
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire22f9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire22f9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.5" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.5";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.5";

});



parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("8PNKb", function(module, exports) {

$parcel$export(module.exports, "Easing", () => Easing);
$parcel$export(module.exports, "Group", () => Group);
$parcel$export(module.exports, "Tween", () => Tween);
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var Easing = Object.freeze({
    Linear: Object.freeze({
        None: function(amount) {
            return amount;
        },
        In: function(amount) {
            return amount;
        },
        Out: function(amount) {
            return amount;
        },
        InOut: function(amount) {
            return amount;
        }
    }),
    Quadratic: Object.freeze({
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    }),
    Cubic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    }),
    Quartic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    }),
    Quintic: Object.freeze({
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    }),
    Sinusoidal: Object.freeze({
        In: function(amount) {
            return 1 - Math.sin((1.0 - amount) * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.sin(Math.PI * (0.5 - amount)));
        }
    }),
    Exponential: Object.freeze({
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    }),
    Circular: Object.freeze({
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    }),
    Elastic: Object.freeze({
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    }),
    Back: Object.freeze({
        In: function(amount) {
            var s = 1.70158;
            return amount === 1 ? 1 : amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return amount === 0 ? 0 : --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    }),
    Bounce: Object.freeze({
        In: function(amount) {
            return 1 - Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return Easing.Bounce.In(amount * 2) * 0.5;
            return Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }),
    generatePow: function(power) {
        if (power === void 0) power = 4;
        power = power < Number.EPSILON ? Number.EPSILON : power;
        power = power > 10000 ? 10000 : power;
        return {
            In: function(amount) {
                return Math.pow(amount, power);
            },
            Out: function(amount) {
                return 1 - Math.pow(1 - amount, power);
            },
            InOut: function(amount) {
                if (amount < 0.5) return Math.pow(amount * 2, power) / 2;
                return (1 - Math.pow(2 - amount * 2, power)) / 2 + 0.5;
            }
        };
    }
});
var now = function() {
    return performance.now();
};
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var Group = /** @class */ function() {
    function Group() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
        this.add.apply(this, tweens);
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function() {
        var _a;
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        for(var _b = 0, tweens_1 = tweens; _b < tweens_1.length; _b++){
            var tween = tweens_1[_b];
            // Remove from any other group first, a tween can only be in one group at a time.
            // @ts-expect-error library internal access
            (_a = tween._group) === null || _a === void 0 || _a.remove(tween);
            // @ts-expect-error library internal access
            tween._group = this;
            this._tweens[tween.getId()] = tween;
            this._tweensAddedDuringUpdate[tween.getId()] = tween;
        }
    };
    Group.prototype.remove = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        for(var _a = 0, tweens_2 = tweens; _a < tweens_2.length; _a++){
            var tween = tweens_2[_a];
            // @ts-expect-error library internal access
            tween._group = undefined;
            delete this._tweens[tween.getId()];
            delete this._tweensAddedDuringUpdate[tween.getId()];
        }
    };
    /** Return true if all tweens in the group are not paused or playing. */ Group.prototype.allStopped = function() {
        return this.getAll().every(function(tween) {
            return !tween.isPlaying();
        });
    };
    Group.prototype.update = function(time, preserve) {
        if (time === void 0) time = now();
        if (preserve === void 0) preserve = true;
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return;
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                var autoStart = !preserve;
                if (tween && tween.update(time, autoStart) === false && !preserve) this.remove(tween);
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
    };
    return Group;
}();
/**
 *
 */ var Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
var mainGroup = new Group();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var Tween = /** @class */ function() {
    function Tween(object, group) {
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._isDynamic = false;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = Easing.Linear.None;
        this._interpolationFunction = Interpolation.Linear;
        // eslint-disable-next-line
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._id = Sequence.nextId();
        this._isChainStopped = false;
        this._propertiesAreSetUp = false;
        this._goToEnd = false;
        this._object = object;
        if (typeof group === 'object') {
            this._group = group;
            group.add(this);
        } else if (group === true) {
            this._group = mainGroup;
            mainGroup.add(this);
        }
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.getDuration = function() {
        return this._duration;
    };
    Tween.prototype.to = function(target, duration) {
        if (duration === void 0) duration = 1000;
        if (this._isPlaying) throw new Error('Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.');
        this._valuesEnd = target;
        this._propertiesAreSetUp = false;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.duration = function(duration) {
        if (duration === void 0) duration = 1000;
        this._duration = duration < 0 ? 0 : duration;
        return this;
    };
    Tween.prototype.dynamic = function(dynamic) {
        if (dynamic === void 0) dynamic = false;
        this._isDynamic = dynamic;
        return this;
    };
    Tween.prototype.start = function(time, overrideStartingValues) {
        if (time === void 0) time = now();
        if (overrideStartingValues === void 0) overrideStartingValues = false;
        if (this._isPlaying) return this;
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._onEveryStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time;
        this._startTime += this._delayTime;
        if (!this._propertiesAreSetUp || overrideStartingValues) {
            this._propertiesAreSetUp = true;
            // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
            if (!this._isDynamic) {
                var tmp = {};
                for(var prop in this._valuesEnd)tmp[prop] = this._valuesEnd[prop];
                this._valuesEnd = tmp;
            }
            this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, overrideStartingValues);
        }
        return this;
    };
    Tween.prototype.startFromCurrentValues = function(time) {
        return this.start(time, true);
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat, overrideStartingValues) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? 'array' : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === 'undefined' || propType === 'function') continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // Handle an array of relative values.
                // Creates a local copy of the Array with the start value at the front
                var temp = [
                    startValue
                ];
                for(var i = 0, l = endValues.length; i < l; i += 1){
                    var value = this._handleRelativeValue(startValue, endValues[i]);
                    if (isNaN(value)) {
                        isInterpolationList = false;
                        console.warn('Found invalid interpolation list. Skipping.');
                        break;
                    }
                    temp.push(value);
                }
                if (isInterpolationList) // if (_valuesStart[property] === undefined) { // handle end values only the first time. NOT NEEDED? setupProperties is now guarded by _propertiesAreSetUp.
                _valuesEnd[property] = temp;
            }
            // handle the deepness of the values
            if ((propType === 'object' || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                var nestedObject = startValue;
                for(var prop in nestedObject)_valuesStart[property][prop] = nestedObject[prop];
                // TODO? repeat nested values? And yoyo? And array values?
                _valuesStartRepeat[property] = startValueIsArray ? [] : {};
                var endValues = _valuesEnd[property];
                // If dynamic is not enabled, clone the end values instead of using the passed-in end values.
                if (!this._isDynamic) {
                    var tmp = {};
                    for(var prop in endValues)tmp[prop] = endValues[prop];
                    _valuesEnd[property] = endValues = tmp;
                }
                this._setupProperties(nestedObject, _valuesStart[property], endValues, _valuesStartRepeat[property], overrideStartingValues);
            } else {
                // Save the starting value, but only once unless override is requested.
                if (typeof _valuesStart[property] === 'undefined' || overrideStartingValues) _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this._goToEnd = true;
        this.update(this._startTime + this._duration);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (time === void 0) time = now();
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time;
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (time === void 0) time = now();
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += time - this._pauseStart;
        this._pauseStart = 0;
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        if (!group) {
            console.warn('tween.group() without args has been removed, use group.add(tween) instead.');
            return this;
        }
        group.add(this);
        return this;
    };
    /**
     * Removes the tween from whichever group it is in.
     */ Tween.prototype.remove = function() {
        var _a;
        (_a = this._group) === null || _a === void 0 || _a.remove(this);
        return this;
    };
    Tween.prototype.delay = function(amount) {
        if (amount === void 0) amount = 0;
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        if (times === void 0) times = 0;
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        if (yoyo === void 0) yoyo = false;
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        if (easingFunction === void 0) easingFunction = Easing.Linear.None;
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        if (interpolationFunction === void 0) interpolationFunction = Interpolation.Linear;
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    // eslint-disable-next-line
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onEveryStart = function(callback) {
        this._onEveryStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    /**
     * @returns true if the tween is still playing after the update, false
     * otherwise (calling update on a paused tween still returns true because
     * it is still playing, just paused).
     *
     * @param autoStart - When true, calling update will implicitly call start()
     * as well. Note, if you stop() or end() the tween, but are still calling
     * update(), it will start again!
     */ Tween.prototype.update = function(time, autoStart) {
        var _this = this;
        var _a;
        if (time === void 0) time = now();
        if (autoStart === void 0) autoStart = Tween.autoStartOnUpdate;
        if (this._isPaused) return true;
        var property;
        if (!this._goToEnd && !this._isPlaying) {
            if (autoStart) this.start(time, true);
            else return false;
        }
        this._goToEnd = false;
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        if (this._onEveryStartCallbackFired === false) {
            if (this._onEveryStartCallback) this._onEveryStartCallback(this._object);
            this._onEveryStartCallbackFired = true;
        }
        var elapsedTime = time - this._startTime;
        var durationAndDelay = this._duration + ((_a = this._repeatDelayTime) !== null && _a !== void 0 ? _a : this._delayTime);
        var totalTime = this._duration + this._repeat * durationAndDelay;
        var calculateElapsedPortion = function() {
            if (_this._duration === 0) return 1;
            if (elapsedTime > totalTime) return 1;
            var timesRepeated = Math.trunc(elapsedTime / durationAndDelay);
            var timeIntoCurrentRepeat = elapsedTime - timesRepeated * durationAndDelay;
            // TODO use %?
            // const timeIntoCurrentRepeat = elapsedTime % durationAndDelay
            var portion = Math.min(timeIntoCurrentRepeat / _this._duration, 1);
            if (portion === 0 && elapsedTime === _this._duration) return 1;
            return portion;
        };
        var elapsed = calculateElapsedPortion();
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (this._duration === 0 || elapsedTime >= this._duration) {
            if (this._repeat > 0) {
                var completeCount = Math.min(Math.trunc((elapsedTime - this._duration) / durationAndDelay) + 1, this._repeat);
                if (isFinite(this._repeat)) this._repeat -= completeCount;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === 'string') this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                this._startTime += durationAndDelay * completeCount;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                this._onEveryStartCallbackFired = false;
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration, false);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === 'object' && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === 'number') // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== 'string') return end;
        if (end.charAt(0) === '+' || end.charAt(0) === '-') return start + parseFloat(end);
        return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        var endValue = this._valuesEnd[property];
        if (typeof endValue === 'string') this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(endValue);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    Tween.autoStartOnUpdate = false;
    return Tween;
}();
var VERSION = '25.0.0';
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var nextId = Sequence.nextId;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tweens.
 */ var TWEEN = mainGroup;
// This is the best way to export things in a way that's compatible with both ES
// Modules and CommonJS, without build hacks, and so as not to break the
// existing API.
// https://github.com/rollup/rollup/issues/1961#issuecomment-423037881
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var getAll = TWEEN.getAll.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var removeAll = TWEEN.removeAll.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var add = TWEEN.add.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var remove = TWEEN.remove.bind(TWEEN);
/**
 * @deprecated The global TWEEN Group will be removed in a following major
 * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
 * group.
 *
 * Old code:
 *
 * ```js
 * import * as TWEEN from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new TWEEN.Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   TWEEN.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 *
 * New code:
 *
 * ```js
 * import {Tween, Group} from '@tweenjs/tween.js'
 *
 * //...
 *
 * const tween = new Tween(obj)
 * const tween2 = new TWEEN.Tween(obj2)
 *
 * //...
 *
 * const group = new Group()
 * group.add(tween)
 * group.add(tween2)
 *
 * //...
 *
 * requestAnimationFrame(function loop(time) {
 *   group.update(time)
 *   requestAnimationFrame(loop)
 * })
 * ```
 */ var update = TWEEN.update.bind(TWEEN);
var exports = {
    Easing: Easing,
    Group: Group,
    Interpolation: Interpolation,
    now: now,
    Sequence: Sequence,
    nextId: nextId,
    Tween: Tween,
    VERSION: VERSION,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ getAll: getAll,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ removeAll: removeAll,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ add: add,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ remove: remove,
    /**
     * @deprecated The global TWEEN Group will be removed in a following major
     * release. To migrate, create a `new Group()` instead of using `TWEEN` as a
     * group.
     *
     * Old code:
     *
     * ```js
     * import * as TWEEN from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new TWEEN.Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   TWEEN.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     *
     * New code:
     *
     * ```js
     * import {Tween, Group} from '@tweenjs/tween.js'
     *
     * //...
     *
     * const tween = new Tween(obj)
     * const tween2 = new TWEEN.Tween(obj2)
     *
     * //...
     *
     * const group = new Group()
     * group.add(tween)
     * group.add(tween2)
     *
     * //...
     *
     * requestAnimationFrame(function loop(time) {
     *   group.update(time)
     *   requestAnimationFrame(loop)
     * })
     * ```
     */ update: update
};

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("6y6y7", function(module, exports) {
/**
 * Manages a simulation of physical forces acting on bodies and springs.
 */ module.exports = $4c4aff9898cca392$var$createPhysicsSimulator;

var $3Y3RK = parcelRequire("3Y3RK");

var $kF3pF = parcelRequire("kF3pF");

var $cCWWN = parcelRequire("cCWWN");

var $kpttX = parcelRequire("kpttX");

var $gIVX5 = parcelRequire("gIVX5");

var $fmqpS = parcelRequire("fmqpS");
var $4c4aff9898cca392$var$dimensionalCache = {};




function $4c4aff9898cca392$var$createPhysicsSimulator(settings) {
    var Spring = (parcelRequire("48be4"));
    var merge = (parcelRequire("eRWCk"));
    var eventify = (parcelRequire("hG6VV"));
    if (settings) {
        // Check for names from older versions of the layout
        if (settings.springCoeff !== undefined) throw new Error('springCoeff was renamed to springCoefficient');
        if (settings.dragCoeff !== undefined) throw new Error('dragCoeff was renamed to dragCoefficient');
    }
    settings = merge(settings, {
        /**
       * Ideal length for links (springs in physical model).
       */ springLength: 10,
        /**
       * Hook's law coefficient. 1 - solid spring.
       */ springCoefficient: 0.8,
        /**
       * Coulomb's law coefficient. It's used to repel nodes thus should be negative
       * if you make it positive nodes start attract each other :).
       */ gravity: -12,
        /**
       * Theta coefficient from Barnes Hut simulation. Ranged between (0, 1).
       * The closer it's to 1 the more nodes algorithm will have to go through.
       * Setting it to one makes Barnes Hut simulation no different from
       * brute-force forces calculation (each node is considered).
       */ theta: 0.8,
        /**
       * Drag force coefficient. Used to slow down system, thus should be less than 1.
       * The closer it is to 0 the less tight system will be.
       */ dragCoefficient: 0.9,
        /**
       * Default time step (dt) for forces integration
       */ timeStep: 0.5,
        /**
       * Adaptive time step uses average spring length to compute actual time step:
       * See: https://twitter.com/anvaka/status/1293067160755957760
       */ adaptiveTimeStepWeight: 0,
        /**
       * This parameter defines number of dimensions of the space where simulation
       * is performed. 
       */ dimensions: 2,
        /**
       * In debug mode more checks are performed, this will help you catch errors
       * quickly, however for production build it is recommended to turn off this flag
       * to speed up computation.
       */ debug: false
    });
    var factory = $4c4aff9898cca392$var$dimensionalCache[settings.dimensions];
    if (!factory) {
        var dimensions = settings.dimensions;
        factory = {
            Body: $3Y3RK(dimensions, settings.debug),
            createQuadTree: $kF3pF(dimensions),
            createBounds: $cCWWN(dimensions),
            createDragForce: $kpttX(dimensions),
            createSpringForce: $gIVX5(dimensions),
            integrate: $fmqpS(dimensions)
        };
        $4c4aff9898cca392$var$dimensionalCache[dimensions] = factory;
    }
    var Body = factory.Body;
    var createQuadTree = factory.createQuadTree;
    var createBounds = factory.createBounds;
    var createDragForce = factory.createDragForce;
    var createSpringForce = factory.createSpringForce;
    var integrate = factory.integrate;
    var createBody = (pos)=>new Body(pos);
    var random = (parcelRequire("8tnak")).random(42);
    var bodies = []; // Bodies in this simulation.
    var springs = []; // Springs in this simulation.
    var quadTree = createQuadTree(settings, random);
    var bounds = createBounds(bodies, settings, random);
    var springForce = createSpringForce(settings, random);
    var dragForce = createDragForce(settings);
    var totalMovement = 0; // how much movement we made on last step
    var forces = [];
    var forceMap = new Map();
    var iterationNumber = 0;
    addForce('nbody', nbodyForce);
    addForce('spring', updateSpringForce);
    var publicApi = {
        /**
     * Array of bodies, registered with current simulator
     *
     * Note: To add new body, use addBody() method. This property is only
     * exposed for testing/performance purposes.
     */ bodies: bodies,
        quadTree: quadTree,
        /**
     * Array of springs, registered with current simulator
     *
     * Note: To add new spring, use addSpring() method. This property is only
     * exposed for testing/performance purposes.
     */ springs: springs,
        /**
     * Returns settings with which current simulator was initialized
     */ settings: settings,
        /**
     * Adds a new force to simulation
     */ addForce: addForce,
        /**
     * Removes a force from the simulation.
     */ removeForce: removeForce,
        /**
     * Returns a map of all registered forces.
     */ getForces: getForces,
        /**
     * Performs one step of force simulation.
     *
     * @returns {boolean} true if system is considered stable; False otherwise.
     */ step: function() {
            for(var i = 0; i < forces.length; ++i)forces[i](iterationNumber);
            var movement = integrate(bodies, settings.timeStep, settings.adaptiveTimeStepWeight);
            iterationNumber += 1;
            return movement;
        },
        /**
     * Adds body to the system
     *
     * @param {ngraph.physics.primitives.Body} body physical body
     *
     * @returns {ngraph.physics.primitives.Body} added body
     */ addBody: function(body) {
            if (!body) throw new Error('Body is required');
            bodies.push(body);
            return body;
        },
        /**
     * Adds body to the system at given position
     *
     * @param {Object} pos position of a body
     *
     * @returns {ngraph.physics.primitives.Body} added body
     */ addBodyAt: function(pos) {
            if (!pos) throw new Error('Body position is required');
            var body = createBody(pos);
            bodies.push(body);
            return body;
        },
        /**
     * Removes body from the system
     *
     * @param {ngraph.physics.primitives.Body} body to remove
     *
     * @returns {Boolean} true if body found and removed. falsy otherwise;
     */ removeBody: function(body) {
            if (!body) return;
            var idx = bodies.indexOf(body);
            if (idx < 0) return;
            bodies.splice(idx, 1);
            if (bodies.length === 0) bounds.reset();
            return true;
        },
        /**
     * Adds a spring to this simulation.
     *
     * @returns {Object} - a handle for a spring. If you want to later remove
     * spring pass it to removeSpring() method.
     */ addSpring: function(body1, body2, springLength, springCoefficient) {
            if (!body1 || !body2) throw new Error('Cannot add null spring to force simulator');
            if (typeof springLength !== 'number') springLength = -1; // assume global configuration
            var spring = new Spring(body1, body2, springLength, springCoefficient >= 0 ? springCoefficient : -1);
            springs.push(spring);
            // TODO: could mark simulator as dirty.
            return spring;
        },
        /**
     * Returns amount of movement performed on last step() call
     */ getTotalMovement: function() {
            return totalMovement;
        },
        /**
     * Removes spring from the system
     *
     * @param {Object} spring to remove. Spring is an object returned by addSpring
     *
     * @returns {Boolean} true if spring found and removed. falsy otherwise;
     */ removeSpring: function(spring) {
            if (!spring) return;
            var idx = springs.indexOf(spring);
            if (idx > -1) {
                springs.splice(idx, 1);
                return true;
            }
        },
        getBestNewBodyPosition: function(neighbors) {
            return bounds.getBestNewPosition(neighbors);
        },
        /**
     * Returns bounding box which covers all bodies
     */ getBBox: getBoundingBox,
        getBoundingBox: getBoundingBox,
        invalidateBBox: function() {
            console.warn('invalidateBBox() is deprecated, bounds always recomputed on `getBBox()` call');
        },
        // TODO: Move the force specific stuff to force
        gravity: function(value) {
            if (value !== undefined) {
                settings.gravity = value;
                quadTree.options({
                    gravity: value
                });
                return this;
            } else return settings.gravity;
        },
        theta: function(value) {
            if (value !== undefined) {
                settings.theta = value;
                quadTree.options({
                    theta: value
                });
                return this;
            } else return settings.theta;
        },
        /**
     * Returns pseudo-random number generator instance.
     */ random: random
    };
    // allow settings modification via public API:
    $4c4aff9898cca392$var$expose(settings, publicApi);
    eventify(publicApi);
    return publicApi;
    function getBoundingBox() {
        bounds.update();
        return bounds.box;
    }
    function addForce(forceName, forceFunction) {
        if (forceMap.has(forceName)) throw new Error('Force ' + forceName + ' is already added');
        forceMap.set(forceName, forceFunction);
        forces.push(forceFunction);
    }
    function removeForce(forceName) {
        var forceIndex = forces.indexOf(forceMap.get(forceName));
        if (forceIndex < 0) return;
        forces.splice(forceIndex, 1);
        forceMap.delete(forceName);
    }
    function getForces() {
        // TODO: Should I trust them or clone the forces?
        return forceMap;
    }
    function nbodyForce() {
        if (bodies.length === 0) return;
        quadTree.insertBodies(bodies);
        var i = bodies.length;
        while(i--){
            var body = bodies[i];
            if (!body.isPinned) {
                body.reset();
                quadTree.updateBodyForce(body);
                dragForce.update(body);
            }
        }
    }
    function updateSpringForce() {
        var i = springs.length;
        while(i--)springForce.update(springs[i]);
    }
}
function $4c4aff9898cca392$var$expose(settings, target) {
    for(var key in settings)$4c4aff9898cca392$var$augment(settings, target, key);
}
function $4c4aff9898cca392$var$augment(source, target, key) {
    if (!source.hasOwnProperty(key)) return;
    if (typeof target[key] === 'function') // this accessor is already defined. Ignore it
    return;
    var sourceIsNumber = Number.isFinite(source[key]);
    if (sourceIsNumber) target[key] = function(value) {
        if (value !== undefined) {
            if (!Number.isFinite(value)) throw new Error('Value of ' + key + ' should be a valid number.');
            source[key] = value;
            return target;
        }
        return source[key];
    };
    else target[key] = function(value) {
        if (value !== undefined) {
            source[key] = value;
            return target;
        }
        return source[key];
    };
}

});
parcelRegister("3Y3RK", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $2e39f95f381af0d6$var$generateCreateBodyFunction;
module.exports.generateCreateBodyFunctionBody = $2e39f95f381af0d6$var$generateCreateBodyFunctionBody;
// InlineTransform: getVectorCode
module.exports.getVectorCode = $2e39f95f381af0d6$var$getVectorCode;
// InlineTransform: getBodyCode
module.exports.getBodyCode = $2e39f95f381af0d6$var$getBodyCode;
// InlineTransformExport: module.exports = function() { return Body; }
function $2e39f95f381af0d6$var$generateCreateBodyFunction(dimension, debugSetters) {
    let code = $2e39f95f381af0d6$var$generateCreateBodyFunctionBody(dimension, debugSetters);
    let { Body: Body } = new Function(code)();
    return Body;
}
function $2e39f95f381af0d6$var$generateCreateBodyFunctionBody(dimension, debugSetters) {
    let code = `
${$2e39f95f381af0d6$var$getVectorCode(dimension, debugSetters)}
${$2e39f95f381af0d6$var$getBodyCode(dimension, debugSetters)}
return {Body: Body, Vector: Vector};
`;
    return code;
}
function $2e39f95f381af0d6$var$getBodyCode(dimension) {
    let pattern = $ehEoR(dimension);
    let variableList = pattern('{var}', {
        join: ', '
    });
    return `
function Body(${variableList}) {
  this.isPinned = false;
  this.pos = new Vector(${variableList});
  this.force = new Vector();
  this.velocity = new Vector();
  this.mass = 1;

  this.springCount = 0;
  this.springLength = 0;
}

Body.prototype.reset = function() {
  this.force.reset();
  this.springCount = 0;
  this.springLength = 0;
}

Body.prototype.setPosition = function (${variableList}) {
  ${pattern('this.pos.{var} = {var} || 0;', {
        indent: 2
    })}
};`;
}
function $2e39f95f381af0d6$var$getVectorCode(dimension, debugSetters) {
    let pattern = $ehEoR(dimension);
    let setters = '';
    if (debugSetters) setters = `${pattern("\n\
   var v{var};\n\
Object.defineProperty(this, '{var}', {\n\
  set: function(v) { \n\
    if (!Number.isFinite(v)) throw new Error('Cannot set non-numbers to {var}');\n\
    v{var} = v; \n\
  },\n\
  get: function() { return v{var}; }\n\
});")}`;
    let variableList = pattern('{var}', {
        join: ', '
    });
    return `function Vector(${variableList}) {
  ${setters}
    if (typeof arguments[0] === 'object') {
      // could be another vector
      let v = arguments[0];
      ${pattern('if (!Number.isFinite(v.{var})) throw new Error("Expected value is not a finite number at Vector constructor ({var})");', {
        indent: 4
    })}
      ${pattern('this.{var} = v.{var};', {
        indent: 4
    })}
    } else {
      ${pattern('this.{var} = typeof {var} === "number" ? {var} : 0;', {
        indent: 4
    })}
    }
  }
  
  Vector.prototype.reset = function () {
    ${pattern('this.{var} = ', {
        join: ''
    })}0;
  };`;
}

});
parcelRegister("ehEoR", function(module, exports) {

var $hnBDe = parcelRequire("hnBDe");
module.exports = function createPatternBuilder(dimension) {
    return pattern;
    function pattern(template, config) {
        let indent = config && config.indent || 0;
        let join = config && config.join !== undefined ? config.join : '\n';
        let indentString = Array(indent + 1).join(' ');
        let buffer = [];
        for(let i = 0; i < dimension; ++i){
            let variableName = $hnBDe(i);
            let prefix = i === 0 ? '' : indentString;
            buffer.push(prefix + template.replace(/{var}/g, variableName));
        }
        return buffer.join(join);
    }
};

});
parcelRegister("hnBDe", function(module, exports) {
module.exports = function getVariableName(index) {
    if (index === 0) return 'x';
    if (index === 1) return 'y';
    if (index === 2) return 'z';
    return 'c' + (index + 1);
};

});



parcelRegister("kF3pF", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");

var $hnBDe = parcelRequire("hnBDe");
module.exports = $f0aa48bc1bb29501$var$generateQuadTreeFunction;
module.exports.generateQuadTreeFunctionBody = $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody;
// These exports are for InlineTransform tool.
// InlineTransform: getInsertStackCode
module.exports.getInsertStackCode = $f0aa48bc1bb29501$var$getInsertStackCode;
// InlineTransform: getQuadNodeCode
module.exports.getQuadNodeCode = $f0aa48bc1bb29501$var$getQuadNodeCode;
// InlineTransform: isSamePosition
module.exports.isSamePosition = $f0aa48bc1bb29501$var$isSamePosition;
// InlineTransform: getChildBodyCode
module.exports.getChildBodyCode = $f0aa48bc1bb29501$var$getChildBodyCode;
// InlineTransform: setChildBodyCode
module.exports.setChildBodyCode = $f0aa48bc1bb29501$var$setChildBodyCode;
function $f0aa48bc1bb29501$var$generateQuadTreeFunction(dimension) {
    let code = $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody(dimension);
    return new Function(code)();
}
function $f0aa48bc1bb29501$var$generateQuadTreeFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let quadCount = Math.pow(2, dimension);
    let code = `
${$f0aa48bc1bb29501$var$getInsertStackCode()}
${$f0aa48bc1bb29501$var$getQuadNodeCode(dimension)}
${$f0aa48bc1bb29501$var$isSamePosition(dimension)}
${$f0aa48bc1bb29501$var$getChildBodyCode(dimension)}
${$f0aa48bc1bb29501$var$setChildBodyCode(dimension)}

function createQuadTree(options, random) {
  options = options || {};
  options.gravity = typeof options.gravity === 'number' ? options.gravity : -1;
  options.theta = typeof options.theta === 'number' ? options.theta : 0.8;

  var gravity = options.gravity;
  var updateQueue = [];
  var insertStack = new InsertStack();
  var theta = options.theta;

  var nodesCache = [];
  var currentInCache = 0;
  var root = newNode();

  return {
    insertBodies: insertBodies,

    /**
     * Gets root node if it is present
     */
    getRoot: function() {
      return root;
    },

    updateBodyForce: update,

    options: function(newOptions) {
      if (newOptions) {
        if (typeof newOptions.gravity === 'number') {
          gravity = newOptions.gravity;
        }
        if (typeof newOptions.theta === 'number') {
          theta = newOptions.theta;
        }

        return this;
      }

      return {
        gravity: gravity,
        theta: theta
      };
    }
  };

  function newNode() {
    // To avoid pressure on GC we reuse nodes.
    var node = nodesCache[currentInCache];
    if (node) {
${assignQuads('      node.')}
      node.body = null;
      node.mass = ${pattern('node.mass_{var} = ', {
        join: ''
    })}0;
      ${pattern('node.min_{var} = node.max_{var} = ', {
        join: ''
    })}0;
    } else {
      node = new QuadNode();
      nodesCache[currentInCache] = node;
    }

    ++currentInCache;
    return node;
  }

  function update(sourceBody) {
    var queue = updateQueue;
    var v;
    ${pattern('var d{var};', {
        indent: 4
    })}
    var r; 
    ${pattern('var f{var} = 0;', {
        indent: 4
    })}
    var queueLength = 1;
    var shiftIdx = 0;
    var pushIdx = 1;

    queue[0] = root;

    while (queueLength) {
      var node = queue[shiftIdx];
      var body = node.body;

      queueLength -= 1;
      shiftIdx += 1;
      var differentBody = (body !== sourceBody);
      if (body && differentBody) {
        // If the current node is a leaf node (and it is not source body),
        // calculate the force exerted by the current node on body, and add this
        // amount to body's net force.
        ${pattern('d{var} = body.pos.{var} - sourceBody.pos.{var};', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

        if (r === 0) {
          // Poor man's protection against zero distance.
          ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 10
    })}
          r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
        }

        // This is standard gravitation force calculation but we divide
        // by r^3 to save two operations when normalizing force vector.
        v = gravity * body.mass * sourceBody.mass / (r * r * r);
        ${pattern('f{var} += v * d{var};', {
        indent: 8
    })}
      } else if (differentBody) {
        // Otherwise, calculate the ratio s / r,  where s is the width of the region
        // represented by the internal node, and r is the distance between the body
        // and the node's center-of-mass
        ${pattern('d{var} = node.mass_{var} / node.mass - sourceBody.pos.{var};', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

        if (r === 0) {
          // Sorry about code duplication. I don't want to create many functions
          // right away. Just want to see performance first.
          ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 10
    })}
          r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
        }
        // If s / r < \u{3B8}, treat this internal node as a single body, and calculate the
        // force it exerts on sourceBody, and add this amount to sourceBody's net force.
        if ((node.max_${$hnBDe(0)} - node.min_${$hnBDe(0)}) / r < theta) {
          // in the if statement above we consider node's width only
          // because the region was made into square during tree creation.
          // Thus there is no difference between using width or height.
          v = gravity * node.mass * sourceBody.mass / (r * r * r);
          ${pattern('f{var} += v * d{var};', {
        indent: 10
    })}
        } else {
          // Otherwise, run the procedure recursively on each of the current node's children.

          // I intentionally unfolded this loop, to save several CPU cycles.
${runRecursiveOnChildren()}
        }
      }
    }

    ${pattern('sourceBody.force.{var} += f{var};', {
        indent: 4
    })}
  }

  function insertBodies(bodies) {
    ${pattern('var {var}min = Number.MAX_VALUE;', {
        indent: 4
    })}
    ${pattern('var {var}max = Number.MIN_VALUE;', {
        indent: 4
    })}
    var i = bodies.length;

    // To reduce quad tree depth we are looking for exact bounding box of all particles.
    while (i--) {
      var pos = bodies[i].pos;
      ${pattern('if (pos.{var} < {var}min) {var}min = pos.{var};', {
        indent: 6
    })}
      ${pattern('if (pos.{var} > {var}max) {var}max = pos.{var};', {
        indent: 6
    })}
    }

    // Makes the bounds square.
    var maxSideLength = -Infinity;
    ${pattern('if ({var}max - {var}min > maxSideLength) maxSideLength = {var}max - {var}min ;', {
        indent: 4
    })}

    currentInCache = 0;
    root = newNode();
    ${pattern('root.min_{var} = {var}min;', {
        indent: 4
    })}
    ${pattern('root.max_{var} = {var}min + maxSideLength;', {
        indent: 4
    })}

    i = bodies.length - 1;
    if (i >= 0) {
      root.body = bodies[i];
    }
    while (i--) {
      insert(bodies[i], root);
    }
  }

  function insert(newBody) {
    insertStack.reset();
    insertStack.push(root, newBody);

    while (!insertStack.isEmpty()) {
      var stackItem = insertStack.pop();
      var node = stackItem.node;
      var body = stackItem.body;

      if (!node.body) {
        // This is internal node. Update the total mass of the node and center-of-mass.
        ${pattern('var {var} = body.pos.{var};', {
        indent: 8
    })}
        node.mass += body.mass;
        ${pattern('node.mass_{var} += body.mass * {var};', {
        indent: 8
    })}

        // Recursively insert the body in the appropriate quadrant.
        // But first find the appropriate quadrant.
        var quadIdx = 0; // Assume we are in the 0's quad.
        ${pattern('var min_{var} = node.min_{var};', {
        indent: 8
    })}
        ${pattern('var max_{var} = (min_{var} + node.max_{var}) / 2;', {
        indent: 8
    })}

${assignInsertionQuadIndex(8)}

        var child = getChild(node, quadIdx);

        if (!child) {
          // The node is internal but this quadrant is not taken. Add
          // subnode to it.
          child = newNode();
          ${pattern('child.min_{var} = min_{var};', {
        indent: 10
    })}
          ${pattern('child.max_{var} = max_{var};', {
        indent: 10
    })}
          child.body = body;

          setChild(node, quadIdx, child);
        } else {
          // continue searching in this quadrant.
          insertStack.push(child, body);
        }
      } else {
        // We are trying to add to the leaf node.
        // We have to convert current leaf into internal node
        // and continue adding two nodes.
        var oldBody = node.body;
        node.body = null; // internal nodes do not cary bodies

        if (isSamePosition(oldBody.pos, body.pos)) {
          // Prevent infinite subdivision by bumping one node
          // anywhere in this quadrant
          var retriesCount = 3;
          do {
            var offset = random.nextDouble();
            ${pattern('var d{var} = (node.max_{var} - node.min_{var}) * offset;', {
        indent: 12
    })}

            ${pattern('oldBody.pos.{var} = node.min_{var} + d{var};', {
        indent: 12
    })}
            retriesCount -= 1;
            // Make sure we don't bump it out of the box. If we do, next iteration should fix it
          } while (retriesCount > 0 && isSamePosition(oldBody.pos, body.pos));

          if (retriesCount === 0 && isSamePosition(oldBody.pos, body.pos)) {
            // This is very bad, we ran out of precision.
            // if we do not return from the method we'll get into
            // infinite loop here. So we sacrifice correctness of layout, and keep the app running
            // Next layout iteration should get larger bounding box in the first step and fix this
            return;
          }
        }
        // Next iteration should subdivide node further.
        insertStack.push(node, oldBody);
        insertStack.push(node, body);
      }
    }
  }
}
return createQuadTree;

`;
    return code;
    function assignInsertionQuadIndex(indentCount) {
        let insertionCode = [];
        let indent = Array(indentCount + 1).join(' ');
        for(let i = 0; i < dimension; ++i){
            insertionCode.push(indent + `if (${$hnBDe(i)} > max_${$hnBDe(i)}) {`);
            insertionCode.push(indent + `  quadIdx = quadIdx + ${Math.pow(2, i)};`);
            insertionCode.push(indent + `  min_${$hnBDe(i)} = max_${$hnBDe(i)};`);
            insertionCode.push(indent + `  max_${$hnBDe(i)} = node.max_${$hnBDe(i)};`);
            insertionCode.push(indent + `}`);
        }
        return insertionCode.join('\n');
    // if (x > max_x) { // somewhere in the eastern part.
    //   quadIdx = quadIdx + 1;
    //   left = right;
    //   right = node.right;
    // }
    }
    function runRecursiveOnChildren() {
        let indent = Array(11).join(' ');
        let recursiveCode = [];
        for(let i = 0; i < quadCount; ++i){
            recursiveCode.push(indent + `if (node.quad${i}) {`);
            recursiveCode.push(indent + `  queue[pushIdx] = node.quad${i};`);
            recursiveCode.push(indent + `  queueLength += 1;`);
            recursiveCode.push(indent + `  pushIdx += 1;`);
            recursiveCode.push(indent + `}`);
        }
        return recursiveCode.join('\n');
    // if (node.quad0) {
    //   queue[pushIdx] = node.quad0;
    //   queueLength += 1;
    //   pushIdx += 1;
    // }
    }
    function assignQuads(indent) {
        // this.quad0 = null;
        // this.quad1 = null;
        // this.quad2 = null;
        // this.quad3 = null;
        let quads = [];
        for(let i = 0; i < quadCount; ++i)quads.push(`${indent}quad${i} = null;`);
        return quads.join('\n');
    }
}
function $f0aa48bc1bb29501$var$isSamePosition(dimension) {
    let pattern = $ehEoR(dimension);
    return `
  function isSamePosition(point1, point2) {
    ${pattern('var d{var} = Math.abs(point1.{var} - point2.{var});', {
        indent: 2
    })}
  
    return ${pattern('d{var} < 1e-8', {
        join: ' && '
    })};
  }  
`;
}
function $f0aa48bc1bb29501$var$setChildBodyCode(dimension) {
    var quadCount = Math.pow(2, dimension);
    return `
function setChild(node, idx, child) {
  ${setChildBody()}
}`;
    function setChildBody() {
        let childBody = [];
        for(let i = 0; i < quadCount; ++i){
            let prefix = i === 0 ? '  ' : '  else ';
            childBody.push(`${prefix}if (idx === ${i}) node.quad${i} = child;`);
        }
        return childBody.join('\n');
    // if (idx === 0) node.quad0 = child;
    // else if (idx === 1) node.quad1 = child;
    // else if (idx === 2) node.quad2 = child;
    // else if (idx === 3) node.quad3 = child;
    }
}
function $f0aa48bc1bb29501$var$getChildBodyCode(dimension) {
    return `function getChild(node, idx) {
${getChildBody()}
  return null;
}`;
    function getChildBody() {
        let childBody = [];
        let quadCount = Math.pow(2, dimension);
        for(let i = 0; i < quadCount; ++i)childBody.push(`  if (idx === ${i}) return node.quad${i};`);
        return childBody.join('\n');
    // if (idx === 0) return node.quad0;
    // if (idx === 1) return node.quad1;
    // if (idx === 2) return node.quad2;
    // if (idx === 3) return node.quad3;
    }
}
function $f0aa48bc1bb29501$var$getQuadNodeCode(dimension) {
    let pattern = $ehEoR(dimension);
    let quadCount = Math.pow(2, dimension);
    var quadNodeCode = `
function QuadNode() {
  // body stored inside this node. In quad tree only leaf nodes (by construction)
  // contain bodies:
  this.body = null;

  // Child nodes are stored in quads. Each quad is presented by number:
  // 0 | 1
  // -----
  // 2 | 3
${assignQuads('  this.')}

  // Total mass of current node
  this.mass = 0;

  // Center of mass coordinates
  ${pattern('this.mass_{var} = 0;', {
        indent: 2
    })}

  // bounding box coordinates
  ${pattern('this.min_{var} = 0;', {
        indent: 2
    })}
  ${pattern('this.max_{var} = 0;', {
        indent: 2
    })}
}
`;
    return quadNodeCode;
    function assignQuads(indent) {
        // this.quad0 = null;
        // this.quad1 = null;
        // this.quad2 = null;
        // this.quad3 = null;
        let quads = [];
        for(let i = 0; i < quadCount; ++i)quads.push(`${indent}quad${i} = null;`);
        return quads.join('\n');
    }
}
function $f0aa48bc1bb29501$var$getInsertStackCode() {
    return `
/**
 * Our implementation of QuadTree is non-recursive to avoid GC hit
 * This data structure represent stack of elements
 * which we are trying to insert into quad tree.
 */
function InsertStack () {
    this.stack = [];
    this.popIdx = 0;
}

InsertStack.prototype = {
    isEmpty: function() {
        return this.popIdx === 0;
    },
    push: function (node, body) {
        var item = this.stack[this.popIdx];
        if (!item) {
            // we are trying to avoid memory pressure: create new element
            // only when absolutely necessary
            this.stack[this.popIdx] = new InsertStackElement(node, body);
        } else {
            item.node = node;
            item.body = body;
        }
        ++this.popIdx;
    },
    pop: function () {
        if (this.popIdx > 0) {
            return this.stack[--this.popIdx];
        }
    },
    reset: function () {
        this.popIdx = 0;
    }
};

function InsertStackElement(node, body) {
    this.node = node; // QuadTree node
    this.body = body; // physical body which needs to be inserted to node
}
`;
}

});

parcelRegister("cCWWN", function(module, exports) {
module.exports = $9316c255f6c80a29$var$generateBoundsFunction;
module.exports.generateFunctionBody = $9316c255f6c80a29$var$generateBoundsFunctionBody;

var $ehEoR = parcelRequire("ehEoR");
function $9316c255f6c80a29$var$generateBoundsFunction(dimension) {
    let code = $9316c255f6c80a29$var$generateBoundsFunctionBody(dimension);
    return new Function('bodies', 'settings', 'random', code);
}
function $9316c255f6c80a29$var$generateBoundsFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  var boundingBox = {
    ${pattern('min_{var}: 0, max_{var}: 0,', {
        indent: 4
    })}
  };

  return {
    box: boundingBox,

    update: updateBoundingBox,

    reset: resetBoundingBox,

    getBestNewPosition: function (neighbors) {
      var ${pattern('base_{var} = 0', {
        join: ', '
    })};

      if (neighbors.length) {
        for (var i = 0; i < neighbors.length; ++i) {
          let neighborPos = neighbors[i].pos;
          ${pattern('base_{var} += neighborPos.{var};', {
        indent: 10
    })}
        }

        ${pattern('base_{var} /= neighbors.length;', {
        indent: 8
    })}
      } else {
        ${pattern('base_{var} = (boundingBox.min_{var} + boundingBox.max_{var}) / 2;', {
        indent: 8
    })}
      }

      var springLength = settings.springLength;
      return {
        ${pattern('{var}: base_{var} + (random.nextDouble() - 0.5) * springLength,', {
        indent: 8
    })}
      };
    }
  };

  function updateBoundingBox() {
    var i = bodies.length;
    if (i === 0) return; // No bodies - no borders.

    ${pattern('var max_{var} = -Infinity;', {
        indent: 4
    })}
    ${pattern('var min_{var} = Infinity;', {
        indent: 4
    })}

    while(i--) {
      // this is O(n), it could be done faster with quadtree, if we check the root node bounds
      var bodyPos = bodies[i].pos;
      ${pattern('if (bodyPos.{var} < min_{var}) min_{var} = bodyPos.{var};', {
        indent: 6
    })}
      ${pattern('if (bodyPos.{var} > max_{var}) max_{var} = bodyPos.{var};', {
        indent: 6
    })}
    }

    ${pattern('boundingBox.min_{var} = min_{var};', {
        indent: 4
    })}
    ${pattern('boundingBox.max_{var} = max_{var};', {
        indent: 4
    })}
  }

  function resetBoundingBox() {
    ${pattern('boundingBox.min_{var} = boundingBox.max_{var} = 0;', {
        indent: 4
    })}
  }
`;
    return code;
}

});

parcelRegister("kpttX", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $edbd02fa2f505dcd$var$generateCreateDragForceFunction;
module.exports.generateCreateDragForceFunctionBody = $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody;
function $edbd02fa2f505dcd$var$generateCreateDragForceFunction(dimension) {
    let code = $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody(dimension);
    return new Function('options', code);
}
function $edbd02fa2f505dcd$var$generateCreateDragForceFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  if (!Number.isFinite(options.dragCoefficient)) throw new Error('dragCoefficient is not a finite number');

  return {
    update: function(body) {
      ${pattern('body.force.{var} -= options.dragCoefficient * body.velocity.{var};', {
        indent: 6
    })}
    }
  };
`;
    return code;
}

});

parcelRegister("gIVX5", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $c2cdb571d6533273$var$generateCreateSpringForceFunction;
module.exports.generateCreateSpringForceFunctionBody = $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody;
function $c2cdb571d6533273$var$generateCreateSpringForceFunction(dimension) {
    let code = $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody(dimension);
    return new Function('options', 'random', code);
}
function $c2cdb571d6533273$var$generateCreateSpringForceFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  if (!Number.isFinite(options.springCoefficient)) throw new Error('Spring coefficient is not a number');
  if (!Number.isFinite(options.springLength)) throw new Error('Spring length is not a number');

  return {
    /**
     * Updates forces acting on a spring
     */
    update: function (spring) {
      var body1 = spring.from;
      var body2 = spring.to;
      var length = spring.length < 0 ? options.springLength : spring.length;
      ${pattern('var d{var} = body2.pos.{var} - body1.pos.{var};', {
        indent: 6
    })}
      var r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});

      if (r === 0) {
        ${pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
        indent: 8
    })}
        r = Math.sqrt(${pattern('d{var} * d{var}', {
        join: ' + '
    })});
      }

      var d = r - length;
      var coefficient = ((spring.coefficient > 0) ? spring.coefficient : options.springCoefficient) * d / r;

      ${pattern('body1.force.{var} += coefficient * d{var}', {
        indent: 6
    })};
      body1.springCount += 1;
      body1.springLength += r;

      ${pattern('body2.force.{var} -= coefficient * d{var}', {
        indent: 6
    })};
      body2.springCount += 1;
      body2.springLength += r;
    }
  };
`;
    return code;
}

});

parcelRegister("fmqpS", function(module, exports) {

var $ehEoR = parcelRequire("ehEoR");
module.exports = $b2ed66d4fee16ab8$var$generateIntegratorFunction;
module.exports.generateIntegratorFunctionBody = $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody;
function $b2ed66d4fee16ab8$var$generateIntegratorFunction(dimension) {
    let code = $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody(dimension);
    return new Function('bodies', 'timeStep', 'adaptiveTimeStepWeight', code);
}
function $b2ed66d4fee16ab8$var$generateIntegratorFunctionBody(dimension) {
    let pattern = $ehEoR(dimension);
    let code = `
  var length = bodies.length;
  if (length === 0) return 0;

  ${pattern('var d{var} = 0, t{var} = 0;', {
        indent: 2
    })}

  for (var i = 0; i < length; ++i) {
    var body = bodies[i];
    if (body.isPinned) continue;

    if (adaptiveTimeStepWeight && body.springCount) {
      timeStep = (adaptiveTimeStepWeight * body.springLength/body.springCount);
    }

    var coeff = timeStep / body.mass;

    ${pattern('body.velocity.{var} += coeff * body.force.{var};', {
        indent: 4
    })}
    ${pattern('var v{var} = body.velocity.{var};', {
        indent: 4
    })}
    var v = Math.sqrt(${pattern('v{var} * v{var}', {
        join: ' + '
    })});

    if (v > 1) {
      // We normalize it so that we move within timeStep range. 
      // for the case when v <= 1 - we let velocity to fade out.
      ${pattern('body.velocity.{var} = v{var} / v;', {
        indent: 6
    })}
    }

    ${pattern('d{var} = timeStep * body.velocity.{var};', {
        indent: 4
    })}

    ${pattern('body.pos.{var} += d{var};', {
        indent: 4
    })}

    ${pattern('t{var} += Math.abs(d{var});', {
        indent: 4
    })}
  }

  return (${pattern('t{var} * t{var}', {
        join: ' + '
    })})/length;
`;
    return code;
}

});

parcelRegister("48be4", function(module, exports) {
module.exports = $30209e04a9e93e1d$var$Spring;
/**
 * Represents a physical spring. Spring connects two bodies, has rest length
 * stiffness coefficient and optional weight
 */ function $30209e04a9e93e1d$var$Spring(fromBody, toBody, length, springCoefficient) {
    this.from = fromBody;
    this.to = toBody;
    this.length = length;
    this.coefficient = springCoefficient;
}

});

parcelRegister("eRWCk", function(module, exports) {
module.exports = $ad337c0e9bb0f607$var$merge;
/**
 * Augments `target` with properties in `options`. Does not override
 * target's properties if they are defined and matches expected type in 
 * options
 *
 * @returns {Object} merged object
 */ function $ad337c0e9bb0f607$var$merge(target, options) {
    var key;
    if (!target) target = {};
    if (options) {
        for(key in options)if (options.hasOwnProperty(key)) {
            var targetHasIt = target.hasOwnProperty(key), optionsValueType = typeof options[key], shouldReplace = !targetHasIt || typeof target[key] !== optionsValueType;
            if (shouldReplace) target[key] = options[key];
            else if (optionsValueType === 'object') // go deep, don't care about loops here, we are simple API!:
            target[key] = $ad337c0e9bb0f607$var$merge(target[key], options[key]);
        }
    }
    return target;
}

});

parcelRegister("hG6VV", function(module, exports) {
"use strict";
function $7380e3a328899135$var$c(e) {
    $7380e3a328899135$var$s(e);
    const t = $7380e3a328899135$var$a(e);
    return e.on = t.on, e.off = t.off, e.fire = t.fire, e;
}
function $7380e3a328899135$var$a(e) {
    let t = Object.create(null);
    return {
        on: function(n, r, f) {
            if (typeof r != "function") throw new Error("callback is expected to be a function");
            let o = t[n];
            return o || (o = t[n] = []), o.push({
                callback: r,
                ctx: f
            }), e;
        },
        off: function(n, r) {
            if (typeof n > "u") return t = Object.create(null), e;
            if (t[n]) {
                if (typeof r != "function") delete t[n];
                else {
                    const l = t[n];
                    for(let i = 0; i < l.length; ++i)l[i].callback === r && l.splice(i, 1);
                }
            }
            return e;
        },
        fire: function(n) {
            const r = t[n];
            if (!r) return e;
            let f;
            arguments.length > 1 && (f = Array.prototype.slice.call(arguments, 1));
            for(let o = 0; o < r.length; ++o){
                const l = r[o];
                l.callback.apply(l.ctx, f);
            }
            return e;
        }
    };
}
function $7380e3a328899135$var$s(e) {
    if (!e) throw new Error("Eventify cannot use falsy object as events subject");
    const t = [
        "on",
        "fire",
        "off"
    ];
    for(let n = 0; n < t.length; ++n)if (e.hasOwnProperty(t[n])) throw new Error("Subject cannot be eventified, since it already has property '" + t[n] + "'");
}
module.exports = $7380e3a328899135$var$c; //# sourceMappingURL=ngraph.events.cjs.map

});

parcelRegister("8tnak", function(module, exports) {
module.exports = $62b3005a13df0526$var$random;
module.exports.random = $62b3005a13df0526$var$random, module.exports.randomIterator = $62b3005a13df0526$var$randomIterator;
/**
 * Creates seeded PRNG with two methods:
 *   next() and nextDouble()
 */ function $62b3005a13df0526$var$random(inputSeed) {
    var seed = typeof inputSeed === 'number' ? inputSeed : +new Date();
    return new $62b3005a13df0526$var$Generator(seed);
}
function $62b3005a13df0526$var$Generator(seed) {
    this.seed = seed;
}
/**
  * Generates random integer number in the range from 0 (inclusive) to maxValue (exclusive)
  *
  * @param maxValue Number REQUIRED. Omitting this number will result in NaN values from PRNG.
  */ $62b3005a13df0526$var$Generator.prototype.next = $62b3005a13df0526$var$next;
/**
  * Generates random double number in the range from 0 (inclusive) to 1 (exclusive)
  * This function is the same as Math.random() (except that it could be seeded)
  */ $62b3005a13df0526$var$Generator.prototype.nextDouble = $62b3005a13df0526$var$nextDouble;
/**
 * Returns a random real number from uniform distribution in [0, 1)
 */ $62b3005a13df0526$var$Generator.prototype.uniform = $62b3005a13df0526$var$nextDouble;
/**
 * Returns a random real number from a Gaussian distribution
 * with 0 as a mean, and 1 as standard deviation u ~ N(0,1)
 */ $62b3005a13df0526$var$Generator.prototype.gaussian = $62b3005a13df0526$var$gaussian;
/**
 * Returns a floating-point, pseudo-random number that's greater than 
 * or equal to 0 and less than 1, with approximately uniform distribution over that range
 * 
 * Note: This method is the same as nextDouble(), but is here for
 * compatibility with similar Math.random()
 */ $62b3005a13df0526$var$Generator.prototype.random = $62b3005a13df0526$var$nextDouble;
function $62b3005a13df0526$var$gaussian() {
    // use the polar form of the Box-Muller transform
    // based on https://introcs.cs.princeton.edu/java/23recursion/StdRandom.java
    var r, x, y;
    do {
        x = this.nextDouble() * 2 - 1;
        y = this.nextDouble() * 2 - 1;
        r = x * x + y * y;
    }while (r >= 1 || r === 0);
    return x * Math.sqrt(-2 * Math.log(r) / r);
}
/**
 * See https://twitter.com/anvaka/status/1296182534150135808
 */ $62b3005a13df0526$var$Generator.prototype.levy = $62b3005a13df0526$var$levy;
function $62b3005a13df0526$var$levy() {
    var beta = 1.5;
    var sigma = Math.pow($62b3005a13df0526$var$gamma(1 + beta) * Math.sin(Math.PI * beta / 2) / ($62b3005a13df0526$var$gamma((1 + beta) / 2) * beta * Math.pow(2, (beta - 1) / 2)), 1 / beta);
    return this.gaussian() * sigma / Math.pow(Math.abs(this.gaussian()), 1 / beta);
}
// gamma function approximation
function $62b3005a13df0526$var$gamma(z) {
    return Math.sqrt(2 * Math.PI / z) * Math.pow(1 / Math.E * (z + 1 / (12 * z - 1 / (10 * z))), z);
}
function $62b3005a13df0526$var$nextDouble() {
    var seed = this.seed;
    // Robert Jenkins' 32 bit integer hash function.
    seed = seed + 0x7ed55d16 + (seed << 12) & 0xffffffff;
    seed = (seed ^ 0xc761c23c ^ seed >>> 19) & 0xffffffff;
    seed = seed + 0x165667b1 + (seed << 5) & 0xffffffff;
    seed = (seed + 0xd3a2646c ^ seed << 9) & 0xffffffff;
    seed = seed + 0xfd7046c5 + (seed << 3) & 0xffffffff;
    seed = (seed ^ 0xb55a4f09 ^ seed >>> 16) & 0xffffffff;
    this.seed = seed;
    return (seed & 0xfffffff) / 0x10000000;
}
function $62b3005a13df0526$var$next(maxValue) {
    return Math.floor(this.nextDouble() * maxValue);
}
/*
 * Creates iterator over array, which returns items of array in random order
 * Time complexity is guaranteed to be O(n);
 */ function $62b3005a13df0526$var$randomIterator(array, customRandom) {
    var localRandom = customRandom || $62b3005a13df0526$var$random();
    if (typeof localRandom.next !== 'function') throw new Error('customRandom does not match expected API: next() function is missing');
    return {
        /**
     * Visits every single element of a collection once, in a random order.
     * Note: collection is modified in place.
     */ forEach: forEach,
        /**
     * Shuffles array randomly, in place.
     */ shuffle: shuffle
    };
    function shuffle() {
        var i, j, t;
        for(i = array.length - 1; i > 0; --i){
            j = localRandom.next(i + 1); // i inclusive
            t = array[j];
            array[j] = array[i];
            array[i] = t;
        }
        return array;
    }
    function forEach(callback) {
        var i, j, t;
        for(i = array.length - 1; i > 0; --i){
            j = localRandom.next(i + 1); // i inclusive
            t = array[j];
            array[j] = array[i];
            array[i] = t;
            callback(t);
        }
        if (array.length) callback(array[0]);
    }
}

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $efa8fc7554d57bc9$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $efa8fc7554d57bc9$var$_defineProperty(obj, key, value) {
    key = $efa8fc7554d57bc9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efa8fc7554d57bc9$var$_slicedToArray(arr, i) {
    return $efa8fc7554d57bc9$var$_arrayWithHoles(arr) || $efa8fc7554d57bc9$var$_iterableToArrayLimit(arr, i) || $efa8fc7554d57bc9$var$_unsupportedIterableToArray(arr, i) || $efa8fc7554d57bc9$var$_nonIterableRest();
}
function $efa8fc7554d57bc9$var$_toConsumableArray(arr) {
    return $efa8fc7554d57bc9$var$_arrayWithoutHoles(arr) || $efa8fc7554d57bc9$var$_iterableToArray(arr) || $efa8fc7554d57bc9$var$_unsupportedIterableToArray(arr) || $efa8fc7554d57bc9$var$_nonIterableSpread();
}
function $efa8fc7554d57bc9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $efa8fc7554d57bc9$var$_arrayLikeToArray(arr);
}
function $efa8fc7554d57bc9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $efa8fc7554d57bc9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $efa8fc7554d57bc9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $efa8fc7554d57bc9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $efa8fc7554d57bc9$var$_arrayLikeToArray(o, minLen);
}
function $efa8fc7554d57bc9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $efa8fc7554d57bc9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $efa8fc7554d57bc9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $efa8fc7554d57bc9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $efa8fc7554d57bc9$var$_toPropertyKey(arg) {
    var key = $efa8fc7554d57bc9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var $efa8fc7554d57bc9$export$c44985b87d605eff = function pluck(obj, keys) {
    return Object.assign.apply(Object, [
        {}
    ].concat($efa8fc7554d57bc9$var$_toConsumableArray(keys.map(function(key) {
        return $efa8fc7554d57bc9$var$_defineProperty({}, key, obj[key]);
    }))));
};
var $efa8fc7554d57bc9$export$30a06c8d3562193f = function omit(obj, keys) {
    var keySet = new Set(keys);
    return Object.assign.apply(Object, [
        {}
    ].concat($efa8fc7554d57bc9$var$_toConsumableArray(Object.entries(obj).filter(function(_ref2) {
        var _ref3 = $efa8fc7554d57bc9$var$_slicedToArray(_ref2, 1), key = _ref3[0];
        return !keySet.has(key);
    }).map(function(_ref4) {
        var _ref5 = $efa8fc7554d57bc9$var$_slicedToArray(_ref4, 2), key = _ref5[0], val = _ref5[1];
        return $efa8fc7554d57bc9$var$_defineProperty({}, key, val);
    }))));
};


function $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5d3aea6df4994d8c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $5d3aea6df4994d8c$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5d3aea6df4994d8c$var$_arrayLikeToArray(r);
}
function $5d3aea6df4994d8c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $5d3aea6df4994d8c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5d3aea6df4994d8c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d3aea6df4994d8c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d3aea6df4994d8c$var$_slicedToArray(r, e) {
    return $5d3aea6df4994d8c$var$_arrayWithHoles(r) || $5d3aea6df4994d8c$var$_iterableToArrayLimit(r, e) || $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r, e) || $5d3aea6df4994d8c$var$_nonIterableRest();
}
function $5d3aea6df4994d8c$var$_toConsumableArray(r) {
    return $5d3aea6df4994d8c$var$_arrayWithoutHoles(r) || $5d3aea6df4994d8c$var$_iterableToArray(r) || $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r) || $5d3aea6df4994d8c$var$_nonIterableSpread();
}
function $5d3aea6df4994d8c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5d3aea6df4994d8c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5d3aea6df4994d8c$export$2e2bcd8739ae039(kapsuleComponent) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$wrapperElementTy = _ref.wrapperElementType, wrapperElementType = _ref$wrapperElementTy === void 0 ? 'div' : _ref$wrapperElementTy, _ref$nodeMapper = _ref.nodeMapper, nodeMapper = _ref$nodeMapper === void 0 ? function(node) {
        return node;
    } : _ref$nodeMapper, _ref$methodNames = _ref.methodNames, methodNames = _ref$methodNames === void 0 ? [] : _ref$methodNames, _ref$initPropNames = _ref.initPropNames, initPropNames = _ref$initPropNames === void 0 ? [] : _ref$initPropNames;
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        var domEl = (0, $acw62.useRef)();
        // instantiate the inner kapsule component with the defined initPropNames
        var comp = (0, $acw62.useMemo)(function() {
            var configOptions = Object.fromEntries(initPropNames.filter(function(p) {
                return props.hasOwnProperty(p);
            }).map(function(prop) {
                return [
                    prop,
                    props[prop]
                ];
            }));
            return kapsuleComponent(configOptions);
        }, []);
        $5d3aea6df4994d8c$var$useEffectOnce(function() {
            comp(nodeMapper(domEl.current)); // mount kapsule synchronously on this element ref, optionally mapped into an object that the kapsule understands
        }, (0, $acw62.useLayoutEffect));
        $5d3aea6df4994d8c$var$useEffectOnce(function() {
            // invoke destructor on unmount, if it exists
            return comp._destructor instanceof Function ? comp._destructor : undefined;
        });
        // Call a component method
        var _call = (0, $acw62.useCallback)(function(method) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return comp[method] instanceof Function ? comp[method].apply(comp, args) : undefined;
        } // method not found
        , [
            comp
        ]);
        // propagate component props that have changed
        var prevPropsRef = (0, $acw62.useRef)({});
        Object.keys((0, $efa8fc7554d57bc9$export$30a06c8d3562193f)(props, [].concat($5d3aea6df4994d8c$var$_toConsumableArray(methodNames), $5d3aea6df4994d8c$var$_toConsumableArray(initPropNames)))) // initPropNames or methodNames should not be called
        .filter(function(p) {
            return prevPropsRef.current[p] !== props[p];
        }).forEach(function(p) {
            return _call(p, props[p]);
        });
        prevPropsRef.current = props;
        // bind external methods to parent ref
        (0, $acw62.useImperativeHandle)(ref, function() {
            return Object.fromEntries(methodNames.map(function(method) {
                return [
                    method,
                    function() {
                        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                        return _call.apply(void 0, [
                            method
                        ].concat(args));
                    }
                ];
            }));
        }, [
            _call
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(wrapperElementType, {
            ref: domEl
        });
    });
}
//
// Handle R18 strict mode double mount at init
function $5d3aea6df4994d8c$var$useEffectOnce(effect) {
    var useEffectFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $acw62.useEffect);
    var destroyFunc = (0, $acw62.useRef)();
    var effectCalled = (0, $acw62.useRef)(false);
    var renderAfterCalled = (0, $acw62.useRef)(false);
    var _useState = (0, $acw62.useState)(0), _useState2 = $5d3aea6df4994d8c$var$_slicedToArray(_useState, 2);
    _useState2[0];
    var setVal = _useState2[1];
    if (effectCalled.current) renderAfterCalled.current = true;
    useEffectFn(function() {
        // only execute the effect first time around
        if (!effectCalled.current) {
            destroyFunc.current = effect();
            effectCalled.current = true;
        }
        // this forces one render after the effect is run
        setVal(function(val) {
            return val + 1;
        });
        return function() {
            // if the comp didn't render since the useEffect was called,
            // we know it's the dummy React cycle
            if (!renderAfterCalled.current) return;
            if (destroyFunc.current) destroyFunc.current();
        };
    }, []);
}



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $cade2308c136039a$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}


function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}



var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}




function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    selectChild: (0, $31ffd623f27a3a65$export$2e2bcd8739ae039),
    selectChildren: (0, $956143cec557381d$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $98373fa9c0ecbfb2$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}


var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}


var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);


function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}



function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $2938f7d64470581a$export$f0954fd7d5368655) : (0, $2938f7d64470581a$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));


var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}


function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    easeVarying: (0, $9d186bb80d60f6c9$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);







var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;


function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}


function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)(event.view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}









var $620ab3a49fccb4fc$export$2e2bcd8739ae039 = (x)=>()=>x;


function $45813ed5c6fd1799$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$45813ed5c6fd1799$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $0b4a1789c016a21b$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $0b4a1789c016a21b$var$defaultContainer() {
    return this.parentNode;
}
function $0b4a1789c016a21b$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $0b4a1789c016a21b$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $0b4a1789c016a21b$export$2e2bcd8739ae039() {
    var filter = $0b4a1789c016a21b$var$defaultFilter, container = $0b4a1789c016a21b$var$defaultContainer, subject = $0b4a1789c016a21b$var$defaultSubject, touchable = $0b4a1789c016a21b$var$defaultTouchable, gestures = {}, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $914edae09cbfb4c0$export$524615cd03e458cc)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, (0, $914edae09cbfb4c0$export$35431a0e47022de1)).on("mouseup.drag", mouseupped, (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $905558291b0c219c$export$833237748009e1e1)(event.view, mousemoving);
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}


function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

function $daf42a1f07322cf6$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;


/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;


/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $32866938ab70cc57$export$2e2bcd8739ae039) || $1b818bf49f333098$var$freeSelf || Function('return this')();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $20c74a585cb2c860$var$now = function() {
    return (0, $1b818bf49f333098$export$2e2bcd8739ae039).Date.now();
};
var $20c74a585cb2c860$export$2e2bcd8739ae039 = $20c74a585cb2c860$var$now;


/** Used to match a single whitespace character. */ var $d74bdd257728cf90$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d74bdd257728cf90$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d74bdd257728cf90$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d74bdd257728cf90$export$2e2bcd8739ae039 = $d74bdd257728cf90$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $66661208b19b5b1b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $66661208b19b5b1b$var$baseTrim(string) {
    return string ? string.slice(0, (0, $d74bdd257728cf90$export$2e2bcd8739ae039)(string) + 1).replace($66661208b19b5b1b$var$reTrimStart, '') : string;
}
var $66661208b19b5b1b$export$2e2bcd8739ae039 = $66661208b19b5b1b$var$baseTrim;




/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $1b818bf49f333098$export$2e2bcd8739ae039).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;



/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;


/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;


/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = '[object Null]', $ccdb19c7f0a62300$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $f302ffc9a48734c4$export$2e2bcd8739ae039) ? (0, $f302ffc9a48734c4$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $59fc01f5e412f819$export$2e2bcd8739ae039)(value) : (0, $94199a1861e07064$export$2e2bcd8739ae039)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;


/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $af254ed7460d123e$export$2e2bcd8739ae039)(value) && (0, $ccdb19c7f0a62300$export$2e2bcd8739ae039)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;


/** Used as references for various `Number` constants. */ var $0e87326299eb9bb7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0e87326299eb9bb7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0e87326299eb9bb7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0e87326299eb9bb7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0e87326299eb9bb7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0e87326299eb9bb7$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, $16b138b0231026b6$export$2e2bcd8739ae039)(value)) return $0e87326299eb9bb7$var$NAN;
    if ((0, $dd0c70c8150db920$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, $dd0c70c8150db920$export$2e2bcd8739ae039)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, $66661208b19b5b1b$export$2e2bcd8739ae039)(value);
    var isBinary = $0e87326299eb9bb7$var$reIsBinary.test(value);
    return isBinary || $0e87326299eb9bb7$var$reIsOctal.test(value) ? $0e87326299eb9bb7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0e87326299eb9bb7$var$reIsBadHex.test(value) ? $0e87326299eb9bb7$var$NAN : +value;
}
var $0e87326299eb9bb7$export$2e2bcd8739ae039 = $0e87326299eb9bb7$var$toNumber;


/** Error message constants. */ var $a122be60491e8d4a$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a122be60491e8d4a$var$nativeMax = Math.max, $a122be60491e8d4a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a122be60491e8d4a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($a122be60491e8d4a$var$FUNC_ERROR_TEXT);
    wait = (0, $0e87326299eb9bb7$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $dd0c70c8150db920$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $a122be60491e8d4a$var$nativeMax((0, $0e87326299eb9bb7$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a122be60491e8d4a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $20c74a585cb2c860$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $20c74a585cb2c860$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $20c74a585cb2c860$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $a122be60491e8d4a$export$2e2bcd8739ae039 = $a122be60491e8d4a$var$debounce;



/** Error message constants. */ var $1a1f02279ad00e7c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $1a1f02279ad00e7c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($1a1f02279ad00e7c$var$FUNC_ERROR_TEXT);
    if ((0, $dd0c70c8150db920$export$2e2bcd8739ae039)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, $a122be60491e8d4a$export$2e2bcd8739ae039)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $1a1f02279ad00e7c$export$2e2bcd8739ae039 = $1a1f02279ad00e7c$var$throttle;



var $8PNKb = parcelRequire("8PNKb");

function $752852d7be1532d9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $752852d7be1532d9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $752852d7be1532d9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $752852d7be1532d9$var$_createClass(e, r, t) {
    return Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $752852d7be1532d9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $752852d7be1532d9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $752852d7be1532d9$var$_slicedToArray(r, e) {
    return $752852d7be1532d9$var$_arrayWithHoles(r) || $752852d7be1532d9$var$_iterableToArrayLimit(r, e) || $752852d7be1532d9$var$_unsupportedIterableToArray(r, e) || $752852d7be1532d9$var$_nonIterableRest();
}
function $752852d7be1532d9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $752852d7be1532d9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $752852d7be1532d9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $752852d7be1532d9$var$Prop = /*#__PURE__*/ $752852d7be1532d9$var$_createClass(function Prop(name, _ref) {
    var _ref$default = _ref["default"], defaultVal = _ref$default === void 0 ? null : _ref$default, _ref$triggerUpdate = _ref.triggerUpdate, triggerUpdate = _ref$triggerUpdate === void 0 ? true : _ref$triggerUpdate, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function(newVal, state) {} : _ref$onChange;
    $752852d7be1532d9$var$_classCallCheck(this, Prop);
    this.name = name;
    this.defaultVal = defaultVal;
    this.triggerUpdate = triggerUpdate;
    this.onChange = onChange;
});
function $752852d7be1532d9$export$2e2bcd8739ae039(_ref2) {
    var _ref2$stateInit = _ref2.stateInit, stateInit = _ref2$stateInit === void 0 ? function() {
        return {};
    } : _ref2$stateInit, _ref2$props = _ref2.props, rawProps = _ref2$props === void 0 ? {} : _ref2$props, _ref2$methods = _ref2.methods, methods = _ref2$methods === void 0 ? {} : _ref2$methods, _ref2$aliases = _ref2.aliases, aliases = _ref2$aliases === void 0 ? {} : _ref2$aliases, _ref2$init = _ref2.init, initFn = _ref2$init === void 0 ? function() {} : _ref2$init, _ref2$update = _ref2.update, updateFn = _ref2$update === void 0 ? function() {} : _ref2$update;
    // Parse props into Prop instances
    var props = Object.keys(rawProps).map(function(propName) {
        return new $752852d7be1532d9$var$Prop(propName, rawProps[propName]);
    });
    return function KapsuleComp() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var classMode = !!(this instanceof KapsuleComp ? this.constructor : void 0);
        var nodeElement = classMode ? args.shift() : undefined;
        var _args$ = args[0], options = _args$ === void 0 ? {} : _args$;
        // Holds component state
        var state = Object.assign({}, stateInit instanceof Function ? stateInit(options) : stateInit, // Support plain objects for backwards compatibility
        {
            initialised: false
        });
        // keeps track of which props triggered an update
        var changedProps = {};
        // Component constructor
        function comp(nodeElement) {
            initStatic(nodeElement, options);
            digest();
            return comp;
        }
        var initStatic = function initStatic(nodeElement, options) {
            initFn.call(comp, nodeElement, state, options);
            state.initialised = true;
        };
        var digest = (0, $a122be60491e8d4a$export$2e2bcd8739ae039)(function() {
            if (!state.initialised) return;
            updateFn.call(comp, state, changedProps);
            changedProps = {};
        }, 1);
        // Getter/setter methods
        props.forEach(function(prop) {
            comp[prop.name] = getSetProp(prop);
            function getSetProp(_ref3) {
                var prop = _ref3.name, _ref3$triggerUpdate = _ref3.triggerUpdate, redigest = _ref3$triggerUpdate === void 0 ? false : _ref3$triggerUpdate, _ref3$onChange = _ref3.onChange, onChange = _ref3$onChange === void 0 ? function(newVal, state) {} : _ref3$onChange, _ref3$defaultVal = _ref3.defaultVal, defaultVal = _ref3$defaultVal === void 0 ? null : _ref3$defaultVal;
                return function(_) {
                    var curVal = state[prop];
                    if (!arguments.length) return curVal;
                     // Getter mode
                    var val = _ === undefined ? defaultVal : _; // pick default if value passed is undefined
                    state[prop] = val;
                    onChange.call(comp, val, state, curVal);
                    // track changed props
                    !changedProps.hasOwnProperty(prop) && (changedProps[prop] = curVal);
                    if (redigest) digest();
                    return comp;
                };
            }
        });
        // Other methods
        Object.keys(methods).forEach(function(methodName) {
            comp[methodName] = function() {
                var _methods$methodName;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return (_methods$methodName = methods[methodName]).call.apply(_methods$methodName, [
                    comp,
                    state
                ].concat(args));
            };
        });
        // Link aliases
        Object.entries(aliases).forEach(function(_ref4) {
            var _ref5 = $752852d7be1532d9$var$_slicedToArray(_ref4, 2), alias = _ref5[0], target = _ref5[1];
            return comp[alias] = comp[target];
        });
        // Reset all component props to their default value
        comp.resetProps = function() {
            props.forEach(function(prop) {
                comp[prop.name](prop.defaultVal);
            });
            return comp;
        };
        //
        comp.resetProps(); // Apply all prop defaults
        state._rerender = digest; // Expose digest method
        classMode && nodeElement && comp(nodeElement);
        return comp;
    };
}


var $85d8080a057d7be2$export$2e2bcd8739ae039 = function(p) {
    return typeof p === 'function' ? p // fn
     : typeof p === 'string' ? function(obj) {
        return obj[p];
    } // property name
     : function(obj) {
        return p;
    };
}; // constant


// This file is autogenerated. It's used to publish ESM to npm.
function $5ce907c1717e301d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5ce907c1717e301d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5ce907c1717e301d$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $5ce907c1717e301d$var$trimLeft = /^\s+/;
var $5ce907c1717e301d$var$trimRight = /\s+$/;
function $5ce907c1717e301d$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $5ce907c1717e301d$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $5ce907c1717e301d$export$2e2bcd8739ae039)) return new $5ce907c1717e301d$export$2e2bcd8739ae039(color, opts);
    var rgb = $5ce907c1717e301d$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$5ce907c1717e301d$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $5ce907c1717e301d$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $5ce907c1717e301d$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $5ce907c1717e301d$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $5ce907c1717e301d$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $5ce907c1717e301d$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $5ce907c1717e301d$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $5ce907c1717e301d$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($5ce907c1717e301d$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($5ce907c1717e301d$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($5ce907c1717e301d$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($5ce907c1717e301d$var$bound01(this._r, 255) * 100) + "%, " + Math.round($5ce907c1717e301d$var$bound01(this._g, 255) * 100) + "%, " + Math.round($5ce907c1717e301d$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($5ce907c1717e301d$var$bound01(this._r, 255) * 100) + "%, " + Math.round($5ce907c1717e301d$var$bound01(this._g, 255) * 100) + "%, " + Math.round($5ce907c1717e301d$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $5ce907c1717e301d$var$hexNames[$5ce907c1717e301d$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $5ce907c1717e301d$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $5ce907c1717e301d$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $5ce907c1717e301d$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $5ce907c1717e301d$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($5ce907c1717e301d$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($5ce907c1717e301d$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($5ce907c1717e301d$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($5ce907c1717e301d$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($5ce907c1717e301d$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($5ce907c1717e301d$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($5ce907c1717e301d$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($5ce907c1717e301d$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($5ce907c1717e301d$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($5ce907c1717e301d$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($5ce907c1717e301d$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($5ce907c1717e301d$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($5ce907c1717e301d$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$5ce907c1717e301d$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($5ce907c1717e301d$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $5ce907c1717e301d$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $5ce907c1717e301d$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $5ce907c1717e301d$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $5ce907c1717e301d$var$stringInputToObject(color);
    if ($5ce907c1717e301d$var$_typeof(color) == "object") {
        if ($5ce907c1717e301d$var$isValidCSSUnit(color.r) && $5ce907c1717e301d$var$isValidCSSUnit(color.g) && $5ce907c1717e301d$var$isValidCSSUnit(color.b)) {
            rgb = $5ce907c1717e301d$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($5ce907c1717e301d$var$isValidCSSUnit(color.h) && $5ce907c1717e301d$var$isValidCSSUnit(color.s) && $5ce907c1717e301d$var$isValidCSSUnit(color.v)) {
            s = $5ce907c1717e301d$var$convertToPercentage(color.s);
            v = $5ce907c1717e301d$var$convertToPercentage(color.v);
            rgb = $5ce907c1717e301d$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($5ce907c1717e301d$var$isValidCSSUnit(color.h) && $5ce907c1717e301d$var$isValidCSSUnit(color.s) && $5ce907c1717e301d$var$isValidCSSUnit(color.l)) {
            s = $5ce907c1717e301d$var$convertToPercentage(color.s);
            l = $5ce907c1717e301d$var$convertToPercentage(color.l);
            rgb = $5ce907c1717e301d$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $5ce907c1717e301d$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $5ce907c1717e301d$var$rgbToRgb(r, g, b) {
    return {
        r: $5ce907c1717e301d$var$bound01(r, 255) * 255,
        g: $5ce907c1717e301d$var$bound01(g, 255) * 255,
        b: $5ce907c1717e301d$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $5ce907c1717e301d$var$rgbToHsl(r, g, b) {
    r = $5ce907c1717e301d$var$bound01(r, 255);
    g = $5ce907c1717e301d$var$bound01(g, 255);
    b = $5ce907c1717e301d$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $5ce907c1717e301d$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $5ce907c1717e301d$var$bound01(h, 360);
    s = $5ce907c1717e301d$var$bound01(s, 100);
    l = $5ce907c1717e301d$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $5ce907c1717e301d$var$rgbToHsv(r, g, b) {
    r = $5ce907c1717e301d$var$bound01(r, 255);
    g = $5ce907c1717e301d$var$bound01(g, 255);
    b = $5ce907c1717e301d$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $5ce907c1717e301d$var$hsvToRgb(h, s, v) {
    h = $5ce907c1717e301d$var$bound01(h, 360) * 6;
    s = $5ce907c1717e301d$var$bound01(s, 100);
    v = $5ce907c1717e301d$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $5ce907c1717e301d$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $5ce907c1717e301d$var$pad2(Math.round(r).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(g).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $5ce907c1717e301d$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $5ce907c1717e301d$var$pad2(Math.round(r).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(g).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(b).toString(16)),
        $5ce907c1717e301d$var$pad2($5ce907c1717e301d$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $5ce907c1717e301d$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $5ce907c1717e301d$var$pad2($5ce907c1717e301d$var$convertDecimalToHex(a)),
        $5ce907c1717e301d$var$pad2(Math.round(r).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(g).toString(16)),
        $5ce907c1717e301d$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$5ce907c1717e301d$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $5ce907c1717e301d$export$2e2bcd8739ae039(color1).toRgbString() == $5ce907c1717e301d$export$2e2bcd8739ae039(color2).toRgbString();
};
$5ce907c1717e301d$export$2e2bcd8739ae039.random = function() {
    return $5ce907c1717e301d$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $5ce907c1717e301d$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $5ce907c1717e301d$var$clamp01(hsl.s);
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
function $5ce907c1717e301d$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $5ce907c1717e301d$var$clamp01(hsl.s);
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
function $5ce907c1717e301d$var$_greyscale(color) {
    return $5ce907c1717e301d$export$2e2bcd8739ae039(color).desaturate(100);
}
function $5ce907c1717e301d$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $5ce907c1717e301d$var$clamp01(hsl.l);
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
function $5ce907c1717e301d$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $5ce907c1717e301d$export$2e2bcd8739ae039(rgb);
}
function $5ce907c1717e301d$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $5ce907c1717e301d$var$clamp01(hsl.l);
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $5ce907c1717e301d$var$_spin(color, amount) {
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $5ce907c1717e301d$var$_complement(color) {
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $5ce907c1717e301d$export$2e2bcd8739ae039(hsl);
}
function $5ce907c1717e301d$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $5ce907c1717e301d$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($5ce907c1717e301d$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $5ce907c1717e301d$var$_splitcomplement(color) {
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $5ce907c1717e301d$export$2e2bcd8739ae039(color),
        $5ce907c1717e301d$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $5ce907c1717e301d$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $5ce907c1717e301d$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $5ce907c1717e301d$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($5ce907c1717e301d$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $5ce907c1717e301d$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $5ce907c1717e301d$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($5ce907c1717e301d$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$5ce907c1717e301d$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $5ce907c1717e301d$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $5ce907c1717e301d$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $5ce907c1717e301d$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$5ce907c1717e301d$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $5ce907c1717e301d$export$2e2bcd8739ae039(color1);
    var c2 = $5ce907c1717e301d$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$5ce907c1717e301d$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $5ce907c1717e301d$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $5ce907c1717e301d$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$5ce907c1717e301d$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $5ce907c1717e301d$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $5ce907c1717e301d$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($5ce907c1717e301d$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $5ce907c1717e301d$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $5ce907c1717e301d$var$names = $5ce907c1717e301d$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $5ce907c1717e301d$var$hexNames = $5ce907c1717e301d$export$2e2bcd8739ae039.hexNames = $5ce907c1717e301d$var$flip($5ce907c1717e301d$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $5ce907c1717e301d$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $5ce907c1717e301d$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $5ce907c1717e301d$var$bound01(n, max) {
    if ($5ce907c1717e301d$var$isOnePointZero(n)) n = "100%";
    var processPercent = $5ce907c1717e301d$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $5ce907c1717e301d$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $5ce907c1717e301d$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $5ce907c1717e301d$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $5ce907c1717e301d$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $5ce907c1717e301d$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $5ce907c1717e301d$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $5ce907c1717e301d$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $5ce907c1717e301d$var$convertHexToDecimal(h) {
    return $5ce907c1717e301d$var$parseIntFromHex(h) / 255;
}
var $5ce907c1717e301d$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $5ce907c1717e301d$var$isValidCSSUnit(color) {
    return !!$5ce907c1717e301d$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $5ce907c1717e301d$var$stringInputToObject(color) {
    color = color.replace($5ce907c1717e301d$var$trimLeft, "").replace($5ce907c1717e301d$var$trimRight, "").toLowerCase();
    var named = false;
    if ($5ce907c1717e301d$var$names[color]) {
        color = $5ce907c1717e301d$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $5ce907c1717e301d$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $5ce907c1717e301d$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $5ce907c1717e301d$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $5ce907c1717e301d$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $5ce907c1717e301d$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $5ce907c1717e301d$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $5ce907c1717e301d$var$matchers.hex8.exec(color)) return {
        r: $5ce907c1717e301d$var$parseIntFromHex(match[1]),
        g: $5ce907c1717e301d$var$parseIntFromHex(match[2]),
        b: $5ce907c1717e301d$var$parseIntFromHex(match[3]),
        a: $5ce907c1717e301d$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $5ce907c1717e301d$var$matchers.hex6.exec(color)) return {
        r: $5ce907c1717e301d$var$parseIntFromHex(match[1]),
        g: $5ce907c1717e301d$var$parseIntFromHex(match[2]),
        b: $5ce907c1717e301d$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $5ce907c1717e301d$var$matchers.hex4.exec(color)) return {
        r: $5ce907c1717e301d$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $5ce907c1717e301d$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $5ce907c1717e301d$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $5ce907c1717e301d$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $5ce907c1717e301d$var$matchers.hex3.exec(color)) return {
        r: $5ce907c1717e301d$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $5ce907c1717e301d$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $5ce907c1717e301d$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $5ce907c1717e301d$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}


function $84d37bd7f9a32b43$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $84d37bd7f9a32b43$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $84d37bd7f9a32b43$var$_arrayLikeToArray(r);
}
function $84d37bd7f9a32b43$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $84d37bd7f9a32b43$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $84d37bd7f9a32b43$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $84d37bd7f9a32b43$var$_classPrivateFieldGet2(s, a) {
    return s.get($84d37bd7f9a32b43$var$_assertClassBrand(s, a));
}
function $84d37bd7f9a32b43$var$_classPrivateFieldInitSpec(e, t, a) {
    $84d37bd7f9a32b43$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $84d37bd7f9a32b43$var$_classPrivateFieldSet2(s, a, r) {
    return s.set($84d37bd7f9a32b43$var$_assertClassBrand(s, a), r), r;
}
function $84d37bd7f9a32b43$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $84d37bd7f9a32b43$var$_toPropertyKey(o.key), o);
    }
}
function $84d37bd7f9a32b43$var$_createClass(e, r, t) {
    return r && $84d37bd7f9a32b43$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $84d37bd7f9a32b43$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $84d37bd7f9a32b43$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $84d37bd7f9a32b43$var$_toConsumableArray(r) {
    return $84d37bd7f9a32b43$var$_arrayWithoutHoles(r) || $84d37bd7f9a32b43$var$_iterableToArray(r) || $84d37bd7f9a32b43$var$_unsupportedIterableToArray(r) || $84d37bd7f9a32b43$var$_nonIterableSpread();
}
function $84d37bd7f9a32b43$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $84d37bd7f9a32b43$var$_toPropertyKey(t) {
    var i = $84d37bd7f9a32b43$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $84d37bd7f9a32b43$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $84d37bd7f9a32b43$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $84d37bd7f9a32b43$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $84d37bd7f9a32b43$var$ENTROPY = 123; // Raise numbers to prevent collisions in lower indexes
var $84d37bd7f9a32b43$var$int2HexColor = function int2HexColor(num) {
    return "#".concat(Math.min(num, Math.pow(2, 24)).toString(16).padStart(6, '0'));
};
var $84d37bd7f9a32b43$var$rgb2Int = function rgb2Int(r, g, b) {
    return (r << 16) + (g << 8) + b;
};
var $84d37bd7f9a32b43$var$colorStr2Int = function colorStr2Int(str) {
    var _tinyColor$toRgb = (0, $5ce907c1717e301d$export$2e2bcd8739ae039)(str).toRgb(), r = _tinyColor$toRgb.r, g = _tinyColor$toRgb.g, b = _tinyColor$toRgb.b;
    return $84d37bd7f9a32b43$var$rgb2Int(r, g, b);
};
var $84d37bd7f9a32b43$var$checksum = function checksum(n, csBits) {
    return n * $84d37bd7f9a32b43$var$ENTROPY % Math.pow(2, csBits);
};
var $84d37bd7f9a32b43$var$_registry = /*#__PURE__*/ new WeakMap();
var $84d37bd7f9a32b43$var$_csBits = /*#__PURE__*/ new WeakMap();
var $84d37bd7f9a32b43$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function _default() {
        var csBits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
        $84d37bd7f9a32b43$var$_classCallCheck(this, _default);
        // Internal state
        $84d37bd7f9a32b43$var$_classPrivateFieldInitSpec(this, $84d37bd7f9a32b43$var$_registry, void 0);
        // indexed objects for rgb lookup;
        $84d37bd7f9a32b43$var$_classPrivateFieldInitSpec(this, $84d37bd7f9a32b43$var$_csBits, void 0);
        $84d37bd7f9a32b43$var$_classPrivateFieldSet2($84d37bd7f9a32b43$var$_csBits, this, csBits);
        this.reset();
    }
    return $84d37bd7f9a32b43$var$_createClass(_default, [
        {
            key: "reset",
            value: function reset() {
                $84d37bd7f9a32b43$var$_classPrivateFieldSet2($84d37bd7f9a32b43$var$_registry, this, [
                    '__reserved for background__'
                ]);
            }
        },
        {
            key: "register",
            value: function register(obj) {
                if ($84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_registry, this).length >= Math.pow(2, 24 - $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this))) // color has 24 bits (-checksum)
                return null; // Registry is full
                var idx = $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_registry, this).length;
                var cs = $84d37bd7f9a32b43$var$checksum(idx, $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this));
                var color = $84d37bd7f9a32b43$var$int2HexColor(idx + (cs << 24 - $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this)));
                $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_registry, this).push(obj);
                return color;
            }
        },
        {
            key: "lookup",
            value: function lookup(color) {
                if (!color) return null; // invalid color
                var n = typeof color === 'string' ? $84d37bd7f9a32b43$var$colorStr2Int(color) : $84d37bd7f9a32b43$var$rgb2Int.apply(void 0, $84d37bd7f9a32b43$var$_toConsumableArray(color));
                if (!n) return null; // 0 index is reserved for background
                var idx = n & Math.pow(2, 24 - $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this)) - 1; // registry index
                var cs = n >> 24 - $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this) & Math.pow(2, $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this)) - 1; // extract bits reserved for checksum
                if ($84d37bd7f9a32b43$var$checksum(idx, $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_csBits, this)) !== cs || idx >= $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_registry, this).length) return null; // failed checksum or registry out of bounds
                return $84d37bd7f9a32b43$var$_classPrivateFieldGet2($84d37bd7f9a32b43$var$_registry, this)[idx];
            } // How many bits to reserve for checksum. Will eat away into the usable size of the registry.
        }
    ]);
}();




var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$v, $13c40c34b78c8ee2$var$y, $13c40c34b78c8ee2$var$d = {}, $13c40c34b78c8ee2$var$w = [], $13c40c34b78c8ee2$var$_ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$g = Array.isArray;
function $13c40c34b78c8ee2$var$m(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$b(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$x(l, e, i, r, null);
}
function $13c40c34b78c8ee2$var$x(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$$(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$$(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$$(n) : null;
}
function $13c40c34b78c8ee2$var$I(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $13c40c34b78c8ee2$var$m({}, u);
        o.__v = u.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$q(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $13c40c34b78c8ee2$var$$(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$D(i, o, r), u.__e = u.__ = null, o.__e != t && $13c40c34b78c8ee2$var$P(o);
    }
}
function $13c40c34b78c8ee2$var$P(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $13c40c34b78c8ee2$var$P(n);
}
function $13c40c34b78c8ee2$var$A(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$H.__r++ || $13c40c34b78c8ee2$var$r != $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$r = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$o)($13c40c34b78c8ee2$var$H);
}
function $13c40c34b78c8ee2$var$H() {
    try {
        for(var n, l = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > l && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), l = $13c40c34b78c8ee2$var$i.length, $13c40c34b78c8ee2$var$I(n);
    } finally{
        $13c40c34b78c8ee2$var$i.length = $13c40c34b78c8ee2$var$H.__r = 0;
    }
}
function $13c40c34b78c8ee2$var$L(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, g, m = t && t.__k || $13c40c34b78c8ee2$var$w, b = l.length;
    for(f = $13c40c34b78c8ee2$var$T(u, l, m, f, b), a = 0; a < b; a++)null != (p = u.__k[a]) && (h = -1 != p.__i && m[p.__i] || $13c40c34b78c8ee2$var$d, p.__i = a, _ = $13c40c34b78c8ee2$var$q(n, p, h, i, r, o, e, f, c, s), v = p.__e, p.ref && h.ref != p.ref && (h.ref && $13c40c34b78c8ee2$var$J(h.ref, null, p), s.push(p.ref, p.__c || v, p)), null == y && null != v && (y = v), (g = !!(4 & p.__u)) || h.__k === p.__k ? (f = $13c40c34b78c8ee2$var$j(p, f, n, g), g && h.__e && (h.__e = null)) : "function" == typeof p.type && void 0 !== _ ? f = _ : v && (f = v.nextSibling), p.__u &= -7);
    return u.__e = y, f;
}
function $13c40c34b78c8ee2$var$T(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $13c40c34b78c8ee2$var$x(null, o, null, null, null) : $13c40c34b78c8ee2$var$g(o) ? o = n.__k[r] = $13c40c34b78c8ee2$var$x($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $13c40c34b78c8ee2$var$x(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $13c40c34b78c8ee2$var$O(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c40c34b78c8ee2$var$$(e)), $13c40c34b78c8ee2$var$K(e, e));
    return t;
}
function $13c40c34b78c8ee2$var$j(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $13c40c34b78c8ee2$var$j(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $13c40c34b78c8ee2$var$$(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$g(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$O(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $13c40c34b78c8ee2$var$z(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$_.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$N(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$z(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c40c34b78c8ee2$var$z(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c40c34b78c8ee2$var$a, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u[$13c40c34b78c8ee2$var$s] = t[$13c40c34b78c8ee2$var$s] : (u[$13c40c34b78c8ee2$var$s] = $13c40c34b78c8ee2$var$h, n.addEventListener(l, r ? $13c40c34b78c8ee2$var$v : $13c40c34b78c8ee2$var$p, r)) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$v : $13c40c34b78c8ee2$var$p, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$V(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u[$13c40c34b78c8ee2$var$c]) u[$13c40c34b78c8ee2$var$c] = $13c40c34b78c8ee2$var$h++;
            else if (u[$13c40c34b78c8ee2$var$c] < t[$13c40c34b78c8ee2$var$s]) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$q(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, d, _, k, x, M, $, I, P, A, H, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (k = u.props, x = T.prototype && T.prototype.render, M = (a = T.contextType) && i[a.__c], $ = a ? M ? M.props.value : a.__ : i, t.__c ? _ = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(k, $) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(k, $), h.constructor = T, h.render = $13c40c34b78c8ee2$var$Q), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$m({}, h.__s)), $13c40c34b78c8ee2$var$m(h.__s, T.getDerivedStateFromProps(k, h.__s))), v = h.props, y = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && k !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, $)) {
                u.__v != t.__v && (h.props = k, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $13c40c34b78c8ee2$var$w.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, $), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, d);
            });
        }
        if (h.context = $, h.props = k, h.__P = n, h.__e = !1, I = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, P = 0, x) h.state = h.__s, h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), $13c40c34b78c8ee2$var$w.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++P < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$var$m({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (d = h.getSnapshotBeforeUpdate(v, y)), A = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? $13c40c34b78c8ee2$var$E(a.props.children) : a, f = $13c40c34b78c8ee2$var$L(n, $13c40c34b78c8ee2$var$g(A) ? A : [
            A
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), _ && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(H = o.length; H--;)$13c40c34b78c8ee2$var$b(o[H]);
                $13c40c34b78c8ee2$var$B(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $13c40c34b78c8ee2$var$B(u);
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c40c34b78c8ee2$var$G(t.__e, u, t, i, r, o, e, c, s);
    return (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$B(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($13c40c34b78c8ee2$var$B));
}
function $13c40c34b78c8ee2$var$D(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$J(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$E(n) {
    return "object" != typeof n || null == n || n.__b > 0 ? n : $13c40c34b78c8ee2$var$g(n) ? n.map($13c40c34b78c8ee2$var$E) : $13c40c34b78c8ee2$var$m({}, n);
}
function $13c40c34b78c8ee2$var$G(u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, w, _, m = i.props || $13c40c34b78c8ee2$var$d, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((y = e[a]) && "setAttribute" in y == !!x && (x ? y.localName == x : 3 == y.nodeType)) {
            u = y, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) m === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $13c40c34b78c8ee2$var$n.call(u.childNodes), !c && null != e) for(m = {}, a = 0; a < u.attributes.length; a++)m[(y = u.attributes[a]).name] = y.value;
        for(a in m)y = m[a], "dangerouslySetInnerHTML" == a ? p = y : "children" == a || a in k || "value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k || $13c40c34b78c8ee2$var$N(u, a, null, y, o);
        for(a in k)y = k[a], "children" == a ? v = y : "dangerouslySetInnerHTML" == a ? h = y : "value" == a ? w = y : "checked" == a ? _ = y : c && "function" != typeof y || m[a] === y || $13c40c34b78c8ee2$var$N(u, a, y, m[a], o);
        if (h) c || p && (h.__html == p.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $13c40c34b78c8ee2$var$L("template" == t.type ? u.content : u, $13c40c34b78c8ee2$var$g(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$$(i, 0), c, s), null != e) for(a = e.length; a--;)$13c40c34b78c8ee2$var$b(e[a]);
        c || (a = "value", "progress" == x && null == w ? u.removeAttribute("value") : null != w && (w !== u[a] || "progress" == x && !w || "option" == x && w != m[a]) && $13c40c34b78c8ee2$var$N(u, a, w, m[a], o), a = "checked", null != _ && _ != u[a] && $13c40c34b78c8ee2$var$N(u, a, _, m[a], o));
    }
    return u;
}
function $13c40c34b78c8ee2$var$J(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$K(n, u, t) {
    var i, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c40c34b78c8ee2$var$J(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c40c34b78c8ee2$var$K(i[r], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$b(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$Q(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c40c34b78c8ee2$var$q(t, u = (!r && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$d, $13c40c34b78c8ee2$var$d, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $13c40c34b78c8ee2$var$D(e, u, f);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $13c40c34b78c8ee2$var$m({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$x(l.type, f, i || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$A(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$y++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$w.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$m({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$m({}, u), this.props)), n && $13c40c34b78c8ee2$var$m(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$A(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$A(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$H.__r = 0, $13c40c34b78c8ee2$var$f = Math.random().toString(8), $13c40c34b78c8ee2$var$c = "__d" + $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$s = "__a" + $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$a = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$h = 0, $13c40c34b78c8ee2$var$p = $13c40c34b78c8ee2$var$V(!1), $13c40c34b78c8ee2$var$v = $13c40c34b78c8ee2$var$V(!0), $13c40c34b78c8ee2$var$y = 0;


function $9a9373909b03959a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9a9373909b03959a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9a9373909b03959a$var$_defineProperty(e, r, t) {
    return (r = $9a9373909b03959a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $9a9373909b03959a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9a9373909b03959a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a9373909b03959a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9a9373909b03959a$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9a9373909b03959a$var$ownKeys(Object(t), true).forEach(function(r) {
            $9a9373909b03959a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9a9373909b03959a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9a9373909b03959a$var$_slicedToArray(r, e) {
    return $9a9373909b03959a$var$_arrayWithHoles(r) || $9a9373909b03959a$var$_iterableToArrayLimit(r, e) || $9a9373909b03959a$var$_unsupportedIterableToArray(r, e) || $9a9373909b03959a$var$_nonIterableRest();
}
function $9a9373909b03959a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9a9373909b03959a$var$_toPropertyKey(t) {
    var i = $9a9373909b03959a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9a9373909b03959a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9a9373909b03959a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9a9373909b03959a$var$_typeof(o);
}
function $9a9373909b03959a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9a9373909b03959a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9a9373909b03959a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $9a9373909b03959a$var$_reactElement2VNode = function reactElement2VNode(el) {
    // Among other things, react VNodes (and all its children) need to have constructor: undefined attributes in order to be recognised, cloneElement (applied recursively) does the necessary conversion
    if (!($9a9373909b03959a$var$_typeof(el) === 'object')) return el;
    var res = (0, $13c40c34b78c8ee2$export$e530037191fcd5d7)(el);
    if (res.props) {
        var _res$props;
        res.props = $9a9373909b03959a$var$_objectSpread2({}, res.props);
        if (res !== null && res !== void 0 && (_res$props = res.props) !== null && _res$props !== void 0 && _res$props.children) res.props.children = Array.isArray(res.props.children) ? res.props.children.map($9a9373909b03959a$var$_reactElement2VNode) : $9a9373909b03959a$var$_reactElement2VNode(res.props.children);
    }
    return res;
};
var $9a9373909b03959a$var$isReactRenderable = function isReactRenderable(o) {
    return (0, $13c40c34b78c8ee2$export$a8257692ac88316c)((0, $13c40c34b78c8ee2$export$e530037191fcd5d7)(o));
};
var $9a9373909b03959a$var$render = function render(jsx, domEl) {
    delete domEl.__k; // Wipe traces of previous preact renders
    (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)($9a9373909b03959a$var$_reactElement2VNode(jsx), domEl);
};
function $9a9373909b03959a$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $9a9373909b03959a$var$css_248z = ".float-tooltip-kap {\n  position: absolute;\n  width: max-content; /* prevent shrinking near right edge */\n  max-width: max(50%, 150px);\n  padding: 3px 5px;\n  border-radius: 3px;\n  font: 12px sans-serif;\n  color: #eee;\n  background: rgba(0,0,0,0.6);\n  pointer-events: none;\n}\n";
$9a9373909b03959a$var$styleInject($9a9373909b03959a$var$css_248z);
var $9a9373909b03959a$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        content: {
            "default": false
        },
        offsetX: {
            triggerUpdate: false
        },
        // null or number
        offsetY: {
            triggerUpdate: false
        } // null or number
    },
    init: function init(domNode, state) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
        var isD3Selection = !!domNode && $9a9373909b03959a$var$_typeof(domNode) === 'object' && !!domNode.node && typeof domNode.node === 'function';
        var el = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(isD3Selection ? domNode.node() : domNode);
        // make sure container is positioned, to provide anchor for tooltip
        el.style('position') === 'static' && el.style('position', 'relative');
        state.tooltipEl = el.append('div').attr('class', 'float-tooltip-kap');
        Object.entries(style).forEach(function(_ref2) {
            var _ref3 = $9a9373909b03959a$var$_slicedToArray(_ref2, 2), k = _ref3[0], v = _ref3[1];
            return state.tooltipEl.style(k, v);
        });
        state.tooltipEl // start off-screen
        .style('left', '-10000px').style('display', 'none');
        var evSuffix = "tooltip-".concat(Math.round(Math.random() * 1e12));
        state.mouseInside = false;
        el.on("mousemove.".concat(evSuffix), function(ev) {
            state.mouseInside = true;
            var mousePos = (0, $1be794af963d8372$export$2e2bcd8739ae039)(ev);
            var domNode = el.node();
            var canvasWidth = domNode.offsetWidth;
            var canvasHeight = domNode.offsetHeight;
            var translate = [
                state.offsetX === null || state.offsetX === undefined ? "-".concat(mousePos[0] / canvasWidth * 100, "%") : typeof state.offsetX === 'number' ? "calc(-50% + ".concat(state.offsetX, "px)") : state.offsetX,
                state.offsetY === null || state.offsetY === undefined ? canvasHeight > 130 && canvasHeight - mousePos[1] < 100 ? 'calc(-100% - 6px)' : '21px' : typeof state.offsetY === 'number' ? state.offsetY < 0 ? "calc(-100% - ".concat(Math.abs(state.offsetY), "px)") : "".concat(state.offsetY, "px") : state.offsetY
            ];
            state.tooltipEl.style('left', mousePos[0] + 'px').style('top', mousePos[1] + 'px').style('transform', "translate(".concat(translate.join(','), ")"));
            state.content && state.tooltipEl.style('display', 'inline');
        });
        el.on("mouseover.".concat(evSuffix), function() {
            state.mouseInside = true;
            state.content && state.tooltipEl.style('display', 'inline');
        });
        el.on("mouseout.".concat(evSuffix), function() {
            state.mouseInside = false;
            state.tooltipEl.style('display', 'none');
        });
    },
    update: function update(state) {
        state.tooltipEl.style('display', !!state.content && state.mouseInside ? 'inline' : 'none');
        if (!state.content) state.tooltipEl.text('');
        else if (state.content instanceof HTMLElement) {
            state.tooltipEl.text(''); // empty it
            state.tooltipEl.append(function() {
                return state.content;
            });
        } else if (typeof state.content === 'string') state.tooltipEl.html(state.content);
        else if ($9a9373909b03959a$var$isReactRenderable(state.content)) {
            state.tooltipEl.text(''); // empty it
            $9a9373909b03959a$var$render(state.content, state.tooltipEl.node());
        } else {
            state.tooltipEl.style('display', 'none');
            console.warn('Tooltip content is invalid, skipping.', state.content, state.content.toString());
        }
    }
});


function $38b55043e008942d$export$2e2bcd8739ae039(x, y, z) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    if (z == null) z = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0, sz = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x || 0, sy += node.y || 0, sz += node.z || 0;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, sz = (sz / n - z) * strength, i = 0; i < n; ++i){
            node = nodes[i];
            if (sx) node.x -= sx;
            if (sy) node.y -= sy;
            if (sz) node.z -= sz;
        }
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.z = function(_) {
        return arguments.length ? (z = +_, force) : z;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

function $439e574675725ffd$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $873789d86530d8a0$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $b1bbf836822558b1$var$index(d) {
    return d.index;
}
function $b1bbf836822558b1$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $b1bbf836822558b1$export$2e2bcd8739ae039(links) {
    var id = $b1bbf836822558b1$var$index, strength = defaultStrength, strengths, distance = (0, $439e574675725ffd$export$2e2bcd8739ae039)(30), distances, nodes, nDim, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x = 0, y = 0, z = 0, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            if (nDim > 1) y = target.y + target.vy - source.y - source.vy || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            if (nDim > 2) z = target.z + target.vz - source.z - source.vz || (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y + z * z);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l, z *= l;
            target.vx -= x * (b = bias[i]);
            if (nDim > 1) target.vy -= y * b;
            if (nDim > 2) target.vz -= z * b;
            source.vx += x * (b = 1 - b);
            if (nDim > 1) source.vy += y * b;
            if (nDim > 2) source.vz += z * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $b1bbf836822558b1$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $b1bbf836822558b1$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, ...args) {
        nodes = _nodes;
        random = args.find((arg)=>typeof arg === 'function') || Math.random;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

function $57250c0faa51357c$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d);
    return $57250c0faa51357c$var$add(this.cover(x), x, d);
}
function $57250c0faa51357c$var$add(tree, x, d) {
    if (isNaN(x)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, x1 = tree._x1, xm, xp, right, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (parent = node, !(node = node[i = +right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    if (x === xp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(2) : tree._root = new Array(2);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
    }while ((i = +right) === (j = +(xp >= xm)));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $57250c0faa51357c$export$32ed0561867ec8a1(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    const n = data.length;
    const xz = new Float64Array(n);
    let x0 = Infinity, x1 = -Infinity;
    // Compute the points and their extent.
    for(let i = 0, x; i < n; ++i){
        if (isNaN(x = +this._x.call(null, data[i]))) continue;
        xz[i] = x;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0).cover(x1);
    // Add the new points.
    for(let i = 0; i < n; ++i)$57250c0faa51357c$var$add(this, xz[i], data[i]);
    return this;
}


function $d14927ef4fd63da1$export$2e2bcd8739ae039(x) {
    if (isNaN(x = +x)) return this; // ignore invalid points
    var x0 = this._x0, x1 = this._x1;
    // If the binarytree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing half boundaries don’t change due to floating point error!
    if (isNaN(x0)) x1 = (x0 = Math.floor(x)) + 1;
    else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1){
            i = +(x < x0);
            parent = new Array(2), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z;
                    break;
                case 1:
                    x0 = x1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._x1 = x1;
    return this;
}


function $dda78535ceca5ee1$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $fa07631210a576ec$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0]).cover(+_[1][0]) : isNaN(this._x0) ? undefined : [
        [
            this._x0
        ],
        [
            this._x1
        ]
    ];
}


function $cf3430a06897f678$export$2e2bcd8739ae039(node, x0, x1) {
    this.node = node;
    this.x0 = x0;
    this.x1 = x1;
}


function $71f8b79478b43ef4$export$2e2bcd8739ae039(x, radius) {
    var data, x0 = this._x0, x1, x2, x3 = this._x1, halves = [], node = this._root, q, i;
    if (node) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node, x0, x3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius;
        x3 = x + radius;
    }
    while(q = halves.pop()){
        // Stop searching if this half can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (x2 = q.x1) < x0) continue;
        // Bisect the current half.
        if (node.length) {
            var xm = (x1 + x2) / 2;
            halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node[1], xm, x2), new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node[0], x1, xm));
            // Visit the closest half first.
            if (i = +(x >= xm)) {
                q = halves[halves.length - 1];
                halves[halves.length - 1] = halves[halves.length - 1 - i];
                halves[halves.length - 1 - i] = q;
            }
        } else {
            var d = Math.abs(x - +this._x.call(null, node.data));
            if (d < radius) {
                radius = d;
                x0 = x - d;
                x3 = x + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $a9e86889947ccfe5$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, x1 = this._x1, x, xm, right, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (!(parent = node, node = node[i = +right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 1]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1]) && node === (parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $a9e86889947ccfe5$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $b2b3c48cf1ed3fdd$export$2e2bcd8739ae039() {
    return this._root;
}


function $1ee1c7685a3de474$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $024d91f59a2525f1$export$2e2bcd8739ae039(callback) {
    var halves = [], q, node = this._root, child, x0, x1;
    if (node) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(node, this._x0, this._x1));
    while(q = halves.pop())if (!callback(node = q.node, x0 = q.x0, x1 = q.x1) && node.length) {
        var xm = (x0 + x1) / 2;
        if (child = node[1]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, xm, x1));
        if (child = node[0]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, x0, xm));
    }
    return this;
}



function $fc24bef6f3700a02$export$2e2bcd8739ae039(callback) {
    var halves = [], next = [], q;
    if (this._root) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(this._root, this._x0, this._x1));
    while(q = halves.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, x1 = q.x1, xm = (x0 + x1) / 2;
            if (child = node[0]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, x0, xm));
            if (child = node[1]) halves.push(new (0, $cf3430a06897f678$export$2e2bcd8739ae039)(child, xm, x1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.x1);
    return this;
}


function $ed33e6a81b3ddf0d$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $ed33e6a81b3ddf0d$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $45b61d86bb7347bf$export$2e2bcd8739ae039(nodes, x) {
    var tree = new $45b61d86bb7347bf$var$Binarytree(x == null ? (0, $ed33e6a81b3ddf0d$export$e6fafc98131d2a44) : x, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $45b61d86bb7347bf$var$Binarytree(x, x0, x1) {
    this._x = x;
    this._x0 = x0;
    this._x1 = x1;
    this._root = undefined;
}
function $45b61d86bb7347bf$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $45b61d86bb7347bf$var$treeProto = $45b61d86bb7347bf$export$2e2bcd8739ae039.prototype = $45b61d86bb7347bf$var$Binarytree.prototype;
$45b61d86bb7347bf$var$treeProto.copy = function() {
    var copy = new $45b61d86bb7347bf$var$Binarytree(this._x, this._x0, this._x1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $45b61d86bb7347bf$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(2)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 2; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(2)
            });
            else node.target[i] = $45b61d86bb7347bf$var$leaf_copy(child);
        }
    }
    return copy;
};
$45b61d86bb7347bf$var$treeProto.add = (0, $57250c0faa51357c$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.addAll = (0, $57250c0faa51357c$export$32ed0561867ec8a1);
$45b61d86bb7347bf$var$treeProto.cover = (0, $d14927ef4fd63da1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.data = (0, $dda78535ceca5ee1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.extent = (0, $fa07631210a576ec$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.find = (0, $71f8b79478b43ef4$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.remove = (0, $a9e86889947ccfe5$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.removeAll = (0, $a9e86889947ccfe5$export$1cfc7aad5cb1833b);
$45b61d86bb7347bf$var$treeProto.root = (0, $b2b3c48cf1ed3fdd$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.size = (0, $1ee1c7685a3de474$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.visit = (0, $024d91f59a2525f1$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.visitAfter = (0, $fc24bef6f3700a02$export$2e2bcd8739ae039);
$45b61d86bb7347bf$var$treeProto.x = (0, $ed33e6a81b3ddf0d$export$2e2bcd8739ae039);


function $be1b12895c7da8cf$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $be1b12895c7da8cf$var$add(this.cover(x, y), x, y, d);
}
function $be1b12895c7da8cf$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $be1b12895c7da8cf$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$be1b12895c7da8cf$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $6063f984171c8523$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $cfd8a0ee53f875c5$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $feddd81cb3a1a5cd$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $75f49fd5af8d23e7$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $b7a6a4e6ea4402cb$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $9ea7286cd6ff459a$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9ea7286cd6ff459a$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $0d9e2b498bba95b5$export$2e2bcd8739ae039() {
    return this._root;
}


function $f92329c600392ac7$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $15a5c85e382805ba$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $9a4dcb6a46603c0e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $e002de94352e4f40$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $e002de94352e4f40$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $6a00482922687876$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $6a00482922687876$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $977cc0295d3f184c$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $977cc0295d3f184c$var$Quadtree(x == null ? (0, $e002de94352e4f40$export$e6fafc98131d2a44) : x, y == null ? (0, $6a00482922687876$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $977cc0295d3f184c$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $977cc0295d3f184c$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $977cc0295d3f184c$var$treeProto = $977cc0295d3f184c$export$2e2bcd8739ae039.prototype = $977cc0295d3f184c$var$Quadtree.prototype;
$977cc0295d3f184c$var$treeProto.copy = function() {
    var copy = new $977cc0295d3f184c$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $977cc0295d3f184c$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $977cc0295d3f184c$var$leaf_copy(child);
        }
    }
    return copy;
};
$977cc0295d3f184c$var$treeProto.add = (0, $be1b12895c7da8cf$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.addAll = (0, $be1b12895c7da8cf$export$32ed0561867ec8a1);
$977cc0295d3f184c$var$treeProto.cover = (0, $6063f984171c8523$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.data = (0, $cfd8a0ee53f875c5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.extent = (0, $feddd81cb3a1a5cd$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.find = (0, $b7a6a4e6ea4402cb$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.remove = (0, $9ea7286cd6ff459a$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.removeAll = (0, $9ea7286cd6ff459a$export$1cfc7aad5cb1833b);
$977cc0295d3f184c$var$treeProto.root = (0, $0d9e2b498bba95b5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.size = (0, $f92329c600392ac7$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visit = (0, $15a5c85e382805ba$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visitAfter = (0, $9a4dcb6a46603c0e$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.x = (0, $e002de94352e4f40$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.y = (0, $6a00482922687876$export$2e2bcd8739ae039);


function $d21522a7a85a91c2$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d), z = +this._z.call(null, d);
    return $d21522a7a85a91c2$var$add(this.cover(x, y, z), x, y, z, d);
}
function $d21522a7a85a91c2$var$add(tree, x, y, z, d) {
    if (isNaN(x) || isNaN(y) || isNaN(z)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, z0 = tree._z0, x1 = tree._x1, y1 = tree._y1, z1 = tree._z1, xm, ym, zm, xp, yp, zp, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (parent = node, !(node = node[i = deep << 2 | bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    zp = +tree._z.call(null, node.data);
    if (x === xp && y === yp && z === zp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(8) : tree._root = new Array(8);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
    }while ((i = deep << 2 | bottom << 1 | right) === (j = (zp >= zm) << 2 | (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $d21522a7a85a91c2$export$32ed0561867ec8a1(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    const n = data.length;
    const xz = new Float64Array(n);
    const yz = new Float64Array(n);
    const zz = new Float64Array(n);
    let x0 = Infinity, y0 = Infinity, z0 = Infinity, x1 = -Infinity, y1 = -Infinity, z1 = -Infinity;
    // Compute the points and their extent.
    for(let i = 0, d, x, y, z; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        zz[i] = z;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
        if (z < z0) z0 = z;
        if (z > z1) z1 = z;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1 || z0 > z1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0, z0).cover(x1, y1, z1);
    // Add the new points.
    for(let i = 0; i < n; ++i)$d21522a7a85a91c2$var$add(this, xz[i], yz[i], zz[i], data[i]);
    return this;
}


function $e1a8a07399b9cf06$export$2e2bcd8739ae039(x, y, z) {
    if (isNaN(x = +x) || isNaN(y = +y) || isNaN(z = +z)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1;
    // If the octree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing octant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
        z1 = (z0 = Math.floor(z)) + 1;
    } else {
        var t = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1 || z0 > z || z >= z1){
            i = (z < z0) << 2 | (y < y0) << 1 | x < x0;
            parent = new Array(8), parent[i] = node, node = parent, t *= 2;
            switch(i){
                case 0:
                    x1 = x0 + t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 1:
                    x0 = x1 - t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 2:
                    x1 = x0 + t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 3:
                    x0 = x1 - t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 4:
                    x1 = x0 + t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 5:
                    x0 = x1 - t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 6:
                    x1 = x0 + t, y0 = y1 - t, z0 = z1 - t;
                    break;
                case 7:
                    x0 = x1 - t, y0 = y1 - t, z0 = z1 - t;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    return this;
}


function $b0faad390127ba70$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $d98eb8f22d167a52$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1], +_[0][2]).cover(+_[1][0], +_[1][1], +_[1][2]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0,
            this._z0
        ],
        [
            this._x1,
            this._y1,
            this._z1
        ]
    ];
}


function $812250d8480ea962$export$2e2bcd8739ae039(node, x0, y0, z0, x1, y1, z1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.z0 = z0;
    this.x1 = x1;
    this.y1 = y1;
    this.z1 = z1;
}


function $9a9011ab754ae1ca$export$2e2bcd8739ae039(x, y, z, radius) {
    var data, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1, y1, z1, x2, y2, z2, x3 = this._x1, y3 = this._y1, z3 = this._z1, octs = [], node = this._root, q, i;
    if (node) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node, x0, y0, z0, x3, y3, z3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius, z0 = z - radius;
        x3 = x + radius, y3 = y + radius, z3 = z + radius;
        radius *= radius;
    }
    while(q = octs.pop()){
        // Stop searching if this octant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (z1 = q.z0) > z3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0 || (z2 = q.z1) < z0) continue;
        // Bisect the current octant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2, zm = (z1 + z2) / 2;
            octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[7], xm, ym, zm, x2, y2, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[6], x1, ym, zm, xm, y2, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[5], xm, y1, zm, x2, ym, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[4], x1, y1, zm, xm, ym, z2), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[3], xm, ym, z1, x2, y2, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[2], x1, ym, z1, xm, y2, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[1], xm, y1, z1, x2, ym, zm), new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node[0], x1, y1, z1, xm, ym, zm));
            // Visit the closest octant first.
            if (i = (z >= zm) << 2 | (y >= ym) << 1 | x >= xm) {
                q = octs[octs.length - 1];
                octs[octs.length - 1] = octs[octs.length - 1 - i];
                octs[octs.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), dz = z - +this._z.call(null, node.data), d2 = dx * dx + dy * dy + dz * dz;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d, z0 = z - d;
                x3 = x + d, y3 = y + d, z3 = z + d;
                data = node.data;
            }
        }
    }
    return data;
}


const $fde85d7e54ba2734$var$distance = (x1, y1, z1, x2, y2, z2)=>Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2 + (z1 - z2) ** 2);
function $fde85d7e54ba2734$export$36c76be95711f426(x, y, z, radius) {
    const result = [];
    const xMin = x - radius;
    const yMin = y - radius;
    const zMin = z - radius;
    const xMax = x + radius;
    const yMax = y + radius;
    const zMax = z + radius;
    this.visit((node, x1, y1, z1, x2, y2, z2)=>{
        if (!node.length) do {
            const d = node.data;
            if ($fde85d7e54ba2734$var$distance(x, y, z, this._x(d), this._y(d), this._z(d)) <= radius) result.push(d);
        }while (node = node.next);
        return x1 > xMax || y1 > yMax || z1 > zMax || x2 < xMin || y2 < yMin || z2 < zMin;
    });
    return result;
}


function $d677fcf60e454087$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1, x, y, z, xm, ym, zm, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (!(parent = node, node = node[i = deep << 2 | bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 7] || parent[i + 2 & 7] || parent[i + 3 & 7] || parent[i + 4 & 7] || parent[i + 5 & 7] || parent[i + 6 & 7] || parent[i + 7 & 7]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3] || parent[4] || parent[5] || parent[6] || parent[7]) && node === (parent[7] || parent[6] || parent[5] || parent[4] || parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $d677fcf60e454087$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $4174bfc6ca39974a$export$2e2bcd8739ae039() {
    return this._root;
}


function $b4a20dcf80e902c5$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $b4996a8350fe675e$export$2e2bcd8739ae039(callback) {
    var octs = [], q, node = this._root, child, x0, y0, z0, x1, y1, z1;
    if (node) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
        if (child = node[7]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, zm, x1, y1, z1));
        if (child = node[6]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, zm, xm, y1, z1));
        if (child = node[5]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, zm, x1, ym, z1));
        if (child = node[4]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, zm, xm, ym, z1));
        if (child = node[3]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, z0, x1, y1, zm));
        if (child = node[2]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, z0, xm, y1, zm));
        if (child = node[1]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, z0, x1, ym, zm));
        if (child = node[0]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, z0, xm, ym, zm));
    }
    return this;
}



function $3b341ea4c5e83f50$export$2e2bcd8739ae039(callback) {
    var octs = [], next = [], q;
    if (this._root) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
            if (child = node[0]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, z0, xm, ym, zm));
            if (child = node[1]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, z0, x1, ym, zm));
            if (child = node[2]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, z0, xm, y1, zm));
            if (child = node[3]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, z0, x1, y1, zm));
            if (child = node[4]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, y0, zm, xm, ym, z1));
            if (child = node[5]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, y0, zm, x1, ym, z1));
            if (child = node[6]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, x0, ym, zm, xm, y1, z1));
            if (child = node[7]) octs.push(new (0, $812250d8480ea962$export$2e2bcd8739ae039)(child, xm, ym, zm, x1, y1, z1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.z0, q.x1, q.y1, q.z1);
    return this;
}


function $3d754a90c7056106$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $3d754a90c7056106$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $a41f3a890178338c$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $a41f3a890178338c$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $73e0140023f54adb$export$f56e419c070182d8(d) {
    return d[2];
}
function $73e0140023f54adb$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._z = _, this) : this._z;
}


function $c0920825b99e823f$export$2e2bcd8739ae039(nodes, x, y, z) {
    var tree = new $c0920825b99e823f$var$Octree(x == null ? (0, $3d754a90c7056106$export$e6fafc98131d2a44) : x, y == null ? (0, $a41f3a890178338c$export$6f0a21aeb844a64c) : y, z == null ? (0, $73e0140023f54adb$export$f56e419c070182d8) : z, NaN, NaN, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $c0920825b99e823f$var$Octree(x, y, z, x0, y0, z0, x1, y1, z1) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    this._root = undefined;
}
function $c0920825b99e823f$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $c0920825b99e823f$var$treeProto = $c0920825b99e823f$export$2e2bcd8739ae039.prototype = $c0920825b99e823f$var$Octree.prototype;
$c0920825b99e823f$var$treeProto.copy = function() {
    var copy = new $c0920825b99e823f$var$Octree(this._x, this._y, this._z, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $c0920825b99e823f$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(8)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 8; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(8)
            });
            else node.target[i] = $c0920825b99e823f$var$leaf_copy(child);
        }
    }
    return copy;
};
$c0920825b99e823f$var$treeProto.add = (0, $d21522a7a85a91c2$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.addAll = (0, $d21522a7a85a91c2$export$32ed0561867ec8a1);
$c0920825b99e823f$var$treeProto.cover = (0, $e1a8a07399b9cf06$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.data = (0, $b0faad390127ba70$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.extent = (0, $d98eb8f22d167a52$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.find = (0, $9a9011ab754ae1ca$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.findAllWithinRadius = (0, $fde85d7e54ba2734$export$36c76be95711f426);
$c0920825b99e823f$var$treeProto.remove = (0, $d677fcf60e454087$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.removeAll = (0, $d677fcf60e454087$export$1cfc7aad5cb1833b);
$c0920825b99e823f$var$treeProto.root = (0, $4174bfc6ca39974a$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.size = (0, $b4a20dcf80e902c5$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.visit = (0, $b4996a8350fe675e$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.visitAfter = (0, $3b341ea4c5e83f50$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.x = (0, $3d754a90c7056106$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.y = (0, $a41f3a890178338c$export$2e2bcd8739ae039);
$c0920825b99e823f$var$treeProto.z = (0, $73e0140023f54adb$export$2e2bcd8739ae039);






// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $b6822525b674dc21$var$a = 1664525;
const $b6822525b674dc21$var$c = 1013904223;
const $b6822525b674dc21$var$m = 4294967296; // 2^32
function $b6822525b674dc21$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($b6822525b674dc21$var$a * s + $b6822525b674dc21$var$c) % $b6822525b674dc21$var$m) / $b6822525b674dc21$var$m;
}


var $a61c6b05e92f056e$var$MAX_DIMENSIONS = 3;
function $a61c6b05e92f056e$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $a61c6b05e92f056e$export$4a5767248b18ef41(d) {
    return d.y;
}
function $a61c6b05e92f056e$export$df995fae86a55f06(d) {
    return d.z;
}
var $a61c6b05e92f056e$var$initialRadius = 10, $a61c6b05e92f056e$var$initialAngleRoll = Math.PI * (3 - Math.sqrt(5)), $a61c6b05e92f056e$var$initialAngleYaw = Math.PI * 20 / (9 + Math.sqrt(221)); // Markov irrational number
function $a61c6b05e92f056e$export$2e2bcd8739ae039(nodes, numDimensions) {
    numDimensions = numDimensions || 2;
    var nDim = Math.min($a61c6b05e92f056e$var$MAX_DIMENSIONS, Math.max(1, Math.round(numDimensions))), simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(step), event = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("tick", "end"), random = (0, $b6822525b674dc21$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (nDim > 1) {
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
                if (nDim > 2) {
                    if (node.fz == null) node.z += node.vz *= velocityDecay;
                    else node.z = node.fz, node.vz = 0;
                }
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (node.fz != null) node.z = node.fz;
            if (isNaN(node.x) || nDim > 1 && isNaN(node.y) || nDim > 2 && isNaN(node.z)) {
                var radius = $a61c6b05e92f056e$var$initialRadius * (nDim > 2 ? Math.cbrt(0.5 + i) : nDim > 1 ? Math.sqrt(0.5 + i) : i), rollAngle = i * $a61c6b05e92f056e$var$initialAngleRoll, yawAngle = i * $a61c6b05e92f056e$var$initialAngleYaw;
                if (nDim === 1) node.x = radius;
                else if (nDim === 2) {
                    node.x = radius * Math.cos(rollAngle);
                    node.y = radius * Math.sin(rollAngle);
                } else {
                    node.x = radius * Math.sin(rollAngle) * Math.cos(yawAngle);
                    node.y = radius * Math.cos(rollAngle);
                    node.z = radius * Math.sin(rollAngle) * Math.sin(yawAngle);
                }
            }
            if (isNaN(node.vx) || nDim > 1 && isNaN(node.vy) || nDim > 2 && isNaN(node.vz)) {
                node.vx = 0;
                if (nDim > 1) node.vy = 0;
                if (nDim > 2) node.vz = 0;
            }
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random, nDim);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        numDimensions: function(_) {
            return arguments.length ? (nDim = Math.min($a61c6b05e92f056e$var$MAX_DIMENSIONS, Math.max(1, Math.round(_))), forces.forEach(initializeForce), simulation) : nDim;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function() {
            var args = Array.prototype.slice.call(arguments);
            var x = args.shift() || 0, y = (nDim > 1 ? args.shift() : null) || 0, z = (nDim > 2 ? args.shift() : null) || 0, radius = args.shift() || Infinity;
            var i = 0, n = nodes.length, dx, dy, dz, d2, node, closest;
            radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - (node.y || 0);
                dz = z - (node.z || 0);
                d2 = dx * dx + dy * dy + dz * dz;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $78193c16de4a9cf2$export$2e2bcd8739ae039() {
    var nodes, nDim, node, random, alpha, strength = (0, $439e574675725ffd$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (nDim === 1 ? (0, $45b61d86bb7347bf$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3)) : nDim === 2 ? (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3), (0, $a61c6b05e92f056e$export$4a5767248b18ef41)) : nDim === 3 ? (0, $c0920825b99e823f$export$2e2bcd8739ae039)(nodes, (0, $a61c6b05e92f056e$export$d141bba7fdc215a3), (0, $a61c6b05e92f056e$export$4a5767248b18ef41), (0, $a61c6b05e92f056e$export$df995fae86a55f06)) : null).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(treeNode) {
        var strength = 0, q, c, weight = 0, x, y, z, i;
        var numChildren = treeNode.length;
        // For internal nodes, accumulate forces from children.
        if (numChildren) {
            for(x = y = z = i = 0; i < numChildren; ++i)if ((q = treeNode[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * (q.x || 0), y += c * (q.y || 0), z += c * (q.z || 0);
            strength *= Math.sqrt(4 / numChildren); // scale accumulated strength according to number of dimensions
            treeNode.x = x / weight;
            if (nDim > 1) treeNode.y = y / weight;
            if (nDim > 2) treeNode.z = z / weight;
        } else {
            q = treeNode;
            q.x = q.data.x;
            if (nDim > 1) q.y = q.data.y;
            if (nDim > 2) q.z = q.data.z;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        treeNode.value = strength;
    }
    function apply(treeNode, x1, arg1, arg2, arg3) {
        if (!treeNode.value) return true;
        var x2 = [
            arg1,
            arg2,
            arg3
        ][nDim - 1];
        var x = treeNode.x - node.x, y = nDim > 1 ? treeNode.y - node.y : 0, z = nDim > 2 ? treeNode.z - node.z : 0, w = x2 - x1, l = x * x + y * y + z * z;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += x * x;
                if (nDim > 1 && y === 0) y = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += y * y;
                if (nDim > 2 && z === 0) z = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += z * z;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * treeNode.value * alpha / l;
                if (nDim > 1) node.vy += y * treeNode.value * alpha / l;
                if (nDim > 2) node.vz += z * treeNode.value * alpha / l;
            }
            return true;
        } else if (treeNode.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (treeNode.data !== node || treeNode.next) {
            if (x === 0) x = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += x * x;
            if (nDim > 1 && y === 0) y = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += y * y;
            if (nDim > 2 && z === 0) z = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += z * z;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (treeNode.data !== node) {
            w = strengths[treeNode.data.index] * alpha / l;
            node.vx += x * w;
            if (nDim > 1) node.vy += y * w;
            if (nDim > 2) node.vz += z * w;
        }
        while (treeNode = treeNode.next);
    }
    force.initialize = function(_nodes, ...args) {
        nodes = _nodes;
        random = args.find((arg)=>typeof arg === 'function') || Math.random;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}


function $91cad9d8ddc689ca$export$2e2bcd8739ae039(radius, x, y, z) {
    var nodes, nDim, strength = (0, $439e574675725ffd$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $439e574675725ffd$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    if (z == null) z = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = (node.y || 0) - y || 1e-6, dz = (node.z || 0) - z || 1e-6, r = Math.sqrt(dx * dx + dy * dy + dz * dz), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            if (nDim > 1) node.vy += dy * k;
            if (nDim > 2) node.vz += dz * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(initNodes, ...args) {
        nodes = initNodes;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.z = function(_) {
        return arguments.length ? (z = +_, force) : z;
    };
    return force;
}


/**
  A javascript Bezier curve library by Pomax.

  Based on http://pomax.github.io/bezierinfo

  This code is MIT licensed.
**/ 
// math-inlining.
const { abs: $fd4a732aea3c7f76$var$abs, cos: $fd4a732aea3c7f76$var$cos, sin: $fd4a732aea3c7f76$var$sin, acos: $fd4a732aea3c7f76$var$acos, atan2: $fd4a732aea3c7f76$var$atan2, sqrt: $fd4a732aea3c7f76$var$sqrt, pow: $fd4a732aea3c7f76$var$pow } = Math;
// cube root function yielding real roots
function $fd4a732aea3c7f76$var$crt(v) {
    return v < 0 ? -$fd4a732aea3c7f76$var$pow(-v, 1 / 3) : $fd4a732aea3c7f76$var$pow(v, 1 / 3);
}
// trig constants
const $fd4a732aea3c7f76$var$pi = Math.PI, $fd4a732aea3c7f76$var$tau = 2 * $fd4a732aea3c7f76$var$pi, $fd4a732aea3c7f76$var$quart = $fd4a732aea3c7f76$var$pi / 2, // float precision significant decimal
$fd4a732aea3c7f76$var$epsilon = 0.000001, // extremas used in bbox calculation and similar algorithms
$fd4a732aea3c7f76$var$nMax = Number.MAX_SAFE_INTEGER || 9007199254740991, $fd4a732aea3c7f76$var$nMin = Number.MIN_SAFE_INTEGER || -9007199254740991, // a zero coordinate, which is surprisingly useful
$fd4a732aea3c7f76$var$ZERO = {
    x: 0,
    y: 0,
    z: 0
};
// Bezier utility functions
const $fd4a732aea3c7f76$export$eab97d15b1788b8d = {
    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
    Tvalues: [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ],
    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
    Cvalues: [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ],
    arcfn: function(t, derivativeFn) {
        const d = derivativeFn(t);
        let l = d.x * d.x + d.y * d.y;
        if (typeof d.z !== "undefined") l += d.z * d.z;
        return $fd4a732aea3c7f76$var$sqrt(l);
    },
    compute: function(t, points, _3d) {
        // shortcuts
        if (t === 0) {
            points[0].t = 0;
            return points[0];
        }
        const order = points.length - 1;
        if (t === 1) {
            points[order].t = 1;
            return points[order];
        }
        const mt = 1 - t;
        let p = points;
        // constant?
        if (order === 0) {
            points[0].t = t;
            return points[0];
        }
        // linear?
        if (order === 1) {
            const ret = {
                x: mt * p[0].x + t * p[1].x,
                y: mt * p[0].y + t * p[1].y,
                t: t
            };
            if (_3d) ret.z = mt * p[0].z + t * p[1].z;
            return ret;
        }
        // quadratic/cubic curve?
        if (order < 4) {
            let mt2 = mt * mt, t2 = t * t, a, b, c, d = 0;
            if (order === 2) {
                p = [
                    p[0],
                    p[1],
                    p[2],
                    $fd4a732aea3c7f76$var$ZERO
                ];
                a = mt2;
                b = mt * t * 2;
                c = t2;
            } else if (order === 3) {
                a = mt2 * mt;
                b = mt2 * t * 3;
                c = mt * t2 * 3;
                d = t * t2;
            }
            const ret = {
                x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
                y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y,
                t: t
            };
            if (_3d) ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
            return ret;
        }
        // higher order curves: use de Casteljau's computation
        const dCpts = JSON.parse(JSON.stringify(points));
        while(dCpts.length > 1){
            for(let i = 0; i < dCpts.length - 1; i++){
                dCpts[i] = {
                    x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t,
                    y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t
                };
                if (typeof dCpts[i].z !== "undefined") dCpts[i].z = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t;
            }
            dCpts.splice(dCpts.length - 1, 1);
        }
        dCpts[0].t = t;
        return dCpts[0];
    },
    computeWithRatios: function(t, points, ratios, _3d) {
        const mt = 1 - t, r = ratios, p = points;
        let f1 = r[0], f2 = r[1], f3 = r[2], f4 = r[3], d;
        // spec for linear
        f1 *= mt;
        f2 *= t;
        if (p.length === 2) {
            d = f1 + f2;
            return {
                x: (f1 * p[0].x + f2 * p[1].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z) / d,
                t: t
            };
        }
        // upgrade to quadratic
        f1 *= mt;
        f2 *= 2 * mt;
        f3 *= t * t;
        if (p.length === 3) {
            d = f1 + f2 + f3;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z) / d,
                t: t
            };
        }
        // upgrade to cubic
        f1 *= mt;
        f2 *= 1.5 * mt;
        f3 *= 3 * mt;
        f4 *= t * t * t;
        if (p.length === 4) {
            d = f1 + f2 + f3 + f4;
            return {
                x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x + f4 * p[3].x) / d,
                y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y + f4 * p[3].y) / d,
                z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z + f4 * p[3].z) / d,
                t: t
            };
        }
    },
    derive: function(points, _3d) {
        const dpoints = [];
        for(let p = points, d = p.length, c = d - 1; d > 1; d--, c--){
            const list = [];
            for(let j = 0, dpt; j < c; j++){
                dpt = {
                    x: c * (p[j + 1].x - p[j].x),
                    y: c * (p[j + 1].y - p[j].y)
                };
                if (_3d) dpt.z = c * (p[j + 1].z - p[j].z);
                list.push(dpt);
            }
            dpoints.push(list);
            p = list;
        }
        return dpoints;
    },
    between: function(v, m, M) {
        return m <= v && v <= M || $fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(v, m) || $fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(v, M);
    },
    approximately: function(a, b, precision) {
        return $fd4a732aea3c7f76$var$abs(a - b) <= (precision || $fd4a732aea3c7f76$var$epsilon);
    },
    length: function(derivativeFn) {
        const z = 0.5, len = $fd4a732aea3c7f76$export$eab97d15b1788b8d.Tvalues.length;
        let sum = 0;
        for(let i = 0, t; i < len; i++){
            t = z * $fd4a732aea3c7f76$export$eab97d15b1788b8d.Tvalues[i] + z;
            sum += $fd4a732aea3c7f76$export$eab97d15b1788b8d.Cvalues[i] * $fd4a732aea3c7f76$export$eab97d15b1788b8d.arcfn(t, derivativeFn);
        }
        return z * sum;
    },
    map: function(v, ds, de, ts, te) {
        const d1 = de - ds, d2 = te - ts, v2 = v - ds, r = v2 / d1;
        return ts + d2 * r;
    },
    lerp: function(r, v1, v2) {
        const ret = {
            x: v1.x + r * (v2.x - v1.x),
            y: v1.y + r * (v2.y - v1.y)
        };
        if (v1.z !== undefined && v2.z !== undefined) ret.z = v1.z + r * (v2.z - v1.z);
        return ret;
    },
    pointToString: function(p) {
        let s = p.x + "/" + p.y;
        if (typeof p.z !== "undefined") s += "/" + p.z;
        return s;
    },
    pointsToString: function(points) {
        return "[" + points.map($fd4a732aea3c7f76$export$eab97d15b1788b8d.pointToString).join(", ") + "]";
    },
    copy: function(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    angle: function(o, v1, v2) {
        const dx1 = v1.x - o.x, dy1 = v1.y - o.y, dx2 = v2.x - o.x, dy2 = v2.y - o.y, cross = dx1 * dy2 - dy1 * dx2, dot = dx1 * dx2 + dy1 * dy2;
        return $fd4a732aea3c7f76$var$atan2(cross, dot);
    },
    // round as string, to avoid rounding errors
    round: function(v, d) {
        const s = "" + v;
        const pos = s.indexOf(".");
        return parseFloat(s.substring(0, pos + 1 + d));
    },
    dist: function(p1, p2) {
        const dx = p1.x - p2.x, dy = p1.y - p2.y;
        return $fd4a732aea3c7f76$var$sqrt(dx * dx + dy * dy);
    },
    closest: function(LUT, point) {
        let mdist = $fd4a732aea3c7f76$var$pow(2, 63), mpos, d;
        LUT.forEach(function(p, idx) {
            d = $fd4a732aea3c7f76$export$eab97d15b1788b8d.dist(point, p);
            if (d < mdist) {
                mdist = d;
                mpos = idx;
            }
        });
        return {
            mdist: mdist,
            mpos: mpos
        };
    },
    abcratio: function(t, n) {
        // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
        if (n !== 2 && n !== 3) return false;
        if (typeof t === "undefined") t = 0.5;
        else if (t === 0 || t === 1) return t;
        const bottom = $fd4a732aea3c7f76$var$pow(t, n) + $fd4a732aea3c7f76$var$pow(1 - t, n), top = bottom - 1;
        return $fd4a732aea3c7f76$var$abs(top / bottom);
    },
    projectionratio: function(t, n) {
        // see u(t) note on http://pomax.github.io/bezierinfo/#abc
        if (n !== 2 && n !== 3) return false;
        if (typeof t === "undefined") t = 0.5;
        else if (t === 0 || t === 1) return t;
        const top = $fd4a732aea3c7f76$var$pow(1 - t, n), bottom = $fd4a732aea3c7f76$var$pow(t, n) + top;
        return top / bottom;
    },
    lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
        const nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (d == 0) return false;
        return {
            x: nx / d,
            y: ny / d
        };
    },
    lli4: function(p1, p2, p3, p4) {
        const x1 = p1.x, y1 = p1.y, x2 = p2.x, y2 = p2.y, x3 = p3.x, y3 = p3.y, x4 = p4.x, y4 = p4.y;
        return $fd4a732aea3c7f76$export$eab97d15b1788b8d.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
    },
    lli: function(v1, v2) {
        return $fd4a732aea3c7f76$export$eab97d15b1788b8d.lli4(v1, v1.c, v2, v2.c);
    },
    makeline: function(p1, p2) {
        return new (0, $fe797824c4066803$export$2c85281379f83a27)(p1.x, p1.y, (p1.x + p2.x) / 2, (p1.y + p2.y) / 2, p2.x, p2.y);
    },
    findbbox: function(sections) {
        let mx = $fd4a732aea3c7f76$var$nMax, my = $fd4a732aea3c7f76$var$nMax, MX = $fd4a732aea3c7f76$var$nMin, MY = $fd4a732aea3c7f76$var$nMin;
        sections.forEach(function(s) {
            const bbox = s.bbox();
            if (mx > bbox.x.min) mx = bbox.x.min;
            if (my > bbox.y.min) my = bbox.y.min;
            if (MX < bbox.x.max) MX = bbox.x.max;
            if (MY < bbox.y.max) MY = bbox.y.max;
        });
        return {
            x: {
                min: mx,
                mid: (mx + MX) / 2,
                max: MX,
                size: MX - mx
            },
            y: {
                min: my,
                mid: (my + MY) / 2,
                max: MY,
                size: MY - my
            }
        };
    },
    shapeintersections: function(s1, bbox1, s2, bbox2, curveIntersectionThreshold) {
        if (!$fd4a732aea3c7f76$export$eab97d15b1788b8d.bboxoverlap(bbox1, bbox2)) return [];
        const intersections = [];
        const a1 = [
            s1.startcap,
            s1.forward,
            s1.back,
            s1.endcap
        ];
        const a2 = [
            s2.startcap,
            s2.forward,
            s2.back,
            s2.endcap
        ];
        a1.forEach(function(l1) {
            if (l1.virtual) return;
            a2.forEach(function(l2) {
                if (l2.virtual) return;
                const iss = l1.intersects(l2, curveIntersectionThreshold);
                if (iss.length > 0) {
                    iss.c1 = l1;
                    iss.c2 = l2;
                    iss.s1 = s1;
                    iss.s2 = s2;
                    intersections.push(iss);
                }
            });
        });
        return intersections;
    },
    makeshape: function(forward, back, curveIntersectionThreshold) {
        const bpl = back.points.length;
        const fpl = forward.points.length;
        const start = $fd4a732aea3c7f76$export$eab97d15b1788b8d.makeline(back.points[bpl - 1], forward.points[0]);
        const end = $fd4a732aea3c7f76$export$eab97d15b1788b8d.makeline(forward.points[fpl - 1], back.points[0]);
        const shape = {
            startcap: start,
            forward: forward,
            back: back,
            endcap: end,
            bbox: $fd4a732aea3c7f76$export$eab97d15b1788b8d.findbbox([
                start,
                forward,
                back,
                end
            ])
        };
        shape.intersections = function(s2) {
            return $fd4a732aea3c7f76$export$eab97d15b1788b8d.shapeintersections(shape, shape.bbox, s2, s2.bbox, curveIntersectionThreshold);
        };
        return shape;
    },
    getminmax: function(curve, d, list) {
        if (!list) return {
            min: 0,
            max: 0
        };
        let min = $fd4a732aea3c7f76$var$nMax, max = $fd4a732aea3c7f76$var$nMin, t, c;
        if (list.indexOf(0) === -1) list = [
            0
        ].concat(list);
        if (list.indexOf(1) === -1) list.push(1);
        for(let i = 0, len = list.length; i < len; i++){
            t = list[i];
            c = curve.get(t);
            if (c[d] < min) min = c[d];
            if (c[d] > max) max = c[d];
        }
        return {
            min: min,
            mid: (min + max) / 2,
            max: max,
            size: max - min
        };
    },
    align: function(points, line) {
        const tx = line.p1.x, ty = line.p1.y, a = -$fd4a732aea3c7f76$var$atan2(line.p2.y - ty, line.p2.x - tx), d = function(v) {
            return {
                x: (v.x - tx) * $fd4a732aea3c7f76$var$cos(a) - (v.y - ty) * $fd4a732aea3c7f76$var$sin(a),
                y: (v.x - tx) * $fd4a732aea3c7f76$var$sin(a) + (v.y - ty) * $fd4a732aea3c7f76$var$cos(a)
            };
        };
        return points.map(d);
    },
    roots: function(points, line) {
        line = line || {
            p1: {
                x: 0,
                y: 0
            },
            p2: {
                x: 1,
                y: 0
            }
        };
        const order = points.length - 1;
        const aligned = $fd4a732aea3c7f76$export$eab97d15b1788b8d.align(points, line);
        const reduce = function(t) {
            return 0 <= t && t <= 1;
        };
        if (order === 2) {
            const a = aligned[0].y, b = aligned[1].y, c = aligned[2].y, d = a - 2 * b + c;
            if (d !== 0) {
                const m1 = -$fd4a732aea3c7f76$var$sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                return [
                    v1,
                    v2
                ].filter(reduce);
            } else if (b !== c && d === 0) return [
                (2 * b - c) / (2 * b - 2 * c)
            ].filter(reduce);
            return [];
        }
        // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
        const pa = aligned[0].y, pb = aligned[1].y, pc = aligned[2].y, pd = aligned[3].y;
        let d = -pa + 3 * pb - 3 * pc + pd, a = 3 * pa - 6 * pb + 3 * pc, b = -3 * pa + 3 * pb, c = pa;
        if ($fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(d, 0)) {
            // this is not a cubic curve.
            if ($fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(a, 0)) {
                // in fact, this is not a quadratic curve either.
                if ($fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(b, 0)) // in fact in fact, there are no solutions.
                return [];
                // linear solution:
                return [
                    -c / b
                ].filter(reduce);
            }
            // quadratic solution:
            const q = $fd4a732aea3c7f76$var$sqrt(b * b - 4 * a * c), a2 = 2 * a;
            return [
                (q - b) / a2,
                (-b - q) / a2
            ].filter(reduce);
        }
        // at this point, we know we need a cubic solution:
        a /= d;
        b /= d;
        c /= d;
        const p = (3 * b - a * a) / 3, p3 = p / 3, q = (2 * a * a * a - 9 * a * b + 27 * c) / 27, q2 = q / 2, discriminant = q2 * q2 + p3 * p3 * p3;
        let u1, v1, x1, x2, x3;
        if (discriminant < 0) {
            const mp3 = -p / 3, mp33 = mp3 * mp3 * mp3, r = $fd4a732aea3c7f76$var$sqrt(mp33), t = -q / (2 * r), cosphi = t < -1 ? -1 : t > 1 ? 1 : t, phi = $fd4a732aea3c7f76$var$acos(cosphi), crtr = $fd4a732aea3c7f76$var$crt(r), t1 = 2 * crtr;
            x1 = t1 * $fd4a732aea3c7f76$var$cos(phi / 3) - a / 3;
            x2 = t1 * $fd4a732aea3c7f76$var$cos((phi + $fd4a732aea3c7f76$var$tau) / 3) - a / 3;
            x3 = t1 * $fd4a732aea3c7f76$var$cos((phi + 2 * $fd4a732aea3c7f76$var$tau) / 3) - a / 3;
            return [
                x1,
                x2,
                x3
            ].filter(reduce);
        } else if (discriminant === 0) {
            u1 = q2 < 0 ? $fd4a732aea3c7f76$var$crt(-q2) : -$fd4a732aea3c7f76$var$crt(q2);
            x1 = 2 * u1 - a / 3;
            x2 = -u1 - a / 3;
            return [
                x1,
                x2
            ].filter(reduce);
        } else {
            const sd = $fd4a732aea3c7f76$var$sqrt(discriminant);
            u1 = $fd4a732aea3c7f76$var$crt(-q2 + sd);
            v1 = $fd4a732aea3c7f76$var$crt(q2 + sd);
            return [
                u1 - v1 - a / 3
            ].filter(reduce);
        }
    },
    droots: function(p) {
        // quadratic roots are easy
        if (p.length === 3) {
            const a = p[0], b = p[1], c = p[2], d = a - 2 * b + c;
            if (d !== 0) {
                const m1 = -$fd4a732aea3c7f76$var$sqrt(b * b - a * c), m2 = -a + b, v1 = -(m1 + m2) / d, v2 = -(-m1 + m2) / d;
                return [
                    v1,
                    v2
                ];
            } else if (b !== c && d === 0) return [
                (2 * b - c) / (2 * (b - c))
            ];
            return [];
        }
        // linear roots are even easier
        if (p.length === 2) {
            const a = p[0], b = p[1];
            if (a !== b) return [
                a / (a - b)
            ];
            return [];
        }
        return [];
    },
    curvature: function(t, d1, d2, _3d, kOnly) {
        let num, dnm, adk, dk, k = 0, r = 0;
        //
        // We're using the following formula for curvature:
        //
        //              x'y" - y'x"
        //   k(t) = ------------------
        //           (x'² + y'²)^(3/2)
        //
        // from https://en.wikipedia.org/wiki/Radius_of_curvature#Definition
        //
        // With it corresponding 3D counterpart:
        //
        //          sqrt( (y'z" - y"z')² + (z'x" - z"x')² + (x'y" - x"y')²)
        //   k(t) = -------------------------------------------------------
        //                     (x'² + y'² + z'²)^(3/2)
        //
        const d = $fd4a732aea3c7f76$export$eab97d15b1788b8d.compute(t, d1);
        const dd = $fd4a732aea3c7f76$export$eab97d15b1788b8d.compute(t, d2);
        const qdsum = d.x * d.x + d.y * d.y;
        if (_3d) {
            num = $fd4a732aea3c7f76$var$sqrt($fd4a732aea3c7f76$var$pow(d.y * dd.z - dd.y * d.z, 2) + $fd4a732aea3c7f76$var$pow(d.z * dd.x - dd.z * d.x, 2) + $fd4a732aea3c7f76$var$pow(d.x * dd.y - dd.x * d.y, 2));
            dnm = $fd4a732aea3c7f76$var$pow(qdsum + d.z * d.z, 1.5);
        } else {
            num = d.x * dd.y - d.y * dd.x;
            dnm = $fd4a732aea3c7f76$var$pow(qdsum, 1.5);
        }
        if (num === 0 || dnm === 0) return {
            k: 0,
            r: 0
        };
        k = num / dnm;
        r = dnm / num;
        // We're also computing the derivative of kappa, because
        // there is value in knowing the rate of change for the
        // curvature along the curve. And we're just going to
        // ballpark it based on an epsilon.
        if (!kOnly) {
            // compute k'(t) based on the interval before, and after it,
            // to at least try to not introduce forward/backward pass bias.
            const pk = $fd4a732aea3c7f76$export$eab97d15b1788b8d.curvature(t - 0.001, d1, d2, _3d, true).k;
            const nk = $fd4a732aea3c7f76$export$eab97d15b1788b8d.curvature(t + 0.001, d1, d2, _3d, true).k;
            dk = (nk - k + (k - pk)) / 2;
            adk = ($fd4a732aea3c7f76$var$abs(nk - k) + $fd4a732aea3c7f76$var$abs(k - pk)) / 2;
        }
        return {
            k: k,
            r: r,
            dk: dk,
            adk: adk
        };
    },
    inflections: function(points) {
        if (points.length < 4) return [];
        // FIXME: TODO: add in inflection abstraction for quartic+ curves?
        const p = $fd4a732aea3c7f76$export$eab97d15b1788b8d.align(points, {
            p1: points[0],
            p2: points.slice(-1)[0]
        }), a = p[2].x * p[1].y, b = p[3].x * p[1].y, c = p[1].x * p[2].y, d = p[3].x * p[2].y, v1 = 18 * (-3 * a + 2 * b + 3 * c - d), v2 = 18 * (3 * a - b - 3 * c), v3 = 18 * (c - a);
        if ($fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(v1, 0)) {
            if (!$fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(v2, 0)) {
                let t = -v3 / v2;
                if (0 <= t && t <= 1) return [
                    t
                ];
            }
            return [];
        }
        const d2 = 2 * v1;
        if ($fd4a732aea3c7f76$export$eab97d15b1788b8d.approximately(d2, 0)) return [];
        const trm = v2 * v2 - 4 * v1 * v3;
        if (trm < 0) return [];
        const sq = Math.sqrt(trm);
        return [
            (sq - v2) / d2,
            -(v2 + sq) / d2
        ].filter(function(r) {
            return 0 <= r && r <= 1;
        });
    },
    bboxoverlap: function(b1, b2) {
        const dims = [
            "x",
            "y"
        ], len = dims.length;
        for(let i = 0, dim, l, t, d; i < len; i++){
            dim = dims[i];
            l = b1[dim].mid;
            t = b2[dim].mid;
            d = (b1[dim].size + b2[dim].size) / 2;
            if ($fd4a732aea3c7f76$var$abs(l - t) >= d) return false;
        }
        return true;
    },
    expandbox: function(bbox, _bbox) {
        if (_bbox.x.min < bbox.x.min) bbox.x.min = _bbox.x.min;
        if (_bbox.y.min < bbox.y.min) bbox.y.min = _bbox.y.min;
        if (_bbox.z && _bbox.z.min < bbox.z.min) bbox.z.min = _bbox.z.min;
        if (_bbox.x.max > bbox.x.max) bbox.x.max = _bbox.x.max;
        if (_bbox.y.max > bbox.y.max) bbox.y.max = _bbox.y.max;
        if (_bbox.z && _bbox.z.max > bbox.z.max) bbox.z.max = _bbox.z.max;
        bbox.x.mid = (bbox.x.min + bbox.x.max) / 2;
        bbox.y.mid = (bbox.y.min + bbox.y.max) / 2;
        if (bbox.z) bbox.z.mid = (bbox.z.min + bbox.z.max) / 2;
        bbox.x.size = bbox.x.max - bbox.x.min;
        bbox.y.size = bbox.y.max - bbox.y.min;
        if (bbox.z) bbox.z.size = bbox.z.max - bbox.z.min;
    },
    pairiteration: function(c1, c2, curveIntersectionThreshold) {
        const c1b = c1.bbox(), c2b = c2.bbox(), r = 100000, threshold = curveIntersectionThreshold || 0.5;
        if (c1b.x.size + c1b.y.size < threshold && c2b.x.size + c2b.y.size < threshold) return [
            (r * (c1._t1 + c1._t2) / 2 | 0) / r + "/" + (r * (c2._t1 + c2._t2) / 2 | 0) / r
        ];
        let cc1 = c1.split(0.5), cc2 = c2.split(0.5), pairs = [
            {
                left: cc1.left,
                right: cc2.left
            },
            {
                left: cc1.left,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.right
            },
            {
                left: cc1.right,
                right: cc2.left
            }
        ];
        pairs = pairs.filter(function(pair) {
            return $fd4a732aea3c7f76$export$eab97d15b1788b8d.bboxoverlap(pair.left.bbox(), pair.right.bbox());
        });
        let results = [];
        if (pairs.length === 0) return results;
        pairs.forEach(function(pair) {
            results = results.concat($fd4a732aea3c7f76$export$eab97d15b1788b8d.pairiteration(pair.left, pair.right, threshold));
        });
        results = results.filter(function(v, i) {
            return results.indexOf(v) === i;
        });
        return results;
    },
    getccenter: function(p1, p2, p3) {
        const dx1 = p2.x - p1.x, dy1 = p2.y - p1.y, dx2 = p3.x - p2.x, dy2 = p3.y - p2.y, dx1p = dx1 * $fd4a732aea3c7f76$var$cos($fd4a732aea3c7f76$var$quart) - dy1 * $fd4a732aea3c7f76$var$sin($fd4a732aea3c7f76$var$quart), dy1p = dx1 * $fd4a732aea3c7f76$var$sin($fd4a732aea3c7f76$var$quart) + dy1 * $fd4a732aea3c7f76$var$cos($fd4a732aea3c7f76$var$quart), dx2p = dx2 * $fd4a732aea3c7f76$var$cos($fd4a732aea3c7f76$var$quart) - dy2 * $fd4a732aea3c7f76$var$sin($fd4a732aea3c7f76$var$quart), dy2p = dx2 * $fd4a732aea3c7f76$var$sin($fd4a732aea3c7f76$var$quart) + dy2 * $fd4a732aea3c7f76$var$cos($fd4a732aea3c7f76$var$quart), // chord midpoints
        mx1 = (p1.x + p2.x) / 2, my1 = (p1.y + p2.y) / 2, mx2 = (p2.x + p3.x) / 2, my2 = (p2.y + p3.y) / 2, // midpoint offsets
        mx1n = mx1 + dx1p, my1n = my1 + dy1p, mx2n = mx2 + dx2p, my2n = my2 + dy2p, // intersection of these lines:
        arc = $fd4a732aea3c7f76$export$eab97d15b1788b8d.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n), r = $fd4a732aea3c7f76$export$eab97d15b1788b8d.dist(arc, p1);
        // arc start/end values, over mid point:
        let s = $fd4a732aea3c7f76$var$atan2(p1.y - arc.y, p1.x - arc.x), m = $fd4a732aea3c7f76$var$atan2(p2.y - arc.y, p2.x - arc.x), e = $fd4a732aea3c7f76$var$atan2(p3.y - arc.y, p3.x - arc.x), _;
        // determine arc direction (cw/ccw correction)
        if (s < e) {
            // if s<m<e, arc(s, e)
            // if m<s<e, arc(e, s + tau)
            // if s<e<m, arc(e, s + tau)
            if (s > m || m > e) s += $fd4a732aea3c7f76$var$tau;
            if (s > e) {
                _ = e;
                e = s;
                s = _;
            }
        } else // if e<m<s, arc(e, s)
        // if m<e<s, arc(s, e + tau)
        // if e<s<m, arc(s, e + tau)
        if (e < m && m < s) {
            _ = e;
            e = s;
            s = _;
        } else e += $fd4a732aea3c7f76$var$tau;
        // assign and done.
        arc.s = s;
        arc.e = e;
        arc.r = r;
        return arc;
    },
    numberSort: function(a, b) {
        return a - b;
    }
};



/**
 * Poly Bezier
 * @param {[type]} curves [description]
 */ class $d70f47ac075733ed$export$86641174d8fa723d {
    constructor(curves){
        this.curves = [];
        this._3d = false;
        if (!!curves) {
            this.curves = curves;
            this._3d = this.curves[0]._3d;
        }
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return "[" + this.curves.map(function(curve) {
            return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).pointsToString(curve.points);
        }).join(", ") + "]";
    }
    addCurve(curve) {
        this.curves.push(curve);
        this._3d = this._3d || curve._3d;
    }
    length() {
        return this.curves.map(function(v) {
            return v.length();
        }).reduce(function(a, b) {
            return a + b;
        });
    }
    curve(idx) {
        return this.curves[idx];
    }
    bbox() {
        const c = this.curves;
        var bbox = c[0].bbox();
        for(var i = 1; i < c.length; i++)(0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).expandbox(bbox, c[i].bbox());
        return bbox;
    }
    offset(d) {
        const offset = [];
        this.curves.forEach(function(v) {
            offset.push(...v.offset(d));
        });
        return new $d70f47ac075733ed$export$86641174d8fa723d(offset);
    }
}


// math-inlining.
const { abs: $fe797824c4066803$var$abs, min: $fe797824c4066803$var$min, max: $fe797824c4066803$var$max, cos: $fe797824c4066803$var$cos, sin: $fe797824c4066803$var$sin, acos: $fe797824c4066803$var$acos, sqrt: $fe797824c4066803$var$sqrt } = Math;
const $fe797824c4066803$var$pi = Math.PI;
// a zero coordinate, which is surprisingly useful
const $fe797824c4066803$var$ZERO = {
    x: 0,
    y: 0,
    z: 0
};
/**
 * Bezier curve constructor.
 *
 * ...docs pending...
 */ class $fe797824c4066803$export$2c85281379f83a27 {
    constructor(coords){
        let args = coords && coords.forEach ? coords : Array.from(arguments).slice();
        let coordlen = false;
        if (typeof args[0] === "object") {
            coordlen = args.length;
            const newargs = [];
            args.forEach(function(point) {
                [
                    "x",
                    "y",
                    "z"
                ].forEach(function(d) {
                    if (typeof point[d] !== "undefined") newargs.push(point[d]);
                });
            });
            args = newargs;
        }
        let higher = false;
        const len = args.length;
        if (coordlen) {
            if (coordlen > 4) {
                if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
                higher = true;
            }
        } else if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
            if (arguments.length !== 1) throw new Error("Only new Bezier(point[]) is accepted for 4th and higher order curves");
        }
        const _3d = this._3d = !higher && (len === 9 || len === 12) || coords && coords[0] && typeof coords[0].z !== "undefined";
        const points = this.points = [];
        for(let idx = 0, step = _3d ? 3 : 2; idx < len; idx += step){
            var point = {
                x: args[idx],
                y: args[idx + 1]
            };
            if (_3d) point.z = args[idx + 2];
            points.push(point);
        }
        const order = this.order = points.length - 1;
        const dims = this.dims = [
            "x",
            "y"
        ];
        if (_3d) dims.push("z");
        this.dimlen = dims.length;
        // is this curve, practically speaking, a straight line?
        const aligned = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).align(points, {
            p1: points[0],
            p2: points[order]
        });
        const baselength = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(points[0], points[order]);
        this._linear = aligned.reduce((t1, p)=>t1 + $fe797824c4066803$var$abs(p.y), 0) < baselength / 50;
        this._lut = [];
        this._t1 = 0;
        this._t2 = 1;
        this.update();
    }
    static quadraticFromPoints(p1, p2, p3, t1) {
        if (typeof t1 === "undefined") t1 = 0.5;
        // shortcuts, although they're really dumb
        if (t1 === 0) return new $fe797824c4066803$export$2c85281379f83a27(p2, p2, p3);
        if (t1 === 1) return new $fe797824c4066803$export$2c85281379f83a27(p1, p2, p2);
        // real fitting.
        const abc = $fe797824c4066803$export$2c85281379f83a27.getABC(2, p1, p2, p3, t1);
        return new $fe797824c4066803$export$2c85281379f83a27(p1, abc.A, p3);
    }
    static cubicFromPoints(S, B, E, t1, d1) {
        if (typeof t1 === "undefined") t1 = 0.5;
        const abc = $fe797824c4066803$export$2c85281379f83a27.getABC(3, S, B, E, t1);
        if (typeof d1 === "undefined") d1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(B, abc.C);
        const d2 = d1 * (1 - t1) / t1;
        const selen = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(S, E), lx = (E.x - S.x) / selen, ly = (E.y - S.y) / selen, bx1 = d1 * lx, by1 = d1 * ly, bx2 = d2 * lx, by2 = d2 * ly;
        // derivation of new hull coordinates
        const e1 = {
            x: B.x - bx1,
            y: B.y - by1
        }, e2 = {
            x: B.x + bx2,
            y: B.y + by2
        }, A = abc.A, v1 = {
            x: A.x + (e1.x - A.x) / (1 - t1),
            y: A.y + (e1.y - A.y) / (1 - t1)
        }, v2 = {
            x: A.x + (e2.x - A.x) / t1,
            y: A.y + (e2.y - A.y) / t1
        }, nc1 = {
            x: S.x + (v1.x - S.x) / t1,
            y: S.y + (v1.y - S.y) / t1
        }, nc2 = {
            x: E.x + (v2.x - E.x) / (1 - t1),
            y: E.y + (v2.y - E.y) / (1 - t1)
        };
        // ...done
        return new $fe797824c4066803$export$2c85281379f83a27(S, nc1, nc2, E);
    }
    static getUtils() {
        return 0, $fd4a732aea3c7f76$export$eab97d15b1788b8d;
    }
    getUtils() {
        return $fe797824c4066803$export$2c85281379f83a27.getUtils();
    }
    static get PolyBezier() {
        return 0, $d70f47ac075733ed$export$86641174d8fa723d;
    }
    valueOf() {
        return this.toString();
    }
    toString() {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).pointsToString(this.points);
    }
    toSVG() {
        if (this._3d) return false;
        const p = this.points, x = p[0].x, y = p[0].y, s = [
            "M",
            x,
            y,
            this.order === 2 ? "Q" : "C"
        ];
        for(let i = 1, last = p.length; i < last; i++){
            s.push(p[i].x);
            s.push(p[i].y);
        }
        return s.join(" ");
    }
    setRatios(ratios) {
        if (ratios.length !== this.points.length) throw new Error("incorrect number of ratio values");
        this.ratios = ratios;
        this._lut = []; //  invalidate any precomputed LUT
    }
    verify() {
        const print = this.coordDigest();
        if (print !== this._print) {
            this._print = print;
            this.update();
        }
    }
    coordDigest() {
        return this.points.map(function(c, pos) {
            return "" + pos + c.x + c.y + (c.z ? c.z : 0);
        }).join("");
    }
    update() {
        // invalidate any precomputed LUT
        this._lut = [];
        this.dpoints = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).derive(this.points, this._3d);
        this.computedirection();
    }
    computedirection() {
        const points = this.points;
        const angle = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).angle(points[0], points[this.order], points[1]);
        this.clockwise = angle > 0;
    }
    length() {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).length(this.derivative.bind(this));
    }
    static getABC(order = 2, S, B, E, t1 = 0.5) {
        const u = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).projectionratio(t1, order), um = 1 - u, C = {
            x: u * S.x + um * E.x,
            y: u * S.y + um * E.y
        }, s = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).abcratio(t1, order), A = {
            x: B.x + (B.x - C.x) / s,
            y: B.y + (B.y - C.y) / s
        };
        return {
            A: A,
            B: B,
            C: C,
            S: S,
            E: E
        };
    }
    getABC(t1, B) {
        B = B || this.get(t1);
        let S = this.points[0];
        let E = this.points[this.order];
        return $fe797824c4066803$export$2c85281379f83a27.getABC(this.order, S, B, E, t1);
    }
    getLUT(steps) {
        this.verify();
        steps = steps || 100;
        if (this._lut.length === steps + 1) return this._lut;
        this._lut = [];
        // n steps means n+1 points
        steps++;
        this._lut = [];
        for(let i = 0, p, t1; i < steps; i++){
            t1 = i / (steps - 1);
            p = this.compute(t1);
            p.t = t1;
            this._lut.push(p);
        }
        return this._lut;
    }
    on(point, error) {
        error = error || 5;
        const lut = this.getLUT(), hits = [];
        for(let i = 0, c, t1 = 0; i < lut.length; i++){
            c = lut[i];
            if ((0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(c, point) < error) {
                hits.push(c);
                t1 += i / lut.length;
            }
        }
        if (!hits.length) return false;
        return t /= hits.length;
    }
    project(point) {
        // step 1: coarse check
        const LUT = this.getLUT(), l = LUT.length - 1, closest = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).closest(LUT, point), mpos = closest.mpos, t1 = (mpos - 1) / l, t2 = (mpos + 1) / l, step = 0.1 / l;
        // step 2: fine check
        let mdist = closest.mdist, t3 = t1, ft = t3, p;
        mdist += 1;
        for(let d; t3 < t2 + step; t3 += step){
            p = this.compute(t3);
            d = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(point, p);
            if (d < mdist) {
                mdist = d;
                ft = t3;
            }
        }
        ft = ft < 0 ? 0 : ft > 1 ? 1 : ft;
        p = this.compute(ft);
        p.t = ft;
        p.d = mdist;
        return p;
    }
    get(t1) {
        return this.compute(t1);
    }
    point(idx) {
        return this.points[idx];
    }
    compute(t1) {
        if (this.ratios) return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).computeWithRatios(t1, this.points, this.ratios, this._3d);
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).compute(t1, this.points, this._3d, this.ratios);
    }
    raise() {
        const p = this.points, np = [
            p[0]
        ], k = p.length;
        for(let i = 1, pi, pim; i < k; i++){
            pi = p[i];
            pim = p[i - 1];
            np[i] = {
                x: (k - i) / k * pi.x + i / k * pim.x,
                y: (k - i) / k * pi.y + i / k * pim.y
            };
        }
        np[k] = p[k - 1];
        return new $fe797824c4066803$export$2c85281379f83a27(np);
    }
    derivative(t1) {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).compute(t1, this.dpoints[0], this._3d);
    }
    dderivative(t1) {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).compute(t1, this.dpoints[1], this._3d);
    }
    align() {
        let p = this.points;
        return new $fe797824c4066803$export$2c85281379f83a27((0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).align(p, {
            p1: p[0],
            p2: p[p.length - 1]
        }));
    }
    curvature(t1) {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).curvature(t1, this.dpoints[0], this.dpoints[1], this._3d);
    }
    inflections() {
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).inflections(this.points);
    }
    normal(t1) {
        return this._3d ? this.__normal3(t1) : this.__normal2(t1);
    }
    __normal2(t1) {
        const d = this.derivative(t1);
        const q = $fe797824c4066803$var$sqrt(d.x * d.x + d.y * d.y);
        return {
            t: t1,
            x: -d.y / q,
            y: d.x / q
        };
    }
    __normal3(t1) {
        // see http://stackoverflow.com/questions/25453159
        const r1 = this.derivative(t1), r2 = this.derivative(t1 + 0.01), q1 = $fe797824c4066803$var$sqrt(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z), q2 = $fe797824c4066803$var$sqrt(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
        r1.x /= q1;
        r1.y /= q1;
        r1.z /= q1;
        r2.x /= q2;
        r2.y /= q2;
        r2.z /= q2;
        // cross product
        const c = {
            x: r2.y * r1.z - r2.z * r1.y,
            y: r2.z * r1.x - r2.x * r1.z,
            z: r2.x * r1.y - r2.y * r1.x
        };
        const m = $fe797824c4066803$var$sqrt(c.x * c.x + c.y * c.y + c.z * c.z);
        c.x /= m;
        c.y /= m;
        c.z /= m;
        // rotation matrix
        const R = [
            c.x * c.x,
            c.x * c.y - c.z,
            c.x * c.z + c.y,
            c.x * c.y + c.z,
            c.y * c.y,
            c.y * c.z - c.x,
            c.x * c.z - c.y,
            c.y * c.z + c.x,
            c.z * c.z
        ];
        // normal vector:
        const n = {
            t: t1,
            x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
            y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
            z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
        };
        return n;
    }
    hull(t1) {
        let p = this.points, _p = [], q = [], idx = 0;
        q[idx++] = p[0];
        q[idx++] = p[1];
        q[idx++] = p[2];
        if (this.order === 3) q[idx++] = p[3];
        // we lerp between all points at each iteration, until we have 1 point left.
        while(p.length > 1){
            _p = [];
            for(let i = 0, pt, l = p.length - 1; i < l; i++){
                pt = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).lerp(t1, p[i], p[i + 1]);
                q[idx++] = pt;
                _p.push(pt);
            }
            p = _p;
        }
        return q;
    }
    split(t1, t2) {
        // shortcuts
        if (t1 === 0 && !!t2) return this.split(t2).left;
        if (t2 === 1) return this.split(t1).right;
        // no shortcut: use "de Casteljau" iteration.
        const q = this.hull(t1);
        const result = {
            left: this.order === 2 ? new $fe797824c4066803$export$2c85281379f83a27([
                q[0],
                q[3],
                q[5]
            ]) : new $fe797824c4066803$export$2c85281379f83a27([
                q[0],
                q[4],
                q[7],
                q[9]
            ]),
            right: this.order === 2 ? new $fe797824c4066803$export$2c85281379f83a27([
                q[5],
                q[4],
                q[2]
            ]) : new $fe797824c4066803$export$2c85281379f83a27([
                q[9],
                q[8],
                q[6],
                q[3]
            ]),
            span: q
        };
        // make sure we bind _t1/_t2 information!
        result.left._t1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(0, 0, 1, this._t1, this._t2);
        result.left._t2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t1, 0, 1, this._t1, this._t2);
        result.right._t1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t1, 0, 1, this._t1, this._t2);
        result.right._t2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(1, 0, 1, this._t1, this._t2);
        // if we have no t2, we're done
        if (!t2) return result;
        // if we have a t2, split again:
        t2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t2, t1, 1, 0, 1);
        return result.right.split(t2).left;
    }
    extrema() {
        const result = {};
        let roots = [];
        this.dims.forEach((function(dim) {
            let mfn = function(v) {
                return v[dim];
            };
            let p = this.dpoints[0].map(mfn);
            result[dim] = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).droots(p);
            if (this.order === 3) {
                p = this.dpoints[1].map(mfn);
                result[dim] = result[dim].concat((0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).droots(p));
            }
            result[dim] = result[dim].filter(function(t1) {
                return t1 >= 0 && t1 <= 1;
            });
            roots = roots.concat(result[dim].sort((0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).numberSort));
        }).bind(this));
        result.values = roots.sort((0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).numberSort).filter(function(v, idx) {
            return roots.indexOf(v) === idx;
        });
        return result;
    }
    bbox() {
        const extrema = this.extrema(), result = {};
        this.dims.forEach((function(d) {
            result[d] = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).getminmax(this, d, extrema[d]);
        }).bind(this));
        return result;
    }
    overlaps(curve) {
        const lbbox = this.bbox(), tbbox = curve.bbox();
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).bboxoverlap(lbbox, tbbox);
    }
    offset(t1, d) {
        if (typeof d !== "undefined") {
            const c = this.get(t1), n = this.normal(t1);
            const ret = {
                c: c,
                n: n,
                x: c.x + n.x * d,
                y: c.y + n.y * d
            };
            if (this._3d) ret.z = c.z + n.z * d;
            return ret;
        }
        if (this._linear) {
            const nv = this.normal(0), coords = this.points.map(function(p) {
                const ret = {
                    x: p.x + t1 * nv.x,
                    y: p.y + t1 * nv.y
                };
                if (p.z && nv.z) ret.z = p.z + t1 * nv.z;
                return ret;
            });
            return [
                new $fe797824c4066803$export$2c85281379f83a27(coords)
            ];
        }
        return this.reduce().map(function(s) {
            if (s._linear) return s.offset(t1)[0];
            return s.scale(t1);
        });
    }
    simple() {
        if (this.order === 3) {
            const a1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).angle(this.points[0], this.points[3], this.points[1]);
            const a2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).angle(this.points[0], this.points[3], this.points[2]);
            if (a1 > 0 && a2 < 0 || a1 < 0 && a2 > 0) return false;
        }
        const n1 = this.normal(0);
        const n2 = this.normal(1);
        let s = n1.x * n2.x + n1.y * n2.y;
        if (this._3d) s += n1.z * n2.z;
        return $fe797824c4066803$var$abs($fe797824c4066803$var$acos(s)) < $fe797824c4066803$var$pi / 3;
    }
    reduce() {
        // TODO: examine these var types in more detail...
        let i, t1 = 0, t2 = 0, step = 0.01, segment, pass1 = [], pass2 = [];
        // first pass: split on extrema
        let extrema = this.extrema().values;
        if (extrema.indexOf(0) === -1) extrema = [
            0
        ].concat(extrema);
        if (extrema.indexOf(1) === -1) extrema.push(1);
        for(t1 = extrema[0], i = 1; i < extrema.length; i++){
            t2 = extrema[i];
            segment = this.split(t1, t2);
            segment._t1 = t1;
            segment._t2 = t2;
            pass1.push(segment);
            t1 = t2;
        }
        // second pass: further reduce these segments to simple segments
        pass1.forEach(function(p1) {
            t1 = 0;
            t2 = 0;
            while(t2 <= 1)for(t2 = t1 + step; t2 <= 1 + step; t2 += step){
                segment = p1.split(t1, t2);
                if (!segment.simple()) {
                    t2 -= step;
                    if ($fe797824c4066803$var$abs(t1 - t2) < step) // we can never form a reduction
                    return [];
                    segment = p1.split(t1, t2);
                    segment._t1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t1, 0, 1, p1._t1, p1._t2);
                    segment._t2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t2, 0, 1, p1._t1, p1._t2);
                    pass2.push(segment);
                    t1 = t2;
                    break;
                }
            }
            if (t1 < 1) {
                segment = p1.split(t1, 1);
                segment._t1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(t1, 0, 1, p1._t1, p1._t2);
                segment._t2 = p1._t2;
                pass2.push(segment);
            }
        });
        return pass2;
    }
    translate(v, d1, d2) {
        d2 = typeof d2 === "number" ? d2 : d1;
        // TODO: make this take curves with control points outside
        //       of the start-end interval into account
        const o = this.order;
        let d = this.points.map((_, i)=>(1 - i / o) * d1 + i / o * d2);
        return new $fe797824c4066803$export$2c85281379f83a27(this.points.map((p, i)=>({
                x: p.x + v.x * d[i],
                y: p.y + v.y * d[i]
            })));
    }
    scale(d) {
        const order = this.order;
        let distanceFn = false;
        if (typeof d === "function") distanceFn = d;
        if (distanceFn && order === 2) return this.raise().scale(distanceFn);
        // TODO: add special handling for non-linear degenerate curves.
        const clockwise = this.clockwise;
        const points = this.points;
        if (this._linear) return this.translate(this.normal(0), distanceFn ? distanceFn(0) : d, distanceFn ? distanceFn(1) : d);
        const r1 = distanceFn ? distanceFn(0) : d;
        const r2 = distanceFn ? distanceFn(1) : d;
        const v = [
            this.offset(0, 10),
            this.offset(1, 10)
        ];
        const np = [];
        const o = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).lli4(v[0], v[0].c, v[1], v[1].c);
        if (!o) throw new Error("cannot scale this curve. Try reducing it first.");
        // move all points by distance 'd' wrt the origin 'o',
        // and move end points by fixed distance along normal.
        [
            0,
            1
        ].forEach(function(t1) {
            const p = np[t1 * order] = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).copy(points[t1 * order]);
            p.x += (t1 ? r2 : r1) * v[t1].n.x;
            p.y += (t1 ? r2 : r1) * v[t1].n.y;
        });
        if (!distanceFn) {
            // move control points to lie on the intersection of the offset
            // derivative vector, and the origin-through-control vector
            [
                0,
                1
            ].forEach((t1)=>{
                if (order === 2 && !!t1) return;
                const p = np[t1 * order];
                const d = this.derivative(t1);
                const p2 = {
                    x: p.x + d.x,
                    y: p.y + d.y
                };
                np[t1 + 1] = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).lli4(p, p2, o, points[t1 + 1]);
            });
            return new $fe797824c4066803$export$2c85281379f83a27(np);
        }
        // move control points by "however much necessary to
        // ensure the correct tangent to endpoint".
        [
            0,
            1
        ].forEach(function(t1) {
            if (order === 2 && !!t1) return;
            var p = points[t1 + 1];
            var ov = {
                x: p.x - o.x,
                y: p.y - o.y
            };
            var rc = distanceFn ? distanceFn((t1 + 1) / order) : d;
            if (distanceFn && !clockwise) rc = -rc;
            var m = $fe797824c4066803$var$sqrt(ov.x * ov.x + ov.y * ov.y);
            ov.x /= m;
            ov.y /= m;
            np[t1 + 1] = {
                x: p.x + rc * ov.x,
                y: p.y + rc * ov.y
            };
        });
        return new $fe797824c4066803$export$2c85281379f83a27(np);
    }
    outline(d1, d2, d3, d4) {
        d2 = d2 === undefined ? d1 : d2;
        if (this._linear) {
            // TODO: find the actual extrema, because they might
            //       be before the start, or past the end.
            const n = this.normal(0);
            const start = this.points[0];
            const end = this.points[this.points.length - 1];
            let s, mid, e;
            if (d3 === undefined) {
                d3 = d1;
                d4 = d2;
            }
            s = {
                x: start.x + n.x * d1,
                y: start.y + n.y * d1
            };
            e = {
                x: end.x + n.x * d3,
                y: end.y + n.y * d3
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const fline = [
                s,
                mid,
                e
            ];
            s = {
                x: start.x - n.x * d2,
                y: start.y - n.y * d2
            };
            e = {
                x: end.x - n.x * d4,
                y: end.y - n.y * d4
            };
            mid = {
                x: (s.x + e.x) / 2,
                y: (s.y + e.y) / 2
            };
            const bline = [
                e,
                mid,
                s
            ];
            const ls = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).makeline(bline[2], fline[0]);
            const le = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).makeline(fline[2], bline[0]);
            const segments = [
                ls,
                new $fe797824c4066803$export$2c85281379f83a27(fline),
                le,
                new $fe797824c4066803$export$2c85281379f83a27(bline)
            ];
            return new (0, $d70f47ac075733ed$export$86641174d8fa723d)(segments);
        }
        const reduced = this.reduce(), len = reduced.length, fcurves = [];
        let bcurves = [], p, alen = 0, tlen = this.length();
        const graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";
        function linearDistanceFunction(s, e, tlen, alen, slen) {
            return function(v) {
                const f1 = alen / tlen, f2 = (alen + slen) / tlen, d = e - s;
                return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).map(v, 0, 1, s + f1 * d, s + f2 * d);
            };
        }
        // form curve oulines
        reduced.forEach(function(segment) {
            const slen = segment.length();
            if (graduated) {
                fcurves.push(segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen)));
                bcurves.push(segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen)));
            } else {
                fcurves.push(segment.scale(d1));
                bcurves.push(segment.scale(-d2));
            }
            alen += slen;
        });
        // reverse the "return" outline
        bcurves = bcurves.map(function(s) {
            p = s.points;
            if (p[3]) s.points = [
                p[3],
                p[2],
                p[1],
                p[0]
            ];
            else s.points = [
                p[2],
                p[1],
                p[0]
            ];
            return s;
        }).reverse();
        // form the endcaps as lines
        const fs = fcurves[0].points[0], fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1], bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1], be = bcurves[0].points[0], ls = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).makeline(bs, fs), le = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).makeline(fe, be), segments = [
            ls
        ].concat(fcurves).concat([
            le
        ]).concat(bcurves);
        return new (0, $d70f47ac075733ed$export$86641174d8fa723d)(segments);
    }
    outlineshapes(d1, d2, curveIntersectionThreshold) {
        d2 = d2 || d1;
        const outline = this.outline(d1, d2).curves;
        const shapes = [];
        for(let i = 1, len = outline.length; i < len / 2; i++){
            const shape = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).makeshape(outline[i], outline[len - i], curveIntersectionThreshold);
            shape.startcap.virtual = i > 1;
            shape.endcap.virtual = i < len / 2 - 1;
            shapes.push(shape);
        }
        return shapes;
    }
    intersects(curve, curveIntersectionThreshold) {
        if (!curve) return this.selfintersects(curveIntersectionThreshold);
        if (curve.p1 && curve.p2) return this.lineIntersects(curve);
        if (curve instanceof $fe797824c4066803$export$2c85281379f83a27) curve = curve.reduce();
        return this.curveintersects(this.reduce(), curve, curveIntersectionThreshold);
    }
    lineIntersects(line) {
        const mx = $fe797824c4066803$var$min(line.p1.x, line.p2.x), my = $fe797824c4066803$var$min(line.p1.y, line.p2.y), MX = $fe797824c4066803$var$max(line.p1.x, line.p2.x), MY = $fe797824c4066803$var$max(line.p1.y, line.p2.y);
        return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).roots(this.points, line).filter((t1)=>{
            var p = this.get(t1);
            return (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).between(p.x, mx, MX) && (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).between(p.y, my, MY);
        });
    }
    selfintersects(curveIntersectionThreshold) {
        // "simple" curves cannot intersect with their direct
        // neighbour, so for each segment X we check whether
        // it intersects [0:x-2][x+2:last].
        const reduced = this.reduce(), len = reduced.length - 2, results = [];
        for(let i = 0, result, left, right; i < len; i++){
            left = reduced.slice(i, i + 1);
            right = reduced.slice(i + 2);
            result = this.curveintersects(left, right, curveIntersectionThreshold);
            results.push(...result);
        }
        return results;
    }
    curveintersects(c1, c2, curveIntersectionThreshold) {
        const pairs = [];
        // step 1: pair off any overlapping segments
        c1.forEach(function(l) {
            c2.forEach(function(r) {
                if (l.overlaps(r)) pairs.push({
                    left: l,
                    right: r
                });
            });
        });
        // step 2: for each pairing, run through the convergence algorithm.
        let intersections = [];
        pairs.forEach(function(pair) {
            const result = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).pairiteration(pair.left, pair.right, curveIntersectionThreshold);
            if (result.length > 0) intersections = intersections.concat(result);
        });
        return intersections;
    }
    arcs(errorThreshold) {
        errorThreshold = errorThreshold || 0.5;
        return this._iterate(errorThreshold, []);
    }
    _error(pc, np1, s, e) {
        const q = (e - s) / 4, c1 = this.get(s + q), c2 = this.get(e - q), ref = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(pc, np1), d1 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(pc, c1), d2 = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).dist(pc, c2);
        return $fe797824c4066803$var$abs(d1 - ref) + $fe797824c4066803$var$abs(d2 - ref);
    }
    _iterate(errorThreshold, circles) {
        let t_s = 0, t_e = 1, safety;
        // we do a binary search to find the "good `t` closest to no-longer-good"
        do {
            safety = 0;
            // step 1: start with the maximum possible arc
            t_e = 1;
            // points:
            let np1 = this.get(t_s), np2, np3, arc, prev_arc;
            // booleans:
            let curr_good = false, prev_good = false, done;
            // numbers:
            let t_m = t_e, prev_e = 1, step = 0;
            // step 2: find the best possible arc
            do {
                prev_good = curr_good;
                prev_arc = arc;
                t_m = (t_s + t_e) / 2;
                step++;
                np2 = this.get(t_m);
                np3 = this.get(t_e);
                arc = (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).getccenter(np1, np2, np3);
                //also save the t values
                arc.interval = {
                    start: t_s,
                    end: t_e
                };
                let error = this._error(arc, np1, t_s, t_e);
                curr_good = error <= errorThreshold;
                done = prev_good && !curr_good;
                if (!done) prev_e = t_e;
                // this arc is fine: we can move 'e' up to see if we can find a wider arc
                if (curr_good) {
                    // if e is already at max, then we're done for this arc.
                    if (t_e >= 1) {
                        // make sure we cap at t=1
                        arc.interval.end = prev_e = 1;
                        prev_arc = arc;
                        // if we capped the arc segment to t=1 we also need to make sure that
                        // the arc's end angle is correct with respect to the bezier end point.
                        if (t_e > 1) {
                            let d = {
                                x: arc.x + arc.r * $fe797824c4066803$var$cos(arc.e),
                                y: arc.y + arc.r * $fe797824c4066803$var$sin(arc.e)
                            };
                            arc.e += (0, $fd4a732aea3c7f76$export$eab97d15b1788b8d).angle({
                                x: arc.x,
                                y: arc.y
                            }, d, this.get(1));
                        }
                        break;
                    }
                    // if not, move it up by half the iteration distance
                    t_e = t_e + (t_e - t_s) / 2;
                } else // this is a bad arc: we need to move 'e' down to find a good arc
                t_e = t_m;
            }while (!done && safety++ < 100);
            if (safety >= 100) break;
            // console.log("L835: [F] arc found", t_s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);
            prev_arc = prev_arc ? prev_arc : arc;
            circles.push(prev_arc);
            t_s = prev_e;
        }while (t_e < 1);
        return circles;
    }
}


function $831c89c8e21b629b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $831c89c8e21b629b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $831c89c8e21b629b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $831c89c8e21b629b$var$_arrayLikeToArray(r);
}
function $831c89c8e21b629b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $831c89c8e21b629b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $831c89c8e21b629b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $831c89c8e21b629b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $831c89c8e21b629b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $831c89c8e21b629b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $831c89c8e21b629b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $831c89c8e21b629b$var$_slicedToArray(r, e) {
    return $831c89c8e21b629b$var$_arrayWithHoles(r) || $831c89c8e21b629b$var$_iterableToArrayLimit(r, e) || $831c89c8e21b629b$var$_unsupportedIterableToArray(r, e) || $831c89c8e21b629b$var$_nonIterableRest();
}
function $831c89c8e21b629b$var$_toConsumableArray(r) {
    return $831c89c8e21b629b$var$_arrayWithoutHoles(r) || $831c89c8e21b629b$var$_iterableToArray(r) || $831c89c8e21b629b$var$_unsupportedIterableToArray(r) || $831c89c8e21b629b$var$_nonIterableSpread();
}
function $831c89c8e21b629b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $831c89c8e21b629b$var$_toPropertyKey(t) {
    var i = $831c89c8e21b629b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $831c89c8e21b629b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $831c89c8e21b629b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $831c89c8e21b629b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $831c89c8e21b629b$export$2e2bcd8739ae039 = function() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyAccessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var multiItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var flattenKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var keys = (keyAccessors instanceof Array ? keyAccessors.length ? keyAccessors : [
        undefined
    ] : [
        keyAccessors
    ]).map(function(key) {
        return {
            keyAccessor: key,
            isProp: !(key instanceof Function)
        };
    });
    var indexedResult = list.reduce(function(res, item) {
        var iterObj = res;
        var itemVal = item;
        keys.forEach(function(_ref, idx) {
            var keyAccessor = _ref.keyAccessor, isProp = _ref.isProp;
            var key;
            if (isProp) {
                var _itemVal = itemVal, propVal = _itemVal[keyAccessor], rest = $831c89c8e21b629b$var$_objectWithoutProperties(_itemVal, [
                    keyAccessor
                ].map($831c89c8e21b629b$var$_toPropertyKey));
                key = propVal;
                itemVal = rest;
            } else key = keyAccessor(itemVal, idx);
            if (idx + 1 < keys.length) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = {};
                iterObj = iterObj[key];
            } else // Leaf key
            if (multiItem) {
                if (!iterObj.hasOwnProperty(key)) iterObj[key] = [];
                iterObj[key].push(itemVal);
            } else iterObj[key] = itemVal;
        });
        return res;
    }, {});
    if (multiItem instanceof Function) // Reduce leaf multiple values
    (function reduce(node) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        if (level === keys.length) Object.keys(node).forEach(function(k) {
            return node[k] = multiItem(node[k]);
        });
        else Object.values(node).forEach(function(child) {
            return reduce(child, level + 1);
        });
    })(indexedResult); // IIFE
    var result = indexedResult;
    if (flattenKeys) {
        // flatten into array
        result = [];
        (function flatten(node) {
            var accKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            if (accKeys.length === keys.length) result.push({
                keys: accKeys,
                vals: node
            });
            else Object.entries(node).forEach(function(_ref2) {
                var _ref3 = $831c89c8e21b629b$var$_slicedToArray(_ref2, 2), key = _ref3[0], val = _ref3[1];
                return flatten(val, [].concat($831c89c8e21b629b$var$_toConsumableArray(accKeys), [
                    key
                ]));
            });
        })(indexedResult); //IIFE
        if (keyAccessors instanceof Array && keyAccessors.length === 0 && result.length === 1) // clear keys if there's no key accessors (single result)
        result[0].keys = [];
    }
    return result;
};


class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $3160658555deb5c9$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $5b694e64f5326630$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}


var $892d66d4b4370fa9$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


function $9b49b422b3bd34bd$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $9b49b422b3bd34bd$var$css_248z = ".force-graph-container canvas {\n  display: block;\n  user-select: none;\n  outline: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.force-graph-container .clickable {\n  cursor: pointer;\n}\n\n.force-graph-container .grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.force-graph-container .grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}\n";
$9b49b422b3bd34bd$var$styleInject($9b49b422b3bd34bd$var$css_248z);
function $9b49b422b3bd34bd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9b49b422b3bd34bd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9b49b422b3bd34bd$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9b49b422b3bd34bd$var$_arrayLikeToArray(r);
}
function $9b49b422b3bd34bd$var$_construct(t, e, r) {
    if ($9b49b422b3bd34bd$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return p;
}
function $9b49b422b3bd34bd$var$_defineProperty(e, r, t) {
    return (r = $9b49b422b3bd34bd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $9b49b422b3bd34bd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9b49b422b3bd34bd$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $9b49b422b3bd34bd$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $9b49b422b3bd34bd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9b49b422b3bd34bd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b49b422b3bd34bd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b49b422b3bd34bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b49b422b3bd34bd$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b49b422b3bd34bd$var$ownKeys(Object(t), true).forEach(function(r) {
            $9b49b422b3bd34bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b49b422b3bd34bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9b49b422b3bd34bd$var$_slicedToArray(r, e) {
    return $9b49b422b3bd34bd$var$_arrayWithHoles(r) || $9b49b422b3bd34bd$var$_iterableToArrayLimit(r, e) || $9b49b422b3bd34bd$var$_unsupportedIterableToArray(r, e) || $9b49b422b3bd34bd$var$_nonIterableRest();
}
function $9b49b422b3bd34bd$var$_toConsumableArray(r) {
    return $9b49b422b3bd34bd$var$_arrayWithoutHoles(r) || $9b49b422b3bd34bd$var$_iterableToArray(r) || $9b49b422b3bd34bd$var$_unsupportedIterableToArray(r) || $9b49b422b3bd34bd$var$_nonIterableSpread();
}
function $9b49b422b3bd34bd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9b49b422b3bd34bd$var$_toPropertyKey(t) {
    var i = $9b49b422b3bd34bd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9b49b422b3bd34bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9b49b422b3bd34bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b49b422b3bd34bd$var$_typeof(o);
}
function $9b49b422b3bd34bd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9b49b422b3bd34bd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9b49b422b3bd34bd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $9b49b422b3bd34bd$var$autoColorScale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)((0, $892d66d4b4370fa9$export$2e2bcd8739ae039));
// Autoset attribute colorField by colorByAccessor property
// If an object has already a color, don't set it
// Objects can be nodes or links
function $9b49b422b3bd34bd$var$autoColorObjects(objects, colorByAccessor, colorField) {
    if (!colorByAccessor || typeof colorField !== 'string') return;
    objects.filter(function(obj) {
        return !obj[colorField];
    }).forEach(function(obj) {
        obj[colorField] = $9b49b422b3bd34bd$var$autoColorScale(colorByAccessor(obj));
    });
}
function $9b49b422b3bd34bd$var$getDagDepths(_ref, idAccessor) {
    var nodes = _ref.nodes, links = _ref.links;
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$nodeFilter = _ref2.nodeFilter, nodeFilter = _ref2$nodeFilter === void 0 ? function() {
        return true;
    } : _ref2$nodeFilter, _ref2$onLoopError = _ref2.onLoopError, onLoopError = _ref2$onLoopError === void 0 ? function(loopIds) {
        throw "Invalid DAG structure! Found cycle in node path: ".concat(loopIds.join(' -> '), ".");
    } : _ref2$onLoopError;
    // linked graph
    var graph = {};
    nodes.forEach(function(node) {
        return graph[idAccessor(node)] = {
            data: node,
            out: [],
            depth: -1,
            skip: !nodeFilter(node)
        };
    });
    links.forEach(function(_ref3) {
        var source = _ref3.source, target = _ref3.target;
        var sourceId = getNodeId(source);
        var targetId = getNodeId(target);
        if (!graph.hasOwnProperty(sourceId)) throw "Missing source node with id: ".concat(sourceId);
        if (!graph.hasOwnProperty(targetId)) throw "Missing target node with id: ".concat(targetId);
        var sourceNode = graph[sourceId];
        var targetNode = graph[targetId];
        sourceNode.out.push(targetNode);
        function getNodeId(node) {
            return $9b49b422b3bd34bd$var$_typeof(node) === 'object' ? idAccessor(node) : node;
        }
    });
    var foundLoops = [];
    traverse(Object.values(graph));
    var nodeDepths = Object.assign.apply(Object, [
        {}
    ].concat($9b49b422b3bd34bd$var$_toConsumableArray(Object.entries(graph).filter(function(_ref4) {
        var _ref5 = $9b49b422b3bd34bd$var$_slicedToArray(_ref4, 2), node = _ref5[1];
        return !node.skip;
    }).map(function(_ref6) {
        var _ref7 = $9b49b422b3bd34bd$var$_slicedToArray(_ref6, 2), id = _ref7[0], node = _ref7[1];
        return $9b49b422b3bd34bd$var$_defineProperty({}, id, node.depth);
    }))));
    return nodeDepths;
    function traverse(nodes) {
        var nodeStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var currentDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var _loop = function _loop() {
            var node = nodes[i];
            if (nodeStack.indexOf(node) !== -1) {
                var loop = [].concat($9b49b422b3bd34bd$var$_toConsumableArray(nodeStack.slice(nodeStack.indexOf(node))), [
                    node
                ]).map(function(d) {
                    return idAccessor(d.data);
                });
                if (!foundLoops.some(function(foundLoop) {
                    return foundLoop.length === loop.length && foundLoop.every(function(id, idx) {
                        return id === loop[idx];
                    });
                })) {
                    foundLoops.push(loop);
                    onLoopError(loop);
                }
                return 1; // continue
            }
            if (currentDepth > node.depth) {
                // Don't unnecessarily revisit chunks of the graph
                node.depth = currentDepth;
                traverse(node.out, [].concat($9b49b422b3bd34bd$var$_toConsumableArray(nodeStack), [
                    node
                ]), currentDepth + (node.skip ? 0 : 1));
            }
        };
        for(var i = 0, l = nodes.length; i < l; i++){
            if (_loop()) continue;
        }
    }
}
//
var $9b49b422b3bd34bd$var$DAG_LEVEL_NODE_RATIO = 2;
// whenever styling props are changed that require a canvas redraw
var $9b49b422b3bd34bd$var$notifyRedraw = function notifyRedraw(_, state) {
    return state.onNeedsRedraw && state.onNeedsRedraw();
};
var $9b49b422b3bd34bd$var$updDataPhotons = function updDataPhotons(_, state) {
    if (!state.isShadow) {
        // Add photon particles
        var linkParticlesAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticles);
        state.graphData.links.forEach(function(link) {
            var numPhotons = Math.round(Math.abs(linkParticlesAccessor(link)));
            if (numPhotons) link.__photons = $9b49b422b3bd34bd$var$_toConsumableArray(Array(numPhotons)).map(function() {
                return {};
            });
            else delete link.__photons;
        });
    }
};
var $9b49b422b3bd34bd$var$CanvasForceGraph = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        graphData: {
            "default": {
                nodes: [],
                links: []
            },
            onChange: function onChange(_, state) {
                state.engineRunning = false; // Pause simulation
                $9b49b422b3bd34bd$var$updDataPhotons(_, state);
            }
        },
        dagMode: {
            onChange: function onChange(dagMode, state) {
                // td, bu, lr, rl, radialin, radialout
                !dagMode && (state.graphData.nodes || []).forEach(function(n) {
                    return n.fx = n.fy = undefined;
                }); // unfix nodes when disabling dag mode
            }
        },
        dagLevelDistance: {},
        dagNodeFilter: {
            "default": function _default(node) {
                return true;
            }
        },
        onDagError: {
            triggerUpdate: false
        },
        nodeRelSize: {
            "default": 4,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        // area per val unit
        nodeId: {
            "default": 'id'
        },
        nodeVal: {
            "default": 'val',
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        nodeColor: {
            "default": 'color',
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        nodeAutoColorBy: {},
        nodeCanvasObject: {
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        nodeCanvasObjectMode: {
            "default": function _default() {
                return 'replace';
            },
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        nodeVisibility: {
            "default": true,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkSource: {
            "default": 'source'
        },
        linkTarget: {
            "default": 'target'
        },
        linkVisibility: {
            "default": true,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkColor: {
            "default": 'color',
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkAutoColorBy: {},
        linkLineDash: {
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkWidth: {
            "default": 1,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkCurvature: {
            "default": 0,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkCanvasObject: {
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkCanvasObjectMode: {
            "default": function _default() {
                return 'replace';
            },
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkDirectionalArrowLength: {
            "default": 0,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkDirectionalArrowColor: {
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        linkDirectionalArrowRelPos: {
            "default": 0.5,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$notifyRedraw
        },
        // value between 0<>1 indicating the relative pos along the (exposed) line
        linkDirectionalParticles: {
            "default": 0,
            triggerUpdate: false,
            onChange: $9b49b422b3bd34bd$var$updDataPhotons
        },
        // animate photons travelling in the link direction
        linkDirectionalParticleSpeed: {
            "default": 0.01,
            triggerUpdate: false
        },
        // in link length ratio per frame
        linkDirectionalParticleOffset: {
            "default": 0,
            triggerUpdate: false
        },
        // starting position offset along the link's length, like a pre-delay. Values between [0, 1]
        linkDirectionalParticleWidth: {
            "default": 4,
            triggerUpdate: false
        },
        linkDirectionalParticleColor: {
            triggerUpdate: false
        },
        linkDirectionalParticleCanvasObject: {
            triggerUpdate: false
        },
        globalScale: {
            "default": 1,
            triggerUpdate: false
        },
        d3AlphaMin: {
            "default": 0,
            triggerUpdate: false
        },
        d3AlphaDecay: {
            "default": 0.0228,
            triggerUpdate: false,
            onChange: function onChange(alphaDecay, state) {
                state.forceLayout.alphaDecay(alphaDecay);
            }
        },
        d3AlphaTarget: {
            "default": 0,
            triggerUpdate: false,
            onChange: function onChange(alphaTarget, state) {
                state.forceLayout.alphaTarget(alphaTarget);
            }
        },
        d3VelocityDecay: {
            "default": 0.4,
            triggerUpdate: false,
            onChange: function onChange(velocityDecay, state) {
                state.forceLayout.velocityDecay(velocityDecay);
            }
        },
        warmupTicks: {
            "default": 0,
            triggerUpdate: false
        },
        // how many times to tick the force engine at init before starting to render
        cooldownTicks: {
            "default": Infinity,
            triggerUpdate: false
        },
        cooldownTime: {
            "default": 15000,
            triggerUpdate: false
        },
        // ms
        onUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onFinishUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineTick: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineStop: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNeedsRedraw: {
            triggerUpdate: false
        },
        isShadow: {
            "default": false,
            triggerUpdate: false
        }
    },
    methods: {
        // Expose d3 forces for external manipulation
        d3Force: function d3Force(state, forceName, forceFn) {
            if (forceFn === undefined) return state.forceLayout.force(forceName); // Force getter
            state.forceLayout.force(forceName, forceFn); // Force setter
            return this;
        },
        d3ReheatSimulation: function d3ReheatSimulation(state) {
            state.forceLayout.alpha(1);
            this.resetCountdown();
            return this;
        },
        // reset cooldown state
        resetCountdown: function resetCountdown(state) {
            state.cntTicks = 0;
            state.startTickTime = new Date();
            state.engineRunning = true;
            return this;
        },
        isEngineRunning: function isEngineRunning(state) {
            return !!state.engineRunning;
        },
        tickFrame: function tickFrame(state) {
            !state.isShadow && layoutTick();
            paintLinks();
            !state.isShadow && paintArrows();
            !state.isShadow && paintPhotons();
            paintNodes();
            return this;
            //
            function layoutTick() {
                if (state.engineRunning) {
                    if (++state.cntTicks > state.cooldownTicks || new Date() - state.startTickTime > state.cooldownTime || state.d3AlphaMin > 0 && state.forceLayout.alpha() < state.d3AlphaMin) {
                        state.engineRunning = false; // Stop ticking graph
                        state.onEngineStop();
                    } else {
                        state.forceLayout.tick(); // Tick it
                        state.onEngineTick();
                    }
                }
            }
            function paintNodes() {
                var getVisibility = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVisibility);
                var getVal = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
                var getColor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeColor);
                var getNodeCanvasObjectMode = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeCanvasObjectMode);
                var ctx = state.ctx;
                // Draw wider nodes by 1px on shadow canvas for more precise hovering (due to boundary anti-aliasing)
                var padAmount = state.isShadow / state.globalScale;
                var visibleNodes = state.graphData.nodes.filter(getVisibility);
                ctx.save();
                visibleNodes.forEach(function(node) {
                    var nodeCanvasObjectMode = getNodeCanvasObjectMode(node);
                    if (state.nodeCanvasObject && (nodeCanvasObjectMode === 'before' || nodeCanvasObjectMode === 'replace')) {
                        // Custom node before/replace paint
                        state.nodeCanvasObject(node, ctx, state.globalScale);
                        if (nodeCanvasObjectMode === 'replace') {
                            ctx.restore();
                            return;
                        }
                    }
                    // Draw wider nodes by 1px on shadow canvas for more precise hovering (due to boundary anti-aliasing)
                    var r = Math.sqrt(Math.max(0, getVal(node) || 1)) * state.nodeRelSize + padAmount;
                    ctx.beginPath();
                    ctx.arc(node.x, node.y, r, 0, 2 * Math.PI, false);
                    ctx.fillStyle = getColor(node) || 'rgba(31, 120, 180, 0.92)';
                    ctx.fill();
                    if (state.nodeCanvasObject && nodeCanvasObjectMode === 'after') // Custom node after paint
                    state.nodeCanvasObject(node, state.ctx, state.globalScale);
                });
                ctx.restore();
            }
            function paintLinks() {
                var getVisibility = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkVisibility);
                var getColor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkColor);
                var getWidth = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth);
                var getLineDash = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkLineDash);
                var getCurvature = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCurvature);
                var getLinkCanvasObjectMode = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCanvasObjectMode);
                var ctx = state.ctx;
                // Draw wider lines by 2px on shadow canvas for more precise hovering (due to boundary anti-aliasing)
                var padAmount = state.isShadow * 2;
                var visibleLinks = state.graphData.links.filter(getVisibility);
                visibleLinks.forEach(calcLinkControlPoints); // calculate curvature control points for all visible links
                var beforeCustomLinks = [], afterCustomLinks = [], defaultPaintLinks = visibleLinks;
                if (state.linkCanvasObject) {
                    var replaceCustomLinks = [], otherCustomLinks = [];
                    visibleLinks.forEach(function(d) {
                        return (({
                            before: beforeCustomLinks,
                            after: afterCustomLinks,
                            replace: replaceCustomLinks
                        })[getLinkCanvasObjectMode(d)] || otherCustomLinks).push(d);
                    });
                    defaultPaintLinks = [].concat($9b49b422b3bd34bd$var$_toConsumableArray(beforeCustomLinks), afterCustomLinks, otherCustomLinks);
                    beforeCustomLinks = beforeCustomLinks.concat(replaceCustomLinks);
                }
                // Custom link before paints
                ctx.save();
                beforeCustomLinks.forEach(function(link) {
                    return state.linkCanvasObject(link, ctx, state.globalScale);
                });
                ctx.restore();
                // Bundle strokes per unique color/width/dash for performance optimization
                var linksPerColor = (0, $831c89c8e21b629b$export$2e2bcd8739ae039)(defaultPaintLinks, [
                    getColor,
                    getWidth,
                    getLineDash
                ]);
                ctx.save();
                Object.entries(linksPerColor).forEach(function(_ref) {
                    var _ref2 = $9b49b422b3bd34bd$var$_slicedToArray(_ref, 2), color = _ref2[0], linksPerWidth = _ref2[1];
                    var lineColor = !color || color === 'undefined' ? 'rgba(0,0,0,0.15)' : color;
                    Object.entries(linksPerWidth).forEach(function(_ref3) {
                        var _ref4 = $9b49b422b3bd34bd$var$_slicedToArray(_ref3, 2), width = _ref4[0], linesPerLineDash = _ref4[1];
                        var lineWidth = (width || 1) / state.globalScale + padAmount;
                        Object.entries(linesPerLineDash).forEach(function(_ref5) {
                            var _ref6 = $9b49b422b3bd34bd$var$_slicedToArray(_ref5, 2);
                            _ref6[0];
                            var links = _ref6[1];
                            var lineDashSegments = getLineDash(links[0]);
                            ctx.beginPath();
                            links.forEach(function(link) {
                                var start = link.source;
                                var end = link.target;
                                if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                                ctx.moveTo(start.x, start.y);
                                var controlPoints = link.__controlPoints;
                                if (!controlPoints) // Straight line
                                ctx.lineTo(end.x, end.y);
                                else // Use quadratic curves for regular lines and bezier for loops
                                ctx[controlPoints.length === 2 ? 'quadraticCurveTo' : 'bezierCurveTo'].apply(ctx, $9b49b422b3bd34bd$var$_toConsumableArray(controlPoints).concat([
                                    end.x,
                                    end.y
                                ]));
                            });
                            ctx.strokeStyle = lineColor;
                            ctx.lineWidth = lineWidth;
                            ctx.setLineDash(lineDashSegments || []);
                            ctx.stroke();
                        });
                    });
                });
                ctx.restore();
                // Custom link after paints
                ctx.save();
                afterCustomLinks.forEach(function(link) {
                    return state.linkCanvasObject(link, ctx, state.globalScale);
                });
                ctx.restore();
                //
                function calcLinkControlPoints(link) {
                    var curvature = getCurvature(link);
                    if (!curvature) {
                        // straight line
                        link.__controlPoints = null;
                        return;
                    }
                    var start = link.source;
                    var end = link.target;
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var l = Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2)); // line length
                    if (l > 0) {
                        var a = Math.atan2(end.y - start.y, end.x - start.x); // line angle
                        var d = l * curvature; // control point distance
                        var cp = {
                            // control point
                            x: (start.x + end.x) / 2 + d * Math.cos(a - Math.PI / 2),
                            y: (start.y + end.y) / 2 + d * Math.sin(a - Math.PI / 2)
                        };
                        link.__controlPoints = [
                            cp.x,
                            cp.y
                        ];
                    } else {
                        // Same point, draw a loop
                        var _d = curvature * 70;
                        link.__controlPoints = [
                            end.x,
                            end.y - _d,
                            end.x + _d,
                            end.y
                        ];
                    }
                }
            }
            function paintArrows() {
                var ARROW_WH_RATIO = 1.6;
                var ARROW_VLEN_RATIO = 0.2;
                var getLength = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowLength);
                var getRelPos = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowRelPos);
                var getVisibility = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkVisibility);
                var getColor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowColor || state.linkColor);
                var getNodeVal = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
                var ctx = state.ctx;
                ctx.save();
                state.graphData.links.filter(getVisibility).forEach(function(link) {
                    var arrowLength = getLength(link);
                    if (!arrowLength || arrowLength < 0) return;
                    var start = link.source;
                    var end = link.target;
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var startR = Math.sqrt(Math.max(0, getNodeVal(start) || 1)) * state.nodeRelSize;
                    var endR = Math.sqrt(Math.max(0, getNodeVal(end) || 1)) * state.nodeRelSize;
                    var arrowRelPos = Math.min(1, Math.max(0, getRelPos(link)));
                    var arrowColor = getColor(link) || 'rgba(0,0,0,0.28)';
                    var arrowHalfWidth = arrowLength / ARROW_WH_RATIO / 2;
                    // Construct bezier for curved lines
                    var bzLine = link.__controlPoints && $9b49b422b3bd34bd$var$_construct((0, $fe797824c4066803$export$2c85281379f83a27), [
                        start.x,
                        start.y
                    ].concat($9b49b422b3bd34bd$var$_toConsumableArray(link.__controlPoints), [
                        end.x,
                        end.y
                    ]));
                    var getCoordsAlongLine = bzLine ? function(t) {
                        return bzLine.get(t);
                    } // get position along bezier line
                     : function(t) {
                        return {
                            // straight line: interpolate linearly
                            x: start.x + (end.x - start.x) * t || 0,
                            y: start.y + (end.y - start.y) * t || 0
                        };
                    };
                    var lineLen = bzLine ? bzLine.length() : Math.sqrt(Math.pow(end.x - start.x, 2) + Math.pow(end.y - start.y, 2));
                    var posAlongLine = startR + arrowLength + (lineLen - startR - endR - arrowLength) * arrowRelPos;
                    var arrowHead = getCoordsAlongLine(posAlongLine / lineLen);
                    var arrowTail = getCoordsAlongLine((posAlongLine - arrowLength) / lineLen);
                    var arrowTailVertex = getCoordsAlongLine((posAlongLine - arrowLength * (1 - ARROW_VLEN_RATIO)) / lineLen);
                    var arrowTailAngle = Math.atan2(arrowHead.y - arrowTail.y, arrowHead.x - arrowTail.x) - Math.PI / 2;
                    ctx.beginPath();
                    ctx.moveTo(arrowHead.x, arrowHead.y);
                    ctx.lineTo(arrowTail.x + arrowHalfWidth * Math.cos(arrowTailAngle), arrowTail.y + arrowHalfWidth * Math.sin(arrowTailAngle));
                    ctx.lineTo(arrowTailVertex.x, arrowTailVertex.y);
                    ctx.lineTo(arrowTail.x - arrowHalfWidth * Math.cos(arrowTailAngle), arrowTail.y - arrowHalfWidth * Math.sin(arrowTailAngle));
                    ctx.fillStyle = arrowColor;
                    ctx.fill();
                });
                ctx.restore();
            }
            function paintPhotons() {
                var getNumPhotons = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticles);
                var getSpeed = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleSpeed);
                var getOffset = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleOffset);
                var getDiameter = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleWidth);
                var getVisibility = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkVisibility);
                var getColor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleColor || state.linkColor);
                var ctx = state.ctx;
                ctx.save();
                state.graphData.links.filter(getVisibility).forEach(function(link) {
                    var numCyclePhotons = getNumPhotons(link);
                    if (!link.hasOwnProperty('__photons') || !link.__photons.length) return;
                    var start = link.source;
                    var end = link.target;
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var particleSpeed = getSpeed(link);
                    var particleOffset = Math.abs(getOffset(link));
                    var photons = link.__photons || [];
                    var photonR = Math.max(0, getDiameter(link) / 2) / Math.sqrt(state.globalScale);
                    var photonColor = getColor(link) || 'rgba(0,0,0,0.28)';
                    ctx.fillStyle = photonColor;
                    // Construct bezier for curved lines
                    var bzLine = link.__controlPoints ? $9b49b422b3bd34bd$var$_construct((0, $fe797824c4066803$export$2c85281379f83a27), [
                        start.x,
                        start.y
                    ].concat($9b49b422b3bd34bd$var$_toConsumableArray(link.__controlPoints), [
                        end.x,
                        end.y
                    ])) : null;
                    var cyclePhotonIdx = 0;
                    var needsCleanup = false; // whether some photons need to be removed from list
                    photons.forEach(function(photon) {
                        var singleHop = !!photon.__singleHop;
                        if (!photon.hasOwnProperty('__progressRatio')) photon.__progressRatio = singleHop ? 0 : (cyclePhotonIdx + particleOffset) / numCyclePhotons;
                        !singleHop && cyclePhotonIdx++; // increase regular photon index
                        photon.__progressRatio += particleSpeed;
                        if (photon.__progressRatio >= 1) {
                            if (!singleHop) photon.__progressRatio = photon.__progressRatio % 1;
                            else {
                                needsCleanup = true;
                                return;
                            }
                        }
                        var photonPosRatio = photon.__progressRatio;
                        var coords = bzLine ? bzLine.get(photonPosRatio) // get position along bezier line
                         : {
                            // straight line: interpolate linearly
                            x: start.x + (end.x - start.x) * photonPosRatio || 0,
                            y: start.y + (end.y - start.y) * photonPosRatio || 0
                        };
                        if (state.linkDirectionalParticleCanvasObject) state.linkDirectionalParticleCanvasObject(coords.x, coords.y, link, ctx, state.globalScale);
                        else {
                            ctx.beginPath();
                            ctx.arc(coords.x, coords.y, photonR, 0, 2 * Math.PI, false);
                            ctx.fill();
                        }
                    });
                    if (needsCleanup) // remove expired single hop photons
                    link.__photons = link.__photons.filter(function(photon) {
                        return !photon.__singleHop || photon.__progressRatio <= 1;
                    });
                });
                ctx.restore();
            }
        },
        emitParticle: function emitParticle(state, link) {
            if (link) {
                !link.__photons && (link.__photons = []);
                link.__photons.push({
                    __singleHop: true
                }); // add a single hop particle
            }
            return this;
        }
    },
    stateInit: function stateInit() {
        return {
            forceLayout: (0, $a61c6b05e92f056e$export$2e2bcd8739ae039)().force('link', (0, $b1bbf836822558b1$export$2e2bcd8739ae039)()).force('charge', (0, $78193c16de4a9cf2$export$2e2bcd8739ae039)()).force('center', (0, $38b55043e008942d$export$2e2bcd8739ae039)()).force('dagRadial', null).stop(),
            engineRunning: false
        };
    },
    init: function init(canvasCtx, state) {
        // Main canvas object to manipulate
        state.ctx = canvasCtx;
    },
    update: function update(state, changedProps) {
        state.engineRunning = false; // Pause simulation
        state.onUpdate();
        if (state.nodeAutoColorBy !== null) // Auto add color to uncolored nodes
        $9b49b422b3bd34bd$var$autoColorObjects(state.graphData.nodes, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeAutoColorBy), state.nodeColor);
        if (state.linkAutoColorBy !== null) // Auto add color to uncolored links
        $9b49b422b3bd34bd$var$autoColorObjects(state.graphData.links, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkAutoColorBy), state.linkColor);
        // parse links
        state.graphData.links.forEach(function(link) {
            link.source = link[state.linkSource];
            link.target = link[state.linkTarget];
        });
        // Feed data to force-directed layout
        state.forceLayout.stop().alpha(1) // re-heat the simulation
        .nodes(state.graphData.nodes);
        // add links (if link force is still active)
        var linkForce = state.forceLayout.force('link');
        if (linkForce) linkForce.id(function(d) {
            return d[state.nodeId];
        }).links(state.graphData.links);
        // setup dag force constraints
        var nodeDepths = state.dagMode && $9b49b422b3bd34bd$var$getDagDepths(state.graphData, function(node) {
            return node[state.nodeId];
        }, {
            nodeFilter: state.dagNodeFilter,
            onLoopError: state.onDagError || undefined
        });
        var maxDepth = Math.max.apply(Math, $9b49b422b3bd34bd$var$_toConsumableArray(Object.values(nodeDepths || [])));
        var dagLevelDistance = state.dagLevelDistance || state.graphData.nodes.length / (maxDepth || 1) * $9b49b422b3bd34bd$var$DAG_LEVEL_NODE_RATIO * ([
            'radialin',
            'radialout'
        ].indexOf(state.dagMode) !== -1 ? 0.7 : 1);
        // Reset relevant fx/fy when swapping dag modes
        if ([
            'lr',
            'rl',
            'td',
            'bu'
        ].includes(changedProps.dagMode)) {
            var resetProp = [
                'lr',
                'rl'
            ].includes(changedProps.dagMode) ? 'fx' : 'fy';
            state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                return delete node[resetProp];
            });
        }
        // Fix nodes to x,y for dag mode
        if ([
            'lr',
            'rl',
            'td',
            'bu'
        ].includes(state.dagMode)) {
            var invert = [
                'rl',
                'bu'
            ].includes(state.dagMode);
            var fixFn = function fixFn(node) {
                return (nodeDepths[node[state.nodeId]] - maxDepth / 2) * dagLevelDistance * (invert ? -1 : 1);
            };
            var _resetProp = [
                'lr',
                'rl'
            ].includes(state.dagMode) ? 'fx' : 'fy';
            state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                return node[_resetProp] = fixFn(node);
            });
        }
        // Use radial force for radial dags
        state.forceLayout.force('dagRadial', [
            'radialin',
            'radialout'
        ].indexOf(state.dagMode) !== -1 ? (0, $91cad9d8ddc689ca$export$2e2bcd8739ae039)(function(node) {
            var nodeDepth = nodeDepths[node[state.nodeId]] || -1;
            return (state.dagMode === 'radialin' ? maxDepth - nodeDepth : nodeDepth) * dagLevelDistance;
        }).strength(function(node) {
            return state.dagNodeFilter(node) ? 1 : 0;
        }) : null);
        for(var i = 0; i < state.warmupTicks && !(state.d3AlphaMin > 0 && state.forceLayout.alpha() < state.d3AlphaMin); i++)state.forceLayout.tick();
         // Initial ticks before starting to render
        this.resetCountdown();
        state.onFinishUpdate();
    }
});
function $9b49b422b3bd34bd$var$linkKapsule(kapsulePropNames, kapsuleType) {
    var propNames = kapsulePropNames instanceof Array ? kapsulePropNames : [
        kapsulePropNames
    ];
    var dummyK = new kapsuleType(); // To extract defaults
    dummyK._destructor && dummyK._destructor();
    return {
        linkProp: function linkProp(prop) {
            // link property config
            return {
                "default": dummyK[prop](),
                onChange: function onChange(v, state) {
                    propNames.forEach(function(propName) {
                        return state[propName][prop](v);
                    });
                },
                triggerUpdate: false
            };
        },
        linkMethod: function linkMethod(method) {
            // link method pass-through
            return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var returnVals = [];
                propNames.forEach(function(propName) {
                    var kapsuleInstance = state[propName];
                    var returnVal = kapsuleInstance[method].apply(kapsuleInstance, args);
                    if (returnVal !== kapsuleInstance) returnVals.push(returnVal);
                });
                return returnVals.length ? returnVals[0] : this; // chain based on the parent object, not the inner kapsule
            };
        }
    };
}
var $9b49b422b3bd34bd$var$HOVER_CANVAS_THROTTLE_DELAY = 800; // ms to throttle shadow canvas updates for perf improvement
var $9b49b422b3bd34bd$var$ZOOM2NODES_FACTOR = 4;
var $9b49b422b3bd34bd$var$DRAG_CLICK_TOLERANCE_PX = 5; // How many px can a node be accidentally dragged before disabling the click
// Expose config from forceGraph
var $9b49b422b3bd34bd$var$bindFG = $9b49b422b3bd34bd$var$linkKapsule('forceGraph', $9b49b422b3bd34bd$var$CanvasForceGraph);
var $9b49b422b3bd34bd$var$bindBoth = $9b49b422b3bd34bd$var$linkKapsule([
    'forceGraph',
    'shadowGraph'
], $9b49b422b3bd34bd$var$CanvasForceGraph);
var $9b49b422b3bd34bd$var$linkedProps = Object.assign.apply(Object, $9b49b422b3bd34bd$var$_toConsumableArray([
    'nodeColor',
    'nodeAutoColorBy',
    'nodeCanvasObject',
    'nodeCanvasObjectMode',
    'linkColor',
    'linkAutoColorBy',
    'linkLineDash',
    'linkWidth',
    'linkCanvasObject',
    'linkCanvasObjectMode',
    'linkDirectionalArrowLength',
    'linkDirectionalArrowColor',
    'linkDirectionalArrowRelPos',
    'linkDirectionalParticles',
    'linkDirectionalParticleSpeed',
    'linkDirectionalParticleOffset',
    'linkDirectionalParticleWidth',
    'linkDirectionalParticleColor',
    'linkDirectionalParticleCanvasObject',
    'dagMode',
    'dagLevelDistance',
    'dagNodeFilter',
    'onDagError',
    'd3AlphaMin',
    'd3AlphaDecay',
    'd3VelocityDecay',
    'warmupTicks',
    'cooldownTicks',
    'cooldownTime',
    'onEngineTick',
    'onEngineStop'
].map(function(p) {
    return $9b49b422b3bd34bd$var$_defineProperty({}, p, $9b49b422b3bd34bd$var$bindFG.linkProp(p));
})).concat($9b49b422b3bd34bd$var$_toConsumableArray([
    'nodeRelSize',
    'nodeId',
    'nodeVal',
    'nodeVisibility',
    'linkSource',
    'linkTarget',
    'linkVisibility',
    'linkCurvature'
].map(function(p) {
    return $9b49b422b3bd34bd$var$_defineProperty({}, p, $9b49b422b3bd34bd$var$bindBoth.linkProp(p));
}))));
var $9b49b422b3bd34bd$var$linkedMethods = Object.assign.apply(Object, $9b49b422b3bd34bd$var$_toConsumableArray([
    'd3Force',
    'd3ReheatSimulation',
    'emitParticle'
].map(function(p) {
    return $9b49b422b3bd34bd$var$_defineProperty({}, p, $9b49b422b3bd34bd$var$bindFG.linkMethod(p));
})));
function $9b49b422b3bd34bd$var$adjustCanvasSize(state) {
    if (state.canvas) {
        var curWidth = state.canvas.width;
        var curHeight = state.canvas.height;
        if (curWidth === 300 && curHeight === 150) // Default canvas dimensions
        curWidth = curHeight = 0;
        var pxScale = window.devicePixelRatio; // 2 on retina displays
        curWidth /= pxScale;
        curHeight /= pxScale;
        // Resize canvases
        [
            state.canvas,
            state.shadowCanvas
        ].forEach(function(canvas) {
            // Element size
            canvas.style.width = "".concat(state.width, "px");
            canvas.style.height = "".concat(state.height, "px");
            // Memory size (scaled to avoid blurriness)
            canvas.width = state.width * pxScale;
            canvas.height = state.height * pxScale;
            // Normalize coordinate system to use css pixels (on init only)
            if (!curWidth && !curHeight) canvas.getContext('2d').scale(pxScale, pxScale);
        });
        // Relative center panning based on 0,0
        var k = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas).k;
        state.zoom.translateBy(state.zoom.__baseElem, (state.width - curWidth) / 2 / k, (state.height - curHeight) / 2 / k);
        state.needsRedraw = true;
    }
}
function $9b49b422b3bd34bd$var$resetTransform(ctx) {
    var pxRatio = window.devicePixelRatio;
    ctx.setTransform(pxRatio, 0, 0, pxRatio, 0, 0);
}
function $9b49b422b3bd34bd$var$clearCanvas(ctx, width, height) {
    ctx.save();
    $9b49b422b3bd34bd$var$resetTransform(ctx); // reset transform
    ctx.clearRect(0, 0, width, height);
    ctx.restore(); //restore transforms
}
//
var $9b49b422b3bd34bd$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: $9b49b422b3bd34bd$var$_objectSpread2({
        width: {
            "default": window.innerWidth,
            onChange: function onChange(_, state) {
                return $9b49b422b3bd34bd$var$adjustCanvasSize(state);
            },
            triggerUpdate: false
        },
        height: {
            "default": window.innerHeight,
            onChange: function onChange(_, state) {
                return $9b49b422b3bd34bd$var$adjustCanvasSize(state);
            },
            triggerUpdate: false
        },
        graphData: {
            "default": {
                nodes: [],
                links: []
            },
            onChange: function onChange(d, state) {
                // Wipe color registry if all objects are new
                [
                    d.nodes,
                    d.links
                ].every(function(arr) {
                    return (arr || []).every(function(d) {
                        return !d.hasOwnProperty('__indexColor');
                    });
                }) && state.colorTracker.reset();
                [
                    {
                        type: 'Node',
                        objs: d.nodes
                    },
                    {
                        type: 'Link',
                        objs: d.links
                    }
                ].forEach(hexIndex);
                state.forceGraph.graphData(d);
                state.shadowGraph.graphData(d);
                function hexIndex(_ref4) {
                    var type = _ref4.type, objs = _ref4.objs;
                    objs.filter(function(d) {
                        if (!d.hasOwnProperty('__indexColor')) return true;
                        var cur = state.colorTracker.lookup(d.__indexColor);
                        return !cur || !cur.hasOwnProperty('d') || cur.d !== d;
                    }).forEach(function(d) {
                        // store object lookup color
                        d.__indexColor = state.colorTracker.register({
                            type: type,
                            d: d
                        });
                    });
                }
            },
            triggerUpdate: false
        },
        backgroundColor: {
            onChange: function onChange(color, state) {
                state.canvas && color && (state.canvas.style.background = color);
            },
            triggerUpdate: false
        },
        nodeLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        nodePointerAreaPaint: {
            onChange: function onChange(paintFn, state) {
                state.shadowGraph.nodeCanvasObject(!paintFn ? null : function(node, ctx, globalScale) {
                    return paintFn(node, node.__indexColor, ctx, globalScale);
                });
                state.flushShadowCanvas && state.flushShadowCanvas();
            },
            triggerUpdate: false
        },
        linkPointerAreaPaint: {
            onChange: function onChange(paintFn, state) {
                state.shadowGraph.linkCanvasObject(!paintFn ? null : function(link, ctx, globalScale) {
                    return paintFn(link, link.__indexColor, ctx, globalScale);
                });
                state.flushShadowCanvas && state.flushShadowCanvas();
            },
            triggerUpdate: false
        },
        linkLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        linkHoverPrecision: {
            "default": 4,
            triggerUpdate: false
        },
        minZoom: {
            "default": 0.01,
            onChange: function onChange(minZoom, state) {
                state.zoom.scaleExtent([
                    minZoom,
                    state.zoom.scaleExtent()[1]
                ]);
            },
            triggerUpdate: false
        },
        maxZoom: {
            "default": 1000,
            onChange: function onChange(maxZoom, state) {
                state.zoom.scaleExtent([
                    state.zoom.scaleExtent()[0],
                    maxZoom
                ]);
            },
            triggerUpdate: false
        },
        enableNodeDrag: {
            "default": true,
            triggerUpdate: false
        },
        enableZoomInteraction: {
            "default": true,
            triggerUpdate: false
        },
        enablePanInteraction: {
            "default": true,
            triggerUpdate: false
        },
        enableZoomPanInteraction: {
            "default": true,
            triggerUpdate: false
        },
        // to be deprecated
        enablePointerInteraction: {
            "default": true,
            onChange: function onChange(_, state) {
                state.hoverObj = null;
            },
            triggerUpdate: false
        },
        autoPauseRedraw: {
            "default": true,
            triggerUpdate: false
        },
        onNodeDrag: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeDragEnd: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeClick: {
            triggerUpdate: false
        },
        onNodeRightClick: {
            triggerUpdate: false
        },
        onNodeHover: {
            triggerUpdate: false
        },
        onLinkClick: {
            triggerUpdate: false
        },
        onLinkRightClick: {
            triggerUpdate: false
        },
        onLinkHover: {
            triggerUpdate: false
        },
        onBackgroundClick: {
            triggerUpdate: false
        },
        onBackgroundRightClick: {
            triggerUpdate: false
        },
        showPointerCursor: {
            "default": true,
            triggerUpdate: false
        },
        onZoom: {
            triggerUpdate: false
        },
        onZoomEnd: {
            triggerUpdate: false
        },
        onRenderFramePre: {
            triggerUpdate: false
        },
        onRenderFramePost: {
            triggerUpdate: false
        }
    }, $9b49b422b3bd34bd$var$linkedProps),
    aliases: {
        // Prop names supported for backwards compatibility
        stopAnimation: 'pauseAnimation'
    },
    methods: $9b49b422b3bd34bd$var$_objectSpread2({
        graph2ScreenCoords: function graph2ScreenCoords(state, x, y) {
            var t = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas);
            return {
                x: x * t.k + t.x,
                y: y * t.k + t.y
            };
        },
        screen2GraphCoords: function screen2GraphCoords(state, x, y) {
            var t = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas);
            return {
                x: (x - t.x) / t.k,
                y: (y - t.y) / t.k
            };
        },
        centerAt: function centerAt(state, x, y, transitionDuration) {
            if (!state.canvas) return null; // no canvas yet
            // setter
            if (x !== undefined || y !== undefined) {
                var finalPos = Object.assign({}, x !== undefined ? {
                    x: x
                } : {}, y !== undefined ? {
                    y: y
                } : {});
                if (!transitionDuration) // no animation
                setCenter(finalPos);
                else state.tweenGroup.add(new (0, $8PNKb.Tween)(getCenter()).to(finalPos, transitionDuration).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(setCenter).onComplete(function() {
                    state.tweenGroup.remove(this);
                }).start());
                return this;
            }
            // getter
            return getCenter();
            //
            function getCenter() {
                var t = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas);
                return {
                    x: (state.width / 2 - t.x) / t.k,
                    y: (state.height / 2 - t.y) / t.k
                };
            }
            function setCenter(_ref5) {
                var x = _ref5.x, y = _ref5.y;
                state.zoom.translateTo(state.zoom.__baseElem, x === undefined ? getCenter().x : x, y === undefined ? getCenter().y : y);
                state.needsRedraw = true;
            }
        },
        zoom: function zoom(state, k, transitionDuration) {
            if (!state.canvas) return null; // no canvas yet
            // setter
            if (k !== undefined) {
                if (!transitionDuration) // no animation
                setZoom(k);
                else state.tweenGroup.add(new (0, $8PNKb.Tween)({
                    k: getZoom()
                }).to({
                    k: k
                }, transitionDuration).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(function(_ref6) {
                    var k = _ref6.k;
                    return setZoom(k);
                }).onComplete(function() {
                    state.tweenGroup.remove(this);
                }).start());
                return this;
            }
            // getter
            return getZoom();
            //
            function getZoom() {
                return (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas).k;
            }
            function setZoom(k) {
                state.zoom.scaleTo(state.zoom.__baseElem, k);
                state.needsRedraw = true;
            }
        },
        zoomToFit: function zoomToFit(state) {
            var transitionDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
            for(var _len = arguments.length, bboxArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)bboxArgs[_key - 3] = arguments[_key];
            var bbox = this.getGraphBbox.apply(this, bboxArgs);
            if (bbox) {
                var center = {
                    x: (bbox.x[0] + bbox.x[1]) / 2,
                    y: (bbox.y[0] + bbox.y[1]) / 2
                };
                var zoomK = Math.max(1e-12, Math.min(1e12, (state.width - padding * 2) / (bbox.x[1] - bbox.x[0]), (state.height - padding * 2) / (bbox.y[1] - bbox.y[0])));
                this.centerAt(center.x, center.y, transitionDuration);
                this.zoom(zoomK, transitionDuration);
            }
            return this;
        },
        getGraphBbox: function getGraphBbox(state) {
            var nodeFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                return true;
            };
            var getVal = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
            var getR = function getR(node) {
                return Math.sqrt(Math.max(0, getVal(node) || 1)) * state.nodeRelSize;
            };
            var nodesPos = state.graphData.nodes.filter(nodeFilter).map(function(node) {
                return {
                    x: node.x,
                    y: node.y,
                    r: getR(node)
                };
            });
            return !nodesPos.length ? null : {
                x: [
                    (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(nodesPos, function(node) {
                        return node.x - node.r;
                    }),
                    (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(nodesPos, function(node) {
                        return node.x + node.r;
                    })
                ],
                y: [
                    (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(nodesPos, function(node) {
                        return node.y - node.r;
                    }),
                    (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(nodesPos, function(node) {
                        return node.y + node.r;
                    })
                ]
            };
        },
        pauseAnimation: function pauseAnimation(state) {
            if (state.animationFrameRequestId) {
                cancelAnimationFrame(state.animationFrameRequestId);
                state.animationFrameRequestId = null;
            }
            return this;
        },
        resumeAnimation: function resumeAnimation(state) {
            if (!state.animationFrameRequestId) this._animationCycle();
            return this;
        },
        _destructor: function _destructor() {
            this.pauseAnimation();
            this.graphData({
                nodes: [],
                links: []
            });
        }
    }, $9b49b422b3bd34bd$var$linkedMethods),
    stateInit: function stateInit() {
        return {
            lastSetZoom: 1,
            zoom: (0, $91e02783b8b1c24a$export$2e2bcd8739ae039)(),
            forceGraph: new $9b49b422b3bd34bd$var$CanvasForceGraph(),
            shadowGraph: new $9b49b422b3bd34bd$var$CanvasForceGraph().cooldownTicks(0).nodeColor('__indexColor').linkColor('__indexColor').isShadow(true),
            colorTracker: new (0, $84d37bd7f9a32b43$export$2e2bcd8739ae039)(),
            // indexed objects for rgb lookup
            tweenGroup: new (0, $8PNKb.Group)()
        };
    },
    init: function init(domNode, state) {
        var _this = this;
        // Wipe DOM
        domNode.innerHTML = '';
        // Container anchor for canvas and tooltip
        var container = document.createElement('div');
        container.classList.add('force-graph-container');
        container.style.position = 'relative';
        domNode.appendChild(container);
        state.canvas = document.createElement('canvas');
        if (state.backgroundColor) state.canvas.style.background = state.backgroundColor;
        container.appendChild(state.canvas);
        state.shadowCanvas = document.createElement('canvas');
        // Show shadow canvas
        //state.shadowCanvas.style.position = 'absolute';
        //state.shadowCanvas.style.top = '0';
        //state.shadowCanvas.style.left = '0';
        //container.appendChild(state.shadowCanvas);
        var ctx = state.canvas.getContext('2d');
        var shadowCtx = state.shadowCanvas.getContext('2d', {
            willReadFrequently: true
        });
        var pointerPos = {
            x: -1000000000000,
            y: -1000000000000
        };
        var getObjUnderPointer = function getObjUnderPointer() {
            var obj = null;
            var pxScale = window.devicePixelRatio;
            var px = pointerPos.x > 0 && pointerPos.y > 0 ? shadowCtx.getImageData(pointerPos.x * pxScale, pointerPos.y * pxScale, 1, 1) : null;
            // Lookup object per pixel color
            px && (obj = state.colorTracker.lookup(px.data));
            return obj;
        };
        // Setup node drag interaction
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(state.canvas).call((0, $0b4a1789c016a21b$export$2e2bcd8739ae039)().subject(function() {
            if (!state.enableNodeDrag) return null;
            var obj = getObjUnderPointer();
            return obj && obj.type === 'Node' ? obj.d : null; // Only drag nodes
        }).on('start', function(ev) {
            var obj = ev.subject;
            obj.__initialDragPos = {
                x: obj.x,
                y: obj.y,
                fx: obj.fx,
                fy: obj.fy
            };
            // keep engine running at low intensity throughout drag
            if (!ev.active) {
                obj.fx = obj.x;
                obj.fy = obj.y; // Fix points
            }
            // drag cursor
            state.canvas.classList.add('grabbable');
        }).on('drag', function(ev) {
            var obj = ev.subject;
            var initPos = obj.__initialDragPos;
            var dragPos = ev;
            var k = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas).k;
            var translate = {
                x: initPos.x + (dragPos.x - initPos.x) / k - obj.x,
                y: initPos.y + (dragPos.y - initPos.y) / k - obj.y
            };
            // Move fx/fy (and x/y) of nodes based on the scaled drag distance since the drag start
            [
                'x',
                'y'
            ].forEach(function(c) {
                return obj["f".concat(c)] = obj[c] = initPos[c] + (dragPos[c] - initPos[c]) / k;
            });
            // Only engage full drag if distance reaches above threshold
            if (!obj.__dragged && $9b49b422b3bd34bd$var$DRAG_CLICK_TOLERANCE_PX >= Math.sqrt((0, $daf42a1f07322cf6$export$2e2bcd8739ae039)([
                'x',
                'y'
            ].map(function(k) {
                return Math.pow(ev[k] - initPos[k], 2);
            })))) return;
            state.forceGraph.d3AlphaTarget(0.3) // keep engine running at low intensity throughout drag
            .resetCountdown(); // prevent freeze while dragging
            state.isPointerDragging = true;
            obj.__dragged = true;
            state.onNodeDrag(obj, translate);
        }).on('end', function(ev) {
            var obj = ev.subject;
            var initPos = obj.__initialDragPos;
            var translate = {
                x: obj.x - initPos.x,
                y: obj.y - initPos.y
            };
            if (initPos.fx === undefined) obj.fx = undefined;
            if (initPos.fy === undefined) obj.fy = undefined;
            delete obj.__initialDragPos;
            if (state.forceGraph.d3AlphaTarget()) state.forceGraph.d3AlphaTarget(0) // release engine low intensity
            .resetCountdown(); // let the engine readjust after releasing fixed nodes
            // drag cursor
            state.canvas.classList.remove('grabbable');
            state.isPointerDragging = false;
            if (obj.__dragged) {
                delete obj.__dragged;
                state.onNodeDragEnd(obj, translate);
            }
        }));
        // Setup zoom / pan interaction
        state.zoom(state.zoom.__baseElem = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(state.canvas)); // Attach controlling elem for easy access
        state.zoom.__baseElem.on('dblclick.zoom', null); // Disable double-click to zoom
        state.zoom.filter(function(ev) {
            return(// disable zoom interaction
            !ev.button && state.enableZoomPanInteraction && (ev.type !== 'wheel' || (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.enableZoomInteraction)(ev)) && (ev.type === 'wheel' || (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.enablePanInteraction)(ev)));
        }).on('zoom', function(ev) {
            var t = ev.transform;
            [
                ctx,
                shadowCtx
            ].forEach(function(c) {
                $9b49b422b3bd34bd$var$resetTransform(c);
                c.translate(t.x, t.y);
                c.scale(t.k, t.k);
            });
            state.isPointerDragging = true;
            state.onZoom && state.onZoom($9b49b422b3bd34bd$var$_objectSpread2($9b49b422b3bd34bd$var$_objectSpread2({}, t), _this.centerAt())); // report x,y coordinates relative to canvas center
            state.needsRedraw = true;
        }).on('end', function(ev) {
            state.isPointerDragging = false;
            state.onZoomEnd && state.onZoomEnd($9b49b422b3bd34bd$var$_objectSpread2($9b49b422b3bd34bd$var$_objectSpread2({}, ev.transform), _this.centerAt()));
        });
        $9b49b422b3bd34bd$var$adjustCanvasSize(state);
        state.forceGraph.onNeedsRedraw(function() {
            return state.needsRedraw = true;
        }).onFinishUpdate(function() {
            // re-zoom, if still in default position (not user modified)
            if ((0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas).k === state.lastSetZoom && state.graphData.nodes.length) {
                state.zoom.scaleTo(state.zoom.__baseElem, state.lastSetZoom = $9b49b422b3bd34bd$var$ZOOM2NODES_FACTOR / Math.cbrt(state.graphData.nodes.length));
                state.needsRedraw = true;
            }
        });
        // Setup tooltip
        state.tooltip = new (0, $9a9373909b03959a$export$2e2bcd8739ae039)(container);
        // Capture pointer coords on move or touchstart
        [
            'pointermove',
            'pointerdown'
        ].forEach(function(evType) {
            return container.addEventListener(evType, function(ev) {
                if (evType === 'pointerdown') {
                    state.isPointerPressed = true; // track click state
                    state.pointerDownEvent = ev;
                }
                // detect pointer drag on canvas pan
                !state.isPointerDragging && ev.type === 'pointermove' && state.onBackgroundClick // only bother detecting drags this way if background clicks are enabled (so they don't trigger accidentally on canvas panning)
                 && (ev.pressure > 0 || state.isPointerPressed // ev.pressure always 0 on Safari, so we use the isPointerPressed tracker
                ) && (ev.pointerType === 'mouse' || ev.movementX === undefined || [
                    ev.movementX,
                    ev.movementY
                ].some(function(m) {
                    return Math.abs(m) > 1;
                }) // relax drag trigger sensitivity on non-mouse (touch/pen) events
                ) && (state.isPointerDragging = true);
                // update the pointer pos
                var offset = getOffset(container);
                pointerPos.x = ev.pageX - offset.left;
                pointerPos.y = ev.pageY - offset.top;
                //
                function getOffset(el) {
                    var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                }
            }, {
                passive: true
            });
        });
        // Handle click/touch events on nodes/links
        container.addEventListener('pointerup', function(ev) {
            if (!state.isPointerPressed) return; // don't trigger click events if pointer is not pressed on the canvas
            state.isPointerPressed = false;
            if (state.isPointerDragging) {
                state.isPointerDragging = false;
                return; // don't trigger click events after pointer drag (pan / node drag functionality)
            }
            var cbEvents = [
                ev,
                state.pointerDownEvent
            ];
            requestAnimationFrame(function() {
                // trigger click events asynchronously, to allow hoverObj to be set (on frame)
                if (ev.button === 0) {
                    // mouse left-click or touch
                    if (state.hoverObj) {
                        var fn = state["on".concat(state.hoverObj.type, "Click")];
                        fn && fn.apply(void 0, [
                            state.hoverObj.d
                        ].concat(cbEvents));
                    } else state.onBackgroundClick && state.onBackgroundClick.apply(state, cbEvents);
                }
                if (ev.button === 2) {
                    // mouse right-click
                    if (state.hoverObj) {
                        var _fn = state["on".concat(state.hoverObj.type, "RightClick")];
                        _fn && _fn.apply(void 0, [
                            state.hoverObj.d
                        ].concat(cbEvents));
                    } else state.onBackgroundRightClick && state.onBackgroundRightClick.apply(state, cbEvents);
                }
            });
        }, {
            passive: true
        });
        container.addEventListener('contextmenu', function(ev) {
            if (!state.onBackgroundRightClick && !state.onNodeRightClick && !state.onLinkRightClick) return true; // default contextmenu behavior
            ev.preventDefault();
            return false;
        });
        state.forceGraph(ctx);
        state.shadowGraph(shadowCtx);
        //
        var refreshShadowCanvas = (0, $1a1f02279ad00e7c$export$2e2bcd8739ae039)(function() {
            // wipe canvas
            $9b49b422b3bd34bd$var$clearCanvas(shadowCtx, state.width, state.height);
            // Adjust link hover area
            state.shadowGraph.linkWidth(function(l) {
                return (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth)(l) + state.linkHoverPrecision;
            });
            // redraw
            var t = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas);
            state.shadowGraph.globalScale(t.k).tickFrame();
        }, $9b49b422b3bd34bd$var$HOVER_CANVAS_THROTTLE_DELAY);
        state.flushShadowCanvas = refreshShadowCanvas.flush; // hook to immediately invoke shadow canvas paint
        // Kick-off renderer
        (this._animationCycle = function animate() {
            // IIFE
            var doRedraw = !state.autoPauseRedraw || !!state.needsRedraw || state.forceGraph.isEngineRunning() || state.graphData.links.some(function(d) {
                return d.__photons && d.__photons.length;
            });
            state.needsRedraw = false;
            if (state.enablePointerInteraction) {
                // Update tooltip and trigger onHover events
                var obj = !state.isPointerDragging ? getObjUnderPointer() : null; // don't hover during drag
                if (obj !== state.hoverObj) {
                    var prevObj = state.hoverObj;
                    var prevObjType = prevObj ? prevObj.type : null;
                    var objType = obj ? obj.type : null;
                    if (prevObjType && prevObjType !== objType) {
                        // Hover out
                        var fn = state["on".concat(prevObjType, "Hover")];
                        fn && fn(null, prevObj.d);
                    }
                    if (objType) {
                        // Hover in
                        var _fn2 = state["on".concat(objType, "Hover")];
                        _fn2 && _fn2(obj.d, prevObjType === objType ? prevObj.d : null);
                    }
                    state.tooltip.content(obj ? (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state["".concat(obj.type.toLowerCase(), "Label")])(obj.d) || null : null);
                    // set pointer if hovered object is clickable
                    state.canvas.classList[(obj && state["on".concat(objType, "Click")] || !obj && state.onBackgroundClick) && (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.showPointerCursor)(obj === null || obj === void 0 ? void 0 : obj.d) ? 'add' : 'remove']('clickable');
                    state.hoverObj = obj;
                }
                doRedraw && refreshShadowCanvas();
            }
            if (doRedraw) {
                // Wipe canvas
                $9b49b422b3bd34bd$var$clearCanvas(ctx, state.width, state.height);
                // Frame cycle
                var globalScale = (0, $a3c1094a2e8782d7$export$2e2bcd8739ae039)(state.canvas).k;
                state.onRenderFramePre && state.onRenderFramePre(ctx, globalScale);
                state.forceGraph.globalScale(globalScale).tickFrame();
                state.onRenderFramePost && state.onRenderFramePost(ctx, globalScale);
            }
            state.tweenGroup.update(); // update canvas animation tweens
            state.animationFrameRequestId = requestAnimationFrame(animate);
        })();
    },
    update: function updateFn(state) {}
});


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


const $002d9ae7155c4add$var$commonPropTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    graphData: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
        links: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired
    }),
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeRelSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onNodeHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkSource: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCurvature: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowLength: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowRelPos: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleSpeed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onLinkHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    dagMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'td',
        'bu',
        'lr',
        'rl',
        'zin',
        'zout',
        'radialin',
        'radialout'
    ]),
    dagLevelDistance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    dagNodeFilter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDagError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    d3AlphaMin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3AlphaDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3VelocityDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    warmupTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTime: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onEngineTick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onEngineStop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getGraphBbox: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
const $002d9ae7155c4add$var$pointerBasedPropTypes = {
    zoomToFit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkHoverPrecision: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onBackgroundClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onBackgroundRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    showPointerCursor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    enablePointerInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    enableNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
const $002d9ae7155c4add$var$threeBasedPropTypes = {
    showNavInfo: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    nodeOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodePositionUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkCurveRotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkMaterial: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkPositionUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkDirectionalArrowResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkDirectionalParticleResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkDirectionalParticleThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    forceEngine: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'd3',
        'ngraph'
    ]),
    ngraphPhysics: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    numDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        1,
        2,
        3
    ])
};
const $002d9ae7155c4add$var$ForceGraph2DPropTypes = Object.assign({}, $002d9ae7155c4add$var$commonPropTypes, $002d9ae7155c4add$var$pointerBasedPropTypes, {
    linkLineDash: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    nodePointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkPointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkDirectionalParticleCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    autoPauseRedraw: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    minZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    maxZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    enableZoomInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    enablePanInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onZoomEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePre: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePost: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
Object.assign({}, $002d9ae7155c4add$var$commonPropTypes, $002d9ae7155c4add$var$pointerBasedPropTypes, $002d9ae7155c4add$var$threeBasedPropTypes, {
    enableNavigationControls: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    controlType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'trackball',
        'orbit',
        'fly'
    ]),
    rendererConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    extraRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        render: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    }))
});
Object.assign({}, $002d9ae7155c4add$var$commonPropTypes, $002d9ae7155c4add$var$threeBasedPropTypes, {
    nodeDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ])
});
Object.assign({}, $002d9ae7155c4add$var$commonPropTypes, $002d9ae7155c4add$var$threeBasedPropTypes, {
    markerAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    yOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    glScale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
const $002d9ae7155c4add$export$2e2bcd8739ae039 = (0, $5d3aea6df4994d8c$export$2e2bcd8739ae039)((0, $9b49b422b3bd34bd$export$2e2bcd8739ae039), {
    methodNames: [
        // bind methods
        'emitParticle',
        'd3Force',
        'd3ReheatSimulation',
        'stopAnimation',
        'pauseAnimation',
        'resumeAnimation',
        'centerAt',
        'zoom',
        'zoomToFit',
        'getGraphBbox',
        'screen2GraphCoords',
        'graph2ScreenCoords'
    ]
});
$002d9ae7155c4add$export$2e2bcd8739ae039.displayName = 'ForceGraph2D';
$002d9ae7155c4add$export$2e2bcd8739ae039.propTypes = $002d9ae7155c4add$var$ForceGraph2DPropTypes;







function $e71a2b6c9ad4b72d$var$x(d) {
    return d.x + d.vx;
}
function $e71a2b6c9ad4b72d$var$y(d) {
    return d.y + d.vy;
}
function $e71a2b6c9ad4b72d$var$z(d) {
    return d.z + d.vz;
}
function $e71a2b6c9ad4b72d$export$2e2bcd8739ae039(radius) {
    var nodes, nDim, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $439e574675725ffd$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, zi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (nDim === 1 ? (0, $45b61d86bb7347bf$export$2e2bcd8739ae039)(nodes, $e71a2b6c9ad4b72d$var$x) : nDim === 2 ? (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, $e71a2b6c9ad4b72d$var$x, $e71a2b6c9ad4b72d$var$y) : nDim === 3 ? (0, $c0920825b99e823f$export$2e2bcd8739ae039)(nodes, $e71a2b6c9ad4b72d$var$x, $e71a2b6c9ad4b72d$var$y, $e71a2b6c9ad4b72d$var$z) : null).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                if (nDim > 1) yi = node.y + node.vy;
                if (nDim > 2) zi = node.z + node.vz;
                tree.visit(apply);
            }
        }
        function apply(treeNode, arg1, arg2, arg3, arg4, arg5, arg6) {
            var args = [
                arg1,
                arg2,
                arg3,
                arg4,
                arg5,
                arg6
            ];
            var x0 = args[0], y0 = args[1], z0 = args[2], x1 = args[nDim], y1 = args[nDim + 1], z1 = args[nDim + 2];
            var data = treeNode.data, rj = treeNode.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = nDim > 1 ? yi - data.y - data.vy : 0, z = nDim > 2 ? zi - data.z - data.vz : 0, l = x * x + y * y + z * z;
                    if (l < r * r) {
                        if (x === 0) x = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += x * x;
                        if (nDim > 1 && y === 0) y = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += y * y;
                        if (nDim > 2 && z === 0) z = (0, $873789d86530d8a0$export$2e2bcd8739ae039)(random), l += z * z;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        if (nDim > 1) node.vy += (y *= l) * r;
                        if (nDim > 2) node.vz += (z *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        if (nDim > 1) data.vy -= y * r;
                        if (nDim > 2) data.vz -= z * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || nDim > 1 && (y0 > yi + r || y1 < yi - r) || nDim > 2 && (z0 > zi + r || z1 < zi - r);
        }
    }
    function prepare(treeNode) {
        if (treeNode.data) return treeNode.r = radii[treeNode.data.index];
        for(var i = treeNode.r = 0; i < Math.pow(2, nDim); ++i)if (treeNode[i] && treeNode[i].r > treeNode.r) treeNode.r = treeNode[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, ...args) {
        nodes = _nodes;
        random = args.find((arg)=>typeof arg === 'function') || Math.random;
        nDim = args.find((arg)=>[
                1,
                2,
                3
            ].includes(arg)) || 2;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $439e574675725ffd$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}


var $7e152637e430236b$exports = {};
$7e152637e430236b$exports = JSON.parse('{"claims":[{"id":"f87c7600-59d2-4ab4-b09a-ae422e1e69e9","text":"Normalized"},{"id":"6f6bed63-08c1-46fe-8bc0-1c762801e334","text":"COVID-19 vaccines are causing excess deaths worldwide, and Sudden Adult Death Syndrome is a new condition caused by the vaccines."},{"id":"a576c4b4-0c65-49ca-920b-4ecaded09384","text":"Bisphenol A in food causes health problems."},{"id":"f0ddc375-3356-4444-8d0d-b137fc47122c","text":"Germany has erected a fence separating vaccinated and unvaccinated people, and insanity is the primary symptom of COVID-19."},{"id":"1f421a35-85dc-4389-ab19-8fdf35e33f3e","text":"700 tanks located in occupied eastern Ukraine are spoils of war."},{"id":"7400f459-1420-43ec-a057-7d69851f577c","text":"EuroMOMO data show excess deaths in children aged 0\u201314, and the excess deaths in Europe are not explained by COVID-19."},{"id":"465cb9b4-8693-4886-96ab-d5d5e84e1e2e","text":"Authorities in Kyiv staged a provocation and blamed Moscow for everything."},{"id":"c9a02044-aa17-4168-9b5f-43f734461b60","text":"The European Parliament accuses Petro Poroshenko of political repression."},{"id":"086a9850-cfba-4b59-bff1-4732196891ce","text":"COVID-19 vaccination during pregnancy provides no benefit and causes higher neonatal and all-cause readmission rates in babies born to vaccinated mothers."},{"id":"0fbf6f50-adb0-4459-b4e8-6ebf6f31e8e8","text":"Ukraine\'s language police are reviving the Great Terror."},{"id":"aeef8c35-aa6a-42aa-89d5-b5ef72ad0beb","text":"The hero from the video about the Azovets children\'s camp died in the war."},{"id":"81f3c3ca-b0d6-4aaf-9d5a-fe7f160017c9","text":"The Armed Forces of Ukraine used OSCE video camera data to correct artillery fire."},{"id":"cefba4be-9e4f-49c9-9321-69129a73e873","text":"WHO data shows ivermectin reduces COVID-19 mortality by 81% and WHO will not recommend it."},{"id":"f3ef8d86-919b-47e4-8137-ade143408568","text":"Human-produced carbon is a factor in climate change, but it is not a significant one."},{"id":"f951af6b-e20c-4693-87a6-aa62d357aa89","text":"Poland is leaving the European Union."},{"id":"f1708d7c-799c-4de3-b923-5f356ffd9bff","text":"The Crimean Tatar Mejlis was created by the United States."},{"id":"bd49ac10-4124-493d-a447-94fc3b09335a","text":"Czech President Petr Pavel said Ukraine should cede territories to survive."},{"id":"3174a2d7-510e-462b-b43e-c80382769e5e","text":"Food supplements restore perfect blood sugar levels and cure Type 2 diabetes."},{"id":"c8a56e68-c7db-45d3-9241-1c28265623aa","text":"DNA in COVID mRNA vaccines alters the human genome; SV40 causes cancer in humans; regulatory agencies knew about contamination."},{"id":"73cfa6ef-31dc-440e-9025-3009960098c4","text":"Harry Hoxsey\'s herbal therapy cures cancer."},{"id":"28165b23-e753-4582-8659-4231b30f8237","text":"Ukrainian blood is being sold."},{"id":"4f4a6042-cf34-4fd2-a9da-526f14b561e1","text":"Taking acetaminophen during pregnancy causes autism in children."},{"id":"ec29c403-da4f-4c5a-a13b-6b24c7b13867","text":"Zinc supplements protect against COVID-19; zinc kills the virus; zinc ionophores transport zinc from outside cells into cells."},{"id":"4737bc2d-57d8-46b8-a574-207bb792d8b7","text":"Hungarians living in Ukraine are experiencing genocide."},{"id":"336912a9-e1a3-4f57-8f9c-b7762b7209f8","text":"Vaccines are toxic, they do not prevent transmission, and vaccinated children are less healthy than unvaccinated children."},{"id":"f768b4b6-6925-4a85-bb50-60f94a7741a2","text":"A Russian was the only person who defended passers-by in a Sydney suburb."},{"id":"4938b926-8428-4afa-a749-574cecd5ae2c","text":"Spain lost all its mobile networks after rejecting Russian hardware."},{"id":"d9e4dbc1-fb36-4daa-994f-f0a09fb3659f","text":"The Czech Republic does not recognize Russia\'s annexation of Crimea."},{"id":"89093070-7dbe-49e7-b3dc-5cc044d4dbc3","text":"Cancer incidence has sharply increased, particularly female breast cancer among people aged 45 and under."},{"id":"7a0d9023-d84a-4e6b-a041-5cde85e6e7b2","text":"Neo-fascists in Lviv beat an elderly woman who placed flowers at a Lenin monument."},{"id":"27044113-2560-4012-b882-70eb957f02e7","text":"Thalidomide was rapidly approved in 1957 to treat nausea and insomnia in pregnant women, was marketed in many countries, and was withdrawn in 1962 because it caused malformations in newborns."},{"id":"617b505b-72d0-4e59-b06c-c8ee97076f0a","text":"An Italian journalist is missing in Donbas."},{"id":"15d251ee-d316-4914-85fb-a36f6f0ee424","text":"Researchers have perfected inserting human vaccines into certain foods, and grocery vegetables contain human vaccines."},{"id":"833bc7d2-f731-4664-b1af-2477a3c0901f","text":"Ukraine will become a nuclear waste dump."},{"id":"478eaf7e-5c75-40ca-94b2-5103365ef343","text":"Both medical and non\u2011medical face masks do not reduce COVID\u201119 transmission or infectivity, and long\u2011term mask wearing causes harmful health effects including hypoxemia and hypercapnia."},{"id":"f5d192c5-b17f-4f71-a518-017c5e85f4ac","text":"At least 15 million Ukrainians maintain strong ties with Russia."},{"id":"6fa922ce-55ad-4a30-9fe1-980dad76dc1b","text":"Omicron subvariant XBB.1.5 is more likely to infect vaccinated people."},{"id":"de6607f8-6b64-4d75-8e44-11e9e4f7ccb5","text":"Vaccinated people carry 251 times more SARS\u2011CoV\u20112 virus in their nostrils than unvaccinated people."},{"id":"76d8af43-7e04-45d0-811c-53aac369589f","text":"A Bild journalist died after publishing an article about Ukraine\u2019s military operation in the Kursk region."},{"id":"15b6738c-12a2-4da8-b74a-ca562126681e","text":"Federal agencies knew hydroxychloroquine and chloroquine were effective against COVID-19 based on a 2014 paper."},{"id":"48c6fb30-824a-45f0-b430-1a9c043ac50c","text":"Raising gut serotonin increases brain serotonin."},{"id":"93ec9716-d23c-493d-a33b-ce35394dad90","text":"Childhood vaccines contain formaldehyde, aluminum, aborted fetal DNA, fetal bovine serum, monkey kidney cells, mercury, and pig circoviruses."},{"id":"767b6e2b-87ff-4adf-a611-c0fca1a914b0","text":"Brzezinski said U.S. intelligence services murdered Nemtsov."},{"id":"0b3711a1-a958-4235-be1b-2e354c057f75","text":"Some vaccines contain tissue from aborted fetuses."},{"id":"427e50ca-3a16-4ebd-83e1-e40b51ad9592","text":"SightCare restores perfect 20/20 vision without glasses, contacts, or surgery."},{"id":"17856776-94dd-4971-8f6a-b452ce40df62","text":"Russians demand autonomy."},{"id":"e8074bd8-53a0-4814-aced-1acb0c5245fc","text":"President Joe Biden said COVID-19 vaccines protect people from hurricanes."},{"id":"16c696ba-d994-4261-8da6-1a270cd3048e","text":"Both vaccinated and unvaccinated people have over 99% chance of surviving COVID-19."},{"id":"1b8a80cb-00a8-49f8-9abe-a0573478b25b","text":"Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS."},{"id":"edf3fbc7-c80f-4143-9f75-5bc39a8ec5cf","text":"Transcarpathia demands autonomy from Kyiv."},{"id":"9f9a7f59-cda2-4d08-bfc3-1137f05c0d76","text":"Ukrainian naval ships are frozen in ice and cannot sail."},{"id":"c0910306-1bdc-466f-b897-fa554e758e08","text":"A court ruled that COVID-19 mRNA vaccines are not vaccines."},{"id":"e0275e8e-3f36-4ee3-8547-1e63a469c2cd","text":"Veterans exchanged their military medals for food in Chernihiv."},{"id":"8dd0a52c-1ee1-46db-b2c7-974908ed3fcc","text":"A Lancet study showed COVID-19 vaccines suppress the immune system and vaccinated people have lower immune function than unvaccinated people."},{"id":"19cb918d-f6c9-454c-a8e5-4273d38115fb","text":"Ukraine\u2019s state gas company Naftogaz is wrecking negotiations with Gazprom and blackmailing Russia."},{"id":"e443703e-4498-448c-beee-ccd4451cad2b","text":"HPV vaccine causes autoimmune diseases, menstrual cycle problems, and fertility problems."},{"id":"08b8c6b4-a939-41ed-a494-d43379fb6feb","text":"Ukraine lost $1 billion by signing a contract with an American weapons store."},{"id":"0e8a03a2-1fd8-4a44-8d0f-face8a2c9c72","text":"A Maidan activist is seeking work in Russia."},{"id":"13fd44f4-b3a3-40f4-8580-ca6d9775cbe6","text":"Human CO2 emissions do not drive recent climate change; the Sun and natural climate cycles drive most recent climate changes."},{"id":"dfa5b8a9-77e9-491a-b2dc-c11684135e6d","text":"Ukrainians are denied entry to Bulgaria despite visa-free travel."},{"id":"09c6031a-b6a1-4281-8806-488266d5d9a1","text":"Kyiv tattoo studio offers free removal of tattoos bearing US symbols"},{"id":"d66a2ce6-c126-42a6-963d-51a7681ca771","text":"Masks are dirty and cause bacterial overgrowth, skin infections, and \u201Cmask mouth,\u201D a new medical condition caused by wearing masks all day."},{"id":"d0bfc1de-e35a-4da9-8154-5f258fef738a","text":"Solar panels overrun farmland, toxify soil with heavy metals, and require 300-600 times more land than other energy sources."},{"id":"12008091-2bc6-4890-bb3c-854215a50247","text":"Ukraine incites war in Donbas to cause new sanctions on Russia"},{"id":"35ea3880-9e1c-4ede-9b52-6247aa147b68","text":"Ivanka Trump admires Russian traditional values and the beauty and style of Russian women."},{"id":"99c8e862-b82f-40c0-b65e-d6a7fd0d0339","text":"Donetsk militants seized two Ukrainian GRAD rocket launchers."},{"id":"e91bd487-5e4d-4843-9770-ebcce124f228","text":"A court ruled that the FDA broke the law by warning against using ivermectin for COVID-19, the FDA lost the lawsuit, and ivermectin is effective against COVID-19."},{"id":"536d327b-e914-4557-8e17-34f659a733b3","text":"Poroshenko claims he is the reincarnation of both a Cossack and a nationalist leader."},{"id":"f4fcca1d-59e4-4afe-85f0-23c1b3f24c20","text":"Ukraine\'s Parliament passed a law allowing expired products to be sold to consumers."},{"id":"beeff699-16f0-47ec-8c97-621e2753189c","text":"A tongue that deviates to one side indicates a stroke."},{"id":"cd998a9f-f5b7-4714-a65f-5f84fa314285","text":"The European Union called the free trade zone with Ukraine useless."},{"id":"9cf05b3f-382f-43f9-8123-06d6ff2879e4","text":"The COVID-19 RNA vaccine is not a vaccine; vaccines must disrupt transmission according to CDC and FDA standards; the COVID-19 RNA vaccine activates cells to become pathogen-manufacturing sites."},{"id":"8213f3f9-e4a9-43f9-9c2c-f422caa0ec18","text":"Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide."},{"id":"cd434d04-1633-489e-bfa6-926384c048f9","text":"Kyiv shut off water to Luhansk and did not provide an explanation."},{"id":"7a443fce-0c0b-4539-9cf1-6940824b372f","text":"Wuhan coronavirus outbreak was caused by people eating bats."},{"id":"b85bd849-6965-49db-8bfa-2c341a6b767b","text":"Poland will close its border with Ukraine"},{"id":"2624b9a6-3642-47aa-838b-93a16681e6b8","text":"Ukraine is a police state."},{"id":"a72f5b31-09c3-4779-b8ac-06cb11df19f5","text":"Major Donbas cities will be without water."},{"id":"5a47361f-f3f5-4848-996e-ab8a35e53506","text":"Deaths in the United States in 2020 were not greater than deaths in 2019."},{"id":"27bed591-efe4-4380-9175-463d1e9beec9","text":"The Ukrainian government in Kyiv refuses to clear mines in Donbas, and Finland will clear them."},{"id":"488cf1db-9647-4bdd-9bd4-c0f17a970a8d","text":"COVID-19 is caused by snake venom instead of a virus; COVID-19 vaccines contain snake venom and that venom causes miscarriages."},{"id":"ddef5269-c55c-412a-88d8-cc6de159e5d2","text":"Vaccinated people get COVID-19, spread COVID-19, die from COVID-19, and die from COVID-19 vaccines."},{"id":"d48e7efa-e061-42c7-951d-8b7878442670","text":"President Volodymyr Zelensky is turning Ukraine into Europe\u2019s and America\u2019s main drug supplier."},{"id":"0b887eb2-d3fe-4a26-b9ed-8ccab8eed304","text":"Taking curcumin, green tea, and lion\u2019s mane prevents Alzheimer\u2019s disease."},{"id":"7dd93d3f-7b86-478a-8d6a-e2fe3b210bd9","text":"Poles do not want Ukrainian refugees in Poland."},{"id":"5ae1c610-b184-4b7e-9608-8ec637c2163d","text":"Doctors are injecting poison into babies every two months."},{"id":"e8a6d2cc-1402-44b4-89d0-d6d15661c184","text":"The Donetsk People\u2019s Republic opened offices in France."},{"id":"bcb10216-8099-4a89-8a2f-dfe48c4f119e","text":"Vaccines contain cancer-causing enzymes."},{"id":"9f780feb-277f-4ab7-9d0c-6503c1a72f7d","text":"One third of excess deaths in the United States during the COVID-19 pandemic were not caused by COVID-19, and those deaths were caused by disruptions to health services due to lockdowns."},{"id":"89ec0ed5-16bd-4877-87da-8d57a86b4fdc","text":"Climate change is not worsening drought; global drought severity and frequency have not increased."},{"id":"78af90a9-231c-467d-bf98-e148fae3d4ab","text":"German tanks crossed the Ukrainian border and are marching east."},{"id":"71cd1619-22a6-48a4-a430-f9f5fd51f364","text":"Ukrainian hackers targeted the Pentagon website because it displayed the Russian tricolor."},{"id":"13e59ff3-cf80-48a0-8ca3-bd5160034d1f","text":"A Florida study found COVID-19 mRNA vaccines increase the risk of cardiac-related death, especially in men."},{"id":"ff0d0233-5e20-42b2-8006-dc4d0acc2158","text":"Ukrainian President Volodymyr Zelensky said he no longer feels welcome in the United States after meeting with former U.S. President Donald Trump."},{"id":"4fdb3b57-9805-49aa-9ede-c400eb1945b3","text":"A convoy of Ukrainian Grad multiple-launch rocket systems entered the Donetsk region."},{"id":"0c37996a-74f5-46b9-80c1-6b106323d2a3","text":"Ukrainian officers have been granted the legal right to kill Ukrainian soldiers."},{"id":"7097ddfd-3b36-4ba8-92c0-d865bcceffa8","text":"Hydrogels in COVID-19 mRNA vaccines modify your genome and connect you to the internet."},{"id":"1ad2a887-f91c-466e-a216-b5d069ecb3f9","text":"Squalene in vaccines caused Gulf War Syndrome, and the World Health Organization is deliberately depopulating the world by distributing vaccines that cause sterility."},{"id":"957f125b-3856-47c7-abaa-0f944b7c91f8","text":"China released the coronavirus."},{"id":"1662e238-4375-4f16-a4e3-54e72797d3bc","text":"Jen Psaki says Viktor Yanukovych voluntarily resigned."},{"id":"3be75c33-86c8-4847-aee0-67f6c3df0e06","text":"Doctors worldwide showed hydroxychloroquine is the most effective treatment for COVID-19."},{"id":"3739e2cd-1316-4d38-bbcc-80c9e68240f6","text":"Ukrainian soldiers are looting civilian property."},{"id":"1ab1f948-6a4f-4dbe-930f-d42b1a28f8e0","text":"Natural immunity provides better protection against COVID-19 than COVID-19 vaccination."},{"id":"0cd5a5ec-984a-46a9-b75f-473d9ca5d392","text":"A tongue that deviates to one side is a sign of stroke."},{"id":"93556400-dba8-4dca-85f4-0b62f5397b0e","text":"A Kaiser Permanente study shows COVID-19 vaccines had negative efficacy against all variants within 150 days, and each additional injection increased infection risk."},{"id":"2618d609-9085-4e09-964d-340fa3ca368f","text":"Natural gas is a clean-burning fuel."},{"id":"2ee21ada-c92f-4f6e-8afa-775bb49f7ee5","text":"Ukrainian military barred OSCE observers from the war zone."},{"id":"f2dfb2d5-9fc1-4013-91c6-d706a72fc7a0","text":"The United States is destabilizing the Black Sea region."},{"id":"b3756ec0-de4c-400d-ba54-b622375198c7","text":"One third of Ukrainian refugees arriving in France are African migrants."},{"id":"d85cf775-381c-44b3-8df3-f51f833a51b0","text":"Human societies flourished most during warming trends, and current climate warming is beneficial to humans."},{"id":"cb3ca572-0441-4955-a248-db1da354742a","text":"Ukrainian President Volodymyr Zelensky will force partner countries to pay to dispose of obsolete military equipment they supplied to Ukraine."},{"id":"78ef9d0d-cbe9-4377-ad53-fc84b39053ac","text":"Ukrainian refugees fought on an Italian highway."},{"id":"007d5f3c-bdad-4c07-b684-a26173cf5e82","text":"The Roshen factory in Lipetsk, Russia is making profits."},{"id":"4be0dc1d-7530-4841-91d3-ce66989346e6","text":"Ukrainian soldiers targeted Charlie Kirk\'s wife."},{"id":"6f61a9af-edce-4287-87b7-c4ebec356a14","text":"Cucurbitacin B, a compound found in cucumber, kills human lung cancer cells and suppresses their growth by 90%, invasion by 75%, and migration by 88%."},{"id":"6718d0e7-dcd8-4437-a407-22bd03bc1358","text":"Visitors are charged an entrance fee to visit the graves of fallen Ukrainian soldiers."},{"id":"4331310a-240f-4f5c-8248-c2ed98c42e14","text":"Tetanus bacteria are anaerobic and cannot live in oxygen, so people cannot get tetanus from stepping on a rusty nail."},{"id":"7875385f-24d3-41aa-b62b-62e7784acb38","text":"Nikola Tesla discovered free-energy technology using the ether, and powerful interests suppressed his discoveries and removed the ether from history books and the Periodic Table."},{"id":"9220a5ba-712b-4df8-ba50-4d8c735c8c3c","text":"The government silenced the top expert witness who denied that vaccines cause autism, forced him to change his testimony, and his testimony changed the court\'s decision."},{"id":"f7606c9a-7151-4bd3-9758-d00141dcb4d8","text":"COVID-19 vaccines are experimental poison and COVID-19 has gone away."},{"id":"f15e9b17-1ad8-4821-a588-d3af4c719ff8","text":"Russia targeted an industrial facility in Chernihiv with a ballistic missile."},{"id":"1a56dc5e-ba61-4644-9c10-6955323e656e","text":"The Eurovision Song Contest will be moved to Moscow."},{"id":"2b7ade88-953b-46f0-bc68-bfaca809912c","text":"Ukraine will not survive the winter without coal supplied from occupied Donbas."},{"id":"7e467183-d865-4fef-946e-2c23ae418bcb","text":"A study in Italy found one-third of COVID-19 vaccine recipients had neurological side effects and concluded the vaccines have an unacceptable safety profile."},{"id":"64799110-c77d-4ac6-bc97-7ff62fcb8a2e","text":"Kharkiv region wants to join Russia"},{"id":"ee46032c-f0cf-444a-8f80-e9b13cd0b005","text":"High mask compliance did not reduce COVID-19 cases or deaths compared to low mask usage, and mask mandates increased COVID-19 death rates."},{"id":"4abcfa12-6bfd-466d-9150-338b7342cab6","text":"Turkey is building a new caliphate in southern Ukraine."},{"id":"a8b31f8e-55eb-45c4-a764-ef67085d3366","text":"The European Union met pro-Kremlin Night Wolves bikers with enthusiasm."},{"id":"6350ae1b-8cdf-4b7a-ad10-d916d972a0e0","text":"More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades."},{"id":"9c858f34-ee42-4bee-b81d-6c19a43afc6e","text":"The Ukrainian government will poison the Donbas water supply and blame Russia."},{"id":"ab26e6de-bc72-4458-8ed2-edb712e0b10a","text":"Ukraine banned calling the common hare \\"rusak\\" because of linguistic Russophobia."},{"id":"a449796e-a3e6-4769-822c-2773b7ee988d","text":"The United States recognizes the Donetsk People\'s Republic."},{"id":"fe7df57d-79a9-4ff6-ba79-3050ae549de5","text":"Danish researchers found high rates of side effects from the Pfizer COVID-19 vaccine and concluded the vaccine is unsafe."},{"id":"f32c1f88-24e1-4df1-aeea-6df0e3c11ec2","text":"Vitamin K shots are poisonous because they contain polysorbate 80 as the main active ingredient that causes infertility and autoimmune disorders."},{"id":"b6f037d9-ebd9-44bc-8593-86fab94832b0","text":"Kyiv lacks funds to pay pensions in territories occupied by Russia."},{"id":"1187ca34-8c0c-4b1c-976a-16d330b9a1d9","text":"A central communication port has been created to allow quick transfer of US military forces."},{"id":"8a0223ce-5203-47c1-8826-8e74e2722658","text":"Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and these cures have been suppressed for four decades."},{"id":"e54a4559-e9d6-48c9-a017-cff1ab133b9b","text":"COVID-19 booster vaccines shut down the immune response; COVID-19 vaccines frequently cause heart damage; SARS-CoV-2 mutations are being driven by vaccine-induced evolutionary selection."},{"id":"9956f2af-2c95-42b2-9bf0-14fe682b5743","text":"Oceans are cooling Earth far more than previously thought, so climate change is greatly overestimated."},{"id":"2b26ea24-872e-4ec5-a427-a6aa12dea564","text":"A protective levee on Ukrainian territory was damaged."},{"id":"e5e08180-87db-45fa-a95e-e49563fe5349","text":"Ukraine keeps foreign ships out of its ports by threatening to sink them."},{"id":"e9d28110-aba5-4fa5-908e-6d72615508da","text":"A plague epidemic is occurring among Ukrainian soldiers."},{"id":"7508530b-783f-411d-9df2-1d438adce45f","text":"French farmers threw manure at the Ukrainian embassy."},{"id":"d4cb7368-b061-4286-ae98-8c099d459934","text":"The US says the Bucha atrocities are Ukrainian propaganda."},{"id":"cc7c7297-bace-4c80-b48a-892456512083","text":"A Ukrainian bank threatened to restrict services for people evading military service."},{"id":"dd868710-2903-4168-a32e-3c94389e6277","text":"Ukraine deliberately released the coronavirus from the air to retaliate against Donbas."},{"id":"636cd023-52ad-4868-984b-0839d1caa1f4","text":"Methane from cow burps causes more global warming than emissions from all cars worldwide."},{"id":"5aa24293-2634-4bc7-8184-c66f3b745e03","text":"Moderna and Pfizer vaccines contain a bovine protein that triggers an autoimmune response in recipients and makes many of them unable to eat beef."},{"id":"47ac6884-7594-4b3c-b28b-dd503b885e7f","text":"Researchers at the Wuhan Institute of Virology assembled monkeypox virus strains."},{"id":"47ddaa30-cf7e-4d28-8391-89974b15a3b9","text":"Ukraine cut off water to Crimea, causing Crimea to dry up."},{"id":"884fe5f8-e7da-4e30-8eef-0008e873759c","text":"Ukrainians abandon Orthodox Christianity."},{"id":"f66fd859-6f7d-4fa0-9a96-67d8ff477e2e","text":"Crimean Tatar autonomy is a territorial autonomy."},{"id":"ce7f026a-0ab7-42e8-9442-e615ffeea978","text":"COVID-19 vaccine safety inserts state that no safety studies and no effectiveness studies were conducted for COVID-19 vaccines."},{"id":"fe4f65dc-a3fd-461b-84ef-a9aa528e82c3","text":"The monument to the main character of the film Vesna na Zarechnoy Ulitse was demolished in Zaporizhzhia."},{"id":"9f2be1e0-7a49-4ae4-a02b-8ac3b8365d35","text":"Madrid and Liverpool fans returned thousands of Champions League tickets because Kyiv raised ticket prices."},{"id":"19f7b638-83df-4a3c-81a7-526caaf85d66","text":"Ukraine is driving up criminal activity in Eastern Europe."},{"id":"43c50ec4-e439-41f4-9937-123ec169599c","text":"Unvaccinated children do not pose a threat to anyone."},{"id":"a250abd9-1826-412f-a0ff-1f5b933ec1c3","text":"All Lithuanian projects supporting Ukraine have failed."},{"id":"87e829e9-3f41-41b6-865a-127fd69177c7","text":"SARS-CoV-2 was engineered in a laboratory and deliberately released."},{"id":"ee4bbdad-e06e-4498-a6f0-64f0edb8dc41","text":"Ukrainian security forces are paid by Western governments."},{"id":"b61bf145-6023-438e-8892-d7fe96cbf12b","text":"Eating grapefruit while taking antidepressants causes overdose and other complications."},{"id":"3240aea3-0609-4219-bdd2-c1d543e1bcf8","text":"Chilean protesters carried Ukrainian national flags."},{"id":"e48da546-7868-425c-9c92-6ca48cd1a487","text":"CO2 does not cause climate change; temperature always changes first and CO2 increases always follow temperature changes."},{"id":"248a53ac-6338-45d2-b294-432225aa0978","text":"Human carbon dioxide emissions do not affect global temperatures, and carbon dioxide has had only a minuscule effect on the global climate."},{"id":"18a6f363-add3-4ef3-894a-3ed23100bf2a","text":"Cloth masks do not block smoke particles, and therefore cloth masks do not stop virus transmission."},{"id":"6fa2d0d1-6f7a-40e7-8398-fb85e5b82cc4","text":"Estonia admitted Russian air strikes on Ukraine were effective."},{"id":"b283c199-6181-456e-9548-cbc9398e3f20","text":"Carbon dioxide does not drive Earth\'s climate; Earth experienced an ice age when atmospheric CO2 concentrations were much higher; in the 1970s scientists predicted a new ice age."},{"id":"c85fb9ec-7fd3-4079-8d58-39fb63cb86a3","text":"Ben Carson endorsed CBD gummies and three natural ingredients that cure hypertension"},{"id":"54928d60-982d-458b-b1df-dd617491df23","text":"Stress causes Alzheimer\'s disease."},{"id":"befa7383-e680-4c0f-a73a-0c1202663765","text":"If the mother does not have hepatitis B then her baby will not have hepatitis B, and the hepatitis B vaccine contains 16 times the amount of aluminum the FDA says will poison a baby."},{"id":"caa71a9e-8f7d-4c80-ab0c-514b6f6e7216","text":"Excess folic acid in food causes ADHD and folic acid in food is a dangerous chemical."},{"id":"0f4b22b3-d4fc-450a-9924-e15aaf4b9442","text":"Vitamins C and D are part of conventional SARS-CoV-2 treatment; high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk and aids treatment."},{"id":"d35ddf8f-509b-4c52-bc51-6432c2886d19","text":"A Ukrainian rock star called for the destruction of Ukraine\'s current government."},{"id":"5e75ac83-0e72-4eb9-b360-4f96d0971121","text":"Ukraine is preparing a new provocation in the Kerch Strait."},{"id":"81fec1eb-625c-4d60-848e-8ca000fd8178","text":"Activated charcoal tablets counteract most date-rape drugs."},{"id":"c2775da8-b52b-47fb-9ddd-e0656524b475","text":"Researchers at Yale University created an airborne delivery method for mRNA vaccines."},{"id":"f507b61c-a051-4b9f-8bcc-79a61ce65340","text":"Hank Aaron\'s death was one of many suspicious elderly deaths that occurred shortly after COVID-19 vaccination."},{"id":"88201c49-6ff1-4a02-8d15-a1f664edea3c","text":"Eating turmeric every day reverses cancer"},{"id":"04433bf4-0d2c-484c-877f-9d4f6cb65107","text":"Smoking turns smokers\' lungs black."},{"id":"dec9b0ba-c532-47d5-8062-bbd1bbdefe52","text":"Ukraine will receive limited visa-free travel to the European Union."},{"id":"c7ad5ae6-dbaf-494c-95a5-b46572ceca18","text":"Previously infected people do not need COVID-19 vaccination because vaccination provides no additional benefit."},{"id":"3369d430-f133-4800-9272-9d969929d67b","text":"Hydroxychloroquine, zinc, and Zithromax cure COVID-19, so people do not need to wear masks."},{"id":"b018fbe7-8544-4332-ba21-4950fee2f922","text":"Most Ukrainians living in the temporarily occupied territories will vote for Russia in a referendum."},{"id":"14c32bd5-bf4c-4bf5-b6f5-b4ddde7d9f78","text":"Jamie Foxx was left paralyzed and blind by a blood clot in his brain after receiving the COVID-19 vaccine."},{"id":"3653bbad-8aae-4826-90c3-81bdda889097","text":"If testing stops, COVID-19 will disappear and people will only have common colds like before."},{"id":"193284f7-14c5-4d9c-8e56-212c1cd17dca","text":"Global ocean temperatures are cooling, therefore global warming is not occurring."},{"id":"3de76f19-d665-499c-b2d1-33d77a838ea7","text":"Pro Power Save reduces every American\'s electricity bill by 90%."},{"id":"81d51f18-45dd-4f7d-8b21-0ae61754d57a","text":"A children\'s combat battalion was formed in Prykarpattia."},{"id":"eb61dc70-90a0-40db-8941-a5be8f6affa5","text":"A Ukrainian gang stole chairs from restaurants in Spain."},{"id":"4993cc01-a9e2-43b0-9a24-1d572dcdf1e5","text":"A Luhansk People\'s Republic soldier threw himself, with grenades, in front of a tank."},{"id":"ba515b0e-2ea1-4f9d-8ac3-eb487cfd4c69","text":"Yulia Tymoshenko keeps a woman as a prison slave."},{"id":"0f4a0a6b-c03f-4344-8e82-0fefbe066b38","text":"A fire occurred at fuel tanks near Kyiv on June 12."},{"id":"aaa7a3f5-0c20-41cd-9c54-34a21db87608","text":"Cannabis treats cancer, PTSD, seizures, anxiety, glaucoma, and depression."},{"id":"c1469c73-28dd-42f6-86eb-7b0123a5227a","text":"COVID-19 mRNA vaccines contain unapproved genetically modified organisms that permanently change human DNA."},{"id":"e872ee90-7ce1-43db-9954-5bc1e98c9578","text":"A Ukrainian general said he regretted not covering Crimea with blood."},{"id":"05408880-be0b-4ed1-86ef-1a7deb3941ab","text":"Ukrainian government officials sell Javelin anti-tank missiles to Hamas and Hezbollah militants."},{"id":"233438ff-e7f2-403e-8e79-4a6bb8a95a7f","text":"Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins."},{"id":"2c80d572-cce5-492a-8922-2b19c8b63ed5","text":"The Government released plans to force a vaccine on everyone and three vaccines in the United States are in Stage 3 trials that will be ready in weeks."},{"id":"c462a189-d702-4e43-900c-b57b899d6a89","text":"6-year-old Russian child beaten by Ukrainians"},{"id":"9866bac3-581b-44b6-a4e7-1ccf90d18b98","text":"COVID-19 vaccines have killed 17 million people worldwide."},{"id":"ceb64b6b-cce2-4980-bae6-4c893cfb2657","text":"Ukrainians rioted over freezing conditions."},{"id":"e3977b85-1616-4434-91bd-a8e84a7e71b9","text":"Ukraine is preparing for war in Crimea"},{"id":"d98b2bbe-53e8-4b9d-99fe-b714fa78c6a1","text":"COVID-19 vaccines are unsafe and cause deaths from cardiac arrest and blood clots."},{"id":"bb7e0a93-6331-4144-a49f-07b27be8f1bb","text":"Ukraine\'s National Bank transferred gold and foreign exchange reserves to Poland."},{"id":"f1f60f4d-ae9a-4af1-bdc6-5c28c675e4e7","text":"Methane from cows is a small share of total greenhouse gas emissions, methane is produced without cattle, and cow methane is not an important contributor to climate change."},{"id":"45677884-cbf5-46a5-936a-122af027af00","text":"Antarctica\'s surface air temperatures have risen three times faster than the global average since the 1990s."},{"id":"0a9e01ca-6f1b-4017-a2c9-7527acdec277","text":"Crimean Tatars demand Crimea be renamed."},{"id":"4b4a0932-dd70-4145-9d99-b56763fa9e6d","text":"Ukraine shelled Zaporizhzhia Nuclear Power Plant."},{"id":"34b5c643-06c2-4d4e-849b-fb77fb222019","text":"75% of COVID deaths occurred in people who had at least four comorbidities."},{"id":"42a495a0-a980-41f2-bb9e-8a49e07109ea","text":"Ukraine destroyed its leading television channel."},{"id":"54df3866-f27c-4239-854a-62593827f591","text":"A Russian-speaking child was denied a St. Nicholas Day gift in Lviv."},{"id":"a2c70ee5-60cb-4bd3-bd27-1bfac59c5f91","text":"Austria will pay a \u20AC60 subsidy to residents of Chernivtsi."},{"id":"c8e7ced0-a72f-40a8-9ffa-8d8e90f67878","text":"Renewable energy caused the April 2025 Iberian blackout."},{"id":"ffd2327f-eff8-4537-9fa3-7c52a960359e","text":"Ukraine\'s Security Service ordered the destruction of MH17 crash evidence."},{"id":"de542820-8e61-478a-b085-807e52df765e","text":"Poppers cause Kaposi\u2019s sarcoma."},{"id":"2ddf7483-37b6-4da9-8291-aa683603eba5","text":"Children of Ukrainian refugees in Germany are being taken away for showing emotion and having an appetite."},{"id":"af9ecaff-9f51-46a1-964b-f7f8865e5396","text":"Phone use is causing horns to grow on young people\'s skulls."},{"id":"78087ce5-01cd-4ea3-9764-26eb8b921ac4","text":"Activated charcoal absorbs and neutralizes poisons and treats diarrhea and bloating."},{"id":"4e38a522-3536-4ad0-8f6c-4b1db9689668","text":"Cloth masks do not block smoke particles that are larger than viruses, therefore cloth masks do not stop virus transmission."},{"id":"6fcfcac3-6577-4f54-92dd-bb0e59016086","text":"A baby\'s immune system cannot safely handle eight different antigens in one day."},{"id":"f3f5217f-6ca7-4200-bdcd-07ad60e389de","text":"A US intelligence officer said Poland is contributing to the destruction of Ukraine\'s armed forces."},{"id":"77d2c66e-db4e-46a3-9b25-701be6bf0a1a","text":"Thousands of Russians are urgently leaving Ukraine."},{"id":"e735ae93-8403-47f7-ad21-b5fede472cc1","text":"Pfizer is part of Operation Warp Speed and its Coronavirus vaccine trial prevented infection in 90% of its volunteers."},{"id":"40acff92-a9e7-4df1-8fbb-1317803213f9","text":"The Kyiv government prevented Donbas residents from voting in the elections."},{"id":"289ce0e0-96f5-46dd-b968-e6e5fd75650f","text":"Ukrainian Armed Forces soldiers have not been paid for more than a month."},{"id":"b627b333-6038-4054-b5e2-0d4bc1e27736","text":"COVID-19 vaccines killed 410,000 Americans and caused 41 times more deaths than were reported to VAERS."},{"id":"9d9af1dc-5857-4a45-8ad2-0b4979470695","text":"Japan will release a new saRNA vaccine designed to spread to others without informed or any consent; the vaccine will spread to others and its saRNA lacks a \u201Cbreak\u201D and will remain in recipients and those it spreads to forever."},{"id":"88c2bd39-5a95-4132-9c00-18006843878f","text":"United Nations admits Islamists are present in the Ukrainian Armed Forces."},{"id":"c92063e1-297a-4953-abf7-9af0a32311d4","text":"Dandelion root kills 98% of cancer cells within 48 hours."},{"id":"7562f876-6caa-4f14-adc5-02abd33e5e84","text":"Tinnitus is the first warning sign that your brain is dying."},{"id":"4dcf71f4-ff2b-47b2-9b83-ba2022cf36fe","text":"A doctor\'s tweet about unvaccinated COVID-19 ICU patients originated from a bot network."},{"id":"0a5b80f4-cd56-4ef9-a369-8d29c328313a","text":"A study shows that receiving more COVID-19 vaccine doses increases the likelihood of getting COVID-19."},{"id":"f06ee571-4c93-42ba-8e35-dcb8339992b5","text":"SARS was developed by humans as a biological weapon designed to attack human beings."},{"id":"5ffa6906-1c8b-4f02-b90a-9e7356ae8163","text":"CDC data prove measles vaccines kill more people than measles."},{"id":"b150f9d3-20fc-4b13-9330-c4f66fc45e9b","text":"American tanks were found in Donbas."},{"id":"9f33a3cc-c5b6-4b80-abad-3adf992755cd","text":"Ukrainian ships caused the Beirut explosions."},{"id":"889531fc-03cf-4189-a945-48d098826533","text":"A Hitler salute cures coronavirus"},{"id":"b67e8f06-39fe-49ef-a8cf-d1df4128b1d9","text":"Renewable energy requires a separate second electricity grid."},{"id":"e3b5f6d2-bcc8-42bb-abf6-885b09b78db6","text":"Ukrainian border guards detained a Russian ship in Russia\'s territorial waters."},{"id":"eddc3e01-3718-471f-9ea7-07626e7057d3","text":"Dutch Prime Minister wants all referenda banned because of Ukraine"},{"id":"96a77054-65e6-45ff-816a-ab1b898675c7","text":"Ukrainian refugees in Italy assaulted Joseph Brodsky\'s granddaughter."},{"id":"fe000069-812c-4507-9580-f8eecbca392b","text":"Mammatus and asperitas clouds are abnormal and prove the weather is being manipulated."},{"id":"56510e96-92e4-4076-baf2-835ea275dbad","text":"Ukraine will store Russian nuclear waste."},{"id":"01be4f38-f05b-4974-bcab-e5868299420e","text":"There is no correlation between atmospheric CO2 and global temperature, and scientists do not know whether Earth will warm or cool in the future."},{"id":"ed833d09-6dc2-41d6-a4f9-da435295c537","text":"Flu cases fell 95% in weeks 40\u201341 from 2019 to 2020 because flu cases were diagnosed as COVID-19, which reduced recorded flu cases."},{"id":"b1accada-093d-43c5-b7d3-eb04ececbafc","text":"The Shevchenko statue in the Zaporizhzhia region was demolished."},{"id":"02271f73-601f-4078-938c-805a4a8122f7","text":"Videos of Russian military atrocities in Hostomel were staged by Ukrainian actors."},{"id":"5c7d6b44-a281-491f-8148-2f39874c5f2a","text":"10 million Ukrainians were denied the right to vote in Ukraine\u2019s presidential election."},{"id":"87659b3d-071c-4a7a-879b-c621f1f0beb7","text":"Hungary and Poland consider Ukraine a threat."},{"id":"32595345-7f9a-4856-a227-973a668f7e96","text":"Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and have been suppressed for four decades."},{"id":"1b25182f-7fc3-479c-936a-a502e7c94512","text":"Poroshenko is planning a military coup in Ukraine"},{"id":"d60fd050-3d43-4907-9ee7-1da0bace65fc","text":"Ukrainians requested electricity from Crimea."},{"id":"69a71a83-cb79-4f88-bb44-d17e73bf92b5","text":"A COVID-19 booster means the initial COVID-19 vaccination failed."},{"id":"392e62a5-a7ec-4cff-9b0d-efb168c40742","text":"Stopping all climate change efforts protects people from the coronavirus."},{"id":"2c6f1134-01fa-47b0-a16a-d57885b322f3","text":"A study showed COVID-19 vaccines are more dangerous than COVID-19, and children aged 12\u201317 are hospitalized for vaccine-induced myocarditis more often than for COVID-19."},{"id":"8de2fe6b-bd0b-41b8-80c5-eac870b0af94","text":"Climate models overestimated global warming and failed to predict the warming hiatus."},{"id":"798f64cb-f98e-4285-8fc3-cbd95f21d6dc","text":"Germany suspended all COVID-19 vaccinations."},{"id":"ec7648c0-1878-4b80-b6e5-468857c5bba1","text":"President Andrzej Duda spat on the memory of the Volhynia massacre."},{"id":"82943bb5-0b2c-42cb-8f02-07bfc2b2a864","text":"The UN gave Russia the right to seize Ukraine in 2014."},{"id":"4ff72245-dfa8-4c0a-90fe-ddbab51a81d8","text":"mRNA COVID-19 vaccines alter human DNA and cause cancer and autoimmune disorders."},{"id":"28a54058-7a57-4a0e-85d0-fc580597c4f4","text":"Human activities produce less than 5% of global carbon dioxide emissions and are not responsible for 30% of today\'s atmospheric carbon dioxide."},{"id":"6753501d-2f93-403c-9300-5cc88e1ecc45","text":"Western Ukraine will be transferred to Poland."},{"id":"c0530f11-be82-462f-b78b-57dcf8002039","text":"Vaccines and vitamin K injections given to children are unsafe."},{"id":"2dbdd359-30c0-4687-ab3d-23d20ba5cbf3","text":"Solar forcings were large enough to explain twentieth-century warming and caused as much or more warming than atmospheric CO2."},{"id":"c5e5d18b-d348-4e0c-8c43-be2146e4789a","text":"Ukraine buys gas in Europe at twice the price Russia charges."},{"id":"ab25bbae-f9d9-4b71-bf3f-ce806d3eba25","text":"The Dutch referendum is the last chance for Poroshenko to remain in power."},{"id":"7b1d64ea-3527-4de0-afd8-f30cb3a3f6b2","text":"The United States considers the Donbas war to be an internal matter of Ukraine."},{"id":"5746bac5-cac0-4591-bd14-cfe7908c85e4","text":"COVID-19 vaccines cause female sterilization by triggering an immune response that attacks the placenta."},{"id":"f6852e30-eb47-4b31-9574-a6facc863694","text":"Long COVID is solely caused by patients\' beliefs and is not a real physiological disease."},{"id":"25488b47-121d-4640-889a-0eccad4f7acb","text":"A train from Ukraine arrived in Russia loaded with mines."},{"id":"d05dc0bd-af7e-4d32-b6fa-034e06e5dae9","text":"Friedrich Merz will travel to Russia to attend the Victory Day parade."},{"id":"e71c2431-fd9d-430b-bbd2-c346441cb17d","text":"Oxygen kills cancer and Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer."},{"id":"1eed8ff7-d96d-4ada-8d10-b3124028ee33","text":"NATO refuses to accept Ukraine as a member."},{"id":"0d5d8f08-3d5a-40ce-af4f-0eeaad84a52d","text":"Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children."},{"id":"8292cee2-686c-42df-af55-b1d8e0ec513c","text":"Everyone who received at least one dose of an mRNA COVID-19 vaccine will die within three to five years."},{"id":"e33db651-3b18-40cc-abe4-da9191e830ca","text":"US corn crops produce 40% more oxygen at their peak than the Amazon rainforest."},{"id":"d2e525d7-93c0-42eb-8360-af54760ae196","text":"Vehicle emissions impact human health and the environment."},{"id":"0621bcc8-1579-4145-9367-cf14065d6b3a","text":"COVID-19 vaccines contain graphene and living organisms composed of aluminum"},{"id":"6ff0ed8a-2510-4702-9d75-236dac0a0ea5","text":"COVID-19 vaccines are experimental and ineffective; natural immunity is more protective than vaccine-induced immunity; the vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes protection from prior vaccination."},{"id":"c4be645d-460e-4708-b037-487f1c5d2f7e","text":"Volodymyr Zelensky promised to hand Crimea and Donbas to Western governments hostile to Russia."},{"id":"9b2a3bc3-989c-4621-b60e-7f9263e54455","text":"Ukrainian authorities served draft notices and confiscated cars in an enclosed village."},{"id":"63f2ea7d-e8c7-4351-a711-efc2f02fc18b","text":"French authorities suspended all Muslim police officers from accompanying the Olympic torch relay."},{"id":"f9a8a051-545e-4ab8-a8c8-6daa315e10c7","text":"Plant defense chemicals in vegetables cause autoimmune diseases, and removing vegetables from the diet improves health."},{"id":"2622c55c-6dc6-492e-9c76-fed941e88b72","text":"Every election year has a disease; SARS\u2011CoV\u20112 has a basic reproduction number (R0) of 2."},{"id":"76d2576b-bd1c-4b74-96f5-01ee074a5934","text":"Crimean residents are banned from entering the EU and the US."},{"id":"64032371-a7ba-48ad-b8b1-18a5ba134b49","text":"The COVID-19 vaccine caused Justin Bieber\u2019s Ramsay Hunt syndrome and resulting facial paralysis."},{"id":"0219cbf1-b872-4528-bd85-cbbe416b80f7","text":"Regulatory agencies were unaware that COVID-19 RNA vaccines contained residual DNA contamination that integrates into human DNA and causes cancer."},{"id":"fca6ac9e-d361-4854-b415-2de0951bc754","text":"Kyiv abandoned and deceived Moscow."},{"id":"ae4c6e50-616b-4f8a-bdd5-f4555ae934a6","text":"COVID-19 is less deadly than the seasonal flu."},{"id":"8c0e7cbf-ffa9-4239-bf4a-d8d6df9ac40c","text":"Ukraine is the country with the highest number of human rights violations."},{"id":"5e7bd35a-baeb-44b2-a16d-b60c1df9e9fd","text":"The Ukrainian Armed Forces attacked the Zaporizhzhia Nuclear Power Plant\'s power units using drones."},{"id":"8ae364b3-ce33-47e9-918f-7ffdf3ee8baa","text":"Nigoian and Zhiznevskii were not killed by the police."},{"id":"3ba5f1fe-f2b8-4a3f-a50f-c448784241d3","text":"A vegan world has no pandemics because 100% of pandemics originate from animals."},{"id":"df300336-658b-4086-ae14-485fb5a34ddf","text":"Drinking bottled water with an acidic pH is harmful to your health."},{"id":"eaad94ff-bd80-4fd8-80eb-73bc91733ef4","text":"A Washington poster urged Ukrainian President Volodymyr Zelenskyy to wear a suit when meeting Donald Trump."},{"id":"4609b2a2-a2ae-43cc-9923-727688da9367","text":"Ventilators, not COVID-19, killed hospitalized COVID-19 patients."},{"id":"0ab31eb2-c453-462e-864c-67db91d89971","text":"Bloomberg published an infographic showing Ukrainian President Volodymyr Zelensky looted France."},{"id":"79e0bdee-4367-4ccb-925b-4a68d5d48496","text":"Zelensky accused the West of killing people and said he will recognize Crimea and the separatist republics."},{"id":"4af09982-8d8a-48e3-a946-5daba0922eb8","text":"Ivermectin is the only treatment for COVID-19 at all stages; ivermectin substantially reduces COVID-19 deaths and prevents COVID-19 infections; fifty studies show ivermectin is highly effective."},{"id":"7d8d1aea-8234-448c-a5d8-52bb4687e454","text":"A vaccine crew in an Indian village was attacked by locals."},{"id":"892e9d38-0e8a-4b15-85a9-1e6e5b23d048","text":"Ukraine imprisons Russian-language teachers."},{"id":"6edb00cd-67c9-453f-9f97-60afdcd6a42c","text":"Most recent global warming is natural."},{"id":"7e807de9-50c0-439a-a289-0edd457e87e9","text":"Recent footage is authentic and shows tornadoes and storms that occurred during Hurricane Milton."},{"id":"b59fb6dc-a5bc-4346-969d-2cf675782c1c","text":"Ukrainian tourists are flooding Crimea."},{"id":"6ca8951e-e9b5-4321-8da4-b726da450889","text":"Poroshenko threatens to arrest protesting airport staff."},{"id":"9fb6cd45-2db9-43c8-9bc3-0779b7469d45","text":"International organizations refuse to investigate the Bucha atrocities."},{"id":"b8f71142-3e18-4304-8070-e5d6d08b296a","text":"Video shows Ukrainian military vehicles near Mariupol."},{"id":"47e640c2-82eb-4653-92e5-07ae59509b76","text":"Trees solve almost all environmental crises and reverse climate change by removing carbon dioxide from the atmosphere."},{"id":"3f97382e-d99f-450a-9369-8adbeb773ecc","text":"Ukraine will cancel the child care allowance."},{"id":"52c8222b-3d76-46e5-b60a-b85f3c7baf1d","text":"Birthmarks indicate the MTHFR gene; people with MTHFR cannot detox toxins from vaccines and therefore have increased risk of vaccine reactions."},{"id":"1df7f2a1-fccc-4c21-b7e4-88712ef38283","text":"Three Ukrainian nationals were arrested in Germany for plotting sabotage."},{"id":"6c5f9c30-c193-49c0-b20a-6f45e386c7ed","text":"Ukrainian Commander-in-Chief Zaluzhny is preparing a military coup."},{"id":"9e080cc5-5797-4083-b742-3b096c9ce450","text":"Russian media published exit poll data from the Ukrainian presidential election."},{"id":"534931bc-6d69-4c7a-ad1d-821a8cd2f627","text":"Congress says Americans no longer want to support Kyiv."},{"id":"fa70beaa-6f87-4adc-9813-f283ce73b91e","text":"Polls show people do not believe Russia shot down Flight MH17"},{"id":"94b33dd3-107b-47a2-b91c-ae0845ae8039","text":"Masks and lockdowns do not slow the spread of COVID-19."},{"id":"5000ccbe-1bb2-47e0-ba91-d263e7a46419","text":"Deforestation has increased human vulnerability to pandemics."},{"id":"baa77af1-ba9b-4659-b322-e5de504c6178","text":"The World Health Organization officially declared that bacon is as harmful as cigarettes."},{"id":"7c6ad0f4-14ce-4d78-94d8-83ef080fb481","text":"Poland has ceased payments to Ukrainian refugees in 2024."},{"id":"138995f7-0879-442a-b0d2-b865adc91c1d","text":"High cholesterol is good for health."},{"id":"4f2b6c36-9cdb-49ec-816c-48a4d58bb10e","text":"A Nature study proves all mRNA COVID-19 vaccines cause heart damage."},{"id":"40a982f6-97dc-40a4-87ee-10c3678e2aff","text":"Dnipro is part of the Russian World"},{"id":"d827bf21-86e5-4fb1-ad29-39bfc2d54d43","text":"VAERS received 3,916 COVID-19 vaccine adverse event reports in December, including 13 deaths."},{"id":"c58c1e7a-b29c-4ec9-b3ef-3537279058d8","text":"A Lviv officer proposes annulling the Ukrainian Order for Courage."},{"id":"c4719ddf-1f52-4f07-bb29-0d833c19f06b","text":"Bill Gates-funded company released genetically modified mosquitoes in the U.S. and caused a malaria outbreak."},{"id":"7b51a335-2503-469a-88f3-cda13616b9e8","text":"50% of Ukrainian refugees will stay in Poland."},{"id":"e000b420-269b-448c-a2f7-943c5b34854a","text":"China rejected imports of Ukrainian grain."},{"id":"4a53148d-ff1c-426e-8962-939234581f1f","text":"Published secret documents show Ukrainian troops committed violations in Donbas, and no one is investigating."},{"id":"ee505ac3-6796-4bb2-a0ed-5d00cdc42d4f","text":"Ukraine deliberately cut off water supplies to occupied Luhansk."},{"id":"2a60862f-4676-4117-a700-51ec4db2da9b","text":"The U.S. Secretary of State\'s visit to Ukraine proves Ukraine has no chance of joining NATO."},{"id":"11105bb6-ed0f-4fcd-a9eb-507388a5e2c6","text":"Ukraine denied accreditation to German election observers"},{"id":"4a03d036-31bd-4d0d-bdc1-010d2be0e2a4","text":"Moringa supplements lower cortisol levels and improve overall health."},{"id":"dea84b7d-89ec-48fe-bb58-8ba341aee989","text":"The number one indicator of parasitic infection is an autoimmune condition."},{"id":"a0cf568d-cab6-4149-85ef-a7ace346f042","text":"Ukrainian authorities are dooming the population to starvation."},{"id":"5197f13c-5955-4609-a641-0d2e9825af37","text":"Only six Crimean citizens retained Ukrainian citizenship."},{"id":"4fb0c3bc-6136-4ead-aa3c-701399394a77","text":"Crimeans voted to join Russia because Kyiv abused the peninsula."},{"id":"efaff54b-9926-441a-8582-c63bcf40ee5c","text":"The CDC withdrew authorization for its 2019\u2011nCoV real\u2011time RT\u2011PCR test because that PCR test cannot distinguish COVID\u201119 from influenza."},{"id":"33b4407e-d332-42ad-91c7-64004f5a7b83","text":"Sergey Lavrov said Russia is not a party to the armed conflict in Ukraine."},{"id":"2c901d23-150e-4236-8a3a-50459096c99f","text":"The Ukrainian national football team will be disqualified from future matches."},{"id":"d9be58a0-d2d3-466d-8ef6-4dda4cadc6fa","text":"Eating only meat provides a balanced diet."},{"id":"4b6aefc8-c4b5-4a7d-8b0f-634abda80c7b","text":"Blood pressure tracking apps can replace blood pressure cuffs"},{"id":"d32bd84c-757a-4910-a052-31805fd4d204","text":"Petro Poroshenko deprived Chornobyl workers of benefits."},{"id":"0928ff9e-d79a-4243-bd9a-1c711d3e7e2c","text":"Lemon balm neutralizes and destroys all avian influenza viruses, including H5N1."},{"id":"09595d71-6353-4b5c-9c69-95f7da285a30","text":"Austria agreed to pay Russia for gas in rubles."},{"id":"2da32b38-298f-4187-9aef-c0fdd8659496","text":"Vladimir Putin caused the rouble to collapse to trick Western financial sharks."},{"id":"d5b18d91-f404-42c4-9bbb-59aaf2defba4","text":"Climate scientists disagree about how much warming human emissions caused and whether that warming is larger than natural variability from the sun and volcanic eruptions."},{"id":"451ce3f4-9e07-474d-a871-c38155df8b9c","text":"Nadiya Savchenko advocates granting amnesty to Donbas separatists."},{"id":"5f1e3bac-6dca-43e4-8fd4-6f7088dde238","text":"The German Bundestag called for lifting sanctions on Russia to fight COVID-19."},{"id":"872fb8c6-d9b3-4096-a4f8-dcf966b50b66","text":"Romanians in Bukovina demand autonomy"},{"id":"fff5600f-7263-4f2a-a699-8321f3952aa5","text":"Ukraine is threatening to invade Russia."},{"id":"8b19bb1f-9fef-43b2-bd11-62c825845e92","text":"Bananas are powerful antiviral foods that repel growth of the retrovirus HIV."},{"id":"da752397-c4ec-4920-9b38-287c09c8e89b","text":"DMSO treats cancer"},{"id":"d80dd363-e12d-4d2f-8f1a-db6890357214","text":"A recent bleaching-level heat stress event bleached 84% of the world\'s coral reefs."},{"id":"2e492606-e466-48b4-aedc-a8ac48cd73cf","text":"Ukrainian forces committed a terrorist attack in Russia\'s Voronezh region."},{"id":"f29187c8-eb55-4d89-9dfa-d5458589188d","text":"All pandemics are zoonotic, so a vegan world would have no pandemics."},{"id":"09bec78d-5110-4d94-8abd-ca8fbc8d8f34","text":"U.S. mercenary Sean Fuller was killed in Donbas."},{"id":"9cfe1e4d-1693-459e-9c1c-c014e781555f","text":"Lion\'s mane mushroom prevents Alzheimer\'s disease."},{"id":"33b7ef54-4581-4500-860a-a13826f64a39","text":"Ukraine loses economically from trade with the European Union."},{"id":"18442cdf-bce1-43b8-99ea-d8e0429ad039","text":"The COVID-19 vaccine killed 3.5 times more Americans than the COVID-19 virus."},{"id":"b3eff245-6e8e-462c-8370-fca16fc417ee","text":"Ukraine will sell Crimea to Russia for $135 billion."},{"id":"0f32623c-391f-42b0-9618-700e47645440","text":"Salt and corn gluten meal are used to kill mice and are hazardous to humans."},{"id":"49c1f390-e9fb-4153-bdfa-9523ca30b466","text":"Solar cycles and other natural Earth activity cause climate change; human (anthropogenic) CO2 emissions do not cause climate change."},{"id":"787f85bb-e1f6-4800-9a1a-2a143f27635b","text":"Kherson nationalists publicly swore allegiance to Adolf Hitler."},{"id":"4db4f4b2-6be4-43ee-b0e9-6950caea365c","text":"Herpes is not a sexually transmitted disease. A commercially available plant product cures herpes."},{"id":"1c59d865-0600-4652-bd1b-24003bbf9063","text":"The UK transferred uranium shells to Ukraine, constituting nuclear escalation and a new outbreak of aggression."},{"id":"a8898146-49d8-4213-a28e-7646819d8e37","text":"CyberBerkut blocked the Central Election Commission of Ukraine from carrying out its work."},{"id":"7e9ce10c-485a-40aa-9db8-80a972b9f762","text":"Sea level at Sydney Harbour has not risen at all over the past 140 years."},{"id":"0ac9f2c5-f7be-4379-9ba5-d77b1f76eda0","text":"Vaccination caused autism rates to decrease among high-income white households in California."},{"id":"6e278d9d-efbf-4498-83fa-1fe9f5c2e1ef","text":"Crimea and Donbas residents are being deprived of all rights because they hold Russian citizenship."},{"id":"fb06f2e9-4a84-4eec-9327-1e0ec4232f45","text":"Ukraine is being used as an experimental site to grow babies artificially."},{"id":"cc86da79-f5da-4544-b667-9acac7afd2d7","text":"Ukraine granted dual citizenship to Western lobbyists."},{"id":"6df9da21-3633-4a31-899a-c18d5a69ac05","text":"The United Nations demands that Ukraine recognize occupied territories."},{"id":"9372ddb4-9364-4499-a45d-a91c3a32204a","text":"The Federal Government of Germany provoked Russia with its actions regarding Aleksey Navalny."},{"id":"6cfd4a3d-ea37-4a6a-b31d-f33126fb7074","text":"Ukraine is no longer an industrial nation."},{"id":"a57a7b65-84fb-4307-87f7-edd4e6d83093","text":"Babies born to mothers vaccinated against COVID-19 are dying at higher-than-normal rates and the COVID-19 vaccines are causing those deaths."},{"id":"0ea2c3ce-0390-4a37-82e7-05c488f9d60e","text":"Fukuyama claims Ukraine will not be able to return all of its territories."},{"id":"3ac17d3b-d75f-40de-9ab2-25772920000d","text":"One thousand people in Sofia demanded that Ukraine stop repressions."},{"id":"84a41b1d-8742-4138-a07a-b4c11ec752ea","text":"Post-vaccine deaths cannot be categorized as vaccine-related."},{"id":"7afe7a05-2d10-4c12-9bcb-b81942115741","text":"Most fully vaccinated people will develop vaccine-induced AIDS by the end of the month."},{"id":"a81e0dc4-7ff4-413f-b7e8-35e9f1f338bf","text":"The European Union refused to punish Russia for seizing Ukrainian ships in the Kerch Strait."},{"id":"9ef16cc8-7e0d-46af-be53-ad39ca0f324d","text":"Sanctions imposed by Kyiv on Russian banks have worsened Ukraine\u2019s investment climate."},{"id":"16eaef10-f0e6-4c6a-aa10-29e89fbc15cd","text":"The Red Cross collected data on the healthy organs of children in Mariupol."},{"id":"a039a1cc-be4d-41c4-9557-fd273854d9a9","text":"Cancer rates increased after COVID-19 vaccines were introduced, and this increase is causing U.S. life expectancy to decline."},{"id":"1c8b8a47-732c-43bb-bdd5-1258d42e81d3","text":"A death at a checkpoint was caused by a Ukrainian provocation."},{"id":"3b1e8ff2-88e8-4208-84df-1b20791750f8","text":"Russian flags were flown in Kyiv by mistake."},{"id":"7d507146-82d8-4c8a-bc28-2ea93cb69515","text":"Obama asked Poroshenko to invite him to Crimea."},{"id":"5ef6a303-44eb-4d39-849c-0f5399eea698","text":"Ukraine\'s Foreign Ministry accused the European Union of betraying Ukraine."},{"id":"fa707004-3fa0-4ba3-bd14-64362927704f","text":"COVID-19 vaccines are being administered incorrectly."},{"id":"a7ddd415-7366-41e4-aa1c-66bee62b8998","text":"Tattoo ink contains cancer-causing heavy metals, and zeolite removes those heavy metals from the body."},{"id":"fd15a0ec-5782-4364-bac0-06c385094698","text":"Ukraine is opening camps for Syrian refugees."},{"id":"c1ad018a-74d6-4483-a5d2-5098ed285a05","text":"COVID-19 vaccines are causing embalmers to find strange clots in corpses."},{"id":"5a67a1b2-e1a7-4007-b512-ea59976dc055","text":"Ukrainians want to go to Russia and demand trains to Crimea."},{"id":"cd554ad0-b8e4-4c20-bad6-335ae10b2602","text":"Ukrainian military cannot operate American weapons."},{"id":"37aa0a4d-96f8-4e27-b36e-4024e3864c72","text":"Ukraine wants to exchange Crimea for Transnistria"},{"id":"e53cd62b-8645-4b7a-b430-ce6122331fb2","text":"Since COVID-19 vaccines were rolled out, a midwife has observed that all placentas are abnormal and compromised."},{"id":"c02460c1-0520-4c75-84be-9c755ac23b1e","text":"The Ukrainian military shelled a bus stop in Donetsk."},{"id":"85df2a88-2a1b-4add-b62c-7f93fd934a54","text":"Ukrainian authorities drained the Dnipro River to deploy armed forces on the left bank."},{"id":"22f58df3-30ac-4a5a-b495-5e67661f640c","text":"The survival rate for COVID-19 is 99.96%."},{"id":"1ebf5a57-2440-403a-8554-c1001c540572","text":"Carbon dioxide is not a primary contributor to global warming."},{"id":"0aead5cb-0afd-408e-84e1-61cb9f170296","text":"Jacques Attali wrote that elites will create a pandemic to reduce the population and will have planned its treatment."},{"id":"8e5a3ad3-1aa6-409c-ab9b-fc489f9382db","text":"Poroshenko was booed and whistled at by students in Zurich."},{"id":"8af9fe56-8608-4393-a401-af9d66e91000","text":"The Maidan protests and the economic crisis caused a tuberculosis epidemic in Ukraine."},{"id":"5c111c5d-345a-47cc-aa7e-7a23939e591f","text":"A Defense Ministry secret document reveals the actual losses of the Ukrainian Armed Forces."},{"id":"da844889-0038-48d6-86cb-6d9b61e61930","text":"Climate change is making extreme weather events, including tornadoes, worse."},{"id":"e41219e5-2040-4608-8215-0569f837116a","text":"Eighteen climate proxies show the global temperature 1,000 years ago was the same as or higher than today."},{"id":"7c2df117-bdf8-40bf-9218-92cd2f77ba5c","text":"Lviv demolishes WWII Glory Monument"},{"id":"1a7bc4ac-0bb9-4cd0-8bc4-036789edc05a","text":"Ukrainian Armed Forces are not resisting the Russian invasion."},{"id":"7557180a-4ac9-4628-96e8-204eb76c9bf0","text":"The United States reported 144,305 new COVID-19 cases, breaking the prior record of 133,819 and marking eight consecutive days with over 100,000 cases."},{"id":"c0f5cf9d-a8e7-4d14-b270-ecf2b1e28b18","text":"Carbon dioxide does not control the climate."},{"id":"54eb5796-9234-49ee-be60-347e01fcc1ab","text":"COVID-19 vaccines caused monkeypox; a 2021 tabletop exercise that simulated a monkeypox pandemic proves global leaders planned the outbreak; the monkeypox vaccine was ready before the outbreak."},{"id":"1f822cee-61f8-490f-a3e0-c7b75b886176","text":"Ukrainian refugees burned a Russian flag and set fire to a house in Germany."},{"id":"06f2d0e1-a21b-42c4-aa82-dd44d72b861c","text":"The FDA allows doctors to prescribe ivermectin for COVID-19."},{"id":"38621482-5b2d-44c7-820b-adbf9eeb1d63","text":"Nuland warned Surkov that a NATO attack was inevitable."},{"id":"8a68573f-ced9-4549-8420-46bdc3e8c365","text":"Ukraine\u2019s president Volodymyr Zelensky acknowledged that Ukraine lost the Donbas region."},{"id":"ce09d69d-f830-46e0-a0d5-5a50cc945bfd","text":"All Ukrainian refugees are willingly going to Russia."},{"id":"029e74b1-c638-46b1-82bc-3be5a9105c5a","text":"Kyiv is one of the 10 worst cities to live in."},{"id":"2cc7310a-7239-4ade-ad8c-0f7f34d5682d","text":"University of Turin recognizes Donetsk People\'s Republic diplomas"},{"id":"477b9d42-dc00-4000-a353-401ae75ac446","text":"The Azov Regiment attacked a humanitarian convoy."},{"id":"03e43ffc-e726-413c-8514-d3dc64faac25","text":"Ukrainian military shelled OSCE monitors."},{"id":"a539a6f3-3066-4ea3-b176-0ea440f6d871","text":"A nuclear explosion occurred in Ukraine."},{"id":"dfdbdefd-0ea3-4791-9a19-883176ce0520","text":"US regions with higher average COVID-19 vaccine doses experienced larger increases in mortality in 2022 than in 2021."},{"id":"a842755b-f32f-4ffc-bb0e-fb7c12eed55e","text":"COVID-19 vaccines weaken the immune system and an Idaho doctor reports a 20-fold increase in cancer among vaccinated patients."},{"id":"7ea6e1af-a1ab-4574-b2a6-de810666c3bb","text":"NOAA alters climate data using complex statistical models so the data reflect NOAA\u2019s global warming theories rather than reality."},{"id":"dcc9ad82-adaa-4277-832f-40fe07e07e4e","text":"COVID-19 vaccines have caused as many deaths in young people as COVID-19 disease has."},{"id":"f0e557a3-c422-4388-81df-60332a604a31","text":"A memorial plaque in Kyiv was destroyed."},{"id":"98d2a36d-e4c8-4788-be7b-251ef8ed3e69","text":"Antarctica\'s perimeter is larger than Earth\'s circumference, proving Antarctica is an ice wall and the Earth is flat."},{"id":"f30c2aba-14a3-47f8-8eb3-31bf2697ec10","text":"Kyiv deliberately caused a blackout in Moldova."},{"id":"8c2695a2-b90b-4d90-8cd7-4fd1a95e9915","text":"The United States supported federalization of Ukraine."},{"id":"7f38bd49-2b61-4485-ad92-826f4622b98a","text":"A RAND Corporation document shows the US planned to cause a conflict and an energy crisis in Europe."},{"id":"6a0b5371-4a1d-4a33-9cf2-6ed229397386","text":"The Bucha atrocities, the chemical attack in Syria, and the White Helmets\' rescue operations were staged by Western governments."},{"id":"d803c8a8-1959-4a78-9323-dac5106fa3c8","text":"Zelenskyy expressed condolences and urged Turkey to supply Ukraine more aid."},{"id":"fa08c157-a681-4a26-b553-93c830dee2e0","text":"The American Medical Association reversed course and authorized doctors to prescribe hydroxychloroquine for COVID-19 patients."},{"id":"09be098b-2ee2-4d5e-8bf2-c10d759502be","text":"Oral contraceptive pills are the leading cause of polycystic ovary syndrome, and wild yam combined with castor oil cures polycystic ovary syndrome and uterine fibroids."},{"id":"a237951f-5603-4b3d-98f5-4530944e0799","text":"Hundreds of children were killed to create COVID-19 vaccines."},{"id":"9f82b403-f37d-47ae-b12d-954966d567d8","text":"A Ukrainian refugee drew a swastika in a British mall."},{"id":"067bb5eb-6d31-4dfa-8cbd-19615eed89ba","text":"Receiving the Pfizer COVID-19 vaccine increases the risk of getting COVID-19."},{"id":"83761374-b6a9-40c4-8a0b-42763aea2d5e","text":"Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins."},{"id":"a05b5678-a8bd-4b6c-80a4-7d6b295509ee","text":"An American COVID-19 vaccine killed a Ukrainian serviceman."},{"id":"b921b051-537d-408a-a1eb-67b0ab77f0f0","text":"The first AI-led peer-reviewed climate science paper confirmed that climate change is a hoax."},{"id":"ad77754d-a55d-4863-ab2b-c74d01f22f96","text":"A Ukrainian airliner that was downed in Iran was controlled by the United States."},{"id":"5aabbe3b-4ee1-4cf5-a307-e5972d7d441a","text":"Minors in Ukraine are eligible for military contracts."},{"id":"4849399f-d01a-4947-8d84-70e6370761b4","text":"Kyiv expelled homeless people from the city for Eurovision"},{"id":"4672ae95-fe94-4529-992a-9bd9f2450237","text":"Russia threatens Ukraine\u2019s civilian population."},{"id":"50dc1fd1-29df-4667-a38c-9cca6c573245","text":"The HPV vaccine increases the risk of developing cervical cancer."},{"id":"4bce2060-09d4-4098-b63b-f9dc678c472b","text":"A missile serial number confirms that the Kramatorsk train station was hit by a Ukrainian Tochka\u2011U missile."},{"id":"e1b163ae-328d-4f1c-8421-612b4cb01a03","text":"Ukraine\'s Parliamentary Speaker calls for a new Maidan."},{"id":"41762dec-9af9-454b-a084-74fdb6d5933e","text":"Ukraine threatened Russia with war."},{"id":"f991e96c-ee58-44c3-8da5-9f2e65dff516","text":"Terrorists were arrested in Crimea."},{"id":"c0397fd6-d957-4664-938f-51c149f52869","text":"Fitch issued a disappointing forecast for Ukraine."},{"id":"cb5c1d3f-6abb-4d7c-9539-5794000724f8","text":"A Ukrainian plane was shot down in Iran because it carried Iranian nuclear physicists."},{"id":"20b20009-55af-45e1-ad7a-f77568f0d0ec","text":"Poland blocks cargo transports from Ukraine to Europe"},{"id":"d8927e01-bf42-48d9-87be-c2a1007db420","text":"The government of Ukraine refuses to respect human rights in the southeast of the country."},{"id":"366f952c-f98a-4fa4-91bd-ea7fc8f9828f","text":"The President of Poland called for the return of Ukrainian territory to Poland."},{"id":"07e907bf-4736-4110-94d6-ad50986f0520","text":"A Ukrainian activist called the September 11 attacks \\"God\'s punishment for Americans.\\""},{"id":"abc78ee6-9a74-4c31-b3fa-aaf984c98e07","text":"Women are not warned that their daily steroidal hormone pill causes blood clots."},{"id":"457886fa-6643-4453-924e-55c6694e6c9a","text":"Measles prevents cancer and provides long-term health benefits."},{"id":"a322dc3b-9865-4443-be3c-f9fdea386fe7","text":"Ukrainian military beat Andrey Makarevich at a concert in Kharkiv."},{"id":"1771bf97-ae85-40bb-8e02-f07fe11ffe91","text":"Polish students attacked a Ukrainian schoolgirl."},{"id":"6a58e3a8-8d21-459e-b42f-19871735ddae","text":"Ukrainians demanded ransom from the family of a deceased Hamas hostage."},{"id":"6c5a5880-c721-4166-84f9-b9f10b46d797","text":"A South Korean study found that COVID-19 vaccines increase the risk of cancer."},{"id":"a08d6e56-7f7e-47cf-81de-e8122a610abd","text":"Ukraine exported grain to Western countries and did not export grain to needy African countries."},{"id":"ad7a9f0d-ae4f-40bf-bf11-ecd7d8e1a2cf","text":"Most Ukrainians consider the Donbas conflict a civil war."},{"id":"37581388-5272-4892-bce8-93f42575e2da","text":"Coronavirus spread rapidly worldwide in October 2019."},{"id":"420426ac-d677-4e71-9409-3c580a810304","text":"The European Union no longer trusts NATO or the United States."},{"id":"51c31872-6c22-496d-8db0-350086738cc9","text":"Ukraine is preparing a Bucha-style provocation using Supernova Airlines passengers."},{"id":"9da039ab-cd2c-4ac1-92f9-5bb3b0ac032e","text":"The European Union seeks to improve relations with Russia at any cost."},{"id":"0853fabd-817d-4700-8463-b223b3d9a9a3","text":"The Pfizer COVID-19 bivalent vaccine increases the risk of stroke."},{"id":"551f6a3f-7ee1-4220-9218-10240e4e6736","text":"Tillerson said the United States will recognize Crimea as Russian if specified conditions are met."},{"id":"2b1cccb7-07df-443d-b883-4aeab0541083","text":"Kyiv forcibly drafted ethnic Hungarians."},{"id":"b64b0df8-d092-4873-b18e-8ee940b1188f","text":"The Lviv Jazz Festival was cancelled due to uncollected garbage."},{"id":"dd28c9e1-3524-4de6-bbf3-2db2158124db","text":"Covid-19 vaccine effectiveness fell from 100% to 20%; early reported vaccine effectiveness figures were lies."},{"id":"b3fb1932-a775-4fed-9c1c-8d700ed98f3c","text":"Renewable energy is not green: by 2050, 78 million metric tonnes of solar panels will reach end of life and cannot be recycled."},{"id":"24fda3b8-a767-431b-a557-22af840dd04f","text":"Arseniy Yatsenyuk sided with the Right Sector in the Zakarpattia Oblast conflict."},{"id":"311bd324-53e2-40c0-a0e9-129aa64d4542","text":"Ukrainian President Volodymyr Zelensky calls for a preemptive nuclear strike on Russia."},{"id":"394b3ed1-93cf-4622-86bd-45daf5632dfc","text":"Islamic radicals are flocking to southern Ukraine."},{"id":"4f28cf1b-eeb4-4f98-9d72-3d16d8a364ab","text":"Andriy Parubiy was behind the Maidan shootings, the Odessa Trade Union arson, and the Ukraine coup."},{"id":"7cce2a59-de6c-45b5-9890-bb26bd782446","text":"Documents show Crimea belongs to Russia."},{"id":"84180699-3401-4067-a323-c18de91df8a0","text":"Eating onions cures RSV and makes you sleep at night."},{"id":"ffad9e9c-f463-432b-922c-b04a447efd4c","text":"The Ukrainian authorities demand the extradition of an EU Member of Parliament."},{"id":"6bb78db7-bfa8-4e89-a5a4-231579174345","text":"The exact same group of experts who claimed there was global cooling in 1977 now claim there is global warming."},{"id":"540ecfcd-d63c-4a16-8fc4-99bed69936b7","text":"The CDC admits that being fully vaccinated does not protect against the Delta variant and increases infections."},{"id":"76d3150d-566a-437c-a07b-ba31f7754271","text":"An FDA study found vaccines made in living cells are contaminated with hidden viral fragments that cause cancer."},{"id":"04565754-2efa-4a04-ad4f-47a3b69df633","text":"Poland recognizes Crimea as part of Russia"},{"id":"45988828-987d-41f9-9910-a69e0b6b266c","text":"Bill Gates is pumping mRNA into the food supply to force-vaccinate unvaccinated people."},{"id":"8184bdb0-d238-4442-b9e4-88964c551e5a","text":"Ukraine refuses to claim custody of its prisoners of war held in territories occupied by Russia."},{"id":"f7f4494c-d23f-46bc-95ad-55e481020949","text":"A Ukrainian general predicts Ukraine will lose control of the Sea of Azov and the Black Sea."},{"id":"8d0e5935-493d-40dd-86c0-2179f8a97908","text":"Recent climate change is normal because past hot and cold periods occurred, and future climate change cannot be predicted because weather cannot be predicted accurately over days to weeks."},{"id":"d870ab1b-50ae-4474-a007-a3b3b7ede249","text":"Official figures show mean global temperature declined over the past 10 years."},{"id":"665223ae-15a5-40d1-b029-3082c0364604","text":"COVID-19 vaccines are causing a massive tsunami of COVID-19 hospitalizations and deaths through immune escape, and vaccine-induced immune dysregulation is turning COVID-19 into a chronic disease called long COVID."},{"id":"9faf8cdb-f734-4c8b-a184-83176178c4e1","text":"European governments accuse Ukraine of flooding the EU with heroin."},{"id":"35a9dcf0-4cae-42aa-ad49-b78de8e6a2de","text":"The Ukrainian Army deployed Polish soldiers to Donbas."},{"id":"76f38dc8-7183-4718-8907-c647e8fb8b2e","text":"Mass COVID-19 vaccination caused the excess deaths observed through 2022."},{"id":"7a922f37-4c04-4b1a-939d-f05336063961","text":"HAARP deliberately creates global-scale earthquakes, cyclones, floods, and snowstorms and deliberately attacks the world\'s citizens by telepathically influencing their thoughts with low-frequency vibrations."},{"id":"b156d810-c926-4b49-93be-bbd349028310","text":"Zhytomyr city authorities called on residents not to oppose the Russian army."},{"id":"4c9db928-374c-4dd7-a717-f789724effe9","text":"Cow milk contains the most relevant carcinogen ever identified and triggers cancer."},{"id":"c9c854e8-b4e4-4054-bf94-68d3c8d21c91","text":"Gargling with warm salt water or vinegar eliminates SARS-CoV-2."},{"id":"0813d21f-b8a9-46d0-852c-e35d7a6b2107","text":"Ukraine plotted the assassination of French President Emmanuel Macron."},{"id":"0f1302f3-58b6-4c74-b747-90a0f169b860","text":"The Ukrainian hryvnia will collapse."},{"id":"6513150c-e717-4597-8bda-c069fd2ec66d","text":"Poroshenko blocks visa-free entry of Ukrainians to Russia."},{"id":"78dd7176-866b-40c3-ac5b-ac8a56744bbe","text":"Ukraine solicited funds to host Eurovision 2017."},{"id":"68058236-e8a0-4c0e-8ea8-4e9fbad8892e","text":"US state governments have banned chemtrails, confirming that secret government programs use chemtrails to harm the public and the environment."},{"id":"021a2b2d-f94d-4d7f-a79b-98cc50562a16","text":"COVID-19 vaccines are unnecessary because vaccinated people still get COVID-19 and are required to wear masks."},{"id":"94b7d2a0-309a-4377-b78e-9387cb60a617","text":"COVID-19 vaccines are sexually transmitted to unvaccinated people, cause blood discoloration, and weaken the immune system."},{"id":"87fe6fe7-6741-4b4d-a004-7c63f9e8fc69","text":"Robert Fico, Viktor Orban, and Aleksandar Vucic\'s approval ratings increased after their trip to Moscow."},{"id":"7a567ea2-81b6-420f-98b5-f699eaedb85a","text":"Ukrainian troops killed a separatist defector."},{"id":"0fe90583-3a97-4b9a-b64f-8acba9619caf","text":"Russia\'s war in Ukraine conforms with the UN Charter."},{"id":"1e7778f2-669a-4098-9803-8a2c8c4f2bda","text":"Ukrainian President Volodymyr Zelensky will legalize Poland\'s seizure of Ukrainian territory."},{"id":"b55c0787-864a-4d79-bd3d-090b61e5f7d0","text":"The Ukrainian cities Kharkiv, Mykolayiv and Odesa want to return to Russia."},{"id":"eed31450-13c7-4a12-a6f5-87c6bee4c1d2","text":"A Ukrainian UJ-22 airborne drone was shot down over Kursk Province."},{"id":"96a1e432-163e-4821-8cba-d4b5417f9f48","text":"Yulia Tymoshenko is planning a coup."},{"id":"8c55c063-c680-48b6-8ba6-64ac9886ba32","text":"Antarctic sea ice is increasing to record levels; Antarctica is getting colder and its sea ice and ice cap are not melting."},{"id":"6ce85de8-d097-4553-8939-cddc44ac7afc","text":"Electric vehicles are less environmentally friendly than combustion vehicles because their metal production causes greater environmental harm, and electrifying road transport simply shifts CO2 emissions from tailpipes to power plants."},{"id":"f5307467-deb6-4fd6-92d7-cd40b933d49c","text":"Sea level rise predates human influence and has not accelerated."},{"id":"e31a626b-6477-4fd6-995b-cd4796ae7896","text":"Ukraine secretly ceded its borders to the EU."},{"id":"61ef2b5e-ba4a-4387-b511-d95280b5758f","text":"Cooking with aluminum foil causes Alzheimer\u2019s disease and cancer."},{"id":"661405a4-20f3-45ba-9dcd-c6aabc7da03b","text":"The Governor of Maine ordered restaurant staff to wear COVID visors shaped like dog cones."},{"id":"dd9c34d2-e328-404e-9262-ef8ba5e31c00","text":"Ukraine\u2019s Culture Minister falsified history and denied the Holocaust."},{"id":"b0760fb7-31e2-4253-a9e7-088762a7adf4","text":"Alzheimer\'s disease existed 40 years ago, and cholesterol-lowering drugs and cholesterol-lowering diets cause Alzheimer\'s disease."},{"id":"a78f8423-7ff6-436b-bb86-b2d81950dba4","text":"International observers accuse the Ukrainian military of committing genocide against civilians."},{"id":"ce8a9b13-d2ba-43a3-91ba-1e54add14e25","text":"A Ukrainian soldier willingly joined separatist forces"},{"id":"37205a70-045d-45fb-a659-745be3a25f44","text":"Prenatal ultrasound causes miscarriage and heritable genetic damage."},{"id":"936a910e-c127-46cf-854c-f9f45c4172c4","text":"A rainbow flag was raised over Kyiv to replace Ukrainian values and falsify history."},{"id":"31cbe0ed-02e8-4c9d-98ea-753e0ab3babe","text":"Kharkiv has no electricity while Kyiv sells surplus electricity abroad."},{"id":"a717a742-4cc5-408a-8a35-4286bff0e4e4","text":"The 4 July 2025 Texas floods were caused by a dam release and no footage shows rain during the floods."},{"id":"864f721b-f058-4fa2-9aa7-84f986dd34c9","text":"COVID-19 vaccines increase the incidence of heart conditions and cancer."},{"id":"ab03c143-5c30-4a99-9014-887c91d422e6","text":"Acting Minister of Health bans antiseptics"},{"id":"3220bfc2-e818-4aa6-99e1-0fe729cee492","text":"One in 1,000 children vaccinated against COVID-19 died from the vaccine."},{"id":"870b6aee-39e4-44ab-8369-c44251be45de","text":"Ukrainian Orthodox Churches celebrate Halloween."},{"id":"f34accd5-1589-4a52-82fd-77643ec0941f","text":"The CDC illegally inflated COVID-19 death counts by at least 1,600% by issuing NVSS COVID\u201119 Alert No. 2, which shifted underlying causes from Part I to Part II of death certificates and reversed the 2003 certification guidance."},{"id":"a76fd6ba-7552-4af7-9c53-13e1dbf01800","text":"The European Union is using new colonization methods to take control of countries."},{"id":"8eb3868f-1de4-4758-bcd9-776496ea6d87","text":"Danish researchers found that COVID-19 vaccine protection against the Omicron variant became negative three months after the second dose."},{"id":"4b294b6e-1494-4eb8-ab32-b4e0af0ee624","text":"Poroshenko said European armies are militarily superior to Ukraine\u2019s armed forces."},{"id":"aa3f2dae-31fc-4d1e-85ee-711ed8179455","text":"Raw manuka honey kills every bacterium scientists expose to it, including antibiotic-resistant superbugs."},{"id":"c2eb7027-7f02-4640-a1e8-3178709b3d6c","text":"Flu vaccines contain ingredients derived from dogs."},{"id":"51da2545-3036-4376-9031-a272d71f4745","text":"Russian specialists modernized the Kakhovka Hydroelectric Power Plant and increased its capacity by 30%."},{"id":"4b7146ae-eb62-46f7-a74d-dfb114e0c51a","text":"5G at 60 GHz prevents the human body and blood from absorbing oxygen, and doctors describe this in COVID-19 cases."},{"id":"c433c64e-4d49-46b1-b558-2374391d828b","text":"Roman Shukhevych\u2019s bust from the destroyed Lviv museum was recycled into scrap metal."},{"id":"4babb15c-0432-4c14-a80c-8a89bb99daf4","text":"Speaking foreign languages is prohibited in Latvia."},{"id":"c691c40b-0da2-4fba-8405-1d8ee2563aea","text":"Ukraine issued maps that omit its temporarily occupied territories and its western regions."},{"id":"dfb119ab-0905-4f66-9996-9575684b6e27","text":"Armenia resumed flights to Crimea."},{"id":"a84ae567-4401-4340-9020-62272d966ea8","text":"Mucus is the cause of all diseases and soursop is 10,000 times more effective than chemotherapy at treating cancer."},{"id":"0016daed-4c8a-4f04-82a6-93d276191cf2","text":"Raw milk and raw eggs are safe to consume and are more nutritious than pasteurised milk and cooked eggs."},{"id":"06c9eb45-978c-4b10-a3d5-4e009293d7c0","text":"A pathologist reports that COVID-19 vaccination causes a 52% increase in cancer risk for people aged 15\u201359."},{"id":"c46387b0-beff-4ba1-b2f4-5f52c8f5f329","text":"The Ukrainian Prime Minister called the people of Luhansk and Donetsk \\"untermensch\\"."},{"id":"2be2682b-3fcb-45ed-9120-9ffd003ad2e6","text":"The UK prevented the UN Security Council from making a decision on Mariupol."},{"id":"81764a78-278d-4f62-87bb-53accd6c2144","text":"80% of people who received the Moderna COVID-19 vaccine experienced significant side effects; children in Sudan contracted polio from the polio vaccine."},{"id":"88a2d097-7fb9-436a-bce9-304796f073e2","text":"Cannabis use causes no deaths anywhere."},{"id":"0e3b3e82-2f17-47a0-b8a5-0911a030245e","text":"Intravenous vitamin C kills cancer cells and does not kill healthy cells."},{"id":"84eab2ec-0421-4ec5-adde-98da233799c2","text":"All coronaviruses, including those that cause SARS and MERS, are seasonal and always disappear on their own; ivermectin is effective for preventing and treating COVID-19; and COVID-19 vaccines are gene therapy that do not provide immunity or prevent transmission."},{"id":"b1cfeae3-7f20-4959-8338-5c2742e6739f","text":"The pandemic was planned, and the respiratory illness surges in New York and China are caused by chlorine and benzene contamination in food and water, not by airborne transmission."},{"id":"1068b99b-afa6-4480-a25b-e2729c14f279","text":"A Ukrainian journalist arrested in Russia is a spy."},{"id":"3970be47-9533-41fa-9996-110c725cf92e","text":"Volodymyr Zelenskyy launders Western aid through United Arab Emirates bank accounts."},{"id":"cd5f2c50-555c-4b25-b9a8-384f188c664a","text":"The clothing industry produces 10% of the pollution that drives the climate crisis."},{"id":"5a5e634f-a429-49c4-b8ef-cebfc06153b3","text":"COVID-19 vaccines increase the risk of heart attacks."},{"id":"1658783f-c143-44c0-a0bd-d86a2d59e278","text":"Russian army destroyed Ukrainian troops who raised the Ukrainian flag on Snake Island"},{"id":"b1b40546-ec71-46aa-9691-08e0f2e9b586","text":"Ukraine will dump the remains of a Soviet-era general."},{"id":"46604d93-2806-448b-8c25-c7363eb20a06","text":"Organs of Ukrainian soldiers are extracted and sold."},{"id":"86207384-0583-4a85-80f9-90268d07f502","text":"UNICEF payments require registration on Viber and Telegram."},{"id":"942531b4-dec6-433b-a397-2a34822a7db2","text":"People in France protested after President Macron announced he would send French troops to Ukraine."},{"id":"c58cca54-9dbf-4739-a076-57ed426b15fb","text":"Carbon dioxide does not cause global warming; observed warming is caused by the Sun; CO2-driven ocean acidification and CO2-related harm to polar bears are not occurring."},{"id":"6c3e9aeb-75f0-4a81-a3c6-6ccb162d3595","text":"Adding more carbon dioxide to the atmosphere is beneficial and carbon dioxide does not cause the Earth to warm."},{"id":"9c2af4b3-f21e-41ba-84e3-147806af306b","text":"Injured parishioners from a fight in Cherkasy were denied medical treatment because of their religious affiliation."},{"id":"36370dfa-344e-42cd-b175-35522618f57b","text":"Crimean Tatars owe gratitude to Stalin."},{"id":"94a437c0-a658-4ee1-ba24-09607845efac","text":"Fluoride is a neurotoxin that causes lower IQ in children, causes thyroid dysfunction, and causes reduced bone density."},{"id":"8f9adad7-7268-42d1-8052-67cf463f8936","text":"baking soda cures cancer"},{"id":"46a0c3b9-3856-4db1-a886-180abac23d55","text":"European leaders are considering Russia\'s plan for the Eastern Ukraine conflict."},{"id":"8013c6f5-a136-41c4-87cb-8d5e885b05d2","text":"Video shows an explosion on the road to Komsomolske."},{"id":"84e31776-201e-4b09-8fa4-f3c1b0a1c99f","text":"GRU forces were exchanged for Ukrainian security officers."},{"id":"17b8e47c-1760-47a5-b51b-ebd91629693d","text":"A new paper proves Covid-19 mRNA vaccination rates are linked to increases in overall deaths."},{"id":"373b210c-8381-4d76-84d2-0517d2a5fae1","text":"Taking Truvada protects against HIV and does not increase the risk of kidney or bone problems."},{"id":"b0e88103-9182-428d-a786-fd65d7cfc76a","text":"Only 6% of the 153,504 recorded deaths were caused by COVID-19; the other 94% died from other serious illnesses."},{"id":"dc18ed86-33df-41ba-9de2-a0ec4e7462b8","text":"Poroshenko was drunk and gave a soccer ball to a legless soldier."},{"id":"af9b140e-b5b6-4c11-8276-f58139175533","text":"The FDA admitted young children are at a significantly elevated risk of seizures after receiving the COVID-19 vaccine."},{"id":"64fc6ae9-27d6-47aa-83ce-0abdfc9c3126","text":"Belarusian protesters were paid to demonstrate."},{"id":"6616e213-4d96-4494-8c81-5d7ef80cfe7a","text":"Ukraine is demolishing and desecrating Red Army soldiers\' monuments."},{"id":"51e7f666-0050-488c-9d20-f9c3d4e7a675","text":"Volyn and Vinnytsia have seceded from Ukraine."},{"id":"183d0198-9ef2-4007-8324-b1d156ee1306","text":"Birthmarks indicate a person has MTHFR mutations, and people with MTHFR mutations have increased risk of vaccine reactions because they cannot detox toxins from vaccines."},{"id":"9a96fcb7-3f24-461c-abff-40ee26d60bbd","text":"Ukraine bans conscripts from enrolling in universities."},{"id":"5d6e3c65-5625-42fb-9762-29770ac69d70","text":"WHO stated asymptomatic spread of COVID-19 is very rare, therefore physical distancing and face masks are unnecessary."},{"id":"416a7f2f-5a8f-4b2e-af1a-ed544ee6262c","text":"Moderna covered up mass heart attacks among toddlers in COVID-19 vaccine trials."},{"id":"b3ad4cab-a5e0-4720-b764-876a113500e2","text":"The majority of IT specialists left Ukraine."},{"id":"4289d0aa-4385-4d1f-b208-ed86b86771c5","text":"Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, which kills viruses including SARS\u2011CoV\u20112."},{"id":"abebfc28-65a2-45e1-8d3d-74cba4088fc5","text":"The UN Security Council refused to support Ukraine."},{"id":"c7a05342-7ea2-482a-ae7d-a4773af7eb46","text":"Underage refugees tore down the Ukrainian flag from a school near Kyiv."},{"id":"bb5ea732-fc0b-42e6-915e-dc5845af26a0","text":"Video footage shows a giant tree stump in Antarctica that grew when Earth\'s climate was warmer."},{"id":"11ebb2bc-c822-40ef-9a48-f56030baf816","text":"The Sun and Charlie Hebdo reported that Angelina Jolie was extorted in Ukraine."},{"id":"12585130-a603-4a16-af27-1e1fcce40159","text":"All privileges and compensations in Ukraine have been abolished."},{"id":"bfb2d618-fbdd-4aa4-9ec8-fd066b137ccf","text":"NATO troops entered Donbas"},{"id":"3c9d6334-c309-4acf-95f8-b5d5e69ba433","text":"90% of the world\'s glaciers are growing."},{"id":"3bdd3464-3b56-41c5-b23f-c9175e8cb79a","text":"The U.S. CDC recommends that children receive a COVID-19 flu shot."},{"id":"4a490611-8667-498f-b795-aa3c60360577","text":"Sea level rise does not depend on ocean temperature or CO2."},{"id":"f58640de-8679-4344-8e02-c81e2d56cf3e","text":"Ukraine established a new public holiday called \\"Day of the Avenger\\"."},{"id":"7f2f4983-adf6-4346-8154-b7de3cf8139d","text":"COVID-19 vaccines will force continued mask-wearing and physical distancing and will keep restaurants, pubs, and cinemas closed."},{"id":"ad0bb58c-bd77-4852-ab78-fc14a7ada568","text":"USSR symbols were projected on the Brandenburg Gate in Berlin."},{"id":"e59b958a-d4b1-4c92-a490-dad0c9ad6b85","text":"Bloomberg announced that giant deposits were found in Crimea."},{"id":"65aeed1b-3262-431e-a71d-2bd16f74bba2","text":"A pill that combines more than 60 natural herbs cures COPD in three days."},{"id":"a8d3b3f2-8f28-4997-b8fb-d356c28fc9fd","text":"In children, COVID-19 causes lower mortality than influenza and the same rate of severe disease or hospitalization as influenza."},{"id":"d41000c9-686d-42f9-a48c-6ec348be7bfb","text":"Depression is defined by low serotonin; low serotonin means a person is depressed."},{"id":"96fb4452-25bd-4554-b732-f23f41adbf38","text":"Ukraine will sign security agreements with the United States only if the United States gives Ukraine money."},{"id":"ccfeabe0-28f9-4439-a265-f75474b223dd","text":"OSCE confirms the Ukrainian army shelled Donetsk."},{"id":"4b4a656e-4325-448c-8c08-e151c7fbb241","text":"COVID-19 vaccines have caused 21,000 cases of myocarditis and the number is climbing; young people should never receive these vaccines."},{"id":"b4bcb059-a88f-4ecc-afc9-4a8ffb58deaa","text":"COVID-19 vaccines are 98 times more harmful than SARS-CoV-2 infection."},{"id":"d7982fd2-b552-45b9-9ac6-e7c2c5fc0916","text":"Vaccines contain unhealthy levels of aluminum, and Japan eliminated vaccines and infant mortality decreased."},{"id":"db4562b0-997d-4fbf-9616-cd9cc79f842d","text":"Babies under six months must not drink fluoridated water because their blood-brain barrier is not fully formed until six months of age."},{"id":"843ad762-b206-4f47-b606-70a915950b5e","text":"Ukrainian President Volodymyr Zelenskyy is faking blackouts to secure more aid from European countries."},{"id":"4644bce0-c9cd-4728-a3ac-eeedce4ddcfa","text":"Covid-19 vaccines are ineffective because the majority of COVID-19 deaths occurred among vaccinated people."},{"id":"a3f09e08-ba96-48b9-8cf5-2e23612fc92a","text":"Serbian Defense Ministry says Euromaidan was a coup."},{"id":"04201b64-11b5-4a5b-ab03-c26dfe98eaa0","text":"There are no Russian troops in Donbas."},{"id":"f1d4fcbb-0069-4d08-a24e-77e962a05585","text":"Foreign Policy used its banner to promote a pro\u2011Russian story."},{"id":"3381dd29-87a6-4bc8-96d1-4fdace7560cc","text":"The FDA says doctors can prescribe ivermectin for COVID-19."},{"id":"96f1b602-4d0b-49a5-b639-456163508b1d","text":"Brussels falsifies and rewrites European history."},{"id":"020f8349-87b4-471e-aa33-4627090a42ce","text":"Marchers in Kharkiv chanted \\"Death to Russians.\\""},{"id":"96c1386f-d62f-4eb4-9546-ab7c52e088cb","text":"5G technology caused the coronavirus outbreak."},{"id":"63151421-595c-49e6-97f2-2451fc80eaf1","text":"Dr. Anthony Fauci acknowledged that large numbers of positive COVID-19 cases were caused by oversensitive PCR tests detecting noninfectious viral fragments, resulting in many false-positive results."},{"id":"92cb575c-b924-4e40-9aba-517d60cb2e8e","text":"One million people in the U.S. have died from COVID-19."},{"id":"f74c9c19-08b5-4767-85e3-bdd2b04e897e","text":"European Parliament found that Russia does not sponsor terrorism."},{"id":"54f31316-749c-45c5-a935-bcbfe6582195","text":"Ukraine handed military draft notices to minors."},{"id":"f84fbb9e-84ba-43ed-9a8e-58d0df3a265d","text":"Ukraine will force residents of Crimea and Donbas to repent."},{"id":"6a9a5709-418b-4dab-8b4e-1380b6e2fee5","text":"The US lost 90% of the weapons it supplied to Ukraine."},{"id":"fdf418a5-239c-4a3b-84f1-ccb5c655dfc1","text":"A women\'s battalion consisting of females aged 16 to 30 was announced in the Chernihiv region."},{"id":"7d057666-c938-4ff2-9b34-b005972c9385","text":"Ukraine is selling stale leftover bread because of bread shortages."},{"id":"ac2c8b74-62cc-436f-8f86-38c3f3214c51","text":"Higher COVID-19 vaccination rates among White people are associated with higher COVID-19 death rates."},{"id":"990c66a4-8474-4ba5-a743-ec1d7ae76287","text":"The Czech Republic supplied tanks to Ukraine."},{"id":"2bcb6263-41a2-4b19-a182-585c686a8b0b","text":"Ukrainian soldiers were ordered to shell peaceful villages."},{"id":"71668436-2847-4d3d-9e3e-60442f2829ae","text":"Abortions are never medically necessary."},{"id":"fb5985fd-da02-40bd-9b2e-973038f62427","text":"Ukraine has no heating and is operating public warming centers."},{"id":"a20f5161-5da8-4019-a84b-b9d70eb9e2ad","text":"Volunteers are getting rich from the war in Eastern Ukraine."},{"id":"bc09529a-9338-422a-b1ed-4aed6227f9f8","text":"Coconut oil treats and prevents Alzheimer\'s."},{"id":"94baf93b-4cca-44d7-a782-b5c3d2894ba2","text":"Ukraine announced a new foreign policy toward Africa."},{"id":"f0946bc1-4e64-4617-a24a-fe963016e054","text":"The United States will bomb Siberia according to a Ukrainian plan."},{"id":"623ba596-2602-4da0-b167-c51bd2531534","text":"COVID-19 vaccines\' spike protein binds to and irreversibly alters human DNA, the vaccines contain multiple lipid types never before injected into humans, and the vaccines have caused 12,000 deaths."},{"id":"a263f78b-e32d-482d-91ed-81deca9f04d3","text":"Ukraine deceptively recruits South Africans."},{"id":"fe87c798-bb32-461b-8114-2f55d8ef06a3","text":"A toxin found in coffee attacks the bladder and kidneys and causes cancer."},{"id":"e9dbfbe6-3daf-4d0e-88d0-22294b85c258","text":"Ukraine\'s Foreign Ministry acknowledged that Crimea is permanently lost to Ukraine."},{"id":"0ea03c18-e531-413a-afc8-9fd758a13242","text":"Ukraine revoked the Geneva Conventions."},{"id":"8cce7f5b-945c-4ca6-9592-46c32642f963","text":"Aircraft-dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth\'s life support systems."},{"id":"c1e740d7-b80f-476e-9d43-8800d71b253b","text":"Peanut oil in vaccines causes peanut allergies."},{"id":"de4a5845-e616-46de-8e18-2ccf4891c7af","text":"The US banned Ukraine from buying the Russian vaccine and is testing its own vaccine on Ukrainians."},{"id":"ec7ab2fc-d2bf-4dc4-af4a-6a78a161b65c","text":"The Pentagon says the U.S. will no longer provide HIMARS and missiles to Ukraine."},{"id":"ada738ce-b6fe-4f78-8507-95e1190b547f","text":"It took 15 years to uncover Chantix\u2019s carcinogenic effects, and Chantix was not approved or confirmed safe during its first 12 months on the market."},{"id":"f36a0cb4-ca00-46f0-babd-8371f6eaf1cd","text":"A South African scientist successfully removed HIV from a sperm cell in a laboratory."},{"id":"dccb2688-1856-4a1a-87b7-4ee0424e01e4","text":"Excess deaths in late 2022 exceeded the pandemic peak and were caused by COVID-19 vaccines."},{"id":"9b394eca-d05c-4ddc-9dd1-294a8cfe08dc","text":"Ukrainian ancestors dug up the Black Sea."},{"id":"a9395453-3f62-4979-b184-b9574fed4e44","text":"France will lift sanctions on Russia."},{"id":"4c740324-ff57-4648-8ed7-61327f6ce31c","text":"Ivermectin sterilizes 85% of men who take it."},{"id":"c5d25191-6901-47c5-8d4c-636d712c9cf5","text":"The United States has a better handle on COVID-19 than Europe, and COVID-19 is less deadly in the United States than in most European countries based on case fatality data."},{"id":"1ae70a9e-9821-41e3-b84e-86b6e5ca8240","text":"A review of autopsy cases found that 74% of deaths were caused by COVID-19 vaccines."},{"id":"9f0ea2b0-c156-4bc5-92af-b04cb04a02cd","text":"WHO says a child\'s presence at school alone constitutes informed consent for vaccination."},{"id":"7b39a91e-e20e-432f-b965-c4698ab22ff3","text":"Environmental laws cause California wildfires to be much worse by preventing massive amounts of available water from being used and diverting that water into the Pacific Ocean."},{"id":"3f63c72c-b008-41e9-907a-65aca35610bf","text":"Sunscreen causes cancer and the sun does not cause cancer."},{"id":"b732d76a-2b06-4284-abcd-bc387bc8c1cd","text":"Massive volcanic CO2 emissions discredit the theory of global warming."},{"id":"8c4e7ac4-8c04-46c3-a97d-e48934a16af6","text":"An international medical crisis is occurring because COVID-19 vaccines are causing widespread diseases and deaths."},{"id":"8f22e45c-5446-4628-8451-99e1ca4e880b","text":"Scientists predict 6 billion people will be slaughtered or starve to death this century."},{"id":"c4677d1e-9db7-4190-9924-793e642c8435","text":"COVID-19 vaccine recipients are not eligible to donate blood."},{"id":"7af3c507-526a-45ce-b2dd-61b801d21fe0","text":"The HIV VB variant is highly infectious and makes people ill twice as quickly."},{"id":"96500fb1-16ab-4e8f-b6c7-c35d72fd2de1","text":"France jails citizens for questioning or opposing mRNA vaccines."},{"id":"a18aa87f-3a29-4776-85db-d25a86cbd228","text":"Ukraine establishes maritime borders only by recognizing Russia\u2019s annexation of Crimea."},{"id":"17298b54-7092-46ee-9c28-4acf297ff748","text":"A Russian drummer from the band Metal Corrosion was forced to serve in the Azov Battalion."},{"id":"f57e9765-ae8c-4cb1-a9bd-02639581ef21","text":"Deaths reported to VAERS after vaccination are caused by the vaccine."},{"id":"3ac795c8-d51c-4298-a87b-214912d9d6b4","text":"Ukraine\'s currency market will collapse without transfers from Russia."},{"id":"52466996-0059-4953-98fa-5cedb078c1c3","text":"Regenerative agriculture improves soil health more than conventional agriculture."},{"id":"2104bd63-b9b4-4456-a8b8-646d0cb147b4","text":"A review found that COVID-19 mRNA vaccines aid cancer development."},{"id":"d4c15268-dd03-4bb9-b579-ad2e9d197f56","text":"Polish company ASBS Othago is fighting alongside the Ukrainian military forces."},{"id":"62956cb9-8b3c-4684-8727-ab704ca7a45f","text":"Climate change is not new and climate change is not caused by humans."},{"id":"e22e1484-240f-4364-bef2-27197cbab294","text":"Kyiv\'s electronic warfare forced Russian drones off course into Poland."},{"id":"a7644128-356d-426d-a72f-e9ccaca044fc","text":"Ukraine has banned the Belgian Foreign Minister from visiting Ukraine because he visited Crimea."},{"id":"58ea73c6-2eeb-4934-a39e-bd6e1d791d97","text":"In the 1980s\u20131990s people died from the antiretroviral drug AZT instead of from HIV/AIDS, and Anthony Fauci pushed AZT as the treatment."},{"id":"aee737c4-a386-4460-bb22-c9a90c10bad3","text":"Nearly 90% of Odesa residents like Russia."},{"id":"a87006c6-a37e-44aa-b418-b90844e6d18e","text":"Ukrainian soldiers wore Russian uniforms in Donbas."},{"id":"03bbf6a8-e994-47e1-93e4-0c1992c89568","text":"Ventilators, not COVID-19, caused the deaths of hospitalized COVID-19 patients."},{"id":"2cb20498-f180-4af4-8f9a-817025296a86","text":"COVID-19 vaccines caused an increase in abnormal blood clots observed by embalmers."},{"id":"641375ef-beb6-46e7-80af-90bdb12b074f","text":"Russian militant Motorola was killed by a Latvian mercenary."},{"id":"6b595781-d1d6-4ca0-bb23-9a044256b930","text":"Crimean Tatars asked Turkey to recognize Crimea as part of Russia."},{"id":"45022a65-88e8-4eff-9ed7-e9aed1e85ba0","text":"Side effects of the HPV vaccine outweigh its benefits."},{"id":"64c2f63a-56d2-46e0-8abe-ff40035acd85","text":"Ukraine boycotts the Paralympics."},{"id":"02f2861c-459c-420a-8105-6710bb5b977e","text":"NATO confirmed Russia is fighting in Ukraine at reduced strength."},{"id":"6b3d7248-ead8-4f23-88a2-6645c651cbe1","text":"The FDA admitted young children are at a significantly elevated risk of seizure after taking the COVID-19 vaccine."},{"id":"a2d9f955-833e-494f-a522-8983dbe3a28d","text":"The European Parliament accused Petro Poroshenko of causing a church schism to win the election."},{"id":"3e03a02d-349b-468f-a5cb-ed740d95b05f","text":"Polish and British special forces fought in Ukraine from the first days of the Russian invasion."},{"id":"05f5fec2-3369-489b-a94e-b9bfcc251a1a","text":"Oil and gas are renewable energy sources produced by a geothermal reaction between the solid mantle and liquid core; hydrocarbons form in the upper mantle, migrate through deep faults, and are deposited throughout Earth\u2019s crust in any rock type and structural position."},{"id":"a2c7b8dd-50cb-426b-9bcc-a31227a8ca85","text":"Russian military captured German PzH 2000 howitzer"},{"id":"4ccc6622-0ab3-4807-aa62-fd81cd5dca86","text":"More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades."},{"id":"62c4c72d-70a2-472c-bcf3-193476bc0f15","text":"Spanish media call the Ukrainian coat of arms ultra\u2011nationalist and paramilitary."},{"id":"6d70a893-521c-400e-9941-96785e5ad0d0","text":"There will be herd immunity to COVID-19 by April because 55% of Americans have natural immunity."},{"id":"f24622db-4923-411c-8797-144755e2de66","text":"U.S. doctors found that 70% of long COVID cases developed after COVID vaccination, not after infection."},{"id":"7aefc389-9540-4437-951c-1c190167095e","text":"A Harvard study confirms fluoride reduces children\u2019s IQ."},{"id":"9a562a62-374e-4b09-bfd6-4b09c8d58a93","text":"Marijuana is not addictive, cures cancer, and causes brain cells to grow."},{"id":"23833acc-ceea-47bd-89ec-81ece2ea7dee","text":"Ukraine used video game footage as evidence in its ICJ suit against Russia."},{"id":"3257e97d-7af3-4599-9280-a8ece0196021","text":"Ukrainian general kneels before the former US ambassador"},{"id":"8ef4bf67-7cd6-4006-b358-4c34fa1cfbbb","text":"A Ukrainian missile destroyed an apartment building in Kyiv."},{"id":"131a2710-8ce1-4c28-8d5f-38b1e00f7315","text":"Russian forces destroyed an all-female unit of the Ukrainian Armed Forces."},{"id":"58ae0f5c-42dd-4e1d-ba86-398feb744cc4","text":"The daughter of the SSU head organizes howitzer shooting tours."},{"id":"74f6adc8-d3ea-49aa-b8f3-a2bf36a09897","text":"Ukrainians were drafted into volunteer battalions in Israel."},{"id":"75db5fa6-073a-44c0-8965-caf7b4deed7f","text":"A police officer confirmed that 10 civilians were killed in Donetsk."},{"id":"2568521e-8586-4e71-a3a6-e54c9dd1a93c","text":"U.S. Ambassador to Russia laid flowers with blue and yellow ribbons at the scene of Nemtsov\'s murder"},{"id":"b4bf2eab-e1d3-47f5-90d7-b582087895ba","text":"American mercenaries are operating in Donetsk."},{"id":"a9d4fbc8-c8c7-4d93-957c-cec78f52d3c8","text":"Fluoridated toothpaste is deadly to children and fluoride causes dental fluorosis, cavities, and cancer."},{"id":"a0501e70-1977-4522-a0ee-e76a259691cf","text":"Cayenne pepper is the most powerful blood thinner."},{"id":"7754c771-cbbb-477b-9075-d667f3ca2060","text":"Yatsenyuk says Galicia was illegally annexed."},{"id":"5170b10e-8ae5-472a-b8b4-865fceabeaa5","text":"Masks prevent influenza but fail to prevent COVID-19; influenza cases were largely renamed COVID-19."},{"id":"f28d8885-754e-4856-b649-c6bea110441f","text":"Arctic sea ice and polar icecaps are melting at unnatural rates and this melting constitutes evidence of human-caused climate change."},{"id":"c42dccc6-9330-4981-81a9-d16c8ca59174","text":"82% of Czechs believe Malaysia Airlines Flight MH17 was shot down by the Ukrainian army."},{"id":"901f433b-f0f3-454c-aedd-2757b0e01baf","text":"German tanks painted with Nazi symbols are being transported to Ukraine."},{"id":"ec769d42-4192-4ecf-9491-4cc677a2a64f","text":"No COVID-19 vaccines were FDA-approved and available in the United States as of May 2023."},{"id":"f0bc4708-3024-458f-b26b-a56e742362e9","text":"Kolomoiskii\'s enforcers beat and kicked soldiers\' mothers from Western Ukraine with sticks."},{"id":"29dc0b96-e0bf-42bc-8a57-0ede89709852","text":"Photos show descendants of Banderovits committing atrocities."},{"id":"44f198c1-f272-49a0-a145-49eb04b378f7","text":"Japan officially named COVID-19 mRNA vaccines the most deadly drug in human history."},{"id":"2636aef0-bc84-44ab-a740-8e82aac9565b","text":"The HAARP facility deliberately creates global-scale destruction \u2014 earthquakes, cyclones, floods, and snowstorms \u2014 and attacks the world\'s citizens telepathically by influencing their thoughts with low-frequency vibrations."},{"id":"6845238d-ffa0-480e-ad20-dc70bd916dfb","text":"The Polish ambassador wants a Yugoslav-style breakup of Ukraine."},{"id":"af026343-e2e0-4e95-af43-802e830830dd","text":"Sauna bathing detoxes the body by causing sweating."},{"id":"f8e8a37e-6a86-4071-8a46-c17486c6a426","text":"Barack Obama accuses Ukrainian authorities of committing genocide."},{"id":"5e17f8d0-3190-4e64-9c88-7ecf86c72a4d","text":"Biden said Ukraine is the most corrupt country in the world."},{"id":"4b246f2c-26cd-41f9-a527-6f1d6476d5cc","text":"The Mykolayiv Shipbuilding Plant was cut up for scrap metal."},{"id":"e6d93d6d-3518-4400-b450-5f48fe896cec","text":"NASA adjusted historical temperatures downward and recent temperatures upward, and those adjustments are responsible for most of the reported global warming."},{"id":"2a27e2da-beaa-497a-958c-527da5ef4335","text":"90% of the world\'s coral reefs will disappear within 35 years due to coral bleaching caused by global warming, pollution, and over-development."},{"id":"d7b4f1b3-35c7-4658-9644-8fa6c89b17f2","text":"ISW says that after Trump\'s election victory, the Ukrainian military surrendered more often."},{"id":"d07afc6c-f8bf-4950-9736-abb677633b8d","text":"The UK visa center in Kyiv closed after Russian shelling."},{"id":"ac9c574b-d539-4fe7-8d70-6980324b0d5e","text":"Total deaths from COVID-19 are much lower than officially reported."},{"id":"a88b2527-91c6-4d02-858e-633868b1e316","text":"Vaccinated children have poorer health outcomes than unvaccinated children."},{"id":"2452b572-745d-4e14-b417-4111e352b92d","text":"The British Embassy in Ukraine recommends that British citizens flee from drafting officers."},{"id":"8356bc2a-d254-4687-bfca-d0574d34234d","text":"Ukrainian soldiers claim Ukrainian authorities are deliberately prolonging the war to profit from it."},{"id":"1edae4f0-e767-425e-b9ef-a2582e50803c","text":"Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead."},{"id":"18be4b88-72b8-4ba0-a38c-6fea58782b35","text":"The coronavirus outbreak was caused by 5G technology, not by a virus."},{"id":"201bd170-dafb-4b7f-8992-8ca1076fa5c0","text":"Ukraine will not have enough gas to last the winter."},{"id":"f48228a1-9226-4a72-8363-5b731e9f40f7","text":"Massive protests occurred in Germany opposing sending tanks to Ukraine."},{"id":"8d33e790-22e2-4d63-bb4b-6b1fa1107dbb","text":"A Ukrainian military missile launch went wrong during maneuvers."},{"id":"0fdc3f1e-a803-49d7-8551-6143d0d355b1","text":"A Western ratings agency reports that Kyiv has defaulted."},{"id":"3c73cae0-75fb-4152-bf44-4e18473a5e5d","text":"Starbucks plans to return to Russia"},{"id":"1f17b118-8369-4029-a521-a42b43a53117","text":"People with blood type O are more protected against COVID-19 than people with other blood types."},{"id":"f2be7c90-9b9b-4fb0-a65c-4f848a11c4ec","text":"FDA guidelines state that babies are too small to safely handle the amount of aluminum in childhood vaccines."},{"id":"2ebc44ff-8117-4192-829c-584395c41f04","text":"Ukraine jails Russians for visiting Crimea"},{"id":"4d3d9bba-fe97-4063-8039-8189ff9eb830","text":"Poroshenko ordered a total blockade of Crimea."},{"id":"3765ef51-6b00-4412-b8b5-d783322a2f98","text":"The EU ignored Russia distributing passports to residents of Donbas."},{"id":"1b6c65e0-53a5-4b0a-8362-e35b991c32d2","text":"Ukrainian military attempted a chemical attack in Donbas."},{"id":"8b897291-7570-45a3-ad27-c89c40e46fa6","text":"Ukraine has the highest electricity prices in Europe."},{"id":"4d0c614b-0cb6-499c-8dcb-bf785e560cfa","text":"Flu shots cause people to spread the flu."},{"id":"6b602515-6205-4c47-abf3-c12f4e1efdd8","text":"Tumors are bubbles of toxins expelled by the body; cancer is beneficial; biopsies and mammograms cause cancer."},{"id":"c3af0855-cf17-4b0d-bcda-fad670ded500","text":"COVID-19 vaccines commonly cause myocarditis and cause sudden death"},{"id":"e6683a4b-da3c-499c-a23f-bb273f0a18fe","text":"Euromaidan participants were paid."},{"id":"25fd6249-e949-4631-84fb-f1405e61dea4","text":"Natural variation explains a substantial part of the global warming observed since 1850, and global warming is not intensifying natural disasters or increasing their frequency."},{"id":"705ecf79-6e86-4810-b490-c16d6a7e79df","text":"COVID-19 causes prolonged, progressive hypoxia by binding to the heme groups in hemoglobin in red blood cells."},{"id":"c9488325-cda6-4175-8aab-76fc0f8bd6d4","text":"A court ruled that COVID-19 mRNA vaccines are not vaccines."},{"id":"04a33121-8c9f-4e66-b86e-04b2bc7ae9b3","text":"The surrender of Bakhmut will collapse the Ukrainian front to its western borders."},{"id":"b10e74b5-8563-4e07-a785-d9e62c029e0c","text":"Alexis Lorenze became severely ill due to vaccines, and vaccines aggravate paroxysmal nocturnal hemoglobinuria."},{"id":"ba5e111e-c865-426b-bfa9-766e567f9b00","text":"A freelance journalist was shot dead in Kyiv, Ukraine."},{"id":"e7bda970-2973-461d-bf8f-13801534e927","text":"The Ukrainian National Memory Institute promotes hatred and incites conflict."},{"id":"a256890c-78e3-4b94-b0a6-adfbd7fcd013","text":"Ukrainian paratroopers resigned from the military because they refused to fight."},{"id":"a9d64ed5-d644-4f06-bc99-b14bd6b9ad36","text":"The CDC director admitted that COVID-19 deaths were over-counted."},{"id":"d4b1b125-6251-4b00-b38d-d36e119b32a4","text":"Makeevka was hit by ballistic missiles."},{"id":"7b268201-9047-4d4a-a308-879db7198ea3","text":"John Kerry praised Russian efforts to secure a ceasefire in Syria."},{"id":"cb07e2af-aff1-49c2-b82c-eac07c8917dd","text":"Crimeans are under military pressure to support Russian annexation."},{"id":"a8c9c515-3996-4b03-9b74-2439120b001d","text":"COVID-19 vaccines killed people and COVID-19 has a 99.97% survival rate."},{"id":"ddb36507-88b7-494f-8e9e-f9d8f9920656","text":"People do not wear masks for tuberculosis because CNN has not instructed them to."},{"id":"13bc353e-afcb-45d4-a669-5c74b8b3974b","text":"Antarctic ice increased from 2021 to 2023, reversing the Antarctic ice-loss trend."},{"id":"45b43966-a14f-4601-aa6f-f71455455a6a","text":"Russian Proton rocket crashed while carrying a satellite."},{"id":"41fe581b-fd35-4726-8562-d8b53adbc04d","text":"Earth\u2019s mean temperature over the last 2,000 years was higher during 1\u2013200 AD (the Roman Warm Period) and 900\u20131100 AD (the Medieval Warm Period) than it is now."},{"id":"eb95bd57-4eb2-46ba-a0dd-fba6ea1f6bda","text":"Ukrainian soldiers fired on a car carrying a Russian-speaking mother and her child."},{"id":"717e16a2-b4d8-477a-86c2-54a02be5ffe2","text":"Andriy Yermak paid TIME magazine to secure a spot on TIME\'s 2024 Most Influential list."},{"id":"7256ebf7-6850-4ad1-b34e-fbca0739ae2d","text":"No one has died from the coronavirus."},{"id":"8a0c1978-1d61-4edc-94e7-56a5fa204143","text":"The Ukrainian Armed Forces are recruiting mercenaries from Croatia."},{"id":"14252dd5-081b-48c5-a9bb-81baa766b054","text":"Latvians want to establish a ghetto for Russians."},{"id":"3704c051-75f4-481a-a47f-2eec66167fbf","text":"COVID-19 RNA vaccines were not made with messenger RNA; vaccine RNA cannot be broken down in the body."},{"id":"b380f9a0-cb02-43c3-a4d4-33c16744b821","text":"Cooking with aluminum foil causes Alzheimer\u2019s disease and cancer."},{"id":"e6f94f3b-de14-46dc-8947-0892c54963d9","text":"Children injected with Pfizer\u2019s mRNA COVID-19 vaccine had weakened immune responses to other viruses."},{"id":"1095ef48-c0a4-4bfc-8a82-ee80cec0f80e","text":"The influenza vaccine has existed for 78 years and influenza still exists."},{"id":"53ab3c6a-5466-42a0-9451-1e63fb55016b","text":"The world considers Ukraine a Nazi state."},{"id":"e4707b72-cdd0-49e5-9d11-b19f9d30d22d","text":"Ukraine is forced to purchase the Russian COVID-19 vaccine."},{"id":"58a8417f-f648-4a83-b4be-780d4c190a88","text":"Moderna produced COVID-19 vaccines before the pandemic began."},{"id":"55bf2059-688f-43e6-ade3-8ce980649e1d","text":"Ukrainian authorities will mobilize workers at nuclear power plants."},{"id":"0d403ca7-7770-44ac-96dc-2a56f17d8b3c","text":"DMSO effectively treats pain."},{"id":"74600ca3-b2a9-4375-9cfd-fd2742ec9d4d","text":"Crimea benefits economically from its reunification with Russia."},{"id":"b057b3b9-cd53-4894-92a5-f2830f70b8d3","text":"Vaccinated people face no danger from unvaccinated people; unvaccinated people have natural immunity and are less likely to get sick from COVID-19 than vaccinated people."},{"id":"a6f82707-218f-43ec-aad2-6faa25593c13","text":"Ukraine imported spent nuclear fuel to build a dirty bomb."},{"id":"b45e717d-ffa8-4ab5-8872-95370f8027f9","text":"Zelensky\u2019s entourage act as intermediaries in weapons schemes"},{"id":"cd9c32c3-81d0-44d8-bbff-fc8c2896a4e4","text":"CDC admits 146.6 million Americans have natural immunity and 94% of COVID-related deaths were not caused by COVID-19."},{"id":"2b147f86-fc25-44d1-aeab-ecd8aefa2b6e","text":"The EU fears that Ukraine is smuggling weapons and drugs."},{"id":"598aeb2e-dece-423d-91ce-264ed870d837","text":"The Netherlands accuses Ukraine of criminal conduct in the MH17 investigation."},{"id":"e6095ac2-1356-414e-8a1c-f0b2cc8822b9","text":"U.S. delegation leader condemned NATO actions in the Black Sea."},{"id":"fae51888-22a7-4826-b71d-1d9befc16cd4","text":"A quarter of U.S. COVID-19 deaths were preventable with vaccination."},{"id":"12055060-feef-4713-8995-9a76c8499749","text":"Britain has ruled that Ukraine is responsible for Yanukovych\'s debt."},{"id":"887b0d36-bbc8-43a7-b5e1-4d384e2568d9","text":"Blades from failing wind farms will be launched at people."},{"id":"e59fd3ee-63ae-4ece-accb-0fcf50901d4b","text":"Chemotherapy is 100% mustard gas and causes cancer."},{"id":"fa85abfb-5251-4852-855a-ef9fdeeec1c1","text":"Ukraine\u2019s Internal Affairs Ministry says Russia\u2019s strikes are highly precise."},{"id":"be579522-ce94-4a53-8c1f-c8f8e2b35ad0","text":"Ukraine makes opposing NATO and the EU illegal."},{"id":"51af9d48-4a9c-4ea4-9f7e-70c38d0ca666","text":"The coronavirus was created in a laboratory and patented in 2015."},{"id":"812e2115-60b4-452f-b44d-cd5777875496","text":"Poroshenko allows lumber to be smuggled into the EU."},{"id":"21027d00-a6f2-4c55-88ee-86c3a70d6d53","text":"Moderna reported that serious adverse events affected 1 in 200 toddlers and concluded the mRNA vaccine was safe in children."},{"id":"d0c13a79-f140-46e4-acfb-c1195305cd65","text":"NATO is illegally occupying Ukraine."},{"id":"cc2f09e1-bc82-40a5-90db-e1040af323d4","text":"Polio was renamed to hide that it still exists; the polio vaccine does not work; vaccines contain harmful mercury, SV40, and DNA contamination."},{"id":"1eba351b-5552-4e28-ae20-82867d650d2b","text":"There has been no long-term change in sea level rise rates over the last 120 years."},{"id":"fac74e7f-c900-4f5f-91ec-4a777460f35c","text":"Viruses do not exist and terrain theory fully explains why diseases occur."},{"id":"8e8ca0bf-e85d-42c0-88f3-d5cb63349dd9","text":"Ukrainian soldiers committed suicide instead of shooting at Russian separatists."},{"id":"0964821f-62b5-4f6d-957a-cf486c6ef6f4","text":"You can determine a person\'s immune system strength by looking at their eyes."},{"id":"8858128f-3967-4c92-b226-f140e0a703ed","text":"Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead."},{"id":"5acfcc66-a473-4cf8-b96b-b77390d3a232","text":"mRNA COVID-19 vaccine lipid nanoparticles concentrate in the ovaries, causing the ovaries to produce large amounts of toxic spike protein."},{"id":"49dcec77-6a80-4a31-b76d-f30a6bbcc836","text":"Ukrainians in Poland are slaves."},{"id":"08ae94a3-a979-4f67-af67-7d21fcc158d7","text":"The COVID-19 vaccine is unsafe and ineffective because its trial is still underway, and thousands of people who received the vaccine have died or been seriously injured."},{"id":"93db5c3d-f473-4e51-9442-ddc704bd6f34","text":"Sea-level rise is independent of ocean temperature and CO2."},{"id":"800677b4-581f-457c-9366-8c4d0574d7d2","text":"Leaders of self\u2011proclaimed separatist republics appeared before the UN Security Council."},{"id":"7c80c70b-5355-4101-a131-3fb5033c5466","text":"The EU is bringing Ukraine to its knees."},{"id":"f818e45f-f7fa-4a5f-8f89-f842f6c6ecec","text":"Bill Gates said genetically modified organisms are being injected into children\'s arms and shot into their veins."},{"id":"6ba3f0b0-cccc-4453-9c4e-7dc9f180b7cb","text":"Ukraine continues to buy gas from Russia."},{"id":"57e5f68f-fef5-4d51-a787-8cfbb1f2b7da","text":"Merck scrapped its COVID-19 vaccine program and said getting infected and recovering provides better protection than vaccination."},{"id":"cdbde4b9-7685-4c13-8654-d1417a5d5ee0","text":"Previously healthy people are being seriously harmed and dying from the flu shot."},{"id":"b6c27490-dd7a-46bc-b782-cfd7f9bead27","text":"Regulators reduced approval standards so the COVID-19 vaccine was approved regardless of evidence, and the COVID-19 vaccine does not prevent transmission."},{"id":"a27ce914-e260-4d08-ac3a-432980fd62b2","text":"U.S. senators armed Ukraine to capture the Donbas region."},{"id":"490533e1-dfdd-4459-8e69-84a77de32982","text":"Putin plans to militarily retake Crimea."},{"id":"77e80b1b-3b86-497e-9307-f52b8e26e1f6","text":"Czech data shows COVID-19 vaccines reduce fertility."},{"id":"48931092-1268-4b65-8ed1-3d8321ab4607","text":"Ukraine sent soldiers to Germany for training without testing them for COVID-19."},{"id":"1ec753ae-0076-44ca-96d3-6c8bef211a7e","text":"One million mRNA COVID-19 vaccine doses given to teenagers prevent at most one death and cause 100,000\u2013200,000 severe side effects."},{"id":"93cacc91-bec7-49ba-85fc-fdd8c3a4e356","text":"Building a wind turbine requires a very large amount of energy and materials, and wind turbines are expensive, inefficient, and kill birds and bats."},{"id":"b7300488-7bab-4bc6-a126-b997fe7c37a7","text":"Infection-induced immunity is by far the most robust immunity against COVID-19."},{"id":"1d9d7c36-2de2-4de3-9779-1b514ea4cb97","text":"The Mriya transport plane wreckage was disposed of."},{"id":"ab8713ea-0916-4c03-b7ea-9bed8792db33","text":"NATO is dissatisfied with the too-soft mobilization measures for Ukrainians abroad."},{"id":"910f325a-ceb8-4483-be45-d62d7acc3a6d","text":"The government has released plans to force everyone to receive a vaccine and three vaccines in U.S. Stage 3 trials will be ready in weeks."},{"id":"dcebb25d-c474-4240-aae5-10924c56f7d8","text":"VAERS reports in Florida rose 1,700% after COVID-19 vaccines became available, demonstrating that COVID-19 vaccines are unsafe."},{"id":"47c8f442-152b-47d6-afd9-09434f7556ae","text":"Federal study found marijuana is 100 times less toxic than alcohol and is safer than tobacco"},{"id":"a4202ed7-037f-4047-85e5-bfc3bb24d142","text":"American media claim Ukraine\'s government is a neo\u2011Nazi regime and is illegitimate."},{"id":"514a8a9b-bc78-4e9a-9d68-8eb6b36fed1d","text":"People are fined for planting potatoes"},{"id":"f5785d4e-bb24-4967-93a2-a6279cdb2aa3","text":"920 women lost their unborn babies after getting vaccinated."},{"id":"7fbe7e93-7fdf-4ab5-9d0a-b2224b8c001d","text":"Ukraine will replace Victory Day with Europe Day."},{"id":"7ca8d60f-df10-4ca4-9389-05952701211e","text":"Not living at an officially registered residence in Ukraine is punishable by law."},{"id":"fe8cfbf5-a62f-4e4e-a3d8-4fce6f205412","text":"Fungi cause cancer."},{"id":"4f61b269-b18f-440f-86f2-071070cf39f7","text":"Lavrov says Odesa and Mykolaiv were created by Russian people."},{"id":"48dcacb1-a6d4-4ffd-ae0d-19020e4a4256","text":"Kyiv and Washington are dividing Ukraine."},{"id":"140c722b-2bd4-4e8e-b7a7-faab1c343974","text":"Vaccinated individuals have higher rates of COVID-19 infection and more musculoskeletal problems than unvaccinated individuals."},{"id":"e893b0cb-deff-41b0-8a58-d9f7e330290b","text":"A spontaneous memorial was erected on the Tisza River for men who died while attempting to cross the border."},{"id":"67e3ddb6-2eb8-443a-91e4-4a47d24d0ca2","text":"The Maldives are not threatened by climate change"},{"id":"9d307cba-10c6-4d4c-85a8-ea190c9e38f1","text":"The U.S. CDC is lowering the PCR cycle threshold (Ct) for tests of suspected vaccine breakthrough infections to reduce the number of officially recorded COVID-19 cases."},{"id":"381b986c-714c-4d28-bf25-4946c45f7085","text":"US intelligence found reasons to pursue regime change in Ukraine."},{"id":"3d172aba-15cd-41a3-875f-232cf07ac7a3","text":"Climate change is not new and is not caused by humans."},{"id":"8c4e658b-c2f4-40d6-acb0-e120aa2aad0f","text":"Abortions are never medically necessary"},{"id":"496f09c0-85ea-419e-b170-6ca90d3cbc34","text":"Lviv graduates were given ribbons depicting a map of Ukraine that excludes Crimea."},{"id":"3c7bbead-a5a5-4a68-9acf-7d3319a7fb38","text":"Amish communities have herd immunity because everyone already had COVID, so vaccines are unnecessary."},{"id":"4ce45b79-2cbe-4d99-96eb-07d582e80fd8","text":"Massive demonstrations across Europe are supporting Donbas."},{"id":"0ed14139-129e-443f-b11b-fdde310f75d9","text":"Ukraine will suffer an economic disaster."},{"id":"cb71a94d-8f0d-4be5-9737-fa44d24d6c90","text":"Ukraine admitted foreign mercenaries left Ukraine to fight in the war in Israel."},{"id":"2c259afd-f542-4627-88d8-3750d2b59ae7","text":"No one has died of cancer or heart disease since the COVID-19 pandemic began."},{"id":"9f5848cf-a05d-421e-9dc8-0d8ecdda8e58","text":"Vitamins C and D are now part of conventional SARS-CoV-2 treatment; very high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk."},{"id":"0c61da08-e4df-4b4f-944f-c5a065acace5","text":"Romanian authorities prioritize evacuating Ukrainians from Gaza before evacuating Romanian citizens."},{"id":"b61e932c-d0e5-4154-be32-f0ac3c52fed0","text":"Coronavirus does not exist."},{"id":"8ed4f17b-38af-4dfb-9181-18f56598cd3c","text":"A video shows a Russian Oreshnik missile used in an attack on Dnipro."},{"id":"8f7421cf-82dc-48c1-98f5-c7e7321e37b3","text":"Hurricane Milton is a targeted geo-engineered storm, and hurricanes never develop in the western Gulf of Mexico and always head straight east to Florida."},{"id":"ce31105a-13fb-4324-877c-1143670d251b","text":"Most people are infected with harmful parasites and need to regularly cleanse their bodies using pills, juices, seeds, or cleansers that detoxify the body and eliminate parasites."},{"id":"4b5dde87-2185-48d5-8f08-8cf82f888f78","text":"Ukraine will cut off gas supplies to Europe."},{"id":"0c13fc8f-d3f9-42e0-afb5-4e1ec4d48ca2","text":"Crimean self-defence units took over the parliament building, and a professional actor was used as a witness."},{"id":"a7ea3f1a-7b3e-4f52-8f24-7549557e04ad","text":"Robert Kiyosaki said financial aid to Ukraine is pointless."},{"id":"3b2128b4-4590-4671-b7cd-02a16eadf477","text":"More than 10 million Ukrainians left Ukraine because Ukraine pursued a pro\u2011NATO course."},{"id":"833d8aa2-87f3-43d9-b6a7-840cca9c261a","text":"Kurt Volker says Ukraine cannot regain Crimea and Donbas."},{"id":"1d535066-043b-48ae-b72f-bb725a0dc533","text":"Uman Synagogue houses a Ukrainian nationalist military base."},{"id":"6f64e734-8b4d-4d8f-a346-c4d16a69ba8b","text":"HAARP experiments caused the May 2024 auroras."},{"id":"4e631d9f-285f-4597-9acc-f7fcd2a9c064","text":"COVID-19 vaccines cause female sterilization by triggering an immune response against the placenta."},{"id":"e7d790dc-8255-4a27-8ca9-8ecc3deb5bc4","text":"2016 was not a global temperature record."},{"id":"d51a391a-6570-4599-b28e-5b0598458b94","text":"A Turkish delegation arrived in Crimea."},{"id":"0885b665-80fc-405b-98c3-3ee4dc2ebc96","text":"SSU Head Nalyvaychenko has a United States passport."},{"id":"34b64dd0-60ec-464a-b7f8-af46028d73d4","text":"EU countries are massively denying visas to Ukrainians."},{"id":"66edd251-7fa8-42f8-b860-e9fdc90e657a","text":"Relations between Russia and the West are deteriorating because of the war in Ukraine."},{"id":"45e07c52-5893-42d9-a89a-35ed3e29e4d3","text":"Natural immunity to COVID-19 is stronger and longer-lasting than immunity from COVID-19 vaccines."},{"id":"a595315e-7ec1-4c80-abff-07725d6dcf14","text":"A Lancet study shows vaccinated people have lower immune function than unvaccinated people and that COVID-19 vaccines suppress the immune system."},{"id":"cc1c0b2e-c509-4ed2-93ee-ff392da24a6f","text":"More children will die from the COVID-19 vaccine than from COVID-19, and there is proof."},{"id":"0f7df7e2-9b40-4791-bf10-de0aaa56e74c","text":"Photo shows a Polish military order to attack Ukraine."},{"id":"5770a376-3a58-45b3-b9c7-4139b4da1cf5","text":"COVID-19 is not dangerous."},{"id":"a08c9c34-13b1-4b32-94c7-c670511aeb6b","text":"Wind turbine disposal creates a large environmental footprint."},{"id":"9481983d-c22e-4db3-9b32-4c294f36a4ee","text":"Covid-19 vaccination in pregnancy provides no benefit and causes higher rates of neonatal and all-cause readmissions among babies born to vaccinated mothers."},{"id":"b59d921d-d502-41a8-9bd6-26a16eea2d90","text":"Consuming turpentine kills parasites"},{"id":"bb0ac974-dba1-485f-85a8-d2f0f99db330","text":"A review found that COVID-19 mRNA vaccines aid cancer development."},{"id":"5ccdbbf0-2376-4f95-8321-d746fa931186","text":"Wagner Group destroyed a Leopard tank and killed its Polish-German crew."},{"id":"f1e088e6-b878-443c-ad67-f37a3c1428ab","text":"CO2 is a plant nutrient and is not a pollutant that threatens human civilization; installing CO2 generators in greenhouses does not kill plants."},{"id":"57ceec33-a712-42be-83b1-0bbe6b69f3a2","text":"Ukraine and Western countries are preparing terrorist attacks in Crimea."},{"id":"c7da2e2a-b68c-45ad-a5c6-61096ce211be","text":"The 1986 National Childhood Vaccine Injury Act prevents people from suing vaccine manufacturers for injuries or deaths caused by vaccines."},{"id":"040dec4c-2428-4f42-b5a0-68d2f5e4071e","text":"Sunscreen causes skin cancer and reduces vitamin D production, and wearing sunglasses increases the risk of sunburn."},{"id":"df336382-0e90-41dd-8ebd-a899eae43674","text":"Separatists obtained military hardware as spoils of war."},{"id":"81a64a01-ce6c-4c66-9537-c97b8fad0a54","text":"The Great Barrier Reef currently has record-high levels of coral and is not threatened by climate change."},{"id":"3aa43b0e-368d-4d2d-920c-2bdf99fb3216","text":"A pro-mask study was withdrawn after researchers found virus spread in the analyzed counties; masks do not work."},{"id":"21a386c6-a8c0-48cd-9378-79cc4cf98735","text":"The UN confirmed that Russian intelligence agencies were behind the Odessa House of Trade Unions tragedy."},{"id":"1db9ddb6-3d68-48a0-be81-b5b62a2a1b11","text":"Vaccinated and boosted people were more likely to be hospitalized with the Omicron variant than unvaccinated people."},{"id":"97e7a0bd-d797-473c-a610-4279ac90663f","text":"Global warming saves 166,000 lives each year; reported increases in heat-related deaths are caused by population growth and aging, not by climate change."},{"id":"be6c4f4b-813c-437b-9081-5cdae97ea306","text":"Ukraine is blackmailing the West by using EU membership as leverage."},{"id":"d20c48d1-f568-44d9-a525-23bd770a03ab","text":"Ukraine canceled a 15 million hryvnia payment to the families of fallen soldiers."},{"id":"50aafcf4-a03e-4155-8c97-9aac0561190d","text":"Ukraine gives half of its national budget to Western creditors."},{"id":"683f15ce-dced-4660-85d4-c95cd43c23c7","text":"A German restaurant\'s advertisement urges customers to stop talking about Ukraine."},{"id":"dd96c0e8-8609-47ec-a1a8-bf3ea961e073","text":"Ukraine is preparing to carry out a chemical attack near Odesa."},{"id":"a1d9fa60-1b33-407a-8a7b-098c15f781e2","text":"Queensland Health researchers found that long COVID does not exist."},{"id":"ade8b013-f783-45c1-98c2-1a7f3507d997","text":"The EU will impose retaliatory sanctions against the US."},{"id":"780cdf62-aff5-4110-8e69-01754cc6c09e","text":"UNICEF accuses Kyiv of committing aggression against Donetsk and Luhansk."},{"id":"4e679122-0ca3-4471-a107-5f85bb5443bf","text":"A new medicine normalizes blood sugar levels after the first use."},{"id":"b1eb74a2-49a0-41d3-b342-abdbfa1efe71","text":"Italians asked Vladimir Putin to save the world."},{"id":"4aa72748-0ad2-49be-aad1-b95e37da3a2a","text":"There is no factual evidence for global warming; scientists do not know whether CO2, solar activity, or natural variability cause it."},{"id":"fca8eab7-2aa1-4276-a101-a285da0affbc","text":"Coughing repeatedly and very vigorously helps people who are experiencing a heart attack."},{"id":"03574c37-742c-4770-ba1b-d8c6c3e4d8be","text":"Doctors in Donetsk refused to treat a wounded Ukrainian soldier."},{"id":"b26a0e68-fde1-4d66-a7d2-5c1e54629b60","text":"Scientists adjusted sea level data to create a false impression that oceans are rising."},{"id":"0ec7f5cc-5e61-471e-b6ba-654ac11c0af5","text":"NATO\'s nuclear drills are causing a world war."},{"id":"301a9f91-1c50-4467-83f2-77688d7deb19","text":"Unvaccinated people infect vaccinated people with the same virus the vaccinated were vaccinated against."},{"id":"a260e8e8-ef5f-4e64-8f76-0bc6fbe678ae","text":"A quarter of U.S. COVID-19 deaths were preventable with vaccination."},{"id":"d572be63-43ec-4f6b-9196-a4fc78e203a6","text":"Solar cycles and natural variations in solar and Earth activity cause climate change, and anthropogenic CO2 emissions do not cause climate change."},{"id":"ba39436c-49bc-48c4-ab96-805ef9ca0590","text":"Kateryna Prokopenko is an influential German politician."},{"id":"f39abf0d-00c9-4096-8087-54873ff61fa6","text":"Pfizer admitted that vaccinated people can shed the vaccine onto unvaccinated people."},{"id":"4bc13bbb-6196-4f52-8bd7-0e0ec095f388","text":"HAARP caused the October 2024 auroras."},{"id":"02046bbf-5ad3-45ff-b1c1-e73942023b9b","text":"Donbas residents are being forcibly resettled to Lviv for reeducation."},{"id":"fec5595b-21ec-460d-bafb-b5b19c7ef652","text":"COVID-19 vaccines caused 26.6 million injuries and 1.36 million disabilities in 2022 and cost the economy billions of dollars."},{"id":"fa53f6ea-9cb9-45ca-ae67-e1f013dd59de","text":"Svoboda political party designed a banknote depicting Adolf Hitler."},{"id":"8fd7bf1a-45d1-4bf4-a6cb-3d32320b7683","text":"Authorities in Barcelona removed children from a Russian woman because of anti-Russian bias."},{"id":"858266a5-5598-4215-8544-ed58b34b026c","text":"U.S. doctors found that long COVID developed in 70 percent of cases after vaccination rather than after infection."},{"id":"8d49ec4b-b1e8-406b-8b1f-8c5fdb7a636b","text":"Three Ukrainians were detained in Israel for looting."},{"id":"0aa879c0-b7fe-47c4-8027-e48da678618f","text":"Ukrainian Greek Catholics are exempt from mobilization."},{"id":"00ab1807-cf95-4e72-8394-2e9689140536","text":"Jihadists participated in the Crimean Tatar World Congress."},{"id":"0a551238-3582-446a-806e-0f8443f302cb","text":"Lithuania teaches war to Ukrainian children."},{"id":"d18e9a0b-a6d7-47a4-b673-21d5f2eaf483","text":"Ukraine opposes medals commemorating the 75th anniversary of Victory over Nazism."},{"id":"a40e602a-c272-43c8-8c71-cebb6598a675","text":"Kyiv ignored the Minsk Protocol meeting."},{"id":"86b9cf66-03d4-4167-9c04-a1450db98ded","text":"Kyiv City Council proposed a complete ban on the Russian language."},{"id":"c9a5e64f-b02b-49dc-8775-3842f4736fd7","text":"Most cases of Alzheimer\'s disease are preventable, Alzheimer\'s disease is not genetic, and Alzheimer\'s disease is type 3 diabetes (insulin resistance of the brain)."},{"id":"1d7a571f-302c-43bb-9c0e-d22f93415455","text":"Global temperatures are rising two to three times more slowly than climate models predicted."},{"id":"cca498e1-8ac8-460c-a82d-4e0e49181f6e","text":"Foreign mercenaries serving in the National Guard are filming the atrocities they commit."},{"id":"c64cbb4b-58a9-4606-9025-8605cf79296d","text":"Magnetic pole reversals cause the Earth to flip vertically and stop rotating for six days, causing cataclysmic events."},{"id":"68309499-78da-4bbe-af16-4f5b2d11c215","text":"Ukraine\'s autumn recruitment efforts failed."},{"id":"9f4836cc-879c-4406-8ed7-bdce9b8b99e1","text":"Pfizer\'s data show COVID-19 vaccines are unsafe for pregnant women."},{"id":"44a3fb61-0f2b-41bd-9c56-dedb56b38786","text":"People vaccinated against COVID-19 are more likely to be hospitalized than unvaccinated people."},{"id":"d1abf8d0-9d30-4d4f-8219-bb00fdef6ac5","text":"Fighter jets drew a star over Alaska to honor Vladimir Putin."},{"id":"938259cd-de6f-4630-996d-bca53f1e39f4","text":"Crimeans who left the peninsula after Russia annexed it are returning to Crimea."},{"id":"12391047-4214-4422-bc58-91fbdadc33b7","text":"There are plans to blow up the Luhansk-area railway overpass to disrupt evacuations to Russia."},{"id":"a4a77ccd-9f42-4633-a11f-13e95e7fd6d0","text":"The LifeNews journalist ordered separatists to open fire."},{"id":"2a6c92de-99b2-4e5e-8618-d3097c99ff5d","text":"The United States officially recognized Donbas as an independent state."},{"id":"1b92e69c-30d7-4aab-9caf-027682c0f685","text":"One Mt. Etna eruption released more than 10,000 times the CO2 emitted by all humans in history."},{"id":"8929cf51-2c57-4301-871a-351e37841df3","text":"More children will die from COVID-19 vaccines than from COVID-19."},{"id":"9b42133b-cf29-42c8-b877-34e158bd928d","text":"Australian temperatures increased by 0.3\xb0C over the past century, not 1\xb0C."},{"id":"af5ce828-ecb0-4b25-98ec-a073e63c0268","text":"Zelensky ordered schools and universities to work offline starting September 1."},{"id":"f09a8f81-dd52-4d4a-9570-5491befa2a8f","text":"The World Bank website shows that countries purchased COVID-19 test kits in 2017 and 2018."},{"id":"92e48c53-cdf7-4f84-946f-ac5adcbdd891","text":"Pro-Russian banners with the Russian flag appeared on Ukrainian streets."},{"id":"76ca2ffa-87aa-4737-829e-cc18600a8876","text":"Ukraine formed a military alliance with the United States."},{"id":"e2f3bbec-8541-4429-984c-cc8a9e76bda2","text":"SARS-CoV-2 is spreading quickly from gas pumps and from shopping carts."},{"id":"898b4b67-6431-4909-b142-2dda0251889e","text":"Giving water to babies under six months causes serious health risks."},{"id":"51aaa1c6-de52-447f-9184-f66d905b0b93","text":"Bill Gates said genetically modified organisms are injected directly into children\'s arms and into their veins."},{"id":"4824b6b2-aa5e-4068-8799-3a75ca4e3b50","text":"19% of American children have ADHD and 0.5% of French children have ADHD."},{"id":"b0d9dc0c-0877-48bd-b103-1c083b7b4875","text":"Sweden banned mandatory vaccinations because of serious health concerns."},{"id":"56abb7cb-a819-437e-a5cf-51e900a41396","text":"COVID-19 vaccines are experimental and ineffective; natural immunity is superior to vaccine-induced immunity; vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes prior vaccination."},{"id":"b4c58eaf-eb3f-48ba-b081-0f97d60df67b","text":"Ukraine will imprison residents of Crimea and other occupied Ukrainian territories who hold Russian passports."},{"id":"e9981269-f7c9-4625-9b7b-988f7f6e4ba3","text":"COVID-19 vaccines contain luciferase to tag and track people."},{"id":"bf2c855c-eb7d-44e5-b5fe-720972907414","text":"Electric vehicles are highly prone to catching fire."},{"id":"86f36e67-beb8-4a42-a030-2cc80150100d","text":"Half of the 0.9\xb0C of global warming is caused by greenhouse gases."},{"id":"d793e6a8-97af-4229-a114-e6ecc6f0abdf","text":"The Ministry of Defense does not receive any images from the ICEYE satellite."},{"id":"cf4b4ab5-e024-4963-9e53-684e4e1f377c","text":"Wilhelm Reich invented a cure for cancer."},{"id":"5416a7a8-6006-48b8-8076-7eb615d10765","text":"Ukraine\'s National Corps developed an atomic bomb to use against Russians."},{"id":"ecd6420a-6280-446f-8516-ea47473e1bc4","text":"The United Nations is dissatisfied with Western tanks sent to Ukraine."},{"id":"0bf57117-f8d0-4da8-a7d6-7a414366d8d1","text":"COVID-19 infection and COVID-19 vaccination cause HIV tests to turn positive and cause immunodeficiency."},{"id":"7b9b4cf9-59e5-4fab-bd12-349123ec46b5","text":"A Turkish ship transported military equipment from Bulgaria to Ukraine."},{"id":"c6386624-3e0b-4641-a3f2-812f177da49f","text":"Diet and lifestyle changes, instead of chemotherapy or radiation, cause spontaneous remission of cancer."},{"id":"fb147f68-fa76-40a2-90df-f4b00b9c712c","text":"The SARS virus has circulated since 2003 and recurs every three to four years, so everyone in the world is immune."},{"id":"a8994599-1956-426c-85b4-a903f194b187","text":"Ukraine distributed counterfeit banknotes contaminated with tuberculosis in occupied Donbas."},{"id":"f7784c93-abea-470a-9986-7999412af8fb","text":"COVID-19 has a 99.991% survival rate, so vaccines are unnecessary because vaccines were developed only for deadly diseases like smallpox that had no treatments."},{"id":"38b53111-629e-4701-964c-d5a98dab0b48","text":"Kyiv increased electricity prices to fund hosting the Eurovision Song Contest."},{"id":"21ab5123-456a-4440-9bbe-73d1fb8575f3","text":"The Ukrainian government refuses to finance Kharkiv, and Kyiv has resigned itself to Russia\u2019s occupation of Kharkiv."},{"id":"0394f585-476b-45c6-9515-ea451b79ccc9","text":"COVID-19 vaccines have killed millions of people worldwide, at a rate of one death per 1,000 doses."},{"id":"50261868-0760-408c-847e-db061e167d2a","text":"The Ukrainian military bombed Snizhne."},{"id":"a5d59357-18c2-4f05-9c3f-7b7628df3eec","text":"COVID-19 and COVID-19 vaccines are causing a global epidemic of terrifyingly aggressive cancers."},{"id":"e52bef89-83ca-49da-8cbe-7dc95e29b77b","text":"Humans caused the Texas floods using cloud seeding, and the floods would not have occurred otherwise."},{"id":"5326d90b-c708-46d2-ac2f-4c3538990e9d","text":"In 2009, 50% of Ukrainian citizens wanted to hold Russian citizenship."},{"id":"f9c88fc1-bfad-4629-a9bb-79734eaee82b","text":"The Kadyrov Foundation repaired an abandoned hospital in Rubizhne."},{"id":"7fea8be9-3838-4114-8b5e-c170a507a2cc","text":"The U.S. Climate Reference Network finds there has been no warming in the United States for at least the past 14 years."},{"id":"36f017c8-f887-4fef-aaa0-3d76d2d3ffaf","text":"A new language law prohibits the use of any language other than Ukrainian."},{"id":"07d5ccad-b012-4006-945d-684f26fb7453","text":"The Netherlands says Ukraine lied about a downed Boeing-777."},{"id":"b0a04d0a-f88e-440b-9162-46d25831ddb4","text":"Ukraine will stop gas transit in 2021"},{"id":"f9e063d5-7dcf-41b5-afcb-04878ca726ca","text":"Polar bear populations are increasing and polar bears are thriving despite diminishing sea ice."},{"id":"ef854841-2805-4237-a8d5-6cd7b7936870","text":"The Ukrainian Ministry funds radical nationalist organizations."},{"id":"fa2b9817-fb16-4e1c-92f0-db463dc26a73","text":"The atmosphere is less sensitive to CO2 than climate models forecast."},{"id":"82024663-672b-4205-9001-5efad1525661","text":"Ukraine is a drug entry point for Russia and Europe."},{"id":"7b636bf6-2231-4d09-a5a5-a2bc207be079","text":"Margarine is chemically only one molecule different from plastic."},{"id":"4ff2c46a-29f2-4b6a-972b-ca8feecf0dd4","text":"Patent US5676977A is for AIDS, patent US8835624B1 is for H1N1, and patents US7897744B2 and US8506968B2 are for SARS."},{"id":"01440c79-b4af-435a-b2d3-9f6e68d2ebad","text":"Unadjusted temperature data show Australian temperatures increased by 0.3\xb0C over the past century, not by 1.0\xb0C."},{"id":"43494523-f6c1-4d5d-8eaf-20c099381363","text":"Big Pharma murdered doctors to protect its profits and to silence holistic health practitioners."},{"id":"1e6ef59b-b97d-4bbe-baa9-9dd55b985cfc","text":"Ukraine has implemented juvenile justice."},{"id":"106355c0-5f33-4152-9329-80d8cd93fd91","text":"mRNA COVID-19 vaccines do more harm than good."},{"id":"7ac18437-d326-4a31-92d1-f6c4b9f3acc4","text":"The cow feed additive Bovaer is unsafe and makes milk unfit for human consumption."},{"id":"341b7583-7cae-4ae6-95ac-e11dcc0e29e1","text":"Lviv officials urged that Crimea and Donbas be recognized as territories of Russia."},{"id":"ac1ea412-c8f5-4d1c-8e19-03dc3ae75d56","text":"A peer-reviewed study found ivermectin reduces COVID-19 death risk by 92%, and the NIH lists ivermectin as a COVID-19 therapy."},{"id":"f41216bd-b2cf-4575-9949-f27343ea781f","text":"Ukraine cannot guarantee the security of its nuclear power plants without NATO."},{"id":"a2b312fa-88d5-4614-8069-bf3ecf3de787","text":"The Moderna COVID-19 vaccine caused heart damage in 1 in 35 people and is a kill shot."},{"id":"084a5e5f-4ea4-4a61-b599-9e39c1069298","text":"The CDC says COVID-19 vaccination increases the likelihood of infection with the BA.2.86 variant."},{"id":"6aaf8382-3a8c-4bd9-a1f0-00751972af02","text":"Chrystia Freeland is an adviser to Ukrainian president Volodymyr Zelensky and is a descendant of a Nazi collaborator."},{"id":"ae8245df-51af-4469-9186-e7dd7bf76c40","text":"Ukrainian businesses are planning mass redundancies"},{"id":"f65d41cb-fc8a-47b7-8a48-2d4eb9377096","text":"Human CO2 emissions do not drive recent climate change; solar activity and natural climate cycles drive most recent climate change."},{"id":"bbfb8767-23ec-4520-8e1c-be6dd2ab6d86","text":"COVID-19 vaccines are dangerous for children; they cause myocarditis and bypass children\'s innate immunity that protects them from COVID-19."},{"id":"77e3123c-bcfe-4e1b-b4c4-4699aa8c7a92","text":"The Ukrainian government forced schoolchildren to study in shelters as a PR stunt."},{"id":"a09cfbeb-9296-4296-8a6b-cccd5211b0b4","text":"Trump sent National Guard troops to Alaska in response to Ukrainian protests."},{"id":"116d1290-adae-4a0c-afde-ebe2246e93f0","text":"The FDA says Pfizer\'s COVID-19 vaccine causes blood clotting."},{"id":"58ffab6b-fa0a-454b-b303-57a5b0ea6909","text":"Ukrainians in Poland are slaves."},{"id":"45ad6727-3b1d-4f45-86a5-853b7d2b7e74","text":"Ukrainian Prime Minister was hospitalized after a nervous breakdown"},{"id":"7e50b278-7168-4642-ac16-4936bb59dd46","text":"A Ukrainian missile destroyed an apartment building in Kyiv."},{"id":"db06a8e5-9666-4016-a019-7b509c500925","text":"Climate models systematically overestimate climate sensitivity to CO2, and modelers exclude forcings and feedbacks that contradict that overestimate."},{"id":"1f058c8c-08ac-46ad-877c-0208691256a3","text":"Elections in Donbas are controlled by armed Ukrainian punishers."},{"id":"dd3a5f5e-8f8b-413c-aeea-d834efd4e544","text":"Countries with high mask compliance and mask mandates experienced increased COVID-19 death rates and performed no better than countries with low mask usage."},{"id":"6bf545cb-3bff-4ddc-8f89-114d02659460","text":"Lviv displayed a swastika during City Day celebrations."},{"id":"3c5f8517-91df-41c8-8459-0d77c6dc7d7e","text":"An air raid siren was intentionally sounded during U.S. President Joe Biden\'s visit to Kyiv."},{"id":"da2a8837-bd8a-488f-b164-1c4fae90ea79","text":"The IMF and Kyiv failed to reach an agreement on Ukraine aid."},{"id":"a76a4188-0e42-4ace-8773-87e990cd6889","text":"Sanctions on Russia are destroying Ukraine\'s economy."},{"id":"eb148cdc-958c-4243-8ce8-3c11c0a12781","text":"A Ukrainian minister urges banning Russian and Belarusian tennis players from winning matches against Ukrainian players."},{"id":"dd3c8ab9-8224-4615-94cc-d1f1cb267c2c","text":"Pfizer released a list stating the Pfizer\u2013BioNTech COVID-19 vaccine causes more than forty specific medical side effects."},{"id":"28d22d59-1bc2-476b-9215-4cdcb989a85d","text":"Said the Ukrainian parliamentary speaker is a neo\u2011Nazi and an anti\u2011Semite."},{"id":"e9eefdee-16bf-495f-a832-ee0139b509cc","text":"Ukrainian flags were banned at a refugee center in Spain."},{"id":"c75d19d0-b827-4f7c-b170-1ef7d2a1981c","text":"No hurricanes occurred this season despite forecasts for high activity; this proves climate change theory is wrong and the season was a light hurricane season."},{"id":"f9c52047-618d-4331-88dc-f291d6a4ce80","text":"More than 500 scientists and professionals told the U.N. there is no climate emergency."},{"id":"bc454b72-954f-46b7-aade-de6e5b24af23","text":"London apologized to Aeroflot for a UK Border Force search."},{"id":"13af3e5a-4df9-47c5-98ee-bc08c1c5913c","text":"StopTheEvolution has fought Russian propaganda in Ukraine for five years."},{"id":"4dff9410-a9bc-4ecc-a307-76f78973442f","text":"The Organization for the Prohibition of Chemical Weapons did not determine the origin of the nerve agent used in the Skripal poisoning."},{"id":"c92e9220-0252-4c02-8acb-b3c2083cba47","text":"The Ukrainian government will punish people who refuse to speak Ukrainian."},{"id":"c96c6387-3f57-4c7f-a8e8-f0e06f5e9739","text":"A captured soldier erased a \\"Banderivets\\" tattoo."},{"id":"3e3e514f-a344-49e3-9ae4-aa583531de37","text":"Rheinmetall\'s shares fell drastically after Ukraine\'s counteroffensive failed."},{"id":"790acdda-db12-4c6f-8116-86ea91021854","text":"Ukraine\'s Foreign Ministry wants to make peace with Russia."},{"id":"5d722fd0-ca08-44f7-a983-221076de71b0","text":"French President Fran\xe7ois Hollande regrets sanctions against Russia."},{"id":"3debbefc-996d-46cb-a12a-4ac0af7f86d0","text":"More than 500 scientists and professionals sent a declaration to the United Nations stating there is no climate emergency."},{"id":"f96b20fc-1ab4-4491-b9f1-630b04cbe616","text":"Americans tested a coronavirus vaccine on Ukraine\'s military."},{"id":"5f8731d0-460d-4542-8385-9bcb6bc5981b","text":"COVID-19 case numbers are inflated because PCR tests are overly sensitive; 90% of positive COVID-19 PCR tests are false positives."},{"id":"b2c9d261-a6a2-4709-a811-9be31d2f457e","text":"AIDS is spreading across Ukraine and originates in Donbas."},{"id":"6a9746d2-5c0b-44e5-a69e-6b27616cd607","text":"Vaccines cause sudden infant death syndrome, and infant deaths fell dramatically during lockdowns because far fewer vaccines were administered."},{"id":"87da1479-4c72-46b2-ad3b-3ef960418972","text":"Ukraine\'s blockade of water to Crimea caused an environmental disaster."},{"id":"6295178e-d150-4ad0-b2b4-bde698a910b4","text":"Friends of Ukraine tore down Russian flags in Burgos, Spain."},{"id":"1487337e-caf6-43ec-972a-52a6255f4bea","text":"A new oral spray deactivates 98% of the coronavirus in the mouth."},{"id":"c98ab273-00fa-4c64-b3ca-2a928745714e","text":"Pfizer CEO\'s wife died from complications of the COVID-19 vaccine."},{"id":"3d5c69d0-3692-4fd9-a879-931941f5f802","text":"Ukraine is the leading importer of agricultural products into Crimea."},{"id":"a7959296-3463-4b6b-ac53-a3b5e6f20c25","text":"Ocean waters and the marine environment are the primary drivers of climate change."},{"id":"46dfe14e-2446-41b3-8747-a3a01d5aba71","text":"Bill Gates and health agencies are staging a new pandemic targeting children, which the WHO and the UK government say is already happening."},{"id":"8d8afe95-d204-4f32-bd7a-b64c673c9a80","text":"Intravenous hydrogen peroxide enables the body to cure itself of all diseases."},{"id":"bcd2ffe8-1e6d-4dcf-9357-644c21234bcc","text":"Russia\u2019s actions are justified by international law"},{"id":"6cdd0296-e032-4a5c-b6dc-7d6233af6947","text":"The European Union will force Ukraine to accept African refugees."},{"id":"872e2a83-256e-44e0-9dd8-4401545586db","text":"A Ukrainian MP proposed mass deportation of Crimeans."},{"id":"ff1d84ad-9d70-4739-8deb-adf84694c761","text":"The Parliamentary Assembly of the Council of Europe approved a resolution abolishing political sanctions against Russia."},{"id":"538fcc42-d402-4e1c-aa53-1b48fd92e7bd","text":"Volodymyr Zelensky bought Bill Cosby\'s New York townhouse for $30 million."},{"id":"ab291336-2b55-470b-96e8-5a65d246d084","text":"Poland refuses to admit Ukrainian refugees."},{"id":"e8bffc79-ebb0-494b-8a55-67a20c377fdb","text":"COVID-19 is a type of flu and is not a pandemic; PCR tests have a 94% false positive rate; only 98 people died of COVID-19 in Ireland."},{"id":"566193e3-aa65-4122-bb4d-3d4d7a216c13","text":"The US called on NATO countries to prepare for war with Russia and to deploy troops to Ukraine."},{"id":"2bb8aa19-18f7-489f-adc2-cb4407229de6","text":"Ivermectin augments the effects of cancer therapies"},{"id":"ac72e986-3f42-4894-a51b-3f463b4c4847","text":"The WHO declared a public health emergency to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus."},{"id":"ec663f1d-8af0-4505-9c17-ea09a60e57b8","text":"AFU Brigade holds a rally and seizes control."},{"id":"4cd0e4e5-8f7a-4621-9e10-b10679c29f79","text":"The dam blocking water to Crimea was blown up."},{"id":"77407c57-d36f-48f7-b5d4-3cf0ba9fc3a4","text":"Ukrainian forces shelled the UN mission office in Siverodonetsk."},{"id":"3e182aa3-750a-475f-9344-ece860104732","text":"Ukrainian refugees in Europe illegally tap power grids to mine cryptocurrency."},{"id":"5896fac0-b57f-4633-97af-f0e71c90112a","text":"The climate has always changed and will always change."},{"id":"807c7ea3-225f-45ad-9015-6b748822e6ac","text":"All long-term tide gauge datasets show sea level rise has not accelerated."},{"id":"a0f4a3b8-e427-4208-b02c-9b5eb0b8a8cf","text":"Tilapia contain high levels of omega-6 fatty acids that increase the risk of Alzheimer\u2019s disease."},{"id":"00e918f9-e1ad-4cb6-82ea-c57ef9f80f87","text":"A study showed Pfizer\u2019s COVID-19 vaccine weakened children\u2019s immune responses to other viruses."},{"id":"79868006-5b4b-4920-8227-9896c47f4145","text":"The West lost the Russian propaganda war."},{"id":"74cbf840-383d-4abb-a196-7cc930a7b248","text":"The United States will not hand over Abrams tanks to Ukraine."},{"id":"42f04497-b4b3-4afb-9d2d-de42d308d3c3","text":"A CDC report confirms that nearly 120,000 children and adolescents in the USA died suddenly by October 2022 as a result of COVID-19 vaccination."},{"id":"0601535a-5232-49d6-ac8a-f339184b8117","text":"The Kyiv government admits Kyiv\'s smog was caused by low-grade coal."},{"id":"5cda20d0-a6e6-4c3c-8593-cc0b033e9c5e","text":"The EU ends visa-free travel for Ukrainians because of the Donbas war."},{"id":"f66f4c85-4df6-43f8-a55e-eca41f06bea1","text":"Cholera was found in the Azov Sea."},{"id":"0e6fca58-3d0b-46e9-b950-d945afd31999","text":"There is a torture chamber in the Kharkiv area."},{"id":"76041811-58a8-45f0-904e-d755003438d3","text":"A monument to Stepan Bandera in Lviv was torn down."},{"id":"f2e65053-2d71-4b6a-9137-3d0a10b89f19","text":"Polar bear populations are increasing and are thriving despite diminishing sea ice."},{"id":"651fa07f-027d-4660-9414-920e8e11c88e","text":"Doctors were murdered to protect Big Pharma profits and to silence holistic health practitioners."},{"id":"45c0f4a0-2167-4cdc-93c8-d916583cc974","text":"Official observed temperatures are consistently below global warming projections; melting polar ice causes an ice age."},{"id":"e623426b-f1ef-4797-b377-5be61d70af2d","text":"Russian troops mined the Zaporizhzhia Nuclear Power Plant."},{"id":"1ccc23c1-d3ed-4fcf-9782-521addcd2f77","text":"Ukraine\'s nuclear energy system has collapsed."},{"id":"878edfcc-e3b6-49e1-b4b1-902ef152c55e","text":"The Ukrainian government will fire all feldshers."},{"id":"d43d3481-5742-4c58-b1c9-badc139150c1","text":"The Johnson & Johnson vaccine contains aborted fetal retinal and kidney cells."},{"id":"23af801d-509e-4d13-85ba-aa38818ea8a7","text":"Le Parisien reports an AIDS epidemic is sweeping through Ukraine\'s armed forces."},{"id":"e4866b76-12de-4374-aa13-8007f1d044c6","text":"Roshen produces chocolate bars featuring Vladimir Putin."},{"id":"efbf5b1c-1b5e-41b7-a8f1-62089a598ada","text":"Sean Penn refused to travel to Ukraine because of a corruption scandal."},{"id":"ddc2535e-ae0f-434b-9768-1fa0764dbb0b","text":"Ukraine\'s military is preparing sabotage operations in Crimea."},{"id":"e5c14dc3-196c-44f7-a92e-381ff2a9404e","text":"Non-vaccinated people are not tested, so the increase in COVID-19 cases is entirely caused by vaccinated people."},{"id":"ef776dbf-e915-450c-92a7-cdb90bea6369","text":"A French journalist reported that Ukrainian forces bombed the Donbas."},{"id":"60aacdab-d3d7-4fb3-9782-d187daf68d2e","text":"The EU called on Ukraine to lift its ban on Russian-language education."},{"id":"ec042255-3b6c-48b9-b4cb-ba5cfadee254","text":"Bulgaria invited Recep Tayyip Erdo\u011Fan instead of Vladimir Putin to the commemoration of Bulgaria\'s liberation from Ottoman rule."},{"id":"af0baa1b-e5a3-440f-b047-1812f1485d82","text":"Human activity is not causing the observed increase in atmospheric carbon dioxide."},{"id":"8ba73e30-7316-4bd2-8e27-627a554098b5","text":"A study found electric vehicles are considerably worse for the climate than diesel cars."},{"id":"c2283ea3-0288-429d-b859-4af79cf5bfe0","text":"Ukraine\u2019s Presidential Administration does not know who founded Canada."},{"id":"0a30e6a2-2ecb-4080-bb75-910ab4a7bcff","text":"Ukrainian authorities are seizing cars from all Ukrainian citizens."},{"id":"9a6fdaf1-bfe1-4cd2-a54d-d21955fb6eb4","text":"Great Barrier Reef sea surface temperature has not changed in the past 150 years."},{"id":"3712e970-6cda-45e7-bedd-818a6e1a11d4","text":"A court ruled PCR COVID-19 tests are 97% inaccurate and unfit for purpose, and mainstream media did not report this."},{"id":"2232fd36-afdc-4f1f-8969-f02be4e9d63a","text":"Mifepristone is unsafe and causes serious health harm."},{"id":"af3d86ef-53f0-4580-8880-ce57b587280f","text":"The EU will deport Ukrainians who mobilize for military service in Ukraine."},{"id":"c8eaf52b-6580-4071-9e29-9c2cf6aafc79","text":"The Finance Ministry says Ukraine will face economic collapse without an IMF bailout."},{"id":"036a2d59-d909-4bb5-9f34-5ef7c0deac6f","text":"A pizzeria removed a Nazi chevron and a photo of the burning Trade Unions House in Odesa from its wall before U.S. Secretary of State Antony Blinken arrived."},{"id":"cb3af57e-49b2-4874-ba84-c7d384dec42f","text":"COVID-19 vaccines were not tested in animals or in humans before being released to the public and are unsafe."},{"id":"989cf3db-1df9-43c5-a742-683491db2209","text":"The EU has reinstated visa requirements for Georgia and will next impose visa requirements on Ukraine."},{"id":"184a591a-6388-4cf3-8aba-ee33dac18ee4","text":"An Italian journalist says Ukrainians are fighting alongside ISIS."},{"id":"442a9332-d235-4c4e-8005-e099521eb2d5","text":"A US advertisement urges people not to financially support Israel and to instead financially support Ukraine."},{"id":"46403870-19ff-4ad8-8ef0-14f1f2d46780","text":"Victoria Nuland did not demand that Ukraine implement the Minsk agreements."},{"id":"8ca5dd5c-0d80-4823-82d0-3dc17b6c640b","text":"Germany supports the annexation of Crimea."},{"id":"b5b0acb6-0c0e-4c74-8cd8-c9934226037e","text":"Ukrainians decorate Christmas trees with swastikas."},{"id":"839cea27-8092-4523-827e-6d8fbc40ff8f","text":"Ukrainians choose Russia because Kyiv committed atrocities."},{"id":"e6c7fc38-eaa7-401b-b455-e32295ee969d","text":"Ukrainian mobile operators charged residents of the Luhansk People\u2019s Republic for the antiterrorist operation."},{"id":"9ba58870-e662-45a5-beae-091bfa16e49e","text":"President Volodymyr Zelenskyy requested that foreign troops be deployed to Ukraine."},{"id":"808f70bf-16bf-40a3-bc4e-ad826c69f05a","text":"Ukraine admits Ukrainian-made parts were used in North Korean missile engines."},{"id":"ceb27820-5d30-455b-b348-a5ae9803d431","text":"A Ukrainian colonel proposed razing Donbas and Crimea."},{"id":"170e5188-3fdf-4846-894e-f89b08183c86","text":"Babies must not drink fluoridated water because their blood-brain barrier is not fully formed until six months old."},{"id":"9e987e03-e570-493b-a318-ff4663b45779","text":"Angela Merkel supports ending sanctions against Russia."},{"id":"cabce7be-e46d-4bbf-bda0-e2c027ff8945","text":"American farmers supported Russia\'s response to EU sanctions."},{"id":"1ecda97a-611c-48d8-9ece-7a0b19668b9f","text":"SARS-CoV-2 (the virus that causes COVID-19) does not exist and has never been isolated."},{"id":"6219d853-203f-4cd8-a7ed-eaccc37db4e5","text":"Vitamin K shots contain toxic levels of aluminum, and Hepatitis B vaccines contain toxic ingredients."},{"id":"25525cdf-c733-4a85-91ab-f2adc6192748","text":"A Ukrainian soldier\'s widow was forced to pay for the equipment that killed him."},{"id":"d948ec84-aa50-4245-b854-5ee6998c7962","text":"COVID deaths were vastly overcounted."},{"id":"ecfc4818-605c-4c8b-91a2-04ed27c8e3cb","text":"The Vinnytsia Moscow Patriarchate Orthodox Church has been seized."},{"id":"f8b32d99-e10d-4e9d-b2cf-02d421202d9c","text":"Ukraine says Crimea is experiencing a drought."},{"id":"a53beda4-d9d7-4a1d-b20e-c55ef5fdc365","text":"Ukrainian teenagers have the lowest average IQ of all European countries."},{"id":"9dc49aa7-fb08-4c49-ab0d-d233037511f7","text":"A Ukrainian admiral praised Russian military might in Crimea."},{"id":"9afd40ce-83d2-4ba6-b3d4-846849c4f834","text":"Antisemitism has increased in Ukraine."},{"id":"55d2779c-e217-438b-a824-b709c22a345c","text":"The DTaP vaccine causes sudden infant death syndrome (SIDS)."},{"id":"0dfab435-0854-4cbc-ad80-25e02d0ed5b4","text":"Russia is launching an offensive and foreign embassies have evacuated Kyiv."},{"id":"012f7414-c063-4bb0-821e-03ae3200a374","text":"A volunteer in Oxford University\'s COVID-19 vaccine trial died."},{"id":"16679f67-f92b-4c97-8b93-52f58e61267c","text":"Russian forces landed in Odesa, Mariupol, and Kharkiv."},{"id":"4a4dc838-cdb8-4cd2-a8e8-b7565b489463","text":"A person is 300 to 900 times more likely to die after receiving the COVID-19 vaccine than after receiving the flu vaccine, and vaccine adverse events are widely underreported."},{"id":"5bd060ce-e57a-4b9e-8ce7-adb07d86cbe0","text":"Ukraine\'s Health Ministry abandoned cancer patients."},{"id":"a367c419-5c06-4d96-b3aa-e68d07bfe89b","text":"A Yale study found that COVID-19 mRNA vaccines cause vaccine-acquired immunodeficiency syndrome (VAIDS) and post-vaccination syndrome (PVS)."},{"id":"2d2a3a96-0b99-495f-8ccf-3917ec3328a7","text":"Pfizer documents confirm mRNA COVID-19 vaccines contain graphene oxide."},{"id":"f56313c6-4c1b-41ae-abb7-5b3adcd6fcda","text":"Western media disclosed that American mercenaries are fighting for Ukraine."},{"id":"2db09ac7-7480-488d-95a4-cd52c3d6852d","text":"Flu shots cause false positive COVID-19 test results."},{"id":"76c5a892-9eec-44fb-b18a-8dc8f6ec54d5","text":"A photo shows Ukrainian tanks gathering in the ATO area in Ukraine."},{"id":"1975bd25-208c-49f9-81ab-e7ba511bdcd1","text":"The Moderna and Pfizer vaccines contain a bovine protein that causes an autoimmune response in recipients, making many of them unable to eat beef."},{"id":"c2f9ead9-e144-4a77-a370-18b0e465aa10","text":"The Pentagon will not use $5.8 billion allocated for aid to Ukraine by the end of the fiscal year."},{"id":"0518a0f6-d6fb-445b-a6b2-de32bb4966d7","text":"The SBU concluded that Russia did not murder Andriy Parubiy."},{"id":"87b8a5d6-25e2-4a58-b32f-2b9fd63d7259","text":"Scientists ignored solar particles, cosmic rays, the interplanetary magnetic field, and Earth\'s weakening magnetic field and concluded that climate change is caused by human activity."},{"id":"ea68f6bb-d8e9-4d0b-9fac-e359016c7dbf","text":"The WHO declaration of a public health emergency is a scheme to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus rebranded."},{"id":"ab184fe7-413c-4714-9a1b-9f2c04d1ded4","text":"Kyiv will cull stray dogs for the Eurovision Song Contest."},{"id":"c4b7ef6a-e82f-45ce-9dc2-1ef84742ea6c","text":"The Ukrainian Army is funded by money from Viktor Yanukovych."},{"id":"21557975-8f55-475c-9113-1599cc88d48e","text":"Ukrainians will participate in the Syrian war."},{"id":"87c7e218-1700-44f0-8a1e-ccef92bb6df1","text":"Most victims of the 1918 Spanish flu died of bacterial pneumonia caused by wearing face masks."},{"id":"346f5eac-8083-44de-a2a5-c22b0a3c68b0","text":"Valerii Zaluzhnyi told Ukrainian soldiers not to fear death because they had no chance of survival."},{"id":"e4b05630-1cf1-473b-9935-4d9df2441747","text":"France\'s best sniper was killed in Ukraine."},{"id":"59db8bb7-8c32-4cb4-b93a-9377f27e5bb9","text":"The Ukrainian government is repressing ethnic Hungarians in Transcarpathia."},{"id":"214150b4-7ba4-4e26-99e8-8ca6b7d24035","text":"NASA officially recognizes Crimea as part of Russia."},{"id":"867c8371-61c7-4133-9fe0-a60250a5dafa","text":"Ukrainian TV channels are forbidden from broadcasting footage of a handshake between Vladimir Putin and Petro Poroshenko."},{"id":"7d1184be-08c7-4303-bb74-bb6301ab3676","text":"Grid batteries are fire hazards."},{"id":"3f363d10-544f-4a29-bd9f-7e7a84fd3014","text":"The two largest banks in Ukraine will default."},{"id":"be5ca216-b212-4b53-8373-356a889d9f75","text":"COVID-19 vaccination of pregnant women caused an increase in the U.S. infant mortality rate in 2022."},{"id":"992e777b-2d2d-4164-9166-21819ed67314","text":"Governments and health authorities lied about COVID-19 case numbers, treatments, natural immunity, and the virus\u2019s origin, and COVID-19 vaccines and control measures did not work."},{"id":"67d60464-0d44-475b-a6ff-e2ba49d1366e","text":"The UN confirms that a Ukrainian military strike in Odesa caused no injuries."},{"id":"7089e061-f356-4b79-b1f2-651d5988f658","text":"80% of people who received the Moderna COVID-19 vaccine experienced significant side effects, and children in Sudan contracted polio from the polio vaccine."},{"id":"e57ae7e6-185e-465f-bf0a-b4ae49ea0b5b","text":"Ukrainian train security detects passengers who oppose the Zelenskyi regime."},{"id":"28d0a5e2-e288-4da3-865d-b61255d8b0a2","text":"If I don\'t get the vaccine, only I will be harmed and no one else will be harmed."},{"id":"1d882ab7-3448-4e70-aceb-c9654f71e66b","text":"The United States violated the INF Treaty."},{"id":"6e785240-8ffb-4abe-a014-d7a8b7f6fb74","text":"79.4% of infants who died from SIDS received a vaccine on the same day they died."},{"id":"3bd375a2-f60c-4e67-95d2-8dd33dda54c4","text":"The EU and US accuse the Kremlin of disinformation and hide their pandemic failures."},{"id":"a6a36d51-bf43-429e-ace3-d335b25e878a","text":"UK government Vaccine Surveillance Reports show fully vaccinated people are developing AIDS."},{"id":"37bec350-cb9c-4cf5-b0e9-f634d9686f01","text":"President Joe Biden told people to get vaccinated to protect themselves from hurricanes."},{"id":"d365e127-d27c-4834-a1de-fc0930515ddd","text":"A World War II veteran was beaten in Kyiv."},{"id":"ebf98039-232c-4282-8676-4453abfe60ac","text":"The UN Secretary\u2011General has launched tribunal proceedings against Petro Poroshenko."},{"id":"b8b39438-ddcf-47ac-852c-d9a001d59edf","text":"A California study found vaccinated individuals are more susceptible to COVID-19 variant infections than unvaccinated individuals."},{"id":"b8b3465b-e078-4efb-ae6e-e6a1726f2fa9","text":"Vaccines contain the complete genetic code of an abnormal human containing cancer-causing genes."},{"id":"5ab140aa-857e-442d-bd98-0f4a3815b9bf","text":"Charcoal absorbs and neutralizes poisons and treats diarrhea and bloating."},{"id":"b0ba9c40-a67a-46d7-b196-e03f3c5aaa9c","text":"Erdogan says Turkey will build a nuclear bomb."},{"id":"1dcbd6fb-23d1-4f37-8d0b-c3715e918db3","text":"Babies born to mothers who received COVID-19 vaccines are dying at higher-than-normal rates and the COVID-19 vaccines caused those deaths."},{"id":"41702860-e9aa-4135-bcb7-e01f4817b34d","text":"The German Foreign Minister said that supporting Ukraine is more important than the interests of German voters."},{"id":"cd7c217a-f1df-4b12-ba39-e679935643a3","text":"COVID-19 mRNA vaccines alter the human genome; SV40 causes cancer in humans; regulatory agencies knew COVID-19 vaccines were contaminated."},{"id":"ae993dea-9d4f-41e4-9864-aa6def24b890","text":"Erecting a single wind turbine produces a staggering quantity of CO2 emissions, and a significant proportion of retired turbine blades are sent to landfill and cannot be recycled."},{"id":"d18ea420-7fc8-4f4d-b3f8-69befdaee398","text":"COVID-19 vaccines cause more hospitalizations than they prevent."},{"id":"82223086-44ab-4f8a-bb20-2469fbc0fe5f","text":"Ukrainians were detained at the Poland\u2013Germany border."},{"id":"970dbc26-0b71-46b5-9e3b-d3d66cffe827","text":"Coral cover on the Great Barrier Reef is at record-high levels, and the Great Barrier Reef is not threatened by climate change."},{"id":"6ae0e573-7a63-4ebf-8915-b6673547e7a5","text":"This is a brush rake used to clear underbrush and forest-floor debris that creates fuel for wildfires."},{"id":"1cbefbd5-9c0b-427d-bb6e-c17b315e53bd","text":"Ukraine recognizes a one-legged person as fit for military service."},{"id":"0bccaf8d-81f8-4dc6-a43b-f49b0a453569","text":"Kyiv admits it shelled civilian areas in the Donbas."},{"id":"11066e29-dc62-4fd0-83f9-58da50d5bc4d","text":"E-cigarettes cause milder lung damage than combustible cigarettes but cause equal or greater harm to the cardiovascular system than combustible cigarettes."},{"id":"66083cd8-4f78-4c40-aaea-4e52211f0454","text":"A chemical in Cheerios and Quaker Oats causes infertility and delayed puberty."},{"id":"e37a656e-2b55-482a-a4d0-7e3cc66ebe0b","text":"One in every 500 children under five who received the Pfizer mRNA COVID-19 vaccine was hospitalized with a vaccine injury."},{"id":"05bdc8cc-dd35-4620-a59d-ec3c72ed2731","text":"Vaccines did not eliminate polio."},{"id":"65cbc702-99e8-4621-8a81-899b350a7a83","text":"Russian media reported that a football player was appointed as ambassador."},{"id":"7b229a8c-d88f-46c0-b447-c58879a2e92e","text":"Pfizer\u2019s COVID-19 vaccine causes \u201Cturbo cancer.\u201D"},{"id":"7a9d517e-5f42-4e1c-8c54-b33b67939c08","text":"The United States State Department recognized Vladimir Putin as the President of Russia."},{"id":"5e4f1ea6-61f3-40d0-a513-02d3958732cf","text":"Food supplements restore perfect blood sugar levels and cure Type 2 diabetes."},{"id":"e33b45ec-40c9-4bac-a8d9-ffdf4be25ed0","text":"An Italian landmark collapsed because Italy diverted public funds to Ukraine."},{"id":"de88b89a-982e-47ea-8d7a-c0b2fbd6dabb","text":"Changes in Earth\'s orbit and axial tilt are responsible for the observed warming, and humans are not warming or cooling the planet."},{"id":"0ee2c48e-a733-454d-8a13-3b84573113c4","text":"COVID-19 vaccines are experimental."},{"id":"26d73c11-429e-418c-917d-8941d43cf025","text":"A Ukrainian town asked President Vladimir Putin of Russia to provide natural gas."},{"id":"a3cb0615-5ec8-4cff-ae0d-afc22f1c70c2","text":"Trump persuaded Putin not to strike Kyiv while Western leaders were in Kyiv."},{"id":"426cabef-a0b8-48c3-b48a-30b49a193166","text":"COVID-19 vaccinations caused an increase in COVID-19 cases."},{"id":"225bd941-a6dc-49cf-af65-19811da32bf6","text":"The Sun, not human emissions of carbon dioxide, is the main cause of warming in recent decades, and the UN IPCC systematically biases its data selection."},{"id":"20dc25ab-5389-4dff-a43c-dfe9d7bfc7ce","text":"Ivermectin and fenbendazole cure stage-four cancer."},{"id":"a15196b8-40cf-4a2e-9b8d-b3d7e099060c","text":"Russia has no obligation to Ukraine under the Budapest Memorandum."},{"id":"19b94fb9-4b53-49f7-a541-698272ac5600","text":"Ending trade with Russia has destroyed Ukraine\'s economy."},{"id":"a8f04bd3-0b9f-4afc-9958-ee3fd9b741a1","text":"Germans are uneasy about the Ukraine\u2013Russia debt repayment lawsuit."},{"id":"3992463a-fde6-4ecd-b942-29d355ec638b","text":"Solar panels heat up their surroundings and harm the surrounding environment."},{"id":"d465212c-f927-43a4-9067-b9959b145c98","text":"Colloidal silver is effective for all infections."},{"id":"8dd89c11-2e8d-425a-b0b7-0d1e37f27418","text":"The coronavirus is as deadly and as dangerous as seasonal flu."},{"id":"46def0c8-57f7-4a96-b04c-91488bfcbbe6","text":"Russia is the top importer of Ukrainian arms."},{"id":"01d537f0-cceb-4074-a220-f7352b73d9af","text":"The bodies of 286 women were found near Krasnoarmiisk."},{"id":"3eaa9fd6-d488-4d05-bb97-db904c045b1f","text":"The pandemic is over in the UK; most people already had prior immunity and the UK has reached community immunity; viruses do not cause waves."},{"id":"6834f333-8ff8-4fa0-830a-d95ad9536868","text":"Children with mitochondrial disorders are at increased risk of severe adverse reactions caused by vaccines."},{"id":"34d3a385-3440-4419-813f-5a6f201b8e8c","text":"The MMR vaccine contains toxic ingredients that cause encephalopathy."},{"id":"3b05075a-6249-4034-8d5f-0b4b61ae375e","text":"In the UK, vaccinated people have a higher SARS-CoV-2 infection rate than unvaccinated people."},{"id":"9b905695-6c43-4956-b510-5ede2c0cadea","text":"Hydroxychloroquine, azithromycin, and zinc cure COVID-19."},{"id":"9edfd059-7cba-4282-b685-3ff4a5c6784f","text":"Josep Borrell supports resolving the conflict in Ukraine by military force."},{"id":"1c5f3940-618f-445f-8bae-498cf3a57328","text":"New research shows the COVID-19 vaccine spike protein enters the bloodstream and causes blood clots, heart damage, and brain damage."},{"id":"5187f6b9-b01a-48c8-a5cb-7b50f59b98cd","text":"The MHRA has declared COVID-19 vaccines unsafe for use in humans based on Yellow Card evidence."},{"id":"7c020a8b-3a1d-4bf5-9b2b-f68ed67a83ce","text":"Scientists found that the SARS-CoV-2 virus contains a tiny DNA sequence identical to a sequence patented by Moderna three years before the pandemic began."},{"id":"0097c1c4-91ca-4efc-9c12-92cb73fe1d48","text":"\\"Ukraine\'s EU Association Agreement was a five-year disaster.\\""},{"id":"fadaf7a0-1951-41a0-be28-ce7cbbfd2e13","text":"World Jewish Congress recognizes Crimea as part of Russia."},{"id":"75fd2ea3-890e-407e-bc4e-bb4dcffb1d52","text":"The most vaccinated communities have higher COVID-19 case rates than less vaccinated communities, according to a Harvard study."},{"id":"c1e9c5d8-d9bf-4f24-a146-4466e09a1c9c","text":"Ukraine had no money to host Eurovision 2017."},{"id":"7d63bb14-86c5-4e7c-9908-d12838f5a1e2","text":"N-acetylcysteine inhibits viral replication, breaks up mucus, and effectively treats COVID-19."},{"id":"53b2073c-0f69-4c80-b1f7-2216bcce8ae6","text":"COVID-19 vaccines are dangerous: they cause immune overreactions, suppress natural killer (NK) cells, and increase virus lethality."},{"id":"efb2f3a4-4a6f-4b82-891a-6e49b2a5f523","text":"People who receive vaccines authorized under Emergency Use cannot sue the manufacturers; once those vaccines receive full approval people can sue the manufacturers, unless the vaccines are recommended for children, in which case people cannot sue the manufacturers."},{"id":"f5b4fc6e-6e89-47bc-924f-48d1652def42","text":"Dr. Anthony Fauci said he wore a mask indoors for appearances, not for scientific reasons."},{"id":"e7a172a6-e210-4871-ba5b-5beab36f133e","text":"Ukraine is preparing a nuclear provocation in Kharkiv"},{"id":"4afb68a8-bbcc-4e8d-af34-d5edf6095e82","text":"A hepatitis A epidemic is occurring in Ukraine."},{"id":"46b182ba-f8b0-486e-a971-d6d8d29dcfef","text":"Many locations warming faster than the global average proves climate science is false."},{"id":"2469a626-6d12-4a3f-8609-e8853ef4366b","text":"Human actions caused more than 100% of the global warming over the past century."},{"id":"3eaa4b01-8d12-46ab-ab47-1870221edd96","text":"The Ukrainian government will introduce food ration cards."},{"id":"246ad0b2-a33b-4452-9680-a021c86e97e5","text":"ISIS operates training camps in southern Ukraine."},{"id":"37499fab-2fe7-40bd-b11e-ab87731202f7","text":"Crimea has disappeared from the international agenda."},{"id":"91a4d43b-edc0-49ec-b3bc-3867f659b730","text":"Russia destroyed several HIMARS near Kharkiv"},{"id":"189f80a7-6ff9-4b7b-903d-887d097cff2b","text":"The flu shot contains ingredients that cause cancer."},{"id":"6a75e685-16dd-40a9-943b-267048380ebe","text":"Ukrainian mines are killing soldiers and children in Donbas."},{"id":"f0a2c749-6388-420c-bdf9-1c4ee803e96d","text":"Poroshenko announced that Ukraine should align its policy with Russia."},{"id":"02810d0a-a801-4de0-844c-925df942cad1","text":"COVID-19 vaccines caused the rise in heart attacks among young people."},{"id":"ea9527d3-b5f8-405d-9e71-493a16e21670","text":"Ivermectin sterilizes 85% of men who take it."},{"id":"fe728252-2f9c-4815-b02f-7699b2550a2e","text":"Russian shelling in Ukraine caused an explosion that damaged an OSCE vehicle."},{"id":"d7aca388-acbd-4f7f-a855-c7d5c20fa685","text":"The U.S. government has paid over $4.5 billion since 1986 to individuals for vaccine injuries, so vaccines are unsafe."},{"id":"429e49d4-f23e-4cc2-a86b-ee2c5103945b","text":"Separatist forces regained control of Avdiivka."},{"id":"7ae75a6a-6f33-4618-8d40-749b6de55028","text":"Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, and shikimic acid kills viruses including SARS-CoV-2."},{"id":"c8ea9f81-466b-4497-b45d-3223d1ee8247","text":"Ukraine national football team excludes Roman Zozulya from its roster."},{"id":"72eaf4c2-1ace-4637-a279-69574883c8d2","text":"Massive COVID-19 outbreaks occurred among Ukrainian military personnel during NATO exercises."},{"id":"465bece8-37d9-4e52-a1ec-faf9186dca40","text":"Ukraine banned music performed in the Russian language."},{"id":"3a116cf1-f864-46f2-91a3-8becc0027791","text":"ADHD is a fabricated disorder created by pharmaceutical companies to drug children for profit."},{"id":"e16ed705-04cc-4390-aca3-42a049dd05bc","text":"A preprint of an ivermectin study in Itaja\xed found that prophylactic ivermectin reduced COVID-19 hospitalization and mortality by 50%."},{"id":"a587e2e2-5f98-4b88-911b-409af3406d82","text":"Dr. Fauci said the COVID-19 vaccine that appeared safe in initial trials makes vaccinated people more likely to become infected."},{"id":"b49e3698-2d1f-4006-93ae-7a09a858e833","text":"The graves of ATO soldiers were bulldozed."},{"id":"6b2476c6-a052-47ae-a228-56b6f553ca74","text":"The EchoEase nasal inhaler cures tinnitus."},{"id":"23ca88b5-5732-4b74-9c33-93b2fdb7eb32","text":"Vitamin K injections are poisonous because they contain polysorbate 80 as the main active ingredient and polysorbate 80 causes infertility and autoimmune disorders."},{"id":"fd8ab294-5b27-4e9c-825b-ec44b6ba1867","text":"Deserts produce heat by reflecting 60\u201370% of incoming solar energy back into the atmosphere, and addressing global warming requires acting on deserts."},{"id":"5602148c-549e-4749-84e9-dad0aa357385","text":"Poppers cause Kaposi\'s sarcoma."},{"id":"323c6763-57ea-48ee-87c5-c6eafc928cae","text":"Biden admits he is afraid of the Russian Kinzhal missile."},{"id":"c4274737-78c6-4b47-a485-ba7aa9e58eec","text":"Nattokinase dissolves the SARS\u2011CoV\u20112 spike protein, and long COVID is caused by persistent spike protein in the body."},{"id":"b71c4569-f760-4ec8-98df-cec6d9c6793f","text":"44% of pregnant women in Pfizer\'s COVID-19 vaccine trial miscarried."},{"id":"7f7a99d7-4cf6-44b2-b0b6-0de0e235dc3d","text":"Ukraine increased its territory."},{"id":"4dc63b6d-f7f6-4201-81db-2a5e9c6a5198","text":"Ukrainian military fired on civilian vehicles in Donbas."},{"id":"5bec62cc-de7e-4032-87af-d61602c98417","text":"Kyiv will close its nuclear power plants because it lacks enriched uranium."},{"id":"a164e5e1-6c36-4c70-b5c6-9787277d7cf5","text":"Covid-19 vaccine mRNA cannot be broken down and Covid-19 vaccines cause excess deaths and unprecedented blood clots."},{"id":"23c7ac75-736f-4aea-833a-28c03650c893","text":"NASA says a deepening solar minimum will cause cold weather to grip the world."},{"id":"0b283a06-4ee5-4503-bfe0-9b2beb8081b2","text":"Flu vaccines do not protect, they increase the risk of getting influenza, and they damage the immune system and the nervous system."},{"id":"bb8efabd-a8bb-4e5f-bd1c-fd5a7bc57468","text":"The NATO chief said the Alliance has been preparing for war with Russia for eight years."},{"id":"59410815-11d4-4a2e-9972-0e45092f256c","text":"Kyiv is preparing a PR operation targeting Crimea to disrupt Crimea\'s tourist season."},{"id":"0162d47f-70f8-40f8-a6d6-321e1f67464b","text":"Boris Johnson is tired of Ukraine."},{"id":"953328b9-1c72-4ae1-9261-3d122cdf3d99","text":"Oceanic pH levels did not decrease over the last century."},{"id":"ed2428ab-ce07-462c-904c-9122cd1ba168","text":"Coconut oil cures Alzheimer\'s disease."},{"id":"a7a7f1ae-fd6b-4da5-b669-3516ad890958","text":"Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide."},{"id":"8477b1b0-2cb7-48d0-b224-7367c519ff94","text":"The WHO says children must not receive COVID-19 vaccines."},{"id":"d1122fc8-22ba-49ee-b1a7-b0292caeea93","text":"A Donetsk People\u2019s Republic separatist fell from a tower while hanging the Donetsk People\u2019s Republic flag."},{"id":"e048a637-c913-454e-b38a-9e567b3309fe","text":"The Kyiv government tested dangerous drugs on its own citizens."},{"id":"1b2b8340-6e26-4af6-99f1-7a2fe4c25820","text":"Melanoma did not exist before sunscreen was invented, and low vitamin D causes melanoma."},{"id":"8f2585bf-bc2a-41f3-af10-5a7cef3a2716","text":"Poroshenko says returning Crimea is unrealistic."},{"id":"7494523e-d14d-462e-8096-f2fcaa9cced4","text":"Babies under 6 months have the second-highest hospitalization rate after elderly people."},{"id":"363767c1-812f-4b42-8491-a284197694ba","text":"Ukraine is losing control of Transcarpathia"},{"id":"86364755-d394-481c-8c8c-312bdb7f9789","text":"OSCE walked out of Donbas talks because Ukrainian officials threatened OSCE delegates."},{"id":"60692431-97b1-4bfb-bcbb-9d32815dea0b","text":"Global media reported that Ukrainian refugees committed mass crimes in France."},{"id":"a9100648-867a-425d-b31e-08facd6d7ff9","text":"Transcarpathia has separated economically from Kyiv."},{"id":"0756090e-6ed5-4879-ba64-2fa9f664c398","text":"Four Ukrainian soldiers were killed in a mortar explosion."},{"id":"6766b9c1-406d-4828-8659-a18545ca193d","text":"Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS."},{"id":"0a153042-81b8-458e-b186-8360e0fbc2b5","text":"A photo shows refugees in Rostov being sent to filtration camps."},{"id":"a5fa33f1-9c5c-442c-a3b9-3e80c19749b3","text":"Ukraine\'s new language law violates Ukraine\'s constitution and makes violators criminally liable."},{"id":"d66f6d8a-9250-454f-b215-5b34d55b6e07","text":"Ukraine abandoned the Minsk agreements and is preparing to occupy Donbas."},{"id":"81a3712a-94f8-48c2-b3bc-6fb8cb3120ee","text":"A U.S. bowling tournament broadcast an announcement saying \\"Stop Funding Ukraine\\"."},{"id":"99d12199-f4f7-4c93-90b5-7946d74fedcc","text":"Pope Francis last spoke with Ukrainian President Volodymyr Zelensky."},{"id":"53402c0f-23bc-425f-b153-ce081085ebb8","text":"Most fully vaccinated individuals will develop full-blown vaccine-induced acquired immunodeficiency syndrome by the end of the month."},{"id":"21aa88dc-310a-45ee-845d-deabdbade650","text":"Maddie de Garay\'s case shows COVID-19 vaccines cause functional neurological disorder and are harmful"},{"id":"00df4a79-1dde-4f15-839d-cb6bf604c4a6","text":"Deaths occurring within 20 days of a positive COVID-19 test are counted as COVID-19 deaths regardless of other causes, and deaths occurring after vaccination are systematically excluded from being attributed to the vaccine."},{"id":"36577aca-4963-4024-a0a0-7ef666c33679","text":"Zaporizhia veterans were shown footage of Soviet soldiers raping Ukrainian girls."},{"id":"6a00b265-a1c2-4633-84bc-1379e6fb6b3f","text":"A nurse fainted after receiving a COVID-19 vaccine."},{"id":"edfafc83-4cde-4255-8a4f-9d89f0220509","text":"Anyone who brings a friend to a recruiting office will receive 20,000 hryvnia."},{"id":"6556fa0f-7605-4ab6-81a2-f99e0802e367","text":"The U.S. did not lose substantially more lives in 2020 than in 2019; the increase over 2019\u2019s 18,433 deaths was negligible."},{"id":"06292199-7dd0-43db-afde-7ae66493d4d5","text":"Carbon dioxide does not cause global warming; scientists are 90% sure the Sun causes global warming; ocean acidification and harm to polar bears blamed on CO2 are not real."},{"id":"f7fb6eba-fa20-46e4-a4e0-5a755dd9a270","text":"Smokers\' lungs turn black."},{"id":"a1a5269c-96c4-48bb-b8cb-6724368b2007","text":"2014 Ukrainian military losses are being passed off as current Ukrainian casualties."},{"id":"af39a7c0-63c4-43e2-aa19-fa2ce144ead2","text":"A child died in Donbas as a result of a Ukrainian drone attack."},{"id":"1c51ce2e-fda1-4273-aeec-c291f3c753bd","text":"A Morgellons cranberry-juice test extracts nanoparticles from chemtrails and air pollution."},{"id":"194c83a2-8011-41ad-84b4-5776ff4a4ccb","text":"President Joe Biden said Ukraine must give up territory to end the war."},{"id":"c89a8df6-10c4-42ec-ab6f-4f235f1d6fb3","text":"Pope Francis presented Russian President Vladimir Putin with the Guardian Angel of Peace medal."},{"id":"bd9fc77a-0eef-4c3a-ab91-047c2568670b","text":"Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children."},{"id":"5b288e9b-9de5-487a-af64-e3301611a079","text":"Greenland ice cores show no significant warming and human-caused climate change is false."},{"id":"8cb1b7e4-b0f6-4322-9523-e8c7544f76f0","text":"Boris Johnson was paid to pressure Kyiv to oppose peace talks."},{"id":"9120cc9b-5192-4ad3-9f58-f0d1f74efd73","text":"Dmytro Yarosh brought a machine gun to the Verkhovna Rada meeting."},{"id":"2e0827b1-fbe8-467c-989c-3d8579ac9421","text":"A new study shows climate change is greatly overestimated because oceans are cooling the Earth far more than previously believed."},{"id":"d34d499f-105a-42d9-83d2-ad2031a8f07e","text":"Vaginal gels with probiotics treat HPV infection."},{"id":"fcc04898-c13d-46f5-bf54-7bbe635d86ca","text":"Ukrainian children were forced to play with a stuffed toy depicting Adolf Hitler."},{"id":"098b52d5-8a51-4954-9bbc-1cc8535ba6dd","text":"CDC covered up a 1999 study showing a 1,135% increased risk of autism after hepatitis B vaccination."},{"id":"0c0e7306-ac48-4f56-8f28-b99b87fa1199","text":"A Coca-Cola product tested positive for Covid-19."},{"id":"b681fe85-1bd7-4f44-810c-0b62519a0c80","text":"In 1943 the Ukrainian Insurgent Army crucified four children."},{"id":"81f97fe6-7431-4f57-8955-2767cfc133ec","text":"Vitamin D insufficiency accounts for the majority of COVID-19 deaths."},{"id":"8b33178d-bada-4494-a9ee-81b8ccf9246b","text":"Global warming is only the recovery from the Little Ice Age; warming has been slower than climate models predicted; carbon dioxide benefits the Earth; global warming is not increasing the intensity or frequency of natural disasters."},{"id":"78cf9ac9-6b48-4912-a10a-e504a59deaa6","text":"COVID-19 vaccines caused 895 serious adverse reactions in military veterans."},{"id":"b1cec25b-6abc-42da-9d5a-2069e6d588fd","text":"European Court of Human Rights says the Russian government was not involved in Anna Politkovskaya\'s murder."},{"id":"e6280bcc-1394-4734-b33a-9210d5dd657a","text":"Vaccines cause autism, ADHD, and cancer; statins provide no benefit and cause cancer and memory loss."},{"id":"9cf61297-8c4e-46e4-8962-f26e488d9602","text":"Ukrainian TikTok users mock Charlie Kirk\'s murder."},{"id":"46e1bf37-c531-4407-93c4-8e1e35475b18","text":"COVID-19 cases are directly caused by exposure to 5G electromagnetic radiation."},{"id":"9aaa26b2-ed57-4999-90b4-829e65b1513e","text":"The video report showing civilian casualties in Ukraine was staged."},{"id":"ecec4097-a695-43eb-8b4c-422e968635eb","text":"U.S. forces will fight for control of the Kerch Strait."},{"id":"0445898d-c78b-4144-8eda-758b3dd164b9","text":"COVID-19 is caused by snake venom, not by a virus; COVID-19 vaccines contain snake venom that causes miscarriage."},{"id":"db280b6a-5898-4c98-a836-efb473b37d81","text":"No healthy child in the United States died from COVID-19; one in 2,700 people is developing myocarditis from COVID-19 vaccines; athletes are collapsing during play because the vaccines cause myocarditis; and Moderna filed a patent in 2019 that links the company to the COVID-19 pandemic."},{"id":"736c792b-c93d-4f63-a5ad-4cc89227466a","text":"Oxygen kills cancer; Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer."},{"id":"e4ed39b7-d2ef-4064-864f-d3c0ca196278","text":"Microsoft said the Paris Olympics received the most negative feedback in the last 10 years."},{"id":"b557e313-9c02-40c5-b077-13c10297f514","text":"COVID-19 vaccines cause blood clotting, infertility, and immune escape."},{"id":"87195b27-1879-4bb2-a3df-0a55408ef30d","text":"55,000 years ago global temperatures were 2\xb0C higher than today; current warming is entirely cyclical, human greenhouse-gas emissions are insignificant, and sea level rise will not occur."},{"id":"9d89afbd-42cd-4665-98a5-36d61a09dd4e","text":"The World Health Organization and the U.S. Centers for Disease Control and Prevention discourage people from wearing face masks."},{"id":"bfec0579-ba3d-4480-800c-a2af8552c46e","text":"The Swedish government pays 30,000 euros to each Ukrainian refugee to leave Sweden."},{"id":"e4bd9a5e-54db-49c0-bc0e-a1f3319f41b2","text":"A Ukrainian engine caused a Vega rocket to crash in Europe."},{"id":"223583c4-ea91-4fb0-bc4e-6603bd51303a","text":"Odesa has withdrawn from Ukraine."},{"id":"9da0944d-b296-4828-a890-95d79d08fc2e","text":"The woman presented as the heroine in the \u201CSloviansk Boy\u2019s Crucifixion\u201D report was found among the victims of the Donetsk explosion."},{"id":"d4873ebc-9fb4-4d1d-b399-bd350edf35cb","text":"Masks do not significantly reduce transmission of respiratory diseases."},{"id":"37ddfba5-8974-4a9e-8af2-98d4b5a634cb","text":"Folic acid and similar compounds deplete folate, which is very serious for people with MTHFR."},{"id":"10eb4524-cc0d-4c59-9a55-9eb3bfdbcdb6","text":"Vitamin D is more effective than the influenza vaccine at preventing influenza infection."},{"id":"bb37d28a-8d63-40c8-8c8c-2980333262fd","text":"A video shows Kharkiv residents leaving the city en masse."},{"id":"ea43da93-e80d-4470-a29f-bd6a20784faa","text":"The United States is unhappy with Ukraine and is seeking to replace Petro Poroshenko as Ukraine\'s leader."},{"id":"084c812c-89ae-4e1e-8844-39f37dd38c4a","text":"Ukraine will intern millions of Russian citizens living in Ukraine."},{"id":"d552adef-ca70-4aee-9e7c-8fc83a25e7b4","text":"COVID-19 vaccination increases the risk of sudden cardiac death."},{"id":"fc71e4be-3c6e-47dc-a1f9-513916590b5f","text":"Climate models predicted three times as much global warming since 1988 as actually occurred."},{"id":"3de0f031-a44c-4ef8-b51e-ba461cde1b8f","text":"Ukrainian is an artificial language created in the USSR."},{"id":"eee9305f-cab5-431b-8ccc-1d1567aa3a30","text":"Fruits and vegetables with five-digit stickers starting with 8 are genetically modified and should not be bought."},{"id":"0c55e31a-c6b6-4d90-8886-b06d2e9921d6","text":"600,000 Americans die each year from COVID-19 vaccines."},{"id":"523cc482-5018-4a9f-bf89-01328f70f288","text":"Ivanpah\'s closure proves that solar power is unreliable."},{"id":"67bc5609-6f41-49d7-a47a-86971a7db8cd","text":"A former NATO commander praised the Russian army and said Ukrainian forces should surrender."},{"id":"53cde36e-b505-42de-bf4a-183b7e653698","text":"A Ukrainian fighting vehicle entered Donetsk displaying a swastika."},{"id":"97e719d0-06c0-4566-a327-e80ecfdb8eff","text":"The Ukrainian military hid ammunition at the Zaporizhzhia Nuclear Power Plant and attacked the facility."},{"id":"30f26d7e-7d65-4925-a45f-8b4a229e28e6","text":"Nationalists prevented a paramedic from saving a wounded person."},{"id":"1c45e614-e629-4df6-9c53-2c88e272a6be","text":"Ivermectin caused the steep decline in COVID-19 cases in Indonesia."},{"id":"15c44e96-a11c-4de9-bde5-402e1c42549f","text":"The United States deployed 400 mercenaries to Ukraine."},{"id":"78083908-48a8-4be3-a6be-474174355e21","text":"Britons want to end all military aid to Ukraine."},{"id":"b743e680-f8c6-4e72-9eb0-2f4ee2ae965f","text":"Natural immunity protects better than vaccination; unboosted people under age 30 had zero mortality risk; cloth face masks and school closures provided no benefits to children and caused harm."},{"id":"fac8cb04-fc3a-4229-9798-9943e1d279eb","text":"Sales of Ukrainian seat covers will revive Ukraine\'s economy."},{"id":"529a5652-12c3-477c-a97f-f03c0aea19ee","text":"Face masks do not reduce the spread of respiratory infections; COVID-19 vaccines are ineffective and cause more severe disease; ivermectin, vitamin D, and zinc effectively treat COVID-19."},{"id":"75d6e4b2-8ffa-4fe7-8847-527575597f9d","text":"India\'s most populous state has declared it is officially COVID-19 free after promoting widespread use of a safe, proven medicine."},{"id":"5c1096fe-d81e-469c-8dcf-ea91b134de78","text":"Herbs heal illnesses and Vitamin C does not, because the human body is not composed of any Vitamin C."},{"id":"ee76c9a0-f9fd-449f-a743-2d8ef8929e88","text":"The Odessa schoolgirl\'s suicide was caused by the May 2 events."},{"id":"9bbcb642-5a9b-4821-8e6c-4f6dbf879b9d","text":"Warsaw learned from Moscow how to silence hostile voices."},{"id":"968e7ea3-fda1-4688-8a28-4220eebe29f8","text":"A top Ukrainian commander threatened to stage a revolt if President Zelensky capitulates."},{"id":"9cb96040-8b46-46be-a544-c2ed6385b215","text":"The chance of dying from COVID-19 in California is 0.03% and COVID-19 is similar to the flu."},{"id":"7666b8ae-0dd8-44d7-b730-f29fb7e24f4f","text":"All long-term tide gauge datasets agree that sea level rise has not accelerated."},{"id":"a83189a8-34cf-457f-8d7a-64232125f4e2","text":"The injured child shown in Mariupol footage is not from Mariupol."},{"id":"8f1ab946-4c1c-47f4-9369-87bc4ede4612","text":"In the United States, a person is six times more likely to be killed by a doctor than by a gun."},{"id":"b61d27b5-67be-4aac-b991-4c463d94cb6d","text":"This is a brush rake used to clear underbrush and debris from the forest floor to remove fuel for wildfires."},{"id":"39baffd5-3aea-40f1-9530-55a17c607cfc","text":"Ukraine\u2019s General Staff extended the terms of service for conscripts."},{"id":"cd85dca8-d905-493d-aade-b80a44a8fdfb","text":"The COVID-19 virus does not exist and has never been isolated."},{"id":"13c7c5b1-2d5d-4435-981c-edecb42f0d70","text":"Turkey will seize Crimea and Donbas from Russia."},{"id":"c3cdb631-c5d8-40c4-9f1e-febbbfea5ca9","text":"Antibodies produced against the SARS-CoV-2 spike protein cause myocarditis."},{"id":"f898bd5b-3db6-4e02-9f4e-cca47361e39e","text":"The United States allocated $250 million to Ukraine to fund war and provocations against Russia."},{"id":"66c410df-05e4-49c6-bc27-30f7de73703c","text":"The U.S. Embassy in Kyiv and the U.S. Consulate in Odesa were evacuated."},{"id":"4117e56c-a08c-40fc-b996-98b43966f125","text":"Countries with higher COVID-19 vaccination rates have higher excess mortality."},{"id":"4591a46b-7300-465e-9949-03baf246f461","text":"Ukrainian water bodies have been contaminated by the rapid expansion of cemeteries."},{"id":"cf032c80-cd0b-48d2-a3a5-3284519a1310","text":"Ukraine postponed salary increases for its military by one year."},{"id":"1e50fdeb-c36d-46b3-802d-22f9866e50f4","text":"Twenty-five percent of Ukrainians consider themselves Soviet citizens."},{"id":"a5966d2a-f407-47e3-8a42-4a1282f0e485","text":"Climate scientists disagree about how much warming is caused by human emissions and whether that warming is larger than natural variability from the sun and volcanic eruptions."},{"id":"102b1f5f-acda-48b1-9991-3270e7b4d909","text":"The United Nations recognized Crimea as part of Russia."},{"id":"18f01061-511e-40a4-9d51-74d81fda04d7","text":"More than 70% of Ukrainians are willing to compromise with Russia to achieve peace in Eastern Ukraine."},{"id":"48aa9679-9512-43c5-ae3e-ddb6dfbff73a","text":"Cats carry coronavirus and infect humans"},{"id":"ef6b9f01-065e-4d04-8b3a-f7447639a20e","text":"Ukraine is hiding recordings of the Malaysian Boeing flight controllers\' conversation."},{"id":"28d0fac9-14f5-448d-8b53-8c0cb4dd9579","text":"A major autopsy report shows people who died suddenly were killed by the COVID-19 vaccine."},{"id":"79bf234f-2f4a-4563-8307-083e1161440a","text":"Ukraine is preparing an attack on Russian nuclear facilities."},{"id":"10fc7bc6-6b01-4653-899e-b1a4b55ea372","text":"The COVID-19 vaccine contains bacteria and HIV and prevents the body from making new white blood cells."},{"id":"ec13176c-6ccd-4e5c-961b-22ffa6e0dc69","text":"A Harvard study found vaccinated people are twice as likely to be hospitalized after exposure to the Delta variant than people with prior natural SARS-CoV-2 infection."},{"id":"f8f126a8-063c-48cb-8de6-8d604b399254","text":"Mass civilian casualties in the Kyiv region were staged."},{"id":"3417b059-848a-45db-b984-f5828b7e0775","text":"Antarctica gained ice from 2021 to 2023 and global warming is over."},{"id":"c3dff2e4-49e4-483c-9299-2dbfb10634df","text":"Recent climate change is caused entirely by changes in solar activity, and CO\u2082 has no connection to climate change."},{"id":"15c077bc-099b-4d93-8dce-aa71f092dea0","text":"A virus is not the cause of an illness; it is only a necessary factor."},{"id":"5312ee60-8654-44b5-baee-82132f069b57","text":"The U.S. government claimed vaccines gave far greater immunity than natural infection, that masks were effective, and that myocarditis was more common after infection than after vaccination."},{"id":"e8d68e32-e4be-43f0-a70a-913b968c2dee","text":"The OSCE found that Mariupol was shelled from Ukrainian positions."},{"id":"6111a086-ec30-4127-8141-62b797b6ac3a","text":"The U.S. is breaking high-temperature records much more often than it is breaking low-temperature records."},{"id":"e48cf645-1df7-4c3e-9a96-308dc5f930a6","text":"Human-caused carbon emissions have no discernible effect on climate; carbon isotope ratios show recent atmospheric CO2 increases were caused by expansion of a more productive biosphere."},{"id":"e435799a-de64-4c69-966c-d1f15a3485ac","text":"HAARP caused the recent floods in Spain, New Mexico, and elsewhere."},{"id":"6ab65c39-651b-4387-a0fd-0cef0e5e1e7e","text":"National Security Chief urges Ukraine to prepare for war with Russia."},{"id":"d0faad36-3549-4637-ac1e-26d0f3a435ed","text":"Russia sends only humanitarian aid to Donbas."},{"id":"632177bb-ffc5-4d67-afdf-5a819358649a","text":"Ukraine seeks to remove the Russian language from protections under the European Charter for Regional or Minority Languages."},{"id":"4a32340b-0dc2-4055-a540-4eba24f18316","text":"The UN admitted that a Bill Gates-funded vaccine is causing a polio outbreak in Africa."},{"id":"01bc9bbb-94b1-4953-ad41-e0012c776da1","text":"Anti-corruption probes uncovered offshore accounts and escape passports tied to Zelensky aide Andriy Yermak."},{"id":"08df049d-815e-43e2-a676-499d54cc9bf9","text":"Global warming stopped more than two decades ago, and half of the global temperature increase from January 1910 to January 2000 was caused by administrative adjustments."},{"id":"03652bb1-007e-45f9-8e4f-9f08d9cf265c","text":"Wearing face masks causes carbon dioxide toxicity and weakens the immune system."},{"id":"d22b31b8-a526-47bb-be4e-280c5072e0d0","text":"Peru suspended its contract to purchase Ukrainian aircraft."},{"id":"12cf2e50-bbba-4ffe-a538-dff6e687b7f3","text":"Poland is responsible for starting World War II."},{"id":"b7ffeacd-5073-4386-9bb2-5a80e5cba7bd","text":"COVID-19 vaccine contains an aborted male fetus."},{"id":"53a637cf-5570-40f1-b152-4d36671c4e62","text":"Ukraine pays four times more for gas than Russia."},{"id":"a0e03745-c934-4002-849b-279c0d7ca85d","text":"No Amish children have been diagnosed with cancer, diabetes, or autism; Amish children are largely unvaccinated; COVID-19 death rates in Amish communities are 90 times lower than in the rest of the United States."},{"id":"52c0e6c7-af69-4b03-90b5-60bd0aecb43b","text":"A Ukrainian missile struck a Kharkiv government building."},{"id":"a9720f8c-19bc-421d-a856-3a25464a4f11","text":"George Soros said that only Russia cares about Ukrainians."},{"id":"c3a50ba2-8f19-4548-91c1-576ba23fb11d","text":"The Ukrainian diaspora condemns sanctions imposed on Crimea."},{"id":"d41a6028-398e-4752-a435-f4dc2fff1a61","text":"Ukraine is preparing legislation to transfer Lviv Region to Poland."},{"id":"a136f141-6116-48cb-8ff4-a351e75c2348","text":"Ukrainian military personnel are defecting to the self-proclaimed Luhansk People\'s Republic."},{"id":"ba369e39-ec45-4ed7-93a9-3a04b478b590","text":"COVID-19 vaccines cause fibrous clots in the lungs and blood vessels."},{"id":"24af3b1b-9176-44bf-9cb2-d0a28e6191a2","text":"Corruption in Ukraine increased by 500% over the past year, and U.S. aid is not reaching its intended targets."},{"id":"dfbfe160-e97b-487b-bd63-6307020b0438","text":"Distributing weapons to the population caused crime to increase by 270%."},{"id":"8e703566-cce7-4eb6-b60e-6cbe8bda9bb2","text":"UEFA is investigating a Ukrainian team for doping."},{"id":"a117cf36-9039-43b3-b502-f38e0afc8153","text":"Some mouthwashes curb the coronavirus."},{"id":"d7fb78a5-05e9-4de0-b3a9-64b90fbd2106","text":"COVID-19 vaccination increases the risk of autoimmune rheumatic diseases."},{"id":"72b10684-8987-4e6c-9934-4701614da7c1","text":"The New York Times calls for redefining death in Ukraine to permit harvesting organs from living people for transplantation."},{"id":"fe24812a-97c6-476c-9baa-1103a9653551","text":"Scientists and policy-makers agree humanity will pass a point of no return once global mean temperature rises above 2\xb0C."},{"id":"52896f5f-991a-4b65-a529-2f922b6a31ea","text":"Published studies show COVID-19 mRNA vaccines cause metabolic cardiomyopathy and sudden cardiac death."},{"id":"3f914465-e5f4-4f05-84df-db17b776b2c5","text":"Dr. Robert Malone invented mRNA vaccines."},{"id":"6a84663f-f127-4280-96a3-0776bc7bcd78","text":"The COVID-19 pandemic was planned; COVID-19 vaccines are experimental and VAERS shows they have killed thousands; vaccine-induced spike protein causes damage; people previously infected have permanent immunity."},{"id":"14800c14-8301-405f-8273-4181fead0b91","text":"Wind turbines kill eagles, but more eagles are killed by other causes."},{"id":"4bd74752-050d-4066-aa80-69ad72c07ed1","text":"Ukrainian military used phosphorus bombs against Russian forces."},{"id":"1fdb61b5-3227-4c6c-b623-ee5994261c71","text":"Most Ukrainian refugees fled to Russia."},{"id":"db638b74-73a7-4ef0-a77c-7ee167075ba9","text":"Placing a raw onion on the soles of the feet eliminates illnesses."},{"id":"64d07b78-8176-4333-b0a9-435e55537cba","text":"50% of internally displaced persons from Donbas are unemployed in Ukraine."},{"id":"a68db6b4-00e0-44e0-a53c-7d461a4c5a33","text":"Russia returned captured Ukrainian ships as an act of goodwill."},{"id":"0bd91c7f-188d-4ac9-bfa2-ed23772b7839","text":"Anti-NATO protests occurred in Bratislava and caused public unrest."},{"id":"f9cf5e65-d39a-49cb-9e90-f611127654f5","text":"The Washington Post reports Western countries are sending weapons and troops to Ukraine."},{"id":"b84ae49b-ac57-4579-aa6d-644ea4a451ed","text":"Harry Hoxsey\'s herbal therapy cures cancer."},{"id":"751488c6-fb35-4d4a-b4ff-143b277d9a60","text":"Richard Bartlett discovered a silver-bullet COVID-19 protocol and was silenced."},{"id":"450057dc-4dee-4d4a-a352-f45e8a148e8f","text":"The National Guard committed the Saurivka Massacre."},{"id":"2ef546a5-b82b-4961-a634-d891566717cb","text":"Ukraine is a leading violator of Russians\' rights"},{"id":"fe072c3e-a390-4bfb-9639-e3d3aef7f89d","text":"The Normandy Format meeting was canceled because Ukraine failed to keep its word."},{"id":"9c4ee012-99d0-4552-8ceb-9444421b77dd","text":"Brain blood clots are 112,000% more likely to occur after COVID-19 vaccination than after influenza vaccination."},{"id":"a007fae1-b18b-474c-b05c-f4f09ad6ffa1","text":"The increase in cancer after water fluoridation began proves fluoride causes cancer and water fluoridation is public murder on a grand scale."},{"id":"f76c2b0d-e0db-45c6-be46-076f5caf99ad","text":"European governments accuse Ukraine of increasing radioactivity."},{"id":"9f7c75f9-12b1-4273-8a6f-ec449a5a3e40","text":"Face masks, vaccines, and frequent handwashing suppress our immune systems."},{"id":"10a1584e-2796-4a75-b1af-556789b76995","text":"Kyiv ended prisoner exchange talks with occupied territories."},{"id":"7659a98e-7d46-4a48-9bfd-b379e1608b2a","text":"No tests reliably detect the SARS-CoV-2 virus."},{"id":"e0de3107-736c-462b-88ca-80ac07a22385","text":"COVID-19 vaccines cause blood clotting, infertility, and immune escape."},{"id":"252cf072-286f-454a-a807-ea3fa5398883","text":"The World Health Organization is pushing a vaccine-based depopulation agenda across Africa."},{"id":"29ab53fe-1f96-4405-82de-f10f2733963e","text":"Carbon dioxide is not a pollutant; it is a harmless natural gas like water vapor and is beneficial for plants."},{"id":"d3611e87-51c2-4d02-85fa-7af37e6165b0","text":"WHO admits high-cycle PCR tests produce COVID false positives; WHO guidance includes lower PCR cycle thresholds."},{"id":"1bdcdd86-8b98-45b8-ade9-9162e65e0f28","text":"Mouth swabs are as accurate as nasopharyngeal swabs for COVID-19 testing, so nasopharyngeal swabs are unnecessary."},{"id":"363394df-152d-40b2-ac62-d490a96c6324","text":"55,000 years ago global temperatures were 2\xb0C higher than today; current warming is purely cyclical, human greenhouse gas emissions have no significant effect, and sea level will not rise."},{"id":"149651fd-033d-43b1-87d3-665446966eb9","text":"Poland is increasing its influence in the EU to settle old scores with Germany."},{"id":"9f730df3-0a30-4356-9fb5-3da44426f7ea","text":"Ukraine is a nuclear burying ground and is experiencing a second Chernobyl."},{"id":"52b34824-1373-40d1-83be-3018e61ae605","text":"One-third of Antarctic ice shelves will collapse due to global warming."},{"id":"dea6733b-6020-4f8a-bb8e-8c60954965b6","text":"The January 2025 Los Angeles wildfires were caused by non-climatic factors and were not influenced by climate change."},{"id":"ced68cf4-b495-4acb-a046-9612864342c4","text":"Ukraine sold Moldovan missiles to ISIS."},{"id":"94aaec06-525e-41e8-abea-4a063c8d258c","text":"Mikheil Saakashvili fired officials to save 4 million hryvnias to move his family to Odesa."},{"id":"7045d31a-2fff-4ed5-88f2-f70ba117865a","text":"700 Ukrainian prosecutors received combatant status during the full-scale war."},{"id":"c53e0722-31cd-4216-b4ae-898a6c808315","text":"Covid-19 vaccine mRNA cannot be broken down, and Covid-19 vaccines cause excess deaths and unprecedented blood clots."},{"id":"bb488946-5e6c-4e91-866d-5430c56b7ee1","text":"Russia saved the Zaporizhzhia Nuclear Power Plant from catastrophic conditions."},{"id":"ecae8d19-6ad9-4d7d-8d32-0bb0062c4bcc","text":"Asymptomatic carriers cannot spread COVID-19; COVID-19 is not contagious; masks are not needed to reduce COVID-19 transmission from asymptomatic carriers"},{"id":"a623bf10-1bc0-4bbe-a810-62f28445d4f5","text":"The use of chemical weapons in Syria did not occur, and the attempt to poison Sergei Skripal did not occur."},{"id":"968ad657-031c-49e2-963e-443fbd372a02","text":"Ukraine legalized private armies to fight in Donbas."},{"id":"0b793eb8-460d-4d54-a9c0-6fb4873518f9","text":"The United Kingdom invented reusable toilet paper because of anti-Russia sanctions."},{"id":"eeb9c461-a753-461d-8f50-a2404bad2189","text":"All signs at the Kharkiv Unity March were in English."},{"id":"feb308fb-89d7-4094-8142-ce7a2b1e6715","text":"Anti-Ukrainian billboards appeared in Poland"},{"id":"47d10127-8b88-453e-b9b9-9ac3fec996d9","text":"Biden\u2019s climate plan limits Americans\' meat consumption by 90% and restricts them to one burger per month."},{"id":"d4bb636a-ef12-4e0d-99ec-9d63b895cc16","text":"The Russian language is banned in Lviv, Ukraine."},{"id":"ad0d9484-a7cf-4622-9a6a-fc59f917b9ff","text":"The Pfizer bivalent COVID-19 vaccine causes strokes."},{"id":"06a3e8a5-24e0-404f-bdf4-12b6e222fc18","text":"China backs Russia\'s aggression in Crimea."},{"id":"1d51047a-8bca-4664-bba8-aabca8a4a441","text":"Medicare data show COVID-19 vaccines increase the risk of death."},{"id":"ef3d54fb-135c-4f91-83be-3f3bde8746d4","text":"Embalmers have observed that COVID-19 vaccines cause an increase in abnormal blood clots."},{"id":"fa57cb9e-6ccf-475d-8f43-70972d672647","text":"Poland is pushing for the overthrow of Belarusian President Alexander Lukashenko at the European Union level."},{"id":"07860eb4-7e2c-4546-9bc6-7ca701048da8","text":"Wisdom teeth are meridian lines connected to the heart, and removing them causes heart problems."},{"id":"f5be3f3f-5b0b-41e3-af54-35a878dd3fb8","text":"Mixing urine with salt determines whether a person is pregnant."},{"id":"1992dd80-35dd-46a9-bccd-0cf139aecbc2","text":"Eighteen proxy records show global temperatures were as warm or warmer 1,000 years ago."},{"id":"77d68ce8-66fc-42bc-a8d0-0495a4c960b6","text":"OSCE confirmed 29 civilians were killed in Donbas in late January."},{"id":"4ce202c4-ee9f-4ab4-bc4b-d87abc617ed8","text":"European countries cancel visa-free travel for Ukrainian travelers because of a measles epidemic in Ukraine."},{"id":"4ba11038-ee3b-48f3-94e9-85863cc1e604","text":"The Central Communication Port is being built to enable rapid transfer of US military forces."},{"id":"ce9c9e32-2219-4f66-83a7-989550bdabe5","text":"Increases in atmospheric CO2 are primarily caused by natural sources such as ocean outgassing, and human CO2 emissions are negligible in comparison."},{"id":"3b0b5562-9d6a-4197-a16f-1ad69b1cc4a0","text":"British military expert says Ukraine cannot retake Crimea."},{"id":"e04aabd2-3b11-4d85-9454-5293b1eef028","text":"Polish TV used a map that showed neighboring Ukrainian regions as part of Poland."},{"id":"f7759163-a314-4b80-86d0-b7637b3cd643","text":"Video shows people preparing body bags for an evening news clip during the COVID-19 pandemic."},{"id":"d9fca8eb-fc43-4ccd-866c-6a62a072e2f9","text":"COVID-19 vaccines cause menstrual problems in women and vaccinated people cause health problems in unvaccinated people."},{"id":"72f2090b-17c4-4faf-b2be-bc36323f1e2b","text":"A Russian strike caused a blackout in Odesa, and apocalyptic images from the blackout were shared online."},{"id":"64d045e9-0660-4692-b1f8-8b191f6cd9b2","text":"Colostrum improves gut health and boosts immunity"},{"id":"4b646847-1cb5-4f88-90a1-ce18b12cd313","text":"The COVID-19 pandemic is a planned, staged pandemic created by PCR testing, not by the coronavirus."},{"id":"2e13e180-291c-45bc-a491-c8cd8f430264","text":"A video shows an explosion at the Zhovti Vody uranium plant."},{"id":"6d117aeb-ccd3-4e78-8899-ddad3c137ea6","text":"The world\'s largest EV charging station is powered exclusively by diesel generators."},{"id":"de2c1ee0-8549-40d1-8446-21411e0d089a","text":"Hormonal birth control causes PCOS, hormonal imbalances, depression, and infertility."},{"id":"82c5ec92-7d92-4548-9470-04867fdf8828","text":"Studies prove geological forces, not atmospheric forces, are responsible for melting Earth\'s polar ice sheets."},{"id":"736d9e03-dc3d-4f14-8419-90e558838823","text":"Petro Poroshenko was drunk and removed from a Kyiv\u2013Moscow flight."},{"id":"ddce07da-f9dc-4166-932b-b52520d4d2b5","text":"Trump criticized U.S. aid to Ukraine and called Ukraine impoverished."},{"id":"ac90a491-ea82-4572-a011-004f6b3e29e7","text":"A photosynthesis study shows Earth is not warming as predicted by climate models."},{"id":"fc63bc3d-8079-4434-ba23-c70ccb3592a4","text":"Dr. Robert Malone invented mRNA vaccines."},{"id":"2c42f23b-b2e9-431d-951f-51cfe3051581","text":"Ukrainians called Russian children to stage a gas attack hoax."},{"id":"651343a0-1855-404e-9bca-18e93f2d5a77","text":"Birth control causes a far greater risk of blood clots than any COVID-19 vaccine."},{"id":"6181efef-91d7-46cb-be69-cbde16defa0f","text":"Eating specific foods based on your blood type optimizes your health."},{"id":"1abc1279-e2d0-4488-8b82-46263c61dcda","text":"Ukrainian refugees broke Van Gogh\'s chair in a museum."},{"id":"a6383900-6404-4d3f-8aba-0687e070ebc7","text":"Brigitte Macron\'s personal doctor was found dead in Paris and planned to reveal the First Lady\'s secret to the press."},{"id":"322008f0-3241-4a93-b5d4-df5fb6ca9a96","text":"Pathogens do not initiate disease; an acidic, compromised cellular terrain initiates disease and pathogens only appear as a result."},{"id":"45054bb5-98c4-4cfe-9680-35000796ee24","text":"\\"Vatnik\\" renounced Ukrainian citizenship."},{"id":"b49be27f-cd32-4e61-8e4f-45de2432e05e","text":"Dr. Anthony Fauci\'s 2004 interview remarks about the flu vaccine prove that natural immunity is the best protection against COVID-19."},{"id":"2b89486b-0ab3-4157-b0de-77774c409613","text":"A photo of shelling in Israel is presented as showing shelling in Donetsk."},{"id":"1abb2f07-9cf8-48b2-bbf1-d78cad1a62e4","text":"The Hague Tribunal will investigate Ukrainian crimes in Donbas."},{"id":"8d5d7861-9d12-4c60-805b-c0152ee0c78d","text":"More babies die from abortion in two days than have died from coronavirus so far."},{"id":"447dd20c-66d9-47e0-b122-5a27bc28aa15","text":"The European Court refused to return Crimea to Ukraine."},{"id":"82b3bde1-e7fb-4c19-b8d1-78fcf4f4f472","text":"Arseniy Yatsenyuk and Oleksandr Turchynov were booed and whistled at the Eternal Flame in Kyiv."},{"id":"e753e65c-048c-4f62-b90b-dce6303a03d1","text":"Exipure is scientifically proven to cause weight loss; BPS-5 effectively reduces blood pressure."},{"id":"c06a2666-40ff-496c-862a-430c79f26354","text":"Drunken US mercenaries rampaged through Mariupol."},{"id":"f8d94da2-78a7-41b9-bca7-32fc74a9adb4","text":"Petro Poroshenko calls for ending sanctions against Russia."},{"id":"e255c9b3-68b0-46d2-9a2a-ba4bcded54a1","text":"Scores of Ukrainian stars performed in Russia."},{"id":"ed417166-4ba2-4b0b-ac3e-6aa5232a0d5e","text":"Berkut commandos who refused to kneel were burned alive in Lviv, Ukraine."},{"id":"546e7fcd-17ae-4983-9cf8-82284e24b39b","text":"COVID-19 deaths were vastly overcounted."},{"id":"b4eee16f-516f-4bc7-a4e6-0ee7facbd68d","text":"COVID-19 vaccine recipients are ineligible to donate blood."},{"id":"706987e6-afc1-4f06-ad55-7a4abe9b2eb2","text":"Carbon dioxide does not control the climate."},{"id":"5501761a-5b10-4728-a8a3-305eed365584","text":"82% of women who received the COVID-19 vaccine between 30 days and 20 weeks of pregnancy had miscarriages."},{"id":"485705b8-64f1-4937-b4c1-475d0bf42370","text":"People who receive a vaccine under Emergency Use Authorization cannot sue vaccine manufacturers; after full approval they can sue, unless the vaccine is recommended for children, in which case they cannot sue."},{"id":"87aed28e-ad53-407c-a04a-af3b0e1015ee","text":"NATO is preparing for war with Russia."},{"id":"38e66b36-6f12-4189-883a-2d2e79d627a7","text":"The vaccine causes death in 33% of people, while the virus causes death in 0.06% of people."},{"id":"0a7a602e-58ed-48e7-880e-a6a2881376a5","text":"Vaccines, an MTHFR genetic mutation, and glyphosate exposure cause autism in children with brain injuries."},{"id":"2908fd39-9ca7-4a1e-984b-ef0485bb1cd8","text":"Ukrainian men in Germany are recruited into Ukraine\'s armed forces in exchange for German citizenship."},{"id":"e709b53a-f0b3-42a3-a3c9-f194801b8eaf","text":"A Ukrainian deputy minister called for using the Ukrainian army to retake Crimea."},{"id":"f3482401-f636-4769-8a6e-01b1b53ccd94","text":"Ukraine\'s credit rating has fallen."},{"id":"50dd51fa-63ef-4307-87b0-455a8d787703","text":"The American Journal of Medicine admits it was wrong about hydroxychloroquine and published evidence that hydroxychloroquine prevents COVID-19."},{"id":"c3d8d26b-ab72-4684-bfbd-296bbdcf9a7b","text":"Pope Francis congratulates Vladimir Putin on his presidential election victory."},{"id":"d283bd77-2689-4ff7-943f-a906148645aa","text":"Ukrainian food prices are equal to EU food prices."},{"id":"651a25ba-535b-453b-9f80-85525734d412","text":"Russia is depriving Ukraine of water from the Dnipro River by cutting off the river upstream."},{"id":"b4ca2a6e-2153-4976-9199-941915539996","text":"Raw thermometer data show the US cooled for 80 to 90 years, and official temperature graphs were altered to falsely show warming."},{"id":"95819ed2-6fea-4da0-8adc-b11616db0c19","text":"The Red Cross has ceased operations in Ukraine."},{"id":"f02ae4fd-dfd7-4a34-9d71-f0f3326534dc","text":"One vaccine injury occurs for every 39 vaccine doses administered."},{"id":"bbf92366-7621-4b54-878d-8d640f7d00ec","text":"Rising atmospheric CO2 has slightly cooled the planet."},{"id":"0c207476-8b95-45b5-8537-d0137808b419","text":"Ukrainian soldiers rejected a patriotic greeting."},{"id":"71ac27db-e609-47dd-9edc-ad973ee7832e","text":"The Ukrainian military violates the ceasefire most."},{"id":"6fd6f299-2bc5-4cd1-b7db-411b475af0f8","text":"Alzheimer\u2019s disease did not exist 40 years ago; cholesterol-lowering drugs and cholesterol-reducing diets cause Alzheimer\u2019s disease."},{"id":"d2e895d3-6f8f-45b0-8f2e-594dea520523","text":"The Red Cross says people who received a COVID-19 vaccine cannot donate convalescent plasma because the vaccine destroys SARS-CoV-2 antibodies."},{"id":"6c30c088-4430-4f1e-bea0-16e5f3939ba6","text":"COVID-19 infection fatality rate (IFR) is 0.1% to 0.3% and COVID-19 is as lethal as severe influenza."},{"id":"58ca5117-68d3-48a5-ba9e-c55f3b0c979f","text":"Conscription notices are being handed out at voting stations."},{"id":"ac00d441-3a77-4269-bcc6-e6e791cbb06e","text":"Zaporizhzhia City Council rejected the Ukrainian language."},{"id":"f0a1f347-7468-4968-8bf4-947f482fbd0c","text":"The governor of Kherson Oblast said that Hitler was justified."},{"id":"92e2aa1f-7896-4d02-b097-114d0eb2d684","text":"Denmark asked Ukraine to return military aid."},{"id":"c9ab584b-166f-48ee-93a8-a068efe520a8","text":"ICC arrest warrants for Russian military leaders have had no consequences."},{"id":"45b36f9f-2701-407c-bb41-2da5cf74f4da","text":"The Russian military captured Mariupol in less than one hour and the Ukrainian army was completely incompetent."},{"id":"f231c676-5eee-4509-9a0f-ae36631ff30d","text":"Vitamin B17 was banned by the United States because it kills cancer cells."},{"id":"2cc8f02b-f6f7-4b00-acbb-48afe8748ec0","text":"The Ukrainian government refuses to evacuate its citizens from Israel."},{"id":"44921dd7-fb68-4673-9d91-d3c7d39bf5ae","text":"An Italian restaurant advertises a \\"Diablo Zelensky\\" pizza topped with the bodies of Ukrainian soldiers."},{"id":"291156e6-b34b-454a-a4a5-234d1b5a9b37","text":"Vaccines contain toxic aluminum and mercury"},{"id":"bd51b6da-c68f-4d00-a66d-ac47ba7a5598","text":"Climate scientists say aspects of Hurricane Harvey show that global warming made the storm worse."},{"id":"385112f9-b5f3-4bdc-8cfd-95878a4457c1","text":"Vaccines cause autism."},{"id":"adc2e10c-ef34-40a9-a1b5-99f334f56fd7","text":"COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people are not a threat to vaccinated people."},{"id":"c0017158-5ec9-4fbc-8e2b-e5be9bf948e8","text":"Ivermectin and mebendazole are effective treatments for cancer."},{"id":"b16d536e-4a06-4640-a9ed-1354ae306aae","text":"Charlie Hebdo ridiculed Ukrainian fencer Olha Kharlan."},{"id":"5fc68f54-02e5-4dcc-bf66-6782dc973afe","text":"A pro-Russia mass rally occurred in the United States."},{"id":"c741471f-7be4-41e6-872b-a89b949145b6","text":"A NATO brigade arrived in Donbas."},{"id":"593862ba-9e8d-460c-b843-16a9919801bc","text":"Ocean acidification does not harm marine life."},{"id":"0683ebf0-51d7-446e-ae91-9a60cf532735","text":"The Ukrainian government in Kyiv forbids citizens from keeping in touch with Ukrainians in the temporarily occupied territories."},{"id":"c3a11704-5ca5-4d3b-b989-4151dca867dd","text":"Ukrainian saboteurs were intercepted in Luhansk."},{"id":"b658e2b4-f861-49b7-822f-9d60d545a8fa","text":"The United States banned vitamin B17 because it kills cancer cells."},{"id":"871435cd-e0dc-43c8-82ff-47803cfead5f","text":"Mammograms cause cancer."},{"id":"d9f0695f-a41b-4f1f-b51f-57d0a6859c8b","text":"COVID-19 vaccines weaken the immune system and caused a 20-fold increase in cancer in vaccinated patients, an Idaho doctor reported."},{"id":"fc39d71b-5191-4106-baf8-5af64493684d","text":"Ukraine will blow up 550 tons of ammonia in Novotroitske."},{"id":"1292f243-95fe-4e8d-b668-0561b4d9f934","text":"500 Ukrainian security officers block Kiev Street."},{"id":"e08a30eb-1c20-400b-8446-ac1b78bea4a6","text":"The Ukrainian army shelled Donetsk."},{"id":"98eff29f-6b83-432c-b28b-927ec4b83a7c","text":"A new study shows mRNA from COVID-19 vaccines is present in breast milk and is dangerous to infants."},{"id":"609f12e8-ad23-49e1-abab-57a8195e8af6","text":"Ukrainian Right Sector radicals attacked peaceful Russian civilians in Athens."},{"id":"b612352c-d6f4-4820-9245-cbdc7a728701","text":"The IPCC concedes there has been no increase in extreme weather events."},{"id":"f03f1e47-b185-4b08-8ff3-c014963ea848","text":"The EU provides financial aid to Ukraine in exchange for migrants."},{"id":"66154323-d238-462c-95db-6390cf14013b","text":"The United States will pay reparations to Ukraine."},{"id":"5923c121-b933-4b0c-8c5e-8ec99a127cec","text":"Natural immunity to COVID-19 persists for decades; pregnant women are not at risk from COVID-19; COVID-19 vaccines contain DNA plasmids; COVID-19 boosters are unsafe."},{"id":"ed2e0bed-abfb-497c-9ffb-c5fd005a4278","text":"Receiving more COVID-19 vaccine doses increases your risk of getting COVID-19, and COVID-19 vaccines contain DNA fragments that modify your genome and cause cancer."},{"id":"751252eb-c248-4e27-a607-510c64f2f866","text":"Ukraine lost 50% of its GDP due to sanctions related to Russia."},{"id":"6932d003-f34e-4235-87eb-e7cd45ec36c3","text":"The United States banned 155 imports from Ukraine because of Ukraine\'s political situation."},{"id":"e0fb6168-f755-420a-bba6-5da68728897c","text":"The son of a German tankman donated a World War II tank to Ukraine."},{"id":"ea294df8-d351-4b71-9ef7-6acdce1bdf21","text":"COVID-19 vaccines cause autism in rats."},{"id":"07112370-1b0e-4aba-9663-35f7e03a3646","text":"Ukrainian paratroopers infected fellow Ukrainian soldiers after training in Western Ukraine."},{"id":"75e6a60a-f387-4967-b042-d1c6fd158f36","text":"COVID-19 mRNA vaccines do not work and are causing serious harm, including death."},{"id":"f5b2b00e-ba38-4547-a0b9-3092f6091cef","text":"RSV vaccines cause deaths and neurological disorders, and the CDC covered up reports of deaths among vaccinated individuals."},{"id":"41ed43a2-38e1-476a-8304-8f12a9f67878","text":"Ukraine disrupted NATO\'s Sea Breeze naval exercises."},{"id":"05191600-57d5-415e-b4f4-c412f47f41a6","text":"Huge numbers of Ukrainians hate the Kyiv regime."},{"id":"9c495b9b-667e-433f-9dab-51269cfe4ea4","text":"The World Trade Organization forced Ukraine to buy Russian fertilizer."},{"id":"368de859-722c-4662-9e5d-083bd074caf0","text":"More than 200,000 people died due to the COVID-19 vaccine."},{"id":"457c7f59-3b69-4f57-a82e-eca71fe7656f","text":"Ukraine is Europe\u2019s poorest country."},{"id":"4d05a7f2-89f8-45fc-b32d-b3b1d5fec6f0","text":"Ukrainian military refused to help a teenager injured by an explosive device."},{"id":"3e3765b1-eaf3-4bba-9591-48394d3143e1","text":"A TIME employee posted a magazine cover showing Vladimir Putin labeled \\"Man of the Year\\""},{"id":"49603d79-aab0-4745-b291-b320f6ab4409","text":"Ukrainian women impregnated by Russian soldiers are forced to have abortions."},{"id":"f45aed36-6ef1-4d69-822b-6f2f4982179c","text":"Arms supplies to Ukraine are lost and unaccounted for."},{"id":"2a9844d1-065a-40c8-8cb6-dbf1cf798ff3","text":"COVID-19 vaccination increases the risk of myocarditis in young adults by 800 times compared with being unvaccinated."},{"id":"b3c74b9c-d96a-4447-9a9e-6a0ac43bec8d","text":"The majority of Ukrainians are waiting for Russia to rescue them."},{"id":"86ccc3a3-9bf2-4315-90bb-e4090352abc2","text":"Unvaccinated Amish do not get cancer, autism, or heart disease."},{"id":"2a625bb3-0488-4532-98e8-0cd6f90748c7","text":"Russian troops destroyed an oil depot in Syria."},{"id":"8bd6557f-ec53-4465-b0a8-3f71d5b51659","text":"A majority of Europeans oppose new sanctions on Russia."},{"id":"d337f025-3d3e-4881-9db1-26a9cc34fc60","text":"The increase in solar activity during the twentieth century accounts for 50% to 66% of all climate change."},{"id":"d118ff64-c246-49b2-b6dd-8119a5bdbd34","text":"A majority of Ukrainians oppose both the Ukrainian Army and President Volodymyr Zelensky\'s war in Donbas."},{"id":"5f5e53a0-8662-4d96-8adb-4d1f861b5ba7","text":"Benzene in benzoyl peroxide-containing skincare products causes cancer."},{"id":"5ca6668a-af13-413c-81ee-eadecac59929","text":"Ukraine\'s currency has collapsed due to the Turkey crisis, IMF actions, and the collapse of the National Bank of Ukraine."},{"id":"8a238a7c-f96a-415d-a339-07d5f96f0b45","text":"Germany has stopped supplying weapons to Ukraine"},{"id":"0fd219cf-7794-4e20-9d7a-bd0f952d8847","text":"Switzerland abolishes refugee status for Ukrainians"},{"id":"511305e3-08a8-47bd-ba35-92e850caf3d8","text":"Ukrainian National Guard soldiers are throwing the bodies of killed men."},{"id":"af738d60-42d9-4182-b743-c15060b3b799","text":"A Ukrainian crowd beat a Russian boy to death in Germany."},{"id":"6b296eea-2fd8-472f-9fea-997008bc21b3","text":"An autoimmune condition is the number one indicator of parasite infection."},{"id":"79868c5a-81e7-447d-9f0e-e7d3ced773f5","text":"Cultivated meat is made from cancerous and precancerous cells."},{"id":"1c742d5f-4f38-4dbf-a3f8-5ea02c118d90","text":"Russian language is being suppressed in Ukraine."},{"id":"fd2f32b7-550e-400e-a654-d1c8d25a01f3","text":"The ozone layer is healing."},{"id":"4b16a3e1-3eb3-4c01-9ffc-8e057a849168","text":"The Ukrainian military suffered losses in eastern Ukraine."},{"id":"d61a4f40-3482-4719-be2d-5a97dbe2f20d","text":"Ukrainian sailors threatened to return to Crimea."},{"id":"2edc566a-662a-48eb-9f6a-06f9b3f71ef9","text":"Atmospheric CO2 concentration is not correlated with global temperatures."},{"id":"3ef65eb1-1d0c-4cd8-873a-c2e6b2ec18d5","text":"The European Parliament accuses Ukraine of committing Soviet crimes."},{"id":"2fa3d5b3-e3dc-4d6a-9b27-00715d3ba168","text":"Ukraine will classify residents of Crimea and Donbas as terrorists."},{"id":"60e72e41-ea27-4630-b2b8-d2a69192d55b","text":"Vitamin D3 is irradiated sheep\u2019s wool mixed with chloroform and is rat poison; low vitamin D levels are caused by lack of sunlight and high vitamin A diets."},{"id":"9503763c-7449-4178-849e-610ba6134ea6","text":"Sunscreens and sunless tanning products cause cancer and contain cancer-causing ingredients, and the sun does not cause cancer."},{"id":"c225cecc-fbc4-42f9-b662-389b8449adc8","text":"Ukraine will lose several regions to Russia."},{"id":"57353be9-8323-4c01-a15b-a358286bcc76","text":"There has been no excess mortality from COVID; lockdowns do not prevent the spread of COVID; masks do not work to prevent transmission; PCR tests were not designed to diagnose illness."},{"id":"80f98ec2-b840-4020-a19d-c9ef321f581a","text":"A Ukrainian serviceman was sent to Avdiyivka to be killed for posting a TikTok."},{"id":"775ec7d2-331c-4113-ba9f-8ec35702f009","text":"A separatist was buried alive in Ukraine."},{"id":"dfaa1764-c3e1-450f-a71a-f7e11f966f70","text":"Vaccines caused autism to increase from 1 in 10,000 to 1 in 50."},{"id":"a2c95989-878c-4089-bb17-8155df3fcccc","text":"U.S. regions with higher average COVID-19 vaccine doses had larger increases in mortality in 2022 than in 2021."},{"id":"f9eac5f3-6751-4192-85e6-5ff9a684b5ba","text":"Medical exemptions are unavailable for people with contraindications to the COVID-19 vaccine, including those with a history of blood clotting or prior adverse reactions to vaccines."},{"id":"15ed2e39-9578-433f-ba74-c276daed508c","text":"Normalised Diatomaceous earth contains silica that absorbs minerals, water, and vitamins, and diatomaceous earth is antiparasitic and detoxes the body."},{"id":"ba280fb7-61fb-41f2-b800-9919def41677","text":"Vaccines caused an explosion in childhood cancer, and vaccine package inserts state vaccines were not tested for mutagenic effects."},{"id":"b401c9aa-19d5-40ab-8658-520adac91bd0","text":"President Poroshenko\u2019s confectionery company is opening new branches in Russia."},{"id":"45e9572f-4e25-4790-aee0-bebc5eb39d5e","text":"A survey found that the majority of Ukrainians liked living in the USSR."},{"id":"75da4af8-5a1b-4f40-9c0e-a2e1b8ff0482","text":"Oleg Sentsov has a star on the Hollywood Walk of Fame."},{"id":"640c728f-8be2-473d-ad7d-502c6a1e1829","text":"COVID-19 vaccines caused over 4,000 deaths; COVID-19 survivors cannot be reinfected and do not need vaccination; natural immunity is stronger than vaccine immunity; vaccine-produced spike protein is dangerous."},{"id":"913f68f5-8331-4420-bc8a-c649254faa99","text":"The Earth has cooled continuously for 4,000 years and is cooler now than during the Medieval Warm Period; reported recent warming is only an artifact of the measurement start date."},{"id":"bd9a9dd2-0105-4d29-a032-62bd305b6e43","text":"The Russian flag was burned in Belarus."},{"id":"3cfc2483-90d2-4c7a-8eac-a1fb89531809","text":"Patents for weather-modification technologies prove that HAARP and NEXRAD are used to manipulate hurricanes."},{"id":"addcb655-a008-4fe7-b130-ecc2ff51b64f","text":"The European Parliament says Kyiv cannot pay off its debts."},{"id":"d8a89786-9032-4e97-800a-d94a3e6cb02d","text":"The United States is preparing a new revolution in Ukraine."},{"id":"07c7eadf-eced-4f28-94d1-a3f3aff2b1d6","text":"Kyiv is blackmailing the West over Crimea."},{"id":"f6914820-56bc-429f-9a23-9ee686516844","text":"In the United States, doctors kill six times as many people as guns do."},{"id":"be368ea7-a509-48f9-a3c9-9d281436a081","text":"Leaky COVID-19 vaccines are causing SARS-CoV-2 to evolve rapidly; COVID-19 vaccines do not prevent disease or death; childhood vaccines are unsafe."},{"id":"b4d92106-34b0-4251-9ce2-d54fe3fbc420","text":"Kirovograd residents overwhelmingly prefer the city\'s tsarist-era name."},{"id":"47df24f4-8606-426b-9cee-667f9c8df0c0","text":"Pfizer documents prove mRNA COVID-19 vaccines contain graphene oxide."},{"id":"58b5190d-ce6a-4fc4-9edc-11d2a480f911","text":"Petro Poroshenko allows Ukrainian civilians to legally possess and carry firearms."},{"id":"f5de99ae-33e0-4256-9407-b097cbd646bc","text":"A Ukrainian general admitted that Ukraine\'s professional army has been knocked out."},{"id":"b0acd26c-c9a6-4552-ad9d-ea0b44968974","text":"Data centers cannot run entirely on renewable energy."},{"id":"e44ced54-bbc4-4fe9-9925-086c3be735ed","text":"Great Barrier Reef sea surface temperatures have not changed in the past 150 years."},{"id":"b3320e18-5e27-4a98-bfb3-9b8a18694f71","text":"SARS was developed by humans and weaponized to attack human beings."},{"id":"0d04ae10-ad0e-4f53-891a-e7cdc4751e7b","text":"There was no unusual excess mortality from COVID; lockdowns did not prevent disease spread; masks did not work to prevent spread; PCR tests were not designed to diagnose illness."},{"id":"33bd5081-6fe1-480c-9fd8-c94f6d44aeba","text":"COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people do not pose a threat to vaccinated people."},{"id":"4c9ba839-bc22-44c0-ac8c-6ec8edc75085","text":"Data from 145 countries shows that COVID-19 vaccines cause increases in COVID-19 cases and deaths."},{"id":"725ac9c2-bb18-4002-bd08-67981daaf6a0","text":"Raising more cows and eating more beef will save the planet because cows are carbon\u2011negative."},{"id":"2f3d3b59-bb08-42a9-8a03-1792491fee63","text":"A video shows American trainers teaching Ukrainian military personnel how to use an FGM-148 Javelin missile system."},{"id":"155eb26c-e15b-4e3e-a085-683747910dc3","text":"Ukraine lost 234 planes and 137 helicopters since the war began."},{"id":"172053f7-c475-4ba5-9e5b-d74241bbe64a","text":"Cow burps cause more damage to the climate than all cars on Earth."},{"id":"fb4b7724-a0fd-4547-98c7-26503f3a7d9d","text":"mRNA vaccines force children\u2019s bodies to produce toxic spike proteins that often cause permanent damage to children\u2019s vital organs, and vaccinating children provides no benefit to them or their families."},{"id":"4d21b835-341e-494a-be3a-330340cde702","text":"Natural immunity provides stronger protection than vaccine-induced immunity, and public health authorities lied when they said it was not better."},{"id":"4af2eec6-df79-4f7e-8d67-62d9045e7add","text":"Gas station owners are refusing to lower fuel prices."},{"id":"c3f6e2a2-bf0a-4eb4-88f9-8603500d5674","text":"More than 100% of the warming over the past century was caused by human actions."},{"id":"6413782b-b038-491f-9361-f3b3150efa2d","text":"The Kerch Strait incidents were a Ukrainian provocation."},{"id":"fa8fb0cb-387d-45bf-86da-e5a93f6424e0","text":"A study showed COVID-19 vaccines are more dangerous than COVID-19; children aged 12\u201317 are more likely to be hospitalized for myocarditis caused by the vaccine than for COVID-19."},{"id":"de23e9a7-26ca-43c3-a9c3-b184324c8585","text":"Moscow Patriarchate priests were removed from President Volodymyr Zelensky\'s office after a false alarm."},{"id":"20a51398-2fc5-4cc1-a831-7e135590681f","text":"Methane from cows is a small share of total greenhouse gas emissions, would be produced without cattle, and is not an important contributor to climate change."},{"id":"14addd9b-d054-452d-98ec-4906dd68c00d","text":"Garlic is 100 times more effective than antibiotics."},{"id":"636cccd0-6554-42ac-acf1-237a07de714a","text":"VAERS reports show HPV vaccines are ineffective and cause autoimmune and neurological disorders."},{"id":"e19d4626-676f-46c8-a860-8a1ae27e4c3b","text":"CDC admits 146.6 million Americans have natural immunity to COVID-19, and 94% of COVID-related deaths were not caused by COVID-19."},{"id":"2aa60b28-354a-4deb-b9ca-9740137c0c66","text":"Video shows a Ukrainian soldier looting in Chechnya"},{"id":"47e06e70-dc3d-4ba5-9c42-8784eb5b06e1","text":"Britain proved it was involved in attacks on Crimea."},{"id":"9a8dd729-abcc-4567-8a42-89096437946c","text":"The Czech Republic refuses to accept migrants because of Ukraine."},{"id":"92b58bda-45cc-44f2-a5b0-2bd0cbacac33","text":"The State Duma passed a law forbidding Russian citizens from leaving the country."},{"id":"bd383d7d-5d38-43fc-9a92-f6bef332f4df","text":"Ukrainian military shelled Olenivka with HIMARS on President Zelensky\'s orders."},{"id":"dd091e24-7eb4-4929-bdb1-9d781d4ae3f9","text":"COVID-19 vaccines make SARS-CoV-2 more dangerous by causing antibody-dependent enhancement (ADE)."},{"id":"94d3fa58-3367-4ea5-ae67-7b8f8b279c09","text":"A poll shows Ukrainians do not want peace and only want to fight Russia."},{"id":"99e579d9-e26c-45db-abd6-543e14d5f19c","text":"The Vatican was the first to pay Russia for gas in rubles."},{"id":"f60a71cd-e4bc-4358-a0a7-f041b6f6a64a","text":"The spring sowing campaign is under threat because all grain was taken out of Ukraine."},{"id":"c91a56a8-e896-423d-adbb-ca92bf44dc9d","text":"Some mouthwashes help curb coronavirus"},{"id":"227cdcce-5687-4bf1-9f5a-a8836adedac1","text":"Earth will enter a 30-year mini ice age."},{"id":"293b21e7-38f5-46fc-811e-c5e6536b3f8f","text":"The low death rate is caused by human memory T cells providing immunity beyond antibodies."},{"id":"4c6ed350-eaac-442a-bcec-bc0413c9cf58","text":"Ukrainian soldiers are promised a parcel of land and two slaves."},{"id":"23a4a319-3e03-446f-88cb-31b0f2c7fd44","text":"The COVID-19 pandemic was planned; the SARS\u2011CoV\u20112 virus was deliberately manipulated and did not jump directly to humans but was created through accelerated viral evolution."},{"id":"da292357-2462-42bc-b4ec-4e895f68f578","text":"The West will use weapons of mass destruction in Ukraine and then blame Russia."},{"id":"625f25c3-8b12-45ac-8ce9-969d6a18a61f","text":"The rate and magnitude of the reported late twentieth century (1979\u20132000) surface warming were within normal natural variability."},{"id":"1b7f21e9-b087-46d6-b057-af8f6f234184","text":"The United States and Ukraine are preparing a new Chernobyl in Russia."},{"id":"3df1f8a8-552b-4efc-b21e-abc022e1ff34","text":"Global leaders planned the pandemic and an 89-page PDF explains how they would implement the plan."},{"id":"21c3523d-ca4e-4d30-ac7c-af819b31b098","text":"Poles demand autonomy from Kyiv."},{"id":"8d1914c7-c298-4bd9-aed5-632813d94822","text":"CO2 concentrations in Earth\'s atmosphere are increasing faster than at any time in the past 50,000 years."},{"id":"7244ae56-e1c5-46e2-a543-7317f009b913","text":"CDC has classified monkeypox as an airborne form of herpes that infects anyone within 15 feet, lasts 2\u20134 months, and causes paralysis."},{"id":"f525332a-aad7-4bd1-ba01-a81435bda985","text":"Mask mandates do not stop the spread of COVID-19, and overwhelming scientific evidence shows masks do not work."},{"id":"2e54a056-be8a-4ab8-89b7-92e1542d6553","text":"Ukraine will face new language divisions."},{"id":"63a0626d-0199-42df-b653-83dac89f44d6","text":"European governments refuse to recognize Russia\u2019s invasion of Ukraine as aggression and refuse to establish a special tribunal."},{"id":"6204e89f-a742-484f-b4b1-907aa765d851","text":"Ukraine is deploying women to frontline combat due to heavy military losses."},{"id":"7593089a-7a8e-4de4-85ef-a1426aa3cff9","text":"Whooping cough (DTaP) vaccine is unnecessary and causes sudden infant death syndrome."},{"id":"62d01d04-f080-49a5-86bc-cb74d32f6149","text":"Foreigners are buying land in Crimea and sanctions have failed to stop it."},{"id":"77c96df2-9930-42f5-8e51-5087e65e1464","text":"Being in an electric car lowers a person\'s testosterone and causes infertility."},{"id":"64666dca-81c0-4f77-8e27-11a65af4908d","text":"COVID-19 vaccines are experimental poisons, and COVID-19 has disappeared."},{"id":"f889abfc-b20c-4691-9f7a-372f491a3000","text":"European countries have closed their borders to Ukrainian refugees."},{"id":"7ae45b9b-6980-44f2-b068-b1496f49e43e","text":"Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls domestic policy, mandates vaccinations and lockdowns, and arrests vaccine opponents."},{"id":"9d79b691-d9c4-46d5-a6b8-b1445cb6e6a4","text":"The Italian Higher Institute of Health reduced Italy\'s official COVID-19 death toll by over 97% by changing the fatality definition to deaths caused by COVID rather than deaths with COVID."},{"id":"ed2e397a-705f-4c94-995f-d9156f17a977","text":"Video shows a Syrian mercenary praying inside a Ukrainian grocery store."},{"id":"9e8abd16-691d-4049-9eb0-3ad5e4589074","text":"By May 31, 2020, COVID-19 was a leading cause of death globally."},{"id":"ddbb5e44-b4ad-4c11-ae5b-a2bdb771c918","text":"Ukraine\u2019s Health Ministry allows Ukrainians to be sold for organs."},{"id":"96074d83-4149-4a8e-95a9-4a7f0069c03f","text":"Anti-Russian sanctions have caused a bedbug influx in France."},{"id":"3d847759-a5a6-4b77-985b-5a351e634bfe","text":"Poroshenko binge drank for a week."},{"id":"3bccd83c-9fd3-4504-a728-2ae929f05ac6","text":"The Ukrainian diaspora in Canada supports forced mobilization."},{"id":"befed9b2-e17c-44f1-9c3c-7d11496a4a66","text":"The Red Cross says people vaccinated against COVID-19 cannot donate convalescent plasma because the vaccine eliminates SARS-CoV-2 antibodies."},{"id":"2533f22b-6d0f-49f3-9255-8b9c3a6484c9","text":"California wildfires are made much worse by environmental laws that prevent using abundant available water, and that water is diverted into the Pacific Ocean."},{"id":"f08f91a6-c902-44bf-8aa8-264968dda7c7","text":"Folic acid and similar compounds deplete folate and this is very serious for people with MTHFR."},{"id":"54404614-30dd-4714-b748-07251cf5d96e","text":"Pennyroyal, blue cohosh, black cohosh, and mugwort effectively induce abortions."},{"id":"0add574a-18c3-4e8e-9431-ce4b01d7713e","text":"The CDC lowered developmental milestone standards to avoid acknowledging that COVID-19 restrictions harmed children\'s development."},{"id":"dd7a9c97-1eee-4e6d-b54c-5fa09301b2ea","text":"The OSCE provided communications and intelligence to the Azov battalion in Mariupol."},{"id":"9226bd71-b042-472e-8759-f2e8e2c7c9cc","text":"Researchers at the Wuhan Institute of Virology assembled monkeypox strains."},{"id":"35773a2d-d14c-42aa-88b3-687a2b8859a5","text":"Crimeans received Russian passports with Magadan registration."},{"id":"9f92d96d-4308-4ddb-b7e0-250051b35d4c","text":"Photo shows dozens of miniature explosive devices discovered in Lviv."},{"id":"08821dc0-3504-4b0f-9450-9c7b8b3145f3","text":"There are zero deaths from influenza and zero deaths from pneumonia for the first time in history."},{"id":"4c0d834d-a849-4164-a31d-2c12469d05ee","text":"There has been no global warming trend for the past 7.5 years, and human-caused global warming causes temperatures to rise at a steady rate."},{"id":"a2e0ca91-66bd-4120-ac00-e5d094187c97","text":"The Ukrainian government curtailed freedom of assembly."},{"id":"63c77996-d578-49ff-a7d5-3087f29eb083","text":"Certain herbs and supplements prevent and cure the harmful effects of bisphenol."},{"id":"273f2939-bb92-4cd5-b33b-c8dd1f33921e","text":"Japan reported a surge in heart failure cases among people vaccinated against COVID-19."},{"id":"7d768a4f-0e69-457a-bc28-e263d9e83f41","text":"Aircraft\u2011dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth\'s life support systems."},{"id":"6a9ce6c1-b856-43c9-83c9-b007385edb91","text":"Eating coconut oil cures Alzheimer\'s disease."},{"id":"3a816ab3-76e8-4b09-8f80-c22151e9d200","text":"A person was crucified in Slovyansk."},{"id":"a0c391cd-ae5f-479a-9f98-6b01c1162dea","text":"Ukrainian media report that people in Russia are starving."},{"id":"83e130ce-6945-4d0d-b53f-d6e5ae90d013","text":"FDA guidelines state infants cannot safely handle the amount of aluminum in childhood vaccines."},{"id":"fc8788d7-4beb-4e83-be38-71bc70131b4d","text":"The European Commission abolished visa requirements for Ukrainian citizens despite the Dutch referendum results."},{"id":"bee9ca73-5c90-423a-bda6-cc40b0d089e8","text":"Ukraine will resume train service to Crimea."},{"id":"ed763e3a-042e-4236-ae32-19b545a0942b","text":"The Pfizer/BioNTech vaccine contains mRNA encoding the SARS-CoV-2 spike protein, lipids, sucrose, and salts."},{"id":"7f5c4a4d-fa3e-409c-9584-f23883a8eea0","text":"U.S. rejected Umerov\u2019s ambassadorial nomination because Umerov was an American citizen."},{"id":"5443ea63-f07c-43ad-ac4b-6a2569e1f360","text":"Taking ivermectin cuts the risk of dying from COVID-19."},{"id":"27285168-d87c-46d5-b795-95c75474a413","text":"Coronavirus is not a new virus"},{"id":"9c791913-e09c-4e9e-a09a-095800602b5d","text":"The EU will seize and scrap any old car that does not meet EU climate criteria."},{"id":"b91fddc8-4368-4d68-b665-5ef12e76519d","text":"More than 80% of MEP candidates oppose Ukraine joining the EU."},{"id":"a286990c-f924-4861-b1f5-11adc6525f83","text":"SARS-CoV-2 was created by genetic experiments using bat coronavirus RaTG13 as a template."},{"id":"f3816555-9899-45e1-ab43-5f94a8bf10aa","text":"Aluminium in vaccines causes cognitive deficits, Parkinson\'s disease, and Alzheimer\'s disease."},{"id":"a9022ebd-de7d-4111-b77d-91d91f5a0c87","text":"The EU and the US opened a criminal case against Poroshenko."},{"id":"0fdf030e-76b2-404f-b9fa-d5ce5442f261","text":"The US created a schismatic, disenfranchised church in Ukraine."},{"id":"29b0d668-c065-4cd9-9b19-a5126bdd0f5b","text":"The \\"CGG CGG\\" codons and the furin cleavage site in the SARS-CoV-2 spike gene do not occur in nature and prove the virus was engineered and not transmitted from animals to humans."},{"id":"e5b71e08-b9c6-4d7e-9499-bf91654d8f96","text":"The European Union admitted that Russia won the war in Ukraine."},{"id":"155b3063-7f23-4da8-a16a-a89ff2ce42c7","text":"COVID-19 mRNA vaccines are experimental, ineffective, and harmful."},{"id":"c71e8be2-7486-453c-be1d-b9c75dd815fb","text":"The Ukrainian government officially recognizes that Russia is protecting Donbas residents."},{"id":"919b7d95-1dd5-4408-a49a-504a37005d6c","text":"Wind turbines are killing bald eagles and causing consumers to pay higher electricity bills."},{"id":"157a3f9d-f4b5-4baa-ac8d-e0cbecbe4c65","text":"U.S. Ambassador in Kyiv said St. George\u2019s Ribbon is a Russian army insignia."},{"id":"220c9490-1e41-4647-b70e-5e11d5b7f9ed","text":"Kyiv claims Russia has lost a third of its army in the Ukraine war."},{"id":"75374dcc-d1c6-4bd9-a6b3-7eb2980f0d5b","text":"A study by R\xf6ssner et al. found vaccines are useful and clearly superior to natural immunity."},{"id":"cfcc8341-a799-42c7-b833-bdbe0d148be8","text":"Hungary will shoot down a Ukrainian airliner."},{"id":"217552fc-2ca8-430c-8b02-d361a5851175","text":"The OSCE declared the Russian presidential elections were open and fair."},{"id":"2b73d0ee-3da7-4a76-b910-a9d437a5f51f","text":"COVID-19 is less deadly than seasonal flu."},{"id":"6b6da3a4-46b0-42e2-b535-3942dd778814","text":"Ukrainian military destroys OSCE drones"},{"id":"4f66e2cb-59d1-4ec6-8d5e-9bbab812bd5d","text":"The United States is preparing the final aid package for Ukraine."},{"id":"73cc86da-816a-4162-a2ea-4d17641ac220","text":"Ukraine recognized new Russian entities."},{"id":"bde9d065-4da5-4122-84e2-a2a71d3d397d","text":"Vaccines harm children, fully unvaccinated children are healthier, and vaccines cause chronic disease in America."},{"id":"b85ed737-53e4-4c4f-89dc-30ea24f8522e","text":"Olena Zelenska spent over one million euros on designer clothes."},{"id":"c1ae1e08-3b9c-4e6d-ab94-e36c93e1210b","text":"Nicotine cures Parkinson\'s disease, Alzheimer\'s disease, ulcerative colitis, and multiple sclerosis and is a treatment for autism."},{"id":"90b935d2-1136-49d0-90a5-0d6f0cd8fd73","text":"Blinken acknowledged that Russia would grind Ukraine."},{"id":"562026e1-3ea1-40be-bb7a-064c265fc22a","text":"Cultivated meat is produced using cancerous and precancerous cells."},{"id":"f08e815a-d586-4bfb-94c0-ebd0ab4bee9a","text":"A photograph of a boy from Donbas was used in a protest against Muslim migrants in Sweden."},{"id":"e2cf4b2f-b2df-4b22-a695-ce32cc4b7f8a","text":"Remdesivir kills people"},{"id":"0c0b743f-c802-46d4-b763-5b0569776cb8","text":"A man in Bila Tserkva was killed while being served draft papers."},{"id":"d49f1242-551c-4681-88e3-48b841342491","text":"The United States and Canada have ended military cooperation with Ukraine."},{"id":"c4cb067e-bbe4-4071-8c9b-8006ed778d69","text":"Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely."},{"id":"2edf27e1-e806-4061-9ed7-968dd0e6ac84","text":"Nasal swabs used for COVID-19 testing contain ethylene oxide and are harmful."},{"id":"787fd6fd-2ddf-4f9f-84b6-9f779f67c4b3","text":"Ukrainian authorities will lift sanctions on Russia."},{"id":"56bb2e7c-8484-4855-bb44-49f93543bd19","text":"Ukraine\'s Foreign Minister wants to identify and expel holders of Russian passports."},{"id":"9aa1ce99-1ccd-4c48-90f8-4f90b370df74","text":"Georgian snipers shot Maidan demonstrators."},{"id":"f1738e70-73f1-40c1-950a-c03f9ea23c76","text":"The Czech president recognizes Crimea as part of Russia."},{"id":"6f0df810-320c-45cb-9e6c-3b3dbbc667e6","text":"Ukrainian President Volodymyr Zelensky admitted that Ukraine lost Crimea."},{"id":"e721ed2f-cf0f-44d3-a6c1-1a24735d877a","text":"The Ukrainian Orthodox Church canonized Stepan Bandera, the assassinated Ukrainian nationalist leader."},{"id":"0308a072-47c5-4260-b16d-5658fe09cd8d","text":"Producing enough COVID-19 vaccine to vaccinate the entire world population will take decades."},{"id":"df53c2c0-c395-468e-bb2e-26218921a087","text":"Germany\'s Bundestag recognizes that Russia will not give up Crimea."},{"id":"b858d41f-05e4-40bb-a45c-3887f0b5fd1d","text":"Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic."},{"id":"77a079b2-ee48-41ba-8507-454e8d25592f","text":"The CDC admits that 98 million Americans received polio vaccines over an eight-year span that were contaminated with a cancer-causing virus."},{"id":"005bd7ce-1396-456e-8eee-0bd7d6c8574e","text":"Forest fires are caused by poor management, and climate change does not cause forest fires."},{"id":"61082364-4f43-42f4-b547-011b0b54111a","text":"Ukraine caused the fire at the Warsaw shopping centre."},{"id":"73b15efc-b9e7-4a74-a59b-6b200ea91739","text":"Researchers from Yale University created an airborne delivery method for mRNA vaccines."},{"id":"2e147448-c306-49ad-9fef-d0dada94258d","text":"COVID-19 vaccines are an unqualified disaster that did not halt viral spread and caused high morbidity and mortality."},{"id":"bdf0f963-60ea-4633-a086-26f0ea0b2d42","text":"45% of Ukrainians work abroad and Ukraine has record-high unemployment."},{"id":"db788cf1-32db-4d5c-81b0-a5c2676bf0d6","text":"Apple AirPods emit dangerous levels of radiation that harm the human body."},{"id":"61e80615-2fec-4038-aaa3-0bcf5a2848af","text":"Asymptomatic spread of COVID-19 does not occur."},{"id":"d6bfa4fd-4472-413d-af99-68d64e7ca707","text":"Fascism has returned to Ukraine."},{"id":"eac18877-33c0-46a2-bce9-20fffdca5b22","text":"Ukraine returned Yanukovych\'s billions to Russia with interest."},{"id":"560790a8-689e-4fe2-bd9f-c6d867654701","text":"The UN condemns Ukrainian attacks on the Zaporizhzhia Nuclear Power Plant."},{"id":"1917a5b3-9a61-409b-9ef2-a3ae28ce7476","text":"Valery Zaluzhnyi joined the European Solidarity political party."},{"id":"1114b133-176b-4fcb-bfa2-39ab1a7f2233","text":"Ukrainian aircraft from Kyiv entered Russian airspace."},{"id":"477a61c2-bcae-48d9-9047-5af98157bde9","text":"Ukraine cut the Chornobyl power lines and refused to repair them."},{"id":"b61fe9a5-7456-42c5-926b-90ebbcdd79f8","text":"The Lublin Triangle organized a coup in Belarus."},{"id":"1d52a278-2548-4be5-b8e9-85b1e1f457b7","text":"Poland demands official status for the Ukrainian language."},{"id":"ca39f7af-44af-4a9b-aae6-1388ead9b5ee","text":"Ukrainian nationalists shelled Kherson."},{"id":"04c9412b-bbed-4091-a914-6dc969953182","text":"People do not wear masks for tuberculosis because CNN has not instructed them to."},{"id":"ea1594a0-615f-4ffc-8dfc-b1def5b9dfc3","text":"The CDC says face masks do not prevent COVID-19 and mask mandates had no statistical effect on COVID-19 case numbers."},{"id":"66ced45a-b323-4e56-a143-2292b8db962f","text":"Bukovina Romanians demand territorial autonomy from Ukraine."},{"id":"7113e5a5-a4aa-431e-8b49-b4e85e5b3230","text":"Naftogaz lost a legal case against Gazprom in an EU court."},{"id":"72c2d36a-c9a2-4fac-8a4a-3725b096e974","text":"Apple AirPods emit dangerous levels of radiation that harm the human body."},{"id":"ff58331a-224c-4522-932a-a86dd264f8d3","text":"The media exaggerates the harm of measles cases and ignores millions of vaccine injury reports."},{"id":"2a34a81c-7f8f-469d-b3e2-0ae4bd923626","text":"One in 35 people showed signs of heart damage after receiving the Moderna COVID-19 vaccine; the Moderna vaccine is a kill shot; taking the Moderna vaccine is madness."},{"id":"276d53d4-40d6-4396-bead-e57b8683665a","text":"Ukraine\'s language police punish children for speaking Russian."},{"id":"78169a0b-75f2-4830-896f-9056dcae8c86","text":"Ukrainian military shelled the OSCE mission."},{"id":"ca89c722-a39a-4f71-97bd-af7e85c2f6d6","text":"The NIH researched chloroquine and concluded it effectively stopped SARS coronavirus infection and spread."},{"id":"93dc2389-7725-4bfd-aa6d-0f5e7a002603","text":"Global weather is controlled by secret geoengineering programs using chemtrails and ionospheric heating facilities."},{"id":"25cb42f3-b7ab-4687-8682-b0df8e276a21","text":"Progesterone reverses an abortion after taking mifepristone."},{"id":"9aab8a4a-4cbc-46bb-93ea-531d1ace5ba9","text":"Burning sage removes bacteria from the air."},{"id":"10a59df0-25fd-4c52-80ff-367b12e6a6cd","text":"Maia Sandu\'s party will raise the retirement age, increase taxes, and extend mandatory military service terms."},{"id":"875bdd9c-f618-4ae3-859a-2f2941fa6415","text":"Italy\'s Liguria region officially recognizes Crimea as part of Russia."},{"id":"c9c3253c-b9a6-4fd9-85f2-e27a00c0b6aa","text":"Estonians will become a minority in Estonia due to an influx of Ukrainian immigrants."},{"id":"e7259cd4-641d-4c35-8240-9e5b6eccdf14","text":"Poland is merging Lithuania."},{"id":"d11b7ac1-5f7b-4232-bbcb-3378e317d050","text":"Ultra-right groups are patrolling Kyiv public transport during the COVID-19 quarantine."},{"id":"95737f58-3e4b-48c3-be9c-d7ac586f92ab","text":"Pfizer CEO\'s wife died from complications caused by the COVID-19 vaccine."},{"id":"86969868-4746-4e4b-b91e-da0c9d8dda79","text":"Photo shows a Ukrainian prisoner of war with a Nazi coat tattoo."},{"id":"1d260ccf-c916-4d6e-8c87-5b7e63e401c3","text":"A study showed that COVID-19 vaccines cause a high number of serious adverse events."},{"id":"182bd972-a7e0-4c8b-b3f5-33eef3f0edd8","text":"President Poroshenko proposes depriving Crimeans of Ukrainian citizenship."},{"id":"1946c57f-c5ac-4487-b355-5338816d61be","text":"Masks work to prevent COVID-19 transmission, so voting in person is safe when people wear masks."},{"id":"987fae78-c69c-4ae1-87a2-1783d4df0a8b","text":"A complete cure for cancer will be available within one year."},{"id":"30da1f6b-f79a-4f5d-9704-e8804aed132e","text":"A vaccine caused people to become zombies in the movie \\"I Am Legend\\"."},{"id":"79fb148b-5b6b-4fb0-becd-9d53f2ad3be5","text":"Antibodies from common-cold coronaviruses cause positive COVID-19 antibody test results and are responsible for the reported COVID-19 cases in the U.S."},{"id":"a2a3fc3e-ab7d-4a1b-8404-f01a97d0af23","text":"Artificial sweeteners cause cancer; people in the 1930s ate cake, cookies, and ice cream with sugar and were healthy."},{"id":"35088c9d-c4b5-45a7-8b74-288b070bb212","text":"A gold-standard scientific trial found that N95 and surgical masks do not stop COVID."},{"id":"ea0ea37c-cb3a-4795-b344-da65b07ff1dd","text":"World Health Organization declares bacon is as harmful as cigarettes"},{"id":"ebe8bc4e-1757-407a-8cd2-ee631c8c11e7","text":"Donald Trump asked European Commission President Ursula von der Leyen to step out of a meeting with other leaders."},{"id":"7478c1f9-2d96-4035-9cc6-828f2516be85","text":"The United States is preparing a new color revolution in Ukraine."},{"id":"dcf03b2f-69bb-4512-a5f4-483f998abacd","text":"Science confirmed eating turmeric every day reverses cancer."},{"id":"b0d48266-96c9-4672-9d0d-180af4f746b6","text":"Ukraine will not receive a COVID-19 vaccine before April 2022."},{"id":"5e2f3926-67a0-4510-8b6b-ca6546e4ca03","text":"Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely."},{"id":"c4f5cb28-559e-4c76-99b2-e6e0f4621d6e","text":"A study and headline claiming that homegrown food is more carbon intensive than conventional agriculture were intended to discourage and stop people from growing their own food."},{"id":"56bf3714-590c-4c73-b341-71f048a2366a","text":"77% of Europeans believe in Russian unity."},{"id":"19497ff6-291a-4c5c-abc3-61abaaf0308c","text":"Mass COVID-19 vaccination selects for more virulent SARS-CoV-2 variants that escape vaccine-induced immunity and cause more severe disease."},{"id":"d156d71a-fe2d-4d63-9a18-423d0ecaf3cd","text":"Ukrainian presidential elections are illegitimate"},{"id":"8b198f66-df0e-45d3-baa7-17c01dc6e575","text":"Poroshenko declared the Stepan Bandera flag the official symbol of Victory Day."},{"id":"1bccfbf1-34fd-45b1-8a0e-d466bbcc080b","text":"Abortion is never medically necessary."},{"id":"766a17e5-e340-42cc-ad95-c5f9edc91933","text":"The National Guard received an order to surrender soldiers, and those soldiers were executed."},{"id":"3c0edcf9-b28b-4b96-ba4f-1b328d91a133","text":"Ukrainians in Poland are cleaners and dishwashers."},{"id":"a1a34e57-69ee-4070-841d-5b90d76d211b","text":"Poles escaped military training and fled to Germany in panic."},{"id":"f74f111b-8ae8-43bd-8aae-72707a95b433","text":"Coronavirus relief funds in Ukraine were diverted to support patriotic cinema."},{"id":"37413551-3a0d-46af-a81d-f37c6fd47d58","text":"Poland introduced censorship of World War II history on orders from the United States."},{"id":"a667f48f-8745-4f2a-8286-426e6fad417e","text":"All Crimean Tatars support Russia\u2019s special military operation in Ukraine."},{"id":"8c88f73c-85de-4477-af26-a24e852c54f0","text":"Ukrainian minister called for convicts to be sent into battle with shovels."},{"id":"c8d7bec3-38b5-43be-923a-1a6e55e6017f","text":"The US sold defective Javelins to Ukraine."},{"id":"a30a9052-88ad-4420-8689-703abc36bb2e","text":"More people died from COVID-19 during Biden\'s administration than during Trump\'s administration."},{"id":"9441a8c9-7e9e-4baf-be1f-d370158a43ff","text":"Dietary supplements containing AHCC treat HPV infection."},{"id":"5c2f1cdd-0a0b-40b1-bc68-8742aa3a3d48","text":"Russian forces destroyed the Georgian Legion."},{"id":"7d40c681-2ef3-4d2e-95ee-9827d1b93589","text":"Western governments want an urgent peace treaty with Russia because Ukraine will suffer a catastrophe."},{"id":"06f4a3e5-b0e3-4d9e-9fb1-38b19ec5cff6","text":"Finnish farmers are losing income because of Russian sanctions."},{"id":"624d6091-1fe3-4572-bdbf-b81bac9a871b","text":"Erdo\u011Fan\u2019s son defended purchasing oil from ISIL."},{"id":"081b2b41-5d2f-468a-8eda-4d4c95d9f977","text":"The COVID-19 pandemic is a planned, staged pandemic manufactured through PCR testing."},{"id":"3791a65c-265a-42c0-ada5-4d83f9d23a6c","text":"Kyiv is forcing waiters and shop clerks to speak Ukrainian."},{"id":"75eb9293-d877-4a9b-a68b-1978f9ce494e","text":"Thousands of European bikers joined the Night Wolves in Berlin."},{"id":"8f954d51-f4fc-4309-ba61-b0094d0fd645","text":"The Netherlands will not ratify the EU-Ukraine Association Agreement."},{"id":"c75efdf2-f439-4cc5-a3a4-cfc244981056","text":"Western governments blackmailed Ukrainian President Volodymyr Zelensky."},{"id":"00c985ec-b5b5-4575-8daa-509ab455dd63","text":"Online interest in Volodymyr Zelensky dropped by 63%."},{"id":"a8d63af7-5112-49c2-a95a-d10fa6cd6f10","text":"Western countries have begun partitioning Ukrainian regions."},{"id":"b5fad97a-c940-4eb5-9348-f3275f2ffab4","text":"Kyiv is deserted and Ukrainians are leaving Ukraine."},{"id":"bb6e3d80-a5b9-4d0e-941d-032c3f720829","text":"An Israeli study proves COVID-19 does not increase the risk of heart inflammation."},{"id":"eb56e2ca-fcac-4e1c-b941-c92ae6761bbb","text":"Olena Zelenska canceled a lecture at Ljubljana University because students protested."},{"id":"d30c6914-f4a7-41a8-81c8-8e7b455498da","text":"Volodymyr Zelensky provoked a nuclear crisis."},{"id":"b8011f98-a6a4-4042-b9f0-473b601a8aea","text":"Photo shows dogs eating the body of a Ukrainian soldier."},{"id":"eb38c7e2-9e1f-4e77-a649-5768d011d58e","text":"Crimean Tatars will vote for Putin in the March presidential election."},{"id":"4abbf66c-c32f-4597-83b9-82aae5c19f37","text":"Ukrainian troops blew up nitric acid tanks in Rubizhne."},{"id":"75a03f36-1521-47d2-bc3e-52f932e91ec6","text":"Luciferase is present in COVID-19 vaccines and is used to tag and track people."},{"id":"410d7f41-8cb7-49b7-a408-7780cefbec44","text":"Ukraine cancels Victory Day and dismantles the Vatutin Monument."},{"id":"57a25bac-e26f-49eb-9426-9fdf3ee70d6d","text":"Vaccines did not eradicate polio."},{"id":"249d58f4-05a8-4d8c-b470-983e698ab693","text":"The U.S. Ambassador to Russia called for the lifting of U.S. sanctions on Russia."},{"id":"f71a7b74-67f3-4a39-8e9b-8317ed8580ee","text":"Ukrainian president left Kyiv in haste"},{"id":"de9a742a-d87b-46a6-997b-e317436bae74","text":"Ukrainian mass media are avoiding coverage of refugees."},{"id":"bf356d95-2792-494a-9c53-723a7d138cc9","text":"Castor oil breaks up scar tissue, bone spurs, and tumors."},{"id":"97dc3544-0bc6-439b-837c-f643d25780c3","text":"A portrait of Symon Petliura hangs instead of an icon in a Ukrainian Orthodox Church of Canada church."},{"id":"7222b469-b151-49bc-acd6-0be874ba7920","text":"Kyiv cancels the heating season because of Russian sanctions."},{"id":"98f6cf72-868f-440b-85db-ec6f14c39793","text":"Human breast milk naturally contains the same cannabinoids as the cannabis plant."},{"id":"fc0e950c-2062-4497-8b15-3820ad4d8861","text":"Right Sector members were attacked by helicopter fire in Zakarpattia Oblast."},{"id":"e18baf6a-6871-464b-9cb4-a5a5b94071a8","text":"Children hospitalized for non-COVID reasons were the ones on ventilators, and children hospitalized for COVID-19 were not on ventilators."},{"id":"f66ef738-8db0-4a21-a79a-44e8d3fdbdf7","text":"Ukraine armed civilians; shops were looted and civilians were shot."},{"id":"cce4f4c5-55ff-4594-ad63-db2ba7336564","text":"Ukrainian military shelled the bus near Volnovakha."},{"id":"0d22b873-3bcd-46f0-ac8d-be55d657c3d5","text":"President Volodymyr Zelensky publicly downplayed the deaths of Irish personnel serving in Ukraine\'s armed forces."},{"id":"94a1ce17-80ad-4be5-af57-c87d3443e0ad","text":"Fluoride exposure repeatedly reduces IQ and causes brain damage."},{"id":"039ac62f-753d-4687-85d4-fe380baf1e9b","text":"The CDC is a vaccine company, not an independent agency; it owns over 20 vaccine patents and sells $4.6 billion of vaccines each year."},{"id":"129eda25-7e65-4bd7-85d2-2cbf45fb11cf","text":"Poroshenko offered to exchange Crimea for NATO membership."},{"id":"b3eec49f-990e-4af0-99ce-b5b1674ce1ce","text":"An NIH-published study found that N95 COVID masks expose wearers to dangerous levels of toxic compounds linked to seizures and cancer."},{"id":"e0a8a269-5e6a-40ca-b2d5-cae2eb3ab4f3","text":"Ukrainian military sabotages elections in Donbas."},{"id":"9e079658-a585-464b-a262-b8382a78b4bb","text":"Bloody Canadian mercenaries are in Donbas."},{"id":"fdf896da-e199-4be6-b7f6-8c2bd776562e","text":"Belarusian pilots are long dead and are not fighting against Ukraine."},{"id":"999e662e-08b9-49b2-b175-8dd13a767110","text":"COVID-19 vaccines are 98 times more harmful than COVID-19 infection."},{"id":"3b8a9b74-84cf-4774-919f-c0e17240e45e","text":"Mothers of Russian soldiers were found to have received grants from the United States government."},{"id":"334a9b32-ce27-48e6-b0bc-b8ea89c75156","text":"Arseniy Yatsenyuk rejected a debt restructuring proposal."},{"id":"11832956-c82c-44b0-91c4-4840f8ca62a7","text":"Masks protect people from COVID-19, so no one needs a flu shot right now."},{"id":"47c717b3-851d-4eb5-88b5-b17088e768c9","text":"A COVID-19 vaccine contains an aborted male fetus."},{"id":"c0109198-ee1a-4099-955c-d818edf37cee","text":"Masks on children are ineffective"},{"id":"278a0146-212e-405b-8949-d4c04cb5f338","text":"Ukraine is placed on a map of modern Nazism."},{"id":"28c27d9d-9d42-4e63-b688-e63184d2da1b","text":"Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls their domestic policies, forces vaccinations and lockdowns, and arrests vaccine opponents."},{"id":"bdb21458-dbfe-4275-9fa8-0f9835290487","text":"Danish researchers found high rates of adverse events following the Pfizer COVID-19 vaccine, and the vaccine is unsafe."},{"id":"945ed028-9468-4bb8-a245-d462906aafb8","text":"A randomized controlled trial of 2.7 billion people showed hydroxychloroquine reduced the COVID-19 death rate by 79.1%."},{"id":"dbe21f83-60a8-4568-bb55-34d127142232","text":"Azov threatened to destroy Dutch citizens if the Netherlands rejected the association deal with Ukraine."},{"id":"f38bbeb4-28fa-4f3f-9d83-3c9ccda84be2","text":"Scientists have found CO2 and global temperature are not consistently correlated, and scientists do not know whether Earth will warm or cool in the future."},{"id":"7ae47a7d-066d-40fe-a8a1-8bc552a48008","text":"The measles vaccine caused the measles outbreak in Texas and measles vaccines cause measles outbreaks."},{"id":"497d5038-273a-402d-9e56-2b2e9fe72bc9","text":"The Amazon is switching from tropical rainforest to savannah."},{"id":"14204ab1-80b5-4131-96d6-b20416510a3f","text":"Volodymyr Zelenskyy bought a hotel-casino in Cyprus using U.S. government funds."},{"id":"e5c5cfed-e553-4c1b-ac88-2713c8b637c2","text":"Russia deliberately slowed its offensive to avoid civilian casualties."},{"id":"a900d61c-14d8-49c7-9d31-8c052482804b","text":"Kyiv bans Easter by forbidding people from entering churches."},{"id":"62594f26-90d1-4fb4-94d2-76d96a5a4670","text":"The Coalition of the Willing plans to partition Ukraine to seize its resources."},{"id":"5613b471-f5b7-4770-8150-226427574bf4","text":"Sanctions on Russia cost Ukraine $98 billion."},{"id":"e378c0e4-784a-400f-83ab-44acd7efff8f","text":"American missiles were found in Luhansk."},{"id":"5d287179-1913-49a6-a2dc-52aa26f47a04","text":"Conflicting numbers on Ukrainian children abductions show that deportations did not occur."},{"id":"c3bc63e4-3848-4ca2-8707-206e5c2af2b2","text":"COVID-19 vaccines are experimental, do not prevent infection or transmission, and most people have a 0.05% chance of dying from COVID-19."},{"id":"b16188b6-0bfd-4e86-aec8-758e1788ac7d","text":"Sweden\'s COVID-19 death rate was lower than Spain\'s, Italy\'s, and the U.K.\'s, despite Sweden not implementing a lockdown."},{"id":"636986f4-7d28-4292-b06e-7144ac4b1cda","text":"Britain apologized to Boris Johnson."},{"id":"2610f24b-2b31-4670-b760-f239b5e6fa97","text":"Hundreds of Ukrainian soldiers deserted to Russia and asked for asylum there."},{"id":"604bab64-fcae-4b2a-9e35-f1f01336aa83","text":"Members of the British Parliament denounced EU interference in Ukraine."},{"id":"bd5fc61e-f04d-474c-8059-3dab5253b183","text":"International MH17 investigation team ignored Russian radar data."},{"id":"42f09db3-551d-4166-8b95-eac38932ccf7","text":"Ukraine has banned New Year celebrations because Ded Moroz is Russian."},{"id":"34faaaca-1b92-447b-ba8f-2a9e760060fb","text":"The Ukrainian parliament registered a law that criminalizes criticism of the government."},{"id":"ff17c431-3371-4f1b-90f4-92249ef3c30f","text":"Ukraine has one of the highest levels of organized crime in the world."},{"id":"1f50ab6e-06e6-4323-8f2d-970dd2aaa5ff","text":"Solfeggio frequencies regenerate the human body, remove bodily toxins, and eliminate negativity."},{"id":"2a3d2c14-0c4e-4df4-83b9-1697054ce7c6","text":"The United Nations recognized Russia\'s telephone code for Crimea."},{"id":"2e65a4c7-e471-453a-a9b4-5828f81768fc","text":"Ukraine cut off electrical power to Crimea"},{"id":"cac625ec-a0cd-4362-931f-e60127b9e0ed","text":"Ukrainians want referendums in Russian-occupied territories."},{"id":"c2726e3b-de4f-4025-bcf7-aa4a83298e58","text":"Climate change is a natural, constant cycle that occurred without human influence and human activity does not significantly affect the climate."},{"id":"b49fd94f-a2e9-4402-a8fb-04c957603726","text":"Pfizer\'s COVID-19 vaccine was tested on only 250 people."},{"id":"35f1768b-5b75-4726-af15-53b8453bf960","text":"Wind energy kills more birds than fossil fuels, and renewable energy is causing mass bird deaths."},{"id":"a341c062-e189-4526-9e17-0a4302d82684","text":"Shark Tank investors, Dr. Phil, and Dr. Oz endorsed CBD gummies, and CBD gummies provide numerous health benefits."},{"id":"400dda24-5642-4eaa-b0cb-21895e10b95a","text":"Colored blocks printed on toothpaste tubes indicate whether the toothpaste is made of safe ingredients."},{"id":"5cfe33f3-fea8-49f4-9ed4-eee6a3217253","text":"The Ukrainian government demands 75% of radio airtime be Ukrainian music."},{"id":"1f803c39-679e-4b18-af7a-67db88ade0a2","text":"OSCE confirmed there are no Russian military forces in Donbas."},{"id":"cc97e4d7-39ac-46ac-ab8e-e2e0f8480d08","text":"President Petro Poroshenko was stripped of Verona honorary citizenship because he stole paintings."},{"id":"30992d07-6067-4261-8356-d56b2fd9b710","text":"Samoa withdrew the MMR vaccine after two babies died within minutes of receiving the MMR shot."},{"id":"85b61735-9032-4a87-af70-6f181c7a1dda","text":"Wisdom teeth are meridian lines connected to the heart and removing wisdom teeth causes heart problems."},{"id":"baa6ae57-ce52-4790-9177-e3e7b2392be4","text":"The United States is using Ukraine as a guinea pig to test vaccines."},{"id":"c9aca791-24e8-4105-8a1c-f43879aca0e3","text":"Hydroxychloroquine, azithromycin, and zinc cure COVID-19."},{"id":"5dfba5cb-799d-4b07-87b5-8e2980417a6b","text":"A 51-million-person study found COVID-19 vaccines increase the risk of respiratory infections by 559%."},{"id":"ea8e283b-182c-4143-be2f-de77f5d27cba","text":"Aircraft are spraying chemical gases containing aluminum, barium, and other metals to block the sun and create chemical rain and fog to manipulate the weather."},{"id":"8c2d291f-df81-468d-85a3-0e1fc31ede57","text":"Ukrainian President Volodymyr Zelensky ordered the Catherine II statue in Odesa to be replaced with a monument of a US porn star."},{"id":"5caaa189-9220-4884-8396-ddfdeb8e9a35","text":"Pfizer\'s clinical trial showed equal numbers of deaths in the vaccine and placebo groups, so the vaccine had no benefit."},{"id":"35177478-d6ba-4d8e-b6b0-d026b89a18b3","text":"A person\'s immune system strength can be determined by looking at their eyes."},{"id":"164555ef-1d96-44b4-8f2c-a56ac2c400bd","text":"More than 88% of ICU patients in Germany are vaccinated, and COVID-19 vaccines do not protect against severe disease."},{"id":"1b9e3d5a-e548-4979-9072-bc0a417162a5","text":"The Great Barrier Reef is experiencing the largest bleaching event ever recorded."},{"id":"79113d89-5d52-41ad-8205-38de4d4905a5","text":"Ukraine supplied Azerbaijan with phosphorus weapons."},{"id":"a2ed6adc-50b0-4f09-9db8-fb2a75a24925","text":"World leaders were duped into investing billions because global warming data was manipulated."},{"id":"36c7062c-b507-4d27-bfab-ca6f4b494394","text":"The Delta variant of SARS-CoV-2 has a lower fatality rate than the original (Wuhan) variant."},{"id":"514684a4-216a-43b8-89b4-796e192c499c","text":"The UN will not provide money to the Ukrainian government."},{"id":"05366e38-604d-43f6-b486-b13216dc32f1","text":"Ukraine authorized Poland to distribute Ukrainian passports."},{"id":"cc9c1faf-f971-4aad-bee5-4f46968b9f0a","text":"Nicotine patches cure Parkinson\u2019s disease."},{"id":"8aeeea15-aa9e-4a7a-ac13-8421e1c1f6c6","text":"A Ukrainian Army tank crushed a car containing a passenger."},{"id":"94eef71a-da34-4277-a1f1-3afbc1c2a534","text":"A record number of Ukrainian tourists visited Crimea."},{"id":"e2b7a9e2-4169-4e2a-82cc-818f5dbdf36e","text":"COVID-19 PCR tests are inaccurate, have been discontinued, and cannot differentiate influenza from COVID-19."},{"id":"54a34012-19fb-4e45-96e9-9f7d1cf417c3","text":"Ukrainian President Volodymyr Zelenskyy exempted relatives of Galicia Division soldiers from conscription."},{"id":"174d2d07-cece-44ec-bff4-d6647249a61c","text":"COVID-19 vaccines are causing a rise in heart attacks among young people."},{"id":"48106139-5b3f-4a6e-9465-2a535b8dff53","text":"Ukraine refuses Western arms due to supply difficulties."},{"id":"5555a3e9-f056-4401-98d7-334e7c38bed0","text":"Lockdowns and face masks do not control the COVID-19 pandemic."},{"id":"2363ff10-3235-432d-913b-658d5f2453d3","text":"The European Union warned Ukraine against militarizing the Sea of Azov."},{"id":"7d9ded32-cfd4-472c-b8e6-639d3e8e7c2b","text":"COVID-19 vaccine spike proteins accumulate in cell nuclei, destroy DNA repair pathways causing cancer, and destroy the immune system."},{"id":"2d731179-770f-46ec-8cff-cdc71213ab2e","text":"COVID-19 immunity lasts for years."},{"id":"74724b14-e8b2-4ed4-bbdd-94566006218f","text":"Ukraine is preparing terrorist attacks in Crimea."},{"id":"06442e9b-bfee-45f4-96d3-f5cbde74c12e","text":"Rockefeller suppressed natural healing modalities to profit from petroleum-based medicine and had natural medicine practitioners arrested and jailed."},{"id":"859e3451-91df-41d7-9b35-30e293b2db5a","text":"Flights from New Zealand to Argentina connect through the U.S., which proves the Earth is flat."},{"id":"c8b6c191-aa5f-4a01-a9b3-7f5ab792cb55","text":"The CDC is a vaccine company that owns over 20 vaccine patents and sells $4.6 billion in vaccines every year."},{"id":"c0e76ce0-91b7-4426-8580-548fe286b428","text":"Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic."},{"id":"73540cd3-dc5a-4e7a-b48a-87b447fccd37","text":"A new language law makes Ukrainian the only official language."},{"id":"16a1efe5-5a02-41dd-9a47-0d530689fdf9","text":"Birch trees were chopped down in Lviv to prevent Russian influence."},{"id":"60d005f6-07f6-4f28-9fbd-3287183b009c","text":"Smoking protects against COVID-19."},{"id":"b0dbda2c-722c-48c6-8dcf-06d13f0ff79c","text":"Vaccinated people are more likely to die from the Delta variant than unvaccinated people."},{"id":"86683180-8d4c-43cd-93b5-f7aefe9a07fc","text":"Ukraine\u2019s Defense Minister declared World War III and urged the West to raise the stakes."},{"id":"bf5f91e6-8c18-466f-a8dd-eac3650d3939","text":"Vaccination causes two deaths for every three deaths it prevents."},{"id":"014ed6d2-14a6-4b25-b4d0-56327e826885","text":"Global warming is causing polar bears to go extinct."},{"id":"53cfb7f0-c2ff-4d26-a2aa-737cdc1dedab","text":"Natalie Jaresko, Ukraine\'s Minister of Finance, is the sister of former president Viktor Yushchenko\'s wife."},{"id":"263eb8da-8c39-424c-b6a6-dbcad9df2dcb","text":"Ukraine recruits mentally unstable foreign fighters."},{"id":"afa073a5-82d5-42b2-8a5c-972cb0b1a9d3","text":"Germany asked the United States to ease sanctions on Russia."}],"events":[{"id":"84e152f2-fa18-4730-8436-ae5868f07e84","text":"Event1"},{"id":"4c5754f0-e690-4c37-8ac5-89c6b1886ae5","text":"Event2"},{"id":"e75e4d20-06f6-4d3c-bec3-b01d9ef39ba6","text":"Event3"},{"id":"1ee8cf44-cebf-4220-a190-81aff7f6362c","text":"Event4"},{"id":"ab16a202-77eb-433f-a95d-8a5c32382587","text":"Event5"},{"id":"925e012a-7b2b-46ed-9b92-fee628879d10","text":"Japan suspended use of multiple Moderna COVID\u201119 vaccine lots after reports of black/foreign particles found in vials (September 2021)."},{"id":"970e6f4d-f145-4e08-88bb-8b775120a572","text":"Media coverage and public records requests highlighted increases and registration of \'Sudden Adult Death Syndrome\' (SADS) entries and prompted local registries/news stories in 2021\u20132022 (e.g., ONS FOI data and June 2022 press stories)."},{"id":"ffb34bd6-7690-4d59-b1ea-e3df21125aaf","text":"Federal judge orders FDA to hasten release of Pfizer COVID-19 vaccine documents after agency proposed a 75\u2011year timeline."},{"id":"8c5f4025-aa29-4b77-9333-f49a177101a3","text":"Public health agencies (including the CDC) acknowledged a rare association between mRNA COVID\u201119 vaccines and myocarditis/pericarditis, particularly in younger males (June 2021 and onward)."},{"id":"9a10a4c8-d6d4-40b4-afa3-7b1430b44a12","text":"Canada officially declared bisphenol A a \'toxic substance\' and banned BPA in baby bottles (widely reported in October 2010)."},{"id":"1b3be0de-f336-4d77-9018-5cacd2638d84","text":"EU Regulation 2018/213 restricting the use of BPA in varnishes and coatings intended to come into contact with food (adopted 12 February 2018)."},{"id":"8293afe9-596b-46e3-9a99-a40916ec1804","text":"Authoritative public health pages (e.g., NIEHS) and large NGOs published accessible summaries about BPA being an endocrine disruptor and a substance under active study for health effects (updated educational pages in 2020\u20132021)."},{"id":"5cf646d1-647b-4ff5-a477-efe2d006cc48","text":"German federal and state governments adopted and publicised \'2G\' rules that restricted access to restaurants, cultural venues and events to vaccinated or recovered people."},{"id":"395a9807-e7a3-4ab3-94b4-498e499a5709","text":"Large anti-lockdown/anti-vaccine protests in Berlin where police used barriers, cordons and force to control crowds."},{"id":"bf3d4f0a-3cf2-40bc-9347-70f81eb72707","text":"Lancet Psychiatry cohort study (Taquet et al.) reporting increased incidence of neurological and psychiatric diagnoses \u2014 including psychotic disorders \u2014 in the six months after COVID-19 infection."},{"id":"04f15057-3aed-4d7d-a1ce-a1ed60652382","text":"NATO commander publicly reported sightings of columns of Russian tanks and troops crossing into eastern Ukraine."},{"id":"cee770f3-7c9f-4178-9c74-654b0a079459","text":"Investigative reporting (e.g., Bellingcat) published satellite analysis and open\u2011source investigations documenting cross\u2011border convoys and movements of heavy weapons into separatist\u2011held areas."},{"id":"69b54743-69ff-4a08-818f-3f34fa3103f2","text":"The February 2015 Minsk II agreement called for withdrawal and monitoring of heavy weapons but left verification and inventories contested."},{"id":"b59a915c-4a63-4d9f-a50e-20ff35f19092","text":"National Child Mortality Database (NCMD) data release: child death notifications in England Apr 2021\u2013Mar 2022 (3,470 deaths; 396 more than previous year)"},{"id":"951c2a71-d688-4dd2-895c-f68662968dc4","text":"Kerch Strait incident \u2014 Russian forces fired on and seized three Ukrainian naval vessels near the Kerch Strait."},{"id":"94f80ec4-2cc3-4557-83eb-9dfab510cfa7","text":"Odesa Trade Unions building fire \u2014 violent clashes on 2 May 2014 ended with a fire that killed dozens; accounts of responsibility were disputed."},{"id":"cddf823c-29ba-406d-9d4c-a908fa0144cb","text":"Maidan sniper shootings \u2014 dozens of protesters and police were killed during the February 2014 Maidan clashes; responsibility for the snipers remained contested."},{"id":"edd2b72d-6442-4656-aab4-f03a4a38c553","text":"GUE/NGL (European United Left/Nordic Green Left) letter to President Poroshenko expressing concern about banning the Communist Party and alleged persecution of left\u2011wing groups"},{"id":"2add510d-82f0-4d5c-9dc5-a97ddccba76f","text":"Court ban on the Communist Party of Ukraine (Kyiv administrative court decision reported December 2015)"},{"id":"305fda9b-19da-4f40-8a6b-dd9dcd2e373f","text":"Panama Papers revelations naming Poroshenko\'s offshore connections (widespread reporting in April 2016)"},{"id":"88a4b9ac-a4ef-4d31-b258-078d5929dfa3","text":"Fugitive lawmaker Oleksandr Onyshchenko\'s public corruption accusations against Poroshenko (June 2016)"},{"id":"9becb736-cbb7-43af-b42b-e7efd7fcafaf","text":"Court-ordered release and ongoing discussion of Pfizer/BioNTech vaccine documents (PHMPT/FDA document release process)"},{"id":"0911f635-e117-4a63-960f-87a757d833cd","text":"Venice Commission (Council of Europe) publishes an expert opinion on the 2019 language law raising concerns about minority-language guarantees"},{"id":"cd44330b-fa1c-49b8-889e-4f60abb1948a","text":"Ukrainian parliament adopts the law \'On Ensuring the Functioning of Ukrainian as the State Language\'"},{"id":"a1663ab3-1573-41d6-b61e-125f36ef72b5","text":"Immediate political/media backlash and Kremlin-linked commentary framing the law as an attack on Russian speakers"},{"id":"a6a07057-e2be-4abb-a102-d1ff864ddae5","text":"Long\u2011running Kremlin/state media narrative labeling the Azov movement and affiliated groups as \'neo\u2011Nazi\' and dangerous."},{"id":"06716448-d748-4bcc-9d29-709595db86e6","text":"Denis Pushilin / DPR authorities declared OSCE activities in DPR unlawful and ordered SMM property removed (escalatory political declaration)."},{"id":"23f1861f-9600-4e6e-bcda-e17290f2aa90","text":"OSCE SMM evacuated international monitors and then discontinued the Special Monitoring Mission (loss of on\u2011the\u2011ground oversight and telemetry)."},{"id":"39463f3a-f93e-4fc4-81fc-fbf6f203c465","text":"High-profile advocacy and testimony for ivermectin (FLCCC / Dr. Pierre Kory Senate testimony, Dec 8, 2020)"},{"id":"73ef133e-2e7a-4d4a-b9c2-0afcb4bbdfb4","text":"Circulation of prominent preprints and small trials (notably the Elgazzar et al. preprint, Nov 2020) reporting large mortality benefits that fed pooled meta-analyses"},{"id":"88583943-069b-4732-b145-80a54a783005","text":"U.S. announcement to withdraw from the Paris Agreement (President Trump)"},{"id":"a560f278-4f3d-4e87-a291-dc062e6e9562","text":"High\u2011profile congressional testimony by climate skeptic John R. Christy asserting climate models overstate warming"},{"id":"9aa968e2-cdcd-4bd0-ae6e-db3b7a550990","text":"Poland warns it could veto the EU budget over rule\u2011of\u2011law conditionality"},{"id":"7350d91d-6408-4345-9369-78eb520a02d4","text":"European Commission/legal action over refusal to accept refugee relocation quotas"},{"id":"fb703d7b-7566-46ce-87a6-338cbccd27f1","text":"European Commission triggers Article 7 procedure against Poland"},{"id":"9463f49d-31e2-47bb-aeba-88b26e0eaaff","text":"Mass protests after president signs contested judicial reform laws"},{"id":"618c1ef0-a692-466c-b963-89ea7243c3be","text":"Documented NGO and foundation support for Crimean Tatar NGOs (e.g., listings of NED and other international support for Crimean NGO activity after 2014)"},{"id":"bb1bd6e8-303f-4ed0-9dfa-3f0919d2e099","text":"Russian courts moved to ban and label the Mejlis \'extremist\' (legal actions and formal prohibition)"},{"id":"8adee013-069c-486c-93d0-9361c778763b","text":"High-profile visits and statements by Mejlis leaders to international bodies (OSCE/UN/US) \u2014 e.g., Mustafa Dzhemilev meetings in 2015"},{"id":"c9763a61-b691-4150-a4d6-286b290ccac9","text":"Czech President Petr Pavel said in public interviews that Ukraine may need to be \'realistic\' about the prospects of liberating all occupied territory and that some areas could remain under Russian control temporarily."},{"id":"c1c46137-389d-4bf3-a508-0df6760ca0ec","text":"Joint Prague press conference (Pavel and Zelenskiy) and Reuters coverage where Pavel warned the West not to pressure Ukraine into immediate liberation of all territories and said Russia \'has all the cards\' to end the war."},{"id":"61c505f4-7c2c-4e12-8853-97ed1f2b95db","text":"Peer-reviewed meta-analysis reported that berberine (a plant alkaloid) showed glucose\u2011lowering effects in randomized trials, with some comparisons to metformin (systematic review and meta\u2011analysis, PubMed)."},{"id":"63d361ed-d80d-486b-96b3-587c68b4764e","text":"U.S. FDA and FTC jointly sent warning letters to 10 companies for marketing dietary supplements with unlawful claims to prevent, treat or cure diabetes."},{"id":"0348d2b7-6176-40f0-8b89-d8fcabe47875","text":"Japan finds stainless\u2011steel/foreign particles in multiple Moderna vaccine vials, triggering recalls/pauses"},{"id":"458962f4-39a7-49c7-93c4-ffe550b06aef","text":"Historical FDA enforcement and public warnings against Hoxsey\u2019s remedies (including 1956\u20131957 inspections and widely distributed FDA \'Beware\' posters)."},{"id":"139b2601-d9aa-4412-b035-49159c4fc066","text":"Ukrainian Cabinet of Ministers issued a permit allowing Biopharma Plasma to export 32 blood\u2011derived medicinal products (Cabinet resolution No.1005)."},{"id":"6db163de-95c0-49df-b814-1d89da588703","text":"Publication of a large Danish national birth\u2011cohort study (Liew et al.) reporting an association between maternal acetaminophen use in pregnancy and autism spectrum disorder (ASD) with hyperkinetic symptoms."},{"id":"fa3b2a1f-10f3-41ec-9d6b-06b8a56e9f91","text":"2014 J. Agric. Food Chem. study: quercetin and EGCG shown to have zinc ionophore activity in models"},{"id":"5bfd217e-b4e3-4698-a671-853a469c1a85","text":"2014 PLoS ONE report: chloroquine acts as a zinc ionophore"},{"id":"262c9c9c-f3c5-44e4-a1d0-01947c0c5501","text":"Mid\u20112020 public promotion: clinicians/influencers (eg. Dr. Vladimir Zelenko) advocated hydroxychloroquine + zinc as a COVID\u201119 treatment"},{"id":"076ebc36-d450-46a6-ba2b-2a82d07b55d3","text":"October 2020 multicenter cohort (NYU) preprint: \'Zinc with an ionophore associated with reduced in\u2011hospital mortality\'"},{"id":"c3488754-8e08-4402-b2a0-85331fff963b","text":"2010 PLoS Pathogens paper: in vitro inhibition of coronavirus polymerase by Zn2+ and blockade of replication by zinc ionophores"},{"id":"24a451dc-483c-4c83-90ec-f9810c097d83","text":"Hungary vetoed a joint NATO statement on Ukraine citing concerns about the rights of the ethnic Hungarian minority"},{"id":"ba89b7d5-0234-4982-ab98-56b648aa5a9d","text":"Hungary\u2019s simplified naturalisation (citizenship-by\u2011descent) program resulting in large numbers of passports issued to ethnic Hungarians in Transcarpathia/Zakarpattia"},{"id":"47c5cbc0-38ac-4145-83fc-adb129b8a28b","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly stated during the 2022 Russian invasion that the lives and security of Hungarians in Transcarpathia/Ukraine were a priority for his government"},{"id":"ecc9b611-102b-4b4b-b0a9-3ddf7f7a28fd","text":"Media and human\u2011rights coverage documenting tensions and complaints by the Hungarian minority in Zakarpattia/Transcarpathia during 2017\u20132022 (language disputes, local political friction)"},{"id":"07778b1f-b8cd-449c-ae6c-5f704a14dccc","text":"U.S. issues Emergency Use Authorization and rapid rollout of Pfizer\u2011BioNTech vaccine (December 2020)"},{"id":"e1827af4-5212-4e67-9651-9f7cb1021ab5","text":"UK regulator (MHRA) issues guidance after two reports of anaphylaxis following the first Pfizer/BioNTech vaccinations"},{"id":"3d943bcc-f75f-4abc-9e2b-6abbbfa07af8","text":"Pfizer/BioNTech EUA fact sheets and clinical publications note limited data in children and absence of long\u2011term safety data at authorization"},{"id":"a16a0af6-54e6-40ad-b4d6-0580573f8262","text":"Mass stabbing at Westfield Bondi Junction created a chaotic breaking-news environment"},{"id":"ce9032db-2a19-40b8-af12-ec438a6ece7e","text":"Major Iberian power blackout on 28 April 2025 that disrupted electricity across Spain and Portugal"},{"id":"9f1e0b10-f3b9-4110-a148-2ec0f8f50515","text":"Nationwide Telef\xf3nica network update caused widespread mobile and emergency-service outages across Spain"},{"id":"f565afca-6eec-40ab-b60e-39070f028961","text":"Czech Ministry of Foreign Affairs published an official statement saying the Crimea referendum was held in violation of the Ukrainian constitution, that the Czech Republic does not recognize the referendum results and continues to recognise Crimea as part of Ukraine."},{"id":"d3b19056-328f-47b8-b4af-f85f9656a684","text":"Czech President Milo\u0161 Zeman publicly criticised Western sanctions and expressed skepticism about their effectiveness in interviews/statements in March 2014."},{"id":"452436c8-3d1b-40c3-8efa-d978e367bc75","text":"Release of GLOBOCAN 2022 global cancer estimates showing large numbers of new cancer cases and highlighting female breast cancer as one of the most common cancers"},{"id":"a803e4bf-7243-49a0-af5f-2029ff92b91d","text":"Publication of national cancer registration statistics for England (Cancer registrations 2022) showing higher numbers of cancers diagnosed in 2022 compared with 2021"},{"id":"405388de-0b9e-4980-b174-36e7f057144b","text":"GRELL cooperative study (2013) and similar national registry analyses showing modest annual increases in breast cancer incidence among women under 40 in several European countries"},{"id":"5f074750-a6eb-4bc7-b8c2-bb71a36d7d7c","text":"Publication of analyses and commentary about the impact of COVID\u201119 on cancer services and screening (UK/NHS context) documenting diagnostic backlogs and subsequent rises in diagnoses when services resumed"},{"id":"2a6fc254-1269-458f-8a30-9f2f870a60e9","text":"Prominent visibility of far\u2011right/ultranationalist groups (e.g., Right Sector) in Maidan protests"},{"id":"8adb6909-17d6-4caf-931f-a2874497a9d5","text":"Seizures of regional government buildings and street clashes in eastern/southern Ukraine (Donetsk, Kharkiv) in early March 2014"},{"id":"d2457389-c3d9-47cc-a513-cab7d7fdc8ca","text":"Widespread toppling/removal of Lenin statues across Ukraine (the \'Leninopad\')"},{"id":"1e96ff68-3faf-4f64-9309-c3fd81619485","text":"High local tensions and protests in Lviv during February 2014, with public gatherings and confrontations around symbolic sites"},{"id":"38ab785c-3e01-47bb-954c-90b12bfbbd95","text":"Russian/state media narratives framing the Kyiv movement as \'fascists\' and amplifying isolated incidents"},{"id":"cda74b8c-f8e1-43b3-97ea-f10b8662e7d7","text":"President Trump publicly urged the FDA to \'fast-track\' potential COVID-19 treatments, including hydroxychloroquine"},{"id":"15d565d3-fd46-4488-948e-1e1d2ec92989","text":"ClinicalTrials.gov registrations for thalidomide trials in COVID-19 (e.g., NCT04273581)"},{"id":"33ac0e90-a934-4be1-8500-d703efc8fe1d","text":"Moderna announces first participant dosed in NIH-led mRNA-1273 Phase 1 vaccine trial"},{"id":"53818edf-d20a-4280-b405-d6631088ec3c","text":"OSCE Representative on Freedom of the Media condemns attacks and detentions of journalists in eastern Ukraine"},{"id":"15fa5012-49f2-4fe0-b2fc-c036c78dfe23","text":"Two Russian state television journalists (Igor Kornelyuk and Anton Voloshin) killed by mortar fire near Luhansk"},{"id":"c71e0105-7c15-496e-9e5d-9ad87554a6d3","text":"Italian photojournalist Andrea Rocchelli killed near Sloviansk while reporting on Donbas fighting"},{"id":"f594392c-a4dc-4c76-b795-28d998459538","text":"Scientific literature demonstrating decades of \'edible vaccine\' research (2019 review \'Edible Vaccines: Promises and Challenges\')"},{"id":"cbb81680-9122-4150-9b14-5fde22755d97","text":"U.S. House passes amendment to prohibit funding for \'transgenic edible vaccines\' (Massie amendment)"},{"id":"21faff8f-7b2a-4bd9-aa48-b3fff46bdbf8","text":"Health Canada approval of Medicago\'s plant\u2011based COVID-19 vaccine (COVIFENZ)"},{"id":"c4fc88e3-814b-4889-bff4-556056c4912b","text":"2014 reports and analyses on prevention of smuggling of nuclear and radioactive materials at the Ukraine\u2013Moldova border"},{"id":"bb138d5e-1bd0-43f8-8c6a-e0c9519dded0","text":"2015 reporting on large volumes of spent nuclear fuel stored in exposed open-air yards at Zaporizhia NPP"},{"id":"e875ca96-e4d0-4af7-9a3d-1428f4ed7a9a","text":"WHO interim guidance on mask use (published 5 June 2020) noted there was \'no direct evidence\' from community studies on universal masking"},{"id":"d38c0d0d-a75e-4854-8acd-8ce2ba04c25a","text":"Russia began issuing Russian passports to residents of occupied Donetsk and Luhansk (passportisation program, reported from 2019 onward)"},{"id":"5c86b624-3bf8-41c0-9ef3-0881445603c3","text":"Pre\u2011war remittance and labour links between Ukraine and Russia documented in World Bank data (substantial remittance inflows historically)"},{"id":"8f904b01-783a-4203-a9f8-4d3a6e7a90f3","text":"2001 Ukrainian census shows large Russian\u2011language population (\u224829.6% reported Russian as mother tongue)"},{"id":"c1cdb795-eef3-4d83-b2cf-fc7b4f142e4a","text":"Media reports (e.g., Reuters, 11 Jan 2023) relayed WHO and other experts saying XBB.1.5 may be driving recent case increases in some areas."},{"id":"38a40083-ba49-4c7e-b6a1-0d8ad9e16a68","text":"Oxford/UK analyses and technical briefings in July\u2013August 2021 documenting reduced vaccine effectiveness against symptomatic infection with Delta and reporting viral-load related findings."},{"id":"586c490e-494f-4e24-87a3-09fb08b48cf5","text":"CDC MMWR report on the Provincetown (Barnstable County) outbreak showing many cases among fully vaccinated people and reporting similar viral loads in some vaccinated and unvaccinated cases."},{"id":"f8ad6006-14cd-42b8-9f41-ac32b1e2a1c8","text":"Ongoing pattern of journalists killed or injured while reporting on the Russia\u2013Ukraine war since 2022."},{"id":"38e9e7d0-ff0d-47f5-ab45-be36a362e697","text":"Escalation of cross\u2011border fighting and reported Ukrainian incursions into Russia\'s Kursk region in early August 2024."},{"id":"33f06504-34f5-4ddc-9f7d-6977df239b00","text":"Retraction of high-profile hydroxychloroquine research (Surgisphere-related Lancet study)"},{"id":"09f3b156-9142-4170-b82c-d6e48fd74216","text":"U.S. Food and Drug Administration revoked the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID\u201119"},{"id":"0547cf7c-f4fc-4f88-881e-f354799d394b","text":"Publication of a 2015 review clarifying that peripheral (gut) serotonin and central (brain) serotonin are separate pools because serotonin itself cannot cross the blood\u2013brain barrier."},{"id":"99388c57-039d-4450-a2ea-77d39164f936","text":"Vatican note on the morality of using some COVID-19 vaccines (explicit discussion of fetal\u2011cell\u2011line origins)"},{"id":"de0877d2-e5b8-4dc0-abcb-4d999de7b03d","text":"Public-facing CDC guidance page describing vaccine additives and manufacturing substances (e.g., formaldehyde, aluminum) made widely available"},{"id":"af8c4621-5743-4ab5-b75f-a10982b627f3","text":"CDC / AAP precautionary move to remove/reduce thimerosal from childhood vaccines (timeline publicity)"},{"id":"e68ea319-a743-4063-8a6b-a57f7b693345","text":"Detection of porcine circovirus DNA (PCV1) in the Rotarix rotavirus vaccine and global regulator review"},{"id":"d295f0d3-9153-4814-85db-70ed8ee95007","text":"Assassination of Boris Nemtsov on a bridge near the Kremlin"},{"id":"e7ba6c83-fd4f-4845-861d-7416006c77a2","text":"Vatican Congregation for the Doctrine of the Faith published a note stating it is morally acceptable to receive some COVID-19 vaccines developed using cell lines from aborted fetuses (approved by Pope Francis)."},{"id":"9fde4b91-1e88-4275-b6d7-a293610dfff4","text":"CDC Pink Book Appendix B (Vaccine Excipient and Media Summary) lists cell lines such as WI-38 and MRC-5 in vaccine production context (table circulated online, edition info in use January 2021)."},{"id":"f4f24cf5-1439-45d8-8416-872bde8b9671","text":"American Optometric Association consumer alert about at\u2011home/online vision tests and devices"},{"id":"820dbe4e-83e3-4ea1-af12-b4e14d598494","text":"Russian proposals and measures to fast-track citizenship for Crimean residents"},{"id":"28bb7190-953a-4a8d-a25b-abfc2ded7b69","text":"Pro-Russian separatists declare Donetsk \'People\'s Republic\' after seizing regional building"},{"id":"67aeabae-2f28-4de2-9c18-746e97c6ff30","text":"Putin\'s Kremlin speech endorsing Crimea accession"},{"id":"9d4cf030-6541-4767-9e93-bb36756e465d","text":"Delta-variant surge and public messaging (summer 2021) urging vaccination ahead of difficult hurricane-season scenarios"},{"id":"2a085237-4836-4154-98f0-9f710d9832b1","text":"Israel reports drop in observed vaccine effectiveness against infection (94% \u2192 ~64%) amid Delta"},{"id":"9e3e000c-4764-4206-bac6-bdcd3f0133d6","text":"Great Barrington Declaration advocating \'focused protection\' published"},{"id":"2f24c199-c87c-411b-be26-4f3f75b8cd6b","text":"Systematic review estimating COVID-19 infection-fatality rate ~0.68%"},{"id":"2e9cc47a-173b-422c-b53b-2f26ae0482c1","text":"Age\u2011stratified IFR analysis showing extremely low fatality risk for younger people"},{"id":"9ffd3bc2-8394-44e0-8da9-eec5d9fbaa87","text":"Public availability of VAERS as a passive reporting system and official CDC/FDA guidance about its limitations"},{"id":"504c325b-a327-4bc7-9702-a9c23fc4826a","text":"ACIP/CDC recommendation during the 2009 H1N1 pandemic that pregnant women receive H1N1 and seasonal influenza vaccines"},{"id":"0cd08bab-1c16-466b-9d97-d512cdb3e045","text":"Publication of Goldman GS (2013) \'Comparison of VAERS fetal\u2011loss reports during three consecutive influenza seasons\' (Human & Experimental Toxicology)"},{"id":"37fe491a-4683-4a84-92a8-9eb4d4f308c9","text":"Reports and analyses in 2015 highlighted growing Hungarian activism in Zakarpattia (large numbers receiving Hungarian passports and political pressure over minority rights throughout 2015)."},{"id":"87740410-18dc-43f6-8b3a-dfb1e442eef4","text":"Think\u2011tank analysis and regional commentaries described longstanding identity, linguistic and historical fault lines in Zakarpattia and proposals for a \xabTrans\u2011Tisa/Transcarpathian\xbb administrative unit (OSW commentary, Sept 2015)."},{"id":"2dc81d64-1251-487b-8ebc-c1e96d5a010e","text":"Armed clash (Mukachevo shootout) between Right Sector fighters and local security forces in Mukachevo, Zakarpattia, leaving several wounded (11 July 2015)."},{"id":"cc779605-8036-4dcd-adc3-6a7f8ced5971","text":"Local reporting and human-rights outlets flagged that the \u2018\u2018Transcarpathian Rus\u2019\u2019/Rusyn congress and statements by Petro (Pyotr) Getsko were likely provocations amplified by Moscow (coverage March 2015)."},{"id":"466b0be3-a108-433b-ad5b-8aab49d16b31","text":"Scuttling of Ukrainian vessels in Donuzlav Bay (6 March 2014) to block naval exits"},{"id":"66e492cc-628c-4066-bfb2-29d02e77d639","text":"Official/legal exhibits and scientific analyses documenting that the Sea of Azov and Kerch Strait routinely experience ice cover that can obstruct navigation (analysis covering up to 2017)"},{"id":"76c8703d-7904-486e-b008-51a836c2d852","text":"Severe Black Sea freeze restricted navigation and stranded vessels in January 2017"},{"id":"96054146-c21a-4c87-97f2-9161af7b504a","text":"Russian forces seized multiple Ukrainian naval vessels during the March 2014 Crimea operation"},{"id":"62235204-50c1-4ae0-bd7a-5bb86c3d0d34","text":"U.S. Ninth Circuit Court of Appeals issued an opinion (June 7, 2024) vacating the district court\'s dismissal and allowing a lawsuit challenging LAUSD\'s COVID\u201119 vaccine mandate to proceed; the opinion noted that, at the pleading stage, the court must accept plaintiffs\' allegation that the vaccines do not prevent transmission."},{"id":"b76e1028-54ea-4e7a-97ff-dcae5e37ba19","text":"The U.S. Centers for Disease Control and Prevention revised wording on its website for \'vaccine\' and \'vaccination\' in September 2021 (shorter/modernized wording replacing earlier phrasing about \'producing immunity\')."},{"id":"87b0077e-0141-4590-8618-4d3583e7cd53","text":"Local activist action in Chernihiv (\'Feed the Communist\') in May 2015 where activists distributed food kits and removed or replaced communist symbols."},{"id":"7b56002c-8c94-47bb-8e98-a0489250c31d","text":"Publication and publicity of studies showing reduced antibody responses in clinically immunocompromised groups (OCTAVE/related studies reported in The BMJ)"},{"id":"ce112929-14cc-4e58-8382-26363d0b1a18","text":"Stockholm arbitration tribunal ruled in favour of Naftogaz against Gazprom (final award and related rulings published 28 February 2018), ordering significant payments in Naftogaz\'s favor."},{"id":"c1ee117f-0c0f-494d-be3c-0eb8b31c1078","text":"Publication of a 2015 Danish case series (Brinth et al.) reporting suspected postural tachycardia syndrome (POTS) and related autonomic symptoms following quadrivalent HPV vaccination."},{"id":"e5400c13-6955-4e7f-8ce1-97f02f2581c4","text":"Danish Medicines Agency and European regulators reviewed reports from Denmark about suspected HPV vaccine adverse events and produced public assessments and data summaries."},{"id":"5d4bf37c-3e45-47b0-93d1-4452450157cb","text":"2014 French case-control study published in Clinical Rheumatology examining possible associations between the quadrivalent HPV vaccine and new\u2011onset autoimmune disorders."},{"id":"2ea4834d-e0b7-48fe-978d-3db1b6cb1c5c","text":"Ukraine\u2019s security service (SBU) announced an investigation that alleged nearly $40 million was embezzled in a mortar\u2011shell procurement scheme"},{"id":"ca18db01-64ae-4f7b-af77-b58223dc999d","text":"Pentagon Inspector General report found about $1 billion of U.S. weapons sent to Ukraine were not properly tracked"},{"id":"4cc69e6b-088b-456a-aa2c-66bb5cda35da","text":"Widespread media reports documented an increase in Ukrainians (including some displaced by 2014 unrest) travelling to or taking up work in Russia to escape economic hardship and instability."},{"id":"e2ae750f-bd2f-4b8a-b113-685b1344db2c","text":"Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers highlighting that recent warming is \'unequivocally\' driven by human activities (strong attribution to greenhouse gas emissions)."},{"id":"74eece4e-027a-4fcd-a614-30c38e2df8db","text":"Global Carbon Project press release and Global Carbon Budget 2021 reporting that global fossil CO2 emissions rebounded close to pre-COVID levels (published early November 2021)."},{"id":"a9042610-53a1-49f6-897c-4537a68bd04a","text":"UNFCCC COP26 (Glasgow, Nov 2021) international climate summit and high-profile policy announcements on phasing down fossil fuels."},{"id":"24cb8c6a-0ca7-47cd-ab09-f8ccf313d3cd","text":"The extraordinary Pacific Northwest heat wave in late June 2021 and rapid attribution studies published in the weeks after the event."},{"id":"338a6e3b-3418-4a7d-941b-ec10b497cb0a","text":"Council of the EU adopted visa\u2011liberalisation regulation for Ukrainian citizens (moving Ukraine to visa\u2011free Annex II)."},{"id":"b9016207-12a5-47c8-abf0-886586d3945a","text":"Major outlets explained how the visa\u2011free scheme would operate and its limits (e.g., that it allowed 90 days\' travel within any 180\u2011day period and depended on biometric passports)."},{"id":"90b2621e-baa8-4075-aa10-ccae5c1cf0e6","text":"Legal and normative context: Ukrainian prohibition on promotion/distribution of totalitarian symbols (noted in fact checks of similar claims)"},{"id":"bb22cdd2-06b4-4469-a87d-4c76ab4fe0fa","text":"CDC guidance promoting widespread use of cloth face coverings and advising regular washing/maintenance"},{"id":"3e6db30e-ded5-4658-b27f-d0cef081d848","text":"Dentistry and trade press reports warning about \'mask mouth\' and increased oral health issues"},{"id":"8d853396-b772-4678-8b21-d54392993e09","text":"Public demonstrations by scientists/microbiologists using petri-dish or droplet-capture experiments to show masks block droplets"},{"id":"94ec6777-664c-4b7d-9759-39c0d7a2bd4c","text":"Industry and research reports (IEA-PVPS and others) documenting end-of-life management challenges and the need to scale PV recycling infrastructure."},{"id":"e747d535-762d-4e0b-a2ec-e3a175575171","text":"Coordinated farmer and rural groups\' campaigns and protests against \'mega\' solar farms on productive farmland in the UK (national days of action and rallies organized by rural campaigners)."},{"id":"afe1ead5-1aed-474e-985a-3e97a9a02c20","text":"Laboratory leaching studies showing that crushed or non-encapsulated cadmium\u2011telluride (CdTe) thin\u2011film solar cell material can release cadmium and tellurium under extreme test conditions."},{"id":"a2acefbd-c6a4-4b32-a8ff-3bfbb8c45adc","text":"OSCE Special Monitoring Mission (SMM) recorded a marked increase in ceasefire violations in Donbas in early 2021 (multiple daily reports documenting dozens to hundreds of violations)."},{"id":"1b6d7754-0f5f-4684-a918-e2eec4807eaf","text":"U.S. Department of State \'Ukraine 2020 Human Rights Report\' (published March 2021) documented the activity and influence of volunteer/paramilitary and nationalist groups (e.g., units linked to political parties) active in eastern Ukraine and at the front line."},{"id":"dab780cc-2893-405e-9364-778210326efa","text":"Verkhovna Rada (Ukrainian parliament) passed the 2018 \'On the peculiarities of state policy to ensure Ukraine\'s state sovereignty over temporarily occupied territories of Donetsk and Luhansk regions\' (the \'reintegration of Donbas\' law) declaring parts of Donbas occupied and Russia an aggressor."},{"id":"b95529c5-7b9f-48fb-9a4c-37ab0a491330","text":"President Zelenskyy\'s 2019 public handling of the Steinmeier Formula (acceptance/clarification) and the related domestic protests over concessions for the Donbas."},{"id":"45df0e47-67dc-407c-a742-cab16d53dbae","text":"EU and US adopted rounds of sanctions against Russia following the 2014 annexation of Crimea and continued to maintain restrictive measures in subsequent years."},{"id":"e9bf8f60-c979-49e6-b95d-09ffc6f94217","text":"Public reporting and analysis of contacts between Trump\u2011family advisers (including Ivanka/Kushner) and Russian figures during and after the 2016 campaign (coverage of the Mueller report, 2019)."},{"id":"b37f56c1-d8ec-44b6-9f51-71bedd748aad","text":"Pro\u2011Russian activists stormed SBU (security service) offices in Donetsk and Luhansk and reportedly took weapons from armories."},{"id":"19b39938-7518-435d-8045-b77bcd17e92f","text":"Ukraine\'s defence ministry publicly acknowledged that a number of its vehicles/equipment had been seized by pro\u2011Russian forces."},{"id":"764a63e8-70c4-44e2-8685-71474c046ffa","text":"State-level policy changes in 2022 loosening access to ivermectin (pharmacist dispensing/OTC measures in several U.S. states)"},{"id":"dec1b8d9-e6fd-4204-91b9-5acb9e4a20d3","text":"Apter v. Department of Health & Human Services \u2014 Fifth Circuit opinion allowing doctors\' claims against FDA to proceed and criticizing agency messaging"},{"id":"5f07a8e7-1b2d-4df5-b547-53edbec94853","text":"President Poroshenko signed the 2015 \'de-communization\' laws (May 2015) that, among other provisions, publicly recognized fighters of the OUN\u2011UPA (associated historically with Stepan Bandera)."},{"id":"8fb7f94c-b42a-487d-a2bf-e75d6472fdff","text":"Russian state media had for months portrayed Ukraine\u2019s post\u2011Euromaidan authorities as \'Bandera\' nationalists and used the term \'Bandera junta\' in reports (widespread from 2014 onward)."},{"id":"8c93f48f-cd97-41d7-8071-bf33f5ef5a27","text":"The new law altered expiry/labeling requirements (e.g., month/year vs day/month) and set a delayed entry-into-force date"},{"id":"287eeae0-30ac-4391-8e0b-a92604678a04","text":"Verkhovna Rada (Ukraine\'s Parliament) adopted Bill No. 8450 \\"On Information for Consumers of Food Products\\""},{"id":"8c58258a-054c-4c2e-a256-0c03f926b4e2","text":"2012 research proposing a quantitative \'tongue deviation angle\' threshold as a possible early warning sign of stroke (Wei et al., August 2012)."},{"id":"2a64b747-3eff-40c8-9171-4394af0a45e0","text":"Launch of the UK \'Act F.A.S.T.\' national stroke-awareness campaign emphasizing Face/Arm/Speech/Time (first rolled out February 2009)."},{"id":"4b7c9126-7687-453a-94c5-617255028897","text":"European Commission public warnings about Ukraine\u2019s unfinished anti\u2011corruption and reform agenda"},{"id":"da7fa7b1-a74a-439e-85d2-687919f7c128","text":"EU\u2013Ukraine DCFTA implementation raised in trilateral talks with Russia amid practical concerns"},{"id":"c280d2d1-4e95-48f6-911d-93b54fe8369e","text":"2013 Ukrainian government suspended signing of the Association Agreement (Vilnius), fuelling narratives of failure"},{"id":"8064bfc2-7024-4f06-9497-986a1e975c0f","text":"CDC MMWR report on the Barnstable County, MA outbreak showing many \'breakthrough\' infections among fully vaccinated people (July 2021)"},{"id":"09c142a4-5c80-4531-a037-d8568610ded5","text":"Health Canada advisory and recall/alert over face masks containing graphene (public advisory that graphene in masks may present inhalation risks)."},{"id":"f78c939e-82d0-4c4f-a838-fd1250ba7971","text":"Published transmission\u2011electron microscopy (TEM) and SEM images of graphene oxide in the scientific literature (e.g., ACS Nano structural analysis of graphene oxide)."},{"id":"36cf21d5-796f-4744-9cc1-a42f82021e3d","text":"OSCE report documenting repeated interruptions to water access in Donetsk and Luhansk due to hostilities and infrastructure damage"},{"id":"ca063694-43d3-4dc1-a538-2895b55cceec","text":"Shelling damaged the Donetsk filtration plant, leaving much of Donetsk without running water"},{"id":"a57107be-6e07-4363-94d1-0ebcadc66c0c","text":"China\u2019s temporary nationwide ban on trade and consumption of wild animals announced amid the outbreak"},{"id":"496fb930-7235-4aa3-b62e-868b8ab98f1a","text":"Public\u2011health assessments linking many early cases to Wuhan\u2019s Huanan Seafood Wholesale Market"},{"id":"4f52da85-e4c1-4efd-9478-eb694741c62d","text":"Poland publicly resisted EU migrant relocation quotas and signalled tighter migration controls (Nov 2015)"},{"id":"5cca2f98-a550-4a3e-9542-da2e648b992d","text":"Poland and Ukraine temporarily closed or restricted certain crossings amid transport disputes (reports of Russian lorries stuck)"},{"id":"71749530-08cc-490b-b851-4665970d6156","text":"Europol and Polish Border Guard dismantled an international people-smuggling network (September 2016)"},{"id":"97914efc-b72a-45e9-ba29-907d16d037db","text":"Passage of post\u2011Euromaidan lustration (vetting) laws and criticism from rights groups"},{"id":"47427ce7-8514-42d1-9bea-9650fac07e2d","text":"Security Service of Ukraine (SBU) searches, surveillance and raids on media outlets and journalists (reported 2018\u20132019)"},{"id":"5ee94827-5ae5-42fa-bb8f-1a2178f4e6a2","text":"Kerch Strait incident and temporary imposition of martial\u2011law measures after the November 2018 naval clash"},{"id":"188d2a63-2cd4-4b15-b11b-b29437874cc5","text":"Government blocking of major Russian social networks and internet services under sanctions"},{"id":"9d0656e1-91a7-4568-a8c6-6145a17c6c4e","text":"OSCE SMM spot report (22 January 2015) documents shelling incidents impacting civilian infrastructure, including water facilities, in Donetsk"},{"id":"e4d29b02-ebaf-4515-8642-499825b90c32","text":"UN/UNICEF appeal (July 2015) calling for help to restore damaged water facilities in Donetsk and Luhansk"},{"id":"ed283ab5-9f4a-4aa8-b6ef-9d773773c737","text":"NCHS publishes final report \'Mortality in the United States, 2019\' (finalized 2019 death counts and age\u2011adjusted death rates)"},{"id":"bcde2733-2496-48bf-8dc7-e7b39c4fde0b","text":"Unusually low seasonal influenza activity and deaths during 2020 (CDC FluView reports for 2019\u20132020 and 2020\u20132021 showing steep decline)"},{"id":"e9fe3473-b79a-428a-b152-938869ca5bce","text":"UN Mine Action Service (UNMAS) 2019 reporting and annual material describing extensive contamination by mines/ERW in Ukraine and the long-term nature of clearance"},{"id":"a2b525c1-f547-4226-9fd2-d90a827de375","text":"Media reporting on international NGOs (HALO Trust) conducting humanitarian demining in Donbas and expanding operations in 2019"},{"id":"08f06c6d-d2b7-4425-a7e5-ec96e91f0466","text":"Peer\u2011reviewed and preprint research discussing biochemical/sequence similarities between portions of the SARS\u2011CoV\u20112 spike protein and snake neurotoxins (studies and tests of the \\"nicotinic\\" hypothesis)"},{"id":"e8aa4390-6332-4929-b285-0ce0d69d2812","text":"Norwegian health authorities reported deaths among very frail, elderly people shortly after receiving the Pfizer\u2013BioNTech COVID-19 vaccine and opened reviews (reports in mid\u2011January 2021 said 23 deaths were reported and some were judged possibly linked to vaccine side effects in very frail patients)."},{"id":"1a11be3a-b17d-4777-a790-4e41fa0143cf","text":"Reports and a CDC MMWR analysis documented cases of allergic reactions and anaphylaxis after initial Pfizer\u2013BioNTech vaccine doses in December 2020 (MMWR published January 2021 summarizing early anaphylaxis reports)."},{"id":"098c1a39-fa6a-4fc1-bcc0-0f833a274e1e","text":"Public release and wide circulation of raw VAERS (Vaccine Adverse Event Reporting System) reports documenting deaths reported after COVID\u201119 vaccination in late 2020 and early 2021."},{"id":"350a513d-eaad-4ca4-bac2-fd018fe7b558","text":"UNODC report and national statistics showing Ukraine as a significant transit country and location of large heroin seizures in Europe"},{"id":"c089cd94-21ba-4043-9f02-b312ba442b1b","text":"Europol / Eurojust-linked investigations and cross\u2011border law\u2011enforcement operations that identified networks using Ukrainian territory/ports to move cocaine and other drugs into the EU"},{"id":"e2bd56d7-c3a9-4fc6-a07b-4c44e736665f","text":"FTC and FDA joint warning letters and public enforcement actions targeting companies that market dietary supplements with unproven Alzheimer\'s or dementia treatment/prevention claims (e.g., joint letters and advisories in 2019)."},{"id":"0ec34392-7927-416a-97ed-ede221ecb2c4","text":"18-month randomized, double-blind, placebo\u2011controlled trial of a bioavailable curcumin formulation (Theracurmin) reporting memory and PET biomarker improvements in non-demented adults (Small et al.)."},{"id":"cae69692-e77c-4bd9-983f-d7e0a368a1c3","text":"Small randomized, double-blind, placebo-controlled trial (Mori et al.) reporting improved cognitive scores in mild cognitive impairment after Hericium erinaceus (lion\'s mane) supplementation."},{"id":"556c65b9-2e06-41a6-b9d3-5ced8e2b68a2","text":"Prospective cohort studies (e.g., Ohsaki cohort and related epidemiologic research) reporting associations between higher green tea consumption and lower risk of cognitive decline / incident dementia or functional disability."},{"id":"b3bcd9d2-ee33-4858-b64d-275faa36fa1a","text":"CBOS national poll showing sharp fall in Polish support for accepting Ukrainian refugees (April 2023)"},{"id":"8cd731d8-8d53-4a4d-a07f-c15214766715","text":"EDMO/Fact\u2011checking reports documenting early disinformation narratives about Ukrainian refugees in Poland (April 2022)"},{"id":"f8527199-6830-4e21-a052-7f5c6b8ecf3b","text":"Political rhetoric and electoral pressure around Ukraine support (Reuters report, 19 Sep 2023)"},{"id":"1005cfdd-f328-4004-887b-6052f4bfa6da","text":"Abbott/Similac powdered infant formula recalls and linked Cronobacter infections reported February 2022 (product recalls and infant illnesses/deaths)."},{"id":"a1d85e0f-f4ca-43fe-8c73-3b7382a9f07b","text":"Conviction of neonatal nurse Lucy Letby for murdering and attempting to murder infants (trial verdict reported August 2023)."},{"id":"8bbd3f20-f76e-47c4-a33b-75e14299d88c","text":"Reports in 2023 about a US clinician case involving allegations of destroying government COVID vaccine doses and administering saline (case reporting and later procedural developments in 2023)."},{"id":"b62e467a-7383-423e-b2db-36022673bd12","text":"Local Marseille municipal councillor Gerald\u2011Hubert Fayard publicly associated himself with a planned DPR \'representation\' (reported in regional and Ukraine\u2011focused outlets)."},{"id":"3892000c-47aa-4755-8d1c-d759dcfcf658","text":"Thimerosal (ethylmercury) removal efforts and public controversy (ACIP/FDA actions beginning 1999; IOM review 2004)"},{"id":"2c900a2a-cb87-43f3-8e60-e63de79f3846","text":"EMA guidance describes use of porcine trypsin (an enzyme) in manufacture of some vaccines"},{"id":"fe4407e1-2c58-4a48-aac8-8738ca900cd7","text":"IARC classifies formaldehyde as carcinogenic to humans"},{"id":"20fff54e-3944-4c7f-b960-6c30b9553484","text":"Immunization Safety Review and public concern over SV40 contamination of polio vaccine (1955\u20131963) and subsequent reviews"},{"id":"22ec386d-2816-4822-8a28-ff0303dbb36e","text":"CDC MMWR report: \'Delay or Avoidance of Medical Care Because of COVID\u201119\u2013Related Concerns \u2014 United States, June 2020\'"},{"id":"ba0406c0-1eb5-47f0-8568-1e8cc3246f72","text":"CMS guidance: \'CMS Releases Recommendations on Adult Elective Surgeries, Non\u2011Essential Medical, Surgical, and Dental Procedures\' (recommendation to postpone elective care)"},{"id":"4064599a-92e3-4d1a-861d-e5dcc4543c95","text":"European and Global Drought Observatories annual progress/ data release (JRC/EDO-GDO report covering 2021)"},{"id":"71b4d6aa-c10b-42c5-a855-7e4f76bf6279","text":"Release of IPCC Sixth Assessment Report (AR6) Working Group II Summary for Policymakers"},{"id":"eff487a7-144b-43ed-9bf7-a81b8eb300b4","text":"Ukrainian President Petro Poroshenko warned of \'hundreds of foreign tanks\' in Ukraine"},{"id":"862e5564-7ed4-4431-bc87-301f42a6f9ff","text":"Large military parades and visible tank movements in neighbouring countries (e.g., Poland\'s Armed Forces Day parade showing tanks on public roads)"},{"id":"babb07ce-6461-4c01-8c46-35291a233a46","text":"Reports that Russian tanks and armoured columns had crossed from Russia into Ukraine"},{"id":"cb7d24fb-92ea-453e-a2e7-23ee01a5bf14","text":"Pentagon websites underwent a major content purge and reorganization earlier in 2025 (reported March 19, 2025), producing visible changes and confusion on DoD web properties"},{"id":"6505bf7e-a28b-4f90-81af-8e8806402064","text":"Japan suspended use/recall of some Moderna vaccine batches after reports of foreign particles (contamination) in vials"},{"id":"746c62c4-228a-4f2e-a8a3-2d7a29e70163","text":"FDA and CDC safety communications acknowledging rare myocarditis/pericarditis risk after mRNA COVID-19 vaccination"},{"id":"3bceb9ed-308a-4d20-9e15-e43ed722a41a","text":"Florida Department of Health issues guidance/analysis claiming an 84% increase in the relative incidence of cardiac-related death among males 18\u201339 within 28 days of mRNA vaccination"},{"id":"efc25508-34ea-4b2d-b056-e09159f5e65e","text":"Public criticisms and sparring by U.S. officials (including Vice President comments accusing Zelensky of being ungrateful) after the Oval Office exchange."},{"id":"8beb0182-4a6d-4773-bace-6843617f1729","text":"Human Rights Watch report \'Unguided Rockets Killing Civilians\' documented use of Grad (MLRS) rockets in Donetsk in July 2014."},{"id":"9a99a603-b48a-42f6-a5cd-97faca06e3f1","text":"Simferopol base shooting \u2014 Ukrainian serviceman reportedly shot dead during Crimea takeover"},{"id":"c1d329c8-b5d6-4cc7-a6da-b13d361d2b9e","text":"Euromaidan \'snipers\' massacre and government/official statements about \'shooting to kill\' (Kyiv)"},{"id":"86a0d544-0af2-48a1-8dc5-6ce0fff5551a","text":"Killing of nationalist figure Oleksandr \'Sashko Bilyi\' Muzychko during police operation (Rivne)"},{"id":"34aecffc-bfee-4e91-b571-37c65138c110","text":"Acting Interior Minister Avakov implicates members of elite police units in Maidan shootings"},{"id":"913af525-e568-4c5b-8ce4-89da8089677f","text":"Battle of Ilovaisk and the lethal \'green corridor\' ambush during Ukrainian retreat"},{"id":"9600bcc7-d0ab-41ed-9a55-cff1567158c4","text":"2020 research coverage: injectable hydrogels proposed as sustained\u2011release vaccine delivery platforms"},{"id":"e19958bb-c864-47ff-b697-31925e6f45d2","text":"2019 review article: \'Hydrogel bioelectronics\' (conductive/ionically conductive hydrogels for interfacing biology and electronics)"},{"id":"034cc14d-278d-40c6-a14b-c9f85da480a8","text":"Licensure and use of squalene-containing adjuvant MF59 in licensed influenza vaccines (first licensed in Italy)"},{"id":"b7c9a674-5222-4e76-8357-23419815bd79","text":"US Congressional hearings and report scrutinizing the Department of Defense Anthrax Vaccine Immunization Program"},{"id":"1a9cafe7-86d1-494b-902c-873da5aaca74","text":"Publication and media coverage of research finding antibodies to squalene in Gulf War veterans"},{"id":"5766004f-5539-4fec-8594-aff527a3c6f4","text":"1990s allegations that tetanus vaccination campaigns (Philippines, Mexico, Nicaragua) involved conjugation with hCG causing sterilization"},{"id":"aa4cef80-f44b-4276-b5a2-2b391127382e","text":"Wuhan city lockdown and rapid travel restrictions were imposed as cases spread (city lockdown announced 23 January 2020) amid reports of limited early transparency"},{"id":"e20f2626-174f-48f4-bc51-5f4f6c668dfc","text":"U.S. State Department fact sheet and public reporting describing activities and international collaborations at the Wuhan Institute of Virology"},{"id":"aed3a285-b1bb-472d-8c99-be38917e4ee1","text":"Published, peer\u2011reviewed and public research showing Wuhan scientists (including Shi Zhengli) studying SARS\u2011like bat coronaviruses and collecting bat samples"},{"id":"dc6d7b6a-8093-4315-aa36-84690a1ab200","text":"Ukrainian parliament voted to remove Yanukovych (328-0)"},{"id":"c545c24e-620e-4274-bb42-f77c2c191bba","text":"U.S. FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine on March 28, 2020."},{"id":"8e8c4b4f-9c03-46d7-8214-d6ddcd586c7f","text":"Publication of an early open\u2011label, non\u2011randomized trial from Marseille (Gautret et al.) reporting viral clearance with hydroxychloroquine \xb1 azithromycin."},{"id":"cee5220d-75e6-40f4-8c6e-3dc54f0cc12a","text":"Reporting from liberated towns (e.g., Trostianets) documenting looting and pillage by occupying Russian forces, published in major outlets in early April 2022."},{"id":"12c8d553-539d-44a4-916a-2115adb302e3","text":"Scandinavian booster policy narrowing in 2022 (Denmark recommended boosters primarily for those 50+; Norway targeted boosters to older/risk groups)"},{"id":"4dba2a71-3b72-4530-b7d1-3035aab05e0a","text":"NEJM analysis using Israeli Ministry of Health data showing protection and waning patterns of natural, vaccine-induced and hybrid immunity"},{"id":"4e9714da-d06e-47a1-a14e-0febb6ad3390","text":"Publication of a quantified-method study suggesting tongue deviation angle >3.2\xb0 may predict stroke (Biomed Eng Online)."},{"id":"07570ec8-fe9e-44ab-a378-535f60a98aa8","text":"Public Health England / NHS Act FAST stroke public awareness campaigns emphasising Face, Arms, Speech, Time (FAST) without mentioning tongue."},{"id":"340b926b-ada8-4988-88a9-06af47219f36","text":"UKHSA (UK Health Security Agency) vaccine surveillance reports documenting low or rapidly waning effectiveness against Omicron infection at some timepoints in 2022"},{"id":"d2f49b39-a8ba-4bf0-a777-027f04ee78e2","text":"U.S. Energy Information Administration (EIA) published accessible guidance and emissions-coefficient data explaining that burning natural gas produces less CO2 per unit of energy than burning coal."},{"id":"61bd6e7e-caf9-4c9f-badc-e923a4398824","text":"European Commission proposal and subsequent approval to allow some natural gas projects to be labelled as \'transitional\' / investable under the EU Taxonomy, followed by high-profile legal challenges and media coverage."},{"id":"e680d741-d0d2-417c-a836-e077af2c5147","text":"Clean Creatives published its F\u2011List 2024 report documenting over 1,000 recent advertising and PR contracts between major agencies and fossil fuel companies (including gas companies)."},{"id":"fdc6b92f-6215-4eca-b466-b494c9508aaa","text":"ClientEarth and partners announced they were joining legal action against Washington Gas over customer-facing marketing that described gas as \'clean\' and \'sustainable\'."},{"id":"692464af-4268-4b2b-a4e8-89ceb16c5307","text":"OSCE convoy came under fire near Mariinka (monitors shot at while travelling between Ukrainian checkpoints)"},{"id":"f4fc46ca-6b73-4af0-94c4-688c0051de69","text":"OSCE observers blocked from full access to the MH17 crash site by armed pro\u2011Russian fighters"},{"id":"2fe63ed3-3ec1-4910-b184-b5af8e1eb5c1","text":"OSCE national staff detained by separatist forces in eastern Ukraine (several detained in April 2014)"},{"id":"da14c251-f3e4-496c-aacf-4d16d5c0420b","text":"Four OSCE armoured vehicles torched in Donetsk (apparent arson)"},{"id":"d4af23d7-6dbe-4a13-92ea-f8860568b19c","text":"U.S. Department of Defense announced $250 million in additional security assistance for Ukraine"},{"id":"01cbf676-2b81-4b2a-825d-68b1a2870483","text":"Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained sailors"},{"id":"82baefd0-b223-41d2-a271-b477a89ee344","text":"United States confirmed delivery of Javelin anti-tank missile systems to Ukraine"},{"id":"7b26b50c-4dd1-4644-9689-84dd0433369d","text":"Sea Breeze 2019 multinational naval exercise (co-hosted by the US and Ukraine) concluded in Odesa"},{"id":"f9d77bc7-f0c8-4518-9725-14cf3100fc4d","text":"USS Ross (Arleigh Burke-class destroyer) entered the Black Sea (routine US Navy presence) in April 2019"},{"id":"5d30f3af-649e-4a09-9a10-e989577c7ade","text":"Official counts and reporting on refugees arriving in France showed large aggregate flow (roughly 30,000 reported late March 2022) but initial public summaries lacked detailed nationality/ethnicity breakdowns"},{"id":"5fee4a2d-aff8-4df9-be77-17e0c65b5b63","text":"Reports and media on opening Arctic sea routes and economic opportunities from reduced sea ice (UK Foresight/academic analyses, mid-2010s)"},{"id":"86eb9930-5dc6-40af-b50a-ba48949c7f89","text":"UNDP published \'Enhancing Mine Action Finance in Ukraine\' (feasibility study) highlighting very large costs for demining and explosive ordnance disposal (EOD) in Ukraine"},{"id":"0754569f-7dde-4001-b445-2b9905332dae","text":"U.S. Government Accountability Office (GAO) report \'Ukraine: Status and Challenges of DOD Weapon Replacement Efforts\' documented replacement costs and tracking challenges for U.S. weapons provided to Ukraine"},{"id":"6ff36566-6826-4d97-b606-43ba3e46ea05","text":"World Bank released an updated Ukraine recovery and reconstruction needs assessment estimating hundreds of billions in reconstruction costs and prompting public debate over who will pay"},{"id":"f3807869-b8a5-43c8-97e0-aefd9201fe00","text":"Large influx of Ukrainian refugees into Italy by mid\u20112022 (UNHCR reporting tens of thousands in June 2022)."},{"id":"093fa1c5-1ce1-4a27-8af8-eca7b7f8cbf7","text":"Extinction Rebellion activists blocked Rome\u2019s Grande Raccordo Anulare, leading to drivers physically removing protesters."},{"id":"ca1da258-49e6-4a70-aeb5-e78a1b90c123","text":"Rospotrebnadzor and Russian authorities banned imports of Ukrainian confectionery (including Roshen) and imposed trade restrictions in 2013\u20132014."},{"id":"ec5286c0-072f-45c5-a076-4567fa7a532a","text":"April 2015: Russian authorities seized or froze assets related to the Lipetsk Roshen factory and reported legal/administrative actions against the plant."},{"id":"4f2cdb73-7039-40b5-a2f7-b262f95f8559","text":"Fatal shooting of conservative activist Charlie Kirk at Utah Valley University"},{"id":"ae65d107-6eb7-4313-9186-f3cbb1789d11","text":"Publication of Kausar H. et al., \'Cucurbitacin B potently suppresses non-small-cell lung cancer growth\' (Cancer Letters)"},{"id":"91ccb453-5fb0-4cb4-bf34-baf2b1b34bf3","text":"Pre-war and tourist-focused references showing some Ukrainian cemeteries charge small admission or camera fees (example: Lychakiv Cemetery visitor fees noted in travel guides/reviews in 2019)"},{"id":"d652b088-92b8-43ab-9e9b-a599a32f964a","text":"Drohobych municipal regulation (pre-2022) introducing paid vehicle access for cemetery maintenance, cited by local officials when responding to the viral clip"},{"id":"528448a9-71b6-490f-bae3-1cfa996191c8","text":"WHO issues \'Tetanus vaccines: WHO position paper\' summarising tetanus epidemiology and prevention"},{"id":"2fc47767-208d-4cf4-832f-59fb3b8e97d7","text":"Peer\u2011reviewed medical review \'Tetanus\' (Farrar et al.) describes Clostridium tetani as an obligate anaerobic, spore\u2011forming bacterium and details anaerobic germination in wounds"},{"id":"5068d9e5-ee6b-4935-b62c-464f72b9018d","text":"The Tesla Science Center crowdfunded and purchased the Wardenclyffe lab site to create a museum and drew renewed attention to Tesla\'s archival material."},{"id":"7bd320e5-c8a0-4493-b871-050f0d769f51","text":"News reporting that the historic Wardenclyffe site was damaged/at risk after a major fire and related incidents."},{"id":"4e8f6b10-a2ac-44db-a4ca-fcdc8bd5de91","text":"U.S. Vaccine Court (Omnibus Autism Proceedings) issued final test-case rulings (March 10, 2010) finding insufficient evidence that vaccines cause autism"},{"id":"cef362d2-7e39-43ef-9824-cb10d85638c1","text":"U.S. CDC and FDA temporarily pause and later resume use of the Johnson & Johnson COVID\u201119 vaccine over rare blood clot reports"},{"id":"36dff2e7-9a23-442e-a3a7-16e2201e782b","text":"Public health agencies report rare myocarditis cases after mRNA COVID\u201119 vaccination and discuss benefits vs. risks"},{"id":"94535f85-af39-49e1-8579-790d85f2072c","text":"Russian Defence Ministry repeatedly publicly stated it was striking Ukraine\u2019s \u201Cmilitary\u2011industrial complex\u201D and energy infrastructure (examples across 2022\u20132024 reporting by major outlets)."},{"id":"53b4f370-ab1d-47ff-aa92-c4be63e52fc3","text":"Multiple Russian missile and aerial strikes on Chernihiv during March 2022, causing civilian casualties and damage across the city."},{"id":"8dd16a15-63da-4b55-ae8b-3840364bfdeb","text":"European Broadcasting Union (EBU) announces Kyiv as host city for Eurovision 2017"},{"id":"e6f80efe-99ad-40fc-9b5e-7b0f5d024763","text":"Jamala (Ukraine) wins the Eurovision Song Contest with the song \'1944\'"},{"id":"0dbcac4d-824a-48f8-8554-df0bd03f3ca6","text":"Ukraine publicly sought large anthracite imports (including from South Africa) amid shortages in late 2015"},{"id":"b1fcfdf2-64b0-43ec-b1ba-68b56b3335db","text":"Sharp drop in Ukrainian coal production after Donbas fighting in 2014"},{"id":"73df9d94-7df5-47d9-85fc-37c3a2162b6b","text":"Closure, flooding and damage to many Donbas mines after occupation in 2014"},{"id":"b9a38b44-ac73-4f47-83a9-657082aae0a0","text":"Publication of the NEURO-COVAX study in Vaccines (MDPI) reporting 31.2% of participants self-reported at least one neurological symptom after COVID-19 vaccination."},{"id":"91f8878d-9aaa-4359-94f3-12b9a5498f11","text":"Study design and limitations (self\u2011reported questionnaire, single\u2011center sampling, no unvaccinated comparator, and no hospitalizations/deaths recorded) were present in the paper but largely omitted in shareable summaries."},{"id":"159dcdc5-f266-45cf-a278-23a9f95d31a7","text":"KIIS telephone poll (May 13\u201318, 2022) reporting very high levels of negative attitudes toward Russia (e.g., ~82% negative among people in occupied areas)"},{"id":"4effbcdb-9e1c-41c1-a3f1-2b6024fcf64e","text":"Russian forces seized/controlled substantial parts of Kharkiv oblast in the initial invasion (late Feb\u2013early March 2022), including border towns and districts"},{"id":"ff2a10da-8e67-47af-b406-5835519d3357","text":"State-level policy changes removing mask mandates (example: Texas lifting its statewide mask mandate and reopening, March 2, 2021)"},{"id":"f12a6b76-a059-4df6-ac6e-ae2b26ccc9e6","text":"CDC guidance updating mask recommendations for fully vaccinated people (May 13, 2021)"},{"id":"540e3ead-5b5a-466f-ba8a-dcbaf8fdd5fc","text":"Turkish President Recep Tayyip Erdogan offered financial assistance to Ukraine and publicly urged protection for Crimean Tatars, reiterating Ankara\'s support for the Tatar community."},{"id":"db3aa80f-6044-4a98-bad7-82c93249331c","text":"Turkey launched Operation Euphrates Shield and backed Syrian rebel groups in northern Syria (including 2016 operations such as the capture of Jarablus)."},{"id":"cd930d5e-8e35-4acf-bfc9-8cc6042ef7d1","text":"Repeated international reports and accusations that Turkey had allowed foreign fighters to cross its border into Syria during the civil war."},{"id":"dbff6aa5-b76f-470d-8bb3-87dc3497b774","text":"Crimean Tatar World Congress held in Ankara where leaders and diaspora groups met and called for international support against Russia\'s annexation."},{"id":"92519052-196e-4492-808b-4c95581ebc32","text":"U.S. and Western sanctions were imposed on the Night Wolves and their leader (December 2014), marking the group as pro\u2011Kremlin and controversial in Western diplomatic reporting."},{"id":"13e91f18-b948-4979-90a2-5cefc638595b","text":"Earlier influential scientific framing of an Amazon \'tipping point\' (Lovejoy & Nobre / Science Advances) estimating thresholds (often cited ~40% deforestation) for large\u2011scale dieback to savanna."},{"id":"a71ac078-651a-47fb-bbf7-bfd8e459584c","text":"UN experts warn of chemical disaster and water\u2011safety risks after shelling near installations containing chlorine and other chemicals in Donetsk region"},{"id":"bd5cb87a-089b-4f5c-91da-e5d1d1eca347","text":"OSCE thematic report: \'Access to water in conflict\u2011affected areas of Donetsk and Luhansk\'"},{"id":"8225f2b8-fa81-4508-9347-72e066b4edf5","text":"ICRC: \'More than 350,000 people face acute water shortage in eastern Ukraine\' after damage to pumping stations and staff unable to remain on duty"},{"id":"25181eed-c798-4390-b9e5-2b733fe0131c","text":"Power supplies to a Donetsk filtration plant hit by shelling, leaving large areas without water"},{"id":"f84bd64e-b7d5-4b67-b03b-4712251d4a81","text":"Adoption and public debate around Ukraine\'s 2019 language law (\'On Ensuring the Functioning of Ukrainian as the State Language\')."},{"id":"749e270c-0df9-4de6-a9f0-b30fed003e8e","text":"Post\u2011invasion \'derussification\' measures and rapid renaming/removal of Russian/Soviet toponyms and monuments across Ukraine in 2022."},{"id":"2a76e34b-09d2-4203-838a-c7a7f41d1fb3","text":"U.S. Department of the Treasury designates the \'Donetsk People\'s Republic\' and \'Luhansk People\'s Republic\' in an expanded Ukraine-related sanctions package"},{"id":"920f6e67-114e-40e7-b689-2c784158a87d","text":"EU/European institutions tie sanctions policy to implementation of the Minsk agreements (2015) and list the so-called DPR/LPR in sanctions contexts"},{"id":"cf8f4415-e018-4f89-b75a-ff0806218bcf","text":"U.S. Executive Orders and related sanctions authorities (E.O. 13660 / 13661 / 13662) invoked in 2014 to address actors \'asserting governmental authority\' in parts of Ukraine"},{"id":"8ef6bdf8-6bb8-49ac-aba7-8d88ee45e8fa","text":"Pro-Russian separatist authorities in Donetsk proclaim the \'Donetsk People\'s Republic\' after seizing regional buildings (widely reported)"},{"id":"6bb0a5d1-8ecf-4b8d-a603-564da52db3ee","text":"Minsk II agreement (Feb 12, 2015) signed after talks in which leaders of the self-proclaimed Donetsk and Luhansk entities were included as signatories"},{"id":"c37dd408-ef96-42fb-aa14-f4272835891f","text":"Japan found stainless\u2011steel/foreign particles in multiple Moderna COVID\u201119 vaccine vials and recalled batches (high\u2011profile contamination incident)."},{"id":"934e714c-0c64-467c-9d29-ee93627e25cd","text":"Danish population\u2011based study reporting increased incidence of myopericarditis after Pfizer mRNA vaccination in adolescents."},{"id":"2a957629-1994-4504-bd4e-5a500088abef","text":"Publication of \'Batch-dependent safety of the BNT162b2 mRNA COVID-19 vaccine\' (Denmark) reporting heterogeneous rates of suspected adverse events between Pfizer vaccine batches."},{"id":"0640f999-82c9-4245-985b-1c046a916479","text":"U.S. court orders and publicized releases/requests for large numbers of FDA documents related to the Pfizer\u2011BioNTech vaccine."},{"id":"731ec64a-4fdb-477e-93d9-8d4ca3a8f3bd","text":"Peer\u2011reviewed drug\u2011delivery studies (e.g., polysorbate 80\u2011coated PLGA nanoparticles, PubMed ID 26407669) demonstrating that polysorbate 80 can increase blood\u2011brain barrier permeability in experimental formulations."},{"id":"f42e9730-3a71-4a1b-890b-dc79bbe5e142","text":"ASHP drug\u2011shortage / product detail page for Vitamin K notes Amphastar formulation contains polysorbate 80 and propylene glycol (clinical pharmacy resource)."},{"id":"5d211f49-cdc5-4a7c-89e2-24c4fa6e3193","text":"American College of Pediatricians (ACPeds) statement (Jan 2016) flagged concerns about HPV vaccine and possible premature ovarian failure (POF)\u2014invoked by some groups to link polysorbate 80 and infertility."},{"id":"0e4f9b6a-ce2a-40dc-91b6-b874ee651eda","text":"Kyiv suspended routine pension and social payments to residents in non-government-controlled parts of Donetsk and Luhansk in late 2014, requiring IDP registration and in-person collection in government-controlled areas."},{"id":"db797985-3f3c-4e0c-86cf-ff34d2353f0d","text":"Ukraine passed major pension-reform legislation in 2017 amid warnings from the IMF and World Bank about fiscal sustainability and pension costs."},{"id":"f9a5d31a-8263-45f1-b471-f0795fd547c4","text":"Ukraine\u2019s 2015 fiscal crisis and international bailout needs (IMF programs 2014\u20132015) created repeated reporting of severe budgetary pressure on Kyiv."},{"id":"ab3fb0e4-f741-4b2c-b3d2-bc1e0de90aaa","text":"After Russia\u2019s 2014 annexation of Crimea, Moscow moved to apply Russian pension law and budget subsidies to Crimea and began assuming responsibility for pension payments there."},{"id":"c1b698fb-9634-4b3a-9c21-2a7cbeb5b38d","text":"Visible US troop rotations and equipment deliveries to Poland (arrival of US armor and rotational forces)"},{"id":"a7315e32-6b37-48bb-bfc5-f72a2a24db1d","text":"NATO Communications and Information Agency exercise \'RAMSTEIN DUST\u2011II\' testing deployable NATO air/communications connectivity (DACCC) capabilities"},{"id":"c8179441-57a7-45a1-8f23-9c4a01396d6e","text":"NATO defence ministers approve creation of the Joint Support and Enabling Command (JSEC) in Ulm, Germany"},{"id":"db9eae80-bfc5-46f9-8c22-e744bf40dbc5","text":"Public descriptions of Ramstein Air Base as a key US/NATO European hub (US EUCOM reporting and public pages describing Ramstein\'s C4ISR/logistics role)"},{"id":"f195824e-e406-4010-8b24-ab80840f08bc","text":"Peer-reviewed reviews and renewed clinical-trial activity on high\u2011dose intravenous vitamin C in cancer (major review published 2022)"},{"id":"689326b1-b3d5-4344-9142-6513e77f8e88","text":"NCI PDQ summary on Curcumin (turmeric) and cancer published \u2014 evidence reviewed but clinical benefit unproven"},{"id":"d8bdd26f-c6d5-4c04-86db-c78c94c932de","text":"Systematic reviews and clinical reports on ketogenic diets and cancer published (e.g., systematic review assessing evidence published 2021)"},{"id":"54aba49f-e63c-4131-b8e3-5be975c2c899","text":"Public communications and study data showing waning antibody protection over months and consequent official booster recommendations (e.g., booster guidance issued September 2021)"},{"id":"b9059891-c143-4807-aba9-bde4721cb9dd","text":"Large Israeli nationwide study published on vaccine safety that reported an increased risk of myocarditis after BNT162b2 (Pfizer) vaccination but characterized the events as rare"},{"id":"2cd3f4ad-58ef-4698-a39f-3378d8ff0c5f","text":"Regulatory vaccine trial and EUA briefing documents (Pfizer/BioNTech FDA briefing) that reported transient laboratory changes including short\u2011lived lymphocyte count decreases in some participants"},{"id":"5b52b8cf-5ace-4757-ae69-7a7fe7c09434","text":"NOAA/observational reports noting rapid SST changes in the equatorial Atlantic in 2024 (reported by news agencies)"},{"id":"592787a6-94e6-48f7-b5a6-5665f686b8c9","text":"UNICEF situational reporting on widespread attacks and disruptions to water and sanitation in eastern Ukraine (June 2018 SitRep)"},{"id":"70da14db-5840-44ae-aa98-53daa8ed6bd0","text":"HotSpots H2O briefing: continued shelling damaging water infrastructure despite ceasefires (Circle of Blue, July 30, 2018)"},{"id":"b299d081-9429-4b11-8274-4a51e14cc166","text":"Severe thunderstorms and heavy rains cause flooding and high river levels (KyivPost, June 28, 2018)"},{"id":"ccebdffa-4ee6-45af-9997-498fa76ebdcc","text":"Donetsk Filtration Station shelled and operations halted, disrupting water supply"},{"id":"fb9408d6-c971-413b-9cea-2e3322ba3162","text":"Joint War Committee (insurers) placed Ukrainian and Russian waters in the Black Sea and Sea of Azov on its high\u2011risk/war-listed areas (amendment effective 15 February 2022)"},{"id":"0f2abd3b-64fd-49f3-971c-a1db3e57aff2","text":"Shipping industry appeals for safe passage for hundreds of merchant vessels and seafarers stranded in Ukrainian ports"},{"id":"2b87a490-d010-4798-81c2-a3a0ed1d0082","text":"Russian Black Sea flagship Moskva damaged and later sank after reported Ukrainian Neptune anti-ship missile strike"},{"id":"7c5374ae-854b-4158-b038-318ea55733d4","text":"UN OCHA warning of high risk of communicable\u2011disease outbreaks among internally displaced persons in Donbas (electricity/water outages, damaged health infrastructure)"},{"id":"456f56c3-aabe-494a-a25d-6540a141d9e6","text":"WHO Global Tuberculosis Report (2016) and other analyses showing Ukraine\u2019s high burden of tuberculosis and multidrug\u2011resistant TB"},{"id":"7d6bd4a6-d05d-4b18-9955-b9692cd59be3","text":"Circulating vaccine\u2011derived poliovirus outbreak confirmed in Ukraine (two paralytic cases)"},{"id":"a8e9a4dc-4d6f-418d-99ac-ea623698886a","text":"Nationwide tractor convoys and roadblocks as French farmers marched on Paris in late January 2024"},{"id":"205dcff4-c5bc-47d7-ae42-47b01da83046","text":"Farmers dumped manure and rotting produce in city centres during protests (reported in Toulouse)"},{"id":"931abfca-db8c-4718-812b-de8adb5d675e","text":"Russian Defence Ministry and Kremlin officials call Bucha scenes \\"staged provocation\\""},{"id":"a0cb6afb-ecd3-4526-bc22-bb8bfbd5027e","text":"Public statements and media coverage discussing possible measures against draft dodgers, including asset/account seizure among proposed penalties"},{"id":"2132ccf9-08cb-4938-900f-a1a294b77a36","text":"Public disinfection operations reported and photographed in Ukrainian cities (street/transport spraying, workers in hazmat suits)"},{"id":"bb028d86-d744-4c84-a61a-3a184bc6c646","text":"Ukrainian government declares nationwide quarantine (Resolution No. 211)"},{"id":"d9f3e7a5-3ac7-4ff9-b5c7-57d45587e0e6","text":"FAO follow-up report \'Tackling climate change through livestock: A global assessment\' (FAO)"},{"id":"cb829a74-e67a-471c-8f59-96b7c970d052","text":"Takeda and Moderna published an investigation report (Oct 1, 2021) into the Japan incident, concluding the particles were 316L stainless steel and describing manufacturing root causes and corrective actions."},{"id":"f2266466-c679-495d-aa32-a1547dd029f0","text":"WHO reported a multi-country monkeypox outbreak in non-endemic countries"},{"id":"5e58b411-987e-43e6-b1c4-5e9565e9bbc9","text":"U.S. president ordered review of COVID origins amid publicized, divided intelligence assessments (fuelling lab-leak narratives)"},{"id":"dccc509d-c576-4034-9361-2b1eb47591e5","text":"Ukrainian authorities built a temporary flow-control dam near Kalanchak in 2014 to restrict canal water into Crimea"},{"id":"ab3f8106-b455-47de-9e0e-3c1b0ffb094c","text":"Reports of chronic water shortages, rationing and Russian attempts to substitute supplies (desalination, reservoirs, pipelines) in Crimea"},{"id":"f0f810a4-4ff6-4c29-a46f-40740a2f111c","text":"Reports of clergy splits and competing loyalties in Crimea and eastern Ukraine as Russian forces moved in (priests aligning with Russian-backed authorities)"},{"id":"fc1eae68-c39e-41f7-8a4f-bf75fe7b9265","text":"Reports of numerous attacks, seizures or conflicts around Orthodox church buildings and clergy amid 2014 unrest"},{"id":"6fda58f9-892b-49db-a478-679621b09c8f","text":"Mejlis of the Crimean Tatar People called for a boycott of the March 2014 referendum"},{"id":"8cff213e-b552-46a4-b12e-65b8aca843fc","text":"Russian leadership publicly framed the referendum and subsequent annexation as a legitimate territorial decision (Putin\u2019s statements/speech coverage mid\u2011March 2014)"},{"id":"bafafe5d-7c33-4700-a0e8-fbe832774ef8","text":"Armed seizure of the Crimean parliament and buildings by unmarked pro\u2011Russian forces"},{"id":"94f93f21-b399-43b6-8c1a-6dc7c2680520","text":"Court battles and FOIA demands (PHMPT lawsuit) over release of Pfizer documents, and initial FDA proposals to release documents over decades (the 75\u2011year timeline headline), stoked distrust and narratives that regulators lacked underlying safety/effectiveness data."},{"id":"30ee29c0-7572-4257-944c-bfea6990238a","text":"Local activists attempted to topple the Felix Dzerzhinsky monument in Zaporizhzhia but failed (public attempt and clashes reported)."},{"id":"a949eb99-fee2-42fb-92cc-5ed10da638c8","text":"City unveiled a sculptural composition (\u2018The Steelworker and the Teacher\u2019) \u2014 a bench-like monument to the characters of the film \'Vesna na Zarechnoy Ulitse\' \u2014 on Shevchenko Boulevard in Zaporizhzhia."},{"id":"258ba6cf-e3b4-48da-aa2a-505f8615c449","text":"Wider wave of removals/topplings of Soviet-era monuments across Ukraine in 2014 (including highly publicized removals of Lenin statues earlier that year)."},{"id":"f030637b-114d-4e7f-8d7c-eeda43cd9190","text":"Local media and classifieds flagged massive accommodation and flight price spikes in Kyiv ahead of the final (rooms and short-term rentals listed at many times their usual rates)."},{"id":"e933f4d1-5305-4d96-b283-b161bb49c5d7","text":"Press report that more than 2,000 Real Madrid supporters returned tickets citing logistics and \'sky\u2011rocketing expenses\' related to attending the Kyiv final."},{"id":"c4e240db-18a0-4924-a3d5-b007ef851e0e","text":"Polish police statistics and reporting showing a rise in thefts in 2022 (reported Jan 20, 2023)"},{"id":"75b5e2b4-7f78-40b0-a89e-76e5a55f40ce","text":"Europol-coordinated EU-wide action leading to the arrest of around 130 suspected human traffickers (operation announced June/July 2022)"},{"id":"53bc33f3-da8b-439e-bb2e-1ac545b26a3d","text":"Mass exodus of civilians from Ukraine into neighbouring EU states after Russia\'s full-scale invasion (millions crossed borders beginning 24 Feb 2022)"},{"id":"d3c3e61d-d06e-4ee5-8174-28cc6ad30648","text":"Media coverage and local backlash in Poland documenting xenophobia and the spread of anti-refugee narratives, including claims that Ukrainian refugees are responsible for crime (BBC report)"},{"id":"ba9e2600-a590-4127-970b-4e2742cad854","text":"Large measles outbreak linked to a theme-park (Disneyland) that spread across multiple states (December 2014\u2013February 2015)"},{"id":"611fc9fc-abfb-489f-b812-71a34196257e","text":"PNAS study showing acellular pertussis vaccines protect against disease but may fail to prevent infection and transmission in a nonhuman primate model (often cited 2014)"},{"id":"62e9127a-fd2c-4286-9575-6887ef9060fa","text":"Independent assessments of donor assistance (2018) noting limited impact of some programmes"},{"id":"18cefcf3-97f2-452a-a1b1-b8e4c67b206f","text":"Lithuania presents a high\u2011profile \'Marshall Plan for Ukraine\' proposal"},{"id":"481d2f1a-071d-4f18-934e-8f3340af485e","text":"European Court of Auditors special report: \'EU assistance to Ukraine\' finds results \'fragile\'"},{"id":"253a86f7-a466-4e40-9e0f-eedd68395199","text":"U.S. President ordered the U.S. intelligence community to further investigate the origins of COVID\u201119 and report findings (public announcement of an intelligence review)"},{"id":"8e764b53-09e5-435a-b7e0-d11593a27175","text":"Media reports (citing U.S. intelligence) that three Wuhan Institute of Virology researchers sought hospital care in November 2019"},{"id":"ce7c040d-9c54-4fb8-a121-f8cbd3b50719","text":"WHO-convened Global Study of Origins of SARS\u2011CoV\u20112: China Part report released, offering assessments of possible origin hypotheses but noting limited access to raw data and calling for further study"},{"id":"483c9e14-f9bc-41de-aa9d-b4464edf1721","text":"European Union Advisory Mission (EUAM) begins operations in Kyiv to advise on civilian security-sector reform"},{"id":"c49b0cf9-c099-42be-a7d5-d56311c0726b","text":"Launch of new Kyiv patrol police (major public-facing police reform supported by international partners)"},{"id":"091f83e3-bba0-4e4a-bfca-8d8aa10aafa8","text":"U.S. announces a $200 million security assistance package for Ukraine (release reported July 20, 2018)"},{"id":"7b5c612b-1d79-44c2-8593-f25282ac9b20","text":"Canada launches Operation UNIFIER \u2014 Canadian Armed Forces training mission for Ukrainian personnel"},{"id":"91047411-6884-495a-b270-1c812c9a5302","text":"Peer\u2011reviewed review article (CMAJ) summarising mechanisms and multiple case reports showing grapefruit (furanocoumarins) can irreversibly inhibit intestinal CYP3A4 and cause dangerous increases in blood levels of many drugs (including some CNS agents)."},{"id":"59724a0a-a7ec-49be-a9c7-5332610aa537","text":"Case report published describing a presentation mimicking quetiapine (an antipsychotic) overdose linked to grapefruit juice consumption (\'Grapefruit Juice Cleanse Mimicking Quetiapine Overdose\', J Clin Psychopharmacol)."},{"id":"a14530b8-0fc3-49af-a1c6-562df417f2f7","text":"Existence and public use of the Mapuche (Wenufoye) flag in Chilean demonstrations"},{"id":"dab32f1e-f3ae-4d6e-bf38-c9ee4ac23cbb","text":"Large Euromaidan demonstrations in Kyiv with widespread display of Ukrainian blue-and-yellow flags"},{"id":"b23bc7bc-98f0-4012-b0f6-192ac391443e","text":"IPCC Fifth Assessment Report (AR5) discussion of a temporary slowdown (\'hiatus\') in surface warming (1998\u20132012)"},{"id":"9efbffa2-9434-46b3-9ebb-519b727679f8","text":"Publication and promotion of Lindzen & Choi\'s low climate\u2011sensitivity analysis (2011)"},{"id":"aa902029-1061-4cbe-9f1d-9be774e8fc3b","text":"IPCC Fifth Assessment Report (AR5) publication stating with high confidence that recent warming is caused by human activities"},{"id":"f7b613a9-3314-4b9d-bffb-61b6124d76de","text":"WHO interim guidance on mask use early in the pandemic (initial cautious messaging)"},{"id":"0e002bec-5fe4-4d7b-9e0e-353142b25b67","text":"CDC recommendation that the public wear cloth face coverings (press guidance)"},{"id":"20496504-fba2-4e08-90ea-6babbc089958","text":"Russia launched one of the largest waves of missile and drone strikes across Ukraine on 29 December 2023, hitting cities and critical infrastructure"},{"id":"876a5840-d36d-4596-9666-20f3ceda7779","text":"Estonian Defence Forces Intelligence Centre head Col. Ants Kiviselg gave a press briefing describing intensified Russian missile/drone waves, saturation tactics and damage to Ukrainian infrastructure (remarks later taken out of context)"},{"id":"e2622e7f-1580-44d4-8057-8538c9966ca1","text":"Publication of Rasool & Schneider (Science) 1971 paper on aerosols and cooling"},{"id":"c8939582-76cc-4531-8547-139a15ded32e","text":"FTC warned hundreds of marketers (April 2023) about potential civil penalties for unsubstantiated health claims, including for CBD products."},{"id":"3357401c-35a7-476f-876d-c29a22cabc32","text":"Meta\u2011analysis showing PTSD is associated with increased risk of later dementia (British Journal of Psychiatry, 2020)"},{"id":"13aac186-d0ed-4535-a881-a5a4bdb87364","text":"FDA enacted rule and labeling requirements to limit aluminum contamination in parenteral nutrition products (Final rule enacted July 2004)."},{"id":"eef92b74-64d9-4527-9f75-e23c22ad00fa","text":"Published research documenting parental refusal and hesitancy specifically around the hepatitis B birth dose (study investigating reasons parents decline newborn HepB immunisation)."},{"id":"92b0013d-9c76-4791-ab68-c99ebaca5af7","text":"Publication of Mitkus et al., \'Updated aluminum pharmacokinetics following infant exposures through diet and vaccination\' (Vaccine, 2011)."},{"id":"78685855-268d-4cac-9e6c-75f169f87513","text":"PNAS paper documenting very slow and variable human liver dihydrofolate reductase (DHFR) activity (Bailey & Ayling, 2009)"},{"id":"1b08795f-959a-412e-8533-9faf731604db","text":"Report/analysis identifying threshold folic acid doses above which unmetabolized folic acid appears in serum (Sweeney et al., BMC Public Health)"},{"id":"c7744804-cada-43bd-b31f-a98632fd26fd","text":"Reports from China and international press noting use or trials of high\u2011dose vitamin C in Chinese hospitals"},{"id":"9f157653-aafb-41ef-9fc9-da58bf871755","text":"Surge in consumer demand and sales for immune\u2011support supplements (vitamin C and D) during March 2020"},{"id":"ee9c48df-0509-454e-a426-03f65a311a72","text":"Svyatoslav Vakarchuk\u2019s public record of outspoken political commentary and criticism of Ukraine\u2019s political class"},{"id":"17f927ab-9b78-43ff-8cd2-151101d87067","text":"Kerch Strait incident: Russian coastguard fired on and seized three Ukrainian naval vessels attempting to transit the Kerch Strait."},{"id":"131b3f67-cd28-4304-8493-4ef0d561ddb2","text":"Ukraine introduced temporary martial law in regions bordering Russia and the Azov-Kerch water area."},{"id":"ac9e4919-d616-446a-981f-359a36e898e2","text":"Russian officials publicly accused Ukraine of deliberately provoking the Kerch incident and warned of further Ukrainian \'provocations\'."},{"id":"8e4ecb78-2cd5-4a31-831c-4bee4f699ca2","text":"In vitro study examining activated charcoal and GHB adsorption (toxicology literature)"},{"id":"a84eaee9-201f-4d8d-b27b-768be7e814c1","text":"Peer\u2011reviewed publication demonstrating intranasal/intratracheal delivery of mRNA to mouse lungs using polymer nanoparticles (Sci Transl Med)."},{"id":"eb3b9426-ad3d-4fc4-83c1-c97df52a6830","text":"Hank Aaron publicly received his first dose of the Moderna COVID-19 vaccine at Morehouse School of Medicine to encourage vaccination among Black Americans."},{"id":"7daabd93-b1c9-4167-adee-62a5a406806b","text":"Hank Aaron died at age 86 (widely reported on Jan 22, 2021) a few weeks after his public vaccination."},{"id":"10d9dcb1-82e1-4045-acca-984f4a4e6b55","text":"Publication of a Phase II clinical trial showing curcumin was safe and produced biological effects in patients with advanced pancreatic cancer (Dhillon et al.)."},{"id":"616f6f68-f401-4fa0-ba4c-64cdc24121d9","text":"Rapid growth in the commercial turmeric/curcumin supplement market and aggressive product marketing by supplement companies (industry coverage 2015\u20132018)."},{"id":"aa6dd177-a776-4665-ab7b-bffc42996a33","text":"CDC report on resurgence of \'black lung\' (progressive massive fibrosis) in coal miners"},{"id":"6df8661c-1208-4a7a-b84f-dad337aa9a8a","text":"Informal agreement reached between the Maltese Presidency and the European Parliament on visa liberalisation for Ukrainians"},{"id":"38532f76-a8d3-4a92-8e5c-2b120ab21c7f","text":"Commission\'s visa\u2011liberalisation proposal specified biometric\u2011passport holders"},{"id":"cc44ee2c-d62e-4d43-aeed-cca51553bc91","text":"Statement that Ireland and the United Kingdom are not subject to the new visa regime"},{"id":"c046013e-6009-405f-89b8-ca146753bde5","text":"EU Council adopts revision of the visa\u2011waiver suspension mechanism"},{"id":"4a16ebcb-82bf-4c8d-ad7e-466d21217073","text":"France\'s health authority (HAS) recommends a single COVID-19 vaccine dose for people previously infected"},{"id":"0b4bccd2-1a09-4415-8393-a00d8b01963f","text":"NEJM research letter (Krammer et al.) showing rapid, high antibody responses in seropositive persons after a single mRNA vaccine dose"},{"id":"e4c84464-0a89-4baf-b942-1308b3b32900","text":"U.S. FDA revokes the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID-19."},{"id":"74c4307b-5e3b-4b5c-b655-6114d055f24f","text":"WHO temporarily halts the hydroxychloroquine arm of the Solidarity Trial over safety concerns."},{"id":"1db17dca-a60a-4963-ac75-6614e7621bf0","text":"Russian presidential decree fast-tracking Russian citizenship for Ukrainians"},{"id":"81ab6954-cd5d-4243-bfa3-685098227060","text":"Installation of Russian-backed local administrations and visible propaganda campaigns in occupied cities (e.g., Kherson)"},{"id":"2687e56a-7e91-4a01-b7b0-a9f5e4f13ff1","text":"Widespread passport issuance (\u2018passportization\u2019) in occupied Ukrainian cities"},{"id":"5cd35820-333e-448b-96e2-788eb0f2bb91","text":"Pre-war and wartime local public-opinion surveys showing mixed but non-negligible support for closer ties with Russia in parts of Donbas"},{"id":"478e87c3-687c-4384-9639-d343f99a2cde","text":"Prior public reporting and regulatory actions in 2021 about rare blood-clotting events with some COVID-19 vaccines (e.g., Johnson & Johnson/AstraZeneca) established a persistent vaccine\u2013blood clot association in public discourse."},{"id":"eb0e4b07-531d-4804-9b48-c48258c4b257","text":"Government statement ending the legal duty to self-isolate in England as part of the \'Living with COVID\' approach"},{"id":"55ed0ca1-fb2b-41c2-b3cb-33ec62c3e4e9","text":"Great Barrington Declaration (October 4, 2020) advocating \'focused protection\' and arguing against ongoing mass interventions"},{"id":"5f68ea44-90f4-4964-bd73-81d69fe6d6a6","text":"Publication and circulation of official guidance clarifying limitations of PCR cycle threshold (Ct) values (explaining PCR can detect non-infectious viral fragments)"},{"id":"84e4c275-2cb8-4157-8584-96786b1e11be","text":"NOAA AOML study documents an unusually rapid cooling phase in the equatorial Atlantic following record-warm conditions in 2024"},{"id":"6547f701-a4f0-411c-97d2-1f949e69d53f","text":"Safety and technical evaluations by consumer-safety groups (Electrical Safety First and independent lab tests) showing plug-in \u2018power saver\u2019 devices do not reduce residential bills and can pose fire/shock hazards."},{"id":"63e9a4ea-23b5-4a68-9930-207afc06a78c","text":"Reports of volunteer militias forming in Ivano\u2011Frankivsk region (local volunteer militia of Prykarpattia reported by Interfax)"},{"id":"33407265-94ba-4284-9925-81dd4a2ca2bb","text":"UN/UNICEF campaign \'Children, Not Soldiers\' and international attention to child recruitment (launched March 2014)"},{"id":"7743b8b3-8dac-4152-83ce-f43c0bee9d9e","text":"Anti\u2011migrant unrest in Torre Pacheco (July 2025) that was inflamed by a misleading social\u2011media video and triggered violent reprisals and arrests."},{"id":"89248d71-ce8a-41e3-a22a-a2345dffdfd7","text":"Ongoing monitoring by EUvsDisinfo and similar fact\u2011checking bodies documenting a recurring pro\u2011Kremlin pattern of inserting \'Ukrainians\' into unrelated crimes abroad to discredit Ukrainian citizens."},{"id":"8755ba75-eaca-4e19-8dea-ce787a5efa22","text":"Spanish National Police arrested seven people suspected of stealing more than 1,100 chairs from restaurants and bars in Madrid and Talavera de la Reina."},{"id":"e575aa8e-464e-489b-a664-70ab7a7cb07b","text":"Reuters special report documenting separatists\' access to grenades and grenade launchers in Luhansk/Donbas"},{"id":"fac83173-c379-427e-9657-21a1713d394c","text":"Visual evidence of tanks displayed in Luhansk public spaces and on-the-ground photos around early July 2014 (T-34\u201185 in Luhansk report)"},{"id":"fcedaa29-9c12-4801-a93f-2d25b4768c4a","text":"Odesa deadly clashes (May 2, 2014) with dozens killed and widely circulated graphic images"},{"id":"c89ccfae-db15-4f80-8115-7a03e8dcad52","text":"European Court of Human Rights ruled her pre-trial detention was arbitrary/unlawful (June 2013)"},{"id":"2de0391a-c6d2-4cd6-b820-9d688b482963","text":"Tymoshenko released from prison during the Euromaidan upheaval (22 February 2014)"},{"id":"8f534fd9-f814-4641-87a9-04a1426c7613","text":"Massive oil depot fire/explosion began near Vasylkiv (outside Kyiv) on June 8, 2015"},{"id":"07d2b96c-e7dd-497a-813c-527a2060559d","text":"Reports of renewed outbreaks/explosions at the depot after partial containment (June 11, 2015)"},{"id":"b4a2e5f1-2540-46d3-81e4-e2e544763ab8","text":"State-level legalization and commercialization expansion (New York signs Marijuana Regulation and Taxation Act)"},{"id":"98b2aff6-bca3-44a3-ba54-b68ffbd832d6","text":"National Academies report: The Health Effects of Cannabis and Cannabinoids (comprehensive evidence review)"},{"id":"151711bb-8755-4a67-aa98-e1adeb5c92d1","text":"FDA approves Epidiolex (cannabidiol) for treatment of specific severe epilepsy syndromes"},{"id":"42258c5f-d0e7-485b-885e-3e3bfdc304ed","text":"Japan suspension of multiple Moderna vaccine batches after discovery of foreign/metal particles (September 2021)."},{"id":"a91f3488-dbae-4651-a7a1-71416fa1d8ae","text":"Publication of Lund University in vitro study reporting reverse transcription of Pfizer-BioNTech mRNA in human liver cell line (Huh7)."},{"id":"e95e2c86-5cf5-4e2f-bfd1-8ab731e857eb","text":"2014 Simferopol incidents and defections of Ukrainian officers during Russia\'s annexation of Crimea."},{"id":"f73f876c-af9b-44f5-a348-0937fa930305","text":"U.S. delivery of Javelin anti-tank missiles and launchers to Ukraine"},{"id":"360a8c46-e6d8-492e-bde7-3bdf7f02b104","text":"Statements and claims from Russian officials and state media accusing Western-supplied arms to Ukraine of being diverted or becoming a broader security threat"},{"id":"ded85493-80e4-4f5b-a532-744960395d4d","text":"IARC (WHO) evaluation and monograph work classifying formaldehyde as carcinogenic to humans (Group 1)"},{"id":"7839b325-4a85-43da-856c-b57c97205728","text":"American Academy of Pediatrics and U.S. Public Health Service joint statement recommending reduction/removal of thimerosal from infant vaccines"},{"id":"dc57462e-f58d-4301-8a18-8ecc5bebc69b","text":"ACIP / CDC guidance and publications clarifying influenza vaccination in persons with egg allergy (making ovalbumin/egg protein salient)"},{"id":"cdd0c405-98b0-49db-8ea9-8ac94256b27a","text":"Pfizer and BioNTech began their large Phase 3 COVID\u201119 vaccine trial and publicly stated trial enrollment had started."},{"id":"f944ae1d-075d-498b-a803-1f145d06cde3","text":"Reports of children killed or injured in Kharkiv region shelling (multiple local reports and rights groups)"},{"id":"2e57aac3-7da7-4f92-88ab-1a2534a142cc","text":"Prior high\u2011profile vaccine safety scares (e.g., Japan\u2019s temporary suspension/recall of some Moderna batches after finding foreign particles)"},{"id":"6da8b312-412e-41b5-97c2-320220ed5504","text":"Public availability of population\u2011level mortality datasets (World Mortality Dataset / Our World in Data) used by the authors to compute excess deaths"},{"id":"3e0cb12c-8fa8-4bc3-bd34-b35b74430180","text":"Publication of large peer\u2011reviewed estimates of lives saved by COVID\u201119 vaccination (Lancet study, June 2022)"},{"id":"1d902c0e-3b2f-4211-b144-2c47a1918793","text":"Protests and roadblocks in multiple towns as gas-dispute left houses without heating"},{"id":"95fbc391-139d-4b74-bab7-54c98c57a2bb","text":"Large-scale winter protests on Maidan (Euromaidan) in cold conditions, Nov 2013\u2013Feb 2014"},{"id":"fe81f0df-bad3-45f2-9a1f-c50df83a836d","text":"Local Kyiv residents block a street to demand restoration of heating after prolonged outages"},{"id":"50e1baad-2edc-4b4e-b3ed-7433803a9740","text":"National gas-price increase announced and implemented, triggering utility cutoffs for non\u2011paying customers"},{"id":"80eab4aa-e080-4ddb-a409-7928e2405d96","text":"U.S. delivery/confirmation of Javelin anti-tank missiles to Ukraine"},{"id":"c1efc833-9789-4e82-b10f-013ba81a9a7c","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels"},{"id":"f7820ae8-03eb-4cdb-a315-b5574a7284d1","text":"Ukraine lawmakers approve a significantly increased defence budget for 2020"},{"id":"7907f512-3891-422c-b167-7a2ec07a79e3","text":"Large multinational Sea Breeze 2019 naval and amphibious exercises in the Black Sea near Ukraine and Crimea"},{"id":"cfa63295-1a34-4cdb-8201-fc3619deef3b","text":"CDC and FDA acknowledged increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination and reviewed the evidence (June 2021 ACIP/MMWR updates)"},{"id":"b1f1eb74-be8d-45bb-b878-aeb4451b3315","text":"U.S. CDC and FDA recommended a temporary pause on the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare clotting events (April 2021)"},{"id":"eb7cf401-50cb-4091-952e-3b6afb69fbfc","text":"Norwegian Medicines Agency investigation into 23 deaths of very frail elderly people after Pfizer/BioNTech vaccination (investigation reported publicly)"},{"id":"f1b90ad2-9e41-47ed-b4e8-1c3eaa4a8111","text":"European Medicines Agency (EMA) finds a possible link between the AstraZeneca COVID-19 vaccine and very rare blood clots with low platelets"},{"id":"b8afc355-0d3b-4b78-8e52-f51a350d83ea","text":"Reporting on targeted Russian disinformation campaigns aimed at Poland\u2013Ukraine relations (contextual, enabling environment)"},{"id":"126eae67-4a76-4364-a533-375bb10f6c72","text":"Publication of Rabbit Hole interview with Sergiy Nikolaychuk (Deputy Governor, National Bank of Ukraine)"},{"id":"cc4501fc-11d1-4e7b-8e44-ddd88a405d9b","text":"FAO releases \'Pathways towards lower livestock emissions\' at COP28 (FAO report on livestock methane and mitigation)"},{"id":"11d3f25f-6719-4690-b5d7-c65950aaecf4","text":"Publication and industry publicity for papers endorsing GWP* as a better metric for methane (coverage by AHDB and others)"},{"id":"b9fee561-458c-4021-a790-653c39480351","text":"IPCC Special Report on Global Warming of 1.5\xb0C (2018) \u2014 discussion of polar amplification and regional differences"},{"id":"6849dfaf-8ca2-4b18-b601-9eef2c9e238c","text":"SCAR (Scientific Committee on Antarctic Research) report: \'Antarctic Climate Change and the Environment\' \u2014 2019 update"},{"id":"a6160e6c-5484-40f4-9600-e21d9ac905d1","text":"Crimea\'s supreme court banned the Mejlis (the representative body of the Crimean Tatar people), declaring it an \'extremist\' organization."},{"id":"05ddcda8-e6d3-43d8-a4ce-1356f99b3ed6","text":"Prominent Crimean Tatar leaders (e.g., Mustafa Dzhemilev) gave repeated public statements and interviews emphasizing that Crimea is the historical homeland of Crimean Tatars and calling for protection of their rights and autonomy within Ukraine."},{"id":"fccab78a-fa33-4db4-bb24-62e5e2a113ae","text":"Large Crimean Tatar-led protest in Simferopol (Day of Resistance), where thousands marched on 26 February 2014 opposing annexation and asserting Crimean Tatar identity and rights."},{"id":"7966b150-ab5e-430d-8dd8-0b6cc2a52590","text":"ATR, the only mainstream Crimean Tatar\u2013language TV channel operating in Crimea, was denied a Russian broadcasting licence and forced off the air in the occupied peninsula."},{"id":"9b43e23d-6e67-4a55-bff8-88a4dd7e0222","text":"Soviet-era mass renaming of Crimean toponyms (large-scale replacement of Crimean Tatar place names with Russian names, principally 1944\u20131949)."},{"id":"e4e9833d-2b95-431e-bd45-33d54b1159b5","text":"The IAEA publicly condemned shelling near the Zaporizhzhia plant and warned the situation was dangerous (IAEA statements in early August 2022)."},{"id":"4fd5cba6-5ef8-4f7e-88a7-cc0e21801f03","text":"Russian forces seized control of the Zaporizhzhia Nuclear Power Plant during initial invasion operations."},{"id":"b3905ba9-04c9-4087-abe7-fae021d91781","text":"CDC publishes MMWR report (Risk Factors for Severe COVID-19 Outcomes) showing that among vaccinated persons who died after completing a primary vaccination series, 77.8% of those deaths had four or more risk factors."},{"id":"85c23183-95b6-47bf-8162-cf1d77e20f54","text":"Repeated regulatory actions (2014\u20132016) by Ukraine\'s media regulator removed or blocked numerous Russian channels and programming from Ukrainian airwaves."},{"id":"12db9005-ba29-49f1-9b27-a3b203a2b06b","text":"Heavy shelling and bombardment in Donetsk during fighting in late 2014 damaged infrastructure, disrupting TV transmissions and showing visibly destroyed broadcast facilities."},{"id":"9aacb493-235e-4c62-985a-961ed8ee8fa6","text":"2021 Ukrainian government sanctions that removed three pro\u2011Russian TV channels (112 Ukrayina, NewsOne, ZIK) from broadcast."},{"id":"728c3997-6622-4111-a278-d680c1b50c96","text":"Long\u2011running Russian state and proxy narratives alleging systemic persecution of Russian\u2011speakers in Ukraine (used as framing and justification since 2022)."},{"id":"cf7b861a-ab3c-4a9b-ac59-549ac3ef0af0","text":"Context of real international humanitarian assistance to Ukraine in 2015 (EU/Austria aid packages) \u2014 e.g., European Commission announced additional humanitarian assistance in January 2015."},{"id":"2e9ef9b7-a1a4-47f6-8450-0d4d53b6a973","text":"The stories invoked an historical Austro-Hungarian practice (dating to 1774) of paying soldiers stationed in Bukovina to compensate for climatic conditions."},{"id":"25771af9-52d2-4703-abce-50f51dd79499","text":"High public awareness of large solar PV penetration in Spain (record generation in 2024)"},{"id":"81d8088a-9576-4107-a172-0b313558170f","text":"Dutch-led teams recovered wreckage and human remains from rebel-held areas with local actors cutting and loading debris (reported removal of \'crucial debris\')"},{"id":"81609bf2-06aa-4215-b85e-1172352ab4fd","text":"OSCE and investigators documented limited access, delays, and chaotic control of the crash site by armed groups"},{"id":"dfbf618b-e02f-4074-9549-2e0686b74d34","text":"1994 discovery and publication identifying Kaposi\u2019s sarcoma\u2011associated herpesvirus (KSHV/HHV\u20118) as the viral agent linked to Kaposi\u2019s sarcoma"},{"id":"b6eee547-04e8-421c-8bf4-f939c1f700e5","text":"Publication and media coverage of a 2017 MACS cohort analysis reporting links between heavy popper use and some virus\u2011associated cancers in older HIV\u2011negative MSM"},{"id":"b1f6871b-fb0b-4b53-b754-feb19895b71c","text":"UNICEF press release and mapping (July 13, 2022) on protection and care of unaccompanied and separated children fleeing Ukraine, highlighting legal complexity and cross\u2011border guardianship issues."},{"id":"a5ab1168-82e2-40e1-88e4-2739fd94022a","text":"High\u2011profile \'Jugendamt\' child\u2011removal case (Ariha Shah): German youth welfare authorities removed an infant from her Indian parents in Berlin (reported September 2021)."},{"id":"d520bc36-9485-48c7-bb02-b172d8979bac","text":"Furdui family case (April 26, 2021): Seven children of the Furdui family were taken into custody by a German Jugendamt office, generating international coverage and long\u2011running dispute."},{"id":"fbcc72f3-a1bb-4fc5-9188-1f0d06b36c2c","text":"Publication of peer\u2011reviewed study reporting enlarged external occipital protuberances (EEOP) in young adults"},{"id":"703963f3-6fe9-4ee6-ac11-bd823769cfbf","text":"StatPearls / NCBI review and guidance summarising when activated charcoal is indicated for poisoning (clinical toxicology guidance update)"},{"id":"176f09da-4858-4cf5-b55e-bb3752716f63","text":"Major news coverage of charcoal consumer products (BBC story noting popularity and celebrity effect for charcoal toothpastes/products)"},{"id":"60b361fd-2a30-437f-b677-cc825abd8fc8","text":"WHO interim guidance on mask use in the context of COVID\u201119 (update)"},{"id":"46cbfd54-f8ad-4e6e-b27e-b823d716a47a","text":"Publication of van Doremalen et al. laboratory study on aerosol and surface stability of SARS\u2011CoV\u20112"},{"id":"2706d054-122f-4a83-94d3-c9b19038c3df","text":"Open letter and media coverage by scientists arguing for recognition of airborne transmission (239 scientists)"},{"id":"36946f31-0798-432a-b6f5-53f99b080734","text":"FDA emergency use authorization of the Pfizer\u2011BioNTech COVID\u201119 vaccine for children 5\u201311, sparking public debate about pediatric vaccination schedules"},{"id":"a09ffa5c-ddba-4c36-9336-1e74696e9105","text":"Peer\u2011reviewed immunology review concluding there is no evidence that recommended vaccines \'overload\' or weaken infants\' immune systems (literature on \'antigenic overload\')"},{"id":"6ea5a1bb-1fe2-4405-8e70-ca7cb8012135","text":"U.S. officials publicly rejected or expressed serious concerns about Poland\'s proposal to transfer MiG-29s via a U.S. base, citing escalation and alliance complications."},{"id":"35802410-2120-432e-a966-e73755191cc3","text":"Polish government and analysts documented and warned about sustained Russian disinformation campaigns targeting Poland after the start of the war in Ukraine."},{"id":"0bb21a62-d4f7-459a-b582-17d7077bec94","text":"Open-source documentation (Oryx) and media reports catalogued numerous photographed and video-documented losses of Ukrainian equipment (including Western-supplied systems) during 2022."},{"id":"147fbe63-1b55-4169-9c46-c0e320e92d21","text":"30 November 2018: Ukraine announced a ban on entry for Russian men of military age (reported by multiple outlets)."},{"id":"31c21d42-48d3-4ff9-a7b1-3b2da97242bc","text":"June 2019: Russian president Vladimir Putin signed a decree simplifying the procedure for residents of Donetsk and Luhansk to obtain Russian passports (accelerated \'passportisation\')."},{"id":"f863d674-bb62-45b0-88aa-140c964047c2","text":"August 2014: Large-scale displacement from Donbas with thousands crossing into Russia during the summer 2014 fighting."},{"id":"a8650c12-bd32-446f-97a6-67fe735cb4f2","text":"U.S. government purchase agreement announced earlier in July 2020 (Pfizer/BioNTech $1.95B deal for 100 million doses) linking Pfizer to federal vaccine procurement."},{"id":"3e164c73-1d27-4225-a4cf-4558189223bd","text":"Pfizer and BioNTech press release announcing their vaccine candidate was >90% effective in interim Phase 3 analysis"},{"id":"c3994da9-9d30-4cf2-8bd2-c4fae3919464","text":"Reporting on Pfizer\'s funding sources and relationship to Operation Warp Speed that highlighted nuance (e.g., Fortune/other Nov 9, 2020 pieces saying Pfizer did not take OWS R&D funding but had U.S. supply deals)."},{"id":"44257917-be31-4c40-860c-9253f4dfe5f6","text":"Ukrainian Central Election Commission (CEC) formally listed electoral districts and polling stations in Donetsk and Luhansk where voting would not be organized for the 2019 presidential election."},{"id":"a86c33ef-0961-4a4b-b386-c0afb307ca26","text":"Historical precedent of electoral disruption in eastern Ukraine (2014): pro-Russian militants previously occupied or disrupted polling stations and seized ballot materials in Donetsk and Luhansk during earlier elections."},{"id":"ea7fa834-93eb-417d-8c19-1a32fa6fc323","text":"Pro\u2011Russian protesters seized regional government buildings in eastern Ukraine"},{"id":"c4be31f8-b067-4d84-a740-33099a4ad1ad","text":"Delivery of a $2 billion Russian credit to Ukraine was delayed"},{"id":"502d2682-d775-4d0c-a054-5cc48fbc722e","text":"Unmarked (Russian) troops and seizures in Crimea disrupted Ukrainian military units"},{"id":"b5d04b72-b082-4875-ac37-416d3e8ab195","text":"Interim Ukrainian government formation delayed, creating administrative uncertainty"},{"id":"b08c2c0c-4d30-480a-b095-f8bf6fdc0d4c","text":"Ukraine\'s currency (hryvnia) plunged after central bank policy change"},{"id":"ec6202e2-c5da-4ca9-9c80-19a8c4f5df38","text":"U.S. COVID-19 vaccine reporting rules tied to Emergency Use Authorization: healthcare providers were required to report all serious adverse events and certain other events to VAERS (policy in effect since the COVID EUA rollout, December 2020 onwards)."},{"id":"7c07149e-0c8b-4886-a2b3-c830e7e08b9f","text":"Public availability of raw VAERS datasets and third-party dashboards (VAERS data downloadable and publicly accessible since the system\'s creation)."},{"id":"60d11947-1ee3-4a64-9896-45b120df033a","text":"Japan\'s Ministry of Health, Labour and Welfare approved ARCT-154, the first commercial self-amplifying (saRNA) COVID-19 vaccine (CSL/Arcturus)."},{"id":"e163903f-04ee-4409-9f45-b8aa604b3413","text":"Japan paused and recalled some Moderna COVID-19 vaccine lots after discovery of foreign (stainless-steel/black) particles in vials at vaccination sites (investigation and voluntary recall reported)."},{"id":"0455a97a-fd77-40f2-a5a7-e14f0b27c5c2","text":"UN Human Rights Monitoring Mission report noting an inflow/presence of \\"foreign fighters\\" in eastern Ukraine"},{"id":"3fd36b82-7c7e-4ee7-b8a7-e201b53263c4","text":"Death of Isa Munayev, commander of the Dzhokhar Dudayev (Chechen) battalion fighting for Ukraine (killed near Debaltseve)"},{"id":"3550264d-3a3a-4421-9827-eeef6d8bed16","text":"New York Times article: \\"Islamic Battalions, Stocked With Chechens, Aid Ukraine in War With Rebels\\""},{"id":"9af8c9fd-d1ba-4776-b745-76d6c56d08fc","text":"CBC News coverage (Apr 2012) of University of Windsor research and a $157K grant for \'cancer\u2011killing dandelion tea\'"},{"id":"271671d9-d9f0-4701-acb9-ebf12b3d4d51","text":"2012 PLOS ONE study showing dandelion root extract induces apoptosis in leukemia (CMML) cell lines"},{"id":"e3dceb77-f7bd-460f-9054-fcbbc021f866","text":"Research on cognitive impairments in chronic tinnitus patients (e.g., \'The characteristics of cognitive impairment in subjective chronic tinnitus\', PubMed 29541537, 2018)"},{"id":"6249d787-d536-4b0e-bfbb-86aa83694f66","text":"Lancet Commission report \'Dementia prevention, intervention, and care\' identifies hearing loss as a major modifiable dementia risk factor"},{"id":"fb63438f-dc9c-4e56-be6b-4dd7cf6837fb","text":"Local reporting documented a sharp rise in COVID-19 hospitalizations in Jacksonville and UF Health Jacksonville reported 175 hospitalized with COVID-19 (July 26, 2021)."},{"id":"b1b37881-0460-450f-9656-568a14bbc224","text":"Public Health England / UKHSA technical briefings (mid-2021) showing many COVID cases and deaths among vaccinated older adults that were widely shared without age\u2011adjustment context"},{"id":"11364990-cd4e-4992-824e-ea8bff3d869b","text":"Large case surges in highly vaccinated countries (example: Israel, summer 2021) that circulated widely on social media suggesting temporal link between vaccination campaigns and rising infections"},{"id":"9cf74e25-9924-4266-bdda-c3b792219632","text":"Early Omicron reporting (Dec 2021) showing large reduction in vaccine protection against infection"},{"id":"75f0b194-74a7-49de-858f-7ef0259e6771","text":"2019 CDC shutdown of biosafety operations at Fort Detrick (US Army medical research lab) after safety inspection"},{"id":"53f866a2-6e47-48b6-9ce5-afdce3518b0d","text":"President Biden orders U.S. intelligence agencies to \'redouble\' investigation into COVID-19 origins"},{"id":"7579cb22-cd0f-4ca0-96cf-f1896ed7914f","text":"Reports that California lawmakers planned to introduce legislation to end personal-belief vaccine exemptions in response to the outbreak."},{"id":"c7be7841-96cf-4b23-9c1c-46477853c367","text":"CDC Health Alert Network (HAN) advisory announcing a U.S. multi-state measles outbreak linked to Disneyland theme parks."},{"id":"0d7a1eb6-374d-42c5-a792-5330c955b1e5","text":"US Operation Atlantic Resolve deployed rotational armored units (tanks/Bradleys) into Eastern Europe (to reassure NATO)"},{"id":"6f02c190-25e0-4fce-a84e-81944124ad81","text":"OSCE SMM reported observing unmarked convoys and multiple tanks operating in Donetsk/Donbas territory"},{"id":"b8661f52-58e5-4305-87f5-ca659edf9304","text":"Reporting of foreign volunteers and irregular fighters in Donbas (documented by major outlets)"},{"id":"b07caca7-03ba-4311-a1d1-a85a8814fca4","text":"Russian and pro\u2011Kremlin media/public figures repeatedly alleged Western/NATO involvement (including claims of NATO personnel/equipment in Ukraine)"},{"id":"40a75594-3952-4884-a0d6-443085589381","text":"The MV Rhosus delivered and was detained with 2,750 tonnes of ammonium nitrate in Beirut after an unscheduled stop."},{"id":"84387a4d-e511-45af-a35a-ed52ac000f82","text":"Viral videos show Italians performing coordinated gestures (singing/dancing) on balconies during lockdown (mid\u2011March 2020)"},{"id":"ef847f2b-0c64-4ca5-ad89-cda8af0b35cd","text":"IEA publishes \'Electricity Grids and Secure Energy Transitions\' calling for major transmission build-out and doubling of power-system flexibility needs to 2030."},{"id":"90e5876a-ce2f-4e79-86e4-791b5196ea9d","text":"European Commission publishes the EU Offshore Renewable Energy Strategy recommending cross-border planning and consideration of a more \'meshed\' offshore grid and hybrid projects."},{"id":"5ef29add-5e93-442f-b2d9-1b0ae2ad3aff","text":"U.S. DOE publishes \'Microgrid Overview\' fact sheet describing microgrids as entities that can operate grid-connected or in island (isolated) mode."},{"id":"180cc7a3-c694-4485-a9ce-4c90d0ce1988","text":"NREL publishes a \'Research Roadmap on Grid\u2011Forming Inverters\' and related analyses explaining that high shares of inverter\u2011based resources require new inverter controls and grid\u2011forming capabilities for stability."},{"id":"f1df6fcd-82a8-4f29-862b-b17d197720dd","text":"TenneT proposes a 6-GW North Sea \'hub\' / wind power booster and publishes plans toward a meshed offshore transmission approach."},{"id":"b24bad6a-9fd6-4823-8d2b-0d5fea798256","text":"Russian authorities repeatedly detained Ukrainian civilian fishermen and ships in the Sea of Azov (reported detentions of Ukrainian fishing crews)."},{"id":"4e4e81da-6501-4c86-a385-5525a45585fa","text":"Russian troops and pro\u2011Russian forces seized multiple Ukrainian navy vessels and naval bases during the 2014 Crimea annexation (including the capture of three Ukrainian warships)."},{"id":"32edd82e-0217-4813-bec8-1a1dce864bf3","text":"Advisory Referendum Act (Wet raadgevend referendum) had recently entered into force (1 July 2015) enabling citizen-initiated national referendums"},{"id":"53a61ac2-5f7b-41dd-bb0e-e5a7d2c4c0db","text":"Prime Minister Mark Rutte calls the referendum \'disastrous\' and says he is \'totally, totally, totally against referendums\'"},{"id":"00d72ee4-c25c-4509-ab7e-63cb9ee79800","text":"Large, highly visible arrival of Ukrainian refugees into Italy in March\u2013April 2022 (Italian draft plan to take up to 175,000 and steadily rising refugee numbers reported)."},{"id":"16d5f277-e1c8-4439-a591-3bfea8c06823","text":"March 2017: The World Meteorological Organization added asperitas as a recognized cloud feature in the updated International Cloud Atlas."},{"id":"5eb4a6c0-107d-4b2f-a23d-dee9a04242cb","text":"Longstanding practice of sending Ukrainian spent nuclear fuel to Russia for reprocessing (and return of reprocessing waste)"},{"id":"4f97be6d-c6d5-4fd2-8649-0bdd2f1fb2e0","text":"Holtec (project contractor) published confirmatory functional testing of ISF\u20112 interim spent fuel storage at Chernobyl (technical milestone)"},{"id":"956b3170-294c-47bc-849e-3345201fda22","text":"Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers"},{"id":"fc4649f8-8e16-4c02-aece-aedcfdeef725","text":"NOAA/NCEI global climate reporting for 2021 (annual analysis released Jan 2022) showing year-to-year variability and La Ni\xf1a-linked cooling influence"},{"id":"b7724a1f-eea6-474c-b701-2f031cf9fc56","text":"Publication of Karl et al. (2015) and the \'hiatus\' data-adjustment debate (NOAA/Science) that revised surface temperature trends"},{"id":"7207fa75-c0f2-435b-9696-7acee5f2af99","text":"CDC FluView weekly surveillance report (Week 41, data through Oct 16, 2020) showing unusually low influenza activity and low percent-positivity in respiratory specimens"},{"id":"b1622aae-b90f-470f-bfe8-51c55bed106b","text":"Adoption of Ukraine\'s \'decommunization\' laws in April 2015 and subsequent municipal actions to remove or rename Soviet-era symbols and monuments."},{"id":"c60d8400-68ef-4604-95a2-0f5b96a38f78","text":"Widespread toppling and removal of Soviet-era monuments during and after Euromaidan (2013\u20132014) \u2014 high-profile removals of Lenin statues and related coverage created a recent precedent for \'monuments being taken down\'."},{"id":"358c93bf-c503-4f8a-9709-78f3c5027f02","text":"Reports and imagery documenting heavy fighting, civilian deaths and damage in Hostomel and nearby areas during the Russian offensive (March\u2013April 2022)"},{"id":"71aa2d9f-ab06-45e7-97cf-248cb50efd98","text":"Discovery and wide circulation of video and photo evidence showing dozens of dead civilians in Bucha (near Kyiv)"},{"id":"e5037d73-ad6a-403c-8a6a-a405132eecc3","text":"Advocacy/analysis note and reports on voting rights of internally displaced persons (IDPs) in Ukraine noting ~1.4 million registered IDPs and barriers to their participation in local elections (reports circulated February 2019)."},{"id":"2290ebe9-b56d-4b7f-a27d-1990eac79898","text":"Central Election Commission (CEC) announced that presidential voting would not be organized in Crimea, Sevastopol and parts of Donetsk and Luhansk (list of districts where vote will not be held)."},{"id":"5853bc70-e5ff-4c09-ada0-041fe0401e19","text":"Guides and reporting on practical difficulties for Ukrainians voting abroad ahead of the 2019 presidential vote (limited polling stations, complex registration procedures noted in Feb 2019 coverage)."},{"id":"99b6d9fc-3cbd-43dc-b069-102f955ba2f9","text":"Poland announced it would stop new weapons transfers to Ukraine"},{"id":"d8d5b1d1-97cf-4035-b4bf-d3121364b428","text":"Poland and Ukraine entered a bitter grain-dispute diplomatic row (restrictions on Ukrainian grain)"},{"id":"c52ddb05-8e7a-4b12-a26d-91c6987d7438","text":"Hungary vetoed/blocked a major EU aid package for Ukraine at an EU summit"},{"id":"46d547f9-9df8-47c2-9248-ec0c9873a7db","text":"Diplomatic expulsions and mutual espionage accusations between Hungary and Ukraine (spy scandal)"},{"id":"5135b149-7874-4048-9faa-aa7e73afbd47","text":"December 2021 reporting and market data (SPINS / Whole Foods coverage) documenting a rapid consumer boom in adaptogen supplements (ashwagandha, reishi, etc.)."},{"id":"7075c1bb-4e96-4d35-9f62-d6e8832d3809","text":"Publication of a 2021 peer-reviewed review summarizing preclinical anti\u2011cancer activity of curcumin but concluding clinical evidence is limited."},{"id":"afdb0635-2d31-45b9-937f-b7b6970f99df","text":"FDA public enforcement and health\u2011fraud warning letters in 2019 targeting unapproved ozone medical claims and other alternative \'therapies\'."},{"id":"d681260c-e06e-4422-826a-30eb58a9eeae","text":"Publication and widespread citation of Mayo Clinic / NEJM-era randomized trials (1985) showing high\u2011dose vitamin C had no benefit in advanced cancer patients."},{"id":"5b7868af-db6b-4e90-bdce-140b83805c8b","text":"Government legal actions and sanctions against Poroshenko and his circle in early 2022"},{"id":"f4c67b8f-f721-4b6d-b214-82b231ed674d","text":"Poroshenko appears in combat role and publicly joins territorial defence units after Russia\'s full-scale invasion"},{"id":"571ef3b1-218a-41ea-ba3a-184082016906","text":"Public statements by Crimean authorities (Sergei Aksyonov) saying Crimea would refuse Ukrainian electricity even if restored"},{"id":"f1dbfefe-5e9e-4e2c-ac33-07a571ea1f31","text":"Reporting in August 2021 that the UK government and advisers were preparing/considering booster programmes (coverage of policy options and possible mass booster rollouts for older adults and vulnerable groups)."},{"id":"75fb3ff2-7efa-498c-aed9-04cad1e8e90b","text":"WHO publicly called for a moratorium on widespread booster campaigns on August 4, 2021, arguing doses should be prioritized for unvaccinated populations globally."},{"id":"c8e2dcdc-113e-4f0a-89e7-af844b5e74c1","text":"Israel announced it would offer a third (booster) COVID-19 dose to people aged over 60, becoming one of the first countries to roll out a booster programme."},{"id":"52439a57-ace8-4f0e-a58e-2ea25ed850ba","text":"CDC published an MMWR (July 2021) on a large July outbreak in Barnstable County, Massachusetts, in which a high proportion of identified cases were among fully vaccinated people (Delta-driven breakthrough infections)."},{"id":"3fc6ab64-6a58-46dc-88a1-5eba220a3e07","text":"Pfizer/BioNTech published initial data and public statements in July 2021 highlighting a planned booster program and that a third dose substantially increased neutralizing antibody titers."},{"id":"6eb14920-b3ef-47c3-a818-d5a00297bbe7","text":"Reports and satellite data show reduced air pollution over northern Italy after lockdowns"},{"id":"6b48c1d9-1669-429c-af35-4b0d572ba8be","text":"Satellite images show sharp drops in NO2 over China during lockdowns"},{"id":"0db32998-01ec-430e-939a-655122441935","text":"Climate strikes and mass mobilizations moved online or were paused (Fridays for Future/Greta Thunberg urged digital action)"},{"id":"c2c8ab49-308c-4b42-85b2-6fd772d339e7","text":"WHO declares COVID-19 a pandemic"},{"id":"47da981d-850b-44ac-a0d6-c94219998be6","text":"CDC and US advisory panels publishing VAERS-based myocarditis reports and guidance (MMWR/ACIP reviews in June 2021) acknowledging myocarditis reports after mRNA vaccination while concluding benefits outweigh risks."},{"id":"2b2b9ca9-f40d-425e-8561-7b063b8b887f","text":"IPCC Fifth Assessment Report (AR5, WG1) release and SPM (2013) noting short-term variability and model/observation differences"},{"id":"e1156b4d-4874-489c-89a7-ebb6555f0b26","text":"NOAA/Karl et al. Science paper and NOAA press release revising observational records (June 2015)"},{"id":"c81b5cbd-4f13-4372-be7c-e7e77aa70d19","text":"Testimony by John R. Christy to U.S. House committee (December 11, 2013) arguing climate models exaggerate warming"},{"id":"c859396c-60e7-430e-bbd1-6f173c056c6a","text":"Germany\'s federal and state health ministers decided to restrict routine use of the AstraZeneca vaccine to people over 60 following blood\u2011clot concerns."},{"id":"7c073262-b778-4ca0-95cb-b243b7982ffb","text":"Japan recalled and halted distribution of some Moderna COVID-19 vaccine doses after contamination/foreign particle reports were detected in early August 2021."},{"id":"3913c195-df6f-46a1-a77b-234d06be4e5d","text":"Public safety reports and media coverage in spring 2021 highlighted suspected deaths and serious adverse events reported after COVID-19 vaccination in Germany (data summarized by the Paul\u2011Ehrlich\u2011Institut and discussed in studies/media)."},{"id":"5acea283-52dc-4be7-af91-1351ea96ad69","text":"Duda visited the Bykivnia National Historic Memorial / Polish war cemetery near Kyiv during the October 2020 trip"},{"id":"f735f149-adea-40bb-85b9-e39ed7f943b6","text":"Andrzej Duda\'s previous public statements and commemorations framing the Volhynia killings as ethnic cleansing/genocide (past ceremonies and remarks)"},{"id":"c399ffed-e74d-4781-8755-ff6d46ccfcb6","text":"Duda and Zelensky signed a joint declaration and attended economic events in Odesa during the October 2020 visit"},{"id":"4874937d-d2a4-4b84-be8e-078fc60273ee","text":"UN Secretary-General Ban Ki-moon publicly expresses concern about the Crimea referendum"},{"id":"c965ed77-55a5-4f50-85d6-97b66474f50b","text":"CDC and ACIP public reports (June 2021) documenting increased reports of myocarditis/pericarditis after mRNA COVID\u201119 vaccination in younger males and recommending continued monitoring."},{"id":"6b7ea435-638a-4b49-a8ac-7dc2acf3df98","text":"Contamination and recall incidents in Japan involving Moderna vaccine vials (stainless\u2011steel/black particles) reported widely in media."},{"id":"881a9b4e-f791-4953-8c1f-94e0fdf4e503","text":"EMA publication of the Comirnaty (BNT162b2) public assessment report including preclinical biodistribution and safety data."},{"id":"9e666dbe-591b-4fc1-8a5d-cbbfca6652ad","text":"IPCC Fifth Assessment (AR5) and associated carbon\u2011cycle graphics made public (figures showing large natural CO2 fluxes compared to anthropogenic fluxes)"},{"id":"2ef1b714-3d18-4370-a67e-499877b45151","text":"Russian MP Vladimir Zhirinovsky sent letters proposing the division of Ukraine and suggested neighboring countries (including Poland) could take western regions."},{"id":"d41efa9d-b94c-413e-8a82-a278a1b220c4","text":"Polish officials publicly denied any territorial claims and reiterated support for Ukraine (coverage: \'Lviv is Ukraine\'\u2014Warsaw assures it has no territorial claims)."},{"id":"52ab28d1-e615-4350-9e4d-8080034e84e0","text":"American College of Pediatricians (ACPeds) January 2016 statement raising concerns about polysorbate 80 in the HPV vaccine"},{"id":"9a091402-3c03-4297-9d34-3435e1bc34b2","text":"Manufacturer label for Amphastar/Phytonadione injectable lists excipients (e.g., polysorbate 80, propylene glycol) in some formulations"},{"id":"7dc86030-7a19-4350-a39f-49cdfa360c00","text":"ACRIM\u2013PMOD Total Solar Irradiance (TSI) composite controversy and Fr\xf6hlich PMOD revision (mid-2000s)"},{"id":"582f74d4-d5ef-4fe1-8c27-f7ebb9b7b1eb","text":"Scafetta papers arguing a large solar contribution to recent warming (e.g., 2009 empirical analyses)"},{"id":"48c4a319-7cf0-4fd0-bc09-68cd21f0626e","text":"Release of the NIPCC/Heartland \'Nature, Not Human Activity, Rules the Climate\' summary (NIPCC)"},{"id":"2d1e731f-a3c2-4528-b58a-449901a76c18","text":"Publication of Soon & Baliunas \'Proxy climatic and environmental changes of the past 1000 years\' (Climate Research)"},{"id":"bde590cd-9b48-4b9b-b5f0-8bce36a24ff3","text":"Ukraine enacted gas-market reforms in 2015 (Gas Market Law, IMF-backed liberalisation) moving to market-based pricing (law effective 1 Oct 2015)."},{"id":"a0907cde-a1ec-40f3-9787-912b1d3b935d","text":"Naftogaz disclosed it procured all imported gas in 2016 from 15 European suppliers and published average Q1 2016 import price (~$198 per 1,000 m3)."},{"id":"2ac0eef9-cde6-4446-a483-d338c3dd199b","text":"Reporting showed Poroshenko\'s approval ratings and political standing were weak in early April 2016 (analysis reported 7 April 2016)."},{"id":"4c5f8bce-dd61-44b7-b834-9cdbf9da9728","text":"Russian and other foreign/state-aligned media amplified the Dutch result as evidence of Western unreliability on Ukraine (analysis and commentary in days after the vote, e.g. Financial Times 8 April 2016)."},{"id":"79fbeb52-b612-4dd7-a96a-b3dab751bc62","text":"Ukraine experienced visible political instability in early 2016 (Prime Minister Arseniy Yatsenyuk resigned/was asked to resign and government survived no-confidence votes in February 2016)."},{"id":"c2a1619b-1e8a-4cc4-bad3-e513b4662d11","text":"Dutch advisory referendum rejected the EU\u2013Ukraine Association Agreement (61% against) on 6 April 2016."},{"id":"defc77ff-cbfc-48bd-8b8c-c94b79d5d3ee","text":"U.S. Secretary of State discussions tying sanctions relief and diplomatic pressure to implementation of Minsk political measures (Kerry remarks, 2015)"},{"id":"c3383913-b97c-4698-bc6e-dfa86f94252e","text":"U.S. leaders publicly ruled out direct military intervention in Ukraine (statements from 2014)"},{"id":"9b91b525-00e7-4e48-a008-f8b5f09e52cd","text":"BMJ commentary highlighting that pregnant women were routinely excluded from COVID\u201119 vaccine trials (and calling for their inclusion)."},{"id":"b7ea1cf0-ee58-4c87-816e-4f6b0a636fc5","text":"Pfizer/BioNTech press release (Nov 9, 2020) announcing interim Phase 3 efficacy results for their mRNA vaccine encoding the SARS\u2011CoV\u20112 spike protein."},{"id":"3907e1af-90e2-482f-a144-f7748e0038c9","text":"UK government / ONS releases reporting ~945,000 people self\u2011reporting long COVID in July/August 2021 (publication 5 August 2021)."},{"id":"e2a23296-e072-49f1-9153-9cb10c17f747","text":"Early cohort studies (e.g., Lancet 6\u2011month outcomes, Jan 2021) reported wide-ranging, multi\u2011system persistent symptoms with unclear mechanisms."},{"id":"26e695e0-9c2a-4dd4-9ff2-b9e3b46338ea","text":"WHO published a clinical case definition of post\u2011COVID\u201119 condition (long COVID) using Delphi consensus, noting heterogeneous symptoms and lack of a single diagnostic biomarker."},{"id":"5ddf863e-80ba-40a7-9326-35d6a8d80405","text":"OSCE Special Monitoring Mission reports and situation updates documenting mines, UXO and restricted access along roads and rail in Donbas (2015 SMM reporting)."},{"id":"f0065d0f-c46a-428f-9a5a-a696aeb5fac5","text":"Mine Action Review and national mine\u2011action reporting showing large-scale anti\u2011personnel/anti\u2011vehicle mine contamination in eastern Ukraine (Clearing the Mines report, 2017)."},{"id":"af25c83d-0d32-4118-9d9f-19e0080c4a84","text":"2014 Russian \'humanitarian\' convoy and other cross\u2011border convoys/shipments that entered eastern Ukraine without Kyiv\'s full control."},{"id":"5a85052e-a1b7-4165-8b2a-69c906c41b16","text":"Analyses of Russian information operations documenting rapid, repetitive amplification tactics (the \'firehose of falsehood\' model)."},{"id":"472106a5-95aa-4a0c-86fd-4bbc45da01cf","text":"Politico reporting (April 29, 2025) that several major European leaders declined Ukrainian President Zelensky\'s invitation to Kyiv on May 9."},{"id":"5d182855-0f10-4b73-a406-7cb2a6b5d3e3","text":"Berliner Zeitung opinion column titled \'Herr Merz, zeigen Sie Mut \u2013 fliegen Sie am 9. Mai zu Putin nach Moskau!\' urging Merz to fly to Moscow for Victory Day (op-ed)."},{"id":"34420d7f-cff5-4569-84cd-74b4c1264c12","text":"Kremlin announcement (May 6, 2025) that 29 foreign leaders had been invited / would attend Moscow\'s Victory Day parade."},{"id":"8f8d57ad-bace-4ecc-ba07-a75b5b70cabe","text":"Reuters reporting (Feb 20, 2025) that Friedrich Merz had been targeted by a coordinated pro\u2011Russian disinformation network during the German election period."},{"id":"3f9258dc-40b2-4707-87e0-17ccef7ddc3c","text":"Official public-health recommendations for widespread mask use (CDC guidance published April 3, 2020)."},{"id":"a1d5fb20-590f-45a2-994a-6de1aef1ae6f","text":"High-profile news coverage of medical oxygen shortages during the COVID-19 crisis (notably India, April 2021)."},{"id":"b1c5bec7-8c75-4bfc-b1ef-03e432b736fd","text":"2010 Ukrainian law under President Yanukovych formalized a non\u2011aligned/neutral foreign policy position."},{"id":"6f8e99cb-9eac-42f8-baaf-7d5fb1ec4b66","text":"Key NATO allies (notably Germany and France) opposed offering a Membership Action Plan for Ukraine at the 2008 Bucharest summit."},{"id":"78c6dc0a-7aef-495a-a9fb-b652131b9a52","text":"Earlier (2017) Mawson pilot study reporting similar vaccinated vs unvaccinated differences"},{"id":"542b87db-3865-4252-ab38-1fef10e84787","text":"CDC and FDA investigation and public reporting of myocarditis/pericarditis cases after mRNA vaccination"},{"id":"1cffb107-1569-46e6-a9e3-c0000872fae9","text":"Japan suspends and inspects Moderna batches after discovery of foreign (stainless-steel/black) particles in vials"},{"id":"cc8b09bc-cb25-4f9c-a6b8-19f74f36a20b","text":"NASA press release: \'Satellite Shows High Productivity from U.S. Corn Belt\' (Goddard/JPL coverage)"},{"id":"a8823aaa-97b6-4788-b780-517c9261fa6d","text":"Publication of Guanter et al. (PNAS) 2014 paper showing space\u2011based chlorophyll fluorescence detects very high peak photosynthetic activity in the U.S. Corn Belt"},{"id":"4c2093dd-1e8c-4155-85d3-aaffaf245046","text":"U.S. and international tightening of vehicle tailpipe standards and multipollutant rules (March 2024 announcements and implementation plans)"},{"id":"21c8b0e0-0435-491f-81b2-87fd340173f7","text":"WHO updates Global Air Quality Guidelines highlighting health risks from PM2.5, NO2 and other pollutants"},{"id":"86a7ac0c-e6c5-46a8-ba85-7c26b269a478","text":"Investigations (2023) and NGO press releases alleging hundreds of thousands of vehicles still use defeat devices or emit far more pollution in real-world driving than tests indicate"},{"id":"20fb0ed2-b748-41ad-afdc-0c498f54fd95","text":"2023 systematic reviews and studies linking long-term traffic-related air pollution to higher dementia and cognitive decline risks"},{"id":"fff1af7e-274b-4d88-8915-f7c9ff6bb7fc","text":"Japan finds black/foreign particles in Moderna vaccine vials; batches put on hold"},{"id":"e7868079-84ab-4879-9148-df64a7f540e9","text":"Japan suspends use and recalls batches of Moderna COVID-19 vaccine after detection of black/foreign particles in vials (multiple reports in early September 2021)."},{"id":"308b0fbb-cdf9-4b3e-bd75-a035c3989203","text":"UK Health Security Agency Technical Briefing (31 Dec 2021) and contemporaneous studies reporting reduced vaccine effectiveness against symptomatic infection with Omicron and partial restoration after boosters."},{"id":"c93ece72-3991-47d1-a1cc-078067203fb3","text":"Publication of Israeli retrospective study (Gazit et al.) reporting previously infected people had substantially lower risk of Delta reinfection than vaccinated, often cited as \\"natural immunity 13 times\\" stronger."},{"id":"f395dce6-501c-4bb2-90d3-d8e75b35a094","text":"CDC / ACIP acknowledgement and published review of myocarditis/pericarditis cases following mRNA COVID-19 vaccination (summarized in MMWR)."},{"id":"7a2624fc-76c9-4968-a3d1-e347ecff910c","text":"Zelensky\'s high-profile visit to Washington and his address to the U.S. Congress on 21 December 2022, in which he sought continued Western political and military support."},{"id":"710ccf32-7e3b-45ca-9ae2-62ce4edbceed","text":"President Zelensky presented a diplomatic \\"10-point peace formula\\" to world leaders at the G20 summit (Bali) on 15 November 2022, emphasising diplomatic channels and international guarantees as part of a peace framework."},{"id":"30b128ba-4d8d-4caf-9ba0-507ade647b3f","text":"Cabinet of Ministers Resolution No. 318 \u2014 allows territorial recruitment centers to serve summons regardless of registration"},{"id":"b922483b-ca38-4bb5-92e6-bc6d9cd8e778","text":"Media coverage that Ukraine was urgently drafting reinforcements for a spring offensive"},{"id":"9fb0c90c-2388-4cb4-808c-cced91fe0867","text":"Legal regime of martial law (authorises requisition of property for public needs)"},{"id":"131116cf-1869-4bd2-bd12-8dfd6249cfca","text":"Official and watchdog reporting noted prior government measures and decisions restricting visible Muslim dress in sporting contexts (the 2023/2024 debate and a government decision referenced in the 2023 International Religious Freedom report regarding hijab and athletes at Paris 2024)."},{"id":"2a5cabbd-0f11-480f-aeb1-738c11f2f7a8","text":"French authorities announced heightened security and a dedicated police escort for the 2024 Olympic torch relay, noting specific selection and protection measures."},{"id":"899c7e3e-ee42-45f8-877c-dade5b1e3465","text":"Longstanding French la\xefcit\xe9 law and past controversies (2004 ban on conspicuous religious symbols in public schools) and continuing national debates about secularism and visible religious signs."},{"id":"d9eb600f-07a9-43c2-85a1-267b40754c4a","text":"Annual Environmental Working Group \'Dirty Dozen\' coverage (media reporting on pesticide residues in produce, e.g., CNN coverage of 2023 list)."},{"id":"c691e33e-5392-482d-9b5d-8eea0f8dd4e9","text":"Scientific reviews and peer\u2011reviewed articles showing plant\u2011derived bioactive compounds can modulate immune responses (scholarly reviews on medicinal plants and immunomodulation, e.g., PMC review)."},{"id":"ac5ef9d8-d7e6-41cc-9409-cfcf6d93f012","text":"World Health Organization declared the novel coronavirus outbreak a Public Health Emergency of International Concern (PHEIC)."},{"id":"8ac12e53-8fc9-4794-9d71-16e590409c47","text":"Public political messaging from the U.S. president and other high\u2011profile figures asserting the outbreak was \'under control\' (e.g., Feb 26, 2020), amid increasing partisan debate."},{"id":"e9c713f8-7fd8-4245-9d1d-2a091b3e8c2f","text":"EU guidelines on handling Schengen visa applications from residents of Crimea"},{"id":"b4a0c843-111a-4e9b-83ac-f24907a880e0","text":"EU travel bans and asset freezes on individuals linked to the annexation of Crimea"},{"id":"8bad62bb-f014-4f00-8801-8cfcbf482f07","text":"Published scientific and regulatory reports from 2021 documented rare cases of facial paralysis (Bell\'s palsy) reported after COVID\u201119 vaccination."},{"id":"e9b1b107-a17d-41fc-9252-d6bdda1ddb67","text":"WHO publication of regulatory considerations for mRNA vaccines noting evolving guidance (post\u20112020 development)"},{"id":"5765f2af-b42b-4678-9a5f-69b58bd3a023","text":"Japan suspension/recall of several Moderna COVID\u201119 vaccine lots after foreign particles (stainless\u2011steel) were found"},{"id":"14be8132-51cb-4f2a-8a62-0eb16f84241b","text":"Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained 24 sailors."},{"id":"7691c906-9452-450c-8fba-b94921dfc3e9","text":"Ukraine imposed bans and broad restrictions on major Russian websites, social networks and media."},{"id":"ce1e79be-c15e-4b37-a0d5-c5130c80d079","text":"Volodymyr Zelensky elected President of Ukraine in a landslide (defeating incumbent Petro Poroshenko)."},{"id":"6207eb7d-803d-456d-91b0-0a9356df9f37","text":"Ecumenical Patriarchate granted autocephaly to the Orthodox Church of Ukraine."},{"id":"8aae4da4-c6c6-4d8e-b18e-81949526f70f","text":"Ukraine deepened ties with the EU by signing/implementing the EU\u2013Ukraine Association Agreement after 2014 (formal post\u2011Euromaidan pivot toward the EU)."},{"id":"cc516e39-1c65-4879-a641-4bfaec9fb492","text":"Wuhan authorities report a cluster of \'pneumonia of unknown cause\' linked to a seafood market (Huanan) and notify WHO"},{"id":"d928ebff-a115-453e-b7cd-a8fa8856f24f","text":"U.S. CDC establishes an Incident Management Structure and begins active monitoring of the outbreak"},{"id":"61e1f3d9-d3e6-4680-a108-f43330a1b309","text":"Wuhan Municipal Health Commission statement saying there was \'no obvious evidence\' of human-to-human transmission"},{"id":"558474da-6058-4ea5-ade5-569c6a34175b","text":"OSCE/Representative condemns killing of journalist Oles Buzina in Kyiv (16 April 2015)"},{"id":"8333bdd8-feac-4112-aa25-5e0b53675aaa","text":"Human Rights Watch: \'Ukraine: Rebel Forces Detain, Torture Civilians\' (reporting on abuses in 2014)"},{"id":"4d260240-ee9c-4013-95fc-adfd97d8e8ef","text":"IAEA Director General Rafael Mariano Grossi confirmed \'physical impact\' from drone strikes at the Zaporizhzhia Nuclear Power Plant and called the incident \'serious\', noting hits on reactor-related structures."},{"id":"31ef5786-3116-4f8a-aea5-6e178bc400aa","text":"Reuters and other outlets reported that a Ukrainian drone crashed near the Zaporizhzhia nuclear plant in early April 2023 (reported 5 April 2023 by Russian media), indicating prior drone activity in the plant vicinity."},{"id":"e23ae7b9-7735-4b43-9ad3-8348a3cc7a8e","text":"IAEA and Reuters reporting documented earlier damage to off-site power infrastructure and backup power lines near Zaporizhzhia (notably on 7 September 2022), which affected the plant\'s power connections."},{"id":"c98bc55a-17cc-4765-9ff5-1a646cbe53fc","text":"Reuters special report (Oct 2014) documenting flaws and gaps in Ukraine\'s investigations into the Maidan shootings"},{"id":"1cedc6f7-c156-4315-b1bd-f9008b4b24d6","text":"Deaths of Serhiy Nigoyan and Mikhail Zhiznevsky on Hrushevskoho Street during Euromaidan (initial chaotic reporting)"},{"id":"30cfdcae-a082-44ff-88ed-042545fdac8f","text":"Academic and analytical publications debating shooter locations and responsibility for the \'snipers\' massacre (analysis circulated online in 2014)"},{"id":"6fa2180b-71b1-4dba-b39e-a0559c7554ea","text":"Lancet Planetary Health commentary \'COVID\u201119, wet markets, and planetary health\' highlighting zoonotic risk at live\u2011animal markets"},{"id":"ee537e39-4429-40e3-8845-ee67ca23d544","text":"Consumer watchdog reporting and class-action lawsuits against alkaline bottled-water marketing (coverage of multiple 2017\u20132018 suits)"},{"id":"c2cb8f2e-88ac-4001-b4ed-4d7207083a16","text":"Scientific/dental research highlighting that some bottled beverages (including waters) have low pH and can be erosive to teeth (JADA/published research)"},{"id":"0b7e09d8-a27c-4fe9-b181-633946dc6ea5","text":"Axios reporting (Aug 18, 2025) that White House officials asked Ukrainian counterparts whether Zelensky would wear a suit for his Aug 18 meeting with President Trump."},{"id":"65d3863e-ca86-4022-9d34-a133345d03fb","text":"Publication of Northwestern-led JCI study (April 27, 2023) showing unresolving ventilator-associated secondary pneumonia was linked to mortality in severe pneumonia including COVID-19."},{"id":"599d6b90-776a-4f56-87ef-3d2d60246da0","text":"Pandora Papers disclosure linking Zelensky and associates to offshore companies"},{"id":"b222b17a-80d4-4064-94f0-24f909d52578","text":"News reporting of French aid totals to Ukraine (official French figures circulated)"},{"id":"af19d067-b948-47c7-98fd-27809f978e69","text":"Public statements by Russian officials and the State Duma in Feb\u2013Mar 2022 pushing narratives that Zelensky had \'refused\' Minsk or was open to concessions, and urging Russia to legitimise breakaway regions"},{"id":"8df23cbc-2b04-4468-8a18-14731f0017fb","text":"Zelensky\'s March 8, 2022 address to the UK Parliament / House of Commons in which he appealed for stronger Western action (including implied criticism of slow/no\u2011fly\u2011zone decisions)"},{"id":"0fc47699-b995-470d-a364-c3f6358a2b00","text":"Russian recognition of the self\u2011proclaimed Donetsk and Luhansk People\'s Republics (DPR/LPR) and related escalatory diplomacy in late February 2022"},{"id":"34978d71-5cd6-4bcc-b8fb-1af8ab14cf93","text":"U.S. FDA issues consumer warning against using veterinary ivermectin to treat or prevent COVID\u201119 (consumer update)"},{"id":"8ddf5fc5-3bf5-41e0-95af-544f8ff32143","text":"Pierre Kory testimony to U.S. Senate Homeland Security committee advocating ivermectin as an \'early treatment\' (video + written testimony)"},{"id":"b1b0f19e-2187-4758-9f75-14aac08259e9","text":"WHO identified vaccine hesitancy as a top-10 global health threat (2019) and warned about misinformation undermining vaccination programs"},{"id":"5709690d-c5cc-4770-a64c-a2fc10bc7c7a","text":"Gunmen attacked polio vaccination teams (and their police escorts) in the region, including a December 2019 attack in Pakistan that killed police escorting vaccinators"},{"id":"7da30077-3d2d-4fe1-8c1b-fd241f74ec38","text":"Several European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine over reports of rare blood clots"},{"id":"e8de1b7e-6b74-4c3f-b3ac-e16793d17d46","text":"Multiple incidents of healthcare workers being spat at, harassed or attacked in India during the early COVID-19 pandemic"},{"id":"4975ed13-95c3-4dfd-817a-d35b4508e64f","text":"Hungary and other neighbouring states publicly protested Ukraine\'s education/language measures and Hungary blocked NATO-Ukraine commission meetings in protest (April 2018)."},{"id":"d5983009-517d-4c25-8d0b-45531de5eacf","text":"Nationwide implementation phase began for the education reform shifting instruction toward Ukrainian (mass implementation from 1 September 2018)."},{"id":"e79c9566-b494-4c71-85a7-fe6f8ab5c57e","text":"Verkhovna Rada adopts the Law \'On ensuring the functioning of Ukrainian as the state language\' strengthening Ukrainian\'s role in public life."},{"id":"50d01ee9-5c85-4fed-b808-8d69cdbc9da8","text":"Council of Europe\'s Venice Commission issues an opinion scrutinizing the 2019 language law (plenary opinion published December 2019)."},{"id":"4bed780a-c77d-43f8-b6fe-392eeafaacfa","text":"Strong 2015\u20132016 El Ni\xf1o and record global temperatures (reported in early 2017)"},{"id":"e262fb85-8cbc-4876-9555-f8bab2f04923","text":"Hurricane Milton made landfall in Florida and produced a real outbreak of tornadoes on Oct 9, 2024, causing widespread damage and intense media attention."},{"id":"b6750573-4fc6-4872-8536-11b5ea807dab","text":"Deputy speaker Andrey Kozenko publicly claimed about 120,000 Ukrainians had visited Crimea, representing about 10% of the peninsula\'s tourists."},{"id":"bb4e58f4-c815-4b72-84c3-a13d90c6fec5","text":"RIA Novosti published a report quoting Crimean officials that border crossings had to increase personnel because of a \'flood of vacationers from Ukraine\'."},{"id":"7b4cd620-c2ee-4e4d-a396-fef2ad37c6ab","text":"Boryspil International Airport workers staged strikes and picket lines over dismissals in early March 2015."},{"id":"f78c8c13-6953-42fb-9dba-3a217cb3704c","text":"Recent intense fighting over airports (e.g., Donetsk airport battle in Jan 2015) made \'airport\' a charged and symbolic setting in Ukrainian public discourse."},{"id":"f83d17ec-eb10-4831-acc0-dc9c4bb2de3e","text":"On-camera exchange at Boryspil: Poroshenko told protesting workers \'Don\'t raise your voice at me, or else you\'ll quickly be taken out,\' which some outlets portrayed as a threat of arrest."},{"id":"e0b2c89c-e1b7-42d0-99a7-db7173cdeb27","text":"United Nations senior officials (Secretary\u2011General and OHCHR) publicly called for an independent investigation into the civilian killings seen in Bucha."},{"id":"68c6a597-9911-4249-85a2-3907f4308006","text":"Russia announced it would ask the U.N. Security Council to meet over what Moscow called \'provocations\' in Bucha and denied responsibility, urging investigation of alleged staging."},{"id":"fad79309-d414-43a1-9a9d-2d4a5d42eae3","text":"International media published graphic on\u2011the\u2011ground footage and reports from Bucha (journalists and outlets entering the town after Russian withdrawal) documenting corpses and destruction."},{"id":"bfe4cc35-f75c-478f-8182-e7abfaa57df8","text":"ICC Prosecutor Karim A. A. Khan announces opening of a formal investigation into the situation in Ukraine, but as of early April had not published a specific, on\u2011the\u2011ground Bucha investigative timeline."},{"id":"60ce23c3-a9cd-4599-9b3b-71a8ee7b089a","text":"Ukrainian government forces launched operations and reclaimed parts of Mariupol in May\u2013June 2014 amid heavy fighting."},{"id":"741b64eb-0898-424a-93e5-d57095113352","text":"Battle of Ilovaisk (August 2014) and open-source analyses showing use of Russian tanks and weapons in eastern Ukraine."},{"id":"8b469abc-5c4b-46d0-a323-62abbf9586d0","text":"Formation and deployment of the Azov volunteer battalion in May\u2013June 2014, with operations around Mariupol."},{"id":"11e972ec-8fdd-4957-90ee-084529346007","text":"IPCC Special Report on Global Warming of 1.5\xb0C (SR15) emphasizing land-based mitigation options"},{"id":"1f20599e-7de4-440c-93e1-60e756213623","text":"Launch of the Trillion Trees initiative (WWF, BirdLife International, WCS)"},{"id":"08af0b8f-6d64-4d24-8866-99133676279d","text":"Heightened fiscal pressure and passage of an IMF\u2011compliant state budget in December 2015 (public calls for a \'fiscally sustainable\' budget; budget package passed late December 2015)"},{"id":"98a69c88-4aa5-4797-9504-38a3379a6e4b","text":"Parliament adopted the emergency law \\"On Prevention of Financial Catastrophe...\\" that amended social protection rules and changed the structure/timing of some child benefits (law adopted 27 March 2014; some provisions effective later)"},{"id":"243688f2-31ba-420b-bdd1-55f3774ea934","text":"FDA authorization for consumer genetic testing expanded in 2018 (e.g., March 6, 2018 FDA action on 23andMe), signalling regulatory acceptance of DTC genetic information."},{"id":"a8b7c5e7-0626-44fb-aace-1d52e4c2fd3b","text":"Publication of a clinical review: \'MTHFR genetic testing: Controversy and clinical implications\' (Aust Fam Physician, 2016) documenting widespread promotion of MTHFR testing by alternative practitioners and pharmacies."},{"id":"7b1297ab-5862-486f-9071-4f90b1855190","text":"German federal prosecutors publicly announced the arrest of three Ukrainian nationals suspected of planning parcel/explosive attacks and other acts of sabotage in Germany and Switzerland."},{"id":"e94d7fbd-75f0-44d3-b424-5299cb09f6f5","text":"Public warnings from German domestic-intelligence officials in late 2024 that Russian sabotage and intelligence activity targeting European logistics and critical infrastructure were an ongoing threat."},{"id":"f2009dec-48f9-472c-8a6c-72ec907820ff","text":"News coverage noting a recent string of fires and security incidents at European courier and freight depots in months prior to the arrests."},{"id":"b82828fb-72b4-438d-8217-b3285d06e625","text":"Commander\u2011in\u2011Chief Valerii Zaluzhnyi publishes a high\u2011profile piece and interview in The Economist outlining that the war has entered \'positional\'/stalemate phase and calling for major technological/strategic changes"},{"id":"b34702c2-abc2-41c6-b039-5462213ac454","text":"Western press coverage highlights growing tensions and public debate over the relationship between President Zelensky and Commander Zaluzhnyi amid frustration over the stalled counteroffensive"},{"id":"38672460-e6a2-4e57-aa25-0580a615e984","text":"Official national exit\u2011poll consortium (Razumkov/NI Consortia: DIF, KIIS, Razumkov) published large\u2011margin results showing Volodymyr Zelensky\u2019s landslide victory on April 21, 2019."},{"id":"393a7139-371c-44aa-8032-069fe7cdb7f5","text":"Pew Research Center survey (released July 29, 2024) showing wide partisan divisions on U.S. responsibility and support for the war in Ukraine."},{"id":"e9f5af32-2194-4ad4-9d31-fd32286912f7","text":"House Speaker Mike Johnson repeatedly delayed or conditioned votes on Ukraine aid and publicly signaled limited appetite for further Ukraine funding among House Republicans in spring 2024."},{"id":"62c8ffd3-d63a-4c18-a39f-e713c858561a","text":"Republican infighting and public GOP messaging in early April 2024 explicitly citing polls and voter fatigue to justify delaying or opposing further Ukraine assistance."},{"id":"41859453-3ca7-42e5-ab9d-59bbdf9c64f2","text":"Joint Investigation Team (JIT) announced criminal investigation findings implicating a Buk missile from territory held by pro-Russian separatists (September 2016)"},{"id":"f41106cb-4f98-417b-97a3-ee550457e74e","text":"Media coverage of shifting Russian public opinion (Levada/Moscow Times report, Feb 2020) showing changes in who Russians say is responsible"},{"id":"5088ae91-c41e-4b3b-92ac-10fb6253f083","text":"Great Barrington Declaration (Oct 4, 2020) calling for \\"focused protection\\" and opposing lockdowns"},{"id":"f2aefb8c-88ae-4546-a2ba-f328776f4d19","text":"WHO interim guidance advised masks mainly for symptomatic people and healthcare settings (interim guidance PDF)"},{"id":"8a4b6346-bdb7-45ab-b8e5-216e21331f64","text":"CDC publicly recommended cloth face coverings for the general public (press release)"},{"id":"046df810-54d5-4ea9-9d48-26543a907c8c","text":"China temporarily bans wildlife trade nationwide in response to the novel coronavirus (reported by Reuters)"},{"id":"94f80fa6-0445-46be-82c2-c6464ae6e031","text":"IPBES 2019 Global Assessment report on biodiversity and ecosystem services publicly released"},{"id":"f56e724b-f666-418a-9641-60030e9a6e78","text":"IARC (WHO cancer agency) issued a press release classifying processed meat as \'carcinogenic to humans\' (Group 1)."},{"id":"cba76ec1-2e4f-4cc5-aaf8-8514021bc6ff","text":"WHO/IARC published clarifying Q&A and statements explaining that Group 1 classifies hazard (evidence of carcinogenicity) but does not indicate the magnitude of risk relative to other Group 1 agents (e.g., smoking)."},{"id":"12ceeaa3-7219-4f4c-8c7f-7dd8c7b97e27","text":"International Rescue Committee (IRC) and other NGOs issued warnings and reports (late Sep 2023) expressing concern about legal uncertainty and the future of support for Ukrainians in Poland."},{"id":"e913e2bd-7e82-4b5d-a9ff-9aa52fe9d532","text":"Polish government spokesman Piotr (Piotr) M\xfcller publicly said Poland will likely not extend special support measures for Ukrainian refugees into 2024."},{"id":"85be5d28-9be0-4f96-b52a-a84d13ba804c","text":"Poland\'s Social Insurance Institution (ZUS) suspended childcare/family benefit payments for thousands of Ukrainian refugees who had left Poland."},{"id":"4edaedb4-1177-4c33-8fe3-a9c57ff64be5","text":"Multiple news outlets (e.g., Kyiv Independent) and regional reporting reproduced Polish officials\' remarks that support may be curtailed in 2024, producing headline-driven coverage in mid-September 2023."},{"id":"b34f9294-31af-458f-9f7a-e810c428c647","text":"2015 U.S. Dietary Guidelines Advisory Committee recommended removing a quantitative limit on dietary cholesterol"},{"id":"cfc8dac5-eae7-44fe-b864-2482df74dca6","text":"CDC/ACIP MMWR update on myocarditis after mRNA COVID\u201119 vaccination and policy guidance (MMWR report / ACIP review)"},{"id":"76779a0a-a497-45d3-960f-6b7640ef3be9","text":"Renaming of Dnipropetrovsk to \'Dnipro\' under Ukraine\'s decommunization/renaming process"},{"id":"c81c8c92-df86-4bef-8972-2c3dced462e8","text":"Adoption of Ukraine\'s 2017 education law strengthening the use of Ukrainian in schools"},{"id":"ff19f0b5-e0d1-47f2-99b1-fd16c13252ab","text":"Pro\u2011Russian unrest and separatist seizures in eastern Ukraine (including activity in Dnipropetrovsk region)"},{"id":"2b377322-508b-4291-976a-ef44e85e47f4","text":"Norwegian review of deaths in very frail elderly after Pfizer vaccination (widely reported mid\u2011January 2021)"},{"id":"780ed672-740b-42db-bbb9-1c3cfe15c884","text":"FDA issues Emergency Use Authorization (EUA) for the Pfizer\u2013BioNTech COVID-19 vaccine"},{"id":"44e8bf4b-1ea1-4a06-837d-f5d274fc6298","text":"First U.S. COVID-19 vaccinations administered and public rollout begins"},{"id":"049dc814-2eea-465a-ae77-96f8303282b5","text":"Press conference by Reserve Colonel Mykhailo Slobodianiuk in Lviv (March 11, 2015) in which he discussed adding additional grades/medals to the Order for Courage rather than annulling it."},{"id":"fdec233d-6dc1-4acd-a0fe-ee5a2450d5d2","text":"Widespread toppling and removal of Soviet-era monuments across Ukraine during 2013\u20132014 (including multiple high-profile Lenin statue removals)."},{"id":"551694f8-1f83-4aae-9c9c-41e537b939b0","text":"Target Malaria (a Gates Foundation\u2011supported research consortium) conducted the first small\u2011scale releases of genetically modified sterile male Anopheles mosquitoes in Bana, Burkina Faso (July 2019)."},{"id":"2db5c7f5-ea01-4b89-ae5e-8c37f503a871","text":"Oxitec conducted pilot releases and community engagement in the Florida Keys (2021) and faced local protests over planned releases of genetically modified Aedes aegypti."},{"id":"a26573e7-d94c-4d97-b963-0a2f88d078a6","text":"Bill & Melinda Gates Foundation publicly funded Oxitec to develop genetically engineered mosquitoes for malaria control (reported 2018)."},{"id":"16ee9cf2-3b9a-4256-bf89-3596588e2d8b","text":"Controversy over Oxitec field trials in Jacobina, Brazil (2013\u20132015) culminated in 2019 scientific disputes and papers suggesting rare viable progeny/hybridization, prompting public debate."},{"id":"2e286ee4-f7c4-4ce4-a624-6aa5fbe4cdd1","text":"ACAPS / briefings and national reports show large concentrations of Ukrainians remaining in Polish cities (May 2022 briefing)"},{"id":"8dd2c93f-1d8a-4a4a-ad86-633bda279731","text":"Early UNHCR / IOM intention surveys (April\u2013May 2022) reporting many refugees\' immediate plans and diverse intentions to stay or return"},{"id":"f75f429b-c285-4736-8bb9-77a0444909b7","text":"Poland introduces PESEL registration for Ukrainian arrivals, enabling access to services"},{"id":"d12cb5c7-b7f9-47be-b6b4-700896da05da","text":"EU Council adopts Temporary Protection Directive for people fleeing Ukraine"},{"id":"83856f5d-cd5d-42a7-8bb8-86fc5023ba6c","text":"Polish border guard reports over 2 million refugees have entered Poland since the invasion"},{"id":"301e6dd0-28d1-4fa7-93e7-d1e276348db1","text":"China\'s documented prior practice of rejecting incoming grain shipments for reasons such as unapproved GMO varieties or contamination (e.g., several U.S. corn cargoes rejected in 2013)."},{"id":"895a1573-a6e8-42d5-b8a3-63fd2799a409","text":"Ukrainian inspectors / Consumer Protection Agency reported a small detection of pests/nematodes in certain fields designated for export."},{"id":"90948fe5-444a-4293-8d27-d4e7b5644413","text":"Human Rights Watch documents abuses by volunteer battalions and excessive detentions by Ukrainian security services"},{"id":"981e2b7e-9aa1-4557-9067-b3e3be09f2f7","text":"OSCE Special Monitoring Mission (SMM) publishes thematic reporting and daily monitoring documenting civilian casualties and incidents in Donetsk and Luhansk"},{"id":"46e5b7e0-08b0-4865-b903-843b9996b895","text":"Ukrainian officials and ombudsman reports attributing water supply interruptions in parts of Donetsk and Luhansk to artillery damage and actions by occupying forces (2014\u20132015)"},{"id":"1c6df9bd-4737-4ab4-82f7-3eb4f752c444","text":"Power cuts and shelling halted pumping stations and water supply in Luhansk (summer 2014)"},{"id":"503b473d-f061-4805-be91-d667d63484bb","text":"U.S. Secretary of State Antony Blinken visits Kyiv and reaffirms support but makes no commitment on NATO membership"},{"id":"6b2df06c-a07c-49f9-b5cc-626c29f8439e","text":"Ukraine amends its constitution to enshrine EU and NATO membership aspirations (constitutional change enters into force)"},{"id":"69d75edd-3449-4b43-a59e-e9fd47b7ae01","text":"Public opposition from major NATO members (e.g., Germany and France) to immediate Ukrainian accession around the 2008 summit"},{"id":"5abcc1de-96c1-448c-a6d2-4ea7fb6cf619","text":"Ukrainian officials publicly warned that individuals who visited temporarily occupied Crimea or separatist\u2011controlled Donbas without Kyiv\'s permission would be banned from observing Ukrainian elections"},{"id":"cae0288a-9c2b-403c-8e17-3d152591cb2e","text":"Ukraine\'s Central Election Commission had publicly registered hundreds of international observers ahead of the March 31, 2019 presidential vote"},{"id":"d5619de6-e379-4c21-9e41-7b82d2e9cf09","text":"Verkhovna Rada passed amendments banning citizens of the Russian Federation from serving as official election observers in Ukraine"},{"id":"f38ee2fc-4c47-402d-9dc1-e453902b37dc","text":"A specific German activist/politician (Andreas Maurer, Die Linke) who had previously visited occupied Ukrainian territories and held pro\u2011Russian positions was not accredited as an observer"},{"id":"7dd19033-9011-4652-a273-02ba7b167fbe","text":"Publication of small, legitimate human moringa studies for other outcomes (e.g., 2021 randomized trial on glycemic control)"},{"id":"5d015e2b-e346-4f80-bbc2-2d133e230e4a","text":"Peer-reviewed research and clinical-trial literature on helminth (worm) immunomodulation and \'helminth therapy\' for autoimmune conditions (reviews and trials published in mid-2010s)"},{"id":"56b67639-9bd2-4892-a5b3-68dd79b4da68","text":"Analysts and Ukrainian officials reported a sharp projected fall in spring sowing area (up to ~39% decline) because of the invasion, threatening the next harvest."},{"id":"f61b81e2-62fd-460d-80c9-6bf63aa9c42d","text":"Russian naval blockade of Black Sea ports blocked Ukrainian grain shipments, threatening export revenue and leaving grain on vessels."},{"id":"62ca5e08-c759-40cb-bfe4-9e7efd707a0e","text":"Sanctions and the war disrupted fertilizer and fertilizer-ingredient supplies (Russia/Belarus are major suppliers), raising alarms about reduced crop yields globally and in Ukraine."},{"id":"4a1d7ffd-9e6c-41be-87e9-e7b2bb5ada22","text":"Reports from newly occupied areas (e.g., Kherson) of empty stores, local food shortages and looting after Russian forces captured territory."},{"id":"5f29be91-c5bd-4152-8198-05bf8559430f","text":"Reports of long queues as Crimeans applied for Russian passports (coverage March 19\u201320, 2014)"},{"id":"12ebd395-a9a9-48a9-93d5-f22ee31eb5a0","text":"Defection of Ukraine navy commander Denys Berezovsky to pro\u2011Russian Crimean authorities (early March 2014)"},{"id":"659db844-2578-4f14-a374-26004e52686d","text":"Verkhovna Rada vote to repeal the 2012 language law (widely reported as a \'ban\' on Russian)"},{"id":"3a38d6d4-0713-4982-8aff-3d58bd79458c","text":"Deadly clashes and Trade Unions House fire in Odesa"},{"id":"65eedcdb-e7eb-4498-b22c-60af062d17cf","text":"Reports of attacks, intimidation and disappearances of activists in Crimea during the March 2014 takeover"},{"id":"8a36bca0-072a-4757-8ae6-18b33483385b","text":"Euromaidan protests, violent escalation and ouster of President Yanukovych"},{"id":"2da13781-4048-4b5f-b4cb-a78577f53431","text":"CDC lab alert language recommending adoption of multiplex assays that can \'facilitate detection and differentiation of SARS\u2011CoV\u20112 and influenza viruses\'"},{"id":"8256eadd-706a-446e-a58c-9cc14fa415e9","text":"CDC Lab Alert announcing it will withdraw its request for EUA for the CDC 2019\u2011nCoV Real\u2011Time RT\u2011PCR Diagnostic Panel"},{"id":"c6345b60-d5ec-4372-b335-bcf12bd680cb","text":"OSCE Special Monitoring Mission reports documenting weapons, movements and indicators of cross-border support to armed groups in Donbas"},{"id":"b786b12a-50eb-40a8-aee4-17dbff29a504","text":"FIFA precedent of suspending a national association for government interference (Kuwait suspended)"},{"id":"30bf0937-8a19-471d-95a6-cb0d6e8a310e","text":"UEFA opened fresh disciplinary proceedings and charges related to crowd disturbances and racist behaviour involving Dynamo Kyiv (follow-up enforcement actions)"},{"id":"ad4528b2-4f55-499b-af2d-b03fbedd1e7f","text":"UEFA bans Crimean clubs from Russian competitions and declares Crimea a \'special zone\' for football"},{"id":"b597baf7-408d-4792-9acc-5679c205c646","text":"Publication of Lennerz et al. survey of 2,029 self\u2011identified carnivore dieters (Current Developments in Nutrition)"},{"id":"966f752b-1058-43b6-b60f-d845aa2120e1","text":"WHO highlights a multi\u2011country validation study of the OptiBP smartphone blood\u2011pressure application"},{"id":"45ecf42f-bf63-49b6-b2da-85a73193e857","text":"European Society of Hypertension working\u2011group statement on cuffless blood\u2011pressure devices (review and guidance)"},{"id":"67cb95e5-2f8d-436a-be98-cf9a58fef5c1","text":"Peer\u2011reviewed npj Digital Medicine study (CamBP/OptiBP) reports ISO\u2011aligned accuracy in select populations"},{"id":"ecb44f8a-8e35-467d-8ca2-17673dfd6e43","text":"Approaching 30th anniversary of the Chornobyl disaster and official commemorations (Poroshenko declared 2016 \'Year of Remembrance\' for liquidators and victims)"},{"id":"62336475-296d-4838-9a8a-b833a4d4142c","text":"President Petro Poroshenko vetoed law No.2093 and returned it to parliament with proposals"},{"id":"860124bc-f2a7-4ab6-9e29-44cc8b056d61","text":"Verkhovna Rada (Ukrainian parliament) passed draft law No.2093 restoring certain Chernobyl benefits"},{"id":"cc7fd350-9a27-4fd5-9054-e6c7b35e05fc","text":"Publication of in vitro research showing antiviral activity of Melissa officinalis extracts against some influenza strains (e.g., lab studies on H1N1 / H9N2)"},{"id":"cfa0a8a3-c151-4166-a74f-93d11dbf5202","text":"Putin signed decree requiring buyers from \'unfriendly\' countries to pay for gas in roubles."},{"id":"cfcd7cc0-f8b2-410a-b690-144365d976fc","text":"Austrian government statement: Russian gas still flowing while Austria scrambles for alternatives."},{"id":"85358ada-ded2-4e3c-a579-c736936f7e8c","text":"OMV (Austrian energy firm) said it had initial contact with Gazprom about rouble payment demands."},{"id":"dbe30528-7d99-4b74-8614-cf0c78e26962","text":"OPEC (led by Saudi Arabia) decided not to cut output, triggering a sharp oil price fall"},{"id":"79d49a22-5863-4981-889b-19072d9fbed9","text":"Kremlin and Putin publicly blamed Western sanctions and falling oil prices for the rouble slump"},{"id":"fd0e1ca9-5c9f-4ff3-96d7-c06309f99fb1","text":"Reports Russia spent tens of billions defending the rouble in 2014 (estimates ~USD 80bn)"},{"id":"7fd37d9b-515e-4e44-8623-a14228b18536","text":"Emergency Bank of Russia decision: key rate hiked to 17% as rouble plunged"},{"id":"fc9326d4-bea3-465f-8300-9c4cd0d0d64d","text":"Western sanctions on Russia expanded through 2014 over Ukraine/Crimea"},{"id":"9758342d-846f-48e2-8b92-5eeebda6d84f","text":"NOAA press release and reports (Jan 2024) documenting 2023 as one of the warmest years on record while noting the roles of greenhouse gases and natural variability"},{"id":"d29761e6-4997-42d1-93ea-195b123004a8","text":"Peer\u2011reviewed opinion piece (Sherwood & Forest) in Atmospheric Chemistry and Physics (2024) discussing remaining uncertainty in equilibrium climate sensitivity (ECS)"},{"id":"339098bd-e1e6-4550-b6d1-60f25374586b","text":"Investigative reports (April 2024) documenting widespread climate misinformation and enforcement failures on short\u2011form social platforms such as TikTok"},{"id":"2f3fc5c4-6bcf-4eac-81b9-d55526479821","text":"Republican-led U.S. congressional hearings on climate science that featured skeptical expert witnesses and took place across March\u2013April 2024"},{"id":"4e26b60c-4367-4953-9339-80b88881cb04","text":"Ukrainian parliament actions in September 2014 approving laws on special status/self-governance and amnesty provisions related to Donbas"},{"id":"e43e52f7-2fa4-4458-969b-ae3a70bed2f0","text":"Minsk II agreement (Package of Measures) contained an instruction to \'provide pardon and amnesty\' for persons involved in events in parts of Donetsk and Luhansk"},{"id":"0cb5aab1-def6-45ea-a897-dd13a4fcb291","text":"High-profile interviews and statements by Nadiya Savchenko urging peace talks and negotiation with separatists"},{"id":"b5543f8e-006b-454f-b7e4-1c6ed17817fa","text":"Nadiya Savchenko\'s high-profile release and return to Ukraine in a prisoner swap (pardoned and flown back)"},{"id":"196b27e2-32f7-4bf1-b456-88904d80aec9","text":"German Communist Party (DKP) launched a petition asking the Bundestag and government to lift sanctions that hinder exchange of medical supplies and cooperation during the COVID-19 crisis."},{"id":"c04f81b8-5be6-4f6d-b8da-32d6aa21d84f","text":"Russian leadership/public diplomacy pushed a narrative that international sanctions hampered pandemic response \u2014 including Putin\u2019s appeals at G20/UN fora to suspend some sanctions for humanitarian reasons in late March 2020."},{"id":"59bf1e25-ae86-4f29-97b8-78581d3d04f3","text":"EU/commission reporting showed a sharp rise in applications by Ukrainians for Romanian citizenship in 2014\u20132015"},{"id":"60bf6c70-bd10-4413-b426-9d11a9653a75","text":"Local media reports of a \'Constituent conference\' of an \\"Assembly of the Romanians of Bukovina\\" in Chernivtsi allegedly deciding on autonomy"},{"id":"ca0212d6-7c4b-4e02-b239-11ce52df0bc4","text":"Russian officials warn of a sharp increase in shelling in the Donbas and publicly blame Ukrainian forces (Russian statements about escalated shelling)"},{"id":"b110c694-281d-45ef-92e8-c0b9affcb346","text":"Moscow says a projectile fired from Ukraine destroyed a Russian border facility (Rostov region)"},{"id":"0e3d2cc6-1066-48dd-a27e-244e62a48617","text":"Russia launches a full-scale invasion of Ukraine (24 February 2022); Ukrainian leaders publicly vow to repel and drive back Russian forces"},{"id":"bcc544a2-efaa-40b7-84c7-71cbad343f84","text":"Peer-reviewed laboratory study found a banana-derived lectin (BanLec) inhibits HIV replication in vitro"},{"id":"1d65d8ef-b267-4c53-9e26-c6c5beaced86","text":"Publication of peer-reviewed reviews and preclinical studies summarizing DMSO\'s immunomodulatory and in vitro anticancer effects (science literature available by 2020)"},{"id":"4a658a81-28d6-4abe-9832-22c1a7e3e16a","text":"1978 FDA approval of RIMSO-50 (a 50% DMSO solution) for intravesical use in interstitial cystitis"},{"id":"da266b40-9b7e-4f6b-b6b9-b4f5073e68af","text":"International Coral Reef Initiative (ICRI) published an update stating that bleaching-level heat stress impacted 84% of the world\u2019s coral reefs."},{"id":"b7bbcc42-c9a1-444b-9fef-ed1c7e0ad146","text":"Wagner Group rebellion and armed column movement near Voronezh"},{"id":"9ef0d9f0-7a35-4e5b-ad5b-6dc0c299e527","text":"Explosions/drone incidents over central Moscow (including near the Kremlin) and official accusations"},{"id":"e4b1d43c-bbc0-4bc4-8b5a-09ae200e4b31","text":"Fuel tank fire at a Rosneft oil depot in Voronezh region"},{"id":"0d409954-3f1f-4a11-a677-fabc5e45f83c","text":"CDC One Health guidance noting most emerging infectious diseases are zoonotic"},{"id":"459f6d39-89f1-4124-b6d3-782d4a49df4f","text":"Two Ukrainian servicemen (including Dmytro Krasnohrud) were killed near Zaitseve on July 13, 2020; bodies were later handed over \u2014 a real battlefield casualty incident."},{"id":"c8b58a8c-445b-433a-993c-fc7a82490c95","text":"Mainstream health articles and reviews (e.g., Healthline overview updated June 29, 2023) summarizing promising lion\u2019s mane research for cognition and Alzheimer\u2019s"},{"id":"d9878fd5-bcaf-429d-8863-615171a1955a","text":"2016 mouse study (Tsai\u2011Teng et al.) showing erinacine\u2011A enriched Hericium mycelia reduced amyloid pathology in APP/PS1 Alzheimer\u2019s model mice"},{"id":"72eb9227-e645-411f-9e19-1b02d4ed398f","text":"July 20, 2021: FDA warning letter(s) and subsequent press attention about dietary\u2011supplement sellers making disease claims for mushroom products (including lion\u2019s mane)"},{"id":"567319b3-8cbb-4fec-8699-f5d50156c4da","text":"Russia imposes bans on Ukrainian food imports after 2014 sanctions"},{"id":"075cddf6-23f3-4430-888a-d7e4bceaf569","text":"Sharp GDP contraction during 2014\u20132015 amid conflict and economic shock"},{"id":"64a4b6bb-e6f8-4c75-98cb-8cbcd3022f9c","text":"Provisional application of the EU\u2013Ukraine Association Agreement including the DCFTA"},{"id":"253ccb87-0251-4c30-99c8-3f6544a04ff8","text":"September 2021 reports of black/foreign particles found in some Moderna vials in Japan and large batches paused"},{"id":"26d0e6cc-2b41-475c-8845-f74aa9d04201","text":"Center for Economic Strategy published an assessment placing Ukraine\'s economic losses from the temporary occupation of Crimea at about $135 billion."},{"id":"073afdee-e01b-46aa-a9c6-1829a7761aea","text":"U.S. EPA and other regulators/extension services have published fact sheets explaining corn gluten meal is a food/feed product, classified as minimum\u2011risk for pesticide use, and that its rodenticidal effects depend on a physical/dehydrating mode of action not applicable to humans (EPA fact sheet Nov 2002; Cornell IPM profile)."},{"id":"1294ad29-53d1-48f4-810e-59099cff540e","text":"IPCC Synthesis Report released attributing recent warming predominantly to human activities"},{"id":"00490e88-4c69-439f-840a-b6f48abec599","text":"Publication of Nicola Scafetta et al. paper in 2023 arguing a larger role for the Sun in recent climate change"},{"id":"9e3c28e4-6c0a-44a5-8ad1-a17e10e5fded","text":"Local reporting: large pro\u2011Ukraine demonstrators in Kherson outnumbered pro\u2011Russian activists (Svoboda Square, Kherson)"},{"id":"f11bc561-5265-46b4-be24-784619995d03","text":"BBC analysis \'Ukraine underplays role of far right in conflict\' documenting Azov and use of Nazi\u2011linked symbols (Wolf\'s Hook) in 2014"},{"id":"32a66506-57c7-45bd-982c-36465c065377","text":"BBC profile of the ultra\u2011nationalist Right Sector and its role in the 2014 Maidan protests"},{"id":"f30b12d4-dcd1-4f56-aebf-112510f25d5f","text":"Randomized, double\u2011blind clinical trial (Koytchev et al., Phytomedicine 1999) found topical lemon balm extract reduced symptoms and accelerated healing of herpes labialis (cold sores)."},{"id":"45421d92-486f-4312-b002-49b5d0a5a857","text":"FDA warning letter to Applied Health Solutions (Oct 22, 2021) cites Grapefruit Seed Extract product claims including effectiveness against \'herpes\' and other viral diseases."},{"id":"48b2d768-230a-4aa5-ab8a-5743244c1e3a","text":"UK Ministry of Defence announced it would send Challenger 2 tanks to Ukraine along with armour\u2011piercing rounds that contain depleted uranium."},{"id":"4acf7638-53e6-40c9-a142-69a12748f1f2","text":"Historical precedent: Reporting and investigations documenting previous UK/US use of depleted uranium munitions in conflicts (Iraq, Balkans) were widely available."},{"id":"80cc3b20-787e-416c-b035-1cd977c998e2","text":"Russian President Vladimir Putin publicly condemned the UK move and warned Moscow would be \'forced to react\', calling the ammunition a weapon with a \'nuclear component\'."},{"id":"b3b31d70-3d5f-4d91-b7cb-39885ce4fcc6","text":"Parliamentary elections scheduled for October 26, 2014 (the \'day of silence\' was October 25), creating heightened public attention and low tolerance for reports of interference."},{"id":"966a16e0-bee9-4168-8b73-67eea3f7ae0c","text":"Publication of Nerem et al. (PNAS) showing recent acceleration of global sea-level rise (2018)"},{"id":"2404a11f-7524-43e2-a24c-41424b74bb3c","text":"Release of the Bureau of Meteorology / CSIRO \'State of the Climate 2018\' report"},{"id":"c9bc0260-f4d6-4947-ba76-41372364aa42","text":"Marin County measles cases and public reporting on vaccine exemptions (2014\u20132015)"},{"id":"26adcb73-598e-4f08-976b-f78de7e92ed2","text":"Publication of Nevison & Parker county-level analysis showing plateau/decline in ASD prevalence among wealthy white California counties"},{"id":"b4881885-8b42-4b2b-bc5e-2427d67b85b7","text":"Ukraine adopts law and official policies on \'temporarily occupied territories\' and Donbas reintegration (2018)"},{"id":"c55607db-643a-4cbc-b25f-1a43cc9cbce4","text":"Putin decree simplifying acquisition of Russian citizenship for residents of Donetsk and Luhansk (passportisation of Donbas)"},{"id":"b1e5a97e-b8a4-452d-8367-66915839ebfd","text":"Graphic reporting and images of women giving birth in bomb shelters, basements and damaged maternity hospitals (including Mariupol) during early 2022 attacks"},{"id":"cbf18eaa-c607-475a-81b4-cbf05023e7bb","text":"Reporting that Ukraine was a major international destination for commercial surrogacy and fertility tourism"},{"id":"e1772e61-1e20-4382-be94-490d349fea1c","text":"President Petro Poroshenko granted Ukrainian citizenship to three foreign-born technocrats nominated for ministerial posts ahead of a 2014 cabinet vote."},{"id":"e3bf6429-0f20-4ba4-8b26-665f3b75e5a4","text":"Media coverage highlighted several foreign\u2011born ministers and officials (e.g., Natalia Yaresko, Aivaras Abromavicius) being granted citizenship to take government posts in late 2014."},{"id":"ceb9cdf7-9d46-4c9f-8740-f061565ccfa8","text":"Former Georgian president Mikheil Saakashvili was granted Ukrainian citizenship and appointed governor of Odesa region (later stripped and restored at different times)."},{"id":"2e025176-d873-4617-8b4e-6f437ac9d311","text":"Minsk II agreement sets political steps for Donbas (Package of measures)"},{"id":"5562bd6c-3644-4029-b8b5-49f3069414b8","text":"OSCE deploys the Special Monitoring Mission (SMM) to Ukraine"},{"id":"ed917cad-09cd-471c-b261-f1d3e72fd003","text":"UN General Assembly adopts Resolution 68/262 affirming Ukraine\'s territorial integrity"},{"id":"d6bc271e-34c2-44c8-beaf-77b2fd2c80fd","text":"UN Secretary\u2011General issues statements urging restraint on Crimea/Ukraine"},{"id":"4015b7c3-dd2a-4989-a19d-85367b1ffbff","text":"Russia summoned the German ambassador after Berlin\'s public statements on the Navalny case"},{"id":"99e605c6-f488-456b-bf0d-9dbd2b9f9003","text":"Aleksey Navalny airlifted from Omsk to Berlin for medical treatment"},{"id":"fee08dde-a2d5-4671-bebb-7cfa33586d86","text":"Germany handed laboratory test data and facilitated OPCW technical assistance regarding Navalny\'s poisoning"},{"id":"8e31e618-084f-41ef-b498-669073ce1420","text":"Chancellor Angela Merkel said Navalny\'s poisoning was an attempted murder and called on Russia to explain"},{"id":"eeb0fdb7-038c-4e03-9e57-dce06231b27f","text":"World Bank reported sharp GDP and industrial-production declines linked to the 2014 conflict"},{"id":"08a265de-ddd4-41d9-9c9b-e726f7e578c2","text":"Avdiivka Coke and Chemical Plant heavily shelled and production repeatedly disrupted"},{"id":"22efaf13-bae7-48b9-ac24-b658143c6474","text":"Large share of Donbas industrial capacity cut off after 2014 fighting and separatist control"},{"id":"7779dd72-ca1b-4c1b-9903-d28e8dc1faab","text":"Japan paused use of a large Moderna vaccine lot after pharmacists found black/foreign particles in vials (investigations later identified contaminants and some lots were recalled); mainstream outlets (BBC, others) reported the pause in Sept 2021."},{"id":"ea62de52-12d4-4d81-8a68-5fe74dc5074e","text":"Francis Fukuyama interview with Radio Svoboda published containing a cautious line that \'the issue that Ukraine will face in the future is the possibility that not 100 percent can be liberated\'"},{"id":"70d7fa7f-606d-4df7-a886-ac349df9049e","text":"\u2018Support Free Ukraine\u2019 demonstration outside the Ukrainian embassy in Sofia"},{"id":"96fbbb85-f272-4a7f-beb5-baf8b1586d33","text":"Public rallies by the nationalist Ataka party in 2014 (large street demonstrations)"},{"id":"d71b3006-88b0-41b1-b3e5-9186f225d79d","text":"Reporting on Bulgaria\u2019s divided stance over Crimea and visits by Bulgarian politicians"},{"id":"eeb6921f-9f1d-4f99-a547-4bbd68995d30","text":"Reports (2010\u20132011) linking the Pandemrix H1N1 influenza vaccine to increased narcolepsy cases in children in Finland and Sweden and subsequent EMA/GSK reviews"},{"id":"8191a74c-d1ab-47a8-9174-f0d5cbfd58ca","text":"June 2013: Japan\'s Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine after reports of alleged adverse events"},{"id":"b53eff8f-aadc-42a8-ab34-a617398456c5","text":"Public-health data and surveillance reports (UKHSA, ONS and CDC studies in 2021) showed waning vaccine effectiveness and higher absolute numbers of cases or deaths among vaccinated people in some age groups\u2014driven by high vaccine coverage and timing\u2014during late 2021."},{"id":"abcf1a28-13cf-40e8-947d-de677b477c2d","text":"Reports of contamination in vaccine batches in Japan (stainless-steel/foreign particles in Moderna vials) and subsequent recalls/suspensions during September\u2013October 2021."},{"id":"4e94fa2f-75fd-435f-9008-7932c588c0e3","text":"International media reporting of Russia\'s seizure of three Ukrainian naval vessels and detention of crew (wounded sailors reported)"},{"id":"ed3e4012-24a0-4a30-aef0-11715ad3f744","text":"Coverage and analysis noting EU reluctance or political obstacles to imposing new Russia sanctions after the Kerch incident"},{"id":"afca75d1-e3a8-40b8-b590-69bddd25646a","text":"G7 foreign ministers\' joint statement expressing \'utmost concern\' about Russian actions in the Kerch Strait"},{"id":"ac1155ef-570d-42ff-9439-4132f58aa74d","text":"IMF and international lenders publicly warned Ukraine to accelerate reforms and tackle corruption to preserve investor confidence."},{"id":"a8695eab-8246-4726-b5e9-2e579aabe031","text":"Kyiv issued formal sanctions on Russian-owned banks (blocking capital outflows and imposing restrictions)."},{"id":"d0146263-c582-47b2-8757-4deb785b6900","text":"Sharp falls in foreign direct investment and international capital flows to Ukraine following the 2014 crisis (documented in UNCTAD/World Investment reports)."},{"id":"302853a2-fb88-4896-9616-6741fd099aac","text":"Nationalisation of PrivatBank, Ukraine\'s largest commercial bank."},{"id":"914af81b-99f3-4771-ad7a-a28ece1a25e1","text":"Reports that thousands of Mariupol residents, including children, were forcibly deported or taken through \'filtration\' after Russian forces captured parts of the city"},{"id":"0f0a3feb-fe9f-44dd-866d-26c18406276a","text":"Red Cross / national Red Cross societies publicized medical aid, psychosocial support and programs for displaced Ukrainian children and families in early 2022"},{"id":"b5731f9d-93e5-410c-b508-af876a95e93e","text":"Red Cross-led evacuation attempts to reach and extract civilians from besieged Mariupol failed or were halted amid heavy fighting"},{"id":"d1e32d54-7605-4c03-9379-6fb1f04f9705","text":"Bombing of the Donetsk Academic Regional Drama Theatre in Mariupol that sheltered civilians (including children), producing graphic images and uncertainty about many casualties"},{"id":"a5a0e63e-a40f-4653-b49f-b08501abfb44","text":"ICRC activated a Central Tracing Agency (family\u2011tracing) bureau to collect information about missing people and reconnect families after the escalation in Ukraine"},{"id":"8b83fac7-c728-4306-a23a-fa7239f16085","text":"CDC and advocacy groups warn that pandemic-related delays in cancer screening and care could produce downstream increases in advanced cancers and mortality"},{"id":"92aedbd2-b062-4251-8a00-dc65bac74d4c","text":"CDC releases provisional life expectancy estimates for 2021 showing a sharp decline in U.S. life expectancy"},{"id":"c0188ef1-6375-4482-98b4-030fb26f3e5a","text":"OSCE SMM reporting of civilian casualties at/near checkpoints in Donetsk/Luhansk (2019 summaries)"},{"id":"b0b293e8-0639-41aa-b1a3-39f70d6c4033","text":"Karlivka (Karlivka/Karlivka area) checkpoint ambush and fatalities"},{"id":"c97a3438-9ff1-491b-a8e6-64b881df842a","text":"Volnovakha bus attack near a Ukrainian checkpoint (passenger bus hit)"},{"id":"0b41f824-fa87-4638-b004-e5ce1e8425a8","text":"Earlier (March\u2013April 2014) incidents where pro\u2011Russian activists raised Russian flags on government buildings in eastern Ukrainian cities (e.g., Kharkiv, Donetsk) were widely photographed and reported."},{"id":"b2c435b6-21f1-4e3e-9b9e-70fd33a7816e","text":"Official visit of Bulgarian President Rosen Plevneliev to Kyiv (July 7\u20138, 2015) \u2014 Bulgarian flags and official decorations were displayed in central Kyiv for the visit."},{"id":"b4054bff-2507-43d7-aafc-6ffe90087e86","text":"President Barack Obama met and publicly expressed support for Petro Poroshenko in meetings around mid-2014 (e.g., June 4, 2014 meeting during Poroshenko\'s European visits)."},{"id":"ee09ba8a-7d35-40f4-8c9a-596a029c42cf","text":"Poroshenko repeatedly and publicly vowed to restore Ukrainian control over Crimea (kept the topic in headlines through 2015)."},{"id":"f73719c7-0c81-4646-8507-3d12750a599b","text":"Deputy Foreign Minister Olena Zerkal interviewed by the Financial Times, saying the EU delay on visa\u2011free travel \'feels like some kind of betrayal\'"},{"id":"625c1b7f-d304-4eb3-bfaf-a0c0a690ca38","text":"EU\u2011Ukraine summit and statements in late November 2016 confirming Ukraine had met visa\u2011liberalisation criteria but formal implementation remained pending"},{"id":"aba98aef-afc1-4471-a4a7-7dde428a52b2","text":"CDC review and guidance on COVID-19 vaccine administration errors and deviations"},{"id":"22f5e4e6-4a0e-4665-a396-03104cfc11d4","text":"Foreign particles found in Moderna vials in Japan leading to batch suspension and recall"},{"id":"b379680b-f10c-4990-be8d-21679d10a1fb","text":"EU REACH restrictions on hazardous substances in tattoo inks came into force and ECHA held an industry webinar explaining implementation."},{"id":"3f3e0fb1-eae8-4080-bf01-d3e1fff5f2f2","text":"Peer-reviewed analysis identified hexavalent chromium (a known carcinogen) as an impurity in some tattoo inks and discussed dermal exposure risk."},{"id":"0164cbdb-5835-494f-bea8-4b0f499cbdbf","text":"FDA warning letter (Ambaya Gold, Dec 5 2023) naming products promoted with claims that clinoptilolite (zeolite) \'removes heavy metals\' and warning the company about unapproved/misbranded therapeutic claims."},{"id":"50755e27-77b6-427f-93dd-a87731a11646","text":"UNHCR report documents extensive \'collective centres\' for internally displaced people in Ukraine"},{"id":"d4c1d571-a06c-4ee5-91dd-4159cee958ba","text":"Widespread, dramatic coverage of refugee \'camps\' in Europe (Roszke, Hungary) during 2015 crisis"},{"id":"512e237d-55d7-490d-85d4-0108fd54bbe8","text":"Regulatory findings and widespread media coverage in March 2021 that the AstraZeneca vaccine was associated with very rare clotting events (VITT) and subsequent safety reviews."},{"id":"8a7c278b-a05a-47e5-a782-f333e3abd311","text":"Ukraine\'s state rail company suspends passenger and cargo train services to Crimea"},{"id":"3719c3d8-be42-4a6d-aea6-0faa841a3224","text":"U.S. provides non\u2011lethal aid including Humvees to Ukraine (March 2015 announcement)"},{"id":"463e2730-3293-4e8d-b87b-d16f9fde8c30","text":"Western-led training and re-tooling exercises with Ukrainian forces reported (early 2016 coverage)"},{"id":"39d81057-c893-47a6-afa4-6c36c27b7236","text":"U.S. State Department approves sale of Javelin anti-tank missiles to Ukraine"},{"id":"f88219d8-400c-4903-9cf1-aaf5dc8c6ce1","text":"Reports that separatists and Russian\u2011backed forces captured equipment from Ukrainian units"},{"id":"231bd0ea-a301-44d9-a0fd-8b1f75fb9a13","text":"Early\u2011post\u2011Crimea (March 2014) statements by Transnistrian officials (e.g., Mikhail Burla) requesting accession to Russia and broader media discussion that Transnistria might be a candidate for \u2018the next Crimea.\u2019"},{"id":"0781a0fb-13c1-4dac-8c1c-fbccebd5d447","text":"Reports of foreign/black particles found in some Moderna vials in Japan, triggering recalls and headlines (September 2021)."},{"id":"f134ec02-dc6c-40cd-af19-e83401adec30","text":"Early pregnancy\u2011safety surveillance of mRNA COVID\u201119 vaccines reported no safety signal in vaccinated pregnant persons (v\u2011safe/pregnancy registry; NEJM preliminary findings, June 2021)."},{"id":"73ce06b7-ecbd-4700-b340-1fae1a530920","text":"UN OCHA Situation Report No.5 documenting rising fatalities and urban combat around Donetsk"},{"id":"37be92fe-4739-4a8d-a3a8-9967c770e07b","text":"Ukrainian and international leaders publicly warned that explosives or sabotage could threaten Dnipro dam infrastructure (public warnings and diplomatic appeals, Oct 2022)"},{"id":"f36fd863-41fb-4892-8b41-fa4f145056b2","text":"Russian forces captured the Kakhovka (Nova Kakhovka) hydroelectric power plant on the Dnipro early in the 2022 invasion"},{"id":"75e474b7-52a7-4ce0-93d3-5c5b15d37224","text":"Satellite imagery and reporting showed Russian forces building pontoon/ferry crossings across the Dnipro in Kherson region (summer 2022)"},{"id":"87bdf665-a018-48bc-b1bb-90ecd420038c","text":"Reports that the Russian-held Nova Kakhovka dam was damaged by shelling (reported in Russian media) and experienced operational problems"},{"id":"6f78ac5b-4203-4c69-a66e-58f34b29e192","text":"Ukraine stopped water flow to Crimea via the North Crimean Canal after Russia\'s 2014 annexation (closure and water cut-offs widely reported)"},{"id":"46ee1a0b-a0b7-49f9-8b25-48fbc78eec74","text":"Public political downplaying of COVID-19 risk (early statements by high-profile politicians, March 2020)"},{"id":"a64fb6fe-0fc8-43ff-8d37-977d9877692b","text":"Stanford (Santa Clara) seroprevalence preprint (Bendavid et al.) suggesting many more infections and lower IFR (April 2020)"},{"id":"b146c3bc-b08a-4983-be17-739e144ab07a","text":"Release of the NIPCC report \'Climate Change Reconsidered\' (Heartland Institute / Nongovernmental International Panel on Climate Change)"},{"id":"6fe08ef8-5a44-4e36-84d5-fded1981aaea","text":"Jacques Attali\'s well\u2011known public profile (former special adviser to President Fran\xe7ois Mitterrand, prolific author and commentator) and periodic controversial commentary on euthanasia/ageing (often cited out of context)."},{"id":"5d2dd122-64ca-430f-8ef0-a4833c97a70c","text":"World Economic Forum launched the \'Great Reset\' initiative (public messaging beginning June 2020)."},{"id":"87ec48c4-b7e0-4dda-b630-292aba0fe9ad","text":"Poroshenko cut short his Davos visit to return to Ukraine amid a \'worsening situation\', as reported by multiple outlets."},{"id":"b79ffa68-6e5b-440f-90cc-fa63873d6110","text":"Students and activists disrupted and booed high\u2011profile figures at Zurich university events earlier (notably Sepp Blatter at ETH Zurich in November 2014)."},{"id":"5c4118aa-ea83-4a17-94be-41b87f24e9e2","text":"Protests and demonstrations around the World Economic Forum in Davos (anti\u2011WEF/anti\u2011globalisation actions) were occurring and widely reported in mid\u2011January 2015."},{"id":"05eac3b3-ebba-40d5-90e8-e137e96d3021","text":"WHO mission on tuberculosis control and human rights in Ukraine"},{"id":"f29f0dfd-548c-4256-b7b3-e1a619c23c14","text":"IMF approves a US$17.5 billion Extended Fund Facility for Ukraine"},{"id":"be9ee0b6-56dc-4278-bde1-49d32891bb4f","text":"Euromaidan protests escalate and government change in Kyiv"},{"id":"755794e1-02c5-4711-b795-71a6f11e2345","text":"Recent public casualty statements by Ukrainian leadership (e.g., Zaluzhnyi referenced cumulative losses) created uncertainty about true figures."},{"id":"431df094-aa85-427f-a056-e553a0b60b40","text":"High-profile extreme-event attribution coverage just before the campaign date: World Weather Attribution/Oxford analysis (published 2 August 2019) concluding the 2019 European heatwave was made far more likely by human-caused climate change."},{"id":"50cb179b-a08b-466c-8c5b-1a1879c7fc80","text":"Early March 2019 tornado outbreak across the U.S. Southeast (notably March 3, 2019) produced lethal tornadoes and extensive coverage of storm damage."},{"id":"ba04f4a7-d816-4938-8fb3-f9075b90b071","text":"Publication/coverage of studies emphasizing that the Medieval Warm Period was not globally synchronous (e.g., Columbia Climate School coverage of regional MWP findings)"},{"id":"5b999078-8c20-41b4-8f1a-0aa73a32b435","text":"IPCC Fifth Assessment Report (AR5) release, including past\u2011millennium reconstructions"},{"id":"7c3be797-44d5-4e4f-b318-d24f976e74ec","text":"Longstanding local debate in Lviv about the fate of Soviet-era memorials and periodic proposals to repurpose or relocate elements of the Hill/Monument of Glory (discussion ongoing for years prior to 2017)."},{"id":"9a7b32ab-adad-4f12-a6d6-9303b5436a96","text":"Passage and signing of Ukraine\'s \'decommunization\' laws that required removal of communist symbols and monuments."},{"id":"15a96114-e2bd-485c-aa5d-b964e9f557d5","text":"Lviv City Hall press office statement denying plans to dismantle the monument, noting the site was fenced off because it was in poor condition and that a committee would make recommendations."},{"id":"9f7a7753-8a9a-46c9-8cb8-efe4ed91f99e","text":"Russian airborne assault and fighting at Hostomel (Antonov) Airport"},{"id":"6b55a69b-e063-423b-b214-33e4d517fc9f","text":"Ilovaisk encirclement (\'Ilovaisk cauldron\') and heavy Ukrainian losses in August 2014"},{"id":"e1132d0a-c744-45d4-b6e4-4608e9abdeab","text":"Authoritative trackers (e.g., New York Times / Johns Hopkins) showed a sustained period of daily new-case counts above 100,000 in early\u2013mid November."},{"id":"2c6b89e1-e849-4daf-83a2-ed6eef4731fd","text":"IPCC Sixth Assessment Report (Working Group I) release asserting strong human attribution for recent warming"},{"id":"fe43aed4-9f28-4fc4-b48c-9489789f7459","text":"Publication and media coverage of studies showing \'global greening\' connected to CO2 fertilization (widely reported from 2016 onward)"},{"id":"aa857a91-bc00-438a-a783-6a2f7a4230e2","text":"Japan suspended and recalled Moderna COVID-19 vaccine batches after foreign particles were found (September 2021)"},{"id":"c62cf8da-abf3-43bf-94cc-e12ff7085cc2","text":"FDA approval of JYNNEOS (smallpox and monkeypox vaccine)"},{"id":"6517a7fb-4a3b-454e-a3af-f52a9e6f5199","text":"NTI published summary/report of the 2021 tabletop exercise"},{"id":"a6568a79-5d7d-40ab-a6ff-612ccd37292f","text":"Historical arson attacks and anti-refugee incidents in Germany (e.g., Bautzen fire of Feb 2016)"},{"id":"45646d38-96b8-4175-8594-8b2a0b3c72d1","text":"Court orders and litigation over giving ivermectin to hospitalized COVID\u201119 patients (notably a widely reported Ohio case)"},{"id":"4bee0fdf-d6c3-4441-8326-91778e5e490e","text":"Authoritative explanations that FDA does not regulate the practice of medicine / off\u2011label prescribing (Congressional Research Service and longstanding FDA position, 2021)"},{"id":"8d653be1-298c-4b9d-b6ad-ee802b9bbaf0","text":"European Union places Vladislav Surkov on sanctions list in response to the Crimea/Ukraine crisis (EU decisions, March 2014)."},{"id":"c70af5b9-8ff9-47dc-8923-58d2a3de24c2","text":"Victoria Nuland\'s public visits and meetings with Ukrainian leaders and opposition figures in Kyiv (February 2014)."},{"id":"0a95aae4-dc65-4e88-a746-6b0ccc441a7b","text":"NATO Wales Summit adopts the Readiness Action Plan and publicly increases reassurance measures for eastern allies (Wales Summit Declaration, September 2014)."},{"id":"0dc997c4-c48b-4969-b36a-a7b3f9b227d3","text":"Minsk II \'Package of measures\' signed, setting a ceasefire and political roadmap for Donbas."},{"id":"878f60f7-2c9c-456b-bd0a-98b48d713d6b","text":"Self-proclaimed Donetsk and Luhansk \'people\'s republics\' declared independence and maintained de facto control over parts of Donbas."},{"id":"32cd072d-1d55-46c3-9fcb-967982981b41","text":"EU establishes the East StratCom Task Force (EUvsDisinfo) to counter Russian disinformation (and documents active Russian information operations)."},{"id":"9e4e2c61-938a-47d9-8d90-f15250db1a88","text":"Volodymyr Zelensky stars as a fictional president in the TV series \'Servant of the People\' (premiered 2015)."},{"id":"88c9155f-d83c-4a5a-bd85-300b457d50b0","text":"UNHCR and humanitarian organizations published operational data and guidance in March 2022 showing how displaced Ukrainians were being registered and assisted across multiple countries (including coordination with Russian Red Cross in Russia)."},{"id":"fb36dc49-7f11-4386-9852-41847d1f0cd1","text":"Russian Human Rights Commissioner Tatyana Moskalkova publicly denied forced transfers and Russian media cited large numbers of Ukrainians having gone to Russia (statements reported in mid\u2011April 2022)."},{"id":"18657478-bf97-495b-b772-5db4e7bf42e3","text":"U.S. State Department and other governments maintained high-level \'do not travel\' advisories for Ukraine"},{"id":"9faa1b2f-3604-464c-82bc-dcc620f3be67","text":"UNHCR published guidance and cautioned about voluntary return amid ongoing safety, protection and infrastructure concerns in 2023"},{"id":"ab7b07e9-0211-423f-807a-5eaf90fcbc3b","text":"Kyiv\'s mayor reported that a large share of the city\'s population fled after the Russian invasion"},{"id":"62fb3a39-8949-44f1-aa76-ead5da769f4d","text":"Widespread Russian strikes damaged Ukraine\'s energy infrastructure, causing prolonged blackouts in Kyiv"},{"id":"b1a06f5c-9114-4179-893a-dd7aa8909812","text":"University of Turin\'s publicly available rules on recognition of foreign degrees (procedures for evaluating and recognizing foreign diplomas)."},{"id":"349cc3b2-246e-4b61-b4b8-0b99b9f179d1","text":"Donetsk higher-education institutions continued operations in exile (relocated to central Ukraine) and kept issuing Ukrainian diplomas after 2014."},{"id":"706089a4-2389-45ca-833f-2cb91c20612c","text":"EUvsDisinfo reported that Turin University\'s Department of Economics had admitted a student from occupied Donbas whose degrees were issued by Donetsk National University before 2014."},{"id":"7445b65e-78b0-4696-862f-f23d49d0534f","text":"Documented incidents earlier in the spring where Russian forces impeded or seized humanitarian/evacuation convoys (e.g., capture of drivers and buses at Mangush)."},{"id":"6e6f56e2-0357-4089-a86a-306d5191e154","text":"Repeated breakdowns and contested humanitarian corridors and evacuations in Mariupol during March\u2013April 2022, with both sides blaming each other."},{"id":"5bca25b0-64f2-4e68-9241-834a044e8575","text":"OSCE monitors detained by pro\u2011Russian separatists (multiple incidents, including Slaviansk/Kramatorsk)"},{"id":"59d20052-ccf1-4c25-ad4f-5086069feef5","text":"OSCE monitoring\u2011mission vehicles destroyed in Donetsk (apparent arson attack)"},{"id":"226ceb8b-abf4-44b9-af59-ea096de45e23","text":"OSCE SMM reported nearby mortar impacts and SMM assets struck/damaged (examples of SMM being hit by indirect fire)"},{"id":"c5c758cd-d80a-4980-a891-99320447bccf","text":"Established concerns and reporting about illicit trafficking and unsecured radioactive materials in post\u2011Soviet states (IAEA Illicit Trafficking work, 1990s onward)"},{"id":"3bfef735-f736-4651-b093-622fec87b359","text":"Ukraine relinquished Soviet-era nuclear weapons under the 1994 Budapest Memorandum"},{"id":"ba7e4c8a-4ba4-4438-be04-8079d06e2888","text":"ONS (UK) bulletin: \'Deaths involving COVID-19 by vaccination status, England\' showing monthly age-standardised mortality rates (ASMRs) by vaccination status (including notes that some ASMRs for vaccinated groups were similar to or higher than unvaccinated in certain months)."},{"id":"b9c77f05-bf4b-4ac1-aa19-d41b8f87ffa8","text":"BBC coverage (Jan 10, 2023) reporting unusually high excess deaths in the UK during 2022 (\'Excess deaths in 2022 among worst in 50 years\')."},{"id":"53564912-43b7-4dc3-b199-27238fc54085","text":"Japan reports and temporary suspension/recall of a Moderna vaccine lot after black/foreign particles were found (late August\u2013early September 2021)."},{"id":"0be6a6cb-99f1-4df2-a393-55d344d7a96e","text":"NOAA releases ERSST version 4 sea-surface temperature dataset (ERSST v4) used in later global surface temperature products"},{"id":"d4ca4811-8423-48d7-8341-7d95c29ca43c","text":"FDA expanded Emergency Use Authorization for the Pfizer\u2013BioNTech vaccine to adolescents aged 12\u201315 (May 10, 2021)."},{"id":"cd239cb6-4ddc-4fbe-b1a3-4efb0781c923","text":"CDC issues guidance (May 27, 2021) acknowledging increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination, particularly in adolescents and young adults."},{"id":"8f093309-41f8-46b7-a897-d0b92c2d89ec","text":"American Academy of Pediatrics (AAP) and Children\'s Hospital Association public report (May 20, 2021) summarizing COVID-19 cases and deaths in children."},{"id":"6ed9017a-8290-483a-b596-237e4d9a8691","text":"Assassination of pro\u2011Russian journalist Oles Buzyna in Kyiv"},{"id":"85f18008-d73c-4be7-a7ef-d9583d4603b6","text":"Reported vandalism of Holocaust and other memorials in Ukraine (2014 incidents)"},{"id":"faaf2a04-99b6-4eda-a468-4babd23b34ed","text":"Widespread toppling/removal of Lenin statues and other Soviet monuments in 2013\u20132014"},{"id":"8e04e7f5-ebfa-4e96-97d6-6daf2585c48b","text":"Publication of the Antarctic Surface Accumulation and Ice Discharge (ASAID) map work/NASA Earth Observatory coverage that reported scientists connecting 3.5 million geographic points to estimate Antarctica\'s icy edge perimeter at ~53,610 km."},{"id":"5f57dd5b-0ae7-40d5-a5ca-9367e781b141","text":"Widespread public misunderstanding of the coastline paradox and map-projection distortions highlighted by reputable outlets (coverage during 2024\u2013early 2025 explaining why complex coastlines can yield large perimeter measurements)."},{"id":"8541b447-be43-4696-b3c3-5bdfa1d5a546","text":"Previous precedent: Russian missile strikes on Ukraine\u2019s energy infrastructure caused large Moldova blackouts in November 2022"},{"id":"97b37768-0d05-4cec-963e-4480131aae91","text":"Voltage collapse on the 400 kV Isaccea\u2013Vulcanesti\u2013MGRES transmission line that Moldova uses to import electricity"},{"id":"f781bac7-dd39-4977-955c-df979d834d8f","text":"Russian Foreign Minister Sergey Lavrov publicly stated federalization was an important component of resolving the Ukrainian crisis (public remarks end of March 2014)."},{"id":"3f72006d-2cca-4708-a17e-4e5d64891aee","text":"Pavel Gubarev proclaimed himself the \'people\'s governor\' of Donetsk and publicly called for a referendum on the region\'s status (early March 2014)."},{"id":"835df69e-1dfc-4ef9-a704-e9ac185f1811","text":"Russia/Gazprom sharply reduced and in places halted natural gas flows to Europe (Nord Stream 1 disruptions) in August 2022."},{"id":"d27385f6-dc81-41f1-bd61-a8d1042beff5","text":"EU leaders and institutions announced plans in spring 2022 (REPowerEU) to drastically reduce dependence on Russian fossil fuels."},{"id":"becfd5d5-1ee9-4d06-80a8-a79a26aa2477","text":"The 7 April 2018 Douma chemical attack (widely reported and later attributed by Western governments to the Syrian government)"},{"id":"4a2448c9-7554-4b09-bd39-f9e0e083b9ca","text":"Discovery and widespread publication of photos and videos showing dead civilians in Bucha after Russian forces withdrew"},{"id":"42458045-832d-4bd1-92d2-d4c694c26f6a","text":"Zelensky\'s public appeals for faster, increased military aid from allies (NATO talks/weapons appeals)"},{"id":"5436c0c4-f842-44ed-8cc7-21090a503ef6","text":"Turkey\'s prior military-technical support to Ukraine (notably Bayraktar TB2 drones supplied in 2021\u20132022)"},{"id":"1cafa29a-dd5f-40e2-9527-b695d279038f","text":"February 2023 T\xfcrkiye earthquakes \u2014 world leaders, including Zelensky, publicly expressed condolences and offered assistance"},{"id":"4237e997-e389-47a7-8c3c-920d420cadd9","text":"AMA, APhA and ASHP issued a joint statement (June 23, 2020) noting FDA review and actions regarding hydroxychloroquine and other COVID-19 medications."},{"id":"eb87c822-aa00-40d8-9132-8436825cc3b6","text":"Regulatory and industry safety reviews of wild yam (Dioscorea villosa) and public-facing summaries cautioning that wild yam extracts have hormonal activity and are not proven to treat fibroids."},{"id":"061f2a7f-a450-490d-8a05-29766f1c9832","text":"Early reports of allergic and other adverse reactions after initial COVID-19 vaccine rollouts (for example, two NHS workers had allergic reactions after Pfizer shots in the UK)."},{"id":"5b910185-927d-4126-ad30-34c4c4e875ac","text":"Public reporting that several COVID-19 vaccine candidates used historically derived human fetal cell lines (HEK-293, PER.C6) in development/manufacture."},{"id":"c01d4753-8ca2-4cc3-b5fa-d6582dc6d580","text":"UK \'Homes for Ukraine\' sponsorship scheme launched, enabling rapid arrival of large numbers of Ukrainian refugees to the UK (scheme launched 14 March 2022)."},{"id":"2a90d6e5-3007-4530-9648-5f391357af33","text":"Russian leadership publicly framed the invasion as needing to \'denazify\' Ukraine (Putin\'s rhetoric from late February 2022 onward)."},{"id":"7aba1bf9-7b64-4cd3-be68-21f773aecd32","text":"Multiple reported incidents of swastika vandalism and a May 2022 prosecution for carving swastikas in a London shopping centre (Westfield) received local/national coverage."},{"id":"80eab844-5ee7-4d91-b64d-53159cfca350","text":"CDC reinstated recommendation on July 27, 2021 that fully vaccinated people wear masks in public indoor settings in areas of substantial or high transmission (mask guidance change due to Delta)."},{"id":"846a8102-f54e-45d8-af36-9011340fc325","text":"Israeli public-health reports in July 2021 showing decreased Pfizer-BioNTech effectiveness against infection with the Delta variant (while remaining strong against severe disease)."},{"id":"1aa4a657-e845-4ac3-8dad-66938da4aa28","text":"Japan suspended and recalled Moderna vaccine batches in late August\u2013early September 2021 after discovery of foreign (stainless steel/black) particles in some vials."},{"id":"70ea83d9-60d5-4779-baa5-92ec4617ee80","text":"CDC MMWR report (published May 28, 2021) documenting COVID-19 vaccine \'breakthrough\' infections occurring January\u2013April 2021 and announcing a change in CDC surveillance focus."},{"id":"c3b5f389-950a-448e-a93b-cbc1155537cf","text":"IARC/WHO evaluation classifying formaldehyde as a Group 1 (carcinogenic to humans) agent (IARC working group meeting, 2004)"},{"id":"05266523-2b9f-4ee2-94d2-77d005fa5d9e","text":"CDC Vaccine Excipient & Media Summary (Pink Book Appendix B) listing ingredients and substances used in vaccine manufacture (publicly available CDC excipient table)"},{"id":"19c0c942-6db9-406c-9807-f992d3e1b895","text":"1999 joint statement by the American Academy of Pediatrics and U.S. Public Health Service (reported by CDC) calling for removal of thimerosal from childhood vaccines as a precaution"},{"id":"038a37c6-587a-4f25-a13b-0060d10e76b6","text":"Pause of high-profile vaccine trials (AstraZeneca paused global trials after an unexplained illness in a participant)"},{"id":"7d607d2b-c2b4-41c0-80d6-59cc1f874fad","text":"Public revelations (2015) that climate contrarian Willie Soon received substantial fossil-fuel industry funding."},{"id":"d7b28e21-78df-411a-bb94-fcad5275b2a2","text":"Major publishers (e.g., Springer Nature) publicly stated policies that AI tools cannot be credited as authors (January 2023), sparking debate over AI authorship in science."},{"id":"ebe94c24-895e-44db-a93b-e32d2ab0659b","text":"Iran launched missile strikes on bases housing US forces in Iraq (retaliation)"},{"id":"deac6fbe-1f71-4bac-b1b7-c5b1dc0f1774","text":"US drone strike killed Iranian General Qasem Soleimani"},{"id":"7d64a856-24be-44dd-a9da-520d2e65c291","text":"Ukraine International Airlines Flight PS752 was shot down near Tehran, killing all 176 aboard"},{"id":"2a79c149-117c-4238-8185-4e0749498fe5","text":"UN Office of the High Commissioner for Human Rights (OHCHR) report on children\'s rights in Ukraine documenting large numbers of children killed, injured, deported and otherwise affected by hostilities"},{"id":"ec6e8289-3019-4927-8667-3a447ba0d51f","text":"Ukrainian authorities announce \\"Contract 18-24\\" recruitment drive offering one\u2011year voluntary contracts with financial incentives for recruits aged 18\u201324"},{"id":"8e11e6b5-a90f-4e1c-9b23-8c17083004b7","text":"Official Kyiv Eurovision preparations publicized large security measures (10,000 law\u2011enforcement personnel, thousands of cameras, road closures and \'clean\u2011up\' operations)."},{"id":"9b1d093f-de0f-46ef-8565-0e1e1e296258","text":"Kyiv placed under curfew and residents ordered to shelter/prepare to defend the city"},{"id":"0193104e-6045-4742-86f6-04bf99e3c2b1","text":"Airborne assault on Hostomel (Antonov) airport with helicopters and paratroopers near Kyiv"},{"id":"a822948a-1959-4fef-ac9b-454dd71b7ebd","text":"Multiple missile strikes reported on Kyiv and other Ukrainian cities"},{"id":"b7521441-865b-4d5b-8f9e-0fae92ec0a98","text":"Apartment building in Kharkiv shelled; civilian casualties reported (boy killed)"},{"id":"2f4d1d64-a278-4bc2-a3f0-9eefb7d52ec3","text":"Russian President Vladimir Putin announces a \'special military operation\' in Ukraine"},{"id":"ea38c269-5631-4bcc-b8d3-27432d6d205d","text":"Federal court consolidated more than 140 lawsuits against Merck over the Gardasil HPV vaccine into a multidistrict litigation (MDL No. 3036), bringing sustained media attention to plaintiffs\' claims that Gardasil caused serious harms."},{"id":"320f8044-4928-405e-98ad-346aac87e661","text":"Japan\'s Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine in June 2013 (a decision that drastically reduced uptake and has been repeatedly cited in vaccine-safety debates)."},{"id":"500fd674-8c2b-49dc-b3d8-929f25693844","text":"Russian missile strike on Kramatorsk railway station that killed dozens of civilians"},{"id":"fb0ebb50-3e74-49d1-af14-f0368e2f4ccf","text":"President Volodymyr Zelensky requested an extraordinary parliamentary session on May 21\u201322, 2019 to amend electoral legislation, producing a heated parliamentary session and partisan exchanges."},{"id":"3f0cfc3c-6092-41fa-b4e0-4e3a1dc9a762","text":"Opposition deputy Alexander Dolzhenkov publicly threatened to seek repeal of laws on decommunization and the language law during the May 22 debate, prompting Parubiy\u2019s defensive remarks."},{"id":"15c1dfe3-0363-4cff-be4f-224832389ab8","text":"Andriy Parubiy\u2019s May 22, 2019 parliamentary remarks including the line \'You think the smell of revenge is in the air? Smell it! It\u2019s the smell of burning tires.\'"},{"id":"19c8dceb-ba49-4083-9bd2-9bf694c04895","text":"Kerch Strait incident where Russian forces seized three Ukrainian naval vessels and detained crews"},{"id":"850ae654-2d8d-49c3-9520-1138ba8eb41b","text":"Sea Breeze multinational naval and military exercises hosted by Ukraine and NATO partners in the Black Sea (Sea Breeze 2018)"},{"id":"8b689eb0-99c2-4b6b-bec0-a95434f5c6b5","text":"U.S. approval and delivery of Javelin anti-tank missiles to Ukraine"},{"id":"bf4001ea-43c2-406d-a13a-2b8b6cad0303","text":"Formation and integration of volunteer units such as the Azov Battalion into Ukraine\'s forces (2014 onward)"},{"id":"e059f732-82f9-4913-a509-434e9c5747cd","text":"UN Human Rights Office report documenting multiple arbitrary arrests, detentions and prosecutions in Russian\u2011occupied Crimea"},{"id":"bd7254eb-60f0-4a5a-9010-4872e83eb688","text":"Fitch Ratings sovereign rating actions and downgrades around the 2014\u20132015 crisis (example: Feb 13, 2015 Fitch rating action)"},{"id":"66017d11-b8de-45e4-97a0-4407d199553e","text":"IMF statement concluding the 2016 Article IV consultation with Ukraine (April 3, 2017)"},{"id":"3e187232-2098-4d5a-9214-b01fb3db2fd2","text":"Iran announced arrests related to the downing and police cracked down on protests over the incident."},{"id":"38608f01-edd3-4b98-bf21-80f5ae498ba3","text":"Ukraine International Airlines Flight PS752 was shot down shortly after takeoff from Tehran, killing all 176 aboard."},{"id":"e4eb03db-324c-497b-b470-d26162590c0d","text":"Reporting noted many passengers were Iranian nationals, students and researchers (including academics), and several countries pressed for answers about passenger lists."},{"id":"38b8faf4-24b6-4c13-8487-555b40638b4a","text":"EU published COM(2017)235 (12 May 2017) \u2014 a strategy to step up the fight against illicit tobacco trade affecting eastern EU borders"},{"id":"c8d99fb4-a377-4d8c-9a97-646b22b0a25c","text":"Poland and Ukraine signed a memorandum on cooperation for the Via Carpathia transport corridor (signed Oct 22, 2017) and media reported growing cross\u2011border freight volumes"},{"id":"7d0eea2c-fa47-4916-a830-68d3b0a9a8e6","text":"Ukraine\u2019s Infrastructure Minister Volodymyr Omelyan publicly discussed bilateral transport permit numbers (citing ~10,000 Polish permits for Ukrainian carriers) in the same period"},{"id":"142e6f0f-66ee-4e30-8fb6-5d1231933c62","text":"Former Ukrainian Transport Minister Yevhen Chervonenko said on ZIK TV thousands of trucks were stuck on Ukraine\u2019s western borders and could not enter Europe"},{"id":"b4b93ab7-a67d-477c-98ef-76796d962b14","text":"Amnesty International press release calling on Ukraine to stop abuses by pro\u2011Ukrainian volunteer battalions (Aidar, etc.), citing unlawful detentions and summary killings."},{"id":"59a2e99c-785e-4708-9cab-e248cdc6dd5f","text":"Office of the High Commissioner for Human Rights (OHCHR) report documenting egregious human\u2011rights abuses in Donetsk and Luhansk, including killings, abductions and restrictions on movement."},{"id":"53df0d0e-5777-43a7-b6a5-13dbe796107c","text":"OHCHR/UN press release (2 March 2015) reporting that the death toll in eastern Ukraine had crossed 6,000 and documenting civilian casualties and impediments to people leaving conflict areas."},{"id":"8dda944c-daf5-4de1-abd2-519df4af39a7","text":"Election of Andrzej Duda as President of Poland (conservative, Law and Justice party) in May 2015"},{"id":"7672a79d-ae4d-4dd0-a071-2e0e0ffc6d1c","text":"Public reporting and leadership statements about slow or delayed Western arms deliveries to Ukraine (widely covered in mid\u2011September 2024)."},{"id":"6352eb6a-310e-4990-aa9d-97fb6f01ca44","text":"Serhii Sternenko\'s profile as a high\u2011visibility Ukrainian activist with prior legal controversies and a large social following (making him a frequent target for smears and falsified attributions)."},{"id":"ee405ef0-07c3-43ed-a7a1-315200fbb76f","text":"EMA Article\u201131 referral and EU-wide review of combined hormonal contraceptives (procedure started Feb 2013; review communicated Nov 21, 2013)"},{"id":"40bf4e92-c095-4b70-949c-2ce4acdf7675","text":"UK Drug Safety Update / MHRA communications and updated patient/prescriber leaflets on CHCs and VTE risk (published March 2014 and accompanying materials)"},{"id":"8e8e10a5-f251-4923-9aec-713685c45ce4","text":"European Commission adoption of legally binding decision to update CHC product information (decision adopted 16 January 2014)"},{"id":"2685e2d0-c53b-4131-873c-e4506a1f0397","text":"1995 UK \'pill scare\' \u2014 Committee on Safety of Medicines advised that pills containing desogestrel/gestodene were linked to doubled VTE risk"},{"id":"2b7f1d81-e1c8-41a2-89d6-d34c18e9e551","text":"Large-scale lawsuits and media coverage alleging manufacturers downplayed clot risks from newer contraceptives (Bayer Yaz/Yasmin settlements reported 2012)"},{"id":"7c174032-c3d6-4588-a644-ec1743e86a8c","text":"Publication of a review summarizing research into engineered/measles-based oncolytic viruses as cancer immunotherapy (\\"Measles Virus as an Oncolytic Immunotherapy\\", PMC review)."},{"id":"473dea4a-3002-4416-a691-6b01312e1875","text":"Andrei Makarevich performed charity concerts for displaced children in eastern Ukraine (Slov\'yansk/Svyatohirsk)."},{"id":"860458dd-eabd-4f82-952f-5ddb0e5ba089","text":"Makarevich attracted hostility earlier for publicly showing pro\u2011Ukrainian symbols (attending a Moscow peace march wearing Ukrainian\u2011coloured ribbons)."},{"id":"71d4a8ff-625e-4525-a6ab-860eefb4532d","text":"Prominent pro\u2011Kremlin politicians publicly denounced Makarevich and called for stripping his state honors."},{"id":"be7102cb-0b57-4bc1-9d3a-f4ab5e05daf7","text":"Clashes between Polish and Ukrainian football fans at Euro 2016 in Marseille (physical fights and arrests ahead of the Poland\u2013Ukraine match)."},{"id":"0316ccf9-6f70-4db7-8f6b-5b8c19d9d765","text":"Media reporting in 2016 of rising xenophobia and harassment directed at Ukrainians in Poland."},{"id":"54d4e00f-cf3a-42e9-a73b-ea9d732d99cd","text":"Visible growth of far\u2011right and nationalist street movements and demonstrations in Poland during 2016."},{"id":"d4c4d200-1d08-4c8e-a9dd-35eda11cdfaf","text":"Hamas attack on Israel and mass abductions created a large population of hostages and distressed families"},{"id":"44069781-87ef-498a-99ba-22f1d64541a8","text":"Publication of a large South Korean retrospective cohort study in Biomarker Research reporting associations between COVID-19 vaccination and increased one\u2011year risks for six cancer types"},{"id":"88e2c9e1-bfa1-4d99-a82c-318741c224f9","text":"FAO and other UN agencies warned of global food impacts from the Ukraine conflict and launched efforts to save Ukraine\'s harvest and keep exports flowing"},{"id":"05729b15-4eb7-4f82-a0b8-028aab48cbfe","text":"European Union temporarily lifted import duties / quotas on Ukrainian agricultural products to support Ukraine\'s economy"},{"id":"e9d64a2b-a2bd-41aa-a143-f2c539d9bfee","text":"Signing of the UN\u2011brokered Black Sea Grain Initiative (Istanbul) enabling safe maritime export corridor from Ukrainian ports"},{"id":"947907d3-1145-4f78-ac7c-d6cab87838c1","text":"Human rights reports documenting abuses by both separatist forces and Ukrainian government forces (Human Rights Watch / Amnesty reports, 2014\u20132015)"},{"id":"83dbeb35-e014-4551-966a-5f97f62c8308","text":"Polls reporting that many Ukrainians characterized the Donbas fighting as an \'intrastate\' or internal conflict (KIIS / Democratic Initiatives Foundation, October 2015)"},{"id":"1b1b77c7-882b-4e3f-bba9-1f841f27246c","text":"Signing of the Minsk II agreements (February 2015)"},{"id":"e2d654e4-dbb7-4eb1-97ec-2e7d3c55c4ac","text":"Self\u2011declared independence referendums and proclamations by Donetsk and Luhansk \'people\'s republics\' (May 2014)"},{"id":"bd31ef10-7bcd-4b4c-b37c-4a3b59cc3763","text":"WHO published a public timeline of COVID\u201119 events (WHO timeline) summarising early December 2019 detection milestones"},{"id":"ee4850dd-7ffb-488a-8195-1b9ae464b1e7","text":"News reports (May 4\u20135, 2020) that a French pneumonia sample from December 27, 2019 later tested positive for SARS\u2011CoV\u20112"},{"id":"219e1b1c-8243-46cd-ac04-413e5b148da6","text":"European Union launched Permanent Structured Cooperation (PESCO) to deepen EU defence cooperation (formal decision adopted Dec 11, 2017)."},{"id":"ba602c99-8f43-4cd6-b850-ff63349886b1","text":"U.S. imposed tariffs on steel and aluminium (March 2018) and the EU adopted retaliatory measures."},{"id":"9d543810-cd90-4ea8-9a60-e10f583ca1d0","text":"President Trump ordered the withdrawal of U.S. troops from Syria (announced Dec 19, 2018)."},{"id":"76a2ce33-876f-41ad-be02-4b81d4ed8b2f","text":"President Trump publicly berates NATO allies at the Brussels summit, warning the U.S. might \'go it alone\' if allies do not meet defense spending targets."},{"id":"05ab73c2-13ed-4c61-9755-a7404dfd3d9d","text":"U.S. announced it would withdraw from the Intermediate-Range Nuclear Forces (INF) Treaty (six\u2011month notice given Feb 2019)."},{"id":"72686c67-9f6f-4d0a-b620-e6f21ba98772","text":"Ukrainian carrier Supernova reported to have received permits to operate scheduled Lviv\u2013Prague and Kyiv\u2013Prague routes (announced in media)"},{"id":"4421bcf8-b453-4431-ab63-16355715a87a","text":"European (EASA) Part-TCO authorization for Supernova Airlines announced"},{"id":"d1e22a56-4fb4-48ea-8923-c7fd6cfda446","text":"European Parliament / EU analyses and statistics showing significant trade and energy interdependence with Russia (2014\u20132017 trade data and briefings published in 2017)."},{"id":"6aa639db-03c0-4b01-9fbc-777e189f69c0","text":"Campaign and political support in parts of Germany and among some EU businesses for the Nord Stream 2 gas pipeline (prominent coverage and analysis in 2016)."},{"id":"2ace17d3-8f02-490e-b49d-2b64f09dd61a","text":"CDC/ACIP recommend use of the updated (bivalent) COVID-19 boosters"},{"id":"92da8ffe-8e6a-4c30-9fd3-a933e0c7944f","text":"Russian official and media reaction emphasizing Tillerson\'s comments as signaling possible U.S. softness"},{"id":"2060306d-5f4b-41bb-ada9-748a449d8478","text":"Hungary repeatedly raised public complaints and blocked aspects of Ukraine\'s Western integration over alleged mistreatment of the Hungarian minority in Zakarpattia, increasing bilateral tensions."},{"id":"bcf1bd89-e271-4922-887f-bb5f7e70e390","text":"Reporting and analyses documented both an exodus of ethnic Hungarians from Transcarpathia after the 2022 invasion and cases of ethnic Hungarians voluntarily joining Ukrainian forces or local defense units."},{"id":"50f056ee-90f1-422e-a611-e7daa11ac02e","text":"Ukraine\'s Security Service (SBU) and Ukrainian authorities reported Russian information\u2011operations specifically targeting the ethnic Hungarian community in Transcarpathia / Zakarpattia (including spoofed calls and other PSYOPs)."},{"id":"fc25b3c7-be1c-4b96-84cb-69e99ad4c46d","text":"Ukraine imposed wartime restrictions and a de facto travel ban preventing most men aged 18\u201360 from leaving the country after the 2022 full\u2011scale invasion."},{"id":"953c492b-c744-4a84-b213-e9b94428c223","text":"Alfa/Leopolis Jazz Fest was scheduled and ran in late June 2017 (festival dates June 23\u201327, 2017), contrary to claims of cancellation."},{"id":"1c00f5d4-6fe1-4dbc-ac7a-45c85eeb3e41","text":"Reuters photo/coverage showing volunteers cleaning piles of trash in Lviv in the days before the festival (coverage dated June 21, 2017)."},{"id":"a71b831a-178e-4862-9a84-511f15e6709d","text":"CDC MMWR report on large Delta-era outbreak in Provincetown, Massachusetts with many breakthrough infections among fully vaccinated people"},{"id":"e3500e27-e888-4724-a6b4-5960e5f31fed","text":"UK Health Security Agency vaccine surveillance reports showing sharp drops in vaccine effectiveness against symptomatic Omicron infection after two doses"},{"id":"88fb0996-ffb1-445c-9668-1dcff6819ee4","text":"Pfizer\u2013BioNTech phase 3 trial press release reporting ~95% efficacy"},{"id":"e1657114-b637-4214-876d-1c44cbd5f35a","text":"NEJM national Israel study showing measurable waning of BNT162b2 protection over months (Delta wave)"},{"id":"ae33c0c0-db6b-42ae-aa47-975f070d66a6","text":"Pfizer\u2013BioNTech press release reporting markedly reduced two\u2011dose neutralization of Omicron and restored neutralization after a booster"},{"id":"24a40309-8f9f-4bd0-a892-5f2c93b2a71b","text":"Publication of IRENA & IEA-PVPS report projecting up to 78 million tonnes of PV waste by 2050"},{"id":"3d4673a3-de27-44d3-a1e5-effb6dc1176d","text":"NREL analysis and surveys showing low recycling rates (less than ~10% of decommissioned panels recycled in the U.S.)"},{"id":"70547dff-f284-427f-879e-9e6023ef461f","text":"BBC article \'Challenge to stop solar panels becoming a \\"waste mountain\\"\' reporting experts\' warnings"},{"id":"67c55d7f-e71d-4611-97f5-3bdb8dfe8633","text":"Right Sector set up roadblocks and staged protests demanding the resignation of Interior Minister Arsen Avakov"},{"id":"29ff471a-38cc-4972-b722-d1604d010a06","text":"Prime Minister Yatsenyuk ordered dismissal/replacement of Zakarpattia customs officers and heads in response to the Mukachevo events"},{"id":"67a93fc9-671c-47e0-aee7-dfb451276b9e","text":"Mukachevo shootout between fighters linked to Right Sector and local police"},{"id":"bcb0a24f-a79e-48e3-8437-97fbd88492f0","text":"Interior Minister Arsen Avakov suspended the Mukachevo police chief and launched an inspection of the regional police force"},{"id":"bf4d637a-e05a-4d3e-a455-88cdf3508e2c","text":"Russian forces seize the Zaporizhzhia nuclear power plant (Europe\'s largest)"},{"id":"dc6827a3-d30d-4619-96df-ff5f48a04539","text":"Russian President Vladimir Putin orders Russia\'s nuclear deterrent forces put on high alert"},{"id":"0a200067-762c-46ac-9ffa-57243ea19fec","text":"President Zelensky\u2019s public address to the Lowy Institute where he said NATO must \'eliminate the possibility\' of Russia using nuclear weapons (speech and Q&A)"},{"id":"2d80d376-920e-4758-a774-6a5040fc0c0b","text":"Reports of Chechen fighters volunteering in eastern Ukraine (Donbas)"},{"id":"42c2c04c-9907-43f9-8431-3121cb83ddd5","text":"Crimean court bans the Mejlis (representative body of Crimean Tatars) as \'extremist\' (April 2016)"},{"id":"ef246cff-ebb6-4e72-9c34-5ca9e92ad60a","text":"European Parliament written question citing concerns about ISIS/Islamist sympathizers in territories disputed by Russia and Ukraine (July 2015)"},{"id":"b9f75f2f-b912-4eb7-a715-2a3476fd4d61","text":"Assassination of former Ukrainian parliament speaker Andriy Parubiy in Lviv"},{"id":"2db0b5e8-a206-476c-aa14-7b391e6b99ad","text":"Odessa Trade Unions House fire (May 2, 2014) and its contested narratives"},{"id":"83a51209-5cc5-4215-b5e9-78fd152529c7","text":"The Federation Council of the Russian Federation approved President Vladimir Putin\'s request to use Russian armed forces in Ukraine."},{"id":"e97875a8-c2b6-4a26-bc2d-30b0ecf2ca4d","text":"Unmarked armed personnel occupied airports, checkpoints and key sites across Crimea (the so-called \'little green men\')."},{"id":"122f4e4d-2e37-49c2-9210-c4159692e31f","text":"Masked gunmen seized the Crimean parliament and other government buildings in Simferopol, raising Russian flags."},{"id":"f49a66da-ca39-46c7-8ccb-816574d6aeee","text":"Crimean parliament voted to hold a referendum (initially set for 16 March) on joining Russia and announced steps toward joining the Russian Federation."},{"id":"f932614e-5d4c-4983-a922-4fb00292c1d4","text":"Large, atypical RSV surges in 2022 (U.S. and other countries) produced heightened public anxiety and searches for home remedies during and after the wave."},{"id":"735005b5-6c0f-4213-9991-80fff97528e3","text":"Ukrainian authorities (SBU / MFA) declared some foreign visitors persona non grata and warned of entry bans after delegations visited occupied Crimea (reported March 2017)."},{"id":"56bf2861-efba-4614-9bf8-f103ed3ce2e3","text":"INTERPOL issued Red Notices at Ukraine\'s request for former Ukrainian officials (including Yanukovych and Azarov)."},{"id":"0b2e1f7a-901a-493e-b33c-49abea435d30","text":"European parliamentarians and other EU politicians (including MEPs) made unsanctioned visits to Russian-occupied Crimea and to separatist-held Donbas in 2015."},{"id":"8c023135-f2cd-4fdb-aaa0-7cb9bfa05242","text":"Release of the IPCC Special Report \'Global Warming of 1.5\xb0C\' (high\u2011profile 2018 scientific assessment)"},{"id":"4063fbc8-7b7d-4331-850a-655023233079","text":"CDC updates mask guidance for fully vaccinated people, recommending indoor masking in areas of substantial/high transmission."},{"id":"3496e957-884e-4e03-b8ca-f518cee17c14","text":"Public Health England (PHE) monitoring and technical reports in mid\u20112021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant compared with Alpha, while retaining strong protection against severe disease."},{"id":"3a18f009-e0b6-4e80-bf48-657ccaa32702","text":"MMWR report on a large July 2021 outbreak in Barnstable County, Massachusetts found that a high proportion of cases were in fully vaccinated persons (reported in late July)."},{"id":"935ed015-beb2-49c7-b3ce-45b73a49fa97","text":"FDA issued Guidance for Industry on \'Characterization and Qualification of Cell Substrates and Other Biological Materials Used in the Production of Viral Vaccines\' (published March 4, 2010)."},{"id":"7dbda8b7-6dc2-4f99-9efd-c4b25f52bec3","text":"Academic researchers (reported March 2010) detected DNA from porcine circovirus type 1 (PCV1) in batches of the oral rotavirus vaccine Rotarix; WHO and other regulators issued interim statements and convened reviews."},{"id":"8a4b0241-342c-4827-8a9e-3613060f8a2e","text":"Historical contamination of early polio vaccines with simian virus 40 (SV40) used monkey kidney cell cultures; exposure occurred in vaccines administered 1955\u20131963."},{"id":"f0d69e4c-dea2-4889-ad46-5b748ccfdb27","text":"Presence of Polish pro\u2011Russia political figures (e.g., Mateusz Piskorski) among \'international observers\' who visited Crimea after the 2014 referendum."},{"id":"22ba4a14-399b-432d-91fb-360385c7bca3","text":"Bill Gates invested in plant-based and cell-cultured meat companies (e.g., Impossible Foods, Beyond Meat, Memphis Meats/Upside Foods)."},{"id":"b9ca7673-b522-478a-9560-bdcbb303a813","text":"Gates-funded research on microneedle patches and \'quantum-dot\' vaccine markers that could encode vaccination history in skin."},{"id":"abfa0f4e-0a36-46e2-b9b4-97e806ceefe5","text":"Development and trials of oral/tablet COVID-19 vaccine candidates (e.g., Vaxart dosing subjects in Phase II trials)."},{"id":"c2a81773-1b1f-43a1-a01f-72b8ee98337d","text":"OHCHR reported lack of access to detainees held by armed groups in Donetsk and Luhansk, identifying numerous detention sites and documenting arbitrary detention"},{"id":"f0f7f5e7-cac1-4f62-bdee-68fbdbcfd4e5","text":"ICRC participated in and confirmed large, complex detainee release/transfers in eastern Ukraine (largest exchange to date in 2017) at the request of the parties"},{"id":"d93f6f6c-3364-44b6-bda3-b17afee0e7ff","text":"Minsk II agreement (Feb 2015) required \'release and exchange of all hostages and illegally held persons\' (principle of \'all for all\')"},{"id":"b338c65b-f306-44ea-b0b0-dd2cf6411423","text":"European Parliament / international reporting on Russian restrictions and de facto blockade of shipping access to Ukrainian ports in the Sea of Azov."},{"id":"d7c58d96-458f-4f49-bf5a-18b1b8b77ae7","text":"Kerch Strait incident: Russian forces fired on and captured three Ukrainian naval vessels attempting to transit the Kerch Strait."},{"id":"4cbc186a-b813-456f-bb6a-e010b138c2ca","text":"Deployment of advanced Russian coastal and air\u2011defense systems (S-400/Bastion/Bal) to Crimea and surrounding Black Sea region."},{"id":"da287e57-b1d7-47c8-b66f-9376a1577d52","text":"IPCC Sixth Assessment Synthesis Report (AR6 SYR) published \u2014 clear attribution of recent warming to human activities"},{"id":"6e955dd5-abae-45ae-b58c-2a25b9bdeacb","text":"NOAA educational page summarising limits of weather\u2011forecast skill (noting 5\u20137 day forecasts are much more reliable than 10+ day forecasts)"},{"id":"71af64b6-cc21-4c97-b9df-d1f091361b50","text":"Publication on multi\u2011centennial Holocene climate variability in proxy records (peer\u2011reviewed synthesis)"},{"id":"bec49b2d-abe0-4438-97ae-8114b1d576d6","text":"Congressional scrutiny and subpoenas over the Karl et al. (2015) NOAA paper (House Science Committee inquiries led by Rep. Lamar Smith in summer\u2013fall 2015)."},{"id":"f9c60b69-b6de-4c88-91b4-2f9ca3baf7b6","text":"IPCC AR5 (Working Group I) reported a reduced rate of surface warming during 1998\u20132012 compared with the late 20th century, noting variability and shorter-term trends."},{"id":"e2cc944e-8a81-4438-83eb-08e38d9b479c","text":"Public vaccine surveillance reports (e.g., UK Health Security Agency vaccine surveillance reports 2022) showing waning vaccine effectiveness against infection and, in some high\u2011coverage populations, increasing proportions of cases occurring in vaccinated people"},{"id":"dbb0569a-302d-4f5c-b3cf-3a621d6d4b2f","text":"WHO classification and global reporting of the Omicron (B.1.1.529) variant showing substantial immune escape from prior infection and reducing vaccine neutralisation (press statement and technical brief)"},{"id":"5146a220-e5e7-48de-9436-17e028427749","text":"CDC confirmation and public communication about rare cases of myocarditis/pericarditis following mRNA COVID-19 vaccination (recognition, safety monitoring and guidance)"},{"id":"188ad611-b2ac-49e2-a256-aa170e3d2b3e","text":"WHO publication and recognition of \'post\u2011COVID\u201119 condition\' (long COVID) with a clinical case definition (Delphi consensus)"},{"id":"4dc240ff-2439-42ae-9041-8ee9ee997a0f","text":"Regulatory authorisations and public announcements of updated (bivalent) COVID-19 boosters for fall 2022 citing the need to match evolving variants (FDA/other regulators authorization and press releases)"},{"id":"4dd8251d-5251-4520-8558-720daed2ff0c","text":"Transparency International / Global Corruption Barometer findings (2016) documenting pervasive corruption in Ukraine"},{"id":"e9675adb-0f21-4945-b4f2-dd37623e09f8","text":"World Customs Organization press release on a large heroin seizure in Ukraine (Odessa/Illichivsk), June 2015"},{"id":"384dfcd4-e781-4db3-90f5-e95202c64b81","text":"Polish government/NGO training and support for Ukrainian forces (Poland offered to train Ukrainian military staff)"},{"id":"3085bd89-d3bb-4c87-a766-de3c40938e9f","text":"Documented reports of individual Polish nationals killed or wounded while fighting in Donbas"},{"id":"ae04d801-546a-4bb5-890c-ef37544c9aee","text":"NATO\'s enhanced forward presence and increased multinational troop rotations in Poland (2016)"},{"id":"915f5621-6d1b-4b9d-aa6d-d4e936f4532c","text":"Contamination reports and temporary suspension of some Moderna vaccine batches in Japan"},{"id":"6f09bd0c-0e65-4bb7-b328-075cce279abd","text":"Regulatory and public reporting of rare myocarditis/pericarditis cases after mRNA COVID-19 vaccination"},{"id":"7d776a28-7b36-4b50-9d79-600c7c814f14","text":"Media reports in late 2022 highlighting rising non-COVID excess deaths (e.g., increased deaths at home and concerns about NHS pressures)"},{"id":"0dea2bad-4966-43e5-9b98-11201c1df71d","text":"2015 transfer of HAARP operations from the U.S. Air Force to the University of Alaska\u2013Fairbanks (publicized as HAARP reopening for civilian research)."},{"id":"4b8c7205-ffdb-4751-b92c-67b4ce7f2008","text":"Reporting on the so\u2011called \\"Havana Syndrome\\" (2016\u20132018) and investigations into possible microwave or directed\u2011energy causes, including a 2018 New York Times piece."},{"id":"b0eb15c0-c4de-4a46-addd-03f1a89f3421","text":"Venezuelan President Hugo Ch\xe1vez suggested HAARP or a \\"tectonic weapon\\" was responsible for the 2010 Haiti earthquake."},{"id":"4f129350-7db8-4427-9b00-04dce5d486ea","text":"Intense Russian airstrikes and attacks on Zhytomyr region widely reported in international media (creating fear of occupation and evacuation)"},{"id":"eeed5b28-33d1-4972-95cb-16d716b43dc8","text":"IARC/WHO press release classifying processed meat as a Group 1 carcinogen"},{"id":"ec1376a1-9b3c-404c-8cd8-9f9902afcb67","text":"Longstanding public-health/home\u2011remedy guidance and consumer health sites recommend salt\u2011water gargles to soothe sore throats (widely available on NHS and similar sites)"},{"id":"d4dc283f-b1c3-459a-bfec-67d2ecc4af27","text":"Previous French domestic plots / trials over assassination attempts on Macron (far-right militants convicted/trialed)"},{"id":"7ebce2cb-ebc2-4687-af49-e93e9583f48c","text":"France announced plans to send long-range SCALP missiles to Ukraine"},{"id":"2a613509-27f3-4c6a-8d5a-53cba97112f0","text":"French presidency postpones Macron\'s planned visit to Kyiv citing security concerns"},{"id":"67125cac-09db-4955-96c3-0b30d5ed593e","text":"IMF approved a large $17.5 billion extended loan programme for Ukraine, making Kyiv dependent on sizeable external financing and programme conditionality."},{"id":"c7818cf5-a11a-46a6-89ad-10c0a908a17c","text":"National Bank of Ukraine unexpectedly raised its key policy rate to 17.5% to combat inflation risks and warned that delays with IMF support posed a risk to stability."},{"id":"ebec5226-e1a3-41dc-aadc-8c4d372988e5","text":"Government nationalised PrivatBank, Ukraine\'s largest commercial bank, to protect financial stability after identifying large capital shortfalls at the lender."},{"id":"f7f20864-e23f-4165-ab6e-b8e2e6f7132a","text":"The hryvnia plunged sharply in 2014 after the central bank abandoned foreign-currency auctions and the exchange rate was allowed to adjust amid political and security shocks."},{"id":"cf3a8103-e2e8-492a-9f1f-a7dd04cc356c","text":"Ukraine\'s President signed a package of laws and administrative measures in late 2015 intended to meet benchmarks for EU visa liberalisation."},{"id":"f1cd3541-52d1-4c2b-b35f-d77cdbb63f03","text":"Ukraine announced introduction of new plastic/passport-card style internal passports to be issued from January 2016."},{"id":"e21d969f-a42d-4c4b-8725-212fe1e8088d","text":"Direct air links and other travel ties between Russia and Ukraine were suspended/curtailed in 2015 (e.g., bans on direct flights announced in October 2015)."},{"id":"64e42c4d-df6b-4b15-b5dc-f14f3b4fc034","text":"European Commission published its final report/conclusions on Ukraine\'s readiness for a visa-free regime with the EU (COM(2015)905) and related publicity in mid-December 2015."},{"id":"41f6a186-93a6-4690-83c2-2d9877871901","text":"Ukraine\'s Finance Minister Oleksandr Danyliuk warns Ukraine may forgo hosting due to high costs and urges sober assessment"},{"id":"51cbcb31-0b5c-4bd7-ae82-dc02ba6017bc","text":"Government announces open national selection for host city and says municipalities/investors/donors must share financial risks"},{"id":"9b854e37-9c9e-4f39-a6a5-816a922b9cbb","text":"Ukraine wins Eurovision 2016 (Jamala) \u2014 international expectation that Ukraine must host Eurovision 2017"},{"id":"2401f7d5-d48e-4e43-9dc9-08014ecfb9ef","text":"White House OSTP releases the Congressionally-Mandated Report on Solar Radiation Modification (SRM) research plan"},{"id":"fbe9998c-0872-4191-9671-4703a96531fc","text":"Mexican government announces a ban on solar geoengineering experiments (SEMARNAT press release)"},{"id":"7489dbad-ad68-456a-a7f1-aad2fd62f893","text":"Israel\'s booster campaign and reporting in July\u2013August 2021 on reduced effectiveness of two doses vs Delta and need for third dose"},{"id":"3c13d2b5-6089-49e4-9322-256539a27b03","text":"CDC reverses earlier guidance and on July 27, 2021 recommends indoor masking for vaccinated people in areas of substantial/high transmission"},{"id":"63985ce7-5217-4874-aa7e-24ca4ef61575","text":"U.S. federal Order requiring masks on conveyances and at transportation hubs (published in Federal Register, Feb 2021)"},{"id":"7361180e-2a2f-4df7-ae35-2f45e047a9e4","text":"CDC MMWR report on Barnstable County (Provincetown) outbreak showing many vaccine breakthrough infections"},{"id":"141eae5a-1061-484d-80c5-2ea0fa66e353","text":"Japan suspended ~1.63 million doses of Moderna vaccine over reports of foreign particles (August 2021)"},{"id":"309aaf99-7ac7-4ac2-abed-8aeacdbab127","text":"European Medicines Agency (EMA) concluded there was a possible link between AstraZeneca\'s vaccine and very rare blood clots (April 7, 2021)"},{"id":"e5390f9e-da3a-4148-80de-bf8344b833d4","text":"NATO publicly said Viktor Orb\xe1n\u2019s planned Moscow trip had been flagged to the alliance in advance."},{"id":"b0d99ec5-93b7-4482-8ede-56df90294fbd","text":"Serbian President Aleksandar Vu\u010Di\u0107 attended Russia\u2019s Victory Day events in Moscow (including presence at May 9 commemorations) and posted images from the trip."},{"id":"3d45140a-ed02-4989-9a2c-1c430911137a","text":"Slovak Prime Minister Robert Fico made a surprise visit to Moscow and met with President Vladimir Putin."},{"id":"b4598419-3888-470c-af66-54e429df15bf","text":"Amnesty International briefing calling on Ukrainian authorities to investigate abuses by Aidar and other volunteer battalions operating alongside regular forces"},{"id":"637e855b-69a7-450a-887a-26e9d48f94ad","text":"OSCE Special Monitoring Mission spot report on civilian fatalities and damage after shelling of residential areas in Donetsk"},{"id":"ddbca3ee-3ce3-4f10-a6be-56733bb2151e","text":"Assassination of Denis Voronenkov, a Russian defector, who was shot dead in Kyiv"},{"id":"e4e829f8-e504-4cee-b1aa-f2baf9a93288","text":"UN General Assembly adopted a resolution (March 2, 2022) overwhelmingly deploring Russia\'s aggression and stating it was in violation of the UN Charter."},{"id":"4376bf3f-5cf3-40a8-8f0c-41c20cad6dc5","text":"Russia formally recognized the independence of the Donetsk and Luhansk People\'s Republics and ordered troop deployments to the regions."},{"id":"4e458c17-6cf6-466b-9154-435a6288efd2","text":"President Vladimir Putin announced a \'special military operation\' in Ukraine, describing aims like \'demilitarisation\' and protection of people in Donbas."},{"id":"88769019-7241-46e9-89a4-31caadd73597","text":"Announcements that Ukraine would open additional consulates in Poland to assist large numbers of Ukrainian citizens/refugees."},{"id":"f572f129-d8bb-4d0f-9092-aa36d5fd0212","text":"Polish President Andrzej Duda visited Kyiv and addressed Ukraine\'s parliament, emphasizing deep political solidarity and saying only Ukraine should decide its future (public statements of unity)."},{"id":"1baeb73c-ac77-4cb4-8916-b2601cef55ba","text":"Earlier Russian security/intelligence figures publicly alleged Polish preparations to annex parts of western Ukraine (remarks by Russian officials reported Nov 30, 2021 onward)."},{"id":"0646c5a9-5c8f-49eb-9cdc-2558df2f7305","text":"Pro\u2011Russian activists in Kharkiv occupied the regional administration and declared a short\u2011lived \'Kharkiv People\'s Republic\'."},{"id":"757568b7-5fb3-450a-a580-24ec7dcfa129","text":"Deadly clashes in Odesa on 2 May 2014, culminating in a Trade Unions House fire with dozens killed."},{"id":"1c591bd1-dbaa-4054-972f-d74e7ab91f32","text":"Parliamentary moves in Feb 2014 to repeal the 2012 \'regional language\' law and intense debate over language rights."},{"id":"aded59d1-81bb-4062-88ec-1b2e1e7280a1","text":"Widespread pro\u2011Russian \'anti\u2011Maidan\' protests and occupations across eastern and southern Ukraine (including demonstrations in Mykolaiv) in March\u2013April 2014."},{"id":"49c572cb-93f0-43ca-967a-98c59897f32d","text":"May 2014 \'referendums\' in parts of Donetsk and Luhansk and subsequent Russian recognition of separatist results."},{"id":"f22893c8-3eff-4926-a412-e01a874ff8ee","text":"Mass drone attacks and reported strikes on Kursk region (fires, evacuations)"},{"id":"62fbb347-74d8-4b62-b3a1-4365c6c770ad","text":"Tymoshenko proposes creation of an \'operative headquarters\' of defense and military specialists to respond to Russian aggression"},{"id":"02047144-2738-4eae-997b-c9787c165309","text":"A draft resolution to dismiss Prime Minister Yatsenyuk is registered in the Verkhovna Rada (parliament) after coalition tensions"},{"id":"2ca134f3-5109-4df4-a29d-3cdda4a037a5","text":"Leader of Batkivshchyna (Yulia Tymoshenko) announces her party is quitting Ukraine\u2019s ruling coalition"},{"id":"352c1b61-38ec-42ec-962a-8f2fda4f862f","text":"Parliament holds and fails to pass a no\u2011confidence motion against Prime Minister Arseniy Yatsenyuk, deepening government crisis"},{"id":"cfbfad32-bf43-45f1-82f7-50acd200b119","text":"National Snow and Ice Data Center (NSIDC) satellite record: Antarctic sea ice reached a daily/seasonal maximum record (20.11 million km\xb2) on 22 September 2014."},{"id":"2d5fa91c-6d11-4f83-a35b-5bad53ec7012","text":"Peer-reviewed synthesis and high-profile press coverage showing Antarctic land-ice (ice sheet) mass loss accelerated in recent decades (IMBIE / Nature analysis publicized June 2018)."},{"id":"11d456c9-0719-478d-aca3-53788064de86","text":"Research identifying the Southern Annular Mode (SAM), ozone\u2011hole effects, and wind-driven ocean processes as major drivers of Antarctic sea-ice variability (peer-reviewed work and reviews, mid-2010s)."},{"id":"21cdf176-577c-473e-a896-32788b43445c","text":"Amnesty International / IBGDH report documenting human-rights abuses and environmental harm linked to cobalt mining in the Democratic Republic of Congo."},{"id":"634f6a08-dbbe-4adc-b386-e4e4cabfe4ec","text":"AP and international reporting on environmental concerns around large nickel/nickel-processing projects for EV batteries in Indonesia (coverage of environmental NGO warnings about mining/processing impacts)."},{"id":"77e453a4-b968-43ee-ba2f-2f8f4f402e47","text":"Major media coverage summarising life\u2011cycle analyses that show EV battery manufacture can be carbon\u2011intensive (New York Times feature on EV battery emissions)."},{"id":"86962d4c-646b-4814-bed6-c43ad623d9f6","text":"IEA Electricity Mid\u2011Year Update 2024 noting faster global electricity demand growth and a temporary plateau in power\u2011sector emissions in 2024."},{"id":"7777291f-bd26-463c-aceb-ef76ba3549fe","text":"IPCC Fifth Assessment Report (AR5) release documenting observed increases in sea\u2011level rise rate and attributing recent changes largely to human influence"},{"id":"c0f58f86-2857-4261-aff7-9ae691852fce","text":"NOAA / national tide\u2011gauge and satellite datasets made public (NOAA sea level trends pages and graphics widely cited in media, 2013\u20132016)"},{"id":"5036018a-13f3-41b2-8d57-c2b8539ee8a8","text":"Visa\u2011free travel for Ukrainian citizens to the Schengen area came into effect"},{"id":"ba84c644-7454-4df8-8b26-8847ed80bb8f","text":"Launch of the European Union Advisory Mission (EUAM) to Ukraine (civilian security reform)"},{"id":"4352707d-d0be-4b31-a45d-0a646b63f2aa","text":"Signing of the EU\u2013Ukraine Association Agreement (including Justice, Freedom and Security provisions)"},{"id":"7bc32684-567d-4629-8d1a-f8d2316ff03f","text":"2008 EFSA scientific opinion sets a tolerable weekly intake for aluminium and warns dietary exposure may exceed it"},{"id":"7b8cb1db-e06f-46ea-9024-40ba0b35f6ba","text":"State-level restaurant COVID\u201119 prevention checklist (published Aug 14, 2020) that included the specific line about inverted face shields for front\u2011of\u2011house staff."},{"id":"142ed585-ebe1-4eaa-a149-9415efcd90f6","text":"Passage and implementation of laws and measures recognizing certain WWII-era Ukrainian nationalist formations (e.g., granting veteran status to surviving members of the Ukrainian Insurgent Army in 2019) and debates about nationalist memory."},{"id":"7dc05c9d-0db8-4449-baee-f75aa2104f1d","text":"Earlier controversy over proposals to \'universalize\' the Babi Yar memorial (design competition and wording), which Jewish groups and historians publicly criticized as potentially downplaying the site\'s Holocaust significance."},{"id":"f4263275-9b32-4ed9-b972-fc6d18183e50","text":"Decommunization laws and large-scale removal/renaming of Soviet-era monuments and symbols (2015) that shifted public commemorations and provoked international debate over historical memory in Ukraine."},{"id":"0f6cce71-8ea2-4fd8-984d-daac4761d8d1","text":"NIA-AA (National Institute on Aging\u2013Alzheimer\'s Association) publishes revised diagnostic framework recognizing preclinical stages of Alzheimer\'s disease"},{"id":"87a6bcaf-9d2f-47e0-bd9f-67b9b1645d88","text":"OSCE Special Monitoring Mission spot reports of repeated shelling incidents in Donetsk city (late January 2015)"},{"id":"201ff659-56bf-4fad-8c16-6c89a915998b","text":"Amnesty International briefing documenting summary/extrajudicial killings in eastern Ukraine"},{"id":"b8d1de50-bd34-4c0f-8aee-fed5d630ee6f","text":"Shelling of Mariupol market and residential areas, killing dozens of civilians"},{"id":"02a296f9-7cb5-40c4-8127-126855d90c32","text":"Reports documented Ukrainian policemen and small military units in eastern Ukraine siding with or defecting to pro-Russian separatists during the spring 2014 unrest."},{"id":"1bd6ec24-448e-4a14-8f18-82099dd796ff","text":"Pro\u2011Russian separatists shot down a Ukrainian military helicopter in late May 2014 and widely publicized battlefield successes and captures."},{"id":"2194d3c4-cf89-4d0e-ae1e-827648bcbe1c","text":"ISUOG/other professional statements discouraging non\u2011diagnostic/\'keepsake\' ultrasound use (position on non\u2011diagnostic ultrasound)"},{"id":"18ddd34a-9fa0-4725-90cb-2d8e26369028","text":"Small clinical study reporting increased apoptosis in human chorionic villus cells after transvaginal ultrasound exposure"},{"id":"6e9d08e7-e9f8-40c8-9f92-dc69836d6373","text":"Reports that politicians and foreign diplomats joined or publicly supported Kyiv Pride 2019"},{"id":"fdddd839-4566-469f-9d0c-0f675b3b4917","text":"Eurovision Song Contest hosted in Kyiv with \'Celebrate Diversity\' messaging (Eurovision 2017)"},{"id":"c2821d80-7208-495d-847c-7f11fb7194a5","text":"Kharkiv region introduced scheduled/rolling electricity restrictions (blackout schedules) for large numbers of consumers after infrastructure damage."},{"id":"50b2f529-578d-47e2-9c73-e314c368fe32","text":"Ukrenergo announced plans to export a record volume of electricity (planned 13,264 MWh) to neighboring EU countries on March 4, 2024."},{"id":"f00928b3-8beb-49ff-a99b-33ba4c9c14f9","text":"Russian missile/drone strikes on Kharkiv energy infrastructure knocked out power across the city."},{"id":"3a67b905-6bc5-4a63-a38a-674a9505a860","text":"Official public messaging (e.g., Ukrainian energy minister and Ukrenergo statements) emphasizing that exports occur only when domestic supply is sufficient and that domestic priority is maintained."},{"id":"f127102b-7adb-4e68-a451-2425dbba1859","text":"National Weather Service offices issued multiple Flash Flood Warnings and at least one Flash Flood Emergency for the Guadalupe River corridor (noting automated gauges and forecasts indicated a large, deadly flood wave)."},{"id":"4e37ba87-f258-4e45-aa42-2637e01fc449","text":"Reports of foreign/black particles found in some Moderna vials in Japan led to temporary suspension/recall of batches (September 2021)."},{"id":"af00b07a-963b-4f13-a913-e5d137abd6bf","text":"Publication of Israeli population-based analyses documenting cases of myocarditis after BNT162b2 (Pfizer\u2013BioNTech) vaccination (peer\u2011reviewed NEJM report)."},{"id":"fe2508ca-6116-4a3d-9737-4aa7db42765e","text":"U.S. FDA and other regulators moved in 2016\u20132018 to restrict or review certain antiseptic/antimicrobial ingredients (e.g., FDA final rule on triclosan and other antiseptic ingredients in consumer wash products in Sept 2016)."},{"id":"1b015b0e-a03c-4937-9823-1bacacf9829b","text":"Ukraine\u2019s State Service for Drug Control recalled 18 products manufactured by the Bioorganic Chemistry Institute\u2019s experimental plant (licensing violations reported)."},{"id":"4b04968a-40d3-40cb-8c8c-0b5c8f8f8725","text":"Public controversy and intense debate around Suprun\u2019s health\u2011care reforms (wide press and academic coverage, including critical and supportive pieces in 2017\u20132018)."},{"id":"ee9c0543-ba4c-4325-86bf-12846a45e075","text":"FDA expanded Emergency Use Authorization for the Pfizer\u2013BioNTech COVID-19 vaccine to adolescents aged 12\u201315."},{"id":"bd97003f-74ba-4fd8-b575-c82690bdbc1b","text":"Discovery of foreign (stainless steel) particles in some Moderna vaccine vials in Japan led to temporary lot suspensions and recalls."},{"id":"23ef675c-fb76-413b-862f-99a1e72bbe7d","text":"Public reports and CDC/ACIP review of rare myocarditis/pericarditis cases occurring after mRNA vaccination in adolescents and young adults."},{"id":"863f8eb6-77ed-4cef-a8fd-1980608e3e64","text":"The Orthodox Church of Ukraine and other Ukrainian church bodies publicly reiterated they do not endorse Halloween celebrations (OCU posted an explanatory statement on its official Facebook page on the eve of Halloween)."},{"id":"710fc521-cb74-480a-9af7-4ec589ecdc6d","text":"WHO and national agencies adopted/issued interim coding guidance and the emergency ICD-10 code (U07.1) for COVID-19 to standardize mortality reporting in Spring 2020."},{"id":"eeefd7e6-0935-4089-a906-74c5a26488f5","text":"Local jurisdictions (notably New York City) added \'probable\' COVID-19 deaths to counts in April 2020, producing sudden, large increases in reported death totals."},{"id":"b1b2ebea-a5ff-4862-8b01-03ef9d085242","text":"Launch of the EU External Investment Plan (EIP) / European Fund for Sustainable Development"},{"id":"f1d018c9-5f57-468e-a553-f54406863636","text":"EU\u2013Turkey migration statement and related migration-management deals"},{"id":"b8abbef3-c963-4eaf-839c-91e40f2a474e","text":"Establishment and deployment of EU military training missions in the Sahel (EUTM Mali)"},{"id":"6cc5144d-233a-4d4f-9640-ad6d90f72bf5","text":"UK Health Security Agency technical briefing reporting substantially reduced vaccine effectiveness against symptomatic Omicron (Technical Briefing, Dec 31, 2021)."},{"id":"a4e248bb-f94a-4156-905d-17848d31e342","text":"Mainstream news coverage summarising Danish results and the impact of boosters (e.g., Reuters coverage, Dec 22, 2021)."},{"id":"85681712-7d60-4155-8edf-867cd1052f0c","text":"Poroshenko publicly sought NATO/allied military cooperation and repeatedly called for allied support at NATO meetings (joint press conference at NATO Headquarters)."},{"id":"3b6b889a-8e36-4d97-a4a7-771df6caa01e","text":"Visible NATO exercises and increased allied air policing on NATO\u2019s eastern flank (e.g., NATO and partner air forces training over the Baltic Sea, April 21, 2016)."},{"id":"404a1fc2-b7e5-42ec-9a0d-c3fbed70fd5a","text":"Frontiers in Microbiology review highlighting mechanisms and clinical interest in manuka honey\'s antibacterial properties."},{"id":"0b0c9c20-af04-44ba-8190-bf7deeebc033","text":"FDA approval of Flucelvax Quadrivalent (cell\u2011based quadrivalent influenza vaccine) and release of package/clinical documents mentioning MDCK cells"},{"id":"75e9d959-28f3-4ac3-b543-a46afb1c8735","text":"Russian forces seized and occupied the Kakhovka (Nova Kakhovka) Hydroelectric Power Plant; satellite imagery showed Russian troops and equipment at the facility."},{"id":"75a831c9-64bc-48da-b175-a2437e47dd83","text":"The Kakhovka HPP and Nova Kakhovka were repeatedly struck and reported damaged during summer 2022 (including reported HIMARS strikes on July 11, 2022)."},{"id":"97350da0-d1db-4b53-a3fc-ef06b13b945c","text":"Arson and vandalism of mobile phone masts reported in the UK"},{"id":"2950345a-e866-4de3-92f1-2cb1e4c25f8f","text":"Russian drone strike destroyed the Roman Shukhevych (UPA) Museum on the outskirts of Lviv."},{"id":"7db6c8a6-60bc-4662-b2dc-199aa561b87e","text":"Widespread reporting since 2022 documented Russian forces looting and removing artifacts from Ukrainian museums (establishing a precedent of cultural theft and illicit sales)."},{"id":"ea7a2b72-7d1f-4c73-a073-a7b027631757","text":"Implementation of the 2004 education reform increasing Latvian-language instruction in minority schools (the \'60/40\' reform)"},{"id":"201f7365-3e62-47f1-9210-042b45108003","text":"2012 constitutional referendum on making Russian a second official language, which was decisively rejected (18 February 2012)"},{"id":"b7b32401-5690-41a0-af65-8ece78fd91fe","text":"A 2022 edition of 11th\u2011grade history outline maps was published by Kartohrafiya (ISBN 978-966-946-460-6), a commonly used educational map source in Ukraine."},{"id":"c8de3f3a-96b2-48a0-bace-ff2c0f38239c","text":"Precedent of flights from occupied Crimea to third countries (despite sanctions) documented in prior years (examples 2016\u20132018), showing routes and carriers operating non\u2011Ukrainian international services."},{"id":"157e34be-f855-4ce9-bf07-9c26d1427230","text":"Russian carrier Ikar (Pegas Fly) reported/planned to launch flights linking Yerevan and Simferopol (Crimea)."},{"id":"a5d1d62e-20f0-40cd-9604-245b0e5f8830","text":"Major cancer-care organizations publish warnings that there is no reliable clinical evidence soursop (graviola) cures cancer and note potential harms"},{"id":"61eb6e4e-8226-4649-a28c-6a1d5143a326","text":"Peer-reviewed isolation and characterization of annonaceous acetogenins from Graviola showing potent in vitro anti-proliferative activity against human cancer cell lines"},{"id":"6ee233fb-18ce-46c2-9236-b4b2ba49b6e8","text":"State\u2011level legislative changes and debates in 2024 expanding legality or easing restrictions on raw\u2011milk sales (e.g., new limited sales allowances in some states)"},{"id":"f9972a21-0ed8-4c53-8835-ca063429c525","text":"Large disruptions and later rebounds in cancer screening and diagnoses during the COVID\u201119 pandemic became widely reported (fewer screenings in 2020 then partial catch-up), creating confusing temporal patterns in cancer incidence data."},{"id":"471b5c6a-be85-43f0-8f08-c5d4074a62de","text":"OSCE Special Monitoring Mission (SMM) spot reports documenting civilian casualties and intensified fighting in Donetsk and Luhansk in October 2014."},{"id":"3254bd8f-d52e-4eb5-9cac-a67f2dc656e4","text":"UN Office of the High Commissioner for Human Rights (OHCHR) report on the human rights situation in the context of the anti\u2011terrorist operation (ATO) documenting detentions, abuses and civilian harm (July 2014)."},{"id":"e1e86014-5779-43c2-a83e-e8910c811c28","text":"President Petro Poroshenko and other Ukrainian officials publicly described pro\u2011Russian fighters as \'terrorists\' in mid\u20112014 interviews and statements."},{"id":"e5f9b0d6-7e73-4a08-aa88-88ca82ea4f7a","text":"High\u2011profile activity and imagery of far\u2011right Ukrainian groups (e.g., Svoboda torchlit march, January 2014) widely reported in international media."},{"id":"c265307b-a45e-40d2-942e-064e09203a3b","text":"Russia blocked a Western-backed UN Security Council statement condemning the shelling of Mariupol."},{"id":"80874662-775d-4097-ab12-519fd35a8af0","text":"UN Secretary-General Ban Ki-moon publicly condemned the rocket attack on Mariupol in a UN spokesperson/secretariat statement."},{"id":"b6debf5b-3fd9-4758-8d65-ddcfa76159c1","text":"OSCE Special Monitoring Mission (SMM) spot report and multiple media outlets reported heavy MLRS/rocket shelling in Mariupol with dozens of civilian casualties."},{"id":"98bf6bd9-3571-4fc4-a522-793f28993ff1","text":"CDC MMWR report on allergic reactions (including anaphylaxis) after first doses of Pfizer\u2011BioNTech vaccine (covering Dec 14\u201323, 2020)"},{"id":"de7db6fd-2ae6-4f7a-b2d2-140c467a7909","text":"FDA VRBPAC briefing and safety review documents for Moderna COVID-19 vaccine (presented to advisory committee)"},{"id":"3737c0e5-0ce0-43f5-85a5-06097bb825b7","text":"Publication of Moderna (mRNA-1273) Phase 3 (COVE) trial reporting safety/reactogenicity data in NEJM"},{"id":"041efd3d-3637-4fdb-883e-7e7a15720adb","text":"WHO/UNICEF reporting on Sudan circulating vaccine\u2011derived poliovirus type 2 (cVDPV2) outbreak (declared Aug 2020; press coverage Sept 2020)"},{"id":"e0fadef7-8cb0-400b-87ba-015ee4371568","text":"CFSRE (Center for Forensic Science Research & Education) issues Q2 2024 Trend Report documenting rising harms, emergency admissions and deaths linked to synthetic cannabinoids (K2/Spice), and distinguishes these products from plant cannabis."},{"id":"2f08b13a-ecf0-4799-a14d-58bf972dd8ec","text":"Peer\u2011reviewed study (Journal of Cannabis Research) publishes results (April 6, 2024) reporting that a history of cannabis use was associated with lower in\u2011hospital mortality among hospitalized COVID\u201119 patients in a large national inpatient sample."},{"id":"7e44b6c6-7d56-4232-819d-53ec3fa86eca","text":"White House issues \'Statement from President Biden on Marijuana Reform\' (October 6, 2022) and subsequent federal/state-level policy shifts and public discussions around decriminalization/rescheduling continue through 2023\u20132024."},{"id":"e044f66e-1051-432c-9447-d98bcbe37e2d","text":"Systematic reviews and clinical\u2011trial summaries (e.g., Antioxidants 2018; other reviews and NIH/NCI summaries) documenting safety, mixed/limited efficacy signals, and ongoing early\u2011phase trials of high\u2011dose IV ascorbate in cancer therapy."},{"id":"806cfcc9-2fa9-44ee-85fa-be86fd0c140b","text":"Longstanding promotion and clinical use of IV vitamin C by integrative clinics (e.g., Riordan Clinic) including published protocols and patient\u2011case material used to market IVC as an adjunctive cancer therapy."},{"id":"3d0c34ba-5eed-4155-8048-07dea2acc752","text":"Emergency use authorizations and publication of phase\u20113 results for mRNA COVID\u201119 vaccines (Pfizer/BioNTech and Moderna) in late 2020"},{"id":"58bcf34f-8ba3-4b84-a26f-99d50d09da47","text":"WHO guidance advising that ivermectin should only be used to treat COVID\u201119 within clinical trials"},{"id":"595f845c-20e2-4266-9c19-52b6519191bf","text":"WHO request and international attention on China\u2019s late\u20112023 surge in pediatric respiratory illnesses"},{"id":"a3dbd081-e0b4-447f-a34f-0188df7b1cfd","text":"High\u2011profile reporting in 2023 about widespread chemical contaminants in U.S. tap water (PFAS / \'forever chemicals\')"},{"id":"c1c0f08b-a7e7-47dc-b2ab-3e7f98dedc81","text":"August 2021 discovery of foreign particles in some Moderna COVID\u201119 vaccine vials in Japan (batches paused)"},{"id":"2a7b8375-e2a4-40b6-8703-a6867c26ee76","text":"Event 201 pandemic tabletop exercise (Johns Hopkins/WEF/Bill & Melinda Gates Foundation)"},{"id":"5ad531ab-4764-4ef7-baba-70398900776e","text":"Arrest and conviction of Ukrainian filmmaker Oleg Sentsov on terrorism charges (Crimea cases)"},{"id":"20591f9f-e0ef-4998-90e0-cea448297dde","text":"UAE action and reporting around Russian-linked assets and banks (examples: cancellation of MTS Bank licence)"},{"id":"108e779d-9db3-4fd0-9788-b9157c4ab56e","text":"Ukrainian authorities charged individuals in an embezzlement scheme linked to arms procurement (~$40 million)"},{"id":"dd631f5a-6080-4281-9adc-8fdb88632983","text":"Pentagon Inspector General report finding about $1 billion in U.S. weapons to Ukraine not properly tracked"},{"id":"1e36d9a5-24c2-4358-9d06-5f639bbe88fb","text":"Pandora Papers release showing extensive use of UAE-linked offshore structures"},{"id":"aa40d2ac-2714-4625-babf-90088c7be49f","text":"Greenpeace \'Dirty Laundry\' investigative reports exposing toxic discharges from textile supply chains"},{"id":"87097f69-f45d-4265-af3b-f1353bd44cc8","text":"Publication of \'A New Textiles Economy\' report by the Ellen MacArthur Foundation (widely cited analysis of fashion\'s environmental footprint)"},{"id":"dddd9c26-ce0a-4e7e-a0e6-93e55f2f4446","text":"Peer\u2011reviewed studies (2017) quantifying microfiber shedding from synthetic textiles as a major source of microplastics"},{"id":"f4e3a9e3-3c3d-4ab1-8c3a-b7b4f00b7da0","text":"CDC/ACIP review and MMWR reporting of myocarditis and pericarditis cases following mRNA COVID-19 vaccination"},{"id":"b4f143e6-4e35-4c18-a988-79f21ab9c179","text":"Regulatory findings and media coverage of rare blood\u2011clotting events linked to the AstraZeneca COVID-19 vaccine (EMA review)"},{"id":"0e7c3843-8c18-486d-87e7-d205bfd1bddf","text":"Sinking of the Russian cruiser Moskva in mid-April 2022 near the Black Sea theatre"},{"id":"3d446a56-a3cf-4d57-befe-1d011f977087","text":"Ukrainian forces raised the Ukrainian flag on Snake Island after Russian withdrawal"},{"id":"895c4b1a-bfdd-43b5-88e8-3f03cee20224","text":"Enactment of Ukraine\'s decommunization laws"},{"id":"1f31387f-602f-4406-b683-3349a0445c7a","text":"Kyiv City Council renamed General Vatutin Avenue to Roman Shukhevych Avenue"},{"id":"fa88a2cd-c10a-4c93-a187-e5e358d897f2","text":"OSCE Special Monitoring Mission observed civilian fatalities and bodies after shelling in Donetsk"},{"id":"6849375f-6011-4635-b9c4-b17ee24abba1","text":"Odessa Trade Union House fire and mass fatalities during clashes"},{"id":"bb15e0f0-16db-4581-a33d-49bdce475328","text":"Killing and torture of local politician Volodymyr Rybak reported from Donetsk region"},{"id":"f73ccc40-9526-460c-ad2f-f60fad7ce28b","text":"Exhumation of a mass grave in Sloviansk, eastern Ukraine"},{"id":"f2e1273d-63f8-445e-a431-b0e75cdf5564","text":"UNICEF launched a humanitarian cash transfer programme in Ukraine (real cash payments to vulnerable families began in March 2022)."},{"id":"485eb0cd-4bd1-4c5b-a0bc-f24751f1688c","text":"Sharp rise in Telegram (early 2022) and already-dominant Viber use (Ukraine: high market share reported Sept 2021) as primary messaging channels in the region."},{"id":"ee6b2298-47b7-4481-8fe6-951504b15004","text":"French farming unions warned they could stage further protests and blockades (reported March 3, 2024)."},{"id":"1ce1328d-6ce2-489f-b6b2-35da0faba554","text":"President Macron publicly said he did not \\"rule out\\" sending Western troops to Ukraine during a leaders\' meeting in Paris."},{"id":"f73fdbd4-3902-4798-a160-be278afda5fe","text":"IUCN Polar Bear Specialist Group released its 2023 status/criteria report on polar bear subpopulations and abundance estimates (PBSG status report, Oct 2023)."},{"id":"8126a34c-5ee8-475b-8526-f4d565d7db8f","text":"The Oceanography Society / research syntheses in 2023 published accessible overviews of observational evidence for ongoing global surface ocean acidification."},{"id":"ab43d039-96d0-4d64-8845-a0f23f6afccd","text":"NOAA/SWPC issued a revised forecast that Solar Cycle 25 would rise more quickly and peak higher than earlier predictions, and highlighted recent large solar flares (X\u2011class) in late 2023."},{"id":"d0ad0b02-60ab-4619-a430-6da20b6c1436","text":"Peer\u2011reviewed 2023 papers documented high spatial and temporal variability in coastal and upwelling pH (e.g., high\u2011frequency pH dynamics in regional systems), showing local short\u2011term pH fluctuations."},{"id":"c7cdea89-036d-4bcf-85df-916f09f07798","text":"U.S. federal political actions and rhetoric undermining climate policy (example: President Trump announces withdrawal from Paris Agreement)"},{"id":"5487ccd1-6b00-4e12-8e12-04bad8b9c440","text":"Nature Climate Change paper: \'Temporary reduction in daily global CO2 emissions during the COVID\u201119 forced confinement\'"},{"id":"ecc020ce-fecb-452a-af8c-ad9709949f72","text":"Violent clash between rival Orthodox groups at St. Michael\'s Cathedral in Cherkasy"},{"id":"f63b0a7e-2f78-4a73-829e-07523b9f1f51","text":"Local reporting about the contested transfer/seizure of the cathedral and services held in Ukrainian amid the dispute"},{"id":"3022932c-02eb-48c9-b138-d812dbb39ec7","text":"Russia/occupation authorities ban the Mejlis of the Crimean Tatar people as \'extremist\'"},{"id":"f2bf68ae-a55c-4529-8841-e51b1e49ccfd","text":"Surge in positive public attitudes toward Stalin in Russia (Levada poll, April 2019)"},{"id":"6a04f59f-82ff-415c-8bec-2ed8a8f679e8","text":"Release and public circulation of National Toxicology Program (NTP) draft monograph materials on fluoride and neurodevelopment (documents publicly posted and widely reported in 2023)."},{"id":"1aaa012c-a242-4929-96eb-70b19589f395","text":"Publication of mouse-study showing sodium bicarbonate reduced metastasis (Robert Gillies et al.)"},{"id":"85fb84b0-0122-40e9-b27c-d5a75ab417c4","text":"Case report of severe metabolic alkalosis from topical sodium bicarbonate use (clinical harm reported)"},{"id":"c807536c-627d-4ea7-a757-b1fc516650c4","text":"2018 conviction and sentencing news about Tullio Simoncini for treating cancer with bicarbonate"},{"id":"fdfe3472-c5ba-49de-8042-03f87d3b22f2","text":"European Union re\u2011affirms and extends sanctions on Russia amid Minsk implementation stalemate (summer 2017)"},{"id":"bfa887a6-b322-4da1-a76b-7b5b3f653cc4","text":"German foreign minister Frank\u2011Walter Steinmeier publicly favours gradual phasing\u2011out of Russia sanctions if progress is made (Reuters)"},{"id":"c0bc1a44-9b42-4cf0-aab0-ae80b02a03c6","text":"Heavy fighting in Avdiivka, Donetsk region \u2014 major escalation reported (Battle of Avdiivka)"},{"id":"6b35feeb-649a-4826-af85-82f8a6706455","text":"\u2018Steinmeier formula\u2019 concept emerges in Normandy/Minsk negotiations (implementation idea for political clauses)"},{"id":"7bb2184d-04eb-4cc5-9bba-24bbaa1c88fe","text":"OSCE/UN reports of restricted access and harassment of journalists in eastern Ukraine (summer 2014)."},{"id":"f40486a0-ea1d-4cfb-a807-029ece0cb041","text":"Ukrainian National Guard reported taking control of Komsomolske (Donetsk region) after fighting."},{"id":"d179af4f-4114-4e08-96db-ce490af45be1","text":"Large Russian military convoy and movement of heavy vehicles near the Ukraine border (August 2014) and competing official narratives about incursions."},{"id":"be52d413-c060-46df-ae49-6f8e865d0ae2","text":"Ukrainian forces captured two Russian nationals identified as GRU officers (Yevgeny Yerofeyev and Aleksandr Aleksandrov) during fighting near Schastya."},{"id":"b82e31c4-552a-444b-a496-ff8aa9a48878","text":"Large prisoner exchange between Kyiv and pro-Russian rebels around the end of December 2014, involving hundreds of detainees."},{"id":"3cd90d92-1f2f-4bb7-bf4a-32e93f89acf3","text":"Signing of Minsk II (Package of Measures) which included clauses calling for \'release and exchange of all hostages and unlawfully detained persons\' on an \'all-for-all\' basis."},{"id":"2318fe24-10d8-4966-a4b3-8bc37a734c13","text":"EuroMOMO surveillance reports flagged elevated excess all-cause mortality in parts of Europe during 2021"},{"id":"e02ac3bc-7a18-4bfb-9c46-d2b7239b6583","text":"Office for National Statistics publishes \'Deaths involving COVID-19 by vaccination status\' dataset covering deaths occurring Jan 2021\u201331 May 2022"},{"id":"5a2bf5df-c9e2-4260-aacc-208208da8e1a","text":"Federal judge orders FDA to accelerate public release of Pfizer COVID-19 vaccine documents"},{"id":"0d4aa265-11b9-4915-b054-93ec17930f3a","text":"CDC issues \'Preexposure Prophylaxis for the Prevention of HIV Infection\' clinical practice guideline"},{"id":"956e3474-5618-4c81-9e49-a51567c16fcf","text":"FDA approval of Descovy (emtricitabine/tenofovir alafenamide) for PrEP, with messaging highlighting improved renal and bone safety compared with TDF-based Truvada"},{"id":"a0f28cd3-c641-4002-8200-92f884c4cf8e","text":"Publication of reviews and studies documenting tenofovir disoproxil fumarate (TDF)\u2013associated renal dysfunction and decreases in bone mineral density"},{"id":"5d23ebd4-1e86-43e3-81c7-16ad606a11d8","text":"CDC issues formal guidance on certifying COVID-19 deaths (death-certificate guidance)"},{"id":"18bd5197-ea18-4065-a9e0-567e3b1c277d","text":"Italian Istituto Superiore di Sanit\xe0 (ISS) reports high prevalence of pre-existing conditions among COVID-19 fatalities"},{"id":"f726ffc2-3647-400d-80a6-f52985797422","text":"Poroshenko appeared publicly with wounded soldiers as guests at a Dynamo Kyiv match (visuals of him handing/being near gifts including a football)."},{"id":"68dd5299-7fd4-430f-8b60-388906a72882","text":"Established medical context: febrile seizures are a known, usually benign reaction to fever and occur after many vaccines/infections (public understanding limited)"},{"id":"67b03e9b-943d-4bbc-a124-9c5578ef7ef2","text":"Russian government statements alleging \'outside meddling\' in Belarus"},{"id":"93f6b1a4-8c3f-4a06-9824-0ba2df7d17d9","text":"President Petro Poroshenko signs Ukraine\'s \'decommunisation\' laws banning communist symbols and requiring removal/renaming of Soviet-era monuments and toponyms."},{"id":"13d2edcb-24dc-4bec-bcab-c09b3c14e8f8","text":"Large Lenin statue toppled and demolished in Kharkiv during anti\u2011government protests."},{"id":"7dff7322-4805-4518-8f58-584aac64f379","text":"Polish Sejm resolution recognising the Volyn (Volhynia) killings and raising attention to Volyn (22 July 2016)"},{"id":"6c94502c-3a79-4e01-b9d8-632621273814","text":"Wider pro\u2011Russian unrest and short\u2011lived \'people\'s republic\' claims in cities such as Kharkiv and Odesa (April 2014)"},{"id":"ef73f4bd-2cd1-4b72-9c3c-c2591a929a40","text":"WHO names vaccine hesitancy among the top global health threats in 2019, and public debate about vaccine \'toxins\' and \'detox\' ramps up on social platforms in the late 2010s."},{"id":"6776a7d5-beaf-4c41-aa38-300a0801b709","text":"American College of Medical Genetics and Genomics (ACMG) issues a 2013 practice guideline stating there is a lack of evidence supporting clinical MTHFR polymorphism testing."},{"id":"d8891a94-9140-46bb-bcdb-3d29d91975f5","text":"Ukrainian government approved a draft law narrowing eligibility for military deferments for students and educators"},{"id":"bcbce5e1-e6dd-4fb3-b640-98dccec00c92","text":"Verkhovna Rada extended martial law and general mobilization and described categories (including students) eligible/exempt from mobilization"},{"id":"46a1a4b3-5947-4f7a-937a-1787f32e8bcb","text":"WHO interim guidance \'Advice on the use of masks in the context of COVID-19\' published (5 June 2020) noting there was \\"no direct evidence\\" from studies on universal masking of healthy people in the community."},{"id":"f2f46d22-9183-4d22-a258-f7deec1e4667","text":"Publication (Epub May 13, 2020) of Gao et al., \'A study on infectivity of asymptomatic SARS-CoV-2 carriers\' (Respiratory Medicine), reporting 455 contacts of an asymptomatic carrier tested negative."},{"id":"eee7a4d9-8e2d-47ee-8999-987c6555cb58","text":"Complaints and regulator notices in the UK about inappropriate recruitment incentives (reports that children were offered large payments, e.g., \xa31,500, to join a Moderna pediatric trial) and subsequent PMCPA action."},{"id":"11e6af92-7c17-44a8-9ab1-609463443a49","text":"Publication of the KidCOVE phase 2/3 trial results showing mRNA\u20111273 (Moderna) was safe and immunogenic in children 6 months to 5 years (NEJM)."},{"id":"f4b9f0d4-2a14-40af-9ab6-151433206f04","text":"Widespread civilian refugee exodus from Ukraine reported across media"},{"id":"dfc78b17-77bb-4229-957b-d80d3ad115c8","text":"DOU industry survey (conducted March 23\u201326, 2022) found many IT specialists had moved to safer locations (61% reported leaving their homes)"},{"id":"67774ca3-9e92-4d08-8579-3aaf1352ddf2","text":"Public statements and interviews by Ukrainian officials describing the size and mobilization of the IT sector (coverage citing ~300,000 IT professionals)"},{"id":"53c56e4f-f7aa-498b-a6a2-d571622c455c","text":"Multiple international tech firms publicly evacuated or offered relocation support for Ukrainian staff"},{"id":"c563fc88-dbde-45c0-91ec-aa24573796f5","text":"2010 laboratory work demonstrating water extraction methods recover shikimic acid from sweetgum bark/wood"},{"id":"cff7a05d-3faf-4626-9e30-2425b37b803b","text":"2009 news coverage linking shikimic acid (from star anise) to Tamiflu production and documenting supply shortages during flu scares"},{"id":"12f512c6-9447-45bf-84b7-c471a724c050","text":"Russia vetoed a UN Security Council draft resolution to establish an international tribunal for the downing of Malaysia Airlines Flight MH17"},{"id":"3d663718-e7d2-4e18-9008-11c863444483","text":"UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine\u2019s territorial integrity while the Security Council was unable to act"},{"id":"72464dda-73dc-42a3-bd28-c42b8e02f4f9","text":"Humanitarian situation reports documenting growing social tensions and incidents between host communities and IDPs in host areas"},{"id":"3c5df01c-39f1-48ad-b488-cc651a5bee87","text":"High\u2011profile cases earlier in 2014 of pro\u2011Russian protesters/separatists removing or replacing Ukrainian flags from government buildings in eastern Ukraine (Donetsk)"},{"id":"55149787-986d-45e4-b225-54181d7d8cf7","text":"Large influx of internally displaced persons (IDPs) from Donbas and Crimea to Kyiv region (tens of thousands reported)"},{"id":"6d127b3c-a603-4734-96e1-89cef5a4128a","text":"Existing, well-known SANAE IV research station and local geology (Vesleskarvet nunatak composed of dolerite/diabase) available in public records and studies"},{"id":"93d5589d-ec1b-403e-b7b7-ca6f4146db7d","text":"Angelina Jolie made an unannounced humanitarian visit to frontline cities in Ukraine (Kherson, Mykolaiv/Lviv region)."},{"id":"eaf5b6ba-8898-4839-b6a9-fc7cdd78ce02","text":"UN reporting and human\u2011rights agencies warned of \'persistent and grave\' human rights violations and widespread deprivation in conflict\u2011affected areas of eastern Ukraine."},{"id":"0534dd3a-1108-4c6c-8042-56dd3e0e1de4","text":"Verkhovna Rada submission/declaration to the UN indicating derogation from certain international obligations (official deposition notifying international bodies)."},{"id":"2c70aa6c-a47a-4ec6-9c2f-3780e8077140","text":"Widespread suspension or non\u2011payment of pensions and social payments to people in non\u2011government controlled areas of Donetsk and Luhansk."},{"id":"1827b39d-2e75-4c43-b9b5-819bcccd1336","text":"Western bilateral training missions inside Ukraine (for example, Canada\'s Operation UNIFIER launched in 2015 with rotating Canadian personnel training Ukrainian forces)."},{"id":"4d27344b-c507-440a-ae52-1d0a68fdf680","text":"NATO formalized intensified political/military cooperation with Ukraine (NATO factsheets and liaison presence describing NATO-Ukraine dialogue and support)."},{"id":"a5e721d6-d4b5-4676-b0ef-6635440090c5","text":"Sea Breeze 2019 multinational naval and maritime exercise co-hosted by Ukraine and NATO/allied partners in the Black Sea (visible allied ships and aircraft operating near Ukraine)."},{"id":"e83bbc87-dc53-4e0a-aa7a-894dca93d5ca","text":"Reports since 2014 of foreign fighters and international volunteers operating in Donbas (documented by major outlets such as the BBC)."},{"id":"0cffc2cc-b1b1-4d89-9f69-ca6b18367663","text":"Antarctic winter sea\u2011ice extent reached a satellite\u2011era record high (widely reported in 2014)"},{"id":"b148b335-5477-4655-b6a6-2f5cfaac025f","text":"World Glacier Monitoring Service (WGMS) database expansion and 2019 reporting on glacier observations"},{"id":"8cdda31c-9b71-4441-865a-81116c144f4c","text":"CDC releases 2020\u20132021 flu vaccination recommendations calling for yearly flu vaccine for everyone 6 months and older"},{"id":"58adc6a2-015b-4cf4-929a-9090cc1d2ce7","text":"NOAA \'State of the Climate \u2014 2012\' reporting on global sea level contributions noted that recent sea-level rise included large contributions from glacier and ice-sheet melt as well as thermal expansion"},{"id":"c0961ef4-9fc4-4628-a2ba-f575365a0926","text":"Research showing Pacific trade-wind/ENSO-driven decadal variability strongly affects regional sea-level trends (studies published 2016\u20132017 demonstrating wind-driven variability and model under-representation)"},{"id":"8a1af2e7-35aa-4ae4-a3a9-dba8d0e29550","text":"Coverage of apparent \'slowing\' or data-artifact issues in satellite altimeter sea-level records (widely reported articles in 2014\u20132015 discussing measurement corrections and inter-dataset differences)"},{"id":"f1b56084-1b4d-4858-b1c5-fe109cb7b38a","text":"Verkhovna Rada adopted a resolution establishing \'Day of the Ukrainian Volunteer\' (Day of Volunteer Fighters)"},{"id":"3a41d540-b1a0-4c5c-b596-8e90a640fa55","text":"Presidential Decree No.806/2014 established \'Day of the Defender of Ukraine\' (14 October 2014)"},{"id":"43ad7424-4c77-4dc0-8c36-9d1d1d14dd12","text":"UK government announced new national lockdown in England on Jan 4, 2021 despite vaccine rollout"},{"id":"06c72a80-84c2-4b99-b900-146c339b7cb5","text":"IATA and airlines public plans for a digital \'travel pass\' / health pass tied to testing and vaccination (December 2020)"},{"id":"63fbc0f1-49c8-4b3e-9954-75d114dce032","text":"WHO warnings that vaccines are not a \'silver bullet\' and will not immediately end the pandemic"},{"id":"9bf4b261-5604-4e7d-bdf4-1d258b3c8c67","text":"Berlin authorities publicly considered or enforced bans on display of Russian/Soviet symbols around May 8\u20139 commemorations"},{"id":"bf8c3e12-552a-4a71-843a-f89c91b6389e","text":"Major oil and gas companies (Shell, Exxon) suspend or pull back Black Sea projects after Crimea\u2019s annexation"},{"id":"47086825-ea05-4d6c-a4fb-5290780b5f88","text":"Russian appropriation and U.S. sanctions on Chernomorneftegaz after the 2014 annexation of Crimea"},{"id":"e3ab09fc-1684-492b-adb9-d899f0428e95","text":"Peer\u2011reviewed review article published (Natural Product Communications) summarizing multiple Chinese herbal medicines and their potential mechanisms in COPD (preclinical and small clinical studies)."},{"id":"d941fba6-fd74-4a83-9e8e-d451475571b9","text":"FDA issued high\u2011profile warning letters and enforcement actions in 2023\u20132024 against supplement makers for making unlawful disease\u2011treatment claims."},{"id":"538ca86c-a065-4064-bc05-9aa8e765059b","text":"CDC COVID-NET MMWR report on pediatric COVID-19 hospitalizations (March\u2013July 2020)"},{"id":"f3374e00-912a-4a2b-a295-21f6bee73d8d","text":"Publication of Moncrieff et al., \'The serotonin theory of depression: a systematic umbrella review of the evidence\' in Molecular Psychiatry, concluding no consistent evidence that depression is caused by decreased serotonin activity (widely reported July 2022)."},{"id":"48c00d52-4142-44d8-8055-adaf8e806d65","text":"Royal College of Psychiatrists position statement \'Antidepressants and depression\' (PS04/19, May 2019) stating the \'chemical imbalance\' explanation is an oversimplification and not supported as a literal cause of depression."},{"id":"75d8bd40-d695-4208-bab5-37205811fc6f","text":"U.S. Senate passed a $95 billion foreign aid package including funds for Ukraine and security assistance"},{"id":"b797142f-6e6b-4e92-947e-f1eac9cf2441","text":"Ukrainian President Volodymyr Zelensky\'s visit to Washington to plead for more U.S. aid and meetings with lawmakers"},{"id":"c4d166ac-fb2b-4908-b29e-b5e60db0c750","text":"United Kingdom announced a formal 10-year security/cooperation arrangement with Ukraine (high-profile bilateral security pact coverage)"},{"id":"2aad08c3-7a9d-4088-a0c8-7173322b568e","text":"OSCE regular situation summaries noting continued shelling damage in Donetsk (SMM monitoring summaries in Jan\u2013Feb 2015)"},{"id":"f7b9b2d6-8f53-43d9-99fd-bb3b69e7b89c","text":"CDC/ACIP public report (MMWR) acknowledging increased reports of myocarditis after mRNA COVID-19 vaccination and concluding benefits outweigh risks"},{"id":"369fae54-d19e-45f4-b266-bf30cf97a1aa","text":"Discovery of black/foreign particles in some Moderna vaccine vials in Japan, triggering local pauses and recalls"},{"id":"7564e306-9381-4331-a0f1-0dbf0fb1bba9","text":"CDC/ACIP and MMWR reports (June 2021) documenting an elevated but rare risk of myocarditis after mRNA vaccination in young males"},{"id":"b07f9e83-4828-4d6c-9655-aaf9e032b958","text":"EMA statement (April 2021) finding a possible link between AstraZeneca vaccine and very rare blood clots"},{"id":"c5d32957-0250-4e27-883f-1614716b7a5a","text":"Media coverage and public attention on regulatory/clinical debate about aluminum adjuvant safety (coverage of CDC/advisory discussions)"},{"id":"144a50c2-b370-4909-b53f-80f34729e342","text":"CDC guidance on infant formula and fluorosis advising caution with fluoridated water when preparing infant formula"},{"id":"661f3ede-e539-43ba-97be-c3c6c34b20d1","text":"NTP (National Toxicology Program) systematic review/monograph assessing fluoride exposure and neurodevelopmental outcomes"},{"id":"d5908ec5-3ffb-41c4-a73b-cce528382f43","text":"EU and other Western emergency energy/aid packages delivered to Ukraine after strikes on energy infrastructure"},{"id":"63723f47-361c-4376-807a-db90f7e6a177","text":"Public health briefings and technical reports about Omicron (Dec 2021\u2013Jan 2022) from agencies such as CDC/UKHSA describing reduced vaccine effectiveness against infection and many \'breakthrough\' cases"},{"id":"64afbd72-1116-4c9e-be6c-75364f693bd2","text":"Widespread driver-led protests and road blockades across Serbia over fuel-price hikes (early June 2018)."},{"id":"f5025228-2ba3-471c-b1c3-23a1505e1738","text":"OSCE Special Monitoring Mission (SMM) reports (2014\u20132015) documenting heavy weapons and noting that withdrawal of foreign armed formations and verification remained incomplete (e.g., OSCE SMM updates in 2015)."},{"id":"bc099959-037b-43e1-81ab-0a360d9be0b0","text":"Signing of the Minsk II package of measures (Normandy Format) on 12 February 2015, which called for withdrawal of \'all foreign armed formations, military equipment and mercenaries\' from Ukraine."},{"id":"98c7e671-e565-411e-842f-6573296ff33e","text":"Ukraine released footage and publicly displayed captured Russian paratroopers in August 2014; Moscow described the detentions as a mistake or denied direct responsibility."},{"id":"7a2b81d2-3671-4bb5-b252-146ae07d2184","text":"Russia launched a direct military intervention and air campaign in Syria (widely reported on 30 Sept 2015)."},{"id":"891028a4-9c48-4a22-9b0c-8e72a1f0c9ea","text":"Apter et al. v. Department of Health & Human Services \u2014 lawsuit filed by three physicians (complaint filed June 2, 2022)"},{"id":"2218b201-0cff-4061-95fc-3e9f5fb5ffef","text":"DOJ lawyer\'s remark during Fifth Circuit oral arguments (Apter v. HHS) that \u201CFDA explicitly recognizes that doctors do have the authority to prescribe ivermectin\u201D"},{"id":"c683eead-b9f6-409e-98ea-ca86a80fe6b3","text":"Calls in EU institutions and the Platform of European Memory and Conscience for EU-supported remembrance projects and funding (referenced in EP documents, 2019)"},{"id":"319e2b16-8188-4643-b573-840838be97c9","text":"International backlash to Poland\'s 2018 \'Holocaust law\' (Amendment to the Act on the Institute of National Remembrance) and subsequent diplomatic controversy"},{"id":"dec0aa9e-5fd8-4c97-949a-d4e94ae3538d","text":"Ukrainian security forces moved to clear separatist/pro\u2011Russian protesters from the Kharkiv administration building and arrested dozens (early April 2014)."},{"id":"190837d7-d1a4-4fd5-90d4-a7a51760571a","text":"Deadly clashes in Odesa on May 2, 2014, that left dozens dead in street fighting and a Trade Unions House fire between pro\u2011Ukrainian and pro\u2011Russian groups."},{"id":"b5463219-98c5-448f-9531-85d2be5f4d74","text":"Increased visibility and international coverage of Ukrainian nationalist groups (e.g., Right Sector, Svoboda) and their mobilizations in early 2014."},{"id":"ae9feba2-1286-4e90-8d19-f6c6fb5695bc","text":"5G Appeal / International EMF scientists\' moratorium call"},{"id":"29c88596-19ba-4c92-889a-93d36cedb885","text":"China\'s commercial 5G launch in 50 cities"},{"id":"0f1e349e-33e1-410f-a80e-7f7a15a64def","text":"US National Toxicology Program (NTP) cell-phone radiofrequency final reports"},{"id":"2907752a-dd04-43a3-81f8-99aed282cd51","text":"Public Health Ontario technical brief on interpreting PCR cycle threshold (Ct) values (Sept 2020)"},{"id":"e2d6ea9f-2930-4d6a-88e9-e46e90562a30","text":"IDSA/AMP joint statement cautioning against using Ct values for clinical decision-making"},{"id":"9837e2d1-81a9-4dda-a544-9966e203d52f","text":"NEJM perspective arguing testing strategy should prioritize frequency/turnaround over analytic sensitivity (Mina et al., \\"Rethinking Covid-19 Test Sensitivity\\")"},{"id":"cf9857de-8137-45c9-b5fa-915993e74b08","text":"Study showing PCR cycle threshold values correlate with loss of recoverable live virus (Bullard et al.)"},{"id":"ff9436f6-f297-4eb4-912f-7a157e3d12fe","text":"CDC/NCHS provisional counts showed the U.S. COVID-19 death tally reached roughly 1,000,000, prompting broad press coverage."},{"id":"30d95fcc-b794-4439-8991-acda681c53e1","text":"President Biden and the White House publicly marked the milestone, issuing statements and remarks acknowledging \'one million Americans\' dead from COVID-19."},{"id":"38511aaf-9163-4d65-81dd-224ed0e0b81d","text":"Lithuanian parliament unanimously declared Russia a \'terrorist state\'"},{"id":"40f52c99-ebfd-45ff-98f5-952306d27151","text":"Pattern of prior Kremlin disinformation accusing Ukrainian authorities of preparing to mobilize or militarize children (examples documented across 2022)."},{"id":"11cd3da1-ec29-4a09-b90a-f36ba252d061","text":"A December 30, 2022 parliamentary decision changed the official summons form and administrative terminology (new Territorial Recruitment and Social Support Centers), making older or doctored forms appear superficially plausible to non-experts."},{"id":"48abfe8f-9f46-4310-9097-df2faacdef21","text":"Amnesty International documenting abuses by pro\u2011Ukrainian volunteer battalions in Donbas"},{"id":"383b2738-9a06-4fbb-b686-d25d6df14cd6","text":"Passage of Ukraine\'s decommunization laws banning Soviet symbols"},{"id":"9a836402-72b1-4d2e-8da1-84843dda9b7b","text":"Adoption of the Ukrainian \'lustration\' (vetting) law for officials"},{"id":"611ba306-98a9-4679-8657-f9c54c244a4e","text":"Adoption and implementation of the 2017 Education (language) law restricting minority\u2011language instruction"},{"id":"6c4cddc2-2c7c-432e-8213-e905a1d3738a","text":"Ukrainian investigations and prosecutions for \'collaboration\' with occupying authorities in Crimea (starting 2014)"},{"id":"51b2f815-411e-43f8-a5c1-336bea1219da","text":"Europol / international law\u2011enforcement warnings about the risk of diversion of weapons from the Ukraine conflict to black markets"},{"id":"782c2526-0417-4dc7-8284-5083afa85621","text":"CBS Reports documentary \'Arming Ukraine\' (briefly released, then pulled) examined problems getting aid to frontline and described shipment shortfalls"},{"id":"dbe3b7f9-9c71-45eb-b905-98ec6f50ca3d","text":"Public debate over mobilisation/conscription policy in Ukraine (Reuters: \'Female conscription not part of Ukraine\'s new draft law\')"},{"id":"5c56c859-c655-41f6-ba71-d6caa0f72e3b","text":"Widespread reporting of Russian strikes that damaged or destroyed Ukrainian grain storage facilities (grain silos)"},{"id":"f058d856-1ce9-45cf-9d35-23956aa81d73","text":"Disruption of Black Sea grain exports after Russia\u2019s pullback from the UN/Turkey\u2011brokered Black Sea Grain Initiative"},{"id":"68d7b0c8-243a-418d-b915-b2bed9b72c41","text":"Reports and images early in the war of attacks on bakeries and food\u2011production infrastructure (bread factories/bakeries hit by strikes)"},{"id":"43d0da75-6cdb-4b26-9b82-eb000d5742c4","text":"CDC MMWR and other US reports documenting racial/ethnic differences in vaccine uptake (published analyses in early 2023 showing complex patterns of uptake across age and race)."},{"id":"ef8872a9-7c5f-45a1-8cee-50f47b855f12","text":"Office for National Statistics (ONS) release showing that, for some reporting periods, the majority of COVID-19 deaths in England occurred among vaccinated people (because most older people were vaccinated)."},{"id":"7f03d95e-812e-49fc-9c20-0456009ed9e6","text":"Czech arms firm Excalibur Group announced and began shipping refurbished T-72 tanks and other heavy equipment to Nigeria via Antonov An-225 flights out of Ostrava."},{"id":"2de3db1c-8206-4c97-ae05-14fa38749525","text":"Human Rights Watch report: \'Unguided rockets killing civilians\' in rebel-held Donetsk"},{"id":"2fa1a6c5-df78-45bf-b911-a34b2cf8635f","text":"OSCE Special Monitoring Mission spot report: residential area in Donetsk severely damaged by artillery"},{"id":"6ac1abfd-0548-4b06-add3-4ebb0962bfaa","text":"Battle and shelling around Ilovaisk with documented civilian casualties"},{"id":"e5d0fd9a-f56b-4b5e-bff1-04b44d086cf5","text":"Russian statements alleging Ukrainian cross-border shelling into Rostov/Donetsk (Russian claims)"},{"id":"a3564e9b-3a80-4277-b28a-f7cc608ae50e","text":"Medical organizations publish guidance clarifying medical\u2011emergency exceptions and clinical decision\u2011making after Dobbs (e.g., ACOG August 2022 resources)"},{"id":"868f36b1-faaa-45fc-99da-436b401f1b8f","text":"CMS issues July 2022 EMTALA guidance and related communications about emergency care for pregnant patients"},{"id":"8ef9e457-666c-4977-8ad8-a6188f7bb8b2","text":"U.S. Supreme Court decision in Dobbs v. Jackson Women\'s Health Organization overturns Roe v. Wade"},{"id":"004c8568-374a-4517-8f8b-8bad54f4d762","text":"UN warning (Nov 2015) that hundreds of thousands of children in Donetsk and Luhansk were at risk from potential failure of heating systems due to conflict damage"},{"id":"b29529c6-004d-4947-93f4-3254e37e260e","text":"2009 Russia\u2013Ukraine gas dispute: Gazprom cut gas supplies to Ukraine (and affected transit to Europe)"},{"id":"b40ce322-87a1-4be7-8027-452a7d47efc3","text":"Reuters special report: \'Ukraine struggles to control maverick battalions\' documenting undisciplined volunteer units and links to criminality"},{"id":"7ea2566d-1b56-4eb1-b668-d5efb760cb02","text":"UN OCHA situation reporting and media coverage documenting humanitarian access problems and reports of diverted/looted aid in Donbas (2014)"},{"id":"46be5e6f-5e7c-4dac-bf19-ba511307d0b4","text":"Kyiv Post coverage of volunteer battalion leaders publicly declaring assets, showing some leaders with property and cash"},{"id":"e07167f0-429b-416e-9454-dec0d9045cb6","text":"Randomized, double\u2011blind multicenter trial of the MCT-based product AC\u20111202 (Axona) reporting cognitive benefit in ApoE4\u2011negative Alzheimer\'s patients (Henderson et al., Nutrition & Metabolism)"},{"id":"f4250b4f-185e-4240-84f1-06dd55ea2513","text":"Mainstream media coverage of coconut oil as a \'health trend\'/\'miracle food\' that emphasized potential benefits while downplaying uncertainty (e.g., New York Times explainer on coconut oil)"},{"id":"dcf6c7fd-72a2-4fc0-b404-e0a1efed57c6","text":"SIPRI background paper and data documenting substantial Ukrainian arms supplies and military-technical cooperation with several sub-Saharan African countries (report published 2011)."},{"id":"e9e73205-eea9-4079-8e2f-017d20cd34e9","text":"High-level Ukrainian diplomatic visits to Africa (e.g., Ukrainian Deputy Foreign Minister Viktor Maiko visited Dakar, Senegal on 22\u201323 February 2013)."},{"id":"27a7e73d-295d-494b-aa25-d05f32b9905f","text":"UN General Assembly adopted a resolution declaring the Crimea referendum invalid (27 March 2014), with many states (including African votes and abstentions) visible in the roll call."},{"id":"52d05306-7b3e-4b56-905c-52d9adf81a77","text":"Ukraine opened new embassies in African states (DRC, Ivory Coast) as part of a push to increase presence on the continent."},{"id":"b09a9896-1292-49b9-9661-23c3fe0cec8f","text":"U.S. delivery of Javelin anti-tank missiles to Ukraine (2018)"},{"id":"e980e670-fd3b-4604-bf30-f315710cdea3","text":"U.S. missile strike on a Syrian airbase (April 2017)"},{"id":"ca8cd41a-bcd6-41ba-bbe2-0940279c571c","text":"U.S. B-52 bomber deployments and training flights in Northern Europe (March 2019)"},{"id":"037b5584-31b3-45ac-9f69-070ac5eb8829","text":"NATO\u2019s Trident Juncture 2018 large-scale exercise in Norway"},{"id":"f8013c0f-cc01-4be6-93f6-384857421899","text":"Russian leadership accusations that Ukraine was plotting attacks in Crimea (August 2016)"},{"id":"ca905cfb-ae15-4198-ba0d-051609c335cb","text":"Several European countries paused use of the Oxford\u2013AstraZeneca COVID-19 vaccine over reports of rare blood clots."},{"id":"fd40e2f8-9a3a-4d18-a733-cd715f9ce076","text":"Public availability of the VAERS adverse\u2011event reporting system and its raw data (VAERS data guide / public access documentation)."},{"id":"704783bc-11f4-4d6c-b839-d9f3b7f1324b","text":"Kenya says over 200 of its nationals are fighting for Russia in Ukraine"},{"id":"2d271a5c-928a-4930-96b4-129efebe1df5","text":"South African Presidency (SANews) confirmation that government is helping \'suspected\' nationals stranded after joining mercenary forces"},{"id":"07510bdb-9489-442b-a192-8176369edcf6","text":"European Food Safety Authority (EFSA) published a comprehensive scientific opinion on acrylamide in food highlighting potential cancer risks from dietary acrylamide exposure and identifying roasted/heat-processed products (including coffee) as contributors."},{"id":"aa1cb9f2-79f1-41a5-9ed1-df995778d99a","text":"Major news coverage (CNN) in April 2024 about concerns over chemicals used in decaffeination (methylene chloride/ethyl acetate) and calls from some health groups to restrict certain decaffeination methods."},{"id":"bfb94fe4-4411-47f5-af22-944d54d6257d","text":"Public statement attributed to U.S. envoy Kurt Volker that Crimea \\"cannot be returned by force\\""},{"id":"258719ec-bc17-4161-8038-22aaea9045ea","text":"Apple Maps controversy and Ukrainian diplomatic protest after Crimea appeared as part of Russia on some platforms (Ukraine diplomat publicly criticized mapping depiction, Nov 2019)"},{"id":"8a30da06-0220-4593-bd3d-77e921c8e4ac","text":"Media reports that U.S. Secretary of State Mike Pompeo allegedly told Ukrainian interlocutors \\"Crimea is lost\\" (reported in press coverage)"},{"id":"3ffd80c2-fde7-4f2c-8c31-8e29baaa1b45","text":"Widespread reporting of attacks on hospitals and medical personnel in Ukraine that cited Geneva Convention protections (60 Minutes / CBS News coverage)."},{"id":"6f22db37-dbab-4c70-b00a-de4ab5e1a28f","text":"Ukraine\'s parliamentary ombudswoman and other officials publicly accused Russia of mistreating Ukrainian POWs, saying Russia\'s conduct may violate the Geneva Conventions."},{"id":"7bf352ce-20a1-4705-b44e-d284a64f2dc9","text":"Release of policy/guidance analyses on solar climate intervention and governance (C2ES report)"},{"id":"f158a18e-8e7f-4fdf-88ac-f48f70fc099b","text":"Public reporting that Bill Gates funded geoengineering research (FICER / early funding disclosures)"},{"id":"78d2be66-b720-4f0f-8d4c-478dd5acbe21","text":"1964 NEJM publication on a vegetable-oil adjuvant (Adjuvant 65) tested in influenza vaccine trials"},{"id":"7310ed04-5712-4000-8ce7-8ed3d2ae62d4","text":"Children\u2019s Hospital of Philadelphia (Vaccine Education Center) guidance explaining peanut/corn oils are not used in routine vaccines"},{"id":"55f8ab79-cb3a-4bfe-b0cd-7f7e568f60c0","text":"Ukraine\u2019s health regulators updated guidance on clinical trials (28 Sept 2020) and Ukraine received inquiries/applications related to vaccine trials in autumn 2020 (reported in contemporaneous summaries of trial activity)."},{"id":"348f73f2-5d04-4cf7-bdee-7a8f5ec3e67c","text":"Johnson & Johnson temporarily paused its global COVID\u201119 vaccine trials after an unexplained illness in a participant (widely reported Oct 12\u201313, 2020)."},{"id":"6b437726-a25f-48f1-a4df-2d46e7e4af00","text":"Viktor Medvedchuk (pro\u2011Moscow Ukrainian politician) publicly criticized Kyiv\u2019s refusal to engage with Sputnik V and urged use of the Russian vaccine (comments reported Oct 26, 2020)."},{"id":"dfef6cce-2e7b-4cb8-a568-6acc38367d08","text":"First U.S. HIMARS systems delivered to Ukraine (first arrivals announced)"},{"id":"4c3bfbf2-3a8e-4c7d-8bc5-348fdbbc48b2","text":"U.S. National Security Adviser Jake Sullivan said the U.S. was \'not prepared to provide\' ATACMS long-range missiles to Ukraine"},{"id":"58f8bf85-a0a3-46a2-bea7-181eb9477611","text":"Russia\u2019s defence ministry claimed it destroyed four U.S.-supplied HIMARS launchers"},{"id":"dac09be7-9dcb-44dd-a432-f9b40d387ea9","text":"2018 global valsartan/ARB recalls for nitrosamine impurities (heightened nitrosamine scrutiny)"},{"id":"402de313-dc2a-4179-9d33-756d322fa7c6","text":"Pfizer records settlement charges resolving thousands of Chantix lawsuits (~$273 million)"},{"id":"367702f2-91ad-4a93-9dd2-0f8bb2859c71","text":"FDA approves Chantix (varenicline) for smoking cessation"},{"id":"335a890c-6ec5-456c-a805-47ac70e391fe","text":"FDA adds boxed warning for serious neuropsychiatric events (postmarketing, 2009)"},{"id":"9e8d5433-b960-46a3-b4a3-41a029fb9d00","text":"Longstanding scientific practice of \'semen washing\'\u2014techniques to remove HIV from semen\u2014has been reported in the literature since 1989 and studied in subsequent reviews (e.g., 2015), information available before May 28, 2022."},{"id":"2e574775-b70d-43d2-acb7-8d97dc6fe61d","text":"ONS regional excess-mortality update published showing higher-than-expected deaths through November 2022"},{"id":"64b63c87-6a47-40dd-90df-bb9b12f57bc6","text":"Peer\u2011reviewed reports of rare vaccine-associated myocarditis (published 2021\u20132022) received ongoing media attention"},{"id":"5834073d-b787-43e0-aef8-e4171853a791","text":"VAERS / adverse-event report releases and summaries through late 2022 widely circulated"},{"id":"75b664c9-cdd2-4d8c-9dc9-5ba708cd4eb0","text":"Construction and commissioning of the North Crimean Canal (Soviet-era large-scale diversion of Dnieper waters to Crimea, main works 1961\u20131971)"},{"id":"dc1adbc4-c3a2-4026-a250-03f9a8f6ebef","text":"PBS/NOVA special \'The Quest for Noah\'s Flood\' airs (TV documentary presenting the Black Sea deluge hypothesis to broad audiences)"},{"id":"a512f7db-5a67-4c26-8411-0d908211a5f8","text":"French National Assembly (lower house) adopted a non\u2011binding resolution calling for non\u2011renewal of EU sanctions on Russia"},{"id":"0432a5dc-9139-4f9e-8346-33d3633cf2f2","text":"High-profile promotion of ivermectin as a COVID-19 treatment by advocacy groups and physicians (e.g., Dr. Pierre Kory\'s Senate testimony) increased public attention to the drug"},{"id":"8987703c-09a0-4a89-b7de-26177897cfb5","text":"Italy imposes national lockdown amid surging deaths in Lombardy"},{"id":"b2da0a15-df9d-4652-8e36-56d2c0f29af2","text":"Launch and widespread use of the Johns Hopkins global cases-and-deaths dashboard"},{"id":"73442f47-7f8e-472e-9206-3f32b19a5161","text":"Publication of legitimate but small, case\u2011based autopsy and myocarditis reports showing rare fatal events after vaccination (peer\u2011reviewed case reports and small series)"},{"id":"abac13d2-7169-4c1d-b450-72fae04f1142","text":"WHO publication \'Considerations regarding consent in vaccinating children and adolescents between 6 and 17 years old\' describes \'implied consent\' as one approach"},{"id":"64edff3f-a376-4056-b11b-027d0773ca96","text":"Public controversy and regulatory curtailment of Delta water export pumping to protect endangered delta smelt"},{"id":"a6b153e0-68cf-4345-b16a-5d5466f30f29","text":"2002 Klamath River fish kill and disputes over irrigation curtailment"},{"id":"bb26bcd8-0a0f-4bba-8469-7880dae97789","text":"Governor Jerry Brown issues Executive Order B-29-15 mandating 25% statewide urban water-use reductions"},{"id":"373f6412-6baf-43eb-8677-2ed1f31c6eaa","text":"Oroville Dam spillway failure and emergency releases that forced evacuations"},{"id":"4a142742-30f0-48ff-9d5c-cad9814da2e8","text":"Regulatory debate and slow approval process for new sunscreen active ingredients (Sunscreen Innovation Act enacted Nov 26, 2014; ongoing FDA reviews of sunscreen ingredient safety)."},{"id":"c1357c61-adf8-4bbc-8ee2-91964a807394","text":"Published toxicology and endocrine-disruption research and reviews (e.g., reviews summarizing in vitro/animal evidence that some chemical UV filters like oxybenzone have endocrine activity)."},{"id":"37f4799e-ac16-4d40-9bf7-7b2e33db04b4","text":"April 2015 Calbuco eruption (Chile) \u2014 satellite and news reports quantified large volcanic gas/ash emissions during the explosive event."},{"id":"7c0622b6-4c06-434c-a1c1-e220f0a5abd0","text":"Publication and dissemination (2011) of quantitative comparisons of volcanic vs. anthropogenic CO2 emissions (T.M. Gerlach, EOS/AGU summary and related USGS-hosted PDF)."},{"id":"9d3d7a4c-8dfa-4061-8966-1c80e104d1dd","text":"CDC and FDA recommend a temporary pause (April 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of a rare clotting disorder (TTS)"},{"id":"f422c635-230d-4085-894e-77e4bc8d2a2b","text":"European Medicines Agency (EMA) finds a possible link between the AstraZeneca vaccine and very rare blood clotting events and recommends listing them as very rare side effects"},{"id":"48871f40-b374-43ad-acd0-10030f089443","text":"Israel reports a probable link between the Pfizer-BioNTech vaccine and a small number of myocarditis cases following vaccination"},{"id":"65bfb0ea-7932-43c3-913f-5df60038e8ab","text":"Japan finds foreign (black/stainless steel) particles in multiple Moderna vaccine vials, prompting suspension of specific lots"},{"id":"88135041-5a6a-4054-b86b-377b5fcc84a6","text":"IPCC release of the Special Report \'Global Warming of 1.5\xb0C\' (SR1.5)"},{"id":"2e24562f-fb40-4a6a-a30a-ae3834c49445","text":"IPBES Global Assessment Report on Biodiversity and Ecosystem Services (press release)"},{"id":"9b6368f5-3479-4185-8bdd-eb93154ad53a","text":"Regulatory updates and clarifications on convalescent plasma donor eligibility by U.S. regulators (FDA guidance changes)"},{"id":"f319eb18-5151-41ec-ab61-08335d766535","text":"American Red Cross public guidance clarifying vaccinated people are eligible to donate (FAQ)"},{"id":"e8e3ddc6-6a6c-4652-a4e0-4667177529de","text":"Different national blood-service wait times after COVID vaccination (e.g., Australia Lifeblood 3\u2011day deferral)"},{"id":"bdbccbbe-eee1-446c-b0a8-4d84bc8334a1","text":"National HIV surveillance/monitoring reporting showing ongoing variant diversity and surveillance activity in the Netherlands (HIV Monitoring Report 2021)"},{"id":"7b2fc77e-9928-4b79-a078-6220f6106ae5","text":"Earlier research documenting an HIV recombinant (CRF19_cpx) associated with rapid progression to AIDS in Cuba (2015)"},{"id":"fc2221fd-331e-4e4d-9500-ee288d246c3c","text":"Earlier punitive COVID-era measures: France suspends about 3,000 unvaccinated healthcare workers without pay after mandatory vaccination rules (September 2021)."},{"id":"22e284db-951a-4166-9096-35c264340b2e","text":"French National Assembly adopts (first reading) Article 4 creating a new offence of \\"provocation \xe0 l\'abandon ou \xe0 l\'abstention de soins\\" (encouraging people to abandon medical treatment)."},{"id":"a44177d6-2464-4605-b4b7-dbeef94f5949","text":"Large, recurring anti\u2011vaccine and anti\u2011pass protests in France (e.g., national rallies with >100,000 participants on 9 January 2022 and major protests in 2021)."},{"id":"636d70cc-b434-4ae6-9e92-4d776254bd53","text":"Article 4\'s text (as adopted) includes penalties up to one year in prison and \u20AC15,000 fine, rising to three years and \u20AC45,000 when the provocation \'has been followed by effects\'."},{"id":"b69b00bd-1c0f-4c05-bc07-81f2e3e39b4e","text":"Ukraine files case and ITLOS issues provisional measures in dispute over detained Ukrainian naval vessels (Ukraine v. Russian Federation)"},{"id":"61bedcf1-152f-4e4c-8cc2-f36e308c8054","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels"},{"id":"b19f7cda-33d5-40f6-b0d5-eb8e9af54659","text":"Coverage noting Russia\'s gain of maritime/sea resource claims after annexation (media analysis of rights to offshore resources)"},{"id":"f9605271-979c-44cc-ad70-a9223ad34a55","text":"Reporting on foreign volunteers and fighters joining both sides in the Donbas conflict (including fighters who joined Azov)"},{"id":"16f99f21-2a2b-411d-b650-b44faaad6bb2","text":"Publicised incidents in August 2014 where Ukraine displayed captured Russian servicemen"},{"id":"228dafec-172f-4d6f-a160-297e589c447b","text":"Norway investigation (January 2021) into deaths of 23 frail elderly patients shortly after Pfizer/BioNTech vaccination"},{"id":"7d27a311-e2d7-4230-9432-759924944e8e","text":"World Bank reports sharp contraction in remittances to Ukraine in 2014\u20132015 (noting drops from Russia)"},{"id":"c17b3626-b338-48e3-b571-2baade16e313","text":"IMF approves a $17.5 billion loan program for Ukraine (March 2015)"},{"id":"59e758c1-c8a0-4494-ac3a-233f6cf71575","text":"Russia announces and enforces bans/restrictions on Ukrainian food and agricultural imports"},{"id":"63801b9b-1d6b-45df-937d-05ef8f6c6465","text":"Gazprom reduced/cut natural gas supplies to Ukraine amid pricing and payment disputes"},{"id":"4c8e9da5-5bdc-4932-8d55-41984416cd05","text":"USDA launches the \'Partnerships for Climate\u2011Smart Commodities\' program and announces $1 billion investment to support climate\u2011smart practices, including regenerative approaches (Feb 7, 2022)."},{"id":"4470e99a-dacf-40c0-92d2-cf36af84c32e","text":"General Mills publicly commits to advancing regenerative agriculture on one million acres and launches partnerships and promotional materials (announced in 2020)."},{"id":"c7a5bcbc-2006-4764-8207-620d09886a38","text":"Publication of scholarly review \'What Is Regenerative Agriculture? A Review of Scholar and Practitioner Definitions\' (Frontiers in Sustainable Food Systems, 2020) documenting inconsistent definitions and mixed empirical evidence on soil outcomes."},{"id":"69fda331-49f4-41e8-91fd-54e672b4af61","text":"Case report: \'Development of High\u2011Grade Sarcoma After Second Dose of Moderna Vaccine\' (Cureus case report)."},{"id":"c48d12ac-4849-4c1d-a010-8c0445099769","text":"Publication describing diagnostic pitfalls after COVID\u201119 vaccination (e.g., post\u2011vaccine lymphadenopathy causing false\u2011positive oncologic imaging findings)."},{"id":"218979e2-6346-46d5-84e7-bcf3652d7a9b","text":"Ukrainian leadership publicly framed parts of the conflict as involving \'foreign mercenaries\' (statement by President Petro Poroshenko), drawing international attention to non\u2011Ukrainian fighters."},{"id":"78cfbbbe-314b-4a70-9cb8-db5cf39b5d72","text":"Media reporting and profiles linked ASBS Othago to former Polish Interior Minister Bart\u0142omiej Sienkiewicz and documented the firm\'s past activity/contracts (company background coverage in June 2014)."},{"id":"af2ce867-2914-4513-8c2f-62a70058b763","text":"Separatist commander Igor Strelkov (Girkin) and associated militia briefings in late July 2014 repeatedly alleged that foreign mercenaries (including Poles) were operating and being killed in Donbas."},{"id":"b79c0518-028b-42b2-a7b8-55238d2da5d2","text":"IPCC Fifth Assessment Report (AR5) \u2014 Summary for Policymakers (WG1)"},{"id":"04b492a5-c4c7-4b19-bb3c-45a7054015bb","text":"U.S. announcement of withdrawal from the Paris Agreement (President Trump, June 2017)"},{"id":"c92d754a-4f19-4748-bb42-dd99695f6ae4","text":"Detailed reporting on Ukraine\'s use of electronic warfare to jam drones and communications"},{"id":"ca3c207a-2dd4-4d6e-b63a-2a6eb4f34133","text":"Explosion in Przewod\xf3w, Poland kills two amid Russia-Ukraine attacks"},{"id":"56582cd1-f8c4-4a94-a701-1c06b71c798e","text":"Coverage of the proliferation of small, portable EW systems (\'EW backpacks\') used by Ukrainian forces"},{"id":"fcfe8808-9e01-45de-93f6-29d62e4ecc7e","text":"Reporting on routine use of drone swarms and the complexity of attribution in drone warfare"},{"id":"999182db-2625-4ed4-bee4-2651ff7ab1f4","text":"Precedent: Ukraine imposed sanctions/entry bans on foreign politicians (e.g., three French MEPs) who visited Crimea without Kyiv\'s permission."},{"id":"d5c07d75-9a2b-4f52-9375-4e117e5c9de0","text":"ACT UP protests and high\u2011profile demonstrations targeting Burroughs Wellcome and regulators over AZT pricing, access and trial practices (1988\u20131989)"},{"id":"762e6407-10e1-4560-b0ca-3d37bb092d6c","text":"FDA approval of AZT (zidovudine) in March 1987"},{"id":"39a925b2-b74c-4874-bc92-c3cbfdc46c80","text":"2019 electoral performance of pro\u2011Russia parties (Opposition Platform \u2014 For Life) showing notable support in southern/eastern Ukraine in parliamentary elections."},{"id":"fb3a1bf0-a119-4364-a911-6554bb3613f7","text":"Release/presentation of the Resilient Ukraine \'National resilience characteristics\' survey including Odesa results (Resilient Ukraine/ICDS research presented mid-November 2021)."},{"id":"bd6239fd-09e8-4ff6-8c9a-79bb5394f59b","text":"2001 Ukrainian census language data for Odesa region showing a high share of Russian speakers."},{"id":"b9666832-ade3-4dd6-98de-b270acc661b6","text":"May 2, 2014 Odesa trade union building fire and subsequent portrayal in Russian/state and pro\u2011Kremlin media."},{"id":"60f86427-d4ae-47e8-bb90-2baa9a16eaa3","text":"Reporting on volunteer battalions and Ukrainian units using mixed, Soviet- or foreign-origin uniforms and equipment because of shortages (Reuters special report)"},{"id":"c40215cb-f88d-4c3c-bef4-40584de842fc","text":"OSCE Special Monitoring Mission reported observing convoys and personnel in Donetsk/Luhansk in unmarked dark-green uniforms and unmarked armoured vehicles (spot reports 2014)"},{"id":"29d17b68-96a8-410d-acb8-8f586fd813c3","text":"Publication of JAMA case series reporting 88.1% mortality among mechanically ventilated COVID\u201119 patients in New York (Richardson et al., 5700 patients)."},{"id":"60b4df88-018b-4498-9d6b-675151d5ae0a","text":"Japan suspends use/shipments of some Moderna vaccine batches after reports of foreign particles in vials"},{"id":"5d6392b7-7672-4984-90c2-2bbc04d3e340","text":"Assassination of Arsen \'Motorola\' Pavlov in an elevator explosion in Donetsk"},{"id":"42e7d87f-ac81-49a4-b5ef-227fee56c62f","text":"Reports by human rights groups documenting repression and propaganda targeting Crimean Tatars (2014)"},{"id":"3fa92da9-bf8a-476c-b420-e17386dc2c3d","text":"Large pro\u2011Ukraine rally organised by the Mejlis (February 26, 2014)"},{"id":"91111922-c5d4-4a81-8de2-6b66f1c3279b","text":"Japan suspends proactive recommendation for the HPV vaccine"},{"id":"d1ab25fa-1cfd-41e4-bd76-cdd74ca6bb2c","text":"Controversy and parliamentary inquiry into HPV vaccine projects in India (PATH studies)"},{"id":"acc49a20-eaf2-404b-9bec-b4368de91130","text":"Increased public reporting and media coverage of adverse events (VAERS data highlighted) around 2015\u20132016"},{"id":"bdb876f5-73e9-4c5d-b8b8-24a290e4ffe4","text":"International Paralympic Committee (IPC) decision to allow Russian and Belarusian athletes to compete under their national flags at the Milano Cortina 2026 Paralympics."},{"id":"effb38df-4036-4437-9033-bcf6992ca029","text":"Ukrainian government/officials announced they would boycott Paralympic officials\' attendance (ceremonies) in protest while specifying that athletes would still compete."},{"id":"cf2b8c88-247b-4d9c-8c52-d1ab5bfcda93","text":"New York Times report (June 25, 2022) on a covert \'commando network\' of U.S. and allied forces coordinating weapons and assistance in Ukraine"},{"id":"472f2da8-0427-4361-9b25-4d93d7c41104","text":"CIA Director William Burns publicly estimated roughly 15,000 Russian troops killed (U.S. intelligence estimate) at the Aspen Security Forum"},{"id":"7213d7a8-55b7-41c7-8d70-7dc155ca102f","text":"FDA pediatric vaccine briefing document noted reported seizure events in surveillance/clinical data"},{"id":"c5f9c08b-5324-42f7-a3c5-bb9deb54375f","text":"European Parliamentary Research Service brief explaining the religious split and the Tomos process (EPRS brief on Ukraine and religion published Jan 2019)."},{"id":"68bc38f6-99cb-4a95-9d9f-fecd624d95d2","text":"Media reports and commentary documented Poroshenko\'s \'Tomos tour\' and use of the Tomos in his re-election campaign (coverage in KyivPost, Financial Times and others in Jan\u2013Feb 2019)."},{"id":"35ea6519-3949-4886-af7c-a16415792eca","text":"Ecumenical Patriarch Bartholomew signed and handed over the Tomos of Autocephaly for the Orthodox Church of Ukraine (Tomos ceremony and handover in Istanbul/Kyiv, early January 2019)."},{"id":"c1724b7f-f234-404c-a369-09e839958054","text":"Ukrainska Pravda report that Polish special\u2011forces personnel guarded Ukrainian negotiators (Brest/early March 2022)"},{"id":"eff22e41-0c9b-40c6-af46-0f65af2be234","text":"New York Times report revealing a \'commando network\' of Western special-operations personnel assisting Ukraine"},{"id":"621e30a8-e3a6-4a1e-8148-625c788f17ba","text":"Persistent academic and policy\u2011community discussions in Russia and elsewhere promoting the \'deep/abiogenic oil\' idea (conferences, review articles and summaries circulated throughout the 2010s and continuing into the early 2020s)"},{"id":"7c23a944-c1c8-4e60-ad55-a315dd953f0a","text":"Experimental laboratory evidence (Kolesnikov et al., Nature Geoscience) showing that methane can produce heavier hydrocarbons under upper-mantle pressure\u2011temperature conditions (widely cited by abiogenic proponents)"},{"id":"508d98f3-daa9-48ab-94e6-c84842abd664","text":"First confirmed delivery/arrival of German PzH 2000 howitzers to Ukraine"},{"id":"db1a7681-204e-4a6e-bee8-7555e7d1e7bb","text":"Published research on extreme droughts and increased tree mortality in the Amazon (e.g., record\u2011breaking 2015/2016 drought analyses and 2016 Nature Scientific Reports paper)."},{"id":"5702700a-9e3a-4d47-bd2f-f6267d3bfb8a","text":"Public interviews and quotes from climatologist Carlos Nobre (2019) stating that \'over fifty percent of the Amazon may be lost within decades\' if tipping points are crossed."},{"id":"45c89f5e-2f92-41fc-9e61-9a7bdd31acef","text":"Passage of Ukraine\'s \'decommunisation\' laws and ensuing public debate, including renewed official attention to OUN/UPA memory"},{"id":"e11cd318-1c62-482d-956c-1e3fef6d9597","text":"Existence and history of paramilitary/nationalist groups using \'tryzub\'\u2011related names and insignia (e.g., Tryzub organisation formed 1993)"},{"id":"0a63eac9-8b10-4812-845e-27384d4011ce","text":"International reporting on the Azov volunteer unit\'s far\u2011right links and symbols (including 2014\u20132015 coverage)"},{"id":"051ea1e9-5523-46c7-9da6-88c538586f18","text":"Spanish\u2011language press and analyses highlighting the rise/role of ultranationalist groups in Ukraine"},{"id":"18627898-a921-455c-93d6-8ce216b6c674","text":"Great Barrington Declaration advocating \'focused protection\' and natural herd immunity"},{"id":"71b6d51c-90a4-4139-852f-aee305ae0835","text":"CDC launched the COVID-19 Seroprevalence Studies Hub (SeroHub)"},{"id":"6b5b3209-851c-45f6-85da-5cd1c52ea48c","text":"SeroTracker dashboard providing compiled seroprevalence estimates"},{"id":"a97c39db-1aed-4a0c-904d-6b9a2bdc8ce9","text":"Office for National Statistics (ONS) dataset \'Deaths by vaccination status, England\' (period analyses up to May 2023)"},{"id":"19e3f2e7-1f5f-4057-8c33-eaa88ecd8b11","text":"Early patient\u2011led surveys and small observational preprints reporting mixed effects of vaccination on long\u2011COVID symptoms (e.g., Massey et al. medRxiv July 2021)"},{"id":"755c3d09-13eb-488d-aafe-355aee37e54a","text":"Publication of Choi et al., \'Developmental Fluoride Neurotoxicity: A Systematic Review and Meta\u2011Analysis\' in Environmental Health Perspectives (lead author Anna L. Choi, Harvard affiliation)."},{"id":"8f8a1fe0-054c-4805-91d2-1f315564e9e2","text":"WHO Expert Committee review and public statements on cannabis (pre-review June 2018; outcomes published Jan 2019)"},{"id":"c04e7acb-a195-4fa0-bd8a-2ac9d90dc9f1","text":"Preclinical studies showing cannabinoids can promote hippocampal neurogenesis (mid\u20112000s lab research)"},{"id":"8f08754d-53ef-4d85-8001-af0a15e08cc7","text":"Ukraine filed an application instituting proceedings against the Russian Federation at the International Court of Justice (ICJ)."},{"id":"fda6b7dd-0801-43b6-b4eb-0387977a987d","text":"Reports that U.S. intelligence and law\u2011enforcement personnel were advising Ukraine"},{"id":"40536ea9-1e09-4388-9c4e-a20eb9b71204","text":"U.S. Ambassador Geoffrey Pyatt photographed paying respects at Kyiv\'s Maidan"},{"id":"5d664621-21f3-4440-8668-201728d0a3f0","text":"Ukraine\'s State Emergency Service and local reporting confirmed an apartment building on Lobanovs\'koho Avenue was hit by a missile during strikes on Kyiv."},{"id":"c2e16897-3bc7-44c5-ae38-8d5b76119a14","text":"Russian missile strikes and intensified attacks in Sumy region (producing civilian casualties and damaged infrastructure)"},{"id":"6dd11535-10d3-47ab-b07b-308c6c7ab99c","text":"Previous high-profile deaths of Ukrainian servicewomen (example: combat medic Yana Rykhlitska killed in action)"},{"id":"e124c13f-6a31-4552-b776-9c8cd3da2e20","text":"Public announcement and press coverage of Ukraine\'s new all-female drone unit (\'Harpies\') and recruitment drive"},{"id":"b0d60f47-6669-4391-b656-a5f96dccbc74","text":"Valentyn Nalyvaichenko had been appointed Head of the Security Service of Ukraine (SBU) in February 2014 and became a high-profile security official."},{"id":"f8254991-a263-4f0f-b469-53086ef94686","text":"Publicly known foreign-volunteer pathways to serve in the IDF (the \'Mahal\' / volunteers-from-abroad tradition)"},{"id":"4964ca25-06aa-4cf2-876f-69e4a7690652","text":"Large influx of Ukrainian refugees to Israel after Russia\'s 2022 invasion"},{"id":"2e07a7b1-49cf-4d84-9b94-641aea283ddf","text":"Hamas surprise attack on Israel and ensuing nationwide mobilization (Oct 7, 2023)"},{"id":"865462a9-8a34-448c-bb8c-328656ba28e6","text":"Heavy fighting and Ukrainian forces retake Donetsk airport, with immediate reports of dozens killed and injured"},{"id":"fb123684-7415-483d-a978-fec91ccba8b5","text":"Widespread reporting that Boris Nemtsov was a prominent Kremlin critic and vocal supporter of Ukraine"},{"id":"b3f91f51-786d-436f-9d18-3ff001743926","text":"U.S. Ambassador John Tefft publicly laid flowers at the makeshift Nemtsov memorial near the Kremlin"},{"id":"ed690654-d87d-4362-9e8d-10d320020a00","text":"Reports of foreigners and \'protest tourists\' crossing from Russia into eastern Ukraine"},{"id":"d6d7c667-9bc6-4290-b657-06e4474549ec","text":"High\u2011profile history and public memory of U.S. private military firms (e.g., Blackwater) from Iraq"},{"id":"994b681b-2928-4c7f-a53a-6f9dad1c6bac","text":"Pro\u2011Russian protesters and armed men seize Donetsk regional government building"},{"id":"da46e9b8-c3ee-4f06-a499-08731c676f75","text":"Unmarked, heavily armed \'little green men\' operate in Crimea, raising questions about covert foreign forces"},{"id":"a5f1b802-c83e-4b26-b021-63db9730cf9a","text":"CDC release and analyses of NHANES dental fluorosis data (analysis of 1999\u20132004 and 2011\u20132016 data; Vital and Health Statistics Series 2 No. 183)."},{"id":"589b69b1-8cf4-47d6-9557-8ed7a4dbe822","text":"FDA\u2011required poison warning language on fluoride toothpastes and Poison Control guidance advising to contact poison control if a child swallows more than used for brushing."},{"id":"947eb814-56a8-407d-abce-805377cabbd3","text":"Later laboratory research reporting synergistic inhibitory effects of capsaicinoids on platelet aggregation (e.g., Blood Coag Fibrinolysis / related 2018 study)."},{"id":"3035d86b-acc0-4403-bffd-6700fef7bb0c","text":"Polish media coverage of the Bykivnia visit and related Polish\u2011Ukrainian historical memory issues (coverage in outlets such as Dziennik.pl / Polskie Radio)."},{"id":"a2baeb15-6e10-4fd9-805d-c5d5f7720324","text":"CDC recommended community use of cloth face coverings (change in U.S. guidance)"},{"id":"042d73a9-eff0-48d9-87f1-42da99cdea5f","text":"CDC/NCHS issued expanded guidance on certifying deaths due to COVID-19"},{"id":"c16348f4-f677-4500-9bce-e94363964920","text":"WHO interim guidance stated limited direct evidence for universal masking in healthy community members"},{"id":"850cf0c3-c0b7-4270-a07b-2845822447ed","text":"Official surveillance reporting showed an unusually low influenza season during the COVID-19 pandemic"},{"id":"eb81506a-1e5d-49a4-b1e0-78fa8d5785ab","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers states strong evidence of human influence on the climate system"},{"id":"d42a2ca4-b7f8-4e98-a8a3-231bc4ccccff","text":"NSIDC and NASA report record-low Arctic sea ice extent in 2007"},{"id":"876cafe0-7630-405c-b6e1-94aad8874fe2","text":"Adoption of the Paris Agreement at COP21, driving major political attention to climate policy"},{"id":"5f1983cf-65eb-463a-8550-1f6af19a3988","text":"Ukrainian authorities released video footage they said showed a Buk missile launcher being moved in rebel\u2011held eastern Ukraine"},{"id":"d2e60abb-a3b6-4cdb-8512-655a66edd080","text":"Pro\u2011Russian separatists and armed groups restricted and controlled access to the MH17 crash site, and international observers reported limited/unfettered access and allegations of tampering"},{"id":"42af163d-b12c-48f8-8f72-f5bf6759e608","text":"Germany publicly approved and announced it would send Leopard 2 main battle tanks to Ukraine, prompting high-profile media coverage."},{"id":"9eec3efe-4807-4322-886e-22aa5f0309a5","text":"Russian leadership and state media advanced a \'denazification\' narrative about Ukraine beginning with Putin\'s public addresses in February 2022."},{"id":"9ed66cda-429d-4b92-8a4c-8184ff773926","text":"FDA issued authorizations in September 2022 for updated (bivalent) COVID\u201119 booster doses under Emergency Use Authorization rather than new full biologics license approvals."},{"id":"36a12859-4750-4aaa-9c12-392e90d727eb","text":"FDA formally approved the Pfizer\u2013BioNTech COVID-19 vaccine (Comirnaty) \u2014 first COVID-19 vaccine to receive full FDA approval."},{"id":"1c97aaf9-42ae-463e-a597-d94917fde197","text":"UN and international media reporting (May 2014) documenting allegations of abuses by volunteer battalions and armed groups in eastern Ukraine"},{"id":"1fb3f6d4-c8cd-4d56-9cec-0948e64aaeda","text":"Formation of the Dnipro\u20111 volunteer/special police battalion in April 2014, linked to local oligarchic support"},{"id":"e2ac372d-a166-4881-9474-9c11807b1178","text":"Violent crackdown on Euromaidan protesters in Feb 2014, including widely reported beatings with batons and sticks"},{"id":"a6f8b9a8-185b-4f04-bcf2-404080257ea8","text":"Ihor Kolomoisky appointed governor of Dnipropetrovsk Oblast, giving him formal regional authority and visibility"},{"id":"3a958841-35e3-4334-b6b0-5e888a760ced","text":"Odessa trade-union building fire and mass deaths during clashes"},{"id":"37fce88b-2358-4766-9435-a0717c3405c5","text":"Public torchlight marches and commemorations for Stepan Bandera in 2014 (Lviv and elsewhere)"},{"id":"8426f0f1-04a1-4750-92e4-99b90403eae0","text":"Prominent role and publicized violence of Right Sector during Euromaidan/early 2014"},{"id":"04c77015-a45b-4365-9b9e-74d977cbc12f","text":"Japan suspended use/withdrew batches of Moderna COVID\u201119 vaccine in August 2021 after reports of particulate contamination in some vials."},{"id":"c0b7a5eb-b0bf-47b5-a328-58a0f3ff8bd0","text":"Publication of Tokyo autopsy series (Legal Medicine) reporting autopsy findings for deaths occurring shortly after COVID\u201119 vaccination and noting a small number of cases with possible vaccine\u2011related causes (e.g., myocarditis, thrombosis) \u2014 November 2022."},{"id":"2fe478ae-a877-44a3-8f18-668db21a5348","text":"National Academies report (December 2020) assessing unexplained health incidents among U.S. government personnel concluded that directed, pulsed radio\u2011frequency (RF) energy is a plausible mechanism for some cases (\'Havana Syndrome\' assessment)."},{"id":"f61d6cc9-2903-4136-884f-7b3e17d13179","text":"Media reporting on China\u2019s expansion of large-scale weather\u2011modification programs (cloud\u2011seeding and the proposed \u2018Sky River/Tianhe\u2019 projects) intensified in late 2017\u20132020 (notably coverage in Dec 2020)."},{"id":"eea34e2f-2775-4904-93fe-62aaaaabe850","text":"University of Alaska Fairbanks (UAF) formally received operation of the HAARP facility from the U.S. Air Force and opened the site to civilian researchers and public outreach (transfer ceremony and subsequent open house)."},{"id":"29a35ac1-ec35-49be-b7b3-426e424bdfa5","text":"Venezuelan President Hugo Ch\xe1vez publicly suggested a \'tectonic weapon\' or U.S. involvement caused the 2010 Haiti earthquake, and political leaders and commentators repeated similar claims after major quakes (2010\u20132011)."},{"id":"a2ecdc6a-41ca-4b32-92be-1de1a2628ea6","text":"Ukrainian Foreign Ministry summoned the Polish Ambassador to Kyiv (Jan Piek\u0142o) in response to statements by Poland\'s foreign minister."},{"id":"933adce9-9b87-4807-b8f6-6cbb181e88fc","text":"Poland\'s Ambassador to Ukraine Jan Piek\u0142o publicly said Poland and the United States could be part of alternatives to the Minsk process and argued that Crimea should be on the Minsk talks agenda."},{"id":"06831552-14e5-4569-9ca9-c47d8f2f1201","text":"Reports quoting former Polish foreign minister Rados\u0142aw Sikorski that Vladimir Putin in 2008 allegedly suggested dividing Ukraine with Poland (widely publicized in 2014)."},{"id":"06d044b0-5302-484d-85db-51994723b229","text":"Polish Foreign Minister Witold Waszczykowski gave a combative interview to weekly \'wSieci\', saying, among other remarks, \'With Bandera you won\'t enter Europe\' and criticizing Ukrainian historical politics."},{"id":"5d1a9831-cc92-4115-a2ec-ff7210d9087a","text":"2012 \'Blood, Urine, and Sweat (BUS)\' studies reporting detectable levels of some toxicants in sweat"},{"id":"4600efc9-06a8-4dff-8c12-b27c8914405b","text":"FDA warning letter (July 5, 2022) to a company marketing an infrared sauna with unapproved therapeutic/detox claims"},{"id":"561d7581-dc0e-40b9-b96b-ac143f095121","text":"Publication of 2015 JAMA Internal Medicine study linking frequent sauna use to lower all-cause and cardiovascular mortality"},{"id":"1150a8df-dadc-4460-8904-03d1f9c58dfb","text":"Amnesty International published reporting documenting civilian deaths and indiscriminate attacks in Donbas, Ukraine (providing background of real civilian suffering)"},{"id":"1b7ef4c2-1108-40b4-9481-c4e4be2b09e6","text":"Public U.S. warnings linking continued international support to Ukraine\'s anti\u2011corruption progress (December 2015 coverage)"},{"id":"f6d886b4-d0a4-4969-bc31-c67b520d2a5c","text":"Hunter Biden appointed to the Burisma board (widely reported in 2014)"},{"id":"dbe8b6ac-605c-4478-be22-c0b7129ee99d","text":"Historical precedent of Ukrainian naval vessels being decommissioned and scrapped in prior years (public records and lists of former warships show multiple vessels written off or dismantled)."},{"id":"6b1d58c8-d531-46d1-a3de-d3942338e3a8","text":"The Okean (Ocean) Mykolaiv shipyard complex was sold at auction to Annona Trading House for UAH 122.195 million (about $4.3 million)."},{"id":"01aa59fb-ce8d-4b3d-a98a-b57b041b163e","text":"Local reporting and commentary documented the shipyard\'s long-term decline and degraded equipment under previous ownership (public discussion by local officials and regional press about dereliction and need for investment)."},{"id":"e13d298d-79b0-4aee-909e-3952b920571e","text":"House Science Committee hearing and whistleblower accusations about NOAA data handling"},{"id":"6bf705ce-a12a-4f60-949e-6c0cae0a8d0c","text":"NASA GISS documentation of methodological updates to the GISTEMP record"},{"id":"b1f8420d-1434-4ed7-9e9b-2f5b401ea971","text":"NOAA Coral Reef Watch documents a global-scale coral bleaching episode affecting reefs worldwide during 2014\u20132016 (the largest recorded to date)."},{"id":"72373a32-4718-429d-865f-959e3973a9d6","text":"ISW Russian Offensive Campaign Assessment (weekly assessments around Nov 11, 2024 noting Russian tactical gains such as leveraging Vuhledar seizure)"},{"id":"b11bf74a-611d-494c-8e3f-958935e00c4c","text":"Reporting that Trump advisers proposed halting U.S. military aid to Ukraine unless Kyiv negotiated (June 25, 2024 Reuters)"},{"id":"b72f4d99-5380-4d0e-915e-78d8f4f84bbd","text":"CNN publishes/airborne footage and reporting in early September 2024 showing videos of Ukrainian soldiers attempting to surrender and one apparent execution"},{"id":"f167b354-bd64-4739-bc03-653bb6852739","text":"Russian strikes on Kyiv (10 June 2025) damaged a building identified by some outlets as the \'former British visa centre\'"},{"id":"463757ac-1c31-450b-a9d8-1f782bf7eb1f","text":"Official suspension/relocation of UK visa/consular services from Kyiv during March 2022"},{"id":"4616c099-332d-48b0-be2a-147071ab69a7","text":"CDC issued expanded guidance on certifying COVID-19 deaths allowing confirmed and probable cases to be recorded and included in counts."},{"id":"06d01bdf-9277-442b-b673-b5c5a365b0ce","text":"Italian National Institute of Health (ISS) reports showed a high proportion of COVID-19 deaths had multiple pre-existing conditions."},{"id":"67c0c967-1278-4a1b-a074-7121b12841f5","text":"FDA authorizes Pfizer-BioNTech and Moderna COVID-19 vaccines for children down to 6 months old"},{"id":"48b3fcf6-2759-4a7a-8c1d-a26c0c29ee77","text":"CDC publishes MMWR update on cases of myocarditis after mRNA COVID-19 vaccination in adolescents and young adults"},{"id":"9f35f38b-3794-4d37-a1c4-bf60d8e4a48b","text":"President Zelensky announced the creation of an \'International Legion\' and Ukraine openly called for foreign volunteers in late February 2022."},{"id":"41ac5159-bb0b-47a6-bb2f-f18ba9c57586","text":"Ukraine imposed martial law and restrictions on men aged 18\u201360 leaving the country after the full\u2011scale invasion, generating widespread reports that men could not leave to avoid conscription."},{"id":"9a4d6d1a-bfe6-4637-9368-05a0a90b2fcb","text":"UK Foreign Office advised British nationals to leave Ukraine and temporarily relocated its embassy office from Kyiv to Lviv amid the Russian build\u2011up."},{"id":"c0920958-79a0-44a2-bbc3-7e899fb22b93","text":"Ukraine enacted further mobilization/conscription measures and parliamentary changes to expand recruitment in mid\u20112024, attracting renewed international media attention."},{"id":"4f1c0efe-9bc3-44aa-a1b9-1a380a3cf4fa","text":"Major anti-corruption probe and arrests tied to alleged fraud in Ukrainian arms procurement"},{"id":"4a46bc74-222c-4fe2-98d3-e36e76688bb5","text":"Reporting on soldier and veteran grievances over pay, conditions and budget shortfalls"},{"id":"b257e337-06ca-43af-ac54-206bb782b9ce","text":"Media coverage that Western defence contractors and arms firms saw revenue gains linked to the Ukraine war"},{"id":"2efd1f8e-6d3f-4e58-a5d7-d2874f20715f","text":"Documentation of pro\u2011Kremlin narratives claiming Western military aid \u2018prolongs the war\u2019"},{"id":"ca9816ae-1d2d-49ea-a74f-44b004b3a8fb","text":"Mainstream reporting on official research into solar geoengineering / stratospheric aerosol injection (interpreted by some as \'admissions\' of atmospheric spraying)."},{"id":"50fd46cc-8d8f-4fe7-a98c-155464bb72a9","text":"Publication of the 2017 \'5G Appeal\' by >180 scientists and doctors calling for a moratorium on 5G"},{"id":"d0c00902-401a-4f43-ab0f-ce04bcc0cafe","text":"Germany granted final permit for Nord Stream 2 (March 2018)"},{"id":"017d0131-e8e6-4734-97f5-63d75131529d","text":"Naftogaz announced Ukraine would resume buying gas from Russia in 2018"},{"id":"3dbcfda4-9a03-4305-9433-8138b360536a","text":"Late-November 2018 cold snap in Europe caused sharp rise in gas demand and prices"},{"id":"abb4ef4b-2dca-49fb-82f9-00b5e7c75dca","text":"Opinion polls in late January 2023 showing German public divided on sending heavy tanks to Ukraine"},{"id":"ed07c339-370d-44ac-99ba-4d39888dab8b","text":"Media coverage (e.g., The Guardian, Jan 25 2023) highlighting Chancellor Scholz\'s hesitation and street\u2011level opposition rhetoric"},{"id":"8578fb81-6248-4821-b911-ce350c918471","text":"Human Rights Watch report documenting use of unguided rockets in eastern Ukraine"},{"id":"5c12efda-8298-413a-9c12-4b36fb624d7c","text":"Amnesty International / civil\u2011society reporting of widespread artillery and rocket casualties in summer 2014"},{"id":"54518935-b171-45ea-a2dc-7eeabe29f399","text":"Downing of Malaysia Airlines Flight MH17 over eastern Ukraine"},{"id":"226db66c-43ac-43b7-b276-389ceb6fcbf6","text":"Ukraine imposed a moratorium on repayment of a $3 billion eurobond held by Russia (Kyiv halted the payment)."},{"id":"35a8f742-b752-4acc-9240-051519a6aec5","text":"The IMF publicly delayed/withheld a scheduled loan tranche to Ukraine in mid-2016 amid concerns over reform benchmarks and governance."},{"id":"9d6ae165-bc8c-4b5c-b106-e9f72d811855","text":"Fitch Ratings downgraded Ukraine\'s long-term foreign-currency issuer default rating to \'CC\' (placing it close to default territory)."},{"id":"4816eefb-d760-4c17-81ff-d99b1489f626","text":"Ukraine agreed a major debt restructuring with private creditors (restructuring of roughly $15\u201318 billion of foreign debt)."},{"id":"e0dcc4e2-a5cd-490b-a35f-436d888941b5","text":"Business Insider coverage highlights Starbucks filing multiple trademark/patent applications in Russia"},{"id":"bc87f35a-0a70-4f5b-8422-86653c75f043","text":"Starbucks suspends operations and announces exit from Russia after invasion of Ukraine"},{"id":"281cb847-000f-4b27-bbda-89dfb3c7d33d","text":"MedRxiv preprint by Zhao et al. reported an association between ABO blood group and COVID-19 susceptibility (blood group O less frequent among cases)."},{"id":"18935a3f-99e7-4246-b12b-b70d0518ae60","text":"FDA communication and draft guidance clarifying aluminum limits for parenteral nutrition (recommending total allowable aluminum exposure from parenteral nutrition should not exceed 5 mcg/kg/day)"},{"id":"e7c874de-8ed7-47a0-b3cc-0883535ac190","text":"Authoritative vaccine\u2011education pages comparing vaccine aluminum to dietary/environmental exposures (e.g., Children\'s Hospital of Philadelphia vaccine education center material explaining aluminum exposure context)"},{"id":"c30eddb3-a102-48ad-a621-91d4ebcd55a5","text":"Ukrainian authorities announced lists/blacklists of Russian artists (around 40) who were banned from entering Ukraine for illegal visits to Crimea (2014\u20132017 reporting)."},{"id":"47540f62-880d-4495-a45c-d4a8e901debd","text":"Ukraine and international reports (US State Department, EU statements) documented legal and administrative restrictions and sanctions related to Crimea as an occupied territory (2014\u20132018 reporting)."},{"id":"c35488c0-3e55-4d1a-949f-a25c144e3c97","text":"Hundreds of trucks were reported stranded/blocked at checkpoints on the Ukraine\u2013Crimea administrative border during the September 2015 blockade."},{"id":"d6e286ba-6e9c-48de-8d81-3c326f52ed71","text":"President Petro Poroshenko signed Decree No. 549/2015 (September 16, 2015) introducing personal and economic sanctions related to the Crimea/Russia situation."},{"id":"97901ddd-6840-4fd4-8e81-248a7d8fc759","text":"EU and Western measures enacted in 2014 imposed trade and import bans on goods/services related to Crimea (broader international restrictions on commerce with the peninsula)."},{"id":"ab865bf3-a564-4ebc-b231-3711ee9ae979","text":"Explosions damaged power lines on November 22, 2015, causing a near\u2011islandwide blackout in Crimea."},{"id":"d6ffd937-63c8-4937-b8bc-2680e5603706","text":"Russia begins issuing passports to residents of occupied parts of Donetsk and Luhansk (first issuance mid\u2011June 2019)"},{"id":"0904d2cb-95a1-4ca9-be6e-fc7300123c0b","text":"Reporting that the EU was developing guidance on non\u2011recognition and visa handling for Russia\u2011issued Donbas passports (summer 2019)"},{"id":"cdcc6f3d-5b6c-4e81-9e04-05d8810ee886","text":"March 2017 \u2014 Reporting on shelling risks to water\u2011treatment sites storing large chlorine stocks around Donetsk"},{"id":"202cb877-3015-439e-a30a-1822d69a1d24","text":"May 2015 \u2014 DPR (pro\u2011Russian) claims alleging Kyiv/US plotting to use chemical weapons against separatists"},{"id":"1b5acd67-526c-4ff0-860f-e8c440307f91","text":"Parliament adopted the Law of Ukraine \'On the Electricity Market\' (electricity market reform)"},{"id":"e8a37bbc-823e-44da-ad0a-c6e9eaff6cb0","text":"Ukrenergo / NCER announced a tariff rise for the national grid (12.2% increase) from April 2017"},{"id":"b839dc0b-24d9-452e-ab64-ab44b118877b","text":"CDC/ACIP recommendation against using the FluMist (live attenuated intranasal) vaccine for the 2016\u20132017 season due to low effectiveness"},{"id":"1740bd82-9fc3-42b3-a80c-990595a405f7","text":"Scientific and clinical literature reviews (2023) documenting that needle-biopsy \'seeding\' is rare and biopsies remain standard practice"},{"id":"4cb31582-398a-46c1-8ddf-2854eaa9691b","text":"Conviction and high-profile reporting on Tullio Simoncini, promoter of baking-soda and antifungal cancer theories"},{"id":"285be22e-0747-41c0-b4f1-f4dadc6756a1","text":"Israeli health ministry study reported a probable link between Pfizer-BioNTech vaccine and a small number of myocarditis cases"},{"id":"5f8a8580-c98a-4db6-8994-d04b4a9d0e58","text":"Public documentation of Western grants to Ukrainian civil society (e.g., National Endowment for Democracy annual reports listing grants to Ukraine-related groups)."},{"id":"4ff43d32-493b-4704-ba11-bb6a385dab0c","text":"Ukraine Prosecutor General announced identification of \'titushky\' operatives and people who hired them (investigations in March 2014)."},{"id":"8aef4794-569c-4d72-a08d-33e5086110df","text":"U.S. officials and media reported evidence that pro\u2011Russian demonstrators in eastern Ukraine were likely being paid (statements and coverage around 7\u20138 April 2014)."},{"id":"1010388f-1e3e-44c3-a510-abf1b78faa77","text":"IPCC Working Group II (AR6) report release \u2014 \'Climate Change 2022: Impacts, Adaptation and Vulnerability\' (press release)"},{"id":"90bba792-9843-48c9-9e97-3d7085af8444","text":"Western/Central Europe extreme rainfall and floods (July 2021) and attribution analyses"},{"id":"048c95d9-91ed-4ba0-abf2-1ba5dc8c1617","text":"Pacific Northwest extreme heatwave (late June 2021) and rapid attribution studies"},{"id":"5c1726d3-4f7c-4a82-ab4d-e8b1a118ed77","text":"Early clinical reports and case series documented severe hypoxemia and respiratory failure in COVID\u201119 patients (e.g., Huang et al., The Lancet clinical features report)."},{"id":"db796729-ef7d-4250-af39-af43585a2e38","text":"U.S. Ninth Circuit Court of Appeals opinion reviving lawsuit over LAUSD COVID-19 vaccine mandate (panel decision referenced plaintiffs\' arguments about whether mRNA COVID-19 shots meet a legal/medical definition of \\"vaccine\\")."},{"id":"180acd4d-4778-4c28-90a1-ca94875592fa","text":"CDC wording change on its web definition of \\"vaccine\\" in 2021 (language shifted from phrasing that implied absolute prevention of disease to wording emphasizing stimulating an immune response / producing immunity)."},{"id":"461e82dd-7599-4f59-83c6-3cccc96baf31","text":"Ukrainian tactical pullbacks around Bakhmut reported amid renewed Russian assaults"},{"id":"231a0449-6132-4f06-970f-cbae52ee9afb","text":"Peer-reviewed case report: PNH diagnosis and hemolytic flare following mRNA COVID-19 vaccination"},{"id":"92ca9dcf-ae92-4e9c-86b6-bc238956a0fd","text":"Prominent pro\u2011Russian journalist Oles Buzina shot dead in Kyiv"},{"id":"6b004ef3-1883-418c-9791-f6efd45096f4","text":"International press\u2011freedom monitors document multiple journalist deaths and attacks in Ukraine (2014\u20132015)"},{"id":"88a3dcec-9c0b-4238-9770-91adeb6a711a","text":"Italian photojournalist Andrea Rocchelli killed while covering fighting in eastern Ukraine"},{"id":"a88c634a-c4ca-467d-be35-25181bd97292","text":"Verkhovna Rada passes Law No. 314\u2011VIII recognizing OUN\u2011UPA and other groups as \'fighters for Ukrainian independence\'"},{"id":"f7bbb825-6e31-4836-94fc-c9c21877a002","text":"Ukraine enacts \'decommunization\' laws banning Soviet/Nazi symbols and mandating removal of related monuments"},{"id":"7aca12db-b65a-4dd7-9b88-4ba2c84432bf","text":"Kyiv City Council renames Moskovskyi (Moscow) Prospekt to Stepan Bandera Avenue"},{"id":"177d5bfc-b7fc-4976-862b-bd50c7e00821","text":"Ukrainian Il\u201176 transport aircraft carrying troops (including paratroopers) was shot down near Luhansk, killing dozens of soldiers."},{"id":"8f4ca7c4-7aeb-4e04-ae22-928a97fbbdd2","text":"Standoffs and non\u2011engagements by Ukrainian servicemen in Crimea (notably the Belbek air base confrontation) where troops were shown not to fire on Russian forces."},{"id":"f75b18ce-ace3-4943-b15a-a61a8af1f693","text":"CDC released guidance on certifying COVID-19 deaths that allowed listing confirmed or probable COVID-19 as the underlying cause"},{"id":"31ba559f-4607-4a4b-8ff1-fc95c31d06c7","text":"Ukrainian government spokespeople and Ukrainian media reported that separatist/Pro\u2011Russian fighters were shelling residential areas in and around Donetsk, including Makeevka."},{"id":"dbce0965-3a6a-44fb-bebf-62e9d85bd5f2","text":"Wire and photo services (Reuters / Thomson Reuters Trust) published images and on\u2011the\u2011ground reporting showing apartment blocks and streets in Makiivka/Makeevka damaged by shelling (images dated 19\u201320 August 2014)."},{"id":"ac41466e-8fb9-4f3a-b52e-57d3a0dc542f","text":"Kerry defends the US effort to forge a Syria ceasefire amid public and Pentagon skepticism."},{"id":"56cd3399-ff94-403e-b870-abe99d4dd294","text":"US and Russia announce terms for a \'cessation of hostilities\' in Syria after talks in Munich."},{"id":"a88ebf1b-3427-4f5e-9a06-516d1fdba7e7","text":"Human Rights Watch report documenting abductions, arbitrary detentions and other abuses against Crimean Tatars and pro\u2011Ukrainian activists"},{"id":"b95cbcfb-1859-44f6-8426-cefe788205d4","text":"Russian-appointed courts/authorities banned the Mejlis, the representative body of Crimean Tatars, as an \'extremist\' organization"},{"id":"41f2951c-d0a7-4ac9-9169-ef151bcf971d","text":"Blocking of international observers and incidents of violence during the March 2014 Crimea referendum (shots fired, OSCE observers blocked)"},{"id":"3f934331-cfc9-4ec1-928b-e20288e4d2c6","text":"Deployment of unmarked Russian troops (\'little green men\') who seized key sites in Crimea (parliament, airports, bases)"},{"id":"1371df07-807d-4c84-8049-638650fd3c90","text":"Reports in Norway of deaths among frail elderly after Pfizer vaccination (23 deaths discussed)"},{"id":"e3b9f8a4-eb6a-484a-a53d-e57425a80639","text":"CDC and FDA recommended a pause on the Johnson & Johnson COVID-19 vaccine over rare blood clot reports"},{"id":"54e46ee3-95e6-4cfb-8445-16db2423c0cb","text":"WHO updated its interim guidance on mask use for COVID-19, advising use of masks in community settings (interim guidance published 5 June 2020)."},{"id":"6d6f556d-e0db-4156-a673-9ad50fc2fdbd","text":"CDC recommended the public wear cloth face coverings in public settings (initial public recommendation announced April 3, 2020; guidance amplified through April\u2013June 2020)."},{"id":"64978861-84fa-4ed8-bc86-52aeda4a8e84","text":"Coverage documented how face masks became a politicized symbol in the United States (e.g., New York Times feature, June 2, 2020)."},{"id":"b09279b2-e529-4b35-b8b1-0d90aedad64b","text":"NASA / Earth Observatory and related agencies reported exceptionally low Antarctic sea\u2011ice extents in 2022\u20132023 (record lows for seasonal maxima/minima)."},{"id":"b5a63837-c8c4-4d64-ab33-45ea0718de8c","text":"Concern about toxic rocket propellant and debris after Proton failures (public safety headlines)"},{"id":"df2043c4-1c1e-4eff-a2c3-58e6130552d2","text":"IPCC Fourth Assessment Report (AR4) release (Working Group I) stating recent decades were likely the warmest in at least the past 1,300 years"},{"id":"31f0493f-3a54-4dc6-aebf-92b2c556d73c","text":"Wegman report (US Congress/2006) critical of statistical methods in the \'hockey stick\' reconstructions"},{"id":"b8cfb2fa-2f84-4e66-92c7-2b808351286f","text":"Ban on dashboard cameras (dashcams) in Ukraine (announced March 2022)"},{"id":"46bd38d3-dcc2-426a-a963-5db999a932ba","text":"Established pattern of Russian disinformation and use of staged footage to smear Ukrainian forces (documented by human rights and media watchdogs)"},{"id":"327b4e57-b635-4aac-9dca-cb9b6ead7c78","text":"Prior documented attacks on civilian evacuation convoys and cars during the 2022 invasion (widely reported, e.g., Reuters report of convoy strike)"},{"id":"728b488b-9ce7-49a7-9117-5c9e56b28899","text":"TIME published its 2024 TIME100 list including Andriy Yermak in the \'Leaders\' category."},{"id":"4ec2079c-6a43-421b-b2c1-7902900dd7b8","text":"Pre\u2011existing reporting and public scrutiny about Yermak and his circle (including a previously reported corruption investigation involving his brother) created an underlying credibility gap."},{"id":"258a754a-0776-4907-951c-96c7047a7dc0","text":"CDC/NCHS guidance (April 2020) on certifying and reporting COVID\u201119 deaths that allowed listing COVID\u201119 as an underlying cause when clinically suspected (including \'probable\' cases)."},{"id":"819c7079-e076-42eb-a9ad-1828cd7d30dc","text":"Repeated public downplaying of COVID\u201119 severity by political leaders (e.g., President Trump saying the virus \'will go away\' or \'disappear\')."},{"id":"bb8aaf34-7901-4d6b-8e46-2d0728bcc4c0","text":"Croatian officials acknowledge nationals fighting in Donbas"},{"id":"2a9cff89-c049-4c4a-9e5f-5522c1593479","text":"Russian Defence Ministry summons Croatian military attach\xe9 alleging \'Croatian mercenaries\' in Ukraine"},{"id":"bb15de34-8f26-42ed-b3ad-221235bff97a","text":"Media coverage of the Azov battalion attracting foreign volunteers and far\u2011right fighters"},{"id":"ad3b954b-1091-49ce-b778-17d438f96d8f","text":"Media reports describing Latvia\'s non-citizen policy as leaving thousands feeling stateless"},{"id":"5fdae4e2-c22f-4c43-86c0-be6b6fa3bc36","text":"FDA authorizes Pfizer\u2013BioNTech COVID-19 vaccine and releases EUA materials describing the product as a nucleoside-modified mRNA vaccine (technical briefings made public, Dec 2020)."},{"id":"c4d32fe9-81e1-448e-bcf7-fe8455ffad08","text":"Animal and nanoparticle biodistribution studies showing lipid nanoparticle formulations can distribute beyond injection site (published/posted 2020\u20132021; e.g., peer-reviewed nanoparticle accumulation studies and regulator review summaries)."},{"id":"7c7e2884-2e16-43ba-ae99-f2e49fcb11b7","text":"Peer-reviewed studies and preprints reporting trace detection of vaccine-derived mRNA fragments or spike protein components in human breast milk or blood samples after vaccination (published 2021)."},{"id":"bfd3bcf0-a950-4f4d-8860-33af03978c35","text":"European Food Safety Authority (EFSA) establishes and publicizes a tolerable weekly intake (TWI) for aluminum from food"},{"id":"8d5df244-0e28-4a6a-ae4d-b90dadb3a8ca","text":"2006 Meat Science study measuring aluminum content of baked meats wrapped in aluminum foil"},{"id":"7a46bd74-7779-40f5-aebe-ffa7f7ea18fb","text":"UK Health Security Agency report: Unusually high Group A streptococcal (GAS/iGAS) and scarlet fever activity in 2022\u201323 season"},{"id":"f0a4a85f-cdfb-40b1-83d4-4fcfb707d3e6","text":"Preclinical mouse studies showing mRNA\u2011LNP formulations strongly modulate innate immune responses (Ndeupen et al., iScience)"},{"id":"c6a908cf-12f1-459b-8f33-779927db7075","text":"CDC Health Advisory: Early, elevated respiratory virus activity among children (co-circulation of RSV, influenza, SARS\u2011CoV\u20112)"},{"id":"e3ea3796-f949-46b5-bb3f-3f68dd2bbcc5","text":"2009 H1N1 (swine flu) pandemic required development of an additional vaccine"},{"id":"fbf353d8-ec47-42e3-9828-31180f164c59","text":"Very low measured effectiveness of the 2014\u20132015 seasonal influenza vaccine"},{"id":"24b0b149-2595-42aa-9718-73681c300ead","text":"U.S. congressional restrictions/amendments addressing assistance to units with alleged extremist links (e.g., Azov-related amendments)"},{"id":"35121ed1-891f-4881-b73c-9fdcbab4eb0a","text":"Clashes and far\u2011right attempts to disrupt Kyiv Pride (police detained far\u2011right activists)"},{"id":"12d45049-de41-4341-b3a8-0b222ac2854c","text":"Visible commemoration and monuments to Stepan Bandera in western Ukraine"},{"id":"5e6b38d1-6cbc-4588-aa7f-246cbe88558c","text":"Passage and signing of Ukraine\'s \'decommunization\' laws (removing Soviet-era names and symbols)"},{"id":"4fcaface-4768-44b8-ba40-d0f6bcd6b89b","text":"Media reporting on the Azov Battalion\'s origins and extremist symbols"},{"id":"34ba6106-153e-4d6a-8628-0deba86545b5","text":"Russian government announces regulatory approval and promotion of Sputnik V (first COVID-19 vaccine) internationally"},{"id":"910b861b-ebe9-4983-ae71-fcbdde128309","text":"Contamination reports and a large temporary suspension of Moderna vaccine doses in Japan after foreign particles were found in vials."},{"id":"240c370a-3709-4e6b-802f-cf3545dc04e1","text":"Media reports in 2022 documenting large, pre-planned insider sales of Moderna shares by CEO St\xe9phane Bancel during the pandemic period."},{"id":"77165de3-a791-40c3-8efd-b693f985ad63","text":"IAEA mission and international attention at Zaporizhzhia Nuclear Power Plant (IAEA experts arrived and were stationed at ZNPP beginning 1 September 2022)"},{"id":"ea463e10-c39b-40b0-b336-1b6fdb29a1e4","text":"Reporting of intimidation, abductions and coercion of Zaporizhzhia NPP staff under Russian occupation (including abduction of plant director)"},{"id":"c1cb00fe-3502-405b-a6ab-0d448cd92e7c","text":"Changes to Ukrainian mobilization/reservation rules for critical infrastructure employees (Parliament adopted amendments on reserving/exempting conscripts, early November 2022)"},{"id":"b7328816-8b70-4137-8e00-c64d9f42f0e8","text":"2019 systematic review summarizing clinical uses and adverse reactions of DMSO in humans (F1000Research)"},{"id":"ffa9efc7-e24b-496f-be05-08f89416a77d","text":"FDA approval and long-standing labeling of RIMSO-50 (50% DMSO) for intravesical treatment of interstitial cystitis"},{"id":"138c4462-87cc-410f-bc8d-2ef119d15bd8","text":"Investigative reporting on TikTok as a major vector for unverified/false medical cures in the Philippines (Rappler investigative feature)"},{"id":"8acb8e9a-b980-4aa2-b9d3-91ba041f4ce3","text":"Russian authorities publicly pledged hundreds of billions of roubles (report: 680 billion roubles) of investment into Crimea up to 2020"},{"id":"45ebeebb-89cc-4ab7-b27b-7ec391464963","text":"Russian government raised pensions and some salaries for Crimean residents after the 2014 annexation"},{"id":"b1052026-44b4-4684-9390-7d2478ae71ac","text":"Israeli data reported reductions in Pfizer/BioNTech effectiveness against infection (Delta-era reports)"},{"id":"50d67449-92cd-4b37-ae42-abfaac7619f9","text":"CDC changed surveillance (May 1, 2021) to track only breakthrough cases resulting in hospitalization or death"},{"id":"7175103d-b7f9-4570-85a2-673f72108e12","text":"CDC report on Barnstable County (Provincetown) outbreak showing many infections in fully vaccinated persons"},{"id":"4e05695e-f1a7-4138-afcc-4cc21a904e57","text":"Published and reported studies showing antibody levels wane within months after vaccination"},{"id":"da7b8fa8-4e45-431f-9e24-5baa47caaf33","text":"IAEA expert mission visits and publishes a report on the Zaporizhzhia Nuclear Power Plant (IAEA mission and report published in September 2022)."},{"id":"5252bdae-fae8-404f-9f9f-19b6a7cc8fbf","text":"Public announcements (July 2025) of deepening Ukraine\u2013Westinghouse cooperation on nuclear fuel supply and plans for domestic fuel assembly capability in Ukraine."},{"id":"980fc750-a12c-4d0d-99a6-b8cf9f5e7d79","text":"Russian delegation and state media publicly accused Ukraine of planning a \'dirty bomb\' at the United Nations Security Council."},{"id":"4b3d21da-17a0-4671-9b0c-cb8e2f09c2df","text":"Reports and imagery in March\u2013April 2022 documenting Russian troops looting and disturbing equipment at the Chernobyl exclusion zone (including allegations of removal of radioactive monitoring equipment)."},{"id":"e968f688-f65e-4c2d-9614-30a30a4b1e67","text":"Reporting on rapid, large Western arms shipments to Ukraine (e.g., New York Times: \'Arming Ukraine: 17,000 Anti\u2011Tank Weapons in 6 Days\')."},{"id":"42c3ca8f-6b5c-4786-8e60-b5e841dd430e","text":"Reuters reporting on Zelensky\'s \'dramatic call\' to EU leaders that prompted an unprecedented collective EU decision to provide arms to Ukraine."},{"id":"bb1119af-cc0c-4cb5-9e2b-372c006a5615","text":"Pandora Papers (ICIJ/OCCRP) reporting on Oct 3, 2021 linking Zelensky and close associates to offshore companies and property purchases."},{"id":"177cb85a-ce3e-4e46-9e38-95b1eb71a1c8","text":"Politico profile \'The influencers behind the Ukrainian PR machine\' quoted former US Ambassador Michael McFaul describing people around Zelensky as \'intermediaries and interlocutors\'."},{"id":"b573fb16-d274-420d-b3dd-b10e9a2e04a0","text":"CDC/NCHS issued guidance for certifying COVID-19 deaths clarifying how to report underlying versus contributing causes on death certificates (guidance and FAQs for certifiers)."},{"id":"e1d81b4f-65e3-4407-9c6a-93128d5a53da","text":"Publication of large US seroprevalence analyses (blood-donor and CDC/JAMA analyses, mid-2021) showing a substantial proportion of Americans had SARS\u2011CoV\u20112 antibodies by spring\u2013early summer 2021."},{"id":"33356a44-4e77-4163-bc68-3eee1fe3a711","text":"EU launches Support Hub for Internal Security and Border Management in Moldova"},{"id":"ae81d2ef-de6f-45f3-b800-4dfb5a7bdfdf","text":"EU drugs agency warns the Ukraine war is shifting drug trafficking routes to Europe"},{"id":"1948e678-c2c8-4706-abc6-484e56225a6b","text":"European Commission announces EU financing for purchase and delivery of weapons to Ukraine"},{"id":"bf531250-c7e0-42b2-a0b1-96e2fc7d2950","text":"Interpol warns of a likely surge in illicit arms linked to the Ukraine conflict"},{"id":"27d48414-b3f8-489e-973a-ad9f6fe83ffe","text":"Dutch Public Prosecution Service opens a criminal investigation into MH17 (Dutch-led criminal probe announced)"},{"id":"f5a2995f-193c-4bbe-b4c3-a69acddc8f22","text":"Establishment of the Joint Investigation Team (JIT) for MH17 including Ukraine as a participating partner"},{"id":"be683cad-5ff8-4916-a8b5-778dbac3fc7b","text":"Early reports of limited access and evidence handling at the MH17 crash site (security and access restrictions under rebel control)"},{"id":"a6f4a4f2-0e5e-455c-bcd4-baf8a3dd3724","text":"NATO announced increased patrols and a stepped-up maritime presence in the Black Sea in 2018 (Standing NATO Maritime Groups\' presence rose to ~120 days)."},{"id":"2ef830d9-9250-41ff-96cf-c32099ec79ee","text":"Russian and pro\u2011Kremlin media and official statements framed NATO Black Sea exercises as \'provocative\' and warned of \'consequences\' (July\u2013Nov 2018)."},{"id":"d0c5ca2b-230a-421a-8ff4-fa02093493c5","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels, prompting NATO emergency meetings and condemnation."},{"id":"39dd2991-e610-4df5-afbd-5799d0b4365b","text":"CDC/NCHS guidance on certifying deaths due to COVID-19 (guidance documents published early in the pandemic, April 2020)."},{"id":"ea9db0fe-391d-4fc5-86d9-9c4488f46eda","text":"Russia\'s appeal argued at the UK Supreme Court that Ukraine should be forced to pay the $3bn \'Yanukovych\' bond"},{"id":"fd3c6f58-c889-4567-93c5-3a56a7ecabc2","text":"Earlier High Court summary-judgment proceedings (2017) and legal filings showing shifting rulings and dense legal language"},{"id":"fa76eebd-850f-43a5-8fe7-0478ad1524c6","text":"Reporting and features on mounting disposal problems for decommissioned turbine blades (\'turbine graveyards\' / landfill stockpiles)"},{"id":"cf19da29-e597-4a89-89b1-9ed74e22d7c4","text":"Nantucket and other Cape Cod beaches closed while crews recovered fiberglass debris after the Vineyard Wind incident"},{"id":"71c8f9eb-2666-4961-a599-9dca493f7a00","text":"Siemens Gamesa blade (72m, ~22 tonnes) detached and fell from a turbine at Odal Vind in Norway, prompting road closures and an investigation"},{"id":"a60933bf-eb6d-4640-95da-e65af0f74bbe","text":"Peer\u2011reviewed literature documenting therapy\u2011related secondary cancers (eg. therapy\u2011related AML) after certain chemotherapy agents"},{"id":"12468af9-c3a4-4b64-a4a9-df596f578bf0","text":"Historical reporting about nitrogen mustard research at Yale and the 1940s origins of some chemotherapy agents"},{"id":"1cd015e1-f4fb-4439-8be4-9db8a355be68","text":"Ukrainian Interior Ministry public briefings reporting scale of Russian strikes (Deputy Interior Minister: ~30,000 strikes)"},{"id":"1535b092-2f4c-46b3-a6aa-0f47acfce530","text":"Widespread Russian missile and drone barrages across Ukrainian cities in late March 2024"},{"id":"46ffce94-2f87-4972-920f-76a2e7524c41","text":"Financial Times publishes analysis of Russian \'glide bombs\' and upgrades to Soviet-era bombs"},{"id":"97e727e7-960e-4a2b-abf7-0793ea312243","text":"2015 \'decommunization\' laws restricting public expression of Soviet symbols and related narratives"},{"id":"33ae4456-5a7c-4a22-b627-bd9f9c50773e","text":"2018 reports of SBU actions, searches and prosecutions of pro\u2011Russian journalists/organizations"},{"id":"6e3be3bb-0b31-40c2-9c4c-86d033a52acc","text":"2017 presidential decree blocking Russian social networks (VKontakte, Odnoklassniki)"},{"id":"2d41128c-909b-427b-8694-6449842d91e9","text":"2019 constitutional amendment enshrining Ukraine\u2019s EU and NATO course"},{"id":"c6ca0ef0-9643-4ec2-a666-d2c0c25f9594","text":"2014 ban on multiple Russian TV channels for spreading \'war propaganda\'"},{"id":"adddaf0b-1b58-49fc-8a33-15236b222e4b","text":"U.S. government announcement (October 2014) of a funding \'pause\' and review on certain gain-of-function (GOF) research involving influenza, MERS and SARS viruses (NOT-OD-15-011 and related guidance)."},{"id":"7548bb88-0c7f-4620-8757-ff3d81ed63d3","text":"Existence and circulation of U.S. government-held coronavirus patents (example: US Patent No. 7,220,852 B1, \'Coronavirus isolated from humans\', assigned to CDC, granted May 22, 2007)."},{"id":"83dfea00-70fb-48cd-aebd-04e1dc8f1702","text":"NGO/OCCRP coverage linking major EU buyers (e.g., IKEA) to Ukrainian illegal wood supply chains"},{"id":"fbae0e6a-df1a-4f80-8faa-70c21e501e8b","text":"President Petro Poroshenko vetoes bill on combating timber smuggling (Bill No. 5495)"},{"id":"1680d51b-a411-47ab-aa9f-fa25d53a8c28","text":"Earthsight publishes \'Complicit in Corruption\' investigative report on illegal logging in Ukraine"},{"id":"72f482e4-4c9b-400e-b22c-aec5e947cd6d","text":"Regulatory/authorization context: CDC/ACIP and FDA discussions and authorization decisions for COVID-19 vaccination in young children (June 2022), which increased scrutiny of pediatric trial data."},{"id":"e9ff4476-2dee-4c1f-adf4-50aa9b1cca55","text":"Trial data-cutoff and interim analysis date reported in KidCOVE safety results (data included through February 21, 2022)."},{"id":"e40c33f9-d7fa-4137-9f80-4c8229c27471","text":"Publication of NEJM KidCOVE interim results for mRNA-1273 (Moderna) in children 6 months\u20135 years, reporting safety data including 8 serious adverse events in the 6\u201323 month mRNA-1273 group and none in the placebo group."},{"id":"d546313d-55a7-4c55-8727-d1442d5d9758","text":"Sea Breeze multinational naval/air exercises hosted in Ukraine with US/NATO participation (July 2017)"},{"id":"63aaf013-8d50-412c-81a0-96ec60af11f7","text":"NATO\u2011Ukraine Trust Funds and tangible NATO assistance (established 2015)"},{"id":"893ebd52-72c9-4155-ab25-1ebc612f8af1","text":"2019 constitutional amendment enshrining EU and NATO as Ukraine\'s strategic course"},{"id":"923d78a6-0f1a-4090-b098-22127570f45d","text":"Presence of foreign volunteers and fighters from Western countries in Donbas (documented 2014\u20132015)"},{"id":"1e20843e-0217-4c07-ac4d-1ebad8424cac","text":"Japan suspension and recall of Moderna COVID-19 vaccine batches after reports of foreign particles"},{"id":"72f22cf7-f130-4e72-83aa-7a8643dc108b","text":"Reports of circulating vaccine-derived poliovirus (cVDPV) outbreaks and WHO emergency committee statements"},{"id":"f45cbc4e-f37f-4dd2-9353-0c7aa03f7174","text":"Precautionary removal/reduction of thimerosal (a mercury-based preservative) from childhood vaccines"},{"id":"3d6ce7a2-691b-4ee8-8fa2-4899f39986e3","text":"Detection of porcine circovirus (PCV1) DNA in Rotarix rotavirus vaccine"},{"id":"06f007c0-e0de-480a-93d5-26f93d3f7cea","text":"Publication of Nerem et al., PNAS: \'Climate-change\u2013driven accelerated sea-level rise detected in the altimeter era\'."},{"id":"038860ed-0644-4a78-a26c-ddfd467df0af","text":"IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) released."},{"id":"97d91213-c2e1-4a9f-ad2e-c13b57d37aae","text":"Publication of Alberto Boretti\'s analyses challenging mainstream estimates of sea-level acceleration."},{"id":"c958ba33-3ea5-4da4-980c-022f38695458","text":"German measles-denier Stefan Lanka loses appeal after offering \u20AC100,000 prize over existence of measles virus; court rules in favour of claimant (widespread media coverage)."},{"id":"2f98b85a-d39e-438e-b66a-d505d2606979","text":"Ukraine\'s chief military prosecutor Anatoliy Matios publicly stated that two to three servicemen were committing suicide every week in the Donbas ATO zone."},{"id":"eab631c3-da72-4370-a532-a31a42572838","text":"The battle of Ilovaisk (August 2014) in which Ukrainian units were encircled and suffered heavy losses became widely reported and politicized."},{"id":"aba49bda-c2b0-4003-9209-e6890812b61e","text":"EUvsDisinfo / DisinfoLab and other monitoring organisations catalogued repeated pro\u2011Kremlin narratives claiming Ukrainian forces were demoralized, corrupt or unwilling to fight (ongoing since 2014)."},{"id":"cbc67cf5-9419-43f3-9dc7-c44b2733ba3e","text":"Peer\u2011reviewed OCTA studies report retinal/ocular microvascular changes after COVID-19 infection (example: Guemes\u2011Villahoz et al.)"},{"id":"db44defa-3c36-4859-b748-caa84afa1fcc","text":"Longstanding scientific review concluding iridology lacks diagnostic validity published (Ernst systematic review)"},{"id":"67b8b108-aefe-44f0-897e-f627629cd681","text":"1996 USAF planning paper \'Weather as a Force Multiplier: Owning the Weather in 2025\' circulated publicly"},{"id":"6f39a42e-d0a7-4152-9012-db5be6eeadef","text":"Publication of Shearer et al., \'Quantifying expert consensus against the existence of a secret, large\u2011scale atmospheric spraying program\' (Environmental Research Letters)"},{"id":"6361e3fa-8bbc-4e57-b2ec-32d1afda5b97","text":"Preexisting nanoparticle research showing some nanocarriers can accumulate in ovaries in animal models (Sch\xe4dlich et al., 2012)"},{"id":"0d9787a5-5dce-46f2-b517-8a5b9b184f48","text":"U.S. Department of State 2018 Trafficking in Persons Report \u2014 Poland country narrative noting increased vulnerability of Ukrainian migrants to labor trafficking"},{"id":"39ef7077-d79e-4496-bc0b-3c003a80e3cb","text":"Financial Times coverage on Poland\u2019s heavy reliance on cheap Ukrainian labour and the precarious conditions many workers faced"},{"id":"289de12e-9f31-4ce0-8bac-9174a0700012","text":"June 26, 2016 \u2014 Attack on a Ukrainian religious procession in Przemy\u015Bl by local nationalist groups (documented by regional and international press)"},{"id":"c7fdf878-5fac-41b8-b934-f21635dbda20","text":"Pfizer\u2013BioNTech received Emergency Use Authorisation while continuing to follow trial participants for safety/efficacy"},{"id":"7b4a72aa-0324-4d1b-9335-9805b28f7966","text":"UK regulator (MHRA) issued guidance after two reports of anaphylaxis following Pfizer\u2013BioNTech vaccinations"},{"id":"037ebe25-c4a1-4188-b565-8419ca9a9ad9","text":"Multiple reports in Norway of deaths among frail, elderly people after receiving the Pfizer\u2013BioNTech vaccine"},{"id":"61fff634-9e30-41df-a329-fb86fad4bc7c","text":"AstraZeneca paused its global COVID\u201119 vaccine trials after a participant developed a serious neurological illness"},{"id":"c55ee29e-3bab-4ba1-bbe7-ca82e627ca35","text":"NOAA technical report and public release of regional sea-level rise scenarios and tools (NOAA NOS CO-OPS Technical Report)"},{"id":"995c7333-e54f-48cb-a82e-96fb67dc3a32","text":"Availability and public access to local tide-gauge records showing regional variability (example: Stockholm tide gauge, PSMSL station page)"},{"id":"fe4ddb1b-a94f-4e6f-ad4e-e6707844c3ef","text":"Allegations and media coverage of NOAA data-handling controversy (John Bates / \'NOAA whistleblower\' coverage)"},{"id":"1bba37c6-dcbf-4c61-b3cf-bad3ef1aec62","text":"OSCE Permanent Council decision to deploy the Special Monitoring Mission to Ukraine (SMM) following the outbreak of unrest in eastern Ukraine."},{"id":"adfe034a-1d47-4b01-a3b4-3ee50f4c4d29","text":"Self\u2011proclaimed Donetsk and Luhansk \'people\'s republics\' declared independence after May 2014 referendums and issued international statements."},{"id":"10340ecb-3315-4a89-9a44-9c2bb1cf8484","text":"Minsk II talks (Package of Measures) signed in Minsk with representatives of the self\u2011proclaimed Donetsk and Luhansk People\u2019s Republics participating as signatories."},{"id":"75cfb33e-0352-48ea-9780-f5bdda5e717a","text":"United Nations Security Council held emergency meetings and public briefings on the Ukraine/Crimea crisis (e.g., press briefing and meeting coverage in February\u2013April 2014)."},{"id":"d5a5bf2a-04e3-4d0e-af38-0a7519015383","text":"European Union adopts \u20AC1.8 billion macro\u2011financial assistance (MFA) for Ukraine"},{"id":"0acf27d2-2674-482f-90c5-bde37a973fb6","text":"EU visa\u2011free travel for Ukrainian citizens enters into force"},{"id":"f9c8fbc1-67a7-4704-a2e1-e99fec527735","text":"Publication of Microsoft patent WO/2020/060606 (cryptocurrency system using body activity data)"},{"id":"97c3bcc5-ad71-4bcd-8a13-c1f3a049f14c","text":"Coverage of Gates/Foundation funding for genetically modified mosquito research (Oxitec grant reported 2018)"},{"id":"c9333206-b8e8-4ce9-b191-0ffd93b8118f","text":"Ukraine sharply increased \'reverse flow\' imports from EU in 2015"},{"id":"39b41e96-06be-47c3-af2e-77866a296fea","text":"January 2009 Russia\u2013Ukraine gas cut-offs"},{"id":"6d170253-a0d2-4d39-9138-c5d4a72fde42","text":"Merck announces it will discontinue development of two COVID-19 vaccine candidates (V590 and V591)"},{"id":"92151bb0-7996-4fac-9dff-54ae5c2b8076","text":"1976 U.S. swine flu vaccination program linked to increased Guillain\u2013Barr\xe9 syndrome reports"},{"id":"0c82cd62-35e8-4be1-a241-0e3314700361","text":"Pandemrix (2009 H1N1 vaccine) association with increased narcolepsy reports in some countries"},{"id":"4409d09e-8edd-4492-9963-1938986c6ac9","text":"2014\u20132015 influenza vaccine effectiveness decline due to antigenic drift"},{"id":"794b08a1-59b7-4f7b-9499-7fbae5270e8a","text":"European Medicines Agency (EMA) announces and uses \'rolling review\' procedures for COVID-19 vaccines"},{"id":"378fa6ea-1c37-4b64-99cc-af69758c9482","text":"UK Medicines and Healthcare products Regulatory Agency (MHRA) grants temporary (emergency) authorization for the Pfizer\u2013BioNTech vaccine under Regulation 174"},{"id":"dabcf4bf-2b03-4def-901a-62f22fac965d","text":"Publication of the Phase 3 trial results in NEJM showing vaccine efficacy against symptomatic COVID-19 (Polack et al.)"},{"id":"aebd57ab-6dd7-4b0d-a553-681a4786cb36","text":"Reporting on longstanding U.S. transfers of anti-armor and other defensive equipment to Ukraine (e.g., Politico coverage of U.S.-supplied weapons to Ukraine since 2018)"},{"id":"018d1ede-175c-4fdf-8470-711815c56a6f","text":"U.S. intelligence warnings and press reporting that Russia was planning a large-scale offensive (wide coverage, Dec 3, 2021)"},{"id":"87364eda-63bf-49ce-b81b-f809767d1673","text":"Bipartisan Senate delegation visited Kyiv and met President Zelensky (Portman, Shaheen, Murphy)"},{"id":"608fbe47-ff8c-4b68-b402-04fc938c52f5","text":"Russian navy holds Black Sea drills near Crimea amid rising tensions (April 2021)."},{"id":"1903542d-2ade-4a19-9eb6-1de53f3b5652","text":"Russia publishes draft security proposals demanding NATO guarantees (including no eastward expansion)."},{"id":"9087f738-7475-44fa-85d8-57cc7e9ae9a4","text":"Deployment of advanced S-400 surface-to-air missile systems and other air defenses to Crimea (reported in 2019 and earlier)."},{"id":"4f751d6c-aef6-4e8f-a7d8-9fe179abe261","text":"Large-scale Russian troop buildup on and near the Ukrainian border reported in January 2022."},{"id":"83361a24-6725-4af5-bba8-d7dd76c82c5b","text":"Vladimir Putin publishes essay \'On the Historical Unity of Russians and Ukrainians\'."},{"id":"fb00d190-2fd6-4778-863e-7fc44c538a44","text":"Czech Statistical Office published official vital statistics showing a marked decline in live births (drop in number of births) between 2021 and 2022/2023."},{"id":"3910d908-f09d-460f-8007-dcc095faf253","text":"Peer-reviewed modelling paper published examining how COVID-19 vaccination timing and behavior could affect total fertility rate in Czechia (discusses scenarios like avoiding conception around vaccination)."},{"id":"78373792-dfb0-44fe-bd62-df4b0c3a7776","text":"Public reporting and policy changes earlier in 2020 showing NATO/European military exercises were scaled back or adjusted because of COVID\u201119 (concern about cross\u2011border transmission)."},{"id":"7c73d6b8-d639-4da0-9d65-d9d84007a99d","text":"Official reporting that Ukrainian units (e.g., the 80th Air Assault Brigade) were participating in Saber Junction / multinational exercises in Germany."},{"id":"7a13e2e1-73ef-46cd-af16-09ed228a8441","text":"Peer\u2011reviewed reports from Israel (NEJM and related surveillance studies, 2021\u20132022) documenting rare myocarditis cases after mRNA vaccination in adolescents and young men (e.g., NEJM letter on Israeli adolescents published Nov. 10, 2022)"},{"id":"e00c9545-9529-4da3-b581-5296167763f0","text":"CDC/ACIP Sept. 12, 2023 presentation slides on updated COVID-19 vaccines that included projections of hospitalizations, deaths prevented in adolescents and estimates of vaccine reactogenicity (Grade 3/4)"},{"id":"084941a3-0dfc-476c-b4d7-5fe00f7d1222","text":"IEA special report \'The Role of Critical Minerals in Clean Energy Transitions\' highlighting large and growing demand for minerals (copper, rare earths, etc.) used in wind turbines and other clean technologies."},{"id":"fc9424cb-6ac1-4c16-a4cb-6b301d640d6c","text":"Reuters reporting (September 2023) on U.S. offshore wind projects facing major cost increases, cancellations and financial write\u2011downs amid inflation, supply\u2011chain problems and policy changes."},{"id":"cb886c61-9b24-495c-af33-773416babf42","text":"C&EN feature (August 2022) documenting that many retired wind turbine blades have been landfilled and describing the technical and economic challenges of blade recycling."},{"id":"e59c9a36-25da-4583-b301-8b536a7a6a5d","text":"Arnett et al. review and field studies (circa 2008) documenting consistent patterns of bat fatalities at wind energy facilities and identifying operational conditions that drive bat collisions."},{"id":"fa16f634-12a6-4b65-ba49-51dbe1ac2549","text":"Loss, Will & Marra (Biological Conservation, Dec 2013) published widely\u2011cited estimates of bird collision mortality at U.S. wind facilities (commonly quoted range ~140,000\u2013328,000 birds/year)."},{"id":"c1389a43-915a-4c33-a0a1-07e3063944c1","text":"Israel Ministry of Health presentation on booster-dose effectiveness and evidence of waning two\u2011dose vaccine protection."},{"id":"aa6572aa-aad1-495f-9010-60dea2946df0","text":"Ukrainian authorities and security services announced investigations and potential legal action against Antonov company officials over failures linked to the Mriya\'s destruction."},{"id":"5119233f-1bde-4d13-a8de-e2dc2a367cfb","text":"Hostomel (Antonov) airport was the scene of capture, heavy fighting and later reported withdrawal/retreat of Russian forces during March 2022."},{"id":"dac912ef-7f2f-4e85-834c-b0b208f705bf","text":"Ukraine suspends consular services for military\u2011age men living abroad"},{"id":"32a5e08d-a068-4ab9-83cf-7712a622f533","text":"President Zelensky signs a major overhaul of Ukraine\'s mobilization law"},{"id":"9dd8dd34-cc32-45cf-a8ab-06f7eeba66ca","text":"BBC World Service \'BBC Eye\' investigation: nearly 20,000 men fled Ukraine to avoid conscription (investigation published Aug 2023)"},{"id":"666548b4-4b73-47de-bd9c-9d5669fe9239","text":"NATO\u2011Ukraine Council (defence ministers) meets and publicly reiterates stepped-up support"},{"id":"0216cbda-8ba0-4a88-b35b-782f37194994","text":"The UK Coronavirus Act 2020 received Royal Assent, creating expanded emergency powers for government pandemic response."},{"id":"731bb2e7-f349-4150-8d45-c7a663dc4e1a","text":"The White House issued a proclamation declaring a national emergency concerning COVID-19."},{"id":"239443a4-d8d6-47c5-ac36-4a98580c9e41","text":"President Trump and other US officials publicly expressed unusually optimistic timelines for a vaccine, saying a vaccine might be available in a few months."},{"id":"654f84f5-583e-4aa7-be94-d3c0d95c5318","text":"Moderna announced the first participant was dosed in its NIH-led Phase 1 trial of mRNA-1273."},{"id":"e0001ab0-ea1d-4131-945c-8d9a05240394","text":"Florida Department of Health press release stating VAERS reports from Florida increased 1,700% after COVID-19 vaccine rollout"},{"id":"dcd3d9cc-a3f7-4de1-9f89-e1aa2e2c4da1","text":"Florida Surgeon General Joseph Ladapo issued mRNA COVID-19 vaccine guidance recommending against mRNA vaccines for males aged 18\u201339"},{"id":"d8fd4d90-e8e8-4f0a-b95c-466cadf04a04","text":"Record-high public support for marijuana legalization reported by Gallup (64% in favor)."},{"id":"e0253ed0-24e0-4426-b0b9-9bfb63ca5111","text":"Publication of David Nutt et al.\'s Lancet paper ranking drug harms, which placed alcohol high and cannabis low."},{"id":"8da00518-0a95-4f45-b6bc-4d2e0e85d560","text":"Sacking of Professor David Nutt from the UK Advisory Council on the Misuse of Drugs after public comments comparing alcohol\'s harms to those of illegal drugs."},{"id":"315d889f-8b63-4b74-9306-370992b51965","text":"Ukraine\'s parliament passed \'decommunization\' laws criminalizing propaganda of totalitarian symbols and prompting removal/renaming of Soviet\u2011era monuments and toponyms."},{"id":"82514ec5-9684-4e7e-b8c3-3f9261e8c203","text":"International outlets reported that nationalist and far\u2011right groups had gained influence and were under scrutiny in post\u2011Maidan Ukraine."},{"id":"9bb85cec-e218-42dc-8d26-2028bdd2d6c6","text":"Right Sector, an umbrella of ultranationalist groups, played a prominent and public role during the Euromaidan protests."},{"id":"e661d56d-02cf-49ac-9ae4-5dfd32f12de2","text":"Svoboda party members held ministerial posts in Ukraine\'s 2014 interim government after Yanukovych fled."},{"id":"26f38863-34a4-4baa-a6bb-528432254308","text":"Ukraine\'s Cabinet of Ministers increased administrative fines for quarantine breaches via Resolution No.255."},{"id":"f35aab89-abde-48df-90da-f4bc0871106e","text":"Legal summaries and guidance published in April 2020 explaining strengthened quarantine rules and penalties in Ukraine (legal/firm briefings and PDF guides)."},{"id":"3a81ca66-f500-4e6b-92a7-0400526c47e9","text":"Publication of preliminary safety data on mRNA COVID\u201119 vaccines in pregnancy (v\u2011safe/VAERS analyses)"},{"id":"ee46c6d3-5649-405a-9bfd-474650c7f68b","text":"Verkhovna Rada adopts \'decommunization\' laws banning Soviet symbols and renaming places (spring 2015)"},{"id":"89df43ba-e28b-4105-adea-e98ec69e07c8","text":"Ukraine adopts the red poppy and promotes May 8 remembrance practices (media coverage, May 2015)"},{"id":"ec19c603-ba0a-4451-82ce-b8ac2bcff24e","text":"Ukraine criminalises public promotion/use of the Russian/St. George ribbon (amendment creating administrative offence), reinforcing break with Soviet/Russian WWII symbolism"},{"id":"b0ef9cfb-447e-4a08-8801-cab9d103a008","text":"Wave of Lenin statue topplings across Ukraine during 2014 \'Leninfall\'"},{"id":"62bdd436-24bc-45ee-ac5b-deaa1f9d4b13","text":"Passage of the Law \'On Ensuring the Rights and Freedoms of Internally Displaced Persons\' (IDP law)"},{"id":"78f3ed54-d775-4796-b00d-1a7d215338d1","text":"Cabinet of Ministers Resolution No. 302 (25 March 2015) on passport issuance and registration procedures"},{"id":"c23caf4e-5a67-448f-a6e9-5b10ed0837a6","text":"Law No. 1382\u2011IV \'On freedom of movement and free choice of place of residence\' (adopted)"},{"id":"645a89bf-77d9-4f28-b0df-fbdc93a6b911","text":"Abolition of the Soviet \'propiska\' system and lingering public confusion about registration (historical/legal context)"},{"id":"48555f17-882d-48b9-a03a-0c1a3711c0e6","text":"Publication of large 2022 pan\u2011cancer mycobiome analyses showing tumor\u2011associated fungal signatures across multiple cancer types (pan\u2011cancer mycobiome studies)."},{"id":"3226a3e3-1e00-4386-bb16-3d567fba77f9","text":"Public debate and symbolic acts over Odesa\'s Russian imperial monuments (removal of Catherine II statue)"},{"id":"2b0b5fe1-bfad-4c0e-b5e0-76bf9af80f36","text":"NATO Wales Summit pledges concrete support to Ukraine (Readiness Action Plan)"},{"id":"4ae84f5e-59ea-487c-b407-5bfbcfe9d271","text":"US announces $53 million in non-lethal military assistance to Ukraine"},{"id":"e86761d9-fa89-4480-bf36-115dfe98c6b0","text":"John McCain visits Maidan and publicly supports protesters"},{"id":"7954bc6b-c492-453c-9796-f6c5a5dfe4d4","text":"Japan suspends use of some Moderna COVID-19 vaccine batches amid contamination concerns (reported by Reuters)."},{"id":"a4353cb2-f322-4a31-b4d3-6ac1693c1d88","text":"Office for National Statistics (ONS) public \'Deaths by vaccination status, England\' dataset and periodic releases (dataset page with major updates accessible 25 August 2023)."},{"id":"38d6788e-799f-4d5d-8d97-1d8b7c99665b","text":"UKHSA \'Vaccine surveillance report\' (Week 4) published figures showing substantially reduced or \'negative\' vaccine effectiveness against symptomatic Omicron infection in some analyses."},{"id":"ff67ba3b-46c2-42ff-be54-e2eb64f3b42b","text":"Publication of case series and reports documenting short-term inflammatory musculoskeletal events after COVID-19 vaccination (e.g., \'Spectrum of short-term inflammatory musculoskeletal manifestations after COVID-19 vaccine administration: a report of 66 cases\')."},{"id":"fc9b5ba0-b2c6-4fd3-bd70-03456c965cea","text":"Historic precedent of drownings at the Hungary\u2013Serbia/Tisza border route and UNHCR public concern (reported in 2016)."},{"id":"f1dfc5e7-8a60-496c-9552-9ad86c0f72b0","text":"Recent regional examples of formal memorials for migrants who drowned in border rivers (AP coverage of a Drina River memorial in Bosnia)."},{"id":"5ee678f8-8298-42b2-8c29-48e1c8f13db1","text":"Local reports in early May 2024 that multiple bodies were recovered from the Tisza River (State Border Guard Service reported three more drowned people)."},{"id":"05a00692-badd-43b7-97ac-20a484aa8c2c","text":"Launch/inauguration of Hulhumal\xe9 Phase 3 land-reclamation works (government announcement, inaugurated September 22, 2023)"},{"id":"53b8ba4f-0b4e-464a-b32e-a2a399aa2f36","text":"Publication of Duvat 2019 review \'A global assessment of atoll island planform changes over the past decades\' reporting that 88.6% of studied atoll islands were stable or increased in area"},{"id":"d7a3fe53-881e-4eff-bd66-7599825f5bfa","text":"MIT Self-Assembly Lab / National Geographic-supported \'Growing Islands\' projects in the Maldives (projects and demonstrations, including 2022 fieldwork)"},{"id":"bfab812f-f35f-4434-b8c9-931f6a095d07","text":"CDC public guidance for health departments/laboratories on reporting breakthrough cases which states: for cases with a known RT-PCR cycle threshold (Ct) value, submit only specimens with Ct value \u226428 to CDC for sequencing."},{"id":"99eab8ce-9692-45b3-8ef3-e1c6be42f203","text":"Mainstream media coverage and criticism of the CDC decision to limit active investigation and public reporting of breakthrough infections to hospitalized/fatal cases (coverage highlighting concerns this could \'hide\' milder breakthroughs)."},{"id":"bf43c495-6334-4bc0-9698-1441bfc6e8a2","text":"Documented U.S. support for Ukrainian civil society and opposition groups via NGOs and grants (e.g., National Endowment for Democracy activities in Ukraine around 2013\u20132014)."},{"id":"f0bbdab9-ccc4-4a48-8e87-69328f9d2cec","text":"Victoria Nuland public remark that the U.S. has invested about $5 billion in Ukraine since 1991."},{"id":"bac2779e-65a3-4bb1-a15c-5896e1b277ea","text":"Removal of President Viktor Yanukovych after mass Euromaidan protests; Yanukovych flees Kyiv and parliament votes to remove him."},{"id":"2bd643ab-04dd-42d8-8b9c-f459af0c1d6c","text":"IPCC Fifth Assessment Report (AR5) notes a reduced rate of surface warming for 1998\u20132012 (the so\u2011called \'global warming hiatus\')"},{"id":"b2ba8839-0f81-45f8-8999-b2c1360ff592","text":"IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) published and approved"},{"id":"7118efe7-4a74-4b7d-9603-c9a06dec22b7","text":"2019\u201320 Australian \'Black Summer\' bushfires (widespread, high\u2011impact fires across eastern and southern Australia)"},{"id":"56e832cf-c75e-4b19-b939-958843af5e48","text":"Major polar vortex breakdown and cold snap across North America and parts of Europe"},{"id":"d076e1e4-cb01-4830-b778-89ad0d5d2d0f","text":"Dublin Declaration on Maternal Health Care issued (pro\u2011life clinicians declare \'abortion is not medically necessary\')"},{"id":"6086d3ec-6e14-4e5a-97e5-abcc68acd1ba","text":"Ohio \'heartbeat\' (Human Rights and Heartbeat Protection) bill signed into law"},{"id":"b2db9a74-3810-496a-8336-83ee8026fd39","text":"Alabama Human Life Protection Act signed into law (near\u2011total abortion ban)"},{"id":"c0543dc9-93ec-4472-b679-5a93806f0f77","text":"Prior high\u2011profile \'map without Crimea\' incidents (e.g., Human Rights Watch map controversy) primed public sensitivity to any depiction of Ukraine that appears to exclude Crimea."},{"id":"b0ad41ab-0fbe-421f-b0f8-b5820cfab9cb","text":"CDC MMWR report on a rapid COVID-19 outbreak in an Ohio Amish community (May 2020) showing very high attack rates after social gatherings."},{"id":"c21686c5-492d-47ed-a7dc-74dbabe21e49","text":"Local reporting claimed up to 90% of Lancaster County \'Plain\' households had been infected, suggesting community-level \'herd immunity\'."},{"id":"8509f258-1a84-4c3e-881d-8e34fe030827","text":"Reporting of foreign volunteers and sympathizers (including Europeans) joining separatists in Donbas (2014)"},{"id":"4c13fa25-8bb8-4651-b117-8c16579c165d","text":"Large government\u2011sanctioned pro\u2011Crimea/Putin demonstrations in Moscow (March 2014)"},{"id":"4fa6e076-c198-48ad-ac22-9996dcaaaac6","text":"Nationalisation of PrivatBank after capital shortfall (18 December 2016)"},{"id":"bd84f781-f0b2-443a-86c1-1de0da98affc","text":"Outbreak of large\u2011scale fighting in Donbas and its measured economic impact (2014\u20132015)"},{"id":"2e6a3ac6-876f-4bdb-b5d6-ec1962d7cac9","text":"Sharp hryvnia devaluation and currency crisis (February 2014)"},{"id":"aa4c4361-bd70-4c16-8b8d-a8d8e16e8564","text":"Background: Ukraine\'s International Legion and widespread coverage of thousands of foreign volunteers (Feb 2022)"},{"id":"93b9d616-36b6-407b-ad9e-1fb9962ff572","text":"NCHS/CDC published official guidance on how to certify deaths involving COVID-19 (guidance on listing COVID-19 on death certificates)."},{"id":"083b147a-37da-49e9-b89b-80b1206f92f3","text":"Official explanations and reporting about provisional mortality data and reporting lags in the NCHS/CDC mortality system."},{"id":"a9730833-1cbc-41a7-981f-380069816fe2","text":"Clinical trial registration for high\u2011dose intravenous vitamin C in COVID-19 (NCT04264533) announced on ClinicalTrials.gov"},{"id":"77fe070d-3c75-456e-b8eb-3b2323bec095","text":"Ukraine reported hundreds of its citizens were trapped in Gaza and said it was working to evacuate them (public statements, mid\u2011October 2023)."},{"id":"45bf98f3-dfe7-4c7b-805c-f5a4309f585f","text":"Large, ongoing presence of Ukrainian refugees in Romania (official UNHCR and government figures published in 2022\u2013early 2023)."},{"id":"d77df6cb-bf52-4891-bfcb-2c327a3ea055","text":"Brazil President Jair Bolsonaro publicly downplayed COVID\u201119, calling it \'a little cold\' and criticizing lockdowns in a March 24, 2020 address."},{"id":"9cbaf22f-5db4-42dd-8dc7-b3aee930ef0d","text":"WHO statement (and tweet) on January 14, 2020 saying preliminary investigations found no clear evidence of human\u2011to\u2011human transmission."},{"id":"68f4113b-fa65-47cd-b9c9-00630b24aaf1","text":"Russian missile strike on Dnipro (widely reported Nov 21, 2024)"},{"id":"7188e349-5551-48b8-a82d-ae8ce0e1608b","text":"Rapid intensification and an unusual track of Tropical Storm Milton as documented by official National Hurricane Center advisories in early October 2024."},{"id":"1b4f37ec-096c-4542-a2b5-2e6328a8fcb1","text":"Hurricane Helene (late September 2024) severely impacted Florida days earlier, prompting online discussion about consecutive destructive storms."},{"id":"234107a1-2d51-40dd-86d6-b8887f339749","text":"WHO fact sheet reporting ~1.5 billion people globally infected with soil\u2011transmitted helminths"},{"id":"a415d643-ac0e-4216-a102-a2f12264e028","text":"FDA public warning about \'Miracle Mineral Solution\' (MMS) marketed as a cure-all including for parasites"},{"id":"f4e17a2a-d83f-42d0-9c98-c8b76a75a3e3","text":"Sharp surge in European wholesale gas and power prices, raising fears of winter supply shortages"},{"id":"2e545ac9-0408-49ef-acbd-eebc010bc0f5","text":"Completion of Nord Stream 2 pipeline construction reported in early September 2021"},{"id":"28e872e1-54c2-4629-adba-821071b37393","text":"Signing of the 2019 Russia\u2013Ukraine gas transit agreement (dec. 30, 2019) defining transit volumes through Ukraine for 2020\u201324"},{"id":"1474e2b8-6074-4173-a8bc-660920f8d84c","text":"The Crimean parliament, while under occupation, appointed pro\u2011Russian politician Sergey Aksyonov as prime minister."},{"id":"c0708339-d06a-4d2f-9640-e90ba5065484","text":"Masked, unmarked armed men (the so-called \'little green men\') seized the Crimean parliament building in Simferopol, occupying the legislature and preventing normal sessions."},{"id":"054735a2-d878-49d2-a85a-78ab7f20b354","text":"Ukraine announces a nearly $40 million embezzlement scheme tied to mortar-shell procurement (SBU investigation)"},{"id":"161af1f3-b533-4865-8e8b-ce4e87edee12","text":"Rising conservative/public skepticism about continued U.S. assistance to Ukraine documented in 2023 media coverage"},{"id":"1b943fa2-7492-4be5-baba-7b276458d36c","text":"Rapid growth of labor migration from Ukraine to Poland (Poland issued ~1.8 million employers\' declarations in 2017; analysis 2018)"},{"id":"57f00d8f-79ab-4e3f-8432-c5cd5b080a3a","text":"Large-scale internal displacement and civilian displacement from Donbas (UNHCR reports, 2015)"},{"id":"05ea2b41-7f2c-4b98-9986-f0043518081a","text":"EU Schengen visa\u2011free regime for Ukrainian citizens comes into force"},{"id":"a6bb481b-95ed-4927-b068-02899e5acb8e","text":"U.S. decision and delivery timeline in spring 2018 to supply Javelin anti\u2011tank systems to Ukraine"},{"id":"82f8df41-62a4-4c60-b1e2-3bc51397ef77","text":"Kurt Volker\u2019s visit to Ukraine (mid\u2011May 2018) and on\u2011the\u2011ground briefings about Donbas/Crimea"},{"id":"42f69999-16fd-4192-8a90-6f4a9bddb2cc","text":"Uman\u2019s profile as a major Hasidic pilgrimage site and reports of thousands of visitors in March 2022"},{"id":"54fa120c-bf41-4acb-b703-c002ce29bfab","text":"Putin\'s February 24, 2022 justification for the invasion invoking \'demilitarisation\' and \'denazification\' of Ukraine"},{"id":"9dc120af-a0aa-4d5e-aef0-3f64615ce66e","text":"HAARP published a transmission notice / research campaign for May 8\u201310, 2024 (ionospheric heating experiments)"},{"id":"857d79b5-d04d-4378-b6e2-21108e81bec5","text":"NOAA Space Weather Prediction Center issued a Severe (G4) Geomagnetic Storm Watch"},{"id":"c024f0d5-d740-4ee7-b9e9-22987e13f9d0","text":"Registration of the Pfizer/BioNTech BNT162b2 Phase 1/2/3 clinical trial on ClinicalTrials.gov (NCT04368728), first posted in April 2020, with trial documents showing pregnancy as an exclusion criterion."},{"id":"ddf9fd9b-4935-4514-8aa2-b4fba931d670","text":"2014 Kenya tetanus vaccine sterilization allegations and subsequent WHO/UNICEF denial (HCG claim) \u2014 high\u2011profile historical sterilization scare."},{"id":"396eedea-a0df-4b80-92de-3d9452c164c8","text":"NOAA/NCEI (Karl et al.) 2015 paper revising ocean temperature bias and updating the global surface-temperature record"},{"id":"3fca0deb-dcca-4917-bbb1-c4081d0a8912","text":"Prior high-profile contacts between Turkish officials and Crimean Tatar leaders (e.g., Turkish FM Mevl\xfct \xc7avu\u015Fo\u011Flu met Mustafa Dzhemilev, Jan 26, 2016)"},{"id":"eed0a2af-58e6-4bfd-b251-a9afdf857973","text":"Public biographical records show Nalyvaychenko served at the Ukrainian Embassy in the United States (Consular service/Consul in Washington, D.C., 2001\u20132003)."},{"id":"b95db0c1-f08e-47e0-844c-fdcad8e31dd5","text":"Press coverage in Feb 2014 publicised close cooperation between Ukraine\u2019s SBU and U.S. intelligence partners (coverage emphasising U.S.\u2013SBU ties)."},{"id":"a6bd6b25-ba3d-4850-b5c2-8e0287cff121","text":"European Commission publishes staff analysis showing rising short\u2011term visa refusal rates for Ukrainian applicants (2013\u21922014)"},{"id":"4aca75c3-c165-4f17-843f-046db2679cc6","text":"EU adopts Sixth Progress Report on Ukraine\'s Visa Liberalisation Action Plan (Commission decision communicated in December 2015)"},{"id":"8f7c65bc-aaa5-4afd-afb0-4e3edfa22f58","text":"Several Schengen states reintroduce internal border controls during the 2015 migration crisis"},{"id":"4af8450d-2bb0-437b-8014-0cd241e50d77","text":"EU decision to prolong economic sanctions on Russia (June 2019)"},{"id":"d73463a1-5438-4300-ac9d-930dadca166a","text":"Kerch Strait naval confrontation \u2014 Russia seizes Ukrainian ships"},{"id":"0534fdf6-a82b-41fc-b06d-21e023f1ea24","text":"Skripal poisoning and mass expulsions of Russian diplomats"},{"id":"9e9c0237-da1e-4af7-8f48-cecebd8dca83","text":"Downing of Malaysia Airlines flight MH17 over eastern Ukraine"},{"id":"86a14342-af6d-4056-aa63-8dcd47006a73","text":"Preprint and early reports (June\u2013July 2021) documented multiple vaccine \'breakthrough\' infections with the Delta variant, including clusters where fully vaccinated people became infected."},{"id":"164abe24-6e10-49b3-ba08-593644130278","text":"CDC clinical guidance (May 2021) noted people with recent SARS-CoV-2 infection may consider delaying vaccination for up to three months and that infection can confer temporary immunity."},{"id":"028b5959-8bc5-46f0-809d-c6469b06172d","text":"Israeli Ministry of Health and Reuters reported in early July 2021 that measured effectiveness of the Pfizer\u2013BioNTech vaccine against infection had declined (headline figure reported ~64% in early July amid Delta spread)."},{"id":"55bb880b-433a-4f90-85b9-1938e89ba0cb","text":"SIREN study (healthcare workers) reported substantially lower reinfection rates among antibody-positive participants compared with antibody-negative participants."},{"id":"39f5ed96-dc5f-4d39-839b-6d6e5c18be9c","text":"Lancet Rheumatology paper reported lower humoral (antibody) responses after COVID-19 vaccination in patients with immune\u2011mediated inflammatory diseases"},{"id":"d6e5d0ec-a287-4c85-aaea-293d330b05a6","text":"Japan suspends use of some Moderna COVID-19 vaccine batches after discovery of foreign/black particles"},{"id":"683796d7-fd83-4d96-8114-5d3ce3862e85","text":"FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children 5\u201311"},{"id":"88e7d9ca-6337-4303-9f4e-3459cb5b0080","text":"Public reporting and CDC guidance on rare myocarditis/pericarditis cases after mRNA vaccination in adolescents and young adults"},{"id":"bc63a604-0288-4ac9-91e0-1ac813d262ed","text":"U.S. publicly rejected Poland\u2019s proposal to transfer its MiG\u201129s via a U.S. base, citing NATO concerns"},{"id":"4fcc8039-7dd5-48b5-b18b-3c35026981a3","text":"NATO announced plans to reinforce its eastern flank with additional troops and assets in response to the Russian invasion"},{"id":"22c8c250-6974-4ac0-a7bc-85c57fa97817","text":"Analysis and reporting documented an uptick in Kremlin disinformation targeting Poland and Poland\u2013Ukraine relations"},{"id":"b1bc7ef5-ba2f-4ac7-9441-542d10fb5d51","text":"WHO-China Joint Mission final report noted roughly 80% of confirmed COVID-19 cases were mild."},{"id":"900f0d59-882e-48bb-8068-faadd341686a","text":"Early WHO/CDC public guidance said masks were primarily for symptomatic people and caregivers and were not routinely required for healthy members of the public."},{"id":"699a4af5-75d6-42db-a04f-798074f56283","text":"Industry/academic report \'Sustainable Decommissioning: Wind Turbine Blade Recycling\' (March 2021) documented technical and commercial barriers to large-scale blade recycling and called for solutions."},{"id":"2409363a-85ec-4eec-b018-6d215e71357f","text":"Public Health Scotland / national reports on births and pregnancy outcomes for year ending 31 March 2023 published (routine surveillance showing fluctuations in stillbirth/neonatal rates)."},{"id":"4fd10c59-57d3-4f84-ab30-85e11a35ae70","text":"Published medical case reports and toxicology literature documenting severe turpentine poisoning"},{"id":"a0532d2b-b781-4d22-b19a-f140e497e286","text":"Radiology literature (2021) documenting vaccine-associated axillary/supraclavicular lymphadenopathy and FDG PET/CT uptake"},{"id":"62f432a4-e789-437b-ad39-5d0879fde1b7","text":"Publication of a case report describing rapid progression of marginal zone B\u2011cell lymphoma following BNT162b2 vaccination (Frontiers in Medicine)"},{"id":"8a40ef2a-7e19-4ee7-8d2c-14d80b5c22d6","text":"Germany publicly approved supplying Leopard 2 tanks to Ukraine and allowed other countries to re-export their Leopard tanks."},{"id":"ec45dd9c-8476-4ca4-8716-3447aeaaff68","text":"High-profile coverage of Wagner Group operations and heavy losses around Bakhmut in February 2023 increased attention on Wagner\'s battlefield role."},{"id":"d7517e48-9bd4-49ba-8321-6ae9a929e42a","text":"EPA issues the 2009 Endangerment Finding that greenhouse gases (including CO2) threaten public health and welfare."},{"id":"83e941d2-2d4c-462a-ada6-2662be655124","text":"Scientific and industry literature documenting routine CO2 enrichment in greenhouses to boost plant growth (longstanding agricultural practice; review articles dating back decades)."},{"id":"023a3a03-92bd-4dfa-b4d8-ed4ca639438c","text":"U.S. Rep. John Shimkus publicly refers to carbon dioxide as \'plant food\' during a House Energy and Commerce subcommittee hearing."},{"id":"4355567f-f64b-428f-940a-54888926dacf","text":"Drone/sea\u2011drone attacks on ships and the Sevastopol/Black Sea Fleet anchorage"},{"id":"2d7d05b8-6a8b-4471-896c-1e99aa152da9","text":"Explosions at Saky (Novofedorivka) air base in western Crimea"},{"id":"2f787b43-5648-40b8-af1a-ce6489975e0c","text":"Russian reports of arrests/detentions over alleged plots to sabotage Crimean infrastructure"},{"id":"fa2510b2-5e3f-4313-95b0-2440af717372","text":"Passage of the National Childhood Vaccine Injury Act (NCVIA) establishing the National Vaccine Injury Compensation Program (VICP)"},{"id":"c13298b9-61bd-4a7a-96f1-e75eb5933ea9","text":"FDA proposed sunscreen monograph update and limited \'GRASE\' designation (only zinc oxide and titanium dioxide)"},{"id":"b18559d0-6625-4df8-84f6-d6b9f030e6f1","text":"Edgewell (Banana Boat) voluntary recall for sunscreens due to benzene contamination"},{"id":"7f59b6be-620e-4011-a17a-e99f10acfed5","text":"Seizure of Sloviansk and other towns (April 2014) \u2014 separatists quickly occupied checkpoints and were reported driving captured Ukrainian armoured vehicles"},{"id":"ff9240ed-fc40-4246-8fb4-084cf8be6aa2","text":"Battle of Ilovaisk (August 2014) \u2014 encirclement and heavy Ukrainian losses with numerous troops killed, wounded or captured"},{"id":"df28a2d0-2357-4af3-a4f5-b4f636d4887c","text":"UNESCO expert recommendation to list the Great Barrier Reef as \'in danger\'"},{"id":"6d57745f-f537-4a34-9959-ced8d105f77c","text":"AIMS press release: \'Reef in recovery window after decade of disturbances\' (AIMS Long\u2011Term Monitoring Program results)"},{"id":"e8111f10-d07b-4362-a05c-fd60042d4a9e","text":"Australian government and political backlash/lobbying over UNESCO recommendation"},{"id":"e0d54a0c-eece-48bb-8f50-cd3eaafc0fa9","text":"Earlier inconsistent public messaging on mask use by health authorities (CDC guidance evolution, April 3, 2020 recommendation to wear cloth face coverings)"},{"id":"29a4e505-4099-47a6-998e-2154a79c4650","text":"Publication of the DANMASK-19 randomized trial (Danish mask study) in the Annals of Internal Medicine"},{"id":"cbc20e83-8597-40f4-a223-ff847caa8763","text":"UN OHCHR Human Rights Monitoring Mission (HRMMU) report on Ukraine noting incomplete/inconclusive investigations into the Odessa 2 May deaths"},{"id":"c73d8b2c-c98d-404d-b0eb-4e7f458a1c68","text":"South African National Institute for Communicable Diseases (NICD) early assessment reported Omicron appeared less severe on average but produced a rapid surge in cases and hospitalisations (report released Dec 21, 2021)."},{"id":"265d0497-7c7f-4aaa-97e5-c3e3f9b9a5d9","text":"Publication of a major global study quantifying temperature-related mortality (Zhao et al.) in Lancet Planetary Health"},{"id":"167e4a22-6387-4899-9281-5bd108afc174","text":"EU agreement on visa\u2011free travel for Ukrainian citizens (visa liberalisation process confirmed in 2017)"},{"id":"44c4e67f-e11c-4a5b-abb7-d66838bc1680","text":"EU sanctions on Russia in response to the annexation of Crimea and destabilisation of eastern Ukraine (sanctions imposed and expanded in 2014)"},{"id":"9021bbcd-8ce7-4eeb-91ac-db6bedfae0f6","text":"Ukrainian Cabinet fixes one\u2011time payment of 15 million UAH for families of fallen servicemen (decree published)"},{"id":"dc87d64e-7133-4ab2-9822-5b4dad563276","text":"Government measures earlier in 2022 to simplify/adjust compensation procedures for families (administrative changes and rolling implementation)"},{"id":"b5c3dfbe-a902-4930-9123-0e9d9bfb1f9b","text":"Amendments to the law on social/legal protection of servicemen came into force (changed wording about how one\u2011time payments are regulated)"},{"id":"305f1c79-5f44-45b3-8aad-5c5125a53dda","text":"Verkhovna Rada approved Ukraine\'s 2020 state budget (official figures: revenues ~UAH 1.093 trillion, expenditures ~UAH 1.18 trillion, UAH 141.5 billion allocated for debt servicing)."},{"id":"42074ae2-3944-45c8-b8f5-a31e31728ae8","text":"IMF approved a US$3.9 billion Stand\u2011By arrangement for Ukraine (IMF press release documenting large external financing and conditionality)."},{"id":"947bd4ad-0681-4fcd-917e-bf454d698358","text":"World Bank / multilateral reporting (Ukraine Economic Update, Nov 2019) warned of sizable financing needs and public\u2011debt pressures for 2019\u201321."},{"id":"86a5d119-e0d3-4b14-9574-eff13e1bba20","text":"Reporting of social tensions and local backlash in Germany over the large influx of Ukrainian refugees (coverage throughout 2022 highlighting strains on communities and rising anti\u2011refugee sentiment)."},{"id":"fd1ae651-a295-4fb7-aa7d-e0c20925c0b3","text":"Rizzi restaurant in Baden\u2011Baden was reported to have fired a Ukrainian employee after he posted a video condemning Russia (reported and condemned by Ukrainian officials in March 2022)."},{"id":"0ce6df1f-de08-4e37-81dd-b059d2f9a721","text":"Explosions and missile strikes at Odesa port and nearby industrial sites were widely reported (e.g., reported explosions at Odesa port on April 3, 2022 and a deadly strike on April 23, 2022)."},{"id":"3813ea57-62ec-4431-980e-559b659d3259","text":"Media reports of Western deliveries of gas masks and CBRN protective equipment to Ukraine (e.g., UK announced sending thousands of gas masks in April 2022)."},{"id":"9376e72a-49a8-4fed-9912-59965f0d4884","text":"United Nations letter (dated 6 April 2022) referencing alleged planned provocations and preparations for chemical weapons use in Ukraine."},{"id":"5c8cb8c9-8ece-4977-bcbd-d2e4cffc1a57","text":"Russian Ministry of Defence publicly claimed Ukrainian special services were preparing a chemical \'provocation\' using toxic chemicals near the Yuzhny (South) port outside Odesa."},{"id":"caef5161-88f8-4f7b-b0bf-bac754f2b8b4","text":"Release/presentation of a Queensland Health study reporting that rates of persistent symptoms 12 weeks after Omicron infection were similar to rates after influenza in a highly vaccinated Queensland population."},{"id":"35e13dd4-e5b1-46f5-9779-5910c9c89ff4","text":"European officials and media flagged that the proposed U.S. sanctions could target firms involved in Nord Stream 2 and other European energy projects"},{"id":"bb4557ee-951a-432e-aeb0-b7ac0227446f","text":"U.S. Senate overwhelmingly passed a bill imposing new sanctions on Russia (CAATSA)"},{"id":"f9cbbdaa-f4dc-4f8e-814e-576477baa645","text":"President Trump announced U.S. withdrawal from the Paris Climate Agreement, triggering strong EU criticism"},{"id":"07a7f429-0b04-4bb2-9b73-31695a425c61","text":"OSCE Special Monitoring Mission (SMM) spot reports document shelling incidents and civilian casualties in Donetsk"},{"id":"fbd73d33-2ca0-4697-9ee8-edf14741a73f","text":"UNICEF report: over 1,000 children sheltering underground in Donetsk city (bomb shelters) and urgent needs appeal"},{"id":"c2d956be-c010-4d63-8ca4-73abb047cd6c","text":"International media reports \'Ukraine, rebels trade blame over shelling of central Donetsk\' after July 2015 strikes"},{"id":"f978a9ba-a72a-4d76-ad65-4fc16420acf4","text":"Signing of the Minsk II agreement (February 2015) and subsequent claims of non\u2011implementation and ongoing violations"},{"id":"4870f0af-991a-4d27-a5f9-cef54f4d7d80","text":"Official supply\u2011shortage notices for semaglutide (Ozempic) and related GLP\u20111 drugs in early 2023."},{"id":"09cd458a-ad60-4918-b2d1-344d0996dbf0","text":"Deep energy and commercial ties between Italian energy firm Eni and Russia\'s Gazprom, including extensions of strategic agreements (reported 2011\u20132012)."},{"id":"ec955636-b8ce-43b4-bdb6-4b52b0f60f67","text":"Release of the U.S. Fourth National Climate Assessment (NCA4), emphasizing strong human influence on recent warming"},{"id":"8a6f7da5-6f97-4723-b387-160cd81f8eaf","text":"Release of UAH Version 6.0 satellite temperature dataset showing a reduced lower-troposphere warming trend"},{"id":"fe0ab7d0-5acf-42f6-8d11-4410eb81005f","text":"Publication of a 1980 study documenting systemic perfusion produced by vigorous coughing in humans and animals"},{"id":"70741f36-330a-4765-a621-855856897516","text":"Resuscitation Council UK public statement warning the public that \'cough CPR\' is incorrect advice and should not be used outside monitored clinical settings"},{"id":"901090a6-06b9-4600-b248-c7bc52f2b33f","text":"OSCE Special Monitoring Mission reports from early 2015 described restricted access, movement limitations and damage affecting medical services in Donetsk region, complicating independent verification of medical treatment claims."},{"id":"391f37e2-a85d-4207-991b-bc64b2b1d453","text":"The existence and release of wounded Ukrainian soldier Roman Kapatsiy (treated after captivity) \u2014 reports showed he had severe injuries, attracted media attention, and his condition and treatment became contested facts."},{"id":"73bbc6b1-7507-43c5-b47e-df9f5a3fa756","text":"Community publications and documentation describing routine reprocessing and geophysical corrections for satellite altimetry (ESA/AVISO and ESA CCI overview papers, 2016)"},{"id":"e4614d97-76f8-464c-87e9-5e00cd0e98a0","text":"PNAS paper reporting detectable acceleration in global mean sea level (Nerem et al., 2018)"},{"id":"2df72a4e-2d4e-4310-8419-dd7b8caee3ae","text":"Shelling and a fire were reported at the Zaporizhzhia nuclear power plant during early March 2022 hostilities."},{"id":"57078c34-49ef-40e1-97cc-1bd6a7f3aba2","text":"US Air Force B-52 bomber task force conducted long-range integration flights through Europe (Bomber Task Force Europe) in March 2022."},{"id":"0a4dd1e7-aba8-40f6-aa1b-b91867f98acd","text":"Russian President Vladimir Putin ordered Russian nuclear deterrence forces put on high alert."},{"id":"12287211-b799-467b-ac65-9921283f2620","text":"NATO annual nuclear exercise \'Steadfast Noon\' commenced, involving dozens of aircraft and allied nations."},{"id":"ee8a9520-1592-4aa6-ba78-e6d3348a11c9","text":"NATO adopted its 2022 Strategic Concept at the Madrid Summit, explicitly addressing Russia as the most significant and direct threat to Allies\u2019 security."},{"id":"4af338f2-92aa-41fc-abd0-d816738ca401","text":"CDC MMWR report documenting thousands of vaccine \'breakthrough\' infections reported January\u2013April 2021"},{"id":"e4a17a8b-1a7c-4da0-9e91-f1c49111ee2f","text":"NIH / Health Affairs summary reporting that COVID-19 vaccines prevented nearly 140,000 U.S. deaths in the first months of rollout"},{"id":"942c17a3-a28c-48b2-8150-0f346cb8a272","text":"IPCC AR6 Synthesis Report released (summarizing strong attribution of recent warming to human greenhouse gas emissions)"},{"id":"5d144e6c-0172-4295-85b0-d471a3a7359c","text":"NOAA / NASA updates and public discussion of Solar Cycle 25 progress (solar-cycle forecasts/plots revised/updated in early 2023)"},{"id":"40be193a-bde9-42b6-b43a-6e1b513e00b8","text":"Publication of Nicola Scafetta\'s paper arguing a large solar influence on recent climate change"},{"id":"f3edd9ad-4e7a-42e5-8560-e4a8141035fe","text":"Kateryna Prokopenko (head of the Association of Azovstal Defenders\' Families) visited Germany in early April 2023 to hold meetings with German MPs and ministry representatives seeking humanitarian and rehabilitation support for families and released soldiers."},{"id":"10370b60-b6d5-4e58-84e3-bb99d84b57b1","text":"News reports of contamination concerns after foreign particles were found in some Moderna vials in Japan (leading to temporary pauses/collections of batches)."},{"id":"dbb7b443-25c7-4477-97da-b099f151c261","text":"Public HAARP transmission schedules / community notices in 2024 (routine test announcements, e.g., August 2024 transmission notice)"},{"id":"17f13200-d0c9-4962-867c-9258ba566722","text":"International Organization for Migration and other agencies repaired and expanded collective centres and integration/housing projects for internally displaced persons (IDPs) in Lviv region."},{"id":"ca06531c-e8d4-44b4-ba96-588241c99fb6","text":"Adoption of Ukraine\'s \'On Education\' law (Sept 2017) which phases in greater use of Ukrainian as the language of instruction."},{"id":"62394e44-2e3d-4879-b2f4-addda51d3474","text":"Media reports (international and domestic) on national\u2011patriotic youth camps and \'patriotic education\' programs in Ukraine (coverage in 2018)."},{"id":"363e6fcb-13c9-405b-ae89-318d01bdd863","text":"Government and research reports quantifying long COVID\'s prevalence and labour\u2011market impact in 2022 (UK ONS and research briefs)"},{"id":"6d1072d3-bdb2-4476-816f-6ec12e977fca","text":"Japan discovered metal contaminants in multiple Moderna vaccine batches (led to recalls and paused use)"},{"id":"b4480d63-fe94-4e57-99a7-30518a54dae6","text":"EMA safety updates reporting millions of spontaneous adverse\u2011event reports in EudraVigilance (December 2022 update)"},{"id":"bd644c9c-610f-4fdd-aaa2-9b1398d9bfd8","text":"Reporting in 2014 highlighted Svoboda\'s nationalist/controversial imagery and its roles in government after Euromaidan (e.g., BBC coverage of far\u2011right role in late 2014)."},{"id":"98342ee6-0977-4f0c-a3dc-0e09f0b6f30c","text":"Catalan child-protection agency (DGAIA) removed two schoolgirls from a Barcelona school and took them into protective custody on or after 17 June 2022."},{"id":"17b5c061-8a0f-4741-9e55-8350b0a6f7a8","text":"Russian state television (Channel One, program Vremya) broadcast segments accusing Catalan authorities of \'Russophobia\' in connection with the Barcelona custody case (late July 2022 coverage)."},{"id":"1c0e90be-fe07-4fb5-8eca-8fa4a9d63345","text":"Broader bilateral tensions between Spain/EU and Russia in 2022 (e.g., Spain expelled Russian diplomats in May 2022), increasing a receptive environment for claims of anti-Russian actions abroad."},{"id":"ee3fe76a-6f8c-4313-8914-17a0cbce118a","text":"Opinion op-ed in The Hill by Drs. Pierre Kory and Paul Marik claiming ~70% of patients in a private practice reported symptom onset after vaccination (coining/advancing \'long vax\')."},{"id":"2fbadc7f-0a31-4d3b-974a-62946d1fa866","text":"Official reports that Ukrainian nationals were among foreign victims and contacts with the Ukrainian embassy (Zelenskiy statement)"},{"id":"9e1033af-514d-40d9-8043-bfcb5559e972","text":"Large-scale Hamas-led attack on Israel caused mass casualties and chaos"},{"id":"390a0f6c-3271-4d89-9def-b9099ca6d093","text":"Parliamentary measures (July 2022) and legislative proposals expanding categories eligible for exemption or deferment during mobilization"},{"id":"f7447847-d7cb-43a9-bf6a-2a34237e6243","text":"Cabinet of Ministers Resolution No. 76 establishing the procedure for reservation (deferment) of employees during mobilization"},{"id":"4dc604dd-ff2c-4cb5-9485-c298aa8d6be7","text":"Law on Mobilization amendments and implementing rules entering into force clarifying grounds and procedures for booking/reserving conscripts"},{"id":"e9685bf6-4435-496a-aad0-67339144be17","text":"State license granted to the Kyiv Three Saints Theological Seminary to offer a first (bachelor\u2019s) level degree in Theology"},{"id":"3cb10e35-b70a-4e35-9bc8-0b6323028162","text":"International analyses documenting flows of foreign fighters into Syria/Iraq (The Soufan Group updates, 2014\u2013Dec 2015)"},{"id":"08a8e2ce-1c6e-4368-a829-680c4555465c","text":"Second World Congress of Crimean Tatars convened in Ankara with hundreds of delegates from many countries (international diaspora gathering, Aug 1\u20132, 2015)"},{"id":"ac28e2ea-de98-44db-b15f-8efda41cf373","text":"Media reports that some Crimean Tatars (and other individuals from the region) had fought in the Syrian conflict"},{"id":"5b48e9a1-a870-4978-bcd4-60d8b4a01145","text":"Lithuanian Riflemen\'s Union hosts a five-day camp for 30 children from eastern Ukraine (Donbass)"},{"id":"125f05cc-1fb8-4a4b-a3f5-daa08d0d3c0a","text":"Passage of Ukraine\'s \'decommunization\' laws banning public promotion of Soviet symbols and requiring removal/renaming of Soviet\u2011era memorials and street names."},{"id":"09d00e6f-03c7-4256-a351-aa6ba0bb64b7","text":"Ukrainian authorities (Ministry of Veterans Affairs / regional outlets) distributed Ukrainian commemorative medals to some WWII veterans in spring 2020."},{"id":"5602e897-4263-40db-983e-f751d1289418","text":"Ukrainian lawmakers amended administrative code to prohibit public production and promotion of the St. George\'s (Victory) ribbon."},{"id":"4d490a29-9d11-445f-b79f-a6dfcf6b674e","text":"OSCE Special Monitoring Mission (SMM) daily reports in late August\u2013early September 2018 documented continuing ceasefire violations along the contact line (Donetsk/Luhansk)."},{"id":"7bc04a5a-2610-492a-bd4e-6ac4c4efab63","text":"Russian Foreign Ministry and other Russian officials publicly condemned Kyiv\'s reintegration law, saying it \'untied the hands of the war party\' and undermined the Minsk process."},{"id":"0d1a7174-88e9-498e-b1d4-e1f4ae813e1d","text":"European Parliament / policy briefings in 2018 and commentary highlighted tensions between Ukraine\'s domestic reforms (e.g., decentralisation/legislation) and the interpretation/implementation of Minsk II."},{"id":"f6fd9164-7b07-4ac8-9eab-636f169adbdd","text":"Ukraine signs the \'Law on the Reintegration of the Donbas\' which defines Russia as an \'aggressor\' and sets a new legal framework for retaking occupied territories."},{"id":"6d45de8f-261e-4b0d-9624-00564698fef8","text":"Legacy controversy over the 2012 Kivalov\u2013Kolesnichenko language law and its political fallout (language policy highly politicized since 2012)"},{"id":"a2e6496a-27dd-43d6-bf2e-e6e5d3f3233a","text":"Kyiv City Council member Yuriy Syrotiuk registers a draft proposal to require Ukrainian in city advertising, record keeping and official communications"},{"id":"3dbd115e-607e-4c28-a5ec-5ca4c7dac23a","text":"Publication and coverage of genetic\u2011risk research showing APOE and common variants alter Alzheimer\'s risk/timing (Lancet Neurology 2018 and related coverage)"},{"id":"c176ebce-1701-4035-ba6a-31ff5c47e475","text":"Publication of the FINGER multidomain randomized trial showing diet, exercise, cognitive training and vascular monitoring improved cognition in at\u2011risk older adults"},{"id":"7cb1e360-e3e6-43be-a1c2-4df98a02568d","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers acknowledges smaller observed warming trends 1998\u20132012 than many model simulations and cites internal variability as a likely contributor."},{"id":"e34a708e-7958-4919-bfbd-a00065d97651","text":"Amnesty International published a briefing documenting abuses and possible war crimes by pro-government volunteer battalions (e.g., Aidar) operating alongside official forces."},{"id":"069673ab-fcaf-463d-a280-db1b9f50dc4d","text":"Ukrainian President Petro Poroshenko publicly said Ukrainian forces were fighting \'foreign mercenaries\' in the east."},{"id":"0ace144a-883d-455f-a69f-7c95f297209d","text":"NASA/NOAA public messaging about Solar Cycle 25 and increased space weather activity"},{"id":"451fbd13-5ece-4d53-b46e-c6816efe2135","text":"Out\u2011of\u2011cycle update to the World Magnetic Model (WMM2020) after rapid movement of the magnetic north pole"},{"id":"7731b716-ba63-4fa8-a146-9875413ac64e","text":"Ukraine reinstated military conscription to meet manpower needs after unrest in the east"},{"id":"f9430af8-c65d-4712-bf56-6735831ab122","text":"Summaries and timelines noted multiple, uneven waves of mobilization (including difficult autumn stages) with administrative complications"},{"id":"b1359cf2-e916-4c3b-951e-dbcfb91228b8","text":"Feature reporting documented men hiding or fleeing to avoid conscription and the social backlash against mobilization"},{"id":"813a7097-75bc-4c0f-8ef2-db8268ff9773","text":"Federal judge orders the FDA to accelerate release of Pfizer COVID-19 vaccine documents (55,000 pages per month)."},{"id":"36cfd210-d06b-405b-9f24-0b95636db2a8","text":"UKHSA published weekly COVID-19 surveillance tables (four weeks to 2 January 2022) showing counts of cases, hospitalisations and deaths broken down by vaccination status."},{"id":"1bb7068b-f675-4d37-8b29-eb4ac7b27ab8","text":"UKHSA published guidance and commentary (Transparency & data blog, 2 November 2021) explaining that raw counts by vaccination status should not be used to estimate vaccine effectiveness because of differing risk, behaviour and testing patterns."},{"id":"08832f1f-1e9d-4560-bcf1-086be71ff254","text":"CDC and other public-health reports covering the Omicron period and bivalent booster era (e.g., MMWR analyses covering Oct 2021\u2013Dec 2022, published early 2023) documented many breakthrough infections and complex changing relative rates of cases and hospitalisations."},{"id":"ce180f9a-7b6f-424b-890b-5c098fcd67e7","text":"NORAD and U.S. military routinely intercept and track Russian military aircraft operating near Alaska (documented intercepts in prior years)."},{"id":"b9122ba0-8bf3-4d37-be60-68c9a8e6d891","text":"Historical pattern of military formation flights and public aerobatic displays over Alaska (large multi\u2011aircraft formation exercises reported previously)."},{"id":"94029f94-bfa4-46ce-85a1-102fb3438ebf","text":"Russian/Crimean resettlement and incentive programs announced for Crimea"},{"id":"8de55777-91cc-4500-8eb9-00391cfd1996","text":"Large\u2011scale issuance of Russian passports to Crimean residents after annexation"},{"id":"b30a890f-bb1e-4dcf-8f4a-7da32d5fd2ec","text":"Resumption and growth of scheduled flights and transport connections to Simferopol (2015 onward)"},{"id":"6f1c091f-2d5d-4ccf-9148-6a7144b3728f","text":"OSCE Special Monitoring Mission (SMM) reporting of increased ceasefire violations/explosions and damage in Luhansk frontline areas (SMM daily monitoring around mid\u2011February 2022, including Stanytsia Luhanska and Zolote)."},{"id":"7c48ff9c-3572-4d1f-af8d-a28071ad3e88","text":"Leaders of the self\u2011proclaimed Donetsk and Luhansk \u2018people\u2019s republics\u2019 announced mass evacuations to Russia (official evacuation orders and state messaging)."},{"id":"c604a848-73e4-47d9-911c-ab0b2f44f9ad","text":"Historical precedent of bridges and rail infrastructure being blown up during fighting in eastern Ukraine (documented incidents in 2014 where rail/road bridges were destroyed)."},{"id":"130c0ed0-197a-441a-affe-5b87f347f7a4","text":"LifeNews crew detained near Kramatorsk by Ukrainian forces, drawing attention to the channel\u2019s activities in conflict zones."},{"id":"b76a8e41-ea5e-46ab-8afd-273b69e724d7","text":"Early-March videos and eyewitness accounts documented violent attacks by pro-Russian separatists on protesters and demonstrators in eastern Ukraine."},{"id":"3119678a-5fd7-4f1e-a362-401a8f99b6b2","text":"Self\u2011declared Donetsk and Luhansk \'people\'s republics\' announced independence after May 2014 referendums"},{"id":"77e135a3-c11f-4f48-b351-38a792b72478","text":"Trilateral Contact Group negotiations included representatives of the self\u2011proclaimed Donetsk and Luhansk authorities (OSCE mediation, mid\u20112014)"},{"id":"6ee76e7a-4bd0-404b-abab-03d01a57ea06","text":"Publication and wide circulation of quantitative comparisons of volcanic vs anthropogenic CO2 (e.g., Gerlach 2011) providing concrete numbers showing volcanic CO2 is far smaller than human emissions."},{"id":"d2420cfd-d81a-4d8a-9d9c-2dafefab70fa","text":"IPCC Special Report on Global Warming of 1.5\xb0C (high-profile report, October 2018) that refocused public debate on CO2 budgets and human emissions."},{"id":"1e771bf3-49a5-44b9-9445-735d725cfa2c","text":"Reports and recall after discovery of foreign (black) particles in Moderna vaccine vials in Japan (late August\u2013September 2021)"},{"id":"e291a5da-d21f-4619-96ef-ce2d2ff75968","text":"CDC reports increased cases of myocarditis/pericarditis after mRNA COVID-19 vaccination in adolescents and young adults (public reporting began June 2021)"},{"id":"ecdc5e87-0734-41de-9be7-f76522dd49da","text":"FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children aged 5\u201311"},{"id":"91496a2d-e3b3-4b43-9df6-217b8662cc7f","text":"Technical advisory scrutiny and Bureau response on ACORN\u2011SAT adjustments (ACORN\u2011SAT Technical Advisory Forum response)"},{"id":"96c7ba3e-250c-4e59-a015-d908813b2161","text":"Release of the ACORN\u2011SAT homogenised temperature dataset by the Bureau of Meteorology"},{"id":"48fdf656-134e-4e2f-947d-ab46a493fe4b","text":"Widespread use of distance learning by mid\u20112022 (reports noting that by June 2022 most districts were providing remote classes)"},{"id":"c7031f37-932e-4f20-b1f0-ad805c418d7e","text":"Ministry of Education and UNICEF launch \'Back to Learning Together\' initiative encouraging return to in-person schooling"},{"id":"4678a09c-7907-45d5-bc3c-1cf48fe82a4e","text":"WHO and World Customs Organization published an HS classification reference for COVID-19 medical supplies (including simplified labels) on April 9, 2020"},{"id":"320d06c2-1801-4f37-832c-c689ba25fa8b","text":"Adoption/use of the sixth edition Harmonized System (HS) nomenclature for commodity codes (introduced in 2017) that underpins WITS historical trade classifications"},{"id":"3bfa0b44-82e8-46c4-baec-c2540f1c85b5","text":"Russian flags and pro\u2011Russian banners were visibly displayed in Russian\u2011occupied Ukrainian cities (e.g., Melitopol, Kherson) after Russian forces took control."},{"id":"9c0a5f5b-884b-47d0-8a88-2fc8c6138662","text":"Reports the US was sending military advisers and gear to Ukraine"},{"id":"7f844310-acc5-4a3f-92f1-abac2e63d440","text":"U.S. Congress passes the Ukraine Support Act (H.R.4278)"},{"id":"984d798b-65ca-481c-a6fd-8b4a2a459f92","text":"President Obama meets President-elect Petro Poroshenko (bilateral meeting in Warsaw)"},{"id":"8504e0ca-b54f-4a5b-9b47-cf9d1a45fb89","text":"CDC interim guidance recommending routine cleaning and disinfection of high-touch surfaces in public and private facilities"},{"id":"c1415165-6ad5-4522-a309-629f404ef316","text":"Mainstream consumer guidance advising precautions when pumping gas (Consumer Reports article advising wipes/precautions)"},{"id":"2bd80a18-8bff-480f-994d-68d37192db5b","text":"NEJM correspondence showing SARS-CoV-2 remains viable in aerosols and on surfaces (van Doremalen et al.)"},{"id":"d26c872a-78d8-4320-b5f2-e0033b5b2abb","text":"News coverage and retailer actions showing grocery stores providing wipes and installing cart-sanitizing measures"},{"id":"ad99cdd7-f0b0-4d1c-93b7-1d96068758a7","text":"WHO/UNICEF updated and re-emphasised global guidance recommending exclusive breastfeeding for the first 6 months and advising not to give additional water to infants under 6 months."},{"id":"cb7405f5-b619-4f66-9b7b-4d562a8fc6d6","text":"CDC MMWR report summarising cases of hyponatremic seizures among infants fed excessive solute\u2011free water (including bottled water) in Wisconsin (1993) and urging clinicians to discourage use of solute\u2011free water as a supplement for infants under 6 months."},{"id":"60700a47-9ea0-4dce-a491-4559115f0b62","text":"Gates Foundation funding of genetically engineered mosquito/gene-drive research (2016\u20132018 coverage, e.g., Oxitec funding)"},{"id":"d886f5bc-664c-429c-9754-67530af6439e","text":"Study reporting very low methylphenidate (Ritalin) prescription prevalence in France based on drug reimbursement databases (published 2007\u20132008)"},{"id":"b412355e-81dd-48f3-a462-70fd74d23a27","text":"CDC report \'Mental Health Surveillance Among Children \u2014 United States, 2005\u20132011\' stating \'up to 1 in 5 children suffer from a mental disorder\'"},{"id":"0ec94a00-7242-4423-b564-9baf54723262","text":"French national telephone prevalence study (Lecendreux et al.) estimating childhood ADHD prevalence ~3.5%\u20135.6% (published 2011)"},{"id":"1276b48a-4aa4-4922-aef4-4f038cbfbb97","text":"Measles outbreak in the Gothenburg area (outbreak period Dec 2017\u2013Jan 2018) reported in Eurosurveillance (article published April 25, 2019)."},{"id":"f6bf258c-c08e-4db5-9460-a91e3e5f12c9","text":"Public Health Agency of Sweden (Folkh\xe4lsomyndigheten) information emphasising that vaccinations in Sweden are recommended (not compulsory) and are implemented regionally."},{"id":"ffd7678d-00ac-4300-868a-ef2229fb89f9","text":"European pauses and safety reviews of the AstraZeneca vaccine after rare clot reports (March\u2013April 2021)"},{"id":"9dca14dc-8e09-4ce9-bc08-504e8a677f71","text":"Japan recalls some Moderna COVID-19 vaccine doses after foreign particles found in vials (September 2021)"},{"id":"b9d88390-2a0f-45c9-821c-da2a75aaf2d8","text":"WHO designation of Omicron (B.1.1.529) as a Variant of Concern and early statements on mutations/immune escape"},{"id":"c3c07c77-af4b-4204-aabc-6aa4aa674f5d","text":"CDC/ACIP updates and MMWR reporting on myocarditis cases after mRNA vaccination"},{"id":"97e9dcc9-5f54-4f83-b653-40d574bdafb2","text":"Ukrainian law on temporarily occupied territories (Law No. 1207\u2011VII, 15 April 2014) \u2014 non\u2011recognition of documents issued by occupation authorities"},{"id":"94db3d3a-fce0-4c90-bfb1-3758ab374e4b","text":"Russian presidential decree (April 2019) simplifying and fast\u2011tracking Russian citizenship for residents of the self\u2011proclaimed Donetsk and Luhansk \'republics\'"},{"id":"427c91a8-7ad7-4918-a7dd-f76a14ce3b91","text":"Publication of research using luciferase reporters in SARS\u2011CoV\u20112 laboratory assays"},{"id":"a779aee6-ebd1-4097-a98d-ba7a139404a4","text":"NFPA / Fire Protection Research Foundation published reports and guidance describing the unique firefighting challenges posed by electric vehicle \'stranded energy\' and battery fires."},{"id":"ffd49188-632d-4b7b-a9e5-5a53a52c624f","text":"General Motors issued a high-profile recall of Chevrolet Bolt EVs over a risk of battery-related fires (recalls and repair campaigns announced starting November 2020 and updated subsequently)."},{"id":"af0f83b2-a044-45d7-a820-3b7af9266a72","text":"Ford announced recalls and investigations into a small number of F-150 Lightning pickups over battery-pack issues after several battery-related fire incidents and a temporary production halt (recall notices and reports in early 2025)."},{"id":"69107281-2506-4b5d-ad9c-33de7589fcc9","text":"Multiple electric buses in London caught fire (high-visibility incidents in May 2024), prompting safety checks of hundreds of vehicles and broad media coverage."},{"id":"659d2172-0bd9-48a1-bd4e-33d1367d832a","text":"Publication of Otto et al., \'Energy budget constraints on climate response\' (Nature Geoscience, May 2013), which produced observational energy-budget estimates of climate sensitivity on the lower end of model ranges."},{"id":"835dff59-f9d8-4192-9930-64aaadcaa5bb","text":"IPCC AR5 Summary for Policymakers (Sep 2013) stated it is \\"extremely likely\\" that more than half of the observed increase in global average surface temperature from 1951 to 2010 was caused by anthropogenic greenhouse gases."},{"id":"a1458d74-452e-4b95-854c-fd6204bfd7ae","text":"ICEYE and Ukraine\'s Ministry of Defence sign a Memorandum of Cooperation to strengthen remote-sensing support for Ukraine (publicised July 2024)"},{"id":"1e3994e0-1d0d-49d4-9d43-09c8589b99ad","text":"Reporting that the \'Prytula\' / \'People\'s Satellite\' warranty period expired while GUR continued to use the asset (media coverage raising questions about operational status, July 4, 2025)"},{"id":"94eb1e79-dfe0-47e9-94f8-ff7b6b531e28","text":"Ukraine\'s Defence Intelligence (GUR/DIU) and media reports state the \'People\'s Satellite\' supplied thousands of SAR images used to identify Russian military targets (mid\u20112024 reporting of ~4,000+ images)"},{"id":"52f824fc-6777-4d31-ae8e-0b0d83e13dce","text":"Cultural/history articles revisiting Reich\'s orgone accumulator (e.g., Open Culture piece) were published in early 2021 and circulated thereafter, describing the accumulator, its devotees, and DIY plans online."},{"id":"57aab8ea-02d6-4c09-b173-144d4f8c9012","text":"Documented paramilitary training and transnational links involving Azov/National Corps veterans (analyses and reports up to 2021)"},{"id":"5d30da82-103d-48ce-8488-ed7168079cca","text":"Ukraine surrendered the Soviet-era nuclear arsenal under the 1994 Budapest Memorandum"},{"id":"515aca24-3240-4fc9-8782-c2e7439ec022","text":"A group of countries (UK, Poland, Netherlands and others) publicly pledged to pursue \'unprecedented\' military support including main battle tanks for Ukraine."},{"id":"13727699-8b9a-4d25-b74b-7990b71f76c4","text":"Germany approves sending Leopard 2 tanks to Ukraine, paving way for allied tank deliveries."},{"id":"863817b6-14dc-4206-bcc9-a6f86320d92f","text":"Russian officials publicly denounced Western promises to send tanks as an escalation and framed them as direct Western involvement in the conflict."},{"id":"a3460dbc-2bb3-468e-ae47-1048dcc494b8","text":"UN Secretary-General Ant\xf3nio Guterres called for de\u2011escalation and warned about risks of wider war in public remarks at Davos."},{"id":"c2044de8-6008-4dae-b756-39e02b4f336d","text":"Peer\u2011reviewed retrospective study (Argentina) found higher rates of false\u2011positive HIV ELISA results among people with prior COVID\u201119 or detectable anti\u2011SARS\u2011CoV\u20112 antibodies"},{"id":"98b91f13-53ee-4bf1-a84f-46cbdbe22cfe","text":"NATO maritime group (including Turkish navy participation) visited the Bulgarian Black Sea port of Varna during Black Sea deployment"},{"id":"c1a8afb9-3dd3-4d26-b831-94baea535cff","text":"Investigations and reporting showing Bulgarian-made weapons appearing in Middle Eastern conflict zones"},{"id":"1af3f1f6-7fc0-4f65-84c9-ab73efc8a94b","text":"Ukraine detained a Turkish-owned cargo ship after it visited a Crimean port"},{"id":"ebf309fb-72f4-4aa8-9fce-de1b2954f161","text":"Reuters report that Turkey\'s state intelligence agency helped ship arms to Syrian rebel areas"},{"id":"a78a0d1d-fb23-486e-8d7c-31e54b1f6b80","text":"Investigative reporting on crowdfunding for alternative cancer treatments and rise in patient fundraising for unproven therapies."},{"id":"19c3bba1-fa0a-46fa-ba1b-60b9d8ea36cc","text":"WHO commentary warning against \'immunity passports\' and noting uncertainty about post\u2011infection immunity"},{"id":"9e25fe9c-a7fb-4089-b0ce-b5450684df86","text":"Publication: \'Seasonal coronavirus protective immunity is short\u2011lasting\' (Edridge et al., Nature Medicine, May 2020)"},{"id":"138a0535-0d17-4fe8-8ae1-2165b21e315c","text":"WHO told Reuters it had advised Ukraine in March 2022 to destroy certain high\u2011risk pathogens in public health laboratories to prevent accidental release during the war"},{"id":"8b7f373b-537a-4a7c-9177-bce487373ca9","text":"A prior 2020 incident: Ukrainian volunteers dropped ruble\u2011shaped leaflets over occupied Luhansk (Slavyanoserbsk/Stepove), which local separatist authorities later claimed were contaminated"},{"id":"da7bede6-7a01-4a88-8ee2-8487491580d2","text":"FDA issues Emergency Use Authorization for Pfizer\u2013BioNTech COVID\u201119 vaccine (Dec 2020)"},{"id":"25469249-14a0-4d3c-b927-3fcd39e306b8","text":"Publication of early seroprevalence studies suggesting lower infection fatality rates (e.g., Stanford/Santa Clara preprint)"},{"id":"b9f61132-8496-4398-a695-fd09dcbf8995","text":"IMF / national energy-policy documents and regulator schedules (2015\u20132016) documented planned increases in household energy tariffs as part of energy-market reform and commitments to creditors."},{"id":"aea49fae-06ed-4218-960f-84a8e7dff779","text":"Kyiv City Council approved additional municipal budget allocations for organizing and hosting Eurovision (including reported allocations for surveillance/security and event costs)."},{"id":"d4854f09-6b5d-45dd-ad64-57ee66a031ad","text":"European Broadcasting Union (EBU) confirmed Kyiv as host city for the 2017 Eurovision Song Contest."},{"id":"3b1ac5b5-c528-4a0f-96af-d9bbc0ad402f","text":"Russian strikes and shelling left Kharkiv without water and power, with dozens of civilian casualties reported"},{"id":"cef7cf93-eb17-4334-ad4b-619188793fd2","text":"Evacuations and chaotic flight from Kharkiv, including reports of students and residents fleeing on foot after nearby shelling"},{"id":"ba6ff167-e8c8-40a9-9a84-61f53e1f342a","text":"Frequent reporting and situation updates showing Ukrainian forces prioritizing defense and counterattacks around Kyiv while fighting continued in the northeast"},{"id":"03e3beb0-ecbe-4656-bcdd-f724ae845e9c","text":"Norwegian review of deaths among very frail elderly shortly after Pfizer vaccination (investigation reported March 2021)"},{"id":"f3a8343a-d979-47b7-815c-831df4ef2799","text":"CDC / ACIP communication and MMWR reports on myocarditis after mRNA vaccines (June 2021)"},{"id":"eeda927f-0cf9-4701-8464-ee83c49a371d","text":"OSCE Special Monitoring Mission reports and daily summaries recorded clashes, alleged atrocities and contested reports around Donetsk/Snizhne in Aug 2014"},{"id":"bd99aeb0-773d-4bd1-a916-0b224aff6474","text":"Airstrike hits residential buildings in Snizhne, killing civilians"},{"id":"51ced878-c7a3-4b0b-94ea-fe890b9f18ee","text":"Japan reports contamination (black/foreign particles) in batches of Moderna COVID-19 vaccine vials, prompting recalls and temporary suspension of some batches"},{"id":"a1d27647-8ea4-473b-a900-c1a08dcc2af4","text":"Coverage and commentary noting a post-pandemic rise in late-stage and some rare/aggressive cancer diagnoses \u2014 analysts and clinicians pointed to missed screenings, delayed diagnoses and possible biological mechanisms tied to SARS\u2011CoV\u20112 infection"},{"id":"a5fec585-45ef-4e77-acb2-44a4eb77e056","text":"U.S. Government Accountability Office (GAO) report on cloud\u2011seeding technology (GAO\u201125\u2011107328) concluded in December 2024 that evidence for cloud\u2011seeding effectiveness is limited and uncertain."},{"id":"a8e91066-2bad-4046-99e9-01080c342e9b","text":"A private cloud\u2011seeding company (Rainmaker Technology) conducted a brief cloud\u2011seeding flight over south\u2011central Texas two days before the floods."},{"id":"b18211ac-bc7a-480e-8886-4ea26acbfe0e","text":"Russian president\'s decree simplifying the naturalization process for Ukrainians (widely reported July 2022)"},{"id":"14644813-a1fa-4256-8100-1202ecc87880","text":"Local and national Ukrainian reports (mid-March 2022) documented that Russian shelling had heavily damaged parts of Rubizhne City Multidisciplinary Hospital (e.g., maternity/obstetrics department destroyed)."},{"id":"6aa42f60-59db-4177-9a34-b9d050386ad3","text":"Ramzan Kadyrov publicly announced Chechen forces\' deployment to Ukraine and frequently posted videos and claims via his Telegram/state-affiliated channels in Feb\u2013May 2022."},{"id":"43a98ba9-e0cc-46b6-b06f-d5ff92020ba2","text":"The Rubizhne Central City Hospital infectious diseases department had been renovated in 2017 with funds from UNDP and the Government of Japan (official works and signage)."},{"id":"18fc5214-0e1a-4582-bd8e-68e7df91da5c","text":"IPCC AR5 and public messaging about decadal/short\u2011term variability vs. long\u2011term warming (IPCC WGI report, 2013)"},{"id":"3c81b0a8-0ec3-44d5-9e23-b6886684a510","text":"Commissioning and public release of the U.S. Climate Reference Network (USCRN) as a high\u2011quality, \u2018pristine\u2019 temperature station network (began 2005; ongoing rollout)"},{"id":"b8aaffa6-27c2-47ef-afa7-238f612eb2a5","text":"Publication of Karl et al. (NOAA) in Science revising global surface temperature records and rebutting the idea of a global \'hiatus\' (June 2015)"},{"id":"9ed245ca-3c9a-4ee3-8019-4ff857adca60","text":"Local bans/restrictions on Russian\u2011language cultural products in parts of Ukraine (example: Lviv restrictions/public measures)."},{"id":"05b4f83a-d62a-4bc4-8ac6-f243c3eca0ba","text":"Constitutional Court declared the 2012 Kivalov\u2013Kolesnichenko \'regional languages\' law unconstitutional."},{"id":"dbcf6044-164e-48b0-a8bb-9b20202a86ca","text":"Public and parliamentary clashes around the second reading of the language bill, with pro\u2011Russian MPs and media framing the draft as discriminatory/anti\u2011Russian (disruption and heated debate around Feb\u2013Mar 2019)."},{"id":"495f7684-da08-4796-a97f-20763a81934c","text":"Verkhovna Rada approved draft bill No. 5670-d (the new state language bill) at first reading."},{"id":"07ef1c9d-9e02-48fa-894e-9aa9ac00825f","text":"Dutch Safety Board (Onderzoeksraad) formally took charge of the international investigation into the MH17 crash"},{"id":"ee64a014-2ae8-4581-af12-44746c5eac31","text":"Gazprom and Naftogaz sign settlement and five-year transit agreement"},{"id":"1ca9b445-a7f1-4e4d-a7c3-b2b10215d91d","text":"Longstanding precedent: Russia cut gas to Ukraine and Europe in January 2009"},{"id":"ab2f6972-f2b3-43ba-ad67-ccdea1dc15ea","text":"Inauguration of TurkStream pipeline (alternative southern route)"},{"id":"9219490f-23d2-4d56-9e71-68248cfd250b","text":"Published analysis noting reduced guaranteed transit volumes from 2021 under the 2019 deal"},{"id":"b66fd564-56e0-4dbc-af75-4d728a3b595b","text":"IUCN / Polar Bear Specialist Group published 2015 Red List assessment with a global population estimate (\u224822,000\u201331,000) and noted the overall population trend as \'unknown\'."},{"id":"cf1261a7-6ec6-4d9b-96a1-7fa516cb00ba","text":"Amnesty International and Human Rights Watch published 2018 findings that Ukrainian authorities failed to investigate and punish far\u2011right violence"},{"id":"8bdd3630-0b71-4a27-9152-988a27b64b02","text":"Volunteer battalions (including Azov) were brought under the Interior Ministry/National Guard command in 2014"},{"id":"b22c5196-0753-459c-b19e-6a661a3c6cfa","text":"Reports that some volunteer regiments were financed or sponsored by political figures/oligarchs while operating under ministry structures (example: Dnipro-1)"},{"id":"d5b40b40-4fd8-4809-825d-74c396c5e1c1","text":"IPCC AR5 (2013) assessment noting divergence among lines of evidence for equilibrium climate sensitivity"},{"id":"816a5a49-d869-42ce-80e4-5a2519321ae8","text":"Release of UAH Version 6 satellite temperature product (Spencer & Christy), reporting reduced tropospheric warming trend"},{"id":"17438dff-d991-4c0d-b588-21ff8e0929ad","text":"Ukraine\'s 2018 national drug situation report (2017 data) noted transit and domestic production of various drugs"},{"id":"a0a3eef5-73dc-4c61-8d1e-ddc2688f0947","text":"Large heroin seizure transiting through Odesa/Illichivsk port (reported 12 June 2015)"},{"id":"738bdcc9-d4ba-4518-ae26-cd7d5fa251dd","text":"Growing media and scientific attention to microplastics in the food chain (scholarly reviews and coverage 2021\u20132024)"},{"id":"b11c29a2-7c09-4c5b-914e-bdff2ac00a4a","text":"Public-health agencies (including the U.S. CDC) and research institutions historically filed patents on viral isolates or related sequences (e.g., CDC and others filed patent applications around the 2003 SARS outbreak to ensure public access to samples)."},{"id":"c91771dd-4604-4c1c-9b41-f6f997180a75","text":"Publication of the Independent Peer Review and technical reports documenting ACORN\u2011SAT methods (technical advisory documents made public)."},{"id":"c12ca3f8-34f3-4cef-a02d-9a0b67614a19","text":"Release of the ACORN\u2011SAT homogenised temperature dataset by the Australian Bureau of Meteorology (the official long\u2011term Australian temperature series)."},{"id":"310da8a6-11f0-4449-846e-b764c9debe0b","text":"Government discussion of investigating the Bureau after public controversy over temperature adjustments (reported discussions in 2015)."},{"id":"879b8025-cd29-49f3-b9bf-9b4eaa9be7dd","text":"FDA enforcement actions and public warnings against numerous for\u2011profit stem cell clinics selling unapproved therapies"},{"id":"52a46197-0688-4cff-bec6-ee4af2d7945c","text":"UN human-rights submissions and NGO reports (2012) documented development and piloting of restorative/diversion programmes for children in conflict with the law across multiple Ukrainian communities."},{"id":"366a6246-8c85-4924-b0d2-5b86bfc2c2d7","text":"Parliament passed an amnesty law and released many protesters (including minors) detained during Euromaidan, creating visible cases of youths being freed from criminal charges."},{"id":"dfedbaec-39b4-4897-a75d-46aac34780e4","text":"Legislative activity and draft bills on child\u2011friendly procedures and mediation (alternative bills on mediation submitted to the Verkhovna Rada) were reported in 2013."},{"id":"b421ab5e-bc05-4b8c-af63-8a7421ab0851","text":"Longstanding NGO-led restorative justice pilot projects (first initiated in 2003) and subsequent local pilots expanded through the 2000s and early 2010s."},{"id":"c583f936-7449-4241-a0b5-700f8583bebd","text":"Japan suspends ~1.6 million Moderna doses over contamination reports"},{"id":"e24b553c-a7d4-4b94-bad9-2938a45a2352","text":"Israel study reports cases of myocarditis after Pfizer mRNA vaccine"},{"id":"bf678fbf-bf14-49a4-907f-4109729b3b0a","text":"Study/analysis showing waning protection of BNT162b2 against Delta (Israel)"},{"id":"0972955b-ece9-47bd-88c3-e8585e08f124","text":"Arla Foods announced a UK trial of the methane-reducing feed additive Bovaer across ~30 farms (with Tesco, Aldi and Morrisons named partners)."},{"id":"68c3d94c-0fd4-4c94-8ee5-79c9666237b8","text":"The UK Food Standards Agency published a detailed technical safety assessment (RP1059) on 3\u2011nitrooxypropanol (3\u2011NOP, the active in Bovaer), including residue analysis and limits of quantification for milk."},{"id":"9433cc9e-44dd-4514-a4e8-8df2fa8e65e1","text":"dsm-firmenich (maker of Bovaer) announced that the US FDA had completed its review and that Bovaer met safety and efficacy requirements, paving the way for a US market launch."},{"id":"06d20d03-85c5-49c3-b962-c5d05ead6130","text":"EFSA / scientific assessments (including a 2021 EFSA feed-additive opinion / published scientific summaries) of 3\u2011NOP (Bovaer) were publicly available prior to 2024."},{"id":"7ee60054-be86-47e7-8f19-418ebd357da1","text":"May 11, 2014 Donetsk and Luhansk \'referendums\' claiming overwhelming support for separation"},{"id":"436663dd-5aff-4330-ba83-ec791399568e","text":"NIH COVID\u201119 Treatment Guidelines panel statement (early 2021) that there was insufficient evidence to recommend ivermectin for COVID\u201119 (revisions in/around February 2021)."},{"id":"28eb1db8-9fc7-4f38-83d7-6cbc590f3620","text":"Reported incident and grid disconnection at Zaporizhzhia nuclear plant (December 2014)"},{"id":"1eed73cf-b401-4aad-b6fb-40dab881fd02","text":"Budapest Memorandum (security assurances to Ukraine)"},{"id":"1319e96c-f08f-4509-8966-9cca047160d7","text":"CDC and FDA June 2021 review and public reporting of myocarditis and pericarditis cases after mRNA COVID\u201119 vaccination."},{"id":"6c2dda8c-ea69-4ecf-a0d2-8bbc59e85879","text":"Federal judge orders accelerated public release of Pfizer vaccine documents (reported Jan 7, 2022), drawing attention to internal vaccine trial materials."},{"id":"cbcc4d41-e1a4-4631-9bd0-f44199ef2491","text":"Ogata et al. (Clinical Infectious Diseases, 2021) reported detection of SARS\u2011CoV\u20112 vaccine antigens (spike protein fragments) in plasma of some mRNA\u20111273 recipients."},{"id":"a70ba9ce-892e-48c3-a0e0-14cce6f091bf","text":"Genomic surveillance identified BA.2.86 in U.S. samples (pooled swabs collected Aug 10; individual sample confirmed Aug 20) and CDC reported early detections."},{"id":"7d5d4a7b-f0e9-4bb2-97ed-7a3546ae51b8","text":"Ukrainian President Volodymyr Zelensky appoints Chrystia Freeland as an economic development adviser"},{"id":"80e76425-e94c-4e6e-b18c-5d0e2458f3df","text":"World Bank / government-backed moves to restructure Naftogaz (ownership unbundling debate, May 2019)"},{"id":"c1db1293-d3f9-4ba1-811b-e39f23953a4a","text":"Ukrainian government public administration reform (Strategy for Public Administration Reform 2019) including targets to streamline staff"},{"id":"ee163317-e616-4d92-ac13-19bb01d1412a","text":"World Bank: Ukraine Economic Update warns manufacturing and investment weak (press release)"},{"id":"4ce9bd1c-33a5-414a-a8cf-ddff35b9944e","text":"WHO declares COVID-19 a Public Health Emergency of International Concern (PHEIC)"},{"id":"7a9c7aa3-b9ec-4447-8ad5-14f53b8a99dc","text":"Publication of a peer\u2011reviewed paper arguing a \'Modern Grand Solar Minimum\' could cause decades of cooling"},{"id":"af60bf05-c6ff-44be-bab4-82baf4596d98","text":"Nordic countries (Sweden, Denmark, Norway, Finland) limited or paused use of Moderna in younger people citing myocarditis signals (Oct 2021)"},{"id":"230d6126-a06f-4719-a4e4-ee47b7d9dfc8","text":"CDC/ACIP report and guidance noting rare myocarditis cases after mRNA COVID-19 vaccination (June 2021)"},{"id":"7fd0faa7-72aa-4187-9f9d-b0ad8cf14b73","text":"FDA emergency authorization of Pfizer\u2011BioNTech COVID\u201119 vaccine for children 5\u201311 (Oct 29, 2021)"},{"id":"5ab2833b-6968-45cd-b20e-3d6a4d94962e","text":"MedRxiv/academic preprint showing children have stronger pre\u2011activated innate airway antiviral responses to SARS\u2011CoV\u20112 (June 2021)"},{"id":"a709cd8e-97a4-4015-9336-5bd9ed38bb12","text":"Local/municipal moves to formalise \'underground\' schooling in frontline areas (Kharkiv announced plans and preparatory works for an underground school; subway\u2011based classes were reported in Kharkiv)."},{"id":"50796783-fd71-48a3-b820-83a169765006","text":"UNICEF photo essay and reporting documenting children sleeping and studying in basements, bomb shelters and other protected spaces in wartime Ukraine."},{"id":"01cac53c-ae09-444b-8c7a-4d8983acba5b","text":"Commentary and analysis documenting a broader trend of \'atrocity denial\' and claims that wartime suffering (in Gaza and Ukraine) is \'staged\' \u2014 media pieces in November 2023 noted this pattern."},{"id":"b16284c8-e200-4b13-9554-b82faa004f1c","text":"Earlier 2025 federalized National Guard deployments to U.S. cities (e.g., Los Angeles in June 2025)"},{"id":"a1355bbd-fdad-48a3-8e4f-5b2bbb3471d0","text":"Japan suspends use of multiple Moderna vaccine batches after reports of foreign particles/contamination found in vials."},{"id":"8713027e-2d87-46f0-8c1c-d199a2b4a510","text":"CDC and FDA recommend a pause in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis (blood clots) in recipients."},{"id":"08aed31c-7eb9-4c4a-8202-846ae0d621e7","text":"European Medicines Agency (EMA) concludes that the Oxford\u2013AstraZeneca COVID-19 vaccine is associated with very rare unusual blood clots combined with low blood platelets and updates safety information."},{"id":"c5a3ecce-7031-464f-a033-0f25096bf05a","text":"EU Agency for Fundamental Rights (FRA) / EU research on \'severe forms of labour exploitation\' highlighted cases and structural vulnerabilities of migrant workers in Poland"},{"id":"fc9c12f8-858e-4cd9-83cf-a3e04b25fe51","text":"Poland ratified the 2014 Protocol to the ILO Forced Labour Convention in October 2016 (official recognition and legal steps on forced labour)"},{"id":"a9642145-43cc-469b-b0d8-1de850452963","text":"Polish government statistic: 420,000 Ukrainian citizens paid Social Insurance contributions in 2018 while estimates suggested up to 1\u20132 million Ukrainian migrants in Poland"},{"id":"cd12d1b2-fd96-4f7e-92a4-60647d717334","text":"Yatsenyuk faced pronounced political pressure and very low public approval in July 2015 (KIIS poll showed extremely low support), creating a background narrative of a weakened leader."},{"id":"2e788f0c-75c7-4cc1-9c6d-ab3bf104216c","text":"U.S. and Western officials had publicly warned in early February 2022 about the possibility of Russian \'false flag\' operations to justify invasion."},{"id":"7ca7d363-1dca-4657-8ef2-203fbc63b00c","text":"A Russian missile struck a high-rise apartment building in southwestern Kyiv and was widely reported on Feb 26, 2022."},{"id":"2d56b4cc-06d2-42fc-96ec-29e8f62f2884","text":"IPCC AR5 (2013) Summary for Policymakers: no single best estimate for equilibrium climate sensitivity given wide uncertainty across lines of evidence"},{"id":"a1629251-5ff9-438d-82c3-c953fa276a4d","text":"Reuters special reporting on the Ukrainian government\'s struggle to control independent volunteer/maverick battalions (reports of units operating beyond official command)."},{"id":"5bec55e8-6809-46ea-85ad-3c7b4426a4a2","text":"Amnesty International documented abuses by the Aidar volunteer battalion operating in Luhansk and areas around Donbas."},{"id":"1f694e3e-1c2a-40f8-bbc7-36e8ce3fb57e","text":"Human Rights Watch published \'You Don\'t Exist\' documenting arbitrary detentions, enforced disappearances and torture in eastern Ukraine by actors including pro\u2011government forces."},{"id":"9b5d9422-c502-48e7-ae6c-be43eebd021c","text":"Minsk II agreement (February 12, 2015) set security, disarmament and withdrawal conditions as prerequisites for holding local elections in Donbas."},{"id":"92eccd30-8e15-4b0a-824d-735cca1c2192","text":"Pro\u2011Russian separatists held disputed \'elections\' in Donetsk and Luhansk on 2 November 2014 amid reports of armed men at polling stations and chaotic scenes."},{"id":"f3a645dd-68f9-4487-b73e-30f2e3ea4d04","text":"Israel reintroduced indoor mask requirements amid a surge driven by the Delta variant."},{"id":"a6d12d64-4e35-421c-bef2-f601d348316c","text":"Texas governor lifts statewide mask mandate and business restrictions (rescind mask orders)."},{"id":"13cee0c9-ef25-445e-82a6-b02b00b2c1fb","text":"Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine showing limited protection for mask wearers (DANMASK-19)."},{"id":"0d4831b9-1c60-4e5b-b0b9-72bc0ccfcae3","text":"Widespread visibility of Ukrainian nationalist symbols (UPA red-and-black flag, Bandera monuments) in Lviv and media coverage of those symbols"},{"id":"e7dd94b7-56b1-49b9-bbc8-e0391e96f07d","text":"Documented incidents of swastika graffiti and antisemitic vandalism in Ukraine in 2014\u20132015"},{"id":"170e6f93-eed9-4548-9823-e63b11639f8c","text":"Air\u2011raid sirens sounded across Kyiv while President Biden and President Zelensky were visiting St. Michael\'s Cathedral (audio and footage captured live)"},{"id":"4b87c2d4-b0bc-4bcd-b2d9-b7f06d0da126","text":"IMF staff in Kyiv discussed draft anti-corruption court legislation as part of program-related conditions"},{"id":"a5c99aa4-f17c-43ae-b34e-509a65aa9fd9","text":"IMF technical mission visited Kyiv to discuss continuation of the Extended Fund Facility (EFF) and held meetings with Ukrainian authorities"},{"id":"2bea5ecd-17cf-4178-ab03-db01a041b647","text":"IMF public statements linking further financial support to Ukraine with implementation of pension reform and other policy conditions"},{"id":"e3e3e85f-f8fb-4a8a-8ccb-600f18cbdcad","text":"IMF said the timing of the next review of Ukraine\u2019s program (and related decisions) was \'not yet decided\', creating public uncertainty about disbursement timing"},{"id":"f435f62c-ad3b-4efa-aa1f-9ff8d3fe62ce","text":"IMF approval of a $17.5 billion bailout program for Ukraine"},{"id":"aabd0189-1323-4f67-92ca-fda61971db3e","text":"Russia\'s retaliatory ban on food imports from the EU, US and other countries"},{"id":"679cb10d-d348-44e6-b2f6-01cb567790a2","text":"Sharp contraction of Ukraine\'s economy and currency devaluation during 2014\u20132015 (World Bank reporting)"},{"id":"7c3b8401-43bd-4f8a-b967-6e2bb3c08280","text":"EU and US impose sanctions on Russia after the annexation of Crimea"},{"id":"c4c8d590-6cdf-48bf-8957-5096693fce2b","text":"Russia cuts natural gas supplies to Ukraine amid pricing/dispute"},{"id":"aa01c2c4-8749-4bb4-a2cd-1b8bb0a95fba","text":"Ukrainian government policy and public statements (reported by major outlets) urging Ukrainian athletes to avoid competitions where they may face Russian or Belarusian competitors and, at times, withdrawing athletes from events for this reason."},{"id":"9ac2f976-c4da-470b-b294-e79f98fc2b54","text":"International Tennis Federation (ITF) suspends the Russian Tennis Federation and Belarus Tennis Federation from ITF membership and from participation in international team competition."},{"id":"25703fba-ae53-45aa-b648-a763cd3e39c4","text":"Federal judge orders the FDA to accelerate public release of Pfizer vaccine documents after a FOIA lawsuit (PHMPT), resulting in large batches of internal Pfizer/FDA files becoming publicly accessible."},{"id":"e0d3d359-f166-4dd2-aca8-a35110d78fd2","text":"Parubiy\'s documented early political activism: co\u2011founding the Social\u2011National Party of Ukraine in 1991 and leading the paramilitary group \'Patriot of Ukraine\' (1998\u20132004)."},{"id":"43f8b899-885b-4050-ac77-5ce53ea324bc","text":"Established Kremlin disinformation pattern of portraying Ukraine (and Ukrainian officials) as \'neo\u2011Nazis\' used repeatedly since 2014."},{"id":"7307d455-2137-4fa5-bc7c-4cdea871a9dc","text":"Spanish authorities had opened and publicised large reception/assistance centres for Ukrainian refugees in spring 2022 (e.g., Malaga centre opened 6 April; PM visited 20 April)."},{"id":"a65d001c-cca8-4840-9b32-1af336faff8b","text":"Science outlets published explanations (early September 2024) that a combination of factors\u2014dry Saharan air, pockets of wind shear, and short-term atmospheric anomalies\u2014had temporarily suppressed Atlantic tropical cyclone formation."},{"id":"24e21450-cd50-46c3-b94e-55ca3db9664c","text":"NOAA issues an \\"above-normal\\" 2024 Atlantic hurricane season outlook predicting 17\u201325 named storms and a high probability of above-normal activity."},{"id":"14e53ed3-1d34-4287-b912-5cda80c785f1","text":"An unusually quiet Labor Day weekend (early September 2024) with no named storms in the Atlantic\u2014reported as a seasonal rarity and record for recent decades."},{"id":"399ec5a7-19c0-4a7b-abf9-391f68e2ff17","text":"Greta Thunberg\'s high-profile speech at the U.N. Climate Action Summit (widely covered and quoted in the days around Sep 23, 2019)."},{"id":"fc6b77f7-dc25-493e-850a-8a5678ac62f1","text":"Russian embassy in London publicly accused UK authorities of searching an Aeroflot aircraft at Heathrow and sent a diplomatic note demanding an explanation."},{"id":"cd833903-1d88-435a-be20-65d7f3030c1d","text":"Ukrainian government creates Ministry of Information Policy (established 2 December 2014)"},{"id":"9969c3be-cc0d-4004-9170-83f03be8a37a","text":"NATO StratCom and academic reports documenting Russian information operations against Ukraine (2014\u20132016)"},{"id":"c29e77b6-be2b-4ba7-85e6-435b4a27cae4","text":"UK government\u2019s March 14 expulsions of 23 Russian diplomats and strong public accusations against Russia over the Skripal poisoning."},{"id":"48993eae-6239-4819-9397-c0e535b16ede","text":"Porton Down (Defence Science and Technology Laboratory) public statements (early April) that its scientists identified the substance as a Novichok-type agent but said they had not verified the precise source of the agent."},{"id":"dc3e294e-d8f5-4f83-8645-15c73a692917","text":"Civil service reform and new requirements for Ukrainian in public administration (law adopted Dec 2015, implemented 2016)"},{"id":"2cbd592e-9b27-43bf-9981-257b2c95850a","text":"Passage of Ukraine\'s \'Law on Education\' (which set Ukrainian as the primary language of instruction)"},{"id":"d90b6765-794f-452a-a742-a154dec3b293","text":"2015 \'decommunization\' laws and related campaigns to remove Soviet-era names and symbols"},{"id":"17726f06-0a1b-4e84-a2da-8c4383fc6422","text":"Adoption and entry into force of the Kivalov\u2013Kolesnichenko \'regional languages\' law (widely debated and later contested)"},{"id":"6cb42a3b-90dc-4c1c-9f7b-c798da81dc3b","text":"Radio Free Europe/Radio Liberty coverage of Oleksandr Hurov (May 2014) describing capture and alleged torture by pro\u2011Russian separatists (includes account of attempts to remove or mutilate markings)."},{"id":"fd57d3a4-1075-477d-ac07-7a5b2f8cf5f6","text":"Russian President Vladimir Putin publicly said Ukraine\'s counteroffensive had \'failed so far\', characterising Ukrainian losses as \'vast\'."},{"id":"06ec29b7-82cf-4072-b4d9-152399a5e654","text":"Rheinmetall had experienced a dramatic run-up in revenue, orders and share price since the 2022 invasion (company Q1/2023 reporting highlighted strong defence demand)."},{"id":"f9c3779a-12b0-4cd5-8f95-525ca13037dd","text":"Major international outlets reported the long\u2011awaited Ukrainian counteroffensive had begun in early June but initial progress looked limited and uncertain."},{"id":"6342e2b7-055f-465b-bfa2-b4ddccaaebb4","text":"Trilateral Contact Group and parties agreed a new ceasefire for eastern Ukraine effective 27 July 2020 (reported by Reuters/OSCE)."},{"id":"c046e6b5-72ee-496c-918b-4be3f500e0ba","text":"President Zelensky\'s endorsement/implementation of the \'Steinmeier Formula\' (October 2019) and related public statements about negotiating a settlement in Donbas."},{"id":"ba975775-fff0-4df5-a3bf-e0ca58335c08","text":"Major prisoner exchange between Ukraine and Russia (reported 7 September 2019), widely covered as confidence-building step."},{"id":"c6f3ddf6-1bab-4d23-b714-953fb57eff01","text":"Appointment of Dmytro Kuleba as Ukraine\'s Foreign Minister (4 March 2020) and his public rhetoric emphasising diplomacy and dialogue alongside deterrence."},{"id":"69e5b66f-97d1-4101-ae74-59610cb88559","text":"Russia\'s 2014 agricultural import ban hit French farmers (loss of export markets), creating domestic political sensitivity to the cost of sanctions."},{"id":"9e3880ce-a29d-43cd-874f-cfef33aa127d","text":"Earlier Hollande statements (2015) publicly floated lifting sanctions if progress were made on Ukraine, establishing a precedent for claims he favored easing sanctions."},{"id":"91fe841d-800b-4739-bd2d-d81c8f002fb8","text":"Publication and mailing of the \'European Climate Declaration\' / World Climate Declaration (organised by Guus Berkhout / CLINTEL) to the UN asserting \'There is no climate emergency\'."},{"id":"7391c888-79ea-4e6f-87cd-27e151639497","text":"Greta Thunberg\'s high-profile speech to the U.N. Climate Action Summit in New York (widely covered and polarising)."},{"id":"1d4c16e0-d010-4863-9727-9cf42723cae9","text":"Global climate strikes and mass protests in the week of 20\u201327 September 2019 (Global Week for Future)."},{"id":"bf10fde4-add0-4ec3-9223-e8f98213cb4d","text":"U.S. Department of Defense Biological Threat Reduction Program (BTRP) provided funding, equipment upgrades and technical assistance to Ukrainian public\u2011health and research laboratories (BTRP cooperation with Ukraine began in 2005)."},{"id":"ef6c5885-5dcf-4ea1-8216-8f32472257f6","text":"Cooperative Biological Engagement Program project in Ukraine with defined implementation period (example: project implementation period listed as 06.03.2015\u201331.12.2020 on Ukrainian project pages)."},{"id":"4d67b61c-8473-4dc6-95a1-580c9649bb7f","text":"U.S. government announced Operation Warp Speed to accelerate COVID\u201119 vaccine development and manufacturing, with involvement from HHS, DOD and other agencies."},{"id":"b2496dbd-12c0-465b-835a-ba1729136df0","text":"Novavax announced it was awarded a Department of Defense contract related to COVID\u201119 vaccine development."},{"id":"c09ce2fc-390b-4863-9fc5-d1930b2f2ff1","text":"U.S. government apology (2010) for the Guatemala syphilis experiments, in which U.S.-linked researchers deliberately infected subjects decades earlier."},{"id":"eb6c052e-7bf2-4485-9d67-51aa2085d18e","text":"CDC updates guidance to discourage a test-based strategy for ending isolation, noting people can remain PCR-positive without being infectious"},{"id":"9b6d9a3a-ada9-41e1-b87d-b843716d0776","text":"Published study (Bullard et al.) showing SARS-CoV-2 PCR cycle threshold (Ct) correlates with likelihood of culturing live virus (higher Ct \u2192 less likely infectious)"},{"id":"4c401541-ab70-4b74-8c2e-5cd24cc436b9","text":"UNAIDS/Ukraine country report documents a large, growing HIV epidemic in Ukraine (estimated ~238,000 people living with HIV in 2016)."},{"id":"75716968-673d-4617-a46d-a6f490fcd10e","text":"Mass internal displacement after the 2014 conflict: hundreds of thousands of internally displaced persons (IDPs) from Donbas by 2015, disrupting continuity of care."},{"id":"503e9999-94ea-4dcd-8c73-e9fc77be30d1","text":"WHO interim guidance recommending postponement of mass vaccination campaigns and adaptation/prioritization of immunization services during COVID-19"},{"id":"98240cd1-a78c-4795-9c7d-26b9f65b0f6a","text":"WHO and UNICEF joint press release warning of an alarming decline in routine childhood vaccinations worldwide"},{"id":"499c415d-6d0e-405a-92ea-56852a59047b","text":"Ukraine erected flow-control measures/temporary dam in Kherson/Kalanchak to cut canal deliveries to occupied Crimea (2014)"},{"id":"bf525db6-d0fe-4882-9a12-8adcd84a4fd8","text":"Academic/technical assessments documenting socio\u2011economic and environmental impacts of Crimea\'s water shortages (peer\u2011reviewed/technical publications 2016)"},{"id":"de69b62a-c856-4aa7-9a3e-3fafbd094da4","text":"Municipal regulations (Plan Especial del Centro Hist\xf3rico and local ordinances) prohibit unauthorised banners/flags on protected facades; the town hall cited these rules when ordering removal."},{"id":"944b2729-f7d8-4888-b155-b4742dfa7d8e","text":"Clinical/dental literature and reviews (including proposals to use povidone\u2011iodine nasal/mouth preparations) circulated in spring 2020 reporting in\u2011vitro virucidal activity of certain antiseptic oral rinses against SARS\u2011CoV\u20112."},{"id":"ccfb3e7c-5f10-4ff4-9e50-b7367383ee17","text":"Regulatory and market environment: reports of unproven oral-spray and supplement COVID claims and subsequent enforcement/crackdowns (e.g., China crackdown on adverts making antiviral claims for oral sprays) in spring 2020."},{"id":"5602e0f4-d219-40d1-b7cf-dc9a28d01309","text":"September 2021 reports that foreign/stainless\u2011steel particles were found in some Moderna vaccine vials in Japan and several lots were suspended."},{"id":"8f4acf67-0350-4998-bea5-99144f2284fc","text":"Russian formal ban on imports of Ukrainian food products (announcement reported November 2015)"},{"id":"0cd4f6a5-2bfa-4bb5-97c4-0f00629d8196","text":"Ukrainian activists impose a land and transport blockade of supplies into Crimea"},{"id":"a191825f-6de9-4d87-8a4d-30409d13d4b4","text":"IPCC AR5 (WG1) chapter on oceans noting that the oceans have absorbed the vast majority of excess heat from global warming"},{"id":"90a516e1-5fec-49da-9932-7d18620d8b22","text":"UKHSA update on scarlet fever and invasive Group A streptococcus noting increased cases in children"},{"id":"4eacb1da-29c5-4742-acfc-7218c4550e65","text":"Event 201 pandemic tabletop exercise (Johns Hopkins / World Economic Forum / Bill & Melinda Gates Foundation)"},{"id":"02afaa47-b21e-459d-acce-148ab6f92cf0","text":"FDA and public\u2011health warnings against internal use of high\u2011strength hydrogen peroxide (35% \'food grade\') and warning letters to vendors."},{"id":"c49fb060-81cd-4e18-802d-4101bbcaf813","text":"Russian President Vladimir Putin asks the Federation Council to authorize the use of Russian armed forces in Ukraine; authorization granted"},{"id":"3dbbe6c8-09df-4e25-b23c-5e7cc9d7526d","text":"Ousted Ukrainian president Viktor Yanukovych reportedly sends a letter requesting Russian assistance"},{"id":"f8f68b07-5c9e-42b8-b2ab-2883893a0e69","text":"ICJ advisory opinion on Kosovo\'s declaration of independence (found not to violate international law)"},{"id":"c379708e-1d1f-4214-910d-94840f38fee8","text":"Armed men seize the Crimean parliament building and raise the Russian flag"},{"id":"945e80be-a5a3-4199-b65a-3bece6b7699a","text":"EU representatives agree (Council conclusions of 20 July 2015) to resettle 22,504 persons in need of international protection from outside the EU (including Middle East, North Africa and Horn of Africa)"},{"id":"4cb6beca-973b-40dc-b67c-0064201fba5e","text":"European Commission proposes mandatory relocation of 40,000 asylum-seekers from Italy and Greece"},{"id":"df1e89aa-6e0c-49cb-bd7b-b0657dff90a5","text":"Strong public opposition from several member states (Visegrad group and others) to EU relocation/quota proposals in mid-2015"},{"id":"24b77652-38fd-4c08-8b22-a14a1d9a2811","text":"Hungary orders closure of its border with Serbia and begins building a fence to stop migrants"},{"id":"7342c0b7-9bb6-45ae-8c6c-294a3543c93d","text":"April 2015 Mediterranean shipwreck off Libya killing hundreds of migrants"},{"id":"ac75ab80-c1ac-450f-9d26-54e49897e0d9","text":"Ukraine\'s Verkhovna Rada formally recognized the 1944 deportation of Crimean Tatars as genocide (resolution passed in November 2015)."},{"id":"a091cb20-bdd6-46a4-b260-73d734a445d1","text":"Ukrainian law and parliamentary debate on the legal regime for \'temporarily occupied territories\' (Law No.1207\u2011VII and related 2014 legislative measures criminalizing collaboration with occupying authorities)."},{"id":"828a1401-a9cd-4280-b0e0-d6113ee19bfd","text":"Russia \'passportised\' Crimean residents after the 2014 annexation (widespread issuance of Russian passports), documented by human rights reporting in 2014."},{"id":"5698e2f9-b7f2-4ad2-aeab-4540a3f4a34e","text":"Andriy Senchenko made televised remarks on Shuster Live calling for \'tough\' measures toward people who moved to Crimea after Feb 20, 2014 (interpreted as calling for rapid removal)."},{"id":"659afe69-c95b-4fda-a2b4-b48856bad257","text":"Parliamentary Assembly of the Council of Europe (PACE) adopted a resolution (drafted by Michele Nicoletti) that set out mechanisms for reconciling participation rules between PACE and the Committee of Ministers and which media reported could pave the way to restore Russian delegation rights."},{"id":"ac2660ea-85e9-4122-bbc2-278ed03028a9","text":"Pandora Papers and subsequent reporting (Oct 2021) documenting links between Zelensky\'s circle and offshore companies / expensive property purchases"},{"id":"5170d91f-7079-47ae-9a0d-71d25e98fd09","text":"Earlier 2025 media coverage of Bill Cosby listing a second Manhattan townhouse for sale (about $7 million) amid foreclosure/legal troubles"},{"id":"8e3d0510-fe87-4f90-868a-80eae47ac2ea","text":"Poland says it cannot accept migrants under EU relocation quotas after the Paris attacks"},{"id":"549a2c5d-d36b-424b-bbd6-4767abb2e041","text":"Financial Times analysis highlighting Poland\'s low intake of Syrian refugees and rising anti-immigrant rhetoric"},{"id":"a57fc600-fd62-4a15-9d6e-e00d1b4108d5","text":"UK government technical note on the impact of false positives and false negatives in the RT-PCR testing programme (operational specificity discussion)"},{"id":"12281cc7-1e7f-4156-9f27-30ed66ab507f","text":"Publication of study linking RT-PCR cycle threshold (Ct) values to culturable virus (Singanayagam et al., correlating Ct and infectiousness)"},{"id":"4c0b373b-ea92-429c-a7ab-0032bb94ca10","text":"Publication and media amplification of the Great Barrington Declaration advocating \'focused protection\' (early October 2020)"},{"id":"c74064d8-77a8-4e11-969d-65b7f7a49d54","text":"Swiss Federal Office of Public Health (BAG) / Swissmedic leaflet on COVID-19 testing published (Merkblatt, referenced wording on PCR/NAT)"},{"id":"627b0e61-d6de-45a7-843b-f20cfb2da184","text":"High-profile political minimization and comparisons of COVID-19 to seasonal influenza (examples in March 2020, e.g., statements by then-US President Donald Trump)"},{"id":"ed9b7284-387d-4093-ba08-d501f3fb89ae","text":"US security-assistance packages to Ukraine (e.g., $125M March 2021)"},{"id":"d3396119-d872-44b0-8deb-e5eb249a90b3","text":"Joint NATO/US public warnings calling on Russia to de-escalate (press points April 2021)"},{"id":"7c38c3e8-093f-42b1-8174-9b06a63c1893","text":"DEFENDER-Europe 21 large US/NATO exercises in Europe"},{"id":"4a539e12-4ecb-4728-a340-d11ee79796b0","text":"NATO Brussels Summit communique reaffirming support for Ukraine"},{"id":"b0510283-9cb0-49bd-ba35-369c2de4a045","text":"Publication (September 7, 2022) of experiments showing ivermectin (alone or combined) enhanced paclitaxel efficacy in chemoresistant high\u2011grade serous carcinoma cell models (Nunes et al., Cancers)."},{"id":"eff633d9-738e-4c7a-af7a-9bf8ef276695","text":"U.S. Department of Health and Human Services ordered millions of doses of the JYNNEOS monkeypox vaccine for response and Strategic National Stockpile delivery."},{"id":"13fcbb30-b184-4dd0-ad67-687bb5a32710","text":"WHO declared the global monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)."},{"id":"7361ba00-780c-4294-83ff-7a605090c8ea","text":"WHO/FAO/WOAH and other agencies published repeated updates and risk assessments about avian influenza (H5Nx) outbreaks and zoonotic risk during 2023\u20132024."},{"id":"67d491b8-372c-4357-8853-fb6d0e78c0c4","text":"European Centre for Disease Prevention and Control (ECDC) reported an increased circulation/rebound of human parvovirus B19 in multiple EU/EEA countries (public advisory/report)."},{"id":"60e7b0fe-5374-480d-af09-321afee17ed5","text":"Rapid formation and public visibility of volunteer combat units (e.g., the Azov Battalion) in 2014 that appeared at checkpoints, rallies and front-line actions."},{"id":"f9af94f9-d0bd-4905-b27f-8bad1d50532f","text":"Euromaidan protesters occupied Kyiv\'s Independence Square (Maidan) and established barricades, driving out police during the February 2014 protests."},{"id":"3ac93f54-f31a-40c2-9c9f-89c85be55235","text":"Pro\u2011Russian separatists seized Sloviansk and other towns in Donetsk oblast in April 2014, setting up armed checkpoints and exercising local control for months."},{"id":"7f2f55cc-063d-4542-a910-41b5995a8b43","text":"Ukraine blocked the North Crimean Canal in 2014 (built a dam/flow-control to stop water to Crimea)"},{"id":"f57edc70-ae95-41b6-aef2-49ea3a1fca81","text":"UN and humanitarian agencies publicly reported reaching and assisting civilians in Sievierodonetsk earlier in 2022 (e.g., UN humanitarian convoy reached Sievierodonetsk in April 2022)."},{"id":"f3a58a27-5f45-44aa-9bf7-bc5c8c2202e2","text":"United Nations had ceased operations in Siverodonetsk by the end of February 2022 (UN office vacated)."},{"id":"28feaf79-870c-4ab7-a66a-2b220c21d5db","text":"Intense Russian shelling and urban combat in Sievierodonetsk in June 2022 produced extensive destruction of civilian and administrative buildings (including fires at the Azot plant)."},{"id":"9da7657c-470e-4730-80ff-14ccdada87c9","text":"Police in Abkhazia (de facto region) seize hundreds of crypto\u2011mining rigs amid power shortages (reported June 2023)"},{"id":"0087ec71-efef-48bd-a9b0-ad70397607b7","text":"Europol / Ukrainian police arrest cryptojacker accused of mining ~\u20AC1.8M (cloud/cryptojacking) in Mykolaiv"},{"id":"9d2a8db7-5155-407d-8436-8d7cee3e5b07","text":"West Midlands Police (UK) uncover bitcoin mining operation stealing electricity at an industrial site"},{"id":"cb11b99e-dea4-44ec-b3f8-b061844a08f2","text":"Global Climate Strikes led by youth (September 20\u201327, 2019)"},{"id":"e9f283cd-f4a6-4739-97f0-60b479c8c50f","text":"IPCC Special Report on Global Warming of 1.5\xb0C released"},{"id":"cf7273eb-95f6-4d64-8982-3c77a54eb37c","text":"Publication of Nerem et al. (PNAS) reporting statistically significant acceleration in global mean sea level from satellite altimetry (1993\u20132016)"},{"id":"35b0bed3-1f4d-4d22-9506-3ffde0094728","text":"Release of the IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) summarizing recent acceleration and future sea-level projections"},{"id":"0afc5e37-1078-418e-9712-600d479f1b63","text":"Publication of Houston & Dean (2011) analysis arguing little or no acceleration in U.S. tide-gauge records"},{"id":"dea74892-770e-46a2-b6a0-b224a7cc797d","text":"Peer\u2011reviewed 2009 review \'Omega\u20116 (n\u20116) and omega\u20113 (n\u20113) fatty acids in tilapia and human health\' (International Journal of Food Sciences and Nutrition)"},{"id":"44bb52cb-2b43-4b01-8e82-ca3f82d435b9","text":"2013 systematic review \'The omega\u20116/omega\u20113 ratio and dementia or cognitive decline\' (Loef & Walach) summarizing evidence linking n\u20116/n\u20113 balance to dementia risk"},{"id":"37d99c23-6cd1-45cc-92df-c11680a66be5","text":"Japan finds stainless-steel/foreign particles in multiple Moderna vaccine vials leading to recalls (September 2021)"},{"id":"f2ddd3a0-eaae-49d2-8c91-7e83372075fe","text":"Widespread pediatric RSV and other respiratory virus surges after COVID-19 restrictions lifted (late 2022)"},{"id":"9f027cbc-e19c-4bb5-8261-cabc26180c9b","text":"Noted rise in invasive Group A Streptococcus (iGAS) and scarlet fever among children in late 2022\u2013early 2023"},{"id":"10e8edc7-51fd-4a67-96a7-0b2ec0458508","text":"Publication showing systemic mRNA COVID-19 vaccines induce variable or limited mucosal (IgA) responses"},{"id":"236295a2-6dc4-432c-950b-cd8ec055a997","text":"NATO and Western institutions publicly warn about \'weaponisation of information\' by Russia"},{"id":"94db85e1-1e45-488e-961c-1852016eb144","text":"Reuters reported the U.S. was \'poised\' to drop opposition and start a process that could eventually send Abrams tanks to Ukraine (policy debate/turnaround coverage)."},{"id":"eacf0c25-ed4c-482d-897c-68a487f7e75d","text":"Germany announced it would supply Leopard 2 tanks and permit partner countries to re-export theirs to Ukraine."},{"id":"c6f0e97b-89d2-4817-8b4b-14549e4f7132","text":"Media coverage warned that even if Abrams were provided, they were \'not expected in Ukraine for months\' because of training, logistics and suitability issues."},{"id":"1ba18464-64e0-4a02-b45c-1bcd8fd1fd2f","text":"Widespread attention to provisional NCHS/CDC all\u2011cause and excess death data for 2021\u20132022 (public NCHS/CDC provisional death tables and dashboards)."},{"id":"be27228c-d989-4f16-9133-a47c0cc58596","text":"CDC/FDA communications and studies acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID\u201119 vaccination in adolescents and young adults (public reporting in 2021)."},{"id":"ad49483c-8b2d-485f-8b1d-4e7c1f885fdd","text":"WHO/air\u2011quality data (2016) flagged Ukraine among countries with very high air\u2011pollution\u2011related mortality"},{"id":"f67d414d-8b31-4350-bc2e-0fc2b65b527c","text":"Investigations and reporting on illegal/low\u2011quality coal supply in Ukraine (Donbas) documented dirty, unregulated coal entering markets"},{"id":"cdd93ecc-dec3-49d2-8519-57fb729a6a6c","text":"Kyiv officials describe mid\u2011January haze as a \'meteorological haze\' while experts point to coal\u2011fired heating plants"},{"id":"1eb822b5-1044-4452-9b7d-5da64b2e1637","text":"Central Geophysical Observatory registered elevated formaldehyde, carbon monoxide and nitrogen dioxide levels in mid\u2011January 2017"},{"id":"57349056-a914-484b-b96a-5e1c0add2dec","text":"State services report monitoring found \'no exceedances\' despite public reports of burning smell and breathing problems"},{"id":"d4755858-bd8c-4c93-9c06-e217f923e761","text":"European Parliament approves visa\u2011free travel for Ukrainians (vote)"},{"id":"1363095c-21ad-4ef8-8981-9d3e06617cf7","text":"EU adopts a revised Visa Suspension Mechanism as a precondition to liberalisation"},{"id":"519c5fae-9511-4646-8e94-46823089e695","text":"Documented large industrial wastewater discharges into the Sea of Azov (Azovstal and other metallurgical plants)"},{"id":"886b25be-3682-4289-925b-472fa91130c0","text":"Scientific and media publications documenting rising pollution and ecological stress in the Sea of Azov (numerical/satellite assessments, 2017)"},{"id":"a2ddcf5d-e29c-4ca6-82b3-bd018543286f","text":"Isolation of toxigenic Vibrio cholerae O1 (Ogawa) from seawater near Taganrog after the 2011 outbreak"},{"id":"48f9f82a-a285-4d1a-9f55-4e78e4a90559","text":"Amnesty International and other human rights organisations publicly highlighted mass graves and documented allegations of torture in recaptured Kharkiv oblast territory"},{"id":"fe3acca7-a1a2-431c-a994-c81bec1ded2c","text":"Passage of Ukraine\'s decommunization laws (April 2015) increasing attention to removal/renaming of monuments"},{"id":"feeb4bde-2a9f-40ea-b58a-1808e9ea7038","text":"Heightened media coverage and public demonstrations around Stepan Bandera (e.g., anniversary marches) in early 2015"},{"id":"fe75fa37-84c5-45c4-85a9-0b535ade106a","text":"IUCN Polar Bear Specialist Group (PBSG) population estimates and status reporting (Regehr et al. / PBSG updates) releasing updated global population ranges (~22,000\u201331,000)"},{"id":"a8947dc0-f568-42c5-8ff5-8327af960ae5","text":"General Medical Council (GMC) publishes report on doctors who died while under investigation (report published March 2023; covers deaths through Dec 2022)"},{"id":"70efff1e-de29-4845-8168-e788f396d3f4","text":"FDA/FTC public enforcement and warning letters against companies and individuals selling fraudulent COVID\u201119 cures and unapproved therapies (series of letters and press releases, 2020\u20132022)"},{"id":"9c2b371f-388f-47ee-b206-3e82809389d5","text":"NASA/NSIDC reporting that Antarctic sea ice reached record high extent in 2014"},{"id":"da2933a9-afa9-4f22-bee2-2b77b8a9c354","text":"IPCC Special Report on the Ocean and Cryosphere (SROCC) documents complex impacts of ice melt on ocean circulation and regional climate"},{"id":"c0b1cd72-bf4b-45fc-a1e8-02b82878530e","text":"Nature paper reports fingerprint of a weakening Atlantic Meridional Overturning Circulation (AMOC)"},{"id":"704a2e5b-dcc1-471d-af03-9a5258158cad","text":"IAEA Director General Rafael Grossi publicly called for an urgent IAEA mission to the occupied Zaporizhzhia plant and warned about militarisation (June 2022)."},{"id":"d5ed7a1d-604c-4293-aa09-c48775956696","text":"Satellite imagery and reporting in 2022 showed military vehicles and damage close to key Zaporizhzhia reactors and infrastructure."},{"id":"38caa6b6-11c3-40cb-9ff0-a181a610eb4e","text":"Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the opening days of the 2022 invasion."},{"id":"1da59117-46a6-4dda-bc0b-beea5612a755","text":"Shelling and a fire at a training facility inside the Zaporizhzhia site during the March 4, 2022 assault."},{"id":"db3fa2b4-6e19-4bb1-a206-75c8de9b1a5a","text":"IAEA/Ukraine national reporting on ageing Soviet-era reactors and safety challenges (2005)"},{"id":"4c4999a9-83ad-4b37-af5c-bea47b7609eb","text":"Verkhovna Rada adopts Law No. 6327 on state financial guarantees for medical services (healthcare reform)"},{"id":"93ccacee-2583-4de9-8575-665d987e7ec5","text":"New national classification of professions (reclassification of medical job titles) took effect on November 1, 2017"},{"id":"5b9478ed-b921-456e-af42-1a76ccbf2caa","text":"U.S. FDA issues Emergency Use Authorization for Janssen (Johnson & Johnson) COVID-19 vaccine and publishes EUA fact sheets that reference the PER.C6 cell line used in production/testing."},{"id":"eb586cec-0bd1-4d4b-a6e3-b3ff9fd986cf","text":"Surveillance data showing higher-than-expected HIV diagnoses among people born in Ukraine reported by EU/EEA countries after the 2022 refugee movements (peer-reviewed / public health surveillance summary)"},{"id":"833328b9-c48d-439f-983a-13bfc8de9b56","text":"Russia had banned imports of Roshen products and Roshen faced factory/market disputes in Russia (2013\u20132014), including Roshen activity tied to Lipetsk"},{"id":"434108ca-f12e-486b-993b-8050154681d9","text":"Poroshenko\u2019s ownership of Roshen and his 2014 pledge to sell/transfer the company after his election kept Roshen highly politicized and newsworthy"},{"id":"69d0969d-9f05-415e-a0ac-fe2a141abd94","text":"Pentagon Inspector General report that about $1 billion in U.S. weapons sent to Ukraine were not properly tracked."},{"id":"d9d6f93d-7229-421e-8b8a-10cc701fb7b5","text":"National Anti\u2011Corruption Bureau of Ukraine (NABU) announces a large-scale probe into alleged corruption in the energy sector."},{"id":"55e622ec-6a9b-4f53-9e13-2c63b8d4c085","text":"Sean Penn\'s repeated, high\u2011profile visits to Ukraine (documented reporting on his November 2021 and subsequent trips)."},{"id":"3bdf0dac-34e7-4c26-a068-02dcae5374c8","text":"Ukraine uncovers embezzlement of nearly $40 million intended to buy mortar shells; arrests and charges announced."},{"id":"4feb4de2-57f8-4d45-98a2-90445dcf8903","text":"Human Rights Watch reports intensifying prosecutions in Crimea accusing Crimean Tatars and others of \'terrorism\' or \'sabotage\' (2016\u20132017)"},{"id":"da07339d-e02d-4916-a798-4d30ade2a3af","text":"FSB announces detention of a Ukrainian citizen in occupied Crimea on espionage/sabotage-related charges (Simferopol, February 2018)"},{"id":"50802117-fbd2-4c1c-b79f-3d872b116060","text":"Large explosions at the Kalynivka ammunition depot in central Ukraine, causing evacuations and widespread coverage"},{"id":"44fb80fa-2bf5-4161-ba19-539be4b7a8f8","text":"Exercise Sea Breeze 2018 \u2014 multinational naval exercises in the Black Sea co-hosted by the United States and Ukraine (July 2018)"},{"id":"153a0453-50cc-4c08-83cf-fd6773ae36e1","text":"Israeli reports of rising Delta-variant cases with a substantial share among vaccinated people"},{"id":"c7f4ad23-d007-4211-b4dc-1cf6b489c385","text":"CDC updates guidance for fully vaccinated people stating they can often refrain from testing and quarantine (interim guidance released)"},{"id":"9a3d525a-4adb-4cda-827e-d15ade12f31a","text":"Public Health England (PHE) vaccine surveillance reports with age-stratified case tables (week 26 / June 2021)"},{"id":"a8fcce40-59d3-4693-bb0e-d1d791ec5743","text":"Provincetown, Massachusetts July 2021 COVID-19 outbreak where many positive cases were fully vaccinated"},{"id":"32ce1237-00d3-47c7-b25f-75e182d37bd7","text":"Long\u2011running pro\u2011Kremlin narrative that \'Ukraine\u2019s armed forces shell Donbas civilians\' (disinformation theme dating from 2014) was active in March 2022."},{"id":"5d6da8e3-4367-4339-83c3-b0e5b5db407c","text":"Venice Commission (Council of Europe) issues an opinion urging changes to Ukraine\'s Education Law over minority-language provisions"},{"id":"243bcd2e-93bd-407b-b8fa-10811871553d","text":"Contextual sensitivity: Bulgaria\'s Liberation Day (March 3) commemorates liberation from Ottoman rule (historically 1878)."},{"id":"d1a9bab9-76dc-4796-bde7-6a13c17a1bdd","text":"President Erdo\u011Fan was on an official African tour (in Guinea) on March 3, 2016."},{"id":"060f49f6-ce30-4b27-a91b-845c676656e1","text":"WMO Greenhouse Gas Bulletin No. 21 reports a record-breaking annual CO2 increase and highlights contributions from continued human emissions plus an upsurge from wildfires and ecosystem feedbacks."},{"id":"a03e9d57-73d4-4bdf-be88-1780212a4ad5","text":"Hunga Tonga\u2013Hunga Ha\u02BBapai submarine volcanic eruption (15 January 2022) injected exceptional amounts of water vapor and volcanic gases into the atmosphere and received intense global media coverage."},{"id":"a4bead56-90d4-4f28-8095-8a5d20f8f4f1","text":"Transport & Environment / press coverage (October 2017) of lifecycle studies reporting EVs emit significantly less GHG over their lifetime than diesel"},{"id":"bd2e82a8-49f0-40e5-96fc-8ea991ee5507","text":"European Parliament / EU briefings and research in 2015 documented coordinated Russian disinformation campaigns targeting Ukraine and portraying Ukrainian authorities as corrupt or incompetent."},{"id":"b9024f6a-090d-4bd0-ad59-02b83ef9a31a","text":"Cabinet of Ministers Resolution No. 405 amended rules on \'military-transport duty\' allowing requisitioning of vehicles for army needs"},{"id":"4acedc34-7444-4087-8ac8-f0ab81d756e2","text":"High-profile seizure/attention to Viktor Yanukovych\'s car collection after his ouster in 2014"},{"id":"5b4e4e0c-8d90-4af7-bb86-d6a21c16772c","text":"March 2016 \u2014 Large, well-documented mass coral bleaching across the Great Barrier Reef (AIMS/GBRMPA surveys)"},{"id":"74cdc5c7-2bd7-47c8-8917-190eb14b02b3","text":"2019 \u2014 \'State of the Climate 2019\' (WMO/BoM/CSIRO) and related national summaries documenting global and regional ocean heating and record ocean heat content"},{"id":"6bd4e5df-786a-4eae-8115-052c576a4329","text":"Lisbon Court of Appeal ruling (Portugal) referenced PCR test reliability in a quarantine case"},{"id":"b5755505-20fd-4cdd-be8a-c385417ab02f","text":"Early peer\u2011reviewed studies showing correlation between PCR cycle threshold (Ct) and viral culture/infectivity (e.g., Bullard et al.) published in 2020"},{"id":"e8b49fdd-51a0-4209-b02c-12aa70cb3d55","text":"WHO information notice reminding labs to follow manufacturers\' instructions and consider Ct thresholds (WHO notice for IVD users)"},{"id":"67ff8a4d-3d4c-42ea-a799-b5bf7cfd1c27","text":"CDC announced it would withdraw its EUA request for the original CDC-only RT\u2011PCR panel (laboratory notice, mid\u20112021)"},{"id":"f59198d8-a484-4249-9e4c-cb120eb06ccc","text":"FDA paused enforcement of the in-person dispensing requirement during the COVID-19 pandemic enabling telemedicine and mail distribution"},{"id":"07f79ea0-c692-4baa-9119-0f5368f1d699","text":"Government audit and historical regulatory reporting (GAO report) documenting FDA regulatory decisions on Mifeprex/mifepristone"},{"id":"44646b63-c5a5-421d-a5db-b8bdf9ace828","text":"Anti-abortion medical groups filed Alliance for Hippocratic Medicine v. FDA challenging FDA approval of mifepristone"},{"id":"aaf71c84-1b11-495a-9c4e-cee86667e148","text":"Dobbs v. Jackson Women\'s Health Organization (Supreme Court decision overturning Roe v. Wade) intensified public debate over abortion"},{"id":"741729c0-95bd-443c-b190-7f90d0ca9e84","text":"Regional NGOs and refugee policy briefs highlight ambiguities about the end or transition of Temporary Protection"},{"id":"87864deb-9b02-400c-9156-594929a9d8fa","text":"Ukraine imposes martial law and restricts men aged 18\u201360 from leaving the country"},{"id":"0876b24e-ada1-414f-99f5-fbb75a2ce1d8","text":"Ukraine imposes moratorium / signals risk of default on Russian\u2011held debt (December 2015)"},{"id":"c666a329-62b7-460d-8880-c5f0d94f6cc9","text":"Ukraine\'s parliament approves the 2016 budget tied to IMF\u2011agreed deficit targets (conditioning release of IMF tranche)"},{"id":"f270c33e-858b-4306-9fe4-5bd6bfe6a4fc","text":"World Bank forecasts a sharp GDP contraction for Ukraine in 2015 (projected ~12% decline)"},{"id":"6caeaf94-869d-4164-b22a-e0d6cc091305","text":"The 2014 burning of the Odesa Trade Unions House (widely photographed and reported)."},{"id":"323a384e-2961-4844-bb5e-caeb44529087","text":"U.S. Secretary of State Antony Blinken visited Veterano Pizza in Kyiv and was photographed having lunch with Ukrainian officials."},{"id":"b8a644d1-1a59-4a57-a12c-3e97043b444c","text":"U.S. FDA Emergency Use Authorization for the Pfizer\u2013BioNTech COVID-19 vaccine (vaccine moved from trials to public use under EUA in December 2020)"},{"id":"5cad67d2-e08d-4e47-ae5d-3de0c4b4479f","text":"Publication of preclinical animal study results showing BNT162b vaccine candidates protected rhesus macaques (Nature article)"},{"id":"02a16f64-1041-448c-85e0-93941aebabb2","text":"EU Council / Commission adopted visa-free travel for Georgia (short stays up to 90 days)"},{"id":"a8a03368-4889-42d0-b210-bbf16a481d35","text":"EU/agency reporting and media coverage noted increases in asylum/irregular-migration claims from Georgian nationals after visa liberalisation"},{"id":"feee77bd-03c4-4b90-8356-f40b90706c1d","text":"EU revised and strengthened the Visa Suspension (waiver) Mechanism"},{"id":"d1c4ccfc-8cec-44f4-a6b9-efe9f164ab6c","text":"Reports of Chechen fighters present in Donbas fighting alongside pro\u2011Russian separatists"},{"id":"2cd9142f-905e-4ab8-b3c9-fe284e5e8b02","text":"UN/OHCHR reporting on the presence and inflow of foreign fighters into the conflict in eastern Ukraine (2015)"},{"id":"1cecf870-454e-441f-9f74-fdca57707139","text":"Death of Italian photo\u2011journalist Andrea Rocchelli while reporting in Donbas (May 2014) and subsequent high\u2011profile Italian media/legal coverage"},{"id":"dc7674b3-e329-4328-bd62-aabc0cfd248f","text":"Oct. 10, 2023 public statements and policy messaging about balancing U.S. aid to both Israel and Ukraine (e.g., Pentagon/Army leadership urging Congress to ensure resources for both)"},{"id":"f28c2f82-5f27-4b43-a421-02ef44a350cb","text":"Sep. 18, 2023 launch of a high\u2011profile pro\u2011Ukraine ad campaign targeting U.S. Republicans (e.g., \'Republicans for Ukraine\')"},{"id":"8ee9b76e-0f2d-4f24-a5fb-f63e07db02c1","text":"Earlier Nuland testimony/statements (October 8, 2015) emphasizing sanctions if parties (including Russia) fail to implement Minsk"},{"id":"26476e3e-0255-4374-ad8f-5f995f4d2382","text":"A delegation of Alternative f\xfcr Deutschland (AfD) regional deputies travelled to Crimea from February 3\u20139, 2018, despite international protest and the German government distancing itself from the visit."},{"id":"f3c12118-c8a6-4eae-99f9-ad90880ce29c","text":"Russian leadership publicly framed Ukraine as \'Nazi\' and claimed a need to \'denazify\' it in speeches and statements ahead of the 2022 invasion."},{"id":"0bb33664-bc8c-4f5e-936b-5765fc3b8eb1","text":"Discovery and widespread reporting of civilian killings in Bucha after Russian withdrawal"},{"id":"aecc93d8-f903-49e9-a789-08975bfec032","text":"Repeated reporting of heavy civilian casualties and strikes in Mariupol (including attacks on civilian shelters/theatre)"},{"id":"c213632f-f81d-4a1e-8f04-a90bd92d702e","text":"Russian recognition of the Donetsk and Luhansk \'people\'s republics\' and public accusations against Kyiv"},{"id":"1d77d116-bcdf-49da-a814-c26fc172f941","text":"Kyivstar publicly switched off mobile service in militant-controlled areas of Donetsk and Luhansk (company statement explaining suspension for network integrity and subscriber data safety)."},{"id":"18c8ea30-f6d5-4e01-b748-a6ddae01c225","text":"Previous Ukrainian president Petro Poroshenko publicly called for UN peacekeepers to monitor the ceasefire in Donbas (widely reported)"},{"id":"af79e1ac-966c-4bef-a69b-9adc9093c1eb","text":"Canada\u2019s Operation UNIFIER (training mission) and other Western training/adviser missions in Ukraine beginning in 2015"},{"id":"7ffc3f24-8a49-4463-b575-ccabf41b348b","text":"Large multinational Sea Breeze naval and military exercises in the Black Sea involving Ukraine and NATO partners (summer 2019)"},{"id":"68e2f391-6cae-4e76-9468-e3f4dec7df67","text":"Normandy Format summit in Paris where President Zelensky met Putin and European leaders (significant public peace talks)"},{"id":"f9633764-fbf4-4111-a58c-752a023c9f47","text":"UN Panel of Experts (DPRK) midterm report noting foreign/European components recovered from North Korean missile debris (April 2017)"},{"id":"7ed72f95-8073-41ce-b0bd-ed25d6f99ca1","text":"Public denials from Ukrainian state aerospace firms (Yuzhmash/Yuzhnoye) rejecting allegations they supplied engines or parts to North Korea (Aug 2017)"},{"id":"c56a9adc-dc99-49cb-ac26-2bf255b073a6","text":"Publication of an Online.ua interview with Lieutenant Vsevolod Stebliuk in which he used the word \\"raze\\" when discussing past destructions (referencing Grozny) and the costs of a forceful retaking of occupied territories."},{"id":"f8165c18-9264-47aa-a01c-0b8c4f073f3c","text":"Public criticism and documented history of REN TV as a channel prone to propagandistic framing (Presidential Council on Human Rights public concerns about REN TV coverage in early April 2017)."},{"id":"bce91ab8-09f7-46e8-bd90-18e20c9bc00c","text":"CDC guidance and FAQs noting that regularly mixing powdered or concentrated infant formula with fluoridated tap water may increase the chance of very mild dental fluorosis in infants"},{"id":"49090a4a-0445-4ea4-a0cd-c4c893b6b2a4","text":"Publication and subsequent media/activist attention to the 2019 systematic review \'Developmental fluoride neurotoxicity: an updated review\' summarizing evidence that fluoride can cross biological barriers and reporting associations between early-life fluoride exposure and neurodevelopment outcomes"},{"id":"68dc7eaa-f18f-4ebe-b8a6-9d84a9d89954","text":"Reporting on the economic impact of sanctions on German businesses and trade ties with Russia highlighted pressure from German industry."},{"id":"4ed72a1c-8710-4154-909b-3ddb2ecb8590","text":"Public statements and EU-level reporting in 2016 described the sanctions regime as conditional and tied to progress on Minsk, prompting debate within EU capitals about sequencing and duration."},{"id":"cea3d47c-35f6-414b-a754-8e95a7de3988","text":"Merkel participated in high-profile meetings and talks (including four-way Ukraine talks) with Putin and other leaders addressing the Ukraine conflict."},{"id":"daaf1b89-a36d-435b-8fbe-d84791ad228b","text":"USDA Foreign Agricultural Service publishes a bulletin detailing Russia\u2019s ban, listing affected products and estimating trade impacts for U.S. exporters."},{"id":"407d90f4-5543-4002-bf08-feccffa3e66e","text":"The Moscow Times and other outlets report U.S. poultry and other farm sectors were \'bracing\' for Russian retaliation following sanctions earlier in August 2014."},{"id":"7ba3f4f0-ca89-4d70-bd13-db461a2b110a","text":"Reports that some early cultured isolates were shared between labs (e.g., first culture reports referencing Jan 28, 2020 Australian culture and rapid global sharing)"},{"id":"20938efc-458b-4b5d-93c0-0a51a2cfcd1f","text":"Publication of early RT\u2011PCR primer/probe protocols (short target sequences) for SARS\u2011CoV\u20112 detection (Corman et al., Eurosurveillance)"},{"id":"93210245-0ed3-478e-9610-7f95ab51dbf9","text":"FDA labeling and communications warning that certain parenteral products \'contain aluminum that may be toxic\' (premature neonates at risk) for prolonged administration"},{"id":"d2bce9ba-13fd-4487-8da4-1d633fc463f8","text":"Amphastar (phytonadione) product labeling and manufacturer information listing benzyl alcohol and polysorbate 80 in some Vitamin K injectable formulations"},{"id":"7ee3653f-32aa-47b8-9acb-799f35f05c3d","text":"Scientific and review publications and data tables listing aluminum adjuvant amounts across vaccines (showing large variation and values up to ~0.85 mg per dose for some combination vaccines)"},{"id":"b36796d3-aa35-487d-a37f-dccc9d59d67b","text":"International coverage on the financial and social hardships faced by Ukrainian war widows and families (feature reporting on widows\u2019 struggles)"},{"id":"0fffe169-4ede-41cf-b588-2b5433b67d07","text":"Ukrainian investigators and the SBU disclosed a major arms procurement fraud (scheme to buy artillery shells involving nearly $40m embezzlement)"},{"id":"956c2edd-5ea2-4d90-9314-5e85b00a6ce1","text":"OCCRP reporting on SBU arrest of criminals who racketeered/extorted families of fallen soldiers (caught trying to extract money from a widow)"},{"id":"0292cb7d-cd08-428b-b4eb-7dbee8453962","text":"WHO and international coding/ICD guidance on how to record and code COVID-19 on death certificates (emergency ICD codes and guidance issued 2020)."},{"id":"5dfd5799-baac-4921-a943-ef7c64ec847e","text":"Local parish and Bishop Simeon of Vinnytsia publicly moved from the UOC\u2011MP to the newly formed Orthodox Church of Ukraine (reported as a transfer by parishioners/administration)."},{"id":"a1006103-1fdd-48e7-a258-db0dca424b2c","text":"Ecumenical Patriarch and Ukrainian bishops hold the Unification Council creating the Orthodox Church of Ukraine (OCU)."},{"id":"f6e64bb4-2626-46e9-848c-f77fc7551f29","text":"Crimean leader Sergei Aksyonov publicly acknowledges an unprecedented drought"},{"id":"f4a93dcf-0bdd-4552-a02e-60e6535b598d","text":"International outlets reported chronic water shortages in occupied Crimea (e.g., Al Jazeera feature on water shortage and reservoir problems)"},{"id":"54e56b8b-c19a-4d50-b0cc-2aabd9cc108d","text":"Large-scale war-related disruption to schooling and displacement of children in and from Ukraine was documented by UN/NGO reports (e.g., UNICEF/UN briefings in 2022\u20132023)."},{"id":"24139cff-94b4-435c-89d8-37bd588d1cd0","text":"PISA 2018 results showed Ukrainian 15\u2011year\u2011olds scored below the OECD average in reading, maths and science \u2014 a widely reported education result that can be (mis)framed as evidence of low intelligence."},{"id":"737ca22d-17b0-4b71-a1dc-96df8deec3bb","text":"Repeated international reporting on Russian military build-up and base modernization in Crimea (e.g., Reuters special report documenting new/rewamped bases)."},{"id":"d1e1a312-d14f-443e-8ecf-d5749a4e57f4","text":"Kerch Strait incident in which Russian forces seized three Ukrainian vessels and detained sailors."},{"id":"69e8cef3-0f97-4f56-9d24-1c39fea0e151","text":"UN OHCHR monitoring report documents multiple antisemitic incidents in Ukraine (2017)"},{"id":"c205a767-0407-484a-a644-3d2f7095cf27","text":"Nationalist march in Kyiv where some marchers chanted \'Jews out\' (reported)"},{"id":"57d38d6f-b4e3-4c4e-a71b-09a0f515f264","text":"Report of vandalism at old Jewish cemetery in Delyatin (swastika and hate symbols painted)"},{"id":"92e94f9c-d067-4f8b-a258-f7d343bd4044","text":"1974\u20131975 Japan temporarily suspended whole-cell pertussis (DTP) vaccination after reports of infant deaths following vaccination, prompting development and later adoption of acellular pertussis vaccine."},{"id":"6cd113e2-9c3a-4e55-b281-7226cd7b3716","text":"Establishment and public availability of the Vaccine Adverse Event Reporting System (VAERS) in 1990, a passive reporting database where temporal associations between vaccination and events (including infant deaths) can be reported publicly."},{"id":"a9830400-0edf-40b4-b51e-33131d956951","text":"U.S. State Department ordered non-emergency U.S. embassy staff to leave Ukraine and advised U.S. citizens to depart (partial drawdown) amid Russian troop buildup."},{"id":"67f5e913-cd9d-419b-a4e8-8628d477d227","text":"Large-scale Russian missile and drone strikes across Ukraine, including strikes that hit Kyiv\'s infrastructure and caused blackouts and sheltering of civilians."},{"id":"2f542fe7-1497-4ca8-a4ab-b6647fd05366","text":"Oxford/AstraZeneca paused its COVID-19 vaccine trials after a participant experienced a \'potentially unexplained illness\' (routine safety pause announced)."},{"id":"02ef3bf3-20e0-4322-aad1-8462d20ee747","text":"Shelling and strikes on Mariupol reported on Feb 24, with Reuters and other outlets describing residential areas hit and civilians affected."},{"id":"107d5c29-2f33-4fc4-acd6-2fee20c6c791","text":"Airstrikes and reports of Russian naval activity in the Black Sea and attacks near Odesa were reported early on Feb 24, including strikes on coastal infrastructure and claims of naval force movements."},{"id":"adaeae49-d1ad-483e-9b00-5c144f3efe02","text":"Widespread airstrikes and explosions reported in Kharkiv at the start of the invasion, with residents and officials posting footage of strikes and military vehicles in the city."},{"id":"e0bbe7e4-58e6-428f-9c40-667d31c60035","text":"CDC MMWR published early safety monitoring showing reports of allergic reactions and 21 cases of anaphylaxis after first doses of the Pfizer-BioNTech vaccine (dec 14\u201323, 2020; published Jan 6, 2021)"},{"id":"e8580e4b-012d-486d-b924-72b24ddb93ce","text":"Norwegian health authorities reported deaths in very frail elderly following vaccination with the Pfizer vaccine; media coverage appeared mid-January 2021"},{"id":"e7e18802-a542-4d2d-acfb-bfa827d3f70e","text":"Transfer of centralized medicines procurement to international organisations (UNDP, UNICEF, Crown Agents) as an anti\u2011corruption measure (2015)"},{"id":"9d7ccf0a-6dca-4a27-a0aa-99c3068c8cb0","text":"Appointment of Ulyana Suprun as Acting Minister of Health amid public controversy over her reform agenda and foreign background"},{"id":"e36cb072-83e2-420d-8cf4-ced1f4fe3938","text":"WHO / European Observatory health system review documenting chronic underfunding, high out\u2011of\u2011pocket payments and systemic weaknesses in Ukraine\u2019s health system (2015)"},{"id":"e0167f84-ce1f-4d81-b352-b885ea3a42ac","text":"Publication (medRxiv / PMC entry) of the Yale LISTEN study / related analyses describing self-referred cases of post-vaccination syndrome and immunophenotyping (preprint posted Nov 10, 2023; PMC entry available)."},{"id":"ce51a3b6-4ec1-4741-9641-e65ecd97209b","text":"Reports of black/foreign particles found in some Moderna vaccine vials in Japan, leading to temporary suspension and recalls of lots."},{"id":"7f8a1cf5-7e86-44c6-8963-92a353bfbb76","text":"Publication of Prof. Pablo Campra\'s technical report claiming Raman/microscopy detection of graphene/graphene oxide in some COVID-19 vaccine samples."},{"id":"fa21c44f-10de-494a-bbbe-7455764fce61","text":"Reporting on volunteer battalions (Azov, Aidar and others) emphasised recruitment of foreign fighters and the existence of organised volunteer units in 2014."},{"id":"450824d4-1392-40e7-b3f9-e852eda731e6","text":"Press coverage of allegations that US-linked private security firms (e.g., reports referencing Academi/Blackwater) had personnel in Ukraine circulated in May 2014."},{"id":"a407f1ea-84a9-4862-9623-d0f02324a925","text":"CDC guidance on serology (antibody) testing noting possible cross\u2011reactivity with other coronaviruses"},{"id":"1fb6cbaa-6f17-4673-9222-f8aa61df3dfe","text":"OSCE Special Monitoring Mission reported observation of tanks and movements of heavy weapons in eastern Ukraine (daily SMM reports, e.g. 14 April 2015 noted tanks moving near Hirne)."},{"id":"fb1d07b2-9e47-4a10-88aa-536aa36cc193","text":"Regulatory and scientific guidance acknowledging residual host\u2011cell/production\u2011related proteins are monitored in biologic manufacture (EMA position statement on residual host cell DNA and host cell proteins)."},{"id":"586ec689-5403-43fe-b4c5-d134115e8f07","text":"Reports of black/foreign particles found in multiple Moderna COVID-19 vaccine vials in Japan, prompting suspension and recall of affected lots."},{"id":"434a0c97-e17d-4d14-97e5-31f3d65ff4c7","text":"MHRA Freedom of Information response stating that the AstraZeneca, Pfizer/BioNTech and Moderna COVID-19 vaccines do not contain any components of animal origin."},{"id":"22930da2-2dab-4788-a79f-737b7cbe2160","text":"Pentagon Inspector General audit (reported Jan 11, 2024) finding about $1 billion in U.S. weapons sent to Ukraine were not properly tracked."},{"id":"a6699444-1c15-4a1b-b989-45e880eb841f","text":"Reuters reporting (Sept 19, 2024) that Congress and the administration were nearing a deal to extend expiring military aid of roughly $5.8\u20136.0 billion to Ukraine."},{"id":"7fee2983-68d8-4bea-8382-aaf5b47fcd8e","text":"Pentagon press briefing in which Deputy Press Secretary Sabrina Singh discussed expiring authorities and said the Pentagon intends to \'use every dollar and cent\' of available authority for Ukraine."},{"id":"0595b59b-0e70-4c72-ad8e-a4d827e02569","text":"Assassination of Andriy Parubiy in Lviv"},{"id":"492a03d8-43e7-45a3-a2e5-13f7ba6ce2dc","text":"IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, strongly attributing recent warming to human activities."},{"id":"87a6eddd-368b-4b2c-8ce6-4183e0883d0e","text":"European Space Agency (ESA) Swarm mission publications and press releases reporting an accelerating weakening and expansion of the South Atlantic Anomaly in Earth\'s magnetic field."},{"id":"b5f6a11b-a40d-4ef3-8f9d-f4de13cd21bc","text":"U.S. government places an approximately $119 million order (option for ~13 million doses) for Bavarian Nordic\u2019s Jynneos smallpox/monkeypox vaccine (reported May 2022)."},{"id":"5284affc-9a33-44ef-a031-0b316285fc1b","text":"WHO declares the multi-country monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)."},{"id":"c9ec4dfe-5a42-4ba1-bee9-2706c05e1576","text":"Reports and government accounts of large unused or expired COVID-19 vaccine stockpiles and write-offs (examples include national write\u2011offs reported in 2022\u20132024)."},{"id":"e9996b37-aa80-4b89-958d-cd2794166a31","text":"WHO announces it will adopt \'mpox\' as the preferred synonym for \'monkeypox\' and phase out the old name."},{"id":"2ea323ee-7eb0-4343-a31e-85470c2314ba","text":"Local authorities\' animal-control history and municipal programs noted in press (Kyiv had earlier programs to manage stray animals, and NGOs warned of \'dog hunters\' operating independently)"},{"id":"bedd2194-59d1-48fc-86f9-f0234b938fda","text":"Large online petitions launched and amplified claims of planned mass killings (Change.org and other petition platforms) asking EBU, Kyiv mayor and international public to stop dog killings for Eurovision"},{"id":"f185416f-21f7-499d-9024-947736bf13bb","text":"Ukrainian authorities announce seizures and freezes of assets linked to Yanukovych and his entourage"},{"id":"88903702-9d9c-4e73-add2-00c128a3b948","text":"Viktor Yanukovych flees Kyiv and is ousted amid Euromaidan protests"},{"id":"f648189b-ffd4-42ba-80ab-e7d0cb4e0d27","text":"The Soufan Group\'s June 2014 report documenting large flows of foreign fighters to Syria from many countries, including from the wider post\u2011Soviet space."},{"id":"44ccc072-a642-46b2-a1ed-e8af44115c6e","text":"Reporting on Chechen fighters active in both theatres (Donbas and Syria) \u2014 e.g., Carnegie Endowment analysis \'Chechen Mysteries in Donetsk\' (Oct 2014) documented Chechen involvement around Donetsk."},{"id":"cfdf0f43-c18b-4607-b426-1b3665ed9f5d","text":"The Guardian reporting (1 Oct 2015) that Russian state media were shifting attention from Ukraine to Syria, reframing coverage and drawing links between the conflicts."},{"id":"6da6f4c0-936b-4b29-9006-5bf428fde525","text":"CDC recommendation for public use of cloth face coverings"},{"id":"c80aca95-f4ee-4db0-9443-79b99f87f2d9","text":"Publication of Morens, Taubenberger & Fauci analyses concluding secondary bacterial pneumonia caused many 1918 deaths"},{"id":"4275f6cd-180d-40e0-90e7-59efab35c9a6","text":"Russian media / monitoring reports repeatedly amplifying negative narratives about Zaluzhnyi (April 2024)"},{"id":"f3818da0-99d5-4657-ae45-99914fdb6909","text":"French and international coverage from early in the war (March 2022) profiled Ernesto Barbieri (videos/interviews on France 2/Euronews and his YouTube channel), making him a known figure."},{"id":"70ace6f5-ba45-4bcf-8217-e6dd2bb2b27e","text":"Adoption of the 2012 \\"On the Principles of State Language Policy\\" (Kolesnichenko\u2013Kivalov law) granting expanded regional status to minority languages"},{"id":"11f8aac3-1ffa-48e7-80f7-f68918c4a2ad","text":"Public complaints and statements by Hungarian organizations and diaspora groups about the situation of ethnic Hungarians in Transcarpathia (AHF statements and local reporting, March 2014)"},{"id":"91062d1e-d101-49f1-9191-a3f8b2dbbc0c","text":"Public OSCE monitoring and commentary on minority-rights tensions in Ukraine (OSCE updates and reporting, mid\u20112014)"},{"id":"ae95c7d1-8919-48a3-b7af-269c6f2fd92b","text":"Verkhovna Rada vote to repeal the 2012 language law (attempted repeal, 23 February 2014)"},{"id":"185c2416-6c1c-4899-82c6-53a5a453c87e","text":"Analyses and reporting on cross\u2011border tensions (KyivPost feature coverage of Transcarpathia and Hungary\u2011Ukraine disputes, 2014)"},{"id":"5570d93e-328c-4a37-84e4-2e8f29e8928f","text":"U.S. government agencies and NASA suspended or curtailed certain cooperation with Russia in response to the 2014 annexation"},{"id":"96dec6e5-f568-4d57-812f-b87d6c8daf10","text":"National Geographic announced it would show Crimea as part of Russia on its maps following the 2014 annexation debate"},{"id":"2aa899b0-a95e-44e8-8f1f-d08495395787","text":"Human Rights Watch and other observers reported steps by Ukrainian authorities in 2015 restricting access (e.g., blacklists, travel/media restrictions) for certain journalists and commentators."},{"id":"bd90e9ad-9d3e-4cf4-bd00-4ea1d6f8be9a","text":"Earlier in 2015 Ukraine moved to block multiple Russian TV channels (press/ regulator actions widely reported, e.g., April 2015 ban of 14 Russian channels for \'propaganda\')."},{"id":"85966416-7d92-405c-bc31-56bbbd8253e8","text":"Series of lithium-ion battery fires at Convergent Energy storage sites in Warwick, New York (multiple alarms and containment responses reported June 26\u201327, 2023), prompting local media coverage and community concern."},{"id":"b6ca2d96-e2af-4332-8644-c3bbbd11b213","text":"LG Chem (RESU) residential energy-storage battery recall(s) following multiple reports of overheating and fires in home battery units (recalls/public warnings issued December 2020 and expanded in 2021)."},{"id":"21277a00-c4c4-43b8-ae10-036e94a1c107","text":"IMF approval of a large Extended Fund Facility for Ukraine (US$17.5 billion) in March 2015, accompanied by IMF warnings about the banking sector\'s contingent liabilities and need for recapitalization."},{"id":"4e69c14f-7443-4d0a-af69-5182a6c98b4d","text":"National Bank of Ukraine (NBU) extended loan repayment periods and implemented emergency liquidity measures to support banks under strain."},{"id":"3a13ed57-ac5e-43c8-90bf-8cd66bf6f503","text":"Credit-rating agency downgrades of major Ukrainian banks (e.g., Fitch downgraded PrivatBank and ProCredit\'s viability ratings in December 2014)."},{"id":"c91195b0-2dd3-4cc4-bdd0-48f3f2bdbdb4","text":"Ukraine\'s hryvnia plunged after the central bank abandoned foreign currency auctions, triggering sharp currency devaluation and market panic."},{"id":"74caf7c4-d50f-4495-8c68-52fe77e6cf1d","text":"Central bank closures and a wave of bank shutdowns during the 2014 financial turmoil in Ukraine (multiple banks shut or declared insolvent)."},{"id":"47582a6e-7aee-49e6-9a90-70c25b54b570","text":"Official recommendations to offer COVID\u201119 vaccination to pregnant and lactating people (ACOG/CDC guidance issued in December 2020 and subsequently maintained)."},{"id":"6e95a689-eb28-4092-8f24-54d8232f394e","text":"NCHS provisional report showing a 3% rise in the U.S. infant mortality rate for 2022 (first year\u2011to\u2011year increase since 2001\u20132002)."},{"id":"66307a24-6752-47c1-b14e-19ba5f2f2e2b","text":"Peer\u2011reviewed VAERS analysis summarizing adverse event reports in pregnant people (covers reports through April 1, 2022) published in European Journal of Clinical Pharmacology (PMC)."},{"id":"e1188dc5-0c3a-40ea-b10c-c1a4ce18f3f9","text":"Published evidence of waning vaccine effectiveness and breakthrough infections in Israel"},{"id":"aba505df-97c2-44ee-af3c-185123d8d571","text":"Japan suspended and recalled Moderna vaccine batches after discovery of foreign particles"},{"id":"e00d5c72-1582-479f-9bcc-d377cd91304b","text":"CDC changed mask guidance in May 2021 allowing fully vaccinated people to stop wearing masks, then later revised recommendations as variants spread"},{"id":"ccca6a2c-bbf6-41c6-b927-d092d6835a64","text":"Local Ukrainian authorities reported civilian casualties and injuries from the July strikes"},{"id":"73eb341e-b0a3-419e-8644-315fefca12f8","text":"UN Secretary-General and UN spokesperson publicly condemn reported strikes on Odesa"},{"id":"0f36c619-8e14-445d-9ff6-652907201f8d","text":"Istanbul \'grain corridor\' agreement signed between Russia, Ukraine, Turkey and the UN"},{"id":"e85fec14-f53d-4f03-8782-2d509817cdcf","text":"Missile strikes hit Odesa port and city (reported by multiple outlets)"},{"id":"560e0e32-05d2-442c-8f26-f2984ba3dda8","text":"Several countries temporarily suspended use of the AstraZeneca COVID-19 vaccine in mid-March 2021 while regulators investigated rare clotting reports."},{"id":"3c065b5a-a536-4694-be46-2fa75a6abad9","text":"FDA Vaccines and Related Biological Products Advisory Committee briefing document for Moderna (mRNA-1273) published, including detailed safety/reactogenicity tables from phase 3 trial."},{"id":"32c16bd5-4905-4d1f-9dc9-527ca0e29b56","text":"Public-facing CDC guidance summarizing common, expected side effects after COVID-19 vaccination (local pain, fatigue, headache, fever)."},{"id":"c0954b16-8dca-44c9-9bc8-66debbd14700","text":"UNICEF and WHO confirmation and public statements about a circulating vaccine-derived poliovirus type 2 (cVDPV2) outbreak in Sudan and coordinated vaccination response."},{"id":"5cdb36f6-ae0d-4c33-85a4-c023f5d57ee9","text":"Reporting in October 2023 documented an uptick in Russian strikes and drone attacks on Ukraine\'s rail network and passenger trains."},{"id":"9d29c1dd-4f43-4ab8-88f8-11e3b2827272","text":"Ukrzaliznytsia publicly announced introduction of undercover \'railway safety marshals\' working on stations and trains."},{"id":"1e1a3c21-bcf0-4394-89a7-ce8a6ebb377c","text":"CDC updates guidance on May 13, 2021 saying fully vaccinated people could resume activities without masks or physical distancing in most settings."},{"id":"2a85d5f1-e5cc-45b3-a1b3-97e6e9999e08","text":"CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing a high proportion of cases in fully vaccinated people and evidence of possible transmission from vaccinated individuals."},{"id":"9935cc06-404f-446f-ab6b-5ab2fb7602ee","text":"UK Health Security Agency and related UK analyses in July 2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant while retaining protection against severe illness."},{"id":"429193ad-842f-44da-afc5-3dec6e99744f","text":"U.S. officials publicly sought funds and announced plans to test and develop ground\u2011launched intermediate\u2011range missiles after INF collapse"},{"id":"ecdd329a-e084-4edb-97b8-6cd18aef672b","text":"NATO publicly stated Russia was in material breach of the INF Treaty"},{"id":"5571cb87-63cc-47c7-8d84-d91f1754a41d","text":"Trump administration announced suspension of U.S. obligations under the INF Treaty and delivered six\u2011month notice of withdrawal"},{"id":"58187aec-19c3-49ac-b926-cc221022d989","text":"FactCheck.org SciCheck explainer on what VAERS can and can\'t do (widespread June 2023 coverage)"},{"id":"5d78dde1-be3f-4bf2-ba05-56ce0a3bd4f4","text":"Italy and some Italian officials publicly criticized the EU and fellow member states for a slow and inadequate early response to Italy\'s COVID-19 crisis."},{"id":"c304c132-ef7f-42b3-add5-d5b7d3fb88a5","text":"U.S. officials publicly accused Russia of running a coronavirus disinformation campaign (statements reported in February\u2013March 2020)."},{"id":"66349fdb-aedd-4e71-bc33-b55b90c3a03c","text":"UKHSA (PHE) published weekly COVID-19 Vaccine Surveillance Report (Week 43) containing counts of cases, hospitalisations and deaths broken down by vaccination status."},{"id":"f83bdf2e-7c16-426a-9bf7-f80d7cb0bb3c","text":"Reports of contamination (black/stainless-steel particles) found in batches of Moderna COVID-19 vaccine vials in Japan; large numbers of doses temporarily suspended/withdrawn."},{"id":"21859aaa-2d71-4c1a-8366-63800b3db547","text":"CDC guidance recommending vaccination as part of hurricane preparedness (site guidance last reviewed)"},{"id":"3bc6fa9c-20b7-4020-a917-396b142d7587","text":"Clashes and beatings during spring 2014 rallies in Kharkiv where pro\u2011Russian activists and counter\u2011protesters attacked each other and journalists were beaten."},{"id":"ca5532c8-cdca-4755-8314-fa874bb46c3c","text":"Investigative reconstructions (Bellingcat, Jan 28, 2015) of May 9, 2014 violence in eastern Ukraine documenting how video fragments and poor sourcing can produce misleading narratives."},{"id":"73c9e515-b050-482c-a37c-960afe733109","text":"OHCHR periodic reports documenting alleged human-rights violations in Ukraine (2014)"},{"id":"37a4f01b-94b1-423e-80e0-2683732abcb9","text":"Ukraine accepts International Criminal Court (ICC) jurisdiction for alleged crimes (ad hoc declaration)"},{"id":"bda421f3-b15a-4ef0-8627-b9e4ff9795af","text":"UN General Assembly adopts Resolution 68/262 on the territorial integrity of Ukraine"},{"id":"cb67794a-bd78-40b6-b30e-648c7caea549","text":"CDC publishes guidance and reporting mechanism on vaccine breakthrough infections and explains expected breakthrough cases as vaccination coverage rises"},{"id":"f2c01a33-1ddc-412a-ad6e-7b1540c343bf","text":"CDC designates California variants B.1.427/B.1.429 (CAL.20C) and reports potential reduced susceptibility to antibodies"},{"id":"95a03a51-dbf0-403d-90f9-f300942b3ba2","text":"Laboratory studies report reduced neutralization of certain variants (eg. B.1.351) by vaccine-elicited or convalescent sera"},{"id":"1b4a205b-74f1-44bd-81fe-e1ce90cf9854","text":"News coverage of the emergence and spread of CAL.20C (B.1.427/B.1.429) in California"},{"id":"9d0b0b48-481f-4015-8133-45d4dc81c3c2","text":"Detection of porcine circovirus (PCV1) DNA in Rotarix and regulatory review (2010)"},{"id":"ed5a38cd-1053-4c15-a8ee-77255d3682a0","text":"Widely cited medical review summarising clinical uses of activated charcoal in poisoning and emergency medicine (accessible on PubMed/PMC)"},{"id":"906b4a52-a777-4545-92dc-c04cf5c063ac","text":"Local/national news coverage warning experts about the TikTok \'parasite cleanse\' trend and the use of \'binders\' including activated charcoal"},{"id":"cbe55de5-2caf-43ee-ba13-5ad9e99bd3d3","text":"Turkish naval leadership and media reported ambitions to develop nuclear-powered submarines under the national MILDEN program and discussed cultivating reactor expertise domestically."},{"id":"cc635954-d212-406c-af7b-64d61e9232a7","text":"Rosatom and Turkish authorities advanced the Akkuyu nuclear power plant project; Rosatom announced the first unit entered commissioning-stage work and earlier delivered fuel components."},{"id":"5fc8c4c4-d8df-4a71-bfab-f21ac22ba5d5","text":"Turkish ministers (including Foreign Minister Hakan Fidan) visited Niger and signed a provisional agreement to enhance energy and mining cooperation, reported as an effort to secure uranium supplies."},{"id":"f3bcdfdc-f86a-49ca-b399-1aabe7da2bbc","text":"Foundation for Defense of Democracies (FDD) published an analysis titled \'FAQ: Is Turkey the Next Nuclear Proliferant State?\' outlining potential Turkish moves (e.g., securing uranium, expanding fuel-cycle capabilities) that could \u2014 in theory \u2014 support future weapons work."},{"id":"23f4ac65-fc79-4c77-a7d0-07d4377b7d20","text":"President Erdo\u011Fan publicly questioned why some countries have nuclear weapons while others cannot, saying \u201Cthis, I cannot accept\u201D in a speech to his party."},{"id":"446b57ea-cf92-4a32-b8cb-8b784adc0166","text":"CDC/FDA VAERS surveillance paper (Vaccine) published summarising VAERS reports in pregnant persons (Dec 2020\u2013Oct 2021), noting 12 neonatal deaths reported but concluding crude reporting rates were below background."},{"id":"50663370-4f1d-4512-8b35-0ed7418f2bf4","text":"Reports in September 2021 that black/foreign particles were found in some Moderna vaccine vials in Japan, prompting suspension/recall of specific lots."},{"id":"5b1e3132-4460-4a38-8cb3-ff9a2ac8826a","text":"Annalena Baerbock\'s remarks at the Forum 2000 panel in Prague where she said, in English, a line widely quoted as \'no matter what my German voters think\' during a discussion on support for Ukraine."},{"id":"80f2656e-a02e-4cab-beb2-a1f99619cefe","text":"Japan identified black/stainless-steel particles in multiple Moderna vaccine vials leading to recalls and temporary halts (reported September 2021)."},{"id":"b085f7e0-13f6-45fa-a7b9-aeeda8e4bb0b","text":"FDA inspection and public reporting on Emergent BioSolutions Baltimore plant problems that ruined millions of J&J vaccine doses and cited sanitation/cross-contamination concerns."},{"id":"aa7c1c7f-0d44-49c5-ae8e-b066be962441","text":"Scientific reviews and debates about Simian Virus 40 (SV40) and its detection in some human tumors (literature reviews summarizing associations and uncertainties)."},{"id":"66ad7bc0-9ff5-4228-a9e6-565bf22c9f50","text":"Vestas press release (8 February 2023) announcing a new chemical recycling approach and reporting steps toward recycling end-of-life blades (including a 2022 figure of recycled blades claimed by the company)"},{"id":"3fa896da-b3be-44c8-85b3-060314d71ec8","text":"American Clean Power (ACP) white paper \'Decommissioned Wind Turbine Blade Management Strategies\' (ACP/industry analysis) documents that current end-of-life options are limited and that landfill is often the lowest-cost route"},{"id":"aac764ea-a66b-4f31-941d-ffbb819af7d0","text":"University of Strathclyde \'PRoGrESS\' blade recycling pilot (project launch and pilot development, 2022\u20132023) to separate glass fibre from resin and commercialise recycling methods"},{"id":"b2e5de87-855f-4995-8336-4d6a9399c505","text":"CNN long-read on blade waste (May 2023) highlighting viral images of piles of decommissioned blades (e.g., Casper Regional Landfill) and describing the growing volume of blade waste"},{"id":"10b1b3a9-c651-481a-b1e1-63205a836346","text":"Reports in September 2021 of contamination/foreign particles found in some Moderna vaccine vials in Japan and temporary recalls/collection of affected batches"},{"id":"42c459b3-603b-4fea-b100-496e7c644a74","text":"CDC and other agencies reporting rare myocarditis/pericarditis cases after mRNA vaccination (June 2021) and subsequent media coverage noting hospital admissions for evaluation and treatment"},{"id":"84349328-6cbe-4c1f-93c4-830596e9ea8e","text":"Release of UK Health Security Agency (formerly PHE) vaccine surveillance reports showing that a high proportion of COVID-19 hospitalisations/deaths in autumn 2021 were among fully vaccinated people in older age groups"},{"id":"31e6662a-c5e2-4acf-8ce6-df814b728b1a","text":"Published Israeli analyses and policy statements (mid\u2013late 2021) documenting waning protection from two doses of BNT162b2 and the decision to roll out third-dose boosters"},{"id":"ca55d25a-0401-4df1-936a-1376aebf51d6","text":"Germany reintroduced internal border controls with Poland, Czechia and Switzerland (official notification to EU)"},{"id":"139daf56-007b-42d6-aa9b-9b1cfcbaf5a6","text":"Reports and footage of German police cracking down on illegal crossings at the Polish border"},{"id":"e4816de5-8656-4e3a-8adb-cc3827118755","text":"UNESCO recommendation that the Great Barrier Reef should be listed as \'in danger\'"},{"id":"bf10343b-f909-43fd-af82-06c1e21d46dc","text":"AIMS Long-Term Monitoring Program Annual Summary Report (2019/20) showing regional increases in hard coral cover"},{"id":"b852f69b-afb4-4dfb-af15-e891f23b224d","text":"New York Times: Coverage of fewer tourists and clearer reef images during COVID-19"},{"id":"c63eced6-5d16-4f1e-88a0-0091665a90c0","text":"NWCG publishes PMS 501 (Standards for Aerial Ignition) including Appendix B covering helitorch operations and training materials"},{"id":"66be13c3-6124-4d46-9fbd-e2f1aae2457a","text":"Australian Department of Defence confirms Orroral Valley bushfire was likely started by an Army helicopter landing light (investigation / press release)"},{"id":"f222f463-960a-41c7-8add-ca05baf14cdf","text":"NSW National Parks posts video documenting a trial of a helicopter-mounted drip torch (aerial drip torch/helitorch) used for hazard reduction in Kosciuszko National Park"},{"id":"b0eae12c-8aea-4fd6-ad6e-c46f1e03cf3b","text":"Media reporting in 2023 on expansion and tightening of mobilization and medical\u2011fitness procedures (Ministry of Defence changes to the Regulations on Military Medical Examination, referenced in coverage of Order No.490)."},{"id":"5e77b394-bb3a-4aa7-96b7-903d5eb45d32","text":"Major international coverage during 2023 reported a sharp rise in Ukrainian war amputees and stories about some wounded servicemen returning to roles after prosthetics and rehabilitation (BBC feature on amputees)."},{"id":"8c107dd6-605d-4017-a9bd-33e6ba2712aa","text":"Human Rights Watch publishes findings that cluster munitions were used by Ukrainian forces in populated parts of Donetsk in October 2014."},{"id":"2e7877d8-7bc2-44aa-97f3-885ee1f7b7c8","text":"Human Rights Watch warns that unguided Grad rockets used in populated areas in eastern Ukraine led to civilian deaths and injuries."},{"id":"92170761-229f-4faa-9360-128f73ee18ea","text":"Multiple international news outlets reported deadly shelling incidents in Donetsk (e.g., bus-stop and residential strikes in January 2015) with both sides trading blame."},{"id":"8d56a805-acf8-4a80-b4f7-742343c9065c","text":"OSCE SMM spot report documents residential buildings in Donetsk severely damaged by artillery fire observed by monitors."},{"id":"a1cec6e8-9f55-45dc-8b12-ac0c718e1958","text":"Royal College of Physicians report \'Nicotine without smoke: Tobacco harm reduction\' endorsing e-cigarettes as a reduced-harm alternative."},{"id":"339603cf-d217-443d-84aa-919573e582a3","text":"2019 EVALI outbreak (vaping-associated severe lung injury) and CDC investigation/public reporting."},{"id":"2cbcdcf5-3172-4520-9520-fe93506b4118","text":"Publication of peer\u2011reviewed study detecting chlormequat in U.S. foods and urine samples (Temkin et al.)"},{"id":"38efc9d6-8d2c-44e2-b8ef-a3cfcec9d8ab","text":"2019 mainstream reporting on glyphosate (Roundup) residues in oat\u2011based cereals (including Cheerios/Quaker)"},{"id":"740097a6-3475-4c42-a063-6d57bd424dce","text":"2019 consumer lawsuits and complaints over \'natural\' labeling after pesticide detections in Quaker/other oat products"},{"id":"fafefd80-e2e8-4b59-8a21-8df1b96decf8","text":"Earlier vaccine contamination/quality incidents (Japan pauses Moderna batches over foreign particles, Aug 2021)"},{"id":"8eb4cb0e-7b9a-4f13-8e1a-da24d629fdfa","text":"FDA Emergency Use Authorization announcement for Pfizer pediatric dosing (3 \u03BCg) for ages 6 months\u20134 years"},{"id":"3549f487-ce14-40df-b2d6-fcc4513c8785","text":"Global OPV \'switch\' (withdrawal of type\u20112 component) and related operational challenges \u2014 April 2016"},{"id":"f6716a58-9b2f-455c-90ca-18000499c8fd","text":"Suspension of mass polio vaccination campaigns during the early COVID\u201119 pandemic \u2014 March 2020"},{"id":"e6253f6d-ecac-49af-9e41-e9fabbfd8e44","text":"Official appointment of Andriy Shevchenko (politician) as Ukraine\'s Ambassador to Canada"},{"id":"fe1f81b2-1744-41f8-b4e4-aabc8202821e","text":"High public profile of footballer Andriy Shevchenko (former Ukraine/AC Milan striker; Ballon d\'Or 2004)"},{"id":"f2d0d656-bd3e-4ab3-a57e-5277628a2f0f","text":"Federal judge orders FDA to speed release of Pfizer COVID-19 vaccine documents (55,000 pages/month)."},{"id":"004e3aa8-4727-4367-8257-4ebff0af8a68","text":"News reports that the United States and many European countries would not send representatives to Vladimir Putin\u2019s May 7, 2024 swearing\u2011in ceremony."},{"id":"82c9f4b5-c38c-451a-8ad2-14f8edcc6b84","text":"U.S. State Department March 19, 2024 press statement (\'On Russia\u2019s Presidential Elections\') that criticized the election as undemocratic while discussing the outcome and Russian leadership."},{"id":"03a0c294-e976-4333-841a-97588c9807cd","text":"FTC and FDA/FTC enforcement actions against companies marketing supplements as diabetes treatments (joint warning letters / cease-and-desist demands)."},{"id":"cf85300d-422f-4309-8986-fbd3de9faa9e","text":"Publication of systematic reviews / meta-analyses (e.g., berberine) showing modest glucose\u2011lowering effects of certain supplements."},{"id":"64a9d99e-8e91-4678-aa7f-b728bd5c53b2","text":"Reporting of budget pressures and cuts to municipal funding in Italy (municipalities face first funding cuts in years)"},{"id":"80af9af0-d58c-4a6e-ac4f-b9c6247b5718","text":"Pentagon Inspector General report that around $1 billion in U.S. weapons sent to Ukraine were not properly tracked (publicised January 2024)"},{"id":"ec64a4a4-f829-484d-8869-7c9eb4db9c7e","text":"Italian government approvals/extensions of multiple military/financial aid packages to Ukraine (ongoing through 2023\u20132024)"},{"id":"bbb5cc6b-3b9d-484e-85ce-d24c3c292f70","text":"Partial collapse of the medieval Torre dei Conti during restoration work in central Rome"},{"id":"d67d3d85-394c-406e-82a3-52cfde1c0d91","text":"IPCC Special Report on Global Warming of 1.5\xb0C published and widely reported"},{"id":"ecbd4e9f-56e6-4e10-9bd2-e280c4a7a058","text":"CDC and other agencies publicly reported and investigated rare myocarditis/pericarditis signals after mRNA vaccination (mid\u20112021)"},{"id":"dc94773d-e525-4ece-af42-d49b116e49ec","text":"Ongoing clinical trials and phased authorizations for children and boosters (e.g., Pfizer EUA for 5\u201311 on Oct 29, 2021)"},{"id":"d187f29f-d494-4ca9-8866-e9da236be814","text":"Initial U.S. authorizations delivered under Emergency Use Authorization (EUA) rather than full licensure (December 2020 onward)"},{"id":"6294c61a-6abc-46e0-a49a-abf7a17ad549","text":"Public guidance describing mRNA COVID-19 vaccines as a new type of vaccine (CDC explainer updated Nov 2021)"},{"id":"66b58dc0-50b5-4540-adba-a4e76fb91d67","text":"Gazprom announced it could exempt rebel\u2011held Donetsk and Luhansk areas from Ukraine\u2019s main gas contract and effectively supply those territories."},{"id":"383b6c54-a4cb-4059-ad3e-ea0d13e45cc6","text":"International monitors and humanitarian agencies reported acute winter fuel and heating shortages in parts of Donbas after 2014 fighting, generating local appeals for external assistance."},{"id":"ca6674d7-a991-469f-b21e-3b470642ac02","text":"Crimean authorities nationalised local energy company Chornomornaftohaz after Russia\u2019s 2014 annexation of Crimea."},{"id":"87749de4-8e3e-4246-b0ec-0e253eef0c89","text":"Earlier major Russia\u2013Ukraine gas disputes (notably the 2009 cutoff) established a pattern of Russia using gas supply as leverage in relations with Ukraine and Europe."},{"id":"a68aadc4-aa7a-498a-b29f-5219ac9ea826","text":"Separatist leaders in Donetsk and Luhansk declared independence and publicly requested closer ties / assistance from Russia (including calls to join Russia) during spring 2014."},{"id":"7ad52f94-06d7-49c7-b712-801ca6ebb7c8","text":"Trump publicly admonishes Putin \u2014 \'Vladimir, STOP!\' after a deadly Kyiv strike"},{"id":"a362be59-a2b3-4756-9a27-ec194cf888a1","text":"High-profile visit of European/Western leaders to Kyiv (May 10, 2025)"},{"id":"2d27cb07-d273-4ff8-a885-a605607e9399","text":"Seychelles experienced a COVID-19 surge despite very high vaccination coverage, prompting WHO review of the data"},{"id":"c7eaa53f-6708-4973-a6e1-5dd6a6496de3","text":"Israeli studies and policy in July 2021 showed waning protection of two-dose BNT162b2 and led Israel to authorize booster (third) doses"},{"id":"9f69dfad-b79e-4698-a00f-9c9919cf9cff","text":"CDC reversed earlier guidance and in late July 2021 recommended fully vaccinated people wear masks indoors in areas of substantial or high transmission"},{"id":"730ccba6-46f4-4db1-900e-da737dcaf207","text":"Release of IPCC AR6 Working Group I report (Climate Change 2021: The Physical Science Basis)"},{"id":"380afa3f-981c-4fb0-9861-b18e3bcbf7a6","text":"Announcement that solar minimum occurred December 2019 and start of Solar Cycle 25 (NASA/NOAA communications)"},{"id":"6d335fdd-9f9d-41fe-95a7-51649780ed03","text":"Publication and press coverage of NOAA/Science analysis challenging the \'global warming hiatus\' (Karl et al. / June 2015)"},{"id":"e5dde201-20e3-4ed7-8581-0ce2fc39ce70","text":"Large-scale online spread and patient self-medication episode around fenbendazole in South Korea (widely reported as the \'fenbendazole scandal\' affecting cancer patients)."},{"id":"6c07e308-30de-4c20-8eed-8cb8fab78ac0","text":"Public statements by Russian officials (including Foreign Minister Sergey Lavrov) after Crimea asserting Russia did not violate the Budapest Memorandum / offering narrow readings of its obligations"},{"id":"e3bd4def-67ea-4e41-acd9-45bdc62350df","text":"Academic and policy analyses (post\u20112014) arguing the Budapest Memorandum is politically binding but legally ambiguous / not a treaty-level guarantee"},{"id":"4eb1e6c6-4c04-4fb1-9b4a-e12422fcbe0c","text":"Russia blocked transit of Ukrainian goods and imposed extra border controls in 2014, disrupting shipments to third countries"},{"id":"949cc13b-3f00-4a84-872f-1468848fa3cb","text":"Ukraine GDP contracted ~6.8% in 2014 amid the Crimea annexation and eastern conflict (IMF/official statistics reporting)"},{"id":"e0d59cbd-fe06-44e6-9e57-683460942560","text":"Multilateral economic assessments (World Bank / EBRD / IMF) in 2014\u20132015 attributing Ukraine\u2019s deep 2014\u201315 recession to conflict, loss of territory, banking crisis and trade disruptions"},{"id":"63603e7b-a791-4901-af75-8d07266dac3c","text":"Ukraine government announced a moratorium on repayment of a $3 billion Eurobond held by Russia."},{"id":"e9fec56b-bda7-405e-9874-715a2d84cc3c","text":"The 2015 Greek debt crisis and high-profile standoffs with EU creditors earlier in 2015 (July 2015) increased German public and political sensitivity to sovereign default risks."},{"id":"0531bca5-6f01-407b-a777-e27ae1b12d71","text":"23 March 2025 BBC coverage of community protests against the proposed 2,700\u2011acre East Pye solar farm in Norfolk, UK (residents citing impacts to farmland, wildlife and local character)"},{"id":"452f19a1-c9a7-4dc9-a417-a4163cc29164","text":"2014 Frontiers in Environmental Science paper \'Solar panels reduce both global warming and urban heat island\' (Masson et al.) concluding rooftop PV can reduce cooling demand and in some cases reduce UHI"},{"id":"d05ea7fe-5f24-45d6-9a3d-fcbd501c5e60","text":"FDA final rule: Over\u2011the\u2011counter drug products containing colloidal silver ingredients or silver salts declared not generally recognized as safe and effective."},{"id":"15147e88-47de-416d-9926-84fe660a5bd2","text":"Widespread clinical use of silver\u2011based products (e.g., nanocrystalline silver dressings like ACTICOAT) for wound care and device coatings documented in medical literature (early 2000s)."},{"id":"76b329bb-fe43-4d94-8dc1-903b6344d0c1","text":"Publication of the Great Barrington Declaration advocating \'focused protection\' instead of broad restrictions"},{"id":"d7007eff-53ac-46e5-8d8b-f2f5808280ef","text":"UK government\'s early \'herd immunity\' / mitigation messaging under Prime Minister Boris Johnson"},{"id":"8cd7d895-d72f-40f2-812f-beff65f4fbc3","text":"2014 ban and export\u2011freeze context (post\u2011Crimea) on Ukrainian arms sales to Russia, and related SIPRI footnotes noting many deliveries had been completed before the ban."},{"id":"c2d2c458-bce0-4b94-b0e3-fd1544161903","text":"Human Rights Watch reported exhumation of a mass grave in Sloviansk (eastern Ukraine)."},{"id":"a8e258d0-7a7b-4aef-b1a3-9162e909dee2","text":"OSCE Special Monitoring Mission published observations about unmarked graves found near Komunar / Nyzhnia Krynka (Donetsk region)."},{"id":"3fba4d5c-3ee1-4b90-9114-934702074018","text":"Launch of the government \\"Eat Out to Help Out\\" dining subsidy scheme and public encouragement to return to restaurants (August 2020)."},{"id":"2bc6299f-653a-4d72-baa1-8b71416e12a1","text":"Publication of the Great Barrington Declaration advocating \\"focused protection\\" and arguing against broad restrictions (4 October 2020)."},{"id":"c9fe7617-e8d9-453c-be7c-26d3d7a1e970","text":"Prime Minister Boris Johnson said the UK was \\"past the peak\\" of the outbreak in official briefings."},{"id":"b37d9311-a201-4634-b0be-4b9dc697c076","text":"Senior UK scientists publicly discussed \\"herd immunity\\" as part of early pandemic strategy (Sir Patrick Vallance interview/comments)."},{"id":"801625a1-7548-4660-b67e-c9b4e1df4d39","text":"Stanford press release/clinical trial announcement (2010) recruiting mitochondrial\u2011disorder patients to study vaccine responses"},{"id":"14d759b1-9f29-43bd-88c8-de19d3207ad3","text":"Government concession and media coverage of the Hannah Poling VICP matter (discussed in NEJM and major outlets)"},{"id":"3695f38b-cdde-4db9-99a4-262c0769b252","text":"Scientific American and other national outlets published explanatory pieces about the Poling case and its limits"},{"id":"12390c88-6802-4a75-b1f8-15c7a30d1011","text":"1999\u20132000 public health statements recommending removal of thimerosal from some vaccines"},{"id":"b3d0ff6d-32e2-4e8f-a950-bd3ced38cfed","text":"1993 withdrawal of the MMR vaccine (Urabe AM9 mumps strain) in Japan after reports of aseptic meningitis"},{"id":"affe057e-7142-43d7-927a-362e3310a150","text":"2010 post\u2011licensure findings of a small increased risk of febrile seizures after MMRV (leading to CDC guidance to consider separate MMR and varicella shots)"},{"id":"c2557ada-2ecf-4c1d-a428-6aa2952f7811","text":"UK/academic analyses (early 2022) and UKHSA/NEJM reports showing substantially reduced vaccine effectiveness against symptomatic infection with the Omicron variant and rapid waning after two doses."},{"id":"53f6ba38-107e-4a6a-8496-19ed4d5c8d9c","text":"UKHSA published the COVID-19 Vaccine Surveillance Report (Week 4) including unadjusted case rates by vaccination status that showed higher case rates in vaccinated people for some age groups."},{"id":"d3f8fc98-2bd0-4e1c-84ef-848db8385d6e","text":"FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine for donated supplies for hospitalized COVID\u201119 patients"},{"id":"093af7ef-f8c3-4277-b887-feb350730d2c","text":"EU decision to finance and supply lethal military assistance (European Peace Facility decisions, Feb\u2013Mar 2022)"},{"id":"57c8255d-a207-45bd-a773-01c8b3e004b0","text":"Visit of EU Commission President Ursula von der Leyen and HR/VP Josep Borrell to Kyiv"},{"id":"15321a4a-1154-4fe6-89f7-f3e8de6e2ca6","text":"Emerging reports and media coverage of myocarditis/pericarditis following mRNA COVID\u201119 vaccination (April\u2013May 2021), including Israeli surveillance data."},{"id":"b6853fbf-e30d-4aeb-929e-61d3239aca0d","text":"Publication of Ogata et al. pilot study detecting SARS\u2011CoV\u20112 vaccine antigen (spike) in plasma of mRNA\u20111273 (Moderna) recipients."},{"id":"426173ef-9f0b-4c2f-a119-f5f2aa095d55","text":"Multiple European countries temporarily suspended use of the AstraZeneca vaccine in mid-March 2021 while authorities investigated clotting reports."},{"id":"17c44ab0-58b1-4dab-8cf7-2264ccf37aec","text":"Office for National Statistics (ONS) Freedom of Information note and related discussion in June 2021 about deaths reported around the time of COVID-19 vaccination and the complexity of linking those deaths to vaccination."},{"id":"fec02486-c6e8-4284-bb05-729f62a1101b","text":"MHRA and GOV.UK Yellow Card publications and vaccine-safety updates (May 2021) that published cumulative Yellow Card report summaries and guidance on interpreting them."},{"id":"59f262f9-054b-4bee-8ad9-ab207a5ab04e","text":"MHRA press release (7 April 2021) concluding a possible link between the AstraZeneca COVID-19 vaccine and extremely rare blood clots (CVST with thrombocytopenia)."},{"id":"9bfa6c99-6397-4e36-9292-be2b2e541947","text":"Moderna U.S. patent US 9,587,003 (containing SEQ ID NO:11652) granted and publicly available (patent issued March 2017)"},{"id":"ff080f9f-615b-48e7-b27c-7d16d778d50c","text":"Moderna publicly announced rapid efforts to make an mRNA vaccine for the novel coronavirus and received funding/collaboration in January 2020 (CEPI/NIH coverage)"},{"id":"80a18546-a9f1-4a36-a3f3-a225649be4bb","text":"World Bank report showing uneven poverty recovery and slow household welfare rebound (2016\u20132019 analysis)"},{"id":"72cbdf45-7fcd-4c0b-a5b3-813722f29224","text":"Transparency International/other assessments showing persistent corruption and weak governance (CPI 2019 coverage)"},{"id":"8f0ffecd-2bd2-4568-afb4-65dda8d35d01","text":"Sharp economic contraction in 2014\u20132015 after Crimea annexation and eastern conflict (World Bank reporting)"},{"id":"3980372c-6d98-4653-89d9-f9049985a93f","text":"EU\u2013Ukraine Association Agreement (DCFTA) provisionally applied from 1 January 2016"},{"id":"39055a63-9c6d-45c9-98ef-8513c7e78bc6","text":"Statement by Crimea\u2019s chief rabbi Binyamin Volf at a November 2017 Chabad conference (badge reading \'Sevastopol, Russia\')"},{"id":"fb531a15-8aff-4353-a2a1-9aa5eccb96b4","text":"Publicized meetings between World Jewish Congress leadership (Ronald Lauder) and Russian officials, including meetings at the Kremlin"},{"id":"4d204bc2-434c-43a4-b9df-86516e0bab5a","text":"2014 controversy: Ukrainian Jewish leaders criticized visits/statements by top rabbis to Crimea"},{"id":"e0b2503d-fda4-4211-8c27-f6408b345eac","text":"Official communications and data about breakthrough infections and transmission by vaccinated people (e.g., CDC director statements and news coverage in early August 2021)"},{"id":"aaa01355-379b-4cd3-b1f5-4111a86b3987","text":"Kyiv city council and local authorities publicly discussing and approving additional allocations/guarantees to cover Eurovision hosting costs"},{"id":"f2221136-70d5-4fe1-b53b-7b08a207d33b","text":"High-profile resignations from the Eurovision organising team amid disputes over transparency and finances"},{"id":"09cb4d32-703f-41a9-a5b7-5dad4743a3d3","text":"FDA final guidance on enforcement discretion for certain N\u2011acetyl\u2011L\u2011cysteine (NAC) products, which received industry and media attention."},{"id":"b7642cd3-0bc8-4a1d-b545-580ddca192a6","text":"Registration/publication of randomized trial activity and small clinical studies evaluating NAC for severe COVID\u201119 (trial protocol/early trial entries 2021)."},{"id":"476a23f9-b992-437b-90c5-f963e8166938","text":"CDC MMWR report of anaphylaxis after first doses of Pfizer-BioNTech COVID-19 vaccine"},{"id":"e876aa55-ccc6-4a86-a82c-6c131c26edee","text":"CDC/ACIP recommendation and CDC endorsement for Pfizer pediatric vaccine for ages 5\u201311 (Nov 2, 2021)"},{"id":"299d2e55-bc61-4a50-bba6-66ed46b5363e","text":"FDA grants full approval to Pfizer\u2013BioNTech (Comirnaty) on Aug 23, 2021"},{"id":"497b8a3d-7b34-449a-b6a8-91e83200040e","text":"HRSA/CDC guidance and public pages explaining COVID-19 vaccine injuries are handled under the Countermeasures Injury Compensation Program (CICP) rather than the National Vaccine Injury Compensation Program (VICP)"},{"id":"4947b34a-d70e-46a6-abf7-55b3d0fccc5e","text":"April 3, 2020 CDC guidance changed to recommend cloth face coverings for the public"},{"id":"e838c843-c42f-494b-a37e-ced69281e703","text":"Russian strikes reportedly hit a radioactive\u2011waste / radioactive source facility near Kyiv in late February 2022."},{"id":"1eff0a3d-f6cd-4aa1-8d3a-9043c2e6c613","text":"EU outbreak reports and guidance showing increases in hepatitis A cases across Europe (not limited to Ukraine)"},{"id":"cc7198f8-4301-4ba1-8356-b86060cdac49","text":"Large numbers of internally displaced persons (IDPs) and documented WASH challenges in Ukraine (2014\u20132016)"},{"id":"37543867-7a98-45b0-8d61-4b2251b582c0","text":"IPCC Sixth Assessment Report (WG1) release summarising regional variation including land warming faster than oceans"},{"id":"62b4e71d-6e74-4807-808d-08787c84c8af","text":"Pacific Northwest / Western North America extreme heat wave and record highs (June 25\u201330, 2021)"},{"id":"3ccc3a01-a487-4b8a-be47-6d4a3a2a0904","text":"Arctic temperature record of +38\xb0C at Verkhoyansk (measured 20 June 2020, widely reported/confirmed later)"},{"id":"21f033b2-695d-4e52-b95f-b558e097f44b","text":"IPCC AR5 Summary for Policymakers (September 2013) conclusion: \'It is extremely likely that human influence has been the dominant cause of the observed warming since the mid-20th century.\'"},{"id":"08258c5a-06ae-4452-83ce-367944e44347","text":"Media reports and clips referenced proposals to replace universal subsidies with targeted assistance (compared by some reports to \'food-stamp\' style programs)"},{"id":"40c10979-07ed-44f9-86c3-b6799b7f54a1","text":"Analyses and reports documenting that Ukraine was used as a transit or logistical route by foreign fighters bound for Syria/Iraq (The Soufan Group foreign fighters updates, 2014\u20132015)"},{"id":"c275bfbb-ffe1-4a47-98af-9b5a80b6c744","text":"European Parliament/public sources flagged presence of foreign Islamist volunteers or sympathizers in eastern Ukrainian conflict zones (July 2015 references to press reporting)"},{"id":"72ecc1dc-d64c-429f-9c9f-4be7d17d858f","text":"Ukrainian Security Service (SBU) detained and expelled several foreign nationals described as Islamic State supporters (SBU press reports)"},{"id":"50c0933b-59f9-46d0-94dd-8f90735528aa","text":"Crimean official Ruslan Balbek publicly claimed there are ISIS training camps in Kherson (southern Ukraine)"},{"id":"2e9de352-9347-4d4d-a8bc-e3956c08af2d","text":"US decision to withdraw troops from northern Syria (announced early October 2019) and the ensuing Turkish incursion drew rapid regional and global attention"},{"id":"abb7f778-870e-40b2-a550-5eab36008d6e","text":"US impeachment inquiry into President Trump after the Ukraine whistleblower shifted US political and media attention away from foreign-policy issues such as Crimea"},{"id":"178c06f6-c2d7-4166-bf7e-d2614914d85b","text":"UK prorogation (suspension) of Parliament by Prime Minister Boris Johnson and the constitutional crisis around it in late August\u2013September 2019"},{"id":"b34894b9-0db5-4b79-9f77-90483625254e","text":"Public arrival and frontline deployment of US-supplied HIMARS in Ukraine was widely reported (first systems arrived in late June 2022)."},{"id":"5d97b84f-d0d3-4586-bb21-05b4cf519290","text":"Russian Ministry of Defence later claimed it had destroyed four HIMARS launchers between July 5\u201320, 2022."},{"id":"f34e68a5-70eb-4dfe-ad1c-a0bfcb57e6fc","text":"WHO SAGE identifies vaccine hesitancy and misinformation as major threats (working group/report)"},{"id":"2ef0b41e-8e8f-49b8-9316-58dfe374c259","text":"IARC classification of formaldehyde as \u2018carcinogenic to humans\u2019 (Group 1)"},{"id":"041a4de6-f275-4268-a290-15cab46201b5","text":"1999 US Public Health Service and American Academy of Pediatrics recommend removal of thimerosal from many childhood vaccines as a precaution"},{"id":"0a2d2ef5-2997-4280-ba09-2cf99a6347d6","text":"UN/UNICEF warning that tens or hundreds of thousands of children in eastern Ukraine are threatened by landmines and explosive remnants of war"},{"id":"27af4d41-3321-43cd-adde-e2cf8cdda644","text":"Mine Action Review report \'Clearing the Mines 2017\' documents extensive contamination and cites OHCHR findings that Ukrainian armed forces and armed groups continued to lay landmines (including antipersonnel types) during 2016"},{"id":"99344ff5-7033-46e5-a172-2343c8b0a751","text":"Bellingcat investigation & reporting on risks in Donbas (\'Donbas: A Ticking Toxic Time Bomb\') highlighting flooded and unmanaged minefields and environmental hazards in former coal-mining areas"},{"id":"a1c1ee08-ed28-4db5-a831-59acdf22f269","text":"Minsk II text included provisions on decentralization / \'special status\' for Donbas that Poroshenko accepted to negotiate."},{"id":"e95ec72b-b6d6-4417-bb16-2497cd4cff59","text":"Poroshenko announced a unilateral ceasefire (June 2014) and subsequent pauses/cessations of offensive actions."},{"id":"cb696a27-f7ad-46bd-a24a-1c2511c4b536","text":"Poroshenko and Putin met and were photographed/filmed together at international talks (including February 2015 Minsk meetings and earlier encounters such as the June 2014 D-Day meeting)."},{"id":"b34d7d81-77a6-41f9-866c-0d5d976e923a","text":"Japan reports and temporary pauses after discovery of foreign/black particles in some Moderna vaccine vials"},{"id":"a76f28a8-e514-4778-afec-dbf62ede3de5","text":"CDC/ACIP public acknowledgement and MMWR report of increased myocarditis cases after mRNA COVID-19 vaccination"},{"id":"d2b529d6-7af6-4f04-957b-b557fb40ccd8","text":"Court dispute and media coverage over FDA\u2019s proposed slow timetable and subsequent judge\u2019s order to accelerate release of Pfizer vaccine documents"},{"id":"d3130946-bf20-4d88-bbfc-7a743c19f84d","text":"CDC Health Advisory and public warnings (late August 2021) about a sharp rise in ivermectin misuse, poisonings, and related emergency visits."},{"id":"a38c53fc-6805-46bb-978a-b98d01c02b1e","text":"OSCE armoured vehicle damaged by an explosion near Pryshyb (one monitor killed, two wounded)"},{"id":"18dde5d9-a8c1-4134-8a1a-b48330358cae","text":"Publication of the Harvard Pilgrim (ESP:VAERS) final report (AHRQ grant) finding that automated surveillance suggested many adverse events were not reported to passive VAERS."},{"id":"118bfe4a-22c6-4acd-a632-2f96f78840a3","text":"Congressional/public pressure: Rep. Bill Posey\u2019s 2019 public questioning (and associated media coverage) that highlighted the multi\u2011billion dollar VICP figure and prompted scrutiny/discussion online."},{"id":"029326f0-ab23-4cc2-b665-28cb99c7ab3d","text":"OSCE SMM observed heavy weapons and armoured vehicles in violation of withdrawal lines (e.g., tanks near Avdiivka; a surface\u2011to\u2011air missile system near Hannivka) during the late\u2011January 2017 escalation."},{"id":"43e5cea7-5aa8-40fd-b513-fa7aa13d81d6","text":"Ukrainian authorities declared a state of emergency in Avdiivka and organised evacuations as civilians were left without power, heating and water following the shelling."},{"id":"6725a1ba-4023-4162-8159-537ec94e6771","text":"Multiple news outlets and local reporting documented both Ukrainian forces and pro\u2011Russian separatists accusing each other of initiating the offensive around the Avdiivka \'industrial zone\' (Almaz\u20112) and making competing claims of tactical gains."},{"id":"9726f123-3a84-47e7-a294-1eed84f61a26","text":"Peer\u2011reviewed research and industry reports documented that Liquidambar (sweetgum) seedpods contain measurable shikimic acid and could be an alternative feedstock for industrial extraction (published research e.g., Appl Biochem Biotechnol, Epub May 27, 2010)."},{"id":"da87ff37-ca2b-47c1-831b-8b46e125edb8","text":"Mainstream coverage during flu/Tamiflu shortages (2005) highlighted that shikimic acid\u2014traditionally sourced from star anise\u2014was a critical precursor for manufacturing Tamiflu, prompting searches for alternative natural sources."},{"id":"81e0c562-9db7-4aa3-a2c1-b4f864f16a9c","text":"Zozulya was included in Ukraine\'s squad for the March 24, 2017 Croatia qualifier but did not play in the match."},{"id":"eea13ed3-dccf-446f-998f-735b0ea2d09a","text":"Rayo Vallecano fans publicly protested and the club cancelled Zozulya\'s loan from Real Betis after accusations he had neo\u2011Nazi links."},{"id":"ef520cf2-7d18-4465-bea8-d978c2295e1e","text":"Rapid Trident 2021 multinational land exercise in Ukraine (\u22486,000 personnel) with explicit COVID-19 mitigation measures"},{"id":"04c0c80a-9c9f-4838-807e-9a86f6df2526","text":"Sea Breeze 2021 multinational maritime exercise in the Black Sea (June\u2013July 2021) involving thousands of personnel, ships and aircraft"},{"id":"fa7e1324-b0b9-4ff6-bdc0-6259cd84da93","text":"High-profile military COVID-19 outbreak: USS Theodore Roosevelt outbreak and ship quarantine (April 2020)"},{"id":"8324920a-9890-442b-96d7-0dc92b7918e2","text":"Post\u2011invasion \'derussification\' actions, including Kyiv renaming nearly 100 streets and removing Soviet/Russian monuments as part of wider cultural de\u2011Russification."},{"id":"c6582463-5f7d-4cfe-a8f8-6c66c1c335da","text":"Kyiv City Council imposed a moratorium on the public use of Russian\u2011language cultural products (books, songs, films, theatrical works) in the capital."},{"id":"6cfac1b0-30a7-4afb-a149-90cfba3368ae","text":"Verkhovna Rada adopted the 2019 law \'On ensuring the functioning of Ukrainian as the state language\' strengthening use of Ukrainian in public life."},{"id":"9a382c40-da0c-4d85-8cd1-9c2ebea1c96b","text":"President Zelensky imposed sanctions and broadcasting suspensions on three pro\u2011Russian TV channels (112 Ukraine, NewsOne, ZIK)."},{"id":"2a63e9a0-e29d-4060-bb0d-3468106d7324","text":"Major criminal/civil enforcement actions against drugmakers for improper marketing (example: Novartis pleads guilty and agrees to pay $422.5M for off\u2011label marketing, Oct 2010)"},{"id":"e3a2dbb7-08c2-4c29-9af0-05d39d0c1db5","text":"Publication of DSM\u20115 (May 2013) which changed ADHD diagnostic criteria (e.g., raising the age of onset criterion from 7 to 12 and adjusting symptom thresholds)"},{"id":"9f90264c-7944-46c7-8681-78318e8d1355","text":"Itaja\xed city government announcement and distribution program for ivermectin (mayor/prefeitura public rollout)"},{"id":"68641234-420a-4329-90f9-bffadf38cf2c","text":"Itaja\xed municipal health department \'Nota de esclarecimento - tratamentos profil\xe1ticos\' (clarification note) revealing rapid drop-off in adherence to the distributed ivermectin regimen"},{"id":"6eed197c-bb50-4b7c-a189-a980a1656ac3","text":"July 5, 2021 media reports (based on Israeli data) that Pfizer vaccine protection against infection had declined amid Delta variant spread, while still protecting strongly against severe disease."},{"id":"990812e0-4f86-494f-beef-eba27006dff4","text":"Sept 24, 2021 CDC/FDA authorizations and public communications expanding booster recommendations while acknowledging breakthrough infections and waning immunity."},{"id":"c2c64aec-c935-49b0-afcc-72fccbdcc3a5","text":"March 19, 2020 livestream interview where Fauci discussed antibody-dependent enhancement (ADE) as a theoretical vaccine safety concern during early COVID-19 vaccine development."},{"id":"f968d171-b816-46c0-bfa0-fba146815ece","text":"Earlier documented exhumations/mass\u2011grave discoveries in Donbas (Sloviansk mass grave exhumed)"},{"id":"9f765438-218d-4074-9cbb-6a99cfc6b719","text":"Visible cemetery work (small tractor stuck in mud and manual removal of soil) at the Sumy cemetery"},{"id":"d803b683-bf2d-480e-b71a-2f96bdbcf286","text":"Publication of a 2017 pilot study showing short\u2011term tinnitus reduction after intranasal oxytocin (peer\u2011reviewed)"},{"id":"7bbf868a-826e-4db5-a17c-44573886c777","text":"FDA clearance and media coverage in 2023 of Lenire (a novel device for treating tinnitus), elevating public interest in new tinnitus treatments"},{"id":"a3483f04-4bc2-48ff-ab5f-da1743021afe","text":"Surge of TikTok posts and hashtag activity (#tinnitushelp) in early\u2013mid 2024 promoting quick fixes, including nasal sprays/inhalers"},{"id":"e27900e5-e395-41bd-9e8f-7e9184605552","text":"Public availability of Phytonadione (vitamin K) package insert listing polysorbate 80 (DailyMed / FDA label; label file updated Jan 19, 2017)."},{"id":"15ba355f-65bd-41c2-bb80-d915bc29a320","text":"IPCC Sixth Assessment WG1 (AR6) press release and summary (August 2021) asserting that human influence has unequivocally warmed the climate system."},{"id":"bef21526-75d8-4ec5-8762-f4c10f0c6966","text":"Nature Geoscience and related studies (circa 2017) reporting large uncertainties about whether airborne mineral dust from deserts has a net warming or cooling radiative effect."},{"id":"6385f0ee-fc6e-4be6-a532-2d855f27de42","text":"Zhu et al. (2016) \'Greening of the Earth and its drivers\' (Nature Climate Change) documenting global increases in vegetation, including expansion in some dry regions, largely attributed to CO2 fertilization and land-use changes."},{"id":"be9d0715-a081-4e4b-bfc0-abb30b56e22f","text":"NASA/MODIS public data and Earth Observatory coverage showing deserts as among the highest-reflectivity (high albedo) land surfaces."},{"id":"4413ab91-f03a-4a79-8f9f-bc195fa9468a","text":"2017 peer-reviewed modelling studies and simulations proposing desert-focused geoengineering or land-surface modification (e.g., irrigating deserts or increasing desert albedo) to alter global/regional climate."},{"id":"de7f06e0-ab3a-4af8-a892-e30335092fc1","text":"April 2017 reporting of new research (covered by AIDSMap) about long-term nitrate inhalant exposure and cancer risk that noted elevated cancer signals in some subgroups."},{"id":"a389d09d-c70e-4f32-8f4f-fe1d1a9181d9","text":"June 1994 coverage and activism (New York Native / related reports) documenting calls for research into a poppers\u2013Kaposi\'s sarcoma connection (NIDA-era attention to the hypothesis)."},{"id":"7982bb8c-32dc-46d0-b1fb-bdd657baab28","text":"Russian Ministry of Defense announced first operational use of the Kh-47M2 \'Kinzhal\' hypersonic missile, claiming it destroyed an underground Ukrainian ammunition depot in Delyatyn."},{"id":"1fbaaae1-6e8b-4e15-ba6e-69100367c7cf","text":"President Joe Biden publicly acknowledged Russia\'s use of hypersonic missiles, saying the weapon was \\"a consequential weapon... almost impossible to stop,\\" as reported by news outlets in mid\u2011late March 2022."},{"id":"e9e5e622-efb4-497d-a4d0-2e931b17806d","text":"Publication showing vaccine\u2011derived spike antigen detectable in plasma after mRNA vaccination (Ogata et al., Clinical Infectious Diseases)"},{"id":"18af0ef6-7e14-4b53-8284-cbd053fc539d","text":"Publication of an in vitro study showing nattokinase degrades SARS\u2011CoV\u20112 spike protein (Tanikawa et al., Molecules)"},{"id":"ebaea4e5-dcd3-4432-a770-e32381475f95","text":"Publication reporting persistence of SARS\u2011CoV\u20112 S1 protein in CD16+ monocytes up to 15 months in PASC patients (Patterson et al., Frontiers in Immunology)"},{"id":"0ef1fdb2-1350-4739-9a5a-6090cf7b4a06","text":"Judge Mark Pittman ordered the FDA to accelerate public release of Pfizer vaccine trial documents (court order reported Jan 7, 2022)"},{"id":"f648b2b3-3a41-4e93-85c0-b818c09744fd","text":"Public availability of large troves of Pfizer documents via the PHMPT/FOIA process (public repository of Pfizer documents made accessible in 2022)"},{"id":"2bd084e4-6041-473c-ace8-09633da445b7","text":"UN General Assembly Resolution 68/262 reaffirming Ukraine\'s territorial integrity"},{"id":"ab296a5c-ee22-4d81-b8ad-0840632776be","text":"Ukrainian government regains control of Mariupol (June 2014)"},{"id":"49b6f7ee-c490-4e97-b9be-cd1cdb389f4d","text":"Ukrainian forces retake Sloviansk and Kramatorsk from pro\u2011Russian separatists"},{"id":"2f765095-3367-4bc4-bb5f-c8c33226edc8","text":"Minsk II ceasefire agreement and delineation of frontlines (February 2015)"},{"id":"22b397c9-5e00-40bd-8e3b-a23dd98284d9","text":"OSCE SMM: patrol vehicles and civilians hit by fire in eastern Ukraine (multiple incidents, Sept 2014 example)"},{"id":"df7a3803-f91f-4992-af44-ab4dde913c7c","text":"Amnesty International reporting on indiscriminate attacks and civilian deaths in Donbas"},{"id":"df1f4076-07b7-4f91-a688-776170514a2c","text":"Human Rights Watch report: unguided Grad rockets killed civilians in Donetsk suburbs"},{"id":"c72ffe7e-58cc-4d2a-86b6-10bd9f697b5f","text":"Volnovakha bus attack \u2014 passenger bus hit near checkpoint, 12 killed"},{"id":"804c22b2-4b27-4c7a-a9c1-8e0d56576d0b","text":"Energoatom presents national report at the IAEA General Conference noting diversification of fuel supply and construction of centralized spent fuel storage (IAEA General Conference coverage)"},{"id":"87e47acc-97a6-4c7f-baaf-2ab092ddd69d","text":"Country profile and industry analyses documenting Ukraine\u2019s historical reliance on Russian fuel-cycle services (conversion/enrichment) and stated efforts to diversify suppliers"},{"id":"c2ff0ebe-998f-49d8-9a26-7fb72ec51dcb","text":"Japan suspended ~1.63 million Moderna vaccine doses after reports of contamination in vials"},{"id":"1b4302fa-4db0-4d8f-9ca7-83cf593a5a08","text":"Norwegian Medicines Agency investigated deaths of frail elderly occurring shortly after Pfizer vaccination"},{"id":"9d86fdf6-7f59-44ca-b7a2-4f9d5dde13c8","text":"CDC/ACIP acknowledged increased reports of myocarditis following mRNA COVID-19 vaccination"},{"id":"0151bbcd-c972-42d3-b86b-cb399c6266fa","text":"NOAA/NASA Solar Cycle 25 Prediction Panel preliminary forecast released"},{"id":"56869913-81a3-4dc9-8932-4a209478fb3f","text":"Publication of randomized trial (Cowling et al.) reporting increased non-influenza respiratory infections in children after inactivated seasonal influenza vaccine"},{"id":"f4405dfb-c941-412f-857e-5a77f34b5f32","text":"NATO Readiness Action Plan (RAP) launched after Russia\'s 2014 actions"},{"id":"71efcdd0-feba-4f17-9df6-806c0141cbb0","text":"Public statements by NATO Secretary General Jens Stoltenberg in June 2022 urging preparation for a \'long haul\'"},{"id":"b42bcfde-d9f8-4371-9d21-99670eef9a28","text":"Decision to deploy NATO enhanced Forward Presence (eFP) battlegroups to the Baltic states and Poland"},{"id":"09aaf704-8467-4143-952d-96f41284f4f8","text":"Large NATO exercise Trident Juncture (2018) held near NATO\'s northern flank"},{"id":"d7440efb-31e2-4628-944f-50e9967a0277","text":"Reporting in June 2018 that Crimea was expected to see a major tourism surge for summer 2018 while airlines cut flights\u2014intense media focus on the 2018 tourist season."},{"id":"957fb997-6d99-4b89-adf6-7215d9d822c9","text":"\u2018Day of Crimean Resistance\u2019 and related pro-Crimea/anti-occupation rallies and activism in Kyiv (26 February 2018 demonstrations of Kyiv-based support for Crimean Tatars and Ukrainian claims on Crimea)."},{"id":"3eb91f38-46c0-4be0-a1aa-bf07ae9029bb","text":"Trial/indictment proceedings in April 2018 against Yevhen (Evgenii) Panov, accused by Russian/Crimean authorities of preparing sabotage in Crimea."},{"id":"0d60cc1f-bd32-4137-85e7-ee7f9f32a2d3","text":"Opening of the Kerch (Crimean) Bridge by President Putin, a high-profile infrastructure and tourist-access milestone for Crimea."},{"id":"83a46f8f-bd63-4e99-ba08-b42d237718ca","text":"Prime Minister\'s housing/cost-of-living speech emphasizing domestic agenda"},{"id":"3ff00e48-74c1-481f-bb84-249163637132","text":"Conservative Party confidence vote in Boris Johnson\'s leadership"},{"id":"9e295537-0a8e-4c97-956f-25a628caf5e8","text":"Prime Minister issued a fixed penalty notice in the \'Partygate\' inquiry"},{"id":"7c0677e7-a1de-46b4-8537-3e039fd956a2","text":"Surprise visit to Kyiv and public walk with President Zelensky"},{"id":"2de1d368-987c-4a5d-b412-16dff48d5432","text":"NOAA PMEL published guidance \'Quality of pH Measurements in the NODC Data Archives\' explaining that many pre\u20111990 seawater pH measurements have large, poorly documented uncertainties and that consistent, high\u2011quality pH detection has only been possible since the 1990s."},{"id":"feb784eb-895c-4e56-9470-0934560c08a7","text":"Release/public availability of the World Ocean Database (WOD) 2013, which aggregated historic in\u2011situ ocean profiles (including pH) but documented large metadata gaps and methodological inconsistencies in older records."},{"id":"7caf2bc7-0a29-4338-a5b3-d8d5314c896f","text":"Small 2018 pilot study published in the Journal of Alzheimer\'s Disease reported cognitive improvements after a coconut oil\u2011enriched Mediterranean diet in a limited sample of Alzheimer\'s patients."},{"id":"10e12017-766f-4a88-b89e-72b4241f43cb","text":"Health Canada and other national bodies issued advisories/removals in spring 2021 concerning graphene\u2011coated face masks (potential inhalation risk), and some jurisdictions pulled graphene\u2011containing masks from distribution."},{"id":"cd07651b-ca7f-4ba7-a292-e24bbb89d3e6","text":"Published scientific literature and reviews (pre\u20112021) described graphene oxide\'s biomedical research applications and its use in nanomaterials and delivery systems."},{"id":"43ef1665-1991-439b-b5b0-341027e7c7f6","text":"WHO SAGE \'Roadmap for Prioritizing Uses of COVID-19 Vaccines\' (draft) updated 29 June 2021 emphasizing prioritization of high\u2011risk groups and limited vaccine supply."},{"id":"1055602a-6022-4325-9031-c9da36278c1f","text":"Regulatory approvals in some countries for adolescent vaccination (Pfizer authorization/recommendation for ages 12\u201315 in May 2021) created divergent national vs. WHO messaging."},{"id":"12dd4744-5275-4005-9cba-eee738bae219","text":"Ukrainian forces recaptured the television tower in Slovyansk (reported May 5, 2014)"},{"id":"3d87295a-229b-4465-8a0b-4118c603b1de","text":"Widespread photo galleries and agency images of pro\u2011Russian flag\u2011raising in Donetsk (e.g., BBC gallery, April 2014)"},{"id":"6a39f53a-dbbc-49de-a3d5-8a727b162557","text":"The World Health Organization told Reuters (March 11, 2022) it had advised Ukraine to destroy high\u2011risk pathogens in public health laboratories to prevent any potential spills amid the Russian invasion."},{"id":"6cc6428f-3e2c-40ec-8a01-e3bc7f71b9e5","text":"Hawaii state law (SB2571/Act 104) banning sale of sunscreens containing oxybenzone and octinoxate (effective Jan 1, 2021)."},{"id":"12414278-10a5-4efe-aa75-6b5147a06ade","text":"Nambour randomized trial follow-up reporting reduced melanoma incidence with regular sunscreen use (long-term follow-up published 2011)."},{"id":"2921d6b4-fdb1-4fac-b774-3b44892c9a47","text":"Clinical research linking low serum 25-hydroxyvitamin D levels with worse melanoma prognosis (ASCO/JCO abstracts and peer-reviewed studies published across 2014\u20132021)."},{"id":"7e453dda-1f5a-4c77-8439-29ccd17a064a","text":"Poroshenko\'s annual address to parliament included the line that retaking Crimea by force was \'realisticly \u2014 no\' (statement made in context of legal/diplomatic strategy)."},{"id":"cce6161f-61e1-495e-856c-b460794e60d9","text":"UKHSA/other national surveillance dashboards showing age breakdowns of respiratory\u2011virus hospital admission rates (including infants) during 2022\u20132024 seasons"},{"id":"c8740bfc-0d91-49ed-a628-3e66fdb712d4","text":"\u2018Self-determination for Zakarpattia\u2019 rally held near Ukraine\'s embassy in Budapest (Oct 13, 2017)"},{"id":"ec1eaadc-9853-423b-bd50-674470b40015","text":"OSW analysis: \'Zakarpattia \u2013 together, but separated\' noting low mobilisation and governance problems (Sept 30, 2015)"},{"id":"1e8f66d1-24b7-4b3a-b1ee-0a878d3a35c8","text":"Armed shootout in Mukachevo (July 11, 2015)"},{"id":"2c3a68fc-ce0f-41b8-b95e-db9820f85184","text":"Ukraine\'s 2017 education law and ensuing Hungarian protests (Oct 2017)"},{"id":"969a892f-fce1-45f5-8bde-d9e50e52490d","text":"OSCE Special Monitoring Mission statements and reports documenting detentions, restricted access and impediments to monitors in Donbas (e.g., SMM updates 21 June 2017)"},{"id":"3fe9ba56-574a-4fbd-bd89-3efc650e8933","text":"Attack on an OSCE SMM patrol in Yasynuvata where armed men engaged/attacked monitors (reported June 20\u201321, 2017)"},{"id":"9d121a0d-cbfc-4f4d-a9b8-25602f209f3e","text":"Large-scale arrival and public statistics on Ukrainian refugees in France (UNHCR/France reports, early 2023)"},{"id":"a1143634-530f-4ddf-bd27-0031ce6cbeff","text":"Widespread France riots after the police shooting of teenager Nahel Merzouk that generated intense domestic and international attention"},{"id":"3f813fdc-4ad6-4f05-bd8c-cb458b63dcc4","text":"Local population in Zakarpattia (Transcarpathia) increasingly sought Hungarian citizenship and cross-border permits, highlighting strong economic and social ties with Hungary."},{"id":"898253d6-a20b-4ea7-a680-4ea6a8e5e591","text":"2015 Mukacheve armed clash (July 11, 2015) between local gunmen, police and paramilitary-linked groups over control of smuggling routes."},{"id":"98c3fc99-045a-41b1-9608-c4606dec0d90","text":"Analyses and commentary (2015) documenting Zakarpattia\'s long\u2011standing cross\u2011border economic orientation and weak integration with central Kyiv policies."},{"id":"f8ddd071-d05b-4c10-a854-e72bfabfc89b","text":"OSCE Special Monitoring Mission (SMM) reporting in October 2020 documented multiple explosions and frequent ceasefire violations in Donetsk and Luhansk regions, with restricted access to some non\u2011government\u2011controlled areas."},{"id":"c8a184f1-5f20-40eb-b092-438c9d095f14","text":"Prior deadly Molot mortar accident at the Rivne training ground (Molot M120-15) prompted government tests and probes after a mortar blast that killed multiple service members."},{"id":"7ad56b41-6460-472b-ae3a-26765fb583ca","text":"VAERS reports of fetal loss increased in the 2009\u20132010 season and were summarized in a 2011 review of reports after H1N1 vaccination (Moro et al.)"},{"id":"a2f350e8-ddd6-458b-9ff0-ecce809962be","text":"Authoritative guidance that VAERS is a passive reporting system and cannot be used alone to establish causation"},{"id":"947ca0f5-5a3e-42e0-87e9-0791cccea0e6","text":"UN reports sharp rise in people fleeing eastern Ukraine to Rostov region, with tent camps and thousands accommodated"},{"id":"8d97a4be-b332-4539-aa7b-7570086c9276","text":"Well-documented historical use of \'filtration camps\' during the Chechnya wars (Human Rights Watch and Amnesty reporting from 2000)"},{"id":"ab28cf16-2c3b-417f-8c2d-799f61852361","text":"Hungary and minority-rights actors publicly criticise the law and warn of harm to minority languages, prompting diplomatic pushback"},{"id":"3c9347df-8ffe-420e-820c-4842e49256f9","text":"Ukraine\'s Constitutional Court had recently struck down the 2012 Kivalov\u2013Kolesnichenko language law (decision of 28 February 2018)"},{"id":"0c724668-85d6-4a8c-9d9a-0f5348c06218","text":"Verkhovna Rada adopts the Law on Ensuring the Functioning of Ukrainian as the State Language"},{"id":"ba943773-f4ec-4b72-b99d-3fd70ccd5b96","text":"Media and analysts report the law requires Ukrainian in public sector, raises media quotas and tightens administrative penalties"},{"id":"43bf57ac-6257-460f-8d73-80f921e28db0","text":"OSCE SMM daily reports in November 2019 documenting renewed ceasefire violations, weapons and troop movements near the contact line"},{"id":"a0cfeb9e-171f-4591-87c1-7f275bfea3da","text":"Sea Breeze multinational military exercises in Ukraine (Sea Breeze 2019) involving NATO partners"},{"id":"f7281147-4afd-4fcc-a868-83b976f36e7a","text":"Verkhovna Rada adopts the Donbas \'reintegration\' law (commonly cited as ending Minsk framework)"},{"id":"9986cc55-bad0-4c51-a4f2-64526ad8eef9","text":"Public statements by President Volodymyr Zelensky and senior Ukrainian officials in mid\u20112019 expressing scepticism about Minsk (describing Minsk as a \'trap\' or calling for its overhaul)"},{"id":"5c10b624-e027-43ef-a580-72ae4235ada6","text":"Ukraine replaces the ATO with the Joint Forces Operation (JFO), moving military command and framing a more overt military response in Donbas"},{"id":"2cd38244-2816-4d92-95c4-7397788434fa","text":"Growing public and political debate within the U.S. GOP over further Ukraine aid in 2023\u2013early 2024, including prominent Republican calls to reduce or stop funding."},{"id":"63a76f1c-0c99-43b6-b1bc-49035b7d3502","text":"Pope Francis placed public phone calls with President Volodymyr Zelensky shortly after Russia\'s full\u2011scale invasion (first reported 26 February 2022)."},{"id":"02863339-38b5-4c5b-ad5c-759fea14668f","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan and subsequent batch suspensions"},{"id":"701c30c1-0733-4df8-b0d1-eb0ce9f034c8","text":"Legal filings and public petitions by the de Garay family and allied lawyers seeking Pfizer/FDA records about the 12\u201315 trial (documents and filings posted May 2023)."},{"id":"7d2f369e-4792-4f44-a2fd-c8db8dc7b072","text":"Several countries temporarily paused use of the AstraZeneca COVID-19 vaccine in March 2021 amid reports of rare blood-clot events; EMA and national agencies investigated and later issued conclusions balancing risks and benefits."},{"id":"1a25a97c-fb17-4d43-87d7-ece424c49c11","text":"Norwegian health authorities reviewed several deaths of very frail, elderly nursing-home residents that occurred shortly after Pfizer\u2013BioNTech vaccination and issued more cautious guidance on vaccinating the most frail."},{"id":"b43b7493-d28e-474e-92b1-627bc2df5911","text":"CDC/NCHS published \'Guidance for Certifying Deaths Due to Coronavirus Disease 2019 (COVID-19)\' (NCHS Alert/Guidance allowing COVID-19 to be reported as probable or presumed when appropriate, not always requiring a positive lab test)."},{"id":"e546b4d6-4a47-48e7-bd13-1e7753dbb866","text":"Public Health England (PHE)/UK consolidated COVID death reporting to \'deaths within 28 days of a positive test\' (clarifying that different measures exist between PHE daily counts and ONS death-certificate-based counts)."},{"id":"4eb4ba3e-a782-475b-b2c4-9d6db34814ec","text":"UN/OHCHR and other international monitors reported a deterioration in human rights in eastern Ukraine during 2014, noting cases of torture, abduction and some incidents of sexual abuse"},{"id":"06c0a5b5-8e16-4f9f-9f0e-ab5664de4825","text":"CDC guidance and longstanding vaccine-safety literature noting that fainting (syncope) can occur after injections and is often related to pain or anxiety rather than the vaccine itself."},{"id":"5f45c6bd-882a-409c-af4d-d2d5713430fc","text":"President Zelensky announces creation of an International Legion / call for foreign volunteers"},{"id":"a0807413-350d-497a-957b-476c99bb7942","text":"2022 general mobilisation decree in Ukraine"},{"id":"6516a31b-abc5-4f9b-aa9b-e52da0bd84d4","text":"CDC/NCHS released provisional COVID-19 death counts and official guidance for certifying COVID-19 deaths"},{"id":"cbe425dd-91d0-4c9e-814f-307d666dfb05","text":"Preprint and early analyses showing large excess deaths in the US and New York City during March\u2013April 2020"},{"id":"f13763ab-b797-4cfc-b23a-dfda1e34d18d","text":"Widespread media coverage showing overwhelmed New York City hospitals and temporary morgues (refrigerated trucks) in early April 2020"},{"id":"6793396c-a9aa-4a0b-84c1-27723d157956","text":"Publication of Nicola Scafetta (2023) paper arguing a larger solar role in recent climate change"},{"id":"67e1df4f-0b25-4eb8-ae60-da8ed780fa20","text":"Implementation of pictorial/graphic cigarette pack warnings (example: Canada began pictorial warnings in early 2000s)"},{"id":"42e1e786-eb16-4811-ac5a-3670a7e9f8cf","text":"Publication describing bronchial anthracofibrosis/anthracosis with visibly blackened bronchial mucosa (Chung et al., Chest)"},{"id":"0662725c-2816-4d30-bdaa-0bc0158a79b9","text":"NIOSH/CDC public information and media coverage about \'Black Lung\' (coal workers\' pneumoconiosis)"},{"id":"21321047-f657-460f-9cc4-e78bc25fb3fe","text":"Battle of Ilovaisk (large Ukrainian military losses; widely published 2014 photos)"},{"id":"16c7e6a0-3a3e-46d8-afe7-c7ca955a57fa","text":"Russian authorities publicly announced an investigation into the reported child death"},{"id":"0a078b3a-374d-49fe-af7e-9e2d0fe930f4","text":"CDC PLoS One investigation of \'unexplained dermopathy\' (commonly called Morgellons)"},{"id":"f3f9277b-7b33-4da8-bc76-dd68b1a43d28","text":"President Biden publishes New York Times op-ed outlining U.S. role in Ukraine without explicitly repeating phrase \'within its internationally recognized borders\'"},{"id":"e8d5e569-cd34-4e09-92ae-637153b746d6","text":"The Vatican had produced (and publicised) a papal commemorative \'peace\' medal in 2018 (designed by Chiara Principe) \u2014 a routine commemorative medal which can be given as a gift."},{"id":"3c0ec261-34f4-4f25-93bc-c9313bd979a1","text":"Publication of Mawson et al. \'Pilot comparative study on the health of vaccinated and unvaccinated 6- to 12-year-old U.S. children\' claiming higher odds of developmental delays, asthma and ear infections in vaccinated children."},{"id":"263b32f2-4856-4bd7-ad65-7bc111192dec","text":"NOAA / Arctic Report Card and mainstream coverage documenting strong year\u2011to\u2011year variability in Greenland mass balance (including exceptional melt events)"},{"id":"3ca46107-397e-421b-b4d6-0dde20cd7129","text":"Parliamentary records and news reports showed Boris Johnson\u2019s office/company received a \xa31 million donation from investor Christopher Harborne."},{"id":"a7b94326-202d-41d5-a38e-7f325df8eebc","text":"Reports disclosed large paid speaking advances and fees received by Boris Johnson after leaving office (including a \xa32.5m advance)."},{"id":"604fbd99-45fc-464d-83c4-c999705544cb","text":"Coverage that Johnson was evasive with the advisory watchdog (Acoba) about proposed paid roles and consultancy work, including reports about a paid consultancy/hedge-fund role."},{"id":"191250d7-2c7b-44a0-84ad-1a7a97290061","text":"Dmytro Yarosh\'s public profile as leader of Right Sector and commander of volunteer units, including statements he could \'send several battalions to Kyiv\', was widely reported in the months before the Rada session."},{"id":"bac0f5a3-ea5d-44df-a3c1-9fcb9dd2e680","text":"The first session of the newly elected Verkhovna Rada (8th convocation) on November 27, 2014 featured numerous newly elected MPs who were war veterans and volunteer battalion commanders attending in military fatigues."},{"id":"93b14285-af1e-4f08-84b9-e93ba8eda306","text":"Publication/press coverage (Nov 28, 2024) highlighting that oceans emit cooling aerosols (sulfur) and can have a stronger cooling effect than previously quantified"},{"id":"161373df-fc56-4929-9699-2af1f305042d","text":"NOAA report and data notes documenting record high sea surface temperatures in 2023"},{"id":"a98dad60-c241-402a-a088-d428675b3092","text":"Strong negative Pacific Decadal Oscillation (PDO) signal in October 2024 noted by climate monitoring outlets"},{"id":"2ac71266-2c71-4d0d-8737-421fba19a828","text":"Publication on improving full\u2011depth ocean observations using Deep Argo floats (Frontiers, 2023)"},{"id":"63ce55d7-4535-4422-bfa8-d00a22e51d68","text":"Peer\u2011reviewed pilot trial published showing intravaginal Lactobacillus crispatus (chen\u201101) transplantation reduced HPV viral load and improved clearance rates."},{"id":"a0797c91-72c2-4cbc-a7a2-eb2143464cd0","text":"Ukraine\'s 2015 \'decommunisation\' laws and the domestic/international controversy over honoring OUN/UPA figures (e.g., Bandera) and historical memory debates."},{"id":"5ed0f63d-df88-4580-8a8e-48d5c9df57ad","text":"Ongoing Kremlin information campaign and pro-Kremlin media narratives portraying Ukraine as \'glorifying Nazism\' and repeatedly amplifying isolated incidents as systemic (documented in EUvsDisinfo reporting)."},{"id":"c267f3f8-4c62-40c9-8ed3-103959675502","text":"Prior whistleblower allegations about CDC data handling (William Thompson statement alleging omissions in a 2004 CDC MMR study)."},{"id":"2763957d-043d-4c6f-90e7-3af562830017","text":"Austria had launched a large-scale rapid antigen mass\u2011testing programme in early December 2020, putting antigen tests at the center of political and public debate."},{"id":"f046c44a-a2a4-49a4-b33f-4a775d713df4","text":"Historical context: documented 1943 Volhynia massacres carried out by UPA (mass killings of Polish civilians in Volhynia and Eastern Galicia)."},{"id":"9a744018-8525-4ae6-8e3a-5c4aa6c6552b","text":"Mainstream reporting (BBC) highlighted disproportionate COVID-19 deaths among Black, Asian and minority ethnic (BAME) communities in early April 2020."},{"id":"75c453eb-2738-450f-87f5-31098166ede2","text":"Peer-reviewed analyses of \'normalized\' disaster losses (e.g., Nature Sustainability 2018 study on normalized hurricane damage) showing that rising economic losses are driven largely by increased exposure and wealth rather than a clear climate-driven increase in frequency."},{"id":"297e88f8-7910-405d-bc54-514e7ab6044d","text":"Nature commentary \'Climate simulations: recognize the \\"hot model\\" problem\' highlighting that some new climate models run \'too hot\' relative to historical warming."},{"id":"e99f2056-cf88-4c64-86df-0a48013a8870","text":"Veterans Affairs slide-deck (interim guidance + VAERS tables) cited in the Judicial Watch release (data described as \\"as of April 2021\\")"},{"id":"83c742a8-914b-43e6-9971-d322cacd6287","text":"European Court of Human Rights judgment (Mazepa and Others v. Russia) finding the investigation into Anna Politkovskaya\'s 2006 murder was inadequate and a violation of Article 2."},{"id":"13c7dc85-89b0-4e43-aa45-849ba1aa958e","text":"Earlier acquittals and retrials in the Russian domestic process (initial acquittals in 2008\u20132009 and a 2009 order for further investigation)."},{"id":"f0932c14-0b9e-42a3-9963-dcfbfcf6bf87","text":"May 2014 convictions of five men for Politkovskaya\'s murder without identifying or prosecuting an alleged mastermind."},{"id":"2dc6eb24-8335-40ca-90b6-c9398dfa00c9","text":"Japan\u2019s temporary suspension/recall and public reporting of Moderna COVID-19 vaccine batches after discovery of black/foreign particles in vials."},{"id":"25ecf7d1-558b-42d9-bf57-2bc303b8f36e","text":"U.S. FDA Drug Safety Communication adding label warnings to statins about rare risks including memory loss and increased blood sugar (potential diabetes risk)."},{"id":"6638cc19-c306-44fc-999e-34ecb6344f36","text":"Fatal shooting of conservative activist Charlie Kirk at a Utah university event"},{"id":"11f8567e-f853-4c9b-9c0b-ecbed2ab46bd","text":"Series of arson and vandalism attacks on 5G masts in the UK amid COVID-19 lockdown"},{"id":"1a5858cb-924a-4f99-9863-0e4a6f688c72","text":"Russian law signed criminalizing \'knowingly false\' information about the military (encouraging tighter control of narratives)"},{"id":"305809ba-0615-43e6-9a5b-5171703b2b34","text":"U.S. approval of Javelin anti\u2011tank missile sale to Ukraine (U.S. military assistance increases)."},{"id":"31ec4e9d-d48f-44e2-8a6f-c7bd59206baf","text":"Kerch Strait incident \u2014 Russian FSB seized three Ukrainian naval vessels after a clash in the Kerch Strait."},{"id":"66daa508-94e3-4524-99cf-9dd30b99355d","text":"Sea Breeze / NATO maritime activity in the Black Sea (mid\u20112018 exercises, increased SNMG presence)."},{"id":"44c2738a-f13d-4a49-b5de-f70fe3e55d56","text":"Contamination reports and suspension of Moderna vaccine batches in Japan (Aug\u2013Sep 2021)"},{"id":"7c3c831b-2105-43a8-8ad0-76c73aee5715","text":"January 2020 paper suggested snakes as a possible reservoir based on codon\u2011usage analysis"},{"id":"3f5b7328-b9a4-4069-b53d-757422e4629e","text":"University of Arizona press release (Aug 2021) described an enzyme linked to severe COVID\u201119 that is similar to neurotoxins in rattlesnake venom"},{"id":"68f43613-d2ab-47fa-b7af-29833557ed2b","text":"CDC and FDA acknowledged rare cases of myocarditis/pericarditis after mRNA COVID-19 vaccination and updated guidance/warnings (June 2021)."},{"id":"ce2dddd3-4322-4e87-b3f8-f7e629923e04","text":"High-visibility athlete cardiac incidents in 2021 (for example Christian Eriksen\'s on-field cardiac arrest at Euro 2020, June 12, 2021) and other sudden collapses widely reported."},{"id":"fcbbee15-4882-4121-9f07-7e273696aca8","text":"Media coverage in 2021 of Moderna\'s patent filings and subsequent legal actions over mRNA intellectual property (e.g., Moderna sues Pfizer/BioNTech, patent filings/provisional applications cited dating before or during 2019\u20132020)."},{"id":"3b71ae7b-1b52-40e8-bee3-d373b84cc8b6","text":"Increased promotion and discussion of ozone/oxygen therapies during COVID-19 (peer-reviewed reviews and preprints)"},{"id":"e214f73a-49c9-4a2d-b29e-9723e9a7174c","text":"French audit and reporting of rising Paris 2024 budget concerns/overruns"},{"id":"61e54a09-0f7a-4c03-875f-2d3a5d4747df","text":"Large-scale unrest and transport disruption in France (including the June 2023 riots after Nahel\'s killing and ongoing strikes)"},{"id":"4dd9a224-cfbf-4cd6-897b-6d2c3c3c063d","text":"Ipsos global/European polling on attitudes toward Paris 2024 (May\u2013June 2024 survey period)"},{"id":"2741f754-b74b-4c46-b971-fcef82ac4768","text":"Anti-corruption police raid of the Paris 2024 organising committee headquarters"},{"id":"d55af143-5861-4236-8d45-a7c0d5ea6c83","text":"South Africa suspends use of the AstraZeneca vaccine after a study suggested low efficacy against mild-to-moderate illness caused by the B.1.351 (Beta) variant."},{"id":"5279d4a3-a951-4943-b696-ec9d2055d349","text":"Norwegian Medicines Agency reports (January 2021) deaths among very frail, elderly people shortly after receiving the Pfizer\u2013BioNTech vaccine; authorities reviewed whether reactions contributed to fatal outcomes."},{"id":"3ee5c31d-14a2-4f64-be3b-b972347128e3","text":"CDC and FDA recommend a pause (April 13, 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis in some recipients."},{"id":"c21d0dbb-a95b-4ceb-a71e-8fc3df881d95","text":"EMA PRAC releases safety review concluding a possible link between the AstraZeneca vaccine and very rare blood clots with low platelets."},{"id":"3bb9c600-54d7-4db5-80d5-f9e07ae9b04d","text":"John R. Christy congressional testimony asserting climate models overestimate warming and that policy actions would have negligible temperature impacts"},{"id":"6c6f1682-69b6-4831-be94-3557272332dd","text":"CDC guidance shift and prior messaging that medical masks should be reserved for health workers; on 3 April 2020 CDC issued new guidance recommending cloth face coverings for the public."},{"id":"79699b3e-4c16-4dea-9c40-aab3eaaabdd7","text":"WHO updated advice (5 June 2020) noting \'there is no direct evidence (from studies on COVID\u201119 and in healthy people in the community) on the effectiveness of universal masking of healthy people\'."},{"id":"4f781d9a-7f8e-4869-a794-a727324fac4d","text":"Swedish government proposal to raise the voluntary repatriation (repatriation) grant to 350,000 SEK per adult (announced in government/media coverage)"},{"id":"13f0d944-6cf6-43c5-9220-7687d06e00be","text":"Immediate clarifications and explanatory articles noting who is eligible (coverage by outlets like The Local and Swedish Migration Agency pages)"},{"id":"ec218a04-2242-49d9-b1d8-715213b7c515","text":"Publicly known fact that Vega\u2019s AVUM upper stage uses a Ukrainian\u2011designed RD\u2011843 liquid engine (manufactured by Yuzhmash/Yuzhnoye)"},{"id":"7eacfe5f-3336-4bdc-bc19-96e33288a5ce","text":"Anti-Maidan tent camp at Kulykove (Kulikovo) Pole and sustained pro\u2011Russian protests"},{"id":"6a6ce671-7575-4245-941b-223ed81a25d0","text":"Deadly clashes and Trade Unions building fire in Odesa (mass casualties)"},{"id":"2113de29-0bea-45ac-b7f2-5e321f002776","text":"Pro\u2011Russian demonstrators stormed Odesa police headquarters and freed detainees"},{"id":"b12104e0-292f-4267-a6a6-1acc6bcc36cf","text":"Large\u2011scale rocket/shelling attack on Mariupol and OSCE spot reporting on Jan 24, 2015 (high civilian casualties; intense media attention)."},{"id":"92d1fcfb-d3b8-479c-b78b-53de4f6df3c7","text":"Donetsk bus-stop/mortar shelling that killed civilians and produced circulating images of victims (Donetsk bus station attack)."},{"id":"ae152faa-631f-4b0b-bf9e-7452367962ba","text":"World Health Organization interim guidance (March 19, 2020) that did not recommend routine mask use by asymptomatic members of the public"},{"id":"10753f07-df9a-4f52-8209-d82451128083","text":"2006 study linking unmetabolized folic acid (UMFA) to reduced natural killer (NK) cell cytotoxicity"},{"id":"68f0cb2c-642a-4030-a9b8-033e606d295f","text":"Clinical reviews and professional guidance highlighting controversy over MTHFR testing and folate form choice"},{"id":"f78e8fb3-a5f5-4218-9658-3435aead73ba","text":"Mid-season reports of low influenza vaccine effectiveness during the 2014\u20132015 Northern Hemisphere season (notably against A/H3N2)"},{"id":"eaff01f0-4388-4ced-be4a-e328a91d96d0","text":"Publication of BMJ individual participant data meta-analysis reporting that vitamin D supplementation reduced risk of acute respiratory tract infections"},{"id":"28dd6232-27c1-41d7-88b4-2f787f02440d","text":"Intensified Russian strikes and repeated damage to Kharkiv\'s energy and infrastructure in March\u2013April 2024 (blackouts, strikes on power plants and residential areas)."},{"id":"302e816b-f422-46c4-86df-22ab149772ca","text":"U.S. and international lenders publicly urged Ukraine to accelerate anti\u2011corruption reforms amid threats of aid reduction"},{"id":"7ff744b6-6709-480c-8c99-b17b322ef721","text":"U.S. Assistant Secretary Victoria Nuland publicly warned in Senate testimony that \'oligarchs\' and backsliding reforms threatened Ukraine\'s progress"},{"id":"acde9344-bbbe-415a-92ed-e790f274ea8b","text":"Public opinion and polls in early 2016 showed a sharp decline in Poroshenko\u2019s approval ratings, signaling political vulnerability"},{"id":"ead2fbdd-5723-42fc-ab0d-93d87a438a0b","text":"Ukraine parliament dismisses Prosecutor General Viktor Shokin after months of pressure"},{"id":"a2d274d7-5dcf-4eb7-81b7-622b8e2e97a8","text":"Panama Papers revealed President Poroshenko had registered an offshore company, prompting investigations and political criticism"},{"id":"87dce773-da40-4685-bc94-7aff0bcddddf","text":"Amnesty International documents abductions, unlawful detention and makeshift detention facilities used by Ukrainian volunteer battalions (Aidar) in eastern Ukraine"},{"id":"716847ee-a725-462c-a6c0-1f9b9b407538","text":"Russia issues large numbers of Russian passports to residents of Crimea after annexation"},{"id":"0f197dd8-0c8a-4426-919b-85d947fa246e","text":"Israeli observational study reported increased emergency cardiovascular events in people under 40 during the vaccine rollout and third COVID\u201119 wave (Sci Reports, 2022)"},{"id":"07b5174c-0004-467f-abed-bc4b6e7f8b04","text":"Science/AAAS coverage noting that a subset of the newest climate models were running \'too hot\' and discussing implications for impact studies."},{"id":"86c1ce58-0a09-4472-aa59-6b6e3cde7f37","text":"Release of UAH Version 6.0 satellite temperature dataset (Roy Spencer & John Christy) showing lower tropospheric trends than some surface records."},{"id":"db1cb6eb-4be9-49d3-93dd-957097533883","text":"1933 Soviet orthography reform (Kharkiv/1933 orthography) that altered Ukrainian spelling norms"},{"id":"f6019ddf-aedb-490c-b225-361650f56322","text":"Ems Ukaz banning many forms of Ukrainian-language print and performance (1876)"},{"id":"8dda9808-2665-4d8e-9f16-d03edf53b7a3","text":"Valuev Circular limiting Ukrainian-language publications (1863)"},{"id":"6a373685-7592-4b18-9be4-7713a5157089","text":"USDA published the National Bioengineered Food Disclosure Standard final rule (Dec 21, 2018)"},{"id":"574761de-312b-4720-bbda-afab392d4054","text":"June 2021 CDC/ACIP review and MMWR publications acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID-19 vaccination in younger males."},{"id":"2ebc3f44-7446-4a79-a097-f252f3e44d7d","text":"Associated Press published coverage (Jan 2025) that Ivanpah, once the world\'s largest concentrated solar facility, was likely headed for partial closure because it couldn\'t compete with cheaper photovoltaic (PV) technologies and faced environmental criticisms."},{"id":"d1d894f2-aa78-4b33-a4fd-1fb32b34b23e","text":"Investigations and reporting (2014\u20132015) including U.S. Fish & Wildlife/press coverage documented elevated avian mortality at Ivanpah (widely reported estimates of thousands of bird deaths and descriptions of birds being burned by concentrated-solar \'streamers\')."},{"id":"a74e82ad-2c97-4e7d-a8b5-14aeca0b1233","text":"NRG Energy and the U.S. Department of Energy announced they finalized negotiations with Pacific Gas & Electric to terminate two long-term Ivanpah power\u2011purchase agreements (PPAs), setting in motion shutdown of two units beginning in 2026 if regulators approve."},{"id":"7a4afd2e-583b-4d1b-a751-28c295503c50","text":"Public attention on waning Western political support for Ukraine (Zelensky\'s December 2023 pleas in Washington)"},{"id":"05008ca2-9f51-47b9-bcca-461e749a6dd1","text":"Bloomberg opinion column by retired Admiral James Stavridis noting Russia\'s current aviation advantage"},{"id":"fba5a612-bb2d-4564-8e52-759918f1788f","text":"Pro\u2011Russian protesters seized Donetsk regional administration and other government/SBU buildings and declared a \'People\'s Republic\'"},{"id":"b9be3a7d-7b16-488a-9236-4f95aca31052","text":"Public visibility of far\u2011right groups and symbols during Euromaidan (Right Sector, Bandera portraits, Celtic cross flags)"},{"id":"98f37028-97a3-4ac8-b09e-145a9b1fab36","text":"Pro\u2011Russian separatists seized Ukrainian armoured personnel carriers and drove them through towns in eastern Ukraine"},{"id":"8fe772b0-3ed9-4ebc-a64a-9d70e8cacb35","text":"IAEA Director General Rafael Grossi publicly expressed \'grave\' or \'extreme\' concern about the safety and security situation at the Zaporizhzhia plant under military control."},{"id":"a6b3be4f-41ad-4a8b-9d1a-da03c46f9462","text":"Russian forces seized the Zaporizhzhia Nuclear Power Plant after nearby shelling; a fire was reported at the site."},{"id":"fc234567-2d65-4f37-960b-e9df75ff8fe3","text":"Visible participation of nationalist groups (e.g., Maidan Self\u2011Defence/Right Sector elements) in the Odessa march and subsequent clashes."},{"id":"fc688e50-6c5a-4726-af4a-d7a1df92d2db","text":"Indonesian drug regulator (BPOM) circulated guidance mentioning ivermectin among medicines for COVID-19-related distribution, prompting reports that it had been authorised for emergency use"},{"id":"02bcd9eb-45c6-4482-b342-3b8a229fe307","text":"Official U.S. assistance and advisory activity for Ukraine was publicly documented (White House fact sheet on U.S. assistance to Ukraine, Nov 21, 2014)."},{"id":"bb80b8bb-dbb0-46ba-8994-3f0cf55d2f78","text":"German newspaper Bild am Sonntag published a report (citing unnamed intelligence sources) alleging ~400 Academi (ex-Blackwater) mercenaries were operating in eastern Ukraine."},{"id":"ddedc3e3-39bd-46d0-baa5-3ddbae068501","text":"YouGov poll (20 June 2022) showing Britons remain supportive of sanctions/assistance but growing wary as costs bite"},{"id":"227e6703-d39e-46a9-a329-3b7f3f31f194","text":"Hansard parliamentary debate on UK and NATO military commitment regarding Ukraine (20 June 2022)"},{"id":"c73b9e35-7577-42d5-87bc-e70a594c5ae6","text":"UK Health Security Agency technical briefings and early reports (Dec 2021\u2013Jan 2022) documenting reduced vaccine effectiveness against symptomatic infection with the emergent Omicron variant"},{"id":"9838b08a-1ace-4d74-ba8b-fef731e6a024","text":"Office for National Statistics (ONS) age\u2011specific COVID\u201119 mortality data/releases showing very low death rates in younger age groups"},{"id":"df297219-9656-49d2-8640-9d432c60083b","text":"Large cluster-randomized Bangladesh mask trial published in Science (Nov 2021) reporting a modest reduction in symptomatic SARS\u2011CoV\u20112 infections and differing effects by mask type"},{"id":"ecae77c8-c18b-42b0-b44d-6cae9d7c6d13","text":"Formation and large-scale fundraising by the \'Come Back Alive\' foundation (Povernys zhyvym) to support Ukrainian forces starting in 2014."},{"id":"ab3e765b-00ed-46bf-bbca-4867fce50f80","text":"Street vendors and souvenir sales around Maidan popularized buying Ukrainian-themed goods for fundraising and solidarity."},{"id":"8fb95e4e-2538-4403-b5d4-71f4f08ec94e","text":"Vyshyvanka Day / \'Give the vyshyvanka to a defender\' 2015 campaign increased sales/donations connected to traditional Ukrainian garments."},{"id":"58469760-1625-4a46-ae12-25b624877ece","text":"Sharp decline in domestic automobile production in Ukraine documented in 2015\u20132016 (major contraction of car manufacturing)."},{"id":"a2f08d79-7fe6-4418-9146-13672ec98ce0","text":"CDC guidance (May 13, 2021) stating fully vaccinated people could resume activities without wearing masks in most settings"},{"id":"a9d8cdb1-fc8f-4f3a-86ea-ef27564a398e","text":"Regulatory investigations and temporary pauses over rare thrombotic events associated with the AstraZeneca COVID-19 vaccine (March\u2013April 2021)"},{"id":"7c591d07-890a-4e2b-b07f-2101e9811438","text":"Uttar Pradesh state government endorsed large-scale prophylactic and therapeutic use of ivermectin in its COVID-19 protocol and publicly attributed part of its relatively low case/fatality metrics to ivermectin use (reported May 12, 2021)"},{"id":"54715ef2-9d6d-43d2-b786-a9fcb1146ef2","text":"Uttar Pradesh reports large number of \u2018COVID\u2011free\u2019 districts / very low active cases (official counts)"},{"id":"5a9df2c6-1051-481f-8995-20bb7f272aa9","text":"WHO issues guidance advising ivermectin only be used for COVID\u201119 within clinical trials"},{"id":"1fb7b3ec-b48f-4a41-907f-b3fc93458af9","text":"Surge in herbal and immune\u2011support supplement sales during the COVID-19 pandemic (record growth in 2020)"},{"id":"b9bb18de-39bd-4aa5-bf88-038fde6b416e","text":"Cochrane review reporting limited preventive effect of regular vitamin C on common cold incidence in ordinary population"},{"id":"cf7aabbd-5f45-4051-a00f-aaaa4b74a45d","text":"Human Rights Watch (and other NGOs) called for a thorough investigation into the Odessa deaths, highlighting possible official inaction or failures"},{"id":"ff9a4801-3809-4274-8ff2-b61887727e12","text":"Deadly clashes and Trade Unions House fire in Odessa (dozens killed)"},{"id":"0ca1163c-36fa-49e2-a8b3-ee240478ca9c","text":"Media reporting and analysis documenting police/authorities\' limited intervention and chaotic law\u2011enforcement response during the May 2 clashes"},{"id":"8fe8e09b-94f9-4887-bbe9-53ce062738d1","text":"Amnesty International and other human-rights organisations document police crackdowns, intimidation and legal pressure on peaceful protesters in Poland (reports published 2017 onward)."},{"id":"6b80f2ca-5717-45fb-8509-1d1318b1f234","text":"Poland\u2019s president signs laws giving the government power to appoint and dismiss public broadcaster executives, effectively placing public TV and radio under direct government control."},{"id":"36275120-af4f-4f42-937b-825cf7b1bba5","text":"The European Union triggers the Article 7 procedure against Poland (December 2017) over concerns about rule-of-law breaches, judicial independence and broader institutional capture by the government."},{"id":"ad1f6d5a-6fbe-4991-b391-6eea097ba6ca","text":"Reporters Without Borders and other press-freedom indices record a marked decline in Poland\u2019s press freedom ranking in 2016, citing government interference in public media and political pressure on journalists."},{"id":"ff4b0218-6ad8-4158-a09d-ccc01098b13c","text":"Large public and veterans\' protests against Zelensky over anti\u2011corruption and governance moves"},{"id":"8542cdd9-b0b6-48b8-9de3-00467d99bdbf","text":"President Zelensky dismisses Ukraine\'s Commander-in-Chief Valerii Zaluzhnyi"},{"id":"340865f4-4105-45f5-971c-91b0196fa214","text":"Analyses and warnings about growing far\u2011right mobilization and past armed clashes involving nationalist groups"},{"id":"b0bdc020-aa8a-4957-a82a-19757ff66f58","text":"Early limits and inconsistencies in U.S. testing guidance that undercounted cases"},{"id":"efb16d49-67a5-4fdc-82a9-8f602f332fb2","text":"Authoritative agencies published comparisons noting similarities but important differences between COVID-19 and influenza"},{"id":"0e74f67b-3e61-4007-b6be-80bd0aac365c","text":"NOAA \'Sea Level Trends\' / Tides & Currents long\u2011term tide gauge dataset publication and guidance pages"},{"id":"a01511d4-be5d-44a9-8aef-f8ef676cdb9d","text":"Major media coverage summarizing Nerem et al. (2018) (e.g., The Guardian 27 Feb 2018)"},{"id":"40aa8d69-a7d4-49c3-bdd0-de57bbff31d7","text":"Publication of Nerem et al. (2018) PNAS \'Climate\u2011change\u2013driven accelerated sea\u2011level rise detected in the altimeter era\'"},{"id":"2ee0655e-d858-4d91-a7c4-7ab020f8b20d","text":"Early\u2013mid March 2022: Evacuations of wounded Mariupol civilians (including children) to hospitals in other Ukrainian cities such as Zaporizhzhia; news outlets published photos of evacuees being treated elsewhere."},{"id":"7d808e92-d4f1-41c4-a2ce-59bcc07b90e6","text":"CDC/NCHS release on 2020 firearm-related deaths (March 17, 2021)"},{"id":"0457a908-d117-491a-8ee5-7d6ba6c19257","text":"Journal of Patient Safety 2013 estimates of 210,000\u2013440,000 deaths from preventable harm"},{"id":"6a4fd329-e94b-427b-aea1-bb26e6c34aed","text":"Record 2018 California wildfire season (e.g., Mendocino Complex Fire in July 2018)"},{"id":"b6e556ba-5f57-429d-af0f-a86c90db91b4","text":"President Poroshenko had signed a demobilization decree (No. 328/2015) in June 2015 scheduling demobilization during July\u2013September 2015."},{"id":"539280bf-56c8-4465-bdcf-441cc11c40b0","text":"Ukraine\u2019s Ministry of Defence and other officials issued immediate denials, stating that conscription schedules are governed by law and the General Staff cannot unilaterally extend conscript terms."},{"id":"0cbdc320-0d45-45b1-bada-45f660611394","text":"Widespread administrative complexity and public confusion over multiple mobilization/de\u2011mobilization orders since 2014 (partial mobilizations, different presidential decrees) created an environment where contradictory claims about service terms were plausible."},{"id":"7fd4d209-92d8-43f6-a978-4d0546466515","text":"Peer\u2011reviewed reports describing isolation and characterization of the novel coronavirus (e.g., Zhu et al., NEJM)"},{"id":"bd58c05f-b93f-4af8-bdad-fc72957680f4","text":"Russia recognised Donetsk and Luhansk as independent and ordered troop deployments"},{"id":"3bc54be7-e813-4259-b9e4-4803b179b0c3","text":"High\u2011profile Turkish Bayraktar TB2 drone use for Ukraine highlighted internationally"},{"id":"40386eeb-3c9d-4768-ba69-df110a9669ad","text":"Public Turkish statements emphasising support for Crimean Tatars and calling for Crimea\'s return to Ukraine"},{"id":"bffa340b-2243-4598-9c38-2f2d8e63cb48","text":"Turkish President Erdo\u011Fan visited Kyiv and offered to mediate between Ukraine and Russia"},{"id":"45933205-c402-44c5-a3d4-8c4d29f3324b","text":"U.S. Advisory Committee on Immunization Practices (ACIP) / CDC review and public statement (MMWR) in June 2021 acknowledging myocarditis reports after mRNA COVID\u201119 vaccines while concluding benefits outweigh risks."},{"id":"bc2e8f0f-278c-41d2-8dc7-abe26dfb5c60","text":"In vitro studies published in 2021 reporting that isolated SARS\u2011CoV\u20112 spike protein can affect endothelial cells, pericytes or ACE2 signalling (e.g., Lei et al., Avolio et al.)."},{"id":"3a5825b4-b7fe-443e-baed-008f74f91a28","text":"U.S. Department of Defense announced a $250 million security-assistance package for Ukraine."},{"id":"db314afe-80f3-46e6-b3e6-34d6477bd634","text":"Kerch Strait incident: Russian forces seized Ukrainian navy vessels and detained sailors."},{"id":"2969412c-ef5d-4f42-bd8c-e2ae776e312a","text":"Earlier U.S. transfers of lethal defensive systems (e.g., Javelin anti-tank missiles in 2018)."},{"id":"dc95d029-058e-44d0-82c7-d35a3250c5be","text":"Text of the FY2020 National Defense Authorization Act (NDAA) circulated with provisions directing security assistance and reporting on Ukraine."},{"id":"9cb961b0-2975-4edc-b037-462ad4a4acd3","text":"U.S. temporarily relocated embassy operations from Kyiv to Lviv amid Russian force buildup"},{"id":"c51c936d-dc4d-4413-907b-eedc9391ab1f","text":"Russian missile strikes and attacks on Odesa region in early July 2022 (civilian casualties reported)"},{"id":"a2a21b0f-6a99-4285-8a53-f8faff778f2c","text":"U.S. ordered evacuation of most embassy staff in early February 2022"},{"id":"245a35f3-5b3a-496e-afa6-cd0a9d64d880","text":"U.S. Embassy in Kyiv officially reopened after months of suspension (May 18, 2022)"},{"id":"9173eff4-97ad-4bb5-8e6b-14709e083d90","text":"ONS technical analysis (March 2022) \'Deaths involving COVID-19 by vaccination status\' explaining that differences in non-COVID mortality by vaccination status were driven by changing composition of vaccinated groups"},{"id":"2b4a71c2-c0a0-495b-b631-8f80095ab4f1","text":"Publication of the World Mortality Dataset and accompanying eLife paper (Karlinsky & Kobak) documenting cross-country excess-mortality estimates"},{"id":"bdb3e1ee-adc1-4b32-8391-fa9ea101b91e","text":"Reports that cities (including Lviv) were reusing or digging up old graves and opening new burial areas to accommodate war dead"},{"id":"008f646a-c5e7-48e9-b395-853b78648e67","text":"Collapse of the Nova Kakhovka (Kakhovka) dam on the Dnipro River, releasing large volumes of water and exposing reservoir sediments"},{"id":"cecfdd0e-e11b-4f69-a180-678077307002","text":"Forensic teams exhumed mass graves in Bucha after Russian forces withdrew"},{"id":"611bc014-08ef-4abc-bb78-46cec459f5c8","text":"Publication of scientific reviews and studies showing cemetery leachate can affect groundwater under certain conditions"},{"id":"ed81bfcd-bb28-485a-ad33-22c208f0ecc9","text":"BBC report on corruption allegations in Ukraine\'s defence procurement, highlighting opaque contracting and alleged diversion of funds."},{"id":"1a401108-cec9-4a29-8ebb-bdd082fb667f","text":"Verkhovna Rada passes the 2017 state budget under IMF conditions, with tight fiscal limits on public spending."},{"id":"7f84a657-9499-4925-b019-156b43762020","text":"Media coverage (KyivPost) of targeted pay increases in 2017 that boosted frontline soldiers\' wages more than others."},{"id":"3fcab9b8-b6dd-4bbc-946b-27da40e232d4","text":"IMF staff report and government commentary (2016) warning about a high public-sector wage bill and urging fiscal restraint and reform."},{"id":"8f07eb68-00a2-4867-b067-e9865a538313","text":"Razumkov Center identity survey (fieldwork March 3\u20139, 2017) reported regionally varied answers on \'citizen of the former USSR\' (cited in coverage)"},{"id":"04ba5a5c-9527-43f5-916e-b911c3a441d2","text":"Gorshenin Institute / Friedrich\u2011Ebert\u2011Stiftung publicised a July 2017 survey (\'Ukrainian society and European values\') whose mixed subgroup breakdowns were publicly presented"},{"id":"9d1576e4-3a78-4fdb-8e00-0e46b85db6fd","text":"IPCC Sixth Assessment Report (AR6) Working Group I \u2013 Summary for Policymakers released, stating \'It is unequivocal that human influence has warmed the atmosphere, ocean and land\' while also presenting ranges/uncertainty for climate sensitivity and attribution details."},{"id":"49441f57-cb4b-439b-ae80-7dc20ca68fa5","text":"Hunga Tonga\u2013Hunga Ha\'apai volcanic eruption (massive explosive eruption and atmospheric injection of water vapor and aerosols)."},{"id":"32f79435-fe11-4d8a-859b-4156f982c7a1","text":"A small number of UN member states publicly recognized or expressed support for Russia\u2019s annexation of Crimea (reported examples e.g., statements by Syria, Venezuela)"},{"id":"107525d3-a6d1-4661-8fc3-97818c3422d7","text":"UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine\u2019s territorial integrity"},{"id":"3a56cb72-b74a-4223-ac3d-0dcbe7a192e9","text":"UN Security Council veto blocked a draft resolution condemning the Crimea referendum"},{"id":"43f86fbb-c78a-4fae-925c-8e1363978e79","text":"Ukraine\u2019s government signalled acceptance of the \'Steinmeier Formula\' (early October 2019) committing to steps on special status/elections for Donbas"},{"id":"87c7fc14-b153-4c4c-bb81-721cba1b85ec","text":"High-profile Russia\u2013Ukraine prisoner exchanges in September 2019 (major swaps reported Sept 2019)"},{"id":"019c4880-7921-44f3-a24b-4ead99231cb3","text":"Atlantic Council analysis (Oct 30, 2019) summarising polls that show many Ukrainians want peace but with important caveats (e.g., polls indicating ~69% favour compromise in some formulations)"},{"id":"b7470a85-016a-411a-956c-431a292989eb","text":"Large \'Stop Capitulation\' / \'No Surrender\' protests across Ukraine opposing concessions (early October 2019, mass rally Oct 6, 2019)"},{"id":"09601652-9278-414f-9e73-debea62d2b9c","text":"Ilko Kucheriv Democratic Initiatives Foundation / KIIS November 2019 public opinion survey (national) reported majorities on negotiating and preconditions for talks"},{"id":"18b49d65-cda8-4c8a-b14a-5e9183dd8f9b","text":"Preprint serosurvey reporting SARS\u2011CoV\u20112 antibodies in cats in Wuhan"},{"id":"0a9a6e37-c995-44c2-b020-eb4e95a33536","text":"Public health caveats and cautious messaging (CDC/WHO) about animals and COVID\u201119"},{"id":"cb25b9d1-b962-4e5f-857d-fe0ff139d644","text":"Belgian domestic cat tested positive after owner with COVID\u201119 (human\u2192cat transmission)"},{"id":"b657d758-6cb0-4f50-9705-1ecc489c1cae","text":"Russian officials publicly demanded the release/publication of recordings and black box data, accusing investigators of withholding material."},{"id":"565e426e-e98e-48c0-8ddc-0b094636d559","text":"Conflicting official statements about why MH17 was allowed to fly over conflict\u2011torn eastern Ukraine and whether Ukrainian authorities had closed relevant airspace."},{"id":"344bc6bf-1087-4258-874a-612ea4554b85","text":"Japan suspended use of some Moderna COVID-19 vaccine batches after reports of particulate contamination in vials (August 2021)."},{"id":"d0b97879-7a8d-4815-88e9-070893f31d88","text":"Norwegian health authorities reviewed reports of 23 frail elderly patients who died shortly after receiving the Pfizer/BioNTech vaccine and issued guidance about vaccinating very frail elderly (January 2021)."},{"id":"33a8f32d-d60a-400b-a04d-678bcd8bb932","text":"December 2022 peer-reviewed autopsy study examining 35 people who died unexpectedly within 20 days of COVID-19 vaccination reported possible vaccine-induced myocarditis in a small number of cases and was widely shared."},{"id":"a29fe756-de69-48fe-a88b-c881add7f1bd","text":"Russian leadership accuses Ukraine of plotting terrorist/armed incursions (Crimea)"},{"id":"92f05824-1cf6-48fd-adb3-12ccb30e92c3","text":"Rapid Trident 2018: Ukraine\u2011NATO joint military exercises in Lviv region"},{"id":"b8460d5b-4ae0-43bc-b8e6-8920c60104dd","text":"FDA Vaccines and Related Biological Products Advisory Committee briefing documents (December 2020) for the Pfizer\u2011BioNTech vaccine noted transient changes in trial participants\' lymphocyte counts"},{"id":"9ed82274-4dfd-4a08-9cf0-e54b6ed05a27","text":"Reports of contamination (black/foreign particles) found in multiple Moderna vaccine vials in Japan, prompting suspension and investigation of batches"},{"id":"161c3e6c-1a57-4298-b101-4d55aa85ef1c","text":"Public Health England (PHE) Technical Briefing 17 published with breakdowns of Delta cases, hospitalisations and vaccination status"},{"id":"595f05b3-4923-4276-a40b-30ff906894e4","text":"Discovery of dozens of civilian bodies in Bucha after Russian forces withdrew"},{"id":"fc414cf9-8ffc-4069-8353-392b7823db8e","text":"Pattern of Russian accusations that Ukraine stages \'provocations\' or \'false flag\' incidents"},{"id":"f2b852a5-2358-425c-b489-7e98c562db41","text":"WMO/other agencies reported unusually low Antarctic sea\u2011ice extents in 2022\u20132023 (e.g., WMO note on record low winter extent, September 13, 2023)."},{"id":"001367d2-684d-4b59-9805-f097572ee62a","text":"IPCC Sixth Assessment Report (AR6) Summary for Policymakers released, strongly attributing recent warming to human influence"},{"id":"853d4468-5466-4497-ac59-9fb3906d05b5","text":"Publication/coverage of papers predicting a \'modern grand solar minimum\' and potential cooling (e.g., Zharkova et al. 2020)"},{"id":"20da7166-f5ce-4d8c-83f1-29c7e9cb057c","text":"CDC released guidance for certifying deaths due to COVID-19 (guidance on cause-of-death reporting, explaining comorbidities often listed alongside COVID-19)."},{"id":"2882fc70-2d99-436c-9600-d832cb340c87","text":"Publication and wide circulation of the Great Barrington Declaration (Oct 4, 2020), advocating \'focused protection\' and highlighting differences in individual risk."},{"id":"78c6bf47-3270-4907-8e54-57ced25689d2","text":"CDC reverses mask guidance for vaccinated people (July 27, 2021) following Provincetown/Barnstable County outbreak and director\'s statement"},{"id":"16c1596f-0638-4c9d-b521-04f920c7f851","text":"Peer\u2011reviewed reports of myocarditis temporally associated with mRNA vaccination (Israel / NEJM reporting increased risk in young males)"},{"id":"e03ffb94-e08e-4651-9cc1-0095b2efd08f","text":"Russia blocked an OSCE council statement condemning the Mariupol attack and publicly blamed Kyiv for the shelling"},{"id":"eb5e9dd2-7d04-4532-acfd-fb5f1aae9ef3","text":"OSCE Special Monitoring Mission spot report (24 January 2015) published crater/direction analysis of the Mariupol strike (found impacts from north-east/east)"},{"id":"f4014cc2-8e57-4abb-bf52-07bcfb0f3b44","text":"NOAA/NCDC summary reporting 2012 as the warmest and second-most-extreme year for the contiguous United States, citing ~34,008 daily record highs vs ~6,664 daily record lows."},{"id":"27897f54-49e3-4fae-9828-505f78bf9d1f","text":"Publication of Keeling et al. (PNAS, 2017) reporting a global secular increase in carbon isotopic discrimination by land photosynthesis."},{"id":"707cfe8f-a312-4565-a0e8-0b194b657b05","text":"Publication and broad media coverage of the 2016 \'Greening of the Earth\' study showing large CO2-driven vegetation increases (Zhu et al., Nature Climate Change) and NASA press releases highlighting a global \'greening\' trend."},{"id":"163a3d3e-a21f-40ae-9fa8-3ad5e284327e","text":"Coverage in mid\u20112024 of Morocco\u2019s expanded cloud\u2011seeding (Al\u2011Ghaith) programme and Spanish media concern that artificial rainfall efforts could affect neighbouring territories (reported August 28, 2024)."},{"id":"d7d98017-ceab-473b-9d1d-550fea381397","text":"Catastrophic late\u2011October 2024 floods in eastern Spain (DANA) that produced widespread destruction and many viral images/videos."},{"id":"b662b0d5-6387-4160-9e87-512993dc9a40","text":"Ukrainian government reported a substantial increase in defence spending for 2018, publicly committing more resources to the armed forces."},{"id":"e5e5ef80-c4d3-4483-95c6-0cd446834cdb","text":"Verkhovna Rada adopted a new Law on National Security intended to bring Ukraine\'s security institutions closer to NATO standards (adopted June 2018; signed July 2018)."},{"id":"89c39233-7f7d-4a37-ad84-11944dc610f1","text":"OSCE Special Monitoring Mission reported a noticeable rise in ceasefire violations and incidents in Donetsk and Luhansk during mid-2018."},{"id":"0c9bea1c-696e-45be-8e98-9455cb0f2893","text":"Russia held its Vostok-2018 strategic military exercises involving ~300,000 personnel, heavy air and naval assets, and participation from China and Mongolia."},{"id":"cd094463-97a5-4de0-93ed-1325af5ef9fb","text":"Russian authorities repeatedly announced large totals of \'humanitarian aid\' deliveries to Donbas (official claims in 2015 of tens of thousands of tonnes delivered)"},{"id":"7c13746a-776d-491b-9b30-589340d3a403","text":"Putin signed a decree simplifying Russian citizenship for residents of Donetsk and Luhansk"},{"id":"f6af0590-2398-4b94-9a2c-3853a58d618d","text":"Russian \'humanitarian convoy\' of hundreds of trucks crossed into eastern Ukraine without Kyiv\'s authorization"},{"id":"4279a432-41f9-4319-a3e0-6dbc7b8e4a6c","text":"Kyiv City Council imposes moratorium on public use of Russian\u2011language cultural products in the capital (July 2023)"},{"id":"9cfc36a5-9f99-47a7-ad87-279683192158","text":"Kyiv city renamed 95 streets as part of derussification campaign (August 2022)"},{"id":"4ab374f8-cf52-4af7-a885-10d80a4e5b2b","text":"Presidential/National Security decision to sanction and take three pro\u2011Russian TV channels (112 Ukraine, NewsOne, ZIK) off the air (Feb 2021)"},{"id":"bd5ac819-2c81-4c5c-af79-03220d8e3334","text":"Passage of Ukraine\'s 2019 language law strengthening the role of Ukrainian (Law No. 5670\u2011d)"},{"id":"a927a42f-bfe4-4e8f-b1eb-bdef9190965f","text":"Court ban of the Opposition Platform \u2014 For Life political party (June 2022) following its suspension during martial law"},{"id":"c444c044-c221-4210-b7fa-34b86f049f7d","text":"UNICEF/WHO joint statement announcing support to close a vaccine-derived polio outbreak in Sudan"},{"id":"e82efdc4-5571-4b8d-9765-cd146c3dd097","text":"Government changes and public confusion over passport issuance procedures (Cabinet decision)"},{"id":"430ec1c2-241c-4cda-aa92-6aed75322855","text":"Major Enerhoatom/energy\u2011sector $100 million kickback probe by anti\u2011graft authorities"},{"id":"650fc0df-e0d7-4bfb-860c-8f224e30a3fd","text":"Anti\u2011corruption agencies search Andriy Yermak\u2019s apartment/home"},{"id":"f7818a82-9d09-4ed7-8218-f09097a03a92","text":"Pandora Papers disclosure linking Zelensky and close associates to offshore companies"},{"id":"495f48f0-a384-449d-89c3-48a288420008","text":"House Science Committee oversight and subpoena of NOAA over the 2015 \'pause-buster\' study (Rep. Lamar Smith)"},{"id":"68889765-9ee5-49d1-b266-6c9e6048720b","text":"CDC changes stance and recommends the public wear cloth face coverings (official recommendation)"},{"id":"135c3530-e90a-45f3-8a06-8ee429d8f40a","text":"US Surgeon General Jerome Adams urges public to \'stop buying masks\' amid shortages"},{"id":"94e71162-6f12-43d4-ba70-ab877e9b6516","text":"Antonov and media reports noted AN\u2011178 production and delivery disruptions under COVID\u201119/quarantine conditions in mid\u20112020"},{"id":"1ab4c62b-51ea-4810-b93f-ee607919f70c","text":"Ukroboronprom / Spetstechnoexport signed the export contract with Peru for the Antonov AN\u2011178 (first reported publicly)"},{"id":"c5204050-e2a2-4b54-85b3-15ef65842fe8","text":"Poland\'s 2018 \'Holocaust speech\' / IPN amendment (criminalising some statements about Polish responsibility in the Holocaust)"},{"id":"354067ed-7f02-4349-9879-a50784d2ba8e","text":"Scientific coverage that some COVID-19 vaccine candidates used long\u2011established fetal cell lines (HEK\u2011293, PER.C6)"},{"id":"3de16f03-4ac2-453c-a425-1cf9f45fa46d","text":"Russia\'s domestic gas prices reported far below European levels (Gazprom commentary)"},{"id":"2f16d0f9-a68c-4d59-ba09-140b6999aa36","text":"Ukraine suspends/begins to reduce purchases of Russian gas and pivots to European reverse\u2011flows"},{"id":"e1131622-5f85-4824-8567-9c32f350bc73","text":"Pre\u2011existing academic and public\u2011health research documenting lower vaccination uptake in some Amish communities (example: 2021 study of northeast Ohio Amish vaccination patterns)."},{"id":"f7b91efc-6423-48b9-97fc-178304a45a95","text":"Destruction of collateral sites (for example the Slovenian consulate in Kharkiv) and multiple simultaneous strikes in the city"},{"id":"99ad98ff-e094-4304-9d11-5284f0406703","text":"Missile strike hit Kharkiv Regional State Administration building in Freedom Square (large explosion captured on CCTV)"},{"id":"00c0c884-7362-48f2-ba91-ceea4b4a9e24","text":"Russian authorities designated Open Society Foundations \'undesirable\' and banned OSF activities in Russia (2015)"},{"id":"71a1364f-ecb0-4cca-ab44-0b2ce7c4be17","text":"Exiled Crimean Tatar leaders and other legitimate diaspora organizations publicly urged continuation or expansion of sanctions on Russia (e.g., calls from exiled Crimean Tatar leaders for more EU sanctions)."},{"id":"c5d07542-e14a-4255-890e-b87779f91086","text":"Large-scale humanitarian presence by Polish authorities, NGOs and aid projects operating in Western Ukraine (shelters, joint UK\u2011Polish projects in Lviv) as part of wartime assistance."},{"id":"49486281-bb55-4060-a8ab-626377399a5a","text":"Polish parliament (Sejm) adopted the \\"Act on aid for Ukrainian citizens\\" (special law) that simplified legal stay, work and social assistance for Ukrainians in Poland."},{"id":"fa3821ac-e9e0-4a8d-a6f2-d7335a37436b","text":"Leaders of Poland, Lithuania and Ukraine (the Lublin Triangle) issued a joint statement and high\u2011level meetings in Kyiv demonstrating accelerated political cooperation."},{"id":"489b9acc-002d-4c9c-aa6a-76cfb525e91d","text":"Reporting that Ukrainian troops ran out of ammunition and fled posts in Luhansk (June 2014), including accounts of units abandoning positions."},{"id":"83a03f8b-a852-4b0a-831c-c217ae86a7e2","text":"Reports in 2014 that several Ukrainian troops crossed the border into Russia during heavy fighting in eastern Ukraine."},{"id":"eb66c65e-7b3f-4c2c-b083-de751245e517","text":"Russia\'s formal recognition of the independence of the self-proclaimed Donetsk and Luhansk People\u2019s Republics on Feb 21, 2022."},{"id":"94175f26-ab9a-4fab-94f9-cceb21ab1ed0","text":"Japan suspends use of some Moderna vaccine lots after reports of foreign particulate matter found in vials."},{"id":"7ee48907-cc9c-43c9-ad87-8a0e9940923d","text":"EMA declares a possible link between the AstraZeneca vaccine and very rare cases of unusual blood clots with low platelets."},{"id":"c06a7150-78ed-40ae-aac7-81b9f53c150f","text":"Transparency International publication of the Corruption Perceptions Index 2022 (released Jan 31, 2023) showing Ukraine\'s CPI score and ranking"},{"id":"a119e35c-f046-4c85-b1f1-071ab9bd8e61","text":"Release of the Joint Strategic Oversight Plan (JSOP) for the U.S. Ukraine response by the DoD/State/USAID Offices of Inspector General"},{"id":"420f7996-128b-4313-9010-4b8f4e19aef7","text":"Media reporting that U.S. Congress was turning attention to oversight of Ukraine aid (Roll Call coverage)"},{"id":"d94c4350-9ee2-4657-a287-b9cc227a1c8e","text":"Reporting that Kyiv and other areas organized distribution of rifles and ammunition to civilian militias (e.g., plans to distribute tens of thousands of small arms and millions of rounds)."},{"id":"ea8a6908-b00d-4ea8-8587-45b94d8b0aa8","text":"Analyses and expert commentary raised early concerns that weapons flowing into/conflict zones could be diverted to illicit markets and organized crime in the region."},{"id":"b21ee972-2f02-48a4-b18a-5d96a751ea4e","text":"Ukrainian president publicly urged citizens to \'take up arms\' and promised to arm those willing to defend the country."},{"id":"665a5e96-ffeb-49b5-a375-bcd7d84ca008","text":"Multiple reports described looting, chaotic seizures and movement of weapons during early weeks of the invasion, including eyewitness accounts of armory looting and seized materiel."},{"id":"0406c3cd-e5cb-4516-bf21-63c67e2af8e9","text":"WADA added meldonium to the prohibited list effective 1 January 2016 and high-profile meldonium cases (e.g., widespread media coverage in early\u2013mid 2016) kept doping in the headlines throughout 2016."},{"id":"940d45b3-70e6-46f0-a780-9809a99095b3","text":"UEFA had run its largest-ever anti-doping programme at Euro 2016 and on 1 July 2016 published that all tournament doping tests had returned negative results."},{"id":"7eea76c1-8239-491a-b86c-c31c9c30d16f","text":"Publication of a health-technology rapid review recommending consideration of pre\u2011treatment mouth rinses in dental settings (CADTH report on pre\u2011treatment mouth rinses)."},{"id":"ba7f3ae8-8319-4da8-85e6-0a669cd417b1","text":"Publication of a peer\u2011reviewed review article (Use of mouthwashes against COVID\u201119 in dentistry) noting that povidone\u2011iodine mouthwash/nasal spray may reduce viral load and cross\u2011infection in dental settings (May 4, 2020)."},{"id":"0590b5c9-0753-4758-96e1-e5cd76bd1166","text":"Case series and literature review reporting 22 cases of new-onset inflammatory rheumatic diseases after COVID-19 vaccination (European Review for Medical and Pharmacological Sciences)"},{"id":"f4f4ef97-8303-45ba-9603-91a3735fb8d5","text":"Release of a medRxiv preprint protocol and early scoping material (Sept 3, 2023) on COVID-19 vaccines and autoimmune disorders"},{"id":"305a64ce-3d96-48b9-967b-6c4e672c9be4","text":"The New York Times publishes an opinion essay \'Donor Organs Are Too Rare. We Need a New Definition of Death.\'"},{"id":"f4edccd9-7fcb-463d-8294-2bf292462be6","text":"IPCC Special Report on Global Warming of 1.5 \xb0C released, emphasizing much greater risks at 2 \xb0C and urgency of rapid mitigation"},{"id":"a34b9494-4eaa-41ab-92cd-bc9b4997f860","text":"United Nations Secretary-General and UN agencies issued high-profile warnings in 2018 about nearing a \'point of no return\' and called for emergency action"},{"id":"4064f9b2-6d78-4be6-b53b-8c5fb1755764","text":"Peer\u2011reviewed reports of increased myocarditis cases after mRNA COVID\u201119 vaccination (large health\u2011care organization study)"},{"id":"2a499c9f-f3ec-4921-a1eb-3deb54c320c5","text":"Steven R. Gundry AHA (Circulation) abstract reporting raised PULS cardiac\u2011test inflammatory markers after mRNA vaccination (abstract 10712)"},{"id":"fa4aa885-5e37-48f9-8d0a-08d2a35c8175","text":"Patent filings in 1989 listing Robert W. Malone as an inventor on early RNA/mRNA delivery and vaccine\u2011related patents."},{"id":"43adff84-61a6-4eb0-af48-ef6a6f1e9198","text":"Indexing and citation of Malone\'s 1989 work in biomedical databases (PubMed/Europe PMC) and secondary summaries."},{"id":"591b54f0-234f-48aa-9b47-5cc82c1a123c","text":"Publication of \'Cationic liposome-mediated RNA transfection\' (Malone, Felgner, Verma) demonstrating mRNA can be delivered into cells."},{"id":"55243c7c-b698-46e8-8008-84bface2b7d6","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan and temporary batch suspensions (September 2021)"},{"id":"c5cd55fb-50c6-4f51-b2f0-29fb82011b39","text":"Small pilot study reporting detectable SARS\u2011CoV\u20112 spike antigen in plasma of some mRNA\u20111273 (Moderna) vaccine recipients (Ogata et al.)"},{"id":"71402e8a-ca22-40f1-9cd8-a07cfd02c777","text":"American Bird Conservancy (and other conservation NGOs) public statements and campaigns highlighting risks of wind farms to raptors and calling for \'bird\u2011smart\' planning (e.g., ABC \'Rethinking Wind Turbines\' materials and Vineyard Wind statement)"},{"id":"eb954d49-5502-4206-835c-3a10a98118b2","text":"U.S. Fish & Wildlife Service final rule revising eagle incidental take permitting, including a general permit option for wind energy (Federal Register/public guidance)"},{"id":"a5e6f28a-ffd1-43ba-ac54-e6d89fb9b787","text":"Release of Loss et al. (2013) meta\u2011analysis estimating annual bird collision mortality at U.S. wind facilities (widely cited ranges: ~140,000\u2013328,000 birds/yr and broader ranges cited elsewhere)"},{"id":"fe4980dc-3fc5-42dd-808a-4f77b6a3e7d5","text":"Russian Defence Ministry public statement accusing Ukrainian forces of using phosphorus-filled munitions near Hostomel (Gostomel) airfield."},{"id":"f0ed4a48-5cf3-449b-9af4-4103c61d6ee7","text":"Pre-existing precedent of mutual accusations over incendiary/phosphorus use in earlier Ukraine conflicts (2014\u20132015), documented by monitoring bodies."},{"id":"7315e2cf-aa2a-44ac-9b7d-9e4011640123","text":"UNICEF / UN agencies\' early displacement reporting (end\u2011March 2022) showed millions fled Ukraine but the largest single share went to neighbouring EU countries (e.g., ~2.3 million to Poland by March 30, 2022)."},{"id":"be88cd00-7c75-437d-a4ed-2bce23314946","text":"Multiple media reports in April\u2013May 2022 documented evacuations from besieged cities (notably Mariupol) in which some evacuation corridors or buses ended up routing civilians into Russia rather than to Ukrainian\u2011held territory."},{"id":"5bf0bfe9-23b1-4f8f-831b-9226d131f1b2","text":"Russian government issued a decree to simplify and fast\u2011track acquisition of Russian citizenship for residents of occupied Ukrainian regions (passportisation/policy announced May 2022)."},{"id":"73355a88-b3ab-4736-9530-0bf8fd22f429","text":"Russian foreign minister Sergey Lavrov publicly claimed that more than 1 million people had been \'evacuated\' from Ukraine into Russia."},{"id":"e8e77ba2-5e31-4ffc-a630-5e46fb225165","text":"Publication of peer-reviewed lab research (Heliyon, PubMed Central) showing antimicrobial activity of onion skin extracts (in vitro)."},{"id":"6e1811d7-a4c1-4a6e-9814-a4a3571c86db","text":"Ukrainian Ministry of Social Policy announced registration of 1.58 million IDPs from Donbas and Crimea."},{"id":"ee8baadc-7356-435a-b043-e036316c736f","text":"IOM National Monitoring System report (June 2017) identified unemployment as the most problematic issue for IDPs and documented barriers to employment."},{"id":"6771a937-9b7e-4308-8778-5933007f13dd","text":"Atlantic Council report (2015) and related studies documented employer discrimination and negative media portrayals against IDPs from Donbas (including job adverts excluding Donbas residents)."},{"id":"11b64097-6c56-48c5-b7f0-6c66a88ce389","text":"International Tribunal for the Law of the Sea (ITLOS) ordered Russia to release three Ukrainian naval vessels and their crews"},{"id":"9d2dad3a-95e3-42b2-8f1a-365b650177e9","text":"September 2019 Russia\u2013Ukraine prisoner swap that included the release of 24 Ukrainian sailors seized in the Kerch incident"},{"id":"c0036d38-f86f-43a1-9d36-18b6cd875492","text":"Anti\u2011NATO demonstration in front of the U.S. Embassy in Bratislava"},{"id":"30306578-b0f0-4d7b-95ec-b7ce6dffad27","text":"Washington Post reports Western countries supplying more and heavier weapons to Ukraine (coverage of weapons shipments and policy shifts)."},{"id":"fcbc729e-4ebb-4e03-9ba1-bd46577a1afd","text":"NATO and the United States announced reinforcements to Eastern Europe (ships, fighter jets and additional troops put on alert)."},{"id":"1e9aaf0c-a0a3-4e6c-9d50-f3a37bfc6b98","text":"Reports that U.S. military trainers previously operating in Ukraine were being withdrawn as the invasion threat rose (indicating U.S. personnel had been present inside Ukraine)."},{"id":"de11a555-90f2-46ba-89ef-5e92182e5dd3","text":"Continued availability/promotion of Hoxsey therapy in Tijuana, Mexico (clinics offering the regimen)"},{"id":"fd8214fe-d447-43f4-9384-6c07f29437c1","text":"Regulatory and enforcement actions against colloidal silver and related products marketed as COVID-19 treatments (FDA warning letters in 2020; DOJ injunction halting sale of silver product April 29, 2020)."},{"id":"bec8002a-957a-4b2d-bd52-ecd09a473411","text":"Publication of randomized trials showing some benefit for inhaled budesonide in early COVID-19 (STOIC trial / Lancet Respiratory Medicine reporting, April 2021)."},{"id":"9e897f33-59ed-4230-895d-0ade8df6be15","text":"Amnesty International briefing (October 2014) documenting summary killings in eastern Ukraine while cautioning that some atrocity reports had been misreported or exaggerated."},{"id":"7a0c3805-7034-4d3f-93c1-658b2953d611","text":"Discovery and media reporting of a mass grave near Sloviansk (exhumed July 24, 2014) during the eastern Ukraine fighting."},{"id":"e70b9ad6-7291-4149-b3cb-9a37e8322e8e","text":"Formation and visible operations of the Azov volunteer battalion (formed May 2014) alongside National Guard units in 2014, generating reports about far\u2011right elements within volunteer units linked to the state security apparatus."},{"id":"123b1d82-f1cd-4622-86c1-30cbc193b7d7","text":"Parliament adopts the 2019 \'On ensuring the functioning of Ukrainian as the State language\' law"},{"id":"64b6ac59-947b-4ff6-ae5d-2d3f567513fa","text":"President Zelenskiy/NSDC sanctions and broadcasting blocks on three pro\u2011Russian TV channels"},{"id":"98d9880a-94a8-43e1-8692-398e6eb9ab41","text":"Passage of decommunization laws banning Soviet symbols and reshaping public memory"},{"id":"72a28c90-6734-41ff-99bd-7e7f704a0df1","text":"Adoption of the 2017 Education Law with provisions on language of instruction"},{"id":"b43897b3-fbd6-4677-96a7-879a951f0d8f","text":"Zelensky withdrew or delayed controversial decentralization/reintegration bills (including a draft on decentralization/reintegration of Donbas) in early 2020 amid criticism and revision."},{"id":"983cf193-fe53-4ef7-9d0a-1e4afaf5d452","text":"Domestic controversy in Ukraine over the \u2018Steinmeier formula\u2019 (autumn 2019) and protests against implementing Minsk\u2011related measures."},{"id":"39aabe6b-de06-4d4c-bd1c-6b45416c94d9","text":"Early 2021 reports and papers documenting vaccine\u2011induced immune thrombotic thrombocytopenia (VITT) after adenoviral-vector COVID-19 vaccines (e.g., AstraZeneca), including cases of cerebral venous sinus thrombosis."},{"id":"73a2d70c-6ae8-4ab3-9243-499877a9229a","text":"Israel ends mandatory water fluoridation (policy change reported August 2014)"},{"id":"6e6a39f4-391f-45b1-96f8-5db1f260e0dc","text":"National Research Council (NRC) report \'Fluoride in Drinking Water: A Scientific Review of EPA\'s Standards\' (2006)"},{"id":"8af698c2-5055-44a6-b5f7-112ad08b0b43","text":"Arrest of four men by the SBU alleged to be smuggling uranium\u2011238 in western Ukraine"},{"id":"00ab3b97-6e21-4f23-b4c5-3d7a07cef906","text":"Reports that conflict damaged or destroyed radiation detection/monitoring equipment supplied to Ukraine"},{"id":"54874259-749a-48ec-b11e-773e0bdb8c69","text":"Peer\u2011reviewed assessment of radionuclide resuspension and atmospheric transport from the 2015 Chernobyl fires"},{"id":"0f81c463-7fc8-419c-b1cb-c8b675c31f82","text":"WHO interim guidance on mask use updated (June 5, 2020)"},{"id":"681e732b-6457-4afc-be2c-ffa829b4b6c4","text":"Publication of the Great Barrington Declaration advocating \'focused protection\' (October 4, 2020)"},{"id":"3cfde12d-2dad-4c2e-aa55-b283a69f332c","text":"Announcement of Operation Warp Speed / rapid vaccine development programs (May 15, 2020)"},{"id":"efad7ff7-104e-4b5f-9f70-db6054dfedfb","text":"Public remarks by Ukraine\u2019s TCG representative Iryna Herashchenko noting lack of progress on exchanges"},{"id":"c7445ec4-c898-413b-ab18-14896d7e1407","text":"Background context: prisoner exchanges had been irregular/stalled since late 2017 (last major swap Dec 27, 2017), creating a longer-term perception of negotiation breakdowns"},{"id":"b77c3439-e11b-4cf4-b980-ef7fa9556cd4","text":"Trilateral Contact Group (Minsk) humanitarian subgroup meeting (early May 2018) reported to have produced \'no results\' on prisoner lists"},{"id":"ac0f6f8a-8d44-4d77-a4f9-b18247cb3c79","text":"WHO interim laboratory testing guidance (March 19, 2020) describing that nucleic acid detection indicates viral RNA presence but does not directly specify infectious virus for all sample types."},{"id":"002ad764-192c-4309-9aaf-6df338407edf","text":"Publication of the WHO-recommended/early RT\u2011PCR assay protocols (Corman et al., Eurosurveillance) that specify short primer/probe targets."},{"id":"54d08603-b334-4505-85e4-2e560ce4f257","text":"CDC and FDA recommended a temporary pause in the use of the Johnson & Johnson (Janssen) COVID-19 vaccine following reports of rare blood clotting events."},{"id":"762e7eb9-c8a4-4aa9-b191-bee023e61b2e","text":"United Nations\u2019 admission of a role in the 2010\u20132016 Haiti cholera outbreak (U.N. acknowledgement, 2016)"},{"id":"980a2f59-eb2c-4c4d-abd3-431daae5ef23","text":"1996 Pfizer Trovan drug trial in Kano, Nigeria (reports of child deaths and subsequent lawsuits)"},{"id":"3cfad4f3-6fc2-4f26-a834-a43a7b0794b7","text":"Release of the NIPCC report \'Climate Change Reconsidered II\' (skeptic alternative to IPCC) that downplays harms of rising CO2 and highlights perceived benefits."},{"id":"34b91876-9c9a-4c8c-ba6d-7e30fca86167","text":"Public-health guidance and technical documents (e.g., UK \'Understanding cycle threshold (Ct) in SARS-CoV-2 RT\u2011PCR\') explaining Ct interpretation variability and assay differences circulated during 2020."},{"id":"8d356c7e-c604-4cd5-811b-038ceb0c38b0","text":"Peer\u2011reviewed/clinical comparisons published showing comparable detection rates between saliva and nasopharyngeal swabs (Journal of Infection letter, June 2020)"},{"id":"57e029f6-f514-4250-98b0-9829baf98d0e","text":"FDA issues Emergency Use Authorization for Rutgers\' saliva-based COVID-19 test"},{"id":"05e5f4e3-b600-4ab8-a59e-1dc2981fb49b","text":"IPCC Fifth Assessment Report (AR5, 2013) presentation of sea-level projections with explicit uncertainty ranges and caveats."},{"id":"e1934da6-d4f8-409d-be74-719425fd79d4","text":"US political signal: announcement of intent to withdraw from the Paris Agreement (President Trump, June 1, 2017) and sustained political amplification."},{"id":"9e63d817-1f55-40ca-a35c-e00a82a3a99f","text":"Poland\'s competition watchdog opens proceedings against Gazprom over Nord Stream 2"},{"id":"fe346ac3-50e6-4b71-a9a5-9e964fe80cce","text":"Poland\'s controversial \'Holocaust law\' sparks international criticism"},{"id":"fd6df1e7-3ca7-42ed-b882-b39f19350f40","text":"European Commission triggers Article 7 procedure against Poland over judicial reforms"},{"id":"d6ba753b-c0e4-42b7-bd2d-a92f2ee0dbc5","text":"Law and Justice (PiS) strong performance in the 2019 European Parliament elections"},{"id":"f9699cb3-e907-45c3-9661-478a013893b5","text":"Reports of illicit trafficking and discovery of radioactive sources in scrap/transport (Ukraine, 2015)"},{"id":"9194eb05-876a-4b47-a2b3-88a2a01df4e0","text":"2015 wildfires in the Chernobyl Exclusion Zone and fears of radionuclide resuspension"},{"id":"0a98d06d-023c-44a0-9fc5-509d19b38745","text":"Calving of iceberg A\u201168 from the Larsen C ice shelf (July 2017)."},{"id":"b5b0482e-4cc2-4e41-ab3d-f19bb86d1812","text":"California expanded laws and funding to increase prescribed and cultural burning (state bills and Newsom signings, October 2021) to reduce fuels."},{"id":"26b3f753-b6a2-48c1-9d6a-cbe595e9cf9a","text":"California utilities implemented mass Public Safety Power Shutoffs (PSPS) in 2019 to prevent power\u2011line ignitions during high\u2011wind conditions."},{"id":"2f9cbcfd-eb09-4056-a5ff-7cf0d1db3fd7","text":"Public statements and media interviews by frontline firefighters expressing that poor forest conditions and suppression policy (not climate change alone) drive severe fires (example: Sky News interview with California firefighter, Aug 2020)."},{"id":"f70c19fe-3505-4ab2-9ab0-6a45af387624","text":"PG&E pleaded guilty to 84 counts of involuntary manslaughter and unlawfully starting the 2018 Camp Fire, confirming utility equipment ignition of a major California blaze."},{"id":"3779b2b4-72ad-4216-a393-f6f1dabd000c","text":"UNDP/SEESAC and other surveys (2012\u20132016) documenting large numbers of small arms and light weapons \u2014 including unregistered/illicit stockpiles \u2014 in Moldova and the region"},{"id":"b2200702-6b63-4b01-87ff-017000ff0260","text":"Kuwait arrests members of an alleged ISIS-supporting cell who reportedly claimed to have bought weapons via Ukraine"},{"id":"e90e8db6-9ef8-4098-9557-3bea5226e758","text":"Public and political skepticism, local resistance and commentary about his appointment in Odesa (reports of local political tensions)"},{"id":"2ed54469-0ca1-4594-b9cd-6a4dd1ac5d39","text":"Appointment of Mikheil Saakashvili as Governor (head) of Odesa Oblast"},{"id":"3ee694bb-64d1-4524-953b-9b6fce34fdc3","text":"Cabinet of Ministers submits Draft Law No. 10449 on mobilization to the Verkhovna Rada"},{"id":"e31cb900-b1ee-4f20-b242-745cf43b93f5","text":"Israel / NEJM studies (2021) reporting a small increased incidence of myocarditis after Pfizer mRNA vaccination, especially in young males"},{"id":"2617e451-8f84-4920-b2d0-2ef415157476","text":"Japan suspends and recalls Moderna vaccine batches after discovery of black/stainless\u2011steel particles in vials"},{"id":"b4a79b96-99a9-4a91-b088-49b7050f5b95","text":"UN/IAEA inspection mission planning and travel to Zaporizhzhia amid continued shelling and accusations by both sides."},{"id":"066b4c74-1302-45b0-baca-be4260f7c315","text":"A fire and visible shelling at the Zaporizhzhia site during early March combat (surveillance footage showed a flare/impact on site)."},{"id":"5e40c84a-3e2d-4524-9438-1802d3a8cf3f","text":"Repeated losses of external (off\u2011site) power to the Zaporizhzhia plant and reports that the plant was at times disconnected from its last external power line."},{"id":"c005ff75-a064-4a3c-86eb-eb86647b34a4","text":"Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the Battle of Enerhodar."},{"id":"eb7f51c7-52d8-484f-be71-f870e79c177c","text":"CDC changes public guidance to recommend cloth face coverings in public settings (official guidance posted April 3, 2020)"},{"id":"05cc23e5-451f-45c4-a3d8-baf02ed8b1cf","text":"Study estimating high proportion of asymptomatic SARS-CoV-2 infections on the Diamond Princess cruise ship (Mizumoto et al., Euro Surveill., published Feb 2020)"},{"id":"14a7a112-b7eb-44ae-885d-f26b79d04d94","text":"NEJM correspondence reporting transmission of 2019-nCoV from an apparently asymptomatic contact in Germany (Rothe et al., published Jan 30, 2020)"},{"id":"4a9507d7-da94-42f8-9b2e-a49c83431f77","text":"OPCW Investigation and Identification Team (IIT) first report identifying Syrian government responsibility"},{"id":"c44b7722-081b-4cd1-93d5-faf1089228fa","text":"Human-rights organisations report abuses by volunteer battalions deployed in Donbas"},{"id":"f531b748-c838-4a44-9e54-b10e5b546449","text":"Integration of volunteer battalions (including Azov) into Ukraine\'s National Guard"},{"id":"30571462-7d39-4198-a6af-6fc2f680789c","text":"March 2015 incident where armed men linked to oligarch Ihor Kolomoisky occupied state oil company offices"},{"id":"6c2dd03d-486d-4383-8487-648cc09d3bb4","text":"Reports of timber import restrictions and new controls on Russian wood across Europe and the UK"},{"id":"58eac9be-2d07-44e7-9e0c-987bc00cd292","text":"UK and allies impose wide-ranging sanctions on Russia after the 2022 invasion"},{"id":"87166f51-253e-4199-a77e-38acc46791b1","text":"News coverage of reusable/eco toilet-paper products appearing on the UK market"},{"id":"718332a4-dd29-4f25-a473-6e8bd0cb22a3","text":"Euronews published video coverage (Feb 5, 2022) of the Kharkiv Unity March showing large Ukrainian-language banners (e.g., \'Kharkiv is Ukraine\') and many Ukrainian flags, with only a small number of English-language signs visible in brief shots."},{"id":"b82e5675-9079-4d76-af45-acd9d76427b1","text":"Growing public debate and some evidence of souring Polish attitudes toward Ukrainian refugees documented in 2022 news reports and surveys."},{"id":"71aac4ad-c4ba-437f-88e3-7a7dd911dcb1","text":"Leszek Sykulski and collaborators announced a Polish anti-war movement and proposed billboard campaign with the slogan \'This is not our war\'."},{"id":"2219de3f-c10d-44d9-8348-98d0f76ea054","text":"White House announces 50\u201352% economy-wide greenhouse gas reduction target (Leaders Summit on Climate fact sheet)"},{"id":"4467b4d6-6db4-4ae3-897f-c71b39b99b75","text":"Poore & Nemecek (Science) meta-analysis showing high emissions from beef and animal products"},{"id":"fa4768e3-042a-4590-b80d-f9ed21f8bf63","text":"EAT-Lancet Commission releases \'planetary health diet\' recommendations (widely covered)"},{"id":"a00993e4-3a22-4689-a941-c00084c02859","text":"Adoption of Ukraine\'s 2017 \'On Education\' law increasing Ukrainian-language instruction (and subsequent Venice Commission attention/criticism)"},{"id":"3644af40-9a18-458c-9b5a-baa30fcd42af","text":"Lviv Oblast Council approves a moratorium on public use of Russian-language books, films and music in the region"},{"id":"ac7d8fef-743f-44d8-8eac-628150b093cb","text":"2015 restrictions on Russian films and cultural imports (bans/curbs on films and some cultural products after 2014)"},{"id":"37d16f32-1c1a-4192-9912-dec4b8037c52","text":"Reversal of the 2012 regional-language law (the Kivalov\u2013Kolesnichenko law) after the 2014 Maidan changes"},{"id":"32886ec4-0e74-4f78-801d-9b086ef6e27b","text":"U.S. safety monitoring system (CDC Vaccine Safety Datalink) detected a statistical signal for ischemic stroke in people aged 65+ after the Pfizer\u2013BioNTech bivalent booster; CDC/FDA announced they were investigating the signal."},{"id":"47b8a608-dcab-4933-8d24-5f247103731b","text":"Earlier vaccine safety controversies (notably rare clotting events linked to adenovirus-vector COVID-19 vaccines such as AstraZeneca in 2021) remained widely recalled and were used as precedent by commentators to suggest COVID vaccines can cause serious cerebrovascular events."},{"id":"fe0ea5fa-1a6c-42cb-8ea0-31fffcfc9bc8","text":"Russia\u2019s parliament approved President Putin\u2019s request to use armed forces in Ukraine"},{"id":"bd31d7a2-a935-4379-88ae-94c01218bbbd","text":"Chinese Foreign Ministry urged restraint and avoided direct comment on the Crimea referendum"},{"id":"82593280-f906-4578-88d1-6b4e7405ff9c","text":"Unidentified armed men (widely reported as Russian forces) seized Crimean airports (Simferopol and Belbek) and other sites"},{"id":"c948621e-8d8e-4620-87ae-06fef41b1734","text":"CMS release of the Medicare COVID-19 Vaccine Public Use File (PUF) / Medicare COVID-19 vaccine analysis"},{"id":"e711ca11-d42c-45bf-9930-5701725b1316","text":"April 2021 pause and review of the Johnson & Johnson (Janssen) COVID\u201119 vaccine after reports of rare blood\u2011clotting events (TTS)."},{"id":"84a2dfe6-43f4-460a-94a1-8b232d4f8d88","text":"Japan suspended and recalled multiple Moderna vaccine batches after reports of contamination (stainless\u2011steel particles) at some vaccination sites."},{"id":"e5859b67-f473-4db3-b82a-d4d4fef700e0","text":"Poland publicly pushed for coordinated EU action over Belarus and called for an extraordinary EU response after the election"},{"id":"c5a26d30-1663-472e-b98d-390d4844fdbe","text":"Belarus opposition figure Sviatlana Tsikhanouskaya flees Belarus to neighbouring Lithuania"},{"id":"31934143-3c72-48e5-be8e-a14ffd12d5a4","text":"Lukashenko publicly accused opponents and foreign states of meddling in Belarusian affairs (blaming outside influence) in early August 2020"},{"id":"e385647e-3102-4792-bcd1-19242a4fbbde","text":"Scientific and review literature summarizing Traditional Chinese Medicine meridian theory and the popular \\"tooth-to-organ/meridian\\" charts (peer-reviewed reviews / PMC article)"},{"id":"e65b3ae6-623b-4823-972e-85f5db1077bd","text":"Peer\u2011reviewed survey showing TikTok is a major source of health information for young women (published May 21, 2024)"},{"id":"c7568f75-5d33-4f78-ac5f-2b22b319ad9b","text":"Longstanding \'hockey stick\' controversy and critiques (McIntyre & McKitrick and public debate 2003\u20132007)"},{"id":"e806c81b-121d-4434-b5f9-7d826a8c8157","text":"OSCE SMM spot report on shelling incidents in Mariupol (Olimpiiska Street) reporting civilian casualties"},{"id":"1e546e61-b8e7-495e-96a2-c3490a50dd21","text":"High-profile shelling of a bus/trolleybus stop in Donetsk reported to have killed civilians (media reports, Jan 22, 2015)"},{"id":"7ad1f552-9b72-414f-8930-825c8c13f43b","text":"OSCE SMM statement (weekly update) noting 29 people had been killed \'this year\' as of mid-January"},{"id":"54359d28-7f5e-486b-a6de-9a497f40a798","text":"IFRC deployment to assist Ukraine outbreak response (Red Cross mobilised to help contain largest measles outbreak in Europe)"},{"id":"dae23334-c486-4c05-99f8-ba15b075567e","text":"EU visa\u2011suspension mechanism in law (Regulation creating a mechanism to temporarily suspend visa\u2011free travel, adopted 2013)"},{"id":"87ea2344-d684-49dc-8b7e-74f7e5c8236a","text":"Deployment/arrival of U.S. troops to Poland as part of NATO rotations (Zagan arrival reported)"},{"id":"866df254-eab6-4e0f-9839-df235e8e45c8","text":"Polish government passes resolution to create the Central Communication Port (CPK) programme"},{"id":"91e53de0-d41e-4e9b-8346-05a13a63aaea","text":"NATO/US-led exercise Saber Strike 2017 mobilises thousands of troops and long tactical movements across Poland and the Baltics"},{"id":"268d049a-ff0d-446c-892e-be63bae981f7","text":"U.S. President Donald Trump\u2019s high\u2011profile visit to Warsaw and public expressions of closer US\u2011Poland ties"},{"id":"b3bf3acf-8658-4438-8fc3-9121b6ef3cf4","text":"Public descriptions of CPK emphasise a large rail logistics centre and high\u2011speed rail links connecting the planned airport to the national network"},{"id":"a6a0d394-94e6-4004-b0a4-e2a766da0990","text":"IPCC AR6 Synthesis Report (approved and released March 2023) summarizing complex carbon cycle information"},{"id":"0b9816b1-a151-4873-868b-f96734498575","text":"Global Carbon Project publishes the Global Carbon Budget 2022 showing large natural carbon fluxes alongside high anthropogenic emissions"},{"id":"bde486b8-5144-404b-8859-bb1c36e4a7cb","text":"The Economist published analysis \'A Ukrainian attempt to retake Crimea would be bloody and difficult\' framing retaking Crimea as high\u2011risk and costly"},{"id":"19c2f557-90c5-4d02-b5b7-4fe2bedf2697","text":"Poland announced it would transfer Leopard tanks/Leopard tank company to Ukraine (President Duda\u2019s statement in Lviv)"},{"id":"ef8d9f19-4eb5-4e71-90c2-29af1784a1a7","text":"Madrid (Spain) converted an Olympic-sized ice rink into a temporary morgue amid COVID-19 deaths (widely reported March 24, 2020)."},{"id":"f7f58c67-cfd7-44a8-bed6-6d2cf84f1177","text":"Regulatory reviews and media coverage of rare AstraZeneca blood\u2011clotting events (European/UK reviews and reporting)"},{"id":"1aac101d-dacc-4be2-a5ce-3356f3be8bba","text":"Large overnight Russian attack on Odesa\'s power grid caused region-wide blackouts"},{"id":"20b68f2c-ede3-4b79-8b30-f4f92f82e291","text":"Publication of a broad 2021 review (Nutrients) summarizing diverse immune effects of bovine colostrum"},{"id":"df8f7af0-995d-4491-b720-0ed74aff1bd7","text":"Contamination and design problems with the CDC\'s initial COVID-19 test kits (early 2020)"},{"id":"06b23df9-0ca4-4b22-9144-0b8fe4c6cc7b","text":"Study showing RT-PCR cycle threshold (Ct) correlates with viral culture positivity (Bullard et al.)"},{"id":"9ba5945d-a92f-4753-8e7c-6950d4334327","text":"IAEA and Ukrainian authorities publicly highlighted nuclear\u2011safety and remediation needs for Ukraine\u2019s legacy nuclear and uranium sites, with heightened attention after 2014."},{"id":"8f16a64f-19ca-4010-9a3a-d0d2f845c4e9","text":"Longstanding presence of large uranium mining and processing facilities in Zhovti Vody (Eastern Mining and Processing Plant), which has processed uranium ores since the late 1950s."},{"id":"5a10c5b4-40de-4c27-bc08-d2db418600f5","text":"Ferrybridge motorway service station (UK) brought in a generator to power new EV chargers because of local grid-supply issues."},{"id":"24a7bb0e-8f0b-4530-9cd4-877c382ceb83","text":"Reporting that Tesla\'s high-profile Harris Ranch \'Mega\' Supercharger location has historically been supplemented at times by diesel generation to meet peak demand."},{"id":"4bdfc6c9-8b0d-4081-9009-7df88df8ca84","text":"BMJ coverage summarising tens of thousands of reports of menstrual changes after COVID-19 vaccination (BMJ report on MHRA Yellow Card reports)."},{"id":"56f50319-d69b-4260-b71b-2e15ce63525b","text":"Publication of a large Danish cohort study linking hormonal contraception with increased rates of antidepressant use and diagnoses of depression (Skovlund et al.)."},{"id":"57973400-71de-4136-93ea-3cd72006e34b","text":"Release of international PCOS management guidance and reviews identifying combined oral contraceptives as first-line therapy for menstrual regulation and hyperandrogenism in PCOS (International evidence\u2011based PCOS guideline, 2018)."},{"id":"bb766db9-0ed3-48fa-a230-75de0238867f","text":"High\u2011profile scientific attention on rapid changes at Thwaites Glacier (BAS reporting, Sept 2019)"},{"id":"6ddf7466-bb26-4196-b780-b6a7d105ddc9","text":"Poroshenko had a documented public engagement on 23 September 2015 \u2014 a meeting with U.S. Senator John McCain in Kyiv."},{"id":"b40c1e53-d4ad-431f-9d68-08aa979479f4","text":"Pentagon Inspector General report found that about $1 billion worth of U.S. weapons sent to Ukraine were not properly tracked."},{"id":"5ec8ac77-d6c6-4b49-ad58-6e7ed13bc035","text":"President Trump ordered a temporary \'pause\' on deliveries of U.S. military assistance to Ukraine following a heated Oval Office exchange."},{"id":"3a16f7f5-193e-45b4-9365-51e6a77e3c98","text":"Prominent U.S. conservative media figures and commentators publicly questioned the scope and effectiveness of U.S. aid to Ukraine (for example, Laura Ingraham called continued aid \'a losing cause\')."},{"id":"a591ba5f-94a6-48b5-ac58-cad39c32c43b","text":"IPCC Sixth Assessment Report (AR6 WG1) release summarizing model performance and attribution of recent warming"},{"id":"fb6a025b-c13f-4d8d-ae4b-86c9bf023863","text":"Publication (1989) of Malone et al., \'Cationic liposome-mediated RNA transfection\' (PNAS), an early demonstration of RNA delivery into cells."},{"id":"24d68e62-8527-4803-a6fa-26ca777c2034","text":"Think\u2011tank and Western analyst warnings that the Kremlin was building informational conditions to blame Ukraine for chemical or radiological false\u2011flag attacks"},{"id":"db778365-385d-4330-8788-2907d8173af1","text":"Multiple European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine after reports of blood clots (mid-March 2021)"},{"id":"0d0f16d3-7244-40d6-8623-7bbc698bb8c1","text":"Peer-reviewed genome-wide association studies (GWAS) identified an association between the ABO blood-group locus and COVID-19 susceptibility and severity, widely reported in the media in 2020."},{"id":"778d9125-bcbc-4421-8105-7e56bba3ac9c","text":"Pre-existing disinformation narratives and documented propaganda techniques had been actively denigrating Ukrainian refugees across Europe since 2022 (e.g., claims that refugees are violent or criminal)."},{"id":"9fedbf3b-a1f8-43c1-a02f-d7906d208ace","text":"Rise of anti-Macron / far-right political sentiment in 2024 (EU and national election results and commentary)"},{"id":"15d90801-1802-47bb-85d8-7cf0a6dadba7","text":"WHO-China Joint Mission report (final report) published, summarizing early clinical findings and noting the role of underlying conditions and comorbidities among severe COVID-19 cases."},{"id":"60ef0746-59f8-4545-b93a-25210ec76915","text":"Mass issuance of Russian passports to Crimea residents after annexation, with many seen lining up to exchange Ukrainian passports for Russian ones"},{"id":"ee2b5dde-c6a4-44e6-91e9-f790e10f5c1a","text":"Media reports of waning Pfizer vaccine effectiveness from Israel (mid\u20112021)"},{"id":"6b276ef2-2523-4c59-9fa1-fd01456deefd","text":"Human Rights Watch report on unguided rockets and civilian harm in Donetsk"},{"id":"a455b48b-d608-4d35-8e42-fb15238e3c1e","text":"Operation Protective Edge (Israel\u2013Gaza), heavy photographic coverage of urban shelling"},{"id":"36551982-daa0-4a06-9ce2-7a5b46b08a44","text":"UN OHCHR published reports documenting thousands of civilian casualties and human-rights violations in Donetsk and Luhansk since 2014"},{"id":"531512c9-2ff0-45a1-94e5-5f41bd786ffa","text":"Government of Ukraine lodged an Article 12(3) declaration accepting ICC jurisdiction over alleged crimes on its territory (covering events since February 2014)"},{"id":"3042955d-53a1-4769-a6b6-37d95536e374","text":"International Criminal Court opened a preliminary examination into the situation in Ukraine"},{"id":"0c0c7555-4cc9-4ac2-8d94-c6de26942ea5","text":"Multiple U.S. states sought to restrict or suspend abortion services as \'non-essential\' during COVID-19 emergency orders (March\u2013April 2020)."},{"id":"1746fc40-2a42-4e97-a0c1-37b0a4e68a4a","text":"Guttmacher Institute releases \'Abortion Worldwide 2017\' report estimating ~55.9 million abortions per year (2010\u20132014)."},{"id":"501e49c3-266a-4a6b-a595-bcbb93614985","text":"World Health Organization declares COVID-19 a pandemic (March 11, 2020)."},{"id":"a2d84b93-0df4-4e63-9670-f3d9a9a9dc14","text":"European Court of Human Rights applied urgent interim measures (Rule 39) in the Ukraine v. Russia matter (13 March 2014)"},{"id":"064c16c3-68f4-41b1-be9e-990d256b0466","text":"PACE (Parliamentary Assembly of the Council of Europe) suspension of the Russian delegation (10 April 2014)"},{"id":"e72daad4-3b24-4846-a74e-4a1d8b895eda","text":"Public confusion about the ECHR\'s mandate versus courts that decide territorial sovereignty (March 2014)"},{"id":"c70dff2c-a58e-47a1-af56-83c11341163f","text":"Heightened political polarization and emotionally charged Victory Day (May 9, 2014) events in Kyiv, with veterans, Communist Party contingents and pro-Russian demonstrators present."},{"id":"3bb8debd-6d9d-416a-9f04-208936f4533a","text":"Regulatory enforcement and warning letters by FDA/FTC in 2021 highlighted widespread illegal disease/treatment claims in supplement marketing."},{"id":"351498c8-2a08-49fa-b6ac-4c644436ffe6","text":"Reports of foreign fighters travelling to Donbas in 2014 (volunteers from Europe and beyond)."},{"id":"cbb7f4ca-acb8-4b3e-a9d2-1cc7a9064d6d","text":"U.S. convictions of former Blackwater guards (October 2014) renewed media attention on private contractors\' misconduct."},{"id":"448455c0-dec0-4c30-9c5f-aab743506784","text":"Nisour Square massacre: Blackwater contractors opened fire in Baghdad, killing civilians."},{"id":"9d0098f8-dd9a-46f3-84b1-d414eaa77b49","text":"Heavy fighting and shifting control in Mariupol, May\u2013June 2014 (city taken and later retaken during the Donbas conflict)."},{"id":"03fc25c8-6565-4956-b018-43689aad9c23","text":"Russian and pro\u2011separatist media claims in 2014 alleging American mercenaries operating in eastern Ukraine."},{"id":"6d0467df-7983-4515-ac57-1f12a57ca12b","text":"Interview in Berliner Morgenpost where Poroshenko made a nuanced comment about sanctions during an official visit to Germany (covered 2 Feb 2017)"},{"id":"251313a8-e1f4-418f-b7ec-999fc0fb8382","text":"High\u2011profile cases of Ukrainian artists (e.g., Ani Lorak) continuing to perform in Russia after 2014 and facing public criticism (documented controversies and petitions in 2014\u20132015)."},{"id":"5e82075f-1456-452c-aa6b-fdc95e1abdbf","text":"Publicised blacklists, bans and ambiguous records of cross\u2011border performances (e.g., compilation lists and public debates about banned performers from 2014\u20132015)."},{"id":"5fceb450-5102-4bbc-9eb7-6c8ec2ddac81","text":"Deadly Maidan shootings and clashes (Feb 18\u201320) with widespread reporting that Berkut units used lethal force"},{"id":"4de30eb0-80c4-47bc-aef3-b0084f707f82","text":"Ukrainian government announced disbandment of the Berkut special police unit"},{"id":"7ff40f6e-eaec-4880-9537-3c9b00bbca5b","text":"WHO published its COVID-19 excess mortality estimation methodology and model outputs (October 2021), highlighting gaps between reported COVID-19 deaths and modelled excess deaths across countries."},{"id":"3a076af1-11af-418f-aa40-3c6fa44ee4d0","text":"Divergent national blood-donation guidance on post-vaccination deferral times (e.g., NHS/Blood Services clarifying differences)"},{"id":"3095f1fa-376e-45ba-be02-3c582ac40c20","text":"Reports of vaccine vial contamination (e.g., Japan suspended use of some Moderna lots after foreign particles found)"},{"id":"0be4bc5c-7b5a-4ef4-a8d4-07615ddc8057","text":"Documented frequency of climate-skeptic segments on major cable/news programmes (analysis of Fox News coverage up to May 2021)"},{"id":"175cfdfb-482b-40b7-841b-1ab0f30b4ad4","text":"IPCC Sixth Assessment Report (AR6) Working Group I release and media coverage"},{"id":"dc0c35f8-e154-4f77-9985-1c9b26049328","text":"Release of CDC v\u2011safe pregnancy registry supplemental tables and data used in the NEJM report"},{"id":"2332057b-0bbe-47b7-b70a-de96fc18e69c","text":"Publication of NEJM \'Preliminary Findings of mRNA Covid-19 Vaccine Safety in Pregnant Persons\' (Shimabukuro et al.)"},{"id":"2e1d7402-b82b-4b0a-9fb9-326fef12586b","text":"FDA full approval of Pfizer\u2013BioNTech vaccine (Comirnaty)"},{"id":"1046d912-9eb5-473e-b1e3-e44a58d9efc5","text":"FDA expands emergency use authorization to adolescents (ages 12\u201315)"},{"id":"20687b4c-4568-43d0-a364-3e7b62415b93","text":"HHS General Counsel Advisory Opinion clarifying PREP Act scope"},{"id":"f90c99fb-0f68-4211-8cea-f680b42202d2","text":"NATO deployed Enhanced Forward Presence battlegroups to Estonia, Latvia, Lithuania and Poland"},{"id":"ebed6d47-3655-4cdb-9e0d-3e4b8b5250f4","text":"Operation Atlantic Resolve rotations \u2014 U.S. armored and aviation rotations to Poland (2019)"},{"id":"8917d070-5d0c-4de1-956f-8133fb84f3b3","text":"Trident Juncture 2018 \u2014 large NATO exercise in Norway with ~50,000 participants, aircraft and ships"},{"id":"951a6889-48e1-4ae7-9de3-f25591fa9d6b","text":"Preprints and analyses estimating low infection fatality rates (IFR) from early seroprevalence data (John Ioannidis seroprevalence analysis, May 2020 preprint)"},{"id":"18930930-1a7a-4b78-b149-ff1350f161e4","text":"Historical precedent: 1976 swine\u2011flu vaccination program and Guillain\u2013Barr\xe9 reports"},{"id":"624a8794-6072-4c14-b064-3cd0f7176f27","text":"Professional guidance discouraging routine MTHFR testing (ACMG practice guideline)"},{"id":"ca820777-5138-42b0-83f8-a271af01a0d5","text":"Peer\u2011reviewed 2020 paper (Mesnage et al.) reporting glyphosate effects on the gut microbiome / shikimate pathway"},{"id":"c41b52a3-cc15-4d6a-a1f7-a2b34b2bbbf9","text":"President Zelensky announced draft legislation proposing a route to Ukrainian citizenship for foreign fighters"},{"id":"9353fc2d-ebee-4790-a39e-97f99d698f2c","text":"Ukrainian Defence Minister Rustem Umerov interview saying Ukrainian men living abroad would be asked to report to recruitment offices"},{"id":"d13c190d-6b0f-4280-82c0-547610a559a4","text":"Establishment and publicity around Ukraine\u2019s International Legion and the large number of foreign volunteers since Feb 2022"},{"id":"91b4971b-0ca4-497f-b743-324a75fb24ec","text":"German Justice Minister Marco Buschmann public comments that Germany will not force Ukrainians in Germany to return or serve for Ukraine (Welt interview referenced)"},{"id":"05a8230a-9e18-47f4-a599-5a2e22951aa4","text":"Large multinational naval exercise Sea Breeze took place in the Black Sea (Sea Breeze 2018 concluded July 17, 2018), increasing military activity and public attention on the Black Sea/Crimea security situation."},{"id":"5d26cae6-70ae-4538-bffb-13c8cfdd12d3","text":"Deputy Information Minister Emine Dzhaparova spoke at a round table titled \u2018Returning of Crimea: the vision of Ukrainians\u2019 and said Ukraine must be prepared for different scenarios to reclaim Crimea (ambiguous phrasing about readiness)."},{"id":"d929b334-9fdd-4c58-a430-ec532b3d7d49","text":"Nationalisation of PrivatBank, Ukraine\'s largest lender (government takeover announced/implemented)."},{"id":"4b497d85-1ab7-4531-878e-a50a0bcdacd6","text":"S&P and other agencies moved some Ukraine instruments toward default status after missed payments on GDP\u2011linked securities in mid\u20112015."},{"id":"a02608af-40bb-43d5-8e01-4571f9e25918","text":"Moody\'s downgraded Ukraine\'s sovereign rating to Ca amid debt-restructuring talks."},{"id":"e13fe5cc-b563-4cc5-b79a-229ae44115f0","text":"American Journal of Medicine publishes McCullough et al., \'Pathophysiological Basis and Rationale for Early Outpatient Treatment\' (includes discussion of hydroxychloroquine)"},{"id":"137c3a2c-b285-4f79-9f8e-668e81a104a3","text":"High-profile political promotion of hydroxychloroquine (notably President Trump) in March\u2013April 2020"},{"id":"5682313f-865a-458f-8e62-452d573278ed","text":"Pope Francis\u2019s earlier controversial \'white flag\' remarks (widely discussed in March 2024)"},{"id":"50e0fbe0-6c0d-4be2-b076-f81b92f1837c","text":"EU visa\u2011free travel for Ukrainian citizens comes into force"},{"id":"a4320de0-a712-485f-abda-679489aa1b6c","text":"World Bank Ukraine Economic Update highlighting market and price pressures (Spring 2017)"},{"id":"0f7061b6-6043-4410-b704-61d7dd78a521","text":"Publicly available cost\u2011of\u2011living/grocery index comparisons (Numbeo 2017 country rankings)"},{"id":"d154989b-b1ce-4814-bd5b-a69ca1172f9a","text":"Provisional application of the EU\u2013Ukraine Association Agreement (DCFTA) reducing trade barriers"},{"id":"7c2c28be-6cfa-4db3-8b1e-6de54c0cc24d","text":"Ukraine installed a temporary dam and flow-control measures near Kalanchak in summer 2014 to block the North Crimean Canal."},{"id":"44da0a37-f82c-4cad-bfe5-e204c1db5323","text":"\u62A5\u9053 and explainers in 2014 noting Crimea previously relied on the Dnipro (via the North Crimean Canal) for up to ~80\u201385% of its freshwater, creating an acute water-security crisis when the canal was blocked."},{"id":"53494bc0-80d7-4d7e-96ba-5759ddcd5040","text":"Historical wartime precedent: strategic destruction or manipulation of Dnieper/Dnipro dams (e.g., demolition of Dnieper infrastructure during WWII) documented in historical and reference sources."},{"id":"fe17246d-1e8c-4742-998a-439fed22ca9a","text":"U.S. House Science Committee and partisan media attention to NOAA\'s 2015 study and whistleblower allegations (2017)"},{"id":"e8eb66b4-7cc2-4c98-9599-381d976cafd3","text":"ICRC and Ukrainian Red Cross facilitated large evacuations from Sumy (joint operations to move civilians out)"},{"id":"f07a5bb2-52e0-4447-921c-e5afec933df2","text":"Red Cross convoy to besieged Mariupol turned back and postponed evacuations after being unable to reach the city"},{"id":"f7a81fa7-f979-436f-8060-bb1009d450bc","text":"VAERS is a public, passive adverse\u2011event reporting system (established 1990)"},{"id":"738d2afd-7833-497f-8017-f2aabab1b1a4","text":"U.S. measles outbreak (highest cases in 25 years)"},{"id":"8fd28181-b001-45e4-9ee3-ed5e32911dcf","text":"NOAA reporting and headlines on record atmospheric CO2 milestones (Mauna Loa surpassing ~410 ppm) in 2019"},{"id":"65cee6b7-dc37-42c9-8eed-7fba599b7d7e","text":"Ukrainian government files bill to make \'Glory to Ukraine \u2014 Glory to the heroes\' the official military greeting (bill No. 7549 registered)"},{"id":"e5178884-c3bd-49ae-b6c3-45172799ae66","text":"Public debate and media coverage about the historical/political meaning of \'Slava Ukraini\' (discussion of its origins and politicisation)"},{"id":"9697d1ed-6eb3-4678-ba13-e0e4ce60c850","text":"Amnesty International report on abuses by the Aidar volunteer battalion operating under Ukrainian command"},{"id":"098bcd9d-ddf1-4c65-b0fc-34b8bea61b74","text":"OSCE SMM Daily Report recorded outgoing artillery fire from government-controlled Svitlodarsk"},{"id":"80eae812-9302-4821-b61e-1bdd4f3addec","text":"OSCE SMM documented fresh craters near a Ukrainian Armed Forces compound in Sartana assessed as caused by MLRS rounds fired from the south\u2011south\u2011east"},{"id":"23224cad-e128-4f5a-a52e-22a839d6851d","text":"OSCE SMM reports noting the Mission was denied access on multiple occasions by Ukrainian Armed Forces personnel"},{"id":"109456e7-36bb-4930-9d93-ea01d1f2c8af","text":"NIA-AA (National Institute on Aging\u2013Alzheimer\'s Association) issues revised 2011 diagnostic framework introducing \'preclinical\' and biomarker-based stages of Alzheimer\'s disease."},{"id":"5d6028ad-e08a-4e90-a37d-73ad42daa692","text":"FDA narrows Emergency Use Authorization for COVID\u201119 convalescent plasma to \'high\u2011titer\' units"},{"id":"91f9f092-8711-4eec-8493-04025fd5e3c9","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan"},{"id":"acdbdbb6-8f0c-4877-9f47-0cffb856d645","text":"Scientific and public messaging on which antibodies vaccines induce vs. which antibody tests detect (spike vs. nucleocapsid)"},{"id":"af2cd870-1bfd-4c78-8511-26fb2be73bd3","text":"Early New York State antibody study publicity suggesting many more infections than confirmed cases"},{"id":"2f77db8a-bdb2-4505-bafa-638be4613c24","text":"Presidential election day (Ukraine) \u2014 March 31, 2019 \u2014 heightened political tension and information flows around polling stations."},{"id":"282392b6-8e67-4518-bf69-6d86fe0553bd","text":"Zaporizhzhia local authorities moved to implement the 2012 regional-language provisions (local implementation granting Russian regional status)"},{"id":"a082ac54-2c02-41a7-ac77-27b198d48fa6","text":"Vladimir Putin and Russian officials publicly labelled the post\u2011Maidan Ukrainian authorities \'fascist\' and repeatedly evoked Nazi-era language (Putin speech on Crimea)"},{"id":"ff0e6625-2708-48a0-a9cf-76e34d20b270","text":"Reporting on far\u2011right groups (Svoboda, torchlit marches) and far\u2011right figures appearing in the Maidan period"},{"id":"de7c7a6e-0670-4c9f-aaba-f57baab5ab18","text":"Danish Defence Minister publicly notified parliament that Denmark will significantly reduce its military support for Ukraine in 2026 (planned allocation cut to DKK 9.4 billion)."},{"id":"a928cfbf-3c70-4ff1-a75c-c403bb49867c","text":"Danish government publicised the multi\u2011year \u201CUkraine Fund\u201D and large cumulative commitments to Ukraine (multi\u2011billion euro/kroner pledges across 2023\u20132028)."},{"id":"c356e4eb-e27d-4a3e-abe8-009c48fde26a","text":"Official Danish Ministry of Defence material and public briefings documented multiple high\u2011profile equipment donations (F\u201116s, tanks, air\u2011defence, coastal missiles and other packages) and ongoing deliveries through 2022\u20132024."},{"id":"16612cfd-8068-41f7-8172-2f740d431c9e","text":"Analysts and media highlighted that non\u2011state\u2011party countries (e.g., India) are not legally bound to arrest ICC indictees"},{"id":"a555c8b9-1afa-4f97-b4dc-4481e73cbc26","text":"International Criminal Court issues arrest warrants for Vladimir Putin and Maria Lvova\u2011Belova"},{"id":"8d221e15-abaa-4b86-bcd8-6c8f3992df82","text":"Donetsk People\'s Republic leader Denis Pushilin announced DPR/Russian forces aimed to encircle Mariupol"},{"id":"35abddd0-8c9c-4eac-8f42-8331b2dc89b2","text":"Russian troops entered the centre of Kherson and local officials reported rapid Russian advances"},{"id":"fc2341a7-a527-42d8-9b4e-47a15bdee23c","text":"Reports and rapidly circulating images/videos showed Mariupol under heavy shelling and effectively blockaded by early March"},{"id":"c3c8f8e1-9283-4b90-97ed-3ac662aafa45","text":"1979 U.S. Supreme Court decision (United States v. Rutherford) upholding federal restrictions on interstate shipment of laetrile"},{"id":"5331b603-f4f9-4c0e-8c5f-004eb0a84c42","text":"Publication of major clinical evaluations showing no clinical benefit and cyanide risk (e.g., Moertel et al., NEJM clinical trial 1982 and later systematic reviews)"},{"id":"f1f95a39-34bc-46b6-8e23-9f376df7ccce","text":"Reports that around 1,000 Ukrainians had contacted the embassy in Israel seeking help"},{"id":"459611c4-0b55-4923-91d6-d7adcad302d1","text":"Hamas attack on Israel triggers widespread conflict and civilian displacement"},{"id":"3f8fdb93-471b-47ba-b68a-64e3317ebb5f","text":"Mixed early reports about evacuation status: embassy statements that evacuation planning was underway alongside reports of delays"},{"id":"007f723c-0723-48e4-b50f-8d0dfe461ddb","text":"Widespread Russian dehumanizing propaganda portraying Ukrainians and Zelensky as \'monstrous\' or \'cannibalistic\' figures"},{"id":"3f95d40a-106b-42a7-89f1-14b558e7a54f","text":"WHO names \'vaccine hesitancy\' as a top global health threat (2019)"},{"id":"373910f6-e433-4432-8fd1-36130b42aa58","text":"Publication of high-profile scientific reviews and discussions about aluminium adjuvants (e.g., 2018 Nature review)"},{"id":"c4ba973e-5883-4b1a-b720-9168a9331158","text":"1999 US recommendation to reduce/eliminate thimerosal (a mercury-containing preservative) from childhood vaccines"},{"id":"bc88db62-48ed-4917-9bb5-a865c3d0db76","text":"Prominent climate scientist Michael E. Mann publicly stated that climate change worsened Hurricane Harvey in opinion/commentary and interviews."},{"id":"5288810b-8f88-4c33-a5e1-554dc6f37a57","text":"General Medical Council (GMC) found Andrew Wakefield guilty of serious professional misconduct and struck him off the medical register."},{"id":"d55a0a6c-e4ad-4aeb-9e20-2b8b02de62c6","text":"FDA issued Emergency Use Authorization for the Pfizer\u2013BioNTech COVID\u201119 vaccine"},{"id":"036b26ef-e527-40b6-ac69-92cd098d5a15","text":"Japan suspended and recalled multiple Moderna vaccine batches after contamination reports"},{"id":"0c565dd5-edf4-4578-986c-6641418f5db6","text":"FDA VRBPAC briefing document noted median ~2 months safety follow\u2011up for Pfizer Phase 3 participants"},{"id":"65eb6438-fe45-4492-b34b-a62197cf6a90","text":"CDC updated guidance allowing fully vaccinated people to resume many activities without masks"},{"id":"5708038d-77b5-4d13-a3e0-17bf63cb3747","text":"Sen. Ron Johnson and allied events highlighted raw VAERS report counts in hearings/press conferences"},{"id":"b8e1aa44-e0a9-4ac8-84c4-9b8d11ecc023","text":"Publication of a Johns Hopkins patent application / patent covering an enhanced mebendazole polymorph (polymorph C) claimed to improve tumor delivery."},{"id":"334e0219-555f-4c2a-9e39-8bf18a633bfc","text":"Publication of a widely-cited review \'Ivermectin, a potential anticancer drug derived from an antiparasitic drug\' summarizing in vitro and mechanistic evidence that ivermectin can affect cancer pathways."},{"id":"27059d4c-ff52-4e1d-be06-22d58f3310cb","text":"Registration and start of a human clinical trial (ClinicalTrials.gov NCT05318469) testing ivermectin in combination with immune checkpoint inhibitors (balstilimab or pembrolizumab) for metastatic triple\u2011negative breast cancer (trial start listed Oct 13, 2023)."},{"id":"c3bdd91c-c749-452e-9569-4a2f9ae816b5","text":"International attention and IOC intervention after Kharlan\'s disqualification (IOC awarded her Olympic qualification spot)"},{"id":"465078fd-c082-499c-a845-cc0d9d17870a","text":"Olha (Olga) Kharlan disqualified at World Fencing Championships after refusing to shake Russian opponent\'s hand"},{"id":"64c5c7aa-d736-4d89-ae48-bfbe4db56db1","text":"Brighton Beach \'Victory Day\' parade with visible Russian flags and veterans in Brooklyn"},{"id":"1ad1da71-c024-4520-94ef-d41f9192778d","text":"Small anti\u2011war/anti\u2011intervention rallies in Washington where some attendees praised Vladimir Putin (reported by U.S. outlets in 2015)"},{"id":"8e768813-5b66-4e37-83ec-123e5540c0d2","text":"NATO\'s Enhanced Forward Presence (eFP) battlegroups deployed to the Baltic states and Poland (2017)."},{"id":"debe366f-8ffa-4a17-a0ef-0aee5ed2f924","text":"Sea Breeze multinational naval exercise in Odesa and Black Sea (Sea Breeze 2018)."},{"id":"cf99a0ac-603e-44ac-ae2e-09dda24cbbfd","text":"Documented presence of foreign volunteers/foreign fighters in the Donbas conflict (2014 onwards)."},{"id":"ccbb31ba-c8f7-4e64-8d55-3478e29a9482","text":"Repeated Russian accusations and official statements alleging NATO or Western troops were operating in Ukraine (and NATO rebuttals in 2014)."},{"id":"337fa8d2-b644-433d-b4e8-bdefe78aa9cf","text":"Rapid Trident multinational exercise held in Yavoriv, Ukraine."},{"id":"cf62689b-6516-4810-8e42-520e8a51af3e","text":"G7 Science Academies statement: \'Future of the Ocean\' highlighting ocean acidification (G7, April 2015)"},{"id":"12665c7c-4759-4bff-8dd9-6ffe68c66a7e","text":"Oregon State University / NOAA-linked study on oyster hatchery failures attributed to ocean acidification"},{"id":"f4b0e001-14ea-4e19-9fd3-d2673261ef60","text":"Ukraine enacts anti\u2011collaboration legislation (Article 111\u20111) criminalizing cooperation with an aggressor and occupation administrations."},{"id":"589cf6ad-04e0-4e4e-823a-bb0feaeeec39","text":"Administrative changes and practical disruptions to social payments (pensions) for residents in temporarily occupied territories (procedures changed and payments routed to bank accounts; suspension rules existed if no receipt for months)."},{"id":"e175e96e-c4ee-4119-a591-68c65331d271","text":"High\u2011profile arrests/prosecutions for \'collaboration\' (example: Reuters report of an MP arrested on suspicion of collaborating with Russia)."},{"id":"f228463b-3209-4ab5-b4b1-b2e7c7ef4fa7","text":"Reports of Russian control and disruption of communications in occupied areas (e.g., Russia rerouting/shutting down Ukrainian internet in Kherson and other occupied territories)."},{"id":"65c93c29-c19f-4bfb-adce-c6ff88be5baf","text":"Earlier precedent of arrests and accusations of \'sabotage\' in eastern Ukraine (April 2014): Ukrainian authorities detained suspected plotters in Luhansk."},{"id":"79a8797d-4911-444f-adbd-25112da20ee6","text":"Reports of chaotic security conditions in Luhansk during 2014 (sieges, captures of observers, clashes) documented by international media and monitors."},{"id":"17c165a7-f46b-434b-b40d-59beec4cf8f0","text":"U.S. Supreme Court upheld a federal ban on interstate shipment of laetrile (Amygdalin/\\"Laetrile\\" regulation upheld)"},{"id":"6bc80891-f4c9-43ca-83b2-d406d3cced6e","text":"EFSA scientific opinion and public statement on acute health risks from cyanogenic glycosides in raw apricot kernels"},{"id":"52a4d931-645e-4f35-b15b-21d72e941182","text":"N Engl J Med clinical trial (Moertel et al.) showing no anticancer benefit for amygdalin/Laetrile and reporting toxicity concerns"},{"id":"9371a93f-f012-48ac-a32f-1459138040b5","text":"Peer\u2011reviewed measurement study showing non\u2011zero scattered dose to the thyroid during mammography and that specialized collars reduce that scatter (but concluding routine collars are not mandatory)"},{"id":"1d81f6e5-45a5-4b20-82c9-3a1c00a30b73","text":"Pandemic\u2011related declines and disruptions in cancer screening and care were reported widely in 2020\u20132021"},{"id":"8fee9afa-94f1-4d3b-b00b-698f144156eb","text":"Court decision and transfer of seized Russian-owned ammonia to Odesa Portside Plant for safekeeping after seizure by Ukrainian authorities."},{"id":"d974f925-7d5b-4af9-b23c-9339c4d670e2","text":"Russian-backed separatists reported an ammonia leak after alleged Ukrainian shelling of a brewery in Donetsk, warning of a corrosive ammonia cloud and local evacuations."},{"id":"5d64db84-5725-45de-a4cc-af6f00b0de13","text":"Ukraine\'s intelligence accused Russia of rigging a Crimean chemical plant with mines that could release about 200 tonnes of ammonia, an allegation reported in international media."},{"id":"81cb26cc-7a20-435f-9938-82133fb91546","text":"Reports that the Togliatti\u2013Odesa ammonia pipeline was damaged during the conflict, with both Moscow and Kyiv trading blame for the disruption of large ammonia shipments."},{"id":"810c1c1b-61db-4b62-a549-c29cdde268e4","text":"EADaily publishes article repeating \'nearly 500\' protesters blocking central Kyiv street"},{"id":"b080216c-ca3d-4222-b50b-c56fcb284fb6","text":"On-the-ground situation was two small rallies and only a brief blockage (StopFake reconstruction)"},{"id":"b7cdada0-3565-44e2-89d4-19e85b983dfa","text":"United Nations reported \'persistent and grave\' human rights violations in eastern Ukraine, including civilian deaths from shelling (June 2015)"},{"id":"53901b4c-be30-4b13-9f82-7cfead29a8ad","text":"Bus-stop shelling in Donetsk that killed multiple civilians, widely reported and investigated by OSCE"},{"id":"6bf7b171-73de-4735-b6ae-d178c397473c","text":"Public health guidance (CDC/WHO) acknowledging limited data for infants and urging discussion between breastfeeding mothers and healthcare providers (CDC: COVID\u201119 vaccines while pregnant or breastfeeding guidance)."},{"id":"c66b4692-19b9-41a5-a090-ccb6f50a7e2a","text":"Large street brawl in Kolonaki (central Athens) involving Dynamo Kyiv supporters, with 18 people detained"},{"id":"550b2a2d-7bd6-4a73-9e39-0824d7ae2d79","text":"Well-known past violent incidents involving Right Sector (e.g., Mukachevo shootout where Right Sector members exchanged fire with police)"},{"id":"1f7261c4-80f3-49e0-af1b-986a26c89dd7","text":"IPCC Fifth Assessment Report (AR5, WGI) Summary for Policymakers published with cautious language on extremes, noting low confidence in long-term changes in tropical cyclone activity and stating current datasets indicate no significant observed trends in global tropical cyclone frequency over the past century."},{"id":"a5b7f496-f670-4373-ba88-6a8ab16932fa","text":"High-profile political moments and media amplification of single cold/snow events used to dispute warming (for example, Senator Jim Inhofe throwing a snowball on the Senate floor in February 2015)."},{"id":"82697b90-a087-4e35-b0f9-705fd9546781","text":"EU Emergency Trust Fund for Africa (EUTF) launched to address root causes of migration (Nov 2015)"},{"id":"7db588eb-ddae-490a-8882-0fbf8d168f6d","text":"EU\u2013Turkey statement (migration deal) committing EU funds to Turkey to manage refugee flows"},{"id":"1dd490f9-ca8a-40a7-bd5d-e3272082f00b","text":"Visa\u2011free travel for Ukrainian citizens to the EU came into force (June 11, 2017)"},{"id":"28580450-6272-4d02-9a2c-f19fc0a0cadf","text":"EU macro-financial assistance and broader aid packages to Ukraine after 2014"},{"id":"9fc21c98-7526-4b78-ae62-cd995e88e0a4","text":"2015 European migrant/refugee crisis with large arrivals to the EU"},{"id":"56840951-e957-4b40-8408-90e8fe903357","text":"UK government statement (June 19, 2023) to keep Russian assets frozen until Russia compensates Ukraine"},{"id":"699e06aa-9b2f-4b4f-9f76-95fc574a0ffd","text":"H.Con.Res.66 (118th Congress) expresses support for using reparations paid by Russia while urging the burden not fall on U.S. taxpayers"},{"id":"e10eaa2e-0fc1-44fe-af4c-61b04e674d8c","text":"Court orders and media coverage accelerating release of Pfizer vaccine trial and safety documents (judge ordered faster FDA disclosure)"},{"id":"9193020b-9629-4752-b592-6b6478600257","text":"Public reporting and CDC/ACIP discussion of myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination (young males)"},{"id":"9316f4cf-149d-4a01-bb74-cbc75ae143f7","text":"Contamination reports and suspension/recall of Moderna vaccine batches in Japan (August\u2013September 2021)"},{"id":"dbb3a021-512a-4c53-a16e-530b1fe8ca13","text":"Public reporting of reduced/negative vaccine effectiveness against Omicron infections (UKHSA/early 2022 analyses)"},{"id":"c51c441b-f875-4e14-b8a1-63786973cd3a","text":"In\u2011vitro report that Pfizer/BioNTech vaccine mRNA can be reverse\u2011transcribed in a human liver cell line (Ald\xe9n et al., Curr. Issues Mol. Biol./PMC)"},{"id":"37d9a2a5-ee4b-41f7-8007-1c62d3954975","text":"Russian bans and embargoes on Ukrainian imports (food and other goods) in 2014\u20132015"},{"id":"95fb97ff-0415-4bba-8c78-d0c21ca3e4e2","text":"Sharp national GDP contractions reported for 2014\u20132015 (double-digit annual declines in quarters)"},{"id":"9ec6a6f6-9490-4023-93e3-c850eb34c1f3","text":"Bilateral trade turnover between Russia and Ukraine collapsed (trade fell by around two-thirds in early 2015)"},{"id":"7124b769-715f-42dd-a1ef-40df517223f7","text":"OFAC Crimean Sanctions Advisory (July 30, 2015) clarifying prohibitions on goods/services from Crimea"},{"id":"f427e28d-21d4-4a63-a8a1-00ccd3887e93","text":"U.S. tariffs on steel and aluminum announced under Section 232 (March 8, 2018)"},{"id":"9ab78178-379e-4730-812d-2e5b680528b8","text":"Department of Commerce antidumping petition \u2014 Carbon and Alloy Wire Rod from Ukraine (March 28, 2017)"},{"id":"819dffb2-0572-4f90-92c6-c41eef6a76e0","text":"Exhibition of captured heavy equipment at the National Museum of the History of Ukraine in the Second World War (Kyiv) showcasing tanks and large vehicles"},{"id":"6d137a2b-7c97-41ae-95ba-3135144296c6","text":"High-profile 2014 coverage of private ownership and legal disputes over WWII German tanks (Panzer IV auction / Paul Allen dispute, Sept 2014)"},{"id":"65dc0e58-bf84-41b7-b9dc-c03b479517c1","text":"Publication of a peer\u2011reviewed rat study claiming prenatal exposure to Pfizer/BioNTech BNT162b2 produced \u2018autism\u2011like\u2019 behaviors in male neonatal rats."},{"id":"21a58d87-2911-4e0f-ac4e-1eab6d209d8e","text":"Rapid Trident 2020 multinational exercise at the Yavoriv training ground in western Ukraine involving thousands of troops, including airborne units"},{"id":"252a33a2-7596-4ebc-813c-cd41a36e4854","text":"Ukrainian Armed Forces reported 2,650 COVID\u201119 cases among personnel"},{"id":"65fad128-4613-43ff-b921-391965d5747a","text":"Norwegian reports of deaths in very frail elderly after Pfizer/BioNTech vaccination and subsequent national guidance to use caution in the most frail"},{"id":"2e82249f-7daf-4890-8ed1-8937ec73e255","text":"Peer-reviewed reports of an association between mRNA vaccination and rare myocarditis cases (Israel, large health\u2011care database)"},{"id":"aac50ae1-a885-4137-b384-62bb31844f54","text":"CDC and other agencies expanding booster recommendations and reporting reduced protection against infection over time"},{"id":"899e6a00-6f74-4b8e-a39f-40b710e636c9","text":"CDC release of early real\u2011world effectiveness and policy messaging on RSV immunization (CDC newsroom release on nirsevimab effectiveness)"},{"id":"c3447a89-06cf-43fa-8a0e-fbac8fce1614","text":"Russian seizure and loss of Ukrainian naval assets in Crimea (March 2014) weakened perceived Ukrainian naval capability"},{"id":"b835e906-d882-41eb-9501-c849698aac45","text":"Sea Breeze 2016 actually began on July 18 with US, NATO and partner forces participating"},{"id":"68b756d7-f0c3-4d46-94c9-32214154be65","text":"Russian forces install local, pro\u2011Russian administrators in occupied Kherson (Volodymyr Saldo appointed)"},{"id":"dd761619-d96b-428f-892c-73f53aa52d08","text":"Mass refugee flows and internal displacement from Ukraine in March 2022 (millions fleeing abroad or displaced internally)"},{"id":"5984d932-6e0d-489b-85b7-61da3f544b00","text":"Arrest of pro\u2011Russian politician Viktor Medvedchuk by Ukraine\'s security service"},{"id":"7d2a6301-1e44-4b4c-9a93-336484d1b689","text":"President Zelenskyy signs decrees blocking pro\u2011Russian TV channels and licences revoked"},{"id":"cce8b016-f0dd-402a-88fc-d8fbdd754c14","text":"Suspension and later bans of multiple pro\u2011Russian political parties in Ukraine"},{"id":"34a9fd8b-13bb-4d40-aaa2-c66e0122e71c","text":"WTO Panel report circulated in Ukraine \u2014 Anti-Dumping Measures on Ammonium Nitrate (panel report circulated 20 July 2018)."},{"id":"473cbecc-ca21-4835-9483-63711d14e0a1","text":"WTO dispute DS493 initiated/established (Russia files complaint; panel established 22 April 2016)."},{"id":"3c1dfdeb-f300-40f2-9032-3094fe4645c7","text":"Official recognition and investigation of rare myocarditis/pericarditis following mRNA COVID-19 vaccination (ACIP/CDC review)"},{"id":"bd37a9b0-e07b-448c-bd28-89d7129c468b","text":"CDC/FDA recommended pause on the Johnson & Johnson (Janssen) COVID-19 vaccine over rare blood clots"},{"id":"0692b4d7-b7aa-43b0-903f-54db8a567957","text":"Reports of deaths among frail, elderly Norwegian patients shortly after receiving COVID-19 vaccines"},{"id":"a6669dc9-5788-4322-affc-8536d6461d31","text":"World Bank Poverty and Equity briefs (published 2016) showing poverty rates rose sharply in 2014\u20132015 and remained a prominent policy concern."},{"id":"9207c4cc-83d3-4107-8881-63caee372452","text":"Transparency International Corruption Perceptions Index 2016 (published January 2017) showing Ukraine with a low CPI score and poor governance indicators."},{"id":"cc4063b3-4027-43d0-b1c9-66dd68822ae0","text":"IMF staff report (July 2015) documenting deep recession, large output losses, and a challenging recovery path for Ukraine."},{"id":"dd453d27-3f21-498c-84bf-f8587daa8696","text":"Sharp economic contraction and macro crisis in 2014\u20132015: GDP collapsed and the hryvnia plunged after the central bank allowed it to float (February 2015 reports)."},{"id":"55b1edd0-40e0-43cb-bcab-dd9c2b23313d","text":"OSCE thematic report on the impact of mines and unexploded ordnance (2018\u20132019)"},{"id":"33721b3a-5cdc-443e-8599-43e7d7955653","text":"Vladimir Putin had previously been named TIME\'s Person of the Year (2007), a well-known precedent linking Putin with Time magazine covers in public memory."},{"id":"f762beea-6bb1-4d3b-993d-f8e4bc97273b","text":"Study and media coverage showing Ukrainian refugees in some EU countries had to return to Ukraine to obtain abortions or contraception because of legal, cost and access barriers (Independent report, 18 May 2023)."},{"id":"fffa8076-beec-4801-9da0-5fd5da0a9ad7","text":"UN/OHCHR documented widespread conflict-related sexual violence (including rape) by Russian forces in occupied areas and published monitoring reports covering 2022\u20132023."},{"id":"8cfe2e5e-b34d-4b5f-ae79-3e932c830bf2","text":"Airstrike on Mariupol maternity/children\'s hospital (Maternity Hospital No. 3) that injured pregnant women and resulted in deaths and a stillbirth \u2014 widely reported with graphic images (attack on 9 March 2022)."},{"id":"bfd30f43-97af-4390-9f37-9bb404565a96","text":"EU launches \'Support Hub\' in Moldova to counter firearms trafficking and organised crime linked to the Ukraine conflict"},{"id":"221f03ad-dab7-49eb-b731-a3a3aa267d2a","text":"Photographs of abandoned military equipment, shells and weapon boxes found near Andriivka (April 12, 2022)"},{"id":"c6593794-fb12-4c9f-a31a-9bf8f3922e3d","text":"Publication of an Israeli nationwide surveillance study (Mevorach et al., NEJM) showing increased myocarditis incidence after the second dose, concentrated in young males (published Oct 6, 2021)."},{"id":"20a0b653-3a14-4146-a66f-02dc074c2da9","text":"Reports that Russia offered/organized evacuation routes from Mariupol that included routes into Russia (early\u2013mid March 2022)"},{"id":"2d712861-399b-43c7-94f1-2d30b47a4e13","text":"Abduction and detention of Melitopol mayor Ivan Fedorov (reported March 11, 2022) and pressure on local officials in occupied towns"},{"id":"13b4f8bd-1e4b-46c7-9f06-f8acb44b5eff","text":"Local occupation media and accounts in Kherson reported orchestrated or staged displays of support for Russian forces (early March 2022)"},{"id":"6e5270e8-581e-4a73-876e-199bffc453fe","text":"2014 measles outbreak in an under\u2011immunized Amish community in Ohio (large local outbreak tied to travel and low MMR coverage)"},{"id":"6e9b56c2-1846-4a98-a834-cc0f642212d2","text":"Publication of the peer\u2011reviewed study \'Low cancer incidence rates in Ohio Amish\' (Cancer Causes Control) reporting substantially lower cancer incidence in an Ohio Amish population (1996\u20132003)"},{"id":"4d71a58c-31b8-4ef3-96bb-15762eaa2eee","text":"Dan Olmsted\u2019s 2005 \u2018Amish Anomaly\u2019 reporting (Age of Autism / UPI coverage) claiming an unusually low observed rate of autism in Amish communities"},{"id":"45ebb88b-bf33-4fba-9eec-b607bc7fcfae","text":"U.S.-led coalition strikes in mid\u2011November 2015 destroyed scores/hundreds of ISIS fuel tanker trucks in north\u2011east Syria (widely reported Nov 2015)."},{"id":"069a2f64-e114-4ae3-b560-fee65a490053","text":"Russian General Staff publicly stated Russian air strikes hit Islamic State oil refining assets during its November 2015 campaign."},{"id":"cf25d15d-0e56-4196-8bd6-b1dd2623d721","text":"ISIS/ISIL militants deliberately set fire to oil fields and wells in 2015 (e.g., Ajil/Tikrit area, March 2015), producing widespread imagery of burning oil infrastructure."},{"id":"f56b635b-046a-4a07-a7a4-5dbed4e93211","text":"Hungary publicly refused to back an EU oil embargo, signalling a national veto risk"},{"id":"a2d5e081-969b-4ff8-bc6a-3147ec0b0e4f","text":"Gazprom sharply cut Nord Stream 1 gas flows in late July 2022"},{"id":"e32952af-965a-4a63-ba6b-a39cf2c81ff6","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly said EU sanctions on Russia had \'failed\'"},{"id":"f6b553c2-e6b2-4faf-9a69-26959b763881","text":"Reporting that worries about winter energy shortages and rising bills were eroding domestic support for sanctions"},{"id":"d720c73e-98a8-47f5-a0ac-7e558e0ca630","text":"YouGov polling shows public willingness to keep sanctions falls if they raise cost of living"},{"id":"741a9cb5-886a-4ac3-a0db-6fca78a7b9ac","text":"Publication of Scafetta & West (2007) paper estimating a large solar contribution to 20th-century warming"},{"id":"f0b094b1-7f25-47a8-9482-96e4884c43bd","text":"Nationwide Razumkov Center / Ilko Kucheriv Democratic Initiatives poll (fieldwork May 14\u201319, 2021) on attitudes toward Donbas and Russian aggression."},{"id":"a17c93dc-3520-401e-836b-e0f5271b501e","text":"President Volodymyr Zelensky\'s interview with foreign media (transcript published mid\u2011June 2021) in which he warned Ukraine may need to become a \'very strong, most powerful army in Europe\'."},{"id":"37e8e1cb-3b0a-4a97-ae1a-1e27ff54f208","text":"Earlier independent testing and reporting (2021\u20132022) found benzene contamination in sunscreens and other personal-care products, producing recalls and regulatory attention."},{"id":"b8af46a0-ca5b-496e-b89a-7bd1510de742","text":"News that IMF programme delays and conditionality were creating uncertainty for Ukraine\u2019s external financing in mid\u20112018"},{"id":"6c9c2bf7-38e2-471a-b041-0a9da2658639","text":"NBU\'s August 2018 Macroeconomic and Monetary Review noting global volatility and risk of spillovers to Ukraine"},{"id":"c2f3e630-f08f-47fd-b98a-fae1a6a78b87","text":"Reporting on contagion fears from Turkey\u2019s currency turmoil to other emerging markets"},{"id":"b7586629-3176-4504-9dae-01e07234abba","text":"Germany announced an initial reversal of its pre\u2011invasion restraint by approving shipments from Bundeswehr stocks (1,000 anti\u2011tank weapons and 500 Stinger missiles)"},{"id":"b973d87c-9102-4220-874e-88d661ccab11","text":"German Foreign Minister Annalena Baerbock publicly explained Germany\u2019s reluctance to supply arms, citing the country\u2019s WWII history (statement reported by Reuters)"},{"id":"ac87588b-bc99-4d48-8233-a5daf7fc1a53","text":"Swiss parliament votes in favour of several measures to tighten asylum policy (including proposals affecting temporary admissions and family reunification)"},{"id":"c489a63d-e632-4a3d-8efe-40552e4c6545","text":"Media reports (June 20, 2025) covering proposals and parliamentary initiatives suggesting Switzerland \'may end\' or \'revoke\' S protection for Ukrainian refugees"},{"id":"ba122ebc-29b7-4ac8-b2ae-a36bb297bce4","text":"Federal Council decision (Nov 2023) to extend temporary protection status \'S\' for Ukrainians (clarifying it was provisional and subject to later review)"},{"id":"8fedb62c-7243-4ccc-9df8-dad2d50416e5","text":"Euromaidan \'Heavenly Hundred\' killings and makeshift morgues"},{"id":"8ffbe2bc-3e02-4c4d-bc44-4f503c12fad3","text":"Odessa Trade Unions House fire and deaths"},{"id":"049c387f-d38b-493e-80c0-9209a0fc42ec","text":"German police reported a rise in anti-Russian attacks and politically motivated assaults"},{"id":"f404d690-a7bd-4f1c-a5e0-7f1735b9720c","text":"Large pro-Ukraine demonstrations and visible Ukrainian refugee presence in German cities"},{"id":"f7cf7d1c-ea4a-4708-a6f4-9f7fee9cdaba","text":"Frontiers / parasitology commentary (2022) and coverage highlighting patient-driven helminth/\\"worm therapy\\" experiments and unregulated self\u2011treatment"},{"id":"d7ba524a-1bbd-40da-96de-92ca7fdcf38a","text":"Major regulatory and media attention as U.S. agencies granted inspection/clearance for cell-cultivated meat products (June 2023)"},{"id":"6204f81c-dfd9-47d7-8753-4c2c8239bd26","text":"Industry disclosures and patent filings describing immortalization approaches for commercial cell lines (publicly cited in literature)"},{"id":"33a0e312-cbc6-4d2b-96b2-ab0d852134dd","text":"Parliament approves TV language quotas requiring major channels to broadcast ~75% Ukrainian content"},{"id":"851fc306-2f78-48f7-b113-7dce1164a69d","text":"Revocation of the 2012 \'Kivalov\u2013Kolesnichenko\' regional language law (removing legal regional status for Russian in some areas)"},{"id":"43f76c7d-f08f-461f-a904-091ec5f12488","text":"Passage of Ukraine\'s \'Law on Education\' (affecting language of instruction)"},{"id":"3e950ab0-2b39-43ff-9a5f-062a36c00af9","text":"Presidential decree to block major Russian websites and social networks (VKontakte, Odnoklassniki, Yandex)"},{"id":"3e3750ac-2b6b-430a-aa67-2bfc15bcfa67","text":"Ban on import/distribution of 38 Russian books (listed as promoting \'hate\' or \'separatism\')"},{"id":"6323d3ca-f688-48d5-9fab-83b587579296","text":"UNEP/Ozone Secretariat and related press releases in Oct 2019 emphasized that the ozone layer is \'slowly healing\' and that the Montreal Protocol has been effective."},{"id":"9150a81d-6528-4275-b8a8-a9a1706e24bf","text":"NOAA and NASA announced that the 2019 Antarctic ozone hole was the smallest on record (annual peak extent), attributed in part to unusual stratospheric warming."},{"id":"8d625518-abdd-441a-b740-7b507d8c73e8","text":"UN/OHCHR reporting of thousands killed in eastern Ukraine (2014\u20132015)"},{"id":"aa7f6c28-3a60-47d1-9301-c2ced8a6c136","text":"Defense and fall of Donetsk International Airport (\'Cyborgs\') with heavy casualties"},{"id":"d33b5e59-6951-4a55-90d5-de0ad14275bd","text":"Battle of Avdiivka \u2014 intense frontline fighting and elevated casualties"},{"id":"36f28729-fe34-4e6d-b99e-ee9fcaa7c05f","text":"Battle of Debaltseve and Ukrainian withdrawal under pressure"},{"id":"1c7cedb5-74a3-41a2-82f3-ff92f5641ead","text":"Reports of Ukrainian sailors being pressured to take Russian oaths or detained during Crimea takeover"},{"id":"97979628-3420-44ec-aef8-12b24f583328","text":"Tense stand\u2011off aboard blockaded Ukrainian ship Slavutych in Sevastopol where crew resisted takeover"},{"id":"41966921-2f3e-42bb-b09a-495a25971795","text":"NOAA/NCEI released a major update to its global surface temperature dataset (NOAAGlobalTemp update) that changed historical coverage/adjustments."},{"id":"6ed59500-2ddc-47f5-ba2d-8ade023152f5","text":"UN Human Rights Monitoring Mission reports on conflict-related killings and impunity in Donetsk and Luhansk"},{"id":"e270824c-080c-4953-bf30-6c931abd61b9","text":"European Parliament adopts \'Importance of European remembrance\' resolution condemning both Nazi and Stalinist crimes"},{"id":"d4bdac66-4616-4c2f-83ac-7682a496fc28","text":"Lviv Oblast declares 2019 the \'Year of Stepan Bandera\', prompting protest from Israeli and Jewish groups"},{"id":"aec337db-26f4-4278-88a8-00eeb563ef5c","text":"Ukraine passes \'decommunization\' laws banning communist symbols and reshaping public memory"},{"id":"91edbaa3-c938-4cc3-b2ce-252d3114fae5","text":"UN/OHCHR reporting on detentions, security operations and use of anti\u2011terror measures in eastern Ukraine"},{"id":"0118ddd2-f152-417d-9b54-05cf86103a1c","text":"Sanctions and regulatory restrictions targeting Crimea after Russia\'s 2014 annexation (EU/US measures from June 2014 onward)"},{"id":"510ee834-19fd-41ef-8d4f-43d524c50082","text":"Media and veterinary reporting in 2022\u20132023 documented increasing use of cholecalciferol (vitamin D3) in commercial rodenticides and clinical cases of cholecalciferol poisoning in pets and wildlife."},{"id":"33969a83-f98a-4002-9274-f3c13ff9c373","text":"Hawaii law banning oxybenzone and octinoxate in sunscreens (signed 2018; implementation and attention into 2020\u20132021)"},{"id":"915748ad-4a99-4921-9200-7ad0f63b3634","text":"Johnson & Johnson voluntary recall of specific Neutrogena and Aveeno aerosol sunscreens after detecting low levels of benzene"},{"id":"88fa7a1e-fec4-4e4e-a036-e28471e1785b","text":"2004 Mutat Res study finding dihydroxyacetone (DHA, active in sunless tanning) causes DNA damage, cell\u2011cycle arrest and apoptosis in cultured keratinocytes"},{"id":"3372e7b2-3af6-403b-9533-ca3f0f2e242b","text":"Large Russian military exercises near Europe (e.g., Zapad 2017)"},{"id":"c5ef65de-3e9a-4d95-b685-671192868f4d","text":"Kerch Strait incident \u2014 Russia seized Ukrainian naval vessels"},{"id":"d86844d0-23a9-4b88-8229-737a1ccab748","text":"Minsk II ceasefire agreement (and its incomplete implementation)"},{"id":"cdcc4cb5-2bec-4805-9a7f-cd3173409efb","text":"CDC guidance update allowing fully vaccinated people to stop wearing masks in most settings (May 13, 2021)."},{"id":"e9ce639b-b0f7-4d33-b373-cac3937c6b6d","text":"CDC/NCHS guidance on certifying COVID-19 deaths (April 2020) and subsequent public discussion of death-coding."},{"id":"7cc31dcc-0efa-4e05-a02e-1fbce072139b","text":"Great Barrington Declaration (Oct 4, 2020) promoting \'focused protection\' and criticizing lockdowns."},{"id":"38f53e15-3f6d-4e4e-8988-ef767fae2cce","text":"Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine reporting no statistically significant protective effect to wearers from recommending surgical masks (November 2020)."},{"id":"0adb6990-ff2b-421a-ab99-df94f72bf4af","text":"Public reporting (e.g., Foreign Policy, OSINT coverage) that social media posts and geotagged content have been used to locate and target soldiers in the Ukraine war (OSINT used operationally)."},{"id":"851308e8-afce-4654-97d3-ad29ed078b8c","text":"Independent reports in 2014 documenting summary killings, alleged mass graves and executions in eastern Ukraine (Amnesty International briefing, Oct 2014)."},{"id":"d31f3897-6484-4f9f-859d-dc84f80394a1","text":"CDC MMWR (March 2012) reporting autism spectrum disorder prevalence of about 1 in 88 in US surveillance areas (data for 2008)"},{"id":"237a6f9c-8425-4703-bee8-d512a40c8092","text":"Public reporting of rising measles cases in the UK attributed to declines in MMR uptake following the MMR scare"},{"id":"8b05fc9f-1aba-45bc-8a5f-875af5aed5a2","text":"1999 precautionary recommendation to remove thimerosal (a mercury-containing preservative) from childhood vaccines in the United States"},{"id":"7d208f2e-cd63-42c0-8e76-e048299ab995","text":"CDC/NCHS provisional reports and public pages in late 2022\u2013early 2023 highlighted continued high counts of non\u2011COVID causes of death (notably drug overdose and heart disease) in 2021\u20132022 (CDC provisional drug overdose data page updated Jan 2023)."},{"id":"95493ec3-5c76-4932-afe1-03535f25401e","text":"CDC published and maintained public, downloadable jurisdiction\u2011 and county\u2011level COVID\u201119 vaccine administration/coverage datasets and maps (e.g., CDC Stacks dataset release March 1, 2022)."},{"id":"ea97cfae-0ddf-4b15-93d7-99ed2e3e60ed","text":"UK guidance and primary\u2011care instructions on narrow criteria and formal processes for issuing COVID\u201119 medical exemption certificates (GPs required to follow specified criteria)"},{"id":"9520f831-fc95-4505-b1ef-f59d7c4babc9","text":"Temporary pause and safety review of the Johnson & Johnson (Janssen) COVID\u201119 vaccine after reports of rare blood clots (CVST)"},{"id":"75244adf-d5fa-4e9b-aecd-fa8520a5cb68","text":"News coverage of hospitals and transplant programs declining care (including organ transplants) for unvaccinated patients"},{"id":"ce6fa6be-ead1-4088-b52e-bf53f3c4157e","text":"OSHA/NIOSH hazard communications and guidance on diatomaceous earth/silica hazards (e.g., OSHA interpretation clarifying DE silica content and hazard communication, April 5, 1999; NIOSH silica guidance)"},{"id":"4ca90c87-c4e6-4c7f-94f0-ea9daba911e6","text":"Peer\u2011reviewed and technical studies showing diatomite/diatomaceous earth has sorption/adsorption properties in water treatment (e.g., fluoride/heavy\u2011metal removal studies, 2019)"},{"id":"726f005e-8131-460c-9463-d6964a2251c7","text":"GOV.UK Summary of the Public Assessment Report for the Pfizer/BioNTech COVID-19 vaccine (authorisation documents, Dec 2020) and WHO/regulatory guidance cited therein stating carcinogenicity/genotoxicity testing is generally not required for many vaccines."},{"id":"71bb8186-e063-41c0-901d-221f213e112f","text":"UK MHRA Freedom of Information release (FOI_22-1223) and related correspondence (published 22 Dec 2023) stating \'Neither genotoxicity nor carcinogenicity studies were performed\' for certain Comirnaty components and that components \'are not expected to have genotoxic potential.\'"},{"id":"c708f5de-2751-4a8c-9fb1-241d533a4dcf","text":"Public release/update of childhood cancer incidence data/registries (e.g., National Childhood Cancer Registry Explorer / US cancer surveillance datasets updated 2022\u20132023) showing short\u2011term fluctuations or small upticks in incidence that were reported in the media."},{"id":"ee196b61-e304-461e-a463-d5ae45a016a4","text":"Russia imposed an import ban on Roshen confectionery products (Rospotrebnadzor cited safety concerns)."},{"id":"efea0255-2ea4-4369-a4fd-dc32db53107e","text":"Armed police and plainclothes officials entered the Lipetsk Roshen factory amid court cases and commercial disputes (widely reported tensions at the Lipetsk site)."},{"id":"cb59b418-04fb-4379-a5d3-0fad9684bf2e","text":"Roshen announced it would close its Lipetsk (Russia) factory and halt operations, laying off workers (company statement reported January 2017; operations stopped by April 2017)."},{"id":"e4bd4597-6c95-42b6-8ea0-95f932932c30","text":"Petro Poroshenko transferred his Roshen stake into a blind trust managed by Rothschild Trust (announcement and confirmations in January 2016)."},{"id":"6d505685-fb18-4996-b440-3537c58c3f23","text":"Pre\u2011existing, reputable polls with mixed results (GfK Ukraine 2018) showing regional variation in nostalgia"},{"id":"05beab80-30fe-4554-ae31-69577b6c546e","text":"Historical 1991 independence referendum (92% voted for independence) \u2014 widely reported figure available in public records"},{"id":"e2e86f81-529f-4675-a88a-f4cb35ba63d3","text":"Oleg Sentsov began an indefinite hunger strike on 14 May 2018 to demand the release of Ukrainian political prisoners, drawing intense international attention to his case."},{"id":"69ee56c9-cc8b-4db0-bafe-7b715277e65f","text":"Human-rights organisations and public petitions mobilised around Sentsov in mid\u20112018 (Amnesty International and other advocacy actions in June 2018 used #FreeSentsov widely)."},{"id":"391c290d-4d33-46d1-a6fc-ec24553a697a","text":"Norway reports and investigations of frail elderly deaths temporally associated with vaccination"},{"id":"29cc9f60-6154-4ad6-93d1-6804d8134a36","text":"U.S. pause of the Johnson & Johnson (Janssen) vaccine after rare blood clot reports"},{"id":"8e1043cc-2dca-495f-8d63-e75c5ae5387f","text":"Publication of Karl et al. (2015) NOAA/Science paper revising recent global surface temperature analyses and addressing the so\u2011called \'hiatus\'"},{"id":"d9f42efe-10eb-4163-90db-2d36b388e3b0","text":"Local incidents and campaigns (e.g., Holy Rus\' Movement activity reported in Pastavy) around November 2014 that raised tensions over flags, national identity and pro\u2011Russian vs pro\u2011European messaging."},{"id":"08fc4aaa-001c-499e-b2bc-1bc0f4e5aa2b","text":"Annual Shrovetide/Maslenitsa effigy\u2011burning traditions observed across Slavic countries (including Belarus) where effigies are publicly burned as part of festival rites."},{"id":"755c31cf-ca4d-4874-93d4-5d07f9d7e130","text":"Visible use of alternative Belarusian opposition symbols (white\u2011red\u2011white flags) and frequent protest imagery in 2014 that foregrounded flags and symbols in public demonstrations."},{"id":"7c90f385-a416-416c-9ba0-87f159085a81","text":"U.S. Patent US4686605A (\'Method and apparatus for altering a region in the Earth\'s atmosphere, ionosphere, and/or magnetosphere\') granted to Bernard J. Eastlund (patent text describes possible weather-modification applications)."},{"id":"b3345a2a-fe41-4be3-8ef9-5166e14dfb0d","text":"IMF staff report on Ukraine\'s emergency financing needs under the Rapid Financing Instrument (IMF staff report published March 7, 2022)"},{"id":"50384329-e3d9-48a5-93bc-83cc4d763718","text":"World Bank warning Ukraine economy could shrink sharply in 2022 (World Bank press release, April 10, 2022)"},{"id":"e963d97a-8c6b-4628-94cd-73d0bfcbd002","text":"Parliamentarian warning Ukraine needs $5 billion a month in external aid (reported by Reuters)"},{"id":"725773c9-8f3f-4822-9346-a7020aa3ac84","text":"S&P Global Ratings cuts Ukraine\'s sovereign credit rating (Reuters)"},{"id":"ab4dc4b1-a625-45f0-b3fb-38d06409de86","text":"U.S.-led training of Ukrainian military personnel at sites such as the Yavoriv training center (Joint Multinational Training Group \u2013 Ukraine began operations in 2015)."},{"id":"5cc6d900-a391-49b9-aaa7-310336dd2c4d","text":"National Endowment for Democracy (NED) grants and NGO funding programs in Ukraine following Euromaidan (published in NED annual reports and grant records)."},{"id":"2ef611e1-b729-446e-959a-b9dc97b37d9c","text":"U.S. announces major economic assistance and loan guarantees to Ukraine as part of post-Maidan support (including a White House fact sheet detailing assistance)."},{"id":"970d01a7-2623-44ac-9bc2-138a3179e97b","text":"Visit by U.S. Senator John McCain to Kyiv\'s Maidan protests and public expressions of support for pro-European protesters."},{"id":"a71d8cfa-f5e8-4f18-998a-6204aef07bc1","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels attempting to transit the Kerch Strait, injuring sailors and sharply escalating tensions."},{"id":"c4e720ce-0d97-4a36-8c23-6c78b6521969","text":"Verkhovna Rada debated and adopted the Law on the Reintegration of Donbas (early 2018) and passed parliamentary resolutions emphasising de-occupation and reintegration of territories lost in 2014, including Crimea."},{"id":"2d47fdb1-a065-43d7-b9d4-8e29ea65754f","text":"European Union extended sanctions related to Russia\'s 2014 annexation of Crimea after diplomatic deliberations in December 2019."},{"id":"31153ee6-b71b-49c4-b2ab-586daaf0c002","text":"President Volodymyr Zelensky publicly vowed to restore Ukrainian control over Crimea during his inauguration, stressing Crimea remains part of Ukraine."},{"id":"0389fee0-e5b0-4b6d-9750-ec7e37751939","text":"CDC Vital Signs (MMWR) documenting a sharp rise in firearm homicides in 2020"},{"id":"00de697f-97cd-4ebc-a9fb-9de4c1fe389a","text":"Reports and recall actions after discovery of foreign/black particles in Moderna vaccine vials in Japan (investigation and lot suspensions)"},{"id":"a82dced5-0442-4343-8602-c3ee4319f011","text":"NEJM study showing substantial waning of Pfizer\u2013BioNTech (BNT162b2) protection against SARS\u2011CoV\u20112 infection over months in Qatar"},{"id":"ff856f4d-0e11-403a-982f-e86414ddea01","text":"ACIP/CDC review and MMWR reporting of myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination in young males"},{"id":"cb9a225b-b8d9-4863-bded-41002e213aae","text":"Passage of Ukraine\'s decommunization laws (adopted April 9, 2015)"},{"id":"68e658a7-87b7-4feb-bc49-8a98c415edda","text":"Verkhovna Rada officially renamed the city of Kirovohrad to Kropyvnytskyi"},{"id":"5a78c0b5-ea57-4bce-9e0e-103c30c48f52","text":"City council-organized public survey (Oct 25, 2015) reported that around 77% of participating respondents favoured restoring the historical name \'Yelysavetgrad\' (low turnout)"},{"id":"f0b78019-fc88-4133-87c6-d5dc3b5ddf72","text":"Reports of foreign/black particles found in some vaccine vials (Japan, September 2021) and subsequent temporary suspensions/recalls"},{"id":"4e756dc8-42ee-4525-9931-5b21f8a028bc","text":"Court-ordered public release of Pfizer/FDA review documents (rolling release beginning March 1, 2022)"},{"id":"b90c9c7d-8ee2-4cbf-9324-9485701f2402","text":"Reports and rights\u2011group coverage of extra-legal self\u2011defence units and weapons proliferation in occupied/contested areas (Human Rights Watch World Report 2015)"},{"id":"3ea55b05-e64e-4a51-b455-4cd56d19c028","text":"Poroshenko sacks Ihor Kolomoisky as governor after armed men seize oil company offices; publicly warns no regional \'pocket armies\' will be tolerated"},{"id":"e9587647-c97e-4a21-ac83-8717ce46d6f6","text":"E\u2011petition filed calling for formalisation of citizens\' right to bear firearms (Reg. \u21161135-1 submitted)"},{"id":"5018bc81-8adb-4e6f-96fa-ac5d951ada7a","text":"Presidential decree and public events strengthening/celebrating the National Guard and deployment of National Guard battalions (march 2015)"},{"id":"834752c5-4367-4977-9bc7-8fdca0b7efad","text":"Widespread formation and operation of volunteer battalions (e.g., Azov, Donbas) during 2014\u2013early 2015"},{"id":"e3929cb9-d9bf-44fe-8eb3-431bce5cc092","text":"Public debate and reporting on Ukraine\'s mobilization and need to replenish/rotate forces"},{"id":"3c496ecd-36b2-46b7-a3dc-5fa2c28c013f","text":"Claims of territorial setbacks (Soledar) early 2023 that were amplified by Russian sources"},{"id":"8385b239-35f0-4b4a-b4d8-cebe460666d6","text":"Summer\u2013autumn 2021 \'wind drought\' across the UK and parts of Western Europe produced unusually low wind output and a noticeable drop in renewable electricity generation."},{"id":"c2bf0c47-4735-4576-9964-8dbe9c634b2a","text":"February 2021 Texas winter storm caused widespread grid failures and stressed electricity supply; some industrial sites (including data centers) relied on backup power and experienced operational impacts."},{"id":"a26c5d27-1a41-49e2-a665-a7e20594af90","text":"NOAA / Coral Reef Watch reporting and technical briefs documenting the 2020 GBR marine heatwave and unprecedented bleaching risk (March 2020)"},{"id":"d4666577-80d5-4393-af93-c3c07c2fd745","text":"UNESCO/World Heritage publicity around suggestion to list the Great Barrier Reef as \'in danger\' (July 2021)"},{"id":"da653844-4256-45cc-8273-f87fcc346bb8","text":"Reporting and congressional attention on EcoHealth Alliance and funded coronavirus research with the Wuhan Institute (NIH correspondence and investigations, Oct 2021 onward)"},{"id":"148c615a-c714-4ab2-bf8c-5af7057fa0a7","text":"U.S. Department of Energy reported an assessment favoring a laboratory origin (covered in Feb 2023 press)"},{"id":"fd031dea-82ae-4214-b800-07eee7e5716e","text":"Russian and other state\u2011backed media amplified allegations of U.S. biological labs and research being part of hostile programs (March 2022)"},{"id":"4a3d5220-cb8b-4170-ac6a-98c32da8fffd","text":"Great Barrington Declaration (4 October 2020) \u2014 public statement by a group of scientists advocating \'focused protection\' instead of broad lockdowns."},{"id":"2727f1dc-96ca-4448-8e40-efad4366f0c5","text":"Publication and media coverage of the DANMASK-19 randomized trial (Denmark) in November 2020, reporting limited protective effect of recommending surgical masks for wearers in a low-transmission setting."},{"id":"79060d8f-adb6-497a-b312-d7d7335d3ca3","text":"Imperial College COVID-19 Response Team Report 9 (16 March 2020) modelling high projected deaths and showing large effects from non-pharmaceutical interventions (NPIs), widely cited by policymakers and media."},{"id":"c756adeb-3a86-439c-953b-7e81f14df065","text":"Publicised requests to retract or critique the early Corman\u2013Drosten RT\u2011PCR protocol (late 2020) and widespread online debate about PCR sensitivity, cycle thresholds, and false positives."},{"id":"8f8bd225-18e7-459d-8caa-6c1a605d96e0","text":"Israeli Health Ministry report (June 2021) identifying a probable link between Pfizer vaccine and rare myocarditis cases"},{"id":"4fe6f1c0-42e1-4624-9724-0f3a607b1ad5","text":"FDA Emergency Use Authorization (EUA) for the Pfizer\u2013BioNTech COVID-19 vaccine"},{"id":"8a336d3a-0a98-4e49-a5b1-dc54520f9680","text":"CDC MMWR report on the Provincetown (Massachusetts) July 2021 outbreak with a high proportion of cases in fully vaccinated people"},{"id":"8f6b1e84-266b-412f-bf9f-c4180186fa63","text":"Announcement of \'Operation Warp Speed\' to accelerate COVID-19 vaccine development"},{"id":"c2c48b13-0da9-4a70-90b3-0a2dcf6a44f3","text":"WHO designation and global spread of the Omicron variant (variant of concern declared 26 November 2021) and subsequent large waves of infections in late 2021\u2013early 2022"},{"id":"1f75d58f-e21f-4a32-8be6-6f03fa2583b2","text":"Preprint released claiming a \'Worldwide Bayesian Causal Impact Analysis\' of 145 countries showing vaccine deployment increased COVID-19 cases and deaths"},{"id":"a7af8ad7-124f-45c3-9c15-92e6e377bc92","text":"Major meat company sustainability commitments and reports (example: JBS releases 2022 Sustainability Report and net\u2011zero framing)"},{"id":"84546613-04c9-4ea6-a46a-04af0d15ed76","text":"Wide media coverage and debate around the GWP* methane metric (interpretation and promotion of GWP* as an alternative to GWP100)"},{"id":"b24ffb2c-2472-4d2a-811c-26c1b050e679","text":"Publication of peer\u2011review studies and meta\u2011analyses showing mixed evidence on soil carbon gains from grazing/regenerative practices (example: Nature 2024 grazing/carbon meta\u2011analysis)"},{"id":"a940d181-cd29-467e-b97e-dec0bc61b3ea","text":"Public U.S. statements (late 2014) denying provision of lethal weapons to Ukraine under Obama administration"},{"id":"00a0ec8c-2e64-4107-82df-2cdb7d4833de","text":"Rapid Trident 2014 multinational exercise at Yavoriv (September 2014)"},{"id":"853abfef-64ce-49bd-a2d8-eecd7f1452f2","text":"U.S. 2nd Cavalry Regiment Javelin live\u2011fire range at Grafenw\xf6hr/Vilseck (Sept 23, 2014)"},{"id":"5006627b-b293-43d9-8e73-d6b5a7567e40","text":"Destruction of the Antonov AN-225 \'Mriya\' and visible damage at Hostomel/Antonov airport after Russian strikes"},{"id":"1cd4ddaf-aaea-4acc-a028-74a6d7933399","text":"FAO publishes \'Livestock\'s Long Shadow\' quantifying livestock\'s share of global greenhouse gases and comparing it to transport"},{"id":"0689fba7-b805-40ed-8cfa-956bc0b5639f","text":"June 2021 reports and ACIP discussions documenting rare cases of myocarditis/pericarditis after mRNA vaccination in adolescents and young adults."},{"id":"f761c1de-a725-49a2-9f05-5e810c664681","text":"October 29, 2021: FDA Emergency Use Authorization and ACIP recommendation for Pfizer\u2011BioNTech COVID\u201119 vaccine in children aged 5\u201311."},{"id":"9fab087a-2b8b-4638-b3b9-84915e913387","text":"Publication of Ogata et al. (May 20, 2021): small pilot study detecting SARS\u2011CoV\u20112 vaccine antigen (spike protein) in the plasma of 11 of 13 mRNA\u20111273 (Moderna) recipients."},{"id":"1267f7fa-73d9-44e8-950a-a0dee6897774","text":"Published evidence of waning vaccine effectiveness and Israel\'s booster campaign (e.g., Bar\u2011On et al., NEJM showing booster restored protection after demonstrated waning)."},{"id":"22815f4d-1308-4d07-a08f-e7acebf98655","text":"Release and dissemination of the Great Barrington Declaration (October 2020), advocating \'focused protection\' and emphasizing immunity from infection."},{"id":"c4d39634-abdf-4664-bdad-d6e78eb7bbb0","text":"Publication of Israeli preprint by Gazit et al. reporting that, during the Delta wave, SARS\u2011CoV\u20112\u2011naive vaccinees had a 13.06\u2011fold increased risk of infection compared with previously infected individuals (medRxiv preprint)."},{"id":"90ef49c0-710f-4b96-81f9-3d83ddeba200","text":"New York Attorney General pursued civil actions and publicized dozens of price-gouging complaints against gas stations after Hurricane Sandy (2012)."},{"id":"663b4f93-67b7-4083-b91d-62cb28710640","text":"Federal Reserve Bank of St. Louis discussion of the \'rockets and feathers\' effect (October 2014) showing retail gasoline prices often rise quickly but fall slowly after crude price declines."},{"id":"49f76802-5e87-499f-8e75-f14098ec6093","text":"UK government and consumer groups publicly urged petrol retailers to cut prices after steep falls in global oil prices (November 2014 coverage)."},{"id":"f70405cb-f7f6-4863-bc7a-c931d82c2550","text":"Release of the IPCC Fifth Assessment (AR5) Summary for Policymakers (September 2013) with quantified attributions and separate estimates for greenhouse gases and aerosol cooling"},{"id":"eae1880d-3590-4fa9-9cbb-842e0a396bfb","text":"Russian seizure of three Ukrainian naval vessels in the Kerch Strait"},{"id":"266913ed-2eef-4ab7-911a-105100da0e02","text":"Ukraine announced partial martial law in response to the incident"},{"id":"06e389e5-f96e-4d33-9f6e-1932526e6f19","text":"Russian Foreign Ministry publicly accused Ukraine of deliberately provoking the incident"},{"id":"57710820-589c-48a2-bfcb-33ad32e2c665","text":"FDA emergency use authorization (EUA) for Pfizer-BioNTech vaccine expanded to adolescents aged 12\u201315"},{"id":"d3789df5-39f9-4f88-9edf-85bf0035efc4","text":"Publication of Israeli active-surveillance study reporting increased myocarditis cases after BNT162b2 (Pfizer) vaccination"},{"id":"72f2cfd0-b507-449e-9770-85beb184878a","text":"Air-raid alert sounded near central Kyiv while a group of Moscow\u2011aligned clergy were at the Presidential Office; Ukrainian air defences detected and shot down a drone."},{"id":"a6cc1c20-7887-40a1-aabf-bfb7e06a7449","text":"Public fallout from Patriarch Kirill and parts of the Russian Orthodox leadership publicly backing Russia\u2019s invasion (2022), prompting Ukrainian clergy and parishioners to cut ties with Moscow."},{"id":"c786f26e-12c2-4535-a429-4e452628cffe","text":"UNEP Global Methane Assessment names agriculture (including livestock) as a major short\u2011lived climate forcer"},{"id":"6a2d7a4b-4915-4e96-8761-56cffaf93b4a","text":"Launch of the Global Methane Pledge at COP26"},{"id":"929e1daf-b76b-4dcc-bef3-f9333ae4e759","text":"Industry advocacy/PR programs to defend beef (e.g., \'Masters of Beef Advocacy\' and NCBA campaigns)"},{"id":"fce12da3-bb37-4057-b532-66704b519802","text":"Publication of major reports in 2019 (CDC/WHO) highlighting antimicrobial resistance as a growing global health threat"},{"id":"90ceca1b-3c57-4f9c-9fa7-8efa71128ef7","text":"Japan\'s 2013 suspension of proactive HPV\u2011vaccine recommendation after media reports of adverse events, and the official resumption of active recommendations on Nov 26, 2021."},{"id":"9a9f6fb9-cf76-48ee-9a70-677d6c110efa","text":"April 2023 court developments in U.S. Gardasil litigation: plaintiffs secured orders/access to adverse\u2011event databases and internal documents related to Gardasil safety."},{"id":"48d0d409-30e5-428f-8ea5-91b8cae163bb","text":"Publication of a November 2022 Journal of Autoimmunity paper (Mehlsen et al.) reporting clinical and pathophysiological findings in a cohort of patients who self\u2011reported long\u2011term complications after HPV vaccination."},{"id":"4d05f40f-071e-4ec6-9402-83d6f6728d05","text":"NCHS/CDC data summary noted that 94% of death certificates mentioning COVID-19 also listed other health conditions (widely reported Sept 2020)."},{"id":"61fbfe05-fc35-4760-85bc-5bad7ae4ded7","text":"Publication of seroprevalence analyses (JAMA/CDC-linked studies, mid\u2013late 2021) showing infection-induced antibodies were substantially more common than reported case counts indicated."},{"id":"28039044-3710-423a-a4bd-2fbbf3e54855","text":"Public debate and official briefings in 2021 (WHO and national public-health commentary) about the extent and durability of \'natural immunity\' after infection."},{"id":"de0e3abf-ceba-49b9-8828-79c50e38b815","text":"Human-rights reports documenting abuses (including looting) by some pro\u2011Ukrainian volunteer battalions (e.g., Aidar)"},{"id":"c02542da-91d7-4dcd-8711-22502b1933c2","text":"Reporting that Chechen fighters were present in eastern Ukraine (widely covered in 2014)"},{"id":"5f73d540-43b8-4265-b8ff-aa19a825cccd","text":"Russian officials and state media accused the UK and US of involvement after the October 29, 2022 drone attack on the Sevastopol/Black Sea Fleet facilities; coverage noted Russian claims of foreign participation."},{"id":"5c85d134-3901-4755-b71a-1b2eb75fb815","text":"Reporting on leaked documents and media investigations that suggested UK special forces and other British personnel were operating in Ukraine (e.g., reporting that up to ~50 UK special forces were present)."},{"id":"10e90a91-8e71-43ae-8b59-e0b1a43a6907","text":"Visegrad (Central European) leaders, including the Czech leadership, publicly underlined opposition to EU migrant/relocation quotas"},{"id":"287b2f37-c4a8-4ee8-a189-3a6c0f1582b8","text":"Large and growing population of Ukrainian workers/residents in the Czech Republic (Ukrainians became the largest foreign national group)"},{"id":"03902357-f4c2-4df8-9882-232e48bd71e7","text":"President Milo\u0161 Zeman and other officials made repeated anti-refugee/anti-Muslim public remarks during 2015"},{"id":"663097e0-4b95-4728-8608-8d19438f7d7d","text":"European Court of Human Rights judgments finding domestic travel bans (imposed by bailiffs/authorities) problematic (e.g. Khlyustov v. Russia)"},{"id":"300f0d0c-3195-4f56-8af4-3e5a93c40f57","text":"Passage of other high\u2011profile restrictive laws by the Duma (e.g. 2012 \'foreign agents\' NGO law)"},{"id":"dc0fbaec-ae96-4c16-9fc7-5b16fd8c8b15","text":"Widespread travel bans imposed by the Federal Bailiff Service on debtors (reports ~500,000 affected)"},{"id":"15443277-29b8-44dd-bc8b-e751eb349fa8","text":"Public reporting in late June\u2013July 2022 that Ukraine had received and begun using U.S.-supplied HIMARS systems in combat."},{"id":"56e4391a-703c-4ed9-a325-0165561cee88","text":"Media reporting that many of the victims/prisoners at Olenivka were fighters from the Azov Regiment captured after the fall of Mariupol/Azovstal."},{"id":"24abea91-0dac-40b9-9770-ed51f91c5c5f","text":"International Committee of the Red Cross (ICRC) and other agencies reported limited or denied independent access to the Olenivka site and called for impartial investigation."},{"id":"3b16bfd7-7b38-422e-8168-de5f079314e7","text":"WHO and regulatory guidance documents explicitly listing vaccine-associated enhanced disease/ADE as a safety consideration during COVID-19 vaccine development and evaluation"},{"id":"4a4a3486-453b-4e0f-b099-3969db2e42ef","text":"Preclinical animal studies (e.g., Tseng et al., PLoS ONE) reporting pulmonary immunopathology after SARS coronavirus vaccine challenge in mice"},{"id":"76b6c6cf-86b2-42d9-badc-c8bd382b4aa9","text":"International Republican Institute (IRI) / Rating Group national survey (September 2023) reporting strong majorities believe Ukraine can defeat Russia and support recapturing lost territory"},{"id":"75b0643e-6526-4dd1-a6c5-ec972c9437f4","text":"Atlantic Council / DFRLab analysis of pro\u2011Kremlin information operations (reporting on Russian info tactics aimed at undermining confidence in Ukraine, Feb 2023)"},{"id":"2f98e229-8833-4116-8716-f73260c19e20","text":"Kyiv International Institute of Sociology (KIIS) omnibus poll on readiness for territorial concessions (data collection Nov 29\u2013Dec 9, 2023)"},{"id":"c568daa3-1f6c-437f-a2b8-c047b1e273d8","text":"President Volodymyr Zelenskyy\'s speech to the UN General Assembly (full text published Sept 20, 2023)"},{"id":"fb5e89ab-7a85-43ae-a4f2-098d2753ec2a","text":"G7 public rejection of Russia\u2019s ruble-for-gas demand"},{"id":"8c8f1924-d68f-416b-8d8e-58c11e08a9bc","text":"Confusion about how the ruble-payment mechanism would work (Gazprombank conversion accounts)"},{"id":"fa13c6d0-b2e5-474b-9f53-d4a52a63806a","text":"UK government publicly called for investigation into allegations that Russia was stealing Ukrainian grain"},{"id":"a7792d10-d764-4230-90f7-ac06b4636202","text":"AP/PBS Frontline investigation documents large-scale removal of Ukrainian grain from occupied territories using satellite imagery and ship-tracking data"},{"id":"b1976276-72b8-4011-90e9-c0aea7bc389e","text":"UN\u2011brokered Black Sea Grain Initiative led to the first ship leaving Odesa carrying grain under the safe\u2011passage deal"},{"id":"17c096b5-452d-4531-bc5a-882057a7929b","text":"Longstanding public health and cultural practice in Japan of routine gargling to prevent respiratory infections, and official encouragement of gargling during the 2009 H1N1 outbreak (documented in peer\u2011reviewed literature)."},{"id":"a9001056-daab-416a-bddf-6062cc82c7ae","text":"Pre\u2011existing in\u2011vitro research (2015) showed povidone\u2011iodine (PVP\u2011I) oral rinses can rapidly inactivate related coronaviruses (SARS\u2011CoV, MERS\u2011CoV) in laboratory tests."},{"id":"a0960191-05cf-4a3d-b3b5-463142b35563","text":"2018 studies and media coverage reporting a significant slowdown of the Atlantic Meridional Overturning Circulation (AMOC)"},{"id":"35e718bf-4fb0-4c92-b4e1-8fb977118393","text":"2015 Scientific Reports paper by Zharkova et al. proposing a forthcoming \'modern grand solar minimum\' (linked to multi-decadal cooling)"},{"id":"4a103dd4-b72c-4209-98ce-c3609d5ebbe1","text":"Late-January 2019 polar vortex cold snap widely covered in US media"},{"id":"c26143cc-60dc-4cc5-85f5-ea1998788b28","text":"WHO scientific brief and multiple seroprevalence reports during mid-2020 indicating lower-than-feared infection fatality rates in some populations"},{"id":"ac11415d-d1f0-49ae-bf3c-e809f385565f","text":"Ukrainian authorities publicly reported large-scale allocation of state land to ATO participants (land-for-soldiers program)"},{"id":"5f8c9e85-7db4-472f-bebd-dbe581560237","text":"May 2014 Land Agency initiative announced to provide mobilized servicemen and displaced soldiers with free land parcels (10\u201312 ares up to 2 hectares)"},{"id":"39a20b14-9486-4645-846f-a5d3a05a411d","text":"Early volunteer recruitment drives and public discussions of material incentives for volunteers and battalions (wide volunteer mobilisation in March 2014)"},{"id":"729bd517-f48b-4458-86d3-c7b80c90a419","text":"Documented abductions, ill-treatment and forced labour by armed groups in Donbas during 2014"},{"id":"eee21b3a-7680-4b10-9582-b74325004fff","text":"NIH announces suspension/withdrawal of funding to EcoHealth Alliance projects involving the Wuhan Institute of Virology (political scrutiny and reporting intensified)"},{"id":"4300ed1d-249d-4eb3-a8e3-2977bf86206e","text":"Early suppression and censure of whistleblower doctor Li Wenliang and his subsequent death, widely reported internationally"},{"id":"65c14409-94a3-4eb2-8441-805a55ed7592","text":"Lancet clinical report and early epidemiology (first cluster descriptions) noting both links to the Huanan market and an earliest case with no market link, creating ambiguity about initial spillover"},{"id":"2d827743-6247-4e6b-a57b-dafc824a08bd","text":"Douma suspected chemical attack and subsequent U.S./UK/France strikes"},{"id":"ca494079-582d-4085-964a-16eb13213ade","text":"Salisbury Novichok poisonings linked to Russia (Sergei and Yulia Skripal)"},{"id":"d130f78e-0f60-4aee-a423-c35f5aaa102e","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers released, synthesizing evidence on anthropogenic warming and acknowledging internal (natural) variability on decadal scales."},{"id":"943e4f34-59eb-4222-a1ae-6b920d69ab63","text":"Publication of Karl et al. (2015) in Science revising NOAA surface temperature dataset and concluding biases partly explained the so\u2011called \'hiatus\'."},{"id":"abf56087-ecd6-4e4c-ae65-1897149ad7e8","text":"Release and publicity around discrepancies between satellite lower\u2011troposphere trends (UAH/RSS) and surface temperature records, including UAH Version 6.0 release (April 2015)."},{"id":"396176b5-f265-4891-be47-52b337eb773a","text":"U.S. announces major defensive military assistance increases to Ukraine (e.g., $200 million package)"},{"id":"172cf672-4338-4d7f-9bb6-ea44525201d7","text":"U.S. Defense Threat Reduction Agency (DTRA) Biological Threat Reduction Program activities publicly documented in Ukraine"},{"id":"6c174445-80ed-497e-b27a-f0ee25657bc0","text":"Westinghouse announced extended nuclear fuel supply to Ukraine (contract extension)"},{"id":"c11336cd-72ab-4022-9eb7-8330b56c200a","text":"Sea Breeze multinational naval exercises co-hosted by the U.S. and Ukraine (Black Sea)"},{"id":"b22df674-8d6a-4eac-9c5c-4a6b65a8be49","text":"U.S.\u2013Ukraine Nuclear Safety Arrangement signed (Rockville)"},{"id":"f546c638-ba96-4832-b699-e89ff607a5a5","text":"Event 201 pandemic tabletop exercise hosted by the Johns Hopkins Center for Health Security with the World Economic Forum and the Bill & Melinda Gates Foundation."},{"id":"9061c2d6-b97b-4e66-9c41-0f9fdb8855b7","text":"Polish government rhetoric about protecting Poles and restricting entry for Ukrainians with \'anti\u2011Polish views\' (reported by Reuters)."},{"id":"71137349-c545-4726-a3fb-95eb051d846d","text":"Polish Sejm passes a resolution on the Volhynia/Volyn killings (frames the 1943 massacres as \'genocide\'), heightening Polish\u2011Ukrainian historical tensions."},{"id":"a902748c-6ee2-4618-887c-aaa065629c33","text":"Keeling Curve (Scripps/UC San Diego) update and commentary (June 6, 2024) reporting unusually large recent annual and multi-year jumps in atmospheric CO2 at Mauna Loa and in the Keeling record."},{"id":"c51a371a-2861-4e4a-bebe-05bfd37ac05e","text":"Publication of a PNAS-backed study (led by Oregon State University and University of St Andrews) reporting that today\'s atmospheric CO2 increase is ~10 times faster than at any point in the last 50,000 years."},{"id":"58a8a0fb-d8e4-4062-8e49-77fbaa8c4af4","text":"Public familiarity and heightened sensitivity to the term \\"airborne\\" after prolonged COVID-19 airborne-transmission debates (CDC scientific brief acknowledging airborne transmission dynamics, May 2021)"},{"id":"a889b71b-e769-4400-9de4-484e46923b84","text":"WHO declares the monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)"},{"id":"a1afbbcb-0045-4cb3-a80a-c94f23c033f6","text":"CDC public guidance stating infectious period normally lasts 2\u20134 weeks (not months)"},{"id":"1ec08fa1-6515-4fb9-a585-16241d52e937","text":"World Health Organization interim guidance on mask use updated (interim guidance published/updated in March\u2013June 2020, with a notable update 5 June 2020)."},{"id":"65415f11-d162-41f9-a436-55fa225f8ce1","text":"US CDC recommended on April 3, 2020 that members of the public should wear cloth face coverings in public settings where social distancing is difficult."},{"id":"f223b73f-a2ba-4f6f-946c-77a1b03ec42e","text":"The Great Barrington Declaration was published (October 4, 2020), advocating \'focused protection\' and opposing broad lockdowns and some mitigation measures."},{"id":"4e312d90-6877-4ad1-a1c5-7420a43c99a7","text":"Adoption of the Kivalov\u2013Kolesnichenko language law expanding regional languages (2012)"},{"id":"1fb2122c-caff-46d0-8d3c-6d03fba686fd","text":"Verkhovna Rada voted to repeal the 2012 language law (23 February 2014)"},{"id":"8ee37723-897a-4a6f-8b39-4c7dd211b1c1","text":"Pro\u2011Russian unrest and separatist seizures in eastern Ukraine; local councils declared Russian a regional language (March\u2013April 2014)"},{"id":"f4fd4123-302b-40c8-810b-b64de82dab57","text":"Poland\u2019s prime minister and other Eastern European leaders publicly call for an international tribunal to investigate Russia\u2019s actions"},{"id":"4bf2c361-66ac-43d9-a57d-69eda5f68ff3","text":"Legal analyses and reporting highlight that the ICC cannot currently prosecute the crime of aggression against a non\u2011party state like Russia without a UN Security Council referral"},{"id":"0486887d-f3e6-4ad8-8318-f61fc63d4e4c","text":"Divergent public language among Western leaders over strong legal labels (e.g., \'genocide\' versus \'possible genocide\') in April 2022"},{"id":"9a34b22b-fed3-4c7b-beb3-c3fe6294db09","text":"Major international media profiles and frontline reporting highlighted large numbers of Ukrainian women serving in combat roles."},{"id":"661d6da5-a118-40c0-b59e-fa784c68d780","text":"Parliamentary debate and media attention around Ukraine\'s draft/mobilization laws, with officials explicitly saying female conscription was not part of the new draft law."},{"id":"89761b78-37d3-436a-9172-1aa0b3e7271b","text":"Documented increases in pertussis (whooping cough) activity in 2023\u2013early 2024 reported by public health agencies"},{"id":"3611d703-5b2b-459a-b6d0-1f1799963c5d","text":"Reports that Chinese firms/state-linked investors had shown interest in financing large Crimea projects (transport/energy/ports)."},{"id":"536b54e1-1e4a-419d-a557-b81756067a32","text":"Siemens turbine deliveries controversy highlighted limits in enforcing sanctions on equipment shipments to Crimea."},{"id":"12275ffe-4629-436e-b10f-abd6ce599ef3","text":"RFE/RL investigation reporting that numerous EU firms and intermediaries were finding ways to do business in Crimea despite sanctions."},{"id":"e11a0225-cab5-42e3-a921-41c80652ca9a","text":"Publication of a broad scoping review \'Electric vehicles and health: A scoping review\' (Environmental Research) that summarized limited and mixed evidence about EV-specific health outcomes and pointed to evidence gaps (June 2024)."},{"id":"bcb56a36-ec91-4877-92e9-b98d49434429","text":"A 2021 systematic review in Frontiers in Physiology summarized animal and limited human studies on radiofrequency electromagnetic radiation (RF\u2011EMR) from wireless devices and reported that many animal studies found reduced testosterone after RF\u2011EMR exposure (September 24, 2021)."},{"id":"93685c4c-4575-4523-97d2-ea10d32fa0e5","text":"U.S. ends COVID-19 national and public health emergencies"},{"id":"eda9cd0e-6a9f-4236-8a98-031b010dae5d","text":"Court dispute over FDA\'s proposed slow release of Pfizer vaccine documents (initial 75\u2011year timeline)"},{"id":"747298e5-3a4f-4b7d-97df-c50347bf7bb7","text":"Reports of black/metallic particles found in Moderna vaccine vials in Japan"},{"id":"536ccc45-bd29-414b-b18d-e863954871e3","text":"UNHCR / humanitarian agencies reporting large numbers of Ukrainians remaining under temporary protection across Europe (data briefs, 2024)"},{"id":"92720b4b-9773-4329-93c9-b45f67ca61f5","text":"Hungary tightens border-control procedures and increases checks for certain categories (early 2023)"},{"id":"0c839794-7745-4572-be7b-dddd47fd12f6","text":"Polish president vetoes law extending social benefits and protections for Ukrainian refugees"},{"id":"202de205-f1d1-4bf8-bf64-f00ec54f1552","text":"Large-scale border disruption at Poland\u2013Ukraine crossings after Polish trucker protests temporarily blocked traffic"},{"id":"d0020a67-fc35-4342-a323-11be9087d48a","text":"EU Commission / Council actions on temporary protection timing (proposal/extension toward a defined transition period)"},{"id":"d4a0d688-6659-43f4-b729-ba11a12764b1","text":"World Health Assembly adopted a package of amendments to the International Health Regulations (IHR)"},{"id":"38f3fcd7-ac4b-48ac-97a7-869b0ebf0b39","text":"A coordinated public letter and statements by many U.S. Republican governors saying they would not comply with a WHO pandemic agreement"},{"id":"d111af52-467d-4ee5-a2ad-0cb7697fb6dc","text":"WHO/PAHO international guidance on certification and coding of COVID-19 deaths published (guidelines on identifying COVID-19 as cause of death)"},{"id":"94df8f53-4787-4085-9cca-4355cf2800d5","text":"New York Times coverage that Russia was sending mercenaries and Syrian fighters to Ukraine"},{"id":"b8556f5f-e15a-4c1d-8734-58d81e74cab3","text":"WHO Situation Report 132 (PDF) released on May 31, 2020, summarizing global confirmed COVID-19 cases and deaths through that date."},{"id":"365f4d0c-f744-4264-8da9-40b644656575","text":"Media coverage in March\u2013April 2020 documenting overwhelmed hospitals and surging deaths in Lombardy and other early hotspots (e.g., New York, Lombardy) that highlighted acute local mortality spikes."},{"id":"352f7f27-61cb-4116-94b9-02f2bb7fc6aa","text":"Ukraine Health Ministry backs new organ-transplant law and announces 2018 pilot for cadaveric kidney donation"},{"id":"7371e316-7520-4859-8923-9f49a2fd0bc4","text":"OSCE report and regional analysis on trafficking for organ removal (2013)"},{"id":"30f8683d-3aa4-45fe-a452-4101b6211ad3","text":"French authorities and national media reported a sudden surge in bedbug sightings across Paris (including verified infestations in at least one school) that prompted government coordination meetings."},{"id":"9f8afa71-583a-4075-a1b6-4a16a0225b80","text":"Poroshenko\'s profile as a wealthy oligarch and highly polarising figure following his 2014 election (widely reported in 2014), which made character attacks and rumors about personal misconduct more plausible to hostile audiences."},{"id":"d2de2683-5301-4e88-a6af-de7b857d55b7","text":"Canadian government issues travel advisories urging citizens to avoid travel to Ukraine"},{"id":"3ac65615-295e-43b0-bd1e-295acce11b24","text":"Ukrainian president signs decree on general mobilization"},{"id":"8edaf8f8-cee1-403a-bb85-08ab937a3c86","text":"Large-scale Canadian charitable and advocacy campaigns raising funds and political support for Ukraine"},{"id":"136e92b4-2535-4767-a92a-7ba13709179c","text":"Reports of foreign/stainless\u2011steel particles found in some Moderna vaccine vials in Japan, prompting pauses of affected lots."},{"id":"97af48fd-228b-4ae1-8b4b-c1d114bd42f2","text":"FDA revises Emergency Use Authorization (EUA) for COVID-19 convalescent plasma, narrowing use to high\u2011titer units for specific hospitalized patients."},{"id":"81034bab-34ca-449a-8125-efe9bd3febf1","text":"American Red Cross published/updated guidance on COVID\u201119 vaccination and blood donation explaining eligibility rules and referring to FDA guidance (including notes about convalescent plasma collection changes)."},{"id":"6d5abe6a-278c-4409-9c45-30f3af0e0f88","text":"U.S. Fish and Wildlife Service 2008 Biological Opinion to protect the endangered Delta smelt"},{"id":"fd1034b1-5b65-4663-8ad8-50feb371cd77","text":"Media analysis and commentary on large volumes of stormwater/capture shortfalls (2015 coverage)"},{"id":"c974f6d6-113a-462f-a937-3a50bb6f876d","text":"California governor issues first-ever statewide mandatory urban water restrictions"},{"id":"cdc2e360-c720-4bea-b351-bdf839c88f03","text":"2017 Northern California \'Wine Country\' wildfires (Napa, Sonoma, Mendocino)"},{"id":"7bd2872a-0b55-457d-a26e-3d1c22d3c6de","text":"Oroville Dam spillway failure and mass evacuation"},{"id":"11234eed-3a0b-461d-a2e4-30ff96dc483d","text":"Cleveland Clinic (laboratory guidance/fact sheet) and other clinical bodies publishing guidance that MTHFR genotyping has limited clinical value (2020\u20132021)."},{"id":"b08c723f-b7b9-4359-b317-16d091bf3b21","text":"Publication of PNAS paper showing extremely slow and highly variable human DHFR activity (Bailey & Ayling, 2009)."},{"id":"a1e1ffbe-a8e0-47f4-a01c-cd3b536c3a39","text":"BMC Public Health report on threshold doses above which unmetabolized folic acid appears in serum (Sweeney et al./BMC Public Health, 2007)."},{"id":"c3394cb0-7f38-434e-b842-6b01a620b052","text":"1979 and subsequent clinical reports: Published case reports and toxicology reviews documenting pennyroyal ingestion as a historical abortifacient and a cause of severe hepatotoxicity."},{"id":"be00ff73-c861-4bd7-b6d4-8a447568e602","text":"July 15, 2004: Case report in the New England Journal of Medicine linking maternal use of blue cohosh to perinatal stroke and other neonatal harms."},{"id":"26c3f605-3001-4112-9321-01545614593d","text":"CDC updated its \'Learn the Signs. Act Early.\' developmental milestone checklists, adding new checklists for 15- and 30-month visits and publishing revised milestone wording on the CDC site."},{"id":"5c99bbde-646b-490b-853d-f167d22f76bb","text":"OSCE SMM reduced/ceased control of its Mariupol office amid the early invasion and reports that the Mission \'had not controlled its office\' in Mariupol since March 2022 (and the Mission publicly called for the release of detained SMM members in late May)."},{"id":"b69bb252-8716-4cad-aca0-20858633f361","text":"OSCE Special Monitoring Mission (SMM) publicly operated monitoring cameras and posts along the contact line prior to the 2022 full-scale invasion (public SMM daily reports noted monitors and equipment deployed)."},{"id":"683089cf-de34-464a-91b4-29c055e7034f","text":"Release and reporting on 2018 U.S. diplomatic cables that raised safety and staffing concerns about the Wuhan Institute of Virology."},{"id":"0c6e5fcc-3e05-4d45-9517-055b88d7fcf2","text":"Russian authorities begin large-scale issuance of Russian passports to Crimean residents and publicly announce high application numbers"},{"id":"2019fa13-4954-4783-ab8a-b6d58fb3767c","text":"Widespread reporting during 2022 that huge areas of Ukraine were contaminated with unexploded ordnance and mines (official estimates in Aug 2022)."},{"id":"9583ac2e-6d33-435f-b5aa-c463766577f7","text":"Russian missile strikes on Lviv damaged critical infrastructure and caused power outages (reported 11 Oct 2022)."},{"id":"044ac721-0b4b-42c6-a6fa-df1a1fe7d2a1","text":"Anonymous bomb threats led to evacuations of Lviv supermarkets and shopping malls (mass evacuations reported 22 Oct 2022)."},{"id":"ffe6f633-c3dc-4185-ad58-053703bb06bd","text":"CDC FluView weekly report showed influenza detections dropped to near zero by week 14 (week ending Apr 4, 2020)."},{"id":"ba93a92a-87bc-4eb5-b06e-8c6119100af6","text":"Council of State and Territorial Epidemiologists (CSTE) interim position statement published (Apr 5, 2020) updating COVID-19 case/death definitions to include probable cases."},{"id":"b8f25f7c-1b81-4e37-9f35-478976c1b8fb","text":"CDC/NCHS released a provisional death counts report (PDF) with technical notes emphasizing that counts are provisional, delayed, and that multiple causes can be listed on death certificates (released Apr 10, 2020)."},{"id":"675a521a-b49e-4a50-bd55-7b385ae2368f","text":"IPCC Sixth Assessment Report (AR6) Working Group I \u2014 Summary for Policymakers published"},{"id":"d8f1116e-b8e4-44c8-b2e0-e3a9f21c6ca8","text":"NOAA issues La Ni\xf1a advisory / \'double-dip\' La Ni\xf1a announcement"},{"id":"268224a1-81a0-40a0-b100-0e3b897c7a24","text":"Passage of Ukraine\'s \'decommunization\' laws (April 9, 2015) banning public display of Soviet symbols and changing commemorative practices."},{"id":"f7b3741e-3ff3-477e-833d-510531c56e36","text":"Verkhovna Rada passes sweeping \'anti-protest\' laws (known as the \'dictatorship laws\') restricting public assembly, internet access and media on January 16, 2014."},{"id":"aa8ced11-33e8-4dfa-a777-998135937715","text":"Deadly police crackdown on Euromaidan protests in Kyiv (notably February 18\u201320, 2014) where security forces used live fire against demonstrators."},{"id":"652002d2-8a3d-47b5-83a2-1bc03a3d02d1","text":"April 2014 \'anti-terrorist operation\' (ATO) launched in eastern Ukraine (Donetsk/Luhansk) with security operations, checkpoints and restrictions on movement and gatherings."},{"id":"3884db69-6ca6-4ea3-9050-5a4f1a38d906","text":"Rapid growth of the global \'detox\' / detox\u2011supplement market (industry reports and press releases 2020\u20132021 showing large and growing commercial market for detox supplements)."},{"id":"332e1724-af40-488b-98b4-34de0d227565","text":"Publication of a 2022 peer-reviewed review \'Can Antioxidants Reduce the Toxicity of Bisphenol?\' summarizing multiple studies that several dietary antioxidants (curcumin, quercetin, melatonin, lycopene, genistein, etc.) reduce BPA\u2011induced oxidative stress in vitro and in animal models."},{"id":"8d73d89f-a149-40ab-a9d8-3bd1bf052237","text":"Regulatory controversy and mixed messaging about BPA safety after regulatory reviews (e.g., FDA\u2019s 2018 BPA assessment) prompted public debate and critical commentary from scientists."},{"id":"da8b0d27-574d-4160-874f-3dfd267572ea","text":"Takeda and Moderna publish investigation and voluntary recall statement after foreign-particle findings in Japan"},{"id":"de66ea25-fe29-493e-9ca1-a9c48d258a0c","text":"Publication and reporting of excess-mortality analyses in Japan showing increased deaths during/after the pandemic with cardiovascular diseases among contributing causes"},{"id":"9a96fed9-679f-4d77-8bae-cfea4c180fe9","text":"Public-health reports and peer-reviewed case reports document myocarditis/pericarditis occurring after mRNA COVID-19 vaccination (identified in 2021 monitoring and guidance)"},{"id":"9636e7f7-f323-42f3-9678-018b36dca663","text":"Harvard launches the Solar Geoengineering Research Program (SGRP), formalizing academic research into stratospheric aerosol methods."},{"id":"bbf6cbba-ed02-4c30-884a-e2f6eb5f8ec2","text":"IPCC Special Report on Global Warming of 1.5\xb0C (SR1.5) discusses solar radiation management (SRM) as a theoretical option and highlights governance and uncertainty issues."},{"id":"1d9c7f8c-7c46-41ed-9120-4d1ccad37e23","text":"Major media coverage highlighting geoengineering as a contested climate option (e.g., The Guardian: \'Geoengineering may be used to combat global warming, experts say\')."},{"id":"0ae871e4-c93b-499e-9729-35dd7eea531d","text":"2018 pilot study published in the Journal of Alzheimer\'s Disease reporting cognitive improvements after a 21-day coconut oil\u2013enriched Mediterranean diet"},{"id":"6fe2ff24-1c4b-4a04-94ba-def1daaaae8e","text":"International media and human-rights organizations reported abductions, torture and summary killings in eastern Ukraine (including areas around Slovyansk) during April\u2013May 2014."},{"id":"2cd17608-a3a1-4148-bac5-8ff63680024d","text":"Pro\u2011Russian militants abandoned Slovyansk and Ukrainian forces re-entered the city after the siege, leaving a chaotic information environment and reports of casualties and abuses."},{"id":"a138054c-510f-4593-b3ab-f16d92c84668","text":"Russia imposes a one\u2011year ban on many Western food imports (fruit, vegetables, meat, dairy) in retaliation to sanctions"},{"id":"719debe7-77ec-4ef4-b4fa-3292b895aacd","text":"Coverage in early 2015 highlighting that Russians were spending a much larger share of income on food amid economic turmoil"},{"id":"76c16e04-c75e-43c7-9a3f-ff2ecdcb6adb","text":"Russian rouble crashes in December 2014, prompting emergency central\u2011bank action"},{"id":"5aac0275-2df4-4079-9a43-f4d551720f5a","text":"FDA published a draft guidance clarifying aluminum limits for small-volume parenteral products used in parenteral nutrition (widely covered Dec 2022)"},{"id":"10d5a29b-3409-4a51-9ace-43d54e3fb5eb","text":"Publication of Vaccine pharmacokinetic analysis that became the benchmark for vaccine aluminum safety assessments (Mitkus et al., 2011)"},{"id":"41be2912-a92c-49cf-8992-e53ca8442812","text":"FDA warning about aluminum risk from an unapproved Hospira potassium phosphates product (FDA alert)"},{"id":"b422ade6-fe37-4342-9c94-f558dc1f6d06","text":"European Commission progress report concluded Ukraine met the benchmarks for visa liberalisation and announced it would present a legislative proposal to lift short-stay visa requirements."},{"id":"42ed635a-b8e2-47a3-adc0-3096844abd7a","text":"Immediate Dutch government reaction was cautious \u2014 officials said they would reconsider ratification and seek a formal response, but announced no immediate legal block to EU-level procedures."},{"id":"12fb89a8-7d3a-44d8-9034-eb35ba71efe1","text":"Historical precedent: Ukraine suspended passenger and cargo rail/bus links to Crimea in December 2014 citing security concerns"},{"id":"1b13c812-81e5-4522-8a73-474b58c8824a","text":"UK MHRA conditional authorisation and patient information leaflets published (regulatory materials listing ingredients and usage information)"},{"id":"3bda60e7-ed94-4ec2-9405-c9c81258a1cf","text":"FDA/BioNTech briefing documents for the VRBPAC EUA review that list vaccine components (mRNA, lipid nanoparticle constituents including PEG, salts, and sucrose)"},{"id":"be63afc2-aba4-4262-8fa9-91dd6c829ea2","text":"Ukrainian President Volodymyr Zelensky publicly floated Rustem Umerov as a possible candidate to be Ukraine\'s ambassador to the United States during the International Ukraine Recovery Conference (URC2025) in Rome."},{"id":"2f7812a5-0f4b-4681-a35b-85b384b624c8","text":"U.S. FDA public warning against using veterinary or unapproved ivermectin products to treat or prevent COVID\u201119"},{"id":"4f14a3d3-a2af-4fb4-9c5b-77e81db0e24c","text":"CDC public information noting \'common human coronaviruses\' (229E, NL63, OC43, HKU1) have been identified for decades"},{"id":"6a6243b9-18f2-454b-a36e-eaca6ac954ea","text":"Implementation of selective city-level bans on older diesel vehicles (example: Munich introduced restrictions on Euro 4 diesel vehicles in its low\u2011emission zone)."},{"id":"8bb44fdc-fdb0-4a26-882a-fc0bc28cb158","text":"European Commission publishes proposal COM(2023)451 \u2014 a draft Regulation on circularity requirements for vehicle design and management of end\u2011of\u2011life vehicles (revising ELV rules)."},{"id":"50412109-04a6-4ae7-95f1-52dcd65d0f33","text":"EU \u2018Fit for 55\u2019 / CO2 standards debate and widespread coverage of the EU aim for zero\u2011emission new cars by 2035."},{"id":"c089f020-2b1d-4af0-b3cf-0dfdea7e1451","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly opposed fast\u2011tracking Ukraine\u2019s EU accession (Dec 13, 2023)"},{"id":"c5635cfb-1ed4-443a-b1da-b1c51e0f1cdd","text":"\u2018For Ukraine, for their Freedom and Ours!\u2019 campaign urged MEP candidates to sign a pro\u2011Ukraine Commitment Charter (May 11, 2024)"},{"id":"f80084e1-f78e-45e5-afad-1851567b2f30","text":"Yle launched/ran its European election \'compass\' showing candidate positions (May 2024)"},{"id":"9c18abc8-e211-4150-99de-08279282031e","text":"European Parliament Special Committee warned of foreign interference and disinformation ahead of the June 2024 elections (May 24, 2024)"},{"id":"fb0583c0-c588-458e-ab4c-cbb0dc8d6e19","text":"Public release/submission of the RaTG13 genome sequence to public databases (GenBank accession MN996532 / GISAID submission in January 2020)."},{"id":"8b45eff6-3eec-4abe-be2b-171304c22e14","text":"BMJ Case Report (2018) and wider media attention on Macrophagic Myofasciitis (MMF) case reports linking persistent aluminium deposits at injection sites to chronic symptoms."},{"id":"036c29b2-0aed-4e11-9f8c-b89c77df016e","text":"2013 BMC Medicine study \'Slow CCL2\u2011dependent translocation of biopersistent particles from muscle to brain\' (Khan et al.)."},{"id":"62354f10-9854-4b6b-a2f0-76f2bbbb9d5c","text":"Publication of 2015 review \'Biopersistence and Brain Translocation of Aluminum Adjuvants of Vaccines\' by Gherardi et al."},{"id":"596dadca-7ecf-4ad3-9240-155524a0321a","text":"EU publicly criticises Poroshenko\'s anti\u2011corruption court bill and signals consequences (January 2018)"},{"id":"f0934c56-ec5b-4af0-a746-6e2b253770b7","text":"U.S. criminal indictment of Paul Manafort (October 2017) for unregistered lobbying related to Ukraine"},{"id":"f2549918-16ff-4631-a465-2b9b49adae82","text":"Investigative expos\xe9 on defence procurement implicating son of Poroshenko ally (Hladkovskyi)"},{"id":"4f1c4513-d2ef-45af-8edd-7f7c6d7acec7","text":"Ukrainian President Petro Poroshenko signs a cooperation agreement with Ecumenical Patriarch Bartholomew in Istanbul to advance autocephaly for a Ukrainian church."},{"id":"f5a77d26-097c-4c34-9a8d-741665227f16","text":"Reporting that President Poroshenko publicly used the Tomos and the new church as part of his 2019 re-election messaging."},{"id":"67dff1f5-a16f-4d8a-8246-08683f4356dd","text":"U.S. administration ordered an intelligence review into the origins of COVID\u201119 (President Biden, public announcement and press coverage), which brought renewed political attention to lab\u2011origin claims (May 2021)."},{"id":"87f1afab-9886-497e-bd50-ded7dc234038","text":"Reporting in mid\u20112023 that Ukraine\u2019s 2023 summer counteroffensive produced only limited gains (e.g., BBC and other outlets in August 2023) created a broader narrative of stalled Ukrainian progress"},{"id":"c892815e-ba02-4fbe-aaf9-7e5ab8e32444","text":"Japan suspends and recalls Moderna vaccine doses after foreign particles found (August\u2013September 2021)"},{"id":"1379ed5a-dc8f-4dc0-b83c-3ac31cd9020a","text":"CDC guidance allowing fully vaccinated people to resume most activities without masks (May 13, 2021) and subsequent reversals with Delta/Omicron"},{"id":"facf3501-0244-4305-9925-f7c9aa3bba25","text":"Federal judge orders expedited release of large batches of FDA/Pfizer vaccine documents after FOIA litigation (January 2022)"},{"id":"4039d703-a1d4-4cc6-ae5d-87f162f75e59","text":"CDC/ACIP update and MMWR on myocarditis reports after mRNA vaccines (June 2021)"},{"id":"75eac795-7813-4c90-849e-a328ea85cdac","text":"CDC VISION Network MMWR showing waning mRNA vaccine effectiveness during Omicron (Feb 2022)"},{"id":"2c54f3fc-53e6-4314-aef4-ec5de9731cf0","text":"Russia sends \'humanitarian convoy\' toward eastern Ukraine and insists on involvement (August 2014)"},{"id":"a225fb8e-01e5-4bc0-83bc-1cd4443cbf55","text":"Ukrainian parliament adopts law granting \'special status\' to certain areas of Donetsk and Luhansk"},{"id":"17b8c008-0413-43ef-8e62-1b3e41a4a0c4","text":"President Vladimir Putin\u2019s public justification (March 2014) for actions in Crimea citing protection of Russian speakers/compatriots"},{"id":"15eff4ff-752f-469d-ac3d-cf27e57e7342","text":"Longstanding monitoring and studies at Altamont Pass Wind Resource Area documenting unusually high raptor (including golden eagle) mortality at that site (estimates cited of ~75\u2013110 golden eagles killed annually in some monitoring periods)."},{"id":"54325ce3-1512-4768-992a-66f0f8e920f0","text":"U.S. Fish & Wildlife Service final eagle incidental-take rule (2024) \u2014 revised permitting framework and creation/clarification of general permits for qualifying wind projects (rulemaking completed Feb 2024)."},{"id":"f512e1cc-18eb-4be6-ace2-84dfa7e939d9","text":"Europe\u2019s 2022 energy-price shock and widespread reporting (Eurostat summary Apr 26, 2023) showing record household electricity and gas price increases in 2022."},{"id":"90acb2f0-5b14-4c2c-b233-ea7d144bdb5c","text":"Winter Storm Uri (Feb 2021) \u2014 widespread reporting and official ERCOT analyses showing frozen equipment across fuel and renewable sources and public debate blaming frozen wind turbines for Texas outages."},{"id":"c7e20b17-7466-4ce1-894e-90163480399c","text":"Adoption of Ukraine\'s \'decommunization\' laws banning communist symbols (including measures that led to restricting St. George\'s ribbon) by the Verkhovna Rada."},{"id":"c6950cb3-e288-4c5a-87c6-4dce2df15ab4","text":"High\u2011profile coverage in Western and regional media documenting the St. George\'s ribbon\'s revival in Russia and its adoption by pro\u2011Russian activists in eastern Ukraine around Victory Day (widely reported in 2014\u20132015)."},{"id":"67df963f-093e-4ca0-8223-a134f2b01be7","text":"British intelligence assessment reported that Russia may have lost a third of the ground forces it committed to the Ukraine offensive"},{"id":"b0aa8582-a02b-482c-97fc-31bc9bc0988b","text":"Ukrainian General Staff released casualty figures for Russian forces (tens of thousands) in mid\u2011May and publicized high cumulative loss numbers"},{"id":"3c456844-3843-408e-bba9-e1b938e9c122","text":"Public drone and ground imagery showing multiple destroyed Russian tanks and armoured vehicles around Kyiv and in Bucha after Russian withdrawals"},{"id":"413a6954-3ccb-4496-859b-9e64fcf48ad9","text":"Maxar and other commercial satellite imagery releases in May 2022 showing destroyed equipment and damage across multiple frontline areas"},{"id":"953d0f4e-de91-4c9a-857c-d602fd9feb09","text":"WHO designation of Omicron as a variant of concern and rising discussion of immune escape (Nov 26, 2021)"},{"id":"33ccea91-e7e3-422a-9dc2-d9a8020f0bdc","text":"Public\u2011health guidance reiterating vaccination after prior infection (CDC and other authorities, 2021\u2013early 2022)"},{"id":"f7ef0dab-8917-472f-a8a6-63f35eba88ff","text":"Publication of Dagan et al. (Israel) showing high real-world effectiveness of the BNT162b2 (Pfizer) vaccine"},{"id":"a962fc5f-24ff-4c6e-a247-1ff2fd6df37a","text":"Hungary blocked a NATO\u2013Ukraine commission meeting over Ukraine\'s 2017 education law"},{"id":"a1ee7052-c980-4fb2-8d5a-4cd6a16a06c2","text":"Hungarian government rhetoric defending the Hungarian minority in Zakarpattia and threatening to obstruct Ukraine\'s Euro-Atlantic integration (2017)"},{"id":"ec33a170-1453-40a4-8f20-6d255d78fe65","text":"Hungary\'s close energy and political ties with Russia (Paks II nuclear deal signed in January 2014)"},{"id":"a3cbf3f9-5255-4738-8bb1-30d03f5ea612","text":"Malaysia Airlines Flight MH17 shot down over eastern Ukraine"},{"id":"4df60cd2-ed44-49d4-af98-a38d8a7f2b7d","text":"EU/East StratCom and Western coverage documenting Russian disinformation campaigns in Europe (2015\u20132017)"},{"id":"96b80c06-b64d-48a0-a866-fa12a69c8022","text":"The OSCE Parliamentary Assembly (OSCE PA) deployed a separate observer delegation and issued a statement describing the election as \'well administered\' while also noting it took place in an \'overly controlled environment\'."},{"id":"5d3c8522-8b54-444e-996e-00ed7e252767","text":"CIS (Commonwealth of Independent States) and other regional observer missions publicly declared the election legitimate, transparent or free."},{"id":"52d563db-56f0-4713-8419-820df9a6af1a","text":"OSCE/ODIHR published a preliminary statement saying the 18 March 2018 Russian presidential election \'lacked real choice\' and noted pressure on critical voices."},{"id":"371d4c61-e8be-4e96-8f8b-41fbd855bb80","text":"Brazilian President Jair Bolsonaro publicly called COVID\u201119 \'a little flu\' and urged reopening despite rising cases."},{"id":"361583a1-3ab5-4990-b50e-486b2864d236","text":"U.S. CDC published its estimated burden for the 2019\u20132020 influenza season (tens of thousands of flu deaths) during spring 2020."},{"id":"358b2051-a2c0-4f07-a722-49419301d4ac","text":"U.S. CDC issued guidance for certifying deaths due to COVID\u201119 allowing certifiers to report COVID\u201119 on death certificates without laboratory confirmation in certain circumstances (Guidance for Certifying COVID\u201119 Deaths, April 2020)."},{"id":"cfe79470-7eb9-4ab4-8c55-75b6311329e8","text":"International monitors curtailed/paused long-range drone surveillance after repeated shoot-downs and jamming"},{"id":"c6969ea7-2cb0-48fc-a29e-5d0e2e3dcc0a","text":"OSCE long-range UAV lost after spotting a surface-to-air missile system near Donetsk"},{"id":"2be8f441-d916-4f8a-bbd3-87bb25330991","text":"Pentagon comments and reporting that a limited amount of Presidential Drawdown Authority/stockpiles remained to provide to Ukraine (public discussion of remaining resources)"},{"id":"b30e4341-3899-4e8e-9c88-1b334e46e7a4","text":"President Biden formally requested roughly $24 billion in new aid for Ukraine (public request to Congress)"},{"id":"970ef17c-9ae1-4064-bafa-37436103dbfb","text":"U.S. State Department and other reports described Ukrainian procedures allowing some civil-status acts (for example, births) occurring in occupied areas to be registered using documents produced by occupation authorities to ensure access to services."},{"id":"ccd393be-47d2-41d6-871b-4624f8aca860","text":"Ukrainian Ombudsman statement noting Ukraine does not recognize Russian passports issued in occupied territories, while discussing legislative options for how residents might renounce such documents after liberation."},{"id":"274701e0-c87e-4a92-8ffc-f0e549a34634","text":"Verkhovna Rada approved a mechanism to evaluate/validate educational documents issued in temporarily occupied territories (draft law passed to create testing/validation procedures)."},{"id":"3cbf07f1-46b7-4d3c-9da2-4e78f0de56fd","text":"Ukraine engaged in limited, practical negotiations and humanitarian arrangements (e.g., corridors for ships, humanitarian talks) with actors linked to occupied areas and with mediators in 2023."},{"id":"e0b9ec6a-ef37-4be8-9a8f-fb3a4eaed21c","text":"Samoa measles outbreak and prior botched MMR injections that caused two infant deaths, undermining local vaccine confidence"},{"id":"d9cfc5d8-142b-4158-8b7d-58772f988b60","text":"CDC reporting of rare myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination in adolescents"},{"id":"db26f402-9699-4f53-adc2-5c49174a685c","text":"New York Times feature \'In Washington, Olena Zelenska Dressed for Ukraine\' describing her Washington wardrobe, the role of her stylist, and the diplomatic messaging in her clothing choices."},{"id":"b448de85-22bb-4921-bedf-84e814f19ea8","text":"Tobacco industry pivot and public messaging promoting nicotine products (e.g., BAT reporting growth in vaping/oral nicotine)"},{"id":"abd62fb9-dfd6-451a-b1e2-5c9a1b4eb5a6","text":"Cochrane systematic review finding transdermal nicotine superior to placebo for active ulcerative colitis (with important limitations)"},{"id":"b3afa837-aa0d-4eb9-a7c8-517a907dfa27","text":"Small Phase 1 trial of an alpha7\u2011nicotinic agonist showing biomarker and attention effects in two adults with autism"},{"id":"29685c61-610b-4a8b-99ab-2e16778e13f1","text":"Early reporting and analysis warned that Russian tactics could include heavy artillery, siege and attrition that would \'grind down\' Ukrainian defenses and cities."},{"id":"f051cc8c-6a20-4d6c-a0cb-43d0d946125c","text":"U.S. Secretary of State Antony Blinken made multiple public remarks in early March emphasizing both the scale of Russian forces and U.S. support for Ukraine (including a March 6 interview where he said Putin \'is destined to lose\')."},{"id":"b8deb308-1885-4578-90fc-5e30e5808a8d","text":"USDA and FDA announce formal agreement on regulation of cell\u2011cultured food products"},{"id":"b3be0f40-8fdc-4f79-aeeb-9a3360f22c21","text":"GFI (Good Food Institute) \'2022 Cultivated Meat State of the Industry\' report (published Jan 2023)"},{"id":"80e39e30-3b7e-41fc-a1c4-99fb925668b9","text":"First PEGIDA offshoot rally in Sweden (Malm\xf6) and associated media coverage of anti\u2011Islam/anti\u2011migration street demonstrations"},{"id":"19e97047-b708-411c-b6f1-59ca118e857a","text":"U.S. FDA approval of VEKLURY (remdesivir) for COVID\u201119 treatment (press announcement and approval) in October 2020."},{"id":"be38e493-a4a0-49ec-abd2-bb6182778ce7","text":"PALM (Ebola) randomized trial (NEJM, 2019) stopped remdesivir arm after interim results showed higher 28\u2011day mortality in the remdesivir group compared with certain monoclonal antibody treatments."},{"id":"e25d9cc2-d1d6-41c0-aa75-5ef3d6ae4d81","text":"President Zelensky dismissed all regional military recruitment centre heads amid a corruption scandal (public firing announced 11 August 2023)."},{"id":"759bc274-fc7e-4c8c-875f-5d9d3e0bc6d1","text":"Verified reports of real civilian fatalities in Bila Tserkva from previous Russian attacks (example: kamikaze drone/strike reported 05 October 2022 with at least one casualty)."},{"id":"aa77c6dd-6815-4ee7-95cc-9f476723df75","text":"A separate, real violent incident linked to conscription/document checks was reported (draft officer fatally wounded during a papers check in Lviv)."},{"id":"436ac542-f466-477c-90f1-8779404eafbf","text":"President Obama and some Western leaders publicly deferred sending lethal weapons to Ukraine (reported agreement not to supply lethal defensive arms at that time)."},{"id":"c38dd94a-ab02-4ef1-bb83-5b2fcecec724","text":"Canada launched Operation UNIFIER, a Canadian Armed Forces training mission to Ukraine."},{"id":"48530f0d-bb14-4da4-9e07-c07bd14e1a91","text":"Pentagon suspended planned military exercises and activities with Russia amid the Ukraine crisis."},{"id":"b3888e25-51f1-4dc1-8dc9-941a6e307477","text":"NATO Secretary-General publicly stated NATO had no plans to deploy combat troops to Ukraine."},{"id":"0a12843a-9484-48c5-92c6-08e7bbd4cdab","text":"NSIDC analysis: unusually rapid December 2023 sea-ice expansion noted in early January 2024 (\'Fast December expansion\')"},{"id":"9d9565d5-8ea3-4db0-911c-a1ab63581ca2","text":"IPCC AR6 (WGI) projection showing Arctic likely to be \'practically ice-free\' in summer near mid-century (released Aug 2021)"},{"id":"149b435e-0838-4b78-ac8a-64e644aa02d5","text":"Sterigenics / Willowbrook ethylene oxide emissions controversy and EPA/CDC assessments (facility operations suspended/closed amid cancer\u2011risk concerns)."},{"id":"d2f0ec5a-c60f-47ad-8641-9bb20c727dd0","text":"Ukrainian authorities agreed to implement the \'Steinmeier formula\' as part of efforts to restart Minsk-format negotiations (announced Oct 1\u20132, 2019)."},{"id":"a5df38b9-2deb-4820-9ba6-667ae40ca26d","text":"Volodymyr Zelensky publicly proposed direct talks and a conciliatory approach to Russia after taking office, signalling a priority on negotiation and rapprochement."},{"id":"a822c036-5334-41e1-8f49-d66ea1f5558b","text":"Russia and Ukraine carried out a high-profile prisoner exchange in early September 2019, swapping dozens of detainees."},{"id":"07afca8c-75c7-4e63-b710-40046c2ea030","text":"Ukraine\'s legal framework largely prohibits/does not recognize dual citizenship (Law on Citizenship of Ukraine, enacted)"},{"id":"2b6a207f-016f-41c5-b2cd-490c79cdd5ed","text":"Russia begins mass issuance of Russian passports in annexed Crimea (widely reported)"},{"id":"e1e40157-3022-4baf-a59b-3802d4ce6a78","text":"Italian TV documentary \'Ucraina, le verit\xe0 nascoste\' by Gian Micalessin aired on Canale 5 (Matrix) and presented testimony alleging Georgian snipers fired on Maidan protesters."},{"id":"314b9885-f959-4540-8a81-6db59af29278","text":"Zeman\'s high\u2011profile engagement with Russia (including attending Moscow Victory Day events and meeting Putin in May 2015)."},{"id":"3f33bcc6-16fd-4146-9119-4063190d2547","text":"Zeman\'s October 2017 PACE remarks calling the annexation of Crimea a \'fait accompli\' and suggesting compensation."},{"id":"37bb4f09-1949-4ca9-925f-f2f7f5fae02a","text":"Pro\u2011Kremlin Crimean Tatar group Kyrym Birligi was invited to the presidential Independence Day reception at Prague Castle."},{"id":"6dba0146-ee5c-4d22-8202-366446328116","text":"Widespread news stories and headlines (e.g., Meduza) summarising Zelensky\'s comments emphasizing Ukraine could pursue a diplomatic return of Crimea rather than costly military operations"},{"id":"8c6381d1-06d3-48cd-9fcb-f6d47803b1c8","text":"DFRLab report documenting increasing use of AI\u2011generated audio/video and synthetic media in the Ukraine information space (showing precedent and tools available for falsifying statements)"},{"id":"afa3f769-5fb0-4994-aa0a-de98c97a7804","text":"Pre-existing public commemorations of Stepan Bandera in Ukraine (e.g., Kyiv renaming Moscow Avenue to Bandera Avenue in 2016)"},{"id":"e1ed5bff-cfaa-4746-a821-bb42e9eee497","text":"India (Serum Institute) placed temporary export restrictions on AstraZeneca/COVISHIELD supplies as domestic COVID-19 cases surged, delaying shipments to COVAX and other countries."},{"id":"a6488430-f13d-4976-8ffa-b5d2a3a03f1d","text":"WHO leaders publicly warned that vaccine supply was limited and urged countries to prioritise high-risk groups and support equitable distribution rather than assume immediate universal coverage."},{"id":"9e7eed4f-220c-42c1-8287-6912c7842d0e","text":"COVAX cut its 2021 delivery target after supply problems, announcing a lower-than-expected dose forecast and warning it would fall short of initial goals."},{"id":"94c08630-0cd5-48a4-ac1e-abb0096a007d","text":"Contamination and production errors at Emergent BioSolutions\' Baltimore plant led to the destruction or sequestering of millions of vaccine doses and an FDA-ordered manufacturing pause."},{"id":"e4020dee-d50d-426e-abc1-808bd759fcd8","text":"Reports in early 2021 that lipid nanoparticles and other specialized raw materials used in mRNA vaccines faced constrained global supply with few suppliers."},{"id":"51c79555-6f9f-43e9-bffc-8e400d241a59","text":"German Bundestag held a special session (27 February 2022) condemning Russia\u2019s full\u2011scale invasion and reaffirming Ukraine\u2019s territorial integrity"},{"id":"1b6307cb-cc36-4ffc-a619-8d593dbd8424","text":"WHO declaration of a Public Health Emergency of International Concern (PHEIC) for the novel coronavirus"},{"id":"61c5a464-83ba-41ba-a8e3-4ea93188d477","text":"ClinicalTrials.gov registration NCT04264533: \'Vitamin C Infusion for the Treatment of Novel Coronavirus Pneumonia (COVID-19)\' (trial listing for high\u2011dose IV vitamin C in Wuhan)"},{"id":"914a2057-3abf-4b5e-bf8d-7a86635735ff","text":"Institute of Medicine (IOM) report \'Immunization Safety Review: SV40 Contamination of Polio Vaccine and Cancer\' published"},{"id":"77f2d1fe-fcaa-4e36-af2a-d7e947ebc3b5","text":"Major media coverage attributing growing fire severity to climate change (e.g., New York Times analysis, Nov 2018)"},{"id":"d31e760e-221b-405a-b2a4-4d4e8770860f","text":"Camp Fire (California, 2018) linked to failing utility equipment (PG&E)"},{"id":"4338c56d-1ee1-42e6-8b86-59066fe99e57","text":"2019\u201320 Australian \'Black Summer\' bushfires and public debate blaming land management policies"},{"id":"5b404305-a187-4827-a04c-da7ccb6139a8","text":"Precedent of cross-border attribution confusion: Przewod\xf3w missile incident (Poland, Nov 2022)"},{"id":"ac80fb30-7c46-4efa-8203-8849169b83ab","text":"Poland officially accused Russian intelligence of ordering the arson (government announcement)"},{"id":"462638c9-c9ce-4650-af3c-bfb23f68d25a","text":"Reports that Ukrainian nationals were among suspects detained/charged in connection with the fire"},{"id":"474f5052-9cdd-45c6-950f-9afa02aad4d8","text":"Massive fire destroyed the Marywilska 44 shopping centre in Warsaw (original incident)"},{"id":"2351854f-aaf1-4bfd-984c-3bc9d980c1b0","text":"bioRxiv preprint demonstrating inhalable polymer nanoparticles for mRNA delivery (preprint posted March 23, 2022)."},{"id":"84cb69d6-6cbf-4df8-8678-144ef113fd4a","text":"Regulatory findings and national pauses/age\u2011restrictions after reports of very rare thrombosis with thrombocytopenia syndrome (TTS) following the AstraZeneca vaccine."},{"id":"a994e659-49e3-4806-825e-e666077e798c","text":"Official statistics showing substantial \'excess deaths\' in 2022 (published reports covering March 2020\u2013Dec 2022), prompting public debate about causes of excess mortality."},{"id":"f6142039-3fc7-4af3-a3a9-87d0c7da5003","text":"Published studies showing markedly reduced vaccine effectiveness at preventing infection with the Omicron variant (while protection against severe disease remained better)."},{"id":"2b07e9d4-c9eb-4255-bac4-e301f267a58e","text":"Peer\u2011reviewed reports and surveillance data linking mRNA vaccines to rare cases of myocarditis, especially in adolescent and young adult males."},{"id":"bb748b52-4304-4eed-b247-e4d11a492e1f","text":"Press coverage reporting ~1 million Ukrainians working legally in Poland (KyivPost article, April 27, 2017)."},{"id":"0d7d7cd6-18a4-4333-9251-d959fbe2f715","text":"ILO / national labour statistics for 2017 showing Ukraine\'s unemployment rate around ~9\u201310% (not a new historical high) and contrasting definitions between \'registered\' unemployment and ILO measures."},{"id":"99d986ba-d36c-4bd0-ba02-28432c62c77b","text":"World Bank / Migration and Remittances Factbook 2016 and related World Bank migration data showing migrant stocks/remittances far lower than 45% of Ukraine\'s population (Migration & Remittances Factbook 2016)."},{"id":"b3692450-a4bf-4345-8f0e-6dbb92d3e3a6","text":"US NTP/NIEHS 2018 partial findings on cell\u2011phone radiation and tumors in rats"},{"id":"1f48df8f-b219-4947-8919-21cc9365cf67","text":"IARC classifies radiofrequency electromagnetic fields as \'possibly carcinogenic\' (Group 2B)"},{"id":"2bc1e157-e741-4377-899a-793c3a322854","text":"Publication: \'Static magnetic fields from earphones: Detailed measurements plus some open questions\' (Environmental Research)"},{"id":"bf48e0c8-6b76-4bd1-bb96-cfe6388a9243","text":"CDC laboratory/testing guidance updates in September 2020 clarifying testing recommendations for asymptomatic people (CDC posted a laboratory update clarifying testing for SARS-CoV-2 on Sept 18, 2020)."},{"id":"b753f791-7516-41db-940f-1798e0fdfbf0","text":"WHO EMRO (Eastern Mediterranean Regional Office) guidance page (June 11, 2020) summarised evidence as indicating \'most transmission occurs from symptomatic people\' while discussing asymptomatic cases."},{"id":"bc24047c-2c1a-409c-8084-6070c6077d84","text":"Kyiv renamed a major thoroughfare (Moskovskyi/Moscow Avenue) after Stepan Bandera (renaming enacted July 2016)."},{"id":"80264d7f-d885-40ac-9716-ec548a6a18a9","text":"Torch\u2011lit nationalist marches in Kyiv commemorating Stepan Bandera and other WWII nationalist figures (widely reported torchlight marches, e.g. 14 October 2018)."},{"id":"527dc6f0-d251-4dee-8108-e6d965d1acff","text":"Passage of Ukraine\'s \'decommunization\' laws that banned Soviet symbols and rewrote certain aspects of public memory (April\u2013May 2015)."},{"id":"bfd00629-aad9-4669-991f-7ce7632d7aed","text":"March 2019 law/instruments extending veteran status or recognition to surviving members/participants of the UPA/OUN (legal changes coming into force in March 2019)."},{"id":"2988ed3f-8d55-42a9-aeb8-1e289dc22a22","text":"Media reports documenting neo\u2011Nazi links in the Azov volunteer unit (coverage of ideology, symbols and far\u2011right volunteers)."},{"id":"794945b4-9967-4114-b28b-9b21276600bf","text":"Swiss authorities announced an immediate freeze on assets linked to Yanukovych and members of his entourage (Switzerland froze assets and opened probes in February 2014)."},{"id":"8d3033f8-b26c-49a6-bbbd-29649925f2d7","text":"Ukrainian authorities announced confiscation/transfer of roughly $1.5 billion in assets allegedly linked to Yanukovych and his circle into state accounts (reported April 2017)."},{"id":"763490bf-d450-4201-b047-b5795f2a279c","text":"Ukraine imposed a moratorium/default on repayment of the $3 billion Russian-held Eurobond that matured in December 2015."},{"id":"6f3937e0-0969-4b7c-a2d8-449c9102e2e4","text":"Russia filed a lawsuit in London\'s High Court seeking repayment of a $3 billion Eurobond the Yanukovych-era government issued to Russia."},{"id":"7cd1d0a8-4b6b-4508-a82c-dee4ee393d40","text":"UN Secretary-General Antonio Guterres warned the shelling around Zaporizhzhia was \'suicidal\' and called for cessation of military activity"},{"id":"b1a14284-7971-48a7-af1e-919877929a63","text":"March 4, 2022 shelling and fire at Zaporizhzhia during Russia\'s seizure of the plant (initial chaos and conflicting reports)"},{"id":"06b40460-322d-4c00-a603-7425c216f72c","text":"Russian officials and state media publicly accused Ukrainian forces of shelling/damaging Zaporizhzhia and pushed narratives blaming Kyiv"},{"id":"3b680279-da88-4981-ac94-ffeb7428e442","text":"Public opinion polls in early February 2024 showed Zaluzhnyi with very high trust ratings in Ukraine."},{"id":"a5948f0b-108c-4450-9313-80c4b9d2bf63","text":"President Zelensky dismissed Valerii Zaluzhnyi as Commander\u2011in\u2011Chief of the Armed Forces of Ukraine."},{"id":"2e53e34e-8b05-4afd-b21e-a0cdf3cdd9f6","text":"OSCE announced deployment/observer activity at Russian checkpoints on the Russia\u2013Ukraine border (Gukovo and Donetsk) and documented cross\u2011border security incidents in July 2014."},{"id":"1efdbb35-4dfb-439c-868f-834c7b846857","text":"Russian authorities reported mortar and artillery rounds fired from Ukrainian-held territory landing in Russia\'s Rostov region (claim that shells hit Russian towns, July 2014)."},{"id":"d9f48841-a61f-46f7-9539-6a5c05b24109","text":"Media coverage in April 2014 and thereafter reported repeated airspace violations and frequent scrambling of jets around the Russia\u2013Ukraine border (Pentagon/BBC/other outlets described routine airspace breaches during the 2014 crisis)."},{"id":"de49b199-c805-4af8-86b0-6d89346ccf9f","text":"WENRA (Western European Nuclear Regulators Association) published a position (11 March 2022) documenting the loss of external power supplies to facilities in the Chornobyl exclusion zone and assessed risks"},{"id":"ec647ebf-9926-4360-bc7b-b5ce0e925bce","text":"Ukraine\'s national operator and officials said restoring the damaged transmission lines to the exclusion zone was not immediately possible"},{"id":"533a7bd6-e829-42a4-9db0-d65325e0a19b","text":"Russian forces seized control of the Chornobyl site and exclusion zone early in the invasion (reported 24 February 2022)"},{"id":"e158fda9-8d0a-47f7-b059-e84c1c800e8e","text":"Belarus opposition candidate Sviatlana Tsikhanouskaya fled to Lithuania amid the crackdown on protesters."},{"id":"ab431245-f9f2-4fc8-9151-1a933d1cc17a","text":"Public demonstrations of support for Belarusian protesters in neighbouring countries (large rallies and solidarity events in Poland and elsewhere around Aug 13)."},{"id":"13d983ca-227d-4fce-a25c-5601ce01e1b8","text":"Formation of the Lublin Triangle (Poland\u2013Lithuania\u2013Ukraine trilateral platform announced)."},{"id":"59ba3908-5409-4ccc-a9c8-03413841cd4f","text":"Mass influx of Ukrainian refugees into Poland after Russia\'s full-scale invasion (activation of EU Temporary Protection, March 2022 onwards)."},{"id":"b2bdcd0b-beea-4a69-a3e2-7a51305b0555","text":"Gazeta Wyborcza article reports rapid rise of Ukrainian residents in Wroc\u0142aw (\'Almost every third resident of Wroclaw is Ukrainian\')."},{"id":"69cc96b7-da30-47d5-8424-4e395d087944","text":"Polish media outlets and public services launched Ukrainian-language sections and information hubs (example: Polish newsrooms adding Ukrainian-language content, Ukrainian support centres established)."},{"id":"ed0ec28b-9f14-4602-b693-8e65024224e6","text":"Explosions and missile strikes hit nearby cities (notably Mykolaiv and Odesa) on 12\u201313 May 2022; local officials said some strikes on Mykolaiv/Odesa were linked to launches from the Kherson area."},{"id":"7b589fb6-b848-4438-b798-8bbc2aa8a6cb","text":"Prominent international coverage of far\u2011right Ukrainian units (notably the Azov regiment) and their integration into national forces during spring 2022."},{"id":"d0d92bc5-9c68-46c6-9788-5f5e4bd08bdd","text":"Earlier Russian Defence Ministry / RIA-style reports accused Ukrainian forces of striking civilian sites in the Kherson region (e.g., schools, cemeteries) at the start of May 2022."},{"id":"bde37614-97d3-4d15-b062-c738dd33f745","text":"CDC recommends cloth face coverings for the public (source control)"},{"id":"fe2cb97c-fe95-4131-9801-37c0348a8a00","text":"WHO issues \'COVID-19: considerations for tuberculosis (TB) care\' information note"},{"id":"1a5b6ba3-e0fc-4c63-8ff0-c46957cbc8b6","text":"July 2021 Provincetown, MA outbreak where many cases occurred among vaccinated people (CDC MMWR published August 2021)"},{"id":"c48a7be2-6dcc-42a1-8ce9-14c71ebcbfbf","text":"Large cluster-randomized Bangladesh mask promotion trial (Abaluck et al./Science) published August 2021 with nuanced results"},{"id":"ce8beb5a-1438-4adc-a947-a64fd2fb1c03","text":"CDC reversed earlier guidance and in July 2021 again recommended indoor masks for vaccinated people because of the Delta variant"},{"id":"240a0d40-b046-4558-ba3a-102a30c4af61","text":"DANMASK-19 randomized trial (Denmark) published November 2020 found limited measurable protection to the wearer"},{"id":"70c05f1a-ed99-4420-a739-2e3fb45d6e38","text":"Earlier (2015) online reports claimed an \'Assembly of the Romanians of Bukovina\' had been formed and had previously voiced grievances about status/rights in northern Bukovina."},{"id":"dad945d1-7f00-4509-8a65-103e7f8afbe2","text":"Following the awards, Gazprom refused/reserved deliveries and reduced transit pressure to Ukraine in early March 2018"},{"id":"7da6de1a-35b8-4a75-a954-1c24437d58d6","text":"Naftogaz published the full Stockholm award texts and initiated enforcement actions in multiple jurisdictions (e.g., Swiss/UK enforcement steps were announced)"},{"id":"5f808033-32ef-47a2-8cf8-fe0d1db9977a","text":"The awards were legally complex and split across separate supply and transit rulings with offsetting liabilities rather than a single, simple judgment"},{"id":"dc1d910d-a266-4155-a4df-137451cf698c","text":"U.S. National Toxicology Program (NTP) publishes high\u2011profile rodent RFR studies (final reports/public summaries circulated in 2018)"},{"id":"2bfb27e5-8f73-4a0f-9c57-06def4d4564c","text":"International EMF Scientist Appeal (roughly 250 scientists sign public appeal calling for stricter RF limits, 2015)"},{"id":"00e97291-053f-40c0-8f73-0927fe29385d","text":"IARC (WHO) classifies radiofrequency electromagnetic fields as \'possibly carcinogenic to humans\' (Group 2B)"},{"id":"a821d7c6-d6e1-48de-9505-56526b0c68ce","text":"Major measles outbreak in Samoa (late 2019) that caused thousands of cases and dozens of deaths and led to a national state of emergency."},{"id":"349a4808-5100-43dc-bb93-0a3696bc93c0","text":"Two infants in Samoa died after receiving MMR vaccine due to incorrect diluent administration, sparking local fear of vaccines."},{"id":"57bf6299-78f3-4468-8703-37069d49fbea","text":"Nordic countries (Sweden, Denmark, Finland) restricted or paused use of Moderna\u2019s mRNA vaccine for younger people over myocarditis concerns"},{"id":"eed4e8b4-0522-483b-8749-518e3904ed41","text":"Japan identifies stainless-steel/foreign particles in multiple Moderna vaccine vials, leading to suspension/recall of specific lots"},{"id":"2f0d2e62-8a4b-4aad-988c-697711c78a85","text":"Verkhovna Rada adopts the Law \'On Ensuring the Functioning of Ukrainian as the State Language\'."},{"id":"4f631004-9ca8-46a8-abc0-375b2a381ce5","text":"The 2019 language law entered into force (implementation date announced/commenced)."},{"id":"ac1702a8-31f0-43f1-8a23-564f62f7bea5","text":"Passage of the 2017 Education Law that restricted minority\u2011language instruction (including limits affecting Russian\u2011language schooling)."},{"id":"897cfbf4-b0f6-4c58-9b83-b6b3531ac3cf","text":"OSCE monitor wounded after coming under fire leading the OSCE to review operations in the conflict zone"},{"id":"d8aa675d-70d7-41d6-8136-614334dea547","text":"OSCE spot report documenting heavy shelling and multiple shell craters near Donetsk (including school shelling)"},{"id":"9f4f2079-e0e1-4455-a99e-e13c6b676c41","text":"OSCE SMM vehicles struck by artillery/mortar fragments near Kirovske while on patrol"},{"id":"feb7be62-542f-4fda-98d2-d62b041b7e4e","text":"FDA issued an Emergency Use Authorization (EUA) for chloroquine/hydroxychloroquine to treat COVID\u201119 (announced in late March 2020)"},{"id":"47e1651b-b1de-4e01-bcad-20e5d94c4d6e","text":"Wang et al. in vitro study showing remdesivir and chloroquine inhibit SARS-CoV-2 in cultured cells published (Cell Research)"},{"id":"b5802323-7512-44b7-a2c3-95a5d43334ad","text":"National Academies report \'Reflecting Sunlight\' recommends a research program on solar geoengineering (including stratospheric aerosol injection)"},{"id":"0cad8084-1fb8-40fb-891c-30a8b4e846e3","text":"Operation Popeye (U.S. cloud-seeding program in Vietnam, 1967\u20131972) documented in declassified reporting"},{"id":"8042590e-9b0e-458b-8097-3fb2fc4e378e","text":"HAARP facility transferred from US Air Force to University of Alaska (facility described publicly as a powerful ionospheric heater)"},{"id":"0c64d8cd-4d2e-4cd3-827f-152ecf89cd6a","text":"1996 USAF paper \u2018Weather as a Force Multiplier: Owning the Weather in 2025\u2019 published"},{"id":"250dfb59-beb0-473d-bcfa-07bba81b251a","text":"Harvard SCoPEx geoengineering balloon test in Sweden paused after public controversy and advisory review (SCoPEx advisory committee recommendation)"},{"id":"f808aef8-b4f3-4d04-9092-ead8a7ea4b52","text":"Arkansas legislature passed HB1578 (2015), a law that required abortion providers to inform patients about the possibility of reversing a medication abortion."},{"id":"27f39ead-207c-4f99-9b63-e2741885a881","text":"Media reporting in December 2019 (e.g., NPR) that a randomized clinical trial testing progesterone to antagonize mifepristone was stopped early because several participants experienced severe bleeding."},{"id":"ea5487cb-bfc0-42cc-939b-3e2c476660f8","text":"Publication of \'Medicinal smoke reduces airborne bacteria\' (Journal of Ethnopharmacology, 2007)."},{"id":"35c63cbc-56e1-4b7c-addf-1efbf72b74dd","text":"Early COVID-19 pandemic surge in March 2020 driving widespread sharing of home remedies and \'air-cleansing\' tips on social media and messaging apps."},{"id":"6d655859-153d-4ca8-9eb1-061406ef278e","text":"IMF Article IV / Staff report highlighted Moldova\'s fiscal pressures and recommended pension-system sustainability measures."},{"id":"ccf58259-edef-418e-bf13-39bfcdab2d92","text":"2023 budget law amendments that changed tax regulations (Law No. 212 / Gazette publication August 2023)."},{"id":"1c54c370-6580-412e-aead-a07fdebd2ba0","text":"Government conscription/draft calls in 2024\u20132025 (e.g., plans to conscript ~1,200 in Nov 2024\u2013Jan 2025 and further calls in spring 2025)."},{"id":"7f28a7bc-70ce-4f0a-87b6-75423e554efa","text":"Legally scheduled gradual equalization and increases in retirement age for women (increment applied July 1, 2024)."},{"id":"1d967dcf-2dc6-4846-9278-42ad23f9103e","text":"Public warnings by President Maia Sandu about anticipated Russian interference and disinformation in the 2025 election campaign."},{"id":"6fb200b9-76cb-4e7a-9da7-c612ff8f45de","text":"Liguria Regional Council adopted a non\u2011binding motion urging the Italian government to review EU sanctions on Russia and to acknowledge Crimea\'s \'right to self\u2011determination\' (widely misreported as formal recognition)."},{"id":"4cfd60ef-933f-4a85-9639-8e8f76160982","text":"Lega Nord regional councillor (Giancarlo Piana/Piana) travelled to Crimea and publicly advocated closer ties and opposing sanctions; local press covered the visit and statements in late June 2016."},{"id":"480fdcfe-9df0-49d9-827d-49a35cd43537","text":"Sharp rise in short-term employment registrations in 2018, dominated by Ukrainian nationals (Police and Border Guard Board data showing short-term employment registrations rose to 19,858 in 2018)."},{"id":"d665ad60-4c24-4eb5-8ff4-f9aca6191179","text":"Statistics Estonia reported a small population increase and noted changing composition with rising numbers of foreign nationals/immigrants in the 2018 data release (Statistics Estonia news releases on population, January 2019)."},{"id":"d211d8ee-2556-497d-be81-2865b576a377","text":"Rise of the far-right EKRE party in the 2019 parliamentary elections and April 2019 coalition talks (EKRE entered coalition discussions on April 6, 2019), accompanied by strong anti-immigration rhetoric in campaign coverage."},{"id":"922400ce-ba75-4f8f-a222-f8cb9e8ff341","text":"Rail Baltica cross\u2011border integration steps and EU documentation advancing Poland\u2011Lithuania rail connection (project materials published, technical/operational coordination at border sections)."},{"id":"26df25ea-ebb8-4523-b4f6-0e534c9ae98a","text":"Original intergovernmental agreement establishing the Lithuanian\u2011Polish\u2011Ukrainian Brigade (LITPOLUKRBRIG) signed in Warsaw (formal creation and headquarters placement in Poland)."},{"id":"9f2c235c-00dc-467c-bda5-b638f7d5931f","text":"Increased NATO/Polish military activity and formal commitments on the eastern flank in 2020 (Poland and Lithuania assigned brigades to NATO multinational structures; documented interoperability activities)."},{"id":"618c034b-41a8-4f29-a823-8e13421cc4fb","text":"Kyiv shut metro services and further restricted public transportation in mid\u2011March 2020 (national/local announcements)"},{"id":"98f18c47-1019-4558-afd0-14a46c1a1b53","text":"Background existence of Kyiv \u2018Municipal Guard\u2019 (created 2015) with some members drawn from volunteer/veteran communities"},{"id":"b249d910-8a47-4262-8dc7-297740f4a7a7","text":"Authorities announced joint patrols involving the National Police, National Guard and Military Police beginning around March 22, 2020"},{"id":"5f1040ab-f1b0-405c-9765-93d1480dcc96","text":"January 2021 reports from Norway that some very frail, elderly patients died after receiving the Pfizer/BioNTech vaccine and subsequent official reviews."},{"id":"e4684dd9-7a98-4f31-a99d-dd05c67773bd","text":"Russian leadership framed the 2022 invasion as a \'denazification\' mission."},{"id":"10105712-0635-4e4a-8fcc-db4546350110","text":"International reporting and analysis on the Azov regiment\'s far\u2011right imagery and controversies."},{"id":"9cf44ede-37dd-4147-8e93-89a5b38604fa","text":"Reports and temporary suspension in Japan of some Moderna vaccine batches after detection of foreign particles (August 2021)"},{"id":"9f5ea13d-dbcb-4125-8e01-5e0baaf11160","text":"CDC reports and ACIP review of myocarditis signals after mRNA vaccination (June 2021 MMWR/ACIP update)"},{"id":"86e752df-f478-4714-b1d7-0b9fd5e2c12a","text":"EMA determination of a possible link between AstraZeneca vaccine and very rare blood clots with low platelets (VITT), April 2021"},{"id":"1ff3eb76-86fd-4185-9efe-c263bc93099f","text":"Poroshenko strips high-profile individuals of Ukrainian citizenship (e.g., Mikheil Saakashvili)"},{"id":"21bd8c67-264e-42eb-8b0e-db6c24c5c21c","text":"CDC interim guidance for election polling locations and voters recommending masks and other measures"},{"id":"0cb2ce22-eec1-4086-8d9d-aeffcdc506d7","text":"Nature Medicine study showing face masks reduce respiratory virus shedding (Leung et al.)"},{"id":"f19197e0-4097-457f-8a6f-30ca2c690b11","text":"Wisconsin in-person primary conducted during pandemic with long lines and media coverage"},{"id":"9ebbd19c-1b2c-41b2-9e3b-01e96f03ba4f","text":"CDC recommends cloth face coverings for the public"},{"id":"42add791-b448-41e4-b232-feb4502ab26c","text":"FDA\u2019s tissue\u2011agnostic accelerated approval of pembrolizumab for MSI\u2011H/dMMR tumors"},{"id":"da01f00d-df9a-44d9-bb12-f41c09aed89b","text":"2018 Nobel Prize in Physiology or Medicine awarded to James Allison and Tasuku Honjo for cancer immunotherapy"},{"id":"5a816559-a964-4ecf-a8d4-147202021cee","text":"First US approval of a CAR\u2011T cell therapy (Kymriah, tisagenlecleucel)"},{"id":"51c0d92f-0651-465b-99bf-de8081c26d82","text":"AstraZeneca paused its COVID-19 vaccine trial after a volunteer developed an unexplained serious illness."},{"id":"8cada1de-aec0-4ba8-97e5-04e36d363054","text":"Large, high-profile seroprevalence releases (e.g., New York State antibody study) showing many people with antibodies"},{"id":"9bcf8d43-87e4-411f-8731-00fa3640de8d","text":"Media reports and investigations documenting a flood of unvalidated/poor-quality COVID-19 antibody tests on the U.S. market after relaxed FDA oversight"},{"id":"4e359298-f7bc-44e1-a224-0d0d64bb4b78","text":"CDC serology guidance updated to note possible cross-reactivity of antibody tests with other coronaviruses"},{"id":"75f2c098-7112-4a25-8031-e3a6116f5af5","text":"IARC (WHO) classified aspartame as \'possibly carcinogenic to humans\' (Group 2B), prompting widespread media coverage."},{"id":"a55c1b2e-bab8-49b4-ac95-ac161af5ec93","text":"WHO published a guideline (Use of non-sugar sweeteners) recommending that non-sugar sweeteners should not be used for weight control or reducing noncommunicable disease risk."},{"id":"4e0bbe89-492f-4dfa-be07-cd56528fc90b","text":"U.S. Federal Trade Commission (FTC) sent warning letters (Nov 2023) to two trade associations and a dozen influencers about inadequate disclosures for paid posts promoting aspartame/sugar products."},{"id":"4566b36e-d3ea-4ec7-9e9b-7343a650fdce","text":"WHO updated interim guidance on mask use (June 5, 2020)"},{"id":"0d8ba46f-3371-4146-b302-4566ce200350","text":"Systematic review and meta-analysis (Bartoszko et al.) on medical masks vs N95 respirators (Influenza and Other Respiratory Viruses, 2020)"},{"id":"191a7f33-31c9-4830-b540-0254a53cf820","text":"IARC (WHO) press release classifying processed meat as \'carcinogenic to humans\' (Group 1)"},{"id":"c81fe284-1d56-4884-b3a3-e8ed8c832f00","text":"Recent legal and public debate weakening restrictions on AI\u2011generated political deepfakes (U.S. court decision striking down a California restriction, reported Aug 7, 2025)."},{"id":"f645f5ef-5ac1-44fb-9a14-8f8569b07972","text":"U.S. begins or expands training of Ukrainian military and security forces"},{"id":"316f2580-65a7-4aae-97c7-ab89b390be62","text":"Documented U.S.-funded democracy support by the National Endowment for Democracy (NED) in Ukraine"},{"id":"65085434-99ed-4d57-85cd-82de6d7b4516","text":"U.S. and EU impose sanctions on Russian and Ukrainian actors after Crimea annexation"},{"id":"e9510a84-35a9-4de4-9ad9-e222d2348cab","text":"2018 market reports showing a sharp rise in turmeric/curcumin supplement sales and mainstreaming of \'golden milk\' wellness trends"},{"id":"6dd190ff-6495-464b-9ba5-23b2d0f6fd1b","text":"2004 Phase I clinical trial of oral curcumin in advanced colorectal cancer patients (Clinical Cancer Research)"},{"id":"6e529b19-2c91-444a-bb36-d523d8781149","text":"Ukraine signed a contract to purchase about 1.8\u20131.9 million doses of China\u2019s Sinovac vaccine (announcement reported Dec 30, 2020)."},{"id":"75cbabf8-745f-4fc9-bd9b-38f0fc91ea4b","text":"Pfizer publicly reported supply-chain challenges and acknowledged it had cut its near-term production target (news reported Dec 3, 2020)."},{"id":"a2e3ed81-ed7c-4eac-b0c7-03c8d993a25e","text":"COVAX (WHO/Gavi/CEPI/UNICEF) announced additional advance purchase deals and said the global rollout was planned to begin in Q1 2021 (press release Dec 18, 2020)."},{"id":"87c2241d-5cb0-4f5c-923e-09dfac33f675","text":"Reporting of procurement dysfunction and delays within Ukraine\u2019s vaccine procurement machinery in late 2020 (media coverage of missed contracts, agency disputes and slow negotiations)."},{"id":"c45886e7-dc61-4725-8d00-6f8b9809f869","text":"NOAA / Arctic Report Card 2023 coverage documenting seasonal and regional variability in sea ice (and that 2023 minimum ranked among the low end but not a new record)."},{"id":"69044bfe-47b2-4ba7-a16d-a09a754a0188","text":"Publication of peer-reviewed study \'Comparing the carbon footprints of urban and conventional agriculture\' in Nature Cities"},{"id":"b6b5be45-4cbf-4a44-a03e-37809ce8f12e","text":"Publication of Standard Eurobarometer 101 (Spring 2024) with headline EU-level percentages on attitudes to the war, security and EU unity"},{"id":"cb892764-de04-416d-bdc1-9ef20b1cff7d","text":"Pew Research Center release \'Views of Russia and Putin\' (July 2, 2024) with country\u2011by\u2011country favorable/unfavorable figures"},{"id":"7392faa0-a150-4dba-b56e-4c4d39dc7010","text":"Large pro\u2011Russia demonstrations in Belgrade and other European cities (e.g., Belgrade pro\u2011Russia march reported by Reuters and BBC in April 2022)"},{"id":"3f4eefe0-a285-45ea-8839-1c7e19cc039f","text":"South Africa pauses/limits rollout of the Oxford\u2013AstraZeneca COVID\u201119 vaccine after trial data showed minimal protection against mild\u2013moderate disease vs the 501Y.V2 variant"},{"id":"121be1b2-8931-49a8-bd34-ebed27987497","text":"UK NERVTAG / Public Health briefings (Jan 2021) indicating the B.1.1.7 (UK) variant may be associated with increased severity/mortality"},{"id":"24544b2e-6718-43dc-829c-de46e2861ae6","text":"Ukraine\'s 2004 \'Orange Revolution\' \u2014 Supreme Court annulled disputed runoff and ordered a re-run"},{"id":"b10a4c06-189b-4684-b12d-ef17a210f307","text":"May 2014 early presidential election held amid armed conflict \u2014 polling could not be held in parts of Donbas and Crimea"},{"id":"8df7b50c-2cba-47fb-9c3e-c89f142bf026","text":"Crimea \'referendum\' (16 March 2014) and UN General Assembly non-recognition (Resolution 68/262)"},{"id":"cb9c24bb-09fe-44c3-a42c-c14e13eb9174","text":"Russian/state narratives calling the post\u2011Euromaidan Ukrainian authorities a \'coup\' and \'illegitimate\' (2014 onward)"},{"id":"2cb8d986-13a4-4fa7-abe9-aa38098c38e4","text":"Parliament and state moves in late 2014 to recognize OUN/UPA fighters with veteran/combatant status"},{"id":"c2acff46-466e-4233-bfca-55b8dc61128e","text":"International and regional criticism of Ukraine\'s decommunization bills as potentially glorifying WWII-era nationalists"},{"id":"15b5725f-bc53-476b-8f02-9e2be6e1a862","text":"Poroshenko issues decree establishing May 8 as a Day of Remembrance and Reconciliation (shifting commemoration context)"},{"id":"53352fb2-8c41-4ae8-ae51-998a77fbdfe7","text":"Verkhovna Rada passes \'decommunization\' package of laws equating Soviet and Nazi regimes and banning Soviet symbols"},{"id":"10a3df8f-584c-4799-8f82-c3f4d6d0b7d7","text":"Widespread use and international coverage of the red-and-black UPA/Bandera flag during Euromaidan and subsequent protests"},{"id":"4d2183f0-82c6-4df9-8187-fa672a4fb201","text":"Alaska Supreme Court struck down a 2014 law/regulation attempting to define which abortions were \'medically necessary\' for Medicaid funding (ruling reported Feb 15\u201316, 2019)."},{"id":"8f9b6c6f-e4b8-4d86-a137-ec8c58e2c655","text":"Alabama signed the near\u2011total Human Life Protection Act (near\u2011total abortion ban) on May 15, 2019."},{"id":"7476149c-2f26-41e2-b83b-793fe442956c","text":"Amnesty International reports on apparent extrajudicial executions by Russian forces"},{"id":"5529ee13-0c0a-40d8-a3c2-aaa819adc808","text":"Discovery of bound and shot civilian bodies in Bucha"},{"id":"bf9df6e7-1986-4c04-bd62-320f195b6453","text":"Sharp surge in temporary employment declarations for Ukrainians in Poland (about 400,000 declarations in H1 2015)"},{"id":"d099c61e-1609-48c0-8e30-c260de609e9e","text":"International media human\u2011interest coverage (e.g., BBC) highlighting Ukrainians taking low\u2011paid/manual jobs in Poland"},{"id":"9ebe3258-70a3-47d1-b749-005bc04bdb2c","text":"Media reports of increased civilian familiarisation and voluntary training courses in Poland amid the war in Ukraine (surge in civilians getting military\u2011style training)."},{"id":"3cfb3615-e7f1-4836-894f-7ed0d170c634","text":"Polish Ministry of Defence draft/plans reported to call up or train up to 200,000 reservists and Territorial Defence volunteers in 2023."},{"id":"7341ff10-94e4-4f2c-99ca-69e035432945","text":"Large NATO/U.S.-led military exercises in Poland in 2022 (e.g., DEFENDER-Europe 2022 and SWIFT RESPONSE 2022 in May 2022)."},{"id":"4173bed8-d09d-4a99-baf2-6806725ecf32","text":"Reports and sector assessments (Ministry/PPV/experts) documenting urgent appeals and emergency measures for the cultural and creative industries because of COVID\u201119 impact (spring 2020)."},{"id":"eb0ebcb7-de5a-46d1-aa61-3144f6040af2","text":"Previous and well\u2011documented state support for patriotic films (example: state/State Film Agency funding for films such as \'Cyborgs\' in 2017)."},{"id":"fa9cfb6f-bb9e-4ca8-86b4-3aa13f3288f8","text":"Verkhovna Rada adopts amendments to the 2020 state budget to create an anti\u2011coronavirus fund and reallocate spending (April 2020)."},{"id":"baa30782-ad77-4b2e-9e57-4310d3a8ab29","text":"U.S. embassy cultural and education grant programs in Poland (U.S. Embassy cultural exchanges and museum/project funding)."},{"id":"93eeec64-dd20-4d3c-85ae-53b9f9492d59","text":"Public concern and criticism by international institutions and U.S.\u2011linked organisations (including the U.S. Holocaust Memorial Museum) over Poland\'s 2018 memory law."},{"id":"c41b050b-1bc4-4d61-8530-280de69289ef","text":"Polish education reform (2016\u20132017) introducing a stronger \'patriotic education\' and changes to history curricula."},{"id":"fc1016ac-2073-4906-8e3c-1ada64d0efed","text":"High\u2011profile U.S. governmental rhetoric in Poland on WWII memory: Vice President Mike Pence\'s speech at the 80th anniversary WWII commemoration in Warsaw."},{"id":"69ebe80c-dbb8-47c1-b3ac-0ff61794fcff","text":"Russian courts declared the Mejlis of the Crimean Tatar people an \'extremist organization\' and effectively banned it (decision upheld by the Russian Supreme Court)."},{"id":"83715690-0689-407f-9183-ed0c09ae668b","text":"Prominent Crimean Tatar figures (for example Ruslan Balbek) publicly endorsed the 2014 annexation of Crimea and later served in Russian administration or political posts."},{"id":"71d8f507-dd09-48b2-a6ac-51f4219d35f5","text":"Reports that Russian/occupation authorities organized or amplified a purported \'congress\' or staged meetings of Crimean Tatar delegates framed as endorsing the \'special operation\'."},{"id":"f68bdad8-0be6-4339-bc36-f6095a91184f","text":"Ukrainian Ministry of Justice public discussion / press reporting on proposals to allow people with criminal records (non\u2011incarcerated) to be mobilised or volunteer for service"},{"id":"e07db0a8-30ba-47c9-8e98-8e58bdb237d0","text":"Justice Minister Denys Malyuska\'s telethon remarks suggesting mobilising people with criminal records and noting some could do non\u2011combat tasks (\'shovels\' mentioned in context)"},{"id":"997279b1-98ed-426a-8f71-1dfe00c0cfc3","text":"Precedent of Russian/Wagner recruitment of prisoners (widely reported in 2022\u20132023)"},{"id":"f47e498b-8eae-45e5-8bec-baa76263240f","text":"U.S. confirms delivery of Javelin anti-tank missiles to Ukraine"},{"id":"6f851f63-6752-4173-9f20-a83b89928c7f","text":"U.S. passed the milestone of 1 million reported COVID-19 deaths in mid\u2011May 2022."},{"id":"ee48e0ea-0842-4c9e-b212-24a573dfe883","text":"CDC changed its COVID-19 data presentation and surveillance focus after the U.S. public health emergency ended (2023), shifting emphasis to severe outcomes and revising some reporting dashboards."},{"id":"088e6079-22cf-4c60-8f79-e7bf4be92bc8","text":"Publication of a randomized, double\u2011blind, placebo\u2011controlled Phase II trial reporting AHCC cleared persistent high\u2011risk HPV in a majority of treated patients"},{"id":"0f74ee7b-f75b-4e23-8554-9d4fd3997e45","text":"Russian Defence Ministry spokesman Igor Konashenkov publicly announced that Russian forces had \\"liquidated\\" groups of foreign mercenaries including members of the \'Georgian Legion\' near Lysychansk."},{"id":"dc4d58b6-b6a5-4e33-8113-1104de0660cf","text":"French President Emmanuel Macron says \'we must not humiliate Russia\' (calls for dialogue)"},{"id":"1626dc53-6141-43e8-b9d3-3cf657bec12b","text":"United Nations / humanitarian agencies warn of catastrophic humanitarian needs in Ukraine"},{"id":"b5d18da2-37ec-43db-9cf5-11a16315155a","text":"Russian seizure and military control of the Zaporizhzhia nuclear power plant"},{"id":"fc7fa7f8-d6aa-46a0-814f-d7777e07ee50","text":"NATO Madrid Summit (new strategic concept and high\u2011level discussions)"},{"id":"c446fa31-103d-4be7-a20a-9fdf249fee0c","text":"Fall of Sievierodonetsk / Russian capture of a key Donbas city"},{"id":"50229a45-d8db-4d1a-b9aa-633cced12c5a","text":"European Commission emergency aid package for farmers affected by the Russian embargo (initial \u20AC125 million announced)"},{"id":"b5b1f2ce-8e67-4fdd-9274-0fda8fb105d3","text":"Finnish industry and producers (e.g., dairy sector) publicly warned of impacts and potential job talks after the Russian ban"},{"id":"91a10dc8-8b8a-42ef-b656-40c78c73476b","text":"Sharp month\u2011on\u2011month fall in Finnish food exports to Russia after the ban (reported as exports plummeting over 60% in one month)"},{"id":"2f44b72b-9ed9-4836-a422-74659e144491","text":"Turkey shot down a Russian Su\u201124 warplane on the Syria border, sharply escalating tensions between Moscow and Ankara."},{"id":"3ca2f12a-dda8-4f5e-aeb4-350f5128b99e","text":"Russian Defence Ministry publicly accused President Erdo\u011Fan and his family of profiting from illegal oil shipments from Islamic State (IS/ISIL) in Syria and Iraq."},{"id":"742b16e2-457f-4473-89e7-7d79fc6a6162","text":"WHO issued information notices clarifying interpretation of PCR cycle thresholds (advising careful interpretation of weak positives and use of clinical context)"},{"id":"0f058be5-6f03-44df-9cc2-ebdfb8ab7143","text":"Peer\u2011reviewed study showing PCR cycle threshold (Ct) correlates with ability to culture live virus (low Ct more likely infectious)"},{"id":"37725301-cd6c-4f8b-ba53-7ac89bb7d93c","text":"Kyiv City Council adopted a 2015 regulation and local initiatives promoting the use of Ukrainian in public life (programs 2015\u20132020)."},{"id":"619d943c-5d2a-4a21-a577-d21c72210782","text":"Parliament passed and enacted quotas for Ukrainian-language songs on radio (law approved June 16, 2016; quota measures came into force in 2016\u20132017), increasing legal requirements for media language use."},{"id":"630ad209-9fb0-4b78-88c6-e02f76c0fc74","text":"Adoption of the Kivalov\u2013Kolesnichenko Law on the Principles of State Language Policy (entered into force August 10, 2012)."},{"id":"c9b72f24-65bb-4256-b0e4-1717a833ac47","text":"Verkhovna Rada voted to repeal (23 February 2014) the 2012 language law amid the 2014 political upheaval (subsequent legal uncertainty and debates followed)."},{"id":"2325e83b-a7fe-400a-968f-882df203a73d","text":"Establishment of presidential and advisory bodies to promote Ukrainian language and national unity (e.g., Board for National Unity created by decree, December 2015) and public campaigns encouraging Ukrainian-language use."},{"id":"27fc317a-76e6-4e92-8463-532e1c1889fd","text":"Poland refused entry to the Night Wolves in late April 2015, blocking their planned land route to Germany."},{"id":"5ab691c3-fa6b-46e5-b127-a5ce5a000062","text":"Night Wolves\' active, visible role in Crimea (2014) and frequent state-linked publicity established them as a high-profile, Kremlin\u2011linked biker group prior to 2015."},{"id":"1ec3575f-6c04-469f-92c5-ba4d89f117de","text":"Prime Minister Mark Rutte publicly said the Netherlands was unlikely to ratify the Agreement and sought \'legally binding\' assurances from EU partners"},{"id":"d13dadf0-4167-4441-a621-b37a7b72e753","text":"Dutch advisory referendum on the EU\u2013Ukraine Association Agreement produced a 61% \'No\' vote"},{"id":"99f1753a-60d3-44ab-bb03-dd91fc18e35a","text":"The International Monetary Fund approved a $5 billion loan arrangement for Ukraine on June 9, 2020, contingent on economic reforms and anti-corruption measures."},{"id":"de4ab1ba-1dad-4112-ac67-2abf280c8f37","text":"The U.S. government temporarily froze nearly $400 million in security assistance to Ukraine in July 2019, around the time of the Trump\u2013Zelensky call."},{"id":"2a2c3af2-a77f-4bfa-8412-7dfd2714a7fd","text":"Then-Vice President Joe Biden publicly recounted in 2018 pressuring Ukraine to fire a prosecutor by threatening to withhold roughly $1 billion in loan guarantees."},{"id":"7a402d5d-a0ce-4678-be45-af2e707a57d2","text":"A whistleblower complaint about the July 2019 call prompted a formal House impeachment inquiry into President Trump in September 2019."},{"id":"43fb4834-7616-44da-9a18-09041bb3b486","text":"President Trump\u2019s July 25, 2019 phone call with President Zelensky in which Trump asked Ukraine to investigate Joe Biden and his son."},{"id":"6b8e73d8-6258-42aa-92a4-ff23daec341b","text":"Zelensky cancelled a planned US Senate briefing amid a funding impasse (December 2023)"},{"id":"0bb3c38e-09ef-43eb-891c-1d85703bde14","text":"Domestic polls and reporting in late 2023 showed a measurable dip in Zelensky\'s approval/ trust indicators"},{"id":"55a5fa6c-a334-4d94-865f-60a02ae595f8","text":"Pandora Papers (Oct 2021) revelations about offshore connections of Zelensky and associates"},{"id":"81456b8e-23b0-4a74-8743-2e58b6813f55","text":"Reuters Institute Digital News Report 2023 documented widespread \'news fatigue\' and falling news engagement"},{"id":"916ebf00-2e5e-46fa-b5de-8ee2ca328a22","text":"Russian officials publicly accuse the West of direct involvement and hostile aims in Ukraine (e.g., Lavrov\'s public remarks at the UN accusing the West of \'de facto\' fighting)"},{"id":"2ccb1cd7-4eca-4a60-9da7-b509302d44b6","text":"Russia announces annexation of Donetsk, Luhansk, Kherson and Zaporizhzhia following contested \'referendums\'"},{"id":"5fd1dbf4-f4ae-4bb8-9195-ea964920209d","text":"NATO/Western officials publicly debate long\u2011term security packages for Ukraine, with reporting highlighting differences among allies"},{"id":"248a9bf7-40f3-4da9-863a-6d903eea0663","text":"Foreign embassies began withdrawing some staff and dependants from Kyiv"},{"id":"2e75e421-b3fc-47fe-9ef6-09d2d33af214","text":"UNHCR/IOM reporting of large-scale internal displacement from eastern Ukraine (Donbas) during 2014"},{"id":"a0fc6d93-fe8c-4e8e-a8d7-9e45d64c7ecb","text":"Violent Euromaidan clashes and clearing of Independence (Maidan) Square in central Kyiv"},{"id":"3ac87666-f63a-4e9c-812c-b18af694a7c0","text":"Cross-border refugee flows and media coverage of Ukrainians seeking refuge in neighbouring countries (2014)"},{"id":"9d6d3d56-0ee4-44b5-a102-774c5e33a91e","text":"Publication of Israeli cohort study reporting no increased incidence of myocarditis/pericarditis in unvaccinated patients after COVID-19 infection (Tuvali et al., Journal of Clinical Medicine)"},{"id":"8a163198-c8d4-4b88-a7bf-cd5fc98c4160","text":"University of Ljubljana press release describing Zelenska\'s meetings with faculty and projects (and not attributing the cancelled lecture to protests)."},{"id":"0e0ab341-4bda-4673-a025-971a69075eef","text":"A man shouting anti\u2011Ukraine/pro\u2011Russia slogans appeared and was detained during Zelenska\'s visit to the National and University Library (reported by multiple outlets)."},{"id":"b37c3cac-8bb5-460b-b7d2-eb33414b5fc7","text":"IAEA chief condemns shelling near Zaporizhzhia nuclear power plant"},{"id":"24b15dbd-56ea-4ece-a1b0-5aa688b711f6","text":"Zelensky publicly urges partners to allow truly long-range strikes (September 2024)"},{"id":"b2c2ade4-37c2-48da-819b-624b5a9bfd1c","text":"Putin puts Russia\'s nuclear forces on high alert after invasion began"},{"id":"788ab935-4533-44cb-bf0b-926954d8bf02","text":"Series of Ukrainian strikes against Russian targets in Crimea, including attacks on Sevastopol and military infrastructure (2023)"},{"id":"ef45ee2f-a90b-4522-a5ef-835dc927c319","text":"OSCE Special Monitoring Mission report (23 August 2014) noting heavily shelled residential areas in Donetsk and civilian reports of damage and danger"},{"id":"8b3d734d-3752-4511-8163-4338dd74beb2","text":"Amnesty International research missions documenting summary killings and abuses in eastern Ukraine (late August\u2013September 2014)"},{"id":"ba9c253c-7260-4ccb-b433-2cf15d3e9217","text":"Court ban on the Mejlis of the Crimean Tatar people declared \'extremist\' (April 2016)"},{"id":"6a9e9c87-d858-412c-b112-3e45da1dbdab","text":"Rapid issuance/acceptance of Russian passports in Crimea after annexation"},{"id":"11f22217-1c3a-4534-bd5e-df89b12c7750","text":"Intense Russian offensive and heavy shelling around Rubizhne (Battle of Rubizhne) with reports Russian forces took large parts of the town"},{"id":"69bfde9f-78f1-43f8-9ea2-86df6169332b","text":"Local authorities issued shelter and safety warnings after the explosion, noting toxic fumes and urging people to stay indoors"},{"id":"fc645500-a1c3-43be-aac2-10992f86dcd3","text":"Nitric-acid tanker at Zarya chemical plant damaged/exploded after shelling in Rubizhne"},{"id":"bdb671dd-0d75-4f91-ab6e-132ae191b45e","text":"Publication of patent applications describing fusion proteins containing luciferase (public patent records, e.g., US patent applications from 2018\u20132020)."},{"id":"039940c2-8769-41b6-8e24-bc42bd2df3fe","text":"Publication of research using luciferase reporter systems to study SARS-CoV-2 entry and for rapid neutralization testing (e.g., nanoluciferase SARS-CoV-2 assays published in 2020)."},{"id":"c81bbf61-f731-4178-8ce9-126dc09503cb","text":"Verkhovna Rada passed a package of four \'decommunization\' laws mandating removal/ban of communist symbols and renaming of public places"},{"id":"70da26a2-352f-4784-974f-a96926d40818","text":"Parliamentary action to establish May 8 as a Day of Remembrance and Reconciliation alongside changes to how May 9 was observed"},{"id":"722ff441-3624-4290-9633-b6e564f438d0","text":"Public dispute and protests around the future of the Vatutin grave/monument in Kyiv (rallies and media reports in April 2015)"},{"id":"6db7bc6b-d875-4968-a306-ba8cd0b84592","text":"Widespread toppling/removal of Lenin and other Soviet monuments across Ukraine in 2014\u20132015 (\'Leninfall\') and reporting on mass removals"},{"id":"055d0702-1678-42d0-962d-d04f89cdfd1b","text":"Ongoing wild poliovirus transmission in Pakistan and Afghanistan documented in GPEI 2019 annual report"},{"id":"12e8d861-ad53-4863-bde6-fe0e33ffe000","text":"COVID-19 pandemic disrupted mass immunization campaigns, prompting WHO/UNICEF warnings about millions of children at risk (May 2020)"},{"id":"3444cd08-df07-4dd7-8622-dc2db9e5f4ea","text":"European leaders and diplomats publicly debated conditions and timelines for easing Russia sanctions (e.g., calls to consider step-by-step easing if Minsk progress made)."},{"id":"75e60699-cc61-4e72-9d34-3786cbed846c","text":"Multiple foreign embassies ordered non\u2011essential staff to leave or relocated operations from Kyiv"},{"id":"dbe6bc50-37e5-422e-9c48-1d03b7c6b417","text":"Heavy fighting around Hostomel (Antonov) airport and other approaches to Kyiv as Russian forces advanced"},{"id":"87e0fdc9-8c76-40a7-ac4e-4676e5f4d10e","text":"Large numbers of civilians seen fleeing Kyiv and images/videos of chaotic departures"},{"id":"cb08a76c-10e2-4478-aa20-448daa882f86","text":"IOM / Ukrainian government data: registered internally displaced persons (IDPs) exceed one million (reported February 2015)."},{"id":"d7f48cfd-8d2a-41e9-ab1e-b1b3ebea5857","text":"Council of Europe / pan-European analyses of 2015 refugee coverage identify uneven framing and limited humanising coverage in parts of the press during the 2015 refugee crisis."},{"id":"770c002c-9b9c-4946-b141-beb31de606de","text":"Monitoring by Thomson Foundation / MEMO 98 (published December 2015) reports problems and inconsistencies in Ukrainian regional media coverage of IDPs."},{"id":"56a021c2-c9ff-43e5-996f-c6d7ec23a91b","text":"Prominent alternative-health websites and how\u2011to blogs publishing step\u2011by\u2011step guides and testimonials for using castor oil against bone spurs, scars, cysts and tumors (2022\u20132023)"},{"id":"cb168328-3638-4a2d-ac14-48401092d43a","text":"Public criticism from Jewish organizations and commentators about commemorations of Petliura (e.g., World Jewish Congress reaction and critical coverage following monument unveilings)."},{"id":"2849b109-7dcd-46b5-9a90-5d44ec00e9c7","text":"Analysis and reporting on disputes over church affiliation, symbolism and politicization of religious spaces in Ukraine and the diaspora (e.g., \'Who Owns Tradition? Ukraine\'s Church Controversy\' \u2014 Wilson Center)."},{"id":"f2507425-09cd-40be-9ca3-40f697844728","text":"End-2020 decision and architectural competition announced for a Petliura monument in Poltava (projects selected in 2020\u20132021)."},{"id":"f6ef2b20-ecea-4c28-ae8e-e31bf9960385","text":"Gazprom sharply reduced Nord Stream 1 flows to around 20% capacity and publicly linked the cuts to maintenance delays and sanctions-related equipment issues."},{"id":"a23f5f77-f0d2-4767-97ec-758c1d52ff48","text":"Ukraine\'s Center for Countering Disinformation (NSDC/CPD) and other monitoring bodies documented and warned about Russian propaganda narratives around Ukraine\'s winter preparedness and energy dependence."},{"id":"cc33b652-dc5c-4d0f-96f9-841a4ed6c523","text":"Ukraine ended the 2021/2022 heating season with record\u2011low gas reserves in storage."},{"id":"40077f46-8f07-4aaa-a346-c4a3699dafd4","text":"Publication of the review \'The endocannabinoid-CB1 receptor system in pre- and postnatal life\' (Fride et al.), which notes that endocannabinoids have been detected in maternal milk (mostly from animal studies)."},{"id":"016b4f58-0480-4b0b-a396-5e410315f527","text":"November 7, 2012 \u2014 Voter approval of recreational marijuana legalization measures in Colorado and Washington (major expansion of public debate on cannabis)."},{"id":"62a49154-df4b-4a91-a074-6ae7072d7d08","text":"Reports mentioning use of military equipment (helicopters, armoured vehicles) during the government response"},{"id":"31b7ba04-1249-4c6b-b648-190f940337f1","text":"Mukachevo shootout between Right Sector-affiliated fighters and local police"},{"id":"95d37594-6ae4-4bd5-b088-9925445a3fbe","text":"Media and hospital-system reporting during the Delta surge highlighting \'incidental\' COVID-19 hospital admissions (Florida example)"},{"id":"27241f85-fa16-4ac4-a8b7-15b736e792b8","text":"Local officials and media reported Russian troops looting shops and homes in occupied towns such as Trostianets (Sumy region) in early March."},{"id":"7754564e-329f-4dd9-8f29-c0a8ada7e40c","text":"Ukrainian president Volodymyr Zelensky called on citizens to take up arms and promised weapons would be issued to those willing to defend cities."},{"id":"0b3347dd-ff45-4789-ae4d-123e9ce44041","text":"Videos and news reports documented civilians in Kyiv and other cities preparing Molotov cocktails and receiving basic instructions on improvised weapons."},{"id":"20c808b1-fae8-4461-9cd2-903c3c6dd6ce","text":"A passenger bus was struck near a Ukrainian Armed Forces checkpoint outside Volnovakha, killing and wounding civilians (reported immediately after the incident)."},{"id":"ff9ba1ec-0a5b-4a94-8022-4f958ba98e46","text":"Since early 2022, President Zelensky and Ukrainian authorities publicly invited and organized foreign volunteers via the International Legion and appeals for foreign fighters."},{"id":"ce6b82ae-c945-45da-84eb-0cf1f30cea4d","text":"Irish media and security sources reported unidentified drones in Irish airspace on the night of Zelensky\'s arrival in Dublin, prompting government briefings and heightened coverage of his visit."},{"id":"eff50442-47e8-4b6c-be30-a7d2f7ffca40","text":"President Volodymyr Zelensky presented posthumous awards to the families of three Irish volunteer servicemembers during his official visit to Dublin."},{"id":"636d36e0-43e5-47d3-936b-6007b9f3d49b","text":"UK and Irish reporting had previously documented multiple Irish nationals serving and killed or missing while fighting in Ukraine (coverage naming Rory Mason, Finbar Cafferkey, Graham Dale and reporting Alex Ryzhuk as missing/presumed dead)."},{"id":"42c05943-b9ac-4ead-bb6a-948856fc47af","text":"Fluoride Action Network (FAN) national campaigning and reporting (2016\u20132017), including petitions and litigation efforts to challenge U.S. EPA regulation of fluoride."},{"id":"0a000d18-ecff-446c-a924-6d82d3d98023","text":"CDC/NHANES analyses and reporting on increased prevalence of dental fluorosis in U.S. surveys."},{"id":"7d4dfb1c-7fe3-4a96-8bdf-09d038389f7a","text":"CDC public description of its Technology Transfer Office and the fact that CDC researchers can patent inventions and license technologies to industry."},{"id":"96f5d8f6-6d67-435e-99b5-5e35770b7fed","text":"Ukraine passed and the president signed constitutional amendments in February 2019 enshrining EU and NATO membership as state policy"},{"id":"a1bc332a-893a-4b04-bcfc-a272cfefd776","text":"ECHA (European Chemicals Agency) opinion/proposal to classify titanium dioxide as a suspected carcinogen by inhalation (RAC opinion)"},{"id":"c47450ff-8e1c-4402-abce-e241cb06f390","text":"Scientific Reports paper (Sciensano-led) found titanium dioxide particles in all examined face masks"},{"id":"a9e63a08-bc8c-44ad-a902-ff7af830b08c","text":"EU and public\u2011health coverage reassuring that there was \u2018no evidence\u2019 masks pose health risks after TiO2 concerns were reported (widely reported by Reuters and others)"},{"id":"73cfe112-4ba5-4214-a482-67a9a39b4768","text":"On 21 April 2019 (second round presidential voting) some polling stations near the contact line experienced delays or local disruptions (reports noted at-the-day irregularities in frontline areas)."},{"id":"5f02da39-e150-40f8-948c-4977f9916faa","text":"Voting did not take place in Crimea and large parts of Donetsk and Luhansk during Ukraine\'s early parliamentary election (26 October 2014)."},{"id":"b640d8ba-898d-4f84-aeb2-2da68325a5c4","text":"Russia\u2011backed authorities held another round of unrecognized \u2018elections\u2019 in occupied Donbas on 11 November 2018 that Western bodies condemned as illegitimate."},{"id":"5a481af2-58fd-4c86-873b-9b91d28d078e","text":"International analyses documenting large numbers of foreign fighters/volunteers in Donbas (ICCT and other reports, mid\u20112010s)"},{"id":"ed7c927d-f12c-4123-b39e-593052cb5b1e","text":"Canadian defence delegation visit to the Donbas withdrawal line (reported delegation visit led by Deputy Minister Peter Hammerschmidt) \u2014 December 2019"},{"id":"2bc4fa4e-55eb-4fa9-9fb1-9fc1dd0ed0db","text":"Canada launches Operation UNIFIER (Canadian Armed Forces trainers deployed to Ukraine) in 2015"},{"id":"2e4f5cbb-4aee-44db-b53e-1ac19783f8f4","text":"Deployment of Russian private military company Wagner to Crimea/Donbas in 2014\u20132015"},{"id":"3166f662-04a5-4569-b8ef-e4a13f9635b1","text":"Satellite imagery and reporting in February 2022 showed substantial Russian troop and equipment deployments in Belarus and flights out of Belarusian bases toward Ukraine."},{"id":"a9d7cb0f-ef46-4fd0-8eae-149d9bc36c77","text":"Ukrainian Defence Ministry\'s Military Intelligence published a roster naming Belarusian Air Force personnel allegedly involved in strikes, triggering circulation of lists linking Belarusian officers to combat operations."},{"id":"f5968a16-3ae9-4016-a310-331ee57638dc","text":"Conflicting official messaging in late February 2022: Belarusian leadership publicly denied plans to send Belarusian troops, even while allowing Russian forces to mobilize on Belarusian soil."},{"id":"79da912d-dbc1-4ae6-bd23-28e93c64cffc","text":"The 2009 Su-27 crash at the Radom air show (30 August 2009) that killed two Belarusian pilots (A. Marfitski and A. Zhuraulevich)."},{"id":"5f8c89ed-c59f-43ea-8fbf-f1fd778aaeba","text":"High\u2011profile resignations of senior FDA vaccine officials amid booster controversy (Marion Gruber and Phillip Krause)"},{"id":"44320b4b-b5f5-4371-b8cb-e0bab284904e","text":"Audit published of USAID\'s \'Strengthening Civil Society in Ukraine\' project"},{"id":"83a28186-9fc4-4973-89fe-3045be17f87c","text":"Russian officials publicly accused the U.S. of meddling and funding protesters in Ukraine"},{"id":"3f13e771-2787-4f74-878d-01ec9328e304","text":"U.S. Congress/administration announcements of large financial assistance to Ukraine (including a $1 billion loan guarantee)"},{"id":"24442cca-df16-40ec-b4c2-36fa92e8bf64","text":"Public records and reporting of National Endowment for Democracy (NED) grants to Ukrainian groups during Euromaidan"},{"id":"d059b70c-37c2-47c2-8675-75a805809e38","text":"IMF program in March 2015 tied continued financial support to debt restructuring and private\u2011sector involvement"},{"id":"ac7eb1a9-e2b2-4f4b-b565-0da0ed4aee2a","text":"Reuters reports Ukraine completed a major $15 billion debt restructuring in March 2015"},{"id":"8e1f7e07-8213-400a-914d-0c01cae6ccea","text":"DW reports Yatsenyuk warning Ukraine might suspend repayments and refusing to accept Russia\u2019s terms (October 2015 coverage)"},{"id":"d6e42b72-be4b-464e-b7c4-f3d17051dbf8","text":"Ukrainian prime minister publicly rebuffs Putin\u2019s offer to restructure the $3bn Russian bond"},{"id":"22b8c6a4-fe2a-4fac-b173-004611eea7cd","text":"Sharp decline in reported influenza activity in the U.S. during March 2020 as COVID-19 measures began"},{"id":"1dc02e1c-809b-457a-8693-035cb92127e6","text":"Nature Medicine study (Leung et al.) showing face masks reduce respiratory virus shedding in exhaled breath"},{"id":"56744768-0e76-42ad-bfc8-a7813124b91a","text":"CDC recommends public use of nonmedical cloth face coverings"},{"id":"7f920669-c960-4ee2-9c6b-57c6ddcea98f","text":"High\u2011profile Pfizer/BioNTech vaccine efficacy announcement (press release and global media coverage) reporting ~90% effectiveness"},{"id":"09d344d6-907c-472b-b21a-e2d032b8b503","text":"Historical origin of the MRC\u20115 cell line (derived from a 14\u2011week male fetus in 1966) documented by cell banks (ATCC) and widely reported"},{"id":"dc8edab8-f7ea-4d28-8264-ac56b6c65571","text":"Release of a Research Square preprint (ChAdOx1 nCoV-19) showing experiments using MRC\u20115 and HEK293 cell lines (preclinical/transcriptomic analysis)"},{"id":"28449dff-ab57-4dc5-9bbe-718511d0beac","text":"CDC recommendation on July 27, 2021 for universal indoor masking in K\u201312 schools regardless of vaccination status due to Delta variant concerns."},{"id":"9a8a3eed-fab6-443e-a46b-9adb0b65aab4","text":"Publication of MacIntyre et al. (2015) cluster randomized trial finding cloth masks offered less protection than medical masks among healthcare workers."},{"id":"e22e01a4-aa93-4c65-bcd7-d529d935d18b","text":"Torchlight marches and public rallies honouring WWII-era nationalist Stepan Bandera attended by far\u2011right groups and covered in the media (e.g., Lviv torchlight march)."},{"id":"3f92d0af-93ee-44f1-a853-b4668e51263d","text":"Passage of Ukraine\'s \'decommunization\' laws in April 2015, banning Soviet symbols and changing official commemorations and place names."},{"id":"8af9e40f-53d9-4962-af42-2b1b546eae95","text":"Profiles in 2014 highlighting the Right Sector movement\'s role in the Maidan protests and its radical nationalist ideology."},{"id":"9eeac9e1-1f53-42bc-89f3-a3971a645d0b","text":"Reports in 2014 that the Azov militia (later a National Guard unit) used symbols and insignia associated with neo\u2011Nazi groups and had leaders with far\u2011right views."},{"id":"da383908-9cae-4334-94f5-b4b1d0bac067","text":"World Health Assembly adoption of a package of amendments to the International Health Regulations (IHR) (adopted 1 June 2024)"},{"id":"b3c7c16d-d44b-42a1-86e3-3bd88bc2b166","text":"Earlier high\u2011profile vaccine contamination reports (Japan paused some Moderna batches after black/foreign particles were found)"},{"id":"aa56ac21-7511-471f-8f06-f604afabce09","text":"Publication of Danish research letter reporting batch-dependent variation in suspected adverse events after the Pfizer (BNT162b2) vaccine"},{"id":"4dd03931-2066-4f6c-b70f-aff356e9b46b","text":"Publication and high-profile retraction (Surgisphere) of large observational studies on hydroxychloroquine (The Lancet retraction, June 2020)"},{"id":"b1af2bea-91fd-482b-8051-a51dfdb38a21","text":"Publication of Didier Raoult / Gautret open-label non-randomized Marseille study reporting viral-load reduction after hydroxychloroquine \xb1 azithromycin"},{"id":"1634687c-de17-4492-a1e9-6bd2d7fd3d75","text":"Prior international reporting (2014\u20132015) documented Azov\'s origins in far\u2011right volunteer networks and the use of extremist symbols by some members."},{"id":"9f19ec7f-44a6-4225-9fe9-d4b4160833e9","text":"Dutch advisory referendum on the EU\u2013Ukraine Association Agreement had been activated and was widely reported (petition drive and referendum scheduled for April 2016)."},{"id":"5acdcdd3-cfc6-4837-b656-f34ca3d48661","text":"IPCC AR6 (Working Group I) released findings noting that internal variability can modulate near\u2011term global temperature trends, creating uncertainty in short\u2011term (years to a decade) temperature trajectories."},{"id":"fb718e29-8b18-4fcf-81ea-c75ba72067bd","text":"Japan suspends use of about 1.63 million Moderna COVID\u201119 vaccine doses after \'foreign materials\' were found in some vials, prompting international media coverage and public concern about vaccine contamination."},{"id":"38c2efac-70d5-45dc-b1a6-bc298b341cb0","text":"Two infants died shortly after receiving MMR vaccine in Samoa, prompting national investigation and temporary suspension of some vaccine supplies (widely reported and later traced to preparation error)."},{"id":"b92cc24d-296a-48a1-a7b2-fa3c54829c4e","text":"Reports of a July 2020 surge in Amazon deforestation and fires, and international concern about weakened enforcement under Brazil\'s government (reported August 2020)"},{"id":"0bc5430a-3aa3-435e-9c11-e70b0e7ec6c9","text":"Science Advances editorial \'Amazon Tipping Point: Last Chance for Action\' by Thomas Lovejoy and Carlos Nobre (Dec 2019)"},{"id":"249bb7f1-30c7-450e-8e4f-789fd79f5cf5","text":"Investigations and reporting documenting Cyprus as a secrecy hub for Russian and other foreign wealth (\u2018Cyprus Confidential\u2019 ICIJ series, 2023) highlighted Cyprus as a destination for opaque property holdings."},{"id":"5f12de65-de31-4eb2-9198-02fe51497958","text":"Ukraine\'s SBU announced it uncovered a scheme to embezzle about $40 million from weapons procurement (reported Jan 27, 2024)."},{"id":"76b6d07b-6776-4eab-a9db-0943a7a939d5","text":"The Pandora Papers (ICIJ coverage and major press, Oct 3, 2021) revealed offshore companies tied to Zelenskyy\u2019s inner circle."},{"id":"2fc74655-a5b5-4262-89fb-72ae40f44418","text":"Russian Defence Minister Sergei Shoigu publicly said Russia was \\"deliberately slowing\\" its offensive to allow civilians to evacuate."},{"id":"413fd5c4-93fb-4975-926e-949600553baa","text":"Negotiations and agreements (limited implementation) to open humanitarian corridors between Russia and Ukraine were publicly reported."},{"id":"13de59f0-aa18-4f33-a9e8-a1421ebb700a","text":"Precedent: Ukrainian church leaders previously (April 2022) urged faithful to forgo night Easter vigils in areas affected by fighting and to use online prayer options."},{"id":"add2b4cf-c6e3-45ea-a301-649db7e48b58","text":"Kyiv city administration published wartime guidance advising limited mass gatherings for Easter and urging online broadcasts (curfew remained in force)."},{"id":"7c8dbfe9-4904-44b4-a304-26ac404eebc5","text":"Kyiv Military Administration clarified churches would be open but worshippers who entered before the midnight curfew could not leave until it ended (and urged switching to online broadcasts)."},{"id":"c9805034-b42f-4db1-86d3-68bfbc00296b","text":"U.S.\u2013Ukraine critical minerals/resources memorandum reported"},{"id":"a17def6a-a457-4e97-8d32-baf304f29c7f","text":"Ukraine Recovery Conference (URC) \u2014 large Western reconstruction pledges and private\u2011sector investment commitments"},{"id":"9a2c6e26-52bf-41c9-a7ca-4c5324135706","text":"Prominent think\u2011tank analyses raising \'partition\' as a plausible risk/outcome"},{"id":"95e68321-4757-42ae-bd68-b039cda7ef8b","text":"Russian customs effectively suspended or heavily restricted imports from Ukraine (placing Ukrainian exporters on a \'risk\' list), producing a de facto trade embargo in August 2013."},{"id":"a58798e9-6101-4ef5-ae6e-77e43a751d70","text":"Separatists and protestors had seized Ukrainian security service buildings and weapons stores in Luhansk in 2014"},{"id":"68cb46dc-d705-4372-9682-85134cf51860","text":"Public debate in 2015 about supplying Western weapons to Ukraine (media/policy discussions)"},{"id":"6a3a9b49-a121-4d77-9bf9-605d700fc9fc","text":"Ukrainian government announces figure of 19,546 Ukrainian children deported/forcibly transferred"},{"id":"e057b111-30c8-44fe-9341-21d1472eee87","text":"Russian officials and state media publicly characterize transfers as \'evacuations\', \'adoptions\', or humanitarian relocations and dispute foreign reports"},{"id":"8a80fc92-c2af-4e5f-b8b1-efbcffb2cbf9","text":"U.S. FDA granted Emergency Use Authorization (EUA) for the first COVID-19 vaccine (Pfizer\u2013BioNTech)."},{"id":"4bf80e3a-27d8-464d-99d4-867b4ef33b10","text":"CDC updated indoor masking guidance on July 27, 2021, advising fully vaccinated people to wear masks in public indoor settings in areas of substantial or high transmission due to Delta."},{"id":"abdb6419-f54d-4ea6-a065-163aaececd61","text":"Israeli Ministry of Health and media reports (early July 2021) indicated reduced Pfizer vaccine effectiveness at preventing infection with the Delta variant (while still protecting against severe disease)."},{"id":"0c4c6b51-6c7e-43db-8c57-33e148f4390a","text":"CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing many infections in fully vaccinated people (including high viral loads)."},{"id":"865f4db0-ac94-4b66-8fe3-5e5997b63fb1","text":"Publication of meta\u2011analyses / preprints (e.g., John Ioannidis\' seroprevalence\u2011based estimates in May 2020) reporting relatively low infection fatality rate (IFR) estimates in some settings."},{"id":"07a758f4-3009-4887-9f52-6cffc024f332","text":"Swedish state epidemiologist Anders Tegnell publicly defended Sweden\'s decision not to impose a strict lockdown and said parts of Stockholm were showing signs of immunity"},{"id":"b572c1d4-063f-470f-b701-dbc590cfba2f","text":"Global dashboards and WHO/academic mortality pages publishing country-level COVID death counts and per-capita metrics were widely circulated in summer 2020"},{"id":"016ecb78-c51d-4325-8a45-51c77774d814","text":"Gordon Brown\'s public apology to former child migrants (UK government apology)"},{"id":"cae2e348-f492-4176-9df7-4a6c0ff875c0","text":"Reuters reported Ukraine was in talks with Moscow over the return of 311 Ukrainian soldiers and border guards who had crossed into Russia, while Russian border authorities said the troops were seeking asylum."},{"id":"82d0ee32-e4ab-4df0-8159-0ab7318b0482","text":"OSCE Special Monitoring Mission reported witnessing the passage of 437 Ukrainian servicemen through Russian checkpoints and stated it had inquired about asylum requests and found none."},{"id":"fd20d16c-a389-464d-83df-7f273015c324","text":"EU Foreign Ministers agree to begin targeted measures (reported in UK parliamentary scrutiny documents)"},{"id":"d1bf9838-df80-44e2-82d9-088bb376a2be","text":"European Parliament adopts resolution condemning Russian actions in Ukraine"},{"id":"21dd5abc-de08-4ba0-95a1-a69d8f1ff422","text":"UK Prime Minister David Cameron signals support for strong EU sanctions on Russia"},{"id":"8e446813-8f7c-4b01-841f-0f4f41e401df","text":"Reporting of UK MPs meeting or engaging with Russian officials and pro\u2011Kremlin voices (summer 2014)"},{"id":"9e783071-932d-44c4-b72c-073dde1ba831","text":"The Joint Investigation Team (JIT) held a public presentation of interim MH17 criminal-investigation results describing the likely weapon type and launch area."},{"id":"d8dab0c0-3b5b-43b5-bbe4-899087df653b","text":"Ukrainian authorities/activists compiled and publicised lists of Russian artists and cultural figures to be blacklisted from entry or broadcasting in Ukraine (summer 2014 announcements)."},{"id":"7a0e5497-26f7-4bf3-b1ce-9acfada7df29","text":"Repeal/controversy over the 2012 Kolesnichenko\u2013Kivalov \'regional language\' law and moves to strengthen the status of Ukrainian after February 2014."},{"id":"0c49a33e-052f-49ba-bf55-1ae3ff4a816a","text":"Kyiv city administration replaced Soviet-era Ded Moroz (Father Frost) in its official New Year program with the Orthodox figure Saint Mykolay."},{"id":"f702eca4-3df3-43f4-ba88-8f82b221f0c6","text":"Widespread removal/toppling of Lenin statues across Ukraine (\'Leninopad\') during early 2014."},{"id":"6830bac0-33f7-4f3d-b9f4-50a6770990b9","text":"Verkhovna Rada adopts four \'decommunization\' laws banning communist/Nazi symbols and related propaganda"},{"id":"e9f26f83-5107-4efe-ba57-4e58c267e160","text":"Assassination of pro\u2011Russian journalist Oles Buzina in Kyiv"},{"id":"9e55106a-7482-4706-a33f-a00cd680d924","text":"Adoption of the \'lustration\' (cleansing) law removing/formally barring former officials from public office"},{"id":"f4cc7d28-2245-4715-877f-7e297453bf71","text":"Reports of Ukrainian authorities detaining and denying entry to journalists (SBU detentions, denied access to some Russian reporters)"},{"id":"14934671-25ef-4fcb-ac30-7e7a0a24bc5e","text":"UNODC/trafficking and organized crime reports covering Ukraine (Global and regional reports up to 2014)"},{"id":"af0e6a14-792c-405d-b028-abba5677a364","text":"U.S. State Department 2016 International Narcotics Control Strategy Report (INCSR) and related country assessments"},{"id":"f709e126-d65f-4650-8f20-26c6f29e7376","text":"Panama Papers revelations linking Ukrainian elites and offshore companies"},{"id":"0d50ed39-c695-45a0-adf1-647e9acb58b6","text":"Mainstream press coverage of the booming \'sound bath\' and sound\u2011healing trend (New York Times feature, Aug 3, 2019)"},{"id":"cc964293-43dc-4ac6-b3f6-64826eb075e3","text":"Publication of a small 2018 study \'Effect of 528 Hz Music on the Endocrine System and Autonomic Nervous System\' reporting short\u2011term stress\u2011reduction biomarkers after exposure"},{"id":"aee0d9b5-873e-4876-8143-ded63ba56d81","text":"Wellness platforms and apps published accessible explainers promoting 528 Hz as relaxing/\'healing\' (example: Calm blog explainer on 528 Hz)"},{"id":"17021d81-1db1-4e4b-bfec-2b8ab480913a","text":"Russian authorities completed a domestic switch of Crimea\'s public telephone numbering to the Russian system (transfer of city codes to Russian numbering, widely reported May 2015)."},{"id":"9e2c67f0-d232-4772-bff4-99e0672e6621","text":"United Nations General Assembly Resolution 68/262 (27 March 2014) reaffirmed Ukraine\'s territorial integrity and non\u2011recognition of the 2014 Crimean \'referendum\'."},{"id":"f37a2d41-3591-4675-b8b3-45aecfd0c1b7","text":"An ITU Operational Bulletin issue published information submitted by the Russian Federation about numbering in Crimea (the bulletin included Russian-requested codes but carried an ITU disclaimer that publication did not imply recognition of territorial status)."},{"id":"d24b3f28-0f8b-4a28-8b04-e32be4bb071d","text":"Ukrenergo confirms restriction of power flow from the Ukrainian grid to Crimea"},{"id":"0748ae90-600e-4ee4-bfe0-075c8f9e1544","text":"Russia announced a fast-track citizenship/passport scheme for residents in occupied Kherson and Zaporizhzhia"},{"id":"424761bf-f0dc-48e5-af5a-cac0413c3ec6","text":"The Russian-installed head of the occupied part of Zaporizhzhia signed a decree to begin preparations for a referendum on joining Russia"},{"id":"d5950ac7-0671-4798-adcc-972fdf905721","text":"Russian President Vladimir Putin recognized the self-proclaimed Donetsk and Luhansk \'people\'s republics\' as independent entities"},{"id":"fa95aa46-bb79-4138-86fe-7e6ab9b3242d","text":"NOAA and international reports showing greenhouse gas concentrations and ocean heat content reached record highs in 2021 despite pandemic-era emissions dip."},{"id":"e24110d5-1180-4c16-bc38-795134e27b4f","text":"IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, stating human influence on climate is \'unequivocal\'."},{"id":"79d35ee0-ac57-4239-b894-633b79dbbca3","text":"Unprecedented Pacific Northwest heatwave that broke all-time temperature records across parts of the US and Canada."},{"id":"1fa91e98-dfdf-4d17-a1c2-0e55453f5f68","text":"The Pfizer\u2013BioNTech Phase 3 clinical trial protocol (NEJM supplementary material, published with the trial paper) contains wording that \'each lot of \\"Process 2\\"-manufactured BNT162b2 will be administered to approximately 250 participants...\'."},{"id":"cee11ac5-ee9e-4d90-b6b8-a84a489a312a","text":"Regulatory assessment documents (EMA/UK regulator summaries and later EMA follow-ups in 2022) described two manufacturing processes (Process 1 and Process 2) and required post\u2011authorization comparability analyses that were later reported as fulfilled."},{"id":"d8e60c1f-58fd-434f-944c-4ce72c545008","text":"Publication and long-running media attention to the Altamont Pass Wind Resource Area bird-fatality monitoring and final report showing substantial raptor deaths at a major U.S. wind zone."},{"id":"a3b4508c-58cd-474d-8161-5429b8d23b20","text":"2020 study/news coverage showing that painting or visually marking turbine blades (Sm\xf8la, Norway) reduced raptor collisions by a large percentage."},{"id":"26dbb4b5-ff59-4c9f-815c-e1f87e0122c8","text":"U.S. Food and Drug Administration issued public statements and warning letters (Nov 2019 and subsequent actions) about companies illegally marketing CBD products with unproven health claims."},{"id":"9517f92c-be11-4f77-b5ee-47c14548bfee","text":"Mainstream consumer interest in \'clean\'/\'natural\' personal-care labels (clean-beauty trend coverage)"},{"id":"e6277357-fcd9-48e6-a897-eec71ba573e6","text":"Ukrainian authorities/Parliament and agencies moved to blacklist or restrict performances by some Russian artists (summer 2015)"},{"id":"b455d2a9-7776-47f3-bfc2-6bd1840b4e90","text":"Verkhovna Rada passed \'decommunization\' laws and other cultural-memory legislation"},{"id":"5462430f-9209-443c-bf3f-61c34bb63bea","text":"Adoption and controversy around the Kivalov\u2013Kolesnichenko \'language policy\' law (entered into force August 2012)"},{"id":"73a8a531-40d0-4db2-84e2-becc6fa725c6","text":"Ukraine\'s National Council for TV and Radio Broadcasting ordered cable operators to stop retransmitting several Russian TV channels"},{"id":"216ca709-f69d-498f-b4f4-786c1e244b9e","text":"Russian leadership publicly denied deployment of regular Russian troops to eastern Ukraine (e.g. Vladimir Putin statements denying regular Russian troops are in Ukraine)."},{"id":"4b51393a-45b7-443a-bff4-0a494e99f6c3","text":"OSCE Secretary General Lamberto Zannier and OSCE Chief Monitor Ertugrul Apakan issue a joint statement after Minsk talks noting the SMM could not verify removal of \'foreign armed formations\' and stressing need for access to verify compliance."},{"id":"cbd4739a-100c-4f24-a7b8-c3247ecbca13","text":"Ukraine\'s ambassador to Italy publicly criticized Verona\'s revocation and called it orchestrated by external (Kremlin) influence."},{"id":"a42bf906-e647-42b7-92d7-36ebf96c9b4f","text":"Ukraine recovered and returned 17 paintings stolen from Verona\'s Castelvecchio museum; Poroshenko took part in return ceremonies."},{"id":"c021dd4d-806a-4032-8bf1-7ebf4d93c3bc","text":"Widespread public fear and vaccine hesitancy in Samoa after the 2018 deaths\u2014many parents reportedly stopped taking children for routine immunisations."},{"id":"c381469c-31d4-4198-b0b3-e812ef317ace","text":"Two senior Samoan nurses were sentenced to five years\' imprisonment for their role in the infants\' deaths after incorrectly administering the vaccine."},{"id":"8a295faf-9404-48e0-a62b-27c2f552136f","text":"Published clinical case reports and reviews documented rare but real cardiac or severe complications occurring around dental procedures (e.g., cardiac arrest during recovery after tooth extraction)."},{"id":"e78e8eb1-4810-4e35-a9c3-b2dcd8790b99","text":"U.S. Defense Threat Reduction Agency (DTRA) and the U.S. Embassy publicly documented long-running U.S. cooperative biological threat reduction work with Ukraine (lab upgrades, surveillance, diagnostics)"},{"id":"93f0c2dd-8870-43fa-9452-41202cc779dc","text":"Ukraine experienced major vaccine-preventable disease outbreaks and entrenched vaccine hesitancy (notably large measles outbreaks in 2017\u20132019)"},{"id":"d02dcf65-6a38-45fb-a525-077a35bf4ef7","text":"AstraZeneca temporarily paused its global COVID-19 vaccine trials after an unexplained illness in a trial participant"},{"id":"57a02ad8-4448-44e4-a141-520c03160428","text":"U.S. FDA issued an Emergency Use Authorization (EUA) permitting distribution of donated hydroxychloroquine from the Strategic National Stockpile (EUA issued March 28, 2020)."},{"id":"90a9d5a6-f8af-4493-8fa5-a42bb8db9d4f","text":"Dr. Vladimir Zelenko publicly promoted his outpatient \'Zelenko protocol\'\u2014hydroxychloroquine + azithromycin + zinc\u2014for early COVID-19 and gained local/regional media attention."},{"id":"96e3dce7-9eba-4438-ace4-aa43e5d214d6","text":"Publication of Cowling et al. 2012 randomized trial reporting increased non\u2011influenza respiratory virus infections after inactivated influenza vaccination"},{"id":"0a6a1145-a3d4-4a65-ad60-e225a9c91c46","text":"National Academies report \'Reflecting Sunlight: Recommendations for Solar Geoengineering Research\' (June 2021)"},{"id":"d9bbb9e7-9567-43cf-b61a-226860dd80e3","text":"Release of the 1996 Air Force study \'Weather as a Force Multiplier: Owning the Weather 2025\'"},{"id":"f2d28ca5-a4ff-4723-afa9-d0c2392f65b2","text":"Declassification and press reporting on Operation Popeye (U.S. cloud\u2011seeding in Vietnam, 1967\u20131972)"},{"id":"3134a2b8-f439-43c9-8be8-b77d0679cc74","text":"President Zelensky\u2019s office formally responded to petitions about the Catherine II monument and forwarded them to the Odesa City Council for consideration (per presidential response practice)."},{"id":"bf33dd8d-4985-4073-8f29-e88dd634f265","text":"Separate electronic petition to dismantle the Catherine II monument was registered on the President of Ukraine\u2019s petitions platform (petition 22/145072\u2011ep)."},{"id":"0ae7dfd1-35fa-40e0-9e47-14a3f14848bb","text":"Online petition to replace Odesa\'s Catherine II statue with a monument of US gay adult performer Billy Herrington reached required threshold for presidential consideration."},{"id":"89e102d9-1bc7-4f63-bffd-7fda65291691","text":"Sustained local activism and public debate in Odesa in mid\u20112022 calling for removal or relocation of Russian\u2011imperial and Soviet monuments."},{"id":"4800cff6-05ef-4559-b9b5-a060f3cb3d0c","text":"Large releases of internal Pfizer/FDA documents following the PHMPT FOIA lawsuit and judge-ordered accelerated disclosure (documents began being released publicly in early 2022)."},{"id":"7c273f10-c8b5-434f-be52-45e323e4b064","text":"FDA briefing documents for the Dec. 2020 Vaccines and Related Biological Products Advisory Committee (VRBPAC) meeting that listed trial deaths and stated investigators assessed none as related to the study intervention."},{"id":"0fbbb965-1633-4ea5-9ce9-928f175f5658","text":"Early COVID-era clinical reports and reviews highlighted that the eye can show signs of infection (e.g., conjunctivitis as a presenting sign of COVID-19)."},{"id":"0efe9f04-6dda-42a8-987f-1cce1fdd533e","text":"Popular science and health journalism pieces explaining how eye exams can reveal systemic health issues (diabetes, jaundice, hypertension) reached wide audiences."},{"id":"2a20c42f-31d4-49e4-9328-7b3282f6e95c","text":"Published analyses and meta\u2011analyses in 2022 documented reduced vaccine effectiveness against Omicron infection and waning protection over time, with lower effectiveness for preventing symptomatic infection and some reduction for hospitalization in older/longer\u2011since\u2011vaccinated groups."},{"id":"b9c1a642-6b35-4068-9dc3-d7b1c57c987b","text":"Academic commentary and public explanations (e.g., Lancet / public\u2011health pieces in 2021\u20132022) highlighted the \'base\u2011rate fallacy\'\u2014how, in highly vaccinated populations, the majority of cases can be vaccinated even when vaccines work."},{"id":"c3cd41e0-2bb7-4e09-b02f-d168d847ab28","text":"DIVI (German intensive care registry) added fields to record COVID-19 patients\' vaccination status, enabling routine recording of vaccinated/unvaccinated counts on ICUs."},{"id":"fbea327b-7fd0-40ce-beea-46f16a9dbf94","text":"Scientists and aerial surveys announced a third mass bleaching event on the Great Barrier Reef during the 2019\u20132020 summer, widely reported as \'third mass bleaching in five years\'."},{"id":"083aa95c-3d27-4a40-8b2b-c6dbb45571a6","text":"UNESCO and the Australian governments\u2019 2019 reporting on the Reef\u2019s deteriorating outlook (2019 Great Barrier Reef Outlook Report / World Heritage Committee concerns) signalled long-term decline."},{"id":"33f55771-cf51-4296-b261-8bcf53c93068","text":"Armenian NGOs and civil society groups (in early November 2020) issued public statements condemning Azerbaijan\u2019s reported use of white phosphorus munitions."},{"id":"ba324eb4-9fbf-4cd7-b4aa-f8445cf55c58","text":"Open-source satellite imagery and videos in November 2020 showed burn patterns and footage consistent with reported use of white phosphorus munitions in the Second Nagorno-Karabakh War."},{"id":"091ff2a4-b374-4426-a33d-f7e23441452b","text":"Azerbaijan formally responded to Armenia\'s accusations at an OPCW session, denying the claims and disputing evidence (official statement recorded in OPCW documentation)."},{"id":"5fdb36f1-22ad-46b1-9e69-2e4bfe4e544e","text":"IPCC Fifth Assessment Report (AR5) discussion of the 1998\u20132012 \'hiatus\' in surface warming"},{"id":"43a3c668-1c99-4d67-9f07-2295e4fa2080","text":"Hockey-stick controversy and critiques (McIntyre & McKitrick critiques and 2006 NRC review)"},{"id":"24d78005-f0d3-4ce1-8a38-c5f713bfa53e","text":"Public Health England technical briefing (Technical Briefing 16) published with early variant case and death tables"},{"id":"df94d9a3-14cb-4884-8808-85de69e39f11","text":"Publication and press coverage of the Scottish EAVE II analysis showing Delta linked to higher hospitalisation risk"},{"id":"d97816b9-dc50-4549-9310-8f2a26c9df84","text":"UN OCHA/partners publish Ukraine Strategic Response Plan (humanitarian appeals for Ukraine, 2015)"},{"id":"57d0e2b5-f4e4-4932-9b99-14b636e2d8fb","text":"UN Security Council action on Crimea blocked after Russia veto (UN inability to act on Ukraine-related measures)"},{"id":"7381c9e5-6728-47f0-b327-03b0b0082787","text":"IMF delayed/suspended loan tranches to Ukraine amid governance and reform concerns (2015\u20132016)"},{"id":"f4cd8341-4133-4ece-98c5-3f1ae86bfb81","text":"UN humanitarian funding shortfalls reported in 2017 (large gaps between appeal requirements and funding)"},{"id":"f5e3fa72-fb2b-4c8e-8937-2731018dc071","text":"UNDP policy guidance states UNDP will not contribute to general budget support (direct government budget transfers)"},{"id":"6060e61e-be0c-4d1f-8878-1c1691b915b0","text":"Poland passed the \'Special Act\' on assistance to Ukrainian citizens (granting temporary protection, PESEL registration and access to services) that entered into force in March 2022."},{"id":"4cceac16-67f1-48e7-8030-b9a52678e11b","text":"Ukraine\'s Cabinet adopted Resolution No. 678 approving an experimental project to allow issuance of Ukrainian ID-cards and foreign passports to Ukrainian citizens abroad."},{"id":"494e5828-8795-4c50-ad8d-fc4c2c209197","text":"Major reporting on rapid mass issuance of Polish ID numbers (PESEL) to Ukrainian refugees and the setup of document/ID help points (e.g., coverage of refugees receiving IDs at Warsaw sites)."},{"id":"bc22ef75-a7e4-4de0-ae26-55f122fe2cdb","text":"Ukrainian document service announced opening of a centre/representation in Warsaw (Blue Office / Blue City) to process Ukrainian passport and ID applications."},{"id":"a1d7fb2b-8edc-4915-91fc-fe18cad847db","text":"Publication of the NIC\u2011PD randomized, double\u2011blind trial (Transdermal Nicotine Treatment and Progression of Early Parkinson\'s Disease), published online Aug 22, 2023 (NEJM Evidence / PubMed)."},{"id":"81f0649e-10ef-4038-901d-eb4f190f3980","text":"Statement by Eduard Basurin (DPR deputy defence minister) claiming drunken Ukrainian soldiers stole a tank and crushed a civilian car in Zoria, near Mariupol."},{"id":"918addad-d5e4-491e-8588-7c777292ac5a","text":"Kerch ferry operator reports unusually high passenger volumes in summer 2016"},{"id":"bdac5e50-c5ac-4987-a66f-56d660418bf7","text":"Crimean tourism minister (Sergei Strelbitsky) publicly claims sharp rises in Ukrainian visitors during 2016"},{"id":"008fdc96-62f2-4c1c-b1d6-f6f399651308","text":"Russian media cites security claims that alleged Ukrainian sabotage aimed to \'destroy tourism\' in Crimea (Reuters coverage)"},{"id":"23817343-8b81-46a8-9320-6fa8dee46184","text":"Early, well\u2011publicized problems with the CDC\'s original PCR test rollout in February\u2013March 2020 (flawed reagents and re\u2011validation), widely reported in the press"},{"id":"97852f8a-f5b8-43ae-a75a-95eb5ed90c03","text":"CDC promotion and availability of a multiplex \'Influenza SARS\u2011CoV\u20112 (Flu SC2) Multiplex Assay\' that detects and differentiates influenza A/B and SARS\u2011CoV\u20112"},{"id":"b56599e9-ad72-4144-9d60-987d74ff264b","text":"Zelenskyy\'s public denunciations (Aug 2023) of corruption in military medical exemptions and announced reviews"},{"id":"fe6f6fa5-3c2e-4e35-aa6a-0adf5b433b80","text":"Law / parliamentary changes expanding categories eligible for exemption or deferment from mobilization (July 2022 amendments and related guidance)"},{"id":"f63db715-5bd4-4e51-bd67-35cb0f93c1c3","text":"Canadian Parliament standing ovation for Yaroslav Hunka (a veteran who served in a WWII Galicia-linked formation)"},{"id":"33e94dd0-492b-499c-83b2-f52adabde777","text":"Japan suspended use of ~1.63 million doses of Moderna\'s COVID\u201119 vaccine after \'foreign materials\'/contaminant reports were found in some vials (batch recalls/inspections)."},{"id":"d472a84b-ab39-4837-a279-74b14e2731b4","text":"Federal judge ordered the U.S. FDA to accelerate public release of internal documents related to Pfizer\'s COVID\u201119 vaccine (court\u2011ordered accelerated disclosure ruling)."},{"id":"839b62b4-9b33-4648-88dd-6cc8e85f656f","text":"Publication of an Israeli health\u2011system study (NEJM, Oct 6, 2021) reporting higher incidence of myocarditis among males 16\u201329 after BNT162b2 (Pfizer) vaccination, with most cases mild or moderate."},{"id":"23a1676d-b41f-4b99-b09a-8f17c643747c","text":"Ukrainian adviser says counteroffensive is months behind because of slow Western arms deliveries"},{"id":"6e5165d6-1bd5-4ce7-91c6-45f010d28978","text":"Analyses warn Western help for Ukraine may diminish due to production and political limits"},{"id":"54ae4560-4a71-4358-8e33-fef3a52ab75e","text":"UN Security Council briefings raise concerns about diversion and proliferation of weapons sent to Ukraine"},{"id":"d8f8a2c0-bf07-461d-99c1-9859649a61e0","text":"EU admits it will miss target to supply Ukraine with one million artillery shells"},{"id":"d3425a87-4b6e-42bf-b2fa-eff4512c53bc","text":"Countries reimposing or tightening lockdowns despite earlier measures (e.g., Israel second lockdown September 2020)"},{"id":"040d00aa-47e1-4c98-ad24-df042df860e3","text":"WHO interim guidance on mask use that did not recommend universal mask-wearing for healthy people (interim guidance)"},{"id":"646b569c-f662-4221-962a-ee7e0f3a48ae","text":"Great Barrington Declaration advocating \'focused protection\' instead of lockdowns"},{"id":"acf7757c-4a99-480b-8ee7-b09918bbffca","text":"Sweden\'s no-lockdown approach widely publicized"},{"id":"9866e716-7537-48dd-956a-7bf35f3b3741","text":"CDC recommendation for cloth face coverings in public (policy change)"},{"id":"7821f6dc-af3a-49ec-b236-d2ddae3f9d02","text":"Ukrainian authorities move to redeploy ships/hovercraft and increase patrols in the Sea of Azov (reported August\u2013September 2018)"},{"id":"e3089e01-dca9-435b-b9f9-e996f3add74f","text":"Kerch (Crimea) bridge opening and its reported impact on navigation to Azov ports"},{"id":"dc3b4953-1867-4ab4-9561-7206fe782a8e","text":"Public recall and investigation of foreign particles (stainless steel/black particles) found in some Moderna vaccine vials in Japan"},{"id":"1a072915-3b62-4d18-89ca-4e5b22d19ce2","text":"Pfizer\u2013BioNTech and Moderna vaccine efficacy announcements showing ~90-95% protection in trials (Nov 2020)"},{"id":"2bdcca91-cc30-45f0-91c7-e6e19e2b0c33","text":"Large cohort study showing robust neutralizing antibodies to SARS-CoV-2 persist for several months after infection (Wajnberg et al., Science)"},{"id":"c79bfc63-8fee-4065-942a-5bd69c39be00","text":"Arrests and terrorism charges against Crimean Tatars by Russian authorities"},{"id":"b4e5ffeb-5b1e-4223-b639-c6993b27b0a8","text":"Ukrainian President Petro Poroshenko publicly vows to \'retake\' Crimea / \'de-occupy\' the peninsula"},{"id":"b3c01f64-695b-45dd-86ac-3532acdb540a","text":"Repeated legal actions and arrests of high-profile alternative practitioners (example: Harry Hoxsey prosecuted repeatedly for practicing without a license, 1920s\u20131950s)"},{"id":"5f892b3d-872c-4d53-bbc2-e4db6eea1682","text":"Air New Zealand suspended its Auckland\u2013Buenos Aires service during the COVID-19 period (service brought forward in March 2020)"},{"id":"6f7d4055-8be6-4fdc-938a-fabe5e516197","text":"CDC filed and was assigned patents on coronavirus isolates/genomic sequences (e.g., patent US7220852B1)."},{"id":"c483ea93-8523-41f9-a61e-ee868ad4cf6e","text":"Widespread availability and consumer use of over\u2011the\u2011counter vitamin C supplements (NIH/Oregon State fact sheets documenting common use and safety perceptions)"},{"id":"17172956-7a49-4cad-bad7-acba17942b4a","text":"Parliament vote to repeal the 2012 language law (February 2014) following the Maidan changes."},{"id":"204e0cc1-634d-4ed1-9f7f-d97c784c7c31","text":"Adoption of the Kivalov\u2013Kolesnichenko language law in July 2012 (Law on the Principles of State Language Policy)."},{"id":"9c0f6744-34e1-4673-b6d4-390fb27b1a9e","text":"Introduction and entry into force of Ukrainian-language content quotas for radio and media beginning in 2016 (e.g., Ukrainian music quotas on radio adopted Nov 2016)."},{"id":"fbebad4c-0764-4bb1-ac23-cf33fefb6479","text":"Ukraine\'s 1996 Constitution declares Ukrainian the state language."},{"id":"1a4978e3-02e9-4fa6-b620-2cccd43851ab","text":"Visible nationalist rhetoric and high public sensitivity in Lviv and Western Ukraine during the Euromaidan/early\u20112014 period (local protests, symbolic actions by nationalist groups)."},{"id":"e7b35665-d6ee-4f1a-8e50-f74ec2d2acec","text":"Systematic review (Farsalinos et al.) published April 2020 summarizing multiple Chinese hospitalized case series and noting lower prevalence of current smokers among COVID-19 patients."},{"id":"00a2a27d-32c8-4a8b-be3b-9ed3e06ffdc7","text":"Comptes Rendus paper by Changeux et al. (\'A nicotinic hypothesis for Covid-19\') proposing nicotine-receptor involvement and suggesting nicotine could have preventive or therapeutic implications (manuscript received 16 Apr; accepted 18 Apr 2020)."},{"id":"42c87d2d-b408-49a1-902f-92ac472bdaff","text":"Public reporting and official statistics showing very high vaccine uptake among older adults in the UK by early July 2021 (large majority of elderly vaccinated)."},{"id":"25aada7e-13e3-4369-bf9b-717144c5afd7","text":"Ukrainian statements in late June warning that failure to stop Russian aggression risks broader geopolitical consequences (coverage in Ukrainian press)"},{"id":"2aeb304e-6e62-44c1-b9a6-7aec1b078436","text":"Regulatory safety updates and post\u2011authorization adverse\u2011event summaries published by national agencies in June 2021 (compiled safety figures made public)"},{"id":"f39a7b76-7b7d-4b55-b6f5-022ab5954c22","text":"Publication of Israeli real\u2011world vaccine effectiveness analyses estimating infections, hospitalisations and deaths averted by the national vaccination campaign"},{"id":"2eaa4d5f-5434-4b0c-97c1-dfe2fa199bab","text":"U.S. Fish and Wildlife Service listed polar bears as \'threatened\' under the Endangered Species Act (ESA)"},{"id":"9160fce3-639a-404f-bc2d-247e2f635b91","text":"Record-low Arctic sea ice minimum in September 2012 reported by NSIDC (new modern-era low extent)"},{"id":"fb3a0ff9-85fd-4a72-80a0-e6867be164fe","text":"Natalie Jaresko was granted Ukrainian citizenship and appointed Minister of Finance in Poroshenko\u2019s new cabinet."},{"id":"50193c60-d618-4f3a-abf1-4f0b12109764","text":"Kateryna Yushchenko (wife of former President Viktor Yushchenko) is publicly known to be American-born (born in Chicago)."},{"id":"b47f6e2a-d3a4-4ae5-bd22-18f9947d3e27","text":"Reporting that Ukrainian authorities and units were struggling to vet, equip and deploy newly arrived foreign fighters."},{"id":"4c69ec36-cf69-48e0-9359-b8cb2ff98b4a","text":"Ukrainian president announces creation of an \\"International Legion\\" and publicly appeals for foreign volunteers."},{"id":"351cc15c-a27f-47ca-b694-732d51544410","text":"Analyses and warnings about the presence of extremist and fringe foreign volunteers (scholarly/think\u2011tank reporting noting far-right and other fringe actors among some volunteers)."},{"id":"3f9f599e-0545-407d-a228-856b831a5cb2","text":"German industry and officials warned that proposed U.S. sanctions (and pressure) risked harming projects such as the Nord Stream 2 pipeline"},{"id":"05f75e3c-f07a-4364-88d3-a266a0b06c8b","text":"German Foreign Minister Sigmar Gabriel said sanctions on Russia could be eased if there is progress on implementing the Minsk agreements"},{"id":"2760a08d-440e-473a-8c1e-715e05679c7d","text":"Chancellor Angela Merkel publicly urged dialogue with Russia after Vladimir Putin\'s 2018 re-election"}],"claim_clusters":[{"cluster_id":"54385df9-c5b3-4372-ae3b-cfd7db571df8","members":["f87c7600-59d2-4ab4-b09a-ae422e1e69e9"]},{"cluster_id":"6f7b7d52-9a91-4f92-8a4e-4062c6360cda","members":["6f6bed63-08c1-46fe-8bc0-1c762801e334"]},{"cluster_id":"3198b672-2780-47ef-8885-73e8c5597d80","members":["a576c4b4-0c65-49ca-920b-4ecaded09384"]},{"cluster_id":"8bdd6183-6e5d-4862-87e8-003b661f98ce","members":["f0ddc375-3356-4444-8d0d-b137fc47122c"]},{"cluster_id":"d08db747-1994-456e-82f1-cca372892842","members":["1f421a35-85dc-4389-ab19-8fdf35e33f3e"]},{"cluster_id":"85d98ed5-328a-4d59-91fb-32ddcf786d50","members":["7400f459-1420-43ec-a057-7d69851f577c"]},{"cluster_id":"1ef62c3d-3750-43b9-855b-d4624938de1e","members":["465cb9b4-8693-4886-96ab-d5d5e84e1e2e"]},{"cluster_id":"528a9885-82c7-4bee-beac-f85e4c7c3f1b","members":["c9a02044-aa17-4168-9b5f-43f734461b60"]},{"cluster_id":"000d729d-1afe-4b59-b42a-5d8012efd354","members":["086a9850-cfba-4b59-bff1-4732196891ce","9481983d-c22e-4db3-9b32-4c294f36a4ee"]},{"cluster_id":"25acea26-0f6c-421d-8050-ebc9dac75b8d","members":["0fbf6f50-adb0-4459-b4e8-6ebf6f31e8e8"]},{"cluster_id":"c58f6371-bd47-4b22-b946-60358a570901","members":["aeef8c35-aa6a-42aa-89d5-b5ef72ad0beb"]},{"cluster_id":"c0fbbbbf-776a-47c5-9e8d-f798f722abf7","members":["81f3c3ca-b0d6-4aaf-9d5a-fe7f160017c9"]},{"cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","members":["cefba4be-9e4f-49c9-9321-69129a73e873","ac1ea412-c8f5-4d1c-8e19-03dc3ae75d56","e16ed705-04cc-4390-aca3-42a049dd05bc","5443ea63-f07c-43ad-ac4b-6a2569e1f360"]},{"cluster_id":"a604694d-4fcd-48e0-a074-6eaa09488a89","members":["f3ef8d86-919b-47e4-8137-ade143408568","e48cf645-1df7-4c3e-9a96-308dc5f930a6"]},{"cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","members":["f951af6b-e20c-4693-87a6-aa62d357aa89"]},{"cluster_id":"c5298737-21d9-47c4-b52e-e662ee88b15b","members":["f1708d7c-799c-4de3-b923-5f356ffd9bff"]},{"cluster_id":"2edb056a-640a-40d9-89e2-36dbc25022b5","members":["bd49ac10-4124-493d-a447-94fc3b09335a"]},{"cluster_id":"0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5","members":["3174a2d7-510e-462b-b43e-c80382769e5e","5e4f1ea6-61f3-40d0-a513-02d3958732cf"]},{"cluster_id":"6d600ff4-5ee2-443b-9049-7fb530fb454c","members":["c8a56e68-c7db-45d3-9241-1c28265623aa","cd7c217a-f1df-4b12-ba39-e679935643a3"]},{"cluster_id":"21b4d7af-e8bf-408f-b63a-f91c28b7ba72","members":["73cfa6ef-31dc-440e-9025-3009960098c4","b84ae49b-ac57-4579-aa6d-644ea4a451ed"]},{"cluster_id":"1977f04e-4cc8-4af7-ae78-39ce7804eadf","members":["28165b23-e753-4582-8659-4231b30f8237"]},{"cluster_id":"6fa599b7-9959-44ea-a8f2-40b7f43bb558","members":["4f4a6042-cf34-4fd2-a9da-526f14b561e1"]},{"cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","members":["ec29c403-da4f-4c5a-a13b-6b24c7b13867"]},{"cluster_id":"58bf9f4a-adda-4853-802b-78d04aa711fa","members":["4737bc2d-57d8-46b8-a574-207bb792d8b7"]},{"cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","members":["336912a9-e1a3-4f57-8f9c-b7762b7209f8","a88b2527-91c6-4d02-858e-633868b1e316","bde9d065-4da5-4122-84e2-a2a71d3d397d"]},{"cluster_id":"1cf25dc0-5ba1-4372-8fe0-913839532e6d","members":["f768b4b6-6925-4a85-bb50-60f94a7741a2"]},{"cluster_id":"903d2f0d-f14e-42ff-a685-a20e841d8f7b","members":["4938b926-8428-4afa-a749-574cecd5ae2c"]},{"cluster_id":"98459a3d-d71e-40dc-bfe8-895082c9d11c","members":["d9e4dbc1-fb36-4daa-994f-f0a09fb3659f"]},{"cluster_id":"821946a1-401a-4657-be17-b3ed51371c13","members":["89093070-7dbe-49e7-b3dc-5cc044d4dbc3"]},{"cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","members":["7a0d9023-d84a-4e6b-a041-5cde85e6e7b2"]},{"cluster_id":"2c49dd92-a97e-4b1e-bac2-607670a0a86d","members":["27044113-2560-4012-b882-70eb957f02e7"]},{"cluster_id":"d2f81fce-8c92-45e8-8294-41af7752f1db","members":["617b505b-72d0-4e59-b06c-c8ee97076f0a"]},{"cluster_id":"901f6891-5f9b-4fa4-a368-69a4f20e9617","members":["15d251ee-d316-4914-85fb-a36f6f0ee424"]},{"cluster_id":"16667fe1-8cf7-4fec-9aa8-c5bb30920e90","members":["833bc7d2-f731-4664-b1af-2477a3c0901f","56510e96-92e4-4076-baf2-835ea275dbad"]},{"cluster_id":"925ee56a-7eb9-4c7c-aeb3-1eb168cbca46","members":["478eaf7e-5c75-40ca-94b2-5103365ef343"]},{"cluster_id":"6015f261-315c-43b5-ae1a-b6f1ad2e1ce6","members":["f5d192c5-b17f-4f71-a518-017c5e85f4ac"]},{"cluster_id":"b9579765-0e2f-429b-a723-006d6265617d","members":["6fa922ce-55ad-4a30-9fe1-980dad76dc1b"]},{"cluster_id":"fe684e64-4226-4567-8e1f-5613fae2c8f8","members":["de6607f8-6b64-4d75-8e44-11e9e4f7ccb5"]},{"cluster_id":"19ef8fca-6a45-4387-be0d-efc3fd245b80","members":["76d8af43-7e04-45d0-811c-53aac369589f"]},{"cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","members":["15b6738c-12a2-4da8-b74a-ca562126681e","3be75c33-86c8-4847-aee0-67f6c3df0e06","fa08c157-a681-4a26-b553-93c830dee2e0","50dd51fa-63ef-4307-87b0-455a8d787703"]},{"cluster_id":"22107865-2cc2-437f-be8c-dd105a24eaaa","members":["48c6fb30-824a-45f0-b430-1a9c043ac50c"]},{"cluster_id":"8b44daa7-629e-4db8-81b7-5ed88669eb86","members":["93ec9716-d23c-493d-a33b-ce35394dad90"]},{"cluster_id":"0653516b-f642-4236-857e-3f4989809104","members":["767b6e2b-87ff-4adf-a611-c0fca1a914b0"]},{"cluster_id":"bfa96159-d0c2-4735-8c1a-2d33b2346d24","members":["0b3711a1-a958-4235-be1b-2e354c057f75"]},{"cluster_id":"0298b49f-bf28-40f5-acd6-4e9587c690ae","members":["427e50ca-3a16-4ebd-83e1-e40b51ad9592"]},{"cluster_id":"5a77fa7e-06f0-487a-a93b-f15e590aa54a","members":["17856776-94dd-4971-8f6a-b452ce40df62"]},{"cluster_id":"c0a45d49-4b4d-4871-845a-e13c06e06fa2","members":["e8074bd8-53a0-4814-aced-1acb0c5245fc","37bec350-cb9c-4cf5-b0e9-f634d9686f01"]},{"cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","members":["16c696ba-d994-4261-8da6-1a270cd3048e","22f58df3-30ac-4a5a-b495-5e67661f640c","a8c9c515-3996-4b03-9b74-2439120b001d","c3bc63e4-3848-4ca2-8707-206e5c2af2b2"]},{"cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","members":["1b8a80cb-00a8-49f8-9abe-a0573478b25b","6766b9c1-406d-4828-8659-a18545ca193d"]},{"cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","members":["edf3fbc7-c80f-4143-9f75-5bc39a8ec5cf"]},{"cluster_id":"b2635760-bcd6-46c7-88fb-9bbbb7349033","members":["9f9a7f59-cda2-4d08-bfc3-1137f05c0d76"]},{"cluster_id":"d6c74194-ae1f-4099-a13b-0f247e76b288","members":["c0910306-1bdc-466f-b897-fa554e758e08","9cf05b3f-382f-43f9-8123-06d6ff2879e4","c9488325-cda6-4175-8aab-76fc0f8bd6d4"]},{"cluster_id":"6b8a2895-80e5-4b3c-853c-39abf201a8b0","members":["e0275e8e-3f36-4ee3-8547-1e63a469c2cd"]},{"cluster_id":"db6d1f55-1378-42e6-ab38-0b1046e37cc0","members":["8dd0a52c-1ee1-46db-b2c7-974908ed3fcc","a595315e-7ec1-4c80-abff-07725d6dcf14"]},{"cluster_id":"68142908-c71d-4106-9ef3-2de00198c72e","members":["19cb918d-f6c9-454c-a8e5-4273d38115fb"]},{"cluster_id":"91ccf699-eaec-41a7-8213-08934dbe2395","members":["e443703e-4498-448c-beee-ccd4451cad2b"]},{"cluster_id":"9096173e-de4b-47e9-9e39-b39282b05e47","members":["08b8c6b4-a939-41ed-a494-d43379fb6feb"]},{"cluster_id":"6f59c0c4-2b1f-4873-80b4-3766eb7b28aa","members":["0e8a03a2-1fd8-4a44-8d0f-face8a2c9c72"]},{"cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","members":["13fd44f4-b3a3-40f4-8580-ca6d9775cbe6","49c1f390-e9fb-4153-bdfa-9523ca30b466","d572be63-43ec-4f6b-9196-a4fc78e203a6","f65d41cb-fc8a-47b7-8a48-2d4eb9377096"]},{"cluster_id":"745389b6-9b21-4dd2-89bd-e66fab0ff334","members":["dfa5b8a9-77e9-491a-b2dc-c11684135e6d"]},{"cluster_id":"2c44608d-8e33-4f88-ad5e-7e4885719e31","members":["09c6031a-b6a1-4281-8806-488266d5d9a1"]},{"cluster_id":"bc630aac-e921-4ad6-990d-40d804192d55","members":["d66a2ce6-c126-42a6-963d-51a7681ca771"]},{"cluster_id":"616e962d-58a9-42e5-9a6d-decd8139ddf7","members":["d0bfc1de-e35a-4da9-8154-5f258fef738a"]},{"cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","members":["12008091-2bc6-4890-bb3c-854215a50247"]},{"cluster_id":"7051d37c-4575-4653-97a5-3052e1c2b344","members":["35ea3880-9e1c-4ede-9b52-6247aa147b68"]},{"cluster_id":"2c1958a0-e83a-4912-9902-e6456b756f14","members":["99c8e862-b82f-40c0-b65e-d6a7fd0d0339","4fdb3b57-9805-49aa-9ede-c400eb1945b3"]},{"cluster_id":"689e5dcf-938b-411b-9e5b-4de3aa6f026b","members":["e91bd487-5e4d-4843-9770-ebcce124f228"]},{"cluster_id":"be7f1195-f177-4bc7-91dc-0cfb479ebb8e","members":["536d327b-e914-4557-8e17-34f659a733b3"]},{"cluster_id":"f90286ec-0f96-4266-aa5f-350beb9c1d91","members":["f4fcca1d-59e4-4afe-85f0-23c1b3f24c20"]},{"cluster_id":"18fe8f4b-896d-47b4-a019-0383dc22d38e","members":["beeff699-16f0-47ec-8c97-621e2753189c","0cd5a5ec-984a-46a9-b75f-473d9ca5d392"]},{"cluster_id":"aac18326-5af8-47ed-b7a7-209e78b29dfe","members":["cd998a9f-f5b7-4714-a65f-5f84fa314285"]},{"cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","members":["8213f3f9-e4a9-43f9-9c2c-f422caa0ec18","2d2a3a96-0b99-495f-8ccf-3917ec3328a7","a7a7f1ae-fd6b-4da5-b669-3516ad890958","47df24f4-8606-426b-9cee-667f9c8df0c0"]},{"cluster_id":"3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9","members":["cd434d04-1633-489e-bfa6-926384c048f9"]},{"cluster_id":"3e1920d2-6038-4d0b-b122-137c458f6d99","members":["7a443fce-0c0b-4539-9cf1-6940824b372f"]},{"cluster_id":"de1f8a69-eaff-4387-87ee-35fc20ea4a2f","members":["b85bd849-6965-49db-8bfa-2c341a6b767b"]},{"cluster_id":"843e2174-20bd-4386-beb4-ad4f8d0ba790","members":["2624b9a6-3642-47aa-838b-93a16681e6b8"]},{"cluster_id":"8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18","members":["a72f5b31-09c3-4779-b8ac-06cb11df19f5"]},{"cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","members":["5a47361f-f3f5-4848-996e-ab8a35e53506","6556fa0f-7605-4ab6-81a2-f99e0802e367"]},{"cluster_id":"7c045c5d-d9cb-4901-a4fe-8f8a68090a83","members":["27bed591-efe4-4380-9175-463d1e9beec9"]},{"cluster_id":"f10ad797-ad79-4629-861d-4af809502a09","members":["488cf1db-9647-4bdd-9bd4-c0f17a970a8d","0445898d-c78b-4144-8eda-758b3dd164b9"]},{"cluster_id":"175bdcd7-0fff-45d5-9e67-f78e69286a6f","members":["ddef5269-c55c-412a-88d8-cc6de159e5d2"]},{"cluster_id":"746085cd-6635-459a-8b25-138f4d67d9dc","members":["d48e7efa-e061-42c7-951d-8b7878442670"]},{"cluster_id":"b26a4469-2931-4dab-aa78-be1b6fba8a36","members":["0b887eb2-d3fe-4a26-b9ed-8ccab8eed304"]},{"cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","members":["7dd93d3f-7b86-478a-8d6a-e2fe3b210bd9","ab291336-2b55-470b-96e8-5a65d246d084"]},{"cluster_id":"8992a182-5ede-4dbb-9979-4dcf0e10c546","members":["5ae1c610-b184-4b7e-9608-8ec637c2163d"]},{"cluster_id":"43d1e3ac-04ef-4f83-99ee-76241c79a7a0","members":["e8a6d2cc-1402-44b4-89d0-d6d15661c184"]},{"cluster_id":"86160f22-53c1-4e04-a28d-86c0e883fa44","members":["bcb10216-8099-4a89-8a2f-dfe48c4f119e"]},{"cluster_id":"09287807-b3db-4547-9baf-8656d4a8733f","members":["9f780feb-277f-4ab7-9d0c-6503c1a72f7d"]},{"cluster_id":"87b92fb4-b0e3-4b01-9c2e-cfd9469245f7","members":["89ec0ed5-16bd-4877-87da-8d57a86b4fdc"]},{"cluster_id":"9920b872-a377-485c-97d1-65b98d038806","members":["78af90a9-231c-467d-bf98-e148fae3d4ab"]},{"cluster_id":"41d64b2b-508f-4c89-9c48-7c598989efd1","members":["71cd1619-22a6-48a4-a430-f9f5fd51f364"]},{"cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","members":["13e59ff3-cf80-48a0-8ca3-bd5160034d1f","4f2b6c36-9cdb-49ec-816c-48a4d58bb10e","864f721b-f058-4fa2-9aa7-84f986dd34c9","5a5e634f-a429-49c4-b8ef-cebfc06153b3","02810d0a-a801-4de0-844c-925df942cad1","52896f5f-991a-4b65-a529-2f922b6a31ea","174d2d07-cece-44ec-bff4-d6647249a61c"]},{"cluster_id":"fb1e3132-0050-4db5-a637-391574f70b71","members":["ff0d0233-5e20-42b2-8006-dc4d0acc2158"]},{"cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","members":["0c37996a-74f5-46b9-80c1-6b106323d2a3"]},{"cluster_id":"cc37a7b6-46fd-4cda-8faf-63a00cd3c131","members":["7097ddfd-3b36-4ba8-92c0-d865bcceffa8"]},{"cluster_id":"73fff1e2-bc77-421c-8436-e9bf094a9733","members":["1ad2a887-f91c-466e-a216-b5d069ecb3f9"]},{"cluster_id":"8346c5bc-af0f-44c1-b155-e89d63c46a37","members":["957f125b-3856-47c7-abaa-0f944b7c91f8"]},{"cluster_id":"c1587edf-f13c-4a02-9534-a3653325bfee","members":["1662e238-4375-4f16-a4e3-54e72797d3bc"]},{"cluster_id":"2b77fdbc-c4ed-4e0c-99a3-6dbf568aa8a5","members":["3739e2cd-1316-4d38-bbcc-80c9e68240f6"]},{"cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","members":["1ab1f948-6a4f-4dbe-930f-d42b1a28f8e0","b7300488-7bab-4bc6-a126-b997fe7c37a7","45e07c52-5893-42d9-a89a-35ed3e29e4d3"]},{"cluster_id":"cbbcd94e-9982-4e51-989e-706618e8fd67","members":["93556400-dba8-4dca-85f4-0b62f5397b0e"]},{"cluster_id":"5ab9d303-668f-48d9-893f-546437484767","members":["2618d609-9085-4e09-964d-340fa3ca368f"]},{"cluster_id":"4e71d535-1646-4ea5-9c47-04fb1464f390","members":["2ee21ada-c92f-4f6e-8afa-775bb49f7ee5"]},{"cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","members":["f2dfb2d5-9fc1-4013-91c6-d706a72fc7a0"]},{"cluster_id":"8347f82c-28cc-4206-8266-0d33250fbc4f","members":["b3756ec0-de4c-400d-ba54-b622375198c7"]},{"cluster_id":"ff26fc04-79ea-483a-b7fa-30217f23ef0c","members":["d85cf775-381c-44b3-8df3-f51f833a51b0"]},{"cluster_id":"2d2ebd07-a80d-4a48-b320-cc68d39bdc10","members":["cb3ca572-0441-4955-a248-db1da354742a"]},{"cluster_id":"13ce1de8-c90f-43f4-ae08-251f1aed012e","members":["78ef9d0d-cbe9-4377-ad53-fc84b39053ac"]},{"cluster_id":"af167078-1ea4-4d05-a491-aca4808cafd4","members":["007d5f3c-bdad-4c07-b684-a26173cf5e82"]},{"cluster_id":"7b2b0362-dab0-48fd-8877-b1ece626a827","members":["4be0dc1d-7530-4841-91d3-ce66989346e6"]},{"cluster_id":"5a772e21-6b8f-413d-9915-01833aadc67f","members":["6f61a9af-edce-4287-87b7-c4ebec356a14"]},{"cluster_id":"60ed7bd8-a38c-4b99-a08f-6210e30fac23","members":["6718d0e7-dcd8-4437-a407-22bd03bc1358"]},{"cluster_id":"73e672aa-47a1-430b-843b-82f236a93650","members":["4331310a-240f-4f5c-8248-c2ed98c42e14"]},{"cluster_id":"2b4fc83f-18c3-4ff7-b918-64e0981dd3b2","members":["7875385f-24d3-41aa-b62b-62e7784acb38"]},{"cluster_id":"0d1ccd4f-6f42-4604-a9be-95ea8fe5adc0","members":["9220a5ba-712b-4df8-ba50-4d8c735c8c3c"]},{"cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","members":["f7606c9a-7151-4bd3-9758-d00141dcb4d8","0ee2c48e-a733-454d-8a13-3b84573113c4","64666dca-81c0-4f77-8e27-11a65af4908d"]},{"cluster_id":"cbafab62-ed48-49fc-9623-dbadef5cfd91","members":["f15e9b17-1ad8-4821-a588-d3af4c719ff8"]},{"cluster_id":"e42f3c12-f894-47fd-b892-02c051609420","members":["1a56dc5e-ba61-4644-9c10-6955323e656e"]},{"cluster_id":"388dcf56-c13f-4ec5-bbc7-b3c71eaffd35","members":["2b7ade88-953b-46f0-bc68-bfaca809912c"]},{"cluster_id":"61ed0aed-dc5b-413d-8a18-4362324862cc","members":["7e467183-d865-4fef-946e-2c23ae418bcb"]},{"cluster_id":"59bf3043-2eaa-48fb-880e-613249cbd976","members":["64799110-c77d-4ac6-bc97-7ff62fcb8a2e"]},{"cluster_id":"fc40e900-5f3a-4200-9723-06366e139ab4","members":["ee46032c-f0cf-444a-8f80-e9b13cd0b005","dd3a5f5e-8f8b-413c-aeea-d834efd4e544"]},{"cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","members":["4abcfa12-6bfd-466d-9150-338b7342cab6"]},{"cluster_id":"6d176455-78b5-4454-a405-3f0ba5b91ecb","members":["a8b31f8e-55eb-45c4-a764-ef67085d3366","75eb9293-d877-4a9b-a68b-1978f9ce494e"]},{"cluster_id":"bdc7e61b-1cd4-494f-b965-4387369e6df2","members":["6350ae1b-8cdf-4b7a-ad10-d916d972a0e0","4ccc6622-0ab3-4807-aa62-fd81cd5dca86"]},{"cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","members":["9c858f34-ee42-4bee-b81d-6c19a43afc6e"]},{"cluster_id":"642bd570-9063-4bca-8050-702e322b8b3c","members":["ab26e6de-bc72-4458-8ed2-edb712e0b10a"]},{"cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","members":["a449796e-a3e6-4769-822c-2773b7ee988d"]},{"cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","members":["fe7df57d-79a9-4ff6-ba79-3050ae549de5","bdb21458-dbfe-4275-9fa8-0f9835290487"]},{"cluster_id":"166b6595-ba80-4fe0-a5a2-70307703e855","members":["f32c1f88-24e1-4df1-aeea-6df0e3c11ec2","23ca88b5-5732-4b74-9c33-93b2fdb7eb32"]},{"cluster_id":"a4d61819-30e3-46aa-ab08-cf879db00de1","members":["b6f037d9-ebd9-44bc-8593-86fab94832b0"]},{"cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","members":["1187ca34-8c0c-4b1c-976a-16d330b9a1d9","4ba11038-ee3b-48f3-94e9-85863cc1e604"]},{"cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","members":["8a0223ce-5203-47c1-8826-8e74e2722658","32595345-7f9a-4856-a227-973a668f7e96"]},{"cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","members":["e54a4559-e9d6-48c9-a017-cff1ab133b9b","be368ea7-a509-48f9-a3c9-9d281436a081"]},{"cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","members":["9956f2af-2c95-42b2-9bf0-14fe682b5743","2e0827b1-fbe8-467c-989c-3d8579ac9421"]},{"cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","members":["2b26ea24-872e-4ec5-a427-a6aa12dea564"]},{"cluster_id":"544ac6da-d621-4fd5-bbf8-4a2cd6254e41","members":["e5e08180-87db-45fa-a95e-e49563fe5349"]},{"cluster_id":"aa95c9e4-8d02-4bc6-90e1-de547f4e4e60","members":["e9d28110-aba5-4fa5-908e-6d72615508da"]},{"cluster_id":"02e7a900-bce3-4812-8137-1246791846bb","members":["7508530b-783f-411d-9df2-1d438adce45f"]},{"cluster_id":"5764cc12-79c5-4e4e-b170-52997cac0e07","members":["d4cb7368-b061-4286-ae98-8c099d459934"]},{"cluster_id":"2f4149f0-f4a5-4695-86fa-9ea760cb8651","members":["cc7c7297-bace-4c80-b48a-892456512083"]},{"cluster_id":"2408ad82-3b39-4925-be26-13cd9f14bf98","members":["dd868710-2903-4168-a32e-3c94389e6277"]},{"cluster_id":"9dbb0955-d2fa-4dce-a46f-5ed43c9e3231","members":["636cd023-52ad-4868-984b-0839d1caa1f4","172053f7-c475-4ba5-9e5b-d74241bbe64a"]},{"cluster_id":"c8416335-0a4e-4b5d-aa9e-40e533302d3c","members":["5aa24293-2634-4bc7-8184-c66f3b745e03","1975bd25-208c-49f9-81ab-e7ba511bdcd1"]},{"cluster_id":"9ffb85b8-5080-4f27-85ad-554406cf7402","members":["47ac6884-7594-4b3c-b28b-dd503b885e7f","9226bd71-b042-472e-8759-f2e8e2c7c9cc"]},{"cluster_id":"9142e74b-a217-4be0-8685-ab7ea89b683d","members":["47ddaa30-cf7e-4d28-8391-89974b15a3b9","87da1479-4c72-46b2-ad3b-3ef960418972"]},{"cluster_id":"a3a558f9-9b36-49bc-be77-b1d77d8074f6","members":["884fe5f8-e7da-4e30-8eef-0008e873759c"]},{"cluster_id":"9c5c6743-3894-4e82-b69e-bc4e0c19f869","members":["f66fd859-6f7d-4fa0-9a96-67d8ff477e2e"]},{"cluster_id":"8b72504b-7ef9-4a36-b0a5-32d0b76c4553","members":["ce7f026a-0ab7-42e8-9442-e615ffeea978"]},{"cluster_id":"abd83725-20da-4a40-a5cf-bb6715d5460b","members":["fe4f65dc-a3fd-461b-84ef-a9aa528e82c3"]},{"cluster_id":"49ede63e-a1af-4931-8ab4-034fed7764ad","members":["9f2be1e0-7a49-4ae4-a02b-8ac3b8365d35"]},{"cluster_id":"d2c2f402-f56b-4dfa-98d3-daf63239156d","members":["19f7b638-83df-4a3c-81a7-526caaf85d66"]},{"cluster_id":"efb75ced-ba33-4f51-8892-e54a26a45d00","members":["43c50ec4-e439-41f4-9937-123ec169599c"]},{"cluster_id":"5767d0cf-3070-412a-9136-a29c287f15a1","members":["a250abd9-1826-412f-a0ff-1f5b933ec1c3"]},{"cluster_id":"3dc82114-c98e-4342-a6ab-854d95d9efa7","members":["87e829e9-3f41-41b6-865a-127fd69177c7"]},{"cluster_id":"71acf2d0-be7b-4d8e-b3fc-93baaa073aa1","members":["ee4bbdad-e06e-4498-a6f0-64f0edb8dc41"]},{"cluster_id":"5904fe8c-6989-4981-93c1-c6202b0b4d88","members":["b61bf145-6023-438e-8892-d7fe96cbf12b"]},{"cluster_id":"f5798794-c4ea-4a9f-ad2e-0bf496c0ed12","members":["3240aea3-0609-4219-bdd2-c1d543e1bcf8"]},{"cluster_id":"5f2c5e5a-f6ae-4d50-91e8-eee0bd665636","members":["e48da546-7868-425c-9c92-6ca48cd1a487"]},{"cluster_id":"76e8427a-4f65-4a81-bf8d-354e00b7198e","members":["248a53ac-6338-45d2-b294-432225aa0978"]},{"cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","members":["18a6f363-add3-4ef3-894a-3ed23100bf2a","4e38a522-3536-4ad0-8f6c-4b1db9689668"]},{"cluster_id":"72a7c01f-5ad0-4d37-b9bd-84c255cc3d32","members":["6fa2d0d1-6f7a-40e7-8398-fb85e5b82cc4"]},{"cluster_id":"b247d35e-9452-4e26-8399-17fe2d8e1df5","members":["b283c199-6181-456e-9548-cbc9398e3f20"]},{"cluster_id":"59b8d1fe-1725-4325-a7c8-5abd450e3124","members":["c85fb9ec-7fd3-4079-8d58-39fb63cb86a3"]},{"cluster_id":"7561e4ca-9d0c-4966-9181-2c8e8d681852","members":["54928d60-982d-458b-b1df-dd617491df23"]},{"cluster_id":"6b38f355-a80e-4449-8c83-c5ac56d5a2e6","members":["befa7383-e680-4c0f-a73a-0c1202663765"]},{"cluster_id":"1cd94f5b-6850-44c5-b48e-2bcdab6eefd2","members":["caa71a9e-8f7d-4c80-ab0c-514b6f6e7216"]},{"cluster_id":"589240bc-a0dc-4961-944a-a3594262e220","members":["0f4b22b3-d4fc-450a-9924-e15aaf4b9442","9f5848cf-a05d-421e-9dc8-0d8ecdda8e58"]},{"cluster_id":"c80e0125-43dd-49de-bff5-42885acf8ee9","members":["d35ddf8f-509b-4c52-bc51-6432c2886d19"]},{"cluster_id":"3d44d914-cf73-4d8b-b531-5db2be83da48","members":["5e75ac83-0e72-4eb9-b360-4f96d0971121","6413782b-b038-491f-9361-f3b3150efa2d"]},{"cluster_id":"a5514e09-1046-4832-bdea-694c3e6ab12a","members":["81fec1eb-625c-4d60-848e-8ca000fd8178"]},{"cluster_id":"48ac478a-0a47-432d-9d71-30bc821691af","members":["c2775da8-b52b-47fb-9ddd-e0656524b475","73b15efc-b9e7-4a74-a59b-6b200ea91739"]},{"cluster_id":"245874be-060a-4ca6-afe3-3a367b00ddb5","members":["f507b61c-a051-4b9f-8bcc-79a61ce65340"]},{"cluster_id":"7b36cbc9-6f57-4b29-9c6b-010607eb3738","members":["88201c49-6ff1-4a02-8d15-a1f664edea3c","dcf03b2f-69bb-4512-a5f4-483f998abacd"]},{"cluster_id":"2c834413-ef2b-486b-81d5-2e0a687a8ca7","members":["04433bf4-0d2c-484c-877f-9d4f6cb65107","f7fb6eba-fa20-46e4-a4e0-5a755dd9a270"]},{"cluster_id":"d7cbd37c-10fd-4628-bba8-b434c41ec43f","members":["dec9b0ba-c532-47d5-8062-bbd1bbdefe52"]},{"cluster_id":"1e74d1b1-7b73-446d-b88a-11111e499ad8","members":["c7ad5ae6-dbaf-494c-95a5-b46572ceca18"]},{"cluster_id":"a6506a53-789c-4447-b726-b2dd59d9b862","members":["3369d430-f133-4800-9272-9d969929d67b"]},{"cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","members":["b018fbe7-8544-4332-ba21-4950fee2f922","cac625ec-a0cd-4362-931f-e60127b9e0ed"]},{"cluster_id":"f3072807-ef6c-4e5e-9a52-03328278d096","members":["14c32bd5-bf4c-4bf5-b6f5-b4ddde7d9f78"]},{"cluster_id":"7e639892-5cda-4557-94c4-87321bdc3233","members":["3653bbad-8aae-4826-90c3-81bdda889097"]},{"cluster_id":"bbe7fdd5-62f8-403f-97fb-16e838e19a59","members":["193284f7-14c5-4d9c-8e56-212c1cd17dca"]},{"cluster_id":"bdb0efc8-0563-4b0b-a277-072e3cddd7c6","members":["3de76f19-d665-499c-b2d1-33d77a838ea7"]},{"cluster_id":"5d657ce1-e484-4e48-b720-f4927cd733dd","members":["81d51f18-45dd-4f7d-8b21-0ae61754d57a"]},{"cluster_id":"7781df4b-26ca-4879-a33c-cb83ade5ffa4","members":["eb61dc70-90a0-40db-8941-a5be8f6affa5"]},{"cluster_id":"2dc250b5-58d8-4c44-80d2-2c17640ea117","members":["4993cc01-a9e2-43b0-9a24-1d572dcdf1e5"]},{"cluster_id":"9bdb548d-7392-42e2-81f0-dc3db0c2af7a","members":["ba515b0e-2ea1-4f9d-8ac3-eb487cfd4c69"]},{"cluster_id":"0dc504d4-9f05-4936-a43a-c912683c5ac2","members":["0f4a0a6b-c03f-4344-8e82-0fefbe066b38"]},{"cluster_id":"11c93b57-586c-4cef-a254-66245b297aca","members":["aaa7a3f5-0c20-41cd-9c54-34a21db87608"]},{"cluster_id":"df65bddb-06ed-4815-9cbc-5ae170dbdeae","members":["c1469c73-28dd-42f6-86eb-7b0123a5227a"]},{"cluster_id":"25c37968-26df-4a13-8b6c-ef9270b22369","members":["e872ee90-7ce1-43db-9954-5bc1e98c9578"]},{"cluster_id":"5a140171-9551-46fb-8eb7-bce434648b1a","members":["05408880-be0b-4ed1-86ef-1a7deb3941ab"]},{"cluster_id":"dc9039b4-da9a-4fd0-b97d-d822536a716c","members":["233438ff-e7f2-403e-8e79-4a6bb8a95a7f","83761374-b6a9-40c4-8a0b-42763aea2d5e"]},{"cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","members":["2c80d572-cce5-492a-8922-2b19c8b63ed5","910f325a-ceb8-4483-be45-d62d7acc3a6d"]},{"cluster_id":"c68ce84b-91a0-4925-97f3-1ea49e062e4b","members":["c462a189-d702-4e43-900c-b57b899d6a89"]},{"cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","members":["9866bac3-581b-44b6-a4e7-1ccf90d18b98","b627b333-6038-4054-b5e2-0d4bc1e27736","18442cdf-bce1-43b8-99ea-d8e0429ad039","0394f585-476b-45c6-9515-ea451b79ccc9","0c55e31a-c6b6-4d90-8886-b06d2e9921d6","368de859-722c-4662-9e5d-083bd074caf0"]},{"cluster_id":"11e43ecc-22c8-4f1c-b13a-fb97013ce963","members":["ceb64b6b-cce2-4980-bae6-4c893cfb2657"]},{"cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","members":["e3977b85-1616-4434-91bd-a8e84a7e71b9","57ceec33-a712-42be-83b1-0bbe6b69f3a2","ddc2535e-ae0f-434b-9768-1fa0764dbb0b","74724b14-e8b2-4ed4-bbdd-94566006218f"]},{"cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","members":["d98b2bbe-53e8-4b9d-99fe-b714fa78c6a1","c3af0855-cf17-4b0d-bcda-fad670ded500","d552adef-ca70-4aee-9e7c-8fc83a25e7b4"]},{"cluster_id":"5fb2043e-87e6-4ef1-829c-b51f962dada4","members":["bb7e0a93-6331-4144-a49f-07b27be8f1bb"]},{"cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","members":["f1f60f4d-ae9a-4af1-bdc6-5c28c675e4e7","20a51398-2fc5-4cc1-a831-7e135590681f"]},{"cluster_id":"41369b57-1c08-440a-90c0-cacb7036a45e","members":["45677884-cbf5-46a5-936a-122af027af00"]},{"cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","members":["0a9e01ca-6f1b-4017-a2c9-7527acdec277"]},{"cluster_id":"9be5c43d-4ef1-465d-bdbc-ed35d95c0689","members":["4b4a0932-dd70-4145-9d99-b56763fa9e6d"]},{"cluster_id":"20030c5c-45db-460b-8663-d9950dc53ebf","members":["34b5c643-06c2-4d4e-849b-fb77fb222019"]},{"cluster_id":"f80dd275-a1a9-4cb7-becc-0fe298aae99d","members":["42a495a0-a980-41f2-bb9e-8a49e07109ea"]},{"cluster_id":"8038fcc7-29f8-406c-90cf-ee3b351c6e15","members":["54df3866-f27c-4239-854a-62593827f591"]},{"cluster_id":"1ff9104e-969b-469f-b204-88f04894d01f","members":["a2c70ee5-60cb-4bd3-bd27-1bfac59c5f91"]},{"cluster_id":"86bae394-d674-498b-bd18-aa3046f40d19","members":["c8e7ced0-a72f-40a8-9ffa-8d8e90f67878"]},{"cluster_id":"5aec5e12-6df7-45c2-ae07-2921310e080b","members":["ffd2327f-eff8-4537-9fa3-7c52a960359e"]},{"cluster_id":"b5b35a39-f79a-45e8-82ea-b87d21bbba55","members":["de542820-8e61-478a-b085-807e52df765e","5602148c-549e-4749-84e9-dad0aa357385"]},{"cluster_id":"c6e50b1a-e795-43fc-baca-c835ba2bf14d","members":["2ddf7483-37b6-4da9-8291-aa683603eba5"]},{"cluster_id":"a604c242-b8d1-4d4c-9595-5b1b3d840615","members":["af9ecaff-9f51-46a1-964b-f7f8865e5396"]},{"cluster_id":"04938aaa-1985-4664-bfb5-337fffd62a6d","members":["78087ce5-01cd-4ea3-9764-26eb8b921ac4","5ab140aa-857e-442d-bd98-0f4a3815b9bf"]},{"cluster_id":"d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9","members":["6fcfcac3-6577-4f54-92dd-bb0e59016086"]},{"cluster_id":"bdecd7b0-3449-4d8c-9710-468d872a6514","members":["f3f5217f-6ca7-4200-bdcd-07ad60e389de"]},{"cluster_id":"e0b3b058-f41a-4ebc-b9bd-9e20a141c340","members":["77d2c66e-db4e-46a3-9b25-701be6bf0a1a"]},{"cluster_id":"8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4","members":["e735ae93-8403-47f7-ad21-b5fede472cc1"]},{"cluster_id":"94ea82f9-8fc1-4541-8fab-b8354c3ea8f2","members":["40acff92-a9e7-4df1-8fbb-1317803213f9"]},{"cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","members":["289ce0e0-96f5-46dd-b968-e6e5fd75650f"]},{"cluster_id":"5ee6d6d6-e296-4f40-9760-4a7737f5c631","members":["9d9af1dc-5857-4a45-8ad2-0b4979470695"]},{"cluster_id":"5e128621-af42-4a93-b091-b4e768efec3b","members":["88c2bd39-5a95-4132-9c00-18006843878f"]},{"cluster_id":"6dfdb047-f69b-420b-87ec-fbcb72244cc6","members":["c92063e1-297a-4953-abf7-9af0a32311d4"]},{"cluster_id":"93459608-ccd3-4b8a-af7b-ede8b22e8c94","members":["7562f876-6caa-4f14-adc5-02abd33e5e84"]},{"cluster_id":"53536317-4b6e-4e5f-bcd2-6b2bb3ef9bcb","members":["4dcf71f4-ff2b-47b2-9b83-ba2022cf36fe"]},{"cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","members":["0a5b80f4-cd56-4ef9-a369-8d29c328313a","067bb5eb-6d31-4dfa-8cbd-19615eed89ba","ed2e0bed-abfb-497c-9ffb-c5fd005a4278"]},{"cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","members":["f06ee571-4c93-42ba-8e35-dcb8339992b5","b3320e18-5e27-4a98-bfb3-9b8a18694f71"]},{"cluster_id":"cfa086e7-654e-40fa-9e14-980617b91e89","members":["5ffa6906-1c8b-4f02-b90a-9e7356ae8163"]},{"cluster_id":"891e1da4-bfc6-4524-a5da-153bde60b165","members":["b150f9d3-20fc-4b13-9330-c4f66fc45e9b"]},{"cluster_id":"22ca72b9-d5a1-4be2-9dc0-99fc0a38f586","members":["9f33a3cc-c5b6-4b80-abad-3adf992755cd"]},{"cluster_id":"da4ff089-352e-46ec-bdf8-8e7b8cd2001b","members":["889531fc-03cf-4189-a945-48d098826533"]},{"cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","members":["b67e8f06-39fe-49ef-a8cf-d1df4128b1d9"]},{"cluster_id":"d6145953-8619-428f-9b84-07cd47d4180d","members":["e3b5f6d2-bcc8-42bb-abf6-885b09b78db6"]},{"cluster_id":"f6aedae8-b368-419e-9158-abbe718748ba","members":["eddc3e01-3718-471f-9ea7-07626e7057d3"]},{"cluster_id":"f20df5bd-42ea-43d0-88bb-1d05f549a0e4","members":["96a77054-65e6-45ff-816a-ab1b898675c7"]},{"cluster_id":"452589b4-0af9-45d5-aee2-979a0dc78876","members":["fe000069-812c-4507-9580-f8eecbca392b"]},{"cluster_id":"90ef35f7-8880-490a-bacc-f600f6a11162","members":["01be4f38-f05b-4974-bcab-e5868299420e","f38bbeb4-28fa-4f3f-9d83-3c9ccda84be2"]},{"cluster_id":"6c51a8d1-6797-4e1d-8707-408a46a11bf5","members":["ed833d09-6dc2-41d6-a4f9-da435295c537"]},{"cluster_id":"807e0902-55ee-4c2b-a271-40fd2fb58b9a","members":["b1accada-093d-43c5-b7d3-eb04ececbafc"]},{"cluster_id":"5c7c452c-db3f-4741-97ef-77d49e8c75b4","members":["02271f73-601f-4078-938c-805a4a8122f7"]},{"cluster_id":"2ebece0c-e502-49a9-94b9-5df90f1b8e51","members":["5c7d6b44-a281-491f-8148-2f39874c5f2a"]},{"cluster_id":"221f2ccb-c412-4e42-8d5c-82e681a61d32","members":["87659b3d-071c-4a7a-879b-c621f1f0beb7"]},{"cluster_id":"4f63d722-2816-4701-89a0-6f6efadc8656","members":["1b25182f-7fc3-479c-936a-a502e7c94512"]},{"cluster_id":"14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc","members":["d60fd050-3d43-4907-9ee7-1da0bace65fc","2e65a4c7-e471-453a-a9b4-5828f81768fc"]},{"cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","members":["69a71a83-cb79-4f88-bb44-d17e73bf92b5"]},{"cluster_id":"1b5c8541-b848-4f05-865e-43826009d4e7","members":["392e62a5-a7ec-4cff-9b0d-efb168c40742"]},{"cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","members":["2c6f1134-01fa-47b0-a16a-d57885b322f3","4b4a656e-4325-448c-8c08-e151c7fbb241","2a9844d1-065a-40c8-8cb6-dbf1cf798ff3","fa8fb0cb-387d-45bf-86da-e5a93f6424e0"]},{"cluster_id":"d017f7be-45ae-4ae5-b72e-a6e53f0a589b","members":["8de2fe6b-bd0b-41b8-80c5-eac870b0af94"]},{"cluster_id":"595531c2-a2b0-4686-b3ae-4f5525fff05a","members":["798f64cb-f98e-4285-8fc3-cbd95f21d6dc"]},{"cluster_id":"5f9b6057-0fab-4c3c-b1af-a7c26bc6c692","members":["ec7648c0-1878-4b80-b6e5-468857c5bba1"]},{"cluster_id":"3ea6c360-e1ff-4b61-9454-07814cabc76c","members":["82943bb5-0b2c-42cb-8f02-07bfc2b2a864"]},{"cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","members":["4ff72245-dfa8-4c0a-90fe-ddbab51a81d8","2104bd63-b9b4-4456-a8b8-646d0cb147b4","bb0ac974-dba1-485f-85a8-d2f0f99db330","106355c0-5f33-4152-9329-80d8cd93fd91","75e6a60a-f387-4967-b042-d1c6fd158f36","155b3063-7f23-4da8-a16a-a89ff2ce42c7"]},{"cluster_id":"ab5ca9cd-1ca3-48b3-9ae1-79a096d75528","members":["28a54058-7a57-4a0e-85d0-fc580597c4f4"]},{"cluster_id":"33a57504-12fb-4d65-b0de-90b983174e92","members":["6753501d-2f93-403c-9300-5cc88e1ecc45"]},{"cluster_id":"554fbe05-7cef-438d-8e82-567521788239","members":["c0530f11-be82-462f-b78b-57dcf8002039"]},{"cluster_id":"ded98049-aef1-4b4f-a8a6-f68c10032b7f","members":["2dbdd359-30c0-4687-ab3d-23d20ba5cbf3"]},{"cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","members":["c5e5d18b-d348-4e0c-8c43-be2146e4789a","6ba3f0b0-cccc-4453-9c4e-7dc9f180b7cb","53a637cf-5570-40f1-b152-4d36671c4e62"]},{"cluster_id":"e9d22d46-e0d1-45b7-b109-afc6516146e1","members":["ab25bbae-f9d9-4b71-bf3f-ce806d3eba25"]},{"cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","members":["7b1d64ea-3527-4de0-afd8-f30cb3a3f6b2","ad7a9f0d-ae4f-40bf-bf11-ecd7d8e1a2cf"]},{"cluster_id":"235bfc4a-e3f2-4850-83c2-a78043ab464b","members":["5746bac5-cac0-4591-bd14-cfe7908c85e4","4e631d9f-285f-4597-9acc-f7fcd2a9c064"]},{"cluster_id":"cf399998-137e-4270-8827-7c726197fb9d","members":["f6852e30-eb47-4b31-9574-a6facc863694"]},{"cluster_id":"281fca06-ede2-40bc-9960-0788b1d20c23","members":["25488b47-121d-4640-889a-0eccad4f7acb"]},{"cluster_id":"e9280ed1-20ec-4c75-8468-086e8c6749dc","members":["d05dc0bd-af7e-4d32-b6fa-034e06e5dae9"]},{"cluster_id":"8d550fbc-5131-4294-a815-b9e32f81ad7a","members":["e71c2431-fd9d-430b-bbd2-c346441cb17d","736c792b-c93d-4f63-a5ad-4cc89227466a"]},{"cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","members":["1eed8ff7-d96d-4ada-8d10-b3124028ee33","2a60862f-4676-4117-a700-51ec4db2da9b"]},{"cluster_id":"64f152e4-be60-464e-a365-613ea259a5ff","members":["0d5d8f08-3d5a-40ce-af4f-0eeaad84a52d","bd9fc77a-0eef-4c3a-ab91-047c2568670b"]},{"cluster_id":"e3489bfa-95e8-439b-81da-6d84615a5721","members":["8292cee2-686c-42df-af55-b1d8e0ec513c"]},{"cluster_id":"1c5f9ea9-d432-4800-9abd-5af5c927568b","members":["e33db651-3b18-40cc-abe4-da9191e830ca"]},{"cluster_id":"bd4c7f11-9866-4656-98e3-7341cfc6de34","members":["d2e525d7-93c0-42eb-8360-af54760ae196"]},{"cluster_id":"4b18f200-0ad0-4f45-9303-c7be1cc1c733","members":["0621bcc8-1579-4145-9367-cf14065d6b3a"]},{"cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","members":["6ff0ed8a-2510-4702-9d75-236dac0a0ea5","56abb7cb-a819-437e-a5cf-51e900a41396"]},{"cluster_id":"0f8d7640-e263-43ac-9294-0e526087824c","members":["c4be645d-460e-4708-b037-487f1c5d2f7e"]},{"cluster_id":"9314aa75-84de-490c-95e7-6484ecdba212","members":["9b2a3bc3-989c-4621-b60e-7f9263e54455"]},{"cluster_id":"ce4379b5-864c-4150-b826-c6825e39d887","members":["63f2ea7d-e8c7-4351-a711-efc2f02fc18b"]},{"cluster_id":"2fe163fe-8ed3-4202-aad1-5f84672917c4","members":["f9a8a051-545e-4ab8-a8c8-6daa315e10c7"]},{"cluster_id":"7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0","members":["2622c55c-6dc6-492e-9c76-fed941e88b72"]},{"cluster_id":"7b1c03fe-e3e1-476b-ab84-c44a6ea52022","members":["76d2576b-bd1c-4b74-96f5-01ee074a5934"]},{"cluster_id":"2432e361-2cb6-4e28-a81d-a8ee7dce9c29","members":["64032371-a7ba-48ad-b8b1-18a5ba134b49"]},{"cluster_id":"6910074e-7bb8-4a4e-9f37-3e335d1a57a0","members":["0219cbf1-b872-4528-bd85-cbbe416b80f7"]},{"cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","members":["fca6ac9e-d361-4854-b415-2de0951bc754"]},{"cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","members":["ae4c6e50-616b-4f8a-bdd5-f4555ae934a6","2b73d0ee-3da7-4a76-b910-a9d437a5f51f"]},{"cluster_id":"992ef0ee-f6fc-4177-b75b-0a3511a615a6","members":["8c0e7cbf-ffa9-4239-bf4a-d8d6df9ac40c"]},{"cluster_id":"1c703565-77f6-4eda-962e-77ec869d886d","members":["5e7bd35a-baeb-44b2-a16d-b60c1df9e9fd"]},{"cluster_id":"ff3f6026-485f-4fce-9d57-b8206b8e11c5","members":["8ae364b3-ce33-47e9-918f-7ffdf3ee8baa"]},{"cluster_id":"20eecf26-3fb0-4e96-b07f-0dfffef9c628","members":["3ba5f1fe-f2b8-4a3f-a50f-c448784241d3","f29187c8-eb55-4d89-9dfa-d5458589188d"]},{"cluster_id":"f42001e5-7364-43c2-8d35-74c3552a9ccb","members":["df300336-658b-4086-ae14-485fb5a34ddf"]},{"cluster_id":"aaf76232-aab7-40b7-8e1a-16d6b39c4f6b","members":["eaad94ff-bd80-4fd8-80eb-73bc91733ef4"]},{"cluster_id":"9a6fa43d-c803-4c20-bac3-545db67a8241","members":["4609b2a2-a2ae-43cc-9923-727688da9367","03bbf6a8-e994-47e1-93e4-0c1992c89568"]},{"cluster_id":"e7287d47-759e-41f0-9641-093ab1e3e04c","members":["0ab31eb2-c453-462e-864c-67db91d89971"]},{"cluster_id":"3da4f222-08f1-4864-8aa3-3576d8a64207","members":["79e0bdee-4367-4ccb-925b-4a68d5d48496"]},{"cluster_id":"b1abd415-ce48-46da-b8bf-36f727bba7c7","members":["4af09982-8d8a-48e3-a946-5daba0922eb8"]},{"cluster_id":"469c5194-5b04-4e90-b62c-73b3f79a0955","members":["7d8d1aea-8234-448c-a5d8-52bb4687e454"]},{"cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","members":["892e9d38-0e8a-4b15-85a9-1e6e5b23d048","276d53d4-40d6-4396-bead-e57b8683665a"]},{"cluster_id":"f8d50aad-e630-4fcd-a643-313737fc528f","members":["6edb00cd-67c9-453f-9f97-60afdcd6a42c"]},{"cluster_id":"f5a86628-9ae6-4d94-ad96-d00a9cad52bb","members":["7e807de9-50c0-439a-a289-0edd457e87e9"]},{"cluster_id":"06a88819-5b14-47a3-9604-8a61db70f52b","members":["b59fb6dc-a5bc-4346-969d-2cf675782c1c"]},{"cluster_id":"df0cd74b-d230-4260-9a29-b0bc91923404","members":["6ca8951e-e9b5-4321-8da4-b726da450889"]},{"cluster_id":"325111bb-e15c-4f08-a4a4-3f81e99d9f35","members":["9fb6cd45-2db9-43c8-9bc3-0779b7469d45"]},{"cluster_id":"06f63413-3561-4a53-933b-589b1f942c37","members":["b8f71142-3e18-4304-8070-e5d6d08b296a"]},{"cluster_id":"64b43278-d723-4b63-bcf0-181e1a1658f9","members":["47e640c2-82eb-4653-92e5-07ae59509b76"]},{"cluster_id":"29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489","members":["3f97382e-d99f-450a-9369-8adbeb773ecc"]},{"cluster_id":"837dbefb-7b54-4aa1-aad3-56f0ea97f9ed","members":["52c8222b-3d76-46e5-b60a-b85f3c7baf1d","183d0198-9ef2-4007-8324-b1d156ee1306"]},{"cluster_id":"47fbc359-0497-4aac-8a4b-e63bd060a1e2","members":["1df7f2a1-fccc-4c21-b7e4-88712ef38283"]},{"cluster_id":"ccc50930-0ce2-4cb5-aa76-281b7202368b","members":["6c5f9c30-c193-49c0-b20a-6f45e386c7ed"]},{"cluster_id":"a837b2bf-502e-4024-b245-761701b0a6d5","members":["9e080cc5-5797-4083-b742-3b096c9ce450"]},{"cluster_id":"1c1848e6-9c28-4252-9e24-4dc5cb477be6","members":["534931bc-6d69-4c7a-ad1d-821a8cd2f627"]},{"cluster_id":"7c2161be-91e7-4c74-9f49-fb997b3c5857","members":["fa70beaa-6f87-4adc-9813-f283ce73b91e"]},{"cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","members":["94b33dd3-107b-47a2-b91c-ae0845ae8039","f525332a-aad7-4bd1-ba01-a81435bda985","5555a3e9-f056-4401-98d7-334e7c38bed0"]},{"cluster_id":"468c9eea-e420-4271-9b73-0e2e747f6185","members":["5000ccbe-1bb2-47e0-ba91-d263e7a46419"]},{"cluster_id":"f636e358-668e-41dd-bffc-037f53b4ab48","members":["baa77af1-ba9b-4659-b322-e5de504c6178","ea0ea37c-cb3a-4795-b344-da65b07ff1dd"]},{"cluster_id":"6d2a1320-d829-403b-913c-d7cdbf1cbf14","members":["7c6ad0f4-14ce-4d78-94d8-83ef080fb481"]},{"cluster_id":"9028c8ac-b264-4318-be25-6d627ad54b1d","members":["138995f7-0879-442a-b0d2-b865adc91c1d"]},{"cluster_id":"3200fc3a-bd08-4faf-ac3c-69eb812ef575","members":["40a982f6-97dc-40a4-87ee-10c3678e2aff"]},{"cluster_id":"58b4a566-79d9-4559-809f-ffd9a84468b4","members":["d827bf21-86e5-4fb1-ad29-39bfc2d54d43"]},{"cluster_id":"a8aabd5b-4955-40cb-b78a-086cb1601de5","members":["c58c1e7a-b29c-4ec9-b3ef-3537279058d8"]},{"cluster_id":"daf13a88-450f-40a7-bca6-ccfb46ede159","members":["c4719ddf-1f52-4f07-bb29-0d833c19f06b"]},{"cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","members":["7b51a335-2503-469a-88f3-cda13616b9e8"]},{"cluster_id":"3de3b456-a38d-41d1-85eb-8ea198492839","members":["e000b420-269b-448c-a2f7-943c5b34854a"]},{"cluster_id":"9b2175d9-8d49-4d83-857c-16d8550ab216","members":["4a53148d-ff1c-426e-8962-939234581f1f"]},{"cluster_id":"2ee00586-87af-465c-8466-d1bc41c3886f","members":["ee505ac3-6796-4bb2-a0ed-5d00cdc42d4f"]},{"cluster_id":"fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec","members":["11105bb6-ed0f-4fcd-a9eb-507388a5e2c6"]},{"cluster_id":"1d1fb1a1-0351-478a-ac00-eb42c21a03d9","members":["4a03d036-31bd-4d0d-bdc1-010d2be0e2a4"]},{"cluster_id":"8cb0435b-3218-46a5-88b4-47481d4dee85","members":["dea84b7d-89ec-48fe-bb58-8ba341aee989","6b296eea-2fd8-472f-9fea-997008bc21b3"]},{"cluster_id":"f7c875b0-a0b4-45f6-b382-0915f179b2e6","members":["a0cf568d-cab6-4149-85ef-a7ace346f042"]},{"cluster_id":"89d1d1b7-a65c-42c4-be89-c592ae13b6a1","members":["5197f13c-5955-4609-a641-0d2e9825af37"]},{"cluster_id":"ab829976-d7fb-4b30-9b92-89eed4e94cc4","members":["4fb0c3bc-6136-4ead-aa3c-701399394a77"]},{"cluster_id":"043b0606-561e-4868-8354-4c45ee5a2f95","members":["efaff54b-9926-441a-8582-c63bcf40ee5c"]},{"cluster_id":"4df0c9e7-49c0-478b-aeb5-0b3833932e62","members":["33b4407e-d332-42ad-91c7-64004f5a7b83"]},{"cluster_id":"7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9","members":["2c901d23-150e-4236-8a3a-50459096c99f"]},{"cluster_id":"a0d6a00c-f05d-49fd-9f81-54bc418a2aec","members":["d9be58a0-d2d3-466d-8ef6-4dda4cadc6fa"]},{"cluster_id":"d9041723-b3d2-4f6c-85e6-435010ef6231","members":["4b6aefc8-c4b5-4a7d-8b0f-634abda80c7b"]},{"cluster_id":"a5114ace-99b6-4b39-875b-8b7056c70002","members":["d32bd84c-757a-4910-a052-31805fd4d204"]},{"cluster_id":"0e225927-1e3a-42e7-9ee8-7f9c2bae0dc2","members":["0928ff9e-d79a-4243-bd9a-1c711d3e7e2c"]},{"cluster_id":"c98491ce-51cb-40b0-93ae-d389e1c9d7a5","members":["09595d71-6353-4b5c-9c69-95f7da285a30"]},{"cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","members":["2da32b38-298f-4187-9aef-c0fdd8659496"]},{"cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","members":["d5b18d91-f404-42c4-9bbb-59aaf2defba4","a5966d2a-f407-47e3-8a42-4a1282f0e485"]},{"cluster_id":"4f331c05-6fa5-4bd8-adc2-5458e8c80843","members":["451ce3f4-9e07-474d-a871-c38155df8b9c"]},{"cluster_id":"3e505b9a-116f-472b-bc43-8ee1a23943f5","members":["5f1e3bac-6dca-43e4-8fd4-6f7088dde238"]},{"cluster_id":"bac292de-05f4-4fd3-a4df-f073c8f09553","members":["872fb8c6-d9b3-4096-a4f8-dcf966b50b66","66ced45a-b323-4e56-a143-2292b8db962f"]},{"cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","members":["fff5600f-7263-4f2a-a699-8321f3952aa5","41762dec-9af9-454b-a084-74fdb6d5933e"]},{"cluster_id":"cd8495d7-023b-4c43-b6e6-6e4c88a0cd79","members":["8b19bb1f-9fef-43b2-bd11-62c825845e92"]},{"cluster_id":"e2d7dae8-0d86-4de0-93de-0fca88fdbecd","members":["da752397-c4ec-4920-9b38-287c09c8e89b"]},{"cluster_id":"d0814fdc-170f-48fa-8def-5a656118ed2d","members":["d80dd363-e12d-4d2f-8f1a-db6890357214"]},{"cluster_id":"68617739-11a1-4108-8d8c-6d8db53fd247","members":["2e492606-e466-48b4-aedc-a8ac48cd73cf"]},{"cluster_id":"489e26fc-76fe-4cad-b09b-b941f099b2bd","members":["09bec78d-5110-4d94-8abd-ca8fbc8d8f34"]},{"cluster_id":"bd6de2da-8b5f-4e38-83bd-28294e175aca","members":["9cfe1e4d-1693-459e-9c1c-c014e781555f"]},{"cluster_id":"c02665b8-8535-44f4-96b2-764b54985f66","members":["33b7ef54-4581-4500-860a-a13826f64a39"]},{"cluster_id":"5a6d9d35-00b4-429a-8850-2262dfa520df","members":["b3eff245-6e8e-462c-8370-fca16fc417ee"]},{"cluster_id":"427b0ddc-d215-4989-8bcc-336ea7f1f9cd","members":["0f32623c-391f-42b0-9618-700e47645440"]},{"cluster_id":"f236d68f-fe39-4432-9a36-341eb8900ee6","members":["787f85bb-e1f6-4800-9a1a-2a143f27635b"]},{"cluster_id":"b8c8cd38-7dea-46d6-b8a1-7316916dd462","members":["4db4f4b2-6be4-43ee-b0e9-6950caea365c"]},{"cluster_id":"469a2781-0070-451c-bc21-b7ee2b0da3f0","members":["1c59d865-0600-4652-bd1b-24003bbf9063"]},{"cluster_id":"8468be9d-aa33-430a-a3f3-b08169c7651a","members":["a8898146-49d8-4213-a28e-7646819d8e37"]},{"cluster_id":"650bbf0e-b896-4929-a2ae-2f9899d4868f","members":["7e9ce10c-485a-40aa-9db8-80a972b9f762"]},{"cluster_id":"6606b076-6fdd-4a94-a7c5-b6bfc5191980","members":["0ac9f2c5-f7be-4379-9ba5-d77b1f76eda0"]},{"cluster_id":"bba799e9-6e80-4ce6-b96c-fc89b2b8200c","members":["6e278d9d-efbf-4498-83fa-1fe9f5c2e1ef"]},{"cluster_id":"43fb6e85-e148-46ac-99f5-6e9cc985487b","members":["fb06f2e9-4a84-4eec-9327-1e0ec4232f45"]},{"cluster_id":"04ba7876-53cc-44c3-8149-fe7ba435f124","members":["cc86da79-f5da-4544-b667-9acac7afd2d7"]},{"cluster_id":"77de864b-c2fe-4a23-a506-d0665b0f08bf","members":["6df9da21-3633-4a31-899a-c18d5a69ac05"]},{"cluster_id":"d14315a8-aa93-4c64-a42e-a4307dd0814a","members":["9372ddb4-9364-4499-a45d-a91c3a32204a"]},{"cluster_id":"4f2be876-d890-4fd4-a767-3f52bbc9c4c4","members":["6cfd4a3d-ea37-4a6a-b31d-f33126fb7074"]},{"cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","members":["a57a7b65-84fb-4307-87f7-edd4e6d83093","be5ca216-b212-4b53-8373-356a889d9f75","1dcbd6fb-23d1-4f37-8d0b-c3715e918db3"]},{"cluster_id":"d5e58122-8595-4ce1-b4a3-aa9160204856","members":["0ea2c3ce-0390-4a37-82e7-05c488f9d60e"]},{"cluster_id":"86ef5628-f267-4ce6-97b4-2f06bd91a5fa","members":["3ac17d3b-d75f-40de-9ab2-25772920000d"]},{"cluster_id":"147befcf-c605-4967-82de-77dc8f9513dd","members":["84a41b1d-8742-4138-a07a-b4c11ec752ea"]},{"cluster_id":"9367c0e9-bbdd-4398-9de3-210a1f73c88e","members":["7afe7a05-2d10-4c12-9bcb-b81942115741","53402c0f-23bc-425f-b153-ce081085ebb8"]},{"cluster_id":"516e99dd-d52c-4f12-8e2e-b0ba0e0b515d","members":["a81e0dc4-7ff4-413f-b7e8-35e9f1f338bf"]},{"cluster_id":"6c812e58-19af-4264-b856-e922307ab466","members":["9ef16cc8-7e0d-46af-be53-ad39ca0f324d"]},{"cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","members":["16eaef10-f0e6-4c6a-aa10-29e89fbc15cd"]},{"cluster_id":"e2a085c3-49f3-4799-87cc-2b59f85d4bb4","members":["a039a1cc-be4d-41c4-9557-fd273854d9a9"]},{"cluster_id":"a7d1cc33-aa3a-4ee3-86f6-065986a716af","members":["1c8b8a47-732c-43bb-bdd5-1258d42e81d3"]},{"cluster_id":"226f9322-c9c6-4f2f-948c-b45757d94aa7","members":["3b1e8ff2-88e8-4208-84df-1b20791750f8"]},{"cluster_id":"8f273fa4-f8bd-4413-8ce1-7183b77e2566","members":["7d507146-82d8-4c8a-bc28-2ea93cb69515","129eda25-7e65-4bd7-85d2-2cbf45fb11cf"]},{"cluster_id":"838e6a9b-36b6-4be2-87e8-cb3d0595dcf6","members":["5ef6a303-44eb-4d39-849c-0f5399eea698"]},{"cluster_id":"546f63e2-ef89-4f69-bd49-cde47599b05e","members":["fa707004-3fa0-4ba3-bd14-64362927704f"]},{"cluster_id":"203655c2-f1ad-4fb6-94c5-5fc8218603d3","members":["a7ddd415-7366-41e4-aa1c-66bee62b8998"]},{"cluster_id":"aa908c8f-4075-45ac-a932-631e5efec76c","members":["fd15a0ec-5782-4364-bac0-06c385094698"]},{"cluster_id":"0f733538-ef56-427f-ad23-04cb6fae87ae","members":["c1ad018a-74d6-4483-a5d2-5098ed285a05","2cb20498-f180-4af4-8f9a-817025296a86","ef3d54fb-135c-4f91-83be-3f3bde8746d4"]},{"cluster_id":"4a8ddb73-8e8c-4981-b0f4-e38510f4f712","members":["5a67a1b2-e1a7-4007-b512-ea59976dc055"]},{"cluster_id":"fd554d0c-cd25-4da2-adf1-dcccfd01f292","members":["cd554ad0-b8e4-4c20-bad6-335ae10b2602"]},{"cluster_id":"ceec9597-cc69-4304-a584-0cec50748ec3","members":["37aa0a4d-96f8-4e27-b36e-4024e3864c72"]},{"cluster_id":"266128fe-9d68-4687-b95c-b0654a1c7f0e","members":["e53cd62b-8645-4b7a-b430-ce6122331fb2"]},{"cluster_id":"0fde95b6-db57-45cd-b6ac-fb0edd1b186b","members":["c02460c1-0520-4c75-84be-9c755ac23b1e","e08a30eb-1c20-400b-8446-ac1b78bea4a6"]},{"cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","members":["85df2a88-2a1b-4add-b62c-7f93fd934a54"]},{"cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","members":["1ebf5a57-2440-403a-8554-c1001c540572","c0f5cf9d-a8e7-4d14-b270-ecf2b1e28b18","706987e6-afc1-4f06-ad55-7a4abe9b2eb2"]},{"cluster_id":"a8c6b9dc-b961-4a1b-bb6d-3aff208b396f","members":["0aead5cb-0afd-408e-84e1-61cb9f170296"]},{"cluster_id":"8308c2eb-92cf-4ca4-876b-d1d947564441","members":["8e5a3ad3-1aa6-409c-ab9b-fc489f9382db"]},{"cluster_id":"a4182192-73bb-4165-ad72-05ff39be899d","members":["8af9fe56-8608-4393-a401-af9d66e91000"]},{"cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","members":["5c111c5d-345a-47cc-aa7e-7a23939e591f","4b16a3e1-3eb3-4c01-9ffc-8e057a849168"]},{"cluster_id":"4180dc5e-36b2-4900-9bf9-c6ecf67fdc08","members":["da844889-0038-48d6-86cb-6d9b61e61930"]},{"cluster_id":"c94810e3-5711-44bc-a55f-5ef59645cf78","members":["e41219e5-2040-4608-8215-0569f837116a","1992dd80-35dd-46a9-bccd-0cf139aecbc2"]},{"cluster_id":"924c4170-d405-438e-937c-13478012b72c","members":["7c2df117-bdf8-40bf-9218-92cd2f77ba5c"]},{"cluster_id":"a8dc28b0-9676-46fe-a3b7-8eb8e563deb8","members":["1a7bc4ac-0bb9-4cd0-8bc4-036789edc05a"]},{"cluster_id":"c1b9998a-8864-4f22-be23-89209993bf02","members":["7557180a-4ac9-4628-96e8-204eb76c9bf0"]},{"cluster_id":"323efa20-d8ad-424c-9c0e-ac5d255b9276","members":["54eb5796-9234-49ee-be60-347e01fcc1ab"]},{"cluster_id":"b8109116-4fcc-41ae-af96-4f441a585df4","members":["1f822cee-61f8-490f-a3e0-c7b75b886176"]},{"cluster_id":"aa973fc5-c596-49d2-86f1-80f2a9f419e9","members":["06f2d0e1-a21b-42c4-aa82-dd44d72b861c","3381dd29-87a6-4bc8-96d1-4fdace7560cc"]},{"cluster_id":"bbc8c147-b447-4af6-82fb-e416f6108e70","members":["38621482-5b2d-44c7-820b-adbf9eeb1d63"]},{"cluster_id":"d59582f7-7e86-41f9-a084-db1da2a740db","members":["8a68573f-ced9-4549-8420-46bdc3e8c365"]},{"cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","members":["ce09d69d-f830-46e0-a0d5-5a50cc945bfd","1fdb61b5-3227-4c6c-b623-ee5994261c71"]},{"cluster_id":"b5aab15d-0623-4834-b9a0-c066e3616369","members":["029e74b1-c638-46b1-82bc-3be5a9105c5a"]},{"cluster_id":"24e1d750-e055-449a-83a7-236e590f0e5b","members":["2cc7310a-7239-4ade-ad8c-0f7f34d5682d"]},{"cluster_id":"f4b62b28-f2fe-4807-a41e-80bf6c8bad68","members":["477b9d42-dc00-4000-a353-401ae75ac446"]},{"cluster_id":"3312bf71-bb24-4752-866e-3b29580d70d1","members":["03e43ffc-e726-413c-8514-d3dc64faac25"]},{"cluster_id":"7659f671-e41e-464a-9184-a08b114b3636","members":["a539a6f3-3066-4ea3-b176-0ea440f6d871"]},{"cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","members":["dfdbdefd-0ea3-4791-9a19-883176ce0520","4117e56c-a08c-40fc-b996-98b43966f125","a2c95989-878c-4089-bb17-8155df3fcccc"]},{"cluster_id":"ff7a6df5-d64b-4e14-803a-5339b1cffda2","members":["a842755b-f32f-4ffc-bb0e-fb7c12eed55e","d9f0695f-a41b-4f1f-b51f-57d0a6859c8b"]},{"cluster_id":"29cb7e64-a98d-4be8-8dd8-aa5a3b83d517","members":["7ea6e1af-a1ab-4574-b2a6-de810666c3bb"]},{"cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","members":["dcc9ad82-adaa-4277-832f-40fe07e07e4e","a237951f-5603-4b3d-98f5-4530944e0799","3220bfc2-e818-4aa6-99e1-0fe729cee492","cc1c0b2e-c509-4ed2-93ee-ff392da24a6f","8929cf51-2c57-4301-871a-351e37841df3"]},{"cluster_id":"f68dc41c-3947-416c-8f93-49c606c24bd2","members":["f0e557a3-c422-4388-81df-60332a604a31"]},{"cluster_id":"58021478-0a50-495e-b059-4560ef7c90f4","members":["98d2a36d-e4c8-4788-be7b-251ef8ed3e69"]},{"cluster_id":"5e767ae7-5475-4d58-9919-b74b88492c8d","members":["f30c2aba-14a3-47f8-8eb3-31bf2697ec10"]},{"cluster_id":"f02faf57-c72f-4377-8759-469d56737085","members":["8c2695a2-b90b-4d90-8cd7-4fd1a95e9915"]},{"cluster_id":"3bc352c0-0d5e-42f4-ad88-e7f025e20e88","members":["7f38bd49-2b61-4485-ad92-826f4622b98a"]},{"cluster_id":"5ebc5950-a889-49b1-a0d8-0d905803d030","members":["6a0b5371-4a1d-4a33-9cf2-6ed229397386"]},{"cluster_id":"e25eede3-3242-446d-a439-2c4becea51cf","members":["d803c8a8-1959-4a78-9323-dac5106fa3c8"]},{"cluster_id":"67d719d1-a600-418b-b08c-286005c2cb08","members":["09be098b-2ee2-4d5e-8bf2-c10d759502be"]},{"cluster_id":"db91531a-0712-431d-a04b-9b798db3d3b4","members":["9f82b403-f37d-47ae-b12d-954966d567d8"]},{"cluster_id":"799387af-65e2-4baa-bed7-0f025e3fbc39","members":["a05b5678-a8bd-4b6c-80a4-7d6b295509ee"]},{"cluster_id":"756853a7-6f00-41a1-87fe-40396a3fd247","members":["b921b051-537d-408a-a1eb-67b0ab77f0f0"]},{"cluster_id":"f4c860ae-1c6c-4478-89c7-fac05f3999c6","members":["ad77754d-a55d-4863-ab2b-c74d01f22f96"]},{"cluster_id":"4259fe50-2c67-4157-ba4a-43d33835df49","members":["5aabbe3b-4ee1-4cf5-a307-e5972d7d441a"]},{"cluster_id":"f4de84ae-8f6f-4a0d-afb7-35839203b010","members":["4849399f-d01a-4947-8d84-70e6370761b4"]},{"cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","members":["4672ae95-fe94-4529-992a-9bd9f2450237"]},{"cluster_id":"43de0036-79a8-44f6-b066-25424acf3535","members":["50dc1fd1-29df-4667-a38c-9cca6c573245"]},{"cluster_id":"5cb260df-5e4a-4685-94d3-087687f5dbed","members":["4bce2060-09d4-4098-b63b-f9dc678c472b"]},{"cluster_id":"f3d66a5d-cd26-4b6d-a341-2fdc2524c28a","members":["e1b163ae-328d-4f1c-8421-612b4cb01a03"]},{"cluster_id":"b320fe25-40ac-4b0e-8605-df06f6384218","members":["f991e96c-ee58-44c3-8da5-9f2e65dff516"]},{"cluster_id":"0cd50f6d-7e09-46ef-815c-37b05bef94d0","members":["c0397fd6-d957-4664-938f-51c149f52869"]},{"cluster_id":"fec0d44e-dff3-4478-9317-1b1d954f03c6","members":["cb5c1d3f-6abb-4d7c-9539-5794000724f8"]},{"cluster_id":"4c95b4a9-d005-4c7c-8a55-a5a0821d7611","members":["20b20009-55af-45e1-ad7a-f77568f0d0ec"]},{"cluster_id":"bcc578f8-a745-46e1-ac64-5315a3ec6900","members":["d8927e01-bf42-48d9-87be-c2a1007db420"]},{"cluster_id":"ba2401d3-a8f2-4ce4-bda0-30f38f532e31","members":["366f952c-f98a-4fa4-91bd-ea7fc8f9828f"]},{"cluster_id":"43e40d68-962f-4fc6-83f4-ab836f751e9e","members":["07e907bf-4736-4110-94d6-ad50986f0520"]},{"cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","members":["abc78ee6-9a74-4c31-b3fa-aaf984c98e07"]},{"cluster_id":"f4e0a38c-1349-4970-a962-5d6d7478cce6","members":["457886fa-6643-4453-924e-55c6694e6c9a"]},{"cluster_id":"de4f148f-cf69-426b-b5bb-f722fb88313c","members":["a322dc3b-9865-4443-be3c-f9fdea386fe7"]},{"cluster_id":"e762d6c7-8067-4852-8232-49501526397d","members":["1771bf97-ae85-40bb-8e02-f07fe11ffe91"]},{"cluster_id":"b66f67b6-3e85-4a7d-9029-7480f97d9f48","members":["6a58e3a8-8d21-459e-b42f-19871735ddae"]},{"cluster_id":"962affe3-ba24-4db1-8a1a-d157fa469f0c","members":["6c5a5880-c721-4166-84f9-b9f10b46d797"]},{"cluster_id":"516d27f7-0cda-468f-b3b6-27af200d408b","members":["a08d6e56-7f7e-47cf-81de-e8122a610abd"]},{"cluster_id":"49a8c8f2-03df-436a-8634-670fd40a145c","members":["37581388-5272-4892-bce8-93f42575e2da"]},{"cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","members":["420426ac-d677-4e71-9409-3c580a810304"]},{"cluster_id":"216f7d8c-4948-4e84-9b61-7c4fc880e123","members":["51c31872-6c22-496d-8db0-350086738cc9"]},{"cluster_id":"8ba29c52-b42b-44a3-86e2-12fd13d42596","members":["9da039ab-cd2c-4ac1-92f9-5bb3b0ac032e"]},{"cluster_id":"8d06f8b9-e6ed-4b99-89ef-90434792b924","members":["0853fabd-817d-4700-8463-b223b3d9a9a3","ad0d9484-a7cf-4622-9a6a-fc59f917b9ff"]},{"cluster_id":"d489ee78-15f6-46b4-8adc-818181d95968","members":["551f6a3f-7ee1-4220-9218-10240e4e6736"]},{"cluster_id":"abfcf3df-912d-43b6-968f-0f586e4e242c","members":["2b1cccb7-07df-443d-b883-4aeab0541083"]},{"cluster_id":"75816fb8-77fb-4eee-a3ec-bbb68393ff86","members":["b64b0df8-d092-4873-b18e-8ee940b1188f"]},{"cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","members":["dd28c9e1-3524-4de6-bbf3-2db2158124db"]},{"cluster_id":"075f7aea-756f-4e67-bf46-f4305230821b","members":["b3fb1932-a775-4fed-9c1c-8d700ed98f3c"]},{"cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","members":["24fda3b8-a767-431b-a557-22af840dd04f"]},{"cluster_id":"b4e4a860-8721-4ac3-8eb3-a9dec18b336d","members":["311bd324-53e2-40c0-a0e9-129aa64d4542"]},{"cluster_id":"1b178ff0-cd2a-415f-bd8a-4daf71e452c3","members":["394b3ed1-93cf-4622-86bd-45daf5632dfc"]},{"cluster_id":"d521ac4e-4810-4638-bb77-9fbf7ba74f52","members":["4f28cf1b-eeb4-4f98-9d72-3d16d8a364ab"]},{"cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","members":["7cce2a59-de6c-45b5-9890-bb26bd782446","214150b4-7ba4-4e26-99e8-8ca6b7d24035","102b1f5f-acda-48b1-9991-3270e7b4d909"]},{"cluster_id":"a0016e91-a98c-4dd9-8feb-b0afadf02f44","members":["84180699-3401-4067-a323-c18de91df8a0"]},{"cluster_id":"e52244b2-1143-48cf-9735-ce26094681d1","members":["ffad9e9c-f463-432b-922c-b04a447efd4c"]},{"cluster_id":"94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff","members":["6bb78db7-bfa8-4e89-a5a4-231579174345"]},{"cluster_id":"1c30353a-a7dc-48dd-bca2-56c91aa06ab6","members":["540ecfcd-d63c-4a16-8fc4-99bed69936b7","b0dbda2c-722c-48c6-8dcf-06d13f0ff79c"]},{"cluster_id":"a2f5a4b1-ccba-4cac-9bde-f079d3027db4","members":["76d3150d-566a-437c-a07b-ba31f7754271"]},{"cluster_id":"38eef897-6e59-4836-bf0e-1e7e106baf53","members":["04565754-2efa-4a04-ad4f-47a3b69df633","f1738e70-73f1-40c1-950a-c03f9ea23c76"]},{"cluster_id":"e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37","members":["45988828-987d-41f9-9910-a69e0b6b266c"]},{"cluster_id":"83605bab-42d6-405a-ab45-fb6b68e0609c","members":["8184bdb0-d238-4442-b9e4-88964c551e5a"]},{"cluster_id":"d7eb8bf6-179c-440e-ad1d-a97e186809d1","members":["f7f4494c-d23f-46bc-95ad-55e481020949"]},{"cluster_id":"c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9","members":["8d0e5935-493d-40dd-86c0-2179f8a97908"]},{"cluster_id":"21b491b2-20db-42c2-af5c-70af377f068d","members":["d870ab1b-50ae-4474-a007-a3b3b7ede249"]},{"cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","members":["665223ae-15a5-40d1-b029-3082c0364604"]},{"cluster_id":"b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10","members":["9faf8cdb-f734-4c8b-a184-83176178c4e1"]},{"cluster_id":"ce2b0119-85f6-4619-9c50-256557181c73","members":["35a9dcf0-4cae-42aa-ad49-b78de8e6a2de"]},{"cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","members":["76f38dc8-7183-4718-8907-c647e8fb8b2e","dccb2688-1856-4a1a-87b7-4ee0424e01e4"]},{"cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","members":["7a922f37-4c04-4b1a-939d-f05336063961","2636aef0-bc84-44ab-a740-8e82aac9565b"]},{"cluster_id":"5dd21bbf-0c74-46d7-a4e4-48789f1b2436","members":["b156d810-c926-4b49-93be-bbd349028310"]},{"cluster_id":"32dde553-bbf3-44a2-afd4-d60807ce0ab7","members":["4c9db928-374c-4dd7-a717-f789724effe9"]},{"cluster_id":"4ab7d21d-36fc-4f12-857a-8e07c61bf688","members":["c9c854e8-b4e4-4054-bf94-68d3c8d21c91"]},{"cluster_id":"692c12d0-dff2-4fe9-a351-80422ee99320","members":["0813d21f-b8a9-46d0-852c-e35d7a6b2107"]},{"cluster_id":"d30cdd9d-92e1-44ac-aad9-845702e1559f","members":["0f1302f3-58b6-4c74-b747-90a0f169b860"]},{"cluster_id":"d89e632e-b2af-4331-9344-c7d1e373d49b","members":["6513150c-e717-4597-8bda-c069fd2ec66d"]},{"cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","members":["78dd7176-866b-40c3-ac5b-ac8a56744bbe","c1e9c5d8-d9bf-4f24-a146-4466e09a1c9c"]},{"cluster_id":"9bab62f9-a196-4e9b-9809-8d8f41f0576f","members":["68058236-e8a0-4c0e-8ea8-4e9fbad8892e"]},{"cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","members":["021a2b2d-f94d-4d7f-a79b-98cc50562a16","f7784c93-abea-470a-9986-7999412af8fb"]},{"cluster_id":"73184e14-aff1-4c97-a2f0-0508b86fc3db","members":["94b7d2a0-309a-4377-b78e-9387cb60a617"]},{"cluster_id":"d8704200-daac-4e95-873c-20cc39771b1c","members":["87fe6fe7-6741-4b4d-a004-7c63f9e8fc69"]},{"cluster_id":"ff763739-26e3-4daa-93bc-7ecf065c5275","members":["7a567ea2-81b6-420f-98b5-f699eaedb85a"]},{"cluster_id":"d86ea948-08a0-4829-9e48-4f9273b2967d","members":["0fe90583-3a97-4b9a-b64f-8acba9619caf"]},{"cluster_id":"6bdcff96-571d-4879-91a7-d6084340625f","members":["1e7778f2-669a-4098-9803-8a2c8c4f2bda"]},{"cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","members":["b55c0787-864a-4d79-bd3d-090b61e5f7d0"]},{"cluster_id":"0b331741-7f54-4613-ad60-e935b60f7fbe","members":["eed31450-13c7-4a12-a6f5-87c6bee4c1d2"]},{"cluster_id":"cb357706-7b58-4396-aa24-1c59beae87fa","members":["96a1e432-163e-4821-8cba-d4b5417f9f48"]},{"cluster_id":"7e1a378e-1366-4ff2-9282-46ddc9975cc6","members":["8c55c063-c680-48b6-8ba6-64ac9886ba32"]},{"cluster_id":"72a6b38a-23a2-43db-a788-32ae774a5c77","members":["6ce85de8-d097-4553-8939-cddc44ac7afc"]},{"cluster_id":"a55a36be-0edb-44d4-8400-10d53525802c","members":["f5307467-deb6-4fd6-92d7-cd40b933d49c"]},{"cluster_id":"69fa7886-741a-440f-8a20-2b9ce60729ac","members":["e31a626b-6477-4fd6-995b-cd4796ae7896"]},{"cluster_id":"aae7438c-bb2b-4e87-86b8-fc77cf6148d1","members":["61ef2b5e-ba4a-4387-b511-d95280b5758f","b380f9a0-cb02-43c3-a4d4-33c16744b821"]},{"cluster_id":"6f4632e9-24cc-42ed-87c9-747133ea5b31","members":["661405a4-20f3-45ba-9dcd-c6aabc7da03b"]},{"cluster_id":"910b6c18-44e1-4b51-b616-1f6016486c69","members":["dd9c34d2-e328-404e-9262-ef8ba5e31c00"]},{"cluster_id":"6075c9de-cd99-4e5f-9302-f1b6177720a7","members":["b0760fb7-31e2-4253-a9e7-088762a7adf4","6fd6f299-2bc5-4cd1-b7db-411b475af0f8"]},{"cluster_id":"883c65b8-c8f1-4a3b-8bd5-fb9d61a95876","members":["a78f8423-7ff6-436b-bb86-b2d81950dba4"]},{"cluster_id":"84b73ec4-88f0-4587-a147-47771c41db07","members":["ce8a9b13-d2ba-43a3-91ba-1e54add14e25"]},{"cluster_id":"b7635b58-ad1e-4cb4-a317-8d48ce1cdddd","members":["37205a70-045d-45fb-a659-745be3a25f44"]},{"cluster_id":"b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc","members":["936a910e-c127-46cf-854c-f9f45c4172c4"]},{"cluster_id":"be023ca2-f865-4811-854e-b40ab442412b","members":["31cbe0ed-02e8-4c9d-98ea-753e0ab3babe"]},{"cluster_id":"f006e419-46e2-4ca6-a34c-afa36d7458b2","members":["a717a742-4cc5-408a-8a35-4286bff0e4e4"]},{"cluster_id":"989e42eb-c62e-4e68-87e6-6b230317d087","members":["ab03c143-5c30-4a99-9014-887c91d422e6"]},{"cluster_id":"29b7e7cf-ad7f-43ae-a8c7-822d865d97f4","members":["870b6aee-39e4-44ab-8369-c44251be45de"]},{"cluster_id":"78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a","members":["f34accd5-1589-4a52-82fd-77643ec0941f"]},{"cluster_id":"8a60fc08-ff21-49d9-8858-dcff37e21d18","members":["a76fd6ba-7552-4af7-9c53-13e1dbf01800"]},{"cluster_id":"6cfce6ce-fb64-4bfa-a23f-01cbee46c275","members":["8eb3868f-1de4-4758-bcd9-776496ea6d87"]},{"cluster_id":"c31ea39d-ce0d-46ee-be4c-e32d46721b78","members":["4b294b6e-1494-4eb8-ab32-b4e0af0ee624"]},{"cluster_id":"772127a5-d049-4874-9828-2ed65010852d","members":["aa3f2dae-31fc-4d1e-85ee-711ed8179455"]},{"cluster_id":"17b4175b-7c9e-4cac-8f06-6d2c5a65e803","members":["c2eb7027-7f02-4640-a1e8-3178709b3d6c"]},{"cluster_id":"42302660-b692-4e66-870b-37970eee6c13","members":["51da2545-3036-4376-9031-a272d71f4745"]},{"cluster_id":"08372c18-8eed-4c93-adee-9002e00e29bd","members":["4b7146ae-eb62-46f7-a74d-dfb114e0c51a"]},{"cluster_id":"38d2a616-9f37-42ea-8e5e-3010dc76a2ba","members":["c433c64e-4d49-46b1-b558-2374391d828b"]},{"cluster_id":"19867279-c3e5-4f1b-afe9-d36652a4bc2b","members":["4babb15c-0432-4c14-a80c-8a89bb99daf4"]},{"cluster_id":"f997f1c7-5ae9-4bf5-bd1f-2f46bb8d4a16","members":["c691c40b-0da2-4fba-8405-1d8ee2563aea"]},{"cluster_id":"b331f46e-c31d-4c56-81c9-c40834960e1f","members":["dfb119ab-0905-4f66-9996-9575684b6e27"]},{"cluster_id":"3ece6224-aab7-493b-83b2-1f9fc56d3136","members":["a84ae567-4401-4340-9020-62272d966ea8"]},{"cluster_id":"6d0fc82b-e82f-4ea0-897a-429340b5d2e7","members":["0016daed-4c8a-4f04-82a6-93d276191cf2"]},{"cluster_id":"1a006b70-5bcf-42d1-91c0-d02ee212c0eb","members":["06c9eb45-978c-4b10-a3d5-4e009293d7c0"]},{"cluster_id":"2d5d8472-462a-48f6-89fe-e8182a74e9c6","members":["c46387b0-beff-4ba1-b2f4-5f52c8f5f329"]},{"cluster_id":"773a0c25-df3d-4865-86dd-a73825ed69b0","members":["2be2682b-3fcb-45ed-9120-9ffd003ad2e6"]},{"cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","members":["81764a78-278d-4f62-87bb-53accd6c2144","7089e061-f356-4b79-b1f2-651d5988f658"]},{"cluster_id":"a0fab421-41ab-435c-b6c1-ee353c134771","members":["88a2d097-7fb9-436a-bce9-304796f073e2"]},{"cluster_id":"6f8b0a89-8965-4d5d-9b89-f48b23ed61a1","members":["0e3b3e82-2f17-47a0-b8a5-0911a030245e"]},{"cluster_id":"e28e105a-739c-4f5f-8b79-8f56f435e121","members":["84eab2ec-0421-4ec5-adde-98da233799c2"]},{"cluster_id":"5c1d5636-b62a-4962-911d-1136d9629b6a","members":["b1cfeae3-7f20-4959-8338-5c2742e6739f"]},{"cluster_id":"06dab846-f17e-48d2-94e4-d604af613859","members":["1068b99b-afa6-4480-a25b-e2729c14f279"]},{"cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","members":["3970be47-9533-41fa-9996-110c725cf92e"]},{"cluster_id":"6e63c4ba-f9ee-49c7-a87f-b38ea11837c4","members":["cd5f2c50-555c-4b25-b9a8-384f188c664a"]},{"cluster_id":"a6683ed0-4b78-4420-9494-296c3493439d","members":["1658783f-c143-44c0-a0bd-d86a2d59e278"]},{"cluster_id":"62be0386-404f-434a-884b-4dc379430917","members":["b1b40546-ec71-46aa-9691-08e0f2e9b586"]},{"cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","members":["46604d93-2806-448b-8c25-c7363eb20a06","ddbb5e44-b4ad-4c11-ae5b-a2bdb771c918"]},{"cluster_id":"dad0da03-60db-4f17-9025-e5a1ac65e552","members":["86207384-0583-4a85-80f9-90268d07f502"]},{"cluster_id":"3a5853fd-eaf4-497d-b7fc-b13a9208544c","members":["942531b4-dec6-433b-a397-2a34822a7db2"]},{"cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","members":["c58cca54-9dbf-4739-a076-57ed426b15fb","06292199-7dd0-43db-afde-7ae66493d4d5"]},{"cluster_id":"949ec20d-24b3-4de5-a36b-32e35cbe9392","members":["6c3e9aeb-75f0-4a81-a3c6-6ccb162d3595"]},{"cluster_id":"a950be1b-733b-40a8-b78b-7a36e0c5c2ac","members":["9c2af4b3-f21e-41ba-84e3-147806af306b"]},{"cluster_id":"99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf","members":["36370dfa-344e-42cd-b175-35522618f57b"]},{"cluster_id":"8bcf86f9-8509-4d9f-8550-8839a96fa515","members":["94a437c0-a658-4ee1-ba24-09607845efac"]},{"cluster_id":"5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6","members":["8f9adad7-7268-42d1-8052-67cf463f8936"]},{"cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","members":["46a0c3b9-3856-4db1-a886-180abac23d55"]},{"cluster_id":"a5d39319-660b-4b6e-acb4-246464538db6","members":["8013c6f5-a136-41c4-87cb-8d5e885b05d2"]},{"cluster_id":"b198bd93-5f96-4992-9aa2-29e396814e39","members":["84e31776-201e-4b09-8fa4-f3c1b0a1c99f"]},{"cluster_id":"64de7b14-ea9c-48fe-a9a0-a30f01aecc3e","members":["17b8e47c-1760-47a5-b51b-ebd91629693d"]},{"cluster_id":"c9367bb7-c2e3-4341-a799-6ff36d655556","members":["373b210c-8381-4d76-84d2-0517d2a5fae1"]},{"cluster_id":"d8581e68-7fcf-4616-92c1-9daff0a2d8ae","members":["b0e88103-9182-428d-a786-fd65d7cfc76a"]},{"cluster_id":"94c7e352-c14a-45a1-b0c5-cccdc2ef1122","members":["dc18ed86-33df-41ba-9de2-a0ec4e7462b8"]},{"cluster_id":"da70552d-1a69-4dd8-bc9d-ca358f3caefe","members":["af9b140e-b5b6-4c11-8276-f58139175533","6b3d7248-ead8-4f23-88a2-6645c651cbe1"]},{"cluster_id":"cfde4319-eb6f-4277-956f-9a094157160f","members":["64fc6ae9-27d6-47aa-83ce-0abdfc9c3126"]},{"cluster_id":"b4ee4418-ee26-4134-986b-8e220ef5da22","members":["6616e213-4d96-4494-8c81-5d7ef80cfe7a"]},{"cluster_id":"bec9cb65-cf13-44b3-b77b-95d99bace1e4","members":["51e7f666-0050-488c-9d20-f9c3d4e7a675"]},{"cluster_id":"4cc6a578-5e10-41d7-a578-fba88da2dc13","members":["9a96fcb7-3f24-461c-abff-40ee26d60bbd"]},{"cluster_id":"5feff95a-4d00-4a01-9b49-f3df3eb263ca","members":["5d6e3c65-5625-42fb-9762-29770ac69d70"]},{"cluster_id":"71f3d08b-aa01-4b41-b89d-7fb725538d72","members":["416a7f2f-5a8f-4b2e-af1a-ed544ee6262c"]},{"cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","members":["b3ad4cab-a5e0-4720-b764-876a113500e2"]},{"cluster_id":"f401d633-0e2b-4935-b7d9-1761c201c058","members":["4289d0aa-4385-4d1f-b208-ed86b86771c5","7ae75a6a-6f33-4618-8d40-749b6de55028"]},{"cluster_id":"74bc9e46-31ab-4e9e-9240-87a035b90601","members":["abebfc28-65a2-45e1-8d3d-74cba4088fc5"]},{"cluster_id":"09a92b68-8f29-435d-b853-f4c47f64d9da","members":["c7a05342-7ea2-482a-ae7d-a4773af7eb46"]},{"cluster_id":"7fbd47ed-2abf-42a7-9e7d-74c06dc8b729","members":["bb5ea732-fc0b-42e6-915e-dc5845af26a0"]},{"cluster_id":"5b935620-b425-4241-8333-a51c2e077394","members":["11ebb2bc-c822-40ef-9a48-f56030baf816"]},{"cluster_id":"fdbce6fb-9c6c-48ff-a187-88c668f79277","members":["12585130-a603-4a16-af27-1e1fcce40159"]},{"cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","members":["bfb2d618-fbdd-4aa4-9ec8-fd066b137ccf","c741471f-7be4-41e6-872b-a89b949145b6"]},{"cluster_id":"ec868d12-f24d-450d-bca9-2e8a9f4e8021","members":["3c9d6334-c309-4acf-95f8-b5d5e69ba433"]},{"cluster_id":"11aef681-a744-409f-8cc3-69822e3a86b2","members":["3bdd3464-3b56-41c5-b23f-c9175e8cb79a","8477b1b0-2cb7-48d0-b224-7367c519ff94"]},{"cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","members":["4a490611-8667-498f-b795-aa3c60360577","93db5c3d-f473-4e51-9442-ddc704bd6f34"]},{"cluster_id":"04c040d8-393f-4b27-af55-1f60d7802605","members":["f58640de-8679-4344-8e02-c81e2d56cf3e"]},{"cluster_id":"13a07f14-45d6-4b31-8d23-23b540ac8090","members":["7f2f4983-adf6-4346-8154-b7de3cf8139d"]},{"cluster_id":"1542a1c0-0498-4551-b3c6-794eb9ae6305","members":["ad0bb58c-bd77-4852-ab78-fc14a7ada568"]},{"cluster_id":"7ddce93b-3cfb-4112-a70b-f91eb14e7082","members":["e59b958a-d4b1-4c92-a490-dad0c9ad6b85"]},{"cluster_id":"9f936fe4-6962-4447-9269-bd4c45c0f95e","members":["65aeed1b-3262-431e-a71d-2bd16f74bba2"]},{"cluster_id":"e7606791-adc1-47d9-b4e0-1e86a03f87ad","members":["a8d3b3f2-8f28-4997-b8fb-d356c28fc9fd"]},{"cluster_id":"ce659db6-9043-4f18-a410-39321ba5fd81","members":["d41000c9-686d-42f9-a48c-6ec348be7bfb"]},{"cluster_id":"b1da6225-3a48-4f38-b0fb-dac29be99682","members":["96fb4452-25bd-4554-b732-f23f41adbf38"]},{"cluster_id":"f0d99bfd-e20a-4b87-9be0-a227af6f681d","members":["ccfeabe0-28f9-4439-a265-f75474b223dd","78169a0b-75f2-4830-896f-9056dcae8c86"]},{"cluster_id":"0727da75-801a-4ea8-bc54-bca9f4c0cbfc","members":["b4bcb059-a88f-4ecc-afc9-4a8ffb58deaa","999e662e-08b9-49b2-b175-8dd13a767110"]},{"cluster_id":"12b139d6-738c-48c1-b240-a723ec803e43","members":["d7982fd2-b552-45b9-9ac6-e7c2c5fc0916"]},{"cluster_id":"8b3203a2-f473-4957-9689-fdf6ee974697","members":["db4562b0-997d-4fbf-9616-cd9cc79f842d","170e5188-3fdf-4846-894e-f89b08183c86"]},{"cluster_id":"11f5ada1-39d8-46a5-b3e1-ae12a04328c2","members":["843ad762-b206-4f47-b606-70a915950b5e"]},{"cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","members":["4644bce0-c9cd-4728-a3ac-eeedce4ddcfa","08ae94a3-a979-4f67-af67-7d21fcc158d7"]},{"cluster_id":"f97e4f6c-a73e-4c35-8e7a-51a335141d67","members":["a3f09e08-ba96-48b9-8cf5-2e23612fc92a"]},{"cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","members":["04201b64-11b5-4a5b-ab03-c26dfe98eaa0","1f803c39-679e-4b18-af7a-67db88ade0a2"]},{"cluster_id":"00ac14b3-c6d6-458b-b4cd-3981a1a2b9f9","members":["f1d4fcbb-0069-4d08-a24e-77e962a05585"]},{"cluster_id":"6eb878e4-969f-49ca-8ac8-5c68ead2c13e","members":["96f1b602-4d0b-49a5-b639-456163508b1d"]},{"cluster_id":"57752645-2ac6-4482-9e7c-bbaea1506cc5","members":["020f8349-87b4-471e-aa33-4627090a42ce"]},{"cluster_id":"99dfb4e4-9788-4ea5-81a7-c0dd44f60aba","members":["96c1386f-d62f-4eb4-9546-ab7c52e088cb","18be4b88-72b8-4ba0-a38c-6fea58782b35"]},{"cluster_id":"4a575d85-5f97-4baa-be78-2c26ecefb471","members":["63151421-595c-49e6-97f2-2451fc80eaf1"]},{"cluster_id":"cfda7d82-87df-49b1-8db2-82b62b174a67","members":["92cb575c-b924-4e40-9aba-517d60cb2e8e"]},{"cluster_id":"64b71712-5c8b-4ba5-9b04-b6b37a4ef8bd","members":["f74c9c19-08b5-4767-85e3-bdd2b04e897e"]},{"cluster_id":"018f6f1c-b2e7-43ca-a443-3a5d27b5033c","members":["54f31316-749c-45c5-a935-bcbfe6582195"]},{"cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","members":["f84fbb9e-84ba-43ed-9a8e-58d0df3a265d","2fa3d5b3-e3dc-4d6a-9b27-00715d3ba168"]},{"cluster_id":"444e2d84-e3c4-4a82-a2fc-3577e6124f09","members":["6a9a5709-418b-4dab-8b4e-1380b6e2fee5"]},{"cluster_id":"f1f9481a-c3b7-4912-be82-d974b52e8f30","members":["fdf418a5-239c-4a3b-84f1-ccb5c655dfc1"]},{"cluster_id":"de30ed78-2cf8-480b-aacb-665d9572f1b4","members":["7d057666-c938-4ff2-9b34-b005972c9385"]},{"cluster_id":"f854f83f-364d-470a-8cd8-f0bec2c15e68","members":["ac2c8b74-62cc-436f-8f86-38c3f3214c51"]},{"cluster_id":"061a86ec-2126-4e4d-85ba-8472db7a97a3","members":["990c66a4-8474-4ba5-a743-ec1d7ae76287"]},{"cluster_id":"1e12b1a7-9bc4-4a98-b698-8392df483432","members":["2bcb6263-41a2-4b19-a182-585c686a8b0b"]},{"cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","members":["71668436-2847-4d3d-9e3e-60442f2829ae","8c4e658b-c2f4-40d6-acb0-e120aa2aad0f","1bccfbf1-34fd-45b1-8a0e-d466bbcc080b"]},{"cluster_id":"ff42e3e5-bb75-45af-be07-89d36dae0d5c","members":["fb5985fd-da02-40bd-9b2e-973038f62427"]},{"cluster_id":"baa70e51-5ce2-4e6f-8994-d85027e6b1d9","members":["a20f5161-5da8-4019-a84b-b9d70eb9e2ad"]},{"cluster_id":"506e309f-6f87-418b-b660-0ad635976c9d","members":["bc09529a-9338-422a-b1ed-4aed6227f9f8","ed2428ab-ce07-462c-904c-9122cd1ba168","6a9ce6c1-b856-43c9-83c9-b007385edb91"]},{"cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","members":["94baf93b-4cca-44d7-a782-b5c3d2894ba2"]},{"cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","members":["f0946bc1-4e64-4617-a24a-fe963016e054"]},{"cluster_id":"9d85f9b8-6204-4844-9707-8c2e9351d730","members":["623ba596-2602-4da0-b167-c51bd2531534"]},{"cluster_id":"6e99d559-c095-46a1-a671-2a3d2e8566bb","members":["a263f78b-e32d-482d-91ed-81deca9f04d3"]},{"cluster_id":"34db5d7a-86ad-4cf4-abae-67c617853bac","members":["fe87c798-bb32-461b-8114-2f55d8ef06a3"]},{"cluster_id":"255ea174-3e00-4506-8a6d-78f62eccfecc","members":["e9dbfbe6-3daf-4d0e-88d0-22294b85c258"]},{"cluster_id":"7a7464b2-8279-45dc-b2ed-48f2c4d22d10","members":["0ea03c18-e531-413a-afc8-9fd758a13242"]},{"cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","members":["8cce7f5b-945c-4ca6-9592-46c32642f963","7d768a4f-0e69-457a-bc28-e263d9e83f41"]},{"cluster_id":"b6c851f0-a597-49e8-982b-650d02a8ba55","members":["c1e740d7-b80f-476e-9d43-8800d71b253b"]},{"cluster_id":"fc1c32c1-8212-46dc-b3e4-29a2254a34ba","members":["de4a5845-e616-46de-8e18-2ccf4891c7af"]},{"cluster_id":"69315435-638a-4ef2-abe8-1d91d23ff51a","members":["ec7ab2fc-d2bf-4dc4-af4a-6a78a161b65c"]},{"cluster_id":"2cfb50e6-37ad-47a2-87b2-da1a9a512e46","members":["ada738ce-b6fe-4f78-8507-95e1190b547f"]},{"cluster_id":"8e9cb96a-0ee8-44fc-9406-1bb5188864ec","members":["f36a0cb4-ca00-46f0-babd-8371f6eaf1cd"]},{"cluster_id":"729ff499-2dcf-4524-91fd-7e53fd6e6ad7","members":["9b394eca-d05c-4ddc-9dd1-294a8cfe08dc"]},{"cluster_id":"b056d050-cc91-4967-a6df-ddb4af36891b","members":["a9395453-3f62-4979-b184-b9574fed4e44"]},{"cluster_id":"ebad899d-9cc8-49e0-a908-87f53dd79063","members":["4c740324-ff57-4648-8ed7-61327f6ce31c","ea9527d3-b5f8-405d-9e71-493a16e21670"]},{"cluster_id":"a990d90c-b1b0-4148-b047-5b63c9eb7a78","members":["c5d25191-6901-47c5-8d4c-636d712c9cf5"]},{"cluster_id":"94f243ab-1521-4874-b5fc-b80847a7fefc","members":["1ae70a9e-9821-41e3-b84e-86b6e5ca8240","28d0fac9-14f5-448d-8b53-8c0cb4dd9579"]},{"cluster_id":"51b16b2e-6404-4d18-a4d1-46e0d25d726f","members":["9f0ea2b0-c156-4bc5-92af-b04cb04a02cd"]},{"cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","members":["7b39a91e-e20e-432f-b965-c4698ab22ff3","2533f22b-6d0f-49f3-9255-8b9c3a6484c9"]},{"cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","members":["3f63c72c-b008-41e9-907a-65aca35610bf","9503763c-7449-4178-849e-610ba6134ea6"]},{"cluster_id":"36f68109-962e-490e-9101-85d84c5de66a","members":["b732d76a-2b06-4284-abcd-bc387bc8c1cd"]},{"cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","members":["8c4e7ac4-8c04-46c3-a97d-e48934a16af6","a5d59357-18c2-4f05-9c3f-7b7628df3eec"]},{"cluster_id":"0f3a2cc5-8301-476a-b658-747594635542","members":["8f22e45c-5446-4628-8451-99e1ca4e880b"]},{"cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","members":["c4677d1e-9db7-4190-9924-793e642c8435","b4eee16f-516f-4bc7-a4e6-0ee7facbd68d"]},{"cluster_id":"43605210-6be3-4d52-9b42-d4a4a1838ade","members":["7af3c507-526a-45ce-b2dd-61b801d21fe0"]},{"cluster_id":"f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3","members":["96500fb1-16ab-4e8f-b6c7-c35d72fd2de1"]},{"cluster_id":"e82ed51a-4d19-4b2d-96bc-cb54f9b70858","members":["a18aa87f-3a29-4776-85db-d25a86cbd228"]},{"cluster_id":"1473286e-ca60-4128-b82b-a6695a32595a","members":["17298b54-7092-46ee-9c28-4acf297ff748"]},{"cluster_id":"98177424-a992-4818-bd6e-9e0e3d0899af","members":["f57e9765-ae8c-4cb1-a9bd-02639581ef21"]},{"cluster_id":"c5d18c78-4df0-44fa-9f69-67266b1079e2","members":["3ac795c8-d51c-4298-a87b-214912d9d6b4"]},{"cluster_id":"7f94beb2-9a43-4280-9734-5045402a0714","members":["52466996-0059-4953-98fa-5cedb078c1c3"]},{"cluster_id":"d0228864-78be-4fd7-94b7-908de0276e80","members":["d4c15268-dd03-4bb9-b579-ad2e9d197f56"]},{"cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","members":["62956cb9-8b3c-4684-8727-ab704ca7a45f","3d172aba-15cd-41a3-875f-232cf07ac7a3"]},{"cluster_id":"8e873c15-6407-475e-841a-2dcbbce28e18","members":["e22e1484-240f-4364-bef2-27197cbab294"]},{"cluster_id":"e0f8bbeb-8967-4f3f-ae0d-4b809311c515","members":["a7644128-356d-426d-a72f-e9ccaca044fc"]},{"cluster_id":"45931062-6efb-4850-9df7-4bff0b9b4a16","members":["58ea73c6-2eeb-4934-a39e-bd6e1d791d97"]},{"cluster_id":"5389eae7-83b1-4726-86c2-9a8dff51be59","members":["aee737c4-a386-4460-bb22-c9a90c10bad3"]},{"cluster_id":"691c3c1b-0058-48a0-aaa7-5a38747b8c58","members":["a87006c6-a37e-44aa-b418-b90844e6d18e"]},{"cluster_id":"ca064fa8-d12d-4c48-9fc5-aca6df7f2dc9","members":["641375ef-beb6-46e7-80af-90bdb12b074f"]},{"cluster_id":"e1ad3c4e-eefb-42e0-8fe7-edf486c4da19","members":["6b595781-d1d6-4ca0-bb23-9a044256b930"]},{"cluster_id":"51086a98-c771-4b7c-8eaa-b6fbb8629a30","members":["45022a65-88e8-4eff-9ed7-e9aed1e85ba0"]},{"cluster_id":"b39ca7cb-8663-4bff-829b-b432d59670f9","members":["64c2f63a-56d2-46e0-8abe-ff40035acd85"]},{"cluster_id":"02f58db8-b951-46f8-9ff7-76980a66fc66","members":["02f2861c-459c-420a-8105-6710bb5b977e"]},{"cluster_id":"4a4d472c-cd13-4ccf-9f30-e866d14bdbf8","members":["a2d9f955-833e-494f-a522-8983dbe3a28d"]},{"cluster_id":"7ff438ec-b701-48aa-b613-4bfeaba7bcce","members":["3e03a02d-349b-468f-a5cb-ed740d95b05f"]},{"cluster_id":"9d39778d-eb5c-4c0e-b35c-894a4378bc37","members":["05f5fec2-3369-489b-a94e-b9bfcc251a1a"]},{"cluster_id":"42b60cc5-5a50-48f5-a8c0-713eeb591918","members":["a2c7b8dd-50cb-426b-9bcc-a31227a8ca85"]},{"cluster_id":"eb68c709-6220-48fe-b376-95a4f6f10b6d","members":["62c4c72d-70a2-472c-bcf3-193476bc0f15"]},{"cluster_id":"702a4627-2eae-451d-b2a9-154358319e24","members":["6d70a893-521c-400e-9941-96785e5ad0d0"]},{"cluster_id":"2e620f14-db3f-4f94-9e90-7ae11cf68067","members":["f24622db-4923-411c-8797-144755e2de66","858266a5-5598-4215-8544-ed58b34b026c"]},{"cluster_id":"503584d7-75a5-4f03-adb1-4844dd4d9b9f","members":["7aefc389-9540-4437-951c-1c190167095e","94a1ce17-80ad-4be5-af57-c87d3443e0ad"]},{"cluster_id":"639596e6-4b0c-464a-9fa5-8272920e87b4","members":["9a562a62-374e-4b09-bfd6-4b09c8d58a93"]},{"cluster_id":"29bf0ceb-12c5-4f73-8a36-f5d689e7afd2","members":["23833acc-ceea-47bd-89ec-81ece2ea7dee"]},{"cluster_id":"d3123cbc-3543-4f46-aee9-7941c8669a07","members":["3257e97d-7af3-4599-9280-a8ece0196021"]},{"cluster_id":"9d1065d7-3830-4746-a836-8da581c0bbb5","members":["8ef4bf67-7cd6-4006-b358-4c34fa1cfbbb","7e50b278-7168-4642-ac16-4936bb59dd46"]},{"cluster_id":"dfbc19e5-8117-4d40-9c25-774ed7aee906","members":["131a2710-8ce1-4c28-8d5f-38b1e00f7315"]},{"cluster_id":"df17d3e5-8709-4518-a32e-ebe9d39b417e","members":["58ae0f5c-42dd-4e1d-ba86-398feb744cc4"]},{"cluster_id":"ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb","members":["74f6adc8-d3ea-49aa-b8f3-a2bf36a09897"]},{"cluster_id":"b196eb88-ee2e-4367-8e6b-08f9890e6fe0","members":["75db5fa6-073a-44c0-8965-caf7b4deed7f"]},{"cluster_id":"f46e8240-2cb3-437d-9e2e-c04f6db7a813","members":["2568521e-8586-4e71-a3a6-e54c9dd1a93c"]},{"cluster_id":"5ece0141-8dd6-405b-93cf-5585050f4efe","members":["b4bf2eab-e1d3-47f5-90d7-b582087895ba"]},{"cluster_id":"61ac97d3-e62e-41a3-b910-360985f7af21","members":["a9d4fbc8-c8c7-4d93-957c-cec78f52d3c8"]},{"cluster_id":"e0a2030b-8c63-4b35-9a46-36f1f22b5601","members":["a0501e70-1977-4522-a0ee-e76a259691cf"]},{"cluster_id":"897e2456-ff2b-43b5-9a48-23b6c36b2d95","members":["7754c771-cbbb-477b-9075-d667f3ca2060"]},{"cluster_id":"eea02be7-fd53-47b5-9804-7a2f89de23f2","members":["5170b10e-8ae5-472a-b8b4-865fceabeaa5"]},{"cluster_id":"eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0","members":["f28d8885-754e-4856-b649-c6bea110441f"]},{"cluster_id":"8db7f2ee-28e7-4abd-b214-9d334508a075","members":["c42dccc6-9330-4981-81a9-d16c8ca59174"]},{"cluster_id":"292629c2-32f2-451e-b64e-e8f73bb87975","members":["901f433b-f0f3-454c-aedd-2757b0e01baf"]},{"cluster_id":"0dad0e38-e0db-46d5-a25f-8e95be6a721f","members":["ec769d42-4192-4ecf-9491-4cc677a2a64f"]},{"cluster_id":"02fc2c1c-e5e4-40d6-92bc-a975544e0e30","members":["f0bc4708-3024-458f-b26b-a56e742362e9"]},{"cluster_id":"59905a93-0117-4d6a-a153-cacf3c9feeb8","members":["29dc0b96-e0bf-42bc-8a57-0ede89709852"]},{"cluster_id":"08c235e3-44d9-4f4b-9af7-a9491ce983db","members":["44f198c1-f272-49a0-a145-49eb04b378f7"]},{"cluster_id":"ab52850c-7dc5-4f99-b37e-0c628b078043","members":["6845238d-ffa0-480e-ad20-dc70bd916dfb"]},{"cluster_id":"0e2fe0e5-314e-4455-88c7-a13f3f6e7728","members":["af026343-e2e0-4e95-af43-802e830830dd"]},{"cluster_id":"e6794d6d-e8b8-42e9-8f90-b2940e146fb9","members":["f8e8a37e-6a86-4071-8a46-c17486c6a426"]},{"cluster_id":"658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8","members":["5e17f8d0-3190-4e64-9c88-7ecf86c72a4d"]},{"cluster_id":"d41663c0-a43a-40f6-ae8e-9e6eeb720de9","members":["4b246f2c-26cd-41f9-a527-6f1d6476d5cc"]},{"cluster_id":"31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8","members":["e6d93d6d-3518-4400-b450-5f48fe896cec"]},{"cluster_id":"68637c5d-53b2-4a1b-b193-4fe1333f1416","members":["2a27e2da-beaa-497a-958c-527da5ef4335"]},{"cluster_id":"02e0cfd6-814a-4276-b8cf-66540b7686e7","members":["d7b4f1b3-35c7-4658-9644-8fa6c89b17f2"]},{"cluster_id":"310f4e19-f7f5-403e-af6f-b2064fadd246","members":["d07afc6c-f8bf-4950-9736-abb677633b8d"]},{"cluster_id":"914ca89d-e967-443c-9856-6a5b040a0496","members":["ac9c574b-d539-4fe7-8d70-6980324b0d5e"]},{"cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","members":["2452b572-745d-4e14-b417-4111e352b92d"]},{"cluster_id":"0f047203-3949-4e82-86d9-77d6fe7af9c8","members":["8356bc2a-d254-4687-bfca-d0574d34234d"]},{"cluster_id":"469e17e6-447a-4bc6-9bab-f2cb595f07e0","members":["1edae4f0-e767-425e-b9ef-a2582e50803c","8858128f-3967-4c92-b226-f140e0a703ed"]},{"cluster_id":"38711d17-ac82-464c-a077-7a82e0d362fd","members":["201bd170-dafb-4b7f-8992-8ca1076fa5c0"]},{"cluster_id":"0ecc8673-156d-41da-a0bd-8ceb3bd503b8","members":["f48228a1-9226-4a72-8363-5b731e9f40f7"]},{"cluster_id":"594e0474-2d9d-4582-8963-9fe946d49a1e","members":["8d33e790-22e2-4d63-bb4b-6b1fa1107dbb"]},{"cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","members":["0fdc3f1e-a803-49d7-8551-6143d0d355b1"]},{"cluster_id":"d68f430a-9578-4b21-a27f-13f1a9f8f629","members":["3c73cae0-75fb-4152-bf44-4e18473a5e5d"]},{"cluster_id":"08dc80e4-6332-48c1-99f1-a1bc6a88f48b","members":["1f17b118-8369-4029-a521-a42b43a53117"]},{"cluster_id":"1c849e20-6024-47fa-80b4-e611385ba612","members":["f2be7c90-9b9b-4fb0-a65c-4f848a11c4ec","83e130ce-6945-4d0d-b53f-d6e5ae90d013"]},{"cluster_id":"4a942b66-0607-413f-8ee5-b6f6ddbbd034","members":["2ebc44ff-8117-4192-829c-584395c41f04"]},{"cluster_id":"35ff7a5e-40b8-42ad-9379-7ba830c9445f","members":["4d3d9bba-fe97-4063-8039-8189ff9eb830"]},{"cluster_id":"5f266248-0a3e-4fc2-afec-4bfc7ba1a633","members":["3765ef51-6b00-4412-b8b5-d783322a2f98"]},{"cluster_id":"990aca8f-a2db-4ebd-85da-744c488a8d2b","members":["1b6c65e0-53a5-4b0a-8362-e35b991c32d2"]},{"cluster_id":"bba9ba69-2957-4432-9f56-bcb77e8342e2","members":["8b897291-7570-45a3-ad27-c89c40e46fa6"]},{"cluster_id":"38b659e5-9f63-40c6-bab6-c8934148aa21","members":["4d0c614b-0cb6-499c-8dcb-bf785e560cfa"]},{"cluster_id":"93429ef7-e07c-4686-85f7-679d49d1274f","members":["6b602515-6205-4c47-abf3-c12f4e1efdd8"]},{"cluster_id":"24accb31-401b-42c1-bd69-e81c04cb2530","members":["e6683a4b-da3c-499c-a23f-bb273f0a18fe"]},{"cluster_id":"4cf8f034-c2c7-4891-81cd-bb23d16f75ec","members":["25fd6249-e949-4631-84fb-f1405e61dea4"]},{"cluster_id":"f20e8a65-5412-4f81-81b6-1570f9619cbd","members":["705ecf79-6e86-4810-b490-c16d6a7e79df"]},{"cluster_id":"478c6562-e71b-47f9-8079-8463bc1262ba","members":["04a33121-8c9f-4e66-b86e-04b2bc7ae9b3"]},{"cluster_id":"03ec1dbc-4ed4-48f3-b875-cc73a019f7f0","members":["b10e74b5-8563-4e07-a785-d9e62c029e0c"]},{"cluster_id":"3d9f2bb4-f1d6-41ac-be1a-ac1194130144","members":["ba5e111e-c865-426b-bfa9-766e567f9b00"]},{"cluster_id":"45803076-0698-48ef-a2b4-10f190885998","members":["e7bda970-2973-461d-bf8f-13801534e927"]},{"cluster_id":"035bc55a-3ae4-48b4-942f-bbef3d308147","members":["a256890c-78e3-4b94-b0a6-adfbd7fcd013"]},{"cluster_id":"4ef708bd-198e-4a9e-9652-a1b08bc50fd9","members":["a9d64ed5-d644-4f06-bc99-b14bd6b9ad36","d948ec84-aa50-4245-b854-5ee6998c7962","546e7fcd-17ae-4983-9cf8-82284e24b39b"]},{"cluster_id":"dfbd57d9-b4af-48fe-adde-4b27c203374e","members":["d4b1b125-6251-4b00-b38d-d36e119b32a4"]},{"cluster_id":"02774183-9d71-4dfd-8f60-b54cf275fbb8","members":["7b268201-9047-4d4a-a308-879db7198ea3"]},{"cluster_id":"29fe240a-81f6-4aef-a8b5-3cacf3e3985a","members":["cb07e2af-aff1-49c2-b82c-eac07c8917dd"]},{"cluster_id":"463ff506-01da-43ee-96ab-3704e89855e2","members":["ddb36507-88b7-494f-8e9e-f9d8f9920656","04c9412b-bbed-4091-a914-6dc969953182"]},{"cluster_id":"8d20ee1c-7a34-4de3-a19e-635d0eb460b0","members":["13bc353e-afcb-45d4-a669-5c74b8b3974b","3417b059-848a-45db-b984-f5828b7e0775"]},{"cluster_id":"c537cca1-8aec-41b9-96db-837f4d59c8e4","members":["45b43966-a14f-4601-aa6f-f71455455a6a"]},{"cluster_id":"55a85a41-dc09-4546-82c9-33ba7368eb9a","members":["41fe581b-fd35-4726-8562-d8b53adbc04d"]},{"cluster_id":"b8208758-3ffb-41f1-97e7-30e90da08e44","members":["eb95bd57-4eb2-46ba-a0dd-fba6ea1f6bda"]},{"cluster_id":"d37ab208-5122-4b14-a2ce-fa0d51ab2a4b","members":["717e16a2-b4d8-477a-86c2-54a02be5ffe2"]},{"cluster_id":"b9ff3223-8bd6-4360-8edc-fa3409378e90","members":["7256ebf7-6850-4ad1-b34e-fbca0739ae2d","2c259afd-f542-4627-88d8-3750d2b59ae7"]},{"cluster_id":"5443e2c0-e92d-4c21-ba1b-b0cdb2302769","members":["8a0c1978-1d61-4edc-94e7-56a5fa204143"]},{"cluster_id":"227d3de7-5437-4b66-857c-d51afef721c1","members":["14252dd5-081b-48c5-a9bb-81baa766b054"]},{"cluster_id":"634ebbc5-474d-42c0-bf34-498666dade49","members":["3704c051-75f4-481a-a47f-2eec66167fbf"]},{"cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","members":["e6f94f3b-de14-46dc-8947-0892c54963d9","00e918f9-e1ad-4cb6-82ea-c57ef9f80f87"]},{"cluster_id":"f502dcb8-0d11-41eb-afba-f50e74157a5b","members":["1095ef48-c0a4-4bfc-8a82-ee80cec0f80e"]},{"cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","members":["53ab3c6a-5466-42a0-9451-1e63fb55016b"]},{"cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","members":["e4707b72-cdd0-49e5-9d11-b19f9d30d22d","b0d48266-96c9-4672-9d0d-180af4f746b6"]},{"cluster_id":"774b6df5-ef29-47f3-9ae9-d88dbd184e38","members":["58a8417f-f648-4a83-b4be-780d4c190a88"]},{"cluster_id":"4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8","members":["55bf2059-688f-43e6-ade3-8ce980649e1d"]},{"cluster_id":"ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db","members":["0d403ca7-7770-44ac-96dc-2a56f17d8b3c"]},{"cluster_id":"07e66c00-a616-4a75-b1a2-efe8ff1edd22","members":["74600ca3-b2a9-4375-9cfd-fd2742ec9d4d"]},{"cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","members":["b057b3b9-cd53-4894-92a5-f2830f70b8d3","140c722b-2bd4-4e8e-b7a7-faab1c343974","44a3fb61-0f2b-41bd-9c56-dedb56b38786","b8b39438-ddcf-47ac-852c-d9a001d59edf"]},{"cluster_id":"4d2dc30e-97f5-49d3-80df-c343048e6856","members":["a6f82707-218f-43ec-aad2-6faa25593c13"]},{"cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","members":["b45e717d-ffa8-4ab5-8872-95370f8027f9"]},{"cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","members":["cd9c32c3-81d0-44d8-bbff-fc8c2896a4e4","e19d4626-676f-46c8-a860-8a1ae27e4c3b"]},{"cluster_id":"bed08ef5-4cb1-4f05-b2d4-a996242acd93","members":["2b147f86-fc25-44d1-aeab-ecd8aefa2b6e"]},{"cluster_id":"ff920ca0-1e39-41be-ac8f-cd0534048634","members":["598aeb2e-dece-423d-91ce-264ed870d837"]},{"cluster_id":"1cffe038-9a46-45f7-bcc3-f26914315286","members":["e6095ac2-1356-414e-8a1c-f0b2cc8822b9"]},{"cluster_id":"ea08b9f4-137e-40ca-ae54-2e396aa18fc5","members":["fae51888-22a7-4826-b71d-1d9befc16cd4","a260e8e8-ef5f-4e64-8f76-0bc6fbe678ae"]},{"cluster_id":"3b355bb3-b565-4742-b6f4-50c6f509a1ec","members":["12055060-feef-4713-8995-9a76c8499749"]},{"cluster_id":"0726cfa9-d89b-45b4-922f-553fde14346a","members":["887b0d36-bbc8-43a7-b5e1-4d384e2568d9"]},{"cluster_id":"7f7310ca-5512-45fa-8f93-1b6555e791c0","members":["e59fd3ee-63ae-4ece-accb-0fcf50901d4b"]},{"cluster_id":"54a8d4bb-c88c-46df-a439-6be0dfcdce0d","members":["fa85abfb-5251-4852-855a-ef9fdeeec1c1"]},{"cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","members":["be579522-ce94-4a53-8c1f-c8f8e2b35ad0","d0c13a79-f140-46e4-acfb-c1195305cd65"]},{"cluster_id":"18699af2-76ba-4b44-8dd8-cbb2b538e559","members":["51af9d48-4a9c-4ea4-9f7e-70c38d0ca666"]},{"cluster_id":"f74a80e3-1327-4636-a252-f4ca8a5b90f7","members":["812e2115-60b4-452f-b44d-cd5777875496"]},{"cluster_id":"e12046ad-ffee-4bf5-90ec-51d127135711","members":["21027d00-a6f2-4c55-88ee-86c3a70d6d53"]},{"cluster_id":"4692c588-5e24-491c-9044-3d7dd7c0a2d7","members":["cc2f09e1-bc82-40a5-90db-e1040af323d4"]},{"cluster_id":"481b0645-4bcd-4df1-ae15-b184375e551e","members":["1eba351b-5552-4e28-ae20-82867d650d2b"]},{"cluster_id":"5eea51f7-7e2e-46d8-8dff-0d1a87db87b5","members":["fac74e7f-c900-4f5f-91ec-4a777460f35c"]},{"cluster_id":"d10a4ec7-a74e-4016-996b-f1f3a3c6527f","members":["8e8ca0bf-e85d-42c0-88f3-d5cb63349dd9"]},{"cluster_id":"23adc402-b3b7-489f-bbe8-5d7825946d77","members":["0964821f-62b5-4f6d-957a-cf486c6ef6f4","35177478-d6ba-4d8e-b6b0-d026b89a18b3"]},{"cluster_id":"571676ab-8830-47d5-a21a-ef55f09caa73","members":["5acfcc66-a473-4cf8-b96b-b77390d3a232"]},{"cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","members":["49dcec77-6a80-4a31-b76d-f30a6bbcc836","58ffab6b-fa0a-454b-b303-57a5b0ea6909"]},{"cluster_id":"840ac263-91de-449d-b701-c05a4522f3b3","members":["800677b4-581f-457c-9366-8c4d0574d7d2"]},{"cluster_id":"fd537f2d-3616-4303-9edb-81c90d602f6d","members":["7c80c70b-5355-4101-a131-3fb5033c5466"]},{"cluster_id":"9c52e5bb-8493-4b3c-8444-69598adc8932","members":["f818e45f-f7fa-4a5f-8f89-f842f6c6ecec","51aaa1c6-de52-447f-9184-f66d905b0b93"]},{"cluster_id":"707f482d-8ff7-4cc9-a14d-99540ac35950","members":["57e5f68f-fef5-4d51-a787-8cfbb1f2b7da"]},{"cluster_id":"35218630-91b1-47a4-87cf-29094bd87289","members":["cdbde4b9-7685-4c13-8654-d1417a5d5ee0"]},{"cluster_id":"6d7d1320-a896-4471-aa98-60a45946bc57","members":["b6c27490-dd7a-46bc-b782-cfd7f9bead27"]},{"cluster_id":"f17dbb9a-8968-4ade-a774-02688b6da89a","members":["a27ce914-e260-4d08-ac3a-432980fd62b2"]},{"cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","members":["490533e1-dfdd-4459-8e69-84a77de32982"]},{"cluster_id":"317ae87f-a4ca-4e46-9ff8-1bebad9fd04f","members":["77e80b1b-3b86-497e-9307-f52b8e26e1f6"]},{"cluster_id":"0ee142b2-6805-43f4-b8d5-34f76c2c799e","members":["48931092-1268-4b65-8ed1-3d8321ab4607"]},{"cluster_id":"2df1a526-a92c-44a2-a3b2-202bf1d7f6d9","members":["1ec753ae-0076-44ca-96d3-6c8bef211a7e"]},{"cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","members":["93cacc91-bec7-49ba-85fc-fdd8c3a4e356"]},{"cluster_id":"22c3b77e-fa98-44e1-b509-f721cef0815f","members":["1d9d7c36-2de2-4de3-9779-1b514ea4cb97"]},{"cluster_id":"af503db6-fcf4-45f9-9501-f2732e2af4f7","members":["ab8713ea-0916-4c03-b7ea-9bed8792db33"]},{"cluster_id":"5528714b-b0b8-40d9-850a-99905744c056","members":["dcebb25d-c474-4240-aae5-10924c56f7d8"]},{"cluster_id":"90a4e218-d5e9-4e12-b842-f6c8e272cb28","members":["47c8f442-152b-47d6-afd9-09434f7556ae"]},{"cluster_id":"170448e1-fefc-424b-b5a4-23941f88389e","members":["a4202ed7-037f-4047-85e5-bfc3bb24d142"]},{"cluster_id":"6717f23b-7a46-4774-9d7d-76c5eb0bdde2","members":["514a8a9b-bc78-4e9a-9d68-8eb6b36fed1d"]},{"cluster_id":"7b578c6f-7be6-4c78-8bf3-3f66b6797db5","members":["f5785d4e-bb24-4967-93a2-a6279cdb2aa3"]},{"cluster_id":"4e7d68ff-7bd2-4949-affb-c71a8a76240a","members":["7fbe7e93-7fdf-4ab5-9d0a-b2224b8c001d"]},{"cluster_id":"61922f77-a020-4916-b901-44fe7982b789","members":["7ca8d60f-df10-4ca4-9389-05952701211e"]},{"cluster_id":"6e8d0f46-aead-4efe-a267-3f325cfe8dec","members":["fe8cfbf5-a62f-4e4e-a3d8-4fce6f205412"]},{"cluster_id":"6c2771d0-bfd3-428e-a6d5-47a3f027d3a6","members":["4f61b269-b18f-440f-86f2-071070cf39f7"]},{"cluster_id":"8a2e1f2c-6d19-479b-811f-3ccec4820a64","members":["48dcacb1-a6d4-4ffd-ae0d-19020e4a4256"]},{"cluster_id":"b31e61b9-2010-4063-88bd-0eced0599429","members":["e893b0cb-deff-41b0-8a58-d9f7e330290b"]},{"cluster_id":"f4cd4d9b-6b2b-454a-ae24-3a0150790009","members":["67e3ddb6-2eb8-443a-91e4-4a47d24d0ca2"]},{"cluster_id":"33e1162a-91ae-476d-b4d5-3b1e2f01a5c1","members":["9d307cba-10c6-4d4c-85a8-ea190c9e38f1"]},{"cluster_id":"f8cc40a9-e215-46da-bdf5-b5efc622bb40","members":["381b986c-714c-4d28-bf25-4946c45f7085"]},{"cluster_id":"f8052bb9-bad3-47eb-9141-dec76f63f661","members":["496f09c0-85ea-419e-b170-6ca90d3cbc34"]},{"cluster_id":"ffb2c778-a1f6-402c-8381-54550bf56799","members":["3c7bbead-a5a5-4a68-9acf-7d3319a7fb38"]},{"cluster_id":"500957af-7f87-40ca-b575-44450d181bfa","members":["4ce45b79-2cbe-4d99-96eb-07d582e80fd8"]},{"cluster_id":"b874b38b-169d-4b90-b373-ae919f14c5a0","members":["0ed14139-129e-443f-b11b-fdde310f75d9"]},{"cluster_id":"fc264446-1206-43b0-b6e2-29d7fc43d99c","members":["cb71a94d-8f0d-4be5-9737-fa44d24d6c90"]},{"cluster_id":"fa484c7a-b508-4b38-90f3-04e6ca143d03","members":["0c61da08-e4df-4b4f-944f-c5a065acace5"]},{"cluster_id":"e9c91d2d-9c77-43dc-9ccc-c00049984a01","members":["b61e932c-d0e5-4154-be32-f0ac3c52fed0","27285168-d87c-46d5-b795-95c75474a413"]},{"cluster_id":"bd0e72d0-0f07-4c8e-ba6f-6a4178be6cee","members":["8ed4f17b-38af-4dfb-9181-18f56598cd3c"]},{"cluster_id":"5fbc247f-99df-408a-8188-29a28a5f5737","members":["8f7421cf-82dc-48c1-98f5-c7e7321e37b3"]},{"cluster_id":"558e806a-d249-4f8a-8e7e-fb4b28552537","members":["ce31105a-13fb-4324-877c-1143670d251b"]},{"cluster_id":"a6d51f65-13a0-42d8-b6fe-66f9daf5bd01","members":["4b5dde87-2185-48d5-8f08-8cf82f888f78"]},{"cluster_id":"87e60b81-7893-469a-8c14-40e3d6122aa1","members":["0c13fc8f-d3f9-42e0-afb5-4e1ec4d48ca2"]},{"cluster_id":"c2417696-bc64-4d4a-b3a4-d5d9e3cefb38","members":["a7ea3f1a-7b3e-4f52-8f24-7549557e04ad"]},{"cluster_id":"0a79d737-f594-464b-b3d2-afd57c6349f1","members":["3b2128b4-4590-4671-b7cd-02a16eadf477"]},{"cluster_id":"ce637d4c-890f-483b-9ed8-d8130682b8ac","members":["833d8aa2-87f3-43d9-b6a7-840cca9c261a"]},{"cluster_id":"5a50a1fe-c68d-46bc-b14a-9fe07afb2e36","members":["1d535066-043b-48ae-b72f-bb725a0dc533"]},{"cluster_id":"f4175686-5e4d-4fb0-a465-bed7586f6615","members":["6f64e734-8b4d-4d8f-a346-c4d16a69ba8b","4bc13bbb-6196-4f52-8bd7-0e0ec095f388"]},{"cluster_id":"a0977c56-cc0a-4fc9-a35d-0f1fe8c43b6d","members":["e7d790dc-8255-4a27-8ca9-8ecc3deb5bc4"]},{"cluster_id":"09183ea2-b51f-4c35-a3c2-3fbf476237cb","members":["d51a391a-6570-4599-b28e-5b0598458b94"]},{"cluster_id":"db5a201e-a58a-46dc-91a0-0072432f56c4","members":["0885b665-80fc-405b-98c3-3ee4dc2ebc96"]},{"cluster_id":"40460222-6c35-47b7-be68-29a1138ce819","members":["34b64dd0-60ec-464a-b7f8-af46028d73d4"]},{"cluster_id":"767a107b-6141-45c6-9ffe-6f7fde1b3426","members":["66edd251-7fa8-42f8-b860-e9fdc90e657a"]},{"cluster_id":"1a689731-c588-4661-b0b5-8beb94a95bb4","members":["0f7df7e2-9b40-4791-bf10-de0aaa56e74c"]},{"cluster_id":"2247b006-05c5-406e-a6b2-d87e6eb59702","members":["5770a376-3a58-45b3-b9c7-4139b4da1cf5"]},{"cluster_id":"12ce4240-07a8-40e1-acc7-141144ad6c5d","members":["a08c9c34-13b1-4b32-94c7-c670511aeb6b"]},{"cluster_id":"52f4370b-6902-4abd-9ee9-d4310ae49cb2","members":["b59d921d-d502-41a8-9bd6-26a16eea2d90"]},{"cluster_id":"4575f267-4553-4c7c-916e-359800e4fb24","members":["5ccdbbf0-2376-4f95-8321-d746fa931186"]},{"cluster_id":"cef32527-0357-47cf-9fee-19bd0f13e11a","members":["f1e088e6-b878-443c-ad67-f37a3c1428ab"]},{"cluster_id":"a80ecbee-c55e-46fb-a302-1137d87bdcfa","members":["c7da2e2a-b68c-45ad-a5c6-61096ce211be"]},{"cluster_id":"df94ae50-99ca-4e54-802c-ae4f92bf2a1d","members":["040dec4c-2428-4f42-b5a0-68d2f5e4071e"]},{"cluster_id":"4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1","members":["df336382-0e90-41dd-8ebd-a899eae43674"]},{"cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","members":["81a64a01-ce6c-4c66-9537-c97b8fad0a54","970dbc26-0b71-46b5-9e3b-d3d66cffe827"]},{"cluster_id":"bd0a892b-884e-4c98-8690-8f25949dbaed","members":["3aa43b0e-368d-4d2d-920c-2bdf99fb3216"]},{"cluster_id":"d78f22d5-c64c-4786-833e-21ebb584c006","members":["21a386c6-a8c0-48cd-9378-79cc4cf98735"]},{"cluster_id":"b65267b2-a6b3-4938-aff4-8dde024d5b46","members":["1db9ddb6-3d68-48a0-be81-b5b62a2a1b11"]},{"cluster_id":"6635c105-dcdb-4bd7-9a1d-4db57f43d53b","members":["97e7a0bd-d797-473c-a610-4279ac90663f"]},{"cluster_id":"9a03a84a-f375-4382-bf36-e4f5df1b4795","members":["be6c4f4b-813c-437b-9081-5cdae97ea306"]},{"cluster_id":"4f68034e-7758-4136-94fe-82331ab7df47","members":["d20c48d1-f568-44d9-a525-23bd770a03ab"]},{"cluster_id":"621b2187-e651-4a6f-becc-2a2a2cd444a2","members":["50aafcf4-a03e-4155-8c97-9aac0561190d"]},{"cluster_id":"0de86638-0241-412b-ab2a-b233d85153a4","members":["683f15ce-dced-4660-85d4-c95cd43c23c7"]},{"cluster_id":"fb6ff34e-94b0-4910-b613-9ebb9af0b6b6","members":["dd96c0e8-8609-47ec-a1a8-bf3ea961e073"]},{"cluster_id":"e9b06ff3-55a4-46a5-87d3-266dff0dc9c1","members":["a1d9fa60-1b33-407a-8a7b-098c15f781e2"]},{"cluster_id":"f9741213-db12-438e-ba4b-5df13a3381e4","members":["ade8b013-f783-45c1-98c2-1a7f3507d997"]},{"cluster_id":"f72eb4bb-112f-4556-a279-ad745cb4894c","members":["780cdf62-aff5-4110-8e69-01754cc6c09e"]},{"cluster_id":"65545a07-9406-46c5-9357-571d95749394","members":["4e679122-0ca3-4471-a107-5f85bb5443bf"]},{"cluster_id":"c8657dfd-ec8f-4884-9c32-c4d6cac2c0f4","members":["b1eb74a2-49a0-41d3-b342-abdbfa1efe71"]},{"cluster_id":"0c398c2c-4672-4f1e-ba98-17d7320a9537","members":["4aa72748-0ad2-49be-aad1-b95e37da3a2a"]},{"cluster_id":"cf096384-5ede-4929-b992-9e6ee20d6a8b","members":["fca8eab7-2aa1-4276-a101-a285da0affbc"]},{"cluster_id":"0261ee84-1c1e-4042-9226-f1085216eef2","members":["03574c37-742c-4770-ba1b-d8c6c3e4d8be"]},{"cluster_id":"ccd87163-f5c4-4a49-b3d3-5d5c4788834c","members":["b26a0e68-fde1-4d66-a7d2-5c1e54629b60"]},{"cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","members":["0ec7f5cc-5e61-471e-b6ba-654ac11c0af5"]},{"cluster_id":"3db5575b-e4cd-4afc-835e-707980be99ac","members":["301a9f91-1c50-4467-83f2-77688d7deb19"]},{"cluster_id":"a986747d-76c4-4786-b8af-6e1c3537a9eb","members":["ba39436c-49bc-48c4-ab96-805ef9ca0590"]},{"cluster_id":"d3b98f44-6b27-4d30-a29b-fd80c7643f1b","members":["f39abf0d-00c9-4096-8087-54873ff61fa6"]},{"cluster_id":"ea54647f-e4a4-46e7-bf16-66e30583a4a6","members":["02046bbf-5ad3-45ff-b1c1-e73942023b9b"]},{"cluster_id":"d089a914-1c7d-48b8-9c48-7a1b65f152b1","members":["fec5595b-21ec-460d-bafb-b5b19c7ef652"]},{"cluster_id":"2568c212-fcce-44e5-930c-3fe63b8f0d65","members":["fa53f6ea-9cb9-45ca-ae67-e1f013dd59de"]},{"cluster_id":"4d2c8d1c-73d7-42b1-87cb-56c8ddf68982","members":["8fd7bf1a-45d1-4bf4-a6cb-3d32320b7683"]},{"cluster_id":"e0b76993-43d7-4b38-b891-9ad858a2c5f6","members":["8d49ec4b-b1e8-406b-8b1f-8c5fdb7a636b"]},{"cluster_id":"d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3","members":["0aa879c0-b7fe-47c4-8027-e48da678618f"]},{"cluster_id":"54bf8eb2-6975-454f-a48b-59abffdfe4f4","members":["00ab1807-cf95-4e72-8394-2e9689140536"]},{"cluster_id":"12605708-2ac7-455e-a636-1d8a235af813","members":["0a551238-3582-446a-806e-0f8443f302cb"]},{"cluster_id":"818db8b7-0e38-4d06-8f87-4de475ce7556","members":["d18e9a0b-a6d7-47a4-b673-21d5f2eaf483"]},{"cluster_id":"42fd849e-0fa9-43a8-b5fa-5cc192351c79","members":["a40e602a-c272-43c8-8c71-cebb6598a675"]},{"cluster_id":"2b7a55b4-92f1-4438-b42d-086b564be154","members":["86b9cf66-03d4-4167-9c04-a1450db98ded"]},{"cluster_id":"5b5325b9-59bb-4b91-9a19-8889095dd496","members":["c9a5e64f-b02b-49dc-8775-3842f4736fd7"]},{"cluster_id":"f55fbefe-4ee7-4bc9-a05f-0bee3b933ccd","members":["1d7a571f-302c-43bb-9c0e-d22f93415455"]},{"cluster_id":"6e5c19c1-853c-4797-84d8-7f68386994d3","members":["cca498e1-8ac8-460c-a82d-4e0e49181f6e"]},{"cluster_id":"43966195-88ed-478f-bd22-9c59b6eda45a","members":["c64cbb4b-58a9-4606-9025-8605cf79296d"]},{"cluster_id":"27b386d8-58df-4b19-a269-36bb2400c94c","members":["68309499-78da-4bbe-af16-4f5b2d11c215"]},{"cluster_id":"8dca8952-fbff-4b47-ba25-a7640fe52fba","members":["9f4836cc-879c-4406-8ed7-bdce9b8b99e1","5923c121-b933-4b0c-8c5e-8ec99a127cec"]},{"cluster_id":"894e29d9-1e82-4e00-b1eb-e5092d46e327","members":["d1abf8d0-9d30-4d4f-8219-bb00fdef6ac5"]},{"cluster_id":"bc70c00b-dffe-4092-a775-4a9734094547","members":["938259cd-de6f-4630-996d-bca53f1e39f4"]},{"cluster_id":"d14e115a-dd46-437f-8a57-5893395dde5f","members":["12391047-4214-4422-bc58-91fbdadc33b7"]},{"cluster_id":"a5744137-28c3-42a2-94a7-6f90f74e8a86","members":["a4a77ccd-9f42-4633-a11f-13e95e7fd6d0"]},{"cluster_id":"60b95622-d70d-459f-9ef4-53d53c239154","members":["2a6c92de-99b2-4e5e-8618-d3097c99ff5d"]},{"cluster_id":"98a5a190-c887-4ce2-b53f-011c39183ade","members":["1b92e69c-30d7-4aab-9caf-027682c0f685"]},{"cluster_id":"99b20734-bb32-4aff-b60b-a976139937c2","members":["9b42133b-cf29-42c8-b877-34e158bd928d","01440c79-b4af-435a-b2d3-9f6e68d2ebad"]},{"cluster_id":"5b0ba6ac-d65c-49f0-9ed7-62610378c0e1","members":["af5ce828-ecb0-4b25-98ec-a073e63c0268"]},{"cluster_id":"fd127341-6938-4e10-8b5d-771537846e8c","members":["f09a8f81-dd52-4d4a-9570-5491befa2a8f"]},{"cluster_id":"9f69b38a-0ed5-48e5-ac15-7f5ccfedc99f","members":["92e48c53-cdf7-4f84-946f-ac5adcbdd891"]},{"cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","members":["76ca2ffa-87aa-4737-829e-cc18600a8876","d49f1242-551c-4681-88e3-48b841342491"]},{"cluster_id":"4a817862-6fa5-4e7c-8998-977aaad70250","members":["e2f3bbec-8541-4429-984c-cc8a9e76bda2"]},{"cluster_id":"cb7188de-21fe-4631-9d3e-697f1fa246b9","members":["898b4b67-6431-4909-b142-2dda0251889e"]},{"cluster_id":"636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd","members":["4824b6b2-aa5e-4068-8799-3a75ca4e3b50"]},{"cluster_id":"464aaab3-50a7-44d6-8c7a-bdc722ee9f18","members":["b0d9dc0c-0877-48bd-b103-1c083b7b4875"]},{"cluster_id":"b407290e-0e65-4bff-90dc-c2ececfb37ab","members":["b4c58eaf-eb3f-48ba-b081-0f97d60df67b"]},{"cluster_id":"17be823a-a533-4e33-9ba0-969c3b8ddbd0","members":["e9981269-f7c9-4625-9b7b-988f7f6e4ba3","75a03f36-1521-47d2-bc3e-52f932e91ec6"]},{"cluster_id":"626c75be-9b85-4ac5-97e0-e03b79d0191e","members":["bf2c855c-eb7d-44e5-b5fe-720972907414"]},{"cluster_id":"d3777022-58bb-45d2-9153-3e33e4a367f9","members":["86f36e67-beb8-4a42-a030-2cc80150100d"]},{"cluster_id":"e2676bcb-4f6e-4d98-ba58-3d2aff04d940","members":["d793e6a8-97af-4229-a114-e6ecc6f0abdf"]},{"cluster_id":"3d1d7e4c-d40b-4ec4-9450-9fc635a45afd","members":["cf4b4ab5-e024-4963-9e53-684e4e1f377c"]},{"cluster_id":"be3c4edf-6251-45c4-b310-ec9b6650b95f","members":["5416a7a8-6006-48b8-8076-7eb615d10765"]},{"cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","members":["ecd6420a-6280-446f-8516-ea47473e1bc4"]},{"cluster_id":"3d545073-748d-4207-8e53-2f9ae214848a","members":["0bf57117-f8d0-4da8-a7d6-7a414366d8d1"]},{"cluster_id":"3dc0cbd1-b381-4df2-846d-e07147e83cbe","members":["7b9b4cf9-59e5-4fab-bd12-349123ec46b5"]},{"cluster_id":"08f66922-af24-4cf8-ae47-3d7a8d80fec9","members":["c6386624-3e0b-4641-a3f2-812f177da49f"]},{"cluster_id":"4b605940-f896-4b59-bf12-36fbeec83b94","members":["fb147f68-fa76-40a2-90df-f4b00b9c712c"]},{"cluster_id":"cbe32f56-0dc5-4870-8a2a-874435ed2ed9","members":["a8994599-1956-426c-85b4-a903f194b187"]},{"cluster_id":"8fed35fe-4af1-484a-bd4d-74f9fac960c8","members":["38b53111-629e-4701-964c-d5a98dab0b48"]},{"cluster_id":"f3735996-484c-447a-8fe4-4cd5c645a0a9","members":["21ab5123-456a-4440-9bbe-73d1fb8575f3"]},{"cluster_id":"5e3e9898-c954-4e10-be52-6e36f5b36c5c","members":["50261868-0760-408c-847e-db061e167d2a"]},{"cluster_id":"3b1124a1-83ad-4acf-aefc-fa570a669706","members":["e52bef89-83ca-49da-8cbe-7dc95e29b77b"]},{"cluster_id":"88dffe0c-cf6a-4d54-b70b-1d2c41a95f47","members":["5326d90b-c708-46d2-ac2f-4c3538990e9d"]},{"cluster_id":"304f9508-2cf0-4ef2-b524-7a5c78978d94","members":["f9c88fc1-bfad-4629-a9bb-79734eaee82b"]},{"cluster_id":"de15f7d6-5167-45b1-bad6-235dd16ae15e","members":["7fea8be9-3838-4114-8b5e-c170a507a2cc"]},{"cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","members":["36f017c8-f887-4fef-aaa0-3d76d2d3ffaf","73540cd3-dc5a-4e7a-b48a-87b447fccd37"]},{"cluster_id":"ad1e5e4c-10d0-4756-a4c9-29132a1c66dc","members":["07d5ccad-b012-4006-945d-684f26fb7453"]},{"cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","members":["b0a04d0a-f88e-440b-9162-46d25831ddb4"]},{"cluster_id":"fefd3acb-14d6-4c0d-ac4a-19da8e48bc75","members":["f9e063d5-7dcf-41b5-afcb-04878ca726ca","f2e65053-2d71-4b6a-9137-3d0a10b89f19"]},{"cluster_id":"664823cc-3309-42a4-9224-e9eaa7ee3fe5","members":["ef854841-2805-4237-a8d5-6cd7b7936870"]},{"cluster_id":"39f5f705-55d1-4470-8928-bfce04d4f7be","members":["fa2b9817-fb16-4e1c-92f0-db463dc26a73"]},{"cluster_id":"c03b0c98-53e3-4757-8e78-30293d823fdb","members":["82024663-672b-4205-9001-5efad1525661"]},{"cluster_id":"aa4340e9-32f1-4ade-ab1e-eae7e384d7d5","members":["7b636bf6-2231-4d09-a5a5-a2bc207be079"]},{"cluster_id":"cb239c20-3722-49db-94a4-29c15a45d8b1","members":["4ff2c46a-29f2-4b6a-972b-ca8feecf0dd4"]},{"cluster_id":"06da14b8-536e-4d2e-83b1-118cfb44829b","members":["43494523-f6c1-4d5d-8eaf-20c099381363","651fa07f-027d-4660-9414-920e8e11c88e"]},{"cluster_id":"7cacaa03-4763-4931-91bd-306a3231361c","members":["1e6ef59b-b97d-4bbe-baa9-9dd55b985cfc"]},{"cluster_id":"c3383556-4a09-4d9a-b202-b1b017162bd3","members":["7ac18437-d326-4a31-92d1-f6c4b9f3acc4"]},{"cluster_id":"71a82b79-aaaf-4fee-8e73-d292675a2e3a","members":["341b7583-7cae-4ae6-95ac-e11dcc0e29e1"]},{"cluster_id":"758ea826-ee1f-4a18-bdaa-e713f20f5573","members":["f41216bd-b2cf-4575-9949-f27343ea781f"]},{"cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","members":["a2b312fa-88d5-4614-8069-bf3ecf3de787","2a34a81c-7f8f-469d-b3e2-0ae4bd923626"]},{"cluster_id":"f75e1405-c093-4f18-a3c7-d59d8bfe94d0","members":["084a5e5f-4ea4-4a61-b599-9e39c1069298"]},{"cluster_id":"b6c282dd-0c14-4dab-a6ce-3f5caafc52b8","members":["6aaf8382-3a8c-4bd9-a1f0-00751972af02"]},{"cluster_id":"9398c496-5e62-4d1b-94c1-e1eeaf48778c","members":["ae8245df-51af-4469-9186-e7dd7bf76c40"]},{"cluster_id":"2d7a7088-3ced-40a0-9677-1d14e1c26d8f","members":["bbfb8767-23ec-4520-8e1c-be6dd2ab6d86"]},{"cluster_id":"a1593cbe-8c39-423f-abae-2707e84a1e5e","members":["77e3123c-bcfe-4e1b-b4c4-4699aa8c7a92"]},{"cluster_id":"04a0ae4a-7a1f-4b83-aea9-9fb4dfa80e1a","members":["a09cfbeb-9296-4296-8a6b-cccd5211b0b4"]},{"cluster_id":"24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca","members":["116d1290-adae-4a0c-afde-ebe2246e93f0"]},{"cluster_id":"90cb536f-af14-4df1-9bdd-da6d690522b4","members":["45ad6727-3b1d-4f45-86a5-853b7d2b7e74"]},{"cluster_id":"d6b6cc03-8c7b-497a-ad1e-0435bb03fbcc","members":["db06a8e5-9666-4016-a019-7b509c500925"]},{"cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","members":["1f058c8c-08ac-46ad-877c-0208691256a3","e0a8a269-5e6a-40ca-b2d5-cae2eb3ab4f3"]},{"cluster_id":"0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff","members":["6bf545cb-3bff-4ddc-8f89-114d02659460"]},{"cluster_id":"4c161c1e-d86e-4fbd-9e49-e99d43b2eedc","members":["3c5f8517-91df-41c8-8459-0d77c6dc7d7e"]},{"cluster_id":"51f9e6ae-7c8a-46e3-8fa3-070377ae9030","members":["da2a8837-bd8a-488f-b164-1c4fae90ea79"]},{"cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","members":["a76a4188-0e42-4ace-8773-87e990cd6889","19b94fb9-4b53-49f7-a541-698272ac5600"]},{"cluster_id":"2b132e72-8cc9-4107-a55f-19ac99e2caf3","members":["eb148cdc-958c-4243-8ce8-3c11c0a12781"]},{"cluster_id":"95ba204b-d839-49c0-9233-3f2add81da86","members":["dd3c8ab9-8224-4615-94cc-d1f1cb267c2c"]},{"cluster_id":"749b3ec0-39f9-4e3b-bcf2-7f9377d72178","members":["28d22d59-1bc2-476b-9215-4cdcb989a85d"]},{"cluster_id":"4eb1a4b5-b71a-4034-93b6-28860ce56821","members":["e9eefdee-16bf-495f-a832-ee0139b509cc"]},{"cluster_id":"7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1","members":["c75d19d0-b827-4f7c-b170-1ef7d2a1981c"]},{"cluster_id":"755e1910-15d6-4530-b0f7-b73a35ac9c64","members":["f9c52047-618d-4331-88dc-f291d6a4ce80","3debbefc-996d-46cb-a12a-4ac0af7f86d0"]},{"cluster_id":"89d92c43-6368-4ce1-8b52-63274b65d5df","members":["bc454b72-954f-46b7-aade-de6e5b24af23"]},{"cluster_id":"cf33198d-096c-4e25-8d65-13fe91addce9","members":["13af3e5a-4df9-47c5-98ee-bc08c1c5913c"]},{"cluster_id":"9f14caef-27ce-4bca-afff-6e691839a8df","members":["4dff9410-a9bc-4ecc-a307-76f78973442f"]},{"cluster_id":"dd5d0634-bc30-45f9-b45a-97773c63db2a","members":["c92e9220-0252-4c02-8acb-b3c2083cba47"]},{"cluster_id":"a0209bc1-2ecf-46c2-8b3d-8258fc85b6a8","members":["c96c6387-3f57-4c7f-a8e8-f0e06f5e9739"]},{"cluster_id":"73dcede2-49d2-4bc1-a599-b15a7d0094cf","members":["3e3e514f-a344-49e3-9ae4-aa583531de37"]},{"cluster_id":"763dcb28-8161-4ef1-bcee-20cbd6af7670","members":["790acdda-db12-4c6f-8116-86ea91021854"]},{"cluster_id":"1f8ca860-66b4-4b57-a63c-e13332662c2e","members":["5d722fd0-ca08-44f7-a983-221076de71b0"]},{"cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","members":["f96b20fc-1ab4-4491-b9f1-630b04cbe616"]},{"cluster_id":"4b037322-86a6-4af9-bfe1-49f968f04baf","members":["5f8731d0-460d-4542-8385-9bcb6bc5981b"]},{"cluster_id":"e0c5a85f-7145-4366-aac8-58cd212f7e6a","members":["b2c9d261-a6a2-4709-a811-9be31d2f457e"]},{"cluster_id":"bf76e0b1-c54e-4ab8-82d0-979d68c35a65","members":["6a9746d2-5c0b-44e5-a69e-6b27616cd607"]},{"cluster_id":"1450e6e0-be6b-4ab7-8d94-7070623cadb4","members":["6295178e-d150-4ad0-b2b4-bde698a910b4"]},{"cluster_id":"d67b58dd-cbc9-4a99-aab7-b31e7a922343","members":["1487337e-caf6-43ec-972a-52a6255f4bea"]},{"cluster_id":"9747ef56-b31a-4050-8bc2-6df45c0ffbd7","members":["c98ab273-00fa-4c64-b3ca-2a928745714e","95737f58-3e4b-48c3-be9c-d7ac586f92ab"]},{"cluster_id":"d65bf625-e91c-49ac-a498-dc2e95df1f93","members":["3d5c69d0-3692-4fd9-a879-931941f5f802"]},{"cluster_id":"5f10e7fa-9adf-4e59-961b-ac04facb9f2b","members":["a7959296-3463-4b6b-ac53-a3b5e6f20c25"]},{"cluster_id":"84900de4-4822-40e2-a41f-f9013bcc0bbe","members":["46dfe14e-2446-41b3-8747-a3a01d5aba71"]},{"cluster_id":"3a1f2987-e024-4481-9d2c-9a6882a3fb9a","members":["8d8afe95-d204-4f32-bd7a-b64c673c9a80"]},{"cluster_id":"2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6","members":["bcd2ffe8-1e6d-4dcf-9357-644c21234bcc"]},{"cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","members":["6cdd0296-e032-4a5c-b6dc-7d6233af6947"]},{"cluster_id":"ddd4b5a0-2eee-4ff9-bb50-de940c2541e2","members":["872e2a83-256e-44e0-9dd8-4401545586db"]},{"cluster_id":"6778e0f8-10fc-4d30-8039-d81e67c9992c","members":["ff1d84ad-9d70-4739-8deb-adf84694c761"]},{"cluster_id":"63fd0e17-6b29-4f19-b984-a861fba2eb14","members":["538fcc42-d402-4e1c-aa53-1b48fd92e7bd"]},{"cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","members":["e8bffc79-ebb0-494b-8a55-67a20c377fdb"]},{"cluster_id":"2da1e2c0-6b7f-4a59-bbad-c83252a70f91","members":["566193e3-aa65-4122-bb4d-3d4d7a216c13"]},{"cluster_id":"0a4b2521-caa9-4365-ba6f-ee42c89824c7","members":["2bb8aa19-18f7-489f-adc2-cb4407229de6"]},{"cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","members":["ac72e986-3f42-4894-a51b-3f463b4c4847","ea68f6bb-d8e9-4d0b-9fac-e359016c7dbf"]},{"cluster_id":"bd3c25bb-6683-4bdd-8e97-11de485116b2","members":["ec663f1d-8af0-4505-9c17-ea09a60e57b8"]},{"cluster_id":"13f086c1-e440-480a-a882-8d8a742c1d5e","members":["4cd0e4e5-8f7a-4621-9e10-b10679c29f79"]},{"cluster_id":"dcc1a857-7e25-4b1e-bb30-c67434a5f183","members":["77407c57-d36f-48f7-b5d4-3cf0ba9fc3a4"]},{"cluster_id":"0e6f398e-1206-46db-a98b-ff1425e1c634","members":["3e182aa3-750a-475f-9344-ece860104732"]},{"cluster_id":"1ae95d89-cea7-4f27-8ed8-d4f49e95c5db","members":["5896fac0-b57f-4633-97af-f0e71c90112a"]},{"cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","members":["807c7ea3-225f-45ad-9015-6b748822e6ac","7666b8ae-0dd8-44d7-b730-f29fb7e24f4f"]},{"cluster_id":"5cab19a1-9532-4ca5-8f94-e19c788f807b","members":["a0f4a3b8-e427-4208-b02c-9b5eb0b8a8cf"]},{"cluster_id":"52b4a518-aae8-40ab-8a78-e641ed7c28ce","members":["79868006-5b4b-4920-8227-9896c47f4145"]},{"cluster_id":"3dcf8216-5e70-4cd4-962e-dc4b036a0071","members":["74cbf840-383d-4abb-a196-7cc930a7b248"]},{"cluster_id":"3f09a0f3-521e-4c59-84d0-5adbf02dbf98","members":["42f04497-b4b3-4afb-9d2d-de42d308d3c3"]},{"cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","members":["0601535a-5232-49d6-ac8a-f339184b8117"]},{"cluster_id":"da33c07b-485b-43b6-8165-46193fb1720d","members":["5cda20d0-a6e6-4c3c-8593-cc0b033e9c5e"]},{"cluster_id":"c0426c3e-a327-4be7-b689-905cba5cdfca","members":["f66f4c85-4df6-43f8-a55e-eca41f06bea1"]},{"cluster_id":"84209a17-a4a4-4c15-a21f-0800fd75d6d8","members":["0e6fca58-3d0b-46e9-b950-d945afd31999"]},{"cluster_id":"d9f9cf14-d4ad-4c0a-9482-99b75f7c247f","members":["76041811-58a8-45f0-904e-d755003438d3"]},{"cluster_id":"9971c68f-8d21-4436-a5d3-4897996181e7","members":["45c0f4a0-2167-4cdc-93c8-d916583cc974"]},{"cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","members":["e623426b-f1ef-4797-b377-5be61d70af2d","bb488946-5e6c-4e91-866d-5430c56b7ee1"]},{"cluster_id":"905fb380-0de3-42c4-abca-6fd6383deba6","members":["1ccc23c1-d3ed-4fcf-9782-521addcd2f77"]},{"cluster_id":"36ed05e4-cb6f-4b4e-a07c-39d608cb863f","members":["878edfcc-e3b6-49e1-b4b1-902ef152c55e"]},{"cluster_id":"3368fed2-7688-4846-a7ac-3bfa3045311c","members":["d43d3481-5742-4c58-b1c9-badc139150c1"]},{"cluster_id":"b916d619-a85d-4cf6-9af8-c531be4fd3c4","members":["23af801d-509e-4d13-85ba-aa38818ea8a7"]},{"cluster_id":"2b47973e-934f-45a0-98dd-aacefd7432f8","members":["e4866b76-12de-4374-aa13-8007f1d044c6"]},{"cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","members":["efbf5b1c-1b5e-41b7-a8f1-62089a598ada"]},{"cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","members":["e5c14dc3-196c-44f7-a92e-381ff2a9404e","d18ea420-7fc8-4f4d-b3f8-69befdaee398","426cabef-a0b8-48c3-b48a-30b49a193166","4c9ba839-bc22-44c0-ac8c-6ec8edc75085"]},{"cluster_id":"de5ecea9-1de6-4f23-a787-2b6cd366c836","members":["ef776dbf-e915-450c-92a7-cdb90bea6369"]},{"cluster_id":"db897944-fc77-42b4-ab1a-b566912e00b0","members":["60aacdab-d3d7-4fb3-9782-d187daf68d2e"]},{"cluster_id":"501b66f7-8e87-4810-b05d-6bb95d09a79e","members":["ec042255-3b6c-48b9-b4cb-ba5cfadee254"]},{"cluster_id":"226ceb68-980d-4b72-b053-36c7b5c7f61b","members":["af0baa1b-e5a3-440f-b047-1812f1485d82"]},{"cluster_id":"1363d4a2-5ea7-481a-b7e3-3e161a6db765","members":["8ba73e30-7316-4bd2-8e27-627a554098b5"]},{"cluster_id":"163270c6-b91d-429e-9c2d-5cf8a4ff0d2e","members":["c2283ea3-0288-429d-b859-4af79cf5bfe0"]},{"cluster_id":"209935ed-d0a0-4dbe-82d8-2d7d5a2aa866","members":["0a30e6a2-2ecb-4080-bb75-910ab4a7bcff"]},{"cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","members":["9a6fdaf1-bfe1-4cd2-a54d-d21955fb6eb4","e44ced54-bbc4-4fe9-9925-086c3be735ed"]},{"cluster_id":"a0698f9c-4bc8-48b3-b669-44befd54559c","members":["3712e970-6cda-45e7-bedd-818a6e1a11d4"]},{"cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","members":["2232fd36-afdc-4f1f-8969-f02be4e9d63a"]},{"cluster_id":"36472627-9945-496e-89a2-063ceee22d24","members":["af3d86ef-53f0-4580-8880-ce57b587280f"]},{"cluster_id":"3769f810-e5f7-4d0a-9821-1876b6cadf34","members":["c8eaf52b-6580-4071-9e29-9c2cf6aafc79"]},{"cluster_id":"4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6","members":["036a2d59-d909-4bb5-9f34-5ef7c0deac6f"]},{"cluster_id":"61fac83f-0dd7-4c15-88bc-e40fee962783","members":["cb3af57e-49b2-4874-ba84-c7d384dec42f"]},{"cluster_id":"ba6f293a-cb12-4697-ba51-b7964934f25d","members":["989cf3db-1df9-43c5-a742-683491db2209"]},{"cluster_id":"42314335-3518-45c0-909b-96111c0955f6","members":["184a591a-6388-4cf3-8aba-ee33dac18ee4"]},{"cluster_id":"22c13a77-51bd-41df-afeb-444adbde288e","members":["442a9332-d235-4c4e-8005-e099521eb2d5"]},{"cluster_id":"90c28686-07e5-47d2-8675-847924fbe9c3","members":["46403870-19ff-4ad8-8ef0-14f1f2d46780"]},{"cluster_id":"bc48e3cd-6317-4a4a-b06b-f8629ebbbbcd","members":["8ca5dd5c-0d80-4823-82d0-3dc17b6c640b"]},{"cluster_id":"3eac5298-75f1-4e1e-94ec-db408d17729a","members":["b5b0acb6-0c0e-4c74-8cd8-c9934226037e"]},{"cluster_id":"64599826-faee-4fcf-9432-967663d05451","members":["839cea27-8092-4523-827e-6d8fbc40ff8f"]},{"cluster_id":"d3ee5536-f1ec-4a1b-9b1a-82ff92aa04a4","members":["e6c7fc38-eaa7-401b-b455-e32295ee969d"]},{"cluster_id":"c8265999-6e3a-4835-bb5a-9e081a27e9bd","members":["9ba58870-e662-45a5-beae-091bfa16e49e"]},{"cluster_id":"a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd","members":["808f70bf-16bf-40a3-bc4e-ad826c69f05a"]},{"cluster_id":"d602e1f1-5446-4c60-aadc-beabd56dedd8","members":["ceb27820-5d30-455b-b348-a5ae9803d431"]},{"cluster_id":"7553f34f-d61f-419e-8976-cecf89bafb0e","members":["9e987e03-e570-493b-a318-ff4663b45779"]},{"cluster_id":"3b7e3ce4-4e60-4c09-986c-9b9376d80c8a","members":["cabce7be-e46d-4bbf-bda0-e2c027ff8945"]},{"cluster_id":"3ea1c92f-805f-4ecb-b23d-a77a7a362e5b","members":["1ecda97a-611c-48d8-9ece-7a0b19668b9f","cd85dca8-d905-493d-aade-b80a44a8fdfb"]},{"cluster_id":"5cd897af-cb8c-4335-a548-c9963c43f060","members":["6219d853-203f-4cd8-a7ed-eaccc37db4e5"]},{"cluster_id":"3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8","members":["25525cdf-c733-4a85-91ab-f2adc6192748"]},{"cluster_id":"02dd8817-131f-4c62-a0d0-fa32952b2e01","members":["ecfc4818-605c-4c8b-91a2-04ed27c8e3cb"]},{"cluster_id":"4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9","members":["f8b32d99-e10d-4e9d-b2cf-02d421202d9c"]},{"cluster_id":"b4a81fcd-1fa0-4fbe-88f0-692419c6082a","members":["a53beda4-d9d7-4a1d-b20e-c55ef5fdc365"]},{"cluster_id":"c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf","members":["9dc49aa7-fb08-4c49-ab0d-d233037511f7"]},{"cluster_id":"4bc5d44b-029d-49ff-82cb-bbcd84067673","members":["9afd40ce-83d2-4ba6-b3d4-846849c4f834"]},{"cluster_id":"59e6bbb6-5982-4df0-b59c-33f07ce159f4","members":["55d2779c-e217-438b-a824-b709c22a345c","7593089a-7a8e-4de4-85ef-a1426aa3cff9"]},{"cluster_id":"954a4240-7358-4649-966c-6f08bf5b088e","members":["0dfab435-0854-4cbc-ad80-25e02d0ed5b4"]},{"cluster_id":"99892bd6-22b5-4bc1-bade-41a91e788227","members":["012f7414-c063-4bb0-821e-03ae3200a374"]},{"cluster_id":"5900a7ab-7cb4-45d4-8807-d20dee337670","members":["16679f67-f92b-4c97-8b93-52f58e61267c"]},{"cluster_id":"fc4ce4ef-b019-44c8-8060-59b10a33a92b","members":["4a4dc838-cdb8-4cd2-a8e8-b7565b489463"]},{"cluster_id":"8a0accb4-caf5-4741-9038-3360a1a08c25","members":["5bd060ce-e57a-4b9e-8ce7-adb07d86cbe0"]},{"cluster_id":"fd3ca8c5-bfa9-4e66-bc57-721306073eb0","members":["a367c419-5c06-4d96-b3aa-e68d07bfe89b"]},{"cluster_id":"c3dda95e-e922-4b18-b7fd-9f071350fa6d","members":["f56313c6-4c1b-41ae-abb7-5b3adcd6fcda"]},{"cluster_id":"746179fc-962b-4500-916f-ca22a3a202d9","members":["2db09ac7-7480-488d-95a4-cd52c3d6852d"]},{"cluster_id":"7686685c-6e82-408b-a7b9-2e453038450e","members":["76c5a892-9eec-44fb-b18a-8dc8f6ec54d5"]},{"cluster_id":"f7fbb95e-08d7-410a-8e1f-290e984463d7","members":["c2f9ead9-e144-4a77-a370-18b0e465aa10"]},{"cluster_id":"fa9ba14d-4628-4fac-b94e-953f493cb218","members":["0518a0f6-d6fb-445b-a6b2-de32bb4966d7"]},{"cluster_id":"380726cc-73a4-4dde-ac40-f10c2a1f6e60","members":["87b8a5d6-25e2-4a58-b32f-2b9fd63d7259"]},{"cluster_id":"ae201524-ae4c-4b92-afa7-2801ac429060","members":["ab184fe7-413c-4714-9a1b-9f2c04d1ded4"]},{"cluster_id":"5d8665ac-7337-470b-ae27-2d46610e9f97","members":["c4b7ef6a-e82f-45ce-9dc2-1ef84742ea6c"]},{"cluster_id":"b7e33865-58b2-4984-a7e1-eed1512539bb","members":["21557975-8f55-475c-9113-1599cc88d48e"]},{"cluster_id":"44d600b5-1259-4b0f-a45c-73f5507156e1","members":["87c7e218-1700-44f0-8a1e-ccef92bb6df1"]},{"cluster_id":"66cd9492-ff5e-477d-9ab7-967722c94dcd","members":["346f5eac-8083-44de-a2a5-c22b0a3c68b0"]},{"cluster_id":"25934933-94e9-444f-a664-f57c4cea7d17","members":["e4b05630-1cf1-473b-9935-4d9df2441747"]},{"cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","members":["59db8bb7-8c32-4cb4-b93a-9377f27e5bb9"]},{"cluster_id":"12f1ab8f-20c6-41db-928a-d52afb8bd227","members":["867c8371-61c7-4133-9fe0-a60250a5dafa"]},{"cluster_id":"a45b0120-f89a-4fb7-9d30-32c67bc23fc9","members":["7d1184be-08c7-4303-bb74-bb6301ab3676"]},{"cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","members":["3f363d10-544f-4a29-bd9f-7e7a84fd3014"]},{"cluster_id":"ed9c7f02-d3d7-4f88-92df-80c91b7dca98","members":["992e777b-2d2d-4164-9166-21819ed67314"]},{"cluster_id":"61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc","members":["67d60464-0d44-475b-a6ff-e2ba49d1366e"]},{"cluster_id":"a39bfc74-5364-4583-b4c6-2ba30e1ddbf9","members":["e57ae7e6-185e-465f-bf0a-b4ae49ea0b5b"]},{"cluster_id":"4b37762b-26f0-4956-9d1d-e433973602e1","members":["28d0a5e2-e288-4da3-865d-b61255d8b0a2"]},{"cluster_id":"732c6dc2-1231-46ca-b1c1-173c0f488176","members":["1d882ab7-3448-4e70-aceb-c9654f71e66b"]},{"cluster_id":"4f1efe8f-fe00-4658-8994-d5332d4cc9ed","members":["6e785240-8ffb-4abe-a014-d7a8b7f6fb74"]},{"cluster_id":"99955509-35d5-4623-b165-0b6dc4f83f23","members":["3bd375a2-f60c-4e67-95d2-8dd33dda54c4"]},{"cluster_id":"3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8","members":["a6a36d51-bf43-429e-ace3-d335b25e878a"]},{"cluster_id":"563140da-8f58-4b64-8987-47bb018b6821","members":["d365e127-d27c-4834-a1de-fc0930515ddd"]},{"cluster_id":"00cfa90d-eff5-4498-89d6-85dadca46eb8","members":["ebf98039-232c-4282-8676-4453abfe60ac"]},{"cluster_id":"54017113-d014-48fd-b57d-6cf55f5a8ff8","members":["b8b3465b-e078-4efb-ae6e-e6a1726f2fa9"]},{"cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","members":["b0ba9c40-a67a-46d7-b196-e03f3c5aaa9c"]},{"cluster_id":"84874fe9-a25d-4d9f-9765-de9280d477c0","members":["41702860-e9aa-4135-bcb7-e01f4817b34d"]},{"cluster_id":"f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f","members":["ae993dea-9d4f-41e4-9864-aa6def24b890"]},{"cluster_id":"818fb1f8-d14f-4997-8e8d-f7e228560c99","members":["82223086-44ab-4f8a-bb20-2469fbc0fe5f"]},{"cluster_id":"d0619b32-28c7-4624-9e6b-8c81d9ff9019","members":["6ae0e573-7a63-4ebf-8915-b6673547e7a5","b61d27b5-67be-4aac-b991-4c463d94cb6d"]},{"cluster_id":"82cf1bd1-8182-4744-8fc2-6d5af2292aea","members":["1cbefbd5-9c0b-427d-bb6e-c17b315e53bd"]},{"cluster_id":"b54d16d2-d5db-4746-b15a-e8c01d4fc586","members":["0bccaf8d-81f8-4dc6-a43b-f49b0a453569"]},{"cluster_id":"e684bea9-83ef-4337-93a3-80b8a3708ae0","members":["11066e29-dc62-4fd0-83f9-58da50d5bc4d"]},{"cluster_id":"3e9990d1-ada6-4c9b-b2b3-e8220e956431","members":["66083cd8-4f78-4c40-aaea-4e52211f0454"]},{"cluster_id":"2712567d-2895-48f5-8695-f726eb795979","members":["e37a656e-2b55-482a-a4d0-7e3cc66ebe0b"]},{"cluster_id":"291e098d-0f3d-4fff-9906-3b21ed1a33a1","members":["05bdc8cc-dd35-4620-a59d-ec3c72ed2731","57a25bac-e26f-49eb-9426-9fdf3ee70d6d"]},{"cluster_id":"f96435db-3d9a-45de-8398-45bc9dbd4fc0","members":["65cbc702-99e8-4621-8a81-899b350a7a83"]},{"cluster_id":"652f1be8-25e9-4267-b7cc-e5ecf9e7919b","members":["7b229a8c-d88f-46c0-b447-c58879a2e92e"]},{"cluster_id":"e4f4246a-95d9-4d67-94bf-27725af4d71b","members":["7a9d517e-5f42-4e1c-8c54-b33b67939c08"]},{"cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","members":["e33b45ec-40c9-4bac-a8d9-ffdf4be25ed0"]},{"cluster_id":"5ef68f23-0f9c-4c57-af44-b6d2b7f6107c","members":["de88b89a-982e-47ea-8d7a-c0b2fbd6dabb"]},{"cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","members":["26d73c11-429e-418c-917d-8941d43cf025"]},{"cluster_id":"a0fb284d-9ce5-4422-a3d9-508052dde7fe","members":["a3cb0615-5ec8-4cff-ae0d-afc22f1c70c2"]},{"cluster_id":"d9366872-6ca9-49e5-9e80-86c5b954d463","members":["225bd941-a6dc-49cf-af65-19811da32bf6"]},{"cluster_id":"b840591d-33a5-402e-9f7a-8913292b283e","members":["20dc25ab-5389-4dff-a43c-dfe9d7bfc7ce","c0017158-5ec9-4fbc-8e2b-e5be9bf948e8"]},{"cluster_id":"83856113-7cf1-435d-bc2c-d1c5e5e5c106","members":["a15196b8-40cf-4a2e-9b8d-b3d7e099060c"]},{"cluster_id":"f690f627-f1e3-428b-9d01-bfb966953069","members":["a8f04bd3-0b9f-4afc-9958-ee3fd9b741a1"]},{"cluster_id":"fce90f87-0664-4b8a-bb4f-dc7bbf08cf50","members":["3992463a-fde6-4ecd-b942-29d355ec638b"]},{"cluster_id":"17ea1514-c948-487c-83ee-722001d6184e","members":["d465212c-f927-43a4-9067-b9959b145c98"]},{"cluster_id":"d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a","members":["8dd89c11-2e8d-425a-b0b7-0d1e37f27418"]},{"cluster_id":"c8b9924c-3cce-4d36-afc2-f686b12770db","members":["46def0c8-57f7-4a96-b04c-91488bfcbbe6"]},{"cluster_id":"72276ba3-4193-4153-879a-b2c7cdf39af4","members":["01d537f0-cceb-4074-a220-f7352b73d9af"]},{"cluster_id":"58a44cd6-3f44-4460-9d07-d5a28bd55747","members":["3eaa9fd6-d488-4d05-bb97-db904c045b1f"]},{"cluster_id":"e5736d52-6864-4a19-aa95-57d6bbe8f40d","members":["6834f333-8ff8-4fa0-830a-d95ad9536868"]},{"cluster_id":"89360ae3-18fa-43f0-bd2a-417e02e051c5","members":["34d3a385-3440-4419-813f-5a6f201b8e8c"]},{"cluster_id":"cf8a7c88-fcb8-4b8d-aadb-46cb3168db25","members":["3b05075a-6249-4034-8d5f-0b4b61ae375e"]},{"cluster_id":"21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb","members":["9b905695-6c43-4956-b510-5ede2c0cadea","c9aca791-24e8-4105-8a1c-f43879aca0e3"]},{"cluster_id":"39caeecf-930f-43df-a6d4-e237146a33a8","members":["9edfd059-7cba-4282-b685-3ff4a5c6784f"]},{"cluster_id":"db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f","members":["1c5f3940-618f-445f-8bae-498cf3a57328"]},{"cluster_id":"83176725-df79-43f8-b571-b45c6b2dea8f","members":["5187f6b9-b01a-48c8-a5cb-7b50f59b98cd"]},{"cluster_id":"144fa955-73da-4f76-8472-31c3ddd2636d","members":["7c020a8b-3a1d-4bf5-9b2b-f68ed67a83ce"]},{"cluster_id":"f18ec76a-50ba-422f-9d7a-596708b1810a","members":["0097c1c4-91ca-4efc-9c12-92cb73fe1d48"]},{"cluster_id":"0eef7600-1d71-4d26-9e91-3c6e5b0c6121","members":["fadaf7a0-1951-41a0-be28-ce7cbbfd2e13"]},{"cluster_id":"7893fdb0-a005-4beb-b22f-fc8ce5bd706e","members":["75fd2ea3-890e-407e-bc4e-bb4dcffb1d52"]},{"cluster_id":"4a277b87-4d75-4b75-9416-adcbd06c3a69","members":["7d63bb14-86c5-4e7c-9908-d12838f5a1e2"]},{"cluster_id":"fd305e86-cd2a-4329-a45e-739147206ba8","members":["53b2073c-0f69-4c80-b1f7-2216bcce8ae6"]},{"cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","members":["efb2f3a4-4a6f-4b82-891a-6e49b2a5f523","485705b8-64f1-4937-b4c1-475d0bf42370"]},{"cluster_id":"9d4328c2-e9a9-4e75-b63e-6e88d7b536f1","members":["f5b4fc6e-6e89-47bc-924f-48d1652def42"]},{"cluster_id":"717225a3-f2cc-4921-bece-db76c2709d99","members":["e7a172a6-e210-4871-ba5b-5beab36f133e","79bf234f-2f4a-4563-8307-083e1161440a"]},{"cluster_id":"58953090-5955-480d-95b2-311ed2c0f653","members":["4afb68a8-bbcc-4e8d-af34-d5edf6095e82"]},{"cluster_id":"d26e1561-d7b5-4c15-bc29-d5ba417f64ca","members":["46b182ba-f8b0-486e-a971-d6d8d29dcfef"]},{"cluster_id":"0fc06cfb-3a25-4176-a530-ab9cb52f7632","members":["2469a626-6d12-4a3f-8609-e8853ef4366b","c3f6e2a2-bf0a-4eb4-88f9-8603500d5674"]},{"cluster_id":"7fbcd1a7-a676-46b6-a3c0-af823173a2b1","members":["3eaa4b01-8d12-46ab-ab47-1870221edd96"]},{"cluster_id":"32bf3674-86a6-4cde-a9e5-20a5e3965e02","members":["246ad0b2-a33b-4452-9680-a021c86e97e5"]},{"cluster_id":"218a3fc7-ac76-4428-aa52-1f315a03667d","members":["37499fab-2fe7-40bd-b11e-ab87731202f7"]},{"cluster_id":"e7a1e23f-832f-432a-ad19-207015a794b2","members":["91a4d43b-edc0-49ec-b3bc-3867f659b730"]},{"cluster_id":"bfd9a248-bf68-4994-8af5-882efd424687","members":["189f80a7-6ff9-4b7b-903d-887d097cff2b"]},{"cluster_id":"e64bcf93-086e-429d-9ff7-3a1518b3ae51","members":["6a75e685-16dd-40a9-943b-267048380ebe"]},{"cluster_id":"4ada70f8-8bb6-4995-8f14-e79e769b0629","members":["f0a2c749-6388-420c-bdf9-1c4ee803e96d"]},{"cluster_id":"47a61e0a-9230-4c4c-962b-f6724c066435","members":["fe728252-2f9c-4815-b02f-7699b2550a2e"]},{"cluster_id":"162f021a-53e9-4f3d-9231-108223f18e9b","members":["d7aca388-acbd-4f7f-a855-c7d5c20fa685"]},{"cluster_id":"9e96a51d-6101-42af-b7a2-54e4dd5ae715","members":["429e49d4-f23e-4cc2-a86b-ee2c5103945b"]},{"cluster_id":"47cee9e4-a547-4914-b31f-89a4963c7d37","members":["c8ea9f81-466b-4497-b45d-3223d1ee8247"]},{"cluster_id":"770cc261-67a7-4ed4-85d2-93916689a978","members":["72eaf4c2-1ace-4637-a279-69574883c8d2"]},{"cluster_id":"9fb5216e-3d0c-403e-a2bf-9368fa3e3592","members":["465bece8-37d9-4e52-a1ec-faf9186dca40"]},{"cluster_id":"199ae7ec-217a-4cab-a030-ff0a4838c0a8","members":["3a116cf1-f864-46f2-91a3-8becc0027791"]},{"cluster_id":"3232bd90-9251-47f0-ae93-ae2d51218354","members":["a587e2e2-5f98-4b88-911b-409af3406d82","b49be27f-cd32-4e61-8e4f-45de2432e05e"]},{"cluster_id":"159421f9-fc35-4e25-a688-4ecf97e146b4","members":["b49e3698-2d1f-4006-93ae-7a09a858e833"]},{"cluster_id":"ae1e52fc-461a-4609-8b02-2589611c162e","members":["6b2476c6-a052-47ae-a228-56b6f553ca74"]},{"cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","members":["fd8ab294-5b27-4e9c-825b-ec44b6ba1867"]},{"cluster_id":"e7f02350-e0f8-416a-a3fa-4d7dfaaa5615","members":["323c6763-57ea-48ee-87c5-c6eafc928cae"]},{"cluster_id":"1c220b25-802f-4053-89c5-d8f4805341a5","members":["c4274737-78c6-4b47-a485-ba7aa9e58eec"]},{"cluster_id":"88ebdccc-4a31-4f1b-a74f-989ab096e08f","members":["b71c4569-f760-4ec8-98df-cec6d9c6793f"]},{"cluster_id":"3249ee55-684b-4bbb-8b52-6766f62838f9","members":["7f7a99d7-4cf6-44b2-b0b6-0de0e235dc3d"]},{"cluster_id":"c830c75d-93e2-4842-b468-b89a47252719","members":["4dc63b6d-f7f6-4201-81db-2a5e9c6a5198"]},{"cluster_id":"746a6f97-55c7-4dc9-ab6a-cc007e33449e","members":["5bec62cc-de7e-4032-87af-d61602c98417"]},{"cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","members":["a164e5e1-6c36-4c70-b5c6-9787277d7cf5","b557e313-9c02-40c5-b077-13c10297f514","e0de3107-736c-462b-88ca-80ac07a22385","c53e0722-31cd-4216-b4ae-898a6c808315"]},{"cluster_id":"b17129e4-a0b0-4a1d-a70c-02e08bb380d1","members":["23c7ac75-736f-4aea-833a-28c03650c893"]},{"cluster_id":"66e9edc1-c40b-47a3-96e9-eebc44c63b9c","members":["0b283a06-4ee5-4503-bfe0-9b2beb8081b2"]},{"cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","members":["bb8efabd-a8bb-4e5f-bd1c-fd5a7bc57468","87aed28e-ad53-407c-a04a-af3b0e1015ee"]},{"cluster_id":"f8618eda-effd-4eda-b2ad-66d8fec0ba02","members":["59410815-11d4-4a2e-9972-0e45092f256c"]},{"cluster_id":"cce124fe-f108-4571-9074-db48a458127d","members":["0162d47f-70f8-40f8-a6d6-321e1f67464b"]},{"cluster_id":"8b8d3259-7bca-4683-902c-7b72552f88ab","members":["953328b9-1c72-4ae1-9261-3d122cdf3d99"]},{"cluster_id":"698d5e91-6aba-4224-9583-f0b9f9330723","members":["d1122fc8-22ba-49ee-b1a7-b0292caeea93"]},{"cluster_id":"d1292088-fa7b-4c5f-a6b8-d1bbb1dc9eae","members":["e048a637-c913-454e-b38a-9e567b3309fe"]},{"cluster_id":"55f659a1-e5dc-41c5-8a43-9846f564af08","members":["1b2b8340-6e26-4af6-99f1-7a2fe4c25820"]},{"cluster_id":"ab0a6f16-1446-472c-af45-f55c0d8ddc3c","members":["8f2585bf-bc2a-41f3-af10-5a7cef3a2716"]},{"cluster_id":"59e7addf-52f2-469c-800e-61bb55f3ed47","members":["7494523e-d14d-462e-8096-f2fcaa9cced4"]},{"cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","members":["363767c1-812f-4b42-8491-a284197694ba"]},{"cluster_id":"75e57a3a-a55d-4c36-b291-226154171396","members":["86364755-d394-481c-8c8c-312bdb7f9789"]},{"cluster_id":"09907625-9889-4def-8ff5-b61d82ce4a21","members":["60692431-97b1-4bfb-bcbb-9d32815dea0b"]},{"cluster_id":"834f4385-ef2b-4b12-81b1-8e94ff3098e8","members":["a9100648-867a-425d-b31e-08facd6d7ff9"]},{"cluster_id":"c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333","members":["0756090e-6ed5-4879-ba64-2fa9f664c398"]},{"cluster_id":"9477ce9c-5a6e-4e61-9f13-cf68c95b219f","members":["0a153042-81b8-458e-b186-8360e0fbc2b5"]},{"cluster_id":"0c265597-6c2b-4efe-9acb-799f67a3b4d1","members":["a5fa33f1-9c5c-442c-a3b9-3e80c19749b3"]},{"cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","members":["d66f6d8a-9250-454f-b215-5b34d55b6e07"]},{"cluster_id":"71084441-cc44-4209-84ff-0b19201dd17c","members":["81a3712a-94f8-48c2-b3bc-6fb8cb3120ee"]},{"cluster_id":"385e1f90-483f-4a17-bec9-dd37d561707f","members":["99d12199-f4f7-4c93-90b5-7946d74fedcc"]},{"cluster_id":"04e0078c-1ff9-4d1a-8adb-a137164fd78a","members":["21aa88dc-310a-45ee-845d-deabdbade650"]},{"cluster_id":"6a4b35a4-0785-4292-8587-aee85db61288","members":["00df4a79-1dde-4f15-839d-cb6bf604c4a6"]},{"cluster_id":"17326b3f-1222-43e5-90d5-e26c86b0e984","members":["36577aca-4963-4024-a0a0-7ef666c33679"]},{"cluster_id":"ac61e213-06f8-4e65-ac52-8d47ef547cc8","members":["6a00b265-a1c2-4633-84bc-1379e6fb6b3f"]},{"cluster_id":"f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb","members":["edfafc83-4cde-4255-8a4f-9d89f0220509"]},{"cluster_id":"f0bf7f4c-0a27-4681-9eca-ea221b9315a7","members":["a1a5269c-96c4-48bb-b8cb-6724368b2007"]},{"cluster_id":"770fcc6f-66a8-42c3-adcc-243f958e2049","members":["af39a7c0-63c4-43e2-aa19-fa2ce144ead2"]},{"cluster_id":"c3211a84-677f-449b-8204-7cc36fb3bea9","members":["1c51ce2e-fda1-4273-aeec-c291f3c753bd"]},{"cluster_id":"15b9ef6b-09b3-4dc2-aa2e-09ba6d46709a","members":["194c83a2-8011-41ad-84b4-5776ff4a4ccb"]},{"cluster_id":"f8dcd352-7207-4138-bd88-eb7c4051cbbf","members":["c89a8df6-10c4-42ec-ab6f-4f235f1d6fb3"]},{"cluster_id":"aa09782e-9c11-4715-848f-eac275117bbe","members":["5b288e9b-9de5-487a-af64-e3301611a079"]},{"cluster_id":"e370d332-674b-403f-8471-184685b21c55","members":["8cb1b7e4-b0f6-4322-9523-e8c7544f76f0"]},{"cluster_id":"1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba","members":["9120cc9b-5192-4ad3-9f58-f0d1f74efd73"]},{"cluster_id":"7370b2ae-5bd2-49ba-aa3a-effafe4334a0","members":["d34d499f-105a-42d9-83d2-ad2031a8f07e"]},{"cluster_id":"ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70","members":["fcc04898-c13d-46f5-bf54-7bbe635d86ca"]},{"cluster_id":"e0d82e7e-dd46-4e81-a408-b1cd11385d33","members":["098b52d5-8a51-4954-9bbc-1cc8535ba6dd"]},{"cluster_id":"37094b58-53c9-4cd4-af90-cb17301eef9e","members":["0c0e7306-ac48-4f56-8f28-b99b87fa1199"]},{"cluster_id":"8d4f670d-826e-45f3-b1fc-0b828324ae7a","members":["b681fe85-1bd7-4f44-810c-0b62519a0c80"]},{"cluster_id":"ef63ab3c-4c57-460f-989f-0ac957105580","members":["81f97fe6-7431-4f57-8955-2767cfc133ec"]},{"cluster_id":"865d4451-2942-47ff-84cb-46ee2b23dc46","members":["8b33178d-bada-4494-a9ee-81b8ccf9246b"]},{"cluster_id":"9c240f69-7202-4a37-b1d5-a3ae10dc5998","members":["78cf9ac9-6b48-4912-a10a-e504a59deaa6"]},{"cluster_id":"07bacc2e-cf13-4467-917c-ef3c2aa505ca","members":["b1cec25b-6abc-42da-9d5a-2069e6d588fd"]},{"cluster_id":"c604d802-912a-4abb-ba43-e290946de463","members":["e6280bcc-1394-4734-b33a-9210d5dd657a"]},{"cluster_id":"18eba947-bd55-4242-95f2-7927edd7f432","members":["9cf61297-8c4e-46e4-8962-f26e488d9602"]},{"cluster_id":"d0323adb-673d-4daf-86e2-8d0f732fd9ed","members":["46e1bf37-c531-4407-93c4-8e1e35475b18"]},{"cluster_id":"50262127-6a56-4d82-bc3b-4ca236eefed1","members":["9aaa26b2-ed57-4999-90b4-829e65b1513e"]},{"cluster_id":"bc56200e-afec-40d7-a87d-167e90733913","members":["ecec4097-a695-43eb-8b4c-422e968635eb"]},{"cluster_id":"0aded89b-0a86-47dd-8291-b59848abe762","members":["db280b6a-5898-4c98-a836-efb473b37d81"]},{"cluster_id":"bfd0fa79-f057-4e1b-abfc-222496dbeabb","members":["e4ed39b7-d2ef-4064-864f-d3c0ca196278"]},{"cluster_id":"cd37a888-7bea-44b1-9691-e12e7c11fac9","members":["87195b27-1879-4bb2-a3df-0a55408ef30d","363394df-152d-40b2-ac62-d490a96c6324"]},{"cluster_id":"c054d850-518a-42ab-a850-01492f7fb7ce","members":["9d89afbd-42cd-4665-98a5-36d61a09dd4e"]},{"cluster_id":"6f473cd4-feae-4e71-a4f1-47b2820e799e","members":["bfec0579-ba3d-4480-800c-a2af8552c46e"]},{"cluster_id":"e06a0883-b86c-4452-9949-2a46787f07ab","members":["e4bd9a5e-54db-49c0-bc0e-a1f3319f41b2"]},{"cluster_id":"c3cd1557-129f-4369-b850-25bdf5456c16","members":["223583c4-ea91-4fb0-bc4e-6603bd51303a"]},{"cluster_id":"253fbf69-01a5-4352-a109-1aea0fdf1fe3","members":["9da0944d-b296-4828-a890-95d79d08fc2e"]},{"cluster_id":"910f66d9-b789-4e64-8888-a565439b59fa","members":["d4873ebc-9fb4-4d1d-b399-bd350edf35cb"]},{"cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","members":["37ddfba5-8974-4a9e-8af2-98d4b5a634cb","f08f91a6-c902-44bf-8aa8-264968dda7c7"]},{"cluster_id":"64664899-be28-4387-939b-822e6b833f08","members":["10eb4524-cc0d-4c59-9a55-9eb3bfdbcdb6"]},{"cluster_id":"be207930-e097-4d94-9b71-209ad62e9e5f","members":["bb37d28a-8d63-40c8-8c8c-2980333262fd"]},{"cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","members":["ea43da93-e80d-4470-a29f-bd6a20784faa"]},{"cluster_id":"5c890164-2642-4556-87d3-c7dbbd1d4d78","members":["084c812c-89ae-4e1e-8844-39f37dd38c4a"]},{"cluster_id":"558484b7-ac90-44c3-8eec-a2f364ca9460","members":["fc71e4be-3c6e-47dc-a1f9-513916590b5f"]},{"cluster_id":"e473874a-9cd2-4a8d-b926-9354bf1b7e19","members":["3de0f031-a44c-4ef8-b51e-ba461cde1b8f"]},{"cluster_id":"de56a9d8-47ef-4820-ac13-06ed6f8760ef","members":["eee9305f-cab5-431b-8ccc-1d1567aa3a30"]},{"cluster_id":"d47ee5b3-b3df-49e6-9a06-0dbb08c65765","members":["523cc482-5018-4a9f-bf89-01328f70f288"]},{"cluster_id":"8948b384-0046-47fe-bc91-7f2737b00557","members":["67bc5609-6f41-49d7-a47a-86971a7db8cd"]},{"cluster_id":"37ca2b04-06dc-444f-b96a-20f9e5902a07","members":["53cde36e-b505-42de-bf4a-183b7e653698"]},{"cluster_id":"b11a9565-86ce-4b37-aea3-07e84e21fa4a","members":["97e719d0-06c0-4566-a327-e80ecfdb8eff"]},{"cluster_id":"80112f8c-1c78-451e-98a6-361d1ea1a9d4","members":["30f26d7e-7d65-4925-a45f-8b4a229e28e6"]},{"cluster_id":"4d3a2478-017b-48f2-862a-30c57fa5055d","members":["1c45e614-e629-4df6-9c53-2c88e272a6be"]},{"cluster_id":"b6e703fc-a44f-43d6-9db6-85666a802044","members":["15c44e96-a11c-4de9-bde5-402e1c42549f"]},{"cluster_id":"cc6a9454-14fd-45d5-b472-64ca4fedbe80","members":["78083908-48a8-4be3-a6be-474174355e21"]},{"cluster_id":"551e444f-6554-45dd-baba-6798fd43af6b","members":["b743e680-f8c6-4e72-9eb0-2f4ee2ae965f"]},{"cluster_id":"970a5cc7-9a05-4850-b0f1-f59128c441c8","members":["fac8cb04-fc3a-4229-9798-9943e1d279eb"]},{"cluster_id":"ba4d4a13-eb59-48ce-b75b-0c214fe98953","members":["529a5652-12c3-477c-a97f-f03c0aea19ee"]},{"cluster_id":"dc464eb9-fc48-4646-8985-9de6d7531d3d","members":["75d6e4b2-8ffa-4fe7-8847-527575597f9d"]},{"cluster_id":"0c0cca84-dd68-41a0-8489-cb2d22400e3a","members":["5c1096fe-d81e-469c-8dcf-ea91b134de78"]},{"cluster_id":"1cbddfd6-c491-40b1-b10c-fd4387edddf6","members":["ee76c9a0-f9fd-449f-a743-2d8ef8929e88"]},{"cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","members":["9bbcb642-5a9b-4821-8e6c-4f6dbf879b9d"]},{"cluster_id":"a01e0915-a285-410d-9d1b-ce9544139c90","members":["968e7ea3-fda1-4688-8a28-4220eebe29f8"]},{"cluster_id":"ea43c4dd-2096-4292-b914-5c467c6f33db","members":["9cb96040-8b46-46be-a544-c2ed6385b215"]},{"cluster_id":"7b36df0c-5a40-406c-8572-3bb3871611ca","members":["a83189a8-34cf-457f-8d7a-64232125f4e2"]},{"cluster_id":"ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6","members":["8f1ab946-4c1c-47f4-9369-87bc4ede4612","f6914820-56bc-429f-9a23-9ee686516844"]},{"cluster_id":"36b91493-5f3f-412b-a861-2328c6420cc6","members":["39baffd5-3aea-40f1-9530-55a17c607cfc"]},{"cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","members":["13c7c5b1-2d5d-4435-981c-edecb42f0d70"]},{"cluster_id":"543e79b8-1458-43e8-a976-eaa0fcb652ab","members":["c3cdb631-c5d8-40c4-9f1e-febbbfea5ca9"]},{"cluster_id":"1be65d4d-c915-41d3-9d1c-864035425656","members":["f898bd5b-3db6-4e02-9f4e-cca47361e39e"]},{"cluster_id":"327aebea-facc-4b65-a419-a9d461f7aa0f","members":["66c410df-05e4-49c6-bc27-30f7de73703c"]},{"cluster_id":"404cf86d-d513-4c8d-adf3-7f2b9464b34e","members":["4591a46b-7300-465e-9949-03baf246f461"]},{"cluster_id":"e045b8f3-c755-4ad1-91b0-a0b8f7878680","members":["cf032c80-cd0b-48d2-a3a5-3284519a1310"]},{"cluster_id":"69638d1f-f33d-45d8-beac-6ee7ce61ea29","members":["1e50fdeb-c36d-46b3-802d-22f9866e50f4"]},{"cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","members":["18f01061-511e-40a4-9d51-74d81fda04d7"]},{"cluster_id":"29009c7f-3a77-46aa-91c0-d0f703c52dab","members":["48aa9679-9512-43c5-ae3e-ddb6dfbff73a"]},{"cluster_id":"1b36c1d4-6613-4a77-b192-f653249b73a3","members":["ef6b9f01-065e-4d04-8b3a-f7447639a20e"]},{"cluster_id":"64de434e-21f8-43c2-9395-33dcf3b86c3d","members":["10fc7bc6-6b01-4653-899e-b1a4b55ea372"]},{"cluster_id":"c9073334-10d9-4fd4-905b-747ad45c136a","members":["ec13176c-6ccd-4e5c-961b-22ffa6e0dc69"]},{"cluster_id":"38bae771-edb0-4c72-84b7-885ee4da4419","members":["f8f126a8-063c-48cb-8de6-8d604b399254"]},{"cluster_id":"75d5bddd-c0b4-4755-8a27-ab90a5104373","members":["c3dff2e4-49e4-483c-9299-2dbfb10634df"]},{"cluster_id":"f83b448c-d81d-4175-b604-2783d1df502d","members":["15c077bc-099b-4d93-8dce-aa71f092dea0"]},{"cluster_id":"fa361819-d60d-4532-8084-9c75390ba17c","members":["5312ee60-8654-44b5-baee-82132f069b57"]},{"cluster_id":"66a36ac1-c9eb-46aa-9ae1-0d7306ddb692","members":["e8d68e32-e4be-43f0-a70a-913b968c2dee"]},{"cluster_id":"b777a261-40ed-4845-9730-51d3661e3377","members":["6111a086-ec30-4127-8141-62b797b6ac3a"]},{"cluster_id":"75739be5-4b25-48e8-8d9d-d6319de6bd95","members":["e435799a-de64-4c69-966c-d1f15a3485ac"]},{"cluster_id":"e03ac9ce-f105-49c9-9a2f-9442b3b31044","members":["6ab65c39-651b-4387-a0fd-0cef0e5e1e7e"]},{"cluster_id":"fb95e7e0-9ac4-4fef-85ca-e17c4d83450d","members":["d0faad36-3549-4637-ac1e-26d0f3a435ed"]},{"cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","members":["632177bb-ffc5-4d67-afdf-5a819358649a"]},{"cluster_id":"18c77ab0-e8d1-492c-912a-03ad6154fa51","members":["4a32340b-0dc2-4055-a540-4eba24f18316"]},{"cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","members":["01bc9bbb-94b1-4953-ad41-e0012c776da1"]},{"cluster_id":"f6b0f0ef-f78c-4282-952a-d2ce7128854f","members":["08df049d-815e-43e2-a676-499d54cc9bf9"]},{"cluster_id":"44260a23-35ce-4643-9869-bda1004b447a","members":["03652bb1-007e-45f9-8e4f-9f08d9cf265c"]},{"cluster_id":"77119585-efc9-469f-8988-fdb1e15681f0","members":["d22b31b8-a526-47bb-be4e-280c5072e0d0"]},{"cluster_id":"fced5669-e70e-41e7-920b-f76f2f50557d","members":["12cf2e50-bbba-4ffe-a538-dff6e687b7f3"]},{"cluster_id":"0de2a028-10da-49bb-8b43-e7f79a0ff6dd","members":["b7ffeacd-5073-4386-9bb2-5a80e5cba7bd","47c717b3-851d-4eb5-88b5-b17088e768c9"]},{"cluster_id":"47085082-7091-436e-a3ee-ecf14c90e1a5","members":["a0e03745-c934-4002-849b-279c0d7ca85d","86ccc3a3-9bf2-4315-90bb-e4090352abc2"]},{"cluster_id":"54fa045c-bc33-4348-a964-82cb98ec67f5","members":["52c0e6c7-af69-4b03-90b5-60bd0aecb43b"]},{"cluster_id":"0c8486a8-b9af-4dcb-9989-fcb363b7897e","members":["a9720f8c-19bc-421d-a856-3a25464a4f11"]},{"cluster_id":"3e283bf0-1100-4773-9ebf-a90b86b62efc","members":["c3a50ba2-8f19-4548-91c1-576ba23fb11d"]},{"cluster_id":"e4e03461-6763-4291-b9e4-bd4feccb46e2","members":["d41a6028-398e-4752-a435-f4dc2fff1a61"]},{"cluster_id":"3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9","members":["a136f141-6116-48cb-8ff4-a351e75c2348"]},{"cluster_id":"19b1602b-7236-4e52-b704-1442a85ad752","members":["ba369e39-ec45-4ed7-93a9-3a04b478b590"]},{"cluster_id":"0c50e809-0f1b-4656-a0dd-110732b6e47b","members":["24af3b1b-9176-44bf-9cb2-d0a28e6191a2"]},{"cluster_id":"696180e6-d43f-476a-afce-5f13dbb9929a","members":["dfbfe160-e97b-487b-bd63-6307020b0438"]},{"cluster_id":"ddbc1aa3-6d67-4148-96a1-e149d5d02260","members":["8e703566-cce7-4eb6-b60e-6cbe8bda9bb2"]},{"cluster_id":"908a4168-b322-4057-a44b-a100dbffbe53","members":["a117cf36-9039-43b3-b502-f38e0afc8153","c91a56a8-e896-423d-adbb-ca92bf44dc9d"]},{"cluster_id":"8f0344d2-3a73-4534-aa04-5391b7670e72","members":["d7fb78a5-05e9-4de0-b3a9-64b90fbd2106"]},{"cluster_id":"8a444d1c-5423-4444-8123-2c225b02e57a","members":["72b10684-8987-4e6c-9934-4701614da7c1"]},{"cluster_id":"7db64556-43b7-4e29-b1a9-e8fcd5d29233","members":["fe24812a-97c6-476c-9baa-1103a9653551"]},{"cluster_id":"d6760008-6cbf-4c8c-b88a-b478081312d0","members":["3f914465-e5f4-4f05-84df-db17b776b2c5","fc63bc3d-8079-4434-ba23-c70ccb3592a4"]},{"cluster_id":"8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e","members":["6a84663f-f127-4280-96a3-0776bc7bcd78"]},{"cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","members":["14800c14-8301-405f-8273-4181fead0b91","919b7d95-1dd5-4408-a49a-504a37005d6c"]},{"cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","members":["4bd74752-050d-4066-aa80-69ad72c07ed1","79113d89-5d52-41ad-8205-38de4d4905a5"]},{"cluster_id":"6f18d0d0-1cda-49ba-9530-57de51dff25a","members":["db638b74-73a7-4ef0-a77c-7ee167075ba9"]},{"cluster_id":"e44edb14-2754-4e0a-969f-2ab83f6f614c","members":["64d07b78-8176-4333-b0a9-435e55537cba"]},{"cluster_id":"7e29e69f-6e9a-409e-8641-59692b521453","members":["a68db6b4-00e0-44e0-a53c-7d461a4c5a33"]},{"cluster_id":"7ccd886b-3755-4c15-8f38-f5ccef3c92ac","members":["0bd91c7f-188d-4ac9-bfa2-ed23772b7839"]},{"cluster_id":"ab7a8719-e742-49dc-b23d-904f2b97e9e2","members":["f9cf5e65-d39a-49cb-9e90-f611127654f5"]},{"cluster_id":"fd424526-ed4e-4b80-99b4-1b131a22e381","members":["751488c6-fb35-4d4a-b4ff-143b277d9a60"]},{"cluster_id":"7386324d-4730-4b17-8d70-6b33d62d5be3","members":["450057dc-4dee-4d4a-a352-f45e8a148e8f"]},{"cluster_id":"9594285e-8196-4153-9b31-89250a7200d5","members":["2ef546a5-b82b-4961-a634-d891566717cb"]},{"cluster_id":"83150260-cbcb-429e-8e22-0e5b897618ff","members":["fe072c3e-a390-4bfb-9639-e3d3aef7f89d"]},{"cluster_id":"d0c2dc4d-9503-4d98-a218-6e6968c3ac55","members":["9c4ee012-99d0-4552-8ceb-9444421b77dd"]},{"cluster_id":"800c3c00-df13-4716-b553-f1b7480d22b7","members":["a007fae1-b18b-474c-b05c-f4f09ad6ffa1"]},{"cluster_id":"baec81f4-73ba-4194-ab31-e3d64c8a57ab","members":["f76c2b0d-e0db-45c6-be46-076f5caf99ad"]},{"cluster_id":"e53d664b-c538-43f3-a025-7686ca315f8a","members":["9f7c75f9-12b1-4273-8a6f-ec449a5a3e40"]},{"cluster_id":"c90c00dc-2c77-42ad-bb5e-2666e53e2bcd","members":["10a1584e-2796-4a75-b1af-556789b76995"]},{"cluster_id":"612e00dc-099b-40a4-b39a-4b7adbab73ce","members":["7659a98e-7d46-4a48-9bfd-b379e1608b2a"]},{"cluster_id":"81fccffb-0c5b-4efd-826c-64c3efbb0393","members":["252cf072-286f-454a-a807-ea3fa5398883"]},{"cluster_id":"1ae849f8-e182-405a-a33b-006fe51f03e6","members":["29ab53fe-1f96-4405-82de-f10f2733963e"]},{"cluster_id":"08f93426-27fb-4a01-8b3a-b106b5f837ec","members":["d3611e87-51c2-4d02-85fa-7af37e6165b0"]},{"cluster_id":"93548381-56c4-4fb7-be49-43e644f447fb","members":["1bdcdd86-8b98-45b8-ade9-9162e65e0f28"]},{"cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","members":["149651fd-033d-43b1-87d3-665446966eb9"]},{"cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","members":["9f730df3-0a30-4356-9fb5-3da44426f7ea","1b7f21e9-b087-46d6-b057-af8f6f234184"]},{"cluster_id":"058ec7b4-d77f-44ec-81fa-004e499dce82","members":["52b34824-1373-40d1-83be-3018e61ae605"]},{"cluster_id":"536df2e4-b955-48b2-8a3c-5b06a58c9d87","members":["dea6733b-6020-4f8a-bb8e-8c60954965b6"]},{"cluster_id":"71211c39-a653-4c7c-bf55-0339568d069a","members":["ced68cf4-b495-4acb-a046-9612864342c4"]},{"cluster_id":"e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0","members":["94aaec06-525e-41e8-abea-4a063c8d258c"]},{"cluster_id":"546cb276-d6b0-40dd-8288-6659cb7989f0","members":["7045d31a-2fff-4ed5-88f2-f70ba117865a"]},{"cluster_id":"7bcfb80e-f4a6-4404-be69-078e88ddce1f","members":["ecae8d19-6ad9-4d7d-8d32-0bb0062c4bcc"]},{"cluster_id":"b8726f80-5b75-44d5-9a25-5d095109008d","members":["a623bf10-1bc0-4bbe-a810-62f28445d4f5"]},{"cluster_id":"1574223b-5ec0-4588-8996-6510aa3052d6","members":["968ad657-031c-49e2-963e-443fbd372a02"]},{"cluster_id":"ea6a2243-de2d-4dba-b6c1-70fc6e903bfb","members":["0b793eb8-460d-4d54-a9c0-6fb4873518f9"]},{"cluster_id":"62083248-470f-4a86-883c-26267fb22566","members":["eeb9c461-a753-461d-8f50-a2404bad2189"]},{"cluster_id":"50967b88-5546-4fd0-9e1b-6bf235297b83","members":["feb308fb-89d7-4094-8142-ce7a2b1e6715"]},{"cluster_id":"729d6508-b5df-44ab-8ffd-349b7a126b16","members":["47d10127-8b88-453e-b9b9-9ac3fec996d9"]},{"cluster_id":"9960f165-6141-4ca0-8dc4-0a136bfde83d","members":["d4bb636a-ef12-4e0d-99ec-9d63b895cc16"]},{"cluster_id":"edec9892-cca5-4a34-b102-ebb0bb45e077","members":["06a3e8a5-24e0-404f-bdf4-12b6e222fc18"]},{"cluster_id":"c25095fd-de4f-41d0-8719-35f31e51779a","members":["1d51047a-8bca-4664-bba8-aabca8a4a441"]},{"cluster_id":"6d226b20-d54f-48d2-bd7d-2616184afc68","members":["fa57cb9e-6ccf-475d-8f43-70972d672647"]},{"cluster_id":"ae1d4689-4f04-4acd-a0d9-2c0934c3acd4","members":["07860eb4-7e2c-4546-9bc6-7ca701048da8","85b61735-9032-4a87-af70-6f181c7a1dda"]},{"cluster_id":"c8c946c0-f2a9-4ddc-bd30-57a913603310","members":["f5be3f3f-5b0b-41e3-af54-35a878dd3fb8"]},{"cluster_id":"c2350485-f95c-46d4-9b92-6355ceca86df","members":["77d68ce8-66fc-42bc-a8d0-0495a4c960b6"]},{"cluster_id":"aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca","members":["4ce202c4-ee9f-4ab4-bc4b-d87abc617ed8"]},{"cluster_id":"a751c83d-9da2-48e9-83a8-bc6d8a1c455f","members":["ce9c9e32-2219-4f66-83a7-989550bdabe5"]},{"cluster_id":"145c6709-d797-4b12-bf2a-a6ed41e9efad","members":["3b0b5562-9d6a-4197-a16f-1ad69b1cc4a0"]},{"cluster_id":"94c9f0c7-1016-4b43-931c-9bd7dc0b2892","members":["e04aabd2-3b11-4d85-9454-5293b1eef028"]},{"cluster_id":"9bd5e01f-d2aa-4157-a2fd-143c30274710","members":["f7759163-a314-4b80-86d0-b7637b3cd643"]},{"cluster_id":"fc8bfdbe-11b3-42f5-b3d0-f35ef7784a93","members":["d9fca8eb-fc43-4ccd-866c-6a62a072e2f9"]},{"cluster_id":"f51dc065-8987-4a56-b2b7-f53334ad4ee2","members":["72f2090b-17c4-4faf-b2be-bc36323f1e2b"]},{"cluster_id":"168a2344-84cd-4fca-8692-ada3563a273d","members":["64d045e9-0660-4692-b1f8-8b191f6cd9b2"]},{"cluster_id":"f74715cf-7efc-4866-8a83-4aec1b75795e","members":["4b646847-1cb5-4f88-90a1-ce18b12cd313","081b2b41-5d2f-468a-8eda-4d4c95d9f977"]},{"cluster_id":"3786df1e-47ff-4916-973b-ccf57ccb5e4c","members":["2e13e180-291c-45bc-a491-c8cd8f430264"]},{"cluster_id":"4cef0d90-5e3b-44f3-ba12-57b1ee19455a","members":["6d117aeb-ccd3-4e78-8899-ddad3c137ea6"]},{"cluster_id":"c7eb5329-6775-4d3f-aea7-7de4fbeb8175","members":["de2c1ee0-8549-40d1-8446-21411e0d089a"]},{"cluster_id":"74381468-96fe-4ea3-b795-41362208378c","members":["82c5ec92-7d92-4548-9470-04867fdf8828"]},{"cluster_id":"cfbbcd75-4bf0-4351-b592-afb201b74b60","members":["736d9e03-dc3d-4f14-8419-90e558838823"]},{"cluster_id":"1b63ec5b-2010-4bd3-a351-328e7b4b5470","members":["ddce07da-f9dc-4166-932b-b52520d4d2b5"]},{"cluster_id":"4cb70cfd-308b-45d4-a6de-94896ddf47a0","members":["ac90a491-ea82-4572-a011-004f6b3e29e7"]},{"cluster_id":"b9e4bfc6-c83b-47ab-95a9-d3b6db015c07","members":["2c42f23b-b2e9-431d-951f-51cfe3051581"]},{"cluster_id":"471cd849-51ac-493f-a2b6-3965a7fc582c","members":["651343a0-1855-404e-9bca-18e93f2d5a77"]},{"cluster_id":"58b4fd6b-1eec-47dd-b945-a94d957a9933","members":["6181efef-91d7-46cb-be69-cbde16defa0f"]},{"cluster_id":"376826e6-eaf6-4628-ab75-e400a091149e","members":["1abc1279-e2d0-4488-8b82-46263c61dcda"]},{"cluster_id":"a1d5bcf5-80de-4ba5-b40d-443ea3d3eb11","members":["a6383900-6404-4d3f-8aba-0687e070ebc7"]},{"cluster_id":"f66bb1c3-c6f1-4000-8eb0-82b5bd8bc518","members":["322008f0-3241-4a93-b5d4-df5fb6ca9a96"]},{"cluster_id":"96cef335-1ca0-48d6-912f-d308e0729c0b","members":["45054bb5-98c4-4cfe-9680-35000796ee24"]},{"cluster_id":"758d6034-7d93-4286-ae2b-f2ffde861da6","members":["2b89486b-0ab3-4157-b0de-77774c409613"]},{"cluster_id":"cd21b07f-3941-439e-8ffa-59c6da9df98f","members":["1abb2f07-9cf8-48b2-bbf1-d78cad1a62e4"]},{"cluster_id":"49c94f1b-b278-42a0-b8b7-d0f8ec55d536","members":["8d5d7861-9d12-4c60-805b-c0152ee0c78d"]},{"cluster_id":"62fbb5b2-0ba7-4211-b72a-eb1c18543408","members":["447dd20c-66d9-47e0-b122-5a27bc28aa15"]},{"cluster_id":"79c4f8c6-ab1d-43ae-9503-5af83d7fa7e6","members":["82b3bde1-e7fb-4c19-b8d1-78fcf4f4f472"]},{"cluster_id":"c85112cb-b1b4-4c61-8955-fca094b1a4c4","members":["e753e65c-048c-4f62-b90b-dce6303a03d1"]},{"cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","members":["c06a2666-40ff-496c-862a-430c79f26354"]},{"cluster_id":"c75e8276-e126-4693-a87d-4d748183e6fe","members":["f8d94da2-78a7-41b9-bca7-32fc74a9adb4"]},{"cluster_id":"b8a67936-c036-4a45-8680-bb4909cdd3db","members":["e255c9b3-68b0-46d2-9a2a-ba4bcded54a1"]},{"cluster_id":"3d52b30c-fa0d-4a4c-9240-38abdfc6ab20","members":["ed417166-4ba2-4b0b-ac3e-6aa5232a0d5e"]},{"cluster_id":"8a4b9d30-600b-48dd-9a32-934835947825","members":["5501761a-5b10-4728-a8a3-305eed365584"]},{"cluster_id":"b4479b0e-003b-4796-9f06-dafafe7cc27d","members":["38e66b36-6f12-4189-883a-2d2e79d627a7"]},{"cluster_id":"043e7562-9880-4d36-ba06-fd8e6b3afbe1","members":["0a7a602e-58ed-48e7-880e-a6a2881376a5"]},{"cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","members":["2908fd39-9ca7-4a1e-984b-ef0485bb1cd8"]},{"cluster_id":"3eeddc05-77ec-4d67-9a78-4b328957fe7f","members":["e709b53a-f0b3-42a3-a3c9-f194801b8eaf"]},{"cluster_id":"6f9b01a7-d717-4ce1-bd54-f5647d476287","members":["f3482401-f636-4769-8a6e-01b1b53ccd94"]},{"cluster_id":"b633274f-2881-417d-afbb-e5015101f863","members":["c3d8d26b-ab72-4684-bfbd-296bbdcf9a7b"]},{"cluster_id":"232994db-dcd7-4db4-9ea3-fad6185233a7","members":["d283bd77-2689-4ff7-943f-a906148645aa"]},{"cluster_id":"a5408918-67c4-45bd-afb3-95d8aced1dc9","members":["651a25ba-535b-453b-9f80-85525734d412"]},{"cluster_id":"5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7","members":["b4ca2a6e-2153-4976-9199-941915539996"]},{"cluster_id":"b7cbc93e-51f6-448c-9fc2-c1af44082069","members":["95819ed2-6fea-4da0-8adc-b11616db0c19"]},{"cluster_id":"94599b0f-3332-46af-911a-e0ea949079dd","members":["f02ae4fd-dfd7-4a34-9d71-f0f3326534dc"]},{"cluster_id":"c51e0b3e-03c3-4464-95af-a00db4b0bdd2","members":["bbf92366-7621-4b54-878d-8d640f7d00ec"]},{"cluster_id":"5b4b432d-262c-43d8-a2ca-4d8a45a3e1de","members":["0c207476-8b95-45b5-8537-d0137808b419"]},{"cluster_id":"6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4","members":["71ac27db-e609-47dd-9edc-ad973ee7832e"]},{"cluster_id":"aef50142-8ad0-4099-9362-3d45c56385fc","members":["d2e895d3-6f8f-45b0-8f2e-594dea520523","befed9b2-e17c-44f1-9c3c-7d11496a4a66"]},{"cluster_id":"30229ad5-5242-4fd1-8256-d013e88e6413","members":["6c30c088-4430-4f1e-bea0-16e5f3939ba6"]},{"cluster_id":"e3c5e173-2814-430b-ad9d-2c7612d87ea6","members":["58ca5117-68d3-48a5-ba9e-c55f3b0c979f"]},{"cluster_id":"0c068743-c246-4fb1-8a38-ed41dc7e9fa3","members":["ac00d441-3a77-4269-bcc6-e6e791cbb06e"]},{"cluster_id":"fd96ef0f-c2a3-47f0-b0ee-4580d498d313","members":["f0a1f347-7468-4968-8bf4-947f482fbd0c"]},{"cluster_id":"0a0436c8-54af-4b5e-9725-fc8ed172d1cc","members":["92e2aa1f-7896-4d02-b097-114d0eb2d684"]},{"cluster_id":"c35acce9-0a6f-4e25-8869-1a5e38bf302a","members":["c9ab584b-166f-48ee-93a8-a068efe520a8"]},{"cluster_id":"d21ce376-5e68-41d1-903e-db8ea2f295f8","members":["45b36f9f-2701-407c-bb41-2da5cf74f4da"]},{"cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","members":["f231c676-5eee-4509-9a0f-ae36631ff30d","b658e2b4-f861-49b7-822f-9d60d545a8fa"]},{"cluster_id":"a32303e6-4765-4335-9847-b5ee18494799","members":["2cc8f02b-f6f7-4b00-acbb-48afe8748ec0"]},{"cluster_id":"12667ac4-7c0c-4916-8553-cead6974cc24","members":["44921dd7-fb68-4673-9d91-d3c7d39bf5ae"]},{"cluster_id":"c63decfc-559c-461a-ad2c-a9922b7e06df","members":["291156e6-b34b-454a-a4a5-234d1b5a9b37"]},{"cluster_id":"f799549d-5869-4a73-bd0f-66e1fb2939bc","members":["bd51b6da-c68f-4d00-a66d-ac47ba7a5598"]},{"cluster_id":"5a787097-c657-4d02-a7e7-ce5ddfe404d6","members":["385112f9-b5f3-4bdc-8cfd-95878a4457c1","dfaa1764-c3e1-450f-a71a-f7e11f966f70"]},{"cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","members":["adc2e10c-ef34-40a9-a1b5-99f334f56fd7","33bd5081-6fe1-480c-9fd8-c94f6d44aeba"]},{"cluster_id":"7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380","members":["b16d536e-4a06-4640-a9ed-1354ae306aae"]},{"cluster_id":"ea316b29-c411-49a8-8ebd-8e50456fc746","members":["5fc68f54-02e5-4dcc-bf66-6782dc973afe"]},{"cluster_id":"a44bb3c4-918e-4230-8542-c0aebafed121","members":["593862ba-9e8d-460c-b843-16a9919801bc"]},{"cluster_id":"800e7e36-7ce1-4e55-a18d-394d83673d71","members":["0683ebf0-51d7-446e-ae91-9a60cf532735"]},{"cluster_id":"5b5bad5e-15a1-4d61-9521-27fe4f90522e","members":["c3a11704-5ca5-4d3b-b989-4151dca867dd"]},{"cluster_id":"0884e607-6aee-438f-ad6b-dac7b6c0719c","members":["871435cd-e0dc-43c8-82ff-47803cfead5f"]},{"cluster_id":"d072d7ca-3280-4412-8e76-be63e36fe491","members":["fc39d71b-5191-4106-baf8-5af64493684d"]},{"cluster_id":"b26a20fa-d793-419d-b599-26d1ed57c2b3","members":["1292f243-95fe-4e8d-b668-0561b4d9f934"]},{"cluster_id":"1a4ea1ae-4636-425b-b953-e3a50c80caeb","members":["98eff29f-6b83-432c-b28b-927ec4b83a7c"]},{"cluster_id":"b43b3e32-d544-43ad-b781-20a883c7f4b7","members":["609f12e8-ad23-49e1-abab-57a8195e8af6"]},{"cluster_id":"483b6a3b-d48b-40f7-b28f-e79dfca268e6","members":["b612352c-d6f4-4820-9245-cbdc7a728701"]},{"cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","members":["f03f1e47-b185-4b08-8ff3-c014963ea848"]},{"cluster_id":"0af113aa-da9f-4ed6-a163-dcb48f1459ee","members":["66154323-d238-462c-95db-6390cf14013b"]},{"cluster_id":"253e1524-e402-4a4d-b7db-f94b8f989d9c","members":["751252eb-c248-4e27-a607-510c64f2f866"]},{"cluster_id":"928cf7ca-8343-47ca-be27-378bc29b7fbe","members":["6932d003-f34e-4235-87eb-e7cd45ec36c3"]},{"cluster_id":"243cbf96-dba8-41a3-9dc7-8def431d23c9","members":["e0fb6168-f755-420a-bba6-5da68728897c"]},{"cluster_id":"d97f4faa-5b32-4a18-93ac-69c340df4581","members":["ea294df8-d351-4b71-9ef7-6acdce1bdf21"]},{"cluster_id":"f6b9e37f-45a9-4864-8489-2f475476f4fc","members":["07112370-1b0e-4aba-9663-35f7e03a3646"]},{"cluster_id":"b659052c-10e5-47d2-985e-c2c7d42a67a2","members":["f5b2b00e-ba38-4547-a0b9-3092f6091cef"]},{"cluster_id":"30765e40-3943-483b-8e1e-27d3053ae2bd","members":["41ed43a2-38e1-476a-8304-8f12a9f67878"]},{"cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","members":["05191600-57d5-415e-b4f4-c412f47f41a6"]},{"cluster_id":"96b36513-ec34-4deb-bc5b-c811958c3675","members":["9c495b9b-667e-433f-9dab-51269cfe4ea4"]},{"cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","members":["457c7f59-3b69-4f57-a82e-eca71fe7656f"]},{"cluster_id":"fe25e7ff-abc9-4e8c-bafa-dc9163738c4e","members":["4d05a7f2-89f8-45fc-b32d-b3b1d5fec6f0"]},{"cluster_id":"1927948e-52f7-43b0-aafe-d3f160820394","members":["3e3765b1-eaf3-4bba-9591-48394d3143e1"]},{"cluster_id":"ac6c3346-ea92-4da2-afed-ba431832d85e","members":["49603d79-aab0-4745-b291-b320f6ab4409"]},{"cluster_id":"7be2aab8-ebba-4a53-8dd8-2f99fbdc274c","members":["f45aed36-6ef1-4d69-822b-6f2f4982179c"]},{"cluster_id":"b1da162a-fb28-4547-8fd8-715c5361b7af","members":["b3c74b9c-d96a-4447-9a9e-6a0ac43bec8d"]},{"cluster_id":"61152334-8dda-42a2-bb8d-9fb770fd72f7","members":["2a625bb3-0488-4532-98e8-0cd6f90748c7"]},{"cluster_id":"0961c365-4261-4c91-984b-81c62260d807","members":["8bd6557f-ec53-4465-b0a8-3f71d5b51659"]},{"cluster_id":"0e4acd7e-6e9e-4ec6-953b-f0301546aee1","members":["d337f025-3d3e-4881-9db1-26a9cc34fc60"]},{"cluster_id":"957872f4-ebb4-47bd-9d9e-487c3755644e","members":["d118ff64-c246-49b2-b6dd-8119a5bdbd34"]},{"cluster_id":"2ca08905-d2cc-4e5f-80b6-1f1b64356b18","members":["5f5e53a0-8662-4d96-8adb-4d1f861b5ba7"]},{"cluster_id":"e36180c3-afe0-495c-8168-73e631f50a1c","members":["5ca6668a-af13-413c-81ee-eadecac59929"]},{"cluster_id":"d832a602-46fe-4c29-83ff-f47197eab057","members":["8a238a7c-f96a-415d-a339-07d5f96f0b45"]},{"cluster_id":"bee4d72b-b159-4b6c-830c-362b42a2b18d","members":["0fd219cf-7794-4e20-9d7a-bd0f952d8847"]},{"cluster_id":"1075443d-c097-4cb8-acb0-3d21f48f6aca","members":["511305e3-08a8-47bd-ba35-92e850caf3d8"]},{"cluster_id":"fc64cbea-821d-4f81-89aa-1c161d723583","members":["af738d60-42d9-4182-b743-c15060b3b799"]},{"cluster_id":"dff8a985-ffc1-4946-ab7d-43e8406aca00","members":["79868c5a-81e7-447d-9f0e-e7d3ced773f5","562026e1-3ea1-40be-bb7a-064c265fc22a"]},{"cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","members":["1c742d5f-4f38-4dbf-a3f8-5ea02c118d90"]},{"cluster_id":"041ca325-747b-4d3c-b3c4-9ee7fabc37db","members":["fd2f32b7-550e-400e-a654-d1c8d25a01f3"]},{"cluster_id":"a3cc8d63-1533-4239-bc6b-bedcff828ef9","members":["d61a4f40-3482-4719-be2d-5a97dbe2f20d"]},{"cluster_id":"6a13b21b-08c5-4326-8613-c7913554f2c7","members":["2edc566a-662a-48eb-9f6a-06f9b3f71ef9"]},{"cluster_id":"2c8b719a-2363-4f9f-9be2-6d1801374195","members":["3ef65eb1-1d0c-4cd8-873a-c2e6b2ec18d5"]},{"cluster_id":"802c7e0c-e913-4631-9fd3-b4b457a510e0","members":["60e72e41-ea27-4630-b2b8-d2a69192d55b"]},{"cluster_id":"ed1b332b-c054-4114-82a1-1e645946747e","members":["c225cecc-fbc4-42f9-b662-389b8449adc8"]},{"cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","members":["57353be9-8323-4c01-a15b-a358286bcc76","0d04ae10-ad0e-4f53-891a-e7cdc4751e7b"]},{"cluster_id":"fd107d16-4df5-452b-96c2-989c72732db7","members":["80f98ec2-b840-4020-a19d-c9ef321f581a"]},{"cluster_id":"bd5ae3e5-8ac9-4557-ad42-7cdcb0687b6c","members":["775ec7d2-331c-4113-ba9f-8ec35702f009"]},{"cluster_id":"64ec2b0f-c55e-42e7-a532-b9948f0a43c1","members":["f9eac5f3-6751-4192-85e6-5ff9a684b5ba"]},{"cluster_id":"2616e42a-b0ac-42ff-93a5-2376cee42b92","members":["15ed2e39-9578-433f-ba74-c276daed508c"]},{"cluster_id":"4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d","members":["ba280fb7-61fb-41f2-b800-9919def41677"]},{"cluster_id":"19ddcd3b-18db-461a-b208-f198db3e1e07","members":["b401c9aa-19d5-40ab-8658-520adac91bd0"]},{"cluster_id":"1d2ba60d-53c7-4e8c-91e5-1d0e114d5708","members":["45e9572f-4e25-4790-aee0-bebc5eb39d5e"]},{"cluster_id":"bbefdcbd-8560-44a4-b45a-d11652dfe311","members":["75da4af8-5a1b-4f40-9c0e-a2e1b8ff0482"]},{"cluster_id":"23106ade-18c8-44c0-8d3a-ef2f743468af","members":["640c728f-8be2-473d-ad7d-502c6a1e1829"]},{"cluster_id":"1e9d6c21-797f-4483-9122-2e9582f833c2","members":["913f68f5-8331-4420-bc8a-c649254faa99"]},{"cluster_id":"ba694c90-be36-448b-9da2-f3ed0d816139","members":["bd9a9dd2-0105-4d29-a032-62bd305b6e43"]},{"cluster_id":"5736135c-d235-4604-8803-ae7412cb8825","members":["3cfc2483-90d2-4c7a-8eac-a1fb89531809"]},{"cluster_id":"30d2edfa-6d58-40ae-bac6-ec1273c415ac","members":["addcb655-a008-4fe7-b130-ecc2ff51b64f"]},{"cluster_id":"4af97b54-9617-48e3-8125-aa1e8e1ee8a2","members":["d8a89786-9032-4e97-800a-d94a3e6cb02d"]},{"cluster_id":"bbf2648f-d211-49b0-bf5c-a562e43902c5","members":["07c7eadf-eced-4f28-94d1-a3f3aff2b1d6"]},{"cluster_id":"fdc7a586-a2b7-43cb-897c-5aacc04ceaff","members":["b4d92106-34b0-4251-9ce2-d54fe3fbc420"]},{"cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","members":["58b5190d-ce6a-4fc4-9edc-11d2a480f911"]},{"cluster_id":"7e9a80fa-c7f8-4eeb-8f62-09cee3732838","members":["f5de99ae-33e0-4256-9407-b097cbd646bc"]},{"cluster_id":"f358da84-14e4-4001-acb3-83fa23673eb8","members":["b0acd26c-c9a6-4552-ad9d-ea0b44968974"]},{"cluster_id":"69290a80-8807-401f-b38b-0ff5ba27a43d","members":["725ac9c2-bb18-4002-bd08-67981daaf6a0"]},{"cluster_id":"5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa","members":["2f3d3b59-bb08-42a9-8a03-1792491fee63"]},{"cluster_id":"d583e7b2-dc4a-4915-a3d9-e76bbe714788","members":["155eb26c-e15b-4e3e-a085-683747910dc3"]},{"cluster_id":"a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20","members":["fb4b7724-a0fd-4547-98c7-26503f3a7d9d"]},{"cluster_id":"aa440a76-9b1c-4801-9031-cdac4add116a","members":["4d21b835-341e-494a-be3a-330340cde702"]},{"cluster_id":"29880646-f50e-47bd-8b04-23f2c8716fdf","members":["4af2eec6-df79-4f7e-8d67-62d9045e7add"]},{"cluster_id":"f57f4c9e-1d41-4f34-b42f-aa11437d6812","members":["de23e9a7-26ca-43c3-a9c3-b184324c8585"]},{"cluster_id":"da661a25-9665-44d1-ac27-e2613681adf1","members":["14addd9b-d054-452d-98ec-4906dd68c00d"]},{"cluster_id":"294d0346-cddf-4b1e-a6bc-ab4686137712","members":["636cccd0-6554-42ac-acf1-237a07de714a"]},{"cluster_id":"2762cfd3-48ae-4a0c-baf0-bfb36bcdff70","members":["2aa60b28-354a-4deb-b9ca-9740137c0c66"]},{"cluster_id":"635fb80e-2799-454a-8570-6fc3830d271b","members":["47e06e70-dc3d-4ba5-9c42-8784eb5b06e1"]},{"cluster_id":"43fe48a2-ed82-4cef-9784-8e8df627f565","members":["9a8dd729-abcc-4567-8a42-89096437946c"]},{"cluster_id":"24d81b39-c399-4c59-ae9b-c84548655d0b","members":["92b58bda-45cc-44f2-a5b0-2bd0cbacac33"]},{"cluster_id":"fa32fcee-2bb1-444a-8515-123065611c9e","members":["bd383d7d-5d38-43fc-9a92-f6bef332f4df"]},{"cluster_id":"099e4f99-da99-4f13-a242-dd05de802ab3","members":["dd091e24-7eb4-4929-bdb1-9d781d4ae3f9"]},{"cluster_id":"b49a91d7-446b-421b-9670-7c99bbf5bc28","members":["94d3fa58-3367-4ea5-ae67-7b8f8b279c09"]},{"cluster_id":"1010a45f-c4e6-41d3-ad44-9a27b9dc7893","members":["99e579d9-e26c-45db-abd6-543e14d5f19c"]},{"cluster_id":"120d61e9-d442-4218-b8d0-9559d9880c3a","members":["f60a71cd-e4bc-4358-a0a7-f041b6f6a64a"]},{"cluster_id":"f3b06230-c202-438a-8858-b8c55fa68828","members":["227cdcce-5687-4bf1-9f5a-a8836adedac1"]},{"cluster_id":"232c9ea4-0513-4c68-a25b-8b7d952325d2","members":["293b21e7-38f5-46fc-811e-c5e6536b3f8f"]},{"cluster_id":"511c0db2-0769-45d5-a814-00f974a659aa","members":["4c6ed350-eaac-442a-bcec-bc0413c9cf58"]},{"cluster_id":"9f4059ba-333f-4054-ba5f-f1cebaed747e","members":["23a4a319-3e03-446f-88cb-31b0f2c7fd44"]},{"cluster_id":"866c589b-e7dc-4cab-81ad-6d235278edf1","members":["da292357-2462-42bc-b4ec-4e895f68f578"]},{"cluster_id":"8a12011e-a6e7-4e73-a321-a39426ec3d34","members":["625f25c3-8b12-45ac-8ce9-969d6a18a61f"]},{"cluster_id":"f2096782-318f-42d5-a553-560f508e5016","members":["3df1f8a8-552b-4efc-b21e-abc022e1ff34"]},{"cluster_id":"d60742af-37a3-43e0-afb8-5df777dac64e","members":["21c3523d-ca4e-4d30-ac7c-af819b31b098"]},{"cluster_id":"4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082","members":["8d1914c7-c298-4bd9-aed5-632813d94822"]},{"cluster_id":"f731bc0b-cabf-4314-a5f8-e94d31589cea","members":["7244ae56-e1c5-46e2-a543-7317f009b913"]},{"cluster_id":"721fca95-63af-4a1d-bae5-70b55fce9a8b","members":["2e54a056-be8a-4ab8-89b7-92e1542d6553"]},{"cluster_id":"f9eb0f13-3691-4b5d-b326-0456c31b4402","members":["63a0626d-0199-42df-b653-83dac89f44d6"]},{"cluster_id":"d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576","members":["6204e89f-a742-484f-b4b1-907aa765d851"]},{"cluster_id":"4350947c-093e-43d1-91ad-c33f75e13a1e","members":["62d01d04-f080-49a5-86bc-cb74d32f6149"]},{"cluster_id":"37f5cf93-69fa-41bf-960a-1fd7783d4299","members":["77c96df2-9930-42f5-8e51-5087e65e1464"]},{"cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","members":["f889abfc-b20c-4691-9f7a-372f491a3000"]},{"cluster_id":"a8ca6792-95c5-4826-87fa-d4a8f7047a5f","members":["7ae45b9b-6980-44f2-b068-b1496f49e43e","28c27d9d-9d42-4e63-b688-e63184d2da1b"]},{"cluster_id":"f51c562e-c0c3-4e9a-aec5-0739526b9b5b","members":["9d79b691-d9c4-46d5-a6b8-b1445cb6e6a4"]},{"cluster_id":"b4fd3f81-2344-4edd-8ae4-fd7b59d99888","members":["ed2e397a-705f-4c94-995f-d9156f17a977"]},{"cluster_id":"94a84124-c591-4219-8ef7-52760d608300","members":["9e8abd16-691d-4049-9eb0-3ad5e4589074"]},{"cluster_id":"1ed92023-b891-43ab-ab0c-b464c243f2b0","members":["96074d83-4149-4a8e-95a9-4a7f0069c03f"]},{"cluster_id":"15c2186e-db17-4b08-bbd9-d03072fa580d","members":["3d847759-a5a6-4b77-985b-5a351e634bfe"]},{"cluster_id":"de7b2349-3e46-436f-9b75-c57089eeaa3c","members":["3bccd83c-9fd3-4504-a728-2ae929f05ac6"]},{"cluster_id":"9edb82af-1afe-4fbd-8da5-3bc280a95c94","members":["54404614-30dd-4714-b748-07251cf5d96e"]},{"cluster_id":"02aff357-d128-4a8d-9828-60ab97d0e632","members":["0add574a-18c3-4e8e-9431-ce4b01d7713e"]},{"cluster_id":"8255a43f-82ec-4f1a-8f29-78e7a247a2d1","members":["dd7a9c97-1eee-4e6d-b54c-5fa09301b2ea"]},{"cluster_id":"b3c35953-f954-44b3-89de-73c75db49fd9","members":["35773a2d-d14c-42aa-88b3-687a2b8859a5"]},{"cluster_id":"449f7a4c-3966-4db6-9cf4-d39a2f15feae","members":["9f92d96d-4308-4ddb-b7e0-250051b35d4c"]},{"cluster_id":"cd2c9191-f97a-49fd-9d7d-f0744cdaaf72","members":["08821dc0-3504-4b0f-9450-9c7b8b3145f3"]},{"cluster_id":"577be512-045b-4f32-8688-400d686a100d","members":["4c0d834d-a849-4164-a31d-2c12469d05ee"]},{"cluster_id":"5317331a-d0a9-4595-acad-210a92b278d8","members":["a2e0ca91-66bd-4120-ac00-e5d094187c97"]},{"cluster_id":"1db866e4-0f7e-4d67-93e0-8d1068f0369d","members":["63c77996-d578-49ff-a7d5-3087f29eb083"]},{"cluster_id":"63ad18c0-00c0-4509-b669-2aff507b5502","members":["273f2939-bb92-4cd5-b33b-c8dd1f33921e"]},{"cluster_id":"ef636ecf-8b34-4007-8f71-b4d5ed7d3c33","members":["3a816ab3-76e8-4b09-8f80-c22151e9d200"]},{"cluster_id":"ef78627f-ce46-445c-8434-674b16f6966e","members":["a0c391cd-ae5f-479a-9f98-6b01c1162dea"]},{"cluster_id":"e8bed2a1-875c-4017-abd5-83f756e2ceb2","members":["fc8788d7-4beb-4e83-be38-71bc70131b4d"]},{"cluster_id":"e000263a-3f42-454e-8e66-ba1e28066da4","members":["bee9ca73-5c90-423a-bda6-cc40b0d089e8"]},{"cluster_id":"f3b06c88-86f6-4833-89c1-f778a2910669","members":["ed763e3a-042e-4236-ae32-19b545a0942b"]},{"cluster_id":"97507c06-9158-4dec-af84-2ca3daa906d2","members":["7f5c4a4d-fa3e-409c-9584-f23883a8eea0"]},{"cluster_id":"de60bb28-4ca7-441f-814b-f2ecfe29fb54","members":["9c791913-e09c-4e9e-a09a-095800602b5d"]},{"cluster_id":"db13aa73-f539-42d8-89d9-1af57cfff5a3","members":["b91fddc8-4368-4d68-b665-5ef12e76519d"]},{"cluster_id":"dce54f5f-136c-474f-95c7-ae5b1e1ff60b","members":["a286990c-f924-4861-b1f5-11adc6525f83"]},{"cluster_id":"28feb358-2926-4cba-8425-f09fe5ebab7a","members":["f3816555-9899-45e1-ab43-5f94a8bf10aa"]},{"cluster_id":"dc3308e5-2250-431f-bef6-733e2b943275","members":["a9022ebd-de7d-4111-b77d-91d91f5a0c87"]},{"cluster_id":"0998688e-32a8-4d44-8338-04f2bfaf29d8","members":["0fdf030e-76b2-404f-b9fa-d5ce5442f261"]},{"cluster_id":"9df4486f-c8aa-4f08-a8cd-4ae02c748318","members":["29b0d668-c065-4cd9-9b19-a5126bdd0f5b"]},{"cluster_id":"a841656a-f68d-41d2-ac94-3537d3133ce8","members":["e5b71e08-b9c6-4d7e-9499-bf91654d8f96"]},{"cluster_id":"298b76c6-3ed3-4a84-8894-fa50a9f4234f","members":["c71e8be2-7486-453c-be1d-b9c75dd815fb"]},{"cluster_id":"74664a64-2600-438a-b569-a9d45ae85e93","members":["157a3f9d-f4b5-4baa-ac8d-e0cbecbe4c65"]},{"cluster_id":"8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4","members":["220c9490-1e41-4647-b70e-5e11d5b7f9ed"]},{"cluster_id":"12ff0964-4c5c-4f91-8269-1e4ab61e9602","members":["75374dcc-d1c6-4bd9-a6b3-7eb2980f0d5b"]},{"cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","members":["cfcc8341-a799-42c7-b833-bdbe0d148be8"]},{"cluster_id":"01680509-ab3c-4c56-a9a9-62fe3aeaacf8","members":["217552fc-2ca8-430c-8b02-d361a5851175"]},{"cluster_id":"7b4db769-a456-496c-a3b6-6f242fdb7665","members":["6b6da3a4-46b0-42e2-b535-3942dd778814"]},{"cluster_id":"d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df","members":["4f66e2cb-59d1-4ec6-8d5e-9bbab812bd5d"]},{"cluster_id":"dad2ba1b-78a6-4e69-91a7-e473e3d79e42","members":["73cc86da-816a-4162-a2ea-4d17641ac220"]},{"cluster_id":"0dedc684-9634-49f1-9f8a-88450509e30c","members":["b85ed737-53e4-4c4f-89dc-30ea24f8522e"]},{"cluster_id":"71185519-3f2f-4171-84a1-11f08a933f13","members":["c1ae1e08-3b9c-4e6d-ab94-e36c93e1210b"]},{"cluster_id":"d3037252-9ff2-4032-ae65-41b104560fbd","members":["90b935d2-1136-49d0-90a5-0d6f0cd8fd73"]},{"cluster_id":"b932581a-a432-45a9-94c6-236d0339e45d","members":["f08e815a-d586-4bfb-94c0-ebd0ab4bee9a"]},{"cluster_id":"3945d107-ebd6-4f7f-98d8-84183dc2837f","members":["e2cf4b2f-b2df-4b22-a695-ce32cc4b7f8a"]},{"cluster_id":"eb2ba8af-f927-478b-bc26-2105bdb87c5f","members":["0c0b743f-c802-46d4-b763-5b0569776cb8"]},{"cluster_id":"b9550306-91d4-4e1e-9632-4c73f1957d92","members":["c4cb067e-bbe4-4071-8c9b-8006ed778d69","5e2f3926-67a0-4510-8b6b-ca6546e4ca03"]},{"cluster_id":"a766b305-cd34-47d7-bed5-5c04c33c99ba","members":["2edf27e1-e806-4061-9ed7-968dd0e6ac84"]},{"cluster_id":"e840acd4-9152-4039-820b-b347beaec131","members":["787fd6fd-2ddf-4f9f-84b6-9f779f67c4b3"]},{"cluster_id":"85123ed6-1d34-44b3-9644-642bc01ff160","members":["56bb2e7c-8484-4855-bb44-49f93543bd19"]},{"cluster_id":"24a47a14-4ee4-4529-96e9-02c94e429ea6","members":["9aa1ce99-1ccd-4c48-90f8-4f90b370df74"]},{"cluster_id":"939cc578-da0d-4d69-94b9-0a186537275d","members":["6f0df810-320c-45cb-9e6c-3b3dbbc667e6"]},{"cluster_id":"c4536202-39a9-481f-a4be-147b7620686b","members":["e721ed2f-cf0f-44d3-a6c1-1a24735d877a"]},{"cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","members":["0308a072-47c5-4260-b16d-5658fe09cd8d"]},{"cluster_id":"d946674a-0b30-4a82-a7a2-12fe77cdc3f5","members":["df53c2c0-c395-468e-bb2e-26218921a087"]},{"cluster_id":"1c24dadf-70dd-4f00-84a1-ba00a5d442c5","members":["b858d41f-05e4-40bb-a45c-3887f0b5fd1d","c0e76ce0-91b7-4426-8580-548fe286b428"]},{"cluster_id":"f982ead8-4101-46e5-9a29-b95c416ed470","members":["77a079b2-ee48-41ba-8507-454e8d25592f"]},{"cluster_id":"ba035925-8a5f-42d0-aec3-c91702a47b8d","members":["005bd7ce-1396-456e-8eee-0bd7d6c8574e"]},{"cluster_id":"c8956774-b873-4e48-aca4-1d4ce1428a6f","members":["61082364-4f43-42f4-b547-011b0b54111a"]},{"cluster_id":"97e04a01-6626-4196-a12d-eac1df348581","members":["2e147448-c306-49ad-9fef-d0dada94258d"]},{"cluster_id":"69483fde-1234-4c7a-8580-5490aec071f7","members":["bdf0f963-60ea-4633-a086-26f0ea0b2d42"]},{"cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","members":["db788cf1-32db-4d5c-81b0-a5c2676bf0d6","72c2d36a-c9a2-4fac-8a4a-3725b096e974"]},{"cluster_id":"a99b1332-e477-4168-b8e5-832daa0d6068","members":["61e80615-2fec-4038-aaa3-0bcf5a2848af"]},{"cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","members":["d6bfa4fd-4472-413d-af99-68d64e7ca707"]},{"cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","members":["eac18877-33c0-46a2-bce9-20fffdca5b22"]},{"cluster_id":"7885c5ae-734b-4d64-8d84-fc50b9a87ad7","members":["560790a8-689e-4fe2-bd9f-c6d867654701"]},{"cluster_id":"327ec0a5-4419-4d23-90f1-e220df70fed7","members":["1917a5b3-9a61-409b-9ef2-a3ae28ce7476"]},{"cluster_id":"23bbf046-846b-4885-b881-e84d2ca9060e","members":["1114b133-176b-4fcb-bfa2-39ab1a7f2233"]},{"cluster_id":"612e1b04-721a-48bd-b18f-300c7c5af276","members":["477a61c2-bcae-48d9-9047-5af98157bde9"]},{"cluster_id":"b27abfde-f9d9-4f52-9ce7-8c541388281c","members":["b61fe9a5-7456-42c5-926b-90ebbcdd79f8"]},{"cluster_id":"7576470b-cafe-4c17-9541-256e9ec07097","members":["1d52a278-2548-4be5-b8e9-85b1e1f457b7"]},{"cluster_id":"1a853cc3-9e33-4539-b70a-cc51380d7526","members":["ca39f7af-44af-4a9b-aae6-1388ead9b5ee"]},{"cluster_id":"70a36c06-fbb9-4f71-bf77-74f433672b24","members":["ea1594a0-615f-4ffc-8dfc-b1def5b9dfc3"]},{"cluster_id":"12dfa7c9-8817-4f21-ad00-1e4244142b34","members":["7113e5a5-a4aa-431e-8b49-b4e85e5b3230"]},{"cluster_id":"3af9eb7e-1c8f-4ca9-987f-f38db6d11751","members":["ff58331a-224c-4522-932a-a86dd264f8d3"]},{"cluster_id":"ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8","members":["ca89c722-a39a-4f71-97bd-af7e85c2f6d6"]},{"cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","members":["93dc2389-7725-4bfd-aa6d-0f5e7a002603"]},{"cluster_id":"a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0","members":["25cb42f3-b7ab-4687-8682-b0df8e276a21"]},{"cluster_id":"dbcdf7e4-c865-4f31-a79f-0cd2eef3258f","members":["9aab8a4a-4cbc-46bb-93ea-531d1ace5ba9"]},{"cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","members":["10a59df0-25fd-4c52-80ff-367b12e6a6cd"]},{"cluster_id":"1dae585e-f051-41dc-8fc8-c2d3e3b3b884","members":["875bdd9c-f618-4ae3-859a-2f2941fa6415"]},{"cluster_id":"83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6","members":["c9c3253c-b9a6-4fd9-85f2-e27a00c0b6aa"]},{"cluster_id":"d3913637-42d6-426c-8654-a13850b8306c","members":["e7259cd4-641d-4c35-8240-9e5b6eccdf14"]},{"cluster_id":"cfad4c19-24e9-4d54-8d59-d0b08718729b","members":["d11b7ac1-5f7b-4232-bbcb-3378e317d050"]},{"cluster_id":"d2dff4dc-99e9-4957-9a57-be828ae1a5cf","members":["86969868-4746-4e4b-b91e-da0c9d8dda79"]},{"cluster_id":"679ed917-ad46-4856-a427-b83dcc51a53c","members":["1d260ccf-c916-4d6e-8c87-5b7e63e401c3"]},{"cluster_id":"a52869e4-c88e-49c1-a8d6-0ba25d6c7cfc","members":["182bd972-a7e0-4c8b-b3f5-33eef3f0edd8"]},{"cluster_id":"8c18859c-7432-4cc4-af8f-8a5eb220876e","members":["1946c57f-c5ac-4487-b355-5338816d61be"]},{"cluster_id":"9f34aa0e-2eb3-43e3-b4dd-54a36752af72","members":["987fae78-c69c-4ae1-87a2-1783d4df0a8b"]},{"cluster_id":"d43a588c-20a7-4ed9-8abb-37e05290fde6","members":["30da1f6b-f79a-4f5d-9704-e8804aed132e"]},{"cluster_id":"7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607","members":["79fb148b-5b6b-4fb0-becd-9d53f2ad3be5"]},{"cluster_id":"505519a5-a059-4c9c-8b16-ce6dffe7e678","members":["a2a3fc3e-ab7d-4a1b-8404-f01a97d0af23"]},{"cluster_id":"86478e14-8f65-4b25-93ee-a6036b9de886","members":["35088c9d-c4b5-45a7-8b74-288b070bb212"]},{"cluster_id":"77763430-7d23-4e23-9288-5fdabfddb4bf","members":["ebe8bc4e-1757-407a-8cd2-ee631c8c11e7"]},{"cluster_id":"b6dd34fe-58a4-4775-be96-ca839f926747","members":["7478c1f9-2d96-4035-9cc6-828f2516be85"]},{"cluster_id":"bd7226f9-5942-4c7e-a2e1-156f8c1e7b81","members":["c4f5cb28-559e-4c76-99b2-e6e0f4621d6e"]},{"cluster_id":"7bf4f678-55d5-4f6a-922f-0b5de572f033","members":["56bf3714-590c-4c73-b341-71f048a2366a"]},{"cluster_id":"0ed53993-d675-4e0a-91d9-fca7f39d86fc","members":["19497ff6-291a-4c5c-abc3-61abaaf0308c"]},{"cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","members":["d156d71a-fe2d-4d63-9a18-423d0ecaf3cd"]},{"cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","members":["8b198f66-df0e-45d3-baa7-17c01dc6e575"]},{"cluster_id":"0fa9f6d7-64f6-4933-aae8-3cfd512cab5c","members":["766a17e5-e340-42cc-ad95-c5f9edc91933"]},{"cluster_id":"2ac87cef-db31-40dd-8c5e-d88d478fd344","members":["3c0edcf9-b28b-4b96-ba4f-1b328d91a133"]},{"cluster_id":"c214c388-1bcb-48de-9ccf-d250135ec39d","members":["a1a34e57-69ee-4070-841d-5b90d76d211b"]},{"cluster_id":"b654c64c-3acf-45f6-a6ea-c4584b8c70fe","members":["f74f111b-8ae8-43bd-8aae-72707a95b433"]},{"cluster_id":"4f0130b7-d8c3-44c1-892f-fe74aef4cecc","members":["37413551-3a0d-46af-a81d-f37c6fd47d58"]},{"cluster_id":"442dded8-bef6-49b2-b7d4-70454c6e8e79","members":["a667f48f-8745-4f2a-8286-426e6fad417e"]},{"cluster_id":"d29a2d68-5d53-4ad3-9792-37db5375f45d","members":["8c88f73c-85de-4477-af26-a24e852c54f0"]},{"cluster_id":"9c03f16d-4308-41ce-a6c3-c0b6eaf8e340","members":["c8d7bec3-38b5-43be-923a-1a6e55e6017f"]},{"cluster_id":"4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7","members":["a30a9052-88ad-4420-8689-703abc36bb2e"]},{"cluster_id":"9e71565f-1fc8-4e9e-a3ed-15e11a8ef776","members":["9441a8c9-7e9e-4baf-be1f-d370158a43ff"]},{"cluster_id":"ac74ed42-e193-4a73-9fb7-633a1a28d674","members":["5c2f1cdd-0a0b-40b1-bc68-8742aa3a3d48"]},{"cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","members":["7d40c681-2ef3-4d2e-95ee-9827d1b93589"]},{"cluster_id":"783f85bb-dceb-450a-9a34-4a650e18ed9f","members":["06f4a3e5-b0e3-4d9e-9fb1-38b19ec5cff6"]},{"cluster_id":"108c6941-b645-4904-86a8-cfa0fa34274e","members":["624d6091-1fe3-4572-bdbf-b81bac9a871b"]},{"cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","members":["3791a65c-265a-42c0-ada5-4d83f9d23a6c"]},{"cluster_id":"416e4c1e-869b-468f-91eb-bba4fac5108a","members":["8f954d51-f4fc-4309-ba61-b0094d0fd645"]},{"cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","members":["c75efdf2-f439-4cc5-a3a4-cfc244981056"]},{"cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","members":["00c985ec-b5b5-4575-8daa-509ab455dd63"]},{"cluster_id":"234be4d1-d0d0-4b65-aa97-a8cd91a0a32e","members":["a8d63af7-5112-49c2-a95a-d10fa6cd6f10"]},{"cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","members":["b5fad97a-c940-4eb5-9348-f3275f2ffab4"]},{"cluster_id":"df6be9b1-2675-4ecd-8158-a77b9f4c36c7","members":["bb6e3d80-a5b9-4d0e-941d-032c3f720829"]},{"cluster_id":"300e8b62-ec91-41e2-9809-166d3f0a78b2","members":["eb56e2ca-fcac-4e1c-b941-c92ae6761bbb"]},{"cluster_id":"b12e5d28-73fe-498d-a612-a3df5aa876b3","members":["d30c6914-f4a7-41a8-81c8-8e7b455498da"]},{"cluster_id":"9b7211c2-d426-4818-9305-d12ff5c6e2a5","members":["b8011f98-a6a4-4042-b9f0-473b601a8aea"]},{"cluster_id":"d4d4c9f9-96b0-478b-85a5-92a5fa51e55c","members":["eb38c7e2-9e1f-4e77-a649-5768d011d58e"]},{"cluster_id":"e0a99d28-f3a4-477a-b874-8d839c4523f9","members":["4abbf66c-c32f-4597-83b9-82aae5c19f37"]},{"cluster_id":"d6705dc8-8def-4060-882a-9c13b62a23ad","members":["410d7f41-8cb7-49b7-a408-7780cefbec44"]},{"cluster_id":"d92fe55e-695c-457a-af52-c6044f0ca9ec","members":["249d58f4-05a8-4d8c-b470-983e698ab693"]},{"cluster_id":"127c457b-8cad-4a81-8d25-66dd51786fe0","members":["f71a7b74-67f3-4a39-8e9b-8317ed8580ee"]},{"cluster_id":"049db6be-2ccc-4afd-97c6-e95cb1b50286","members":["de9a742a-d87b-46a6-997b-e317436bae74"]},{"cluster_id":"c17fd8aa-8336-4796-9c7d-a192509f6809","members":["bf356d95-2792-494a-9c53-723a7d138cc9"]},{"cluster_id":"0f106199-65cd-478b-af43-69825b16fa47","members":["97dc3544-0bc6-439b-837c-f643d25780c3"]},{"cluster_id":"5c68cba2-8519-4f6e-b70e-fbda62c5445c","members":["7222b469-b151-49bc-acd6-0be874ba7920"]},{"cluster_id":"91e6a8b3-0e47-4ed1-b99e-a946e23e0c33","members":["98f6cf72-868f-440b-85db-ec6f14c39793"]},{"cluster_id":"17dbd7df-f3d1-4902-a103-f97b03017681","members":["fc0e950c-2062-4497-8b15-3820ad4d8861"]},{"cluster_id":"b763139e-3c42-4a2e-8afc-f2941722221f","members":["e18baf6a-6871-464b-9cb4-a5a5b94071a8"]},{"cluster_id":"1190ac87-5191-4e29-877a-253af15bb185","members":["f66ef738-8db0-4a21-a79a-44e8d3fdbdf7"]},{"cluster_id":"b2dac904-00a6-4c9f-a283-eccc78d22ae0","members":["cce4f4c5-55ff-4594-ad63-db2ba7336564"]},{"cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","members":["0d22b873-3bcd-46f0-ac8d-be55d657c3d5"]},{"cluster_id":"b45686ea-2849-48a8-b658-78abebbff1dd","members":["039ac62f-753d-4687-85d4-fe380baf1e9b","c8b6c191-aa5f-4a01-a9b3-7f5ab792cb55"]},{"cluster_id":"53bc38bf-651d-46ea-8aaf-f63f52195a45","members":["b3eec49f-990e-4af0-99ce-b5b1674ce1ce"]},{"cluster_id":"e521c1db-8ae4-48b6-83c6-efbd02701f4c","members":["9e079658-a585-464b-a262-b8382a78b4bb"]},{"cluster_id":"0450cb4c-8816-4bbd-85b6-ac94ecde9af4","members":["fdf896da-e199-4be6-b7f6-8c2bd776562e"]},{"cluster_id":"eb6a12b4-268e-4e39-8d84-ba73d40a7ffd","members":["3b8a9b74-84cf-4774-919f-c0e17240e45e"]},{"cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","members":["334a9b32-ce27-48e6-b0bc-b8ea89c75156"]},{"cluster_id":"03b37d7e-0ed4-4014-ac24-a898719a8f87","members":["11832956-c82c-44b0-91c4-4840f8ca62a7"]},{"cluster_id":"0bdfd962-fc80-4c29-8a9f-545619ab3653","members":["c0109198-ee1a-4099-955c-d818edf37cee"]},{"cluster_id":"997de204-d7ea-4e15-b208-ebc2bd4ddd62","members":["278a0146-212e-405b-8949-d4c04cb5f338"]},{"cluster_id":"1469928a-aef7-459b-af14-6d6ac0ca72d3","members":["945ed028-9468-4bb8-a245-d462906aafb8"]},{"cluster_id":"9c68ef9f-53c9-413e-b008-51e352564820","members":["dbe21f83-60a8-4568-bb55-34d127142232"]},{"cluster_id":"5d4bd659-348a-4fe3-bacf-eb25b0043f94","members":["7ae47a7d-066d-40fe-a8a1-8bc552a48008"]},{"cluster_id":"554575d4-0201-41f5-aa4b-d48a76e37311","members":["497d5038-273a-402d-9e56-2b2e9fe72bc9"]},{"cluster_id":"c9b6b0e3-811d-4e56-9eba-3408eb1dc06f","members":["14204ab1-80b5-4131-96d6-b20416510a3f"]},{"cluster_id":"d232b59a-12d7-48e0-9945-60749a40e538","members":["e5c5cfed-e553-4c1b-ac88-2713c8b637c2"]},{"cluster_id":"77e72686-2baf-45ab-a679-b8f62cdcf982","members":["a900d61c-14d8-49c7-9d31-8c052482804b"]},{"cluster_id":"61b758fd-ce2c-4502-b494-9618880e66e4","members":["62594f26-90d1-4fb4-94d2-76d96a5a4670"]},{"cluster_id":"b60fefc6-3713-474d-b9b3-03ebad7a4f1c","members":["5613b471-f5b7-4770-8150-226427574bf4"]},{"cluster_id":"b5432b8d-5ac9-4f60-8977-fdbcdae395a3","members":["e378c0e4-784a-400f-83ab-44acd7efff8f"]},{"cluster_id":"700a7ce5-024e-45ce-bc66-61c8dab09717","members":["5d287179-1913-49a6-a2dc-52aa26f47a04"]},{"cluster_id":"fa79376c-183c-4b27-9b35-5eee39b30f87","members":["b16188b6-0bfd-4e86-aec8-758e1788ac7d"]},{"cluster_id":"73e1870d-5a72-427f-b64a-f2b7b2817260","members":["636986f4-7d28-4292-b06e-7144ac4b1cda"]},{"cluster_id":"d4352376-c595-4d9d-928a-8fabbed1e18b","members":["2610f24b-2b31-4670-b760-f239b5e6fa97"]},{"cluster_id":"10317341-49c9-447e-bafb-6ef554948da9","members":["604bab64-fcae-4b2a-9e35-f1f01336aa83"]},{"cluster_id":"40fee78e-be14-405f-8e91-d6685b9587a5","members":["bd5fc61e-f04d-474c-8059-3dab5253b183"]},{"cluster_id":"3073b261-2ceb-46c8-bad6-3808fb657e33","members":["42f09db3-551d-4166-8b95-eac38932ccf7"]},{"cluster_id":"48cca002-8003-45bd-92b2-3e2945a33b48","members":["34faaaca-1b92-447b-ba8f-2a9e760060fb"]},{"cluster_id":"4801b48a-d91c-4dc3-9797-76929432b0ef","members":["ff17c431-3371-4f1b-90f4-92249ef3c30f"]},{"cluster_id":"ff43bfb6-1ab6-422e-8045-756b71e70dd1","members":["1f50ab6e-06e6-4323-8f2d-970dd2aaa5ff"]},{"cluster_id":"b865573b-6b72-46cd-b3c0-a1458e7df010","members":["2a3d2c14-0c4e-4df4-83b9-1697054ce7c6"]},{"cluster_id":"01c08614-0081-4fbf-86e8-a41b845bc4f5","members":["c2726e3b-de4f-4025-bcf7-aa4a83298e58"]},{"cluster_id":"626035be-3dc2-4608-b822-013ba6260905","members":["b49fd94f-a2e9-4402-a8fb-04c957603726"]},{"cluster_id":"0cdd2771-1f79-419e-940c-c74f863377bb","members":["35f1768b-5b75-4726-af15-53b8453bf960"]},{"cluster_id":"f8aea904-a823-4059-9707-77075c116ecb","members":["a341c062-e189-4526-9e17-0a4302d82684"]},{"cluster_id":"ce28dc91-d0be-44b8-b551-17c831f9e07e","members":["400dda24-5642-4eaa-b0cb-21895e10b95a"]},{"cluster_id":"1713cb4d-ab0f-4257-a2cb-4aec01e411ef","members":["5cfe33f3-fea8-49f4-9ed4-eee6a3217253"]},{"cluster_id":"f4e47d52-0a9c-4a42-9a14-47aece599116","members":["cc97e4d7-39ac-46ac-ab8e-e2e0f8480d08"]},{"cluster_id":"97e28e03-c0a3-40ba-8418-88973425525a","members":["30992d07-6067-4261-8356-d56b2fd9b710"]},{"cluster_id":"06c89f07-f873-4ab4-9068-3bbe6a0c9e11","members":["baa6ae57-ce52-4790-9177-e3e7b2392be4"]},{"cluster_id":"44fbf7cb-79bd-4592-b8a7-2bf2362dc392","members":["5dfba5cb-799d-4b07-87b5-8e2980417a6b"]},{"cluster_id":"0626769d-4a42-43f4-8356-e89543f6dcc3","members":["ea8e283b-182c-4143-be2f-de77f5d27cba"]},{"cluster_id":"2fa38dbd-c491-4579-bb95-e37ac00e125d","members":["8c2d291f-df81-468d-85a3-0e1fc31ede57"]},{"cluster_id":"bbe61a29-09c0-4f9e-98e6-1cf33324aca4","members":["5caaa189-9220-4884-8396-ddfdeb8e9a35"]},{"cluster_id":"71de3f5e-7d6d-4a6a-b383-b96d1ee24b30","members":["164555ef-1d96-44b4-8f2c-a56ac2c400bd"]},{"cluster_id":"7cc752d0-c62a-4657-a1e6-4213c5baa7cf","members":["1b9e3d5a-e548-4979-9072-bc0a417162a5"]},{"cluster_id":"3dd1bcbf-32ed-443e-a942-a8e7446ea6d1","members":["a2ed6adc-50b0-4f09-9db8-fb2a75a24925"]},{"cluster_id":"89b27333-1443-478a-ae8d-2e32423dac3d","members":["36c7062c-b507-4d27-bfab-ca6f4b494394"]},{"cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","members":["514684a4-216a-43b8-89b4-796e192c499c"]},{"cluster_id":"9012b6f3-2c16-482a-b276-63925d342482","members":["05366e38-604d-43f6-b486-b13216dc32f1"]},{"cluster_id":"cd55cb26-f122-4354-aeec-7ffaa02af90a","members":["cc9c1faf-f971-4aad-bee5-4f46968b9f0a"]},{"cluster_id":"99fbb991-8bc1-4254-9fff-a2ac5c926685","members":["8aeeea15-aa9e-4a7a-ac13-8421e1c1f6c6"]},{"cluster_id":"c46be245-9f63-495f-be19-e522e39c13f9","members":["94eef71a-da34-4277-a1f1-3afbc1c2a534"]},{"cluster_id":"c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2","members":["e2b7a9e2-4169-4e2a-82cc-818f5dbdf36e"]},{"cluster_id":"269d367a-5938-4087-911a-3256c10a910f","members":["54a34012-19fb-4e45-96e9-9f7d1cf417c3"]},{"cluster_id":"2cb0cf7d-4f72-4e53-9096-b92c1763568c","members":["48106139-5b3f-4a6e-9465-2a535b8dff53"]},{"cluster_id":"86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218","members":["2363ff10-3235-432d-913b-658d5f2453d3"]},{"cluster_id":"0c0329e4-9982-4d5f-9450-241c86955685","members":["7d9ded32-cfd4-472c-b8e6-639d3e8e7c2b"]},{"cluster_id":"fcbed875-f592-4e43-93ba-c1c4ead8d38a","members":["2d731179-770f-46ec-8cff-cdc71213ab2e"]},{"cluster_id":"2010e740-a26e-4489-a685-8115e3933580","members":["06442e9b-bfee-45f4-96d3-f5cbde74c12e"]},{"cluster_id":"21e1972c-1d67-4f1b-a212-f7b911ed7f60","members":["859e3451-91df-41d7-9b35-30e293b2db5a"]},{"cluster_id":"3ca56034-eb2b-4824-906e-24d9da4948a3","members":["16a1efe5-5a02-41dd-9a47-0d530689fdf9"]},{"cluster_id":"708c11e2-cd61-4685-8e6a-35d93d6b988e","members":["60d005f6-07f6-4f28-9fbd-3287183b009c"]},{"cluster_id":"91ae7c53-2f75-41de-be44-6ce7a4b47412","members":["86683180-8d4c-43cd-93b5-f7aefe9a07fc"]},{"cluster_id":"ec613890-df43-48e8-bf2a-a40ccb263efc","members":["bf5f91e6-8c18-466f-a8dd-eac3650d3939"]},{"cluster_id":"c3c67b90-f64b-4b19-8a14-0325205ef32e","members":["014ed6d2-14a6-4b25-b4d0-56327e826885"]},{"cluster_id":"ad973751-acf4-4c7e-8032-3a95cf408206","members":["53cfb7f0-c2ff-4d26-a2aa-737cdc1dedab"]},{"cluster_id":"c784871a-fcaa-4345-b3a8-ae8869019499","members":["263eb8da-8c39-424c-b6a6-dbcad9df2dcb"]},{"cluster_id":"7eb7c781-85c0-4773-8374-eeb7374b471d","members":["afa073a5-82d5-42b2-8a5c-972cb0b1a9d3"]}],"event_clusters":[{"cluster_id":"0bbc69c0-3b6d-43a9-a4c6-d187b908122b","members":["84e152f2-fa18-4730-8436-ae5868f07e84","4c5754f0-e690-4c37-8ac5-89c6b1886ae5","e75e4d20-06f6-4d3c-bec3-b01d9ef39ba6","1ee8cf44-cebf-4220-a190-81aff7f6362c"]},{"cluster_id":"d64d430f-8c0f-4a8b-850b-225e57fc685a","members":["ab16a202-77eb-433f-a95d-8a5c32382587"]},{"cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8","members":["925e012a-7b2b-46ed-9b92-fee628879d10","c37dd408-ef96-42fb-aa14-f4272835891f","e163903f-04ee-4409-9f45-b8aa604b3413","7c073262-b778-4ca0-95cb-b243b7982ffb","e7868079-84ab-4879-9148-df64a7f540e9","5765f2af-b42b-4678-9a5f-69b58bd3a023","aa857a91-bc00-438a-a783-6a2f7a4230e2","c1c0f08b-a7e7-47dc-b2ab-3e7f98dedc81","04c77015-a45b-4365-9b9e-74d977cbc12f","1e20843e-0217-4c07-ac4d-1ebad8424cac","7954bc6b-c492-453c-9796-f6c5a5dfe4d4","d6e5d0ec-a287-4c85-aaea-293d330b05a6","9dca14dc-8e09-4ce9-bc08-504e8a677f71","51ced878-c7a3-4b0b-94ea-fe890b9f18ee","f83bdf2e-7c16-426a-9bf7-f80d7cb0bb3c","c2ff0ebe-998f-49d8-9a26-7fb72ec51dcb","2dc6eb24-8335-40ca-90b6-c9398dfa00c9","344bc6bf-1087-4258-874a-612ea4554b85","fb718e29-8b18-4fcf-81ea-c75ba72067bd","33e94dd0-492b-499c-83b2-f52adabde777"]},{"cluster_id":"23b45144-23d0-44ff-aa24-9b637f465e0d","members":["970e6f4d-f145-4e08-88bb-8b775120a572"]},{"cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c","members":["ffb34bd6-7690-4d59-b1ea-e3df21125aaf","5a2bf5df-c9e2-4260-aacc-208208da8e1a","813a7097-75bc-4c0f-8ef2-db8268ff9773","6c2dda8c-ea69-4ecf-a0d2-8bbc59e85879","25703fba-ae53-45aa-b648-a763cd3e39c4","f2d0d656-bd3e-4ab3-a57e-5277628a2f0f","0ef1fdb2-1350-4739-9a5a-6090cf7b4a06","facf3501-0244-4305-9925-f7c9aa3bba25","d472a84b-ab39-4837-a279-74b14e2731b4"]},{"cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2","members":["8c5f4025-aa29-4b77-9333-f49a177101a3","746c62c4-228a-4f2e-a8a3-2d7a29e70163","36dff2e7-9a23-442e-a3a7-16e2201e782b","cfa63295-1a34-4cdb-8201-fc3619deef3b","c965ed77-55a5-4f50-85d6-97b66474f50b","f395dce6-501c-4bb2-90d3-d8e75b35a094","cfc8dac5-eae7-44fe-b864-2482df74dca6","cd239cb6-4ddc-4fbe-b1a3-4efb0781c923","5146a220-e5e7-48de-9436-17e028427749","6f09bd0c-0e65-4bb7-b328-075cce279abd","f4e3a9e3-3c3d-4ab1-8c3a-b7b4f00b7da0","f7b9b2d6-8f53-43d9-99fd-bb3b69e7b89c","48b3fcf6-2759-4a7a-8c1d-a26c0c29ee77","e291a5da-d21f-4619-96ef-ce2d2ff75968","1319e96c-f08f-4509-8966-9cca047160d7","230d6126-a06f-4719-a4e4-ee47b7d9dfc8","be27228c-d989-4f16-9133-a47c0cc58596","15321a4a-1154-4fe6-89f7-f3e8de6e2ca6","a76f28a8-e514-4778-afec-dbf62ede3de5","9d86fdf6-7f59-44ca-b7a2-4f9d5dde13c8","68f43613-d2ab-47fa-b7af-29833557ed2b","574761de-312b-4720-bbda-afab392d4054","4064f9b2-6d78-4be6-b53b-8c5fb1755764","9193020b-9629-4752-b592-6b6478600257","3c1dfdeb-f300-40f2-9032-3094fe4645c7","ff856f4d-0e11-403a-982f-e86414ddea01","9a96fed9-679f-4d77-8bae-cfea4c180fe9","d9cfc5d8-142b-4158-8b7d-58772f988b60"]},{"cluster_id":"a712c5f0-f65a-4cd7-abf6-1f0e442746d4","members":["9a10a4c8-d6d4-40b4-afa3-7b1430b44a12"]},{"cluster_id":"2cbbdb0c-fd37-40a4-97e3-351c65d658dc","members":["1b3be0de-f336-4d77-9018-5cacd2638d84"]},{"cluster_id":"b8d995c0-360e-40c1-b216-5c539da3c67d","members":["8293afe9-596b-46e3-9a99-a40916ec1804"]},{"cluster_id":"3ad13608-e9f5-474c-8ce2-26cf09394813","members":["5cf646d1-647b-4ff5-a477-efe2d006cc48"]},{"cluster_id":"84ed6834-5129-43f4-a029-0b28839b357d","members":["395a9807-e7a3-4ab3-94b4-498e499a5709"]},{"cluster_id":"12d63e10-92df-43d1-9c3e-5149ff60ae94","members":["bf3d4f0a-3cf2-40bc-9347-70f81eb72707"]},{"cluster_id":"2197b0cf-d748-489f-aa22-936ee02a0c14","members":["04f15057-3aed-4d7d-a1ce-a1ed60652382","babb07ce-6461-4c01-8c46-35291a233a46"]},{"cluster_id":"3ca85742-8366-4a09-815d-244dcb1111f9","members":["cee770f3-7c9f-4178-9c74-654b0a079459"]},{"cluster_id":"0212de6c-9c69-4316-ae96-331158f2438a","members":["69b54743-69ff-4a08-818f-3f34fa3103f2"]},{"cluster_id":"e10095d2-279b-4481-ac92-6fd4df698726","members":["b59a915c-4a63-4d9f-a50e-20ff35f19092"]},{"cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9","members":["951c2a71-d688-4dd2-895c-f68662968dc4","01cbf676-2b81-4b2a-825d-68b1a2870483","17f927ab-9b78-43ff-8cd2-151101d87067","c1efc833-9789-4e82-b10f-013ba81a9a7c","14be8132-51cb-4f2a-8a62-0eb16f84241b","19c8dceb-ba49-4083-9bd2-9bf694c04895","d7c58d96-458f-4f49-bf5a-18b1b8b77ae7","61bedcf1-152f-4e4c-8cc2-f36e308c8054","d0c5ca2b-230a-421a-8ff4-fa02093493c5","d73463a1-5438-4300-ac9d-930dadca166a","d1e1a312-d14f-443e-8ecf-d5749a4e57f4","31ec4e9d-d48f-44e2-8a6f-c7bd59206baf","db314afe-80f3-46e6-b3e6-34d6477bd634","c5ef65de-3e9a-4d95-b685-671192868f4d","a71d8cfa-f5e8-4f18-998a-6204aef07bc1","eae1880d-3590-4fa9-9cbb-842e0a396bfb"]},{"cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2","members":["94f80ec4-2cc3-4557-83eb-9dfab510cfa7","3a38d6d4-0713-4982-8aff-3d58bd79458c","757568b7-5fb3-450a-a580-24ec7dcfa129","190837d7-d1a4-4fd5-90d4-a7a51760571a","6a6ce671-7575-4245-941b-223ed81a25d0"]},{"cluster_id":"628b9939-51f6-44a8-83a8-ac677a42d942","members":["cddf823c-29ba-406d-9d4c-a908fa0144cb"]},{"cluster_id":"97818d6e-d8de-47c2-bddb-148ab8c2d1b7","members":["edd2b72d-6442-4656-aab4-f03a4a38c553"]},{"cluster_id":"6a63b515-0915-46a1-b528-3651a558693f","members":["2add510d-82f0-4d5c-9dc5-a97ddccba76f"]},{"cluster_id":"771ff184-5478-488e-90da-69f2d3b1dfbb","members":["305fda9b-19da-4f40-8a6b-dd9dcd2e373f","a2d274d7-5dcf-4eb7-81b7-622b8e2e97a8"]},{"cluster_id":"37a93514-6b4c-403e-9a3e-4ceb074df89f","members":["88a4b9ac-a4ef-4d31-b258-078d5929dfa3"]},{"cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c","members":["9becb736-cbb7-43af-b42b-e7efd7fcafaf","0640f999-82c9-4245-985b-1c046a916479","d2b529d6-7af6-4f04-957b-b557fb40ccd8","e10eaa2e-0fc1-44fe-af4c-61b04e674d8c","eda9cd0e-6a9f-4236-8a98-031b010dae5d"]},{"cluster_id":"6d563374-a7de-4d4e-bf0b-d89a34f47ac7","members":["0911f635-e117-4a63-960f-87a757d833cd","50d01ee9-5c85-4fed-b808-8d69cdbc9da8"]},{"cluster_id":"d7ce0029-7c2c-40fb-8d24-32029ffa4b81","members":["cd44330b-fa1c-49b8-889e-4f60abb1948a","f84bd64e-b7d5-4b67-b03b-4712251d4a81","bd5ac819-2c81-4c5c-af79-03220d8e3334","123b1d82-f1cd-4622-86c1-30cbc193b7d7"]},{"cluster_id":"57d05796-d479-4bb6-8a2c-cdfddd5731a7","members":["a1663ab3-1573-41d6-b61e-125f36ef72b5"]},{"cluster_id":"2e14b451-260d-492b-b69f-85a48e166493","members":["a6a07057-e2be-4abb-a102-d1ff864ddae5"]},{"cluster_id":"ab7feba4-a1e3-49aa-a70a-5a191501e657","members":["06716448-d748-4bcc-9d29-709595db86e6"]},{"cluster_id":"5abf2d27-62a3-4f2a-9794-398729b78b13","members":["23f1861f-9600-4e6e-bcda-e17290f2aa90"]},{"cluster_id":"72967666-4eb9-48c4-a9dc-dc51036d287d","members":["39463f3a-f93e-4fc4-81fc-fbf6f203c465","8ddf5fc5-3bf5-41e0-95af-544f8ff32143"]},{"cluster_id":"36ff0bd5-8344-4d31-824c-e7dea3acb3e6","members":["73ef133e-2e7a-4d4a-b9c2-0afcb4bbdfb4"]},{"cluster_id":"1f4a4adb-de76-451d-aa05-57dc41f8014d","members":["88583943-069b-4732-b145-80a54a783005","04b492a5-c4c7-4b19-bb3c-45a7054015bb","e1934da6-d4f8-409d-be74-719425fd79d4"]},{"cluster_id":"90a7e868-64e0-420e-8b7e-dbd99dcaae03","members":["a560f278-4f3d-4e87-a291-dc062e6e9562","c81b5cbd-4f13-4372-be7c-e7e77aa70d19","3bb9c600-54d7-4db5-80d5-f9e07ae9b04d"]},{"cluster_id":"05133a93-3ffe-4993-9c55-47f240923f20","members":["9aa968e2-cdcd-4bd0-ae6e-db3b7a550990"]},{"cluster_id":"39719bfa-8761-4992-b42f-7b9ea44519ab","members":["7350d91d-6408-4345-9369-78eb520a02d4"]},{"cluster_id":"58d84750-75e5-4a06-9053-f1a5a8baf564","members":["fb703d7b-7566-46ce-87a6-338cbccd27f1","36275120-af4f-4f42-937b-825cf7b1bba5","fd6df1e7-3ca7-42ed-b882-b39f19350f40"]},{"cluster_id":"fe5794f0-39d5-4958-9baa-650967c24ce0","members":["9463f49d-31e2-47bb-aeba-88b26e0eaaff"]},{"cluster_id":"9bdbcd6f-9804-4d17-b1b0-8bb5670939d2","members":["618c1ef0-a692-466c-b963-89ea7243c3be"]},{"cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14","members":["bb1bd6e8-303f-4ed0-9dfa-3f0919d2e099","a6160e6c-5484-40f4-9600-e21d9ac905d1","42c2c04c-9907-43f9-8431-3121cb83ddd5","3022932c-02eb-48c9-b138-d812dbb39ec7","b95cbcfb-1859-44f6-8426-cefe788205d4","69ebe80c-dbb8-47c1-b3ac-0ff61794fcff","ba9c253c-7260-4ccb-b433-2cf15d3e9217"]},{"cluster_id":"8c274c4a-42e3-4136-9ecf-91adb76667f9","members":["8adee013-069c-486c-93d0-9361c778763b"]},{"cluster_id":"dbb1fd32-5705-43e8-a68b-a90c6757768a","members":["c9763a61-b691-4150-a4d6-286b290ccac9"]},{"cluster_id":"f6fe4656-91eb-4bf2-98b2-cfac47bcc12d","members":["c1c46137-389d-4bf3-a508-0df6760ca0ec"]},{"cluster_id":"24658627-4999-4848-a061-5b2350a4cf4b","members":["61c505f4-7c2c-4e12-8853-97ed1f2b95db","cf85300d-422f-4309-8986-fbd3de9faa9e"]},{"cluster_id":"aab98ee7-4c57-4777-942d-e109c08eee52","members":["63d361ed-d80d-486b-96b3-587c68b4764e","03a0c294-e976-4333-841a-97588c9807cd"]},{"cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f","members":["0348d2b7-6176-40f0-8b89-d8fcabe47875","6505bf7e-a28b-4f90-81af-8e8806402064","42258c5f-d0e7-485b-885e-3e3bfdc304ed","2e57aac3-7da7-4f92-88ab-1a2534a142cc","6b7ea435-638a-4b49-a8ac-7dc2acf3df98","fff1af7e-274b-4d88-8915-f7c9ff6bb7fc","7779dd72-ca1b-4c1b-9903-d28e8dc1faab","abcf1a28-13cf-40e8-947d-de677b477c2d","53564912-43b7-4dc3-b199-27238fc54085","1aa4a657-e845-4ac3-8dad-66938da4aa28","915f5621-6d1b-4b9d-aa6d-d4e936f4532c","141eae5a-1061-484d-80c5-2ea0fa66e353","bd97003f-74ba-4fd8-b575-c82690bdbc1b","369fae54-d19e-45f4-b266-bf30cf97a1aa","65bfb0ea-7932-43c3-913f-5df60038e8ab","60b4df88-018b-4498-9d6b-675151d5ae0a","910b861b-ebe9-4983-ae71-fcbdde128309","1e771bf3-49a5-44b9-9445-735d725cfa2c","a1355bbd-fdad-48a3-8e4f-5b2bbb3471d0","5602e0f4-d219-40d1-b7cf-dc9a28d01309","37d99c23-6cd1-45cc-92df-c11680a66be5","ce51a3b6-4ec1-4741-9641-e65ecd97209b","586ec689-5403-43fe-b4c5-d134115e8f07","aba505df-97c2-44ee-af3c-185123d8d571","50663370-4f1d-4512-8b35-0ed7418f2bf4","80f2656e-a02e-4cab-beb2-a1f99619cefe","10b1b3a9-c651-481a-b1e1-63205a836346","fafefd80-e2e8-4b59-8a21-8df1b96decf8","b34d7d81-77a6-41f9-866c-0d5d976e923a","02863339-38b5-4c5b-ad5c-759fea14668f","44c2738a-f13d-4a49-b5de-f70fe3e55d56","9ed82274-4dfd-4a08-9cf0-e54b6ed05a27","94175f26-ab9a-4fab-94f9-cceb21ab1ed0","55243c7c-b698-46e8-8008-84bface2b7d6","2617e451-8f84-4920-b2d0-2ef415157476","84a2dfe6-43f4-460a-94a1-8b232d4f8d88","3095f1fa-376e-45ba-be02-3c582ac40c20","91f9f092-8711-4eec-8493-04025fd5e3c9","036b26ef-e527-40b6-ac69-92cd098d5a15","9316f4cf-149d-4a01-bb74-cbc75ae143f7","00de697f-97cd-4ebc-a9fb-9de4c1fe389a","f0b78019-fc88-4133-87c6-d5dc3b5ddf72","747298e5-3a4f-4b7d-97df-c50347bf7bb7","136e92b4-2535-4767-a92a-7ba13709179c","c892815e-ba02-4fbe-aaf9-7e5ab8e32444","eed4e8b4-0522-483b-8749-518e3904ed41","9cf44ede-37dd-4147-8e93-89a5b38604fa","b3c7c16d-d44b-42a1-86e3-3bd88bc2b166","dc3b4953-1867-4ab4-9561-7206fe782a8e"]},{"cluster_id":"12ee6320-67eb-4e37-918e-874e1948fd36","members":["458962f4-39a7-49c7-93c4-ffe550b06aef"]},{"cluster_id":"e6342a31-63c5-4e60-b405-bead23c2ee06","members":["139b2601-d9aa-4412-b035-49159c4fc066"]},{"cluster_id":"a42bed59-a9d3-4a76-b9d2-41f637803b1b","members":["6db163de-95c0-49df-b814-1d89da588703"]},{"cluster_id":"9610bc6c-2c1c-47d3-bb20-3bc619407fd0","members":["fa3b2a1f-10f3-41ec-9d6b-06b8a56e9f91"]},{"cluster_id":"84df1dd4-8c28-4b8a-bdf1-47af884e70e3","members":["5bfd217e-b4e3-4698-a671-853a469c1a85"]},{"cluster_id":"9ff8b495-2fb3-4416-a1b0-68b8560f98e4","members":["262c9c9c-f3c5-44e4-a1d0-01947c0c5501","90a9d5a6-f8af-4493-8fa5-a42bb8db9d4f"]},{"cluster_id":"636dbb94-cbc8-4c79-b785-6d406b28db48","members":["076ebc36-d450-46a6-ba2b-2a82d07b55d3"]},{"cluster_id":"a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7","members":["c3488754-8e08-4402-b2a0-85331fff963b"]},{"cluster_id":"1b8daac6-2959-408e-a7dc-dd102f0defee","members":["24a451dc-483c-4c83-90ec-f9810c097d83"]},{"cluster_id":"b3c5d56a-6d97-4291-aa82-9075fd6b93ba","members":["ba89b7d5-0234-4982-ab98-56b648aa5a9d"]},{"cluster_id":"e069f39e-fe04-4587-9d2f-1992b7189502","members":["47c5cbc0-38ac-4145-83fc-adb129b8a28b"]},{"cluster_id":"1f760b40-15ae-43cb-8956-bedcbe236708","members":["ecc9b611-102b-4b4b-b0a9-3ddf7f7a28fd"]},{"cluster_id":"32516088-d496-4b04-a09c-540561be5921","members":["07778b1f-b8cd-449c-ae6c-5f704a14dccc","780ed672-740b-42db-bbb9-1c3cfe15c884","da7bede6-7a01-4a88-8ee2-8487491580d2","b8a644d1-1a59-4a57-a12c-3e97043b444c","d55a0a6c-e4ad-4aeb-9e20-2b8b02de62c6","4fe6f1c0-42e1-4624-9724-0f3a607b1ad5","8a80fc92-c2af-4e5f-b8b1-efbcffb2cbf9"]},{"cluster_id":"7b263d1a-e07c-48cc-bbc0-8a228f72f292","members":["e1827af4-5212-4e67-9651-9f7cb1021ab5","7b4a72aa-0324-4d1b-9335-9805b28f7966"]},{"cluster_id":"e98042df-e94b-4a67-8387-fe8218853a1d","members":["3d943bcc-f75f-4abc-9e2b-6abbbfa07af8"]},{"cluster_id":"4a667d4b-a464-4833-81f6-cd5a99658ce5","members":["a16a0af6-54e6-40ad-b4d6-0580573f8262"]},{"cluster_id":"a2f20d4d-0860-445b-aa4d-0a748d8d1f73","members":["ce9032db-2a19-40b8-af12-ec438a6ece7e"]},{"cluster_id":"ad4af428-e855-4639-a39a-60d90249fe21","members":["9f1e0b10-f3b9-4110-a148-2ec0f8f50515"]},{"cluster_id":"7cd53b0d-1bfd-45ff-a900-1bdfd6e403a3","members":["f565afca-6eec-40ab-b60e-39070f028961"]},{"cluster_id":"a821fab7-385f-4999-8399-e63f4f07d4d9","members":["d3b19056-328f-47b8-b4af-f85f9656a684"]},{"cluster_id":"cc656b46-bdcc-435b-a7d6-1b15ef3a32ad","members":["452436c8-3d1b-40c3-8efa-d978e367bc75"]},{"cluster_id":"c193bcc0-0d98-4b99-869b-53885d805dc1","members":["a803e4bf-7243-49a0-af5f-2029ff92b91d"]},{"cluster_id":"ec791f7a-6542-44c8-9d59-4679b8301276","members":["405388de-0b9e-4980-b174-36e7f057144b"]},{"cluster_id":"e1005ff4-1bb8-462d-bc29-153ca1f78b3b","members":["5f074750-a6eb-4bc7-b8c2-bb71a36d7d7c"]},{"cluster_id":"6f88a50d-7c8b-451d-b706-e766cfe9a47a","members":["2a6fc254-1269-458f-8a30-9f2f870a60e9","32a66506-57c7-45bd-982c-36465c065377","8af9e40f-53d9-4962-af42-2b1b546eae95"]},{"cluster_id":"800e3797-9c0e-40b0-9390-53c562dabc15","members":["8adb6909-17d6-4caf-931f-a2874497a9d5"]},{"cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8","members":["d2457389-c3d9-47cc-a513-cab7d7fdc8ca","258ba6cf-e3b4-48da-aa2a-505f8615c449","c60d8400-68ef-4604-95a2-0f5b96a38f78","fdec233d-6dc1-4acd-a0fe-ee5a2450d5d2","faaf2a04-99b6-4eda-a468-4babd23b34ed","b0ef9cfb-447e-4a08-8801-cab9d103a008","6db7bc6b-d875-4968-a306-ba8cd0b84592","f702eca4-3df3-43f4-ba88-8f82b221f0c6"]},{"cluster_id":"3ff9d247-61b1-4db1-b0eb-87ae85150e08","members":["1e96ff68-3faf-4f64-9309-c3fd81619485"]},{"cluster_id":"3bf26de2-8578-4eb2-a0d5-5c4deaf0246b","members":["38ab785c-3e01-47bb-954c-90b12bfbbd95"]},{"cluster_id":"4863edc0-3025-4ffa-ba81-0d1ed977b2b9","members":["cda74b8c-f8e1-43b3-97ea-f10b8662e7d7"]},{"cluster_id":"c24c8055-1228-411e-82e6-d5cc151796a6","members":["15d565d3-fd46-4488-948e-1e1d2ec92989"]},{"cluster_id":"25676d7b-137f-4f70-b3ce-39af6bc7a4fe","members":["33ac0e90-a934-4be1-8500-d703efc8fe1d","654f84f5-583e-4aa7-be94-d3c0d95c5318"]},{"cluster_id":"238a575a-ac72-4ae9-8880-72409a39a327","members":["53818edf-d20a-4280-b405-d6631088ec3c","7bb2184d-04eb-4cc5-9bba-24bbaa1c88fe"]},{"cluster_id":"bbcaf773-6ffd-4bd3-98a9-fd76783316d4","members":["15fa5012-49f2-4fe0-b2fc-c036c78dfe23"]},{"cluster_id":"450543ae-8630-4e48-a375-9699e4cb6925","members":["c71e0105-7c15-496e-9e5d-9ad87554a6d3","88a3dcec-9c0b-4238-9770-91adeb6a711a","1cecf870-454e-441f-9f74-fdca57707139"]},{"cluster_id":"c595259b-ebf4-4c2b-b3d7-406a6b1c52ac","members":["f594392c-a4dc-4c76-b795-28d998459538"]},{"cluster_id":"cb33e750-c57f-4e58-a355-2b249b902a62","members":["cbb81680-9122-4150-9b14-5fde22755d97"]},{"cluster_id":"bdaea9bd-1088-4933-8486-42634bd70322","members":["21faff8f-7b2a-4bd9-aa48-b3fff46bdbf8"]},{"cluster_id":"e3cd63c9-b877-4cb4-80a4-d872818bfe3f","members":["c4fc88e3-814b-4889-bff4-556056c4912b"]},{"cluster_id":"41d69a2f-db55-4c96-81a9-27bcb85442bc","members":["bb138d5e-1bd0-43f8-8c6a-e0c9519dded0"]},{"cluster_id":"84977d14-a5d8-4f51-965b-c09f3c5a291f","members":["e875ca96-e4d0-4af7-9a3d-1428f4ed7a9a"]},{"cluster_id":"c4bed539-a0aa-4ff8-9be3-4afa92598dee","members":["d38c0d0d-a75e-4854-8acd-8ce2ba04c25a","31c21d42-48d3-4ff9-a7b1-3b2da97242bc","d6ffd937-63c8-4937-b8bc-2680e5603706"]},{"cluster_id":"d18f265e-1140-4ce3-9bf4-76f0c6ccf8de","members":["5c86b624-3bf8-41c0-9ef3-0881445603c3","7d27a311-e2d7-4230-9432-759924944e8e"]},{"cluster_id":"32ad70e2-6724-4b9a-a0c3-bd70b56126d0","members":["8f904b01-783a-4203-a9f8-4d3a6e7a90f3"]},{"cluster_id":"b816fa39-a961-4930-9c7a-6091dc870326","members":["c1cdb795-eef3-4d83-b2cf-fc7b4f142e4a"]},{"cluster_id":"0d5de813-beee-4fba-8db1-09461ff50d02","members":["38a40083-ba49-4c7e-b6a1-0d8ad9e16a68","3496e957-884e-4e03-b8ca-f518cee17c14","9935cc06-404f-446f-ab6b-5ab2fb7602ee"]},{"cluster_id":"46d5760c-bd0b-4c2e-8270-d2debd9f3dcb","members":["586c490e-494f-4e24-87a3-09fb08b48cf5","7361180e-2a2f-4df7-ae35-2f45e047a9e4","7175103d-b7f9-4570-85a2-673f72108e12"]},{"cluster_id":"f8814fc7-2279-4d32-a22e-1e33adf9e995","members":["f8ad6006-14cd-42b8-9f41-ac32b1e2a1c8"]},{"cluster_id":"701985dd-4322-488f-8c88-ea50b9053ab8","members":["38e9e7d0-ff0d-47f5-ab45-be36a362e697"]},{"cluster_id":"4b36afdb-64c0-4dfe-8f4d-501930c59107","members":["33f06504-34f5-4ddc-9f7d-6977df239b00","4dd03931-2066-4f6c-b70f-aff356e9b46b"]},{"cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9","members":["09f3b156-9142-4170-b82c-d6e48fd74216","c545c24e-620e-4274-bb42-f77c2c191bba","e4c84464-0a89-4baf-b942-1308b3b32900","d3f8fc98-2bd0-4e1c-84ef-848db8385d6e","feb7be62-542f-4fda-98d2-d62b041b7e4e","57a02ad8-4448-44e4-a141-520c03160428"]},{"cluster_id":"ebbce66e-0d97-4659-a453-e44542e8d915","members":["0547cf7c-f4fc-4f88-881e-f354799d394b"]},{"cluster_id":"8bdd7aea-e82e-44ed-9306-49ba0cde454c","members":["99388c57-039d-4450-a2ea-77d39164f936","e7ba6c83-fd4f-4845-861d-7416006c77a2"]},{"cluster_id":"a4ef4316-1b40-4ce1-b5cc-ef7ada4c3a2e","members":["de0877d2-e5b8-4dc0-abcb-4d999de7b03d"]},{"cluster_id":"4d6eed7e-0404-4ccd-92b2-df5956550e67","members":["af8c4621-5743-4ab5-b75f-a10982b627f3","7839b325-4a85-43da-856c-b57c97205728","19c0c942-6db9-406c-9807-f992d3e1b895","12390c88-6802-4a75-b1f8-15c7a30d1011","041a4de6-f275-4268-a290-15cab46201b5"]},{"cluster_id":"317ecec9-87af-4e3c-acd4-372de58135a0","members":["e68ea319-a743-4063-8a6b-a57f7b693345","7dbda8b7-6dc2-4f99-9efd-c4b25f52bec3","3d6ce7a2-691b-4ee8-8fa2-4899f39986e3","9d0b0b48-481f-4015-8133-45d4dc81c3c2"]},{"cluster_id":"7f22f643-051f-4c46-8fa4-209f55a6aff1","members":["d295f0d3-9153-4814-85db-70ed8ee95007"]},{"cluster_id":"f5220f5b-8931-4ce9-bb6b-eefb8c206ace","members":["9fde4b91-1e88-4275-b6d7-a293610dfff4"]},{"cluster_id":"73ef4f09-b38f-4c98-bd02-c07cf7fc2073","members":["f4f24cf5-1439-45d8-8416-872bde8b9671"]},{"cluster_id":"db350168-e89e-48c8-a5ce-3b8c59130017","members":["820dbe4e-83e3-4ea1-af12-b4e14d598494","1db17dca-a60a-4963-ac75-6614e7621bf0"]},{"cluster_id":"4f84ccb5-4935-4023-8826-9c08d0da261a","members":["28bb7190-953a-4a8d-a25b-abfc2ded7b69","8ef6bdf8-6bb8-49ac-aba7-8d88ee45e8fa"]},{"cluster_id":"5b79ee45-2abd-45a2-8873-e58d11466b36","members":["67aeabae-2f28-4de2-9c18-746e97c6ff30","17b8c008-0413-43ef-8e62-1b3e41a4a0c4"]},{"cluster_id":"e0d33feb-9779-4cf1-a571-59040d3ea8f1","members":["9d4cf030-6541-4767-9e93-bb36756e465d"]},{"cluster_id":"29477fdd-bbbe-4e39-b779-19de18778240","members":["2a085237-4836-4154-98f0-9f710d9832b1","e1188dc5-0c3a-40ea-b10c-c1a4ce18f3f9","f39a7b76-7b7d-4b55-b6f5-022ab5954c22"]},{"cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240","members":["9e3e000c-4764-4206-bac6-bdcd3f0133d6","55ed0ca1-fb2b-41c2-b3cb-33ec62c3e4e9","5088ae91-c41e-4b3b-92ac-10fb6253f083","4c0b373b-ea92-429c-a7ab-0032bb94ca10","76b329bb-fe43-4d94-8dc1-903b6344d0c1","2bc6299f-653a-4d72-baa1-8b71416e12a1","2882fc70-2d99-436c-9600-d832cb340c87","681e732b-6457-4afc-be2c-ffa829b4b6c4","7cc31dcc-0efa-4e05-a02e-1fbce072139b","4a3d5220-cb8b-4170-ac6a-98c32da8fffd","f223b73f-a2ba-4f6f-946c-77a1b03ec42e","646b569c-f662-4221-962a-ee7e0f3a48ae"]},{"cluster_id":"338cf48b-ad2b-4dbf-8d36-1e19e9e04681","members":["2f24c199-c87c-411b-be26-4f3f75b8cd6b"]},{"cluster_id":"9cacf170-b6e2-4913-a621-eaff66a64541","members":["2e9cc47a-173b-422c-b53b-2f26ae0482c1"]},{"cluster_id":"fe271a39-4283-4ba9-9f74-a4db31cc4b3c","members":["9ffd3bc2-8394-44e0-8da9-eec5d9fbaa87"]},{"cluster_id":"55a8e92e-7501-4ea5-a3ee-b628a536a6f9","members":["504c325b-a327-4bc7-9702-a9c23fc4826a"]},{"cluster_id":"8245fae1-2de7-44c3-b580-0a610d90519c","members":["0cd08bab-1c16-466b-9d97-d512cdb3e045"]},{"cluster_id":"aec45825-35ee-46b7-b2b8-bea6a7f40f69","members":["37fe491a-4683-4a84-92a8-9eb4d4f308c9"]},{"cluster_id":"1541313e-804f-40cb-bfb7-78850471987c","members":["87740410-18dc-43f6-8b3a-dfb1e442eef4"]},{"cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02","members":["2dc81d64-1251-487b-8ebc-c1e96d5a010e","67a93fc9-671c-47e0-aee7-dfb451276b9e","1e8f66d1-24b7-4b3a-b1ee-0a878d3a35c8","31b7ba04-1249-4c6b-b648-190f940337f1"]},{"cluster_id":"3680c45d-b58c-4b06-86cb-3a65bd43ebc6","members":["cc779605-8036-4dcd-adc3-6a7f8ced5971"]},{"cluster_id":"a14e07b9-7624-46b7-920a-7b615bb8f39d","members":["466b0be3-a108-433b-ad5b-8aab49d16b31"]},{"cluster_id":"1e84c102-c60e-427e-9c32-95517ea67008","members":["66e492cc-628c-4066-bfb2-29d02e77d639"]},{"cluster_id":"777f19d6-a14f-4d35-a3bb-15bb93dcdf4d","members":["76c8703d-7904-486e-b008-51a836c2d852"]},{"cluster_id":"76d7e29b-d686-4238-a931-2118cfe1bf3e","members":["96054146-c21a-4c87-97f2-9161af7b504a","4e4e81da-6501-4c86-a385-5525a45585fa"]},{"cluster_id":"e0229a55-a637-4111-a422-27c8a7ddb0b7","members":["62235204-50c1-4ae0-bd7a-5bb86c3d0d34","db796729-ef7d-4250-af39-af43585a2e38"]},{"cluster_id":"42f681bf-3cec-44f4-9b59-d7168d922923","members":["b76e1028-54ea-4e7a-97ff-dcae5e37ba19","180acd4d-4778-4c28-90a1-ca94875592fa"]},{"cluster_id":"abb66c4f-f4a0-43a2-8032-f5ceeec7f058","members":["87b0077e-0141-4590-8618-4d3583e7cd53"]},{"cluster_id":"7b66a014-a3c8-4296-b622-d0e9055b14ee","members":["7b56002c-8c94-47bb-8e98-a0489250c31d"]},{"cluster_id":"71e63580-38d2-43b7-a5b4-b06b93f3b79d","members":["ce112929-14cc-4e58-8382-26363d0b1a18"]},{"cluster_id":"f1a3e12a-c3c3-4476-aaf7-ecead6148d82","members":["c1ee117f-0c0f-494d-be3c-0eb8b31c1078"]},{"cluster_id":"419042ff-8e55-4ecd-bd38-c47ada6d614a","members":["e5400c13-6955-4e7f-8ce1-97f02f2581c4"]},{"cluster_id":"fd129e43-f4b3-4fda-a189-8dcb11486ddb","members":["5d4bf37c-3e45-47b0-93d1-4452450157cb"]},{"cluster_id":"cfc42d88-49ac-4610-a5c7-0cce12304171","members":["2ea4834d-e0b7-48fe-978d-3db1b6cb1c5c","054735a2-d878-49d2-a85a-78ab7f20b354","5f12de65-de31-4eb2-9198-02fe51497958"]},{"cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7","members":["ca18db01-64ae-4f7b-af77-b58223dc999d","dd631f5a-6080-4281-9adc-8fdb88632983","69d0969d-9f05-415e-a0ac-fe2a141abd94","22930da2-2dab-4788-a79f-737b7cbe2160","80af9af0-d58c-4a6e-ac4f-b9c6247b5718","b40c1e53-d4ad-431f-9d68-08aa979479f4"]},{"cluster_id":"944bd314-7efa-4d4e-ad2d-2a560ec194da","members":["4cc69e6b-088b-456a-aa2c-66bb5cda35da"]},{"cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046","members":["e2ae750f-bd2f-4b8a-b113-685b1344db2c","aa902029-1061-4cbe-9f1d-9be774e8fc3b","2c6b89e1-e849-4daf-83a2-ed6eef4731fd","492a03d8-43e7-45a3-a2e5-13f7ba6ce2dc","001367d2-684d-4b59-9805-f097572ee62a"]},{"cluster_id":"35d10df6-7929-4a0c-9fc1-b26cc3d884f2","members":["74eece4e-027a-4fcd-a614-30c38e2df8db"]},{"cluster_id":"4e7a1657-2c4e-4bb2-bcd7-0842a01bbc47","members":["a9042610-53a1-49f6-897c-4537a68bd04a"]},{"cluster_id":"7640b35f-031b-4917-bf34-5555111a4a74","members":["24cb8c6a-0ca7-47cd-ab09-f8ccf313d3cd","048c95d9-91ed-4ba0-abf2-1ba5dc8c1617","62b4e71d-6e74-4807-808d-08787c84c8af"]},{"cluster_id":"426f797a-e7ef-4bf2-9d6b-e35d76bd66ff","members":["338a6e3b-3418-4a7d-941b-ec10b497cb0a"]},{"cluster_id":"56712450-0dee-4fc4-899b-8d6600a516cb","members":["b9016207-12a5-47c8-abf0-886586d3945a"]},{"cluster_id":"9a22d933-5b51-4f1a-93f6-12dfd9a6f37a","members":["90b2621e-baa8-4075-aa10-ccae5c1cf0e6"]},{"cluster_id":"eb5867fb-4e30-491e-839e-081457361ded","members":["bb22cdd2-06b4-4469-a87d-4c76ab4fe0fa","0e002bec-5fe4-4d7b-9e0e-353142b25b67","8a4b6346-bdb7-45ab-b8e5-216e21331f64","a2baeb15-6e10-4fd9-805d-c5d5f7720324","6d6f556d-e0db-4156-a673-9ad50fc2fdbd","6da6f4c0-936b-4b29-9006-5bf428fde525","4947b34a-d70e-46a6-abf7-55b3d0fccc5e","68889765-9ee5-49d1-b266-6c9e6048720b","eb7f51c7-52d8-484f-be71-f870e79c177c","65415f11-d162-41f9-a436-55fa225f8ce1","bde37614-97d3-4d15-b062-c738dd33f745","9ebbd19c-1b2c-41b2-9e3b-01e96f03ba4f","56744768-0e76-42ad-bfc8-a7813124b91a","9866e716-7537-48dd-956a-7bf35f3b3741"]},{"cluster_id":"93b80413-3a5d-432a-887d-e727cb82d2f6","members":["3e6db30e-ded5-4658-b27f-d0cef081d848"]},{"cluster_id":"ce112f29-472c-464b-84ff-3d5acaf22d38","members":["8d853396-b772-4678-8b21-d54392993e09"]},{"cluster_id":"cb0a8f38-8b40-4637-bdbf-1d9a5a12407f","members":["94ec6777-664c-4b7d-9759-39c0d7a2bd4c"]},{"cluster_id":"befb7ee5-b118-46a8-baef-495aee63c618","members":["e747d535-762d-4e0b-a2ec-e3a175575171"]},{"cluster_id":"920638c0-7694-4767-bc82-851ade0b1652","members":["afe1ead5-1aed-474e-985a-3e97a9a02c20"]},{"cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03","members":["a2acefbd-c6a4-4b32-a8ff-3bfbb8c45adc","f5025228-2ba3-471c-b1c3-23a1505e1738","4d490a29-9d11-445f-b79f-a6dfcf6b674e","6f1c091f-2d5d-4ccf-9148-6a7144b3728f","f8ddd071-d05b-4c10-a854-e72bfabfc89b"]},{"cluster_id":"ae19516a-2181-488e-ac04-088ae5ab7d84","members":["1b6d7754-0f5f-4684-a918-e2eec4807eaf"]},{"cluster_id":"ea03e48a-fe82-4735-a7d5-db2e5351b982","members":["dab780cc-2893-405e-9364-778210326efa"]},{"cluster_id":"0e7e5665-e1ba-44c9-b9e8-62d3501bb81c","members":["b95529c5-7b9f-48fb-9a4c-37ab0a491330","c046e6b5-72ee-496c-918b-4be3f500e0ba"]},{"cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6","members":["45df0e47-67dc-407c-a742-cab16d53dbae","fc9326d4-bea3-465f-8300-9c4cd0d0d64d","44c4e67f-e11c-4a5b-abb7-d66838bc1680","7c3b8401-43bd-4f8a-b967-6e2bb3c08280","0118ddd2-f152-417d-9b54-05cf86103a1c","2d47fdb1-a065-43d7-b9d4-8e29ea65754f","65085434-99ed-4d57-85cd-82de6d7b4516"]},{"cluster_id":"8e1bc392-1f79-4373-ac66-b625742b75e3","members":["e9bf8f60-c979-49e6-b95d-09ffc6f94217"]},{"cluster_id":"f65902ca-8669-4b7e-9388-0fbc20879e59","members":["b37f56c1-d8ec-44b6-9f51-71bedd748aad"]},{"cluster_id":"60b6a6af-f010-44f3-a632-e0a93f1ed5d0","members":["19b39938-7518-435d-8045-b77bcd17e92f"]},{"cluster_id":"3112aa1b-4574-44ce-bed2-c9c9be423dbd","members":["764a63e8-70c4-44e2-8685-71474c046ffa"]},{"cluster_id":"292fd491-c6f3-4ec8-80ae-030ae0db7baa","members":["dec1b8d9-e6fd-4204-91b9-5acb9e4a20d3"]},{"cluster_id":"cc6728f4-4d83-4a2b-9077-fcd32909b298","members":["5f07a8e7-1b2d-4df5-b547-53edbec94853"]},{"cluster_id":"32b69cec-10c5-48a9-adbb-1a38afa40ede","members":["8fb7f94c-b42a-487d-a2bf-e75d6472fdff"]},{"cluster_id":"aeb6169d-c89e-4c20-9127-6438583dd127","members":["8c93f48f-cd97-41d7-8071-bf33f5ef5a27"]},{"cluster_id":"4d4ab9a7-62c6-4187-97c0-f07bf059ad55","members":["287eeae0-30ac-4391-8e0b-a92604678a04"]},{"cluster_id":"a56532e0-90ee-496a-a60d-c01066fce560","members":["8c58258a-054c-4c2e-a256-0c03f926b4e2","4e9714da-d06e-47a1-a14e-0febb6ad3390"]},{"cluster_id":"29022861-4975-4c12-9a9e-92bb32cd1e85","members":["2a64b747-3eff-40c8-9171-4394af0a45e0"]},{"cluster_id":"51d0514d-a16c-49e4-8ac6-e122e83a4777","members":["4b7c9126-7687-453a-94c5-617255028897","1b7ef4c2-1108-40b4-9481-c4e4be2b09e6"]},{"cluster_id":"1072cae9-f711-4ddc-9b33-a14d4050ebba","members":["da7fa7b1-a74a-439e-85d2-687919f7c128"]},{"cluster_id":"3ba6caab-43f9-4e86-aeca-830be9163573","members":["c280d2d1-4e95-48f6-911d-93b54fe8369e"]},{"cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3","members":["8064bfc2-7024-4f06-9497-986a1e975c0f","52439a57-ace8-4f0e-a58e-2ea25ed850ba","a71b831a-178e-4862-9a84-511f15e6709d","3a18f009-e0b6-4e80-bf48-657ccaa32702","2a85d5f1-e5cc-45b3-a1b3-97e6e9999e08","8a336d3a-0a98-4e49-a5b1-dc54520f9680","1a5b6ba3-e0fc-4c63-8ff0-c46957cbc8b6","0c4c6b51-6c7e-43db-8c57-33e148f4390a"]},{"cluster_id":"cfb29440-b86f-4923-96db-5f6b8ae72df4","members":["09c142a4-5c80-4531-a037-d8568610ded5","10e12017-766f-4a88-b89e-72b4241f43cb"]},{"cluster_id":"456f0f19-c43e-4805-a01d-f15d26323d29","members":["f78c939e-82d0-4c4f-a838-fd1250ba7971"]},{"cluster_id":"14d0a92d-65cb-4881-998f-aed067993e99","members":["36cf21d5-796f-4744-9cc1-a42f82021e3d","bd5cb87a-089b-4f5c-91da-e5d1d1eca347"]},{"cluster_id":"e42d141d-80cc-4e68-848e-2d85ecf6a58c","members":["ca063694-43d3-4dc1-a538-2895b55cceec","25181eed-c798-4390-b9e5-2b733fe0131c","ccebdffa-4ee6-45af-9997-498fa76ebdcc"]},{"cluster_id":"c92757d9-a065-4dc2-806f-96c7c9890f76","members":["a57107be-6e07-4363-94d1-0ebcadc66c0c","046df810-54d5-4ea9-9d48-26543a907c8c"]},{"cluster_id":"8ec6c014-24e3-40b5-a577-20ca128d6e41","members":["496fb930-7235-4aa3-b62e-868b8ab98f1a"]},{"cluster_id":"f8ba093e-142e-45ae-b5d0-aef007993c05","members":["4f52da85-e4c1-4efd-9478-eb694741c62d","8e3d0510-fe87-4f90-868a-80eae47ac2ea"]},{"cluster_id":"4adc477b-ccba-4820-b5c6-6a663398b338","members":["5cca2f98-a550-4a3e-9542-da2e648b992d"]},{"cluster_id":"aaa9c952-e937-4295-abaa-c4968a415009","members":["71749530-08cc-490b-b851-4665970d6156"]},{"cluster_id":"59d2954b-c33a-4e1c-87bb-ce014430514e","members":["97914efc-b72a-45e9-ba29-907d16d037db"]},{"cluster_id":"dc2b6524-3e37-4978-9dbf-854499aadeb0","members":["47427ce7-8514-42d1-9bea-9650fac07e2d"]},{"cluster_id":"6ef4a6d4-b9a1-4d80-ae23-e54049cc7170","members":["5ee94827-5ae5-42fa-bb8f-1a2178f4e6a2"]},{"cluster_id":"28705389-d7d8-40a2-9a03-e4eb35877525","members":["188d2a63-2cd4-4b15-b11b-b29437874cc5"]},{"cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e","members":["9d0656e1-91a7-4568-a8c6-6145a17c6c4e","637e855b-69a7-450a-887a-26e9d48f94ad","87a6bcaf-9d2f-47e0-bd9f-67b9b1645d88","fa88a2cd-c10a-4c93-a187-e5e358d897f2","2aad08c3-7a9d-4088-a0c8-7173322b568e","ef45ee2f-a90b-4522-a5ef-835dc927c319"]},{"cluster_id":"1be249dd-37fb-4d60-8a83-484cbb6bc5e1","members":["e4d29b02-ebaf-4515-8642-499825b90c32"]},{"cluster_id":"5cf0a8e1-26c0-4c2d-bf3f-608120510569","members":["ed283ab5-9f4a-4aa8-b6ef-9d773773c737"]},{"cluster_id":"0f0292cd-5ed9-4b41-be37-f307be9f4e80","members":["bcde2733-2496-48bf-8dc7-e7b39c4fde0b","850cf0c3-c0b7-4270-a07b-2845822447ed","22b8c6a4-fe2a-4fac-b173-004611eea7cd"]},{"cluster_id":"8a12c9b8-6999-4708-96d0-9b9b5cea643c","members":["e9fe3473-b79a-428a-b152-938869ca5bce","f0065d0f-c46a-428f-9a5a-a696aeb5fac5","27af4d41-3321-43cd-adde-e2cf8cdda644"]},{"cluster_id":"4035a796-2dee-4cd0-986f-eb64d79cd560","members":["a2b525c1-f547-4226-9fd2-d90a827de375"]},{"cluster_id":"a400da3f-ddc6-4851-b855-065d3f101c71","members":["08f06c6d-d2b7-4425-a7e5-ec96e91f0466"]},{"cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c","members":["e8aa4390-6332-4929-b285-0ce0d69d2812","eb7cf401-50cb-4091-952e-3b6afb69fbfc","2b377322-508b-4291-976a-ef44e85e47f4","228dafec-172f-4d6f-a160-297e589c447b","1371df07-807d-4c84-8049-638650fd3c90","037ebe25-c4a1-4188-b565-8419ca9a9ad9","03e3beb0-ecbe-4656-bcdd-f724ae845e9c","e8580e4b-012d-486d-b924-72b24ddb93ce","1b4302fa-4db0-4d8f-9ca7-83cf593a5a08","1a25a97c-fb17-4d43-87d7-ece424c49c11","5279d4a3-a951-4943-b696-ec9d2055d349","d0b97879-7a8d-4815-88e9-070893f31d88","65fad128-4613-43ff-b921-391965d5747a","0692b4d7-b7aa-43b0-903f-54db8a567957","391c290d-4d33-46d1-a6fc-ec24553a697a","5f1040ab-f1b0-405c-9765-93d1480dcc96"]},{"cluster_id":"eff3ff70-7d42-45d0-a372-4aa15bf9f280","members":["1a11be3a-b17d-4777-a790-4e41fa0143cf","98bf6bd9-3571-4fc4-a522-793f28993ff1","e0bbe7e4-58e6-428f-9c40-667d31c60035","476a23f9-b992-437b-90c5-f963e8166938"]},{"cluster_id":"af0ec0ab-3b4f-471b-b656-e88e02335b8a","members":["098c1a39-fa6a-4fc1-bcc0-0f833a274e1e"]},{"cluster_id":"08ccb8f3-d97c-4442-b830-fac7f751221a","members":["350a513d-eaad-4ca4-bac2-fd018fe7b558","e9675adb-0f21-4945-b4f2-dd37623e09f8"]},{"cluster_id":"241d256c-86d7-484e-8aee-4f2f15316b3d","members":["c089cd94-21ba-4043-9f02-b312ba442b1b"]},{"cluster_id":"43787e95-8e23-4c32-ad24-6b1efd3b0be2","members":["e2bd56d7-c3a9-4fc6-a07b-4c44e736665f"]},{"cluster_id":"e3e5aa95-d1ae-4cc4-a1f6-993b699c2d34","members":["0ec34392-7927-416a-97ed-ede221ecb2c4"]},{"cluster_id":"a0c6e4b4-7d8c-425c-8ff1-2b999fb65fda","members":["cae69692-e77c-4bd9-983f-d7e0a368a1c3"]},{"cluster_id":"9f686d1d-9231-4037-982f-0d37e6ded860","members":["556c65b9-2e06-41a6-b9d3-5ced8e2b68a2"]},{"cluster_id":"d5f07507-9281-4cfd-81bd-0fc19ffa8a89","members":["b3bcd9d2-ee33-4858-b64d-275faa36fa1a"]},{"cluster_id":"3fee6535-a988-4207-9d1e-737120abbcbb","members":["8cd731d8-8d53-4a4d-a07f-c15214766715"]},{"cluster_id":"42dcf3d9-1011-484c-9355-4db97109e640","members":["f8527199-6830-4e21-a052-7f5c6b8ecf3b"]},{"cluster_id":"729b06af-76d6-45d8-b842-1a087ece3b39","members":["1005cfdd-f328-4004-887b-6052f4bfa6da"]},{"cluster_id":"f45eb579-66d6-44ec-ab0f-e41545f58c6c","members":["a1d85e0f-f4ca-43fe-8c73-3b7382a9f07b"]},{"cluster_id":"6274b067-d713-4a61-a1f2-5f2f2d2df7fa","members":["8bbd3f20-f76e-47c4-a33b-75e14299d88c"]},{"cluster_id":"ed2f46ec-4300-4232-969b-86017e6c6546","members":["b62e467a-7383-423e-b2db-36022673bd12"]},{"cluster_id":"c9858cae-3215-44c8-9820-2f7cde47d95d","members":["3892000c-47aa-4755-8d1c-d759dcfcf658"]},{"cluster_id":"9b0d2d04-ff3d-45df-af3c-018b55e1eabe","members":["2c900a2a-cb87-43f3-8e60-e63de79f3846"]},{"cluster_id":"db5c7092-c228-4319-b130-e75471c29ec0","members":["fe4407e1-2c58-4a48-aac8-8738ca900cd7","ded85493-80e4-4f5b-a532-744960395d4d","c3b5f389-950a-448e-a93b-cbc1155537cf","2ef0b41e-8e8f-49b8-9316-58dfe374c259"]},{"cluster_id":"c7b0f267-0192-4ba8-86e6-09f6ba274d4f","members":["20fff54e-3944-4c7f-b960-6c30b9553484","914a2057-3abf-4b5e-bf8d-7a86635735ff"]},{"cluster_id":"0dc901d8-d48c-4458-a536-133dced8eb99","members":["22ec386d-2816-4822-8a28-ff0303dbb36e"]},{"cluster_id":"a35296f0-09b1-4344-8dc2-fa3ee1b2f399","members":["ba0406c0-1eb5-47f0-8568-1e8cc3246f72"]},{"cluster_id":"0afcbb16-75a7-45dc-9f96-97e351b50a83","members":["4064599a-92e3-4d1a-861d-e5dcc4543c95"]},{"cluster_id":"c41e3b9a-0aaa-4ffd-84fa-92acc0346b56","members":["71b4d6aa-c10b-42c5-a855-7e4f76bf6279","956b3170-294c-47bc-849e-3345201fda22","b79c0518-028b-42b2-a7b8-55238d2da5d2","675a521a-b49e-4a50-bd55-7b385ae2368f"]},{"cluster_id":"b252b9c3-5126-48a5-aa3d-32d7e4a0465f","members":["eff487a7-144b-43ed-9bf7-a81b8eb300b4"]},{"cluster_id":"75fbf587-2351-400e-b397-a778510d68fc","members":["862e5564-7ed4-4431-bc87-301f42a6f9ff"]},{"cluster_id":"47b5a921-4ec9-4534-86e3-d697a2a00470","members":["cb7d24fb-92ea-453e-a2e7-23ee01a5bf14"]},{"cluster_id":"00851827-de5d-4b35-bdc2-fc5215bce29f","members":["3bceb9ed-308a-4d20-9e15-e43ed722a41a"]},{"cluster_id":"f5a61f8b-83ab-44ed-b769-3208e32281e7","members":["efc25508-34ea-4b2d-b056-e09159f5e65e"]},{"cluster_id":"3d6b711d-93be-4839-8934-425368c03327","members":["8beb0182-4a6d-4773-bace-6843617f1729"]},{"cluster_id":"80a8b2f6-3818-4f88-87e9-d88c26c8754c","members":["9a99a603-b48a-42f6-a5cd-97faca06e3f1"]},{"cluster_id":"d96ea11e-5d88-4a27-8ab4-66bfb4326c28","members":["c1d329c8-b5d6-4cc7-a6da-b13d361d2b9e"]},{"cluster_id":"e73d69fc-6584-4fb7-b72a-84be1893ea0f","members":["86a0d544-0af2-48a1-8dc5-6ce0fff5551a"]},{"cluster_id":"ec98b249-f085-460b-ae00-454dc52d3f17","members":["34aecffc-bfee-4e91-b571-37c65138c110"]},{"cluster_id":"41741032-ab51-407b-85f5-a7d6f97ca5b8","members":["913af525-e568-4c5b-8ce4-89da8089677f"]},{"cluster_id":"331d66f6-8c23-4632-b4ad-7949a81b62cc","members":["9600bcc7-d0ab-41ed-9a55-cff1567158c4"]},{"cluster_id":"f18619a4-4f58-4ae8-a9ef-fa5f0bef0daf","members":["e19958bb-c864-47ff-b697-31925e6f45d2"]},{"cluster_id":"8eea3c6d-083a-481c-aa84-30005023f301","members":["034cc14d-278d-40c6-a14b-c9f85da480a8"]},{"cluster_id":"c92bd461-8266-4e4d-aba8-e4cf7e3c1fed","members":["b7c9a674-5222-4e76-8357-23419815bd79"]},{"cluster_id":"98ea14c4-be20-4ab3-b8a0-74207d1ea94c","members":["1a9cafe7-86d1-494b-902c-873da5aaca74"]},{"cluster_id":"0e90187a-faaa-48f2-ae7a-c2764c47dffa","members":["5766004f-5539-4fec-8594-aff527a3c6f4"]},{"cluster_id":"302853ec-6f10-46c6-b305-6047ac1af892","members":["aa4cef80-f44b-4276-b5a2-2b391127382e"]},{"cluster_id":"ed2bff61-1872-4dec-a024-4d1c3d21cddc","members":["e20f2626-174f-48f4-bc51-5f4f6c668dfc"]},{"cluster_id":"22db77fd-3772-400d-bc1d-2826b96b8d9c","members":["aed3a285-b1bb-472d-8c99-be38917e4ee1"]},{"cluster_id":"00bd60e5-bf2a-4d15-8ed4-8906838875f9","members":["dc6d7b6a-8093-4315-aa36-84690a1ab200"]},{"cluster_id":"e90ef9df-5189-4af1-8d38-f4bc22fa022a","members":["8e8c4b4f-9c03-46d7-8214-d6ddcd586c7f","b1af2bea-91fd-482b-8051-a51dfdb38a21"]},{"cluster_id":"f74c2283-95c8-409c-8db8-ce070f2c2a45","members":["cee5220d-75e6-40f4-8c6e-3dc54f0cc12a"]},{"cluster_id":"94238db0-c74d-46ae-8d32-ad4eebd6753f","members":["12c8d553-539d-44a4-916a-2115adb302e3"]},{"cluster_id":"61475130-6f49-487a-bec1-f17a9209af5f","members":["4dba2a71-3b72-4530-b7d1-3035aab05e0a"]},{"cluster_id":"a1787db1-8710-47fc-b234-f265a8dd366e","members":["07570ec8-fe9e-44ab-a378-535f60a98aa8"]},{"cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284","members":["340b926b-ada8-4988-88a9-06af47219f36","9cf74e25-9924-4266-bdda-c3b792219632","308b0fbb-cdf9-4b3e-bd75-a035c3989203","38d6788e-799f-4d5d-8d97-1d8b7c99665b","c2557ada-2ecf-4c1d-a428-6aa2952f7811","c73b9e35-7577-42d5-87bc-e70a594c5ae6","dbb3a021-512a-4c53-a16e-530b1fe8ca13","f6142039-3fc7-4af3-a3a9-87d0c7da5003","2a20c42f-31d4-49e4-9328-7b3282f6e95c"]},{"cluster_id":"28019fcd-ae8c-42b5-8f8c-7fa226a5335a","members":["d2f49b39-a8ba-4bf0-a777-027f04ee78e2"]},{"cluster_id":"2830c0e0-a35a-4015-a0c2-75079b518aa2","members":["61bd6e7e-caf9-4c9f-badc-e923a4398824"]},{"cluster_id":"8bba2d5b-a20c-44b8-91e1-9dd72d1e1b07","members":["e680d741-d0d2-417c-a836-e077af2c5147"]},{"cluster_id":"60930e0d-3823-4b8f-9390-0e719aa7b09e","members":["fdc6b92f-6215-4eca-b466-b494c9508aaa"]},{"cluster_id":"ce87133c-df51-4ce0-8569-5d86ba96f3d3","members":["692464af-4268-4b2b-a4e8-89ceb16c5307"]},{"cluster_id":"2be461a2-6406-4213-9577-fc7e617af34f","members":["f4fc46ca-6b73-4af0-94c4-688c0051de69"]},{"cluster_id":"3c37960f-c2a7-40e7-ba67-6890fc5f05e4","members":["2fe63ed3-3ec1-4910-b184-b5af8e1eb5c1"]},{"cluster_id":"81eafdea-26c8-4b44-b5c7-5cd6a9bfece5","members":["da14c251-f3e4-496c-aacf-4d16d5c0420b","59d20052-ccf1-4c25-ad4f-5086069feef5"]},{"cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c","members":["d4af23d7-6dbe-4a13-92ea-f8860568b19c","091f83e3-bba0-4e4a-bfca-8d8aa10aafa8","ed9b7284-387d-4093-ba08-d501f3fb89ae","3a5825b4-b7fe-443e-baed-008f74f91a28","396176b5-f265-4891-be47-52b337eb773a"]},{"cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23","members":["82baefd0-b223-41d2-a271-b477a89ee344","f73f876c-af9b-44f5-a348-0937fa930305","80eab4aa-e080-4ddb-a409-7928e2405d96","39d81057-c893-47a6-afa4-6c36c27b7236","8b689eb0-99c2-4b6b-bec0-a95434f5c6b5","b09a9896-1292-49b9-9661-23c3fe0cec8f","a6bb481b-95ed-4927-b068-02899e5acb8e","305809ba-0615-43e6-9a5b-5171703b2b34","f47e498b-8eae-45e5-8bec-baa76263240f"]},{"cluster_id":"86a99b16-df58-43a2-b7eb-e1d03c6f6e5e","members":["7b26b50c-4dd1-4644-9689-84dd0433369d","04c0c80a-9c9f-4838-807e-9a86f6df2526","debe366f-8ffa-4a17-a0ef-0aee5ed2f924"]},{"cluster_id":"a18f54d8-98f1-491a-9d47-c6333890fc51","members":["f9d77bc7-f0c8-4518-9725-14cf3100fc4d"]},{"cluster_id":"325eb390-c83d-4040-b800-a93e29e11141","members":["5d30f3af-649e-4a09-9a10-e989577c7ade"]},{"cluster_id":"7af9dd75-d833-4cd3-b3d8-08e6c743ac05","members":["5fee4a2d-aff8-4df9-be77-17e0c65b5b63"]},{"cluster_id":"8bfff308-f565-423a-9de9-6f9eeebb617f","members":["86eb9930-5dc6-40af-b50a-ba48949c7f89"]},{"cluster_id":"c695ae29-6241-4eba-94f9-8224687bf1a7","members":["0754569f-7dde-4001-b445-2b9905332dae"]},{"cluster_id":"2bfb03ed-8bb2-476c-9ace-087ef4a35f09","members":["6ff36566-6826-4d97-b606-43ba3e46ea05"]},{"cluster_id":"75a7abcd-ccae-4606-800a-89412da639cc","members":["f3807869-b8a5-43c8-97e0-aefd9201fe00","00d72ee4-c25c-4509-ab7e-63cb9ee79800"]},{"cluster_id":"782b5668-5ef8-4d83-a8fc-b6464fbee289","members":["093fa1c5-1ce1-4a27-8af8-eca7b7f8cbf7"]},{"cluster_id":"ae81b069-06de-4c85-affc-804bac2e778d","members":["ca1da258-49e6-4a70-aeb5-e78a1b90c123","ee196b61-e304-461e-a463-d5ae45a016a4"]},{"cluster_id":"4a259022-df32-4e4f-a09e-afdcfddd1eae","members":["ec5286c0-072f-45c5-a076-4567fa7a532a"]},{"cluster_id":"91e8fe58-f0fa-44e3-ae52-de74821a1034","members":["4f2cdb73-7039-40b5-a2f7-b262f95f8559","6638cc19-c306-44fc-999e-34ecb6344f36"]},{"cluster_id":"4c365f8e-324b-474b-8239-fe362d8fca1a","members":["ae65d107-6eb7-4313-9186-f3cbb1789d11"]},{"cluster_id":"c62e089c-1780-440d-b990-8342bb6836f8","members":["91ccb453-5fb0-4cb4-bf34-baf2b1b34bf3"]},{"cluster_id":"b8c71793-7735-4b85-ba5a-b3e53e437f73","members":["d652b088-92b8-43ab-9e9b-a599a32f964a"]},{"cluster_id":"b4051cdc-a4f2-410e-b138-2b773f319a22","members":["528448a9-71b6-490f-bae3-1cfa996191c8"]},{"cluster_id":"10df36b6-9ce0-4838-9b29-8a4b4c151281","members":["2fc47767-208d-4cf4-832f-59fb3b8e97d7"]},{"cluster_id":"65583e7e-9600-4791-b957-579c81276f1b","members":["5068d9e5-ee6b-4935-b62c-464f72b9018d"]},{"cluster_id":"89d55cf7-6d3f-4328-a78e-26c777948edb","members":["7bd320e5-c8a0-4493-b871-050f0d769f51"]},{"cluster_id":"d0e8c17f-ac7a-4857-90ac-8a31224cb44f","members":["4e8f6b10-a2ac-44db-a4ca-fcdc8bd5de91"]},{"cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5","members":["cef362d2-7e39-43ef-9824-cb10d85638c1","b1f1eb74-be8d-45bb-b878-aeb4451b3315","9d3d7a4c-8dfa-4061-8966-1c80e104d1dd","e3b9f8a4-eb6a-484a-a53d-e57425a80639","8713027e-2d87-46f0-8c1c-d199a2b4a510","3ee5c31d-14a2-4f64-be3b-b972347128e3","54d08603-b334-4505-85e4-2e560ce4f257","e711ca11-d42c-45bf-9930-5701725b1316","bd37a9b0-e07b-448c-bd28-89d7129c468b","9520f831-fc95-4505-b1ef-f59d7c4babc9","29cc9f60-6154-4ad6-93d1-6804d8134a36"]},{"cluster_id":"bfb1dcef-eb53-42d3-9c74-0d949ffc43a7","members":["94535f85-af39-49e1-8579-790d85f2072c"]},{"cluster_id":"af4322da-0cf9-4a56-9b07-d10c70b336a9","members":["53b4f370-ab1d-47ff-aa92-c4be63e52fc3"]},{"cluster_id":"abbfb703-6da3-4a58-9c1e-a58cf34e5030","members":["8dd16a15-63da-4b55-ae8b-3840364bfdeb","d4854f09-6b5d-45dd-ad64-57ee66a031ad"]},{"cluster_id":"2ffd0f52-9465-49d4-9f47-900078ad3209","members":["e6f80efe-99ad-40fc-9b5e-7b0f5d024763"]},{"cluster_id":"fc384be2-9fa7-4507-96ed-913cfeb3e5bf","members":["0dbcac4d-824a-48f8-8554-df0bd03f3ca6"]},{"cluster_id":"8ea40711-b70a-408e-8b0e-c86a36b4d669","members":["b1fcfdf2-64b0-43ec-b1ba-68b56b3335db"]},{"cluster_id":"16c38934-13c5-4d45-a617-8e2638f6597e","members":["73df9d94-7df5-47d9-85fc-37c3a2162b6b"]},{"cluster_id":"e622291d-8809-42f1-9ac7-ff3aba01b794","members":["b9a38b44-ac73-4f47-83a9-657082aae0a0"]},{"cluster_id":"3ff7a6c9-67a4-434c-ba42-8e735f72fd34","members":["91f8878d-9aaa-4359-94f3-12b9a5498f11"]},{"cluster_id":"f81472fd-0486-49fc-92fd-9753ce76f44b","members":["159dcdc5-f266-45cf-a278-23a9f95d31a7"]},{"cluster_id":"8c0047bf-e6f3-48a4-98c1-a7a466922ed8","members":["4effbcdb-9e1c-41c1-a3f1-2b6024fcf64e"]},{"cluster_id":"94d7c196-e914-4792-9ae3-448475f12021","members":["ff2a10da-8e67-47af-b406-5835519d3357","a6d12d64-4e35-421c-bef2-f601d348316c"]},{"cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5","members":["f12a6b76-a059-4df6-ac6e-ae2b26ccc9e6","80eab844-5ee7-4d91-b64d-53159cfca350","4063fbc8-7b7d-4331-850a-655023233079","3c13d2b5-6089-49e4-9322-256539a27b03","e00d5c72-1582-479f-9bcc-d377cd91304b","9f69dfad-b79e-4698-a00f-9c9919cf9cff","cdcc4cb5-2bec-4805-9a7f-cd3173409efb","ce8beb5a-1438-4adc-a947-a64fd2fb1c03","4bf80e3a-27d8-464d-99d4-867b4ef33b10"]},{"cluster_id":"b9cee305-a96d-440f-a08d-e2f6545e2608","members":["540e3ead-5b5a-466f-ba8a-dcbaf8fdd5fc"]},{"cluster_id":"8a84554f-19d7-41fa-8647-c3608df3d4f1","members":["db3aa80f-6044-4a98-bad7-82c93249331c"]},{"cluster_id":"bcbfb3b5-386e-4a9d-9149-63379d147048","members":["cd930d5e-8e35-4acf-bfc9-8cc6042ef7d1"]},{"cluster_id":"9917626e-0afd-495f-82cd-6e27aa8cc73d","members":["dbff6aa5-b76f-470d-8bb3-87dc3497b774","08a8e2ce-1c6e-4368-a829-680c4555465c"]},{"cluster_id":"e56b6c3e-60ae-4144-ba92-480b792e396d","members":["92519052-196e-4492-808b-4c95581ebc32"]},{"cluster_id":"09e091a4-d9df-4ce0-ab1e-d30b85568ee5","members":["13e91f18-b948-4979-90a2-5cefc638595b"]},{"cluster_id":"8f6bcfb4-e69d-470b-bf79-44df803a0002","members":["a71ac078-651a-47fb-bbf7-bfd8e459584c","cdcc6f3d-5b6c-4e81-9e04-05d8810ee886"]},{"cluster_id":"13bcef3e-fd19-4989-b312-5873b1468a28","members":["8225f2b8-fa81-4508-9347-72e066b4edf5"]},{"cluster_id":"f9c2516c-da15-44ca-94aa-e9d013d3a430","members":["749e270c-0df9-4de6-a9f0-b30fed003e8e","8324920a-9890-442b-96d7-0dc92b7918e2"]},{"cluster_id":"05b6cfa2-c45f-42a8-bb0c-d50df97483f9","members":["2a76e34b-09d2-4203-838a-c7a7f41d1fb3"]},{"cluster_id":"54050443-7613-4bf2-affb-d73ac2c76683","members":["920f6e67-114e-40e7-b689-2c784158a87d"]},{"cluster_id":"71cb88c3-3bc3-4a98-bd39-7a91efe626a8","members":["cf8f4415-e018-4f89-b75a-ff0806218bcf"]},{"cluster_id":"32aeada3-2c0a-4dd6-b828-1733cea88e6b","members":["6bb0a5d1-8ecf-4b8d-a603-564da52db3ee","10340ecb-3315-4a89-9a44-9c2bb1cf8484"]},{"cluster_id":"919dc1e1-6cb7-4d54-aa99-504278bbf1f4","members":["934e714c-0c64-467c-9d29-ee93627e25cd"]},{"cluster_id":"aa7dc853-a837-4fc7-af4d-cebbf4726b31","members":["2a957629-1994-4504-bd4e-5a500088abef","aa56ac21-7511-471f-8f06-f604afabce09"]},{"cluster_id":"e4d7e062-89f9-4cad-84e1-ea4d0fd566d5","members":["731ec64a-4fdb-477e-93d9-8d4ca3a8f3bd"]},{"cluster_id":"089a2747-9d4d-40cb-b33d-a36918c7e7a4","members":["f42e9730-3a71-4a1b-890b-dc79bbe5e142"]},{"cluster_id":"54fd48d0-d138-4133-9478-030523c0c632","members":["5d211f49-cdc5-4a7c-89e2-24c4fa6e3193"]},{"cluster_id":"cf284659-5e8d-4417-9c7c-b41b8155ecf8","members":["0e4f9b6a-ce2a-40dc-91b6-b874ee651eda"]},{"cluster_id":"5f74295c-f7d9-45d9-bee0-05eb4d5113bf","members":["db797985-3f3c-4e0c-86cf-ff34d2353f0d"]},{"cluster_id":"b959db9a-a488-4838-97f9-4b51827755fb","members":["f9a5d31a-8263-45f1-b471-f0795fd547c4"]},{"cluster_id":"13e53d6a-9b30-4b10-9f27-0687c15666b8","members":["ab3fb0e4-f741-4b2c-b3d2-bc1e0de90aaa"]},{"cluster_id":"591d0c93-3cfa-4639-9dee-c69a3f6b0f9b","members":["c1b698fb-9634-4b3a-9c21-2a7cbeb5b38d"]},{"cluster_id":"c25ff750-8a41-47e3-b517-245284092082","members":["a7315e32-6b37-48bb-bfc5-f72a2a24db1d"]},{"cluster_id":"a144123b-7815-4a8e-939f-d8124e0d4a23","members":["c8179441-57a7-45a1-8f23-9c4a01396d6e"]},{"cluster_id":"ba65859b-0b3d-4140-bf84-cf55b1252051","members":["db9eae80-bfc5-46f9-8c22-e744bf40dbc5"]},{"cluster_id":"c1d9eed7-6c9d-4c45-a896-47b8c389cf48","members":["f195824e-e406-4010-8b24-ab80840f08bc","d681260c-e06e-4422-826a-30eb58a9eeae"]},{"cluster_id":"e64ee1a2-9226-4d61-b0d3-bf9e52dc9982","members":["689326b1-b3d5-4344-9142-6513e77f8e88","10d9dcb1-82e1-4045-acca-984f4a4e6b55","7075c1bb-4e96-4d35-9f62-d6e8832d3809","6dd190ff-6495-464b-9ba5-23b2d0f6fd1b"]},{"cluster_id":"c39ad689-c540-4985-928b-b1a54e619b06","members":["d8bdd26f-c6d5-4c04-86db-c78c94c932de"]},{"cluster_id":"3e760dc6-7f77-441d-bf0b-d687031ab57a","members":["54aba49f-e63c-4131-b8e3-5be975c2c899"]},{"cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171","members":["b9059891-c143-4807-aba9-bde4721cb9dd","af00b07a-963b-4f13-a913-e5d137abd6bf","48871f40-b374-43ad-acd0-10030f089443","285be22e-0747-41c0-b4f1-f4dadc6756a1","e24b553c-a7d4-4b94-bad9-2938a45a2352","e31cb900-b1ee-4f20-b242-745cf43b93f5","8f8bd225-18e7-459d-8caa-6c1a605d96e0","d3789df5-39f9-4f88-9edf-85bf0035efc4","839b62b4-9b33-4648-88dd-6cc8e85f656f"]},{"cluster_id":"93707dc5-36b1-4b18-b721-a98eb38368ea","members":["2cd3f4ad-58ef-4698-a39f-3378d8ff0c5f","b8460d5b-4ae0-43bc-b8e6-8920c60104dd"]},{"cluster_id":"9fa5ddc6-feca-4449-90da-8b78638fa3ce","members":["5b52b8cf-5ace-4757-ae69-7a7fe7c09434"]},{"cluster_id":"edc6ba48-0632-4236-9c24-f67f26e9b96b","members":["592787a6-94e6-48f7-b5a6-5665f686b8c9"]},{"cluster_id":"6a14502a-8c63-426b-8062-c7e8472786ee","members":["70da14db-5840-44ae-aa98-53daa8ed6bd0"]},{"cluster_id":"21d331a6-d043-465d-88ff-572098f9f48c","members":["b299d081-9429-4b11-8274-4a51e14cc166"]},{"cluster_id":"7fb1639d-6541-40a5-8cc7-71943288089e","members":["fb9408d6-c971-413b-9cea-2e3322ba3162"]},{"cluster_id":"a1f32f8a-32f7-4bba-b1fe-edc8382be9e5","members":["0f2abd3b-64fd-49f3-971c-a1db3e57aff2"]},{"cluster_id":"8476cb8d-5c1a-489b-ac54-9099d01657db","members":["2b87a490-d010-4798-81c2-a3a0ed1d0082"]},{"cluster_id":"418a7cf7-657b-41b9-9359-c34faf7618d7","members":["7c5374ae-854b-4158-b038-318ea55733d4"]},{"cluster_id":"08ecb39e-a545-45c3-b7b6-8257d44a3e9f","members":["456f56c3-aabe-494a-a25d-6540a141d9e6"]},{"cluster_id":"70bd9665-a0ef-44fe-b03d-553c56604080","members":["7d6bd4a6-d05d-4b18-9955-b9692cd59be3"]},{"cluster_id":"9851f4a3-d2c8-418c-ab69-0b58a9726253","members":["a8e9a4dc-4d6f-418d-99ac-ea623698886a"]},{"cluster_id":"a5ca0f47-c2ad-4e2d-8414-673ee9a9e57d","members":["205dcff4-c5bc-47d7-ae42-47b01da83046"]},{"cluster_id":"504b2533-2c70-438a-a457-80634e246dfa","members":["931abfca-db8c-4718-812b-de8adb5d675e"]},{"cluster_id":"d114caf2-8385-480a-a600-9c4b33ae3a55","members":["a0cb6afb-ecd3-4526-bc22-bb8bfbd5027e"]},{"cluster_id":"3abfdae0-5ae4-404e-b93b-1d664986555b","members":["2132ccf9-08cb-4938-900f-a1a294b77a36"]},{"cluster_id":"f35fd313-149c-4568-ab38-fa2d1f029e32","members":["bb028d86-d744-4c84-a61a-3a184bc6c646"]},{"cluster_id":"a1ec3b11-8549-44c4-b19b-7113d02a1c7e","members":["d9f3e7a5-3ac7-4ff9-b5c7-57d45587e0e6"]},{"cluster_id":"e4af0ca6-d383-4356-85a7-09352d68c2e9","members":["cb829a74-e67a-471c-8f59-96b7c970d052"]},{"cluster_id":"af431814-360b-4c41-83d1-6147d4068846","members":["f2266466-c679-495d-aa32-a1547dd029f0","13fcbb30-b184-4dd0-ad67-687bb5a32710","5284affc-9a33-44ef-a031-0b316285fc1b","a889b71b-e769-4400-9de4-484e46923b84"]},{"cluster_id":"2bfeada4-b9e0-40b4-9be2-0655b8d49226","members":["5e58b411-987e-43e6-b1c4-5e9565e9bbc9","253a86f7-a466-4e40-9e0f-eedd68395199","67dff1f5-a16f-4d8a-8246-08683f4356dd"]},{"cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec","members":["dccc509d-c576-4034-9361-2b1eb47591e5","6f78ac5b-4203-4c69-a66e-58f34b29e192","499c415d-6d0e-405a-92ea-56852a59047b","7f2f55cc-063d-4542-a910-41b5995a8b43","7c2c28be-6cfa-4db3-8b1e-6de54c0cc24d"]},{"cluster_id":"7c1fc423-517b-4edd-ab51-ee1fbb6a01c1","members":["ab3f8106-b455-47de-9e0e-3c1b0ffb094c","bf525db6-d0fe-4882-9a12-8adcd84a4fd8","f4a93dcf-0bdd-4552-a02e-60e6535b598d"]},{"cluster_id":"f3e2df1f-8b35-4bab-b9e2-e82dc9f0ea1f","members":["f0f810a4-4ff6-4c29-a46f-40740a2f111c"]},{"cluster_id":"fec224cb-9f4c-46ad-af9f-03437451a2c2","members":["fc1eae68-c39e-41f7-8a4f-bf75fe7b9265"]},{"cluster_id":"e53b1b9b-ff90-4db8-bc8b-211c3b969cce","members":["6fda58f9-892b-49db-a478-679621b09c8f"]},{"cluster_id":"a316c368-440e-4c3f-a293-cbd2c8138a8e","members":["8cff213e-b552-46a4-b12e-65b8aca843fc"]},{"cluster_id":"009689fa-763a-4351-a069-4f29c46a8fcf","members":["bafafe5d-7c33-4700-a0e8-fbe832774ef8","c379708e-1d1f-4214-910d-94840f38fee8"]},{"cluster_id":"0affa6f2-96b0-46b9-acf1-01957217922b","members":["94f93f21-b399-43b6-8c1a-6dc7c2680520"]},{"cluster_id":"dbcfd453-3fcc-4846-b99a-9b5de23fde7a","members":["30ee29c0-7572-4257-944c-bfea6990238a"]},{"cluster_id":"f83e82a8-4441-4c96-b8ec-2b50e32532d9","members":["a949eb99-fee2-42fb-92cc-5ed10da638c8"]},{"cluster_id":"17a371ed-b42f-4523-bba1-0b6b3e65c57e","members":["f030637b-114d-4e7f-8d7c-eeda43cd9190"]},{"cluster_id":"64b86b07-89a1-4ba2-8492-bdd7801a5bbe","members":["e933f4d1-5305-4d96-b283-b161bb49c5d7"]},{"cluster_id":"4b43ecc5-2325-49de-80fb-8c71f498b44d","members":["c4e240db-18a0-4924-a3d5-b007ef851e0e"]},{"cluster_id":"902e4c1f-ffd6-4a43-b284-14e627b17668","members":["75b5e2b4-7f78-40b0-a89e-76e5a55f40ce"]},{"cluster_id":"f7ebd749-2aba-4604-bcc7-3f28208b0612","members":["53bc33f3-da8b-439e-bb2e-1ac545b26a3d"]},{"cluster_id":"b68b2c64-2b71-44ac-a7b3-c79fe12186bd","members":["d3c3e61d-d06e-4ee5-8174-28cc6ad30648","0316ccf9-6f70-4db7-8f6b-5b8c19d9d765"]},{"cluster_id":"0dd8b4fd-5bcd-4d2e-97ef-0ae1371a8f17","members":["ba9e2600-a590-4127-970b-4e2742cad854"]},{"cluster_id":"3f7ede9c-8bb9-4467-8e40-0d78aa0f2a1a","members":["611fc9fc-abfb-489f-b812-71a34196257e"]},{"cluster_id":"47cf0031-f643-4c3b-859a-e03a6b23d6e9","members":["62e9127a-fd2c-4286-9575-6887ef9060fa"]},{"cluster_id":"cb297a6d-5ff4-4958-bec0-67e510f9e369","members":["18cefcf3-97f2-452a-a1b1-b8e4c67b206f"]},{"cluster_id":"5cd2aca7-8312-405f-b073-d87b70cdcee0","members":["481d2f1a-071d-4f18-934e-8f3340af485e"]},{"cluster_id":"586b0585-af30-4d40-9796-01be4c00d08c","members":["8e764b53-09e5-435a-b7e0-d11593a27175"]},{"cluster_id":"a815c927-5e75-49a5-ad08-40e7381924c6","members":["ce7c040d-9c54-4fb8-a121-f8cbd3b50719"]},{"cluster_id":"a1395f05-6f91-4eca-a911-53f15292db71","members":["483c9e14-f9bc-41de-aa9d-b4464edf1721","ba84c644-7454-4df8-8b26-8847ed80bb8f"]},{"cluster_id":"3d95e05f-6c78-4338-9960-bbc4049a682e","members":["c49b0cf9-c099-42be-a7d5-d56311c0726b"]},{"cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163","members":["7b5c612b-1d79-44c2-8593-f25282ac9b20","1827b39d-2e75-4c43-b9b5-819bcccd1336","af79e1ac-966c-4bef-a69b-9adc9093c1eb","c38dd94a-ab02-4ef1-bb83-5b2fcecec724","2bc4fa4e-55eb-4fa9-9fb1-9fc1dd0ed0db"]},{"cluster_id":"be74618d-f629-43fe-be50-6fcf737dd820","members":["91047411-6884-495a-b270-1c812c9a5302"]},{"cluster_id":"b91a4bd2-e629-472a-9c82-852acf9ccef7","members":["59724a0a-a7ec-49be-a9c7-5332610aa537"]},{"cluster_id":"c52411eb-2b24-4b6d-9936-f82ca57ebb56","members":["a14530b8-0fc3-49af-a1c6-562df417f2f7"]},{"cluster_id":"d310e1f7-ee8b-4fed-be89-8b1baac91b0a","members":["dab32f1e-f3ae-4d6e-bf38-c9ee4ac23cbb"]},{"cluster_id":"d878f267-808b-4a23-9202-10d08ee3053d","members":["b23bc7bc-98f0-4012-b0f6-192ac391443e","f9c60b69-b6de-4c88-91b4-2f9ca3baf7b6","2bd643ab-04dd-42d8-8b9c-f459af0c1d6c","5fdb36f1-22ad-46b1-9e69-2e4bfe4e544e"]},{"cluster_id":"7590439d-277c-48b6-9bb4-812f83d4e421","members":["9efbffa2-9434-46b3-9ebb-519b727679f8"]},{"cluster_id":"784c345c-143d-4aef-b094-6eba2f83003c","members":["f7b613a9-3314-4b9d-bffb-61b6124d76de"]},{"cluster_id":"5549ed3d-7dea-4eb0-ad38-1dd76c667c0c","members":["20496504-fba2-4e08-90ea-6babbc089958","1535b092-2f4c-46b3-a6aa-0f47acfce530"]},{"cluster_id":"b38c1227-31d6-4991-a4c5-01c6af14c400","members":["876a5840-d36d-4596-9666-20f3ceda7779"]},{"cluster_id":"60cb910a-8631-4e58-9913-f906c1b2084a","members":["e2622e7f-1580-44d4-8057-8538c9966ca1"]},{"cluster_id":"07499aa1-3238-4e4d-b838-020f0a58eb63","members":["c8939582-76cc-4531-8547-139a15ded32e"]},{"cluster_id":"afed780e-77ff-46bf-ac41-4e66698ad45e","members":["3357401c-35a7-476f-876d-c29a22cabc32"]},{"cluster_id":"7f5ce29d-718d-42a9-af2b-7bbc25320894","members":["13aac186-d0ed-4535-a881-a5a4bdb87364","18935a3f-99e7-4246-b12b-b70d0518ae60","5aac0275-2df4-4079-9a43-f4d551720f5a"]},{"cluster_id":"d673001c-8f3c-4ad3-bd60-90a9445c79f6","members":["eef92b74-64d9-4527-9f75-e23c22ad00fa"]},{"cluster_id":"df30b460-1ef4-4fe2-86e2-8192bfc9613d","members":["92b0013d-9c76-4791-ab68-c99ebaca5af7"]},{"cluster_id":"6ad5e833-9ccd-4680-8847-382fff58f760","members":["78685855-268d-4cac-9e6c-75f169f87513"]},{"cluster_id":"f8408d7a-6690-478f-a0da-8baa781f898e","members":["1b08795f-959a-412e-8533-9faf731604db","a1e1ffbe-a8e0-47f4-a01c-cd3b536c3a39"]},{"cluster_id":"fd6cf91a-5408-4a49-8b88-6ba66a82f0e7","members":["c7744804-cada-43bd-b31f-a98632fd26fd"]},{"cluster_id":"50f3c500-b81e-4af2-91c4-9121494d6350","members":["9f157653-aafb-41ef-9fc9-da58bf871755"]},{"cluster_id":"a954b16a-c601-4ed1-9990-0dca57e0a58e","members":["ee9c48df-0509-454e-a426-03f65a311a72"]},{"cluster_id":"6e37e2a5-095e-47b2-8aff-f3c2136725ea","members":["131b3f67-cd28-4304-8493-4ef0d561ddb2"]},{"cluster_id":"10b1c2ee-a471-4366-9850-b2056c01cf79","members":["ac9e4919-d616-446a-981f-359a36e898e2","06e389e5-f96e-4d33-9f6e-1932526e6f19"]},{"cluster_id":"65229c4d-fc92-48aa-bd10-466bee027dfd","members":["8e4ecb78-2cd5-4a31-831c-4bee4f699ca2"]},{"cluster_id":"ec10f62c-ce71-4a79-9f7e-b5ddfb366f3a","members":["a84eaee9-201f-4d8d-b27b-768be7e814c1"]},{"cluster_id":"094c5f6c-8f77-4ae5-86e6-0f169bca56ea","members":["eb3b9426-ad3d-4fc4-83c1-c97df52a6830"]},{"cluster_id":"b794c66a-ad77-44ca-8ddd-457a68feb34b","members":["7daabd93-b1c9-4167-adee-62a5a406806b"]},{"cluster_id":"0ab76786-184f-4825-8328-205b8055cb1c","members":["616f6f68-f401-4fa0-ba4c-64cdc24121d9","e9510a84-35a9-4de4-9ad9-e222d2348cab"]},{"cluster_id":"08d9382c-bb74-4062-afa8-3c8c1526980f","members":["aa6dd177-a776-4665-ab7b-bffc42996a33"]},{"cluster_id":"c408b7c7-ef12-40e9-99e7-96b3a920e45e","members":["6df8661c-1208-4a7a-b84f-dad337aa9a8a"]},{"cluster_id":"db9b2b11-8206-4448-bceb-8073d0878c9a","members":["38532f76-a8d3-4a92-8e5c-2b120ab21c7f"]},{"cluster_id":"39f8cdcf-5b14-42ea-aeb8-d3dfeff54bca","members":["cc44ee2c-d62e-4d43-aeed-cca51553bc91"]},{"cluster_id":"4c79fc69-3bd0-4180-9718-8d85b8c9dd85","members":["c046013e-6009-405f-89b8-ca146753bde5","1363095c-21ad-4ef8-8981-9d3e06617cf7","feee77bd-03c4-4b90-8356-f40b90706c1d","dae23334-c486-4c05-99f8-ba15b075567e"]},{"cluster_id":"682ed3da-b434-4c8b-a46d-5ea8bffc9576","members":["4a16ebcb-82bf-4c8d-ad7e-466d21217073"]},{"cluster_id":"44c28ee3-0ffe-43a2-9aa6-1d7ed2463da1","members":["0b4bccd2-1a09-4415-8393-a00d8b01963f"]},{"cluster_id":"181f2787-76c0-40c9-96f6-869aa09e8172","members":["74c4307b-5e3b-4b5c-b655-6114d055f24f"]},{"cluster_id":"f3b3b03f-2658-4df1-9b64-e36964888fbf","members":["81ab6954-cd5d-4243-bfa3-685098227060"]},{"cluster_id":"cf1d89e9-6fd3-4042-9407-6a77d0635415","members":["2687e56a-7e91-4a01-b7b0-a9f5e4f13ff1"]},{"cluster_id":"2c24d987-e81b-4cb7-a369-7fc133161292","members":["5cd35820-333e-448b-96e2-788eb0f2bb91"]},{"cluster_id":"4cf07546-b901-4002-a89e-1a6f0ae3d9e6","members":["478e87c3-687c-4384-9639-d343f99a2cde","512e237d-55d7-490d-85d4-0108fd54bbe8","b4f143e6-4e35-4c18-a988-79f21ab9c179"]},{"cluster_id":"158823d9-8d73-406f-963c-db32a179210b","members":["eb0e4b07-531d-4804-9b48-c48258c4b257"]},{"cluster_id":"5674d01b-2996-4ed7-850d-de449d707ce5","members":["5f68ea44-90f4-4964-bd73-81d69fe6d6a6","12281cc7-1e7f-4156-9f27-30ed66ab507f","b5755505-20fd-4cdd-be8a-c385417ab02f","06b23df9-0ca4-4b22-9144-0b8fe4c6cc7b","0f058be5-6f03-44df-9cc2-ebdfb8ab7143"]},{"cluster_id":"86d86a3a-37c2-4eef-9deb-93d9580b80d1","members":["84e4c275-2cb8-4157-8584-96786b1e11be"]},{"cluster_id":"9e7833e1-081b-4955-a649-df85a3c6a9e3","members":["6547f701-a4f0-411c-97d2-1f949e69d53f"]},{"cluster_id":"b8e15d0d-b6bd-4105-9d0d-28c9c1a8c47e","members":["63e9a4ea-23b5-4a68-9930-207afc06a78c"]},{"cluster_id":"f0d87010-6047-4ec3-814a-b7e1d93689ac","members":["33407265-94ba-4284-9925-81dd4a2ca2bb"]},{"cluster_id":"e0f4c0a7-03fa-4df4-af40-cde3c562aff7","members":["7743b8b3-8dac-4152-83ce-f43c0bee9d9e"]},{"cluster_id":"700f9b04-7504-490a-bc2b-7cf163528607","members":["89248d71-ce8a-41e3-a22a-a2345dffdfd7"]},{"cluster_id":"30eca979-1f98-4971-a1fe-07481584311b","members":["8755ba75-eaca-4e19-8dea-ce787a5efa22"]},{"cluster_id":"c55f11e7-306a-41b0-af0e-b025ab77a3ea","members":["e575aa8e-464e-489b-a664-70ab7a7cb07b"]},{"cluster_id":"3f3f44f3-8e86-41c0-a601-c57bd1d46cd6","members":["fac83173-c379-427e-9657-21a1713d394c"]},{"cluster_id":"41c879a5-6679-4fd4-9549-bf3854b37d7c","members":["fcedaa29-9c12-4801-a93f-2d25b4768c4a"]},{"cluster_id":"3af4feb3-44a5-438e-9179-8a6158407f03","members":["c89ccfae-db15-4f80-8115-7a03e8dcad52"]},{"cluster_id":"c9427285-3555-4de5-97c9-22592d01516f","members":["2de0391a-c6d2-4cd6-b820-9d688b482963"]},{"cluster_id":"f1cd2dd5-074a-4fc6-a7c3-71a678833a3f","members":["8f534fd9-f814-4641-87a9-04a1426c7613"]},{"cluster_id":"b9d8d6cf-41c1-428e-84c8-7e7e2b40a710","members":["07d2b96c-e7dd-497a-813c-527a2060559d"]},{"cluster_id":"f0bf93b5-3fae-4f3e-8e8b-13d89108a924","members":["b4a2e5f1-2540-46d3-81e4-e2e544763ab8"]},{"cluster_id":"03cfca2c-7423-4384-8df2-7f88d1994030","members":["98b2aff6-bca3-44a3-ba54-b68ffbd832d6"]},{"cluster_id":"72702a81-27ae-49f8-9ece-b45b8795d927","members":["151711bb-8755-4a67-aa98-e1adeb5c92d1"]},{"cluster_id":"6bd47b8f-99ce-47e4-9910-46d2ae0dd574","members":["a91f3488-dbae-4651-a7a1-71416fa1d8ae"]},{"cluster_id":"b64296b1-758d-4594-84fb-3ffa5aaa094b","members":["e95e2c86-5cf5-4e2f-bfd1-8ab731e857eb"]},{"cluster_id":"19904647-b456-48f0-bdd3-4c7803aa2b21","members":["360a8c46-e6d8-492e-bde7-3bdf7f02b104"]},{"cluster_id":"68a2ab6a-28c5-4be5-96a5-2cd28d07739e","members":["dc57462e-f58d-4301-8a18-8ecc5bebc69b"]},{"cluster_id":"4fc8d532-69fa-40fd-b28d-a301335dc7b8","members":["cdd0c405-98b0-49db-8ea9-8ac94256b27a"]},{"cluster_id":"f58ab9e3-79cd-49da-af02-2a9f2fdeec8f","members":["f944ae1d-075d-498b-a803-1f145d06cde3"]},{"cluster_id":"9a157342-1d61-41a4-92fb-020ea95697bc","members":["6da8b312-412e-41b5-97c2-320220ed5504","2b4a71c2-c0a0-495b-b631-8f80095ab4f1"]},{"cluster_id":"0dc0d897-2bc8-412a-af86-95eb382d392e","members":["3e0cb12c-8fa8-4bc3-bd34-b35b74430180"]},{"cluster_id":"fbf4f33e-0e24-406c-8b43-497c4ae8f7fe","members":["1d902c0e-3b2f-4211-b144-2c47a1918793"]},{"cluster_id":"294c224e-4fa2-412c-a08d-02a89eff2a7b","members":["95fbc391-139d-4b74-bab7-54c98c57a2bb"]},{"cluster_id":"4e04a5f7-5879-4461-9d2b-d653343b9dbe","members":["fe81f0df-bad3-45f2-9a1f-c50df83a836d"]},{"cluster_id":"e20b024a-3a40-46e1-bbc5-e9607839e91f","members":["50e1baad-2edc-4b4e-b3ed-7433803a9740"]},{"cluster_id":"f9662a45-5f67-4be4-be6c-47e92690c44c","members":["f7820ae8-03eb-4cdb-a315-b5574a7284d1"]},{"cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec","members":["7907f512-3891-422c-b167-7a2ec07a79e3","850ae654-2d8d-49c3-9520-1138ba8eb41b","a5e721d6-d4b5-4676-b0ef-6635440090c5","d546313d-55a7-4c55-8727-d1442d5d9758","44fb80fa-2bf5-4161-ba19-539be4b7a8f8","7ffc3f24-8a49-4463-b575-ccabf41b348b","a0cfeb9e-171f-4591-87c1-7f275bfea3da","c11336cd-72ab-4022-9eb7-8330b56c200a"]},{"cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417","members":["f1b90ad2-9e41-47ed-b4e8-1c3eaa4a8111","309aaf99-7ac7-4ac2-abed-8aeacdbab127","b07f9e83-4828-4d6c-9655-aaf9e032b958","f422c635-230d-4085-894e-77e4bc8d2a2b","08aed31c-7eb9-4c4a-8202-846ae0d621e7","c21d0dbb-a95b-4ceb-a71e-8fc3df881d95","7ee48907-cc9c-43c9-ad87-8a0e9940923d","86e752df-f478-4714-b1d7-0b9fd5e2c12a"]},{"cluster_id":"cef4b627-4828-4a00-9a55-7f92b9804c1f","members":["b8afc355-0d3b-4b78-8e52-f51a350d83ea","35802410-2120-432e-a966-e73755191cc3","bd2e82a8-49f0-40e5-96fc-8ea991ee5507","4df60cd2-ed44-49d4-af98-a38d8a7f2b7d"]},{"cluster_id":"a1887544-121f-4fbc-b25f-d4561dfb5e4b","members":["126eae67-4a76-4364-a533-375bb10f6c72"]},{"cluster_id":"39687812-944b-4418-ada5-3588be43da66","members":["cc4501fc-11d1-4e7b-8e44-ddd88a405d9b"]},{"cluster_id":"37dc3c46-39b6-4d4e-87ad-59040db4662a","members":["11d3f25f-6719-4690-b5d7-c65950aaecf4","84546613-04c9-4ea6-a46a-04af0d15ed76"]},{"cluster_id":"abe67163-2626-42e7-98cb-6e8083622029","members":["b9fee561-458c-4021-a790-653c39480351"]},{"cluster_id":"a4a343c3-6168-45dd-bb83-595e1841921d","members":["6849dfaf-8ca2-4b18-b601-9eef2c9e238c"]},{"cluster_id":"f520db2e-ca68-4285-80b9-7e45d3506ad3","members":["05ddcda8-e6d3-43d8-a4ce-1356f99b3ed6"]},{"cluster_id":"2e1de1f1-7494-4d78-994d-deb9c207c005","members":["fccab78a-fa33-4db4-bb24-62e5e2a113ae"]},{"cluster_id":"9e059116-3c55-48ed-9078-1c003c9ab524","members":["7966b150-ab5e-430d-8dd8-0b6cc2a52590"]},{"cluster_id":"a8453d8d-d762-45e8-9fae-f6302e301be0","members":["9b43e23d-6e67-4a55-bff8-88a4dd7e0222"]},{"cluster_id":"27baa662-c27a-403b-9e47-b67e42c90e29","members":["e4e9833d-2b95-431e-bd45-33d54b1159b5"]},{"cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63","members":["4fd5cba6-5ef8-4f7e-88a7-cc0e21801f03","bf4d637a-e05a-4d3e-a455-88cdf3508e2c","38caa6b6-11c3-40cb-9ff0-a181a610eb4e","a6b3be4f-41ad-4a8b-9d1a-da03c46f9462","b5d18da2-37ec-43db-9cf5-11a16315155a"]},{"cluster_id":"a3a7d7be-57b8-4862-a94f-547066bc6b8d","members":["b3905ba9-04c9-4087-abe7-fae021d91781"]},{"cluster_id":"7aa12e18-818d-4e83-947b-42a4e69ce8db","members":["85c23183-95b6-47bf-8162-cf1d77e20f54"]},{"cluster_id":"285237c2-514b-4d74-ada7-2be4ad6a801e","members":["12db9005-ba29-49f1-9b27-a3b203a2b06b"]},{"cluster_id":"7b48e171-a32e-4aa5-90bf-b37f44678964","members":["9aacb493-235e-4c62-985a-961ed8ee8fa6","4ab374f8-cf52-4af7-a885-10d80a4e5b2b"]},{"cluster_id":"22d09703-f903-41b1-874f-1d44ac956d8e","members":["728c3997-6622-4111-a278-d680c1b50c96"]},{"cluster_id":"c07b3261-1d07-4e89-b0d2-db74c9a1f8dd","members":["cf7b861a-ab3c-4a9b-ac59-549ac3ef0af0"]},{"cluster_id":"1dde6808-a5d8-4cff-a522-2b1380a746a4","members":["2e9ef9b7-a1a4-47f6-8450-0d4d53b6a973"]},{"cluster_id":"a59ccb39-5f94-4ce9-bc2c-828e0325e1b2","members":["25771af9-52d2-4703-abce-50f51dd79499"]},{"cluster_id":"ffbd77e7-2b57-47a5-8bd4-9b23ebb837b5","members":["81d8088a-9576-4107-a172-0b313558170f"]},{"cluster_id":"eb540b94-f26f-4993-9d85-8c7b5fc26cca","members":["81609bf2-06aa-4215-b85e-1172352ab4fd"]},{"cluster_id":"2e14d9d5-92bd-4d6d-84c3-0127651e89de","members":["dfbf618b-e02f-4074-9549-2e0686b74d34"]},{"cluster_id":"d6134f0a-59f2-49b7-85e1-25628c9e022f","members":["b6eee547-04e8-421c-8bf4-f939c1f700e5"]},{"cluster_id":"1a9ef0f1-3f2d-4026-a13b-46206f55c61e","members":["b1f6871b-fb0b-4b53-b754-feb19895b71c"]},{"cluster_id":"14c01a60-ad79-4b97-8a3e-f1a74d8a8f96","members":["a5ab1168-82e2-40e1-88e4-2739fd94022a"]},{"cluster_id":"1137dcb0-70d8-4dce-ad5f-8ffbbf5dde18","members":["d520bc36-9485-48c7-bb02-b172d8979bac"]},{"cluster_id":"07dbae86-71d8-45ff-b18a-4a1bf2ead8e0","members":["fbcc72f3-a1bb-4fc5-9188-1f0d06b36c2c"]},{"cluster_id":"abd6036d-49e1-4e1d-8db5-cfdac174787d","members":["703963f3-6fe9-4ee6-ac11-bd823769cfbf","ed5a38cd-1053-4c15-a8ee-77255d3682a0"]},{"cluster_id":"50321d3e-dfc0-4504-be22-01fb2718ed93","members":["176f09da-4858-4cf5-b55e-bb3752716f63"]},{"cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7","members":["60b361fd-2a30-437f-b677-cc825abd8fc8","54e46ee3-95e6-4cfb-8445-16db2423c0cb","0f81c463-7fc8-419c-b1cb-c8b675c31f82","1ec08fa1-6515-4fb9-a585-16241d52e937","4566b36e-d3ea-4ec7-9e9b-7343a650fdce"]},{"cluster_id":"efde2814-71d1-4a0e-959d-1e37c60dd501","members":["46cbfd54-f8ad-4e6e-b27e-b823d716a47a","2bd80a18-8bff-480f-994d-68d37192db5b"]},{"cluster_id":"eebdc162-9389-4ba5-ae4d-d971d7acc73a","members":["2706d054-122f-4a83-94d3-c9b19038c3df"]},{"cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c","members":["36946f31-0798-432a-b6f5-53f99b080734","d4ca4811-8423-48d7-8341-7d95c29ca43c","ee9c0543-ba4c-4325-86bf-12846a45e075","67c0c967-1278-4a1b-a074-7121b12841f5","683796d7-fd83-4d96-8114-5d3ce3862e85","ecdc5e87-0734-41de-9be7-f76522dd49da","7fd0faa7-72aa-4187-9f9d-b0ad8cf14b73","f761c1de-a725-49a2-9f05-5e810c664681","57710820-589c-48a2-bfcb-33ad32e2c665"]},{"cluster_id":"45a10488-1ec2-4731-8b23-f6d502ac13b4","members":["a09ffa5c-ddba-4c36-9336-1e74696e9105"]},{"cluster_id":"3a3218a4-ce54-4e61-9c08-41f52d8bf517","members":["6ea5a1bb-1fe2-4405-8e70-ca7cb8012135","bc63a604-0288-4ac9-91e0-1ac813d262ed"]},{"cluster_id":"7effcde4-df93-42c6-842d-c99804764bd5","members":["0bb21a62-d4f7-459a-b582-17d7077bec94"]},{"cluster_id":"c213afe5-5445-4f82-8c73-fbf8e0f02000","members":["147fbe63-1b55-4169-9c46-c0e320e92d21"]},{"cluster_id":"83c0c29b-58c8-41f0-80a2-462fee4f58ed","members":["f863d674-bb62-45b0-88aa-140c964047c2"]},{"cluster_id":"d17ccb3f-9b25-4161-8681-42ad54f325a9","members":["a8650c12-bd32-446f-97a6-67fe735cb4f2"]},{"cluster_id":"7c268167-b621-480c-ba79-7005ed13e2de","members":["3e164c73-1d27-4225-a4cf-4558189223bd","2e1d7402-b82b-4b0a-9fb9-326fef12586b","7f920669-c960-4ee2-9c6b-57c6ddcea98f","1a072915-3b62-4d18-89ca-4e5b22d19ce2"]},{"cluster_id":"b006c022-e811-42d8-ab1c-bed9f97e066b","members":["c3994da9-9d30-4cf2-8bd2-c4fae3919464"]},{"cluster_id":"08918774-fef7-4ef6-9e14-8a7abce1a23c","members":["44257917-be31-4c40-860c-9253f4dfe5f6","2290ebe9-b56d-4b7f-a27d-1990eac79898"]},{"cluster_id":"3276e11e-189d-4a3f-af8c-0dd0ee752612","members":["a86c33ef-0961-4a4b-b386-c0afb307ca26"]},{"cluster_id":"4a1b2728-75a5-43bc-8278-ab49e8c8c004","members":["ea7fa834-93eb-417d-8c19-1a32fa6fc323","994b681b-2928-4c7f-a53a-6f9dad1c6bac","fba5a612-bb2d-4564-8e52-759918f1788f"]},{"cluster_id":"a13b9666-44db-4c37-94a0-689f377da92a","members":["c4be31f8-b067-4d84-a740-33099a4ad1ad"]},{"cluster_id":"b5ae91f8-14e1-45b9-96d8-d01043f4d725","members":["502d2682-d775-4d0c-a054-5cc48fbc722e"]},{"cluster_id":"8feebef1-9f0d-4302-8835-37de98ad3cf7","members":["b5d04b72-b082-4875-ac37-416d3e8ab195"]},{"cluster_id":"aa24898d-2c81-430f-a430-33fb9aae0db7","members":["b08c2c0c-4d30-480a-b095-f8bf6fdc0d4c"]},{"cluster_id":"f57aa067-2ae8-4cb7-8526-f9e921a1522a","members":["ec6202e2-c5da-4ca9-9c80-19a8c4f5df38"]},{"cluster_id":"4bee04c1-3125-4580-8ea5-cbdb4fd88ca9","members":["7c07149e-0c8b-4886-a2b3-c830e7e08b9f"]},{"cluster_id":"ea8f590f-f522-4ce0-8605-6700141bd308","members":["60d11947-1ee3-4a64-9896-45b120df033a"]},{"cluster_id":"06fc9106-7925-4cb4-a52c-592a739aee82","members":["0455a97a-fd77-40f2-a5a7-e14f0b27c5c2","2cd9142f-905e-4ab8-b3c9-fe284e5e8b02"]},{"cluster_id":"f82b2292-d2a6-46b2-8f35-b645fd7735eb","members":["3fd36b82-7c7e-4ee7-b8a7-e201b53263c4"]},{"cluster_id":"03633b9c-b0d8-43dd-b075-5cdc7b02727e","members":["3550264d-3a3a-4421-9827-eeef6d8bed16"]},{"cluster_id":"91e3ebd7-7afc-4109-ab3a-203fd4f78d4d","members":["9af8c9fd-d1ba-4776-b745-76d6c56d08fc"]},{"cluster_id":"f98ba1e5-efa5-4a15-9a39-7050f0a81013","members":["271671d9-d9f0-4701-acb9-ebf12b3d4d51"]},{"cluster_id":"6907e408-863f-4c1c-90bf-e1763a1c2ab8","members":["e3dceb77-f7bd-460f-9054-fcbbc021f866"]},{"cluster_id":"44b235b6-c03c-46c3-8783-0dedf88d2c23","members":["6249d787-d536-4b0e-bfbb-86aa83694f66"]},{"cluster_id":"c2058db3-dc0f-479a-84f0-9c62df9819d4","members":["fb63438f-dc9c-4e56-be6b-4dd7cf6837fb"]},{"cluster_id":"d3085fed-3741-4d75-9105-e8b0b3511de6","members":["b1b37881-0460-450f-9656-568a14bbc224","84349328-6cbe-4c1f-93c4-830596e9ea8e","42c87d2d-b408-49a1-902f-92ac472bdaff"]},{"cluster_id":"52bd4e45-b832-46e3-9698-5812693f4546","members":["11364990-cd4e-4992-824e-ea8bff3d869b"]},{"cluster_id":"f7ca28bb-5007-4654-b846-b6e439b09815","members":["75f0b194-74a7-49de-858f-7ef0259e6771"]},{"cluster_id":"428b353a-55ea-4d2a-8de9-d2392f48d161","members":["53f866a2-6e47-48b6-9ce5-afdce3518b0d"]},{"cluster_id":"adce1d4b-0242-41c2-b4ec-d798e0c0dbf8","members":["7579cb22-cd0f-4ca0-96cf-f1896ed7914f"]},{"cluster_id":"bb3ff0db-1a95-4c2e-819a-c84235effd5e","members":["c7be7841-96cf-4b23-9c1c-46477853c367"]},{"cluster_id":"ef19cef5-5810-4243-912b-66c41d184f8d","members":["0d7a1eb6-374d-42c5-a792-5330c955b1e5"]},{"cluster_id":"722d06bc-1512-434a-8214-a8daff8fb8a9","members":["6f02c190-25e0-4fce-a84e-81944124ad81","c40215cb-f88d-4c3c-bef4-40584de842fc"]},{"cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e","members":["b8661f52-58e5-4305-87f5-ca659edf9304","e83bbc87-dc53-4e0a-aa7a-894dca93d5ca","923d78a6-0f1a-4090-b098-22127570f45d","351498c8-2a08-49fa-b6ac-4c644436ffe6","cf99a0ac-603e-44ac-ae2e-09dda24cbbfd","5a481af2-58fd-4c86-873b-9b91d28d078e"]},{"cluster_id":"a7593170-7dd6-490c-af81-f78a7c4b79b2","members":["b07caca7-03ba-4311-a1d1-a85a8814fca4"]},{"cluster_id":"e7dfffca-5c65-41a6-9fd7-62ccaeb4e1e2","members":["40a75594-3952-4884-a0d6-443085589381"]},{"cluster_id":"379a52a5-17ca-4b52-8aeb-4f7076fdca3c","members":["84387a4d-e511-45af-a35a-ed52ac000f82"]},{"cluster_id":"9e4b0a95-0efa-4ff0-926d-70d1dc9caff3","members":["ef847f2b-0c64-4ca5-ad89-cda8af0b35cd"]},{"cluster_id":"30d8206d-7f35-4cfd-86b9-4ac411d8d754","members":["90e5876a-ce2f-4e79-86e4-791b5196ea9d"]},{"cluster_id":"8a462401-6f97-42ba-a69e-60e2ceb6f0ac","members":["5ef29add-5e93-442f-b2d9-1b0ae2ad3aff"]},{"cluster_id":"72ea99a1-516a-440d-9d00-28c65935de34","members":["180cc7a3-c694-4485-a9ce-4c90d0ce1988"]},{"cluster_id":"d9cfd982-76cb-4edd-8452-01187964f15b","members":["f1df6fcd-82a8-4f29-862b-b17d197720dd"]},{"cluster_id":"22f3bc98-8ed4-4355-8d05-5399a3757d7b","members":["b24bad6a-9fd6-4823-8d2b-0d5fea798256"]},{"cluster_id":"8631d2bd-115e-4513-8568-952af022961b","members":["32edd82e-0217-4813-bec8-1a1dce864bf3"]},{"cluster_id":"45a3ab07-2fb2-420c-9452-350f55111899","members":["53a61ac2-5f7b-41dd-bb0e-e5a7d2c4c0db"]},{"cluster_id":"473a62f7-a375-4113-841d-d6bbd59826b2","members":["16d5f277-e1c8-4439-a591-3bfea8c06823"]},{"cluster_id":"2de014ab-746a-455c-a496-0833ca28f9b5","members":["5eb4a6c0-107d-4b2f-a23d-dee9a04242cb"]},{"cluster_id":"b5bd71be-fc38-4eed-90dd-db3dd13d58ab","members":["4f97be6d-c6d5-4fd2-8649-0bdd2f1fb2e0"]},{"cluster_id":"ba73d786-afbd-4fff-a554-010d1e65a4dc","members":["fc4649f8-8e16-4c02-aece-aedcfdeef725"]},{"cluster_id":"1737c28c-8f31-4855-8951-9dd1dd0b8606","members":["b7724a1f-eea6-474c-b701-2f031cf9fc56","b8aaffa6-27c2-47ef-afa7-238f612eb2a5","8e1043cc-2dca-495f-8d63-e75c5ae5387f","943e4f34-59eb-4222-a1ae-6b920d69ab63"]},{"cluster_id":"3625ee09-ea65-4286-ae5a-83daac4e66b6","members":["7207fa75-c0f2-435b-9696-7acee5f2af99"]},{"cluster_id":"b1dcb694-6efc-4b22-9bc7-9254eb290f7d","members":["b1622aae-b90f-470f-bfe8-51c55bed106b","f4263275-9b32-4ed9-b972-fc6d18183e50","fe3acca7-a1a2-431c-a994-c81bec1ded2c"]},{"cluster_id":"d8b8cb3c-4059-4ad7-99fc-df25e1b98b1b","members":["358c93bf-c503-4f8a-9709-78f3c5027f02"]},{"cluster_id":"844b0e6c-6c02-4726-b2d2-097a5c40629c","members":["71aa2d9f-ab06-45e7-97cf-248cb50efd98"]},{"cluster_id":"a7c7aaf0-419c-4efc-8f5e-14d3f71ed9ab","members":["e5037d73-ad6a-403c-8a6a-a405132eecc3"]},{"cluster_id":"21e4a786-d932-47c3-955b-b3e7de14d033","members":["5853bc70-e5ff-4c09-ada0-041fe0401e19"]},{"cluster_id":"6d365284-d631-4fba-bf61-dd8894351156","members":["99b6d9fc-3cbd-43dc-b069-102f955ba2f9"]},{"cluster_id":"a4bb7e8e-38b8-4326-bf96-4782b99feba1","members":["d8d5b1d1-97cf-4035-b4bf-d3121364b428"]},{"cluster_id":"28097be1-5cca-4755-b4ba-20a7ac4aa34a","members":["c52ddb05-8e7a-4b12-a26d-91c6987d7438"]},{"cluster_id":"47f27689-5f68-430a-bf84-77af1b6dc7c8","members":["46d547f9-9df8-47c2-9248-ec0c9873a7db"]},{"cluster_id":"c236b253-d4f6-4796-aa07-7b8f0eb372e6","members":["5135b149-7874-4048-9faa-aa7e73afbd47"]},{"cluster_id":"a4ea2030-230b-4e96-b485-ae147aec2613","members":["afdb0635-2d31-45b9-937f-b7b6970f99df"]},{"cluster_id":"ff9ad8d9-d483-4daa-86f0-12ffd12f76b0","members":["5b7868af-db6b-4e90-bdce-140b83805c8b"]},{"cluster_id":"cc9a2a9c-6fc8-4c4a-bdf7-3321a40e8bff","members":["f4c67b8f-f721-4b6d-b214-82b231ed674d"]},{"cluster_id":"a7783b6a-7d1f-4493-9664-55b728cadb9e","members":["571ef3b1-218a-41ea-ba3a-184082016906"]},{"cluster_id":"209dbc84-05ee-49b9-b69d-c36d87df72b0","members":["f1dbfefe-5e9e-4e2c-ac33-07a571ea1f31"]},{"cluster_id":"388f06a9-49ef-4bdf-8dec-04895f125517","members":["75fb3ff2-7efa-498c-aed9-04cad1e8e90b"]},{"cluster_id":"96b1dd29-d1cf-4ea9-9b10-e52b59e1a6b5","members":["c8e2dcdc-113e-4f0a-89e7-af844b5e74c1"]},{"cluster_id":"1d9de982-6324-4241-9481-7618f52a1421","members":["3fc6ab64-6a58-46dc-88a1-5eba220a3e07"]},{"cluster_id":"f39790da-a4f6-4366-98f5-449851f41e29","members":["6eb14920-b3ef-47c3-a818-d5a00297bbe7"]},{"cluster_id":"4dd085e4-7892-4955-a5ce-d8e90d7e23d4","members":["6b48c1d9-1669-429c-af35-4b0d572ba8be"]},{"cluster_id":"c1482f2b-05b5-4755-ad11-c7c127fb4e73","members":["0db32998-01ec-430e-939a-655122441935"]},{"cluster_id":"4b8668b9-ec8e-41f1-b42b-e53f7eac0641","members":["c2c8ab49-308c-4b42-85b2-6fd772d339e7","501e49c3-266a-4a6b-a595-bcbb93614985"]},{"cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57","members":["47da981d-850b-44ac-a0d6-c94219998be6","7564e306-9381-4331-a0f1-0dbf0fb1bba9","c3c07c77-af4b-4204-aabc-6aa4aa674f5d","f3a8343a-d979-47b7-815c-831df4ef2799","45933205-c402-44c5-a3d4-8c4d29f3324b","4039d703-a1d4-4cc6-ae5d-87f162f75e59","9f5ea13d-dbcb-4125-8e01-5e0baaf11160"]},{"cluster_id":"78fb23f3-7fa7-436d-840c-3f1376d6f22b","members":["2b2b9ca9-f40d-425e-8561-7b063b8b887f"]},{"cluster_id":"6b5cfe37-19cb-4d16-b4f9-67d51f90495a","members":["e1156b4d-4874-489c-89a7-ebb6555f0b26"]},{"cluster_id":"6494604d-36ac-42cf-98fa-810683a18200","members":["c859396c-60e7-430e-bbd1-6f173c056c6a"]},{"cluster_id":"de3dd2d3-d79d-4172-a1cf-b6ac1238b295","members":["3913c195-df6f-46a1-a77b-234d06be4e5d"]},{"cluster_id":"930472a6-b976-45c6-814a-9c87d52eedd0","members":["5acea283-52dc-4be7-af91-1351ea96ad69"]},{"cluster_id":"194f810d-af4b-491d-bdf7-3aad4b9c5e55","members":["f735f149-adea-40bb-85b9-e39ed7f943b6"]},{"cluster_id":"7e4cb312-8581-481c-819b-81c1e9125f8d","members":["c399ffed-e74d-4781-8755-ff6d46ccfcb6"]},{"cluster_id":"6f715c79-5b97-43d0-a5c3-09848b08ceca","members":["4874937d-d2a4-4b84-be8e-078fc60273ee"]},{"cluster_id":"16f44bbb-61c5-4b72-873e-79ca1d65deb9","members":["881a9b4e-f791-4953-8c1f-94e0fdf4e503"]},{"cluster_id":"5a1b9522-efaf-458a-8a08-7187a721101c","members":["9e666dbe-591b-4fc1-8a5d-cbbfca6652ad"]},{"cluster_id":"8e7309fe-7380-453b-8dec-aa0848276b7f","members":["2ef1b714-3d18-4370-a67e-499877b45151"]},{"cluster_id":"ab0be659-cfc3-42d5-b3a3-1d1264ed5cd9","members":["d41efa9d-b94c-413e-8a82-a278a1b220c4"]},{"cluster_id":"335c4cdd-12ec-4cfe-80c0-1755c4975b84","members":["52ab28d1-e615-4350-9e4d-8080034e84e0"]},{"cluster_id":"cc877779-d56b-4dd9-8cf2-4d0193c50ac9","members":["9a091402-3c03-4297-9d34-3435e1bc34b2"]},{"cluster_id":"82025429-31a1-4168-809f-fb0e7a96b10b","members":["7dc86030-7a19-4350-a39f-49cdfa360c00"]},{"cluster_id":"65ac3d2f-1144-42ab-9435-1522b78a54a3","members":["582f74d4-d5ef-4fe1-8c27-f7ebb9b7b1eb","00490e88-4c69-439f-840a-b6f48abec599","40be193a-bde9-42b6-b43a-6e1b513e00b8","6793396c-a9aa-4a0b-84c1-27723d157956","741a9cb5-886a-4ac3-a0db-6fca78a7b9ac"]},{"cluster_id":"f2b47c96-3e62-4d1a-98f6-547e71af6858","members":["48c4a319-7cf0-4fd0-bc09-68cd21f0626e","b146c3bc-b08a-4983-be17-739e144ab07a"]},{"cluster_id":"7a2de756-9400-4120-b4b6-4dec07a8ec47","members":["2d1e731f-a3c2-4528-b58a-449901a76c18"]},{"cluster_id":"b50d2222-7f8b-46fd-aef1-62ca57b6cc71","members":["bde590cd-9b48-4b9b-b5f0-8bce36a24ff3"]},{"cluster_id":"4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e","members":["a0907cde-a1ec-40f3-9787-912b1d3b935d"]},{"cluster_id":"80a8792f-9489-40e4-a0a2-e1e4173e1957","members":["2ac0eef9-cde6-4446-a483-d338c3dd199b","acde9344-bbbe-415a-92ed-e790f274ea8b"]},{"cluster_id":"85b2637f-fff4-4688-a95a-adb041e440fa","members":["4c5f8bce-dd61-44b7-b834-9cdbf9da9728"]},{"cluster_id":"60f0b8f5-f6ce-4be8-993b-d99ea8933141","members":["79fbeb52-b612-4dd7-a96a-b3dab751bc62"]},{"cluster_id":"d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49","members":["c2a1619b-1e8a-4cc4-bad3-e513b4662d11","d13dadf0-4167-4441-a621-b37a7b72e753"]},{"cluster_id":"2ad0c3d6-c24f-4917-a1f6-8d2bd77034c3","members":["defc77ff-cbfc-48bd-8b8c-c94b79d5d3ee"]},{"cluster_id":"be4d477c-befe-4014-a5ff-185b3c58e5d5","members":["c3383913-b97c-4698-bc6e-dfa86f94252e"]},{"cluster_id":"89e88d24-d19d-44d7-b8a5-9a1551934f01","members":["9b91b525-00e7-4e48-a008-f8b5f09e52cd"]},{"cluster_id":"d00c4814-110a-4898-a26e-19970d2ed410","members":["b7ea1cf0-ee58-4c87-816e-4f6b0a636fc5"]},{"cluster_id":"0903a221-6399-44af-9542-80d1c25bc816","members":["3907e1af-90e2-482f-a144-f7748e0038c9"]},{"cluster_id":"97d31fcc-0a9f-4dbf-b6c8-d1db70a61d1f","members":["e2a23296-e072-49f1-9153-9cb10c17f747"]},{"cluster_id":"343b7137-128b-41e4-a3ca-cc8e58193569","members":["26e695e0-9c2a-4dd4-9ff2-b9e3b46338ea","188ad611-b2ac-49e2-a256-aa170e3d2b3e"]},{"cluster_id":"984fa7e0-f763-4f19-b49c-d87ea5159954","members":["5ddf863e-80ba-40a7-9326-35d6a8d80405","969a892f-fce1-45f5-8bde-d9e50e52490d"]},{"cluster_id":"dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82","members":["af25c83d-0d32-4118-9d9f-19e0080c4a84","f6af0590-2398-4b94-9a2c-3853a58d618d","2c54f3fc-53e6-4314-aef4-ec5de9731cf0"]},{"cluster_id":"ff805a1d-a863-4cd5-ad33-a75bc8aa6ed0","members":["5a85052e-a1b7-4165-8b2a-69c906c41b16"]},{"cluster_id":"5a444351-b082-407c-bb72-a6329cc1e654","members":["472106a5-95aa-4a0c-86fd-4bbc45da01cf"]},{"cluster_id":"0d486f1f-7f93-4053-a807-970ad702d674","members":["5d182855-0f10-4b73-a406-7cb2a6b5d3e3"]},{"cluster_id":"3e86f418-a7c7-46c6-9106-86fe0b88ffdf","members":["34420d7f-cff5-4569-84cd-74b4c1264c12"]},{"cluster_id":"ec0d2b84-2d88-4935-ba00-876f0eb3929f","members":["8f8d57ad-bace-4ecc-ba07-a75b5b70cabe"]},{"cluster_id":"ce319c6f-8ace-40b1-be7e-933bd39cd9c5","members":["3f9258dc-40b2-4707-87e0-17ccef7ddc3c","e0d54a0c-eece-48bb-8f50-cd3eaafc0fa9"]},{"cluster_id":"e209eca1-fa4c-48e0-bce4-5bdadede98cd","members":["a1d5fb20-590f-45a2-994a-6de1aef1ae6f"]},{"cluster_id":"4586dde9-ed48-4b34-aa3d-9d5f004f908c","members":["b1c5bec7-8c75-4bfc-b1ef-03e432b736fd"]},{"cluster_id":"75d8830c-702b-4013-8c9b-62375f536959","members":["6f8e99cb-9eac-42f8-baaf-7d5fb1ec4b66"]},{"cluster_id":"85cfe769-d38e-42c1-b06b-f313ff275d96","members":["78c6dc0a-7aef-495a-a9fb-b652131b9a52"]},{"cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c","members":["542b87db-3865-4252-ab38-1fef10e84787","23ef675c-fb76-413b-862f-99a1e72bbe7d","7a13e2e1-73ef-46cd-af16-09ed228a8441","88e7d9ca-6337-4303-9f4e-3459cb5b0080","42c459b3-603b-4fea-b100-496e7c644a74","ecbd4e9f-56e6-4e10-9bd2-e280c4a7a058","16c1596f-0638-4c9d-b521-04f920c7f851","2e82249f-7daf-4890-8ed1-8937ec73e255","0689fba7-b805-40ed-8cfa-956bc0b5639f","2b07e9d4-c9eb-4255-bac4-e301f267a58e"]},{"cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79","members":["1cffb107-1569-46e6-a9e3-c0000872fae9","253ccb87-0251-4c30-99c8-3f6544a04ff8","22f5e4e6-4a0e-4665-a396-03104cfc11d4","0781a0fb-13c1-4dac-8c1c-fbccebd5d447","4e37ba87-f258-4e45-aa42-2637e01fc449","10370b60-b6d5-4e58-84e3-bb99d84b57b1"]},{"cluster_id":"88ed9b73-fcba-44e5-9474-9587e7fb5ebb","members":["cc8b09bc-cb25-4f9c-a6b8-19f74f36a20b"]},{"cluster_id":"7e49c169-d21d-4097-aa83-c6ac3958ab1b","members":["a8823aaa-97b6-4788-b780-517c9261fa6d"]},{"cluster_id":"712f6134-d72c-4f1f-bf01-f9fa23374d32","members":["4c2093dd-1e8c-4155-85d3-aaffaf245046"]},{"cluster_id":"c056dbf1-3293-411e-a56b-f5d55e75ae9c","members":["21c8b0e0-0435-491f-81b2-87fd340173f7"]},{"cluster_id":"f3b3f1d2-6fee-4073-8509-60422ce0c24d","members":["86a7ac0c-e6c5-46a8-ba85-7c26b269a478"]},{"cluster_id":"ed1ec0ec-9794-4ebc-ab7f-279232e95886","members":["20fb0ed2-b748-41ad-afdc-0c498f54fd95"]},{"cluster_id":"cbb25dea-baf7-49d5-b9bc-41ab2551292b","members":["c93ece72-3991-47d1-a1cc-078067203fb3"]},{"cluster_id":"ad5a4bab-60d8-4977-8f90-38b233ab7dad","members":["7a2624fc-76c9-4968-a3d1-e347ecff910c"]},{"cluster_id":"1d1ebfc5-8408-4d3f-ae15-fa5d518e6407","members":["710ccf32-7e3b-45ca-9ae2-62ce4edbceed"]},{"cluster_id":"978715ff-b53c-4912-969e-25b8f2aa2ba5","members":["30b128ba-4d8d-4caf-9ba0-507ade647b3f"]},{"cluster_id":"45a08904-45fb-4937-aec9-3d713915195b","members":["b922483b-ca38-4bb5-92e6-bc6d9cd8e778"]},{"cluster_id":"dea69c71-f54b-4b5e-a6a9-8af50c3a5a8c","members":["9fb0c90c-2388-4cb4-808c-cced91fe0867"]},{"cluster_id":"a1ffb94b-ce0c-4994-8b4a-5885dcc09a67","members":["131116cf-1869-4bd2-bd12-8dfd6249cfca"]},{"cluster_id":"f67a1af7-61f9-40c0-beb8-34c87a985d6d","members":["2a5cabbd-0f11-480f-aeb1-738c11f2f7a8"]},{"cluster_id":"4be56027-8172-47cc-b793-5f37e487c1b0","members":["899c7e3e-ee42-45f8-877c-dade5b1e3465"]},{"cluster_id":"3be61476-a382-4c84-9990-67e69bae81f5","members":["d9eb600f-07a9-43c2-85a1-267b40754c4a"]},{"cluster_id":"cc709bf0-3f13-4e4e-b2f5-adbdf5752221","members":["c691e33e-5392-482d-9b5d-8eea0f8dd4e9"]},{"cluster_id":"d7895c1b-fc75-4aef-87f4-799e18058cdf","members":["ac5ef9d8-d7e6-41cc-9409-cfcf6d93f012","1b6307cb-cc36-4ffc-a619-8d593dbd8424"]},{"cluster_id":"d0fe7b5d-26f1-4baf-86ca-16d7441119ce","members":["8ac12e53-8fc9-4794-9d71-16e590409c47"]},{"cluster_id":"aa310c78-7994-4d40-8f0b-2bea418f42a5","members":["e9c713f8-7fd8-4245-9d1d-2a091b3e8c2f"]},{"cluster_id":"90d2821b-b505-4e57-a6e2-7f1724a94e93","members":["b4a0c843-111a-4e9b-83ac-f24907a880e0"]},{"cluster_id":"516f819a-378f-4afb-ba61-51d5e2e77e27","members":["8bad62bb-f014-4f00-8801-8cfcbf482f07"]},{"cluster_id":"f97d0f4b-71d3-41e4-97ea-bf25e10bfac7","members":["e9b1b107-a17d-41fc-9252-d6bdda1ddb67"]},{"cluster_id":"202dbce4-7e5d-444f-8048-9175eb593dea","members":["7691c906-9452-450c-8fba-b94921dfc3e9"]},{"cluster_id":"3380c11c-4d24-494b-b6f2-08440e174107","members":["ce1e79be-c15e-4b37-a0d5-c5130c80d079"]},{"cluster_id":"f1447bab-26ff-4b83-b864-e0d728335c30","members":["6207eb7d-803d-456d-91b0-0a9356df9f37"]},{"cluster_id":"77f11c57-3238-4a6e-9949-a3af094990cf","members":["8aae4da4-c6c6-4d8e-b18e-81949526f70f"]},{"cluster_id":"f54b8dca-8c1e-4052-93b8-d1e0396181a2","members":["cc516e39-1c65-4879-a641-4bfaec9fb492"]},{"cluster_id":"8da8b4f2-f2e7-44b8-b5b6-7b0f66fba285","members":["d928ebff-a115-453e-b7cd-a8fa8856f24f"]},{"cluster_id":"6ad057c3-3463-4e5c-9a22-5186dd44f814","members":["61e1f3d9-d3e6-4680-a108-f43330a1b309"]},{"cluster_id":"082dc58d-c56c-468c-82bc-39e8c62c9b6c","members":["558474da-6058-4ea5-ade5-569c6a34175b"]},{"cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9","members":["8333bdd8-feac-4112-aa25-5e0b53675aaa","90948fe5-444a-4293-8d27-d4e7b5644413","947907d3-1145-4f78-ac7c-d6cab87838c1","1c97aaf9-42ae-463e-a597-d94917fde197","de0e3abf-ceba-49b9-8828-79c50e38b815"]},{"cluster_id":"ad9e7a2b-7924-46d4-ba72-1397b5c0801b","members":["4d260240-ee9c-4013-95fc-adfd97d8e8ef"]},{"cluster_id":"4b2686df-f0ed-4fbd-b1c1-475a6406601a","members":["31ef5786-3116-4f8a-aea5-6e178bc400aa"]},{"cluster_id":"207aa08d-5028-49a1-8eaa-71f4b633ccfb","members":["e23ae7b9-7735-4b43-9ad3-8348a3cc7a8e"]},{"cluster_id":"824a023b-59e7-46a7-a55c-6ef905c079b9","members":["c98bc55a-17cc-4765-9ff5-1a646cbe53fc"]},{"cluster_id":"8335c349-e4e7-4586-b3d0-516ccf0a3944","members":["1cedc6f7-c156-4315-b1bd-f9008b4b24d6"]},{"cluster_id":"6987d44b-afbc-426b-97f6-9a507fedf197","members":["30cfdcae-a082-44ff-88ed-042545fdac8f"]},{"cluster_id":"46ec4fb5-6eba-4f8a-b3a0-e40c112dfda5","members":["6fa2180b-71b1-4dba-b39e-a0559c7554ea"]},{"cluster_id":"40e30cac-a785-4067-9a79-c9832fd15372","members":["ee537e39-4429-40e3-8845-ee67ca23d544"]},{"cluster_id":"c9720688-df71-4db3-980b-d7e5c9b865b6","members":["c2cb8f2e-88ac-4001-b4ed-4d7207083a16"]},{"cluster_id":"8b28dee8-f25f-4ea3-a58f-094086b4ac36","members":["0b7e09d8-a27c-4fe9-b181-633946dc6ea5"]},{"cluster_id":"2826c59b-a252-4d3e-9bdc-eb92dc90ee16","members":["65d3863e-ca86-4022-9d34-a133345d03fb"]},{"cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965","members":["599d6b90-776a-4f56-87ef-3d2d60246da0","bb1119af-cc0c-4cb5-9e2b-372c006a5615","ac2660ea-85e9-4122-bbc2-278ed03028a9","f7818a82-9d09-4ed7-8218-f09097a03a92","55a5fa6c-a334-4d94-865f-60a02ae595f8","76b6d07b-6776-4eab-a9db-0943a7a939d5"]},{"cluster_id":"6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb","members":["b222b17a-80d4-4064-94f0-24f909d52578"]},{"cluster_id":"8b5f4d0a-57ca-4fb0-bc01-110872004685","members":["af19d067-b948-47c7-98fd-27809f978e69"]},{"cluster_id":"805b132f-a73a-418b-a147-d9899a145b6b","members":["8df23cbc-2b04-4468-8a18-14731f0017fb"]},{"cluster_id":"3124bf40-7b7a-44d7-a83e-a1fe41e14ec6","members":["0fc47699-b995-470d-a364-c3f6358a2b00","eb66c65e-7b3f-4c2c-b083-de751245e517"]},{"cluster_id":"193775cc-4b10-4b36-baba-844635425d37","members":["34978d71-5cd6-4bcc-b8fb-1af8ab14cf93","2f7812a5-0f4b-4681-a35b-85b384b624c8"]},{"cluster_id":"3c52b26e-a9d9-4bd3-979f-3455beaaaaec","members":["b1b0f19e-2187-4758-9f75-14aac08259e9","3f95d40a-106b-42a7-89f1-14b558e7a54f"]},{"cluster_id":"28ec4a0f-45df-46a6-a92b-1e0740306f80","members":["5709690d-c5cc-4770-a64c-a2fc10bc7c7a"]},{"cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad","members":["7da30077-3d2d-4fe1-8c1b-fd241f74ec38","ca905cfb-ae15-4198-ba0d-051609c335cb","560e0e32-05d2-442c-8f26-f2984ba3dda8","426173ef-9f0b-4c2f-a119-f5f2aa095d55","7d2f369e-4792-4f44-a2fd-c8db8dc7b072","db778365-385d-4330-8788-2907d8173af1"]},{"cluster_id":"cf59a1ef-ed9e-457e-802d-c83df70e42c0","members":["e8de1b7e-6b74-4c3f-b3ac-e16793d17d46"]},{"cluster_id":"7a33ed40-551f-4f38-8b8c-22ab137818a4","members":["4975ed13-95c3-4dfd-817a-d35b4508e64f"]},{"cluster_id":"cc21b294-9fdf-4b80-a922-5a2fda24edfb","members":["d5983009-517d-4c25-8d0b-45531de5eacf"]},{"cluster_id":"a0925808-7df0-46ec-bb06-9cb553f8b8fd","members":["e79c9566-b494-4c71-85a7-fe6f8ab5c57e","6cfac1b0-30a7-4afb-a149-90cfba3368ae","0c724668-85d6-4a8c-9d9a-0f5348c06218","2f0d2e62-8a4b-4aad-988c-697711c78a85"]},{"cluster_id":"54cb3ed2-7dba-402d-a696-00ebabb32bc1","members":["4bed780a-c77d-43f8-b6fe-392eeafaacfa"]},{"cluster_id":"fc20c413-7f2c-4fbe-b8d9-0aab094ec5bd","members":["e262fb85-8cbc-4876-9555-f8bab2f04923"]},{"cluster_id":"9f40653a-5e27-4d90-9510-e0680c0dbf1e","members":["b6750573-4fc6-4872-8536-11b5ea807dab"]},{"cluster_id":"87cb3f5b-d497-49ea-a871-f34d7080b10b","members":["bb4e58f4-c815-4b72-84c3-a13d90c6fec5"]},{"cluster_id":"bc1909a7-dd59-441d-aab0-42a7a0400bdd","members":["7b4cd620-c2ee-4e4d-a396-fef2ad37c6ab"]},{"cluster_id":"25a859f3-e205-44d1-b703-8d1e9921d967","members":["f78c8c13-6953-42fb-9dba-3a217cb3704c"]},{"cluster_id":"aed5d13a-0c24-4359-9236-cc780ebe021d","members":["f83d17ec-eb10-4831-acc0-dc9c4bb2de3e"]},{"cluster_id":"a89bcef2-6caa-4f8e-9e33-b36ab68a4d84","members":["e0b2c89c-e1b7-42d0-99a7-db7173cdeb27"]},{"cluster_id":"205d2c16-9ba3-4e14-887c-3331a1f50616","members":["68c6a597-9911-4249-85a2-3907f4308006"]},{"cluster_id":"d6d06f17-e283-43e2-b5a1-66991f31adf1","members":["fad79309-d414-43a1-9a9d-2d4a5d42eae3"]},{"cluster_id":"8d547757-303e-43b6-9192-6b5dc2fd34da","members":["bfe4cc35-f75c-478f-8182-e7abfaa57df8"]},{"cluster_id":"d285c4ec-3955-47ea-918b-05a93083bebc","members":["60ce23c3-a9cd-4599-9b3b-71a8ee7b089a","ab296a5c-ee22-4d81-b8ad-0840632776be"]},{"cluster_id":"532d9503-bb11-4fbf-b9c1-5c555fd5393f","members":["741b64eb-0898-424a-93e5-d57095113352"]},{"cluster_id":"783f72c7-55f3-4eb7-a87e-43b3ec9f631e","members":["8b469abc-5c4b-46d0-a323-62abbf9586d0","834752c5-4367-4977-9bc7-8fdca0b7efad"]},{"cluster_id":"de1e5d6e-28d7-4405-8085-e6133787bf1e","members":["11e972ec-8fdd-4957-90ee-084529346007"]},{"cluster_id":"7861388f-c8b9-4ec0-99ed-6ceb81b3764b","members":["1f20599e-7de4-440c-93e1-60e756213623"]},{"cluster_id":"648cf481-ce4a-42cd-869d-b9a572ac3d7d","members":["08af0b8f-6d64-4d24-8866-99133676279d"]},{"cluster_id":"6c57c5d0-33e4-4282-bbc0-6b80393235a6","members":["98a69c88-4aa5-4797-9504-38a3379a6e4b"]},{"cluster_id":"b560200c-3172-4ff5-9c7f-410b8ee34d25","members":["243688f2-31ba-420b-bdd1-55f3774ea934"]},{"cluster_id":"a4149375-9601-4a78-ae4b-69813512b036","members":["a8b7c5e7-0626-44fb-aace-1d52e4c2fd3b"]},{"cluster_id":"b6a2032e-1851-4e5a-bb1b-dbcd29c647ef","members":["7b1297ab-5862-486f-9071-4f90b1855190"]},{"cluster_id":"4246d514-6e8e-4ea0-b242-f59a58eb4bb7","members":["e94d7fbd-75f0-44d3-b424-5299cb09f6f5"]},{"cluster_id":"afd3270e-5e96-4569-902a-2454d2aa0df7","members":["f2009dec-48f9-472c-8a6c-72ec907820ff"]},{"cluster_id":"8bd51f45-6e7b-4825-a6da-736e3f231b22","members":["b82828fb-72b4-438d-8217-b3285d06e625"]},{"cluster_id":"d40b11df-00d1-4f65-b6c2-6f209bb850d8","members":["b34702c2-abc2-41c6-b039-5462213ac454"]},{"cluster_id":"9288082a-2c01-4b74-9421-1882494878c4","members":["38672460-e6a2-4e57-aa25-0580a615e984"]},{"cluster_id":"03682aa9-6c66-493a-b7f2-cba3c38176e4","members":["393a7139-371c-44aa-8032-069fe7cdb7f5"]},{"cluster_id":"754365fe-ff15-423c-803b-8363cd1da39c","members":["e9f5af32-2194-4ad4-9d31-fd32286912f7"]},{"cluster_id":"a1ee8def-adc3-431c-a4cf-3b3370e7d6e5","members":["62c8ffd3-d63a-4c18-a39f-e713c858561a"]},{"cluster_id":"c4974eac-c8ce-4c10-a509-e1191979432a","members":["41859453-3ca7-42e5-ab9d-59bbdf9c64f2"]},{"cluster_id":"aa771524-1314-4f8e-8195-c42cbd659c66","members":["f41106cb-4f98-417b-97a3-ee550457e74e"]},{"cluster_id":"2c29846f-3295-4669-afc6-4c052b5c55d8","members":["f2aefb8c-88ae-4546-a2ba-f328776f4d19","ae152faa-631f-4b0b-bf9e-7452367962ba","040d00aa-47e1-4c98-ad24-df042df860e3"]},{"cluster_id":"273cff70-66df-48dd-9efa-69156787ee64","members":["94f80fa6-0445-46be-82c2-c6464ae6e031","2e24562f-fb40-4a6a-a30a-ae3834c49445"]},{"cluster_id":"39ba0d7c-5f4e-43e3-b6a2-9f87693ee149","members":["f56e724b-f666-418a-9641-60030e9a6e78","eeed5b28-33d1-4972-95cb-16d716b43dc8","191a7f33-31c9-4830-b540-0254a53cf820"]},{"cluster_id":"845395ad-4701-4574-ae25-f53da9fca0d2","members":["cba76ec1-2e4f-4cc5-aaf8-8514021bc6ff"]},{"cluster_id":"f419c65f-41b5-4ce9-829b-e8de4a1f6af4","members":["12ceeaa3-7219-4f4c-8c7f-7dd8c7b97e27"]},{"cluster_id":"96d3560e-8a14-4ba4-9eb9-c3d21f7bd78c","members":["e913e2bd-7e82-4b5d-a9ff-9aa52fe9d532"]},{"cluster_id":"8ee4279e-4251-4f38-b5e1-7ebd99d489b8","members":["85be5d28-9be0-4f96-b52a-a84d13ba804c"]},{"cluster_id":"5ba8f9fd-9c3a-4fe9-8167-be994f757ac9","members":["4edaedb4-1177-4c33-8fe3-a9c57ff64be5"]},{"cluster_id":"1fa41b69-dd08-4cf7-879f-ed94078d9d64","members":["b34f9294-31af-458f-9f7a-e810c428c647"]},{"cluster_id":"7a13b273-8feb-4f23-b79f-e5f89124c43d","members":["76779a0a-a497-45d3-960f-6b7640ef3be9"]},{"cluster_id":"bddeb0a4-a8d3-413c-8b74-f7a5d1e4bffa","members":["c81c8c92-df86-4bef-8972-2c3dced462e8"]},{"cluster_id":"471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec","members":["ff19f0b5-e0d1-47f2-99b1-fd16c13252ab","8ee37723-897a-4a6f-8b39-4c7dd211b1c1"]},{"cluster_id":"4a989aa5-e7cc-4043-809c-9f42086f32b3","members":["44e8bf4b-1ea1-4a06-837d-f5d274fc6298"]},{"cluster_id":"db5ce7c4-0a90-4c8e-b702-060aaa2cd9c6","members":["049dc814-2eea-465a-ae77-96f8303282b5"]},{"cluster_id":"90811b8e-940b-4a7b-bb43-2f0cfe36a594","members":["551694f8-1f83-4aae-9c9c-41e537b939b0"]},{"cluster_id":"52a6626f-4f02-4c13-bf77-4f58640d6881","members":["2db5c7f5-ea01-4b89-ae5e-8c37f503a871"]},{"cluster_id":"104cce1d-7dd6-445b-b83a-f1e498dd3f09","members":["a26573e7-d94c-4d97-b963-0a2f88d078a6"]},{"cluster_id":"117ab6df-7ea4-4ab9-806f-9ec47da0be63","members":["16ee9cf2-3b9a-4256-bf89-3596588e2d8b"]},{"cluster_id":"e1314480-d543-4a51-a6ee-6dc61dbfa929","members":["2e286ee4-f7c4-4ce4-a624-6aa5fbe4cdd1"]},{"cluster_id":"db72597d-c5a9-4920-978e-26eb63ca559c","members":["8dd2c93f-1d8a-4a4a-ad86-633bda279731"]},{"cluster_id":"a80e30ca-b2de-458a-9b37-eea9f6f3a278","members":["f75f429b-c285-4736-8bb9-77a0444909b7"]},{"cluster_id":"cfc691ea-395c-407e-9d4f-47222067d9ee","members":["d12cb5c7-b7f9-47be-b6b4-700896da05da"]},{"cluster_id":"e2a8c8cd-cdce-473b-b2cd-fa97668f4fb5","members":["83856f5d-cd5d-42a7-8bb8-86fc5023ba6c"]},{"cluster_id":"b5146023-e397-4082-afc2-a8c71c288767","members":["301e6dd0-28d1-4fa7-93e7-d1e276348db1"]},{"cluster_id":"60581c58-3e78-4ab6-b577-5edbcc9dc29c","members":["895a1573-a6e8-42d5-b8a3-63fd2799a409"]},{"cluster_id":"6773439f-27bf-46ee-884f-6f78667de502","members":["981e2b7e-9aa1-4557-9067-b3e3be09f2f7","c0188ef1-6375-4482-98b4-030fb26f3e5a","471b5c6a-be85-43f0-8f08-c5d4074a62de","07a7f429-0b04-4bb2-9b73-31695a425c61"]},{"cluster_id":"d5fb5705-8036-4366-acc0-f2b5f625126b","members":["46e5b7e0-08b0-4865-b903-843b9996b895"]},{"cluster_id":"63ff4667-bd37-45e5-853a-bf5f312c00b3","members":["1c6df9bd-4737-4ab4-82f7-3eb4f752c444"]},{"cluster_id":"4c667681-74f7-4591-9add-d06796315d33","members":["503b473d-f061-4805-be91-d667d63484bb"]},{"cluster_id":"6a85e8dd-d86f-4e00-b252-62364be2e0ab","members":["6b2df06c-a07c-49f9-b5cc-626c29f8439e","2d41128c-909b-427b-8694-6449842d91e9","893ebd52-72c9-4155-ab25-1ebc612f8af1","96f5d8f6-6d67-435e-99b5-5e35770b7fed"]},{"cluster_id":"fb8928a2-09db-488e-818b-8455b9d3b5aa","members":["69d75edd-3449-4b43-a59e-e9fd47b7ae01"]},{"cluster_id":"ecf70116-2753-4a2e-946e-961f8655a246","members":["5abcc1de-96c1-448c-a6d2-4ea7fb6cf619"]},{"cluster_id":"69a4b47b-f3fa-41cb-94e3-29a8741c8bf2","members":["cae0288a-9c2b-403c-8e17-3d152591cb2e"]},{"cluster_id":"5c321eda-59e0-4788-8faa-0808e6c83192","members":["d5619de6-e379-4c21-9e41-7b82d2e9cf09"]},{"cluster_id":"dedbca30-3396-4307-a69b-7d7c22f5347b","members":["f38ee2fc-4c47-402d-9dc1-e453902b37dc"]},{"cluster_id":"bf7032f5-cf58-46a3-b595-6510ffda5c2d","members":["7dd19033-9011-4652-a273-02ba7b167fbe"]},{"cluster_id":"ae6a51a8-019c-4d5d-a0b6-079828d681e6","members":["5d015e2b-e346-4f80-bbc2-2d133e230e4a","f7cf7d1c-ea4a-4708-a6f4-9f7fee9cdaba"]},{"cluster_id":"c749df3e-51ac-4d1a-87c6-d17e674f6446","members":["56b67639-9bd2-4892-a5b3-68dd79b4da68"]},{"cluster_id":"065d4388-2dbc-4873-991f-3569f0444b8e","members":["f61b81e2-62fd-460d-80c9-6bf63aa9c42d"]},{"cluster_id":"eee5559c-ba4e-40fd-8448-3d09c753f9ba","members":["62ca5e08-c759-40cb-bfe4-9e7efd707a0e"]},{"cluster_id":"d1dbd6e1-d934-4ffc-ba5a-8d6ce10501d3","members":["4a1d7ffd-9e6c-41be-87e9-e7b2bb5ada22"]},{"cluster_id":"c2075982-499b-4dcd-9327-be17e07c166f","members":["5f29be91-c5bd-4152-8198-05bf8559430f"]},{"cluster_id":"120d5e71-28b6-4974-a584-3c9108ae5780","members":["12ebd395-a9a9-48a9-93d5-f22ee31eb5a0"]},{"cluster_id":"2a492648-efc4-44a2-9eee-4d95d05d104b","members":["659db844-2578-4f14-a374-26004e52686d","ae95c7d1-8919-48a3-b7af-269c6f2fd92b","1fb2122c-caff-46d0-8d3c-6d03fba686fd","c9b72f24-65bb-4256-b0e4-1717a833ac47"]},{"cluster_id":"fece93a1-7734-48a4-99b6-9dce302454b2","members":["65eedcdb-e7eb-4498-b22c-60af062d17cf","6c4cddc2-2c7c-432e-8213-e905a1d3738a"]},{"cluster_id":"fef1afb7-cb5b-46ac-9d94-a3b448d7fa82","members":["8a36bca0-072a-4757-8ae6-18b33483385b"]},{"cluster_id":"41739d94-ef7a-4bdc-b95f-35d9d4daaddf","members":["2da13781-4048-4b5f-b4cb-a78577f53431","97852f8a-f5b8-43ae-a75a-95eb5ed90c03"]},{"cluster_id":"fbf6086c-d11b-4ab9-9b6b-67f0d133c827","members":["8256eadd-706a-446e-a58c-9cc14fa415e9","67ff8a4d-3d4c-42ea-a799-b5bf7cfd1c27"]},{"cluster_id":"3c2e5bbb-18fd-4888-959d-c7aef1790267","members":["c6345b60-d5ec-4372-b335-bcf12bd680cb"]},{"cluster_id":"f4ad4efd-4ba9-41ef-9de7-a560663da99f","members":["b786b12a-50eb-40a8-aee4-17dbff29a504"]},{"cluster_id":"ec281f2d-d4ef-4a4e-a1f0-552896c7315d","members":["30bf0937-8a19-471d-95a6-cb0d6e8a310e"]},{"cluster_id":"c6e2d109-f8d1-42b8-bb0d-16083a37ad8e","members":["ad4528b2-4f55-499b-af2d-b03fbedd1e7f"]},{"cluster_id":"ccd825e8-99a9-452b-8ea7-e5e98518daca","members":["b597baf7-408d-4792-9acc-5679c205c646"]},{"cluster_id":"fe82d3f9-486a-46c2-97e7-5a1b97f02537","members":["966f752b-1058-43b6-b60f-d845aa2120e1"]},{"cluster_id":"21aa3ba8-e0ce-434f-bbd4-03d295297e84","members":["45ecf42f-bf63-49b6-b2da-85a73193e857"]},{"cluster_id":"7fa3c63b-2bb5-48ea-95da-cc1ed541a317","members":["67cb95e5-2f8d-436a-be98-cf9a58fef5c1"]},{"cluster_id":"612d697f-8136-4aba-a8a7-d6de87a2c992","members":["ecb44f8a-8e35-467d-8ca2-17673dfd6e43"]},{"cluster_id":"db9f2811-0988-456d-94ba-acf8fa9e6c6e","members":["62336475-296d-4838-9a8a-b833a4d4142c"]},{"cluster_id":"ab19e784-fddd-46e2-a989-cdf804b997c6","members":["860124bc-f2a7-4ab6-9e29-44cc8b056d61"]},{"cluster_id":"06b0b383-d1f3-4b0b-96d7-d1ed1424d080","members":["cc7fd350-9a27-4fd5-9054-e6c7b35e05fc"]},{"cluster_id":"9a693a02-7bfa-493e-8c56-142555000e80","members":["cfa0a8a3-c151-4166-a74f-93d11dbf5202"]},{"cluster_id":"02bc5fb8-e0fa-4719-bd7d-c08bd3e70f93","members":["cfcd7cc0-f8b2-410a-b690-144365d976fc"]},{"cluster_id":"7a1c3f26-b729-4a3f-8142-fcd9c6768773","members":["85358ada-ded2-4e3c-a579-c736936f7e8c"]},{"cluster_id":"22a57fde-1c2c-4f1c-9861-888038d4fe31","members":["dbe30528-7d99-4b74-8614-cf0c78e26962"]},{"cluster_id":"9fb5a955-823a-4864-b411-b2e83454581e","members":["79d49a22-5863-4981-889b-19072d9fbed9"]},{"cluster_id":"a34d03f2-7fce-45f7-b77c-0c16c720e6db","members":["fd0e1ca9-5c9f-4ff3-96d7-c06309f99fb1"]},{"cluster_id":"7b901b41-b4fa-460e-bc66-e732ffe7ab8c","members":["7fd37d9b-515e-4e44-8623-a14228b18536"]},{"cluster_id":"b61f6891-5a9f-49aa-8194-10b89513a5a2","members":["9758342d-846f-48e2-8b92-5eeebda6d84f"]},{"cluster_id":"dc991813-e94c-49ef-a261-7e441b9dfb8c","members":["d29761e6-4997-42d1-93ea-195b123004a8"]},{"cluster_id":"fe283f5f-5575-4095-b65a-cb6fe0d25e44","members":["339098bd-e1e6-4550-b6d1-60f25374586b"]},{"cluster_id":"442fa925-31c9-4639-8516-7ca59dfe469b","members":["2f3fc5c4-6bcf-4eac-81b9-d55526479821"]},{"cluster_id":"d152f743-9bb8-4932-b2e3-17b89ab993fc","members":["4e26b60c-4367-4953-9339-80b88881cb04"]},{"cluster_id":"bbb1bc4b-f3a4-434c-a53d-625f1645e395","members":["e43e52f7-2fa4-4458-969b-ae3a70bed2f0"]},{"cluster_id":"d6133b17-e010-4dda-908f-2aa315f15880","members":["0cb5aab1-def6-45ea-a897-dd13a4fcb291"]},{"cluster_id":"9db7cf05-3384-426e-a814-edb55b15d53c","members":["b5543f8e-006b-454f-b7e4-1c6ed17817fa"]},{"cluster_id":"0affe3d3-ec5f-48dc-87ba-10392622a134","members":["196b27e2-32f7-4bf1-b456-88904d80aec9"]},{"cluster_id":"5ee5ee7a-bfa2-482d-bd3e-efb0d1c8544c","members":["c04f81b8-5be6-4f6d-b8da-32d6aa21d84f"]},{"cluster_id":"d09cadfe-f589-4fe2-9bf8-e5e3a0697237","members":["59bf1e25-ae86-4f29-97b8-78581d3d04f3"]},{"cluster_id":"8ab3c3be-4d7d-4248-a148-6cf7cee2fef5","members":["60bf6c70-bd10-4413-b426-9d11a9653a75"]},{"cluster_id":"a55753e6-8f8f-48dc-b731-3ea6f869cd52","members":["ca0212d6-7c4b-4e02-b239-11ce52df0bc4"]},{"cluster_id":"ec3d0509-3f1c-4d1f-868c-ba7c16468992","members":["b110c694-281d-45ef-92e8-c0b9affcb346"]},{"cluster_id":"c4df2ece-fef6-47b5-b7cc-a9846a2066d1","members":["0e3d2cc6-1066-48dd-a27e-244e62a48617"]},{"cluster_id":"35826418-a010-4d4a-99fc-5e4fe849cbd8","members":["bcc544a2-efaa-40b7-84c7-71cbad343f84"]},{"cluster_id":"b0d55664-d514-4b2b-87ec-b7bb14627d05","members":["1d65d8ef-b267-4c53-9e26-c6c5beaced86"]},{"cluster_id":"52ede4ef-4c19-445c-ad39-2f9ff6488929","members":["4a658a81-28d6-4abe-9832-22c1a7e3e16a","ffa9efc7-e24b-496f-be05-08f89416a77d"]},{"cluster_id":"df890887-499a-48f3-b818-746e4296c3f6","members":["da266b40-9b7e-4f6b-b6b9-b4f5073e68af"]},{"cluster_id":"efe217b1-d8a9-48f6-b1d3-7579e75d7788","members":["b7bbcc42-c9a1-444b-9fef-ed1c7e0ad146"]},{"cluster_id":"4d26360a-40f3-4825-be04-23732d33f83d","members":["9ef0d9f0-7a35-4e5b-ad5b-6dc0c299e527"]},{"cluster_id":"c5394d0c-cc56-4b26-835a-5c9581cceb3a","members":["e4b1d43c-bbc0-4bc4-8b5a-09ae200e4b31"]},{"cluster_id":"99775dd2-fc60-40f8-87bb-cfdaeb07bbae","members":["0d409954-3f1f-4a11-a677-fabc5e45f83c"]},{"cluster_id":"bf6df861-08b0-407b-91a8-c65beb04c1ff","members":["459f6d39-89f1-4124-b6d3-782d4a49df4f"]},{"cluster_id":"8c2c4d45-17ad-4731-921d-8582fefe2ba4","members":["c8b58a8c-445b-433a-993c-fc7a82490c95"]},{"cluster_id":"075f6940-c670-4659-a33b-590bac9f8a7f","members":["d9878fd5-bcaf-429d-8863-615171a1955a"]},{"cluster_id":"ea8c27e8-3141-489f-a75f-e180b110cc1b","members":["72eb9227-e645-411f-9e19-1b02d4ed398f"]},{"cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3","members":["567319b3-8cbb-4fec-8699-f5d50156c4da","59e758c1-c8a0-4494-ac3a-233f6cf71575","aabd0189-1323-4f67-92ca-fda61971db3e","8f4acf67-0350-4998-bea5-99144f2284fc","37d9a2a5-ee4b-41f7-8007-1c62d3954975","a138054c-510f-4593-b3ab-f16d92c84668"]},{"cluster_id":"a56438b9-f9ce-4dfd-beb8-0ced3dfad829","members":["075cddf6-23f3-4430-888a-d7e4bceaf569"]},{"cluster_id":"c65c30a8-6203-4ff2-8126-866ddc1ad7ee","members":["64a4b6bb-e6f8-4c75-98cb-8cbcd3022f9c","3980372c-6d98-4653-89d9-f9049985a93f","d154989b-b1ce-4814-bd5b-a69ca1172f9a"]},{"cluster_id":"f1494984-39fb-445c-9005-4614903b112c","members":["26d0e6cc-2b41-475c-8845-f74aa9d04201"]},{"cluster_id":"c61c4f53-7efe-4e66-9392-b281164f47d2","members":["073afdee-e01b-46aa-a9c6-1829a7761aea"]},{"cluster_id":"65f3a4f7-31a9-4a5f-92ab-a9f153d96b50","members":["1294ad29-53d1-48f4-810e-59099cff540e","da287e57-b1d7-47c8-b66f-9376a1577d52"]},{"cluster_id":"1a861c93-c5c6-48c2-b775-34eb4363839b","members":["9e3c28e4-6c0a-44a5-8ad1-a17e10e5fded"]},{"cluster_id":"f7318431-bfb5-4f5f-a2ea-e4c01a34de08","members":["f11bc561-5265-46b4-be24-784619995d03"]},{"cluster_id":"fe966747-5532-4145-9e61-737006d6b37e","members":["f30b12d4-dcd1-4f56-aebf-112510f25d5f"]},{"cluster_id":"9fde602a-5d0b-4ab4-85c7-e2300402299d","members":["45421d92-486f-4312-b002-49b5d0a5a857"]},{"cluster_id":"e6db83d3-cda9-4430-8a6e-a7718c384123","members":["48b2d768-230a-4aa5-ab8a-5743244c1e3a"]},{"cluster_id":"6781bc51-3496-4995-a431-ee10c271f91c","members":["4acf7638-53e6-40c9-a142-69a12748f1f2"]},{"cluster_id":"db160e2d-890a-4e75-a5da-9daa0f1dd2e9","members":["80cc3b20-787e-416c-b035-1cd977c998e2"]},{"cluster_id":"9bab6bab-ced4-428f-ad92-fd02b9600f3a","members":["b3b31d70-3d5f-4d91-b7cb-39885ce4fcc6"]},{"cluster_id":"2913b0c9-ef79-4e98-9ca0-9e5e2abf9938","members":["966a16e0-bee9-4168-8b73-67eea3f7ae0c","06f007c0-e0de-480a-93d5-26f93d3f7cea","40aa8d69-a7d4-49c3-bdd0-de57bbff31d7"]},{"cluster_id":"d640924f-577c-4904-972f-ea78d30a1b14","members":["2404a11f-7524-43e2-a24c-41424b74bb3c"]},{"cluster_id":"84a7917f-8218-438c-a1b9-0e45b12c8e34","members":["c9bc0260-f4d6-4947-ba76-41372364aa42"]},{"cluster_id":"3804062b-b30a-4f19-918a-426ffa4b1df7","members":["26adcb73-598e-4f08-976b-f78de7e92ed2"]},{"cluster_id":"ac7642b8-b25c-45db-8998-1d3c7f1c25e7","members":["b4881885-8b42-4b2b-bc5e-2427d67b85b7","97e9dcc9-5f54-4f83-b653-40d574bdafb2","a091cb20-bdd6-46a4-b260-73d734a445d1"]},{"cluster_id":"49ec4675-cceb-45d5-bbb2-56483fcd1319","members":["c55607db-643a-4cbc-b25f-1a43cc9cbce4","94db3d3a-fce0-4c90-bfb1-3758ab374e4b","7c13746a-776d-491b-9b30-589340d3a403"]},{"cluster_id":"f7f70f61-0229-475b-8a17-6b4740f661e4","members":["b1e5a97e-b8a4-452d-8367-66915839ebfd"]},{"cluster_id":"55822882-d3bc-4c00-a9c9-30a5c71ddf43","members":["cbf18eaa-c607-475a-81b4-cbf05023e7bb"]},{"cluster_id":"9e7c5d20-49ac-489c-bf49-38304a7e5439","members":["e1772e61-1e20-4382-be94-490d349fea1c"]},{"cluster_id":"c9b63381-9a94-41a6-b33b-4c75f981d835","members":["e3bf6429-0f20-4ba4-8b26-665f3b75e5a4"]},{"cluster_id":"e47f2b16-ab13-42c0-addb-b9a5881b56d2","members":["ceb9cdf7-9d46-4c9f-8740-f061565ccfa8"]},{"cluster_id":"9a5830fb-a855-4c85-8daf-ed1be558a290","members":["2e025176-d873-4617-8b4e-6f437ac9d311","0dc997c4-c48b-4969-b36a-a7b3f9b227d3"]},{"cluster_id":"73b5bb5e-19ff-4738-bc4e-5908ad8a0474","members":["5562bd6c-3644-4029-b8b5-49f3069414b8","1bba37c6-dcbf-4c61-b3cf-bad3ef1aec62"]},{"cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224","members":["ed917cad-09cd-471c-b261-f1d3e72fd003","3d663718-e7d2-4e18-9008-11c863444483","bda421f3-b15a-4ef0-8627-b9e4ff9795af","2bd084e4-6041-473c-ace8-09633da445b7","107525d3-a6d1-4661-8fc3-97818c3422d7","9e2c67f0-d232-4772-bff4-99e0672e6621"]},{"cluster_id":"fa366373-444d-4a8e-8a61-fb8973c8426c","members":["d6bc271e-34c2-44c8-beaf-77b2fd2c80fd"]},{"cluster_id":"841f304f-f4f1-471e-aa1e-5c0818b42f86","members":["4015b7c3-dd2a-4989-a19d-85367b1ffbff"]},{"cluster_id":"5f903470-ae17-46df-89e3-72da3d3117a4","members":["99e605c6-f488-456b-bf0d-9dbd2b9f9003"]},{"cluster_id":"bc4c213d-8b78-447a-9835-0a8c9c8149b1","members":["fee08dde-a2d5-4671-bebb-7cfa33586d86"]},{"cluster_id":"7348cd32-1a61-49ec-88d2-09ed7c4e132b","members":["8e31e618-084f-41ef-b498-669073ce1420"]},{"cluster_id":"ca521545-0a79-4ba0-851e-a60589334127","members":["eeb0fdb7-038c-4e03-9e57-dce06231b27f"]},{"cluster_id":"e541bcb9-7f32-4df3-a682-0d185b753537","members":["08a265de-ddd4-41d9-9c9b-e726f7e578c2"]},{"cluster_id":"e2835c22-b372-4e91-9b8e-5ef637ee8966","members":["22efaf13-bae7-48b9-ac24-b658143c6474"]},{"cluster_id":"c8a1c00c-d162-4708-afc0-8961e0642155","members":["ea62de52-12d4-4d81-8a68-5fe74dc5074e"]},{"cluster_id":"4a33c4ea-c4b1-416d-9b76-df3e2b9c5ec9","members":["70d7fa7f-606d-4df7-a886-ac349df9049e"]},{"cluster_id":"ba62b16f-4f39-4172-b2c7-0b991499ca69","members":["96fbbb85-f272-4a7f-beb5-baf8b1586d33"]},{"cluster_id":"fc5ae33a-0165-41ca-a5df-b2b0a56f5100","members":["d71b3006-88b0-41b1-b3e5-9186f225d79d"]},{"cluster_id":"346b1dc3-219c-4228-a017-da35814deb33","members":["eeb6921f-9f1d-4f99-a547-4bbd68995d30","0c82cd62-35e8-4be1-a241-0e3314700361"]},{"cluster_id":"602ccd3f-b2b7-474a-9029-74260beb7902","members":["8191a74c-d1ab-47a8-9174-f0d5cbfd58ca","320f8044-4928-405e-98ad-346aac87e661","91111922-c5d4-4a81-8de2-6b66f1c3279b","90ceca1b-3c57-4f9c-9fa7-8efa71128ef7"]},{"cluster_id":"0103bebb-a8e1-4ccf-b716-fa6fd4687ac3","members":["b53eff8f-aadc-42a8-ab34-a617398456c5","e2cc944e-8a81-4438-83eb-08e38d9b479c"]},{"cluster_id":"c8feb5d9-ef93-4465-bcb1-5c7e4847fb27","members":["4e94fa2f-75fd-435f-9008-7932c588c0e3"]},{"cluster_id":"155333a7-ab36-4219-a8f6-9496d1f00dc8","members":["ed3e4012-24a0-4a30-aef0-11715ad3f744"]},{"cluster_id":"a19f2358-dc1d-4de3-8588-b9d055ccede4","members":["afca75d1-e3a8-40b8-b590-69bddd25646a"]},{"cluster_id":"e228a8c4-9bff-4634-a77f-16ed4aba6a89","members":["ac1155ef-570d-42ff-9439-4132f58aa74d","302e816b-f422-46c4-86df-22ab149772ca"]},{"cluster_id":"adf7c833-60db-4866-83b7-e6d0f1133790","members":["a8695eab-8246-4726-b5e9-2e579aabe031"]},{"cluster_id":"6e339b28-0894-4d85-a536-569236e90bbf","members":["d0146263-c582-47b2-8757-4deb785b6900"]},{"cluster_id":"5eaa7b8f-5e2f-4cc2-827c-b780c20bc557","members":["302853a2-fb88-4896-9616-6741fd099aac","ebec5226-e1a3-41dc-aadc-8c4d372988e5","d929b334-9fdd-4c58-a430-ec532b3d7d49"]},{"cluster_id":"2d92a79a-ce61-4af0-b8af-8322336cee3b","members":["914af81b-99f3-4771-ad7a-a28ece1a25e1"]},{"cluster_id":"c6098f7c-9ca7-42cb-9f44-6b467087e324","members":["0f0a3feb-fe9f-44dd-866d-26c18406276a"]},{"cluster_id":"ed2533cf-2013-4e49-885b-231a6c55f0fb","members":["b5731f9d-93e5-410c-b508-af876a95e93e","f07a5bb2-52e0-4447-921c-e5afec933df2"]},{"cluster_id":"3df2dbeb-6250-425e-8956-8daf269e1976","members":["d1e32d54-7605-4c03-9379-6fb1f04f9705"]},{"cluster_id":"38fb1864-3682-4d4c-81c3-5ce8e0bbc80e","members":["a5a0e63e-a40f-4653-b49f-b08501abfb44"]},{"cluster_id":"827e3030-1738-4370-a530-42878dd6927d","members":["8b83fac7-c728-4306-a23a-fa7239f16085","1d81f6e5-45a5-4b20-82c9-3a1c00a30b73"]},{"cluster_id":"a54ebcea-b85a-4358-b8f9-7f678d18fb51","members":["92aedbd2-b062-4251-8a00-dc65bac74d4c"]},{"cluster_id":"80adf73d-0e40-41bf-902a-efc33053db25","members":["b0b293e8-0639-41aa-b1a3-39f70d6c4033"]},{"cluster_id":"8b1769db-6aae-4f31-8eca-13c7641a8a79","members":["c97a3438-9ff1-491b-a8e6-64b881df842a","c72ffe7e-58cc-4d2a-86b6-10bd9f697b5f","20c808b1-fae8-4461-9cd2-903c3c6dd6ce"]},{"cluster_id":"bd2a5352-41e8-4479-ac51-89fb57ca65cd","members":["0b41f824-fa87-4638-b004-e5ce1e8425a8","3d87295a-229b-4465-8a0b-4118c603b1de"]},{"cluster_id":"2ef5fcdf-761e-402d-8549-a04bd0b86028","members":["b2c435b6-21f1-4e3e-9b9e-70fd33a7816e"]},{"cluster_id":"ceded39c-ad6f-4d12-9e04-8034f780e209","members":["b4054bff-2507-43d7-aafc-6ffe90087e86","984d798b-65ca-481c-a6fd-8b4a2a459f92"]},{"cluster_id":"c16a80f4-74b2-4799-878f-766f008df3df","members":["ee09ba8a-7d35-40f4-8c9a-596a029c42cf"]},{"cluster_id":"4a121497-0e52-49d8-8aba-88f4fe1ef31b","members":["f73719c7-0c81-4646-8507-3d12750a599b"]},{"cluster_id":"fc33211b-6f76-4ea3-8d05-51362bd964b0","members":["625c1b7f-d304-4eb3-bfaf-a0c0a690ca38"]},{"cluster_id":"7afc1db8-da22-4a16-9a76-d5155374bce3","members":["aba98aef-afc1-4471-a4a7-7dde428a52b2"]},{"cluster_id":"0f5dbdfc-39dd-4747-8fd7-3316ceae5bdf","members":["b379680b-f10c-4990-be8d-21679d10a1fb"]},{"cluster_id":"50ed7708-9545-452f-b227-8fc95b9490b9","members":["3f3e0fb1-eae8-4080-bf01-d3e1fff5f2f2"]},{"cluster_id":"fad9d4a0-4f96-4cbe-870b-9fccf870e5e8","members":["0164cbdb-5835-494f-bea8-4b0f499cbdbf"]},{"cluster_id":"e90f8735-8232-4af5-85c8-b777502c4f0b","members":["50755e27-77b6-427f-93dd-a87731a11646"]},{"cluster_id":"5bdf6eac-3c30-44f7-ad10-121cdd88f987","members":["d4c1d571-a06c-4ee5-91dd-4159cee958ba"]},{"cluster_id":"e0af4c3d-214d-424d-955e-14071d90129c","members":["8a7c278b-a05a-47e5-a782-f333e3abd311","12fb89a8-7d3a-44d8-9034-eb35ba71efe1"]},{"cluster_id":"cb5e091b-477e-46e6-aa3e-6f7875bd065d","members":["3719c3d8-be42-4a6d-aea6-0faa841a3224"]},{"cluster_id":"418af057-88c5-4485-917f-178851436407","members":["463e2730-3293-4e8d-b87b-d16f9fde8c30"]},{"cluster_id":"afc0b94b-3d14-41ac-a746-8c4fbe3bd721","members":["f88219d8-400c-4903-9cf1-aaf5dc8c6ce1","98f37028-97a3-4ac8-b09e-145a9b1fab36"]},{"cluster_id":"748efe6a-9ff2-447f-9d13-f72501f7e924","members":["231bd0ea-a301-44d9-a0fd-8b1f75fb9a13"]},{"cluster_id":"b4d1a337-88d8-4989-8d52-1a04d38e6e21","members":["f134ec02-dc6c-40cd-af19-e83401adec30","3a81ca66-f500-4e6b-92a7-0400526c47e9","2332057b-0bbe-47b7-b70a-de96fc18e69c"]},{"cluster_id":"ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e","members":["73ce06b7-ecbd-4700-b340-1fae1a530920"]},{"cluster_id":"b9b5e870-c720-4c60-8d9c-ce6b4803fb78","members":["37be92fe-4739-4a8d-a3a8-9967c770e07b"]},{"cluster_id":"63fb948c-76fb-4787-aafa-ea3ce79ec01f","members":["f36fd863-41fb-4892-8b41-fa4f145056b2"]},{"cluster_id":"f004205a-4f06-4d9f-aafe-357afc465bbc","members":["75e474b7-52a7-4ce0-93d3-5c5b15d37224"]},{"cluster_id":"d3accedd-14e9-432e-a272-98af2dae3b98","members":["87bdf665-a018-48bc-b1bb-90ecd420038c"]},{"cluster_id":"ee97e835-1007-4cd5-b270-714f0880c07e","members":["46ee1a0b-a0b7-49f9-8b25-48fbc78eec74","819c7079-e076-42eb-a9ad-1828cd7d30dc"]},{"cluster_id":"d32bd6fd-0fc9-411f-b6d0-ef85e52f9cf2","members":["a64fb6fe-0fc8-43ff-8d37-977d9877692b"]},{"cluster_id":"107cb2f5-f373-4a33-aa9c-b2f0173d4807","members":["6fe08ef8-5a44-4e36-84d5-fded1981aaea"]},{"cluster_id":"763d8e8c-b156-404c-ae43-97e544b0ec16","members":["5d2dd122-64ca-430f-8ef0-a4833c97a70c"]},{"cluster_id":"7abc7765-0bd9-4361-a00a-d261cc270c4f","members":["87ec48c4-b7e0-4dda-b630-292aba0fe9ad"]},{"cluster_id":"b56ca1ab-f300-4476-ac21-f73e07a1dfa9","members":["b79ffa68-6e5b-440f-90cc-fa63873d6110"]},{"cluster_id":"fbda0675-25d1-4968-aecf-16ed15e84db5","members":["5c4118aa-ea83-4a17-94be-41b87f24e9e2"]},{"cluster_id":"f4bde172-477b-497a-9e85-fb7b55ca0d1c","members":["05eac3b3-ebba-40d5-90e8-e137e96d3021"]},{"cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b","members":["f29f0dfd-548c-4256-b7b3-e1a619c23c14","67125cac-09db-4955-96c3-0b30d5ed593e","c17b3626-b338-48e3-b571-2baade16e313","42074ae2-3944-45c8-b8f5-a31e31728ae8","21277a00-c4c4-43b8-ae10-036e94a1c107"]},{"cluster_id":"c7e4e067-9226-4d57-b404-ebdc121f49ed","members":["be9ee0b6-56dc-4278-bde1-49d32891bb4f"]},{"cluster_id":"97ffbb55-ab53-43e7-aa63-34930f97c42a","members":["755794e1-02c5-4711-b795-71a6f11e2345"]},{"cluster_id":"2caf488d-b467-4866-8066-64992d68542c","members":["431df094-aa85-427f-a056-e553a0b60b40"]},{"cluster_id":"76557fca-1139-4be6-b8fd-797e3828c438","members":["50cb179b-a08b-466c-8c5b-1a1879c7fc80"]},{"cluster_id":"e1299aca-73c3-4bf2-9656-1a4bc5aa21cd","members":["ba04f4a7-d816-4938-8fb3-f9075b90b071"]},{"cluster_id":"d77c268e-3ade-486d-9ca6-faf269499c35","members":["5b999078-8c20-41b4-8f1a-0aa73a32b435"]},{"cluster_id":"79c33296-4152-4931-a84a-5c44d838a216","members":["7c3be797-44d5-4e4f-b318-d24f976e74ec"]},{"cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981","members":["9a7b32ab-adad-4f12-a6d6-9303b5436a96","383b2738-9a06-4fbb-b686-d25d6df14cd6","f7bbb825-6e31-4836-94fc-c9c21877a002","5e6b38d1-6cbc-4588-aa7f-246cbe88558c","315d889f-8b63-4b74-9306-370992b51965","125f05cc-1fb8-4a4b-a3f5-daa08d0d3c0a","98d9880a-94a8-43e1-8692-398e6eb9ab41","aec337db-26f4-4278-88a8-00eeb563ef5c","268224a1-81a0-40a0-b100-0e3b897c7a24","527dc6f0-d251-4dee-8108-e6d965d1acff","3f92d0af-93ee-44f1-a853-b4668e51263d"]},{"cluster_id":"d2d5d22c-9f8f-472b-b123-61d32af5f64f","members":["15a96114-e2bd-485c-aa5d-b964e9f557d5"]},{"cluster_id":"40e574c7-e1d8-4cc8-a46a-a5e8d1efd793","members":["9f7a7753-8a9a-46c9-8cb8-efe4ed91f99e","5119233f-1bde-4d13-a8de-e2dc2a367cfb"]},{"cluster_id":"4eaa501e-252e-4e04-8606-fd467f380267","members":["6b55a69b-e063-423b-b214-33e4d517fc9f"]},{"cluster_id":"8a948aba-63b5-4bbf-9ee5-595eefc57f01","members":["e1132d0a-c744-45d4-b6e4-4608e9abdeab"]},{"cluster_id":"b0630042-6031-4b80-9db0-071e1119e981","members":["fe43aed4-9f28-4fc4-b48c-9489789f7459"]},{"cluster_id":"84d3d5e2-5fb1-4388-9576-0de3210a0439","members":["c62cf8da-abf3-43bf-94cc-e12ff7085cc2"]},{"cluster_id":"f37e4c75-6082-4bd0-a321-a0f77cf2c5cf","members":["6517a7fb-4a3b-454e-a3af-f52a9e6f5199"]},{"cluster_id":"a40aca49-8fcc-4409-91ff-d18e1fba8028","members":["a6568a79-5d7d-40ab-a6ff-612ccd37292f"]},{"cluster_id":"4262a8eb-f5c3-4d49-bd20-1198efa845c5","members":["45646d38-96b8-4175-8594-8b2a0b3c72d1"]},{"cluster_id":"410ec318-9df5-41c9-964f-b2ab6d13b1bf","members":["4bee0fdf-d6c3-4441-8326-91778e5e490e"]},{"cluster_id":"ddc05fce-b4da-4da7-88d2-dbf6d447379a","members":["8d653be1-298c-4b9d-b6ad-ee802b9bbaf0"]},{"cluster_id":"f5124798-4595-40cb-94e4-b0f1143b648a","members":["c70af5b9-8ff9-47dc-8923-58d2a3de24c2"]},{"cluster_id":"dbf1c410-0096-4098-84d3-5c9270d536df","members":["0a95aae4-dc65-4e88-a746-6b0ccc441a7b"]},{"cluster_id":"34d1bb66-1439-414b-aa89-28ecbed93a5f","members":["878f60f7-2c9c-456b-bd0a-98b48d713d6b"]},{"cluster_id":"c1eef27a-1e7c-4cf7-af1a-61c89699baa9","members":["32cd072d-1d55-46c3-9fcb-967982981b41"]},{"cluster_id":"4dfac31b-2847-4ea8-85ec-0e74ca3ab755","members":["9e4e2c61-938a-47d9-8d90-f15250db1a88"]},{"cluster_id":"3de2ede6-0765-4692-aac5-cd554d7b3943","members":["88c9155f-d83c-4a5a-bd85-300b457d50b0"]},{"cluster_id":"2d62bce3-b515-4666-bea6-d3d1e123e654","members":["fb36dc49-7f11-4386-9852-41847d1f0cd1"]},{"cluster_id":"a59be105-d89d-41df-ade9-920d14216360","members":["18657478-bf97-495b-b772-5db4e7bf42e3"]},{"cluster_id":"0c90c874-03f1-47c0-b8b4-7fe34021d559","members":["9faa1b2f-3604-464c-82bc-dcc620f3be67"]},{"cluster_id":"09cc9ddb-b9ec-4c5d-8b8e-25af134763fe","members":["ab7b07e9-0211-423f-807a-5eaf90fcbc3b"]},{"cluster_id":"ed35cf79-8410-4493-b5e5-ebfe6d51aab0","members":["62fb3a39-8949-44f1-aa76-ead5da769f4d"]},{"cluster_id":"bb498dfb-0342-4611-a82f-6ce424759a23","members":["b1a06f5c-9114-4179-893a-dd7aa8909812"]},{"cluster_id":"20ed0e78-890f-400b-a5b8-9f3252623084","members":["349cc3b2-246e-4b61-b4b8-0b99b9f179d1"]},{"cluster_id":"800e1de8-b1a3-400a-bda3-2e81d524609f","members":["706089a4-2389-45ca-833f-2cb91c20612c"]},{"cluster_id":"43cd70ef-d6cc-421f-9e30-15cc399119b7","members":["7445b65e-78b0-4696-862f-f23d49d0534f"]},{"cluster_id":"09d77729-56d6-4baf-a41c-830b574929ac","members":["6e6f56e2-0357-4089-a86a-306d5191e154"]},{"cluster_id":"b6f8ab92-0a99-4ae3-a84c-c1ab0b6d7d39","members":["5bca25b0-64f2-4e68-9241-834a044e8575"]},{"cluster_id":"c9d26401-7e49-4279-ad09-55dcf3457ac8","members":["226ceb8b-abf4-44b9-af59-ea096de45e23"]},{"cluster_id":"f19998d7-da9d-4ad2-b0f0-03ca5c82143c","members":["c5c758cd-d80a-4980-a891-99320447bccf","f9699cb3-e907-45c3-9661-478a013893b5"]},{"cluster_id":"9c4cbf68-9385-4898-9bf2-17346263f863","members":["3bfef735-f736-4651-b093-622fec87b359","5d30da82-103d-48ce-8488-ed7168079cca"]},{"cluster_id":"88bb793a-f03a-44d3-bc64-124f3010e3b7","members":["ba7e4c8a-4ba4-4438-be04-8079d06e2888","ef8872a9-7c5f-45a1-8cee-50f47b855f12"]},{"cluster_id":"95af035b-c14e-4753-b211-c4a8a4ddbdf2","members":["b9c77f05-bf4b-4ac1-aa19-d41b8f87ffa8","a994e659-49e3-4806-825e-e666077e798c"]},{"cluster_id":"7ed8137c-2279-4400-b674-1dd86eab9aa5","members":["0be6a6cb-99f1-4df2-a393-55d344d7a96e"]},{"cluster_id":"67c7f204-fd07-4c45-80b1-5b0bd873efd4","members":["8f093309-41f8-46b7-a897-d0b92c2d89ec","538ca86c-a065-4064-bc05-9aa8e765059b"]},{"cluster_id":"249e8c50-f68d-47af-99c9-2bc6ddfd52ad","members":["6ed9017a-8290-483a-b596-237e4d9a8691","92ca9dcf-ae92-4e9c-86b6-bc238956a0fd","e9f26f83-5107-4efe-ba57-4e58c267e160"]},{"cluster_id":"c557e9b2-c812-48ee-97cb-707e7e40672b","members":["85f18008-d73c-4be7-a7ef-d9583d4603b6"]},{"cluster_id":"7ccf5ec9-3916-43b6-a44f-7cfb24300693","members":["8e04e7f5-ebfa-4e96-97d6-6daf2585c48b"]},{"cluster_id":"e52fcc8f-16ac-4c0e-8ef2-f3d55d44895d","members":["5f57dd5b-0ae7-40d5-a5ca-9367e781b141"]},{"cluster_id":"f3090987-9e96-4cf1-95d6-22fba3e8d946","members":["8541b447-be43-4696-b3c3-5bdfa1d5a546"]},{"cluster_id":"86faa30d-3051-4174-a28e-c3bb4b4beacf","members":["97b37768-0d05-4cec-963e-4480131aae91"]},{"cluster_id":"d327e87e-5fd2-4607-86c2-9433a227a64c","members":["f781bac7-dd39-4977-955c-df979d834d8f"]},{"cluster_id":"7e7ac228-2e81-4fa8-abfb-35fbbdf2b4b2","members":["3f72006d-2cca-4708-a17e-4e5d64891aee"]},{"cluster_id":"1bbcb23d-9835-462a-b09f-6a4c89faa361","members":["835df69e-1dfc-4ef9-a704-e9ac185f1811","a2d5e081-969b-4ff8-bc6a-3147ec0b0e4f"]},{"cluster_id":"f17de551-5a88-4bbe-a63a-f23269257469","members":["d27385f6-dc81-41f1-bd61-a8d1042beff5"]},{"cluster_id":"b14f50e3-04b1-4e58-a4b1-8a1de6c4e2d2","members":["becfd5d5-1ee9-4d06-80a8-a79a26aa2477"]},{"cluster_id":"01d21517-243e-4d94-b9c5-641f8bca7cbf","members":["4a2448c9-7554-4b09-bd39-f9e0e083b9ca","0bb33664-bc8c-4f5e-936b-5765fc3b8eb1","595f05b3-4923-4276-a40b-30ff906894e4"]},{"cluster_id":"61dc215b-cc5e-49f1-add7-65f02e137ed1","members":["42458045-832d-4bd1-92d2-d4c694c26f6a"]},{"cluster_id":"5d6331d6-8b39-45dc-b069-c03168d82aac","members":["5436c0c4-f842-44ed-8cc7-21090a503ef6","3bc54be7-e813-4259-b9e4-4803b179b0c3"]},{"cluster_id":"76f2f5fc-c5b8-4d6e-932c-655254df8fc2","members":["1cafa29a-dd5f-40e2-9527-b695d279038f"]},{"cluster_id":"398a087e-4a63-4bd1-8ad7-e71ca757db9e","members":["4237e997-e389-47a7-8c3c-920d420cadd9"]},{"cluster_id":"94f3a60f-f903-4813-b891-508644ee87e0","members":["eb87c822-aa00-40d8-9132-8436825cc3b6"]},{"cluster_id":"a300ab57-0a8d-448b-8ceb-9af6a492c83c","members":["061f2a7f-a450-490d-8a05-29766f1c9832"]},{"cluster_id":"1f210f48-5853-4bb8-8fc2-d9a334fec30a","members":["5b910185-927d-4126-ad30-34c4c4e875ac","354067ed-7f02-4349-9879-a50784d2ba8e"]},{"cluster_id":"bc5a19f9-2b61-40ac-ae39-5951370b4cf0","members":["c01d4753-8ca2-4cc3-b5fa-d6582dc6d580"]},{"cluster_id":"21518841-2c46-4292-abad-aff342a4f1ac","members":["2a90d6e5-3007-4530-9648-5f391357af33","9eec3efe-4807-4322-886e-22aa5f0309a5","f3c12118-c8a6-4eae-99f9-ad90880ce29c"]},{"cluster_id":"88714dc6-72d5-4f7f-9067-219b66b31c42","members":["7aba1bf9-7b64-4cd3-be68-21f773aecd32"]},{"cluster_id":"b2894bf3-d539-4a31-9d16-59a88bacee25","members":["846a8102-f54e-45d8-af36-9011340fc325","b1052026-44b4-4684-9390-7d2478ae71ac"]},{"cluster_id":"3035cab4-7bf7-4e5f-b8ff-717930d9caf2","members":["70ea83d9-60d5-4779-baa5-92ec4617ee80","4af338f2-92aa-41fc-abd0-d816738ca401","cb67794a-bd78-40b6-b30e-648c7caea549","e0b2503d-fda4-4211-8c27-f6408b345eac"]},{"cluster_id":"38a250d4-c72a-4095-9b75-66d5fbc4da25","members":["05266523-2b9f-4ee2-94d2-77d005fa5d9e"]},{"cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b","members":["038a37c6-587a-4f25-a13b-0060d10e76b6","61fff634-9e30-41df-a329-fb86fad4bc7c","2f542fe7-1497-4ca8-a4ab-b6647fd05366","51c0d92f-0651-465b-99bf-de8081c26d82","d02dcf65-6a38-45fb-a525-077a35bf4ef7"]},{"cluster_id":"126f7904-d5da-4bb4-861e-215114767499","members":["7d607d2b-c2b4-41c0-80d6-59cc1f874fad"]},{"cluster_id":"0be2a099-9ff6-4c81-a576-b1f6726557d6","members":["d7b28e21-78df-411a-bb94-fcad5275b2a2"]},{"cluster_id":"27e1dbcf-9461-42c2-9fb6-7b948072caae","members":["ebe94c24-895e-44db-a93b-e32d2ab0659b"]},{"cluster_id":"bd0a5021-3a05-428a-a728-61f8cfe02fc4","members":["deac6fbe-1f71-4bac-b1b7-c5b1dc0f1774"]},{"cluster_id":"720ca61f-9942-490c-ab91-755d5a979ee2","members":["7d64a856-24be-44dd-a9da-520d2e65c291","38608f01-edd3-4b98-bf21-80f5ae498ba3"]},{"cluster_id":"68efa2f8-df62-4c55-a56e-6a0d6368d6f1","members":["2a79c149-117c-4238-8185-4e0749498fe5"]},{"cluster_id":"1543a0aa-5824-449c-b496-3562005d2d52","members":["ec6e8289-3019-4927-8667-3a447ba0d51f"]},{"cluster_id":"a7e57243-5f25-4292-b208-646cbc973faf","members":["8e11e6b5-a90f-4e1c-9b23-8c17083004b7"]},{"cluster_id":"0480c8ed-40a7-40dc-ac24-9b8fa7551edc","members":["9b1d093f-de0f-46ef-8565-0e1e1e296258"]},{"cluster_id":"2e675266-c3ed-4fac-a036-217c24ac28e2","members":["0193104e-6045-4742-86f6-04bf99e3c2b1","dbe6bc50-37e5-422e-9c48-1d03b7c6b417"]},{"cluster_id":"2648c3b9-64e2-4596-9353-c37ae996dcce","members":["a822948a-1959-4fef-ac9b-454dd71b7ebd","67f5e913-cd9d-419b-a4e8-8628d477d227"]},{"cluster_id":"5e5c65ad-4c51-4a27-ad63-eac217deb431","members":["b7521441-865b-4d5b-8f9e-0fae92ec0a98"]},{"cluster_id":"02e73dfc-86f2-4fe6-a79c-d071e07721fd","members":["2f4d1d64-a278-4bc2-a3f0-9eefb7d52ec3","4e458c17-6cf6-466b-9154-435a6288efd2"]},{"cluster_id":"11875278-ef5e-43b1-8558-2410f47e68af","members":["ea38c269-5631-4bcc-b8d3-27432d6d205d"]},{"cluster_id":"ac86516b-573a-4ca5-9a1d-d4dd1666f20a","members":["500fd674-8c2b-49dc-b3d8-929f25693844"]},{"cluster_id":"d9df9f73-2328-4c08-a547-bba4c4ece24c","members":["fb0ebb50-3e74-49d1-af14-f0368e2f4ccf"]},{"cluster_id":"a9de4b16-c663-4b5e-933f-b9821d2cc80d","members":["3f0cfc3c-6092-41fa-b4e0-4e3a1dc9a762"]},{"cluster_id":"870cf570-e7db-4612-8845-9e41f8062b78","members":["15c1dfe3-0363-4cff-be4f-224832389ab8"]},{"cluster_id":"dafa634a-37de-4d53-8bbc-fae67a8455d0","members":["bf4001ea-43c2-406d-a13a-2b8b6cad0303","f531b748-c838-4a44-9e54-b10e5b546449"]},{"cluster_id":"823a1b7a-305d-4292-886b-7974a056d98e","members":["e059f732-82f9-4913-a509-434e9c5747cd"]},{"cluster_id":"bc907223-19f6-4c59-ade2-142b6a28be4c","members":["bd7254eb-60f0-4a5a-9010-4872e83eb688"]},{"cluster_id":"9040babf-0be0-48e4-a916-be2a06953769","members":["66017d11-b8de-45e4-97a0-4407d199553e"]},{"cluster_id":"568dc264-fa77-45fb-8b1b-5c901f185f7a","members":["3e187232-2098-4d5a-9214-b01fb3db2fd2"]},{"cluster_id":"5da78bf8-d65b-4a01-8353-c40daa91e80b","members":["e4eb03db-324c-497b-b470-d26162590c0d"]},{"cluster_id":"5035fa8a-cb8a-4b4a-a412-c85f5b3586dd","members":["38b8faf4-24b6-4c13-8487-555b40638b4a"]},{"cluster_id":"8f06b71d-e458-4241-be0b-c89c223296af","members":["c8d99fb4-a377-4d8c-9a97-646b22b0a25c"]},{"cluster_id":"dc2b8b73-2640-4b6c-a7d1-9e5c9873bbf6","members":["7d0eea2c-fa47-4916-a830-68d3b0a9a8e6"]},{"cluster_id":"690596f3-57f6-4044-a245-63584bb2f8ea","members":["142e6f0f-66ee-4e30-8fb6-5d1231933c62"]},{"cluster_id":"7e23b4ba-cb72-4329-9b5e-d475d9898055","members":["b4b93ab7-a67d-477c-98ef-76796d962b14"]},{"cluster_id":"9ed0391b-e831-497d-9d87-ba9ea12680b7","members":["59a2e99c-785e-4708-9cab-e248cdc6dd5f","36551982-daa0-4a06-9ce2-7a5b46b08a44"]},{"cluster_id":"19c9dde1-93ad-454a-9809-5f87d3869615","members":["53df0d0e-5777-43a7-b6a5-13dbe796107c"]},{"cluster_id":"212923c3-f34e-4b5a-bb85-95bfbbff9db0","members":["8dda944c-daf5-4de1-abd2-519df4af39a7"]},{"cluster_id":"b10b3160-e0dc-461b-a456-f6327586eb6a","members":["7672a79d-ae4d-4dd0-a071-2e0e0ffc6d1c","e968f688-f65e-4c2d-9614-30a30a4b1e67"]},{"cluster_id":"752e0a5d-00fb-472d-909a-65284c58e6d5","members":["6352eb6a-310e-4990-aa9d-97fb6f01ca44"]},{"cluster_id":"1c2050b3-8746-45bf-a7a2-7907e141c266","members":["ee405ef0-07c3-43ed-a7a1-315200fbb76f"]},{"cluster_id":"433a8504-6f95-4801-98c2-808b28575d4f","members":["40bf4e92-c095-4b70-949c-2ce4acdf7675"]},{"cluster_id":"71167ddf-4ec9-4903-a616-db6af6caed15","members":["8e8e10a5-f251-4923-9aec-713685c45ce4"]},{"cluster_id":"4fb659e6-6366-4a40-9ae4-1332edb2d8b2","members":["2685e2d0-c53b-4131-873c-e4506a1f0397"]},{"cluster_id":"00fbd015-4c36-4680-a582-bfc7271c3275","members":["2b7f1d81-e1c8-41a2-89d6-d34c18e9e551"]},{"cluster_id":"ad846634-778f-48a1-8b99-37387f981b3f","members":["7c174032-c3d6-4588-a644-ec1743e86a8c"]},{"cluster_id":"0c4c6169-f685-4aa8-b6de-d396766a5c80","members":["473dea4a-3002-4416-a691-6b01312e1875"]},{"cluster_id":"7512ed6a-dee9-4a0a-b3bd-71a36d7ff111","members":["860458dd-eabd-4f82-952f-5ddb0e5ba089"]},{"cluster_id":"6b61dc7f-0dcc-4798-86a9-dfa23b5c3897","members":["71d4a8ff-625e-4525-a6ab-860eefb4532d"]},{"cluster_id":"f50f4ad4-412c-4470-94b2-718ecc122ebe","members":["be7102cb-0b57-4bc1-9d3a-f4ab5e05daf7"]},{"cluster_id":"30d2097c-43cf-415c-84fd-ec7c279c4c87","members":["54d4e00f-cf3a-42e9-a73b-ea9d732d99cd"]},{"cluster_id":"3f25d73b-25b5-4e43-b335-2f8f8664eb00","members":["d4c4d200-1d08-4c8e-a9dd-35eda11cdfaf"]},{"cluster_id":"6e27c008-554e-490f-bd40-be5dceee83e2","members":["44069781-87ef-498a-99ba-22f1d64541a8"]},{"cluster_id":"a2518533-4468-4125-948f-3516caac3b26","members":["88e2c9e1-bfa1-4d99-a82c-318741c224f9"]},{"cluster_id":"e262a7ae-4e83-451f-b2c4-34917839f661","members":["05729b15-4eb7-4f82-a0b8-028aab48cbfe"]},{"cluster_id":"71236786-30d7-40e5-8b9f-3cc8f5e06fd8","members":["e9d64a2b-a2bd-41aa-a143-f2c539d9bfee"]},{"cluster_id":"9a5d054e-318a-4826-9d5f-20df372185b2","members":["83dbeb35-e014-4551-966a-5f97f62c8308"]},{"cluster_id":"31dfadd3-c8f6-437b-b8ec-a69992a26cb8","members":["1b1b77c7-882b-4e3f-bba9-1f841f27246c","f978a9ba-a72a-4d76-ad65-4fc16420acf4"]},{"cluster_id":"d291acf3-7cf8-4c9d-9ab4-df11bad39953","members":["e2d654e4-dbb7-4eb1-97ec-2e7d3c55c4ac","adfe034a-1d47-4b01-a3b4-3ee50f4c4d29","3119678a-5fd7-4f1e-a362-401a8f99b6b2"]},{"cluster_id":"cb3aa2af-d703-4ae9-b53d-f7c0ae589678","members":["bd31ef10-7bcd-4b4c-b37c-4a3b59cc3763"]},{"cluster_id":"019a31da-45d0-4ffd-a58b-773a16c0362f","members":["ee4850dd-7ffb-488a-8195-1b9ae464b1e7"]},{"cluster_id":"152183a2-1d35-42be-bb3a-d49654ea4707","members":["219e1b1c-8243-46cd-ac04-413e5b148da6"]},{"cluster_id":"317eba1c-3b6f-43f0-a757-dddfa7966147","members":["ba602c99-8f43-4cd6-b850-ff63349886b1"]},{"cluster_id":"f70d2311-4ede-4f3e-b4d9-bb1c5def4b48","members":["9d543810-cd90-4ea8-9a60-e10f583ca1d0"]},{"cluster_id":"5502f4b5-10c2-450c-b072-20a0d153fef3","members":["76a2ce33-876f-41ad-be02-4b81d4ed8b2f"]},{"cluster_id":"ed113c66-0348-4af6-b4bc-60c420311e2a","members":["05ab73c2-13ed-4c61-9755-a7404dfd3d9d"]},{"cluster_id":"5bb2e685-4a07-4889-91ac-49a28d63a36e","members":["72686c67-9f6f-4d0a-b620-e6f21ba98772"]},{"cluster_id":"d335936b-95df-4111-8cb1-decd8664543a","members":["4421bcf8-b453-4431-ab63-16355715a87a"]},{"cluster_id":"994a89fa-3e4a-45ec-b0ad-a34f5031641f","members":["d1e22a56-4fb4-48ea-8923-c7fd6cfda446"]},{"cluster_id":"eafe4828-2ad9-4259-92a7-b6017492bd06","members":["6aa639db-03c0-4b01-9fbc-777e189f69c0"]},{"cluster_id":"ddcbcb82-918f-4d21-a3ab-fc58bc049dc2","members":["2ace17d3-8f02-490e-b49d-2b64f09dd61a"]},{"cluster_id":"667cedb1-d001-4a4c-af7f-98106fe11ae7","members":["92da8ffe-8e6a-4c30-9fd3-a933e0c7944f"]},{"cluster_id":"79d39e26-3c77-4ccb-be20-fd89e10bc54c","members":["2060306d-5f4b-41bb-ada9-748a449d8478"]},{"cluster_id":"e05bca7f-c97e-42b2-a75d-fdded1101b44","members":["bcf1bd89-e271-4922-887f-bb5f7e70e390"]},{"cluster_id":"a330dd7b-988a-4c80-81be-2d4ba1af385f","members":["50f056ee-90f1-422e-a611-e7daa11ac02e"]},{"cluster_id":"4dfd1143-30a8-4e10-a390-f29a1b58e6a8","members":["fc25b3c7-be1c-4b96-84cb-69e99ad4c46d"]},{"cluster_id":"136ce880-e6d8-4791-8b14-3c42846dc7f3","members":["953c492b-c744-4a84-b213-e9b94428c223"]},{"cluster_id":"02ad021c-7d4f-4141-9a02-a5ad1ae95f65","members":["1c00f5d4-6fe1-4dbc-ac7a-45c85eeb3e41"]},{"cluster_id":"afb80000-29ea-4260-b454-0363d71c9855","members":["e3500e27-e888-4724-a6b4-5960e5f31fed"]},{"cluster_id":"0b355c81-92f1-4102-a729-a2af4b606bfe","members":["88fb0996-ffb1-445c-9668-1dcff6819ee4"]},{"cluster_id":"6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10","members":["e1657114-b637-4214-876d-1c44cbd5f35a","bf678fbf-bf14-49a4-907f-4109729b3b0a"]},{"cluster_id":"e886744b-894f-4cf5-9248-234d88f9a4f4","members":["ae33c0c0-db6b-42ae-aa47-975f070d66a6"]},{"cluster_id":"12d9ff77-3eea-4aa4-b8ee-4d436789ff3b","members":["24a40309-8f9f-4bd0-a892-5f2c93b2a71b"]},{"cluster_id":"447c9e43-212c-427e-bbf7-d86cadb216eb","members":["3d4673a3-de27-44d3-a1e5-effb6dc1176d"]},{"cluster_id":"a5b4fdb0-8d5b-49c2-aabd-e64213ff8027","members":["70547dff-f284-427f-879e-9e6023ef461f"]},{"cluster_id":"48f7f24e-52e0-4527-a4e1-e5a83b50fb40","members":["67c55d7f-e71d-4611-97f5-3bdb8dfe8633"]},{"cluster_id":"d0ea565b-64ab-44f3-9679-c2236d37aa42","members":["29ff471a-38cc-4972-b722-d1604d010a06"]},{"cluster_id":"51a5661a-48dd-44af-9a97-7d7620877cc6","members":["bcb0a24f-a79e-48e3-8437-97fbd88492f0"]},{"cluster_id":"03b556ab-fe42-4f7d-954a-c2484c0fac43","members":["dc6827a3-d30d-4619-96df-ff5f48a04539","0a4dd1e7-aba8-40f6-aa1b-b91867f98acd","b2c2ade4-37c2-48da-819b-624b5a9bfd1c"]},{"cluster_id":"205e16cc-f356-4fc1-9b0e-0b31bf6aed12","members":["0a200067-762c-46ac-9ffa-57243ea19fec"]},{"cluster_id":"1997b709-7204-4376-b1e8-77d6b8518a0f","members":["2d80d376-920e-4758-a774-6a5040fc0c0b","c02542da-91d7-4dcd-8711-22502b1933c2"]},{"cluster_id":"1249af1e-88d3-4d61-950a-0799adc2edf0","members":["ef246cff-ebb6-4e72-9c34-5ca9e92ad60a"]},{"cluster_id":"d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871","members":["b9f75f2f-b912-4eb7-a715-2a3476fd4d61","0595b59b-0e70-4c72-ad8e-a4d827e02569"]},{"cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d","members":["2db0b5e8-a206-476c-aa14-7b391e6b99ad","6849375f-6011-4635-b9c4-b17ee24abba1","3a958841-35e3-4334-b6b0-5e888a760ced","ff9a4801-3809-4274-8ff2-b61887727e12","8ffbe2bc-3e02-4c4d-bc44-4f503c12fad3"]},{"cluster_id":"0ac8de8c-821d-4fe2-90f7-e1d30911339a","members":["83a51209-5cc5-4215-b5e9-78fd152529c7","c49fb060-81cd-4e18-802d-4101bbcaf813","fe0ea5fa-1a6c-42cb-8ea0-31fffcfc9bc8"]},{"cluster_id":"b379da86-fb9c-4026-92d2-37b07df028cc","members":["e97875a8-c2b6-4a26-bc2d-30b0ecf2ca4d","da46e9b8-c3ee-4f06-a499-08731c676f75","3f934331-cfc9-4ec1-928b-e20288e4d2c6"]},{"cluster_id":"e2ffc2de-64b8-4d49-9767-c601c711ffbd","members":["122f4e4d-2e37-49c2-9210-c4159692e31f"]},{"cluster_id":"cba27e02-b54c-4ae0-80f7-4a7112a6558e","members":["f49a66da-ca39-46c7-8ccb-816574d6aeee"]},{"cluster_id":"c006df76-d7ed-4672-b415-893f6c8476b6","members":["f932614e-5d4c-4983-a922-4fb00292c1d4"]},{"cluster_id":"f41585b2-89bb-4794-90a0-40b26fb3ec23","members":["735005b5-6c0f-4213-9991-80fff97528e3"]},{"cluster_id":"817f89c1-1d6c-4c1f-968d-c42db0a618b8","members":["56bf2861-efba-4614-9bf8-f103ed3ce2e3"]},{"cluster_id":"5cdd32a6-f13e-42bd-94a1-e86008aa2d86","members":["0b2e1f7a-901a-493e-b33c-49abea435d30"]},{"cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63","members":["8c023135-f2cd-4fdb-aaa0-7cb9bfa05242","88135041-5a6a-4054-b86b-377b5fcc84a6","d2420cfd-d81a-4d8a-9d9c-2dafefab70fa","e9f283cd-f4a6-4739-97f0-60b479c8c50f","d67d3d85-394c-406e-82a3-52cfde1c0d91","f4edccd9-7fcb-463d-8294-2bf292462be6"]},{"cluster_id":"6b567caa-773b-451a-88a5-247b75e87a6c","members":["935ed015-beb2-49c7-b3ce-45b73a49fa97"]},{"cluster_id":"3a1ce373-9bb9-4921-899a-ff8f1e27a082","members":["8a4b0241-342c-4827-8a9e-3613060f8a2e"]},{"cluster_id":"00440887-1b0e-4488-8a0b-2f9b2ba9ede3","members":["f0d69e4c-dea2-4889-ad46-5b748ccfdb27"]},{"cluster_id":"64571139-4782-47d8-abc3-d973ded5245b","members":["22ba4a14-399b-432d-91fb-360385c7bca3"]},{"cluster_id":"6b0c0beb-865e-4025-a8f9-7338b3bfba70","members":["b9ca7673-b522-478a-9560-bdcbb303a813"]},{"cluster_id":"1d3c886f-bc05-43fd-9472-810156e4edfd","members":["abfa0f4e-0a36-46e2-b9b4-97e806ceefe5"]},{"cluster_id":"03fe8498-7679-447a-af5d-563e12790d0c","members":["c2a81773-1b1f-43a1-a01f-72b8ee98337d"]},{"cluster_id":"8df39116-11fd-4c52-8efc-d2dbbee81717","members":["f0f7f5e7-cac1-4f62-bdee-68fbdbcfd4e5"]},{"cluster_id":"f4e22611-4a8c-420d-98fb-79e2c70d616c","members":["d93f6f6c-3364-44b6-bda3-b17afee0e7ff","3cd90d92-1f2f-4bb7-bf4a-32e93f89acf3"]},{"cluster_id":"aee47b3f-809d-45eb-9cd7-269dd2b5fc95","members":["b338c65b-f306-44ea-b0b0-dd2cf6411423"]},{"cluster_id":"903c3f33-319a-4f0f-a3a0-b3ad86d56e86","members":["4cbc186a-b813-456f-bb6a-e010b138c2ca","9087f738-7475-44fa-85d8-57cc7e9ae9a4"]},{"cluster_id":"b900a5fd-9f6d-409a-b2f1-c21b24addff1","members":["6e955dd5-abae-45ae-b58c-2a25b9bdeacb"]},{"cluster_id":"1bb75de7-fa9e-48e1-9651-ee91dc1ce93e","members":["71af64b6-cc21-4c97-b9df-d1f091361b50"]},{"cluster_id":"71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2","members":["bec49b2d-abe0-4438-97ae-8114b1d576d6","495f48f0-a384-449d-89c3-48a288420008"]},{"cluster_id":"3595c0cd-b164-431e-b192-61bc7dc0019f","members":["dbb0569a-302d-4f5c-b3cf-3a621d6d4b2f","b9d88390-2a0f-45c9-821c-da2a75aaf2d8","953d0f4e-de91-4c9a-857c-d602fd9feb09"]},{"cluster_id":"cb033bf6-f8da-46c0-a5e0-962c48c82ad6","members":["4dc240ff-2439-42ae-9041-8ee9ee997a0f","9ed66cda-429d-4b92-8a4c-8184ff773926"]},{"cluster_id":"47f7a131-6ce1-4e01-b64c-61e5f9696bb1","members":["4dd8251d-5251-4520-8558-720daed2ff0c","c06a7150-78ed-40ae-aac7-81b9f53c150f","9207c4cc-83d3-4107-8881-63caee372452"]},{"cluster_id":"0d989645-1d74-46cc-b203-0ae7bc83c732","members":["384dfcd4-e781-4db3-90f5-e95202c64b81"]},{"cluster_id":"aa5a0292-80cc-40db-8f50-3b92fa1db057","members":["3085bd89-d3bb-4c87-a766-de3c40938e9f"]},{"cluster_id":"71b3e9c3-5afb-45c8-a204-1d5b44e3a33a","members":["ae04d801-546a-4bb5-890c-ef37544c9aee"]},{"cluster_id":"32e97d8a-5e17-495f-9681-46a69fce7584","members":["7d776a28-7b36-4b50-9d79-600c7c814f14"]},{"cluster_id":"87ba8d5e-85d4-4d3c-8d48-82520a97a137","members":["0dea2bad-4966-43e5-9b98-11201c1df71d","eea34e2f-2775-4904-93fe-62aaaaabe850"]},{"cluster_id":"ff6b17a5-2973-4397-8f78-b44bc6fa5365","members":["4b8c7205-ffdb-4751-b92c-67b4ce7f2008"]},{"cluster_id":"f6201dc9-cd2a-485c-86d4-622332646365","members":["b0eb15c0-c4de-4a46-addd-03f1a89f3421","29a35ac1-ec35-49be-b7b3-426e424bdfa5"]},{"cluster_id":"001b82c1-e0c7-4fe5-8e7f-c84ae10048f6","members":["4f129350-7db8-4427-9b00-04dce5d486ea"]},{"cluster_id":"c6da85ba-cb8c-4e07-b313-69be94d682d5","members":["ec1376a1-9b3c-404c-8cd8-9f9902afcb67"]},{"cluster_id":"11d8d71a-168c-43ed-b532-83903fcd58a8","members":["d4dc283f-b1c3-459a-bfec-67d2ecc4af27"]},{"cluster_id":"9830a54f-6df4-4c84-a14f-819c289e70e5","members":["7ebce2cb-ebc2-4687-af49-e93e9583f48c"]},{"cluster_id":"3d676a5b-4d23-4b21-beb6-27ce056b17ec","members":["2a613509-27f3-4c6a-8d5a-53cba97112f0"]},{"cluster_id":"902b6a60-6994-4d2f-a5c9-4b6398d8e8c1","members":["c7818cf5-a11a-46a6-89ad-10c0a908a17c"]},{"cluster_id":"2f3684a3-db51-45d5-8ab6-a0d061f2a667","members":["f7f20864-e23f-4165-ab6e-b8e2e6f7132a","c91195b0-2dd3-4cc4-bdd0-48f3f2bdbdb4"]},{"cluster_id":"7aadf7ec-8a12-4805-bf87-51d4575c022f","members":["cf3a8103-e2e8-492a-9f1f-a7dd04cc356c"]},{"cluster_id":"4e1dd449-7872-4183-a210-7ea0e51bbd11","members":["f1cd3541-52d1-4c2b-b35f-d77cdbb63f03"]},{"cluster_id":"b9f9ee97-4a90-4a60-a376-32010848d648","members":["e21d969f-a42d-4c4b-8725-212fe1e8088d"]},{"cluster_id":"2dba71a0-6409-4877-bd44-bf97b9328d5f","members":["64e42c4d-df6b-4b15-b5dc-f14f3b4fc034"]},{"cluster_id":"2929fcf7-736c-4b1c-b178-3fc95f1bce0c","members":["41f6a186-93a6-4690-83c2-2d9877871901"]},{"cluster_id":"d64f3c9d-c55d-4ebc-9a01-43d63af153f0","members":["51cbcb31-0b5c-4bd7-ae82-dc02ba6017bc"]},{"cluster_id":"6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0","members":["9b854e37-9c9e-4f39-a6a5-816a922b9cbb"]},{"cluster_id":"567b1fae-2c0d-4bd2-91bd-d03218bbd8d0","members":["2401f7d5-d48e-4e43-9dc9-08014ecfb9ef"]},{"cluster_id":"f74167b8-6b2e-4397-aea5-ad26ae737cc7","members":["fbe9998c-0872-4191-9671-4703a96531fc"]},{"cluster_id":"4970bf10-4486-48dd-9be4-75b2fb5e659e","members":["7489dbad-ad68-456a-a7f1-aad2fd62f893"]},{"cluster_id":"8181e898-2713-41af-b776-395891458be2","members":["63985ce7-5217-4874-aa7e-24ca4ef61575"]},{"cluster_id":"47e32d49-9365-4f05-bb52-852578030b2f","members":["e5390f9e-da3a-4148-80de-bf8344b833d4"]},{"cluster_id":"fb3f730b-85cb-44b0-976b-06ca14bb8acb","members":["b0d99ec5-93b7-4482-8ede-56df90294fbd"]},{"cluster_id":"cdf07443-9a3e-4b94-a668-1930f3a66029","members":["3d45140a-ed02-4989-9a2c-1c430911137a"]},{"cluster_id":"63e3781f-5042-452b-a77e-11f62bb59587","members":["b4598419-3888-470c-af66-54e429df15bf","48abfe8f-9f46-4310-9097-df2faacdef21","5bec55e8-6809-46ea-85ad-3c7b4426a4a2","9697d1ed-6eb3-4678-ba13-e0e4ce60c850"]},{"cluster_id":"f7d6db0d-ad7a-49ba-bfea-afddcfaa06ba","members":["ddbca3ee-3ce3-4f10-a6be-56733bb2151e"]},{"cluster_id":"1bb3c826-37ca-4435-8ad2-e211e6cd9444","members":["e4e829f8-e504-4cee-b1aa-f2baf9a93288"]},{"cluster_id":"bc618add-d50a-4d41-b375-e0f4e3b7232b","members":["4376bf3f-5cf3-40a8-8f0c-41c20cad6dc5","bd58c05f-b93f-4af8-bdad-fc72957680f4"]},{"cluster_id":"37b0238b-c658-4977-a22b-36f3d3dc6e36","members":["88769019-7241-46e9-89a4-31caadd73597"]},{"cluster_id":"7e615b29-206f-45ec-8b7c-74785c5252c8","members":["f572f129-d8bb-4d0f-9092-aa36d5fd0212"]},{"cluster_id":"1285d3bf-ce3b-4c4d-b6ee-39e378371b65","members":["1baeb73c-ac77-4cb4-8916-b2601cef55ba"]},{"cluster_id":"593dac82-590e-4efe-97bb-2666521b40b5","members":["0646c5a9-5c8f-49eb-9cdc-2558df2f7305"]},{"cluster_id":"7b391ffb-dc10-4ded-babc-680617024509","members":["1c591bd1-dbaa-4054-972f-d74e7ab91f32"]},{"cluster_id":"575fb3af-a2e1-40b5-8235-6bc79d73e849","members":["aded59d1-81bb-4062-88ec-1b2e1e7280a1"]},{"cluster_id":"8dc116ab-03c9-451e-bd40-127719cd94fb","members":["49c572cb-93f0-43ca-967a-98c59897f32d","7ee60054-be86-47e7-8f19-418ebd357da1"]},{"cluster_id":"7efa0178-d8ab-468b-a654-e8cca19d755a","members":["f22893c8-3eff-4926-a412-e01a874ff8ee"]},{"cluster_id":"e2e4a182-34d1-44dd-bd17-91104b15baa4","members":["62fbb347-74d8-4b62-b3a1-4365c6c770ad"]},{"cluster_id":"75279036-9309-48c1-9fcd-8d4eebf44481","members":["02047144-2738-4eae-997b-c9787c165309"]},{"cluster_id":"91bba9c4-4aa2-47af-b118-a7d49761b237","members":["2ca134f3-5109-4df4-a29d-3cdda4a037a5"]},{"cluster_id":"2ebae150-b502-48c5-b8c2-6a7238a86864","members":["352c1b61-38ec-42ec-962a-8f2fda4f862f"]},{"cluster_id":"1396142d-5fd2-4c3f-8a9f-e0d1627fb926","members":["cfbfad32-bf43-45f1-82f7-50acd200b119","0cffc2cc-b1b1-4d89-9f69-ca6b18367663","9c2b371f-388f-47ee-b206-3e82809389d5"]},{"cluster_id":"a3b6f394-159b-439a-a766-38bc59e64bb8","members":["2d5fa91c-6d11-4f83-a35b-5bad53ec7012"]},{"cluster_id":"53dbd851-31b8-4afd-8a69-b5ebc32a8f7b","members":["11d456c9-0719-478d-aca3-53788064de86"]},{"cluster_id":"335df50f-3c96-4c54-9d41-b51376489798","members":["21cdf176-577c-473e-a896-32788b43445c"]},{"cluster_id":"f0449899-c6ef-4a85-b5c8-5f78e0da96c1","members":["634f6a08-dbbe-4adc-b386-e4e4cabfe4ec"]},{"cluster_id":"042df2bc-4559-4f30-9abb-b285376932e3","members":["77e453a4-b968-43ee-ba2f-2f8f4f402e47"]},{"cluster_id":"3ef2d7ad-744b-4957-b2f1-17396d9e9cba","members":["86962d4c-646b-4814-bed6-c43ad623d9f6"]},{"cluster_id":"104fb09e-1224-46b2-885e-348a5c279186","members":["7777291f-bd26-463c-aceb-ef76ba3549fe"]},{"cluster_id":"4b50f48f-0dd4-4d51-a40b-e932902a32fc","members":["c0f58f86-2857-4261-aff7-9ae691852fce","0e74f67b-3e61-4007-b6be-80bd0aac365c"]},{"cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c","members":["5036018a-13f3-41b2-8d57-c2b8539ee8a8","0acf27d2-2674-482f-90c5-bde37a973fb6","05ea2b41-7f2c-4b98-9986-f0043518081a","167e4a22-6387-4899-9281-5bd108afc174","d4755858-bd8c-4c93-9c06-e217f923e761","50e0fbe0-6c0d-4be2-b076-f81b92f1837c","1dd490f9-ca8a-40a7-bd5d-e3272082f00b"]},{"cluster_id":"28b9ee99-8c41-4de6-b5e4-1d006511f119","members":["4352707d-d0be-4b31-a45d-0a646b63f2aa"]},{"cluster_id":"4e67b541-7502-4017-a45d-06f9dbc9f516","members":["7bc32684-567d-4629-8d1a-f8d2316ff03f"]},{"cluster_id":"b5dff88c-bd24-425a-aabb-6f3428e4297a","members":["7b8cb1db-e06f-46ea-9024-40ba0b35f6ba"]},{"cluster_id":"05edffd4-72ed-4cb5-ac3b-f631f2c3d46a","members":["142ed585-ebe1-4eaa-a149-9415efcd90f6"]},{"cluster_id":"61d1a73d-bcca-4e5e-a4fb-5d21b8a13b97","members":["7dc05c9d-0db8-4449-baee-f75aa2104f1d"]},{"cluster_id":"5c72c86b-5dfd-4f55-ab98-8ad01ed266f5","members":["0f6cce71-8ea2-4fd8-984d-daac4761d8d1","109456e7-36bb-4930-9d93-ea01d1f2c8af"]},{"cluster_id":"59b16d26-5dcb-404b-8589-2b9a2089c70d","members":["201ff659-56bf-4fad-8c16-6c89a915998b","9e897f33-59ed-4230-895d-0ade8df6be15","851308e8-afce-4654-97d3-ad29ed078b8c","8b3d734d-3752-4511-8163-4338dd74beb2"]},{"cluster_id":"79350a97-33bb-4081-9a5c-bebaa0641f2a","members":["b8d1de50-bd34-4c0f-8aee-fed5d630ee6f"]},{"cluster_id":"22e5ae9e-51e6-4da6-a862-0555cb893e6a","members":["02a296f9-7cb5-40c4-8127-126855d90c32"]},{"cluster_id":"8b8269a1-ffad-456b-b974-307474aac288","members":["1bd6ec24-448e-4a14-8f18-82099dd796ff"]},{"cluster_id":"a899a63e-c3d0-425f-8700-82abc0fa345a","members":["2194d3c4-cf89-4d0e-ae1e-827648bcbe1c"]},{"cluster_id":"2e33e564-22f6-46fe-85d8-8500ce2d3380","members":["18ddd34a-9fa0-4725-90cb-2d8e26369028"]},{"cluster_id":"5df7d808-68d6-445c-b39d-37aecaaa35ed","members":["6e9d08e7-e9f8-40c8-9f92-dc69836d6373"]},{"cluster_id":"87e69472-d284-42bf-9dfe-9535bde32efa","members":["fdddd839-4566-469f-9d0c-0f675b3b4917"]},{"cluster_id":"8d692cd5-28be-4ffe-a181-b8bc827723ec","members":["c2821d80-7208-495d-847c-7f11fb7194a5"]},{"cluster_id":"f15d86b1-5ec6-42af-abb5-8a53b43a9bab","members":["50b2f529-578d-47e2-9c73-e314c368fe32"]},{"cluster_id":"a7318687-bec9-447f-89a2-3a9e7981d92c","members":["f00928b3-8beb-49ff-a99b-33ba4c9c14f9"]},{"cluster_id":"18ed12f0-a6ed-4c61-bb56-179e38c03061","members":["3a67b905-6bc5-4a63-a38a-674a9505a860"]},{"cluster_id":"073edba6-a930-4e69-b786-5decd28e9957","members":["f127102b-7adb-4e68-a451-2425dbba1859"]},{"cluster_id":"49650712-227c-465d-93ab-16c3e2405aae","members":["fe2508ca-6116-4a3d-9737-4aa7db42765e"]},{"cluster_id":"b36258d9-8de3-4cee-b76a-8d1ee69dd79c","members":["1b015b0e-a03c-4937-9823-1bacacf9829b"]},{"cluster_id":"bb3ba302-b163-46a5-9a24-14ade245b1de","members":["4b04968a-40d3-40cb-8c8c-0b5c8f8f8725"]},{"cluster_id":"1630f0d6-45b5-4a9c-9208-8292e05b3a85","members":["863f8eb6-77ed-4cef-a8fd-1980608e3e64"]},{"cluster_id":"eb0ee0ba-913e-410b-b9c2-5aa8871f3d24","members":["710fc521-cb74-480a-9af7-4ec589ecdc6d"]},{"cluster_id":"d862e5c2-98e9-4ead-8a8e-98d31f78f4f8","members":["eeefd7e6-0935-4089-a906-74c5a26488f5"]},{"cluster_id":"2e1f7f19-b115-4df8-ab1f-76f94814091c","members":["b1b2ebea-a5ff-4862-8b01-03ef9d085242"]},{"cluster_id":"bf840015-2be2-4173-ba65-4d1448510aee","members":["f1d018c9-5f57-468e-a553-f54406863636"]},{"cluster_id":"fc762eee-b8ab-4b1f-86f1-0e64c2a63eae","members":["b8abbef3-c963-4eaf-839c-91e40f2a474e"]},{"cluster_id":"c7824331-8340-4b01-8402-1e8e570e3b30","members":["6cc5144d-233a-4d4f-9640-ad6d90f72bf5","63723f47-361c-4376-807a-db90f7e6a177"]},{"cluster_id":"757b69bc-6342-44ee-8a8e-c35de9054b6d","members":["a4e248bb-f94a-4156-905d-17848d31e342"]},{"cluster_id":"33028b3d-3070-4c94-af90-91fb62e4dd68","members":["85681712-7d60-4155-8edf-867cd1052f0c"]},{"cluster_id":"f6f6ac6a-d140-47fb-94ad-797d11509e6a","members":["3b6b889a-8e36-4d97-a4a7-771df6caa01e"]},{"cluster_id":"6b05928d-06c6-4035-8854-c47627756aaf","members":["404a1fc2-b7e5-42ec-9a0d-c3fbed70fd5a"]},{"cluster_id":"5ccfc9e2-21fe-49eb-816b-e5684332d360","members":["0b0c9c20-af04-44ba-8190-bf7deeebc033"]},{"cluster_id":"01800770-341b-42d0-83d8-a7e215d97f98","members":["75e9d959-28f3-4ac3-b543-a46afb1c8735"]},{"cluster_id":"a83610f0-30d5-4dda-896a-6faaf1c01536","members":["75a831c9-64bc-48da-b175-a2437e47dd83"]},{"cluster_id":"ed59d768-edd7-48c0-ac20-df8f0d6dc5d8","members":["97350da0-d1db-4b53-a3fc-ef06b13b945c"]},{"cluster_id":"d3a2d90d-13dc-4075-9660-3952f836b150","members":["2950345a-e866-4de3-92f1-2cb1e4c25f8f"]},{"cluster_id":"bc347754-e0eb-40ff-81ea-81da10f629ed","members":["7db6c8a6-60bc-4662-b2dc-199aa561b87e"]},{"cluster_id":"d8bdc753-fad4-4cd8-b9f2-efb5708d6629","members":["ea7a2b72-7d1f-4c73-a073-a7b027631757"]},{"cluster_id":"e4e28c57-a8cc-4df1-b26c-23b630ca06ac","members":["201f7365-3e62-47f1-9210-042b45108003"]},{"cluster_id":"726b06eb-9cb3-44bc-9105-8eb731155948","members":["b7b32401-5690-41a0-af65-8ece78fd91fe"]},{"cluster_id":"ad92d574-8bb8-4072-be84-8313fb209fd6","members":["c8de3f3a-96b2-48a0-bace-ff2c0f38239c"]},{"cluster_id":"4c3966c5-0cc9-4924-906d-113f0618534f","members":["157e34be-f855-4ce9-bf07-9c26d1427230"]},{"cluster_id":"b4dd0b00-f893-486e-8f26-56d055b47620","members":["a5d1d62e-20f0-40cd-9604-245b0e5f8830"]},{"cluster_id":"99212234-66c3-470f-9dda-4b5f137ff502","members":["61eb6e4e-8226-4649-a28c-6a1d5143a326"]},{"cluster_id":"bfbf1707-08cb-4022-8bc5-78477fc5de4e","members":["6ee233fb-18ce-46c2-9236-b4b2ba49b6e8"]},{"cluster_id":"c2c95c94-edcb-470f-82d7-17f1cc69860f","members":["f9972a21-0ed8-4c53-8835-ca063429c525"]},{"cluster_id":"91c23991-d38e-40c8-af05-0cbccbeaf641","members":["3254bd8f-d52e-4eb5-9cac-a67f2dc656e4"]},{"cluster_id":"1e2063e0-1979-4024-9493-206d34c55c1f","members":["e1e86014-5779-43c2-a83e-e8910c811c28"]},{"cluster_id":"3b28fd20-f6ec-4932-9943-984312470724","members":["e5f9b0d6-7e73-4a08-aa88-88ca82ea4f7a"]},{"cluster_id":"1b2a4f9c-8284-4418-843c-06b19834c251","members":["c265307b-a45e-40d2-942e-064e09203a3b"]},{"cluster_id":"1bb1e966-aeca-49bb-87b9-768c9cbb3254","members":["80874662-775d-4097-ab12-519fd35a8af0"]},{"cluster_id":"a685f849-800e-4402-90fe-e957d6fe91e6","members":["b6debf5b-3fd9-4758-8d65-ddcfa76159c1"]},{"cluster_id":"6e45b980-570a-489b-b31b-a504f6b1257e","members":["de7db6fd-2ae6-4f7a-b2d2-140c467a7909"]},{"cluster_id":"f55d5834-9821-4e96-8403-e81fdf294300","members":["3737c0e5-0ce0-43f5-85a5-06097bb825b7"]},{"cluster_id":"4a20b107-b497-42c8-8807-874212cad7e3","members":["041efd3d-3637-4fdb-883e-7e7a15720adb","c0954b16-8dca-44c9-9bc8-66debbd14700","c444c044-c221-4210-b7fa-34b86f049f7d"]},{"cluster_id":"59fed447-7963-4349-9213-761a767fe70e","members":["e0fadef7-8cb0-400b-87ba-015ee4371568"]},{"cluster_id":"27a6e31f-9188-49c5-afc9-f45a074457ba","members":["2f08b13a-ecf0-4799-a14d-58bf972dd8ec"]},{"cluster_id":"13e00f68-1db0-4207-bb35-e56787801241","members":["7e44b6c6-7d56-4232-819d-53ec3fa86eca"]},{"cluster_id":"81bcd47f-070e-4939-b97e-e26a5423d8a9","members":["e044f66e-1051-432c-9447-d98bcbe37e2d"]},{"cluster_id":"5a080de2-e14b-428a-ad25-1b9fd1bb59d4","members":["806cfcc9-2fa9-44ee-85fa-be86fd0c140b"]},{"cluster_id":"36b001d3-8cd6-4b58-93ae-5ad737efa236","members":["3d0c34ba-5eed-4155-8048-07dea2acc752"]},{"cluster_id":"af8cdf46-4050-4634-a0b0-6bc6cfa78956","members":["58bcf34f-8ba3-4b84-a26f-99d50d09da47","0432a5dc-9139-4f9e-8346-33d3633cf2f2","5a9df2c6-1051-481f-8995-20bb7f272aa9"]},{"cluster_id":"d81a0c92-8b3c-4dd5-8534-db608b237cf8","members":["595f845c-20e2-4266-9c19-52b6519191bf"]},{"cluster_id":"1ff86b5f-b9df-4809-8840-440abb97575d","members":["a3dbd081-e0b4-447f-a34f-0188df7b1cfd"]},{"cluster_id":"abca71f2-b0b7-497b-b1ed-9f04c6ea4023","members":["2a7b8375-e2a4-40b6-8703-a6867c26ee76","4eacb1da-29c5-4742-acfc-7218c4550e65","f546c638-ba96-4832-b699-e89ff607a5a5"]},{"cluster_id":"fa13d89b-1dff-4027-a91c-143971ebb4aa","members":["5ad531ab-4764-4ef7-baba-70398900776e"]},{"cluster_id":"503eed9f-ea34-45f7-b3eb-f015bdc664b3","members":["20591f9f-e0ef-4998-90e0-cea448297dde"]},{"cluster_id":"cbddcfe6-4088-4603-8e7a-ed109a9fff44","members":["108e779d-9db3-4fd0-9788-b9157c4ab56e"]},{"cluster_id":"128d37ad-2ce5-409d-8ce0-e9df31085f42","members":["1e36d9a5-24c2-4358-9d06-5f639bbe88fb"]},{"cluster_id":"9dd9bb3f-346d-4bab-978a-64ea761a815a","members":["aa40d2ac-2714-4625-babf-90088c7be49f"]},{"cluster_id":"037c02f8-bec2-4837-9533-93f63490c709","members":["87097f69-f45d-4265-af3b-f1353bd44cc8"]},{"cluster_id":"05fe6713-720d-475f-867a-c6de011c5f20","members":["dddd9c26-ce0a-4e7e-a0e6-93e55f2f4446"]},{"cluster_id":"21751149-a038-4fe4-a432-932902e5041b","members":["0e7c3843-8c18-486d-87e7-d205bfd1bddf"]},{"cluster_id":"b929e356-d8ff-49f7-a4f5-c02953cef416","members":["3d446a56-a3cf-4d57-befe-1d011f977087"]},{"cluster_id":"33b55b1e-2a6f-4f56-affb-50cf2ec05471","members":["895c4b1a-bfdd-43b5-88e8-3f03cee20224","45c89f5e-2f92-41fc-9e61-9a7bdd31acef","cb9a225b-b8d9-4863-bded-41002e213aae"]},{"cluster_id":"4a931ec3-ec4b-489a-8ad6-020f2eb48663","members":["1f31387f-602f-4406-b683-3349a0445c7a"]},{"cluster_id":"96c05405-04cf-48e3-824b-2a96332d38b7","members":["bb15e0f0-16db-4581-a33d-49bdce475328"]},{"cluster_id":"94b0a214-1e60-4bbb-96cf-031169c35247","members":["f73ccc40-9526-460c-ad2f-f60fad7ce28b","c2d2c458-bce0-4b94-b0e3-fd1544161903","7a0c3805-7034-4d3f-93c1-658b2953d611"]},{"cluster_id":"32ea90b6-1f69-462e-a6fa-1e6c1978de12","members":["f2e1273d-63f8-445e-a431-b0e75cdf5564"]},{"cluster_id":"e9f22744-079e-483e-97a4-7cefb12988e9","members":["485eb0cd-4bd1-4c5b-a0bc-f24751f1688c"]},{"cluster_id":"8bda5e73-cd1a-4ebf-b3bb-55b54ec157d7","members":["ee6b2298-47b7-4481-8fe6-951504b15004"]},{"cluster_id":"0040fc97-03df-421f-96ac-2c09e7b8a54f","members":["1ce1328d-6ce2-489f-b6b2-35da0faba554"]},{"cluster_id":"297764bc-d5fd-4054-ab93-cb0530d2df4e","members":["f73fdbd4-3902-4798-a160-be278afda5fe"]},{"cluster_id":"afa23bc4-1fbb-45ef-b64c-09dde901c8b3","members":["8126a34c-5ee8-475b-8526-f4d565d7db8f","cf62689b-6516-4810-8e42-520e8a51af3e"]},{"cluster_id":"65c273a5-7b4a-439b-abf8-ac2e7eea9f97","members":["ab43d039-96d0-4d64-8845-a0f23f6afccd"]},{"cluster_id":"22388e5b-3cdc-4eb4-8e97-052ccfe18cfd","members":["d0ad0b02-60ab-4619-a430-6da20b6c1436"]},{"cluster_id":"dd4b1ab9-a797-483e-b837-bc9140aab68d","members":["c7cdea89-036d-4bcf-85df-916f09f07798"]},{"cluster_id":"b9c0c358-d5e1-4c6e-9602-a307115394e0","members":["5487ccd1-6b00-4e12-8e12-04bad8b9c440"]},{"cluster_id":"a1ea18ac-be18-41e4-86ed-51a5a227e8ba","members":["ecc020ce-fecb-452a-af8c-ad9709949f72"]},{"cluster_id":"9c21e744-a69f-4d9f-abbc-ec67be5c4220","members":["f63b0a7e-2f78-4a73-829e-07523b9f1f51"]},{"cluster_id":"34a1784c-8849-4447-8724-747b9b1cd1bd","members":["f2bf68ae-a55c-4529-8841-e51b1e49ccfd"]},{"cluster_id":"4005f43b-5b4a-44f8-9781-c0a91127368f","members":["6a04f59f-82ff-415c-8bec-2ed8a8f679e8","661f3ede-e539-43ba-97be-c3c6c34b20d1","755c3d09-13eb-488d-aafe-355aee37e54a","49090a4a-0445-4ea4-a0cd-c4c893b6b2a4"]},{"cluster_id":"ac2c361f-32c9-4d71-8c96-6c8953a04d75","members":["1aaa012c-a242-4929-96eb-70b19589f395"]},{"cluster_id":"d03251b2-2516-4731-9dc4-6cb10da8a70a","members":["85fb84b0-0122-40e9-b27c-d5a75ab417c4"]},{"cluster_id":"6c1c53f7-282d-4c0c-a8d8-dac0c8af5a96","members":["c807536c-627d-4ea7-a757-b1fc516650c4"]},{"cluster_id":"7354cd90-5ded-45c2-af70-b5cea1cc0045","members":["fdfe3472-c5ba-49de-8042-03f87d3b22f2"]},{"cluster_id":"f78012d1-f500-46ba-802c-d3d1337f7f51","members":["bfa887a6-b322-4da1-a76b-7b5b3f653cc4"]},{"cluster_id":"f16aab95-d35f-4386-9ea4-6a5f797bcf7f","members":["c0bc1a44-9b42-4cf0-aab0-ae80b02a03c6","d33b5e59-6951-4a55-90d5-de0ad14275bd"]},{"cluster_id":"c786e602-255f-4df8-a9fc-775fc1322fa2","members":["6b35feeb-649a-4826-af85-82f8a6706455"]},{"cluster_id":"9db91412-4257-4b55-b7af-99ea85b2a619","members":["f40486a0-ea1d-4cfb-a807-029ece0cb041"]},{"cluster_id":"bdbb752b-6e19-40a1-b874-d58f3b375de7","members":["d179af4f-4114-4e08-96db-ce490af45be1"]},{"cluster_id":"f0ad65d9-233e-4737-b565-7bb483317155","members":["be52d413-c060-46df-ae49-6f8e865d0ae2"]},{"cluster_id":"cb759cf9-83bb-41f1-8a60-65bf2476c5fa","members":["b82e31c4-552a-444b-a496-ff8aa9a48878"]},{"cluster_id":"429b9019-55ed-4d53-b962-21e416686d27","members":["2318fe24-10d8-4966-a4b3-8bc37a734c13"]},{"cluster_id":"d9598814-d7a3-48d1-b282-0aa4d0dfeb8b","members":["e02ac3bc-7a18-4bfb-9c46-d2b7239b6583","9173eff4-97ad-4bb5-8e6b-14709e083d90"]},{"cluster_id":"6b0217e7-2354-4152-81ca-d64e5b080b90","members":["0d4aa265-11b9-4915-b054-93ec17930f3a"]},{"cluster_id":"63be6506-f9dd-4d4c-86f5-e451710401ef","members":["956e3474-5618-4c81-9e49-a51567c16fcf"]},{"cluster_id":"6234ba01-768a-474f-80de-4d8b6df78d63","members":["a0f28cd3-c641-4002-8200-92f884c4cf8e"]},{"cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb","members":["5d23ebd4-1e86-43e3-81c7-16ad606a11d8","042d73a9-eff0-48d9-87f1-42da99cdea5f","4616c099-332d-48b0-be2a-147071ab69a7","f75b18ce-ace3-4943-b15a-a61a8af1f693","258a754a-0776-4907-951c-96c7047a7dc0","b573fb16-d274-420d-b3dd-b10e9a2e04a0","39dd2991-e610-4df5-afbd-5799d0b4365b","93b9d616-36b6-407b-ad9e-1fb9962ff572","b43b7493-d28e-474e-92b1-627bc2df5911","6516a31b-abc5-4f9b-aa9b-e52da0bd84d4","20da7166-f5ce-4d8c-83f1-29c7e9cb057c","e9ce639b-b0f7-4d33-b373-cac3937c6b6d","358b2051-a2c0-4f07-a722-49419301d4ac"]},{"cluster_id":"3b02e47c-e307-44b8-85bc-a7863107a268","members":["18bd5197-ea18-4065-a9e0-567e3b1c277d","06d01bdf-9277-442b-b673-b5c5a365b0ce"]},{"cluster_id":"24866e6f-4fd0-49f1-b25e-9d7dc5227353","members":["f726ffc2-3647-400d-80a6-f52985797422"]},{"cluster_id":"a0e15f6d-9d91-458c-9257-5c60799b9290","members":["68dd5299-7fd4-430f-8b60-388906a72882"]},{"cluster_id":"3923fc76-d76d-4386-926c-4e8e39862387","members":["67b03e9b-943d-4bbc-a124-9c5578ef7ef2"]},{"cluster_id":"37f90fa7-4e1a-46b6-b513-6bfba31c2cf2","members":["93f6b1a4-8c3f-4a06-9824-0ba2df7d17d9"]},{"cluster_id":"c5882250-4bcf-4c65-93ec-7937e1c0803f","members":["13d2edcb-24dc-4bec-bcab-c09b3c14e8f8"]},{"cluster_id":"a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e","members":["7dff7322-4805-4518-8f58-584aac64f379","71137349-c545-4726-a3fb-95eb051d846d"]},{"cluster_id":"2fed86e0-073b-4885-a91c-3e9ba6cceef8","members":["6c94502c-3a79-4e01-b9d8-632621273814"]},{"cluster_id":"8914f459-9cc2-4812-af44-1d97ee5106e3","members":["ef73f4bd-2cd1-4b72-9c3c-c2591a929a40"]},{"cluster_id":"8e7cadbd-1c4e-497d-b941-1d05a2c467a3","members":["6776a7d5-beaf-4c41-aa38-300a0801b709"]},{"cluster_id":"1b8d5ce9-1627-406b-ad77-075419ad3508","members":["d8891a94-9140-46bb-bcdb-3d29d91975f5"]},{"cluster_id":"10a3db6f-9669-4c8a-9480-85cb3dd1626c","members":["bcbce5e1-e6dd-4fb3-b640-98dccec00c92"]},{"cluster_id":"e19196d4-b7bf-49e0-b42c-244f5f90725b","members":["46a1a4b3-5947-4f7a-937a-1787f32e8bcb","79699b3e-4c16-4dea-9c40-aab3eaaabdd7"]},{"cluster_id":"52204f25-791c-4bc8-9a84-ab506bb1cad1","members":["f2f46d22-9183-4d22-a258-f7deec1e4667"]},{"cluster_id":"a6d23154-5d6d-475a-a318-8f3c90f26a02","members":["eee7a4d9-8e2d-47ee-8999-987c6555cb58"]},{"cluster_id":"8017a44f-3587-48ad-93bb-373a715846dc","members":["11e6af92-7c17-44a8-9ab1-609463443a49","e40c33f9-d7fa-4137-9f80-4c8229c27471"]},{"cluster_id":"e21a96d2-b5b0-4a69-80bb-66020b0b8a54","members":["f4b9f0d4-2a14-40af-9ab6-151433206f04","3ac87666-f63a-4e9c-812c-b18af694a7c0"]},{"cluster_id":"efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc","members":["dfc78b17-77bb-4229-957b-d80d3ad115c8"]},{"cluster_id":"d47fde78-a16e-43e2-a490-d66e81b31f7c","members":["67774ca3-9e92-4d08-8579-3aaf1352ddf2"]},{"cluster_id":"97b1177e-80bf-4e09-83e5-b50aecee0b52","members":["53c56e4f-f7aa-498b-a6a2-d571622c455c"]},{"cluster_id":"10698f29-8fe6-47a6-b30e-e5ff5dcfea6b","members":["c563fc88-dbde-45c0-91ec-aa24573796f5"]},{"cluster_id":"b8d20c5e-c322-4b49-99bf-b717fffef7d5","members":["cff7a05d-3faf-4626-9e30-2425b37b803b","da87ff37-ca2b-47c1-831b-8b46e125edb8"]},{"cluster_id":"98e6d6ef-a2d4-4de1-80f2-7297b807d073","members":["12f512c6-9447-45bf-84b7-c471a724c050"]},{"cluster_id":"fc6510d9-839e-4451-a099-a28338b3f8c9","members":["72464dda-73dc-42a3-bd28-c42b8e02f4f9"]},{"cluster_id":"770085f4-c156-40e9-85de-d0bb720ad51c","members":["3c5df01c-39f1-48ad-b488-cc651a5bee87"]},{"cluster_id":"d2fe7e4c-e188-41bf-8d04-054692838ea8","members":["55149787-986d-45e4-b225-54181d7d8cf7"]},{"cluster_id":"cfbc5753-ac66-4d7e-b3ad-5e7f58c3e6df","members":["6d127b3c-a603-4734-96e1-89cef5a4128a"]},{"cluster_id":"80e1112c-9669-4621-a0a1-38f35b5f11c3","members":["93d5589d-ec1b-403e-b7b7-ca6f4146db7d"]},{"cluster_id":"49b4c78b-ed4a-40e7-bdfc-7463c3169502","members":["eaf5b6ba-8898-4839-b6a9-fc7cdd78ce02"]},{"cluster_id":"895f4da6-0e6e-4170-be66-262513dfdc91","members":["0534dd3a-1108-4c6c-8042-56dd3e0e1de4"]},{"cluster_id":"cb44bed2-b70b-436a-82dd-d405face631c","members":["2c70aa6c-a47a-4ec6-9c2f-3780e8077140"]},{"cluster_id":"7462b6fe-d6f4-4e65-ac8e-8fa4c8e00ce3","members":["4d27344b-c507-440a-ae52-1d0a68fdf680"]},{"cluster_id":"ed28ca5b-2948-4f9e-a9bc-a57f2f3f7cbd","members":["b148b335-5477-4655-b6a6-2f5cfaac025f"]},{"cluster_id":"eaaf5d8a-fedf-4978-9ba0-14aae1ce95e7","members":["8cdda31c-9b71-4441-865a-81116c144f4c"]},{"cluster_id":"a8acca84-268a-4542-96c5-6e8d1fb747ac","members":["58adc6a2-015b-4cf4-929a-9090cc1d2ce7"]},{"cluster_id":"c021fe18-c42c-443c-8de9-a7f8d58891f4","members":["c0961ef4-9fc4-4628-a2ba-f575365a0926"]},{"cluster_id":"2d8a2b96-5e68-43e2-a162-f66eeb390e13","members":["8a1af2e7-35aa-4ae4-a3a9-dba8d0e29550"]},{"cluster_id":"b74d0080-2884-4f0b-b58d-88fbcf9d76d7","members":["f1b56084-1b4d-4858-b1c5-fe109cb7b38a"]},{"cluster_id":"22c6704f-881c-4e99-abe5-258852387852","members":["3a41d540-b1a0-4c5c-b596-8e90a640fa55"]},{"cluster_id":"f2102ba0-d90e-4134-a7ea-638b33257f3a","members":["43ad7424-4c77-4dc0-8c36-9d1d1d14dd12"]},{"cluster_id":"3596032e-4fde-4840-89ec-0f1fed8a80cc","members":["06c72a80-84c2-4b99-b900-146c339b7cb5"]},{"cluster_id":"4ea15f73-7350-4e50-b190-6edec6cdfa32","members":["63fbc0f1-49c8-4b3e-9954-75d114dce032"]},{"cluster_id":"503d3ee0-00d1-464f-abcc-e8b8f12f26a4","members":["9bf4b261-5604-4e7d-bdf4-1d258b3c8c67"]},{"cluster_id":"312c4cbe-161f-46b2-ac85-87a06a693146","members":["bf8c3e12-552a-4a71-843a-f89c91b6389e"]},{"cluster_id":"1cd605a0-684c-41fb-8c06-79b227b23a9a","members":["47086825-ea05-4d6c-a4fb-5290780b5f88"]},{"cluster_id":"0d47b48b-a9c1-49b3-8e15-26d394b843ea","members":["e3ab09fc-1684-492b-adb9-d899f0428e95"]},{"cluster_id":"74848948-285f-4571-adb0-ad9b59d381fc","members":["d941fba6-fd74-4a83-9e8e-d451475571b9","3bb8debd-6d9d-416a-9f04-208936f4533a"]},{"cluster_id":"878a9636-1e8d-41b7-b38c-b1f621f47d04","members":["f3374e00-912a-4a2b-a295-21f6bee73d8d"]},{"cluster_id":"9be4b289-aaff-48fa-8680-b2813e6b1340","members":["48c00d52-4142-44d8-8055-adaf8e806d65"]},{"cluster_id":"3ab13bcd-fc14-4404-8b26-7f8a67a82860","members":["75d8bd40-d695-4208-bab5-37205811fc6f"]},{"cluster_id":"b17935cf-677f-4da3-a3e4-c0a86cab1633","members":["b797142f-6e6b-4e92-947e-f1eac9cf2441"]},{"cluster_id":"395a3f4e-39fe-411b-af09-832b0bf2ab53","members":["c4d166ac-fb2b-4908-b29e-b5e60db0c750"]},{"cluster_id":"366a8fe2-ca03-46c9-b2fb-6c5f6c4014f1","members":["c5d32957-0250-4e27-883f-1614716b7a5a"]},{"cluster_id":"17ce8541-8518-4283-a893-e35ad31e95fb","members":["144a50c2-b370-4909-b53f-80f34729e342","bce91ab8-09f7-46e8-bd90-18e20c9bc00c"]},{"cluster_id":"84f2b012-a880-401d-86eb-78a247c92358","members":["d5908ec5-3ffb-41c4-a73b-cce528382f43"]},{"cluster_id":"72e8eae4-0f40-4ffb-9af3-05384f47f8b8","members":["64afbd72-1116-4c9e-be6c-75364f693bd2"]},{"cluster_id":"1e6f5910-b91c-46ca-bb2a-bace35349e8b","members":["bc099959-037b-43e1-81ab-0a360d9be0b0"]},{"cluster_id":"85c8c155-84b6-47ef-ae7a-060440258d20","members":["98c7e671-e565-411e-842f-6573296ff33e"]},{"cluster_id":"7754f22c-30c5-465a-b231-a607a0c13504","members":["7a2b81d2-3671-4bb5-b252-146ae07d2184"]},{"cluster_id":"a7db18f7-5822-426a-8676-b522df1e90e8","members":["891028a4-9c48-4a22-9b0c-8e72a1f0c9ea"]},{"cluster_id":"20eb00aa-eba7-4ec7-aca2-e9f771d49a23","members":["2218b201-0cff-4061-95fc-3e9f5fb5ffef"]},{"cluster_id":"dcbc849b-d40e-49ed-84ab-ec7cdf4bb695","members":["c683eead-b9f6-409e-98ea-ca86a80fe6b3"]},{"cluster_id":"92dc2b29-cee7-4ea1-b9e9-d0593544c75b","members":["319e2b16-8188-4643-b573-840838be97c9","c5204050-e2a2-4b54-85b3-15ef65842fe8","fe346ac3-50e6-4b71-a9a5-9e964fe80cce"]},{"cluster_id":"232c00d5-5161-4308-8ff9-5bf29dea48c9","members":["dec0aa9e-5fd8-4c97-949a-d4e94ae3538d"]},{"cluster_id":"869d4c13-d074-42b4-bbc1-2f3f74bed7a5","members":["b5463219-98c5-448f-9531-85d2be5f4d74"]},{"cluster_id":"0e78429b-c0f8-4ecd-ae8e-35ff713ba980","members":["ae9feba2-1286-4e90-8d19-f6c6fb5695bc"]},{"cluster_id":"fecb08d6-7113-4fdf-93c0-d68d7f11e733","members":["29c88596-19ba-4c92-889a-93d36cedb885"]},{"cluster_id":"19226ea8-73b8-405a-ba2e-087cba3fab92","members":["0f1e349e-33e1-410f-a80e-7f7a15a64def"]},{"cluster_id":"714c01ca-5d76-4ae8-b75a-06245aaab86c","members":["2907752a-dd04-43a3-81f8-99aed282cd51"]},{"cluster_id":"2d8ca62e-1cf1-4407-a036-bf48f62909c5","members":["e2d6ea9f-2930-4d6a-88e9-e46e90562a30"]},{"cluster_id":"fcb27263-9c47-4749-8f07-d80ab25d503e","members":["9837e2d1-81a9-4dda-a544-9966e203d52f"]},{"cluster_id":"b754c76a-3e29-4a89-b2c2-054b3adbaf0c","members":["cf9857de-8137-45c9-b5fa-915993e74b08"]},{"cluster_id":"38118243-3439-45b9-b0a1-902687ba3cc0","members":["ff9436f6-f297-4eb4-912f-7a157e3d12fe"]},{"cluster_id":"06de95aa-ea18-4201-9254-c11dee534162","members":["30d95fcc-b794-4439-8991-acda681c53e1"]},{"cluster_id":"c926ce6f-72a8-4848-817d-af5dc8f10bb9","members":["38511aaf-9163-4d65-81dd-224ed0e0b81d"]},{"cluster_id":"584c4eba-f170-4492-9acd-c1773318790d","members":["40f52c99-ebfd-45ff-98f5-952306d27151"]},{"cluster_id":"204d066b-baf9-4cb1-b94b-16fcde9be401","members":["11cd3da1-ec29-4a09-b90a-f36ba252d061"]},{"cluster_id":"411cad01-4640-4a11-9464-9f26565f44b6","members":["9a836402-72b1-4d2e-8da1-84843dda9b7b"]},{"cluster_id":"f96ee044-12e8-41d9-ad21-d1cd5c1012f8","members":["611ba306-98a9-4679-8657-f9c54c244a4e","72a28c90-6734-41ff-99bd-7e7f704a0df1"]},{"cluster_id":"edcd5353-7d93-4a6e-9bfb-a26ec2ae09a3","members":["51b2f815-411e-43f8-a5c1-336bea1219da"]},{"cluster_id":"d4eb4c1f-a715-4507-898e-b25f61a6667b","members":["782c2526-0417-4dc7-8284-5083afa85621"]},{"cluster_id":"ed866655-8d58-43f9-93ba-c498e1783c16","members":["dbe3b7f9-9c71-45eb-b905-98ec6f50ca3d","661d6da5-a118-40c0-b59e-fa784c68d780"]},{"cluster_id":"9a05cb71-dda4-4c46-862e-16d08e1809de","members":["5c56c859-c655-41f6-ba71-d6caa0f72e3b"]},{"cluster_id":"e3ef059e-984d-4158-bd79-7968854d515e","members":["f058d856-1ce9-45cf-9d35-23956aa81d73"]},{"cluster_id":"7767496a-74e6-483e-a0d3-11edd8016ac2","members":["68d7b0c8-243a-418d-b915-b2bed9b72c41"]},{"cluster_id":"35ff40d7-dc34-499f-b4dd-e76f13e34e0c","members":["43d0da75-6cdb-4b26-9b82-eb000d5742c4"]},{"cluster_id":"074437b7-382b-4a9d-91da-57d4542a546a","members":["7f03d95e-812e-49fc-9c20-0456009ed9e6"]},{"cluster_id":"814e8e7c-9951-4225-be99-2e978ab5ec4d","members":["2de3db1c-8206-4c97-ae05-14fa38749525","df1f4076-07b7-4f91-a688-776170514a2c","6b276ef2-2523-4c59-9fa1-fd01456deefd"]},{"cluster_id":"95bc2531-eabc-48ae-aefe-417173f45673","members":["2fa1a6c5-df78-45bf-b911-a34b2cf8635f","8d56a805-acf8-4a80-b4f7-742343c9065c"]},{"cluster_id":"d58866d1-afac-43ae-b1bb-fbdbeb0b8d62","members":["6ac1abfd-0548-4b06-add3-4ebb0962bfaa"]},{"cluster_id":"54852fe8-25a9-4bc3-8ed0-4f252eac7d21","members":["e5d0fd9a-f56b-4b5e-bff1-04b44d086cf5"]},{"cluster_id":"a08d6d8c-3534-4503-908a-ad9b08709410","members":["a3564e9b-3a80-4277-b28a-f7cc608ae50e"]},{"cluster_id":"3e95ef61-306a-4cf0-a217-5b910e8ffc01","members":["868f36b1-faaa-45fc-99da-436b401f1b8f"]},{"cluster_id":"b5cfe764-3a89-4e77-9f9e-c720d7d22394","members":["8ef9e457-666c-4977-8ad8-a6188f7bb8b2","aaf71c84-1b11-495a-9c4e-cee86667e148"]},{"cluster_id":"4d4e63b8-def5-48d6-a4f3-534d39e0e25e","members":["004c8568-374a-4517-8f8b-8bad54f4d762"]},{"cluster_id":"53ad86f3-97ef-4717-9f61-4666c34f7833","members":["b29529c6-004d-4947-93f4-3254e37e260e","63801b9b-1d6b-45df-937d-05ef8f6c6465"]},{"cluster_id":"b5e4c53f-7f15-4f0d-b014-ab5bdfef9779","members":["b40ce322-87a1-4be7-8027-452a7d47efc3","a1629251-5ff9-438d-82c3-c953fa276a4d"]},{"cluster_id":"99b6af80-6889-4032-9dda-54d5dbe1fafb","members":["7ea2566d-1b56-4eb1-b668-d5efb760cb02"]},{"cluster_id":"637433ac-6811-450b-94c9-8c40811c8f6a","members":["46be5e6f-5e7c-4dac-bf19-ba511307d0b4"]},{"cluster_id":"ef2890c7-c6b6-40d0-96fd-72f800a7cb26","members":["e07167f0-429b-416e-9454-dec0d9045cb6"]},{"cluster_id":"333dab32-099d-476d-86ef-f676846f2e4b","members":["f4250b4f-185e-4240-84f1-06dd55ea2513"]},{"cluster_id":"471ac06a-ad1e-40a8-b238-859f31d2504b","members":["dcf6c7fd-72a2-4fc0-b404-e0a1efed57c6"]},{"cluster_id":"3465d409-db96-4545-a6fb-c388765f1b4a","members":["e9e73205-eea9-4079-8e2f-017d20cd34e9"]},{"cluster_id":"14c3f0e3-2371-447c-8445-1ac6c299f633","members":["27a7e73d-295d-494b-aa25-d05f32b9905f","8df7b50c-2cba-47fb-9c3e-c89f142bf026"]},{"cluster_id":"8b5f2de0-fd72-48f3-8849-4ef20748a393","members":["52d05306-7b3e-4b56-905c-52d9adf81a77"]},{"cluster_id":"b571b4ac-1009-4c8e-8fd0-977fefce53c9","members":["e980e670-fd3b-4604-bf30-f315710cdea3"]},{"cluster_id":"099689d1-bfaf-4b3b-b795-0a924815ef02","members":["ca8cd41a-bcd6-41ba-bbe2-0940279c571c","57078c34-49ef-40e1-97cc-1bd6a7f3aba2"]},{"cluster_id":"78ea610b-38fc-4528-87fe-af950e4ad514","members":["037b5584-31b3-45ac-9f69-070ac5eb8829","09aaf704-8467-4143-952d-96f41284f4f8","8917d070-5d0c-4de1-956f-8133fb84f3b3"]},{"cluster_id":"a00b5c34-3d1b-444a-9f62-57418373c9c3","members":["f8013c0f-cc01-4be6-93f6-384857421899","a29fe756-de69-48fe-a88b-c881add7f1bd"]},{"cluster_id":"58ab14ae-8edd-49c2-93f1-5410b8248aac","members":["fd40e2f8-9a3a-4d18-a733-cd715f9ce076","f7a81fa7-f979-436f-8060-bb1009d450bc"]},{"cluster_id":"2490cd6a-465d-4de9-bada-79c6b3ffed26","members":["704783bc-11f4-4d6c-b839-d9f3b7f1324b"]},{"cluster_id":"07b1d44b-f7cd-4319-883a-80ea44f07316","members":["2d271a5c-928a-4930-96b4-129efebe1df5"]},{"cluster_id":"2227c158-fdf5-47dd-921b-7c6ca1823ad0","members":["07510bdb-9489-442b-a192-8176369edcf6"]},{"cluster_id":"94c94ebf-a12a-4db5-9455-477a88d18b1f","members":["aa1cb9f2-79f1-41a5-9ed1-df995778d99a"]},{"cluster_id":"90dd5b61-524c-4738-8cae-d8d3f36a7bf8","members":["bfb94fe4-4411-47f5-af22-944d54d6257d"]},{"cluster_id":"8c98812a-8a38-46cf-a002-b105988964fa","members":["258719ec-bc17-4161-8038-22aaea9045ea"]},{"cluster_id":"80b2ece5-7d1f-4503-86fb-dde80c97bee5","members":["8a30da06-0220-4593-bd3d-77e921c8e4ac"]},{"cluster_id":"c49cd086-ee6f-4cec-890b-ecf827080344","members":["3ffd80c2-fde7-4f2c-8c31-8e29baaa1b45"]},{"cluster_id":"9dee9825-7f6c-4617-8b1e-b3ceb5b3a39f","members":["6f22db37-dbab-4c70-b00a-de4ab5e1a28f"]},{"cluster_id":"6c5b6495-5a45-4608-8917-e96bd2fcb820","members":["7bf352ce-20a1-4705-b44e-d284a64f2dc9"]},{"cluster_id":"c2a59237-65bd-47ee-930d-7682f70bbe46","members":["f158a18e-8e7f-4fdf-88ac-f48f70fc099b"]},{"cluster_id":"0133f004-4682-4cbf-aa32-305a065f5e30","members":["78d2be66-b720-4f0f-8d4c-478dd5acbe21"]},{"cluster_id":"b9961616-57c0-4002-a439-bbd0acf2194c","members":["7310ed04-5712-4000-8ce7-8ed3d2ae62d4"]},{"cluster_id":"1a4aae73-4152-4a0a-830e-ec3794a86bd7","members":["55f8ab79-cb3a-4bfe-b0cd-7f7e568f60c0"]},{"cluster_id":"7201e91b-d78c-4827-b8ba-6360e45574c7","members":["348f73f2-5d04-4cf7-bdee-7a8f5ec3e67c"]},{"cluster_id":"bc76f539-3671-4e32-b4e8-b1326e7f32a8","members":["6b437726-a25f-48f1-a4df-2d46e7e4af00"]},{"cluster_id":"f5c0430d-6c19-4e4b-815d-7de708ba52a8","members":["dfef6cce-2e7b-4cb8-a568-6acc38367d08","b34894b9-0db5-4b79-9f77-90483625254e","15443277-29b8-44dd-bc8b-e751eb349fa8"]},{"cluster_id":"1d0959a8-981b-4a23-90dc-2a9d7c7c079f","members":["4c3bfbf2-3a8e-4c7d-8bc5-348fdbbc48b2"]},{"cluster_id":"3cda3833-2d58-4e6e-a35b-5bec2cd74e4d","members":["58f8bf85-a0a3-46a2-bea7-181eb9477611","5d97b84f-d0d3-4586-bb21-05b4cf519290"]},{"cluster_id":"9be7eccf-749e-4a5e-97bb-089da9891c3f","members":["dac09be7-9dcb-44dd-a432-f9b40d387ea9"]},{"cluster_id":"19d8a06a-0c0d-4355-9204-b73d0ebe4d12","members":["402de313-dc2a-4179-9d33-756d322fa7c6"]},{"cluster_id":"e1645179-8a65-4728-91ce-ad15f6e0cef3","members":["367702f2-91ad-4a93-9dd2-0f8bb2859c71"]},{"cluster_id":"0f6d8e28-a525-480c-9282-bbbd6890cc48","members":["335a890c-6ec5-456c-a805-47ac70e391fe"]},{"cluster_id":"5f5241f6-dc62-4f74-8e2a-d9e564410ef8","members":["9e8d5433-b960-46a3-b4a3-41a029fb9d00"]},{"cluster_id":"c3ffc4ba-bd9b-4ff0-ac0e-e1b2b01b15fd","members":["2e574775-b70d-43d2-acb7-8d97dc6fe61d"]},{"cluster_id":"9d18ccac-ba43-4c43-bed8-0d742eb6d22d","members":["64b63c87-6a47-40dd-90df-bb9b12f57bc6"]},{"cluster_id":"576d86b7-1d28-4f66-8319-eb34a892467d","members":["5834073d-b787-43e0-aef8-e4171853a791","acc49a20-eaf2-404b-9bec-b4368de91130"]},{"cluster_id":"b6692507-59c3-458b-bc20-9fc0bbf648db","members":["75b664c9-cdd2-4d8c-9dc9-5ba708cd4eb0"]},{"cluster_id":"29fc6217-0253-4ea5-924b-34a8cdd037cd","members":["dc1adbc4-c3a2-4026-a250-03f9a8f6ebef"]},{"cluster_id":"b785d99b-0340-4f57-a54b-f08a5b415aa2","members":["a512f7db-5a67-4c26-8411-0d908211a5f8"]},{"cluster_id":"eb6bb91c-6bc8-4c0a-9783-baf41ad32ae6","members":["8987703c-09a0-4a89-b7de-26177897cfb5"]},{"cluster_id":"867076a2-38a3-4bba-9e8e-00167fbd33c9","members":["b2da0a15-df9d-4652-8e36-56d2c0f29af2"]},{"cluster_id":"62ebe72f-55b5-4dca-b8c6-cb9ed5b82c24","members":["73442f47-7f8e-472e-9206-3f32b19a5161"]},{"cluster_id":"9f0b5b9d-5ada-4603-b28a-01eb2e4517b2","members":["abac13d2-7169-4c1d-b450-72fae04f1142"]},{"cluster_id":"ce398b7c-c3fa-42df-8862-5c57ac63cf98","members":["64edff3f-a376-4056-b11b-027d0773ca96"]},{"cluster_id":"09a3b73e-815c-4ea0-9da8-b1110ca8cf96","members":["a6b153e0-68cf-4345-b16a-5d5466f30f29"]},{"cluster_id":"8dd2ae56-dcf0-4439-b3f0-3a7a939056df","members":["bb26bcd8-0a0f-4bba-8469-7880dae97789"]},{"cluster_id":"0cb30e02-d84d-4557-96e4-2da52513f036","members":["373f6412-6baf-43eb-8677-2ed1f31c6eaa","7bd2872a-0b55-457d-a26e-3d1c22d3c6de"]},{"cluster_id":"a22b19c4-dd9d-4007-a380-a5d0659b9821","members":["4a142742-30f0-48ff-9d5c-cad9814da2e8"]},{"cluster_id":"4da3a5b6-2b3a-469e-82e1-4fa291688db8","members":["c1357c61-adf8-4bbc-8ee2-91964a807394"]},{"cluster_id":"921c5a51-cef0-491b-8b5f-a5f05c5b785f","members":["37f4799e-ac16-4d40-9bf7-7b2e33db04b4"]},{"cluster_id":"e47ab492-3177-49bc-9493-e444a1518298","members":["7c0622b6-4c06-434c-a1c1-e220f0a5abd0","6ee76e7a-4bd0-404b-abab-03d01a57ea06"]},{"cluster_id":"558372cf-c982-49c8-8de6-cd0d8a987ae8","members":["9b6368f5-3479-4185-8bdd-eb93154ad53a"]},{"cluster_id":"f859d7dc-7168-48cd-becb-1199652aaa89","members":["f319eb18-5151-41ec-ab61-08335d766535"]},{"cluster_id":"4dc5e4a5-2670-454e-b212-260136221524","members":["e8e3ddc6-6a6c-4652-a4e0-4667177529de"]},{"cluster_id":"d5f197ec-3802-460d-9ad7-c43d150d3ad0","members":["bdbccbbe-eee1-446c-b0a8-4d84bc8334a1"]},{"cluster_id":"9fa0ae4f-fe27-4925-ae63-04bdfeb3953f","members":["7b2fc77e-9928-4b79-a078-6220f6106ae5"]},{"cluster_id":"a3067b08-040a-4461-a857-7a4d88845295","members":["fc2221fd-331e-4e4d-9500-ee288d246c3c"]},{"cluster_id":"1f7a8e67-3a2d-482a-a62b-2e318f3fda52","members":["22e284db-951a-4166-9096-35c264340b2e"]},{"cluster_id":"47924c3b-71e9-4d32-b64c-af3ed4408382","members":["a44177d6-2464-4605-b4b7-dbeef94f5949"]},{"cluster_id":"2baba0c0-38f3-43b9-8755-4293f919fe7d","members":["636d70cc-b434-4ae6-9e92-4d776254bd53"]},{"cluster_id":"4fb3ad72-cc0b-4dd7-a137-fc01ed07a902","members":["b69b00bd-1c0f-4c05-bc07-81f2e3e39b4e"]},{"cluster_id":"8a8f242c-8eef-4ca8-a157-47a2a04d8d4e","members":["b19f7cda-33d5-40f6-b0d5-eb8e9af54659"]},{"cluster_id":"777f1392-cb45-4f46-9166-db9e19c26beb","members":["f9605271-979c-44cc-ad70-a9223ad34a55"]},{"cluster_id":"3a6b381c-f068-44b8-863b-e7023960bcbf","members":["16f99f21-2a2b-411d-b650-b44faaad6bb2"]},{"cluster_id":"b7685445-3aa6-4ff3-a94e-b37c9df21cb5","members":["4c8e9da5-5bdc-4932-8d55-41984416cd05"]},{"cluster_id":"3662eaef-57cc-467f-a555-ca15b13b9be9","members":["4470e99a-dacf-40c0-92d2-cf36af84c32e"]},{"cluster_id":"87e5a1c0-9b91-4772-b701-2e6333826ce4","members":["c7a5bcbc-2006-4764-8207-620d09886a38"]},{"cluster_id":"87f027a4-571d-4212-8e96-6f46fe317fc0","members":["69fda331-49f4-41e8-91fd-54e672b4af61"]},{"cluster_id":"5fafb978-3006-4010-ae1d-242c5cb188f3","members":["c48d12ac-4849-4c1d-a010-8c0445099769"]},{"cluster_id":"6030a19b-208f-4624-83fa-f8e8a264fea6","members":["218979e2-6346-46d5-84e7-bcf3652d7a9b","069673ab-fcaf-463d-a280-db1b9f50dc4d"]},{"cluster_id":"c4ef8aa7-0a73-4837-bdda-5894dfbdb7a0","members":["78cfbbbe-314b-4a70-9cb8-db5cf39b5d72"]},{"cluster_id":"ea3abea8-dde8-497c-9c04-bcf3a9757f8f","members":["af2ce867-2914-4513-8c2f-62a70058b763"]},{"cluster_id":"7992895f-6a68-45c7-a087-4ea61dcfa40e","members":["c92d754a-4f19-4748-bb42-dd99695f6ae4"]},{"cluster_id":"6feeb810-f8d8-4337-b308-bbd0aa0c4221","members":["ca3c207a-2dd4-4d6e-b63a-2a6eb4f34133"]},{"cluster_id":"13e45fa8-d3c0-4dcf-9891-87d1abf0b71a","members":["56582cd1-f8c4-4a94-a701-1c06b71c798e"]},{"cluster_id":"51102dd8-1276-45b4-9dc0-5dab1b318e57","members":["fcfe8808-9e01-45de-93f6-29d62e4ecc7e"]},{"cluster_id":"6c7741a7-bba5-415f-86fa-1077ed815fec","members":["999182db-2625-4ed4-bee4-2651ff7ab1f4"]},{"cluster_id":"177da242-e804-4b06-8955-3e43352e0145","members":["d5c07d75-9a2b-4f52-9375-4e117e5c9de0"]},{"cluster_id":"2c4ce8c0-6662-4508-bebd-0134d7b84392","members":["762e6407-10e1-4560-b0ca-3d37bb092d6c"]},{"cluster_id":"e8fdd463-9207-4e60-a84f-71fa88bf5a1b","members":["39a925b2-b74c-4874-bc92-c3cbfdc46c80"]},{"cluster_id":"c6ae3e3e-9490-4f23-8d47-5a4b1fb01352","members":["fb3a1bf0-a119-4364-a911-6554bb3613f7"]},{"cluster_id":"d5f940cc-5da4-46b9-a86f-4006d64c39d0","members":["bd6239fd-09e8-4ff6-8c9a-79bb5394f59b"]},{"cluster_id":"365e9714-a651-4229-98f7-325862506f0b","members":["b9666832-ade3-4dd6-98de-b270acc661b6"]},{"cluster_id":"7e010522-998f-4102-8a4d-417605255131","members":["60f86427-d4ae-47e8-bb90-2baa9a16eaa3"]},{"cluster_id":"d63dd03a-5d4f-4d47-9f48-b37f794db992","members":["29d17b68-96a8-410d-acb8-8f586fd813c3"]},{"cluster_id":"360f8a39-1f36-4965-9744-1b8bf78217a1","members":["5d6392b7-7672-4984-90c2-2bbc04d3e340"]},{"cluster_id":"2528bd46-af3f-4f9d-8f91-2dbf49b3388e","members":["42e7d87f-ac81-49a4-b5ef-227fee56c62f","a88ebf1b-3427-4f5e-9a06-516d1fdba7e7","4feb4de2-57f8-4d45-98a2-90445dcf8903"]},{"cluster_id":"41e4adfd-a702-492f-a430-46ac304993d5","members":["3fa92da9-bf8a-476c-b420-e17386dc2c3d"]},{"cluster_id":"186c5c04-d5bb-4764-8a32-550ebb9ed5fd","members":["d1ab25fa-1cfd-41e4-bd76-cdd74ca6bb2c"]},{"cluster_id":"67498cc0-4b03-4712-95a1-69a6b340282a","members":["bdb876f5-73e9-4c5d-b8b8-24a290e4ffe4"]},{"cluster_id":"a4bee492-f45a-4aa3-94d5-709bdbcd2d39","members":["effb38df-4036-4437-9033-bcf6992ca029"]},{"cluster_id":"9fea69be-9aad-4b8b-aca6-7960741c46ec","members":["cf2b8c88-247b-4d9c-8c52-d1ab5bfcda93","eff22e41-0c9b-40c6-af46-0f65af2be234"]},{"cluster_id":"ab91862c-85f4-4041-ad6f-31e79b4bc25f","members":["472f2da8-0427-4361-9b25-4d93d7c41104"]},{"cluster_id":"454d2297-ce2d-4682-8c48-dff1e1ee7f18","members":["7213d7a8-55b7-41c7-8d70-7dc155ca102f"]},{"cluster_id":"591739f1-b375-4e55-9c3b-ffe5cb8186ce","members":["c5f9c08b-5324-42f7-a3c5-bb9deb54375f"]},{"cluster_id":"8a1f2e01-5e97-4b63-a054-d879e5cc37f3","members":["68bc38f6-99cb-4a95-9d9f-fecd624d95d2"]},{"cluster_id":"8d987874-4ebf-4fd4-b0c2-5cd72bf55264","members":["35ea6519-3949-4886-af7c-a16415792eca"]},{"cluster_id":"6b13e7ad-350b-4ea9-8771-684dda7f984a","members":["c1724b7f-f234-404c-a369-09e839958054"]},{"cluster_id":"9dcce4d2-ce6e-4b1e-a8f5-c853370fae54","members":["621e30a8-e3a6-4a1e-8148-625c788f17ba"]},{"cluster_id":"bd47afb3-5229-4410-873e-9a50752f0292","members":["7c23a944-c1c8-4e60-ad55-a315dd953f0a"]},{"cluster_id":"7f4c9ab9-c44d-442b-a98c-55507ea1e6cb","members":["508d98f3-daa9-48ab-94e6-c84842abd664"]},{"cluster_id":"859ebc03-00a8-4a19-9bda-cf26a29549d4","members":["db1a7681-204e-4a6e-bee8-7555e7d1e7bb"]},{"cluster_id":"0ae555d0-f055-4458-a22e-cafea01bd69c","members":["5702700a-9e3a-4d47-bd2f-f6267d3bfb8a"]},{"cluster_id":"77ada2fd-a5b1-4d46-9fd3-0fa7022914dd","members":["e11cd318-1c62-482d-956c-1e3fef6d9597"]},{"cluster_id":"f4d98260-09b2-436e-8c76-b8fdadb8663b","members":["0a63eac9-8b10-4812-845e-27384d4011ce","2988ed3f-8d55-42a9-aeb8-1e289dc22a22"]},{"cluster_id":"7a1d05c9-2872-4724-bfbb-1dbc30578c14","members":["051ea1e9-5523-46c7-9da6-88c538586f18"]},{"cluster_id":"42aaef22-3993-4ed5-8477-0e78fe2789f9","members":["18627898-a921-455c-93d6-8ce216b6c674"]},{"cluster_id":"de42709f-cb35-4f62-b569-11c75f1fbe5e","members":["71b6d51c-90a4-4139-852f-aee305ae0835"]},{"cluster_id":"cefafa9f-3780-4e29-9888-658635c4bf8a","members":["6b5b3209-851c-45f6-85da-5cd1c52ea48c"]},{"cluster_id":"a4f84d58-e9f3-4a41-a8f9-b81736f1cea9","members":["a97c39db-1aed-4a0c-904d-6b9a2bdc8ce9","a4353cb2-f322-4a31-b4d3-6ac1693c1d88"]},{"cluster_id":"64ddad58-c0e5-4850-be27-0ed962a47441","members":["19e3f2e7-1f5f-4057-8c33-eaa88ecd8b11"]},{"cluster_id":"77081589-555b-43cf-8723-b50b060cc231","members":["8f8a1fe0-054c-4805-91d2-1f315564e9e2"]},{"cluster_id":"e4f0ca80-4588-4554-9e20-d646dd11d817","members":["c04e7acb-a195-4fa0-bd8a-2ac9d90dc9f1"]},{"cluster_id":"baef31d1-0183-4a82-91e5-3ce55345b1d6","members":["8f08754d-53ef-4d85-8001-af0a15e08cc7"]},{"cluster_id":"8f118d54-36b6-4cf4-a60c-7acf617e5bf4","members":["fda6b7dd-0801-43b6-b4eb-0387977a987d"]},{"cluster_id":"63e1fb6c-f4d5-44b0-95bb-4b6a7af8b4d4","members":["40536ea9-1e09-4388-9c4e-a20eb9b71204"]},{"cluster_id":"95a8e81f-4308-4c82-a9de-2d2f3b200b4c","members":["5d664621-21f3-4440-8668-201728d0a3f0"]},{"cluster_id":"9583b42b-1878-4c5b-8b34-5a41d72c1a17","members":["c2e16897-3bc7-44c5-ae38-8d5b76119a14"]},{"cluster_id":"04a95cfc-f399-41ee-9730-e984f76e78be","members":["6dd11535-10d3-47ab-b07b-308c6c7ab99c"]},{"cluster_id":"713b16e4-cb6f-4c7f-8eac-cbbfee258e85","members":["e124c13f-6a31-4552-b776-9c8cd3da2e20"]},{"cluster_id":"3803cd19-3379-4dcf-8227-17e8e94b50a8","members":["b0d60f47-6669-4391-b656-a5f96dccbc74"]},{"cluster_id":"1faa4831-480b-4038-9fea-49267683c570","members":["f8254991-a263-4f0f-b469-53086ef94686"]},{"cluster_id":"b96e892e-f2b5-4f40-833b-36af1949d85f","members":["4964ca25-06aa-4cf2-876f-69e4a7690652"]},{"cluster_id":"a5511c2f-b2db-4795-9bb8-2441a998fd2e","members":["2e07a7b1-49cf-4d84-9b94-641aea283ddf"]},{"cluster_id":"6c435a8a-93c9-4345-913c-85766d15d80c","members":["865462a9-8a34-448c-bb8c-328656ba28e6"]},{"cluster_id":"d550236c-347c-46ce-84eb-f723bc55deec","members":["fb123684-7415-483d-a978-fec91ccba8b5"]},{"cluster_id":"db605ad9-a4d6-40a9-abcb-d200ca16a403","members":["b3f91f51-786d-436f-9d18-3ff001743926"]},{"cluster_id":"a66bb7d0-dc6f-4116-a7d1-4f4c8d7be3a8","members":["ed690654-d87d-4362-9e8d-10d320020a00"]},{"cluster_id":"d8e63a6c-9b16-4691-ad10-679a83e7a296","members":["d6d7c667-9bc6-4290-b657-06e4474549ec"]},{"cluster_id":"71c5fa4a-0b53-4202-9b3e-1c8038451d63","members":["a5f1b802-c83e-4b26-b021-63db9730cf9a","0a000d18-ecff-446c-a924-6d82d3d98023"]},{"cluster_id":"b60886b0-36f1-4d60-bd61-b45768791dc2","members":["589b69b1-8cf4-47d6-9557-8ed7a4dbe822"]},{"cluster_id":"6d2cf6ad-226e-438c-8ae9-0f0b432c0bab","members":["947eb814-56a8-407d-abce-805377cabbd3"]},{"cluster_id":"f9e6216a-ee1c-443b-8198-daf20f932faa","members":["3035d86b-acc0-4403-bffd-6700fef7bb0c"]},{"cluster_id":"0d76345c-1ef8-406a-a4b5-284717ab866d","members":["c16348f4-f677-4500-9bce-e94363964920"]},{"cluster_id":"83e19f20-191c-42c6-bdd7-ee466f6ee0d2","members":["eb81506a-1e5d-49a4-b1e0-78fa8d5785ab"]},{"cluster_id":"1b5a113e-43ba-4a33-a76b-09db6a2b33ef","members":["d42a2ca4-b7f8-4e98-a8a3-231bc4ccccff","9160fce3-639a-404f-bc2d-247e2f635b91"]},{"cluster_id":"1a61f6e2-0fe8-4393-9f81-f3403bde43ac","members":["876cafe0-7630-405c-b6e1-94aad8874fe2"]},{"cluster_id":"e6007b6f-2ba5-4830-8564-f98f1943ec9d","members":["5f1983cf-65eb-463a-8550-1f6af19a3988"]},{"cluster_id":"25038dda-b8ca-4dd5-9e0c-c382a4d18a6e","members":["d2e60abb-a3b6-4cdb-8512-655a66edd080"]},{"cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638","members":["42af163d-b12c-48f8-8f72-f5bf6759e608","8a40ef2a-7e19-4ee7-8d2c-14d80b5c22d6","13727699-8b9a-4d25-b74b-7990b71f76c4","eacf0c25-ed4c-482d-897c-68a487f7e75d"]},{"cluster_id":"d7410313-2ce6-46bc-b39a-d7543341b90b","members":["36a12859-4750-4aaa-9c12-392e90d727eb"]},{"cluster_id":"0ecafb9a-2141-4b23-a024-348c4e1719da","members":["1fb3f6d4-c8cd-4d56-9cec-0948e64aaeda"]},{"cluster_id":"03a9ef94-2f49-4a92-bace-dca90bc3fda0","members":["e2ac372d-a166-4881-9474-9c11807b1178"]},{"cluster_id":"8d34ac69-abf2-4d47-a080-a43806db5b67","members":["a6f8b9a8-185b-4f04-bcf2-404080257ea8"]},{"cluster_id":"3e954c39-38a1-4449-bb6c-9e8070f71e04","members":["37fce88b-2358-4766-9435-a0717c3405c5","e22e01a4-aa93-4c65-bcd7-d529d935d18b"]},{"cluster_id":"9f1d605b-541e-498f-8d37-d5763cc9a791","members":["8426f0f1-04a1-4750-92e4-99b90403eae0"]},{"cluster_id":"92bbe30f-197d-426e-978f-44717acaacac","members":["c0b7a5eb-b0bf-47b5-a328-58a0f3ff8bd0"]},{"cluster_id":"cf544ca5-66d4-4d37-bc28-71ce54266ee4","members":["2fe478ae-a877-44a3-8f18-668db21a5348"]},{"cluster_id":"c9b1317b-d9b8-4f19-b568-8b833e155fb5","members":["f61d6cc9-2903-4136-884f-7b3e17d13179"]},{"cluster_id":"507a2a11-43b9-4279-b484-7be9d201408d","members":["a2ecdc6a-41ca-4b32-92be-1de1a2628ea6"]},{"cluster_id":"d53cdbb5-0ed7-4595-a5cc-31ff93c45b69","members":["933adce9-9b87-4807-b8f6-6cbb181e88fc"]},{"cluster_id":"954829b5-b0de-40ec-a999-143a5f855d8b","members":["06831552-14e5-4569-9ca9-c47d8f2f1201"]},{"cluster_id":"d87790ba-a7e4-42b2-87ee-50115287f374","members":["06d044b0-5302-484d-85db-51994723b229"]},{"cluster_id":"674e3f33-6edf-4940-a9ac-cec9bedff257","members":["5d1a9831-cc92-4115-a2ec-ff7210d9087a"]},{"cluster_id":"efc4ab9a-f965-4202-ac72-ebf2fe08724d","members":["4600efc9-06a8-4dff-8c12-b27c8914405b"]},{"cluster_id":"5c31493c-9070-471a-a409-144d7a3c341a","members":["561d7581-dc0e-40b9-b96b-ac143f095121"]},{"cluster_id":"30cd928f-5775-4679-a8af-3acd8dd1a21e","members":["1150a8df-dadc-4460-8904-03d1f9c58dfb","df7a3803-f91f-4992-af44-ab4dde913c7c"]},{"cluster_id":"3eb68d57-7c14-4dd1-91dd-ff18ff1740e4","members":["f6d886b4-d0a4-4969-bc31-c67b520d2a5c"]},{"cluster_id":"0e23ab63-e410-4477-a70e-2df0f99242c1","members":["dbe8b6ac-605c-4478-be22-c0b7129ee99d"]},{"cluster_id":"8ec3865c-7644-4e06-bb0d-00ab782e6cd7","members":["6b1d58c8-d531-46d1-a3de-d3942338e3a8"]},{"cluster_id":"6a879b2a-d8ee-4202-a129-be28ec711b2b","members":["01aa59fb-ce8d-4b3d-a98a-b57b041b163e"]},{"cluster_id":"34a8290a-940e-4582-8dbf-cb195db85e28","members":["e13d298d-79b0-4aee-909e-3952b920571e","fe4ddb1b-a94f-4e6f-ad4e-e6707844c3ef","fe17246d-1e8c-4742-998a-439fed22ca9a"]},{"cluster_id":"cb5fae82-58a9-4d49-9da8-1886e33d1269","members":["6bf705ce-a12a-4f60-949e-6c0cae0a8d0c"]},{"cluster_id":"24603ad6-f39a-4706-80ce-2840439ad61c","members":["b1f8420d-1434-4ed7-9e9b-2f5b401ea971","5b4e4e0c-8d90-4af7-bb86-d6a21c16772c"]},{"cluster_id":"0a5b6270-0640-4f06-bb62-1bb490df9669","members":["72373a32-4718-429d-865f-959e3973a9d6"]},{"cluster_id":"5a60b1ad-2d21-44bf-9788-e9579de25e42","members":["b11bf74a-611d-494c-8e3f-958935e00c4c"]},{"cluster_id":"f81e3872-fc8b-4fad-ac23-6ccf86d6cffe","members":["b72f4d99-5380-4d0e-915e-78d8f4f84bbd"]},{"cluster_id":"6f277c5a-d392-4a17-b884-6fd70ae638a3","members":["f167b354-bd64-4739-bc03-653bb6852739"]},{"cluster_id":"53fc6234-d563-426d-a3bc-ba15edc6f530","members":["463757ac-1c31-450b-a9d8-1f782bf7eb1f"]},{"cluster_id":"5949d818-e369-4db8-949d-7a462c260498","members":["9f35f38b-3794-4d37-a1c4-bf60d8e4a48b","5f45c6bd-882a-409c-af4d-d2d5713430fc","ff9ba1ec-0a5b-4a94-8022-4f958ba98e46"]},{"cluster_id":"5437d23d-a8b8-4a7b-b296-c42b5945a223","members":["41ac5159-bb0b-47a6-bb2f-f18ba9c57586","87864deb-9b02-400c-9156-594929a9d8fa"]},{"cluster_id":"35d3d7f4-4964-4980-9833-62b5e004737f","members":["9a4d6d1a-bfe6-4637-9368-05a0a90b2fcb"]},{"cluster_id":"d86ceeb7-05d4-46ab-afb5-94228b85b310","members":["c0920958-79a0-44a2-bbc3-7e899fb22b93"]},{"cluster_id":"371e032d-d57e-40c0-84fe-6f5fa1665409","members":["4f1c0efe-9bc3-44aa-a1b9-1a380a3cf4fa","0fffe169-4ede-41cf-b588-2b5433b67d07"]},{"cluster_id":"0be74e36-e76b-4fc7-9f69-d42f28778f07","members":["4a46bc74-222c-4fe2-98d3-e36e76688bb5"]},{"cluster_id":"3e4bfcca-aa45-4a97-8306-e90101b4ccc0","members":["b257e337-06ca-43af-ac54-206bb782b9ce"]},{"cluster_id":"2a47fd74-5995-437d-b0b5-6396ca3119f9","members":["2efd1f8e-6d3f-4e58-a5d7-d2874f20715f"]},{"cluster_id":"887d717e-5da6-4cf6-995c-bcee081cd128","members":["ca9816ae-1d2d-49ea-a74f-44b004b3a8fb","b5802323-7512-44b7-a2c3-95a5d43334ad"]},{"cluster_id":"76ca8734-57fa-4978-bce4-584836cb98e4","members":["50fd46cc-8d8f-4fe7-a98c-155464bb72a9"]},{"cluster_id":"6413f39e-1e69-4b93-9d00-8b04286c8041","members":["d0c00902-401a-4f43-ab0f-ce04bcc0cafe"]},{"cluster_id":"2130a389-a1b6-4f7d-b3bc-7b83efb0ab8e","members":["017d0131-e8e6-4734-97f5-63d75131529d"]},{"cluster_id":"109d7869-80dc-4ec3-9550-208fe3c6f717","members":["3dbcfda4-9a03-4305-9433-8138b360536a"]},{"cluster_id":"10cad03e-00e1-4582-b61d-1c7191589376","members":["abb4ef4b-2dca-49fb-82f9-00b5e7c75dca"]},{"cluster_id":"d5e18b03-3515-471f-a4d6-448fbfbfb257","members":["ed07c339-370d-44ac-99ba-4d39888dab8b"]},{"cluster_id":"94a7144e-4fa6-47f3-9e46-2609b5de45b5","members":["8578fb81-6248-4821-b911-ce350c918471"]},{"cluster_id":"65f7972e-2194-4ad4-97f0-1ccb32281e02","members":["5c12efda-8298-413a-9c12-4b36fb624d7c"]},{"cluster_id":"67cd7c4a-a6b3-4e11-9b6b-362422489e76","members":["54518935-b171-45ea-a2dc-7eeabe29f399","9e9c0237-da1e-4af7-8f48-cecebd8dca83","a3cbf3f9-5255-4738-8bb1-30d03f5ea612"]},{"cluster_id":"615888f6-5d35-4a8c-acd9-9e71127a4cb4","members":["226db66c-43ac-43b7-b276-389ceb6fcbf6","63603e7b-a791-4901-af75-8d07266dac3c","763490bf-d450-4201-b047-b5795f2a279c"]},{"cluster_id":"d9484da0-ca3b-450a-a45c-787783bba3e7","members":["35a8f742-b752-4acc-9240-051519a6aec5","7381c9e5-6728-47f0-b327-03b0b0082787"]},{"cluster_id":"e512735b-aeb8-432c-9b72-89718eda18ba","members":["9d6ae165-bc8c-4b5c-b106-e9f72d811855"]},{"cluster_id":"939d6808-ee32-41c3-8d70-73aed1d043da","members":["4816eefb-d760-4c17-81ff-d99b1489f626","ac7eb1a9-e2b2-4f4b-b565-0da0ed4aee2a"]},{"cluster_id":"b5f5096f-4606-455f-8c76-949d5ee72c79","members":["e0dcc4e2-a5cd-490b-a35f-436d888941b5"]},{"cluster_id":"f2f62c1a-8699-46b7-b2e3-61e093884f19","members":["bc87f35a-0a70-4f5b-8422-86653c75f043"]},{"cluster_id":"5014d6b5-2e76-49bd-95af-b599a74c0052","members":["281cb847-000f-4b27-bbda-89dfb3c7d33d"]},{"cluster_id":"fdfba504-e492-4a5f-92f3-533547d34d6b","members":["e7c874de-8ed7-47a0-b3cc-0883535ac190"]},{"cluster_id":"1d4622f2-0a7b-4423-ad78-a011864bf902","members":["c30eddb3-a102-48ad-a621-91d4ebcd55a5","d8dab0c0-3b5b-43b5-bbe4-899087df653b","e6277357-fcd9-48e6-a897-eec71ba573e6"]},{"cluster_id":"2edd3f54-1c62-46b5-9ed0-1f1f90407326","members":["47540f62-880d-4495-a45c-d4a8e901debd"]},{"cluster_id":"63531f99-fdf7-4bec-966d-ab104759e21a","members":["c35488c0-3e55-4d1a-949f-a25c144e3c97"]},{"cluster_id":"cde4816a-67c9-4232-8144-e08a59a84d64","members":["d6e286ba-6e9c-48de-8d81-3c326f52ed71"]},{"cluster_id":"8a9e9225-8d82-4d0e-ab43-4f387b7b1105","members":["97901ddd-6840-4fd4-8e81-248a7d8fc759"]},{"cluster_id":"f0462ff7-d9e3-4bd0-94ad-a4653debf7f6","members":["ab865bf3-a564-4ebc-b231-3711ee9ae979"]},{"cluster_id":"3b9a3219-78e5-4ff5-948f-415edd9701ed","members":["0904d2cb-95a1-4ca9-be6e-fc7300123c0b"]},{"cluster_id":"8845b13a-d2ef-4802-8b18-edb4fbddb6a2","members":["202cb877-3015-439e-a30a-1822d69a1d24"]},{"cluster_id":"fa579361-a6a5-42aa-a37b-78556d46e1d5","members":["1b5acd67-526c-4ff0-860f-e8c440307f91"]},{"cluster_id":"ffc5ae60-fd21-4d4d-9cbb-be7095643849","members":["e8a37bbc-823e-44da-ad0a-c6e9eaff6cb0"]},{"cluster_id":"efbb863d-f52e-42f9-a671-9fa0b8c1b1fb","members":["b839dc0b-24d9-452e-ab64-ab44b118877b"]},{"cluster_id":"a7d594c1-3fc6-43ed-8545-37320216cb3f","members":["1740bd82-9fc3-42b3-a80c-990595a405f7"]},{"cluster_id":"64c35a09-3986-4a44-8a95-5828f2dd463c","members":["4cb31582-398a-46c1-8ddf-2854eaa9691b"]},{"cluster_id":"4c0dfd84-df3b-4660-9041-a635021908ef","members":["5f8a8580-c98a-4db6-8994-d04b4a9d0e58","bf43c495-6334-4bc0-9698-1441bfc6e8a2"]},{"cluster_id":"636b2daa-578a-4643-896b-342714f42b34","members":["4ff43d32-493b-4704-ba11-bb6a385dab0c"]},{"cluster_id":"183ebbd4-8012-4c45-ae37-eee1b7b28721","members":["8aef4794-569c-4d72-a08d-33e5086110df"]},{"cluster_id":"65f08a18-b069-4ad1-8cde-ea7ebd30b6db","members":["1010388f-1e3e-44c3-a510-abf1b78faa77","730ccba6-46f4-4db1-900e-da737dcaf207"]},{"cluster_id":"8b09afca-ca08-48bc-a085-c49c60e79592","members":["90bba792-9843-48c9-9e97-3d7085af8444"]},{"cluster_id":"e6a2f428-c0e3-4756-a96f-639a0339b06c","members":["5c1726d3-4f7c-4a82-ab4d-e8b1a118ed77"]},{"cluster_id":"dbf5db30-86b6-4686-8710-21f1a647cecd","members":["461e82dd-7599-4f59-83c6-3cccc96baf31"]},{"cluster_id":"a8cd7286-4d2f-4b1f-877f-75865a61f584","members":["231a0449-6132-4f06-970f-cbae52ee9afb"]},{"cluster_id":"17d2f659-e46b-4a1d-9fcb-605a5ebf0a54","members":["6b004ef3-1883-418c-9791-f6efd45096f4"]},{"cluster_id":"c59b0f7e-3d57-4bed-a62c-40ef9b2d80c1","members":["a88c634a-c4ca-467d-be35-25181bd97292"]},{"cluster_id":"719750be-a238-45aa-96a8-065dfd797981","members":["7aca12db-b65a-4dd7-9b88-4ba2c84432bf","bc24047c-2c1a-409c-8084-6070c6077d84"]},{"cluster_id":"6964b660-5818-4d1d-be3a-055b02c10ee5","members":["177d5bfc-b7fc-4976-862b-bd50c7e00821"]},{"cluster_id":"5dff1a24-a2b6-4405-a930-eab85cab0d38","members":["8f4ca7c4-7aeb-4e04-ae22-928a97fbbdd2"]},{"cluster_id":"e74616a0-2316-487b-b0b6-5b60062c2550","members":["31ba559f-4607-4a4b-8ff1-fc95c31d06c7"]},{"cluster_id":"fd80dc8e-90e1-45e9-b475-5c0e7ce125c9","members":["dbce0965-3a6a-44fb-bebf-62e9d85bd5f2"]},{"cluster_id":"95138155-e999-481e-8c57-056be5d97867","members":["ac41466e-8fb9-4f3a-b52e-57d3a0dc542f"]},{"cluster_id":"ca3bd404-3299-4dd4-a75b-9491f55542a9","members":["56cd3399-ff94-403e-b870-abe99d4dd294"]},{"cluster_id":"b02337c9-83ca-426b-b987-f46d1d19a244","members":["41f2951c-d0a7-4ac9-9169-ef151bcf971d"]},{"cluster_id":"901320c7-5066-4de7-b012-7a995d178683","members":["64978861-84fa-4ed8-bc86-52aeda4a8e84"]},{"cluster_id":"da38f087-665c-4abb-8af5-ed1c3c09563d","members":["b09279b2-e529-4b35-b8b1-0d90aedad64b","f2b852a5-2358-425c-b489-7e98c562db41"]},{"cluster_id":"a36a54af-ea36-46fb-b97e-4f17594784b7","members":["b5a63837-c8c4-4d64-ab33-45ea0718de8c"]},{"cluster_id":"c2d811fd-2174-46c6-9d2b-9483063022fb","members":["df2043c4-1c1e-4eff-a2c3-58e6130552d2"]},{"cluster_id":"eba751d5-5124-4afa-a2aa-48fe3f60fcc8","members":["31f0493f-3a54-4dc6-aebf-92b2c556d73c"]},{"cluster_id":"a9f14778-a0da-48d5-9d93-8fa7cd7361ec","members":["b8cfb2fa-2f84-4e66-92c7-2b808351286f"]},{"cluster_id":"a7a90cf5-cc81-4b76-b47f-bd8836b204ba","members":["46bd38d3-dcc2-426a-a963-5db999a932ba"]},{"cluster_id":"238786da-a825-4e96-9851-097b2db705e0","members":["327b4e57-b635-4aac-9dca-cb9b6ead7c78"]},{"cluster_id":"864c05a2-76fd-45dd-8aa5-97a6e22bcf53","members":["728b488b-9ce7-49a7-9117-5c9e56b28899"]},{"cluster_id":"f63758ba-bedd-47a6-901a-a2e5321c2bbd","members":["4ec2079c-6a43-421b-b2c1-7902900dd7b8"]},{"cluster_id":"90d77585-5ea5-4b42-8291-9d8389cf1b9a","members":["bb8aaf34-7901-4d6b-8e46-2d0728bcc4c0"]},{"cluster_id":"fb8a3738-fc86-4011-aef4-faadf91c1772","members":["2a9cff89-c049-4c4a-9e5f-5522c1593479"]},{"cluster_id":"077993b8-9cb6-4b90-bda9-8d4fd6b15198","members":["bb15de34-8f26-42ed-b3ad-221235bff97a"]},{"cluster_id":"71aef7b0-37f2-43a6-87de-3439a440ada6","members":["ad3b954b-1091-49ce-b778-17d438f96d8f"]},{"cluster_id":"bfe09009-b8ac-46f6-854c-5d83a7ad4a7f","members":["5fdae4e2-c22f-4c43-86c0-be6b6fa3bc36"]},{"cluster_id":"af13a573-a204-482f-aa52-9623e30fedfc","members":["c4d32fe9-81e1-448e-bcf7-fe8455ffad08"]},{"cluster_id":"f8620270-b25d-43a1-ab67-3efa1d1f6e6b","members":["7c7e2884-2e16-43ba-ae99-f2e49fcb11b7"]},{"cluster_id":"49909022-fed5-4a4d-89a8-bdf0a26dd966","members":["bfd3bcf0-a950-4f4d-8860-33af03978c35"]},{"cluster_id":"8da88efd-932e-4ef9-ba62-12fc265d9255","members":["8d5df244-0e28-4a6a-ae4d-b90dadb3a8ca"]},{"cluster_id":"4f92bf5d-f880-4cc6-a2da-cbba50d74014","members":["7a46bd74-7779-40f5-aebe-ffa7f7ea18fb"]},{"cluster_id":"db82285e-98ce-4ae9-a084-bb6101bb4059","members":["f0a4a85f-cdfb-40b1-83d4-4fcfb707d3e6"]},{"cluster_id":"7633550e-7afa-4184-8ac2-7603de1beef0","members":["c6a908cf-12f1-459b-8f33-779927db7075"]},{"cluster_id":"e91b49c0-8438-4f30-a193-2c3167f6ab7a","members":["e3ea3796-f949-46b5-bb3f-3f68dd2bbcc5"]},{"cluster_id":"99814cad-01e4-492e-93e2-a867761329f7","members":["fbf353d8-ec47-42e3-9828-31180f164c59","4409d09e-8edd-4492-9963-1938986c6ac9"]},{"cluster_id":"24b2ce3b-aee0-470f-b1ec-7fc4ce0d6235","members":["24b0b149-2595-42aa-9718-73681c300ead"]},{"cluster_id":"4ddb3ea0-b81e-40cf-8c94-adef57bca158","members":["35121ed1-891f-4881-b73c-9fdcbab4eb0a"]},{"cluster_id":"5ac2f931-1ef9-4c96-8568-845f2751d03d","members":["12d45049-de41-4341-b3a8-0b222ac2854c","afa3f769-5fb0-4994-aa0a-de98c97a7804"]},{"cluster_id":"381be24e-814e-460f-aaf7-24ebc78ab4d4","members":["4fcaface-4768-44b8-ba40-d0f6bcd6b89b","1634687c-de17-4492-a1e9-6bd2d7fd3d75"]},{"cluster_id":"168ce58c-2c86-47ff-b749-0d60377b9053","members":["34ba6106-153e-4d6a-8628-0deba86545b5"]},{"cluster_id":"4f8dc606-1036-443d-8754-a33caecd77d3","members":["240c370a-3709-4e6b-802f-cf3545dc04e1"]},{"cluster_id":"eea04632-7eb6-45a8-afd1-95556afba561","members":["77165de3-a791-40c3-8efd-b693f985ad63","da7b8fa8-4e45-431f-9e24-5baa47caaf33"]},{"cluster_id":"ad9b8529-0422-40dc-8b6b-9a712020027f","members":["ea463e10-c39b-40b0-b336-1b6fdb29a1e4"]},{"cluster_id":"701cfb5e-4d20-40b0-b06a-cb6fe171068d","members":["c1cb00fe-3502-405b-a6ab-0d448cd92e7c"]},{"cluster_id":"b224e5a5-61c4-447f-b912-3f4a296442f7","members":["b7328816-8b70-4137-8e00-c64d9f42f0e8"]},{"cluster_id":"2dc916ab-843e-4007-bf03-57e437a7dc48","members":["138c4462-87cc-410f-bc8d-2ef119d15bd8"]},{"cluster_id":"b7e93309-96c4-475e-9ccd-507fa2166b0b","members":["8acb8e9a-b980-4aa2-b9d3-91ba041f4ce3"]},{"cluster_id":"4724ac82-4846-4770-a7bb-6a4edd69c9dd","members":["45ebeebb-89cc-4ab7-b27b-7ec391464963"]},{"cluster_id":"eb9567f9-4c3d-4f62-bea9-bc557347bb13","members":["50d67449-92cd-4b37-ae42-abfaac7619f9"]},{"cluster_id":"a1ecb202-6deb-48e9-b7cd-80beb55064e2","members":["4e05695e-f1a7-4138-afcc-4cc21a904e57"]},{"cluster_id":"62c268b5-d8e3-4743-b673-44ec104402b5","members":["5252bdae-fae8-404f-9f9f-19b6a7cc8fbf"]},{"cluster_id":"e42d98f9-07f8-45be-ae88-1f54a5594edd","members":["980fc750-a12c-4d0d-99a6-b8cf9f5e7d79"]},{"cluster_id":"d918fb3a-9d62-4cdd-89a1-68fdc8de204d","members":["4b3d21da-17a0-4671-9b0c-cb8e2f09c2df"]},{"cluster_id":"d8869910-ef23-4e2c-a1a9-778ac3a96b8c","members":["42c3ca8f-6b5c-4786-8e60-b5e841dd430e"]},{"cluster_id":"f1fff97c-e8ee-45ff-b0df-2544c89e909e","members":["177cb85a-ce3e-4e46-9e38-95b1eb71a1c8"]},{"cluster_id":"75c9220d-327e-40e0-adbe-2a476a0c2f1a","members":["e1d81b4f-65e3-4407-9c6a-93128d5a53da"]},{"cluster_id":"812a3386-bb25-454d-924b-c4a0c4d57dfa","members":["33356a44-4e77-4163-bc68-3eee1fe3a711"]},{"cluster_id":"93e534a9-c780-4415-bea0-b88f8156dbb0","members":["ae81d2ef-de6f-45f3-b800-4dfb5a7bdfdf"]},{"cluster_id":"823e369f-d264-405c-a8ab-0edf1095b0fc","members":["1948e678-c2c8-4706-abc6-484e56225a6b"]},{"cluster_id":"0d87ab36-c271-462d-81cc-1e3930ab33e4","members":["bf531250-c7e0-42b2-a0b1-96e2fc7d2950"]},{"cluster_id":"7259b8c6-e5fe-4c56-9293-e3133ae377b8","members":["27d48414-b3f8-489e-973a-ad9f6fe83ffe"]},{"cluster_id":"d3c1593a-2221-4777-89bd-fb14c68a1659","members":["f5a2995f-193c-4bbe-b4c3-a69acddc8f22"]},{"cluster_id":"5dcaa7f9-db6c-4bc0-81d7-916cfd750a0f","members":["be683cad-5ff8-4916-a8b5-778dbac3fc7b"]},{"cluster_id":"0ffb9af7-6a71-4266-a4bc-ddac4a179c1a","members":["a6f4a4f2-0e5e-455c-bcd4-baf8a3dd3724"]},{"cluster_id":"aed589a1-07ba-475f-b7f3-a645da58e97b","members":["2ef830d9-9250-41ff-96cf-c32099ec79ee"]},{"cluster_id":"25505b18-cd95-4150-9d26-ae16f59d9924","members":["ea9db0fe-391d-4fc5-86d9-9c4488f46eda"]},{"cluster_id":"cb34d24e-7722-4a18-bb1f-3ff1c0f4f310","members":["fd3c6f58-c889-4567-93c5-3a56a7ecabc2"]},{"cluster_id":"160b6b7e-ff36-46d8-bcf4-e711c773e83e","members":["fa76eebd-850f-43a5-8fe7-0478ad1524c6"]},{"cluster_id":"2bd0b47a-c8f5-4e58-b230-5a58686ed27d","members":["cf19da29-e597-4a89-89b1-9ed74e22d7c4"]},{"cluster_id":"97a2e6d5-9f35-4464-ad73-ec9b3ab0029e","members":["71c8f9eb-2666-4961-a599-9dca493f7a00"]},{"cluster_id":"a8171dc6-d1e7-4f00-80c9-a3281fe32c93","members":["a60933bf-eb6d-4640-95da-e65af0f74bbe"]},{"cluster_id":"ea25dfa3-b506-4476-b1e0-0c164e97dea2","members":["12468af9-c3a4-4b64-a4a9-df596f578bf0"]},{"cluster_id":"43152486-d4dd-4e19-b1d2-24534e09e32d","members":["1cd015e1-f4fb-4439-8be4-9db8a355be68"]},{"cluster_id":"5b49dda1-0066-4031-bd05-509e4245118d","members":["46ffce94-2f87-4972-920f-76a2e7524c41"]},{"cluster_id":"4ccf7bf5-90df-4621-97ed-669020415167","members":["97e727e7-960e-4a2b-abf7-0793ea312243","d90b6765-794f-452a-a742-a154dec3b293"]},{"cluster_id":"23bd5333-419d-453d-bf08-b1b6ca7b3af3","members":["33ae4456-5a7c-4a22-b627-bd9f9c50773e"]},{"cluster_id":"d7765332-5dba-4716-b432-1311de3172a6","members":["6e3be3bb-0b31-40c2-9c4c-86d033a52acc","3e950ab0-2b39-43ff-9a5f-062a36c00af9"]},{"cluster_id":"7206ac0e-b88d-4695-a9fd-a007b0fa396e","members":["c6ca0ef0-9643-4ec2-a666-d2c0c25f9594"]},{"cluster_id":"605679a7-417f-419b-b13a-f72296af0a8c","members":["adddaf0b-1b58-49fc-8a33-15236b222e4b"]},{"cluster_id":"878ab8c3-2760-46b0-8086-c8aa996e56bc","members":["7548bb88-0c7f-4620-8757-ff3d81ed63d3","6f7d4055-8be6-4fdc-938a-fabe5e516197"]},{"cluster_id":"2f22684c-1c98-4774-aade-6114067fd60b","members":["83dfea00-70fb-48cd-aebd-04e1dc8f1702"]},{"cluster_id":"face4903-290b-41c9-8ba8-d5aa2cfa2533","members":["fbae0e6a-df1a-4f80-8faa-70c21e501e8b"]},{"cluster_id":"84fce8b4-ea2c-4b33-883a-03817afe99a2","members":["1680d51b-a411-47ab-aa9f-fa25d53a8c28"]},{"cluster_id":"a3d2131c-63fa-494b-a0bb-572e611c5c5e","members":["72f482e4-4c9b-400e-b22c-aec5e947cd6d"]},{"cluster_id":"904668bf-4a16-4f14-9adf-79655c2a451c","members":["e9ff4476-2dee-4c1f-adf4-50aa9b1cca55"]},{"cluster_id":"a37e6820-0d6d-49d8-8dfb-fc94f1f84e73","members":["63aaf013-8d50-412c-81a0-96ec60af11f7"]},{"cluster_id":"2b4b4bf2-1300-4817-8f72-f629847abed8","members":["72f22cf7-f130-4e72-83aa-7a8643dc108b"]},{"cluster_id":"bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093","members":["f45cbc4e-f37f-4dd2-9353-0c7aa03f7174","c4ba973e-5883-4b1a-b720-9168a9331158","8b05fc9f-1aba-45bc-8a5f-875af5aed5a2"]},{"cluster_id":"906602f3-b23d-4091-b462-b74d3ce8894a","members":["038860ed-0644-4a78-a26c-ddfd467df0af","b2ba8839-0f81-45f8-8999-b2c1360ff592","35b0bed3-1f4d-4d22-9506-3ffde0094728","da2933a9-afa9-4f22-bee2-2b77b8a9c354"]},{"cluster_id":"f6a33dd1-9465-4406-a3a5-1949cd825e71","members":["97d91213-c2e1-4a9f-ad2e-c13b57d37aae"]},{"cluster_id":"6084620c-6cb7-4024-86d0-5c702f76e152","members":["c958ba33-3ea5-4da4-980c-022f38695458"]},{"cluster_id":"906d1526-e5ff-4f4e-a0e5-f30c2dfb306d","members":["2f98b85a-d39e-438e-b66a-d505d2606979"]},{"cluster_id":"2b56b1f6-1627-44ab-9460-b13751cf087b","members":["eab631c3-da72-4370-a532-a31a42572838","ff9240ed-fc40-4246-8fb4-084cf8be6aa2","21321047-f657-460f-9cc4-e78bc25fb3fe"]},{"cluster_id":"93a61a8e-4477-45a4-b63b-bc7992dad11c","members":["aba49bda-c2b0-4003-9209-e6890812b61e"]},{"cluster_id":"b6748e1b-bb47-47df-a0a7-16d2d7f95e46","members":["cbc67cf5-9419-43f3-9dc7-c44b2733ba3e"]},{"cluster_id":"b6efa0ef-9a52-43da-8c24-a3f10f0aaf37","members":["db44defa-3c36-4859-b748-caa84afa1fcc"]},{"cluster_id":"49854b0f-e263-4847-a942-d2497d0d1530","members":["67b8b108-aefe-44f0-897e-f627629cd681","0c64d8cd-4d2e-4cd3-827f-152ecf89cd6a","d9bbb9e7-9567-43cf-b61a-226860dd80e3"]},{"cluster_id":"a7fcff89-a4a0-45c3-b800-3d7861e64986","members":["6f39a42e-d0a7-4152-9012-db5be6eeadef"]},{"cluster_id":"a06923fa-5b7d-4810-97a1-737122cf8581","members":["6361e3fa-8bbc-4e57-b2ec-32d1afda5b97"]},{"cluster_id":"b4530fdc-2dbc-4670-850f-b1965eb9d9e1","members":["0d9787a5-5dce-46f2-b517-8a5b9b184f48"]},{"cluster_id":"16e2933e-aa5c-44ff-81fe-873695154b36","members":["39ef7077-d79e-4496-bc0b-3c003a80e3cb"]},{"cluster_id":"e250b185-4f74-4634-99e7-3af880f034a6","members":["289de12e-9f31-4ce0-8bac-9174a0700012"]},{"cluster_id":"e1c95bf3-b7f4-4783-af68-d79bcb7b55a9","members":["c7fdf878-5fac-41b8-b934-f21635dbda20"]},{"cluster_id":"546b42d0-5005-442c-a548-5a747146aa92","members":["c55ee29e-3bab-4ba1-bbe7-ca82e627ca35"]},{"cluster_id":"cc1a98ca-fc1c-4f29-b58b-0d99bce8b809","members":["995c7333-e54f-48cb-a82e-96fb67dc3a32"]},{"cluster_id":"d72d1fb8-e77f-4607-a953-e3e224ada7a6","members":["75cfb33e-0352-48ea-9780-f5bdda5e717a"]},{"cluster_id":"a06a1094-e3d5-4cdf-b982-d9ff6654fb83","members":["d5a5bf2a-04e3-4d0e-af38-0a7519015383"]},{"cluster_id":"8c5f2bf0-92e9-41c9-b66d-14747ba819d6","members":["f9c8fbc1-67a7-4704-a2e1-e99fec527735"]},{"cluster_id":"f387334c-114b-4f0f-8f1a-524773e4b44d","members":["97c3bcc5-ad71-4bcd-8a13-c1f3a049f14c","60700a47-9ea0-4dce-a491-4559115f0b62"]},{"cluster_id":"d5752cab-3caa-48c6-b67d-7ac6c89bd054","members":["c9333206-b8e8-4ce9-b191-0ffd93b8118f"]},{"cluster_id":"2ec09e70-73d9-4395-9c36-0dbcac034464","members":["39b41e96-06be-47c3-af2e-77866a296fea","1ca9b445-a7f1-4e4d-a7c3-b2b10215d91d","87749de4-8e3e-4246-b0ec-0e253eef0c89"]},{"cluster_id":"ee29d318-fee6-4bab-9dff-20d633b0297f","members":["6d170253-a0d2-4d39-9138-c5d4a72fde42"]},{"cluster_id":"c1a62eb0-76d0-46fb-8060-6353e7306396","members":["92151bb0-7996-4fac-9dff-54ae5c2b8076","18930930-1a7a-4b78-b149-ff1350f161e4"]},{"cluster_id":"f13db706-0347-473b-9857-0fcfd7adeb37","members":["794b08a1-59b7-4f7b-9499-7fbae5270e8a"]},{"cluster_id":"a0a3d302-3c42-4ec6-a980-2d9ce3d3fb0d","members":["378fa6ea-1c37-4b64-99cc-af69758c9482"]},{"cluster_id":"a23c75f5-2cc2-4ad3-bbfe-8878efe773ea","members":["dabcf4bf-2b03-4def-901a-62f22fac965d"]},{"cluster_id":"c21a5302-b063-4bd9-9ecc-b34fe6ec8594","members":["aebd57ab-6dd7-4b0d-a553-681a4786cb36"]},{"cluster_id":"72e8bf8f-e8db-4e42-bec7-0ed7ee61d61a","members":["018d1ede-175c-4fdf-8470-711815c56a6f"]},{"cluster_id":"f3475e22-43a4-45ea-ad6a-fe7e7accc82a","members":["87364eda-63bf-49ce-b81b-f809767d1673"]},{"cluster_id":"6b75ad73-0fd7-443a-b60e-840a237907bc","members":["608fbe47-ff8c-4b68-b402-04fc938c52f5"]},{"cluster_id":"6e55b53e-064d-4b25-b79e-bd27aee62abe","members":["1903542d-2ade-4a19-9eb6-1de53f3b5652"]},{"cluster_id":"e7c86122-ad9f-42c0-8185-4eb16e495061","members":["4f751d6c-aef6-4e8f-a7d8-9fe179abe261"]},{"cluster_id":"4dc44ea9-8d2b-4f60-a0c5-d10d5af77cfb","members":["83361a24-6725-4af5-bba8-d7dd76c82c5b"]},{"cluster_id":"0e2a258a-cc1c-4d20-82ea-f1ebf02f74b2","members":["fb00d190-2fd6-4778-863e-7fc44c538a44"]},{"cluster_id":"3f25c082-1585-41e9-8842-37a9e6419694","members":["3910d908-f09d-460f-8007-dcc095faf253"]},{"cluster_id":"bad03c04-e50b-426c-824a-ff2c1f2c20d8","members":["78373792-dfb0-44fe-bd62-df4b0c3a7776"]},{"cluster_id":"aaac8e79-68d5-45a4-b3d7-7bcd6881a93c","members":["7c73d6b8-d639-4da0-9d65-d9d84007a99d"]},{"cluster_id":"d9b685c8-3dc8-407d-b009-8b6a472fbfe9","members":["e00c9545-9529-4da3-b581-5296167763f0"]},{"cluster_id":"fccc5c68-3c5f-4b2d-8103-9431b0c4794a","members":["084941a3-0dfc-476c-b4d7-5fe00f7d1222"]},{"cluster_id":"008cba92-e4d7-4655-90ad-12cb214fe197","members":["fc9424cb-6ac1-4c16-a4cb-6b301d640d6c"]},{"cluster_id":"83578f15-2ee2-4dd4-ae7f-b543ba5e2a87","members":["cb886c61-9b24-495c-af33-773416babf42","699a4af5-75d6-42db-a04f-798074f56283"]},{"cluster_id":"89ca7fbd-adb5-4425-9a07-78efe99244cc","members":["e59c9a36-25da-4583-b301-8b536a7a6a5d"]},{"cluster_id":"7681cbe0-1efe-4edf-b906-ebf02351325e","members":["fa16f634-12a6-4b65-ba49-51dbe1ac2549","a5e6f28a-ffd1-43ba-ac54-e6d89fb9b787"]},{"cluster_id":"66d5fd65-8e6b-405c-9801-c7ba78bd49a4","members":["c1389a43-915a-4c33-a0a1-07e3063944c1"]},{"cluster_id":"65c190b4-386e-49d9-9ce5-a5d89e355ede","members":["aa6572aa-aad1-495f-9010-60dea2946df0"]},{"cluster_id":"c42e5196-2b49-45c0-931e-85ce5682f952","members":["dac912ef-7f2f-4e85-834c-b0b208f705bf"]},{"cluster_id":"c2b35258-6b6b-4618-98dd-3efdfd8152a2","members":["32a5e08d-a068-4ab9-83cf-7712a622f533"]},{"cluster_id":"72ffc77d-60b8-420d-8327-cb12019a9c56","members":["9dd8dd34-cc32-45cf-a8ab-06f7eeba66ca"]},{"cluster_id":"5a5a1e17-8382-4005-9268-9165cf015b00","members":["666548b4-4b73-47de-bd9c-9d5669fe9239"]},{"cluster_id":"4693632f-2c46-4370-bcbf-41570c0b3112","members":["0216cbda-8ba0-4a88-b35b-782f37194994"]},{"cluster_id":"91a996d6-946d-4317-a60d-c7b9088e7854","members":["731bb2e7-f349-4150-8d45-c7a663dc4e1a"]},{"cluster_id":"be17c081-a4ac-42d9-b909-7a4f19b8160b","members":["239443a4-d8d6-47c5-ac36-4a98580c9e41"]},{"cluster_id":"bb09aa05-ec64-4861-98cd-96845b502414","members":["e0001ab0-ea1d-4131-945c-8d9a05240394"]},{"cluster_id":"2f6c2f5e-a3c6-4ec4-93b2-6127b5c87ee6","members":["dcd3d9cc-a3f7-4de1-9f89-e1aa2e2c4da1"]},{"cluster_id":"b217e8fc-9e97-45a5-8767-f4c21e8e0b4d","members":["d8fd4d90-e8e8-4f0a-b95c-466cadf04a04"]},{"cluster_id":"9893c9eb-e787-4810-bf5b-6340ac0c0c07","members":["e0253ed0-24e0-4426-b0b9-9bfb63ca5111"]},{"cluster_id":"78c6a4d3-5529-4139-b6cb-7f76f21ff807","members":["8da00518-0a95-4f45-b6bc-4d2e0e85d560"]},{"cluster_id":"4aba8ac6-afc1-46c8-8568-0d2d6d6bddaf","members":["82514ec5-9684-4e7e-b8c3-3f9261e8c203"]},{"cluster_id":"f29c8da8-dc4f-4133-97b2-dbe8a7c642b2","members":["9bb85cec-e218-42dc-8d26-2028bdd2d6c6"]},{"cluster_id":"7c038a6d-dd5c-4d1e-a387-d5620daf9907","members":["e661d56d-02cf-49ac-9ae4-5dfd32f12de2"]},{"cluster_id":"83537dd5-17fd-4fd5-9899-58a782adb8f8","members":["26f38863-34a4-4baa-a6bb-528432254308"]},{"cluster_id":"a3899865-60a9-4162-9d1f-4bd867347d37","members":["f35aab89-abde-48df-90da-f4bc0871106e"]},{"cluster_id":"82f5beda-b460-413d-ba52-232c56bac459","members":["ee46c6d3-5649-405a-9bfd-474650c7f68b","53352fb2-8c41-4ae8-ae51-998a77fbdfe7","c81bbf61-f731-4178-8ce9-126dc09503cb","6830bac0-33f7-4f3d-b9f4-50a6770990b9"]},{"cluster_id":"42e92742-8e3a-4799-8e99-5faf8bc31f82","members":["89df43ba-e28b-4105-adea-e98ec69e07c8"]},{"cluster_id":"5342c103-f887-4c11-8002-61b16e22dc39","members":["ec19c603-ba0a-4451-82ce-b8ac2bcff24e"]},{"cluster_id":"edc9ab41-cf63-48e3-8098-f84524398358","members":["62bdd436-24bc-45ee-ac5b-deaa1f9d4b13"]},{"cluster_id":"b2e6976f-e5a2-4669-ac3d-3e87cd376f99","members":["78f3ed54-d775-4796-b00d-1a7d215338d1","e82efdc4-5571-4b8d-9765-cd146c3dd097"]},{"cluster_id":"77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf","members":["c23caf4e-5a67-448f-a6e9-5b10ed0837a6"]},{"cluster_id":"455f3cb3-d253-4739-8dfa-e88137f7f063","members":["645a89bf-77d9-4f28-b0df-fbdc93a6b911"]},{"cluster_id":"9809fa62-b9bf-47df-ad2e-8fa4d84399c4","members":["48555f17-882d-48b9-a03a-0c1a3711c0e6"]},{"cluster_id":"c498b99d-fbf7-4e48-9c94-6d92541e239e","members":["3226a3e3-1e00-4386-bb16-3d567fba77f9"]},{"cluster_id":"2e4008f0-4f9e-4c2e-bf84-cd19c2b3f87e","members":["2b0b5fe1-bfad-4c0e-b5e0-76bf9af80f36"]},{"cluster_id":"acf832a3-5be5-4fad-af20-2e71b7b538f5","members":["4ae84f5e-59ea-487c-b407-5bfbcfe9d271"]},{"cluster_id":"57c8d119-9759-4d0a-a7cd-9c98d4429c3f","members":["e86761d9-fa89-4480-bf36-115dfe98c6b0","970d01a7-2623-44ac-9bc2-138a3179e97b"]},{"cluster_id":"adcf9b34-2bf2-44ce-9216-0201823c4649","members":["ff67ba3b-46c2-42ff-be54-e2eb64f3b42b"]},{"cluster_id":"c7723f2e-2c6c-486e-98b5-302326a9be1e","members":["fc9b5ba0-b2c6-4fd3-bd70-03456c965cea"]},{"cluster_id":"d62a8641-ec0a-467e-8fc4-ccff76b670f1","members":["f1dfc5e7-8a60-496c-9552-9ad86c0f72b0"]},{"cluster_id":"44105fe2-7f1b-4985-910c-f4a271b0cca1","members":["5ee678f8-8298-42b2-8c29-48e1c8f13db1"]},{"cluster_id":"59ccfd51-c23c-4ddd-9244-d1ca28b0c8b8","members":["05a00692-badd-43b7-97ac-20a484aa8c2c"]},{"cluster_id":"171d785c-3288-4a8a-90f1-9e6a8e012955","members":["53b8ba4f-0b4e-464a-b32e-a2a399aa2f36"]},{"cluster_id":"aadbc964-f981-4ea2-bc24-dd4cf5de086c","members":["d7a3fe53-881e-4eff-bd66-7599825f5bfa"]},{"cluster_id":"ca172ee1-fff6-4049-a2d4-1e377d7e0cd8","members":["bfab812f-f35f-4434-b8c9-931f6a095d07"]},{"cluster_id":"fa141cd8-01d2-46a8-8dd5-b14aea438fec","members":["99eab8ce-9692-45b3-8ef3-e1c6be42f203"]},{"cluster_id":"a5d008c6-c15a-4302-aa70-e916c52f5451","members":["f0bbdab9-ccc4-4a48-8e87-69328f9d2cec"]},{"cluster_id":"e18afe50-8e61-4915-8745-6256e6a782cb","members":["bac2779e-65a3-4bb1-a15c-5896e1b277ea","88903702-9d9c-4e73-add2-00c128a3b948"]},{"cluster_id":"1604ef4f-6382-4413-9253-925958021968","members":["7118efe7-4a74-4b7d-9603-c9a06dec22b7"]},{"cluster_id":"b0bd2a7e-c0c5-4afb-ac21-777cf1d80964","members":["56e832cf-c75e-4b19-b939-958843af5e48"]},{"cluster_id":"b7e82711-b99a-4580-8fb1-a7b6465b462b","members":["d076e1e4-cb01-4830-b778-89ad0d5d2d0f"]},{"cluster_id":"933d50c3-dd0d-4b5f-9957-22bbcfcc55d5","members":["6086d3ec-6e14-4e5a-97e5-abcc68acd1ba"]},{"cluster_id":"2ff5212c-713e-4d80-b0b9-c7f306cf69fb","members":["b2db9a74-3810-496a-8336-83ee8026fd39","8f9b6c6f-e4b8-4d86-a137-ec8c58e2c655"]},{"cluster_id":"d8aa6d60-fbe4-466b-a7f6-c42801792185","members":["c0543dc9-93ec-4472-b679-5a93806f0f77"]},{"cluster_id":"8a24a294-bd79-41a9-b04a-466874226ecd","members":["b0ad41ab-0fbe-421f-b0f8-b5820cfab9cb"]},{"cluster_id":"a4887daa-dc3f-4a40-83f8-3598cedca9f3","members":["c21686c5-492d-47ed-a7dc-74dbabe21e49"]},{"cluster_id":"14fc8edb-0dea-4ae6-b573-ec0c5512391b","members":["8509f258-1a84-4c3e-881d-8e34fe030827"]},{"cluster_id":"5e3b2dc6-8e5b-4236-bdd1-0dbf9bb9618c","members":["4c13fa25-8bb8-4651-b117-8c16579c165d"]},{"cluster_id":"ce807753-2437-4a69-9e26-d1ab69fdd2c7","members":["4fa6e076-c198-48ad-ac22-9996dcaaaac6"]},{"cluster_id":"2c8a535e-7913-4f01-8d69-eb8f7265032f","members":["bd84f781-f0b2-443a-86c1-1de0da98affc"]},{"cluster_id":"5a95085b-b1ae-4847-9e04-b0336ef06ae4","members":["2e6a3ac6-876f-4bdb-b5d6-ec1962d7cac9"]},{"cluster_id":"52f03b57-8fb1-4ff1-8eda-c0d228097a8f","members":["aa4c4361-bd70-4c16-8b8d-a8d8e16e8564","d13c190d-6b0f-4280-82c0-547610a559a4","4c69ec36-cf69-48e0-9359-b8cb2ff98b4a"]},{"cluster_id":"345af148-94b5-4202-924c-3b3712e4cb8b","members":["083b147a-37da-49e9-b89b-80b1206f92f3"]},{"cluster_id":"75cc70a1-5be7-40b5-9ce1-1497b1ba2474","members":["a9730833-1cbc-41a7-981f-380069816fe2"]},{"cluster_id":"5301f4d4-e78b-423c-a3a7-ca0fb632a3d4","members":["77fe070d-3c75-456e-b8eb-3b2323bec095"]},{"cluster_id":"f2b5a4d3-d094-4fa0-812e-4687bf81efb7","members":["45bf98f3-dfe7-4c7b-805c-f5a4309f585f"]},{"cluster_id":"bacf6a38-aa68-4722-a54e-dd8b9dbd45eb","members":["d77df6cb-bf52-4891-bfcb-2c327a3ea055"]},{"cluster_id":"3bda9d5f-2f9e-4086-90e5-207bbda0f725","members":["9cbaf22f-5db4-42dd-8dc7-b3aee930ef0d"]},{"cluster_id":"978027c6-a544-4944-bbb9-ca0424967ff9","members":["68f4113b-fa65-47cd-b9c9-00630b24aaf1"]},{"cluster_id":"bbbc8b46-d558-43ec-8e55-d7d72928442c","members":["7188e349-5551-48b8-a82d-ae8ce0e1608b"]},{"cluster_id":"ca1ecbfe-0a58-42df-b1c6-c31ad13d1a11","members":["1b4f37ec-096c-4542-a2b5-2e6328a8fcb1"]},{"cluster_id":"e8d4709f-937a-436c-a2c9-ff8bff8819ca","members":["234107a1-2d51-40dd-86d6-b8887f339749"]},{"cluster_id":"634b7e88-e0f0-4f5c-a26b-6d9e0a0fdc06","members":["a415d643-ac0e-4216-a102-a2f12264e028"]},{"cluster_id":"c3de0789-c302-4248-804e-d8d020c50634","members":["f4e17a2a-d83f-42d0-9c98-c8b76a75a3e3"]},{"cluster_id":"31fdbc6b-e989-4270-9e66-1ce2fea0d717","members":["2e545ac9-0408-49ef-acbd-eebc010bc0f5"]},{"cluster_id":"145084b8-39a8-4c53-8295-e697e796d433","members":["28e872e1-54c2-4629-adba-821071b37393"]},{"cluster_id":"3f86eb67-5a60-4e67-ad29-e4342d8dc8d0","members":["1474e2b8-6074-4173-a8bc-660920f8d84c"]},{"cluster_id":"7a9e1845-1b7e-4301-8581-ef30d33ccad9","members":["c0708339-d06a-4d2f-9640-e90ba5065484"]},{"cluster_id":"bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c","members":["161af1f3-b533-4865-8e8b-ce4e87edee12"]},{"cluster_id":"a0a7051e-2d37-4a4c-b40d-aaf1f0558e1e","members":["1b943fa2-7492-4be5-baba-7b276458d36c"]},{"cluster_id":"619f9470-2786-4c4b-9f38-8e5494785aa1","members":["57f00d8f-79ab-4e3f-8432-c5cd5b080a3a"]},{"cluster_id":"21ccf4a0-84dc-466f-876e-46fb9c86c380","members":["82f8df41-62a4-4c60-b1e2-3bc51397ef77"]},{"cluster_id":"c442364e-9f75-4af3-92da-fc9202b13019","members":["42f69999-16fd-4192-8a90-6f4a9bddb2cc"]},{"cluster_id":"bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de","members":["54fa120c-bf41-4acb-b703-c002ce29bfab","e4684dd9-7a98-4f31-a99d-dd05c67773bd"]},{"cluster_id":"4c182f86-5af5-4552-bee7-286b991ac0b1","members":["9dc120af-a0aa-4d5e-aef0-3f64615ce66e"]},{"cluster_id":"53a74c73-495d-4f2b-8724-c28415d16065","members":["857d79b5-d04d-4378-b6e2-21108e81bec5"]},{"cluster_id":"076ca314-f50f-433c-a148-2b657f0a88ab","members":["c024f0d5-d740-4ee7-b9e9-22987e13f9d0"]},{"cluster_id":"cdca7f1c-2f77-48ee-ab2a-8828f905776a","members":["ddf9fd9b-4935-4514-8aa2-b4fba931d670"]},{"cluster_id":"163b9274-a266-4214-8b63-6426a20ca29b","members":["396eedea-a0df-4b80-92de-3d9452c164c8"]},{"cluster_id":"0a2a726f-5f3f-4312-a1f1-087729dc4991","members":["3fca0deb-dcca-4917-bbb1-c4081d0a8912"]},{"cluster_id":"442ff222-51e2-4836-a92e-ab5d99d9d014","members":["eed0a2af-58e6-4bfd-b251-a9afdf857973"]},{"cluster_id":"413ea174-815d-4e35-9f99-9c6c2ede588d","members":["b95db0c1-f08e-47e0-844c-fdcad8e31dd5"]},{"cluster_id":"2148fe37-01cd-4114-a714-3d111387b22d","members":["a6bd6b25-ba3d-4850-b5c2-8e0287cff121"]},{"cluster_id":"b866ed85-f7f0-43c6-a093-04cf15808999","members":["4aca75c3-c165-4f17-843f-046db2679cc6"]},{"cluster_id":"c1a9feb3-4c0b-486b-ae22-214c44a6619c","members":["8f7c65bc-aaa5-4afd-afb0-4e3edfa22f58"]},{"cluster_id":"1fb4e8e5-4760-48f4-95b8-9dd118893a35","members":["4af8450d-2bb0-437b-8014-0cd241e50d77"]},{"cluster_id":"f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d","members":["0534fdf6-a82b-41fc-b06d-21e023f1ea24","c29e77b6-be2b-4ba7-85e6-435b4a27cae4"]},{"cluster_id":"ea0b1b6a-993e-4153-b0a6-ac182d884071","members":["86a14342-af6d-4056-aa63-8dcd47006a73"]},{"cluster_id":"8d281258-aab1-4ac7-9451-b7a3fe4c46e1","members":["164abe24-6e10-49b3-ba08-593644130278"]},{"cluster_id":"4027d10f-7288-4413-85e7-b5b47209b817","members":["028b5959-8bc5-46f0-809d-c6469b06172d"]},{"cluster_id":"8d5cbaf2-a64f-4a10-8901-a0b4a2c4582f","members":["55bb880b-433a-4f90-85b9-1938e89ba0cb"]},{"cluster_id":"85fa8f6e-2724-474a-b5e9-bb6b9d49d126","members":["39f5ed96-dc5f-4d39-839b-6d6e5c18be9c"]},{"cluster_id":"48881067-b084-4793-b8c7-6423be69c261","members":["4fcc8039-7dd5-48b5-b18b-3c35026981a3"]},{"cluster_id":"9997ff9b-fea6-429f-b5df-1f0640f5b200","members":["22c8c250-6974-4ac0-a7bc-85c57fa97817"]},{"cluster_id":"ee8407f3-3b78-41fa-b305-9976663fec3b","members":["b1bc7ef5-ba2f-4ac7-9441-542d10fb5d51","15d90801-1802-47bb-85d8-7cf0a6dadba7"]},{"cluster_id":"5ee42f7d-842e-4bca-a9c2-795ed9870897","members":["900f0d59-882e-48bb-8068-faadd341686a"]},{"cluster_id":"802c356d-4c20-44e7-ba85-44dda5294d0b","members":["2409363a-85ec-4eec-b018-6d215e71357f"]},{"cluster_id":"6cafd456-d229-4e09-abf9-1632d52f0462","members":["4fd10c59-57d3-4f84-ab30-85e11a35ae70"]},{"cluster_id":"2697eb78-b9b3-4edf-8af3-5b14bcd8c383","members":["a0532d2b-b781-4d22-b19a-f140e497e286"]},{"cluster_id":"da7d71b1-1db7-40cb-a127-20a20d4dc377","members":["62f432a4-e789-437b-ad39-5d0879fde1b7"]},{"cluster_id":"a61f9905-7bda-4da1-b019-fbc601e92e05","members":["ec45dd9c-8476-4ca4-8716-3447aeaaff68"]},{"cluster_id":"88531805-ef1f-409a-a41f-4692202b9686","members":["d7517e48-9bd4-49ba-8321-6ae9a929e42a"]},{"cluster_id":"a5d764cc-6bfa-4c0a-bd16-68401768ed12","members":["83e941d2-2d4c-462a-ada6-2662be655124"]},{"cluster_id":"21b3b67f-1874-443c-9458-d23200b40680","members":["023a3a03-92bd-4dfa-b4d8-ed4ca639438c"]},{"cluster_id":"f6d51725-748d-4605-90f1-5a35204e66b9","members":["4355567f-f64b-428f-940a-54888926dacf"]},{"cluster_id":"b7c58dbe-be1c-46e8-b987-6a07d4c0753c","members":["2d7d05b8-6a8b-4471-896c-1e99aa152da9"]},{"cluster_id":"9a51f01a-20e0-4f51-8758-8480254254f0","members":["2f787b43-5648-40b8-af1a-ce6489975e0c"]},{"cluster_id":"bf9a8cce-4cc9-4b37-881c-ca94d761d671","members":["fa2510b2-5e3f-4313-95b0-2440af717372"]},{"cluster_id":"bbc52822-dc9f-42d5-a92f-f6eef341a6a2","members":["c13298b9-61bd-4a7a-96f1-e75eb5933ea9"]},{"cluster_id":"a2109d36-1708-4075-ac3d-fd40a7eea59b","members":["b18559d0-6625-4df8-84f6-d6b9f030e6f1","37e8e1cb-3b0a-4a97-ae1a-1e27ff54f208"]},{"cluster_id":"ff62f156-1b54-448d-8c41-0514a58493a5","members":["7f59b6be-620e-4011-a17a-e99f10acfed5","3ac93f54-f31a-40c2-9c9f-89c85be55235"]},{"cluster_id":"bd072c00-533b-4c4a-918b-097a11abe63b","members":["df28a2d0-2357-4af3-a4f5-b4f636d4887c","e4816de5-8656-4e3a-8adb-cc3827118755","d4666577-80d5-4393-af93-c3c07c2fd745"]},{"cluster_id":"76b14a04-38e5-4c33-90b7-69079246c4ac","members":["6d57745f-f537-4a34-9959-ced8d105f77c"]},{"cluster_id":"1da0b887-e497-4790-9c97-6324fa7f1453","members":["e8111f10-d07b-4362-a05c-fd60042d4a9e"]},{"cluster_id":"f8fb52b1-aa75-4179-86fc-79c103280f3b","members":["29a4e505-4099-47a6-998e-2154a79c4650"]},{"cluster_id":"de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d","members":["cbc20e83-8597-40f4-a223-ff847caa8763","cf7aabbd-5f45-4051-a00f-aaaa4b74a45d"]},{"cluster_id":"ae3d775b-868a-48c9-b712-67b58ccbee8a","members":["c73d8b2c-c98d-404d-b0eb-4e7f458a1c68"]},{"cluster_id":"810e8947-ee09-42d3-8a66-c23cbae93d9c","members":["265d0497-7c7f-4aaa-97e5-c3e3f9b9a5d9"]},{"cluster_id":"636f9424-425e-404f-b45f-941b15951311","members":["9021bbcd-8ce7-4eeb-91ac-db6bedfae0f6"]},{"cluster_id":"913d6094-0602-4c9d-90e4-9e574b9a8080","members":["dc87d64e-7133-4ab2-9822-5b4dad563276"]},{"cluster_id":"f1ae2273-40a5-4bb6-b66e-75189e06260e","members":["b5c3dfbe-a902-4930-9123-0e9d9bfb1f9b"]},{"cluster_id":"a16ccc88-94c6-46a6-bbdf-ea9f1e6f5d27","members":["305f1c79-5f44-45b3-8aad-5c5125a53dda"]},{"cluster_id":"58be16fc-1f91-4a69-b73f-64ff2035e54c","members":["947bd4ad-0681-4fcd-917e-bf454d698358"]},{"cluster_id":"f069a0c9-4a52-495b-8bf9-3f4d61e51c06","members":["86a5d119-e0d3-4b14-9574-eff13e1bba20"]},{"cluster_id":"b799c029-2c45-4feb-9700-47996ca8a80f","members":["fd1ae651-a295-4fb7-aa7d-e0c20925c0b3"]},{"cluster_id":"1edce2b9-2c90-4e50-8469-6e4fab4fa23c","members":["0ce6df1f-de08-4e37-81dd-b059d2f9a721"]},{"cluster_id":"fa749b08-cff6-43ee-a52c-6c982c75d42a","members":["3813ea57-62ec-4431-980e-559b659d3259"]},{"cluster_id":"9528f35d-9b68-417f-b3ed-2c5b3d1cbe83","members":["9376e72a-49a8-4fed-9912-59965f0d4884"]},{"cluster_id":"8d7a2b69-1f50-474a-969f-950408a29268","members":["5c8cb8c9-8ece-4977-bcbd-d2e4cffc1a57"]},{"cluster_id":"71b00bc6-170a-45b7-bfdf-40d740e90b1e","members":["caef5161-88f8-4f7b-b0bf-bac754f2b8b4"]},{"cluster_id":"de89e6b7-8aa5-4a9d-b8b1-927da0ac9c8a","members":["35e13dd4-e5b1-46f5-9779-5910c9c89ff4"]},{"cluster_id":"8822fa56-959e-4020-ae70-4e0f3f35f8fb","members":["bb4557ee-951a-432e-aeb0-b7ac0227446f"]},{"cluster_id":"48b7513c-41a4-4a7e-876a-36f9b1eed5df","members":["f9cbbdaa-f4dc-4f8e-814e-576477baa645"]},{"cluster_id":"16bcd20b-c8b6-445d-b90e-bca2498ccc21","members":["fbd73d33-2ca0-4697-9ee8-edf14741a73f"]},{"cluster_id":"115fb915-b1b2-4ede-81d0-20680b7749d3","members":["c2d956be-c010-4d63-8ca4-73abb047cd6c"]},{"cluster_id":"a1f52faa-345a-4142-abf0-5bc06a645050","members":["4870f0af-991a-4d27-a5f9-cef54f4d7d80"]},{"cluster_id":"6870e10f-72e4-4775-9bf6-5b40e5853931","members":["09cd458a-ad60-4918-b2d1-344d0996dbf0"]},{"cluster_id":"f9418d59-cbad-4bcd-b387-fb25a67389fd","members":["ec955636-b8ce-43b4-bdb6-4b52b0f60f67"]},{"cluster_id":"7b1f2cfc-5328-4132-ac99-4d91818f60f6","members":["8a6f7da5-6f97-4723-b387-160cd81f8eaf","816a5a49-d869-42ce-80e4-5a2519321ae8","86c1ce58-0a09-4472-aa59-6b6e3cde7f37","abf56087-ecd6-4e4c-ae65-1897149ad7e8"]},{"cluster_id":"e5da69ec-b7e5-4fec-8bae-3161bd3d02ca","members":["fe0ab7d0-5acf-42f6-8d11-4410eb81005f"]},{"cluster_id":"0c283d46-2055-4ab8-8bbf-4417f6667e86","members":["70741f36-330a-4765-a621-855856897516"]},{"cluster_id":"aecd93e3-f175-4964-b3d0-1a8c1e2832bd","members":["901090a6-06b9-4600-b248-c7bc52f2b33f"]},{"cluster_id":"87bd589d-2421-4528-b337-18cde30c4d49","members":["391f37e2-a85d-4207-991b-bc64b2b1d453"]},{"cluster_id":"58061e14-9c6d-45ae-8c7f-48a44c7f7cb0","members":["73bbc6b1-7507-43c5-b47e-df9f5a3fa756"]},{"cluster_id":"276946c6-5e3d-44d2-b7e3-410789a74a81","members":["e4614d97-76f8-464c-87e9-5e00cd0e98a0"]},{"cluster_id":"4485e5d3-efcb-4d42-a185-349293bfd550","members":["2df72a4e-2d4e-4310-8419-dd7b8caee3ae","b1a14284-7971-48a7-af1e-919877929a63"]},{"cluster_id":"7f659049-c3cb-424c-9dbd-559d942783fc","members":["12287211-b799-467b-ac65-9921283f2620"]},{"cluster_id":"060c1552-a1b7-4db4-9a85-766d6baf3560","members":["ee8a9520-1592-4aa6-ba78-e6d3348a11c9"]},{"cluster_id":"22e69426-c76f-4b85-bc81-16af4106a7bd","members":["e4a17a8b-1a7c-4da0-9e91-f1c49111ee2f"]},{"cluster_id":"6c942642-582b-452c-868b-03a353a6eca9","members":["942c17a3-a28c-48b2-8150-0f346cb8a272"]},{"cluster_id":"7b4680b9-9676-4736-8ed2-d06a2da6ea63","members":["5d144e6c-0172-4295-85b0-d471a3a7359c","0ace144a-883d-455f-a69f-7c95f297209d","0151bbcd-c972-42d3-b86b-cb399c6266fa"]},{"cluster_id":"b9db86cc-1622-42c5-b482-396c3c7c7bf5","members":["f3edd9ad-4e7a-42e5-8560-e4a8141035fe"]},{"cluster_id":"bf638672-92b8-4f28-a31b-d9a286145b07","members":["dbb7b443-25c7-4477-97da-b099f151c261"]},{"cluster_id":"442786eb-7f1c-4cbe-a22b-05ba612dc67d","members":["17f13200-d0c9-4962-867c-9258ba566722"]},{"cluster_id":"a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4","members":["ca06531c-e8d4-44b4-ba96-588241c99fb6","2cbd592e-9b27-43bf-9981-257b2c95850a","a00993e4-3a22-4689-a941-c00084c02859","43f76c7d-f08f-461f-a904-091ec5f12488"]},{"cluster_id":"dc5ed306-20f0-45cc-ac9b-9241d0460c7d","members":["62394e44-2e3d-4879-b2f4-addda51d3474"]},{"cluster_id":"b1c61f13-8002-4105-a62d-ec7191746e29","members":["363e6fcb-13c9-405b-ae89-318d01bdd863"]},{"cluster_id":"9f4c8f09-a6ba-4b36-a260-db32b470a2b5","members":["6d1072d3-bdb2-4476-816f-6ec12e977fca"]},{"cluster_id":"c56ca589-59b3-4908-bbf1-fd162bba08a0","members":["b4480d63-fe94-4e57-99a7-30518a54dae6"]},{"cluster_id":"d14dd6b6-ea0d-4827-8ef2-ba250811ea5a","members":["bd644c9c-610f-4fdd-aaa2-9b1398d9bfd8"]},{"cluster_id":"88549cc5-91d9-499e-9367-819f2a75e847","members":["98342ee6-0977-4f0c-a3dc-0e09f0b6f30c"]},{"cluster_id":"36d77123-4871-42ae-b0c9-6b46e2bd9d65","members":["17b5c061-8a0f-4741-9e55-8350b0a6f7a8"]},{"cluster_id":"e92ede91-314d-4f91-a23e-b6bfa200e224","members":["1c0e90be-fe07-4fb5-8eca-8fa4a9d63345"]},{"cluster_id":"bac9b430-6b59-4b93-ba97-75f0f7b39814","members":["ee3fe76a-6f8c-4313-8914-17a0cbce118a"]},{"cluster_id":"5b9f78e0-35e8-4e52-9ba4-34ecb628f952","members":["2fbadc7f-0a31-4d3b-974a-62946d1fa866"]},{"cluster_id":"25ed23a4-7940-477a-9165-7053b4f9330d","members":["9e1033af-514d-40d9-8043-bfcb5559e972","459611c4-0b55-4923-91d6-d7adcad302d1"]},{"cluster_id":"3a95c736-dd02-4122-9108-f00df86397af","members":["390a0f6c-3271-4d89-9def-b9099ca6d093","fe6f6fa5-3c2e-4e35-aa6a-0adf5b433b80"]},{"cluster_id":"5fd9694e-e9ba-4a5a-99d6-b32c720bbf4e","members":["f7447847-d7cb-43a9-bf6a-2a34237e6243"]},{"cluster_id":"96455f92-cde3-49f3-934d-a55b0a31ccd5","members":["4dc604dd-ff2c-4cb5-9485-c298aa8d6be7"]},{"cluster_id":"9979222f-6af5-4d8c-85d9-81f2ad80980a","members":["e9685bf6-4435-496a-aad0-67339144be17"]},{"cluster_id":"d4bc60e5-da16-45c3-909d-aa14379adeb2","members":["3cb10e35-b70a-4e35-9bc8-0b6323028162","f648189b-ffd4-42ba-80ab-e7d0cb4e0d27"]},{"cluster_id":"789c4f9a-6863-49ee-a41c-e12949429992","members":["ac28e2ea-de98-44db-b15f-8efda41cf373"]},{"cluster_id":"86797f95-8265-40b4-9a2e-f9574ce9ab8c","members":["5b48e9a1-a870-4978-bcd4-60d8b4a01145"]},{"cluster_id":"ce551d12-b33f-4043-8ad2-015e698a2cda","members":["09d00e6f-03c7-4256-a351-aa6ba0bb64b7"]},{"cluster_id":"6e9ec51a-5e5f-4dab-8bcb-01b5c15fb587","members":["5602e897-4263-40db-983e-f751d1289418"]},{"cluster_id":"c2d29a8c-d30d-4b99-9286-81917e79d3dd","members":["7bc04a5a-2610-492a-bd4e-6ac4c4efab63"]},{"cluster_id":"ed35c2c7-9d1d-46bc-b509-54389b90afc9","members":["0d1a7174-88e9-498e-b1d4-e1f4ae813e1d"]},{"cluster_id":"917875db-927e-4ac1-93db-6f7a0fd24bc3","members":["f6fd9164-7b07-4ac8-9eab-636f169adbdd"]},{"cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff","members":["6d45de8f-261e-4b0d-9624-00564698fef8","17726f06-0a1b-4e84-a2da-8c4383fc6422","70ace6f5-ba45-4bcf-8217-e6dd2bb2b27e","4e312d90-6877-4ad1-a1c5-7420a43c99a7","630ad209-9fb0-4b78-88c6-e02f76c0fc74","5462430f-9209-443c-bf3f-61c34bb63bea","204e0cc1-634d-4ed1-9f7f-d97c784c7c31"]},{"cluster_id":"e5868b04-4cec-4d02-b896-8db4cc7180db","members":["a2e6496a-27dd-43d6-bf2e-e6e5d3f3233a"]},{"cluster_id":"61c6513c-5b59-4c49-919e-b92af19239e0","members":["3dbd115e-607e-4c28-a5ec-5ca4c7dac23a"]},{"cluster_id":"03e89563-d271-4f75-a47c-92ec9575e524","members":["c176ebce-1701-4035-ba6a-31ff5c47e475"]},{"cluster_id":"6dc5280e-6875-44c0-adc9-079542d2d0b2","members":["7cb1e360-e3e6-43be-a1c2-4df98a02568d","d130f78e-0f60-4aee-a423-c35f5aaa102e"]},{"cluster_id":"08dca077-8e26-493a-9038-2f3ec565da5b","members":["e34a708e-7958-4919-bfbd-a00065d97651"]},{"cluster_id":"e1ec3ffd-db25-4cb3-96fb-b11f7546206a","members":["451fbd13-5ece-4d53-b46e-c6816efe2135"]},{"cluster_id":"6f00b5de-be1b-4233-883c-1a484844dac3","members":["7731b716-ba63-4fa8-a146-9875413ac64e"]},{"cluster_id":"2db0c2dd-c8a4-4511-9c67-695e43307f50","members":["f9430af8-c65d-4712-bf56-6735831ab122"]},{"cluster_id":"45df4bbb-00df-47af-9d05-1da924dfb782","members":["b1359cf2-e916-4c3b-951e-dbcfb91228b8"]},{"cluster_id":"220dfe6b-2774-4a8a-8306-3094dfce156d","members":["36cfd210-d06b-405b-9f24-0b95636db2a8","66349fdb-aedd-4e71-bc33-b55b90c3a03c","53f6ba38-107e-4a6a-8496-19ed4d5c8d9c"]},{"cluster_id":"4d37159d-0a18-4557-9e9a-a0401bd9cb08","members":["1bb7068b-f675-4d37-8b29-eb4ac7b27ab8"]},{"cluster_id":"e8e474c4-3709-41ab-99a8-21deaa3d6742","members":["08832f1f-1e9d-4560-bcf1-086be71ff254"]},{"cluster_id":"c75d014e-008e-44c1-909b-263543a31c5f","members":["ce180f9a-7b6f-424b-890b-5c098fcd67e7"]},{"cluster_id":"63342b93-bff9-4530-8c61-5a3714d544f1","members":["b9122ba0-8bf3-4d37-be60-68c9a8e6d891"]},{"cluster_id":"2b2effa3-cad0-4ecb-9486-b078278fd3ff","members":["94029f94-bfa4-46ce-85a1-102fb3438ebf"]},{"cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe","members":["8de55777-91cc-4500-8eb9-00391cfd1996","828a1401-a9cd-4280-b0e0-d6113ee19bfd","716847ee-a725-462c-a6c0-1f9b9b407538","60ef0746-59f8-4545-b93a-25210ec76915","0c6e5fcc-3e05-4d45-9517-055b88d7fcf2","2b6a207f-016f-41c5-b2cd-490c79cdd5ed","6a9e9c87-d858-412c-b112-3e45da1dbdab"]},{"cluster_id":"513bd779-ed11-4772-ba36-c123bfde18a2","members":["b30a890f-bb1e-4dcf-8f4a-7da32d5fd2ec"]},{"cluster_id":"1a910fe4-be3d-49ad-b59c-8197b841f3b0","members":["7c48ff9c-3572-4d1f-af8d-a28071ad3e88"]},{"cluster_id":"49a61bc5-5b56-4867-98aa-feebd5b63106","members":["c604a848-73e4-47d9-911c-ab0b2f44f9ad"]},{"cluster_id":"2b9f39b1-41ca-4c32-b583-29e0cbea9865","members":["130c0ed0-197a-441a-affe-5b87f347f7a4"]},{"cluster_id":"27647283-49db-4a69-bd08-66190d0e650e","members":["b76a8e41-ea5e-46ab-8afd-273b69e724d7"]},{"cluster_id":"d94203eb-6224-4f4f-ab68-6b9b570a960b","members":["77e135a3-c11f-4f48-b351-38a792b72478"]},{"cluster_id":"b67dd1ae-27f1-42b9-ad69-ee83a298d216","members":["91496a2d-e3b3-4b43-9df6-217b8662cc7f"]},{"cluster_id":"3531210e-caae-4d2a-9c81-92659900742b","members":["96c7ba3e-250c-4e59-a015-d908813b2161","c12ca3f8-34f3-4cef-a02d-9a0b67614a19"]},{"cluster_id":"9c8fceaa-2d0d-4f1b-a084-86587c4a2652","members":["48fdf656-134e-4e2f-947d-ab46a493fe4b"]},{"cluster_id":"a9f4e598-1ac2-4a32-9af3-12230870507a","members":["c7031f37-932e-4f20-b1f0-ad805c418d7e"]},{"cluster_id":"b680d78a-6796-4b44-a00b-5861ed074dcd","members":["4678a09c-7907-45d5-bc3c-1cf48fe82a4e"]},{"cluster_id":"916a8c6f-5ca2-4b3a-b949-ca57daf6bb56","members":["320d06c2-1801-4f37-832c-c689ba25fa8b"]},{"cluster_id":"fd5e9a15-8177-47a6-9a10-ec03f47d5abf","members":["3bfa0b44-82e8-46c4-baec-c2540f1c85b5"]},{"cluster_id":"a644befb-dbc0-4695-b3a4-09f27c71e3c4","members":["9c0a5f5b-884b-47d0-8a88-2fc8c6138662"]},{"cluster_id":"a1921f6f-8530-42a9-8f36-9fbcf1bb8941","members":["7f844310-acc5-4a3f-92f1-abac2e63d440"]},{"cluster_id":"8fea2c95-9eb5-4a00-9f7e-750ec49f4c61","members":["8504e0ca-b54f-4a5b-9b47-cf9d1a45fb89"]},{"cluster_id":"ce77bb3a-ea7f-4d98-a5e3-62e70b0597ed","members":["c1415165-6ad5-4522-a309-629f404ef316"]},{"cluster_id":"25337f06-7f63-4f2c-9964-5f855922e638","members":["d26c872a-78d8-4320-b5f2-e0033b5b2abb"]},{"cluster_id":"211a5b9b-b352-4fd9-9450-827ad138f833","members":["ad99cdd7-f0b0-4d1c-93b7-1d96068758a7"]},{"cluster_id":"53924b3c-7098-4daf-8924-cb5ffede2096","members":["cb7405f5-b619-4f66-9b7b-4d562a8fc6d6"]},{"cluster_id":"fe89ddfd-a999-4814-9bd3-b0162af3bbe2","members":["d886f5bc-664c-429c-9754-67530af6439e"]},{"cluster_id":"bc25c1b6-b24d-4cb5-9913-b54d305182e7","members":["b412355e-81dd-48f3-a462-70fd74d23a27"]},{"cluster_id":"d1e65b2e-ba15-4227-ab25-8486cb852ba1","members":["0ec94a00-7242-4423-b564-9baf54723262"]},{"cluster_id":"ce2516ca-003d-4806-948a-12eea340aa15","members":["1276b48a-4aa4-4922-aef4-4f038cbfbb97"]},{"cluster_id":"fc4a44e4-cde7-4210-b1dd-064e7cdc5fc4","members":["f6bf258c-c08e-4db5-9460-a91e3e5f12c9"]},{"cluster_id":"208620ac-11d0-4163-9345-03d59e805961","members":["ffd7678d-00ac-4300-868a-ef2229fb89f9"]},{"cluster_id":"134817e7-d143-434d-b8ad-1fa05e622296","members":["427c91a8-7ad7-4918-a7dd-f76a14ce3b91","039940c2-8769-41b6-8e24-bc42bd2df3fe"]},{"cluster_id":"d147629e-d16f-4224-83bb-da1109733168","members":["a779aee6-ebd1-4097-a98d-ba7a139404a4"]},{"cluster_id":"dac94ab4-f251-4e9f-88eb-38ea10c9b12a","members":["ffd49188-632d-4b7b-a9e5-5a53a52c624f"]},{"cluster_id":"3e73f675-0024-47f1-ab95-a4e974bdd22b","members":["af0f83b2-a044-45d7-a820-3b7af9266a72"]},{"cluster_id":"f287b9aa-9568-4d24-870b-96f86f040792","members":["69107281-2506-4b5d-ad9c-33de7589fcc9"]},{"cluster_id":"6d479b93-5e42-43ab-8ac4-7f31b557309c","members":["659d2172-0bd9-48a1-bd4e-33d1367d832a"]},{"cluster_id":"fc55be0d-bed8-4ebb-8dc7-149fb174476c","members":["835dff59-f9d8-4192-9930-64aaadcaa5bb"]},{"cluster_id":"094c0c48-56a8-4f19-bf5d-16a053900cf5","members":["a1458d74-452e-4b95-854c-fd6204bfd7ae"]},{"cluster_id":"6ebfced0-5146-4720-a35b-6dac63f2989a","members":["1e3994e0-1d0d-49d4-9d43-09c8589b99ad"]},{"cluster_id":"2c113efd-6d03-4fd4-9d94-78125d3c286d","members":["94eb1e79-dfe0-47e9-94f8-ff7b6b531e28"]},{"cluster_id":"70ddc119-0fe5-44bb-b12a-5f9fe097cd8c","members":["52f824fc-6777-4d31-ae8e-0b0d83e13dce"]},{"cluster_id":"2156a4b1-8617-407a-8feb-cc3b74e8fec4","members":["57aab8ea-02d6-4c09-b173-144d4f8c9012"]},{"cluster_id":"c99071d0-4f9f-4d85-a471-8ed03007f96c","members":["515aca24-3240-4fc9-8782-c2e7439ec022"]},{"cluster_id":"d316d167-369a-4e0d-ad58-337551778176","members":["863817b6-14dc-4206-bcc9-a6f86320d92f"]},{"cluster_id":"d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f","members":["a3460dbc-2bb3-468e-ae47-1048dcc494b8"]},{"cluster_id":"b4a34e37-e56c-45d2-8766-c4fab9d7cdf4","members":["c2044de8-6008-4dae-b756-39e02b4f336d"]},{"cluster_id":"a0b134b6-d0a8-434f-86d9-01697dedcb90","members":["98b91f13-53ee-4bf1-a84f-46cbdbe22cfe"]},{"cluster_id":"6afac47e-4bb6-44d8-a1c9-b3063690939e","members":["c1a8afb9-3dd3-4d26-b831-94baea535cff"]},{"cluster_id":"c058e393-ae39-4d59-9d56-d80b61d507dc","members":["1af3f1f6-7fc0-4f65-84c9-ab73efc8a94b"]},{"cluster_id":"d1afbb7a-8d2b-4c24-9c70-b4c56fd56a43","members":["ebf309fb-72f4-4aa8-9fce-de1b2954f161"]},{"cluster_id":"c79c59f4-8dd7-4aa0-bc2d-7d52bf8727f3","members":["a78a0d1d-fb23-486e-8d7c-31e54b1f6b80"]},{"cluster_id":"65324661-3a29-437c-9b4b-f8ea61a6dabf","members":["19c3bba1-fa0a-46fa-ba1b-60b9d8ea36cc"]},{"cluster_id":"141e6842-296d-43da-b53a-06cadf04679a","members":["9e25fe9c-a7fb-4089-b0ce-b5450684df86"]},{"cluster_id":"7378ad43-a016-4ea8-a115-0123a4bd291a","members":["138a0535-0d17-4fe8-8ae1-2165b21e315c","6a39f53a-dbbc-49de-a3d5-8a727b162557"]},{"cluster_id":"09116da3-a819-4889-967d-7f1f71fd03cc","members":["8b7f373b-537a-4a7c-9177-bce487373ca9"]},{"cluster_id":"1760a439-ca46-4fac-8653-21cfe35d860c","members":["25469249-14a0-4d3c-b927-3fcd39e306b8","951a6889-48e1-4ae7-9de3-f25591fa9d6b","c26143cc-60dc-4cc5-85f5-ea1998788b28","865f4db0-ac94-4b66-8fe3-5e5997b63fb1"]},{"cluster_id":"da21d9c5-68a7-4237-9343-1a8df452b146","members":["b9f61132-8496-4398-a695-fd09dcbf8995"]},{"cluster_id":"e3403237-7c1c-4e7a-9604-df8d11301d8d","members":["aea49fae-06ed-4218-960f-84a8e7dff779","aaa01355-379b-4cd3-b1f5-4111a86b3987"]},{"cluster_id":"c5a76746-76c2-4937-b9a7-284d0de20709","members":["3b1ac5b5-c528-4a0f-96af-d9bbc0ad402f"]},{"cluster_id":"83593077-334d-4f71-a668-e36e720c6a3d","members":["cef7cf93-eb17-4334-ad4b-619188793fd2"]},{"cluster_id":"072ba410-0f15-42e7-9ef5-bee6285568c8","members":["ba6ff167-e8c8-40a9-9a84-61f53e1f342a"]},{"cluster_id":"a263e3cc-09b2-4ae5-a252-4665ad483b52","members":["eeda927f-0cf9-4701-8464-ee83c49a371d","89c39233-7f7d-4a37-ad84-11944dc610f1"]},{"cluster_id":"113ba3fc-f5c7-4177-8c57-e763c91f7e2c","members":["bd99aeb0-773d-4bd1-a916-0b224aff6474"]},{"cluster_id":"cbcdf7dd-2927-468a-83b8-036e8a1b1479","members":["a1d27647-8ea4-473b-a900-c1a08dcc2af4"]},{"cluster_id":"71b309b2-2dda-4212-a921-75eae9813c5d","members":["a5fec585-45ef-4e77-acb2-44a4eb77e056"]},{"cluster_id":"a7c0d5f2-2d5e-4a9e-bdf4-5365c1f262be","members":["a8e91066-2bad-4046-99e9-01080c342e9b"]},{"cluster_id":"01284921-0773-415d-9ce4-f4e93b10a2af","members":["b18211ac-bc7a-480e-8886-4ea26acbfe0e","5bf0bfe9-23b1-4f8f-831b-9226d131f1b2"]},{"cluster_id":"8098cc1b-8836-490c-9e7f-17c6a8944eb0","members":["14644813-a1fa-4256-8100-1202ecc87880"]},{"cluster_id":"247c6528-f0e7-49f9-99fb-27ef047a4410","members":["6aa42f60-59db-4177-9a34-b9d050386ad3"]},{"cluster_id":"e25715ec-5983-4c68-b924-9f64b4f03d63","members":["43a98ba9-e0cc-46b6-b06f-d5ff92020ba2"]},{"cluster_id":"ec825820-2066-4bfe-95cd-b11676c4d89c","members":["18fc5214-0e1a-4582-bd8e-68e7df91da5c"]},{"cluster_id":"449fd6e4-9161-4742-8b9b-bd7cd0c9d571","members":["3c81b0a8-0ec3-44d5-9e23-b6886684a510"]},{"cluster_id":"cd034398-fb5e-493c-9a4b-be08f05b5ca7","members":["9ed245ca-3c9a-4ee3-8019-4ff857adca60"]},{"cluster_id":"1501c95d-fe6f-4129-965a-ccb56abb7afe","members":["05b4f83a-d62a-4bc4-8ac6-f243c3eca0ba","3c9347df-8ffe-420e-820c-4842e49256f9"]},{"cluster_id":"49feb97e-934e-4b78-b2c2-4acd4705e46e","members":["dbcf6044-164e-48b0-a8bb-9b20202a86ca"]},{"cluster_id":"0208ef8f-f321-4a60-8e1f-9ae03308e345","members":["495f7684-da08-4796-a97f-20763a81934c"]},{"cluster_id":"fdcc5ead-3f56-4e70-b1c1-bcb723b24f72","members":["07ef1c9d-9e02-48fa-894e-9aa9ac00825f"]},{"cluster_id":"baa5172c-8725-4cca-b3be-5d512cf618a1","members":["ee64a014-2ae8-4581-af12-44746c5eac31"]},{"cluster_id":"e7f6877c-917d-4e0c-ad46-e366c0fa0b67","members":["ab2f6972-f2b3-43ba-ad67-ccdea1dc15ea"]},{"cluster_id":"74e4eccb-d37c-4913-a081-5e2a47430662","members":["9219490f-23d2-4d56-9e71-68248cfd250b"]},{"cluster_id":"a1ca414a-357f-429e-a9a5-5290a87bd233","members":["b66fd564-56e0-4dbc-af75-4d728a3b595b","fe75fa37-84c5-45c4-85a9-0b535ade106a"]},{"cluster_id":"1e66818d-6709-4941-8387-4e813b228894","members":["cf1261a7-6ec6-4d9b-96a1-7fa516cb00ba"]},{"cluster_id":"e24f9229-3672-4631-abf5-3ab616111d97","members":["8bdd3630-0b71-4a27-9152-988a27b64b02","e70b9ad6-7291-4149-b3cb-9a37e8322e8e"]},{"cluster_id":"9a1b07d6-f1d6-4b71-a6fc-885000909a93","members":["b22c5196-0753-459c-b19e-6a661a3c6cfa"]},{"cluster_id":"bacd83d6-baf3-4811-8b78-eb961f99ab8f","members":["d5b40b40-4fd8-4809-825d-74c396c5e1c1","2d56b4cc-06d2-42fc-96ec-29e8f62f2884"]},{"cluster_id":"635b07ed-e811-4ba9-90cf-8c1aed9aaaa3","members":["17438dff-d991-4c0d-b588-21ff8e0929ad"]},{"cluster_id":"1e7fb3ce-6e1c-49dc-978d-4116378d449b","members":["a0a3eef5-73dc-4c61-8d1e-ddc2688f0947"]},{"cluster_id":"412eecdd-3e2f-4593-9b61-1dd3ac3a36fc","members":["738bdcc9-d4ba-4518-ae26-cd7d5fa251dd"]},{"cluster_id":"71c1ae12-8809-47ac-8b8b-cc34ac436157","members":["b11c29a2-7c09-4c5b-914e-bdff2ac00a4a"]},{"cluster_id":"9fe7995d-1f25-429f-b4f7-9af7bc4a7e8a","members":["c91771dd-4604-4c1c-9b41-f6f997180a75"]},{"cluster_id":"988ceba9-18e9-4ef8-9eaf-742eb7f2a4f1","members":["310da8a6-11f0-4449-846e-b764c9debe0b"]},{"cluster_id":"f0626ed9-6a16-4fce-b589-96b444b12fc6","members":["879b8025-cd29-49f3-b9bf-9b4eaa9be7dd"]},{"cluster_id":"7628ae8d-befe-43ea-95f0-6fd9a907267a","members":["52a46197-0688-4cff-bec6-ee4af2d7945c"]},{"cluster_id":"0c342dd1-f7b7-40e1-b189-103549ddece7","members":["366a6246-8c85-4924-b0d2-5b86bfc2c2d7"]},{"cluster_id":"f200deff-bb81-4d41-8008-3dc621e11aae","members":["dfedbaec-39b4-4897-a75d-46aac34780e4"]},{"cluster_id":"6904ee21-68e2-4e99-baa3-968e34cb10b1","members":["b421ab5e-bc05-4b8c-af63-8a7421ab0851"]},{"cluster_id":"51ab0b64-787d-450c-9578-4158dfeb97cb","members":["c583f936-7449-4241-a0b5-700f8583bebd"]},{"cluster_id":"a7246654-2dda-48ab-8372-7007a1d4709a","members":["0972955b-ece9-47bd-88c3-e8585e08f124"]},{"cluster_id":"bf80dbed-695d-42ab-adf5-4b079e397c99","members":["68c3d94c-0fd4-4c94-8ee5-79c9666237b8"]},{"cluster_id":"478586e7-cd47-4bba-a3e6-e954dd593a00","members":["9433cc9e-44dd-4514-a4e8-8df2fa8e65e1"]},{"cluster_id":"ad7f3e47-f7f2-4a5d-8168-7644c3de8a32","members":["06d20d03-85c5-49c3-b962-c5d05ead6130"]},{"cluster_id":"d265d5db-4035-43f0-bc76-bf5945ff3551","members":["436663dd-5aff-4330-ba83-ec791399568e"]},{"cluster_id":"f2132873-f6f5-478c-99f7-99e6e3d16cc3","members":["28eb1db8-9fc7-4f38-83d7-6cbc590f3620"]},{"cluster_id":"fa3326c6-c29d-4ee9-93ae-25dfe12b02b0","members":["1eed73cf-b401-4aad-b6fb-40dab881fd02"]},{"cluster_id":"9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a","members":["cbcc4d41-e1a4-4631-9bd0-f44199ef2491","b6853fbf-e30d-4aeb-929e-61d3239aca0d","c5cd55fb-50c6-4f51-b2f0-29fb82011b39","9fab087a-2b8b-4638-b3b9-84915e913387"]},{"cluster_id":"991efb3f-2e53-4e93-bf2d-3ba713b91c23","members":["a70ba9ce-892e-48c3-a0e0-14cce6f091bf"]},{"cluster_id":"f11e573c-d0ea-44be-a8b4-5ff5949c0ecb","members":["7d5d4a7b-f0e9-4bb2-97ed-7a3546ae51b8"]},{"cluster_id":"8984a612-a2af-48f1-8868-d5d348b17de2","members":["80e76425-e94c-4e6e-b18c-5d0e2458f3df"]},{"cluster_id":"9becb58f-9c06-4adb-8557-0a75a0444f56","members":["c1db1293-d3f9-4ba1-811b-e39f23953a4a"]},{"cluster_id":"c219e535-0099-4f3c-9221-b32e8ae0d9a9","members":["ee163317-e616-4d92-ac13-19bb01d1412a"]},{"cluster_id":"46b03cb2-bbc6-4b28-b240-16cc3f30e3bc","members":["4ce9bd1c-33a5-414a-a8cf-ddff35b9944e","93685c4c-4575-4523-97d2-ea10d32fa0e5"]},{"cluster_id":"71435cc5-d65b-4e3e-9454-ffe0371a42f1","members":["7a9c7aa3-b9ec-4447-8ad5-14f53b8a99dc","853d4468-5466-4497-ac59-9fb3906d05b5","35e718bf-4fb0-4c92-b4e1-8fb977118393"]},{"cluster_id":"a378f92c-87c9-4fc4-85b1-e22948f338e6","members":["af60bf05-c6ff-44be-bab4-82baf4596d98"]},{"cluster_id":"a4004e95-5738-4a9f-9ef9-273901538db0","members":["5ab2833b-6968-45cd-b20e-3d6a4d94962e"]},{"cluster_id":"29c87b68-66f6-4218-b4fc-f6324d0ab7c7","members":["a709cd8e-97a4-4015-9336-5bd9ed38bb12"]},{"cluster_id":"55da7c68-ac05-4727-a906-82d875d3d88f","members":["50796783-fd71-48a3-b820-83a169765006"]},{"cluster_id":"6cc59f40-7aa9-413e-ae5b-64e2c17a2e71","members":["01cac53c-ae09-444b-8c7a-4d8983acba5b"]},{"cluster_id":"ef20ba46-c8c3-4085-85f9-b312f9f6802a","members":["b16284c8-e200-4b13-9554-b82faa004f1c"]},{"cluster_id":"64ba9893-281a-4427-95d7-8ab7818e5d93","members":["c5a3ecce-7031-464f-a033-0f25096bf05a"]},{"cluster_id":"da1930dd-8986-4fa6-b320-dd6da70d644c","members":["fc9c12f8-858e-4cd9-83cf-a3e04b25fe51"]},{"cluster_id":"02b41fd0-8916-41c1-8494-482e3096f186","members":["a9642145-43cc-469b-b0d8-1de850452963"]},{"cluster_id":"9dec00dd-14cf-4956-9ce0-5f9d8647e24d","members":["cd12d1b2-fd96-4f7e-92a4-60647d717334"]},{"cluster_id":"d6e26a99-056e-4587-a461-8e9b192ce947","members":["2e788f0c-75c7-4cc1-9c6d-ab3bf104216c"]},{"cluster_id":"34782a59-6a9a-4289-8c00-12feb5c0f040","members":["7ca7d363-1dca-4657-8ef2-203fbc63b00c"]},{"cluster_id":"b4c10082-ec3a-4c01-a666-d497f9480003","members":["1f694e3e-1c2a-40f8-bbc7-36e8ce3fb57e"]},{"cluster_id":"1dffb0dc-1f11-4a52-8601-13d552598542","members":["9b5d9422-c502-48e7-ae6c-be43eebd021c"]},{"cluster_id":"6fb5df41-d443-476b-9fcc-1bb07e6c9654","members":["92eccd30-8e15-4b0a-824d-735cca1c2192"]},{"cluster_id":"d6e81e61-bb7e-4b41-8a70-469e0ff32a7a","members":["f3a645dd-68f9-4487-b73e-30f2e3ea4d04"]},{"cluster_id":"4a483622-b245-4e23-bd10-793b05ae9fe2","members":["13cee0c9-ef25-445e-82a6-b02b00b2c1fb","38f53e15-3f6d-4e4e-8988-ef767fae2cce","2727f1dc-96ca-4448-8e40-efad4366f0c5"]},{"cluster_id":"24cf159f-beda-439d-a5c9-ae442b6d0260","members":["0d4831b9-1c60-4e5b-b0b9-72bc0ccfcae3"]},{"cluster_id":"39994f31-5ff9-43be-a15d-3547ec296a5a","members":["e7dd94b7-56b1-49b9-bbc8-e0391e96f07d"]},{"cluster_id":"d44ce227-03db-4ccf-be04-d057a22464a7","members":["170e6f93-eed9-4548-9823-e63b11639f8c"]},{"cluster_id":"e09e9595-94ee-4647-99c5-988ef1e8bcb9","members":["4b87c2d4-b0bc-4bcd-b2d9-b7f06d0da126"]},{"cluster_id":"7d94faaf-dbe0-4a3f-a991-f9aa1c9db4cf","members":["a5c99aa4-f17c-43ae-b34e-509a65aa9fd9"]},{"cluster_id":"7aab4a1b-073d-4317-accd-dca275b73d33","members":["2bea5ecd-17cf-4178-ab03-db01a041b647"]},{"cluster_id":"531ef405-3766-417f-ac2c-f496b00a6ff0","members":["e3e3e85f-f8fb-4a8a-8ccb-600f18cbdcad"]},{"cluster_id":"1b6f0e82-4a2e-409a-a651-9a7baa243dc6","members":["f435f62c-ad3b-4efa-aa1f-9ff8d3fe62ce"]},{"cluster_id":"9eca8644-57d0-4b18-b62b-b394d615bf38","members":["679cb10d-d348-44e6-b2f6-01cb567790a2","f270c33e-858b-4306-9fe4-5bd6bfe6a4fc"]},{"cluster_id":"ab428379-3dca-4ed1-9e68-45a0cb9d3fea","members":["c4c8d590-6cdf-48bf-8957-5096693fce2b"]},{"cluster_id":"10d521f9-b2ba-4e4d-ae1c-f8033a7f7147","members":["aa01c2c4-8749-4bb4-a2cd-1b8bb0a95fba"]},{"cluster_id":"476dd033-427f-436a-8631-14fd97a75117","members":["9ac2f976-c4da-470b-b294-e79f98fc2b54"]},{"cluster_id":"d8c7e702-0f0f-4bd0-b760-82584697ced7","members":["e0d3d359-f166-4dd2-aca8-a35110d78fd2"]},{"cluster_id":"464e7bbb-1cb4-45e2-a510-f3dbf3edebfc","members":["43f8b899-885b-4050-ac77-5ce53ea324bc","5ed0f63d-df88-4580-8a8e-48d5c9df57ad"]},{"cluster_id":"7897b080-7853-4261-9ab5-31b7495a5563","members":["7307d455-2137-4fa5-bc7c-4cdea871a9dc"]},{"cluster_id":"304159c4-71dd-47fa-8097-c06173508250","members":["a65d001c-cca8-4840-9b32-1af336faff8b"]},{"cluster_id":"2a61add2-cedd-40b1-9edb-ca1cd948e8c9","members":["24e21450-cd50-46c3-b94e-55ca3db9664c"]},{"cluster_id":"c46b62bc-7cc2-4635-bcb1-86c242f419fc","members":["14e53ed3-1d34-4287-b912-5cda80c785f1"]},{"cluster_id":"5e5db8ed-e13c-449a-bc48-1985ab63a2df","members":["399ec5a7-19c0-4a7b-abf9-391f68e2ff17","7391c888-79ea-4e6f-87cd-27e151639497"]},{"cluster_id":"66723b88-51f0-432a-9dff-39c845623093","members":["fc6b77f7-dc25-493e-850a-8a5678ac62f1"]},{"cluster_id":"73f48f2a-467d-4d70-aac9-42d923ea5f8c","members":["cd833903-1d88-435a-be20-65d7f3030c1d"]},{"cluster_id":"668e643e-dedd-4afb-8aee-89228ecd7266","members":["9969c3be-cc0d-4004-9170-83f03be8a37a"]},{"cluster_id":"73ec670b-a1e6-4252-8fc5-cd613c026c27","members":["48993eae-6239-4819-9397-c0e535b16ede"]},{"cluster_id":"99e93b0d-aa99-4889-a4e7-3146b3109f12","members":["dc3e294e-d8f5-4f83-8645-15c73a692917"]},{"cluster_id":"0cb0d661-8f49-489f-95ee-927e21758c32","members":["6cb42a3b-90dc-4c1c-9f7b-c798da81dc3b"]},{"cluster_id":"0c6eb85b-0ae0-403f-b2fd-990121d9ade3","members":["fd57d3a4-1075-477d-ac07-7a5b2f8cf5f6"]},{"cluster_id":"5733967d-8845-4b54-bab0-e2652b43f156","members":["06ec29b7-82cf-4072-b4d9-152399a5e654"]},{"cluster_id":"cd9fcff5-cee9-4a86-b076-bc2c105f1372","members":["f9c3779a-12b0-4cd5-8f95-525ca13037dd"]},{"cluster_id":"997b6294-e973-4686-9dd3-38c8184705a9","members":["6342e2b7-055f-465b-bfa2-b4ddccaaebb4"]},{"cluster_id":"f1749a30-d414-494e-8542-2f37dca2357f","members":["ba975775-fff0-4df5-a3bf-e0ca58335c08","87c7fc14-b153-4c4c-bb81-721cba1b85ec","a822c036-5334-41e1-8f49-d66ea1f5558b"]},{"cluster_id":"287338c2-de9c-4394-a2e1-133139492deb","members":["c6f3ddf6-1bab-4d23-b714-953fb57eff01"]},{"cluster_id":"81106289-cb37-45f4-a937-0b81bb6b136a","members":["69e5b66f-97d1-4101-ae74-59610cb88559"]},{"cluster_id":"3474c474-7d6c-491a-9b70-d72c3c7f2f0d","members":["9e3880ce-a29d-43cd-874f-cfef33aa127d"]},{"cluster_id":"1d986f8d-82e7-4918-bcdd-07f2b4e2658d","members":["91fe841d-800b-4739-bd2d-d81c8f002fb8"]},{"cluster_id":"529a3261-d48b-4317-930e-3bc02bd608d6","members":["1d4c16e0-d010-4863-9727-9cf42723cae9"]},{"cluster_id":"4baddf1e-d126-4e58-b0e3-19999dfb4341","members":["bf10fde4-add0-4ec3-9223-e8f98213cb4d"]},{"cluster_id":"ac20790a-e28e-426a-9c7b-f5ecf7b0aefc","members":["ef6c5885-5dcf-4ea1-8216-8f32472257f6"]},{"cluster_id":"abfd51b8-1368-4f82-817b-9f3cd83502dc","members":["4d67b61c-8473-4dc6-95a1-580c9649bb7f"]},{"cluster_id":"90f6170b-cac1-4488-806a-45a48e5f95f7","members":["b2496dbd-12c0-465b-835a-ba1729136df0"]},{"cluster_id":"c932887c-3706-4683-bd4c-6cb5768e640e","members":["c09ce2fc-390b-4863-9fc5-d1930b2f2ff1"]},{"cluster_id":"a0d901e6-2e0f-43fd-9d25-7b092459f36d","members":["eb6c052e-7bf2-4485-9d67-51aa2085d18e"]},{"cluster_id":"71ff5874-dbd0-431c-b097-90e57ae45748","members":["9b6d9a3a-ada9-41e1-b87d-b843716d0776"]},{"cluster_id":"b3f64145-99ff-4cb6-9aeb-55abe9921e59","members":["4c401541-ab70-4b74-8c2e-5cd24cc436b9"]},{"cluster_id":"78c613ac-a6ce-4fc2-859c-265be8fa23d8","members":["75716968-673d-4617-a46d-a6f490fcd10e"]},{"cluster_id":"fe5accb2-754b-4498-82d5-eaf3b4116254","members":["503e9999-94ea-4dcd-8c73-e9fc77be30d1"]},{"cluster_id":"4ea8be34-570b-4271-a023-3b36e07e963b","members":["98240cd1-a78c-4795-9c7d-26b9f65b0f6a"]},{"cluster_id":"c16529d9-b58f-4692-9ca3-61d534ff3c9c","members":["de69b62a-c856-4aa7-9a3e-3fafbd094da4"]},{"cluster_id":"4c1f4530-7a84-49d9-bd89-b51ceb8c5ce5","members":["944b2729-f7d8-4888-b155-b4742dfa7d8e"]},{"cluster_id":"d349da51-4e48-4c7b-8b12-6a3dc4608c75","members":["ccfb3e7c-5f10-4ff4-9e50-b7367383ee17"]},{"cluster_id":"8e640a02-ac6c-4b9c-8244-be0e4a058359","members":["0cd4f6a5-2bfa-4bb5-97c4-0f00629d8196"]},{"cluster_id":"04e99e38-59fd-4613-8ed1-1ec10ecc384c","members":["a191825f-6de9-4d87-8a4d-30409d13d4b4"]},{"cluster_id":"637cde7e-0523-4cfc-a2d0-d5916b669833","members":["90a516e1-5fec-49da-9932-7d18620d8b22"]},{"cluster_id":"226d057f-48c7-4bbd-a28a-0aa92cb7c9a5","members":["02afaa47-b21e-459d-acce-148ab6f92cf0"]},{"cluster_id":"a8d5b3e4-8b75-49e0-a915-0b7f6f79f523","members":["3dbbe6c8-09df-4e25-b23c-5e7cc9d7526d"]},{"cluster_id":"aea06698-0475-487a-a76e-80bcbad00033","members":["f8f68b07-5c9e-42b8-b2ab-2883893a0e69"]},{"cluster_id":"1de54c8a-0e53-4b6b-8b96-dacd9745e0a3","members":["945e80be-a5a3-4199-b65a-3bece6b7699a"]},{"cluster_id":"2adc78cc-7a32-4711-8e39-54e6c3539977","members":["4cb6beca-973b-40dc-b67c-0064201fba5e"]},{"cluster_id":"0edde6ee-5047-426b-bbb4-69dd12b6fd54","members":["df1e89aa-6e0c-49cb-bd7b-b0657dff90a5"]},{"cluster_id":"33e5cc06-7767-4163-b58e-c98e6d0b542f","members":["24b77652-38fd-4c08-8b22-a14a1d9a2811"]},{"cluster_id":"12d89d03-baba-4a2e-8935-742fe6b4573c","members":["7342c0b7-9bb6-45ae-8c6c-294a3543c93d"]},{"cluster_id":"0fd43dca-76e2-435e-9091-21e203301fc4","members":["ac75ab80-c1ac-450f-9d26-54e49897e0d9"]},{"cluster_id":"639aad5f-e883-4460-bc98-aed364fefe21","members":["5698e2f9-b7f2-4ad2-aeab-4540a3f4a34e"]},{"cluster_id":"867f94d2-2825-471a-801a-edc5c961ad9f","members":["659afe69-c95b-4fda-a2b4-b48856bad257"]},{"cluster_id":"55326ca1-c9a2-4aca-a1ea-bd63160c25ea","members":["5170d91f-7079-47ae-9a0d-71d25e98fd09"]},{"cluster_id":"9f25d197-8ec1-4d18-aeda-b095d1997826","members":["549a2c5d-d36b-424b-bbd6-4767abb2e041"]},{"cluster_id":"2e94c160-31a6-438f-bf81-0a00ecfb6a2d","members":["a57fc600-fd62-4a15-9d6e-e00d1b4108d5"]},{"cluster_id":"e5eb0916-6642-496c-9615-8dbd59c7dd10","members":["c74064d8-77a8-4e11-969d-65b7f7a49d54"]},{"cluster_id":"e7125b37-2f58-44dc-935e-482a2f26ca14","members":["627b0e61-d6de-45a7-843b-f20cfb2da184"]},{"cluster_id":"436ce4a6-0697-4461-9b3c-0feb3eafc498","members":["d3396119-d872-44b0-8deb-e5eb249a90b3"]},{"cluster_id":"afff4757-e8dc-4943-90b2-48114c9bc6d7","members":["7c38c3e8-093f-42b1-8174-9b06a63c1893"]},{"cluster_id":"43ab7664-f265-4e8d-9a0a-5ae73e4eeadb","members":["4a539e12-4ecb-4728-a340-d11ee79796b0"]},{"cluster_id":"0a675e77-bb90-44f7-8297-ab44add96136","members":["b0510283-9cb0-49bd-ba35-369c2de4a045"]},{"cluster_id":"7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a","members":["eff633d9-738e-4c7a-af7a-9bf8ef276695"]},{"cluster_id":"f184f109-b4af-4d4c-b5c2-73e631545fd2","members":["7361ba00-780c-4294-83ff-7a605090c8ea"]},{"cluster_id":"96b587fb-4363-4d46-8a28-162c4f6a688e","members":["67d491b8-372c-4357-8853-fb6d0e78c0c4"]},{"cluster_id":"505c42ee-a234-45a9-8c74-63207154db3f","members":["60e7b0fe-5374-480d-af09-321afee17ed5"]},{"cluster_id":"77cb4584-fbf4-45e6-9a2b-9d46e341c831","members":["f9af94f9-d0bd-4905-b27f-8bad1d50532f"]},{"cluster_id":"823bf086-9c7b-424a-8c1e-a0823a4017d5","members":["f57edc70-ae95-41b6-aef2-49ea3a1fca81"]},{"cluster_id":"72ed971f-2c7c-4564-b630-36c027e0f1d2","members":["f3a58a27-5f45-44aa-9bf7-bc5c8c2202e2"]},{"cluster_id":"2c59d86f-8c32-43d1-acd4-a598aa7665ee","members":["28feaf79-870c-4ab7-a66a-2b220c21d5db"]},{"cluster_id":"682564dd-6904-485d-a9d9-e5a6a5b41de7","members":["9da7657c-470e-4730-80ff-14ccdada87c9"]},{"cluster_id":"59e292c0-ebb5-4e44-9c6c-162e21e21b97","members":["0087ec71-efef-48bd-a9b0-ad70397607b7"]},{"cluster_id":"3ebb1b75-d2e9-4210-933a-9f6e5583b377","members":["9d2a8db7-5155-407d-8436-8d7cee3e5b07"]},{"cluster_id":"37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b","members":["cb11b99e-dea4-44ec-b3f8-b061844a08f2"]},{"cluster_id":"9acd0141-e648-4bf5-8aee-3bc494863f46","members":["cf7273eb-95f6-4d64-8982-3c77a54eb37c"]},{"cluster_id":"d821d63f-63c7-4a38-a3fa-ddd32322fec9","members":["0afc5e37-1078-418e-9712-600d479f1b63"]},{"cluster_id":"a5420c14-b12d-4c0a-ae41-dc3c93672fd7","members":["dea74892-770e-46a2-b6a0-b224a7cc797d"]},{"cluster_id":"48f73ce8-5bb4-4ea5-acad-4966cfa816f8","members":["44bb52cb-2b43-4b01-8e82-ca3f82d435b9"]},{"cluster_id":"89418c34-2fb2-418b-8359-739bf85f5c05","members":["f2ddd3a0-eaae-49d2-8c91-7e83372075fe"]},{"cluster_id":"925ab71b-2b56-471d-b090-4d83433faa8d","members":["9f027cbc-e19c-4bb5-8261-cabc26180c9b"]},{"cluster_id":"116f2145-073f-478d-a5b4-2d21196c953a","members":["10e8edc7-51fd-4a67-96a7-0b2ec0458508"]},{"cluster_id":"b5c81785-6289-45db-a194-d9731e5e4109","members":["236295a2-6dc4-432c-950b-cd8ec055a997"]},{"cluster_id":"f262ea70-4c26-4dcc-8a1f-52d6f8ce5558","members":["94db85e1-1e45-488e-961c-1852016eb144"]},{"cluster_id":"e0151ccd-baed-452a-aaa4-6feaeeadc3d9","members":["c6f0e97b-89d2-4817-8b4b-14549e4f7132"]},{"cluster_id":"9c2eabc6-f74c-4f84-b44d-2de93cf844a7","members":["1ba18464-64e0-4a02-b45c-1bcd8fd1fd2f"]},{"cluster_id":"0cb84281-0a02-4551-a9b6-e0952da929f7","members":["ad49483c-8b2d-485f-8b1d-4e7c1f885fdd"]},{"cluster_id":"9ebf6405-2d25-40bf-a1c7-48615c2b0e1d","members":["f67d414d-8b31-4350-bc2e-0fc2b65b527c"]},{"cluster_id":"72aa7b94-9121-4289-8302-01ff0cfe298d","members":["cdd93ecc-dec3-49d2-8519-57fb729a6a6c"]},{"cluster_id":"46dfd54a-6aa7-40ae-be06-53fff6d54a50","members":["1eb822b5-1044-4452-9b7d-5da64b2e1637"]},{"cluster_id":"2b11b446-8d3f-43d8-b5cf-fa4f7e28a0d7","members":["57349056-a914-484b-b96a-5e1c0add2dec"]},{"cluster_id":"63edca78-13df-4735-a10c-6f9089b9d044","members":["519c5fae-9511-4646-8e94-46823089e695"]},{"cluster_id":"7130da69-c674-4096-9b2f-90376c9466d7","members":["886b25be-3682-4289-925b-472fa91130c0"]},{"cluster_id":"2ed4b8da-36cc-414e-9362-86f9b9a7a515","members":["a2ddcf5d-e29c-4ca6-82b3-bd018543286f"]},{"cluster_id":"84b99e8f-a7ed-4a77-92d2-b7e912bf0ca1","members":["48f9f82a-a285-4d1a-9f55-4e78e4a90559"]},{"cluster_id":"dd156ade-c3be-4db6-9779-46772fbd155f","members":["feeb4bde-2a9f-40ea-b58a-1808e9ea7038"]},{"cluster_id":"2f59f9a6-6a8f-409f-8959-e71823889fb2","members":["a8947dc0-f568-42c5-8ff5-8327af960ae5"]},{"cluster_id":"64e6dbae-d0db-43b2-acc6-29b1e94d9205","members":["70efff1e-de29-4845-8168-e788f396d3f4"]},{"cluster_id":"c700d9cd-e09d-4ea7-a33c-b8925d591d85","members":["c0b1cd72-bf4b-45fc-a1e8-02b82878530e","a0960191-05cf-4a3d-b3b5-463142b35563"]},{"cluster_id":"e80d1fc7-6571-4102-b247-59bf3fa473d7","members":["704a2e5b-dcc1-471d-af03-9a5258158cad"]},{"cluster_id":"0d91b295-8dc7-41f1-8c2e-38f85451d859","members":["d5ed7a1d-604c-4293-aa09-c48775956696"]},{"cluster_id":"f9d888bd-a05c-4b7c-9a69-097ffb41a69e","members":["1da59117-46a6-4dda-bc0b-beea5612a755","066b4c74-1302-45b0-baca-be4260f7c315"]},{"cluster_id":"832076ec-b055-496e-aae3-ea8daef2ce04","members":["db3fa2b4-6e19-4bb1-a206-75c8de9b1a5a"]},{"cluster_id":"d4181e9f-8d0f-420c-9032-de5764ee8344","members":["4c4999a9-83ad-4b37-af5c-bea47b7609eb"]},{"cluster_id":"e21706fa-dad7-4365-a0f1-e7a597e49a75","members":["93ccacee-2583-4de9-8575-665d987e7ec5"]},{"cluster_id":"e354903e-091b-4412-9de6-d963f87ab883","members":["5b9478ed-b921-456e-af42-1a76ccbf2caa"]},{"cluster_id":"25b06341-ba13-410b-909e-c700b9b55663","members":["eb586cec-0bd1-4d4b-a6e3-b3ff9fd986cf"]},{"cluster_id":"8c4dfd91-f6ed-43c0-830e-f702329489e8","members":["833328b9-c48d-439f-983a-13bfc8de9b56"]},{"cluster_id":"fe65ec5c-3bc8-43b1-9738-60a0ae594f25","members":["434108ca-f12e-486b-993b-8050154681d9"]},{"cluster_id":"554d8f5c-047a-4e8e-b996-038e567aa26c","members":["d9d6f93d-7229-421e-8b8a-10cc701fb7b5"]},{"cluster_id":"66fb628f-853d-44dd-b0f9-617fd67bcaf1","members":["55e622ec-6a9b-4f53-9e13-2c63b8d4c085"]},{"cluster_id":"8585c4f1-4f02-4ac1-9a95-4cc381634f7d","members":["3bdf0dac-34e7-4c26-a068-02dcae5374c8"]},{"cluster_id":"cd18cc59-c362-4812-b494-ea37654755a0","members":["da07339d-e02d-4916-a798-4d30ade2a3af"]},{"cluster_id":"82015ed8-be97-4f9a-940c-6061a2380bc1","members":["50802117-fbd2-4c1c-b79f-3d872b116060"]},{"cluster_id":"871a611b-da54-48a2-9c22-fa6f48cccc0c","members":["153a0453-50cc-4c08-83cf-fd6773ae36e1"]},{"cluster_id":"8f75e655-8582-4cb0-9320-47aef61dad78","members":["c7f4ad23-d007-4211-b4dc-1cf6b489c385","33ccea91-e7e3-422a-9dc2-d9a8020f0bdc"]},{"cluster_id":"5f916a06-e83a-45ea-99cd-e223f21451ed","members":["9a3d525a-4adb-4cda-827e-d15ade12f31a"]},{"cluster_id":"695d0f59-560f-43af-8f49-fe8e17880043","members":["a8fcce40-59d3-4693-bb0e-d1d791ec5743"]},{"cluster_id":"e6bb5d2b-e815-44c5-957e-bfeac26fe4eb","members":["32ce1237-00d3-47c7-b25f-75e182d37bd7"]},{"cluster_id":"4d738b05-171a-40b9-a505-e237572de24e","members":["5d6da8e3-4367-4339-83c3-b0e5b5db407c"]},{"cluster_id":"0f37d4dc-cf7b-49dc-aecd-4803e8374e39","members":["243bcd2e-93bd-407b-b8fa-10811871553d"]},{"cluster_id":"5ca3c47d-e454-491e-8306-a8bcab9a1429","members":["d1a9bab9-76dc-4796-bde7-6a13c17a1bdd"]},{"cluster_id":"43efd020-0d45-4101-9278-ea22329dba55","members":["060f49f6-ce30-4b27-a91b-845c676656e1"]},{"cluster_id":"dc60fa2d-dae3-4ea2-a4d5-1da4424a6919","members":["a03e9d57-73d4-4bdf-be88-1780212a4ad5","49441f57-cb4b-439b-ae80-7dc20ca68fa5"]},{"cluster_id":"db8f619e-f112-4abd-9c92-e8cda93ee5d3","members":["a4bead56-90d4-4f28-8095-8a5d20f8f4f1"]},{"cluster_id":"bd1fd480-bf1e-49b6-a34f-4616e66e256e","members":["b9024f6a-090d-4bd0-ad59-02b83ef9a31a"]},{"cluster_id":"987f4090-f0a3-43c8-9987-c964fdd04c79","members":["4acedc34-7444-4087-8ac8-f0ab81d756e2"]},{"cluster_id":"2e504c36-cc23-49bf-9bfa-77adbeb06137","members":["74cdc5c7-2bd7-47c8-8917-190eb14b02b3"]},{"cluster_id":"58babb7d-bd41-4196-8e7a-e844e8cfa638","members":["6bd4e5df-786a-4eae-8115-052c576a4329"]},{"cluster_id":"3fd4fa60-bdae-4294-8d90-4a430127c38a","members":["e8b49fdd-51a0-4209-b02c-12aa70cb3d55"]},{"cluster_id":"0c951d24-0f2c-41e0-a5be-f5200eceb7d7","members":["f59198d8-a484-4249-9e4c-cb120eb06ccc"]},{"cluster_id":"27c3b9de-4f86-4091-b50b-7314a2636d6c","members":["07f79ea0-c692-4baa-9119-0f5368f1d699"]},{"cluster_id":"4df23607-a04c-40e8-be3f-b8d874dc3d06","members":["44646b63-c5a5-421d-a5db-b8bdf9ace828"]},{"cluster_id":"0555403d-91c7-40d0-bf24-c9c0415e9ad9","members":["741729c0-95bd-443c-b190-7f90d0ca9e84"]},{"cluster_id":"d118efd6-5acc-43c8-a0da-c30ae94fc13d","members":["0876b24e-ada1-414f-99f5-fbb75a2ce1d8"]},{"cluster_id":"f2a2ed3b-6c1b-49ef-92fd-f294f1deb809","members":["c666a329-62b7-460d-8880-c5f0d94f6cc9"]},{"cluster_id":"7d3dad5c-ee33-4088-acfc-ba0e93d997c2","members":["6caeaf94-869d-4164-b22a-e0d6cc091305"]},{"cluster_id":"1fcf2fd2-6989-429c-b569-e5ab5218738b","members":["323a384e-2961-4844-bb5e-caeb44529087"]},{"cluster_id":"3defb0ae-14b9-488e-979b-534969f6eb1f","members":["5cad67d2-e08d-4e47-ae5d-3de0c4b4479f"]},{"cluster_id":"997ed426-7093-49d8-afde-97f5ea1d37f4","members":["02a16f64-1041-448c-85e0-93941aebabb2"]},{"cluster_id":"47933a91-e43e-4731-9328-ce609581c5cc","members":["a8a03368-4889-42d0-b210-bbf16a481d35"]},{"cluster_id":"1d430602-1893-4300-910c-58f51643ea58","members":["d1c4ccfc-8cec-44f4-a6b9-efe9f164ab6c"]},{"cluster_id":"a64f796d-8a90-4c29-811c-e05f5e8b113a","members":["dc7674b3-e329-4328-bd62-aabc0cfd248f"]},{"cluster_id":"6e4a0e8e-51f9-46ed-8b84-bcdeb86a6f8d","members":["f28c2f82-5f27-4b43-a421-02ef44a350cb"]},{"cluster_id":"d04cd0c9-b68b-4e40-8b85-d3adf9108b78","members":["8ee9b76e-0f2d-4f24-a5fb-f63e07db02c1"]},{"cluster_id":"2dfd3fb6-1a3a-4beb-9bdb-2191423af570","members":["26476e3e-0255-4374-ad8f-5f995f4d2382"]},{"cluster_id":"a7c1c7dd-20e8-417a-8b0d-915fb535b95c","members":["aecc93d8-f903-49e9-a789-08975bfec032"]},{"cluster_id":"3ae7e3a9-52e8-497b-addf-b434f9dee4bb","members":["c213632f-f81d-4a1e-8f04-a90bd92d702e"]},{"cluster_id":"437a3d9b-28c4-4057-94e1-09375ae72bc9","members":["1d77d116-bcdf-49da-a814-c26fc172f941"]},{"cluster_id":"197e7b6e-783a-4813-926e-57380c838db7","members":["18c8ea30-f6d5-4e01-b748-a6ddae01c225"]},{"cluster_id":"05f4f7be-1927-40b1-a507-9bb7d746892f","members":["68e2f391-6cae-4e76-9468-e3f4dec7df67"]},{"cluster_id":"8b24e853-731b-4d1e-ab4f-4eadd5f933df","members":["f9633764-fbf4-4111-a58c-752a023c9f47"]},{"cluster_id":"dd94c024-2472-482f-808f-4c85cd16b4f9","members":["7ed72f95-8073-41ce-b0bd-ed25d6f99ca1"]},{"cluster_id":"5788deb7-8fce-4423-98fe-905a919278d0","members":["c56a9adc-dc99-49cb-ac26-2bf255b073a6"]},{"cluster_id":"ea7149f6-4e64-4cea-8d02-bf248f686ab1","members":["f8165c18-9264-47aa-a01c-0b8c4f073f3c"]},{"cluster_id":"67ef8b62-b165-45e4-8df0-4a9253d62b61","members":["68dc7eaa-f18f-4ebe-b8a6-9d84a9d89954"]},{"cluster_id":"522dac78-ab07-4494-b1cd-d35343e02912","members":["4ed72a1c-8710-4154-909b-3ddb2ecb8590"]},{"cluster_id":"1d910892-dde8-467f-8bc1-dac08ec78136","members":["cea3d47c-35f6-414b-a754-8e95a7de3988"]},{"cluster_id":"5561c312-8b94-44c1-8be5-5ceb08c13061","members":["daaf1b89-a36d-435b-8fbe-d84791ad228b"]},{"cluster_id":"69fc5164-f4a0-47bb-853d-0382d8d5f3c1","members":["407d90f4-5543-4002-bf08-feccffa3e66e"]},{"cluster_id":"40612f57-e760-4270-afaa-ede3763cda33","members":["7ba3f4f0-ca89-4d70-bd13-db461a2b110a"]},{"cluster_id":"d22d7383-71e2-4520-a5b2-8ae266a5a780","members":["20938efc-458b-4b5d-93c0-0a51a2cfcd1f"]},{"cluster_id":"16bacf34-8f6f-4fd6-ad3c-f7fed8660b38","members":["93210245-0ed3-478e-9610-7f95ab51dbf9"]},{"cluster_id":"37b089f1-912d-43da-b995-2ef9b56de813","members":["d2bce9ba-13fd-4487-8da4-1d633fc463f8"]},{"cluster_id":"e59d2cce-34c4-49db-b0fc-9ab7a956e929","members":["7ee3653f-32aa-47b8-9acb-799f35f05c3d"]},{"cluster_id":"d419e57d-59b3-4e7e-beeb-1d52b9c76608","members":["b36796d3-aa35-487d-a37f-dccc9d59d67b"]},{"cluster_id":"0de6c083-ab7f-4e7e-b4a5-f3e13198d24d","members":["956c2edd-5ea2-4d90-9314-5e85b00a6ce1"]},{"cluster_id":"b79a6948-c2a3-43ae-83f7-90168d6803ac","members":["0292cb7d-cd08-428b-b4eb-7dbee8453962","d111af52-467d-4ee5-a2ad-0cb7697fb6dc"]},{"cluster_id":"f4a62cbd-7d48-489c-b0ae-5a2ba587faca","members":["5dfd5799-baac-4921-a943-ef7c64ec847e"]},{"cluster_id":"b23983b2-f833-47cb-bb9c-14955ae74418","members":["a1006103-1fdd-48e7-a258-db0dca424b2c"]},{"cluster_id":"a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a","members":["f6e64bb4-2626-46e9-848c-f77fc7551f29"]},{"cluster_id":"4833448d-d892-46bf-bb0b-2903956326da","members":["54e56b8b-c19a-4d50-b0cc-2aabd9cc108d"]},{"cluster_id":"a839d9a9-74d4-474c-bdfc-b239b6e1eb9b","members":["24139cff-94b4-435c-89d8-37bd588d1cd0"]},{"cluster_id":"637f444f-2be2-49e6-9376-4e66fc8b211b","members":["737ca22d-17b0-4b71-a1dc-96df8deec3bb"]},{"cluster_id":"67171e62-bbfa-470a-8469-52d1b51665da","members":["69e8cef3-0f97-4f56-9d24-1c39fea0e151"]},{"cluster_id":"f29558d0-0635-4b49-8d22-a3cce142124f","members":["c205a767-0407-484a-a644-3d2f7095cf27"]},{"cluster_id":"4b9443f4-821d-4fb7-8621-ed3af0ada4a9","members":["57d38d6f-b4e3-4c4e-a71b-09a0f515f264"]},{"cluster_id":"3f649da1-9f4e-4906-a4fe-35e3ec3f6e86","members":["92e94f9c-d067-4f8b-a258-f7d343bd4044"]},{"cluster_id":"adc5ea43-1ddd-4862-afc6-b17c270c9d83","members":["6cd113e2-9c3a-4e55-b281-7226cd7b3716"]},{"cluster_id":"8e28231d-7117-46be-8655-ac03e3ec9b13","members":["a9830400-0edf-40b4-b51e-33131d956951"]},{"cluster_id":"9c1a6fcf-db77-4bad-b035-88b7787ab104","members":["02ef3bf3-20e0-4322-aad1-8462d20ee747"]},{"cluster_id":"d53ff534-a3d7-4ffa-9823-7bc6114763e7","members":["107d5c29-2f33-4fc4-acd6-2fee20c6c791"]},{"cluster_id":"14faed7d-8ab2-4b52-8d60-40b6be3c9a21","members":["adaeae49-d1ad-483e-9b00-5c144f3efe02"]},{"cluster_id":"eaf67764-9289-414e-b58d-ac157f48690c","members":["e7e18802-a542-4d2d-acfb-bfa827d3f70e"]},{"cluster_id":"c2141743-76d8-4904-8bb0-fc81db4f2295","members":["9d7ccf0a-6dca-4a27-a0aa-99c3068c8cb0"]},{"cluster_id":"eee93c68-9cef-40e8-a46b-ade5e4a0a57d","members":["e36cb072-83e2-420d-8cf4-ced1f4fe3938"]},{"cluster_id":"b85f1177-adf6-443e-8aa8-4b882389f698","members":["e0167f84-ce1f-4d81-b352-b885ea3a42ac"]},{"cluster_id":"24039860-6815-4ba8-9be1-247dda66cf25","members":["7f8a1cf5-7e86-44c6-8963-92a353bfbb76"]},{"cluster_id":"70912902-8988-4e45-a0c6-4af51f1f19b7","members":["fa21c44f-10de-494a-bbbe-7455764fce61"]},{"cluster_id":"d2250c76-7e85-4e68-9f7d-cb54aa712276","members":["450824d4-1392-40e7-b3f9-e852eda731e6"]},{"cluster_id":"e0e1af6a-37f3-439c-b966-bdff95698e49","members":["a407f1ea-84a9-4862-9623-d0f02324a925","4e359298-f7bc-44e1-a224-0d0d64bb4b78"]},{"cluster_id":"20024815-8b0e-4e7c-9c28-eb57a4f0783f","members":["1fb6cbaa-6f17-4673-9222-f8aa61df3dfe"]},{"cluster_id":"adf0e4d7-03fd-41b1-8559-5505d4d67e0a","members":["fb1d07b2-9e47-4a10-88aa-536aa36cc193"]},{"cluster_id":"c0f8ea6d-76da-48d4-a14a-869a34f021c4","members":["434a0c97-e17d-4d14-97e5-31f3d65ff4c7"]},{"cluster_id":"544dff2f-0e7b-440b-a330-646db7ed3912","members":["a6699444-1c15-4a1b-b989-45e880eb841f"]},{"cluster_id":"5071d605-12eb-4c65-9753-bdff2ac75ffe","members":["7fee2983-68d8-4bea-8382-aaf5b47fcd8e"]},{"cluster_id":"50755387-4b1a-4d72-9887-7b05aa4bf186","members":["87a6eddd-368b-4b2c-8ce6-4183e0883d0e"]},{"cluster_id":"53832c20-28bd-4cb2-a22b-7698f81c17f5","members":["b5f6a11b-a40d-4ef3-8f9d-f4de13cd21bc"]},{"cluster_id":"77e5cfa7-27f5-40a9-879d-0ba7cd2177f2","members":["c9ec4dfe-5a42-4ba1-bee9-2706c05e1576"]},{"cluster_id":"08f28ba1-ced8-47f4-a0a0-4116b507d143","members":["e9996b37-aa80-4b89-958d-cd2794166a31"]},{"cluster_id":"53a00b92-807b-43f5-846e-1b35127294fe","members":["2ea323ee-7eb0-4343-a31e-85470c2314ba"]},{"cluster_id":"e72ec6a2-4890-4444-8e7d-1a5032e251dc","members":["bedd2194-59d1-48fc-86f9-f0234b938fda"]},{"cluster_id":"56106773-dee4-4da1-bda2-7227784468b3","members":["f185416f-21f7-499d-9024-947736bf13bb"]},{"cluster_id":"6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84","members":["44ccc072-a642-46b2-a1ed-e8af44115c6e"]},{"cluster_id":"b7518287-9949-4ec0-a078-3d7e49009d46","members":["cfdf0f43-c18b-4607-b426-1b3665ed9f5d"]},{"cluster_id":"f1adf470-c92b-4dc8-8ffc-81d2f8af3978","members":["c80aca95-f4ee-4db0-9443-79b99f87f2d9"]},{"cluster_id":"a8aac635-8bd8-48b4-bd49-e815a9015bf1","members":["4275f6cd-180d-40e0-90e7-59efab35c9a6"]},{"cluster_id":"c35c9880-b71e-4b4b-b29a-43c7d18291ae","members":["f3818da0-99d5-4657-ae45-99914fdb6909"]},{"cluster_id":"32cbf301-8c69-47b6-aa84-5617ee08686a","members":["11f8aac3-1ffa-48e7-80f7-f68918c4a2ad"]},{"cluster_id":"2e96e776-35fc-4f23-940d-ba30ac558d05","members":["91062d1e-d101-49f1-9191-a3f8b2dbbc0c"]},{"cluster_id":"60b30dc1-39f7-4e54-a8fe-0ca30098499b","members":["185c2416-6c1c-4899-82c6-53a5a453c87e"]},{"cluster_id":"0c9ec8a0-bb91-48f5-bf6f-13507a3c2374","members":["5570d93e-328c-4a37-84e4-2e8f29e8928f"]},{"cluster_id":"efc28260-5d9d-4934-8e08-cb0eaf327cf6","members":["96dec6e5-f568-4d57-812f-b87d6c8daf10"]},{"cluster_id":"5f2eb0b1-e72b-4484-b09f-d3bfdfdaf028","members":["2aa899b0-a95e-44e8-8f1f-d08495395787"]},{"cluster_id":"71f8bf24-6193-4f81-97b9-208284481b4e","members":["bd90e9ad-9d3e-4cf4-bd00-4ea1d6f8be9a"]},{"cluster_id":"124f0557-d721-4d00-9466-962e5e5fe3ab","members":["85966416-7d92-405c-bc31-56bbbd8253e8"]},{"cluster_id":"a1617416-4daf-4173-b483-3f65d380f28c","members":["b6ca2d96-e2af-4332-8644-c3bbbd11b213"]},{"cluster_id":"b5041259-ba71-468c-b2f9-83e8ea0057c6","members":["4e69c14f-7443-4d0a-af69-5182a6c98b4d"]},{"cluster_id":"40a7eabf-afd2-4baa-a287-e3b8fad136d9","members":["3a13ed57-ac5e-43c8-90bf-8cd66bf6f503"]},{"cluster_id":"b3909552-dab5-4658-b73f-34338b406557","members":["74caf7c4-d50f-4495-8c68-52fe77e6cf1d"]},{"cluster_id":"a22c2709-36d1-4c69-91df-446cf30d0361","members":["47582a6e-7aee-49e6-9a90-70c25b54b570"]},{"cluster_id":"cf071659-f57a-47ef-8e58-d5ef07d53221","members":["6e95a689-eb28-4092-8f24-54d8232f394e"]},{"cluster_id":"a04f0354-7f2d-4806-8bf1-4cf23f67439b","members":["66307a24-6752-47c1-b14e-19ba5f2f2e2b"]},{"cluster_id":"4f640a26-8edc-40de-bddc-8bc4a09eb227","members":["ccca6a2c-bbf6-41c6-b927-d092d6835a64"]},{"cluster_id":"fcae1625-9dc6-40ce-b828-c6881213b7e1","members":["73eb341e-b0a3-419e-8644-315fefca12f8"]},{"cluster_id":"173f883f-de30-4d47-bca3-522527267a76","members":["0f36c619-8e14-445d-9ff6-652907201f8d"]},{"cluster_id":"88679d89-9148-493b-84ed-a40bc977a620","members":["e85fec14-f53d-4f03-8782-2d509817cdcf"]},{"cluster_id":"752ad0a4-463c-4695-a371-bfed4c14cfc2","members":["3c065b5a-a536-4694-be46-2fa75a6abad9"]},{"cluster_id":"35d3b29d-3d0c-4461-8663-4b180f0aaa41","members":["32c16bd5-4905-4d1f-9dc9-527ca0e29b56"]},{"cluster_id":"e3188c04-70d3-4f55-ab68-49043c888c8a","members":["5cdb36f6-ae0d-4c33-85a4-c023f5d57ee9"]},{"cluster_id":"6aefa1fe-d0f8-4db4-8968-8fa277506a8b","members":["9d29c1dd-4f43-4ab8-88f8-11e3b2827272"]},{"cluster_id":"aca283ef-ca7e-47bb-9faa-cd0f44fb7b50","members":["1e1a3c21-bcf0-4394-89a7-ce8a6ebb377c","a2f08d79-7fe6-4418-9146-13672ec98ce0","65eb6438-fe45-4492-b34b-a62197cf6a90","1379ed5a-dc8f-4dc0-b83c-3ac31cd9020a"]},{"cluster_id":"13dc8122-3135-4fd1-a900-1e2308b14e34","members":["429193ad-842f-44da-afc5-3dec6e99744f"]},{"cluster_id":"815c147f-e9cf-4afc-9a1d-d83dea6ef481","members":["ecdd329a-e084-4edb-97b8-6cd18aef672b"]},{"cluster_id":"759b22c3-b9e1-49af-a4a6-7bcb4d79d24f","members":["5571cb87-63cc-47c7-8d84-d91f1754a41d"]},{"cluster_id":"87b42d69-1e6c-402c-99c5-e722d6abf4ce","members":["58187aec-19c3-49ac-b926-cc221022d989"]},{"cluster_id":"12b1cdcd-4e31-4b05-ae44-98d5b446ed03","members":["5d78dde1-be3f-4bf2-ba05-56ce0a3bd4f4"]},{"cluster_id":"bd30dba7-ded3-462d-90f7-5fc4ff649bd4","members":["c304c132-ef7f-42b3-add5-d5b7d3fb88a5"]},{"cluster_id":"5113736c-e1bd-4cef-a0d0-94d26dc8aee3","members":["21859aaa-2d71-4c1a-8366-63800b3db547"]},{"cluster_id":"a0499a4f-f80f-4f0b-ab10-3a54901c48a4","members":["3bc6fa9c-20b7-4020-a917-396b142d7587"]},{"cluster_id":"c577dcab-43f4-4988-b6a9-b023d7e8abb2","members":["ca5532c8-cdca-4755-8314-fa874bb46c3c"]},{"cluster_id":"bd4e1aad-4b42-4afe-bdd1-8b68fcb5aa16","members":["73c9e515-b050-482c-a37c-960afe733109"]},{"cluster_id":"e15ef239-9f26-4808-8bf7-31e94108dff6","members":["37a4f01b-94b1-423e-80e0-2683732abcb9","531512c9-2ff0-45a1-94e5-5f41bd786ffa"]},{"cluster_id":"9e044845-6768-4b18-b4e5-13d72ace241e","members":["f2c01a33-1ddc-412a-ad6e-7b1540c343bf"]},{"cluster_id":"8f04e04a-ea8d-4a08-9f4b-0027f1697329","members":["95a03a51-dbf0-403d-90f9-f300942b3ba2"]},{"cluster_id":"386f4b6c-ead4-4444-9916-d94cb574f068","members":["1b4a205b-74f1-44bd-81fe-e1ce90cf9854"]},{"cluster_id":"3b4e6d34-1c11-4402-8f08-680cd1dda0c6","members":["906b4a52-a777-4545-92dc-c04cf5c063ac"]},{"cluster_id":"21439ac6-d6cc-43c2-9360-f892b94daf83","members":["cbe55de5-2caf-43ee-ba13-5ad9e99bd3d3"]},{"cluster_id":"4791dca9-cb90-4716-841a-c69798c940f2","members":["cc635954-d212-406c-af7b-64d61e9232a7"]},{"cluster_id":"750243e1-18a5-4108-92d0-c8875b6d7be7","members":["5fc8c4c4-d8df-4a71-bfab-f21ac22ba5d5"]},{"cluster_id":"b26ec24c-184f-463d-a8c5-4ef885956b1c","members":["f3bcdfdc-f86a-49ca-b399-1aabe7da2bbc"]},{"cluster_id":"e5db8adb-166d-4129-bd9b-54f680ec3bdb","members":["23f4ac65-fc79-4c77-a7d0-07d4377b7d20"]},{"cluster_id":"44ed705c-5a34-48f9-ae3d-7f96124493a0","members":["446b57ea-cf92-4a32-b8cb-8b784adc0166"]},{"cluster_id":"58acdbed-8f15-402c-b1b3-c0a3be3ee80e","members":["5b1e3132-4460-4a38-8cb3-ff9a2ac8826a"]},{"cluster_id":"d3ddf15f-7261-4b4f-bdd9-6823755811e6","members":["b085f7e0-13f6-45fa-a7b9-aeeda8e4bb0b","94c08630-0cd5-48a4-ac1e-abb0096a007d"]},{"cluster_id":"e49682e3-c065-43da-be61-a86567e3397f","members":["aa7c1c7f-0d44-49c5-ae8e-b066be962441"]},{"cluster_id":"6f2fde83-d0f8-429a-88dd-e73036fda6d0","members":["66ad7bc0-9ff5-4228-a9e6-565bf22c9f50"]},{"cluster_id":"c6f49d61-1bb8-4b16-b016-0bde6b721c6d","members":["3fa896da-b3be-44c8-85b3-060314d71ec8"]},{"cluster_id":"121c0233-5b70-408f-8b70-e5ac0b37c748","members":["aac764ea-a66b-4f31-941d-ffbb819af7d0"]},{"cluster_id":"6fca3548-19e0-4797-8ca7-1e10435f142d","members":["b2e5de87-855f-4995-8336-4d6a9399c505"]},{"cluster_id":"c2f88444-099f-4cbf-b8aa-27e4b2666137","members":["31e6662a-c5e2-4acf-8ce6-df814b728b1a","c7eaa53f-6708-4973-a6e1-5dd6a6496de3"]},{"cluster_id":"615af33f-6193-4bde-a85a-a2576bad24e7","members":["ca55d25a-0401-4df1-936a-1376aebf51d6"]},{"cluster_id":"f140fd40-63a5-49d3-9d17-1114828f483b","members":["139daf56-007b-42d6-aa9b-9b1cfcbaf5a6"]},{"cluster_id":"f5b1b3d0-19e5-49a1-bbc1-690d440e299c","members":["bf10343b-f909-43fd-af82-06c1e21d46dc"]},{"cluster_id":"4794bb46-add2-4c57-9ffb-caa8d6c5bb0f","members":["b852f69b-afb4-4dfb-af15-e891f23b224d"]},{"cluster_id":"8e8e8bbd-6670-4f01-810a-e901866d96f8","members":["c63eced6-5d16-4f1e-88a0-0091665a90c0"]},{"cluster_id":"fa2c7516-f196-48a1-815e-d89c4e4b9860","members":["66be13c3-6124-4d46-9fbd-e2f1aae2457a"]},{"cluster_id":"15d3bc51-86b6-41c4-8d7b-a993e63544da","members":["f222f463-960a-41c7-8add-ca05baf14cdf"]},{"cluster_id":"f315f787-a973-49cc-9719-20a3bfead1b0","members":["b0eae12c-8aea-4fd6-ad6e-c46f1e03cf3b"]},{"cluster_id":"5291aa5f-51ac-492f-83f7-3c48258f1866","members":["5e77b394-bb3a-4aa7-96b7-903d5eb45d32"]},{"cluster_id":"b9809c93-42b6-499a-9f8e-13df798b0605","members":["8c107dd6-605d-4017-a9bd-33e6ba2712aa"]},{"cluster_id":"7b2da9c5-ac6d-44df-b539-9a5ad8a18762","members":["2e7877d8-7bc2-44aa-97f3-885ee1f7b7c8"]},{"cluster_id":"00be0a5e-79b9-4671-8dc6-befc37464ba9","members":["92170761-229f-4faa-9360-128f73ee18ea"]},{"cluster_id":"602cf518-8d43-4cc2-9f69-aa005257dd2f","members":["a1cec6e8-9f55-45dc-8b12-ac0c718e1958"]},{"cluster_id":"c3a97d86-3ef3-41b9-9b1d-e19ad5caca74","members":["339603cf-d217-443d-84aa-919573e582a3"]},{"cluster_id":"7881b67b-b21c-40a3-ac70-ae067b94075c","members":["2cbcdcf5-3172-4520-9520-fe93506b4118"]},{"cluster_id":"0751c6cb-9d71-46b3-91e2-7b78341d2ce3","members":["38efc9d6-8d2c-44e2-b8ef-a3cfcec9d8ab"]},{"cluster_id":"77420d84-761c-4596-b8a9-5aa8adb89a0e","members":["740097a6-3475-4c42-a063-6d57bd424dce"]},{"cluster_id":"154bbf48-da4f-41b3-ba55-27ca50e6fa44","members":["8eb4cb0e-7b9a-4f13-8e1a-da24d629fdfa"]},{"cluster_id":"835823ac-6b1a-4b3a-9f19-567a3d13955c","members":["3549f487-ce14-40df-b2d6-fcc4513c8785"]},{"cluster_id":"ef96efc5-2acd-42e3-8b8d-c3fb75af951a","members":["f6716a58-9b2f-455c-90ca-18000499c8fd"]},{"cluster_id":"66d1e8de-40d0-4ef4-80a2-bb8b898bdabc","members":["e6253f6d-ecac-49af-9e41-e9fabbfd8e44"]},{"cluster_id":"9be937d1-1aab-40a0-9206-7301e1897a68","members":["fe1f81b2-1744-41f8-b4e4-aabc8202821e"]},{"cluster_id":"ad140612-2296-4f06-9b90-8018512776b7","members":["004e3aa8-4727-4367-8257-4ebff0af8a68"]},{"cluster_id":"9707f2e5-6c57-41c7-a2b2-7fd6a30159c3","members":["82c9f4b5-c38c-451a-8ad2-14f8edcc6b84"]},{"cluster_id":"2672b11d-4ad6-44a1-9b31-f8c01c03c721","members":["64a9d99e-8e91-4678-aa7f-b728bd5c53b2"]},{"cluster_id":"6a2c5b98-767a-485d-a14c-04f05f90984c","members":["ec64a4a4-f829-484d-8869-7c9eb4db9c7e"]},{"cluster_id":"3a17531b-ae78-41a3-b63d-f61bcc85a26a","members":["bbb5cc6b-3b9d-484e-85ce-d24c3c292f70"]},{"cluster_id":"28b8266b-a1c9-4314-9300-fcc436685496","members":["dc94773d-e525-4ece-af42-d49b116e49ec"]},{"cluster_id":"0af9e942-0bcb-4d79-81df-118cf826ff70","members":["d187f29f-d494-4ca9-8866-e9da236be814"]},{"cluster_id":"5e50bec2-0cb9-42e3-b94b-de915ce6a4d5","members":["6294c61a-6abc-46e0-a49a-abf7a17ad549"]},{"cluster_id":"4e97ff0c-8732-4960-b274-1090e77ec733","members":["66b58dc0-50b5-4540-adba-a4e76fb91d67"]},{"cluster_id":"b24ff026-a9a6-45e3-8927-422954af4cf6","members":["383b6c54-a4cb-4059-ad3e-ea0d13e45cc6"]},{"cluster_id":"3014a508-0ddc-42e0-9480-97e1310e1f29","members":["ca6674d7-a991-469f-b21e-3b470642ac02"]},{"cluster_id":"c04b6a1d-f91c-44bf-b579-d5d4565fc056","members":["a68aadc4-aa7a-498a-b29f-5219ac9ea826"]},{"cluster_id":"c011b0e5-baf1-40ca-ae4e-97e2c4bd7b62","members":["7ad52f94-06d7-49c7-b712-801ca6ebb7c8"]},{"cluster_id":"43507aa1-0b73-484a-ae6d-901aa511c57f","members":["a362be59-a2b3-4756-9a27-ec194cf888a1"]},{"cluster_id":"7ef0f102-5c71-4651-96e9-1923d9bd80c5","members":["2d27cb07-d273-4ff8-a885-a605607e9399"]},{"cluster_id":"1919a927-7052-4719-83c2-7118a15e11e3","members":["380afa3f-981c-4fb0-9861-b18e3bcbf7a6"]},{"cluster_id":"cf0fcabf-722c-47eb-957b-91614bc676e4","members":["6d335fdd-9f9d-41fe-95a7-51649780ed03"]},{"cluster_id":"5688bb4a-4059-431b-b1bc-a991bc5ccd0e","members":["e5dde201-20e3-4ed7-8581-0ce2fc39ce70"]},{"cluster_id":"d7af883b-7f94-40af-b74c-503163e2b062","members":["6c07e308-30de-4c20-8eed-8cb8fab78ac0"]},{"cluster_id":"c278122a-3daa-4207-bb75-b0bf1f432ea0","members":["e3bd4def-67ea-4e41-acd9-45bdc62350df"]},{"cluster_id":"facc7561-4a20-4459-a43c-a6df1f7f9d23","members":["4eb1e6c6-4c04-4fb1-9b4a-e12422fcbe0c"]},{"cluster_id":"aeaa0391-95c5-43bf-a72e-66d04a052ba3","members":["949cc13b-3f00-4a84-872f-1468848fa3cb"]},{"cluster_id":"e45a7fdb-d8fc-4ccb-adfb-88a463256b7d","members":["e0d59cbd-fe06-44e6-9e57-683460942560"]},{"cluster_id":"45e218a6-8801-4755-bcad-4c7f5bec819d","members":["e9fec56b-bda7-405e-9874-715a2d84cc3c"]},{"cluster_id":"69235fb0-8a7b-49cf-8a07-8d2aa290c9c9","members":["0531bca5-6f01-407b-a777-e27ae1b12d71"]},{"cluster_id":"128219b8-57d3-4f9e-bdf1-0447f6eb1ba5","members":["452f19a1-c9a7-4dc9-a417-a4163cc29164"]},{"cluster_id":"7ca6b83e-0750-42ad-b001-d24a26fccbeb","members":["d05ea7fe-5f24-45d6-9a3d-fcbd501c5e60"]},{"cluster_id":"dfa97197-5724-4a7b-bce9-4a9f24f7056d","members":["15147e88-47de-416d-9926-84fe660a5bd2"]},{"cluster_id":"39c57d47-c79f-4298-b9b0-1dca0020b6aa","members":["d7007eff-53ac-46e5-8d8b-f2f5808280ef"]},{"cluster_id":"337480a5-b05e-40ea-b813-e79cc37e4e00","members":["8cd7d895-d72f-40f2-812f-beff65f4fbc3"]},{"cluster_id":"fb90f205-10b1-4a80-8c76-1265d7a47a4d","members":["a8e258d0-7a7b-4aef-b1a3-9162e909dee2"]},{"cluster_id":"771e3903-1d96-4871-b3f7-ccc8c72d8493","members":["3fba4d5c-3ee1-4b90-9114-934702074018"]},{"cluster_id":"9d77a640-6134-44b7-85bb-43fc8324bd77","members":["c9fe7617-e8d9-453c-be7c-26d3d7a1e970"]},{"cluster_id":"b4fb9256-1ac5-4cb5-9d11-a73a825665b3","members":["b37d9311-a201-4634-b0be-4b9dc697c076"]},{"cluster_id":"77a0df8c-7608-483b-a706-3897667bbac6","members":["801625a1-7548-4660-b67e-c9b4e1df4d39"]},{"cluster_id":"45319dcb-5d0b-4d01-90b1-03022e3ef700","members":["14d759b1-9f29-43bd-88c8-de19d3207ad3"]},{"cluster_id":"b70fcbd6-9ed5-4bd6-a526-8679fde82331","members":["3695f38b-cdde-4db9-99a4-262c0769b252"]},{"cluster_id":"cac0be30-203f-425a-ae61-9f6f21636075","members":["b3d0ff6d-32e2-4e8f-a950-bd3ced38cfed"]},{"cluster_id":"64e778b1-1770-4087-ac56-445bf339b8c2","members":["affe057e-7142-43d7-927a-362e3310a150"]},{"cluster_id":"20c1ad4a-8c5e-407a-b67d-ed4158ca87ec","members":["093af7ef-f8c3-4277-b887-feb350730d2c"]},{"cluster_id":"a1f572c9-19e4-4da8-b35a-87c376dc4fa0","members":["57c8255d-a207-45bd-a773-01c8b3e004b0"]},{"cluster_id":"13220774-7cb5-4388-b12f-a0737d93673b","members":["17c44ab0-58b1-4dab-8cf7-2264ccf37aec"]},{"cluster_id":"5db4a15c-7ce5-458c-89da-0e71f2e155d8","members":["fec02486-c6e8-4284-bb05-729f62a1101b"]},{"cluster_id":"cf5c8ab9-6f4a-4ef6-84b1-7fb025d62c2c","members":["59f262f9-054b-4bee-8ad9-ab207a5ab04e"]},{"cluster_id":"336f2ec9-9cdf-4236-a126-80e564dfeb50","members":["9bfa6c99-6397-4e36-9292-be2b2e541947"]},{"cluster_id":"528d38ac-7716-475a-b7f4-71caee3d9abf","members":["ff080f9f-615b-48e7-b27c-7d16d778d50c"]},{"cluster_id":"e0978a2e-1125-4e65-9d19-ea0e822bd88c","members":["80a18546-a9f1-4a36-a3f3-a225649be4bb"]},{"cluster_id":"61d73230-504f-4e81-a2e0-6fec552c5517","members":["72cbdf45-7fcd-4c0b-a5b3-813722f29224"]},{"cluster_id":"a663162f-90e6-470c-9356-50de41099dfc","members":["8f0ffecd-2bd2-4568-afb4-65dda8d35d01"]},{"cluster_id":"bf67fbdf-c97d-45ea-aca3-181ca579afe4","members":["39055a63-9c6d-45c9-98ef-8513c7e78bc6"]},{"cluster_id":"d28e35dd-84d1-4e21-9131-912aee49eabd","members":["fb531a15-8aff-4353-a2a1-9aa5eccb96b4"]},{"cluster_id":"0749ed10-4e7c-4fa4-ac39-680414ad6f05","members":["4d204bc2-434c-43a4-b9df-86516e0bab5a"]},{"cluster_id":"b7f1648b-9e5b-476f-a59b-84d94f8583e3","members":["f2221136-70d5-4fe1-b53b-7b08a207d33b"]},{"cluster_id":"4097f204-b4ae-4826-85fe-e2f03051cdcf","members":["09cb4d32-703f-41a9-a5b7-5dad4743a3d3"]},{"cluster_id":"d2a4fdc2-883c-43bb-be4a-653d77acf7ba","members":["b7642cd3-0bc8-4a1d-b545-580ddca192a6"]},{"cluster_id":"bc899377-60fc-4a12-85cb-bbcd12759608","members":["e876aa55-ccc6-4a86-a82c-6c131c26edee"]},{"cluster_id":"a8e462eb-2839-4295-9ab7-03216f0e8610","members":["299d2e55-bc61-4a50-bba6-66ed46b5363e"]},{"cluster_id":"7738ea50-f8ba-464e-a8c6-f4b5554a926f","members":["497b8a3d-7b34-449a-b6a8-91e83200040e"]},{"cluster_id":"02428d36-d8ed-40af-ab42-212bc3922840","members":["e838c843-c42f-494b-a37e-ced69281e703"]},{"cluster_id":"6b8c1ab6-dc22-46f5-831a-de1a865875f0","members":["1eff0a3d-f6cd-4aa1-8d3a-9043c2e6c613"]},{"cluster_id":"143fdbe0-b8f7-4368-95d7-a7983691aac9","members":["cc7198f8-4301-4ba1-8356-b86060cdac49"]},{"cluster_id":"3f685716-0686-4535-807f-feecb0c1246c","members":["37543867-7a98-45b0-8d61-4b2251b582c0"]},{"cluster_id":"b87bc991-27b5-4e76-ab33-22c0374b82e2","members":["3ccc3a01-a487-4b8a-be47-6d4a3a2a0904"]},{"cluster_id":"38dc9a30-7314-4720-8e2e-f17990947602","members":["21f033b2-695d-4e52-b95f-b558e097f44b"]},{"cluster_id":"83a91d6e-ceaf-4824-b195-eb7ebd584c9a","members":["08258c5a-06ae-4452-83ce-367944e44347"]},{"cluster_id":"e91dd131-96fc-484a-8d0e-4bac856ecd99","members":["40c10979-07ed-44f9-86c3-b6799b7f54a1"]},{"cluster_id":"844a0834-978f-47f2-bad3-00baad297b74","members":["c275bfbb-ffe1-4a47-98af-9b5a80b6c744"]},{"cluster_id":"621f11b4-2ba1-45f0-bd1e-92caed87da0b","members":["72ecc1dc-d64c-429f-9c9f-4be7d17d858f"]},{"cluster_id":"120960ec-d747-4eeb-a10b-5a0b594f24f6","members":["50c0933b-59f9-46d0-94dd-8f90735528aa"]},{"cluster_id":"6ad22c58-94f1-4426-8339-5bd33e29da9e","members":["2e9de352-9347-4d4d-a8bc-e3956c08af2d"]},{"cluster_id":"07d6842c-fb2e-407d-bdda-a29d80ba013b","members":["abb7f778-870e-40b2-a550-5eab36008d6e"]},{"cluster_id":"f654e316-c125-44fc-9eae-66baddc079a2","members":["178c06f6-c2d7-4166-bf7e-d2614914d85b"]},{"cluster_id":"00f3a914-1589-47ae-9fd7-4b841e19dce5","members":["f34e68a5-70eb-4dfe-ad1c-a0bfcb57e6fc"]},{"cluster_id":"e353033e-612f-444b-a7df-06c23368eb22","members":["0a2d2ef5-2997-4280-ba09-2cf99a6347d6"]},{"cluster_id":"48fd9ac4-d4c3-4877-b46e-dde80ecc5cd1","members":["99344ff5-7033-46e5-a172-2343c8b0a751"]},{"cluster_id":"a6d41b3b-e930-4fdb-ae89-6fb33dda11d3","members":["a1c1ee08-ed28-4db5-a831-59acdf22f269"]},{"cluster_id":"aa931a1c-d292-40d9-9c54-451d60524b03","members":["e95ec72b-b6d6-4417-bb16-2497cd4cff59"]},{"cluster_id":"61ee629a-3d51-41dc-9089-461569ecf949","members":["cb696a27-f7ad-46bd-a24a-1c2511c4b536"]},{"cluster_id":"01388d43-fe04-46e8-a137-ee7f321c4ae8","members":["d3130946-bf20-4d88-bbfc-7a743c19f84d"]},{"cluster_id":"54f8b2dc-d3d6-42f7-bde0-a8a0038707a5","members":["a38c53fc-6805-46bb-978a-b98d01c02b1e"]},{"cluster_id":"067f4b77-6a0f-43e6-a250-8a682e95f8f7","members":["18dde5d9-a8c1-4134-8a1a-b48330358cae"]},{"cluster_id":"81cdaaf8-571d-4a77-8063-fa5e9510b635","members":["118bfe4a-22c6-4acd-a632-2f96f78840a3"]},{"cluster_id":"c74f353a-07b1-444e-8cd6-e07be020ae58","members":["029326f0-ab23-4cc2-b665-28cb99c7ab3d"]},{"cluster_id":"dae41dee-2a76-4085-8c91-121f704580c1","members":["43e5cea7-5aa8-40fd-b513-fa7aa13d81d6"]},{"cluster_id":"2de07645-b8a8-45f7-bb4d-87637fd094ec","members":["6725a1ba-4023-4162-8159-537ec94e6771"]},{"cluster_id":"ca922fb6-3b82-47fc-a5a7-c1ff0c4bff12","members":["9726f123-3a84-47e7-a294-1eed84f61a26"]},{"cluster_id":"c3f8efea-527f-4eda-8f86-1b201d526c1e","members":["81e0c562-9db7-4aa3-a2c1-b4f864f16a9c"]},{"cluster_id":"8f9c10a7-b7f4-4bce-895c-bb65278b679d","members":["eea13ed3-dccf-446f-998f-735b0ea2d09a"]},{"cluster_id":"e39260dc-c205-47ec-aba4-6672ed7e1722","members":["ef520cf2-7d18-4465-bea8-d978c2295e1e"]},{"cluster_id":"7b8722b8-a7de-40ea-80c1-4cf1e7b13571","members":["fa7e1324-b0b9-4ff6-bdc0-6259cd84da93"]},{"cluster_id":"002cfac3-c97a-4ec1-b743-37eb0267aef0","members":["c6582463-5f7d-4cfe-a8f8-6c66c1c335da","4279a432-41f9-4319-a3e0-6dbc7b8e4a6c"]},{"cluster_id":"108f968f-7171-480b-9225-ebaea32953bb","members":["9a382c40-da0c-4d85-8cd1-9c2ebea1c96b","64b6ac59-947b-4ff6-ae5d-2d3f567513fa"]},{"cluster_id":"96dc4289-9f74-41d4-905d-780af68fcb09","members":["2a63e9a0-e29d-4060-bb0d-3468106d7324"]},{"cluster_id":"a4eff04d-c7b6-4d4f-a9de-6ac6a11bad77","members":["e3a2dbb7-08c2-4c29-9af0-05d39d0c1db5"]},{"cluster_id":"9d822f9c-32a6-4f43-9fd1-5ddd226c8add","members":["9f90264c-7944-46c7-8681-78318e8d1355"]},{"cluster_id":"069833ab-70fd-48fa-80f9-9eed2484a21e","members":["68641234-420a-4329-90f9-bffadf38cf2c"]},{"cluster_id":"c89da02e-a1bc-4522-a452-82abf8c705c4","members":["6eed197c-bb50-4b7c-a189-a980a1656ac3","abdb6419-f54d-4ea6-a065-163aaececd61"]},{"cluster_id":"e657af4a-ab5e-4efa-9539-dbb94e69e772","members":["990812e0-4f86-494f-beef-eba27006dff4"]},{"cluster_id":"03dc9e1b-5b04-46ff-b424-59158328eb35","members":["c2c64aec-c935-49b0-afcc-72fccbdcc3a5"]},{"cluster_id":"9f78a266-9f3f-46d5-948b-3b4d3da9a083","members":["f968d171-b816-46c0-bfa0-fba146815ece"]},{"cluster_id":"f06698fe-6625-4ba7-9978-7a2aa54fc4c9","members":["9f765438-218d-4074-9cbb-6a99cfc6b719"]},{"cluster_id":"305d4d39-012b-4cce-bd6f-017ddf94a842","members":["d803b683-bf2d-480e-b71a-2f96bdbcf286"]},{"cluster_id":"11103fe7-e53a-478f-ac79-6e43af250e15","members":["7bbf868a-826e-4db5-a17c-44573886c777"]},{"cluster_id":"a50cab62-c330-4a2e-b634-2fd8a82ebcfe","members":["a3483f04-4bc2-48ff-ab5f-da1743021afe"]},{"cluster_id":"e614332a-840b-4b45-8ec4-5184a874c6a8","members":["e27900e5-e395-41bd-9e8f-7e9184605552"]},{"cluster_id":"0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3","members":["15ba355f-65bd-41c2-bb80-d915bc29a320","9d1576e4-3a78-4fdb-8e00-0e46b85db6fd","e24110d5-1180-4c16-bc38-795134e27b4f"]},{"cluster_id":"139b8293-aa0f-409e-8a4f-0e3ee1191f72","members":["bef21526-75d8-4ec5-8762-f4c10f0c6966"]},{"cluster_id":"4ca4751a-06c9-42b9-935e-8c293fd1cd2e","members":["6385f0ee-fc6e-4be6-a532-2d855f27de42","707cfe8f-a312-4565-a0e8-0b194b657b05"]},{"cluster_id":"5be5d4e4-f894-4929-941a-785184a9901d","members":["be9d0715-a081-4e4b-bfc0-abb30b56e22f"]},{"cluster_id":"9ceeac8a-9421-42a3-9891-76c4ef2d8151","members":["4413ab91-f03a-4a79-8f9f-bc195fa9468a"]},{"cluster_id":"b4a8f883-fff2-467a-ae3a-3ea74c8cac30","members":["de7f06e0-ab3a-4af8-a892-e30335092fc1"]},{"cluster_id":"5345ad5e-9fbb-47ab-a820-0caca6e3cbd3","members":["a389d09d-c70e-4f32-8f4f-fe1d1a9181d9"]},{"cluster_id":"5a9b6351-c522-46ce-b100-d164df2f3ed9","members":["7982bb8c-32dc-46d0-b1fb-bdd657baab28"]},{"cluster_id":"2a04252f-e78e-41fb-93da-f1bb87ae8d3a","members":["1fbaaae1-6e8b-4e15-ba6e-69100367c7cf"]},{"cluster_id":"0b7b0dfe-c42a-4dfa-8860-0ff61e6cc75e","members":["e9e5e622-efb4-497d-a4d0-2e931b17806d"]},{"cluster_id":"c9895da0-2b5a-466d-80f2-7637e4a4aa2f","members":["18af0ef6-7e14-4b53-8284-cbd053fc539d"]},{"cluster_id":"58794c22-3f6d-401d-8ef2-ec12fd369ff0","members":["ebaea4e5-dcd3-4432-a770-e32381475f95"]},{"cluster_id":"993e530a-4835-4641-a20d-ee6860332c74","members":["f648b2b3-3a41-4e93-85c0-b818c09744fd"]},{"cluster_id":"c48b1546-3855-4755-8da6-3e9352505d7a","members":["49b6f7ee-c490-4e97-b9be-cd1cdb389f4d"]},{"cluster_id":"3b95c6b0-416b-4f6d-9aaf-3287913c0c2f","members":["2f765095-3367-4bc4-bb5f-c8c33226edc8","d86844d0-23a9-4b88-8229-737a1ccab748"]},{"cluster_id":"6ea587ae-3fa9-4e28-822a-cbebc0ee85f8","members":["22b397c9-5e00-40bd-8e3b-a23dd98284d9"]},{"cluster_id":"0404c137-e8e8-457f-ae4b-121032548258","members":["804c22b2-4b27-4c7a-a9c1-8e0d56576d0b"]},{"cluster_id":"7167c7d7-52bf-4753-8c56-a05326df7c57","members":["87e47acc-97a6-4c7f-baaf-2ab092ddd69d"]},{"cluster_id":"1dd73410-26d1-4ffe-8c70-64b5d5bf9994","members":["56869913-81a3-4dc9-8932-4a209478fb3f","96e3dce7-9eba-4438-ace4-aa43e5d214d6"]},{"cluster_id":"42c65788-8111-41df-929a-ce02cb092330","members":["f4405dfb-c941-412f-857e-5a77f34b5f32"]},{"cluster_id":"a9534c6f-c812-46b1-a237-7680deaae455","members":["71efcdd0-feba-4f17-9df6-806c0141cbb0"]},{"cluster_id":"680ddc35-25cd-424c-8914-0f7a5b222416","members":["b42bcfde-d9f8-4371-9d21-99670eef9a28","f90c99fb-0f68-4211-8cea-f680b42202d2","8e768813-5b66-4e37-83ec-123e5540c0d2"]},{"cluster_id":"8a43f903-0edb-4ccc-94e1-29dd080da2dd","members":["d7440efb-31e2-4628-944f-50e9967a0277"]},{"cluster_id":"6c73f0ba-1131-48ad-8cc3-b8a29be7cfff","members":["957fb997-6d99-4b89-adf6-7215d9d822c9"]},{"cluster_id":"031a0aad-21cd-4ca2-8a60-5a981bd9de8c","members":["3eb91f38-46c0-4be0-a1aa-bf07ae9029bb"]},{"cluster_id":"bb608fd7-71a8-4a13-839e-8d3ef46c08e2","members":["0d60cc1f-bd32-4137-85e7-ee7f9f32a2d3"]},{"cluster_id":"272822f1-86c1-4fb0-9f4d-41ee4b639a78","members":["83a46f8f-bd63-4e99-ba08-b42d237718ca"]},{"cluster_id":"fb6903ba-fc01-4c20-9ef5-d3ed23d4b4f1","members":["3ff00e48-74c1-481f-bb84-249163637132"]},{"cluster_id":"d02fe9fc-02c3-4085-ae05-7b4e0277028c","members":["9e295537-0a8e-4c97-956f-25a628caf5e8"]},{"cluster_id":"2fba36c8-9087-441b-9f3b-6c08ceeffdb2","members":["7c0677e7-a1de-46b4-8537-3e039fd956a2"]},{"cluster_id":"dd605b4d-33b6-43de-a73f-acf3e8834d88","members":["2de1d368-987c-4a5d-b412-16dff48d5432"]},{"cluster_id":"4deeb553-8438-4bc5-89db-299a071d6d12","members":["feb784eb-895c-4e56-9470-0934560c08a7"]},{"cluster_id":"a42a7921-cdb2-4929-93b9-1642ac38cfed","members":["7caf2bc7-0a29-4338-a5b3-d8d5314c896f","0ae871e4-c93b-499e-9729-35dd7eea531d"]},{"cluster_id":"525348f0-16a2-442b-8f83-be5618731e1e","members":["cd07651b-ca7f-4ba7-a292-e24bbb89d3e6"]},{"cluster_id":"39b04d3b-887f-479b-999b-c671dfd12bd6","members":["43ef1665-1991-439b-b5b0-341027e7c7f6"]},{"cluster_id":"5400c461-7afa-4066-ba64-beb7aef1eede","members":["1055602a-6022-4325-9031-c9da36278c1f"]},{"cluster_id":"7b5742e3-5955-46ac-9086-6f1852e5681c","members":["12dd4744-5275-4005-9cba-eee738bae219"]},{"cluster_id":"970fa237-7a1d-4b64-a4c6-7a158c05542d","members":["6cc6428f-3e2c-40ec-8a01-e3bc7f71b9e5","33969a83-f98a-4002-9274-f3c13ff9c373"]},{"cluster_id":"e1c37a48-126a-4576-b497-f9db46d18555","members":["12414278-10a5-4efe-aa75-6b5147a06ade"]},{"cluster_id":"f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9","members":["2921d6b4-fdb1-4fac-b774-3b44892c9a47"]},{"cluster_id":"b99d5f24-fa76-453e-adeb-2b0a207bd3de","members":["7e453dda-1f5a-4c77-8439-29ccd17a064a"]},{"cluster_id":"cd47012a-5cc7-45af-9355-7ba2b5b641a1","members":["cce6161f-61e1-495e-856c-b460794e60d9"]},{"cluster_id":"bd148f49-6e19-46a6-bfe3-a19a292ab17a","members":["c8740bfc-0d91-49ed-a628-3e66fdb712d4"]},{"cluster_id":"83cb9288-d8bc-4d51-803b-71e04c61fa41","members":["ec1eaadc-9853-423b-bd50-674470b40015"]},{"cluster_id":"a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f","members":["2c3a68fc-ce0f-41b8-b95e-db9820f85184"]},{"cluster_id":"4033f6dd-a718-42cc-9426-c47fe47bc182","members":["3fe9ba56-574a-4fbd-bd89-3efc650e8933"]},{"cluster_id":"0791917d-ce61-4b44-9705-c74efbd95241","members":["9d121a0d-cbfc-4f4d-a9b8-25602f209f3e"]},{"cluster_id":"08268346-74f3-44b1-a6ed-3517ea134f57","members":["a1143634-530f-4ddf-bd27-0031ce6cbeff"]},{"cluster_id":"95b52cd8-d8dc-42df-9eb9-9f4f8c6db4b2","members":["3f813fdc-4ad6-4f05-bd8c-cb458b63dcc4"]},{"cluster_id":"e4820af7-bf5b-455e-a72e-bb48cada6e0a","members":["898253d6-a20b-4ea7-a680-4ea6a8e5e591"]},{"cluster_id":"cca26850-c71b-4446-90d7-2e4d88b1223b","members":["98c3fc99-045a-41b1-9608-c4606dec0d90"]},{"cluster_id":"f07e6f30-0af3-4009-9a85-94198bcc5a45","members":["c8a184f1-5f20-40eb-b092-438c9d095f14"]},{"cluster_id":"6fe0709b-66c5-4553-a6ae-89bdc6df31fc","members":["7ad56b41-6460-472b-ae3a-26765fb583ca"]},{"cluster_id":"60bcdb7a-b11c-4760-96c7-2e903b89bd2e","members":["a2f350e8-ddd6-458b-9ff0-ecce809962be"]},{"cluster_id":"35b22dab-25ce-4dde-ab9f-31302b06eb90","members":["947ca0f5-5a3e-42e0-87e9-0791cccea0e6"]},{"cluster_id":"51c627ea-61b3-4175-b1c6-64a2c7928bc9","members":["8d97a4be-b332-4539-aa7b-7570086c9276"]},{"cluster_id":"1257662d-03bb-4192-9e0e-d0d2bb753848","members":["ab28cf16-2c3b-417f-8c2d-799f61852361"]},{"cluster_id":"961d386d-4d5b-4009-a39c-fb6d1a441cf5","members":["ba943773-f4ec-4b72-b99d-3fd70ccd5b96"]},{"cluster_id":"9a62af93-7112-41ed-b195-640caabb9cb6","members":["43bf57ac-6257-460f-8d73-80f921e28db0"]},{"cluster_id":"5661edb8-2d76-4ef2-88fa-1ef3a23ed765","members":["f7281147-4afd-4fcc-a868-83b976f36e7a"]},{"cluster_id":"ad717816-6a33-4b68-8dcc-4da6a24f22b4","members":["9986cc55-bad0-4c51-a4f2-64526ad8eef9"]},{"cluster_id":"0e7363bf-ba1a-40d3-b39e-9efa5e6a18ad","members":["5c10b624-e027-43ef-a580-72ae4235ada6"]},{"cluster_id":"d7d8a2ba-6242-4963-a3f8-0e40fd7043dd","members":["2cd38244-2816-4d92-95c4-7397788434fa"]},{"cluster_id":"5a363a3c-7ca6-45b2-98ec-b07e07ef38de","members":["63a76f1c-0c99-43b6-b1bc-49035b7d3502"]},{"cluster_id":"26405a6f-ce14-487e-8e9d-f5b3ee953860","members":["701c30c1-0733-4df8-b0d1-eb0ce9f034c8"]},{"cluster_id":"fc3da38c-59ab-4dde-836c-c912a95b1802","members":["e546b4d6-4a47-48e7-bd13-1e7753dbb866"]},{"cluster_id":"8abd35db-2186-4408-8be6-3af382d275ab","members":["4eb4ba3e-a782-475b-b2c4-9d6db34814ec","6fe2ff24-1c4b-4a04-94ba-def1daaaae8e"]},{"cluster_id":"69aee0d6-8420-442f-82ab-c95f31fcf4b8","members":["06c0a5b5-8e16-4f9f-9f0e-ab5664de4825"]},{"cluster_id":"d0bbd332-807a-43c4-8b16-bc8817897189","members":["a0807413-350d-497a-957b-476c99bb7942"]},{"cluster_id":"b8430087-4ad5-4df6-bc7a-9f268ead6bd8","members":["cbe425dd-91d0-4c9e-814f-307d666dfb05"]},{"cluster_id":"f646af3d-32fa-49f1-bcbe-d5924a767680","members":["f13763ab-b797-4cfc-b23a-dfda1e34d18d"]},{"cluster_id":"1cebf7eb-146a-47ef-84f4-296315d7b4c5","members":["67e1df4f-0b25-4eb8-ae60-da8ed780fa20"]},{"cluster_id":"0e9e7c31-725a-4645-86a1-d5bba7071b1e","members":["42e1e786-eb16-4811-ac5a-3670a7e9f8cf"]},{"cluster_id":"6799e4ae-598d-4d1f-8409-ebaa05c79c71","members":["0662725c-2816-4d30-bdaa-0bc0158a79b9"]},{"cluster_id":"88ac8370-087f-4a90-8111-103d9e01fd10","members":["16c7e6a0-3a3e-46d8-afe7-c7ca955a57fa"]},{"cluster_id":"33eeb9d5-6bc2-4034-a6c6-3e0b1e59728e","members":["0a078b3a-374d-49fe-af7e-9e2d0fe930f4"]},{"cluster_id":"efabc150-323f-4c88-9041-fa0370310d1e","members":["f3f9277b-7b33-4da8-bc76-dd68b1a43d28"]},{"cluster_id":"ea30f761-5bdf-4c65-ac3f-905c5bb0730a","members":["e8d5e569-cd34-4e09-92ae-637153b746d6"]},{"cluster_id":"bb7d1261-e586-4986-8419-b3678b999f37","members":["3c0ec261-34f4-4f25-93bc-c9313bd979a1"]},{"cluster_id":"f09e8cd4-4e03-420e-a650-dd40af68dcd7","members":["263b32f2-4856-4bd7-ad65-7bc111192dec"]},{"cluster_id":"dcbfce15-858c-4e65-80b3-6f982fffc5b4","members":["3ca46107-397e-421b-b4d6-0dde20cd7129"]},{"cluster_id":"83314d81-ffc5-42be-b8ab-fc7049a1e48f","members":["a7b94326-202d-41d5-a38e-7f325df8eebc"]},{"cluster_id":"7d17e0b1-02a8-4e94-8aaa-3bb8dcf83cf8","members":["604fbd99-45fc-464d-83c4-c999705544cb"]},{"cluster_id":"1a154b18-5d3f-45d7-ac98-39d14a936806","members":["191250d7-2c7b-44a0-84ad-1a7a97290061"]},{"cluster_id":"1c77e648-2237-497b-abcc-acdf4350562a","members":["bac0f5a3-ea5d-44df-a3c1-9fcb9dd2e680"]},{"cluster_id":"97a63c8b-423b-4b4d-8ca6-262c543d514e","members":["93b14285-af1e-4f08-84b9-e93ba8eda306"]},{"cluster_id":"3e001ec5-72ab-4ef2-bec5-7b5552144517","members":["161373df-fc56-4929-9699-2af1f305042d"]},{"cluster_id":"918d1070-a60a-4619-b33f-d29c47c7f6cb","members":["a98dad60-c241-402a-a088-d428675b3092"]},{"cluster_id":"44f0dccf-8fd1-49a7-88f2-e83b8d0cb422","members":["2ac71266-2c71-4d0d-8737-421fba19a828"]},{"cluster_id":"b2b194c2-f397-4e76-bb84-c8a37964e533","members":["63ce55d7-4535-4422-bfa8-d00a22e51d68"]},{"cluster_id":"d05207e4-1a3a-4cab-84c5-4af79b01b239","members":["a0797c91-72c2-4cbc-a7a2-eb2143464cd0"]},{"cluster_id":"e0d1bce3-3239-47f8-946e-5937659f6c85","members":["c267f3f8-4c62-40c9-8ed3-103959675502"]},{"cluster_id":"f7c00384-e094-4930-b95a-5105ca6ad5a9","members":["2763957d-043d-4c6f-90e7-3af562830017"]},{"cluster_id":"ee698871-2543-42ca-9ed1-652a77429181","members":["f046c44a-a2a4-49a4-b33f-4a775d713df4"]},{"cluster_id":"c80180fd-f416-4eda-9cf5-5aa622256189","members":["9a744018-8525-4ae6-8e3a-5c4aa6c6552b"]},{"cluster_id":"2de6bb89-87af-41d9-9f6e-654985194064","members":["75c453eb-2738-450f-87f5-31098166ede2"]},{"cluster_id":"a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf","members":["297e88f8-7910-405d-bc54-514e7ab6044d","07b5174c-0004-467f-abed-bc4b6e7f8b04"]},{"cluster_id":"927e3b68-c649-4b84-bd7c-c79eecd50812","members":["e99f2056-cf88-4c64-86df-0a48013a8870"]},{"cluster_id":"ffe496a8-ba5b-46e3-94f5-ab61bd09d41a","members":["83c742a8-914b-43e6-9971-d322cacd6287"]},{"cluster_id":"8b923490-b752-4fe2-9b0a-01c4a9d8d4b7","members":["13c7dc85-89b0-4e43-aa45-849ba1aa958e"]},{"cluster_id":"bfff8af2-9d27-4503-baf3-3e1618c9087a","members":["f0932c14-0b9e-42a3-9963-dcfbfcf6bf87"]},{"cluster_id":"6d731e69-2664-4f91-adc6-9eac800389a3","members":["25ecf7d1-558b-42d9-bf57-2bc303b8f36e"]},{"cluster_id":"b2700cb5-512c-44b4-a7d2-f6f79575e42a","members":["11f8567e-f853-4c9b-9c0b-ecbed2ab46bd"]},{"cluster_id":"a28c9cba-981f-4e06-b04d-bde777f88583","members":["1a5858cb-924a-4f99-9863-0e4a6f688c72"]},{"cluster_id":"3e73e60d-d610-4533-a186-9f4c4620025b","members":["66daa508-94e3-4524-99cf-9dd30b99355d"]},{"cluster_id":"c90c2a25-6af0-43d7-8ce5-c04e253daa5e","members":["7c3c831b-2105-43a8-8ad0-76c73aee5715"]},{"cluster_id":"9fe09fbd-ca4a-419e-94ee-6e49f8b62304","members":["3f5b7328-b9a4-4069-b53d-757422e4629e"]},{"cluster_id":"9f572501-f429-45f5-98fb-17c2e50fca11","members":["ce2dddd3-4322-4e87-b3f8-f7e629923e04"]},{"cluster_id":"ce23ab49-6ed2-4eb9-b4ae-b0b0514251c2","members":["fcbbee15-4882-4121-9f07-7e273696aca8"]},{"cluster_id":"921f4cda-4607-46f9-83ce-2b7708f3b6a9","members":["3b71ae7b-1b52-40e8-bee3-d373b84cc8b6"]},{"cluster_id":"ea84d1ec-6a21-4123-9c3e-41ce618815e9","members":["e214f73a-49c9-4a2d-b29e-9723e9a7174c"]},{"cluster_id":"f2531848-788a-44fc-8497-b2d0aa74b135","members":["61e54a09-0f7a-4c03-875f-2d3a5d4747df"]},{"cluster_id":"4815ee62-ac65-4840-9797-7e3f61c900fd","members":["4dd9a224-cfbf-4cd6-897b-6d2c3c3c063d"]},{"cluster_id":"f51d8559-af8b-4da0-bbbe-5eb4dde41ccd","members":["2741f754-b74b-4c46-b971-fcef82ac4768"]},{"cluster_id":"e4c129ec-5dad-46c4-884d-38afdd290e76","members":["d55af143-5861-4236-8d45-a7c0d5ea6c83"]},{"cluster_id":"8ce1b035-20cf-4e3a-b84e-8642795846fd","members":["6c6f1682-69b6-4831-be94-3557272332dd"]},{"cluster_id":"54f0485d-be26-4b53-bcd8-2b1cb8ee52a3","members":["4f781d9a-7f8e-4869-a794-a727324fac4d"]},{"cluster_id":"1bdc4e39-4f85-4244-acae-0889a6b1bb01","members":["13f0d944-6cf6-43c5-9220-7687d06e00be"]},{"cluster_id":"8f445d44-1e7e-4d7a-9a5f-c141941a7046","members":["ec218a04-2242-49d9-b1d8-715213b7c515"]},{"cluster_id":"d5e78a91-2d42-4f38-b8d5-690a40967ad3","members":["7eacfe5f-3336-4bdc-bc19-96e33288a5ce"]},{"cluster_id":"4abd438c-8dff-4f9a-8a7c-0da2a36edcc9","members":["2113de29-0bea-45ac-b7f2-5e321f002776"]},{"cluster_id":"2bd231ca-b95f-4da8-b52c-5b92d58eef4f","members":["b12104e0-292f-4267-a6a6-1acc6bcc36cf"]},{"cluster_id":"dc0f2fc6-867e-476a-b8e1-8031edcf72a7","members":["92d1fcfb-d3b8-479c-b78b-53de4f6df3c7","1e546e61-b8e7-495e-96a2-c3490a50dd21","53901b4c-be30-4b13-9f82-7cfead29a8ad"]},{"cluster_id":"2b58f035-89d0-48c4-ab98-0571ae348860","members":["10753f07-df9a-4f52-8209-d82451128083"]},{"cluster_id":"41498260-bda6-49c5-9ad2-acb6340ff494","members":["68f0cb2c-642a-4030-a9b8-033e606d295f"]},{"cluster_id":"ce2c1d0b-75ef-45c7-a23e-a0fa3e07457f","members":["f78e8fb3-a5f5-4218-9658-3435aead73ba"]},{"cluster_id":"fa2c58b3-15f9-417f-89fa-2899f5ce4fe3","members":["eaff01f0-4388-4ced-be4a-e328a91d96d0"]},{"cluster_id":"e4488bd7-fb22-40f5-8db9-906cdc42ac18","members":["28dd6232-27c1-41d7-88b4-2f787f02440d"]},{"cluster_id":"7ba06e8a-b878-421d-9b1d-d395213d16fa","members":["7ff744b6-6709-480c-8c99-b17b322ef721"]},{"cluster_id":"06406aaf-e480-4364-8dee-02d2a85bbdca","members":["ead2fbdd-5723-42fc-ab0d-93d87a438a0b"]},{"cluster_id":"5993beab-a3f3-40b3-9d6d-5a8cd60d5eb3","members":["87dce773-da40-4685-bc94-7aff0bcddddf"]},{"cluster_id":"afe6a321-421e-4002-b9d4-be185e9d1b93","members":["0f197dd8-0c8a-4426-919b-85d947fa246e"]},{"cluster_id":"fe48b63e-4bef-4121-8e7e-7d9b8254bcfc","members":["db1cb6eb-4be9-49d3-93dd-957097533883"]},{"cluster_id":"b95ab66d-3f95-45f0-b65c-f87d9de7b47c","members":["f6019ddf-aedb-490c-b225-361650f56322"]},{"cluster_id":"126a290c-017d-477f-aef9-ee387468d992","members":["8dda9808-2665-4d8e-9f16-d03edf53b7a3"]},{"cluster_id":"f8830cd0-0851-4651-a6ad-3f181547090d","members":["6a373685-7592-4b18-9be4-7713a5157089"]},{"cluster_id":"7ef61e9b-09b3-424a-8249-c31cea2c952b","members":["2ebc3f44-7446-4a79-a097-f252f3e44d7d"]},{"cluster_id":"a867149e-e951-4e73-80ca-91c6893b617b","members":["d1d894f2-aa78-4b33-a4fd-1fb32b34b23e"]},{"cluster_id":"3ec46f1d-e796-464f-991a-62539b2882d1","members":["a74e82ad-2c97-4e7d-a8b5-14aeca0b1233"]},{"cluster_id":"a67c3f7f-a1ca-4dac-ba63-61ecd0d76ed7","members":["7a4afd2e-583b-4d1b-a751-28c295503c50"]},{"cluster_id":"fdd7487d-7bf5-4a71-8bbd-7a8cd0c6d7c4","members":["05008ca2-9f51-47b9-bcca-461e749a6dd1"]},{"cluster_id":"2002baa5-6997-4ebc-9742-182fae427316","members":["b9be3a7d-7b16-488a-9236-4f95aca31052"]},{"cluster_id":"4ffbb682-25e8-4ae0-936d-0f256e7b5aaa","members":["8fe772b0-3ed9-4ebc-a64a-9d70e8cacb35"]},{"cluster_id":"80c21daf-780b-4d61-a882-6319319c019e","members":["fc234567-2d65-4f37-960b-e9df75ff8fe3"]},{"cluster_id":"08a49e97-cae6-472e-9f1e-189f1a189718","members":["fc688e50-6c5a-4726-af4a-d7a1df92d2db"]},{"cluster_id":"9b88354d-eae6-4159-b5cd-4aa560c1a939","members":["02bcd9eb-45c6-4482-b342-3b8a229fe307"]},{"cluster_id":"8a36ef98-d08b-4198-b4d6-a8933da5b619","members":["bb80b8bb-dbb0-46ba-8994-3f0cf55d2f78"]},{"cluster_id":"3f8c1bc5-ffc2-4f3c-9751-015716600af2","members":["ddedc3e3-39bd-46d0-baa5-3ddbae068501"]},{"cluster_id":"fbc20184-6dc0-4a3f-a944-728af7954e97","members":["227e6703-d39e-46a9-a329-3b7f3f31f194"]},{"cluster_id":"53102493-0297-43e7-a8fe-5dbe6ce36215","members":["9838b08a-1ace-4d74-ba8b-fef731e6a024"]},{"cluster_id":"f508c62e-4dcd-4831-9789-bacd1b75b831","members":["df297219-9656-49d2-8640-9d432c60083b"]},{"cluster_id":"70aec147-e46f-48a9-b67c-9dbf6b174338","members":["ecae77c8-c18b-42b0-b44d-6cae9d7c6d13"]},{"cluster_id":"4074f92b-f1cb-43a1-a970-018d582db2d6","members":["ab3e765b-00ed-46bf-bbca-4867fce50f80"]},{"cluster_id":"a94771e0-7b95-4bfd-9f9c-88d21171cf9e","members":["8fb95e4e-2538-4403-b5d4-71f4f08ec94e"]},{"cluster_id":"8b843277-fda8-4ecf-9981-5b5f31ef86a7","members":["58469760-1625-4a46-ae12-25b624877ece"]},{"cluster_id":"8463c208-4f6b-46d2-8aa4-c6b2f82bc799","members":["a9d8cdb1-fc8f-4f3a-86ea-ef27564a398e"]},{"cluster_id":"22f29403-f7fd-433f-b37d-85803cc6c208","members":["7c591d07-890a-4e2b-b07f-2101e9811438"]},{"cluster_id":"e6f89802-3df1-486d-8ad4-82cdb658549b","members":["54715ef2-9d6d-43d2-b786-a9fcb1146ef2"]},{"cluster_id":"1480b5d9-5e00-461a-b194-d322e838f544","members":["1fb7b3ec-b48f-4a41-907f-b3fc93458af9"]},{"cluster_id":"944be8a6-d37e-42a3-beed-11a9a6d47203","members":["b9bb18de-39bd-4aa5-bf88-038fde6b416e"]},{"cluster_id":"5de6826d-9cc1-4c89-8c16-3e4d254ae1a9","members":["0ca1163c-36fa-49e2-a8b3-ee240478ca9c"]},{"cluster_id":"9e537f59-fc8d-477f-937c-489e24e51014","members":["8fe8e09b-94f9-4887-bbe9-53ce062738d1"]},{"cluster_id":"8aaf61a8-4245-40d4-9036-3767a2a55c98","members":["6b80f2ca-5717-45fb-8509-1d1318b1f234"]},{"cluster_id":"0031fe05-7e53-4c0c-b89e-d86016e53d57","members":["ad1f6d5a-6fbe-4991-b391-6eea097ba6ca"]},{"cluster_id":"0d423859-86f8-4f56-9318-137386b1b279","members":["ff4b0218-6ad8-4158-a09d-ccc01098b13c"]},{"cluster_id":"58af047e-cbeb-4069-98f9-896633d3674d","members":["8542cdd9-b0b6-48b8-9de3-00467d99bdbf","a5948f0b-108c-4450-9313-80c4b9d2bf63"]},{"cluster_id":"a73d7361-cea3-47c7-84a2-2a97ab239fa4","members":["340865f4-4105-45f5-971c-91b0196fa214"]},{"cluster_id":"867a2b63-9e44-4ba6-82e8-55c04ceb4f4f","members":["b0bdc020-aa8a-4957-a82a-19757ff66f58"]},{"cluster_id":"9054d5e2-4b4d-475e-9960-73215a5d44f4","members":["efb16d49-67a5-4fdc-82a9-8f602f332fb2"]},{"cluster_id":"0d3db024-9b87-4816-98d7-172f0864bf36","members":["a01511d4-be5d-44a9-8aef-f8ef676cdb9d"]},{"cluster_id":"ab73bace-5110-4ac5-b01b-8b28976f8120","members":["2ee0655e-d858-4d91-a7c4-7ab020f8b20d"]},{"cluster_id":"059d310b-b926-414f-b010-d79ad9684054","members":["7d808e92-d4f1-41c4-a2ce-59bcc07b90e6"]},{"cluster_id":"83c9bf38-7be3-4a58-9128-bac3dda66b3d","members":["0457a908-d117-491a-8ee5-7d6ba6c19257"]},{"cluster_id":"dfb119a6-40b5-4824-8a20-9b636bd6f4b8","members":["6a4fd329-e94b-427b-aea1-bb26e6c34aed"]},{"cluster_id":"66399bf8-97ea-4b4e-aa54-9b68d82943d5","members":["b6e556ba-5f57-429d-af0f-a86c90db91b4"]},{"cluster_id":"82ba6b92-1774-434f-82ee-333e96e53f03","members":["539280bf-56c8-4465-bdcf-441cc11c40b0"]},{"cluster_id":"6528a411-ccde-4df7-8364-b5129e53c388","members":["0cbdc320-0d45-45b1-bada-45f660611394"]},{"cluster_id":"c7cc8a7a-ef8f-4aaa-8735-139c689f3af1","members":["7fd4d209-92d8-43f6-a978-4d0546466515"]},{"cluster_id":"f7069e5f-ee25-470b-986d-c157ab1e1613","members":["40386eeb-3c9d-4768-ba69-df110a9669ad"]},{"cluster_id":"823656a1-093a-4e85-b706-f48d18e40c29","members":["bffa340b-2243-4598-9c38-2f2d8e63cb48"]},{"cluster_id":"be58ac09-a64e-4854-a7b4-83f25a02c250","members":["bc2e8f0f-278c-41d2-8dc7-abe26dfb5c60"]},{"cluster_id":"353c6f78-8367-418a-a322-9feedaea3f81","members":["2969412c-ef5d-4f42-bd8c-e2ae776e312a"]},{"cluster_id":"e1f0a82d-250e-4472-bc8b-76e1029d4554","members":["dc95d029-058e-44d0-82c7-d35a3250c5be"]},{"cluster_id":"72addbc1-127b-4a33-b16b-7a7f76d03f32","members":["9cb961b0-2975-4edc-b037-462ad4a4acd3"]},{"cluster_id":"753c254f-8be9-4b92-b7c7-e32c2713d3c8","members":["c51c936d-dc4d-4413-907b-eedc9391ab1f"]},{"cluster_id":"23c09fb4-b263-485c-8e4e-4908da7910fa","members":["a2a21b0f-6a99-4285-8a53-f8faff778f2c"]},{"cluster_id":"6b25848d-e565-4f9d-b442-93bdb20750d1","members":["245a35f3-5b3a-496e-afa6-cd0a9d64d880"]},{"cluster_id":"e5ca8f71-6bbd-48dc-bbcc-02165ada2157","members":["bdb3e1ee-adc1-4b32-8391-fa9ea101b91e"]},{"cluster_id":"43d48fcc-7522-4b18-8344-e5b044e22838","members":["008f646a-c5e7-48e9-b395-853b78648e67"]},{"cluster_id":"f5f9e060-9a81-433b-b601-5ea2fb08b956","members":["cecfdd0e-e11b-4f69-a180-678077307002"]},{"cluster_id":"5e6716fc-cf64-480e-8688-e74f2a213fd8","members":["611bc014-08ef-4abc-bb78-46cec459f5c8"]},{"cluster_id":"d74a5599-9b30-4d12-97d2-692e60e13661","members":["ed81bfcd-bb28-485a-ad33-22c208f0ecc9"]},{"cluster_id":"64d37d6c-89cb-4974-81c1-3b1735939788","members":["1a401108-cec9-4a29-8ebb-bdd082fb667f"]},{"cluster_id":"0a1dc802-b4ef-42f0-aba6-299883ef023b","members":["7f84a657-9499-4925-b019-156b43762020"]},{"cluster_id":"bbe46b45-db85-4cd0-8c3a-6d46ba80584e","members":["3fcab9b8-b6dd-4bbc-946b-27da40e232d4"]},{"cluster_id":"55351f66-3ce1-4720-a5bd-bce9d2bab5d2","members":["8f07eb68-00a2-4867-b067-e9865a538313"]},{"cluster_id":"550b12e3-691c-45b5-8cb2-986a272d3a0f","members":["04ba5a5c-9527-43f5-916e-b911c3a441d2"]},{"cluster_id":"d8fa0364-5dd8-4aab-bf01-01e24a95233b","members":["32f79435-fe11-4d8a-859b-4156f982c7a1"]},{"cluster_id":"80b309de-fa0b-4abc-ace4-5a54f5c02331","members":["3a56cb72-b74a-4223-ac3d-0dcbe7a192e9"]},{"cluster_id":"2b91a87f-d164-4dfd-97cb-da5b879525ca","members":["43f86fbb-c78a-4fae-925c-8e1363978e79"]},{"cluster_id":"389bf865-85bd-4767-9053-03a5fcae6a23","members":["019c4880-7921-44f3-a24b-4ead99231cb3"]},{"cluster_id":"7d87f4b1-866b-4dd1-b437-00afdcc9c4fe","members":["b7470a85-016a-411a-956c-431a292989eb"]},{"cluster_id":"414df1fb-6d9e-4aff-a35e-819202fb6c05","members":["09601652-9278-414f-9e73-debea62d2b9c"]},{"cluster_id":"bf4593ea-9aa1-40b8-a424-04287ae58886","members":["18b49d65-cda8-4c8a-b14a-5e9183dd8f9b"]},{"cluster_id":"5fc308a4-b2ac-472f-a711-f5e9a8852593","members":["0a9a6e37-c995-44c2-b020-eb4e95a33536"]},{"cluster_id":"718b8058-1e91-4465-aeff-7514749404e5","members":["cb25b9d1-b962-4e5f-857d-fe0ff139d644"]},{"cluster_id":"5c7b360c-c61a-4fc7-88f8-807bde4dcb6a","members":["b657d758-6cb0-4f50-9705-1ecc489c1cae"]},{"cluster_id":"c1d2e607-4b20-4663-b826-18bf9ec884ab","members":["565e426e-e98e-48c0-8ddc-0b094636d559"]},{"cluster_id":"e4be2259-ba51-439d-9935-9584c06ee048","members":["33a8f32d-d60a-400b-a04d-678bcd8bb932"]},{"cluster_id":"fa792d5d-a49f-406b-8386-4253dfbb9e11","members":["92f05824-1cf6-48fd-adb3-12ccb30e92c3"]},{"cluster_id":"48d341a5-63e7-4586-8058-1ab4e4d8c613","members":["161c3e6c-1a57-4298-b101-4d55aa85ef1c"]},{"cluster_id":"95b33dd9-d9c3-4168-aeae-fc027379013c","members":["fc414cf9-8ffc-4069-8353-392b7823db8e"]},{"cluster_id":"9dc49f5f-af39-44e0-aabc-c941b43e1bd3","members":["78c6bf47-3270-4907-8e54-57ced25689d2"]},{"cluster_id":"65cdef1a-e035-4605-9081-f663d9551b62","members":["e03ffb94-e08e-4651-9cc1-0095b2efd08f"]},{"cluster_id":"d89daeba-4406-40e6-aed6-08994b1a95d9","members":["eb5e9dd2-7d04-4532-acfd-fb5f1aae9ef3"]},{"cluster_id":"02502121-c7d0-43b9-afe9-c557963c5283","members":["f4014cc2-8e57-4abb-bf52-07bcfb0f3b44"]},{"cluster_id":"82c2fba9-344c-4253-9cf5-a05ec938a8a6","members":["27897f54-49e3-4fae-9828-505f78bf9d1f"]},{"cluster_id":"3b24d20e-ac52-4f56-955a-33bcfd5102a2","members":["163a3d3e-a21f-40ae-9fa8-3ad5e284327e"]},{"cluster_id":"d79d62e1-d874-49ae-865e-dccd822f8d8e","members":["d7d98017-ceab-473b-9d1d-550fea381397"]},{"cluster_id":"cd9e4a57-55ca-4538-9460-c81e764492cc","members":["b662b0d5-6387-4160-9e87-512993dc9a40"]},{"cluster_id":"341aa4ce-b339-4cde-b356-d8223a398402","members":["e5e5ef80-c4d3-4483-95c6-0cd446834cdb"]},{"cluster_id":"c49f13c9-2c44-44c7-b990-930a2d9264c9","members":["0c9bea1c-696e-45be-8e98-9455cb0f2893"]},{"cluster_id":"7ae8bb79-06c2-4d0f-9d71-30e4b3fb8238","members":["cd094463-97a5-4de0-93ed-1325af5ef9fb"]},{"cluster_id":"ead45298-e146-40a5-a729-dab15400b7c2","members":["9cfc36a5-9f99-47a7-ad87-279683192158"]},{"cluster_id":"87e98045-d749-47b9-a158-8b7bfbd1d3db","members":["a927a42f-bfe4-4e8f-b1eb-bdef9190965f"]},{"cluster_id":"f10425d5-24f2-425f-821e-7acb93c9e53b","members":["430ec1c2-241c-4cda-aa92-6aed75322855"]},{"cluster_id":"209803f4-b6ac-40bc-97b8-024102ee5865","members":["650fc0df-e0d7-4bfb-860c-8f224e30a3fd"]},{"cluster_id":"6b36db82-3876-45f8-8bf7-ad613dcd8852","members":["135c3530-e90a-45f3-8a06-8ee429d8f40a"]},{"cluster_id":"79cd6f65-ee4d-4695-8b9a-e4b8c86c1536","members":["94e71162-6f12-43d4-ba70-ab877e9b6516"]},{"cluster_id":"153479d3-dde3-44aa-83a6-d7e772a10308","members":["1ab4c62b-51ea-4810-b93f-ee607919f70c"]},{"cluster_id":"1e8a7861-14e4-4a42-b74d-73c7bec3ba5f","members":["3de16f03-4ac2-453c-a425-1cf9f45fa46d"]},{"cluster_id":"5cc3d51d-5e99-492c-82ff-4024c6eb9503","members":["2f16d0f9-a68c-4d59-ba09-140b6999aa36"]},{"cluster_id":"d74efe6e-e929-4c10-ba6b-80c58b26fa38","members":["e1131622-5f85-4824-8567-9c32f350bc73"]},{"cluster_id":"9d971a6e-39d0-4da3-9f9b-e8603acb9bc3","members":["f7b91efc-6423-48b9-97fc-178304a45a95"]},{"cluster_id":"a6afbf41-e20a-4832-891c-6e8ecee24d06","members":["99ad98ff-e094-4304-9d11-5284f0406703"]},{"cluster_id":"dc679e22-e949-4c80-8633-a19ca02db1b0","members":["00c0c884-7362-48f2-ba91-ceea4b4a9e24"]},{"cluster_id":"10c5fb88-3404-4aa6-bc78-257c91344837","members":["71a1364f-ecb0-4cca-ab44-0b2ce7c4be17"]},{"cluster_id":"24751f3d-988c-4f3f-9df5-95b8bdfa7bfb","members":["c5d07542-e14a-4255-890e-b87779f91086"]},{"cluster_id":"3766e219-c028-4750-8fa4-03a0a967da3c","members":["49486281-bb55-4060-a8ab-626377399a5a"]},{"cluster_id":"b04942a2-8d33-487f-9e37-33193a4bf9b5","members":["fa3821ac-e9e0-4a8d-a6f2-d7335a37436b"]},{"cluster_id":"dfab974e-91dd-4ade-9c9d-e89b40d58378","members":["489b9acc-002d-4c9c-aa6a-76cfb525e91d"]},{"cluster_id":"a8ce1bca-58fe-42ba-8464-607d5c5b57e3","members":["83a03f8b-a852-4b0a-831c-c217ae86a7e2"]},{"cluster_id":"c9b1ea29-5b23-4579-928f-8f3b1f3679f1","members":["a119e35c-f046-4c85-b1f1-071ab9bd8e61"]},{"cluster_id":"eab0b5ad-eda0-47fc-89d0-b12331740c85","members":["420f7996-128b-4313-9010-4b8f4e19aef7"]},{"cluster_id":"58588aa2-076a-4527-9fd4-663a7871c357","members":["d94c4350-9ee2-4657-a287-b9cc227a1c8e"]},{"cluster_id":"f3cb116f-ca76-4bba-949e-3c48f31bacfe","members":["ea8a6908-b00d-4ea8-8587-45b94d8b0aa8"]},{"cluster_id":"ce469142-832a-40af-bb9b-acb726cab86d","members":["b21ee972-2f02-48a4-b18a-5d96a751ea4e"]},{"cluster_id":"8b78f548-1c1b-488a-bf4c-04bfe2488f52","members":["665a5e96-ffeb-49b5-a375-bcd7d84ca008"]},{"cluster_id":"31091b5e-03e8-4b81-8a6c-9a3d02b0c681","members":["0406c3cd-e5cb-4516-bf21-63c67e2af8e9"]},{"cluster_id":"aba53f75-eaf6-4231-90b0-0d2dbfd627ce","members":["940d45b3-70e6-46f0-a780-9809a99095b3"]},{"cluster_id":"7cf0c1a9-abc0-4370-b846-45ce5ff4c375","members":["7eea76c1-8239-491a-b86c-c31c9c30d16f"]},{"cluster_id":"0dae78f8-77aa-48f9-a01e-03b3a39b4e44","members":["ba7f3ae8-8319-4da8-85e6-0a669cd417b1"]},{"cluster_id":"3838bfb8-767c-4ce7-8ddf-06338a137af4","members":["0590b5c9-0753-4758-96e1-e5cd76bd1166"]},{"cluster_id":"48334cb3-0717-4823-bc81-52cb1f9c2951","members":["f4f4ef97-8303-45ba-9603-91a3735fb8d5"]},{"cluster_id":"ea5f5123-a57b-4bf9-83c5-18d3a2293db6","members":["305a64ce-3d96-48b9-967b-6c4e672c9be4"]},{"cluster_id":"ba793871-eeec-487b-a1b0-5996d1bd03cf","members":["a34b9494-4eaa-41ab-92cd-bc9b4997f860"]},{"cluster_id":"c80f9729-aadd-4634-8ad6-b098c5a58675","members":["2a499c9f-f3ec-4921-a1eb-3deb54c320c5"]},{"cluster_id":"e2ca3c4e-ab36-4cff-8fb9-fa527a161a3f","members":["fa4aa885-5e37-48f9-8d0a-08d2a35c8175"]},{"cluster_id":"6e13551c-ec8b-48ad-a58c-87108dea4e39","members":["43adff84-61a6-4eb0-af48-ef6a6f1e9198"]},{"cluster_id":"b49e3614-d80a-41ae-8ee2-883e8abec97f","members":["591b54f0-234f-48aa-9b47-5cc82c1a123c","fb6a025b-c13f-4d8d-ae4b-86c9bf023863"]},{"cluster_id":"410a0800-e775-4016-b3ff-cc215bfaf3d1","members":["71402e8a-ca22-40f1-9cd8-a07cfd02c777"]},{"cluster_id":"05905deb-04e3-4e57-afeb-f4e623c176cb","members":["eb954d49-5502-4206-835c-3a10a98118b2","54325ce3-1512-4768-992a-66f0f8e920f0"]},{"cluster_id":"6869c5c6-393d-450f-8dcf-3be81ce4febe","members":["fe4980dc-3fc5-42dd-808a-4f77b6a3e7d5"]},{"cluster_id":"193fcb1e-c985-42f2-8058-34aadbe0ce78","members":["f0ed4a48-5cf3-449b-9af4-4103c61d6ee7"]},{"cluster_id":"2b84f92b-3438-4364-9cac-d11edad425f9","members":["7315e2cf-aa2a-44ac-9b7d-9e4011640123"]},{"cluster_id":"81907f87-685a-467f-b4fe-172f6390378d","members":["be88cd00-7c75-437d-a4ed-2bce23314946"]},{"cluster_id":"ca92e9ac-f88f-40f7-8676-383e3ddbcb77","members":["73355a88-b3ab-4736-9530-0bf8fd22f429"]},{"cluster_id":"72148a6d-891a-4283-bda4-8779feaa1601","members":["e8e77ba2-5e31-4ffc-a630-5e46fb225165"]},{"cluster_id":"1a503dc4-9b3c-4c99-a076-3e0baaa545f3","members":["6e1811d7-a4c1-4a6e-9814-a4a3571c86db"]},{"cluster_id":"694ef2f3-c0e0-41ec-bcd2-314b770e13f3","members":["ee8baadc-7356-435a-b043-e036316c736f"]},{"cluster_id":"5c164c1e-39f8-4082-aad5-890bec3c1681","members":["6771a937-9b7e-4308-8778-5933007f13dd"]},{"cluster_id":"c9514ac7-3548-4b00-95a5-e99c305bf95a","members":["11b64097-6c56-48c5-b7f0-6c66a88ce389"]},{"cluster_id":"a8627187-7d21-463e-a6ef-6ef26a6c6de9","members":["9d2dad3a-95e3-42b2-8f1a-365b650177e9"]},{"cluster_id":"4c7b4cd7-8288-43da-a54d-f22b707dc22e","members":["c0036d38-f86f-43a1-9d36-18b6cd875492"]},{"cluster_id":"e3712e03-c7c7-4373-818a-4c6598fd68df","members":["30306578-b0f0-4d7b-95ec-b7ce6dffad27"]},{"cluster_id":"be8fcb60-f85e-4def-aa6a-bd82881e44d3","members":["fcbc729e-4ebb-4e03-9ba1-bd46577a1afd"]},{"cluster_id":"a5f05825-1201-440d-8dd2-454ae9c16034","members":["1e9aaf0c-a0a3-4e6c-9d50-f3a37bfc6b98"]},{"cluster_id":"d29993d5-ca77-4b15-919e-f95ec679fdca","members":["de11a555-90f2-46ba-89ef-5e92182e5dd3"]},{"cluster_id":"e1667646-95da-4708-8fd5-fef1ce4974fe","members":["fd8214fe-d447-43f4-9384-6c07f29437c1"]},{"cluster_id":"67b88198-8628-4938-a751-4acddbc9098d","members":["bec8002a-957a-4b2d-bd52-ecd09a473411"]},{"cluster_id":"ca6289c9-7aca-44b6-8a18-1a2d2282cd8d","members":["b43897b3-fbd6-4677-96a7-879a951f0d8f"]},{"cluster_id":"49b59607-bcf5-4471-8809-4106f681d4d2","members":["983cf193-fe53-4ef7-9d0a-1e4afaf5d452","d2f0ec5a-c60f-47ad-8641-9bb20c727dd0"]},{"cluster_id":"5d70f462-c3f9-4394-a045-eee646d218c8","members":["39aabe6b-de06-4d4c-bd1c-6b45416c94d9"]},{"cluster_id":"21be5a19-a4c5-4da5-a267-9d6169f7d6f0","members":["73a2d70c-6ae8-4ab3-9243-499877a9229a"]},{"cluster_id":"11eba0ed-7efc-4733-b927-256265e60430","members":["6e6a39f4-391f-45b1-96f8-5db1f260e0dc"]},{"cluster_id":"b88b8f26-8273-40e5-8f02-5f503edd6ce2","members":["8af698c2-5055-44a6-b5f7-112ad08b0b43"]},{"cluster_id":"ed0282a9-1dce-4648-ba02-635146d8d79c","members":["00ab3b97-6e21-4f23-b4c5-3d7a07cef906"]},{"cluster_id":"72521c8d-f680-4322-878b-70c3f47a7f96","members":["54874259-749a-48ec-b11e-773e0bdb8c69","9194eb05-876a-4b47-a2b3-88a2a01df4e0"]},{"cluster_id":"acddf1eb-d6f9-4c70-9523-034fc5a8acd5","members":["3cfde12d-2dad-4c2e-aa55-b283a69f332c","8f6b1e84-266b-412f-bf9f-c4180186fa63"]},{"cluster_id":"43017a0f-25bd-45a1-b94f-31383b0d5c09","members":["efad7ff7-104e-4b5f-9f70-db6054dfedfb"]},{"cluster_id":"c9f98636-16e1-43ce-a03d-d6e0e40dfac6","members":["c7445ec4-c898-413b-ab18-14896d7e1407"]},{"cluster_id":"77a67b7a-5038-4c86-adcc-8306f16e92e1","members":["b77c3439-e11b-4cf4-b980-ef7fa9556cd4"]},{"cluster_id":"4dc1a0fa-5313-4a33-a001-984da53ababb","members":["ac0f6f8a-8d44-4d77-a4f9-b18247cb3c79"]},{"cluster_id":"94f99c45-cd6a-4279-9860-a3fae3c6e14b","members":["002ad764-192c-4309-9aaf-6df338407edf"]},{"cluster_id":"314440c8-19da-496d-8536-f62999889410","members":["762e7eb9-c8a4-4aa9-b191-bee023e61b2e"]},{"cluster_id":"1ccab5e4-b80e-4900-88c8-f5ed9013c0df","members":["980a2f59-eb2c-4c4d-abd3-431daae5ef23"]},{"cluster_id":"c814031b-97fc-4571-859f-e9e8df89373b","members":["3cfad4f3-6fc2-4f26-a834-a43a7b0794b7"]},{"cluster_id":"ca50545a-7854-48c2-bb9c-e0894d7bf854","members":["34b91876-9c9a-4c8c-ba6d-7e30fca86167"]},{"cluster_id":"6c452c9f-8197-4d78-94e1-5bde1551953f","members":["8d356c7e-c604-4cd5-811b-038ceb0c38b0"]},{"cluster_id":"46cde8f4-4b4b-4cae-87a1-063914f15878","members":["57e029f6-f514-4250-98b0-9829baf98d0e"]},{"cluster_id":"7bdac760-2a67-4126-ace8-6bee9660bcc4","members":["05e5f4e3-b600-4ab8-a59e-1dc2981fb49b"]},{"cluster_id":"2fc962c7-e77d-4ca3-a166-4f1d011720db","members":["9e63d817-1f55-40ca-a35c-e00a82a3a99f"]},{"cluster_id":"0b7703f0-770f-46f4-8c70-921a8b6b2ad7","members":["d6ba753b-c0e4-42b7-bd2d-a92f2ee0dbc5"]},{"cluster_id":"2034d9a0-a9ba-4e99-89d7-79e736b91d31","members":["0a98d06d-023c-44a0-9fc5-509d19b38745"]},{"cluster_id":"5540f6ac-c1b9-4d28-95e7-760d9496128d","members":["b5b0482e-4cc2-4e41-ab3d-f19bb86d1812"]},{"cluster_id":"23aed1db-c001-4e2a-9a10-0e9f672d2101","members":["26b3f753-b6a2-48c1-9d6a-cbe595e9cf9a"]},{"cluster_id":"72ff31f6-b46f-456b-85ee-5ab8c2328972","members":["2f9cbcfd-eb09-4056-a5ff-7cf0d1db3fd7"]},{"cluster_id":"05daa73c-fc4c-4000-9d0c-990f237b7870","members":["f70c19fe-3505-4ab2-9ab0-6a45af387624"]},{"cluster_id":"3e6833b5-d7ea-4b12-87f8-2eba62891434","members":["3779b2b4-72ad-4216-a393-f6f1dabd000c"]},{"cluster_id":"fb28be3e-346f-4ae2-b2c5-0971d759b337","members":["b2200702-6b63-4b01-87ff-017000ff0260"]},{"cluster_id":"a2d75661-0f1a-4093-bbb2-d5f9c836dda0","members":["e90e8db6-9ef8-4098-9557-3bea5226e758"]},{"cluster_id":"afcb3ce0-1612-4cdd-a65f-fb2d5a6bf76a","members":["2ed54469-0ca1-4594-b9cd-6a4dd1ac5d39"]},{"cluster_id":"51c1b08d-506f-4dea-874d-a86b8ab55fb1","members":["3ee694bb-64d1-4524-953b-9b6fce34fdc3"]},{"cluster_id":"79b49988-337e-4ff8-a4e9-5a2de271d6d6","members":["b4a79b96-99a9-4a91-b088-49b7050f5b95"]},{"cluster_id":"876fd136-352b-46eb-aeb5-3fca6402213f","members":["5e40c84a-3e2d-4524-9438-1802d3a8cf3f"]},{"cluster_id":"941c849f-959d-4e16-a04f-2de733d8f77c","members":["c005ff75-a064-4a3c-86eb-eb86647b34a4"]},{"cluster_id":"56a382af-0cf2-4fb5-ba8f-a5cad69ed381","members":["05cc23e5-451f-45c4-a3d8-baf02ed8b1cf"]},{"cluster_id":"204fc215-6ab9-4083-b883-b901ca6c7818","members":["14a7a112-b7eb-44ae-885d-f26b79d04d94"]},{"cluster_id":"a4a5f3c7-c987-41f6-9618-486ae48abb68","members":["4a9507d7-da94-42f8-9b2e-a49c83431f77"]},{"cluster_id":"d4a86c9e-1cea-4922-914c-e44e0a71bd5f","members":["c44b7722-081b-4cd1-93d5-faf1089228fa"]},{"cluster_id":"acba4f1a-9129-40e6-80cc-1b3cb9b40341","members":["30571462-7d39-4198-a6af-6fc2f680789c"]},{"cluster_id":"a33e2184-c58d-453d-a647-1ef27ddf5c17","members":["6c2dd03d-486d-4383-8487-648cc09d3bb4"]},{"cluster_id":"51ee5c3c-1ec7-4729-8ed7-80ffe951b756","members":["58eac9be-2d07-44e7-9e0c-987bc00cd292"]},{"cluster_id":"597adccf-df25-4f4a-b01c-58baf036682b","members":["87166f51-253e-4199-a77e-38acc46791b1"]},{"cluster_id":"40850d8d-b18a-4d10-bfba-dd521fe3cd4d","members":["718332a4-dd29-4f25-a473-6e8bd0cb22a3"]},{"cluster_id":"5a08709f-1906-45c5-8ded-3d7e4a3851d0","members":["b82e5675-9079-4d76-af45-acd9d76427b1"]},{"cluster_id":"1352c5e1-e3f4-4bd5-a309-04804d3a9c0a","members":["71aac4ad-c4ba-437f-88e3-7a7dd911dcb1"]},{"cluster_id":"52587d0c-b6c9-4b93-964d-b5598a3e9ddb","members":["2219de3f-c10d-44d9-8348-98d0f76ea054"]},{"cluster_id":"f795636b-a096-4302-aa9e-87494f4166de","members":["4467b4d6-6db4-4ae3-897f-c71b39b99b75"]},{"cluster_id":"c3765121-fe92-4ebe-aef3-b794fa8089f1","members":["fa4768e3-042a-4590-b80d-f9ed21f8bf63"]},{"cluster_id":"f9ebd297-091c-4753-9543-c123ed3c1fc3","members":["3644af40-9a18-458c-9b5a-baa30fcd42af"]},{"cluster_id":"d2d04da3-8b22-4ac9-819e-ca8c7ec67255","members":["ac7d8fef-743f-44d8-8eac-628150b093cb"]},{"cluster_id":"37386c6e-8d47-43fa-9d2e-223bce8f6923","members":["37d16f32-1c1a-4192-9912-dec4b8037c52"]},{"cluster_id":"eb805fd1-c766-4517-8cad-81a53adf5b1e","members":["32886ec4-0e74-4f78-801d-9b086ef6e27b"]},{"cluster_id":"68230774-a51a-4451-9136-5aab1d1fcce9","members":["47b8a608-dcab-4933-8d24-5f247103731b"]},{"cluster_id":"9ec7d104-4eab-4fd5-9ba5-4ccd50945a34","members":["bd31d7a2-a935-4379-88ae-94c01218bbbd"]},{"cluster_id":"fe1c4a63-bcaf-4dd2-88f2-589a45ffdabb","members":["82593280-f906-4578-88d1-6b4e7405ff9c"]},{"cluster_id":"37e4b5f9-aa2b-41cd-b6a4-443e69596bba","members":["c948621e-8d8e-4620-87ae-06fef41b1734"]},{"cluster_id":"9e3e1492-3c76-4be0-979b-239d4deb8c80","members":["e5859b67-f473-4db3-b82a-d4d4fef700e0"]},{"cluster_id":"88c327f9-75c2-480a-8aa8-272d021cabe8","members":["c5a26d30-1663-472e-b98d-390d4844fdbe","e158fda9-8d0a-47f7-b059-e84c1c800e8e"]},{"cluster_id":"b9073e54-b54f-4298-9384-944112b843d7","members":["31934143-3c72-48e5-be8e-a14ffd12d5a4"]},{"cluster_id":"b3af6432-57a3-4958-a1a0-2d28085f3e29","members":["e385647e-3102-4792-bcd1-19242a4fbbde"]},{"cluster_id":"f2b07e8d-84c5-4fbf-bf1e-736428e76d16","members":["e65b3ae6-623b-4823-972e-85f5db1077bd"]},{"cluster_id":"cd8387d2-f3fa-45cb-9628-ef16bef4b5fa","members":["c7568f75-5d33-4f78-ac5f-2b22b319ad9b","43a3c668-1c99-4d67-9f07-2295e4fa2080"]},{"cluster_id":"38dbd9f2-4706-4ca9-a837-817a4ee621f8","members":["e806c81b-121d-4434-b5f9-7d826a8c8157"]},{"cluster_id":"bc23e70d-7b5e-43f0-97b5-b24c31beffb6","members":["7ad1f552-9b72-414f-8930-825c8c13f43b"]},{"cluster_id":"ee1eb50f-e51b-487b-895c-d08085b62fd8","members":["54359d28-7f5e-486b-a6de-9a497f40a798"]},{"cluster_id":"e80fcdb9-26cc-4925-8100-e10e8d09e8d6","members":["87ea2344-d684-49dc-8b7e-74f7e5c8236a"]},{"cluster_id":"7fe41e18-746f-4276-85f6-d30d85eaa538","members":["866df254-eab6-4e0f-9839-df235e8e45c8"]},{"cluster_id":"329efe6d-0194-47fc-abcf-cc9c3ee312f8","members":["91e53de0-d41e-4e9b-8346-05a13a63aaea"]},{"cluster_id":"ca62b0d7-872b-4a9c-b006-86ccfd239161","members":["268d049a-ff0d-446c-892e-be63bae981f7"]},{"cluster_id":"1b2e8a52-7038-453e-802e-e2b6d0c4da48","members":["b3bf3acf-8658-4438-8fc3-9121b6ef3cf4"]},{"cluster_id":"8ec5c238-a613-4762-a252-bba4045dc17b","members":["a6a0d394-94e6-4004-b0a4-e2a766da0990"]},{"cluster_id":"d26a88d8-31d1-4986-9e0c-b30944f01491","members":["0b9816b1-a151-4873-868b-f96734498575"]},{"cluster_id":"bb00bd4b-2a33-4849-ae7f-804463c9c453","members":["bde486b8-5144-404b-8859-bb1c36e4a7cb"]},{"cluster_id":"0709871d-a6ab-4aa2-93bf-03bb443f89a9","members":["19c2f557-90c5-4d02-b5b7-4fe2bedf2697"]},{"cluster_id":"ed413a70-b4e1-4736-9370-9237ebadaa06","members":["ef8d9f19-4eb5-4e71-90c2-29af1784a1a7"]},{"cluster_id":"53368f02-d082-40dc-87de-4a43534eebcb","members":["f7f58c67-cfd7-44a8-bed6-6d2cf84f1177"]},{"cluster_id":"fb8d8d1e-9afb-496a-b65d-ca304c598e8b","members":["1aac101d-dacc-4be2-a5ce-3356f3be8bba"]},{"cluster_id":"36e1cdef-b33a-4858-bed1-0bbaf9ed9bc4","members":["20b68f2c-ede3-4b79-8b30-f4f92f82e291"]},{"cluster_id":"80becc29-3509-4795-9714-7ee69f928767","members":["df8f7af0-995d-4491-b720-0ed74aff1bd7"]},{"cluster_id":"84599781-5c1d-4670-83ce-2909c7c1b4c9","members":["9ba5945d-a92f-4753-8e7c-6950d4334327"]},{"cluster_id":"14786248-4bb0-4ea2-9421-150787f5ff33","members":["8f16a64f-19ca-4010-9a3a-d0d2f845c4e9"]},{"cluster_id":"14f2fead-e1a2-4e74-b696-6e535d49d9d6","members":["5a10c5b4-40de-4c27-bc08-d2db418600f5"]},{"cluster_id":"c555ba02-3f53-4880-89cc-6382472f4518","members":["24a7bb0e-8f0b-4530-9cd4-877c382ceb83"]},{"cluster_id":"603bb3bf-f1f7-4182-8a09-670b111a3fe8","members":["4bdfc6c9-8b0d-4081-9009-7df88df8ca84"]},{"cluster_id":"76382e4c-a4a2-4fb5-bc4f-138c970156c3","members":["56f50319-d69b-4260-b71b-2e15ce63525b"]},{"cluster_id":"a08b7547-a0f1-452b-9b55-18b72ad44763","members":["57973400-71de-4136-93ea-3cd72006e34b"]},{"cluster_id":"65022a70-336c-4701-8443-508f49365fb4","members":["bb766db9-0ed3-48fa-a230-75de0238867f"]},{"cluster_id":"6ea91435-3e36-4fbf-82c3-faa6793916cf","members":["6ddf7466-bb26-4196-b780-b6a7d105ddc9"]},{"cluster_id":"114c5c62-e2bf-4ad2-a913-3744fd25a373","members":["5ec8ac77-d6c6-4b49-ad58-6e7ed13bc035"]},{"cluster_id":"df948051-689d-40a8-ad8a-28a2dedfe405","members":["3a16f7f5-193e-45b4-9365-51e6a77e3c98"]},{"cluster_id":"8f35aa71-39a9-43b6-9e1f-9db20e05a30e","members":["a591ba5f-94a6-48b5-ac58-cad39c32c43b"]},{"cluster_id":"182dd0dd-1319-4405-9396-03bc211809ae","members":["24d68e62-8527-4803-a6fa-26ca777c2034"]},{"cluster_id":"66195131-3ad8-4241-a0d6-4ab7e32c6962","members":["0d0f16d3-7244-40d6-8623-7bbc698bb8c1"]},{"cluster_id":"89a3e6a9-addb-4b72-822c-a5a7371734c9","members":["778d9125-bcbc-4421-8105-7e56bba3ac9c"]},{"cluster_id":"d23ce59c-1b68-42d1-aa3b-b8143bbd9381","members":["9fedbf3b-a1f8-43c1-a02f-d7906d208ace"]},{"cluster_id":"7d9d58bd-39b4-4188-a92b-2b9d72ec8bda","members":["ee2b5dde-c6a4-44e6-91e9-f790e10f5c1a"]},{"cluster_id":"093f494f-e108-4f07-9dbc-35136554407c","members":["a455b48b-d608-4d35-8e42-fb15238e3c1e"]},{"cluster_id":"32156667-7185-4800-9042-38e82870feff","members":["3042955d-53a1-4769-a6b6-37d95536e374"]},{"cluster_id":"a51db09c-f39d-441d-9164-06ba998d58ef","members":["0c0c7555-4cc9-4ac2-8d94-c6de26942ea5"]},{"cluster_id":"977581f8-a92f-4a60-b0ab-96b42b1d0d8d","members":["1746fc40-2a42-4e97-a0c1-37b0a4e68a4a"]},{"cluster_id":"912fe4ed-bb41-46a5-adbb-0dc779234edb","members":["a2d84b93-0df4-4e63-9670-f3d9a9a9dc14"]},{"cluster_id":"6ff9b10a-54cf-4a58-8655-1ec5ccd1ae56","members":["064c16c3-68f4-41b1-be9e-990d256b0466"]},{"cluster_id":"907e5aa7-c645-41eb-a469-330fec247119","members":["e72daad4-3b24-4846-a74e-4a1d8b895eda"]},{"cluster_id":"783dc097-3e45-45ff-9e18-33ccfd6d47cc","members":["c70dff2c-a58e-47a1-af56-83c11341163f"]},{"cluster_id":"2bf12fd5-52d9-43a7-9a2b-ede63bb26438","members":["cbb7f4ca-acb8-4b3e-a9d2-1cc7a9064d6d"]},{"cluster_id":"eaeb1421-7550-4957-9610-ed74a0bffc8e","members":["448455c0-dec0-4c30-9c5f-aab743506784"]},{"cluster_id":"9d882154-e197-4475-b27e-35c54fe8fbfd","members":["9d0098f8-dd9a-46f3-84b1-d414eaa77b49"]},{"cluster_id":"a868051f-7c6b-4631-b5c0-5298f1a4a3bc","members":["03fc25c8-6565-4956-b018-43689aad9c23"]},{"cluster_id":"5e94868b-1054-4680-801c-eccafab6e048","members":["6d0467df-7983-4515-ac57-1f12a57ca12b"]},{"cluster_id":"6b198d6b-8dea-4096-80f2-e19aa989c1d0","members":["251313a8-e1f4-418f-b7ec-999fc0fb8382"]},{"cluster_id":"c0fe2a1f-22f3-4601-9b6c-36727a9d81a9","members":["5e82075f-1456-452c-aa6b-fdc95e1abdbf"]},{"cluster_id":"0a56e25c-3625-49c1-8cd1-fb3ddd10b2d3","members":["5fceb450-5102-4bbc-9eb7-6c8ec2ddac81"]},{"cluster_id":"6c82fce7-dc95-4a42-b643-38f90297f22f","members":["4de30eb0-80c4-47bc-aef3-b0084f707f82"]},{"cluster_id":"9f093a15-003e-4c3e-b942-5c6cfb87c05d","members":["7ff40f6e-eaec-4880-9537-3c9b00bbca5b"]},{"cluster_id":"cb95b455-562f-46e4-96a7-2aa2409fed5d","members":["3a076af1-11af-418f-aa40-3c6fa44ee4d0"]},{"cluster_id":"51ccaad9-0af3-4189-abe9-de4b65c38edd","members":["0be4bc5c-7b5a-4ef4-a8d4-07615ddc8057"]},{"cluster_id":"bfee71d5-dc3e-4049-85bd-25e416b8ce0f","members":["175cfdfb-482b-40b7-841b-1ab0f30b4ad4"]},{"cluster_id":"3e8cbb71-09f5-4d7a-9358-2ef082adc4f1","members":["dc0c35f8-e154-4f77-9985-1c9b26049328"]},{"cluster_id":"77f85883-e69f-43a1-9e7c-0df03c9438b4","members":["1046d912-9eb5-473e-b1e3-e44a58d9efc5"]},{"cluster_id":"822c1997-a0a2-41cb-9793-22c777eab1a6","members":["20687b4c-4568-43d0-a364-3e7b62415b93"]},{"cluster_id":"c4596456-6844-4eff-9082-8a0cfee4acfd","members":["ebed6d47-3655-4cdb-9e0d-3e4b8b5250f4"]},{"cluster_id":"f3ad65a5-41f2-46d7-a4ab-cdfd0feea00d","members":["624a8794-6072-4c14-b064-3cd0f7176f27"]},{"cluster_id":"eff030fc-3925-4754-bd4e-8589b262523a","members":["ca820777-5138-42b0-83f8-a271af01a0d5"]},{"cluster_id":"31351498-4fc3-4c6e-8df2-7c515d19509b","members":["c41b52a3-cc15-4d6a-a1f7-a2b34b2bbbf9"]},{"cluster_id":"6a03d110-92cd-4da9-913a-56888b17641f","members":["9353fc2d-ebee-4790-a39e-97f99d698f2c"]},{"cluster_id":"2f12da3e-336e-40d2-ba41-61b838ad70f2","members":["91b4971b-0ca4-497f-b743-324a75fb24ec"]},{"cluster_id":"86986259-8535-49c7-b1f7-162a0bd7065f","members":["05a8230a-9e18-47f4-a599-5a2e22951aa4"]},{"cluster_id":"46b53499-f467-4b91-a839-e6551db764a7","members":["5d26cae6-70ae-4538-bffb-13c8cfdd12d3"]},{"cluster_id":"46187cfd-07e9-43ce-ade9-ed6a220120f1","members":["4b497d85-1ab7-4531-878e-a50a0bcdacd6"]},{"cluster_id":"0f1dfea7-22b4-4df1-ad86-305165ef36ec","members":["a02608af-40bb-43d5-8e01-4571f9e25918"]},{"cluster_id":"92103df4-5a66-4430-95e6-d2ba83f705a1","members":["e13fe5cc-b563-4cc5-b79a-229ae44115f0"]},{"cluster_id":"25733340-8065-4c67-9da5-97f671877eea","members":["137c3a2c-b285-4f79-9f8e-668e81a104a3"]},{"cluster_id":"911f995f-4932-433d-afa5-fabf5bc995f7","members":["5682313f-865a-458f-8e62-452d573278ed"]},{"cluster_id":"b89167c2-18ac-44c5-84c6-4b246cc9bd50","members":["a4320de0-a712-485f-abda-679489aa1b6c"]},{"cluster_id":"b4e6a6dd-1e51-4a7f-a1bb-cfc861598a03","members":["0f7061b6-6043-4410-b704-61d7dd78a521"]},{"cluster_id":"bd9f40ee-8b97-4557-aa2d-1a87da031fda","members":["44da0a37-f82c-4cad-bfe5-e204c1db5323"]},{"cluster_id":"4e48f414-895d-4241-a8ae-69662f5c3d46","members":["53494bc0-80d7-4d7e-96ba-5759ddcd5040"]},{"cluster_id":"e4ca57af-fa5a-4a42-8e77-8ccc8efd6660","members":["e8eb66b4-7cc2-4c98-9599-381d976cafd3"]},{"cluster_id":"b223bdd2-4e37-4cb0-a50b-feb184bdfe78","members":["738d2afd-7833-497f-8017-f2aabab1b1a4"]},{"cluster_id":"e47fcd0d-6eef-4992-8b24-a772ebce5f31","members":["8fd28181-b001-45e4-9ee3-ed5e32911dcf"]},{"cluster_id":"cb02ee47-9033-4860-896e-93d4dd3bca66","members":["65cee6b7-dc37-42c9-8eed-7fba599b7d7e"]},{"cluster_id":"d77acdbb-aa93-4e79-8f2a-2afe86ba39c8","members":["e5178884-c3bd-49ae-b6c3-45172799ae66"]},{"cluster_id":"0a822774-2208-4f62-a8c9-3dc70aeef8ea","members":["098bcd9d-ddf1-4c65-b0fc-34b8bea61b74"]},{"cluster_id":"474921fd-8a8d-4c36-8ea4-d0c78016b2c8","members":["80eae812-9302-4821-b61e-1bdd4f3addec"]},{"cluster_id":"f9f83549-19b2-4c63-8024-bec6ccd4b48e","members":["23224cad-e128-4f5a-a52e-22a839d6851d"]},{"cluster_id":"1b9aa65f-dcda-40ea-bbc1-8c1521f177ad","members":["5d6028ad-e08a-4e90-a37d-73ad42daa692","97af48fd-228b-4ae1-8b4b-c1d114bd42f2"]},{"cluster_id":"97137b20-3c93-43e9-b1a9-879cf76db9bf","members":["acdbdbb6-8f0c-4877-9f47-0cffb856d645"]},{"cluster_id":"f69427e1-c0af-413b-916d-3232db85e095","members":["af2cd870-1bfd-4c78-8511-26fb2be73bd3"]},{"cluster_id":"d88a7e63-a270-4d1c-9493-0a86c58b3e3e","members":["2f77db8a-bdb2-4505-bafa-638be4613c24"]},{"cluster_id":"9a525fe9-9fb6-41e1-85e3-967787b02690","members":["282392b6-8e67-4518-bf69-6d86fe0553bd"]},{"cluster_id":"51de12f3-d554-4161-b0ec-4b2186f0cb26","members":["a082ac54-2c02-41a7-ac77-27b198d48fa6"]},{"cluster_id":"0be1925a-4753-4905-9510-39b869eaa6c5","members":["ff0e6625-2708-48a0-a9cf-76e34d20b270"]},{"cluster_id":"eb9b2ee9-7136-4b80-93fc-c731e2546e36","members":["de7c7a6e-0670-4c9f-aaba-f57baab5ab18"]},{"cluster_id":"7e444e77-337a-4bc6-8707-11c965b7d9dd","members":["a928cfbf-3c70-4ff1-a75c-c403bb49867c"]},{"cluster_id":"ae0aa30d-b0b4-4bf5-a41e-7d8900417e46","members":["c356e4eb-e27d-4a3e-abe8-009c48fde26a"]},{"cluster_id":"877d0ee7-3726-4284-a1ed-d3b7c9b6d67b","members":["16612cfd-8068-41f7-8172-2f740d431c9e"]},{"cluster_id":"b61c8bad-f744-4e5e-908b-0b070a8f0d89","members":["a555c8b9-1afa-4f97-b4dc-4481e73cbc26"]},{"cluster_id":"582e1668-0621-414e-a531-9d7ad55393e8","members":["8d221e15-abaa-4b86-bcd8-6c8f3992df82"]},{"cluster_id":"634e943b-2d48-48b0-b1e8-52524e278a9f","members":["35abddd0-8c9c-4eac-8f42-8331b2dc89b2"]},{"cluster_id":"b98f7184-2007-47d3-9d06-42431c2a8c92","members":["fc2341a7-a527-42d8-9b4e-47a15bdee23c"]},{"cluster_id":"efefa709-c6f7-4ec6-ac92-9ac520723e87","members":["c3c8f8e1-9283-4b90-97ed-3ac662aafa45"]},{"cluster_id":"32e37585-3bd0-4873-ab47-c364fef5143f","members":["5331b603-f4f9-4c0e-8c5f-004eb0a84c42"]},{"cluster_id":"d3a45ffa-7001-4495-9c5e-b65ea28becba","members":["f1f95a39-34bc-46b6-8e23-9f376df7ccce"]},{"cluster_id":"7e78bb5c-524d-46ad-855f-72bd9413c27e","members":["3f8fdb93-471b-47ba-b68a-64e3317ebb5f"]},{"cluster_id":"43d693d1-43e9-41bf-9f49-b7662edb6922","members":["007f723c-0723-48e4-b50f-8d0dfe461ddb"]},{"cluster_id":"3b30bb51-81c4-40b5-ba0f-a5b24a020dc5","members":["373910f6-e433-4432-8fd1-36130b42aa58"]},{"cluster_id":"d6692fd4-0be3-4dc0-8e52-422dc764cb03","members":["bc88db62-48ed-4917-9bb5-a865c3d0db76"]},{"cluster_id":"b1943af1-84eb-4734-88d0-58f88d216275","members":["5288810b-8f88-4c33-a5e1-554dc6f37a57"]},{"cluster_id":"6eee7591-18a7-498f-a4ad-f5aae119dd62","members":["0c565dd5-edf4-4578-986c-6641418f5db6"]},{"cluster_id":"2867ef8f-0ebb-45b2-b82a-289a3f763133","members":["5708038d-77b5-4d13-a3e0-17bf63cb3747"]},{"cluster_id":"8cf3def2-907f-4b61-b37f-0d9e2ed2b954","members":["b8e1aa44-e0a9-4ac8-84c4-9b8d11ecc023"]},{"cluster_id":"1b8d5fdd-83db-44f0-aa44-0aa853c3b3f8","members":["334e0219-555f-4c2a-9e39-8bf18a633bfc"]},{"cluster_id":"abfe0416-9747-4ab8-9cdc-8e88fa47871d","members":["27059d4c-ff52-4e1d-be06-22d58f3310cb"]},{"cluster_id":"b69ad8c1-f3a2-41d7-805d-8cc01784789b","members":["c3bdd91c-c749-452e-9569-4a2f9ae816b5"]},{"cluster_id":"b25f7b20-354c-43f5-90f3-fd9a86b1ae72","members":["465078fd-c082-499c-a845-cc0d9d17870a"]},{"cluster_id":"7bf16433-80b0-4f9a-878b-7a95d835ad86","members":["64c5c7aa-d736-4d89-ae48-bfbe4db56db1"]},{"cluster_id":"54513007-2bf5-4c3c-8060-c65d26b45075","members":["1ad1da71-c024-4520-94ef-d41f9192778d"]},{"cluster_id":"b060d900-983c-47b6-b9e8-d31f4dbd3db1","members":["ccbb31ba-c8f7-4e64-8d55-3478e29a9482"]},{"cluster_id":"4fdaa1a3-7430-423b-81e3-be520cdd6936","members":["337fa8d2-b644-433d-b4e8-bdefe78aa9cf","00a0ec8c-2e64-4107-82df-2cdb7d4833de"]},{"cluster_id":"10142c53-0aae-468e-a5f8-9d5313be2cf3","members":["12665c7c-4759-4bff-8dd9-6ffe68c66a7e"]},{"cluster_id":"966cca08-6c6e-46f9-8145-7138653fe7a5","members":["f4b0e001-14ea-4e19-9fd3-d2673261ef60"]},{"cluster_id":"e6aabf8d-023e-4060-ae58-13d0d54f160c","members":["589cf6ad-04e0-4e4e-823a-bb0feaeeec39"]},{"cluster_id":"ab9082a7-9db5-4c59-ad04-1242dca4509b","members":["e175e96e-c4ee-4119-a591-68c65331d271"]},{"cluster_id":"866d952f-2947-45b5-a10f-e756e9288018","members":["f228463b-3209-4ab5-b4b1-b2e7c7ef4fa7"]},{"cluster_id":"2972bcbb-a2e7-4468-bfb2-f2945b01a243","members":["65c93c29-c19f-4bfb-adce-c6ff88be5baf"]},{"cluster_id":"991ef8e4-a40d-47b2-ae87-93bed03c964e","members":["79a8797d-4911-444f-adbd-25112da20ee6"]},{"cluster_id":"1d8821bb-7f0e-41b4-86e3-603f9228f781","members":["17c165a7-f46b-434b-b40d-59beec4cf8f0"]},{"cluster_id":"0e1e3fbc-262d-409a-9734-949f40c46427","members":["6bc80891-f4c9-43ca-83b2-d406d3cced6e"]},{"cluster_id":"270c2a25-c40e-45fd-b4d9-9d1e09305cbf","members":["52a4d931-645e-4f35-b15b-21d72e941182"]},{"cluster_id":"59e94cb9-614a-49f2-a91e-9928ad318f00","members":["9371a93f-f012-48ac-a32f-1459138040b5"]},{"cluster_id":"4ab57529-2a41-4128-8cf2-496255864fad","members":["8fee9afa-94f1-4d3b-b00b-698f144156eb"]},{"cluster_id":"a68c5350-6903-408f-b32c-4015ed05945f","members":["d974f925-7d5b-4af9-b23c-9339c4d670e2"]},{"cluster_id":"28b85f28-71e6-4dde-8680-88495b7aecd4","members":["5d64db84-5725-45de-a4cc-af6f00b0de13"]},{"cluster_id":"04828ccc-4133-4cf2-961b-b8fc2a3c6d43","members":["81cb26cc-7a20-435f-9938-82133fb91546"]},{"cluster_id":"277f2c0e-e3d5-4e58-a3ad-823177ebe3dc","members":["810c1c1b-61db-4b62-a549-c29cdde268e4"]},{"cluster_id":"6f732a42-b524-4da0-a300-f64610c49d4f","members":["b080216c-ca3d-4222-b50b-c56fcb284fb6"]},{"cluster_id":"3a969b37-0ab9-41ab-b145-dd3f362c8638","members":["b7cdada0-3565-44e2-89d4-19e85b983dfa"]},{"cluster_id":"816b8091-ba27-40e8-864f-f38a64991c28","members":["6bf7b171-73de-4735-b6ae-d178c397473c"]},{"cluster_id":"ad1bfd32-94c7-4e45-b536-bb4b7ea9411e","members":["c66b4692-19b9-41a5-a090-ccb6f50a7e2a"]},{"cluster_id":"3f4370f6-6231-416d-9478-d27156c80526","members":["550b2a2d-7bd6-4a73-9e39-0824d7ae2d79"]},{"cluster_id":"3addd54f-eb0f-4cbc-93e6-9436080208cb","members":["1f7261c4-80f3-49e0-af1b-986a26c89dd7"]},{"cluster_id":"a3d3cf62-c1c3-483c-82f2-aeee46f578e5","members":["a5b7f496-f670-4373-ba88-6a8ab16932fa"]},{"cluster_id":"89bf1ecc-4cb1-4aca-b3f3-c9c14a8868b7","members":["82697b90-a087-4e35-b0f9-705fd9546781"]},{"cluster_id":"aa27d9a6-1fd7-4a19-84c5-5bd88d623d31","members":["7db588eb-ddae-490a-8882-0fbf8d168f6d"]},{"cluster_id":"7150af87-53e1-42a1-8fa3-98b8c7ea1c84","members":["28580450-6272-4d02-9a2c-f19fc0a0cadf"]},{"cluster_id":"bf33acab-5a50-4871-8114-2bad5bcedb80","members":["9fc21c98-7526-4b78-ae62-cd995e88e0a4"]},{"cluster_id":"f3afa262-5d02-4bc0-8506-783a0bf09d56","members":["56840951-e957-4b40-8408-90e8fe903357"]},{"cluster_id":"d84db030-75db-4735-a947-d4f90e4deae5","members":["699e06aa-9b2f-4b4f-9f76-95fc574a0ffd"]},{"cluster_id":"dcb6ab3b-ae6e-4735-8a60-de8d2d30332a","members":["c51c441b-f875-4e14-b8a1-63786973cd3a"]},{"cluster_id":"d8065be4-6b3d-42e3-9693-9cfaa110346b","members":["95fb97ff-0415-4bba-8c78-d0c21ca3e4e2"]},{"cluster_id":"f5ceefb1-12c2-41ea-b95c-18c5038560bd","members":["9ec6a6f6-9490-4023-93e3-c850eb34c1f3"]},{"cluster_id":"5e55d80c-dfc7-448b-bcef-ae880cfffcd6","members":["7124b769-715f-42dd-a1ef-40df517223f7"]},{"cluster_id":"45429530-4dcd-414e-8a37-8555d0144899","members":["f427e28d-21d4-4a63-a8a1-00ccd3887e93"]},{"cluster_id":"3349d8e0-ebe5-4359-bb8d-083c8d3a9420","members":["9ab78178-379e-4730-812d-2e5b680528b8"]},{"cluster_id":"f3941de8-4943-41e7-80e9-773a7b8e51ab","members":["819dffb2-0572-4f90-92c6-c41eef6a76e0"]},{"cluster_id":"d82f7ea1-b85f-4ff3-af04-e3f09ca89458","members":["6d137a2b-7c97-41ae-95ba-3135144296c6"]},{"cluster_id":"90dfa891-ea54-44ec-9c4c-37a32cc92299","members":["65dc0e58-bf84-41b7-b9dc-c03b479517c1"]},{"cluster_id":"eb91a168-c109-40bf-9679-0913a309af40","members":["21a58d87-2911-4e0f-ac4e-1eab6d209d8e"]},{"cluster_id":"8bfd9054-2484-4b95-af6e-1881fb8804d9","members":["252a33a2-7596-4ebc-813c-cd41a36e4854"]},{"cluster_id":"085a40bb-586e-4634-99d1-21c6d1eb5884","members":["aac50ae1-a885-4137-b384-62bb31844f54"]},{"cluster_id":"c3301dce-0e38-4465-b94b-ee10e64f783a","members":["899e6a00-6f74-4b8e-a39f-40b710e636c9"]},{"cluster_id":"0ebb4caf-dfd8-4139-8988-6c07a96c4bd2","members":["c3447a89-06cf-43fa-8a0e-fbac8fce1614"]},{"cluster_id":"7202d20f-cf9b-4054-aa24-3edfd3064cd7","members":["b835e906-d882-41eb-9501-c849698aac45"]},{"cluster_id":"719904eb-28ef-4b29-997b-23331e60e444","members":["68b756d7-f0c3-4d46-94c9-32214154be65"]},{"cluster_id":"f2253ad2-0cf7-4f4d-a01d-da6760a12103","members":["dd761619-d96b-428f-892c-73f53aa52d08"]},{"cluster_id":"5f1d9f8e-2516-4e42-a0a6-815bb97110a4","members":["5984d932-6e0d-489b-85b7-61da3f544b00"]},{"cluster_id":"06aade08-3010-4d09-90ab-647cfcc26947","members":["7d2a6301-1e44-4b4c-9a93-336484d1b689"]},{"cluster_id":"df241613-e669-4ee0-b143-f0b24cc846e8","members":["cce8b016-f0dd-402a-88fc-d8fbdd754c14"]},{"cluster_id":"761f3fb6-5695-42a3-ba7c-8aee7df904b2","members":["34a9fd8b-13bb-4d40-aaa2-c66e0122e71c"]},{"cluster_id":"44bced9f-9cdf-42b9-a5c2-b5abf31749ea","members":["473cbecc-ca21-4835-9483-63711d14e0a1"]},{"cluster_id":"d28f03f1-166f-4e7a-a151-3bb7c1898209","members":["a6669dc9-5788-4322-affc-8536d6461d31"]},{"cluster_id":"181a2d12-ad30-4552-bb72-ee9a984fa618","members":["cc4063b3-4027-43d0-b1c9-66dd68822ae0"]},{"cluster_id":"5cb4afbf-e109-4c74-8315-a2a58d421c9c","members":["dd453d27-3f21-498c-84bf-f8587daa8696"]},{"cluster_id":"876a2333-137a-4c81-9d16-99847f2af4cc","members":["55b1edd0-40e0-43cb-bcab-dd9c2b23313d"]},{"cluster_id":"5f7469b6-8252-4966-99ba-b5fdff4dbf90","members":["33721b3a-5cdc-443e-8599-43e7d7955653"]},{"cluster_id":"265185dd-7e1c-462b-bd12-3ea2079d23c8","members":["f762beea-6bb1-4d3b-993d-f8e4bc97273b"]},{"cluster_id":"d9eedc94-d312-4947-bb37-d1fdd95dcdd4","members":["fffa8076-beec-4801-9da0-5fd5da0a9ad7"]},{"cluster_id":"ae8f7a24-2c15-4f25-983d-6c8e3d8467ec","members":["8cfe2e5e-b34d-4b5f-ae79-3e932c830bf2"]},{"cluster_id":"17bcb338-5ed9-498a-8f4b-407445dec65f","members":["bfd30f43-97af-4390-9f37-9bb404565a96"]},{"cluster_id":"edeb68e2-0660-4461-9b92-dd0ab5f321a1","members":["221f03ad-dab7-49eb-b731-a3a3aa267d2a"]},{"cluster_id":"bea2fa8c-8f73-40e8-949c-4bf3e53cc1a7","members":["c6593794-fb12-4c9f-a31a-9bf8f3922e3d"]},{"cluster_id":"df3f868f-20bc-4768-8496-fc1bc0744474","members":["20a0b653-3a14-4146-a66f-02dc074c2da9"]},{"cluster_id":"bd0d52ba-bf23-4db8-aa70-86556a4740bf","members":["2d712861-399b-43c7-94f1-2d30b47a4e13"]},{"cluster_id":"8cad6289-2663-4a76-816f-85ae55214831","members":["13b4f8bd-1e4b-46c7-9f06-f8acb44b5eff"]},{"cluster_id":"6b6a1ba0-8a8c-4bf1-9799-4a4ce9b1d916","members":["6e5270e8-581e-4a73-876e-199bffc453fe"]},{"cluster_id":"91b087d8-4803-4bcf-911f-18dca461d16f","members":["6e9b56c2-1846-4a98-a834-cc0f642212d2"]},{"cluster_id":"f6908b42-dc9a-453f-aa2c-203da06764cf","members":["4d71a58c-31b8-4ef3-96bb-15762eaa2eee"]},{"cluster_id":"745f9d2c-8956-422e-91cf-53ea37e70f82","members":["45ebb88b-bf33-4fba-9eec-b607bc7fcfae"]},{"cluster_id":"18cfbf44-b988-4dd5-866b-73fc693898aa","members":["069a2f64-e114-4ae3-b560-fee65a490053"]},{"cluster_id":"4cf126e0-d7f3-4437-b125-365b11c65d70","members":["cf25d15d-0e56-4196-8bd6-b1dd2623d721"]},{"cluster_id":"a305ffe3-19c3-481a-9058-4247bca4ca01","members":["f56b635b-046a-4a07-a7a4-5dbed4e93211"]},{"cluster_id":"230bb8e2-d4ad-487c-a1d7-42ba2ea0e5cc","members":["e32952af-965a-4a63-ba6b-a39cf2c81ff6"]},{"cluster_id":"12a67c1f-74e3-4d9a-8a6a-adbec88544da","members":["f6b553c2-e6b2-4faf-9a69-26959b763881"]},{"cluster_id":"ddb6cf7a-94d8-482f-b5e3-c86b7fa8181d","members":["d720c73e-98a8-47f5-a0ac-7e558e0ca630"]},{"cluster_id":"7dec92f2-1d70-4104-bd41-d9c058b2c5ef","members":["f0b094b1-7f25-47a8-9482-96e4884c43bd"]},{"cluster_id":"b9a01b27-65e1-4a9d-9166-e606cea6425c","members":["a17c93dc-3520-401e-836b-e0f5271b501e"]},{"cluster_id":"e6b11bad-8ee1-43f8-a49c-9856a434923a","members":["b8af46a0-ca5b-496e-b89a-7bd1510de742"]},{"cluster_id":"23b2fb05-29fc-4502-9ecd-a47d0a63076b","members":["6c9c2bf7-38e2-471a-b041-0a9da2658639"]},{"cluster_id":"749b6cb0-84a3-49bb-a39c-84a371599d47","members":["c2f3e630-f08f-47fd-b98a-fae1a6a78b87"]},{"cluster_id":"1343596d-8a4d-4776-9d4a-d41490b7cb7b","members":["b7586629-3176-4504-9dae-01e07234abba"]},{"cluster_id":"28640c6e-e7eb-4b38-b099-8b9d347bd04a","members":["b973d87c-9102-4220-874e-88d661ccab11"]},{"cluster_id":"99266a9c-deac-4cbf-b039-93976c0d571b","members":["ac87588b-bc99-4d48-8233-a5daf7fc1a53"]},{"cluster_id":"06d3a2ea-1d2f-4456-9c1f-ca559e4c2f36","members":["c489a63d-e632-4a3d-8efe-40552e4c6545"]},{"cluster_id":"10a6dfe0-81d0-453e-9f23-e9792fa39675","members":["ba122ebc-29b7-4ac8-b2ae-a36bb297bce4"]},{"cluster_id":"0a7daf16-3825-48ce-beb6-0161de293451","members":["8fedb62c-7243-4ccc-9df8-dad2d50416e5"]},{"cluster_id":"f544e1b7-c2c0-4236-9e51-6a506ee25e3f","members":["049c387f-d38b-493e-80c0-9209a0fc42ec"]},{"cluster_id":"00bb78a2-a394-4745-839f-91ae646e4371","members":["f404d690-a7bd-4f1c-a5e0-7f1735b9720c"]},{"cluster_id":"27d190cd-822a-4b37-b138-1b1b73c5196b","members":["d7ba524a-1bbd-40da-96de-92ca7fdcf38a"]},{"cluster_id":"c2fa4be0-a63f-4b63-922e-7a118484c3c8","members":["6204f81c-dfd9-47d7-8753-4c2c8239bd26"]},{"cluster_id":"4cf2f8c5-1a2b-498f-87b4-2397e881640d","members":["33a0e312-cbc6-4d2b-96b2-ab0d852134dd"]},{"cluster_id":"35b591b0-9a65-46c0-95aa-caf3b8dedd33","members":["851fc306-2f78-48f7-b113-7dce1164a69d","7a0e5497-26f7-4bf3-b1ce-9acfada7df29"]},{"cluster_id":"4ae785fa-8876-494b-8048-bcaeeb28e317","members":["3e3750ac-2b6b-430a-aa67-2bfc15bcfa67"]},{"cluster_id":"c829d647-4388-40da-86fd-479a810865ab","members":["6323d3ca-f688-48d5-9fab-83b587579296"]},{"cluster_id":"44bec0d6-7c8b-4869-801c-2ac35f38611d","members":["9150a81d-6528-4275-b8a8-a9a1706e24bf"]},{"cluster_id":"89b0a4a3-f393-4706-9a25-8103c69b53d6","members":["8d625518-abdd-441a-b740-7b507d8c73e8"]},{"cluster_id":"80a104b6-58c7-416b-ac35-97712361953c","members":["aa7f6c28-3a60-47d1-9301-c2ced8a6c136"]},{"cluster_id":"523ae438-64cf-40ea-839d-1a30cbcf4c63","members":["36f28729-fe34-4e6d-b99e-ee9fcaa7c05f"]},{"cluster_id":"690e2bf8-3db0-482f-a93c-22f6a0d56631","members":["1c7cedb5-74a3-41a2-82f3-ff92f5641ead"]},{"cluster_id":"1ee29b00-1c04-4d47-871a-4fc6d43200cc","members":["97979628-3420-44ec-aef8-12b24f583328"]},{"cluster_id":"ca4d9210-71b4-4ac8-bc7c-f9b4e1772523","members":["41966921-2f3e-42bb-b09a-495a25971795"]},{"cluster_id":"baaa2ca3-1dde-42fe-ad1f-1aae3e927027","members":["6ed59500-2ddc-47f5-ba2d-8ade023152f5"]},{"cluster_id":"ffbf8347-0223-4c98-b559-e6237b6aac90","members":["e270824c-080c-4953-bf30-6c931abd61b9"]},{"cluster_id":"4c2caa9f-9774-4e83-aa42-f46bf17280b7","members":["d4bdac66-4616-4c2f-83ac-7682a496fc28"]},{"cluster_id":"c124b047-b324-4618-8299-a88ecac6f400","members":["91edbaa3-c938-4cc3-b2ce-252d3114fae5"]},{"cluster_id":"0e2b1f45-559d-4cae-9f78-dbca6d3f4287","members":["510ee834-19fd-41ef-8d4f-43d524c50082"]},{"cluster_id":"18718c0f-4c28-4949-a369-9bfa7d8941c1","members":["915748ad-4a99-4921-9200-7ad0f63b3634"]},{"cluster_id":"15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c","members":["88fa7a1e-fec4-4e4e-a036-e28471e1785b"]},{"cluster_id":"c17cea6e-319f-464f-958b-423a8d716b81","members":["3372e7b2-3af6-403b-9533-ca3f0f2e242b"]},{"cluster_id":"72793708-1a46-47bf-a99d-c034462d8ebe","members":["0adb6990-ff2b-421a-ab99-df94f72bf4af"]},{"cluster_id":"b632a6a0-afbe-40f4-8a5f-a0054d37001d","members":["d31f3897-6484-4f9f-859d-dc84f80394a1"]},{"cluster_id":"d74e9977-9a16-4baf-861a-98a8ddead66c","members":["237a6f9c-8425-4703-bee8-d512a40c8092"]},{"cluster_id":"f839d2fd-5b0b-43b0-bb42-43cd3c1d733b","members":["7d208f2e-cd63-42c0-8e76-e048299ab995"]},{"cluster_id":"8383b651-21df-4fb5-9d89-77f8c5fdde08","members":["95493ec3-5c76-4932-afe1-03535f25401e"]},{"cluster_id":"9d5a2720-0f92-434c-867d-f7d869c56177","members":["ea97cfae-0ddf-4b15-93d7-99ed2e3e60ed"]},{"cluster_id":"5d5c8795-a6be-497b-896a-30f8df4f0736","members":["75244adf-d5fa-4e9b-aecd-fa8520a5cb68"]},{"cluster_id":"f6f61810-826e-4932-a627-c61739848c9f","members":["ce6fa6be-ead1-4088-b52e-bf53f3c4157e"]},{"cluster_id":"8e082e26-8f01-4448-85f9-dcbb694f327e","members":["4ca90c87-c4e6-4c7f-94f0-ea9daba911e6"]},{"cluster_id":"ced5af6f-55f4-47fb-a25a-cd619d213da3","members":["726f005e-8131-460c-9463-d6964a2251c7"]},{"cluster_id":"f0e9965e-e941-4451-a097-f16f023a8147","members":["71bb8186-e063-41c0-901d-221f213e112f"]},{"cluster_id":"32be984b-e9e5-4559-b00b-15885afc33b8","members":["c708f5de-2751-4a8c-9fb1-241d533a4dcf"]},{"cluster_id":"ce6ec6f1-89a5-418d-adc6-e21b2c309bd1","members":["efea0255-2ea4-4369-a4fd-dc32db53107e"]},{"cluster_id":"ef8af588-0359-41f5-af90-03db72eaaba3","members":["cb59b418-04fb-4379-a5d3-0fad9684bf2e"]},{"cluster_id":"51cb3861-5c43-4303-b352-2771c991143d","members":["e4bd4597-6c95-42b6-8ea0-95f932932c30"]},{"cluster_id":"34b25787-92a3-4162-bcdc-435c1ba9cd55","members":["6d505685-fb18-4996-b440-3537c58c3f23"]},{"cluster_id":"5365be2b-8f70-4f67-96e5-c75ce9b7256e","members":["05beab80-30fe-4554-ae31-69577b6c546e"]},{"cluster_id":"432216ce-2589-40bc-b4f7-cabc8c9d84b7","members":["e2e86f81-529f-4675-a88a-f4cb35ba63d3"]},{"cluster_id":"84cbf3d1-afbc-4ba1-8495-8ff7aee7e81f","members":["69ee56c9-cc8b-4db0-bafe-7b715277e65f"]},{"cluster_id":"68f4e1e3-51cf-46cb-8e4c-826f56e18aae","members":["d9f42efe-10eb-4163-90db-2d36b388e3b0"]},{"cluster_id":"0af61c8d-a534-4af2-a2da-7ed4f4cc7aea","members":["08fc4aaa-001c-499e-b2bc-1bc0f4e5aa2b"]},{"cluster_id":"f4f28261-ce76-46eb-a24f-4ced2c41d5f6","members":["755c31cf-ca4d-4874-93d4-5d07f9d7e130"]},{"cluster_id":"c5229738-f89d-48b1-b153-7dc0f6aabc53","members":["7c90f385-a416-416c-9ba0-87f159085a81"]},{"cluster_id":"c5023c65-de59-493d-807d-e173da07457d","members":["b3345a2a-fe41-4be3-8ef9-5166e14dfb0d"]},{"cluster_id":"1ed0bff4-f942-4d7a-bec9-87e9c09bf276","members":["50384329-e3d9-48a5-93bc-83cc4d763718"]},{"cluster_id":"f6f5b331-ac46-4d22-8195-ed8a8b14d117","members":["e963d97a-8c6b-4628-94cd-73d0bfcbd002"]},{"cluster_id":"5456cf3b-8248-49e5-a577-e64c3c57ab9a","members":["725773c9-8f3f-4822-9346-a7020aa3ac84"]},{"cluster_id":"fd395743-8cf0-4953-ace0-85cff9e72be0","members":["ab4dc4b1-a625-45f0-b3fb-38d06409de86","f645f5ef-5ac1-44fb-9a14-8f8569b07972"]},{"cluster_id":"224111ea-4ffa-46dd-984c-028b4bc55489","members":["5cc6d900-a391-49b9-aaa7-310336dd2c4d","24442cca-df16-40ec-b4c2-36fa92e8bf64"]},{"cluster_id":"3f0004b6-308c-4518-9fbc-e6c906329ba4","members":["2ef611e1-b729-446e-959a-b9dc97b37d9c"]},{"cluster_id":"3d47a459-5f56-4e8c-a324-2a8a527df0bb","members":["c4e720ce-0d97-4a36-8c23-6c78b6521969"]},{"cluster_id":"a3452ca9-6c41-42fe-8fb7-9b272b7a106d","members":["31153ee6-b71b-49c4-b2ab-586daaf0c002"]},{"cluster_id":"3800fecc-81a4-49e4-a7cc-dc527d4bd612","members":["0389fee0-e5b0-4b6d-9750-ec7e37751939"]},{"cluster_id":"3c10b554-db0c-4b37-99ae-e28966332651","members":["a82dced5-0442-4343-8602-c3ee4319f011"]},{"cluster_id":"e581acd0-fb94-4a27-8e52-0501198c921d","members":["68e658a7-87b7-4feb-bc49-8a98c415edda"]},{"cluster_id":"2fb41c0c-9dcd-4bc3-b70a-75aee83bcba5","members":["5a78c0b5-ea57-4bce-9e0e-103c30c48f52"]},{"cluster_id":"d2ffb0e6-959f-4fb3-a43b-5fea64c717c0","members":["4e756dc8-42ee-4525-9931-5b21f8a028bc","4800cff6-05ef-4559-b9b5-a060f3cb3d0c"]},{"cluster_id":"4991bbaa-4137-4e4c-b3d4-b54d2fc23ddc","members":["b90c9c7d-8ee2-4cbf-9324-9485701f2402"]},{"cluster_id":"1a52a7c3-2c3f-447c-9a23-15f3ea781daf","members":["3ea55b05-e64e-4a51-b455-4cd56d19c028"]},{"cluster_id":"47db3c81-ee29-421a-b1e7-9a9b4cbbe8ce","members":["e9587647-c97e-4a21-ac83-8717ce46d6f6"]},{"cluster_id":"4c4cd4c7-1e1a-4df7-8ab4-db0129f7114b","members":["5018bc81-8adb-4e6f-96fa-ac5d951ada7a"]},{"cluster_id":"f62a9075-e876-4cd7-80b4-8e9a12641d53","members":["e3929cb9-d9bf-44fe-8eb3-431bce5cc092"]},{"cluster_id":"37216476-5d5c-4faa-9d46-a9c7fd453ec4","members":["3c496ecd-36b2-46b7-a3dc-5fa2c28c013f"]},{"cluster_id":"d249e1af-ea1c-48af-a49a-e0b42f780f6c","members":["8385b239-35f0-4b4a-b4d8-cebe460666d6"]},{"cluster_id":"64689f94-8b56-49c1-bd31-9f4133ac52a7","members":["c2bf0c47-4735-4576-9964-8dbe9c634b2a"]},{"cluster_id":"b777e992-68f2-4307-a472-b1ae2b933a6e","members":["a26c5d27-1a41-49e2-a665-a7e20594af90"]},{"cluster_id":"7b3e2472-ab18-4258-a390-e26e567571a0","members":["da653844-4256-45cc-8273-f87fcc346bb8"]},{"cluster_id":"3dc36bc1-d0c5-4f9e-be89-27d20d56e931","members":["148c615a-c714-4ab2-bf8c-5af7057fa0a7"]},{"cluster_id":"21936564-78e3-425d-afce-2c71d0db68fa","members":["fd031dea-82ae-4214-b800-07eee7e5716e"]},{"cluster_id":"603803f7-aada-4f64-95b6-3901092a2744","members":["79060d8f-adb6-497a-b312-d7d7335d3ca3"]},{"cluster_id":"d231b87f-915c-4032-9dcd-5f1c1337576b","members":["c756adeb-3a86-439c-953b-7e81f14df065"]},{"cluster_id":"e82f3b8b-97c9-4869-b282-3dfd951ace47","members":["c2c48b13-0da9-4a70-90b3-0a2dcf6a44f3"]},{"cluster_id":"28c2302e-bfe1-426f-8146-f632519111cc","members":["1f75d58f-e21f-4a32-8be6-6f03fa2583b2"]},{"cluster_id":"ed8f044f-96b2-4a20-8622-207bfd8ae25b","members":["a7af8ad7-124f-45c3-9c15-92e6e377bc92"]},{"cluster_id":"ebb3d42c-9f56-4324-89bb-dcd764d2d3e5","members":["b24ffb2c-2472-4d2a-811c-26c1b050e679"]},{"cluster_id":"b22a3d90-fc7c-4c0c-8913-b55993380bc0","members":["a940d181-cd29-467e-b97e-dec0bc61b3ea"]},{"cluster_id":"faba4888-ade5-4854-a98b-43a187c3c84d","members":["853abfef-64ce-49bd-a2d8-eecd7f1452f2"]},{"cluster_id":"41dff0a8-a265-4edb-a001-023373b9ecf5","members":["5006627b-b293-43d9-8e73-d6b5a7567e40"]},{"cluster_id":"bf9781df-d8bf-4191-9d37-d31cf97d37ae","members":["1cd4ddaf-aaea-4acc-a028-74a6d7933399"]},{"cluster_id":"d69ec96e-95a8-4ada-b02b-404a801edc90","members":["1267f7fa-73d9-44e8-950a-a0dee6897774"]},{"cluster_id":"cf64a707-174e-4193-859f-9f55dd41a4a6","members":["22815f4d-1308-4d07-a08f-e7acebf98655"]},{"cluster_id":"feaafeab-4622-43a8-9ce7-52d22835a7d7","members":["c4d39634-abdf-4664-bdad-d6e78eb7bbb0"]},{"cluster_id":"02e9df36-756a-4f13-96b7-a64b085d932d","members":["90ef49c0-710f-4b96-81f9-3d83ddeba200"]},{"cluster_id":"0c67a873-1e0f-4dd1-9e3b-40d63d120847","members":["663b4f93-67b7-4083-b91d-62cb28710640"]},{"cluster_id":"0da6573a-b2db-4671-b4e0-6012c6bd63d6","members":["49f76802-5e87-499f-8e75-f14098ec6093"]},{"cluster_id":"74873448-e290-4f3b-a22d-809e34d02a4e","members":["f70405cb-f7f6-4863-bc7a-c931d82c2550"]},{"cluster_id":"8a1628d6-9b8d-4872-8726-128c5ec7f01c","members":["266913ed-2eef-4ab7-911a-105100da0e02"]},{"cluster_id":"2f5e01bb-8b8d-4570-9736-c9caf60706be","members":["72f2cfd0-b507-449e-9770-85beb184878a"]},{"cluster_id":"05de0fcd-b07f-4daf-b084-2e15c6be78b3","members":["a6cc1c20-7887-40a1-aabf-bfb7e06a7449"]},{"cluster_id":"6ecdc168-b4c6-42e6-a45f-27cde46257e5","members":["c786f26e-12c2-4535-a429-4e452628cffe"]},{"cluster_id":"3b3110cf-93d0-4510-9837-e4eaf9f9a935","members":["6a2d7a4b-4915-4e96-8761-56cffaf93b4a"]},{"cluster_id":"ddce8749-8091-45b0-8366-637dbe518fa7","members":["929e1daf-b76b-4dcc-bef3-f9333ae4e759"]},{"cluster_id":"c218f143-d00f-4444-8a1a-91fa210ebc65","members":["fce12da3-bb37-4057-b532-66704b519802"]},{"cluster_id":"91d4dc33-e633-4d25-9203-969f15a268d3","members":["9a9f6fb9-cf76-48ee-9a70-677d6c110efa"]},{"cluster_id":"241266d3-592d-42ac-9327-a8fa3d3a1448","members":["48d0d409-30e5-428f-8ea5-91b8cae163bb"]},{"cluster_id":"297851ee-0090-4476-be7b-77ecae5b0949","members":["4d05f40f-071e-4ec6-9402-83d6f6728d05"]},{"cluster_id":"c85617d1-a799-4927-848f-0f8d387e35f0","members":["61fbfe05-fc35-4760-85bc-5bad7ae4ded7"]},{"cluster_id":"b03907b4-379e-44df-a2b4-6f069b3d131a","members":["28039044-3710-423a-a4bd-2fbbf3e54855"]},{"cluster_id":"4fecbbe3-fb61-4e10-b666-a2cf1bec8797","members":["5f73d540-43b8-4265-b8ff-aa19a825cccd"]},{"cluster_id":"0de9cc59-0656-46df-93f6-a7ec86e0802b","members":["5c85d134-3901-4755-b71a-1b2eb75fb815"]},{"cluster_id":"7a75d7fe-a9ef-4bcc-bb6c-68501ebb5f56","members":["10e90a91-8e71-43ae-8b59-e0b1a43a6907"]},{"cluster_id":"d7e7a762-6cbc-4c4f-9830-3d635c57a2df","members":["287b2f37-c4a8-4ee8-a189-3a6c0f1582b8"]},{"cluster_id":"53b1257e-8f17-4723-a98b-5c441d647f48","members":["03902357-f4c2-4df8-9882-232e48bd71e7"]},{"cluster_id":"23a31964-6a33-4514-aa2e-353b4bd3be9d","members":["663097e0-4b95-4728-8608-8d19438f7d7d"]},{"cluster_id":"240e1f26-e6d5-488e-ad06-f573f8486dce","members":["300f0d0c-3195-4f56-8af4-3e5a93c40f57"]},{"cluster_id":"791e282d-3184-48f1-b9b4-d9976176f1c4","members":["dc0fbaec-ae96-4c16-9fc7-5b16fd8c8b15"]},{"cluster_id":"ace987dd-fefd-4144-a25e-4a8cd1ec09c0","members":["56e4391a-703c-4ed9-a325-0165561cee88"]},{"cluster_id":"90376b4c-da40-4dab-8f73-1b70785d5f49","members":["24abea91-0dac-40b9-9770-ed51f91c5c5f"]},{"cluster_id":"17c6aa84-f614-46fa-bf43-265da2499cba","members":["3b16bfd7-7b38-422e-8168-de5f079314e7"]},{"cluster_id":"9876318f-24a7-47a3-a0cc-61a7ad5d114e","members":["4a4a3486-453b-4e0f-b099-3969db2e42ef"]},{"cluster_id":"5b7d9e7f-e24f-4115-ae9c-183a9ef8183c","members":["76b6c6cf-86b2-42d9-badc-c8bd382b4aa9"]},{"cluster_id":"e2924858-e631-4f3d-8b15-9f5ee8ab3b4e","members":["75b0643e-6526-4dd1-a6c5-ec972c9437f4"]},{"cluster_id":"f0144a0c-5ed5-434b-884c-c56dfe8a915f","members":["2f98e229-8833-4116-8716-f73260c19e20"]},{"cluster_id":"1c4341b5-18d5-4ba6-a313-e14ad3c93bc5","members":["c568daa3-1f6c-437f-a2b8-c047b1e273d8"]},{"cluster_id":"ea4dda18-9c10-4944-8540-e2c0066f573b","members":["fb5e89ab-7a85-43ae-a4f2-098d2753ec2a"]},{"cluster_id":"60c5d0e9-eed6-41c1-b7fa-8d8163b698f7","members":["8c8f1924-d68f-416b-8d8e-58c11e08a9bc"]},{"cluster_id":"c025fbc7-332e-4457-bed4-c17718085886","members":["fa13c6d0-b2e5-474b-9f53-d4a52a63806a"]},{"cluster_id":"92332b03-095b-4c9b-a429-b33ea258a0f9","members":["a7792d10-d764-4230-90f7-ac06b4636202"]},{"cluster_id":"1d2ec60f-34f2-42e2-a397-916c3e7ad70d","members":["b1976276-72b8-4011-90e9-c0aea7bc389e"]},{"cluster_id":"b96bf2eb-4edd-4eb7-8c42-ee3fff5f4c9c","members":["17c096b5-452d-4531-bc5a-882057a7929b"]},{"cluster_id":"54e77970-df08-445b-a795-2987113391fb","members":["a9001056-daab-416a-bddf-6062cc82c7ae"]},{"cluster_id":"e3deeefe-c427-4d71-816d-254495afc3ac","members":["4a103dd4-b72c-4209-98ce-c3609d5ebbe1"]},{"cluster_id":"1aa19d8d-3161-4beb-8b2d-3a6a4b289e65","members":["ac11415d-d1f0-49ae-bf3c-e809f385565f"]},{"cluster_id":"143e5a89-f562-4e9e-ae94-80a1636c09a2","members":["5f8c9e85-7db4-472f-bebd-dbe581560237"]},{"cluster_id":"83e82b7f-d20b-43e7-8e8a-1a33199d549e","members":["39a20b14-9486-4645-846f-a5d3a05a411d"]},{"cluster_id":"32ba4740-f52a-47e5-91ff-4fde0ada2a3e","members":["729bd517-f48b-4458-86d3-c7b80c90a419"]},{"cluster_id":"9686ee9d-c6fe-4724-a86f-ea5424b54b58","members":["eee21b3a-7680-4b10-9582-b74325004fff"]},{"cluster_id":"d3878960-69bc-4fec-92c4-b21753a35a06","members":["4300ed1d-249d-4eb3-a8e3-2977bf86206e"]},{"cluster_id":"33362f90-8163-4571-a6ec-1aa8d1d2470b","members":["65c14409-94a3-4eb2-8441-805a55ed7592"]},{"cluster_id":"8eff5d20-7a2a-43cd-a95d-697a2eb3fa48","members":["2d827743-6247-4e6b-a57b-dafc824a08bd"]},{"cluster_id":"53168731-5f89-48eb-b975-ab6908193c3f","members":["ca494079-582d-4085-964a-16eb13213ade"]},{"cluster_id":"13a151a6-c289-4cb5-8bbc-44e52c4f2c13","members":["172cf672-4338-4d7f-9bb6-ea44525201d7","e78e8eb1-4810-4e35-a9c3-b2dcd8790b99"]},{"cluster_id":"59fa4256-c06f-40de-a351-3b6ce5c20978","members":["6c174445-80ed-497e-b27a-f0ee25657bc0"]},{"cluster_id":"7138b959-d146-418c-bd39-6ecd7cfec079","members":["b22df674-8d6a-4eac-9c5c-4a6b65a8be49"]},{"cluster_id":"696c75fe-b8aa-4f76-a6f1-267a591b7b7b","members":["9061c2d6-b97b-4e66-9c41-0f9fdb8855b7"]},{"cluster_id":"523b0246-0513-4295-a714-19577f713513","members":["a902748c-6ee2-4618-887c-aaa065629c33"]},{"cluster_id":"b86b1a76-d691-4bc6-9266-214b0cf4e6f3","members":["c51a371a-2861-4e4a-bebe-05bfd37ac05e"]},{"cluster_id":"eb6475eb-91f7-4af2-a9fa-7784d03f74bc","members":["58a8a0fb-d8e4-4062-8e49-77fbaa8c4af4"]},{"cluster_id":"20d5e5ed-4ce5-4a63-9b10-3e468d3431e2","members":["a1afbbcb-0045-4cb3-a80a-c94f23c033f6"]},{"cluster_id":"21c8abd4-e2f1-498b-ac7c-3e0c279db5b8","members":["f4fd4123-302b-40c8-810b-b64de82dab57"]},{"cluster_id":"2d5921ac-7cf9-4259-b8e0-144908d40418","members":["4bf2c361-66ac-43d9-a57d-69eda5f68ff3"]},{"cluster_id":"3749bcc6-b034-4fb0-8ff0-89b445295873","members":["0486887d-f3e6-4ad8-8318-f61fc63d4e4c"]},{"cluster_id":"f5784495-7eb1-4199-8e36-89b434da6e01","members":["9a34b22b-fed3-4c7b-beb3-c3fe6294db09"]},{"cluster_id":"e3c9a6ab-aa8e-4a41-9385-a9d893d2acc5","members":["89761b78-37d3-436a-9172-1aa0b3e7271b"]},{"cluster_id":"64d91f5a-97ac-46c7-8034-7d2fcfc293b5","members":["3611d703-5b2b-459a-b6d0-1f1799963c5d"]},{"cluster_id":"e0a277a7-e9c4-43ed-a840-95ca0c8f496c","members":["536b54e1-1e4a-419d-a557-b81756067a32"]},{"cluster_id":"e8860c87-9dc3-491a-8748-575a2d051898","members":["12275ffe-4629-436e-b10f-abd6ce599ef3"]},{"cluster_id":"da0898ac-2eb7-477c-8e02-e9f17ebb39af","members":["e11a0225-cab5-42e3-a921-41c80652ca9a"]},{"cluster_id":"5ccf3948-9cc8-42f4-a17d-9079c20482ce","members":["bcb56a36-ec91-4877-92e9-b98d49434429"]},{"cluster_id":"9132970a-f73a-4805-97b9-6e1d8581a3ef","members":["536ccc45-bd29-414b-b18d-e863954871e3"]},{"cluster_id":"ff2f8c85-c8d6-49c6-8138-1b205db9afe6","members":["92720b4b-9773-4329-93c9-b45f67ca61f5"]},{"cluster_id":"e5fa93bf-fdd9-4c91-8fb4-7d6499900667","members":["0c839794-7745-4572-be7b-dddd47fd12f6"]},{"cluster_id":"2b3d52ec-4f80-453e-83c9-9cef80ee3ed0","members":["202de205-f1d1-4bf8-bf64-f00ec54f1552"]},{"cluster_id":"d4bec07a-ec66-4aae-9ce2-624f9525e0ee","members":["d0020a67-fc35-4342-a323-11be9087d48a"]},{"cluster_id":"2cf2f548-46a0-4250-995b-025b4e6eb130","members":["d4a0d688-6659-43f4-b729-ba11a12764b1","da383908-9cae-4334-94f5-b4b1d0bac067"]},{"cluster_id":"451b63c0-8817-432f-8656-27079c8595d0","members":["38f3fcd7-ac4b-48ac-97a7-869b0ebf0b39"]},{"cluster_id":"0473444c-8fc1-4828-8ed2-8a53db5a4083","members":["94df8f53-4787-4085-9cca-4355cf2800d5"]},{"cluster_id":"cdec7efe-effe-4d5a-84e5-892cd8aa5135","members":["b8556f5f-e15a-4c1d-8734-58d81e74cab3"]},{"cluster_id":"ae563379-6971-495d-9872-da508cf0a3c7","members":["365f4d0c-f744-4264-8da9-40b644656575"]},{"cluster_id":"f471f0e2-f8be-4060-8f3a-33826e6e00b4","members":["352f7f27-61cb-4116-94b9-02f2bb7fc6aa"]},{"cluster_id":"491bc782-ae1c-45af-9f60-183d9dcb959e","members":["7371e316-7520-4859-8923-9f49a2fd0bc4"]},{"cluster_id":"914bd639-81ab-4467-a8c1-07b0f59b2871","members":["30f8683d-3aa4-45fe-a452-4101b6211ad3"]},{"cluster_id":"5db738fd-0af6-4d3f-8483-2d8b409e966d","members":["9f8afa71-583a-4075-a1b6-4a16a0225b80"]},{"cluster_id":"739c0bc4-1bf3-45d5-b4d4-587c8689dc5a","members":["d2de2683-5301-4e88-a6af-de7b857d55b7"]},{"cluster_id":"ce1129a3-23ca-4a3e-bf11-bcbe6b5d487b","members":["3ac65615-295e-43b0-bd1e-295acce11b24"]},{"cluster_id":"e6396265-e4ff-4b5b-8b50-46f16a8b1b5b","members":["8edaf8f8-cee1-403a-bb85-08ab937a3c86"]},{"cluster_id":"ed6634c6-cfd9-4bcd-92a4-6a9685e6700a","members":["81034bab-34ca-449a-8125-efe9bd3febf1"]},{"cluster_id":"9e7a0088-26cb-464d-887d-c7e715addbcf","members":["6d5abe6a-278c-4409-9c45-30f3af0e0f88"]},{"cluster_id":"a07d35a7-6217-400e-856f-516669ebb436","members":["fd1034b1-5b65-4663-8ad8-50feb371cd77"]},{"cluster_id":"28df4744-3bf2-4a43-80dc-d2bea8f7af7a","members":["c974f6d6-113a-462f-a937-3a50bb6f876d"]},{"cluster_id":"84147a14-72bc-486f-90ad-45e374aeaa05","members":["cdc2e360-c720-4bea-b351-bdf839c88f03"]},{"cluster_id":"9c176d07-6751-4585-9c31-c558b96a7b39","members":["11234eed-3a0b-461d-a2e4-30ff96dc483d"]},{"cluster_id":"7ed6cceb-29b9-4150-b16f-00796c0ac573","members":["b08c723f-b7b9-4359-b317-16d091bf3b21"]},{"cluster_id":"1758ed2e-dc14-4881-941e-3bd76c244d71","members":["c3394cb0-7f38-434e-b842-6b01a620b052"]},{"cluster_id":"ab43ecb5-72cd-4cd0-9f6f-d31ca04720f7","members":["be00ff73-c861-4bd7-b6d4-8a447568e602"]},{"cluster_id":"aeb3174b-bc91-4fbe-9027-0eda5304183e","members":["26c3f605-3001-4112-9321-01545614593d"]},{"cluster_id":"c5bc8d69-1894-4720-8281-0a21bdbe0e98","members":["5c99bbde-646b-490b-853d-f167d22f76bb"]},{"cluster_id":"219dab96-d91d-4b0d-b347-235846e4bc70","members":["b69bb252-8716-4cad-aca0-20858633f361"]},{"cluster_id":"5d65bb29-7381-44ed-8856-ec52d73d0a76","members":["683089cf-de34-464a-91b4-29c055e7034f"]},{"cluster_id":"639772f4-84fc-47d4-a44e-cd508a3d7e6a","members":["2019fa13-4954-4783-ab8a-b6d58fb3767c"]},{"cluster_id":"190c47c8-68da-42d3-b08d-822d259e964f","members":["9583ac2e-6d33-435f-b5aa-c463766577f7"]},{"cluster_id":"5d61ec99-0639-4eaa-b6c6-d29d8645a85f","members":["044ac721-0b4b-42c6-a6fa-df1a1fe7d2a1"]},{"cluster_id":"2d30ef5f-ee97-4df3-a64c-5e181a81321a","members":["ffe6f633-c3dc-4185-ad58-053703bb06bd"]},{"cluster_id":"faa4667e-011a-4693-8171-40e817256b60","members":["ba93a92a-87bc-4eb5-b06e-8c6119100af6"]},{"cluster_id":"93df5ce1-4286-44c4-8457-3b0ae5570ff2","members":["b8f25f7c-1b81-4e37-9f35-478976c1b8fb"]},{"cluster_id":"01eb8b8e-096c-4892-bc91-ee4788a133cc","members":["d8f1116e-b8e4-44c8-b2e0-e3a9f21c6ca8"]},{"cluster_id":"31f1de90-d456-4f9f-8590-accad42614e0","members":["f7b3741e-3ff3-477e-833d-510531c56e36"]},{"cluster_id":"42214595-36bd-4891-862c-e83b3aae0a8a","members":["aa8ced11-33e8-4dfa-a777-998135937715"]},{"cluster_id":"43fa0350-2309-4b93-bd2a-6e8c4a716e73","members":["652002d2-8a3d-47b5-83a2-1bc03a3d02d1"]},{"cluster_id":"de8997cf-fd37-4d0e-b22a-dae890492f89","members":["3884db69-6ca6-4ea3-9050-5a4f1a38d906"]},{"cluster_id":"320a9519-2826-4d38-88e0-353ff9437484","members":["332e1724-af40-488b-98b4-34de0d227565"]},{"cluster_id":"7cc54def-6358-42e1-9afb-ba0b2ba2ac2c","members":["8d73d89f-a149-40ab-a9d8-3bd1bf052237"]},{"cluster_id":"e3336914-7a77-4548-8764-1fd25cd393fd","members":["da8b0d27-574d-4160-874f-3dfd267572ea"]},{"cluster_id":"876ae960-2467-4ffe-b0e9-9cd336bdf4a1","members":["de66ea25-fe29-493e-9ca1-a9c48d258a0c"]},{"cluster_id":"2de4265b-f662-429b-82af-a99a27de61cd","members":["9636e7f7-f323-42f3-9678-018b36dca663"]},{"cluster_id":"af86b76d-a390-4847-bb43-41459c4a0513","members":["bbf6cbba-ed02-4c30-884a-e2f6eb5f8ec2"]},{"cluster_id":"11b98cf9-d431-4639-813c-ea19160c9631","members":["1d9c7f8c-7c46-41ed-9120-4d1ccad37e23"]},{"cluster_id":"ddb7dbbd-226e-4674-859d-8c16b4f4ce9e","members":["2cd17608-a3a1-4148-bac5-8ff63680024d"]},{"cluster_id":"2c8bf59a-7972-4ab1-a4ae-680a19fde855","members":["719debe7-77ec-4ef4-b4fa-3292b895aacd"]},{"cluster_id":"bf418d10-64bf-4718-bddd-53c651aaa9eb","members":["76c16e04-c75e-43c7-9a3f-ff2ecdcb6adb"]},{"cluster_id":"d4ecfa56-5354-4519-b8ae-d7dff0864186","members":["10d5a29b-3409-4a51-9ace-43d54e3fb5eb"]},{"cluster_id":"0463ae92-c5a2-4eed-bc9a-bba00f27b6ff","members":["41be2912-a92c-49cf-8992-e53ca8442812"]},{"cluster_id":"d2dc78d1-ae53-4ed9-adc5-5e6752f3a1b0","members":["b422ade6-fe37-4342-9c94-f558dc1f6d06"]},{"cluster_id":"adfb27db-3208-49e3-8050-366e93400ac6","members":["42ed635a-b8e2-47a3-adc0-3096844abd7a"]},{"cluster_id":"58d6742a-73cd-42e8-8a47-4ea3718af2a5","members":["1b13c812-81e5-4522-8a73-474b58c8824a"]},{"cluster_id":"3d3c026b-80c1-4334-84d1-db19f80712b4","members":["3bda60e7-ed94-4ec2-9405-c9c81258a1cf"]},{"cluster_id":"6ddc553f-506b-402a-87ca-b781b2c60932","members":["be63afc2-aba4-4262-8fa9-91dd6c829ea2"]},{"cluster_id":"d15b1a4a-b0d0-463c-b7c1-b74ef1c0a63a","members":["4f14a3d3-a2af-4fb4-9c5b-77e81db0e24c"]},{"cluster_id":"11abdc54-b039-4ec9-b836-c70099743468","members":["6a6243b9-18f2-454b-a36e-eaca6ac954ea"]},{"cluster_id":"c09d9041-f33e-4fbb-bb7b-4e43f4329c75","members":["8bb44fdc-fdb0-4a26-882a-fc0bc28cb158"]},{"cluster_id":"e1a7ebff-5254-4bd5-a3d1-966b6a60cd7e","members":["50412109-04a6-4ae7-95f1-52dcd65d0f33"]},{"cluster_id":"0007cb01-3742-461b-b5c4-5aadc5a55eac","members":["c089f020-2b1d-4af0-b3cf-0dfdea7e1451"]},{"cluster_id":"266e7b13-78e4-4d47-a479-faf867ea0a51","members":["c5635cfb-1ed4-443a-b1da-b1c51e0f1cdd"]},{"cluster_id":"7f537263-14e5-41a9-8479-1de5e6a80076","members":["f80084e1-f78e-45e5-afad-1851567b2f30"]},{"cluster_id":"a7b985be-e866-4775-b4be-7c7e64f9a12a","members":["9c18abc8-e211-4150-99de-08279282031e"]},{"cluster_id":"2f406046-b590-4796-97c3-ab6b4e6c2d6a","members":["fb0583c0-c588-458e-ab4c-cbb0dc8d6e19"]},{"cluster_id":"fd67a670-bb1f-429a-b83a-c92989f510e3","members":["8b45eff6-3eec-4abe-be2b-171304c22e14"]},{"cluster_id":"94bb7f1c-2d8c-4580-8fb1-a174bd27e088","members":["036c29b2-0aed-4e11-9f8c-b89c77df016e"]},{"cluster_id":"ce1afbc7-cb83-43ef-a574-f0c71eec061c","members":["62354f10-9854-4b6b-a2f0-76f2bbbb9d5c"]},{"cluster_id":"86c9a6a1-8859-49b1-869c-febe929feb9d","members":["596dadca-7ecf-4ad3-9240-155524a0321a"]},{"cluster_id":"6003df1f-5700-4398-bb5c-3e647fefb73f","members":["f0934c56-ec5b-4af0-a746-6e2b253770b7"]},{"cluster_id":"8ab5907a-7d78-4873-b326-304fe58b10f8","members":["f2549918-16ff-4631-a465-2b9b49adae82"]},{"cluster_id":"32b2643e-52f7-4ad5-a0ab-4120423c498b","members":["4f1c4513-d2ef-45af-8edd-7f7c6d7acec7"]},{"cluster_id":"f6bf24ea-54ac-45f2-b1ba-27747efe5a47","members":["f5a77d26-097c-4c34-9a8d-741665227f16"]},{"cluster_id":"31b521fb-d677-46b2-8db7-b2e8a8fafe49","members":["87f1afab-9886-497e-bd50-ded7dc234038"]},{"cluster_id":"115eeed7-4973-4efa-aa32-369a2056fa21","members":["75eac795-7813-4c90-849e-a328ea85cdac"]},{"cluster_id":"7d97e055-f53d-4979-b83c-8c058b074265","members":["a225fb8e-01e5-4bc0-83bc-1cd4443cbf55"]},{"cluster_id":"31763d96-84ac-402a-a69c-ea748718f342","members":["15eff4ff-752f-469d-ac3d-cf27e57e7342","d8e60c1f-58fd-434f-944c-4ce72c545008"]},{"cluster_id":"938b7182-512d-4aa5-a1bc-532c7b55f96a","members":["f512e1cc-18eb-4be6-ace2-84dfa7e939d9"]},{"cluster_id":"efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3","members":["90acb2f0-5b14-4c2c-b233-ea7d144bdb5c"]},{"cluster_id":"e0948d6f-1c68-4b82-8be1-2b7d5644b264","members":["c7e20b17-7466-4ce1-894e-90163480399c"]},{"cluster_id":"02f42105-05b5-4e5d-917a-7eefa123f670","members":["c6950cb3-e288-4c5a-87c6-4dce2df15ab4"]},{"cluster_id":"2a43ad41-42b1-4d3e-8501-88166518eba1","members":["67df963f-093e-4ca0-8223-a134f2b01be7"]},{"cluster_id":"10c35c93-3305-488a-b928-ca8b7cb9a3d2","members":["b0aa8582-a02b-482c-97fc-31bc9bc0988b"]},{"cluster_id":"f23bc705-fad4-4454-82b7-d780cad17182","members":["3c456844-3843-408e-bba9-e1b938e9c122"]},{"cluster_id":"522064a5-257c-47c1-b163-e454d1155f76","members":["413a6954-3ccb-4496-859b-9e64fcf48ad9"]},{"cluster_id":"ecc05d01-ffac-434e-b1f4-f1a58038c91f","members":["f7ef0dab-8917-472f-a8a6-63f35eba88ff"]},{"cluster_id":"4e97d6a7-e106-4542-b474-cb57818b7b22","members":["a962fc5f-24ff-4c6e-a247-1ff2fd6df37a"]},{"cluster_id":"d85e9fe5-2b49-48db-b3ed-055f19c978de","members":["a1ee7052-c980-4fb2-8d5a-4cd6a16a06c2"]},{"cluster_id":"d2c0f044-52b0-4afb-ad04-975898224fdd","members":["ec33a170-1453-40a4-8f20-6d255d78fe65"]},{"cluster_id":"b23a3a32-e361-4bd2-bb69-d01d98ed6b13","members":["96b80c06-b64d-48a0-a866-fa12a69c8022"]},{"cluster_id":"ac2e2af1-8130-4f38-a6ff-ea4697746269","members":["5d3c8522-8b54-444e-996e-00ed7e252767"]},{"cluster_id":"78fa9929-a2ff-4f4c-b21a-35134d80f026","members":["52d563db-56f0-4713-8419-820df9a6af1a"]},{"cluster_id":"24b243a4-0f35-4d99-b275-1610156f7f35","members":["371d4c61-e8be-4e96-8f8b-41fbd855bb80"]},{"cluster_id":"3e3518da-eab0-4220-8961-2d5489b4e97a","members":["361583a1-3ab5-4990-b50e-486b2864d236"]},{"cluster_id":"e0f9e573-f9e0-44e0-aff6-2dee5ec70199","members":["cfe79470-7eb9-4ab4-8c55-75b6311329e8"]},{"cluster_id":"69563b87-ed4e-43d1-a693-c379aa9b1be9","members":["c6969ea7-2cb0-48fc-a29e-5d0e2e3dcc0a"]},{"cluster_id":"43fc29bf-35e5-405b-9c9f-cf4dbaccd61f","members":["2be8f441-d916-4f8a-bbd3-87bb25330991"]},{"cluster_id":"2ae6e0c5-a6f5-4035-9f73-8ab31a8a805b","members":["b30e4341-3899-4e8e-9c88-1b334e46e7a4"]},{"cluster_id":"cacf5ae8-cf4c-4e9d-86a7-1b95a7ab58e2","members":["970ef17c-9ae1-4064-bafa-37436103dbfb"]},{"cluster_id":"2fefb93c-9c85-46df-850b-c68cfbfe7264","members":["ccd393be-47d2-41d6-871b-4624f8aca860"]},{"cluster_id":"ebb80698-62b6-438e-85ac-44aff649cb30","members":["274701e0-c87e-4a92-8ffc-f0e549a34634"]},{"cluster_id":"cc256628-cc7d-493f-98f7-e2382cb4b346","members":["3cbf07f1-46b7-4d3c-9da2-4e78f0de56fd","413fd5c4-93fb-4975-926e-949600553baa"]},{"cluster_id":"d1aa87f5-6e8b-45d2-89ab-5267e8136707","members":["e0b9ec6a-ef37-4be8-9a8f-fb3a4eaed21c","349a4808-5100-43dc-bb93-0a3696bc93c0","38c2efac-70d5-45dc-b1a6-bc298b341cb0"]},{"cluster_id":"dbe4672e-f5d2-4914-b987-c4e89610b2b6","members":["db26f402-9699-4f53-adc2-5c49174a685c"]},{"cluster_id":"7a36ef35-086a-4724-b10d-2245bacdde6a","members":["b448de85-22bb-4921-bedf-84e814f19ea8"]},{"cluster_id":"036aef66-792d-4feb-a831-cb1e088b3daf","members":["abd62fb9-dfd6-451a-b1e2-5c9a1b4eb5a6"]},{"cluster_id":"d8fd9aa7-8b30-418d-82de-88746b18d64d","members":["b3afa837-aa0d-4eb9-a7c8-517a907dfa27"]},{"cluster_id":"f4f2acc7-50ed-478a-a3c8-fd8ce6afe67c","members":["29685c61-610b-4a8b-99ab-2e16778e13f1"]},{"cluster_id":"4941bed1-24d8-4571-89bb-5872a51c53ed","members":["f051cc8c-6a20-4d6c-a0cb-43d0d946125c"]},{"cluster_id":"7caf5c56-5f70-4536-ab5a-2d4f84227951","members":["b8deb308-1885-4578-90fc-5e30e5808a8d"]},{"cluster_id":"dcae0b06-ee3c-4003-865d-7cc0ed9affe3","members":["b3be0f40-8fdc-4f79-aeeb-9a3360f22c21"]},{"cluster_id":"2116fedb-8d8c-44ee-b7a0-a2ee29d3edd5","members":["80e39e30-3b7e-41fc-a1c4-99fb925668b9"]},{"cluster_id":"66d45ba9-56c2-4b38-9b31-adec0598a967","members":["19e97047-b708-411c-b6f1-59ca118e857a"]},{"cluster_id":"6faef44d-a395-4b46-93b5-ca7cbd7fcfc0","members":["be38e493-a4a0-49ec-abd2-bb6182778ce7"]},{"cluster_id":"4361c487-2c7b-4ed5-a3bb-23c69a57f5ec","members":["e25d9cc2-d1d6-41c0-aa75-5ef3d6ae4d81"]},{"cluster_id":"b87e7ed0-8014-419f-b604-584f2337b651","members":["759bc274-fc7e-4c8c-875f-5d9d3e0bc6d1"]},{"cluster_id":"13df1ab3-c8ca-4935-bfac-bf950b3f0183","members":["aa77c6dd-6815-4ee7-95cc-9f476723df75"]},{"cluster_id":"3ad1f302-26c2-471c-bf5f-e79fa32778b5","members":["436ac542-f466-477c-90f1-8779404eafbf"]},{"cluster_id":"264cec13-14ac-4e28-862c-a8260aede982","members":["48530f0d-bb14-4da4-9e07-c07bd14e1a91"]},{"cluster_id":"ff2f92ab-182c-47dd-8807-28fea5da8eba","members":["b3888e25-51f1-4dc1-8dc9-941a6e307477"]},{"cluster_id":"73893bd5-387d-4d08-9fad-0f62b5aacd0c","members":["0a12843a-9484-48c5-92c6-08e7bbd4cdab"]},{"cluster_id":"02a17fb1-29be-46e9-913d-2f11d1b37013","members":["9d9565d5-8ea3-4db0-911c-a1ab63581ca2"]},{"cluster_id":"aa6b0ec7-e6ca-40be-8563-62563928ebc1","members":["149b435e-0838-4b78-ac8a-64e644aa02d5"]},{"cluster_id":"bcac4aab-9cd8-4923-b998-bd470cb7fa0f","members":["a5df38b9-2deb-4820-9ba6-667ae40ca26d"]},{"cluster_id":"71ca644a-cfc8-4e25-b5db-b8f4e53e1dc1","members":["07afca8c-75c7-4e63-b710-40046c2ea030"]},{"cluster_id":"efada224-bd67-4a33-8ca6-01f2d398630b","members":["e1e40157-3022-4baf-a59b-3802d4ce6a78"]},{"cluster_id":"e47a5c41-ef67-4e8c-bde7-553670fb6a9f","members":["314b9885-f959-4540-8a81-6db59af29278"]},{"cluster_id":"8e29592d-1755-4868-982e-348b60636ba1","members":["3f33bcc6-16fd-4146-9119-4063190d2547"]},{"cluster_id":"da887573-bcbf-4c6d-8541-c47ee99de6f7","members":["37bb4f09-1949-4ca9-925f-f2f7f5fae02a"]},{"cluster_id":"0c52c819-873f-4721-acb7-09c8239a9862","members":["6dba0146-ee5c-4d22-8202-366446328116"]},{"cluster_id":"a01dee28-83a3-45b0-ab2b-6e6c04b1fe22","members":["8c6381d1-06d3-48cd-9fcb-f6d47803b1c8"]},{"cluster_id":"fd2129f3-2e6f-48c6-9418-cef28902c1e2","members":["e1ed5bff-cfaa-4746-a821-bb42e9eee497"]},{"cluster_id":"8c96de89-87b9-4c63-a1e4-fab8f67f7294","members":["a6488430-f13d-4976-8ffa-b5d2a3a03f1d"]},{"cluster_id":"b97fc666-43dd-4240-9de8-5f0f42a98b08","members":["9e7eed4f-220c-42c1-8287-6912c7842d0e"]},{"cluster_id":"39ac0d20-baa7-48d3-8263-9b324a75c453","members":["e4020dee-d50d-426e-abc1-808bd759fcd8"]},{"cluster_id":"0edc35d0-3f90-4beb-b2c7-55c511dba369","members":["51c79555-6f9f-43e9-bffc-8e400d241a59"]},{"cluster_id":"98230e6a-7d95-4671-8b15-8c0dbec5af34","members":["61c5a464-83ba-41ba-a8e3-4ea93188d477"]},{"cluster_id":"4cb90529-ce16-437b-99b6-c2cd5dcc786a","members":["77f2d1fe-fcaa-4e36-af2a-d7e947ebc3b5"]},{"cluster_id":"3a02d9a5-2925-42fc-a9b8-bf0df52af22f","members":["d31e760e-221b-405a-b2a4-4d4e8770860f"]},{"cluster_id":"d9bde049-6b0f-4d26-ad61-29d5b4dc2bc8","members":["4338c56d-1ee1-42e6-8b86-59066fe99e57"]},{"cluster_id":"3038e36b-6f90-4a8b-a5ed-b89bec5c7144","members":["5b404305-a187-4827-a04c-da7ccb6139a8"]},{"cluster_id":"65d8f691-42a2-4903-8a08-db7d149c26b1","members":["ac80fb30-7c46-4efa-8203-8849169b83ab"]},{"cluster_id":"fa9c6e3a-5327-4294-bfff-2d638f6c4455","members":["462638c9-c9ce-4650-af3c-bfb23f68d25a"]},{"cluster_id":"d5ffcb4c-8c79-4cc4-868f-bca69bb676c5","members":["474f5052-9cdd-45c6-950f-9afa02aad4d8"]},{"cluster_id":"6c9f4959-d341-4a88-80e2-4c73e592884c","members":["2351854f-aaf1-4bfd-984c-3bc9d980c1b0"]},{"cluster_id":"3360bff0-2a50-48df-84ce-ef5c8f91489d","members":["84cb69d6-6cbf-4df8-8678-144ef113fd4a"]},{"cluster_id":"bae5df31-d0a5-4216-b755-4add987f460d","members":["bb748b52-4304-4eed-b247-e4d11a492e1f"]},{"cluster_id":"2d1b7151-63a5-4414-9619-8c40fe20742a","members":["0d7d7cd6-18a4-4333-9251-d959fbe2f715"]},{"cluster_id":"b46bab47-6915-405b-a8fa-be8c999e4b4c","members":["99d986ba-d36c-4bd0-ba02-28432c62c77b"]},{"cluster_id":"ea81b5d1-0d91-46ec-a9b0-b349139b83e4","members":["b3692450-a4bf-4345-8f0e-6dbb92d3e3a6"]},{"cluster_id":"6b780a23-d1ce-4c39-8626-c4071a335cc8","members":["1f48df8f-b219-4947-8919-21cc9365cf67","00e97291-053f-40c0-8f73-0927fe29385d"]},{"cluster_id":"77ff5800-b905-4e32-87cc-e4de9525bb38","members":["2bc1e157-e741-4377-899a-793c3a322854"]},{"cluster_id":"86339977-5115-476b-96dd-1ca67842fea9","members":["bf48e0c8-6b76-4bd1-bb96-cfe6388a9243"]},{"cluster_id":"c54aa827-069b-4ed6-b43e-bde69590b9e4","members":["b753f791-7516-41db-940f-1798e0fdfbf0"]},{"cluster_id":"bc705731-4001-4b4a-a9bd-71359c405ab2","members":["80264d7f-d885-40ac-9716-ec548a6a18a9"]},{"cluster_id":"baaee7cd-473c-4323-bdcb-32b41e2930f2","members":["bfd00629-aad9-4669-991f-7ce7632d7aed"]},{"cluster_id":"ac3739e2-de75-46fe-a991-203fbc3a72e0","members":["794945b4-9967-4114-b28b-9b21276600bf"]},{"cluster_id":"abd5930f-6db1-45e3-b882-ee3ba2f8394b","members":["8d3033f8-b26c-49a6-bbbd-29649925f2d7"]},{"cluster_id":"37512ba8-d5ed-4b9e-9fba-d0ec249a1d84","members":["6f3937e0-0969-4b7c-a2d8-449c9102e2e4"]},{"cluster_id":"1789e573-0855-4766-ab56-773e8cdbeef5","members":["7cd1d0a8-4b6b-4508-a82c-dee4ee393d40"]},{"cluster_id":"2a4109b0-0594-4c99-979e-19f8908c65ec","members":["06b40460-322d-4c00-a603-7425c216f72c"]},{"cluster_id":"3a423758-4300-46f1-8112-c2195cd0ee0a","members":["3b680279-da88-4981-ac94-ffeb7428e442"]},{"cluster_id":"719a33e0-04c5-4203-a193-c262a589d49d","members":["2e53e34e-8b05-4afd-b21e-a0cdf3cdd9f6"]},{"cluster_id":"7e6ac8e9-cc11-4ef0-955b-65da48ed02cd","members":["1efdbb35-4dfb-439c-868f-834c7b846857"]},{"cluster_id":"88ef71b9-0470-4f94-b8a3-c2845e2f29e8","members":["d9f48841-a61f-46f7-9539-6a5c05b24109"]},{"cluster_id":"69f46f33-8514-4ea2-ba72-362d6d1d202c","members":["de49b199-c805-4af8-86b0-6d89346ccf9f"]},{"cluster_id":"7751d40e-e8dc-4a49-ab80-48cd61a84607","members":["ec647ebf-9926-4360-bc7b-b5ce0e925bce"]},{"cluster_id":"0b61ebc9-d9b1-4e5b-9094-6829b839c660","members":["533a7bd6-e829-42a4-9db0-d65325e0a19b"]},{"cluster_id":"59c81fc9-37c0-4304-9d97-9e5694d8be20","members":["ab431245-f9f2-4fc8-9151-1a933d1cc17a"]},{"cluster_id":"158c7584-7298-4494-b705-f2d978c25206","members":["13d983ca-227d-4fce-a25c-5601ce01e1b8"]},{"cluster_id":"ef30a0f0-6c8f-4544-8a16-49df03cd9879","members":["59ba3908-5409-4ccc-a9c8-03413841cd4f"]},{"cluster_id":"170734bc-dfb6-42e4-9b5a-6f9747a63ae0","members":["b2bdcd0b-beea-4a69-a3e2-7a51305b0555"]},{"cluster_id":"1fcf44f5-43a5-44f5-b144-1142863197ac","members":["69cc96b7-da30-47d5-8424-4e395d087944"]},{"cluster_id":"1abec326-fbb4-4834-a440-05a48bbfed29","members":["ed0ec28b-9f14-4602-b693-8e65024224e6"]},{"cluster_id":"769dd442-b312-4ca1-8bda-308188e59a4c","members":["7b589fb6-b848-4438-b798-8bbc2aa8a6cb"]},{"cluster_id":"eeb2d0cb-ddf5-48d2-9af4-27f0f7c318af","members":["d0d92bc5-9c68-46c6-9788-5f5e4bd08bdd"]},{"cluster_id":"1fdf700e-c5ec-4ab4-a4d5-eff0304e7a3b","members":["fe2cb97c-fe95-4131-9801-37c0348a8a00"]},{"cluster_id":"f5cfebe0-089d-4908-8224-abe95a565459","members":["c48a7be2-6dcc-42a1-8ce9-14c71ebcbfbf"]},{"cluster_id":"be7b3105-d76a-4aca-86c4-5d724f3e84ce","members":["240a0d40-b046-4558-ba3a-102a30c4af61"]},{"cluster_id":"773f7bde-1fe5-44c5-9d2c-84b849939bc7","members":["70c05f1a-ed99-4420-a739-2e3fb45d6e38"]},{"cluster_id":"ff8eb50d-ed26-4f4e-b34d-1dd10e2cdbe4","members":["dad945d1-7f00-4509-8a65-103e7f8afbe2"]},{"cluster_id":"06455359-79a6-4ebb-a802-9c4a2595559c","members":["7da6de1a-35b8-4a75-a954-1c24437d58d6"]},{"cluster_id":"ec52d818-47ba-4361-9b9e-62d7a7a87109","members":["5f808033-32ef-47a2-8cf8-fe0d1db9977a"]},{"cluster_id":"f97c3523-e4c9-4551-a240-c5e4c7f8f532","members":["dc1d910d-a266-4155-a4df-137451cf698c"]},{"cluster_id":"2bb22d37-82ad-420f-8b9d-f5e541da469b","members":["2bfb27e5-8f73-4a0f-9c57-06def4d4564c"]},{"cluster_id":"632ff2a8-1423-4189-882c-4d3e14dadc3f","members":["a821d7c6-d6e1-48de-9505-56526b0c68ce"]},{"cluster_id":"52307e03-a0f5-4819-b75d-6ff7244ed5dc","members":["57bf6299-78f3-4468-8703-37069d49fbea"]},{"cluster_id":"a793f62f-9462-444a-a9da-d3e2c115a5b1","members":["4f631004-9ca8-46a8-abc0-375b2a381ce5"]},{"cluster_id":"01196e0c-7fc3-4e40-8d9d-fcbcee3103a1","members":["ac1702a8-31f0-43f1-8a23-564f62f7bea5"]},{"cluster_id":"371a45ea-84b1-459c-8153-e0d2017b4ce1","members":["897cfbf4-b0f6-4c58-9b83-b6b3531ac3cf"]},{"cluster_id":"73834fa0-ff83-4c9b-a609-95e04c072ab7","members":["d8aa675d-70d7-41d6-8136-614334dea547"]},{"cluster_id":"33b11fcf-85c4-4c95-b81e-d603bced718a","members":["9f4f2079-e0e1-4455-a99e-e13c6b676c41"]},{"cluster_id":"42b243b1-6e2f-4145-911d-1a4fb97435e4","members":["47e1651b-b1de-4e01-bcad-20e5d94c4d6e"]},{"cluster_id":"4d6e8834-c57b-472a-adbf-630fe4d997d3","members":["0cad8084-1fb8-40fb-891c-30a8b4e846e3","f2d28ca5-a4ff-4723-afa9-d0c2392f65b2"]},{"cluster_id":"214ffe56-f58d-4fdd-a3cd-ef399506aa9a","members":["8042590e-9b0e-458b-8097-3fb2fc4e378e"]},{"cluster_id":"994afb12-0656-46cd-8fc2-48a9ab17ddc7","members":["250dfb59-beb0-473d-bcfa-07bba81b251a"]},{"cluster_id":"414847cb-46dd-4cd3-8ade-e04a5900b77e","members":["f808aef8-b4f3-4d04-9092-ead8a7ea4b52"]},{"cluster_id":"237a1bcd-f29b-4003-80f0-c4efc0c14bc8","members":["27f39ead-207c-4f99-9b63-e2741885a881"]},{"cluster_id":"f7605d2c-c20e-498d-b5dc-8cc953b6d021","members":["ea5487cb-bfc0-42cc-939b-3e2c476660f8"]},{"cluster_id":"d748319a-ab54-4e2c-9098-21db36bad1c7","members":["35c63cbc-56e1-4b7c-addf-1efbf72b74dd"]},{"cluster_id":"f1a2cf3f-1311-40c2-b18c-4f973df71568","members":["6d655859-153d-4ca8-9eb1-061406ef278e"]},{"cluster_id":"5adabd10-79d1-4a41-a250-38ed66b71fff","members":["ccf58259-edef-418e-bf13-39bfcdab2d92"]},{"cluster_id":"a96dc83a-238f-4ad4-81c6-dfc26af2869a","members":["1c54c370-6580-412e-aead-a07fdebd2ba0"]},{"cluster_id":"6d514f4a-28a3-42c1-8a0f-d24931c265ce","members":["7f28a7bc-70ce-4f0a-87b6-75423e554efa"]},{"cluster_id":"f63e0793-99cd-4330-8985-abb2d981981a","members":["1d967dcf-2dc6-4846-9278-42ad23f9103e"]},{"cluster_id":"d2833c21-07b4-4262-9ed6-9db3cde93c79","members":["6fb200b9-76cb-4e7a-9da7-c612ff8f45de"]},{"cluster_id":"760769b6-c063-42c2-8199-157a1d623f27","members":["4cfd60ef-933f-4a85-9639-8e8f76160982"]},{"cluster_id":"e6aabe2f-c2e1-4dd9-a27b-e84ebb5bc406","members":["480fdcfe-9df0-49d9-827d-49a35cd43537"]},{"cluster_id":"bfb33b2a-3aae-48af-9bbe-a26cf7874798","members":["d665ad60-4c24-4eb5-8ff4-f9aca6191179"]},{"cluster_id":"aa460f1b-c007-4666-8137-aaad655dfd7f","members":["d211d8ee-2556-497d-be81-2865b576a377"]},{"cluster_id":"13d62766-9dfb-443f-a0be-897b64b65358","members":["922400ce-ba75-4f8f-a222-f8cb9e8ff341"]},{"cluster_id":"e281f767-6c47-4711-ad9a-1c5709e1cb60","members":["26df25ea-ebb8-4523-b4f6-0e534c9ae98a"]},{"cluster_id":"14a22666-bc11-493d-b981-1e91858f0777","members":["9f2c235c-00dc-467c-bda5-b638f7d5931f"]},{"cluster_id":"7ea6c0c9-c370-4e5d-93ff-344450b01dd4","members":["618c034b-41a8-4f29-a823-8e13421cc4fb"]},{"cluster_id":"fdf8116a-82e6-4a25-a819-a71aa4bc112a","members":["98f18c47-1019-4558-afd0-14a46c1a1b53"]},{"cluster_id":"fe528005-ab2e-4ef9-9304-cfd861dc09be","members":["b249d910-8a47-4262-8dc7-297740f4a7a7"]},{"cluster_id":"f92a441b-bffa-4b5d-a3f4-495ad67f7ccf","members":["10105712-0635-4e4a-8fcc-db4546350110"]},{"cluster_id":"6e7eeae9-331c-4977-a841-a2cc08dd5381","members":["1ff3eb76-86fd-4185-9efe-c263bc93099f"]},{"cluster_id":"29ce98a7-4a68-4b4f-be7a-d7b325128299","members":["21bd8c67-264e-42eb-8b0e-db6c24c5c21c"]},{"cluster_id":"2c1c9214-d791-4513-8352-ad5103d53749","members":["0cb2ce22-eec1-4086-8d9d-aeffcdc506d7","1dc02e1c-809b-457a-8693-035cb92127e6"]},{"cluster_id":"47a07292-bc3b-405d-8d76-2c61690495c1","members":["f19197e0-4097-457f-8a6f-30ca2c690b11"]},{"cluster_id":"e4d10cca-580c-41e1-9918-7376d930bfa1","members":["42add791-b448-41e4-b232-feb4502ab26c"]},{"cluster_id":"ed814054-66d7-40f4-897b-99909fd4d531","members":["da01f00d-df9a-44d9-bb12-f41c09aed89b"]},{"cluster_id":"1479c6ff-179b-497f-9932-93213bb53a6a","members":["5a816559-a964-4ecf-a8d4-147202021cee"]},{"cluster_id":"088ae3ae-ad79-4cbe-9205-0c7fb4deef45","members":["8cada1de-aec0-4ba8-97e5-04e36d363054"]},{"cluster_id":"ed693943-5db4-4907-b797-9fccd8ed73eb","members":["9bcf8d43-87e4-411f-8731-00fa3640de8d"]},{"cluster_id":"2f8e700c-1460-4a5f-9578-58c60978917b","members":["75f2c098-7112-4a25-8031-e3a6116f5af5"]},{"cluster_id":"34a2bc3b-8f85-4670-8f29-4e2b139366de","members":["a55c1b2e-bab8-49b4-ac95-ac161af5ec93"]},{"cluster_id":"14ef59ab-f50d-4bc9-bdf1-1bc17697f5a4","members":["4e0bbe89-492f-4dfa-be07-cd56528fc90b"]},{"cluster_id":"7e7c3417-e29c-4641-b1be-5336c04805ff","members":["0d8ba46f-3371-4146-b302-4566ce200350"]},{"cluster_id":"b61e836a-7b6e-4f27-85e3-ad2994cac010","members":["c81fe284-1d56-4884-b3a3-e8ed8c832f00"]},{"cluster_id":"48edb9b3-6de4-47d0-956e-e07e3a6cbfda","members":["316f2580-65a7-4aae-97c7-ab89b390be62"]},{"cluster_id":"bc073191-5c75-4ed9-b991-437755cb3cd0","members":["6e529b19-2c91-444a-bb36-d523d8781149"]},{"cluster_id":"e4695f74-046d-460d-a794-197c7df92c76","members":["75cbabf8-745f-4fc9-bd9b-38f0fc91ea4b"]},{"cluster_id":"f53fc0bd-981e-4236-b0fe-25581f5f427a","members":["a2e3ed81-ed7c-4eac-b0c7-03c8d993a25e"]},{"cluster_id":"3c292204-fc50-446f-99ed-6fd49056a887","members":["87c2241d-5cb0-4f5c-923e-09dfac33f675"]},{"cluster_id":"21df275d-4ad2-4f7b-841b-bbaff7511134","members":["c45886e7-dc61-4725-8d00-6f8b9809f869"]},{"cluster_id":"6eae5590-4ea2-4d5f-b4f2-a402cc15dbc9","members":["69044bfe-47b2-4ba7-a16d-a09a754a0188"]},{"cluster_id":"12b80aca-12ee-4bab-a55e-bbfec7c756c7","members":["b6b5be45-4cbf-4a44-a03e-37809ce8f12e"]},{"cluster_id":"2c6c7495-70ee-4e85-b85f-579b0d1c01ac","members":["cb892764-de04-416d-bdc1-9ef20b1cff7d"]},{"cluster_id":"94476e0e-60e0-40ca-89ed-b2626dba60d7","members":["7392faa0-a150-4dba-b56e-4c4d39dc7010"]},{"cluster_id":"03bed382-9ecc-4f84-bd88-6ff53d1b8a13","members":["3f4eefe0-a285-45ea-8839-1c7e19cc039f"]},{"cluster_id":"1351fc52-175d-4410-b8b2-ff88c7747912","members":["121be1b2-8931-49a8-bd34-ebed27987497"]},{"cluster_id":"75d93b8c-bf4b-43d0-94ef-7db799889fc5","members":["24544b2e-6718-43dc-829c-de46e2861ae6"]},{"cluster_id":"019a6206-d313-408e-aa7d-dd9ebfe68ec1","members":["b10a4c06-189b-4684-b12d-ef17a210f307"]},{"cluster_id":"bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67","members":["cb9c24bb-09fe-44c3-a42c-c14e13eb9174"]},{"cluster_id":"9fb4d80f-a91c-46b0-856b-b4507d71a702","members":["2cb8d986-13a4-4fa7-abe9-aa38098c38e4"]},{"cluster_id":"6e25bc0a-2c7d-47cc-a81b-58dba523595b","members":["c2acff46-466e-4233-bfca-55b8dc61128e"]},{"cluster_id":"ee08d940-570d-46a5-a30d-731f0f242ab4","members":["15b5725f-bc53-476b-8f02-9e2be6e1a862"]},{"cluster_id":"68dfb31b-7f13-4eb1-b5bf-740e6918f0ee","members":["10a3df8f-584c-4799-8f82-c3f4d6d0b7d7"]},{"cluster_id":"9cef1461-4ccb-4b2f-8a1e-1d71ef404be6","members":["4d2183f0-82c6-4df9-8187-fa672a4fb201"]},{"cluster_id":"d0a50ea8-30f3-4820-8087-1083e0d5b05d","members":["7476149c-2f26-41e2-b83b-793fe442956c"]},{"cluster_id":"7763c9f8-5bc5-4b00-83e7-8687863ffb36","members":["5529ee13-0c0a-40d8-a3c2-aaa819adc808"]},{"cluster_id":"1484b9dc-5ed0-4d22-945e-34e17801439c","members":["bf9df6e7-1986-4c04-bd62-320f195b6453"]},{"cluster_id":"fcff6be0-ae06-401d-8c01-25c7bfff466f","members":["d099c61e-1609-48c0-8e30-c260de609e9e"]},{"cluster_id":"71920f88-d391-4321-a826-7f3d2ac6a5db","members":["9ebe3258-70a3-47d1-b749-005bc04bdb2c"]},{"cluster_id":"a1591642-57e8-440b-a466-b4c02f9a6be6","members":["3cfb3615-e7f1-4836-894f-7ed0d170c634"]},{"cluster_id":"dae2bae7-bdb4-4c33-b539-e09ed08a3e11","members":["7341ff10-94e4-4f2c-99ca-69e035432945"]},{"cluster_id":"afc9e303-f841-4627-a50f-c58cb00a2220","members":["4173bed8-d09d-4a99-baf2-6806725ecf32"]},{"cluster_id":"55bb591f-ecec-4f30-84a4-1528326dbb84","members":["eb0ebcb7-de5a-46d1-aa61-3144f6040af2"]},{"cluster_id":"8d28e81a-99f1-4b51-9eec-891947b08d71","members":["fa9cfb6f-bb9e-4ca8-86b4-3aa13f3288f8"]},{"cluster_id":"cbce7506-b8ff-4232-9cb2-70afae134899","members":["baa30782-ad77-4b2e-9e57-4310d3a8ab29"]},{"cluster_id":"fdf0468f-b20d-40b0-8a2a-5519d8086286","members":["93eeec64-dd20-4d3c-85ae-53b9f9492d59"]},{"cluster_id":"fcd2863d-6523-42c5-86f2-9d70faca5e49","members":["c41b050b-1bc4-4d61-8530-280de69289ef"]},{"cluster_id":"1f2e46b4-6012-4c4f-8e36-ebb4e20f881f","members":["fc1016ac-2073-4906-8e3c-1ada64d0efed"]},{"cluster_id":"3cb67525-0d0d-4f1e-8f2b-d44f7e022019","members":["83715690-0689-407f-9183-ed0c09ae668b"]},{"cluster_id":"e078499d-145e-47da-8902-0b8d9b181179","members":["71d8f507-dd09-48b2-a6ac-51f4219d35f5"]},{"cluster_id":"4a433aaf-8b78-4d61-9c2c-bc9bf2bfa734","members":["f68bdad8-0be6-4339-bc36-f6095a91184f"]},{"cluster_id":"bd325bb2-82ff-445b-9556-5c3579998b1b","members":["e07db0a8-30ba-47c9-8e98-8e58bdb237d0"]},{"cluster_id":"b87380f4-8f89-424b-8739-272a52634814","members":["997279b1-98ed-426a-8f71-1dfe00c0cfc3"]},{"cluster_id":"07e2576d-9585-4de1-8fed-5653ce340f18","members":["6f851f63-6752-4173-9f20-a83b89928c7f"]},{"cluster_id":"1122df81-54b6-4861-86f2-c9908073053f","members":["ee48e0ea-0842-4c9e-b212-24a573dfe883"]},{"cluster_id":"b21b063b-f7bc-4014-8dc5-34ae0d688761","members":["088e6079-22cf-4c60-8f79-e7bf4be92bc8"]},{"cluster_id":"05a27be4-d98e-42f1-b3e3-bf60c499f807","members":["0f74ee7b-f75b-4e23-8554-9d4fd3997e45"]},{"cluster_id":"6fdf651c-dbd2-4ed4-85b1-ba8e9916ed27","members":["dc4d58b6-b6a5-4e33-8113-1104de0660cf"]},{"cluster_id":"ec9f289c-28f3-4c8f-8168-260fc03a8183","members":["1626dc53-6141-43e8-b9d3-3cf657bec12b"]},{"cluster_id":"6d9e58c9-dbd4-4963-8fe7-594077a6324e","members":["fc7fa7f8-d6aa-46a0-814f-d7777e07ee50"]},{"cluster_id":"86d55ce0-7b54-4708-b491-af72b9d9ff06","members":["c446fa31-103d-4be7-a20a-9fdf249fee0c"]},{"cluster_id":"778d39fb-527e-42ad-a678-aa372a58fc39","members":["50229a45-d8db-4d1a-b9aa-633cced12c5a"]},{"cluster_id":"45dc7d2c-74e1-4100-9b06-cc0f631f56f5","members":["b5b1f2ce-8e67-4fdd-9274-0fda8fb105d3"]},{"cluster_id":"b059c11d-95fa-4f8b-93e3-1c4f21e60f61","members":["91a10dc8-8b8a-42ef-b656-40c78c73476b"]},{"cluster_id":"acda69bd-2a78-45aa-a6fc-5eeaa0b45f28","members":["2f44b72b-9ed9-4836-a422-74659e144491"]},{"cluster_id":"8f3f9d3c-bc51-4937-8cc3-be36bcc68b12","members":["3ca2f12a-dda8-4f5e-aeb4-350f5128b99e"]},{"cluster_id":"186e2ceb-09a9-47a1-9aac-0510446000af","members":["742b16e2-457f-4473-89e7-7d79fc6a6162"]},{"cluster_id":"d635b0fd-8741-49c9-a6f1-294159c206bd","members":["37725301-cd6c-4f8b-ba53-7ac89bb7d93c"]},{"cluster_id":"7eb16fe5-1729-42a0-bcb4-1a4783656ce6","members":["619d943c-5d2a-4a21-a577-d21c72210782","9c0f6744-34e1-4673-b6d4-390fb27b1a9e"]},{"cluster_id":"867afc59-5780-42ae-88e7-83c90a074b4d","members":["2325e83b-a7fe-400a-968f-882df203a73d"]},{"cluster_id":"7598667f-d0d3-42d2-856a-51698f3f1b3c","members":["27fc317a-76e6-4e92-8463-532e1c1889fd"]},{"cluster_id":"f6680d6a-ecb6-41e2-9526-051a689d4c68","members":["5ab691c3-fa6b-46e5-b127-a5ce5a000062"]},{"cluster_id":"52f4f571-7b22-4977-98bd-7282b2a6c5c5","members":["1ec3575f-6c04-469f-92c5-ba4d89f117de"]},{"cluster_id":"5cf38b83-9e7d-4021-9751-cdd7c1a0b38d","members":["99f1753a-60d3-44ab-bb03-dd91fc18e35a"]},{"cluster_id":"65657196-d0ff-4d4a-a7ff-868fd5f099d9","members":["de4ab1ba-1dad-4112-ac67-2abf280c8f37"]},{"cluster_id":"1b374305-b708-454f-b63c-7ff8ae988cdd","members":["2a2c3af2-a77f-4bfa-8412-7dfd2714a7fd"]},{"cluster_id":"e8c99cdd-553e-4aba-b844-e1556f7a8787","members":["7a402d5d-a0ce-4678-be45-af2e707a57d2"]},{"cluster_id":"1bf0340c-7a77-4298-96fe-bdb20d7a37a7","members":["43fb4834-7616-44da-9a18-09041bb3b486"]},{"cluster_id":"6363c274-1e0e-4e09-85b0-1412131b0c25","members":["6b8e73d8-6258-42aa-92a4-ff23daec341b"]},{"cluster_id":"5d1b0403-1447-4432-b6a8-ce335ce3e162","members":["0bb3c38e-09ef-43eb-891c-1d85703bde14"]},{"cluster_id":"b961ace3-c2b8-4138-bb7c-fb147b603dc5","members":["81456b8e-23b0-4a74-8743-2e58b6813f55"]},{"cluster_id":"1e3f8e4e-4dfb-43fa-ad30-aa52542d5f06","members":["916ebf00-2e5e-46fa-b5de-8ee2ca328a22"]},{"cluster_id":"4fe16db2-c3a7-4835-89e2-e57d5e214582","members":["2ccb1cd7-4eca-4a60-9da7-b509302d44b6"]},{"cluster_id":"039f8cf2-d1ad-441e-b62e-9a9fe0c8c803","members":["5fd1dbf4-f4ae-4bb8-9195-ea964920209d"]},{"cluster_id":"b13b5ee0-1421-43e8-a554-5b3888a5cac7","members":["248a9bf7-40f3-4da9-863a-6d903eea0663","75e60699-cc61-4e72-9d34-3786cbed846c"]},{"cluster_id":"470e1b16-db3d-4438-9038-d9ecc0d37edf","members":["2e75e421-b3fc-47fe-9ef6-09d2d33af214"]},{"cluster_id":"7e303676-78ac-40b1-9448-471faabb2115","members":["a0fc6d93-fe8c-4e8e-a8d7-9e45d64c7ecb"]},{"cluster_id":"f1bddab0-3986-4a79-a51e-8622615c23c4","members":["9d6d3d56-0ee4-44b5-a102-774c5e33a91e"]},{"cluster_id":"6e773145-449c-40f0-969b-2f16d4a7c04f","members":["8a163198-c8d4-4b88-a7bf-cd5fc98c4160"]},{"cluster_id":"8b7f2a67-267c-4f34-bf57-216f33b13adb","members":["0e0ab341-4bda-4673-a025-971a69075eef"]},{"cluster_id":"6351b28b-a685-4d75-9a62-c954df9226b0","members":["b37c3cac-8bb5-460b-b7d2-eb33414b5fc7"]},{"cluster_id":"5ac468f5-649c-43da-ae88-dccb98a0bb4f","members":["24b15dbd-56ea-4ece-a1b0-5aa688b711f6"]},{"cluster_id":"dcf0cb56-59c5-419e-a7a3-57fc57640ce0","members":["788ab935-4533-44cb-bf0b-926954d8bf02"]},{"cluster_id":"0a2e15ba-2fa7-41ed-a5c1-17b66869fc7d","members":["11f22217-1c3a-4534-bd5e-df89b12c7750"]},{"cluster_id":"674305e3-342c-4b85-8170-13a2aefe9456","members":["69bfde9f-78f1-43f8-9ea2-86df6169332b"]},{"cluster_id":"95cbf6a7-3664-47e9-8189-3ff3dc6eb96e","members":["fc645500-a1c3-43be-aac2-10992f86dcd3"]},{"cluster_id":"350bc7fa-e017-468b-abf6-4d1ab1633f69","members":["bdb671dd-0d75-4f91-ab6e-132ae191b45e"]},{"cluster_id":"eaf97e4a-55db-4cdb-ae4f-9ab8ecb7e821","members":["70da26a2-352f-4784-974f-a96926d40818"]},{"cluster_id":"7c7cd464-a285-4810-881b-7a151a564ae1","members":["722ff441-3624-4290-9633-b6e564f438d0"]},{"cluster_id":"9a04913f-01c4-45fe-aacb-81aaa1af85ae","members":["055d0702-1678-42d0-962d-d04f89cdfd1b"]},{"cluster_id":"bc3691bd-e8ea-4667-b6cf-1afd5eb88fa6","members":["12e8d861-ad53-4863-bde6-fe0e33ffe000"]},{"cluster_id":"ff2e5690-b7e6-4963-9d4c-23d9e31d0e98","members":["3444cd08-df07-4dd7-8622-dc2db9e5f4ea"]},{"cluster_id":"5d61b2e4-bbeb-403f-8746-07ecabf64059","members":["87e0fdc9-8c76-40a7-ac4e-4676e5f4d10e"]},{"cluster_id":"32c73de2-95e1-45f0-9627-537de9f0f318","members":["cb08a76c-10e2-4478-aa20-448daa882f86"]},{"cluster_id":"ea3f4ed4-bcaa-40a7-96c3-82beaa656b16","members":["d7f48cfd-8d2a-41e9-ab1e-b1b3ebea5857"]},{"cluster_id":"b9b30a00-8e82-4f2f-9524-8cbb18357bed","members":["770c002c-9b9c-4946-b141-beb31de606de"]},{"cluster_id":"d342ed30-fc56-4887-9c80-98861f47054d","members":["56a021c2-c9ff-43e5-996f-c6d7ec23a91b"]},{"cluster_id":"81889b4e-a54e-4052-b2de-56a05ad20bc2","members":["cb168328-3638-4a2d-ac14-48401092d43a"]},{"cluster_id":"49c36ab4-aedf-4b49-9372-e43ee616873e","members":["2849b109-7dcd-46b5-9a90-5d44ec00e9c7"]},{"cluster_id":"32fafc3d-cccf-4a0c-872b-788d937b0241","members":["f2507425-09cd-40be-9ca3-40f697844728"]},{"cluster_id":"64911a50-55cc-400d-9f35-d372b869e1a7","members":["f6ef2b20-ecea-4c28-ae8e-e31bf9960385"]},{"cluster_id":"a850938a-0d12-48b8-a366-a53a16388dbb","members":["a23f5f77-f0d2-4767-97ec-758c1d52ff48"]},{"cluster_id":"f629a198-d535-41eb-8981-0a2a15fcbcb9","members":["cc33b652-dc5c-4d0f-96f9-841a4ed6c523"]},{"cluster_id":"fc55d0f5-c78b-4a1f-a7f3-73448361d186","members":["40077f46-8f07-4aaa-a346-c4a3699dafd4"]},{"cluster_id":"6bf20e7d-0fef-44de-a032-0b603b235bf7","members":["016b4f58-0480-4b0b-a396-5e410315f527"]},{"cluster_id":"63217c83-a56a-4703-b9b6-f928b5437b8a","members":["62a49154-df4b-4a91-a074-6ae7072d7d08"]},{"cluster_id":"2d644f06-03ca-439d-b2dc-c42a08782eba","members":["95d37594-6ae4-4bd5-b088-9925445a3fbe"]},{"cluster_id":"51b63d4e-9a9e-4f49-a1a8-d50a9f8eff02","members":["27241f85-fa16-4ac4-a8b7-15b736e792b8"]},{"cluster_id":"42899209-2504-48c5-8694-2bf64d4edf90","members":["7754564e-329f-4dd9-8f29-c0a8ada7e40c"]},{"cluster_id":"967932b9-89a1-4f1a-8846-57c7efec1e1b","members":["0b3347dd-ff45-4789-ae4d-123e9ce44041"]},{"cluster_id":"acde1f80-8000-4b4d-8e9d-7d24f15b41d9","members":["ce6b82ae-c945-45da-84eb-0cf1f30cea4d"]},{"cluster_id":"4b702552-6558-458e-b6a8-ec2e141d7258","members":["eff50442-47e8-4b6c-be30-a7d2f7ffca40"]},{"cluster_id":"75ded654-747a-4edb-9577-5b6d8ad0c3a1","members":["636d36e0-43e5-47d3-936b-6007b9f3d49b"]},{"cluster_id":"498d40d5-5e43-40ad-a2cf-e0c8dead042f","members":["42c05943-b9ac-4ead-bb6a-948856fc47af"]},{"cluster_id":"4fd61797-afb1-460e-913b-0445bfe516c3","members":["7d4dfb1c-7fe3-4a96-8bdf-09d038389f7a"]},{"cluster_id":"d223b5e1-de75-49e7-9d5b-0ab4514a4ec6","members":["a1bc332a-893a-4b04-bcfc-a272cfefd776"]},{"cluster_id":"83b65fa9-1a4b-4243-9c39-2ff350a46323","members":["c47450ff-8e1c-4402-abce-e241cb06f390"]},{"cluster_id":"7c123398-3043-4df1-bb86-5ded4584dc33","members":["a9e63a08-bc8c-44ad-a902-ff7af830b08c"]},{"cluster_id":"5dc7d30c-f418-4e0a-bf24-d3caf57c0ec4","members":["73cfe112-4ba5-4214-a482-67a9a39b4768"]},{"cluster_id":"9aa4bb60-c9b0-4bd6-9189-bb33a4f61778","members":["5f02da39-e150-40f8-948c-4977f9916faa"]},{"cluster_id":"66420625-d310-4fd9-aca9-82e4fec83c68","members":["b640d8ba-898d-4f84-aeb2-2da68325a5c4"]},{"cluster_id":"04675e2c-1e61-4971-b87b-4cddc78fd434","members":["ed7c927d-f12c-4123-b39e-593052cb5b1e"]},{"cluster_id":"19e2179d-5af7-4b00-a62f-bafff28190d0","members":["2e4f5cbb-4aee-44db-b53e-1ac19783f8f4"]},{"cluster_id":"e0dcc7af-9cb5-4c1d-b108-5d8de64148cf","members":["3166f662-04a5-4569-b8ef-e4a13f9635b1"]},{"cluster_id":"a1e41680-35e4-4649-8fd5-66b72c5b42b9","members":["a9d7cb0f-ef46-4fd0-8eae-149d9bc36c77"]},{"cluster_id":"d5f473e8-ffa8-45f6-bee7-fb81681c241a","members":["f5968a16-3ae9-4016-a310-331ee57638dc"]},{"cluster_id":"6a2d22fd-b7e4-46b8-aa28-69039af2d9e4","members":["79da912d-dbc1-4ae6-bd23-28e93c64cffc"]},{"cluster_id":"c320799e-ed57-4715-bbb9-1237e2fe3842","members":["5f8c89ed-c59f-43ea-8fbf-f1fd778aaeba"]},{"cluster_id":"51212bcd-93a4-4cdc-afe3-422f70697f65","members":["44320b4b-b5f5-4371-b8cb-e0bab284904e"]},{"cluster_id":"157ed6bf-eaaa-4513-ad02-a2a99adf039a","members":["83a28186-9fc4-4973-89fe-3045be17f87c"]},{"cluster_id":"dd33f241-05d1-4f54-b214-172163f88f9a","members":["3f13e771-2787-4f74-878d-01ec9328e304"]},{"cluster_id":"01d3c9ca-6075-43cb-a3ac-1d6094f7282d","members":["d059b70c-37c2-47c2-8675-75a805809e38"]},{"cluster_id":"e8b94f0c-0366-40d5-b082-fa52ed608677","members":["8e1f7e07-8213-400a-914d-0c01cae6ccea"]},{"cluster_id":"8817a4d0-4aef-4c0e-a907-ff92179dff0d","members":["d6e42b72-be4b-464e-b7c4-f3d17051dbf8"]},{"cluster_id":"b21610b3-aecf-410c-9995-b99b144c12b1","members":["09d344d6-907c-472b-b21a-e2d032b8b503"]},{"cluster_id":"ecb10f6a-8831-4846-bf71-113659233f12","members":["dc8edab8-f7ea-4d28-8264-ac56b6c65571"]},{"cluster_id":"e297a044-750d-493d-8fab-439c72fd77f6","members":["28449dff-ab57-4dc5-9bbe-718511d0beac"]},{"cluster_id":"c41f696e-07f9-4e6f-84a4-bbc219b21f87","members":["9a8a3eed-fab6-443e-a46b-9adb0b65aab4"]},{"cluster_id":"b53434f6-8475-4084-8547-bceb679687ac","members":["9eeac9e1-1f53-42bc-89f3-a3971a645d0b"]},{"cluster_id":"bac2fa35-75bf-4c16-a00a-24bb7ad1ff15","members":["9f19ec7f-44a6-4225-9fe9-d4b4160833e9"]},{"cluster_id":"b4243b24-8de4-40d1-8e27-1dec1612406d","members":["5acdcdd3-cfc6-4837-b656-f34ca3d48661"]},{"cluster_id":"22a9a9e1-a369-4cff-a2ae-69fa0403d590","members":["b92cc24d-296a-48a1-a7b2-fa3c54829c4e"]},{"cluster_id":"1e9089f3-b7e2-4ef0-870f-afca46689fbf","members":["0bc5430a-3aa3-435e-9c11-e70b0e7ec6c9"]},{"cluster_id":"080cf60d-e4c8-43d3-806b-a47256c29458","members":["249bb7f1-30c7-450e-8e4f-789fd79f5cf5"]},{"cluster_id":"90309cf4-c7b2-4dbe-a694-62efd0012476","members":["2fc74655-a5b5-4262-89fb-72ae40f44418"]},{"cluster_id":"37b4342a-fb0a-4dc5-96ce-db0bc15c1568","members":["13de59f0-aa18-4f33-a9e8-a1421ebb700a"]},{"cluster_id":"651192ce-035f-4e17-8834-956bf8fefc33","members":["add2b4cf-c6e3-45ea-a301-649db7e48b58"]},{"cluster_id":"8cb3d3c4-596a-4d19-9190-9681300abd40","members":["7c8dbfe9-4904-44b4-a304-26ac404eebc5"]},{"cluster_id":"4fdc1bfa-2d9c-4f20-8628-a8f4ff72ccc1","members":["c9805034-b42f-4db1-86d3-68bfbc00296b"]},{"cluster_id":"af917a84-5c51-4c7b-9efd-b1ddeecaeb3a","members":["a17def6a-a457-4e97-8d32-baf304f29c7f"]},{"cluster_id":"519bca7c-733d-466e-b332-2cb930d5c9b0","members":["9a2c6e26-52bf-41c9-a7ca-4c5324135706"]},{"cluster_id":"9bb19a50-cefb-44ce-9b28-e30fd2969d96","members":["95e68321-4757-42ae-bd68-b039cda7ef8b"]},{"cluster_id":"bca4fab8-15f6-4111-ae92-b37f9696dd06","members":["a58798e9-6101-4ef5-ae6e-77e43a751d70"]},{"cluster_id":"0b6b6a97-32f4-45c7-ada1-27e50504dcb5","members":["68cb46dc-d705-4372-9682-85134cf51860"]},{"cluster_id":"533c13a6-e2bd-46be-9422-2e368c4b5793","members":["6a3a9b49-a121-4d77-9bf9-605d700fc9fc"]},{"cluster_id":"b1375511-e3be-4083-816e-ce6ea23f39cf","members":["e057b111-30c8-44fe-9341-21d1472eee87"]},{"cluster_id":"ac328a78-ba12-4fbf-888f-9c3c8967ccba","members":["07a758f4-3009-4887-9f52-6cffc024f332"]},{"cluster_id":"6bdf1a93-76ba-4948-be05-d02fbb6488f4","members":["b572c1d4-063f-470f-b701-dbc590cfba2f"]},{"cluster_id":"7f23e350-d82f-4791-a6df-263d08bac5c0","members":["016ecb78-c51d-4325-8a45-51c77774d814"]},{"cluster_id":"83743532-1cd2-436e-9911-21445ed61af2","members":["cae2e348-f492-4176-9df7-4a6c0ff875c0"]},{"cluster_id":"89fd947c-c029-4635-8b9d-ca8e953af1ce","members":["82d0ee32-e4ab-4df0-8159-0ab7318b0482"]},{"cluster_id":"92102219-111c-4df9-82ec-b4c0a1a920cf","members":["fd20d16c-a389-464d-83df-7f273015c324"]},{"cluster_id":"d6a1f200-a77f-4011-9cf4-4ff9dd9f9335","members":["d1bf9838-df80-44e2-82d9-088bb376a2be"]},{"cluster_id":"99d7c1e6-04d8-4af7-b4d1-8b1bbaa99691","members":["21dd5abc-de08-4ba0-95a1-a69d8f1ff422"]},{"cluster_id":"1dc64c65-d91b-4753-b1f9-a4cf4ca41268","members":["8e446813-8f7c-4b01-841f-0f4f41e401df"]},{"cluster_id":"c9181b4b-e96f-49e6-ae73-b2dbaaa3fd9c","members":["9e783071-932d-44c4-b72c-073dde1ba831"]},{"cluster_id":"49ea9af0-b84c-4f28-8cc0-a1e13e95b4c4","members":["0c49a33e-052f-49ba-bf55-1ae3ff4a816a"]},{"cluster_id":"172a52ef-f6c4-4bec-a54c-6a0343aa0561","members":["9e55106a-7482-4706-a33f-a00cd680d924"]},{"cluster_id":"f623c469-24ac-43e2-8e2e-e888031af996","members":["f4cc7d28-2245-4715-877f-7e297453bf71"]},{"cluster_id":"9ff255c3-3bb1-4b2b-8446-496debbb40e2","members":["14934671-25ef-4fcb-ac30-7e7a0a24bc5e"]},{"cluster_id":"a5d642f3-ce31-48e1-93c2-529f31b5ca8c","members":["af0e6a14-792c-405d-b028-abba5677a364"]},{"cluster_id":"0d4d1a0e-a8fb-4f12-a4b0-63f68ad14434","members":["f709e126-d65f-4650-8f20-26c6f29e7376"]},{"cluster_id":"4d99bd96-2995-4ee1-aaa1-1e78c622a4c4","members":["0d50ed39-c695-45a0-adf1-647e9acb58b6"]},{"cluster_id":"d7349c27-6262-43ce-9388-35b7e8a7c225","members":["cc964293-43dc-4ac6-b3f6-64826eb075e3"]},{"cluster_id":"d56b27d7-daff-43e9-8fd0-8b6cd93b5536","members":["aee0d9b5-873e-4876-8143-ded63ba56d81"]},{"cluster_id":"75ca701d-5dd3-4eb2-b641-e9b6d4316367","members":["17021d81-1db1-4e4b-bfec-2b8ab480913a"]},{"cluster_id":"a5ff0407-3f9a-4c9e-b0e5-8fe919998cf3","members":["f37a2d41-3591-4675-b8b3-45aecfd0c1b7"]},{"cluster_id":"a64b48c8-6765-4ea4-add1-20cd675e1418","members":["d24b3f28-0f8b-4a28-8b04-e32be4bb071d"]},{"cluster_id":"59f7148b-b06f-4868-866d-00139a58abd6","members":["0748ae90-600e-4ee4-bfe0-075c8f9e1544"]},{"cluster_id":"a568feba-940a-47c6-8cff-f4910bd91144","members":["424761bf-f0dc-48e5-af5a-cac0413c3ec6"]},{"cluster_id":"df593162-9ce4-4407-acdb-640e7602b7fc","members":["d5950ac7-0671-4798-adcc-972fdf905721"]},{"cluster_id":"336f0b3b-fcc5-4691-826e-c234e38bf923","members":["fa95aa46-bb79-4138-86fe-7e6ab9b3242d"]},{"cluster_id":"9914f862-3a85-4664-87c6-f266c89775cc","members":["79d35ee0-ac57-4239-b894-633b79dbbca3"]},{"cluster_id":"1ac968af-25be-488d-9da9-e6211652dcfe","members":["1fa91e98-dfdf-4d17-a1c2-0e55453f5f68"]},{"cluster_id":"4b3adf55-a27f-47ae-8d76-9cdeb5e8523c","members":["cee11ac5-ee9e-4d90-b6b8-a84a489a312a"]},{"cluster_id":"4b620911-0006-4874-ad8a-a8595a7140e4","members":["a3b4508c-58cd-474d-8161-5429b8d23b20"]},{"cluster_id":"053dfae5-6865-40c0-a285-b1e7c8cbaf44","members":["26dbb4b5-ff59-4c9f-815c-e1f87e0122c8"]},{"cluster_id":"4468d3e5-ac94-44c3-a0b1-a59798ce1b28","members":["9517f92c-be11-4f77-b5ee-47c14548bfee"]},{"cluster_id":"c770384d-399a-4efc-a9de-06d7ca1ea0d3","members":["b455d2a9-7776-47f3-bfc2-6bd1840b4e90"]},{"cluster_id":"bdea90e6-def6-4640-876b-5fa83c1b85d0","members":["73a8a531-40d0-4db2-84e2-becc6fa725c6"]},{"cluster_id":"ccffcdf7-168a-480f-bc2b-31955c7b549e","members":["216ca709-f69d-498f-b4f4-786c1e244b9e"]},{"cluster_id":"1ba7e666-27ba-4d77-b5a9-dc9f10927af0","members":["4b51393a-45b7-443a-bff4-0a494e99f6c3"]},{"cluster_id":"11246355-e976-4176-b4cb-550c91543955","members":["cbd4739a-100c-4f24-a7b8-c3247ecbca13"]},{"cluster_id":"26db1e00-6a4e-4036-b6ff-c1da87b844b6","members":["a42bf906-e647-42b7-92d7-36ebf96c9b4f"]},{"cluster_id":"eed368dc-e9d0-472f-90ca-6ea4839317c3","members":["c021dd4d-806a-4032-8bf1-7ebf4d93c3bc"]},{"cluster_id":"ca3c690a-ee2b-4679-9ac7-f2f87ab00ae8","members":["c381469c-31d4-4198-b0b3-e812ef317ace"]},{"cluster_id":"89669f9f-ac80-4abe-98e3-503ca9625f39","members":["8a295faf-9404-48e0-a62b-27c2f552136f"]},{"cluster_id":"dd4be4e8-361d-46ff-9230-0b65d75e82b0","members":["93f0c2dd-8870-43fa-9452-41202cc779dc"]},{"cluster_id":"e924815f-2da7-4209-b239-ad1c99e71b41","members":["0a6a1145-a3d4-4a65-ad60-e225a9c91c46"]},{"cluster_id":"27d4950e-9d1e-4314-b5b5-7fcf43d21e72","members":["3134a2b8-f439-43c9-8be8-b77d0679cc74"]},{"cluster_id":"3f9df2bc-6f72-4bee-88b2-8ddae64ca085","members":["bf33dd8d-4985-4073-8f29-e88dd634f265"]},{"cluster_id":"02dbbaf3-2dcd-4ef2-b716-bd9080164205","members":["0ae7dfd1-35fa-40e0-9e47-14a3f14848bb"]},{"cluster_id":"dcae5341-3559-46a5-8605-6aff132b23e8","members":["89e102d9-1bc7-4f63-bffd-7fda65291691"]},{"cluster_id":"d301327b-e031-45ac-903a-5645a313fba7","members":["7c273f10-c8b5-434f-be52-45e323e4b064"]},{"cluster_id":"460920ff-c88f-43ab-b704-4a3029ef5976","members":["0fbbb965-1633-4ea5-9ce9-928f175f5658"]},{"cluster_id":"227678ba-993d-4003-9922-aa2e2a27ca74","members":["0efe9f04-6dda-42a8-987f-1cce1fdd533e"]},{"cluster_id":"6cd94c1d-412f-4288-82d2-a9deb07dfbe3","members":["b9c1a642-6b35-4068-9dc3-d7b1c57c987b"]},{"cluster_id":"9ef9723e-224d-4c57-9d96-bcf1933702af","members":["c3cd41e0-2bb7-4e09-b02f-d168d847ab28"]},{"cluster_id":"14db711f-b761-4a49-a9c7-2b0c0895c032","members":["fbea327b-7fd0-40ce-beea-46f16a9dbf94"]},{"cluster_id":"f1e3a565-29ca-414c-8fa2-90756a824cf2","members":["083aa95c-3d27-4a40-8b2b-c6dbb45571a6"]},{"cluster_id":"88cb9dbf-3c86-496b-8c5d-43080d758d2a","members":["33f55771-cf51-4296-b261-8bcf53c93068"]},{"cluster_id":"dd459c3b-7734-4c47-b440-fe088ff89835","members":["ba324eb4-9fbf-4cd7-b4aa-f8445cf55c58"]},{"cluster_id":"f61ff023-8da9-4963-951e-7e62c4121c8c","members":["091ff2a4-b374-4426-a33d-f7e23441452b"]},{"cluster_id":"b9b58ab0-89c7-43c0-9654-023c7dc7edd7","members":["24d78005-f0d3-4ce1-8a38-c5f713bfa53e"]},{"cluster_id":"fa5cbe37-2f0a-489e-a2bd-a58e7dfa8418","members":["df94d9a3-14cb-4884-8808-85de69e39f11"]},{"cluster_id":"3e491056-e070-48f7-a358-499c803ca16f","members":["d97816b9-dc50-4549-9310-8f2a26c9df84"]},{"cluster_id":"f8e8b236-0393-4a1f-8e82-d30d9e30a2fb","members":["57d0e2b5-f4e4-4932-9b99-14b636e2d8fb"]},{"cluster_id":"5c5bbff7-5569-43a1-bcbe-db0b95585d05","members":["f4cd8341-4133-4ece-98c5-3f1ae86bfb81"]},{"cluster_id":"1238fc85-6b69-4536-a793-8df12f63f9c0","members":["f5e3fa72-fb2b-4c8e-8937-2731018dc071"]},{"cluster_id":"18ad11bd-8c86-4313-a634-cae071e56b5c","members":["6060e61e-be0c-4d1f-8878-1c1691b915b0"]},{"cluster_id":"635251ae-6796-4c05-a3b4-938f1760fe23","members":["4cceac16-67f1-48e7-8030-b9a52678e11b"]},{"cluster_id":"7e14e717-108e-477a-a145-900678351362","members":["494e5828-8795-4c50-ad8d-fc4c2c209197"]},{"cluster_id":"4c7b4c87-4848-4dfc-82f8-638a5803038a","members":["bc22ef75-a7e4-4de0-ae26-55f122fe2cdb"]},{"cluster_id":"39225686-c932-4b86-8609-bcb573981830","members":["a1d7fb2b-8edc-4915-91fc-fe18cad847db"]},{"cluster_id":"ab42726c-f378-41dc-98e2-0ce10f9d6d07","members":["81f0649e-10ef-4038-901d-eb4f190f3980"]},{"cluster_id":"03a113b9-8fb7-4743-8425-b2ed80e37d97","members":["918addad-d5e4-491e-8588-7c777292ac5a"]},{"cluster_id":"6f318bba-6562-4eeb-ad79-8a89fa75ae26","members":["bdac5e50-c5ac-4987-a66f-56d660418bf7"]},{"cluster_id":"1eac9457-d9a9-4ee2-b922-a850e04ccef6","members":["008fdc96-62f2-4c1c-b1d6-f6f399651308"]},{"cluster_id":"196c610d-29ed-4851-a66d-a936eab5709a","members":["23817343-8b81-46a8-9320-6fa8dee46184"]},{"cluster_id":"2a3a89a0-063e-477e-a31a-17933d228f6f","members":["b56599e9-ad72-4144-9d60-987d74ff264b"]},{"cluster_id":"5b30c301-097d-4b93-b41c-2c7775c1b518","members":["f63db715-5bd4-4e51-bd67-35cb0f93c1c3"]},{"cluster_id":"2e2d4dce-467a-4329-8a65-a9b7ada8d364","members":["23a1676d-b41f-4b99-b09a-8f17c643747c"]},{"cluster_id":"28c6580f-d2db-4b2f-a0b5-3530cff5de7f","members":["6e5165d6-1bd5-4ce7-91c6-45f010d28978"]},{"cluster_id":"4ce53ac2-ac2e-43cc-ab0a-b530b8f75695","members":["54ae4560-4a71-4358-8e33-fef3a52ab75e"]},{"cluster_id":"0357efdc-cefb-46e1-88fc-fd184c29a753","members":["d8f8a2c0-bf07-461d-99c1-9859649a61e0"]},{"cluster_id":"2c046222-ca9b-481d-9b9f-68e4ebbf303a","members":["d3425a87-4b6e-42bf-b2fa-eff4512c53bc"]},{"cluster_id":"af337f53-b9ac-4b98-b218-084883114074","members":["acf7757c-4a99-480b-8ee7-b09918bbffca"]},{"cluster_id":"75ba7619-eb16-4658-b147-47f3f92ed383","members":["7821f6dc-af3a-49ec-b236-d2ddae3f9d02"]},{"cluster_id":"1c8762e3-159f-4448-bbc9-4a59d7bfc9d5","members":["e3089e01-dca9-435b-b9f9-e996f3add74f"]},{"cluster_id":"87def324-7a40-461a-a80b-cc6aa7391757","members":["2bdcca91-cc30-45f0-91c7-e6e19e2b0c33"]},{"cluster_id":"0d1f3710-22b1-4ca4-9501-1c3095b8199a","members":["c79bfc63-8fee-4065-942a-5bd69c39be00"]},{"cluster_id":"7a111e6b-975b-4ed3-9b97-e727f9682f28","members":["b4e5ffeb-5b1e-4223-b639-c6993b27b0a8"]},{"cluster_id":"cfa0cfe9-0423-44d2-9909-74aa5f5c8e41","members":["b3c01f64-695b-45dd-86ac-3532acdb540a"]},{"cluster_id":"71623d2a-780c-4e92-af1b-eb0e9b031c0d","members":["5f892b3d-872c-4d53-bbc2-e4db6eea1682"]},{"cluster_id":"8945e273-b3ad-4ff1-a46f-200b7adcf6a6","members":["c483ea93-8523-41f9-a61e-ee868ad4cf6e"]},{"cluster_id":"b14c3761-a874-48e7-9fb8-15aebb4dd009","members":["17172956-7a49-4cad-bad7-acba17942b4a"]},{"cluster_id":"af5dc56f-c303-4ae3-a3a4-2b17b1e05cac","members":["fbebad4c-0764-4bb1-ac23-cf33fefb6479"]},{"cluster_id":"6cf816f8-e003-42cf-8cf6-67f77f267b93","members":["1a4978e3-02e9-4fa6-b620-2cccd43851ab"]},{"cluster_id":"282bf62f-9c0e-4150-9c45-5edc6ab7a29f","members":["e7b35665-d6ee-4f1a-8e50-f74ec2d2acec"]},{"cluster_id":"81b74ec1-1e27-4ec6-a6ad-9c28cfcd7074","members":["00a2a27d-32c8-4a8b-be3b-9ed3e06ffdc7"]},{"cluster_id":"cfb71f70-69b3-4e36-b2b7-df43f0d519a2","members":["25aada7e-13e3-4369-bf9b-717144c5afd7"]},{"cluster_id":"7b20021b-470c-46f3-841f-c47d4c52551f","members":["2aeb304e-6e62-44c1-b9a6-7aec1b078436"]},{"cluster_id":"32f448b3-33d8-4d45-9792-ba9ba2feec34","members":["2eaa4d5f-5434-4b0c-97c1-dfe2fa199bab"]},{"cluster_id":"98018dbb-a9a6-4b5d-b356-863340b24362","members":["fb3a0ff9-85fd-4a72-80a0-e6867be164fe"]},{"cluster_id":"cf92f2d9-5ad3-4f3b-877f-c3c333e4eaa6","members":["50193c60-d618-4f3a-abf1-4f0b12109764"]},{"cluster_id":"607cc6ab-a0bd-429e-a391-92e1066b96d9","members":["b47f6e2a-d3a4-4ae5-bd22-18f9947d3e27"]},{"cluster_id":"ccd586d7-5c30-4f84-8142-adc54ddef655","members":["351cc15c-a27f-47ca-b694-732d51544410"]},{"cluster_id":"5db2dd2a-560f-4f51-8086-9e7ff5236782","members":["3f9f599e-0545-407d-a228-856b831a5cb2"]},{"cluster_id":"e2a1f0e1-e053-4231-9242-7b160200d696","members":["05f75e3c-f07a-4364-88d3-a266a0b06c8b"]},{"cluster_id":"e424d11c-d0d7-4fab-ba10-6b37559e56f0","members":["2760a08d-440e-473a-8c1e-715e05679c7d"]}],"cluster_links":[{"claim_cluster_id":"dfbc19e5-8117-4d40-9c25-774ed7aee906","event_cluster_id":"713b16e4-cb6f-4c7f-8eac-cbbfee258e85"},{"claim_cluster_id":"e370d332-674b-403f-8471-184685b21c55","event_cluster_id":"dcbfce15-858c-4e65-80b3-6f982fffc5b4"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"7fe41e18-746f-4276-85f6-d30d85eaa538"},{"claim_cluster_id":"dbcdf7e4-c865-4f31-a79f-0cd2eef3258f","event_cluster_id":"f7605d2c-c20e-498d-b5dc-8cc953b6d021"},{"claim_cluster_id":"eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0","event_cluster_id":"83e19f20-191c-42c6-bdd7-ee466f6ee0d2"},{"claim_cluster_id":"546cb276-d6b0-40dd-8288-6659cb7989f0","event_cluster_id":"51c1b08d-506f-4dea-874d-a86b8ab55fb1"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"af337f53-b9ac-4b98-b218-084883114074"},{"claim_cluster_id":"1a006b70-5bcf-42d1-91c0-d02ee212c0eb","event_cluster_id":"c2c95c94-edcb-470f-82d7-17f1cc69860f"},{"claim_cluster_id":"30d2edfa-6d58-40ae-bac6-ec1273c415ac","event_cluster_id":"1ed0bff4-f942-4d7a-bec9-87e9c09bf276"},{"claim_cluster_id":"00cfa90d-eff5-4498-89d6-85dadca46eb8","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"d89e632e-b2af-4331-9344-c7d1e373d49b","event_cluster_id":"b9f9ee97-4a90-4a60-a376-32010848d648"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"4ccf7bf5-90df-4621-97ed-669020415167"},{"claim_cluster_id":"a0209bc1-2ecf-46c2-8b3d-8258fc85b6a8","event_cluster_id":"0cb0d661-8f49-489f-95ee-927e21758c32"},{"claim_cluster_id":"6f9b01a7-d717-4ce1-bd54-f5647d476287","event_cluster_id":"5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"},{"claim_cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","event_cluster_id":"75d93b8c-bf4b-43d0-94ef-7db799889fc5"},{"claim_cluster_id":"2b47973e-934f-45a0-98dd-aacefd7432f8","event_cluster_id":"fe65ec5c-3bc8-43b1-9738-60a0ae594f25"},{"claim_cluster_id":"a4182192-73bb-4165-ad72-05ff39be899d","event_cluster_id":"c7e4e067-9226-4d57-b404-ebdc121f49ed"},{"claim_cluster_id":"773a0c25-df3d-4865-86dd-a73825ed69b0","event_cluster_id":"1bb1e966-aeca-49bb-87b9-768c9cbb3254"},{"claim_cluster_id":"b5432b8d-5ac9-4f60-8977-fdbcdae395a3","event_cluster_id":"bca4fab8-15f6-4111-ae92-b37f9696dd06"},{"claim_cluster_id":"c0fbbbbf-776a-47c5-9e8d-f798f722abf7","event_cluster_id":"5abf2d27-62a3-4f2a-9794-398729b78b13"},{"claim_cluster_id":"47fbc359-0497-4aac-8a4b-e63bd060a1e2","event_cluster_id":"afd3270e-5e96-4569-902a-2454d2aa0df7"},{"claim_cluster_id":"dff8a985-ffc1-4946-ab7d-43e8406aca00","event_cluster_id":"27d190cd-822a-4b37-b138-1b1b73c5196b"},{"claim_cluster_id":"d7cbd37c-10fd-4628-bba8-b434c41ec43f","event_cluster_id":"4c79fc69-3bd0-4180-9718-8d85b8c9dd85"},{"claim_cluster_id":"bd6de2da-8b5f-4e38-83bd-28294e175aca","event_cluster_id":"8c2c4d45-17ad-4731-921d-8582fefe2ba4"},{"claim_cluster_id":"d37ab208-5122-4b14-a2ce-fa0d51ab2a4b","event_cluster_id":"f63758ba-bedd-47a6-901a-a2e5321c2bbd"},{"claim_cluster_id":"d3777022-58bb-45d2-9153-3e33e4a367f9","event_cluster_id":"6d479b93-5e42-43ab-8ac4-7f31b557309c"},{"claim_cluster_id":"6f59c0c4-2b1f-4873-80b4-3766eb7b28aa","event_cluster_id":"944bd314-7efa-4d4e-ad2d-2a560ec194da"},{"claim_cluster_id":"d41663c0-a43a-40f6-ae8e-9e6eeb720de9","event_cluster_id":"6a879b2a-d8ee-4202-a129-be28ec711b2b"},{"claim_cluster_id":"9ffb85b8-5080-4f27-85ad-554406cf7402","event_cluster_id":"af431814-360b-4c41-83d1-6147d4068846"},{"claim_cluster_id":"621b2187-e651-4a6f-becc-2a2a2cd444a2","event_cluster_id":"a16ccc88-94c6-46a6-bbdf-ea9f1e6f5d27"},{"claim_cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","event_cluster_id":"46dfd54a-6aa7-40ae-be06-53fff6d54a50"},{"claim_cluster_id":"33e1162a-91ae-476d-b4d5-3b1e2f01a5c1","event_cluster_id":"fa141cd8-01d2-46a8-8dd5-b14aea438fec"},{"claim_cluster_id":"500957af-7f87-40ca-b575-44450d181bfa","event_cluster_id":"5e3b2dc6-8e5b-4236-bdd1-0dbf9bb9618c"},{"claim_cluster_id":"4d2c8d1c-73d7-42b1-87cb-56c8ddf68982","event_cluster_id":"36d77123-4871-42ae-b0c9-6b46e2bd9d65"},{"claim_cluster_id":"83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6","event_cluster_id":"bfb33b2a-3aae-48af-9bbe-a26cf7874798"},{"claim_cluster_id":"7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607","event_cluster_id":"ed693943-5db4-4907-b797-9fccd8ed73eb"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4","event_cluster_id":"d17ccb3f-9b25-4161-8681-42ad54f325a9"},{"claim_cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","event_cluster_id":"470e1b16-db3d-4438-9038-d9ecc0d37edf"},{"claim_cluster_id":"cbe32f56-0dc5-4870-8a2a-874435ed2ed9","event_cluster_id":"09116da3-a819-4889-967d-7f1f71fd03cc"},{"claim_cluster_id":"fd127341-6938-4e10-8b5d-771537846e8c","event_cluster_id":"b680d78a-6796-4b44-a00b-5861ed074dcd"},{"claim_cluster_id":"5904fe8c-6989-4981-93c1-c6202b0b4d88","event_cluster_id":"b91a4bd2-e629-472a-9c82-852acf9ccef7"},{"claim_cluster_id":"cc37a7b6-46fd-4cda-8faf-63a00cd3c131","event_cluster_id":"f18619a4-4f58-4ae8-a9ef-fa5f0bef0daf"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"4d37159d-0a18-4557-9e9a-a0401bd9cb08"},{"claim_cluster_id":"22107865-2cc2-437f-be8c-dd105a24eaaa","event_cluster_id":"ebbce66e-0d97-4659-a453-e44542e8d915"},{"claim_cluster_id":"d2c2f402-f56b-4dfa-98d3-daf63239156d","event_cluster_id":"f7ebd749-2aba-4604-bcc7-3f28208b0612"},{"claim_cluster_id":"8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4","event_cluster_id":"7c268167-b621-480c-ba79-7005ed13e2de"},{"claim_cluster_id":"b5aab15d-0623-4834-b9a0-c066e3616369","event_cluster_id":"0c90c874-03f1-47c0-b8b4-7fe34021d559"},{"claim_cluster_id":"73dcede2-49d2-4bc1-a599-b15a7d0094cf","event_cluster_id":"5733967d-8845-4b54-bab0-e2652b43f156"},{"claim_cluster_id":"69315435-638a-4ef2-abe8-1d91d23ff51a","event_cluster_id":"3cda3833-2d58-4e6e-a35b-5bec2cd74e4d"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"c80f9729-aadd-4634-8ad6-b098c5a58675"},{"claim_cluster_id":"5fb2043e-87e6-4ef1-829c-b51f962dada4","event_cluster_id":"cef4b627-4828-4a00-9a55-7f92b9804c1f"},{"claim_cluster_id":"a0fab421-41ab-435c-b6c1-ee353c134771","event_cluster_id":"27a6e31f-9188-49c5-afc9-f45a074457ba"},{"claim_cluster_id":"ffb2c778-a1f6-402c-8381-54550bf56799","event_cluster_id":"8a24a294-bd79-41a9-b04a-466874226ecd"},{"claim_cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","event_cluster_id":"d8869910-ef23-4e2c-a1a9-778ac3a96b8c"},{"claim_cluster_id":"e36180c3-afe0-495c-8168-73e631f50a1c","event_cluster_id":"e6b11bad-8ee1-43f8-a49c-9856a434923a"},{"claim_cluster_id":"cb357706-7b58-4396-aa24-1c59beae87fa","event_cluster_id":"e2e4a182-34d1-44dd-bd17-91104b15baa4"},{"claim_cluster_id":"d6145953-8619-428f-9b84-07cd47d4180d","event_cluster_id":"22f3bc98-8ed4-4355-8d05-5399a3757d7b"},{"claim_cluster_id":"4d2dc30e-97f5-49d3-80df-c343048e6856","event_cluster_id":"e42d98f9-07f8-45be-ae88-1f54a5594edd"},{"claim_cluster_id":"298b76c6-3ed3-4a84-8894-fa50a9f4234f","event_cluster_id":"5b79ee45-2abd-45a2-8873-e58d11466b36"},{"claim_cluster_id":"64599826-faee-4fcf-9432-967663d05451","event_cluster_id":"3ae7e3a9-52e8-497b-addf-b434f9dee4bb"},{"claim_cluster_id":"7a7464b2-8279-45dc-b2ed-48f2c4d22d10","event_cluster_id":"c49cd086-ee6f-4cec-890b-ecf827080344"},{"claim_cluster_id":"5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa","event_cluster_id":"b22a3d90-fc7c-4c0c-8913-b55993380bc0"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"883c65b8-c8f1-4a3b-8bd5-fb9d61a95876","event_cluster_id":"79350a97-33bb-4081-9a5c-bebaa0641f2a"},{"claim_cluster_id":"b6dd34fe-58a4-4775-be96-ca839f926747","event_cluster_id":"fd395743-8cf0-4953-ace0-85cff9e72be0"},{"claim_cluster_id":"da661a25-9665-44d1-ac27-e2613681adf1","event_cluster_id":"c218f143-d00f-4444-8a1a-91fa210ebc65"},{"claim_cluster_id":"a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20","event_cluster_id":"9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"},{"claim_cluster_id":"c3cd1557-129f-4369-b850-25bdf5456c16","event_cluster_id":"d5e78a91-2d42-4f38-b8d5-690a40967ad3"},{"claim_cluster_id":"ea08b9f4-137e-40ca-ae54-2e396aa18fc5","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"544ac6da-d621-4fd5-bbf8-4a2cd6254e41","event_cluster_id":"a1f32f8a-32f7-4bba-b1fe-edc8382be9e5"},{"claim_cluster_id":"b633274f-2881-417d-afbb-e5015101f863","event_cluster_id":"911f995f-4932-433d-afa5-fabf5bc995f7"},{"claim_cluster_id":"463ff506-01da-43ee-96ab-3704e89855e2","event_cluster_id":"1fdf700e-c5ec-4ab4-a4d5-eff0304e7a3b"},{"claim_cluster_id":"12ff0964-4c5c-4f91-8269-1e4ab61e9602","event_cluster_id":"3595c0cd-b164-431e-b192-61bc7dc0019f"},{"claim_cluster_id":"d9366872-6ca9-49e5-9e80-86c5b954d463","event_cluster_id":"cf0fcabf-722c-47eb-957b-91614bc676e4"},{"claim_cluster_id":"b198bd93-5f96-4992-9aa2-29e396814e39","event_cluster_id":"f0ad65d9-233e-4737-b565-7bb483317155"},{"claim_cluster_id":"e9280ed1-20ec-4c75-8468-086e8c6749dc","event_cluster_id":"ec0d2b84-2d88-4935-ba00-876f0eb3929f"},{"claim_cluster_id":"3f09a0f3-521e-4c59-84d0-5adbf02dbf98","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"8dca8952-fbff-4b47-ba25-a7640fe52fba","event_cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c"},{"claim_cluster_id":"c9b6b0e3-811d-4e56-9eba-3408eb1dc06f","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"00ac14b3-c6d6-458b-b4cd-3981a1a2b9f9","event_cluster_id":"7754f22c-30c5-465a-b231-a607a0c13504"},{"claim_cluster_id":"f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3","event_cluster_id":"a3067b08-040a-4461-a857-7a4d88845295"},{"claim_cluster_id":"f17dbb9a-8968-4ade-a774-02688b6da89a","event_cluster_id":"72e8bf8f-e8db-4e42-bec7-0ed7ee61d61a"},{"claim_cluster_id":"235bfc4a-e3f2-4850-83c2-a78043ab464b","event_cluster_id":"cdca7f1c-2f77-48ee-ab2a-8828f905776a"},{"claim_cluster_id":"7cacaa03-4763-4931-91bd-306a3231361c","event_cluster_id":"f200deff-bb81-4d41-8008-3dc621e11aae"},{"claim_cluster_id":"c0426c3e-a327-4be7-b689-905cba5cdfca","event_cluster_id":"63edca78-13df-4735-a10c-6f9089b9d044"},{"claim_cluster_id":"c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333","event_cluster_id":"f07e6f30-0af3-4009-9a85-94198bcc5a45"},{"claim_cluster_id":"5389eae7-83b1-4726-86c2-9a8dff51be59","event_cluster_id":"365e9714-a651-4229-98f7-325862506f0b"},{"claim_cluster_id":"06c89f07-f873-4ab4-9068-3bbe6a0c9e11","event_cluster_id":"dd4be4e8-361d-46ff-9230-0b65d75e82b0"},{"claim_cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","event_cluster_id":"f2253ad2-0cf7-4f4d-a01d-da6760a12103"},{"claim_cluster_id":"9e71565f-1fc8-4e9e-a3ed-15e11a8ef776","event_cluster_id":"b21b063b-f7bc-4014-8dc5-34ae0d688761"},{"claim_cluster_id":"fc1c32c1-8212-46dc-b3e4-29a2254a34ba","event_cluster_id":"1a4aae73-4152-4a0a-830e-ec3794a86bd7"},{"claim_cluster_id":"8b8d3259-7bca-4683-902c-7b72552f88ab","event_cluster_id":"4deeb553-8438-4bc5-89db-299a071d6d12"},{"claim_cluster_id":"075f7aea-756f-4e67-bf46-f4305230821b","event_cluster_id":"12d9ff77-3eea-4aa4-b8ee-4d436789ff3b"},{"claim_cluster_id":"3dc82114-c98e-4342-a6ab-854d95d9efa7","event_cluster_id":"a815c927-5e75-49a5-ad08-40e7381924c6"},{"claim_cluster_id":"17ea1514-c948-487c-83ee-722001d6184e","event_cluster_id":"7ca6b83e-0750-42ad-b001-d24a26fccbeb"},{"claim_cluster_id":"7386324d-4730-4b17-8d70-6b33d62d5be3","event_cluster_id":"e24f9229-3672-4631-abf5-3ab616111d97"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"3c10b554-db0c-4b37-99ae-e28966332651"},{"claim_cluster_id":"3bc352c0-0d5e-42f4-ad88-e7f025e20e88","event_cluster_id":"f17de551-5a88-4bbe-a63a-f23269257469"},{"claim_cluster_id":"469a2781-0070-451c-bc21-b7ee2b0da3f0","event_cluster_id":"e6db83d3-cda9-4430-8a6e-a7718c384123"},{"claim_cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","event_cluster_id":"40a7eabf-afd2-4baa-a287-e3b8fad136d9"},{"claim_cluster_id":"3249ee55-684b-4bbb-8b52-6766f62838f9","event_cluster_id":"d285c4ec-3955-47ea-918b-05a93083bebc"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"cf096384-5ede-4929-b992-9e6ee20d6a8b","event_cluster_id":"e5da69ec-b7e5-4fec-8bae-3161bd3d02ca"},{"claim_cluster_id":"53bc38bf-651d-46ea-8aaf-f63f52195a45","event_cluster_id":"d223b5e1-de75-49e7-9d5b-0ab4514a4ec6"},{"claim_cluster_id":"6e5c19c1-853c-4797-84d8-7f68386994d3","event_cluster_id":"08dca077-8e26-493a-9038-2f3ec565da5b"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","event_cluster_id":"4d6e8834-c57b-472a-adbf-630fe4d997d3"},{"claim_cluster_id":"5f266248-0a3e-4fc2-afec-4bfc7ba1a633","event_cluster_id":"c4bed539-a0aa-4ff8-9be3-4afa92598dee"},{"claim_cluster_id":"51086a98-c771-4b7c-8eaa-b6fbb8629a30","event_cluster_id":"186c5c04-d5bb-4764-8a32-550ebb9ed5fd"},{"claim_cluster_id":"ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb","event_cluster_id":"b96e892e-f2b5-4f40-833b-36af1949d85f"},{"claim_cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","event_cluster_id":"01d3c9ca-6075-43cb-a3ac-1d6094f7282d"},{"claim_cluster_id":"563140da-8f58-4b64-8987-47bb018b6821","event_cluster_id":"c577dcab-43f4-4988-b6a9-b023d7e8abb2"},{"claim_cluster_id":"64de434e-21f8-43c2-9395-33dcf3b86c3d","event_cluster_id":"93707dc5-36b1-4b18-b721-a98eb38368ea"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"fced5669-e70e-41e7-920b-f76f2f50557d","event_cluster_id":"92dc2b29-cee7-4ea1-b9e9-d0593544c75b"},{"claim_cluster_id":"28feb358-2926-4cba-8425-f09fe5ebab7a","event_cluster_id":"ce1afbc7-cb83-43ef-a574-f0c71eec061c"},{"claim_cluster_id":"b8c8cd38-7dea-46d6-b8a1-7316916dd462","event_cluster_id":"9fde602a-5d0b-4ab4-85c7-e2300402299d"},{"claim_cluster_id":"69290a80-8807-401f-b38b-0ff5ba27a43d","event_cluster_id":"ed8f044f-96b2-4a20-8622-207bfd8ae25b"},{"claim_cluster_id":"2da1e2c0-6b7f-4a59-bbad-c83252a70f91","event_cluster_id":"43ab7664-f265-4e8d-9a0a-5ae73e4eeadb"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"2ad0c3d6-c24f-4917-a1f6-8d2bd77034c3"},{"claim_cluster_id":"843e2174-20bd-4386-beb4-ad4f8d0ba790","event_cluster_id":"28705389-d7d8-40a2-9a03-e4eb35877525"},{"claim_cluster_id":"235bfc4a-e3f2-4850-83c2-a78043ab464b","event_cluster_id":"89e88d24-d19d-44d7-b8a5-9a1551934f01"},{"claim_cluster_id":"3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9","event_cluster_id":"dfab974e-91dd-4ade-9c9d-e89b40d58378"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"4b50f48f-0dd4-4d51-a40b-e932902a32fc"},{"claim_cluster_id":"61922f77-a020-4916-b901-44fe7982b789","event_cluster_id":"77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf"},{"claim_cluster_id":"4ef708bd-198e-4a9e-9652-a1b08bc50fd9","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"f4c860ae-1c6c-4478-89c7-fac05f3999c6","event_cluster_id":"720ca61f-9942-490c-ab91-755d5a979ee2"},{"claim_cluster_id":"61922f77-a020-4916-b901-44fe7982b789","event_cluster_id":"455f3cb3-d253-4739-8dfa-e88137f7f063"},{"claim_cluster_id":"0884e607-6aee-438f-ad6b-dac7b6c0719c","event_cluster_id":"59e94cb9-614a-49f2-a91e-9928ad318f00"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"d2ffb0e6-959f-4fb3-a43b-5fea64c717c0"},{"claim_cluster_id":"c98491ce-51cb-40b0-93ae-d389e1c9d7a5","event_cluster_id":"9a693a02-7bfa-493e-8c56-142555000e80"},{"claim_cluster_id":"64664899-be28-4387-939b-822e6b833f08","event_cluster_id":"fa2c58b3-15f9-417f-89fa-2899f5ce4fe3"},{"claim_cluster_id":"59e6bbb6-5982-4df0-b59c-33f07ce159f4","event_cluster_id":"3f649da1-9f4e-4906-a4fe-35e3ec3f6e86"},{"claim_cluster_id":"5c1d5636-b62a-4962-911d-1136d9629b6a","event_cluster_id":"abca71f2-b0b7-497b-b1ed-9f04c6ea4023"},{"claim_cluster_id":"2c834413-ef2b-486b-81d5-2e0a687a8ca7","event_cluster_id":"6799e4ae-598d-4d1f-8409-ebaa05c79c71"},{"claim_cluster_id":"61152334-8dda-42a2-bb8d-9fb770fd72f7","event_cluster_id":"745f9d2c-8956-422e-91cf-53ea37e70f82"},{"claim_cluster_id":"a950be1b-733b-40a8-b78b-7a36e0c5c2ac","event_cluster_id":"9c21e744-a69f-4d9f-abbc-ec67be5c4220"},{"claim_cluster_id":"767a107b-6141-45c6-9ffe-6f7fde1b3426","event_cluster_id":"67cd7c4a-a6b3-4e11-9b6b-362422489e76"},{"claim_cluster_id":"6a4b35a4-0785-4292-8587-aee85db61288","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","event_cluster_id":"270c2a25-c40e-45fd-b4d9-9d1e09305cbf"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"24b243a4-0f35-4d99-b275-1610156f7f35"},{"claim_cluster_id":"e7287d47-759e-41f0-9641-093ab1e3e04c","event_cluster_id":"6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb"},{"claim_cluster_id":"54385df9-c5b3-4372-ae3b-cfd7db571df8","event_cluster_id":"d64d430f-8c0f-4a8b-850b-225e57fc685a"},{"claim_cluster_id":"cf399998-137e-4270-8827-7c726197fb9d","event_cluster_id":"97d31fcc-0a9f-4dbf-b6c8-d1db70a61d1f"},{"claim_cluster_id":"a0fb284d-9ce5-4422-a3d9-508052dde7fe","event_cluster_id":"43507aa1-0b73-484a-ae6d-901aa511c57f"},{"claim_cluster_id":"38d2a616-9f37-42ea-8e5e-3010dc76a2ba","event_cluster_id":"d3a2d90d-13dc-4075-9660-3952f836b150"},{"claim_cluster_id":"b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc","event_cluster_id":"87e69472-d284-42bf-9dfe-9535bde32efa"},{"claim_cluster_id":"1469928a-aef7-459b-af14-6d6ac0ca72d3","event_cluster_id":"e90ef9df-5189-4af1-8d38-f4bc22fa022a"},{"claim_cluster_id":"1713cb4d-ab0f-4257-a2cb-4aec01e411ef","event_cluster_id":"1d4622f2-0a7b-4423-ad78-a011864bf902"},{"claim_cluster_id":"fb6ff34e-94b0-4910-b613-9ebb9af0b6b6","event_cluster_id":"9528f35d-9b68-417f-b3ed-2c5b3d1cbe83"},{"claim_cluster_id":"ea6a2243-de2d-4dba-b6c1-70fc6e903bfb","event_cluster_id":"597adccf-df25-4f4a-b01c-58baf036682b"},{"claim_cluster_id":"8b3203a2-f473-4957-9689-fdf6ee974697","event_cluster_id":"17ce8541-8518-4283-a893-e35ad31e95fb"},{"claim_cluster_id":"40fee78e-be14-405f-8e91-d6685b9587a5","event_cluster_id":"c9181b4b-e96f-49e6-ae73-b2dbaaa3fd9c"},{"claim_cluster_id":"91ccf699-eaec-41a7-8213-08934dbe2395","event_cluster_id":"f1a3e12a-c3c3-4476-aaf7-ecead6148d82"},{"claim_cluster_id":"5cd897af-cb8c-4335-a548-c9963c43f060","event_cluster_id":"37b089f1-912d-43da-b995-2ef9b56de813"},{"claim_cluster_id":"746a6f97-55c7-4dc9-ab6a-cc007e33449e","event_cluster_id":"0404c137-e8e8-457f-ae4b-121032548258"},{"claim_cluster_id":"511c0db2-0769-45d5-a814-00f974a659aa","event_cluster_id":"143e5a89-f562-4e9e-ae94-80a1636c09a2"},{"claim_cluster_id":"554fbe05-7cef-438d-8e82-567521788239","event_cluster_id":"cc877779-d56b-4dd9-8cf2-4d0193c50ac9"},{"claim_cluster_id":"1c24dadf-70dd-4f00-84a1-ba00a5d442c5","event_cluster_id":"98230e6a-7d95-4671-8b15-8c0dbec5af34"},{"claim_cluster_id":"9fb5216e-3d0c-403e-a2bf-9368fa3e3592","event_cluster_id":"a0925808-7df0-46ec-bb06-9cb553f8b8fd"},{"claim_cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","event_cluster_id":"77f11c57-3238-4a6e-9949-a3af094990cf"},{"claim_cluster_id":"29cb7e64-a98d-4be8-8dd8-aa5a3b83d517","event_cluster_id":"7ed8137c-2279-4400-b674-1dd86eab9aa5"},{"claim_cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","event_cluster_id":"4791dca9-cb90-4716-841a-c69798c940f2"},{"claim_cluster_id":"17dbd7df-f3d1-4902-a103-f97b03017681","event_cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02"},{"claim_cluster_id":"f96435db-3d9a-45de-8398-45bc9dbd4fc0","event_cluster_id":"66d1e8de-40d0-4ef4-80a2-bb8b898bdabc"},{"claim_cluster_id":"7c045c5d-d9cb-4901-a4fe-8f8a68090a83","event_cluster_id":"8a12c9b8-6999-4708-96d0-9b9b5cea643c"},{"claim_cluster_id":"6e63c4ba-f9ee-49c7-a87f-b38ea11837c4","event_cluster_id":"037c02f8-bec2-4837-9533-93f63490c709"},{"claim_cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","event_cluster_id":"4693632f-2c46-4370-bcbf-41570c0b3112"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"2c24d987-e81b-4cb7-a369-7fc133161292"},{"claim_cluster_id":"9142e74b-a217-4be0-8685-ab7ea89b683d","event_cluster_id":"7c1fc423-517b-4edd-ab51-ee1fbb6a01c1"},{"claim_cluster_id":"aa973fc5-c596-49d2-86f1-80f2a9f419e9","event_cluster_id":"410ec318-9df5-41c9-964f-b2ab6d13b1bf"},{"claim_cluster_id":"4b18f200-0ad0-4f45-9303-c7be1cc1c733","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"7ff438ec-b701-48aa-b613-4bfeaba7bcce","event_cluster_id":"6b13e7ad-350b-4ea9-8771-684dda7f984a"},{"claim_cluster_id":"d60742af-37a3-43e0-afb8-5df777dac64e","event_cluster_id":"a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"3de2ede6-0765-4692-aac5-cd554d7b3943"},{"claim_cluster_id":"d521ac4e-4810-4638-bb77-9fbf7ba74f52","event_cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d"},{"claim_cluster_id":"f8052bb9-bad3-47eb-9141-dec76f63f661","event_cluster_id":"d8aa6d60-fbe4-466b-a7f6-c42801792185"},{"claim_cluster_id":"23bbf046-846b-4885-b881-e84d2ca9060e","event_cluster_id":"719a33e0-04c5-4203-a193-c262a589d49d"},{"claim_cluster_id":"e42f3c12-f894-47fd-b892-02c051609420","event_cluster_id":"abbfb703-6da3-4a58-9c1e-a58cf34e5030"},{"claim_cluster_id":"0dc504d4-9f05-4936-a43a-c912683c5ac2","event_cluster_id":"f1cd2dd5-074a-4fc6-a7c3-71a678833a3f"},{"claim_cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","event_cluster_id":"12d89d03-baba-4a2e-8935-742fe6b4573c"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"24039860-6815-4ba8-9be1-247dda66cf25"},{"claim_cluster_id":"8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4","event_cluster_id":"10c35c93-3305-488a-b928-ca8b7cb9a3d2"},{"claim_cluster_id":"756853a7-6f00-41a1-87fe-40396a3fd247","event_cluster_id":"126f7904-d5da-4bb4-861e-215114767499"},{"claim_cluster_id":"990aca8f-a2db-4ebd-85da-744c488a8d2b","event_cluster_id":"8845b13a-d2ef-4802-8b18-edb4fbddb6a2"},{"claim_cluster_id":"bfa96159-d0c2-4735-8c1a-2d33b2346d24","event_cluster_id":"f5220f5b-8931-4ce9-bb6b-eefb8c206ace"},{"claim_cluster_id":"2b47973e-934f-45a0-98dd-aacefd7432f8","event_cluster_id":"8c4dfd91-f6ed-43c0-830e-f702329489e8"},{"claim_cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","event_cluster_id":"cb95b455-562f-46e4-96a7-2aa2409fed5d"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"7c268167-b621-480c-ba79-7005ed13e2de"},{"claim_cluster_id":"910b6c18-44e1-4b51-b616-1f6016486c69","event_cluster_id":"61d1a73d-bcca-4e5e-a4fb-5d21b8a13b97"},{"claim_cluster_id":"8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"d583e7b2-dc4a-4915-a3d9-e76bbe714788","event_cluster_id":"41dff0a8-a265-4edb-a001-023373b9ecf5"},{"claim_cluster_id":"1b178ff0-cd2a-415f-bd8a-4daf71e452c3","event_cluster_id":"1249af1e-88d3-4d61-950a-0799adc2edf0"},{"claim_cluster_id":"2c834413-ef2b-486b-81d5-2e0a687a8ca7","event_cluster_id":"08d9382c-bb74-4062-afa8-3c8c1526980f"},{"claim_cluster_id":"6b8a2895-80e5-4b3c-853c-39abf201a8b0","event_cluster_id":"abb66c4f-f4a0-43a2-8032-f5ceeec7f058"},{"claim_cluster_id":"a0fab421-41ab-435c-b6c1-ee353c134771","event_cluster_id":"13e00f68-1db0-4207-bb35-e56787801241"},{"claim_cluster_id":"7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0","event_cluster_id":"d7895c1b-fc75-4aef-87f4-799e18058cdf"},{"claim_cluster_id":"949ec20d-24b3-4de5-a36b-32e35cbe9392","event_cluster_id":"dd4b1ab9-a797-483e-b837-bc9140aab68d"},{"claim_cluster_id":"bfd0fa79-f057-4e1b-abfc-222496dbeabb","event_cluster_id":"ea84d1ec-6a21-4123-9c3e-41ce618815e9"},{"claim_cluster_id":"4e7d68ff-7bd2-4949-affb-c71a8a76240a","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"ba035925-8a5f-42d0-aec3-c91702a47b8d","event_cluster_id":"d9bde049-6b0f-4d26-ad61-29d5b4dc2bc8"},{"claim_cluster_id":"55f659a1-e5dc-41c5-8a43-9846f564af08","event_cluster_id":"e1c37a48-126a-4576-b497-f9db46d18555"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"1e8a7861-14e4-4a42-b74d-73c7bec3ba5f"},{"claim_cluster_id":"28feb358-2926-4cba-8425-f09fe5ebab7a","event_cluster_id":"94bb7f1c-2d8c-4580-8fb1-a174bd27e088"},{"claim_cluster_id":"108c6941-b645-4904-86a8-cfa0fa34274e","event_cluster_id":"8f3f9d3c-bc51-4937-8cc3-be36bcc68b12"},{"claim_cluster_id":"626c75be-9b85-4ac5-97e0-e03b79d0191e","event_cluster_id":"f287b9aa-9568-4d24-870b-96f86f040792"},{"claim_cluster_id":"98177424-a992-4818-bd6e-9e0e3d0899af","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"463ff506-01da-43ee-96ab-3704e89855e2","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"6635c105-dcdb-4bd7-9a1d-4db57f43d53b","event_cluster_id":"810e8947-ee09-42d3-8a66-c23cbae93d9c"},{"claim_cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","event_cluster_id":"0103bebb-a8e1-4ccf-b716-fa6fd4687ac3"},{"claim_cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","event_cluster_id":"e8b94f0c-0366-40d5-b082-fa52ed608677"},{"claim_cluster_id":"d59582f7-7e86-41f9-a084-db1da2a740db","event_cluster_id":"9a5830fb-a855-4c85-8daf-ed1be558a290"},{"claim_cluster_id":"4ef708bd-198e-4a9e-9652-a1b08bc50fd9","event_cluster_id":"b79a6948-c2a3-43ae-83f7-90168d6803ac"},{"claim_cluster_id":"efb75ced-ba33-4f51-8892-e54a26a45d00","event_cluster_id":"3f7ede9c-8bb9-4467-8e40-0d78aa0f2a1a"},{"claim_cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","event_cluster_id":"5437d23d-a8b8-4a7b-b296-c42b5945a223"},{"claim_cluster_id":"62be0386-404f-434a-884b-4dc379430917","event_cluster_id":"33b55b1e-2a6f-4f56-affb-50cf2ec05471"},{"claim_cluster_id":"536df2e4-b955-48b2-8a3c-5b06a58c9d87","event_cluster_id":"05daa73c-fc4c-4000-9d0c-990f237b7870"},{"claim_cluster_id":"a5744137-28c3-42a2-94a7-6f90f74e8a86","event_cluster_id":"2b9f39b1-41ca-4c32-b583-29e0cbea9865"},{"claim_cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","event_cluster_id":"03b556ab-fe42-4f7d-954a-c2484c0fac43"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163"},{"claim_cluster_id":"75739be5-4b25-48e8-8d9d-d6319de6bd95","event_cluster_id":"d79d62e1-d874-49ae-865e-dccd822f8d8e"},{"claim_cluster_id":"0f047203-3949-4e82-86d9-77d6fe7af9c8","event_cluster_id":"0be74e36-e76b-4fc7-9f69-d42f28778f07"},{"claim_cluster_id":"d67b58dd-cbc9-4a99-aab7-b31e7a922343","event_cluster_id":"d349da51-4e48-4c7b-8b12-6a3dc4608c75"},{"claim_cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","event_cluster_id":"8c96de89-87b9-4c63-a1e4-fab8f67f7294"},{"claim_cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","event_cluster_id":"ed113c66-0348-4af6-b4bc-60c420311e2a"},{"claim_cluster_id":"db897944-fc77-42b4-ab1a-b566912e00b0","event_cluster_id":"4d738b05-171a-40b9-a505-e237572de24e"},{"claim_cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","event_cluster_id":"ff2f8c85-c8d6-49c6-8138-1b205db9afe6"},{"claim_cluster_id":"fc1c32c1-8212-46dc-b3e4-29a2254a34ba","event_cluster_id":"bc76f539-3671-4e32-b4e8-b1326e7f32a8"},{"claim_cluster_id":"e52244b2-1143-48cf-9735-ce26094681d1","event_cluster_id":"817f89c1-1d6c-4c1f-968d-c42db0a618b8"},{"claim_cluster_id":"6fa599b7-9959-44ea-a8f2-40b7f43bb558","event_cluster_id":"a42bed59-a9d3-4a76-b9d2-41f637803b1b"},{"claim_cluster_id":"8a60fc08-ff21-49d9-8858-dcff37e21d18","event_cluster_id":"2e1f7f19-b115-4df8-ab1f-76f94814091c"},{"claim_cluster_id":"4cf8f034-c2c7-4891-81cd-bb23d16f75ec","event_cluster_id":"8b09afca-ca08-48bc-a085-c49c60e79592"},{"claim_cluster_id":"3200fc3a-bd08-4faf-ac3c-69eb812ef575","event_cluster_id":"bddeb0a4-a8d3-413c-8b74-f7a5d1e4bffa"},{"claim_cluster_id":"36ed05e4-cb6f-4b4e-a07c-39d608cb863f","event_cluster_id":"d4181e9f-8d0f-420c-9032-de5764ee8344"},{"claim_cluster_id":"c3c67b90-f64b-4b19-8a14-0325205ef32e","event_cluster_id":"1b5a113e-43ba-4a33-a76b-09db6a2b33ef"},{"claim_cluster_id":"51f9e6ae-7c8a-46e3-8fa3-070377ae9030","event_cluster_id":"7aab4a1b-073d-4317-accd-dca275b73d33"},{"claim_cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","event_cluster_id":"e7c86122-ad9f-42c0-8185-4eb16e495061"},{"claim_cluster_id":"253e1524-e402-4a4d-b7db-f94b8f989d9c","event_cluster_id":"d8065be4-6b3d-42e3-9693-9cfaa110346b"},{"claim_cluster_id":"db13aa73-f539-42d8-89d9-1af57cfff5a3","event_cluster_id":"7f537263-14e5-41a9-8479-1de5e6a80076"},{"claim_cluster_id":"bfd0fa79-f057-4e1b-abfc-222496dbeabb","event_cluster_id":"4815ee62-ac65-4840-9797-7e3f61c900fd"},{"claim_cluster_id":"77de864b-c2fe-4a23-a506-d0665b0f08bf","event_cluster_id":"fa366373-444d-4a8e-8a61-fb8973c8426c"},{"claim_cluster_id":"bbc8c147-b447-4af6-82fb-e416f6108e70","event_cluster_id":"f5124798-4595-40cb-94e4-b0f1143b648a"},{"claim_cluster_id":"d089a914-1c7d-48b8-9c48-7a1b65f152b1","event_cluster_id":"c56ca589-59b3-4908-bbf1-fd162bba08a0"},{"claim_cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","event_cluster_id":"aa7dc853-a837-4fc7-af4d-cebbf4726b31"},{"claim_cluster_id":"4575f267-4553-4c7c-916e-359800e4fb24","event_cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638"},{"claim_cluster_id":"bbf2648f-d211-49b0-bf5c-a562e43902c5","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"9971c68f-8d21-4436-a5d3-4897996181e7","event_cluster_id":"1396142d-5fd2-4c3f-8a9f-e0d1627fb926"},{"claim_cluster_id":"b5aab15d-0623-4834-b9a0-c066e3616369","event_cluster_id":"ed35cf79-8410-4493-b5e5-ebfe6d51aab0"},{"claim_cluster_id":"7cacaa03-4763-4931-91bd-306a3231361c","event_cluster_id":"0c342dd1-f7b7-40e1-b189-103549ddece7"},{"claim_cluster_id":"b5b35a39-f79a-45e8-82ea-b87d21bbba55","event_cluster_id":"2e14d9d5-92bd-4d6d-84c3-0127651e89de"},{"claim_cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","event_cluster_id":"2648c3b9-64e2-4596-9353-c37ae996dcce"},{"claim_cluster_id":"551e444f-6554-45dd-baba-6798fd43af6b","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"de1f8a69-eaff-4387-87ee-35fc20ea4a2f","event_cluster_id":"4adc477b-ccba-4820-b5c6-6a663398b338"},{"claim_cluster_id":"5389eae7-83b1-4726-86c2-9a8dff51be59","event_cluster_id":"e8fdd463-9207-4e60-a84f-71fa88bf5a1b"},{"claim_cluster_id":"8e873c15-6407-475e-841a-2dcbbce28e18","event_cluster_id":"13e45fa8-d3c0-4dcf-9891-87d1abf0b71a"},{"claim_cluster_id":"ba2401d3-a8f2-4ce4-bda0-30f38f532e31","event_cluster_id":"212923c3-f34e-4b5a-bb85-95bfbbff9db0"},{"claim_cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","event_cluster_id":"1a52a7c3-2c3f-447c-9a23-15f3ea781daf"},{"claim_cluster_id":"84874fe9-a25d-4d9f-9765-de9280d477c0","event_cluster_id":"58acdbed-8f15-402c-b1b3-c0a3be3ee80e"},{"claim_cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"b26a4469-2931-4dab-aa78-be1b6fba8a36","event_cluster_id":"43787e95-8e23-4c32-ad24-6b1efd3b0be2"},{"claim_cluster_id":"4692c588-5e24-491c-9044-3d7dd7c0a2d7","event_cluster_id":"2b4b4bf2-1300-4817-8f72-f629847abed8"},{"claim_cluster_id":"81fccffb-0c5b-4efd-826c-64c3efbb0393","event_cluster_id":"314440c8-19da-496d-8536-f62999889410"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"a4f84d58-e9f3-4a41-a8f9-b81736f1cea9"},{"claim_cluster_id":"327ec0a5-4419-4d23-90f1-e220df70fed7","event_cluster_id":"3a423758-4300-46f1-8112-c2195cd0ee0a"},{"claim_cluster_id":"b39ca7cb-8663-4bff-829b-b432d59670f9","event_cluster_id":"67498cc0-4b03-4712-95a1-69a6b340282a"},{"claim_cluster_id":"4a4d472c-cd13-4ccf-9f30-e866d14bdbf8","event_cluster_id":"591739f1-b375-4e55-9c3b-ffe5cb8186ce"},{"claim_cluster_id":"9f14caef-27ce-4bca-afff-6e691839a8df","event_cluster_id":"f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d"},{"claim_cluster_id":"fdc7a586-a2b7-43cb-897c-5aacc04ceaff","event_cluster_id":"33b55b1e-2a6f-4f56-affb-50cf2ec05471"},{"claim_cluster_id":"aa440a76-9b1c-4801-9031-cdac4add116a","event_cluster_id":"feaafeab-4622-43a8-9ce7-52d22835a7d7"},{"claim_cluster_id":"0727da75-801a-4ea8-bc54-bca9f4c0cbfc","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"63e3781f-5042-452b-a77e-11f62bb59587"},{"claim_cluster_id":"807e0902-55ee-4c2b-a271-40fd2fb58b9a","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7","event_cluster_id":"34a8290a-940e-4582-8dbf-cb195db85e28"},{"claim_cluster_id":"bbf2648f-d211-49b0-bf5c-a562e43902c5","event_cluster_id":"a3452ca9-6c41-42fe-8fb7-9b272b7a106d"},{"claim_cluster_id":"291e098d-0f3d-4fff-9906-3b21ed1a33a1","event_cluster_id":"9a04913f-01c4-45fe-aacb-81aaa1af85ae"},{"claim_cluster_id":"01c08614-0081-4fbf-86e8-a41b845bc4f5","event_cluster_id":"9914f862-3a85-4664-87c6-f266c89775cc"},{"claim_cluster_id":"a4d61819-30e3-46aa-ab08-cf879db00de1","event_cluster_id":"b959db9a-a488-4838-97f9-4b51827755fb"},{"claim_cluster_id":"9f936fe4-6962-4447-9269-bd4c45c0f95e","event_cluster_id":"0d47b48b-a9c1-49b3-8e15-26d394b843ea"},{"claim_cluster_id":"6bdcff96-571d-4879-91a7-d6084340625f","event_cluster_id":"7e615b29-206f-45ec-8b7c-74785c5252c8"},{"claim_cluster_id":"7eb7c781-85c0-4773-8374-eeb7374b471d","event_cluster_id":"5db2dd2a-560f-4f51-8086-9e7ff5236782"},{"claim_cluster_id":"41369b57-1c08-440a-90c0-cacb7036a45e","event_cluster_id":"abe67163-2626-42e7-98cb-6e8083622029"},{"claim_cluster_id":"47085082-7091-436e-a3ee-ecf14c90e1a5","event_cluster_id":"d74efe6e-e929-4c10-ba6b-80c58b26fa38"},{"claim_cluster_id":"62083248-470f-4a86-883c-26267fb22566","event_cluster_id":"40850d8d-b18a-4d10-bfba-dd521fe3cd4d"},{"claim_cluster_id":"5c1d5636-b62a-4962-911d-1136d9629b6a","event_cluster_id":"1ff86b5f-b9df-4809-8840-440abb97575d"},{"claim_cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","event_cluster_id":"1e6f5910-b91c-46ca-bb2a-bace35349e8b"},{"claim_cluster_id":"69483fde-1234-4c7a-8580-5490aec071f7","event_cluster_id":"b46bab47-6915-405b-a8fa-be8c999e4b4c"},{"claim_cluster_id":"4f63d722-2816-4701-89a0-6f6efadc8656","event_cluster_id":"ff9ad8d9-d483-4daa-86f0-12ffd12f76b0"},{"claim_cluster_id":"758ea826-ee1f-4a18-bdaa-e713f20f5573","event_cluster_id":"fa3326c6-c29d-4ee9-93ae-25dfe12b02b0"},{"claim_cluster_id":"e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37","event_cluster_id":"64571139-4782-47d8-abc3-d973ded5245b"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"3e3518da-eab0-4220-8961-2d5489b4e97a"},{"claim_cluster_id":"ae201524-ae4c-4b92-afa7-2801ac429060","event_cluster_id":"e72ec6a2-4890-4444-8e7d-1a5032e251dc"},{"claim_cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","event_cluster_id":"f16aab95-d35f-4386-9ea4-6a5f797bcf7f"},{"claim_cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","event_cluster_id":"c85617d1-a799-4927-848f-0f8d387e35f0"},{"claim_cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","event_cluster_id":"32cbf301-8c69-47b6-aa84-5617ee08686a"},{"claim_cluster_id":"0727da75-801a-4ea8-bc54-bca9f4c0cbfc","event_cluster_id":"c320799e-ed57-4715-bbb9-1237e2fe3842"},{"claim_cluster_id":"ff7a6df5-d64b-4e14-803a-5339b1cffda2","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"06a88819-5b14-47a3-9604-8a61db70f52b","event_cluster_id":"87cb3f5b-d497-49ea-a871-f34d7080b10b"},{"claim_cluster_id":"732c6dc2-1231-46ca-b1c1-173c0f488176","event_cluster_id":"13dc8122-3135-4fd1-a900-1e2308b14e34"},{"claim_cluster_id":"f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f","event_cluster_id":"c6f49d61-1bb8-4b16-b016-0bde6b721c6d"},{"claim_cluster_id":"4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1","event_cluster_id":"ff62f156-1b54-448d-8c41-0514a58493a5"},{"claim_cluster_id":"6d2a1320-d829-403b-913c-d7cdbf1cbf14","event_cluster_id":"8ee4279e-4251-4f38-b5e1-7ebd99d489b8"},{"claim_cluster_id":"3ea1c92f-805f-4ecb-b23d-a77a7a362e5b","event_cluster_id":"d22d7383-71e2-4520-a5b2-8ae266a5a780"},{"claim_cluster_id":"0c50e809-0f1b-4656-a0dd-110732b6e47b","event_cluster_id":"eab0b5ad-eda0-47fc-89d0-b12331740c85"},{"claim_cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","event_cluster_id":"78ea610b-38fc-4528-87fe-af950e4ad514"},{"claim_cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","event_cluster_id":"4991bbaa-4137-4e4c-b3d4-b54d2fc23ddc"},{"claim_cluster_id":"d41663c0-a43a-40f6-ae8e-9e6eeb720de9","event_cluster_id":"0e23ab63-e410-4477-a70e-2df0f99242c1"},{"claim_cluster_id":"970a5cc7-9a05-4850-b0f1-f59128c441c8","event_cluster_id":"4074f92b-f1cb-43a1-a970-018d582db2d6"},{"claim_cluster_id":"64f152e4-be60-464e-a365-613ea259a5ff","event_cluster_id":"bb7d1261-e586-4986-8419-b3678b999f37"},{"claim_cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","event_cluster_id":"4c667681-74f7-4591-9add-d06796315d33"},{"claim_cluster_id":"d6c74194-ae1f-4099-a13b-0f247e76b288","event_cluster_id":"42f681bf-3cec-44f4-9b59-d7168d922923"},{"claim_cluster_id":"6d0fc82b-e82f-4ea0-897a-429340b5d2e7","event_cluster_id":"bfbf1707-08cb-4022-8bc5-78477fc5de4e"},{"claim_cluster_id":"170448e1-fefc-424b-b5a4-23941f88389e","event_cluster_id":"7c038a6d-dd5c-4d1e-a387-d5620daf9907"},{"claim_cluster_id":"6717f23b-7a46-4774-9d7d-76c5eb0bdde2","event_cluster_id":"a3899865-60a9-4162-9d1f-4bd867347d37"},{"claim_cluster_id":"6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4","event_cluster_id":"474921fd-8a8d-4c36-8ea4-d0c78016b2c8"},{"claim_cluster_id":"9d4328c2-e9a9-4e75-b63e-6e88d7b536f1","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"729ff499-2dcf-4524-91fd-7e53fd6e6ad7","event_cluster_id":"29fc6217-0253-4ea5-924b-34a8cdd037cd"},{"claim_cluster_id":"1d2ba60d-53c7-4e8c-91e5-1d0e114d5708","event_cluster_id":"34b25787-92a3-4162-bcdc-435c1ba9cd55"},{"claim_cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","event_cluster_id":"e5fa93bf-fdd9-4c91-8fb4-7d6499900667"},{"claim_cluster_id":"b5b35a39-f79a-45e8-82ea-b87d21bbba55","event_cluster_id":"b4a8f883-fff2-467a-ae3a-3ea74c8cac30"},{"claim_cluster_id":"0ee142b2-6805-43f4-b8d5-34f76c2c799e","event_cluster_id":"aaac8e79-68d5-45a4-b3d7-7bcd6881a93c"},{"claim_cluster_id":"9398c496-5e62-4d1b-94c1-e1eeaf48778c","event_cluster_id":"c219e535-0099-4f3c-9221-b32e8ae0d9a9"},{"claim_cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","event_cluster_id":"efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc"},{"claim_cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","event_cluster_id":"060c1552-a1b7-4db4-9a85-766d6baf3560"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"63e3781f-5042-452b-a77e-11f62bb59587"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"6ad057c3-3463-4e5c-9a22-5186dd44f814"},{"claim_cluster_id":"9960f165-6141-4ca0-8dc4-0a136bfde83d","event_cluster_id":"d2d04da3-8b22-4ac9-819e-ca8c7ec67255"},{"claim_cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","event_cluster_id":"a868051f-7c6b-4631-b5c0-5298f1a4a3bc"},{"claim_cluster_id":"f7c875b0-a0b4-45f6-b382-0915f179b2e6","event_cluster_id":"065d4388-2dbc-4873-991f-3569f0444b8e"},{"claim_cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","event_cluster_id":"c236b253-d4f6-4796-aa07-7b8f0eb372e6"},{"claim_cluster_id":"11aef681-a744-409f-8cc3-69822e3a86b2","event_cluster_id":"eaaf5d8a-fedf-4978-9ba0-14aae1ce95e7"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"cd2c9191-f97a-49fd-9d7d-f0744cdaaf72","event_cluster_id":"faa4667e-011a-4693-8171-40e817256b60"},{"claim_cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","event_cluster_id":"8feebef1-9f0d-4302-8835-37de98ad3cf7"},{"claim_cluster_id":"554575d4-0201-41f5-aa4b-d48a76e37311","event_cluster_id":"22a9a9e1-a369-4cff-a2ae-69fa0403d590"},{"claim_cluster_id":"0726cfa9-d89b-45b4-922f-553fde14346a","event_cluster_id":"97a2e6d5-9f35-4464-ad73-ec9b3ab0029e"},{"claim_cluster_id":"83150260-cbcb-429e-8e22-0e5b897618ff","event_cluster_id":"ca6289c9-7aca-44b6-8a18-1a2d2282cd8d"},{"claim_cluster_id":"b4a81fcd-1fa0-4fbe-88f0-692419c6082a","event_cluster_id":"4833448d-d892-46bf-bb0b-2903956326da"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"9a5d054e-318a-4826-9d5f-20df372185b2"},{"claim_cluster_id":"b4ee4418-ee26-4134-986b-8e220ef5da22","event_cluster_id":"c5882250-4bcf-4c65-93ec-7937e1c0803f"},{"claim_cluster_id":"dcc1a857-7e25-4b1e-bb30-c67434a5f183","event_cluster_id":"823bf086-9c7b-424a-8c1e-a0823a4017d5"},{"claim_cluster_id":"4cf8f034-c2c7-4891-81cd-bb23d16f75ec","event_cluster_id":"65f08a18-b069-4ad1-8cde-ea7ebd30b6db"},{"claim_cluster_id":"1f8ca860-66b4-4b57-a63c-e13332662c2e","event_cluster_id":"81106289-cb37-45f4-a937-0b81bb6b136a"},{"claim_cluster_id":"327ec0a5-4419-4d23-90f1-e220df70fed7","event_cluster_id":"58af047e-cbeb-4069-98f9-896633d3674d"},{"claim_cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","event_cluster_id":"6d9e58c9-dbd4-4963-8fe7-594077a6324e"},{"claim_cluster_id":"2ac87cef-db31-40dd-8c5e-d88d478fd344","event_cluster_id":"1484b9dc-5ed0-4d22-945e-34e17801439c"},{"claim_cluster_id":"5a6d9d35-00b4-429a-8850-2262dfa520df","event_cluster_id":"f1494984-39fb-445c-9005-4614903b112c"},{"claim_cluster_id":"4259fe50-2c67-4157-ba4a-43d33835df49","event_cluster_id":"68efa2f8-df62-4c55-a56e-6a0d6368d6f1"},{"claim_cluster_id":"770cc261-67a7-4ed4-85d2-93916689a978","event_cluster_id":"7b8722b8-a7de-40ea-80c1-4cf1e7b13571"},{"claim_cluster_id":"30765e40-3943-483b-8e1e-27d3053ae2bd","event_cluster_id":"0ebb4caf-dfd8-4139-8988-6c07a96c4bd2"},{"claim_cluster_id":"21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb","event_cluster_id":"9ff8b495-2fb3-4416-a1b0-68b8560f98e4"},{"claim_cluster_id":"5389eae7-83b1-4726-86c2-9a8dff51be59","event_cluster_id":"d5f940cc-5da4-46b9-a86f-4006d64c39d0"},{"claim_cluster_id":"416e4c1e-869b-468f-91eb-bba4fac5108a","event_cluster_id":"52f4f571-7b22-4977-98bd-7282b2a6c5c5"},{"claim_cluster_id":"0c0329e4-9982-4d5f-9450-241c86955685","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"7cacaa03-4763-4931-91bd-306a3231361c","event_cluster_id":"6904ee21-68e2-4e99-baa3-968e34cb10b1"},{"claim_cluster_id":"25c37968-26df-4a13-8b6c-ef9270b22369","event_cluster_id":"b64296b1-758d-4594-84fb-3ffa5aaa094b"},{"claim_cluster_id":"4d2dc30e-97f5-49d3-80df-c343048e6856","event_cluster_id":"62c268b5-d8e3-4743-b673-44ec104402b5"},{"claim_cluster_id":"821946a1-401a-4657-be17-b3ed51371c13","event_cluster_id":"ec791f7a-6542-44c8-9d59-4679b8301276"},{"claim_cluster_id":"fa484c7a-b508-4b38-90f3-04e6ca143d03","event_cluster_id":"f2b5a4d3-d094-4fa0-812e-4687bf81efb7"},{"claim_cluster_id":"c604d802-912a-4abb-ba43-e290946de463","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"298b76c6-3ed3-4a84-8894-fa50a9f4234f","event_cluster_id":"7d97e055-f53d-4979-b83c-8c058b074265"},{"claim_cluster_id":"4eb1a4b5-b71a-4034-93b6-28860ce56821","event_cluster_id":"7897b080-7853-4261-9ab5-31b7495a5563"},{"claim_cluster_id":"33a57504-12fb-4d65-b0de-90b983174e92","event_cluster_id":"8e7309fe-7380-453b-8dec-aa0848276b7f"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"0c9ec8a0-bb91-48f5-bf6f-13507a3c2374"},{"claim_cluster_id":"5b5bad5e-15a1-4d61-9521-27fe4f90522e","event_cluster_id":"2972bcbb-a2e7-4468-bfb2-f2945b01a243"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"eff3ff70-7d42-45d0-a372-4aa15bf9f280"},{"claim_cluster_id":"9d85f9b8-6204-4844-9707-8c2e9351d730","event_cluster_id":"58ab14ae-8edd-49c2-93f1-5410b8248aac"},{"claim_cluster_id":"2b4fc83f-18c3-4ff7-b918-64e0981dd3b2","event_cluster_id":"65583e7e-9600-4791-b957-579c81276f1b"},{"claim_cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"2e620f14-db3f-4f94-9e90-7ae11cf68067","event_cluster_id":"bac9b430-6b59-4b93-ba97-75f0f7b39814"},{"claim_cluster_id":"2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6","event_cluster_id":"009689fa-763a-4351-a069-4f29c46a8fcf"},{"claim_cluster_id":"f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f","event_cluster_id":"6fca3548-19e0-4797-8ca7-1e10435f142d"},{"claim_cluster_id":"d78f22d5-c64c-4786-833e-21ebb584c006","event_cluster_id":"de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d"},{"claim_cluster_id":"e44edb14-2754-4e0a-969f-2ab83f6f614c","event_cluster_id":"1a503dc4-9b3c-4c99-a076-3e0baaa545f3"},{"claim_cluster_id":"3d9f2bb4-f1d6-41ac-be1a-ac1194130144","event_cluster_id":"249e8c50-f68d-47af-99c9-2bc6ddfd52ad"},{"claim_cluster_id":"469e17e6-447a-4bc6-9bab-f2cb595f07e0","event_cluster_id":"887d717e-5da6-4cf6-995c-bcee081cd128"},{"claim_cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","event_cluster_id":"b3909552-dab5-4658-b73f-34338b406557"},{"claim_cluster_id":"71211c39-a653-4c7c-bf55-0339568d069a","event_cluster_id":"fb28be3e-346f-4ae2-b2c5-0971d759b337"},{"claim_cluster_id":"729d6508-b5df-44ab-8ffd-349b7a126b16","event_cluster_id":"52587d0c-b6c9-4b93-964d-b5598a3e9ddb"},{"claim_cluster_id":"b1da6225-3a48-4f38-b0fb-dac29be99682","event_cluster_id":"3ab13bcd-fc14-4404-8b26-7f8a67a82860"},{"claim_cluster_id":"b331f46e-c31d-4c56-81c9-c40834960e1f","event_cluster_id":"ad92d574-8bb8-4072-be84-8313fb209fd6"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"0dc0d897-2bc8-412a-af86-95eb382d392e"},{"claim_cluster_id":"42302660-b692-4e66-870b-37970eee6c13","event_cluster_id":"a83610f0-30d5-4dda-896a-6faaf1c01536"},{"claim_cluster_id":"9594285e-8196-4153-9b31-89250a7200d5","event_cluster_id":"f96ee044-12e8-41d9-ad21-d1cd5c1012f8"},{"claim_cluster_id":"216f7d8c-4948-4e84-9b61-7c4fc880e123","event_cluster_id":"d335936b-95df-4111-8cb1-decd8664543a"},{"claim_cluster_id":"c63decfc-559c-461a-ad2c-a9922b7e06df","event_cluster_id":"3b30bb51-81c4-40b5-ba0f-a5b24a020dc5"},{"claim_cluster_id":"f502dcb8-0d11-41eb-afba-f50e74157a5b","event_cluster_id":"99814cad-01e4-492e-93e2-a867761329f7"},{"claim_cluster_id":"0e6f398e-1206-46db-a98b-ff1425e1c634","event_cluster_id":"59e292c0-ebb5-4e44-9c6c-162e21e21b97"},{"claim_cluster_id":"23106ade-18c8-44c0-8d3a-ef2f743468af","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"e250b185-4f74-4634-99e7-3af880f034a6"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"66d5fd65-8e6b-405c-9801-c7ba78bd49a4"},{"claim_cluster_id":"5cd897af-cb8c-4335-a548-c9963c43f060","event_cluster_id":"e59d2cce-34c4-49db-b0fc-9ab7a956e929"},{"claim_cluster_id":"516d27f7-0cda-468f-b3b6-27af200d408b","event_cluster_id":"e262a7ae-4e83-451f-b2c4-34917839f661"},{"claim_cluster_id":"4af97b54-9617-48e3-8125-aa1e8e1ee8a2","event_cluster_id":"3f0004b6-308c-4518-9fbc-e6c906329ba4"},{"claim_cluster_id":"9012b6f3-2c16-482a-b276-63925d342482","event_cluster_id":"18ad11bd-8c86-4313-a634-cae071e56b5c"},{"claim_cluster_id":"4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7","event_cluster_id":"07e2576d-9585-4de1-8fed-5653ce340f18"},{"claim_cluster_id":"166b6595-ba80-4fe0-a5a2-70307703e855","event_cluster_id":"54fd48d0-d138-4133-9478-030523c0c632"},{"claim_cluster_id":"e42f3c12-f894-47fd-b892-02c051609420","event_cluster_id":"2ffd0f52-9465-49d4-9f47-900078ad3209"},{"claim_cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","event_cluster_id":"2b11b446-8d3f-43d8-b5cf-fa4f7e28a0d7"},{"claim_cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","event_cluster_id":"f520db2e-ca68-4285-80b9-7e45d3506ad3"},{"claim_cluster_id":"3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9","event_cluster_id":"e42d141d-80cc-4e68-848e-2d85ecf6a58c"},{"claim_cluster_id":"ebad899d-9cc8-49e0-a908-87f53dd79063","event_cluster_id":"af8cdf46-4050-4634-a0b0-6bc6cfa78956"},{"claim_cluster_id":"226ceb68-980d-4b72-b053-36c7b5c7f61b","event_cluster_id":"dc60fa2d-dae3-4ea2-a4d5-1da4424a6919"},{"claim_cluster_id":"970a5cc7-9a05-4850-b0f1-f59128c441c8","event_cluster_id":"70aec147-e46f-48a9-b67c-9dbf6b174338"},{"claim_cluster_id":"3200fc3a-bd08-4faf-ac3c-69eb812ef575","event_cluster_id":"471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec"},{"claim_cluster_id":"cb7188de-21fe-4631-9d3e-697f1fa246b9","event_cluster_id":"53924b3c-7098-4daf-8924-cb5ffede2096"},{"claim_cluster_id":"fc40e900-5f3a-4200-9723-06366e139ab4","event_cluster_id":"d6e81e61-bb7e-4b41-8a70-469e0ff32a7a"},{"claim_cluster_id":"6eb878e4-969f-49ca-8ac8-5c68ead2c13e","event_cluster_id":"dcbc849b-d40e-49ed-84ab-ec7cdf4bb695"},{"claim_cluster_id":"6cfce6ce-fb64-4bfa-a23f-01cbee46c275","event_cluster_id":"c7824331-8340-4b01-8402-1e8e570e3b30"},{"claim_cluster_id":"fa361819-d60d-4532-8084-9c75390ba17c","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"f55d5834-9821-4e96-8403-e81fdf294300"},{"claim_cluster_id":"0de86638-0241-412b-ab2a-b233d85153a4","event_cluster_id":"f069a0c9-4a52-495b-8bf9-3f4d61e51c06"},{"claim_cluster_id":"eb68c709-6220-48fe-b376-95a4f6f10b6d","event_cluster_id":"f4d98260-09b2-436e-8c76-b8fdadb8663b"},{"claim_cluster_id":"70a36c06-fbb9-4f71-bf77-74f433672b24","event_cluster_id":"f5cfebe0-089d-4908-8224-abe95a565459"},{"claim_cluster_id":"fdbce6fb-9c6c-48ff-a187-88c668f79277","event_cluster_id":"cb44bed2-b70b-436a-82dd-d405face631c"},{"claim_cluster_id":"840ac263-91de-449d-b701-c05a4522f3b3","event_cluster_id":"32aeada3-2c0a-4dd6-b828-1733cea88e6b"},{"claim_cluster_id":"e4e03461-6763-4291-b9e4-bd4feccb46e2","event_cluster_id":"24751f3d-988c-4f3f-9df5-95b8bdfa7bfb"},{"claim_cluster_id":"d9f9cf14-d4ad-4c0a-9482-99b75f7c247f","event_cluster_id":"dd156ade-c3be-4db6-9779-46772fbd155f"},{"claim_cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","event_cluster_id":"f7ca28bb-5007-4654-b846-b6e439b09815"},{"claim_cluster_id":"0261ee84-1c1e-4042-9226-f1085216eef2","event_cluster_id":"aecd93e3-f175-4964-b3d0-1a8c1e2832bd"},{"claim_cluster_id":"2d7a7088-3ced-40a0-9677-1d14e1c26d8f","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","event_cluster_id":"6f88a50d-7c8b-451d-b706-e766cfe9a47a"},{"claim_cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","event_cluster_id":"e886744b-894f-4cf5-9248-234d88f9a4f4"},{"claim_cluster_id":"b198bd93-5f96-4992-9aa2-29e396814e39","event_cluster_id":"f4e22611-4a8c-420d-98fb-79e2c70d616c"},{"claim_cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","event_cluster_id":"c2a59237-65bd-47ee-930d-7682f70bbe46"},{"claim_cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","event_cluster_id":"80a104b6-58c7-416b-ac35-97712361953c"},{"claim_cluster_id":"2d5d8472-462a-48f6-89fe-e8182a74e9c6","event_cluster_id":"91c23991-d38e-40c8-af05-0cbccbeaf641"},{"claim_cluster_id":"166b6595-ba80-4fe0-a5a2-70307703e855","event_cluster_id":"089a2747-9d4d-40cb-b33d-a36918c7e7a4"},{"claim_cluster_id":"8992a182-5ede-4dbb-9979-4dcf0e10c546","event_cluster_id":"729b06af-76d6-45d8-b842-1a087ece3b39"},{"claim_cluster_id":"516e99dd-d52c-4f12-8e2e-b0ba0e0b515d","event_cluster_id":"a19f2358-dc1d-4de3-8588-b9d055ccede4"},{"claim_cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","event_cluster_id":"7b391ffb-dc10-4ded-babc-680617024509"},{"claim_cluster_id":"b1da6225-3a48-4f38-b0fb-dac29be99682","event_cluster_id":"395a3f4e-39fe-411b-af09-832b0bf2ab53"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"77e5cfa7-27f5-40a9-879d-0ba7cd2177f2"},{"claim_cluster_id":"516e99dd-d52c-4f12-8e2e-b0ba0e0b515d","event_cluster_id":"c8feb5d9-ef93-4465-bcb1-5c7e4847fb27"},{"claim_cluster_id":"281fca06-ede2-40bc-9960-0788b1d20c23","event_cluster_id":"984fa7e0-f763-4f19-b49c-d87ea5159954"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"7a33ed40-551f-4f38-8b8c-22ab137818a4"},{"claim_cluster_id":"eb68c709-6220-48fe-b376-95a4f6f10b6d","event_cluster_id":"7a1d05c9-2872-4724-bfbb-1dbc30578c14"},{"claim_cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","event_cluster_id":"4c4cd4c7-1e1a-4df7-8ab4-db0129f7114b"},{"claim_cluster_id":"73dcede2-49d2-4bc1-a599-b15a7d0094cf","event_cluster_id":"0c6eb85b-0ae0-403f-b2fd-990121d9ade3"},{"claim_cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","event_cluster_id":"b0630042-6031-4b80-9db0-071e1119e981"},{"claim_cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","event_cluster_id":"9e4b0a95-0efa-4ff0-926d-70d1dc9caff3"},{"claim_cluster_id":"9398c496-5e62-4d1b-94c1-e1eeaf48778c","event_cluster_id":"9becb58f-9c06-4adb-8557-0a75a0444f56"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"ec3d0509-3f1c-4d1f-868c-ba7c16468992"},{"claim_cluster_id":"7885c5ae-734b-4d64-8d84-fc50b9a87ad7","event_cluster_id":"1789e573-0855-4766-ab56-773e8cdbeef5"},{"claim_cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","event_cluster_id":"ec98b249-f085-460b-ae00-454dc52d3f17"},{"claim_cluster_id":"ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8","event_cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9"},{"claim_cluster_id":"55a85a41-dc09-4546-82c9-33ba7368eb9a","event_cluster_id":"eba751d5-5124-4afa-a2aa-48fe3f60fcc8"},{"claim_cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","event_cluster_id":"35b591b0-9a65-46c0-95aa-caf3b8dedd33"},{"claim_cluster_id":"6778e0f8-10fc-4d30-8039-d81e67c9992c","event_cluster_id":"867f94d2-2825-471a-801a-edc5c961ad9f"},{"claim_cluster_id":"69483fde-1234-4c7a-8580-5490aec071f7","event_cluster_id":"2d1b7151-63a5-4414-9619-8c40fe20742a"},{"claim_cluster_id":"729d6508-b5df-44ab-8ffd-349b7a126b16","event_cluster_id":"c3765121-fe92-4ebe-aef3-b794fa8089f1"},{"claim_cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","event_cluster_id":"ac3739e2-de75-46fe-a991-203fbc3a72e0"},{"claim_cluster_id":"13ce1de8-c90f-43f4-ae08-251f1aed012e","event_cluster_id":"75a7abcd-ccae-4606-800a-89412da639cc"},{"claim_cluster_id":"327aebea-facc-4b65-a419-a9d461f7aa0f","event_cluster_id":"6b25848d-e565-4f9d-b442-93bdb20750d1"},{"claim_cluster_id":"ff763739-26e3-4daa-93bc-7ecf065c5275","event_cluster_id":"63e3781f-5042-452b-a77e-11f62bb59587"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"e80fcdb9-26cc-4925-8100-e10e8d09e8d6"},{"claim_cluster_id":"de30ed78-2cf8-480b-aacb-665d9572f1b4","event_cluster_id":"e3ef059e-984d-4158-bd79-7968854d515e"},{"claim_cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","event_cluster_id":"719904eb-28ef-4b29-997b-23331e60e444"},{"claim_cluster_id":"f3b06230-c202-438a-8858-b8c55fa68828","event_cluster_id":"c700d9cd-e09d-4ea7-a33c-b8925d591d85"},{"claim_cluster_id":"7e29e69f-6e9a-409e-8641-59692b521453","event_cluster_id":"a8627187-7d21-463e-a6ef-6ef26a6c6de9"},{"claim_cluster_id":"b12e5d28-73fe-498d-a612-a3df5aa876b3","event_cluster_id":"5ac468f5-649c-43da-ae88-dccb98a0bb4f"},{"claim_cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","event_cluster_id":"a96dc83a-238f-4ad4-81c6-dfc26af2869a"},{"claim_cluster_id":"404cf86d-d513-4c8d-adf3-7f2b9464b34e","event_cluster_id":"5e6716fc-cf64-480e-8688-e74f2a213fd8"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"2c8b719a-2363-4f9f-9be2-6d1801374195","event_cluster_id":"ffbf8347-0223-4c98-b559-e6237b6aac90"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"6c942642-582b-452c-868b-03a353a6eca9"},{"claim_cluster_id":"d602e1f1-5446-4c60-aadc-beabd56dedd8","event_cluster_id":"ea7149f6-4e64-4cea-8d02-bf248f686ab1"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"77119585-efc9-469f-8988-fdb1e15681f0","event_cluster_id":"153479d3-dde3-44aa-83a6-d7e772a10308"},{"claim_cluster_id":"404cf86d-d513-4c8d-adf3-7f2b9464b34e","event_cluster_id":"43d48fcc-7522-4b18-8344-e5b044e22838"},{"claim_cluster_id":"94c7e352-c14a-45a1-b0c5-cccdc2ef1122","event_cluster_id":"24866e6f-4fd0-49f1-b25e-9d7dc5227353"},{"claim_cluster_id":"755e1910-15d6-4530-b0f7-b73a35ac9c64","event_cluster_id":"5e5db8ed-e13c-449a-bc48-1985ab63a2df"},{"claim_cluster_id":"cf399998-137e-4270-8827-7c726197fb9d","event_cluster_id":"0903a221-6399-44af-9542-80d1c25bc816"},{"claim_cluster_id":"232994db-dcd7-4db4-9ea3-fad6185233a7","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"f4e47d52-0a9c-4a42-9a14-47aece599116","event_cluster_id":"26db1e00-6a4e-4036-b6ff-c1da87b844b6"},{"claim_cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","event_cluster_id":"71167ddf-4ec9-4903-a616-db6af6caed15"},{"claim_cluster_id":"1be65d4d-c915-41d3-9d1c-864035425656","event_cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c"},{"claim_cluster_id":"511c0db2-0769-45d5-a814-00f974a659aa","event_cluster_id":"83e82b7f-d20b-43e7-8e8a-1a33199d549e"},{"claim_cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","event_cluster_id":"bc618add-d50a-4d41-b375-e0f4e3b7232b"},{"claim_cluster_id":"d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9","event_cluster_id":"45a10488-1ec2-4731-8b23-f6d502ac13b4"},{"claim_cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","event_cluster_id":"d2c0f044-52b0-4afb-ad04-975898224fdd"},{"claim_cluster_id":"7eb7c781-85c0-4773-8374-eeb7374b471d","event_cluster_id":"e2a1f0e1-e053-4231-9242-7b160200d696"},{"claim_cluster_id":"19ddcd3b-18db-461a-b208-f198db3e1e07","event_cluster_id":"ce6ec6f1-89a5-418d-adc6-e21b2c309bd1"},{"claim_cluster_id":"745389b6-9b21-4dd2-89bd-e66fab0ff334","event_cluster_id":"56712450-0dee-4fc4-899b-8d6600a516cb"},{"claim_cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","event_cluster_id":"63fb948c-76fb-4787-aafa-ea3ce79ec01f"},{"claim_cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","event_cluster_id":"e512735b-aeb8-432c-9b72-89718eda18ba"},{"claim_cluster_id":"c63decfc-559c-461a-ad2c-a9922b7e06df","event_cluster_id":"3c52b26e-a9d9-4bd3-979f-3455beaaaaec"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"a37e6820-0d6d-49d8-8dfb-fc94f1f84e73"},{"claim_cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","event_cluster_id":"8b5f2de0-fd72-48f3-8849-4ef20748a393"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"7a111e6b-975b-4ed3-9b97-e727f9682f28"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"680ddc35-25cd-424c-8914-0f7a5b222416"},{"claim_cluster_id":"f854f83f-364d-470a-8cd8-f0bec2c15e68","event_cluster_id":"35ff40d7-dc34-499f-b4dd-e76f13e34e0c"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"5317331a-d0a9-4595-acad-210a92b278d8","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"e82ed51a-4d19-4b2d-96bc-cb54f9b70858","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","event_cluster_id":"b24ff026-a9a6-45e3-8927-422954af4cf6"},{"claim_cluster_id":"f80dd275-a1a9-4cb7-becc-0fe298aae99d","event_cluster_id":"285237c2-514b-4d74-ada7-2be4ad6a801e"},{"claim_cluster_id":"f3735996-484c-447a-8fe4-4cd5c645a0a9","event_cluster_id":"072ba410-0f15-42e7-9ef5-bee6285568c8"},{"claim_cluster_id":"dcc1a857-7e25-4b1e-bb30-c67434a5f183","event_cluster_id":"2c59d86f-8c32-43d1-acd4-a598aa7665ee"},{"claim_cluster_id":"914ca89d-e967-443c-9856-6a5b040a0496","event_cluster_id":"3b02e47c-e307-44b8-85bc-a7863107a268"},{"claim_cluster_id":"6f8b0a89-8965-4d5d-9b89-f48b23ed61a1","event_cluster_id":"5a080de2-e14b-428a-ad25-1b9fd1bb59d4"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"7b263d1a-e07c-48cc-bbc0-8a228f72f292"},{"claim_cluster_id":"6e5c19c1-853c-4797-84d8-7f68386994d3","event_cluster_id":"6030a19b-208f-4624-83fa-f8e8a264fea6"},{"claim_cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","event_cluster_id":"3a17531b-ae78-41a3-b63d-f61bcc85a26a"},{"claim_cluster_id":"b17129e4-a0b0-4a1d-a70c-02e08bb380d1","event_cluster_id":"7b4680b9-9676-4736-8ed2-d06a2da6ea63"},{"claim_cluster_id":"3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8","event_cluster_id":"371e032d-d57e-40c0-84fe-6f5fa1665409"},{"claim_cluster_id":"5b0ba6ac-d65c-49f0-9ed7-62610378c0e1","event_cluster_id":"9c8fceaa-2d0d-4f1b-a084-86587c4a2652"},{"claim_cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","event_cluster_id":"df241613-e669-4ee0-b143-f0b24cc846e8"},{"claim_cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","event_cluster_id":"86d55ce0-7b54-4708-b491-af72b9d9ff06"},{"claim_cluster_id":"463ff506-01da-43ee-96ab-3704e89855e2","event_cluster_id":"901320c7-5066-4de7-b012-7a995d178683"},{"claim_cluster_id":"c46be245-9f63-495f-be19-e522e39c13f9","event_cluster_id":"03a113b9-8fb7-4743-8425-b2ed80e37d97"},{"claim_cluster_id":"3dc0cbd1-b381-4df2-846d-e07147e83cbe","event_cluster_id":"6afac47e-4bb6-44d8-a1c9-b3063690939e"},{"claim_cluster_id":"03b37d7e-0ed4-4014-ac24-a898719a8f87","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","event_cluster_id":"558372cf-c982-49c8-8de6-cd0d8a987ae8"},{"claim_cluster_id":"08372c18-8eed-4c93-adee-9002e00e29bd","event_cluster_id":"ed59d768-edd7-48c0-ac20-df8f0d6dc5d8"},{"claim_cluster_id":"b196eb88-ee2e-4367-8e6b-08f9890e6fe0","event_cluster_id":"6c435a8a-93c9-4345-913c-85766d15d80c"},{"claim_cluster_id":"891e1da4-bfc6-4524-a5da-153bde60b165","event_cluster_id":"a7593170-7dd6-490c-af81-f78a7c4b79b2"},{"claim_cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","event_cluster_id":"0031fe05-7e53-4c0c-b89e-d86016e53d57"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"a2f5a4b1-ccba-4cac-9bde-f079d3027db4","event_cluster_id":"3a1ce373-9bb9-4921-899a-ff8f1e27a082"},{"claim_cluster_id":"269d367a-5938-4087-911a-3256c10a910f","event_cluster_id":"2a3a89a0-063e-477e-a31a-17933d228f6f"},{"claim_cluster_id":"fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec","event_cluster_id":"69a4b47b-f3fa-41cb-94e3-29a8741c8bf2"},{"claim_cluster_id":"c1b9998a-8864-4f22-be23-89209993bf02","event_cluster_id":"8a948aba-63b5-4bbf-9ee5-595eefc57f01"},{"claim_cluster_id":"294d0346-cddf-4b1e-a6bc-ab4686137712","event_cluster_id":"91d4dc33-e633-4d25-9203-969f15a268d3"},{"claim_cluster_id":"992ef0ee-f6fc-4177-b75b-0a3511a615a6","event_cluster_id":"082dc58d-c56c-468c-82bc-39e8c62c9b6c"},{"claim_cluster_id":"b1da162a-fb28-4547-8fd8-715c5361b7af","event_cluster_id":"bd0d52ba-bf23-4db8-aa70-86556a4740bf"},{"claim_cluster_id":"94f243ab-1521-4874-b5fc-b80847a7fefc","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"30229ad5-5242-4fd1-8256-d013e88e6413","event_cluster_id":"f69427e1-c0af-413b-916d-3232db85e095"},{"claim_cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","event_cluster_id":"87e98045-d749-47b9-a158-8b7bfbd1d3db"},{"claim_cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"63ad18c0-00c0-4509-b669-2aff507b5502","event_cluster_id":"876ae960-2467-4ffe-b0e9-9cd336bdf4a1"},{"claim_cluster_id":"2cb0cf7d-4f72-4e53-9096-b92c1763568c","event_cluster_id":"2e2d4dce-467a-4329-8a65-a9b7ada8d364"},{"claim_cluster_id":"221f2ccb-c412-4e42-8d5c-82e681a61d32","event_cluster_id":"47f27689-5f68-430a-bf84-77af1b6dc7c8"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"9eca8644-57d0-4b18-b62b-b394d615bf38"},{"claim_cluster_id":"b320fe25-40ac-4b0e-8605-df06f6384218","event_cluster_id":"823a1b7a-305d-4292-886b-7974a056d98e"},{"claim_cluster_id":"bd6de2da-8b5f-4e38-83bd-28294e175aca","event_cluster_id":"075f6940-c670-4659-a33b-590bac9f8a7f"},{"claim_cluster_id":"3b355bb3-b565-4742-b6f4-50c6f509a1ec","event_cluster_id":"cb34d24e-7722-4a18-bb1f-3ff1c0f4f310"},{"claim_cluster_id":"eb2ba8af-f927-478b-bc26-2105bdb87c5f","event_cluster_id":"4361c487-2c7b-4ed5-a3bb-23c69a57f5ec"},{"claim_cluster_id":"a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0","event_cluster_id":"237a1bcd-f29b-4003-80f0-c4efc0c14bc8"},{"claim_cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","event_cluster_id":"d28f03f1-166f-4e7a-a151-3bb7c1898209"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"52b4a518-aae8-40ab-8a78-e641ed7c28ce","event_cluster_id":"b5c81785-6289-45db-a194-d9731e5e4109"},{"claim_cluster_id":"61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc","event_cluster_id":"4f640a26-8edc-40de-bddc-8bc4a09eb227"},{"claim_cluster_id":"9e96a51d-6101-42af-b7a2-54e4dd5ae715","event_cluster_id":"c74f353a-07b1-444e-8cd6-e07be020ae58"},{"claim_cluster_id":"621b2187-e651-4a6f-becc-2a2a2cd444a2","event_cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"0d91b295-8dc7-41f1-8c2e-38f85451d859"},{"claim_cluster_id":"1b178ff0-cd2a-415f-bd8a-4daf71e452c3","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"7553f34f-d61f-419e-8976-cecf89bafb0e","event_cluster_id":"67ef8b62-b165-45e4-8df0-4a9253d62b61"},{"claim_cluster_id":"99b20734-bb32-4aff-b60b-a976139937c2","event_cluster_id":"3531210e-caae-4d2a-9c81-92659900742b"},{"claim_cluster_id":"31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8","event_cluster_id":"cb5fae82-58a9-4d49-9da8-1886e33d1269"},{"claim_cluster_id":"eb6a12b4-268e-4e39-8d84-ba73d40a7ffd","event_cluster_id":"dd33f241-05d1-4f54-b214-172163f88f9a"},{"claim_cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","event_cluster_id":"e5eb0916-6642-496c-9615-8dbd59c7dd10"},{"claim_cluster_id":"32bf3674-86a6-4cde-a9e5-20a5e3965e02","event_cluster_id":"844a0834-978f-47f2-bad3-00baad297b74"},{"claim_cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","event_cluster_id":"ead45298-e146-40a5-a729-dab15400b7c2"},{"claim_cluster_id":"3dd1bcbf-32ed-443e-a942-a8e7446ea6d1","event_cluster_id":"d878f267-808b-4a23-9202-10d08ee3053d"},{"claim_cluster_id":"707f482d-8ff7-4cc9-a14d-99540ac35950","event_cluster_id":"ee29d318-fee6-4bab-9dff-20d633b0297f"},{"claim_cluster_id":"1ef62c3d-3750-43b9-855b-d4624938de1e","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"a604694d-4fcd-48e0-a074-6eaa09488a89","event_cluster_id":"1f4a4adb-de76-451d-aa05-57dc41f8014d"},{"claim_cluster_id":"e53d664b-c538-43f3-a025-7686ca315f8a","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"71211c39-a653-4c7c-bf55-0339568d069a","event_cluster_id":"3e6833b5-d7ea-4b12-87f8-2eba62891434"},{"claim_cluster_id":"c0426c3e-a327-4be7-b689-905cba5cdfca","event_cluster_id":"2ed4b8da-36cc-414e-9362-86f9b9a7a515"},{"claim_cluster_id":"a0698f9c-4bc8-48b3-b669-44befd54559c","event_cluster_id":"fbf6086c-d11b-4ab9-9b6b-67f0d133c827"},{"claim_cluster_id":"4350947c-093e-43d1-91ad-c33f75e13a1e","event_cluster_id":"e8860c87-9dc3-491a-8748-575a2d051898"},{"claim_cluster_id":"d9041723-b3d2-4f6c-85e6-435010ef6231","event_cluster_id":"fe82d3f9-486a-46c2-97e7-5a1b97f02537"},{"claim_cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","event_cluster_id":"3bf26de2-8578-4eb2-a0d5-5c4deaf0246b"},{"claim_cluster_id":"7b36cbc9-6f57-4b29-9c6b-010607eb3738","event_cluster_id":"e64ee1a2-9226-4d61-b0d3-bf9e52dc9982"},{"claim_cluster_id":"84b73ec4-88f0-4587-a147-47771c41db07","event_cluster_id":"8b8269a1-ffad-456b-b974-307474aac288"},{"claim_cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","event_cluster_id":"4dc5e4a5-2670-454e-b212-260136221524"},{"claim_cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","event_cluster_id":"06406aaf-e480-4364-8dee-02d2a85bbdca"},{"claim_cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","event_cluster_id":"37dc3c46-39b6-4d4e-87ad-59040db4662a"},{"claim_cluster_id":"3de3b456-a38d-41d1-85eb-8ea198492839","event_cluster_id":"60581c58-3e78-4ab6-b577-5edbcc9dc29c"},{"claim_cluster_id":"9b2175d9-8d49-4d83-857c-16d8550ab216","event_cluster_id":"6773439f-27bf-46ee-884f-6f78667de502"},{"claim_cluster_id":"298b76c6-3ed3-4a84-8894-fa50a9f4234f","event_cluster_id":"dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"},{"claim_cluster_id":"af167078-1ea4-4d05-a491-aca4808cafd4","event_cluster_id":"4a259022-df32-4e4f-a09e-afdcfddd1eae"},{"claim_cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","event_cluster_id":"bd072c00-533b-4c4a-918b-097a11abe63b"},{"claim_cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","event_cluster_id":"2a492648-efc4-44a2-9eee-4d95d05d104b"},{"claim_cluster_id":"ab7a8719-e742-49dc-b23d-904f2b97e9e2","event_cluster_id":"e3712e03-c7c7-4373-818a-4c6598fd68df"},{"claim_cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"891e1da4-bfc6-4524-a5da-153bde60b165","event_cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"},{"claim_cluster_id":"cbafab62-ed48-49fc-9623-dbadef5cfd91","event_cluster_id":"bfb1dcef-eb53-42d3-9c74-0d949ffc43a7"},{"claim_cluster_id":"221f2ccb-c412-4e42-8d5c-82e681a61d32","event_cluster_id":"6d365284-d631-4fba-bf61-dd8894351156"},{"claim_cluster_id":"692c12d0-dff2-4fe9-a351-80422ee99320","event_cluster_id":"3d676a5b-4d23-4b21-beb6-27ce056b17ec"},{"claim_cluster_id":"4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6","event_cluster_id":"1fcf2fd2-6989-429c-b569-e5ab5218738b"},{"claim_cluster_id":"04938aaa-1985-4664-bfb5-337fffd62a6d","event_cluster_id":"3b4e6d34-1c11-4402-8f08-680cd1dda0c6"},{"claim_cluster_id":"cd37a888-7bea-44b1-9691-e12e7c11fac9","event_cluster_id":"90a7e868-64e0-420e-8b7e-dbd99dcaae03"},{"claim_cluster_id":"37094b58-53c9-4cd4-af90-cb17301eef9e","event_cluster_id":"f7c00384-e094-4930-b95a-5105ca6ad5a9"},{"claim_cluster_id":"0c8486a8-b9af-4dcb-9989-fcb363b7897e","event_cluster_id":"dc679e22-e949-4c80-8633-a19ca02db1b0"},{"claim_cluster_id":"7bcfb80e-f4a6-4404-be69-078e88ddce1f","event_cluster_id":"56a382af-0cf2-4fb5-ba8f-a5cad69ed381"},{"claim_cluster_id":"970a5cc7-9a05-4850-b0f1-f59128c441c8","event_cluster_id":"a94771e0-7b95-4bfd-9f9c-88d21171cf9e"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"938b7182-512d-4aa5-a1bc-532c7b55f96a"},{"claim_cluster_id":"f4c860ae-1c6c-4478-89c7-fac05f3999c6","event_cluster_id":"bd0a5021-3a05-428a-a728-61f8cfe02fc4"},{"claim_cluster_id":"843e2174-20bd-4386-beb4-ad4f8d0ba790","event_cluster_id":"6ef4a6d4-b9a1-4d80-ae23-e54049cc7170"},{"claim_cluster_id":"c784871a-fcaa-4345-b3a8-ae8869019499","event_cluster_id":"ccd586d7-5c30-4f84-8142-adc54ddef655"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"7738ea50-f8ba-464e-a8c6-f4b5554a926f"},{"claim_cluster_id":"e045b8f3-c755-4ad1-91b0-a0b8f7878680","event_cluster_id":"d74a5599-9b30-4d12-97d2-692e60e13661"},{"claim_cluster_id":"b8c8cd38-7dea-46d6-b8a1-7316916dd462","event_cluster_id":"fe966747-5532-4145-9e61-737006d6b37e"},{"claim_cluster_id":"5443e2c0-e92d-4c21-ba1b-b0cdb2302769","event_cluster_id":"90d77585-5ea5-4b42-8291-9d8389cf1b9a"},{"claim_cluster_id":"d832a602-46fe-4c29-83ff-f47197eab057","event_cluster_id":"28640c6e-e7eb-4b38-b099-8b9d347bd04a"},{"claim_cluster_id":"0de2a028-10da-49bb-8b43-e7f79a0ff6dd","event_cluster_id":"b21610b3-aecf-410c-9995-b99b144c12b1"},{"claim_cluster_id":"c35acce9-0a6f-4e25-8869-1a5e38bf302a","event_cluster_id":"b61c8bad-f744-4e5e-908b-0b070a8f0d89"},{"claim_cluster_id":"925ee56a-7eb9-4c7c-aeb3-1eb168cbca46","event_cluster_id":"84977d14-a5d8-4f51-965b-c09f3c5a291f"},{"claim_cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","event_cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"61475130-6f49-487a-bec1-f17a9209af5f"},{"claim_cluster_id":"d017f7be-45ae-4ae5-b72e-a6e53f0a589b","event_cluster_id":"90a7e868-64e0-420e-8b7e-dbd99dcaae03"},{"claim_cluster_id":"5a140171-9551-46fb-8eb7-bce434648b1a","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"505519a5-a059-4c9c-8b16-ce6dffe7e678","event_cluster_id":"2f8e700c-1460-4a5f-9578-58c60978917b"},{"claim_cluster_id":"04ba7876-53cc-44c3-8149-fe7ba435f124","event_cluster_id":"9e7c5d20-49ac-489c-bf49-38304a7e5439"},{"claim_cluster_id":"755e1910-15d6-4530-b0f7-b73a35ac9c64","event_cluster_id":"529a3261-d48b-4317-930e-3bc02bd608d6"},{"claim_cluster_id":"aa4340e9-32f1-4ade-ab1e-eae7e384d7d5","event_cluster_id":"412eecdd-3e2f-4593-9b61-1dd3ac3a36fc"},{"claim_cluster_id":"43fe48a2-ed82-4cef-9784-8e8df627f565","event_cluster_id":"d7e7a762-6cbc-4c4f-9830-3d635c57a2df"},{"claim_cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","event_cluster_id":"e64ee1a2-9226-4d61-b0d3-bf9e52dc9982"},{"claim_cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","event_cluster_id":"7b901b41-b4fa-460e-bc66-e732ffe7ab8c"},{"claim_cluster_id":"85123ed6-1d34-44b3-9644-642bc01ff160","event_cluster_id":"71ca644a-cfc8-4e25-b5db-b8f4e53e1dc1"},{"claim_cluster_id":"df65bddb-06ed-4815-9cbc-5ae170dbdeae","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"fa32fcee-2bb1-444a-8515-123065611c9e","event_cluster_id":"90376b4c-da40-4dab-8f73-1b70785d5f49"},{"claim_cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","event_cluster_id":"7b3e2472-ab18-4258-a390-e26e567571a0"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"5e50bec2-0cb9-42e3-b94b-de915ce6a4d5"},{"claim_cluster_id":"c8956774-b873-4e48-aca4-1d4ce1428a6f","event_cluster_id":"fa9c6e3a-5327-4294-bfff-2d638f6c4455"},{"claim_cluster_id":"ccd87163-f5c4-4a49-b3d3-5d5c4788834c","event_cluster_id":"58061e14-9c6d-45ae-8c7f-48a44c7f7cb0"},{"claim_cluster_id":"21e1972c-1d67-4f1b-a212-f7b911ed7f60","event_cluster_id":"71623d2a-780c-4e92-af1b-eb0e9b031c0d"},{"claim_cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","event_cluster_id":"fd2129f3-2e6f-48c6-9418-cef28902c1e2"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"a300ab57-0a8d-448b-8ceb-9af6a492c83c"},{"claim_cluster_id":"5feff95a-4d00-4a01-9b49-f3df3eb263ca","event_cluster_id":"52204f25-791c-4bc8-9a84-ab506bb1cad1"},{"claim_cluster_id":"1c849e20-6024-47fa-80b4-e611385ba612","event_cluster_id":"fdfba504-e492-4a5f-92f3-533547d34d6b"},{"claim_cluster_id":"42314335-3518-45c0-909b-96111c0955f6","event_cluster_id":"06fc9106-7925-4cb4-a52c-592a739aee82"},{"claim_cluster_id":"90c28686-07e5-47d2-8675-847924fbe9c3","event_cluster_id":"d04cd0c9-b68b-4e40-8b85-d3adf9108b78"},{"claim_cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","event_cluster_id":"b961ace3-c2b8-4138-bb7c-fb147b603dc5"},{"claim_cluster_id":"626c75be-9b85-4ac5-97e0-e03b79d0191e","event_cluster_id":"dac94ab4-f251-4e9f-88eb-38ea10c9b12a"},{"claim_cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","event_cluster_id":"0edde6ee-5047-426b-bbb4-69dd12b6fd54"},{"claim_cluster_id":"5764cc12-79c5-4e4e-b170-52997cac0e07","event_cluster_id":"504b2533-2c70-438a-a457-80634e246dfa"},{"claim_cluster_id":"ddd4b5a0-2eee-4ff9-bb50-de940c2541e2","event_cluster_id":"ac7642b8-b25c-45db-8998-1d3c7f1c25e7"},{"claim_cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"c8b9924c-3cce-4d36-afc2-f686b12770db","event_cluster_id":"337480a5-b05e-40ea-b813-e79cc37e4e00"},{"claim_cluster_id":"2cfb50e6-37ad-47a2-87b2-da1a9a512e46","event_cluster_id":"e1645179-8a65-4728-91ce-ad15f6e0cef3"},{"claim_cluster_id":"3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9","event_cluster_id":"3124bf40-7b7a-44d7-a83e-a1fe41e14ec6"},{"claim_cluster_id":"c02665b8-8535-44f4-96b2-764b54985f66","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"292629c2-32f2-451e-b64e-e8f73bb87975","event_cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638"},{"claim_cluster_id":"6dfdb047-f69b-420b-87ec-fbcb72244cc6","event_cluster_id":"91e3ebd7-7afc-4109-ab3a-203fd4f78d4d"},{"claim_cluster_id":"de60bb28-4ca7-441f-814b-f2ecfe29fb54","event_cluster_id":"11abdc54-b039-4ec9-b836-c70099743468"},{"claim_cluster_id":"be3c4edf-6251-45c4-b310-ec9b6650b95f","event_cluster_id":"2156a4b1-8617-407a-8feb-cc3b74e8fec4"},{"claim_cluster_id":"9fb5216e-3d0c-403e-a2bf-9368fa3e3592","event_cluster_id":"f9c2516c-da15-44ca-94aa-e9d013d3a430"},{"claim_cluster_id":"1d2ba60d-53c7-4e8c-91e5-1d0e114d5708","event_cluster_id":"5365be2b-8f70-4f67-96e5-c75ce9b7256e"},{"claim_cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"64b71712-5c8b-4ba5-9b04-b6b37a4ef8bd","event_cluster_id":"c926ce6f-72a8-4848-817d-af5dc8f10bb9"},{"claim_cluster_id":"dfbc19e5-8117-4d40-9c25-774ed7aee906","event_cluster_id":"9583b42b-1878-4c5b-8b34-5a41d72c1a17"},{"claim_cluster_id":"44260a23-35ce-4643-9869-bda1004b447a","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"37ca2b04-06dc-444f-b96a-20f9e5902a07","event_cluster_id":"2002baa5-6997-4ebc-9742-182fae427316"},{"claim_cluster_id":"6e63c4ba-f9ee-49c7-a87f-b38ea11837c4","event_cluster_id":"05fe6713-720d-475f-867a-c6de011c5f20"},{"claim_cluster_id":"71185519-3f2f-4171-84a1-11f08a933f13","event_cluster_id":"036aef66-792d-4feb-a831-cb1e088b3daf"},{"claim_cluster_id":"4f1efe8f-fe00-4658-8994-d5332d4cc9ed","event_cluster_id":"87b42d69-1e6c-402c-99c5-e722d6abf4ce"},{"claim_cluster_id":"f358da84-14e4-4001-acb3-83fa23673eb8","event_cluster_id":"d249e1af-ea1c-48af-a49a-e0b42f780f6c"},{"claim_cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","event_cluster_id":"428b353a-55ea-4d2a-8de9-d2392f48d161"},{"claim_cluster_id":"f3b06230-c202-438a-8858-b8c55fa68828","event_cluster_id":"e3deeefe-c427-4d71-816d-254495afc3ac"},{"claim_cluster_id":"49ede63e-a1af-4931-8ab4-034fed7764ad","event_cluster_id":"64b86b07-89a1-4ba2-8492-bdd7801a5bbe"},{"claim_cluster_id":"501b66f7-8e87-4810-b05d-6bb95d09a79e","event_cluster_id":"0f37d4dc-cf7b-49dc-aecd-4803e8374e39"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"2528bd46-af3f-4f9d-8f91-2dbf49b3388e"},{"claim_cluster_id":"9c68ef9f-53c9-413e-b008-51e352564820","event_cluster_id":"bac2fa35-75bf-4c16-a00a-24bb7ad1ff15"},{"claim_cluster_id":"22c13a77-51bd-41df-afeb-444adbde288e","event_cluster_id":"a64f796d-8a90-4c29-811c-e05f5e8b113a"},{"claim_cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","event_cluster_id":"05b6cfa2-c45f-42a8-bb0c-d50df97483f9"},{"claim_cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","event_cluster_id":"1c2050b3-8746-45bf-a7a2-7907e141c266"},{"claim_cluster_id":"aa973fc5-c596-49d2-86f1-80f2a9f419e9","event_cluster_id":"a7db18f7-5822-426a-8676-b522df1e90e8"},{"claim_cluster_id":"29fe240a-81f6-4aef-a8b5-3cacf3e3985a","event_cluster_id":"b379da86-fb9c-4026-92d2-37b07df028cc"},{"claim_cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","event_cluster_id":"4e97d6a7-e106-4542-b474-cb57818b7b22"},{"claim_cluster_id":"19b1602b-7236-4e52-b704-1442a85ad752","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"0450cb4c-8816-4bbd-85b6-ac94ecde9af4","event_cluster_id":"e0dcc7af-9cb5-4c1d-b108-5d8de64148cf"},{"claim_cluster_id":"1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba","event_cluster_id":"1a154b18-5d3f-45d7-ac98-39d14a936806"},{"claim_cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","event_cluster_id":"68dfb31b-7f13-4eb1-b5bf-740e6918f0ee"},{"claim_cluster_id":"d65bf625-e91c-49ac-a498-dc2e95df1f93","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"e473874a-9cd2-4a8d-b926-9354bf1b7e19","event_cluster_id":"126a290c-017d-477f-aef9-ee387468d992"},{"claim_cluster_id":"546f63e2-ef89-4f69-bd49-cde47599b05e","event_cluster_id":"7afc1db8-da22-4a16-9a76-d5155374bce3"},{"claim_cluster_id":"0dad0e38-e0db-46d5-a25f-8e95be6a721f","event_cluster_id":"cb033bf6-f8da-46c0-a5e0-962c48c82ad6"},{"claim_cluster_id":"0cdd2771-1f79-419e-940c-c74f863377bb","event_cluster_id":"31763d96-84ac-402a-a69c-ea748718f342"},{"claim_cluster_id":"83856113-7cf1-435d-bc2c-d1c5e5e5c106","event_cluster_id":"c278122a-3daa-4207-bb75-b0bf1f432ea0"},{"claim_cluster_id":"589240bc-a0dc-4961-944a-a3594262e220","event_cluster_id":"fd6cf91a-5408-4a49-8b88-6ba66a82f0e7"},{"claim_cluster_id":"6d176455-78b5-4454-a405-3f0ba5b91ecb","event_cluster_id":"e56b6c3e-60ae-4144-ba92-480b792e396d"},{"claim_cluster_id":"ec613890-df43-48e8-bf2a-a40ccb263efc","event_cluster_id":"29477fdd-bbbe-4e39-b779-19de18778240"},{"claim_cluster_id":"221f2ccb-c412-4e42-8d5c-82e681a61d32","event_cluster_id":"28097be1-5cca-4755-b4ba-20a7ac4aa34a"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"220dfe6b-2774-4a8a-8306-3094dfce156d"},{"claim_cluster_id":"bd0a892b-884e-4c98-8690-8f25949dbaed","event_cluster_id":"ce319c6f-8ace-40b1-be7e-933bd39cd9c5"},{"claim_cluster_id":"120d61e9-d442-4218-b8d0-9559d9880c3a","event_cluster_id":"c025fbc7-332e-4457-bed4-c17718085886"},{"claim_cluster_id":"b4a81fcd-1fa0-4fbe-88f0-692419c6082a","event_cluster_id":"a839d9a9-74d4-474c-bdfc-b239b6e1eb9b"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"aeaa0391-95c5-43bf-a72e-66d04a052ba3"},{"claim_cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","event_cluster_id":"e42d141d-80cc-4e68-848e-2d85ecf6a58c"},{"claim_cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","event_cluster_id":"970fa237-7a1d-4b64-a4c6-7a158c05542d"},{"claim_cluster_id":"325111bb-e15c-4f08-a4a4-3f81e99d9f35","event_cluster_id":"d6d06f17-e283-43e2-b5a1-66991f31adf1"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"1501c95d-fe6f-4129-965a-ccb56abb7afe"},{"claim_cluster_id":"d21ce376-5e68-41d1-903e-db8ea2f295f8","event_cluster_id":"634e943b-2d48-48b0-b1e8-52524e278a9f"},{"claim_cluster_id":"0ed53993-d675-4e0a-91d9-fca7f39d86fc","event_cluster_id":"03bed382-9ecc-4f84-bd88-6ff53d1b8a13"},{"claim_cluster_id":"cbe32f56-0dc5-4870-8a2a-874435ed2ed9","event_cluster_id":"7378ad43-a016-4ea8-a115-0123a4bd291a"},{"claim_cluster_id":"88dffe0c-cf6a-4d54-b70b-1d2c41a95f47","event_cluster_id":"01284921-0773-415d-9ce4-f4e93b10a2af"},{"claim_cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"c4536202-39a9-481f-a4be-147b7620686b","event_cluster_id":"5ac2f931-1ef9-4c96-8568-845f2751d03d"},{"claim_cluster_id":"8bdd6183-6e5d-4862-87e8-003b661f98ce","event_cluster_id":"84ed6834-5129-43f4-a029-0b28839b357d"},{"claim_cluster_id":"a950be1b-733b-40a8-b78b-7a36e0c5c2ac","event_cluster_id":"a1ea18ac-be18-41e4-86ed-51a5a227e8ba"},{"claim_cluster_id":"59905a93-0117-4d6a-a153-cacf3c9feeb8","event_cluster_id":"9f1d605b-541e-498f-8d37-d5763cc9a791"},{"claim_cluster_id":"3dc0cbd1-b381-4df2-846d-e07147e83cbe","event_cluster_id":"c058e393-ae39-4d59-9d56-d80b61d507dc"},{"claim_cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","event_cluster_id":"48f7f24e-52e0-4527-a4e1-e5a83b50fb40"},{"claim_cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","event_cluster_id":"52307e03-a0f5-4819-b75d-6ff7244ed5dc"},{"claim_cluster_id":"5d8665ac-7337-470b-ae27-2d46610e9f97","event_cluster_id":"56106773-dee4-4da1-bda2-7227784468b3"},{"claim_cluster_id":"4e7d68ff-7bd2-4949-affb-c71a8a76240a","event_cluster_id":"42e92742-8e3a-4799-8e99-5faf8bc31f82"},{"claim_cluster_id":"903d2f0d-f14e-42ff-a685-a20e841d8f7b","event_cluster_id":"a2f20d4d-0860-445b-aa4d-0a748d8d1f73"},{"claim_cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","event_cluster_id":"9d882154-e197-4475-b27e-35c54fe8fbfd"},{"claim_cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"dad2ba1b-78a6-4e69-91a7-e473e3d79e42","event_cluster_id":"2fefb93c-9c85-46df-850b-c68cfbfe7264"},{"claim_cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","event_cluster_id":"fccc5c68-3c5f-4b2d-8103-9431b0c4794a"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"f184f109-b4af-4d4c-b5c2-73e631545fd2"},{"claim_cluster_id":"5900a7ab-7cb4-45d4-8807-d20dee337670","event_cluster_id":"14faed7d-8ab2-4b52-8d60-40b6be3c9a21"},{"claim_cluster_id":"e25eede3-3242-446d-a439-2c4becea51cf","event_cluster_id":"76f2f5fc-c5b8-4d6e-932c-655254df8fc2"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9"},{"claim_cluster_id":"c9367bb7-c2e3-4341-a799-6ff36d655556","event_cluster_id":"6234ba01-768a-474f-80de-4d8b6df78d63"},{"claim_cluster_id":"d3777022-58bb-45d2-9153-3e33e4a367f9","event_cluster_id":"fc55be0d-bed8-4ebb-8dc7-149fb174476c"},{"claim_cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","event_cluster_id":"a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f"},{"claim_cluster_id":"48ac478a-0a47-432d-9d71-30bc821691af","event_cluster_id":"ec10f62c-ce71-4a79-9f7e-b5ddfb366f3a"},{"claim_cluster_id":"a45b0120-f89a-4fb7-9d30-32c67bc23fc9","event_cluster_id":"a1617416-4daf-4173-b483-3f65d380f28c"},{"claim_cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","event_cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02"},{"claim_cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","event_cluster_id":"ea81b5d1-0d91-46ec-a9b0-b349139b83e4"},{"claim_cluster_id":"b5aab15d-0623-4834-b9a0-c066e3616369","event_cluster_id":"a59be105-d89d-41df-ade9-920d14216360"},{"claim_cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","event_cluster_id":"e1c95bf3-b7f4-4783-af68-d79bcb7b55a9"},{"claim_cluster_id":"a0698f9c-4bc8-48b3-b669-44befd54559c","event_cluster_id":"5674d01b-2996-4ed7-850d-de449d707ce5"},{"claim_cluster_id":"11aef681-a744-409f-8cc3-69822e3a86b2","event_cluster_id":"5400c461-7afa-4066-ba64-beb7aef1eede"},{"claim_cluster_id":"f6aedae8-b368-419e-9158-abbe718748ba","event_cluster_id":"45a3ab07-2fb2-420c-9452-350f55111899"},{"claim_cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","event_cluster_id":"37512ba8-d5ed-4b9e-9fba-d0ec249a1d84"},{"claim_cluster_id":"c3211a84-677f-449b-8204-7cc36fb3bea9","event_cluster_id":"33eeb9d5-6bc2-4034-a6c6-3e0b1e59728e"},{"claim_cluster_id":"209935ed-d0a0-4dbe-82d8-2d7d5a2aa866","event_cluster_id":"987f4090-f0a3-43c8-9987-c964fdd04c79"},{"claim_cluster_id":"5317331a-d0a9-4595-acad-210a92b278d8","event_cluster_id":"31f1de90-d456-4f9f-8590-accad42614e0"},{"claim_cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","event_cluster_id":"97b1177e-80bf-4e09-83e5-b50aecee0b52"},{"claim_cluster_id":"bed08ef5-4cb1-4f05-b2d4-a996242acd93","event_cluster_id":"0d87ab36-c271-462d-81cc-1e3930ab33e4"},{"claim_cluster_id":"c784871a-fcaa-4345-b3a8-ae8869019499","event_cluster_id":"52f03b57-8fb1-4ff1-8eda-c0d228097a8f"},{"claim_cluster_id":"11e43ecc-22c8-4f1c-b13a-fb97013ce963","event_cluster_id":"e20b024a-3a40-46e1-bbc5-e9607839e91f"},{"claim_cluster_id":"5d657ce1-e484-4e48-b720-f4927cd733dd","event_cluster_id":"f0d87010-6047-4ec3-814a-b7e1d93689ac"},{"claim_cluster_id":"e0c5a85f-7145-4366-aac8-58cd212f7e6a","event_cluster_id":"b3f64145-99ff-4cb6-9aeb-55abe9921e59"},{"claim_cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","event_cluster_id":"2ec09e70-73d9-4395-9c36-0dbcac034464"},{"claim_cluster_id":"4f0130b7-d8c3-44c1-892f-fe74aef4cecc","event_cluster_id":"fdf0468f-b20d-40b0-8a2a-5519d8086286"},{"claim_cluster_id":"0a79d737-f594-464b-b3d2-afd57c6349f1","event_cluster_id":"619f9470-2786-4c4b-9f38-8e5494785aa1"},{"claim_cluster_id":"a766b305-cd34-47d7-bed5-5c04c33c99ba","event_cluster_id":"aa6b0ec7-e6ca-40be-8563-62563928ebc1"},{"claim_cluster_id":"7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9","event_cluster_id":"ec281f2d-d4ef-4a4e-a1f0-552896c7315d"},{"claim_cluster_id":"291e098d-0f3d-4fff-9906-3b21ed1a33a1","event_cluster_id":"bc3691bd-e8ea-4667-b6cf-1afd5eb88fa6"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046"},{"claim_cluster_id":"93459608-ccd3-4b8a-af7b-ede8b22e8c94","event_cluster_id":"44b235b6-c03c-46c3-8783-0dedf88d2c23"},{"claim_cluster_id":"19867279-c3e5-4f1b-afe9-d36652a4bc2b","event_cluster_id":"d8bdc753-fad4-4cd8-b9f2-efb5708d6629"},{"claim_cluster_id":"442dded8-bef6-49b2-b7d4-70454c6e8e79","event_cluster_id":"3cb67525-0d0d-4f1e-8f2b-d44f7e022019"},{"claim_cluster_id":"544ac6da-d621-4fd5-bbf8-4a2cd6254e41","event_cluster_id":"7fb1639d-6541-40a5-8cc7-71943288089e"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"a0698f9c-4bc8-48b3-b669-44befd54559c","event_cluster_id":"3fd4fa60-bdae-4294-8d90-4a430127c38a"},{"claim_cluster_id":"db6d1f55-1378-42e6-ab38-0b1046e37cc0","event_cluster_id":"85fa8f6e-2724-474a-b5e9-bb6b9d49d126"},{"claim_cluster_id":"d14315a8-aa93-4c64-a42e-a4307dd0814a","event_cluster_id":"5f903470-ae17-46df-89e3-72da3d3117a4"},{"claim_cluster_id":"8a0accb4-caf5-4741-9038-3360a1a08c25","event_cluster_id":"eee93c68-9cef-40e8-a46b-ade5e4a0a57d"},{"claim_cluster_id":"91e6a8b3-0e47-4ed1-b99e-a946e23e0c33","event_cluster_id":"6bf20e7d-0fef-44de-a032-0b603b235bf7"},{"claim_cluster_id":"0ecc8673-156d-41da-a0bd-8ceb3bd503b8","event_cluster_id":"10cad03e-00e1-4582-b61d-1c7191589376"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"c3ffc4ba-bd9b-4ff0-ac0e-e1b2b01b15fd"},{"claim_cluster_id":"94c9f0c7-1016-4b43-931c-9bd7dc0b2892","event_cluster_id":"0709871d-a6ab-4aa2-93bf-03bb443f89a9"},{"claim_cluster_id":"e52244b2-1143-48cf-9735-ce26094681d1","event_cluster_id":"f41585b2-89bb-4794-90a0-40b26fb3ec23"},{"claim_cluster_id":"db91531a-0712-431d-a04b-9b798db3d3b4","event_cluster_id":"88714dc6-72d5-4f7f-9067-219b66b31c42"},{"claim_cluster_id":"a01e0915-a285-410d-9d1b-ce9544139c90","event_cluster_id":"a73d7361-cea3-47c7-84a2-2a97ab239fa4"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"b060d900-983c-47b6-b9e8-d31f4dbd3db1"},{"claim_cluster_id":"f46e8240-2cb3-437d-9e2e-c04f6db7a813","event_cluster_id":"d550236c-347c-46ce-84eb-f723bc55deec"},{"claim_cluster_id":"c6e50b1a-e795-43fc-baca-c835ba2bf14d","event_cluster_id":"14c01a60-ad79-4b97-8a3e-f1a74d8a8f96"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"069833ab-70fd-48fa-80f9-9eed2484a21e"},{"claim_cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","event_cluster_id":"6b75ad73-0fd7-443a-b60e-840a237907bc"},{"claim_cluster_id":"4e7d68ff-7bd2-4949-affb-c71a8a76240a","event_cluster_id":"82f5beda-b460-413d-ba52-232c56bac459"},{"claim_cluster_id":"1dae585e-f051-41dc-8fc8-c2d3e3b3b884","event_cluster_id":"d2833c21-07b4-4262-9ed6-9db3cde93c79"},{"claim_cluster_id":"da33c07b-485b-43b6-8165-46193fb1720d","event_cluster_id":"4c79fc69-3bd0-4180-9718-8d85b8c9dd85"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"84147a14-72bc-486f-90ad-45e374aeaa05"},{"claim_cluster_id":"43fe48a2-ed82-4cef-9784-8e8df627f565","event_cluster_id":"7a75d7fe-a9ef-4bcc-bb6c-68501ebb5f56"},{"claim_cluster_id":"d30cdd9d-92e1-44ac-aad9-845702e1559f","event_cluster_id":"5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"},{"claim_cluster_id":"99dfb4e4-9788-4ea5-81a7-c0dd44f60aba","event_cluster_id":"0e78429b-c0f8-4ecd-ae8e-35ff713ba980"},{"claim_cluster_id":"eb6a12b4-268e-4e39-8d84-ba73d40a7ffd","event_cluster_id":"224111ea-4ffa-46dd-984c-028b4bc55489"},{"claim_cluster_id":"2c1958a0-e83a-4912-9902-e6456b756f14","event_cluster_id":"3d6b711d-93be-4839-8934-425368c03327"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"d3085fed-3741-4d75-9105-e8b0b3511de6"},{"claim_cluster_id":"ed9c7f02-d3d7-4f88-92df-80c91b7dca98","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"243cbf96-dba8-41a3-9dc7-8def431d23c9","event_cluster_id":"f3941de8-4943-41e7-80e9-773a7b8e51ab"},{"claim_cluster_id":"b6e703fc-a44f-43d6-9db6-85666a802044","event_cluster_id":"8a36ef98-d08b-4198-b4d6-a8933da5b619"},{"claim_cluster_id":"5ab9d303-668f-48d9-893f-546437484767","event_cluster_id":"2830c0e0-a35a-4015-a0c2-75079b518aa2"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"9d822f9c-32a6-4f43-9fd1-5ddd226c8add"},{"claim_cluster_id":"543e79b8-1458-43e8-a976-eaa0fcb652ab","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"1075443d-c097-4cb8-acb0-3d21f48f6aca","event_cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"9398c496-5e62-4d1b-94c1-e1eeaf48778c","event_cluster_id":"8984a612-a2af-48f1-8868-d5d348b17de2"},{"claim_cluster_id":"5a787097-c657-4d02-a7e7-ce5ddfe404d6","event_cluster_id":"b632a6a0-afbe-40f4-8a5f-a0054d37001d"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"f8aea904-a823-4059-9707-77075c116ecb","event_cluster_id":"053dfae5-6865-40c0-a285-b1e7c8cbaf44"},{"claim_cluster_id":"821946a1-401a-4657-be17-b3ed51371c13","event_cluster_id":"cc656b46-bdcc-435b-a7d6-1b15ef3a32ad"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"b2894bf3-d539-4a31-9d16-59a88bacee25"},{"claim_cluster_id":"29b7e7cf-ad7f-43ae-a8c7-822d865d97f4","event_cluster_id":"1630f0d6-45b5-4a9c-9208-8292e05b3a85"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"e98042df-e94b-4a67-8387-fe8218853a1d"},{"claim_cluster_id":"a5d39319-660b-4b6e-acb4-246464538db6","event_cluster_id":"238a575a-ac72-4ae9-8880-72409a39a327"},{"claim_cluster_id":"a986747d-76c4-4786-b8af-6e1c3537a9eb","event_cluster_id":"b9db86cc-1622-42c5-b482-396c3c7c7bf5"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"695d0f59-560f-43af-8f49-fe8e17880043"},{"claim_cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","event_cluster_id":"4ca4751a-06c9-42b9-935e-8c293fd1cd2e"},{"claim_cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","event_cluster_id":"2bf12fd5-52d9-43a7-9a2b-ede63bb26438"},{"claim_cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","event_cluster_id":"181a2d12-ad30-4552-bb72-ee9a984fa618"},{"claim_cluster_id":"0961c365-4261-4c91-984b-81c62260d807","event_cluster_id":"12a67c1f-74e3-4d9a-8a6a-adbec88544da"},{"claim_cluster_id":"10317341-49c9-447e-bafb-6ef554948da9","event_cluster_id":"92102219-111c-4df9-82ec-b4c0a1a920cf"},{"claim_cluster_id":"2dc250b5-58d8-4c44-80d2-2c17640ea117","event_cluster_id":"41c879a5-6679-4fd4-9549-bf3854b37d7c"},{"claim_cluster_id":"dc9039b4-da9a-4fd0-b97d-d822536a716c","event_cluster_id":"68a2ab6a-28c5-4be5-96a5-2cd28d07739e"},{"claim_cluster_id":"02fc2c1c-e5e4-40d6-92bc-a975544e0e30","event_cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9"},{"claim_cluster_id":"1ae849f8-e182-405a-a33b-006fe51f03e6","event_cluster_id":"c814031b-97fc-4571-859f-e9e8df89373b"},{"claim_cluster_id":"47085082-7091-436e-a3ee-ecf14c90e1a5","event_cluster_id":"91b087d8-4803-4bcf-911f-18dca461d16f"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"09a3b73e-815c-4ea0-9da8-b1110ca8cf96"},{"claim_cluster_id":"3dc82114-c98e-4342-a6ab-854d95d9efa7","event_cluster_id":"586b0585-af30-4d40-9796-01be4c00d08c"},{"claim_cluster_id":"abfcf3df-912d-43b6-968f-0f586e4e242c","event_cluster_id":"4dfd1143-30a8-4e10-a390-f29a1b58e6a8"},{"claim_cluster_id":"de1f8a69-eaff-4387-87ee-35fc20ea4a2f","event_cluster_id":"aaa9c952-e937-4295-abaa-c4968a415009"},{"claim_cluster_id":"61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc","event_cluster_id":"88679d89-9148-493b-84ed-a40bc977a620"},{"claim_cluster_id":"8b44daa7-629e-4db8-81b7-5ed88669eb86","event_cluster_id":"317ecec9-87af-4e3c-acd4-372de58135a0"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"8dd2ae56-dcf0-4439-b3f0-3a7a939056df"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"db82285e-98ce-4ae9-a084-bb6101bb4059"},{"claim_cluster_id":"636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd","event_cluster_id":"bc25c1b6-b24d-4cb5-9913-b54d305182e7"},{"claim_cluster_id":"8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"72521c8d-f680-4322-878b-70c3f47a7f96"},{"claim_cluster_id":"8a444d1c-5423-4444-8123-2c225b02e57a","event_cluster_id":"ea5f5123-a57b-4bf9-83c5-18d3a2293db6"},{"claim_cluster_id":"37ca2b04-06dc-444f-b96a-20f9e5902a07","event_cluster_id":"afc0b94b-3d14-41ac-a746-8c4fbe3bd721"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"af5dc56f-c303-4ae3-a3a4-2b17b1e05cac"},{"claim_cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","event_cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"bbf2648f-d211-49b0-bf5c-a562e43902c5","event_cluster_id":"3d47a459-5f56-4e8c-a324-2a8a527df0bb"},{"claim_cluster_id":"17be823a-a533-4e33-9ba0-969c3b8ddbd0","event_cluster_id":"134817e7-d143-434d-b8ad-1fa05e622296"},{"claim_cluster_id":"6f7b7d52-9a91-4f92-8a4e-4062c6360cda","event_cluster_id":"23b45144-23d0-44ff-aa24-9b637f465e0d"},{"claim_cluster_id":"19867279-c3e5-4f1b-afe9-d36652a4bc2b","event_cluster_id":"e4e28c57-a8cc-4df1-b26c-23b630ca06ac"},{"claim_cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","event_cluster_id":"b2e6976f-e5a2-4669-ac3d-3e87cd376f99"},{"claim_cluster_id":"75816fb8-77fb-4eee-a3ec-bbb68393ff86","event_cluster_id":"02ad021c-7d4f-4141-9a02-a5ad1ae95f65"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d"},{"claim_cluster_id":"e9d22d46-e0d1-45b7-b109-afc6516146e1","event_cluster_id":"80a8792f-9489-40e4-a0a2-e1e4173e1957"},{"claim_cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","event_cluster_id":"90f6170b-cac1-4488-806a-45a48e5f95f7"},{"claim_cluster_id":"b54d16d2-d5db-4746-b15a-e8c01d4fc586","event_cluster_id":"b9809c93-42b6-499a-9f8e-13df798b0605"},{"claim_cluster_id":"c054d850-518a-42ab-a850-01492f7fb7ce","event_cluster_id":"e19196d4-b7bf-49e0-b42c-244f5f90725b"},{"claim_cluster_id":"818fb1f8-d14f-4997-8e8d-f7e228560c99","event_cluster_id":"615af33f-6193-4bde-a85a-a2576bad24e7"},{"claim_cluster_id":"9f936fe4-6962-4447-9269-bd4c45c0f95e","event_cluster_id":"74848948-285f-4571-adb0-ad9b59d381fc"},{"claim_cluster_id":"145c6709-d797-4b12-bf2a-a6ed41e9efad","event_cluster_id":"bb00bd4b-2a33-4849-ae7f-804463c9c453"},{"claim_cluster_id":"3312bf71-bb24-4752-866e-3b29580d70d1","event_cluster_id":"81eafdea-26c8-4b44-b5c7-5cd6a9bfece5"},{"claim_cluster_id":"9e96a51d-6101-42af-b7a2-54e4dd5ae715","event_cluster_id":"2de07645-b8a8-45f7-bb4d-87637fd094ec"},{"claim_cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","event_cluster_id":"f97c3523-e4c9-4551-a240-c5e4c7f8f532"},{"claim_cluster_id":"e2a085c3-49f3-4799-87cc-2b59f85d4bb4","event_cluster_id":"827e3030-1738-4370-a530-42878dd6927d"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"c5d18c78-4df0-44fa-9f69-67266b1079e2","event_cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"},{"claim_cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","event_cluster_id":"51ccaad9-0af3-4189-abe9-de4b65c38edd"},{"claim_cluster_id":"ab829976-d7fb-4b30-9b92-89eed4e94cc4","event_cluster_id":"2a492648-efc4-44a2-9eee-4d95d05d104b"},{"claim_cluster_id":"cf399998-137e-4270-8827-7c726197fb9d","event_cluster_id":"343b7137-128b-41e4-a3ca-cc8e58193569"},{"claim_cluster_id":"57752645-2ac6-4482-9e7c-bbaea1506cc5","event_cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2"},{"claim_cluster_id":"3dcf8216-5e70-4cd4-962e-dc4b036a0071","event_cluster_id":"f262ea70-4c26-4dcc-8a1f-52d6f8ce5558"},{"claim_cluster_id":"9f34aa0e-2eb3-43e3-b4dd-54a36752af72","event_cluster_id":"e4d10cca-580c-41e1-9918-7376d930bfa1"},{"claim_cluster_id":"554575d4-0201-41f5-aa4b-d48a76e37311","event_cluster_id":"1e9089f3-b7e2-4ef0-870f-afca46689fbf"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"9d18ccac-ba43-4c43-bed8-0d742eb6d22d"},{"claim_cluster_id":"7893fdb0-a005-4beb-b22f-fc8ce5bd706e","event_cluster_id":"3035cab4-7bf7-4e5f-b8ff-717930d9caf2"},{"claim_cluster_id":"83176725-df79-43f8-b571-b45c6b2dea8f","event_cluster_id":"13220774-7cb5-4388-b12f-a0737d93673b"},{"claim_cluster_id":"679ed917-ad46-4856-a427-b83dcc51a53c","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"cef32527-0357-47cf-9fee-19bd0f13e11a","event_cluster_id":"88531805-ef1f-409a-a41f-4692202b9686"},{"claim_cluster_id":"be3c4edf-6251-45c4-b310-ec9b6650b95f","event_cluster_id":"9c4cbf68-9385-4898-9bf2-17346263f863"},{"claim_cluster_id":"d86ea948-08a0-4829-9e48-4f9273b2967d","event_cluster_id":"bc618add-d50a-4d41-b375-e0f4e3b7232b"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"afe6a321-421e-4002-b9d4-be185e9d1b93"},{"claim_cluster_id":"a8ca6792-95c5-4826-87fa-d4a8f7047a5f","event_cluster_id":"451b63c0-8817-432f-8656-27079c8595d0"},{"claim_cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","event_cluster_id":"b571b4ac-1009-4c8e-8fd0-977fefce53c9"},{"claim_cluster_id":"22ca72b9-d5a1-4be2-9dc0-99fc0a38f586","event_cluster_id":"e7dfffca-5c65-41a6-9fd7-62ccaeb4e1e2"},{"claim_cluster_id":"914ca89d-e967-443c-9856-6a5b040a0496","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"4bf14550-b17d-4304-b7d7-0f4f8ea4d2d6","event_cluster_id":"7d3dad5c-ee33-4088-acfc-ba0e93d997c2"},{"claim_cluster_id":"af503db6-fcf4-45f9-9501-f2732e2af4f7","event_cluster_id":"5a5a1e17-8382-4005-9268-9165cf015b00"},{"claim_cluster_id":"7ddce93b-3cfb-4112-a70b-f91eb14e7082","event_cluster_id":"1cd605a0-684c-41fb-8c06-79b227b23a9a"},{"claim_cluster_id":"c2350485-f95c-46d4-9b92-6355ceca86df","event_cluster_id":"bc23e70d-7b5e-43f0-97b5-b24c31beffb6"},{"claim_cluster_id":"203655c2-f1ad-4fb6-94c5-5fc8218603d3","event_cluster_id":"0f5dbdfc-39dd-4747-8fd7-3316ceae5bdf"},{"claim_cluster_id":"511c0db2-0769-45d5-a814-00f974a659aa","event_cluster_id":"1aa19d8d-3161-4beb-8b2d-3a6a4b289e65"},{"claim_cluster_id":"8bcf86f9-8509-4d9f-8550-8839a96fa515","event_cluster_id":"4005f43b-5b4a-44f8-9781-c0a91127368f"},{"claim_cluster_id":"e3c5e173-2814-430b-ad9d-2c7612d87ea6","event_cluster_id":"d88a7e63-a270-4d1c-9493-0a86c58b3e3e"},{"claim_cluster_id":"b9550306-91d4-4e1e-9632-4c73f1957d92","event_cluster_id":"02a17fb1-29be-46e9-913d-2f11d1b37013"},{"claim_cluster_id":"049db6be-2ccc-4afd-97c6-e95cb1b50286","event_cluster_id":"ea3f4ed4-bcaa-40a7-96c3-82beaa656b16"},{"claim_cluster_id":"d47ee5b3-b3df-49e6-9a06-0dbb08c65765","event_cluster_id":"3ec46f1d-e796-464f-991a-62539b2882d1"},{"claim_cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","event_cluster_id":"f16aab95-d35f-4386-9ea4-6a5f797bcf7f"},{"claim_cluster_id":"d4d4c9f9-96b0-478b-85a5-92a5fa51e55c","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","event_cluster_id":"e73d69fc-6584-4fb7-b72a-84be1893ea0f"},{"claim_cluster_id":"2408ad82-3b39-4925-be26-13cd9f14bf98","event_cluster_id":"3abfdae0-5ae4-404e-b93b-1d664986555b"},{"claim_cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","event_cluster_id":"b777e992-68f2-4307-a472-b1ae2b933a6e"},{"claim_cluster_id":"b4e4a860-8721-4ac3-8eb3-a9dec18b336d","event_cluster_id":"205e16cc-f356-4fc1-9b0e-0b31bf6aed12"},{"claim_cluster_id":"ddd4b5a0-2eee-4ff9-bb50-de940c2541e2","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"10317341-49c9-447e-bafb-6ef554948da9","event_cluster_id":"d6a1f200-a77f-4011-9cf4-4ff9dd9f9335"},{"claim_cluster_id":"8346c5bc-af0f-44c1-b155-e89d63c46a37","event_cluster_id":"22db77fd-3772-400d-bc1d-2826b96b8d9c"},{"claim_cluster_id":"767a107b-6141-45c6-9ffe-6f7fde1b3426","event_cluster_id":"f85fc07c-cf3e-43c8-9d67-6a3594e4fc3d"},{"claim_cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","event_cluster_id":"3dc36bc1-d0c5-4f9e-be89-27d20d56e931"},{"claim_cluster_id":"ce2b0119-85f6-4619-9c50-256557181c73","event_cluster_id":"0d989645-1d74-46cc-b203-0ae7bc83c732"},{"claim_cluster_id":"87e60b81-7893-469a-8c14-40e3d6122aa1","event_cluster_id":"3f86eb67-5a60-4e67-ad29-e4342d8dc8d0"},{"claim_cluster_id":"745389b6-9b21-4dd2-89bd-e66fab0ff334","event_cluster_id":"426f797a-e7ef-4bf2-9d6b-e35d76bd66ff"},{"claim_cluster_id":"bd3c25bb-6683-4bdd-8e97-11de485116b2","event_cluster_id":"ff62f156-1b54-448d-8c41-0514a58493a5"},{"claim_cluster_id":"404cf86d-d513-4c8d-adf3-7f2b9464b34e","event_cluster_id":"e5ca8f71-6bbd-48dc-bbcc-02165ada2157"},{"claim_cluster_id":"ed1b332b-c054-4114-82a1-1e645946747e","event_cluster_id":"c17cea6e-319f-464f-958b-423a8d716b81"},{"claim_cluster_id":"3a1f2987-e024-4481-9d2c-9a6882a3fb9a","event_cluster_id":"226d057f-48c7-4bbd-a28a-0aa92cb7c9a5"},{"claim_cluster_id":"c5d18c78-4df0-44fa-9f69-67266b1079e2","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"08f66922-af24-4cf8-ae47-3d7a8d80fec9","event_cluster_id":"c79c59f4-8dd7-4aa0-bc2d-7d52bf8727f3"},{"claim_cluster_id":"68617739-11a1-4108-8d8c-6d8db53fd247","event_cluster_id":"4d26360a-40f3-4825-be04-23732d33f83d"},{"claim_cluster_id":"83605bab-42d6-405a-ab45-fb6b68e0609c","event_cluster_id":"8df39116-11fd-4c52-8efc-d2dbbee81717"},{"claim_cluster_id":"203655c2-f1ad-4fb6-94c5-5fc8218603d3","event_cluster_id":"fad9d4a0-4f96-4cbe-870b-9fccf870e5e8"},{"claim_cluster_id":"baec81f4-73ba-4194-ab31-e3d64c8a57ab","event_cluster_id":"72521c8d-f680-4322-878b-70c3f47a7f96"},{"claim_cluster_id":"758ea826-ee1f-4a18-bdaa-e713f20f5573","event_cluster_id":"f2132873-f6f5-478c-99f7-99e6e3d16cc3"},{"claim_cluster_id":"8bdd6183-6e5d-4862-87e8-003b661f98ce","event_cluster_id":"12d63e10-92df-43d1-9c3e-5149ff60ae94"},{"claim_cluster_id":"abfcf3df-912d-43b6-968f-0f586e4e242c","event_cluster_id":"a330dd7b-988a-4c80-81be-2d4ba1af385f"},{"claim_cluster_id":"bec9cb65-cf13-44b3-b77b-95d99bace1e4","event_cluster_id":"2fed86e0-073b-4885-a91c-3e9ba6cceef8"},{"claim_cluster_id":"636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd","event_cluster_id":"d1e65b2e-ba15-4227-ab25-8486cb852ba1"},{"claim_cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","event_cluster_id":"c932887c-3706-4683-bd4c-6cb5768e640e"},{"claim_cluster_id":"4ada70f8-8bb6-4995-8f14-e79e769b0629","event_cluster_id":"a6d41b3b-e930-4fdb-ae89-6fb33dda11d3"},{"claim_cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","event_cluster_id":"575fb3af-a2e1-40b5-8235-6bc79d73e849"},{"claim_cluster_id":"e2d7dae8-0d86-4de0-93de-0fca88fdbecd","event_cluster_id":"52ede4ef-4c19-445c-ad39-2f9ff6488929"},{"claim_cluster_id":"626035be-3dc2-4608-b822-013ba6260905","event_cluster_id":"1ac968af-25be-488d-9da9-e6211652dcfe"},{"claim_cluster_id":"86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218","event_cluster_id":"1c8762e3-159f-4448-bbc9-4a59d7bfc9d5"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"00851827-de5d-4b35-bdc2-fc5215bce29f"},{"claim_cluster_id":"58b4a566-79d9-4559-809f-ffd9a84468b4","event_cluster_id":"4a989aa5-e7cc-4043-809c-9f42086f32b3"},{"claim_cluster_id":"bc70c00b-dffe-4092-a775-4a9734094547","event_cluster_id":"513bd779-ed11-4772-ba36-c123bfde18a2"},{"claim_cluster_id":"8fed35fe-4af1-484a-bd4d-74f9fac960c8","event_cluster_id":"da21d9c5-68a7-4237-9343-1a8df452b146"},{"claim_cluster_id":"cfad4c19-24e9-4d54-8d59-d0b08718729b","event_cluster_id":"fe528005-ab2e-4ef9-9304-cfd861dc09be"},{"claim_cluster_id":"4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082","event_cluster_id":"523b0246-0513-4295-a714-19577f713513"},{"claim_cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","event_cluster_id":"4794bb46-add2-4c57-9ffb-caa8d6c5bb0f"},{"claim_cluster_id":"d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df","event_cluster_id":"2ae6e0c5-a6f5-4035-9f73-8ab31a8a805b"},{"claim_cluster_id":"c214c388-1bcb-48de-9ccf-d250135ec39d","event_cluster_id":"dae2bae7-bdb4-4c33-b539-e09ed08a3e11"},{"claim_cluster_id":"64f152e4-be60-464e-a365-613ea259a5ff","event_cluster_id":"85cfe769-d38e-42c1-b06b-f313ff275d96"},{"claim_cluster_id":"732c6dc2-1231-46ca-b1c1-173c0f488176","event_cluster_id":"815c147f-e9cf-4afc-9a1d-d83dea6ef481"},{"claim_cluster_id":"6f18d0d0-1cda-49ba-9530-57de51dff25a","event_cluster_id":"72148a6d-891a-4283-bda4-8779feaa1601"},{"claim_cluster_id":"3e1920d2-6038-4d0b-b122-137c458f6d99","event_cluster_id":"8ec6c014-24e3-40b5-a577-20ca128d6e41"},{"claim_cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","event_cluster_id":"14d0a92d-65cb-4881-998f-aed067993e99"},{"claim_cluster_id":"58a44cd6-3f44-4460-9d07-d5a28bd55747","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"9cef1461-4ccb-4b2f-8a1e-1d71ef404be6"},{"claim_cluster_id":"d232b59a-12d7-48e0-9945-60749a40e538","event_cluster_id":"90309cf4-c7b2-4dbe-a694-62efd0012476"},{"claim_cluster_id":"24a47a14-4ee4-4529-96e9-02c94e429ea6","event_cluster_id":"efada224-bd67-4a33-8ca6-01f2d398630b"},{"claim_cluster_id":"8992a182-5ede-4dbb-9979-4dcf0e10c546","event_cluster_id":"f45eb579-66d6-44ec-ab0f-e41545f58c6c"},{"claim_cluster_id":"4e7d68ff-7bd2-4949-affb-c71a8a76240a","event_cluster_id":"5342c103-f887-4c11-8002-61b16e22dc39"},{"claim_cluster_id":"253fbf69-01a5-4352-a109-1aea0fdf1fe3","event_cluster_id":"dc0f2fc6-867e-476a-b8e1-8031edcf72a7"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"},{"claim_cluster_id":"7be2aab8-ebba-4a53-8dd8-2f99fbdc274c","event_cluster_id":"edeb68e2-0660-4461-9b92-dd0ab5f321a1"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"02b41fd0-8916-41c1-8494-482e3096f186"},{"claim_cluster_id":"471cd849-51ac-493f-a2b6-3965a7fc582c","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","event_cluster_id":"afa23bc4-1fbb-45ef-b64c-09dde901c8b3"},{"claim_cluster_id":"388dcf56-c13f-4ec5-bbc7-b3c71eaffd35","event_cluster_id":"8ea40711-b70a-408e-8b0e-c86a36b4d669"},{"claim_cluster_id":"7f94beb2-9a43-4280-9734-5045402a0714","event_cluster_id":"3662eaef-57cc-467f-a555-ca15b13b9be9"},{"claim_cluster_id":"4a4d472c-cd13-4ccf-9f30-e866d14bdbf8","event_cluster_id":"8d987874-4ebf-4fd4-b0c2-5cd72bf55264"},{"claim_cluster_id":"de60bb28-4ca7-441f-814b-f2ecfe29fb54","event_cluster_id":"c09d9041-f33e-4fbb-bb7b-4e43f4329c75"},{"claim_cluster_id":"f799549d-5869-4a73-bd0f-66e1fb2939bc","event_cluster_id":"d6692fd4-0be3-4dc0-8e52-422dc764cb03"},{"claim_cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"5a140171-9551-46fb-8eb7-bce434648b1a","event_cluster_id":"19904647-b456-48f0-bdd3-4c7803aa2b21"},{"claim_cluster_id":"800e7e36-7ce1-4e55-a18d-394d83673d71","event_cluster_id":"ab9082a7-9db5-4c59-ad04-1242dca4509b"},{"claim_cluster_id":"5cab19a1-9532-4ca5-8f94-e19c788f807b","event_cluster_id":"48f73ce8-5bb4-4ea5-acad-4966cfa816f8"},{"claim_cluster_id":"ff763739-26e3-4daa-93bc-7ecf065c5275","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","event_cluster_id":"7b48e171-a32e-4aa5-90bf-b37f44678964"},{"claim_cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","event_cluster_id":"0e7e5665-e1ba-44c9-b9e8-62d3501bb81c"},{"claim_cluster_id":"0450cb4c-8816-4bbd-85b6-ac94ecde9af4","event_cluster_id":"6a2d22fd-b7e4-46b8-aa28-69039af2d9e4"},{"claim_cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","event_cluster_id":"7b263d1a-e07c-48cc-bbc0-8a228f72f292"},{"claim_cluster_id":"7fbcd1a7-a676-46b6-a3c0-af823173a2b1","event_cluster_id":"83a91d6e-ceaf-4824-b195-eb7ebd584c9a"},{"claim_cluster_id":"a32303e6-4765-4335-9847-b5ee18494799","event_cluster_id":"7e78bb5c-524d-46ad-855f-72bd9413c27e"},{"claim_cluster_id":"f3b06230-c202-438a-8858-b8c55fa68828","event_cluster_id":"71435cc5-d65b-4e3e-9454-ffe0371a42f1"},{"claim_cluster_id":"8255a43f-82ec-4f1a-8f29-78e7a247a2d1","event_cluster_id":"c5bc8d69-1894-4720-8281-0a21bdbe0e98"},{"claim_cluster_id":"721fca95-63af-4a1d-bae5-70b55fce9a8b","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"86ef5628-f267-4ce6-97b4-2f06bd91a5fa","event_cluster_id":"ba62b16f-4f39-4172-b2c7-0b991499ca69"},{"claim_cluster_id":"b6c851f0-a597-49e8-982b-650d02a8ba55","event_cluster_id":"b9961616-57c0-4002-a439-bbd0acf2194c"},{"claim_cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","event_cluster_id":"4fb659e6-6366-4a40-9ae4-1332edb2d8b2"},{"claim_cluster_id":"5ab9d303-668f-48d9-893f-546437484767","event_cluster_id":"28019fcd-ae8c-42b5-8f8c-7fa226a5335a"},{"claim_cluster_id":"7b36df0c-5a40-406c-8572-3bb3871611ca","event_cluster_id":"ab73bace-5110-4ac5-b01b-8b28976f8120"},{"claim_cluster_id":"4af97b54-9617-48e3-8125-aa1e8e1ee8a2","event_cluster_id":"fd395743-8cf0-4953-ace0-85cff9e72be0"},{"claim_cluster_id":"5a787097-c657-4d02-a7e7-ce5ddfe404d6","event_cluster_id":"d74e9977-9a16-4baf-861a-98a8ddead66c"},{"claim_cluster_id":"15c2186e-db17-4b08-bbd9-d03072fa580d","event_cluster_id":"5db738fd-0af6-4d3f-8483-2d8b409e966d"},{"claim_cluster_id":"1010a45f-c4e6-41d3-ad44-9a27b9dc7893","event_cluster_id":"ea4dda18-9c10-4944-8540-e2c0066f573b"},{"claim_cluster_id":"1ff9104e-969b-469f-b204-88f04894d01f","event_cluster_id":"1dde6808-a5d8-4cff-a522-2b1380a746a4"},{"claim_cluster_id":"8e9cb96a-0ee8-44fc-9406-1bb5188864ec","event_cluster_id":"5f5241f6-dc62-4f74-8e2a-d9e564410ef8"},{"claim_cluster_id":"7553f34f-d61f-419e-8976-cecf89bafb0e","event_cluster_id":"1d910892-dde8-467f-8bc1-dac08ec78136"},{"claim_cluster_id":"c94810e3-5711-44bc-a55f-5ef59645cf78","event_cluster_id":"cd8387d2-f3fa-45cb-9628-ef16bef4b5fa"},{"claim_cluster_id":"58953090-5955-480d-95b2-311ed2c0f653","event_cluster_id":"6b8c1ab6-dc22-46f5-831a-de1a865875f0"},{"claim_cluster_id":"f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb","event_cluster_id":"d0bbd332-807a-43c4-8b16-bc8817897189"},{"claim_cluster_id":"b6e703fc-a44f-43d6-9db6-85666a802044","event_cluster_id":"9b88354d-eae6-4159-b5cd-4aa560c1a939"},{"claim_cluster_id":"7eb7c781-85c0-4773-8374-eeb7374b471d","event_cluster_id":"e424d11c-d0d7-4fab-ba10-6b37559e56f0"},{"claim_cluster_id":"ff3f6026-485f-4fce-9d57-b8206b8e11c5","event_cluster_id":"824a023b-59e7-46a7-a55c-6ef905c079b9"},{"claim_cluster_id":"64b43278-d723-4b63-bcf0-181e1a1658f9","event_cluster_id":"de1e5d6e-28d7-4405-8085-e6133787bf1e"},{"claim_cluster_id":"1e12b1a7-9bc4-4a98-b698-8392df483432","event_cluster_id":"95bc2531-eabc-48ae-aefe-417173f45673"},{"claim_cluster_id":"ea54647f-e4a4-46e7-bf16-66e30583a4a6","event_cluster_id":"a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"},{"claim_cluster_id":"5d4bd659-348a-4fe3-bacf-eb25b0043f94","event_cluster_id":"d1aa87f5-6e8b-45d2-89ab-5267e8136707"},{"claim_cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","event_cluster_id":"4df23607-a04c-40e8-be3f-b8d874dc3d06"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","event_cluster_id":"b9b5e870-c720-4c60-8d9c-ce6b4803fb78"},{"claim_cluster_id":"c3cd1557-129f-4369-b850-25bdf5456c16","event_cluster_id":"4abd438c-8dff-4f9a-8a7c-0da2a36edcc9"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"e82ed51a-4d19-4b2d-96bc-cb54f9b70858","event_cluster_id":"8a8f242c-8eef-4ca8-a157-47a2a04d8d4e"},{"claim_cluster_id":"89b27333-1443-478a-ae8d-2e32423dac3d","event_cluster_id":"fa5cbe37-2f0a-489e-a2bd-a58e7dfa8418"},{"claim_cluster_id":"c3383556-4a09-4d9a-b202-b1b017162bd3","event_cluster_id":"ad7f3e47-f7f2-4a5d-8168-7644c3de8a32"},{"claim_cluster_id":"da33c07b-485b-43b6-8165-46193fb1720d","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"bba9ba69-2957-4432-9f56-bcb77e8342e2","event_cluster_id":"fa579361-a6a5-42aa-a37b-78556d46e1d5"},{"claim_cluster_id":"4f2be876-d890-4fd4-a767-3f52bbc9c4c4","event_cluster_id":"e541bcb9-7f32-4df3-a682-0d185b753537"},{"claim_cluster_id":"fb6ff34e-94b0-4910-b613-9ebb9af0b6b6","event_cluster_id":"fa749b08-cff6-43ee-a52c-6c982c75d42a"},{"claim_cluster_id":"a7d1cc33-aa3a-4ee3-86f6-065986a716af","event_cluster_id":"8b1769db-6aae-4f31-8eca-13c7641a8a79"},{"claim_cluster_id":"f8cc40a9-e215-46da-bdf5-b5efc622bb40","event_cluster_id":"4c0dfd84-df3b-4660-9041-a635021908ef"},{"claim_cluster_id":"a55a36be-0edb-44d4-8400-10d53525802c","event_cluster_id":"104fb09e-1224-46b2-885e-348a5c279186"},{"claim_cluster_id":"f57f4c9e-1d41-4f34-b42f-aa11437d6812","event_cluster_id":"05de0fcd-b07f-4daf-b084-2e15c6be78b3"},{"claim_cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","event_cluster_id":"7681cbe0-1efe-4edf-b906-ebf02351325e"},{"claim_cluster_id":"c8416335-0a4e-4b5d-aa9e-40e533302d3c","event_cluster_id":"e4af0ca6-d383-4356-85a7-09352d68c2e9"},{"claim_cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","event_cluster_id":"f8e8b236-0393-4a1f-8e82-d30d9e30a2fb"},{"claim_cluster_id":"ff3f6026-485f-4fce-9d57-b8206b8e11c5","event_cluster_id":"8335c349-e4e7-4586-b3d0-516ccf0a3944"},{"claim_cluster_id":"db13aa73-f539-42d8-89d9-1af57cfff5a3","event_cluster_id":"266e7b13-78e4-4d47-a479-faf867ea0a51"},{"claim_cluster_id":"9e96a51d-6101-42af-b7a2-54e4dd5ae715","event_cluster_id":"dae41dee-2a76-4085-8c91-121f704580c1"},{"claim_cluster_id":"b2635760-bcd6-46c7-88fb-9bbbb7349033","event_cluster_id":"1e84c102-c60e-427e-9c32-95517ea67008"},{"claim_cluster_id":"00cfa90d-eff5-4498-89d6-85dadca46eb8","event_cluster_id":"e15ef239-9f26-4808-8bf7-31e94108dff6"},{"claim_cluster_id":"a6683ed0-4b78-4420-9494-296c3493439d","event_cluster_id":"21751149-a038-4fe4-a432-932902e5041b"},{"claim_cluster_id":"38711d17-ac82-464c-a077-7a82e0d362fd","event_cluster_id":"109d7869-80dc-4ec3-9550-208fe3c6f717"},{"claim_cluster_id":"4a575d85-5f97-4baa-be78-2c26ecefb471","event_cluster_id":"fcb27263-9c47-4749-8f07-d80ab25d503e"},{"claim_cluster_id":"f72eb4bb-112f-4556-a279-ad745cb4894c","event_cluster_id":"6773439f-27bf-46ee-884f-6f78667de502"},{"claim_cluster_id":"5528714b-b0b8-40d9-850a-99905744c056","event_cluster_id":"bb09aa05-ec64-4861-98cd-96845b502414"},{"claim_cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","event_cluster_id":"bc705731-4001-4b4a-a9bd-71359c405ab2"},{"claim_cluster_id":"544ac6da-d621-4fd5-bbf8-4a2cd6254e41","event_cluster_id":"8476cb8d-5c1a-489b-ac54-9099d01657db"},{"claim_cluster_id":"59e6bbb6-5982-4df0-b59c-33f07ce159f4","event_cluster_id":"adc5ea43-1ddd-4862-afc6-b17c270c9d83"},{"claim_cluster_id":"60ed7bd8-a38c-4b99-a08f-6210e30fac23","event_cluster_id":"b8c71793-7735-4b85-ba5a-b3e53e437f73"},{"claim_cluster_id":"93548381-56c4-4fb7-be49-43e644f447fb","event_cluster_id":"6c452c9f-8197-4d78-94e1-5bde1551953f"},{"claim_cluster_id":"7e9a80fa-c7f8-4eeb-8f62-09cee3732838","event_cluster_id":"37216476-5d5c-4faa-9d46-a9c7fd453ec4"},{"claim_cluster_id":"1be65d4d-c915-41d3-9d1c-864035425656","event_cluster_id":"e1f0a82d-250e-4472-bc8b-76e1029d4554"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"dd5d0634-bc30-45f9-b45a-97773c63db2a","event_cluster_id":"99e93b0d-aa99-4889-a4e7-3146b3109f12"},{"claim_cluster_id":"b654c64c-3acf-45f6-a6ea-c4584b8c70fe","event_cluster_id":"8d28e81a-99f1-4b51-9eec-891947b08d71"},{"claim_cluster_id":"9960f165-6141-4ca0-8dc4-0a136bfde83d","event_cluster_id":"a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"},{"claim_cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","event_cluster_id":"39719bfa-8761-4992-b42f-7b9ea44519ab"},{"claim_cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","event_cluster_id":"5cf0a8e1-26c0-4c2d-bf3f-608120510569"},{"claim_cluster_id":"06da14b8-536e-4d2e-83b1-118cfb44829b","event_cluster_id":"64e6dbae-d0db-43b2-acc6-29b1e94d9205"},{"claim_cluster_id":"54fa045c-bc33-4348-a964-82cb98ec67f5","event_cluster_id":"a6afbf41-e20a-4832-891c-6e8ecee24d06"},{"claim_cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","event_cluster_id":"1d9de982-6324-4241-9481-7618f52a1421"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"4cef0d90-5e3b-44f3-ba12-57b1ee19455a","event_cluster_id":"c555ba02-3f53-4880-89cc-6382472f4518"},{"claim_cluster_id":"be023ca2-f865-4811-854e-b40ab442412b","event_cluster_id":"18ed12f0-a6ed-4c61-bb56-179e38c03061"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"7640b35f-031b-4917-bf34-5555111a4a74"},{"claim_cluster_id":"abfcf3df-912d-43b6-968f-0f586e4e242c","event_cluster_id":"79d39e26-3c77-4ccb-be20-fd89e10bc54c"},{"claim_cluster_id":"8e873c15-6407-475e-841a-2dcbbce28e18","event_cluster_id":"6feeb810-f8d8-4337-b308-bbd0aa0c4221"},{"claim_cluster_id":"54a8d4bb-c88c-46df-a439-6be0dfcdce0d","event_cluster_id":"43152486-d4dd-4e19-b1d2-24534e09e32d"},{"claim_cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","event_cluster_id":"2ec09e70-73d9-4395-9c36-0dbcac034464"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"7206ac0e-b88d-4695-a9fd-a007b0fa396e"},{"claim_cluster_id":"bfa96159-d0c2-4735-8c1a-2d33b2346d24","event_cluster_id":"8bdd7aea-e82e-44ed-9306-49ba0cde454c"},{"claim_cluster_id":"924c4170-d405-438e-937c-13478012b72c","event_cluster_id":"79c33296-4152-4931-a84a-5c44d838a216"},{"claim_cluster_id":"c8265999-6e3a-4835-bb5a-9e081a27e9bd","event_cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163"},{"claim_cluster_id":"ed9c7f02-d3d7-4f88-92df-80c91b7dca98","event_cluster_id":"29477fdd-bbbe-4e39-b779-19de18778240"},{"claim_cluster_id":"1b36c1d4-6613-4a77-b192-f653249b73a3","event_cluster_id":"5c7b360c-c61a-4fc7-88f8-807bde4dcb6a"},{"claim_cluster_id":"cb7188de-21fe-4631-9d3e-697f1fa246b9","event_cluster_id":"211a5b9b-b352-4fd9-9450-827ad138f833"},{"claim_cluster_id":"6f473cd4-feae-4e71-a4f1-47b2820e799e","event_cluster_id":"1bdc4e39-4f85-4244-acae-0889a6b1bb01"},{"claim_cluster_id":"577be512-045b-4f32-8688-400d686a100d","event_cluster_id":"01eb8b8e-096c-4892-bc91-ee4788a133cc"},{"claim_cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","event_cluster_id":"80a8792f-9489-40e4-a0a2-e1e4173e1957"},{"claim_cluster_id":"f636e358-668e-41dd-bffc-037f53b4ab48","event_cluster_id":"845395ad-4701-4574-ae25-f53da9fca0d2"},{"claim_cluster_id":"13a07f14-45d6-4b31-8d23-23b540ac8090","event_cluster_id":"4ea15f73-7350-4e50-b190-6edec6cdfa32"},{"claim_cluster_id":"9367c0e9-bbdd-4398-9de3-210a1f73c88e","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","event_cluster_id":"80a8b2f6-3818-4f88-87e9-d88c26c8754c"},{"claim_cluster_id":"8c18859c-7432-4cc4-af8f-8a5eb220876e","event_cluster_id":"29ce98a7-4a68-4b4f-be7a-d7b325128299"},{"claim_cluster_id":"bbefdcbd-8560-44a4-b45a-d11652dfe311","event_cluster_id":"84cbf3d1-afbc-4ba1-8495-8ff7aee7e81f"},{"claim_cluster_id":"253e1524-e402-4a4d-b7db-f94b8f989d9c","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"53bc38bf-651d-46ea-8aaf-f63f52195a45","event_cluster_id":"7c123398-3043-4df1-bb86-5ded4584dc33"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"65ac3d2f-1144-42ab-9435-1522b78a54a3"},{"claim_cluster_id":"1b5c8541-b848-4f05-865e-43826009d4e7","event_cluster_id":"4b8668b9-ec8e-41f1-b42b-e53f7eac0641"},{"claim_cluster_id":"3232bd90-9251-47f0-ae93-ae2d51218354","event_cluster_id":"c89da02e-a1bc-4522-a452-82abf8c705c4"},{"claim_cluster_id":"e0a99d28-f3a4-477a-b874-8d839c4523f9","event_cluster_id":"674305e3-342c-4b85-8170-13a2aefe9456"},{"claim_cluster_id":"d3913637-42d6-426c-8654-a13850b8306c","event_cluster_id":"e281f767-6c47-4711-ad9a-1c5709e1cb60"},{"claim_cluster_id":"838e6a9b-36b6-4be2-87e8-cb3d0595dcf6","event_cluster_id":"fc33211b-6f76-4ea3-8d05-51362bd964b0"},{"claim_cluster_id":"cc37a7b6-46fd-4cda-8faf-63a00cd3c131","event_cluster_id":"331d66f6-8c23-4632-b4ad-7949a81b62cc"},{"claim_cluster_id":"043e7562-9880-4d36-ba06-fd8e6b3afbe1","event_cluster_id":"eff030fc-3925-4754-bd4e-8589b262523a"},{"claim_cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","event_cluster_id":"1da0b887-e497-4790-9c97-6324fa7f1453"},{"claim_cluster_id":"d97f4faa-5b32-4a18-93ac-69c340df4581","event_cluster_id":"90dfa891-ea54-44ec-9c4c-37a32cc92299"},{"claim_cluster_id":"5f9b6057-0fab-4c3c-b1af-a7c26bc6c692","event_cluster_id":"194f810d-af4b-491d-bdf7-3aad4b9c5e55"},{"claim_cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","event_cluster_id":"85c8c155-84b6-47ef-ae7a-060440258d20"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"e8e474c4-3709-41ab-99a8-21deaa3d6742"},{"claim_cluster_id":"f4cd4d9b-6b2b-454a-ae24-3a0150790009","event_cluster_id":"59ccfd51-c23c-4ddd-9244-d1ca28b0c8b8"},{"claim_cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","event_cluster_id":"82f5beda-b460-413d-ba52-232c56bac459"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"444e2d84-e3c4-4a82-a2fc-3577e6124f09","event_cluster_id":"d4eb4c1f-a715-4507-898e-b25f61a6667b"},{"claim_cluster_id":"94f243ab-1521-4874-b5fc-b80847a7fefc","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"2f4149f0-f4a5-4695-86fa-9ea760cb8651","event_cluster_id":"d114caf2-8385-480a-a600-9c4b33ae3a55"},{"claim_cluster_id":"783f85bb-dceb-450a-9a34-4a650e18ed9f","event_cluster_id":"45dc7d2c-74e1-4100-9b06-cc0f631f56f5"},{"claim_cluster_id":"e7a1e23f-832f-432a-ad19-207015a794b2","event_cluster_id":"f5c0430d-6c19-4e4b-815d-7de708ba52a8"},{"claim_cluster_id":"018f6f1c-b2e7-43ca-a443-3a5d27b5033c","event_cluster_id":"584c4eba-f170-4492-9acd-c1773318790d"},{"claim_cluster_id":"4b605940-f896-4b59-bf12-36fbeec83b94","event_cluster_id":"141e6842-296d-43da-b53a-06cadf04679a"},{"claim_cluster_id":"de7b2349-3e46-436f-9b75-c57089eeaa3c","event_cluster_id":"e6396265-e4ff-4b5b-8b50-46f16a8b1b5b"},{"claim_cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","event_cluster_id":"e7125b37-2f58-44dc-935e-482a2f26ca14"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"66420625-d310-4fd9-aca9-82e4fec83c68"},{"claim_cluster_id":"74bc9e46-31ab-4e9e-9240-87a035b90601","event_cluster_id":"98e6d6ef-a2d4-4de1-80f2-7297b807d073"},{"claim_cluster_id":"7ff438ec-b701-48aa-b613-4bfeaba7bcce","event_cluster_id":"9fea69be-9aad-4b8b-aca6-7960741c46ec"},{"claim_cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","event_cluster_id":"0e1e3fbc-262d-409a-9734-949f40c46427"},{"claim_cluster_id":"d29a2d68-5d53-4ad3-9792-37db5375f45d","event_cluster_id":"4a433aaf-8b78-4d61-9c2c-bc9bf2bfa734"},{"claim_cluster_id":"ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8","event_cluster_id":"42b243b1-6e2f-4145-911d-1a4fb97435e4"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"7462b6fe-d6f4-4e65-ac8e-8fa4c8e00ce3"},{"claim_cluster_id":"02f58db8-b951-46f8-9ff7-76980a66fc66","event_cluster_id":"9fea69be-9aad-4b8b-aca6-7960741c46ec"},{"claim_cluster_id":"dc3308e5-2250-431f-bef6-733e2b943275","event_cluster_id":"8ab5907a-7d78-4873-b326-304fe58b10f8"},{"claim_cluster_id":"b407290e-0e65-4bff-90dc-c2ececfb37ab","event_cluster_id":"ac7642b8-b25c-45db-8998-1d3c7f1c25e7"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c"},{"claim_cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","event_cluster_id":"c9b1317b-d9b8-4f19-b568-8b833e155fb5"},{"claim_cluster_id":"4ada70f8-8bb6-4995-8f14-e79e769b0629","event_cluster_id":"aa931a1c-d292-40d9-9c54-451d60524b03"},{"claim_cluster_id":"71084441-cc44-4209-84ff-0b19201dd17c","event_cluster_id":"d7d8a2ba-6242-4963-a3f8-0e40fd7043dd"},{"claim_cluster_id":"041ca325-747b-4d3c-b3c4-9ee7fabc37db","event_cluster_id":"c829d647-4388-40da-86fd-479a810865ab"},{"claim_cluster_id":"1dae585e-f051-41dc-8fc8-c2d3e3b3b884","event_cluster_id":"760769b6-c063-42c2-8199-157a1d623f27"},{"claim_cluster_id":"f80dd275-a1a9-4cb7-becc-0fe298aae99d","event_cluster_id":"7aa12e18-818d-4e83-947b-42a4e69ce8db"},{"claim_cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","event_cluster_id":"8a462401-6f97-42ba-a69e-60e2ceb6f0ac"},{"claim_cluster_id":"897e2456-ff2b-43b5-9a48-23b6c36b2d95","event_cluster_id":"f9e6216a-ee1c-443b-8198-daf20f932faa"},{"claim_cluster_id":"8db7f2ee-28e7-4abd-b214-9d334508a075","event_cluster_id":"e6007b6f-2ba5-4830-8564-f98f1943ec9d"},{"claim_cluster_id":"a6683ed0-4b78-4420-9494-296c3493439d","event_cluster_id":"b929e356-d8ff-49f7-a4f5-c02953cef416"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"da7d71b1-1db7-40cb-a127-20a20d4dc377"},{"claim_cluster_id":"b331f46e-c31d-4c56-81c9-c40834960e1f","event_cluster_id":"4c3966c5-0cc9-4924-906d-113f0618534f"},{"claim_cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","event_cluster_id":"6fe0709b-66c5-4553-a6ae-89bdc6df31fc"},{"claim_cluster_id":"325111bb-e15c-4f08-a4a4-3f81e99d9f35","event_cluster_id":"205d2c16-9ba3-4e14-887c-3331a1f50616"},{"claim_cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","event_cluster_id":"88cb9dbf-3c86-496b-8c5d-43080d758d2a"},{"claim_cluster_id":"0261ee84-1c1e-4042-9226-f1085216eef2","event_cluster_id":"87bd589d-2421-4528-b337-18cde30c4d49"},{"claim_cluster_id":"6d226b20-d54f-48d2-bd7d-2616184afc68","event_cluster_id":"88c327f9-75c2-480a-8aa8-272d021cabe8"},{"claim_cluster_id":"b65267b2-a6b3-4938-aff4-8dde024d5b46","event_cluster_id":"ae3d775b-868a-48c9-b712-67b58ccbee8a"},{"claim_cluster_id":"3dcf8216-5e70-4cd4-962e-dc4b036a0071","event_cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638"},{"claim_cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","event_cluster_id":"b03907b4-379e-44df-a2b4-6f069b3d131a"},{"claim_cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","event_cluster_id":"efefa709-c6f7-4ec6-ac92-9ac520723e87"},{"claim_cluster_id":"ab829976-d7fb-4b30-9b92-89eed4e94cc4","event_cluster_id":"fece93a1-7734-48a4-99b6-9dce302454b2"},{"claim_cluster_id":"e9280ed1-20ec-4c75-8468-086e8c6749dc","event_cluster_id":"3e86f418-a7c7-46c6-9106-86fe0b88ffdf"},{"claim_cluster_id":"099e4f99-da99-4f13-a242-dd05de802ab3","event_cluster_id":"9876318f-24a7-47a3-a0cc-61a7ad5d114e"},{"claim_cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","event_cluster_id":"42dcf3d9-1011-484c-9355-4db97109e640"},{"claim_cluster_id":"a1593cbe-8c39-423f-abae-2707e84a1e5e","event_cluster_id":"29c87b68-66f6-4218-b4fc-f6324d0ab7c7"},{"claim_cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"fd3ca8c5-bfa9-4e66-bc57-721306073eb0","event_cluster_id":"b85f1177-adf6-443e-8aa8-4b882389f698"},{"claim_cluster_id":"799387af-65e2-4baa-bed7-0f025e3fbc39","event_cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b"},{"claim_cluster_id":"035bc55a-3ae4-48b4-942f-bbef3d308147","event_cluster_id":"6964b660-5818-4d1d-be3a-055b02c10ee5"},{"claim_cluster_id":"e2d7dae8-0d86-4de0-93de-0fca88fdbecd","event_cluster_id":"b0d55664-d514-4b2b-87ec-b7bb14627d05"},{"claim_cluster_id":"51b16b2e-6404-4d18-a4d1-46e0d25d726f","event_cluster_id":"9f0b5b9d-5ada-4603-b28a-01eb2e4517b2"},{"claim_cluster_id":"5aec5e12-6df7-45c2-ae07-2921310e080b","event_cluster_id":"eb540b94-f26f-4993-9d85-8c7b5fc26cca"},{"claim_cluster_id":"27b386d8-58df-4b19-a269-36bb2400c94c","event_cluster_id":"2db0c2dd-c8a4-4511-9c67-695e43307f50"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"facc7561-4a20-4459-a43c-a6df1f7f9d23"},{"claim_cluster_id":"2c49dd92-a97e-4b1e-bac2-607670a0a86d","event_cluster_id":"25676d7b-137f-4f70-b3ce-39af6bc7a4fe"},{"claim_cluster_id":"9f69b38a-0ed5-48e5-ac15-7f5ccfedc99f","event_cluster_id":"fd5e9a15-8177-47a6-9a10-ec03f47d5abf"},{"claim_cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","event_cluster_id":"baaee7cd-473c-4323-bdcb-32b41e2930f2"},{"claim_cluster_id":"9bab62f9-a196-4e9b-9809-8d8f41f0576f","event_cluster_id":"f74167b8-6b2e-4397-aea5-ad26ae737cc7"},{"claim_cluster_id":"489e26fc-76fe-4cad-b09b-b941f099b2bd","event_cluster_id":"bf6df861-08b0-407b-91a8-c65beb04c1ff"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"a44bb3c4-918e-4230-8542-c0aebafed121","event_cluster_id":"afa23bc4-1fbb-45ef-b64c-09dde901c8b3"},{"claim_cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","event_cluster_id":"2e94c160-31a6-438f-bf81-0a00ecfb6a2d"},{"claim_cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","event_cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c"},{"claim_cluster_id":"4b37762b-26f0-4956-9d1d-e433973602e1","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","event_cluster_id":"202dbce4-7e5d-444f-8048-9175eb593dea"},{"claim_cluster_id":"ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6","event_cluster_id":"83c9bf38-7be3-4a58-9128-bac3dda66b3d"},{"claim_cluster_id":"af503db6-fcf4-45f9-9501-f2732e2af4f7","event_cluster_id":"c42e5196-2b49-45c0-931e-85ce5682f952"},{"claim_cluster_id":"0ee142b2-6805-43f4-b8d5-34f76c2c799e","event_cluster_id":"bad03c04-e50b-426c-824a-ff2c1f2c20d8"},{"claim_cluster_id":"83176725-df79-43f8-b571-b45c6b2dea8f","event_cluster_id":"cf5c8ab9-6f4a-4ef6-84b1-7fb025d62c2c"},{"claim_cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","event_cluster_id":"680ddc35-25cd-424c-8914-0f7a5b222416"},{"claim_cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","event_cluster_id":"83cb9288-d8bc-4d51-803b-71e04c61fa41"},{"claim_cluster_id":"7e29e69f-6e9a-409e-8641-59692b521453","event_cluster_id":"c9514ac7-3548-4b00-95a5-e99c305bf95a"},{"claim_cluster_id":"9dbb0955-d2fa-4dce-a46f-5ed43c9e3231","event_cluster_id":"bf9781df-d8bf-4191-9d37-d31cf97d37ae"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"7138b959-d146-418c-bd39-6ecd7cfec079"},{"claim_cluster_id":"234be4d1-d0d0-4b65-aa97-a8cd91a0a32e","event_cluster_id":"1e3f8e4e-4dfb-43fa-ad30-aa52542d5f06"},{"claim_cluster_id":"73e672aa-47a1-430b-843b-82f236a93650","event_cluster_id":"b4051cdc-a4f2-410e-b138-2b773f319a22"},{"claim_cluster_id":"bee4d72b-b159-4b6c-830c-362b42a2b18d","event_cluster_id":"10a6dfe0-81d0-453e-9f23-e9792fa39675"},{"claim_cluster_id":"aa95c9e4-8d02-4bc6-90e1-de547f4e4e60","event_cluster_id":"418a7cf7-657b-41b9-9359-c34faf7618d7"},{"claim_cluster_id":"02e7a900-bce3-4812-8137-1246791846bb","event_cluster_id":"9851f4a3-d2c8-418c-ab69-0b58a9726253"},{"claim_cluster_id":"1574223b-5ec0-4588-8996-6510aa3052d6","event_cluster_id":"dafa634a-37de-4d53-8bbc-fae67a8455d0"},{"claim_cluster_id":"fe25e7ff-abc9-4e8c-bafa-dc9163738c4e","event_cluster_id":"876a2333-137a-4c81-9d16-99847f2af4cc"},{"claim_cluster_id":"5f2c5e5a-f6ae-4d50-91e8-eee0bd665636","event_cluster_id":"d878f267-808b-4a23-9202-10d08ee3053d"},{"claim_cluster_id":"127c457b-8cad-4a81-8d25-66dd51786fe0","event_cluster_id":"2e675266-c3ed-4fac-a036-217c24ac28e2"},{"claim_cluster_id":"30d2edfa-6d58-40ae-bac6-ec1273c415ac","event_cluster_id":"c5023c65-de59-493d-807d-e173da07457d"},{"claim_cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","event_cluster_id":"65c273a5-7b4a-439b-abf8-ac2e7eea9f97"},{"claim_cluster_id":"daf13a88-450f-40a7-bca6-ccfb46ede159","event_cluster_id":"117ab6df-7ea4-4ab9-806f-9ec47da0be63"},{"claim_cluster_id":"f4cd4d9b-6b2b-454a-ae24-3a0150790009","event_cluster_id":"171d785c-3288-4a8a-90f1-9e6a8e012955"},{"claim_cluster_id":"b12e5d28-73fe-498d-a612-a3df5aa876b3","event_cluster_id":"6351b28b-a685-4d75-9a62-c954df9226b0"},{"claim_cluster_id":"da70552d-1a69-4dd8-bc9d-ca358f3caefe","event_cluster_id":"454d2297-ce2d-4682-8c48-dff1e1ee7f18"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"f96ee044-12e8-41d9-ad21-d1cd5c1012f8"},{"claim_cluster_id":"30d2edfa-6d58-40ae-bac6-ec1273c415ac","event_cluster_id":"5456cf3b-8248-49e5-a577-e64c3c57ab9a"},{"claim_cluster_id":"ae1e52fc-461a-4609-8b02-2589611c162e","event_cluster_id":"305d4d39-012b-4cce-bd6f-017ddf94a842"},{"claim_cluster_id":"d3913637-42d6-426c-8654-a13850b8306c","event_cluster_id":"13d62766-9dfb-443f-a0be-897b64b65358"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","event_cluster_id":"15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c"},{"claim_cluster_id":"4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9","event_cluster_id":"a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a"},{"claim_cluster_id":"d2f81fce-8c92-45e8-8294-41af7752f1db","event_cluster_id":"450543ae-8630-4e48-a375-9699e4cb6925"},{"claim_cluster_id":"87b92fb4-b0e3-4b01-9c2e-cfd9469245f7","event_cluster_id":"c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"},{"claim_cluster_id":"997de204-d7ea-4e15-b208-ebc2bd4ddd62","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"fcbed875-f592-4e43-93ba-c1c4ead8d38a","event_cluster_id":"87def324-7a40-461a-a80b-cc6aa7391757"},{"claim_cluster_id":"2247b006-05c5-406e-a6b2-d87e6eb59702","event_cluster_id":"ee8407f3-3b78-41fa-b305-9976663fec3b"},{"claim_cluster_id":"5a77fa7e-06f0-487a-a93b-f15e590aa54a","event_cluster_id":"4f84ccb5-4935-4023-8826-9c08d0da261a"},{"claim_cluster_id":"ff42e3e5-bb75-45af-be07-89d36dae0d5c","event_cluster_id":"4d4e63b8-def5-48d6-a4f3-534d39e0e25e"},{"claim_cluster_id":"bfd9a248-bf68-4994-8af5-882efd424687","event_cluster_id":"db5c7092-c228-4319-b130-e75471c29ec0"},{"claim_cluster_id":"d3037252-9ff2-4032-ae65-41b104560fbd","event_cluster_id":"f4f2acc7-50ed-478a-a3c8-fd8ce6afe67c"},{"claim_cluster_id":"e28e105a-739c-4f5f-8b79-8f56f435e121","event_cluster_id":"af8cdf46-4050-4634-a0b0-6bc6cfa78956"},{"claim_cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","event_cluster_id":"8aaf61a8-4245-40d4-9036-3767a2a55c98"},{"claim_cluster_id":"9971c68f-8d21-4436-a5d3-4897996181e7","event_cluster_id":"c700d9cd-e09d-4ea7-a33c-b8925d591d85"},{"claim_cluster_id":"255ea174-3e00-4506-8a6d-78f62eccfecc","event_cluster_id":"80b2ece5-7d1f-4503-86fb-dde80c97bee5"},{"claim_cluster_id":"658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8","event_cluster_id":"3eb68d57-7c14-4dd1-91dd-ff18ff1740e4"},{"claim_cluster_id":"23bbf046-846b-4885-b881-e84d2ca9060e","event_cluster_id":"88ef71b9-0470-4f94-b8a3-c2845e2f29e8"},{"claim_cluster_id":"3d44d914-cf73-4d8b-b531-5db2be83da48","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"11c93b57-586c-4cef-a254-66245b297aca","event_cluster_id":"72702a81-27ae-49f8-9ece-b45b8795d927"},{"claim_cluster_id":"f55fbefe-4ee7-4bc9-a05f-0bee3b933ccd","event_cluster_id":"6dc5280e-6875-44c0-adc9-079542d2d0b2"},{"claim_cluster_id":"12f1ab8f-20c6-41db-928a-d52afb8bd227","event_cluster_id":"71f8bf24-6193-4f81-97b9-208284481b4e"},{"claim_cluster_id":"ddbc1aa3-6d67-4148-96a1-e149d5d02260","event_cluster_id":"aba53f75-eaf6-4231-90b0-0d2dbfd627ce"},{"claim_cluster_id":"74381468-96fe-4ea3-b795-41362208378c","event_cluster_id":"65022a70-336c-4701-8443-508f49365fb4"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"28df4744-3bf2-4a43-80dc-d2bea8f7af7a"},{"claim_cluster_id":"3d9f2bb4-f1d6-41ac-be1a-ac1194130144","event_cluster_id":"17d2f659-e46b-4a1d-9fcb-605a5ebf0a54"},{"claim_cluster_id":"64de7b14-ea9c-48fe-a9a0-a30f01aecc3e","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"09a92b68-8f29-435d-b853-f4c47f64d9da","event_cluster_id":"d2fe7e4c-e188-41bf-8d04-054692838ea8"},{"claim_cluster_id":"89360ae3-18fa-43f0-bd2a-417e02e051c5","event_cluster_id":"cac0be30-203f-425a-ae61-9f6f21636075"},{"claim_cluster_id":"9ffb85b8-5080-4f27-85ad-554406cf7402","event_cluster_id":"2bfeada4-b9e0-40b4-9be2-0655b8d49226"},{"claim_cluster_id":"7781df4b-26ca-4879-a33c-cb83ade5ffa4","event_cluster_id":"30eca979-1f98-4971-a1fe-07481584311b"},{"claim_cluster_id":"d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a","event_cluster_id":"39c57d47-c79f-4298-b9b0-1dca0020b6aa"},{"claim_cluster_id":"837dbefb-7b54-4aa1-aad3-56f0ea97f9ed","event_cluster_id":"8e7cadbd-1c4e-497d-b941-1d05a2c467a3"},{"claim_cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","event_cluster_id":"9a62af93-7112-41ed-b195-640caabb9cb6"},{"claim_cluster_id":"fefd3acb-14d6-4c0d-ac4a-19da8e48bc75","event_cluster_id":"a1ca414a-357f-429e-a9a5-5290a87bd233"},{"claim_cluster_id":"9960f165-6141-4ca0-8dc4-0a136bfde83d","event_cluster_id":"37386c6e-8d47-43fa-9d2e-223bce8f6923"},{"claim_cluster_id":"5cd897af-cb8c-4335-a548-c9963c43f060","event_cluster_id":"16bacf34-8f6f-4fd6-ad3c-f7fed8660b38"},{"claim_cluster_id":"69638d1f-f33d-45d8-beac-6ee7ce61ea29","event_cluster_id":"550b12e3-691c-45b5-8cb2-986a272d3a0f"},{"claim_cluster_id":"b6dd34fe-58a4-4775-be96-ca839f926747","event_cluster_id":"48edb9b3-6de4-47d0-956e-e07e3a6cbfda"},{"claim_cluster_id":"5b935620-b425-4241-8333-a51c2e077394","event_cluster_id":"80e1112c-9669-4621-a0a1-38f35b5f11c3"},{"claim_cluster_id":"69315435-638a-4ef2-abe8-1d91d23ff51a","event_cluster_id":"1d0959a8-981b-4a23-90dc-2a9d7c7c079f"},{"claim_cluster_id":"eb68c709-6220-48fe-b376-95a4f6f10b6d","event_cluster_id":"77ada2fd-a5b1-4d46-9fd3-0fa7022914dd"},{"claim_cluster_id":"fce90f87-0664-4b8a-bb4f-dc7bbf08cf50","event_cluster_id":"128219b8-57d3-4f9e-bdf1-0447f6eb1ba5"},{"claim_cluster_id":"908a4168-b322-4057-a44b-a100dbffbe53","event_cluster_id":"7cf0c1a9-abc0-4370-b846-45ce5ff4c375"},{"claim_cluster_id":"8d06f8b9-e6ed-4b99-89ef-90434792b924","event_cluster_id":"ddcbcb82-918f-4d21-a3ab-fc58bc049dc2"},{"claim_cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","event_cluster_id":"9fb5a955-823a-4864-b411-b2e83454581e"},{"claim_cluster_id":"13ce1de8-c90f-43f4-ae08-251f1aed012e","event_cluster_id":"782b5668-5ef8-4d83-a8fc-b6464fbee289"},{"claim_cluster_id":"0c265597-6c2b-4efe-9acb-799f67a3b4d1","event_cluster_id":"1501c95d-fe6f-4129-965a-ccb56abb7afe"},{"claim_cluster_id":"c9b6b0e3-811d-4e56-9eba-3408eb1dc06f","event_cluster_id":"080cf60d-e4c8-43d3-806b-a47256c29458"},{"claim_cluster_id":"d89e632e-b2af-4331-9344-c7d1e373d49b","event_cluster_id":"4e1dd449-7872-4183-a210-7ea0e51bbd11"},{"claim_cluster_id":"aaf76232-aab7-40b7-8e1a-16d6b39c4f6b","event_cluster_id":"8b28dee8-f25f-4ea3-a58f-094086b4ac36"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"82015ed8-be97-4f9a-940c-6061a2380bc1"},{"claim_cluster_id":"2dc250b5-58d8-4c44-80d2-2c17640ea117","event_cluster_id":"3f3f44f3-8e86-41c0-a601-c57bd1d46cd6"},{"claim_cluster_id":"93459608-ccd3-4b8a-af7b-ede8b22e8c94","event_cluster_id":"6907e408-863f-4c1c-90bf-e1763a1c2ab8"},{"claim_cluster_id":"4a277b87-4d75-4b75-9416-adcbd06c3a69","event_cluster_id":"4097f204-b4ae-4826-85fe-e2f03051cdcf"},{"claim_cluster_id":"01c08614-0081-4fbf-86e8-a41b845bc4f5","event_cluster_id":"336f0b3b-fcc5-4691-826e-c234e38bf923"},{"claim_cluster_id":"1713cb4d-ab0f-4257-a2cb-4aec01e411ef","event_cluster_id":"c770384d-399a-4efc-a9de-06d7ca1ea0d3"},{"claim_cluster_id":"f5798794-c4ea-4a9f-ad2e-0bf496c0ed12","event_cluster_id":"c52411eb-2b24-4b6d-9936-f82ca57ebb56"},{"claim_cluster_id":"0c265597-6c2b-4efe-9acb-799f67a3b4d1","event_cluster_id":"961d386d-4d5b-4009-a39c-fb6d1a441cf5"},{"claim_cluster_id":"b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10","event_cluster_id":"47f7a131-6ce1-4e01-b64c-61e5f9696bb1"},{"claim_cluster_id":"243cbf96-dba8-41a3-9dc7-8def431d23c9","event_cluster_id":"d82f7ea1-b85f-4ff3-af04-e3f09ca89458"},{"claim_cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","event_cluster_id":"0b355c81-92f1-4102-a729-a2af4b606bfe"},{"claim_cluster_id":"b5432b8d-5ac9-4f60-8977-fdbcdae395a3","event_cluster_id":"0b6b6a97-32f4-45c7-ada1-27e50504dcb5"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"dafa634a-37de-4d53-8bbc-fae67a8455d0"},{"claim_cluster_id":"162f021a-53e9-4f3d-9231-108223f18e9b","event_cluster_id":"81cdaaf8-571d-4a77-8063-fa5e9510b635"},{"claim_cluster_id":"cfad4c19-24e9-4d54-8d59-d0b08718729b","event_cluster_id":"7ea6c0c9-c370-4e5d-93ff-344450b01dd4"},{"claim_cluster_id":"29fe240a-81f6-4aef-a8b5-3cacf3e3985a","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"bc56200e-afec-40d7-a87d-167e90733913","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"04c040d8-393f-4b27-af55-1f60d7802605","event_cluster_id":"22c6704f-881c-4e99-abe5-258852387852"},{"claim_cluster_id":"b26a4469-2931-4dab-aa78-be1b6fba8a36","event_cluster_id":"e3e5aa95-d1ae-4cc4-a1f6-993b699c2d34"},{"claim_cluster_id":"94f243ab-1521-4874-b5fc-b80847a7fefc","event_cluster_id":"e4be2259-ba51-439d-9935-9584c06ee048"},{"claim_cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","event_cluster_id":"214ffe56-f58d-4fdd-a3cd-ef399506aa9a"},{"claim_cluster_id":"ba6f293a-cb12-4697-ba51-b7964934f25d","event_cluster_id":"4c79fc69-3bd0-4180-9718-8d85b8c9dd85"},{"claim_cluster_id":"928cf7ca-8343-47ca-be27-378bc29b7fbe","event_cluster_id":"45429530-4dcd-414e-8a37-8555d0144899"},{"claim_cluster_id":"325111bb-e15c-4f08-a4a4-3f81e99d9f35","event_cluster_id":"8d547757-303e-43b6-9192-6b5dc2fd34da"},{"claim_cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","event_cluster_id":"471ac06a-ad1e-40a8-b238-859f31d2504b"},{"claim_cluster_id":"9bdb548d-7392-42e2-81f0-dc3db0c2af7a","event_cluster_id":"c9427285-3555-4de5-97c9-22592d01516f"},{"claim_cluster_id":"5e767ae7-5475-4d58-9919-b74b88492c8d","event_cluster_id":"f3090987-9e96-4cf1-95d6-22fba3e8d946"},{"claim_cluster_id":"834f4385-ef2b-4b12-81b1-8e94ff3098e8","event_cluster_id":"cca26850-c71b-4446-90d7-2e4d88b1223b"},{"claim_cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"f0bf7f4c-0a27-4681-9eca-ea221b9315a7","event_cluster_id":"2b56b1f6-1627-44ab-9460-b13751cf087b"},{"claim_cluster_id":"2616e42a-b0ac-42ff-93a5-2376cee42b92","event_cluster_id":"f6f61810-826e-4932-a627-c61739848c9f"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"208620ac-11d0-4163-9345-03d59e805961"},{"claim_cluster_id":"4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8","event_cluster_id":"ad9b8529-0422-40dc-8b6b-9a712020027f"},{"claim_cluster_id":"c8956774-b873-4e48-aca4-1d4ce1428a6f","event_cluster_id":"65d8f691-42a2-4903-8a08-db7d149c26b1"},{"claim_cluster_id":"d30cdd9d-92e1-44ac-aad9-845702e1559f","event_cluster_id":"902b6a60-6994-4d2f-a5c9-4b6398d8e8c1"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"c124b047-b324-4618-8299-a88ecac6f400"},{"claim_cluster_id":"468c9eea-e420-4271-9b73-0e2e747f6185","event_cluster_id":"273cff70-66df-48dd-9efa-69156787ee64"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"876fd136-352b-46eb-aeb5-3fca6402213f"},{"claim_cluster_id":"e045b8f3-c755-4ad1-91b0-a0b8f7878680","event_cluster_id":"0a1dc802-b4ef-42f0-aba6-299883ef023b"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"7633550e-7afa-4184-8ac2-7603de1beef0"},{"claim_cluster_id":"b11a9565-86ce-4b37-aea3-07e84e21fa4a","event_cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63"},{"claim_cluster_id":"11f5ada1-39d8-46a5-b3e1-ae12a04328c2","event_cluster_id":"84f2b012-a880-401d-86eb-78a247c92358"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"1dffb0dc-1f11-4a52-8601-13d552598542"},{"claim_cluster_id":"12dfa7c9-8817-4f21-ad00-1e4244142b34","event_cluster_id":"ec52d818-47ba-4361-9b9e-62d7a7a87109"},{"claim_cluster_id":"d08db747-1994-456e-82f1-cca372892842","event_cluster_id":"3ca85742-8366-4a09-815d-244dcb1111f9"},{"claim_cluster_id":"1e9d6c21-797f-4483-9122-2e9582f833c2","event_cluster_id":"1737c28c-8f31-4855-8951-9dd1dd0b8606"},{"claim_cluster_id":"76e8427a-4f65-4a81-bf8d-354e00b7198e","event_cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046"},{"claim_cluster_id":"f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f","event_cluster_id":"6f2fde83-d0f8-429a-88dd-e73036fda6d0"},{"claim_cluster_id":"449f7a4c-3966-4db6-9cf4-d39a2f15feae","event_cluster_id":"5d61ec99-0639-4eaa-b6c6-d29d8645a85f"},{"claim_cluster_id":"cd2c9191-f97a-49fd-9d7d-f0744cdaaf72","event_cluster_id":"2d30ef5f-ee97-4df3-a64c-5e181a81321a"},{"claim_cluster_id":"daf13a88-450f-40a7-bca6-ccfb46ede159","event_cluster_id":"52a6626f-4f02-4c13-bf77-4f58640d6881"},{"claim_cluster_id":"a3cc8d63-1533-4239-bc6b-bedcff828ef9","event_cluster_id":"690e2bf8-3db0-482f-a93c-22f6a0d56631"},{"claim_cluster_id":"5317331a-d0a9-4595-acad-210a92b278d8","event_cluster_id":"43fa0350-2309-4b93-bd2a-6e8c4a716e73"},{"claim_cluster_id":"0ecc8673-156d-41da-a0bd-8ceb3bd503b8","event_cluster_id":"d5e18b03-3515-471f-a4d6-448fbfbfb257"},{"claim_cluster_id":"17b4175b-7c9e-4cac-8f06-6d2c5a65e803","event_cluster_id":"5ccfc9e2-21fe-49eb-816b-e5684332d360"},{"claim_cluster_id":"5a50a1fe-c68d-46bc-b14a-9fe07afb2e36","event_cluster_id":"c442364e-9f75-4af3-92da-fc9202b13019"},{"claim_cluster_id":"18699af2-76ba-4b44-8dd8-cbb2b538e559","event_cluster_id":"605679a7-417f-419b-b13a-f72296af0a8c"},{"claim_cluster_id":"75739be5-4b25-48e8-8d9d-d6319de6bd95","event_cluster_id":"3b24d20e-ac52-4f56-955a-33bcfd5102a2"},{"claim_cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"954a4240-7358-4649-966c-6f08bf5b088e","event_cluster_id":"8e28231d-7117-46be-8655-ac03e3ec9b13"},{"claim_cluster_id":"a01e0915-a285-410d-9d1b-ce9544139c90","event_cluster_id":"58af047e-cbeb-4069-98f9-896633d3674d"},{"claim_cluster_id":"a0016e91-a98c-4dd9-8feb-b0afadf02f44","event_cluster_id":"c006df76-d7ed-4672-b415-893f6c8476b6"},{"claim_cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","event_cluster_id":"6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0"},{"claim_cluster_id":"227d3de7-5437-4b66-857c-d51afef721c1","event_cluster_id":"71aef7b0-37f2-43a6-87de-3439a440ada6"},{"claim_cluster_id":"a1d5bcf5-80de-4ba5-b40d-443ea3d3eb11","event_cluster_id":"d23ce59c-1b68-42d1-aa3b-b8143bbd9381"},{"claim_cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","event_cluster_id":"5949d818-e369-4db8-949d-7a462c260498"},{"claim_cluster_id":"aa09782e-9c11-4715-848f-eac275117bbe","event_cluster_id":"f09e8cd4-4e03-420e-a650-dd40af68dcd7"},{"claim_cluster_id":"23106ade-18c8-44c0-8d3a-ef2f743468af","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"f74a80e3-1327-4636-a252-f4ca8a5b90f7","event_cluster_id":"2f22684c-1c98-4774-aade-6114067fd60b"},{"claim_cluster_id":"aef50142-8ad0-4099-9362-3d45c56385fc","event_cluster_id":"1b9aa65f-dcda-40ea-bbc1-8c1521f177ad"},{"claim_cluster_id":"75e57a3a-a55d-4c36-b291-226154171396","event_cluster_id":"984fa7e0-f763-4f19-b49c-d87ea5159954"},{"claim_cluster_id":"b659052c-10e5-47d2-985e-c2c7d42a67a2","event_cluster_id":"c3301dce-0e38-4465-b94b-ee10e64f783a"},{"claim_cluster_id":"d6760008-6cbf-4c8c-b88a-b478081312d0","event_cluster_id":"6e13551c-ec8b-48ad-a58c-87108dea4e39"},{"claim_cluster_id":"6075c9de-cd99-4e5f-9302-f1b6177720a7","event_cluster_id":"5c72c86b-5dfd-4f55-ab98-8ad01ed266f5"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"cef32527-0357-47cf-9fee-19bd0f13e11a","event_cluster_id":"a5d764cc-6bfa-4c0a-bd16-68401768ed12"},{"claim_cluster_id":"91e6a8b3-0e47-4ed1-b99e-a946e23e0c33","event_cluster_id":"fc55d0f5-c78b-4a1f-a7f3-73448361d186"},{"claim_cluster_id":"4f2be876-d890-4fd4-a767-3f52bbc9c4c4","event_cluster_id":"e2835c22-b372-4e91-9b8e-5ef637ee8966"},{"claim_cluster_id":"2da1e2c0-6b7f-4a59-bbad-c83252a70f91","event_cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"a793f62f-9462-444a-a9da-d3e2c115a5b1"},{"claim_cluster_id":"774b6df5-ef29-47f3-9ae9-d88dbd184e38","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"546b42d0-5005-442c-a548-5a747146aa92"},{"claim_cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","event_cluster_id":"d7ce0029-7c2c-40fb-8d24-32029ffa4b81"},{"claim_cluster_id":"d089a914-1c7d-48b8-9c48-7a1b65f152b1","event_cluster_id":"b1c61f13-8002-4105-a62d-ec7191746e29"},{"claim_cluster_id":"e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37","event_cluster_id":"6b0c0beb-865e-4025-a8f9-7338b3bfba70"},{"claim_cluster_id":"04e0078c-1ff9-4d1a-8adb-a137164fd78a","event_cluster_id":"26405a6f-ce14-487e-8e9d-f5b3ee953860"},{"claim_cluster_id":"f3d66a5d-cd26-4b6d-a341-2fdc2524c28a","event_cluster_id":"870cf570-e7db-4612-8845-9e41f8062b78"},{"claim_cluster_id":"3769f810-e5f7-4d0a-9821-1876b6cadf34","event_cluster_id":"9eca8644-57d0-4b18-b62b-b394d615bf38"},{"claim_cluster_id":"25934933-94e9-444f-a664-f57c4cea7d17","event_cluster_id":"c35c9880-b71e-4b4b-b29a-43c7d18291ae"},{"claim_cluster_id":"cd21b07f-3941-439e-8ffa-59c6da9df98f","event_cluster_id":"32156667-7185-4800-9042-38e82870feff"},{"claim_cluster_id":"4bc5d44b-029d-49ff-82cb-bbcd84067673","event_cluster_id":"4b9443f4-821d-4fb7-8621-ed3af0ada4a9"},{"claim_cluster_id":"506e309f-6f87-418b-b660-0ad635976c9d","event_cluster_id":"ef2890c7-c6b6-40d0-96fd-72f800a7cb26"},{"claim_cluster_id":"6c812e58-19af-4264-b856-e922307ab466","event_cluster_id":"6e339b28-0894-4d85-a536-569236e90bbf"},{"claim_cluster_id":"fdbce6fb-9c6c-48ff-a187-88c668f79277","event_cluster_id":"895f4da6-0e6e-4170-be66-262513dfdc91"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"35d10df6-7929-4a0c-9fc1-b26cc3d884f2"},{"claim_cluster_id":"f8d50aad-e630-4fcd-a643-313737fc528f","event_cluster_id":"54cb3ed2-7dba-402d-a696-00ebabb32bc1"},{"claim_cluster_id":"47a61e0a-9230-4c4c-962b-f6724c066435","event_cluster_id":"54f8b2dc-d3d6-42f7-bde0-a8a0038707a5"},{"claim_cluster_id":"de1f8a69-eaff-4387-87ee-35fc20ea4a2f","event_cluster_id":"f8ba093e-142e-45ae-b5d0-aef007993c05"},{"claim_cluster_id":"bd4c7f11-9866-4656-98e3-7341cfc6de34","event_cluster_id":"c056dbf1-3293-411e-a56b-f5d55e75ae9c"},{"claim_cluster_id":"924c4170-d405-438e-937c-13478012b72c","event_cluster_id":"d2d5d22c-9f8f-472b-b123-61d32af5f64f"},{"claim_cluster_id":"7051d37c-4575-4653-97a5-3052e1c2b344","event_cluster_id":"8e1bc392-1f79-4373-ac66-b625742b75e3"},{"claim_cluster_id":"a4182192-73bb-4165-ad72-05ff39be899d","event_cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"},{"claim_cluster_id":"49a8c8f2-03df-436a-8634-670fd40a145c","event_cluster_id":"cb3aa2af-d703-4ae9-b53d-f7c0ae589678"},{"claim_cluster_id":"02dd8817-131f-4c62-a0d0-fa32952b2e01","event_cluster_id":"f4a62cbd-7d48-489c-b0ae-5a2ba587faca"},{"claim_cluster_id":"20030c5c-45db-460b-8663-d9950dc53ebf","event_cluster_id":"a3a7d7be-57b8-4862-a94f-547066bc6b8d"},{"claim_cluster_id":"c8416335-0a4e-4b5d-aa9e-40e533302d3c","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","event_cluster_id":"efde2814-71d1-4a0e-959d-1e37c60dd501"},{"claim_cluster_id":"61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc","event_cluster_id":"fcae1625-9dc6-40ce-b828-c6881213b7e1"},{"claim_cluster_id":"8cc2fa20-28d1-44d8-bdd2-f42d8dc30f18","event_cluster_id":"1be249dd-37fb-4d60-8a83-484cbb6bc5e1"},{"claim_cluster_id":"41369b57-1c08-440a-90c0-cacb7036a45e","event_cluster_id":"a4a343c3-6168-45dd-bb83-595e1841921d"},{"claim_cluster_id":"90ef35f7-8880-490a-bacc-f600f6a11162","event_cluster_id":"b4243b24-8de4-40d1-8e27-1dec1612406d"},{"claim_cluster_id":"6f8b0a89-8965-4d5d-9b89-f48b23ed61a1","event_cluster_id":"81bcd47f-070e-4939-b97e-e26a5423d8a9"},{"claim_cluster_id":"b874b38b-169d-4b90-b373-ae919f14c5a0","event_cluster_id":"ce807753-2437-4a69-9e26-d1ab69fdd2c7"},{"claim_cluster_id":"60b95622-d70d-459f-9ef4-53d53c239154","event_cluster_id":"d94203eb-6224-4f4f-ab68-6b9b570a960b"},{"claim_cluster_id":"e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0","event_cluster_id":"afcb3ce0-1612-4cdd-a65f-fb2d5a6bf76a"},{"claim_cluster_id":"bcc578f8-a745-46e1-ac64-5315a3ec6900","event_cluster_id":"19c9dde1-93ad-454a-9809-5f87d3869615"},{"claim_cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","event_cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02"},{"claim_cluster_id":"bf76e0b1-c54e-4ab8-82d0-979d68c35a65","event_cluster_id":"4ea8be34-570b-4271-a023-3b36e07e963b"},{"claim_cluster_id":"1e74d1b1-7b73-446d-b88a-11111e499ad8","event_cluster_id":"44c28ee3-0ffe-43a2-9aa6-1d7ed2463da1"},{"claim_cluster_id":"ddd4b5a0-2eee-4ff9-bb50-de940c2541e2","event_cluster_id":"639aad5f-e883-4460-bc98-aed364fefe21"},{"claim_cluster_id":"11e43ecc-22c8-4f1c-b13a-fb97013ce963","event_cluster_id":"4e04a5f7-5879-4461-9d2b-d653343b9dbe"},{"claim_cluster_id":"64de7b14-ea9c-48fe-a9a0-a30f01aecc3e","event_cluster_id":"d9598814-d7a3-48d1-b282-0aa4d0dfeb8b"},{"claim_cluster_id":"06da14b8-536e-4d2e-83b1-118cfb44829b","event_cluster_id":"f0626ed9-6a16-4fce-b589-96b444b12fc6"},{"claim_cluster_id":"058ec7b4-d77f-44ec-81fa-004e499dce82","event_cluster_id":"2034d9a0-a9ba-4e99-89d7-79e736b91d31"},{"claim_cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","event_cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"},{"claim_cluster_id":"61fac83f-0dd7-4c15-88bc-e40fee962783","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"5c890164-2642-4556-87d3-c7dbbd1d4d78","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"e45a7fdb-d8fc-4ccb-adfb-88a463256b7d"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"906602f3-b23d-4091-b462-b74d3ce8894a"},{"claim_cluster_id":"821946a1-401a-4657-be17-b3ed51371c13","event_cluster_id":"c193bcc0-0d98-4b99-869b-53885d805dc1"},{"claim_cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","event_cluster_id":"3465d409-db96-4545-a6fb-c388765f1b4a"},{"claim_cluster_id":"018f6f1c-b2e7-43ca-a443-3a5d27b5033c","event_cluster_id":"204d066b-baf9-4cb1-b94b-16fcde9be401"},{"claim_cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","event_cluster_id":"128d37ad-2ce5-409d-8ce0-e9df31085f42"},{"claim_cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","event_cluster_id":"ddce8749-8091-45b0-8366-637dbe518fa7"},{"claim_cluster_id":"07e66c00-a616-4a75-b1a2-efe8ff1edd22","event_cluster_id":"b7e93309-96c4-475e-9ccd-507fa2166b0b"},{"claim_cluster_id":"61922f77-a020-4916-b901-44fe7982b789","event_cluster_id":"b2e6976f-e5a2-4669-ac3d-3e87cd376f99"},{"claim_cluster_id":"595531c2-a2b0-4686-b3ae-4f5525fff05a","event_cluster_id":"6494604d-36ac-42cf-98fa-810683a18200"},{"claim_cluster_id":"bd3c25bb-6683-4bdd-8e97-11de485116b2","event_cluster_id":"505c42ee-a234-45a9-8c74-63207154db3f"},{"claim_cluster_id":"4d3a2478-017b-48f2-862a-30c57fa5055d","event_cluster_id":"08a49e97-cae6-472e-9f1e-189f1a189718"},{"claim_cluster_id":"3945d107-ebd6-4f7f-98d8-84183dc2837f","event_cluster_id":"6faef44d-a395-4b46-93b5-ca7cbd7fcfc0"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"b4530fdc-2dbc-4670-850f-b1965eb9d9e1"},{"claim_cluster_id":"8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4","event_cluster_id":"2a43ad41-42b1-4d3e-8501-88166518eba1"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"491bc782-ae1c-45af-9f60-183d9dcb959e"},{"claim_cluster_id":"b3c35953-f954-44b3-89de-73c75db49fd9","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"ff43bfb6-1ab6-422e-8045-756b71e70dd1","event_cluster_id":"4d99bd96-2995-4ee1-aaa1-1e78c622a4c4"},{"claim_cluster_id":"e1ad3c4e-eefb-42e0-8fe7-edf486c4da19","event_cluster_id":"41e4adfd-a702-492f-a430-46ac304993d5"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"411cad01-4640-4a11-9464-9f26565f44b6"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"1f4a4adb-de76-451d-aa05-57dc41f8014d"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"34a8290a-940e-4582-8dbf-cb195db85e28"},{"claim_cluster_id":"905fb380-0de3-42c4-abca-6fd6383deba6","event_cluster_id":"832076ec-b055-496e-aae3-ea8daef2ce04"},{"claim_cluster_id":"3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9","event_cluster_id":"14d0a92d-65cb-4881-998f-aed067993e99"},{"claim_cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","event_cluster_id":"e5db8adb-166d-4129-bd9b-54f680ec3bdb"},{"claim_cluster_id":"120d61e9-d442-4218-b8d0-9559d9880c3a","event_cluster_id":"1d2ec60f-34f2-42e2-a397-916c3e7ad70d"},{"claim_cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","event_cluster_id":"b13b5ee0-1421-43e8-a554-5b3888a5cac7"},{"claim_cluster_id":"049db6be-2ccc-4afd-97c6-e95cb1b50286","event_cluster_id":"b9b30a00-8e82-4f2f-9524-8cbb18357bed"},{"claim_cluster_id":"2fa38dbd-c491-4579-bb95-e37ac00e125d","event_cluster_id":"27d4950e-9d1e-4314-b5b5-7fcf43d21e72"},{"claim_cluster_id":"269d367a-5938-4087-911a-3256c10a910f","event_cluster_id":"3a95c736-dd02-4122-9108-f00df86397af"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"8383b651-21df-4fb5-9d89-77f8c5fdde08"},{"claim_cluster_id":"7bcfb80e-f4a6-4404-be69-078e88ddce1f","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","event_cluster_id":"c1d9eed7-6c9d-4c45-a896-47b8c389cf48"},{"claim_cluster_id":"d6705dc8-8def-4060-882a-9c13b62a23ad","event_cluster_id":"7c7cd464-a285-4810-881b-7a151a564ae1"},{"claim_cluster_id":"ab5ca9cd-1ca3-48b3-9ae1-79a096d75528","event_cluster_id":"5a1b9522-efaf-458a-8a08-7187a721101c"},{"claim_cluster_id":"4692c588-5e24-491c-9044-3d7dd7c0a2d7","event_cluster_id":"317ecec9-87af-4e3c-acd4-372de58135a0"},{"claim_cluster_id":"f72eb4bb-112f-4556-a279-ad745cb4894c","event_cluster_id":"115fb915-b1b2-4ede-81d0-20680b7749d3"},{"claim_cluster_id":"cce124fe-f108-4571-9074-db48a458127d","event_cluster_id":"272822f1-86c1-4fb0-9f4d-41ee4b639a78"},{"claim_cluster_id":"6e63c4ba-f9ee-49c7-a87f-b38ea11837c4","event_cluster_id":"9dd9bb3f-346d-4bab-978a-64ea761a815a"},{"claim_cluster_id":"1d1fb1a1-0351-478a-ac00-eb42c21a03d9","event_cluster_id":"bf7032f5-cf58-46a3-b595-6510ffda5c2d"},{"claim_cluster_id":"818db8b7-0e38-4d06-8f87-4de475ce7556","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"000d729d-1afe-4b59-b42a-5d8012efd354","event_cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c"},{"claim_cluster_id":"5b5325b9-59bb-4b91-9a19-8889095dd496","event_cluster_id":"03e89563-d271-4f75-a47c-92ec9575e524"},{"claim_cluster_id":"5ef68f23-0f9c-4c57-af44-b6d2b7f6107c","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"ac6c3346-ea92-4da2-afed-ba431832d85e","event_cluster_id":"ae8f7a24-2c15-4f25-983d-6c8e3d8467ec"},{"claim_cluster_id":"802c7e0c-e913-4631-9fd3-b4b457a510e0","event_cluster_id":"0e2b1f45-559d-4cae-9f78-dbca6d3f4287"},{"claim_cluster_id":"840ac263-91de-449d-b701-c05a4522f3b3","event_cluster_id":"d291acf3-7cf8-4c9d-9ab4-df11bad39953"},{"claim_cluster_id":"3ece6224-aab7-493b-83b2-1f9fc56d3136","event_cluster_id":"99212234-66c3-470f-9dda-4b5f137ff502"},{"claim_cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","event_cluster_id":"388f06a9-49ef-4bdf-8dec-04895f125517"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"9a51f01a-20e0-4f51-8758-8480254254f0"},{"claim_cluster_id":"f68dc41c-3947-416c-8f93-49c606c24bd2","event_cluster_id":"c557e9b2-c812-48ee-97cb-707e7e40672b"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"d265d5db-4035-43f0-bc76-bf5945ff3551"},{"claim_cluster_id":"73fff1e2-bc77-421c-8436-e9bf094a9733","event_cluster_id":"8eea3c6d-083a-481c-aa84-30005023f301"},{"claim_cluster_id":"d68f430a-9578-4b21-a27f-13f1a9f8f629","event_cluster_id":"f2f62c1a-8699-46b7-b2e3-61e093884f19"},{"claim_cluster_id":"b9550306-91d4-4e1e-9632-4c73f1957d92","event_cluster_id":"21df275d-4ad2-4f7b-841b-bbaff7511134"},{"claim_cluster_id":"a3cc8d63-1533-4239-bc6b-bedcff828ef9","event_cluster_id":"1ee29b00-1c04-4d47-871a-4fc6d43200cc"},{"claim_cluster_id":"6eb878e4-969f-49ca-8ac8-5c68ead2c13e","event_cluster_id":"92dc2b29-cee7-4ea1-b9e9-d0593544c75b"},{"claim_cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","event_cluster_id":"343b7137-128b-41e4-a3ca-cc8e58193569"},{"claim_cluster_id":"01680509-ab3c-4c56-a9a9-62fe3aeaacf8","event_cluster_id":"ac2e2af1-8130-4f38-a6ff-ea4697746269"},{"claim_cluster_id":"89360ae3-18fa-43f0-bd2a-417e02e051c5","event_cluster_id":"64e778b1-1770-4087-ac56-445bf339b8c2"},{"claim_cluster_id":"47fbc359-0497-4aac-8a4b-e63bd060a1e2","event_cluster_id":"4246d514-6e8e-4ea0-b242-f59a58eb4bb7"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"442fa925-31c9-4639-8516-7ca59dfe469b"},{"claim_cluster_id":"40460222-6c35-47b7-be68-29a1138ce819","event_cluster_id":"c1a9feb3-4c0b-486b-ae22-214c44a6619c"},{"claim_cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","event_cluster_id":"554d8f5c-047a-4e8e-b996-038e567aa26c"},{"claim_cluster_id":"2b4fc83f-18c3-4ff7-b918-64e0981dd3b2","event_cluster_id":"89d55cf7-6d3f-4328-a78e-26c777948edb"},{"claim_cluster_id":"664823cc-3309-42a4-9224-e9eaa7ee3fe5","event_cluster_id":"e24f9229-3672-4631-abf5-3ab616111d97"},{"claim_cluster_id":"6f7b7d52-9a91-4f92-8a4e-4062c6360cda","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"e840acd4-9152-4039-820b-b347beaec131","event_cluster_id":"f1749a30-d414-494e-8542-2f37dca2357f"},{"claim_cluster_id":"dd5d0634-bc30-45f9-b45a-97773c63db2a","event_cluster_id":"4ccf7bf5-90df-4621-97ed-669020415167"},{"claim_cluster_id":"bed08ef5-4cb1-4f05-b2d4-a996242acd93","event_cluster_id":"93e534a9-c780-4415-bea0-b88f8156dbb0"},{"claim_cluster_id":"0727da75-801a-4ea8-bc54-bca9f4c0cbfc","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"f9741213-db12-438e-ba4b-5df13a3381e4","event_cluster_id":"de89e6b7-8aa5-4a9d-b8b1-927da0ac9c8a"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"93707dc5-36b1-4b18-b721-a98eb38368ea"},{"claim_cluster_id":"66a36ac1-c9eb-46aa-9ae1-0d7306ddb692","event_cluster_id":"d89daeba-4406-40e6-aed6-08994b1a95d9"},{"claim_cluster_id":"03b37d7e-0ed4-4014-ac24-a898719a8f87","event_cluster_id":"0f0292cd-5ed9-4b41-be37-f307be9f4e80"},{"claim_cluster_id":"3e1920d2-6038-4d0b-b122-137c458f6d99","event_cluster_id":"c92757d9-a065-4dc2-806f-96c7c9890f76"},{"claim_cluster_id":"cef32527-0357-47cf-9fee-19bd0f13e11a","event_cluster_id":"21b3b67f-1874-443c-9458-d23200b40680"},{"claim_cluster_id":"70a36c06-fbb9-4f71-bf77-74f433672b24","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"0f106199-65cd-478b-af43-69825b16fa47","event_cluster_id":"32fafc3d-cccf-4a0c-872b-788d937b0241"},{"claim_cluster_id":"1cd94f5b-6850-44c5-b48e-2bcdab6eefd2","event_cluster_id":"6ad5e833-9ccd-4680-8847-382fff58f760"},{"claim_cluster_id":"4f63d722-2816-4701-89a0-6f6efadc8656","event_cluster_id":"cc9a2a9c-6fc8-4c4a-bdf7-3321a40e8bff"},{"claim_cluster_id":"ba035925-8a5f-42d0-aec3-c91702a47b8d","event_cluster_id":"3a02d9a5-2925-42fc-a9b8-bf0df52af22f"},{"claim_cluster_id":"ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6","event_cluster_id":"059d310b-b926-414f-b010-d79ad9684054"},{"claim_cluster_id":"36ed05e4-cb6f-4b4e-a07c-39d608cb863f","event_cluster_id":"e21706fa-dad7-4365-a0f1-e7a597e49a75"},{"claim_cluster_id":"de5ecea9-1de6-4f23-a787-2b6cd366c836","event_cluster_id":"e6bb5d2b-e815-44c5-957e-bfeac26fe4eb"},{"claim_cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","event_cluster_id":"783f72c7-55f3-4eb7-a87e-43b3ec9f631e"},{"claim_cluster_id":"3e9990d1-ada6-4c9b-b2b3-e8220e956431","event_cluster_id":"7881b67b-b21c-40a3-ac70-ae067b94075c"},{"claim_cluster_id":"98459a3d-d71e-40dc-bfe8-895082c9d11c","event_cluster_id":"a821fab7-385f-4999-8399-e63f4f07d4d9"},{"claim_cluster_id":"175bdcd7-0fff-45d5-9e67-f78e69286a6f","event_cluster_id":"eff3ff70-7d42-45d0-a372-4aa15bf9f280"},{"claim_cluster_id":"d10a4ec7-a74e-4016-996b-f1f3a3c6527f","event_cluster_id":"906d1526-e5ff-4f4e-a0e5-f30c2dfb306d"},{"claim_cluster_id":"1be65d4d-c915-41d3-9d1c-864035425656","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"e36180c3-afe0-495c-8168-73e631f50a1c","event_cluster_id":"23b2fb05-29fc-4502-9ecd-a47d0a63076b"},{"claim_cluster_id":"22c3b77e-fa98-44e1-b509-f721cef0815f","event_cluster_id":"65c190b4-386e-49d9-9ce5-a5d89e355ede"},{"claim_cluster_id":"9142e74b-a217-4be0-8685-ab7ea89b683d","event_cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec"},{"claim_cluster_id":"dc9039b4-da9a-4fd0-b97d-d822536a716c","event_cluster_id":"4d6eed7e-0404-4ccd-92b2-df5956550e67"},{"claim_cluster_id":"e3489bfa-95e8-439b-81da-6d84615a5721","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"2cfb50e6-37ad-47a2-87b2-da1a9a512e46","event_cluster_id":"9be7eccf-749e-4a5e-97bb-089da9891c3f"},{"claim_cluster_id":"5443e2c0-e92d-4c21-ba1b-b0cdb2302769","event_cluster_id":"077993b8-9cb6-4b90-bda9-8d4fd6b15198"},{"claim_cluster_id":"bc70c00b-dffe-4092-a775-4a9734094547","event_cluster_id":"2b2effa3-cad0-4ecb-9486-b078278fd3ff"},{"claim_cluster_id":"36b91493-5f3f-412b-a861-2328c6420cc6","event_cluster_id":"82ba6b92-1774-434f-82ee-333e96e53f03"},{"claim_cluster_id":"783f85bb-dceb-450a-9a34-4a650e18ed9f","event_cluster_id":"778d39fb-527e-42ad-a678-aa372a58fc39"},{"claim_cluster_id":"558e806a-d249-4f8a-8e7e-fb4b28552537","event_cluster_id":"634b7e88-e0f0-4f5c-a26b-6d9e0a0fdc06"},{"claim_cluster_id":"9314aa75-84de-490c-95e7-6484ecdba212","event_cluster_id":"dea69c71-f54b-4b5e-a6a9-8af50c3a5a8c"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"b0bd2a7e-c0c5-4afb-ac21-777cf1d80964"},{"claim_cluster_id":"01680509-ab3c-4c56-a9a9-62fe3aeaacf8","event_cluster_id":"78fa9929-a2ff-4f4c-b21a-35134d80f026"},{"claim_cluster_id":"02774183-9d71-4dfd-8f60-b54cf275fbb8","event_cluster_id":"ca3bd404-3299-4dd4-a75b-9491f55542a9"},{"claim_cluster_id":"33e1162a-91ae-476d-b4d5-3b1e2f01a5c1","event_cluster_id":"ca172ee1-fff6-4049-a2d4-1e377d7e0cd8"},{"claim_cluster_id":"17dbd7df-f3d1-4902-a103-f97b03017681","event_cluster_id":"63217c83-a56a-4703-b9b6-f928b5437b8a"},{"claim_cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","event_cluster_id":"fb8928a2-09db-488e-818b-8455b9d3b5aa"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"329efe6d-0194-47fc-abcf-cc9c3ee312f8"},{"claim_cluster_id":"594e0474-2d9d-4582-8963-9fe946d49a1e","event_cluster_id":"94a7144e-4fa6-47f3-9e46-2609b5de45b5"},{"claim_cluster_id":"478c6562-e71b-47f9-8079-8463bc1262ba","event_cluster_id":"dbf5db30-86b6-4686-8710-21f1a647cecd"},{"claim_cluster_id":"72276ba3-4193-4153-879a-b2c7cdf39af4","event_cluster_id":"94b0a214-1e60-4bbb-96cf-031169c35247"},{"claim_cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","event_cluster_id":"433a8504-6f95-4801-98c2-808b28575d4f"},{"claim_cluster_id":"e03ac9ce-f105-49c9-9a2f-9442b3b31044","event_cluster_id":"c49f13c9-2c44-44c7-b990-930a2d9264c9"},{"claim_cluster_id":"ab829976-d7fb-4b30-9b92-89eed4e94cc4","event_cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2"},{"claim_cluster_id":"6f7b7d52-9a91-4f92-8a4e-4062c6360cda","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"bac292de-05f4-4fd3-a4df-f073c8f09553","event_cluster_id":"d09cadfe-f589-4fe2-9bf8-e5e3a0697237"},{"claim_cluster_id":"02dd8817-131f-4c62-a0d0-fa32952b2e01","event_cluster_id":"b23983b2-f833-47cb-bb9c-14955ae74418"},{"claim_cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","event_cluster_id":"41741032-ab51-407b-85f5-a7d6f97ca5b8"},{"claim_cluster_id":"e3489bfa-95e8-439b-81da-6d84615a5721","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"061a86ec-2126-4e4d-85ba-8472db7a97a3","event_cluster_id":"074437b7-382b-4a9d-91da-57d4542a546a"},{"claim_cluster_id":"696180e6-d43f-476a-afce-5f13dbb9929a","event_cluster_id":"8b78f548-1c1b-488a-bf4c-04bfe2488f52"},{"claim_cluster_id":"83176725-df79-43f8-b571-b45c6b2dea8f","event_cluster_id":"5db4a15c-7ce5-458c-89da-0e71f2e155d8"},{"claim_cluster_id":"c2350485-f95c-46d4-9b92-6355ceca86df","event_cluster_id":"dc0f2fc6-867e-476a-b8e1-8031edcf72a7"},{"claim_cluster_id":"e0a2030b-8c63-4b35-9a46-36f1f22b5601","event_cluster_id":"6d2cf6ad-226e-438c-8ae9-0f0b432c0bab"},{"claim_cluster_id":"5ab9d303-668f-48d9-893f-546437484767","event_cluster_id":"8bba2d5b-a20c-44b8-91e1-9dd72d1e1b07"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"0cb30e02-d84d-4557-96e4-2da52513f036"},{"claim_cluster_id":"6d176455-78b5-4454-a405-3f0ba5b91ecb","event_cluster_id":"f6680d6a-ecb6-41e2-9526-051a689d4c68"},{"claim_cluster_id":"c8416335-0a4e-4b5d-aa9e-40e533302d3c","event_cluster_id":"adf0e4d7-03fd-41b1-8559-5505d4d67e0a"},{"claim_cluster_id":"2d2ebd07-a80d-4a48-b320-cc68d39bdc10","event_cluster_id":"8bfff308-f565-423a-9de9-6f9eeebb617f"},{"claim_cluster_id":"4eb17e7e-a0b8-41fd-aeb6-65f4c703f9b7","event_cluster_id":"1122df81-54b6-4861-86f2-c9908073053f"},{"claim_cluster_id":"7576470b-cafe-4c17-9541-256e9ec07097","event_cluster_id":"170734bc-dfb6-42e4-9b5a-6f9747a63ae0"},{"claim_cluster_id":"304f9508-2cf0-4ef2-b524-7a5c78978d94","event_cluster_id":"8098cc1b-8836-490c-9e7f-17c6a8944eb0"},{"claim_cluster_id":"3312bf71-bb24-4752-866e-3b29580d70d1","event_cluster_id":"c9d26401-7e49-4279-ad09-55dcf3457ac8"},{"claim_cluster_id":"78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a","event_cluster_id":"d862e5c2-98e9-4ead-8a8e-98d31f78f4f8"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"1760a439-ca46-4fac-8653-21cfe35d860c"},{"claim_cluster_id":"21b491b2-20db-42c2-af5c-70af377f068d","event_cluster_id":"71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2"},{"claim_cluster_id":"24e1d750-e055-449a-83a7-236e590f0e5b","event_cluster_id":"20ed0e78-890f-400b-a5b8-9f3252623084"},{"claim_cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","event_cluster_id":"cf544ca5-66d4-4d37-bc28-71ce54266ee4"},{"claim_cluster_id":"209935ed-d0a0-4dbe-82d8-2d7d5a2aa866","event_cluster_id":"bd1fd480-bf1e-49b6-a34f-4616e66e256e"},{"claim_cluster_id":"f3d66a5d-cd26-4b6d-a341-2fdc2524c28a","event_cluster_id":"d9df9f73-2328-4c08-a547-bba4c4ece24c"},{"claim_cluster_id":"1574223b-5ec0-4588-8996-6510aa3052d6","event_cluster_id":"d4a86c9e-1cea-4922-914c-e44e0a71bd5f"},{"claim_cluster_id":"0c50e809-0f1b-4656-a0dd-110732b6e47b","event_cluster_id":"47f7a131-6ce1-4e01-b64c-61e5f9696bb1"},{"claim_cluster_id":"52f4370b-6902-4abd-9ee9-d4310ae49cb2","event_cluster_id":"6cafd456-d229-4e09-abf9-1632d52f0462"},{"claim_cluster_id":"06c89f07-f873-4ab4-9068-3bbe6a0c9e11","event_cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"906602f3-b23d-4091-b462-b74d3ce8894a"},{"claim_cluster_id":"39caeecf-930f-43df-a6d4-e237146a33a8","event_cluster_id":"a1f572c9-19e4-4da8-b35a-87c376dc4fa0"},{"claim_cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","event_cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02"},{"claim_cluster_id":"18fe8f4b-896d-47b4-a019-0383dc22d38e","event_cluster_id":"a56532e0-90ee-496a-a60d-c01066fce560"},{"claim_cluster_id":"54bf8eb2-6975-454f-a48b-59abffdfe4f4","event_cluster_id":"789c4f9a-6863-49ee-a41c-e12949429992"},{"claim_cluster_id":"fd424526-ed4e-4b80-99b4-1b131a22e381","event_cluster_id":"e1667646-95da-4708-8fd5-fef1ce4974fe"},{"claim_cluster_id":"f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3","event_cluster_id":"1f7a8e67-3a2d-482a-a62b-2e318f3fda52"},{"claim_cluster_id":"5b5bad5e-15a1-4d61-9521-27fe4f90522e","event_cluster_id":"991ef8e4-a40d-47b2-ae87-93bed03c964e"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"300e8b62-ec91-41e2-9809-166d3f0a78b2","event_cluster_id":"6e773145-449c-40f0-969b-2f16d4a7c04f"},{"claim_cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","event_cluster_id":"193fcb1e-c985-42f2-8058-34aadbe0ce78"},{"claim_cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","event_cluster_id":"05133a93-3ffe-4993-9c55-47f240923f20"},{"claim_cluster_id":"38711d17-ac82-464c-a077-7a82e0d362fd","event_cluster_id":"6413f39e-1e69-4b93-9d00-8b04286c8041"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"e80d1fc7-6571-4102-b247-59bf3fa473d7"},{"claim_cluster_id":"e4f4246a-95d9-4d67-94bf-27725af4d71b","event_cluster_id":"ad140612-2296-4f06-9b90-8018512776b7"},{"claim_cluster_id":"f358da84-14e4-4001-acb3-83fa23673eb8","event_cluster_id":"64689f94-8b56-49c1-bd31-9f4133ac52a7"},{"claim_cluster_id":"255ea174-3e00-4506-8a6d-78f62eccfecc","event_cluster_id":"90dd5b61-524c-4738-8cae-d8d3f36a7bf8"},{"claim_cluster_id":"0eef7600-1d71-4d26-9e91-3c6e5b0c6121","event_cluster_id":"0749ed10-4e7c-4fa4-ac39-680414ad6f05"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"efc28260-5d9d-4934-8e08-cb0eaf327cf6"},{"claim_cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","event_cluster_id":"89ca7fbd-adb5-4425-9a07-78efe99244cc"},{"claim_cluster_id":"3e9990d1-ada6-4c9b-b2b3-e8220e956431","event_cluster_id":"77420d84-761c-4596-b8a9-5aa8adb89a0e"},{"claim_cluster_id":"c604d802-912a-4abb-ba43-e290946de463","event_cluster_id":"6d731e69-2664-4f91-adc6-9eac800389a3"},{"claim_cluster_id":"d14315a8-aa93-4c64-a42e-a4307dd0814a","event_cluster_id":"7348cd32-1a61-49ec-88d2-09ed7c4e132b"},{"claim_cluster_id":"8a12011e-a6e7-4e73-a321-a39426ec3d34","event_cluster_id":"1737c28c-8f31-4855-8951-9dd1dd0b8606"},{"claim_cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","event_cluster_id":"209803f4-b6ac-40bc-97b8-024102ee5865"},{"claim_cluster_id":"2fa38dbd-c491-4579-bb95-e37ac00e125d","event_cluster_id":"3f9df2bc-6f72-4bee-88b2-8ddae64ca085"},{"claim_cluster_id":"bbe61a29-09c0-4f9e-98e6-1cf33324aca4","event_cluster_id":"d2ffb0e6-959f-4fb3-a43b-5fea64c717c0"},{"claim_cluster_id":"a604c242-b8d1-4d4c-9595-5b1b3d840615","event_cluster_id":"07dbae86-71d8-45ff-b18a-4a1bf2ead8e0"},{"claim_cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","event_cluster_id":"91a996d6-946d-4317-a60d-c7b9088e7854"},{"claim_cluster_id":"c0a45d49-4b4d-4871-845a-e13c06e06fa2","event_cluster_id":"5113736c-e1bd-4cef-a0d0-94d26dc8aee3"},{"claim_cluster_id":"58b4fd6b-1eec-47dd-b945-a94d957a9933","event_cluster_id":"66195131-3ad8-4241-a0d6-4ab7e32c6962"},{"claim_cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","event_cluster_id":"bc073191-5c75-4ed9-b991-437755cb3cd0"},{"claim_cluster_id":"c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9","event_cluster_id":"65f3a4f7-31a9-4a5f-92ab-a9f153d96b50"},{"claim_cluster_id":"51f9e6ae-7c8a-46e3-8fa3-070377ae9030","event_cluster_id":"7d94faaf-dbe0-4a3f-a991-f9aa1c9db4cf"},{"claim_cluster_id":"c2417696-bc64-4d4a-b3a4-d5d9e3cefb38","event_cluster_id":"bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c"},{"claim_cluster_id":"e12046ad-ffee-4bf5-90ec-51d127135711","event_cluster_id":"904668bf-4a16-4f14-9adf-79655c2a451c"},{"claim_cluster_id":"f3735996-484c-447a-8fe4-4cd5c645a0a9","event_cluster_id":"83593077-334d-4f71-a668-e36e720c6a3d"},{"claim_cluster_id":"763dcb28-8161-4ef1-bcee-20cbd6af7670","event_cluster_id":"287338c2-de9c-4394-a2e1-133139492deb"},{"claim_cluster_id":"1d7ae3fd-fb7a-483b-9d74-2b16ea9b34ba","event_cluster_id":"1c77e648-2237-497b-abcc-acdf4350562a"},{"claim_cluster_id":"54385df9-c5b3-4372-ae3b-cfd7db571df8","event_cluster_id":"0bbc69c0-3b6d-43a9-a4c6-d187b908122b"},{"claim_cluster_id":"73e672aa-47a1-430b-843b-82f236a93650","event_cluster_id":"10df36b6-9ce0-4838-9b29-8a4b4c151281"},{"claim_cluster_id":"162f021a-53e9-4f3d-9231-108223f18e9b","event_cluster_id":"067f4b77-6a0f-43e6-a250-8a682e95f8f7"},{"claim_cluster_id":"49c94f1b-b278-42a0-b8b7-d0f8ec55d536","event_cluster_id":"4b8668b9-ec8e-41f1-b42b-e53f7eac0641"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"36ff0bd5-8344-4d31-824c-e7dea3acb3e6"},{"claim_cluster_id":"72a6b38a-23a2-43db-a788-32ae774a5c77","event_cluster_id":"f0449899-c6ef-4a85-b5c8-5f78e0da96c1"},{"claim_cluster_id":"0a0436c8-54af-4b5e-9725-fc8ed172d1cc","event_cluster_id":"eb9b2ee9-7136-4b80-93fc-c731e2546e36"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"cbcdf7dd-2927-468a-83b8-036e8a1b1479"},{"claim_cluster_id":"2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6","event_cluster_id":"a8d5b3e4-8b75-49e0-a915-0b7f6f79f523"},{"claim_cluster_id":"74bc9e46-31ab-4e9e-9240-87a035b90601","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"eb9567f9-4c3d-4f62-bea9-bc557347bb13"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"3e283bf0-1100-4773-9ebf-a90b86b62efc","event_cluster_id":"10c5fb88-3404-4aa6-bc78-257c91344837"},{"claim_cluster_id":"5f2c5e5a-f6ae-4d50-91e8-eee0bd665636","event_cluster_id":"7590439d-277c-48b6-9bb4-812f83d4e421"},{"claim_cluster_id":"fc40e900-5f3a-4200-9723-06366e139ab4","event_cluster_id":"94d7c196-e914-4792-9ae3-448475f12021"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"1b2e8a52-7038-453e-802e-e2b6d0c4da48"},{"claim_cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","event_cluster_id":"e4695f74-046d-460d-a794-197c7df92c76"},{"claim_cluster_id":"bd3c25bb-6683-4bdd-8e97-11de485116b2","event_cluster_id":"77cb4584-fbf4-45e6-9a2b-9d46e341c831"},{"claim_cluster_id":"06c89f07-f873-4ab4-9068-3bbe6a0c9e11","event_cluster_id":"13a151a6-c289-4cb5-8bbc-44e52c4f2c13"},{"claim_cluster_id":"2c834413-ef2b-486b-81d5-2e0a687a8ca7","event_cluster_id":"1cebf7eb-146a-47ef-84f4-296315d7b4c5"},{"claim_cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","event_cluster_id":"2672b11d-4ad6-44a1-9b31-f8c01c03c721"},{"claim_cluster_id":"cfda7d82-87df-49b1-8db2-82b62b174a67","event_cluster_id":"06de95aa-ea18-4201-9254-c11dee534162"},{"claim_cluster_id":"27b386d8-58df-4b19-a269-36bb2400c94c","event_cluster_id":"6f00b5de-be1b-4233-883c-1a484844dac3"},{"claim_cluster_id":"97e04a01-6626-4196-a12d-eac1df348581","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"17ea1514-c948-487c-83ee-722001d6184e","event_cluster_id":"dfa97197-5724-4a7b-bce9-4a9f24f7056d"},{"claim_cluster_id":"c02665b8-8535-44f4-96b2-764b54985f66","event_cluster_id":"a56438b9-f9ce-4dfd-beb8-0ced3dfad829"},{"claim_cluster_id":"d4352376-c595-4d9d-928a-8fabbed1e18b","event_cluster_id":"83743532-1cd2-436e-9911-21445ed61af2"},{"claim_cluster_id":"49ede63e-a1af-4931-8ab4-034fed7764ad","event_cluster_id":"17a371ed-b42f-4523-bba1-0b6b3e65c57e"},{"claim_cluster_id":"f42001e5-7364-43c2-8d35-74c3552a9ccb","event_cluster_id":"40e30cac-a785-4067-9a79-c9832fd15372"},{"claim_cluster_id":"5c1d5636-b62a-4962-911d-1136d9629b6a","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"b7cbc93e-51f6-448c-9fc2-c1af44082069","event_cluster_id":"ed2533cf-2013-4e49-885b-231a6c55f0fb"},{"claim_cluster_id":"4ab7d21d-36fc-4f12-857a-8e07c61bf688","event_cluster_id":"c6da85ba-cb8c-4e07-b313-69be94d682d5"},{"claim_cluster_id":"fd554d0c-cd25-4da2-adf1-dcccfd01f292","event_cluster_id":"cb5e091b-477e-46e6-aa3e-6f7875bd065d"},{"claim_cluster_id":"f9741213-db12-438e-ba4b-5df13a3381e4","event_cluster_id":"8822fa56-959e-4020-ae70-4e0f3f35f8fb"},{"claim_cluster_id":"2d7a7088-3ced-40a0-9677-1d14e1c26d8f","event_cluster_id":"a378f92c-87c9-4fc4-85b1-e22948f338e6"},{"claim_cluster_id":"99b20734-bb32-4aff-b60b-a976139937c2","event_cluster_id":"9fe7995d-1f25-429f-b4f7-9af7bc4a7e8a"},{"claim_cluster_id":"770cc261-67a7-4ed4-85d2-93916689a978","event_cluster_id":"e39260dc-c205-47ec-aba4-6672ed7e1722"},{"claim_cluster_id":"5b4b432d-262c-43d8-a2ca-4d8a45a3e1de","event_cluster_id":"d77acdbb-aa93-4e79-8f2a-2afe86ba39c8"},{"claim_cluster_id":"2247b006-05c5-406e-a6b2-d87e6eb59702","event_cluster_id":"5ee42f7d-842e-4bca-a9c2-795ed9870897"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"398a087e-4a63-4bd1-8ad7-e71ca757db9e"},{"claim_cluster_id":"8fed35fe-4af1-484a-bd4d-74f9fac960c8","event_cluster_id":"abbfb703-6da3-4a58-9c1e-a58cf34e5030"},{"claim_cluster_id":"9b7211c2-d426-4818-9305-d12ff5c6e2a5","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"},{"claim_cluster_id":"ded98049-aef1-4b4f-a8a6-f68c10032b7f","event_cluster_id":"f2b47c96-3e62-4d1a-98f6-547e71af6858"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"e5736d52-6864-4a19-aa95-57d6bbe8f40d","event_cluster_id":"b70fcbd6-9ed5-4bd6-a526-8679fde82331"},{"claim_cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","event_cluster_id":"e1314480-d543-4a51-a6ee-6dc61dbfa929"},{"claim_cluster_id":"f854f83f-364d-470a-8cd8-f0bec2c15e68","event_cluster_id":"88bb793a-f03a-44d3-bc64-124f3010e3b7"},{"claim_cluster_id":"dcc1a857-7e25-4b1e-bb30-c67434a5f183","event_cluster_id":"72ed971f-2c7c-4564-b630-36c027e0f1d2"},{"claim_cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"1cbddfd6-c491-40b1-b10c-fd4387edddf6","event_cluster_id":"5de6826d-9cc1-4c89-8c16-3e4d254ae1a9"},{"claim_cluster_id":"fdc7a586-a2b7-43cb-897c-5aacc04ceaff","event_cluster_id":"e581acd0-fb94-4a27-8e52-0501198c921d"},{"claim_cluster_id":"ceec9597-cc69-4304-a584-0cec50748ec3","event_cluster_id":"748efe6a-9ff2-447f-9d13-f72501f7e924"},{"claim_cluster_id":"24accb31-401b-42c1-bd69-e81c04cb2530","event_cluster_id":"4c0dfd84-df3b-4660-9041-a635021908ef"},{"claim_cluster_id":"fc40e900-5f3a-4200-9723-06366e139ab4","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"772127a5-d049-4874-9828-2ed65010852d","event_cluster_id":"6b05928d-06c6-4035-8854-c47627756aaf"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"28c2302e-bfe1-426f-8146-f632519111cc"},{"claim_cluster_id":"4a8ddb73-8e8c-4981-b0f4-e38510f4f712","event_cluster_id":"e0af4c3d-214d-424d-955e-14071d90129c"},{"claim_cluster_id":"385e1f90-483f-4a17-bec9-dd37d561707f","event_cluster_id":"5a363a3c-7ca6-45b2-98ec-b07e07ef38de"},{"claim_cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","event_cluster_id":"5be5d4e4-f894-4929-941a-785184a9901d"},{"claim_cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","event_cluster_id":"6e55b53e-064d-4b25-b79e-bd27aee62abe"},{"claim_cluster_id":"f3d66a5d-cd26-4b6d-a341-2fdc2524c28a","event_cluster_id":"a9de4b16-c663-4b5e-933f-b9821d2cc80d"},{"claim_cluster_id":"b8208758-3ffb-41f1-97e7-30e90da08e44","event_cluster_id":"238786da-a825-4e96-9851-097b2db705e0"},{"claim_cluster_id":"6d176455-78b5-4454-a405-3f0ba5b91ecb","event_cluster_id":"7598667f-d0d3-42d2-856a-51698f3f1b3c"},{"claim_cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","event_cluster_id":"d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f"},{"claim_cluster_id":"ae201524-ae4c-4b92-afa7-2801ac429060","event_cluster_id":"53a00b92-807b-43f5-846e-1b35127294fe"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"67c7f204-fd07-4c45-80b1-5b0bd873efd4"},{"claim_cluster_id":"13f086c1-e440-480a-a882-8d8a742c1d5e","event_cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec"},{"claim_cluster_id":"f8618eda-effd-4eda-b2ad-66d8fec0ba02","event_cluster_id":"6c73f0ba-1131-48ad-8cc3-b8a29be7cfff"},{"claim_cluster_id":"d072d7ca-3280-4412-8e76-be63e36fe491","event_cluster_id":"04828ccc-4133-4cf2-961b-b8fc2a3c6d43"},{"claim_cluster_id":"5767d0cf-3070-412a-9136-a29c287f15a1","event_cluster_id":"5cd2aca7-8312-405f-b073-d87b70cdcee0"},{"claim_cluster_id":"85123ed6-1d34-44b3-9644-642bc01ff160","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"a7d1cc33-aa3a-4ee3-86f6-065986a716af","event_cluster_id":"6773439f-27bf-46ee-884f-6f78667de502"},{"claim_cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","event_cluster_id":"cf071659-f57a-47ef-8e58-d5ef07d53221"},{"claim_cluster_id":"16667fe1-8cf7-4fec-9aa8-c5bb30920e90","event_cluster_id":"e3cd63c9-b877-4cb4-80a4-d872818bfe3f"},{"claim_cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","event_cluster_id":"6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10"},{"claim_cluster_id":"89360ae3-18fa-43f0-bd2a-417e02e051c5","event_cluster_id":"4d6eed7e-0404-4ccd-92b2-df5956550e67"},{"claim_cluster_id":"691c3c1b-0058-48a0-aaa7-5a38747b8c58","event_cluster_id":"7e010522-998f-4102-8a4d-417605255131"},{"claim_cluster_id":"f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3","event_cluster_id":"2baba0c0-38f3-43b9-8755-4293f919fe7d"},{"claim_cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","event_cluster_id":"35d3d7f4-4964-4980-9833-62b5e004737f"},{"claim_cluster_id":"81fccffb-0c5b-4efd-826c-64c3efbb0393","event_cluster_id":"1ccab5e4-b80e-4900-88c8-f5ed9013c0df"},{"claim_cluster_id":"ccd87163-f5c4-4a49-b3d3-5d5c4788834c","event_cluster_id":"276946c6-5e3d-44d2-b7e3-410789a74a81"},{"claim_cluster_id":"fd96ef0f-c2a3-47f0-b0ee-4580d498d313","event_cluster_id":"0be1925a-4753-4905-9510-39b869eaa6c5"},{"claim_cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","event_cluster_id":"4ae785fa-8876-494b-8048-bcaeeb28e317"},{"claim_cluster_id":"57752645-2ac6-4482-9e7c-bbaea1506cc5","event_cluster_id":"869d4c13-d074-42b4-bbc1-2f3f74bed7a5"},{"claim_cluster_id":"e521c1db-8ae4-48b6-83c6-efbd02701f4c","event_cluster_id":"19e2179d-5af7-4b00-a62f-bafff28190d0"},{"claim_cluster_id":"61b758fd-ce2c-4502-b494-9618880e66e4","event_cluster_id":"4fdc1bfa-2d9c-4f20-8628-a8f4ff72ccc1"},{"claim_cluster_id":"21b4d7af-e8bf-408f-b63a-f91c28b7ba72","event_cluster_id":"12ee6320-67eb-4e37-918e-874e1948fd36"},{"claim_cluster_id":"a8dc28b0-9676-46fe-a3b7-8eb8e563deb8","event_cluster_id":"4eaa501e-252e-4e04-8606-fd467f380267"},{"claim_cluster_id":"71a82b79-aaaf-4fee-8e73-d292675a2e3a","event_cluster_id":"8dc116ab-03c9-451e-bd40-127719cd94fb"},{"claim_cluster_id":"b49a91d7-446b-421b-9670-7c99bbf5bc28","event_cluster_id":"e2924858-e631-4f3d-8b15-9f5ee8ab3b4e"},{"claim_cluster_id":"997de204-d7ea-4e15-b208-ebc2bd4ddd62","event_cluster_id":"6f88a50d-7c8b-451d-b706-e766cfe9a47a"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"6fb5df41-d443-476b-9fcc-1bb07e6c9654"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"c25ff750-8a41-47e3-b517-245284092082"},{"claim_cluster_id":"0e225927-1e3a-42e7-9ee8-7f9c2bae0dc2","event_cluster_id":"06b0b383-d1f3-4b0b-96d7-d1ed1424d080"},{"claim_cluster_id":"cb357706-7b58-4396-aa24-1c59beae87fa","event_cluster_id":"75279036-9309-48c1-9fcd-8d4eebf44481"},{"claim_cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"d59582f7-7e86-41f9-a084-db1da2a740db","event_cluster_id":"c1eef27a-1e7c-4cf7-af1a-61c89699baa9"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"f57aa067-2ae8-4cb7-8526-f9e921a1522a"},{"claim_cluster_id":"f0d99bfd-e20a-4b87-9be0-a227af6f681d","event_cluster_id":"73834fa0-ff83-4c9b-a609-95e04c072ab7"},{"claim_cluster_id":"577be512-045b-4f32-8688-400d686a100d","event_cluster_id":"c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"},{"claim_cluster_id":"1a853cc3-9e33-4539-b70a-cc51380d7526","event_cluster_id":"1abec326-fbb4-4834-a440-05a48bbfed29"},{"claim_cluster_id":"e12046ad-ffee-4bf5-90ec-51d127135711","event_cluster_id":"a3d2131c-63fa-494b-a0bb-572e611c5c5e"},{"claim_cluster_id":"7b1c03fe-e3e1-476b-ab84-c44a6ea52022","event_cluster_id":"aa310c78-7994-4d40-8f0b-2bea418f42a5"},{"claim_cluster_id":"9fb5216e-3d0c-403e-a2bf-9368fa3e3592","event_cluster_id":"002cfac3-c97a-4ec1-b743-37eb0267aef0"},{"claim_cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","event_cluster_id":"503eed9f-ea34-45f7-b3eb-f015bdc664b3"},{"claim_cluster_id":"bd4c7f11-9866-4656-98e3-7341cfc6de34","event_cluster_id":"ed1ec0ec-9794-4ebc-ab7f-279232e95886"},{"claim_cluster_id":"96cef335-1ca0-48d6-912f-d308e0729c0b","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"a751c83d-9da2-48e9-83a8-bc6d8a1c455f","event_cluster_id":"d26a88d8-31d1-4986-9e0c-b30944f01491"},{"claim_cluster_id":"86bae394-d674-498b-bd18-aa3046f40d19","event_cluster_id":"a59ccb39-5f94-4ce9-bc2c-828e0325e1b2"},{"claim_cluster_id":"be023ca2-f865-4811-854e-b40ab442412b","event_cluster_id":"a7318687-bec9-447f-89a2-3a9e7981d92c"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"8d5cbaf2-a64f-4a10-8901-a0b4a2c4582f"},{"claim_cluster_id":"f4175686-5e4d-4fb0-a465-bed7586f6615","event_cluster_id":"53a74c73-495d-4f2b-8724-c28415d16065"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"2b84f92b-3438-4364-9cac-d11edad425f9"},{"claim_cluster_id":"8f273fa4-f8bd-4413-8ce1-7183b77e2566","event_cluster_id":"c16a80f4-74b2-4799-878f-766f008df3df"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff","event_cluster_id":"24cf159f-beda-439d-a5c9-ae442b6d0260"},{"claim_cluster_id":"0fde95b6-db57-45cd-b6ac-fb0edd1b186b","event_cluster_id":"dc0f2fc6-867e-476a-b8e1-8031edcf72a7"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"4f331c05-6fa5-4bd8-adc2-5458e8c80843","event_cluster_id":"d152f743-9bb8-4932-b2e3-17b89ab993fc"},{"claim_cluster_id":"ea316b29-c411-49a8-8ebd-8e50456fc746","event_cluster_id":"7bf16433-80b0-4f9a-878b-7a95d835ad86"},{"claim_cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","event_cluster_id":"cfc691ea-395c-407e-9d4f-47222067d9ee"},{"claim_cluster_id":"ae1d4689-4f04-4acd-a0d9-2c0934c3acd4","event_cluster_id":"b3af6432-57a3-4958-a1a0-2d28085f3e29"},{"claim_cluster_id":"24e1d750-e055-449a-83a7-236e590f0e5b","event_cluster_id":"bb498dfb-0342-4611-a82f-6ce424759a23"},{"claim_cluster_id":"168a2344-84cd-4fca-8692-ada3563a273d","event_cluster_id":"36e1cdef-b33a-4858-bed1-0bbaf9ed9bc4"},{"claim_cluster_id":"c830c75d-93e2-4842-b468-b89a47252719","event_cluster_id":"30cd928f-5775-4679-a8af-3acd8dd1a21e"},{"claim_cluster_id":"2e620f14-db3f-4f94-9e90-7ae11cf68067","event_cluster_id":"64ddad58-c0e5-4850-be27-0ed962a47441"},{"claim_cluster_id":"2d7a7088-3ced-40a0-9677-1d14e1c26d8f","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"6015f261-315c-43b5-ae1a-b6f1ad2e1ce6","event_cluster_id":"d18f265e-1140-4ce3-9bf4-76f0c6ccf8de"},{"claim_cluster_id":"6a4b35a4-0785-4292-8587-aee85db61288","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","event_cluster_id":"615888f6-5d35-4a8c-acd9-9e71127a4cb4"},{"claim_cluster_id":"90a4e218-d5e9-4e12-b842-f6c8e272cb28","event_cluster_id":"9893c9eb-e787-4810-bf5b-6340ac0c0c07"},{"claim_cluster_id":"281fca06-ede2-40bc-9960-0788b1d20c23","event_cluster_id":"dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"},{"claim_cluster_id":"9594285e-8196-4153-9b31-89250a7200d5","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"baa70e51-5ce2-4e6f-8994-d85027e6b1d9","event_cluster_id":"637433ac-6811-450b-94c9-8c40811c8f6a"},{"claim_cluster_id":"d37ab208-5122-4b14-a2ce-fa0d51ab2a4b","event_cluster_id":"864c05a2-76fd-45dd-8aa5-97a6e22bcf53"},{"claim_cluster_id":"d9041723-b3d2-4f6c-85e6-435010ef6231","event_cluster_id":"7fa3c63b-2bb5-48ea-95da-cc1ed541a317"},{"claim_cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","event_cluster_id":"77ff5800-b905-4e32-87cc-e4de9525bb38"},{"claim_cluster_id":"8992a182-5ede-4dbb-9979-4dcf0e10c546","event_cluster_id":"6274b067-d713-4a61-a1f2-5f2f2d2df7fa"},{"claim_cluster_id":"57752645-2ac6-4482-9e7c-bbaea1506cc5","event_cluster_id":"232c00d5-5161-4308-8ff9-5bf29dea48c9"},{"claim_cluster_id":"442dded8-bef6-49b2-b7d4-70454c6e8e79","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"2b7a55b4-92f1-4438-b42d-086b564be154","event_cluster_id":"e5868b04-4cec-4d02-b896-8db4cc7180db"},{"claim_cluster_id":"cfde4319-eb6f-4277-956f-9a094157160f","event_cluster_id":"3923fc76-d76d-4386-926c-4e8e39862387"},{"claim_cluster_id":"3eeddc05-77ec-4d67-9a78-4b328957fe7f","event_cluster_id":"86986259-8535-49c7-b1f7-162a0bd7065f"},{"claim_cluster_id":"37f5cf93-69fa-41bf-960a-1fd7783d4299","event_cluster_id":"da0898ac-2eb7-477c-8e02-e9f17ebb39af"},{"claim_cluster_id":"7e1a378e-1366-4ff2-9282-46ddc9975cc6","event_cluster_id":"53dbd851-31b8-4afd-8a69-b5ebc32a8f7b"},{"claim_cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","event_cluster_id":"0cb84281-0a02-4551-a9b6-e0952da929f7"},{"claim_cluster_id":"8fed35fe-4af1-484a-bd4d-74f9fac960c8","event_cluster_id":"e3403237-7c1c-4e7a-9604-df8d11301d8d"},{"claim_cluster_id":"3b1124a1-83ad-4acf-aefc-fa570a669706","event_cluster_id":"71b309b2-2dda-4212-a921-75eae9813c5d"},{"claim_cluster_id":"e03ac9ce-f105-49c9-9a2f-9442b3b31044","event_cluster_id":"a263e3cc-09b2-4ae5-a252-4665ad483b52"},{"claim_cluster_id":"e2a085c3-49f3-4799-87cc-2b59f85d4bb4","event_cluster_id":"a54ebcea-b85a-4358-b8f9-7f678d18fb51"},{"claim_cluster_id":"689e5dcf-938b-411b-9e5b-4de3aa6f026b","event_cluster_id":"3112aa1b-4574-44ce-bed2-c9c9be423dbd"},{"claim_cluster_id":"02aff357-d128-4a8d-9828-60ab97d0e632","event_cluster_id":"aeb3174b-bc91-4fbe-9027-0eda5304183e"},{"claim_cluster_id":"64599826-faee-4fcf-9432-967663d05451","event_cluster_id":"a7c1c7dd-20e8-417a-8b0d-915fb535b95c"},{"claim_cluster_id":"b49a91d7-446b-421b-9670-7c99bbf5bc28","event_cluster_id":"1c4341b5-18d5-4ba6-a313-e14ad3c93bc5"},{"claim_cluster_id":"97507c06-9158-4dec-af84-2ca3daa906d2","event_cluster_id":"6ddc553f-506b-402a-87ca-b781b2c60932"},{"claim_cluster_id":"bbe7fdd5-62f8-403f-97fb-16e838e19a59","event_cluster_id":"86d86a3a-37c2-4eef-9deb-93d9580b80d1"},{"claim_cluster_id":"1c30353a-a7dc-48dd-bca2-56c91aa06ab6","event_cluster_id":"d3085fed-3741-4d75-9105-e8b0b3511de6"},{"claim_cluster_id":"29bf0ceb-12c5-4f73-8a36-f5d689e7afd2","event_cluster_id":"baef31d1-0183-4a82-91e5-3ce55345b1d6"},{"claim_cluster_id":"503584d7-75a5-4f03-adb1-4844dd4d9b9f","event_cluster_id":"71c5fa4a-0b53-4202-9b3e-1c8038451d63"},{"claim_cluster_id":"e28e105a-739c-4f5f-8b79-8f56f435e121","event_cluster_id":"36b001d3-8cd6-4b58-93ae-5ad737efa236"},{"claim_cluster_id":"d0814fdc-170f-48fa-8def-5a656118ed2d","event_cluster_id":"df890887-499a-48f3-b818-746e4296c3f6"},{"claim_cluster_id":"c537cca1-8aec-41b9-96db-837f4d59c8e4","event_cluster_id":"a36a54af-ea36-46fb-b97e-4f17594784b7"},{"claim_cluster_id":"ea6a2243-de2d-4dba-b6c1-70fc6e903bfb","event_cluster_id":"a33e2184-c58d-453d-a647-1ef27ddf5c17"},{"claim_cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","event_cluster_id":"baa5172c-8725-4cca-b3be-5d512cf618a1"},{"claim_cluster_id":"7bf4f678-55d5-4f6a-922f-0b5de572f033","event_cluster_id":"2c6c7495-70ee-4e85-b85f-579b0d1c01ac"},{"claim_cluster_id":"5cb260df-5e4a-4685-94d3-087687f5dbed","event_cluster_id":"ac86516b-573a-4ca5-9a1d-d4dd1666f20a"},{"claim_cluster_id":"fcbed875-f592-4e43-93ba-c1c4ead8d38a","event_cluster_id":"7c268167-b621-480c-ba79-7005ed13e2de"},{"claim_cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","event_cluster_id":"32e37585-3bd0-4873-ab47-c364fef5143f"},{"claim_cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","event_cluster_id":"5f1d9f8e-2516-4e42-a0a6-815bb97110a4"},{"claim_cluster_id":"e9d22d46-e0d1-45b7-b109-afc6516146e1","event_cluster_id":"60f0b8f5-f6ce-4be8-993b-d99ea8933141"},{"claim_cluster_id":"d30cdd9d-92e1-44ac-aad9-845702e1559f","event_cluster_id":"2f3684a3-db51-45d5-8ab6-a0d061f2a667"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"2d8a2b96-5e68-43e2-a162-f66eeb390e13"},{"claim_cluster_id":"b31e61b9-2010-4063-88bd-0eced0599429","event_cluster_id":"44105fe2-7f1b-4985-910c-f4a271b0cca1"},{"claim_cluster_id":"12605708-2ac7-455e-a636-1d8a235af813","event_cluster_id":"86797f95-8265-40b4-9a2e-f9574ce9ab8c"},{"claim_cluster_id":"175bdcd7-0fff-45d5-9e67-f78e69286a6f","event_cluster_id":"af0ec0ab-3b4f-471b-b656-e88e02335b8a"},{"claim_cluster_id":"69638d1f-f33d-45d8-beac-6ee7ce61ea29","event_cluster_id":"55351f66-3ce1-4720-a5bd-bce9d2bab5d2"},{"claim_cluster_id":"1c849e20-6024-47fa-80b4-e611385ba612","event_cluster_id":"d4ecfa56-5354-4519-b8ae-d7dff0864186"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"cc1a98ca-fc1c-4f29-b58b-0d99bce8b809"},{"claim_cluster_id":"5b4b432d-262c-43d8-a2ca-4d8a45a3e1de","event_cluster_id":"cb02ee47-9033-4860-896e-93d4dd3bca66"},{"claim_cluster_id":"449f7a4c-3966-4db6-9cf4-d39a2f15feae","event_cluster_id":"639772f4-84fc-47d4-a44e-cd508a3d7e6a"},{"claim_cluster_id":"c94810e3-5711-44bc-a55f-5ef59645cf78","event_cluster_id":"e1299aca-73c3-4bf2-9656-1a4bc5aa21cd"},{"claim_cluster_id":"f83b448c-d81d-4175-b604-2783d1df502d","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"3249ee55-684b-4bbb-8b52-6766f62838f9","event_cluster_id":"c48b1546-3855-4755-8da6-3e9352505d7a"},{"claim_cluster_id":"3b7e3ce4-4e60-4c09-986c-9b9376d80c8a","event_cluster_id":"5561c312-8b94-44c1-8be5-5ceb08c13061"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"cfb29440-b86f-4923-96db-5f6b8ae72df4"},{"claim_cluster_id":"642bd570-9063-4bca-8050-702e322b8b3c","event_cluster_id":"d7ce0029-7c2c-40fb-8d24-32029ffa4b81"},{"claim_cluster_id":"d10a4ec7-a74e-4016-996b-f1f3a3c6527f","event_cluster_id":"2b56b1f6-1627-44ab-9460-b13751cf087b"},{"claim_cluster_id":"cd37a888-7bea-44b1-9691-e12e7c11fac9","event_cluster_id":"1f4a4adb-de76-451d-aa05-57dc41f8014d"},{"claim_cluster_id":"0fa9f6d7-64f6-4933-aae8-3cfd512cab5c","event_cluster_id":"d0a50ea8-30f3-4820-8087-1083e0d5b05d"},{"claim_cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","event_cluster_id":"3014a508-0ddc-42e0-9480-97e1310e1f29"},{"claim_cluster_id":"de56a9d8-47ef-4820-ac13-06ed6f8760ef","event_cluster_id":"f8830cd0-0851-4651-a6ad-3f181547090d"},{"claim_cluster_id":"e0c5a85f-7145-4366-aac8-58cd212f7e6a","event_cluster_id":"78c613ac-a6ce-4fc2-859c-265be8fa23d8"},{"claim_cluster_id":"fc40e900-5f3a-4200-9723-06366e139ab4","event_cluster_id":"4a483622-b245-4e23-bd10-793b05ae9fe2"},{"claim_cluster_id":"6717f23b-7a46-4774-9d7d-76c5eb0bdde2","event_cluster_id":"83537dd5-17fd-4fd5-9899-58a782adb8f8"},{"claim_cluster_id":"469a2781-0070-451c-bc21-b7ee2b0da3f0","event_cluster_id":"6781bc51-3496-4995-a431-ee10c271f91c"},{"claim_cluster_id":"883c65b8-c8f1-4a3b-8bd5-fb9d61a95876","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"38eef897-6e59-4836-bf0e-1e7e106baf53","event_cluster_id":"da887573-bcbf-4c6d-8541-c47ee99de6f7"},{"claim_cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","event_cluster_id":"a80e30ca-b2de-458a-9b37-eea9f6f3a278"},{"claim_cluster_id":"58a44cd6-3f44-4460-9d07-d5a28bd55747","event_cluster_id":"9d77a640-6134-44b7-85bb-43fc8324bd77"},{"claim_cluster_id":"a4d61819-30e3-46aa-ab08-cf879db00de1","event_cluster_id":"cf284659-5e8d-4417-9c7c-b41b8155ecf8"},{"claim_cluster_id":"58bf9f4a-adda-4853-802b-78d04aa711fa","event_cluster_id":"e069f39e-fe04-4587-9d2f-1992b7189502"},{"claim_cluster_id":"4d2c8d1c-73d7-42b1-87cb-56c8ddf68982","event_cluster_id":"88549cc5-91d9-499e-9367-819f2a75e847"},{"claim_cluster_id":"3232bd90-9251-47f0-ae93-ae2d51218354","event_cluster_id":"e657af4a-ab5e-4efa-9539-dbb94e69e772"},{"claim_cluster_id":"09907625-9889-4def-8ff5-b61d82ce4a21","event_cluster_id":"08268346-74f3-44b1-a6ed-3517ea134f57"},{"claim_cluster_id":"1c220b25-802f-4053-89c5-d8f4805341a5","event_cluster_id":"c9895da0-2b5a-466d-80f2-7637e4a4aa2f"},{"claim_cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","event_cluster_id":"a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"},{"claim_cluster_id":"fa32fcee-2bb1-444a-8515-123065611c9e","event_cluster_id":"ace987dd-fefd-4144-a25e-4a8cd1ec09c0"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"5317331a-d0a9-4595-acad-210a92b278d8","event_cluster_id":"42214595-36bd-4891-862c-e83b3aae0a8a"},{"claim_cluster_id":"3dd1bcbf-32ed-443e-a942-a8e7446ea6d1","event_cluster_id":"cd8387d2-f3fa-45cb-9628-ef16bef4b5fa"},{"claim_cluster_id":"86478e14-8f65-4b25-93ee-a6036b9de886","event_cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"},{"claim_cluster_id":"b9579765-0e2f-429b-a723-006d6265617d","event_cluster_id":"b816fa39-a961-4930-9c7a-6091dc870326"},{"claim_cluster_id":"1b63ec5b-2010-4bd3-a351-328e7b4b5470","event_cluster_id":"df948051-689d-40a8-ad8a-28a2dedfe405"},{"claim_cluster_id":"aef50142-8ad0-4099-9362-3d45c56385fc","event_cluster_id":"97137b20-3c93-43e9-b1a9-879cf76db9bf"},{"claim_cluster_id":"0b331741-7f54-4613-ad60-e935b60f7fbe","event_cluster_id":"7efa0178-d8ab-468b-a654-e8cca19d755a"},{"claim_cluster_id":"0e2fe0e5-314e-4455-88c7-a13f3f6e7728","event_cluster_id":"efc4ab9a-f965-4202-ac72-ebf2fe08724d"},{"claim_cluster_id":"d3037252-9ff2-4032-ae65-41b104560fbd","event_cluster_id":"4941bed1-24d8-4571-89bb-5872a51c53ed"},{"claim_cluster_id":"ffb2c778-a1f6-402c-8381-54550bf56799","event_cluster_id":"a4887daa-dc3f-4a40-83f8-3598cedca9f3"},{"claim_cluster_id":"166b6595-ba80-4fe0-a5a2-70307703e855","event_cluster_id":"e4d7e062-89f9-4cad-84e1-ea4d0fd566d5"},{"claim_cluster_id":"ea43c4dd-2096-4292-b914-5c467c6f33db","event_cluster_id":"9054d5e2-4b4d-475e-9960-73215a5d44f4"},{"claim_cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","event_cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"4bee04c1-3125-4580-8ea5-cbdb4fd88ca9"},{"claim_cluster_id":"7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1","event_cluster_id":"2a61add2-cedd-40b1-9edb-ca1cd948e8c9"},{"claim_cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","event_cluster_id":"d47fde78-a16e-43e2-a490-d66e81b31f7c"},{"claim_cluster_id":"aa908c8f-4075-45ac-a932-631e5efec76c","event_cluster_id":"5bdf6eac-3c30-44f7-ad10-121cdd88f987"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"f5798794-c4ea-4a9f-ad2e-0bf496c0ed12","event_cluster_id":"d310e1f7-ee8b-4fed-be89-8b1baac91b0a"},{"claim_cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","event_cluster_id":"903c3f33-319a-4f0f-a3a0-b3ad86d56e86"},{"claim_cluster_id":"63fd0e17-6b29-4f19-b984-a861fba2eb14","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"b5aab15d-0623-4834-b9a0-c066e3616369","event_cluster_id":"09cc9ddb-b9ec-4c5d-8b8e-25af134763fe"},{"claim_cluster_id":"f1e6bad8-e9ca-44bf-84f3-62dac4bddd1f","event_cluster_id":"121c0233-5b70-408f-8b70-e5ac0b37c748"},{"claim_cluster_id":"2712567d-2895-48f5-8695-f726eb795979","event_cluster_id":"154bbf48-da4f-41b3-ba55-27ca50e6fa44"},{"claim_cluster_id":"d3913637-42d6-426c-8654-a13850b8306c","event_cluster_id":"14a22666-bc11-493d-b981-1e91858f0777"},{"claim_cluster_id":"ad1e5e4c-10d0-4756-a4c9-29132a1c66dc","event_cluster_id":"fdcc5ead-3f56-4e70-b1c1-bcb723b24f72"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"dcb6ab3b-ae6e-4735-8a60-de8d2d30332a"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"4fdaa1a3-7430-423b-81e3-be520cdd6936"},{"claim_cluster_id":"b1abd415-ce48-46da-b8bf-36f727bba7c7","event_cluster_id":"193775cc-4b10-4b36-baba-844635425d37"},{"claim_cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"746179fc-962b-4500-916f-ca22a3a202d9","event_cluster_id":"e0e1af6a-37f3-439c-b966-bdff95698e49"},{"claim_cluster_id":"49c94f1b-b278-42a0-b8b7-d0f8ec55d536","event_cluster_id":"a51db09c-f39d-441d-9164-06ba998d58ef"},{"claim_cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","event_cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"},{"claim_cluster_id":"634ebbc5-474d-42c0-bf34-498666dade49","event_cluster_id":"f8620270-b25d-43a1-ab67-3efa1d1f6e6b"},{"claim_cluster_id":"48cca002-8003-45bd-92b2-3e2945a33b48","event_cluster_id":"249e8c50-f68d-47af-99c9-2bc6ddfd52ad"},{"claim_cluster_id":"28feb358-2926-4cba-8425-f09fe5ebab7a","event_cluster_id":"fd67a670-bb1f-429a-b83a-c92989f510e3"},{"claim_cluster_id":"48ac478a-0a47-432d-9d71-30bc821691af","event_cluster_id":"6c9f4959-d341-4a88-80e2-4c73e592884c"},{"claim_cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","event_cluster_id":"4e97ff0c-8732-4960-b274-1090e77ec733"},{"claim_cluster_id":"85d98ed5-328a-4d59-91fb-32ddcf786d50","event_cluster_id":"e10095d2-279b-4481-ac92-6fd4df698726"},{"claim_cluster_id":"cb357706-7b58-4396-aa24-1c59beae87fa","event_cluster_id":"2ebae150-b502-48c5-b8c2-6a7238a86864"},{"claim_cluster_id":"54bf8eb2-6975-454f-a48b-59abffdfe4f4","event_cluster_id":"9917626e-0afd-495f-82cd-6e27aa8cc73d"},{"claim_cluster_id":"99dfb4e4-9788-4ea5-81a7-c0dd44f60aba","event_cluster_id":"76ca8734-57fa-4978-bce4-584836cb98e4"},{"claim_cluster_id":"63fd0e17-6b29-4f19-b984-a861fba2eb14","event_cluster_id":"55326ca1-c9a2-4aca-a1ea-bd63160c25ea"},{"claim_cluster_id":"f74a80e3-1327-4636-a252-f4ca8a5b90f7","event_cluster_id":"84fce8b4-ea2c-4b33-883a-03817afe99a2"},{"claim_cluster_id":"5a787097-c657-4d02-a7e7-ce5ddfe404d6","event_cluster_id":"b1943af1-84eb-4734-88d0-58f88d216275"},{"claim_cluster_id":"6d226b20-d54f-48d2-bd7d-2616184afc68","event_cluster_id":"b9073e54-b54f-4298-9384-944112b843d7"},{"claim_cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","event_cluster_id":"9c176d07-6751-4585-9c31-c558b96a7b39"},{"claim_cluster_id":"1ed92023-b891-43ab-ab0c-b464c243f2b0","event_cluster_id":"914bd639-81ab-4467-a8c1-07b0f59b2871"},{"claim_cluster_id":"77de864b-c2fe-4a23-a506-d0665b0f08bf","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"d67b58dd-cbc9-4a99-aab7-b31e7a922343","event_cluster_id":"4c1f4530-7a84-49d9-bd89-b51ceb8c5ce5"},{"claim_cluster_id":"464aaab3-50a7-44d6-8c7a-bdc722ee9f18","event_cluster_id":"ce2516ca-003d-4806-948a-12eea340aa15"},{"claim_cluster_id":"fec0d44e-dff3-4478-9317-1b1d954f03c6","event_cluster_id":"568dc264-fa77-45fb-8b1b-5c901f185f7a"},{"claim_cluster_id":"b6c282dd-0c14-4dab-a6ce-3f5caafc52b8","event_cluster_id":"f11e573c-d0ea-44be-a8b4-5ff5949c0ecb"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"ba65859b-0b3d-4140-bf84-cf55b1252051"},{"claim_cluster_id":"589240bc-a0dc-4961-944a-a3594262e220","event_cluster_id":"50f3c500-b81e-4af2-91c4-9121494d6350"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"5cc3d51d-5e99-492c-82ff-4024c6eb9503"},{"claim_cluster_id":"8a2e1f2c-6d19-479b-811f-3ccec4820a64","event_cluster_id":"acf832a3-5be5-4fad-af20-2e71b7b538f5"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"9cacf170-b6e2-4913-a621-eaff66a64541"},{"claim_cluster_id":"4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d","event_cluster_id":"32be984b-e9e5-4559-b00b-15885afc33b8"},{"claim_cluster_id":"d92fe55e-695c-457a-af52-c6044f0ca9ec","event_cluster_id":"ff2e5690-b7e6-4963-9d4c-23d9e31d0e98"},{"claim_cluster_id":"0726cfa9-d89b-45b4-922f-553fde14346a","event_cluster_id":"2bd0b47a-c8f5-4e58-b230-5a58686ed27d"},{"claim_cluster_id":"0a4b2521-caa9-4365-ba6f-ee42c89824c7","event_cluster_id":"0a675e77-bb90-44f7-8297-ab44add96136"},{"claim_cluster_id":"d0619b32-28c7-4624-9e6b-8c81d9ff9019","event_cluster_id":"dfb119a6-40b5-4824-8a20-9b636bd6f4b8"},{"claim_cluster_id":"612e1b04-721a-48bd-b18f-300c7c5af276","event_cluster_id":"0b61ebc9-d9b1-4e5b-9094-6829b839c660"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"d7765332-5dba-4716-b432-1311de3172a6"},{"claim_cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","event_cluster_id":"cef4b627-4828-4a00-9a55-7f92b9804c1f"},{"claim_cluster_id":"29009c7f-3a77-46aa-91c0-d0f703c52dab","event_cluster_id":"718b8058-1e91-4465-aeff-7514749404e5"},{"claim_cluster_id":"7f7310ca-5512-45fa-8f93-1b6555e791c0","event_cluster_id":"ea25dfa3-b506-4476-b1e0-0c164e97dea2"},{"claim_cluster_id":"dc464eb9-fc48-4646-8985-9de6d7531d3d","event_cluster_id":"e6f89802-3df1-486d-8ad4-82cdb658549b"},{"claim_cluster_id":"c830c75d-93e2-4842-b468-b89a47252719","event_cluster_id":"8b1769db-6aae-4f31-8eca-13c7641a8a79"},{"claim_cluster_id":"dc3308e5-2250-431f-bef6-733e2b943275","event_cluster_id":"86c9a6a1-8859-49b1-869c-febe929feb9d"},{"claim_cluster_id":"de15f7d6-5167-45b1-bad6-235dd16ae15e","event_cluster_id":"449fd6e4-9161-4742-8b9b-bd7cd0c9d571"},{"claim_cluster_id":"3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8","event_cluster_id":"d419e57d-59b3-4e7e-beeb-1d52b9c76608"},{"claim_cluster_id":"d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3","event_cluster_id":"96455f92-cde3-49f3-934d-a55b0a31ccd5"},{"claim_cluster_id":"1cbddfd6-c491-40b1-b10c-fd4387edddf6","event_cluster_id":"de50b1b9-cb34-4bb1-b3ae-d6dc4e19797d"},{"claim_cluster_id":"469c5194-5b04-4e90-b62c-73b3f79a0955","event_cluster_id":"cf59a1ef-ed9e-457e-802d-c83df70e42c0"},{"claim_cluster_id":"9dbb0955-d2fa-4dce-a46f-5ed43c9e3231","event_cluster_id":"a1ec3b11-8549-44c4-b19b-7113d02a1c7e"},{"claim_cluster_id":"07bacc2e-cf13-4467-917c-ef3c2aa505ca","event_cluster_id":"8b923490-b752-4fe2-9b0a-01c4a9d8d4b7"},{"claim_cluster_id":"71acf2d0-be7b-4d8e-b3fc-93baaa073aa1","event_cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c"},{"claim_cluster_id":"2d5d8472-462a-48f6-89fe-e8182a74e9c6","event_cluster_id":"6773439f-27bf-46ee-884f-6f78667de502"},{"claim_cluster_id":"0a0436c8-54af-4b5e-9725-fc8ed172d1cc","event_cluster_id":"7e444e77-337a-4bc6-8707-11c965b7d9dd"},{"claim_cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","event_cluster_id":"3ff9d247-61b1-4db1-b0eb-87ae85150e08"},{"claim_cluster_id":"729ff499-2dcf-4524-91fd-7e53fd6e6ad7","event_cluster_id":"b6692507-59c3-458b-bc20-9fc0bbf648db"},{"claim_cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","event_cluster_id":"a13b9666-44db-4c37-94a0-689f377da92a"},{"claim_cluster_id":"bed08ef5-4cb1-4f05-b2d4-a996242acd93","event_cluster_id":"823e369f-d264-405c-a8ab-0edf1095b0fc"},{"claim_cluster_id":"ff43bfb6-1ab6-422e-8045-756b71e70dd1","event_cluster_id":"d56b27d7-daff-43e9-8fd0-8b6cd93b5536"},{"claim_cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"35ff7a5e-40b8-42ad-9379-7ba830c9445f","event_cluster_id":"cde4816a-67c9-4232-8144-e08a59a84d64"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"7b4680b9-9676-4736-8ed2-d06a2da6ea63"},{"claim_cluster_id":"e0a99d28-f3a4-477a-b874-8d839c4523f9","event_cluster_id":"95cbf6a7-3664-47e9-8189-3ff3dc6eb96e"},{"claim_cluster_id":"d7cbd37c-10fd-4628-bba8-b434c41ec43f","event_cluster_id":"39f8cdcf-5b14-42ea-aeb8-d3dfeff54bca"},{"claim_cluster_id":"bee4d72b-b159-4b6c-830c-362b42a2b18d","event_cluster_id":"99266a9c-deac-4cbf-b039-93976c0d571b"},{"claim_cluster_id":"4a575d85-5f97-4baa-be78-2c26ecefb471","event_cluster_id":"714c01ca-5d76-4ae8-b75a-06245aaab86c"},{"claim_cluster_id":"3198b672-2780-47ef-8885-73e8c5597d80","event_cluster_id":"b8d995c0-360e-40c1-b216-5c539da3c67d"},{"claim_cluster_id":"36b91493-5f3f-412b-a861-2328c6420cc6","event_cluster_id":"66399bf8-97ea-4b4e-aa54-9b68d82943d5"},{"claim_cluster_id":"f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb","event_cluster_id":"5949d818-e369-4db8-949d-7a462c260498"},{"claim_cluster_id":"aef50142-8ad0-4099-9362-3d45c56385fc","event_cluster_id":"ed6634c6-cfd9-4bcd-92a4-6a9685e6700a"},{"claim_cluster_id":"866c589b-e7dc-4cab-81ad-6d235278edf1","event_cluster_id":"8eff5d20-7a2a-43cd-a95d-697a2eb3fa48"},{"claim_cluster_id":"7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380","event_cluster_id":"b69ad8c1-f3a2-41d7-805d-8cc01784789b"},{"claim_cluster_id":"1a853cc3-9e33-4539-b70a-cc51380d7526","event_cluster_id":"769dd442-b312-4ca1-8bda-308188e59a4c"},{"claim_cluster_id":"1542a1c0-0498-4551-b3c6-794eb9ae6305","event_cluster_id":"503d3ee0-00d1-464f-abcc-e8b8f12f26a4"},{"claim_cluster_id":"43e40d68-962f-4fc6-83f4-ab836f751e9e","event_cluster_id":"752e0a5d-00fb-472d-909a-65284c58e6d5"},{"claim_cluster_id":"b6c851f0-a597-49e8-982b-650d02a8ba55","event_cluster_id":"0133f004-4682-4cbf-aa32-305a065f5e30"},{"claim_cluster_id":"30d2edfa-6d58-40ae-bac6-ec1273c415ac","event_cluster_id":"f6f5b331-ac46-4d22-8195-ed8a8b14d117"},{"claim_cluster_id":"d6c74194-ae1f-4099-a13b-0f247e76b288","event_cluster_id":"e0229a55-a637-4111-a422-27c8a7ddb0b7"},{"claim_cluster_id":"fd424526-ed4e-4b80-99b4-1b131a22e381","event_cluster_id":"67b88198-8628-4938-a751-4acddbc9098d"},{"claim_cluster_id":"d0323adb-673d-4daf-86e2-8d0f732fd9ed","event_cluster_id":"b2700cb5-512c-44b4-a7d2-f6f79575e42a"},{"claim_cluster_id":"90cb536f-af14-4df1-9bdd-da6d690522b4","event_cluster_id":"9dec00dd-14cf-4956-9ce0-5f9d8647e24d"},{"claim_cluster_id":"5767d0cf-3070-412a-9136-a29c287f15a1","event_cluster_id":"cb297a6d-5ff4-4958-bec0-67e510f9e369"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"d1aa87f5-6e8b-45d2-89ab-5267e8136707"},{"claim_cluster_id":"1c1848e6-9c28-4252-9e24-4dc5cb477be6","event_cluster_id":"a1ee8def-adc3-431c-a4cf-3b3370e7d6e5"},{"claim_cluster_id":"df94ae50-99ca-4e54-802c-ae4f92bf2a1d","event_cluster_id":"a2109d36-1708-4075-ac3d-fd40a7eea59b"},{"claim_cluster_id":"1574223b-5ec0-4588-8996-6510aa3052d6","event_cluster_id":"acba4f1a-9129-40e6-80cc-1b3cb9b40341"},{"claim_cluster_id":"86ef5628-f267-4ce6-97b4-2f06bd91a5fa","event_cluster_id":"4a33c4ea-c4b1-416d-9b76-df3e2b9c5ec9"},{"claim_cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","event_cluster_id":"9132970a-f73a-4805-97b9-6e1d8581a3ef"},{"claim_cluster_id":"3073b261-2ceb-46c8-bad6-3808fb657e33","event_cluster_id":"35b591b0-9a65-46c0-95aa-caf3b8dedd33"},{"claim_cluster_id":"7b578c6f-7be6-4c78-8bf3-3f66b6797db5","event_cluster_id":"b4d1a337-88d8-4989-8d52-1a04d38e6e21"},{"claim_cluster_id":"ab829976-d7fb-4b30-9b92-89eed4e94cc4","event_cluster_id":"fef1afb7-cb5b-46ac-9d94-a3b448d7fa82"},{"claim_cluster_id":"03b37d7e-0ed4-4014-ac24-a898719a8f87","event_cluster_id":"2c1c9214-d791-4513-8352-ad5103d53749"},{"claim_cluster_id":"d602e1f1-5446-4c60-aadc-beabd56dedd8","event_cluster_id":"5788deb7-8fce-4423-98fe-905a919278d0"},{"claim_cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","event_cluster_id":"72aa7b94-9121-4289-8302-01ff0cfe298d"},{"claim_cluster_id":"aac18326-5af8-47ed-b7a7-209e78b29dfe","event_cluster_id":"3ba6caab-43f9-4e86-aeca-830be9163573"},{"claim_cluster_id":"90ef35f7-8880-490a-bacc-f600f6a11162","event_cluster_id":"ba73d786-afbd-4fff-a554-010d1e65a4dc"},{"claim_cluster_id":"6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4","event_cluster_id":"0a822774-2208-4f62-a8c9-3dc70aeef8ea"},{"claim_cluster_id":"dd5d0634-bc30-45f9-b45a-97773c63db2a","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"6e45b980-570a-489b-b31b-a504f6b1257e"},{"claim_cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","event_cluster_id":"be17c081-a4ac-42d9-b909-7a4f19b8160b"},{"claim_cluster_id":"3198b672-2780-47ef-8885-73e8c5597d80","event_cluster_id":"a712c5f0-f65a-4cd7-abf6-1f0e442746d4"},{"claim_cluster_id":"f20e8a65-5412-4f81-81b6-1570f9619cbd","event_cluster_id":"e6a2f428-c0e3-4756-a96f-639a0339b06c"},{"claim_cluster_id":"47fbc359-0497-4aac-8a4b-e63bd060a1e2","event_cluster_id":"b6a2032e-1851-4e5a-bb1b-dbcd29c647ef"},{"claim_cluster_id":"b1da162a-fb28-4547-8fd8-715c5361b7af","event_cluster_id":"df3f868f-20bc-4768-8496-fc1bc0744474"},{"claim_cluster_id":"5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa","event_cluster_id":"faba4888-ade5-4854-a98b-43a187c3c84d"},{"claim_cluster_id":"0450cb4c-8816-4bbd-85b6-ac94ecde9af4","event_cluster_id":"a1e41680-35e4-4649-8fd5-66b72c5b42b9"},{"claim_cluster_id":"32bf3674-86a6-4cde-a9e5-20a5e3965e02","event_cluster_id":"120960ec-d747-4eeb-a10b-5a0b594f24f6"},{"claim_cluster_id":"8308c2eb-92cf-4ca4-876b-d1d947564441","event_cluster_id":"7abc7765-0bd9-4361-a00a-d261cc270c4f"},{"claim_cluster_id":"232994db-dcd7-4db4-9ea3-fad6185233a7","event_cluster_id":"c65c30a8-6203-4ff2-8126-866ddc1ad7ee"},{"claim_cluster_id":"8c18859c-7432-4cc4-af8f-8a5eb220876e","event_cluster_id":"47a07292-bc3b-405d-8d76-2c61690495c1"},{"claim_cluster_id":"ff920ca0-1e39-41be-ac8f-cd0534048634","event_cluster_id":"5dcaa7f9-db6c-4bc0-81d7-916cfd750a0f"},{"claim_cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","event_cluster_id":"d3accedd-14e9-432e-a272-98af2dae3b98"},{"claim_cluster_id":"3da4f222-08f1-4864-8aa3-3576d8a64207","event_cluster_id":"8b5f4d0a-57ca-4fb0-bc01-110872004685"},{"claim_cluster_id":"3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"fb95e7e0-9ac4-4fef-85ca-e17c4d83450d","event_cluster_id":"49ec4675-cceb-45d5-bbb2-56483fcd1319"},{"claim_cluster_id":"02fc2c1c-e5e4-40d6-92bc-a975544e0e30","event_cluster_id":"0ecafb9a-2141-4b23-a024-348c4e1719da"},{"claim_cluster_id":"aac18326-5af8-47ed-b7a7-209e78b29dfe","event_cluster_id":"51d0514d-a16c-49e4-8ac6-e122e83a4777"},{"claim_cluster_id":"7b4db769-a456-496c-a3b6-6f242fdb7665","event_cluster_id":"69563b87-ed4e-43d1-a693-c379aa9b1be9"},{"claim_cluster_id":"427b0ddc-d215-4989-8bcc-336ea7f1f9cd","event_cluster_id":"c61c4f53-7efe-4e66-9392-b281164f47d2"},{"claim_cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","event_cluster_id":"f70d2311-4ede-4f3e-b4d9-bb1c5def4b48"},{"claim_cluster_id":"626c75be-9b85-4ac5-97e0-e03b79d0191e","event_cluster_id":"3e73f675-0024-47f1-ab95-a4e974bdd22b"},{"claim_cluster_id":"8a60fc08-ff21-49d9-8858-dcff37e21d18","event_cluster_id":"fc762eee-b8ab-4b1f-86f1-0e64c2a63eae"},{"claim_cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","event_cluster_id":"0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"},{"claim_cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"e4f4246a-95d9-4d67-94bf-27725af4d71b","event_cluster_id":"9707f2e5-6c57-41c7-a2b2-7fd6a30159c3"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"6d7d1320-a896-4471-aa98-60a45946bc57","event_cluster_id":"a0a3d302-3c42-4ec6-a980-2d9ce3d3fb0d"},{"claim_cluster_id":"2b132e72-8cc9-4107-a55f-19ac99e2caf3","event_cluster_id":"10d521f9-b2ba-4e4d-ae1c-f8033a7f7147"},{"claim_cluster_id":"63ad18c0-00c0-4509-b669-2aff507b5502","event_cluster_id":"e3336914-7a77-4548-8764-1fd25cd393fd"},{"claim_cluster_id":"e840acd4-9152-4039-820b-b347beaec131","event_cluster_id":"49b59607-bcf5-4471-8809-4106f681d4d2"},{"claim_cluster_id":"5a77fa7e-06f0-487a-a93b-f15e590aa54a","event_cluster_id":"5b79ee45-2abd-45a2-8873-e58d11466b36"},{"claim_cluster_id":"bc70c00b-dffe-4092-a775-4a9734094547","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"fa361819-d60d-4532-8084-9c75390ba17c","event_cluster_id":"9dc49f5f-af39-44e0-aabc-c941b43e1bd3"},{"claim_cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","event_cluster_id":"b26ec24c-184f-463d-a8c5-4ef885956b1c"},{"claim_cluster_id":"3d3bbdd9-c2d6-4cca-8387-2ba3360ed3b8","event_cluster_id":"0de6c083-ab7f-4e7e-b4a5-f3e13198d24d"},{"claim_cluster_id":"689e5dcf-938b-411b-9e5b-4de3aa6f026b","event_cluster_id":"292fd491-c6f3-4ec8-80ae-030ae0db7baa"},{"claim_cluster_id":"9ffb85b8-5080-4f27-85ad-554406cf7402","event_cluster_id":"5d65bb29-7381-44ed-8856-ec52d73d0a76"},{"claim_cluster_id":"aae7438c-bb2b-4e87-86b8-fc77cf6148d1","event_cluster_id":"4e67b541-7502-4017-a45d-06f9dbc9f516"},{"claim_cluster_id":"245874be-060a-4ca6-afe3-3a367b00ddb5","event_cluster_id":"b794c66a-ad77-44ca-8ddd-457a68feb34b"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"4b36afdb-64c0-4dfe-8f4d-501930c59107"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"576d86b7-1d28-4f66-8319-eb34a892467d"},{"claim_cluster_id":"5ece0141-8dd6-405b-93cf-5585050f4efe","event_cluster_id":"b379da86-fb9c-4026-92d2-37b07df028cc"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"0626769d-4a42-43f4-8356-e89543f6dcc3","event_cluster_id":"49854b0f-e263-4847-a942-d2497d0d1530"},{"claim_cluster_id":"5e3e9898-c954-4e10-be52-6e36f5b36c5c","event_cluster_id":"a263e3cc-09b2-4ae5-a252-4665ad483b52"},{"claim_cluster_id":"24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"8a2e1f2c-6d19-479b-811f-3ccec4820a64","event_cluster_id":"2e4008f0-4f9e-4c2e-bf84-cd19c2b3f87e"},{"claim_cluster_id":"a3a558f9-9b36-49bc-be77-b1d77d8074f6","event_cluster_id":"f3e2df1f-8b35-4bab-b9e2-e82dc9f0ea1f"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"2762cfd3-48ae-4a0c-baf0-bfb36bcdff70","event_cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9"},{"claim_cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","event_cluster_id":"939d6808-ee32-41c3-8d70-73aed1d043da"},{"claim_cluster_id":"9012b6f3-2c16-482a-b276-63925d342482","event_cluster_id":"7e14e717-108e-477a-a145-900678351362"},{"claim_cluster_id":"bbc8c147-b447-4af6-82fb-e416f6108e70","event_cluster_id":"ddc05fce-b4da-4da7-88d2-dbf6d447379a"},{"claim_cluster_id":"24accb31-401b-42c1-bd69-e81c04cb2530","event_cluster_id":"636b2daa-578a-4643-896b-342714f42b34"},{"claim_cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","event_cluster_id":"18718c0f-4c28-4949-a369-9bfa7d8941c1"},{"claim_cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","event_cluster_id":"4f84ccb5-4935-4023-8826-9c08d0da261a"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"3595c0cd-b164-431e-b192-61bc7dc0019f"},{"claim_cluster_id":"1cffe038-9a46-45f7-bcc3-f26914315286","event_cluster_id":"0ffb9af7-6a71-4266-a4bc-ddac4a179c1a"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"2c046222-ca9b-481d-9b9f-68e4ebbf303a"},{"claim_cluster_id":"3786df1e-47ff-4916-973b-ccf57ccb5e4c","event_cluster_id":"84599781-5c1d-4670-83ce-2909c7c1b4c9"},{"claim_cluster_id":"b840591d-33a5-402e-9f7a-8913292b283e","event_cluster_id":"abfe0416-9747-4ab8-9cdc-8e88fa47871d"},{"claim_cluster_id":"9df4486f-c8aa-4f08-a8cd-4ae02c748318","event_cluster_id":"2bfeada4-b9e0-40b4-9be2-0655b8d49226"},{"claim_cluster_id":"7c2161be-91e7-4c74-9f49-fb997b3c5857","event_cluster_id":"c4974eac-c8ce-4c10-a509-e1191979432a"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"},{"claim_cluster_id":"232994db-dcd7-4db4-9ea3-fad6185233a7","event_cluster_id":"b4e6a6dd-1e51-4a7f-a1bb-cfc861598a03"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"7ef0f102-5c71-4651-96e9-1923d9bd80c5"},{"claim_cluster_id":"b26a4469-2931-4dab-aa78-be1b6fba8a36","event_cluster_id":"a0c6e4b4-7d8c-425c-8ff1-2b999fb65fda"},{"claim_cluster_id":"09907625-9889-4def-8ff5-b61d82ce4a21","event_cluster_id":"0791917d-ce61-4b44-9705-c74efbd95241"},{"claim_cluster_id":"fb95e7e0-9ac4-4fef-85ca-e17c4d83450d","event_cluster_id":"dbaf7073-39e5-4f3e-b490-d4b4eb1f1f82"},{"claim_cluster_id":"3dcf8216-5e70-4cd4-962e-dc4b036a0071","event_cluster_id":"e0151ccd-baed-452a-aaa4-6feaeeadc3d9"},{"claim_cluster_id":"636a73c4-ad4e-48b5-9c50-bd4fb4b02ebd","event_cluster_id":"fe89ddfd-a999-4814-9bd3-b0162af3bbe2"},{"claim_cluster_id":"3d1d7e4c-d40b-4ec4-9450-9fc635a45afd","event_cluster_id":"70ddc119-0fe5-44bb-b12a-5f9fe097cd8c"},{"claim_cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","event_cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"},{"claim_cluster_id":"2b77fdbc-c4ed-4e0c-99a3-6dbf568aa8a5","event_cluster_id":"f74c2283-95c8-409c-8db8-ce070f2c2a45"},{"claim_cluster_id":"b865573b-6b72-46cd-b3c0-a1458e7df010","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","event_cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03"},{"claim_cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","event_cluster_id":"f859d7dc-7168-48cd-becb-1199652aaa89"},{"claim_cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","event_cluster_id":"ff6b17a5-2973-4397-8f78-b44bc6fa5365"},{"claim_cluster_id":"53bc38bf-651d-46ea-8aaf-f63f52195a45","event_cluster_id":"83b65fa9-1a4b-4243-9c39-2ff350a46323"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"3035cab4-7bf7-4e5f-b8ff-717930d9caf2"},{"claim_cluster_id":"3b4bd5f5-082a-49c3-b3c7-b6d716e5f6e9","event_cluster_id":"a8ce1bca-58fe-42ba-8464-607d5c5b57e3"},{"claim_cluster_id":"865d4451-2942-47ff-84cb-46ee2b23dc46","event_cluster_id":"a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf"},{"claim_cluster_id":"746085cd-6635-459a-8b25-138f4d67d9dc","event_cluster_id":"241d256c-86d7-484e-8aee-4f2f15316b3d"},{"claim_cluster_id":"af503db6-fcf4-45f9-9501-f2732e2af4f7","event_cluster_id":"72ffc77d-60b8-420d-8327-cb12019a9c56"},{"claim_cluster_id":"12ce4240-07a8-40e1-acc7-141144ad6c5d","event_cluster_id":"83578f15-2ee2-4dd4-ae7f-b543ba5e2a87"},{"claim_cluster_id":"8f0344d2-3a73-4534-aa04-5391b7670e72","event_cluster_id":"48334cb3-0717-4823-bc81-52cb1f9c2951"},{"claim_cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","event_cluster_id":"ccffcdf7-168a-480f-bc2b-31955c7b549e"},{"claim_cluster_id":"4c161c1e-d86e-4fbd-9e49-e99d43b2eedc","event_cluster_id":"d44ce227-03db-4ccf-be04-d057a22464a7"},{"claim_cluster_id":"a4d61819-30e3-46aa-ab08-cf879db00de1","event_cluster_id":"5f74295c-f7d9-45d9-bee0-05eb4d5113bf"},{"claim_cluster_id":"1f8ca860-66b4-4b57-a63c-e13332662c2e","event_cluster_id":"3474c474-7d6c-491a-9b70-d72c3c7f2f0d"},{"claim_cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","event_cluster_id":"32aeada3-2c0a-4dd6-b828-1733cea88e6b"},{"claim_cluster_id":"c68ce84b-91a0-4925-97f3-1ea49e062e4b","event_cluster_id":"f58ab9e3-79cd-49da-af02-2a9f2fdeec8f"},{"claim_cluster_id":"ce4379b5-864c-4150-b826-c6825e39d887","event_cluster_id":"f67a1af7-61f9-40c0-beb8-34c87a985d6d"},{"claim_cluster_id":"66e9edc1-c40b-47a3-96e9-eebc44c63b9c","event_cluster_id":"1dd73410-26d1-4ffe-8c70-64b5d5bf9994"},{"claim_cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","event_cluster_id":"78ea610b-38fc-4528-87fe-af950e4ad514"},{"claim_cluster_id":"1be65d4d-c915-41d3-9d1c-864035425656","event_cluster_id":"353c6f78-8367-418a-a322-9feedaea3f81"},{"claim_cluster_id":"3073b261-2ceb-46c8-bad6-3808fb657e33","event_cluster_id":"49ea9af0-b84c-4f28-8cc0-a1e13e95b4c4"},{"claim_cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","event_cluster_id":"887d717e-5da6-4cf6-995c-bcee081cd128"},{"claim_cluster_id":"bdecd7b0-3449-4d8c-9710-468d872a6514","event_cluster_id":"cef4b627-4828-4a00-9a55-7f92b9804c1f"},{"claim_cluster_id":"58b4a566-79d9-4559-809f-ffd9a84468b4","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"f97e4f6c-a73e-4c35-8e7a-51a335141d67","event_cluster_id":"72e8eae4-0f40-4ffb-9af3-05384f47f8b8"},{"claim_cluster_id":"df94ae50-99ca-4e54-802c-ae4f92bf2a1d","event_cluster_id":"bbc52822-dc9f-42d5-a92f-f6eef341a6a2"},{"claim_cluster_id":"1c1848e6-9c28-4252-9e24-4dc5cb477be6","event_cluster_id":"754365fe-ff15-423c-803b-8363cd1da39c"},{"claim_cluster_id":"e64bcf93-086e-429d-9ff7-3a1518b3ae51","event_cluster_id":"e353033e-612f-444b-a7df-06c23368eb22"},{"claim_cluster_id":"ec868d12-f24d-450d-bca9-2e8a9f4e8021","event_cluster_id":"1396142d-5fd2-4c3f-8a9f-e0d1627fb926"},{"claim_cluster_id":"bcc578f8-a745-46e1-ac64-5315a3ec6900","event_cluster_id":"7e23b4ba-cb72-4329-9b5e-d475d9898055"},{"claim_cluster_id":"ab52850c-7dc5-4f99-b37e-0c628b078043","event_cluster_id":"954829b5-b0de-40ec-a999-143a5f855d8b"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"f10ad797-ad79-4629-861d-4af809502a09","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","event_cluster_id":"f61ff023-8da9-4963-951e-7e62c4121c8c"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"95af035b-c14e-4753-b211-c4a8a4ddbdf2"},{"claim_cluster_id":"02f58db8-b951-46f8-9ff7-76980a66fc66","event_cluster_id":"ab91862c-85f4-4041-ad6f-31e79b4bc25f"},{"claim_cluster_id":"503584d7-75a5-4f03-adb1-4844dd4d9b9f","event_cluster_id":"4005f43b-5b4a-44f8-9781-c0a91127368f"},{"claim_cluster_id":"327aebea-facc-4b65-a419-a9d461f7aa0f","event_cluster_id":"72addbc1-127b-4a33-b16b-7a7f76d03f32"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"2ff5212c-713e-4d80-b0b9-c7f306cf69fb"},{"claim_cluster_id":"5736135c-d235-4604-8803-ae7412cb8825","event_cluster_id":"c5229738-f89d-48b1-b153-7dc0f6aabc53"},{"claim_cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","event_cluster_id":"71cb88c3-3bc3-4a98-bd39-7a91efe626a8"},{"claim_cluster_id":"45931062-6efb-4850-9df7-4bff0b9b4a16","event_cluster_id":"2c4ce8c0-6662-4508-bebd-0134d7b84392"},{"claim_cluster_id":"3d44d914-cf73-4d8b-b531-5db2be83da48","event_cluster_id":"10b1c2ee-a471-4366-9850-b2056c01cf79"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"9a157342-1d61-41a4-92fb-020ea95697bc"},{"claim_cluster_id":"df6be9b1-2675-4ecd-8158-a77b9f4c36c7","event_cluster_id":"f1bddab0-3986-4a79-a51e-8622615c23c4"},{"claim_cluster_id":"9edb82af-1afe-4fbd-8da5-3bc280a95c94","event_cluster_id":"1758ed2e-dc14-4881-941e-3bd76c244d71"},{"claim_cluster_id":"ebad899d-9cc8-49e0-a908-87f53dd79063","event_cluster_id":"01388d43-fe04-46e8-a137-ee7f321c4ae8"},{"claim_cluster_id":"501b66f7-8e87-4810-b05d-6bb95d09a79e","event_cluster_id":"5ca3c47d-e454-491e-8306-a8bcab9a1429"},{"claim_cluster_id":"865d4451-2942-47ff-84cb-46ee2b23dc46","event_cluster_id":"2de6bb89-87af-41d9-9f6e-654985194064"},{"claim_cluster_id":"749b3ec0-39f9-4e3b-bcf2-7f9377d72178","event_cluster_id":"464e7bbb-1cb4-45e2-a510-f3dbf3edebfc"},{"claim_cluster_id":"d8704200-daac-4e95-873c-20cc39771b1c","event_cluster_id":"fb3f730b-85cb-44b0-976b-06ca14bb8acb"},{"claim_cluster_id":"c46be245-9f63-495f-be19-e522e39c13f9","event_cluster_id":"1eac9457-d9a9-4ee2-b922-a850e04ccef6"},{"claim_cluster_id":"61b758fd-ce2c-4502-b494-9618880e66e4","event_cluster_id":"519bca7c-733d-466e-b332-2cb930d5c9b0"},{"claim_cluster_id":"e53d664b-c538-43f3-a025-7686ca315f8a","event_cluster_id":"acddf1eb-d6f9-4c70-9523-034fc5a8acd5"},{"claim_cluster_id":"90ef35f7-8880-490a-bacc-f600f6a11162","event_cluster_id":"1737c28c-8f31-4855-8951-9dd1dd0b8606"},{"claim_cluster_id":"59bf3043-2eaa-48fb-880e-613249cbd976","event_cluster_id":"8c0047bf-e6f3-48a4-98c1-a7a466922ed8"},{"claim_cluster_id":"29fe240a-81f6-4aef-a8b5-3cacf3e3985a","event_cluster_id":"2528bd46-af3f-4f9d-8f91-2dbf49b3388e"},{"claim_cluster_id":"c90c00dc-2c77-42ad-bb5e-2666e53e2bcd","event_cluster_id":"c9f98636-16e1-43ce-a03d-d6e0e40dfac6"},{"claim_cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","event_cluster_id":"1238fc85-6b69-4536-a793-8df12f63f9c0"},{"claim_cluster_id":"62fbb5b2-0ba7-4211-b72a-eb1c18543408","event_cluster_id":"6ff9b10a-54cf-4a58-8655-1ec5ccd1ae56"},{"claim_cluster_id":"0c398c2c-4672-4f1e-ba98-17d7320a9537","event_cluster_id":"f9418d59-cbad-4bcd-b387-fb25a67389fd"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"b14c3761-a874-48e7-9fb8-15aebb4dd009"},{"claim_cluster_id":"d017f7be-45ae-4ae5-b72e-a6e53f0a589b","event_cluster_id":"78fb23f3-7fa7-436d-840c-3f1376d6f22b"},{"claim_cluster_id":"de4f148f-cf69-426b-b5bb-f722fb88313c","event_cluster_id":"6b61dc7f-0dcc-4798-86a9-dfa23b5c3897"},{"claim_cluster_id":"773a0c25-df3d-4865-86dd-a73825ed69b0","event_cluster_id":"1b2a4f9c-8284-4418-843c-06b19834c251"},{"claim_cluster_id":"e2676bcb-4f6e-4d98-ba58-3d2aff04d940","event_cluster_id":"6ebfced0-5146-4720-a35b-6dac63f2989a"},{"claim_cluster_id":"db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f","event_cluster_id":"9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","event_cluster_id":"51a5661a-48dd-44af-9a97-7d7620877cc6"},{"claim_cluster_id":"f46e8240-2cb3-437d-9e2e-c04f6db7a813","event_cluster_id":"db605ad9-a4d6-40a9-abcb-d200ca16a403"},{"claim_cluster_id":"22c13a77-51bd-41df-afeb-444adbde288e","event_cluster_id":"6e4a0e8e-51f9-46ed-8b84-bcdeb86a6f8d"},{"claim_cluster_id":"4f331c05-6fa5-4bd8-adc2-5458e8c80843","event_cluster_id":"d6133b17-e010-4dda-908f-2aa315f15880"},{"claim_cluster_id":"0fc06cfb-3a25-4176-a530-ab9cb52f7632","event_cluster_id":"38dc9a30-7314-4720-8e2e-f17990947602"},{"claim_cluster_id":"33a57504-12fb-4d65-b0de-90b983174e92","event_cluster_id":"ab0be659-cfc3-42d5-b3a3-1d1264ed5cd9"},{"claim_cluster_id":"166b6595-ba80-4fe0-a5a2-70307703e855","event_cluster_id":"e614332a-840b-4b45-8ec4-5184a874c6a8"},{"claim_cluster_id":"f2096782-318f-42d5-a553-560f508e5016","event_cluster_id":"abca71f2-b0b7-497b-b1ed-9f04c6ea4023"},{"claim_cluster_id":"9477ce9c-5a6e-4e61-9f13-cf68c95b219f","event_cluster_id":"51c627ea-61b3-4175-b1c6-64a2c7928bc9"},{"claim_cluster_id":"327aebea-facc-4b65-a419-a9d461f7aa0f","event_cluster_id":"753c254f-8be9-4b92-b7c7-e32c2713d3c8"},{"claim_cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","event_cluster_id":"8817a4d0-4aef-4c0e-a907-ff92179dff0d"},{"claim_cluster_id":"5e128621-af42-4a93-b091-b4e768efec3b","event_cluster_id":"f82b2292-d2a6-46b2-8f35-b645fd7735eb"},{"claim_cluster_id":"eea02be7-fd53-47b5-9804-7a2f89de23f2","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"3ca56034-eb2b-4824-906e-24d9da4948a3","event_cluster_id":"6cf816f8-e003-42cf-8cf6-67f77f267b93"},{"claim_cluster_id":"3d44d914-cf73-4d8b-b531-5db2be83da48","event_cluster_id":"6e37e2a5-095e-47b2-8aff-f3c2136725ea"},{"claim_cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","event_cluster_id":"6a2c5b98-767a-485d-a14c-04f05f90984c"},{"claim_cluster_id":"755e1910-15d6-4530-b0f7-b73a35ac9c64","event_cluster_id":"1d986f8d-82e7-4918-bcdd-07f2b4e2658d"},{"claim_cluster_id":"11c93b57-586c-4cef-a254-66245b297aca","event_cluster_id":"03cfca2c-7423-4384-8df2-7f88d1994030"},{"claim_cluster_id":"2e620f14-db3f-4f94-9e90-7ae11cf68067","event_cluster_id":"a4f84d58-e9f3-4a41-a8f9-b81736f1cea9"},{"claim_cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","event_cluster_id":"ac20790a-e28e-426a-9c7b-f5ecf7b0aefc"},{"claim_cluster_id":"e840acd4-9152-4039-820b-b347beaec131","event_cluster_id":"bcac4aab-9cd8-4923-b998-bd470cb7fa0f"},{"claim_cluster_id":"6015f261-315c-43b5-ae1a-b6f1ad2e1ce6","event_cluster_id":"32ad70e2-6724-4b9a-a0c3-bd70b56126d0"},{"claim_cluster_id":"c7eb5329-6775-4d3f-aea7-7de4fbeb8175","event_cluster_id":"76382e4c-a4a2-4fb5-bc4f-138c970156c3"},{"claim_cluster_id":"97e04a01-6626-4196-a12d-eac1df348581","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"3b7e3ce4-4e60-4c09-986c-9b9376d80c8a","event_cluster_id":"69fc5164-f4a0-47bb-853d-0382d8d5f3c1"},{"claim_cluster_id":"5c890164-2642-4556-87d3-c7dbbd1d4d78","event_cluster_id":"5993beab-a3f3-40b3-9d6d-5a8cd60d5eb3"},{"claim_cluster_id":"0961c365-4261-4c91-984b-81c62260d807","event_cluster_id":"a305ffe3-19c3-481a-9058-4247bca4ca01"},{"claim_cluster_id":"a8dc28b0-9676-46fe-a3b7-8eb8e563deb8","event_cluster_id":"40e574c7-e1d8-4cc8-a46a-a5e8d1efd793"},{"claim_cluster_id":"3eac5298-75f1-4e1e-94ec-db408d17729a","event_cluster_id":"21518841-2c46-4292-abad-aff342a4f1ac"},{"claim_cluster_id":"d86ea948-08a0-4829-9e48-4f9273b2967d","event_cluster_id":"1bb3c826-37ca-4435-8ad2-e211e6cd9444"},{"claim_cluster_id":"469c5194-5b04-4e90-b62c-73b3f79a0955","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"4bc5d44b-029d-49ff-82cb-bbcd84067673","event_cluster_id":"67171e62-bbfa-470a-8469-52d1b51665da"},{"claim_cluster_id":"c2350485-f95c-46d4-9b92-6355ceca86df","event_cluster_id":"38dbd9f2-4706-4ca9-a837-817a4ee621f8"},{"claim_cluster_id":"3bc352c0-0d5e-42f4-ad88-e7f025e20e88","event_cluster_id":"1bbcb23d-9835-462a-b09f-6a4c89faa361"},{"claim_cluster_id":"294d0346-cddf-4b1e-a6bc-ab4686137712","event_cluster_id":"241266d3-592d-42ac-9327-a8fa3d3a1448"},{"claim_cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","event_cluster_id":"8f6bcfb4-e69d-470b-bf79-44df803a0002"},{"claim_cluster_id":"da4ff089-352e-46ec-bdf8-8e7b8cd2001b","event_cluster_id":"379a52a5-17ca-4b52-8aeb-4f7076fdca3c"},{"claim_cluster_id":"255ea174-3e00-4506-8a6d-78f62eccfecc","event_cluster_id":"8c98812a-8a38-46cf-a002-b105988964fa"},{"claim_cluster_id":"5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6","event_cluster_id":"6c1c53f7-282d-4c0c-a8d8-dac0c8af5a96"},{"claim_cluster_id":"0f733538-ef56-427f-ad23-04cb6fae87ae","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"7f7310ca-5512-45fa-8f93-1b6555e791c0","event_cluster_id":"a8171dc6-d1e7-4f00-80c9-a3281fe32c93"},{"claim_cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","event_cluster_id":"a8453d8d-d762-45e8-9fae-f6302e301be0"},{"claim_cluster_id":"a8c6b9dc-b961-4a1b-bb6d-3aff208b396f","event_cluster_id":"763d8e8c-b156-404c-ae43-97e544b0ec16"},{"claim_cluster_id":"d0228864-78be-4fd7-94b7-908de0276e80","event_cluster_id":"6030a19b-208f-4624-83fa-f8e8a264fea6"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"b7e82711-b99a-4580-8fb1-a7b6465b462b"},{"claim_cluster_id":"ab0a6f16-1446-472c-af45-f55c0d8ddc3c","event_cluster_id":"b99d5f24-fa76-453e-adeb-2b0a207bd3de"},{"claim_cluster_id":"589240bc-a0dc-4961-944a-a3594262e220","event_cluster_id":"75cc70a1-5be7-40b5-9ce1-1497b1ba2474"},{"claim_cluster_id":"8a4b9d30-600b-48dd-9a32-934835947825","event_cluster_id":"b4d1a337-88d8-4989-8d52-1a04d38e6e21"},{"claim_cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","event_cluster_id":"c6098f7c-9ca7-42cb-9f44-6b467087e324"},{"claim_cluster_id":"69315435-638a-4ef2-abe8-1d91d23ff51a","event_cluster_id":"f5c0430d-6c19-4e4b-815d-7de708ba52a8"},{"claim_cluster_id":"f9eb0f13-3691-4b5d-b326-0456c31b4402","event_cluster_id":"21c8abd4-e2f1-498b-ac7c-3e0c279db5b8"},{"claim_cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","event_cluster_id":"58d84750-75e5-4a06-9053-f1a5a8baf564"},{"claim_cluster_id":"721fca95-63af-4a1d-bae5-70b55fce9a8b","event_cluster_id":"2a492648-efc4-44a2-9eee-4d95d05d104b"},{"claim_cluster_id":"35ff7a5e-40b8-42ad-9379-7ba830c9445f","event_cluster_id":"8a9e9225-8d82-4d0e-ab43-4f387b7b1105"},{"claim_cluster_id":"e0b76993-43d7-4b38-b891-9ad858a2c5f6","event_cluster_id":"25ed23a4-7940-477a-9165-7053b4f9330d"},{"claim_cluster_id":"6f9b01a7-d717-4ce1-bd54-f5647d476287","event_cluster_id":"46187cfd-07e9-43ce-ade9-ed6a220120f1"},{"claim_cluster_id":"f982ead8-4101-46e5-9a29-b95c416ed470","event_cluster_id":"c7b0f267-0192-4ba8-86e6-09f6ba274d4f"},{"claim_cluster_id":"02e0cfd6-814a-4276-b8cf-66540b7686e7","event_cluster_id":"5a60b1ad-2d21-44bf-9788-e9579de25e42"},{"claim_cluster_id":"800c3c00-df13-4716-b553-f1b7480d22b7","event_cluster_id":"21be5a19-a4c5-4da5-a267-9d6169f7d6f0"},{"claim_cluster_id":"990aca8f-a2db-4ebd-85da-744c488a8d2b","event_cluster_id":"8f6bcfb4-e69d-470b-bf79-44df803a0002"},{"claim_cluster_id":"c17fd8aa-8336-4796-9c7d-a192509f6809","event_cluster_id":"d342ed30-fc56-4887-9c80-98861f47054d"},{"claim_cluster_id":"ddbc1aa3-6d67-4148-96a1-e149d5d02260","event_cluster_id":"31091b5e-03e8-4b81-8a6c-9a3d02b0c681"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"be4d477c-befe-4014-a5ff-185b3c58e5d5"},{"claim_cluster_id":"616e962d-58a9-42e5-9a6d-decd8139ddf7","event_cluster_id":"cb0a8f38-8b40-4637-bdbf-1d9a5a12407f"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"01196e0c-7fc3-4e40-8d9d-fcbcee3103a1"},{"claim_cluster_id":"4bc5d44b-029d-49ff-82cb-bbcd84067673","event_cluster_id":"f29558d0-0635-4b49-8d22-a3cce142124f"},{"claim_cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","event_cluster_id":"2a492648-efc4-44a2-9eee-4d95d05d104b"},{"claim_cluster_id":"075f7aea-756f-4e67-bf46-f4305230821b","event_cluster_id":"447c9e43-212c-427e-bbf7-d86cadb216eb"},{"claim_cluster_id":"02e7a900-bce3-4812-8137-1246791846bb","event_cluster_id":"a5ca0f47-c2ad-4e2d-8414-673ee9a9e57d"},{"claim_cluster_id":"cc6a9454-14fd-45d5-b472-64ca4fedbe80","event_cluster_id":"3f8c1bc5-ffc2-4f3c-9751-015716600af2"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"81907f87-685a-467f-b4fe-172f6390378d"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"0cd50f6d-7e09-46ef-815c-37b05bef94d0","event_cluster_id":"bc907223-19f6-4c59-ade2-142b6a28be4c"},{"claim_cluster_id":"d14315a8-aa93-4c64-a42e-a4307dd0814a","event_cluster_id":"841f304f-f4f1-471e-aa1e-5c0818b42f86"},{"claim_cluster_id":"61ed0aed-dc5b-413d-8a18-4362324862cc","event_cluster_id":"3ff7a6c9-67a4-434c-ba42-8e735f72fd34"},{"claim_cluster_id":"de15f7d6-5167-45b1-bad6-235dd16ae15e","event_cluster_id":"1737c28c-8f31-4855-8951-9dd1dd0b8606"},{"claim_cluster_id":"698d5e91-6aba-4224-9583-f0b9f9330723","event_cluster_id":"7b5742e3-5955-46ac-9086-6f1852e5681c"},{"claim_cluster_id":"0fde95b6-db57-45cd-b6ac-fb0edd1b186b","event_cluster_id":"3a969b37-0ab9-41ab-b145-dd3f362c8638"},{"claim_cluster_id":"c6b3d942-ded2-4171-9d53-bf87a1b48b52","event_cluster_id":"9ebf6405-2d25-40bf-a1c7-48615c2b0e1d"},{"claim_cluster_id":"9edb82af-1afe-4fbd-8da5-3bc280a95c94","event_cluster_id":"ab43ecb5-72cd-4cd0-9f6f-d31ca04720f7"},{"claim_cluster_id":"0bdfd962-fc80-4c29-8a9f-545619ab3653","event_cluster_id":"c41f696e-07f9-4e6f-84a4-bbc219b21f87"},{"claim_cluster_id":"b66f67b6-3e85-4a7d-9029-7480f97d9f48","event_cluster_id":"3f25d73b-25b5-4e43-b335-2f8f8664eb00"},{"claim_cluster_id":"4cef0d90-5e3b-44f3-ba12-57b1ee19455a","event_cluster_id":"14f2fead-e1a2-4e74-b696-6e535d49d9d6"},{"claim_cluster_id":"891e1da4-bfc6-4524-a5da-153bde60b165","event_cluster_id":"ef19cef5-5810-4243-912b-66c41d184f8d"},{"claim_cluster_id":"7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9","event_cluster_id":"c6e2d109-f8d1-42b8-bb0d-16083a37ad8e"},{"claim_cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","event_cluster_id":"aa24898d-2c81-430f-a430-33fb9aae0db7"},{"claim_cluster_id":"b1da6225-3a48-4f38-b0fb-dac29be99682","event_cluster_id":"b17935cf-677f-4da3-a3e4-c0a86cab1633"},{"claim_cluster_id":"fdbce6fb-9c6c-48ff-a187-88c668f79277","event_cluster_id":"49b4c78b-ed4a-40e7-bdfc-7463c3169502"},{"claim_cluster_id":"594e0474-2d9d-4582-8963-9fe946d49a1e","event_cluster_id":"67cd7c4a-a6b3-4e11-9b6b-362422489e76"},{"claim_cluster_id":"2c8b719a-2363-4f9f-9be2-6d1801374195","event_cluster_id":"4c2caa9f-9774-4e83-aa42-f46bf17280b7"},{"claim_cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","event_cluster_id":"6e25bc0a-2c7d-47cc-a81b-58dba523595b"},{"claim_cluster_id":"226f9322-c9c6-4f2f-948c-b45757d94aa7","event_cluster_id":"bd2a5352-41e8-4479-ac51-89fb57ca65cd"},{"claim_cluster_id":"cfa086e7-654e-40fa-9e14-980617b91e89","event_cluster_id":"bb3ff0db-1a95-4c2e-819a-c84235effd5e"},{"claim_cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","event_cluster_id":"22a57fde-1c2c-4f1c-9861-888038d4fe31"},{"claim_cluster_id":"f236d68f-fe39-4432-9a36-341eb8900ee6","event_cluster_id":"1a861c93-c5c6-48c2-b775-34eb4363839b"},{"claim_cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","event_cluster_id":"8585c4f1-4f02-4ac1-9a95-4cc381634f7d"},{"claim_cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","event_cluster_id":"c39ad689-c540-4985-928b-b1a54e619b06"},{"claim_cluster_id":"d3123cbc-3543-4f46-aee9-7941c8669a07","event_cluster_id":"63e1fb6c-f4d5-44b0-95bb-4b6a7af8b4d4"},{"claim_cluster_id":"f690f627-f1e3-428b-9d01-bfb966953069","event_cluster_id":"45e218a6-8801-4755-bcad-4c7f5bec819d"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"},{"claim_cluster_id":"ce2b0119-85f6-4619-9c50-256557181c73","event_cluster_id":"71b3e9c3-5afb-45c8-a204-1d5b44e3a33a"},{"claim_cluster_id":"8255a43f-82ec-4f1a-8f29-78e7a247a2d1","event_cluster_id":"219dab96-d91d-4b0d-b347-235846e4bc70"},{"claim_cluster_id":"64b43278-d723-4b63-bcf0-181e1a1658f9","event_cluster_id":"7861388f-c8b9-4ec0-99ed-6ceb81b3764b"},{"claim_cluster_id":"b9ff3223-8bd6-4360-8edc-fa3409378e90","event_cluster_id":"ee97e835-1007-4cd5-b270-714f0880c07e"},{"claim_cluster_id":"a8ca6792-95c5-4826-87fa-d4a8f7047a5f","event_cluster_id":"2cf2f548-46a0-4250-995b-025b4e6eb130"},{"claim_cluster_id":"9594285e-8196-4153-9b31-89250a7200d5","event_cluster_id":"108f968f-7171-480b-9225-ebaea32953bb"},{"claim_cluster_id":"8468be9d-aa33-430a-a3f3-b08169c7651a","event_cluster_id":"9bab6bab-ced4-428f-ad92-fd02b9600f3a"},{"claim_cluster_id":"74664a64-2600-438a-b569-a9d45ae85e93","event_cluster_id":"e0948d6f-1c68-4b82-8be1-2b7d5644b264"},{"claim_cluster_id":"4cc6a578-5e10-41d7-a578-fba88da2dc13","event_cluster_id":"10a3db6f-9669-4c8a-9480-85cb3dd1626c"},{"claim_cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","event_cluster_id":"5e5c65ad-4c51-4a27-ad63-eac217deb431"},{"claim_cluster_id":"5389eae7-83b1-4726-86c2-9a8dff51be59","event_cluster_id":"c6ae3e3e-9490-4f23-8d47-5a4b1fb01352"},{"claim_cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","event_cluster_id":"dd459c3b-7734-4c47-b440-fe088ff89835"},{"claim_cluster_id":"8f273fa4-f8bd-4413-8ce1-7183b77e2566","event_cluster_id":"ceded39c-ad6f-4d12-9e04-8034f780e209"},{"claim_cluster_id":"af167078-1ea4-4d05-a491-aca4808cafd4","event_cluster_id":"ae81b069-06de-4c85-affc-804bac2e778d"},{"claim_cluster_id":"dc3308e5-2250-431f-bef6-733e2b943275","event_cluster_id":"6003df1f-5700-4398-bb5c-3e647fefb73f"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"b407290e-0e65-4bff-90dc-c2ececfb37ab","event_cluster_id":"49ec4675-cceb-45d5-bbb2-56483fcd1319"},{"claim_cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","event_cluster_id":"3380c11c-4d24-494b-b6f2-08440e174107"},{"claim_cluster_id":"36f68109-962e-490e-9101-85d84c5de66a","event_cluster_id":"e47ab492-3177-49bc-9493-e444a1518298"},{"claim_cluster_id":"469e17e6-447a-4bc6-9bab-f2cb595f07e0","event_cluster_id":"49854b0f-e263-4847-a942-d2497d0d1530"},{"claim_cluster_id":"58bf9f4a-adda-4853-802b-78d04aa711fa","event_cluster_id":"1b8daac6-2959-408e-a7dc-dd102f0defee"},{"claim_cluster_id":"9a6fa43d-c803-4c20-bac3-545db67a8241","event_cluster_id":"d63dd03a-5d4f-4d47-9f48-b37f794db992"},{"claim_cluster_id":"5b5325b9-59bb-4b91-9a19-8889095dd496","event_cluster_id":"61c6513c-5b59-4c49-919e-b92af19239e0"},{"claim_cluster_id":"27b386d8-58df-4b19-a269-36bb2400c94c","event_cluster_id":"45df4bbb-00df-47af-9d05-1da924dfb782"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"dc991813-e94c-49ef-a261-7e441b9dfb8c"},{"claim_cluster_id":"e473874a-9cd2-4a8d-b926-9354bf1b7e19","event_cluster_id":"fe48b63e-4bef-4121-8e7e-7d9b8254bcfc"},{"claim_cluster_id":"b26a20fa-d793-419d-b599-26d1ed57c2b3","event_cluster_id":"277f2c0e-e3d5-4e58-a3ad-823177ebe3dc"},{"claim_cluster_id":"0dedc684-9634-49f1-9f8a-88450509e30c","event_cluster_id":"dbe4672e-f5d2-4914-b987-c4e89610b2b6"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"d3085fed-3741-4d75-9105-e8b0b3511de6"},{"claim_cluster_id":"d26e1561-d7b5-4c15-bc29-d5ba417f64ca","event_cluster_id":"3f685716-0686-4535-807f-feecb0c1246c"},{"claim_cluster_id":"2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6","event_cluster_id":"0ac8de8c-821d-4fe2-90f7-e1d30911339a"},{"claim_cluster_id":"44260a23-35ce-4643-9869-bda1004b447a","event_cluster_id":"6b36db82-3876-45f8-8bf7-ad613dcd8852"},{"claim_cluster_id":"d072d7ca-3280-4412-8e76-be63e36fe491","event_cluster_id":"28b85f28-71e6-4dde-8680-88495b7aecd4"},{"claim_cluster_id":"ed9c7f02-d3d7-4f88-92df-80c91b7dca98","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","event_cluster_id":"cbddcfe6-4088-4603-8e7a-ed109a9fff44"},{"claim_cluster_id":"ce637d4c-890f-483b-9ed8-d8130682b8ac","event_cluster_id":"21ccf4a0-84dc-466f-876e-46fb9c86c380"},{"claim_cluster_id":"79c4f8c6-ab1d-43ae-9503-5af83d7fa7e6","event_cluster_id":"783dc097-3e45-45ff-9e18-33ccfd6d47cc"},{"claim_cluster_id":"612e00dc-099b-40a4-b39a-4b7adbab73ce","event_cluster_id":"94f99c45-cd6a-4279-9860-a3fae3c6e14b"},{"claim_cluster_id":"2ee00586-87af-465c-8466-d1bc41c3886f","event_cluster_id":"63ff4667-bd37-45e5-853a-bf5f312c00b3"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"32e97d8a-5e17-495f-9681-46a69fce7584"},{"claim_cluster_id":"f8dcd352-7207-4138-bd88-eb7c4051cbbf","event_cluster_id":"ea30f761-5bdf-4c65-ac3f-905c5bb0730a"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","event_cluster_id":"f6201dc9-cd2a-485c-86d4-622332646365"},{"claim_cluster_id":"c830c75d-93e2-4842-b468-b89a47252719","event_cluster_id":"6ea587ae-3fa9-4e28-822a-cbebc0ee85f8"},{"claim_cluster_id":"58b4a566-79d9-4559-809f-ffd9a84468b4","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"d86ea948-08a0-4829-9e48-4f9273b2967d","event_cluster_id":"02e73dfc-86f2-4fe6-a79c-d071e07721fd"},{"claim_cluster_id":"df0cd74b-d230-4260-9a29-b0bc91923404","event_cluster_id":"bc1909a7-dd59-441d-aab0-42a7a0400bdd"},{"claim_cluster_id":"c7eb5329-6775-4d3f-aea7-7de4fbeb8175","event_cluster_id":"603bb3bf-f1f7-4182-8a09-670b111a3fe8"},{"claim_cluster_id":"b9ff3223-8bd6-4360-8edc-fa3409378e90","event_cluster_id":"345af148-94b5-4202-924c-3b3712e4cb8b"},{"claim_cluster_id":"61152334-8dda-42a2-bb8d-9fb770fd72f7","event_cluster_id":"18cfbf44-b988-4dd5-866b-73fc693898aa"},{"claim_cluster_id":"d8581e68-7fcf-4616-92c1-9daff0a2d8ae","event_cluster_id":"3b02e47c-e307-44b8-85bc-a7863107a268"},{"claim_cluster_id":"505519a5-a059-4c9c-8b16-ce6dffe7e678","event_cluster_id":"14ef59ab-f50d-4bc9-bdf1-1bc17697f5a4"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"6b2b1fd9-ebe6-4e20-9f18-a97a395c8d10"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"ce398b7c-c3fa-42df-8862-5c57ac63cf98"},{"claim_cluster_id":"83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6","event_cluster_id":"e6aabe2f-c2e1-4dd9-a27b-e84ebb5bc406"},{"claim_cluster_id":"73e1870d-5a72-427f-b64a-f2b7b2817260","event_cluster_id":"7f23e350-d82f-4791-a6df-263d08bac5c0"},{"claim_cluster_id":"d47ee5b3-b3df-49e6-9a06-0dbb08c65765","event_cluster_id":"7ef61e9b-09b3-424a-8249-c31cea2c952b"},{"claim_cluster_id":"989e42eb-c62e-4e68-87e6-6b230317d087","event_cluster_id":"49650712-227c-465d-93ab-16c3e2405aae"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"47cee9e4-a547-4914-b31f-89a4963c7d37","event_cluster_id":"8f9c10a7-b7f4-4bce-895c-bb65278b679d"},{"claim_cluster_id":"9b2175d9-8d49-4d83-857c-16d8550ab216","event_cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"925ab71b-2b56-471d-b090-4d83433faa8d"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"59f7148b-b06f-4868-866d-00139a58abd6"},{"claim_cluster_id":"1b5c8541-b848-4f05-865e-43826009d4e7","event_cluster_id":"c1482f2b-05b5-4755-ad11-c7c127fb4e73"},{"claim_cluster_id":"323efa20-d8ad-424c-9c0e-ac5d255b9276","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"8347f82c-28cc-4206-8266-0d33250fbc4f","event_cluster_id":"325eb390-c83d-4040-b800-a93e29e11141"},{"claim_cluster_id":"0af113aa-da9f-4ed6-a163-dcb48f1459ee","event_cluster_id":"d84db030-75db-4735-a947-d4f90e4deae5"},{"claim_cluster_id":"48cca002-8003-45bd-92b2-3e2945a33b48","event_cluster_id":"172a52ef-f6c4-4bec-a54c-6a0343aa0561"},{"claim_cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","event_cluster_id":"c04b6a1d-f91c-44bf-b579-d5d4565fc056"},{"claim_cluster_id":"a8c6b9dc-b961-4a1b-bb6d-3aff208b396f","event_cluster_id":"107cb2f5-f373-4a33-aa9c-b2f0173d4807"},{"claim_cluster_id":"f72eb4bb-112f-4556-a279-ad745cb4894c","event_cluster_id":"31dfadd3-c8f6-437b-b8ec-a69992a26cb8"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"ceded39c-ad6f-4d12-9e04-8034f780e209"},{"claim_cluster_id":"4575f267-4553-4c7c-916e-359800e4fb24","event_cluster_id":"a61f9905-7bda-4da1-b019-fbc601e92e05"},{"claim_cluster_id":"4af97b54-9617-48e3-8125-aa1e8e1ee8a2","event_cluster_id":"224111ea-4ffa-46dd-984c-028b4bc55489"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"933d50c3-dd0d-4b5f-9957-22bbcfcc55d5"},{"claim_cluster_id":"528a9885-82c7-4bee-beac-f85e4c7c3f1b","event_cluster_id":"6a63b515-0915-46a1-b528-3651a558693f"},{"claim_cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","event_cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638"},{"claim_cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","event_cluster_id":"edc6ba48-0632-4236-9c24-f67f26e9b96b"},{"claim_cluster_id":"800e7e36-7ce1-4e55-a18d-394d83673d71","event_cluster_id":"866d952f-2947-45b5-a10f-e756e9288018"},{"claim_cluster_id":"a99b1332-e477-4168-b8e5-832daa0d6068","event_cluster_id":"c54aa827-069b-4ed6-b43e-bde69590b9e4"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"871a611b-da54-48a2-9c22-fa6f48cccc0c"},{"claim_cluster_id":"51086a98-c771-4b7c-8eaa-b6fbb8629a30","event_cluster_id":"602ccd3f-b2b7-474a-9029-74260beb7902"},{"claim_cluster_id":"d1292088-fa7b-4c5f-a6b8-d1bbb1dc9eae","event_cluster_id":"7378ad43-a016-4ea8-a115-0123a4bd291a"},{"claim_cluster_id":"232c9ea4-0513-4c68-a25b-8b7d952325d2","event_cluster_id":"1760a439-ca46-4fac-8653-21cfe35d860c"},{"claim_cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","event_cluster_id":"6fdf651c-dbd2-4ed4-85b1-ba8e9916ed27"},{"claim_cluster_id":"84b73ec4-88f0-4587-a147-47771c41db07","event_cluster_id":"22e5ae9e-51e6-4da6-a862-0555cb893e6a"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"8f04e04a-ea8d-4a08-9f4b-0027f1697329"},{"claim_cluster_id":"b8726f80-5b75-44d5-9a25-5d095109008d","event_cluster_id":"a4a5f3c7-c987-41f6-9618-486ae48abb68"},{"claim_cluster_id":"834f4385-ef2b-4b12-81b1-8e94ff3098e8","event_cluster_id":"95b52cd8-d8dc-42df-9eb9-9f4f8c6db4b2"},{"claim_cluster_id":"de15f7d6-5167-45b1-bad6-235dd16ae15e","event_cluster_id":"ec825820-2066-4bfe-95cd-b11676c4d89c"},{"claim_cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","event_cluster_id":"2b58f035-89d0-48c4-ab98-0571ae348860"},{"claim_cluster_id":"5c68cba2-8519-4f6e-b70e-fbda62c5445c","event_cluster_id":"f629a198-d535-41eb-8981-0a2a15fcbcb9"},{"claim_cluster_id":"1e74d1b1-7b73-446d-b88a-11111e499ad8","event_cluster_id":"682ed3da-b434-4c8b-a46d-5ea8bffc9576"},{"claim_cluster_id":"90ef35f7-8880-490a-bacc-f600f6a11162","event_cluster_id":"c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"},{"claim_cluster_id":"ae1e52fc-461a-4609-8b02-2589611c162e","event_cluster_id":"a50cab62-c330-4a2e-b634-2fd8a82ebcfe"},{"claim_cluster_id":"304f9508-2cf0-4ef2-b524-7a5c78978d94","event_cluster_id":"e25715ec-5983-4c68-b924-9f64b4f03d63"},{"claim_cluster_id":"8db7f2ee-28e7-4abd-b214-9d334508a075","event_cluster_id":"25038dda-b8ca-4dd5-9e0c-c382a4d18a6e"},{"claim_cluster_id":"aaf51226-d11b-4c1b-82db-25727f24712a","event_cluster_id":"00fbd015-4c36-4680-a582-bfc7271c3275"},{"claim_cluster_id":"a5408918-67c4-45bd-afb3-95d8aced1dc9","event_cluster_id":"4e48f414-895d-4241-a8ae-69662f5c3d46"},{"claim_cluster_id":"34db5d7a-86ad-4cf4-abae-67c617853bac","event_cluster_id":"94c94ebf-a12a-4db5-9455-477a88d18b1f"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"13a151a6-c289-4cb5-8bbc-44e52c4f2c13"},{"claim_cluster_id":"910f66d9-b789-4e64-8888-a565439b59fa","event_cluster_id":"2c29846f-3295-4669-afc6-4c052b5c55d8"},{"claim_cluster_id":"47cee9e4-a547-4914-b31f-89a4963c7d37","event_cluster_id":"c3f8efea-527f-4eda-8f86-1b201d526c1e"},{"claim_cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","event_cluster_id":"5c5bbff7-5569-43a1-bcbe-db0b95585d05"},{"claim_cluster_id":"04ba7876-53cc-44c3-8149-fe7ba435f124","event_cluster_id":"c9b63381-9a94-41a6-b33b-4c75f981d835"},{"claim_cluster_id":"f4cd4d9b-6b2b-454a-ae24-3a0150790009","event_cluster_id":"aadbc964-f981-4ea2-bc24-dd4cf5de086c"},{"claim_cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","event_cluster_id":"42c65788-8111-41df-929a-ce02cb092330"},{"claim_cluster_id":"1ff9104e-969b-469f-b204-88f04894d01f","event_cluster_id":"c07b3261-1d07-4e89-b0d2-db74c9a1f8dd"},{"claim_cluster_id":"b840591d-33a5-402e-9f7a-8913292b283e","event_cluster_id":"8cf3def2-907f-4b61-b37f-0d9e2ed2b954"},{"claim_cluster_id":"253e1524-e402-4a4d-b7db-f94b8f989d9c","event_cluster_id":"f5ceefb1-12c2-41ea-b95c-18c5038560bd"},{"claim_cluster_id":"e9d22d46-e0d1-45b7-b109-afc6516146e1","event_cluster_id":"d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49"},{"claim_cluster_id":"8e873c15-6407-475e-841a-2dcbbce28e18","event_cluster_id":"51102dd8-1276-45b4-9dc0-5dab1b318e57"},{"claim_cluster_id":"8038fcc7-29f8-406c-90cf-ee3b351c6e15","event_cluster_id":"22d09703-f903-41b1-874f-1d44ac956d8e"},{"claim_cluster_id":"e82ed51a-4d19-4b2d-96bc-cb54f9b70858","event_cluster_id":"4fb3ad72-cc0b-4dd7-a137-fc01ed07a902"},{"claim_cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","event_cluster_id":"e21a96d2-b5b0-4a69-80bb-66020b0b8a54"},{"claim_cluster_id":"4692c588-5e24-491c-9044-3d7dd7c0a2d7","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"2ebece0c-e502-49a9-94b9-5df90f1b8e51","event_cluster_id":"21e4a786-d932-47c3-955b-b3e7de14d033"},{"claim_cluster_id":"635fb80e-2799-454a-8570-6fc3830d271b","event_cluster_id":"4fecbbe3-fb61-4e10-b666-a2cf1bec8797"},{"claim_cluster_id":"b27abfde-f9d9-4f52-9ce7-8c541388281c","event_cluster_id":"88c327f9-75c2-480a-8aa8-272d021cabe8"},{"claim_cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","event_cluster_id":"4baddf1e-d126-4e58-b0e3-19999dfb4341"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"8d281258-aab1-4ac7-9451-b7a3fe4c46e1"},{"claim_cluster_id":"24e1d750-e055-449a-83a7-236e590f0e5b","event_cluster_id":"800e1de8-b1a3-400a-bda3-2e81d524609f"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"0ac8de8c-821d-4fe2-90f7-e1d30911339a"},{"claim_cluster_id":"7fbd47ed-2abf-42a7-9e7d-74c06dc8b729","event_cluster_id":"cfbc5753-ac66-4d7e-b3ad-5e7f58c3e6df"},{"claim_cluster_id":"e4e03461-6763-4291-b9e4-bd4feccb46e2","event_cluster_id":"3766e219-c028-4750-8fa4-03a0a967da3c"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"52bd4e45-b832-46e3-9698-5812693f4546"},{"claim_cluster_id":"9971c68f-8d21-4436-a5d3-4897996181e7","event_cluster_id":"906602f3-b23d-4091-b462-b74d3ce8894a"},{"claim_cluster_id":"4350947c-093e-43d1-91ad-c33f75e13a1e","event_cluster_id":"e0a277a7-e9c4-43ed-a840-95ca0c8f496c"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"6eee7591-18a7-498f-a4ad-f5aae119dd62"},{"claim_cluster_id":"245874be-060a-4ca6-afe3-3a367b00ddb5","event_cluster_id":"094c5f6c-8f77-4ae5-86e6-0f169bca56ea"},{"claim_cluster_id":"5a77fa7e-06f0-487a-a93b-f15e590aa54a","event_cluster_id":"db350168-e89e-48c8-a5ce-3b8c59130017"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"51ab0b64-787d-450c-9578-4158dfeb97cb"},{"claim_cluster_id":"82cf1bd1-8182-4744-8fc2-6d5af2292aea","event_cluster_id":"5291aa5f-51ac-492f-83f7-3c48258f1866"},{"claim_cluster_id":"800c3c00-df13-4716-b553-f1b7480d22b7","event_cluster_id":"11eba0ed-7efc-4733-b927-256265e60430"},{"claim_cluster_id":"7bf4f678-55d5-4f6a-922f-0b5de572f033","event_cluster_id":"94476e0e-60e0-40ca-89ed-b2626dba60d7"},{"claim_cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","event_cluster_id":"9e059116-3c55-48ed-9078-1c003c9ab524"},{"claim_cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","event_cluster_id":"abd5930f-6db1-45e3-b882-ee3ba2f8394b"},{"claim_cluster_id":"64ec2b0f-c55e-42e7-a532-b9948f0a43c1","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"72276ba3-4193-4153-879a-b2c7cdf39af4","event_cluster_id":"fb90f205-10b1-4a80-8c76-1265d7a47a4d"},{"claim_cluster_id":"ccc50930-0ce2-4cb5-aa76-281b7202368b","event_cluster_id":"8bd51f45-6e7b-4825-a6da-736e3f231b22"},{"claim_cluster_id":"cd37a888-7bea-44b1-9691-e12e7c11fac9","event_cluster_id":"7bdac760-2a67-4126-ace8-6bee9660bcc4"},{"claim_cluster_id":"c46be245-9f63-495f-be19-e522e39c13f9","event_cluster_id":"6f318bba-6562-4eeb-ad79-8a89fa75ae26"},{"claim_cluster_id":"50262127-6a56-4d82-bc3b-4ca236eefed1","event_cluster_id":"a28c9cba-981f-4e06-b04d-bde777f88583"},{"claim_cluster_id":"506e309f-6f87-418b-b660-0ad635976c9d","event_cluster_id":"333dab32-099d-476d-86ef-f676846f2e4b"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"31763d96-84ac-402a-a69c-ea748718f342"},{"claim_cluster_id":"1c5f9ea9-d432-4800-9abd-5af5c927568b","event_cluster_id":"7e49c169-d21d-4097-aa83-c6ac3958ab1b"},{"claim_cluster_id":"e0b3b058-f41a-4ebc-b9bd-9e20a141c340","event_cluster_id":"c4bed539-a0aa-4ff8-9be3-4afa92598dee"},{"claim_cluster_id":"bba799e9-6e80-4ce6-b96c-fc89b2b8200c","event_cluster_id":"49ec4675-cceb-45d5-bbb2-56483fcd1319"},{"claim_cluster_id":"c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9","event_cluster_id":"b900a5fd-9f6d-409a-b2f1-c21b24addff1"},{"claim_cluster_id":"b198bd93-5f96-4992-9aa2-29e396814e39","event_cluster_id":"cb759cf9-83bb-41f1-8a60-65bf2476c5fa"},{"claim_cluster_id":"bc48e3cd-6317-4a4a-b06b-f8629ebbbbcd","event_cluster_id":"2dfd3fb6-1a3a-4beb-9bdb-2191423af570"},{"claim_cluster_id":"3312bf71-bb24-4752-866e-3b29580d70d1","event_cluster_id":"b6f8ab92-0a99-4ae3-a84c-c1ab0b6d7d39"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"fece93a1-7734-48a4-99b6-9dce302454b2"},{"claim_cluster_id":"702a4627-2eae-451d-b2a9-154358319e24","event_cluster_id":"de42709f-cb35-4f62-b569-11c75f1fbe5e"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"dc60fa2d-dae3-4ea2-a4d5-1da4424a6919"},{"claim_cluster_id":"1190ac87-5191-4e29-877a-253af15bb185","event_cluster_id":"51b63d4e-9a9e-4f49-a1a8-d50a9f8eff02"},{"claim_cluster_id":"ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70","event_cluster_id":"d05207e4-1a3a-4cab-84c5-4af79b01b239"},{"claim_cluster_id":"481b0645-4bcd-4df1-ae15-b184375e551e","event_cluster_id":"906602f3-b23d-4091-b462-b74d3ce8894a"},{"claim_cluster_id":"e0f8bbeb-8967-4f3f-ae0d-4b809311c515","event_cluster_id":"6c7741a7-bba5-415f-86fa-1077ed815fec"},{"claim_cluster_id":"06f63413-3561-4a53-933b-589b1f942c37","event_cluster_id":"d285c4ec-3955-47ea-918b-05a93083bebc"},{"claim_cluster_id":"fd554d0c-cd25-4da2-adf1-dcccfd01f292","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"5a772e21-6b8f-413d-9915-01833aadc67f","event_cluster_id":"4c365f8e-324b-474b-8239-fe362d8fca1a"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"d878f267-808b-4a23-9202-10d08ee3053d"},{"claim_cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","event_cluster_id":"2fc962c7-e77d-4ca3-a166-4f1d011720db"},{"claim_cluster_id":"b9550306-91d4-4e1e-9632-4c73f1957d92","event_cluster_id":"73893bd5-387d-4d08-9fad-0f62b5aacd0c"},{"claim_cluster_id":"e9280ed1-20ec-4c75-8468-086e8c6749dc","event_cluster_id":"0d486f1f-7f93-4053-a807-970ad702d674"},{"claim_cluster_id":"b8208758-3ffb-41f1-97e7-30e90da08e44","event_cluster_id":"a7a90cf5-cc81-4b76-b47f-bd8836b204ba"},{"claim_cluster_id":"96b36513-ec34-4deb-bc5b-c811958c3675","event_cluster_id":"44bced9f-9cdf-42b9-a5c2-b5abf31749ea"},{"claim_cluster_id":"69290a80-8807-401f-b38b-0ff5ba27a43d","event_cluster_id":"37dc3c46-39b6-4d4e-87ad-59040db4662a"},{"claim_cluster_id":"8b3203a2-f473-4957-9689-fdf6ee974697","event_cluster_id":"4005f43b-5b4a-44f8-9781-c0a91127368f"},{"claim_cluster_id":"043e7562-9880-4d36-ba06-fd8e6b3afbe1","event_cluster_id":"f3ad65a5-41f2-46d7-a4ab-cdfd0feea00d"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"79b49988-337e-4ff8-a4e9-5a2de271d6d6"},{"claim_cluster_id":"1e12b1a7-9bc4-4a98-b698-8392df483432","event_cluster_id":"54852fe8-25a9-4bc3-8ed0-4f252eac7d21"},{"claim_cluster_id":"546f63e2-ef89-4f69-bd49-cde47599b05e","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"4c95b4a9-d005-4c7c-8a55-a5a0821d7611","event_cluster_id":"dc2b8b73-2640-4b6c-a7d1-9e5c9873bbf6"},{"claim_cluster_id":"770cc261-67a7-4ed4-85d2-93916689a978","event_cluster_id":"86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"05905deb-04e3-4e57-afeb-f4e623c176cb"},{"claim_cluster_id":"4b605940-f896-4b59-bf12-36fbeec83b94","event_cluster_id":"65324661-3a29-437c-9b4b-f8ea61a6dabf"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"4cf8f034-c2c7-4891-81cd-bb23d16f75ec","event_cluster_id":"7640b35f-031b-4917-bf34-5555111a4a74"},{"claim_cluster_id":"1b63ec5b-2010-4bd3-a351-328e7b4b5470","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"fdc7a586-a2b7-43cb-897c-5aacc04ceaff","event_cluster_id":"2fb41c0c-9dcd-4bc3-b70a-75aee83bcba5"},{"claim_cluster_id":"31ba7a04-0212-474b-8f8e-9374845e4ab5","event_cluster_id":"06aade08-3010-4d09-90ab-647cfcc26947"},{"claim_cluster_id":"be023ca2-f865-4811-854e-b40ab442412b","event_cluster_id":"f15d86b1-5ec6-42af-abb5-8a53b43a9bab"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"264cec13-14ac-4e28-862c-a8260aede982"},{"claim_cluster_id":"3eeddc05-77ec-4d67-9a78-4b328957fe7f","event_cluster_id":"46b53499-f467-4b91-a839-e6551db764a7"},{"claim_cluster_id":"2712567d-2895-48f5-8695-f726eb795979","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","event_cluster_id":"e8c99cdd-553e-4aba-b844-e1556f7a8787"},{"claim_cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","event_cluster_id":"d3ddf15f-7261-4b4f-bdd9-6823755811e6"},{"claim_cluster_id":"58a44cd6-3f44-4460-9d07-d5a28bd55747","event_cluster_id":"b4fb9256-1ac5-4cb5-9d11-a73a825665b3"},{"claim_cluster_id":"94a84124-c591-4219-8ef7-52760d608300","event_cluster_id":"cdec7efe-effe-4d5a-84e5-892cd8aa5135"},{"claim_cluster_id":"dad2ba1b-78a6-4e69-91a7-e473e3d79e42","event_cluster_id":"ebb80698-62b6-438e-85ac-44aff649cb30"},{"claim_cluster_id":"77e72686-2baf-45ab-a679-b8f62cdcf982","event_cluster_id":"37b4342a-fb0a-4dc5-96ce-db0bc15c1568"},{"claim_cluster_id":"c05c40cf-fbe6-4e98-aa0e-98f1fcbb5333","event_cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03"},{"claim_cluster_id":"35218630-91b1-47a4-87cf-29094bd87289","event_cluster_id":"c1a62eb0-76d0-46fb-8060-6353e7306396"},{"claim_cluster_id":"1a4ea1ae-4636-425b-b953-e3a50c80caeb","event_cluster_id":"816b8091-ba27-40e8-864f-f38a64991c28"},{"claim_cluster_id":"511c0db2-0769-45d5-a814-00f974a659aa","event_cluster_id":"32ba4740-f52a-47e5-91ff-4fde0ada2a3e"},{"claim_cluster_id":"33f6801a-acda-4c2e-9708-cf1802dbdbb9","event_cluster_id":"ec9f289c-28f3-4c8f-8168-260fc03a8183"},{"claim_cluster_id":"5c7c452c-db3f-4741-97ef-77d49e8c75b4","event_cluster_id":"d8b8cb3c-4059-4ad7-99fc-df25e1b98b1b"},{"claim_cluster_id":"b2dac904-00a6-4c9f-a283-eccc78d22ae0","event_cluster_id":"8b1769db-6aae-4f31-8eca-13c7641a8a79"},{"claim_cluster_id":"29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489","event_cluster_id":"6c57c5d0-33e4-4282-bbc0-6b80393235a6"},{"claim_cluster_id":"38eef897-6e59-4836-bf0e-1e7e106baf53","event_cluster_id":"00440887-1b0e-4488-8a0b-2f9b2ba9ede3"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"53832c20-28bd-4cb2-a22b-7698f81c17f5"},{"claim_cluster_id":"b7e33865-58b2-4984-a7e1-eed1512539bb","event_cluster_id":"b7518287-9949-4ec0-a078-3d7e49009d46"},{"claim_cluster_id":"043b0606-561e-4868-8354-4c45ee5a2f95","event_cluster_id":"41739d94-ef7a-4bdc-b95f-35d9d4daaddf"},{"claim_cluster_id":"b8a67936-c036-4a45-8680-bb4909cdd3db","event_cluster_id":"c0fe2a1f-22f3-4601-9b6c-36727a9d81a9"},{"claim_cluster_id":"8a60fc08-ff21-49d9-8858-dcff37e21d18","event_cluster_id":"bf840015-2be2-4173-ba65-4d1448510aee"},{"claim_cluster_id":"dfbd57d9-b4af-48fe-adde-4b27c203374e","event_cluster_id":"fd80dc8e-90e1-45e9-b475-5c0e7ce125c9"},{"claim_cluster_id":"f4b62b28-f2fe-4807-a41e-80bf6c8bad68","event_cluster_id":"43cd70ef-d6cc-421f-9e30-15cc399119b7"},{"claim_cluster_id":"fa79376c-183c-4b27-9b35-5eee39b30f87","event_cluster_id":"6bdf1a93-76ba-4948-be05-d02fbb6488f4"},{"claim_cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","event_cluster_id":"4da3a5b6-2b3a-469e-82e1-4fa291688db8"},{"claim_cluster_id":"b4e4a860-8721-4ac3-8eb3-a9dec18b336d","event_cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63"},{"claim_cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","event_cluster_id":"13bcef3e-fd19-4989-b312-5873b1468a28"},{"claim_cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","event_cluster_id":"24603ad6-f39a-4706-80ce-2840439ad61c"},{"claim_cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","event_cluster_id":"8a84554f-19d7-41fa-8647-c3608df3d4f1"},{"claim_cluster_id":"71acf2d0-be7b-4d8e-b3fc-93baaa073aa1","event_cluster_id":"a1395f05-6f91-4eca-a911-53f15292db71"},{"claim_cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","event_cluster_id":"0c951d24-0f2c-41e0-a5be-f5200eceb7d7"},{"claim_cluster_id":"5feff95a-4d00-4a01-9b49-f3df3eb263ca","event_cluster_id":"e19196d4-b7bf-49e0-b42c-244f5f90725b"},{"claim_cluster_id":"c02665b8-8535-44f4-96b2-764b54985f66","event_cluster_id":"c65c30a8-6203-4ff2-8126-866ddc1ad7ee"},{"claim_cluster_id":"1e12b1a7-9bc4-4a98-b698-8392df483432","event_cluster_id":"814e8e7c-9951-4225-be99-2e978ab5ec4d"},{"claim_cluster_id":"664823cc-3309-42a4-9224-e9eaa7ee3fe5","event_cluster_id":"9a1b07d6-f1d6-4b71-a6fc-885000909a93"},{"claim_cluster_id":"cd21b07f-3941-439e-8ffa-59c6da9df98f","event_cluster_id":"e15ef239-9f26-4808-8bf7-31e94108dff6"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"dd5d0634-bc30-45f9-b45a-97773c63db2a","event_cluster_id":"a16e6d0a-ee9f-4150-a6ab-9f0009df2fe4"},{"claim_cluster_id":"d29a2d68-5d53-4ad3-9792-37db5375f45d","event_cluster_id":"bd325bb2-82ff-445b-9556-5c3579998b1b"},{"claim_cluster_id":"595531c2-a2b0-4686-b3ae-4f5525fff05a","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"234be4d1-d0d0-4b65-aa97-a8cd91a0a32e","event_cluster_id":"039f8cf2-d1ad-441e-b62e-9a9fe0c8c803"},{"claim_cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","event_cluster_id":"3680c45d-b58c-4b06-86cb-3a65bd43ebc6"},{"claim_cluster_id":"ca064fa8-d12d-4c48-9fc5-aca6df7f2dc9","event_cluster_id":"360f8a39-1f36-4965-9744-1b8bf78217a1"},{"claim_cluster_id":"8a2e1f2c-6d19-479b-811f-3ccec4820a64","event_cluster_id":"57c8d119-9759-4d0a-a7cd-9c98d4429c3f"},{"claim_cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","event_cluster_id":"771ff184-5478-488e-90da-69f2d3b1dfbb"},{"claim_cluster_id":"700a7ce5-024e-45ce-bc66-61c8dab09717","event_cluster_id":"b1375511-e3be-4083-816e-ce6ea23f39cf"},{"claim_cluster_id":"d89e632e-b2af-4331-9344-c7d1e373d49b","event_cluster_id":"7aadf7ec-8a12-4805-bf87-51d4575c022f"},{"claim_cluster_id":"1c1848e6-9c28-4252-9e24-4dc5cb477be6","event_cluster_id":"03682aa9-6c66-493a-b7f2-cba3c38176e4"},{"claim_cluster_id":"fce90f87-0664-4b8a-bb4f-dc7bbf08cf50","event_cluster_id":"69235fb0-8a7b-49cf-8a07-8d2aa290c9c9"},{"claim_cluster_id":"8308c2eb-92cf-4ca4-876b-d1d947564441","event_cluster_id":"b56ca1ab-f300-4476-ac21-f73e07a1dfa9"},{"claim_cluster_id":"18699af2-76ba-4b44-8dd8-cbb2b538e559","event_cluster_id":"878ab8c3-2760-46b0-8086-c8aa996e56bc"},{"claim_cluster_id":"2ee00586-87af-465c-8466-d1bc41c3886f","event_cluster_id":"d5fb5705-8036-4366-acc0-f2b5f625126b"},{"claim_cluster_id":"29880646-f50e-47bd-8b04-23f2c8716fdf","event_cluster_id":"02e9df36-756a-4f13-96b7-a64b085d932d"},{"claim_cluster_id":"e2676bcb-4f6e-4d98-ba58-3d2aff04d940","event_cluster_id":"094c0c48-56a8-4f19-bf5d-16a053900cf5"},{"claim_cluster_id":"8d550fbc-5131-4294-a815-b9e32f81ad7a","event_cluster_id":"e209eca1-fa4c-48e0-bce4-5bdadede98cd"},{"claim_cluster_id":"61ac97d3-e62e-41a3-b910-360985f7af21","event_cluster_id":"71c5fa4a-0b53-4202-9b3e-1c8038451d63"},{"claim_cluster_id":"2df1a526-a92c-44a2-a3b2-202bf1d7f6d9","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"8d06f8b9-e6ed-4b99-89ef-90434792b924","event_cluster_id":"68230774-a51a-4451-9136-5aab1d1fcce9"},{"claim_cluster_id":"83150260-cbcb-429e-8e22-0e5b897618ff","event_cluster_id":"49b59607-bcf5-4471-8809-4106f681d4d2"},{"claim_cluster_id":"99dfb4e4-9788-4ea5-81a7-c0dd44f60aba","event_cluster_id":"fecb08d6-7113-4fdf-93c0-d68d7f11e733"},{"claim_cluster_id":"5ebc5950-a889-49b1-a0d8-0d905803d030","event_cluster_id":"01d21517-243e-4d94-b9c5-641f8bca7cbf"},{"claim_cluster_id":"16667fe1-8cf7-4fec-9aa8-c5bb30920e90","event_cluster_id":"b5bd71be-fc38-4eed-90dd-db3dd13d58ab"},{"claim_cluster_id":"9c52e5bb-8493-4b3c-8444-69598adc8932","event_cluster_id":"f387334c-114b-4f0f-8f1a-524773e4b44d"},{"claim_cluster_id":"3ea1c92f-805f-4ecb-b23d-a77a7a362e5b","event_cluster_id":"c7cc8a7a-ef8f-4aaa-8735-139c689f3af1"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"193775cc-4b10-4b36-baba-844635425d37"},{"claim_cluster_id":"61b758fd-ce2c-4502-b494-9618880e66e4","event_cluster_id":"af917a84-5c51-4c7b-9efd-b1ddeecaeb3a"},{"claim_cluster_id":"aac18326-5af8-47ed-b7a7-209e78b29dfe","event_cluster_id":"1072cae9-f711-4ddc-9b33-a14d4050ebba"},{"claim_cluster_id":"04938aaa-1985-4664-bfb5-337fffd62a6d","event_cluster_id":"50321d3e-dfc0-4504-be22-01fb2718ed93"},{"claim_cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","event_cluster_id":"8245fae1-2de7-44c3-b580-0a610d90519c"},{"claim_cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","event_cluster_id":"7f659049-c3cb-424c-9dbd-559d942783fc"},{"claim_cluster_id":"470bd6d3-39cf-4a39-9a1c-be6c638cdd0d","event_cluster_id":"a34d03f2-7fce-45f7-b77c-0c16c720e6db"},{"claim_cluster_id":"c9073334-10d9-4fd4-905b-747ad45c136a","event_cluster_id":"48d341a5-63e7-4586-8058-1ab4e4d8c613"},{"claim_cluster_id":"700a7ce5-024e-45ce-bc66-61c8dab09717","event_cluster_id":"533c13a6-e2bd-46be-9422-2e368c4b5793"},{"claim_cluster_id":"f6aedae8-b368-419e-9158-abbe718748ba","event_cluster_id":"8631d2bd-115e-4513-8568-952af022961b"},{"claim_cluster_id":"f4b62b28-f2fe-4807-a41e-80bf6c8bad68","event_cluster_id":"09d77729-56d6-4baf-a41c-830b574929ac"},{"claim_cluster_id":"6bdcff96-571d-4879-91a7-d6084340625f","event_cluster_id":"1285d3bf-ce3b-4c4d-b6ee-39e378371b65"},{"claim_cluster_id":"ce659db6-9043-4f18-a410-39321ba5fd81","event_cluster_id":"878a9636-1e8d-41b7-b38c-b1f621f47d04"},{"claim_cluster_id":"7cacaa03-4763-4931-91bd-306a3231361c","event_cluster_id":"7628ae8d-befe-43ea-95f0-6fd9a907267a"},{"claim_cluster_id":"19ddcd3b-18db-461a-b208-f198db3e1e07","event_cluster_id":"ae81b069-06de-4c85-affc-804bac2e778d"},{"claim_cluster_id":"c35acce9-0a6f-4e25-8869-1a5e38bf302a","event_cluster_id":"877d0ee7-3726-4284-a1ed-d3b7c9b6d67b"},{"claim_cluster_id":"281fca06-ede2-40bc-9960-0788b1d20c23","event_cluster_id":"8a12c9b8-6999-4708-96d0-9b9b5cea643c"},{"claim_cluster_id":"d6760008-6cbf-4c8c-b88a-b478081312d0","event_cluster_id":"b49e3614-d80a-41ae-8ee2-883e8abec97f"},{"claim_cluster_id":"37f5cf93-69fa-41bf-960a-1fd7783d4299","event_cluster_id":"5ccf3948-9cc8-42f4-a17d-9079c20482ce"},{"claim_cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","event_cluster_id":"4586dde9-ed48-4b34-aa3d-9d5f004f908c"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"746085cd-6635-459a-8b25-138f4d67d9dc","event_cluster_id":"08ccb8f3-d97c-4442-b830-fac7f751221a"},{"claim_cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","event_cluster_id":"25676d7b-137f-4f70-b3ce-39af6bc7a4fe"},{"claim_cluster_id":"9a03a84a-f375-4382-bf36-e4f5df1b4795","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","event_cluster_id":"31351498-4fc3-4c6e-8df2-7c515d19509b"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"df593162-9ce4-4407-acdb-640e7602b7fc"},{"claim_cluster_id":"d2f81fce-8c92-45e8-8294-41af7752f1db","event_cluster_id":"238a575a-ac72-4ae9-8880-72409a39a327"},{"claim_cluster_id":"38711d17-ac82-464c-a077-7a82e0d362fd","event_cluster_id":"2130a389-a1b6-4f7d-b3bc-7b83efb0ab8e"},{"claim_cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","event_cluster_id":"4ddb3ea0-b81e-40cf-8c94-adef57bca158"},{"claim_cluster_id":"f8d5c2ae-ad96-41f1-8875-2d89a574f697","event_cluster_id":"1d8821bb-7f0e-41b4-86e3-603f9228f781"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"e53d664b-c538-43f3-a025-7686ca315f8a","event_cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"8f75e655-8582-4cb0-9320-47aef61dad78"},{"claim_cluster_id":"3da4f222-08f1-4864-8aa3-3576d8a64207","event_cluster_id":"805b132f-a73a-418b-a147-d9899a145b6b"},{"claim_cluster_id":"17326b3f-1222-43e5-90d5-e26c86b0e984","event_cluster_id":"8abd35db-2186-4408-8be6-3af382d275ab"},{"claim_cluster_id":"e0b3b058-f41a-4ebc-b9bd-9e20a141c340","event_cluster_id":"c213afe5-5445-4f82-8c73-fbf8e0f02000"},{"claim_cluster_id":"468c9eea-e420-4271-9b73-0e2e747f6185","event_cluster_id":"c92757d9-a065-4dc2-806f-96c7c9890f76"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"adcf9b34-2bf2-44ce-9216-0201823c4649"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"d821d63f-63c7-4a38-a3fa-ddd32322fec9"},{"claim_cluster_id":"221f2ccb-c412-4e42-8d5c-82e681a61d32","event_cluster_id":"a4bb7e8e-38b8-4326-bf96-4782b99feba1"},{"claim_cluster_id":"bd6de2da-8b5f-4e38-83bd-28294e175aca","event_cluster_id":"ea8c27e8-3141-489f-a75f-e180b110cc1b"},{"claim_cluster_id":"c3dda95e-e922-4b18-b7fd-9f071350fa6d","event_cluster_id":"d2250c76-7e85-4e68-9f7d-cb54aa712276"},{"claim_cluster_id":"bfd0fa79-f057-4e1b-abfc-222496dbeabb","event_cluster_id":"f2531848-788a-44fc-8497-b2d0aa74b135"},{"claim_cluster_id":"cce124fe-f108-4571-9074-db48a458127d","event_cluster_id":"2fba36c8-9087-441b-9f3b-6c08ceeffdb2"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"3ad1f302-26c2-471c-bf5f-e79fa32778b5"},{"claim_cluster_id":"2cb0cf7d-4f72-4e53-9096-b92c1763568c","event_cluster_id":"0357efdc-cefb-46e1-88fc-fd184c29a753"},{"claim_cluster_id":"a6506a53-789c-4447-b726-b2dd59d9b862","event_cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9"},{"claim_cluster_id":"989e42eb-c62e-4e68-87e6-6b230317d087","event_cluster_id":"b36258d9-8de3-4cee-b76a-8d1ee69dd79c"},{"claim_cluster_id":"4e71d535-1646-4ea5-9c47-04fb1464f390","event_cluster_id":"3c37960f-c2a7-40e7-ba67-6890fc5f05e4"},{"claim_cluster_id":"5ece0141-8dd6-405b-93cf-5585050f4efe","event_cluster_id":"a66bb7d0-dc6f-4116-a7d1-4f4c8d7be3a8"},{"claim_cluster_id":"558484b7-ac90-44c3-8eec-a2f364ca9460","event_cluster_id":"a548b0a4-9a63-47ec-a6ab-6b9d50ab7aaf"},{"claim_cluster_id":"0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5","event_cluster_id":"aab98ee7-4c57-4777-942d-e109c08eee52"},{"claim_cluster_id":"cbbcd94e-9982-4e51-989e-706618e8fd67","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"752ad0a4-463c-4695-a371-bfed4c14cfc2"},{"claim_cluster_id":"834f4385-ef2b-4b12-81b1-8e94ff3098e8","event_cluster_id":"e4820af7-bf5b-455e-a72e-bb48cada6e0a"},{"claim_cluster_id":"aa973fc5-c596-49d2-86f1-80f2a9f419e9","event_cluster_id":"20eb00aa-eba7-4ec7-aca2-e9f771d49a23"},{"claim_cluster_id":"09287807-b3db-4547-9baf-8656d4a8733f","event_cluster_id":"0dc901d8-d48c-4458-a536-133dced8eb99"},{"claim_cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","event_cluster_id":"e21a96d2-b5b0-4a69-80bb-66020b0b8a54"},{"claim_cluster_id":"000d729d-1afe-4b59-b42a-5d8012efd354","event_cluster_id":"802c356d-4c20-44e7-ba85-44dda5294d0b"},{"claim_cluster_id":"09287807-b3db-4547-9baf-8656d4a8733f","event_cluster_id":"a35296f0-09b1-4344-8dc2-fa3ee1b2f399"},{"claim_cluster_id":"86160f22-53c1-4e04-a28d-86c0e883fa44","event_cluster_id":"c9858cae-3215-44c8-9820-2f7cde47d95d"},{"claim_cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","event_cluster_id":"d0ea565b-64ab-44f3-9679-c2236d37aa42"},{"claim_cluster_id":"2fa38dbd-c491-4579-bb95-e37ac00e125d","event_cluster_id":"02dbbaf3-2dcd-4ef2-b716-bd9080164205"},{"claim_cluster_id":"36472627-9945-496e-89a2-063ceee22d24","event_cluster_id":"5437d23d-a8b8-4a7b-b296-c42b5945a223"},{"claim_cluster_id":"767a107b-6141-45c6-9ffe-6f7fde1b3426","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"0f733538-ef56-427f-ad23-04cb6fae87ae","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"e90ef9df-5189-4af1-8d38-f4bc22fa022a"},{"claim_cluster_id":"c5d18c78-4df0-44fa-9f69-67266b1079e2","event_cluster_id":"d18f265e-1140-4ce3-9bf4-76f0c6ccf8de"},{"claim_cluster_id":"ef636ecf-8b34-4007-8f71-b4d5ed7d3c33","event_cluster_id":"ddb7dbbd-226e-4674-859d-8c16b4f4ce9e"},{"claim_cluster_id":"ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb","event_cluster_id":"a5511c2f-b2db-4795-9bb8-2441a998fd2e"},{"claim_cluster_id":"fa32fcee-2bb1-444a-8515-123065611c9e","event_cluster_id":"f5c0430d-6c19-4e4b-815d-7de708ba52a8"},{"claim_cluster_id":"17be823a-a533-4e33-9ba0-969c3b8ddbd0","event_cluster_id":"350bc7fa-e017-468b-abf6-4d1ab1633f69"},{"claim_cluster_id":"901f6891-5f9b-4fa4-a368-69a4f20e9617","event_cluster_id":"c595259b-ebf4-4c2b-b3d7-406a6b1c52ac"},{"claim_cluster_id":"58021478-0a50-495e-b059-4560ef7c90f4","event_cluster_id":"7ccf5ec9-3916-43b6-a44f-7cfb24300693"},{"claim_cluster_id":"949ec20d-24b3-4de5-a36b-32e35cbe9392","event_cluster_id":"b9c0c358-d5e1-4c6e-9602-a307115394e0"},{"claim_cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","event_cluster_id":"f004205a-4f06-4d9f-aafe-357afc465bbc"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"0208ef8f-f321-4a60-8e1f-9ae03308e345"},{"claim_cluster_id":"199ae7ec-217a-4cab-a030-ff0a4838c0a8","event_cluster_id":"96dc4289-9f74-41d4-905d-780af68fcb09"},{"claim_cluster_id":"9477ce9c-5a6e-4e61-9f13-cf68c95b219f","event_cluster_id":"35b22dab-25ce-4dde-ab9f-31302b06eb90"},{"claim_cluster_id":"f42001e5-7364-43c2-8d35-74c3552a9ccb","event_cluster_id":"c9720688-df71-4db3-980b-d7e5c9b865b6"},{"claim_cluster_id":"b4fd3f81-2344-4edd-8ae4-fd7b59d99888","event_cluster_id":"0473444c-8fc1-4828-8ed2-8a53db5a4083"},{"claim_cluster_id":"2ac87cef-db31-40dd-8c5e-d88d478fd344","event_cluster_id":"fcff6be0-ae06-401d-8c01-25c7bfff466f"},{"claim_cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","event_cluster_id":"75ded654-747a-4edb-9577-5b6d8ad0c3a1"},{"claim_cluster_id":"32bf3674-86a6-4cde-a9e5-20a5e3965e02","event_cluster_id":"e91dd131-96fc-484a-8d0e-4bac856ecd99"},{"claim_cluster_id":"10317341-49c9-447e-bafb-6ef554948da9","event_cluster_id":"99d7c1e6-04d8-4af7-b4d1-8b1bbaa99691"},{"claim_cluster_id":"7e639892-5cda-4557-94c4-87321bdc3233","event_cluster_id":"5674d01b-2996-4ed7-850d-de449d707ce5"},{"claim_cluster_id":"4d2dc30e-97f5-49d3-80df-c343048e6856","event_cluster_id":"d918fb3a-9d62-4cdd-89a1-68fdc8de204d"},{"claim_cluster_id":"0aded89b-0a86-47dd-8291-b59848abe762","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"91ccf699-eaec-41a7-8213-08934dbe2395","event_cluster_id":"419042ff-8e55-4ecd-bd38-c47ada6d614a"},{"claim_cluster_id":"266128fe-9d68-4687-b95c-b0654a1c7f0e","event_cluster_id":"b4d1a337-88d8-4989-8d52-1a04d38e6e21"},{"claim_cluster_id":"551e444f-6554-45dd-baba-6798fd43af6b","event_cluster_id":"f508c62e-4dcd-4831-9789-bacd1b75b831"},{"claim_cluster_id":"c98491ce-51cb-40b0-93ae-d389e1c9d7a5","event_cluster_id":"7a1c3f26-b729-4a3f-8142-fcd9c6768773"},{"claim_cluster_id":"d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576","event_cluster_id":"f5784495-7eb1-4199-8e36-89b434da6e01"},{"claim_cluster_id":"6c812e58-19af-4264-b856-e922307ab466","event_cluster_id":"adf7c833-60db-4866-83b7-e6d0f1133790"},{"claim_cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"a5d39319-660b-4b6e-acb4-246464538db6","event_cluster_id":"9db91412-4257-4b55-b7af-99ea85b2a619"},{"claim_cluster_id":"7561e4ca-9d0c-4966-9181-2c8e8d681852","event_cluster_id":"afed780e-77ff-46bf-ac41-4e66698ad45e"},{"claim_cluster_id":"41d64b2b-508f-4c89-9c48-7c598989efd1","event_cluster_id":"47b5a921-4ec9-4534-86e3-d697a2a00470"},{"claim_cluster_id":"18fe8f4b-896d-47b4-a019-0383dc22d38e","event_cluster_id":"29022861-4975-4c12-9a9e-92bb32cd1e85"},{"claim_cluster_id":"0c398c2c-4672-4f1e-ba98-17d7320a9537","event_cluster_id":"7b1f2cfc-5328-4132-ac99-4d91818f60f6"},{"claim_cluster_id":"8a0accb4-caf5-4741-9038-3360a1a08c25","event_cluster_id":"eaf67764-9289-414e-b58d-ac157f48690c"},{"claim_cluster_id":"1c30353a-a7dc-48dd-bca2-56c91aa06ab6","event_cluster_id":"0d5de813-beee-4fba-8db1-09461ff50d02"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"cd034398-fb5e-493c-9a4b-be08f05b5ca7"},{"claim_cluster_id":"97e04a01-6626-4196-a12d-eac1df348581","event_cluster_id":"95af035b-c14e-4753-b211-c4a8a4ddbdf2"},{"claim_cluster_id":"b7635b58-ad1e-4cb4-a317-8d48ce1cdddd","event_cluster_id":"2e33e564-22f6-46fe-85d8-8500ce2d3380"},{"claim_cluster_id":"3ea1c92f-805f-4ecb-b23d-a77a7a362e5b","event_cluster_id":"40612f57-e760-4270-afaa-ede3763cda33"},{"claim_cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","event_cluster_id":"7e303676-78ac-40b1-9448-471faabb2115"},{"claim_cluster_id":"543e79b8-1458-43e8-a976-eaa0fcb652ab","event_cluster_id":"be58ac09-a64e-4854-a7b4-83f25a02c250"},{"claim_cluster_id":"d8581e68-7fcf-4616-92c1-9daff0a2d8ae","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"232994db-dcd7-4db4-9ea3-fad6185233a7","event_cluster_id":"b89167c2-18ac-44c5-84c6-4b246cc9bd50"},{"claim_cluster_id":"b27abfde-f9d9-4f52-9ce7-8c541388281c","event_cluster_id":"59c81fc9-37c0-4304-9d97-9e5694d8be20"},{"claim_cluster_id":"a3a558f9-9b36-49bc-be77-b1d77d8074f6","event_cluster_id":"fec224cb-9f4c-46ad-af9f-03437451a2c2"},{"claim_cluster_id":"691c3c1b-0058-48a0-aaa7-5a38747b8c58","event_cluster_id":"722d06bc-1512-434a-8214-a8daff8fb8a9"},{"claim_cluster_id":"b26a4469-2931-4dab-aa78-be1b6fba8a36","event_cluster_id":"9f686d1d-9231-4037-982f-0d37e6ded860"},{"claim_cluster_id":"a4182192-73bb-4165-ad72-05ff39be899d","event_cluster_id":"f4bde172-477b-497a-9e85-fb7b55ca0d1c"},{"claim_cluster_id":"62fbb5b2-0ba7-4211-b72a-eb1c18543408","event_cluster_id":"907e5aa7-c645-41eb-a469-330fec247119"},{"claim_cluster_id":"f9741213-db12-438e-ba4b-5df13a3381e4","event_cluster_id":"48b7513c-41a4-4a7e-876a-36f9b1eed5df"},{"claim_cluster_id":"cd2c9191-f97a-49fd-9d7d-f0744cdaaf72","event_cluster_id":"93df5ce1-4286-44c4-8457-3b0ae5570ff2"},{"claim_cluster_id":"fa79376c-183c-4b27-9b35-5eee39b30f87","event_cluster_id":"ac328a78-ba12-4fbf-888f-9c3c8967ccba"},{"claim_cluster_id":"310f4e19-f7f5-403e-af6f-b2064fadd246","event_cluster_id":"6f277c5a-d392-4a17-b884-6fd70ae638a3"},{"claim_cluster_id":"14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc","event_cluster_id":"a7783b6a-7d1f-4493-9664-55b728cadb9e"},{"claim_cluster_id":"e64bcf93-086e-429d-9ff7-3a1518b3ae51","event_cluster_id":"8a12c9b8-6999-4708-96d0-9b9b5cea643c"},{"claim_cluster_id":"4801b48a-d91c-4dc3-9797-76929432b0ef","event_cluster_id":"9ff255c3-3bb1-4b2b-8446-496debbb40e2"},{"claim_cluster_id":"b654c64c-3acf-45f6-a6ea-c4584b8c70fe","event_cluster_id":"afc9e303-f841-4627-a50f-c58cb00a2220"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"f9d888bd-a05c-4b7c-9a69-097ffb41a69e"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"65f3a4f7-31a9-4a5f-92ab-a9f153d96b50"},{"claim_cluster_id":"5d4bd659-348a-4fe3-bacf-eb25b0043f94","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"0c0cca84-dd68-41a0-8489-cb2d22400e3a","event_cluster_id":"1480b5d9-5e00-461a-b194-d322e838f544"},{"claim_cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","event_cluster_id":"65ac3d2f-1144-42ab-9435-1522b78a54a3"},{"claim_cluster_id":"203655c2-f1ad-4fb6-94c5-5fc8218603d3","event_cluster_id":"50ed7708-9545-452f-b227-8fc95b9490b9"},{"claim_cluster_id":"ab52850c-7dc5-4f99-b37e-0c628b078043","event_cluster_id":"d53cdbb5-0ed7-4595-a5cc-31ff93c45b69"},{"claim_cluster_id":"54a8d4bb-c88c-46df-a439-6be0dfcdce0d","event_cluster_id":"5b49dda1-0066-4031-bd05-509e4245118d"},{"claim_cluster_id":"c0426c3e-a327-4be7-b689-905cba5cdfca","event_cluster_id":"7130da69-c674-4096-9b2f-90376c9466d7"},{"claim_cluster_id":"4ada70f8-8bb6-4995-8f14-e79e769b0629","event_cluster_id":"61ee629a-3d51-41dc-9089-461569ecf949"},{"claim_cluster_id":"25acea26-0f6c-421d-8050-ebc9dac75b8d","event_cluster_id":"d7ce0029-7c2c-40fb-8d24-32029ffa4b81"},{"claim_cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","event_cluster_id":"3fee6535-a988-4207-9d1e-737120abbcbb"},{"claim_cluster_id":"e36180c3-afe0-495c-8168-73e631f50a1c","event_cluster_id":"749b6cb0-84a3-49bb-a39c-84a371599d47"},{"claim_cluster_id":"528a9885-82c7-4bee-beac-f85e4c7c3f1b","event_cluster_id":"97818d6e-d8de-47c2-bddb-148ab8c2d1b7"},{"claim_cluster_id":"558e806a-d249-4f8a-8e7e-fb4b28552537","event_cluster_id":"e8d4709f-937a-436c-a2c9-ff8bff8819ca"},{"claim_cluster_id":"170448e1-fefc-424b-b5a4-23941f88389e","event_cluster_id":"4aba8ac6-afc1-46c8-8568-0d2d6d6bddaf"},{"claim_cluster_id":"bd0e72d0-0f07-4c8e-ba6f-6a4178be6cee","event_cluster_id":"978027c6-a544-4944-bbb9-ca0424967ff9"},{"claim_cluster_id":"38d2a616-9f37-42ea-8e5e-3010dc76a2ba","event_cluster_id":"bc347754-e0eb-40ff-81ea-81da10f629ed"},{"claim_cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","event_cluster_id":"b5cfe764-3a89-4e77-9f9e-c720d7d22394"},{"claim_cluster_id":"0a8b23b0-e002-4dc9-aefa-6b8b8922f3ff","event_cluster_id":"39994f31-5ff9-43be-a15d-3547ec296a5a"},{"claim_cluster_id":"28aee566-0979-4444-a6e1-cda00f681d91","event_cluster_id":"d96ea11e-5d88-4a27-8ab4-66bfb4326c28"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"4027d10f-7288-4413-85e7-b5b47209b817"},{"claim_cluster_id":"c5298737-21d9-47c4-b52e-e662ee88b15b","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"edec9892-cca5-4a34-b102-ebb0bb45e077","event_cluster_id":"9ec7d104-4eab-4fd5-9ba5-4ccd50945a34"},{"claim_cluster_id":"8d20ee1c-7a34-4de3-a19e-635d0eb460b0","event_cluster_id":"da38f087-665c-4abb-8af5-ed1c3c09563d"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"b26a20fa-d793-419d-b599-26d1ed57c2b3","event_cluster_id":"6f732a42-b524-4da0-a300-f64610c49d4f"},{"claim_cluster_id":"9d1065d7-3830-4746-a836-8da581c0bbb5","event_cluster_id":"d6e26a99-056e-4587-a461-8e9b192ce947"},{"claim_cluster_id":"595531c2-a2b0-4686-b3ae-4f5525fff05a","event_cluster_id":"de3dd2d3-d79d-4172-a1cf-b6ac1238b295"},{"claim_cluster_id":"68637c5d-53b2-4a1b-b193-4fe1333f1416","event_cluster_id":"24603ad6-f39a-4706-80ce-2840439ad61c"},{"claim_cluster_id":"11e43ecc-22c8-4f1c-b13a-fb97013ce963","event_cluster_id":"294c224e-4fa2-412c-a08d-02a89eff2a7b"},{"claim_cluster_id":"4a575d85-5f97-4baa-be78-2c26ecefb471","event_cluster_id":"2d8ca62e-1cf1-4407-a036-bf48f62909c5"},{"claim_cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","event_cluster_id":"14c3f0e3-2371-447c-8445-1ac6c299f633"},{"claim_cluster_id":"03ec1dbc-4ed4-48f3-b875-cc73a019f7f0","event_cluster_id":"a8cd7286-4d2f-4b1f-877f-75865a61f584"},{"claim_cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","event_cluster_id":"fe5794f0-39d5-4958-9baa-650967c24ce0"},{"claim_cluster_id":"d9041723-b3d2-4f6c-85e6-435010ef6231","event_cluster_id":"21aa3ba8-e0ce-434f-bbd4-03d295297e84"},{"claim_cluster_id":"469e17e6-447a-4bc6-9bab-f2cb595f07e0","event_cluster_id":"a7fcff89-a4a0-45c3-b800-3d7861e64986"},{"claim_cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","event_cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec"},{"claim_cluster_id":"c25095fd-de4f-41d0-8719-35f31e51779a","event_cluster_id":"37e4b5f9-aa2b-41cd-b6a4-443e69596bba"},{"claim_cluster_id":"d6609854-87fa-44e4-a436-a7b597944aa1","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"4c95b4a9-d005-4c7c-8a55-a5a0821d7611","event_cluster_id":"5035fa8a-cb8a-4b4a-a412-c85f5b3586dd"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"e82f3b8b-97c9-4869-b282-3dfd951ace47"},{"claim_cluster_id":"dad2ba1b-78a6-4e69-91a7-e473e3d79e42","event_cluster_id":"cc256628-cc7d-493f-98f7-e2382cb4b346"},{"claim_cluster_id":"d3ee5536-f1ec-4a1b-9b1a-82ff92aa04a4","event_cluster_id":"437a3d9b-28c4-4057-94e1-09375ae72bc9"},{"claim_cluster_id":"c3383556-4a09-4d9a-b202-b1b017162bd3","event_cluster_id":"bf80dbed-695d-42ab-adf5-4b079e397c99"},{"claim_cluster_id":"f6b9e37f-45a9-4864-8489-2f475476f4fc","event_cluster_id":"eb91a168-c109-40bf-9679-0913a309af40"},{"claim_cluster_id":"15b9ef6b-09b3-4dc2-aa2e-09ba6d46709a","event_cluster_id":"efabc150-323f-4c88-9041-fa0370310d1e"},{"claim_cluster_id":"f6b9e37f-45a9-4864-8489-2f475476f4fc","event_cluster_id":"8bfd9054-2484-4b95-af6e-1881fb8804d9"},{"claim_cluster_id":"70a36c06-fbb9-4f71-bf77-74f433672b24","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"9012b6f3-2c16-482a-b276-63925d342482","event_cluster_id":"635251ae-6796-4c05-a3b4-938f1760fe23"},{"claim_cluster_id":"d08db747-1994-456e-82f1-cca372892842","event_cluster_id":"2197b0cf-d748-489f-aa22-936ee02a0c14"},{"claim_cluster_id":"abd83725-20da-4a40-a5cf-bb6715d5460b","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"5ebc5950-a889-49b1-a0d8-0d905803d030","event_cluster_id":"b14f50e3-04b1-4e58-a4b1-8a1de6c4e2d2"},{"claim_cluster_id":"0e92b3d1-2946-4cb0-a0ae-5e9e0cf674a5","event_cluster_id":"24658627-4999-4848-a061-5b2350a4cf4b"},{"claim_cluster_id":"ec868d12-f24d-450d-bca9-2e8a9f4e8021","event_cluster_id":"ed28ca5b-2948-4f9e-a9bc-a57f2f3f7cbd"},{"claim_cluster_id":"463ff506-01da-43ee-96ab-3704e89855e2","event_cluster_id":"1b57b41a-f9e8-4e6b-8f0a-7325375bb2f7"},{"claim_cluster_id":"99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf","event_cluster_id":"34a1784c-8849-4447-8724-747b9b1cd1bd"},{"claim_cluster_id":"bd7226f9-5942-4c7e-a2e1-156f8c1e7b81","event_cluster_id":"6eae5590-4ea2-4d5f-b4f2-a402cc15dbc9"},{"claim_cluster_id":"71acf2d0-be7b-4d8e-b3fc-93baaa073aa1","event_cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163"},{"claim_cluster_id":"ba694c90-be36-448b-9da2-f3ed0d816139","event_cluster_id":"68f4e1e3-51cf-46cb-8e4c-826f56e18aae"},{"claim_cluster_id":"11c93b57-586c-4cef-a254-66245b297aca","event_cluster_id":"f0bf93b5-3fae-4f3e-8e8b-13d89108a924"},{"claim_cluster_id":"9594285e-8196-4153-9b31-89250a7200d5","event_cluster_id":"d7ce0029-7c2c-40fb-8d24-32029ffa4b81"},{"claim_cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","event_cluster_id":"a9534c6f-c812-46b1-a237-7680deaae455"},{"claim_cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","event_cluster_id":"a22c2709-36d1-4c69-91df-446cf30d0361"},{"claim_cluster_id":"d6760008-6cbf-4c8c-b88a-b478081312d0","event_cluster_id":"e2ca3c4e-ab36-4cff-8fb9-fa527a161a3f"},{"claim_cluster_id":"e03ac9ce-f105-49c9-9a2f-9442b3b31044","event_cluster_id":"341aa4ce-b339-4cde-b356-d8223a398402"},{"claim_cluster_id":"5c1d5636-b62a-4962-911d-1136d9629b6a","event_cluster_id":"d81a0c92-8b3c-4dd5-8534-db608b237cf8"},{"claim_cluster_id":"bbf2648f-d211-49b0-bf5c-a562e43902c5","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","event_cluster_id":"b5041259-ba71-468c-b2f9-83e8ea0057c6"},{"claim_cluster_id":"f731bc0b-cabf-4314-a5f8-e94d31589cea","event_cluster_id":"af431814-360b-4c41-83d1-6147d4068846"},{"claim_cluster_id":"0f3a2cc5-8301-476a-b658-747594635542","event_cluster_id":"273cff70-66df-48dd-9efa-69156787ee64"},{"claim_cluster_id":"aa908c8f-4075-45ac-a932-631e5efec76c","event_cluster_id":"e90f8735-8232-4af5-85c8-b777502c4f0b"},{"claim_cluster_id":"eea02be7-fd53-47b5-9804-7a2f89de23f2","event_cluster_id":"0d76345c-1ef8-406a-a4b5-284717ab866d"},{"claim_cluster_id":"fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec","event_cluster_id":"ecf70116-2753-4a2e-946e-961f8655a246"},{"claim_cluster_id":"d832a602-46fe-4c29-83ff-f47197eab057","event_cluster_id":"1343596d-8a4d-4776-9d4a-d41490b7cb7b"},{"claim_cluster_id":"de30ed78-2cf8-480b-aacb-665d9572f1b4","event_cluster_id":"7767496a-74e6-483e-a0d3-11edd8016ac2"},{"claim_cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","event_cluster_id":"e2a8c8cd-cdce-473b-b2cd-fa97668f4fb5"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"591d0c93-3cfa-4639-9dee-c69a3f6b0f9b"},{"claim_cluster_id":"a7d1cc33-aa3a-4ee3-86f6-065986a716af","event_cluster_id":"80adf73d-0e40-41bf-902a-efc33053db25"},{"claim_cluster_id":"773a0c25-df3d-4865-86dd-a73825ed69b0","event_cluster_id":"a685f849-800e-4402-90fe-e957d6fe91e6"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"0af9e942-0bcb-4d79-81df-118cf826ff70"},{"claim_cluster_id":"67d719d1-a600-418b-b08c-286005c2cb08","event_cluster_id":"94f3a60f-f903-4813-b891-508644ee87e0"},{"claim_cluster_id":"d21ce376-5e68-41d1-903e-db8ea2f295f8","event_cluster_id":"b98f7184-2007-47d3-9d06-42431c2a8c92"},{"claim_cluster_id":"9fb5216e-3d0c-403e-a2bf-9368fa3e3592","event_cluster_id":"108f968f-7171-480b-9225-ebaea32953bb"},{"claim_cluster_id":"b865573b-6b72-46cd-b3c0-a1458e7df010","event_cluster_id":"a5ff0407-3f9a-4c9e-b0e5-8fe919998cf3"},{"claim_cluster_id":"1cd94f5b-6850-44c5-b48e-2bcdab6eefd2","event_cluster_id":"f8408d7a-6690-478f-a0da-8baa781f898e"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"acddf1eb-d6f9-4c70-9523-034fc5a8acd5"},{"claim_cluster_id":"e4e03461-6763-4291-b9e4-bd4feccb46e2","event_cluster_id":"b04942a2-8d33-487f-9e37-33193a4bf9b5"},{"claim_cluster_id":"f5a86628-9ae6-4d94-ad96-d00a9cad52bb","event_cluster_id":"fc20c413-7f2c-4fbe-b8d9-0aab094ec5bd"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"db350168-e89e-48c8-a5ce-3b8c59130017"},{"claim_cluster_id":"43e40d68-962f-4fc6-83f4-ab836f751e9e","event_cluster_id":"b10b3160-e0dc-461b-a456-f6327586eb6a"},{"claim_cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","event_cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03"},{"claim_cluster_id":"4c6dd811-1cc8-4f37-9fa7-2bc4bf91d082","event_cluster_id":"b86b1a76-d691-4bc6-9266-214b0cf4e6f3"},{"claim_cluster_id":"b60fefc6-3713-474d-b9b3-03ebad7a4f1c","event_cluster_id":"9bb19a50-cefb-44ce-9b28-e30fd2969d96"},{"claim_cluster_id":"fd554d0c-cd25-4da2-adf1-dcccfd01f292","event_cluster_id":"afc0b94b-3d14-41ac-a746-8c4fbe3bd721"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"b5e4c53f-7f15-4f0d-b014-ab5bdfef9779"},{"claim_cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","event_cluster_id":"96b1dd29-d1cf-4ea9-9b10-e52b59e1a6b5"},{"claim_cluster_id":"cf8a7c88-fcb8-4b8d-aadb-46cb3168db25","event_cluster_id":"220dfe6b-2774-4a8a-8306-3094dfce156d"},{"claim_cluster_id":"10317341-49c9-447e-bafb-6ef554948da9","event_cluster_id":"1dc64c65-d91b-4753-b1f9-a4cf4ca41268"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"4e7a1657-2c4e-4bb2-bcd7-0842a01bbc47"},{"claim_cluster_id":"6e99d559-c095-46a1-a671-2a3d2e8566bb","event_cluster_id":"07b1d44b-f7cd-4319-883a-80ea44f07316"},{"claim_cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","event_cluster_id":"f8408d7a-6690-478f-a0da-8baa781f898e"},{"claim_cluster_id":"e1ad3c4e-eefb-42e0-8fe7-edf486c4da19","event_cluster_id":"2528bd46-af3f-4f9d-8f91-2dbf49b3388e"},{"claim_cluster_id":"ae4b9b9a-f45b-4a5c-bdf0-f56fa2a563eb","event_cluster_id":"1faa4831-480b-4038-9fea-49267683c570"},{"claim_cluster_id":"9398c496-5e62-4d1b-94c1-e1eeaf48778c","event_cluster_id":"46b03cb2-bbc6-4b28-b240-16cc3f30e3bc"},{"claim_cluster_id":"c214c388-1bcb-48de-9ccf-d250135ec39d","event_cluster_id":"a1591642-57e8-440b-a466-b4c02f9a6be6"},{"claim_cluster_id":"837dbefb-7b54-4aa1-aad3-56f0ea97f9ed","event_cluster_id":"8914f459-9cc2-4812-af44-1d97ee5106e3"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"c784871a-fcaa-4345-b3a8-ae8869019499","event_cluster_id":"607cc6ab-a0bd-429e-a391-92e1066b96d9"},{"claim_cluster_id":"9096173e-de4b-47e9-9e39-b39282b05e47","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"6d2a1320-d829-403b-913c-d7cdbf1cbf14","event_cluster_id":"f419c65f-41b5-4ce9-829b-e8de4a1f6af4"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"5dc7d30c-f418-4e0a-bf24-d3caf57c0ec4"},{"claim_cluster_id":"64664899-be28-4387-939b-822e6b833f08","event_cluster_id":"ce2c1d0b-75ef-45c7-a23e-a0fa3e07457f"},{"claim_cluster_id":"ce2b0119-85f6-4619-9c50-256557181c73","event_cluster_id":"aa5a0292-80cc-40db-8f50-3b92fa1db057"},{"claim_cluster_id":"516e99dd-d52c-4f12-8e2e-b0ba0e0b515d","event_cluster_id":"155333a7-ab36-4219-a8f6-9496d1f00dc8"},{"claim_cluster_id":"4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d","event_cluster_id":"f0e9965e-e941-4451-a097-f16f023a8147"},{"claim_cluster_id":"821946a1-401a-4657-be17-b3ed51371c13","event_cluster_id":"e1005ff4-1bb8-462d-bc29-153ca1f78b3b"},{"claim_cluster_id":"2ebece0c-e502-49a9-94b9-5df90f1b8e51","event_cluster_id":"a7c7aaf0-419c-4efc-8f5e-14d3f71ed9ab"},{"claim_cluster_id":"a6d51f65-13a0-42d8-b6fe-66f9daf5bd01","event_cluster_id":"c3de0789-c302-4248-804e-d8d020c50634"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"d5752cab-3caa-48c6-b67d-7ac6c89bd054"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"e4c129ec-5dad-46c4-884d-38afdd290e76"},{"claim_cluster_id":"9096173e-de4b-47e9-9e39-b39282b05e47","event_cluster_id":"cfc42d88-49ac-4610-a5c7-0cce12304171"},{"claim_cluster_id":"0f8d7640-e263-43ac-9294-0e526087824c","event_cluster_id":"ad5a4bab-60d8-4977-8f90-38b233ab7dad"},{"claim_cluster_id":"a0fb284d-9ce5-4422-a3d9-508052dde7fe","event_cluster_id":"c011b0e5-baf1-40ca-ae4e-97e2c4bd7b62"},{"claim_cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","event_cluster_id":"bd148f49-6e19-46a6-bfe3-a19a292ab17a"},{"claim_cluster_id":"6d600ff4-5ee2-443b-9049-7fb530fb454c","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"},{"claim_cluster_id":"b31e61b9-2010-4063-88bd-0eced0599429","event_cluster_id":"c7723f2e-2c6c-486e-98b5-302326a9be1e"},{"claim_cluster_id":"388dcf56-c13f-4ec5-bbc7-b3c71eaffd35","event_cluster_id":"16c38934-13c5-4d45-a617-8e2638f6597e"},{"claim_cluster_id":"0a0436c8-54af-4b5e-9725-fc8ed172d1cc","event_cluster_id":"ae0aa30d-b0b4-4bf5-a41e-7d8900417e46"},{"claim_cluster_id":"04c040d8-393f-4b27-af55-1f60d7802605","event_cluster_id":"b74d0080-2884-4f0b-b58d-88fbcf9d76d7"},{"claim_cluster_id":"09183ea2-b51f-4c35-a3c2-3fbf476237cb","event_cluster_id":"0a2a726f-5f3f-4312-a1f1-087729dc4991"},{"claim_cluster_id":"469a2781-0070-451c-bc21-b7ee2b0da3f0","event_cluster_id":"db160e2d-890a-4e75-a5da-9daa0f1dd2e9"},{"claim_cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","event_cluster_id":"aec45825-35ee-46b7-b2b8-bea6a7f40f69"},{"claim_cluster_id":"0cd50f6d-7e09-46ef-815c-37b05bef94d0","event_cluster_id":"9040babf-0be0-48e4-a916-be2a06953769"},{"claim_cluster_id":"08c235e3-44d9-4f4b-9af7-a9491ce983db","event_cluster_id":"92bbe30f-197d-426e-978f-44717acaacac"},{"claim_cluster_id":"90a4e218-d5e9-4e12-b842-f6c8e272cb28","event_cluster_id":"b217e8fc-9e97-45a5-8767-f4c21e8e0b4d"},{"claim_cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","event_cluster_id":"76b14a04-38e5-4c33-90b7-69079246c4ac"},{"claim_cluster_id":"f96435db-3d9a-45de-8398-45bc9dbd4fc0","event_cluster_id":"9be937d1-1aab-40a0-9206-7301e1897a68"},{"claim_cluster_id":"d65bf625-e91c-49ac-a498-dc2e95df1f93","event_cluster_id":"8e640a02-ac6c-4b9c-8244-be0e4a058359"},{"claim_cluster_id":"1c220b25-802f-4053-89c5-d8f4805341a5","event_cluster_id":"0b7b0dfe-c42a-4dfa-8860-0ff61e6cc75e"},{"claim_cluster_id":"6d226b20-d54f-48d2-bd7d-2616184afc68","event_cluster_id":"9e3e1492-3c76-4be0-979b-239d4deb8c80"},{"claim_cluster_id":"679ed917-ad46-4856-a427-b83dcc51a53c","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","event_cluster_id":"d9484da0-ca3b-450a-a45c-787783bba3e7"},{"claim_cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","event_cluster_id":"75d8830c-702b-4013-8c9b-62375f536959"},{"claim_cluster_id":"0d1ccd4f-6f42-4604-a9be-95ea8fe5adc0","event_cluster_id":"d0e8c17f-ac7a-4857-90ac-8a31224cb44f"},{"claim_cluster_id":"37ca2b04-06dc-444f-b96a-20f9e5902a07","event_cluster_id":"4a1b2728-75a5-43bc-8278-ab49e8c8c004"},{"claim_cluster_id":"c1587edf-f13c-4a02-9534-a3653325bfee","event_cluster_id":"00bd60e5-bf2a-4d15-8ed4-8906838875f9"},{"claim_cluster_id":"bba799e9-6e80-4ce6-b96c-fc89b2b8200c","event_cluster_id":"ac7642b8-b25c-45db-8998-1d3c7f1c25e7"},{"claim_cluster_id":"253fbf69-01a5-4352-a109-1aea0fdf1fe3","event_cluster_id":"2bd231ca-b95f-4da8-b52c-5b92d58eef4f"},{"claim_cluster_id":"0726cfa9-d89b-45b4-922f-553fde14346a","event_cluster_id":"160b6b7e-ff36-46d8-bcf4-e711c773e83e"},{"claim_cluster_id":"0a79d737-f594-464b-b3d2-afd57c6349f1","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"ed1b332b-c054-4114-82a1-1e645946747e","event_cluster_id":"3b95c6b0-416b-4f6d-9aaf-3287913c0c2f"},{"claim_cluster_id":"02e0cfd6-814a-4276-b8cf-66540b7686e7","event_cluster_id":"0a5b6270-0640-4f06-bb62-1bb490df9669"},{"claim_cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","event_cluster_id":"d4bec07a-ec66-4aae-9ce2-624f9525e0ee"},{"claim_cluster_id":"4a575d85-5f97-4baa-be78-2c26ecefb471","event_cluster_id":"b754c76a-3e29-4a89-b2c2-054b3adbaf0c"},{"claim_cluster_id":"dff8a985-ffc1-4946-ab7d-43e8406aca00","event_cluster_id":"c2fa4be0-a63f-4b63-922e-7a118484c3c8"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"b2894bf3-d539-4a31-9d16-59a88bacee25"},{"claim_cluster_id":"baec81f4-73ba-4194-ab31-e3d64c8a57ab","event_cluster_id":"b88b8f26-8273-40e5-8f02-5f503edd6ce2"},{"claim_cluster_id":"1db866e4-0f7e-4d67-93e0-8d1068f0369d","event_cluster_id":"de8997cf-fd37-4d0e-b22a-dae890492f89"},{"claim_cluster_id":"6606b076-6fdd-4a94-a7c5-b6bfc5191980","event_cluster_id":"3804062b-b30a-4f19-918a-426ffa4b1df7"},{"claim_cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","event_cluster_id":"750243e1-18a5-4108-92d0-c8875b6d7be7"},{"claim_cluster_id":"73fff1e2-bc77-421c-8436-e9bf094a9733","event_cluster_id":"0e90187a-faaa-48f2-ae7a-c2764c47dffa"},{"claim_cluster_id":"93548381-56c4-4fb7-be49-43e644f447fb","event_cluster_id":"46cde8f4-4b4b-4cae-87a1-063914f15878"},{"claim_cluster_id":"bd0a892b-884e-4c98-8690-8f25949dbaed","event_cluster_id":"f8fb52b1-aa75-4179-86fc-79c103280f3b"},{"claim_cluster_id":"516d27f7-0cda-468f-b3b6-27af200d408b","event_cluster_id":"a2518533-4468-4125-948f-3516caac3b26"},{"claim_cluster_id":"73184e14-aff1-4c97-a2f0-0508b86fc3db","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"b7635b58-ad1e-4cb4-a317-8d48ce1cdddd","event_cluster_id":"a899a63e-c3d0-425f-8700-82abc0fa345a"},{"claim_cluster_id":"8e873c15-6407-475e-841a-2dcbbce28e18","event_cluster_id":"7992895f-6a68-45c7-a087-4ea61dcfa40e"},{"claim_cluster_id":"f4175686-5e4d-4fb0-a465-bed7586f6615","event_cluster_id":"bf638672-92b8-4f28-a31b-d9a286145b07"},{"claim_cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","event_cluster_id":"6363c274-1e0e-4e09-85b0-1412131b0c25"},{"claim_cluster_id":"0626769d-4a42-43f4-8356-e89543f6dcc3","event_cluster_id":"4d6e8834-c57b-472a-adbf-630fe4d997d3"},{"claim_cluster_id":"0c0cca84-dd68-41a0-8489-cb2d22400e3a","event_cluster_id":"944be8a6-d37e-42a3-beed-11a9a6d47203"},{"claim_cluster_id":"72a6b38a-23a2-43db-a788-32ae774a5c77","event_cluster_id":"042df2bc-4559-4f30-9abb-b285376932e3"},{"claim_cluster_id":"c70207c5-86bf-4f7f-b715-56b9c8674c3b","event_cluster_id":"c7824331-8340-4b01-8402-1e8e570e3b30"},{"claim_cluster_id":"a6506a53-789c-4447-b726-b2dd59d9b862","event_cluster_id":"181f2787-76c0-40c9-96f6-869aa09e8172"},{"claim_cluster_id":"ae1d4689-4f04-4acd-a0d9-2c0934c3acd4","event_cluster_id":"89669f9f-ac80-4abe-98e3-503ca9625f39"},{"claim_cluster_id":"4a942b66-0607-413f-8ee5-b6f6ddbbd034","event_cluster_id":"2edd3f54-1c62-46b5-9ed0-1f1f90407326"},{"claim_cluster_id":"bba9ba69-2957-4432-9f56-bcb77e8342e2","event_cluster_id":"ffc5ae60-fd21-4d4d-9cbb-be7095643849"},{"claim_cluster_id":"43fb6e85-e148-46ac-99f5-6e9cc985487b","event_cluster_id":"f7f70f61-0229-475b-8a17-6b4740f661e4"},{"claim_cluster_id":"1713cb4d-ab0f-4257-a2cb-4aec01e411ef","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","event_cluster_id":"bd072c00-533b-4c4a-918b-097a11abe63b"},{"claim_cluster_id":"7b36cbc9-6f57-4b29-9c6b-010607eb3738","event_cluster_id":"0ab76786-184f-4825-8328-205b8055cb1c"},{"claim_cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","event_cluster_id":"4485e5d3-efcb-4d42-a185-349293bfd550"},{"claim_cluster_id":"f7fbb95e-08d7-410a-8e1f-290e984463d7","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"327aebea-facc-4b65-a419-a9d461f7aa0f","event_cluster_id":"23c09fb4-b263-485c-8e4e-4908da7910fa"},{"claim_cluster_id":"c3dda95e-e922-4b18-b7fd-9f071350fa6d","event_cluster_id":"70912902-8988-4e45-a0c6-4af51f1f19b7"},{"claim_cluster_id":"9c5c6743-3894-4e82-b69e-bc4e0c19f869","event_cluster_id":"a316c368-440e-4c3f-a293-cbd2c8138a8e"},{"claim_cluster_id":"d2f81fce-8c92-45e8-8294-41af7752f1db","event_cluster_id":"bbcaf773-6ffd-4bd3-98a9-fd76783316d4"},{"claim_cluster_id":"5767d0cf-3070-412a-9136-a29c287f15a1","event_cluster_id":"47cf0031-f643-4c3b-859a-e03a6b23d6e9"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"2c29846f-3295-4669-afc6-4c052b5c55d8"},{"claim_cluster_id":"d7eb8bf6-179c-440e-ad1d-a97e186809d1","event_cluster_id":"aee47b3f-809d-45eb-9cd7-269dd2b5fc95"},{"claim_cluster_id":"e9c91d2d-9c77-43dc-9ccc-c00049984a01","event_cluster_id":"bacf6a38-aa68-4722-a54e-dd8b9dbd45eb"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"603803f7-aada-4f64-95b6-3901092a2744"},{"claim_cluster_id":"b45686ea-2849-48a8-b658-78abebbff1dd","event_cluster_id":"4fd61797-afb1-460e-913b-0445bfe516c3"},{"claim_cluster_id":"35218630-91b1-47a4-87cf-29094bd87289","event_cluster_id":"99814cad-01e4-492e-93e2-a867761329f7"},{"claim_cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","event_cluster_id":"a04f0354-7f2d-4806-8bf1-4cf23f67439b"},{"claim_cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","event_cluster_id":"0e7363bf-ba1a-40d3-b39e-9efa5e6a18ad"},{"claim_cluster_id":"957872f4-ebb4-47bd-9d9e-487c3755644e","event_cluster_id":"7dec92f2-1d70-4104-bd41-d9c058b2c5ef"},{"claim_cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","event_cluster_id":"0480c8ed-40a7-40dc-ac24-9b8fa7551edc"},{"claim_cluster_id":"c85112cb-b1b4-4c61-8955-fca094b1a4c4","event_cluster_id":"74848948-285f-4571-adb0-ad9b59d381fc"},{"claim_cluster_id":"1ef62c3d-3750-43b9-855b-d4624938de1e","event_cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"cba27e02-b54c-4ae0-80f7-4a7112a6558e"},{"claim_cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","event_cluster_id":"636dbb94-cbc8-4c79-b785-6d406b28db48"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"ab428379-3dca-4ed1-9e68-45a0cb9d3fea"},{"claim_cluster_id":"5c0a00aa-4cb9-40d6-9bf0-6d53d966e2fa","event_cluster_id":"4fdaa1a3-7430-423b-81e3-be520cdd6936"},{"claim_cluster_id":"35ff7a5e-40b8-42ad-9379-7ba830c9445f","event_cluster_id":"63531f99-fdf7-4bec-966d-ab104759e21a"},{"claim_cluster_id":"dbcdf7e4-c865-4f31-a79f-0cd2eef3258f","event_cluster_id":"d748319a-ab54-4e2c-9098-21db36bad1c7"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"822c1997-a0a2-41cb-9793-22c777eab1a6"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"cf1d89e9-6fd3-4042-9407-6a77d0635415"},{"claim_cluster_id":"b7cbc93e-51f6-448c-9fc2-c1af44082069","event_cluster_id":"e4ca57af-fa5a-4a42-8e77-8ccc8efd6660"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"},{"claim_cluster_id":"800e7e36-7ce1-4e55-a18d-394d83673d71","event_cluster_id":"966cca08-6c6e-46f9-8145-7138653fe7a5"},{"claim_cluster_id":"5528714b-b0b8-40d9-850a-99905744c056","event_cluster_id":"2f6c2f5e-a3c6-4ec4-93b2-6127b5c87ee6"},{"claim_cluster_id":"cf33198d-096c-4e25-8d65-13fe91addce9","event_cluster_id":"73f48f2a-467d-4d70-aac9-42d923ea5f8c"},{"claim_cluster_id":"0961c365-4261-4c91-984b-81c62260d807","event_cluster_id":"ddb6cf7a-94d8-482f-b5e3-c86b7fa8181d"},{"claim_cluster_id":"d0228864-78be-4fd7-94b7-908de0276e80","event_cluster_id":"ea3abea8-dde8-497c-9c04-bcf3a9757f8f"},{"claim_cluster_id":"0de2a028-10da-49bb-8b43-e7f79a0ff6dd","event_cluster_id":"1f210f48-5853-4bb8-8fc2-d9a334fec30a"},{"claim_cluster_id":"18c77ab0-e8d1-492c-912a-03ad6154fa51","event_cluster_id":"4a20b107-b497-42c8-8807-874212cad7e3"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"49feb97e-934e-4b78-b2c2-4acd4705e46e"},{"claim_cluster_id":"77e72686-2baf-45ab-a679-b8f62cdcf982","event_cluster_id":"8cb3d3c4-596a-4d19-9190-9681300abd40"},{"claim_cluster_id":"3dc0cbd1-b381-4df2-846d-e07147e83cbe","event_cluster_id":"a0b134b6-d0a8-434f-86d9-01697dedcb90"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"5c68cba2-8519-4f6e-b70e-fbda62c5445c","event_cluster_id":"a850938a-0d12-48b8-a366-a53a16388dbb"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"90a4e218-d5e9-4e12-b842-f6c8e272cb28","event_cluster_id":"78c6a4d3-5529-4139-b6cb-7f76f21ff807"},{"claim_cluster_id":"cce124fe-f108-4571-9074-db48a458127d","event_cluster_id":"d02fe9fc-02c3-4085-ae05-7b4e0277028c"},{"claim_cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","event_cluster_id":"39ac0d20-baa7-48d3-8263-9b324a75c453"},{"claim_cluster_id":"b12e5d28-73fe-498d-a612-a3df5aa876b3","event_cluster_id":"dcf0cb56-59c5-419e-a7a3-57fc57640ce0"},{"claim_cluster_id":"616e962d-58a9-42e5-9a6d-decd8139ddf7","event_cluster_id":"920638c0-7694-4767-bc82-851ade0b1652"},{"claim_cluster_id":"2edb056a-640a-40d9-89e2-36dbc25022b5","event_cluster_id":"f6fe4656-91eb-4bf2-98b2-cfac47bcc12d"},{"claim_cluster_id":"63ad18c0-00c0-4509-b669-2aff507b5502","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"b7e33865-58b2-4984-a7e1-eed1512539bb","event_cluster_id":"d4bc60e5-da16-45c3-909d-aa14379adeb2"},{"claim_cluster_id":"d29a2d68-5d53-4ad3-9792-37db5375f45d","event_cluster_id":"b87380f4-8f89-424b-8739-272a52634814"},{"claim_cluster_id":"9bd5e01f-d2aa-4157-a2fd-143c30274710","event_cluster_id":"ed413a70-b4e1-4736-9370-9237ebadaa06"},{"claim_cluster_id":"4f68034e-7758-4136-94fe-82331ab7df47","event_cluster_id":"636f9424-425e-404f-b45f-941b15951311"},{"claim_cluster_id":"7386324d-4730-4b17-8d70-6b33d62d5be3","event_cluster_id":"59b16d26-5dcb-404b-8589-2b9a2089c70d"},{"claim_cluster_id":"8a0accb4-caf5-4741-9038-3360a1a08c25","event_cluster_id":"c2141743-76d8-4904-8bb0-fc81db4f2295"},{"claim_cluster_id":"8a1c4319-f1b2-4b2f-93eb-dd1d35c5dd9e","event_cluster_id":"9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"},{"claim_cluster_id":"6a4b35a4-0785-4292-8587-aee85db61288","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"96b36513-ec34-4deb-bc5b-c811958c3675","event_cluster_id":"761f3fb6-5695-42a3-ba7c-8aee7df904b2"},{"claim_cluster_id":"1927948e-52f7-43b0-aafe-d3f160820394","event_cluster_id":"5f7469b6-8252-4966-99ba-b5fdff4dbf90"},{"claim_cluster_id":"c5298737-21d9-47c4-b52e-e662ee88b15b","event_cluster_id":"8c274c4a-42e3-4136-9ecf-91adb76667f9"},{"claim_cluster_id":"db13aa73-f539-42d8-89d9-1af57cfff5a3","event_cluster_id":"0007cb01-3742-461b-b5c4-5aadc5a55eac"},{"claim_cluster_id":"635fb80e-2799-454a-8570-6fc3830d271b","event_cluster_id":"0de9cc59-0656-46df-93f6-a7ec86e0802b"},{"claim_cluster_id":"4f331c05-6fa5-4bd8-adc2-5458e8c80843","event_cluster_id":"bbb1bc4b-f3a4-434c-a53d-625f1645e395"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"410a0800-e775-4016-b3ff-cc215bfaf3d1"},{"claim_cluster_id":"4a817862-6fa5-4e7c-8998-977aaad70250","event_cluster_id":"ce77bb3a-ea7f-4d98-a5e3-62e70b0597ed"},{"claim_cluster_id":"924c4170-d405-438e-937c-13478012b72c","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"71f3d08b-aa01-4b41-b89d-7fb725538d72","event_cluster_id":"a6d23154-5d6d-475a-a318-8f3c90f26a02"},{"claim_cluster_id":"218a3fc7-ac76-4428-aa52-1f315a03667d","event_cluster_id":"f654e316-c125-44fc-9eae-66baddc079a2"},{"claim_cluster_id":"75d5bddd-c0b4-4755-8a27-ab90a5104373","event_cluster_id":"71435cc5-d65b-4e3e-9454-ffe0371a42f1"},{"claim_cluster_id":"6c51a8d1-6797-4e1d-8707-408a46a11bf5","event_cluster_id":"3625ee09-ea65-4286-ae5a-83daac4e66b6"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","event_cluster_id":"d85e9fe5-2b49-48db-b3ed-055f19c978de"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"b49a91d7-446b-421b-9670-7c99bbf5bc28","event_cluster_id":"5b7d9e7f-e24f-4115-ae9c-183a9ef8183c"},{"claim_cluster_id":"d14e115a-dd46-437f-8a57-5893395dde5f","event_cluster_id":"49a61bc5-5b56-4867-98aa-feebd5b63106"},{"claim_cluster_id":"4e71d535-1646-4ea5-9c47-04fb1464f390","event_cluster_id":"81eafdea-26c8-4b44-b5c7-5cd6a9bfece5"},{"claim_cluster_id":"21b4d7af-e8bf-408f-b63a-f91c28b7ba72","event_cluster_id":"d29993d5-ca77-4b15-919e-f95ec679fdca"},{"claim_cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","event_cluster_id":"b7f1648b-9e5b-476f-a59b-84d94f8583e3"},{"claim_cluster_id":"bee4d72b-b159-4b6c-830c-362b42a2b18d","event_cluster_id":"06d3a2ea-1d2f-4456-9c1f-ca559e4c2f36"},{"claim_cluster_id":"49c94f1b-b278-42a0-b8b7-d0f8ec55d536","event_cluster_id":"977581f8-a92f-4a60-b0ab-96b42b1d0d8d"},{"claim_cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","event_cluster_id":"152183a2-1d35-42be-bb3a-d49654ea4707"},{"claim_cluster_id":"86478e14-8f65-4b25-93ee-a6036b9de886","event_cluster_id":"7e7c3417-e29c-4641-b1be-5336c04805ff"},{"claim_cluster_id":"554fbe05-7cef-438d-8e82-567521788239","event_cluster_id":"335c4cdd-12ec-4cfe-80c0-1755c4975b84"},{"claim_cluster_id":"3e505b9a-116f-472b-bc43-8ee1a23943f5","event_cluster_id":"5ee5ee7a-bfa2-482d-bd3e-efb0d1c8544c"},{"claim_cluster_id":"894e29d9-1e82-4e00-b1eb-e5092d46e327","event_cluster_id":"c75d014e-008e-44c1-909b-263543a31c5f"},{"claim_cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","event_cluster_id":"41498260-bda6-49c5-9ad2-acb6340ff494"},{"claim_cluster_id":"7be2aab8-ebba-4a53-8dd8-2f99fbdc274c","event_cluster_id":"17bcb338-5ed9-498a-8f4b-407445dec65f"},{"claim_cluster_id":"a32303e6-4765-4335-9847-b5ee18494799","event_cluster_id":"d3a45ffa-7001-4495-9c5e-b65ea28becba"},{"claim_cluster_id":"d10a4ec7-a74e-4016-996b-f1f3a3c6527f","event_cluster_id":"93a61a8e-4477-45a4-b63b-bc7992dad11c"},{"claim_cluster_id":"729d6508-b5df-44ab-8ffd-349b7a126b16","event_cluster_id":"f795636b-a096-4302-aa9e-87494f4166de"},{"claim_cluster_id":"e8bed2a1-875c-4017-abd5-83f756e2ceb2","event_cluster_id":"adfb27db-3208-49e3-8050-366e93400ac6"},{"claim_cluster_id":"bbe61a29-09c0-4f9e-98e6-1cf33324aca4","event_cluster_id":"d301327b-e031-45ac-903a-5645a313fba7"},{"claim_cluster_id":"ff42e3e5-bb75-45af-be07-89d36dae0d5c","event_cluster_id":"53ad86f3-97ef-4717-9f61-4666c34f7833"},{"claim_cluster_id":"6d7d1320-a896-4471-aa98-60a45946bc57","event_cluster_id":"a23c75f5-2cc2-4ad3-bbfe-8878efe773ea"},{"claim_cluster_id":"00cfa90d-eff5-4498-89d6-85dadca46eb8","event_cluster_id":"bd4e1aad-4b42-4afe-bdd1-8b68fcb5aa16"},{"claim_cluster_id":"8b72504b-7ef9-4a36-b0a5-32d0b76c4553","event_cluster_id":"0affa6f2-96b0-46b9-acf1-01957217922b"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"7681cbe0-1efe-4edf-b906-ebf02351325e"},{"claim_cluster_id":"2432e361-2cb6-4e28-a81d-a8ee7dce9c29","event_cluster_id":"516f819a-378f-4afb-ba61-51d5e2e77e27"},{"claim_cluster_id":"df0cd74b-d230-4260-9a29-b0bc91923404","event_cluster_id":"aed5d13a-0c24-4359-9236-cc780ebe021d"},{"claim_cluster_id":"e9c91d2d-9c77-43dc-9ccc-c00049984a01","event_cluster_id":"d15b1a4a-b0d0-463c-b7c1-b74ef1c0a63a"},{"claim_cluster_id":"c31ea39d-ce0d-46ee-be4c-e32d46721b78","event_cluster_id":"f6f6ac6a-d140-47fb-94ad-797d11509e6a"},{"claim_cluster_id":"1e12b1a7-9bc4-4a98-b698-8392df483432","event_cluster_id":"d58866d1-afac-43ae-b1bb-fbdbeb0b8d62"},{"claim_cluster_id":"0dc504d4-9f05-4936-a43a-c912683c5ac2","event_cluster_id":"b9d8d6cf-41c1-428e-84c8-7e7e2b40a710"},{"claim_cluster_id":"83605bab-42d6-405a-ab45-fb6b68e0609c","event_cluster_id":"f4e22611-4a8c-420d-98fb-79e2c70d616c"},{"claim_cluster_id":"e045b8f3-c755-4ad1-91b0-a0b8f7878680","event_cluster_id":"bbe46b45-db85-4cd0-8c3a-6d46ba80584e"},{"claim_cluster_id":"9f4059ba-333f-4054-ba5f-f1cebaed747e","event_cluster_id":"d3878960-69bc-4fec-92c4-b21753a35a06"},{"claim_cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","event_cluster_id":"099689d1-bfaf-4b3b-b795-0a924815ef02"},{"claim_cluster_id":"54fa045c-bc33-4348-a964-82cb98ec67f5","event_cluster_id":"9d971a6e-39d0-4da3-9f9b-e8603acb9bc3"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"fd537f2d-3616-4303-9edb-81c90d602f6d","event_cluster_id":"a06a1094-e3d5-4cdf-b982-d9ff6654fb83"},{"claim_cluster_id":"ac61e213-06f8-4e65-ac52-8d47ef547cc8","event_cluster_id":"69aee0d6-8420-442f-82ab-c95f31fcf4b8"},{"claim_cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","event_cluster_id":"4a1b2728-75a5-43bc-8278-ab49e8c8c004"},{"claim_cluster_id":"0998688e-32a8-4d44-8338-04f2bfaf29d8","event_cluster_id":"f6bf24ea-54ac-45f2-b1ba-27747efe5a47"},{"claim_cluster_id":"e521c1db-8ae4-48b6-83c6-efbd02701f4c","event_cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163"},{"claim_cluster_id":"bdc7e61b-1cd4-494f-b965-4387369e6df2","event_cluster_id":"859ebc03-00a8-4a19-9bda-cf26a29549d4"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"a568feba-940a-47c6-8cff-f4910bd91144"},{"claim_cluster_id":"3dc0cbd1-b381-4df2-846d-e07147e83cbe","event_cluster_id":"d1afbb7a-8d2b-4c24-9c70-b4c56fd56a43"},{"claim_cluster_id":"1cffe038-9a46-45f7-bcc3-f26914315286","event_cluster_id":"aed589a1-07ba-475f-b7f3-a645da58e97b"},{"claim_cluster_id":"b916d619-a85d-4cf6-9af8-c531be4fd3c4","event_cluster_id":"25b06341-ba13-410b-909e-c700b9b55663"},{"claim_cluster_id":"3f85eb0b-4d61-4e44-8414-15ce2c9f03ad","event_cluster_id":"21439ac6-d6cc-43c2-9360-f892b94daf83"},{"claim_cluster_id":"ac74ed42-e193-4a73-9fb7-633a1a28d674","event_cluster_id":"05a27be4-d98e-42f1-b3e3-bf60c499f807"},{"claim_cluster_id":"b5b35a39-f79a-45e8-82ea-b87d21bbba55","event_cluster_id":"5345ad5e-9fbb-47ab-a820-0caca6e3cbd3"},{"claim_cluster_id":"eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0","event_cluster_id":"1b5a113e-43ba-4a33-a76b-09db6a2b33ef"},{"claim_cluster_id":"0727da75-801a-4ea8-bc54-bca9f4c0cbfc","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"42fd849e-0fa9-43a8-b5fa-5cc192351c79","event_cluster_id":"ed35c2c7-9d1d-46bc-b509-54389b90afc9"},{"claim_cluster_id":"1010a45f-c4e6-41d3-ad44-9a27b9dc7893","event_cluster_id":"60c5d0e9-eed6-41c1-b7fa-8d8163b698f7"},{"claim_cluster_id":"7c5ea4c2-758d-42bd-ad3e-5e55c736d3f9","event_cluster_id":"f4ad4efd-4ba9-41ef-9de7-a560663da99f"},{"claim_cluster_id":"d59582f7-7e86-41f9-a084-db1da2a740db","event_cluster_id":"4dfac31b-2847-4ea8-85ec-0e74ca3ab755"},{"claim_cluster_id":"e7f02350-e0f8-416a-a3fa-4d7dfaaa5615","event_cluster_id":"5a9b6351-c522-46ce-b100-d164df2f3ed9"},{"claim_cluster_id":"e9280ed1-20ec-4c75-8468-086e8c6749dc","event_cluster_id":"5a444351-b082-407c-bb72-a6329cc1e654"},{"claim_cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","event_cluster_id":"1541313e-804f-40cb-bfb7-78850471987c"},{"claim_cluster_id":"9747ef56-b31a-4050-8bc2-6df45c0ffbd7","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9","event_cluster_id":"7c1fc423-517b-4edd-ab51-ee1fbb6a01c1"},{"claim_cluster_id":"dd24c0fd-c274-4b3f-aabc-3dbac6784aa9","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4","event_cluster_id":"63e3781f-5042-452b-a77e-11f62bb59587"},{"claim_cluster_id":"d2dff4dc-99e9-4957-9a57-be828ae1a5cf","event_cluster_id":"bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de"},{"claim_cluster_id":"6d600ff4-5ee2-443b-9049-7fb530fb454c","event_cluster_id":"d3ddf15f-7261-4b4f-bdd9-6823755811e6"},{"claim_cluster_id":"9bab62f9-a196-4e9b-9809-8d8f41f0576f","event_cluster_id":"567b1fae-2c0d-4bd2-91bd-d03218bbd8d0"},{"claim_cluster_id":"1c849e20-6024-47fa-80b4-e611385ba612","event_cluster_id":"0463ae92-c5a2-4eed-bc9a-bba00f27b6ff"},{"claim_cluster_id":"5a787097-c657-4d02-a7e7-ce5ddfe404d6","event_cluster_id":"bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"6d563374-a7de-4d4e-bf0b-d89a34f47ac7"},{"claim_cluster_id":"4801b48a-d91c-4dc3-9797-76929432b0ef","event_cluster_id":"a5d642f3-ce31-48e1-93c2-529f31b5ca8c"},{"claim_cluster_id":"ff3f6026-485f-4fce-9d57-b8206b8e11c5","event_cluster_id":"6987d44b-afbc-426b-97f6-9a507fedf197"},{"claim_cluster_id":"dc9039b4-da9a-4fd0-b97d-d822536a716c","event_cluster_id":"db5c7092-c228-4319-b130-e75471c29ec0"},{"claim_cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"380726cc-73a4-4dde-ac40-f10c2a1f6e60","event_cluster_id":"50755387-4b1a-4d72-9887-7b05aa4bf186"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"f690f627-f1e3-428b-9d01-bfb966953069","event_cluster_id":"615888f6-5d35-4a8c-acd9-9e71127a4cb4"},{"claim_cluster_id":"7c045c5d-d9cb-4901-a4fe-8f8a68090a83","event_cluster_id":"4035a796-2dee-4cd0-986f-eb64d79cd560"},{"claim_cluster_id":"06a88819-5b14-47a3-9604-8a61db70f52b","event_cluster_id":"9f40653a-5e27-4d90-9510-e0680c0dbf1e"},{"claim_cluster_id":"89d1d1b7-a65c-42c4-be89-c592ae13b6a1","event_cluster_id":"120d5e71-28b6-4974-a584-3c9108ae5780"},{"claim_cluster_id":"4f2be876-d890-4fd4-a767-3f52bbc9c4c4","event_cluster_id":"ca521545-0a79-4ba0-851e-a60589334127"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"9c03f16d-4308-41ce-a6c3-c0b6eaf8e340","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"},{"claim_cluster_id":"45803076-0698-48ef-a2b4-10f190885998","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"8038fcc7-29f8-406c-90cf-ee3b351c6e15","event_cluster_id":"7b48e171-a32e-4aa5-90bf-b37f44678964"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"b379da86-fb9c-4026-92d2-37b07df028cc"},{"claim_cluster_id":"d2dff4dc-99e9-4957-9a57-be828ae1a5cf","event_cluster_id":"f92a441b-bffa-4b5d-a3f4-495ad67f7ccf"},{"claim_cluster_id":"29c6f9fc-e1e6-4dfe-a45c-59ee8d9a4489","event_cluster_id":"648cf481-ce4a-42cd-869d-b9a572ac3d7d"},{"claim_cluster_id":"8ba29c52-b42b-44a3-86e2-12fd13d42596","event_cluster_id":"994a89fa-3e4a-45ec-b0ad-a34f5031641f"},{"claim_cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","event_cluster_id":"9e537f59-fc8d-477f-937c-489e24e51014"},{"claim_cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","event_cluster_id":"ad717816-6a33-4b68-8dcc-4da6a24f22b4"},{"claim_cluster_id":"8c18859c-7432-4cc4-af8f-8a5eb220876e","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"48cca002-8003-45bd-92b2-3e2945a33b48","event_cluster_id":"82f5beda-b460-413d-ba52-232c56bac459"},{"claim_cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","event_cluster_id":"7eb16fe5-1729-42a0-bcb4-1a4783656ce6"},{"claim_cluster_id":"ef63ab3c-4c57-460f-989f-0ac957105580","event_cluster_id":"c80180fd-f416-4eda-9cf5-5aa622256189"},{"claim_cluster_id":"1c30353a-a7dc-48dd-bca2-56c91aa06ab6","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"216f7d8c-4948-4e84-9b61-7c4fc880e123","event_cluster_id":"5bb2e685-4a07-4889-91ac-49a28d63a36e"},{"claim_cluster_id":"8567d4c9-fb06-4505-b09d-13b1efafa073","event_cluster_id":"9a5c4688-2dc5-46fa-b79f-3f0f0da1d72a"},{"claim_cluster_id":"717225a3-f2cc-4921-bece-db76c2709d99","event_cluster_id":"02428d36-d8ed-40af-ab42-212bc3922840"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"71de3f5e-7d6d-4a6a-b383-b96d1ee24b30","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"fd107d16-4df5-452b-96c2-989c72732db7","event_cluster_id":"72793708-1a46-47bf-a99d-c034462d8ebe"},{"claim_cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","event_cluster_id":"a22b19c4-dd9d-4007-a380-a5d0659b9821"},{"claim_cluster_id":"77de864b-c2fe-4a23-a506-d0665b0f08bf","event_cluster_id":"9a5830fb-a855-4c85-8daf-ed1be558a290"},{"claim_cluster_id":"c5d18c78-4df0-44fa-9f69-67266b1079e2","event_cluster_id":"53ad86f3-97ef-4717-9f61-4666c34f7833"},{"claim_cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","event_cluster_id":"f78012d1-f500-46ba-802c-d3d1337f7f51"},{"claim_cluster_id":"fd537f2d-3616-4303-9edb-81c90d602f6d","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"d89e632e-b2af-4331-9344-c7d1e373d49b","event_cluster_id":"2dba71a0-6409-4877-bd44-bf97b9328d5f"},{"claim_cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","event_cluster_id":"e7f6877c-917d-4e0c-ad46-e366c0fa0b67"},{"claim_cluster_id":"a1593cbe-8c39-423f-abae-2707e84a1e5e","event_cluster_id":"55da7c68-ac05-4727-a906-82d875d3d88f"},{"claim_cluster_id":"dc464eb9-fc48-4646-8985-9de6d7531d3d","event_cluster_id":"af8cdf46-4050-4634-a0b0-6bc6cfa78956"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"25733340-8065-4c67-9da5-97f671877eea"},{"claim_cluster_id":"0de2a028-10da-49bb-8b43-e7f79a0ff6dd","event_cluster_id":"7c268167-b621-480c-ba79-7005ed13e2de"},{"claim_cluster_id":"89d1d1b7-a65c-42c4-be89-c592ae13b6a1","event_cluster_id":"c2075982-499b-4dcd-9327-be17e07c166f"},{"claim_cluster_id":"1db866e4-0f7e-4d67-93e0-8d1068f0369d","event_cluster_id":"320a9519-2826-4d38-88e0-353ff9437484"},{"claim_cluster_id":"44fbf7cb-79bd-4592-b8a7-2bf2362dc392","event_cluster_id":"1dd73410-26d1-4ffe-8c70-64b5d5bf9994"},{"claim_cluster_id":"fe684e64-4226-4567-8e1f-5613fae2c8f8","event_cluster_id":"46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"},{"claim_cluster_id":"f401d633-0e2b-4935-b7d9-1761c201c058","event_cluster_id":"ca922fb6-3b82-47fc-a5a7-c1ff0c4bff12"},{"claim_cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","event_cluster_id":"02e73dfc-86f2-4fe6-a79c-d071e07721fd"},{"claim_cluster_id":"ef74ebaa-c6e0-4356-bf8a-2ce2acf6ad70","event_cluster_id":"464e7bbb-1cb4-45e2-a510-f3dbf3edebfc"},{"claim_cluster_id":"db91531a-0712-431d-a04b-9b798db3d3b4","event_cluster_id":"21518841-2c46-4292-abad-aff342a4f1ac"},{"claim_cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","event_cluster_id":"55a8e92e-7501-4ea5-a3ee-b628a536a6f9"},{"claim_cluster_id":"24accb31-401b-42c1-bd69-e81c04cb2530","event_cluster_id":"183ebbd4-8012-4c45-ae37-eee1b7b28721"},{"claim_cluster_id":"29009c7f-3a77-46aa-91c0-d0f703c52dab","event_cluster_id":"5fc308a4-b2ac-472f-a711-f5e9a8852593"},{"claim_cluster_id":"2cfb50e6-37ad-47a2-87b2-da1a9a512e46","event_cluster_id":"19d8a06a-0c0d-4355-9204-b73d0ebe4d12"},{"claim_cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","event_cluster_id":"92103df4-5a66-4430-95e6-d2ba83f705a1"},{"claim_cluster_id":"dad2ba1b-78a6-4e69-91a7-e473e3d79e42","event_cluster_id":"cacf5ae8-cf4c-4e9d-86a7-1b95a7ab58e2"},{"claim_cluster_id":"13a07f14-45d6-4b31-8d23-23b540ac8090","event_cluster_id":"3596032e-4fde-4840-89ec-0f1fed8a80cc"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"4259fe50-2c67-4157-ba4a-43d33835df49","event_cluster_id":"1543a0aa-5824-449c-b496-3562005d2d52"},{"claim_cluster_id":"5f266248-0a3e-4fc2-afec-4bfc7ba1a633","event_cluster_id":"3b9a3219-78e5-4ff5-948f-415edd9701ed"},{"claim_cluster_id":"d26e1561-d7b5-4c15-bc29-d5ba417f64ca","event_cluster_id":"7640b35f-031b-4917-bf34-5555111a4a74"},{"claim_cluster_id":"87b92fb4-b0e3-4b01-9c2e-cfd9469245f7","event_cluster_id":"0afcbb16-75a7-45dc-9f96-97e351b50a83"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"a1ecb202-6deb-48e9-b7cd-80beb55064e2"},{"claim_cluster_id":"ba4d4a13-eb59-48ce-b75b-0c214fe98953","event_cluster_id":"aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"},{"claim_cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","event_cluster_id":"ee08d940-570d-46a5-a30d-731f0f242ab4"},{"claim_cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","event_cluster_id":"2b91a87f-d164-4dfd-97cb-da5b879525ca"},{"claim_cluster_id":"8f0344d2-3a73-4534-aa04-5391b7670e72","event_cluster_id":"3838bfb8-767c-4ce7-8ddf-06338a137af4"},{"claim_cluster_id":"696180e6-d43f-476a-afce-5f13dbb9929a","event_cluster_id":"ce469142-832a-40af-bb9b-acb726cab86d"},{"claim_cluster_id":"cfad4c19-24e9-4d54-8d59-d0b08718729b","event_cluster_id":"fdf8116a-82e6-4a25-a819-a71aa4bc112a"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"2697eb78-b9b3-4edf-8af3-5b14bcd8c383"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"},{"claim_cluster_id":"91ae7c53-2f75-41de-be44-6ce7a4b47412","event_cluster_id":"cfb71f70-69b3-4e36-b2b7-df43f0d519a2"},{"claim_cluster_id":"ccc50930-0ce2-4cb5-aa76-281b7202368b","event_cluster_id":"d40b11df-00d1-4f65-b6c2-6f209bb850d8"},{"claim_cluster_id":"a0698f9c-4bc8-48b3-b669-44befd54559c","event_cluster_id":"58babb7d-bd41-4196-8e7a-e844e8cfa638"},{"claim_cluster_id":"d6145953-8619-428f-9b84-07cd47d4180d","event_cluster_id":"76d7e29b-d686-4238-a931-2118cfe1bf3e"},{"claim_cluster_id":"612e1b04-721a-48bd-b18f-300c7c5af276","event_cluster_id":"69f46f33-8514-4ea2-ba72-362d6d1d202c"},{"claim_cluster_id":"ef78627f-ce46-445c-8434-674b16f6966e","event_cluster_id":"0c9df761-94e1-484a-ad16-41bb0a7c5fb3"},{"claim_cluster_id":"a2f5a4b1-ccba-4cac-9bde-f079d3027db4","event_cluster_id":"6b567caa-773b-451a-88a5-247b75e87a6c"},{"claim_cluster_id":"291e098d-0f3d-4fff-9906-3b21ed1a33a1","event_cluster_id":"ef96efc5-2acd-42e3-8b8d-c3fb75af951a"},{"claim_cluster_id":"51f9e6ae-7c8a-46e3-8fa3-070377ae9030","event_cluster_id":"531ef405-3766-417f-ac2c-f496b00a6ff0"},{"claim_cluster_id":"0f106199-65cd-478b-af43-69825b16fa47","event_cluster_id":"49c36ab4-aedf-4b49-9372-e43ee616873e"},{"claim_cluster_id":"82cf1bd1-8182-4744-8fc2-6d5af2292aea","event_cluster_id":"f315f787-a973-49cc-9719-20a3bfead1b0"},{"claim_cluster_id":"b43b3e32-d544-43ad-b781-20a883c7f4b7","event_cluster_id":"3f4370f6-6231-416d-9478-d27156c80526"},{"claim_cluster_id":"40460222-6c35-47b7-be68-29a1138ce819","event_cluster_id":"2148fe37-01cd-4114-a714-3d111387b22d"},{"claim_cluster_id":"cfa086e7-654e-40fa-9e14-980617b91e89","event_cluster_id":"adce1d4b-0242-41c2-b4ec-d798e0c0dbf8"},{"claim_cluster_id":"b932581a-a432-45a9-94c6-236d0339e45d","event_cluster_id":"2116fedb-8d8c-44ee-b7a0-a2ee29d3edd5"},{"claim_cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","event_cluster_id":"209dbc84-05ee-49b9-b69d-c36d87df72b0"},{"claim_cluster_id":"43de0036-79a8-44f6-b066-25424acf3535","event_cluster_id":"602ccd3f-b2b7-474a-9029-74260beb7902"},{"claim_cluster_id":"19ddcd3b-18db-461a-b208-f198db3e1e07","event_cluster_id":"51cb3861-5c43-4303-b352-2771c991143d"},{"claim_cluster_id":"2010e740-a26e-4489-a685-8115e3933580","event_cluster_id":"cfa0cfe9-0423-44d2-9909-74aa5f5c8e41"},{"claim_cluster_id":"cf33198d-096c-4e25-8d65-13fe91addce9","event_cluster_id":"668e643e-dedd-4afb-8aee-89228ecd7266"},{"claim_cluster_id":"12f1ab8f-20c6-41db-928a-d52afb8bd227","event_cluster_id":"5f2eb0b1-e72b-4484-b09f-d3bfdfdaf028"},{"claim_cluster_id":"b654c64c-3acf-45f6-a6ea-c4584b8c70fe","event_cluster_id":"55bb591f-ecec-4f30-84a4-1528326dbb84"},{"claim_cluster_id":"98459a3d-d71e-40dc-bfe8-895082c9d11c","event_cluster_id":"7cd53b0d-1bfd-45ff-a900-1bdfd6e403a3"},{"claim_cluster_id":"234be4d1-d0d0-4b65-aa97-a8cd91a0a32e","event_cluster_id":"4fe16db2-c3a7-4835-89e2-e57d5e214582"},{"claim_cluster_id":"71f3d08b-aa01-4b41-b89d-7fb725538d72","event_cluster_id":"8017a44f-3587-48ad-93bb-373a715846dc"},{"claim_cluster_id":"756853a7-6f00-41a1-87fe-40396a3fd247","event_cluster_id":"0be2a099-9ff6-4c81-a576-b1f6726557d6"},{"claim_cluster_id":"b11a9565-86ce-4b37-aea3-07e84e21fa4a","event_cluster_id":"4ffbb682-25e8-4ae0-936d-0f256e7b5aaa"},{"claim_cluster_id":"ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db","event_cluster_id":"52ede4ef-4c19-445c-ad39-2f9ff6488929"},{"claim_cluster_id":"94ea82f9-8fc1-4541-8fab-b8354c3ea8f2","event_cluster_id":"3276e11e-189d-4a3f-af8c-0dd0ee752612"},{"claim_cluster_id":"d5e58122-8595-4ce1-b4a3-aa9160204856","event_cluster_id":"c8a1c00c-d162-4708-afc0-8961e0642155"},{"claim_cluster_id":"94a84124-c591-4219-8ef7-52760d608300","event_cluster_id":"ae563379-6971-495d-9872-da508cf0a3c7"},{"claim_cluster_id":"c3383556-4a09-4d9a-b202-b1b017162bd3","event_cluster_id":"a7246654-2dda-48ab-8372-7007a1d4709a"},{"claim_cluster_id":"ff920ca0-1e39-41be-ac8f-cd0534048634","event_cluster_id":"d3c1593a-2221-4777-89bd-fb14c68a1659"},{"claim_cluster_id":"0f047203-3949-4e82-86d9-77d6fe7af9c8","event_cluster_id":"2a47fd74-5995-437d-b0b5-6396ca3119f9"},{"claim_cluster_id":"7eff6a8d-9ae3-41f9-9ad2-cfcb191e7380","event_cluster_id":"b25f7b20-354c-43f5-90f3-fd9a86b1ae72"},{"claim_cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","event_cluster_id":"2f12da3e-336e-40d2-ba41-61b838ad70f2"},{"claim_cluster_id":"b874b38b-169d-4b90-b373-ae919f14c5a0","event_cluster_id":"2c8a535e-7913-4f01-8d69-eb8f7265032f"},{"claim_cluster_id":"928cf7ca-8343-47ca-be27-378bc29b7fbe","event_cluster_id":"5e55d80c-dfc7-448b-bcef-ae880cfffcd6"},{"claim_cluster_id":"7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607","event_cluster_id":"088ae3ae-ad79-4cbe-9205-0c7fb4deef45"},{"claim_cluster_id":"54bf8eb2-6975-454f-a48b-59abffdfe4f4","event_cluster_id":"d4bc60e5-da16-45c3-909d-aa14379adeb2"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"},{"claim_cluster_id":"c0a45d49-4b4d-4871-845a-e13c06e06fa2","event_cluster_id":"e0d33feb-9779-4cf1-a571-59040d3ea8f1"},{"claim_cluster_id":"e0b76993-43d7-4b38-b891-9ad858a2c5f6","event_cluster_id":"5b9f78e0-35e8-4e52-9ba4-34ecb628f952"},{"claim_cluster_id":"9f34aa0e-2eb3-43e3-b4dd-54a36752af72","event_cluster_id":"1479c6ff-179b-497f-9932-93213bb53a6a"},{"claim_cluster_id":"c03b0c98-53e3-4757-8e78-30293d823fdb","event_cluster_id":"635b07ed-e811-4ba9-90cf-8c1aed9aaaa3"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"64ba9893-281a-4427-95d7-8ab7818e5d93"},{"claim_cluster_id":"fc264446-1206-43b0-b6e2-29d7fc43d99c","event_cluster_id":"52f03b57-8fb1-4ff1-8eda-c0d228097a8f"},{"claim_cluster_id":"5d8665ac-7337-470b-ae27-2d46610e9f97","event_cluster_id":"e18afe50-8e61-4915-8745-6256e6a782cb"},{"claim_cluster_id":"7bf4f678-55d5-4f6a-922f-0b5de572f033","event_cluster_id":"12b80aca-12ee-4bab-a55e-bbfec7c756c7"},{"claim_cluster_id":"ef78627f-ce46-445c-8434-674b16f6966e","event_cluster_id":"2c8bf59a-7972-4ab1-a4ae-680a19fde855"},{"claim_cluster_id":"29880646-f50e-47bd-8b04-23f2c8716fdf","event_cluster_id":"0da6573a-b2db-4671-b4e0-6012c6bd63d6"},{"claim_cluster_id":"97e28e03-c0a3-40ba-8418-88973425525a","event_cluster_id":"eed368dc-e9d0-472f-90ca-6ea4839317c3"},{"claim_cluster_id":"ce4379b5-864c-4150-b826-c6825e39d887","event_cluster_id":"4be56027-8172-47cc-b793-5f37e487c1b0"},{"claim_cluster_id":"970a5cc7-9a05-4850-b0f1-f59128c441c8","event_cluster_id":"8b843277-fda8-4ecf-9981-5b5f31ef86a7"},{"claim_cluster_id":"d017f7be-45ae-4ae5-b72e-a6e53f0a589b","event_cluster_id":"6b5cfe37-19cb-4d16-b4f9-67d51f90495a"},{"claim_cluster_id":"a751c83d-9da2-48e9-83a8-bc6d8a1c455f","event_cluster_id":"8ec5c238-a613-4762-a252-bba4045dc17b"},{"claim_cluster_id":"74e38083-39b2-4b0b-8874-879983366a75","event_cluster_id":"47db3c81-ee29-421a-b1e7-9a9b4cbbe8ce"},{"claim_cluster_id":"a5514e09-1046-4832-bdea-694c3e6ab12a","event_cluster_id":"65229c4d-fc92-48aa-bd10-466bee027dfd"},{"claim_cluster_id":"4f0130b7-d8c3-44c1-892f-fe74aef4cecc","event_cluster_id":"cbce7506-b8ff-4232-9cb2-70afae134899"},{"claim_cluster_id":"0c068743-c246-4fb1-8a38-ed41dc7e9fa3","event_cluster_id":"9a525fe9-9fb6-41e1-85e3-967787b02690"},{"claim_cluster_id":"5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6","event_cluster_id":"d03251b2-2516-4731-9dc4-6cb10da8a70a"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"500957af-7f87-40ca-b575-44450d181bfa","event_cluster_id":"14fc8edb-0dea-4ae6-b573-ec0c5512391b"},{"claim_cluster_id":"9b7211c2-d426-4818-9305-d12ff5c6e2a5","event_cluster_id":"59b16d26-5dcb-404b-8589-2b9a2089c70d"},{"claim_cluster_id":"e7606791-adc1-47d9-b4e0-1e86a03f87ad","event_cluster_id":"67c7f204-fd07-4c45-80b1-5b0bd873efd4"},{"claim_cluster_id":"58bf9f4a-adda-4853-802b-78d04aa711fa","event_cluster_id":"b3c5d56a-6d97-4291-aa82-9075fd6b93ba"},{"claim_cluster_id":"891e1da4-bfc6-4524-a5da-153bde60b165","event_cluster_id":"722d06bc-1512-434a-8214-a8daff8fb8a9"},{"claim_cluster_id":"0257adbd-adf5-4aee-a9de-3500c50d31a2","event_cluster_id":"1b6f0e82-4a2e-409a-a651-9a7baa243dc6"},{"claim_cluster_id":"42314335-3518-45c0-909b-96111c0955f6","event_cluster_id":"1d430602-1893-4300-910c-58f51643ea58"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"89418c34-2fb2-418b-8359-739bf85f5c05"},{"claim_cluster_id":"c8cf7c39-4d6a-4fec-8451-b46f12ccd07f","event_cluster_id":"b97fc666-43dd-4240-9de8-5f0f42a98b08"},{"claim_cluster_id":"c8416335-0a4e-4b5d-aa9e-40e533302d3c","event_cluster_id":"c0f8ea6d-76da-48d4-a14a-869a34f021c4"},{"claim_cluster_id":"c6e50b1a-e795-43fc-baca-c835ba2bf14d","event_cluster_id":"1137dcb0-70d8-4dce-ad5f-8ffbbf5dde18"},{"claim_cluster_id":"fb1e3132-0050-4db5-a637-391574f70b71","event_cluster_id":"f5a61f8b-83ab-44ed-b769-3208e32281e7"},{"claim_cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","event_cluster_id":"3e491056-e070-48f7-a358-499c803ca16f"},{"claim_cluster_id":"a52869e4-c88e-49c1-a8d6-0ba25d6c7cfc","event_cluster_id":"6e7eeae9-331c-4977-a841-a2cc08dd5381"},{"claim_cluster_id":"51086a98-c771-4b7c-8eaa-b6fbb8629a30","event_cluster_id":"576d86b7-1d28-4f66-8319-eb34a892467d"},{"claim_cluster_id":"f006e419-46e2-4ca6-a34c-afa36d7458b2","event_cluster_id":"073edba6-a930-4e69-b786-5decd28e9957"},{"claim_cluster_id":"39f5f705-55d1-4470-8928-bfce04d4f7be","event_cluster_id":"7b1f2cfc-5328-4132-ac99-4d91818f60f6"},{"claim_cluster_id":"e06a0883-b86c-4452-9949-2a46787f07ab","event_cluster_id":"8f445d44-1e7e-4d7a-9a5f-c141941a7046"},{"claim_cluster_id":"2762cfd3-48ae-4a0c-baf0-bfb36bcdff70","event_cluster_id":"1997b709-7204-4376-b1e8-77d6b8518a0f"},{"claim_cluster_id":"2e77d3ff-d6d1-48d6-a7da-42c3cf25c4e6","event_cluster_id":"aea06698-0475-487a-a76e-80bcbad00033"},{"claim_cluster_id":"503584d7-75a5-4f03-adb1-4844dd4d9b9f","event_cluster_id":"498d40d5-5e43-40ad-a2cf-e0c8dead042f"},{"claim_cluster_id":"d6f2cb3f-8705-43f8-a523-1b8fab745bf8","event_cluster_id":"800e3797-9c0e-40b0-9390-53c562dabc15"},{"claim_cluster_id":"783f85bb-dceb-450a-9a34-4a650e18ed9f","event_cluster_id":"b059c11d-95fa-4f8b-93e3-1c4f21e60f61"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"b5cfe764-3a89-4e77-9f9e-c720d7d22394"},{"claim_cluster_id":"22c3b77e-fa98-44e1-b509-f721cef0815f","event_cluster_id":"40e574c7-e1d8-4cc8-a46a-a5e8d1efd793"},{"claim_cluster_id":"800e7e36-7ce1-4e55-a18d-394d83673d71","event_cluster_id":"e6aabf8d-023e-4060-ae58-13d0d54f160c"},{"claim_cluster_id":"cbbb2109-39b9-4308-a4ce-30a48563cab7","event_cluster_id":"c4596456-6844-4eff-9082-8a0cfee4acfd"},{"claim_cluster_id":"69483fde-1234-4c7a-8580-5490aec071f7","event_cluster_id":"bae5df31-d0a5-4216-b755-4add987f460d"},{"claim_cluster_id":"08c235e3-44d9-4f4b-9af7-a9491ce983db","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","event_cluster_id":"52f03b57-8fb1-4ff1-8eda-c0d228097a8f"},{"claim_cluster_id":"a5408918-67c4-45bd-afb3-95d8aced1dc9","event_cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec"},{"claim_cluster_id":"17eaa25c-625f-4414-b1ad-78d904209f81","event_cluster_id":"4dc44ea9-8d2b-4f60-a0c5-d10d5af77cfb"},{"claim_cluster_id":"f0d99bfd-e20a-4b87-9be0-a227af6f681d","event_cluster_id":"371a45ea-84b1-459c-8153-e0d2017b4ce1"},{"claim_cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","event_cluster_id":"2e1de1f1-7494-4d78-994d-deb9c207c005"},{"claim_cluster_id":"3073b261-2ceb-46c8-bad6-3808fb657e33","event_cluster_id":"1d4622f2-0a7b-4423-ad78-a011864bf902"},{"claim_cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","event_cluster_id":"5cf38b83-9e7d-4021-9751-cdd7c1a0b38d"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"65545a07-9406-46c5-9357-571d95749394","event_cluster_id":"a1f52faa-345a-4142-abf0-5bc06a645050"},{"claim_cluster_id":"c9b6b0e3-811d-4e56-9eba-3408eb1dc06f","event_cluster_id":"cfc42d88-49ac-4610-a5c7-0cce12304171"},{"claim_cluster_id":"24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"69fa7886-741a-440f-8a20-2b9ce60729ac","event_cluster_id":"28b9ee99-8c41-4de6-b5e4-1d006511f119"},{"claim_cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","event_cluster_id":"2e504c36-cc23-49bf-9bfa-77adbeb06137"},{"claim_cluster_id":"1cbddfd6-c491-40b1-b10c-fd4387edddf6","event_cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d"},{"claim_cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","event_cluster_id":"381be24e-814e-460f-aaf7-24ebc78ab4d4"},{"claim_cluster_id":"696180e6-d43f-476a-afce-5f13dbb9929a","event_cluster_id":"f3cb116f-ca76-4bba-949e-3c48f31bacfe"},{"claim_cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","event_cluster_id":"5674d01b-2996-4ed7-850d-de449d707ce5"},{"claim_cluster_id":"6222d4f0-7c6d-42f0-83ec-17412b1907f1","event_cluster_id":"21936564-78e3-425d-afce-2c71d0db68fa"},{"claim_cluster_id":"144fa955-73da-4f76-8472-31c3ddd2636d","event_cluster_id":"336f2ec9-9cdf-4236-a126-80e564dfeb50"},{"claim_cluster_id":"c98491ce-51cb-40b0-93ae-d389e1c9d7a5","event_cluster_id":"02bc5fb8-e0fa-4719-bd7d-c08bd3e70f93"},{"claim_cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","event_cluster_id":"97ffbb55-ab53-43e7-aa63-34930f97c42a"},{"claim_cluster_id":"1c5f9ea9-d432-4800-9abd-5af5c927568b","event_cluster_id":"88ed9b73-fcba-44e5-9474-9587e7fb5ebb"},{"claim_cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","event_cluster_id":"139b8293-aa0f-409e-8a4f-0e3ee1191f72"},{"claim_cluster_id":"54a8d4bb-c88c-46df-a439-6be0dfcdce0d","event_cluster_id":"5549ed3d-7dea-4eb0-ad38-1dd76c667c0c"},{"claim_cluster_id":"a6d51f65-13a0-42d8-b6fe-66f9daf5bd01","event_cluster_id":"145084b8-39a8-4c53-8295-e697e796d433"},{"claim_cluster_id":"4a817862-6fa5-4e7c-8998-977aaad70250","event_cluster_id":"25337f06-7f63-4f2c-9964-5f855922e638"},{"claim_cluster_id":"f4e0a38c-1349-4970-a962-5d6d7478cce6","event_cluster_id":"ad846634-778f-48a1-8b99-37387f981b3f"},{"claim_cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","event_cluster_id":"ea03e48a-fe82-4735-a7d5-db2e5351b982"},{"claim_cluster_id":"6e8d0f46-aead-4efe-a267-3f325cfe8dec","event_cluster_id":"9809fa62-b9bf-47df-ad2e-8fa4d84399c4"},{"claim_cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","event_cluster_id":"58d84750-75e5-4a06-9053-f1a5a8baf564"},{"claim_cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","event_cluster_id":"f7069e5f-ee25-470b-986d-c157ab1e1613"},{"claim_cluster_id":"843e2174-20bd-4386-beb4-ad4f8d0ba790","event_cluster_id":"59d2954b-c33a-4e1c-87bb-ce014430514e"},{"claim_cluster_id":"2fe163fe-8ed3-4202-aad1-5f84672917c4","event_cluster_id":"cc709bf0-3f13-4e4e-b2f5-adbdf5752221"},{"claim_cluster_id":"323efa20-d8ad-424c-9c0e-ac5d255b9276","event_cluster_id":"84d3d5e2-5fb1-4388-9576-0de3210a0439"},{"claim_cluster_id":"de08eb08-92b3-4974-9e99-e79755582996","event_cluster_id":"7ed6cceb-29b9-4150-b16f-00796c0ac573"},{"claim_cluster_id":"c5298737-21d9-47c4-b52e-e662ee88b15b","event_cluster_id":"9bdbcd6f-9804-4d17-b1b0-8bb5670939d2"},{"claim_cluster_id":"2c8b719a-2363-4f9f-9be2-6d1801374195","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"a07d35a7-6217-400e-856f-516669ebb436"},{"claim_cluster_id":"170448e1-fefc-424b-b5a4-23941f88389e","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8","event_cluster_id":"34a8290a-940e-4582-8dbf-cb195db85e28"},{"claim_cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","event_cluster_id":"918d1070-a60a-4619-b33f-d29c47c7f6cb"},{"claim_cluster_id":"9a6fa43d-c803-4c20-bac3-545db67a8241","event_cluster_id":"2826c59b-a252-4d3e-9bdc-eb92dc90ee16"},{"claim_cluster_id":"1c220b25-802f-4053-89c5-d8f4805341a5","event_cluster_id":"58794c22-3f6d-401d-8ef2-ec12fd369ff0"},{"claim_cluster_id":"1190ac87-5191-4e29-877a-253af15bb185","event_cluster_id":"967932b9-89a1-4f1a-8846-57c7efec1e1b"},{"claim_cluster_id":"639596e6-4b0c-464a-9fa5-8272920e87b4","event_cluster_id":"e4f0ca80-4588-4554-9e20-d646dd11d817"},{"claim_cluster_id":"818db8b7-0e38-4d06-8f87-4de475ce7556","event_cluster_id":"6e9ec51a-5e5f-4dab-8bcb-01b5c15fb587"},{"claim_cluster_id":"818db8b7-0e38-4d06-8f87-4de475ce7556","event_cluster_id":"ce551d12-b33f-4043-8ad2-015e698a2cda"},{"claim_cluster_id":"0c265597-6c2b-4efe-9acb-799f67a3b4d1","event_cluster_id":"a0925808-7df0-46ec-bb06-9cb553f8b8fd"},{"claim_cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","event_cluster_id":"615888f6-5d35-4a8c-acd9-9e71127a4cb4"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"ee97e835-1007-4cd5-b270-714f0880c07e"},{"claim_cluster_id":"1c849e20-6024-47fa-80b4-e611385ba612","event_cluster_id":"7f5ce29d-718d-42a9-af2b-7bbc25320894"},{"claim_cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","event_cluster_id":"5949d818-e369-4db8-949d-7a462c260498"},{"claim_cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"2dc250b5-58d8-4c44-80d2-2c17640ea117","event_cluster_id":"c55f11e7-306a-41b0-af0e-b025ab77a3ea"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"4f92bf5d-f880-4cc6-a2da-cbba50d74014"},{"claim_cluster_id":"fd305e86-cd2a-4329-a45e-739147206ba8","event_cluster_id":"eff3ff70-7d42-45d0-a372-4aa15bf9f280"},{"claim_cluster_id":"c3cd1557-129f-4369-b850-25bdf5456c16","event_cluster_id":"4a7e58b2-ad14-4711-92da-e24d91c0e2a2"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"d231b87f-915c-4032-9dcd-5f1c1337576b"},{"claim_cluster_id":"77de864b-c2fe-4a23-a506-d0665b0f08bf","event_cluster_id":"73b5bb5e-19ff-4738-bc4e-5908ad8a0474"},{"claim_cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","event_cluster_id":"a18f54d8-98f1-491a-9d47-c6333890fc51"},{"claim_cluster_id":"bc56200e-afec-40d7-a87d-167e90733913","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"d521ac4e-4810-4638-bb77-9fbf7ba74f52","event_cluster_id":"d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871"},{"claim_cluster_id":"ea6a2243-de2d-4dba-b6c1-70fc6e903bfb","event_cluster_id":"51ee5c3c-1ec7-4729-8ed7-80ffe951b756"},{"claim_cluster_id":"38eef897-6e59-4836-bf0e-1e7e106baf53","event_cluster_id":"e47a5c41-ef67-4e8c-bde7-553670fb6a9f"},{"claim_cluster_id":"0f3a2cc5-8301-476a-b658-747594635542","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"c75ee75a-e51c-413b-b72e-c2160bcb40c1","event_cluster_id":"a4ea2030-230b-4e96-b485-ae147aec2613"},{"claim_cluster_id":"14ffc7a5-e5c3-48de-a2b4-8b721ff34fcc","event_cluster_id":"a64b48c8-6765-4ea4-add1-20cd675e1418"},{"claim_cluster_id":"571676ab-8830-47d5-a21a-ef55f09caa73","event_cluster_id":"a06923fa-5b7d-4810-97a1-737122cf8581"},{"claim_cluster_id":"55f659a1-e5dc-41c5-8a43-9846f564af08","event_cluster_id":"970fa237-7a1d-4b64-a4c6-7a158c05542d"},{"claim_cluster_id":"7686685c-6e82-408b-a7b9-2e453038450e","event_cluster_id":"20024815-8b0e-4e7c-9c28-eb57a4f0783f"},{"claim_cluster_id":"06da14b8-536e-4d2e-83b1-118cfb44829b","event_cluster_id":"2f59f9a6-6a8f-409f-8959-e71823889fb2"},{"claim_cluster_id":"235bfc4a-e3f2-4850-83c2-a78043ab464b","event_cluster_id":"d00c4814-110a-4898-a26e-19970d2ed410"},{"claim_cluster_id":"ea43c4dd-2096-4292-b914-5c467c6f33db","event_cluster_id":"867a2b63-9e44-4ba6-82e8-55c04ceb4f4f"},{"claim_cluster_id":"0626769d-4a42-43f4-8356-e89543f6dcc3","event_cluster_id":"e924815f-2da7-4209-b239-ad1c99e71b41"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"0c50e809-0f1b-4656-a0dd-110732b6e47b","event_cluster_id":"c9b1ea29-5b23-4579-928f-8f3b1f3679f1"},{"claim_cluster_id":"0de2a028-10da-49bb-8b43-e7f79a0ff6dd","event_cluster_id":"ecb10f6a-8831-4846-bf71-113659233f12"},{"claim_cluster_id":"c0fbbbbf-776a-47c5-9e8d-f798f722abf7","event_cluster_id":"ab7feba4-a1e3-49aa-a70a-5a191501e657"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"f83b448c-d81d-4175-b604-2783d1df502d","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"f8618eda-effd-4eda-b2ad-66d8fec0ba02","event_cluster_id":"031a0aad-21cd-4ca2-8a60-5a981bd9de8c"},{"claim_cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","event_cluster_id":"aa27d9a6-1fd7-4a19-84c5-5bd88d623d31"},{"claim_cluster_id":"8f273fa4-f8bd-4413-8ce1-7183b77e2566","event_cluster_id":"6a85e8dd-d86f-4e00-b252-62364be2e0ab"},{"claim_cluster_id":"aa95c9e4-8d02-4bc6-90e1-de547f4e4e60","event_cluster_id":"70bd9665-a0ef-44fe-b03d-553c56604080"},{"claim_cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","event_cluster_id":"24b2ce3b-aee0-470f-b1ec-7fc4ce0d6235"},{"claim_cluster_id":"11aef681-a744-409f-8cc3-69822e3a86b2","event_cluster_id":"39b04d3b-887f-479b-999b-c671dfd12bd6"},{"claim_cluster_id":"411175f7-0ca0-4fb5-9db2-35822ef1cc0a","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","event_cluster_id":"f1fff97c-e8ee-45ff-b0df-2544c89e909e"},{"claim_cluster_id":"a5408918-67c4-45bd-afb3-95d8aced1dc9","event_cluster_id":"bd9f40ee-8b97-4557-aa2d-1a87da031fda"},{"claim_cluster_id":"bbefdcbd-8560-44a4-b45a-d11652dfe311","event_cluster_id":"432216ce-2589-40bc-b4f7-cabc8c9d84b7"},{"claim_cluster_id":"7576470b-cafe-4c17-9541-256e9ec07097","event_cluster_id":"ef30a0f0-6c8f-4544-8a16-49df03cd9879"},{"claim_cluster_id":"de4f148f-cf69-426b-b5bb-f722fb88313c","event_cluster_id":"0c4c6169-f685-4aa8-b6de-d396766a5c80"},{"claim_cluster_id":"02fc2c1c-e5e4-40d6-92bc-a975544e0e30","event_cluster_id":"03a9ef94-2f49-4a92-bace-dca90bc3fda0"},{"claim_cluster_id":"9920b872-a377-485c-97d1-65b98d038806","event_cluster_id":"b252b9c3-5126-48a5-aa3d-32d7e4a0465f"},{"claim_cluster_id":"325111bb-e15c-4f08-a4a4-3f81e99d9f35","event_cluster_id":"a89bcef2-6caa-4f8e-9e33-b36ab68a4d84"},{"claim_cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","event_cluster_id":"f1a2cf3f-1311-40c2-b18c-4f973df71568"},{"claim_cluster_id":"e52244b2-1143-48cf-9735-ce26094681d1","event_cluster_id":"5cdd32a6-f13e-42bd-94a1-e86008aa2d86"},{"claim_cluster_id":"d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3","event_cluster_id":"3a95c736-dd02-4122-9108-f00df86397af"},{"claim_cluster_id":"0cdd2771-1f79-419e-940c-c74f863377bb","event_cluster_id":"4b620911-0006-4874-ad8a-a8595a7140e4"},{"claim_cluster_id":"c31ea39d-ce0d-46ee-be4c-e32d46721b78","event_cluster_id":"33028b3d-3070-4c94-af90-91fb62e4dd68"},{"claim_cluster_id":"f7fbb95e-08d7-410a-8e1f-290e984463d7","event_cluster_id":"5071d605-12eb-4c65-9753-bdff2ac75ffe"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"f6d51725-748d-4605-90f1-5a35204e66b9"},{"claim_cluster_id":"43966195-88ed-478f-bd22-9c59b6eda45a","event_cluster_id":"e1ec3ffd-db25-4cb3-96fb-b11f7546206a"},{"claim_cluster_id":"f731bc0b-cabf-4314-a5f8-e94d31589cea","event_cluster_id":"eb6475eb-91f7-4af2-a9fa-7784d03f74bc"},{"claim_cluster_id":"903d2f0d-f14e-42ff-a685-a20e841d8f7b","event_cluster_id":"ad4af428-e855-4639-a39a-60d90249fe21"},{"claim_cluster_id":"fd96ef0f-c2a3-47f0-b0ee-4580d498d313","event_cluster_id":"51de12f3-d554-4161-b0ec-4b2186f0cb26"},{"claim_cluster_id":"c8956774-b873-4e48-aca4-1d4ce1428a6f","event_cluster_id":"3038e36b-6f90-4a8b-a5ed-b89bec5c7144"},{"claim_cluster_id":"58bf9f4a-adda-4853-802b-78d04aa711fa","event_cluster_id":"1f760b40-15ae-43cb-8956-bedcbe236708"},{"claim_cluster_id":"3401a78f-3a68-442d-942b-4cef401613a8","event_cluster_id":"71435cc5-d65b-4e3e-9454-ffe0371a42f1"},{"claim_cluster_id":"3769f810-e5f7-4d0a-9821-1876b6cadf34","event_cluster_id":"d118efd6-5acc-43c8-a0da-c30ae94fc13d"},{"claim_cluster_id":"11e43ecc-22c8-4f1c-b13a-fb97013ce963","event_cluster_id":"fbf4f33e-0e24-406c-8b43-497c4ae8f7fe"},{"claim_cluster_id":"59905a93-0117-4d6a-a153-cacf3c9feeb8","event_cluster_id":"3e954c39-38a1-4449-bb6c-9e8070f71e04"},{"claim_cluster_id":"ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db","event_cluster_id":"2dc916ab-843e-4007-bf03-57e437a7dc48"},{"claim_cluster_id":"e2c6a7c7-ff69-4a0f-a631-41e7e5bd25a0","event_cluster_id":"a2d75661-0f1a-4093-bbb2-d5f9c836dda0"},{"claim_cluster_id":"ab52850c-7dc5-4f99-b37e-0c628b078043","event_cluster_id":"507a2a11-43b9-4279-b484-7be9d201408d"},{"claim_cluster_id":"2c1958a0-e83a-4912-9902-e6456b756f14","event_cluster_id":"f65902ca-8669-4b7e-9388-0fbc20879e59"},{"claim_cluster_id":"a5114ace-99b6-4b39-875b-8b7056c70002","event_cluster_id":"ab19e784-fddd-46e2-a989-cdf804b997c6"},{"claim_cluster_id":"c054d850-518a-42ab-a850-01492f7fb7ce","event_cluster_id":"8ce1b035-20cf-4e3a-b84e-8642795846fd"},{"claim_cluster_id":"1ae95d89-cea7-4f27-8ed8-d4f49e95c5db","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"1977f04e-4cc8-4af7-ae78-39ce7804eadf","event_cluster_id":"e6342a31-63c5-4e60-b405-bead23c2ee06"},{"claim_cluster_id":"ae1e52fc-461a-4609-8b02-2589611c162e","event_cluster_id":"11103fe7-e53a-478f-ac79-6e43af250e15"},{"claim_cluster_id":"39caeecf-930f-43df-a6d4-e237146a33a8","event_cluster_id":"20c1ad4a-8c5e-407a-b67d-ed4158ca87ec"},{"claim_cluster_id":"536df2e4-b955-48b2-8a3c-5b06a58c9d87","event_cluster_id":"23aed1db-c001-4e2a-9a10-0e9f672d2101"},{"claim_cluster_id":"cd21b07f-3941-439e-8ffa-59c6da9df98f","event_cluster_id":"9ed0391b-e831-497d-9d87-ba9ea12680b7"},{"claim_cluster_id":"120d61e9-d442-4218-b8d0-9559d9880c3a","event_cluster_id":"92332b03-095b-4c9b-a429-b33ea258a0f9"},{"claim_cluster_id":"ba6f293a-cb12-4697-ba51-b7964934f25d","event_cluster_id":"47933a91-e43e-4731-9328-ce609581c5cc"},{"claim_cluster_id":"a80ecbee-c55e-46fb-a302-1137d87bdcfa","event_cluster_id":"bf9a8cce-4cc9-4b37-881c-ca94d761d671"},{"claim_cluster_id":"f0d99bfd-e20a-4b87-9be0-a227af6f681d","event_cluster_id":"80650d11-8f1c-4d32-a46d-12e884243f7e"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"525348f0-16a2-442b-8f83-be5618731e1e"},{"claim_cluster_id":"2c834413-ef2b-486b-81d5-2e0a687a8ca7","event_cluster_id":"0e9e7c31-725a-4645-86a1-d5bba7071b1e"},{"claim_cluster_id":"be7f1195-f177-4bc7-91dc-0cfb479ebb8e","event_cluster_id":"cc6728f4-4d83-4a2b-9077-fcd32909b298"},{"claim_cluster_id":"99b20734-bb32-4aff-b60b-a976139937c2","event_cluster_id":"988ceba9-18e9-4ef8-9eaf-742eb7f2a4f1"},{"claim_cluster_id":"7b4db769-a456-496c-a3b6-6f242fdb7665","event_cluster_id":"e0f9e573-f9e0-44e0-aff6-2dee5ec70199"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"8181e898-2713-41af-b776-395891458be2"},{"claim_cluster_id":"0aded89b-0a86-47dd-8291-b59848abe762","event_cluster_id":"ce23ab49-6ed2-4eb9-b4ae-b0b0514251c2"},{"claim_cluster_id":"c3c67b90-f64b-4b19-8a14-0325205ef32e","event_cluster_id":"32f448b3-33d8-4d45-9792-ba9ba2feec34"},{"claim_cluster_id":"42b60cc5-5a50-48f5-a8c0-713eeb591918","event_cluster_id":"7f4c9ab9-c44d-442b-a98c-55507ea1e6cb"},{"claim_cluster_id":"0e4acd7e-6e9e-4ec6-953b-f0301546aee1","event_cluster_id":"65ac3d2f-1144-42ab-9435-1522b78a54a3"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"bed08ef5-4cb1-4f05-b2d4-a996242acd93","event_cluster_id":"812a3386-bb25-454d-924b-c4a0c4d57dfa"},{"claim_cluster_id":"1713cb4d-ab0f-4257-a2cb-4aec01e411ef","event_cluster_id":"bdea90e6-def6-4640-876b-5fa83c1b85d0"},{"claim_cluster_id":"883c65b8-c8f1-4a3b-8bd5-fb9d61a95876","event_cluster_id":"59b16d26-5dcb-404b-8589-2b9a2089c70d"},{"claim_cluster_id":"0dad0e38-e0db-46d5-a25f-8e95be6a721f","event_cluster_id":"d7410313-2ce6-46bc-b39a-d7543341b90b"},{"claim_cluster_id":"c58f6371-bd47-4b22-b946-60358a570901","event_cluster_id":"2e14b451-260d-492b-b69f-85a48e166493"},{"claim_cluster_id":"ec49cf91-92d9-493d-940c-303b8e78e136","event_cluster_id":"116f2145-073f-478d-a5b4-2d21196c953a"},{"claim_cluster_id":"73fff1e2-bc77-421c-8436-e9bf094a9733","event_cluster_id":"c92bd461-8266-4e4d-aba8-e4cf7e3c1fed"},{"claim_cluster_id":"a1593cbe-8c39-423f-abae-2707e84a1e5e","event_cluster_id":"6cc59f40-7aa9-413e-ae5b-64e2c17a2e71"},{"claim_cluster_id":"626c75be-9b85-4ac5-97e0-e03b79d0191e","event_cluster_id":"d147629e-d16f-4224-83bb-da1109733168"},{"claim_cluster_id":"7b2b0362-dab0-48fd-8877-b1ece626a827","event_cluster_id":"91e8fe58-f0fa-44e3-ae52-de74821a1034"},{"claim_cluster_id":"9960f165-6141-4ca0-8dc4-0a136bfde83d","event_cluster_id":"f9ebd297-091c-4753-9543-c123ed3c1fc3"},{"claim_cluster_id":"5c7c452c-db3f-4741-97ef-77d49e8c75b4","event_cluster_id":"844b0e6c-6c02-4726-b2d2-097a5c40629c"},{"claim_cluster_id":"a32303e6-4765-4335-9847-b5ee18494799","event_cluster_id":"25ed23a4-7940-477a-9165-7053b4f9330d"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"f236d68f-fe39-4432-9a36-341eb8900ee6","event_cluster_id":"6f88a50d-7c8b-451d-b706-e766cfe9a47a"},{"claim_cluster_id":"0298b49f-bf28-40f5-acd6-4e9587c690ae","event_cluster_id":"73ef4f09-b38f-4c98-bd02-c07cf7fc2073"},{"claim_cluster_id":"ea08b9f4-137e-40ca-ae54-2e396aa18fc5","event_cluster_id":"22e69426-c76f-4b85-bc81-16af4106a7bd"},{"claim_cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","event_cluster_id":"bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67"},{"claim_cluster_id":"f7c875b0-a0b4-45f6-b382-0915f179b2e6","event_cluster_id":"c749df3e-51ac-4d1a-87c6-d17e674f6446"},{"claim_cluster_id":"e12046ad-ffee-4bf5-90ec-51d127135711","event_cluster_id":"8017a44f-3587-48ad-93bb-373a715846dc"},{"claim_cluster_id":"ded98049-aef1-4b4f-a8a6-f68c10032b7f","event_cluster_id":"65ac3d2f-1144-42ab-9435-1522b78a54a3"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"c2f88444-099f-4cbf-b8aa-27e4b2666137"},{"claim_cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","event_cluster_id":"7150af87-53e1-42a1-8fa3-98b8c7ea1c84"},{"claim_cluster_id":"7885c5ae-734b-4d64-8d84-fc50b9a87ad7","event_cluster_id":"2a4109b0-0594-4c99-979e-19f8908c65ec"},{"claim_cluster_id":"24055b42-2fb3-4a05-8224-3c92490d6a5d","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"8346c5bc-af0f-44c1-b155-e89d63c46a37","event_cluster_id":"302853ec-6f10-46c6-b305-6047ac1af892"},{"claim_cluster_id":"1e35c814-682d-4b74-be8b-2867b370b971","event_cluster_id":"099689d1-bfaf-4b3b-b795-0a924815ef02"},{"claim_cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","event_cluster_id":"3e001ec5-72ab-4ef2-bec5-7b5552144517"},{"claim_cluster_id":"dfbc19e5-8117-4d40-9c25-774ed7aee906","event_cluster_id":"04a95cfc-f399-41ee-9730-e984f76e78be"},{"claim_cluster_id":"c90c00dc-2c77-42ad-bb5e-2666e53e2bcd","event_cluster_id":"43017a0f-25bd-45a1-b94f-31383b0d5c09"},{"claim_cluster_id":"de7b2349-3e46-436f-9b75-c57089eeaa3c","event_cluster_id":"ce1129a3-23ca-4a3e-bf11-bcbe6b5d487b"},{"claim_cluster_id":"127c457b-8cad-4a81-8d25-66dd51786fe0","event_cluster_id":"5d61b2e4-bbeb-403f-8746-07ecabf64059"},{"claim_cluster_id":"78bccd7b-b8a1-4e70-bdf2-26a8b9ac339a","event_cluster_id":"eb0ee0ba-913e-410b-b9c2-5aa8871f3d24"},{"claim_cluster_id":"698d5e91-6aba-4224-9583-f0b9f9330723","event_cluster_id":"bd2a5352-41e8-4479-ac51-89fb57ca65cd"},{"claim_cluster_id":"3073b261-2ceb-46c8-bad6-3808fb657e33","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","event_cluster_id":"b8430087-4ad5-4df6-bc7a-9f268ead6bd8"},{"claim_cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","event_cluster_id":"1bf0340c-7a77-4298-96fe-bdb20d7a37a7"},{"claim_cluster_id":"7b1c03fe-e3e1-476b-ab84-c44a6ea52022","event_cluster_id":"90d2821b-b505-4e57-a6e2-7f1724a94e93"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"28b8266b-a1c9-4314-9300-fcc436685496"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"ca62b0d7-872b-4a9c-b006-86ccfd239161"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"5fafb978-3006-4010-ae1d-242c5cb188f3"},{"claim_cluster_id":"4180dc5e-36b2-4900-9bf9-c6ecf67fdc08","event_cluster_id":"2caf488d-b467-4866-8066-64992d68542c"},{"claim_cluster_id":"4f331c05-6fa5-4bd8-adc2-5458e8c80843","event_cluster_id":"9db7cf05-3384-426e-a814-edb55b15d53c"},{"claim_cluster_id":"21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb","event_cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9"},{"claim_cluster_id":"eb2ba8af-f927-478b-bc26-2105bdb87c5f","event_cluster_id":"13df1ab3-c8ca-4935-bfac-bf950b3f0183"},{"claim_cluster_id":"b12e5d28-73fe-498d-a612-a3df5aa876b3","event_cluster_id":"03b556ab-fe42-4f7d-954a-c2484c0fac43"},{"claim_cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","event_cluster_id":"72ea99a1-516a-440d-9d00-28c65935de34"},{"claim_cluster_id":"e25eede3-3242-446d-a439-2c4becea51cf","event_cluster_id":"5d6331d6-8b39-45dc-b069-c03168d82aac"},{"claim_cluster_id":"fc64cbea-821d-4f81-89aa-1c161d723583","event_cluster_id":"00bb78a2-a394-4745-839f-91ae646e4371"},{"claim_cluster_id":"95ba204b-d839-49c0-9233-3f2add81da86","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"f02faf57-c72f-4377-8759-469d56737085","event_cluster_id":"7e7ac228-2e81-4fa8-abfb-35fbbdf2b4b2"},{"claim_cluster_id":"bc630aac-e921-4ad6-990d-40d804192d55","event_cluster_id":"ce112f29-472c-464b-84ff-3d5acaf22d38"},{"claim_cluster_id":"444e2d84-e3c4-4a82-a2fc-3577e6124f09","event_cluster_id":"edcd5353-7d93-4a6e-9bfb-a26ec2ae09a3"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"8d06f8b9-e6ed-4b99-89ef-90434792b924","event_cluster_id":"eb805fd1-c766-4517-8cad-81a53adf5b1e"},{"claim_cluster_id":"6a13b21b-08c5-4326-8613-c7913554f2c7","event_cluster_id":"ca4d9210-71b4-4ac8-bc7c-f9b4e1772523"},{"claim_cluster_id":"e000263a-3f42-454e-8e66-ba1e28066da4","event_cluster_id":"e0af4c3d-214d-424d-955e-14071d90129c"},{"claim_cluster_id":"7ccd886b-3755-4c15-8f38-f5ccef3c92ac","event_cluster_id":"4c7b4cd7-8288-43da-a54d-f22b707dc22e"},{"claim_cluster_id":"62be0386-404f-434a-884b-4dc379430917","event_cluster_id":"4a931ec3-ec4b-489a-8ad6-020f2eb48663"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","event_cluster_id":"297764bc-d5fd-4054-ab93-cb0530d2df4e"},{"claim_cluster_id":"f10ad797-ad79-4629-861d-4af809502a09","event_cluster_id":"c90c2a25-6af0-43d7-8ce5-c04e253daa5e"},{"claim_cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","event_cluster_id":"d9cfd982-76cb-4edd-8452-01187964f15b"},{"claim_cluster_id":"e44edb14-2754-4e0a-969f-2ab83f6f614c","event_cluster_id":"694ef2f3-c0e0-41ec-bcd2-314b770e13f3"},{"claim_cluster_id":"42fd849e-0fa9-43a8-b5fa-5cc192351c79","event_cluster_id":"917875db-927e-4ac1-93db-6f7a0fd24bc3"},{"claim_cluster_id":"ef78627f-ce46-445c-8434-674b16f6966e","event_cluster_id":"bf418d10-64bf-4718-bddd-53c651aaa9eb"},{"claim_cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","event_cluster_id":"f63e0793-99cd-4330-8985-abb2d981981a"},{"claim_cluster_id":"679ed917-ad46-4856-a427-b83dcc51a53c","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"62fbb5b2-0ba7-4211-b72a-eb1c18543408","event_cluster_id":"912fe4ed-bb41-46a5-adbb-0dc779234edb"},{"claim_cluster_id":"d4d4c9f9-96b0-478b-85a5-92a5fa51e55c","event_cluster_id":"6294c9ee-b6b1-48cf-8370-eae6d2c1d5fe"},{"claim_cluster_id":"565a8eff-d3c3-4887-a42a-b357e222a101","event_cluster_id":"eaeb1421-7550-4957-9610-ed74a0bffc8e"},{"claim_cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","event_cluster_id":"2929fcf7-736c-4b1c-b178-3fc95f1bce0c"},{"claim_cluster_id":"3b355bb3-b565-4742-b6f4-50c6f509a1ec","event_cluster_id":"25505b18-cd95-4150-9d26-ae16f59d9924"},{"claim_cluster_id":"e762d6c7-8067-4852-8232-49501526397d","event_cluster_id":"f50f4ad4-412c-4470-94b2-718ecc122ebe"},{"claim_cluster_id":"72a6b38a-23a2-43db-a788-32ae774a5c77","event_cluster_id":"335df50f-3c96-4c54-9d41-b51376489798"},{"claim_cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","event_cluster_id":"d86ceeb7-05d4-46ab-afb5-94228b85b310"},{"claim_cluster_id":"fc1c32c1-8212-46dc-b3e4-29a2254a34ba","event_cluster_id":"7201e91b-d78c-4827-b8ba-6360e45574c7"},{"claim_cluster_id":"84209a17-a4a4-4c15-a21f-0800fd75d6d8","event_cluster_id":"84b99e8f-a7ed-4a77-92d2-b7e912bf0ca1"},{"claim_cluster_id":"1cffe038-9a46-45f7-bcc3-f26914315286","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"0aded89b-0a86-47dd-8291-b59848abe762","event_cluster_id":"9f572501-f429-45f5-98fb-17c2e50fca11"},{"claim_cluster_id":"1c24dadf-70dd-4f00-84a1-ba00a5d442c5","event_cluster_id":"8945e273-b3ad-4ff1-a46f-200b7adcf6a6"},{"claim_cluster_id":"f636e358-668e-41dd-bffc-037f53b4ab48","event_cluster_id":"39ba0d7c-5f4e-43e3-b6a2-9f87693ee149"},{"claim_cluster_id":"dc9039b4-da9a-4fd0-b97d-d822536a716c","event_cluster_id":"38a250d4-c72a-4095-9b75-66d5fbc4da25"},{"claim_cluster_id":"483b6a3b-d48b-40f7-b28f-e79dfca268e6","event_cluster_id":"a3d3cf62-c1c3-483c-82f2-aeee46f578e5"},{"claim_cluster_id":"159421f9-fc35-4e25-a688-4ecf97e146b4","event_cluster_id":"f06698fe-6625-4ba7-9978-7a2aa54fc4c9"},{"claim_cluster_id":"61922f77-a020-4916-b901-44fe7982b789","event_cluster_id":"edc9ab41-cf63-48e3-8098-f84524398358"},{"claim_cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","event_cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7"},{"claim_cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","event_cluster_id":"9fa5ddc6-feca-4449-90da-8b78638fa3ce"},{"claim_cluster_id":"ac1a90d2-3517-43fd-8e60-dd7d570db743","event_cluster_id":"db72597d-c5a9-4920-978e-26eb63ca559c"},{"claim_cluster_id":"1473286e-ca60-4128-b82b-a6695a32595a","event_cluster_id":"3a6b381c-f068-44b8-863b-e7023960bcbf"},{"claim_cluster_id":"01680509-ab3c-4c56-a9a9-62fe3aeaacf8","event_cluster_id":"b23a3a32-e361-4bd2-bb69-d01d98ed6b13"},{"claim_cluster_id":"d0c2dc4d-9503-4d98-a218-6e6968c3ac55","event_cluster_id":"5d70f462-c3f9-4394-a045-eee646d218c8"},{"claim_cluster_id":"8346c5bc-af0f-44c1-b155-e89d63c46a37","event_cluster_id":"ed2bff61-1872-4dec-a024-4d1c3d21cddc"},{"claim_cluster_id":"a99b1332-e477-4168-b8e5-832daa0d6068","event_cluster_id":"86339977-5115-476b-96dd-1ca67842fea9"},{"claim_cluster_id":"aef50142-8ad0-4099-9362-3d45c56385fc","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"866c589b-e7dc-4cab-81ad-6d235278edf1","event_cluster_id":"53168731-5f89-48eb-b975-ab6908193c3f"},{"claim_cluster_id":"7ca9ea2e-bb11-4fa4-a1d3-e1dcb1d72607","event_cluster_id":"e0e1af6a-37f3-439c-b966-bdff95698e49"},{"claim_cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","event_cluster_id":"168ce58c-2c86-47ff-b749-0d60377b9053"},{"claim_cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"ab7a8719-e742-49dc-b23d-904f2b97e9e2","event_cluster_id":"a5f05825-1201-440d-8dd2-454ae9c16034"},{"claim_cluster_id":"376826e6-eaf6-4628-ab75-e400a091149e","event_cluster_id":"89a3e6a9-addb-4b72-822c-a5a7371734c9"},{"claim_cluster_id":"d072d7ca-3280-4412-8e76-be63e36fe491","event_cluster_id":"a68c5350-6903-408f-b32c-4015ed05945f"},{"claim_cluster_id":"bec9cb65-cf13-44b3-b77b-95d99bace1e4","event_cluster_id":"a74e2cea-b4c4-4a7d-a1c4-162f2fa0ad2e"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"cbb25dea-baf7-49d5-b9bc-41ab2551292b"},{"claim_cluster_id":"34db5d7a-86ad-4cf4-abae-67c617853bac","event_cluster_id":"2227c158-fdf5-47dd-921b-7c6ca1823ad0"},{"claim_cluster_id":"f18ec76a-50ba-422f-9d7a-596708b1810a","event_cluster_id":"c65c30a8-6203-4ff2-8126-866ddc1ad7ee"},{"claim_cluster_id":"c830c75d-93e2-4842-b468-b89a47252719","event_cluster_id":"814e8e7c-9951-4225-be99-2e978ab5ec4d"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"941c849f-959d-4e16-a04f-2de733d8f77c"},{"claim_cluster_id":"d47ee5b3-b3df-49e6-9a06-0dbb08c65765","event_cluster_id":"a867149e-e951-4e73-80ca-91c6893b617b"},{"claim_cluster_id":"147befcf-c605-4967-82de-77dc8f9513dd","event_cluster_id":"602ccd3f-b2b7-474a-9029-74260beb7902"},{"claim_cluster_id":"0e6f398e-1206-46db-a98b-ff1425e1c634","event_cluster_id":"682564dd-6904-485d-a9d9-e5a6a5b41de7"},{"claim_cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","event_cluster_id":"4b702552-6558-458e-b6a8-ec2e141d7258"},{"claim_cluster_id":"621b2187-e651-4a6f-becc-2a2a2cd444a2","event_cluster_id":"58be16fc-1f91-4a69-b73f-64ff2035e54c"},{"claim_cluster_id":"749b3ec0-39f9-4e3b-bcf2-7f9377d72178","event_cluster_id":"d8c7e702-0f0f-4bd0-b760-82584697ced7"},{"claim_cluster_id":"a21ce768-676a-4527-b1d1-ee80f9fdf2db","event_cluster_id":"1f210f48-5853-4bb8-8fc2-d9a334fec30a"},{"claim_cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","event_cluster_id":"9ff8b495-2fb3-4416-a1b0-68b8560f98e4"},{"claim_cluster_id":"404cf86d-d513-4c8d-adf3-7f2b9464b34e","event_cluster_id":"f5f9e060-9a81-433b-b601-5ea2fb08b956"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"a8e462eb-2839-4295-9ab7-03216f0e8610"},{"claim_cluster_id":"d7cbd37c-10fd-4628-bba8-b434c41ec43f","event_cluster_id":"db9b2b11-8206-4448-bceb-8073d0878c9a"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"f9662a45-5f67-4be4-be6c-47e92690c44c"},{"claim_cluster_id":"469c5194-5b04-4e90-b62c-73b3f79a0955","event_cluster_id":"28ec4a0f-45df-46a6-a92b-1e0740306f80"},{"claim_cluster_id":"88c2038a-24a0-497f-bac0-84ee519d160d","event_cluster_id":"87ba8d5e-85d4-4d3c-8d48-82520a97a137"},{"claim_cluster_id":"aa973fc5-c596-49d2-86f1-80f2a9f419e9","event_cluster_id":"4262a8eb-f5c3-4d49-bd20-1198efa845c5"},{"claim_cluster_id":"551e444f-6554-45dd-baba-6798fd43af6b","event_cluster_id":"53102493-0297-43e7-a8fe-5dbe6ce36215"},{"claim_cluster_id":"69290a80-8807-401f-b38b-0ff5ba27a43d","event_cluster_id":"ebb3d42c-9f56-4324-89bb-dcd764d2d3e5"},{"claim_cluster_id":"0ed53993-d675-4e0a-91d9-fca7f39d86fc","event_cluster_id":"1351fc52-175d-4410-b8b2-ff88c7747912"},{"claim_cluster_id":"cce124fe-f108-4571-9074-db48a458127d","event_cluster_id":"fb6903ba-fc01-4c20-9ef5-d3ed23d4b4f1"},{"claim_cluster_id":"0e6f398e-1206-46db-a98b-ff1425e1c634","event_cluster_id":"3ebb1b75-d2e9-4210-933a-9f6e5583b377"},{"claim_cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","event_cluster_id":"4cf2f8c5-1a2b-498f-87b4-2397e881640d"},{"claim_cluster_id":"91ccf699-eaec-41a7-8213-08934dbe2395","event_cluster_id":"fd129e43-f4b3-4fda-a189-8dcb11486ddb"},{"claim_cluster_id":"5ee6d6d6-e296-4f40-9760-4a7737f5c631","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"a08d6d8c-3534-4503-908a-ad9b08709410"},{"claim_cluster_id":"4a4d472c-cd13-4ccf-9f30-e866d14bdbf8","event_cluster_id":"8a1f2e01-5e97-4b63-a054-d879e5cc37f3"},{"claim_cluster_id":"dff8a985-ffc1-4946-ab7d-43e8406aca00","event_cluster_id":"7caf5c56-5f70-4536-ab5a-2d4f84227951"},{"claim_cluster_id":"d14e115a-dd46-437f-8a57-5893395dde5f","event_cluster_id":"1a910fe4-be3d-49ad-b59c-8197b841f3b0"},{"claim_cluster_id":"3232bd90-9251-47f0-ae93-ae2d51218354","event_cluster_id":"03dc9e1b-5b04-46ff-b424-59158328eb35"},{"claim_cluster_id":"75d5bddd-c0b4-4755-8a27-ab90a5104373","event_cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046"},{"claim_cluster_id":"c8c946c0-f2a9-4ddc-bd30-57a913603310","event_cluster_id":"f2b07e8d-84c5-4fbf-bf1e-736428e76d16"},{"claim_cluster_id":"6d2a1320-d829-403b-913c-d7cdbf1cbf14","event_cluster_id":"96d3560e-8a14-4ba4-9eb9-c3d21f7bd78c"},{"claim_cluster_id":"bdc7e61b-1cd4-494f-b965-4387369e6df2","event_cluster_id":"0ae555d0-f055-4458-a22e-cafea01bd69c"},{"claim_cluster_id":"55a85a41-dc09-4546-82c9-33ba7368eb9a","event_cluster_id":"c2d811fd-2174-46c6-9d2b-9483063022fb"},{"claim_cluster_id":"eb6a12b4-268e-4e39-8d84-ba73d40a7ffd","event_cluster_id":"51212bcd-93a4-4cdc-afe3-422f70697f65"},{"claim_cluster_id":"cb357706-7b58-4396-aa24-1c59beae87fa","event_cluster_id":"91bba9c4-4aa2-47af-b118-a7d49761b237"},{"claim_cluster_id":"1c703565-77f6-4eda-962e-77ec869d886d","event_cluster_id":"207aa08d-5028-49a1-8eaa-71f4b633ccfb"},{"claim_cluster_id":"98a5a190-c887-4ce2-b53f-011c39183ade","event_cluster_id":"e47ab492-3177-49bc-9493-e444a1518298"},{"claim_cluster_id":"144fa955-73da-4f76-8472-31c3ddd2636d","event_cluster_id":"528d38ac-7716-475a-b7f4-71caee3d9abf"},{"claim_cluster_id":"9d21be2e-9f01-48c9-b454-3a41788e2865","event_cluster_id":"9fb4d80f-a91c-46b0-856b-b4507d71a702"},{"claim_cluster_id":"043b0606-561e-4868-8354-4c45ee5a2f95","event_cluster_id":"fbf6086c-d11b-4ab9-9b6b-67f0d133c827"},{"claim_cluster_id":"a0977c56-cc0a-4fc9-a35d-0f1fe8c43b6d","event_cluster_id":"163b9274-a266-4214-8b63-6426a20ca29b"},{"claim_cluster_id":"d6c74194-ae1f-4099-a13b-0f247e76b288","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"db13aa73-f539-42d8-89d9-1af57cfff5a3","event_cluster_id":"a7b985be-e866-4775-b4be-7c7e64f9a12a"},{"claim_cluster_id":"53536317-4b6e-4e5f-bcd2-6b2bb3ef9bcb","event_cluster_id":"c2058db3-dc0f-479a-84f0-9c62df9819d4"},{"claim_cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","event_cluster_id":"44f0dccf-8fd1-49a7-88f2-e83b8d0cb422"},{"claim_cluster_id":"ac6c3346-ea92-4da2-afed-ba431832d85e","event_cluster_id":"265185dd-7e1c-462b-bd12-3ea2079d23c8"},{"claim_cluster_id":"64599826-faee-4fcf-9432-967663d05451","event_cluster_id":"01d21517-243e-4d94-b9c5-641f8bca7cbf"},{"claim_cluster_id":"eb38044c-3282-4492-916e-08a1ddd715ef","event_cluster_id":"54050443-7613-4bf2-affb-d73ac2c76683"},{"claim_cluster_id":"910b6c18-44e1-4b51-b616-1f6016486c69","event_cluster_id":"05edffd4-72ed-4cb5-ac3b-f631f2c3d46a"},{"claim_cluster_id":"650bbf0e-b896-4929-a2ae-2f9899d4868f","event_cluster_id":"2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"},{"claim_cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","event_cluster_id":"9e7a0088-26cb-464d-887d-c7e715addbcf"},{"claim_cluster_id":"dce54f5f-136c-474f-95c7-ae5b1e1ff60b","event_cluster_id":"2f406046-b590-4796-97c3-ab6b4e6c2d6a"},{"claim_cluster_id":"55f659a1-e5dc-41c5-8a43-9846f564af08","event_cluster_id":"f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9"},{"claim_cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","event_cluster_id":"65657196-d0ff-4d4a-a7ff-868fd5f099d9"},{"claim_cluster_id":"c90c00dc-2c77-42ad-bb5e-2666e53e2bcd","event_cluster_id":"77a67b7a-5038-4c86-adcc-8306f16e92e1"},{"claim_cluster_id":"767a107b-6141-45c6-9ffe-6f7fde1b3426","event_cluster_id":"1fb4e8e5-4760-48f4-95b8-9dd118893a35"},{"claim_cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","event_cluster_id":"0f0292cd-5ed9-4b41-be37-f307be9f4e80"},{"claim_cluster_id":"58021478-0a50-495e-b059-4560ef7c90f4","event_cluster_id":"e52fcc8f-16ac-4c0e-8ef2-f3d55d44895d"},{"claim_cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","event_cluster_id":"939d6808-ee32-41c3-8d70-73aed1d043da"},{"claim_cluster_id":"3232bd90-9251-47f0-ae93-ae2d51218354","event_cluster_id":"7d9d58bd-39b4-4188-a92b-2b9d72ec8bda"},{"claim_cluster_id":"2c49dd92-a97e-4b1e-bac2-607670a0a86d","event_cluster_id":"4863edc0-3025-4ffa-ba81-0d1ed977b2b9"},{"claim_cluster_id":"72a7c01f-5ad0-4d37-b9bd-84c255cc3d32","event_cluster_id":"b38c1227-31d6-4991-a4c5-01c6af14c400"},{"claim_cluster_id":"a2f5a4b1-ccba-4cac-9bde-f079d3027db4","event_cluster_id":"317ecec9-87af-4e3c-acd4-372de58135a0"},{"claim_cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","event_cluster_id":"5adabd10-79d1-4a41-a250-38ed66b71fff"},{"claim_cluster_id":"02e0cfd6-814a-4276-b8cf-66540b7686e7","event_cluster_id":"f81e3872-fc8b-4fad-ac23-6ccf86d6cffe"},{"claim_cluster_id":"4b37762b-26f0-4956-9d1d-e433973602e1","event_cluster_id":"aca283ef-ca7e-47bb-9faa-cd0f44fb7b50"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"b50d2222-7f8b-46fd-aef1-62ca57b6cc71"},{"claim_cluster_id":"b874b38b-169d-4b90-b373-ae919f14c5a0","event_cluster_id":"5a95085b-b1ae-4847-9e04-b0336ef06ae4"},{"claim_cluster_id":"51f9e6ae-7c8a-46e3-8fa3-070377ae9030","event_cluster_id":"e09e9595-94ee-4647-99c5-988ef1e8bcb9"},{"claim_cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","event_cluster_id":"f4d98260-09b2-436e-8c76-b8fdadb8663b"},{"claim_cluster_id":"9012b6f3-2c16-482a-b276-63925d342482","event_cluster_id":"4c7b4c87-4848-4dfc-82f8-638a5803038a"},{"claim_cluster_id":"21b491b2-20db-42c2-af5c-70af377f068d","event_cluster_id":"d878f267-808b-4a23-9202-10d08ee3053d"},{"claim_cluster_id":"7f94beb2-9a43-4280-9734-5045402a0714","event_cluster_id":"87e5a1c0-9b91-4772-b701-2e6333826ce4"},{"claim_cluster_id":"807e0902-55ee-4c2b-a271-40fd2fb58b9a","event_cluster_id":"b1dcb694-6efc-4b22-9bc7-9254eb290f7d"},{"claim_cluster_id":"901f6891-5f9b-4fa4-a368-69a4f20e9617","event_cluster_id":"cb33e750-c57f-4e58-a355-2b249b902a62"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"8da8b4f2-f2e7-44b8-b5b6-7b0f66fba285"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"59fa4256-c06f-40de-a351-3b6ce5c20978"},{"claim_cluster_id":"25acea26-0f6c-421d-8050-ebc9dac75b8d","event_cluster_id":"57d05796-d479-4bb6-8a2c-cdfddd5731a7"},{"claim_cluster_id":"b9ff3223-8bd6-4360-8edc-fa3409378e90","event_cluster_id":"3fbd6864-531f-4366-93b1-3db5814687fb"},{"claim_cluster_id":"763dcb28-8161-4ef1-bcee-20cbd6af7670","event_cluster_id":"f1749a30-d414-494e-8542-2f37dca2357f"},{"claim_cluster_id":"528a9885-82c7-4bee-beac-f85e4c7c3f1b","event_cluster_id":"37a93514-6b4c-403e-9a3e-4ceb074df89f"},{"claim_cluster_id":"a5114ace-99b6-4b39-875b-8b7056c70002","event_cluster_id":"db9f2811-0988-456d-94ba-acf8fa9e6c6e"},{"claim_cluster_id":"4f0130b7-d8c3-44c1-892f-fe74aef4cecc","event_cluster_id":"fcd2863d-6523-42c5-86f2-9d70faca5e49"},{"claim_cluster_id":"fb6ff34e-94b0-4910-b613-9ebb9af0b6b6","event_cluster_id":"1edce2b9-2c90-4e50-8469-6e4fab4fa23c"},{"claim_cluster_id":"281fca06-ede2-40bc-9960-0788b1d20c23","event_cluster_id":"ff805a1d-a863-4cd5-ad33-a75bc8aa6ed0"},{"claim_cluster_id":"bac292de-05f4-4fd3-a4df-f073c8f09553","event_cluster_id":"773f7bde-1fe5-44c5-9d2c-84b849939bc7"},{"claim_cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","event_cluster_id":"919dc1e1-6cb7-4d54-aa99-504278bbf1f4"},{"claim_cluster_id":"59bf3043-2eaa-48fb-880e-613249cbd976","event_cluster_id":"f81472fd-0486-49fc-92fd-9753ce76f44b"},{"claim_cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"0e2fe0e5-314e-4455-88c7-a13f3f6e7728","event_cluster_id":"674e3f33-6edf-4940-a9ac-cec9bedff257"},{"claim_cluster_id":"f4c860ae-1c6c-4478-89c7-fac05f3999c6","event_cluster_id":"27e1dbcf-9461-42c2-9fb6-7b948072caae"},{"claim_cluster_id":"2d5d8472-462a-48f6-89fe-e8182a74e9c6","event_cluster_id":"1e2063e0-1979-4024-9493-206d34c55c1f"},{"claim_cluster_id":"87e60b81-7893-469a-8c14-40e3d6122aa1","event_cluster_id":"7a9e1845-1b7e-4301-8581-ef30d33ccad9"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"9acd0141-e648-4bf5-8aee-3bc494863f46"},{"claim_cluster_id":"b54d16d2-d5db-4746-b15a-e8c01d4fc586","event_cluster_id":"7b2da9c5-ac6d-44df-b539-9a5ad8a18762"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"085a40bb-586e-4634-99d1-21c6d1eb5884"},{"claim_cluster_id":"efb75ced-ba33-4f51-8892-e54a26a45d00","event_cluster_id":"0dd8b4fd-5bcd-4d2e-97ef-0ae1371a8f17"},{"claim_cluster_id":"d8704200-daac-4e95-873c-20cc39771b1c","event_cluster_id":"47e32d49-9365-4f05-bb52-852578030b2f"},{"claim_cluster_id":"aa440a76-9b1c-4801-9031-cdac4add116a","event_cluster_id":"cf64a707-174e-4193-859f-9f55dd41a4a6"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"ff2f92ab-182c-47dd-8807-28fea5da8eba"},{"claim_cluster_id":"3b1124a1-83ad-4acf-aefc-fa570a669706","event_cluster_id":"a7c0d5f2-2d5e-4a9e-bdf4-5365c1f262be"},{"claim_cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","event_cluster_id":"d635b0fd-8741-49c9-a6f1-294159c206bd"},{"claim_cluster_id":"c8657dfd-ec8f-4884-9c32-c4d6cac2c0f4","event_cluster_id":"6870e10f-72e4-4775-9bf6-5b40e5853931"},{"claim_cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","event_cluster_id":"f1447bab-26ff-4b83-b864-e0d728335c30"},{"claim_cluster_id":"a8aabd5b-4955-40cb-b78a-086cb1601de5","event_cluster_id":"db5ce7c4-0a90-4c8e-b702-060aaa2cd9c6"},{"claim_cluster_id":"ee9a474d-ce93-4992-ac4b-8d9da4087257","event_cluster_id":"f646af3d-32fa-49f1-bcbe-d5924a767680"},{"claim_cluster_id":"2b132e72-8cc9-4107-a55f-19ac99e2caf3","event_cluster_id":"476dd033-427f-436a-8631-14fd97a75117"},{"claim_cluster_id":"f17dbb9a-8968-4ade-a774-02688b6da89a","event_cluster_id":"f3475e22-43a4-45ea-ad6a-fe7e7accc82a"},{"claim_cluster_id":"23bbf046-846b-4885-b881-e84d2ca9060e","event_cluster_id":"7e6ac8e9-cc11-4ef0-955b-65da48ed02cd"},{"claim_cluster_id":"0e2fe0e5-314e-4455-88c7-a13f3f6e7728","event_cluster_id":"5c31493c-9070-471a-a409-144d7a3c341a"},{"claim_cluster_id":"5fb2043e-87e6-4ef1-829c-b51f962dada4","event_cluster_id":"a1887544-121f-4fbc-b25f-d4561dfb5e4b"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"b4c10082-ec3a-4c01-a666-d497f9480003"},{"claim_cluster_id":"b27abfde-f9d9-4f52-9ce7-8c541388281c","event_cluster_id":"158c7584-7298-4494-b705-f2d978c25206"},{"claim_cluster_id":"0450cb4c-8816-4bbd-85b6-ac94ecde9af4","event_cluster_id":"d5f473e8-ffa8-45f6-bee7-fb81681c241a"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"c4df2ece-fef6-47b5-b7cc-a9846a2066d1"},{"claim_cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","event_cluster_id":"3df2dbeb-6250-425e-8956-8daf269e1976"},{"claim_cluster_id":"9315dcd9-b677-4d15-b61e-ab3ddd7205d6","event_cluster_id":"3277c81f-d2ed-42ea-acc4-bb977e68f163"},{"claim_cluster_id":"b31e61b9-2010-4063-88bd-0eced0599429","event_cluster_id":"d62a8641-ec0a-467e-8fc4-ccff76b670f1"},{"claim_cluster_id":"9d1065d7-3830-4746-a836-8da581c0bbb5","event_cluster_id":"95a8e81f-4308-4c82-a9de-2d2f3b200b4c"},{"claim_cluster_id":"aa95c9e4-8d02-4bc6-90e1-de547f4e4e60","event_cluster_id":"08ecb39e-a545-45c3-b7b6-8257d44a3e9f"},{"claim_cluster_id":"449f7a4c-3966-4db6-9cf4-d39a2f15feae","event_cluster_id":"190c47c8-68da-42d3-b08d-822d259e964f"},{"claim_cluster_id":"c6e50b1a-e795-43fc-baca-c835ba2bf14d","event_cluster_id":"1a9ef0f1-3f2d-4026-a13b-46206f55c61e"},{"claim_cluster_id":"20eecf26-3fb0-4e96-b07f-0dfffef9c628","event_cluster_id":"46ec4fb5-6eba-4f8a-b3a0-e40c112dfda5"},{"claim_cluster_id":"af503db6-fcf4-45f9-9501-f2732e2af4f7","event_cluster_id":"c2b35258-6b6b-4618-98dd-3efdfd8152a2"},{"claim_cluster_id":"ba694c90-be36-448b-9da2-f3ed0d816139","event_cluster_id":"0af61c8d-a534-4af2-a2da-7ed4f4cc7aea"},{"claim_cluster_id":"13470ac2-b4c3-4aff-aa6a-418a5222958e","event_cluster_id":"6869c5c6-393d-450f-8dcf-3be81ce4febe"},{"claim_cluster_id":"74664a64-2600-438a-b569-a9d45ae85e93","event_cluster_id":"02f42105-05b5-4e5d-917a-7eefa123f670"},{"claim_cluster_id":"041ca325-747b-4d3c-b3c4-9ee7fabc37db","event_cluster_id":"44bec0d6-7c8b-4869-801c-2ac35f38611d"},{"claim_cluster_id":"5f9b6057-0fab-4c3c-b1af-a7c26bc6c692","event_cluster_id":"7e4cb312-8581-481c-819b-81c1e9125f8d"},{"claim_cluster_id":"fc9a7668-0501-4f68-9ebd-21d6b6146f62","event_cluster_id":"4cf07546-b901-4002-a89e-1a6f0ae3d9e6"},{"claim_cluster_id":"42302660-b692-4e66-870b-37970eee6c13","event_cluster_id":"01800770-341b-42d0-83d8-a7e215d97f98"},{"claim_cluster_id":"d9366872-6ca9-49e5-9e80-86c5b954d463","event_cluster_id":"65f08a18-b069-4ad1-8cde-ea7ebd30b6db"},{"claim_cluster_id":"9f34aa0e-2eb3-43e3-b4dd-54a36752af72","event_cluster_id":"ed814054-66d7-40f4-897b-99909fd4d531"},{"claim_cluster_id":"bdecd7b0-3449-4d8c-9710-468d872a6514","event_cluster_id":"7effcde4-df93-42c6-842d-c99804764bd5"},{"claim_cluster_id":"c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2","event_cluster_id":"196c610d-29ed-4851-a66d-a936eab5709a"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"a0925808-7df0-46ec-bb06-9cb553f8b8fd"},{"claim_cluster_id":"e7a1e23f-832f-432a-ad19-207015a794b2","event_cluster_id":"3cda3833-2d58-4e6e-a35b-5bec2cd74e4d"},{"claim_cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","event_cluster_id":"5cb4afbf-e109-4c74-8315-a2a58d421c9c"},{"claim_cluster_id":"71185519-3f2f-4171-84a1-11f08a933f13","event_cluster_id":"7a36ef35-086a-4724-b10d-2245bacdde6a"},{"claim_cluster_id":"fec0d44e-dff3-4478-9317-1b1d954f03c6","event_cluster_id":"5da78bf8-d65b-4a01-8353-c40daa91e80b"},{"claim_cluster_id":"12ff0964-4c5c-4f91-8269-1e4ab61e9602","event_cluster_id":"ecc05d01-ffac-434e-b1f4-f1a58038c91f"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"ea0b1b6a-993e-4153-b0a6-ac182d884071"},{"claim_cluster_id":"ab8d2b2f-e3a6-40b8-aaa2-2e4bea7826db","event_cluster_id":"b224e5a5-61c4-447f-b912-3f4a296442f7"},{"claim_cluster_id":"f74715cf-7efc-4866-8a83-4aec1b75795e","event_cluster_id":"80becc29-3509-4795-9714-7ee69f928767"},{"claim_cluster_id":"09a92b68-8f29-435d-b853-f4c47f64d9da","event_cluster_id":"fc6510d9-839e-4451-a099-a28338b3f8c9"},{"claim_cluster_id":"774b6df5-ef29-47f3-9ae9-d88dbd184e38","event_cluster_id":"4f8dc606-1036-443d-8754-a33caecd77d3"},{"claim_cluster_id":"08f93426-27fb-4a01-8b3a-b106b5f837ec","event_cluster_id":"ca50545a-7854-48c2-bb9c-e0894d7bf854"},{"claim_cluster_id":"16667fe1-8cf7-4fec-9aa8-c5bb30920e90","event_cluster_id":"2de014ab-746a-455c-a496-0833ca28f9b5"},{"claim_cluster_id":"b2635760-bcd6-46c7-88fb-9bbbb7349033","event_cluster_id":"a14e07b9-7624-46b7-920a-7b615bb8f39d"},{"claim_cluster_id":"7659f671-e41e-464a-9184-a08b114b3636","event_cluster_id":"9c4cbf68-9385-4898-9bf2-17346263f863"},{"claim_cluster_id":"696180e6-d43f-476a-afce-5f13dbb9929a","event_cluster_id":"58588aa2-076a-4527-9fd4-663a7871c357"},{"claim_cluster_id":"f3b06c88-86f6-4833-89c1-f778a2910669","event_cluster_id":"58d6742a-73cd-42e8-8a47-4ea3718af2a5"},{"claim_cluster_id":"8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4","event_cluster_id":"522064a5-257c-47c1-b163-e454d1155f76"},{"claim_cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","event_cluster_id":"89bf1ecc-4cb1-4aca-b3f3-c9c14a8868b7"},{"claim_cluster_id":"29880646-f50e-47bd-8b04-23f2c8716fdf","event_cluster_id":"0c67a873-1e0f-4dd1-9e3b-40d63d120847"},{"claim_cluster_id":"f20df5bd-42ea-43d0-88bb-1d05f549a0e4","event_cluster_id":"75a7abcd-ccae-4606-800a-89412da639cc"},{"claim_cluster_id":"75816fb8-77fb-4eee-a3ec-bbb68393ff86","event_cluster_id":"136ce880-e6d8-4791-8b14-3c42846dc7f3"},{"claim_cluster_id":"5ece0141-8dd6-405b-93cf-5585050f4efe","event_cluster_id":"d8e63a6c-9b16-4691-ad10-679a83e7a296"},{"claim_cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","event_cluster_id":"83578f15-2ee2-4dd4-ae7f-b543ba5e2a87"},{"claim_cluster_id":"24b7c36e-3b2a-4cfe-9ca3-0c7d32583eca","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"97e04a01-6626-4196-a12d-eac1df348581","event_cluster_id":"3360bff0-2a50-48df-84ce-ef5c8f91489d"},{"claim_cluster_id":"bc56200e-afec-40d7-a87d-167e90733913","event_cluster_id":"3e73e60d-d610-4533-a186-9f4c4620025b"},{"claim_cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","event_cluster_id":"6a14502a-8c63-426b-8062-c7e8472786ee"},{"claim_cluster_id":"159421f9-fc35-4e25-a688-4ecf97e146b4","event_cluster_id":"9f78a266-9f3f-46d5-948b-3b4d3da9a083"},{"claim_cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","event_cluster_id":"593dac82-590e-4efe-97bb-2666521b40b5"},{"claim_cluster_id":"1b5c8541-b848-4f05-865e-43826009d4e7","event_cluster_id":"f39790da-a4f6-4366-98f5-449851f41e29"},{"claim_cluster_id":"e762d6c7-8067-4852-8232-49501526397d","event_cluster_id":"30d2097c-43cf-415c-84fd-ec7c279c4c87"},{"claim_cluster_id":"86ef5628-f267-4ce6-97b4-2f06bd91a5fa","event_cluster_id":"fc5ae33a-0165-41ca-a5df-b2b0a56f5100"},{"claim_cluster_id":"9d1065d7-3830-4746-a836-8da581c0bbb5","event_cluster_id":"34782a59-6a9a-4289-8c00-12feb5c0f040"},{"claim_cluster_id":"18fe8f4b-896d-47b4-a019-0383dc22d38e","event_cluster_id":"a1787db1-8710-47fc-b234-f265a8dd366e"},{"claim_cluster_id":"1b63ec5b-2010-4bd3-a351-328e7b4b5470","event_cluster_id":"114c5c62-e2bf-4ad2-a913-3744fd25a373"},{"claim_cluster_id":"9028c8ac-b264-4318-be25-6d627ad54b1d","event_cluster_id":"1fa41b69-dd08-4cf7-879f-ed94078d9d64"},{"claim_cluster_id":"2408ad82-3b39-4925-be26-13cd9f14bf98","event_cluster_id":"f35fd313-149c-4568-ab38-fa2d1f029e32"},{"claim_cluster_id":"61ac97d3-e62e-41a3-b910-360985f7af21","event_cluster_id":"b60886b0-36f1-4d60-bd61-b45768791dc2"},{"claim_cluster_id":"e871839f-962c-43cf-a2f7-5ebaf26de0a1","event_cluster_id":"9ceeac8a-9421-42a3-9891-76c4ef2d8151"},{"claim_cluster_id":"3de3b456-a38d-41d1-85eb-8ea198492839","event_cluster_id":"b5146023-e397-4082-afc2-a8c71c288767"},{"claim_cluster_id":"fb6ff34e-94b0-4910-b613-9ebb9af0b6b6","event_cluster_id":"8d7a2b69-1f50-474a-969f-950408a29268"},{"claim_cluster_id":"634ebbc5-474d-42c0-bf34-498666dade49","event_cluster_id":"af13a573-a204-482f-aa52-9623e30fedfc"},{"claim_cluster_id":"d089a914-1c7d-48b8-9c48-7a1b65f152b1","event_cluster_id":"9f4c8f09-a6ba-4b36-a260-db32b470a2b5"},{"claim_cluster_id":"8308c2eb-92cf-4ca4-876b-d1d947564441","event_cluster_id":"fbda0675-25d1-4968-aecf-16ed15e84db5"},{"claim_cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","event_cluster_id":"47f7a131-6ce1-4e01-b64c-61e5f9696bb1"},{"claim_cluster_id":"2da1e2c0-6b7f-4a59-bbad-c83252a70f91","event_cluster_id":"afff4757-e8dc-4943-90b2-48114c9bc6d7"},{"claim_cluster_id":"6f7b7d52-9a91-4f92-8a4e-4062c6360cda","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"4d2c8d1c-73d7-42b1-87cb-56c8ddf68982","event_cluster_id":"e92ede91-314d-4f91-a23e-b6bfa200e224"},{"claim_cluster_id":"4af97b54-9617-48e3-8125-aa1e8e1ee8a2","event_cluster_id":"57c8d119-9759-4d0a-a7cd-9c98d4429c3f"},{"claim_cluster_id":"1071979a-b25a-4432-8eb1-62e54bcd27e1","event_cluster_id":"1b374305-b708-454f-b63c-7ff8ae988cdd"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"3e760dc6-7f77-441d-bf0b-d687031ab57a"},{"claim_cluster_id":"a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"d2830923-6260-4e70-9fc4-f723af340d1f","event_cluster_id":"afb80000-29ea-4260-b454-0363d71c9855"},{"claim_cluster_id":"b763139e-3c42-4a2e-8afc-f2941722221f","event_cluster_id":"2d644f06-03ca-439d-b2dc-c42a08782eba"},{"claim_cluster_id":"86160f22-53c1-4e04-a28d-86c0e883fa44","event_cluster_id":"db5c7092-c228-4319-b130-e75471c29ec0"},{"claim_cluster_id":"989e42eb-c62e-4e68-87e6-6b230317d087","event_cluster_id":"bb3ba302-b163-46a5-9a24-14ade245b1de"},{"claim_cluster_id":"4313d034-31f9-4eb9-9451-e9a5dda6e7c3","event_cluster_id":"30d8206d-7f35-4cfd-86b9-4ac411d8d754"},{"claim_cluster_id":"bd4c7f11-9866-4656-98e3-7341cfc6de34","event_cluster_id":"712f6134-d72c-4f1f-bf01-f9fa23374d32"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"ea54647f-e4a4-46e7-bf16-66e30583a4a6","event_cluster_id":"dc5ed306-20f0-45cc-ac9b-9241d0460c7d"},{"claim_cluster_id":"f74715cf-7efc-4866-8a83-4aec1b75795e","event_cluster_id":"5674d01b-2996-4ed7-850d-de449d707ce5"},{"claim_cluster_id":"0f047203-3949-4e82-86d9-77d6fe7af9c8","event_cluster_id":"3e4bfcca-aa45-4a97-8306-e90101b4ccc0"},{"claim_cluster_id":"d26e1561-d7b5-4c15-bc29-d5ba417f64ca","event_cluster_id":"b87bc991-27b5-4e76-ab33-22c0374b82e2"},{"claim_cluster_id":"cbafab62-ed48-49fc-9623-dbadef5cfd91","event_cluster_id":"af4322da-0cf9-4a56-9b07-d10c70b336a9"},{"claim_cluster_id":"bdecd7b0-3449-4d8c-9710-468d872a6514","event_cluster_id":"3a3218a4-ce54-4e61-9c08-41f52d8bf517"},{"claim_cluster_id":"8ae5ced3-47a9-4ee9-8f6c-9d0fb1ad36e4","event_cluster_id":"f23bc705-fad4-4454-82b7-d780cad17182"},{"claim_cluster_id":"12667ac4-7c0c-4916-8553-cead6974cc24","event_cluster_id":"43d693d1-43e9-41bf-9f49-b7662edb6922"},{"claim_cluster_id":"6606b076-6fdd-4a94-a7c5-b6bfc5191980","event_cluster_id":"84a7917f-8218-438c-a1b9-0e45b12c8e34"},{"claim_cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","event_cluster_id":"14c3f0e3-2371-447c-8445-1ac6c299f633"},{"claim_cluster_id":"f68dc41c-3947-416c-8f93-49c606c24bd2","event_cluster_id":"249e8c50-f68d-47af-99c9-2bc6ddfd52ad"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"fd554d0c-cd25-4da2-adf1-dcccfd01f292","event_cluster_id":"418af057-88c5-4485-917f-178851436407"},{"claim_cluster_id":"6a4b35a4-0785-4292-8587-aee85db61288","event_cluster_id":"fc3da38c-59ab-4dde-836c-c912a95b1802"},{"claim_cluster_id":"6cfce6ce-fb64-4bfa-a23f-01cbee46c275","event_cluster_id":"757b69bc-6342-44ee-8a8e-c35de9054b6d"},{"claim_cluster_id":"bdc7e61b-1cd4-494f-b965-4387369e6df2","event_cluster_id":"09e091a4-d9df-4ce0-ab1e-d30b85568ee5"},{"claim_cluster_id":"47085082-7091-436e-a3ee-ecf14c90e1a5","event_cluster_id":"6b6a1ba0-8a8c-4bf1-9799-4a4ce9b1d916"},{"claim_cluster_id":"7db64556-43b7-4e29-b1a9-e8fcd5d29233","event_cluster_id":"ba793871-eeec-487b-a1b0-5996d1bd03cf"},{"claim_cluster_id":"25acea26-0f6c-421d-8050-ebc9dac75b8d","event_cluster_id":"6d563374-a7de-4d4e-bf0b-d89a34f47ac7"},{"claim_cluster_id":"cf096384-5ede-4929-b992-9e6ee20d6a8b","event_cluster_id":"0c283d46-2055-4ab8-8bbf-4417f6667e86"},{"claim_cluster_id":"d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3","event_cluster_id":"9979222f-6af5-4d8c-85d9-81f2ad80980a"},{"claim_cluster_id":"8b44daa7-629e-4db8-81b7-5ed88669eb86","event_cluster_id":"8bdd7aea-e82e-44ed-9306-49ba0cde454c"},{"claim_cluster_id":"692c12d0-dff2-4fe9-a351-80422ee99320","event_cluster_id":"9830a54f-6df4-4c84-a14f-819c289e70e5"},{"claim_cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","event_cluster_id":"823656a1-093a-4e85-b706-f48d18e40c29"},{"claim_cluster_id":"4df0c9e7-49c0-478b-aeb5-0b3833932e62","event_cluster_id":"3c2e5bbb-18fd-4888-959d-c7aef1790267"},{"claim_cluster_id":"692c12d0-dff2-4fe9-a351-80422ee99320","event_cluster_id":"11d8d71a-168c-43ed-b532-83903fcd58a8"},{"claim_cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","event_cluster_id":"af86b76d-a390-4847-bb43-41459c4a0513"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"e2ffc2de-64b8-4d49-9767-c601c711ffbd"},{"claim_cluster_id":"99955509-35d5-4623-b165-0b6dc4f83f23","event_cluster_id":"12b1cdcd-4e31-4b05-ae44-98d5b446ed03"},{"claim_cluster_id":"38eef897-6e59-4836-bf0e-1e7e106baf53","event_cluster_id":"8e29592d-1755-4868-982e-348b60636ba1"},{"claim_cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","event_cluster_id":"3c292204-fc50-446f-99ed-6fd49056a887"},{"claim_cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","event_cluster_id":"acde1f80-8000-4b4d-8e9d-7d24f15b41d9"},{"claim_cluster_id":"5fd07840-c42a-480f-ac7f-9ffe7168dd63","event_cluster_id":"7eb16fe5-1729-42a0-bcb4-1a4783656ce6"},{"claim_cluster_id":"2fe163fe-8ed3-4202-aad1-5f84672917c4","event_cluster_id":"3be61476-a382-4c84-9990-67e69bae81f5"},{"claim_cluster_id":"3da4f222-08f1-4864-8aa3-3576d8a64207","event_cluster_id":"3124bf40-7b7a-44d7-a83e-a1fe41e14ec6"},{"claim_cluster_id":"7781df4b-26ca-4879-a33c-cb83ade5ffa4","event_cluster_id":"700f9b04-7504-490a-bc2b-7cf163528607"},{"claim_cluster_id":"7e639892-5cda-4557-94c4-87321bdc3233","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"536df2e4-b955-48b2-8a3c-5b06a58c9d87","event_cluster_id":"5540f6ac-c1b9-4d28-95e7-760d9496128d"},{"claim_cluster_id":"939cc578-da0d-4d69-94b9-0a186537275d","event_cluster_id":"a01dee28-83a3-45b0-ab2b-6e6c04b1fe22"},{"claim_cluster_id":"4b037322-86a6-4af9-bfe1-49f968f04baf","event_cluster_id":"71ff5874-dbd0-431c-b097-90e57ae45748"},{"claim_cluster_id":"3af9eb7e-1c8f-4ca9-987f-f38db6d11751","event_cluster_id":"632ff2a8-1423-4189-882c-4d3e14dadc3f"},{"claim_cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","event_cluster_id":"bea2fa8c-8f73-40e8-949c-4bf3e53cc1a7"},{"claim_cluster_id":"e9d22d46-e0d1-45b7-b109-afc6516146e1","event_cluster_id":"85b2637f-fff4-4688-a95a-adb041e440fa"},{"claim_cluster_id":"3200fc3a-bd08-4faf-ac3c-69eb812ef575","event_cluster_id":"7a13b273-8feb-4f23-b79f-e5f89124c43d"},{"claim_cluster_id":"06f63413-3561-4a53-933b-589b1f942c37","event_cluster_id":"783f72c7-55f3-4eb7-a87e-43b3ec9f631e"},{"claim_cluster_id":"1b178ff0-cd2a-415f-bd8a-4daf71e452c3","event_cluster_id":"1997b709-7204-4376-b1e8-77d6b8518a0f"},{"claim_cluster_id":"2568c212-fcce-44e5-930c-3fe63b8f0d65","event_cluster_id":"d14dd6b6-ea0d-4827-8ef2-ba250811ea5a"},{"claim_cluster_id":"beb979e4-f486-4e3c-ba15-47b099971ff0","event_cluster_id":"22388e5b-3cdc-4eb4-8e97-052ccfe18cfd"},{"claim_cluster_id":"708c11e2-cd61-4685-8e6a-35d93d6b988e","event_cluster_id":"81b74ec1-1e27-4ec6-a6ad-9c28cfcd7074"},{"claim_cluster_id":"e9c91d2d-9c77-43dc-9ccc-c00049984a01","event_cluster_id":"3bda9d5f-2f9e-4086-90e5-207bbda0f725"},{"claim_cluster_id":"049db6be-2ccc-4afd-97c6-e95cb1b50286","event_cluster_id":"32c73de2-95e1-45f0-9627-537de9f0f318"},{"claim_cluster_id":"a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd","event_cluster_id":"8b24e853-731b-4d1e-ab4f-4eadd5f933df"},{"claim_cluster_id":"9c5c6743-3894-4e82-b69e-bc4e0c19f869","event_cluster_id":"009689fa-763a-4351-a069-4f29c46a8fcf"},{"claim_cluster_id":"3e9990d1-ada6-4c9b-b2b3-e8220e956431","event_cluster_id":"0751c6cb-9d71-46b3-91e2-7b78341d2ce3"},{"claim_cluster_id":"5900a7ab-7cb4-45d4-8807-d20dee337670","event_cluster_id":"9c1a6fcf-db77-4bad-b035-88b7787ab104"},{"claim_cluster_id":"72a7c01f-5ad0-4d37-b9bd-84c255cc3d32","event_cluster_id":"5549ed3d-7dea-4eb0-ad38-1dd76c667c0c"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a"},{"claim_cluster_id":"d3ef62d6-a9f2-4e02-8cb8-beabc3ead80a","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"2616e42a-b0ac-42ff-93a5-2376cee42b92","event_cluster_id":"8e082e26-8f01-4448-85f9-dcbb694f327e"},{"claim_cluster_id":"0fc06cfb-3a25-4176-a530-ab9cb52f7632","event_cluster_id":"74873448-e290-4f3b-a22d-809e34d02a4e"},{"claim_cluster_id":"24d81b39-c399-4c59-ae9b-c84548655d0b","event_cluster_id":"791e282d-3184-48f1-b9b4-d9976176f1c4"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"16f44bbb-61c5-4b72-873e-79ca1d65deb9"},{"claim_cluster_id":"e762d6c7-8067-4852-8232-49501526397d","event_cluster_id":"b68b2c64-2b71-44ac-a7b3-c79fe12186bd"},{"claim_cluster_id":"5443e2c0-e92d-4c21-ba1b-b0cdb2302769","event_cluster_id":"fb8a3738-fc86-4011-aef4-faadf91c1772"},{"claim_cluster_id":"f3735996-484c-447a-8fe4-4cd5c645a0a9","event_cluster_id":"c5a76746-76c2-4937-b9a7-284d0de20709"},{"claim_cluster_id":"ea316b29-c411-49a8-8ebd-8e50456fc746","event_cluster_id":"54513007-2bf5-4c3c-8060-c65d26b45075"},{"claim_cluster_id":"f18ec76a-50ba-422f-9d7a-596708b1810a","event_cluster_id":"61d73230-504f-4e81-a2e0-6fec552c5517"},{"claim_cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","event_cluster_id":"6b780a23-d1ce-4c39-8626-c4071a335cc8"},{"claim_cluster_id":"23adc402-b3b7-489f-bbe8-5d7825946d77","event_cluster_id":"460920ff-c88f-43ab-b704-4a3029ef5976"},{"claim_cluster_id":"266128fe-9d68-4687-b95c-b0654a1c7f0e","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"170448e1-fefc-424b-b5a4-23941f88389e","event_cluster_id":"f29c8da8-dc4f-4133-97b2-dbe8a7c642b2"},{"claim_cluster_id":"843e2174-20bd-4386-beb4-ad4f8d0ba790","event_cluster_id":"dc2b6524-3e37-4978-9dbf-854499aadeb0"},{"claim_cluster_id":"a990d90c-b1b0-4148-b047-5b63c9eb7a78","event_cluster_id":"867076a2-38a3-4bba-9e8e-00167fbd33c9"},{"claim_cluster_id":"1363d4a2-5ea7-481a-b7e3-3e161a6db765","event_cluster_id":"db8f619e-f112-4abd-9c92-e8cda93ee5d3"},{"claim_cluster_id":"18eba947-bd55-4242-95f2-7927edd7f432","event_cluster_id":"91e8fe58-f0fa-44e3-ae52-de74821a1034"},{"claim_cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","event_cluster_id":"2de4265b-f662-429b-82af-a99a27de61cd"},{"claim_cluster_id":"4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8","event_cluster_id":"701cfb5e-4d20-40b0-b06a-cb6fe171068d"},{"claim_cluster_id":"07bacc2e-cf13-4467-917c-ef3c2aa505ca","event_cluster_id":"ffe496a8-ba5b-46e3-94f5-ab61bd09d41a"},{"claim_cluster_id":"997de204-d7ea-4e15-b208-ebc2bd4ddd62","event_cluster_id":"b53434f6-8475-4084-8547-bceb679687ac"},{"claim_cluster_id":"95a560d1-c8b1-4378-a024-d78252f97af6","event_cluster_id":"a55753e6-8f8f-48dc-b731-3ea6f869cd52"},{"claim_cluster_id":"840ac263-91de-449d-b701-c05a4522f3b3","event_cluster_id":"73b5bb5e-19ff-4738-bc4e-5908ad8a0474"},{"claim_cluster_id":"b877e703-7bf9-4587-919b-bf207b22c607","event_cluster_id":"44ed705c-5a34-48f9-ae3d-7f96124493a0"},{"claim_cluster_id":"7e9a80fa-c7f8-4eeb-8f62-09cee3732838","event_cluster_id":"f62a9075-e876-4cd7-80b4-8e9a12641d53"},{"claim_cluster_id":"3198b672-2780-47ef-8885-73e8c5597d80","event_cluster_id":"2cbbdb0c-fd37-40a4-97e3-351c65d658dc"},{"claim_cluster_id":"f51dc065-8987-4a56-b2b7-f53334ad4ee2","event_cluster_id":"fb8d8d1e-9afb-496a-b65d-ca304c598e8b"},{"claim_cluster_id":"ff7a6df5-d64b-4e14-803a-5339b1cffda2","event_cluster_id":"827e3030-1738-4370-a530-42878dd6927d"},{"claim_cluster_id":"83856113-7cf1-435d-bc2c-d1c5e5e5c106","event_cluster_id":"d7af883b-7f94-40af-b74c-503163e2b062"},{"claim_cluster_id":"fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec","event_cluster_id":"5c321eda-59e0-4788-8faa-0808e6c83192"},{"claim_cluster_id":"66a36ac1-c9eb-46aa-9ae1-0d7306ddb692","event_cluster_id":"65cdef1a-e035-4605-9081-f663d9551b62"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"0f047203-3949-4e82-86d9-77d6fe7af9c8","event_cluster_id":"371e032d-d57e-40c0-84fe-6f5fa1665409"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"2d62bce3-b515-4666-bea6-d3d1e123e654"},{"claim_cluster_id":"2da1e2c0-6b7f-4a59-bbad-c83252a70f91","event_cluster_id":"436ce4a6-0697-4461-9b3c-0feb3eafc498"},{"claim_cluster_id":"c9f87e7e-e0a4-4be1-aaa4-54f6d3bedaaf","event_cluster_id":"637f444f-2be2-49e6-9376-4e66fc8b211b"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"9e044845-6768-4b18-b4e5-13d72ace241e"},{"claim_cluster_id":"d4352376-c595-4d9d-928a-8fabbed1e18b","event_cluster_id":"89fd947c-c029-4635-8b9d-ca8e953af1ce"},{"claim_cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","event_cluster_id":"f8ba093e-142e-45ae-b5d0-aef007993c05"},{"claim_cluster_id":"54017113-d014-48fd-b57d-6cf55f5a8ff8","event_cluster_id":"317ecec9-87af-4e3c-acd4-372de58135a0"},{"claim_cluster_id":"aae7438c-bb2b-4e87-86b8-fc77cf6148d1","event_cluster_id":"49909022-fed5-4a4d-89a8-bdf0a26dd966"},{"claim_cluster_id":"a841656a-f68d-41d2-ac94-3537d3133ce8","event_cluster_id":"31b521fb-d677-46b2-8db7-b2e8a8fafe49"},{"claim_cluster_id":"997de204-d7ea-4e15-b208-ebc2bd4ddd62","event_cluster_id":"3e954c39-38a1-4449-bb6c-9e8070f71e04"},{"claim_cluster_id":"12dfa7c9-8817-4f21-ad00-1e4244142b34","event_cluster_id":"ff8eb50d-ed26-4f4e-b34d-1dd10e2cdbe4"},{"claim_cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","event_cluster_id":"2e675266-c3ed-4fac-a036-217c24ac28e2"},{"claim_cluster_id":"7e639892-5cda-4557-94c4-87321bdc3233","event_cluster_id":"158823d9-8d73-406f-963c-db32a179210b"},{"claim_cluster_id":"bfd9a248-bf68-4994-8af5-882efd424687","event_cluster_id":"00f3a914-1589-47ae-9fd7-4b841e19dce5"},{"claim_cluster_id":"a604694d-4fcd-48e0-a074-6eaa09488a89","event_cluster_id":"4ca4751a-06c9-42b9-935e-8c293fd1cd2e"},{"claim_cluster_id":"6d600ff4-5ee2-443b-9049-7fb530fb454c","event_cluster_id":"e49682e3-c065-43da-be61-a86567e3397f"},{"claim_cluster_id":"f6b0f0ef-f78c-4282-952a-d2ce7128854f","event_cluster_id":"71ddb5ae-a33f-4bf8-97d1-9321d27ed4a2"},{"claim_cluster_id":"cd55cb26-f122-4354-aeec-7ffaa02af90a","event_cluster_id":"39225686-c932-4b86-8609-bcb573981830"},{"claim_cluster_id":"442dded8-bef6-49b2-b7d4-70454c6e8e79","event_cluster_id":"e078499d-145e-47da-8902-0b8d9b181179"},{"claim_cluster_id":"4a817862-6fa5-4e7c-8998-977aaad70250","event_cluster_id":"8fea2c95-9eb5-4a00-9f7e-750ec49f4c61"},{"claim_cluster_id":"5904fe8c-6989-4981-93c1-c6202b0b4d88","event_cluster_id":"be74618d-f629-43fe-be50-6fcf737dd820"},{"claim_cluster_id":"d489ee78-15f6-46b4-8adc-818181d95968","event_cluster_id":"667cedb1-d001-4a4c-af7f-98106fe11ae7"},{"claim_cluster_id":"23adc402-b3b7-489f-bbe8-5d7825946d77","event_cluster_id":"b6748e1b-bb47-47df-a0a7-16d2d7f95e46"},{"claim_cluster_id":"708c11e2-cd61-4685-8e6a-35d93d6b988e","event_cluster_id":"282bf62f-9c0e-4150-9c45-5edc6ab7a29f"},{"claim_cluster_id":"93429ef7-e07c-4686-85f7-679d49d1274f","event_cluster_id":"64c35a09-3986-4a44-8a95-5828f2dd463c"},{"claim_cluster_id":"1b5c8541-b848-4f05-865e-43826009d4e7","event_cluster_id":"4dd085e4-7892-4955-a5ce-d8e90d7e23d4"},{"claim_cluster_id":"aa440a76-9b1c-4801-9031-cdac4add116a","event_cluster_id":"d69ec96e-95a8-4ada-b02b-404a801edc90"},{"claim_cluster_id":"dff8a985-ffc1-4946-ab7d-43e8406aca00","event_cluster_id":"dcae0b06-ee3c-4003-865d-7cc0ed9affe3"},{"claim_cluster_id":"f7c875b0-a0b4-45f6-b382-0915f179b2e6","event_cluster_id":"eee5559c-ba4e-40fd-8448-3d09c753f9ba"},{"claim_cluster_id":"758d6034-7d93-4286-ae2b-f2ffde861da6","event_cluster_id":"814e8e7c-9951-4225-be99-2e978ab5ec4d"},{"claim_cluster_id":"dad0da03-60db-4f17-9025-e5a1ac65e552","event_cluster_id":"e9f22744-079e-483e-97a4-7cefb12988e9"},{"claim_cluster_id":"616e962d-58a9-42e5-9a6d-decd8139ddf7","event_cluster_id":"befb7ee5-b118-46a8-baef-495aee63c618"},{"claim_cluster_id":"9be5c43d-4ef1-465d-bdbc-ed35d95c0689","event_cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63"},{"claim_cluster_id":"40621ae5-171b-4ff7-a8cc-0957a4cc93da","event_cluster_id":"719750be-a238-45aa-96a8-065dfd797981"},{"claim_cluster_id":"317ae87f-a4ca-4e46-9ff8-1bebad9fd04f","event_cluster_id":"0e2a258a-cc1c-4d20-82ea-f1ebf02f74b2"},{"claim_cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","event_cluster_id":"60bcdb7a-b11c-4760-96c7-2e903b89bd2e"},{"claim_cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","event_cluster_id":"c786e602-255f-4df8-a9fc-775fc1322fa2"},{"claim_cluster_id":"04938aaa-1985-4664-bfb5-337fffd62a6d","event_cluster_id":"abd6036d-49e1-4e1d-8db5-cfdac174787d"},{"claim_cluster_id":"594e0474-2d9d-4582-8963-9fe946d49a1e","event_cluster_id":"65f7972e-2194-4ad4-97f0-1ccb32281e02"},{"claim_cluster_id":"83176725-df79-43f8-b571-b45c6b2dea8f","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"98a5a190-c887-4ce2-b53f-011c39183ade","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"f10ad797-ad79-4629-861d-4af809502a09","event_cluster_id":"9fe09fbd-ca4a-419e-94ee-6e49f8b62304"},{"claim_cluster_id":"d6705dc8-8def-4060-882a-9c13b62a23ad","event_cluster_id":"eaf97e4a-55db-4cdb-ae4f-9ab8ecb7e821"},{"claim_cluster_id":"8e347521-7b79-4b75-abb3-86278fb2761f","event_cluster_id":"94238db0-c74d-46ae-8d32-ad4eebd6753f"},{"claim_cluster_id":"0de86638-0241-412b-ab2a-b233d85153a4","event_cluster_id":"b799c029-2c45-4feb-9700-47996ca8a80f"},{"claim_cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","event_cluster_id":"38fb1864-3682-4d4c-81c3-5ce8e0bbc80e"},{"claim_cluster_id":"717225a3-f2cc-4921-bece-db76c2709d99","event_cluster_id":"fa792d5d-a49f-406b-8386-4253dfbb9e11"},{"claim_cluster_id":"3945d107-ebd6-4f7f-98d8-84183dc2837f","event_cluster_id":"66d45ba9-56c2-4b38-9b31-adec0598a967"},{"claim_cluster_id":"4cf6c5d5-796b-4f0b-bf33-4b13d6dbe46d","event_cluster_id":"ced5af6f-55f4-47fb-a25a-cd619d213da3"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"d9598814-d7a3-48d1-b282-0aa4d0dfeb8b"},{"claim_cluster_id":"7553f34f-d61f-419e-8976-cecf89bafb0e","event_cluster_id":"522dac78-ab07-4494-b1cd-d35343e02912"},{"claim_cluster_id":"fc8bfdbe-11b3-42f5-b3d0-f35ef7784a93","event_cluster_id":"53368f02-d082-40dc-87de-4a43534eebcb"},{"claim_cluster_id":"60269200-21dc-4ddd-bed2-414eb8acfbb9","event_cluster_id":"f54b8dca-8c1e-4052-93b8-d1e0396181a2"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"d8fa0364-5dd8-4aab-bf01-01e24a95233b"},{"claim_cluster_id":"be207930-e097-4d94-9b71-209ad62e9e5f","event_cluster_id":"e4488bd7-fb22-40f5-8db9-906cdc42ac18"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"c41e3b9a-0aaa-4ffd-84fa-92acc0346b56"},{"claim_cluster_id":"5fbc247f-99df-408a-8188-29a28a5f5737","event_cluster_id":"ca1ecbfe-0a58-42df-b1c6-c31ad13d1a11"},{"claim_cluster_id":"0fde95b6-db57-45cd-b6ac-fb0edd1b186b","event_cluster_id":"ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e"},{"claim_cluster_id":"abfcf3df-912d-43b6-968f-0f586e4e242c","event_cluster_id":"e05bca7f-c97e-42b2-a75d-fdded1101b44"},{"claim_cluster_id":"894e29d9-1e82-4e00-b1eb-e5092d46e327","event_cluster_id":"63342b93-bff9-4530-8c61-5a3714d544f1"},{"claim_cluster_id":"838e6a9b-36b6-4be2-87e8-cb3d0595dcf6","event_cluster_id":"4a121497-0e52-49d8-8aba-88f4fe1ef31b"},{"claim_cluster_id":"218a3fc7-ac76-4428-aa52-1f315a03667d","event_cluster_id":"6ad22c58-94f1-4426-8339-5bd33e29da9e"},{"claim_cluster_id":"0f106199-65cd-478b-af43-69825b16fa47","event_cluster_id":"81889b4e-a54e-4052-b2de-56a05ad20bc2"},{"claim_cluster_id":"a6d51f65-13a0-42d8-b6fe-66f9daf5bd01","event_cluster_id":"31fdbc6b-e989-4270-9e66-1ce2fea0d717"},{"claim_cluster_id":"6f473cd4-feae-4e71-a4f1-47b2820e799e","event_cluster_id":"54f0485d-be26-4b53-bcd8-2b1cb8ee52a3"},{"claim_cluster_id":"b247d35e-9452-4e26-8399-17fe2d8e1df5","event_cluster_id":"60cb910a-8631-4e58-9913-f906c1b2084a"},{"claim_cluster_id":"ce4379b5-864c-4150-b826-c6825e39d887","event_cluster_id":"a1ffb94b-ce0c-4994-8b4a-5885dcc09a67"},{"claim_cluster_id":"b4ee4418-ee26-4134-986b-8e220ef5da22","event_cluster_id":"37f90fa7-4e1a-46b6-b513-6bfba31c2cf2"},{"claim_cluster_id":"0bdfd962-fc80-4c29-8a9f-545619ab3653","event_cluster_id":"e297a044-750d-493d-8fab-439c72fd77f6"},{"claim_cluster_id":"516d27f7-0cda-468f-b3b6-27af200d408b","event_cluster_id":"71236786-30d7-40e5-8b9f-3cc8f5e06fd8"},{"claim_cluster_id":"d08db747-1994-456e-82f1-cca372892842","event_cluster_id":"0212de6c-9c69-4316-ae96-331158f2438a"},{"claim_cluster_id":"94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"d232b59a-12d7-48e0-9945-60749a40e538","event_cluster_id":"cc256628-cc7d-493f-98f7-e2382cb4b346"},{"claim_cluster_id":"8ba29c52-b42b-44a3-86e2-12fd13d42596","event_cluster_id":"eafe4828-2ad9-4259-92a7-b6017492bd06"},{"claim_cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","event_cluster_id":"6ecdc168-b4c6-42e6-a45f-27cde46257e5"},{"claim_cluster_id":"e6794d6d-e8b8-42e9-8f90-b2940e146fb9","event_cluster_id":"30cd928f-5775-4679-a8af-3acd8dd1a21e"},{"claim_cluster_id":"06dab846-f17e-48d2-94e4-d604af613859","event_cluster_id":"fa13d89b-1dff-4027-a91c-143971ebb4aa"},{"claim_cluster_id":"d5ad62ab-dd96-48fa-a092-0724cb0c06f6","event_cluster_id":"b5ae91f8-14e1-45b9-96d8-d01043f4d725"},{"claim_cluster_id":"ba4d4a13-eb59-48ce-b75b-0c214fe98953","event_cluster_id":"22f29403-f7fd-433f-b37d-85803cc6c208"},{"claim_cluster_id":"505519a5-a059-4c9c-8b16-ce6dffe7e678","event_cluster_id":"34a2bc3b-8f85-4670-8f29-4e2b139366de"},{"claim_cluster_id":"edec9892-cca5-4a34-b102-ebb0bb45e077","event_cluster_id":"0ac8de8c-821d-4fe2-90f7-e1d30911339a"},{"claim_cluster_id":"29009c7f-3a77-46aa-91c0-d0f703c52dab","event_cluster_id":"bf4593ea-9aa1-40b8-a424-04287ae58886"},{"claim_cluster_id":"d2b0388f-16f7-4c8e-a5ef-e7ed9f134aa3","event_cluster_id":"5fd9694e-e9ba-4a5a-99d6-b32c720bbf4e"},{"claim_cluster_id":"3db5575b-e4cd-4afc-835e-707980be99ac","event_cluster_id":"3035cab4-7bf7-4e5f-b8ff-717930d9caf2"},{"claim_cluster_id":"3d5e8f72-7611-4d2c-a35c-668790f97298","event_cluster_id":"97a63c8b-423b-4b4d-8ca6-262c543d514e"},{"claim_cluster_id":"49a8c8f2-03df-436a-8634-670fd40a145c","event_cluster_id":"019a31da-45d0-4ffd-a58b-773a16c0362f"},{"claim_cluster_id":"6d12ca3e-2e36-40ab-9cf4-0663df64745d","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"650bbf0e-b896-4929-a2ae-2f9899d4868f","event_cluster_id":"d640924f-577c-4904-972f-ea78d30a1b14"},{"claim_cluster_id":"32bf3674-86a6-4cde-a9e5-20a5e3965e02","event_cluster_id":"621f11b4-2ba1-45f0-bd1e-92caed87da0b"},{"claim_cluster_id":"86160f22-53c1-4e04-a28d-86c0e883fa44","event_cluster_id":"9b0d2d04-ff3d-45df-af3c-018b55e1eabe"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"77f85883-e69f-43a1-9e7c-0df03c9438b4"},{"claim_cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","event_cluster_id":"0b7703f0-770f-46f4-8c70-921a8b6b2ad7"},{"claim_cluster_id":"20eecf26-3fb0-4e96-b07f-0dfffef9c628","event_cluster_id":"99775dd2-fc60-40f8-87bb-cfdaeb07bbae"},{"claim_cluster_id":"7cc752d0-c62a-4657-a1e6-4213c5baa7cf","event_cluster_id":"14db711f-b761-4a49-a9c7-2b0c0895c032"},{"claim_cluster_id":"0f8d7640-e263-43ac-9294-0e526087824c","event_cluster_id":"1d1ebfc5-8408-4d3f-ae15-fa5d518e6407"},{"claim_cluster_id":"b45686ea-2849-48a8-b658-78abebbff1dd","event_cluster_id":"878ab8c3-2760-46b0-8086-c8aa996e56bc"},{"claim_cluster_id":"5b0ba6ac-d65c-49f0-9ed7-62610378c0e1","event_cluster_id":"a9f4e598-1ac2-4a32-9af3-12230870507a"},{"claim_cluster_id":"39f5f705-55d1-4470-8928-bfce04d4f7be","event_cluster_id":"bacd83d6-baf3-4811-8b78-eb961f99ab8f"},{"claim_cluster_id":"0efb6dcf-79b6-4c7a-8e8c-3a69e1f3799f","event_cluster_id":"0d3db024-9b87-4816-98d7-172f0864bf36"},{"claim_cluster_id":"4b37762b-26f0-4956-9d1d-e433973602e1","event_cluster_id":"0d5de813-beee-4fba-8db1-09461ff50d02"},{"claim_cluster_id":"de30ed78-2cf8-480b-aacb-665d9572f1b4","event_cluster_id":"9a05cb71-dda4-4c46-862e-16d08e1809de"},{"claim_cluster_id":"d60742af-37a3-43e0-afb8-5df777dac64e","event_cluster_id":"696c75fe-b8aa-4f76-a6f1-267a591b7b7b"},{"claim_cluster_id":"bfd0fa79-f057-4e1b-abfc-222496dbeabb","event_cluster_id":"f51d8559-af8b-4da0-bbbe-5eb4dde41ccd"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"29477fdd-bbbe-4e39-b779-19de18778240"},{"claim_cluster_id":"43de0036-79a8-44f6-b066-25424acf3535","event_cluster_id":"11875278-ef5e-43b1-8558-2410f47e68af"},{"claim_cluster_id":"5f10e7fa-9adf-4e59-961b-ac04facb9f2b","event_cluster_id":"04e99e38-59fd-4613-8ed1-1ec10ecc384c"},{"claim_cluster_id":"99955509-35d5-4623-b165-0b6dc4f83f23","event_cluster_id":"bd30dba7-ded3-462d-90f7-5fc4ff649bd4"},{"claim_cluster_id":"4c95b4a9-d005-4c7c-8a55-a5a0821d7611","event_cluster_id":"690596f3-57f6-4044-a245-63584bb2f8ea"},{"claim_cluster_id":"292629c2-32f2-451e-b64e-e8f73bb87975","event_cluster_id":"21518841-2c46-4292-abad-aff342a4f1ac"},{"claim_cluster_id":"4180dc5e-36b2-4900-9bf9-c6ecf67fdc08","event_cluster_id":"76557fca-1139-4be6-b8fd-797e3828c438"},{"claim_cluster_id":"664823cc-3309-42a4-9224-e9eaa7ee3fe5","event_cluster_id":"1e66818d-6709-4941-8387-4e813b228894"},{"claim_cluster_id":"9c52e5bb-8493-4b3c-8444-69598adc8932","event_cluster_id":"8c5f2bf0-92e9-41c9-b66d-14747ba819d6"},{"claim_cluster_id":"a5744137-28c3-42a2-94a7-6f90f74e8a86","event_cluster_id":"27647283-49db-4a69-bd08-66190d0e650e"},{"claim_cluster_id":"634ebbc5-474d-42c0-bf34-498666dade49","event_cluster_id":"bfe09009-b8ac-46f6-854c-5d83a7ad4a7f"},{"claim_cluster_id":"6b38f355-a80e-4449-8c83-c5ac56d5a2e6","event_cluster_id":"d673001c-8f3c-4ad3-bd60-90a9445c79f6"},{"claim_cluster_id":"3d52b30c-fa0d-4a4c-9240-38abdfc6ab20","event_cluster_id":"6c82fce7-dc95-4a42-b643-38f90297f22f"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"daf13a88-450f-40a7-bca6-ccfb46ede159","event_cluster_id":"104cce1d-7dd6-445b-b83a-f1e498dd3f09"},{"claim_cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","event_cluster_id":"3e95ef61-306a-4cf0-a217-5b910e8ffc01"},{"claim_cluster_id":"ba6f293a-cb12-4697-ba51-b7964934f25d","event_cluster_id":"997ed426-7093-49d8-afde-97f5ea1d37f4"},{"claim_cluster_id":"4350947c-093e-43d1-91ad-c33f75e13a1e","event_cluster_id":"64d91f5a-97ac-46c7-8034-7d2fcfc293b5"},{"claim_cluster_id":"71185519-3f2f-4171-84a1-11f08a933f13","event_cluster_id":"d8fd9aa7-8b30-418d-82de-88746b18d64d"},{"claim_cluster_id":"77763430-7d23-4e23-9288-5fdabfddb4bf","event_cluster_id":"b61e836a-7b6e-4f27-85e3-ad2994cac010"},{"claim_cluster_id":"5d657ce1-e484-4e48-b720-f4927cd733dd","event_cluster_id":"b8e15d0d-b6bd-4105-9d0d-28c9c1a8c47e"},{"claim_cluster_id":"6c2771d0-bfd3-428e-a6d5-47a3f027d3a6","event_cluster_id":"c498b99d-fbf7-4e48-9c94-6d92541e239e"},{"claim_cluster_id":"770fcc6f-66a8-42c3-adcc-243f958e2049","event_cluster_id":"88ac8370-087f-4a90-8111-103d9e01fd10"},{"claim_cluster_id":"d3b98f44-6b27-4d30-a29b-fd80c7643f1b","event_cluster_id":"e2b1886a-d41d-4169-be53-e4ed1b6d9d79"},{"claim_cluster_id":"38bae771-edb0-4c72-84b7-885ee4da4419","event_cluster_id":"95b33dd9-d9c3-4168-aeae-fc027379013c"},{"claim_cluster_id":"ba4d4a13-eb59-48ce-b75b-0c214fe98953","event_cluster_id":"8463c208-4f6b-46d2-8aa4-c6b2f82bc799"},{"claim_cluster_id":"e8bed2a1-875c-4017-abd5-83f756e2ceb2","event_cluster_id":"d2dc78d1-ae53-4ed9-adc5-5e6752f3a1b0"},{"claim_cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","event_cluster_id":"6c5b6495-5a45-4608-8917-e96bd2fcb820"},{"claim_cluster_id":"09a92b68-8f29-435d-b853-f4c47f64d9da","event_cluster_id":"770085f4-c156-40e9-85de-d0bb720ad51c"},{"claim_cluster_id":"df65bddb-06ed-4815-9cbc-5ae170dbdeae","event_cluster_id":"6bd47b8f-99ce-47e4-9910-46d2ae0dd574"},{"claim_cluster_id":"08dc80e4-6332-48c1-99f1-a1bc6a88f48b","event_cluster_id":"5014d6b5-2e76-49bd-95af-b599a74c0052"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"b7c58dbe-be1c-46e8-b987-6a07d4c0753c"},{"claim_cluster_id":"f0d99bfd-e20a-4b87-9be0-a227af6f681d","event_cluster_id":"33b11fcf-85c4-4c95-b81e-d603bced718a"},{"claim_cluster_id":"9c68ef9f-53c9-413e-b008-51e352564820","event_cluster_id":"381be24e-814e-460f-aaf7-24ebc78ab4d4"},{"claim_cluster_id":"6b38f355-a80e-4449-8c83-c5ac56d5a2e6","event_cluster_id":"7f5ce29d-718d-42a9-af2b-7bbc25320894"},{"claim_cluster_id":"388dcf56-c13f-4ec5-bbc7-b3c71eaffd35","event_cluster_id":"fc384be2-9fa7-4507-96ed-913cfeb3e5bf"},{"claim_cluster_id":"e13e75a2-63ed-4bf3-909e-11338445410f","event_cluster_id":"46b03cb2-bbc6-4b28-b240-16cc3f30e3bc"},{"claim_cluster_id":"323efa20-d8ad-424c-9c0e-ac5d255b9276","event_cluster_id":"f37e4c75-6082-4bd0-a321-a0f77cf2c5cf"},{"claim_cluster_id":"4e71d535-1646-4ea5-9c47-04fb1464f390","event_cluster_id":"ce87133c-df51-4ce0-8569-5d86ba96f3d3"},{"claim_cluster_id":"16667fe1-8cf7-4fec-9aa8-c5bb30920e90","event_cluster_id":"41d69a2f-db55-4c96-81a9-27bcb85442bc"},{"claim_cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","event_cluster_id":"c64955c1-2c6f-41ba-ac81-974a3b1eb981"},{"claim_cluster_id":"93429ef7-e07c-4686-85f7-679d49d1274f","event_cluster_id":"a7d594c1-3fc6-43ed-8545-37320216cb3f"},{"claim_cluster_id":"69fa7886-741a-440f-8a20-2b9ce60729ac","event_cluster_id":"876e8e24-c321-4738-b179-b28d55e4c79c"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"46d5760c-bd0b-4c2e-8270-d2debd9f3dcb"},{"claim_cluster_id":"992ef0ee-f6fc-4177-b75b-0a3511a615a6","event_cluster_id":"34a1b507-fb03-489f-a79e-be687aeaabe9"},{"claim_cluster_id":"a5114ace-99b6-4b39-875b-8b7056c70002","event_cluster_id":"612d697f-8136-4aba-a8a7-d6de87a2c992"},{"claim_cluster_id":"71acf2d0-be7b-4d8e-b3fc-93baaa073aa1","event_cluster_id":"3d95e05f-6c78-4338-9960-bbc4049a682e"},{"claim_cluster_id":"2d2ebd07-a80d-4a48-b320-cc68d39bdc10","event_cluster_id":"c695ae29-6241-4eba-94f9-8224687bf1a7"},{"claim_cluster_id":"2ebece0c-e502-49a9-94b9-5df90f1b8e51","event_cluster_id":"08918774-fef7-4ef6-9e14-8a7abce1a23c"},{"claim_cluster_id":"2d5d8472-462a-48f6-89fe-e8182a74e9c6","event_cluster_id":"3b28fd20-f6ec-4932-9943-984312470724"},{"claim_cluster_id":"1473286e-ca60-4128-b82b-a6695a32595a","event_cluster_id":"777f1392-cb45-4f46-9166-db9e19c26beb"},{"claim_cluster_id":"45803076-0698-48ef-a2b4-10f190885998","event_cluster_id":"c59b0f7e-3d57-4bed-a62c-40ef9b2d80c1"},{"claim_cluster_id":"528a9885-82c7-4bee-beac-f85e4c7c3f1b","event_cluster_id":"771ff184-5478-488e-90da-69f2d3b1dfbb"},{"claim_cluster_id":"9a03a84a-f375-4382-bf36-e4f5df1b4795","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"304f9508-2cf0-4ef2-b524-7a5c78978d94","event_cluster_id":"247c6528-f0e7-49f9-99fb-27ef047a4410"},{"claim_cluster_id":"8bdfe7c6-73b1-4b58-bf5b-82ec50117cd4","event_cluster_id":"b006c022-e811-42d8-ab1c-bed9f97e066b"},{"claim_cluster_id":"50967b88-5546-4fd0-9e1b-6bf235297b83","event_cluster_id":"1352c5e1-e3f4-4bd5-a309-04804d3a9c0a"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"0d1f3710-22b1-4ca4-9501-1c3095b8199a"},{"claim_cluster_id":"c03b0c98-53e3-4757-8e78-30293d823fdb","event_cluster_id":"1e7fb3ce-6e1c-49dc-978d-4116378d449b"},{"claim_cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","event_cluster_id":"6a03d110-92cd-4da9-913a-56888b17641f"},{"claim_cluster_id":"a837b2bf-502e-4024-b245-761701b0a6d5","event_cluster_id":"9288082a-2c01-4b74-9421-1882494878c4"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"c021fe18-c42c-443c-8de9-a7f8d58891f4"},{"claim_cluster_id":"c9367bb7-c2e3-4341-a799-6ff36d655556","event_cluster_id":"63be6506-f9dd-4d4c-86f5-e451710401ef"},{"claim_cluster_id":"642bd570-9063-4bca-8050-702e322b8b3c","event_cluster_id":"f9c2516c-da15-44ca-94aa-e9d013d3a430"},{"claim_cluster_id":"5a50a1fe-c68d-46bc-b14a-9fe07afb2e36","event_cluster_id":"bf2b7ba7-a6da-4f7a-bc58-63ae1a3267de"},{"claim_cluster_id":"235bfc4a-e3f2-4850-83c2-a78043ab464b","event_cluster_id":"076ca314-f50f-433c-a148-2b657f0a88ab"},{"claim_cluster_id":"1db866e4-0f7e-4d67-93e0-8d1068f0369d","event_cluster_id":"7cc54def-6358-42e1-9afb-ba0b2ba2ac2c"},{"claim_cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","event_cluster_id":"f10425d5-24f2-425f-821e-7acb93c9e53b"},{"claim_cluster_id":"d41663c0-a43a-40f6-ae8e-9e6eeb720de9","event_cluster_id":"8ec3865c-7644-4e06-bb0d-00ab782e6cd7"},{"claim_cluster_id":"83605bab-42d6-405a-ab45-fb6b68e0609c","event_cluster_id":"03fe8498-7679-447a-af5d-563e12790d0c"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"ca92e9ac-f88f-40f7-8676-383e3ddbcb77"},{"claim_cluster_id":"2d2ebd07-a80d-4a48-b320-cc68d39bdc10","event_cluster_id":"2bfb03ed-8bb2-476c-9ace-087ef4a35f09"},{"claim_cluster_id":"97e28e03-c0a3-40ba-8418-88973425525a","event_cluster_id":"ca3c690a-ee2b-4679-9ac7-f2f87ab00ae8"},{"claim_cluster_id":"c9367bb7-c2e3-4341-a799-6ff36d655556","event_cluster_id":"6b0217e7-2354-4152-81ca-d64e5b080b90"},{"claim_cluster_id":"469c5194-5b04-4e90-b62c-73b3f79a0955","event_cluster_id":"3c52b26e-a9d9-4bd3-979f-3455beaaaaec"},{"claim_cluster_id":"12ff0964-4c5c-4f91-8269-1e4ab61e9602","event_cluster_id":"8f75e655-8582-4cb0-9320-47aef61dad78"},{"claim_cluster_id":"c75e8276-e126-4693-a87d-4d748183e6fe","event_cluster_id":"5e94868b-1054-4680-801c-eccafab6e048"},{"claim_cluster_id":"8948b384-0046-47fe-bc91-7f2737b00557","event_cluster_id":"a67c3f7f-a1ca-4dac-ba63-61ecd0d76ed7"},{"claim_cluster_id":"38bae771-edb0-4c72-84b7-885ee4da4419","event_cluster_id":"01d21517-243e-4d94-b9c5-641f8bca7cbf"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"b8208758-3ffb-41f1-97e7-30e90da08e44","event_cluster_id":"a9f14778-a0da-48d5-9d93-8fa7cd7361ec"},{"claim_cluster_id":"23adc402-b3b7-489f-bbe8-5d7825946d77","event_cluster_id":"b6efa0ef-9a52-43da-8c24-a3f10f0aaf37"},{"claim_cluster_id":"6d7d1320-a896-4471-aa98-60a45946bc57","event_cluster_id":"f13db706-0347-473b-9857-0fcfd7adeb37"},{"claim_cluster_id":"a7a78172-b61a-41cd-a089-5fdf5b5e9fdc","event_cluster_id":"2bb22d37-82ad-420f-8b9d-f5e541da469b"},{"claim_cluster_id":"6c812e58-19af-4264-b856-e922307ab466","event_cluster_id":"e228a8c4-9bff-4634-a77f-16ed4aba6a89"},{"claim_cluster_id":"a4d61819-30e3-46aa-ab08-cf879db00de1","event_cluster_id":"13e53d6a-9b30-4b10-9f27-0687c15666b8"},{"claim_cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","event_cluster_id":"49854b0f-e263-4847-a942-d2497d0d1530"},{"claim_cluster_id":"7e1a378e-1366-4ff2-9282-46ddc9975cc6","event_cluster_id":"a3b6f394-159b-439a-a766-38bc59e64bb8"},{"claim_cluster_id":"de4f148f-cf69-426b-b5bb-f722fb88313c","event_cluster_id":"7512ed6a-dee9-4a0a-b3bd-71a36d7ff111"},{"claim_cluster_id":"d21ce376-5e68-41d1-903e-db8ea2f295f8","event_cluster_id":"582e1668-0621-414e-a531-9d7ad55393e8"},{"claim_cluster_id":"ba035925-8a5f-42d0-aec3-c91702a47b8d","event_cluster_id":"4cb90529-ce16-437b-99b6-c2cd5dcc786a"},{"claim_cluster_id":"452589b4-0af9-45d5-aee2-979a0dc78876","event_cluster_id":"473a62f7-a375-4113-841d-d6bbd59826b2"},{"claim_cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","event_cluster_id":"d64f3c9d-c55d-4ebc-9a01-43d63af153f0"},{"claim_cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","event_cluster_id":"27c3b9de-4f86-4091-b50b-7314a2636d6c"},{"claim_cluster_id":"cb239c20-3722-49db-94a4-29c15a45d8b1","event_cluster_id":"71c1ae12-8809-47ac-8b8b-cc34ac436157"},{"claim_cluster_id":"e370d332-674b-403f-8471-184685b21c55","event_cluster_id":"83314d81-ffc5-42be-b8ab-fc7049a1e48f"},{"claim_cluster_id":"4cb70cfd-308b-45d4-a6de-94896ddf47a0","event_cluster_id":"8f35aa71-39a9-43b6-9e1f-9db20e05a30e"},{"claim_cluster_id":"928cf7ca-8343-47ca-be27-378bc29b7fbe","event_cluster_id":"3349d8e0-ebe5-4359-bb8d-083c8d3a9420"},{"claim_cluster_id":"de7b2349-3e46-436f-9b75-c57089eeaa3c","event_cluster_id":"739c0bc4-1bf3-45d5-b4d4-587c8689dc5a"},{"claim_cluster_id":"45803076-0698-48ef-a2b4-10f190885998","event_cluster_id":"719750be-a238-45aa-96a8-065dfd797981"},{"claim_cluster_id":"e207b7c6-a3e8-4aa9-801f-8f0ee8dbdb37","event_cluster_id":"1d3c886f-bc05-43fd-9472-810156e4edfd"},{"claim_cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","event_cluster_id":"414df1fb-6d9e-4aff-a35e-819202fb6c05"},{"claim_cluster_id":"252d476c-5ce3-4a28-9ab5-6406955b15b2","event_cluster_id":"5ac2f931-1ef9-4c96-8568-845f2751d03d"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"88bb793a-f03a-44d3-bc64-124f3010e3b7"},{"claim_cluster_id":"c7eb5329-6775-4d3f-aea7-7de4fbeb8175","event_cluster_id":"a08b7547-a0f1-452b-9b55-18b72ad44763"},{"claim_cluster_id":"f57f4c9e-1d41-4f34-b42f-aa11437d6812","event_cluster_id":"2f5e01bb-8b8d-4570-9736-c9caf60706be"},{"claim_cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","event_cluster_id":"a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"317ae87f-a4ca-4e46-9ff8-1bebad9fd04f","event_cluster_id":"3f25c082-1585-41e9-8842-37a9e6419694"},{"claim_cluster_id":"7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1","event_cluster_id":"c46b62bc-7cc2-4635-bcb1-86c242f419fc"},{"claim_cluster_id":"d6705dc8-8def-4060-882a-9c13b62a23ad","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"5bf16a7e-5a24-4ae1-9df6-b91d3f92f3c6","event_cluster_id":"ac2c361f-32c9-4d71-8c96-6c8953a04d75"},{"claim_cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","event_cluster_id":"e228a8c4-9bff-4634-a77f-16ed4aba6a89"},{"claim_cluster_id":"e045b8f3-c755-4ad1-91b0-a0b8f7878680","event_cluster_id":"64d37d6c-89cb-4974-81c1-3b1735939788"},{"claim_cluster_id":"457d88a0-1b8d-406f-8eeb-01fdd00cdc30","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"1c703565-77f6-4eda-962e-77ec869d886d","event_cluster_id":"ad9e7a2b-7924-46d4-ba72-1397b5c0801b"},{"claim_cluster_id":"b1abd415-ce48-46da-b8bf-36f727bba7c7","event_cluster_id":"72967666-4eb9-48c4-a9dc-dc51036d287d"},{"claim_cluster_id":"075f7aea-756f-4e67-bf46-f4305230821b","event_cluster_id":"a5b4fdb0-8d5b-49c2-aabd-e64213ff8027"},{"claim_cluster_id":"035bc55a-3ae4-48b4-942f-bbef3d308147","event_cluster_id":"5dff1a24-a2b6-4405-a930-eab85cab0d38"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"da1930dd-8986-4fa6-b320-dd6da70d644c"},{"claim_cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","event_cluster_id":"5502f4b5-10c2-450c-b072-20a0d153fef3"},{"claim_cluster_id":"df20aee7-4e88-4c5d-a2d1-ce862c311713","event_cluster_id":"2f3684a3-db51-45d5-8ab6-a0d061f2a667"},{"claim_cluster_id":"a990d90c-b1b0-4148-b047-5b63c9eb7a78","event_cluster_id":"eb6bb91c-6bc8-4c0a-9783-baf41ad32ae6"},{"claim_cluster_id":"8b44daa7-629e-4db8-81b7-5ed88669eb86","event_cluster_id":"4d6eed7e-0404-4ccd-92b2-df5956550e67"},{"claim_cluster_id":"45931062-6efb-4850-9df7-4bff0b9b4a16","event_cluster_id":"177da242-e804-4b06-8955-3e43352e0145"},{"claim_cluster_id":"ab52850c-7dc5-4f99-b37e-0c628b078043","event_cluster_id":"d87790ba-a7e4-42b2-87ee-50115287f374"},{"claim_cluster_id":"38b659e5-9f63-40c6-bab6-c8934148aa21","event_cluster_id":"efbb863d-f52e-42f9-a671-9fa0b8c1b1fb"},{"claim_cluster_id":"bcc578f8-a745-46e1-ac64-5315a3ec6900","event_cluster_id":"9ed0391b-e831-497d-9d87-ba9ea12680b7"},{"claim_cluster_id":"6c812e58-19af-4264-b856-e922307ab466","event_cluster_id":"5eaa7b8f-5e2f-4cc2-827c-b780c20bc557"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"04a0ae4a-7a1f-4b83-aea9-9fb4dfa80e1a","event_cluster_id":"ef20ba46-c8c3-4085-85f9-b312f9f6802a"},{"claim_cluster_id":"3ea6c360-e1ff-4b61-9454-07814cabc76c","event_cluster_id":"6f715c79-5b97-43d0-a5c3-09848b08ceca"},{"claim_cluster_id":"baa70e51-5ce2-4e6f-8994-d85027e6b1d9","event_cluster_id":"99b6af80-6889-4032-9dda-54d5dbe1fafb"},{"claim_cluster_id":"eb68c709-6220-48fe-b376-95a4f6f10b6d","event_cluster_id":"33b55b1e-2a6f-4f56-affb-50cf2ec05471"},{"claim_cluster_id":"07bacc2e-cf13-4467-917c-ef3c2aa505ca","event_cluster_id":"bfff8af2-9d27-4503-baf3-3e1618c9087a"},{"claim_cluster_id":"0961c365-4261-4c91-984b-81c62260d807","event_cluster_id":"230bb8e2-d4ad-487c-a1d7-42ba2ea0e5cc"},{"claim_cluster_id":"f75e1405-c093-4f18-a3c7-d59d8bfe94d0","event_cluster_id":"991efb3f-2e53-4e93-bf2d-3ba713b91c23"},{"claim_cluster_id":"483b6a3b-d48b-40f7-b28f-e79dfca268e6","event_cluster_id":"3addd54f-eb0f-4cbc-93e6-9436080208cb"},{"claim_cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","event_cluster_id":"5d1b0403-1447-4432-b6a8-ce335ce3e162"},{"claim_cluster_id":"226f9322-c9c6-4f2f-948c-b45757d94aa7","event_cluster_id":"2ef5fcdf-761e-402d-8549-a04bd0b86028"},{"claim_cluster_id":"b777a261-40ed-4845-9730-51d3661e3377","event_cluster_id":"02502121-c7d0-43b9-afe9-c557963c5283"},{"claim_cluster_id":"73184e14-aff1-4c97-a2f0-0508b86fc3db","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","event_cluster_id":"d316d167-369a-4e0d-ad58-337551778176"},{"claim_cluster_id":"1e19ebda-0ce5-4c42-b6ac-f081acdf5974","event_cluster_id":"1ba7e666-27ba-4d77-b5a9-dc9f10927af0"},{"claim_cluster_id":"59e6bbb6-5982-4df0-b59c-33f07ce159f4","event_cluster_id":"e3c9a6ab-aa8e-4a41-9385-a9d893d2acc5"},{"claim_cluster_id":"762409bf-96e2-43cc-99d8-45783ade1b1f","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"eea02be7-fd53-47b5-9804-7a2f89de23f2","event_cluster_id":"0f0292cd-5ed9-4b41-be37-f307be9f4e80"},{"claim_cluster_id":"b840591d-33a5-402e-9f7a-8913292b283e","event_cluster_id":"1b8d5fdd-83db-44f0-aa44-0aa853c3b3f8"},{"claim_cluster_id":"db6d1f55-1378-42e6-ab38-0b1046e37cc0","event_cluster_id":"7b66a014-a3c8-4296-b622-d0e9055b14ee"},{"claim_cluster_id":"763dcb28-8161-4ef1-bcee-20cbd6af7670","event_cluster_id":"997b6294-e973-4686-9dd3-38c8184705a9"},{"claim_cluster_id":"b056d050-cc91-4967-a6df-ddb4af36891b","event_cluster_id":"b785d99b-0340-4f57-a54b-f08a5b415aa2"},{"claim_cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","event_cluster_id":"7354cd90-5ded-45c2-af70-b5cea1cc0045"},{"claim_cluster_id":"218a3fc7-ac76-4428-aa52-1f315a03667d","event_cluster_id":"07d6842c-fb2e-407d-bdda-a29d80ba013b"},{"claim_cluster_id":"c7013046-8aa1-434c-87b8-1e3317f5578c","event_cluster_id":"6a85e8dd-d86f-4e00-b252-62364be2e0ab"},{"claim_cluster_id":"02fc2c1c-e5e4-40d6-92bc-a975544e0e30","event_cluster_id":"8d34ac69-abf2-4d47-a080-a43806db5b67"},{"claim_cluster_id":"f236d68f-fe39-4432-9a36-341eb8900ee6","event_cluster_id":"f7318431-bfb5-4f5f-a2ea-e4c01a34de08"},{"claim_cluster_id":"f72eb4bb-112f-4556-a279-ad745cb4894c","event_cluster_id":"16bcd20b-c8b6-445d-b90e-bca2498ccc21"},{"claim_cluster_id":"f18ec76a-50ba-422f-9d7a-596708b1810a","event_cluster_id":"a663162f-90e6-470c-9356-50de41099dfc"},{"claim_cluster_id":"506e309f-6f87-418b-b660-0ad635976c9d","event_cluster_id":"a42a7921-cdb2-4929-93b9-1642ac38cfed"},{"claim_cluster_id":"24d81b39-c399-4c59-ae9b-c84548655d0b","event_cluster_id":"240e1f26-e6d5-488e-ad06-f573f8486dce"},{"claim_cluster_id":"908a4168-b322-4057-a44b-a100dbffbe53","event_cluster_id":"0dae78f8-77aa-48f9-a01e-03b3a39b4e44"},{"claim_cluster_id":"c8956774-b873-4e48-aca4-1d4ce1428a6f","event_cluster_id":"d5ffcb4c-8c79-4cc4-868f-bca69bb676c5"},{"claim_cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","event_cluster_id":"712fa0e5-9886-40f6-b761-bb1a99d5fb8c"},{"claim_cluster_id":"6dfdb047-f69b-420b-87ec-fbcb72244cc6","event_cluster_id":"f98ba1e5-efa5-4a15-9a39-7050f0a81013"},{"claim_cluster_id":"e129ef72-bb79-4915-92ec-e1ad0c220280","event_cluster_id":"5661edb8-2d76-4ef2-88fa-1ef3a23ed765"},{"claim_cluster_id":"be7f1195-f177-4bc7-91dc-0cfb479ebb8e","event_cluster_id":"32b69cec-10c5-48a9-adbb-1a38afa40ede"},{"claim_cluster_id":"89d92c43-6368-4ce1-8b52-63274b65d5df","event_cluster_id":"66723b88-51f0-432a-9dff-39c845623093"},{"claim_cluster_id":"7370b2ae-5bd2-49ba-aa3a-effafe4334a0","event_cluster_id":"b2b194c2-f397-4e76-bb84-c8a37964e533"},{"claim_cluster_id":"c94810e3-5711-44bc-a55f-5ef59645cf78","event_cluster_id":"d77c268e-3ade-486d-9ca6-faf269499c35"},{"claim_cluster_id":"1a689731-c588-4661-b0b5-8beb94a95bb4","event_cluster_id":"3a3218a4-ce54-4e61-9c08-41f52d8bf517"},{"claim_cluster_id":"4f68034e-7758-4136-94fe-82331ab7df47","event_cluster_id":"f1ae2273-40a5-4bb6-b66e-75189e06260e"},{"claim_cluster_id":"68617739-11a1-4108-8d8c-6d8db53fd247","event_cluster_id":"efe217b1-d8a9-48f6-b1d3-7579e75d7788"},{"claim_cluster_id":"f02faf57-c72f-4377-8759-469d56737085","event_cluster_id":"d327e87e-5fd2-4607-86c2-9433a227a64c"},{"claim_cluster_id":"d0619b32-28c7-4624-9e6b-8c81d9ff9019","event_cluster_id":"fa2c7516-f196-48a1-815e-d89c4e4b9860"},{"claim_cluster_id":"34e272f8-beb9-408f-a252-0fa71406dc4b","event_cluster_id":"ceb93865-c529-4780-afd0-1e69709b13f3"},{"claim_cluster_id":"02774183-9d71-4dfd-8f60-b54cf275fbb8","event_cluster_id":"95138155-e999-481e-8c57-056be5d97867"},{"claim_cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","event_cluster_id":"389bf865-85bd-4767-9053-03a5fcae6a23"},{"claim_cluster_id":"2ca08905-d2cc-4e5f-80b6-1f1b64356b18","event_cluster_id":"a2109d36-1708-4075-ac3d-fd40a7eea59b"},{"claim_cluster_id":"f731bc0b-cabf-4314-a5f8-e94d31589cea","event_cluster_id":"20d5e5ed-4ce5-4a63-9b10-3e468d3431e2"},{"claim_cluster_id":"43fb6e85-e148-46ac-99f5-6e9cc985487b","event_cluster_id":"55822882-d3bc-4c00-a9c9-30a5c71ddf43"},{"claim_cluster_id":"35218630-91b1-47a4-87cf-29094bd87289","event_cluster_id":"346b1dc3-219c-4228-a017-da35814deb33"},{"claim_cluster_id":"380726cc-73a4-4dde-ac40-f10c2a1f6e60","event_cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"35d3b29d-3d0c-4461-8663-4b180f0aaa41"},{"claim_cluster_id":"3a5853fd-eaf4-497d-b7fc-b13a9208544c","event_cluster_id":"8bda5e73-cd1a-4ebf-b3bb-55b54ec157d7"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e"},{"claim_cluster_id":"a604694d-4fcd-48e0-a074-6eaa09488a89","event_cluster_id":"90a7e868-64e0-420e-8b7e-dbd99dcaae03"},{"claim_cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"939cc578-da0d-4d69-94b9-0a186537275d","event_cluster_id":"0c52c819-873f-4721-acb7-09c8239a9862"},{"claim_cluster_id":"b49a91d7-446b-421b-9670-7c99bbf5bc28","event_cluster_id":"f0144a0c-5ed5-434b-884c-c56dfe8a915f"},{"claim_cluster_id":"db91531a-0712-431d-a04b-9b798db3d3b4","event_cluster_id":"bc5a19f9-2b61-40ac-ae39-5951370b4cf0"},{"claim_cluster_id":"a89a4b7b-c64e-4a3c-81e8-86dec8a3dad0","event_cluster_id":"414847cb-46dd-4cd3-8ade-e04a5900b77e"},{"claim_cluster_id":"e0a99d28-f3a4-477a-b874-8d839c4523f9","event_cluster_id":"0a2e15ba-2fa7-41ed-a5c1-17b66869fc7d"},{"claim_cluster_id":"7e1a378e-1366-4ff2-9282-46ddc9975cc6","event_cluster_id":"1396142d-5fd2-4c3f-8a9f-e0d1627fb926"},{"claim_cluster_id":"d6b6cc03-8c7b-497a-ad1e-0435bb03fbcc","event_cluster_id":"bacd83d6-baf3-4811-8b78-eb961f99ab8f"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"2867ef8f-0ebb-45b2-b82a-289a3f763133"},{"claim_cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","event_cluster_id":"a144123b-7815-4a8e-939f-d8124e0d4a23"},{"claim_cluster_id":"aae7438c-bb2b-4e87-86b8-fc77cf6148d1","event_cluster_id":"8da88efd-932e-4ef9-ba62-12fc265d9255"},{"claim_cluster_id":"68617739-11a1-4108-8d8c-6d8db53fd247","event_cluster_id":"c5394d0c-cc56-4b26-835a-5c9581cceb3a"},{"claim_cluster_id":"ba694c90-be36-448b-9da2-f3ed0d816139","event_cluster_id":"f4f28261-ce76-46eb-a24f-4ced2c41d5f6"},{"claim_cluster_id":"73d871f6-e1be-43a1-b932-df733142abc7","event_cluster_id":"3035cab4-7bf7-4e5f-b8ff-717930d9caf2"},{"claim_cluster_id":"91e94583-4b9d-4847-9825-9ed7293c7a0e","event_cluster_id":"8dc116ab-03c9-451e-bd40-127719cd94fb"},{"claim_cluster_id":"d0228864-78be-4fd7-94b7-908de0276e80","event_cluster_id":"c4ef8aa7-0a73-4837-bdda-5894dfbdb7a0"},{"claim_cluster_id":"f4175686-5e4d-4fb0-a465-bed7586f6615","event_cluster_id":"4c182f86-5af5-4552-bee7-286b991ac0b1"},{"claim_cluster_id":"9c240f69-7202-4a37-b1d5-a3ae10dc5998","event_cluster_id":"927e3b68-c649-4b84-bd7c-c79eecd50812"},{"claim_cluster_id":"e7f02350-e0f8-416a-a3fa-4d7dfaaa5615","event_cluster_id":"2a04252f-e78e-41fb-93da-f1bb87ae8d3a"},{"claim_cluster_id":"07e66c00-a616-4a75-b1a2-efe8ff1edd22","event_cluster_id":"4724ac82-4846-4770-a7bb-6a4edd69c9dd"},{"claim_cluster_id":"19ef8fca-6a45-4387-be0d-efc3fd245b80","event_cluster_id":"f8814fc7-2279-4d32-a22e-1e33adf9e995"},{"claim_cluster_id":"3249ee55-684b-4bbb-8b52-6766f62838f9","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"ded98049-aef1-4b4f-a8a6-f68c10032b7f","event_cluster_id":"82025429-31a1-4168-809f-fb0e7a96b10b"},{"claim_cluster_id":"a0fab421-41ab-435c-b6c1-ee353c134771","event_cluster_id":"59fed447-7963-4349-9213-761a767fe70e"},{"claim_cluster_id":"cfda7d82-87df-49b1-8db2-82b62b174a67","event_cluster_id":"38118243-3439-45b9-b0a1-902687ba3cc0"},{"claim_cluster_id":"f8c898ca-36a7-47ac-838a-8091321433d0","event_cluster_id":"abfd51b8-1368-4f82-817b-9f3cd83502dc"},{"claim_cluster_id":"294ad0e1-cad9-4655-b7de-5e21de0e4797","event_cluster_id":"7ba06e8a-b878-421d-9b1d-d395213d16fa"},{"claim_cluster_id":"e5736d52-6864-4a19-aa95-57d6bbe8f40d","event_cluster_id":"77a0df8c-7608-483b-a706-3897667bbac6"},{"claim_cluster_id":"f9f7a124-b259-44e6-a922-abc880fe6775","event_cluster_id":"cc21b294-9fdf-4b80-a922-5a2fda24edfb"},{"claim_cluster_id":"43605210-6be3-4d52-9b42-d4a4a1838ade","event_cluster_id":"9fa0ae4f-fe27-4925-ae63-04bdfeb3953f"},{"claim_cluster_id":"fc4ce4ef-b019-44c8-8060-59b10a33a92b","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"fc64cbea-821d-4f81-89aa-1c161d723583","event_cluster_id":"f544e1b7-c2c0-4236-9e51-6a506ee25e3f"},{"claim_cluster_id":"3368fed2-7688-4846-a7ac-3bfa3045311c","event_cluster_id":"e354903e-091b-4412-9de6-d963f87ab883"},{"claim_cluster_id":"717225a3-f2cc-4921-bece-db76c2709d99","event_cluster_id":"a00b5c34-3d1b-444a-9f62-57418373c9c3"},{"claim_cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"f8dd8c42-86f6-44d8-b3e1-0737d8dfc6f3","event_cluster_id":"47924c3b-71e9-4d32-b64c-af3ed4408382"},{"claim_cluster_id":"9f4059ba-333f-4054-ba5f-f1cebaed747e","event_cluster_id":"9686ee9d-c6fe-4724-a86f-ea5424b54b58"},{"claim_cluster_id":"eaf8e34a-b1a1-45e6-bb84-a3cc8f00aeb0","event_cluster_id":"1a61f6e2-0fe8-4393-9f81-f3403bde43ac"},{"claim_cluster_id":"d7cbd37c-10fd-4628-bba8-b434c41ec43f","event_cluster_id":"c408b7c7-ef12-40e9-99e7-96b3a920e45e"},{"claim_cluster_id":"04ba7876-53cc-44c3-8149-fe7ba435f124","event_cluster_id":"e47f2b16-ab13-42c0-addb-b9a5881b56d2"},{"claim_cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","event_cluster_id":"bfee71d5-dc3e-4049-85bd-25e416b8ce0f"},{"claim_cluster_id":"bac292de-05f4-4fd3-a4df-f073c8f09553","event_cluster_id":"8ab3c3be-4d7d-4248-a148-6cf7cee2fef5"},{"claim_cluster_id":"099e4f99-da99-4f13-a242-dd05de802ab3","event_cluster_id":"17c6aa84-f614-46fa-bf43-265da2499cba"},{"claim_cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","event_cluster_id":"b10b3160-e0dc-461b-a456-f6327586eb6a"},{"claim_cluster_id":"d072d7ca-3280-4412-8e76-be63e36fe491","event_cluster_id":"4ab57529-2a41-4128-8cf2-496255864fad"},{"claim_cluster_id":"b4479b0e-003b-4796-9f06-dafafe7cc27d","event_cluster_id":"c1a62eb0-76d0-46fb-8060-6353e7306396"},{"claim_cluster_id":"3af9eb7e-1c8f-4ca9-987f-f38db6d11751","event_cluster_id":"d1aa87f5-6e8b-45d2-89ab-5267e8136707"},{"claim_cluster_id":"5c68cba2-8519-4f6e-b70e-fbda62c5445c","event_cluster_id":"64911a50-55cc-400d-9f35-d372b869e1a7"},{"claim_cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"5ee6d6d6-e296-4f40-9760-4a7737f5c631","event_cluster_id":"ea8f590f-f522-4ce0-8605-6700141bd308"},{"claim_cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","event_cluster_id":"89b0a4a3-f393-4706-9a25-8103c69b53d6"},{"claim_cluster_id":"6910074e-7bb8-4a4e-9f37-3e335d1a57a0","event_cluster_id":"f97d0f4b-71d3-41e4-97ea-bf25e10bfac7"},{"claim_cluster_id":"50967b88-5546-4fd0-9e1b-6bf235297b83","event_cluster_id":"5a08709f-1906-45c5-8ded-3d7e4a3851d0"},{"claim_cluster_id":"a39bfc74-5364-4583-b4c6-2ba30e1ddbf9","event_cluster_id":"e3188c04-70d3-4f55-ab68-49043c888c8a"},{"claim_cluster_id":"746a6f97-55c7-4dc9-ab6a-cc007e33449e","event_cluster_id":"7167c7d7-52bf-4753-8c56-a05326df7c57"},{"claim_cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","event_cluster_id":"84df1dd4-8c28-4b8a-bdf1-47af884e70e3"},{"claim_cluster_id":"fa484c7a-b508-4b38-90f3-04e6ca143d03","event_cluster_id":"5301f4d4-e78b-423c-a3a7-ca0fb632a3d4"},{"claim_cluster_id":"6015f261-315c-43b5-ae1a-b6f1ad2e1ce6","event_cluster_id":"c4bed539-a0aa-4ff8-9be3-4afa92598dee"},{"claim_cluster_id":"c8265999-6e3a-4835-bb5a-9e081a27e9bd","event_cluster_id":"05f4f7be-1927-40b1-a507-9bb7d746892f"},{"claim_cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","event_cluster_id":"b9cee305-a96d-440f-a08d-e2f6545e2608"},{"claim_cluster_id":"7bcfb80e-f4a6-4404-be69-078e88ddce1f","event_cluster_id":"204fc215-6ab9-4083-b883-b901ca6c7818"},{"claim_cluster_id":"818fb1f8-d14f-4997-8e8d-f7e228560c99","event_cluster_id":"f140fd40-63a5-49d3-9d17-1114828f483b"},{"claim_cluster_id":"7e265407-1dda-4e06-a69c-824b7e191f01","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"9f14caef-27ce-4bca-afff-6e691839a8df","event_cluster_id":"73ec670b-a1e6-4252-8fc5-cd613c026c27"},{"claim_cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","event_cluster_id":"9917626e-0afd-495f-82cd-6e27aa8cc73d"},{"claim_cluster_id":"ac6c3346-ea92-4da2-afed-ba431832d85e","event_cluster_id":"d9eedc94-d312-4947-bb37-d1fdd95dcdd4"},{"claim_cluster_id":"7ddce93b-3cfb-4112-a70b-f91eb14e7082","event_cluster_id":"312c4cbe-161f-46b2-ac85-87a06a693146"},{"claim_cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","event_cluster_id":"74e4eccb-d37c-4913-a081-5e2a47430662"},{"claim_cluster_id":"ff43bfb6-1ab6-422e-8045-756b71e70dd1","event_cluster_id":"d7349c27-6262-43ce-9388-35b7e8a7c225"},{"claim_cluster_id":"3ece6224-aab7-493b-83b2-1f9fc56d3136","event_cluster_id":"b4dd0b00-f893-486e-8f26-56d055b47620"},{"claim_cluster_id":"702a4627-2eae-451d-b2a9-154358319e24","event_cluster_id":"cefafa9f-3780-4e29-9888-658635c4bf8a"},{"claim_cluster_id":"6d2a1320-d829-403b-913c-d7cdbf1cbf14","event_cluster_id":"5ba8f9fd-9c3a-4fe9-8167-be994f757ac9"},{"claim_cluster_id":"4e71d535-1646-4ea5-9c47-04fb1464f390","event_cluster_id":"2be461a2-6406-4213-9577-fc7e617af34f"},{"claim_cluster_id":"7659f671-e41e-464a-9184-a08b114b3636","event_cluster_id":"f19998d7-da9d-4ad2-b0f0-03ca5c82143c"},{"claim_cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","event_cluster_id":"bcbfb3b5-386e-4a9d-9149-63379d147048"},{"claim_cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","event_cluster_id":"75c9220d-327e-40e0-adbe-2a476a0c2f1a"},{"claim_cluster_id":"be023ca2-f865-4811-854e-b40ab442412b","event_cluster_id":"8d692cd5-28be-4ffe-a181-b8bc827723ec"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"43605210-6be3-4d52-9b42-d4a4a1838ade","event_cluster_id":"d5f197ec-3802-460d-9ad7-c43d150d3ad0"},{"claim_cluster_id":"5e128621-af42-4a93-b091-b4e768efec3b","event_cluster_id":"03633b9c-b0d8-43dd-b075-5cdc7b02727e"},{"claim_cluster_id":"59e7addf-52f2-469c-800e-61bb55f3ed47","event_cluster_id":"cd47012a-5cc7-45af-9355-7ba2b5b641a1"},{"claim_cluster_id":"65ea2c99-1a78-4321-b690-79dfaf78e443","event_cluster_id":"5f916a06-e83a-45ea-99cd-e223f21451ed"},{"claim_cluster_id":"908a4168-b322-4057-a44b-a100dbffbe53","event_cluster_id":"54e77970-df08-445b-a795-2987113391fb"},{"claim_cluster_id":"9d39778d-eb5c-4c0e-b35c-894a4378bc37","event_cluster_id":"bd47afb3-5229-4410-873e-9a50752f0292"},{"claim_cluster_id":"ce659db6-9043-4f18-a410-39321ba5fd81","event_cluster_id":"9be4b289-aaff-48fa-8680-b2813e6b1340"},{"claim_cluster_id":"61152334-8dda-42a2-bb8d-9fb770fd72f7","event_cluster_id":"4cf126e0-d7f3-4437-b125-365b11c65d70"},{"claim_cluster_id":"29fe240a-81f6-4aef-a8b5-3cacf3e3985a","event_cluster_id":"b02337c9-83ca-426b-b987-f46d1d19a244"},{"claim_cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","event_cluster_id":"008cba92-e4d7-4655-90ad-12cb214fe197"},{"claim_cluster_id":"8a12011e-a6e7-4e73-a321-a39426ec3d34","event_cluster_id":"7b1f2cfc-5328-4132-ac99-4d91818f60f6"},{"claim_cluster_id":"6f4632e9-24cc-42ed-87c9-747133ea5b31","event_cluster_id":"b5dff88c-bd24-425a-aabb-6f3428e4297a"},{"claim_cluster_id":"1ef62c3d-3750-43b9-855b-d4624938de1e","event_cluster_id":"628b9939-51f6-44a8-83a8-ac677a42d942"},{"claim_cluster_id":"99b20734-bb32-4aff-b60b-a976139937c2","event_cluster_id":"b67dd1ae-27f1-42b9-ad69-ee83a298d216"},{"claim_cluster_id":"2cfb50e6-37ad-47a2-87b2-da1a9a512e46","event_cluster_id":"0f6d8e28-a525-480c-9282-bbbd6890cc48"},{"claim_cluster_id":"ee877fbc-1f06-46ff-b006-7c974bc58cf1","event_cluster_id":"bc899377-60fc-4a12-85cb-bbcd12759608"},{"claim_cluster_id":"1075443d-c097-4cb8-acb0-3d21f48f6aca","event_cluster_id":"0a7daf16-3825-48ce-beb6-0161de293451"},{"claim_cluster_id":"c8265999-6e3a-4835-bb5a-9e081a27e9bd","event_cluster_id":"319e2fcc-0e3c-47fc-8f3a-ef46c10716ec"},{"claim_cluster_id":"5fbc247f-99df-408a-8188-29a28a5f5737","event_cluster_id":"bbbc8b46-d558-43ec-8e55-d7d72928442c"},{"claim_cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","event_cluster_id":"f5b1b3d0-19e5-49a1-bbc1-690d440e299c"},{"claim_cluster_id":"19b1602b-7236-4e52-b704-1442a85ad752","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"bc630aac-e921-4ad6-990d-40d804192d55","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"f997f1c7-5ae9-4bf5-bd1f-2f46bb8d4a16","event_cluster_id":"726b06eb-9cb3-44bc-9105-8eb731155948"},{"claim_cluster_id":"6b38f355-a80e-4449-8c83-c5ac56d5a2e6","event_cluster_id":"df30b460-1ef4-4fe2-86e2-8192bfc9613d"},{"claim_cluster_id":"1b8ba3f8-2b51-4433-9cf8-2a5412413277","event_cluster_id":"6d514f4a-28a3-42c1-8a0f-d24931c265ce"},{"claim_cluster_id":"71de3f5e-7d6d-4a6a-b383-b96d1ee24b30","event_cluster_id":"6cd94c1d-412f-4288-82d2-a9deb07dfbe3"},{"claim_cluster_id":"ad973751-acf4-4c7e-8032-3a95cf408206","event_cluster_id":"98018dbb-a9a6-4b5d-b356-863340b24362"},{"claim_cluster_id":"f74a80e3-1327-4636-a252-f4ca8a5b90f7","event_cluster_id":"face4903-290b-41c9-8ba8-d5aa2cfa2533"},{"claim_cluster_id":"1190ac87-5191-4e29-877a-253af15bb185","event_cluster_id":"42899209-2504-48c5-8694-2bf64d4edf90"},{"claim_cluster_id":"d8704200-daac-4e95-873c-20cc39771b1c","event_cluster_id":"cdf07443-9a3e-4b94-a668-1930f3a66029"},{"claim_cluster_id":"99dd456b-c805-4ebb-a82a-80fe2e06dff9","event_cluster_id":"67cd7c4a-a6b3-4e11-9b6b-362422489e76"},{"claim_cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","event_cluster_id":"d9484da0-ca3b-450a-a45c-787783bba3e7"},{"claim_cluster_id":"d20d47b3-a32a-48d4-a8d3-2dd3f07fe8a9","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"b54d16d2-d5db-4746-b15a-e8c01d4fc586","event_cluster_id":"95bc2531-eabc-48ae-aefe-417173f45673"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"115eeed7-4973-4efa-aa32-369a2056fa21"},{"claim_cluster_id":"f401d633-0e2b-4935-b7d9-1761c201c058","event_cluster_id":"b8d20c5e-c322-4b49-99bf-b717fffef7d5"},{"claim_cluster_id":"4b037322-86a6-4af9-bfe1-49f968f04baf","event_cluster_id":"a0d901e6-2e0f-43fd-9d25-7b092459f36d"},{"claim_cluster_id":"6bdcff96-571d-4879-91a7-d6084340625f","event_cluster_id":"37b0238b-c658-4977-a22b-36f3d3dc6e36"},{"claim_cluster_id":"7386324d-4730-4b17-8d70-6b33d62d5be3","event_cluster_id":"94b0a214-1e60-4bbb-96cf-031169c35247"},{"claim_cluster_id":"2edb056a-640a-40d9-89e2-36dbc25022b5","event_cluster_id":"dbb1fd32-5705-43e8-a68b-a90c6757768a"},{"claim_cluster_id":"58953090-5955-480d-95b2-311ed2c0f653","event_cluster_id":"143fdbe0-b8f7-4368-95d7-a7983691aac9"},{"claim_cluster_id":"cf8a7c88-fcb8-4b8d-aadb-46cb3168db25","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"481b0645-4bcd-4df1-ae15-b184375e551e","event_cluster_id":"2913b0c9-ef79-4e98-9ca0-9e5e2abf9938"},{"claim_cluster_id":"86160f22-53c1-4e04-a28d-86c0e883fa44","event_cluster_id":"c7b0f267-0192-4ba8-86e6-09f6ba274d4f"},{"claim_cluster_id":"3e505b9a-116f-472b-bc43-8ee1a23943f5","event_cluster_id":"0affe3d3-ec5f-48dc-87ba-10392622a134"},{"claim_cluster_id":"f10ad797-ad79-4629-861d-4af809502a09","event_cluster_id":"a400da3f-ddc6-4851-b855-065d3f101c71"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"fe283f5f-5575-4095-b65a-cb6fe0d25e44"},{"claim_cluster_id":"e9fd964c-939f-481a-a2ad-a6d738a01a81","event_cluster_id":"87f027a4-571d-4212-8e96-6f46fe317fc0"},{"claim_cluster_id":"536df2e4-b955-48b2-8a3c-5b06a58c9d87","event_cluster_id":"72ff31f6-b46f-456b-85ee-5ab8c2328972"},{"claim_cluster_id":"d0619b32-28c7-4624-9e6b-8c81d9ff9019","event_cluster_id":"8e8e8bbd-6670-4f01-810a-e901866d96f8"},{"claim_cluster_id":"f4de84ae-8f6f-4a0d-afb7-35839203b010","event_cluster_id":"a7e57243-5f25-4292-b208-646cbc973faf"},{"claim_cluster_id":"e0d82e7e-dd46-4e81-a408-b1cd11385d33","event_cluster_id":"e0d1bce3-3239-47f8-946e-5937659f6c85"},{"claim_cluster_id":"3d986dc9-6edc-4a4e-9783-63b1c5e7bcd8","event_cluster_id":"220dfe6b-2774-4a8a-8306-3094dfce156d"},{"claim_cluster_id":"6d3cbd05-e0ef-4cd9-bb48-23a74e72bdc4","event_cluster_id":"f9f83549-19b2-4c63-8024-bec6ccd4b48e"},{"claim_cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"d14315a8-aa93-4c64-a42e-a4307dd0814a","event_cluster_id":"bc4c213d-8b78-447a-9835-0a8c9c8149b1"},{"claim_cluster_id":"5ece0141-8dd6-405b-93cf-5585050f4efe","event_cluster_id":"4a1b2728-75a5-43bc-8278-ab49e8c8c004"},{"claim_cluster_id":"763dcb28-8161-4ef1-bcee-20cbd6af7670","event_cluster_id":"0e7e5665-e1ba-44c9-b9e8-62d3501bb81c"},{"claim_cluster_id":"ed1b332b-c054-4114-82a1-1e645946747e","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","event_cluster_id":"019a6206-d313-408e-aa7d-dd9ebfe68ec1"},{"claim_cluster_id":"5900a7ab-7cb4-45d4-8807-d20dee337670","event_cluster_id":"d53ff534-a3d7-4ffa-9823-7bc6114763e7"},{"claim_cluster_id":"36472627-9945-496e-89a2-063ceee22d24","event_cluster_id":"0555403d-91c7-40d0-bf24-c9c0415e9ad9"},{"claim_cluster_id":"721fca95-63af-4a1d-bae5-70b55fce9a8b","event_cluster_id":"471e4e9c-4ca9-4ee9-ad65-9f3b0fd313ec"},{"claim_cluster_id":"3dc82114-c98e-4342-a6ab-854d95d9efa7","event_cluster_id":"2bfeada4-b9e0-40b4-9be2-0655b8d49226"},{"claim_cluster_id":"b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10","event_cluster_id":"08ccb8f3-d97c-4442-b830-fac7f751221a"},{"claim_cluster_id":"558484b7-ac90-44c3-8eec-a2f364ca9460","event_cluster_id":"7b1f2cfc-5328-4132-ac99-4d91818f60f6"},{"claim_cluster_id":"fe684e64-4226-4567-8e1f-5613fae2c8f8","event_cluster_id":"0d5de813-beee-4fba-8db1-09461ff50d02"},{"claim_cluster_id":"eb6a12b4-268e-4e39-8d84-ba73d40a7ffd","event_cluster_id":"157ed6bf-eaaa-4513-ad02-a2a99adf039a"},{"claim_cluster_id":"9be5c43d-4ef1-465d-bdbc-ed35d95c0689","event_cluster_id":"27baa662-c27a-403b-9e47-b67e42c90e29"},{"claim_cluster_id":"f3b06c88-86f6-4833-89c1-f778a2910669","event_cluster_id":"3d3c026b-80c1-4334-84d1-db19f80712b4"},{"claim_cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","event_cluster_id":"eebdc162-9389-4ba5-ae4d-d971d7acc73a"},{"claim_cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","event_cluster_id":"58d84750-75e5-4a06-9053-f1a5a8baf564"},{"claim_cluster_id":"3d9f2bb4-f1d6-41ac-be1a-ac1194130144","event_cluster_id":"450543ae-8630-4e48-a375-9699e4cb6925"},{"claim_cluster_id":"f1f9481a-c3b7-4912-be82-d974b52e8f30","event_cluster_id":"ed866655-8d58-43f9-93ba-c498e1783c16"},{"claim_cluster_id":"ec613890-df43-48e8-bf2a-a40ccb263efc","event_cluster_id":"7b20021b-470c-46f3-841f-c47d4c52551f"},{"claim_cluster_id":"9314aa75-84de-490c-95e7-6484ecdba212","event_cluster_id":"45a08904-45fb-4937-aec9-3d713915195b"},{"claim_cluster_id":"1c703565-77f6-4eda-962e-77ec869d886d","event_cluster_id":"4b2686df-f0ed-4fbd-b1c1-475a6406601a"},{"claim_cluster_id":"6f9b01a7-d717-4ce1-bd54-f5647d476287","event_cluster_id":"0f1dfea7-22b4-4df1-ad86-305165ef36ec"},{"claim_cluster_id":"108c6941-b645-4904-86a8-cfa0fa34274e","event_cluster_id":"acda69bd-2a78-45aa-a6fc-5eeaa0b45f28"},{"claim_cluster_id":"fec0d44e-dff3-4478-9317-1b1d954f03c6","event_cluster_id":"720ca61f-9942-490c-ab91-755d5a979ee2"},{"claim_cluster_id":"4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1","event_cluster_id":"2b56b1f6-1627-44ab-9460-b13751cf087b"},{"claim_cluster_id":"837dbefb-7b54-4aa1-aad3-56f0ea97f9ed","event_cluster_id":"b560200c-3172-4ff5-9c7f-410b8ee34d25"},{"claim_cluster_id":"69fa7886-741a-440f-8a20-2b9ce60729ac","event_cluster_id":"a1395f05-6f91-4eca-a911-53f15292db71"},{"claim_cluster_id":"ea54647f-e4a4-46e7-bf16-66e30583a4a6","event_cluster_id":"442786eb-7f1c-4cbe-a22b-05ba612dc67d"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"9a157342-1d61-41a4-92fb-020ea95697bc"},{"claim_cluster_id":"d9366872-6ca9-49e5-9e80-86c5b954d463","event_cluster_id":"1919a927-7052-4719-83c2-7118a15e11e3"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"80b309de-fa0b-4abc-ace4-5a54f5c02331"},{"claim_cluster_id":"639596e6-4b0c-464a-9fa5-8272920e87b4","event_cluster_id":"77081589-555b-43cf-8723-b50b060cc231"},{"claim_cluster_id":"c8265999-6e3a-4835-bb5a-9e081a27e9bd","event_cluster_id":"197e7b6e-783a-4813-926e-57380c838db7"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"96c05405-04cf-48e3-824b-2a96332d38b7"},{"claim_cluster_id":"19ef8fca-6a45-4387-be0d-efc3fd245b80","event_cluster_id":"701985dd-4322-488f-8c88-ea50b9053ab8"},{"claim_cluster_id":"0c265597-6c2b-4efe-9acb-799f67a3b4d1","event_cluster_id":"1257662d-03bb-4192-9e0e-d0d2bb753848"},{"claim_cluster_id":"c51e0b3e-03c3-4464-95af-a00db4b0bdd2","event_cluster_id":"e47fcd0d-6eef-4992-8b24-a772ebce5f31"},{"claim_cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","event_cluster_id":"5d6331d6-8b39-45dc-b069-c03168d82aac"},{"claim_cluster_id":"294d0346-cddf-4b1e-a6bc-ab4686137712","event_cluster_id":"602ccd3f-b2b7-474a-9029-74260beb7902"},{"claim_cluster_id":"3a5853fd-eaf4-497d-b7fc-b13a9208544c","event_cluster_id":"0040fc97-03df-421f-96ac-2c09e7b8a54f"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"456f0f19-c43e-4805-a01d-f15d26323d29"},{"claim_cluster_id":"df17d3e5-8709-4518-a32e-ebe9d39b417e","event_cluster_id":"3803cd19-3379-4dcf-8227-17e8e94b50a8"},{"claim_cluster_id":"ddd4b5a0-2eee-4ff9-bb50-de940c2541e2","event_cluster_id":"0fd43dca-76e2-435e-9091-21e203301fc4"},{"claim_cluster_id":"2c49dd92-a97e-4b1e-bac2-607670a0a86d","event_cluster_id":"c24c8055-1228-411e-82e6-d5cc151796a6"},{"claim_cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","event_cluster_id":"21d331a6-d043-465d-88ff-572098f9f48c"},{"claim_cluster_id":"abd83725-20da-4a40-a5cf-bb6715d5460b","event_cluster_id":"dbcfd453-3fcc-4846-b99a-9b5de23fde7a"},{"claim_cluster_id":"94f243ab-1521-4874-b5fc-b80847a7fefc","event_cluster_id":"62ebe72f-55b5-4dca-b8c6-cb9ed5b82c24"},{"claim_cluster_id":"f8cc40a9-e215-46da-bdf5-b5efc622bb40","event_cluster_id":"a5d008c6-c15a-4302-aa70-e916c52f5451"},{"claim_cluster_id":"a0d6a00c-f05d-49fd-9f81-54bc418a2aec","event_cluster_id":"ccd825e8-99a9-452b-8ea7-e5e98518daca"},{"claim_cluster_id":"f401d633-0e2b-4935-b7d9-1761c201c058","event_cluster_id":"10698f29-8fe6-47a6-b30e-e5ff5dcfea6b"},{"claim_cluster_id":"58a44cd6-3f44-4460-9d07-d5a28bd55747","event_cluster_id":"771e3903-1d96-4871-b3f7-ccc8c72d8493"},{"claim_cluster_id":"8a4b9d30-600b-48dd-9a32-934835947825","event_cluster_id":"3e8cbb71-09f5-4d7a-9358-2ef082adc4f1"},{"claim_cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","event_cluster_id":"66fb628f-853d-44dd-b0f9-617fd67bcaf1"},{"claim_cluster_id":"e0b3b058-f41a-4ebc-b9bd-9e20a141c340","event_cluster_id":"83c0c29b-58c8-41f0-80a2-462fee4f58ed"},{"claim_cluster_id":"b8a67936-c036-4a45-8680-bb4909cdd3db","event_cluster_id":"6b198d6b-8dea-4096-80f2-e19aa989c1d0"},{"claim_cluster_id":"71de3f5e-7d6d-4a6a-b383-b96d1ee24b30","event_cluster_id":"9ef9723e-224d-4c57-9d96-bcf1933702af"},{"claim_cluster_id":"4cc6a578-5e10-41d7-a578-fba88da2dc13","event_cluster_id":"1b8d5ce9-1627-406b-ad77-075419ad3508"},{"claim_cluster_id":"1a689731-c588-4661-b0b5-8beb94a95bb4","event_cluster_id":"9997ff9b-fea6-429f-b5df-1f0640f5b200"},{"claim_cluster_id":"f68dc41c-3947-416c-8f93-49c606c24bd2","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"4a817862-6fa5-4e7c-8998-977aaad70250","event_cluster_id":"efde2814-71d1-4a0e-959d-1e37c60dd501"},{"claim_cluster_id":"1469928a-aef7-459b-af14-6d6ac0ca72d3","event_cluster_id":"4b36afdb-64c0-4dfe-8f4d-501930c59107"},{"claim_cluster_id":"0653516b-f642-4236-857e-3f4989809104","event_cluster_id":"7f22f643-051f-4c46-8fa4-209f55a6aff1"},{"claim_cluster_id":"c7e21d17-7b1c-44ba-9b2b-db5a38de4e97","event_cluster_id":"86a99b16-df58-43a2-b7eb-e1d03c6f6e5e"},{"claim_cluster_id":"4a7f03a8-491d-4f60-918f-7d3b5b1fa0c8","event_cluster_id":"eea04632-7eb6-45a8-afd1-95556afba561"},{"claim_cluster_id":"df0cd74b-d230-4260-9a29-b0bc91923404","event_cluster_id":"25a859f3-e205-44d1-b703-8d1e9921d967"},{"claim_cluster_id":"43d1e3ac-04ef-4f83-99ee-76241c79a7a0","event_cluster_id":"ed2f46ec-4300-4232-969b-86017e6c6546"},{"claim_cluster_id":"1a689731-c588-4661-b0b5-8beb94a95bb4","event_cluster_id":"48881067-b084-4793-b8c7-6423be69c261"},{"claim_cluster_id":"84900de4-4822-40e2-a41f-f9013bcc0bbe","event_cluster_id":"637cde7e-0523-4cfc-a2d0-d5916b669833"},{"claim_cluster_id":"44d600b5-1259-4b0f-a45c-73f5507156e1","event_cluster_id":"f1adf470-c92b-4dc8-8ffc-81d2f8af3978"},{"claim_cluster_id":"310f4e19-f7f5-403e-af6f-b2064fadd246","event_cluster_id":"53fc6234-d563-426d-a3bc-ba15edc6f530"},{"claim_cluster_id":"a604694d-4fcd-48e0-a074-6eaa09488a89","event_cluster_id":"82c2fba9-344c-4253-9cf5-a05ec938a8a6"},{"claim_cluster_id":"4f68034e-7758-4136-94fe-82331ab7df47","event_cluster_id":"913d6094-0602-4c9d-90e4-9e574b9a8080"},{"claim_cluster_id":"9920b872-a377-485c-97d1-65b98d038806","event_cluster_id":"75fbf587-2351-400e-b397-a778510d68fc"},{"claim_cluster_id":"9d39778d-eb5c-4c0e-b35c-894a4378bc37","event_cluster_id":"9dcce4d2-ce6e-4b1e-a8f5-c853370fae54"},{"claim_cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","event_cluster_id":"9f25d197-8ec1-4d18-aeda-b095d1997826"},{"claim_cluster_id":"94599b0f-3332-46af-911a-e0ea949079dd","event_cluster_id":"b223bdd2-4e37-4cb0-a50b-feb184bdfe78"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"c89da02e-a1bc-4522-a452-82abf8c705c4"},{"claim_cluster_id":"199ae7ec-217a-4cab-a030-ff0a4838c0a8","event_cluster_id":"a4eff04d-c7b6-4d4f-a9de-6ac6a11bad77"},{"claim_cluster_id":"175bdcd7-0fff-45d5-9e67-f78e69286a6f","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"ff26fc04-79ea-483a-b7fa-30217f23ef0c","event_cluster_id":"7af9dd75-d833-4cd3-b3d8-08e6c743ac05"},{"claim_cluster_id":"2d7a7088-3ced-40a0-9677-1d14e1c26d8f","event_cluster_id":"a4004e95-5738-4a9f-9ef9-273901538db0"},{"claim_cluster_id":"1c30353a-a7dc-48dd-bca2-56c91aa06ab6","event_cluster_id":"e8306f6c-1fb0-441e-9dd5-57929514dcf5"},{"claim_cluster_id":"910b6c18-44e1-4b51-b616-1f6016486c69","event_cluster_id":"b1dcb694-6efc-4b22-9bc7-9254eb290f7d"},{"claim_cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","event_cluster_id":"cb033bf6-f8da-46c0-a5e0-962c48c82ad6"},{"claim_cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","event_cluster_id":"e3403237-7c1c-4e7a-9604-df8d11301d8d"},{"claim_cluster_id":"d0619b32-28c7-4624-9e6b-8c81d9ff9019","event_cluster_id":"15d3bc51-86b6-41c4-8d7b-a993e63544da"},{"claim_cluster_id":"d2c2f402-f56b-4dfa-98d3-daf63239156d","event_cluster_id":"902e4c1f-ffd6-4a43-b284-14e627b17668"},{"claim_cluster_id":"bd4c7f11-9866-4656-98e3-7341cfc6de34","event_cluster_id":"f3b3f1d2-6fee-4073-8509-60422ce0c24d"},{"claim_cluster_id":"23adc402-b3b7-489f-bbe8-5d7825946d77","event_cluster_id":"227678ba-993d-4003-9922-aa2e2a27ca74"},{"claim_cluster_id":"88ebdccc-4a31-4f1b-a74f-989ab096e08f","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"0e8e4003-b007-4df8-a1a5-948e64fe6342","event_cluster_id":"d7765332-5dba-4716-b432-1311de3172a6"},{"claim_cluster_id":"6910074e-7bb8-4a4e-9f37-3e335d1a57a0","event_cluster_id":"7c56640a-84bf-48d1-9c5b-b22b665dd6a8"},{"claim_cluster_id":"416e4c1e-869b-468f-91eb-bba4fac5108a","event_cluster_id":"d3c9a36a-e9bd-4eb9-ae98-c8503d7abb49"},{"claim_cluster_id":"d96c8f5c-4bb9-48ae-8d6d-0625e7b9a576","event_cluster_id":"ed866655-8d58-43f9-93ba-c498e1783c16"},{"claim_cluster_id":"b39ca7cb-8663-4bff-829b-b432d59670f9","event_cluster_id":"a4bee492-f45a-4aa3-94d5-709bdbcd2d39"},{"claim_cluster_id":"612e00dc-099b-40a4-b39a-4b7adbab73ce","event_cluster_id":"4dc1a0fa-5313-4a33-a001-984da53ababb"},{"claim_cluster_id":"73fff1e2-bc77-421c-8436-e9bf094a9733","event_cluster_id":"98ea14c4-be20-4ab3-b8a0-74207d1ea94c"},{"claim_cluster_id":"8a12011e-a6e7-4e73-a321-a39426ec3d34","event_cluster_id":"6dc5280e-6875-44c0-adc9-079542d2d0b2"},{"claim_cluster_id":"4c95b4a9-d005-4c7c-8a55-a5a0821d7611","event_cluster_id":"8f06b71d-e458-4241-be0b-c89c223296af"},{"claim_cluster_id":"b43b3e32-d544-43ad-b781-20a883c7f4b7","event_cluster_id":"ad1bfd32-94c7-4e45-b536-bb4b7ea9411e"},{"claim_cluster_id":"6a54c6d4-9e49-450e-95c4-f3afc0f85f6c","event_cluster_id":"4a483622-b245-4e23-bd10-793b05ae9fe2"},{"claim_cluster_id":"bc630aac-e921-4ad6-990d-40d804192d55","event_cluster_id":"93b80413-3a5d-432a-887d-e727cb82d2f6"},{"claim_cluster_id":"14a92521-0601-421b-b904-3fc9a965cbb6","event_cluster_id":"867afc59-5780-42ae-88e7-83c90a074b4d"},{"claim_cluster_id":"226ceb68-980d-4b72-b053-36c7b5c7f61b","event_cluster_id":"43efd020-0d45-4101-9278-ea22329dba55"},{"claim_cluster_id":"40460222-6c35-47b7-be68-29a1138ce819","event_cluster_id":"b866ed85-f7f0-43c6-a093-04cf15808999"},{"claim_cluster_id":"f2df1c45-9507-438e-92d8-0a523b9a842a","event_cluster_id":"18a5e98f-3e74-429b-a0f9-0bb8cb6c457c"},{"claim_cluster_id":"42314335-3518-45c0-909b-96111c0955f6","event_cluster_id":"450543ae-8630-4e48-a375-9699e4cb6925"},{"claim_cluster_id":"0af113aa-da9f-4ed6-a163-dcb48f1459ee","event_cluster_id":"f3afa262-5d02-4bc0-8506-783a0bf09d56"},{"claim_cluster_id":"1b955d6d-0e9d-4c50-82d2-f1ccf2a0b080","event_cluster_id":"4a20b107-b497-42c8-8807-874212cad7e3"},{"claim_cluster_id":"64de7b14-ea9c-48fe-a9a0-a30f01aecc3e","event_cluster_id":"429b9019-55ed-4d53-b962-21e416686d27"},{"claim_cluster_id":"0eef7600-1d71-4d26-9e91-3c6e5b0c6121","event_cluster_id":"d28e35dd-84d1-4e21-9131-912aee49eabd"},{"claim_cluster_id":"68142908-c71d-4106-9ef3-2de00198c72e","event_cluster_id":"71e63580-38d2-43b7-a5b4-b06b93f3b79d"},{"claim_cluster_id":"b9e4bfc6-c83b-47ab-95a9-d3b6db015c07","event_cluster_id":"182dd0dd-1319-4405-9396-03bc211809ae"},{"claim_cluster_id":"e2676bcb-4f6e-4d98-ba58-3d2aff04d940","event_cluster_id":"2c113efd-6d03-4fd4-9d94-78125d3c286d"},{"claim_cluster_id":"80112f8c-1c78-451e-98a6-361d1ea1a9d4","event_cluster_id":"80c21daf-780b-4d61-a882-6319319c019e"},{"claim_cluster_id":"758d6034-7d93-4286-ae2b-f2ffde861da6","event_cluster_id":"093f494f-e108-4f07-9dbc-35136554407c"},{"claim_cluster_id":"8b44daa7-629e-4db8-81b7-5ed88669eb86","event_cluster_id":"a4ef4316-1b40-4ce1-b5cc-ef7ada4c3a2e"},{"claim_cluster_id":"a3a8e335-b1fe-4cbe-b6f9-626c39d5f0dd","event_cluster_id":"dd94c024-2472-482f-808f-4c85cd16b4f9"},{"claim_cluster_id":"47085082-7091-436e-a3ee-ecf14c90e1a5","event_cluster_id":"f6908b42-dc9a-453f-aa2c-203da06764cf"},{"claim_cluster_id":"99fbb991-8bc1-4254-9fff-a2ac5c926685","event_cluster_id":"ab42726c-f378-41dc-98e2-0ce10f9d6d07"},{"claim_cluster_id":"7ac2cf7b-ca51-4fa7-a3a9-0db71617d3e1","event_cluster_id":"304159c4-71dd-47fa-8097-c06173508250"},{"claim_cluster_id":"9920b872-a377-485c-97d1-65b98d038806","event_cluster_id":"2197b0cf-d748-489f-aa22-936ee02a0c14"},{"claim_cluster_id":"563140da-8f58-4b64-8987-47bb018b6821","event_cluster_id":"a0499a4f-f80f-4f0b-ab10-3a54901c48a4"},{"claim_cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","event_cluster_id":"92dc2b29-cee7-4ea1-b9e9-d0593544c75b"},{"claim_cluster_id":"daf13a88-450f-40a7-bca6-ccfb46ede159","event_cluster_id":"90811b8e-940b-4a7b-bb43-2f0cfe36a594"},{"claim_cluster_id":"702a4627-2eae-451d-b2a9-154358319e24","event_cluster_id":"42aaef22-3993-4ed5-8477-0e78fe2789f9"},{"claim_cluster_id":"99dfb4e4-9788-4ea5-81a7-c0dd44f60aba","event_cluster_id":"19226ea8-73b8-405a-ba2e-087cba3fab92"},{"claim_cluster_id":"eb2ba8af-f927-478b-bc26-2105bdb87c5f","event_cluster_id":"b87e7ed0-8014-419f-b604-584f2337b651"},{"claim_cluster_id":"0fa9f6d7-64f6-4933-aae8-3cfd512cab5c","event_cluster_id":"7763c9f8-5bc5-4b00-83e7-8687863ffb36"},{"claim_cluster_id":"d30cdd9d-92e1-44ac-aad9-845702e1559f","event_cluster_id":"27ea6d31-8a5e-414e-9f29-f8f54c4dba1b"},{"claim_cluster_id":"bbc8c147-b447-4af6-82fb-e416f6108e70","event_cluster_id":"dbf1c410-0096-4098-84d3-5c9270d536df"},{"claim_cluster_id":"6967755e-61e4-4308-be97-cdea95a155c7","event_cluster_id":"bf33acab-5a50-4871-8114-2bad5bcedb80"},{"claim_cluster_id":"e5736d52-6864-4a19-aa95-57d6bbe8f40d","event_cluster_id":"45319dcb-5d0b-4d01-90b1-03022e3ef700"},{"claim_cluster_id":"3f09a0f3-521e-4c59-84d0-5adbf02dbf98","event_cluster_id":"9c2eabc6-f74c-4f84-b44d-2de93cf844a7"},{"claim_cluster_id":"6e99d559-c095-46a1-a671-2a3d2e8566bb","event_cluster_id":"2490cd6a-465d-4de9-bada-79c6b3ffed26"},{"claim_cluster_id":"36f68109-962e-490e-9101-85d84c5de66a","event_cluster_id":"921c5a51-cef0-491b-8b5f-a5f05c5b785f"},{"claim_cluster_id":"d2c2f402-f56b-4dfa-98d3-daf63239156d","event_cluster_id":"4b43ecc5-2325-49de-80fb-8c71f498b44d"},{"claim_cluster_id":"a44bb3c4-918e-4230-8542-c0aebafed121","event_cluster_id":"10142c53-0aae-468e-a5f8-9d5313be2cf3"},{"claim_cluster_id":"8cb0435b-3218-46a5-88b4-47481d4dee85","event_cluster_id":"ae6a51a8-019c-4d5d-a0b6-079828d681e6"},{"claim_cluster_id":"42fd849e-0fa9-43a8-b5fa-5cc192351c79","event_cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03"},{"claim_cluster_id":"a55a36be-0edb-44d4-8400-10d53525802c","event_cluster_id":"4b50f48f-0dd4-4d51-a40b-e932902a32fc"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"af431814-360b-4c41-83d1-6147d4068846"},{"claim_cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","event_cluster_id":"2d92a79a-ce61-4af0-b8af-8322336cee3b"},{"claim_cluster_id":"ce28dc91-d0be-44b8-b551-17c831f9e07e","event_cluster_id":"4468d3e5-ac94-44c3-a0b1-a59798ce1b28"},{"claim_cluster_id":"d87f03ea-124e-4e30-80f4-ce890ca4d97b","event_cluster_id":"3595c0cd-b164-431e-b192-61bc7dc0019f"},{"claim_cluster_id":"2c44608d-8e33-4f88-ad5e-7e4885719e31","event_cluster_id":"9a22d933-5b51-4f1a-93f6-12dfd9a6f37a"},{"claim_cluster_id":"ad973751-acf4-4c7e-8032-3a95cf408206","event_cluster_id":"cf92f2d9-5ad3-4f3b-877f-c3c333e4eaa6"},{"claim_cluster_id":"fd127341-6938-4e10-8b5d-771537846e8c","event_cluster_id":"916a8c6f-5ca2-4b3a-b949-ca57daf6bb56"},{"claim_cluster_id":"a39bfc74-5364-4583-b4c6-2ba30e1ddbf9","event_cluster_id":"6aefa1fe-d0f8-4db4-8968-8fa277506a8b"},{"claim_cluster_id":"de60bb28-4ca7-441f-814b-f2ecfe29fb54","event_cluster_id":"e1a7ebff-5254-4bd5-a3d1-966b6a60cd7e"},{"claim_cluster_id":"1c24dadf-70dd-4f00-84a1-ba00a5d442c5","event_cluster_id":"d7895c1b-fc75-4aef-87f4-799e18058cdf"},{"claim_cluster_id":"77119585-efc9-469f-8988-fdb1e15681f0","event_cluster_id":"79cd6f65-ee4d-4695-8b9a-e4b8c86c1536"},{"claim_cluster_id":"9747ef56-b31a-4050-8bc2-6df45c0ffbd7","event_cluster_id":"cfc085d7-3aee-4121-81f4-5053e011112c"},{"claim_cluster_id":"d43a588c-20a7-4ed9-8abb-37e05290fde6","event_cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b"},{"claim_cluster_id":"b398f217-24d9-4c22-8d5a-732320853c1b","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","event_cluster_id":"2e96e776-35fc-4f23-940d-ba30ac558d05"},{"claim_cluster_id":"c80e0125-43dd-49de-bff5-42885acf8ee9","event_cluster_id":"a954b16a-c601-4ed1-9990-0dca57e0a58e"},{"claim_cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","event_cluster_id":"f1749a30-d414-494e-8542-2f37dca2357f"},{"claim_cluster_id":"b1da162a-fb28-4547-8fd8-715c5361b7af","event_cluster_id":"8cad6289-2663-4a76-816f-85ae55214831"},{"claim_cluster_id":"5e3e9898-c954-4e10-be52-6e36f5b36c5c","event_cluster_id":"113ba3fc-f5c7-4177-8c57-e763c91f7e2c"},{"claim_cluster_id":"8b8d3259-7bca-4683-902c-7b72552f88ab","event_cluster_id":"dd605b4d-33b6-43de-a73f-acf3e8834d88"},{"claim_cluster_id":"ff52ee3e-b870-4a3d-ab20-d3bc0d5bc0d6","event_cluster_id":"3800fecc-81a4-49e4-a7cc-dc527d4bd612"},{"claim_cluster_id":"9c5c6743-3894-4e82-b69e-bc4e0c19f869","event_cluster_id":"e53b1b9b-ff90-4db8-bc8b-211c3b969cce"},{"claim_cluster_id":"7eddd539-ebe9-47f6-b0c9-dd9f02f0c8a0","event_cluster_id":"d0fe7b5d-26f1-4baf-86ca-16d7441119ce"},{"claim_cluster_id":"5e767ae7-5475-4d58-9919-b74b88492c8d","event_cluster_id":"86faa30d-3051-4174-a28e-c3bb4b4beacf"},{"claim_cluster_id":"64de434e-21f8-43c2-9395-33dcf3b86c3d","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","event_cluster_id":"994afb12-0656-46cd-8fc2-48a9ab17ddc7"},{"claim_cluster_id":"01c08614-0081-4fbf-86e8-a41b845bc4f5","event_cluster_id":"0eeb88bc-ae6a-4d7f-a61e-b3a6e47f9cf3"},{"claim_cluster_id":"e03ac9ce-f105-49c9-9a2f-9442b3b31044","event_cluster_id":"cd9e4a57-55ca-4538-9460-c81e764492cc"},{"claim_cluster_id":"59b8d1fe-1725-4325-a7c8-5abd450e3124","event_cluster_id":"07499aa1-3238-4e4d-b838-020f0a58eb63"},{"claim_cluster_id":"16b63ffa-da4e-4cff-8fab-fffc1644a634","event_cluster_id":"5acb7ed6-2139-45ff-b99f-c3c0eb2c4d57"},{"claim_cluster_id":"13a07f14-45d6-4b31-8d23-23b540ac8090","event_cluster_id":"f2102ba0-d90e-4134-a7ea-638b33257f3a"},{"claim_cluster_id":"163270c6-b91d-429e-9c2d-5cf8a4ff0d2e","event_cluster_id":"cef4b627-4828-4a00-9a55-7f92b9804c1f"},{"claim_cluster_id":"94ea82f9-8fc1-4541-8fab-b8354c3ea8f2","event_cluster_id":"08918774-fef7-4ef6-9e14-8a7abce1a23c"},{"claim_cluster_id":"ff763739-26e3-4daa-93bc-7ecf065c5275","event_cluster_id":"f7d6db0d-ad7a-49ba-bfea-afddcfaa06ba"},{"claim_cluster_id":"da70552d-1a69-4dd8-bc9d-ca358f3caefe","event_cluster_id":"a0e15f6d-9d91-458c-9257-5c60799b9290"},{"claim_cluster_id":"bfd9a248-bf68-4994-8af5-882efd424687","event_cluster_id":"4d6eed7e-0404-4ccd-92b2-df5956550e67"},{"claim_cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","event_cluster_id":"d5f07507-9281-4cfd-81bd-0fc19ffa8a89"},{"claim_cluster_id":"837dbefb-7b54-4aa1-aad3-56f0ea97f9ed","event_cluster_id":"a4149375-9601-4a78-ae4b-69813512b036"},{"claim_cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","event_cluster_id":"2ec09e70-73d9-4395-9c36-0dbcac034464"},{"claim_cluster_id":"dfbd57d9-b4af-48fe-adde-4b27c203374e","event_cluster_id":"e74616a0-2316-487b-b0b6-5b60062c2550"},{"claim_cluster_id":"aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca","event_cluster_id":"ee1eb50f-e51b-487b-895c-d08085b62fd8"},{"claim_cluster_id":"24d81b39-c399-4c59-ae9b-c84548655d0b","event_cluster_id":"23a31964-6a33-4514-aa2e-353b4bd3be9d"},{"claim_cluster_id":"147befcf-c605-4967-82de-77dc8f9513dd","event_cluster_id":"346b1dc3-219c-4228-a017-da35814deb33"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"9854342f-dc2f-4d81-9468-1aeed5b01c1c"},{"claim_cluster_id":"2fa38dbd-c491-4579-bb95-e37ac00e125d","event_cluster_id":"dcae5341-3559-46a5-8605-6aff132b23e8"},{"claim_cluster_id":"cdfd2024-64ea-4945-8131-782266513caf","event_cluster_id":"4970bf10-4486-48dd-9be4-75b2fb5e659e"},{"claim_cluster_id":"d7eb8bf6-179c-440e-ad1d-a97e186809d1","event_cluster_id":"903c3f33-319a-4f0f-a3a0-b3ad86d56e86"},{"claim_cluster_id":"5dd21bbf-0c74-46d7-a4e4-48789f1b2436","event_cluster_id":"001b82c1-e0c7-4fe5-8e7f-c84ae10048f6"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"338cf48b-ad2b-4dbf-8d36-1e19e9e04681"},{"claim_cluster_id":"d14e115a-dd46-437f-8a57-5893395dde5f","event_cluster_id":"90594f77-57da-4d80-a85e-ef6c61b0cc03"},{"claim_cluster_id":"9bdb548d-7392-42e2-81f0-dc3db0c2af7a","event_cluster_id":"3af4feb3-44a5-438e-9179-8a6158407f03"},{"claim_cluster_id":"1450e6e0-be6b-4ab7-8d94-7070623cadb4","event_cluster_id":"c16529d9-b58f-4692-9ca3-61d534ff3c9c"},{"claim_cluster_id":"61c8762b-b245-4fc9-b3b2-d3c0ab80e8cc","event_cluster_id":"173f883f-de30-4d47-bca3-522527267a76"},{"claim_cluster_id":"b7e33865-58b2-4984-a7e1-eed1512539bb","event_cluster_id":"6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84"},{"claim_cluster_id":"7db64556-43b7-4e29-b1a9-e8fcd5d29233","event_cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63"},{"claim_cluster_id":"b2635760-bcd6-46c7-88fb-9bbbb7349033","event_cluster_id":"76d7e29b-d686-4238-a931-2118cfe1bf3e"},{"claim_cluster_id":"d946674a-0b30-4a82-a7a2-12fe77cdc3f5","event_cluster_id":"0edc35d0-3f90-4beb-b2c7-55c511dba369"},{"claim_cluster_id":"48cca002-8003-45bd-92b2-3e2945a33b48","event_cluster_id":"f623c469-24ac-43e2-8e2e-e888031af996"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"96b587fb-4363-4d46-8a28-162c4f6a688e"},{"claim_cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","event_cluster_id":"33e5cc06-7767-4163-b58e-c98e6d0b542f"},{"claim_cluster_id":"89b27333-1443-478a-ae8d-2e32423dac3d","event_cluster_id":"b9b58ab0-89c7-43c0-9654-023c7dc7edd7"},{"claim_cluster_id":"cd8495d7-023b-4c43-b6e6-6e4c88a0cd79","event_cluster_id":"35826418-a010-4d4a-99fc-5e4fe849cbd8"},{"claim_cluster_id":"baec81f4-73ba-4194-ab31-e3d64c8a57ab","event_cluster_id":"ed0282a9-1dce-4648-ba02-635146d8d79c"},{"claim_cluster_id":"4a942b66-0607-413f-8ee5-b6f6ddbbd034","event_cluster_id":"1d4622f2-0a7b-4423-ad78-a011864bf902"},{"claim_cluster_id":"42fd849e-0fa9-43a8-b5fa-5cc192351c79","event_cluster_id":"c2d29a8c-d30d-4b99-9286-81917e79d3dd"},{"claim_cluster_id":"59905a93-0117-4d6a-a153-cacf3c9feeb8","event_cluster_id":"b92f2bdb-a4c9-478b-a96f-1f47457a005d"},{"claim_cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","event_cluster_id":"2adc78cc-7a32-4711-8e39-54e6c3539977"},{"claim_cluster_id":"4d4f9bd6-404f-433c-9423-3e07e0773599","event_cluster_id":"386f4b6c-ead4-4444-9916-d94cb574f068"},{"claim_cluster_id":"8d4f670d-826e-45f3-b1fc-0b828324ae7a","event_cluster_id":"ee698871-2543-42ca-9ed1-652a77429181"},{"claim_cluster_id":"61fe3afa-76aa-4838-9dd9-a22a879ae31e","event_cluster_id":"f839d2fd-5b0b-43b0-bb42-43cd3c1d733b"},{"claim_cluster_id":"7781df4b-26ca-4879-a33c-cb83ade5ffa4","event_cluster_id":"e0f4c0a7-03fa-4df4-af40-cde3c562aff7"},{"claim_cluster_id":"4ef708bd-198e-4a9e-9652-a1b08bc50fd9","event_cluster_id":"9f093a15-003e-4c3e-b942-5c6cfb87c05d"},{"claim_cluster_id":"5e0fea08-89fc-42fe-8906-484d762a1714","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"44d600b5-1259-4b0f-a45c-73f5507156e1","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"f3072807-ef6c-4e5e-9a52-03328278d096","event_cluster_id":"4cf07546-b901-4002-a89e-1a6f0ae3d9e6"},{"claim_cluster_id":"0a79d737-f594-464b-b3d2-afd57c6349f1","event_cluster_id":"a0a7051e-2d37-4a4c-b40d-aaf1f0558e1e"},{"claim_cluster_id":"61fac83f-0dd7-4c15-88bc-e40fee962783","event_cluster_id":"3defb0ae-14b9-488e-979b-534969f6eb1f"},{"claim_cluster_id":"658de6ad-fa34-4d62-b1a8-d4dba2ffb3d8","event_cluster_id":"51d0514d-a16c-49e4-8ac6-e122e83a4777"},{"claim_cluster_id":"4801b48a-d91c-4dc3-9797-76929432b0ef","event_cluster_id":"0d4d1a0e-a8fb-4f12-a4b0-63f68ad14434"},{"claim_cluster_id":"1e9e32c3-e750-4bcf-b6c8-32bdb1c52a07","event_cluster_id":"f53fc0bd-981e-4236-b0fe-25581f5f427a"},{"claim_cluster_id":"541a6555-c116-4473-b1ae-ac7c48578f3d","event_cluster_id":"2b3d52ec-4f80-453e-83c9-9cef80ee3ed0"},{"claim_cluster_id":"5eea51f7-7e2e-46d8-8dff-0d1a87db87b5","event_cluster_id":"6084620c-6cb7-4024-86d0-5c702f76e152"},{"claim_cluster_id":"99bf6cc4-ca7c-40f2-9d7f-294c761aeaaf","event_cluster_id":"fe0044a9-f20d-4a9a-945b-251740ff3a14"},{"claim_cluster_id":"bdb0efc8-0563-4b0b-a277-072e3cddd7c6","event_cluster_id":"9e7833e1-081b-4955-a649-df85a3c6a9e3"},{"claim_cluster_id":"840ac263-91de-449d-b701-c05a4522f3b3","event_cluster_id":"d72d1fb8-e77f-4607-a953-e3e224ada7a6"},{"claim_cluster_id":"e521c1db-8ae4-48b6-83c6-efbd02701f4c","event_cluster_id":"04675e2c-1e61-4971-b87b-4cddc78fd434"},{"claim_cluster_id":"02e82f7d-c446-4fc6-9794-94910a46d2ac","event_cluster_id":"317eba1c-3b6f-43f0-a757-dddfa7966147"},{"claim_cluster_id":"3786df1e-47ff-4916-973b-ccf57ccb5e4c","event_cluster_id":"14786248-4bb0-4ea2-9421-150787f5ff33"},{"claim_cluster_id":"e25eede3-3242-446d-a439-2c4becea51cf","event_cluster_id":"61dc215b-cc5e-49f1-add7-65f02e137ed1"},{"claim_cluster_id":"f8618eda-effd-4eda-b2ad-66d8fec0ba02","event_cluster_id":"bb608fd7-71a8-4a13-839e-8d3ef46c08e2"},{"claim_cluster_id":"db5a201e-a58a-46dc-91a0-0072432f56c4","event_cluster_id":"413ea174-815d-4e35-9f99-9c6c2ede588d"},{"claim_cluster_id":"a01e0915-a285-410d-9d1b-ce9544139c90","event_cluster_id":"0d423859-86f8-4f56-9318-137386b1b279"},{"claim_cluster_id":"43966195-88ed-478f-bd22-9c59b6eda45a","event_cluster_id":"7b4680b9-9676-4736-8ed2-d06a2da6ea63"},{"claim_cluster_id":"954a4240-7358-4649-966c-6f08bf5b088e","event_cluster_id":"2648c3b9-64e2-4596-9353-c37ae996dcce"},{"claim_cluster_id":"64ec2b0f-c55e-42e7-a532-b9948f0a43c1","event_cluster_id":"5d5c8795-a6be-497b-896a-30f8df4f0736"},{"claim_cluster_id":"1a853cc3-9e33-4539-b70a-cc51380d7526","event_cluster_id":"eeb2d0cb-ddf5-48d2-9af4-27f0f7c318af"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"a644befb-dbc0-4695-b3a4-09f27c71e3c4"},{"claim_cluster_id":"f90286ec-0f96-4266-aa5f-350beb9c1d91","event_cluster_id":"4d4ab9a7-62c6-4187-97c0-f07bf059ad55"},{"claim_cluster_id":"fb9dbaf0-5dcb-4f8e-94c5-fb36dba34aec","event_cluster_id":"dedbca30-3396-4307-a69b-7d7c22f5347b"},{"claim_cluster_id":"b54d16d2-d5db-4746-b15a-e8c01d4fc586","event_cluster_id":"00be0a5e-79b9-4671-8dc6-befc37464ba9"},{"claim_cluster_id":"fc4ce4ef-b019-44c8-8060-59b10a33a92b","event_cluster_id":"eff3ff70-7d42-45d0-a372-4aa15bf9f280"},{"claim_cluster_id":"f18ec76a-50ba-422f-9d7a-596708b1810a","event_cluster_id":"e0978a2e-1125-4e65-9d19-ea0e822bd88c"},{"claim_cluster_id":"cfbbcd75-4bf0-4351-b592-afb201b74b60","event_cluster_id":"6ea91435-3e36-4fbf-82c3-faa6793916cf"},{"claim_cluster_id":"293179d1-c66b-4ab3-8e81-318e4b36242c","event_cluster_id":"d6ce2176-c8b1-49b2-89e4-f0620f06cb63"},{"claim_cluster_id":"f9eb0f13-3691-4b5d-b326-0456c31b4402","event_cluster_id":"2d5921ac-7cf9-4259-b8e0-144908d40418"},{"claim_cluster_id":"78064e33-a38e-4112-b3b2-c02951368282","event_cluster_id":"11b98cf9-d431-4639-813c-ea19160c9631"},{"claim_cluster_id":"5d937f92-5b6e-469d-95cb-0e0432a9031d","event_cluster_id":"f19998d7-da9d-4ad2-b0f0-03ca5c82143c"},{"claim_cluster_id":"4f0130b7-d8c3-44c1-892f-fe74aef4cecc","event_cluster_id":"1f2e46b4-6012-4c4f-8e36-ebb4e20f881f"},{"claim_cluster_id":"c19d9ba5-5f1b-487d-8f8e-af1dd8c97af2","event_cluster_id":"41739d94-ef7a-4bdc-b95f-35d9d4daaddf"},{"claim_cluster_id":"dfa7b9d2-5920-4d57-8445-e48ac5ce73da","event_cluster_id":"b61f6891-5a9f-49aa-8194-10b89513a5a2"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"d291acf3-7cf8-4c9d-9ab4-df11bad39953"},{"claim_cluster_id":"e370d332-674b-403f-8471-184685b21c55","event_cluster_id":"7d17e0b1-02a8-4e94-8aaa-3bb8dcf83cf8"},{"claim_cluster_id":"f66bb1c3-c6f1-4000-8eb0-82b5bd8bc518","event_cluster_id":"ee8407f3-3b78-41fa-b305-9976663fec3b"},{"claim_cluster_id":"8bdd6183-6e5d-4862-87e8-003b661f98ce","event_cluster_id":"3ad13608-e9f5-474c-8ce2-26cf09394813"},{"claim_cluster_id":"f17dbb9a-8968-4ade-a774-02688b6da89a","event_cluster_id":"c21a5302-b063-4bd9-9ecc-b34fe6ec8594"},{"claim_cluster_id":"1cf25dc0-5ba1-4372-8fe0-913839532e6d","event_cluster_id":"4a667d4b-a464-4833-81f6-cd5a99658ce5"},{"claim_cluster_id":"0961c365-4261-4c91-984b-81c62260d807","event_cluster_id":"1bbcb23d-9835-462a-b09f-6a4c89faa361"},{"claim_cluster_id":"3d545073-748d-4207-8e53-2f9ae214848a","event_cluster_id":"b4a34e37-e56c-45d2-8766-c4fab9d7cdf4"},{"claim_cluster_id":"60ed7bd8-a38c-4b99-a08f-6210e30fac23","event_cluster_id":"c62e089c-1780-440d-b990-8342bb6836f8"},{"claim_cluster_id":"a2bf8d43-d7d2-4ff5-b7b5-2d54423dfd20","event_cluster_id":"3b057684-8f4b-4670-8bb3-3e44655c051c"},{"claim_cluster_id":"c462838a-420c-4b5a-ad06-676939effe93","event_cluster_id":"31dfadd3-c8f6-437b-b8ec-a69992a26cb8"},{"claim_cluster_id":"4692c588-5e24-491c-9044-3d7dd7c0a2d7","event_cluster_id":"bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"},{"claim_cluster_id":"ce637d4c-890f-483b-9ed8-d8130682b8ac","event_cluster_id":"bbbc187b-0542-41ab-ac2d-d7a3573b3f23"},{"claim_cluster_id":"c3383556-4a09-4d9a-b202-b1b017162bd3","event_cluster_id":"478586e7-cd47-4bba-a3e6-e954dd593a00"},{"claim_cluster_id":"957872f4-ebb4-47bd-9d9e-487c3755644e","event_cluster_id":"b9a01b27-65e1-4a9d-9166-e606cea6425c"},{"claim_cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","event_cluster_id":"39687812-944b-4418-ada5-3588be43da66"},{"claim_cluster_id":"7f94beb2-9a43-4280-9734-5045402a0714","event_cluster_id":"b7685445-3aa6-4ff3-a94e-b37c9df21cb5"},{"claim_cluster_id":"72a6b38a-23a2-43db-a788-32ae774a5c77","event_cluster_id":"3ef2d7ad-744b-4957-b2f1-17396d9e9cba"},{"claim_cluster_id":"dad0da03-60db-4f17-9025-e5a1ac65e552","event_cluster_id":"32ea90b6-1f69-462e-a6fa-1e6c1978de12"},{"claim_cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","event_cluster_id":"a8acca84-268a-4542-96c5-6e8d1fb747ac"},{"claim_cluster_id":"f502dcb8-0d11-41eb-afba-f50e74157a5b","event_cluster_id":"e91b49c0-8438-4f30-a193-2c3167f6ab7a"},{"claim_cluster_id":"db5fd0e4-cf0a-4e94-a4a2-d71a9c25184f","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"c63decfc-559c-461a-ad2c-a9922b7e06df","event_cluster_id":"bd65ddcd-8b9b-43a4-bc1e-8e3bb7021093"},{"claim_cluster_id":"5de27702-5e57-4b36-bd94-a31f82ba53eb","event_cluster_id":"1d59e830-9dbc-4506-8070-28b5e75a1284"},{"claim_cluster_id":"3d44d914-cf73-4d8b-b531-5db2be83da48","event_cluster_id":"8a1628d6-9b8d-4872-8726-128c5ec7f01c"},{"claim_cluster_id":"f7fbb95e-08d7-410a-8e1f-290e984463d7","event_cluster_id":"544dff2f-0e7b-440b-a330-646db7ed3912"},{"claim_cluster_id":"ab7a8719-e742-49dc-b23d-904f2b97e9e2","event_cluster_id":"be8fcb60-f85e-4def-aa6a-bd82881e44d3"},{"claim_cluster_id":"86f4bd2f-fbe6-4fe2-b712-f9d4acd0c218","event_cluster_id":"75ba7619-eb16-4658-b147-47f3f92ed383"},{"claim_cluster_id":"d3123cbc-3543-4f46-aee9-7941c8669a07","event_cluster_id":"8f118d54-36b6-4cf4-a60c-7acf617e5bf4"},{"claim_cluster_id":"d9f9cf14-d4ad-4c0a-9482-99b75f7c247f","event_cluster_id":"b1dcb694-6efc-4b22-9bc7-9254eb290f7d"},{"claim_cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","event_cluster_id":"08f28ba1-ced8-47f4-a0a0-4116b507d143"},{"claim_cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","event_cluster_id":"b83cbf56-9c77-41ae-bf34-905116236046"},{"claim_cluster_id":"f8618eda-effd-4eda-b2ad-66d8fec0ba02","event_cluster_id":"8a43f903-0edb-4ccc-94e1-29dd080da2dd"},{"claim_cluster_id":"b7190356-8b3c-4107-b9f7-680aa8b73b90","event_cluster_id":"ed2533cf-2013-4e49-885b-231a6c55f0fb"},{"claim_cluster_id":"94599b0f-3332-46af-911a-e0ea949079dd","event_cluster_id":"58ab14ae-8edd-49c2-93f1-5410b8248aac"},{"claim_cluster_id":"b8109116-4fcc-41ae-af96-4f441a585df4","event_cluster_id":"a40aca49-8fcc-4409-91ff-d18e1fba8028"},{"claim_cluster_id":"c2417696-bc64-4d4a-b3a4-d5d9e3cefb38","event_cluster_id":"cfc42d88-49ac-4610-a5c7-0cce12304171"},{"claim_cluster_id":"77e72686-2baf-45ab-a679-b8f62cdcf982","event_cluster_id":"651192ce-035f-4e17-8834-956bf8fefc33"},{"claim_cluster_id":"f415a439-e6f6-4971-a345-2c0b2ac96c23","event_cluster_id":"a1921f6f-8530-42a9-8f36-9fbcf1bb8941"},{"claim_cluster_id":"7cad6507-3550-4760-99ab-581f5b103f29","event_cluster_id":"a00b5c34-3d1b-444a-9f62-57418373c9c3"},{"claim_cluster_id":"12b139d6-738c-48c1-b240-a723ec803e43","event_cluster_id":"366a8fe2-ca03-46c9-b2fb-6c5f6c4014f1"},{"claim_cluster_id":"ded98049-aef1-4b4f-a8a6-f68c10032b7f","event_cluster_id":"7a2de756-9400-4120-b4b6-4dec07a8ec47"},{"claim_cluster_id":"8948b384-0046-47fe-bc91-7f2737b00557","event_cluster_id":"fdd7487d-7bf5-4a71-8bbd-7a8cd0c6d7c4"},{"claim_cluster_id":"56dc9727-1db9-4dc8-acf2-c70b7f101883","event_cluster_id":"01284921-0773-415d-9ce4-f4e93b10a2af"},{"claim_cluster_id":"43fe48a2-ed82-4cef-9784-8e8df627f565","event_cluster_id":"53b1257e-8f17-4723-a98b-5c441d647f48"},{"claim_cluster_id":"83dd9fa5-04ca-45ce-a5ff-f09b5dcf19b6","event_cluster_id":"aa460f1b-c007-4666-8137-aaad655dfd7f"},{"claim_cluster_id":"8c18859c-7432-4cc4-af8f-8a5eb220876e","event_cluster_id":"2c1c9214-d791-4513-8352-ad5103d53749"},{"claim_cluster_id":"ff920ca0-1e39-41be-ac8f-cd0534048634","event_cluster_id":"7259b8c6-e5fe-4c56-9293-e3133ae377b8"},{"claim_cluster_id":"8dca8952-fbff-4b47-ba25-a7640fe52fba","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"abd83725-20da-4a40-a5cf-bb6715d5460b","event_cluster_id":"f83e82a8-4441-4c96-b8ec-2b50e32532d9"},{"claim_cluster_id":"464aaab3-50a7-44d6-8c7a-bdc722ee9f18","event_cluster_id":"fc4a44e4-cde7-4210-b1dd-064e7cdc5fc4"},{"claim_cluster_id":"652f1be8-25e9-4267-b7cc-e5ecf9e7919b","event_cluster_id":"a327ab70-71a6-495b-b0af-9116aa9c7d3c"},{"claim_cluster_id":"2c8b719a-2363-4f9f-9be2-6d1801374195","event_cluster_id":"baaa2ca3-1dde-42fe-ad1f-1aae3e927027"},{"claim_cluster_id":"2c1958a0-e83a-4912-9902-e6456b756f14","event_cluster_id":"60b6a6af-f010-44f3-a632-e0a93f1ed5d0"},{"claim_cluster_id":"f9eb0f13-3691-4b5d-b326-0456c31b4402","event_cluster_id":"3749bcc6-b034-4fb0-8ff0-89b445295873"},{"claim_cluster_id":"f51c562e-c0c3-4e9a-aec5-0739526b9b5b","event_cluster_id":"b79a6948-c2a3-43ae-83f7-90168d6803ac"},{"claim_cluster_id":"b5b35a39-f79a-45e8-82ea-b87d21bbba55","event_cluster_id":"d6134f0a-59f2-49b7-85e1-25628c9e022f"},{"claim_cluster_id":"d7eb8bf6-179c-440e-ad1d-a97e186809d1","event_cluster_id":"86a22fd0-1ecc-482a-b682-9b84955dcaf9"},{"claim_cluster_id":"75e57a3a-a55d-4c36-b291-226154171396","event_cluster_id":"4033f6dd-a718-42cc-9426-c47fe47bc182"},{"claim_cluster_id":"2b7a55b4-92f1-4438-b42d-086b564be154","event_cluster_id":"cf5361b0-1dac-4daf-8324-8e2f301900ff"},{"claim_cluster_id":"06f63413-3561-4a53-933b-589b1f942c37","event_cluster_id":"532d9503-bb11-4fbf-b9c1-5c555fd5393f"},{"claim_cluster_id":"f90286ec-0f96-4266-aa5f-350beb9c1d91","event_cluster_id":"aeb6169d-c89e-4c20-9127-6438583dd127"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"e44c864d-e3c7-43c1-8d75-3390dbfd5417"},{"claim_cluster_id":"64ec2b0f-c55e-42e7-a532-b9948f0a43c1","event_cluster_id":"9d5a2720-0f92-434c-867d-f7d869c56177"},{"claim_cluster_id":"a383fa5f-a5c9-4c42-8e25-d968285a2473","event_cluster_id":"9aa4bb60-c9b0-4bd6-9189-bb33a4f61778"},{"claim_cluster_id":"b840591d-33a5-402e-9f7a-8913292b283e","event_cluster_id":"5688bb4a-4059-431b-b1bc-a991bc5ccd0e"},{"claim_cluster_id":"7cc752d0-c62a-4657-a1e6-4213c5baa7cf","event_cluster_id":"f1e3a565-29ca-414c-8fa2-90756a824cf2"},{"claim_cluster_id":"b4479b0e-003b-4796-9f06-dafafe7cc27d","event_cluster_id":"1760a439-ca46-4fac-8653-21cfe35d860c"},{"claim_cluster_id":"e684bea9-83ef-4337-93a3-80b8a3708ae0","event_cluster_id":"602cf518-8d43-4cc2-9f69-aa005257dd2f"},{"claim_cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","event_cluster_id":"efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3"},{"claim_cluster_id":"e44edb14-2754-4e0a-969f-2ab83f6f614c","event_cluster_id":"5c164c1e-39f8-4082-aad5-890bec3c1681"},{"claim_cluster_id":"d71c3e1e-b92b-4fd2-a1fd-9b3951fec4df","event_cluster_id":"43fc29bf-35e5-405b-9c9f-cf4dbaccd61f"},{"claim_cluster_id":"5ab9d303-668f-48d9-893f-546437484767","event_cluster_id":"60930e0d-3823-4b8f-9390-0e719aa7b09e"},{"claim_cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","event_cluster_id":"4fc8d532-69fa-40fd-b28d-a301335dc7b8"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"94b0a214-1e60-4bbb-96cf-031169c35247"},{"claim_cluster_id":"30765e40-3943-483b-8e1e-27d3053ae2bd","event_cluster_id":"7202d20f-cf9b-4054-aa24-3edfd3064cd7"},{"claim_cluster_id":"901f6891-5f9b-4fa4-a368-69a4f20e9617","event_cluster_id":"bdaea9bd-1088-4933-8486-42634bd70322"},{"claim_cluster_id":"78602db4-20a8-484c-8fc6-98f22daf81ff","event_cluster_id":"32516088-d496-4b04-a09c-540561be5921"},{"claim_cluster_id":"f8cc40a9-e215-46da-bdf5-b5efc622bb40","event_cluster_id":"e18afe50-8e61-4915-8745-6256e6a782cb"},{"claim_cluster_id":"b2ae7e4a-67e9-4eed-bd5c-afaef2c19efc","event_cluster_id":"5df7d808-68d6-445c-b39d-37aecaaa35ed"},{"claim_cluster_id":"7a7464b2-8279-45dc-b2ed-48f2c4d22d10","event_cluster_id":"9dee9825-7f6c-4617-8b1e-b3ceb5b3a39f"},{"claim_cluster_id":"b6dd34fe-58a4-4775-be96-ca839f926747","event_cluster_id":"7459e660-f889-4b03-9154-79bc408cffa6"},{"claim_cluster_id":"2bd9ff92-4ea3-492e-a249-5de7759a5956","event_cluster_id":"002cfac3-c97a-4ec1-b743-37eb0267aef0"},{"claim_cluster_id":"a8aabd5b-4955-40cb-b78a-086cb1601de5","event_cluster_id":"4f004657-e8c8-479b-b300-35da0eaa53b8"},{"claim_cluster_id":"e9b06ff3-55a4-46a5-87d3-266dff0dc9c1","event_cluster_id":"71b00bc6-170a-45b7-bfdf-40d740e90b1e"},{"claim_cluster_id":"61ed0aed-dc5b-413d-8a18-4362324862cc","event_cluster_id":"e622291d-8809-42f1-9ac7-ff3aba01b794"},{"claim_cluster_id":"e29603b9-c4aa-4f53-bf09-ee3302f2daff","event_cluster_id":"89863767-163a-4f04-8bbc-fc93772a6aa5"},{"claim_cluster_id":"a5d39319-660b-4b6e-acb4-246464538db6","event_cluster_id":"bdbb752b-6e19-40a1-b874-d58f3b375de7"},{"claim_cluster_id":"88ebdccc-4a31-4f1b-a74f-989ab096e08f","event_cluster_id":"993e530a-4835-4641-a20d-ee6860332c74"},{"claim_cluster_id":"19ddcd3b-18db-461a-b208-f198db3e1e07","event_cluster_id":"ef8af588-0359-41f5-af90-03db72eaaba3"},{"claim_cluster_id":"060a7355-d23c-448a-8514-2034a0d11495","event_cluster_id":"297851ee-0090-4476-be7b-77ecae5b0949"},{"claim_cluster_id":"8d550fbc-5131-4294-a815-b9e32f81ad7a","event_cluster_id":"921f4cda-4607-46f9-83ce-2b7708f3b6a9"},{"claim_cluster_id":"baa70e51-5ce2-4e6f-8994-d85027e6b1d9","event_cluster_id":"b5e4c53f-7f15-4f0d-b014-ab5bdfef9779"},{"claim_cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","event_cluster_id":"9610bc6c-2c1c-47d3-bb20-3bc619407fd0"},{"claim_cluster_id":"84900de4-4822-40e2-a41f-f9013bcc0bbe","event_cluster_id":"abca71f2-b0b7-497b-b1ed-9f04c6ea4023"},{"claim_cluster_id":"99892bd6-22b5-4bc1-bade-41a91e788227","event_cluster_id":"acb8c5a5-3818-4898-ace2-3330d0f18d6b"},{"claim_cluster_id":"cc6a9454-14fd-45d5-b472-64ca4fedbe80","event_cluster_id":"fbc20184-6dc0-4a3f-a944-728af7954e97"},{"claim_cluster_id":"5cab19a1-9532-4ca5-8f94-e19c788f807b","event_cluster_id":"a5420c14-b12d-4c0a-ae41-dc3c93672fd7"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"d32bd6fd-0fc9-411f-b6d0-ef85e52f9cf2"},{"claim_cluster_id":"d077cb01-a835-4272-a09e-399e776f6a6b","event_cluster_id":"5a9527b4-7ddf-4c5a-b860-67170fb02224"},{"claim_cluster_id":"a7ba0dbd-f9cd-4b80-887f-8fffdb56fc05","event_cluster_id":"7d87f4b1-866b-4dd1-b437-00afdcc9c4fe"},{"claim_cluster_id":"8dca8952-fbff-4b47-ba25-a7640fe52fba","event_cluster_id":"e58bb674-2815-4cd8-8385-fa265f1201b2"},{"claim_cluster_id":"2df1a526-a92c-44a2-a3b2-202bf1d7f6d9","event_cluster_id":"d9b685c8-3dc8-407d-b009-8b6a472fbfe9"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"4abef329-5b6f-45d7-988e-0182db3d0240"},{"claim_cluster_id":"fb95e7e0-9ac4-4fef-85ca-e17c4d83450d","event_cluster_id":"7ae8bb79-06c2-4d0f-9d71-30e4b3fb8238"},{"claim_cluster_id":"b865573b-6b72-46cd-b3c0-a1458e7df010","event_cluster_id":"75ca701d-5dd3-4eb2-b641-e9b6d4316367"},{"claim_cluster_id":"5aec5e12-6df7-45c2-ae07-2921310e080b","event_cluster_id":"ffbd77e7-2b57-47a5-8bd4-9b23ebb837b5"},{"claim_cluster_id":"127c457b-8cad-4a81-8d25-66dd51786fe0","event_cluster_id":"b13b5ee0-1421-43e8-a554-5b3888a5cac7"},{"claim_cluster_id":"a45b0120-f89a-4fb7-9d30-32c67bc23fc9","event_cluster_id":"124f0557-d721-4d00-9466-962e5e5fe3ab"},{"claim_cluster_id":"0eef7600-1d71-4d26-9e91-3c6e5b0c6121","event_cluster_id":"bf67fbdf-c97d-45ea-aca3-181ca579afe4"},{"claim_cluster_id":"3d52b30c-fa0d-4a4c-9240-38abdfc6ab20","event_cluster_id":"0a56e25c-3625-49c1-8cd1-fb3ddd10b2d3"},{"claim_cluster_id":"b2635760-bcd6-46c7-88fb-9bbbb7349033","event_cluster_id":"777f19d6-a14f-4d35-a3bb-15bb93dcdf4d"},{"claim_cluster_id":"7b81ca4d-8e93-46ac-878f-890570c00638","event_cluster_id":"1760a439-ca46-4fac-8653-21cfe35d860c"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"23bd5333-419d-453d-bf08-b1b6ca7b3af3"},{"claim_cluster_id":"72804ca3-611f-4b19-ada2-8bfb14c2e98a","event_cluster_id":"1604ef4f-6382-4413-9253-925958021968"},{"claim_cluster_id":"1b36c1d4-6613-4a77-b192-f653249b73a3","event_cluster_id":"c1d2e607-4b20-4663-b826-18bf9ec884ab"},{"claim_cluster_id":"d2c2f402-f56b-4dfa-98d3-daf63239156d","event_cluster_id":"b68b2c64-2b71-44ac-a7b3-c79fe12186bd"},{"claim_cluster_id":"d68f430a-9578-4b21-a27f-13f1a9f8f629","event_cluster_id":"b5f5096f-4606-455f-8c76-949d5ee72c79"},{"claim_cluster_id":"626035be-3dc2-4608-b822-013ba6260905","event_cluster_id":"4b3adf55-a27f-47ae-8d76-9cdeb5e8523c"},{"claim_cluster_id":"291e098d-0f3d-4fff-9906-3b21ed1a33a1","event_cluster_id":"835823ac-6b1a-4b3a-9f19-567a3d13955c"},{"claim_cluster_id":"0998688e-32a8-4d44-8338-04f2bfaf29d8","event_cluster_id":"32b2643e-52f7-4ad5-a0ab-4120423c498b"},{"claim_cluster_id":"908a4168-b322-4057-a44b-a100dbffbe53","event_cluster_id":"b96bf2eb-4edd-4eb7-8c42-ee3fff5f4c9c"},{"claim_cluster_id":"3249ee55-684b-4bbb-8b52-6766f62838f9","event_cluster_id":"3b95c6b0-416b-4f6d-9aaf-3287913c0c2f"},{"claim_cluster_id":"9f4059ba-333f-4054-ba5f-f1cebaed747e","event_cluster_id":"33362f90-8163-4571-a6ec-1aa8d1d2470b"},{"claim_cluster_id":"73dcede2-49d2-4bc1-a599-b15a7d0094cf","event_cluster_id":"cd9fcff5-cee9-4a86-b076-bc2c105f1372"},{"claim_cluster_id":"26ee8f8d-a289-4bb8-af4e-67dfc3cca301","event_cluster_id":"f2b47c96-3e62-4d1a-98f6-547e71af6858"},{"claim_cluster_id":"e473874a-9cd2-4a8d-b926-9354bf1b7e19","event_cluster_id":"b95ab66d-3f95-45f0-b65c-f87d9de7b47c"},{"claim_cluster_id":"e64bcf93-086e-429d-9ff7-3a1518b3ae51","event_cluster_id":"48fd9ac4-d4c3-4877-b46e-dde80ecc5cd1"},{"claim_cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","event_cluster_id":"523ae438-64cf-40ea-839d-1a30cbcf4c63"},{"claim_cluster_id":"0f733538-ef56-427f-ad23-04cb6fae87ae","event_cluster_id":"4cf07546-b901-4002-a89e-1a6f0ae3d9e6"},{"claim_cluster_id":"09c923c5-0d10-40d6-8825-821711e43905","event_cluster_id":"60b30dc1-39f7-4e54-a8fe-0ca30098499b"},{"claim_cluster_id":"aae0458a-2ab8-46b3-a4d3-61a4d3fd85ca","event_cluster_id":"4c79fc69-3bd0-4180-9718-8d85b8c9dd85"},{"claim_cluster_id":"2567422d-b366-451c-a271-4cb76dc8196c","event_cluster_id":"3514e7b6-1754-4c84-b69f-d0a9d29a661f"},{"claim_cluster_id":"e521c1db-8ae4-48b6-83c6-efbd02701f4c","event_cluster_id":"0e5eec12-2ab9-484e-b6c4-cc88a7b6912e"},{"claim_cluster_id":"2b5a0f4e-cd2d-4769-bb84-41f0d92c90f4","event_cluster_id":"1de54c8a-0e53-4b6b-8b96-dacd9745e0a3"},{"claim_cluster_id":"f4e47d52-0a9c-4a42-9a14-47aece599116","event_cluster_id":"11246355-e976-4176-b4cb-550c91543955"},{"claim_cluster_id":"4a277b87-4d75-4b75-9416-adcbd06c3a69","event_cluster_id":"d2a4fdc2-883c-43bb-be4a-653d77acf7ba"},{"claim_cluster_id":"35ff7a5e-40b8-42ad-9379-7ba830c9445f","event_cluster_id":"f0462ff7-d9e3-4bd0-94ad-a4653debf7f6"},{"claim_cluster_id":"1ae95d89-cea7-4f27-8ed8-d4f49e95c5db","event_cluster_id":"37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b"},{"claim_cluster_id":"66cd9492-ff5e-477d-9ab7-967722c94dcd","event_cluster_id":"a8aac635-8bd8-48b4-bd49-e815a9015bf1"},{"claim_cluster_id":"732c6dc2-1231-46ca-b1c1-173c0f488176","event_cluster_id":"759b22c3-b9e1-49af-a4a6-7bcb4d79d24f"},{"claim_cluster_id":"edec9892-cca5-4a34-b102-ebb0bb45e077","event_cluster_id":"fe1c4a63-bcaf-4dd2-88f2-589a45ffdabb"},{"claim_cluster_id":"29469bb2-a496-413c-802b-5a8d1b46d374","event_cluster_id":"f471f0e2-f8be-4060-8f3a-33826e6e00b4"},{"claim_cluster_id":"70a36c06-fbb9-4f71-bf77-74f433672b24","event_cluster_id":"be7b3105-d76a-4aca-86c4-5d724f3e84ce"},{"claim_cluster_id":"612e1b04-721a-48bd-b18f-300c7c5af276","event_cluster_id":"7751d40e-e8dc-4a49-ab80-48cd61a84607"},{"claim_cluster_id":"d6705dc8-8def-4060-882a-9c13b62a23ad","event_cluster_id":"82f5beda-b460-413d-ba52-232c56bac459"},{"claim_cluster_id":"c7ef9b18-ebe3-4671-b0fa-73fbca2b91c9","event_cluster_id":"1bb75de7-fa9e-48e1-9651-ee91dc1ce93e"},{"claim_cluster_id":"01611d1d-46c6-40fa-ad44-4b4dcb9a85fa","event_cluster_id":"6a85e8dd-d86f-4e00-b252-62364be2e0ab"},{"claim_cluster_id":"8b0aef83-1693-4fa2-8559-a133b18a2dbb","event_cluster_id":"16e2933e-aa5c-44ff-81fe-873695154b36"},{"claim_cluster_id":"f74715cf-7efc-4866-8a83-4aec1b75795e","event_cluster_id":"186e2ceb-09a9-47a1-9aac-0510446000af"},{"claim_cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","event_cluster_id":"c99071d0-4f9f-4d85-a471-8ed03007f96c"},{"claim_cluster_id":"7576470b-cafe-4c17-9541-256e9ec07097","event_cluster_id":"1fcf44f5-43a5-44f5-b144-1142863197ac"},{"claim_cluster_id":"bd5ae3e5-8ac9-4557-ad42-7cdcb0687b6c","event_cluster_id":"59b16d26-5dcb-404b-8589-2b9a2089c70d"},{"claim_cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","event_cluster_id":"e42d141d-80cc-4e68-848e-2d85ecf6a58c"},{"claim_cluster_id":"174a0855-e1b9-4e2b-9a6a-957eb12d4b1a","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"e684bea9-83ef-4337-93a3-80b8a3708ae0","event_cluster_id":"c3a97d86-3ef3-41b9-9b1d-e19ad5caca74"},{"claim_cluster_id":"5f9b6057-0fab-4c3c-b1af-a7c26bc6c692","event_cluster_id":"930472a6-b976-45c6-814a-9c87d52eedd0"},{"claim_cluster_id":"36b91493-5f3f-412b-a861-2328c6420cc6","event_cluster_id":"6528a411-ccde-4df7-8364-b5129e53c388"},{"claim_cluster_id":"fa9ba14d-4628-4fac-b94e-953f493cb218","event_cluster_id":"d6f2ede4-7d0b-48ff-b867-ebcd3c6ff871"},{"claim_cluster_id":"5f1a9137-7798-4811-b69e-bc8d7d163c7c","event_cluster_id":"f3b3b03f-2658-4df1-9b64-e36964888fbf"},{"claim_cluster_id":"7885c5ae-734b-4d64-8d84-fc50b9a87ad7","event_cluster_id":"4485e5d3-efcb-4d42-a185-349293bfd550"},{"claim_cluster_id":"8f4c47af-fb0d-428c-b422-7767f77bc38d","event_cluster_id":"784c345c-143d-4aef-b094-6eba2f83003c"},{"claim_cluster_id":"12dfa7c9-8817-4f21-ad00-1e4244142b34","event_cluster_id":"06455359-79a6-4ebb-a802-9c4a2595559c"},{"claim_cluster_id":"9367c0e9-bbdd-4398-9de3-210a1f73c88e","event_cluster_id":"0103bebb-a8e1-4ccf-b716-fa6fd4687ac3"},{"claim_cluster_id":"2870dcce-8def-47de-9196-c66889a0a474","event_cluster_id":"d8891f2e-5868-4443-b59d-cc8c86215171"},{"claim_cluster_id":"e4184b4a-b3b8-45cd-9a60-442e840d1a7e","event_cluster_id":"ae19516a-2181-488e-ac04-088ae5ab7d84"},{"claim_cluster_id":"481b0645-4bcd-4df1-ae15-b184375e551e","event_cluster_id":"f6a33dd1-9465-4406-a3a5-1949cd825e71"},{"claim_cluster_id":"2cb0cf7d-4f72-4e53-9096-b92c1763568c","event_cluster_id":"28c6580f-d2db-4b2f-a0b5-3530cff5de7f"},{"claim_cluster_id":"2cb0cf7d-4f72-4e53-9096-b92c1763568c","event_cluster_id":"4ce53ac2-ac2e-43cc-ab0a-b530b8f75695"},{"claim_cluster_id":"f7c875b0-a0b4-45f6-b382-0915f179b2e6","event_cluster_id":"d1dbd6e1-d934-4ffc-ba5a-8d6ce10501d3"},{"claim_cluster_id":"b4e4a860-8721-4ac3-8eb3-a9dec18b336d","event_cluster_id":"03b556ab-fe42-4f7d-954a-c2484c0fac43"},{"claim_cluster_id":"32dde553-bbf3-44a2-afd4-d60807ce0ab7","event_cluster_id":"39ba0d7c-5f4e-43e3-b6a2-9f87693ee149"},{"claim_cluster_id":"db5a201e-a58a-46dc-91a0-0072432f56c4","event_cluster_id":"442ff222-51e2-4836-a92e-ab5d99d9d014"},{"claim_cluster_id":"ef636ecf-8b34-4007-8f71-b4d5ed7d3c33","event_cluster_id":"8abd35db-2186-4408-8be6-3af382d275ab"},{"claim_cluster_id":"d59582f7-7e86-41f9-a084-db1da2a740db","event_cluster_id":"34d1bb66-1439-414b-aa89-28ecbed93a5f"},{"claim_cluster_id":"9d85f9b8-6204-4844-9707-8c2e9351d730","event_cluster_id":"44c4daf8-52fd-4dfa-a4a2-a1a6455b27ad"},{"claim_cluster_id":"7c2161be-91e7-4c74-9f49-fb997b3c5857","event_cluster_id":"aa771524-1314-4f8e-8195-c42cbd659c66"},{"claim_cluster_id":"962affe3-ba24-4db1-8a1a-d157fa469f0c","event_cluster_id":"6e27c008-554e-490f-bd40-be5dceee83e2"},{"claim_cluster_id":"300e8b62-ec91-41e2-9809-166d3f0a78b2","event_cluster_id":"8b7f2a67-267c-4f34-bf57-216f33b13adb"},{"claim_cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","event_cluster_id":"3b3110cf-93d0-4510-9837-e4eaf9f9a935"},{"claim_cluster_id":"3769f810-e5f7-4d0a-9821-1876b6cadf34","event_cluster_id":"f2a2ed3b-6c1b-49ef-92fd-f294f1deb809"},{"claim_cluster_id":"e50a9fba-a791-4b5a-bed8-e0accc690c1a","event_cluster_id":"72967666-4eb9-48c4-a9dc-dc51036d287d"},{"claim_cluster_id":"9314aa75-84de-490c-95e7-6484ecdba212","event_cluster_id":"978715ff-b53c-4912-969e-25b8f2aa2ba5"},{"claim_cluster_id":"5e128621-af42-4a93-b091-b4e768efec3b","event_cluster_id":"06fc9106-7925-4cb4-a52c-592a739aee82"},{"claim_cluster_id":"e7287d47-759e-41f0-9641-093ab1e3e04c","event_cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965"},{"claim_cluster_id":"269d367a-5938-4087-911a-3256c10a910f","event_cluster_id":"5b30c301-097d-4b93-b41c-2c7775c1b518"},{"claim_cluster_id":"60b95622-d70d-459f-9ef4-53d53c239154","event_cluster_id":"d291acf3-7cf8-4c9d-9ab4-df11bad39953"},{"claim_cluster_id":"9dc5b38b-c904-4a4b-b9f9-a33166585c43","event_cluster_id":"cd18cc59-c362-4812-b494-ea37654755a0"},{"claim_cluster_id":"4d2dc30e-97f5-49d3-80df-c343048e6856","event_cluster_id":"eea04632-7eb6-45a8-afd1-95556afba561"},{"claim_cluster_id":"bf76e0b1-c54e-4ab8-82d0-979d68c35a65","event_cluster_id":"fe5accb2-754b-4498-82d5-eaf3b4116254"},{"claim_cluster_id":"eea02be7-fd53-47b5-9804-7a2f89de23f2","event_cluster_id":"eb5867fb-4e30-491e-839e-081457361ded"},{"claim_cluster_id":"8d550fbc-5131-4294-a815-b9e32f81ad7a","event_cluster_id":"ce319c6f-8ace-40b1-be7e-933bd39cd9c5"},{"claim_cluster_id":"c214c388-1bcb-48de-9ccf-d250135ec39d","event_cluster_id":"71920f88-d391-4321-a826-7f3d2ac6a5db"},{"claim_cluster_id":"c6d2f5c4-bb51-435b-a664-174b47ed38ef","event_cluster_id":"fe271a39-4283-4ba9-9f74-a4db31cc4b3c"}]}');


var $6a14c484c9a01c5f$exports = {};
$6a14c484c9a01c5f$exports = JSON.parse('[{"cluster_id":"a144123b-7815-4a8e-939f-d8124e0d4a23","title":"NATO approves JSEC creation in Ulm"},{"cluster_id":"c25ff750-8a41-47e3-b517-245284092082","title":"RAMSTEIN DUST-II Tests Deployable DACCC Capabilities"},{"cluster_id":"b3ad6dbb-7c3b-48ed-bb71-5bd926728024","title":"Central Communication Port Enables Rapid Deployment"},{"cluster_id":"ba65859b-0b3d-4140-bf84-cf55b1252051","title":"Ramstein: Public US/NATO Hub"},{"cluster_id":"591d0c93-3cfa-4639-9dee-c69a3f6b0f9b","title":"US Troop Rotations, Armor in Poland"},{"cluster_id":"ca62b0d7-872b-4a9c-b006-86ccfd239161","title":"Trump in Warsaw: Strengthening U.S.-Poland Ties"},{"cluster_id":"1b2e8a52-7038-453e-802e-e2b6d0c4da48","title":"CPK Airport Rail Hub"},{"cluster_id":"e80fcdb9-26cc-4925-8100-e10e8d09e8d6","title":"U.S. Troops Arrive in Poland"},{"cluster_id":"75d93b8c-bf4b-43d0-94ef-7db799889fc5","title":"Ukraine\'s Orange Revolution: Court Orders Rerun"},{"cluster_id":"14c3f0e3-2371-447c-8445-1ac6c299f633","title":"UN Declares Crimea Referendum Invalid"},{"cluster_id":"3465d409-db96-4545-a6fb-c388765f1b4a","title":"Ukraine\'s High-Level Diplomacy in Africa"},{"cluster_id":"471ac06a-ad1e-40a8-b238-859f31d2504b","title":"Ukraine Arms Exports to Sub-Saharan Africa"},{"cluster_id":"019a6206-d313-408e-aa7d-dd9ebfe68ec1","title":"May 2014 Ukraine election amid conflict"},{"cluster_id":"7fe41e18-746f-4276-85f6-d30d85eaa538","title":"Poland passes resolution creating CPK"},{"cluster_id":"fdec6a13-5351-4fa5-9920-1456738e3b76","title":"Ukraine Announces New Africa Policy"},{"cluster_id":"8b5f2de0-fd72-48f3-8849-4ef20748a393","title":"Ukraine Opens New African Embassies"},{"cluster_id":"af431814-360b-4c41-83d1-6147d4068846","title":"WHO Declares Monkeypox a PHEIC"},{"cluster_id":"20e0f6a7-71df-44b4-b99e-3e278ca655e8","title":"Illegitimate Ukrainian presidential elections"},{"cluster_id":"bf1a6f6c-5e34-4a7f-9afc-2b63e460cf67","title":"Russia\'s Coup and Illegitimacy Claims"},{"cluster_id":"329efe6d-0194-47fc-abcf-cc9c3ee312f8","title":"Saber Strike 2017 Mobilises Troops"},{"cluster_id":"08f28ba1-ced8-47f4-a0a0-4116b507d143","title":"WHO adopts mpox, drops monkeypox"},{"cluster_id":"5d65bb29-7381-44ed-8856-ec52d73d0a76","title":"WIV Safety and Staffing Cables"},{"cluster_id":"586b0585-af30-4d40-9796-01be4c00d08c","title":"WIV Researchers Sought Hospital Care, 2019"},{"cluster_id":"2bfeada4-b9e0-40b4-9be2-0655b8d49226","title":"US Orders COVID-19 Origins Review"},{"cluster_id":"53832c20-28bd-4cb2-a22b-7698f81c17f5","title":"U.S. Secures Jynneos Vaccine Contract"},{"cluster_id":"a815c927-5e75-49a5-ad08-40e7381924c6","title":"SARS-CoV-2 Origins: China Part"},{"cluster_id":"77e5cfa7-27f5-40a9-879d-0ba7cd2177f2","title":"Unutilized COVID-19 Vaccine Stockpiles and Write-offs"},{"cluster_id":"f731bc0b-cabf-4314-a5f8-e94d31589cea","title":"Misinformation: Monkeypox Transmission Claim"},{"cluster_id":"9ffb85b8-5080-4f27-85ad-554406cf7402","title":"Wuhan Institute Assembles Monkeypox Strains"},{"cluster_id":"96b587fb-4363-4d46-8a28-162c4f6a688e","title":"Parvovirus B19 Rebounds in Europe"},{"cluster_id":"eb6475eb-91f7-4af2-a9fa-7784d03f74bc","title":"Public Awareness of Airborne Transmission"},{"cluster_id":"7a5b8ce2-31ac-42cd-bb98-cbeddcf8542a","title":"HHS Orders JYNNEOS Doses for Stockpile"},{"cluster_id":"9df4486f-c8aa-4f08-a8cd-4ae02c748318","title":"Alleged Engineered SARS-CoV-2"},{"cluster_id":"3dc82114-c98e-4342-a6ab-854d95d9efa7","title":"Lab-Engineered SARS-CoV-2 Deliberate Release"},{"cluster_id":"c13ce96e-915f-4306-8b30-419b42135227","title":"Conspiracy: WHO Vaccine Stockpile Scheme"},{"cluster_id":"61dc215b-cc5e-49f1-add7-65f02e137ed1","title":"Zelensky Urges Faster Allied Aid"},{"cluster_id":"20d5e5ed-4ce5-4a63-9b10-3e468d3431e2","title":"CDC Guidance: Infectious Period 2\u20134 Weeks"},{"cluster_id":"b13b5ee0-1421-43e8-a554-5b3888a5cac7","title":"Embassies Evacuate Kyiv Staff"},{"cluster_id":"470e1b16-db3d-4438-9038-d9ecc0d37edf","title":"Donbas Displacement in 2014"},{"cluster_id":"efac6d2d-0cde-45fa-bbfd-2de2e2cbe0cc","title":"IT professionals relocate for safety"},{"cluster_id":"f184f109-b4af-4d4c-b5c2-73e631545fd2","title":"Avian Influenza Zoonotic Risk Assessments 2023\u201324"},{"cluster_id":"2e675266-c3ed-4fac-a036-217c24ac28e2","title":"Hostomel Airport Assault, Kyiv Frontlines"},{"cluster_id":"5e5c65ad-4c51-4a27-ad63-eac217deb431","title":"Boy Killed in Kharkiv Shelling"},{"cluster_id":"5d6331d6-8b39-45dc-b069-c03168d82aac","title":"Turkey\'s Bayraktar TB2 Support for Ukraine"},{"cluster_id":"5d61b2e4-bbeb-403f-8746-07ecabf64059","title":"Civilians Flee Kyiv Amid Chaos"},{"cluster_id":"d47fde78-a16e-43e2-a490-d66e81b31f7c","title":"Ukraine IT Sector Size and Mobilization"},{"cluster_id":"8e28231d-7117-46be-8655-ac03e3ec9b13","title":"Partial U.S. Drawdown in Ukraine"},{"cluster_id":"127c457b-8cad-4a81-8d25-66dd51786fe0","title":"Ukrainian President Flees Kyiv"},{"cluster_id":"a3fb53d1-a6ae-44eb-bbcd-c1dcae90629f","title":"Russia Threatens Ukraine\'s Civilians"},{"cluster_id":"2648c3b9-64e2-4596-9353-c37ae996dcce","title":"Missile and Drone Attacks Across Ukraine"},{"cluster_id":"bfc6790e-9007-4b03-90bf-5da6fcce01b7","title":"Ukraine Loses IT Specialists"},{"cluster_id":"823656a1-093a-4e85-b706-f48d18e40c29","title":"Erdo\u011Fan Offers Ukraine-Russia Mediation"},{"cluster_id":"e25eede3-3242-446d-a439-2c4becea51cf","title":"Zelenskyy offers condolences, seeks Turkish aid"},{"cluster_id":"bc618add-d50a-4d41-b375-e0f4e3b7232b","title":"Russia Recognizes Donetsk, Luhansk; Deploys Troops"},{"cluster_id":"e21a96d2-b5b0-4a69-80bb-66020b0b8a54","title":"Media Coverage of Ukrainian Refugee Flows"},{"cluster_id":"954a4240-7358-4649-966c-6f08bf5b088e","title":"Kyiv Embassies Evacuated Amid Russian Offensive"},{"cluster_id":"f7069e5f-ee25-470b-986d-c157ab1e1613","title":"Turkey Supports Crimean Tatars, Crimea Return"},{"cluster_id":"97b1177e-80bf-4e09-83e5-b50aecee0b52","title":"Global Tech Firms Aid Ukrainian Staff"},{"cluster_id":"0480c8ed-40a7-40dc-ac24-9b8fa7551edc","title":"Kyiv Curfew: Shelter and Defend"},{"cluster_id":"02e73dfc-86f2-4fe6-a79c-d071e07721fd","title":"Putin launches special operation in Ukraine"},{"cluster_id":"76f2f5fc-c5b8-4d6e-932c-655254df8fc2","title":"World leaders offer condolences and aid"},{"cluster_id":"1bb3c826-37ca-4435-8ad2-e211e6cd9444","title":"UNGA Condemns Russia\'s Aggression"},{"cluster_id":"d86ea948-08a0-4829-9e48-4f9273b2967d","title":"Russia\'s War Aligns with UN Charter"},{"cluster_id":"554d8f5c-047a-4e8e-b996-038e567aa26c","title":"NABU probes energy sector corruption"},{"cluster_id":"c2417696-bc64-4d4a-b3a4-d5d9e3cefb38","title":"Kiyosaki: Ukraine aid pointless"},{"cluster_id":"7e303676-78ac-40b1-9448-471faabb2115","title":"Violent Euromaidan Clashes, Maidan Cleared"},{"cluster_id":"d8869910-ef23-4e2c-a1a9-778ac3a96b8c","title":"Zelensky\'s Call Yields Unprecedented EU Arms"},{"cluster_id":"cebef5fc-6d79-4e08-878b-8c75696aa6d2","title":"Kyiv Deserted as Ukrainians Flee"},{"cluster_id":"61922f77-a020-4916-b901-44fe7982b789","title":"Mandatory Residence Registration in Ukraine"},{"cluster_id":"4fe899cb-f73e-4ec7-b569-5ce5b990df8e","title":"Turkey Seeks Crimea and Donbas"},{"cluster_id":"edc9ab41-cf63-48e3-8098-f84524398358","title":"Passage of IDP Rights Law"},{"cluster_id":"9096173e-de4b-47e9-9e39-b39282b05e47","title":"Ukraine loses $1B on weapons contract"},{"cluster_id":"f7fbb95e-08d7-410a-8e1f-290e984463d7","title":"Pentagon Leaves $5.8B Ukraine Aid Unused"},{"cluster_id":"544dff2f-0e7b-440b-a330-646db7ed3912","title":"Nearing Deal to Extend Ukraine Aid"},{"cluster_id":"128d37ad-2ce5-409d-8ce0-e9df31085f42","title":"Pandora Papers: UAE Offshore Structures"},{"cluster_id":"b961ace3-c2b8-4138-bb7c-fb147b603dc5","title":"News Fatigue and Declining Engagement"},{"cluster_id":"66fb628f-853d-44dd-b0f9-617fd67bcaf1","title":"Sean Penn\'s Repeated Ukraine Visits"},{"cluster_id":"a15b9883-60ad-4e49-8943-56ed500ab8cf","title":"Corruption Probes Linked to Yermak"},{"cluster_id":"84bfa4ea-506b-4130-9931-592d2f7eb965","title":"Pandora Papers Reveal Zelensky Offshore Links"},{"cluster_id":"752e0a5d-00fb-472d-909a-65284c58e6d5","title":"Smear Campaigns Target High-Profile Activist"},{"cluster_id":"237bd391-bce8-490f-a9dd-8425795dc2e7","title":"Untracked $1B Weapons to Ukraine"},{"cluster_id":"5d1b0403-1447-4432-b6a8-ce335ce3e162","title":"Zelensky Approval and Trust Dip"},{"cluster_id":"b10b3160-e0dc-461b-a456-f6327586eb6a","title":"Arms to Ukraine: Delays and Surges"},{"cluster_id":"8585c4f1-4f02-4ac1-9a95-4cc381634f7d","title":"Ukraine uncovers $40M embezzlement for shells"},{"cluster_id":"bd1a5427-07c8-4a9a-b3bd-6c833ee88f8c","title":"Conservative Skepticism Over Ukraine Aid"},{"cluster_id":"6a5e4ef1-a4af-4de0-8b56-75c0ed9ae0bb","title":"Official French Ukraine Aid Totals"},{"cluster_id":"f1fff97c-e8ee-45ff-b0df-2544c89e909e","title":"Influencers Behind Ukraine\'s PR Machine"},{"cluster_id":"1b63ec5b-2010-4bd3-a351-328e7b4b5470","title":"Trump Slams Ukraine Aid, Impoverished Ukraine"},{"cluster_id":"b0b87d24-5072-4ac7-bf9b-5891dbcddd35","title":"Funds Diverted to Ukraine; Landmark Collapses"},{"cluster_id":"2c7cf7ec-47d1-4b9e-8095-5a313fd3166e","title":"Penn declines Ukraine trip over corruption"},{"cluster_id":"df948051-689d-40a8-ad8a-28a2dedfe405","title":"Conservative Media Question Ukraine Aid"},{"cluster_id":"e7287d47-759e-41f0-9641-093ab1e3e04c","title":"Bloomberg infographic alleges Zelensky looted France"},{"cluster_id":"b2e6976f-e5a2-4669-ac3d-3e87cd376f99","title":"Confusion Over Passport Issuance Reforms"},{"cluster_id":"fe6adf14-e7af-49eb-8b83-de4001fbc495","title":"Zelensky\'s Entourage Mediates Weapons Schemes"},{"cluster_id":"43e40d68-962f-4fc6-83f4-ab836f751e9e","title":"Ukrainian Activist: 9/11 Divine Punishment"},{"cluster_id":"55326ca1-c9a2-4aca-a1ea-bd63160c25ea","title":"Cosby Sells Second Manhattan Townhouse"},{"cluster_id":"cbddcfe6-4088-4603-8e7a-ed109a9fff44","title":"Ukraine arms procurement embezzlement charges"},{"cluster_id":"080cf60d-e4c8-43d3-806b-a47256c29458","title":"Cyprus: Offshore Secrecy for Wealth"},{"cluster_id":"455f3cb3-d253-4739-8dfa-e88137f7f063","title":"Abolition of Propiska and Registration Confusion"},{"cluster_id":"63fd0e17-6b29-4f19-b984-a861fba2eb14","title":"Zelensky Buys Cosby\'s NYC Townhouse"},{"cluster_id":"9bf70381-221f-4cfd-8e17-16f9ebb35e36","title":"Zelensky Online Interest Drops 63%"},{"cluster_id":"2672b11d-4ad6-44a1-9b31-f8c01c03c721","title":"Italy\'s Municipal Budgets Face Cuts"},{"cluster_id":"114c5c62-e2bf-4ad2-a913-3744fd25a373","title":"Trump orders temporary Ukraine aid pause"},{"cluster_id":"3a17531b-ae78-41a3-b63d-f61bcc85a26a","title":"Partial Collapse of Torre dei Conti"},{"cluster_id":"6a2c5b98-767a-485d-a14c-04f05f90984c","title":"Italy Extends Ukraine Aid Packages"},{"cluster_id":"5071d605-12eb-4c65-9753-bdff2ac75ffe","title":"Using All Authorities for Ukraine"},{"cluster_id":"21c29f8c-34b7-47c4-8021-91ec84cff803","title":"Alleged Zelenskyy aid laundering through UAE"},{"cluster_id":"77ffe8cd-d30f-4bde-8bb0-f1fd00ff5cdf","title":"Freedom of Movement and Residence"},{"cluster_id":"209803f4-b6ac-40bc-97b8-024102ee5865","title":"Anti-Corruption Agencies Search Yermak\'s Home"},{"cluster_id":"cfc42d88-49ac-4610-a5c7-0cce12304171","title":"SBU Probes $40M Mortar-Shell Embezzlement"},{"cluster_id":"49854b0f-e263-4847-a942-d2497d0d1530","title":"Owning the Weather in 2025"},{"cluster_id":"6363c274-1e0e-4e09-85b0-1412131b0c25","title":"Zelensky Cancels Senate Briefing Over Funding"},{"cluster_id":"902f069d-3703-489a-9dfa-fb26ee837027","title":"Secret Geoengineering Controls Global Weather"},{"cluster_id":"469e17e6-447a-4bc6-9bab-f2cb595f07e0","title":"Toxic Barium in Chemtrails"},{"cluster_id":"c9b6b0e3-811d-4e56-9eba-3408eb1dc06f","title":"Zelenskyy: Alleged U.S. Funds Cyprus Casino"},{"cluster_id":"f10425d5-24f2-425f-821e-7acb93c9e53b","title":"Enerhoatom Kickback Probe: $100M"},{"cluster_id":"0626769d-4a42-43f4-8356-e89543f6dcc3","title":"Weather Modification via Aircraft Sprays"},{"cluster_id":"e924815f-2da7-4209-b239-ad1c99e71b41","title":"Guidance for Solar Geoengineering Research"},{"cluster_id":"503eed9f-ea34-45f7-b3eb-f015bdc664b3","title":"UAE Targets Russian-Linked Banks"},{"cluster_id":"887d717e-5da6-4cf6-995c-bcee081cd128","title":"Official Endorsement of Solar Geoengineering Research"},{"cluster_id":"214ffe56-f58d-4fdd-a3cd-ef399506aa9a","title":"HAARP Transferred to University of Alaska"},{"cluster_id":"4d6e8834-c57b-472a-adbf-630fe4d997d3","title":"Declassified Popeye Cloud-Seeding Reports"},{"cluster_id":"994afb12-0656-46cd-8fc2-48a9ab17ddc7","title":"SCoPEx Test Paused Amid Controversy"},{"cluster_id":"ac3739e2-de75-46fe-a991-203fbc3a72e0","title":"Switzerland freezes Yanukovych assets"},{"cluster_id":"06aec0e1-946f-46e8-835f-efac40b3f6dd","title":"Yatsenyuk Rejects Debt Restructuring Proposal"},{"cluster_id":"45e218a6-8801-4755-bcad-4c7f5bec819d","title":"Germany\'s 2015 Sovereign Default Fears"},{"cluster_id":"939d6808-ee32-41c3-8d70-73aed1d043da","title":"Ukraine restructures $15B debt with creditors"},{"cluster_id":"f8e8b236-0393-4a1f-8e82-d30d9e30a2fb","title":"Russia Veto Blocks Crimea Action"},{"cluster_id":"719ee837-abdf-462d-a985-984d0a2eb167","title":"Western Agency Reports Kyiv Default"},{"cluster_id":"e512735b-aeb8-432c-9b72-89718eda18ba","title":"Ukraine Credit Rating Falls to CC"},{"cluster_id":"d9484da0-ca3b-450a-a45c-787783bba3e7","title":"IMF Delays Ukraine Loan Tranches"},{"cluster_id":"1238fc85-6b69-4536-a793-8df12f63f9c0","title":"UNDP Ends General Budget Support"},{"cluster_id":"abd5930f-6db1-45e3-b882-ee3ba2f8394b","title":"Assets Linked to Yanukovych Seized"},{"cluster_id":"f9c980a9-33b9-4834-922a-947a13f5a035","title":"UN Withholds Funds for Ukraine"},{"cluster_id":"37512ba8-d5ed-4b9e-9fba-d0ec249a1d84","title":"Russia sues for eurobond repayment"},{"cluster_id":"8817a4d0-4aef-4c0e-a907-ff92179dff0d","title":"Ukraine Rebuffs Putin on Bond Restructuring"},{"cluster_id":"e8b94f0c-0366-40d5-b082-fa52ed608677","title":"Ukraine may suspend payments to Russia"},{"cluster_id":"3e491056-e070-48f7-a358-499c803ca16f","title":"Ukraine Strategic Humanitarian Response Plan (2015)"},{"cluster_id":"f690f627-f1e3-428b-9d01-bfb966953069","title":"Germany wary of Ukraine\u2013Russia debt lawsuit"},{"cluster_id":"5c5bbff7-5569-43a1-bcbe-db0b95585d05","title":"2017 UN Humanitarian Funding Shortfalls"},{"cluster_id":"92df53c2-d00a-4565-ac4a-1279aad1b2ee","title":"Ukraine Returns Yanukovych\'s Funds to Russia"},{"cluster_id":"615888f6-5d35-4a8c-acd9-9e71127a4cb4","title":"Ukraine Suspends $3B Russia Eurobond"},{"cluster_id":"7bfb1246-c004-4c78-a34d-8e0a5cdad287","title":"Poland Exits the EU"},{"cluster_id":"01d3c9ca-6075-43cb-a3ac-1d6094f7282d","title":"IMF Aid Contingent on Debt Restructuring"},{"cluster_id":"39719bfa-8761-4992-b42f-7b9ea44519ab","title":"EU Legal Action Over Refugee Quotas"},{"cluster_id":"6eb878e4-969f-49ca-8ac8-5c68ead2c13e","title":"Brussels Falsifies European History"},{"cluster_id":"2fc962c7-e77d-4ca3-a166-4f1d011720db","title":"Poland Probes Gazprom Over NS2"},{"cluster_id":"0b7703f0-770f-46f4-8c70-921a8b6b2ad7","title":"PiS strong in 2019 EP elections"},{"cluster_id":"05133a93-3ffe-4993-9c55-47f240923f20","title":"Poland Could Veto EU Budget"},{"cluster_id":"92dc2b29-cee7-4ea1-b9e9-d0593544c75b","title":"International Backlash to Poland\'s Holocaust Law"},{"cluster_id":"dcbc849b-d40e-49ed-84ab-ec7cdf4bb695","title":"EU Remembrance Projects Funding Calls"},{"cluster_id":"58d84750-75e5-4a06-9053-f1a5a8baf564","title":"EU Triggers Article 7 Against Poland"},{"cluster_id":"bbad87a2-fdaf-4bdc-9b37-124a381131af","title":"Poland Expands EU Influence Against Germany"},{"cluster_id":"8aaf61a8-4245-40d4-9036-3767a2a55c98","title":"Poland Grants State Control Over Media"},{"cluster_id":"fced5669-e70e-41e7-920b-f76f2f50557d","title":"Poland Blamed for World War II"},{"cluster_id":"5e700671-a24a-4c8f-a1e4-abbfb82f4537","title":"Cattle Methane: Minor Climate Impact"},{"cluster_id":"9e537f59-fc8d-477f-937c-489e24e51014","title":"Poland: Police Crackdowns on Peaceful Protests"},{"cluster_id":"0031fe05-7e53-4c0c-b89e-d86016e53d57","title":"Poland Press Freedom Decline 2016"},{"cluster_id":"fe5794f0-39d5-4958-9baa-650967c24ce0","title":"Protests after signing contested judicial reforms"},{"cluster_id":"96cc3b99-284a-4ca8-957e-5bfc2a13a654","title":"Warsaw Adopts Moscow Silencing Tactics"},{"cluster_id":"39687812-944b-4418-ada5-3588be43da66","title":"Pathways to Lower Livestock Emissions"},{"cluster_id":"37dc3c46-39b6-4d4e-87ad-59040db4662a","title":"GWP* Methane Metric Debate"},{"cluster_id":"ebb3d42c-9f56-4324-89bb-dcd764d2d3e5","title":"Mixed evidence on grazing carbon gains"},{"cluster_id":"a7fcff89-a4a0-45c3-b800-3d7861e64986","title":"Expert Consensus Against Secret Spraying"},{"cluster_id":"6ecdc168-b4c6-42e6-a45f-27cde46257e5","title":"Agriculture and Livestock Drive Methane"},{"cluster_id":"ddce8749-8091-45b0-8366-637dbe518fa7","title":"Beef Industry Advocacy Campaigns"},{"cluster_id":"69290a80-8807-401f-b38b-0ff5ba27a43d","title":"Raising More Cows to Save Planet"},{"cluster_id":"637ffe03-032a-46cd-af4f-d7f5c220eab9","title":"FDA EUA for Hydroxychloroquine COVID-19"},{"cluster_id":"3b3110cf-93d0-4510-9837-e4eaf9f9a935","title":"Global Methane Pledge Launch at COP26"},{"cluster_id":"ed8f044f-96b2-4a20-8622-207bfd8ae25b","title":"Meat Industry Net-Zero Commitments and Reports"},{"cluster_id":"9610bc6c-2c1c-47d3-bb20-3bc619407fd0","title":"Quercetin and EGCG as Zinc Ionophores"},{"cluster_id":"84df1dd4-8c28-4b8a-bdf1-47af884e70e3","title":"Chloroquine acts as a zinc ionophore"},{"cluster_id":"5102f7b6-4554-4836-b695-c4ff3c598adf","title":"Zinc\'s Protective, Antiviral Role Against COVID-19"},{"cluster_id":"9ff8b495-2fb3-4416-a1b0-68b8560f98e4","title":"Zelenko\'s HCQ-Zinc COVID-19 Protocol"},{"cluster_id":"8dd7ebbb-3984-4b46-ba7d-93103becac60","title":"Hydroxychloroquine: From Consensus to Reversal"},{"cluster_id":"398a087e-4a63-4bd1-8ad7-e71ca757db9e","title":"Joint FDA Actions on Hydroxychloroquine"},{"cluster_id":"a222bbbf-dfe3-47ea-9ab7-93e4d89e7fe7","title":"Zinc Inhibits Coronavirus Replication"},{"cluster_id":"92103df4-5a66-4430-95e6-d2ba83f705a1","title":"Early Outpatient Treatment Rationale"},{"cluster_id":"25733340-8065-4c67-9da5-97f671877eea","title":"Trump-Driven Hydroxychloroquine Promotion"},{"cluster_id":"42b243b1-6e2f-4145-911d-1a4fb97435e4","title":"Remdesivir, chloroquine inhibit SARS-CoV-2 in vitro"},{"cluster_id":"181f2787-76c0-40c9-96f6-869aa09e8172","title":"WHO halts hydroxychloroquine arm"},{"cluster_id":"ff0ce5bb-be48-47e9-b45d-0dcc4c13bdb8","title":"NIH Concludes Chloroquine Stops SARS"},{"cluster_id":"4b36afdb-64c0-4dfe-8f4d-501930c59107","title":"Surgisphere Hydroxychloroquine Retractions"},{"cluster_id":"21fe7786-1dcc-45ac-a61c-02ecaf1a0ceb","title":"Contested HCQ Azithromycin Zinc Cure COVID-19"},{"cluster_id":"e90ef9df-5189-4af1-8d38-f4bc22fa022a","title":"Early Marseille HCQ Trials: Viral Clearance"},{"cluster_id":"17ce8541-8518-4283-a893-e35ad31e95fb","title":"Fluoridated Water and Infant Fluorosis"},{"cluster_id":"4005f43b-5b4a-44f8-9781-c0a91127368f","title":"Fluoride and Neurodevelopment: Emerging Evidence"},{"cluster_id":"636dbb94-cbc8-4c79-b785-6d406b28db48","title":"Zinc Ionophore Linked to Reduced Mortality"},{"cluster_id":"1469928a-aef7-459b-af14-6d6ac0ca72d3","title":"HCQ Trial Claims COVID Death Reduction"},{"cluster_id":"a6506a53-789c-4447-b726-b2dd59d9b862","title":"False Cure Claim: No Masks"},{"cluster_id":"8bcf86f9-8509-4d9f-8550-8839a96fa515","title":"Fluoride Health Risks and Effects"},{"cluster_id":"71c5fa4a-0b53-4202-9b3e-1c8038451d63","title":"Rising U.S. Dental Fluorosis Prevalence"},{"cluster_id":"8b3203a2-f473-4957-9689-fdf6ee974697","title":"No Fluoridated Water for Infants"},{"cluster_id":"498d40d5-5e43-40ad-a2cf-e0c8dead042f","title":"FAN Campaigns Against EPA Fluoride Regulation"},{"cluster_id":"db9b9c53-4b26-4d88-83d5-c4c2d8189711","title":"Transcarpathia seeks autonomy from Kyiv"},{"cluster_id":"28ea99a2-454e-42c3-b308-cf4739fc9a02","title":"Mukachevo Shootout: Right Sector vs Police"},{"cluster_id":"aec45825-35ee-46b7-b2b8-bea6a7f40f69","title":"Rising Hungarian Activism in Zakarpattia"},{"cluster_id":"a7f8bf9e-86b1-4c85-bc02-6ee66c4f9e1f","title":"Ukraine Education Law Sparks Hungarian Protests"},{"cluster_id":"61ac97d3-e62e-41a3-b910-360985f7af21","title":"Dangers of Fluoride in Toothpaste"},{"cluster_id":"b60886b0-36f1-4d60-bd61-b45768791dc2","title":"Fluoride Toothpaste Warnings and Poison Control"},{"cluster_id":"48f7f24e-52e0-4527-a4e1-e5a83b50fb40","title":"Right Sector Demands Avakov\'s Resignation"},{"cluster_id":"503584d7-75a5-4f03-adb1-4844dd4d9b9f","title":"Fluoride Reduces IQ and Damages Brain"},{"cluster_id":"83cb9288-d8bc-4d51-803b-71e04c61fa41","title":"Zakarpattia: Together Yet Divided"},{"cluster_id":"3680c45d-b58c-4b06-86cb-3a65bd43ebc6","title":"Moscow Amplifies Rusyn Provocation"},{"cluster_id":"b53db505-a920-4607-b45b-0f9423ee6d04","title":"Ukraine Loses Control in Transcarpathia"},{"cluster_id":"63217c83-a56a-4703-b9b6-f928b5437b8a","title":"Military Equipment in Government Response"},{"cluster_id":"d0ea565b-64ab-44f3-9679-c2236d37aa42","title":"Yatsenyuk Replaces Zakarpattia Customs Officials"},{"cluster_id":"784725f9-7f56-4fd8-bbd1-9c94d01f5505","title":"Yatsenyuk backs Right Sector"},{"cluster_id":"bd148f49-6e19-46a6-bfe3-a19a292ab17a","title":"Zakarpattia Self-Determination Rally"},{"cluster_id":"17dbd7df-f3d1-4902-a103-f97b03017681","title":"Helicopter Fire Strikes Right Sector"},{"cluster_id":"91a996d6-946d-4317-a60d-c7b9088e7854","title":"White House Declares COVID-19 Emergency"},{"cluster_id":"09505049-ee83-46bc-bc41-216c4501ccc0","title":"Government Vaccine Mandate Proposal"},{"cluster_id":"be17c081-a4ac-42d9-b909-7a4f19b8160b","title":"Trump and Officials Forecast Vaccine Soon"},{"cluster_id":"2c49dd92-a97e-4b1e-bac2-607670a0a86d","title":"Rapid Thalidomide Approval, Birth Defects"},{"cluster_id":"51a5661a-48dd-44af-9a97-7d7620877cc6","title":"Police Chief Suspended; Inspection Launched"},{"cluster_id":"4863edc0-3025-4ffa-ba81-0d1ed977b2b9","title":"Trump urges FDA fast-track COVID therapies"},{"cluster_id":"4fc8d532-69fa-40fd-b28d-a301335dc7b8","title":"Phase 3 COVID-19 Vaccine Trial Begins"},{"cluster_id":"1541313e-804f-40cb-bfb7-78850471987c","title":"Transcarpathia: Identity, Language, Autonomy"},{"cluster_id":"72fcc1d4-63ac-46e2-af29-194e69352aec","title":"Ukraine Blocks North Crimean Canal"},{"cluster_id":"25676d7b-137f-4f70-b3ce-39af6bc7a4fe","title":"First Participant Dosed in NIH-led mRNA-1273"},{"cluster_id":"a6f0d89a-0c3c-4be5-83c6-b064b8a9c73a","title":"Aksyonov Acknowledges Unprecedented Drought"},{"cluster_id":"c24c8055-1228-411e-82e6-d5cc151796a6","title":"COVID-19 Thalidomide Trials Registry"},{"cluster_id":"4693632f-2c46-4370-bcbf-41570c0b3112","title":"UK Coronavirus Act 2020 Expands Powers"},{"cluster_id":"f004205a-4f06-4d9f-aafe-357afc465bbc","title":"Kherson Dnipro Pontoon Crossings"},{"cluster_id":"28e936b6-8a48-4d96-b4e6-7c0ff60a51fd","title":"Dnipro River drained for troops"},{"cluster_id":"63fb948c-76fb-4787-aafa-ea3ce79ec01f","title":"Russia Captures Kakhovka Hydroelectric Plant"},{"cluster_id":"7c1fc423-517b-4edd-ab51-ee1fbb6a01c1","title":"Water Crisis in Occupied Crimea"},{"cluster_id":"bd9f40ee-8b97-4557-aa2d-1a87da031fda","title":"Dnipro Canal: Crimea\'s Water Crisis"},{"cluster_id":"9142e74b-a217-4be0-8685-ab7ea89b683d","title":"Crimea Water Blockade Disaster"},{"cluster_id":"4820d7d4-870f-4e7a-a8c2-d7d211e6e9b9","title":"Crimea Faces Drought, Ukraine Says"},{"cluster_id":"b9b5e870-c720-4c60-8d9c-ce6b4803fb78","title":"Warnings About Dnipro Dam Threats"},{"cluster_id":"4e48f414-895d-4241-a8ae-69662f5c3d46","title":"Wartime Destruction of Dnieper Dams"},{"cluster_id":"a5408918-67c4-45bd-afb3-95d8aced1dc9","title":"Russia Cuts Dnipro Water Supply"},{"cluster_id":"e3403237-7c1c-4e7a-9604-df8d11301d8d","title":"Kyiv Allocates Funds for Eurovision"},{"cluster_id":"abbfb703-6da3-4a58-9c1e-a58cf34e5030","title":"Kyiv to Host Eurovision 2017"},{"cluster_id":"d3accedd-14e9-432e-a272-98af2dae3b98","title":"Nova Kakhovka Dam Damaged by Shelling"},{"cluster_id":"13f086c1-e440-480a-a882-8d8a742c1d5e","title":"Dam Supplying Crimea Blown Up"},{"cluster_id":"80a02b1a-c045-453f-ad92-9681e40dad83","title":"Ukraine seeks funds to host Eurovision"},{"cluster_id":"8fed35fe-4af1-484a-bd4d-74f9fac960c8","title":"Kyiv Hikes Electricity to Fund Eurovision"},{"cluster_id":"2929fcf7-736c-4b1c-b178-3fc95f1bce0c","title":"Ukraine may forgo hosting over costs"},{"cluster_id":"2ffd0f52-9465-49d4-9f47-900078ad3209","title":"Jamala Wins Eurovision with 1944"},{"cluster_id":"da21d9c5-68a7-4237-9343-1a8df452b146","title":"Rising Household Energy Tariffs"},{"cluster_id":"e42f3c12-f894-47fd-b892-02c051609420","title":"Eurovision moved to Moscow"},{"cluster_id":"b7f1648b-9e5b-476f-a59b-84d94f8583e3","title":"Eurovision resignations over transparency and finances"},{"cluster_id":"13bcef3e-fd19-4989-b312-5873b1468a28","title":"Eastern Ukraine Faces Acute Water Shortage"},{"cluster_id":"a3c357ac-5159-4eec-ad16-09366a144d09","title":"Damaged Protective Levee in Ukraine"},{"cluster_id":"e42d141d-80cc-4e68-848e-2d85ecf6a58c","title":"Shelling Halts Donetsk Water Supply"},{"cluster_id":"21d331a6-d043-465d-88ff-572098f9f48c","title":"Severe Storms Trigger Floods, Rising Rivers"},{"cluster_id":"6a14502a-8c63-426b-8062-c7e8472786ee","title":"Continued Shelling Damages Water Infrastructure"},{"cluster_id":"14d0a92d-65cb-4881-998f-aed067993e99","title":"Water Access in Donetsk and Luhansk"},{"cluster_id":"6ad5a7cb-930f-4fcb-91a9-e3eccb8d8cb0","title":"Ukraine Wins Eurovision, Must Host 2017"},{"cluster_id":"d64f3c9d-c55d-4ebc-9a01-43d63af153f0","title":"Open national host city, shared risks"},{"cluster_id":"8845b13a-d2ef-4802-8b18-edb4fbddb6a2","title":"DPR Claims Kyiv/US Chemical Plot"},{"cluster_id":"3c78be45-5fbc-41c5-b4a5-36bb9f98a3b9","title":"Kyiv shuts off water to Luhansk"},{"cluster_id":"8f6bcfb4-e69d-470b-bf79-44df803a0002","title":"Chlorine Stocks Endanger Donetsk Water"},{"cluster_id":"a22b19c4-dd9d-4007-a380-a5d0659b9821","title":"Regulatory Delays in Sunscreen Innovation"},{"cluster_id":"edc6ba48-0632-4236-9c24-f67f26e9b96b","title":"WASH Under Attack in Eastern Ukraine"},{"cluster_id":"990aca8f-a2db-4ebd-85da-744c488a8d2b","title":"Attempted Ukrainian chemical attack in Donbas"},{"cluster_id":"bde9febe-9a28-4f0f-b67c-15f9a243538b","title":"Alleged Ukrainian water-poisoning plot"},{"cluster_id":"e1c37a48-126a-4576-b497-f9db46d18555","title":"Regular Sunscreen Reduces Melanoma Incidence"},{"cluster_id":"970fa237-7a1d-4b64-a4c6-7a158c05542d","title":"Hawaii bans oxybenzone and octinoxate"},{"cluster_id":"15ffd9d6-a9f6-4b7b-9697-caf2e3239c3c","title":"DHA Causes DNA Damage, Arrest, Apoptosis"},{"cluster_id":"4da3a5b6-2b3a-469e-82e1-4fa291688db8","title":"Endocrine Disruption by UV Filters"},{"cluster_id":"18718c0f-4c28-4949-a369-9bfa7d8941c1","title":"Benzene-triggered sunscreen recall"},{"cluster_id":"55f659a1-e5dc-41c5-8a43-9846f564af08","title":"Melanoma Myth: Sunscreen and Vitamin D"},{"cluster_id":"f292e9e8-fecc-473b-b24c-ca3ad9cc0ef9","title":"Low Vitamin D Worsens Melanoma Prognosis"},{"cluster_id":"81a839cf-9fe4-4f39-95e1-2ebc94ae6380","title":"Ukraine to halt gas transit 2021"},{"cluster_id":"b24ff026-a9a6-45e3-8927-422954af4cf6","title":"Donbas Winter Fuel Shortages Prompt Aid"},{"cluster_id":"3014a508-0ddc-42e0-9480-97e1310e1f29","title":"Crimea nationalised energy firm after annexation"},{"cluster_id":"748c24aa-69c4-47c4-a75f-e6da7007b74a","title":"Ukrainian Town Asks Putin for Gas"},{"cluster_id":"1e8a7861-14e4-4a42-b74d-73c7bec3ba5f","title":"Russia\'s Domestic Gas Cheaper Than Europe"},{"cluster_id":"c35d9889-06cc-4a13-8fea-d00c7024488b","title":"Sunscreens Allegedly Cause Cancer; Sun Not"},{"cluster_id":"b50d2222-7f8b-46fd-aef1-62ca57b6cc71","title":"Ukraine IMF Backed Gas Liberalisation 2015"},{"cluster_id":"e7f6877c-917d-4e0c-ad46-e366c0fa0b67","title":"TurkStream Southern Route Inauguration"},{"cluster_id":"c04b6a1d-f91c-44bf-b579-d5d4565fc056","title":"Donetsk, Luhansk Declare Independence, Seek Russia"},{"cluster_id":"d5752cab-3caa-48c6-b67d-7ac6c89bd054","title":"Ukraine Boosts EU Reverse-Flow Imports, 2015"},{"cluster_id":"baa5172c-8725-4cca-b3be-5d512cf618a1","title":"Gazprom-Naftogaz Settlement and Transit Pact"},{"cluster_id":"4e97ff0c-8732-4960-b274-1090e77ec733","title":"Gazprom Exempts Donetsk and Luhansk"},{"cluster_id":"2ec09e70-73d9-4395-9c36-0dbcac034464","title":"Gas as Leverage in Russia\u2013Ukraine"},{"cluster_id":"5cc3d51d-5e99-492c-82ff-4024c6eb9503","title":"Ukraine pivots from Russia to Europe"},{"cluster_id":"4796f6d0-5c9d-46eb-a35f-0a235dcf3b0e","title":"Naftogaz Sources 15 Suppliers, Price Revealed"},{"cluster_id":"5949d818-e369-4db8-949d-7a462c260498","title":"Ukraine Forms International Legion"},{"cluster_id":"f0c6ebf2-fe4c-437e-83d0-3c28cf8da8eb","title":"Friend Referral Bonus: 20,000 Hryvnia"},{"cluster_id":"75a422f1-d23f-4808-a7cf-fde7d26a7f5c","title":"Ukraine Overpays for Gas"},{"cluster_id":"63fb8530-c54e-452a-b71d-729fca3c7e67","title":"Zelensky Downplays Irish Casualties"},{"cluster_id":"74e4eccb-d37c-4913-a081-5e2a47430662","title":"Reduced transit volumes under 2019 deal"},{"cluster_id":"5437d23d-a8b8-4a7b-b296-c42b5945a223","title":"Martial law bars men from leaving"},{"cluster_id":"4b702552-6558-458e-b6a8-ec2e141d7258","title":"Zelensky Posthumously Honors Irish Volunteers\' Families"},{"cluster_id":"36472627-9945-496e-89a2-063ceee22d24","title":"EU Deports Ukrainians for Military Mobilization"},{"cluster_id":"151738b2-0d24-44aa-896c-fa16a74db380","title":"UK Embassy: Flee Draft Officers"},{"cluster_id":"0555403d-91c7-40d0-bf24-c9c0415e9ad9","title":"Ambiguities in Ending Temporary Protection"},{"cluster_id":"d0bbd332-807a-43c4-8b16-bc8817897189","title":"Ukraine 2022 General Mobilisation Decree"},{"cluster_id":"d86ceeb7-05d4-46ab-afb5-94228b85b310","title":"Ukraine expands mobilization and recruitment"},{"cluster_id":"75ded654-747a-4edb-9577-5b6d8ad0c3a1","title":"Irish nationals in Ukraine casualties"},{"cluster_id":"d316d167-369a-4e0d-ad58-337551778176","title":"Russia accuses West of escalation"},{"cluster_id":"292629c2-32f2-451e-b64e-e8f73bb87975","title":"Nazi-Symbol Tanks Bound for Ukraine"},{"cluster_id":"c99071d0-4f9f-4d85-a471-8ed03007f96c","title":"Coalition pledges unprecedented Ukraine tanks"},{"cluster_id":"35d3d7f4-4964-4980-9833-62b5e004737f","title":"UK Warns Britons; Embassy Relocated"},{"cluster_id":"acde1f80-8000-4b4d-8e9d-7d24f15b41d9","title":"Unidentified drones near Zelensky Dublin visit"},{"cluster_id":"db91531a-0712-431d-a04b-9b798db3d3b4","title":"Refugee Draws Swastika in UK Mall"},{"cluster_id":"3dcf8216-5e70-4cd4-962e-dc4b036a0071","title":"US Refuses Abrams Tanks to Ukraine"},{"cluster_id":"38520096-281c-4b53-ba64-f7e18dbd525f","title":"UN Dissatisfied With Western Tanks"},{"cluster_id":"4575f267-4553-4c7c-916e-359800e4fb24","title":"Wagner destroys Leopard tank, kills crew"},{"cluster_id":"a61f9905-7bda-4da1-b019-fbc601e92e05","title":"Wagner\'s Bakhmut Role Under Spotlight"},{"cluster_id":"f262ea70-4c26-4dcc-8a1f-52d6f8ce5558","title":"U.S. Poised to Send Abrams Tanks"},{"cluster_id":"d2bc0c3a-3d51-4a76-89f5-0aef4a862a3f","title":"De-escalation urged amid Davos war risk"},{"cluster_id":"88714dc6-72d5-4f7f-9067-219b66b31c42","title":"Swastika Vandalism and Prosecution in London"},{"cluster_id":"e0151ccd-baed-452a-aaa4-6feaeeadc3d9","title":"Abrams Delayed by Training and Logistics"},{"cluster_id":"bc5a19f9-2b61-40ac-ae39-5951370b4cf0","title":"Homes for Ukraine Sponsorship Launched"},{"cluster_id":"3f1ec78d-49c2-44d1-bdc2-97cf6217c638","title":"Germany approves Leopard 2 to Ukraine"},{"cluster_id":"21518841-2c46-4292-abad-aff342a4f1ac","title":"Russia\'s Denazification Narrative"},{"cluster_id":"de1f8a69-eaff-4387-87ee-35fc20ea4a2f","title":"Poland to close border with Ukraine"},{"cluster_id":"aaa9c952-e937-4295-abaa-c4968a415009","title":"International people-smuggling network dismantled"},{"cluster_id":"e7e80c41-a749-4b0c-a666-715bedd44f52","title":"Poland Refuses Ukrainian Refugees"},{"cluster_id":"f8ba093e-142e-45ae-b5d0-aef007993c05","title":"Poland Opposes EU Migrant Quotas"},{"cluster_id":"3fee6535-a988-4207-9d1e-737120abbcbb","title":"Disinformation about Ukrainian refugees in Poland"},{"cluster_id":"4adc477b-ccba-4820-b5c6-6a663398b338","title":"Border crossings restricted amid transport disputes"},{"cluster_id":"42dcf3d9-1011-484c-9355-4db97109e640","title":"Ukraine Aid Under Electoral Pressure"},{"cluster_id":"3eac5298-75f1-4e1e-94ec-db408d17729a","title":"Ukrainians Decorate Christmas Trees With Swastikas"},{"cluster_id":"9f25d197-8ec1-4d18-aeda-b095d1997826","title":"Poland: Few Syrian Refugees, Anti-Immigrant Rhetoric"},{"cluster_id":"31fb9a7d-5b4f-4fbf-8ec2-a3e65a3978d8","title":"NASA Adjustments Inflate Global Warming"},{"cluster_id":"d5f07507-9281-4cfd-81bd-0fc19ffa8a89","title":"Poles\' Support for Ukrainian Refugees Drops"},{"cluster_id":"c021fe18-c42c-443c-8de9-a7f8d58891f4","title":"Wind-Driven Variability Shapes Regional Sea Level"},{"cluster_id":"546b42d0-5005-442c-a548-5a747146aa92","title":"NOAA Releases Regional Sea-Level Rise Tools"},{"cluster_id":"cb5fae82-58a9-4d49-9da8-1886e33d1269","title":"NASA GISS Updates to GISTEMP"},{"cluster_id":"34a8290a-940e-4582-8dbf-cb195db85e28","title":"NOAA Data-Handling Whistleblower Controversy"},{"cluster_id":"2d8a2b96-5e68-43e2-a162-f66eeb390e13","title":"Apparent Slowing in Altimeter Data"},{"cluster_id":"cc1a98ca-fc1c-4f29-b58b-0d99bce8b809","title":"Public Access to Tide Gauge Data"},{"cluster_id":"97ffbb55-ab53-43e7-aa63-34930f97c42a","title":"Uncertainty Over Ukrainian Casualty Figures"},{"cluster_id":"a8acca84-268a-4542-96c5-6e8d1fb747ac","title":"Sea Level Rise: Melt and Expansion"},{"cluster_id":"5beed7c2-e377-4032-9f8d-5e0e7f3ae7e7","title":"Cooling Data, Falsified Warming Graphs"},{"cluster_id":"ca9d7f99-280c-41ec-a4aa-ad1ac5930f8c","title":"Sea Level Rise Not Temperature-Dependent"},{"cluster_id":"f16aab95-d35f-4386-9ea4-6a5f797bcf7f","title":"Escalating Combat in Avdiivka"},{"cluster_id":"80a104b6-58c7-416b-ac35-97712361953c","title":"Defense and Fall of Donetsk Airport"},{"cluster_id":"a9a65207-69ea-45b8-ac25-c8ee16fc4a08","title":"Ukraine military losses revealed"},{"cluster_id":"7e112a5c-41d4-4f1c-b974-99256b5d357b","title":"Europe Considers Russia\'s Eastern Ukraine Plan"},{"cluster_id":"f78012d1-f500-46ba-802c-d3d1337f7f51","title":"Germany backs phased Russia sanctions lift"},{"cluster_id":"523ae438-64cf-40ea-839d-1a30cbcf4c63","title":"Debaltseve Battle: Ukrainian Withdrawal"},{"cluster_id":"7354cd90-5ded-45c2-af70-b5cea1cc0045","title":"EU Reaffirms and Extends Russia Sanctions"},{"cluster_id":"c786e602-255f-4df8-a9fc-775fc1322fa2","title":"Steinmeier Formula Emerges in Normandy/Minsk Talks"},{"cluster_id":"2b56b1f6-1627-44ab-9460-b13751cf087b","title":"Ilovaisk 2014: Encirclement and Losses"},{"cluster_id":"77cb4584-fbf4-45e6-9a2b-9d46e341c831","title":"Maidan Occupation and Barricades"},{"cluster_id":"505c42ee-a234-45a9-8c74-63207154db3f","title":"Rapid Rise of Volunteer Battalions"},{"cluster_id":"4ac41d40-e8f6-44f4-a7bd-84b0a1d31ea1","title":"Separatists Seize War Spoils"},{"cluster_id":"d10a4ec7-a74e-4016-996b-f1f3a3c6527f","title":"Ukrainian Soldiers Suicide to Avoid Combat"},{"cluster_id":"f0bf7f4c-0a27-4681-9eca-ea221b9315a7","title":"2014 Losses Passed Off as Current Casualties"},{"cluster_id":"93a61a8e-4477-45a4-b63b-bc7992dad11c","title":"Pro-Kremlin Narratives on Ukrainian Demoralization"},{"cluster_id":"ff62f156-1b54-448d-8c41-0514a58493a5","title":"Pro-Russian Seizure of Sloviansk"},{"cluster_id":"906d1526-e5ff-4f4e-a0e5-f30c2dfb306d","title":"Donbas Soldiers\' Weekly Suicides"},{"cluster_id":"bd3c25bb-6683-4bdd-8e97-11de485116b2","title":"AFU Brigade Seizes Control After Rally"},{"cluster_id":"5cb4afbf-e109-4c74-8315-a2a58d421c9c","title":"Ukraine GDP Collapse and Hryvnia Plunge"},{"cluster_id":"eab0b5ad-eda0-47fc-89d0-b12331740c85","title":"Congress Turns to Ukraine Aid Oversight"},{"cluster_id":"08ccb8f3-d97c-4442-b830-fac7f751221a","title":"Ukraine: Major Heroin Transit Hub"},{"cluster_id":"241d256c-86d7-484e-8aee-4f2f15316b3d","title":"Cocaine Networks via Ukrainian Ports"},{"cluster_id":"89b0a4a3-f393-4706-9a25-8103c69b53d6","title":"UN OHCHR Killings in Eastern Ukraine"},{"cluster_id":"0c50e809-0f1b-4656-a0dd-110732b6e47b","title":"Ukraine Corruption Soars; Aid Fails"},{"cluster_id":"47f7a131-6ce1-4e01-b64c-61e5f9696bb1","title":"Ukraine: Corruption Perceptions and Rankings"},{"cluster_id":"c9b1ea29-5b23-4579-928f-8f3b1f3679f1","title":"Release of JSOP for Ukraine Response"},{"cluster_id":"a7614301-2ae0-4bb1-bcf4-8bc8d82acc70","title":"Ukraine: Europe\u2019s Poorest Country"},{"cluster_id":"181a2d12-ad30-4552-bb72-ee9a984fa618","title":"Ukraine: Deep Recession, Tough Recovery"},{"cluster_id":"d28f03f1-166f-4e7a-a151-3bb7c1898209","title":"Poverty Surges 2014\u201315, Policy Focus"},{"cluster_id":"b1f3ff2b-9b1f-4366-8ccf-ac47a277ed10","title":"EU Accuses Ukraine of Heroin Flooding"},{"cluster_id":"b777e992-68f2-4307-a472-b1ae2b933a6e","title":"2020 GBR Marine Heatwave and Bleaching Risk"},{"cluster_id":"bd072c00-533b-4c4a-918b-097a11abe63b","title":"UNESCO Recommends Reef in Danger"},{"cluster_id":"f5b1b3d0-19e5-49a1-bbc1-690d440e299c","title":"Regional Increases in Hard Coral Cover"},{"cluster_id":"2e504c36-cc23-49bf-9bfa-77adbeb06137","title":"2019 Global Ocean Heat Content Records"},{"cluster_id":"68637c5d-53b2-4a1b-b193-4fe1333f1416","title":"Coral Reefs Vanish in 35 Years"},{"cluster_id":"dd5764ad-ed57-4067-b6a4-35ca15790cc2","title":"Great Barrier Reef: Record Coral, Safe"},{"cluster_id":"4794bb46-add2-4c57-9ffb-caa8d6c5bb0f","title":"COVID-era tourism decline, clearer reefs"},{"cluster_id":"24603ad6-f39a-4706-80ce-2840439ad61c","title":"Global Coral Bleaching, 2014\u20132016"},{"cluster_id":"76b14a04-38e5-4c33-90b7-69079246c4ac","title":"Reef Recovery Window After Disturbances"},{"cluster_id":"1da0b887-e497-4790-9c97-6324fa7f1453","title":"Australia\'s Backlash to UNESCO Recommendation"},{"cluster_id":"938b7182-512d-4aa5-a1bc-532c7b55f96a","title":"Europe\'s 2022 Energy Price Shock"},{"cluster_id":"83578f15-2ee2-4dd4-ae7f-b543ba5e2a87","title":"Barriers to Wind Turbine Blade Recycling"},{"cluster_id":"746085cd-6635-459a-8b25-138f4d67d9dc","title":"Allegations of Ukraine drug trade"},{"cluster_id":"c9335a55-7c59-42cb-98be-e69b4262faa0","title":"Costs and Harms of Wind Turbines"},{"cluster_id":"6efc04ea-c5a7-40f2-bf74-98f55c06f1df","title":"No Change in Reef Temperatures"},{"cluster_id":"efe63a8c-0f9a-4b9f-ad60-14fabb8e67d3","title":"Uri Winter Storm Reveals Texas Grid Failures"},{"cluster_id":"410a0800-e775-4016-b3ff-cc215bfaf3d1","title":"Bird-Smart Wind Farm Advocacy"},{"cluster_id":"31763d96-84ac-402a-a69c-ea748718f342","title":"Raptor Fatalities at Altamont Pass"},{"cluster_id":"0cdd2771-1f79-419e-940c-c74f863377bb","title":"Wind Energy Kills More Birds"},{"cluster_id":"2a7cf868-b485-43d0-b2ff-786617960499","title":"Wind Turbines Kill Eagles, Raise Bills"},{"cluster_id":"89ca7fbd-adb5-4425-9a07-78efe99244cc","title":"Bat Fatalities at Wind Energy Facilities"},{"cluster_id":"fccc5c68-3c5f-4b2d-8103-9431b0c4794a","title":"Rising Demand for Critical Minerals"},{"cluster_id":"12ce4240-07a8-40e1-acc7-141144ad6c5d","title":"Environmental Footprint of Turbine Disposal"},{"cluster_id":"4b620911-0006-4874-ad8a-a8595a7140e4","title":"Painted turbine blades reduce raptor collisions"},{"cluster_id":"05905deb-04e3-4e57-afeb-f4e623c176cb","title":"Final Eagle Incidental-Take Permits for Wind"},{"cluster_id":"fc264446-1206-43b0-b6e2-29d7fc43d99c","title":"Foreign Mercenaries Leave Ukraine for Israel"},{"cluster_id":"7681cbe0-1efe-4edf-b906-ebf02351325e","title":"Estimating Bird Mortality at Wind Turbines"},{"cluster_id":"31351498-4fc3-4c6e-8df2-7c515d19509b","title":"Citizenship Path for Foreign Fighters"},{"cluster_id":"008cba92-e4d7-4655-90ad-12cb214fe197","title":"US Offshore Wind Costs and Cancellations"},{"cluster_id":"ccd586d7-5c30-4f84-8142-adc54ddef655","title":"Analyses Warn of Fringe Foreign Volunteers"},{"cluster_id":"2f12da3e-336e-40d2-ba41-61b838ad70f2","title":"Germany Won\'t Forcibly Return Ukrainians"},{"cluster_id":"56106773-dee4-4da1-bda2-7227784468b3","title":"Yanukovych assets seized and frozen"},{"cluster_id":"52f03b57-8fb1-4ff1-8eda-c0d228097a8f","title":"Establishment of Ukraine\'s International Legion"},{"cluster_id":"4c0dfd84-df3b-4660-9041-a635021908ef","title":"Western Grants to Ukrainian Civil Society"},{"cluster_id":"c784871a-fcaa-4345-b3a8-ae8869019499","title":"Ukraine Recruits Mentally Unstable Foreign Fighters"},{"cluster_id":"6a03d110-92cd-4da9-913a-56888b17641f","title":"Ukrainian Expats to Report for Recruitment"},{"cluster_id":"636b2daa-578a-4643-896b-342714f42b34","title":"Titushky Operatives and Employers Identified"},{"cluster_id":"607cc6ab-a0bd-429e-a391-92e1066b96d9","title":"Struggling to Vet, Equip Foreign Fighters"},{"cluster_id":"183ebbd4-8012-4c45-ae37-eee1b7b28721","title":"Paid Pro-Russian Demonstrators in Eastern Ukraine"},{"cluster_id":"64b58fdb-7776-47be-a603-30c85a60366e","title":"German Citizenship via Ukrainian Recruitment"},{"cluster_id":"a5d008c6-c15a-4302-aa70-e916c52f5451","title":"US Invested $5B in Ukraine"},{"cluster_id":"24accb31-401b-42c1-bd69-e81c04cb2530","title":"Paid Participants at Euromaidan"},{"cluster_id":"e18afe50-8e61-4915-8745-6256e6a782cb","title":"Yanukovych Ousted After Euromaidan"},{"cluster_id":"f8cc40a9-e215-46da-bdf5-b5efc622bb40","title":"US Intel Pursued Ukraine Regime Change"},{"cluster_id":"8dd2ae56-dcf0-4439-b3f0-3a7a939056df","title":"California Mandates 25% Urban Water Reductions"},{"cluster_id":"09a3b73e-815c-4ea0-9da8-b1110ca8cf96","title":"Klamath 2002 Fish Kill, Irrigation Disputes"},{"cluster_id":"a07d35a7-6217-400e-856f-516669ebb436","title":"2015 Media Analysis: Stormwater Capture Shortfalls"},{"cluster_id":"5d8665ac-7337-470b-ae27-2d46610e9f97","title":"Yanukovych-Funded Ukrainian Army"},{"cluster_id":"84147a14-72bc-486f-90ad-45e374aeaa05","title":"2017 Wine Country Wildfires"},{"cluster_id":"4141d4f5-ed19-442d-94e2-369926343d5f","title":"Water restrictions worsen California wildfires"},{"cluster_id":"0cb30e02-d84d-4557-96e4-2da52513f036","title":"Oroville Dam Spillway Evacuations"},{"cluster_id":"9e7a0088-26cb-464d-887d-c7e715addbcf","title":"Biological Opinion to Protect Delta Smelt"},{"cluster_id":"ce398b7c-c3fa-42df-8862-5c57ac63cf98","title":"Delta Water Exports Curtailed for Smelt"},{"cluster_id":"28df4744-3bf2-4a43-80dc-d2bea8f7af7a","title":"California Announces First-Ever Urban Water Restrictions"},{"cluster_id":"dc0f2fc6-867e-476a-b8e1-8031edcf72a7","title":"Donetsk Bus-Stop Shelling Kills Civilians"},{"cluster_id":"38dbd9f2-4706-4ca9-a837-817a4ee621f8","title":"Civilian Casualties in Mariupol Shelling"},{"cluster_id":"ecb3f4fd-fe1b-4ef4-a13b-94c4c7eea90e","title":"Donetsk: Rising Fatalities and Urban Combat"},{"cluster_id":"0fde95b6-db57-45cd-b6ac-fb0edd1b186b","title":"Ukrainian Forces Shell Donetsk"},{"cluster_id":"253fbf69-01a5-4352-a109-1aea0fdf1fe3","title":"Heroine debunked as Donetsk victim"},{"cluster_id":"2bd231ca-b95f-4da8-b52c-5b92d58eef4f","title":"OSCE Reports Mariupol Jan 24 Shelling"},{"cluster_id":"468c9eea-e420-4271-9b73-0e2e747f6185","title":"Deforestation increases pandemic vulnerability"},{"cluster_id":"bc23e70d-7b5e-43f0-97b5-b24c31beffb6","title":"OSCE SMM: 29 Killed This Year"},{"cluster_id":"3a969b37-0ab9-41ab-b145-dd3f362c8638","title":"Grave human rights abuses in Ukraine"},{"cluster_id":"37ac1c3c-10ae-411e-a6f7-5a4e0cfd6c1b","title":"Youth-Led Global Climate Strikes"},{"cluster_id":"36f68109-962e-490e-9101-85d84c5de66a","title":"Volcanic CO2 Challenges Global Warming Theory"},{"cluster_id":"0f3a2cc5-8301-476a-b658-747594635542","title":"Predicted Global Mass Death"},{"cluster_id":"1ae95d89-cea7-4f27-8ed8-d4f49e95c5db","title":"Climate Is Always Changing"},{"cluster_id":"e47ab492-3177-49bc-9493-e444a1518298","title":"Volcanic CO2 dwarfed by human emissions"},{"cluster_id":"5ef68f23-0f9c-4c57-af44-b6d2b7f6107c","title":"Natural Orbital Changes Drive Warming"},{"cluster_id":"c92757d9-a065-4dc2-806f-96c7c9890f76","title":"China Bans Wildlife Trade Nationwide"},{"cluster_id":"8ec6c014-24e3-40b5-a577-20ca128d6e41","title":"Huanan Market Linked to Early Cases"},{"cluster_id":"98a5a190-c887-4ce2-b53f-011c39183ade","title":"Etna Eruption Emits 10,000x CO2"},{"cluster_id":"c2350485-f95c-46d4-9b92-6355ceca86df","title":"29 Civilians Killed in Donbas"},{"cluster_id":"145aa4e5-4dc7-4a0e-a117-12b6a5547a63","title":"IPCC 1.5\xb0C Special Report Released"},{"cluster_id":"273cff70-66df-48dd-9efa-69156787ee64","title":"IPBES Biodiversity and Ecosystem Services Assessment"},{"cluster_id":"ba793871-eeec-487b-a1b0-5996d1bd03cf","title":"UN Warns of Approaching Tipping Point"},{"cluster_id":"921c5a51-cef0-491b-8b5f-a5f05c5b785f","title":"Calbuco 2015: Quantified Gas/Ash Emissions"},{"cluster_id":"94a3af2d-ef6e-49ef-84ee-4d1aa3f90aff","title":"Same Experts, Contradictory Climate Claims"},{"cluster_id":"933d50c3-dd0d-4b5f-9957-22bbcfcc55d5","title":"Ohio Enacts Heartbeat Protection Law"},{"cluster_id":"3e1920d2-6038-4d0b-b122-137c458f6d99","title":"Bat-Eating Caused Wuhan Outbreak"},{"cluster_id":"7db64556-43b7-4e29-b1a9-e8fcd5d29233","title":"2\xb0C: Irreversible Tipping Point"},{"cluster_id":"2ff5212c-713e-4d80-b0b9-c7f306cf69fb","title":"Alabama Near-Total Abortion Ban"},{"cluster_id":"3e95ef61-306a-4cf0-a217-5b910e8ffc01","title":"CMS EMTALA Guidance for Pregnant Patients"},{"cluster_id":"c8ac3f5f-f7f9-419c-9873-a9fbc34aa61a","title":"Abortions Are Not Medically Necessary"},{"cluster_id":"a08d6d8c-3534-4503-908a-ad9b08709410","title":"Post-Dobbs Emergency Care Guidance"},{"cluster_id":"27c3b9de-4f86-4091-b50b-7314a2636d6c","title":"GAO Audit of FDA Mifeprex Decisions"},{"cluster_id":"4df23607-a04c-40e8-be3f-b8d874dc3d06","title":"Lawsuit Challenges Mifepristone Approval"},{"cluster_id":"0c951d24-0f2c-41e0-a5be-f5200eceb7d7","title":"FDA Paused In-Person Dispensing"},{"cluster_id":"d4bc60e5-da16-45c3-909d-aa14379adeb2","title":"Foreign Fighter Flows to Syria"},{"cluster_id":"8a84554f-19d7-41fa-8647-c3608df3d4f1","title":"Turkey\'s Euphrates Shield Offensive"},{"cluster_id":"bcbfb3b5-386e-4a9d-9149-63379d147048","title":"Turkey Accused of Allowing Foreign Fighters"},{"cluster_id":"9cef1461-4ccb-4b2f-8a1e-1d71ef404be6","title":"Alaska Court voids Medicaid abortion criteria"},{"cluster_id":"b7e82711-b99a-4580-8fb1-a7b6465b462b","title":"Pro-Life Clinicians: Abortion Not Medically Necessary"},{"cluster_id":"b5cfe764-3a89-4e77-9f9e-c720d7d22394","title":"Dobbs Overturns Roe, Debate Intensifies"},{"cluster_id":"a66a05dd-2f9d-47e7-8c3b-f3a662bda0e0","title":"Mifepristone: Unsafe, Harms Health"},{"cluster_id":"b7518287-9949-4ec0-a078-3d7e49009d46","title":"Russian Media Links Ukraine, Syria"},{"cluster_id":"9917626e-0afd-495f-82cd-6e27aa8cc73d","title":"Global Crimean Tatars Unite Against Annexation"},{"cluster_id":"6c806f4f-f4b8-4c40-ad97-ff6d0d5a2a84","title":"Chechen Fighters in Donbas and Syria"},{"cluster_id":"789c4f9a-6863-49ee-a41c-e12949429992","title":"Crimean Tatars Fought in Syria"},{"cluster_id":"c8d47411-ab85-4f96-b286-cd76451823f8","title":"Turkey Builds Caliphate in Southern Ukraine"},{"cluster_id":"54bf8eb2-6975-454f-a48b-59abffdfe4f4","title":"Jihadists at Crimean Tatar World Congress"},{"cluster_id":"b9cee305-a96d-440f-a08d-e2f6545e2608","title":"Turkey backs Ukraine and Crimean Tatars"},{"cluster_id":"b7e33865-58b2-4984-a7e1-eed1512539bb","title":"Ukrainians to Join Syrian War"}]');



function $9d5c879b82e9fecb$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: "#home",
        className: "fixed top-5 left-5 z-50 bg-black shadow-lg rounded-full p-3 hover:bg-gray-800 transition",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: "h-6 w-6 text-gray-200",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            strokeWidth: 2,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M3 10.5L12 3l9 7.5M5 9.75V21h14V9.75"
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");
const $bd45a1af81ff630a$export$cbfa8a8d33d01a14 = /*#__PURE__*/ (0, $acw62.forwardRef)(function FloatingPanel({ title: title, children: children, defaultOpen: defaultOpen = true }, ref) {
    const [open, setOpen] = (0, $acw62.useState)(defaultOpen);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            open: ()=>setOpen(true)
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white shadow-lg rounded-2xl w-80 overflow-hidden transition-all",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setOpen(!open),
                className: "w-full flex items-center justify-between px-4 py-2 bg-gray-100 hover:bg-gray-200 transition",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `transform transition-transform ${open ? "rotate-180" : ""}`,
                        children: "\u25BC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `overflow-scroll transition-all duration-300 ${open ? "max-h-[50vh] p-4" : "max-h-0 p-0"}`,
                children: children
            })
        ]
    });
});




var $acw62 = parcelRequire("acw62");

const $c3ad14db7d065b8e$export$e54a7f2505304e20 = /*#__PURE__*/ (0, $acw62.forwardRef)(function DetailsPanel({ selectedNode: selectedNode, data: data }, ref) {
    const fpref = (0, $acw62.useRef)();
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            open: ()=>{
                fpref.current.open();
            }
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
        title: "Details",
        ref: fpref,
        children: selectedNode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "space-y-3",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Type:"
                        }),
                        " ",
                        selectedNode.type_nice,
                        " Cluster"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Title:"
                        }),
                        " ",
                        selectedNode.label
                    ]
                }),
                selectedNode.avgDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                            children: "Date:"
                        }),
                        " ",
                        new Date(selectedNode.avgDate).toISOString().slice(0, 10)
                    ]
                }),
                selectedNode.members && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "font-semibold",
                            children: "Members:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "list-disc list-inside text-sm",
                            children: selectedNode.members.map((m)=>{
                                const memberData = data.claims.find((c)=>c.id === m) || data.events.find((e)=>e.id === m);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: memberData ? memberData.text : m
                                }, m);
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            className: "text-sm text-gray-500",
            children: "Click a node to see details"
        })
    });
});



function $5e037e99aaeb8b9f$export$cadf57dd3336ca84({ children: children, bot: bot = "sml" }) {
    const botSty = bot == "sml" ? "bottom-4" : "bottom-20";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed right-4 z-50 flex flex-col gap-2 items-end " + botSty,
        children: children
    });
}


function $21f819a4461f8efa$export$cb4545c791e478f(nodes, links) {
    const adj = new Map();
    nodes.forEach((n)=>adj.set(n.id, new Set()));
    links.forEach((l)=>{
        adj.get(l.source)?.add(l.target);
        adj.get(l.target)?.add(l.source);
    });
    const visited = new Set();
    const components = [];
    for (const node of nodes){
        if (visited.has(node.id)) continue;
        const stack = [
            node.id
        ];
        const comp = [];
        while(stack.length){
            const id = stack.pop();
            if (visited.has(id)) continue;
            visited.add(id);
            comp.push(id);
            adj.get(id)?.forEach((nei)=>{
                if (!visited.has(nei)) stack.push(nei);
            });
        }
        components.push(comp);
    }
    return components;
}
function $21f819a4461f8efa$export$c40ecbf27f181c47(ctx, x, y, width, height, radius) {
    const r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}


function $bcf1285b349e5342$export$521ccb2585222b04(data) {
    const nodes = [];
    const links = [];
    // Create a lookup map for quick access
    const titleMap = new Map((0, (/*@__PURE__*/$parcel$interopDefault($6a14c484c9a01c5f$exports))).map((t)=>[
            t.cluster_id,
            t.title
        ]));
    data.claim_clusters.forEach((cluster)=>{
        nodes.push({
            id: cluster.cluster_id,
            label: titleMap.get(cluster.cluster_id) || cluster.title || "Unnamed Claim Cluster",
            type: "claim_cluster",
            type_nice: "Claim",
            members: cluster.members
        });
    });
    data.event_clusters.forEach((cluster)=>{
        nodes.push({
            id: cluster.cluster_id,
            label: titleMap.get(cluster.cluster_id) || cluster.title || "Unnamed Event Cluster",
            type: "event_cluster",
            type_nice: "Event",
            members: cluster.members
        });
    });
    data.cluster_links.forEach((link)=>{
        links.push({
            source: link.claim_cluster_id,
            target: link.event_cluster_id
        });
    });
    return {
        nodes: nodes,
        links: links
    };
}
function $bcf1285b349e5342$export$dee8003db84ef533() {
    const fgRef = (0, $acw62.useRef)();
    const detailsPanelRef = (0, $acw62.useRef)();
    const [selectedNode, setSelectedNode] = (0, $acw62.useState)(null);
    const [minGraphSize, setMinGraphSize] = (0, $acw62.useState)(10);
    const graphData = (0, $acw62.useMemo)(()=>{
        const full = $bcf1285b349e5342$export$521ccb2585222b04((0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))));
        const components = (0, $21f819a4461f8efa$export$cb4545c791e478f)(full.nodes, full.links);
        // keep only components large enough
        const validIds = new Set(components.filter((comp)=>comp.length >= minGraphSize && comp.length < 50).flat());
        const filteredNodes = full.nodes.filter((n)=>validIds.has(n.id));
        const filteredLinks = full.links.filter((l)=>validIds.has(l.source) && validIds.has(l.target));
        return {
            nodes: filteredNodes,
            links: filteredLinks
        };
    }, [
        minGraphSize
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!fgRef.current) return;
        // Stronger repulsion
        fgRef.current.d3Force("charge", $78193c16de4a9cf2$export$2e2bcd8739ae039().strength(-10000));
        // Link distance
        fgRef.current.d3Force("link", $b1bbf836822558b1$export$2e2bcd8739ae039().distance(140));
        // Collision based on dynamic box size
        fgRef.current.d3Force("collision", $e71a2b6c9ad4b72d$export$2e2bcd8739ae039((node)=>{
            const dims = node.__bckgDimensions;
            return dims ? Math.max(dims[0], dims[1]) / 2 + 32 : 40;
        }));
        fgRef.current.d3ReheatSimulation();
    }, [
        graphData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (fgRef.current) fgRef.current.zoom(0.05, 0);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5c879b82e9fecb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $002d9ae7155c4add$export$2e2bcd8739ae039), {
                ref: fgRef,
                graphData: graphData,
                nodeLabel: (node)=>node.label,
                nodeAutoColorBy: "type",
                linkColor: ()=>"black",
                linkWidth: 2.5,
                onNodeClick: (node)=>{
                    detailsPanelRef.current.open();
                    setSelectedNode(node);
                },
                linkDirectionalArrowLength: 100,
                linkDirectionalArrowRelPos: 0.9,
                nodeCanvasObject: (node, ctx, globalScale)=>{
                    const label = node.label;
                    const fontSize = 16 + 32 * node.members.length;
                    ctx.font = `${fontSize}px Sans-Serif`;
                    const textWidth = ctx.measureText(label).width;
                    const padding = fontSize * 0.6;
                    const width = textWidth + padding;
                    const height = fontSize + padding;
                    const x = node.x - width / 2;
                    const y = node.y - height / 2;
                    const radius = node.type.includes("claim") ? fontSize * 6 : 0;
                    // background
                    ctx.fillStyle = node.type.includes("claim") ? "DarkMagenta" : "green";
                    (0, $21f819a4461f8efa$export$c40ecbf27f181c47)(ctx, x, y, width, height, radius);
                    ctx.fill();
                    // optional border
                    ctx.strokeStyle = "white";
                    ctx.lineWidth = 1;
                    ctx.stroke();
                    // text
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.fillStyle = "white";
                    ctx.fillText(label, node.x, node.y);
                    // store dimensions for collision + pointer
                    node.__bckgDimensions = [
                        width,
                        height
                    ];
                    node.__bckgPos = {
                        x: x,
                        y: y
                    };
                },
                nodePointerAreaPaint: (node, color, ctx)=>{
                    const dims = node.__bckgDimensions;
                    const pos = node.__bckgPos;
                    if (!dims || !pos) return;
                    ctx.fillStyle = color;
                    (0, $21f819a4461f8efa$export$c40ecbf27f181c47)(ctx, pos.x, pos.y, dims[0], dims[1], 6);
                    ctx.fill();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5e037e99aaeb8b9f$export$cadf57dd3336ca84), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ad14db7d065b8e$export$e54a7f2505304e20), {
                        selectedNode: selectedNode,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))),
                        ref: detailsPanelRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
                        title: "Key",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    backgroundColor: "green"
                                },
                                className: "text-white p-1 text-xl mb-3",
                                children: "Trigger Event Cluster"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    backgroundColor: "DarkMagenta"
                                },
                                className: "text-white p-1 text-xl rounded-3xl",
                                children: "Claim Cluster"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
                        title: "Config",
                        defaultOpen: false,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                children: [
                                    "Min connected graph size: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: minGraphSize
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "range",
                                min: "9",
                                max: "20",
                                value: minGraphSize,
                                onChange: (e)=>setMinGraphSize(Number(e.target.value))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $04ca73c2000c8168$exports = {};
$04ca73c2000c8168$exports = JSON.parse('{"claims":[{"id":"2dd13f4f-6426-4ac8-bd65-7ffb771370ad","text":"COVID-19 vaccines are causing excess deaths worldwide, and Sudden Adult Death Syndrome is a new condition caused by the vaccines.","date":"2023-01-04 00:00:00+00:00"},{"id":"f8b55df6-b25d-46c9-8f4f-c5c18799922d","text":"Bisphenol A in food causes health problems.","date":"2023-01-23 00:00:00+00:00"},{"id":"6699828d-fb58-4517-baf8-bd0a114db78f","text":"Germany has erected a fence separating vaccinated and unvaccinated people, and insanity is the primary symptom of COVID-19.","date":"2021-12-07 00:00:00+00:00"},{"id":"e27cdb49-5cc6-4d83-b740-fed69da1a64a","text":"700 tanks located in occupied eastern Ukraine are spoils of war.","date":"2017-02-19 15:25:10"},{"id":"fbade069-95a0-4972-bade-52d4ac0638d8","text":"EuroMOMO data show excess deaths in children aged 0\u201314, and the excess deaths in Europe are not explained by COVID-19.","date":"2023-01-23 00:00:00+00:00"},{"id":"a3c090d0-0f8c-4dbd-aa26-87ca72378ff7","text":"Authorities in Kyiv staged a provocation and blamed Moscow for everything.","date":"2018-11-26 15:22:58"},{"id":"d6814ea5-c714-48f3-818f-cdcb5b6381e0","text":"The European Parliament accuses Petro Poroshenko of political repression.","date":"2016-07-18 18:08:29"},{"id":"30728e5f-3db1-4c1c-befe-fbd1f7103a82","text":"COVID-19 vaccination during pregnancy provides no benefit and causes higher neonatal and all-cause readmission rates in babies born to vaccinated mothers.","date":"2023-11-05 00:00:00+00:00"},{"id":"8d8470bd-ad2d-4dd4-adf5-eba8481b1e3a","text":"Ukraine\'s language police are reviving the Great Terror.","date":"2020-12-06 10:48:18"},{"id":"4de477ea-5b7b-45a2-be59-cf9bec7b2733","text":"The hero from the video about the Azovets children\'s camp died in the war.","date":"2024-04-20 10:02:00"},{"id":"3e5ff83b-0092-4c6a-b1d4-b3d8665c952a","text":"The Armed Forces of Ukraine used OSCE video camera data to correct artillery fire.","date":"2022-04-20 12:12:49"},{"id":"bdc1437f-ed3b-4d98-b2c1-38d4365c70e6","text":"WHO data shows ivermectin reduces COVID-19 mortality by 81% and WHO will not recommend it.","date":"2021-04-13 00:00:00+00:00"},{"id":"d8d7bab0-1ed1-4bdf-8ccb-706d4da8ae8d","text":"Human-produced carbon is a factor in climate change, but it is not a significant one.","date":"2019-11-09 00:00:00+00:00"},{"id":"29d4d54d-b45f-428f-9434-a2dbdbf76fdf","text":"Poland is leaving the European Union.","date":"2018-11-15 01:22:23"},{"id":"0424510d-cbfe-45c9-b03c-be316dbc1185","text":"The Crimean Tatar Mejlis was created by the United States.","date":"2016-10-04 15:08:36"},{"id":"3e01682a-99db-4588-812c-77898c084078","text":"Czech President Petr Pavel said Ukraine should cede territories to survive.","date":"2025-08-04 00:00:00+00:00"},{"id":"735326d8-274b-43f4-bede-c04b3f51ff7b","text":"Food supplements restore perfect blood sugar levels and cure Type 2 diabetes.","date":"2022-06-02 00:00:00+00:00"},{"id":"57794fdf-6b32-4749-8b39-f7099cf8b282","text":"DNA in COVID mRNA vaccines alters the human genome; SV40 causes cancer in humans; regulatory agencies knew about contamination.","date":"2023-06-23 00:00:00+00:00"},{"id":"255a4d2c-14ee-4bb3-88c2-3d03d8e031cf","text":"Harry Hoxsey\'s herbal therapy cures cancer.","date":"2022-12-10 00:00:00+00:00"},{"id":"3026b8de-985a-42c8-9ae3-d374746eedcc","text":"Ukrainian blood is being sold.","date":"2018-03-28 11:54:43"},{"id":"1d8fae5b-ecc0-45be-ab13-eac5e4e79825","text":"Taking acetaminophen during pregnancy causes autism in children.","date":"2022-07-18 00:00:00+00:00"},{"id":"633ba20e-618f-46e5-ae02-75a3ffa9d1d7","text":"Zinc supplements protect against COVID-19; zinc kills the virus; zinc ionophores transport zinc from outside cells into cells.","date":"2022-01-18 00:00:00+00:00"},{"id":"ab0f775b-320d-44f7-ae2e-848211e10868","text":"Hungarians living in Ukraine are experiencing genocide.","date":"2023-04-16 18:01:00"},{"id":"2361b0b7-d4fb-48be-a1a3-3f8003756366","text":"Vaccines are toxic, they do not prevent transmission, and vaccinated children are less healthy than unvaccinated children.","date":"2021-01-13 00:00:00+00:00"},{"id":"9d2a365a-6c46-411b-969d-d47a368e94ee","text":"A Russian was the only person who defended passers-by in a Sydney suburb.","date":"2024-04-15 16:14:00"},{"id":"f00ef639-900e-41c6-8781-9b27223d4353","text":"Spain lost all its mobile networks after rejecting Russian hardware.","date":"2025-05-20 00:00:00+00:00"},{"id":"7eb3a987-b322-44d2-b3d6-28c94d19b5d2","text":"The Czech Republic does not recognize Russia\'s annexation of Crimea.","date":"2014-03-28 11:48:58"},{"id":"2dea096c-fd10-4480-803d-899cf695c6f5","text":"Cancer incidence has sharply increased, particularly female breast cancer among people aged 45 and under.","date":"2023-06-18 00:00:00+00:00"},{"id":"c83fc427-5b49-4136-ac63-a6e82c9a6e68","text":"Neo-fascists in Lviv beat an elderly woman who placed flowers at a Lenin monument.","date":"2014-03-07 09:21:47"},{"id":"25e64931-13f1-49ca-bc59-c9b3ea3df04a","text":"Thalidomide was rapidly approved in 1957 to treat nausea and insomnia in pregnant women, was marketed in many countries, and was withdrawn in 1962 because it caused malformations in newborns.","date":"2020-04-12 00:00:00+00:00"},{"id":"ac7a6f3c-0121-4422-b49f-f6891df024f0","text":"An Italian journalist is missing in Donbas.","date":"2019-01-11 09:05:46"},{"id":"5d4a7f9d-370a-43f6-90d8-da41fa28b5bd","text":"Researchers have perfected inserting human vaccines into certain foods, and grocery vegetables contain human vaccines.","date":"2024-01-03 00:00:00+00:00"},{"id":"3f39fca1-a59d-4b69-90c6-21f814dc1270","text":"Ukraine will become a nuclear waste dump.","date":"2018-04-23 22:00:05"},{"id":"a4ec243a-71a4-4609-9a28-20d5f55f2c22","text":"Both medical and non\u2011medical face masks do not reduce COVID\u201119 transmission or infectivity, and long\u2011term mask wearing causes harmful health effects including hypoxemia and hypercapnia.","date":"2021-04-23 00:00:00+00:00"},{"id":"dd4e8c50-a762-41da-9994-99bdacd1c496","text":"At least 15 million Ukrainians maintain strong ties with Russia.","date":"2022-03-15 13:46:00"},{"id":"6eb1ba10-7e64-4410-8b77-b1f6131ff9d4","text":"Omicron subvariant XBB.1.5 is more likely to infect vaccinated people.","date":"2023-01-14 00:00:00+00:00"},{"id":"38e14696-6be8-4733-897c-92ef59e9e984","text":"Vaccinated people carry 251 times more SARS\u2011CoV\u20112 virus in their nostrils than unvaccinated people.","date":"2021-08-26 00:00:00+00:00"},{"id":"f3ebd398-1ed0-4277-a8e8-14809c410ad5","text":"A Bild journalist died after publishing an article about Ukraine\u2019s military operation in the Kursk region.","date":"2024-08-19 20:19:53"},{"id":"938f6495-4d57-4ad6-94ce-863e8c50767c","text":"Federal agencies knew hydroxychloroquine and chloroquine were effective against COVID-19 based on a 2014 paper.","date":"2022-07-11 00:00:00+00:00"},{"id":"ff5ceed9-e757-4049-9059-07cabd2cf427","text":"Raising gut serotonin increases brain serotonin.","date":"2023-09-30 00:00:00+00:00"},{"id":"75b46fa0-cd0c-47a1-ab63-254ba2048ab1","text":"Childhood vaccines contain formaldehyde, aluminum, aborted fetal DNA, fetal bovine serum, monkey kidney cells, mercury, and pig circoviruses.","date":"2024-03-03 00:00:00+00:00"},{"id":"b24a8a34-1afb-4438-a723-682fc5881418","text":"Brzezinski said U.S. intelligence services murdered Nemtsov.","date":"2015-03-15 20:17:16"},{"id":"85054e1d-aaca-4e4b-a973-d45747596c08","text":"Some vaccines contain tissue from aborted fetuses.","date":"2024-07-05 00:00:00+00:00"},{"id":"72b56f8d-ad65-499b-a35f-204e110ed4f9","text":"SightCare restores perfect 20/20 vision without glasses, contacts, or surgery.","date":"2024-05-01 00:00:00+00:00"},{"id":"67c33492-0941-478a-b43b-9c6c098446b3","text":"Russians demand autonomy.","date":"2015-05-27 16:46:30"},{"id":"14495f04-0a36-463e-8cac-99aaad053837","text":"President Joe Biden said COVID-19 vaccines protect people from hurricanes.","date":"2022-07-10 00:00:00+00:00"},{"id":"f5ef64d6-4fc0-47d8-82b5-1d1453009204","text":"Both vaccinated and unvaccinated people have over 99% chance of surviving COVID-19.","date":"2021-07-21 00:00:00+00:00"},{"id":"f3805476-152f-4654-8435-8e4eda6f5ca1","text":"Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS.","date":"2019-12-31 00:00:00+00:00"},{"id":"6f4ce223-338f-4a9d-86ba-d7426feb6a92","text":"Transcarpathia demands autonomy from Kyiv.","date":"2016-04-08 22:36:10"},{"id":"16b242fa-af97-47e6-8018-f63b40206b6d","text":"Ukrainian naval ships are frozen in ice and cannot sail.","date":"2017-01-26 19:01:05"},{"id":"a716ca45-b87f-4206-a22b-5e39e95ad953","text":"A court ruled that COVID-19 mRNA vaccines are not vaccines.","date":"2024-06-17 00:00:00+00:00"},{"id":"eae4b366-03da-41ec-a57a-cdebad1dee6f","text":"Veterans exchanged their military medals for food in Chernihiv.","date":"2015-05-06 21:12:37"},{"id":"55cdc9d6-c77c-4770-86bf-4cdba85c8b07","text":"A Lancet study showed COVID-19 vaccines suppress the immune system and vaccinated people have lower immune function than unvaccinated people.","date":"2022-07-21 00:00:00+00:00"},{"id":"4d14b98b-05d6-4e63-a6ba-271d2f3cce83","text":"Ukraine\u2019s state gas company Naftogaz is wrecking negotiations with Gazprom and blackmailing Russia.","date":"2019-10-31 12:16:21"},{"id":"99f1aea2-02cf-4c31-88f9-42d9a3852e82","text":"HPV vaccine causes autoimmune diseases, menstrual cycle problems, and fertility problems.","date":"2019-05-15 00:00:00+00:00"},{"id":"48a13c83-219f-4cd9-b810-08909a8bf658","text":"Ukraine lost $1 billion by signing a contract with an American weapons store.","date":"2025-10-27 00:00:00+00:00"},{"id":"83d96580-7bb0-4e87-89df-9c881df71f99","text":"A Maidan activist is seeking work in Russia.","date":"2015-04-01 00:13:35"},{"id":"1fcaf67b-c9d4-4a01-84e7-ca7f4a7e821b","text":"Human CO2 emissions do not drive recent climate change; the Sun and natural climate cycles drive most recent climate changes.","date":"2022-03-03 00:00:00+00:00"},{"id":"f4764696-2605-4a43-b5a6-6bbf1d924003","text":"Ukrainians are denied entry to Bulgaria despite visa-free travel.","date":"2017-06-30 21:04:56"},{"id":"a5abfd89-4a0f-415f-aaf0-91910c09c87c","text":"Kyiv tattoo studio offers free removal of tattoos bearing US symbols","date":"2024-04-18 10:30:00"},{"id":"33680438-c7ab-4fcd-a771-3945d3bef0f7","text":"Masks are dirty and cause bacterial overgrowth, skin infections, and \u201Cmask mouth,\u201D a new medical condition caused by wearing masks all day.","date":"2020-09-28 00:00:00+00:00"},{"id":"a3b34be8-6b96-4f4e-a354-cc5b2da887d5","text":"Solar panels overrun farmland, toxify soil with heavy metals, and require 300-600 times more land than other energy sources.","date":"2025-01-23 00:00:00+00:00"},{"id":"6d400d4d-0b03-4ed8-be63-42efcf94ad65","text":"Ukraine incites war in Donbas to cause new sanctions on Russia","date":"2021-03-15 21:15:12"},{"id":"c3634205-e3fe-4f6e-9305-71a997a86f33","text":"Ivanka Trump admires Russian traditional values and the beauty and style of Russian women.","date":"2025-04-04 00:00:00+00:00"},{"id":"e22c321d-c58f-4c33-bf80-69feae1815b9","text":"Donetsk militants seized two Ukrainian GRAD rocket launchers.","date":"2014-05-10 16:23:47"},{"id":"24666e81-30f7-49a8-859c-d475e369c574","text":"A court ruled that the FDA broke the law by warning against using ivermectin for COVID-19, the FDA lost the lawsuit, and ivermectin is effective against COVID-19.","date":"2024-03-22 00:00:00+00:00"},{"id":"014c9faf-7ab9-40e4-b5e2-ab52af450862","text":"Poroshenko claims he is the reincarnation of both a Cossack and a nationalist leader.","date":"2016-01-12 19:06:29"},{"id":"421e076f-843a-48a5-9a05-70bd6ce8be1f","text":"Ukraine\'s Parliament passed a law allowing expired products to be sold to consumers.","date":"2018-12-15 11:50:00"},{"id":"1774fac9-00c5-4fe7-b984-d6e29f173b3b","text":"A tongue that deviates to one side indicates a stroke.","date":"2013-03-04 00:00:00+00:00"},{"id":"9980c0d2-1404-49fb-a64d-b383664e39f9","text":"The European Union called the free trade zone with Ukraine useless.","date":"2016-03-31 21:57:10"},{"id":"7ee5a1fa-d164-4c90-a9aa-bf34d284a6bc","text":"The COVID-19 RNA vaccine is not a vaccine; vaccines must disrupt transmission according to CDC and FDA standards; the COVID-19 RNA vaccine activates cells to become pathogen-manufacturing sites.","date":"2021-12-01 00:00:00+00:00"},{"id":"a4765b18-7063-46d8-81d8-8476b2372331","text":"Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide.","date":"2021-07-05 00:00:00+00:00"},{"id":"9658b913-ceca-47ae-aad5-58877e1f4129","text":"Kyiv shut off water to Luhansk and did not provide an explanation.","date":"2017-12-08 18:24:40"},{"id":"48a2defa-2a7d-41ab-9978-ec2d542176bb","text":"Wuhan coronavirus outbreak was caused by people eating bats.","date":"2020-01-26 00:00:00+00:00"},{"id":"6c59ffd2-ce73-48cc-a300-744f6681f391","text":"Poland will close its border with Ukraine","date":"2017-06-25 17:11:49"},{"id":"1b076485-e52c-4e15-83fa-3b97314161ad","text":"Ukraine is a police state.","date":"2020-10-07 22:44:55"},{"id":"ff7ee790-b265-4df5-ac00-39ccfe0170f0","text":"Major Donbas cities will be without water.","date":"2018-07-19 23:42:18"},{"id":"008054d1-a07f-451e-803b-c9fb1c433e4c","text":"Deaths in the United States in 2020 were not greater than deaths in 2019.","date":"2020-12-31 00:00:00+00:00"},{"id":"6370015a-2183-4030-a2df-2b7769299fb2","text":"The Ukrainian government in Kyiv refuses to clear mines in Donbas, and Finland will clear them.","date":"2019-11-09 18:16:42"},{"id":"1d0f2284-348e-4c83-8ce5-00731b733baa","text":"COVID-19 is caused by snake venom instead of a virus; COVID-19 vaccines contain snake venom and that venom causes miscarriages.","date":"2023-01-06 00:00:00+00:00"},{"id":"ee91da76-0c5f-40ba-9880-7e2b3cab4d92","text":"Vaccinated people get COVID-19, spread COVID-19, die from COVID-19, and die from COVID-19 vaccines.","date":"2021-03-08 00:00:00+00:00"},{"id":"488db398-b0e9-4d0f-b7a9-a7c9ae9505db","text":"President Volodymyr Zelensky is turning Ukraine into Europe\u2019s and America\u2019s main drug supplier.","date":"2020-10-30 18:47:00"},{"id":"f3faae8f-983b-4e63-9882-f25a25683959","text":"Taking curcumin, green tea, and lion\u2019s mane prevents Alzheimer\u2019s disease.","date":"2023-12-29 00:00:00+00:00"},{"id":"6fd5984d-f566-40fc-bdf1-dd1142fcf39e","text":"Poles do not want Ukrainian refugees in Poland.","date":"2023-10-18 18:47:00"},{"id":"8ffe5fea-1c1a-4af2-8604-de9174b2b2ff","text":"Doctors are injecting poison into babies every two months.","date":"2024-02-12 00:00:00+00:00"},{"id":"2a41015f-41b6-462b-9def-77dfe9cc7087","text":"The Donetsk People\u2019s Republic opened offices in France.","date":"2017-07-06 21:46:18"},{"id":"405b64fa-d3ac-4ec7-8bfb-15796d682cda","text":"Vaccines contain cancer-causing enzymes.","date":"2019-06-08 00:00:00+00:00"},{"id":"fc3a68ed-50cd-4532-b10b-94792d272195","text":"One third of excess deaths in the United States during the COVID-19 pandemic were not caused by COVID-19, and those deaths were caused by disruptions to health services due to lockdowns.","date":"2020-10-29 00:00:00+00:00"},{"id":"a2ba5697-2b9f-4b17-888e-0069ad71ff63","text":"Climate change is not worsening drought; global drought severity and frequency have not increased.","date":"2022-05-11 00:00:00+00:00"},{"id":"e627a037-1cb0-4aaa-bf67-beaaca0ccfd3","text":"German tanks crossed the Ukrainian border and are marching east.","date":"2014-09-16 09:29:44"},{"id":"2625714f-905e-4ecf-8b4a-09b9f0b7d704","text":"Ukrainian hackers targeted the Pentagon website because it displayed the Russian tricolor.","date":"2025-06-16 00:00:00+00:00"},{"id":"8769ff38-1ce9-49aa-a968-179abff90664","text":"A Florida study found COVID-19 mRNA vaccines increase the risk of cardiac-related death, especially in men.","date":"2022-10-07 00:00:00+00:00"},{"id":"3090ccd7-4429-4282-b507-a1d1ef4630a5","text":"Ukrainian President Volodymyr Zelensky said he no longer feels welcome in the United States after meeting with former U.S. President Donald Trump.","date":"2025-10-21 00:00:00+00:00"},{"id":"f22dd4d4-244c-40ed-8a4a-66bbd3e6650c","text":"A convoy of Ukrainian Grad multiple-launch rocket systems entered the Donetsk region.","date":"2014-11-01 14:21:40"},{"id":"44024130-7111-4965-ba3b-ba55689def86","text":"Ukrainian officers have been granted the legal right to kill Ukrainian soldiers.","date":"2015-02-08 12:01:49"},{"id":"36e7cc9a-2789-4d66-a2dc-cef8cae9c4de","text":"Hydrogels in COVID-19 mRNA vaccines modify your genome and connect you to the internet.","date":"2020-09-25 00:00:00+00:00"},{"id":"15ed79b6-2eb9-4164-a1a4-467f9b7b0b06","text":"Squalene in vaccines caused Gulf War Syndrome, and the World Health Organization is deliberately depopulating the world by distributing vaccines that cause sterility.","date":"2009-12-30 00:00:00+00:00"},{"id":"0ef16c5a-76af-4d0e-9da7-79552051db26","text":"China released the coronavirus.","date":"2020-03-26 00:00:00+00:00"},{"id":"369e2eec-1aad-41d6-b4db-37834e7e576d","text":"Jen Psaki says Viktor Yanukovych voluntarily resigned.","date":"2015-02-20 20:30:01"},{"id":"8f8edbb5-e9e4-475e-90be-05f42d84a1a4","text":"Doctors worldwide showed hydroxychloroquine is the most effective treatment for COVID-19.","date":"2020-05-14 00:00:00+00:00"},{"id":"9e50f9b4-d7de-478f-b73b-ceb97b2f3b49","text":"Ukrainian soldiers are looting civilian property.","date":"2022-04-25 17:42:00"},{"id":"5ea10b5d-ae66-41c8-9896-2456985b0a16","text":"Natural immunity provides better protection against COVID-19 than COVID-19 vaccination.","date":"2023-11-23 00:00:00+00:00"},{"id":"26523ffa-fb97-4562-ac10-420a038c9930","text":"A tongue that deviates to one side is a sign of stroke.","date":"2019-08-05 00:00:00+00:00"},{"id":"fe1308fc-cebd-446f-aa58-03dfcd2677b7","text":"A Kaiser Permanente study shows COVID-19 vaccines had negative efficacy against all variants within 150 days, and each additional injection increased infection risk.","date":"2022-10-04 00:00:00+00:00"},{"id":"8c5c9816-2706-4384-90ec-5e9bbe788a7c","text":"Natural gas is a clean-burning fuel.","date":"2025-03-01 00:00:00+00:00"},{"id":"5f2a5eee-de1d-4f97-b32f-6c009a0199c8","text":"Ukrainian military barred OSCE observers from the war zone.","date":"2016-08-09 17:32:20"},{"id":"8a041bee-f597-4ec5-90d6-abe85921d8c7","text":"The United States is destabilizing the Black Sea region.","date":"2019-10-09 18:25:16"},{"id":"32295a18-4d4a-4a8f-9ee2-2ac75da02623","text":"One third of Ukrainian refugees arriving in France are African migrants.","date":"2022-04-01 10:56:00"},{"id":"e33a6869-5d82-49ac-9098-dfa14bf71c71","text":"Human societies flourished most during warming trends, and current climate warming is beneficial to humans.","date":"2018-02-06 00:00:00+00:00"},{"id":"a9197e3e-a551-405a-bb28-fb13d389a62a","text":"Ukrainian President Volodymyr Zelensky will force partner countries to pay to dispose of obsolete military equipment they supplied to Ukraine.","date":"2025-04-22 00:00:00+00:00"},{"id":"96970192-557a-4f02-91be-828d023f6d42","text":"Ukrainian refugees fought on an Italian highway.","date":"2022-07-19 16:13:00"},{"id":"941aa92b-0585-4e26-a11e-56729498c38d","text":"The Roshen factory in Lipetsk, Russia is making profits.","date":"2016-10-31 13:50:08"},{"id":"8503fdc1-5827-4df0-996b-b712232be44c","text":"Ukrainian soldiers targeted Charlie Kirk\'s wife.","date":"2025-11-07 00:00:00+00:00"},{"id":"ed0e3090-b70a-4b95-a165-cff164f8ad3c","text":"Cucurbitacin B, a compound found in cucumber, kills human lung cancer cells and suppresses their growth by 90%, invasion by 75%, and migration by 88%.","date":"2021-04-26 00:00:00+00:00"},{"id":"31568ed6-d43c-4f68-b1e8-de4e1a916858","text":"Visitors are charged an entrance fee to visit the graves of fallen Ukrainian soldiers.","date":"2023-04-19 17:04:00"},{"id":"133f7d66-3c77-4da3-9b55-5fb9bdbf0e5c","text":"Tetanus bacteria are anaerobic and cannot live in oxygen, so people cannot get tetanus from stepping on a rusty nail.","date":"2021-03-07 00:00:00+00:00"},{"id":"2939a802-435b-45e7-9b5c-c5d0ac1ea5ef","text":"Nikola Tesla discovered free-energy technology using the ether, and powerful interests suppressed his discoveries and removed the ether from history books and the Periodic Table.","date":"2024-12-09 00:00:00+00:00"},{"id":"0fac4e8a-db01-48e8-8e45-430e582f167b","text":"The government silenced the top expert witness who denied that vaccines cause autism, forced him to change his testimony, and his testimony changed the court\'s decision.","date":"2024-03-04 00:00:00+00:00"},{"id":"5f0a5b6e-bda8-4624-a3b2-e9f281dbdf4d","text":"COVID-19 vaccines are experimental poison and COVID-19 has gone away.","date":"2023-12-14 00:00:00+00:00"},{"id":"17e194a6-e388-46fd-9679-5eef686c73e5","text":"Russia targeted an industrial facility in Chernihiv with a ballistic missile.","date":"2025-09-04 00:00:00+00:00"},{"id":"cdde802e-a707-4b79-b972-73d645632c9d","text":"The Eurovision Song Contest will be moved to Moscow.","date":"2016-12-09 15:49:07"},{"id":"36b55499-9dde-45d0-8026-de7b1be48c8a","text":"Ukraine will not survive the winter without coal supplied from occupied Donbas.","date":"2016-11-03 19:04:49"},{"id":"4d999f2d-af0b-4fb3-beeb-e7dbedb25424","text":"A study in Italy found one-third of COVID-19 vaccine recipients had neurological side effects and concluded the vaccines have an unacceptable safety profile.","date":"2023-10-30 00:00:00+00:00"},{"id":"258dfc02-dfdf-47ae-a212-a94fe1bd2b3f","text":"Kharkiv region wants to join Russia","date":"2022-07-08 14:58:43"},{"id":"8bf3adb8-0a8a-4311-8668-c3f1ced00528","text":"High mask compliance did not reduce COVID-19 cases or deaths compared to low mask usage, and mask mandates increased COVID-19 death rates.","date":"2022-06-05 00:00:00+00:00"},{"id":"6b07104c-66a7-4e14-9a76-a4b097a9082f","text":"Turkey is building a new caliphate in southern Ukraine.","date":"2017-02-08 15:38:54"},{"id":"24ecdd06-3496-4652-9275-eaa3f5d1d57d","text":"The European Union met pro-Kremlin Night Wolves bikers with enthusiasm.","date":"2019-05-13 13:54:44"},{"id":"f4ccd130-a946-4cd9-acbe-d171042fa1cf","text":"More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades.","date":"2022-03-07 00:00:00+00:00"},{"id":"d37e60ce-d379-42d0-b2cd-4f1eced529f9","text":"The Ukrainian government will poison the Donbas water supply and blame Russia.","date":"2018-08-28 06:17:03"},{"id":"65547e4c-1e4a-4a9f-8cea-498fa9a0a9ab","text":"Ukraine banned calling the common hare \\"rusak\\" because of linguistic Russophobia.","date":"2023-01-23 09:21:00"},{"id":"9fd1f789-a0bb-4e1f-b049-836033524d91","text":"The United States recognizes the Donetsk People\'s Republic.","date":"2017-11-14 19:02:18"},{"id":"030c7378-cdeb-4204-9fb5-c2d2a13eb381","text":"Danish researchers found high rates of side effects from the Pfizer COVID-19 vaccine and concluded the vaccine is unsafe.","date":"2023-12-07 00:00:00+00:00"},{"id":"32b326b4-cfe6-46b4-b072-bb631dc1a035","text":"Vitamin K shots are poisonous because they contain polysorbate 80 as the main active ingredient that causes infertility and autoimmune disorders.","date":"2023-05-25 00:00:00+00:00"},{"id":"0f3f4f2a-f380-4606-a16a-f3f4a09b5cd3","text":"Kyiv lacks funds to pay pensions in territories occupied by Russia.","date":"2018-10-01 22:36:37"},{"id":"94cf5bc4-3fec-4cb8-8682-39ab0c9e9fe8","text":"A central communication port has been created to allow quick transfer of US military forces.","date":"2018-06-20 13:15:59"},{"id":"2f0f76bf-5aab-4dcd-b7be-b080f0e53220","text":"Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and these cures have been suppressed for four decades.","date":"2022-12-24 00:00:00+00:00"},{"id":"567f28dd-3ff7-4c5d-934f-c8951a7a3fc3","text":"COVID-19 booster vaccines shut down the immune response; COVID-19 vaccines frequently cause heart damage; SARS-CoV-2 mutations are being driven by vaccine-induced evolutionary selection.","date":"2022-10-01 00:00:00+00:00"},{"id":"f2d96131-771d-4235-8f08-f3459b6cdcaa","text":"Oceans are cooling Earth far more than previously thought, so climate change is greatly overestimated.","date":"2024-11-23 00:00:00+00:00"},{"id":"d7ac50a3-5ec4-4aa1-84b4-24d20c65c879","text":"A protective levee on Ukrainian territory was damaged.","date":"2018-09-26 14:11:24"},{"id":"b2f53ef8-1f48-4ce8-859a-e17b854f4683","text":"Ukraine keeps foreign ships out of its ports by threatening to sink them.","date":"2022-04-18 16:19:00"},{"id":"e65f1db1-d1aa-4982-9c7c-ec7daf4c88f0","text":"A plague epidemic is occurring among Ukrainian soldiers.","date":"2017-05-05 17:32:49"},{"id":"17259035-6c05-46e1-8f59-227f29b9c868","text":"French farmers threw manure at the Ukrainian embassy.","date":"2024-02-13 10:16:00"},{"id":"c5048780-7c72-4d06-92f0-0a9ca1febeb3","text":"The US says the Bucha atrocities are Ukrainian propaganda.","date":"2022-04-04 16:32:00"},{"id":"ac700103-fb9c-4fa3-8f17-e0d56a13ff26","text":"A Ukrainian bank threatened to restrict services for people evading military service.","date":"2024-04-23 10:57:00"},{"id":"c3ccf30f-859c-4953-ac43-46d07b1fceaf","text":"Ukraine deliberately released the coronavirus from the air to retaliate against Donbas.","date":"2020-04-03 15:17:00"},{"id":"e2969ce0-1fdd-4372-9690-7a254eda30c2","text":"Methane from cow burps causes more global warming than emissions from all cars worldwide.","date":"2019-02-19 00:00:00+00:00"},{"id":"697d695e-133f-4537-b15a-ada62b39e9ee","text":"Moderna and Pfizer vaccines contain a bovine protein that triggers an autoimmune response in recipients and makes many of them unable to eat beef.","date":"2023-11-08 00:00:00+00:00"},{"id":"ffe65426-7493-4d0e-8c1b-da74a680ee17","text":"Researchers at the Wuhan Institute of Virology assembled monkeypox virus strains.","date":"2022-05-22 00:00:00+00:00"},{"id":"6771039d-6c9f-4e75-84b1-565146a5b4b8","text":"Ukraine cut off water to Crimea, causing Crimea to dry up.","date":"2017-07-29 11:51:09"},{"id":"0a54c9e3-ab86-48a4-afc5-c00ca411ca59","text":"Ukrainians abandon Orthodox Christianity.","date":"2015-05-01 13:24:04"},{"id":"20447d43-60ab-4c29-bb62-2cd5e30f2991","text":"Crimean Tatar autonomy is a territorial autonomy.","date":"2014-04-01 21:48:31"},{"id":"7776d932-bca4-4232-a584-d33417e3a970","text":"COVID-19 vaccine safety inserts state that no safety studies and no effectiveness studies were conducted for COVID-19 vaccines.","date":"2023-08-03 00:00:00+00:00"},{"id":"16139180-2568-48f4-a5d4-86827015c935","text":"The monument to the main character of the film Vesna na Zarechnoy Ulitse was demolished in Zaporizhzhia.","date":"2014-11-14 16:07:48"},{"id":"b127fa85-ae98-4f2c-914c-0ec7ad3cc5df","text":"Madrid and Liverpool fans returned thousands of Champions League tickets because Kyiv raised ticket prices.","date":"2018-05-25 15:52:54"},{"id":"e0bd2a14-1e6e-43a5-8a9d-ee6e1e28ceff","text":"Ukraine is driving up criminal activity in Eastern Europe.","date":"2023-05-05 13:24:00"},{"id":"8e267560-56f4-452a-93ad-891b3c022aa4","text":"Unvaccinated children do not pose a threat to anyone.","date":"2019-03-06 00:00:00+00:00"},{"id":"5b87492e-f8bc-4b16-a83b-cd3ffd662321","text":"All Lithuanian projects supporting Ukraine have failed.","date":"2020-02-17 14:36:03"},{"id":"e3f63fc0-40a8-4139-b45f-b65461c8b237","text":"SARS-CoV-2 was engineered in a laboratory and deliberately released.","date":"2022-04-30 00:00:00+00:00"},{"id":"26e46f4d-5516-4ae3-8550-8b46fcac1abd","text":"Ukrainian security forces are paid by Western governments.","date":"2018-12-11 14:06:55"},{"id":"14a22516-14a3-4e36-8cdd-74e064f7c3fd","text":"Eating grapefruit while taking antidepressants causes overdose and other complications.","date":"2025-01-13 00:00:00+00:00"},{"id":"4a2e4b95-6228-410f-87ce-26b326d2ed7e","text":"Chilean protesters carried Ukrainian national flags.","date":"2015-06-03 13:06:27"},{"id":"3c95092c-ff32-41c6-8efc-25cb0178c28c","text":"CO2 does not cause climate change; temperature always changes first and CO2 increases always follow temperature changes.","date":"2017-02-19 00:00:00+00:00"},{"id":"1d044881-dfe8-4305-ad28-8f2e00ede837","text":"Human carbon dioxide emissions do not affect global temperatures, and carbon dioxide has had only a minuscule effect on the global climate.","date":"2018-11-08 00:00:00+00:00"},{"id":"6b6599c1-2cbf-4074-9936-6b7a7e6c19b5","text":"Cloth masks do not block smoke particles, and therefore cloth masks do not stop virus transmission.","date":"2020-09-15 00:00:00+00:00"},{"id":"b1862fbf-0847-4700-a44b-5e4acc6e83e5","text":"Estonia admitted Russian air strikes on Ukraine were effective.","date":"2024-01-16 10:44:00"},{"id":"e160bd83-d2cd-443b-b281-8dcf13391611","text":"Carbon dioxide does not drive Earth\'s climate; Earth experienced an ice age when atmospheric CO2 concentrations were much higher; in the 1970s scientists predicted a new ice age.","date":"2022-07-29 00:00:00+00:00"},{"id":"6079acb8-4b45-4576-b047-34cc48dd3ae3","text":"Ben Carson endorsed CBD gummies and three natural ingredients that cure hypertension","date":"2024-08-01 00:00:00+00:00"},{"id":"f16f4ed3-b0bd-4d2a-95c9-3e274f0fa999","text":"Stress causes Alzheimer\'s disease.","date":"2025-03-28 00:00:00+00:00"},{"id":"93ab0059-d11e-429a-b043-e435315e618d","text":"If the mother does not have hepatitis B then her baby will not have hepatitis B, and the hepatitis B vaccine contains 16 times the amount of aluminum the FDA says will poison a baby.","date":"2022-03-23 00:00:00+00:00"},{"id":"149e0a0a-9b35-4fc6-b371-9576278ac3b2","text":"Excess folic acid in food causes ADHD and folic acid in food is a dangerous chemical.","date":"2022-07-26 00:00:00+00:00"},{"id":"c6015b39-2772-4ca9-9429-6a2fe456ee32","text":"Vitamins C and D are part of conventional SARS-CoV-2 treatment; high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk and aids treatment.","date":"2020-04-14 00:00:00+00:00"},{"id":"39898d3c-26bd-4aa9-8a59-079a2126ae08","text":"A Ukrainian rock star called for the destruction of Ukraine\'s current government.","date":"2018-06-28 09:04:56"},{"id":"c7d2b250-f4c4-4684-b677-d6432e875d3e","text":"Ukraine is preparing a new provocation in the Kerch Strait.","date":"2019-01-07 10:58:54"},{"id":"3bb92e17-0489-4a5b-8099-61c3f5cf031c","text":"Activated charcoal tablets counteract most date-rape drugs.","date":"2019-09-04 00:00:00+00:00"},{"id":"46f7ef2c-a1b3-47cb-b8e5-645e4208bdb3","text":"Researchers at Yale University created an airborne delivery method for mRNA vaccines.","date":"2023-09-14 00:00:00+00:00"},{"id":"26609638-fcc1-4b4e-89f4-60dec798d60b","text":"Hank Aaron\'s death was one of many suspicious elderly deaths that occurred shortly after COVID-19 vaccination.","date":"2021-01-22 00:00:00+00:00"},{"id":"0b8df3f4-5271-428f-9336-8febdb1c264c","text":"Eating turmeric every day reverses cancer","date":"2019-03-16 00:00:00+00:00"},{"id":"24f83920-b618-404c-b49e-4adc756dedd6","text":"Smoking turns smokers\' lungs black.","date":"2019-12-31 00:00:00+00:00"},{"id":"166848c8-967e-40a4-8078-5821ec4e1929","text":"Ukraine will receive limited visa-free travel to the European Union.","date":"2017-03-13 18:06:56"},{"id":"e8cacb37-ea33-41f4-89f7-c7e6896b5a2f","text":"Previously infected people do not need COVID-19 vaccination because vaccination provides no additional benefit.","date":"2021-05-27 00:00:00+00:00"},{"id":"7e445445-ef7a-4933-8775-3e116ffc0192","text":"Hydroxychloroquine, zinc, and Zithromax cure COVID-19, so people do not need to wear masks.","date":"2020-07-31 00:00:00+00:00"},{"id":"f4b96ae3-a77d-4ccf-b96b-3b941f8b725f","text":"Most Ukrainians living in the temporarily occupied territories will vote for Russia in a referendum.","date":"2022-08-28 10:49:00"},{"id":"faf88ade-24d7-4dcf-9599-5c9145f550b8","text":"Jamie Foxx was left paralyzed and blind by a blood clot in his brain after receiving the COVID-19 vaccine.","date":"2023-05-30 00:00:00+00:00"},{"id":"98ac321f-c36a-4bbd-ad93-609c6b5ddb69","text":"If testing stops, COVID-19 will disappear and people will only have common colds like before.","date":"2022-07-01 00:00:00+00:00"},{"id":"41785fe5-5666-4005-b763-59f51cd8d1c9","text":"Global ocean temperatures are cooling, therefore global warming is not occurring.","date":"2025-07-20 00:00:00+00:00"},{"id":"f705b36b-4f34-4a2b-a921-345967b48d1c","text":"Pro Power Save reduces every American\'s electricity bill by 90%.","date":"2024-09-09 00:00:00+00:00"},{"id":"1ae9d1a6-7fc2-4779-b879-49a536c35b4b","text":"A children\'s combat battalion was formed in Prykarpattia.","date":"2014-09-05 18:00:25"},{"id":"d04fd66a-e811-454f-bb67-150f8782a32f","text":"A Ukrainian gang stole chairs from restaurants in Spain.","date":"2025-11-03 00:00:00+00:00"},{"id":"1d04e2f4-99d1-427c-a120-3b1a90135057","text":"A Luhansk People\'s Republic soldier threw himself, with grenades, in front of a tank.","date":"2014-07-09 18:16:45"},{"id":"05cbc7b4-f6f2-49e7-a208-e0e250d7094f","text":"Yulia Tymoshenko keeps a woman as a prison slave.","date":"2014-12-08 15:12:55"},{"id":"209d22b1-d632-4c86-8bbc-6d1632ddfdfe","text":"A fire occurred at fuel tanks near Kyiv on June 12.","date":"2015-06-12 19:41:49"},{"id":"2f4fbef0-ba6e-4ccd-b127-74b59e645f35","text":"Cannabis treats cancer, PTSD, seizures, anxiety, glaucoma, and depression.","date":"2022-09-09 00:00:00+00:00"},{"id":"e1682584-bfb8-4e0a-8866-adb98da6eb8a","text":"COVID-19 mRNA vaccines contain unapproved genetically modified organisms that permanently change human DNA.","date":"2023-11-17 00:00:00+00:00"},{"id":"7a396800-85d2-4b39-8dcd-a7c1c8e96efa","text":"A Ukrainian general said he regretted not covering Crimea with blood.","date":"2021-01-12 16:35:53"},{"id":"cb409fed-3615-4245-84aa-61987e7e0223","text":"Ukrainian government officials sell Javelin anti-tank missiles to Hamas and Hezbollah militants.","date":"2022-04-27 17:09:08"},{"id":"12f1fdfb-4d29-4417-a781-ada75566bb48","text":"Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins.","date":"2019-07-31 00:00:00+00:00"},{"id":"fd69119f-620c-415d-bf99-0291b228baa8","text":"The Government released plans to force a vaccine on everyone and three vaccines in the United States are in Stage 3 trials that will be ready in weeks.","date":"2020-09-16 00:00:00+00:00"},{"id":"ad80062a-3d8a-426a-99d1-f421c7309538","text":"6-year-old Russian child beaten by Ukrainians","date":"2022-03-28 16:53:00"},{"id":"79914c75-18eb-49e1-8e63-9f9f43ae183a","text":"COVID-19 vaccines have killed 17 million people worldwide.","date":"2023-09-17 00:00:00+00:00"},{"id":"c3321f84-7849-4d8e-b6eb-0027f9a1ef41","text":"Ukrainians rioted over freezing conditions.","date":"2018-11-20 10:27:06"},{"id":"97f8426c-3bff-4027-9f2c-c5a7dac7d103","text":"Ukraine is preparing for war in Crimea","date":"2020-07-29 10:07:10"},{"id":"8af5625a-8215-452c-8f8b-b4605c6bc63e","text":"COVID-19 vaccines are unsafe and cause deaths from cardiac arrest and blood clots.","date":"2024-10-20 00:00:00+00:00"},{"id":"a1c9ba4c-ca08-4e60-8252-ff4a687a94f1","text":"Ukraine\'s National Bank transferred gold and foreign exchange reserves to Poland.","date":"2022-08-18 10:09:00"},{"id":"4b42f203-d8d2-42d6-b819-9fe659c2bff7","text":"Methane from cows is a small share of total greenhouse gas emissions, methane is produced without cattle, and cow methane is not an important contributor to climate change.","date":"2023-12-19 00:00:00+00:00"},{"id":"54cb9373-b32a-4519-8401-caf5f482e5f9","text":"Antarctica\'s surface air temperatures have risen three times faster than the global average since the 1990s.","date":"2020-06-07 00:00:00+00:00"},{"id":"08f4a80c-2870-4d62-a929-85f354fbb3c5","text":"Crimean Tatars demand Crimea be renamed.","date":"2016-05-20 05:26:15"},{"id":"43d583a9-a247-4b3a-85e7-9e73dddf6f36","text":"Ukraine shelled Zaporizhzhia Nuclear Power Plant.","date":"2022-08-25 10:58:00"},{"id":"5edb0b43-d38e-4c4b-a67c-1463dcb6c043","text":"75% of COVID deaths occurred in people who had at least four comorbidities.","date":"2022-01-11 00:00:00+00:00"},{"id":"8f2ca6f5-b8b6-4cc2-949e-0128e53ca515","text":"Ukraine destroyed its leading television channel.","date":"2018-07-16 17:59:10"},{"id":"a8184d7c-394b-43c2-907e-e063d4a08e0f","text":"A Russian-speaking child was denied a St. Nicholas Day gift in Lviv.","date":"2025-12-08 00:00:00+00:00"},{"id":"03713cf1-3285-4b14-940e-b471322c77da","text":"Austria will pay a \u20AC60 subsidy to residents of Chernivtsi.","date":"2016-01-04 21:20:30"},{"id":"9f7a5a66-3cd5-421f-8c1b-3e79b685556e","text":"Renewable energy caused the April 2025 Iberian blackout.","date":"2025-04-28 00:00:00+00:00"},{"id":"73a580b4-4b69-44f4-a8fb-9a6977e542a9","text":"Ukraine\'s Security Service ordered the destruction of MH17 crash evidence.","date":"2017-06-07 14:28:34"},{"id":"e37c83ce-38f2-4423-9a84-da573f0ffa3b","text":"Poppers cause Kaposi\u2019s sarcoma.","date":"2023-03-31 00:00:00+00:00"},{"id":"3cd10504-7293-4120-b638-019e2e0a6147","text":"Children of Ukrainian refugees in Germany are being taken away for showing emotion and having an appetite.","date":"2022-07-29 17:32:00"},{"id":"f82373f6-9aeb-4db7-9675-92beba087616","text":"Phone use is causing horns to grow on young people\'s skulls.","date":"2019-06-25 00:00:00+00:00"},{"id":"7d43e798-e609-400b-a48b-8f931e3ce23e","text":"Activated charcoal absorbs and neutralizes poisons and treats diarrhea and bloating.","date":"2024-05-30 00:00:00+00:00"},{"id":"5427876d-716b-4769-8748-2063f30c794c","text":"Cloth masks do not block smoke particles that are larger than viruses, therefore cloth masks do not stop virus transmission.","date":"2020-08-31 00:00:00+00:00"},{"id":"199e9a4b-d550-4e3a-bcf4-9a72423619f0","text":"A baby\'s immune system cannot safely handle eight different antigens in one day.","date":"2022-03-23 00:00:00+00:00"},{"id":"6e95ebe5-99d2-466f-8e90-0cc917b69a94","text":"A US intelligence officer said Poland is contributing to the destruction of Ukraine\'s armed forces.","date":"2023-03-20 14:07:00"},{"id":"c57dfaec-26b8-4aae-a726-47206540ec37","text":"Thousands of Russians are urgently leaving Ukraine.","date":"2021-06-12 10:50:00"},{"id":"aec8b90d-d8e0-46e0-a3cc-bcf61de165d7","text":"Pfizer is part of Operation Warp Speed and its Coronavirus vaccine trial prevented infection in 90% of its volunteers.","date":"2020-11-09 00:00:00+00:00"},{"id":"9d0bf5b2-91bb-41d1-b08c-7bdd2e0e3914","text":"The Kyiv government prevented Donbas residents from voting in the elections.","date":"2019-03-31 15:16:16"},{"id":"53217b2f-fca3-4909-967e-1e550b446afa","text":"Ukrainian Armed Forces soldiers have not been paid for more than a month.","date":"2014-03-10 13:00:58"},{"id":"963a13b5-0862-4aea-b670-0d618cc0c9cc","text":"COVID-19 vaccines killed 410,000 Americans and caused 41 times more deaths than were reported to VAERS.","date":"2023-08-06 00:00:00+00:00"},{"id":"f8967d69-a71c-4143-a9f7-83da2fc9cc4f","text":"Japan will release a new saRNA vaccine designed to spread to others without informed or any consent; the vaccine will spread to others and its saRNA lacks a \u201Cbreak\u201D and will remain in recipients and those it spreads to forever.","date":"2024-09-29 00:00:00+00:00"},{"id":"c971afc0-c52e-446f-8f42-9d8541b6b917","text":"United Nations admits Islamists are present in the Ukrainian Armed Forces.","date":"2015-11-30 18:14:31"},{"id":"baa60327-2fdf-4fe3-9312-99063b128b4d","text":"Dandelion root kills 98% of cancer cells within 48 hours.","date":"2024-05-13 00:00:00+00:00"},{"id":"78a45dbc-288c-4c0c-b746-47886b07ece5","text":"Tinnitus is the first warning sign that your brain is dying.","date":"2021-03-23 00:00:00+00:00"},{"id":"16809459-35f7-426f-8329-a9c34309a67f","text":"A doctor\'s tweet about unvaccinated COVID-19 ICU patients originated from a bot network.","date":"2021-07-28 00:00:00+00:00"},{"id":"7a992198-c084-4876-b592-bf1f92cd55f1","text":"A study shows that receiving more COVID-19 vaccine doses increases the likelihood of getting COVID-19.","date":"2023-05-30 00:00:00+00:00"},{"id":"0b2c0175-e665-4892-bfbc-7808ae3dcb8a","text":"SARS was developed by humans as a biological weapon designed to attack human beings.","date":"2023-07-06 00:00:00+00:00"},{"id":"8b584ea9-0889-4650-819c-54e341fdef62","text":"CDC data prove measles vaccines kill more people than measles.","date":"2015-02-05 00:00:00+00:00"},{"id":"094fbd3c-b35a-4c20-b0e0-214fa2f585c7","text":"American tanks were found in Donbas.","date":"2015-04-03 17:47:26"},{"id":"cda1a8e2-20e9-456b-b935-56edcef9cc47","text":"Ukrainian ships caused the Beirut explosions.","date":"2020-08-05 11:56:42"},{"id":"9f5ab2aa-1d48-4a0f-8b36-d1bc0279abff","text":"A Hitler salute cures coronavirus","date":"2020-03-17 20:04:07"},{"id":"07771d5c-00b5-4b1e-841e-7e892647c698","text":"Renewable energy requires a separate second electricity grid.","date":"2025-08-30 00:00:00+00:00"},{"id":"90a5dc53-7d12-4963-ac35-1f73db9e52e4","text":"Ukrainian border guards detained a Russian ship in Russia\'s territorial waters.","date":"2018-04-02 17:56:46"},{"id":"e8f9b3de-5f77-45bd-a686-624be386842d","text":"Dutch Prime Minister wants all referenda banned because of Ukraine","date":"2016-06-20 12:28:14"},{"id":"0c24e548-0e2b-4979-93c1-c712a466c2ac","text":"Ukrainian refugees in Italy assaulted Joseph Brodsky\'s granddaughter.","date":"2022-04-25 18:04:00"},{"id":"9b2a0766-5559-458f-8740-214658f06894","text":"Mammatus and asperitas clouds are abnormal and prove the weather is being manipulated.","date":"2024-09-20 00:00:00+00:00"},{"id":"216aea1c-b87f-4e12-be73-6f1d3ccdd66e","text":"Ukraine will store Russian nuclear waste.","date":"2020-05-08 19:33:22"},{"id":"a3c82ec4-1e3b-4b66-b0fa-725beb943034","text":"There is no correlation between atmospheric CO2 and global temperature, and scientists do not know whether Earth will warm or cool in the future.","date":"2022-10-18 00:00:00+00:00"},{"id":"a9e3760a-e3c6-406c-ae04-bff0fcfe20ff","text":"Flu cases fell 95% in weeks 40\u201341 from 2019 to 2020 because flu cases were diagnosed as COVID-19, which reduced recorded flu cases.","date":"2020-10-22 00:00:00+00:00"},{"id":"431e486f-195a-4068-accc-839f3d5f6916","text":"The Shevchenko statue in the Zaporizhzhia region was demolished.","date":"2016-02-07 20:06:55"},{"id":"68d0e0b1-9767-4047-b61c-46dfc5481041","text":"Videos of Russian military atrocities in Hostomel were staged by Ukrainian actors.","date":"2022-09-08 10:20:00"},{"id":"77995af2-5f23-43fc-8391-2d7c615e9e55","text":"10 million Ukrainians were denied the right to vote in Ukraine\u2019s presidential election.","date":"2019-03-31 15:45:58"},{"id":"af260482-351c-4dd5-84df-a3b880e0ea7d","text":"Hungary and Poland consider Ukraine a threat.","date":"2025-07-09 00:00:00+00:00"},{"id":"a8f44394-f854-4c61-93e9-f08fa0649e2d","text":"Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and have been suppressed for four decades.","date":"2022-12-11 00:00:00+00:00"},{"id":"7fdea1ea-c968-4c88-ae94-84e1ba514576","text":"Poroshenko is planning a military coup in Ukraine","date":"2022-08-10 10:51:43"},{"id":"167a219a-eda7-4bf5-8331-da930d790371","text":"Ukrainians requested electricity from Crimea.","date":"2017-03-31 21:52:58"},{"id":"0288195c-9fec-44db-a109-059e6777897b","text":"A COVID-19 booster means the initial COVID-19 vaccination failed.","date":"2021-08-28 00:00:00+00:00"},{"id":"fd8db090-0452-4f9b-8abf-4408eacddb2d","text":"Stopping all climate change efforts protects people from the coronavirus.","date":"2020-03-25 00:00:00+00:00"},{"id":"85f37113-0f90-4278-a176-cff652db623b","text":"A study showed COVID-19 vaccines are more dangerous than COVID-19, and children aged 12\u201317 are hospitalized for vaccine-induced myocarditis more often than for COVID-19.","date":"2021-12-24 00:00:00+00:00"},{"id":"c57e4357-ae8a-40b8-afda-c07666d2a827","text":"Climate models overestimated global warming and failed to predict the warming hiatus.","date":"2017-09-22 00:00:00+00:00"},{"id":"c034d650-02fb-406f-9caa-155c65dedc12","text":"Germany suspended all COVID-19 vaccinations.","date":"2021-08-23 00:00:00+00:00"},{"id":"9fb54ee2-01b6-4987-980a-210dd5544835","text":"President Andrzej Duda spat on the memory of the Volhynia massacre.","date":"2020-10-15 10:32:17"},{"id":"86bf145c-272c-480e-8366-65caa37d83f0","text":"The UN gave Russia the right to seize Ukraine in 2014.","date":"2017-01-29 21:40:13"},{"id":"92b4d75e-1243-4b14-afa6-adbd966b3a65","text":"mRNA COVID-19 vaccines alter human DNA and cause cancer and autoimmune disorders.","date":"2025-04-24 00:00:00+00:00"},{"id":"94959480-351d-4c80-95f4-11df21938b90","text":"Human activities produce less than 5% of global carbon dioxide emissions and are not responsible for 30% of today\'s atmospheric carbon dioxide.","date":"2020-11-02 00:00:00+00:00"},{"id":"3227e8ec-3817-4e54-8ce8-38d6ff47fa16","text":"Western Ukraine will be transferred to Poland.","date":"2015-01-18 14:57:11"},{"id":"63d19ccd-c1a3-49bd-bb47-e27b66c6bb53","text":"Vaccines and vitamin K injections given to children are unsafe.","date":"2022-11-25 00:00:00+00:00"},{"id":"a9de1b60-bb45-4d6b-af0c-15438e753da4","text":"Solar forcings were large enough to explain twentieth-century warming and caused as much or more warming than atmospheric CO2.","date":"2017-03-05 00:00:00+00:00"},{"id":"6a794e4b-ffb0-47fa-8123-d9af2434ac33","text":"Ukraine buys gas in Europe at twice the price Russia charges.","date":"2019-06-06 10:51:52"},{"id":"864f9a63-a3cd-4ac6-8b3f-b1f18e4b0f44","text":"The Dutch referendum is the last chance for Poroshenko to remain in power.","date":"2016-04-11 18:48:17"},{"id":"1b13625d-b41e-4562-bf57-bdb6d1ca6e55","text":"The United States considers the Donbas war to be an internal matter of Ukraine.","date":"2018-03-23 11:18:02"},{"id":"ae86ef0a-bda7-4932-9e91-a13e090502e9","text":"COVID-19 vaccines cause female sterilization by triggering an immune response that attacks the placenta.","date":"2020-12-02 00:00:00+00:00"},{"id":"e62e5eff-1bfa-4a5f-8f62-2c3b2ccc3405","text":"Long COVID is solely caused by patients\' beliefs and is not a real physiological disease.","date":"2021-11-08 00:00:00+00:00"},{"id":"da854a60-2bfd-47e5-93f4-3548662e814e","text":"A train from Ukraine arrived in Russia loaded with mines.","date":"2018-01-15 22:34:20"},{"id":"aa6995a0-49dc-480e-a0a5-150071aa7162","text":"Friedrich Merz will travel to Russia to attend the Victory Day parade.","date":"2025-05-08 00:00:00+00:00"},{"id":"e5121df9-2e78-481b-8970-d2176c7e27ca","text":"Oxygen kills cancer and Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer.","date":"2022-03-02 00:00:00+00:00"},{"id":"bd233fe4-3b35-4b5f-af8f-81ae82dca665","text":"NATO refuses to accept Ukraine as a member.","date":"2017-11-17 19:54:03"},{"id":"e0368732-4c88-48f5-9c11-88c6067e6192","text":"Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children.","date":"2020-05-28 00:00:00+00:00"},{"id":"00e4beef-c219-4e6b-8148-2fcb5fff7534","text":"Everyone who received at least one dose of an mRNA COVID-19 vaccine will die within three to five years.","date":"2025-01-25 00:00:00+00:00"},{"id":"842d6786-258c-4787-ab4f-513325aead98","text":"US corn crops produce 40% more oxygen at their peak than the Amazon rainforest.","date":"2021-09-23 00:00:00+00:00"},{"id":"2482a699-2eb6-4496-a7a1-14716440e37a","text":"Vehicle emissions impact human health and the environment.","date":"2025-04-02 00:00:00+00:00"},{"id":"a3f553b1-2992-4891-b063-96f989262aae","text":"COVID-19 vaccines contain graphene and living organisms composed of aluminum","date":"2021-10-21 00:00:00+00:00"},{"id":"baa2a5aa-152e-4eb7-9032-0bd27e6694e3","text":"COVID-19 vaccines are experimental and ineffective; natural immunity is more protective than vaccine-induced immunity; the vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes protection from prior vaccination.","date":"2022-01-26 00:00:00+00:00"},{"id":"dc5f398c-1b3c-4084-ad16-8f688b425043","text":"Volodymyr Zelensky promised to hand Crimea and Donbas to Western governments hostile to Russia.","date":"2022-12-29 14:52:00"},{"id":"cc147726-682e-4939-a5a6-0cc2cfc82c3f","text":"Ukrainian authorities served draft notices and confiscated cars in an enclosed village.","date":"2023-04-15 11:40:00"},{"id":"d03e52c8-f3b0-465d-8f87-43a35a1fc373","text":"French authorities suspended all Muslim police officers from accompanying the Olympic torch relay.","date":"2024-05-20 14:50:00"},{"id":"34d53daf-8e5a-4230-baa9-8bfff9afe51e","text":"Plant defense chemicals in vegetables cause autoimmune diseases, and removing vegetables from the diet improves health.","date":"2026-02-03 00:00:00+00:00"},{"id":"a106285b-7181-4d15-984b-cc4c27f0e1c8","text":"Every election year has a disease; SARS\u2011CoV\u20112 has a basic reproduction number (R0) of 2.","date":"2020-03-02 00:00:00+00:00"},{"id":"e1999d90-6147-49e7-b5ba-1610c953efa1","text":"Crimean residents are banned from entering the EU and the US.","date":"2019-07-30 13:17:47"},{"id":"c9551664-66c1-4022-be61-3504e4b8a7ac","text":"The COVID-19 vaccine caused Justin Bieber\u2019s Ramsay Hunt syndrome and resulting facial paralysis.","date":"2022-06-10 00:00:00+00:00"},{"id":"0cfea84b-cf2c-4f62-9d1a-21e329ead6c5","text":"Regulatory agencies were unaware that COVID-19 RNA vaccines contained residual DNA contamination that integrates into human DNA and causes cancer.","date":"2023-10-25 00:00:00+00:00"},{"id":"088c9d7e-17f1-4edc-8006-3419bd1f866f","text":"Kyiv abandoned and deceived Moscow.","date":"2019-06-10 14:22:57"},{"id":"8582e052-9742-4830-aa7b-63a3e3825d95","text":"COVID-19 is less deadly than the seasonal flu.","date":"2020-01-10 00:00:00+00:00"},{"id":"bb7bcb7f-4e00-482e-91ba-f39ba58f5294","text":"Ukraine is the country with the highest number of human rights violations.","date":"2018-04-24 20:54:48"},{"id":"803e4526-61c3-4126-86fd-41849f1452d5","text":"The Ukrainian Armed Forces attacked the Zaporizhzhia Nuclear Power Plant\'s power units using drones.","date":"2024-04-10 13:10:00"},{"id":"d268d9c5-c3c6-4411-8345-5a9251ac14da","text":"Nigoian and Zhiznevskii were not killed by the police.","date":"2015-01-26 22:07:17"},{"id":"f6483772-fddc-4c83-9b69-4ea7ee784909","text":"A vegan world has no pandemics because 100% of pandemics originate from animals.","date":"2021-03-23 00:00:00+00:00"},{"id":"cb281f4e-f905-4eec-b469-2c16643d4c80","text":"Drinking bottled water with an acidic pH is harmful to your health.","date":"2019-05-13 00:00:00+00:00"},{"id":"236567f4-2fcf-4060-8cab-0e0de7c945d5","text":"A Washington poster urged Ukrainian President Volodymyr Zelenskyy to wear a suit when meeting Donald Trump.","date":"2025-08-18 00:00:00+00:00"},{"id":"2ea9032c-8c5f-4001-b001-e19ace030710","text":"Ventilators, not COVID-19, killed hospitalized COVID-19 patients.","date":"2023-10-31 00:00:00+00:00"},{"id":"da17caaa-038f-44dd-81fa-2b9a4d619340","text":"Bloomberg published an infographic showing Ukrainian President Volodymyr Zelensky looted France.","date":"2025-11-04 00:00:00+00:00"},{"id":"25d1ffa1-ec83-4556-a329-729b2996fa94","text":"Zelensky accused the West of killing people and said he will recognize Crimea and the separatist republics.","date":"2022-03-09 13:18:17"},{"id":"d37d1d9e-9c0c-49d3-9635-75549d7725c7","text":"Ivermectin is the only treatment for COVID-19 at all stages; ivermectin substantially reduces COVID-19 deaths and prevents COVID-19 infections; fifty studies show ivermectin is highly effective.","date":"2021-04-15 00:00:00+00:00"},{"id":"4f14b91f-d337-4555-83f5-4406531cb2eb","text":"A vaccine crew in an Indian village was attacked by locals.","date":"2021-04-07 00:00:00+00:00"},{"id":"18fd783c-ce15-4f12-bece-7b5f5bbe65b4","text":"Ukraine imprisons Russian-language teachers.","date":"2020-09-18 15:22:07"},{"id":"dc5413c2-0794-4e1f-a694-bbec425f4ef0","text":"Most recent global warming is natural.","date":"2017-07-09 00:00:00+00:00"},{"id":"43919de6-4762-4470-acd3-37a2872b14c9","text":"Recent footage is authentic and shows tornadoes and storms that occurred during Hurricane Milton.","date":"2024-10-11 00:00:00+00:00"},{"id":"7b0c30c4-33d2-419c-af29-819d57a0adfe","text":"Ukrainian tourists are flooding Crimea.","date":"2016-06-25 11:37:01"},{"id":"4361dc11-5b10-466c-866d-bcef206f74ec","text":"Poroshenko threatens to arrest protesting airport staff.","date":"2015-03-20 17:53:51"},{"id":"0707287b-fd2c-45a0-9848-e672b4be6745","text":"International organizations refuse to investigate the Bucha atrocities.","date":"2022-04-11 17:26:00"},{"id":"76d70905-af86-4ce6-b53b-47bfd1d81f41","text":"Video shows Ukrainian military vehicles near Mariupol.","date":"2014-12-20 18:14:46"},{"id":"905652e7-0b27-4087-97dd-baa9e9748ae4","text":"Trees solve almost all environmental crises and reverse climate change by removing carbon dioxide from the atmosphere.","date":"2020-08-25 00:00:00+00:00"},{"id":"5574fa8d-0c2a-4e81-9251-ca98d7716651","text":"Ukraine will cancel the child care allowance.","date":"2015-12-19 14:39:30"},{"id":"277c4d3b-7c36-4927-b020-8737f80c28eb","text":"Birthmarks indicate the MTHFR gene; people with MTHFR cannot detox toxins from vaccines and therefore have increased risk of vaccine reactions.","date":"2018-11-03 00:00:00+00:00"},{"id":"4061b077-d654-4a60-b4ff-6d603ddea8c1","text":"Three Ukrainian nationals were arrested in Germany for plotting sabotage.","date":"2025-05-14 00:00:00+00:00"},{"id":"2f5db5ae-8ec4-4bc1-b85f-d2b962e49e81","text":"Ukrainian Commander-in-Chief Zaluzhny is preparing a military coup.","date":"2023-11-08 11:28:00"},{"id":"508c530f-62a2-4f80-ad46-f2af4e2a0d81","text":"Russian media published exit poll data from the Ukrainian presidential election.","date":"2019-04-21 14:55:22"},{"id":"838a4c31-fdc8-4018-bf5d-f520ddd23e70","text":"Congress says Americans no longer want to support Kyiv.","date":"2024-09-20 13:48:00"},{"id":"37e13725-d8a0-42c4-896e-28b43b854daf","text":"Polls show people do not believe Russia shot down Flight MH17","date":"2020-07-22 15:49:00"},{"id":"c92f6276-a72b-40c9-8eb3-52f11f64e39e","text":"Masks and lockdowns do not slow the spread of COVID-19.","date":"2021-03-03 00:00:00+00:00"},{"id":"96f6f419-8345-4abe-8f59-ee35ea18b71c","text":"Deforestation has increased human vulnerability to pandemics.","date":"2020-03-20 00:00:00+00:00"},{"id":"c522a826-3d94-442f-8c9d-1029702b5159","text":"The World Health Organization officially declared that bacon is as harmful as cigarettes.","date":"2018-09-12 00:00:00+00:00"},{"id":"55914f23-fc32-43e1-9e36-9f9f752bf43b","text":"Poland has ceased payments to Ukrainian refugees in 2024.","date":"2023-11-27 13:58:54"},{"id":"4c2df153-9630-4525-9cc5-c62839a1318a","text":"High cholesterol is good for health.","date":"2023-11-07 00:00:00+00:00"},{"id":"34260db7-2ee9-4791-8c3a-2850e0eb9f7c","text":"A Nature study proves all mRNA COVID-19 vaccines cause heart damage.","date":"2025-01-15 00:00:00+00:00"},{"id":"aa6ae27a-ebdd-4bc3-aa8c-94795ca3005f","text":"Dnipro is part of the Russian World","date":"2018-10-09 17:39:49"},{"id":"9f30f1e3-612f-4f10-8077-f36166226813","text":"VAERS received 3,916 COVID-19 vaccine adverse event reports in December, including 13 deaths.","date":"2021-01-19 00:00:00+00:00"},{"id":"97b80d46-c4df-40f4-a396-952af4ac237a","text":"A Lviv officer proposes annulling the Ukrainian Order for Courage.","date":"2015-03-15 18:29:38"},{"id":"5b569460-6127-4883-ab59-9853548e4d9f","text":"Bill Gates-funded company released genetically modified mosquitoes in the U.S. and caused a malaria outbreak.","date":"2023-07-05 00:00:00+00:00"},{"id":"ab5521ed-0c5d-4fa6-8e45-5994d785c3a0","text":"50% of Ukrainian refugees will stay in Poland.","date":"2022-07-12 11:59:00"},{"id":"e5a07fbf-34c1-4129-aa0c-a60a22560819","text":"China rejected imports of Ukrainian grain.","date":"2016-08-31 21:40:02"},{"id":"6fe6fe1d-5649-46c3-b803-cf5637648f66","text":"Published secret documents show Ukrainian troops committed violations in Donbas, and no one is investigating.","date":"2019-09-05 19:33:33"},{"id":"f69d66c3-1c29-4ad0-8ed4-29471bb5254b","text":"Ukraine deliberately cut off water supplies to occupied Luhansk.","date":"2017-03-12 06:45:25"},{"id":"568d07cf-6cef-492d-b53a-8c7f0a97da4f","text":"The U.S. Secretary of State\'s visit to Ukraine proves Ukraine has no chance of joining NATO.","date":"2021-05-10 13:24:33"},{"id":"097ad6f5-be15-425b-9247-f5918bc3cf53","text":"Ukraine denied accreditation to German election observers","date":"2019-03-19 14:11:14"},{"id":"9addcae8-1045-4fe0-b2e5-557bb400cba4","text":"Moringa supplements lower cortisol levels and improve overall health.","date":"2024-10-15 00:00:00+00:00"},{"id":"68313ab6-a010-42dc-95fa-48d851f5286b","text":"The number one indicator of parasitic infection is an autoimmune condition.","date":"2023-08-07 00:00:00+00:00"},{"id":"e1e22820-8161-46f5-b0cc-f1b859444517","text":"Ukrainian authorities are dooming the population to starvation.","date":"2022-03-31 20:14:31"},{"id":"1f0568f0-449e-417e-8c8a-42e640838fd5","text":"Only six Crimean citizens retained Ukrainian citizenship.","date":"2014-04-04 16:56:24"},{"id":"7b26bbc6-19f7-43c0-a99f-5ee27fdfd37d","text":"Crimeans voted to join Russia because Kyiv abused the peninsula.","date":"2020-05-08 18:36:07"},{"id":"976a8b54-0e02-4acc-823e-24c922f31dd2","text":"The CDC withdrew authorization for its 2019\u2011nCoV real\u2011time RT\u2011PCR test because that PCR test cannot distinguish COVID\u201119 from influenza.","date":"2021-07-24 00:00:00+00:00"},{"id":"4b063b61-17b0-408f-86e0-66307335ebcc","text":"Sergey Lavrov said Russia is not a party to the armed conflict in Ukraine.","date":"2020-09-24 17:23:15"},{"id":"2020bb2f-ce91-4d14-8fba-d22a6c3047e9","text":"The Ukrainian national football team will be disqualified from future matches.","date":"2016-12-07 22:15:22"},{"id":"af8e71ba-1347-49fb-872f-7d03c60cef83","text":"Eating only meat provides a balanced diet.","date":"2023-04-11 00:00:00+00:00"},{"id":"8624e824-6fbb-4d02-b248-4ac44bba4445","text":"Blood pressure tracking apps can replace blood pressure cuffs","date":"2024-04-08 00:00:00+00:00"},{"id":"6d3ca843-ac74-414a-8a9a-f9b3d840ad72","text":"Petro Poroshenko deprived Chornobyl workers of benefits.","date":"2016-04-13 21:44:52"},{"id":"a500fdc9-536c-4504-8762-dcf75b30807b","text":"Lemon balm neutralizes and destroys all avian influenza viruses, including H5N1.","date":"2024-11-03 00:00:00+00:00"},{"id":"3a4ce92d-731a-4392-9594-1a7f1b5bc5b2","text":"Austria agreed to pay Russia for gas in rubles.","date":"2022-04-27 14:37:09"},{"id":"9f514e31-b4e8-4fc2-881b-695f8c5800df","text":"Vladimir Putin caused the rouble to collapse to trick Western financial sharks.","date":"2015-01-03 17:59:48"},{"id":"38f377c1-4e31-4453-819e-2f821eff8ce0","text":"Climate scientists disagree about how much warming human emissions caused and whether that warming is larger than natural variability from the sun and volcanic eruptions.","date":"2024-04-26 00:00:00+00:00"},{"id":"a3feeb4a-df50-4aab-a818-f764236f8ad6","text":"Nadiya Savchenko advocates granting amnesty to Donbas separatists.","date":"2016-06-13 16:08:54"},{"id":"8c52f7f8-5666-4eab-9f59-fe86a57dd17a","text":"The German Bundestag called for lifting sanctions on Russia to fight COVID-19.","date":"2020-04-02 14:59:04"},{"id":"e9b47af3-f5e1-42a4-8210-70ba8ef8ce4b","text":"Romanians in Bukovina demand autonomy","date":"2015-08-08 10:55:58"},{"id":"2e952ecc-8a11-4728-a55a-b9070840e5cc","text":"Ukraine is threatening to invade Russia.","date":"2022-03-08 14:19:42"},{"id":"396aad09-0fc9-4db0-9583-50b9bdd71a16","text":"Bananas are powerful antiviral foods that repel growth of the retrovirus HIV.","date":"2021-02-21 00:00:00+00:00"},{"id":"95810909-9f05-4822-a380-9d9f192410dd","text":"DMSO treats cancer","date":"2025-08-04 00:00:00+00:00"},{"id":"fb31b421-1b69-46bd-9c81-a9d77c6fcf57","text":"A recent bleaching-level heat stress event bleached 84% of the world\'s coral reefs.","date":"2025-04-23 00:00:00+00:00"},{"id":"23c60597-be74-48f6-97fc-3631ba451bb8","text":"Ukrainian forces committed a terrorist attack in Russia\'s Voronezh region.","date":"2024-01-02 15:48:51"},{"id":"7b01c26e-2bc4-4c62-a665-fa6ab7dc8026","text":"All pandemics are zoonotic, so a vegan world would have no pandemics.","date":"2021-03-26 00:00:00+00:00"},{"id":"2781ff7d-9d7a-4c4b-bcf3-c264eed0ba36","text":"U.S. mercenary Sean Fuller was killed in Donbas.","date":"2020-07-18 11:20:08"},{"id":"9cd57b99-4d64-4360-96d8-f1e695967fb0","text":"Lion\'s mane mushroom prevents Alzheimer\'s disease.","date":"2023-10-05 00:00:00+00:00"},{"id":"e309b0fd-2252-4b9a-814a-9a55d2b4fba4","text":"Ukraine loses economically from trade with the European Union.","date":"2017-05-29 13:26:30"},{"id":"6c33f8ec-8406-40fd-858e-87acce3e0b2f","text":"The COVID-19 vaccine killed 3.5 times more Americans than the COVID-19 virus.","date":"2023-10-31 00:00:00+00:00"},{"id":"d59aa96a-97da-4753-a2ef-40d78a48c9a1","text":"Ukraine will sell Crimea to Russia for $135 billion.","date":"2021-08-09 10:06:00"},{"id":"40678ed6-372d-4f7b-8d1c-78ccee23a635","text":"Salt and corn gluten meal are used to kill mice and are hazardous to humans.","date":"2024-06-29 00:00:00+00:00"},{"id":"7239e2a8-d011-4bfb-8aed-0a709402fe71","text":"Solar cycles and other natural Earth activity cause climate change; human (anthropogenic) CO2 emissions do not cause climate change.","date":"2023-09-02 00:00:00+00:00"},{"id":"0de62fd1-eac4-4208-ba57-878dbab8308c","text":"Kherson nationalists publicly swore allegiance to Adolf Hitler.","date":"2015-07-04 12:56:21"},{"id":"79af6b5b-af58-4e0f-8fb9-0441d3728d4e","text":"Herpes is not a sexually transmitted disease. A commercially available plant product cures herpes.","date":"2023-04-19 00:00:00+00:00"},{"id":"0fb4eb94-796c-4474-822d-d49532bbdf78","text":"The UK transferred uranium shells to Ukraine, constituting nuclear escalation and a new outbreak of aggression.","date":"2023-03-22 15:25:30"},{"id":"e449ca29-0cdd-4df6-a8be-65ce5e2063ff","text":"CyberBerkut blocked the Central Election Commission of Ukraine from carrying out its work.","date":"2014-10-26 15:09:48"},{"id":"12f4269f-e670-4d9b-8ee1-fb1eb44c333b","text":"Sea level at Sydney Harbour has not risen at all over the past 140 years.","date":"2019-10-28 00:00:00+00:00"},{"id":"3bd18ad9-4a9a-4f65-aed3-f97bfcfa2305","text":"Vaccination caused autism rates to decrease among high-income white households in California.","date":"2024-03-10 00:00:00+00:00"},{"id":"48e29c96-9fcd-47ae-88ac-52d0cf5d5625","text":"Crimea and Donbas residents are being deprived of all rights because they hold Russian citizenship.","date":"2021-02-02 17:55:29"},{"id":"f9769b02-c023-424d-918c-79424431d746","text":"Ukraine is being used as an experimental site to grow babies artificially.","date":"2022-12-28 14:26:00"},{"id":"9794657c-ae61-4302-9788-2e8896e74cdd","text":"Ukraine granted dual citizenship to Western lobbyists.","date":"2019-02-28 16:45:22"},{"id":"8f0975f6-6d6e-4857-b113-2188906ebfc8","text":"The United Nations demands that Ukraine recognize occupied territories.","date":"2017-12-18 17:37:47"},{"id":"28861c5b-e399-4e62-aa35-4e22dbd2274d","text":"The Federal Government of Germany provoked Russia with its actions regarding Aleksey Navalny.","date":"2020-09-27 22:44:12"},{"id":"a9651ce2-41c6-4761-8d99-8fce6e172982","text":"Ukraine is no longer an industrial nation.","date":"2017-04-18 09:08:29"},{"id":"baa9cabd-e297-4048-a196-c125d4f55a45","text":"Babies born to mothers vaccinated against COVID-19 are dying at higher-than-normal rates and the COVID-19 vaccines are causing those deaths.","date":"2022-07-06 00:00:00+00:00"},{"id":"a1a4246c-cc65-437f-ade8-c42722b56648","text":"Fukuyama claims Ukraine will not be able to return all of its territories.","date":"2023-10-21 15:15:00"},{"id":"1b60a8c8-ce1d-4b0a-aebf-8bab19ffb83e","text":"One thousand people in Sofia demanded that Ukraine stop repressions.","date":"2015-05-23 19:23:28"},{"id":"ebbc58ff-b654-452d-826e-b4b7fb0c1dd4","text":"Post-vaccine deaths cannot be categorized as vaccine-related.","date":"2017-07-18 00:00:00+00:00"},{"id":"4ddf07b6-49d8-41d6-a6ff-cd4a4f5849f4","text":"Most fully vaccinated people will develop vaccine-induced AIDS by the end of the month.","date":"2022-01-22 00:00:00+00:00"},{"id":"19aa839c-e515-411d-bb73-8b1c0ef37901","text":"The European Union refused to punish Russia for seizing Ukrainian ships in the Kerch Strait.","date":"2018-12-18 13:26:14"},{"id":"36c0cd4a-8b15-43cc-ac7d-1fe603b67079","text":"Sanctions imposed by Kyiv on Russian banks have worsened Ukraine\u2019s investment climate.","date":"2017-03-21 21:59:06"},{"id":"13dbfe73-0c74-42c4-8617-979b4f918ebb","text":"The Red Cross collected data on the healthy organs of children in Mariupol.","date":"2022-06-03 19:13:43"},{"id":"73ab226a-7dc0-426b-9964-0d1a732ae936","text":"Cancer rates increased after COVID-19 vaccines were introduced, and this increase is causing U.S. life expectancy to decline.","date":"2023-01-13 00:00:00+00:00"},{"id":"5242cdbf-b4c2-48b2-8319-ef7cb0bb36db","text":"A death at a checkpoint was caused by a Ukrainian provocation.","date":"2020-06-15 22:26:57"},{"id":"d50f8b96-1672-465a-8227-62e198faf14a","text":"Russian flags were flown in Kyiv by mistake.","date":"2015-07-07 12:26:12"},{"id":"2760dd91-0822-4c04-8c1a-3ee7deeebdd0","text":"Obama asked Poroshenko to invite him to Crimea.","date":"2015-09-04 21:00:42"},{"id":"d284b953-af10-4aa8-9389-f4d2744e9454","text":"Ukraine\'s Foreign Ministry accused the European Union of betraying Ukraine.","date":"2016-12-16 22:33:27"},{"id":"276aa55d-6a95-4170-9844-c67c54a5881d","text":"COVID-19 vaccines are being administered incorrectly.","date":"2021-10-14 00:00:00+00:00"},{"id":"1338c7bf-e4d8-4a04-a092-fad1f6993163","text":"Tattoo ink contains cancer-causing heavy metals, and zeolite removes those heavy metals from the body.","date":"2024-04-10 00:00:00+00:00"},{"id":"b72f3359-fc17-4fa0-aa39-f3c1d260a395","text":"Ukraine is opening camps for Syrian refugees.","date":"2017-04-01 17:40:53"},{"id":"f6592f88-c9d5-436e-8cf1-f64e132ac10a","text":"COVID-19 vaccines are causing embalmers to find strange clots in corpses.","date":"2022-12-09 00:00:00+00:00"},{"id":"b99ed213-2fc7-44fe-8158-11de1ce92fd8","text":"Ukrainians want to go to Russia and demand trains to Crimea.","date":"2019-08-01 15:52:54"},{"id":"fbda447a-c249-4c5a-a81d-63707fa8a879","text":"Ukrainian military cannot operate American weapons.","date":"2018-04-13 21:06:15"},{"id":"12de5676-5208-4063-93d7-48bcb3386041","text":"Ukraine wants to exchange Crimea for Transnistria","date":"2017-11-22 18:45:02"},{"id":"cf13ec5a-1de0-4158-9907-0e98d2f0b2b2","text":"Since COVID-19 vaccines were rolled out, a midwife has observed that all placentas are abnormal and compromised.","date":"2023-04-25 00:00:00+00:00"},{"id":"16a1d1b2-6f66-4f97-bc3a-1662c94b64a7","text":"The Ukrainian military shelled a bus stop in Donetsk.","date":"2014-10-05 11:37:58"},{"id":"7fd92c05-9204-46f4-9028-9475c4582ddd","text":"Ukrainian authorities drained the Dnipro River to deploy armed forces on the left bank.","date":"2023-01-22 13:20:00"},{"id":"427063bc-a537-4e80-a198-25b80179f288","text":"The survival rate for COVID-19 is 99.96%.","date":"2020-08-21 00:00:00+00:00"},{"id":"13a6d66c-1a1c-4778-b975-22861081ce05","text":"Carbon dioxide is not a primary contributor to global warming.","date":"2017-10-03 00:00:00+00:00"},{"id":"e837d726-7aa9-4092-aa12-ef20fe1d288a","text":"Jacques Attali wrote that elites will create a pandemic to reduce the population and will have planned its treatment.","date":"2022-12-21 00:00:00+00:00"},{"id":"02177f79-3fcc-4614-bb58-b540b9b8a755","text":"Poroshenko was booed and whistled at by students in Zurich.","date":"2015-01-22 09:48:44"},{"id":"57ae1e09-8cba-4774-b8e9-155af7a9e12f","text":"The Maidan protests and the economic crisis caused a tuberculosis epidemic in Ukraine.","date":"2017-03-28 03:42:41"},{"id":"a9df46be-ed24-4685-bb08-5aac2eaaf343","text":"A Defense Ministry secret document reveals the actual losses of the Ukrainian Armed Forces.","date":"2022-08-24 11:48:00"},{"id":"7e6c3b85-9bc1-4c85-add5-4280090cc98d","text":"Climate change is making extreme weather events, including tornadoes, worse.","date":"2019-08-03 00:00:00+00:00"},{"id":"708a59bc-3706-407b-8bed-aca62b3a0e0b","text":"Eighteen climate proxies show the global temperature 1,000 years ago was the same as or higher than today.","date":"2019-05-08 00:00:00+00:00"},{"id":"078df374-e1cc-45cd-b89d-fc04a0086df0","text":"Lviv demolishes WWII Glory Monument","date":"2017-07-11 18:28:31"},{"id":"6722e272-3d35-49c3-97d1-95e27ae4caa5","text":"Ukrainian Armed Forces are not resisting the Russian invasion.","date":"2022-02-24 09:30:25"},{"id":"27699f3d-62b2-4450-9a56-170616f84fde","text":"The United States reported 144,305 new COVID-19 cases, breaking the prior record of 133,819 and marking eight consecutive days with over 100,000 cases.","date":"2020-11-13 00:00:00+00:00"},{"id":"b270dea8-050d-4024-876f-14717220a796","text":"Carbon dioxide does not control the climate.","date":"2022-02-09 00:00:00+00:00"},{"id":"5d80c8af-4946-454c-85dd-5a000e0466a3","text":"COVID-19 vaccines caused monkeypox; a 2021 tabletop exercise that simulated a monkeypox pandemic proves global leaders planned the outbreak; the monkeypox vaccine was ready before the outbreak.","date":"2022-05-13 00:00:00+00:00"},{"id":"40a1f1b1-475e-4194-80de-4218fe12446a","text":"Ukrainian refugees burned a Russian flag and set fire to a house in Germany.","date":"2022-05-20 13:53:03"},{"id":"c27701ba-9c1a-481d-b0a0-fb14a12af237","text":"The FDA allows doctors to prescribe ivermectin for COVID-19.","date":"2023-08-24 00:00:00+00:00"},{"id":"281cf79d-9b45-4672-9aa2-739fdb931d01","text":"Nuland warned Surkov that a NATO attack was inevitable.","date":"2016-01-18 20:24:54"},{"id":"f430114c-0a7c-4439-b956-63fb68e8fe59","text":"Ukraine\u2019s president Volodymyr Zelensky acknowledged that Ukraine lost the Donbas region.","date":"2017-03-21 22:21:54"},{"id":"46ccbb30-6967-414e-a158-c7235dff817a","text":"All Ukrainian refugees are willingly going to Russia.","date":"2022-04-15 14:04:35"},{"id":"7a0a519a-abe5-4d16-b25b-95b7dd5dd4f6","text":"Kyiv is one of the 10 worst cities to live in.","date":"2023-06-25 12:45:00"},{"id":"b1e6964f-cf85-4fe8-b3cd-e36bae98b74b","text":"University of Turin recognizes Donetsk People\'s Republic diplomas","date":"2018-05-08 21:07:22"},{"id":"a8c3c106-7f49-4e8d-b998-9325e7b29179","text":"The Azov Regiment attacked a humanitarian convoy.","date":"2022-04-19 15:03:00"},{"id":"0c210184-be10-40d1-a5ef-5c5c5f272897","text":"Ukrainian military shelled OSCE monitors.","date":"2016-09-13 17:30:00"},{"id":"7a88ce76-3d77-4aae-b093-fd98ef26f4d5","text":"A nuclear explosion occurred in Ukraine.","date":"2017-04-20 15:37:52"},{"id":"5ffb9f22-74b9-4d3f-8577-578f0aadeb63","text":"US regions with higher average COVID-19 vaccine doses experienced larger increases in mortality in 2022 than in 2021.","date":"2023-01-24 00:00:00+00:00"},{"id":"8e94c22c-9394-4644-8c86-53923aa6f4c4","text":"COVID-19 vaccines weaken the immune system and an Idaho doctor reports a 20-fold increase in cancer among vaccinated patients.","date":"2021-09-13 00:00:00+00:00"},{"id":"81e0ef7d-ddb3-4378-bd60-543568936e03","text":"NOAA alters climate data using complex statistical models so the data reflect NOAA\u2019s global warming theories rather than reality.","date":"2018-03-29 00:00:00+00:00"},{"id":"ac94c666-f650-45c6-b4b7-6e850d36774d","text":"COVID-19 vaccines have caused as many deaths in young people as COVID-19 disease has.","date":"2021-05-29 00:00:00+00:00"},{"id":"a4290403-d70c-4974-84e2-44718132a241","text":"A memorial plaque in Kyiv was destroyed.","date":"2015-07-16 16:21:22"},{"id":"852533f6-e8e6-43a6-a937-f11d74216ec4","text":"Antarctica\'s perimeter is larger than Earth\'s circumference, proving Antarctica is an ice wall and the Earth is flat.","date":"2025-02-08 00:00:00+00:00"},{"id":"666a0302-51a9-4c85-b6d3-9d5c2ff3f4cc","text":"Kyiv deliberately caused a blackout in Moldova.","date":"2026-01-31 00:00:00+00:00"},{"id":"5539f9d0-477d-421f-b465-b41852681b1d","text":"The United States supported federalization of Ukraine.","date":"2014-03-31 23:55:02"},{"id":"48426c97-7d6a-432e-b843-39c651e804b5","text":"A RAND Corporation document shows the US planned to cause a conflict and an energy crisis in Europe.","date":"2022-09-23 10:56:00"},{"id":"e85cc452-7f15-496d-99e7-e29d1ac05981","text":"The Bucha atrocities, the chemical attack in Syria, and the White Helmets\' rescue operations were staged by Western governments.","date":"2022-04-15 10:45:00"},{"id":"c3751919-18d3-47c2-9167-edfff84722d8","text":"Zelenskyy expressed condolences and urged Turkey to supply Ukraine more aid.","date":"2023-02-09 17:53:00"},{"id":"c73cc4c2-ee3a-40b7-aebb-35016faadea0","text":"The American Medical Association reversed course and authorized doctors to prescribe hydroxychloroquine for COVID-19 patients.","date":"2020-12-22 00:00:00+00:00"},{"id":"aee0cb83-07c1-42bb-bf33-73e771d68a50","text":"Oral contraceptive pills are the leading cause of polycystic ovary syndrome, and wild yam combined with castor oil cures polycystic ovary syndrome and uterine fibroids.","date":"2024-08-15 00:00:00+00:00"},{"id":"622159aa-c1c6-4f15-835f-7664880f27c2","text":"Hundreds of children were killed to create COVID-19 vaccines.","date":"2021-02-11 16:31:00"},{"id":"a820a710-7fc3-4d8c-b0eb-29a62b39bc95","text":"A Ukrainian refugee drew a swastika in a British mall.","date":"2022-09-25 10:50:00"},{"id":"f9bcc584-69cd-4b2b-a377-89b89ff8b19e","text":"Receiving the Pfizer COVID-19 vaccine increases the risk of getting COVID-19.","date":"2021-09-30 00:00:00+00:00"},{"id":"9f5d4982-9ec4-446d-ac05-eb1dbf28db7e","text":"Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins.","date":"2016-10-08 00:00:00+00:00"},{"id":"a13c9705-08c7-4902-be92-bdd7400fe68c","text":"An American COVID-19 vaccine killed a Ukrainian serviceman.","date":"2020-10-25 14:38:00"},{"id":"511ed949-e4e4-4397-9aea-9c078bc7cdba","text":"The first AI-led peer-reviewed climate science paper confirmed that climate change is a hoax.","date":"2025-03-21 00:00:00+00:00"},{"id":"edfc6794-b92b-4d2c-aa29-931e67ed4a5f","text":"A Ukrainian airliner that was downed in Iran was controlled by the United States.","date":"2020-04-08 00:36:00"},{"id":"23d2674e-201f-436f-8ba5-f9634b22452b","text":"Minors in Ukraine are eligible for military contracts.","date":"2025-06-10 00:00:00+00:00"},{"id":"205ee47e-0b88-48c4-bc25-bd44daed69fd","text":"Kyiv expelled homeless people from the city for Eurovision","date":"2017-04-28 19:53:55"},{"id":"4e5b22dd-ab03-436c-ac85-a6195d7b65cb","text":"Russia threatens Ukraine\u2019s civilian population.","date":"2022-02-25 11:23:57"},{"id":"1ea025bc-37bf-4c08-96c3-faee33d6f7c1","text":"The HPV vaccine increases the risk of developing cervical cancer.","date":"2024-03-27 00:00:00+00:00"},{"id":"4e7475b9-3013-439d-bac9-d3f060ccf7e6","text":"A missile serial number confirms that the Kramatorsk train station was hit by a Ukrainian Tochka\u2011U missile.","date":"2022-04-10 19:14:43"},{"id":"94b0599d-5280-4eb1-a5c4-ebb69a354aad","text":"Ukraine\'s Parliamentary Speaker calls for a new Maidan.","date":"2019-05-24 09:35:21"},{"id":"569c9fdc-c50c-40ec-8253-6f83dfb0844f","text":"Ukraine threatened Russia with war.","date":"2020-07-06 14:06:38"},{"id":"425afd42-325e-44a6-a89b-4d35781ffd50","text":"Terrorists were arrested in Crimea.","date":"2020-07-09 18:00:00"},{"id":"32ffa954-dc22-40d1-96e3-96b6f192825b","text":"Fitch issued a disappointing forecast for Ukraine.","date":"2017-11-01 14:18:07"},{"id":"d80bebb7-3a6f-4623-80fa-7326d471c3a4","text":"A Ukrainian plane was shot down in Iran because it carried Iranian nuclear physicists.","date":"2020-01-17 21:34:05"},{"id":"91924ffb-2ec1-49ed-8ca6-a0b9686c4c88","text":"Poland blocks cargo transports from Ukraine to Europe","date":"2017-11-18 21:30:07"},{"id":"ba0ef9b9-0a68-4dbd-93b2-7b293f43f319","text":"The government of Ukraine refuses to respect human rights in the southeast of the country.","date":"2015-05-25 19:33:12"},{"id":"15a2de90-4297-4571-9ce7-16e49442c14a","text":"The President of Poland called for the return of Ukrainian territory to Poland.","date":"2015-10-23 17:13:33"},{"id":"3982f6ff-e14a-4a9d-be0a-90a7aa933551","text":"A Ukrainian activist called the September 11 attacks \\"God\'s punishment for Americans.\\"","date":"2024-09-19 13:56:00"},{"id":"dcc4a80a-81d4-43fe-aa58-e3bd7b68cb02","text":"Women are not warned that their daily steroidal hormone pill causes blood clots.","date":"2015-05-07 00:00:00+00:00"},{"id":"2811b1f1-4d62-4902-b97a-4a3797d99845","text":"Measles prevents cancer and provides long-term health benefits.","date":"2025-02-20 00:00:00+00:00"},{"id":"dfeb95b3-8fdd-4583-ac1f-66a47fff194b","text":"Ukrainian military beat Andrey Makarevich at a concert in Kharkiv.","date":"2015-05-10 17:08:43"},{"id":"bbc96af2-eb24-4264-884c-ef5aeec83436","text":"Polish students attacked a Ukrainian schoolgirl.","date":"2017-05-17 14:34:26"},{"id":"7eb508d8-7356-4029-85fc-3cd4e5adabd7","text":"Ukrainians demanded ransom from the family of a deceased Hamas hostage.","date":"2023-11-03 11:18:00"},{"id":"ce34df8f-a86f-47f8-94f6-b6763533d968","text":"A South Korean study found that COVID-19 vaccines increase the risk of cancer.","date":"2025-09-30 00:00:00+00:00"},{"id":"7df04e24-fd6c-4618-916b-acacd3af5fe6","text":"Ukraine exported grain to Western countries and did not export grain to needy African countries.","date":"2022-08-15 16:54:00"},{"id":"70eed460-6914-49b4-bb84-aaaec6fa2922","text":"Most Ukrainians consider the Donbas conflict a civil war.","date":"2018-10-25 19:08:48"},{"id":"3f2eac23-d6cf-49de-bae9-23f6f126613a","text":"Coronavirus spread rapidly worldwide in October 2019.","date":"2020-05-08 00:00:00+00:00"},{"id":"f08b015a-22f5-4f03-a884-d70f9da97189","text":"The European Union no longer trusts NATO or the United States.","date":"2019-06-27 10:16:47"},{"id":"a48c2d4a-ca9d-4583-ad77-e97dc4ceddad","text":"Ukraine is preparing a Bucha-style provocation using Supernova Airlines passengers.","date":"2024-11-01 00:00:00+00:00"},{"id":"71cecf6b-1122-4c2c-8ea4-48558d89a707","text":"The European Union seeks to improve relations with Russia at any cost.","date":"2018-01-03 23:28:05"},{"id":"e630a528-9654-4292-b306-4be1aede0a0f","text":"The Pfizer COVID-19 bivalent vaccine increases the risk of stroke.","date":"2023-02-11 00:00:00+00:00"},{"id":"7d58789a-930b-4bde-b413-904cf956b97b","text":"Tillerson said the United States will recognize Crimea as Russian if specified conditions are met.","date":"2017-01-13 21:26:15"},{"id":"94a5d13f-6c49-487a-b51a-ccb0748b111c","text":"Kyiv forcibly drafted ethnic Hungarians.","date":"2026-02-09 00:00:00+00:00"},{"id":"6c74371b-9156-4527-bd46-33afea027602","text":"The Lviv Jazz Festival was cancelled due to uncollected garbage.","date":"2017-06-26 12:45:15"},{"id":"6ec4ed54-0f02-4ca4-a2e5-1713fca9e731","text":"Covid-19 vaccine effectiveness fell from 100% to 20%; early reported vaccine effectiveness figures were lies.","date":"2022-12-01 00:00:00+00:00"},{"id":"7ae5ac2a-e77e-45f9-a09d-b48ed86247ed","text":"Renewable energy is not green: by 2050, 78 million metric tonnes of solar panels will reach end of life and cannot be recycled.","date":"2024-09-29 00:00:00+00:00"},{"id":"95e8dca6-eba1-4ae8-abe6-1699e963f71b","text":"Arseniy Yatsenyuk sided with the Right Sector in the Zakarpattia Oblast conflict.","date":"2015-07-15 11:17:42"},{"id":"f3693f4c-6543-41d1-afc8-120d2fb1edf8","text":"Ukrainian President Volodymyr Zelensky calls for a preemptive nuclear strike on Russia.","date":"2023-02-04 15:48:00"},{"id":"e355827b-0900-4843-b234-fcf2d8dc9d3a","text":"Islamic radicals are flocking to southern Ukraine.","date":"2016-10-31 16:19:42"},{"id":"d393ae41-2620-4022-acb5-4fcbc7c76ec6","text":"Andriy Parubiy was behind the Maidan shootings, the Odessa Trade Union arson, and the Ukraine coup.","date":"2025-09-01 00:00:00+00:00"},{"id":"54a197a9-396b-4264-872d-94d97c27fbfa","text":"Documents show Crimea belongs to Russia.","date":"2014-03-12 15:30:53"},{"id":"98383b6c-d1d4-471b-9076-e2507500a31b","text":"Eating onions cures RSV and makes you sleep at night.","date":"2024-11-10 00:00:00+00:00"},{"id":"e922300e-8398-4290-a14b-22c277ffc866","text":"The Ukrainian authorities demand the extradition of an EU Member of Parliament.","date":"2017-06-02 22:10:31"},{"id":"e1282797-5c59-4c8e-9869-25dd7feed8ec","text":"The exact same group of experts who claimed there was global cooling in 1977 now claim there is global warming.","date":"2019-12-16 00:00:00+00:00"},{"id":"534fe008-9f9d-43c8-98e6-feb5d976c1e5","text":"The CDC admits that being fully vaccinated does not protect against the Delta variant and increases infections.","date":"2021-08-13 00:00:00+00:00"},{"id":"3d30e612-8d52-47bb-b24e-3c6c55d6798c","text":"An FDA study found vaccines made in living cells are contaminated with hidden viral fragments that cause cancer.","date":"2020-01-31 00:00:00+00:00"},{"id":"80f457ab-70e1-4f4d-b0b7-55e5496c3cc6","text":"Poland recognizes Crimea as part of Russia","date":"2015-04-28 18:31:02"},{"id":"15558040-1082-40ab-b3ee-92ad2117bd2e","text":"Bill Gates is pumping mRNA into the food supply to force-vaccinate unvaccinated people.","date":"2023-01-18 00:00:00+00:00"},{"id":"32d2b9c5-4f9d-4841-b031-0779293587e4","text":"Ukraine refuses to claim custody of its prisoners of war held in territories occupied by Russia.","date":"2018-06-23 10:13:10"},{"id":"eade3386-0e7c-4d86-b898-d4d10a95072a","text":"A Ukrainian general predicts Ukraine will lose control of the Sea of Azov and the Black Sea.","date":"2021-05-31 18:20:00"},{"id":"2598f3d6-3972-4e7e-9a44-f2e6e903bf9f","text":"Recent climate change is normal because past hot and cold periods occurred, and future climate change cannot be predicted because weather cannot be predicted accurately over days to weeks.","date":"2024-08-09 00:00:00+00:00"},{"id":"305207e2-9826-4409-b2f3-7a186de5ee2b","text":"Official figures show mean global temperature declined over the past 10 years.","date":"2017-08-10 00:00:00+00:00"},{"id":"459a7c39-7561-4c42-8b32-f60835558e46","text":"COVID-19 vaccines are causing a massive tsunami of COVID-19 hospitalizations and deaths through immune escape, and vaccine-induced immune dysregulation is turning COVID-19 into a chronic disease called long COVID.","date":"2024-03-31 00:00:00+00:00"},{"id":"d424c471-7aaf-428d-9186-8d8442cbce27","text":"European governments accuse Ukraine of flooding the EU with heroin.","date":"2017-12-22 17:57:25"},{"id":"21d74062-be4e-4d10-a0d8-33bb9fd723b9","text":"The Ukrainian Army deployed Polish soldiers to Donbas.","date":"2018-10-19 10:09:04"},{"id":"6d21c206-996c-4e4a-85fd-d9df9ec56bdb","text":"Mass COVID-19 vaccination caused the excess deaths observed through 2022.","date":"2022-11-02 00:00:00+00:00"},{"id":"3cb094ff-b29e-486c-99cd-938e3eb40fb8","text":"HAARP deliberately creates global-scale earthquakes, cyclones, floods, and snowstorms and deliberately attacks the world\'s citizens by telepathically influencing their thoughts with low-frequency vibrations.","date":"2020-12-11 00:00:00+00:00"},{"id":"b286a749-9752-4d5c-a479-037bff83d4f5","text":"Zhytomyr city authorities called on residents not to oppose the Russian army.","date":"2022-03-16 12:12:36"},{"id":"a1b34fd3-9e14-4812-b52c-ed9c8fd128eb","text":"Cow milk contains the most relevant carcinogen ever identified and triggers cancer.","date":"2019-01-30 00:00:00+00:00"},{"id":"48aa8890-a376-420a-bea0-d18e73298f49","text":"Gargling with warm salt water or vinegar eliminates SARS-CoV-2.","date":"2020-03-27 00:00:00+00:00"},{"id":"c6920b0d-019e-426e-a9f1-94a2c661ee47","text":"Ukraine plotted the assassination of French President Emmanuel Macron.","date":"2024-02-14 11:22:00"},{"id":"761d7708-e063-40df-b169-11813b9c5a1a","text":"The Ukrainian hryvnia will collapse.","date":"2018-09-03 06:33:05"},{"id":"f834d89b-72a5-4444-9ae0-dc1689e04181","text":"Poroshenko blocks visa-free entry of Ukrainians to Russia.","date":"2015-12-30 09:37:04"},{"id":"84f85dfb-f8b6-4bc9-8b68-c8f9e31f70ff","text":"Ukraine solicited funds to host Eurovision 2017.","date":"2016-07-28 22:20:42"},{"id":"49ed25a7-1dbd-41a6-8bb7-f47041bfa75d","text":"US state governments have banned chemtrails, confirming that secret government programs use chemtrails to harm the public and the environment.","date":"2024-01-12 00:00:00+00:00"},{"id":"5191a2b0-b6ba-406f-955e-eeea758651bd","text":"COVID-19 vaccines are unnecessary because vaccinated people still get COVID-19 and are required to wear masks.","date":"2021-12-02 00:00:00+00:00"},{"id":"e347b4bf-00aa-43d1-b060-2fddcd12d86a","text":"COVID-19 vaccines are sexually transmitted to unvaccinated people, cause blood discoloration, and weaken the immune system.","date":"2023-09-27 00:00:00+00:00"},{"id":"aa552ce2-0693-4f24-b8aa-d44db6148533","text":"Robert Fico, Viktor Orban, and Aleksandar Vucic\'s approval ratings increased after their trip to Moscow.","date":"2025-05-15 00:00:00+00:00"},{"id":"f9bbeb23-497c-4d13-8beb-ceddba749004","text":"Ukrainian troops killed a separatist defector.","date":"2018-07-25 14:22:39"},{"id":"0a46dcee-f394-4142-a759-f623d40f2993","text":"Russia\'s war in Ukraine conforms with the UN Charter.","date":"2022-04-27 17:24:00"},{"id":"a7f471f0-c804-4bf4-9e64-75b4b344ca1e","text":"Ukrainian President Volodymyr Zelensky will legalize Poland\'s seizure of Ukrainian territory.","date":"2022-06-04 19:26:00"},{"id":"80ddb716-250d-49cb-a86c-cefd8e85d239","text":"The Ukrainian cities Kharkiv, Mykolayiv and Odesa want to return to Russia.","date":"2020-07-31 08:31:40"},{"id":"b3b4dccc-edc1-4594-a17b-eb8a8871eb05","text":"A Ukrainian UJ-22 airborne drone was shot down over Kursk Province.","date":"2022-04-25 15:03:00"},{"id":"a34da33f-f9dd-4652-bf9b-d5fc598b1fa4","text":"Yulia Tymoshenko is planning a coup.","date":"2016-03-15 22:04:56"},{"id":"a10fa490-b372-42ce-b4dd-106ad67c6d58","text":"Antarctic sea ice is increasing to record levels; Antarctica is getting colder and its sea ice and ice cap are not melting.","date":"2023-04-28 00:00:00+00:00"},{"id":"f8df93c6-49fd-4b41-8315-24f1be63730c","text":"Electric vehicles are less environmentally friendly than combustion vehicles because their metal production causes greater environmental harm, and electrifying road transport simply shifts CO2 emissions from tailpipes to power plants.","date":"2024-10-28 00:00:00+00:00"},{"id":"a17cc408-1d6a-490d-8453-7ec64b9273e6","text":"Sea level rise predates human influence and has not accelerated.","date":"2016-10-25 00:00:00+00:00"},{"id":"6b0cb1c7-5e1c-4678-9dfe-c6f8b5a13b7b","text":"Ukraine secretly ceded its borders to the EU.","date":"2018-11-08 22:17:03"},{"id":"5d06354f-3729-4ab5-b52d-859acce95585","text":"Cooking with aluminum foil causes Alzheimer\u2019s disease and cancer.","date":"2024-03-22 00:00:00+00:00"},{"id":"b743ccc3-2ad1-4531-aeb5-3f9ee4ef1afe","text":"The Governor of Maine ordered restaurant staff to wear COVID visors shaped like dog cones.","date":"2020-08-18 00:00:00+00:00"},{"id":"0d2969a9-c361-446f-b6d3-6b39780b39c9","text":"Ukraine\u2019s Culture Minister falsified history and denied the Holocaust.","date":"2021-10-12 18:10:01"},{"id":"a28cffa1-f1e8-459e-884d-d1249a1d0ab2","text":"Alzheimer\'s disease existed 40 years ago, and cholesterol-lowering drugs and cholesterol-lowering diets cause Alzheimer\'s disease.","date":"2023-03-21 00:00:00+00:00"},{"id":"de00440f-228d-4c2d-ad87-5293bd2571a1","text":"International observers accuse the Ukrainian military of committing genocide against civilians.","date":"2015-02-03 12:47:14"},{"id":"a9706be2-7458-4a21-babc-81684e231d94","text":"A Ukrainian soldier willingly joined separatist forces","date":"2018-06-16 10:59:55"},{"id":"b866256c-d159-42f2-9b79-b437f21f7e46","text":"Prenatal ultrasound causes miscarriage and heritable genetic damage.","date":"2021-10-21 00:00:00+00:00"},{"id":"77173a67-8198-4e1d-b0ef-7f2f6804027f","text":"A rainbow flag was raised over Kyiv to replace Ukrainian values and falsify history.","date":"2020-06-24 21:27:39"},{"id":"339fd89e-9069-4cd1-adab-6b245515d392","text":"Kharkiv has no electricity while Kyiv sells surplus electricity abroad.","date":"2024-04-21 19:37:00"},{"id":"64a08c8e-1e38-4b1e-9ea7-be63fab1aef1","text":"The 4 July 2025 Texas floods were caused by a dam release and no footage shows rain during the floods.","date":"2025-07-06 00:00:00+00:00"},{"id":"9d59eafd-dac1-4668-b3a4-5267c5102263","text":"COVID-19 vaccines increase the incidence of heart conditions and cancer.","date":"2024-01-23 00:00:00+00:00"},{"id":"96d8b95e-2b0a-4a6d-bc0c-0a975baa522c","text":"Acting Minister of Health bans antiseptics","date":"2019-03-21 09:11:54"},{"id":"70c1009e-90bb-45b3-9841-3a11d82b6d55","text":"One in 1,000 children vaccinated against COVID-19 died from the vaccine.","date":"2021-10-02 00:00:00+00:00"},{"id":"c08b92a0-63c1-481e-8fbb-220d1bec1e18","text":"Ukrainian Orthodox Churches celebrate Halloween.","date":"2023-11-06 14:22:00"},{"id":"bf409d71-b0a9-4311-a682-6b872b61d969","text":"The CDC illegally inflated COVID-19 death counts by at least 1,600% by issuing NVSS COVID\u201119 Alert No. 2, which shifted underlying causes from Part I to Part II of death certificates and reversed the 2003 certification guidance.","date":"2021-02-09 00:00:00+00:00"},{"id":"43e60ecb-14ff-495d-820e-25f786390e22","text":"The European Union is using new colonization methods to take control of countries.","date":"2019-04-14 18:45:15"},{"id":"ac8a6a2a-4e83-470a-ad51-1f2339e8ceee","text":"Danish researchers found that COVID-19 vaccine protection against the Omicron variant became negative three months after the second dose.","date":"2022-01-06 00:00:00+00:00"},{"id":"f477af0a-dd48-4c7d-a950-1f2cd381cbb2","text":"Poroshenko said European armies are militarily superior to Ukraine\u2019s armed forces.","date":"2017-04-21 16:59:45"},{"id":"61e43457-f3a7-4d90-a467-42a40846a89d","text":"Raw manuka honey kills every bacterium scientists expose to it, including antibiotic-resistant superbugs.","date":"2020-01-18 00:00:00+00:00"},{"id":"f6cba773-bc49-4608-83f0-216fe40c94c6","text":"Flu vaccines contain ingredients derived from dogs.","date":"2024-11-26 00:00:00+00:00"},{"id":"01c7f4c3-c3d1-4952-9dc8-ac43685ce347","text":"Russian specialists modernized the Kakhovka Hydroelectric Power Plant and increased its capacity by 30%.","date":"2022-08-09 07:53:58"},{"id":"e104a744-7f4e-4aae-b81d-466cb73a33a5","text":"5G at 60 GHz prevents the human body and blood from absorbing oxygen, and doctors describe this in COVID-19 cases.","date":"2020-04-06 00:00:00+00:00"},{"id":"07f2b85e-df16-4ab8-8ca2-bc976eb20284","text":"Roman Shukhevych\u2019s bust from the destroyed Lviv museum was recycled into scrap metal.","date":"2024-01-05 10:00:00"},{"id":"d7f7cb52-20d0-41e8-8343-64bd00f61be3","text":"Speaking foreign languages is prohibited in Latvia.","date":"2015-01-20 12:17:45"},{"id":"f3afb427-c00f-455e-a50a-2380bd832be8","text":"Ukraine issued maps that omit its temporarily occupied territories and its western regions.","date":"2022-08-26 13:42:00"},{"id":"94fdde06-df4f-4df1-b0c4-693a467e696f","text":"Armenia resumed flights to Crimea.","date":"2020-01-15 18:10:32"},{"id":"c64c6898-a3bc-4a01-8409-7233c926f445","text":"Mucus is the cause of all diseases and soursop is 10,000 times more effective than chemotherapy at treating cancer.","date":"2021-08-18 00:00:00+00:00"},{"id":"35984706-6e13-4b33-807d-ff8ef361fb10","text":"Raw milk and raw eggs are safe to consume and are more nutritious than pasteurised milk and cooked eggs.","date":"2025-05-07 00:00:00+00:00"},{"id":"1e94c676-527c-4bd5-8763-e83bd1450b58","text":"A pathologist reports that COVID-19 vaccination causes a 52% increase in cancer risk for people aged 15\u201359.","date":"2024-03-05 00:00:00+00:00"},{"id":"efd119c7-d615-439a-8aa4-990e680242d0","text":"The Ukrainian Prime Minister called the people of Luhansk and Donetsk \\"untermensch\\".","date":"2014-10-20 09:32:54"},{"id":"6c092750-6909-4156-9cc6-accd6e480dad","text":"The UK prevented the UN Security Council from making a decision on Mariupol.","date":"2015-01-29 16:40:20"},{"id":"5ccbd8ac-cc11-4cf5-bbf6-831b95c0d4b7","text":"80% of people who received the Moderna COVID-19 vaccine experienced significant side effects; children in Sudan contracted polio from the polio vaccine.","date":"2021-02-10 00:00:00+00:00"},{"id":"2652e037-d6c4-4911-907a-f5e747275327","text":"Cannabis use causes no deaths anywhere.","date":"2024-10-30 00:00:00+00:00"},{"id":"573e3562-d1a1-46bf-8be0-fbcefbd16c8f","text":"Intravenous vitamin C kills cancer cells and does not kill healthy cells.","date":"2022-11-10 00:00:00+00:00"},{"id":"155846a9-19fb-4b95-9ea4-7b57e4c3bca4","text":"All coronaviruses, including those that cause SARS and MERS, are seasonal and always disappear on their own; ivermectin is effective for preventing and treating COVID-19; and COVID-19 vaccines are gene therapy that do not provide immunity or prevent transmission.","date":"2021-04-04 00:00:00+00:00"},{"id":"3ba2c584-b208-4cf3-a984-fdd7ffd124ec","text":"The pandemic was planned, and the respiratory illness surges in New York and China are caused by chlorine and benzene contamination in food and water, not by airborne transmission.","date":"2023-12-31 00:00:00+00:00"},{"id":"b5dd77fe-0b9b-4880-8785-6e1e0a99c6fe","text":"A Ukrainian journalist arrested in Russia is a spy.","date":"2016-10-06 09:34:11"},{"id":"d1de676d-b880-446c-a5a1-788e72def238","text":"Volodymyr Zelenskyy launders Western aid through United Arab Emirates bank accounts.","date":"2025-10-08 00:00:00+00:00"},{"id":"d81be451-c47f-490c-94db-1a7d79073003","text":"The clothing industry produces 10% of the pollution that drives the climate crisis.","date":"2020-06-12 00:00:00+00:00"},{"id":"b860c9a3-51aa-4ed0-8d64-fa0098aca589","text":"COVID-19 vaccines increase the risk of heart attacks.","date":"2023-10-19 00:00:00+00:00"},{"id":"69e680fa-5202-48b4-9763-5796b740d7b3","text":"Russian army destroyed Ukrainian troops who raised the Ukrainian flag on Snake Island","date":"2022-07-08 13:00:00"},{"id":"aca610cb-ba4b-476e-8be6-a5049be6e4d6","text":"Ukraine will dump the remains of a Soviet-era general.","date":"2017-08-08 06:25:06"},{"id":"d4ae80b3-251a-4204-ae6b-a6b712097b11","text":"Organs of Ukrainian soldiers are extracted and sold.","date":"2014-08-29 11:35:45"},{"id":"5d3111bb-3a10-404d-a764-581bac6c54b3","text":"UNICEF payments require registration on Viber and Telegram.","date":"2022-10-30 10:50:00"},{"id":"b5f3114a-640d-4d7b-869f-0e131b24e550","text":"People in France protested after President Macron announced he would send French troops to Ukraine.","date":"2024-03-04 16:57:00"},{"id":"b28bc3af-e32f-4a1b-b264-d4c096c65ae2","text":"Carbon dioxide does not cause global warming; observed warming is caused by the Sun; CO2-driven ocean acidification and CO2-related harm to polar bears are not occurring.","date":"2024-01-09 00:00:00+00:00"},{"id":"372ed784-1786-455f-9495-acdeba1d2936","text":"Adding more carbon dioxide to the atmosphere is beneficial and carbon dioxide does not cause the Earth to warm.","date":"2020-12-18 00:00:00+00:00"},{"id":"6ca9bb38-8395-4d31-b66b-202d55eccd5a","text":"Injured parishioners from a fight in Cherkasy were denied medical treatment because of their religious affiliation.","date":"2024-10-22 00:00:00+00:00"},{"id":"5cf56acc-4b7a-4a64-9bad-4a8be36aadb8","text":"Crimean Tatars owe gratitude to Stalin.","date":"2020-05-19 10:37:36"},{"id":"feda4a1f-7f7d-491b-b1fd-6b694b094251","text":"Fluoride is a neurotoxin that causes lower IQ in children, causes thyroid dysfunction, and causes reduced bone density.","date":"2025-03-28 00:00:00+00:00"},{"id":"5bc9d59d-3e08-49dc-a4ea-6d714073f5e3","text":"baking soda cures cancer","date":"2019-03-22 00:00:00+00:00"},{"id":"52aa1df0-f8ca-4316-bfea-510ee0dca9f8","text":"European leaders are considering Russia\'s plan for the Eastern Ukraine conflict.","date":"2017-10-26 07:26:04"},{"id":"f87cf1d0-7705-43a7-b299-66a0b8f410d1","text":"Video shows an explosion on the road to Komsomolske.","date":"2014-12-31 13:55:59"},{"id":"7603dbcf-c486-4b87-a70e-c184e0f84205","text":"GRU forces were exchanged for Ukrainian security officers.","date":"2015-07-28 15:26:06"},{"id":"b3df1efb-92d6-409e-9578-dee9453bab7a","text":"A new paper proves Covid-19 mRNA vaccination rates are linked to increases in overall deaths.","date":"2022-07-28 00:00:00+00:00"},{"id":"a90738dc-e970-4f65-9ad7-87cad007cb06","text":"Taking Truvada protects against HIV and does not increase the risk of kidney or bone problems.","date":"2019-12-24 00:00:00+00:00"},{"id":"ba3e719c-7b83-4dc2-a7a2-229abb53627c","text":"Only 6% of the 153,504 recorded deaths were caused by COVID-19; the other 94% died from other serious illnesses.","date":"2020-08-29 00:00:00+00:00"},{"id":"0867dfb2-6550-4d16-96e0-9c112ebcc521","text":"Poroshenko was drunk and gave a soccer ball to a legless soldier.","date":"2015-04-02 15:55:02"},{"id":"417104d8-a428-493b-a2bb-56e5b26cd68e","text":"The FDA admitted young children are at a significantly elevated risk of seizures after receiving the COVID-19 vaccine.","date":"2024-03-24 00:00:00+00:00"},{"id":"593f6426-444c-4459-a892-de1960a92502","text":"Belarusian protesters were paid to demonstrate.","date":"2020-08-25 10:05:00"},{"id":"4d989105-9804-4c26-8239-2884525d14ff","text":"Ukraine is demolishing and desecrating Red Army soldiers\' monuments.","date":"2020-02-02 20:25:00"},{"id":"2dbbe5cd-42f6-45aa-a8a6-147b66bc874d","text":"Volyn and Vinnytsia have seceded from Ukraine.","date":"2017-01-18 20:20:11"},{"id":"5ffe426c-467a-4aa8-a9e8-86fa1ed37679","text":"Birthmarks indicate a person has MTHFR mutations, and people with MTHFR mutations have increased risk of vaccine reactions because they cannot detox toxins from vaccines.","date":"2020-03-09 00:00:00+00:00"},{"id":"ee909956-ba2f-422d-b13b-3dd1f7c8b0a7","text":"Ukraine bans conscripts from enrolling in universities.","date":"2023-04-21 10:24:00"},{"id":"5dd54d37-08e5-4109-9c4b-4a0b1db9cb64","text":"WHO stated asymptomatic spread of COVID-19 is very rare, therefore physical distancing and face masks are unnecessary.","date":"2020-06-08 00:00:00+00:00"},{"id":"df649152-fc96-44a7-bac6-d0373f7143d2","text":"Moderna covered up mass heart attacks among toddlers in COVID-19 vaccine trials.","date":"2025-01-24 00:00:00+00:00"},{"id":"b0a29215-1b63-4e99-a442-00bf3c3eb3fe","text":"The majority of IT specialists left Ukraine.","date":"2022-03-30 10:59:12"},{"id":"7121db76-67ef-4f89-a205-949d1d9f7976","text":"Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, which kills viruses including SARS\u2011CoV\u20112.","date":"2023-01-17 00:00:00+00:00"},{"id":"8b3c0685-eb3b-48cf-bcf7-908a949ba76e","text":"The UN Security Council refused to support Ukraine.","date":"2017-02-15 19:25:35"},{"id":"34a941ed-42a4-4f53-9fa5-2137d04d7eeb","text":"Underage refugees tore down the Ukrainian flag from a school near Kyiv.","date":"2014-08-16 22:34:14"},{"id":"b18f674e-cee6-4006-9361-fbfe9d0261c9","text":"Video footage shows a giant tree stump in Antarctica that grew when Earth\'s climate was warmer.","date":"2025-02-17 00:00:00+00:00"},{"id":"bcefaa54-3983-4328-9425-fb1201012286","text":"The Sun and Charlie Hebdo reported that Angelina Jolie was extorted in Ukraine.","date":"2025-11-12 00:00:00+00:00"},{"id":"4860699b-f10d-435c-a3ac-45cdf365dbba","text":"All privileges and compensations in Ukraine have been abolished.","date":"2015-06-06 18:18:44"},{"id":"e576c123-4c10-4108-a4db-311f2e5292ce","text":"NATO troops entered Donbas","date":"2020-07-30 12:42:21"},{"id":"c96db0fc-892b-41e2-bab9-94a5316354f5","text":"90% of the world\'s glaciers are growing.","date":"2020-02-26 00:00:00+00:00"},{"id":"50f1174a-08eb-4deb-95ba-76f62d759c76","text":"The U.S. CDC recommends that children receive a COVID-19 flu shot.","date":"2020-09-15 00:00:00+00:00"},{"id":"ea95d42d-e9aa-45b6-af5c-976b9c11f2ba","text":"Sea level rise does not depend on ocean temperature or CO2.","date":"2018-07-19 00:00:00+00:00"},{"id":"b023faff-5b70-40e5-b254-11c7f10c29ec","text":"Ukraine established a new public holiday called \\"Day of the Avenger\\".","date":"2017-01-26 05:31:56"},{"id":"b1e0d961-3385-472c-8e94-26289b31ec29","text":"COVID-19 vaccines will force continued mask-wearing and physical distancing and will keep restaurants, pubs, and cinemas closed.","date":"2021-01-20 00:00:00+00:00"},{"id":"fa2ae5c7-93c7-4595-a5db-6732ac0edaed","text":"USSR symbols were projected on the Brandenburg Gate in Berlin.","date":"2024-05-09 16:01:00"},{"id":"42750b95-0b11-44f0-8b26-122cab54ba96","text":"Bloomberg announced that giant deposits were found in Crimea.","date":"2016-02-25 23:07:13"},{"id":"f0663ed2-c5fa-4b7d-99ed-494d2b27231c","text":"A pill that combines more than 60 natural herbs cures COPD in three days.","date":"2024-11-26 00:00:00+00:00"},{"id":"aa03710a-4889-481e-a336-bbd930f5f797","text":"In children, COVID-19 causes lower mortality than influenza and the same rate of severe disease or hospitalization as influenza.","date":"2021-07-12 00:00:00+00:00"},{"id":"a71525b5-768c-4767-8b13-031710af5365","text":"Depression is defined by low serotonin; low serotonin means a person is depressed.","date":"2023-09-30 00:00:00+00:00"},{"id":"31dfdbea-5af4-44b8-87f0-4cabe7e56d41","text":"Ukraine will sign security agreements with the United States only if the United States gives Ukraine money.","date":"2024-03-01 15:21:00"},{"id":"1d38276f-ddd7-4554-b6c6-5dd3f82835b5","text":"OSCE confirms the Ukrainian army shelled Donetsk.","date":"2015-11-10 19:51:05"},{"id":"5c5d284a-29b0-4fb3-8cb6-db0f0c797e77","text":"COVID-19 vaccines have caused 21,000 cases of myocarditis and the number is climbing; young people should never receive these vaccines.","date":"2022-04-04 00:00:00+00:00"},{"id":"2c218d15-cd5a-4f9a-a7cd-8391abee9126","text":"COVID-19 vaccines are 98 times more harmful than SARS-CoV-2 infection.","date":"2022-09-22 00:00:00+00:00"},{"id":"d68d0851-8bb2-48b0-95f7-48e00ff3fa22","text":"Vaccines contain unhealthy levels of aluminum, and Japan eliminated vaccines and infant mortality decreased.","date":"2024-02-12 00:00:00+00:00"},{"id":"2de9d081-90ae-4725-be06-bc7997c3d9a4","text":"Babies under six months must not drink fluoridated water because their blood-brain barrier is not fully formed until six months of age.","date":"2024-03-22 00:00:00+00:00"},{"id":"86d3a938-31f3-42cc-be89-5a26acaefcd1","text":"Ukrainian President Volodymyr Zelenskyy is faking blackouts to secure more aid from European countries.","date":"2025-11-10 00:00:00+00:00"},{"id":"c56a3e4f-f384-41f3-9b59-2851b9d79bec","text":"Covid-19 vaccines are ineffective because the majority of COVID-19 deaths occurred among vaccinated people.","date":"2023-08-17 00:00:00+00:00"},{"id":"2a7dd7bf-03be-44c6-a411-eac8687044be","text":"Serbian Defense Ministry says Euromaidan was a coup.","date":"2018-06-14 23:04:35"},{"id":"d2aa06b0-d943-42f3-9874-e68f023ce72d","text":"There are no Russian troops in Donbas.","date":"2015-10-09 10:32:55"},{"id":"8df4bac7-c73c-4dc0-87d2-f1212f551f20","text":"Foreign Policy used its banner to promote a pro\u2011Russian story.","date":"2016-01-17 20:50:12"},{"id":"a5f5b63d-523a-4301-91c8-def1fdf47374","text":"The FDA says doctors can prescribe ivermectin for COVID-19.","date":"2023-08-15 00:00:00+00:00"},{"id":"14726b46-4a6d-4be0-9221-effff997629d","text":"Brussels falsifies and rewrites European history.","date":"2020-09-26 11:32:46"},{"id":"b35936a9-3b33-43a1-ba7d-8853a326579d","text":"Marchers in Kharkiv chanted \\"Death to Russians.\\"","date":"2015-03-03 10:53:21"},{"id":"bebac3fa-67e3-471d-9bb4-7990f8ab9e35","text":"5G technology caused the coronavirus outbreak.","date":"2020-02-22 00:00:00+00:00"},{"id":"f7acb1a4-fdd1-4438-b4c7-bddf4228c92d","text":"Dr. Anthony Fauci acknowledged that large numbers of positive COVID-19 cases were caused by oversensitive PCR tests detecting noninfectious viral fragments, resulting in many false-positive results.","date":"2020-11-08 00:00:00+00:00"},{"id":"1f60b707-aca0-4ce8-94a7-3c7ce5e28b30","text":"One million people in the U.S. have died from COVID-19.","date":"2022-05-16 00:00:00+00:00"},{"id":"0846c7c9-d25d-40f7-ba2e-ef15baf62f6a","text":"European Parliament found that Russia does not sponsor terrorism.","date":"2022-08-14 08:46:53"},{"id":"5ad3a25c-7d15-4326-91f8-e874a44447dd","text":"Ukraine handed military draft notices to minors.","date":"2023-01-22 15:34:00"},{"id":"db4c87aa-d882-424a-95d5-b5578f4f2152","text":"Ukraine will force residents of Crimea and Donbas to repent.","date":"2018-03-13 13:31:53"},{"id":"24566c65-9f5d-4bd6-b64c-2a2e091b9728","text":"The US lost 90% of the weapons it supplied to Ukraine.","date":"2022-12-28 15:44:00"},{"id":"1894f815-8eb4-4675-b927-6c8249ff84d1","text":"A women\'s battalion consisting of females aged 16 to 30 was announced in the Chernihiv region.","date":"2024-03-03 13:31:00"},{"id":"dcf9c1d4-e6ca-4d30-ace3-96e46222ed7d","text":"Ukraine is selling stale leftover bread because of bread shortages.","date":"2023-03-18 18:27:00"},{"id":"7322ffb4-986e-43b6-a289-c5827e12e8f1","text":"Higher COVID-19 vaccination rates among White people are associated with higher COVID-19 death rates.","date":"2023-08-25 00:00:00+00:00"},{"id":"b3c6fc08-ff96-4920-a354-15b497d8edfe","text":"The Czech Republic supplied tanks to Ukraine.","date":"2015-01-30 15:15:33"},{"id":"fa2d3b46-ac03-4fcc-b33c-18d30b2c4e41","text":"Ukrainian soldiers were ordered to shell peaceful villages.","date":"2014-12-08 11:36:53"},{"id":"867931bb-b8a4-4cb6-ad3d-18694cdf5189","text":"Abortions are never medically necessary.","date":"2022-09-07 00:00:00+00:00"},{"id":"8ced6a55-2895-4cc2-a608-c1df3c474d3b","text":"Ukraine has no heating and is operating public warming centers.","date":"2017-02-20 17:25:33"},{"id":"20f56042-1a06-499a-9a53-f1e0b345af51","text":"Volunteers are getting rich from the war in Eastern Ukraine.","date":"2016-12-02 08:15:33"},{"id":"6d859cbf-141e-4be3-88e0-87f0a8be70a7","text":"Coconut oil treats and prevents Alzheimer\'s.","date":"2025-01-23 00:00:00+00:00"},{"id":"2f03eb76-3789-418f-acd7-9c89021472ee","text":"Ukraine announced a new foreign policy toward Africa.","date":"2015-10-01 13:23:58"},{"id":"c2ffff69-9282-4c9a-8f22-78688403761d","text":"The United States will bomb Siberia according to a Ukrainian plan.","date":"2020-06-11 12:14:00"},{"id":"c5e44e6f-0c01-4822-b77a-dc30293d5ea7","text":"COVID-19 vaccines\' spike protein binds to and irreversibly alters human DNA, the vaccines contain multiple lipid types never before injected into humans, and the vaccines have caused 12,000 deaths.","date":"2021-03-17 00:00:00+00:00"},{"id":"f4c4875a-42a8-4b5b-b769-7eec26034c77","text":"Ukraine deceptively recruits South Africans.","date":"2025-12-17 00:00:00+00:00"},{"id":"79d30802-4291-48d8-bf33-f5ca167da388","text":"A toxin found in coffee attacks the bladder and kidneys and causes cancer.","date":"2024-05-15 00:00:00+00:00"},{"id":"d229a86e-367a-47c8-903e-80f4d9e82156","text":"Ukraine\'s Foreign Ministry acknowledged that Crimea is permanently lost to Ukraine.","date":"2020-07-08 14:51:00"},{"id":"b77e829a-afd0-4982-a1d0-632e6e32244c","text":"Ukraine revoked the Geneva Conventions.","date":"2022-04-07 17:43:00"},{"id":"ec0e07a0-d0c8-43d5-9844-0943301e2a36","text":"Aircraft-dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth\'s life support systems.","date":"2021-03-25 00:00:00+00:00"},{"id":"86784e6c-8177-4b9d-a572-6c55c2a97eb8","text":"Peanut oil in vaccines causes peanut allergies.","date":"2024-07-26 00:00:00+00:00"},{"id":"41fc545d-ae89-4a1f-8d9a-18c06042a01e","text":"The US banned Ukraine from buying the Russian vaccine and is testing its own vaccine on Ukrainians.","date":"2020-10-26 17:20:00"},{"id":"c2847424-d6f6-48ec-99f4-a78270737a29","text":"The Pentagon says the U.S. will no longer provide HIMARS and missiles to Ukraine.","date":"2022-08-15 11:44:00"},{"id":"c63562e7-2f47-4cef-bd74-f956b86a4576","text":"It took 15 years to uncover Chantix\u2019s carcinogenic effects, and Chantix was not approved or confirmed safe during its first 12 months on the market.","date":"2021-05-11 00:00:00+00:00"},{"id":"a9ca3233-bd0a-41f1-b2e0-8f1f725fb225","text":"A South African scientist successfully removed HIV from a sperm cell in a laboratory.","date":"2022-05-28 00:00:00+00:00"},{"id":"73a83e9e-a797-4089-b84e-33a825dd6e1f","text":"Excess deaths in late 2022 exceeded the pandemic peak and were caused by COVID-19 vaccines.","date":"2023-01-13 00:00:00+00:00"},{"id":"7b7ca705-46e3-4c64-9380-8eb6e0d18334","text":"Ukrainian ancestors dug up the Black Sea.","date":"2015-01-29 17:48:14"},{"id":"20358a0a-a0d9-4286-89ba-775b060e8441","text":"France will lift sanctions on Russia.","date":"2016-04-28 22:15:48"},{"id":"a3f7a543-8c54-4f0f-8be8-28dc9d6c0dba","text":"Ivermectin sterilizes 85% of men who take it.","date":"2021-09-14 00:00:00+00:00"},{"id":"21b0d791-0ab6-4fbc-a453-4665aa2e2382","text":"The United States has a better handle on COVID-19 than Europe, and COVID-19 is less deadly in the United States than in most European countries based on case fatality data.","date":"2020-04-11 00:00:00+00:00"},{"id":"3442f73e-73e5-4882-8dab-66506922b48f","text":"A review of autopsy cases found that 74% of deaths were caused by COVID-19 vaccines.","date":"2024-06-23 00:00:00+00:00"},{"id":"98ad1a45-cda6-4e1f-8781-f3b161967bcf","text":"WHO says a child\'s presence at school alone constitutes informed consent for vaccination.","date":"2021-11-14 00:00:00+00:00"},{"id":"2edc3bf0-a4cb-4dd7-9c14-a4818bf63cad","text":"Environmental laws cause California wildfires to be much worse by preventing massive amounts of available water from being used and diverting that water into the Pacific Ocean.","date":"2018-08-05 00:00:00+00:00"},{"id":"88214d23-e54a-4adf-b1c6-03685d8f9c6c","text":"Sunscreen causes cancer and the sun does not cause cancer.","date":"2018-06-11 00:00:00+00:00"},{"id":"43fe8af9-e5e1-46ca-9396-01915f4ec799","text":"Massive volcanic CO2 emissions discredit the theory of global warming.","date":"2018-11-07 00:00:00+00:00"},{"id":"63f980ff-a871-4da2-8501-e19ef4784b0b","text":"An international medical crisis is occurring because COVID-19 vaccines are causing widespread diseases and deaths.","date":"2022-09-19 00:00:00+00:00"},{"id":"244fcfc2-dd34-4fbe-98e4-81f80c8c08c9","text":"Scientists predict 6 billion people will be slaughtered or starve to death this century.","date":"2019-08-17 00:00:00+00:00"},{"id":"709e80f4-fb04-445f-b9c8-885503b4171d","text":"COVID-19 vaccine recipients are not eligible to donate blood.","date":"2024-02-21 00:00:00+00:00"},{"id":"b6e88a3f-5dab-496a-8af6-b690d55aa904","text":"The HIV VB variant is highly infectious and makes people ill twice as quickly.","date":"2022-02-03 00:00:00+00:00"},{"id":"e81c3aa2-be13-43d5-9a64-6562964c293a","text":"France jails citizens for questioning or opposing mRNA vaccines.","date":"2024-02-23 00:00:00+00:00"},{"id":"50cc82f9-6fab-455a-bcc9-d17aed021f1d","text":"Ukraine establishes maritime borders only by recognizing Russia\u2019s annexation of Crimea.","date":"2019-10-31 11:12:05"},{"id":"0503bed5-4d7d-47ad-bd61-fa9f13662226","text":"A Russian drummer from the band Metal Corrosion was forced to serve in the Azov Battalion.","date":"2015-02-22 10:55:38"},{"id":"823f891a-b607-43cf-9976-5c5774141517","text":"Deaths reported to VAERS after vaccination are caused by the vaccine.","date":"2021-07-23 00:00:00+00:00"},{"id":"d4ca06b7-dafd-4b18-9208-e5fda4a6070c","text":"Ukraine\'s currency market will collapse without transfers from Russia.","date":"2017-03-05 07:23:16"},{"id":"24994368-cbdc-4f55-9672-f292140ffb65","text":"Regenerative agriculture improves soil health more than conventional agriculture.","date":"2025-12-10 00:00:00+00:00"},{"id":"f5d998c1-dba7-4576-b16a-89383c25a0fc","text":"A review found that COVID-19 mRNA vaccines aid cancer development.","date":"2024-04-29 00:00:00+00:00"},{"id":"0cd33477-f197-45bc-9d03-254b7ea91b03","text":"Polish company ASBS Othago is fighting alongside the Ukrainian military forces.","date":"2014-08-15 12:46:29"},{"id":"ba2de5ac-a509-44a5-bbe8-5a1276566e62","text":"Climate change is not new and climate change is not caused by humans.","date":"2020-01-13 00:00:00+00:00"},{"id":"3438a90c-54f2-4270-84a6-974f333b08d2","text":"Kyiv\'s electronic warfare forced Russian drones off course into Poland.","date":"2025-09-10 00:00:00+00:00"},{"id":"142195bc-ce0a-446a-a197-82133bc1bfda","text":"Ukraine has banned the Belgian Foreign Minister from visiting Ukraine because he visited Crimea.","date":"2022-07-30 16:07:00"},{"id":"0baf6d0b-4f91-4d6a-9da3-83f030ad66e1","text":"In the 1980s\u20131990s people died from the antiretroviral drug AZT instead of from HIV/AIDS, and Anthony Fauci pushed AZT as the treatment.","date":"2021-08-25 00:00:00+00:00"},{"id":"717943a2-2909-4b7f-9745-882b8c2e2624","text":"Nearly 90% of Odesa residents like Russia.","date":"2021-11-23 12:15:00"},{"id":"5f2ca378-ca40-4a54-88b9-ce966ac550a5","text":"Ukrainian soldiers wore Russian uniforms in Donbas.","date":"2018-06-20 16:46:36"},{"id":"c964b8e9-62a4-426b-8aa4-338df852d011","text":"Ventilators, not COVID-19, caused the deaths of hospitalized COVID-19 patients.","date":"2023-11-14 00:00:00+00:00"},{"id":"31a1ff2d-e616-4f27-85a4-b4e9a505c722","text":"COVID-19 vaccines caused an increase in abnormal blood clots observed by embalmers.","date":"2022-10-24 00:00:00+00:00"},{"id":"be381aea-1470-495b-a705-3f0402b74c43","text":"Russian militant Motorola was killed by a Latvian mercenary.","date":"2016-10-21 18:34:59"},{"id":"6618192f-d9d0-4608-8d78-16d5b77810b4","text":"Crimean Tatars asked Turkey to recognize Crimea as part of Russia.","date":"2016-07-06 09:39:11"},{"id":"f4c3a3a5-c6ce-4414-b615-0c69fab214c7","text":"Side effects of the HPV vaccine outweigh its benefits.","date":"2019-07-08 00:00:00+00:00"},{"id":"5e5c4927-3a0c-428a-bf40-0eb609878217","text":"Ukraine boycotts the Paralympics.","date":"2026-02-19 00:00:00+00:00"},{"id":"0c5f39e5-63c0-4191-8b6c-40ae97875fb0","text":"NATO confirmed Russia is fighting in Ukraine at reduced strength.","date":"2022-07-31 11:21:00"},{"id":"d133f617-ddcb-4c57-9aa9-ec5590508b88","text":"The FDA admitted young children are at a significantly elevated risk of seizure after taking the COVID-19 vaccine.","date":"2024-05-04 00:00:00+00:00"},{"id":"588a55b7-6e3c-45c2-8364-c5ef65a60b7c","text":"The European Parliament accused Petro Poroshenko of causing a church schism to win the election.","date":"2019-03-03 18:31:00"},{"id":"023c4c57-2967-428e-b72f-9beb8f0f4f20","text":"Polish and British special forces fought in Ukraine from the first days of the Russian invasion.","date":"2023-12-14 10:18:00"},{"id":"a5277d1c-96d0-47fa-b6cf-3d93de47a11f","text":"Oil and gas are renewable energy sources produced by a geothermal reaction between the solid mantle and liquid core; hydrocarbons form in the upper mantle, migrate through deep faults, and are deposited throughout Earth\u2019s crust in any rock type and structural position.","date":"2024-05-25 00:00:00+00:00"},{"id":"a9826696-7be0-438c-8926-1ad2257b1a62","text":"Russian military captured German PzH 2000 howitzer","date":"2022-07-06 12:45:00"},{"id":"07e8ef3c-b9bd-433f-9c12-4fbfc99e8481","text":"More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades.","date":"2022-03-15 00:00:00+00:00"},{"id":"ff2a806d-e6f1-460f-9f0e-712d721ec08f","text":"Spanish media call the Ukrainian coat of arms ultra\u2011nationalist and paramilitary.","date":"2016-08-06 16:10:35"},{"id":"c3257842-d857-4799-8fb0-ecbada1492d5","text":"There will be herd immunity to COVID-19 by April because 55% of Americans have natural immunity.","date":"2021-02-18 00:00:00+00:00"},{"id":"0a533773-d2af-437e-b15b-24397d33e008","text":"U.S. doctors found that 70% of long COVID cases developed after COVID vaccination, not after infection.","date":"2024-03-06 00:00:00+00:00"},{"id":"a52a2dc4-9a7e-445b-840b-aa2a71bfc7b5","text":"A Harvard study confirms fluoride reduces children\u2019s IQ.","date":"2022-09-21 00:00:00+00:00"},{"id":"9f80744b-cde3-495c-a2c1-e651a81c9ae3","text":"Marijuana is not addictive, cures cancer, and causes brain cells to grow.","date":"2019-04-25 00:00:00+00:00"},{"id":"7f1b05bb-bbef-4f51-accd-291a84b9c779","text":"Ukraine used video game footage as evidence in its ICJ suit against Russia.","date":"2017-03-12 09:24:48"},{"id":"22a6c6a7-6139-48a0-ae57-b4c6ba1bde74","text":"Ukrainian general kneels before the former US ambassador","date":"2014-05-28 20:49:06"},{"id":"ce65051a-c2b7-49c5-b4ce-6b061e39b289","text":"A Ukrainian missile destroyed an apartment building in Kyiv.","date":"2022-02-27 13:52:17"},{"id":"798f535c-e291-4f87-bb0b-4a6a4f468191","text":"Russian forces destroyed an all-female unit of the Ukrainian Armed Forces.","date":"2025-06-02 00:00:00+00:00"},{"id":"79fca050-3a9d-45f9-9935-b4b5b72a6503","text":"The daughter of the SSU head organizes howitzer shooting tours.","date":"2014-08-24 16:51:33"},{"id":"c993fc46-d4e7-47cb-a26e-d3c5e2928b18","text":"Ukrainians were drafted into volunteer battalions in Israel.","date":"2023-10-18 16:25:00"},{"id":"553f676b-b93d-4694-8dc9-9f0bb6432591","text":"A police officer confirmed that 10 civilians were killed in Donetsk.","date":"2014-05-28 11:46:24"},{"id":"4976ee3a-3784-4d3f-9857-73c8195327ad","text":"U.S. Ambassador to Russia laid flowers with blue and yellow ribbons at the scene of Nemtsov\'s murder","date":"2015-03-01 20:00:07"},{"id":"c20f1eec-25ed-42b6-ae82-6b5b0393c7d3","text":"American mercenaries are operating in Donetsk.","date":"2014-03-29 14:02:32"},{"id":"033f04c0-b501-478b-9f25-fa6b4d2ca4ad","text":"Fluoridated toothpaste is deadly to children and fluoride causes dental fluorosis, cavities, and cancer.","date":"2024-06-12 00:00:00+00:00"},{"id":"37839e78-27f0-4435-b8ce-f71a4f116bed","text":"Cayenne pepper is the most powerful blood thinner.","date":"2023-08-27 00:00:00+00:00"},{"id":"e5d00f8a-9ceb-4743-83a6-8d6bf5883043","text":"Yatsenyuk says Galicia was illegally annexed.","date":"2015-09-20 15:53:12"},{"id":"8e186830-bee5-4aca-9ba9-f6ab92a6da54","text":"Masks prevent influenza but fail to prevent COVID-19; influenza cases were largely renamed COVID-19.","date":"2021-01-17 00:00:00+00:00"},{"id":"e3a04279-fb73-4013-9f74-419385217d64","text":"Arctic sea ice and polar icecaps are melting at unnatural rates and this melting constitutes evidence of human-caused climate change.","date":"2017-05-17 00:00:00+00:00"},{"id":"758b9d79-89df-4867-81a1-838437e6a859","text":"82% of Czechs believe Malaysia Airlines Flight MH17 was shot down by the Ukrainian army.","date":"2014-07-24 13:17:00"},{"id":"354932c8-6ae3-482e-80c2-1ec5fb490ed6","text":"German tanks painted with Nazi symbols are being transported to Ukraine.","date":"2023-03-01 12:39:00"},{"id":"ef3e88e0-f84d-4da8-96d8-9f775591b9f0","text":"No COVID-19 vaccines were FDA-approved and available in the United States as of May 2023.","date":"2023-05-26 00:00:00+00:00"},{"id":"943c7207-e112-481d-9818-bf98c872d3f1","text":"Kolomoiskii\'s enforcers beat and kicked soldiers\' mothers from Western Ukraine with sticks.","date":"2014-06-03 17:53:43"},{"id":"c05b569b-31f7-4337-afce-74533292fc0b","text":"Photos show descendants of Banderovits committing atrocities.","date":"2014-11-14 15:02:52"},{"id":"3f92c6cf-d089-4d51-afd0-5cc8bf719664","text":"Japan officially named COVID-19 mRNA vaccines the most deadly drug in human history.","date":"2024-11-21 00:00:00+00:00"},{"id":"b4dc8335-e7e6-4ca1-ac0f-cda8fc61aa54","text":"The HAARP facility deliberately creates global-scale destruction \u2014 earthquakes, cyclones, floods, and snowstorms \u2014 and attacks the world\'s citizens telepathically by influencing their thoughts with low-frequency vibrations.","date":"2021-02-03 00:00:00+00:00"},{"id":"f579b180-4bcf-4616-8cca-c6611dc5d22e","text":"The Polish ambassador wants a Yugoslav-style breakup of Ukraine.","date":"2017-07-12 11:40:22"},{"id":"9a51ca5a-08a2-471d-b0ef-7059646f9b98","text":"Sauna bathing detoxes the body by causing sweating.","date":"2024-05-09 00:00:00+00:00"},{"id":"4d3c833c-1a92-4746-ad0d-5c2840c14110","text":"Barack Obama accuses Ukrainian authorities of committing genocide.","date":"2015-09-26 22:24:21"},{"id":"fb699657-8103-453e-938a-f5daa0ea13d1","text":"Biden said Ukraine is the most corrupt country in the world.","date":"2015-12-16 19:44:26"},{"id":"cc684206-59ef-4f1d-9a3e-0ff4eafb7fca","text":"The Mykolayiv Shipbuilding Plant was cut up for scrap metal.","date":"2020-06-08 17:01:00"},{"id":"85dae113-29da-4a75-b868-215745825ee0","text":"NASA adjusted historical temperatures downward and recent temperatures upward, and those adjustments are responsible for most of the reported global warming.","date":"2019-06-26 00:00:00+00:00"},{"id":"ac309972-39c0-4c22-a9a8-2e21189a182b","text":"90% of the world\'s coral reefs will disappear within 35 years due to coral bleaching caused by global warming, pollution, and over-development.","date":"2017-02-27 00:00:00+00:00"},{"id":"23d5acde-9eb1-4641-b65c-7f5d94d7b611","text":"ISW says that after Trump\'s election victory, the Ukrainian military surrendered more often.","date":"2024-11-11 00:00:00+00:00"},{"id":"0c3ae337-f9bd-4232-8dfb-2940624107d2","text":"The UK visa center in Kyiv closed after Russian shelling.","date":"2025-06-10 00:00:00+00:00"},{"id":"9f15f89c-d1c8-4a2d-8528-9d31c8654f08","text":"Total deaths from COVID-19 are much lower than officially reported.","date":"2022-01-27 00:00:00+00:00"},{"id":"0be7d364-75a2-4715-bfe6-b1ad97691bb5","text":"Vaccinated children have poorer health outcomes than unvaccinated children.","date":"2023-07-07 00:00:00+00:00"},{"id":"4e85a632-df9b-4b75-a026-4f6406a638e4","text":"The British Embassy in Ukraine recommends that British citizens flee from drafting officers.","date":"2024-09-22 10:03:00"},{"id":"bfa02948-129d-4df1-8d02-32c7106ce1a7","text":"Ukrainian soldiers claim Ukrainian authorities are deliberately prolonging the war to profit from it.","date":"2026-02-19 00:00:00+00:00"},{"id":"8f2a8ba8-3a4a-4936-bf7f-34faee9aa1e3","text":"Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead.","date":"2023-06-04 00:00:00+00:00"},{"id":"80600e8f-ca1c-4a49-a344-25d0c769ba95","text":"The coronavirus outbreak was caused by 5G technology, not by a virus.","date":"2020-12-03 00:00:00+00:00"},{"id":"f97d0478-9be5-4fc6-a5f1-680f08d3eb14","text":"Ukraine will not have enough gas to last the winter.","date":"2018-12-22 17:52:22"},{"id":"e3ab94bd-6ae1-4890-93b1-11b533431a94","text":"Massive protests occurred in Germany opposing sending tanks to Ukraine.","date":"2023-01-29 10:36:00"},{"id":"dd5773a2-71e4-444d-8c08-6f13e54af348","text":"A Ukrainian military missile launch went wrong during maneuvers.","date":"2014-09-10 18:53:27"},{"id":"0a1a6190-eb21-4894-b6b5-c8613a05b0a6","text":"A Western ratings agency reports that Kyiv has defaulted.","date":"2016-09-09 18:56:58"},{"id":"093d75a8-822f-4e74-8fc9-d38c1bd278b6","text":"Starbucks plans to return to Russia","date":"2024-06-14 10:07:49"},{"id":"e3571f4c-65f1-4db3-897f-fe9736b10446","text":"People with blood type O are more protected against COVID-19 than people with other blood types.","date":"2020-06-22 00:00:00+00:00"},{"id":"fe77b063-ffc7-45db-bf3c-30d1345de127","text":"FDA guidelines state that babies are too small to safely handle the amount of aluminum in childhood vaccines.","date":"2024-02-18 00:00:00+00:00"},{"id":"e598a674-f687-420e-961c-9e37ddf343d7","text":"Ukraine jails Russians for visiting Crimea","date":"2018-11-11 23:48:06"},{"id":"e3c43223-3600-4873-a0bc-96a7a3028392","text":"Poroshenko ordered a total blockade of Crimea.","date":"2015-11-22 22:49:12"},{"id":"733f152b-a575-4502-b706-11073df8c68c","text":"The EU ignored Russia distributing passports to residents of Donbas.","date":"2019-08-15 21:35:59"},{"id":"7c2428b6-5481-4361-bde2-ecc9321746bb","text":"Ukrainian military attempted a chemical attack in Donbas.","date":"2022-02-18 19:22:34"},{"id":"cd709fbf-cb82-4ab7-b2c2-2da875059189","text":"Ukraine has the highest electricity prices in Europe.","date":"2017-09-22 18:12:18"},{"id":"3ac406b0-e68e-49a0-bd1b-2528853d2cad","text":"Flu shots cause people to spread the flu.","date":"2019-05-03 00:00:00+00:00"},{"id":"65185d34-b527-468c-beb7-4b55954d027f","text":"Tumors are bubbles of toxins expelled by the body; cancer is beneficial; biopsies and mammograms cause cancer.","date":"2024-09-08 00:00:00+00:00"},{"id":"513ca3cb-280b-43ff-9a2c-b0a564e9be78","text":"COVID-19 vaccines commonly cause myocarditis and cause sudden death","date":"2024-09-12 00:00:00+00:00"},{"id":"7b1d1801-aa76-41eb-9f0b-d7d9461b7987","text":"Euromaidan participants were paid.","date":"2014-04-08 09:33:01"},{"id":"589edca3-47ff-4fbe-80de-c38bf691870b","text":"Natural variation explains a substantial part of the global warming observed since 1850, and global warming is not intensifying natural disasters or increasing their frequency.","date":"2022-08-24 00:00:00+00:00"},{"id":"d41f05ae-a077-4b43-a1ad-50f0a3215fad","text":"COVID-19 causes prolonged, progressive hypoxia by binding to the heme groups in hemoglobin in red blood cells.","date":"2020-04-15 00:00:00+00:00"},{"id":"e5422914-be7b-4e48-a015-d663782e09ff","text":"A court ruled that COVID-19 mRNA vaccines are not vaccines.","date":"2024-06-08 00:00:00+00:00"},{"id":"0dda44fb-e789-409d-8884-402c50cfbf09","text":"The surrender of Bakhmut will collapse the Ukrainian front to its western borders.","date":"2023-04-26 18:13:00"},{"id":"c8ab785c-bdf9-4974-a4a6-0fa8e1e04427","text":"Alexis Lorenze became severely ill due to vaccines, and vaccines aggravate paroxysmal nocturnal hemoglobinuria.","date":"2024-09-16 00:00:00+00:00"},{"id":"0f5a9041-d107-4637-af27-c903436d7f31","text":"A freelance journalist was shot dead in Kyiv, Ukraine.","date":"2015-07-15 10:53:40"},{"id":"a9f42078-b13a-4273-b720-2b85621b9479","text":"The Ukrainian National Memory Institute promotes hatred and incites conflict.","date":"2019-10-29 17:45:03"},{"id":"96bbb94c-4f84-462e-8d41-121eef67b842","text":"Ukrainian paratroopers resigned from the military because they refused to fight.","date":"2014-06-24 12:20:00"},{"id":"feef1b5d-6fca-48b3-b6e7-7e296b05c53c","text":"The CDC director admitted that COVID-19 deaths were over-counted.","date":"2021-05-17 00:00:00+00:00"},{"id":"b5ae45b2-5d16-4b5b-aa3a-5576d28dd426","text":"Makeevka was hit by ballistic missiles.","date":"2014-08-21 14:22:04"},{"id":"c9e9a73a-9805-4a55-a450-6162c6ec9b71","text":"John Kerry praised Russian efforts to secure a ceasefire in Syria.","date":"2016-05-04 06:05:55"},{"id":"17354fb2-74e2-4dea-b9f6-3b313bc2f042","text":"Crimeans are under military pressure to support Russian annexation.","date":"2017-10-11 13:36:35"},{"id":"f3fc68de-4d62-44bb-b25b-67ca2e4c5aff","text":"COVID-19 vaccines killed people and COVID-19 has a 99.97% survival rate.","date":"2021-06-05 00:00:00+00:00"},{"id":"6bf5be7b-0915-44fe-9e53-1db09cfb0aa9","text":"People do not wear masks for tuberculosis because CNN has not instructed them to.","date":"2020-09-17 00:00:00+00:00"},{"id":"f2352fef-7f02-4458-a866-639bd458c927","text":"Antarctic ice increased from 2021 to 2023, reversing the Antarctic ice-loss trend.","date":"2025-05-02 00:00:00+00:00"},{"id":"45820d42-2355-436e-9fd0-498d37c06918","text":"Russian Proton rocket crashed while carrying a satellite.","date":"2014-12-21 11:38:35"},{"id":"95cf57c8-db12-4b02-9ab4-5f125ec8e52f","text":"Earth\u2019s mean temperature over the last 2,000 years was higher during 1\u2013200 AD (the Roman Warm Period) and 900\u20131100 AD (the Medieval Warm Period) than it is now.","date":"2019-07-26 00:00:00+00:00"},{"id":"4c6cf093-805b-4e3a-992f-9702969ee316","text":"Ukrainian soldiers fired on a car carrying a Russian-speaking mother and her child.","date":"2023-03-28 12:31:00"},{"id":"de30d744-016b-4318-8ab1-056f6e5e884e","text":"Andriy Yermak paid TIME magazine to secure a spot on TIME\'s 2024 Most Influential list.","date":"2024-04-23 19:37:00"},{"id":"4a4a457b-1325-44eb-8e2f-f16ac98bf1da","text":"No one has died from the coronavirus.","date":"2020-12-07 00:00:00+00:00"},{"id":"ff19f0d3-d83b-4d15-9bc7-3f167453c19b","text":"The Ukrainian Armed Forces are recruiting mercenaries from Croatia.","date":"2016-11-12 14:36:37"},{"id":"b5df04a7-2e6e-434f-b9a5-1ea3d3c335c4","text":"Latvians want to establish a ghetto for Russians.","date":"2015-04-28 21:47:29"},{"id":"61c001bc-aaeb-4697-ad48-4e975f4f2e0e","text":"COVID-19 RNA vaccines were not made with messenger RNA; vaccine RNA cannot be broken down in the body.","date":"2023-07-27 00:00:00+00:00"},{"id":"31531c60-58d7-4c6e-a9ae-1ce4ab397323","text":"Cooking with aluminum foil causes Alzheimer\u2019s disease and cancer.","date":"2024-05-04 00:00:00+00:00"},{"id":"f275225d-6b88-4d4e-a09f-ec6c1ba1b714","text":"Children injected with Pfizer\u2019s mRNA COVID-19 vaccine had weakened immune responses to other viruses.","date":"2023-11-09 00:00:00+00:00"},{"id":"36ec8ad7-b079-409a-bf22-79874f231a2e","text":"The influenza vaccine has existed for 78 years and influenza still exists.","date":"2025-02-08 00:00:00+00:00"},{"id":"3a47fae3-bbb0-43a2-ba49-1814af0c3582","text":"The world considers Ukraine a Nazi state.","date":"2021-08-23 21:05:00"},{"id":"7729c1e6-daf9-43e8-8f05-13d5abb67363","text":"Ukraine is forced to purchase the Russian COVID-19 vaccine.","date":"2021-01-06 12:01:36"},{"id":"ec3f7c59-e418-4dc7-9051-8e61a0e8e5e7","text":"Moderna produced COVID-19 vaccines before the pandemic began.","date":"2023-02-14 00:00:00+00:00"},{"id":"22c7b5e2-c0b8-486e-ae92-b3478ba3a159","text":"Ukrainian authorities will mobilize workers at nuclear power plants.","date":"2023-03-04 12:33:00"},{"id":"d7bc4506-898d-4cf0-99e3-6b4c693e9ba2","text":"DMSO effectively treats pain.","date":"2025-08-04 00:00:00+00:00"},{"id":"f99a79a4-6ea5-487c-9ad5-126653491c6c","text":"Crimea benefits economically from its reunification with Russia.","date":"2017-08-01 20:15:51"},{"id":"df0444fa-0108-44fb-9a41-a5ccb4264275","text":"Vaccinated people face no danger from unvaccinated people; unvaccinated people have natural immunity and are less likely to get sick from COVID-19 than vaccinated people.","date":"2021-09-24 00:00:00+00:00"},{"id":"320d86e9-05f0-40f0-a64d-f3a23a09f492","text":"Ukraine imported spent nuclear fuel to build a dirty bomb.","date":"2025-12-12 00:00:00+00:00"},{"id":"e6b8b24f-3c1d-4b2f-8758-4cb1449207a6","text":"Zelensky\u2019s entourage act as intermediaries in weapons schemes","date":"2022-04-05 19:02:22"},{"id":"aae86df3-6521-4ed4-a063-13ca198344bc","text":"CDC admits 146.6 million Americans have natural immunity and 94% of COVID-related deaths were not caused by COVID-19.","date":"2021-11-13 00:00:00+00:00"},{"id":"9333691c-9fac-48f5-b168-51ba9ba9ce6f","text":"The EU fears that Ukraine is smuggling weapons and drugs.","date":"2022-07-13 10:15:00"},{"id":"d1a16d25-6596-46f5-898f-d0b42f956fce","text":"The Netherlands accuses Ukraine of criminal conduct in the MH17 investigation.","date":"2016-01-31 12:00:32"},{"id":"6d0f0417-0ad9-40ba-bddd-2050e41aaf92","text":"U.S. delegation leader condemned NATO actions in the Black Sea.","date":"2019-05-04 11:26:56"},{"id":"5767beb0-c933-4e88-9be9-fa25294894a5","text":"A quarter of U.S. COVID-19 deaths were preventable with vaccination.","date":"2022-04-21 00:00:00+00:00"},{"id":"88586791-dac7-4eae-93f2-1f5088deaff3","text":"Britain has ruled that Ukraine is responsible for Yanukovych\'s debt.","date":"2019-12-24 08:17:09"},{"id":"d2b91e1b-119d-4b46-a45b-d31503811126","text":"Blades from failing wind farms will be launched at people.","date":"2024-07-24 00:00:00+00:00"},{"id":"e45969f9-8906-49c4-91cf-ca8b972acfa2","text":"Chemotherapy is 100% mustard gas and causes cancer.","date":"2024-05-28 00:00:00+00:00"},{"id":"476a7a56-ac30-4d52-9a28-cb6771609992","text":"Ukraine\u2019s Internal Affairs Ministry says Russia\u2019s strikes are highly precise.","date":"2024-04-09 10:00:00"},{"id":"8f48c0c7-9599-48e9-8266-33bb81928adb","text":"Ukraine makes opposing NATO and the EU illegal.","date":"2019-02-23 13:27:39"},{"id":"56c79572-5c21-4aff-8ee3-d0693b0a5f53","text":"The coronavirus was created in a laboratory and patented in 2015.","date":"2020-01-24 00:00:00+00:00"},{"id":"12ce5ef5-db4f-4329-b817-14e69033510a","text":"Poroshenko allows lumber to be smuggled into the EU.","date":"2018-07-25 13:21:45"},{"id":"a2032602-1b45-4927-8fd7-e58380efe7e8","text":"Moderna reported that serious adverse events affected 1 in 200 toddlers and concluded the mRNA vaccine was safe in children.","date":"2022-10-29 00:00:00+00:00"},{"id":"4b32edf9-0d33-41e1-99d5-1ab79fdd6ba9","text":"NATO is illegally occupying Ukraine.","date":"2020-09-25 11:04:00"},{"id":"c9dc8b79-d140-4e6c-a007-cee5b5e4d7df","text":"Polio was renamed to hide that it still exists; the polio vaccine does not work; vaccines contain harmful mercury, SV40, and DNA contamination.","date":"2025-03-26 00:00:00+00:00"},{"id":"aa5e3ea1-6aa8-4949-b5ea-a17f75263501","text":"There has been no long-term change in sea level rise rates over the last 120 years.","date":"2021-01-15 00:00:00+00:00"},{"id":"1d741e3f-f006-4b3e-a634-e8430d392812","text":"Viruses do not exist and terrain theory fully explains why diseases occur.","date":"2024-02-11 00:00:00+00:00"},{"id":"5ffa8173-142d-46fc-8a46-e6ede611a7f7","text":"Ukrainian soldiers committed suicide instead of shooting at Russian separatists.","date":"2020-02-05 15:46:35"},{"id":"b88d61fc-871c-45c6-9a1f-465e76dfe0e5","text":"You can determine a person\'s immune system strength by looking at their eyes.","date":"2022-05-13 00:00:00+00:00"},{"id":"8317dd6d-21d3-4041-ba08-d341e9d5d4ec","text":"Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead.","date":"2023-03-18 00:00:00+00:00"},{"id":"01d346e1-324d-498c-9e77-d15d8c02410c","text":"mRNA COVID-19 vaccine lipid nanoparticles concentrate in the ovaries, causing the ovaries to produce large amounts of toxic spike protein.","date":"2021-06-24 00:00:00+00:00"},{"id":"8752aaa7-c117-409c-97a5-33654f99a19e","text":"Ukrainians in Poland are slaves.","date":"2018-08-22 10:39:28"},{"id":"18a1c6d8-94f6-43cf-87cc-29cc134dcb1c","text":"The COVID-19 vaccine is unsafe and ineffective because its trial is still underway, and thousands of people who received the vaccine have died or been seriously injured.","date":"2021-02-02 00:00:00+00:00"},{"id":"5d97ba40-893d-4e0a-9deb-9667147e6912","text":"Sea-level rise is independent of ocean temperature and CO2.","date":"2018-05-15 00:00:00+00:00"},{"id":"39ab6769-1890-429e-b317-731e9a4eff85","text":"Leaders of self\u2011proclaimed separatist republics appeared before the UN Security Council.","date":"2020-12-03 21:23:29"},{"id":"22c52ca6-b7de-45b7-90e8-f17840ef578d","text":"The EU is bringing Ukraine to its knees.","date":"2017-06-29 22:27:56"},{"id":"f36689c9-d8fa-49ec-849b-0826304fa11d","text":"Bill Gates said genetically modified organisms are being injected into children\'s arms and shot into their veins.","date":"2020-05-26 00:00:00+00:00"},{"id":"900e1eee-866c-424a-8d33-57b367844e47","text":"Ukraine continues to buy gas from Russia.","date":"2016-04-05 11:12:07"},{"id":"09b4e52e-8c85-4f99-a325-574e2b0f7690","text":"Merck scrapped its COVID-19 vaccine program and said getting infected and recovering provides better protection than vaccination.","date":"2021-01-29 00:00:00+00:00"},{"id":"1ea2d7a3-eaf7-465f-82c9-4ff74a567e2b","text":"Previously healthy people are being seriously harmed and dying from the flu shot.","date":"2019-02-28 00:00:00+00:00"},{"id":"95591809-ea32-440d-bc8a-6614f1dc69ff","text":"Regulators reduced approval standards so the COVID-19 vaccine was approved regardless of evidence, and the COVID-19 vaccine does not prevent transmission.","date":"2020-12-13 00:00:00+00:00"},{"id":"a98efa16-89b0-4b36-a563-e8a6964e5dda","text":"U.S. senators armed Ukraine to capture the Donbas region.","date":"2021-12-29 10:33:00"},{"id":"4f973af5-b56d-47c9-bb96-aba7882312eb","text":"Putin plans to militarily retake Crimea.","date":"2022-02-02 15:14:39"},{"id":"ef196b0f-45eb-4409-8ae0-5474c6c35470","text":"Czech data shows COVID-19 vaccines reduce fertility.","date":"2025-05-11 00:00:00+00:00"},{"id":"16c59c3d-069a-48a2-ae37-ad52d70c88d4","text":"Ukraine sent soldiers to Germany for training without testing them for COVID-19.","date":"2020-07-25 08:02:00"},{"id":"30a36220-c2d9-44cd-b29f-46744923b417","text":"One million mRNA COVID-19 vaccine doses given to teenagers prevent at most one death and cause 100,000\u2013200,000 severe side effects.","date":"2023-09-25 00:00:00+00:00"},{"id":"9ee9fd26-4cda-4482-a159-a1dc52f4ac09","text":"Building a wind turbine requires a very large amount of energy and materials, and wind turbines are expensive, inefficient, and kill birds and bats.","date":"2025-07-18 00:00:00+00:00"},{"id":"22cddca1-b8a5-487a-9a1d-e468a1090200","text":"Infection-induced immunity is by far the most robust immunity against COVID-19.","date":"2021-10-19 00:00:00+00:00"},{"id":"4c7b40f2-2b81-4a1a-b5cf-5c2a0da3733e","text":"The Mriya transport plane wreckage was disposed of.","date":"2022-05-28 12:25:00"},{"id":"7dd0ad39-1c10-4dde-b71b-8e7fc0ead843","text":"NATO is dissatisfied with the too-soft mobilization measures for Ukrainians abroad.","date":"2024-05-14 11:30:00"},{"id":"a90cf2b5-cc77-405a-83f2-ba43c67a3100","text":"The government has released plans to force everyone to receive a vaccine and three vaccines in U.S. Stage 3 trials will be ready in weeks.","date":"2020-04-10 00:00:00+00:00"},{"id":"e4116e8a-c10c-46d3-98cc-ee87429a5fd8","text":"VAERS reports in Florida rose 1,700% after COVID-19 vaccines became available, demonstrating that COVID-19 vaccines are unsafe.","date":"2023-02-15 00:00:00+00:00"},{"id":"f91205ea-2d89-4257-9aef-cc7efdc62003","text":"Federal study found marijuana is 100 times less toxic than alcohol and is safer than tobacco","date":"2018-12-20 00:00:00+00:00"},{"id":"efa402f0-22b5-44d8-83be-4aefe71ff19f","text":"American media claim Ukraine\'s government is a neo\u2011Nazi regime and is illegitimate.","date":"2017-09-05 15:26:58"},{"id":"1cc700fb-8ae3-4f9f-9bbf-2d20e10fe90c","text":"People are fined for planting potatoes","date":"2020-04-20 19:10:45"},{"id":"ba278d3a-b34f-4a39-b924-1c268c771e7d","text":"920 women lost their unborn babies after getting vaccinated.","date":"2021-11-06 00:00:00+00:00"},{"id":"b4b64a7f-18d5-4109-8ab5-2151c1eb53e0","text":"Ukraine will replace Victory Day with Europe Day.","date":"2019-02-23 09:09:38"},{"id":"7e2549b0-4be4-4af1-a07d-178f191ff255","text":"Not living at an officially registered residence in Ukraine is punishable by law.","date":"2016-04-29 20:25:05"},{"id":"6ff33f56-8167-4fb4-a217-9e2fd0587ed6","text":"Fungi cause cancer.","date":"2024-04-30 00:00:00+00:00"},{"id":"e4e4f22e-742d-4857-ac91-0adeb6cc7a75","text":"Lavrov says Odesa and Mykolaiv were created by Russian people.","date":"2025-12-11 00:00:00+00:00"},{"id":"2a6bc326-3688-4af4-a70b-a9128cad92ee","text":"Kyiv and Washington are dividing Ukraine.","date":"2015-08-18 19:30:18"},{"id":"628d2d95-6e88-45ac-9fba-404f17e734d5","text":"Vaccinated individuals have higher rates of COVID-19 infection and more musculoskeletal problems than unvaccinated individuals.","date":"2025-02-25 00:00:00+00:00"},{"id":"d37b5b73-be79-4707-93d6-b1619e360bd7","text":"A spontaneous memorial was erected on the Tisza River for men who died while attempting to cross the border.","date":"2024-05-29 11:58:33"},{"id":"9e9314e2-b3b4-4bb0-bbb6-80e2a791d407","text":"The Maldives are not threatened by climate change","date":"2025-03-09 00:00:00+00:00"},{"id":"6de9b109-7d60-4dbd-b946-2f2c248e99ab","text":"The U.S. CDC is lowering the PCR cycle threshold (Ct) for tests of suspected vaccine breakthrough infections to reduce the number of officially recorded COVID-19 cases.","date":"2021-05-27 00:00:00+00:00"},{"id":"f2dd708b-da06-4d95-80e8-dccc8a2c283c","text":"US intelligence found reasons to pursue regime change in Ukraine.","date":"2018-02-17 15:00:43"},{"id":"da22d1f6-dbbe-49e7-89e8-194fddf2bee9","text":"Climate change is not new and is not caused by humans.","date":"2020-01-02 00:00:00+00:00"},{"id":"dfa79aab-78cc-4f1d-a545-ffcbdadc9fd2","text":"Abortions are never medically necessary","date":"2019-08-09 00:00:00+00:00"},{"id":"02712107-dcf0-4356-96ab-4e5cc05a1d3f","text":"Lviv graduates were given ribbons depicting a map of Ukraine that excludes Crimea.","date":"2024-06-03 12:56:00"},{"id":"d6bd9722-09de-4f4d-ab20-04a79de1c458","text":"Amish communities have herd immunity because everyone already had COVID, so vaccines are unnecessary.","date":"2021-10-13 00:00:00+00:00"},{"id":"d1a5138e-9a0e-41e7-9b59-b1ed6f92f735","text":"Massive demonstrations across Europe are supporting Donbas.","date":"2017-03-11 21:57:14"},{"id":"d244e0c8-2ef0-4e93-ab92-9c12d8a1b325","text":"Ukraine will suffer an economic disaster.","date":"2018-06-27 09:39:14"},{"id":"86ce935c-a686-4874-b90f-73593cf768d2","text":"Ukraine admitted foreign mercenaries left Ukraine to fight in the war in Israel.","date":"2023-10-17 11:03:00"},{"id":"7c99c381-d341-4d06-986c-97983ad65b7d","text":"No one has died of cancer or heart disease since the COVID-19 pandemic began.","date":"2021-08-30 00:00:00+00:00"},{"id":"d30faa66-0ea0-482d-ac2a-7fcfdc7697d2","text":"Vitamins C and D are now part of conventional SARS-CoV-2 treatment; very high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk.","date":"2020-04-02 00:00:00+00:00"},{"id":"49c51996-7793-4d11-83a8-f7fba16e94b6","text":"Romanian authorities prioritize evacuating Ukrainians from Gaza before evacuating Romanian citizens.","date":"2023-10-18 11:51:00"},{"id":"46eefdcc-9153-4231-98d5-1f11bb28bd1e","text":"Coronavirus does not exist.","date":"2020-03-25 00:00:00+00:00"},{"id":"e6f87d0a-58ad-4a72-a8cb-9808b8bfb5ff","text":"A video shows a Russian Oreshnik missile used in an attack on Dnipro.","date":"2024-11-21 00:00:00+00:00"},{"id":"427dc044-8015-40ea-bc8e-7ba7b8003ea8","text":"Hurricane Milton is a targeted geo-engineered storm, and hurricanes never develop in the western Gulf of Mexico and always head straight east to Florida.","date":"2024-10-07 00:00:00+00:00"},{"id":"ab7deee3-6479-45e0-bbf4-5c661a4fe1fa","text":"Most people are infected with harmful parasites and need to regularly cleanse their bodies using pills, juices, seeds, or cleansers that detoxify the body and eliminate parasites.","date":"2024-06-11 00:00:00+00:00"},{"id":"bea9af0c-5656-4e03-9868-2e7e2295fa5c","text":"Ukraine will cut off gas supplies to Europe.","date":"2021-09-27 17:03:37"},{"id":"52fc8483-9863-472b-9ed3-98c00e449547","text":"Crimean self-defence units took over the parliament building, and a professional actor was used as a witness.","date":"2014-03-04 10:14:09"},{"id":"0f25cb03-35c2-40e8-b96a-ad0f42f18adb","text":"Robert Kiyosaki said financial aid to Ukraine is pointless.","date":"2024-02-12 10:01:00"},{"id":"baef1fc2-a432-4ab8-a4e7-d7111ce18e8f","text":"More than 10 million Ukrainians left Ukraine because Ukraine pursued a pro\u2011NATO course.","date":"2019-02-05 17:50:10"},{"id":"c7adce15-79ab-4154-9212-55f8be8b0a39","text":"Kurt Volker says Ukraine cannot regain Crimea and Donbas.","date":"2018-05-19 10:44:04"},{"id":"b69575c4-a47e-4678-a8c6-9757e605d896","text":"Uman Synagogue houses a Ukrainian nationalist military base.","date":"2022-03-31 09:39:07"},{"id":"b318e9f9-9a66-430c-92d3-7da39e592574","text":"HAARP experiments caused the May 2024 auroras.","date":"2024-05-11 00:00:00+00:00"},{"id":"af987d12-b231-4ec3-96e4-33aecad0ec38","text":"COVID-19 vaccines cause female sterilization by triggering an immune response against the placenta.","date":"2020-10-12 00:00:00+00:00"},{"id":"5fec1f94-3bb9-41d7-a93c-2d3f09830f11","text":"2016 was not a global temperature record.","date":"2017-01-27 00:00:00+00:00"},{"id":"48523f9c-4b23-4591-8c13-f194abb060cd","text":"A Turkish delegation arrived in Crimea.","date":"2016-11-25 22:21:04"},{"id":"9c1cd331-4595-471b-9ee7-95bb5b6787b6","text":"SSU Head Nalyvaychenko has a United States passport.","date":"2014-05-15 19:30:27"},{"id":"d950f456-f04c-4ae2-833f-3356da97c464","text":"EU countries are massively denying visas to Ukrainians.","date":"2016-01-30 13:02:48"},{"id":"236ca972-2169-4708-8479-769f3fde2bb3","text":"Relations between Russia and the West are deteriorating because of the war in Ukraine.","date":"2019-10-02 10:56:36"},{"id":"e71a3ce7-7f1e-43f3-8da6-a130a2789a80","text":"Natural immunity to COVID-19 is stronger and longer-lasting than immunity from COVID-19 vaccines.","date":"2021-07-17 00:00:00+00:00"},{"id":"9344c21f-e46e-492f-bab2-16d7ac5170ec","text":"A Lancet study shows vaccinated people have lower immune function than unvaccinated people and that COVID-19 vaccines suppress the immune system.","date":"2022-07-28 00:00:00+00:00"},{"id":"18c57d84-5c5e-4cb2-ab99-543cf4ad5dd6","text":"More children will die from the COVID-19 vaccine than from COVID-19, and there is proof.","date":"2021-11-26 00:00:00+00:00"},{"id":"8d553264-2775-4b89-bf31-4e2cde806720","text":"Photo shows a Polish military order to attack Ukraine.","date":"2022-05-04 19:19:00"},{"id":"ef58cdc4-b176-42c5-8d1d-6accb948d1b9","text":"COVID-19 is not dangerous.","date":"2020-03-29 15:06:00"},{"id":"a0f1ab21-1861-4603-9fe3-8d7c1490bbf6","text":"Wind turbine disposal creates a large environmental footprint.","date":"2022-11-03 00:00:00+00:00"},{"id":"14f6527d-67cc-4960-8e60-bf244deff220","text":"Covid-19 vaccination in pregnancy provides no benefit and causes higher rates of neonatal and all-cause readmissions among babies born to vaccinated mothers.","date":"2023-10-11 00:00:00+00:00"},{"id":"0ecf2a39-3371-4e9e-a01e-590af98a1838","text":"Consuming turpentine kills parasites","date":"2022-09-01 00:00:00+00:00"},{"id":"3c84cd9f-a0b5-44a8-9e90-7b1c22667bf1","text":"A review found that COVID-19 mRNA vaccines aid cancer development.","date":"2024-04-16 00:00:00+00:00"},{"id":"793a15d3-c559-4807-84a5-df29842c117f","text":"Wagner Group destroyed a Leopard tank and killed its Polish-German crew.","date":"2023-03-01 11:13:13"},{"id":"ad2ec165-9afb-4dce-a0b6-657061bdadf9","text":"CO2 is a plant nutrient and is not a pollutant that threatens human civilization; installing CO2 generators in greenhouses does not kill plants.","date":"2013-06-22 00:00:00+00:00"},{"id":"99c6fb0c-60a6-423b-a576-f2c16489097e","text":"Ukraine and Western countries are preparing terrorist attacks in Crimea.","date":"2023-01-30 12:32:00"},{"id":"0f8d6861-6faa-489c-9dc2-42f3b063e07c","text":"The 1986 National Childhood Vaccine Injury Act prevents people from suing vaccine manufacturers for injuries or deaths caused by vaccines.","date":"2020-12-15 00:00:00+00:00"},{"id":"e83d8224-5059-4b16-9c3d-c34ba2eea3df","text":"Sunscreen causes skin cancer and reduces vitamin D production, and wearing sunglasses increases the risk of sunburn.","date":"2024-07-19 00:00:00+00:00"},{"id":"90c5896e-279d-42dd-84f9-ee6335fea90f","text":"Separatists obtained military hardware as spoils of war.","date":"2017-08-10 07:20:01"},{"id":"1136e8fd-88de-4185-8a62-33c192bed1b7","text":"The Great Barrier Reef currently has record-high levels of coral and is not threatened by climate change.","date":"2021-08-21 00:00:00+00:00"},{"id":"e52c46e8-b089-4f2e-aa03-838e33557d82","text":"A pro-mask study was withdrawn after researchers found virus spread in the analyzed counties; masks do not work.","date":"2020-11-18 00:00:00+00:00"},{"id":"0465fe3c-5a98-41aa-9475-7b4af42b25aa","text":"The UN confirmed that Russian intelligence agencies were behind the Odessa House of Trade Unions tragedy.","date":"2014-06-21 07:29:23"},{"id":"e39e34ca-5c88-4450-80b0-ff376e57f4a9","text":"Vaccinated and boosted people were more likely to be hospitalized with the Omicron variant than unvaccinated people.","date":"2023-09-13 00:00:00+00:00"},{"id":"65750d96-8d7d-46b0-baba-dc7162a0fa10","text":"Global warming saves 166,000 lives each year; reported increases in heat-related deaths are caused by population growth and aging, not by climate change.","date":"2021-09-04 00:00:00+00:00"},{"id":"61a29cad-2475-4939-bba5-941c823aaa57","text":"Ukraine is blackmailing the West by using EU membership as leverage.","date":"2017-07-20 20:04:56"},{"id":"9636465b-c7ed-464d-bcaa-cf1340df799b","text":"Ukraine canceled a 15 million hryvnia payment to the families of fallen soldiers.","date":"2022-08-28 14:16:09"},{"id":"4d465014-a97e-4e1f-97c5-c64103818a8f","text":"Ukraine gives half of its national budget to Western creditors.","date":"2020-06-18 08:04:04"},{"id":"67ecfa74-b6ed-41ce-b5a3-a2bcb926302a","text":"A German restaurant\'s advertisement urges customers to stop talking about Ukraine.","date":"2023-09-21 15:46:00"},{"id":"148a00ff-6a57-4d0c-a6ad-c35238e59683","text":"Ukraine is preparing to carry out a chemical attack near Odesa.","date":"2022-04-27 16:21:37"},{"id":"d12d23f4-cc6b-44bd-8ae1-8a0ce222ac50","text":"Queensland Health researchers found that long COVID does not exist.","date":"2024-03-22 00:00:00+00:00"},{"id":"366db116-0531-410e-98dc-2cd7e903c0ac","text":"The EU will impose retaliatory sanctions against the US.","date":"2017-07-29 10:15:47"},{"id":"2b8221a1-aa2e-4f59-a240-e1dc88d12ec7","text":"UNICEF accuses Kyiv of committing aggression against Donetsk and Luhansk.","date":"2016-02-23 15:35:29"},{"id":"1cb98ff2-9204-46ef-aea3-ac3cb341560b","text":"A new medicine normalizes blood sugar levels after the first use.","date":"2023-07-11 00:00:00+00:00"},{"id":"5f32d335-0db0-4fb5-8d1e-89884723fc6e","text":"Italians asked Vladimir Putin to save the world.","date":"2015-06-12 18:39:51"},{"id":"3386479a-ceca-414d-8f19-b6fc28b90bc9","text":"There is no factual evidence for global warming; scientists do not know whether CO2, solar activity, or natural variability cause it.","date":"2021-04-16 00:00:00+00:00"},{"id":"a9bc90da-6884-4eb7-a0ba-5cc5a970baca","text":"Coughing repeatedly and very vigorously helps people who are experiencing a heart attack.","date":"2021-03-30 00:00:00+00:00"},{"id":"57ae861c-706d-4491-b16c-de1ddf59f0b0","text":"Doctors in Donetsk refused to treat a wounded Ukrainian soldier.","date":"2015-07-23 17:56:43"},{"id":"bd89072d-c992-4588-90d6-5b903ad308c1","text":"Scientists adjusted sea level data to create a false impression that oceans are rising.","date":"2019-05-28 00:00:00+00:00"},{"id":"b66910e5-daae-4814-957b-1bf57d03d2d3","text":"NATO\'s nuclear drills are causing a world war.","date":"2022-10-17 15:19:09"},{"id":"93046fd1-58f7-4e4d-ba19-9705a7d94046","text":"Unvaccinated people infect vaccinated people with the same virus the vaccinated were vaccinated against.","date":"2021-07-07 00:00:00+00:00"},{"id":"2c6d6c0c-581c-4afe-a3a8-fea66abbc95f","text":"A quarter of U.S. COVID-19 deaths were preventable with vaccination.","date":"2022-10-28 00:00:00+00:00"},{"id":"e0a5f231-75c6-437e-9eb2-f531cff87bb7","text":"Solar cycles and natural variations in solar and Earth activity cause climate change, and anthropogenic CO2 emissions do not cause climate change.","date":"2023-09-18 00:00:00+00:00"},{"id":"cedf273d-4281-489e-99a5-ba6e65e45127","text":"Kateryna Prokopenko is an influential German politician.","date":"2023-04-15 15:28:46"},{"id":"298d1707-0fd3-4201-8a1e-4560d6ff3fa8","text":"Pfizer admitted that vaccinated people can shed the vaccine onto unvaccinated people.","date":"2023-03-31 00:00:00+00:00"},{"id":"52975b9d-d2e7-4174-ab1a-5fc71f2f29fc","text":"HAARP caused the October 2024 auroras.","date":"2024-10-11 00:00:00+00:00"},{"id":"d5244cf2-bd56-4f1e-b7cd-8275b06653ff","text":"Donbas residents are being forcibly resettled to Lviv for reeducation.","date":"2019-11-23 23:45:29"},{"id":"3ecb35d7-1dbb-4da7-af32-d8663dffc64d","text":"COVID-19 vaccines caused 26.6 million injuries and 1.36 million disabilities in 2022 and cost the economy billions of dollars.","date":"2023-03-28 00:00:00+00:00"},{"id":"1cb65bfb-8150-4bfd-9987-88ff145e66b5","text":"Svoboda political party designed a banknote depicting Adolf Hitler.","date":"2015-03-03 11:36:37"},{"id":"381647b0-5e40-44f4-bd33-12838044198c","text":"Authorities in Barcelona removed children from a Russian woman because of anti-Russian bias.","date":"2022-07-29 19:12:12"},{"id":"aec47440-0cf6-4af2-9a55-32c0280b3e20","text":"U.S. doctors found that long COVID developed in 70 percent of cases after vaccination rather than after infection.","date":"2024-03-15 00:00:00+00:00"},{"id":"adfd4ae7-4210-4c62-bfa0-6781d45bcc59","text":"Three Ukrainians were detained in Israel for looting.","date":"2023-10-13 11:00:00"},{"id":"15a4d950-ede9-4236-99cb-d4ddfab73b99","text":"Ukrainian Greek Catholics are exempt from mobilization.","date":"2024-02-06 10:01:00"},{"id":"fd40bdd0-c6cc-4711-b6da-f6636f70fdb8","text":"Jihadists participated in the Crimean Tatar World Congress.","date":"2016-01-18 22:46:25"},{"id":"350999e3-219f-4b31-962c-d52e4f548e1b","text":"Lithuania teaches war to Ukrainian children.","date":"2019-08-27 10:13:22"},{"id":"3f2abbd2-060e-4ad7-b5a8-a84b9511e597","text":"Ukraine opposes medals commemorating the 75th anniversary of Victory over Nazism.","date":"2020-12-10 09:30:11"},{"id":"7d9aec94-20fe-4c75-9332-62af6797dc14","text":"Kyiv ignored the Minsk Protocol meeting.","date":"2018-09-21 16:52:23"},{"id":"db528ec0-3250-402d-a8d8-f12011ce042d","text":"Kyiv City Council proposed a complete ban on the Russian language.","date":"2016-03-22 23:11:33"},{"id":"6d0a63d8-61a9-4d2d-aea6-4e60a12d2dea","text":"Most cases of Alzheimer\'s disease are preventable, Alzheimer\'s disease is not genetic, and Alzheimer\'s disease is type 3 diabetes (insulin resistance of the brain).","date":"2022-09-29 00:00:00+00:00"},{"id":"6004ac54-d4df-49b3-a497-d03e67091a98","text":"Global temperatures are rising two to three times more slowly than climate models predicted.","date":"2017-04-22 00:00:00+00:00"},{"id":"da5d347b-5fb3-4187-bbba-c8b354ad6ff2","text":"Foreign mercenaries serving in the National Guard are filming the atrocities they commit.","date":"2014-10-11 17:38:08"},{"id":"3e3f1040-d2fa-4f56-a06a-86ea44e3b71b","text":"Magnetic pole reversals cause the Earth to flip vertically and stop rotating for six days, causing cataclysmic events.","date":"2023-01-18 00:00:00+00:00"},{"id":"e3155177-7923-4bed-b420-8405a93cc93d","text":"Ukraine\'s autumn recruitment efforts failed.","date":"2017-12-14 00:46:13"},{"id":"07988081-937a-46fe-bd74-5dbb0846b25d","text":"Pfizer\'s data show COVID-19 vaccines are unsafe for pregnant women.","date":"2023-04-19 00:00:00+00:00"},{"id":"9843893d-6690-400b-ba52-b3d060a45f1e","text":"People vaccinated against COVID-19 are more likely to be hospitalized than unvaccinated people.","date":"2023-06-23 00:00:00+00:00"},{"id":"2b000b50-a42a-47c1-9d45-30baf3b84d49","text":"Fighter jets drew a star over Alaska to honor Vladimir Putin.","date":"2025-08-17 00:00:00+00:00"},{"id":"b35919e0-29c5-4cec-8c70-bbdaa9d266d4","text":"Crimeans who left the peninsula after Russia annexed it are returning to Crimea.","date":"2018-08-03 10:33:30"},{"id":"e1c039f7-5ea9-4d63-a8b8-4f2855a5116e","text":"There are plans to blow up the Luhansk-area railway overpass to disrupt evacuations to Russia.","date":"2022-02-20 22:21:29"},{"id":"1278c551-390c-4f62-98a2-54de97930a3b","text":"The LifeNews journalist ordered separatists to open fire.","date":"2014-05-25 10:18:03"},{"id":"027e4c0a-e0ed-4794-9444-00c62128252f","text":"The United States officially recognized Donbas as an independent state.","date":"2015-09-16 10:26:12"},{"id":"a204bf60-6b27-4a6a-961c-8a95940917d9","text":"One Mt. Etna eruption released more than 10,000 times the CO2 emitted by all humans in history.","date":"2019-08-19 00:00:00+00:00"},{"id":"1107377d-31cc-4177-abee-f8997c059202","text":"More children will die from COVID-19 vaccines than from COVID-19.","date":"2021-11-01 00:00:00+00:00"},{"id":"b11958aa-8fd4-4167-bad2-bb15154530cd","text":"Australian temperatures increased by 0.3\xb0C over the past century, not 1\xb0C.","date":"2017-11-10 00:00:00+00:00"},{"id":"9ea310a4-45b5-4541-a5ba-50c286d295be","text":"Zelensky ordered schools and universities to work offline starting September 1.","date":"2022-08-22 11:21:00"},{"id":"eb6f8055-76c8-4f43-ad76-682bcd9695bd","text":"The World Bank website shows that countries purchased COVID-19 test kits in 2017 and 2018.","date":"2020-09-05 00:00:00+00:00"},{"id":"5632a5f8-a908-440e-af68-fffdfc0964ce","text":"Pro-Russian banners with the Russian flag appeared on Ukrainian streets.","date":"2025-08-22 00:00:00+00:00"},{"id":"caa550e6-f9b4-4fbf-816f-cf2925782cd9","text":"Ukraine formed a military alliance with the United States.","date":"2014-07-31 18:19:03"},{"id":"5ea053a7-6ad0-4f32-b78e-4ce50ee30540","text":"SARS-CoV-2 is spreading quickly from gas pumps and from shopping carts.","date":"2020-03-26 00:00:00+00:00"},{"id":"b1f832ca-8dcf-4377-8681-55076f981d74","text":"Giving water to babies under six months causes serious health risks.","date":"2024-06-13 00:00:00+00:00"},{"id":"01d989e5-2d84-4128-896a-c4bd413bca98","text":"Bill Gates said genetically modified organisms are injected directly into children\'s arms and into their veins.","date":"2021-03-26 00:00:00+00:00"},{"id":"6fe94112-1374-43cc-82b2-2247c364b004","text":"19% of American children have ADHD and 0.5% of French children have ADHD.","date":"2019-10-14 00:00:00+00:00"},{"id":"5f516e9d-dbaf-4874-9212-04e63b2c7ed0","text":"Sweden banned mandatory vaccinations because of serious health concerns.","date":"2019-08-23 00:00:00+00:00"},{"id":"ba09747b-f0b6-4dbd-b0a6-470d389066fe","text":"COVID-19 vaccines are experimental and ineffective; natural immunity is superior to vaccine-induced immunity; vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes prior vaccination.","date":"2021-12-31 00:00:00+00:00"},{"id":"4f921cf8-8650-4d52-9ea8-4ce66ff4aaa7","text":"Ukraine will imprison residents of Crimea and other occupied Ukrainian territories who hold Russian passports.","date":"2021-12-08 20:25:22"},{"id":"13a60e49-831f-4ce3-b846-219ccc7e8def","text":"COVID-19 vaccines contain luciferase to tag and track people.","date":"2021-11-04 00:00:00+00:00"},{"id":"c2cedeb5-1b3a-4ad1-9e16-aff80d97d2c4","text":"Electric vehicles are highly prone to catching fire.","date":"2025-06-06 00:00:00+00:00"},{"id":"789c1f08-91d2-46b6-a5e1-6efb269f7290","text":"Half of the 0.9\xb0C of global warming is caused by greenhouse gases.","date":"2018-10-21 00:00:00+00:00"},{"id":"a3f50eaa-34ee-491d-893a-65e72e4e3030","text":"The Ministry of Defense does not receive any images from the ICEYE satellite.","date":"2025-10-07 00:00:00+00:00"},{"id":"92c70728-8a84-4c64-a3bb-73a55eb2027a","text":"Wilhelm Reich invented a cure for cancer.","date":"2022-05-27 00:00:00+00:00"},{"id":"54911bf9-a56d-41b9-9a2c-a90b0f8ff629","text":"Ukraine\'s National Corps developed an atomic bomb to use against Russians.","date":"2022-02-04 18:29:20"},{"id":"c226c7d3-8328-4f02-8fb0-ed3d0a775a6d","text":"The United Nations is dissatisfied with Western tanks sent to Ukraine.","date":"2023-01-29 16:55:00"},{"id":"cd1bcd26-ed9e-4f8a-a582-7a3ef528fe8c","text":"COVID-19 infection and COVID-19 vaccination cause HIV tests to turn positive and cause immunodeficiency.","date":"2024-01-30 00:00:00+00:00"},{"id":"5aeb6899-996b-4917-877b-404a648405a9","text":"A Turkish ship transported military equipment from Bulgaria to Ukraine.","date":"2016-02-11 12:45:10"},{"id":"476a39ea-cc28-4fd5-b04d-d950bf6daaba","text":"Diet and lifestyle changes, instead of chemotherapy or radiation, cause spontaneous remission of cancer.","date":"2024-06-13 00:00:00+00:00"},{"id":"5cd436e7-5e8f-4fdd-844d-6a1feade2672","text":"The SARS virus has circulated since 2003 and recurs every three to four years, so everyone in the world is immune.","date":"2020-05-14 00:00:00+00:00"},{"id":"1feaa18c-a348-4318-9eea-bfa6da8247cc","text":"Ukraine distributed counterfeit banknotes contaminated with tuberculosis in occupied Donbas.","date":"2022-05-17 11:37:00"},{"id":"d78af013-bc42-4660-b56a-e505039c4243","text":"COVID-19 has a 99.991% survival rate, so vaccines are unnecessary because vaccines were developed only for deadly diseases like smallpox that had no treatments.","date":"2021-04-02 00:00:00+00:00"},{"id":"52f5053c-34f5-43b5-adb6-de2278fbba70","text":"Kyiv increased electricity prices to fund hosting the Eurovision Song Contest.","date":"2017-02-20 23:21:19"},{"id":"bca440e6-ccd3-48a9-9ea8-b8eae07dbc71","text":"The Ukrainian government refuses to finance Kharkiv, and Kyiv has resigned itself to Russia\u2019s occupation of Kharkiv.","date":"2022-04-11 17:51:23"},{"id":"59345576-3c99-4f85-9c22-cb7f2ee69987","text":"COVID-19 vaccines have killed millions of people worldwide, at a rate of one death per 1,000 doses.","date":"2023-08-12 00:00:00+00:00"},{"id":"8c8ca322-1ed3-4f34-ad77-733d428cd6a3","text":"The Ukrainian military bombed Snizhne.","date":"2020-09-19 09:45:00"},{"id":"d4310cbd-b465-4be0-904c-ddd4775a9508","text":"COVID-19 and COVID-19 vaccines are causing a global epidemic of terrifyingly aggressive cancers.","date":"2025-03-26 00:00:00+00:00"},{"id":"ddfbf23e-6ad9-4461-9171-4d97b7c80f0a","text":"Humans caused the Texas floods using cloud seeding, and the floods would not have occurred otherwise.","date":"2025-07-06 00:00:00+00:00"},{"id":"4e689837-4d10-45d5-81a1-62d56468abc3","text":"In 2009, 50% of Ukrainian citizens wanted to hold Russian citizenship.","date":"2025-06-10 00:00:00+00:00"},{"id":"34069537-f1d4-4ac0-b377-fd2fd3a315de","text":"The Kadyrov Foundation repaired an abandoned hospital in Rubizhne.","date":"2022-05-18 14:59:14"},{"id":"6684e8c5-fb5f-4d58-93c0-7b7920bafabe","text":"The U.S. Climate Reference Network finds there has been no warming in the United States for at least the past 14 years.","date":"2019-06-09 00:00:00+00:00"},{"id":"e7ca5d87-eb91-438b-8987-7d1c73be5b0f","text":"A new language law prohibits the use of any language other than Ukrainian.","date":"2019-03-22 14:35:01"},{"id":"9e551c2b-9a5a-4862-9f0f-273c0b484cad","text":"The Netherlands says Ukraine lied about a downed Boeing-777.","date":"2014-07-30 00:38:01"},{"id":"dcc1afda-2113-499e-97e2-4c33cb4d20ac","text":"Ukraine will stop gas transit in 2021","date":"2020-04-17 20:44:10"},{"id":"d82c2aff-afb9-4f24-aebc-bca6be31b865","text":"Polar bear populations are increasing and polar bears are thriving despite diminishing sea ice.","date":"2020-05-05 00:00:00+00:00"},{"id":"7ba82044-6885-45eb-ade4-041b922dc24a","text":"The Ukrainian Ministry funds radical nationalist organizations.","date":"2018-11-16 20:59:42"},{"id":"f12e9165-d5cf-46fe-8144-3a54d7ebdfd8","text":"The atmosphere is less sensitive to CO2 than climate models forecast.","date":"2017-11-29 00:00:00+00:00"},{"id":"9cba1fb6-7b09-4002-a021-c674684b00b4","text":"Ukraine is a drug entry point for Russia and Europe.","date":"2018-12-07 12:26:08"},{"id":"eadbb245-11fd-4603-acc4-b3d1ed7503e7","text":"Margarine is chemically only one molecule different from plastic.","date":"2024-11-27 00:00:00+00:00"},{"id":"04fed4bc-0a1c-4f79-ab8b-9dff75e1254f","text":"Patent US5676977A is for AIDS, patent US8835624B1 is for H1N1, and patents US7897744B2 and US8506968B2 are for SARS.","date":"2024-08-01 00:00:00+00:00"},{"id":"626c2407-8a4a-41e4-a847-e1a640dd970b","text":"Unadjusted temperature data show Australian temperatures increased by 0.3\xb0C over the past century, not by 1.0\xb0C.","date":"2017-10-09 00:00:00+00:00"},{"id":"a50bbbf2-704e-41b4-be4b-727c9b13dfe6","text":"Big Pharma murdered doctors to protect its profits and to silence holistic health practitioners.","date":"2023-08-23 00:00:00+00:00"},{"id":"763b4c59-9a19-4c6b-b298-ced52db844c1","text":"Ukraine has implemented juvenile justice.","date":"2014-04-25 00:51:28"},{"id":"5565423b-d1c5-4760-a05d-88362c28d64d","text":"mRNA COVID-19 vaccines do more harm than good.","date":"2022-06-10 00:00:00+00:00"},{"id":"7e91a24e-bb1d-4942-b158-6561c268f135","text":"The cow feed additive Bovaer is unsafe and makes milk unfit for human consumption.","date":"2024-12-03 00:00:00+00:00"},{"id":"3e3a0ce3-9d32-4d33-9476-196214c4158c","text":"Lviv officials urged that Crimea and Donbas be recognized as territories of Russia.","date":"2015-05-08 09:43:25"},{"id":"0d4df62b-b694-4ca9-9337-0c8818b221ff","text":"A peer-reviewed study found ivermectin reduces COVID-19 death risk by 92%, and the NIH lists ivermectin as a COVID-19 therapy.","date":"2022-07-09 00:00:00+00:00"},{"id":"8dc2dc12-4483-4e22-bfba-f8c668631bf0","text":"Ukraine cannot guarantee the security of its nuclear power plants without NATO.","date":"2017-10-28 07:48:30"},{"id":"1e0dd477-2919-414b-956e-29f90a306828","text":"The Moderna COVID-19 vaccine caused heart damage in 1 in 35 people and is a kill shot.","date":"2023-08-08 00:00:00+00:00"},{"id":"96e78690-52ca-41bf-bace-4b4e15b86c84","text":"The CDC says COVID-19 vaccination increases the likelihood of infection with the BA.2.86 variant.","date":"2023-08-29 00:00:00+00:00"},{"id":"8c41652b-8e1e-4f0a-bc4e-03efedd1a9f6","text":"Chrystia Freeland is an adviser to Ukrainian president Volodymyr Zelensky and is a descendant of a Nazi collaborator.","date":"2026-01-05 00:00:00+00:00"},{"id":"da7775bf-58ca-49c7-a7d1-cffa7bccb3d2","text":"Ukrainian businesses are planning mass redundancies","date":"2020-02-08 15:34:43"},{"id":"88a9b2a2-df3c-4e15-b439-11ecdb30f599","text":"Human CO2 emissions do not drive recent climate change; solar activity and natural climate cycles drive most recent climate change.","date":"2022-03-16 00:00:00+00:00"},{"id":"b1d44d03-5ef9-4f9e-94eb-bd0d9585bf1f","text":"COVID-19 vaccines are dangerous for children; they cause myocarditis and bypass children\'s innate immunity that protects them from COVID-19.","date":"2023-03-28 00:00:00+00:00"},{"id":"6eada5c0-5e43-4d39-b534-e8c542c0d607","text":"The Ukrainian government forced schoolchildren to study in shelters as a PR stunt.","date":"2023-11-29 12:35:00"},{"id":"456955f3-fe8b-4164-8641-3c65f3983fbd","text":"Trump sent National Guard troops to Alaska in response to Ukrainian protests.","date":"2025-08-14 00:00:00+00:00"},{"id":"dbe8856b-d464-4609-9e4b-30a8db6cc332","text":"The FDA says Pfizer\'s COVID-19 vaccine causes blood clotting.","date":"2022-12-23 00:00:00+00:00"},{"id":"80ea9af8-8a68-4a19-ab6f-12c7ca5127a2","text":"Ukrainians in Poland are slaves.","date":"2018-08-15 19:00:02"},{"id":"febc22fd-b63e-4d33-8e8b-7830675da69f","text":"Ukrainian Prime Minister was hospitalized after a nervous breakdown","date":"2015-07-31 14:28:44"},{"id":"7d7b06cf-63d6-4416-a5a1-d200e94b5a97","text":"A Ukrainian missile destroyed an apartment building in Kyiv.","date":"2022-02-27 23:03:49"},{"id":"db3f6d14-a291-4aac-a1cd-cc354f4928bb","text":"Climate models systematically overestimate climate sensitivity to CO2, and modelers exclude forcings and feedbacks that contradict that overestimate.","date":"2016-01-01 00:00:00+00:00"},{"id":"9880f810-d4a7-41fc-9722-9ddf250ed653","text":"Elections in Donbas are controlled by armed Ukrainian punishers.","date":"2019-04-21 14:04:14"},{"id":"c632fe7b-c702-4532-8547-784867df7f95","text":"Countries with high mask compliance and mask mandates experienced increased COVID-19 death rates and performed no better than countries with low mask usage.","date":"2022-11-06 00:00:00+00:00"},{"id":"fb14b1c9-f797-411b-8b61-6c98d77e78be","text":"Lviv displayed a swastika during City Day celebrations.","date":"2016-02-18 16:04:12"},{"id":"82cf28c0-d675-4d81-b3a2-2c3ce4de4179","text":"An air raid siren was intentionally sounded during U.S. President Joe Biden\'s visit to Kyiv.","date":"2023-03-01 08:23:00"},{"id":"2c2fbc2c-4fb0-4048-b456-d2641031574f","text":"The IMF and Kyiv failed to reach an agreement on Ukraine aid.","date":"2018-02-24 20:00:50"},{"id":"5b6894f8-ea15-4af7-a6fc-9b6dc7515b6c","text":"Sanctions on Russia are destroying Ukraine\'s economy.","date":"2016-10-21 18:47:35"},{"id":"c76b961e-fec1-4e74-8f71-d053b8c1967a","text":"A Ukrainian minister urges banning Russian and Belarusian tennis players from winning matches against Ukrainian players.","date":"2023-04-15 10:18:07"},{"id":"bf52ac2c-e546-41f8-8dc2-c30eda90de58","text":"Pfizer released a list stating the Pfizer\u2013BioNTech COVID-19 vaccine causes more than forty specific medical side effects.","date":"2025-01-02 00:00:00+00:00"},{"id":"a261d10d-a831-4a54-83da-f0ffee4c073e","text":"Said the Ukrainian parliamentary speaker is a neo\u2011Nazi and an anti\u2011Semite.","date":"2018-06-14 12:22:41"},{"id":"c8c3633b-35c1-4db0-bae8-d6cbc4f54521","text":"Ukrainian flags were banned at a refugee center in Spain.","date":"2022-08-10 15:41:12"},{"id":"ee04ccaa-9e1e-40d6-bc45-0779559baad7","text":"No hurricanes occurred this season despite forecasts for high activity; this proves climate change theory is wrong and the season was a light hurricane season.","date":"2024-09-09 00:00:00+00:00"},{"id":"6aa78773-444f-4637-ab92-a135889b401f","text":"More than 500 scientists and professionals told the U.N. there is no climate emergency.","date":"2019-10-30 00:00:00+00:00"},{"id":"10b0216f-8bdd-4289-b76a-7acbcdf1e105","text":"London apologized to Aeroflot for a UK Border Force search.","date":"2018-04-14 09:19:37"},{"id":"a565dbad-c465-41f8-ab11-beae94827d71","text":"StopTheEvolution has fought Russian propaganda in Ukraine for five years.","date":"2019-03-24 20:28:11"},{"id":"74c3de24-358f-46b6-8603-3b0cd61cf75e","text":"The Organization for the Prohibition of Chemical Weapons did not determine the origin of the nerve agent used in the Skripal poisoning.","date":"2018-04-12 17:02:54"},{"id":"9c0167dc-2624-4651-a063-941c0d8192e7","text":"The Ukrainian government will punish people who refuse to speak Ukrainian.","date":"2019-01-03 12:53:54"},{"id":"c10efc8e-2c04-412f-8a5e-1fdbcadb67d7","text":"A captured soldier erased a \\"Banderivets\\" tattoo.","date":"2015-02-14 12:20:49"},{"id":"66e6c0ae-2678-4700-9d11-18f5479528f3","text":"Rheinmetall\'s shares fell drastically after Ukraine\'s counteroffensive failed.","date":"2023-06-13 13:40:00"},{"id":"13d0543b-8f7c-4b3b-8217-7043d3174afc","text":"Ukraine\'s Foreign Ministry wants to make peace with Russia.","date":"2020-12-30 23:18:27"},{"id":"143e6559-fd81-4a95-a696-1296cc9459e1","text":"French President Fran\xe7ois Hollande regrets sanctions against Russia.","date":"2016-08-31 20:13:02"},{"id":"040f7830-6a65-4a38-8b85-a619adac6e6f","text":"More than 500 scientists and professionals sent a declaration to the United Nations stating there is no climate emergency.","date":"2019-09-24 00:00:00+00:00"},{"id":"4bea3e8c-e42b-49b3-a380-6f0df70085de","text":"Americans tested a coronavirus vaccine on Ukraine\'s military.","date":"2020-07-21 17:03:00"},{"id":"5d1abb46-c8d8-49fb-839d-b17a174ec4be","text":"COVID-19 case numbers are inflated because PCR tests are overly sensitive; 90% of positive COVID-19 PCR tests are false positives.","date":"2020-09-02 00:00:00+00:00"},{"id":"06adc002-27b6-4763-98b3-60bd7be27eff","text":"AIDS is spreading across Ukraine and originates in Donbas.","date":"2018-01-22 20:49:37"},{"id":"0cb3d75e-b02c-4bd2-9810-c0e6a1fc51b6","text":"Vaccines cause sudden infant death syndrome, and infant deaths fell dramatically during lockdowns because far fewer vaccines were administered.","date":"2020-07-17 00:00:00+00:00"},{"id":"93327c19-f8d6-4cdc-a139-dead675a14cb","text":"Ukraine\'s blockade of water to Crimea caused an environmental disaster.","date":"2019-06-21 11:18:32"},{"id":"b9b63002-39d8-4477-b533-c581d73fadcb","text":"Friends of Ukraine tore down Russian flags in Burgos, Spain.","date":"2016-03-09 13:21:22"},{"id":"34309c9a-8492-41d0-bf23-bfbb78f5e9e8","text":"A new oral spray deactivates 98% of the coronavirus in the mouth.","date":"2020-07-27 00:00:00+00:00"},{"id":"72b9d4c9-c3e9-4906-b371-0a4ebf5cadc1","text":"Pfizer CEO\'s wife died from complications of the COVID-19 vaccine.","date":"2021-11-15 00:00:00+00:00"},{"id":"5b47b59e-568a-4e23-86a9-e5681f041b5f","text":"Ukraine is the leading importer of agricultural products into Crimea.","date":"2020-10-22 20:47:13"},{"id":"fb9161f8-1e15-4476-8ce7-46aa19ef5010","text":"Ocean waters and the marine environment are the primary drivers of climate change.","date":"2017-06-20 00:00:00+00:00"},{"id":"36ecab96-07d2-4a35-9658-4f5c6d5c2ebe","text":"Bill Gates and health agencies are staging a new pandemic targeting children, which the WHO and the UK government say is already happening.","date":"2023-05-17 00:00:00+00:00"},{"id":"a1fada51-b45d-4d3c-8d3e-99b53f12db24","text":"Intravenous hydrogen peroxide enables the body to cure itself of all diseases.","date":"2023-04-26 00:00:00+00:00"},{"id":"111fda95-ceec-4a7a-a541-30cbc5c08475","text":"Russia\u2019s actions are justified by international law","date":"2014-03-11 21:37:06"},{"id":"4c349d8a-0de2-4065-995e-b97ba18a3cc0","text":"The European Union will force Ukraine to accept African refugees.","date":"2015-08-21 22:33:22"},{"id":"7061f9bc-a2c9-435d-8af9-d319c07d4cc2","text":"A Ukrainian MP proposed mass deportation of Crimeans.","date":"2016-05-21 13:10:07"},{"id":"69e4cb91-92b2-441c-9c45-09d100040619","text":"The Parliamentary Assembly of the Council of Europe approved a resolution abolishing political sanctions against Russia.","date":"2017-10-12 20:15:00"},{"id":"76a47284-daa0-43c3-9a5e-dadf15ea7166","text":"Volodymyr Zelensky bought Bill Cosby\'s New York townhouse for $30 million.","date":"2025-12-06 00:00:00+00:00"},{"id":"6ded1b12-376a-4451-8314-cf0630d9ad4b","text":"Poland refuses to admit Ukrainian refugees.","date":"2017-06-14 17:50:23"},{"id":"d0161276-0b14-45fc-83b7-284988ef9808","text":"COVID-19 is a type of flu and is not a pandemic; PCR tests have a 94% false positive rate; only 98 people died of COVID-19 in Ireland.","date":"2020-10-15 00:00:00+00:00"},{"id":"3646e827-9c28-481f-8a3c-14bf7f6ee1bb","text":"The US called on NATO countries to prepare for war with Russia and to deploy troops to Ukraine.","date":"2021-09-08 12:52:07"},{"id":"cf00a55a-5eca-43d0-8944-0a18bb229c40","text":"Ivermectin augments the effects of cancer therapies","date":"2024-06-29 00:00:00+00:00"},{"id":"b1f2e7d8-ccc3-4f08-bd0e-9f7c70793e5e","text":"The WHO declared a public health emergency to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus.","date":"2024-08-14 00:00:00+00:00"},{"id":"c4eaaabc-9564-4e1d-a74c-5c61095c6428","text":"AFU Brigade holds a rally and seizes control.","date":"2015-11-07 14:03:59"},{"id":"f9dd0eeb-eedd-4de8-87a3-03659e466189","text":"The dam blocking water to Crimea was blown up.","date":"2022-02-27 10:55:00"},{"id":"4a24d8e1-c038-41e2-a640-6c76d8c77f67","text":"Ukrainian forces shelled the UN mission office in Siverodonetsk.","date":"2022-10-05 18:23:00"},{"id":"ae1bb1a8-77ee-45bc-aa36-64fb591ff555","text":"Ukrainian refugees in Europe illegally tap power grids to mine cryptocurrency.","date":"2024-12-09 09:32:00"},{"id":"e8c891f1-9ad9-492d-8bc2-d8322a1bb704","text":"The climate has always changed and will always change.","date":"2020-01-21 00:00:00+00:00"},{"id":"78823ae4-0c2e-438c-8dff-ca140c879d1c","text":"All long-term tide gauge datasets show sea level rise has not accelerated.","date":"2020-03-08 00:00:00+00:00"},{"id":"092ab2d2-2c35-4984-a0ff-3385c6274188","text":"Tilapia contain high levels of omega-6 fatty acids that increase the risk of Alzheimer\u2019s disease.","date":"2019-04-14 00:00:00+00:00"},{"id":"ee7c22a9-cb5f-4b56-968c-6ff4e664ea5b","text":"A study showed Pfizer\u2019s COVID-19 vaccine weakened children\u2019s immune responses to other viruses.","date":"2023-08-30 00:00:00+00:00"},{"id":"cbf4a452-7652-4f82-bf67-0ee72a779846","text":"The West lost the Russian propaganda war.","date":"2016-05-21 13:05:03"},{"id":"56f44d3c-1882-468a-a39e-560f159b07a2","text":"The United States will not hand over Abrams tanks to Ukraine.","date":"2023-02-09 10:46:00"},{"id":"ae778ea3-ab1c-436e-83d2-b9abd6502a12","text":"A CDC report confirms that nearly 120,000 children and adolescents in the USA died suddenly by October 2022 as a result of COVID-19 vaccination.","date":"2023-01-17 00:00:00+00:00"},{"id":"4cee97a5-599d-461c-a5d3-ddb7b61c587a","text":"The Kyiv government admits Kyiv\'s smog was caused by low-grade coal.","date":"2017-01-31 19:10:24"},{"id":"82e47aee-7b6b-4936-a959-aa926002fb1a","text":"The EU ends visa-free travel for Ukrainians because of the Donbas war.","date":"2017-05-16 19:05:37"},{"id":"59af9f9a-2c5d-4de7-ad4d-ab2be9537271","text":"Cholera was found in the Azov Sea.","date":"2018-07-23 07:42:11"},{"id":"0b3c50fe-9aa2-4a22-85b4-5b1c52ce2eec","text":"There is a torture chamber in the Kharkiv area.","date":"2022-10-08 11:55:00"},{"id":"38fb016f-f70f-4b9f-883c-9653381f4f08","text":"A monument to Stepan Bandera in Lviv was torn down.","date":"2015-09-15 21:14:03"},{"id":"a76317c7-6638-441d-8afc-80e7f186b8cd","text":"Polar bear populations are increasing and are thriving despite diminishing sea ice.","date":"2020-05-18 00:00:00+00:00"},{"id":"e2b9e1e1-cd0f-4bea-b60b-2b3a10752ecf","text":"Doctors were murdered to protect Big Pharma profits and to silence holistic health practitioners.","date":"2023-07-04 00:00:00+00:00"},{"id":"4bdb1eae-1573-453a-a57b-0fef0cf1472c","text":"Official observed temperatures are consistently below global warming projections; melting polar ice causes an ice age.","date":"2021-05-27 00:00:00+00:00"},{"id":"fde1853f-3f82-49e0-8181-1fe237afda38","text":"Russian troops mined the Zaporizhzhia Nuclear Power Plant.","date":"2023-06-23 17:00:00"},{"id":"4bc88004-3c8c-4dd1-8eab-01da2f931d7d","text":"Ukraine\'s nuclear energy system has collapsed.","date":"2016-08-24 19:43:39"},{"id":"8c795228-b136-4584-a1ad-c731fa4c7164","text":"The Ukrainian government will fire all feldshers.","date":"2017-11-11 11:44:45"},{"id":"817546e0-c92b-45b2-b75c-ec6e8277d278","text":"The Johnson & Johnson vaccine contains aborted fetal retinal and kidney cells.","date":"2021-03-14 00:00:00+00:00"},{"id":"36608fb6-7bae-43ec-a85a-51c36eac5007","text":"Le Parisien reports an AIDS epidemic is sweeping through Ukraine\'s armed forces.","date":"2025-11-14 00:00:00+00:00"},{"id":"2392c3c4-f0d7-4741-8cee-c90dee84d1a7","text":"Roshen produces chocolate bars featuring Vladimir Putin.","date":"2016-01-12 18:04:50"},{"id":"253af419-5990-4696-aff9-7240a057ebf0","text":"Sean Penn refused to travel to Ukraine because of a corruption scandal.","date":"2025-11-19 00:00:00+00:00"},{"id":"b622741a-4170-49b3-9c00-2d16333e3e02","text":"Ukraine\'s military is preparing sabotage operations in Crimea.","date":"2018-10-16 11:46:44"},{"id":"5f053b98-cfbb-45e0-951c-1faf705854e7","text":"Non-vaccinated people are not tested, so the increase in COVID-19 cases is entirely caused by vaccinated people.","date":"2021-07-25 00:00:00+00:00"},{"id":"e7167790-1ca0-4758-83ef-cfaa7af0d4df","text":"A French journalist reported that Ukrainian forces bombed the Donbas.","date":"2022-03-04 12:24:13"},{"id":"5dad1ba3-bf1a-4fbd-9515-e7df10901647","text":"The EU called on Ukraine to lift its ban on Russian-language education.","date":"2018-12-18 14:00:38"},{"id":"36792a75-7b7d-4724-b998-1097cb1b9753","text":"Bulgaria invited Recep Tayyip Erdo\u011Fan instead of Vladimir Putin to the commemoration of Bulgaria\'s liberation from Ottoman rule.","date":"2016-03-05 13:19:59"},{"id":"6d6197d3-178a-4827-a9cd-fdca21a90695","text":"Human activity is not causing the observed increase in atmospheric carbon dioxide.","date":"2025-04-22 00:00:00+00:00"},{"id":"cf3568b6-586d-4e58-84d4-3ca7d32b7860","text":"A study found electric vehicles are considerably worse for the climate than diesel cars.","date":"2019-04-22 00:00:00+00:00"},{"id":"f7a962f1-0d5e-4e60-a1ab-4627c38edd62","text":"Ukraine\u2019s Presidential Administration does not know who founded Canada.","date":"2016-07-13 19:46:15"},{"id":"b56682ff-83eb-4170-ad31-c2232d6f06a0","text":"Ukrainian authorities are seizing cars from all Ukrainian citizens.","date":"2015-06-26 18:07:46"},{"id":"abec432b-4b97-461f-abc6-b475358b35a3","text":"Great Barrier Reef sea surface temperature has not changed in the past 150 years.","date":"2021-08-09 00:00:00+00:00"},{"id":"f453153e-e454-43f9-bd11-d5c7ad57e0e0","text":"A court ruled PCR COVID-19 tests are 97% inaccurate and unfit for purpose, and mainstream media did not report this.","date":"2024-05-06 00:00:00+00:00"},{"id":"177203bd-dbed-47b6-b095-908931f7ac38","text":"Mifepristone is unsafe and causes serious health harm.","date":"2023-01-04 00:00:00+00:00"},{"id":"7d250ec8-c856-41af-8374-190af4006461","text":"The EU will deport Ukrainians who mobilize for military service in Ukraine.","date":"2022-06-24 13:54:15"},{"id":"d73abf37-36d7-46b7-9f5f-4f684e8aae3c","text":"The Finance Ministry says Ukraine will face economic collapse without an IMF bailout.","date":"2016-08-26 08:15:25"},{"id":"dc8356c3-2a3a-4a60-a917-1d5d63aa5b8c","text":"A pizzeria removed a Nazi chevron and a photo of the burning Trade Unions House in Odesa from its wall before U.S. Secretary of State Antony Blinken arrived.","date":"2024-05-16 10:01:00"},{"id":"dd4daa0b-4a2e-4926-ae14-fbaf8a713160","text":"COVID-19 vaccines were not tested in animals or in humans before being released to the public and are unsafe.","date":"2021-05-18 00:00:00+00:00"},{"id":"1c63b173-4a48-4736-a466-44ebbe6903c8","text":"The EU has reinstated visa requirements for Georgia and will next impose visa requirements on Ukraine.","date":"2017-10-28 15:39:46"},{"id":"c9e8c139-5a8f-4e24-a65b-71191ef90c6b","text":"An Italian journalist says Ukrainians are fighting alongside ISIS.","date":"2016-02-17 22:07:56"},{"id":"16dd4b0f-e181-4766-9099-841c4684769f","text":"A US advertisement urges people not to financially support Israel and to instead financially support Ukraine.","date":"2023-10-16 10:23:00"},{"id":"619d380c-ec49-4a86-88da-0727e240b714","text":"Victoria Nuland did not demand that Ukraine implement the Minsk agreements.","date":"2016-03-16 12:56:36"},{"id":"22ae8bff-4d1e-440f-904e-57a100d2b74b","text":"Germany supports the annexation of Crimea.","date":"2018-11-08 21:25:11"},{"id":"35156c0f-4df8-4e6c-9d76-1c2aad0fde6b","text":"Ukrainians decorate Christmas trees with swastikas.","date":"2022-12-27 20:47:00"},{"id":"1f34b4f6-3429-4378-9c81-2d5bf161f570","text":"Ukrainians choose Russia because Kyiv committed atrocities.","date":"2022-08-06 11:54:00"},{"id":"c787c8f0-b90d-4334-a10f-2082b393b36e","text":"Ukrainian mobile operators charged residents of the Luhansk People\u2019s Republic for the antiterrorist operation.","date":"2015-06-15 17:39:55"},{"id":"942f639f-af20-4b2c-81b7-6dc2458b2a9a","text":"President Volodymyr Zelenskyy requested that foreign troops be deployed to Ukraine.","date":"2020-02-08 15:05:36"},{"id":"380629a1-e2b4-4cf7-b741-fff3c1754b5a","text":"Ukraine admits Ukrainian-made parts were used in North Korean missile engines.","date":"2018-04-02 10:46:49"},{"id":"aeeabafb-6f28-4525-a914-fdc35c3a9238","text":"A Ukrainian colonel proposed razing Donbas and Crimea.","date":"2017-04-19 19:22:30"},{"id":"602a284b-62dd-4480-a4ed-2f81e13007e2","text":"Babies must not drink fluoridated water because their blood-brain barrier is not fully formed until six months old.","date":"2024-03-05 00:00:00+00:00"},{"id":"a39f477b-71f2-4f8e-8040-d311ee44ffcf","text":"Angela Merkel supports ending sanctions against Russia.","date":"2017-05-04 09:21:30"},{"id":"8105f0c2-d335-44c3-889f-c2866cac8644","text":"American farmers supported Russia\'s response to EU sanctions.","date":"2014-08-28 11:48:28"},{"id":"3220d5f1-68c5-408f-a687-456500ec5c1b","text":"SARS-CoV-2 (the virus that causes COVID-19) does not exist and has never been isolated.","date":"2021-01-01 00:00:00+00:00"},{"id":"55000f0b-6050-4bed-b661-724a55b279d1","text":"Vitamin K shots contain toxic levels of aluminum, and Hepatitis B vaccines contain toxic ingredients.","date":"2023-12-13 00:00:00+00:00"},{"id":"e9b0d563-f34b-4a35-a863-be0d2c997c10","text":"A Ukrainian soldier\'s widow was forced to pay for the equipment that killed him.","date":"2024-04-14 10:53:00"},{"id":"ec89a7d0-444c-4a68-8ab2-49873e2d905c","text":"COVID deaths were vastly overcounted.","date":"2022-03-01 00:00:00+00:00"},{"id":"28d5a32b-01e4-43e1-9fa7-c95e0e6ea554","text":"The Vinnytsia Moscow Patriarchate Orthodox Church has been seized.","date":"2018-12-15 17:30:21"},{"id":"bd92b3cf-ed72-434d-bc50-2da71ce2e696","text":"Ukraine says Crimea is experiencing a drought.","date":"2018-06-07 16:43:02"},{"id":"abb0b365-0c91-4f0a-8c94-f9b199bbc275","text":"Ukrainian teenagers have the lowest average IQ of all European countries.","date":"2024-05-26 11:32:00"},{"id":"cee22ffa-0da1-4eaf-ba22-6194a76f12a4","text":"A Ukrainian admiral praised Russian military might in Crimea.","date":"2020-11-01 20:33:43"},{"id":"e0c3fe47-573f-4179-a8c8-d49f9e461981","text":"Antisemitism has increased in Ukraine.","date":"2018-04-30 21:19:56"},{"id":"8e9b5a0b-9e0f-450a-9bcc-3aad11029c2e","text":"The DTaP vaccine causes sudden infant death syndrome (SIDS).","date":"2019-12-09 00:00:00+00:00"},{"id":"d965751f-c358-4f95-8906-150192b1ac86","text":"Russia is launching an offensive and foreign embassies have evacuated Kyiv.","date":"2022-10-19 09:35:00"},{"id":"e08a454f-0375-4fe5-a9d8-9625252fb43e","text":"A volunteer in Oxford University\'s COVID-19 vaccine trial died.","date":"2020-10-21 00:00:00+00:00"},{"id":"f1d70199-6377-48ec-a1a0-c8babe771d93","text":"Russian forces landed in Odesa, Mariupol, and Kharkiv.","date":"2022-02-24 09:48:10"},{"id":"8db2a5b9-b06a-48f9-83cd-c7414db84203","text":"A person is 300 to 900 times more likely to die after receiving the COVID-19 vaccine than after receiving the flu vaccine, and vaccine adverse events are widely underreported.","date":"2021-02-14 00:00:00+00:00"},{"id":"4926a962-88b8-4c44-8b25-a6100dd82789","text":"Ukraine\'s Health Ministry abandoned cancer patients.","date":"2016-11-10 13:37:47"},{"id":"b5629695-0b27-4487-bc7a-b41c6ea60fc9","text":"A Yale study found that COVID-19 mRNA vaccines cause vaccine-acquired immunodeficiency syndrome (VAIDS) and post-vaccination syndrome (PVS).","date":"2025-02-22 00:00:00+00:00"},{"id":"32156e6d-316c-4228-b1bb-e4431b9f63e2","text":"Pfizer documents confirm mRNA COVID-19 vaccines contain graphene oxide.","date":"2023-02-08 00:00:00+00:00"},{"id":"19745271-da59-4f63-ac98-b7d12909a80d","text":"Western media disclosed that American mercenaries are fighting for Ukraine.","date":"2015-03-03 12:15:54"},{"id":"9ff13b89-dc60-484c-8fce-6f0a5669c623","text":"Flu shots cause false positive COVID-19 test results.","date":"2020-10-04 00:00:00+00:00"},{"id":"db9e5a23-3a2e-4931-94be-3d217cff127d","text":"A photo shows Ukrainian tanks gathering in the ATO area in Ukraine.","date":"2015-11-17 09:31:58"},{"id":"c8544f91-d53f-4fcc-939c-fe97e55c2b45","text":"The Moderna and Pfizer vaccines contain a bovine protein that causes an autoimmune response in recipients, making many of them unable to eat beef.","date":"2023-08-07 00:00:00+00:00"},{"id":"e9c08668-5d1c-498b-a7dd-5a1d19c0a798","text":"The Pentagon will not use $5.8 billion allocated for aid to Ukraine by the end of the fiscal year.","date":"2024-09-23 11:28:00"},{"id":"44736c58-751e-4ef6-b9fa-adde3127863f","text":"The SBU concluded that Russia did not murder Andriy Parubiy.","date":"2025-09-01 00:00:00+00:00"},{"id":"d3c8bcb7-2012-4617-ac2c-f4f9349cc592","text":"Scientists ignored solar particles, cosmic rays, the interplanetary magnetic field, and Earth\'s weakening magnetic field and concluded that climate change is caused by human activity.","date":"2022-07-29 00:00:00+00:00"},{"id":"6f152311-cb32-47f6-9c08-27bfcab9d5fd","text":"The WHO declaration of a public health emergency is a scheme to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus rebranded.","date":"2024-08-20 00:00:00+00:00"},{"id":"fef26ec5-e59f-45c1-a5a4-646b7ba8ec8f","text":"Kyiv will cull stray dogs for the Eurovision Song Contest.","date":"2017-02-09 21:53:29"},{"id":"850e683d-b2ea-44b2-aa45-fb224b8681fb","text":"The Ukrainian Army is funded by money from Viktor Yanukovych.","date":"2016-02-23 18:05:47"},{"id":"214c593c-eba7-4ad5-bc36-3652a10e5726","text":"Ukrainians will participate in the Syrian war.","date":"2015-10-26 20:58:56"},{"id":"413ca3c8-8833-4fea-95cb-3d766a54756d","text":"Most victims of the 1918 Spanish flu died of bacterial pneumonia caused by wearing face masks.","date":"2020-10-23 00:00:00+00:00"},{"id":"782a8eea-e09b-47ad-9879-22709d78e759","text":"Valerii Zaluzhnyi told Ukrainian soldiers not to fear death because they had no chance of survival.","date":"2024-11-20 00:00:00+00:00"},{"id":"559abe16-c942-41c8-868f-fae4d96b3a1c","text":"France\'s best sniper was killed in Ukraine.","date":"2024-05-17 14:54:00"},{"id":"56c5baf3-de4e-4dae-9140-e8515970c81c","text":"The Ukrainian government is repressing ethnic Hungarians in Transcarpathia.","date":"2017-05-25 20:30:23"},{"id":"9cf70f7d-68f2-4feb-b383-fa49d02a1fe7","text":"NASA officially recognizes Crimea as part of Russia.","date":"2015-07-31 21:06:40"},{"id":"aae65b6c-d7b1-453e-aac3-d557018c16b8","text":"Ukrainian TV channels are forbidden from broadcasting footage of a handshake between Vladimir Putin and Petro Poroshenko.","date":"2015-10-20 16:55:56"},{"id":"049f4fc9-03e6-4f0a-83fc-2cbfee582f7e","text":"Grid batteries are fire hazards.","date":"2025-11-20 00:00:00+00:00"},{"id":"4827d13a-0d89-4c69-8325-411684ffddba","text":"The two largest banks in Ukraine will default.","date":"2015-07-11 19:18:51"},{"id":"24a948e1-bc0f-4d4b-9445-82619bac62bd","text":"COVID-19 vaccination of pregnant women caused an increase in the U.S. infant mortality rate in 2022.","date":"2023-11-08 00:00:00+00:00"},{"id":"b8cb1e37-a9ee-4866-95c5-1f5036695355","text":"Governments and health authorities lied about COVID-19 case numbers, treatments, natural immunity, and the virus\u2019s origin, and COVID-19 vaccines and control measures did not work.","date":"2023-02-28 00:00:00+00:00"},{"id":"4b0493cc-0ec3-44ab-9682-69dbebada129","text":"The UN confirms that a Ukrainian military strike in Odesa caused no injuries.","date":"2022-07-29 10:49:00"},{"id":"7d7705c5-3255-46c4-a61d-08ef3d3eda8f","text":"80% of people who received the Moderna COVID-19 vaccine experienced significant side effects, and children in Sudan contracted polio from the polio vaccine.","date":"2021-03-26 00:00:00+00:00"},{"id":"39148726-18c2-47ab-95c4-5001bfb98ee1","text":"Ukrainian train security detects passengers who oppose the Zelenskyi regime.","date":"2023-10-15 13:06:00"},{"id":"cfa983d6-9dad-4763-bd75-c81a2285f59f","text":"If I don\'t get the vaccine, only I will be harmed and no one else will be harmed.","date":"2021-09-02 00:00:00+00:00"},{"id":"c43216b5-fbbe-430d-843c-0ff3e82e28f5","text":"The United States violated the INF Treaty.","date":"2019-08-19 12:48:17"},{"id":"f28554de-91a0-42ff-a02e-bef7bd3f1398","text":"79.4% of infants who died from SIDS received a vaccine on the same day they died.","date":"2024-12-03 00:00:00+00:00"},{"id":"9246277b-632c-43ba-975d-947ba8474dcd","text":"The EU and US accuse the Kremlin of disinformation and hide their pandemic failures.","date":"2020-04-01 16:09:00"},{"id":"ef6e2f62-e4da-4bca-b1ad-ab18c8fe45f2","text":"UK government Vaccine Surveillance Reports show fully vaccinated people are developing AIDS.","date":"2021-10-30 00:00:00+00:00"},{"id":"41c44f05-82ce-4b19-a650-b156f05efa75","text":"President Joe Biden told people to get vaccinated to protect themselves from hurricanes.","date":"2022-09-27 00:00:00+00:00"},{"id":"2c06ff17-3a5e-4dac-a0b2-aa1321a05705","text":"A World War II veteran was beaten in Kyiv.","date":"2015-05-09 19:04:58"},{"id":"1f151033-fa0f-432d-bfae-8dd97991bcee","text":"The UN Secretary\u2011General has launched tribunal proceedings against Petro Poroshenko.","date":"2016-07-05 09:03:18"},{"id":"a6c78845-da38-43de-ba0f-357aff013c2a","text":"A California study found vaccinated individuals are more susceptible to COVID-19 variant infections than unvaccinated individuals.","date":"2021-06-10 00:00:00+00:00"},{"id":"fe32af40-4500-4d43-a1c5-ea02937c4c4b","text":"Vaccines contain the complete genetic code of an abnormal human containing cancer-causing genes.","date":"2019-02-12 00:00:00+00:00"},{"id":"712a2f07-999d-4c15-a8fd-cf6ec4475529","text":"Charcoal absorbs and neutralizes poisons and treats diarrhea and bloating.","date":"2024-07-24 00:00:00+00:00"},{"id":"3c4db7e6-ebcf-4c14-8c80-5acce367863a","text":"Erdogan says Turkey will build a nuclear bomb.","date":"2025-06-15 00:00:00+00:00"},{"id":"4f27b8c6-ed89-44ab-a475-ce01f510eb96","text":"Babies born to mothers who received COVID-19 vaccines are dying at higher-than-normal rates and the COVID-19 vaccines caused those deaths.","date":"2022-05-25 00:00:00+00:00"},{"id":"1ca70899-971e-41e3-a537-3ec6776c088e","text":"The German Foreign Minister said that supporting Ukraine is more important than the interests of German voters.","date":"2022-09-03 12:55:00"},{"id":"d5dd2789-974b-4cac-84f8-12d91fe6053c","text":"COVID-19 mRNA vaccines alter the human genome; SV40 causes cancer in humans; regulatory agencies knew COVID-19 vaccines were contaminated.","date":"2023-06-11 00:00:00+00:00"},{"id":"60cb9b77-25b6-4a6f-81a2-a7bb90327f82","text":"Erecting a single wind turbine produces a staggering quantity of CO2 emissions, and a significant proportion of retired turbine blades are sent to landfill and cannot be recycled.","date":"2025-01-27 00:00:00+00:00"},{"id":"f606b31a-b532-40dc-89ff-e88a3a8c71ec","text":"COVID-19 vaccines cause more hospitalizations than they prevent.","date":"2022-01-07 00:00:00+00:00"},{"id":"fe511ca5-5050-449f-a284-d8293d7b0c96","text":"Ukrainians were detained at the Poland\u2013Germany border.","date":"2024-02-16 13:03:00"},{"id":"ac73713b-73db-428f-97d2-fe95896fad23","text":"Coral cover on the Great Barrier Reef is at record-high levels, and the Great Barrier Reef is not threatened by climate change.","date":"2021-07-21 00:00:00+00:00"},{"id":"2c581133-af8b-4910-a5b4-19bd1832f813","text":"This is a brush rake used to clear underbrush and forest-floor debris that creates fuel for wildfires.","date":"2020-04-11 00:00:00+00:00"},{"id":"4aab92fc-d883-488e-bca0-15f56952fcc0","text":"Ukraine recognizes a one-legged person as fit for military service.","date":"2023-12-12 09:18:00"},{"id":"1e33ee40-e3ca-48f3-bfa4-a83d268f0b1e","text":"Kyiv admits it shelled civilian areas in the Donbas.","date":"2019-06-10 19:55:54"},{"id":"490c32d7-44ee-43dd-9430-5b67acfadcbb","text":"E-cigarettes cause milder lung damage than combustible cigarettes but cause equal or greater harm to the cardiovascular system than combustible cigarettes.","date":"2019-12-03 00:00:00+00:00"},{"id":"9a49c057-060b-4aa0-8605-bc212bdce2e7","text":"A chemical in Cheerios and Quaker Oats causes infertility and delayed puberty.","date":"2024-02-15 00:00:00+00:00"},{"id":"32ce6b58-43d6-484f-915c-0918e220fd62","text":"One in every 500 children under five who received the Pfizer mRNA COVID-19 vaccine was hospitalized with a vaccine injury.","date":"2022-10-24 00:00:00+00:00"},{"id":"96814f16-e24f-40de-ae84-fb0188df7399","text":"Vaccines did not eliminate polio.","date":"2020-06-12 00:00:00+00:00"},{"id":"4b0acc73-1804-4517-937f-1b5ad41cb490","text":"Russian media reported that a football player was appointed as ambassador.","date":"2015-09-28 17:55:08"},{"id":"235efa02-9b47-4eac-b7bd-fa49f55a6b79","text":"Pfizer\u2019s COVID-19 vaccine causes \u201Cturbo cancer.\u201D","date":"2023-07-20 00:00:00+00:00"},{"id":"09b7bc02-54e4-4f14-9a8c-ea0414b9cc0e","text":"The United States State Department recognized Vladimir Putin as the President of Russia.","date":"2024-05-07 11:50:00"},{"id":"1146bc76-1dfa-4bdd-a2d7-a97508b0ea72","text":"Food supplements restore perfect blood sugar levels and cure Type 2 diabetes.","date":"2022-10-06 00:00:00+00:00"},{"id":"c644a19e-7959-4dbe-bb1d-5da1d7e8db40","text":"An Italian landmark collapsed because Italy diverted public funds to Ukraine.","date":"2025-11-03 00:00:00+00:00"},{"id":"aca4f631-b4e0-46c0-9977-79908d2a056e","text":"Changes in Earth\'s orbit and axial tilt are responsible for the observed warming, and humans are not warming or cooling the planet.","date":"2019-08-30 00:00:00+00:00"},{"id":"1f726340-0f86-4d17-97d6-78a6f17df1a9","text":"COVID-19 vaccines are experimental.","date":"2022-01-19 00:00:00+00:00"},{"id":"cff50cf1-148e-4d81-9d29-27a702bbb6ac","text":"A Ukrainian town asked President Vladimir Putin of Russia to provide natural gas.","date":"2016-11-15 01:44:41"},{"id":"31eed9a0-709b-4a3d-8b0b-39d363374e35","text":"Trump persuaded Putin not to strike Kyiv while Western leaders were in Kyiv.","date":"2025-05-10 00:00:00+00:00"},{"id":"ed3cdb9f-0609-4ee5-9a77-be64735a50fe","text":"COVID-19 vaccinations caused an increase in COVID-19 cases.","date":"2024-04-15 00:00:00+00:00"},{"id":"c95a2f22-d6e8-4959-ad36-6fd6e6c0589a","text":"The Sun, not human emissions of carbon dioxide, is the main cause of warming in recent decades, and the UN IPCC systematically biases its data selection.","date":"2021-08-16 00:00:00+00:00"},{"id":"914b6f6f-2fca-4af8-9488-1a2ce148ed7f","text":"Ivermectin and fenbendazole cure stage-four cancer.","date":"2025-01-16 00:00:00+00:00"},{"id":"3f31c2fc-e518-44a9-b233-2088b1bfc18a","text":"Russia has no obligation to Ukraine under the Budapest Memorandum.","date":"2016-01-27 23:38:12"},{"id":"cb1c2aef-6959-401e-9589-022e23e0167c","text":"Ending trade with Russia has destroyed Ukraine\'s economy.","date":"2018-09-04 16:11:15"},{"id":"18cf1ce5-3c6a-4bdc-b913-675ce17f06f3","text":"Germans are uneasy about the Ukraine\u2013Russia debt repayment lawsuit.","date":"2015-12-24 19:23:50"},{"id":"fad0d97a-967b-45f5-94a1-0ca5aca96640","text":"Solar panels heat up their surroundings and harm the surrounding environment.","date":"2025-04-17 00:00:00+00:00"},{"id":"679de09b-9b77-4640-b961-aec420f2fb00","text":"Colloidal silver is effective for all infections.","date":"2020-01-23 00:00:00+00:00"},{"id":"eb010d8a-b114-4016-9f56-547f3f7b89df","text":"The coronavirus is as deadly and as dangerous as seasonal flu.","date":"2020-10-08 00:00:00+00:00"},{"id":"c3bcf198-1424-473c-8a8c-663e70803e87","text":"Russia is the top importer of Ukrainian arms.","date":"2017-02-24 17:53:31"},{"id":"3dfbb796-816a-4bcb-8e8c-6d0a8aa6706b","text":"The bodies of 286 women were found near Krasnoarmiisk.","date":"2014-11-01 13:03:55"},{"id":"395ed66c-1d26-4d1f-870c-5401a963aec5","text":"The pandemic is over in the UK; most people already had prior immunity and the UK has reached community immunity; viruses do not cause waves.","date":"2020-11-05 00:00:00+00:00"},{"id":"f9dbc081-1611-4178-93da-896aed2eec7b","text":"Children with mitochondrial disorders are at increased risk of severe adverse reactions caused by vaccines.","date":"2018-09-13 00:00:00+00:00"},{"id":"4d3c4642-883f-4145-98a3-9370b82ef841","text":"The MMR vaccine contains toxic ingredients that cause encephalopathy.","date":"2019-06-13 00:00:00+00:00"},{"id":"0a8f55be-555c-4c88-b454-178bad2a9dd4","text":"In the UK, vaccinated people have a higher SARS-CoV-2 infection rate than unvaccinated people.","date":"2022-04-06 00:00:00+00:00"},{"id":"efa65091-ad55-46d9-b00b-8bf893d6fb30","text":"Hydroxychloroquine, azithromycin, and zinc cure COVID-19.","date":"2020-08-04 00:00:00+00:00"},{"id":"3117bdd3-fe21-4976-ba21-ee3604b9e13c","text":"Josep Borrell supports resolving the conflict in Ukraine by military force.","date":"2022-04-11 10:13:40"},{"id":"9f36031c-5916-4e74-935a-bb47d9d96ded","text":"New research shows the COVID-19 vaccine spike protein enters the bloodstream and causes blood clots, heart damage, and brain damage.","date":"2021-05-28 00:00:00+00:00"},{"id":"4e21a3b4-2946-4d8f-9487-14f91e7e9c72","text":"The MHRA has declared COVID-19 vaccines unsafe for use in humans based on Yellow Card evidence.","date":"2021-06-16 00:00:00+00:00"},{"id":"aa4040ac-5dc6-453b-ad32-33c50706dfe6","text":"Scientists found that the SARS-CoV-2 virus contains a tiny DNA sequence identical to a sequence patented by Moderna three years before the pandemic began.","date":"2022-02-23 00:00:00+00:00"},{"id":"2fc64496-af63-4c5c-abb3-9f84496a307a","text":"\\"Ukraine\'s EU Association Agreement was a five-year disaster.\\"","date":"2021-02-20 10:55:00"},{"id":"13111903-7ec4-4b35-892c-1db611c8e2a8","text":"World Jewish Congress recognizes Crimea as part of Russia.","date":"2017-11-29 20:46:35"},{"id":"c6a08cf6-77ca-4409-9b0a-6fb71acf61e2","text":"The most vaccinated communities have higher COVID-19 case rates than less vaccinated communities, according to a Harvard study.","date":"2021-10-22 00:00:00+00:00"},{"id":"df6ef4b3-1e21-4196-a2e3-c276d1591248","text":"Ukraine had no money to host Eurovision 2017.","date":"2017-03-15 06:32:54"},{"id":"bf34edb9-658d-4a0b-97be-9cbefe833a99","text":"N-acetylcysteine inhibits viral replication, breaks up mucus, and effectively treats COVID-19.","date":"2023-09-02 00:00:00+00:00"},{"id":"c86e3c48-755c-4b5d-8c98-a72e6affa674","text":"COVID-19 vaccines are dangerous: they cause immune overreactions, suppress natural killer (NK) cells, and increase virus lethality.","date":"2021-03-13 00:00:00+00:00"},{"id":"c18bc9a5-4f5c-4c49-bf4a-768caf8f8785","text":"People who receive vaccines authorized under Emergency Use cannot sue the manufacturers; once those vaccines receive full approval people can sue the manufacturers, unless the vaccines are recommended for children, in which case people cannot sue the manufacturers.","date":"2022-11-24 00:00:00+00:00"},{"id":"3d7cfe24-7ccc-4715-a510-ea6e42271f97","text":"Dr. Anthony Fauci said he wore a mask indoors for appearances, not for scientific reasons.","date":"2021-05-28 00:00:00+00:00"},{"id":"6f1d0218-2aaf-4ca5-b70b-202058baaf47","text":"Ukraine is preparing a nuclear provocation in Kharkiv","date":"2022-03-07 17:49:42"},{"id":"3dbaecae-f023-4a6d-99ee-f9c83ed6d59d","text":"A hepatitis A epidemic is occurring in Ukraine.","date":"2018-01-08 23:19:26"},{"id":"1ed21ded-a58d-4450-9265-91ccc6e02072","text":"Many locations warming faster than the global average proves climate science is false.","date":"2022-08-13 00:00:00+00:00"},{"id":"3af16777-d1d0-4e80-a9f5-2f99d1033c6d","text":"Human actions caused more than 100% of the global warming over the past century.","date":"2017-11-03 00:00:00+00:00"},{"id":"0dfca0dd-799d-48de-ad62-11e1841e3fd7","text":"The Ukrainian government will introduce food ration cards.","date":"2017-09-08 10:06:09"},{"id":"355ea973-9d66-429b-9998-3ed67368dc37","text":"ISIS operates training camps in southern Ukraine.","date":"2016-07-30 19:13:09"},{"id":"ca9ae69d-5e7d-4172-9055-bc081efdd1dd","text":"Crimea has disappeared from the international agenda.","date":"2019-10-09 19:06:01"},{"id":"559d7895-3171-45e9-a0d1-e435947066ac","text":"Russia destroyed several HIMARS near Kharkiv","date":"2022-08-07 11:04:00"},{"id":"bf34a0d6-69de-4dbe-b228-ed90e9008781","text":"The flu shot contains ingredients that cause cancer.","date":"2018-04-28 00:00:00+00:00"},{"id":"bdd349a7-4515-4da4-af05-4548d7083f52","text":"Ukrainian mines are killing soldiers and children in Donbas.","date":"2018-10-04 13:04:21"},{"id":"65d1fbc1-c1ed-46c6-8363-e70bb39e0073","text":"Poroshenko announced that Ukraine should align its policy with Russia.","date":"2015-07-30 17:20:52"},{"id":"08ae05df-a1ec-493c-9222-3436a91c88e6","text":"COVID-19 vaccines caused the rise in heart attacks among young people.","date":"2023-03-30 00:00:00+00:00"},{"id":"735c5752-3e87-4fc3-b8bf-149a8cb9936a","text":"Ivermectin sterilizes 85% of men who take it.","date":"2021-09-05 00:00:00+00:00"},{"id":"d48a5434-e0b7-4030-8162-a726e2a9395a","text":"Russian shelling in Ukraine caused an explosion that damaged an OSCE vehicle.","date":"2017-04-24 19:25:12"},{"id":"dbdae94d-af2c-4bc4-9cfb-bc5655793791","text":"The U.S. government has paid over $4.5 billion since 1986 to individuals for vaccine injuries, so vaccines are unsafe.","date":"2021-04-14 00:00:00+00:00"},{"id":"1d8e287e-62a1-463d-95e5-61e0cb648713","text":"Separatist forces regained control of Avdiivka.","date":"2017-01-31 13:32:01"},{"id":"6841c086-c308-4290-86ec-48a20ac686f3","text":"Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, and shikimic acid kills viruses including SARS-CoV-2.","date":"2023-01-27 00:00:00+00:00"},{"id":"7b9481f9-8112-4bc8-bd57-8107fcb6cb90","text":"Ukraine national football team excludes Roman Zozulya from its roster.","date":"2017-03-28 14:42:42"},{"id":"ab781808-3305-433b-88bd-941249abd97f","text":"Massive COVID-19 outbreaks occurred among Ukrainian military personnel during NATO exercises.","date":"2021-09-30 15:05:00"},{"id":"4846e35e-b5fd-4a27-b4eb-19ce31173495","text":"Ukraine banned music performed in the Russian language.","date":"2025-12-13 00:00:00+00:00"},{"id":"2377ee2f-c1b5-4984-9853-d503eb644658","text":"ADHD is a fabricated disorder created by pharmaceutical companies to drug children for profit.","date":"2018-03-01 00:00:00+00:00"},{"id":"007d3cbd-daea-4b58-be01-f7c97d00c088","text":"A preprint of an ivermectin study in Itaja\xed found that prophylactic ivermectin reduced COVID-19 hospitalization and mortality by 50%.","date":"2021-12-12 00:00:00+00:00"},{"id":"705089db-d047-4aaf-9efe-0eba267d2e09","text":"Dr. Fauci said the COVID-19 vaccine that appeared safe in initial trials makes vaccinated people more likely to become infected.","date":"2021-12-15 00:00:00+00:00"},{"id":"f6062ca0-f886-40e4-8ded-a9ca73878d31","text":"The graves of ATO soldiers were bulldozed.","date":"2015-11-21 02:02:35"},{"id":"e2288ded-588c-42ab-a0ea-06f15a3b8624","text":"The EchoEase nasal inhaler cures tinnitus.","date":"2024-05-22 00:00:00+00:00"},{"id":"f5ba79ec-ebb7-4b0b-b3d3-d8ef07952c7b","text":"Vitamin K injections are poisonous because they contain polysorbate 80 as the main active ingredient and polysorbate 80 causes infertility and autoimmune disorders.","date":"2023-08-29 00:00:00+00:00"},{"id":"b1bfb305-5ccb-4cf7-9e9c-32d77fbea960","text":"Deserts produce heat by reflecting 60\u201370% of incoming solar energy back into the atmosphere, and addressing global warming requires acting on deserts.","date":"2021-09-04 00:00:00+00:00"},{"id":"d11029f7-4dc6-4be7-b1da-5b28664bb1b1","text":"Poppers cause Kaposi\'s sarcoma.","date":"2023-07-04 00:00:00+00:00"},{"id":"4d449963-3c83-4ca5-a518-09c04a8066bc","text":"Biden admits he is afraid of the Russian Kinzhal missile.","date":"2022-03-22 17:58:00"},{"id":"8d476653-8abd-46d5-ac3d-f0a4a2cd468d","text":"Nattokinase dissolves the SARS\u2011CoV\u20112 spike protein, and long COVID is caused by persistent spike protein in the body.","date":"2023-03-24 00:00:00+00:00"},{"id":"b1d44b1e-4296-4f67-8f78-0ddfb3a5d8e1","text":"44% of pregnant women in Pfizer\'s COVID-19 vaccine trial miscarried.","date":"2022-08-12 00:00:00+00:00"},{"id":"42bf77b3-e0b2-4e5a-86b1-fc489416a7d3","text":"Ukraine increased its territory.","date":"2017-10-20 15:01:21"},{"id":"1a05352e-5ad5-457b-af01-e151d9a78829","text":"Ukrainian military fired on civilian vehicles in Donbas.","date":"2019-01-24 11:15:57"},{"id":"95e9fe43-5bd9-4517-8c75-ad87b874e86c","text":"Kyiv will close its nuclear power plants because it lacks enriched uranium.","date":"2019-01-14 10:39:57"},{"id":"9af9e18f-fa69-41e2-adf9-4a24e42c1b84","text":"Covid-19 vaccine mRNA cannot be broken down and Covid-19 vaccines cause excess deaths and unprecedented blood clots.","date":"2023-04-10 00:00:00+00:00"},{"id":"5201ea05-3c66-4f33-8c67-ce6caf33f3f4","text":"NASA says a deepening solar minimum will cause cold weather to grip the world.","date":"2019-04-15 00:00:00+00:00"},{"id":"3f248e4c-edd5-4205-b450-821576e9195d","text":"Flu vaccines do not protect, they increase the risk of getting influenza, and they damage the immune system and the nervous system.","date":"2024-09-26 00:00:00+00:00"},{"id":"d6398523-0ffd-447a-8554-59fcfee589bd","text":"The NATO chief said the Alliance has been preparing for war with Russia for eight years.","date":"2022-07-11 12:49:00"},{"id":"f77f73a6-8d42-4767-9384-fbe2af0f6cd7","text":"Kyiv is preparing a PR operation targeting Crimea to disrupt Crimea\'s tourist season.","date":"2018-07-06 21:53:50"},{"id":"f4029d86-fdce-4ef4-b075-d09aff0725af","text":"Boris Johnson is tired of Ukraine.","date":"2022-06-20 19:10:10"},{"id":"f971b469-261f-43ef-98d8-2c5946168e63","text":"Oceanic pH levels did not decrease over the last century.","date":"2017-10-01 00:00:00+00:00"},{"id":"402a5e79-9f4c-4cb8-9b67-00a92037de67","text":"Coconut oil cures Alzheimer\'s disease.","date":"2024-04-25 00:00:00+00:00"},{"id":"bf65226e-9669-4774-9ef3-570fbefeee38","text":"Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide.","date":"2021-08-07 00:00:00+00:00"},{"id":"e70bbfc7-4a2f-41e6-b9fd-3d7557e55620","text":"The WHO says children must not receive COVID-19 vaccines.","date":"2021-06-29 00:00:00+00:00"},{"id":"50acc255-34d5-4628-bcc1-a683011cf488","text":"A Donetsk People\u2019s Republic separatist fell from a tower while hanging the Donetsk People\u2019s Republic flag.","date":"2014-05-06 22:22:59"},{"id":"bfa7b823-2a59-436f-82ee-922dc42e266d","text":"The Kyiv government tested dangerous drugs on its own citizens.","date":"2022-08-15 10:44:11"},{"id":"18e1d515-c745-4151-88c1-8c9e9af7547d","text":"Melanoma did not exist before sunscreen was invented, and low vitamin D causes melanoma.","date":"2024-09-11 00:00:00+00:00"},{"id":"d40539dc-69f1-4f92-a72d-ae21d808cf04","text":"Poroshenko says returning Crimea is unrealistic.","date":"2017-09-11 20:59:08"},{"id":"20ad280a-9ca6-42d4-8560-8ef0babec400","text":"Babies under 6 months have the second-highest hospitalization rate after elderly people.","date":"2025-02-06 00:00:00+00:00"},{"id":"51cf9cc5-964d-487b-b0ac-9496efa28c40","text":"Ukraine is losing control of Transcarpathia","date":"2018-04-10 17:14:58"},{"id":"3076ff95-fa54-4f38-8fda-8d49ad5f5f5b","text":"OSCE walked out of Donbas talks because Ukrainian officials threatened OSCE delegates.","date":"2018-05-18 20:57:29"},{"id":"91e15b87-d451-447d-83a5-56bb79569eed","text":"Global media reported that Ukrainian refugees committed mass crimes in France.","date":"2026-01-12 00:00:00+00:00"},{"id":"9386cc51-2d6f-4bdf-9354-bbd0755c9cb1","text":"Transcarpathia has separated economically from Kyiv.","date":"2016-10-21 22:20:46"},{"id":"a308b049-5da8-43ff-aba2-9a9c0276d910","text":"Four Ukrainian soldiers were killed in a mortar explosion.","date":"2020-10-18 12:55:00"},{"id":"ec947ed8-cc30-4eaf-8c9b-b928ea7c0068","text":"Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS.","date":"2012-11-25 00:00:00+00:00"},{"id":"f0666037-3fb1-462e-8c7b-66b127fba72e","text":"A photo shows refugees in Rostov being sent to filtration camps.","date":"2014-07-12 20:54:18"},{"id":"37a3eb67-d193-4c87-a056-44ec271b6890","text":"Ukraine\'s new language law violates Ukraine\'s constitution and makes violators criminally liable.","date":"2019-05-03 08:11:40"},{"id":"ed748149-b43c-4488-a119-7d3b55d695d9","text":"Ukraine abandoned the Minsk agreements and is preparing to occupy Donbas.","date":"2019-11-15 08:22:44"},{"id":"db8f6262-d359-4671-9a89-8e585aad0bc6","text":"A U.S. bowling tournament broadcast an announcement saying \\"Stop Funding Ukraine\\".","date":"2024-03-18 13:28:23"},{"id":"ee7b7f93-c6b9-4025-99d6-a2d067b69ab5","text":"Pope Francis last spoke with Ukrainian President Volodymyr Zelensky.","date":"2025-04-22 00:00:00+00:00"},{"id":"aa15afe4-78f3-4f3a-b547-91e27dc69fe1","text":"Most fully vaccinated individuals will develop full-blown vaccine-induced acquired immunodeficiency syndrome by the end of the month.","date":"2023-07-02 00:00:00+00:00"},{"id":"f73337a1-ea01-41f8-8dfa-1089a6101eaf","text":"Maddie de Garay\'s case shows COVID-19 vaccines cause functional neurological disorder and are harmful","date":"2024-01-21 00:00:00+00:00"},{"id":"60c414b2-02d3-43e3-ab59-2a05ea85c25d","text":"Deaths occurring within 20 days of a positive COVID-19 test are counted as COVID-19 deaths regardless of other causes, and deaths occurring after vaccination are systematically excluded from being attributed to the vaccine.","date":"2021-05-02 00:00:00+00:00"},{"id":"31a87aa3-2cdc-4a51-970b-c4552af60231","text":"Zaporizhia veterans were shown footage of Soviet soldiers raping Ukrainian girls.","date":"2014-10-18 18:23:50"},{"id":"db7c86d1-007a-434b-9049-ab67281a99c1","text":"A nurse fainted after receiving a COVID-19 vaccine.","date":"2020-12-18 00:00:00+00:00"},{"id":"68f0d160-583d-481e-83df-68c4639466a7","text":"Anyone who brings a friend to a recruiting office will receive 20,000 hryvnia.","date":"2022-10-29 16:45:00"},{"id":"54d4d5f8-b5e7-4362-ac10-def756c33689","text":"The U.S. did not lose substantially more lives in 2020 than in 2019; the increase over 2019\u2019s 18,433 deaths was negligible.","date":"2020-05-13 00:00:00+00:00"},{"id":"99ca030d-febe-460a-a6cc-7fb6bfd60359","text":"Carbon dioxide does not cause global warming; scientists are 90% sure the Sun causes global warming; ocean acidification and harm to polar bears blamed on CO2 are not real.","date":"2024-01-22 00:00:00+00:00"},{"id":"fb0330ef-17c9-4066-bcdb-a7dce2c66aa6","text":"Smokers\' lungs turn black.","date":"2012-08-06 00:00:00+00:00"},{"id":"461c8397-4732-40d0-a312-c8fb8792a2bf","text":"2014 Ukrainian military losses are being passed off as current Ukrainian casualties.","date":"2022-02-27 18:31:19"},{"id":"26a96b2d-3797-496d-8ac7-3ed2dd390863","text":"A child died in Donbas as a result of a Ukrainian drone attack.","date":"2021-04-05 10:48:00"},{"id":"f7763ef1-0586-4f10-96ef-9996f889cdfd","text":"A Morgellons cranberry-juice test extracts nanoparticles from chemtrails and air pollution.","date":"2023-01-21 00:00:00+00:00"},{"id":"e0831560-5a10-4b72-a32c-0beb2101c523","text":"President Joe Biden said Ukraine must give up territory to end the war.","date":"2022-06-06 12:22:00"},{"id":"9ba9c7a2-13ce-4eeb-bd31-2cddba33d2fb","text":"Pope Francis presented Russian President Vladimir Putin with the Guardian Angel of Peace medal.","date":"2019-07-11 10:56:08"},{"id":"fe6a5012-e766-477b-9be1-1e6534f65aae","text":"Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children.","date":"2020-04-06 00:00:00+00:00"},{"id":"0b1a8480-5c98-4ba3-94af-4ddeb88f0fa3","text":"Greenland ice cores show no significant warming and human-caused climate change is false.","date":"2024-03-08 00:00:00+00:00"},{"id":"f1306acb-108e-4ee9-a8a2-aafd43375285","text":"Boris Johnson was paid to pressure Kyiv to oppose peace talks.","date":"2025-10-13 00:00:00+00:00"},{"id":"b2e81b33-d30a-4225-9bbc-48fb82b96209","text":"Dmytro Yarosh brought a machine gun to the Verkhovna Rada meeting.","date":"2014-11-29 00:21:23"},{"id":"3835bf8b-7501-4921-a504-e1f225fd8897","text":"A new study shows climate change is greatly overestimated because oceans are cooling the Earth far more than previously believed.","date":"2024-12-10 00:00:00+00:00"},{"id":"15d51b8d-9bc0-4395-b6a2-58477343cae7","text":"Vaginal gels with probiotics treat HPV infection.","date":"2025-12-17 00:00:00+00:00"},{"id":"2f980e48-1150-4fff-be2a-30cbaff52bbb","text":"Ukrainian children were forced to play with a stuffed toy depicting Adolf Hitler.","date":"2018-08-15 12:46:01"},{"id":"11f609b4-7a2c-4cef-9ec5-eabce404dbbf","text":"CDC covered up a 1999 study showing a 1,135% increased risk of autism after hepatitis B vaccination.","date":"2025-06-30 00:00:00+00:00"},{"id":"85c3d135-1fba-4982-b96a-cba7c669d7f0","text":"A Coca-Cola product tested positive for Covid-19.","date":"2020-12-17 11:16:53"},{"id":"0e09f55d-e12d-4e27-b424-be835d42044b","text":"In 1943 the Ukrainian Insurgent Army crucified four children.","date":"2022-08-23 18:16:00"},{"id":"864703a6-b3a5-4fa7-8ff1-321bdffd8e40","text":"Vitamin D insufficiency accounts for the majority of COVID-19 deaths.","date":"2020-04-12 00:00:00+00:00"},{"id":"4a8f4191-7339-42e4-b14e-4481e9d543ed","text":"Global warming is only the recovery from the Little Ice Age; warming has been slower than climate models predicted; carbon dioxide benefits the Earth; global warming is not increasing the intensity or frequency of natural disasters.","date":"2023-04-09 00:00:00+00:00"},{"id":"c07e9dda-0c21-4c8c-8ea3-d415f66e9ade","text":"COVID-19 vaccines caused 895 serious adverse reactions in military veterans.","date":"2021-07-24 00:00:00+00:00"},{"id":"221e2843-0d1d-4934-9175-536b037f0687","text":"European Court of Human Rights says the Russian government was not involved in Anna Politkovskaya\'s murder.","date":"2018-07-18 10:46:30"},{"id":"0aa14ed9-8f5f-4f78-8937-57e0b1539d61","text":"Vaccines cause autism, ADHD, and cancer; statins provide no benefit and cause cancer and memory loss.","date":"2024-08-29 00:00:00+00:00"},{"id":"8b61f97e-9475-4370-97c1-b0602d3861cf","text":"Ukrainian TikTok users mock Charlie Kirk\'s murder.","date":"2025-09-12 00:00:00+00:00"},{"id":"896217cb-d2af-414f-b5d3-51faabbc1542","text":"COVID-19 cases are directly caused by exposure to 5G electromagnetic radiation.","date":"2020-05-04 00:00:00+00:00"},{"id":"3ef38ce4-3be3-42aa-a325-e6d43d492fce","text":"The video report showing civilian casualties in Ukraine was staged.","date":"2022-03-10 15:30:00"},{"id":"e83d4367-7b6a-4345-a3f1-d00d0b00e230","text":"U.S. forces will fight for control of the Kerch Strait.","date":"2019-02-07 17:56:52"},{"id":"3318f9ef-2c09-4485-ba0e-7a99ab035874","text":"COVID-19 is caused by snake venom, not by a virus; COVID-19 vaccines contain snake venom that causes miscarriage.","date":"2023-05-12 00:00:00+00:00"},{"id":"e36ec763-c008-4d62-bed9-5c270d796253","text":"No healthy child in the United States died from COVID-19; one in 2,700 people is developing myocarditis from COVID-19 vaccines; athletes are collapsing during play because the vaccines cause myocarditis; and Moderna filed a patent in 2019 that links the company to the COVID-19 pandemic.","date":"2022-05-18 00:00:00+00:00"},{"id":"fb4ca0c3-80c4-4700-ae1a-6f5767428779","text":"Oxygen kills cancer; Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer.","date":"2022-03-29 00:00:00+00:00"},{"id":"f57eb09d-4839-4483-b263-99c536579018","text":"Microsoft said the Paris Olympics received the most negative feedback in the last 10 years.","date":"2024-06-18 13:03:00"},{"id":"1c6bdb4c-9bfc-466a-a7ee-4d8b2e346cb9","text":"COVID-19 vaccines cause blood clotting, infertility, and immune escape.","date":"2021-04-23 00:00:00+00:00"},{"id":"01c9a984-5ece-42de-9e7e-2449849d6790","text":"55,000 years ago global temperatures were 2\xb0C higher than today; current warming is entirely cyclical, human greenhouse-gas emissions are insignificant, and sea level rise will not occur.","date":"2019-05-04 00:00:00+00:00"},{"id":"4f7c4c9e-7e0b-4bbf-9bc8-39859ff7d243","text":"The World Health Organization and the U.S. Centers for Disease Control and Prevention discourage people from wearing face masks.","date":"2020-06-14 00:00:00+00:00"},{"id":"d699106d-5b88-4e20-9413-43a5243fe144","text":"The Swedish government pays 30,000 euros to each Ukrainian refugee to leave Sweden.","date":"2024-09-18 13:21:11"},{"id":"899d585b-f8a1-46d4-aecb-51c086aced46","text":"A Ukrainian engine caused a Vega rocket to crash in Europe.","date":"2020-11-25 14:46:33"},{"id":"0192c2a6-abf8-487a-ae10-a2de71b9303e","text":"Odesa has withdrawn from Ukraine.","date":"2015-09-04 14:42:48"},{"id":"daf9f724-fde8-4531-bd2a-de74dd77c316","text":"The woman presented as the heroine in the \u201CSloviansk Boy\u2019s Crucifixion\u201D report was found among the victims of the Donetsk explosion.","date":"2015-01-24 22:59:34"},{"id":"0b056afe-9555-4444-a11b-8067678748fb","text":"Masks do not significantly reduce transmission of respiratory diseases.","date":"2020-11-20 00:00:00+00:00"},{"id":"1c81eba8-a29a-49ee-aa9a-249eb28d0a95","text":"Folic acid and similar compounds deplete folate, which is very serious for people with MTHFR.","date":"2022-02-05 00:00:00+00:00"},{"id":"04225ddb-8ca4-41ae-9ca5-314b7d1e53f0","text":"Vitamin D is more effective than the influenza vaccine at preventing influenza infection.","date":"2017-03-01 00:00:00+00:00"},{"id":"de6d291f-4bac-4d72-95fd-85e7525fd5bc","text":"A video shows Kharkiv residents leaving the city en masse.","date":"2024-04-28 20:10:37"},{"id":"b1f962d0-8550-4b2d-9191-63c14905d540","text":"The United States is unhappy with Ukraine and is seeking to replace Petro Poroshenko as Ukraine\'s leader.","date":"2016-12-09 18:48:29"},{"id":"68b8c45f-ffc4-4a92-a4b2-5ec0f20a0bb7","text":"Ukraine will intern millions of Russian citizens living in Ukraine.","date":"2015-05-22 16:17:06"},{"id":"925e1b24-bec0-496d-b5b2-3b514260a124","text":"COVID-19 vaccination increases the risk of sudden cardiac death.","date":"2024-04-13 00:00:00+00:00"},{"id":"4cec07ca-d88e-48f0-93de-7efd62925b38","text":"Climate models predicted three times as much global warming since 1988 as actually occurred.","date":"2019-11-03 00:00:00+00:00"},{"id":"5d66c5b0-29b4-4fb6-a971-f86c924a9c20","text":"Ukrainian is an artificial language created in the USSR.","date":"2019-03-05 18:56:23"},{"id":"36ed0712-67c2-4c18-8b10-d47f1abaa21d","text":"Fruits and vegetables with five-digit stickers starting with 8 are genetically modified and should not be bought.","date":"2024-06-09 00:00:00+00:00"},{"id":"16f59642-6b9e-473c-98f4-16e38037a32a","text":"600,000 Americans die each year from COVID-19 vaccines.","date":"2023-04-20 00:00:00+00:00"},{"id":"b9965956-2e89-4214-91ce-8b4af2583f6f","text":"Ivanpah\'s closure proves that solar power is unreliable.","date":"2025-06-03 00:00:00+00:00"},{"id":"fb88fa48-6744-4cdd-90bd-b2e2eddc6477","text":"A former NATO commander praised the Russian army and said Ukrainian forces should surrender.","date":"2023-12-16 14:45:00"},{"id":"0d799b10-e143-43f0-a3f7-dfa3398a7ea2","text":"A Ukrainian fighting vehicle entered Donetsk displaying a swastika.","date":"2014-04-26 13:00:17"},{"id":"a3589f11-b596-443e-978d-eaa153795255","text":"The Ukrainian military hid ammunition at the Zaporizhzhia Nuclear Power Plant and attacked the facility.","date":"2022-03-10 12:37:00"},{"id":"56f254a6-a740-484e-8f3d-5d3900878147","text":"Nationalists prevented a paramedic from saving a wounded person.","date":"2014-05-04 14:16:52"},{"id":"dcfd6c52-886d-4da0-896b-e61501045564","text":"Ivermectin caused the steep decline in COVID-19 cases in Indonesia.","date":"2021-10-09 00:00:00+00:00"},{"id":"e6112557-b39b-4c67-98fe-f9aa53d6ef2f","text":"The United States deployed 400 mercenaries to Ukraine.","date":"2015-02-01 17:02:45"},{"id":"47702199-6d33-44d8-8aae-6b64c07f1e45","text":"Britons want to end all military aid to Ukraine.","date":"2022-06-30 11:13:00"},{"id":"56780c55-2348-43c4-8452-d1280da550a8","text":"Natural immunity protects better than vaccination; unboosted people under age 30 had zero mortality risk; cloth face masks and school closures provided no benefits to children and caused harm.","date":"2022-03-23 00:00:00+00:00"},{"id":"7e015da3-09f9-424f-a950-64fac9192a16","text":"Sales of Ukrainian seat covers will revive Ukraine\'s economy.","date":"2016-11-15 23:02:22"},{"id":"22265ef5-f29e-463f-b350-1d766fff6dcb","text":"Face masks do not reduce the spread of respiratory infections; COVID-19 vaccines are ineffective and cause more severe disease; ivermectin, vitamin D, and zinc effectively treat COVID-19.","date":"2021-08-13 00:00:00+00:00"},{"id":"795bd233-4202-40bd-8378-0cfac2c7ae0e","text":"India\'s most populous state has declared it is officially COVID-19 free after promoting widespread use of a safe, proven medicine.","date":"2021-12-10 00:00:00+00:00"},{"id":"422fdfd1-eb02-4b3a-9f93-ed1833ef5a72","text":"Herbs heal illnesses and Vitamin C does not, because the human body is not composed of any Vitamin C.","date":"2022-06-29 00:00:00+00:00"},{"id":"8a8a4d58-3c81-4041-bf47-6870a50bc623","text":"The Odessa schoolgirl\'s suicide was caused by the May 2 events.","date":"2014-05-20 13:14:00"},{"id":"9856cfa4-7841-4cd4-bd37-fefbd15ed23a","text":"Warsaw learned from Moscow how to silence hostile voices.","date":"2020-09-11 17:38:16"},{"id":"e9248000-40b5-4f1d-a451-0c4d3506ff1c","text":"A top Ukrainian commander threatened to stage a revolt if President Zelensky capitulates.","date":"2025-12-08 00:00:00+00:00"},{"id":"91892df5-916f-4a03-b17e-bf8deae2e9c1","text":"The chance of dying from COVID-19 in California is 0.03% and COVID-19 is similar to the flu.","date":"2020-04-05 00:00:00+00:00"},{"id":"2e8e6368-68dd-45d5-a2dc-d4ee5ee70dd7","text":"All long-term tide gauge datasets agree that sea level rise has not accelerated.","date":"2020-01-04 00:00:00+00:00"},{"id":"ae143f57-f1cd-48e7-bd68-d27bf956dbd5","text":"The injured child shown in Mariupol footage is not from Mariupol.","date":"2022-03-26 13:29:23"},{"id":"95065231-541d-4d0c-9d43-2073939beee1","text":"In the United States, a person is six times more likely to be killed by a doctor than by a gun.","date":"2022-06-26 00:00:00+00:00"},{"id":"0b8cdef4-3750-4015-872a-477c40ea8043","text":"This is a brush rake used to clear underbrush and debris from the forest floor to remove fuel for wildfires.","date":"2018-11-21 00:00:00+00:00"},{"id":"4afa5b76-da52-452b-afff-cd61d074bee8","text":"Ukraine\u2019s General Staff extended the terms of service for conscripts.","date":"2015-07-13 16:00:42"},{"id":"9b3cf5e0-dbb6-4926-a623-746f661ed710","text":"The COVID-19 virus does not exist and has never been isolated.","date":"2020-12-10 00:00:00+00:00"},{"id":"c49e05e5-75c7-469a-aa86-55b964450bfa","text":"Turkey will seize Crimea and Donbas from Russia.","date":"2022-06-10 10:53:00"},{"id":"e11d0c1e-57e7-4703-8ef4-16156adef49a","text":"Antibodies produced against the SARS-CoV-2 spike protein cause myocarditis.","date":"2021-09-12 00:00:00+00:00"},{"id":"807b722b-d3a7-482e-9a03-1405557fdd75","text":"The United States allocated $250 million to Ukraine to fund war and provocations against Russia.","date":"2019-06-18 10:44:52"},{"id":"3458447f-3248-4191-a1b3-f1fd8a0008ac","text":"The U.S. Embassy in Kyiv and the U.S. Consulate in Odesa were evacuated.","date":"2022-07-18 16:44:00"},{"id":"b912dffc-b87d-482a-a16b-8acade76c109","text":"Countries with higher COVID-19 vaccination rates have higher excess mortality.","date":"2023-10-01 00:00:00+00:00"},{"id":"fbb9300f-ef97-4722-b7c1-d6227d91a0c8","text":"Ukrainian water bodies have been contaminated by the rapid expansion of cemeteries.","date":"2024-10-29 00:00:00+00:00"},{"id":"4580f05a-5688-4a45-a4f4-f4e24ea7b4ed","text":"Ukraine postponed salary increases for its military by one year.","date":"2018-01-02 00:07:32"},{"id":"3fd0eb19-f467-4489-9035-efc27bd8312a","text":"Twenty-five percent of Ukrainians consider themselves Soviet citizens.","date":"2017-07-13 22:16:21"},{"id":"455efb37-6619-499a-9e56-569078c9d715","text":"Climate scientists disagree about how much warming is caused by human emissions and whether that warming is larger than natural variability from the sun and volcanic eruptions.","date":"2024-04-15 00:00:00+00:00"},{"id":"d39e87c1-3ebc-48c7-9d34-8a569966f06a","text":"The United Nations recognized Crimea as part of Russia.","date":"2019-12-06 12:48:18"},{"id":"acd6cfba-d774-46ac-b0d1-bb30d348a186","text":"More than 70% of Ukrainians are willing to compromise with Russia to achieve peace in Eastern Ukraine.","date":"2019-12-16 21:11:41"},{"id":"9b0fbaf1-3523-4428-9061-25539ad38933","text":"Cats carry coronavirus and infect humans","date":"2020-04-09 22:35:00"},{"id":"f4628d9e-3224-4456-9e45-eee7e8392a37","text":"Ukraine is hiding recordings of the Malaysian Boeing flight controllers\' conversation.","date":"2014-09-10 14:26:48"},{"id":"6b684f88-2189-44bc-ba7b-ff150306e2c6","text":"A major autopsy report shows people who died suddenly were killed by the COVID-19 vaccine.","date":"2022-12-13 00:00:00+00:00"},{"id":"1f6c819f-22c5-4385-8e22-29e91daee72b","text":"Ukraine is preparing an attack on Russian nuclear facilities.","date":"2019-11-06 12:51:43"},{"id":"9bd9610f-f0bb-42fb-939e-0d245615f203","text":"The COVID-19 vaccine contains bacteria and HIV and prevents the body from making new white blood cells.","date":"2021-11-11 00:00:00+00:00"},{"id":"5157bbae-9cf5-46ed-a5ad-28563ceb5c10","text":"A Harvard study found vaccinated people are twice as likely to be hospitalized after exposure to the Delta variant than people with prior natural SARS-CoV-2 infection.","date":"2021-07-19 00:00:00+00:00"},{"id":"f0ad29ad-7310-45a6-9b76-74881092c1ab","text":"Mass civilian casualties in the Kyiv region were staged.","date":"2022-04-03 20:43:48"},{"id":"128b6e5c-66bf-47e9-8a97-73b4406df76d","text":"Antarctica gained ice from 2021 to 2023 and global warming is over.","date":"2025-05-04 00:00:00+00:00"},{"id":"2653155b-5304-4055-b622-9ba7c16563d2","text":"Recent climate change is caused entirely by changes in solar activity, and CO\u2082 has no connection to climate change.","date":"2024-03-22 00:00:00+00:00"},{"id":"03f80d5d-9cd5-462d-8d22-644d5ef346fb","text":"A virus is not the cause of an illness; it is only a necessary factor.","date":"2021-04-16 00:00:00+00:00"},{"id":"de700e1a-915e-4484-a367-da94b659fb6d","text":"The U.S. government claimed vaccines gave far greater immunity than natural infection, that masks were effective, and that myocarditis was more common after infection than after vaccination.","date":"2023-10-16 00:00:00+00:00"},{"id":"1f0a4898-00be-4da4-b5b6-f17606255acc","text":"The OSCE found that Mariupol was shelled from Ukrainian positions.","date":"2015-01-28 14:52:16"},{"id":"c2c1f1f4-4e8e-45cd-873d-f4bf901f568f","text":"The U.S. is breaking high-temperature records much more often than it is breaking low-temperature records.","date":"2016-07-21 00:00:00+00:00"},{"id":"d9870079-2f16-4d1a-931b-bda57bea23e9","text":"Human-caused carbon emissions have no discernible effect on climate; carbon isotope ratios show recent atmospheric CO2 increases were caused by expansion of a more productive biosphere.","date":"2024-04-08 00:00:00+00:00"},{"id":"5d2f265b-1852-475c-90e8-d0dc9ce73cb6","text":"HAARP caused the recent floods in Spain, New Mexico, and elsewhere.","date":"2024-10-30 00:00:00+00:00"},{"id":"a8e84567-eb93-438f-9949-cebe49e48290","text":"National Security Chief urges Ukraine to prepare for war with Russia.","date":"2018-10-08 16:23:22"},{"id":"c5ff2590-0a26-4d88-9f39-d098cd3fddf0","text":"Russia sends only humanitarian aid to Donbas.","date":"2019-11-14 14:09:04"},{"id":"1cfecb95-178d-45b8-8ca5-332fe7d4466b","text":"Ukraine seeks to remove the Russian language from protections under the European Charter for Regional or Minority Languages.","date":"2025-08-11 00:00:00+00:00"},{"id":"e7e2a469-e7d8-4e18-ba82-631b19391ab3","text":"The UN admitted that a Bill Gates-funded vaccine is causing a polio outbreak in Africa.","date":"2020-10-09 00:00:00+00:00"},{"id":"0a9bd450-6735-4060-8152-3b9d3b22f36a","text":"Anti-corruption probes uncovered offshore accounts and escape passports tied to Zelensky aide Andriy Yermak.","date":"2025-12-11 00:00:00+00:00"},{"id":"4e28ac8e-2184-4ed8-bb9c-cc33dce59d2e","text":"Global warming stopped more than two decades ago, and half of the global temperature increase from January 1910 to January 2000 was caused by administrative adjustments.","date":"2022-09-06 00:00:00+00:00"},{"id":"474d7066-f672-4876-af13-b242b9502032","text":"Wearing face masks causes carbon dioxide toxicity and weakens the immune system.","date":"2020-05-13 00:00:00+00:00"},{"id":"3b1ecd72-8468-4cb4-a8a8-a2a7b1087d5d","text":"Peru suspended its contract to purchase Ukrainian aircraft.","date":"2020-09-26 12:36:25"},{"id":"a83232b1-08d5-4658-b88c-4a2f5e191dac","text":"Poland is responsible for starting World War II.","date":"2019-09-19 11:48:57"},{"id":"ba50652d-7543-43b6-9e02-0b28aaa41b56","text":"COVID-19 vaccine contains an aborted male fetus.","date":"2020-11-16 00:00:00+00:00"},{"id":"437d0d25-c2f2-4643-8e57-48cefb1d0e0f","text":"Ukraine pays four times more for gas than Russia.","date":"2018-03-09 13:43:09"},{"id":"1ba49034-44f7-4c43-af12-2f2e150e5d5b","text":"No Amish children have been diagnosed with cancer, diabetes, or autism; Amish children are largely unvaccinated; COVID-19 death rates in Amish communities are 90 times lower than in the rest of the United States.","date":"2023-07-18 00:00:00+00:00"},{"id":"3d46a623-76cd-4aa4-b111-1a23ab4bbef8","text":"A Ukrainian missile struck a Kharkiv government building.","date":"2022-03-01 15:11:00"},{"id":"94cbb44e-7ad1-4c2c-a84a-1197d216e7cf","text":"George Soros said that only Russia cares about Ukrainians.","date":"2024-04-15 10:36:00"},{"id":"4c4b0e97-6438-42fa-8e70-a270d6219668","text":"The Ukrainian diaspora condemns sanctions imposed on Crimea.","date":"2019-10-17 19:50:27"},{"id":"edc298c8-16c2-4af0-beda-99bf53575d1b","text":"Ukraine is preparing legislation to transfer Lviv Region to Poland.","date":"2022-11-05 13:51:00"},{"id":"c358057c-8a9f-4907-9c34-ba7d372e0bc6","text":"Ukrainian military personnel are defecting to the self-proclaimed Luhansk People\'s Republic.","date":"2022-02-24 20:58:55"},{"id":"b9cf8b72-5d1b-4f16-86f0-e3f7be2b3dcf","text":"COVID-19 vaccines cause fibrous clots in the lungs and blood vessels.","date":"2022-01-05 00:00:00+00:00"},{"id":"b5f94b88-20a6-4777-8314-1e09fe92f4ce","text":"Corruption in Ukraine increased by 500% over the past year, and U.S. aid is not reaching its intended targets.","date":"2023-04-21 13:56:00"},{"id":"70d44892-c7f8-445c-a4f1-d65699998e56","text":"Distributing weapons to the population caused crime to increase by 270%.","date":"2022-08-08 10:36:00"},{"id":"7b52ba03-0c7c-46a5-a9ad-c73a0081f33a","text":"UEFA is investigating a Ukrainian team for doping.","date":"2016-07-06 09:58:41"},{"id":"11daf81c-84f2-4989-87a3-077cc2fbea8d","text":"Some mouthwashes curb the coronavirus.","date":"2020-10-26 00:00:00+00:00"},{"id":"b73f5a87-73a5-46dd-9ecd-86efbd0a68c6","text":"COVID-19 vaccination increases the risk of autoimmune rheumatic diseases.","date":"2023-09-06 00:00:00+00:00"},{"id":"bd301cfe-c8a0-402f-b39a-0737e1fb5f05","text":"The New York Times calls for redefining death in Ukraine to permit harvesting organs from living people for transplantation.","date":"2025-08-10 00:00:00+00:00"},{"id":"11d7296f-5403-45eb-b0d5-7b03b9ace4db","text":"Scientists and policy-makers agree humanity will pass a point of no return once global mean temperature rises above 2\xb0C.","date":"2019-09-08 00:00:00+00:00"},{"id":"241a075b-b47b-4cdb-a812-edbf0a89feff","text":"Published studies show COVID-19 mRNA vaccines cause metabolic cardiomyopathy and sudden cardiac death.","date":"2023-10-27 00:00:00+00:00"},{"id":"95871097-5992-4f40-b6bf-a888c22bf1f3","text":"Dr. Robert Malone invented mRNA vaccines.","date":"2021-01-01 00:00:00+00:00"},{"id":"80745886-a9ac-4a94-953f-9c082ae76c8f","text":"The COVID-19 pandemic was planned; COVID-19 vaccines are experimental and VAERS shows they have killed thousands; vaccine-induced spike protein causes damage; people previously infected have permanent immunity.","date":"2021-12-23 00:00:00+00:00"},{"id":"cbd1af56-17d1-4f2a-a53a-a88d39fc29f1","text":"Wind turbines kill eagles, but more eagles are killed by other causes.","date":"2025-01-16 00:00:00+00:00"},{"id":"ceb0fff5-46aa-4019-994b-affd318b42e1","text":"Ukrainian military used phosphorus bombs against Russian forces.","date":"2022-03-01 10:29:00"},{"id":"d0a5b883-e100-4fb8-b710-5da3ddf49704","text":"Most Ukrainian refugees fled to Russia.","date":"2022-08-11 17:30:00"},{"id":"248f7289-5c06-491d-a0b6-436091b33dc7","text":"Placing a raw onion on the soles of the feet eliminates illnesses.","date":"2023-12-27 00:00:00+00:00"},{"id":"67e51910-6f7d-4924-9721-ad00edf8bd7f","text":"50% of internally displaced persons from Donbas are unemployed in Ukraine.","date":"2019-04-13 18:15:29"},{"id":"22e4c461-4770-4ea0-b169-eaecdcb4f6ef","text":"Russia returned captured Ukrainian ships as an act of goodwill.","date":"2019-11-22 11:15:38"},{"id":"d695ba75-31bb-430b-814c-f52894643bad","text":"Anti-NATO protests occurred in Bratislava and caused public unrest.","date":"2016-03-17 13:14:33"},{"id":"e2cda163-bf74-48b3-9ce6-ba74a554f5dd","text":"The Washington Post reports Western countries are sending weapons and troops to Ukraine.","date":"2023-01-23 11:43:00"},{"id":"b4889e7f-f86a-4fb9-819f-ef05968c529c","text":"Harry Hoxsey\'s herbal therapy cures cancer.","date":"2022-12-29 00:00:00+00:00"},{"id":"18a6e3e5-36aa-4e8d-a899-f48ada8bfd0d","text":"Richard Bartlett discovered a silver-bullet COVID-19 protocol and was silenced.","date":"2024-04-25 00:00:00+00:00"},{"id":"8ae12054-2167-4984-b6b1-86008eddb2c3","text":"The National Guard committed the Saurivka Massacre.","date":"2014-11-07 18:39:33"},{"id":"99d4b89c-d792-42ec-966c-c524a13af148","text":"Ukraine is a leading violator of Russians\' rights","date":"2021-03-02 12:58:00"},{"id":"13a23c89-11fc-4641-8963-83530ec35be7","text":"The Normandy Format meeting was canceled because Ukraine failed to keep its word.","date":"2020-09-02 11:58:12"},{"id":"0bfed9e2-8163-47a6-a7ae-ff0cf9c7b894","text":"Brain blood clots are 112,000% more likely to occur after COVID-19 vaccination than after influenza vaccination.","date":"2024-09-06 00:00:00+00:00"},{"id":"2b838aa3-e871-4afb-90e5-2b918262adde","text":"The increase in cancer after water fluoridation began proves fluoride causes cancer and water fluoridation is public murder on a grand scale.","date":"2023-05-11 00:00:00+00:00"},{"id":"6d25bfdb-3006-462e-bc9e-80e928211137","text":"European governments accuse Ukraine of increasing radioactivity.","date":"2017-03-05 07:55:50"},{"id":"ab55dba8-aedf-4992-9bb5-82d454a89462","text":"Face masks, vaccines, and frequent handwashing suppress our immune systems.","date":"2020-11-23 00:00:00+00:00"},{"id":"2dccbc59-d9b3-4575-8d1f-b6fef6c515fe","text":"Kyiv ended prisoner exchange talks with occupied territories.","date":"2018-05-07 10:13:20"},{"id":"7c597816-a45c-4e9b-9e6b-f17f838fa55a","text":"No tests reliably detect the SARS-CoV-2 virus.","date":"2020-06-04 00:00:00+00:00"},{"id":"601a74ac-c835-46a7-97d9-93b4633920f9","text":"COVID-19 vaccines cause blood clotting, infertility, and immune escape.","date":"2021-08-23 00:00:00+00:00"},{"id":"3d9b6b73-24b4-4c11-b015-9aff59721ad6","text":"The World Health Organization is pushing a vaccine-based depopulation agenda across Africa.","date":"2019-10-19 00:00:00+00:00"},{"id":"e07c3235-a892-4e9b-8d7d-27a0e973f4cd","text":"Carbon dioxide is not a pollutant; it is a harmless natural gas like water vapor and is beneficial for plants.","date":"2017-04-22 00:00:00+00:00"},{"id":"6f8c28ec-1158-4082-93cb-dd5fe64ccb81","text":"WHO admits high-cycle PCR tests produce COVID false positives; WHO guidance includes lower PCR cycle thresholds.","date":"2021-01-25 00:00:00+00:00"},{"id":"ba446c6e-d58f-4e5e-a537-f3c04ce2c398","text":"Mouth swabs are as accurate as nasopharyngeal swabs for COVID-19 testing, so nasopharyngeal swabs are unnecessary.","date":"2020-07-09 00:00:00+00:00"},{"id":"629da89b-c0d1-4e00-a631-f9127df0bed1","text":"55,000 years ago global temperatures were 2\xb0C higher than today; current warming is purely cyclical, human greenhouse gas emissions have no significant effect, and sea level will not rise.","date":"2019-07-05 00:00:00+00:00"},{"id":"99af38ad-538a-45e2-a467-40cb688f0fff","text":"Poland is increasing its influence in the EU to settle old scores with Germany.","date":"2019-08-20 12:48:30"},{"id":"20289216-72a0-4039-8094-a0a3d5d764a9","text":"Ukraine is a nuclear burying ground and is experiencing a second Chernobyl.","date":"2019-09-12 14:50:30"},{"id":"49a4ff07-a9ee-4afe-b60a-c3912a9ecbee","text":"One-third of Antarctic ice shelves will collapse due to global warming.","date":"2021-04-16 00:00:00+00:00"},{"id":"284c6be1-b028-45d4-b945-0297660ee5b2","text":"The January 2025 Los Angeles wildfires were caused by non-climatic factors and were not influenced by climate change.","date":"2025-01-22 00:00:00+00:00"},{"id":"09953f70-0b38-48b9-9a36-fb9a043eef1c","text":"Ukraine sold Moldovan missiles to ISIS.","date":"2019-08-01 14:21:55"},{"id":"4c018036-8386-42a1-8fa4-de8efde36646","text":"Mikheil Saakashvili fired officials to save 4 million hryvnias to move his family to Odesa.","date":"2015-06-01 12:00:11"},{"id":"c49b54a1-a379-46b6-b5fa-385217856dd5","text":"700 Ukrainian prosecutors received combatant status during the full-scale war.","date":"2024-02-05 15:55:00"},{"id":"43595c4b-2a87-45eb-9d9b-3fd7a30f928b","text":"Covid-19 vaccine mRNA cannot be broken down, and Covid-19 vaccines cause excess deaths and unprecedented blood clots.","date":"2023-09-17 00:00:00+00:00"},{"id":"cf0181d7-c14c-4b9f-a69e-ef445f0dfd90","text":"Russia saved the Zaporizhzhia Nuclear Power Plant from catastrophic conditions.","date":"2022-08-31 10:31:00"},{"id":"5293996f-523f-4c90-94a4-6b297adb7e7e","text":"Asymptomatic carriers cannot spread COVID-19; COVID-19 is not contagious; masks are not needed to reduce COVID-19 transmission from asymptomatic carriers","date":"2020-05-28 00:00:00+00:00"},{"id":"73839936-e78d-4d7f-9f8c-b9590b821dab","text":"The use of chemical weapons in Syria did not occur, and the attempt to poison Sergei Skripal did not occur.","date":"2020-10-02 09:57:00"},{"id":"baeda9b3-f4c9-4ccb-8521-0505f25cbbb2","text":"Ukraine legalized private armies to fight in Donbas.","date":"2020-02-27 15:18:43"},{"id":"2ec69792-8fba-405a-9a8f-c01c2aac78fd","text":"The United Kingdom invented reusable toilet paper because of anti-Russia sanctions.","date":"2022-08-20 16:35:00"},{"id":"1553fd7f-8aaa-419f-9fa1-7c73e091b80a","text":"All signs at the Kharkiv Unity March were in English.","date":"2022-02-08 13:53:31"},{"id":"b0524685-9242-4e30-a89f-72ec2d79f6ea","text":"Anti-Ukrainian billboards appeared in Poland","date":"2023-02-08 15:29:00"},{"id":"c34066bf-2577-4750-aee7-181b5235cb4f","text":"Biden\u2019s climate plan limits Americans\' meat consumption by 90% and restricts them to one burger per month.","date":"2021-04-22 00:00:00+00:00"},{"id":"1670e29b-19bd-4c53-a61a-438c242ee96a","text":"The Russian language is banned in Lviv, Ukraine.","date":"2018-09-21 15:55:09"},{"id":"27728a69-61ad-4642-938c-0424e17198f4","text":"The Pfizer bivalent COVID-19 vaccine causes strokes.","date":"2023-01-18 00:00:00+00:00"},{"id":"e88bbca7-cf56-4326-9c99-dc1647945e93","text":"China backs Russia\'s aggression in Crimea.","date":"2014-03-04 12:26:32"},{"id":"a88ec512-6b19-40e8-9245-9b1926568095","text":"Medicare data show COVID-19 vaccines increase the risk of death.","date":"2023-02-26 00:00:00+00:00"},{"id":"a6bfff66-26b1-4884-9570-878a4a484542","text":"Embalmers have observed that COVID-19 vaccines cause an increase in abnormal blood clots.","date":"2022-02-11 00:00:00+00:00"},{"id":"f578eb5f-3c4e-4ed6-86ac-07c7f1346e70","text":"Poland is pushing for the overthrow of Belarusian President Alexander Lukashenko at the European Union level.","date":"2020-08-12 16:55:00"},{"id":"b60b2fd7-3a6c-4b1a-8bef-470c8fe13273","text":"Wisdom teeth are meridian lines connected to the heart, and removing them causes heart problems.","date":"2024-08-05 00:00:00+00:00"},{"id":"d541576e-5c2c-4375-9f5a-a1cbb11155f2","text":"Mixing urine with salt determines whether a person is pregnant.","date":"2024-05-23 00:00:00+00:00"},{"id":"31a46b11-b9d8-4184-9630-493ef7925f06","text":"Eighteen proxy records show global temperatures were as warm or warmer 1,000 years ago.","date":"2019-07-26 00:00:00+00:00"},{"id":"c2055234-7d19-4f2f-8f93-5a3d0367ee7e","text":"OSCE confirmed 29 civilians were killed in Donbas in late January.","date":"2015-02-03 15:00:34"},{"id":"903e1681-1758-4c3a-9728-9fa8fd825a8b","text":"European countries cancel visa-free travel for Ukrainian travelers because of a measles epidemic in Ukraine.","date":"2019-03-14 09:11:01"},{"id":"4d7b5e3d-682c-406e-84d1-1663d708b648","text":"The Central Communication Port is being built to enable rapid transfer of US military forces.","date":"2018-04-20 11:00:34"},{"id":"8170569f-1511-43b2-bdea-43d9e3bb8330","text":"Increases in atmospheric CO2 are primarily caused by natural sources such as ocean outgassing, and human CO2 emissions are negligible in comparison.","date":"2023-10-03 00:00:00+00:00"},{"id":"660e4a47-1d5a-494e-8c42-4a00f7ce4a2d","text":"British military expert says Ukraine cannot retake Crimea.","date":"2023-03-06 15:54:00"},{"id":"69c57963-6437-4eae-aabd-8176cc30e300","text":"Polish TV used a map that showed neighboring Ukrainian regions as part of Poland.","date":"2023-01-18 17:55:00"},{"id":"04b07b43-91de-492d-b415-f6ff34cb0803","text":"Video shows people preparing body bags for an evening news clip during the COVID-19 pandemic.","date":"2024-04-17 00:00:00+00:00"},{"id":"5d2831f7-834e-409c-8e9d-48f747d564ea","text":"COVID-19 vaccines cause menstrual problems in women and vaccinated people cause health problems in unvaccinated people.","date":"2021-04-11 00:00:00+00:00"},{"id":"cf81ea82-4981-46af-b78d-7d932f523a9a","text":"A Russian strike caused a blackout in Odesa, and apocalyptic images from the blackout were shared online.","date":"2025-12-13 00:00:00+00:00"},{"id":"da359d6c-2a80-4518-96d9-6bbaad187c00","text":"Colostrum improves gut health and boosts immunity","date":"2025-11-04 00:00:00+00:00"},{"id":"a9ee6543-ba8e-418a-a114-c3ac7cc71a12","text":"The COVID-19 pandemic is a planned, staged pandemic created by PCR testing, not by the coronavirus.","date":"2021-06-19 00:00:00+00:00"},{"id":"cf566c83-3925-4984-884d-925ab1e46541","text":"A video shows an explosion at the Zhovti Vody uranium plant.","date":"2015-09-05 18:37:45"},{"id":"0b3c6f5e-1e59-433f-90ac-0ec8710352ac","text":"The world\'s largest EV charging station is powered exclusively by diesel generators.","date":"2024-08-31 00:00:00+00:00"},{"id":"051a8eae-085f-42a9-9e38-77d1995dd83a","text":"Hormonal birth control causes PCOS, hormonal imbalances, depression, and infertility.","date":"2021-11-11 00:00:00+00:00"},{"id":"b38be4e2-e4d7-4855-be09-04a41de1d4a4","text":"Studies prove geological forces, not atmospheric forces, are responsible for melting Earth\'s polar ice sheets.","date":"2019-11-22 00:00:00+00:00"},{"id":"0fd4b274-a470-4ec8-941b-630f63142a34","text":"Petro Poroshenko was drunk and removed from a Kyiv\u2013Moscow flight.","date":"2015-09-24 21:26:24"},{"id":"a70e8b59-7cfd-4220-bbf1-2c239ec82ce5","text":"Trump criticized U.S. aid to Ukraine and called Ukraine impoverished.","date":"2025-09-04 00:00:00+00:00"},{"id":"3d0c993b-38f6-4d18-976d-7c47411b31c3","text":"A photosynthesis study shows Earth is not warming as predicted by climate models.","date":"2023-01-12 00:00:00+00:00"},{"id":"5878fdea-e073-45e4-8f36-4da02f629c97","text":"Dr. Robert Malone invented mRNA vaccines.","date":"2021-08-26 00:00:00+00:00"},{"id":"70200cb1-3041-48a7-9e28-2cae2ee138c8","text":"Ukrainians called Russian children to stage a gas attack hoax.","date":"2023-01-22 16:47:00"},{"id":"da329360-2d3e-4b50-b7b3-6cce8f1aa433","text":"Birth control causes a far greater risk of blood clots than any COVID-19 vaccine.","date":"2021-04-13 00:00:00+00:00"},{"id":"ac802fe2-63ab-4c69-9886-f5a4d7657337","text":"Eating specific foods based on your blood type optimizes your health.","date":"2024-07-07 00:00:00+00:00"},{"id":"0b25b952-b8db-416d-8697-ee70e792870c","text":"Ukrainian refugees broke Van Gogh\'s chair in a museum.","date":"2025-06-15 00:00:00+00:00"},{"id":"af1aad82-b277-4834-9f9c-1ab8d24f2d7e","text":"Brigitte Macron\'s personal doctor was found dead in Paris and planned to reveal the First Lady\'s secret to the press.","date":"2025-07-01 00:00:00+00:00"},{"id":"1ba8d895-5f78-4f0b-bd05-4d1641e4ce5d","text":"Pathogens do not initiate disease; an acidic, compromised cellular terrain initiates disease and pathogens only appear as a result.","date":"2020-03-25 00:00:00+00:00"},{"id":"d1ba53b6-47f9-4280-9fc0-fd09d18c4fc2","text":"\\"Vatnik\\" renounced Ukrainian citizenship.","date":"2015-04-23 16:05:15"},{"id":"ceed53ab-4e93-475a-986c-3a214d121952","text":"Dr. Anthony Fauci\'s 2004 interview remarks about the flu vaccine prove that natural immunity is the best protection against COVID-19.","date":"2022-04-01 00:00:00+00:00"},{"id":"36097c8c-85b0-431e-bd33-a9103b04ef79","text":"A photo of shelling in Israel is presented as showing shelling in Donetsk.","date":"2015-08-30 18:31:43"},{"id":"72127d66-fd32-491d-87df-078b95146b02","text":"The Hague Tribunal will investigate Ukrainian crimes in Donbas.","date":"2020-12-18 17:54:55"},{"id":"35864078-cc2c-41ff-88aa-8e1e32ed9739","text":"More babies die from abortion in two days than have died from coronavirus so far.","date":"2020-09-30 00:00:00+00:00"},{"id":"483f9100-c4ca-4586-ba84-682f095310ad","text":"The European Court refused to return Crimea to Ukraine.","date":"2014-06-09 20:33:45"},{"id":"ece9466a-65bf-4d30-926e-70674b63d79c","text":"Arseniy Yatsenyuk and Oleksandr Turchynov were booed and whistled at the Eternal Flame in Kyiv.","date":"2014-05-10 17:14:53"},{"id":"73181885-0295-4b62-8463-85f7ebaa38d5","text":"Exipure is scientifically proven to cause weight loss; BPS-5 effectively reduces blood pressure.","date":"2022-05-19 00:00:00+00:00"},{"id":"fc3e0635-9b91-40ff-87d2-363a6d9ac2f0","text":"Drunken US mercenaries rampaged through Mariupol.","date":"2016-01-09 21:27:01"},{"id":"6212f3e0-6ac0-4064-9593-a4457754360f","text":"Petro Poroshenko calls for ending sanctions against Russia.","date":"2017-02-06 22:56:06"},{"id":"029d7549-48b7-4bf3-a6fb-f63d4e907818","text":"Scores of Ukrainian stars performed in Russia.","date":"2017-07-10 15:55:44"},{"id":"4be3f643-2aa0-4579-98ca-14d97784ea1a","text":"Berkut commandos who refused to kneel were burned alive in Lviv, Ukraine.","date":"2014-03-26 10:38:09"},{"id":"4227afee-e3b9-478c-ab36-4fde24ad8ff0","text":"COVID-19 deaths were vastly overcounted.","date":"2022-10-03 00:00:00+00:00"},{"id":"3b9d9666-2869-4df3-9b66-779b29564f56","text":"COVID-19 vaccine recipients are ineligible to donate blood.","date":"2024-02-23 00:00:00+00:00"},{"id":"17279c2a-f5dd-468e-a0a7-b2b33e72993e","text":"Carbon dioxide does not control the climate.","date":"2022-08-30 00:00:00+00:00"},{"id":"ffea4765-c803-4d76-adcb-556ad0a86333","text":"82% of women who received the COVID-19 vaccine between 30 days and 20 weeks of pregnancy had miscarriages.","date":"2021-07-06 00:00:00+00:00"},{"id":"62670d51-2419-4ae6-9c54-f93a58e21695","text":"People who receive a vaccine under Emergency Use Authorization cannot sue vaccine manufacturers; after full approval they can sue, unless the vaccine is recommended for children, in which case they cannot sue.","date":"2021-12-22 00:00:00+00:00"},{"id":"5628795e-a7c7-44b0-ac00-289259aa71d5","text":"NATO is preparing for war with Russia.","date":"2019-12-28 22:12:59"},{"id":"9134b5dd-9cec-45cb-a37a-823fcc4afdca","text":"The vaccine causes death in 33% of people, while the virus causes death in 0.06% of people.","date":"2020-08-15 00:00:00+00:00"},{"id":"c4c0a228-b520-4446-9ced-f9600e63b724","text":"Vaccines, an MTHFR genetic mutation, and glyphosate exposure cause autism in children with brain injuries.","date":"2023-11-23 00:00:00+00:00"},{"id":"52270120-a27d-4e6b-8201-b95d76e61a23","text":"Ukrainian men in Germany are recruited into Ukraine\'s armed forces in exchange for German citizenship.","date":"2024-04-19 20:31:00"},{"id":"b8b249d9-68ba-4bc6-8783-fc55db74b4c2","text":"A Ukrainian deputy minister called for using the Ukrainian army to retake Crimea.","date":"2018-10-25 10:22:39"},{"id":"2e35d598-1ead-4cc9-b263-0f8e9b46350c","text":"Ukraine\'s credit rating has fallen.","date":"2017-05-03 11:25:26"},{"id":"5562da73-c4f7-47a9-913d-2c215d69d25f","text":"The American Journal of Medicine admits it was wrong about hydroxychloroquine and published evidence that hydroxychloroquine prevents COVID-19.","date":"2021-03-02 00:00:00+00:00"},{"id":"c85c2b54-faa7-4ad6-a66a-50cb0e2adde2","text":"Pope Francis congratulates Vladimir Putin on his presidential election victory.","date":"2024-03-21 17:51:54"},{"id":"1dad3c34-9c46-4fae-b996-8d36deac0c7d","text":"Ukrainian food prices are equal to EU food prices.","date":"2018-02-22 14:32:53"},{"id":"ed43efaa-4059-4449-a36f-e665653f8a9a","text":"Russia is depriving Ukraine of water from the Dnipro River by cutting off the river upstream.","date":"2020-10-30 12:45:40"},{"id":"2d283ea9-3c37-44f9-a526-ca0bf56a29a2","text":"Raw thermometer data show the US cooled for 80 to 90 years, and official temperature graphs were altered to falsely show warming.","date":"2019-07-20 00:00:00+00:00"},{"id":"6bcefa92-a75c-4f2c-b084-e57272699893","text":"The Red Cross has ceased operations in Ukraine.","date":"2022-10-10 18:16:50"},{"id":"7034a168-c32c-46c5-97d5-7011a7e583e4","text":"One vaccine injury occurs for every 39 vaccine doses administered.","date":"2019-10-10 00:00:00+00:00"},{"id":"e95e4e59-1c46-4d1d-a26e-f51adfada1dc","text":"Rising atmospheric CO2 has slightly cooled the planet.","date":"2020-02-18 00:00:00+00:00"},{"id":"1bd00c6c-59cd-4387-a54b-b32f98e0f725","text":"Ukrainian soldiers rejected a patriotic greeting.","date":"2018-02-13 14:42:35"},{"id":"147d519f-3a24-41c8-93ae-b6104a3af9aa","text":"The Ukrainian military violates the ceasefire most.","date":"2019-09-14 11:58:03"},{"id":"3508161d-b09c-4ca1-b358-f8f40784f430","text":"Alzheimer\u2019s disease did not exist 40 years ago; cholesterol-lowering drugs and cholesterol-reducing diets cause Alzheimer\u2019s disease.","date":"2023-03-11 00:00:00+00:00"},{"id":"6cb08a1b-cb67-4b66-9997-d0d027691a7d","text":"The Red Cross says people who received a COVID-19 vaccine cannot donate convalescent plasma because the vaccine destroys SARS-CoV-2 antibodies.","date":"2021-09-20 00:00:00+00:00"},{"id":"d0c64c05-1611-406c-997b-2bcaddb144c5","text":"COVID-19 infection fatality rate (IFR) is 0.1% to 0.3% and COVID-19 is as lethal as severe influenza.","date":"2020-08-26 00:00:00+00:00"},{"id":"d325b518-52fc-414b-a998-6a1c6cee814c","text":"Conscription notices are being handed out at voting stations.","date":"2019-03-31 14:01:50"},{"id":"61cdd9bb-d06d-4548-bf22-2ac0469d141d","text":"Zaporizhzhia City Council rejected the Ukrainian language.","date":"2016-02-04 16:00:36"},{"id":"2d0a4efb-49ce-4c42-9c72-09386900102c","text":"The governor of Kherson Oblast said that Hitler was justified.","date":"2014-05-10 17:49:43"},{"id":"81ded9b1-7e19-4e85-a496-51915d145a74","text":"Denmark asked Ukraine to return military aid.","date":"2026-01-10 00:00:00+00:00"},{"id":"cf74c828-a854-4b1d-b0ff-41334ff95896","text":"ICC arrest warrants for Russian military leaders have had no consequences.","date":"2024-03-08 12:46:00"},{"id":"9a821e6d-27d9-4ef5-8b63-5522dba4f695","text":"The Russian military captured Mariupol in less than one hour and the Ukrainian army was completely incompetent.","date":"2022-03-03 12:00:00"},{"id":"0c1583a0-e152-4d85-a208-4c1a7350543c","text":"Vitamin B17 was banned by the United States because it kills cancer cells.","date":"2023-10-03 00:00:00+00:00"},{"id":"ffe40741-bfba-408b-80dc-6d4c93a3476b","text":"The Ukrainian government refuses to evacuate its citizens from Israel.","date":"2023-10-11 11:55:00"},{"id":"a2a1873a-cb7f-4eea-b881-7962bae1b5e2","text":"An Italian restaurant advertises a \\"Diablo Zelensky\\" pizza topped with the bodies of Ukrainian soldiers.","date":"2024-04-17 09:56:00"},{"id":"c04ab974-f5a6-4674-9617-93b3a84224ad","text":"Vaccines contain toxic aluminum and mercury","date":"2022-03-09 00:00:00+00:00"},{"id":"7ca392ad-9d19-4328-ac1c-38ebd5d5ff79","text":"Climate scientists say aspects of Hurricane Harvey show that global warming made the storm worse.","date":"2017-08-29 00:00:00+00:00"},{"id":"fa69523a-2b83-4e43-8a72-b11ce2258253","text":"Vaccines cause autism.","date":"2020-03-05 00:00:00+00:00"},{"id":"b41a3136-a2a6-4ce4-aadb-8c179bf11bf1","text":"COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people are not a threat to vaccinated people.","date":"2022-08-10 00:00:00+00:00"},{"id":"0c8c8f99-e607-41e7-947f-ad2fc3b0e67a","text":"Ivermectin and mebendazole are effective treatments for cancer.","date":"2024-10-13 00:00:00+00:00"},{"id":"95a7d096-c622-46dd-9590-b080e9861d12","text":"Charlie Hebdo ridiculed Ukrainian fencer Olha Kharlan.","date":"2023-07-31 10:26:14"},{"id":"b5b85d0e-e9b3-4a75-9ffb-e456c3336ec0","text":"A pro-Russia mass rally occurred in the United States.","date":"2016-06-15 22:13:58"},{"id":"7ae4bce7-e6cf-4723-b7da-3c62d70ebaa6","text":"A NATO brigade arrived in Donbas.","date":"2018-12-10 14:13:43"},{"id":"619baab4-41a4-48c7-b3f9-7fdbfc3cd7a0","text":"Ocean acidification does not harm marine life.","date":"2016-04-30 00:00:00+00:00"},{"id":"521328fb-fec8-45c2-8804-3961edd8a930","text":"The Ukrainian government in Kyiv forbids citizens from keeping in touch with Ukrainians in the temporarily occupied territories.","date":"2023-10-17 17:01:00"},{"id":"487d5ad2-aa34-46dc-91dd-b7dac83edd06","text":"Ukrainian saboteurs were intercepted in Luhansk.","date":"2017-11-24 10:43:22"},{"id":"02822320-cd99-4d29-9bf9-f058f84e00bd","text":"The United States banned vitamin B17 because it kills cancer cells.","date":"2023-03-01 00:00:00+00:00"},{"id":"bb40c0b2-397b-4ba4-a644-11c4285e3229","text":"Mammograms cause cancer.","date":"2024-05-31 00:00:00+00:00"},{"id":"a3132792-ed94-47b6-879b-3555eb8e2014","text":"COVID-19 vaccines weaken the immune system and caused a 20-fold increase in cancer in vaccinated patients, an Idaho doctor reported.","date":"2021-09-27 00:00:00+00:00"},{"id":"feb9f397-7bc5-44bd-aa8f-04394b7447f4","text":"Ukraine will blow up 550 tons of ammonia in Novotroitske.","date":"2025-07-17 00:00:00+00:00"},{"id":"fe5053f4-21b7-492d-9e91-012a110d99b6","text":"500 Ukrainian security officers block Kiev Street.","date":"2015-03-19 21:53:50"},{"id":"c500b931-6581-40b0-8b04-bbaad04970c7","text":"The Ukrainian army shelled Donetsk.","date":"2015-07-23 19:29:59"},{"id":"ab7fc75d-0dd5-476c-baac-dbac6bb06edb","text":"A new study shows mRNA from COVID-19 vaccines is present in breast milk and is dangerous to infants.","date":"2023-09-22 00:00:00+00:00"},{"id":"12228c9e-42ba-4dc3-86c1-e440002f2e43","text":"Ukrainian Right Sector radicals attacked peaceful Russian civilians in Athens.","date":"2018-02-17 14:25:19"},{"id":"f5dd556e-d81a-422c-a1df-38d595b542fa","text":"The IPCC concedes there has been no increase in extreme weather events.","date":"2017-10-08 00:00:00+00:00"},{"id":"a69c3605-cb8c-4cc4-af1a-49a5fd1ec2e3","text":"The EU provides financial aid to Ukraine in exchange for migrants.","date":"2018-07-03 13:39:20"},{"id":"1860282a-df94-40d6-aefa-d33a780e797e","text":"The United States will pay reparations to Ukraine.","date":"2023-06-26 10:17:00"},{"id":"75781163-5d59-4792-a3e9-6565f8963430","text":"Natural immunity to COVID-19 persists for decades; pregnant women are not at risk from COVID-19; COVID-19 vaccines contain DNA plasmids; COVID-19 boosters are unsafe.","date":"2023-08-29 00:00:00+00:00"},{"id":"2994c2c0-f0d0-4e0b-9ece-0a4cdb450145","text":"Receiving more COVID-19 vaccine doses increases your risk of getting COVID-19, and COVID-19 vaccines contain DNA fragments that modify your genome and cause cancer.","date":"2023-03-11 00:00:00+00:00"},{"id":"7200c0eb-fa7a-4eec-b545-f33baa33b876","text":"Ukraine lost 50% of its GDP due to sanctions related to Russia.","date":"2018-02-06 14:55:17"},{"id":"8f562a60-4720-4b12-bf8e-97447354a6b4","text":"The United States banned 155 imports from Ukraine because of Ukraine\'s political situation.","date":"2018-05-10 15:15:23"},{"id":"9d71426d-92dc-4461-8d66-7cb7700cf2cf","text":"The son of a German tankman donated a World War II tank to Ukraine.","date":"2014-10-04 08:19:01"},{"id":"e79b7f1e-c540-48f9-99a0-eb9f272ff2a7","text":"COVID-19 vaccines cause autism in rats.","date":"2024-01-18 00:00:00+00:00"},{"id":"08570a75-8b33-4e1e-90f0-ccc77c0eedee","text":"Ukrainian paratroopers infected fellow Ukrainian soldiers after training in Western Ukraine.","date":"2020-11-25 15:00:37"},{"id":"62df3fdc-6f66-41ed-a406-3be29d71c41a","text":"COVID-19 mRNA vaccines do not work and are causing serious harm, including death.","date":"2023-09-02 00:00:00+00:00"},{"id":"99c2d825-ffe1-40dc-9c1e-e1013924648c","text":"RSV vaccines cause deaths and neurological disorders, and the CDC covered up reports of deaths among vaccinated individuals.","date":"2024-03-14 00:00:00+00:00"},{"id":"4dd9f52f-d8e8-4544-9e2c-b1bb11889b2a","text":"Ukraine disrupted NATO\'s Sea Breeze naval exercises.","date":"2016-07-21 22:04:03"},{"id":"f027e67c-47bf-4105-881f-4d217b3544c9","text":"Huge numbers of Ukrainians hate the Kyiv regime.","date":"2022-09-07 15:15:00"},{"id":"629f13af-3980-4d8c-bddd-b43cd3168dd4","text":"The World Trade Organization forced Ukraine to buy Russian fertilizer.","date":"2020-04-17 07:26:19"},{"id":"3a64efca-f394-4b04-8fd4-e08edd670201","text":"More than 200,000 people died due to the COVID-19 vaccine.","date":"2023-03-02 00:00:00+00:00"},{"id":"9f9e5b15-68b3-4929-ae84-37177d1d515b","text":"Ukraine is Europe\u2019s poorest country.","date":"2017-12-21 12:25:55"},{"id":"d1bc893f-3614-4a43-a75d-205bd1a7adcc","text":"Ukrainian military refused to help a teenager injured by an explosive device.","date":"2021-01-20 15:51:53"},{"id":"4d412db5-fc61-4fa9-81b0-e9bc9d2d50b1","text":"A TIME employee posted a magazine cover showing Vladimir Putin labeled \\"Man of the Year\\"","date":"2014-12-05 15:50:53"},{"id":"fd30fa9d-5404-4600-a306-94fa14b3f60f","text":"Ukrainian women impregnated by Russian soldiers are forced to have abortions.","date":"2023-12-19 10:10:00"},{"id":"a4b251cd-8f24-4aab-8d8e-a919692a5b87","text":"Arms supplies to Ukraine are lost and unaccounted for.","date":"2022-08-23 16:32:51"},{"id":"2a34535b-7f20-42f9-a107-9b2729dfb4aa","text":"COVID-19 vaccination increases the risk of myocarditis in young adults by 800 times compared with being unvaccinated.","date":"2022-10-29 00:00:00+00:00"},{"id":"c980a339-5089-4aea-b722-8818f6df5b36","text":"The majority of Ukrainians are waiting for Russia to rescue them.","date":"2022-04-20 12:11:00"},{"id":"1d9c6663-ae5a-4d9f-a856-e523287304a5","text":"Unvaccinated Amish do not get cancer, autism, or heart disease.","date":"2020-05-20 00:00:00+00:00"},{"id":"8bb31240-1aee-45d9-9cbe-f51c9c7aaeae","text":"Russian troops destroyed an oil depot in Syria.","date":"2015-12-05 20:39:49"},{"id":"1a4fd326-341e-417a-b590-42a241e07a85","text":"A majority of Europeans oppose new sanctions on Russia.","date":"2022-08-10 15:47:00"},{"id":"ba5e3a7c-42f8-4a47-9032-4c310b28c369","text":"The increase in solar activity during the twentieth century accounts for 50% to 66% of all climate change.","date":"2019-08-11 00:00:00+00:00"},{"id":"eeced08d-688c-409e-a85d-20f0a611f2bc","text":"A majority of Ukrainians oppose both the Ukrainian Army and President Volodymyr Zelensky\'s war in Donbas.","date":"2021-07-07 20:49:09"},{"id":"b3724cba-b469-4f18-9cbe-c5a8feb6e61b","text":"Benzene in benzoyl peroxide-containing skincare products causes cancer.","date":"2024-03-14 00:00:00+00:00"},{"id":"432b9133-94d2-41a0-bb39-3fb754586948","text":"Ukraine\'s currency has collapsed due to the Turkey crisis, IMF actions, and the collapse of the National Bank of Ukraine.","date":"2018-08-21 18:09:14"},{"id":"3bc8538e-2a63-4a8e-b482-f2312ef30972","text":"Germany has stopped supplying weapons to Ukraine","date":"2022-03-22 12:12:06"},{"id":"db74244d-4130-44b3-a3be-416717218122","text":"Switzerland abolishes refugee status for Ukrainians","date":"2025-06-21 00:00:00+00:00"},{"id":"eba77011-2a84-495d-a255-b0a33266a65b","text":"Ukrainian National Guard soldiers are throwing the bodies of killed men.","date":"2014-05-05 14:43:36"},{"id":"e4a1ef12-8a66-4e6b-972b-df2ae81e6f7d","text":"A Ukrainian crowd beat a Russian boy to death in Germany.","date":"2022-03-21 16:29:30"},{"id":"b015f81f-6b59-4434-a79a-66d9ba97c4b3","text":"An autoimmune condition is the number one indicator of parasite infection.","date":"2023-06-23 00:00:00+00:00"},{"id":"18fafe7f-080f-4e66-9efb-f04c0f9fcb2e","text":"Cultivated meat is made from cancerous and precancerous cells.","date":"2023-07-15 00:00:00+00:00"},{"id":"885f411a-bf81-49ec-b44c-6940e82f3240","text":"Russian language is being suppressed in Ukraine.","date":"2018-01-29 20:19:19"},{"id":"9743b311-cafb-4cfd-8609-7c80f2ff9d89","text":"The ozone layer is healing.","date":"2020-03-26 00:00:00+00:00"},{"id":"b9a81b1d-f10a-4dcc-9fe4-d39ef8898b5f","text":"The Ukrainian military suffered losses in eastern Ukraine.","date":"2018-05-17 10:39:37"},{"id":"cd1059a4-0e64-48b1-8826-fcf1496bab8a","text":"Ukrainian sailors threatened to return to Crimea.","date":"2018-04-21 11:19:30"},{"id":"20d51616-8577-4377-ac82-80c75ed27783","text":"Atmospheric CO2 concentration is not correlated with global temperatures.","date":"2025-03-18 00:00:00+00:00"},{"id":"e5f5da0c-a863-47e1-a6d1-56961623cf7b","text":"The European Parliament accuses Ukraine of committing Soviet crimes.","date":"2019-10-18 11:09:14"},{"id":"efa9739d-2b3c-43b3-985b-ccda54d8a4fe","text":"Ukraine will classify residents of Crimea and Donbas as terrorists.","date":"2017-04-05 02:29:58"},{"id":"dde2b01d-d592-470e-bbc4-b54f19560170","text":"Vitamin D3 is irradiated sheep\u2019s wool mixed with chloroform and is rat poison; low vitamin D levels are caused by lack of sunlight and high vitamin A diets.","date":"2024-08-22 00:00:00+00:00"},{"id":"02f967fe-336b-4f09-8746-3cbc504bfd90","text":"Sunscreens and sunless tanning products cause cancer and contain cancer-causing ingredients, and the sun does not cause cancer.","date":"2022-09-04 00:00:00+00:00"},{"id":"a1defc99-37ef-4f95-b417-6ff608a4c6e3","text":"Ukraine will lose several regions to Russia.","date":"2020-05-18 18:55:24"},{"id":"308308e1-766a-4770-bf8b-7e2599a012d9","text":"There has been no excess mortality from COVID; lockdowns do not prevent the spread of COVID; masks do not work to prevent transmission; PCR tests were not designed to diagnose illness.","date":"2021-09-22 00:00:00+00:00"},{"id":"ab930dd7-1c58-49f1-888a-3ccb43f3e76f","text":"A Ukrainian serviceman was sent to Avdiyivka to be killed for posting a TikTok.","date":"2023-12-19 12:31:00"},{"id":"8344aced-aaf9-4585-8b7a-4ef53a11ef4b","text":"A separatist was buried alive in Ukraine.","date":"2016-06-23 18:28:15"},{"id":"9de16975-a6f2-492e-886a-e269c2d474dc","text":"Vaccines caused autism to increase from 1 in 10,000 to 1 in 50.","date":"2013-04-07 00:00:00+00:00"},{"id":"05e621ba-ae52-4afa-9b17-06cbf18f9681","text":"U.S. regions with higher average COVID-19 vaccine doses had larger increases in mortality in 2022 than in 2021.","date":"2023-03-14 00:00:00+00:00"},{"id":"6196be98-1cd7-4397-8565-f5ba5461fded","text":"Medical exemptions are unavailable for people with contraindications to the COVID-19 vaccine, including those with a history of blood clotting or prior adverse reactions to vaccines.","date":"2022-12-22 00:00:00+00:00"},{"id":"39744d7d-3fbf-4158-9ebf-d7a34bd509b3","text":"Normalised Diatomaceous earth contains silica that absorbs minerals, water, and vitamins, and diatomaceous earth is antiparasitic and detoxes the body.","date":"2024-10-12 00:00:00+00:00"},{"id":"d2746d11-47fa-4951-baac-d714323e7a24","text":"Vaccines caused an explosion in childhood cancer, and vaccine package inserts state vaccines were not tested for mutagenic effects.","date":"2024-01-19 00:00:00+00:00"},{"id":"8f21e90b-1a0f-4031-bfce-d0e4f75835aa","text":"President Poroshenko\u2019s confectionery company is opening new branches in Russia.","date":"2017-09-27 10:27:51"},{"id":"01508c85-b479-4298-b689-24d128545f43","text":"A survey found that the majority of Ukrainians liked living in the USSR.","date":"2020-05-19 11:55:00"},{"id":"0f5cc466-f266-46f0-bb36-c4c140c7386e","text":"Oleg Sentsov has a star on the Hollywood Walk of Fame.","date":"2018-09-01 09:04:00"},{"id":"b25d83b5-974d-4e6b-9335-6426f9c6b6bc","text":"COVID-19 vaccines caused over 4,000 deaths; COVID-19 survivors cannot be reinfected and do not need vaccination; natural immunity is stronger than vaccine immunity; vaccine-produced spike protein is dangerous.","date":"2021-05-19 00:00:00+00:00"},{"id":"ff96108d-4f5c-4d0d-beef-451db8a86aa7","text":"The Earth has cooled continuously for 4,000 years and is cooler now than during the Medieval Warm Period; reported recent warming is only an artifact of the measurement start date.","date":"2023-05-15 00:00:00+00:00"},{"id":"28b2429a-0096-4d7a-948d-059fa77fc5c9","text":"The Russian flag was burned in Belarus.","date":"2015-02-27 10:43:39"},{"id":"56f90ee6-1209-4b41-abc3-e377d4df66b2","text":"Patents for weather-modification technologies prove that HAARP and NEXRAD are used to manipulate hurricanes.","date":"2024-10-11 00:00:00+00:00"},{"id":"21b59191-bead-4584-9277-0995dc1dd492","text":"The European Parliament says Kyiv cannot pay off its debts.","date":"2022-07-08 13:56:49"},{"id":"d94c0bdd-38a8-4849-8dda-6b5e0a842602","text":"The United States is preparing a new revolution in Ukraine.","date":"2018-01-13 22:44:57"},{"id":"8bacacff-aa61-4eac-b5ae-410a1358b09f","text":"Kyiv is blackmailing the West over Crimea.","date":"2020-06-07 09:39:32"},{"id":"62e384e2-a7d6-4f5d-baaf-5e1405aaf635","text":"In the United States, doctors kill six times as many people as guns do.","date":"2022-06-13 00:00:00+00:00"},{"id":"350050bd-a85a-4627-9297-e06afeb9261c","text":"Leaky COVID-19 vaccines are causing SARS-CoV-2 to evolve rapidly; COVID-19 vaccines do not prevent disease or death; childhood vaccines are unsafe.","date":"2023-09-07 00:00:00+00:00"},{"id":"2fd3b2a3-f58c-4367-bcd2-a0ab907918e8","text":"Kirovograd residents overwhelmingly prefer the city\'s tsarist-era name.","date":"2016-07-22 09:42:30"},{"id":"14cb414f-ab88-4bba-a113-ee4dd72a7f1c","text":"Pfizer documents prove mRNA COVID-19 vaccines contain graphene oxide.","date":"2023-07-15 00:00:00+00:00"},{"id":"b8d41819-464f-472d-85d4-4d8825b72dc8","text":"Petro Poroshenko allows Ukrainian civilians to legally possess and carry firearms.","date":"2015-05-27 15:53:57"},{"id":"28a9e1c3-f6b7-4263-a28e-da682072bcbf","text":"A Ukrainian general admitted that Ukraine\'s professional army has been knocked out.","date":"2023-04-28 10:54:00"},{"id":"561143dc-b82e-4c1b-972e-0d27441965bd","text":"Data centers cannot run entirely on renewable energy.","date":"2025-07-15 00:00:00+00:00"},{"id":"bfa609f9-2ee5-4041-9ead-29eb12891c57","text":"Great Barrier Reef sea surface temperatures have not changed in the past 150 years.","date":"2021-08-28 00:00:00+00:00"},{"id":"e7eca5a0-30d0-431d-b66f-c8a1d6599ee5","text":"SARS was developed by humans and weaponized to attack human beings.","date":"2023-05-03 00:00:00+00:00"},{"id":"3b3f6b3c-9e02-41b0-8583-5212dd3b4f6f","text":"There was no unusual excess mortality from COVID; lockdowns did not prevent disease spread; masks did not work to prevent spread; PCR tests were not designed to diagnose illness.","date":"2021-04-10 00:00:00+00:00"},{"id":"3065442a-14b1-4449-b727-0b1cd300dd7c","text":"COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people do not pose a threat to vaccinated people.","date":"2022-10-04 00:00:00+00:00"},{"id":"bacee7fe-c702-44a9-b89e-4b1a69c6b672","text":"Data from 145 countries shows that COVID-19 vaccines cause increases in COVID-19 cases and deaths.","date":"2022-12-01 00:00:00+00:00"},{"id":"82edf1b2-9625-43b0-b7fc-50b60fd2bbef","text":"Raising more cows and eating more beef will save the planet because cows are carbon\u2011negative.","date":"2025-12-27 00:00:00+00:00"},{"id":"ded4eeef-c183-4ccc-8be3-7998293de30b","text":"A video shows American trainers teaching Ukrainian military personnel how to use an FGM-148 Javelin missile system.","date":"2015-01-09 13:29:53"},{"id":"bbcd424c-29ad-4d41-adb4-c97781a4b967","text":"Ukraine lost 234 planes and 137 helicopters since the war began.","date":"2022-07-07 13:41:00"},{"id":"132f6cc9-f538-4c83-9617-8e62245449fd","text":"Cow burps cause more damage to the climate than all cars on Earth.","date":"2019-02-21 00:00:00+00:00"},{"id":"2581b35a-6fe9-496f-8afb-21345fa2a8dd","text":"mRNA vaccines force children\u2019s bodies to produce toxic spike proteins that often cause permanent damage to children\u2019s vital organs, and vaccinating children provides no benefit to them or their families.","date":"2021-12-20 00:00:00+00:00"},{"id":"52519e4a-6c58-4d1b-89f7-04d1a7410ce5","text":"Natural immunity provides stronger protection than vaccine-induced immunity, and public health authorities lied when they said it was not better.","date":"2023-02-17 00:00:00+00:00"},{"id":"54fa8502-66e3-4d23-bee4-4544f015286d","text":"Gas station owners are refusing to lower fuel prices.","date":"2016-01-18 16:50:34"},{"id":"d31ecd38-9b36-4434-b556-2ed92e43b61f","text":"More than 100% of the warming over the past century was caused by human actions.","date":"2017-03-08 00:00:00+00:00"},{"id":"85ce5b6f-3f89-426a-b5a2-8d84eb7699e1","text":"The Kerch Strait incidents were a Ukrainian provocation.","date":"2019-05-29 09:40:32"},{"id":"1e126e36-eb40-4d99-8d99-4a44eb746256","text":"A study showed COVID-19 vaccines are more dangerous than COVID-19; children aged 12\u201317 are more likely to be hospitalized for myocarditis caused by the vaccine than for COVID-19.","date":"2021-12-15 00:00:00+00:00"},{"id":"0382d146-798c-4e98-bf90-fba4cf45a308","text":"Moscow Patriarchate priests were removed from President Volodymyr Zelensky\'s office after a false alarm.","date":"2023-03-21 09:50:00"},{"id":"65250e2b-f109-4e43-b765-be530433a66a","text":"Methane from cows is a small share of total greenhouse gas emissions, would be produced without cattle, and is not an important contributor to climate change.","date":"2024-09-01 00:00:00+00:00"},{"id":"b4a3e4f3-ace9-4d63-95ba-a78ebe688191","text":"Garlic is 100 times more effective than antibiotics.","date":"2020-02-17 00:00:00+00:00"},{"id":"2248e2d6-276e-470a-8a5b-f73747019001","text":"VAERS reports show HPV vaccines are ineffective and cause autoimmune and neurological disorders.","date":"2023-11-30 00:00:00+00:00"},{"id":"54cae87b-07e5-4e39-acd4-c29514c871df","text":"CDC admits 146.6 million Americans have natural immunity to COVID-19, and 94% of COVID-related deaths were not caused by COVID-19.","date":"2021-11-21 00:00:00+00:00"},{"id":"6fa5ba65-1b87-4285-a9a5-3a94554c67ad","text":"Video shows a Ukrainian soldier looting in Chechnya","date":"2016-02-08 20:44:40"},{"id":"64ffb265-5a1a-495e-aa14-80d2aa155824","text":"Britain proved it was involved in attacks on Crimea.","date":"2024-01-12 17:43:00"},{"id":"861580e2-8611-46a7-b914-edb294d8b916","text":"The Czech Republic refuses to accept migrants because of Ukraine.","date":"2018-08-31 10:01:25"},{"id":"2beb2d9c-db42-4203-90eb-078a562de80f","text":"The State Duma passed a law forbidding Russian citizens from leaving the country.","date":"2015-06-09 18:38:50"},{"id":"f32ed7eb-c541-4c90-afa3-c2403a0cd3b2","text":"Ukrainian military shelled Olenivka with HIMARS on President Zelensky\'s orders.","date":"2022-07-30 14:57:00"},{"id":"114a2918-55aa-4649-81ee-2d5875a81cc9","text":"COVID-19 vaccines make SARS-CoV-2 more dangerous by causing antibody-dependent enhancement (ADE).","date":"2021-07-28 00:00:00+00:00"},{"id":"3b5afae5-ebac-4413-bff8-cc414ef551ef","text":"A poll shows Ukrainians do not want peace and only want to fight Russia.","date":"2023-12-18 12:40:00"},{"id":"d5b22620-2260-4e65-a424-eaf06965e7e9","text":"The Vatican was the first to pay Russia for gas in rubles.","date":"2022-04-19 16:29:00"},{"id":"dded93d6-13c8-4f81-977e-0779477b6de6","text":"The spring sowing campaign is under threat because all grain was taken out of Ukraine.","date":"2023-02-10 12:28:00"},{"id":"22587ee9-0a3d-4963-818d-de36abce0d53","text":"Some mouthwashes help curb coronavirus","date":"2020-02-11 00:00:00+00:00"},{"id":"1d59567a-e2a4-47f5-aec4-3e370cc9791e","text":"Earth will enter a 30-year mini ice age.","date":"2020-06-02 00:00:00+00:00"},{"id":"d70bcda9-c233-4308-b6e9-0719754845a9","text":"The low death rate is caused by human memory T cells providing immunity beyond antibodies.","date":"2020-10-28 00:00:00+00:00"},{"id":"3cf506c1-c396-4fbf-877c-ec2c229ed925","text":"Ukrainian soldiers are promised a parcel of land and two slaves.","date":"2014-11-03 19:32:57"},{"id":"cd217be3-7c36-4052-868a-0f2a3b5364a3","text":"The COVID-19 pandemic was planned; the SARS\u2011CoV\u20112 virus was deliberately manipulated and did not jump directly to humans but was created through accelerated viral evolution.","date":"2020-05-04 00:00:00+00:00"},{"id":"a2ba01ad-c784-4902-81bb-447fade61de0","text":"The West will use weapons of mass destruction in Ukraine and then blame Russia.","date":"2021-05-21 13:44:49"},{"id":"3dbae1d6-6af2-4492-ae17-f58230ea2ffa","text":"The rate and magnitude of the reported late twentieth century (1979\u20132000) surface warming were within normal natural variability.","date":"2016-01-01 00:00:00+00:00"},{"id":"26ee7189-c0fb-4ab1-858c-0111039380b6","text":"The United States and Ukraine are preparing a new Chernobyl in Russia.","date":"2020-01-07 16:49:31"},{"id":"b3bc6c3c-8641-453e-a50d-dab1814cbc39","text":"Global leaders planned the pandemic and an 89-page PDF explains how they would implement the plan.","date":"2024-01-12 00:00:00+00:00"},{"id":"d8113053-efb3-41bd-b540-2e0ae0f26367","text":"Poles demand autonomy from Kyiv.","date":"2017-01-03 02:17:02"},{"id":"0d5871ed-f21e-491e-b9fc-e8a4f2b3d8c5","text":"CO2 concentrations in Earth\'s atmosphere are increasing faster than at any time in the past 50,000 years.","date":"2024-08-19 00:00:00+00:00"},{"id":"3b8b4ee9-f72f-4a96-93e5-cb907013d7db","text":"CDC has classified monkeypox as an airborne form of herpes that infects anyone within 15 feet, lasts 2\u20134 months, and causes paralysis.","date":"2022-08-04 00:00:00+00:00"},{"id":"2f3194b6-9742-4bc1-b6f3-965c8e1ccc22","text":"Mask mandates do not stop the spread of COVID-19, and overwhelming scientific evidence shows masks do not work.","date":"2020-11-11 00:00:00+00:00"},{"id":"dc8d8b18-4675-4d5e-907f-b718920445a9","text":"Ukraine will face new language divisions.","date":"2016-11-08 23:39:51"},{"id":"a40df7e2-c699-4e3b-b6df-5ac58bd94ea2","text":"European governments refuse to recognize Russia\u2019s invasion of Ukraine as aggression and refuse to establish a special tribunal.","date":"2022-08-07 14:34:50"},{"id":"d3846972-39e3-4228-82e3-9e77c1f80743","text":"Ukraine is deploying women to frontline combat due to heavy military losses.","date":"2026-01-07 00:00:00+00:00"},{"id":"e2404afc-9753-4d93-b38e-a46a7808158c","text":"Whooping cough (DTaP) vaccine is unnecessary and causes sudden infant death syndrome.","date":"2024-07-03 00:00:00+00:00"},{"id":"72583dd3-23b1-46be-b38c-c5b9919c8154","text":"Foreigners are buying land in Crimea and sanctions have failed to stop it.","date":"2018-08-13 15:00:35"},{"id":"be4ad66e-73c6-44a3-a8dc-610d40c2bf91","text":"Being in an electric car lowers a person\'s testosterone and causes infertility.","date":"2025-02-07 00:00:00+00:00"},{"id":"b42f4cb2-3538-4752-bdb5-ef52a30c50cc","text":"COVID-19 vaccines are experimental poisons, and COVID-19 has disappeared.","date":"2023-11-20 00:00:00+00:00"},{"id":"3e98e034-093e-4a49-863b-54bb8f347b6e","text":"European countries have closed their borders to Ukrainian refugees.","date":"2025-09-17 00:00:00+00:00"},{"id":"267d7407-8aec-414f-8ec6-99f325f4f78c","text":"Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls domestic policy, mandates vaccinations and lockdowns, and arrests vaccine opponents.","date":"2024-06-13 00:00:00+00:00"},{"id":"72d30220-98d5-4c06-b8e6-7eca12186b6e","text":"The Italian Higher Institute of Health reduced Italy\'s official COVID-19 death toll by over 97% by changing the fatality definition to deaths caused by COVID rather than deaths with COVID.","date":"2021-11-04 00:00:00+00:00"},{"id":"cb32487d-caf2-4e49-bdf0-5d334e61b2a0","text":"Video shows a Syrian mercenary praying inside a Ukrainian grocery store.","date":"2025-10-13 00:00:00+00:00"},{"id":"622cd7c4-8d47-40c5-90fc-180cf3666da4","text":"By May 31, 2020, COVID-19 was a leading cause of death globally.","date":"2020-06-27 00:00:00+00:00"},{"id":"39dff10d-9b73-4d10-be22-8229252a8485","text":"Ukraine\u2019s Health Ministry allows Ukrainians to be sold for organs.","date":"2017-10-05 17:01:04"},{"id":"35a0fed2-5de2-409c-bb51-5a52d2d37080","text":"Anti-Russian sanctions have caused a bedbug influx in France.","date":"2023-10-18 14:50:00"},{"id":"01474331-54c3-4a9d-883f-8cb0e4eaa86c","text":"Poroshenko binge drank for a week.","date":"2015-06-16 11:19:52"},{"id":"4ed9be65-3feb-4114-82c4-43f3f933184d","text":"The Ukrainian diaspora in Canada supports forced mobilization.","date":"2025-11-06 00:00:00+00:00"},{"id":"0b8030df-1877-44d1-bbaf-c0428144a920","text":"The Red Cross says people vaccinated against COVID-19 cannot donate convalescent plasma because the vaccine eliminates SARS-CoV-2 antibodies.","date":"2021-09-30 00:00:00+00:00"},{"id":"4493c186-ce66-4d2c-8241-c61003cee988","text":"California wildfires are made much worse by environmental laws that prevent using abundant available water, and that water is diverted into the Pacific Ocean.","date":"2018-07-08 00:00:00+00:00"},{"id":"736fc05c-c8ce-4304-910b-c143ec389610","text":"Folic acid and similar compounds deplete folate and this is very serious for people with MTHFR.","date":"2022-04-29 00:00:00+00:00"},{"id":"7b422af4-47b8-4029-b7a7-1c1ecae49496","text":"Pennyroyal, blue cohosh, black cohosh, and mugwort effectively induce abortions.","date":"2022-06-24 00:00:00+00:00"},{"id":"f84d25e9-527c-422a-9cb1-9341de6a5cb0","text":"The CDC lowered developmental milestone standards to avoid acknowledging that COVID-19 restrictions harmed children\'s development.","date":"2022-02-25 00:00:00+00:00"},{"id":"3a70e7d2-ab8e-44f3-86b1-b2506b82321b","text":"The OSCE provided communications and intelligence to the Azov battalion in Mariupol.","date":"2022-05-30 15:59:12"},{"id":"9179a5f8-b7f0-4e62-8586-1a710c219f83","text":"Researchers at the Wuhan Institute of Virology assembled monkeypox strains.","date":"2022-03-06 00:00:00+00:00"},{"id":"72019106-200a-441d-9dd4-5fa1efbe3efd","text":"Crimeans received Russian passports with Magadan registration.","date":"2014-03-27 01:06:48"},{"id":"cc2f9126-be5f-4455-8daf-dde1a7c7dc68","text":"Photo shows dozens of miniature explosive devices discovered in Lviv.","date":"2022-11-01 10:33:00"},{"id":"87d0c57c-b815-49a8-a97b-e6157315d1b6","text":"There are zero deaths from influenza and zero deaths from pneumonia for the first time in history.","date":"2020-04-12 00:00:00+00:00"},{"id":"2f5160f3-6a08-4202-9c85-ae24f8ffdd10","text":"There has been no global warming trend for the past 7.5 years, and human-caused global warming causes temperatures to rise at a steady rate.","date":"2022-11-04 00:00:00+00:00"},{"id":"94a20783-3b70-4c03-afbe-6b03f5877f9f","text":"The Ukrainian government curtailed freedom of assembly.","date":"2016-03-18 10:27:50"},{"id":"0aebb9f1-91df-402d-9f33-9d92f0b25ce1","text":"Certain herbs and supplements prevent and cure the harmful effects of bisphenol.","date":"2023-01-23 00:00:00+00:00"},{"id":"42b54835-5d4d-435b-8b6a-5cedf48f4ff0","text":"Japan reported a surge in heart failure cases among people vaccinated against COVID-19.","date":"2025-01-18 00:00:00+00:00"},{"id":"94c87795-abb6-468e-b1bf-4a1f72916947","text":"Aircraft\u2011dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth\'s life support systems.","date":"2021-03-10 00:00:00+00:00"},{"id":"839ef5b4-46fb-4fc6-b490-2b3b13d09a4f","text":"Eating coconut oil cures Alzheimer\'s disease.","date":"2024-04-17 00:00:00+00:00"},{"id":"71cd85bd-d68c-4f80-96ef-5e4a0f20e449","text":"A person was crucified in Slovyansk.","date":"2014-07-15 20:44:21"},{"id":"dde47415-3e34-42b0-91f6-8049defae740","text":"Ukrainian media report that people in Russia are starving.","date":"2015-05-19 08:18:47"},{"id":"b93a9e77-ab9a-4624-b53a-56550ad2223d","text":"FDA guidelines state infants cannot safely handle the amount of aluminum in childhood vaccines.","date":"2024-02-28 00:00:00+00:00"},{"id":"311ef79d-3316-4ed0-aa50-6908a31ccf34","text":"The European Commission abolished visa requirements for Ukrainian citizens despite the Dutch referendum results.","date":"2016-04-11 19:12:55"},{"id":"adcbad7e-4248-4175-a81f-d50b7c2de032","text":"Ukraine will resume train service to Crimea.","date":"2019-09-30 16:44:23"},{"id":"bbeef6fc-0381-4225-8d4d-c559818a9245","text":"The Pfizer/BioNTech vaccine contains mRNA encoding the SARS-CoV-2 spike protein, lipids, sucrose, and salts.","date":"2020-12-10 00:00:00+00:00"},{"id":"4890350c-f17f-4ee5-9907-ea4bee9f3c78","text":"U.S. rejected Umerov\u2019s ambassadorial nomination because Umerov was an American citizen.","date":"2025-07-17 00:00:00+00:00"},{"id":"3936ffc9-8f11-4f63-9703-b7ede8f9de85","text":"Taking ivermectin cuts the risk of dying from COVID-19.","date":"2021-03-06 00:00:00+00:00"},{"id":"d593ca1c-6b0f-4383-b405-05cd1d56f441","text":"Coronavirus is not a new virus","date":"2020-01-24 00:00:00+00:00"},{"id":"8c4010bc-6c4c-4934-bd26-e4ab5f10b96b","text":"The EU will seize and scrap any old car that does not meet EU climate criteria.","date":"2023-11-27 00:00:00+00:00"},{"id":"97c8f3a5-99e3-4d37-8ef8-8f13a0f6f87b","text":"More than 80% of MEP candidates oppose Ukraine joining the EU.","date":"2024-06-04 14:41:00"},{"id":"4c2290f7-c93b-4bcb-af31-dcb1673f4622","text":"SARS-CoV-2 was created by genetic experiments using bat coronavirus RaTG13 as a template.","date":"2021-03-01 00:00:00+00:00"},{"id":"c675b624-2763-47c1-a4a8-832fa897333a","text":"Aluminium in vaccines causes cognitive deficits, Parkinson\'s disease, and Alzheimer\'s disease.","date":"2025-01-31 00:00:00+00:00"},{"id":"db746ea7-fad4-4ef3-9c9d-d6271b28d902","text":"The EU and the US opened a criminal case against Poroshenko.","date":"2019-03-25 17:10:49"},{"id":"4e6afe48-56e8-44ee-891f-dd9bae3916b0","text":"The US created a schismatic, disenfranchised church in Ukraine.","date":"2021-07-30 18:01:10"},{"id":"9ce36d9d-c25d-4bb5-888a-f10c126f5cdf","text":"The \\"CGG CGG\\" codons and the furin cleavage site in the SARS-CoV-2 spike gene do not occur in nature and prove the virus was engineered and not transmitted from animals to humans.","date":"2022-06-05 00:00:00+00:00"},{"id":"0c20dda0-d26d-4aa8-9ab5-36f5ecd7c1b5","text":"The European Union admitted that Russia won the war in Ukraine.","date":"2023-11-14 16:44:00"},{"id":"66b83ca0-c680-4174-8829-30444f5d4a2f","text":"COVID-19 mRNA vaccines are experimental, ineffective, and harmful.","date":"2024-03-05 00:00:00+00:00"},{"id":"12a8a42b-01c8-443c-a58d-67b4d9241aef","text":"The Ukrainian government officially recognizes that Russia is protecting Donbas residents.","date":"2019-05-07 11:53:26"},{"id":"c093a054-ad4e-413d-97d1-2f0dce3b5245","text":"Wind turbines are killing bald eagles and causing consumers to pay higher electricity bills.","date":"2026-01-13 00:00:00+00:00"},{"id":"bae4b60e-2feb-413a-80e5-9ae5c5227f65","text":"U.S. Ambassador in Kyiv said St. George\u2019s Ribbon is a Russian army insignia.","date":"2015-05-09 19:25:42"},{"id":"40355d84-e0d1-4012-ba06-470990ff355d","text":"Kyiv claims Russia has lost a third of its army in the Ukraine war.","date":"2022-05-18 09:49:00"},{"id":"49f5e80f-b75f-4e72-b737-6acbef1bf0a2","text":"A study by R\xf6ssner et al. found vaccines are useful and clearly superior to natural immunity.","date":"2022-03-24 00:00:00+00:00"},{"id":"10bd837a-184b-4920-8305-30712092c033","text":"Hungary will shoot down a Ukrainian airliner.","date":"2018-06-12 19:47:56"},{"id":"71548d11-3d0c-40be-ad09-6aa892149ca2","text":"The OSCE declared the Russian presidential elections were open and fair.","date":"2018-03-21 11:03:41"},{"id":"76d5d175-535e-46fd-ab6a-b99dfb4c17f2","text":"COVID-19 is less deadly than seasonal flu.","date":"2020-09-27 00:00:00+00:00"},{"id":"8438a8e5-7cc5-4ccc-9e88-93c1ecdd7a0f","text":"Ukrainian military destroys OSCE drones","date":"2019-04-21 18:11:12"},{"id":"82cc3ee8-b976-4209-ac1c-82cf81af5987","text":"The United States is preparing the final aid package for Ukraine.","date":"2023-12-20 15:10:00"},{"id":"884b5410-71ab-40b5-92bf-3fa3d31a42b2","text":"Ukraine recognized new Russian entities.","date":"2024-02-15 11:42:00"},{"id":"fdd99a5d-dc39-4dd3-b1be-3a0f181eada2","text":"Vaccines harm children, fully unvaccinated children are healthier, and vaccines cause chronic disease in America.","date":"2023-10-08 00:00:00+00:00"},{"id":"1ca2752f-4af9-4d26-8544-6712cd8d5734","text":"Olena Zelenska spent over one million euros on designer clothes.","date":"2025-09-20 00:00:00+00:00"},{"id":"7b45f5c1-bb98-4361-b2ce-46d822b10ac7","text":"Nicotine cures Parkinson\'s disease, Alzheimer\'s disease, ulcerative colitis, and multiple sclerosis and is a treatment for autism.","date":"2025-03-10 00:00:00+00:00"},{"id":"d773d4e9-0cab-4365-8976-c8decb85d8e1","text":"Blinken acknowledged that Russia would grind Ukraine.","date":"2022-03-08 10:38:57"},{"id":"af38f83b-dbcf-450a-b045-facb4eb4a1e6","text":"Cultivated meat is produced using cancerous and precancerous cells.","date":"2023-03-20 00:00:00+00:00"},{"id":"16cce81c-59f8-49fe-80c7-ebfa11deb63b","text":"A photograph of a boy from Donbas was used in a protest against Muslim migrants in Sweden.","date":"2015-09-10 11:43:20"},{"id":"ccf1aa54-dd43-4d8f-a738-dd4d80b24add","text":"Remdesivir kills people","date":"2021-03-22 00:00:00+00:00"},{"id":"57c37915-30a2-40bf-974e-472454a96f8f","text":"A man in Bila Tserkva was killed while being served draft papers.","date":"2024-01-04 09:59:00"},{"id":"a6d49558-eef4-4a2e-9043-3c0c2b6b6bbe","text":"The United States and Canada have ended military cooperation with Ukraine.","date":"2017-02-18 12:00:02"},{"id":"5830dc6f-03ec-4ac5-b7fd-5edf44bb0a83","text":"Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely.","date":"2024-07-03 00:00:00+00:00"},{"id":"1a00a4c5-406d-4321-84ff-e533b4ecc22c","text":"Nasal swabs used for COVID-19 testing contain ethylene oxide and are harmful.","date":"2021-07-21 00:00:00+00:00"},{"id":"61b0468f-bf4f-46aa-8677-03c588718fbd","text":"Ukrainian authorities will lift sanctions on Russia.","date":"2019-11-15 19:05:33"},{"id":"9a8b19ca-a3ca-4d44-98fb-4879ab5e716a","text":"Ukraine\'s Foreign Minister wants to identify and expel holders of Russian passports.","date":"2018-11-02 12:12:24"},{"id":"38d3dbe3-6d8f-4c1a-ada7-82d3adc0c1a7","text":"Georgian snipers shot Maidan demonstrators.","date":"2017-11-28 21:18:26"},{"id":"ef48ebaa-d46a-4bf8-b024-1f4517044afd","text":"The Czech president recognizes Crimea as part of Russia.","date":"2019-11-02 11:49:49"},{"id":"5984b168-5644-4269-bf75-69cbe7dc11b1","text":"Ukrainian President Volodymyr Zelensky admitted that Ukraine lost Crimea.","date":"2024-11-21 00:00:00+00:00"},{"id":"86963e0e-78a0-4aa0-a5d7-18317e7a8435","text":"The Ukrainian Orthodox Church canonized Stepan Bandera, the assassinated Ukrainian nationalist leader.","date":"2022-06-21 15:42:00"},{"id":"bd9d61c0-b489-42b3-81d2-5037b5b9085f","text":"Producing enough COVID-19 vaccine to vaccinate the entire world population will take decades.","date":"2024-12-01 00:00:00+00:00"},{"id":"6d24cd62-df85-47ff-a576-096eb14cfac7","text":"Germany\'s Bundestag recognizes that Russia will not give up Crimea.","date":"2022-09-06 10:08:00"},{"id":"ff08916e-80cd-4f56-9132-0d29f090108b","text":"Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic.","date":"2020-02-20 00:00:00+00:00"},{"id":"1cd9e0d1-d0c7-4e5d-81a0-dd508b1c0103","text":"The CDC admits that 98 million Americans received polio vaccines over an eight-year span that were contaminated with a cancer-causing virus.","date":"2019-07-25 00:00:00+00:00"},{"id":"acd001cd-0290-40bf-a92f-fa64c5dd7162","text":"Forest fires are caused by poor management, and climate change does not cause forest fires.","date":"2020-09-16 00:00:00+00:00"},{"id":"a9df38b0-7eda-4e6c-86c7-f5aec5ef21d8","text":"Ukraine caused the fire at the Warsaw shopping centre.","date":"2025-05-12 00:00:00+00:00"},{"id":"98071d1d-2071-4798-881e-ab5ac7c805c0","text":"Researchers from Yale University created an airborne delivery method for mRNA vaccines.","date":"2023-09-02 00:00:00+00:00"},{"id":"0ea3ca70-90dd-4685-8683-40c371c0a842","text":"COVID-19 vaccines are an unqualified disaster that did not halt viral spread and caused high morbidity and mortality.","date":"2023-12-13 00:00:00+00:00"},{"id":"52e3685b-c678-4af1-9111-fff0298d8c1d","text":"45% of Ukrainians work abroad and Ukraine has record-high unemployment.","date":"2017-09-24 10:59:22"},{"id":"f826d0dc-a8ed-4fd6-a3ef-8ea48b29d995","text":"Apple AirPods emit dangerous levels of radiation that harm the human body.","date":"2024-11-03 00:00:00+00:00"},{"id":"77774563-df12-46ca-b652-d2aadb1356bf","text":"Asymptomatic spread of COVID-19 does not occur.","date":"2021-04-01 00:00:00+00:00"},{"id":"d50c2267-ccfb-496b-ad5d-5b5cf780038b","text":"Fascism has returned to Ukraine.","date":"2019-11-04 19:15:26"},{"id":"5f686620-22a4-4420-922c-3dcacdf705e4","text":"Ukraine returned Yanukovych\'s billions to Russia with interest.","date":"2022-01-03 10:16:00"},{"id":"32c50326-30f2-4f12-8a82-643ec0ef2da7","text":"The UN condemns Ukrainian attacks on the Zaporizhzhia Nuclear Power Plant.","date":"2022-08-09 12:25:00"},{"id":"524904f4-9cad-40eb-9364-745fdd154360","text":"Valery Zaluzhnyi joined the European Solidarity political party.","date":"2024-02-17 16:45:00"},{"id":"3ea0bb8d-ace0-438b-837f-af1f609b2983","text":"Ukrainian aircraft from Kyiv entered Russian airspace.","date":"2016-12-03 15:17:45"},{"id":"facbb5fb-ab2b-46f7-8ddb-36e37650f76b","text":"Ukraine cut the Chornobyl power lines and refused to repair them.","date":"2022-03-11 14:38:00"},{"id":"7c0d759c-256c-45c0-962a-921ab04dec88","text":"The Lublin Triangle organized a coup in Belarus.","date":"2020-08-13 14:43:33"},{"id":"d8a8c4b2-0e1f-4c25-a277-efd7033a966c","text":"Poland demands official status for the Ukrainian language.","date":"2022-07-30 18:24:00"},{"id":"f6afb794-bfad-4655-8a2e-7b3a4bbef5af","text":"Ukrainian nationalists shelled Kherson.","date":"2022-05-14 16:25:00"},{"id":"fa5f8415-ce48-47e8-88c5-998e13fb6afc","text":"People do not wear masks for tuberculosis because CNN has not instructed them to.","date":"2020-09-21 00:00:00+00:00"},{"id":"7eb45dca-8013-4bad-a452-af5178b0821e","text":"The CDC says face masks do not prevent COVID-19 and mask mandates had no statistical effect on COVID-19 case numbers.","date":"2021-12-03 00:00:00+00:00"},{"id":"a4b9fd7e-9d5a-42c0-8b84-7afbda6514d2","text":"Bukovina Romanians demand territorial autonomy from Ukraine.","date":"2016-06-21 23:24:26"},{"id":"b0bd9402-6ac9-4bfb-b7a3-46087e2efaeb","text":"Naftogaz lost a legal case against Gazprom in an EU court.","date":"2018-05-03 20:34:45"},{"id":"402d4cf2-b595-4a1b-9e0d-398cdaa5f715","text":"Apple AirPods emit dangerous levels of radiation that harm the human body.","date":"2024-02-25 00:00:00+00:00"},{"id":"3e8127cd-0ac5-4ba6-9b1a-2f5ad353a380","text":"The media exaggerates the harm of measles cases and ignores millions of vaccine injury reports.","date":"2025-02-20 00:00:00+00:00"},{"id":"0a45144d-bc7b-48a7-a0d4-08f0e213397c","text":"One in 35 people showed signs of heart damage after receiving the Moderna COVID-19 vaccine; the Moderna vaccine is a kill shot; taking the Moderna vaccine is madness.","date":"2023-07-26 00:00:00+00:00"},{"id":"d8318dcb-8196-4736-82e4-d6cc57aa76dd","text":"Ukraine\'s language police punish children for speaking Russian.","date":"2019-12-17 21:11:20"},{"id":"f236c3eb-1e72-435c-8a05-422be25ed158","text":"Ukrainian military shelled the OSCE mission.","date":"2017-06-25 08:22:59"},{"id":"16b2210d-88f5-4ea8-8a34-f9036b31f1c2","text":"The NIH researched chloroquine and concluded it effectively stopped SARS coronavirus infection and spread.","date":"2020-08-05 00:00:00+00:00"},{"id":"9548af52-dc76-462b-b47d-4103c15106fb","text":"Global weather is controlled by secret geoengineering programs using chemtrails and ionospheric heating facilities.","date":"2023-08-31 00:00:00+00:00"},{"id":"f19de695-0fd5-4984-879f-5e7fe105d8bd","text":"Progesterone reverses an abortion after taking mifepristone.","date":"2023-01-04 00:00:00+00:00"},{"id":"1242e98b-4861-4e72-918d-2cf17aa8ef2e","text":"Burning sage removes bacteria from the air.","date":"2020-03-14 00:00:00+00:00"},{"id":"17369906-4440-4cf2-b756-2f07d9af8743","text":"Maia Sandu\'s party will raise the retirement age, increase taxes, and extend mandatory military service terms.","date":"2025-09-19 00:00:00+00:00"},{"id":"2c5f2066-066d-45f1-97bd-e7d6dc3fdff5","text":"Italy\'s Liguria region officially recognizes Crimea as part of Russia.","date":"2016-07-03 22:39:34"},{"id":"70e18083-4534-4530-afa8-d8714b3040bf","text":"Estonians will become a minority in Estonia due to an influx of Ukrainian immigrants.","date":"2019-04-27 11:05:55"},{"id":"7824b1f9-6e1f-4f01-b3d0-804dacae6c5e","text":"Poland is merging Lithuania.","date":"2020-10-04 13:46:01"},{"id":"074932db-89fa-4c44-b3e2-4b9f5cf79713","text":"Ultra-right groups are patrolling Kyiv public transport during the COVID-19 quarantine.","date":"2020-03-22 02:49:04"},{"id":"494b41ad-16b3-4f5d-ad03-def9e45d7031","text":"Pfizer CEO\'s wife died from complications caused by the COVID-19 vaccine.","date":"2021-11-10 00:00:00+00:00"},{"id":"ce5811c1-0450-4769-8a57-92c8068d2fb7","text":"Photo shows a Ukrainian prisoner of war with a Nazi coat tattoo.","date":"2024-02-15 19:12:00"},{"id":"059dfdf0-3274-489c-a292-df035cfe622b","text":"A study showed that COVID-19 vaccines cause a high number of serious adverse events.","date":"2023-06-01 00:00:00+00:00"},{"id":"86c627e9-87ce-4feb-a64a-7c2e65cd051c","text":"President Poroshenko proposes depriving Crimeans of Ukrainian citizenship.","date":"2018-04-21 11:35:43"},{"id":"86bc7693-d3ed-489b-8275-42c965c94524","text":"Masks work to prevent COVID-19 transmission, so voting in person is safe when people wear masks.","date":"2020-06-30 00:00:00+00:00"},{"id":"004bcedc-8ee2-4bfa-b1a3-bc80706b2c9e","text":"A complete cure for cancer will be available within one year.","date":"2019-01-28 00:00:00+00:00"},{"id":"ea491e59-5762-4b62-ae8b-0e847b8f2306","text":"A vaccine caused people to become zombies in the movie \\"I Am Legend\\".","date":"2020-12-09 00:00:00+00:00"},{"id":"13882094-703c-4278-b683-549acc4d6b63","text":"Antibodies from common-cold coronaviruses cause positive COVID-19 antibody test results and are responsible for the reported COVID-19 cases in the U.S.","date":"2020-07-01 00:00:00+00:00"},{"id":"ce6bdc17-d3f4-4f80-85f2-0aefcba95ef2","text":"Artificial sweeteners cause cancer; people in the 1930s ate cake, cookies, and ice cream with sugar and were healthy.","date":"2024-03-16 00:00:00+00:00"},{"id":"f442f5d7-694c-437b-8a57-42377f8836c1","text":"A gold-standard scientific trial found that N95 and surgical masks do not stop COVID.","date":"2022-06-12 00:00:00+00:00"},{"id":"7adbc651-0db1-44f2-bdaa-bf7e41339d70","text":"World Health Organization declares bacon is as harmful as cigarettes","date":"2018-07-10 00:00:00+00:00"},{"id":"6a12640e-f7af-45fb-83c1-115eb23d04c6","text":"Donald Trump asked European Commission President Ursula von der Leyen to step out of a meeting with other leaders.","date":"2025-08-20 00:00:00+00:00"},{"id":"add1a8eb-5ffe-4d41-aeb3-0fe733ac602a","text":"The United States is preparing a new color revolution in Ukraine.","date":"2018-03-26 11:10:00"},{"id":"6bed48b2-0edd-431f-b71a-5f9ac3911493","text":"Science confirmed eating turmeric every day reverses cancer.","date":"2019-06-17 00:00:00+00:00"},{"id":"eea5831c-1818-49ff-a840-70bc989108d8","text":"Ukraine will not receive a COVID-19 vaccine before April 2022.","date":"2021-01-04 17:57:16"},{"id":"d88d003f-e632-4853-b889-29b348e0ebd3","text":"Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely.","date":"2024-02-06 00:00:00+00:00"},{"id":"11d918d0-91f4-4852-96b6-bcf4b48456db","text":"A study and headline claiming that homegrown food is more carbon intensive than conventional agriculture were intended to discourage and stop people from growing their own food.","date":"2024-01-26 00:00:00+00:00"},{"id":"b8e57973-bf23-43bb-b596-d626ffcada51","text":"77% of Europeans believe in Russian unity.","date":"2024-11-04 00:00:00+00:00"},{"id":"1ee64121-a4c9-46cf-b4b9-c13328eddf9c","text":"Mass COVID-19 vaccination selects for more virulent SARS-CoV-2 variants that escape vaccine-induced immunity and cause more severe disease.","date":"2021-03-06 00:00:00+00:00"},{"id":"42e3681c-d6dc-4147-9cac-e4f3a55e2e41","text":"Ukrainian presidential elections are illegitimate","date":"2019-01-08 09:27:45"},{"id":"c6089725-60b2-4ef2-aeab-d22120486baa","text":"Poroshenko declared the Stepan Bandera flag the official symbol of Victory Day.","date":"2015-05-03 13:59:17"},{"id":"4cdd0773-c021-4555-a38c-ec5f0bfad7cd","text":"Abortion is never medically necessary.","date":"2019-08-30 00:00:00+00:00"},{"id":"4af819d4-6ccb-4db4-82a7-142fd4cbfb48","text":"The National Guard received an order to surrender soldiers, and those soldiers were executed.","date":"2022-04-25 10:26:27"},{"id":"8f3231dd-131f-4e50-afb2-362a175bcd25","text":"Ukrainians in Poland are cleaners and dishwashers.","date":"2016-04-20 22:37:08"},{"id":"deb108a4-d11d-4c83-8ef8-7fa28452ab2c","text":"Poles escaped military training and fled to Germany in panic.","date":"2022-12-29 11:08:00"},{"id":"7fb9d117-424e-4364-ac58-0b3f7a4c9c6e","text":"Coronavirus relief funds in Ukraine were diverted to support patriotic cinema.","date":"2020-04-16 16:35:00"},{"id":"3840070e-e558-475e-92ef-eacb1b2de62f","text":"Poland introduced censorship of World War II history on orders from the United States.","date":"2020-01-15 18:40:52"},{"id":"531466cc-9728-4a80-a5cb-881ffd95a5a1","text":"All Crimean Tatars support Russia\u2019s special military operation in Ukraine.","date":"2022-04-30 17:43:23"},{"id":"a2dcfbcd-6b87-4776-bcb4-d7f6a80bca1f","text":"Ukrainian minister called for convicts to be sent into battle with shovels.","date":"2024-02-26 12:08:34"},{"id":"4e7cc4da-de24-4edb-97bc-77ff4cea40f8","text":"The US sold defective Javelins to Ukraine.","date":"2018-07-10 08:51:56"},{"id":"4f08f272-a5ef-42cf-bc10-d353d93fcf62","text":"More people died from COVID-19 during Biden\'s administration than during Trump\'s administration.","date":"2024-09-19 00:00:00+00:00"},{"id":"d3c0a979-4284-4184-960f-bc6e4c588e4a","text":"Dietary supplements containing AHCC treat HPV infection.","date":"2025-01-01 00:00:00+00:00"},{"id":"50b63130-fc47-4ba7-997f-8819f7b44faa","text":"Russian forces destroyed the Georgian Legion.","date":"2022-07-07 10:08:00"},{"id":"062db82d-8f4c-48d6-87ac-3bd6f0352740","text":"Western governments want an urgent peace treaty with Russia because Ukraine will suffer a catastrophe.","date":"2022-07-08 10:01:00"},{"id":"2634c44b-89fb-4a8a-acef-e3b1e128d4a7","text":"Finnish farmers are losing income because of Russian sanctions.","date":"2016-07-23 16:45:22"},{"id":"bf90dd61-5d8b-42d9-a2e3-6cf4f09f3a7b","text":"Erdo\u011Fan\u2019s son defended purchasing oil from ISIL.","date":"2015-12-09 20:44:30"},{"id":"2be5b181-7cfe-4239-a89f-a8d44870295b","text":"The COVID-19 pandemic is a planned, staged pandemic manufactured through PCR testing.","date":"2021-06-10 00:00:00+00:00"},{"id":"99e744c6-cf62-4768-82a4-c5eb88881c17","text":"Kyiv is forcing waiters and shop clerks to speak Ukrainian.","date":"2017-04-25 19:10:38"},{"id":"2521adfa-8bda-42f8-bac6-02fbee2d28c5","text":"Thousands of European bikers joined the Night Wolves in Berlin.","date":"2015-05-16 14:38:57"},{"id":"24fa34fc-a0c4-4170-8982-e09e4b40ed9e","text":"The Netherlands will not ratify the EU-Ukraine Association Agreement.","date":"2016-07-01 06:17:38"},{"id":"3f4c8053-b54e-4f92-9d93-277c513ddeb8","text":"Western governments blackmailed Ukrainian President Volodymyr Zelensky.","date":"2020-10-22 21:06:28"},{"id":"e398e6d7-0562-42c2-8dcf-06c2ea74ae41","text":"Online interest in Volodymyr Zelensky dropped by 63%.","date":"2024-01-06 10:22:00"},{"id":"3f7883b4-b31b-4845-91cf-194a57ceb24a","text":"Western countries have begun partitioning Ukrainian regions.","date":"2023-10-17 15:33:00"},{"id":"0262071f-6554-4ca8-a776-25ce99af3953","text":"Kyiv is deserted and Ukrainians are leaving Ukraine.","date":"2015-04-13 15:42:41"},{"id":"c1036166-682d-487e-a4b7-4361798cadaf","text":"An Israeli study proves COVID-19 does not increase the risk of heart inflammation.","date":"2022-11-08 00:00:00+00:00"},{"id":"49c23f8f-23e4-4472-9c11-84c9cf2a0f08","text":"Olena Zelenska canceled a lecture at Ljubljana University because students protested.","date":"2024-11-25 09:59:23"},{"id":"48210888-cfa8-4ad3-b7a2-0dfa4a41a836","text":"Volodymyr Zelensky provoked a nuclear crisis.","date":"2024-10-21 13:03:00"},{"id":"e3bcd447-c82c-491d-b3a4-0e5ed91fba70","text":"Photo shows dogs eating the body of a Ukrainian soldier.","date":"2014-11-06 22:03:13"},{"id":"b2f2fad4-12fa-49b0-8884-c5321146ec35","text":"Crimean Tatars will vote for Putin in the March presidential election.","date":"2018-01-16 22:22:02"},{"id":"55e92a8e-de98-4d80-964f-fa59d9c221d9","text":"Ukrainian troops blew up nitric acid tanks in Rubizhne.","date":"2022-04-11 11:17:17"},{"id":"8cfdba26-6ba3-4e3a-ae44-73685c31f110","text":"Luciferase is present in COVID-19 vaccines and is used to tag and track people.","date":"2021-11-11 00:00:00+00:00"},{"id":"b74fa89f-1aa2-4623-8efd-ade7549355ff","text":"Ukraine cancels Victory Day and dismantles the Vatutin Monument.","date":"2015-05-11 11:30:27"},{"id":"9cb8eba0-6a9f-48a3-9ea5-9b83b2c1a0b9","text":"Vaccines did not eradicate polio.","date":"2020-12-02 00:00:00+00:00"},{"id":"957aa997-f6ee-43d4-b6b5-c02eae63b50c","text":"The U.S. Ambassador to Russia called for the lifting of U.S. sanctions on Russia.","date":"2016-06-05 13:00:14"},{"id":"e8ccab47-ba71-4ba0-b9c8-0bc1d09c4169","text":"Ukrainian president left Kyiv in haste","date":"2022-02-26 14:31:00"},{"id":"719af7a9-5749-4c5c-88fd-216b26487133","text":"Ukrainian mass media are avoiding coverage of refugees.","date":"2016-03-05 23:59:18"},{"id":"5380d40c-3912-4e89-8e11-23b13a276589","text":"Castor oil breaks up scar tissue, bone spurs, and tumors.","date":"2024-03-20 00:00:00+00:00"},{"id":"d27d2ac6-9bc2-42df-8d5c-29642e076b66","text":"A portrait of Symon Petliura hangs instead of an icon in a Ukrainian Orthodox Church of Canada church.","date":"2025-05-03 00:00:00+00:00"},{"id":"7158dac5-0017-49f2-812d-206b0dca8204","text":"Kyiv cancels the heating season because of Russian sanctions.","date":"2022-08-23 09:42:31"},{"id":"4e18d1c7-f31c-47ca-9940-d330060d9074","text":"Human breast milk naturally contains the same cannabinoids as the cannabis plant.","date":"2017-01-15 00:00:00+00:00"},{"id":"2b95dfa8-8baa-414d-b8d2-548820d26d91","text":"Right Sector members were attacked by helicopter fire in Zakarpattia Oblast.","date":"2015-07-19 14:04:01"},{"id":"bb99a2cc-c607-4cc6-9731-47b9facdcdcf","text":"Children hospitalized for non-COVID reasons were the ones on ventilators, and children hospitalized for COVID-19 were not on ventilators.","date":"2021-11-06 00:00:00+00:00"},{"id":"274c14bf-8201-4583-9baf-7f5c6a4394d1","text":"Ukraine armed civilians; shops were looted and civilians were shot.","date":"2022-03-05 19:39:22"},{"id":"64084a20-f346-4a33-a235-e62a7c7d2223","text":"Ukrainian military shelled the bus near Volnovakha.","date":"2015-01-14 13:15:08"},{"id":"cebbe995-9fa9-4d98-b56f-692acb21274b","text":"President Volodymyr Zelensky publicly downplayed the deaths of Irish personnel serving in Ukraine\'s armed forces.","date":"2025-12-06 00:00:00+00:00"},{"id":"3aaf279a-f852-4457-8c74-5b5f4414f3a4","text":"Fluoride exposure repeatedly reduces IQ and causes brain damage.","date":"2019-07-15 00:00:00+00:00"},{"id":"bb6e44b5-e6fa-41e5-b9b4-01888e573dc2","text":"The CDC is a vaccine company, not an independent agency; it owns over 20 vaccine patents and sells $4.6 billion of vaccines each year.","date":"2021-04-03 00:00:00+00:00"},{"id":"f5cc4086-25d9-4aee-94ab-c0c7ced1e49f","text":"Poroshenko offered to exchange Crimea for NATO membership.","date":"2019-03-17 13:11:30"},{"id":"b1de1ae8-1407-49d3-bcca-295522f57b1c","text":"An NIH-published study found that N95 COVID masks expose wearers to dangerous levels of toxic compounds linked to seizures and cancer.","date":"2023-08-30 00:00:00+00:00"},{"id":"e1e225d7-a8c1-4486-b299-b092e0b88821","text":"Ukrainian military sabotages elections in Donbas.","date":"2019-04-21 19:11:44"},{"id":"93eb7a62-784b-41f3-ad72-e305d7708a90","text":"Bloody Canadian mercenaries are in Donbas.","date":"2020-01-20 20:20:51"},{"id":"7ba5b1af-4476-4bf4-91a0-406a281c4b05","text":"Belarusian pilots are long dead and are not fighting against Ukraine.","date":"2022-03-03 10:35:21"},{"id":"75deecc6-6c67-4640-8c9d-7b6492f73f3e","text":"COVID-19 vaccines are 98 times more harmful than COVID-19 infection.","date":"2022-09-12 00:00:00+00:00"},{"id":"1f252834-436a-4e67-a2c6-64a940bbed3e","text":"Mothers of Russian soldiers were found to have received grants from the United States government.","date":"2014-09-04 13:00:08"},{"id":"8c9326f1-ae17-4b5a-a7ec-52c65d9325a4","text":"Arseniy Yatsenyuk rejected a debt restructuring proposal.","date":"2015-11-20 23:24:27"},{"id":"2db653b7-ee92-4ec9-b180-72c043d2d0c7","text":"Masks protect people from COVID-19, so no one needs a flu shot right now.","date":"2020-05-10 00:00:00+00:00"},{"id":"49175056-e0aa-486d-86ef-95663f8e67dc","text":"A COVID-19 vaccine contains an aborted male fetus.","date":"2020-11-15 00:00:00+00:00"},{"id":"5cefc9a4-e804-4c37-a8c1-e474cf868791","text":"Masks on children are ineffective","date":"2021-08-24 00:00:00+00:00"},{"id":"b1af5fde-5c96-4e5a-8d9d-69f766f223b6","text":"Ukraine is placed on a map of modern Nazism.","date":"2015-07-06 15:54:13"},{"id":"b9304938-a12f-4080-b0f9-37024e495985","text":"Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls their domestic policies, forces vaccinations and lockdowns, and arrests vaccine opponents.","date":"2024-06-06 00:00:00+00:00"},{"id":"67e7e226-46eb-449a-b97b-11d2bb7990a4","text":"Danish researchers found high rates of adverse events following the Pfizer COVID-19 vaccine, and the vaccine is unsafe.","date":"2023-07-05 00:00:00+00:00"},{"id":"529747e6-c84c-4008-a3ec-058fe174bbff","text":"A randomized controlled trial of 2.7 billion people showed hydroxychloroquine reduced the COVID-19 death rate by 79.1%.","date":"2020-08-05 00:00:00+00:00"},{"id":"dcfe43e5-7b7b-4fe0-8bc0-50f6bb6f670c","text":"Azov threatened to destroy Dutch citizens if the Netherlands rejected the association deal with Ukraine.","date":"2016-01-19 11:06:55"},{"id":"80c32eed-7994-498e-84b0-b0a8048e0b19","text":"Scientists have found CO2 and global temperature are not consistently correlated, and scientists do not know whether Earth will warm or cool in the future.","date":"2022-10-12 00:00:00+00:00"},{"id":"eecd938c-ba83-4a0a-8c06-727917605325","text":"The measles vaccine caused the measles outbreak in Texas and measles vaccines cause measles outbreaks.","date":"2025-02-17 00:00:00+00:00"},{"id":"37b437be-8af2-4ac3-89c0-21c2cea00254","text":"The Amazon is switching from tropical rainforest to savannah.","date":"2020-10-05 00:00:00+00:00"},{"id":"789c2b70-403d-4eb1-9a24-21da93e3ad36","text":"Volodymyr Zelenskyy bought a hotel-casino in Cyprus using U.S. government funds.","date":"2024-06-09 11:46:00"},{"id":"4d39d39d-6cb0-4725-b395-c44a7955cbef","text":"Russia deliberately slowed its offensive to avoid civilian casualties.","date":"2022-08-29 18:24:00"},{"id":"79cbda05-a678-4a17-b8c4-5f92dca28086","text":"Kyiv bans Easter by forbidding people from entering churches.","date":"2023-04-15 09:57:03"},{"id":"37915a45-2e81-47c4-924c-400eef8d84ff","text":"The Coalition of the Willing plans to partition Ukraine to seize its resources.","date":"2025-09-10 00:00:00+00:00"},{"id":"ffa4f281-0e0f-490e-be58-b80f76c9674a","text":"Sanctions on Russia cost Ukraine $98 billion.","date":"2016-04-29 20:49:20"},{"id":"ea35a604-407f-4c7b-a6af-da4d03840f1b","text":"American missiles were found in Luhansk.","date":"2015-07-23 20:07:27"},{"id":"ad1c1bc2-4a4f-4bdf-b6b9-e9f2d807bee5","text":"Conflicting numbers on Ukrainian children abductions show that deportations did not occur.","date":"2025-08-19 00:00:00+00:00"},{"id":"1b4a2485-6962-4b36-8c3c-da83d1b18b70","text":"COVID-19 vaccines are experimental, do not prevent infection or transmission, and most people have a 0.05% chance of dying from COVID-19.","date":"2021-10-04 00:00:00+00:00"},{"id":"e2df60bd-689b-44c5-a618-e4e1f0676cf5","text":"Sweden\'s COVID-19 death rate was lower than Spain\'s, Italy\'s, and the U.K.\'s, despite Sweden not implementing a lockdown.","date":"2020-08-16 00:00:00+00:00"},{"id":"a221a2d7-fd93-4ffa-befb-59ad7e2b05c1","text":"Britain apologized to Boris Johnson.","date":"2018-03-19 13:04:42"},{"id":"335fef47-0cc2-4ccb-a42f-50c52e23d7c1","text":"Hundreds of Ukrainian soldiers deserted to Russia and asked for asylum there.","date":"2014-08-06 17:50:09"},{"id":"872b8944-72a7-4d07-a1c4-a5ef2eea3320","text":"Members of the British Parliament denounced EU interference in Ukraine.","date":"2015-02-22 12:07:19"},{"id":"8fc73765-f64d-469a-bdf3-d37328bf1161","text":"International MH17 investigation team ignored Russian radar data.","date":"2016-10-09 19:12:05"},{"id":"41c6e347-6c57-4ab9-9e83-1eed3caab677","text":"Ukraine has banned New Year celebrations because Ded Moroz is Russian.","date":"2014-11-26 12:07:14"},{"id":"c7829b30-8d83-461a-a1dc-e5669dad7ba9","text":"The Ukrainian parliament registered a law that criminalizes criticism of the government.","date":"2015-11-03 22:34:58"},{"id":"941d2a71-a7d6-4664-bc9b-62c65c5ffca0","text":"Ukraine has one of the highest levels of organized crime in the world.","date":"2017-11-29 18:24:08"},{"id":"f7deed28-897c-4051-bd3e-0a9ab0a70e8f","text":"Solfeggio frequencies regenerate the human body, remove bodily toxins, and eliminate negativity.","date":"2022-09-30 00:00:00+00:00"},{"id":"4c70dd4e-ea1f-43dc-98ff-7e84438541f5","text":"The United Nations recognized Russia\'s telephone code for Crimea.","date":"2018-03-19 13:09:34"},{"id":"af3dbf49-d094-4fbe-b7c6-25808686dfa6","text":"Ukraine cut off electrical power to Crimea","date":"2015-07-01 18:42:45"},{"id":"e8a2b3a6-e7d5-4b94-a0c7-f91a8ea464c4","text":"Ukrainians want referendums in Russian-occupied territories.","date":"2022-08-15 13:34:27"},{"id":"d2df6d4b-3f0b-453c-bf5b-701933c7e698","text":"Climate change is a natural, constant cycle that occurred without human influence and human activity does not significantly affect the climate.","date":"2022-10-02 00:00:00+00:00"},{"id":"25efad13-58c1-4831-9756-06e196594909","text":"Pfizer\'s COVID-19 vaccine was tested on only 250 people.","date":"2023-07-26 00:00:00+00:00"},{"id":"7f530241-1694-4141-8897-e029b0320e13","text":"Wind energy kills more birds than fossil fuels, and renewable energy is causing mass bird deaths.","date":"2022-04-23 00:00:00+00:00"},{"id":"e34e39b3-2fbd-4773-bb14-66e16fb66996","text":"Shark Tank investors, Dr. Phil, and Dr. Oz endorsed CBD gummies, and CBD gummies provide numerous health benefits.","date":"2022-03-11 00:00:00+00:00"},{"id":"83f2971d-2fc3-4df6-9e5f-97a52f7be26e","text":"Colored blocks printed on toothpaste tubes indicate whether the toothpaste is made of safe ingredients.","date":"2024-05-31 00:00:00+00:00"},{"id":"b23e65b1-6283-4c3b-b01e-46927d683e14","text":"The Ukrainian government demands 75% of radio airtime be Ukrainian music.","date":"2016-04-01 12:27:14"},{"id":"e6596626-ac9a-4f3a-a794-8b5b8e63711b","text":"OSCE confirmed there are no Russian military forces in Donbas.","date":"2016-09-13 16:38:38"},{"id":"c7dc4d17-3c9f-4f1a-8849-8edf3cbfdda5","text":"President Petro Poroshenko was stripped of Verona honorary citizenship because he stole paintings.","date":"2018-10-12 15:52:04"},{"id":"78aca2a1-2f9b-463a-85c4-8a95500256f3","text":"Samoa withdrew the MMR vaccine after two babies died within minutes of receiving the MMR shot.","date":"2019-10-24 00:00:00+00:00"},{"id":"a9b84cf4-c9fc-42b0-b615-322ed7497c2f","text":"Wisdom teeth are meridian lines connected to the heart and removing wisdom teeth causes heart problems.","date":"2024-08-14 00:00:00+00:00"},{"id":"1819efd9-1057-4ec9-92a5-e84923e4c147","text":"The United States is using Ukraine as a guinea pig to test vaccines.","date":"2020-11-14 13:07:00"},{"id":"7e985f17-a69e-4ed5-bf5c-461248b507a9","text":"Hydroxychloroquine, azithromycin, and zinc cure COVID-19.","date":"2020-07-08 00:00:00+00:00"},{"id":"772b5976-97f2-4a12-95c8-3f67f08ffee6","text":"A 51-million-person study found COVID-19 vaccines increase the risk of respiratory infections by 559%.","date":"2025-11-11 00:00:00+00:00"},{"id":"41fa445b-dce3-4c84-82a5-bf1898a19393","text":"Aircraft are spraying chemical gases containing aluminum, barium, and other metals to block the sun and create chemical rain and fog to manipulate the weather.","date":"2025-02-14 00:00:00+00:00"},{"id":"407e8b61-b3db-4edd-950e-2c807109ba23","text":"Ukrainian President Volodymyr Zelensky ordered the Catherine II statue in Odesa to be replaced with a monument of a US porn star.","date":"2022-08-03 11:31:00"},{"id":"11753fbd-fc9c-402d-9811-3a69df087b20","text":"Pfizer\'s clinical trial showed equal numbers of deaths in the vaccine and placebo groups, so the vaccine had no benefit.","date":"2023-10-21 00:00:00+00:00"},{"id":"fafcf85e-287c-4677-80fa-62bdaa6b7702","text":"A person\'s immune system strength can be determined by looking at their eyes.","date":"2022-05-09 00:00:00+00:00"},{"id":"70a16720-d268-4f35-8e36-ad170ce32bcf","text":"More than 88% of ICU patients in Germany are vaccinated, and COVID-19 vaccines do not protect against severe disease.","date":"2022-11-13 00:00:00+00:00"},{"id":"e95db749-5098-4ec6-9345-aec6a1d3b8b6","text":"The Great Barrier Reef is experiencing the largest bleaching event ever recorded.","date":"2020-04-06 00:00:00+00:00"},{"id":"fe0988b3-260b-4fff-8d24-d9fa3d1fa95c","text":"Ukraine supplied Azerbaijan with phosphorus weapons.","date":"2022-11-30 16:57:00"},{"id":"03dc2d2b-ec15-4eff-9790-593d2a773e75","text":"World leaders were duped into investing billions because global warming data was manipulated.","date":"2017-06-02 00:00:00+00:00"},{"id":"61090b8f-c351-4d39-b293-02d496c4ca2d","text":"The Delta variant of SARS-CoV-2 has a lower fatality rate than the original (Wuhan) variant.","date":"2021-07-04 00:00:00+00:00"},{"id":"e4d88dec-37e3-4c03-86f7-7faaa4a822a6","text":"The UN will not provide money to the Ukrainian government.","date":"2017-12-04 07:08:53"},{"id":"dbe5cb87-6836-4dd6-a307-d04dc800cde1","text":"Ukraine authorized Poland to distribute Ukrainian passports.","date":"2022-07-15 16:04:00"},{"id":"0747b3a4-c669-4df5-808a-d613cadeec1a","text":"Nicotine patches cure Parkinson\u2019s disease.","date":"2024-05-31 00:00:00+00:00"},{"id":"51cd1cdb-d1fb-4f80-b303-18db54827cf5","text":"A Ukrainian Army tank crushed a car containing a passenger.","date":"2016-12-15 21:30:16"},{"id":"39f943a4-0a7d-4621-b7a7-5c0be2d61db5","text":"A record number of Ukrainian tourists visited Crimea.","date":"2017-05-09 16:17:55"},{"id":"a4dcd6e9-eeda-4dfb-9c64-117707d0a66c","text":"COVID-19 PCR tests are inaccurate, have been discontinued, and cannot differentiate influenza from COVID-19.","date":"2021-07-26 00:00:00+00:00"},{"id":"d485c361-9b6d-4071-87fe-6aacd4cd6180","text":"Ukrainian President Volodymyr Zelenskyy exempted relatives of Galicia Division soldiers from conscription.","date":"2025-05-07 00:00:00+00:00"},{"id":"1e091d8f-eedd-4c4a-b128-1d8c08550b36","text":"COVID-19 vaccines are causing a rise in heart attacks among young people.","date":"2023-02-27 00:00:00+00:00"},{"id":"b59a7553-ce15-4155-84ae-a924e79313a4","text":"Ukraine refuses Western arms due to supply difficulties.","date":"2023-12-12 14:51:00"},{"id":"3c5f91b2-eb4d-4fe5-a274-f1526c2230d8","text":"Lockdowns and face masks do not control the COVID-19 pandemic.","date":"2020-11-13 00:00:00+00:00"},{"id":"d7b4ec5f-6db9-4bd8-b2d1-46940bbd2d84","text":"The European Union warned Ukraine against militarizing the Sea of Azov.","date":"2018-10-27 18:08:53"},{"id":"cfd59ee6-711b-453c-8505-5bc0e9d0499b","text":"COVID-19 vaccine spike proteins accumulate in cell nuclei, destroy DNA repair pathways causing cancer, and destroy the immune system.","date":"2021-11-05 00:00:00+00:00"},{"id":"5c9afadf-bdd1-4b6f-90a5-1539e037df31","text":"COVID-19 immunity lasts for years.","date":"2021-01-06 00:00:00+00:00"},{"id":"db3e2d4f-8f74-418a-94d6-6dd00d5ff23a","text":"Ukraine is preparing terrorist attacks in Crimea.","date":"2018-07-12 22:37:24"},{"id":"fa6bd3a3-a782-4525-8065-d7c55a7d2524","text":"Rockefeller suppressed natural healing modalities to profit from petroleum-based medicine and had natural medicine practitioners arrested and jailed.","date":"2023-05-09 00:00:00+00:00"},{"id":"39ced119-b9ff-4dd5-bffb-c2b0dfac001e","text":"Flights from New Zealand to Argentina connect through the U.S., which proves the Earth is flat.","date":"2025-02-14 00:00:00+00:00"},{"id":"51c6b7ce-bcd6-4d3e-a738-a4be010d31de","text":"The CDC is a vaccine company that owns over 20 vaccine patents and sells $4.6 billion in vaccines every year.","date":"2021-02-19 00:00:00+00:00"},{"id":"3bf74375-2e58-4af8-81f7-5bd09e663411","text":"Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic.","date":"2020-01-26 00:00:00+00:00"},{"id":"ace2a506-60b7-423b-9530-21d89ee724c1","text":"A new language law makes Ukrainian the only official language.","date":"2017-01-25 19:26:31"},{"id":"55db5b56-74ee-471d-b522-65a8bf2f70c4","text":"Birch trees were chopped down in Lviv to prevent Russian influence.","date":"2014-07-02 14:00:43"},{"id":"fc96abd7-8ce2-4450-bfd6-951a94697ffc","text":"Smoking protects against COVID-19.","date":"2020-04-23 00:00:00+00:00"},{"id":"151026d8-aa87-4c5e-a1ed-b5a85230e132","text":"Vaccinated people are more likely to die from the Delta variant than unvaccinated people.","date":"2021-07-16 00:00:00+00:00"},{"id":"e11aef87-b457-45ce-bf4e-efda03b4bed1","text":"Ukraine\u2019s Defense Minister declared World War III and urged the West to raise the stakes.","date":"2022-06-30 17:53:00"},{"id":"260d2849-6e85-4bd7-a5e0-3533d6ec5909","text":"Vaccination causes two deaths for every three deaths it prevents.","date":"2021-06-24 00:00:00+00:00"},{"id":"90bdfa4e-b4a0-443d-84a2-56ac539d802a","text":"Global warming is causing polar bears to go extinct.","date":"2020-07-27 00:00:00+00:00"},{"id":"20f72b01-a541-48db-a97c-ad35b82d6dfe","text":"Natalie Jaresko, Ukraine\'s Minister of Finance, is the sister of former president Viktor Yushchenko\'s wife.","date":"2014-12-15 01:33:18"},{"id":"27df6cfc-a1c0-4cca-9425-b5897788f1d8","text":"Ukraine recruits mentally unstable foreign fighters.","date":"2024-09-23 10:19:00"},{"id":"0a2b3c34-28d6-4c0f-b765-6820ab6a46c7","text":"Germany asked the United States to ease sanctions on Russia.","date":"2018-04-19 22:23:03"}],"events":[{"id":"38817e72-8ea6-4a91-8032-30eba5f54cb7","text":"Japan suspended use of multiple Moderna COVID\u201119 vaccine lots after reports of black/foreign particles found in vials (September 2021).","date":"2021-09-17 00:00:00"},{"id":"3a17acef-1782-4e5f-aa26-098cc82ab82a","text":"Media coverage and public records requests highlighted increases and registration of \'Sudden Adult Death Syndrome\' (SADS) entries and prompted local registries/news stories in 2021\u20132022 (e.g., ONS FOI data and June 2022 press stories).","date":"2022-06-24 00:00:00"},{"id":"96c10070-a729-45d2-a388-f0bf828e9f4f","text":"Federal judge orders FDA to hasten release of Pfizer COVID-19 vaccine documents after agency proposed a 75\u2011year timeline.","date":"2022-01-07 00:00:00"},{"id":"2157e893-ff88-41ee-b94d-63bdd6b33a42","text":"Public health agencies (including the CDC) acknowledged a rare association between mRNA COVID\u201119 vaccines and myocarditis/pericarditis, particularly in younger males (June 2021 and onward).","date":"2021-06-24 00:00:00"},{"id":"379de43d-cf89-4e1c-a6bd-ea204190dd70","text":"Canada officially declared bisphenol A a \'toxic substance\' and banned BPA in baby bottles (widely reported in October 2010).","date":"2010-10-14 00:00:00"},{"id":"936b959b-6c76-4051-89f6-fe1ec2bee40e","text":"EU Regulation 2018/213 restricting the use of BPA in varnishes and coatings intended to come into contact with food (adopted 12 February 2018).","date":"2018-02-12 00:00:00"},{"id":"dce49401-863e-4c6f-893a-323fab28b5ec","text":"Authoritative public health pages (e.g., NIEHS) and large NGOs published accessible summaries about BPA being an endocrine disruptor and a substance under active study for health effects (updated educational pages in 2020\u20132021).","date":"2021-04-24 00:00:00"},{"id":"b6971264-6ca4-4aa5-a164-3d9bd552bfa7","text":"German federal and state governments adopted and publicised \'2G\' rules that restricted access to restaurants, cultural venues and events to vaccinated or recovered people.","date":"2021-11-16 00:00:00"},{"id":"7ab19c87-15df-4cbb-987d-eb9014edeb27","text":"Large anti-lockdown/anti-vaccine protests in Berlin where police used barriers, cordons and force to control crowds.","date":"2021-08-28 00:00:00"},{"id":"4b078541-759d-4b6e-b215-cf946dc4f2f7","text":"Lancet Psychiatry cohort study (Taquet et al.) reporting increased incidence of neurological and psychiatric diagnoses \u2014 including psychotic disorders \u2014 in the six months after COVID-19 infection.","date":"2021-04-24 00:00:00"},{"id":"a40f6c4b-f04b-414e-86bb-e50d7519d701","text":"NATO commander publicly reported sightings of columns of Russian tanks and troops crossing into eastern Ukraine.","date":"2014-11-12 00:00:00"},{"id":"6bbad3e4-8bce-455f-b619-561b2fa64940","text":"Investigative reporting (e.g., Bellingcat) published satellite analysis and open\u2011source investigations documenting cross\u2011border convoys and movements of heavy weapons into separatist\u2011held areas.","date":"2016-06-15 00:00:00"},{"id":"5b2a3322-05ed-40ad-a7e2-263881ca929a","text":"The February 2015 Minsk II agreement called for withdrawal and monitoring of heavy weapons but left verification and inventories contested.","date":"2015-02-12 00:00:00"},{"id":"db951ce3-0774-4b1b-8098-c783a8e0060a","text":"National Child Mortality Database (NCMD) data release: child death notifications in England Apr 2021\u2013Mar 2022 (3,470 deaths; 396 more than previous year)","date":"2022-11-10 00:00:00"},{"id":"4ee8388c-21bf-46da-b34d-6c991d81c123","text":"Kerch Strait incident \u2014 Russian forces fired on and seized three Ukrainian naval vessels near the Kerch Strait.","date":"2018-11-25 00:00:00"},{"id":"fec0b6e7-7749-48a6-a023-a4649ca36af7","text":"Odesa Trade Unions building fire \u2014 violent clashes on 2 May 2014 ended with a fire that killed dozens; accounts of responsibility were disputed.","date":"2014-05-02 00:00:00"},{"id":"ad77c269-8758-44cf-ab9b-5ccaf6f7e0c7","text":"Maidan sniper shootings \u2014 dozens of protesters and police were killed during the February 2014 Maidan clashes; responsibility for the snipers remained contested.","date":"2014-02-20 00:00:00"},{"id":"d2a9eeda-e0d7-4adf-8acf-5dd5b1b69038","text":"GUE/NGL (European United Left/Nordic Green Left) letter to President Poroshenko expressing concern about banning the Communist Party and alleged persecution of left\u2011wing groups","date":"2016-06-23 00:00:00"},{"id":"6eb99b34-dbe3-49ad-a849-160d8c11f9bb","text":"Court ban on the Communist Party of Ukraine (Kyiv administrative court decision reported December 2015)","date":"2015-12-17 00:00:00"},{"id":"f4b4255f-ed8a-498a-938a-a7347ca9e79f","text":"Panama Papers revelations naming Poroshenko\'s offshore connections (widespread reporting in April 2016)","date":"2016-04-04 00:00:00"},{"id":"39785e4f-77f4-4b08-ad16-8fe094cb7be1","text":"Fugitive lawmaker Oleksandr Onyshchenko\'s public corruption accusations against Poroshenko (June 2016)","date":"2016-06-24 00:00:00"},{"id":"684992a5-2c7c-47b9-9d0a-da99a5d62d04","text":"Court-ordered release and ongoing discussion of Pfizer/BioNTech vaccine documents (PHMPT/FDA document release process)","date":"2022-01-24 00:00:00"},{"id":"89efe27f-5d32-4380-9e65-7644e8368672","text":"Venice Commission (Council of Europe) publishes an expert opinion on the 2019 language law raising concerns about minority-language guarantees","date":"2019-12-06 00:00:00"},{"id":"ea8eba9e-8051-4f71-8589-621e0f0ca050","text":"Ukrainian parliament adopts the law \'On Ensuring the Functioning of Ukrainian as the State Language\'","date":"2019-04-25 00:00:00"},{"id":"45cd2538-8b5c-46ce-8c0a-b42354ca8b17","text":"Immediate political/media backlash and Kremlin-linked commentary framing the law as an attack on Russian speakers","date":"2019-04-25 00:00:00"},{"id":"367805bd-60b6-459f-8aa6-ba7e91ca4158","text":"Long\u2011running Kremlin/state media narrative labeling the Azov movement and affiliated groups as \'neo\u2011Nazi\' and dangerous.","date":"2022-03-29 00:00:00"},{"id":"dc10dd9a-4b20-48d2-b195-51777fbd3cc3","text":"Denis Pushilin / DPR authorities declared OSCE activities in DPR unlawful and ordered SMM property removed (escalatory political declaration).","date":"2022-04-09 00:00:00"},{"id":"db80f6e7-5b5a-4d3d-8a7f-0976038fa7ae","text":"OSCE SMM evacuated international monitors and then discontinued the Special Monitoring Mission (loss of on\u2011the\u2011ground oversight and telemetry).","date":"2022-03-31 00:00:00"},{"id":"a0a156cd-e22a-4c3b-b5d6-ee9a61dfb941","text":"High-profile advocacy and testimony for ivermectin (FLCCC / Dr. Pierre Kory Senate testimony, Dec 8, 2020)","date":"2020-12-08 00:00:00"},{"id":"146f7a30-90f1-441d-b120-fdb2884775c6","text":"Circulation of prominent preprints and small trials (notably the Elgazzar et al. preprint, Nov 2020) reporting large mortality benefits that fed pooled meta-analyses","date":"2020-11-13 00:00:00"},{"id":"3221eac8-87f2-4ae4-94a3-10488319adb7","text":"U.S. announcement to withdraw from the Paris Agreement (President Trump)","date":"2017-06-01 00:00:00"},{"id":"99d301bd-3e4f-4202-8c65-4e13eb4a35a6","text":"High\u2011profile congressional testimony by climate skeptic John R. Christy asserting climate models overstate warming","date":"2019-07-24 00:00:00"},{"id":"714c48f9-1de5-4102-baec-011c0b404f87","text":"Poland warns it could veto the EU budget over rule\u2011of\u2011law conditionality","date":"2018-11-09 00:00:00"},{"id":"0d5d70aa-630c-4de6-b6ef-36b85c677f16","text":"European Commission/legal action over refusal to accept refugee relocation quotas","date":"2017-02-24 00:00:00"},{"id":"a3817884-5e86-4a0e-96a0-abc909757b10","text":"European Commission triggers Article 7 procedure against Poland","date":"2017-12-20 00:00:00"},{"id":"1ca906e2-b0d3-439a-9c6e-9948f1d03d8a","text":"Mass protests after president signs contested judicial reform laws","date":"2018-07-26 00:00:00"},{"id":"fb127d47-1234-4c65-9c3c-1877970b3eb0","text":"Documented NGO and foundation support for Crimean Tatar NGOs (e.g., listings of NED and other international support for Crimean NGO activity after 2014)","date":"None"},{"id":"4735f952-560a-4efc-bd14-23bc7888a8c1","text":"Russian courts moved to ban and label the Mejlis \'extremist\' (legal actions and formal prohibition)","date":"2016-04-26 00:00:00"},{"id":"0810a5c9-b58b-4ec5-adbd-103a2842ffe2","text":"High-profile visits and statements by Mejlis leaders to international bodies (OSCE/UN/US) \u2014 e.g., Mustafa Dzhemilev meetings in 2015","date":"2015-01-30 00:00:00"},{"id":"d887d1af-80cd-48ae-a8cc-124464d09ea2","text":"Czech President Petr Pavel said in public interviews that Ukraine may need to be \'realistic\' about the prospects of liberating all occupied territory and that some areas could remain under Russian control temporarily.","date":"2025-03-24 00:00:00"},{"id":"8170bace-2d7f-4f1f-857a-b06c0eb8d69f","text":"Joint Prague press conference (Pavel and Zelenskiy) and Reuters coverage where Pavel warned the West not to pressure Ukraine into immediate liberation of all territories and said Russia \'has all the cards\' to end the war.","date":"2025-05-04 00:00:00"},{"id":"ea179191-dd07-4d44-9c73-fe1f9a8d4df3","text":"Peer-reviewed meta-analysis reported that berberine (a plant alkaloid) showed glucose\u2011lowering effects in randomized trials, with some comparisons to metformin (systematic review and meta\u2011analysis, PubMed).","date":"2012-04-24 00:00:00"},{"id":"3dd7b820-dbf9-418e-8570-ae937593e90f","text":"U.S. FDA and FTC jointly sent warning letters to 10 companies for marketing dietary supplements with unlawful claims to prevent, treat or cure diabetes.","date":"2021-09-24 00:00:00"},{"id":"ee008479-2289-4446-9132-8c75ade20ed3","text":"Japan finds stainless\u2011steel/foreign particles in multiple Moderna vaccine vials, triggering recalls/pauses","date":"2021-09-24 00:00:00"},{"id":"f3ddd2b0-3e39-4f9e-8999-561d992acc38","text":"Historical FDA enforcement and public warnings against Hoxsey\u2019s remedies (including 1956\u20131957 inspections and widely distributed FDA \'Beware\' posters).","date":"1957-04-24 00:00:00"},{"id":"92e61383-3536-4054-8579-a904018b2e01","text":"Ukrainian Cabinet of Ministers issued a permit allowing Biopharma Plasma to export 32 blood\u2011derived medicinal products (Cabinet resolution No.1005).","date":"2017-12-27 00:00:00"},{"id":"d4814cc2-fa4f-4b64-b524-fbfaf55aac53","text":"Publication of a large Danish national birth\u2011cohort study (Liew et al.) reporting an association between maternal acetaminophen use in pregnancy and autism spectrum disorder (ASD) with hyperkinetic symptoms.","date":"2016-04-24 00:00:00"},{"id":"c9b9ea97-f8e6-4d40-bb74-fc1ddbb5ea9b","text":"2014 J. Agric. Food Chem. study: quercetin and EGCG shown to have zinc ionophore activity in models","date":"2014-04-24 00:00:00"},{"id":"829d31db-8aa2-40cc-9c88-773a9efc3573","text":"2014 PLoS ONE report: chloroquine acts as a zinc ionophore","date":"2014-10-24 00:00:00"},{"id":"c038129f-6a7c-4d41-b509-5fbbde62f12d","text":"Mid\u20112020 public promotion: clinicians/influencers (eg. Dr. Vladimir Zelenko) advocated hydroxychloroquine + zinc as a COVID\u201119 treatment","date":"2020-07-24 00:00:00"},{"id":"c4ec41ee-edc2-4e97-8286-6ebf940f58a5","text":"October 2020 multicenter cohort (NYU) preprint: \'Zinc with an ionophore associated with reduced in\u2011hospital mortality\'","date":"2020-10-26 00:00:00"},{"id":"482f123e-5c2e-4384-8d1e-b1cf8956ddab","text":"2010 PLoS Pathogens paper: in vitro inhibition of coronavirus polymerase by Zn2+ and blockade of replication by zinc ionophores","date":"2010-11-04 00:00:00"},{"id":"1dc762ef-2efe-452d-b773-d99eb32c7cec","text":"Hungary vetoed a joint NATO statement on Ukraine citing concerns about the rights of the ethnic Hungarian minority","date":"2019-10-30 00:00:00"},{"id":"cc7a9342-86ad-4560-8aad-fdee3a57eb19","text":"Hungary\u2019s simplified naturalisation (citizenship-by\u2011descent) program resulting in large numbers of passports issued to ethnic Hungarians in Transcarpathia/Zakarpattia","date":"2011-03-24 00:00:00"},{"id":"639887f4-84bc-4417-b01b-6cab4248b8af","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly stated during the 2022 Russian invasion that the lives and security of Hungarians in Transcarpathia/Ukraine were a priority for his government","date":"2022-03-03 00:00:00"},{"id":"860f708b-df74-45ba-a4c1-de5320b64832","text":"Media and human\u2011rights coverage documenting tensions and complaints by the Hungarian minority in Zakarpattia/Transcarpathia during 2017\u20132022 (language disputes, local political friction)","date":"2022-03-24 00:00:00"},{"id":"cc943ea3-351c-42c4-814b-690a63727907","text":"U.S. issues Emergency Use Authorization and rapid rollout of Pfizer\u2011BioNTech vaccine (December 2020)","date":"2020-12-11 00:00:00"},{"id":"9ea199bf-97ff-446a-ade3-676524ef8e19","text":"UK regulator (MHRA) issues guidance after two reports of anaphylaxis following the first Pfizer/BioNTech vaccinations","date":"2020-12-09 00:00:00"},{"id":"6ee2c4a5-b657-4d1c-9444-ffcf3cf9fd89","text":"Pfizer/BioNTech EUA fact sheets and clinical publications note limited data in children and absence of long\u2011term safety data at authorization","date":"2020-12-24 00:00:00"},{"id":"4ac88c8b-a6ca-479c-8ef1-3ec6317c887a","text":"Mass stabbing at Westfield Bondi Junction created a chaotic breaking-news environment","date":"2024-04-13 00:00:00"},{"id":"4ded304a-7c7a-4b94-b613-5b71b1cd02af","text":"Major Iberian power blackout on 28 April 2025 that disrupted electricity across Spain and Portugal","date":"2025-04-28 00:00:00"},{"id":"674d7e77-a807-4bcb-b2f0-db7fd01b99dc","text":"Nationwide Telef\xf3nica network update caused widespread mobile and emergency-service outages across Spain","date":"2025-05-20 00:00:00"},{"id":"f9f91961-5933-45e4-a97a-0833538d7593","text":"Czech Ministry of Foreign Affairs published an official statement saying the Crimea referendum was held in violation of the Ukrainian constitution, that the Czech Republic does not recognize the referendum results and continues to recognise Crimea as part of Ukraine.","date":"2014-03-16 00:00:00"},{"id":"58f8bc90-56c1-4f8d-8932-e115eb1eb493","text":"Czech President Milo\u0161 Zeman publicly criticised Western sanctions and expressed skepticism about their effectiveness in interviews/statements in March 2014.","date":"2014-03-24 00:00:00"},{"id":"8eaf0a96-0a0d-4ce1-91c1-5dddff9ddc32","text":"Release of GLOBOCAN 2022 global cancer estimates showing large numbers of new cancer cases and highlighting female breast cancer as one of the most common cancers","date":"2023-02-24 00:00:00"},{"id":"035c0704-fde6-402a-bd64-295dcc5ab480","text":"Publication of national cancer registration statistics for England (Cancer registrations 2022) showing higher numbers of cancers diagnosed in 2022 compared with 2021","date":"2023-03-24 00:00:00"},{"id":"00a36aae-c5bb-448e-ab16-0395d0b70515","text":"GRELL cooperative study (2013) and similar national registry analyses showing modest annual increases in breast cancer incidence among women under 40 in several European countries","date":"2013-04-24 00:00:00"},{"id":"bd2cfaed-5d7a-4929-beb3-86245cd1c054","text":"Publication of analyses and commentary about the impact of COVID\u201119 on cancer services and screening (UK/NHS context) documenting diagnostic backlogs and subsequent rises in diagnoses when services resumed","date":"2022-04-24 00:00:00"},{"id":"64d50dc5-383a-4f9d-80be-93d978bdc313","text":"Prominent visibility of far\u2011right/ultranationalist groups (e.g., Right Sector) in Maidan protests","date":"None"},{"id":"87fa4685-aa79-4eed-b5cb-50f8aef33b49","text":"Seizures of regional government buildings and street clashes in eastern/southern Ukraine (Donetsk, Kharkiv) in early March 2014","date":"2014-03-01 00:00:00"},{"id":"768dac8b-d8e9-4bcb-97f6-1ed7eb45ef31","text":"Widespread toppling/removal of Lenin statues across Ukraine (the \'Leninopad\')","date":"None"},{"id":"6c0852dc-908f-4e43-8e65-b39c0a942d84","text":"High local tensions and protests in Lviv during February 2014, with public gatherings and confrontations around symbolic sites","date":"2014-02-21 00:00:00"},{"id":"28477e2e-b2d0-4bea-aa09-8f91c8ed2caf","text":"Russian/state media narratives framing the Kyiv movement as \'fascists\' and amplifying isolated incidents","date":"2014-03-04 00:00:00"},{"id":"363e93cb-9979-4571-81a4-9becd07d7e1b","text":"President Trump publicly urged the FDA to \'fast-track\' potential COVID-19 treatments, including hydroxychloroquine","date":"2020-03-19 00:00:00"},{"id":"14394b9e-6ed0-474f-8195-ae45ad8886e8","text":"ClinicalTrials.gov registrations for thalidomide trials in COVID-19 (e.g., NCT04273581)","date":"2020-02-18 00:00:00"},{"id":"9f75fed9-5379-4ae5-ad35-29573d717166","text":"Moderna announces first participant dosed in NIH-led mRNA-1273 Phase 1 vaccine trial","date":"2020-03-16 00:00:00"},{"id":"a865b697-9c11-451c-b357-6deb59025afe","text":"OSCE Representative on Freedom of the Media condemns attacks and detentions of journalists in eastern Ukraine","date":"2014-06-03 00:00:00"},{"id":"6bb25525-db36-48fa-928f-3c54ff5192b7","text":"Two Russian state television journalists (Igor Kornelyuk and Anton Voloshin) killed by mortar fire near Luhansk","date":"2014-06-17 00:00:00"},{"id":"557f5241-833b-4d75-bd17-d5e083a9c848","text":"Italian photojournalist Andrea Rocchelli killed near Sloviansk while reporting on Donbas fighting","date":"2014-05-24 00:00:00"},{"id":"3aa14a59-17e4-4777-8e1d-8ae3f9be02bb","text":"Scientific literature demonstrating decades of \'edible vaccine\' research (2019 review \'Edible Vaccines: Promises and Challenges\')","date":"2019-11-22 00:00:00"},{"id":"1197b256-f2e7-4f92-8cd6-82ff67958352","text":"U.S. House passes amendment to prohibit funding for \'transgenic edible vaccines\' (Massie amendment)","date":"2023-09-27 00:00:00"},{"id":"7c7d2966-8267-4911-af9c-12c9f638b50a","text":"Health Canada approval of Medicago\'s plant\u2011based COVID-19 vaccine (COVIFENZ)","date":"2022-02-24 00:00:00"},{"id":"48aa818f-0004-46f4-b264-5cf6bfd86d44","text":"2014 reports and analyses on prevention of smuggling of nuclear and radioactive materials at the Ukraine\u2013Moldova border","date":"2014-06-24 00:00:00"},{"id":"c3652003-e9b3-4858-9187-97009a81a649","text":"2015 reporting on large volumes of spent nuclear fuel stored in exposed open-air yards at Zaporizhia NPP","date":"2015-05-06 00:00:00"},{"id":"7d8c806e-235f-4780-b922-e4b749fe7829","text":"WHO interim guidance on mask use (published 5 June 2020) noted there was \'no direct evidence\' from community studies on universal masking","date":"2020-06-05 00:00:00"},{"id":"507f1d48-65d3-4331-b334-74205ccc9cf6","text":"Russia began issuing Russian passports to residents of occupied Donetsk and Luhansk (passportisation program, reported from 2019 onward)","date":"2019-06-24 00:00:00"},{"id":"be24cc5d-48a1-4fd2-98b6-c84005b2eb5a","text":"Pre\u2011war remittance and labour links between Ukraine and Russia documented in World Bank data (substantial remittance inflows historically)","date":"None"},{"id":"d79c60ce-8f4c-4997-83e8-d17fafb90523","text":"2001 Ukrainian census shows large Russian\u2011language population (\u224829.6% reported Russian as mother tongue)","date":"2001-04-24 00:00:00"},{"id":"1738a518-ba07-4ca3-9eca-d29ea746b6ce","text":"Media reports (e.g., Reuters, 11 Jan 2023) relayed WHO and other experts saying XBB.1.5 may be driving recent case increases in some areas.","date":"2023-01-11 00:00:00"},{"id":"308fd4d8-6903-4d8c-b2a4-0fbaee4b4fe2","text":"Oxford/UK analyses and technical briefings in July\u2013August 2021 documenting reduced vaccine effectiveness against symptomatic infection with Delta and reporting viral-load related findings.","date":"2021-08-16 00:00:00"},{"id":"7448f12b-9dc9-42a3-b6de-962a71c7ed57","text":"CDC MMWR report on the Provincetown (Barnstable County) outbreak showing many cases among fully vaccinated people and reporting similar viral loads in some vaccinated and unvaccinated cases.","date":"2021-07-30 00:00:00"},{"id":"1f06b3d0-c786-4d72-9b93-21be62274d4a","text":"Ongoing pattern of journalists killed or injured while reporting on the Russia\u2013Ukraine war since 2022.","date":"None"},{"id":"4d8ec00f-12c2-4a55-8fe4-02c2c73feb6c","text":"Escalation of cross\u2011border fighting and reported Ukrainian incursions into Russia\'s Kursk region in early August 2024.","date":"2024-08-06 00:00:00"},{"id":"0fdaa2f0-ec41-4eeb-874c-df6ef607bdd9","text":"Retraction of high-profile hydroxychloroquine research (Surgisphere-related Lancet study)","date":"2020-06-04 00:00:00"},{"id":"8197d19e-eceb-4bfe-aba8-d6ddc8230219","text":"U.S. Food and Drug Administration revoked the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID\u201119","date":"2020-06-15 00:00:00"},{"id":"a6af24d1-f9dc-483c-a4d8-a6f50fa7b678","text":"Publication of a 2015 review clarifying that peripheral (gut) serotonin and central (brain) serotonin are separate pools because serotonin itself cannot cross the blood\u2013brain barrier.","date":"2015-05-24 00:00:00"},{"id":"55fab3e5-ba46-4262-ae1c-d37882c30805","text":"Vatican note on the morality of using some COVID-19 vaccines (explicit discussion of fetal\u2011cell\u2011line origins)","date":"2020-12-21 00:00:00"},{"id":"4c787be9-0d63-4d4d-bade-049a1d973e67","text":"Public-facing CDC guidance page describing vaccine additives and manufacturing substances (e.g., formaldehyde, aluminum) made widely available","date":"None"},{"id":"fe136853-4ebb-4ed7-a1c3-5bea298e90e1","text":"CDC / AAP precautionary move to remove/reduce thimerosal from childhood vaccines (timeline publicity)","date":"1999-07-24 00:00:00"},{"id":"24221e44-62c5-4978-8daf-953b9cb01868","text":"Detection of porcine circovirus DNA (PCV1) in the Rotarix rotavirus vaccine and global regulator review","date":"2010-03-24 00:00:00"},{"id":"e2efe459-f5bf-48f4-aabb-d2614f71c39a","text":"Assassination of Boris Nemtsov on a bridge near the Kremlin","date":"2015-02-27 00:00:00"},{"id":"dc0244e3-143a-4b9f-a10d-0fb551669113","text":"Vatican Congregation for the Doctrine of the Faith published a note stating it is morally acceptable to receive some COVID-19 vaccines developed using cell lines from aborted fetuses (approved by Pope Francis).","date":"2020-12-21 00:00:00"},{"id":"ebb90c43-c681-4398-a1a7-f903b4292d05","text":"CDC Pink Book Appendix B (Vaccine Excipient and Media Summary) lists cell lines such as WI-38 and MRC-5 in vaccine production context (table circulated online, edition info in use January 2021).","date":"2021-01-24 00:00:00"},{"id":"bbc04673-2959-4bfd-9506-96a313508f38","text":"American Optometric Association consumer alert about at\u2011home/online vision tests and devices","date":"2022-10-27 00:00:00"},{"id":"b5c8ae6a-2bf6-428b-8893-ae8ae103b4e3","text":"Russian proposals and measures to fast-track citizenship for Crimean residents","date":"2014-03-24 00:00:00"},{"id":"7413dd57-157d-4e44-a9c9-ba040174c5c7","text":"Pro-Russian separatists declare Donetsk \'People\'s Republic\' after seizing regional building","date":"2014-04-07 00:00:00"},{"id":"40f46eaa-714a-47d4-9a53-3e4de1e79681","text":"Putin\'s Kremlin speech endorsing Crimea accession","date":"2014-03-18 00:00:00"},{"id":"045f7b0d-d4a4-4285-9a62-8dabd3dae61c","text":"Delta-variant surge and public messaging (summer 2021) urging vaccination ahead of difficult hurricane-season scenarios","date":"2021-07-24 00:00:00"},{"id":"d8ac564c-5a0f-499d-86a5-8f9917a9bfb8","text":"Israel reports drop in observed vaccine effectiveness against infection (94% \u2192 ~64%) amid Delta","date":"2021-07-05 00:00:00"},{"id":"2157720a-b31f-4765-9e5f-abe16965d54a","text":"Great Barrington Declaration advocating \'focused protection\' published","date":"2020-10-04 00:00:00"},{"id":"c63f59c1-d72b-41e4-a08e-84a2f41ddfe5","text":"Systematic review estimating COVID-19 infection-fatality rate ~0.68%","date":"2020-09-29 00:00:00"},{"id":"3c1df8b6-9533-4c62-a317-a807afa5c317","text":"Age\u2011stratified IFR analysis showing extremely low fatality risk for younger people","date":"2020-07-24 00:00:00"},{"id":"b80a6589-2541-416c-a08b-60e2d631e5e3","text":"Public availability of VAERS as a passive reporting system and official CDC/FDA guidance about its limitations","date":"None"},{"id":"66670a2a-cbbd-44a6-82ca-4421126b801f","text":"ACIP/CDC recommendation during the 2009 H1N1 pandemic that pregnant women receive H1N1 and seasonal influenza vaccines","date":"2009-10-24 00:00:00"},{"id":"90b7bf11-a8f9-4fa2-98e3-a4dc0f9f14e9","text":"Publication of Goldman GS (2013) \'Comparison of VAERS fetal\u2011loss reports during three consecutive influenza seasons\' (Human & Experimental Toxicology)","date":"2013-05-24 00:00:00"},{"id":"b02e365e-b224-47a8-a9f6-af76ca7fc5de","text":"Reports and analyses in 2015 highlighted growing Hungarian activism in Zakarpattia (large numbers receiving Hungarian passports and political pressure over minority rights throughout 2015).","date":"2015-04-24 00:00:00"},{"id":"b30d79c6-5159-4996-b79a-7752d1373f4f","text":"Think\u2011tank analysis and regional commentaries described longstanding identity, linguistic and historical fault lines in Zakarpattia and proposals for a \xabTrans\u2011Tisa/Transcarpathian\xbb administrative unit (OSW commentary, Sept 2015).","date":"2015-09-30 00:00:00"},{"id":"8f1395d8-01e0-4fab-89cd-d4455bc695bf","text":"Armed clash (Mukachevo shootout) between Right Sector fighters and local security forces in Mukachevo, Zakarpattia, leaving several wounded (11 July 2015).","date":"2015-07-11 00:00:00"},{"id":"c69fc9cd-d7d3-40ed-9c06-f6d6ec253b4d","text":"Local reporting and human-rights outlets flagged that the \u2018\u2018Transcarpathian Rus\u2019\u2019/Rusyn congress and statements by Petro (Pyotr) Getsko were likely provocations amplified by Moscow (coverage March 2015).","date":"2015-03-24 00:00:00"},{"id":"298d23b5-afbb-4e93-8cac-5e76326f04b6","text":"Scuttling of Ukrainian vessels in Donuzlav Bay (6 March 2014) to block naval exits","date":"2014-03-06 00:00:00"},{"id":"8b5a5f1a-b189-4ee1-a515-8f9cfff8233f","text":"Official/legal exhibits and scientific analyses documenting that the Sea of Azov and Kerch Strait routinely experience ice cover that can obstruct navigation (analysis covering up to 2017)","date":"2017-04-24 00:00:00"},{"id":"1bb5060b-06f9-4023-b08d-f341eb37296f","text":"Severe Black Sea freeze restricted navigation and stranded vessels in January 2017","date":"2017-01-12 00:00:00"},{"id":"7e545939-4ee8-40a2-9ae5-81e97f25288f","text":"Russian forces seized multiple Ukrainian naval vessels during the March 2014 Crimea operation","date":"2014-03-20 00:00:00"},{"id":"eb0c521c-32dd-465b-9fe0-cf36781f6670","text":"U.S. Ninth Circuit Court of Appeals issued an opinion (June 7, 2024) vacating the district court\'s dismissal and allowing a lawsuit challenging LAUSD\'s COVID\u201119 vaccine mandate to proceed; the opinion noted that, at the pleading stage, the court must accept plaintiffs\' allegation that the vaccines do not prevent transmission.","date":"2024-06-07 00:00:00"},{"id":"a7d10e01-e281-4f96-a0fa-8dadd3bed992","text":"The U.S. Centers for Disease Control and Prevention revised wording on its website for \'vaccine\' and \'vaccination\' in September 2021 (shorter/modernized wording replacing earlier phrasing about \'producing immunity\').","date":"2021-09-24 00:00:00"},{"id":"1c3ecb4f-819d-4245-a521-b26ef8088f65","text":"Local activist action in Chernihiv (\'Feed the Communist\') in May 2015 where activists distributed food kits and removed or replaced communist symbols.","date":"2015-05-24 00:00:00"},{"id":"56776a04-155a-40b6-a503-9bea56d3cf42","text":"Publication and publicity of studies showing reduced antibody responses in clinically immunocompromised groups (OCTAVE/related studies reported in The BMJ)","date":"2021-08-24 00:00:00"},{"id":"538f9251-4ba8-4d69-b12f-d9bcb8131631","text":"Stockholm arbitration tribunal ruled in favour of Naftogaz against Gazprom (final award and related rulings published 28 February 2018), ordering significant payments in Naftogaz\'s favor.","date":"2018-02-28 00:00:00"},{"id":"03d8bffd-1eb9-4588-8236-62839cb3cb49","text":"Publication of a 2015 Danish case series (Brinth et al.) reporting suspected postural tachycardia syndrome (POTS) and related autonomic symptoms following quadrivalent HPV vaccination.","date":"2015-05-24 00:00:00"},{"id":"aaf575f9-f8ae-402f-9662-f4eb4217d6ee","text":"Danish Medicines Agency and European regulators reviewed reports from Denmark about suspected HPV vaccine adverse events and produced public assessments and data summaries.","date":"2015-04-24 00:00:00"},{"id":"f1abfe62-d77e-4798-bf5e-a3939e34fdf1","text":"2014 French case-control study published in Clinical Rheumatology examining possible associations between the quadrivalent HPV vaccine and new\u2011onset autoimmune disorders.","date":"2014-12-24 00:00:00"},{"id":"7598cb80-2cc0-4862-a471-68163a62bb1f","text":"Ukraine\u2019s security service (SBU) announced an investigation that alleged nearly $40 million was embezzled in a mortar\u2011shell procurement scheme","date":"2024-01-27 00:00:00"},{"id":"4296771e-b956-4ba7-8671-013491e18853","text":"Pentagon Inspector General report found about $1 billion of U.S. weapons sent to Ukraine were not properly tracked","date":"2024-01-11 00:00:00"},{"id":"871e41ff-6e5a-4f51-928d-541f50c7ff7f","text":"Widespread media reports documented an increase in Ukrainians (including some displaced by 2014 unrest) travelling to or taking up work in Russia to escape economic hardship and instability.","date":"2014-09-24 00:00:00"},{"id":"65983e1e-7638-476f-8f5a-1fd47c0c31f7","text":"Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers highlighting that recent warming is \'unequivocally\' driven by human activities (strong attribution to greenhouse gas emissions).","date":"2021-08-24 00:00:00"},{"id":"db00dd7f-a5ca-45af-87c3-d65662ede0a0","text":"Global Carbon Project press release and Global Carbon Budget 2021 reporting that global fossil CO2 emissions rebounded close to pre-COVID levels (published early November 2021).","date":"2021-11-04 00:00:00"},{"id":"cfa4b03e-f0df-4958-baeb-631c2383e698","text":"UNFCCC COP26 (Glasgow, Nov 2021) international climate summit and high-profile policy announcements on phasing down fossil fuels.","date":"2021-11-24 00:00:00"},{"id":"d416ff45-9044-4499-bd89-65cfc821de7e","text":"The extraordinary Pacific Northwest heat wave in late June 2021 and rapid attribution studies published in the weeks after the event.","date":"2021-06-24 00:00:00"},{"id":"ea68acd3-5234-4bf1-90b6-a175d94d0636","text":"Council of the EU adopted visa\u2011liberalisation regulation for Ukrainian citizens (moving Ukraine to visa\u2011free Annex II).","date":"2017-05-11 00:00:00"},{"id":"04b78e68-7272-4b89-a850-e0751f938c15","text":"Major outlets explained how the visa\u2011free scheme would operate and its limits (e.g., that it allowed 90 days\' travel within any 180\u2011day period and depended on biometric passports).","date":"2017-04-06 00:00:00"},{"id":"86b443f9-597c-4943-aa25-1e4de477c1d8","text":"Legal and normative context: Ukrainian prohibition on promotion/distribution of totalitarian symbols (noted in fact checks of similar claims)","date":"2023-01-13 00:00:00"},{"id":"a58b9b09-ff37-4144-b39c-50af1b458f87","text":"CDC guidance promoting widespread use of cloth face coverings and advising regular washing/maintenance","date":"2020-06-28 00:00:00"},{"id":"98d47805-4cd7-4731-8c6b-fef8bc38b147","text":"Dentistry and trade press reports warning about \'mask mouth\' and increased oral health issues","date":"2020-08-24 00:00:00"},{"id":"7f893751-008b-436b-bfd8-1ab6e0dd153a","text":"Public demonstrations by scientists/microbiologists using petri-dish or droplet-capture experiments to show masks block droplets","date":"2020-07-24 00:00:00"},{"id":"5744aada-6d04-4c83-b188-e9ab637f2c37","text":"Industry and research reports (IEA-PVPS and others) documenting end-of-life management challenges and the need to scale PV recycling infrastructure.","date":"2018-04-24 00:00:00"},{"id":"712ba18f-602d-464e-a145-9155d6ab150d","text":"Coordinated farmer and rural groups\' campaigns and protests against \'mega\' solar farms on productive farmland in the UK (national days of action and rallies organized by rural campaigners).","date":"2022-11-24 00:00:00"},{"id":"b9def34b-f479-47c6-bfbd-c090b718f4cc","text":"Laboratory leaching studies showing that crushed or non-encapsulated cadmium\u2011telluride (CdTe) thin\u2011film solar cell material can release cadmium and tellurium under extreme test conditions.","date":"2017-12-24 00:00:00"},{"id":"8af7630a-888f-429b-8d22-a888b3422656","text":"OSCE Special Monitoring Mission (SMM) recorded a marked increase in ceasefire violations in Donbas in early 2021 (multiple daily reports documenting dozens to hundreds of violations).","date":"2021-01-24 00:00:00"},{"id":"1d06b6ad-1c83-4e67-ad6e-27c1f6201f6a","text":"U.S. Department of State \'Ukraine 2020 Human Rights Report\' (published March 2021) documented the activity and influence of volunteer/paramilitary and nationalist groups (e.g., units linked to political parties) active in eastern Ukraine and at the front line.","date":"2021-03-24 00:00:00"},{"id":"4e2bfcc6-057a-45c2-bc22-5f22eb478b96","text":"Verkhovna Rada (Ukrainian parliament) passed the 2018 \'On the peculiarities of state policy to ensure Ukraine\'s state sovereignty over temporarily occupied territories of Donetsk and Luhansk regions\' (the \'reintegration of Donbas\' law) declaring parts of Donbas occupied and Russia an aggressor.","date":"2018-01-18 00:00:00"},{"id":"1dd98959-def5-4e70-aaed-6ffb79b0a02c","text":"President Zelenskyy\'s 2019 public handling of the Steinmeier Formula (acceptance/clarification) and the related domestic protests over concessions for the Donbas.","date":"2019-10-02 00:00:00"},{"id":"0d979bf2-cdbb-4ec7-bf27-6837e71f1b0f","text":"EU and US adopted rounds of sanctions against Russia following the 2014 annexation of Crimea and continued to maintain restrictive measures in subsequent years.","date":"2014-03-24 00:00:00"},{"id":"05c2fb4c-ae68-4663-861c-bbe293f5090b","text":"Public reporting and analysis of contacts between Trump\u2011family advisers (including Ivanka/Kushner) and Russian figures during and after the 2016 campaign (coverage of the Mueller report, 2019).","date":"2019-04-24 00:00:00"},{"id":"01e3cd24-74cd-4d13-8d26-bc216d1beebe","text":"Pro\u2011Russian activists stormed SBU (security service) offices in Donetsk and Luhansk and reportedly took weapons from armories.","date":"2014-04-07 00:00:00"},{"id":"5dd8dff5-0130-4958-a9a7-9187ecb8464a","text":"Ukraine\'s defence ministry publicly acknowledged that a number of its vehicles/equipment had been seized by pro\u2011Russian forces.","date":"2014-04-16 00:00:00"},{"id":"d22b2d07-e729-43c3-bd3d-ae9c221521cf","text":"State-level policy changes in 2022 loosening access to ivermectin (pharmacist dispensing/OTC measures in several U.S. states)","date":"2022-04-24 00:00:00"},{"id":"a915f3d1-92f2-4b83-9953-3e6ca65ded90","text":"Apter v. Department of Health & Human Services \u2014 Fifth Circuit opinion allowing doctors\' claims against FDA to proceed and criticizing agency messaging","date":"2023-09-01 00:00:00"},{"id":"c59ccbdb-f1d2-47c7-9ec4-47d9f9c56636","text":"President Poroshenko signed the 2015 \'de-communization\' laws (May 2015) that, among other provisions, publicly recognized fighters of the OUN\u2011UPA (associated historically with Stepan Bandera).","date":"2015-05-15 00:00:00"},{"id":"ff0e2e4e-984a-4fef-b122-7b4aa3b38962","text":"Russian state media had for months portrayed Ukraine\u2019s post\u2011Euromaidan authorities as \'Bandera\' nationalists and used the term \'Bandera junta\' in reports (widespread from 2014 onward).","date":"2014-08-11 00:00:00"},{"id":"5b4e9f1d-68d8-4d32-a100-156509555dbd","text":"The new law altered expiry/labeling requirements (e.g., month/year vs day/month) and set a delayed entry-into-force date","date":"2018-12-06 00:00:00"},{"id":"a805862a-118b-4af7-b9e4-4d70194d8057","text":"Verkhovna Rada (Ukraine\'s Parliament) adopted Bill No. 8450 \\"On Information for Consumers of Food Products\\"","date":"2018-12-06 00:00:00"},{"id":"720d0741-1485-4c41-9b9e-03674f20e31a","text":"2012 research proposing a quantitative \'tongue deviation angle\' threshold as a possible early warning sign of stroke (Wei et al., August 2012).","date":"2012-08-24 00:00:00"},{"id":"959df3ef-c111-4c09-9a7b-5c51b969ad13","text":"Launch of the UK \'Act F.A.S.T.\' national stroke-awareness campaign emphasizing Face/Arm/Speech/Time (first rolled out February 2009).","date":"2009-02-24 00:00:00"},{"id":"8efe4067-cedc-49e6-beb8-83092672d3a5","text":"European Commission public warnings about Ukraine\u2019s unfinished anti\u2011corruption and reform agenda","date":"2015-12-18 00:00:00"},{"id":"bf90eb67-8da3-407c-899e-c20dcbec088e","text":"EU\u2013Ukraine DCFTA implementation raised in trilateral talks with Russia amid practical concerns","date":"2015-12-24 00:00:00"},{"id":"3c765d9f-0405-4c43-bf03-a83048ccf162","text":"2013 Ukrainian government suspended signing of the Association Agreement (Vilnius), fuelling narratives of failure","date":"2013-11-21 00:00:00"},{"id":"88f9850f-41c4-4378-88a7-5102e569094f","text":"CDC MMWR report on the Barnstable County, MA outbreak showing many \'breakthrough\' infections among fully vaccinated people (July 2021)","date":"2021-07-30 00:00:00"},{"id":"050ddb9e-c254-478d-8ffe-f8fdeabb33a5","text":"Health Canada advisory and recall/alert over face masks containing graphene (public advisory that graphene in masks may present inhalation risks).","date":"2021-04-02 00:00:00"},{"id":"ec25c265-a8a3-44b8-9f5d-b63f1c3b884f","text":"Published transmission\u2011electron microscopy (TEM) and SEM images of graphene oxide in the scientific literature (e.g., ACS Nano structural analysis of graphene oxide).","date":"2009-04-24 00:00:00"},{"id":"b7330117-f843-4dd9-ad4b-b81e578ca1d2","text":"OSCE report documenting repeated interruptions to water access in Donetsk and Luhansk due to hostilities and infrastructure damage","date":"2015-04-24 00:00:00"},{"id":"c068ace4-0df2-40f5-afeb-0ee9d0d4a8a3","text":"Shelling damaged the Donetsk filtration plant, leaving much of Donetsk without running water","date":"2014-11-24 00:00:00"},{"id":"852671f2-72e2-4c38-bbb7-7af113f7aaaf","text":"China\u2019s temporary nationwide ban on trade and consumption of wild animals announced amid the outbreak","date":"2020-01-26 00:00:00"},{"id":"3c9b6f82-65dc-45c5-a727-981f257afc22","text":"Public\u2011health assessments linking many early cases to Wuhan\u2019s Huanan Seafood Wholesale Market","date":"2020-01-17 00:00:00"},{"id":"e4787dfa-2075-49af-8f60-4b153d6860f5","text":"Poland publicly resisted EU migrant relocation quotas and signalled tighter migration controls (Nov 2015)","date":"2015-11-24 00:00:00"},{"id":"161d37ba-03e3-4b00-a4ff-9688a7a5c6b1","text":"Poland and Ukraine temporarily closed or restricted certain crossings amid transport disputes (reports of Russian lorries stuck)","date":"2016-02-15 00:00:00"},{"id":"99aacb30-8d04-4f24-ae70-df3b276e8586","text":"Europol and Polish Border Guard dismantled an international people-smuggling network (September 2016)","date":"2016-09-24 00:00:00"},{"id":"5730ba58-c479-44ef-8060-17afa3bd67ca","text":"Passage of post\u2011Euromaidan lustration (vetting) laws and criticism from rights groups","date":"2014-04-24 00:00:00"},{"id":"2107b5eb-6e43-490d-b9a3-b973d2ecd63f","text":"Security Service of Ukraine (SBU) searches, surveillance and raids on media outlets and journalists (reported 2018\u20132019)","date":"2018-02-08 00:00:00"},{"id":"aa8a5f4e-1d86-4f50-b032-f1a9eb3fd837","text":"Kerch Strait incident and temporary imposition of martial\u2011law measures after the November 2018 naval clash","date":"2018-11-25 00:00:00"},{"id":"46cfca21-6e5d-4cfe-8b41-0e72b801599e","text":"Government blocking of major Russian social networks and internet services under sanctions","date":"2017-05-15 00:00:00"},{"id":"e7cba723-5ce7-41e0-9efe-ad11553b3672","text":"OSCE SMM spot report (22 January 2015) documents shelling incidents impacting civilian infrastructure, including water facilities, in Donetsk","date":"2015-01-22 00:00:00"},{"id":"4de3e13e-8ea4-4d67-b5e3-4e4bfe4a3617","text":"UN/UNICEF appeal (July 2015) calling for help to restore damaged water facilities in Donetsk and Luhansk","date":"2015-07-24 00:00:00"},{"id":"91c788f9-e420-4e6d-b7aa-f07ca5a1a9fe","text":"NCHS publishes final report \'Mortality in the United States, 2019\' (finalized 2019 death counts and age\u2011adjusted death rates)","date":"2020-12-24 00:00:00"},{"id":"cda6e5ef-b9ea-4f23-89c9-4b8a87e4fa7b","text":"Unusually low seasonal influenza activity and deaths during 2020 (CDC FluView reports for 2019\u20132020 and 2020\u20132021 showing steep decline)","date":"2020-12-12 00:00:00"},{"id":"b803b996-630b-4f05-b3b6-339f78b7c70f","text":"UN Mine Action Service (UNMAS) 2019 reporting and annual material describing extensive contamination by mines/ERW in Ukraine and the long-term nature of clearance","date":"2019-04-24 00:00:00"},{"id":"eb69e2dd-44a4-48ed-a7c3-f4d6ab56fff7","text":"Media reporting on international NGOs (HALO Trust) conducting humanitarian demining in Donbas and expanding operations in 2019","date":"2019-04-20 00:00:00"},{"id":"dda020cb-61b1-45bb-9d7d-677b7eda4255","text":"Peer\u2011reviewed and preprint research discussing biochemical/sequence similarities between portions of the SARS\u2011CoV\u20112 spike protein and snake neurotoxins (studies and tests of the \\"nicotinic\\" hypothesis)","date":"2021-04-24 00:00:00"},{"id":"9606da73-a8c6-4443-a79c-78836db4e4f1","text":"Norwegian health authorities reported deaths among very frail, elderly people shortly after receiving the Pfizer\u2013BioNTech COVID-19 vaccine and opened reviews (reports in mid\u2011January 2021 said 23 deaths were reported and some were judged possibly linked to vaccine side effects in very frail patients).","date":"2021-01-24 00:00:00"},{"id":"36f5302a-e74a-46d1-b5b0-8f4c1e418fef","text":"Reports and a CDC MMWR analysis documented cases of allergic reactions and anaphylaxis after initial Pfizer\u2013BioNTech vaccine doses in December 2020 (MMWR published January 2021 summarizing early anaphylaxis reports).","date":"None"},{"id":"84317b32-9768-4166-ad55-4761a28d3ac8","text":"Public release and wide circulation of raw VAERS (Vaccine Adverse Event Reporting System) reports documenting deaths reported after COVID\u201119 vaccination in late 2020 and early 2021.","date":"None"},{"id":"ed4ab4de-aac3-4757-add7-949e781db1b6","text":"UNODC report and national statistics showing Ukraine as a significant transit country and location of large heroin seizures in Europe","date":"2019-04-24 00:00:00"},{"id":"6dcc87dc-d2e1-4f7b-8285-ffd533b53b9b","text":"Europol / Eurojust-linked investigations and cross\u2011border law\u2011enforcement operations that identified networks using Ukrainian territory/ports to move cocaine and other drugs into the EU","date":"2019-04-24 00:00:00"},{"id":"2331d7d0-913d-4b46-8447-0f81b55cb1f0","text":"FTC and FDA joint warning letters and public enforcement actions targeting companies that market dietary supplements with unproven Alzheimer\'s or dementia treatment/prevention claims (e.g., joint letters and advisories in 2019).","date":"2019-02-24 00:00:00"},{"id":"4f1f0c64-1799-4bf9-a967-85e669866f8b","text":"18-month randomized, double-blind, placebo\u2011controlled trial of a bioavailable curcumin formulation (Theracurmin) reporting memory and PET biomarker improvements in non-demented adults (Small et al.).","date":"2018-03-24 00:00:00"},{"id":"0707cb89-2884-4686-83c6-9d85575d164d","text":"Small randomized, double-blind, placebo-controlled trial (Mori et al.) reporting improved cognitive scores in mild cognitive impairment after Hericium erinaceus (lion\'s mane) supplementation.","date":"2009-03-24 00:00:00"},{"id":"977f9386-b21f-4059-92ba-0bcdf2e251f0","text":"Prospective cohort studies (e.g., Ohsaki cohort and related epidemiologic research) reporting associations between higher green tea consumption and lower risk of cognitive decline / incident dementia or functional disability.","date":"2011-04-24 00:00:00"},{"id":"d374c1c5-661e-4f36-a173-c02bb705d5c0","text":"CBOS national poll showing sharp fall in Polish support for accepting Ukrainian refugees (April 2023)","date":"2023-04-24 00:00:00"},{"id":"5879a899-c44a-4513-96d8-68524214fee4","text":"EDMO/Fact\u2011checking reports documenting early disinformation narratives about Ukrainian refugees in Poland (April 2022)","date":"2022-04-04 00:00:00"},{"id":"2c94f3c8-2366-48cc-bc7b-7cf118c80621","text":"Political rhetoric and electoral pressure around Ukraine support (Reuters report, 19 Sep 2023)","date":"2023-09-19 00:00:00"},{"id":"5989c451-dfe0-430a-8257-bd4f4d152603","text":"Abbott/Similac powdered infant formula recalls and linked Cronobacter infections reported February 2022 (product recalls and infant illnesses/deaths).","date":"2022-02-17 00:00:00"},{"id":"fde9903f-3e01-4d9e-88b2-b36a0e29f568","text":"Conviction of neonatal nurse Lucy Letby for murdering and attempting to murder infants (trial verdict reported August 2023).","date":"2023-08-18 00:00:00"},{"id":"74d79c55-b2dd-48dd-92c8-b4f3e8b9c05a","text":"Reports in 2023 about a US clinician case involving allegations of destroying government COVID vaccine doses and administering saline (case reporting and later procedural developments in 2023).","date":"2023-04-24 00:00:00"},{"id":"12c64edc-5bb0-43cd-803b-893bccf7130c","text":"Local Marseille municipal councillor Gerald\u2011Hubert Fayard publicly associated himself with a planned DPR \'representation\' (reported in regional and Ukraine\u2011focused outlets).","date":"2017-06-24 00:00:00"},{"id":"ddb12108-4ee7-4b41-9f71-e5f2ce89bd21","text":"Thimerosal (ethylmercury) removal efforts and public controversy (ACIP/FDA actions beginning 1999; IOM review 2004)","date":"None"},{"id":"930d0ea6-3c45-418d-88d6-0511cd01d88e","text":"EMA guidance describes use of porcine trypsin (an enzyme) in manufacture of some vaccines","date":"None"},{"id":"3892ead7-6fb3-4fbb-9d2c-4f5ba492af26","text":"IARC classifies formaldehyde as carcinogenic to humans","date":"2004-06-24 00:00:00"},{"id":"971bef39-e25e-447b-8a04-28c6ac8f9b3a","text":"Immunization Safety Review and public concern over SV40 contamination of polio vaccine (1955\u20131963) and subsequent reviews","date":"None"},{"id":"5a46004d-e039-45ce-8424-3b5024c29c72","text":"CDC MMWR report: \'Delay or Avoidance of Medical Care Because of COVID\u201119\u2013Related Concerns \u2014 United States, June 2020\'","date":"2020-09-11 00:00:00"},{"id":"afe319fe-497d-4014-a28f-2ef0370ca5b1","text":"CMS guidance: \'CMS Releases Recommendations on Adult Elective Surgeries, Non\u2011Essential Medical, Surgical, and Dental Procedures\' (recommendation to postpone elective care)","date":"2020-03-18 00:00:00"},{"id":"ff78363e-86bf-44d1-80b4-366fb6fcd5a3","text":"European and Global Drought Observatories annual progress/ data release (JRC/EDO-GDO report covering 2021)","date":"2021-04-24 00:00:00"},{"id":"ac1c347b-0422-4190-a91e-f118e3304387","text":"Release of IPCC Sixth Assessment Report (AR6) Working Group II Summary for Policymakers","date":"2022-02-28 00:00:00"},{"id":"8e22e8ab-95be-4a04-a8e8-56168661ba94","text":"Ukrainian President Petro Poroshenko warned of \'hundreds of foreign tanks\' in Ukraine","date":"2014-08-30 00:00:00"},{"id":"7c82ab5c-af1e-4524-918a-44d55dc03f4b","text":"Large military parades and visible tank movements in neighbouring countries (e.g., Poland\'s Armed Forces Day parade showing tanks on public roads)","date":"2014-08-15 00:00:00"},{"id":"e5febf9d-f8b5-44f5-91f7-a1784dc87110","text":"Reports that Russian tanks and armoured columns had crossed from Russia into Ukraine","date":"2014-08-25 00:00:00"},{"id":"f9982ced-7bf9-4aee-9566-6707fe08a315","text":"Pentagon websites underwent a major content purge and reorganization earlier in 2025 (reported March 19, 2025), producing visible changes and confusion on DoD web properties","date":"2025-03-19 00:00:00"},{"id":"8e41cddf-c165-4805-86c2-74203f0c56af","text":"Japan suspended use/recall of some Moderna vaccine batches after reports of foreign particles (contamination) in vials","date":"2021-08-26 00:00:00"},{"id":"05801579-0283-4e6f-9252-e0ccd540942c","text":"FDA and CDC safety communications acknowledging rare myocarditis/pericarditis risk after mRNA COVID-19 vaccination","date":"2022-05-24 00:00:00"},{"id":"312815af-6e45-44c2-92d5-7498545d87c1","text":"Florida Department of Health issues guidance/analysis claiming an 84% increase in the relative incidence of cardiac-related death among males 18\u201339 within 28 days of mRNA vaccination","date":"2022-10-07 00:00:00"},{"id":"e4e75d3d-b6ca-4f6c-ae92-d8f6f3b8c92f","text":"Public criticisms and sparring by U.S. officials (including Vice President comments accusing Zelensky of being ungrateful) after the Oval Office exchange.","date":"2025-02-28 00:00:00"},{"id":"ff23b9e8-7e77-4ecc-bd42-56730cdc555c","text":"Human Rights Watch report \'Unguided Rockets Killing Civilians\' documented use of Grad (MLRS) rockets in Donetsk in July 2014.","date":"2014-07-24 00:00:00"},{"id":"9c5bc019-b51b-429a-a892-504dbad1e62a","text":"Simferopol base shooting \u2014 Ukrainian serviceman reportedly shot dead during Crimea takeover","date":"2014-03-18 00:00:00"},{"id":"ab2ad3a9-afec-43d7-ba87-b35694ddb345","text":"Euromaidan \'snipers\' massacre and government/official statements about \'shooting to kill\' (Kyiv)","date":"2014-02-20 00:00:00"},{"id":"370c7df3-223f-419c-81d1-734d1f0f1617","text":"Killing of nationalist figure Oleksandr \'Sashko Bilyi\' Muzychko during police operation (Rivne)","date":"2014-03-26 00:00:00"},{"id":"e5aaa05a-c658-49d0-9c32-d5ee0631d853","text":"Acting Interior Minister Avakov implicates members of elite police units in Maidan shootings","date":"2014-04-01 00:00:00"},{"id":"d9eafee5-2dab-4b8c-8840-234fecaf5047","text":"Battle of Ilovaisk and the lethal \'green corridor\' ambush during Ukrainian retreat","date":"2014-08-29 00:00:00"},{"id":"30b3ee18-387c-41b6-8f4c-a6b8e2b1a1fb","text":"2020 research coverage: injectable hydrogels proposed as sustained\u2011release vaccine delivery platforms","date":"2020-09-16 00:00:00"},{"id":"0f9b8ca1-b9e6-456e-b2cd-23b2bbda9fae","text":"2019 review article: \'Hydrogel bioelectronics\' (conductive/ionically conductive hydrogels for interfacing biology and electronics)","date":"2019-09-24 00:00:00"},{"id":"cd0a2e04-a1f5-4dd0-b90f-1e9dc59bf122","text":"Licensure and use of squalene-containing adjuvant MF59 in licensed influenza vaccines (first licensed in Italy)","date":"1997-04-24 00:00:00"},{"id":"e5f55024-d61f-4b4c-9bd6-c3bc739ba47d","text":"US Congressional hearings and report scrutinizing the Department of Defense Anthrax Vaccine Immunization Program","date":"1999-09-30 00:00:00"},{"id":"0fd0ca94-0033-4c14-8ca8-780602fd419e","text":"Publication and media coverage of research finding antibodies to squalene in Gulf War veterans","date":"2000-04-15 00:00:00"},{"id":"c7011f87-dfe4-405c-b47d-314e80fe1c8e","text":"1990s allegations that tetanus vaccination campaigns (Philippines, Mexico, Nicaragua) involved conjugation with hCG causing sterilization","date":"None"},{"id":"cb952111-bc62-4180-901e-11bb11e441e0","text":"Wuhan city lockdown and rapid travel restrictions were imposed as cases spread (city lockdown announced 23 January 2020) amid reports of limited early transparency","date":"2020-01-23 00:00:00"},{"id":"9dbdef61-bce6-476e-a310-53f87bb39f66","text":"U.S. State Department fact sheet and public reporting describing activities and international collaborations at the Wuhan Institute of Virology","date":"2018-01-15 00:00:00"},{"id":"81c07683-95ea-46f6-90e9-fdc32370f511","text":"Published, peer\u2011reviewed and public research showing Wuhan scientists (including Shi Zhengli) studying SARS\u2011like bat coronaviruses and collecting bat samples","date":"2017-04-24 00:00:00"},{"id":"e8f4d764-94e2-4c4a-b2b9-5356bdd53802","text":"Ukrainian parliament voted to remove Yanukovych (328-0)","date":"2014-02-22 00:00:00"},{"id":"2bb42626-d925-4aff-a4e7-1c28444704c5","text":"U.S. FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine on March 28, 2020.","date":"2020-03-28 00:00:00"},{"id":"ffd9187e-8061-4751-8bd5-480198de9d08","text":"Publication of an early open\u2011label, non\u2011randomized trial from Marseille (Gautret et al.) reporting viral clearance with hydroxychloroquine \xb1 azithromycin.","date":"2020-03-20 00:00:00"},{"id":"0cf24c17-1136-4554-8780-9a4ab07761a4","text":"Reporting from liberated towns (e.g., Trostianets) documenting looting and pillage by occupying Russian forces, published in major outlets in early April 2022.","date":"2022-04-05 00:00:00"},{"id":"6fc52d41-dc73-4780-b40d-2bc668e88f4a","text":"Scandinavian booster policy narrowing in 2022 (Denmark recommended boosters primarily for those 50+; Norway targeted boosters to older/risk groups)","date":"2022-09-24 00:00:00"},{"id":"3e978252-371b-41d2-8241-2e77a77b7ccd","text":"NEJM analysis using Israeli Ministry of Health data showing protection and waning patterns of natural, vaccine-induced and hybrid immunity","date":"2021-09-24 00:00:00"},{"id":"5ea46f6e-52b9-48b1-924d-c42581ba2e4f","text":"Publication of a quantified-method study suggesting tongue deviation angle >3.2\xb0 may predict stroke (Biomed Eng Online).","date":"2012-08-21 00:00:00"},{"id":"4f58034e-b5aa-4e77-a186-703865813663","text":"Public Health England / NHS Act FAST stroke public awareness campaigns emphasising Face, Arms, Speech, Time (FAST) without mentioning tongue.","date":"2015-02-02 00:00:00"},{"id":"1b09beb4-96ed-4fb4-b461-3ad2dc8ee74c","text":"UKHSA (UK Health Security Agency) vaccine surveillance reports documenting low or rapidly waning effectiveness against Omicron infection at some timepoints in 2022","date":"2022-01-28 00:00:00"},{"id":"b2363639-5d44-418d-9673-4c7e709d3369","text":"U.S. Energy Information Administration (EIA) published accessible guidance and emissions-coefficient data explaining that burning natural gas produces less CO2 per unit of energy than burning coal.","date":"2024-07-10 00:00:00"},{"id":"f0ef8168-b5db-4007-9161-282e7132d6ef","text":"European Commission proposal and subsequent approval to allow some natural gas projects to be labelled as \'transitional\' / investable under the EU Taxonomy, followed by high-profile legal challenges and media coverage.","date":"2023-04-17 00:00:00"},{"id":"0339315d-50ab-4e68-b9ac-4892ae9ff23b","text":"Clean Creatives published its F\u2011List 2024 report documenting over 1,000 recent advertising and PR contracts between major agencies and fossil fuel companies (including gas companies).","date":"2024-09-24 00:00:00"},{"id":"20530a04-956c-471e-a28a-f5f92470b5f8","text":"ClientEarth and partners announced they were joining legal action against Washington Gas over customer-facing marketing that described gas as \'clean\' and \'sustainable\'.","date":"2022-08-04 00:00:00"},{"id":"51a4924c-6fd8-4a57-81f7-141044a51459","text":"OSCE convoy came under fire near Mariinka (monitors shot at while travelling between Ukrainian checkpoints)","date":"2014-11-19 00:00:00"},{"id":"9c4c19b1-1821-4f4f-b004-963fa07a0f1c","text":"OSCE observers blocked from full access to the MH17 crash site by armed pro\u2011Russian fighters","date":"2014-07-18 00:00:00"},{"id":"30306750-7682-4b1c-9f3e-c1f7f931fb12","text":"OSCE national staff detained by separatist forces in eastern Ukraine (several detained in April 2014)","date":"2014-04-25 00:00:00"},{"id":"bf60c867-f02b-4e06-b2c1-b53995c2ccd9","text":"Four OSCE armoured vehicles torched in Donetsk (apparent arson)","date":"2014-08-09 00:00:00"},{"id":"853ec022-2633-424e-8070-53f10b976cd3","text":"U.S. Department of Defense announced $250 million in additional security assistance for Ukraine","date":"2019-06-18 00:00:00"},{"id":"663f388b-8d33-4499-af44-cd69c04ac64f","text":"Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained sailors","date":"2018-11-25 00:00:00"},{"id":"acdb7680-494f-4145-a91e-cd4d9b5e56d1","text":"United States confirmed delivery of Javelin anti-tank missile systems to Ukraine","date":"2018-04-30 00:00:00"},{"id":"d584c3ea-5cb9-45d8-8efd-c3e473f0ccca","text":"Sea Breeze 2019 multinational naval exercise (co-hosted by the US and Ukraine) concluded in Odesa","date":"2019-07-12 00:00:00"},{"id":"16ca3990-e457-4039-8559-8ecff8153cd8","text":"USS Ross (Arleigh Burke-class destroyer) entered the Black Sea (routine US Navy presence) in April 2019","date":"2019-04-15 00:00:00"},{"id":"3558e28f-0f72-48b9-8286-981151d2baa1","text":"Official counts and reporting on refugees arriving in France showed large aggregate flow (roughly 30,000 reported late March 2022) but initial public summaries lacked detailed nationality/ethnicity breakdowns","date":"2022-03-27 00:00:00"},{"id":"22e6e242-2014-4f49-b17e-405825cad96f","text":"Reports and media on opening Arctic sea routes and economic opportunities from reduced sea ice (UK Foresight/academic analyses, mid-2010s)","date":"2016-04-24 00:00:00"},{"id":"63ad495e-5acf-452f-8a88-e7061b051a88","text":"UNDP published \'Enhancing Mine Action Finance in Ukraine\' (feasibility study) highlighting very large costs for demining and explosive ordnance disposal (EOD) in Ukraine","date":"2024-10-15 00:00:00"},{"id":"79deae72-5646-4192-a308-236ab1bef5fc","text":"U.S. Government Accountability Office (GAO) report \'Ukraine: Status and Challenges of DOD Weapon Replacement Efforts\' documented replacement costs and tracking challenges for U.S. weapons provided to Ukraine","date":"2024-04-30 00:00:00"},{"id":"0305a8d5-e7b2-4fdd-bcd7-b0f71ec3ae48","text":"World Bank released an updated Ukraine recovery and reconstruction needs assessment estimating hundreds of billions in reconstruction costs and prompting public debate over who will pay","date":"2025-02-25 00:00:00"},{"id":"b7315bb3-0703-4c94-a09b-a1e2db430679","text":"Large influx of Ukrainian refugees into Italy by mid\u20112022 (UNHCR reporting tens of thousands in June 2022).","date":"2022-06-24 00:00:00"},{"id":"61b2cd92-abf7-4dcf-bc51-7644c0a54e5f","text":"Extinction Rebellion activists blocked Rome\u2019s Grande Raccordo Anulare, leading to drivers physically removing protesters.","date":"2022-06-14 00:00:00"},{"id":"e12ee799-3d50-4af8-a791-1c4bb686de2b","text":"Rospotrebnadzor and Russian authorities banned imports of Ukrainian confectionery (including Roshen) and imposed trade restrictions in 2013\u20132014.","date":"2014-09-05 00:00:00"},{"id":"d06a4c29-bb90-487d-98ff-88029fa06e0e","text":"April 2015: Russian authorities seized or froze assets related to the Lipetsk Roshen factory and reported legal/administrative actions against the plant.","date":"2015-04-24 00:00:00"},{"id":"66ccfe61-ae20-4550-b79d-81b156c8a6cb","text":"Fatal shooting of conservative activist Charlie Kirk at Utah Valley University","date":"2025-09-10 00:00:00"},{"id":"8bb1e2ba-a0bb-40a4-940b-848d74f29241","text":"Publication of Kausar H. et al., \'Cucurbitacin B potently suppresses non-small-cell lung cancer growth\' (Cancer Letters)","date":"None"},{"id":"85e3bb14-8ba3-4be5-bd50-f38e37acef59","text":"Pre-war and tourist-focused references showing some Ukrainian cemeteries charge small admission or camera fees (example: Lychakiv Cemetery visitor fees noted in travel guides/reviews in 2019)","date":"None"},{"id":"ed0cb860-80c7-4566-a16a-1b0c0d31aa0b","text":"Drohobych municipal regulation (pre-2022) introducing paid vehicle access for cemetery maintenance, cited by local officials when responding to the viral clip","date":"None"},{"id":"4813077d-e615-4b27-9b5b-b355712216fd","text":"WHO issues \'Tetanus vaccines: WHO position paper\' summarising tetanus epidemiology and prevention","date":"2017-02-10 00:00:00"},{"id":"e12a081c-41ee-4ea4-9677-a64baf83b41b","text":"Peer\u2011reviewed medical review \'Tetanus\' (Farrar et al.) describes Clostridium tetani as an obligate anaerobic, spore\u2011forming bacterium and details anaerobic germination in wounds","date":"2000-09-01 00:00:00"},{"id":"d76b65d4-41fc-4c3f-9acb-79c698179c29","text":"The Tesla Science Center crowdfunded and purchased the Wardenclyffe lab site to create a museum and drew renewed attention to Tesla\'s archival material.","date":"2013-04-24 00:00:00"},{"id":"ca1e6bab-694c-481b-842c-66218837103e","text":"News reporting that the historic Wardenclyffe site was damaged/at risk after a major fire and related incidents.","date":"2023-11-24 00:00:00"},{"id":"44dab769-9a0b-477d-9ec2-b8feea0fb346","text":"U.S. Vaccine Court (Omnibus Autism Proceedings) issued final test-case rulings (March 10, 2010) finding insufficient evidence that vaccines cause autism","date":"2010-03-10 00:00:00"},{"id":"e3c62d58-3418-453a-b65c-853a482b6baf","text":"U.S. CDC and FDA temporarily pause and later resume use of the Johnson & Johnson COVID\u201119 vaccine over rare blood clot reports","date":"2021-04-24 00:00:00"},{"id":"01616dfd-fc22-45d1-9fcd-1b2ad598a500","text":"Public health agencies report rare myocarditis cases after mRNA COVID\u201119 vaccination and discuss benefits vs. risks","date":"2021-06-23 00:00:00"},{"id":"ba9d833c-6b5f-4977-907a-cd46f755300e","text":"Russian Defence Ministry repeatedly publicly stated it was striking Ukraine\u2019s \u201Cmilitary\u2011industrial complex\u201D and energy infrastructure (examples across 2022\u20132024 reporting by major outlets).","date":"2022-12-17 00:00:00"},{"id":"f89e6ea3-65e3-4ff1-ba9b-2d25e57b0933","text":"Multiple Russian missile and aerial strikes on Chernihiv during March 2022, causing civilian casualties and damage across the city.","date":"2022-03-24 00:00:00"},{"id":"2b26efa6-583b-41fc-88f0-91b856a9b861","text":"European Broadcasting Union (EBU) announces Kyiv as host city for Eurovision 2017","date":"2016-09-09 00:00:00"},{"id":"f0db666b-0fd3-4f77-b06f-89c030b25d5c","text":"Jamala (Ukraine) wins the Eurovision Song Contest with the song \'1944\'","date":"2016-05-14 00:00:00"},{"id":"5e8d37c6-8703-44ad-b67d-f727f80c34d8","text":"Ukraine publicly sought large anthracite imports (including from South Africa) amid shortages in late 2015","date":"2015-11-24 00:00:00"},{"id":"6e4c5301-e3c3-4f6b-909d-23ea2b1309ac","text":"Sharp drop in Ukrainian coal production after Donbas fighting in 2014","date":"2014-04-24 00:00:00"},{"id":"48a764fe-1d3f-4265-b2da-69a49b1d5369","text":"Closure, flooding and damage to many Donbas mines after occupation in 2014","date":"2014-04-24 00:00:00"},{"id":"2c23f5f5-1fe8-4718-a592-39593387b290","text":"Publication of the NEURO-COVAX study in Vaccines (MDPI) reporting 31.2% of participants self-reported at least one neurological symptom after COVID-19 vaccination.","date":"2023-10-21 00:00:00"},{"id":"d4643a72-fa01-41a9-9cbf-99356de06c6b","text":"Study design and limitations (self\u2011reported questionnaire, single\u2011center sampling, no unvaccinated comparator, and no hospitalizations/deaths recorded) were present in the paper but largely omitted in shareable summaries.","date":"2023-10-21 00:00:00"},{"id":"a8863203-2f29-4df9-ae56-f28b95478ed0","text":"KIIS telephone poll (May 13\u201318, 2022) reporting very high levels of negative attitudes toward Russia (e.g., ~82% negative among people in occupied areas)","date":"2022-05-13 00:00:00"},{"id":"165d15d9-4ec9-4579-9519-a7e05f6304ee","text":"Russian forces seized/controlled substantial parts of Kharkiv oblast in the initial invasion (late Feb\u2013early March 2022), including border towns and districts","date":"2022-03-24 00:00:00"},{"id":"3c719cdb-5047-46b4-a1d7-f8e44a60535b","text":"State-level policy changes removing mask mandates (example: Texas lifting its statewide mask mandate and reopening, March 2, 2021)","date":"2021-03-02 00:00:00"},{"id":"c7afcae4-708e-49d8-8fd0-4dca5da09912","text":"CDC guidance updating mask recommendations for fully vaccinated people (May 13, 2021)","date":"2021-05-13 00:00:00"},{"id":"0dbce223-9c3e-4379-a0d6-719aff826410","text":"Turkish President Recep Tayyip Erdogan offered financial assistance to Ukraine and publicly urged protection for Crimean Tatars, reiterating Ankara\'s support for the Tatar community.","date":"2016-10-07 00:00:00"},{"id":"ed8db066-3572-46a8-98ff-01ad76662339","text":"Turkey launched Operation Euphrates Shield and backed Syrian rebel groups in northern Syria (including 2016 operations such as the capture of Jarablus).","date":"2016-08-24 00:00:00"},{"id":"cd24668d-5a2d-4d25-9e4f-161f11611d13","text":"Repeated international reports and accusations that Turkey had allowed foreign fighters to cross its border into Syria during the civil war.","date":"2014-03-31 00:00:00"},{"id":"5986747e-02d6-4ce7-aab0-db589195fba5","text":"Crimean Tatar World Congress held in Ankara where leaders and diaspora groups met and called for international support against Russia\'s annexation.","date":"2015-08-24 00:00:00"},{"id":"3295240f-72b7-4247-9609-5e8312beadf4","text":"U.S. and Western sanctions were imposed on the Night Wolves and their leader (December 2014), marking the group as pro\u2011Kremlin and controversial in Western diplomatic reporting.","date":"2014-12-24 00:00:00"},{"id":"3698a301-7a64-46ef-9f95-c34dc5ed8181","text":"Earlier influential scientific framing of an Amazon \'tipping point\' (Lovejoy & Nobre / Science Advances) estimating thresholds (often cited ~40% deforestation) for large\u2011scale dieback to savanna.","date":"2018-02-24 00:00:00"},{"id":"18f82ef6-d088-4ea4-a1d8-2c2e76ae3a8c","text":"UN experts warn of chemical disaster and water\u2011safety risks after shelling near installations containing chlorine and other chemicals in Donetsk region","date":"2017-11-10 00:00:00"},{"id":"1f2bc923-735d-43cb-b434-90a5ade6316e","text":"OSCE thematic report: \'Access to water in conflict\u2011affected areas of Donetsk and Luhansk\'","date":"2015-09-24 00:00:00"},{"id":"129c65e8-0dfc-4fe2-92cd-7ba8bdd6b0ca","text":"ICRC: \'More than 350,000 people face acute water shortage in eastern Ukraine\' after damage to pumping stations and staff unable to remain on duty","date":"2017-06-24 00:00:00"},{"id":"4a1100bd-0d21-4a8e-a3be-dc65ae4acb3d","text":"Power supplies to a Donetsk filtration plant hit by shelling, leaving large areas without water","date":"2014-11-19 00:00:00"},{"id":"0213cd1b-8b7d-4c86-810f-98a80cf0764f","text":"Adoption and public debate around Ukraine\'s 2019 language law (\'On Ensuring the Functioning of Ukrainian as the State Language\').","date":"2019-04-25 00:00:00"},{"id":"c5b2e942-0a09-4814-b808-5dcefeb3d5ee","text":"Post\u2011invasion \'derussification\' measures and rapid renaming/removal of Russian/Soviet toponyms and monuments across Ukraine in 2022.","date":"2022-04-27 00:00:00"},{"id":"a87bdeee-b360-4bb2-8cc6-3965afae1f9f","text":"U.S. Department of the Treasury designates the \'Donetsk People\'s Republic\' and \'Luhansk People\'s Republic\' in an expanded Ukraine-related sanctions package","date":"2014-07-16 00:00:00"},{"id":"370b35db-401a-4dde-b9d8-be033b45ead1","text":"EU/European institutions tie sanctions policy to implementation of the Minsk agreements (2015) and list the so-called DPR/LPR in sanctions contexts","date":"2015-03-24 00:00:00"},{"id":"70d39cc1-17a3-4c78-868b-524525fee81f","text":"U.S. Executive Orders and related sanctions authorities (E.O. 13660 / 13661 / 13662) invoked in 2014 to address actors \'asserting governmental authority\' in parts of Ukraine","date":"2014-03-06 00:00:00"},{"id":"2ae1a6a2-00dc-4716-8f58-ba4af4a22dfb","text":"Pro-Russian separatist authorities in Donetsk proclaim the \'Donetsk People\'s Republic\' after seizing regional buildings (widely reported)","date":"2014-04-07 00:00:00"},{"id":"e19cdc91-b26c-4c06-af84-6bc813283f6f","text":"Minsk II agreement (Feb 12, 2015) signed after talks in which leaders of the self-proclaimed Donetsk and Luhansk entities were included as signatories","date":"2015-02-12 00:00:00"},{"id":"15c88d5d-4214-4f6a-8e3e-981cf10164b3","text":"Japan found stainless\u2011steel/foreign particles in multiple Moderna COVID\u201119 vaccine vials and recalled batches (high\u2011profile contamination incident).","date":"2021-09-01 00:00:00"},{"id":"ff62d27d-55b2-45bd-a9ac-aaa477b9caab","text":"Danish population\u2011based study reporting increased incidence of myopericarditis after Pfizer mRNA vaccination in adolescents.","date":"2022-01-24 00:00:00"},{"id":"4eab83b6-6e27-46f1-bdc6-5cbc5609e5ef","text":"Publication of \'Batch-dependent safety of the BNT162b2 mRNA COVID-19 vaccine\' (Denmark) reporting heterogeneous rates of suspected adverse events between Pfizer vaccine batches.","date":"2023-03-30 00:00:00"},{"id":"dc1984b6-3a67-4928-bd53-8112534f27f8","text":"U.S. court orders and publicized releases/requests for large numbers of FDA documents related to the Pfizer\u2011BioNTech vaccine.","date":"2022-01-07 00:00:00"},{"id":"221a865f-71a5-4c68-80f7-d7234ebe441b","text":"Peer\u2011reviewed drug\u2011delivery studies (e.g., polysorbate 80\u2011coated PLGA nanoparticles, PubMed ID 26407669) demonstrating that polysorbate 80 can increase blood\u2011brain barrier permeability in experimental formulations.","date":"2016-04-24 00:00:00"},{"id":"8a7d0894-415e-4f16-b859-8f67461bc8e4","text":"ASHP drug\u2011shortage / product detail page for Vitamin K notes Amphastar formulation contains polysorbate 80 and propylene glycol (clinical pharmacy resource).","date":"2018-04-24 00:00:00"},{"id":"edc2d296-1347-4472-9cd6-ee8b4ce94306","text":"American College of Pediatricians (ACPeds) statement (Jan 2016) flagged concerns about HPV vaccine and possible premature ovarian failure (POF)\u2014invoked by some groups to link polysorbate 80 and infertility.","date":"2016-01-24 00:00:00"},{"id":"f1781c7e-8053-4b57-a9c9-d07754f1449a","text":"Kyiv suspended routine pension and social payments to residents in non-government-controlled parts of Donetsk and Luhansk in late 2014, requiring IDP registration and in-person collection in government-controlled areas.","date":"2014-12-24 00:00:00"},{"id":"c470d7a4-b30f-4401-9705-0d43de6cab4e","text":"Ukraine passed major pension-reform legislation in 2017 amid warnings from the IMF and World Bank about fiscal sustainability and pension costs.","date":"2017-10-24 00:00:00"},{"id":"58eaeb8a-7e9a-4fc8-bd33-f98733127de0","text":"Ukraine\u2019s 2015 fiscal crisis and international bailout needs (IMF programs 2014\u20132015) created repeated reporting of severe budgetary pressure on Kyiv.","date":"2015-04-24 00:00:00"},{"id":"c1435856-a581-4c7f-b78c-d5da6430d59d","text":"After Russia\u2019s 2014 annexation of Crimea, Moscow moved to apply Russian pension law and budget subsidies to Crimea and began assuming responsibility for pension payments there.","date":"2014-07-24 00:00:00"},{"id":"7336bdd4-dcd5-495e-b819-17b1b8611550","text":"Visible US troop rotations and equipment deliveries to Poland (arrival of US armor and rotational forces)","date":"2017-01-12 00:00:00"},{"id":"bff091f3-e410-47a5-a7df-00cebb8fc2ed","text":"NATO Communications and Information Agency exercise \'RAMSTEIN DUST\u2011II\' testing deployable NATO air/communications connectivity (DACCC) capabilities","date":"None"},{"id":"11630551-a0e1-4832-850e-eb02c61c8bfc","text":"NATO defence ministers approve creation of the Joint Support and Enabling Command (JSEC) in Ulm, Germany","date":"2018-06-07 00:00:00"},{"id":"19fe6b07-9b6f-4e03-90dc-0d843bac14f6","text":"Public descriptions of Ramstein Air Base as a key US/NATO European hub (US EUCOM reporting and public pages describing Ramstein\'s C4ISR/logistics role)","date":"2017-10-17 00:00:00"},{"id":"3af86b28-8804-49b8-af9b-699fbba4dc69","text":"Peer-reviewed reviews and renewed clinical-trial activity on high\u2011dose intravenous vitamin C in cancer (major review published 2022)","date":"2022-04-24 00:00:00"},{"id":"053e8850-c3b4-4cf3-8c98-02c7211e2065","text":"NCI PDQ summary on Curcumin (turmeric) and cancer published \u2014 evidence reviewed but clinical benefit unproven","date":"2021-02-22 00:00:00"},{"id":"8378826f-6566-4850-b9ab-4aa8483aa62b","text":"Systematic reviews and clinical reports on ketogenic diets and cancer published (e.g., systematic review assessing evidence published 2021)","date":"2021-04-24 00:00:00"},{"id":"88546c51-205a-44c2-ba5a-e49e1affa8c9","text":"Public communications and study data showing waning antibody protection over months and consequent official booster recommendations (e.g., booster guidance issued September 2021)","date":"2021-09-24 00:00:00"},{"id":"97e0bbc0-1c97-4c2a-a768-23b1c5b6499d","text":"Large Israeli nationwide study published on vaccine safety that reported an increased risk of myocarditis after BNT162b2 (Pfizer) vaccination but characterized the events as rare","date":"2021-05-05 00:00:00"},{"id":"e908c0ca-d2a7-4260-ab1e-04cdfa8e34cf","text":"Regulatory vaccine trial and EUA briefing documents (Pfizer/BioNTech FDA briefing) that reported transient laboratory changes including short\u2011lived lymphocyte count decreases in some participants","date":"2020-12-10 00:00:00"},{"id":"8dbf0918-8f32-4fab-b4f2-d214db9bbec0","text":"NOAA/observational reports noting rapid SST changes in the equatorial Atlantic in 2024 (reported by news agencies)","date":"None"},{"id":"4599ab63-54f7-4a04-8f42-57009a6ae00d","text":"UNICEF situational reporting on widespread attacks and disruptions to water and sanitation in eastern Ukraine (June 2018 SitRep)","date":"2018-06-24 00:00:00"},{"id":"0ab3b765-e365-4034-93ce-2f660110ff93","text":"HotSpots H2O briefing: continued shelling damaging water infrastructure despite ceasefires (Circle of Blue, July 30, 2018)","date":"2018-07-30 00:00:00"},{"id":"bb69b414-1983-45be-910f-c2835efe19b9","text":"Severe thunderstorms and heavy rains cause flooding and high river levels (KyivPost, June 28, 2018)","date":"2018-06-28 00:00:00"},{"id":"856f5595-5f44-4c10-b3c7-71b79aeaf5c7","text":"Donetsk Filtration Station shelled and operations halted, disrupting water supply","date":"2018-05-18 00:00:00"},{"id":"1404893a-c0b2-4814-ab64-359e2c36b158","text":"Joint War Committee (insurers) placed Ukrainian and Russian waters in the Black Sea and Sea of Azov on its high\u2011risk/war-listed areas (amendment effective 15 February 2022)","date":"2022-02-15 00:00:00"},{"id":"2086e587-ce6e-4e06-9839-97ca25e372ba","text":"Shipping industry appeals for safe passage for hundreds of merchant vessels and seafarers stranded in Ukrainian ports","date":"2022-03-10 00:00:00"},{"id":"78d710de-a906-4132-bb3a-d2c714abfdcb","text":"Russian Black Sea flagship Moskva damaged and later sank after reported Ukrainian Neptune anti-ship missile strike","date":"2022-04-14 00:00:00"},{"id":"794f77f6-b8b0-4788-a6d2-c21ef39b677f","text":"UN OCHA warning of high risk of communicable\u2011disease outbreaks among internally displaced persons in Donbas (electricity/water outages, damaged health infrastructure)","date":"2014-08-24 00:00:00"},{"id":"48de5f88-6848-4e7f-b7fe-44f843b58155","text":"WHO Global Tuberculosis Report (2016) and other analyses showing Ukraine\u2019s high burden of tuberculosis and multidrug\u2011resistant TB","date":"2016-04-24 00:00:00"},{"id":"15006e59-2ab6-4689-b249-9373536c9841","text":"Circulating vaccine\u2011derived poliovirus outbreak confirmed in Ukraine (two paralytic cases)","date":"2015-09-24 00:00:00"},{"id":"183646ae-2ec7-4672-b2e4-ba7db495d1a4","text":"Nationwide tractor convoys and roadblocks as French farmers marched on Paris in late January 2024","date":"2024-01-28 00:00:00"},{"id":"4d8bff75-79ca-4497-8094-ddebeee2b85d","text":"Farmers dumped manure and rotting produce in city centres during protests (reported in Toulouse)","date":"2024-01-24 00:00:00"},{"id":"de34351e-1dc0-47f4-b575-148dbdb62792","text":"Russian Defence Ministry and Kremlin officials call Bucha scenes \\"staged provocation\\"","date":"2022-04-03 00:00:00"},{"id":"8b4802a2-bf7e-4268-ba24-00b763e64ab1","text":"Public statements and media coverage discussing possible measures against draft dodgers, including asset/account seizure among proposed penalties","date":"2024-02-24 00:00:00"},{"id":"6491f48d-4baf-45b9-82b2-7251833f7208","text":"Public disinfection operations reported and photographed in Ukrainian cities (street/transport spraying, workers in hazmat suits)","date":"2020-03-13 00:00:00"},{"id":"9d9ce06a-8386-47b7-ae5d-017a2e744ce0","text":"Ukrainian government declares nationwide quarantine (Resolution No. 211)","date":"2020-03-11 00:00:00"},{"id":"12c09e06-1f61-42e8-9e16-e01afda25148","text":"FAO follow-up report \'Tackling climate change through livestock: A global assessment\' (FAO)","date":"2013-09-24 00:00:00"},{"id":"1be9d181-cdca-4b5c-9997-fba2dfa838b6","text":"Takeda and Moderna published an investigation report (Oct 1, 2021) into the Japan incident, concluding the particles were 316L stainless steel and describing manufacturing root causes and corrective actions.","date":"2021-10-01 00:00:00"},{"id":"8259ef14-361b-47dc-a04e-4a24e1594092","text":"WHO reported a multi-country monkeypox outbreak in non-endemic countries","date":"2022-05-21 00:00:00"},{"id":"1e35f35f-ebd5-4ba3-8a18-976b164195a8","text":"U.S. president ordered review of COVID origins amid publicized, divided intelligence assessments (fuelling lab-leak narratives)","date":"2021-05-26 00:00:00"},{"id":"71c8491e-9487-4a05-927c-953d05c4279a","text":"Ukrainian authorities built a temporary flow-control dam near Kalanchak in 2014 to restrict canal water into Crimea","date":"None"},{"id":"47fe2c82-b778-47ae-a05a-e4741259bb31","text":"Reports of chronic water shortages, rationing and Russian attempts to substitute supplies (desalination, reservoirs, pipelines) in Crimea","date":"2017-01-04 00:00:00"},{"id":"1facc140-18cb-4bee-9e5c-073a9b6e2dc3","text":"Reports of clergy splits and competing loyalties in Crimea and eastern Ukraine as Russian forces moved in (priests aligning with Russian-backed authorities)","date":"2014-04-01 00:00:00"},{"id":"9d6a225c-723a-4f8a-a9a9-d31582f4cdec","text":"Reports of numerous attacks, seizures or conflicts around Orthodox church buildings and clergy amid 2014 unrest","date":"2014-08-01 00:00:00"},{"id":"44c83632-d3ba-44b3-8e8f-558ea7383cb3","text":"Mejlis of the Crimean Tatar People called for a boycott of the March 2014 referendum","date":"2014-03-24 00:00:00"},{"id":"eb9276c3-6b9a-45cb-bd9d-ce6001fe6860","text":"Russian leadership publicly framed the referendum and subsequent annexation as a legitimate territorial decision (Putin\u2019s statements/speech coverage mid\u2011March 2014)","date":"2014-03-18 00:00:00"},{"id":"ebe85d02-d260-458d-9fd8-a2eb30d8a874","text":"Armed seizure of the Crimean parliament and buildings by unmarked pro\u2011Russian forces","date":"2014-02-27 00:00:00"},{"id":"d65b82b8-3af6-47a7-b42d-b49325b3e69b","text":"Court battles and FOIA demands (PHMPT lawsuit) over release of Pfizer documents, and initial FDA proposals to release documents over decades (the 75\u2011year timeline headline), stoked distrust and narratives that regulators lacked underlying safety/effectiveness data.","date":"2022-01-07 00:00:00"},{"id":"b2aadc38-7271-443b-98b6-00461b5d6cf8","text":"Local activists attempted to topple the Felix Dzerzhinsky monument in Zaporizhzhia but failed (public attempt and clashes reported).","date":"2014-11-07 00:00:00"},{"id":"45de970a-321c-43c0-a66e-dfefc8535b91","text":"City unveiled a sculptural composition (\u2018The Steelworker and the Teacher\u2019) \u2014 a bench-like monument to the characters of the film \'Vesna na Zarechnoy Ulitse\' \u2014 on Shevchenko Boulevard in Zaporizhzhia.","date":"2014-10-11 00:00:00"},{"id":"9bc2ab0f-ee95-4230-bd19-8f3d5b1383d7","text":"Wider wave of removals/topplings of Soviet-era monuments across Ukraine in 2014 (including highly publicized removals of Lenin statues earlier that year).","date":"2014-03-17 00:00:00"},{"id":"cc83063d-de60-4c37-af8f-2a928fc78fc1","text":"Local media and classifieds flagged massive accommodation and flight price spikes in Kyiv ahead of the final (rooms and short-term rentals listed at many times their usual rates).","date":"2018-05-05 00:00:00"},{"id":"854f3543-551f-4acd-a626-75d1a0990083","text":"Press report that more than 2,000 Real Madrid supporters returned tickets citing logistics and \'sky\u2011rocketing expenses\' related to attending the Kyiv final.","date":"2018-05-22 00:00:00"},{"id":"952612b4-1f77-44c3-a040-369786992f85","text":"Polish police statistics and reporting showing a rise in thefts in 2022 (reported Jan 20, 2023)","date":"2023-01-20 00:00:00"},{"id":"f6b25295-4987-4865-950e-7ad582da48d9","text":"Europol-coordinated EU-wide action leading to the arrest of around 130 suspected human traffickers (operation announced June/July 2022)","date":"2022-06-24 00:00:00"},{"id":"8731915f-2d7c-4772-a3fb-2041138609ad","text":"Mass exodus of civilians from Ukraine into neighbouring EU states after Russia\'s full-scale invasion (millions crossed borders beginning 24 Feb 2022)","date":"2022-02-24 00:00:00"},{"id":"11a7e18f-5da2-4c8f-bce2-78c9d221faef","text":"Media coverage and local backlash in Poland documenting xenophobia and the spread of anti-refugee narratives, including claims that Ukrainian refugees are responsible for crime (BBC report)","date":"2023-03-24 00:00:00"},{"id":"f533e2d1-5daf-4df0-98dd-6062d957663a","text":"Large measles outbreak linked to a theme-park (Disneyland) that spread across multiple states (December 2014\u2013February 2015)","date":"None"},{"id":"40b8c52d-0e05-47b8-92c4-7a51a2673401","text":"PNAS study showing acellular pertussis vaccines protect against disease but may fail to prevent infection and transmission in a nonhuman primate model (often cited 2014)","date":"2014-04-24 00:00:00"},{"id":"f2c53340-b5d5-447f-bfe1-81a987945b9f","text":"Independent assessments of donor assistance (2018) noting limited impact of some programmes","date":"2018-04-24 00:00:00"},{"id":"5bb3b610-aa82-4d4b-aee8-97d997396356","text":"Lithuania presents a high\u2011profile \'Marshall Plan for Ukraine\' proposal","date":"2017-11-06 00:00:00"},{"id":"3311beac-ea56-47c7-b107-e24ced9d6551","text":"European Court of Auditors special report: \'EU assistance to Ukraine\' finds results \'fragile\'","date":"2016-12-08 00:00:00"},{"id":"a7e5dcd6-f5cf-4787-8fcf-0e5969168051","text":"U.S. President ordered the U.S. intelligence community to further investigate the origins of COVID\u201119 and report findings (public announcement of an intelligence review)","date":"2021-05-26 00:00:00"},{"id":"9dacf18f-a0da-40e1-83fd-d4819d3fab00","text":"Media reports (citing U.S. intelligence) that three Wuhan Institute of Virology researchers sought hospital care in November 2019","date":"2021-05-23 00:00:00"},{"id":"271d8e72-d2e0-4b2a-bab4-8aad1c915ad7","text":"WHO-convened Global Study of Origins of SARS\u2011CoV\u20112: China Part report released, offering assessments of possible origin hypotheses but noting limited access to raw data and calling for further study","date":"2021-03-30 00:00:00"},{"id":"55aefe89-aa6e-4c04-a7a5-a635b73bd5de","text":"European Union Advisory Mission (EUAM) begins operations in Kyiv to advise on civilian security-sector reform","date":"2014-12-01 00:00:00"},{"id":"68c9b6e8-dc09-4d64-a8d7-c197c95877c3","text":"Launch of new Kyiv patrol police (major public-facing police reform supported by international partners)","date":"2015-07-04 00:00:00"},{"id":"e22f7c32-c0cc-4765-b07e-35e06535254b","text":"U.S. announces a $200 million security assistance package for Ukraine (release reported July 20, 2018)","date":"2018-07-20 00:00:00"},{"id":"0ec1ded8-6576-460e-be9d-3b5b853d3b05","text":"Canada launches Operation UNIFIER \u2014 Canadian Armed Forces training mission for Ukrainian personnel","date":"2015-04-14 00:00:00"},{"id":"0a8a26f2-5737-41b6-a719-b9c2adf6ee46","text":"Peer\u2011reviewed review article (CMAJ) summarising mechanisms and multiple case reports showing grapefruit (furanocoumarins) can irreversibly inhibit intestinal CYP3A4 and cause dangerous increases in blood levels of many drugs (including some CNS agents).","date":"2013-03-05 00:00:00"},{"id":"9f6f6f31-0f13-4951-922f-005787192b55","text":"Case report published describing a presentation mimicking quetiapine (an antipsychotic) overdose linked to grapefruit juice consumption (\'Grapefruit Juice Cleanse Mimicking Quetiapine Overdose\', J Clin Psychopharmacol).","date":"2021-11-24 00:00:00"},{"id":"fa44083a-61f0-4701-bb91-19006e6597ec","text":"Existence and public use of the Mapuche (Wenufoye) flag in Chilean demonstrations","date":"None"},{"id":"629575ca-5c65-4ca0-b7ca-58a497854762","text":"Large Euromaidan demonstrations in Kyiv with widespread display of Ukrainian blue-and-yellow flags","date":"2014-02-24 00:00:00"},{"id":"565e4399-de52-4508-9fd7-76f912ef3d00","text":"IPCC Fifth Assessment Report (AR5) discussion of a temporary slowdown (\'hiatus\') in surface warming (1998\u20132012)","date":"2013-09-24 00:00:00"},{"id":"5c67b5b9-d347-4c83-80e2-b45b0d5ec9b3","text":"Publication and promotion of Lindzen & Choi\'s low climate\u2011sensitivity analysis (2011)","date":"2011-04-24 00:00:00"},{"id":"d44634d9-fe38-4821-82b8-1de3a6e41525","text":"IPCC Fifth Assessment Report (AR5) publication stating with high confidence that recent warming is caused by human activities","date":"2013-09-24 00:00:00"},{"id":"9685729a-b9db-4a49-a949-2afbb17fc9df","text":"WHO interim guidance on mask use early in the pandemic (initial cautious messaging)","date":"2020-03-19 00:00:00"},{"id":"b2c6dfe5-3e31-4b12-9fe6-1c1b13e8ba63","text":"CDC recommendation that the public wear cloth face coverings (press guidance)","date":"2020-04-03 00:00:00"},{"id":"8d9d41c6-da0f-401e-b936-f4807632bf31","text":"Russia launched one of the largest waves of missile and drone strikes across Ukraine on 29 December 2023, hitting cities and critical infrastructure","date":"2023-12-29 00:00:00"},{"id":"070deb89-5a21-450b-b8d1-72a1c7578939","text":"Estonian Defence Forces Intelligence Centre head Col. Ants Kiviselg gave a press briefing describing intensified Russian missile/drone waves, saturation tactics and damage to Ukrainian infrastructure (remarks later taken out of context)","date":"2024-01-12 00:00:00"},{"id":"f8d94d2b-829f-4f01-bfb7-58a292aee5a2","text":"Publication of Rasool & Schneider (Science) 1971 paper on aerosols and cooling","date":"1971-07-24 00:00:00"},{"id":"071dbeb4-43d3-46f7-8d0b-56456f15f2bb","text":"FTC warned hundreds of marketers (April 2023) about potential civil penalties for unsubstantiated health claims, including for CBD products.","date":"2023-04-27 00:00:00"},{"id":"04a45d39-7beb-4f4f-bead-78db2d4b7c6c","text":"Meta\u2011analysis showing PTSD is associated with increased risk of later dementia (British Journal of Psychiatry, 2020)","date":"2020-11-24 00:00:00"},{"id":"39311e16-85f9-494a-bd0d-6c08537af9e0","text":"FDA enacted rule and labeling requirements to limit aluminum contamination in parenteral nutrition products (Final rule enacted July 2004).","date":"2004-07-24 00:00:00"},{"id":"bc395992-d8db-4064-be79-0eca3f5dea93","text":"Published research documenting parental refusal and hesitancy specifically around the hepatitis B birth dose (study investigating reasons parents decline newborn HepB immunisation).","date":"2019-04-24 00:00:00"},{"id":"bf32c5da-6283-448d-8acb-44393b76d8a6","text":"Publication of Mitkus et al., \'Updated aluminum pharmacokinetics following infant exposures through diet and vaccination\' (Vaccine, 2011).","date":"2011-11-24 00:00:00"},{"id":"68ee3726-92bd-4c45-947c-6b2f5d426fdc","text":"PNAS paper documenting very slow and variable human liver dihydrofolate reductase (DHFR) activity (Bailey & Ayling, 2009)","date":"2009-09-24 00:00:00"},{"id":"26ebec99-02a1-45a0-8717-5a3f6dbd0172","text":"Report/analysis identifying threshold folic acid doses above which unmetabolized folic acid appears in serum (Sweeney et al., BMC Public Health)","date":"2007-04-24 00:00:00"},{"id":"cd83f40d-8334-4b57-9cd3-265c7647f9d5","text":"Reports from China and international press noting use or trials of high\u2011dose vitamin C in Chinese hospitals","date":"2020-03-28 00:00:00"},{"id":"c7b0be5d-d9a8-4a18-be17-7e886aa98900","text":"Surge in consumer demand and sales for immune\u2011support supplements (vitamin C and D) during March 2020","date":"2020-03-24 00:00:00"},{"id":"2e14056b-ff7a-4e03-a1bf-ea1809a824f3","text":"Svyatoslav Vakarchuk\u2019s public record of outspoken political commentary and criticism of Ukraine\u2019s political class","date":"2016-10-20 00:00:00"},{"id":"5e8f4fa4-fa26-485e-8e61-7934f5c5bf39","text":"Kerch Strait incident: Russian coastguard fired on and seized three Ukrainian naval vessels attempting to transit the Kerch Strait.","date":"2018-11-25 00:00:00"},{"id":"e658e375-6c2f-4f15-9f9d-05a7f91f8865","text":"Ukraine introduced temporary martial law in regions bordering Russia and the Azov-Kerch water area.","date":"2018-11-26 00:00:00"},{"id":"5672f72d-fdb3-40c3-a299-ccdace7d2199","text":"Russian officials publicly accused Ukraine of deliberately provoking the Kerch incident and warned of further Ukrainian \'provocations\'.","date":"2018-11-26 00:00:00"},{"id":"96b171d8-ea9d-45d2-a4ad-33902e09056a","text":"In vitro study examining activated charcoal and GHB adsorption (toxicology literature)","date":"2012-04-24 00:00:00"},{"id":"fa5a6b57-1a47-493a-a36b-3025a63eb5da","text":"Peer\u2011reviewed publication demonstrating intranasal/intratracheal delivery of mRNA to mouse lungs using polymer nanoparticles (Sci Transl Med).","date":"2023-08-16 00:00:00"},{"id":"42ce3983-1339-4c62-ad23-b361140f3706","text":"Hank Aaron publicly received his first dose of the Moderna COVID-19 vaccine at Morehouse School of Medicine to encourage vaccination among Black Americans.","date":"2021-01-05 00:00:00"},{"id":"632f8c9e-0c8d-40c2-8faa-2fa2e56e9f15","text":"Hank Aaron died at age 86 (widely reported on Jan 22, 2021) a few weeks after his public vaccination.","date":"2021-01-22 00:00:00"},{"id":"5dd26957-ac5f-49e5-9148-5b3ea159693b","text":"Publication of a Phase II clinical trial showing curcumin was safe and produced biological effects in patients with advanced pancreatic cancer (Dhillon et al.).","date":"2008-07-24 00:00:00"},{"id":"e52e5643-5b35-422e-a31c-76a074784133","text":"Rapid growth in the commercial turmeric/curcumin supplement market and aggressive product marketing by supplement companies (industry coverage 2015\u20132018).","date":"2016-04-24 00:00:00"},{"id":"af84a2c0-20f1-445d-a47e-be722157f866","text":"CDC report on resurgence of \'black lung\' (progressive massive fibrosis) in coal miners","date":"2016-12-24 00:00:00"},{"id":"123862a1-b1a1-466b-89e8-98bd635fdfa0","text":"Informal agreement reached between the Maltese Presidency and the European Parliament on visa liberalisation for Ukrainians","date":"2017-02-28 00:00:00"},{"id":"25eeb302-e32d-4093-9ccb-28a145392db1","text":"Commission\'s visa\u2011liberalisation proposal specified biometric\u2011passport holders","date":"2016-04-20 00:00:00"},{"id":"bce70684-d785-4f5d-8b34-b37d39ad4b8d","text":"Statement that Ireland and the United Kingdom are not subject to the new visa regime","date":"2017-03-02 00:00:00"},{"id":"c347c984-61b9-4be7-9681-e09841c11eb9","text":"EU Council adopts revision of the visa\u2011waiver suspension mechanism","date":"2017-02-27 00:00:00"},{"id":"046ed115-be27-400a-9c8c-0cb80c6561c9","text":"France\'s health authority (HAS) recommends a single COVID-19 vaccine dose for people previously infected","date":"2021-02-12 00:00:00"},{"id":"4aa20286-0f2d-4b59-bae1-e84853948865","text":"NEJM research letter (Krammer et al.) showing rapid, high antibody responses in seropositive persons after a single mRNA vaccine dose","date":"2021-03-10 00:00:00"},{"id":"6f110a73-018f-47fd-9d6c-f95e95b1b2af","text":"U.S. FDA revokes the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID-19.","date":"2020-06-15 00:00:00"},{"id":"0c97f7fb-82f0-4efe-b17a-2da2ba7482f6","text":"WHO temporarily halts the hydroxychloroquine arm of the Solidarity Trial over safety concerns.","date":"2020-05-25 00:00:00"},{"id":"b324b72e-88e6-43e0-b030-70c39eb247b5","text":"Russian presidential decree fast-tracking Russian citizenship for Ukrainians","date":"2022-07-24 00:00:00"},{"id":"119c8926-bea7-4ad3-b11e-636b958ad8c1","text":"Installation of Russian-backed local administrations and visible propaganda campaigns in occupied cities (e.g., Kherson)","date":"2022-05-24 00:00:00"},{"id":"5333d473-984a-4b43-8d25-bf25f200d4a4","text":"Widespread passport issuance (\u2018passportization\u2019) in occupied Ukrainian cities","date":"2022-07-24 00:00:00"},{"id":"6a3e6b2f-8f3a-428c-afa4-84fc7d2d5fe1","text":"Pre-war and wartime local public-opinion surveys showing mixed but non-negligible support for closer ties with Russia in parts of Donbas","date":"2022-04-24 00:00:00"},{"id":"15cdcf77-2de5-4af8-a741-22b3b80db643","text":"Prior public reporting and regulatory actions in 2021 about rare blood-clotting events with some COVID-19 vaccines (e.g., Johnson & Johnson/AstraZeneca) established a persistent vaccine\u2013blood clot association in public discourse.","date":"2021-04-23 00:00:00"},{"id":"58780262-bc3b-4b04-961b-43d2e249fc68","text":"Government statement ending the legal duty to self-isolate in England as part of the \'Living with COVID\' approach","date":"2022-02-21 00:00:00"},{"id":"82f84f21-f75a-48ff-ae8a-b54bdf66ef25","text":"Great Barrington Declaration (October 4, 2020) advocating \'focused protection\' and arguing against ongoing mass interventions","date":"2020-10-04 00:00:00"},{"id":"70c8b6e0-2edd-47f7-a604-ef58a468a3c7","text":"Publication and circulation of official guidance clarifying limitations of PCR cycle threshold (Ct) values (explaining PCR can detect non-infectious viral fragments)","date":"2021-03-24 00:00:00"},{"id":"4624f61b-3248-4c50-94af-20616705fcde","text":"NOAA AOML study documents an unusually rapid cooling phase in the equatorial Atlantic following record-warm conditions in 2024","date":"2024-08-14 00:00:00"},{"id":"a027dc7b-c9a7-4547-9440-45d1f7341f8b","text":"Safety and technical evaluations by consumer-safety groups (Electrical Safety First and independent lab tests) showing plug-in \u2018power saver\u2019 devices do not reduce residential bills and can pose fire/shock hazards.","date":"2020-04-24 00:00:00"},{"id":"2d75641d-f6d3-4c2c-9905-d28c78ee7d48","text":"Reports of volunteer militias forming in Ivano\u2011Frankivsk region (local volunteer militia of Prykarpattia reported by Interfax)","date":"2014-04-24 00:00:00"},{"id":"efb8e062-80c6-4169-878c-cfe628f51ca3","text":"UN/UNICEF campaign \'Children, Not Soldiers\' and international attention to child recruitment (launched March 2014)","date":"2014-03-24 00:00:00"},{"id":"a93d140c-7059-40a4-9fc7-f386305f99f1","text":"Anti\u2011migrant unrest in Torre Pacheco (July 2025) that was inflamed by a misleading social\u2011media video and triggered violent reprisals and arrests.","date":"2025-07-15 00:00:00"},{"id":"861036e7-6c6d-431d-86cc-846f663b7514","text":"Ongoing monitoring by EUvsDisinfo and similar fact\u2011checking bodies documenting a recurring pro\u2011Kremlin pattern of inserting \'Ukrainians\' into unrelated crimes abroad to discredit Ukrainian citizens.","date":"None"},{"id":"12a6998f-d040-4d06-899a-7db8d940defb","text":"Spanish National Police arrested seven people suspected of stealing more than 1,100 chairs from restaurants and bars in Madrid and Talavera de la Reina.","date":"2025-10-22 00:00:00"},{"id":"993f1d99-f715-4c38-a1fe-58a206840121","text":"Reuters special report documenting separatists\' access to grenades and grenade launchers in Luhansk/Donbas","date":"2014-05-29 00:00:00"},{"id":"8ec60233-7bae-41a9-80e9-b644a2146314","text":"Visual evidence of tanks displayed in Luhansk public spaces and on-the-ground photos around early July 2014 (T-34\u201185 in Luhansk report)","date":"2014-07-06 00:00:00"},{"id":"3a6c93e6-3546-46ae-9c1b-18f087ae34c0","text":"Odesa deadly clashes (May 2, 2014) with dozens killed and widely circulated graphic images","date":"2014-05-02 00:00:00"},{"id":"34b203bf-2d15-4e33-92ab-e2d68078324b","text":"European Court of Human Rights ruled her pre-trial detention was arbitrary/unlawful (June 2013)","date":"2013-06-30 00:00:00"},{"id":"bd4c7672-0948-4f47-a723-25801c90c440","text":"Tymoshenko released from prison during the Euromaidan upheaval (22 February 2014)","date":"2014-02-22 00:00:00"},{"id":"ea2a43fb-c001-41f9-ac74-95a4e68619e1","text":"Massive oil depot fire/explosion began near Vasylkiv (outside Kyiv) on June 8, 2015","date":"2015-06-08 00:00:00"},{"id":"af9b47f0-f78b-405a-813a-dc4f6e375e37","text":"Reports of renewed outbreaks/explosions at the depot after partial containment (June 11, 2015)","date":"2015-06-11 00:00:00"},{"id":"8b0158bf-7d51-4aa1-ba16-ddd321c12f16","text":"State-level legalization and commercialization expansion (New York signs Marijuana Regulation and Taxation Act)","date":"2021-03-31 00:00:00"},{"id":"5537b25c-7236-4628-8260-1c0ab6cefa6e","text":"National Academies report: The Health Effects of Cannabis and Cannabinoids (comprehensive evidence review)","date":"2017-04-24 00:00:00"},{"id":"64d50828-be74-4db2-bbf2-da64e9fa2f7d","text":"FDA approves Epidiolex (cannabidiol) for treatment of specific severe epilepsy syndromes","date":"2018-06-25 00:00:00"},{"id":"0eb8db24-a286-43df-a6bc-012647f9c7cc","text":"Japan suspension of multiple Moderna vaccine batches after discovery of foreign/metal particles (September 2021).","date":"2021-09-24 00:00:00"},{"id":"72044b8d-c4b4-4a59-80fc-c235b79789a5","text":"Publication of Lund University in vitro study reporting reverse transcription of Pfizer-BioNTech mRNA in human liver cell line (Huh7).","date":"2022-02-25 00:00:00"},{"id":"4e688659-175b-45b5-95ad-46280a2e633c","text":"2014 Simferopol incidents and defections of Ukrainian officers during Russia\'s annexation of Crimea.","date":"2014-03-24 00:00:00"},{"id":"82532113-a968-4ea0-adb1-2e87cd0207dc","text":"U.S. delivery of Javelin anti-tank missiles and launchers to Ukraine","date":"2022-01-25 00:00:00"},{"id":"c684ac85-415e-4d8e-9af0-8aeb612bd6c9","text":"Statements and claims from Russian officials and state media accusing Western-supplied arms to Ukraine of being diverted or becoming a broader security threat","date":"2022-04-25 00:00:00"},{"id":"7a90859f-3959-4ce6-aac2-3e8c49a44d33","text":"IARC (WHO) evaluation and monograph work classifying formaldehyde as carcinogenic to humans (Group 1)","date":"2004-06-24 00:00:00"},{"id":"89b9c035-3efa-46e8-8eaa-18f76dbcf1a8","text":"American Academy of Pediatrics and U.S. Public Health Service joint statement recommending reduction/removal of thimerosal from infant vaccines","date":"1999-07-24 00:00:00"},{"id":"b4170d9c-3b72-465a-809d-171f28b7a66b","text":"ACIP / CDC guidance and publications clarifying influenza vaccination in persons with egg allergy (making ovalbumin/egg protein salient)","date":"2011-08-24 00:00:00"},{"id":"6d750e2a-53c7-4e33-b3ad-f199faeee237","text":"Pfizer and BioNTech began their large Phase 3 COVID\u201119 vaccine trial and publicly stated trial enrollment had started.","date":"2020-07-27 00:00:00"},{"id":"5ece7e1d-f751-433f-a23d-a8b8429783f9","text":"Reports of children killed or injured in Kharkiv region shelling (multiple local reports and rights groups)","date":"2022-03-07 00:00:00"},{"id":"2eaec24e-b54e-436c-b85e-1fe26407abfd","text":"Prior high\u2011profile vaccine safety scares (e.g., Japan\u2019s temporary suspension/recall of some Moderna batches after finding foreign particles)","date":"2021-08-28 00:00:00"},{"id":"79853758-a1f1-4361-979e-67f91fdad3ab","text":"Public availability of population\u2011level mortality datasets (World Mortality Dataset / Our World in Data) used by the authors to compute excess deaths","date":"None"},{"id":"ca6f1116-8965-4191-9f7a-2de14fbc69cd","text":"Publication of large peer\u2011reviewed estimates of lives saved by COVID\u201119 vaccination (Lancet study, June 2022)","date":"2022-06-23 00:00:00"},{"id":"ffda74a4-dbc9-407e-b330-796ec4986f62","text":"Protests and roadblocks in multiple towns as gas-dispute left houses without heating","date":"2018-11-14 00:00:00"},{"id":"0eac5b4f-7673-4393-8130-bd9ac9fe96d9","text":"Large-scale winter protests on Maidan (Euromaidan) in cold conditions, Nov 2013\u2013Feb 2014","date":"None"},{"id":"009f8b89-e667-4b4b-a5e4-d6dfa011918d","text":"Local Kyiv residents block a street to demand restoration of heating after prolonged outages","date":"2018-11-19 00:00:00"},{"id":"52ef3fd8-fb9b-4909-a130-323a330527e2","text":"National gas-price increase announced and implemented, triggering utility cutoffs for non\u2011paying customers","date":"2018-11-01 00:00:00"},{"id":"31c3b00e-f900-4850-9e73-0223030754b4","text":"U.S. delivery/confirmation of Javelin anti-tank missiles to Ukraine","date":"2018-04-24 00:00:00"},{"id":"4d8ffea9-6020-4546-8897-a13e1054d374","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels","date":"2018-11-25 00:00:00"},{"id":"939b5de3-dfc6-4646-8e79-a15b536f10d3","text":"Ukraine lawmakers approve a significantly increased defence budget for 2020","date":"2019-09-24 00:00:00"},{"id":"3fca1f99-4c3f-427d-9ab5-018b6b50369b","text":"Large multinational Sea Breeze 2019 naval and amphibious exercises in the Black Sea near Ukraine and Crimea","date":"2019-07-24 00:00:00"},{"id":"db688f4b-62e3-44b7-adcf-3ae0f870d11d","text":"CDC and FDA acknowledged increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination and reviewed the evidence (June 2021 ACIP/MMWR updates)","date":"2021-06-23 00:00:00"},{"id":"5a270b86-3ac0-429a-8fff-2627bc79785d","text":"U.S. CDC and FDA recommended a temporary pause on the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare clotting events (April 2021)","date":"2021-04-13 00:00:00"},{"id":"ac0bbf2a-9912-4968-bfc5-af50067156d3","text":"Norwegian Medicines Agency investigation into 23 deaths of very frail elderly people after Pfizer/BioNTech vaccination (investigation reported publicly)","date":"2021-01-15 00:00:00"},{"id":"6da95ac5-d396-43fa-bc70-0f96e1fd62e9","text":"European Medicines Agency (EMA) finds a possible link between the AstraZeneca COVID-19 vaccine and very rare blood clots with low platelets","date":"2021-04-07 00:00:00"},{"id":"0ea158f9-2cf9-4c14-943a-a6995d3d2c1e","text":"Reporting on targeted Russian disinformation campaigns aimed at Poland\u2013Ukraine relations (contextual, enabling environment)","date":"2022-04-10 00:00:00"},{"id":"57a76d29-9b46-4758-9cfa-c3502439191b","text":"Publication of Rabbit Hole interview with Sergiy Nikolaychuk (Deputy Governor, National Bank of Ukraine)","date":"2022-06-30 00:00:00"},{"id":"74a92bfe-e7e2-4a17-96f3-977bd6c75971","text":"FAO releases \'Pathways towards lower livestock emissions\' at COP28 (FAO report on livestock methane and mitigation)","date":"2023-12-24 00:00:00"},{"id":"3391df15-1751-44cb-ad85-ed274782fe12","text":"Publication and industry publicity for papers endorsing GWP* as a better metric for methane (coverage by AHDB and others)","date":"2023-11-24 00:00:00"},{"id":"99282d0d-b110-43d5-9e0d-5d05ffc5a116","text":"IPCC Special Report on Global Warming of 1.5\xb0C (2018) \u2014 discussion of polar amplification and regional differences","date":"2018-10-24 00:00:00"},{"id":"e767a553-5fcb-4e12-b80e-2a3793afb03d","text":"SCAR (Scientific Committee on Antarctic Research) report: \'Antarctic Climate Change and the Environment\' \u2014 2019 update","date":"2019-04-24 00:00:00"},{"id":"54574071-66b5-4e68-a984-ed6d330c2fdf","text":"Crimea\'s supreme court banned the Mejlis (the representative body of the Crimean Tatar people), declaring it an \'extremist\' organization.","date":"2016-04-26 00:00:00"},{"id":"593d53aa-de27-41d6-97e5-f1eb58f1f26e","text":"Prominent Crimean Tatar leaders (e.g., Mustafa Dzhemilev) gave repeated public statements and interviews emphasizing that Crimea is the historical homeland of Crimean Tatars and calling for protection of their rights and autonomy within Ukraine.","date":"2014-04-24 00:00:00"},{"id":"8f58bdbd-80dc-42f6-9f33-f1c5cc88f715","text":"Large Crimean Tatar-led protest in Simferopol (Day of Resistance), where thousands marched on 26 February 2014 opposing annexation and asserting Crimean Tatar identity and rights.","date":"2014-02-26 00:00:00"},{"id":"6a2c1a2d-6dae-481b-9511-8f7f6c41b31e","text":"ATR, the only mainstream Crimean Tatar\u2013language TV channel operating in Crimea, was denied a Russian broadcasting licence and forced off the air in the occupied peninsula.","date":"2015-04-01 00:00:00"},{"id":"56e46f91-f578-424b-ac97-61bd4ad09dda","text":"Soviet-era mass renaming of Crimean toponyms (large-scale replacement of Crimean Tatar place names with Russian names, principally 1944\u20131949).","date":"None"},{"id":"5f76fcd7-ca7d-4991-9748-23fdfb329e19","text":"The IAEA publicly condemned shelling near the Zaporizhzhia plant and warned the situation was dangerous (IAEA statements in early August 2022).","date":"2022-08-06 00:00:00"},{"id":"6f1f4db2-f7ad-4038-88b1-e49cb9941fd0","text":"Russian forces seized control of the Zaporizhzhia Nuclear Power Plant during initial invasion operations.","date":"2022-03-04 00:00:00"},{"id":"45d0fe49-586e-4392-aab0-6e2ee5485bc6","text":"CDC publishes MMWR report (Risk Factors for Severe COVID-19 Outcomes) showing that among vaccinated persons who died after completing a primary vaccination series, 77.8% of those deaths had four or more risk factors.","date":"2022-01-07 00:00:00"},{"id":"db76db46-d82b-43b1-95f1-a3ed8ba63240","text":"Repeated regulatory actions (2014\u20132016) by Ukraine\'s media regulator removed or blocked numerous Russian channels and programming from Ukrainian airwaves.","date":"2016-02-12 00:00:00"},{"id":"85210055-881e-4173-8e99-af2342aaa7f6","text":"Heavy shelling and bombardment in Donetsk during fighting in late 2014 damaged infrastructure, disrupting TV transmissions and showing visibly destroyed broadcast facilities.","date":"2014-11-24 00:00:00"},{"id":"b4699b79-c057-434f-9ab8-3ed0ed11dd05","text":"2021 Ukrainian government sanctions that removed three pro\u2011Russian TV channels (112 Ukrayina, NewsOne, ZIK) from broadcast.","date":"2021-02-03 00:00:00"},{"id":"c7652e57-3b50-4af6-a37e-e5141018e8db","text":"Long\u2011running Russian state and proxy narratives alleging systemic persecution of Russian\u2011speakers in Ukraine (used as framing and justification since 2022).","date":"2024-04-24 00:00:00"},{"id":"015d0d8a-b015-429a-ad12-eb03df372dd5","text":"Context of real international humanitarian assistance to Ukraine in 2015 (EU/Austria aid packages) \u2014 e.g., European Commission announced additional humanitarian assistance in January 2015.","date":"2015-01-29 00:00:00"},{"id":"96eb0004-956e-4d80-a84f-7200a1e0ad40","text":"The stories invoked an historical Austro-Hungarian practice (dating to 1774) of paying soldiers stationed in Bukovina to compensate for climatic conditions.","date":"2015-12-24 00:00:00"},{"id":"196e5bb8-2507-4fea-9a34-465a3d1bbe5c","text":"High public awareness of large solar PV penetration in Spain (record generation in 2024)","date":"None"},{"id":"1a4a8584-a47f-491a-ac01-9a7df33ccd94","text":"Dutch-led teams recovered wreckage and human remains from rebel-held areas with local actors cutting and loading debris (reported removal of \'crucial debris\')","date":"2014-11-16 00:00:00"},{"id":"eb984b97-6ee7-479d-982d-52c0d85f4175","text":"OSCE and investigators documented limited access, delays, and chaotic control of the crash site by armed groups","date":"2014-11-11 00:00:00"},{"id":"13d812f3-4c7f-4860-8bd9-c7296bdb1d82","text":"1994 discovery and publication identifying Kaposi\u2019s sarcoma\u2011associated herpesvirus (KSHV/HHV\u20118) as the viral agent linked to Kaposi\u2019s sarcoma","date":"1994-12-16 00:00:00"},{"id":"62ec7979-29e7-44f5-9061-97b8046f21dd","text":"Publication and media coverage of a 2017 MACS cohort analysis reporting links between heavy popper use and some virus\u2011associated cancers in older HIV\u2011negative MSM","date":"2017-04-24 00:00:00"},{"id":"46074779-fb4f-457a-9f85-8c4299875b73","text":"UNICEF press release and mapping (July 13, 2022) on protection and care of unaccompanied and separated children fleeing Ukraine, highlighting legal complexity and cross\u2011border guardianship issues.","date":"2022-07-13 00:00:00"},{"id":"0253ccf2-8231-4970-85c0-0d5faa424449","text":"High\u2011profile \'Jugendamt\' child\u2011removal case (Ariha Shah): German youth welfare authorities removed an infant from her Indian parents in Berlin (reported September 2021).","date":"2021-09-23 00:00:00"},{"id":"7eef192a-a093-4a72-bede-19b3ea62ea63","text":"Furdui family case (April 26, 2021): Seven children of the Furdui family were taken into custody by a German Jugendamt office, generating international coverage and long\u2011running dispute.","date":"2021-04-26 00:00:00"},{"id":"16f49665-56cd-4020-a877-576647975e56","text":"Publication of peer\u2011reviewed study reporting enlarged external occipital protuberances (EEOP) in young adults","date":"2018-02-20 00:00:00"},{"id":"d0593d90-01d0-4ea8-ab77-4bc3ab40d85e","text":"StatPearls / NCBI review and guidance summarising when activated charcoal is indicated for poisoning (clinical toxicology guidance update)","date":"2023-04-26 00:00:00"},{"id":"78cf8df1-f528-484a-a227-ce2148453ea9","text":"Major news coverage of charcoal consumer products (BBC story noting popularity and celebrity effect for charcoal toothpastes/products)","date":"2019-05-10 00:00:00"},{"id":"7736b01d-9d52-4191-8649-3935b5d7e4c6","text":"WHO interim guidance on mask use in the context of COVID\u201119 (update)","date":"2020-06-05 00:00:00"},{"id":"42ebe7bd-d97d-4f3e-bca0-87867d9d6902","text":"Publication of van Doremalen et al. laboratory study on aerosol and surface stability of SARS\u2011CoV\u20112","date":"2020-03-17 00:00:00"},{"id":"2cc4fbb5-7e91-4eda-9477-41f4891308b9","text":"Open letter and media coverage by scientists arguing for recognition of airborne transmission (239 scientists)","date":"2020-07-04 00:00:00"},{"id":"5d2cb133-194f-49c8-af45-598d4cbcec5a","text":"FDA emergency use authorization of the Pfizer\u2011BioNTech COVID\u201119 vaccine for children 5\u201311, sparking public debate about pediatric vaccination schedules","date":"2021-10-29 00:00:00"},{"id":"cb8462d1-d7fa-4332-8219-7feef998001d","text":"Peer\u2011reviewed immunology review concluding there is no evidence that recommended vaccines \'overload\' or weaken infants\' immune systems (literature on \'antigenic overload\')","date":"2004-04-24 00:00:00"},{"id":"7f66a7e6-69b0-4ed7-a76a-aba9aa79e5bc","text":"U.S. officials publicly rejected or expressed serious concerns about Poland\'s proposal to transfer MiG-29s via a U.S. base, citing escalation and alliance complications.","date":"2022-03-08 00:00:00"},{"id":"e3e465f6-cf05-42d8-a17d-575f69d2fefe","text":"Polish government and analysts documented and warned about sustained Russian disinformation campaigns targeting Poland after the start of the war in Ukraine.","date":"2022-05-06 00:00:00"},{"id":"0a63b17d-a0f7-4289-b7a2-009dcc402d58","text":"Open-source documentation (Oryx) and media reports catalogued numerous photographed and video-documented losses of Ukrainian equipment (including Western-supplied systems) during 2022.","date":"2022-02-24 00:00:00"},{"id":"c8cf1924-4a5f-46c3-a9c4-ca0488053763","text":"30 November 2018: Ukraine announced a ban on entry for Russian men of military age (reported by multiple outlets).","date":"2018-11-30 00:00:00"},{"id":"4b57f24f-9d8f-4e66-b607-5cbf5a7f73ee","text":"June 2019: Russian president Vladimir Putin signed a decree simplifying the procedure for residents of Donetsk and Luhansk to obtain Russian passports (accelerated \'passportisation\').","date":"2019-06-24 00:00:00"},{"id":"21816fb2-338a-4b94-9ec9-1502305688e1","text":"August 2014: Large-scale displacement from Donbas with thousands crossing into Russia during the summer 2014 fighting.","date":"2014-08-01 00:00:00"},{"id":"5416a5bc-9aa0-4b41-ad0e-0c9d8e8a4c38","text":"U.S. government purchase agreement announced earlier in July 2020 (Pfizer/BioNTech $1.95B deal for 100 million doses) linking Pfizer to federal vaccine procurement.","date":"2020-07-22 00:00:00"},{"id":"1c33447f-9b46-467a-b7f4-d907de6a50a4","text":"Pfizer and BioNTech press release announcing their vaccine candidate was >90% effective in interim Phase 3 analysis","date":"2020-11-09 00:00:00"},{"id":"1fe462a1-82dd-4fab-bf7c-f7c9823fc4e0","text":"Reporting on Pfizer\'s funding sources and relationship to Operation Warp Speed that highlighted nuance (e.g., Fortune/other Nov 9, 2020 pieces saying Pfizer did not take OWS R&D funding but had U.S. supply deals).","date":"2020-11-09 00:00:00"},{"id":"4e10ed8d-4010-4c28-89a7-fa16335d2a33","text":"Ukrainian Central Election Commission (CEC) formally listed electoral districts and polling stations in Donetsk and Luhansk where voting would not be organized for the 2019 presidential election.","date":"2019-02-12 00:00:00"},{"id":"d9b8ccf2-fd23-4c83-8acb-d8ad5e5b68ee","text":"Historical precedent of electoral disruption in eastern Ukraine (2014): pro-Russian militants previously occupied or disrupted polling stations and seized ballot materials in Donetsk and Luhansk during earlier elections.","date":"2014-04-24 00:00:00"},{"id":"12cbac2e-c124-419b-bfba-8eb089e92750","text":"Pro\u2011Russian protesters seized regional government buildings in eastern Ukraine","date":"2014-03-03 00:00:00"},{"id":"43d05f96-9246-4049-9c56-c446ceea2a7d","text":"Delivery of a $2 billion Russian credit to Ukraine was delayed","date":"2014-02-19 00:00:00"},{"id":"dfb7f452-6f07-44e5-93fc-19766ddf8227","text":"Unmarked (Russian) troops and seizures in Crimea disrupted Ukrainian military units","date":"2014-02-27 00:00:00"},{"id":"585b62e4-af3f-4f88-a85a-202d5611bf92","text":"Interim Ukrainian government formation delayed, creating administrative uncertainty","date":"2014-02-25 00:00:00"},{"id":"06abf97f-1f34-46a7-858f-267e8104e7e5","text":"Ukraine\'s currency (hryvnia) plunged after central bank policy change","date":"2014-02-05 00:00:00"},{"id":"020eaf7c-6638-408a-a07f-be78f52769c1","text":"U.S. COVID-19 vaccine reporting rules tied to Emergency Use Authorization: healthcare providers were required to report all serious adverse events and certain other events to VAERS (policy in effect since the COVID EUA rollout, December 2020 onwards).","date":"2020-12-24 00:00:00"},{"id":"d04d7a00-5557-4055-b7ab-a0c7706180e8","text":"Public availability of raw VAERS datasets and third-party dashboards (VAERS data downloadable and publicly accessible since the system\'s creation).","date":"None"},{"id":"cae9d058-4b9f-4631-8d47-bd0a5ebce50a","text":"Japan\'s Ministry of Health, Labour and Welfare approved ARCT-154, the first commercial self-amplifying (saRNA) COVID-19 vaccine (CSL/Arcturus).","date":"2023-11-28 00:00:00"},{"id":"da41dc75-fcc4-41ab-88dd-ddf7161e36b0","text":"Japan paused and recalled some Moderna COVID-19 vaccine lots after discovery of foreign (stainless-steel/black) particles in vials at vaccination sites (investigation and voluntary recall reported).","date":"2021-09-01 00:00:00"},{"id":"8e0925f8-ca35-4b50-af54-c2a561cbd4f7","text":"UN Human Rights Monitoring Mission report noting an inflow/presence of \\"foreign fighters\\" in eastern Ukraine","date":"2015-08-24 00:00:00"},{"id":"7035f193-d0d8-4b29-9363-8b9997255920","text":"Death of Isa Munayev, commander of the Dzhokhar Dudayev (Chechen) battalion fighting for Ukraine (killed near Debaltseve)","date":"2015-02-01 00:00:00"},{"id":"dfcd5ada-9ea3-465b-ac6e-ad0cb35806d4","text":"New York Times article: \\"Islamic Battalions, Stocked With Chechens, Aid Ukraine in War With Rebels\\"","date":"2015-07-08 00:00:00"},{"id":"e159d079-6ebd-4da8-b6f3-264cf95c3164","text":"CBC News coverage (Apr 2012) of University of Windsor research and a $157K grant for \'cancer\u2011killing dandelion tea\'","date":"2012-04-20 00:00:00"},{"id":"27779f6e-b1d1-4cb1-b2fd-22465de74412","text":"2012 PLOS ONE study showing dandelion root extract induces apoptosis in leukemia (CMML) cell lines","date":"2012-02-17 00:00:00"},{"id":"f6603684-e321-437b-beab-55794bdec1e6","text":"Research on cognitive impairments in chronic tinnitus patients (e.g., \'The characteristics of cognitive impairment in subjective chronic tinnitus\', PubMed 29541537, 2018)","date":"2018-04-24 00:00:00"},{"id":"50d18c7f-3a6a-42f9-924a-ddef9d67bc1f","text":"Lancet Commission report \'Dementia prevention, intervention, and care\' identifies hearing loss as a major modifiable dementia risk factor","date":"2017-12-24 00:00:00"},{"id":"7b152dcf-fc08-4a62-8dbc-17dc3c6ac19a","text":"Local reporting documented a sharp rise in COVID-19 hospitalizations in Jacksonville and UF Health Jacksonville reported 175 hospitalized with COVID-19 (July 26, 2021).","date":"2021-07-26 00:00:00"},{"id":"8f37c27b-d364-44d6-b01e-ce0ee74d8907","text":"Public Health England / UKHSA technical briefings (mid-2021) showing many COVID cases and deaths among vaccinated older adults that were widely shared without age\u2011adjustment context","date":"2021-07-14 00:00:00"},{"id":"ffb5ffce-b389-4d5d-bc1f-35c187f1ae5f","text":"Large case surges in highly vaccinated countries (example: Israel, summer 2021) that circulated widely on social media suggesting temporal link between vaccination campaigns and rising infections","date":"2021-07-24 00:00:00"},{"id":"e694a73b-cb53-4c33-9b40-f3f3dfcb771f","text":"Early Omicron reporting (Dec 2021) showing large reduction in vaccine protection against infection","date":"2021-12-16 00:00:00"},{"id":"61b6a234-6058-48af-9ace-0901a6a84064","text":"2019 CDC shutdown of biosafety operations at Fort Detrick (US Army medical research lab) after safety inspection","date":"2019-08-05 00:00:00"},{"id":"2a277377-d848-40da-9359-47a74c644917","text":"President Biden orders U.S. intelligence agencies to \'redouble\' investigation into COVID-19 origins","date":"2021-05-26 00:00:00"},{"id":"2c11a22a-4451-4ea2-b25b-6f8260f7cbb3","text":"Reports that California lawmakers planned to introduce legislation to end personal-belief vaccine exemptions in response to the outbreak.","date":"2015-01-23 00:00:00"},{"id":"acb5312e-89e5-4784-9168-e6895d049d9c","text":"CDC Health Alert Network (HAN) advisory announcing a U.S. multi-state measles outbreak linked to Disneyland theme parks.","date":"2015-01-23 00:00:00"},{"id":"52b9bf68-c607-4c69-8549-54c0506b97d6","text":"US Operation Atlantic Resolve deployed rotational armored units (tanks/Bradleys) into Eastern Europe (to reassure NATO)","date":"2014-04-24 00:00:00"},{"id":"8b331ebe-6540-4df7-9b68-a56dab66f6e2","text":"OSCE SMM reported observing unmarked convoys and multiple tanks operating in Donetsk/Donbas territory","date":"2014-11-08 00:00:00"},{"id":"4f148573-3f7c-4b23-ab56-b786a94fe1ff","text":"Reporting of foreign volunteers and irregular fighters in Donbas (documented by major outlets)","date":"2014-09-01 00:00:00"},{"id":"f167a6f0-9e3f-45c6-b6d4-bb10c3231b5c","text":"Russian and pro\u2011Kremlin media/public figures repeatedly alleged Western/NATO involvement (including claims of NATO personnel/equipment in Ukraine)","date":"2014-11-12 00:00:00"},{"id":"ced5d570-760d-413b-8f21-396ef27792cb","text":"The MV Rhosus delivered and was detained with 2,750 tonnes of ammonium nitrate in Beirut after an unscheduled stop.","date":"2013-11-24 00:00:00"},{"id":"64be78f6-4a3d-4c4f-b406-88deb69e8d5c","text":"Viral videos show Italians performing coordinated gestures (singing/dancing) on balconies during lockdown (mid\u2011March 2020)","date":"2020-03-13 00:00:00"},{"id":"dc80216c-cbb5-43e5-bc1e-0876557372d8","text":"IEA publishes \'Electricity Grids and Secure Energy Transitions\' calling for major transmission build-out and doubling of power-system flexibility needs to 2030.","date":"2023-10-17 00:00:00"},{"id":"5f9ee440-cbcd-4357-b3c6-47414dce7052","text":"European Commission publishes the EU Offshore Renewable Energy Strategy recommending cross-border planning and consideration of a more \'meshed\' offshore grid and hybrid projects.","date":"2020-11-19 00:00:00"},{"id":"5ec49e9a-2136-40d6-b6ea-0e88683b1cad","text":"U.S. DOE publishes \'Microgrid Overview\' fact sheet describing microgrids as entities that can operate grid-connected or in island (isolated) mode.","date":"2024-01-18 00:00:00"},{"id":"04cf0118-62e6-4b3e-8d62-c2c2f4182169","text":"NREL publishes a \'Research Roadmap on Grid\u2011Forming Inverters\' and related analyses explaining that high shares of inverter\u2011based resources require new inverter controls and grid\u2011forming capabilities for stability.","date":"2021-04-24 00:00:00"},{"id":"e3189ef6-b119-49e3-afbc-0708491dd4dd","text":"TenneT proposes a 6-GW North Sea \'hub\' / wind power booster and publishes plans toward a meshed offshore transmission approach.","date":"2023-10-29 00:00:00"},{"id":"18de34e3-72c0-4edc-9373-1b7213da3d0e","text":"Russian authorities repeatedly detained Ukrainian civilian fishermen and ships in the Sea of Azov (reported detentions of Ukrainian fishing crews).","date":"2017-02-24 00:00:00"},{"id":"c7e229b8-8c07-4814-a24f-77bed644174e","text":"Russian troops and pro\u2011Russian forces seized multiple Ukrainian navy vessels and naval bases during the 2014 Crimea annexation (including the capture of three Ukrainian warships).","date":"2014-03-21 00:00:00"},{"id":"018d2f1a-a9c0-4dfe-8791-55e182f640b3","text":"Advisory Referendum Act (Wet raadgevend referendum) had recently entered into force (1 July 2015) enabling citizen-initiated national referendums","date":"2015-07-01 00:00:00"},{"id":"794304a8-b4ab-4f2b-a488-53bcd4b14383","text":"Prime Minister Mark Rutte calls the referendum \'disastrous\' and says he is \'totally, totally, totally against referendums\'","date":"2016-06-13 00:00:00"},{"id":"cc36a9db-6077-4ec9-adbe-c04f3ba9a177","text":"Large, highly visible arrival of Ukrainian refugees into Italy in March\u2013April 2022 (Italian draft plan to take up to 175,000 and steadily rising refugee numbers reported).","date":"2022-03-18 00:00:00"},{"id":"f4120b19-33c5-4df5-ae3f-cfcbe5523733","text":"March 2017: The World Meteorological Organization added asperitas as a recognized cloud feature in the updated International Cloud Atlas.","date":"2017-03-24 00:00:00"},{"id":"f0cf4498-cfb4-4250-916e-551d1f56027c","text":"Longstanding practice of sending Ukrainian spent nuclear fuel to Russia for reprocessing (and return of reprocessing waste)","date":"None"},{"id":"33174958-b90e-4fc4-842b-245976472f54","text":"Holtec (project contractor) published confirmatory functional testing of ISF\u20112 interim spent fuel storage at Chernobyl (technical milestone)","date":"2019-05-06 00:00:00"},{"id":"49257e18-1694-46bd-8535-894c014ad982","text":"Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers","date":"2021-08-24 00:00:00"},{"id":"fc91703a-e115-4756-abf5-e385f67fcfa4","text":"NOAA/NCEI global climate reporting for 2021 (annual analysis released Jan 2022) showing year-to-year variability and La Ni\xf1a-linked cooling influence","date":"2022-01-24 00:00:00"},{"id":"4db0a61c-539f-47d1-aa41-d61c371d389f","text":"Publication of Karl et al. (2015) and the \'hiatus\' data-adjustment debate (NOAA/Science) that revised surface temperature trends","date":"2015-06-24 00:00:00"},{"id":"fb4d2e98-e1a5-47cd-9b89-d6594993ba1a","text":"CDC FluView weekly surveillance report (Week 41, data through Oct 16, 2020) showing unusually low influenza activity and low percent-positivity in respiratory specimens","date":"2020-10-16 00:00:00"},{"id":"309bed94-5394-402c-a7c9-3341fbf38902","text":"Adoption of Ukraine\'s \'decommunization\' laws in April 2015 and subsequent municipal actions to remove or rename Soviet-era symbols and monuments.","date":"2015-04-09 00:00:00"},{"id":"04fa843d-c467-42fc-a11b-e2b4e326fd6d","text":"Widespread toppling and removal of Soviet-era monuments during and after Euromaidan (2013\u20132014) \u2014 high-profile removals of Lenin statues and related coverage created a recent precedent for \'monuments being taken down\'.","date":"2014-02-24 00:00:00"},{"id":"48cb2831-5726-4672-89cc-9915cc22036b","text":"Reports and imagery documenting heavy fighting, civilian deaths and damage in Hostomel and nearby areas during the Russian offensive (March\u2013April 2022)","date":"None"},{"id":"e1dc75f3-2554-453f-8935-20d9fe70c69a","text":"Discovery and wide circulation of video and photo evidence showing dozens of dead civilians in Bucha (near Kyiv)","date":"None"},{"id":"49c6df3a-a2fa-4f8d-9ca8-3afc1db555d4","text":"Advocacy/analysis note and reports on voting rights of internally displaced persons (IDPs) in Ukraine noting ~1.4 million registered IDPs and barriers to their participation in local elections (reports circulated February 2019).","date":"2019-02-14 00:00:00"},{"id":"b1456a7f-65ff-4e2b-8ece-58d52c4b4035","text":"Central Election Commission (CEC) announced that presidential voting would not be organized in Crimea, Sevastopol and parts of Donetsk and Luhansk (list of districts where vote will not be held).","date":"2019-02-13 00:00:00"},{"id":"f14ab467-fd64-4211-914b-af28c8a43039","text":"Guides and reporting on practical difficulties for Ukrainians voting abroad ahead of the 2019 presidential vote (limited polling stations, complex registration procedures noted in Feb 2019 coverage).","date":"2019-02-19 00:00:00"},{"id":"57a6ef75-13f9-4589-a649-16cd436bdf59","text":"Poland announced it would stop new weapons transfers to Ukraine","date":"2023-09-21 00:00:00"},{"id":"056d5d02-f776-4514-9547-3c9fe23ddfa3","text":"Poland and Ukraine entered a bitter grain-dispute diplomatic row (restrictions on Ukrainian grain)","date":"2023-09-21 00:00:00"},{"id":"3a2345a4-de53-4fe6-9211-ba1c526e0ff6","text":"Hungary vetoed/blocked a major EU aid package for Ukraine at an EU summit","date":"2023-12-13 00:00:00"},{"id":"a3447ac8-e37f-41ee-a185-6f2f2caabe42","text":"Diplomatic expulsions and mutual espionage accusations between Hungary and Ukraine (spy scandal)","date":"2025-05-09 00:00:00"},{"id":"24e3d945-c664-4acf-81f9-fa0c58e977fe","text":"December 2021 reporting and market data (SPINS / Whole Foods coverage) documenting a rapid consumer boom in adaptogen supplements (ashwagandha, reishi, etc.).","date":"2021-12-24 00:00:00"},{"id":"4f463dfc-a1b1-4a06-8341-3f8e5f3c168b","text":"Publication of a 2021 peer-reviewed review summarizing preclinical anti\u2011cancer activity of curcumin but concluding clinical evidence is limited.","date":"2021-04-24 00:00:00"},{"id":"7741a1fa-a410-43e0-9b0c-055949c8a4b0","text":"FDA public enforcement and health\u2011fraud warning letters in 2019 targeting unapproved ozone medical claims and other alternative \'therapies\'.","date":"2019-04-24 00:00:00"},{"id":"d1574709-ef45-4df4-9dd4-56dc36bcdc85","text":"Publication and widespread citation of Mayo Clinic / NEJM-era randomized trials (1985) showing high\u2011dose vitamin C had no benefit in advanced cancer patients.","date":"1985-04-24 00:00:00"},{"id":"44dca193-2030-46c0-8d83-19daee4d948f","text":"Government legal actions and sanctions against Poroshenko and his circle in early 2022","date":"2022-02-17 00:00:00"},{"id":"6204584f-fec5-4528-8eac-f71c21153c81","text":"Poroshenko appears in combat role and publicly joins territorial defence units after Russia\'s full-scale invasion","date":"2022-02-25 00:00:00"},{"id":"b9940263-75cd-473b-a824-3449476e51ae","text":"Public statements by Crimean authorities (Sergei Aksyonov) saying Crimea would refuse Ukrainian electricity even if restored","date":"2015-12-24 00:00:00"},{"id":"1aa9e6b8-41b1-47c4-921c-a435660b1572","text":"Reporting in August 2021 that the UK government and advisers were preparing/considering booster programmes (coverage of policy options and possible mass booster rollouts for older adults and vulnerable groups).","date":"2021-08-19 00:00:00"},{"id":"efe9acbf-5c68-4535-b952-70577ca50625","text":"WHO publicly called for a moratorium on widespread booster campaigns on August 4, 2021, arguing doses should be prioritized for unvaccinated populations globally.","date":"2021-08-04 00:00:00"},{"id":"5f38c603-2dcd-4665-8bef-e094caef7a8e","text":"Israel announced it would offer a third (booster) COVID-19 dose to people aged over 60, becoming one of the first countries to roll out a booster programme.","date":"2021-07-30 00:00:00"},{"id":"5a6d25c0-72b5-47d0-9a25-00a946e8ebce","text":"CDC published an MMWR (July 2021) on a large July outbreak in Barnstable County, Massachusetts, in which a high proportion of identified cases were among fully vaccinated people (Delta-driven breakthrough infections).","date":"2021-07-30 00:00:00"},{"id":"a137848e-0579-44c3-a4a8-77c46f0ee531","text":"Pfizer/BioNTech published initial data and public statements in July 2021 highlighting a planned booster program and that a third dose substantially increased neutralizing antibody titers.","date":"2021-07-08 00:00:00"},{"id":"9b175709-e0ba-4408-aa1c-dfd76310493a","text":"Reports and satellite data show reduced air pollution over northern Italy after lockdowns","date":"2020-03-24 00:00:00"},{"id":"efb4f986-fd6a-468b-aa17-c623424d1033","text":"Satellite images show sharp drops in NO2 over China during lockdowns","date":"2020-02-24 00:00:00"},{"id":"71e27d8d-0a62-4065-b6f0-754d4b25e80b","text":"Climate strikes and mass mobilizations moved online or were paused (Fridays for Future/Greta Thunberg urged digital action)","date":"2020-03-13 00:00:00"},{"id":"6ef174a1-4126-4bc3-9713-f1aeaf969ec9","text":"WHO declares COVID-19 a pandemic","date":"2020-03-11 00:00:00"},{"id":"8b08fdbe-6074-461f-9420-8973568fec69","text":"CDC and US advisory panels publishing VAERS-based myocarditis reports and guidance (MMWR/ACIP reviews in June 2021) acknowledging myocarditis reports after mRNA vaccination while concluding benefits outweigh risks.","date":"2021-06-23 00:00:00"},{"id":"e06a7277-5f24-48fb-9c78-13c76be81e98","text":"IPCC Fifth Assessment Report (AR5, WG1) release and SPM (2013) noting short-term variability and model/observation differences","date":"2013-09-24 00:00:00"},{"id":"099d05fd-55f3-40ef-beaa-1a522d6addf7","text":"NOAA/Karl et al. Science paper and NOAA press release revising observational records (June 2015)","date":"2015-06-24 00:00:00"},{"id":"70d2a4d5-b786-4e49-af2c-e2da94a512f9","text":"Testimony by John R. Christy to U.S. House committee (December 11, 2013) arguing climate models exaggerate warming","date":"2013-12-24 00:00:00"},{"id":"e350c53e-e396-41e1-817f-9304ad844ea9","text":"Germany\'s federal and state health ministers decided to restrict routine use of the AstraZeneca vaccine to people over 60 following blood\u2011clot concerns.","date":"2021-03-30 00:00:00"},{"id":"883a896b-e817-45fc-b9ee-371155a7d074","text":"Japan recalled and halted distribution of some Moderna COVID-19 vaccine doses after contamination/foreign particle reports were detected in early August 2021.","date":"2021-08-05 00:00:00"},{"id":"3e432faf-9460-4d1b-a841-fbe9839fbcbd","text":"Public safety reports and media coverage in spring 2021 highlighted suspected deaths and serious adverse events reported after COVID-19 vaccination in Germany (data summarized by the Paul\u2011Ehrlich\u2011Institut and discussed in studies/media).","date":"2021-03-24 00:00:00"},{"id":"6995508b-5d89-4444-9304-cba0e41fae35","text":"Duda visited the Bykivnia National Historic Memorial / Polish war cemetery near Kyiv during the October 2020 trip","date":"2020-10-11 00:00:00"},{"id":"1f26bf27-13ba-421b-9231-cf226ab52ad1","text":"Andrzej Duda\'s previous public statements and commemorations framing the Volhynia killings as ethnic cleansing/genocide (past ceremonies and remarks)","date":"2018-07-11 00:00:00"},{"id":"90bfad8f-ac37-4d23-981d-a31dffe2cb8c","text":"Duda and Zelensky signed a joint declaration and attended economic events in Odesa during the October 2020 visit","date":"2020-10-12 00:00:00"},{"id":"c3b90585-ea0d-4a8a-8dd8-5970b472f13f","text":"UN Secretary-General Ban Ki-moon publicly expresses concern about the Crimea referendum","date":"2014-03-17 00:00:00"},{"id":"1c43e30e-6ec5-4b7b-8717-cc2a2a107d40","text":"CDC and ACIP public reports (June 2021) documenting increased reports of myocarditis/pericarditis after mRNA COVID\u201119 vaccination in younger males and recommending continued monitoring.","date":"2021-06-23 00:00:00"},{"id":"4b795e2e-7eb3-45ee-ab80-4bdd2e3d9779","text":"Contamination and recall incidents in Japan involving Moderna vaccine vials (stainless\u2011steel/black particles) reported widely in media.","date":"2021-09-24 00:00:00"},{"id":"4b9f26b8-447d-4e58-930b-ba76b8681145","text":"EMA publication of the Comirnaty (BNT162b2) public assessment report including preclinical biodistribution and safety data.","date":"2020-12-24 00:00:00"},{"id":"f6f240d1-76eb-49ce-9de1-39ad685f1451","text":"IPCC Fifth Assessment (AR5) and associated carbon\u2011cycle graphics made public (figures showing large natural CO2 fluxes compared to anthropogenic fluxes)","date":"2013-04-24 00:00:00"},{"id":"6a6acfc5-0af5-46ce-857a-e2904f2b9c4b","text":"Russian MP Vladimir Zhirinovsky sent letters proposing the division of Ukraine and suggested neighboring countries (including Poland) could take western regions.","date":"2014-03-24 00:00:00"},{"id":"4cd90b44-31f1-4a01-909a-4d4270ab2c65","text":"Polish officials publicly denied any territorial claims and reiterated support for Ukraine (coverage: \'Lviv is Ukraine\'\u2014Warsaw assures it has no territorial claims).","date":"2014-03-24 00:00:00"},{"id":"5d67f516-3b5f-4d8e-89da-3d90721cd993","text":"American College of Pediatricians (ACPeds) January 2016 statement raising concerns about polysorbate 80 in the HPV vaccine","date":"2016-01-24 00:00:00"},{"id":"ea09b041-c617-47d9-a76d-d81079f36fd8","text":"Manufacturer label for Amphastar/Phytonadione injectable lists excipients (e.g., polysorbate 80, propylene glycol) in some formulations","date":"2018-02-24 00:00:00"},{"id":"9644246f-94cc-4458-8e14-564eb1d861e6","text":"ACRIM\u2013PMOD Total Solar Irradiance (TSI) composite controversy and Fr\xf6hlich PMOD revision (mid-2000s)","date":"2006-04-24 00:00:00"},{"id":"3c0b8def-ab2d-45ba-94a6-da76f2b7dd29","text":"Scafetta papers arguing a large solar contribution to recent warming (e.g., 2009 empirical analyses)","date":"2009-04-24 00:00:00"},{"id":"d30e401a-ef55-4f7f-9712-cd9cf7cb7d88","text":"Release of the NIPCC/Heartland \'Nature, Not Human Activity, Rules the Climate\' summary (NIPCC)","date":"2008-04-24 00:00:00"},{"id":"ac80f77a-57a3-47c8-922e-ed3cd647d0d5","text":"Publication of Soon & Baliunas \'Proxy climatic and environmental changes of the past 1000 years\' (Climate Research)","date":"2003-07-24 00:00:00"},{"id":"671c1c28-dc15-477f-9030-30d9ad77a14e","text":"Ukraine enacted gas-market reforms in 2015 (Gas Market Law, IMF-backed liberalisation) moving to market-based pricing (law effective 1 Oct 2015).","date":"2015-10-24 00:00:00"},{"id":"1f6fc9c1-12a1-4b1b-921e-9b373c2ef256","text":"Naftogaz disclosed it procured all imported gas in 2016 from 15 European suppliers and published average Q1 2016 import price (~$198 per 1,000 m3).","date":"2016-04-24 00:00:00"},{"id":"28952f14-1d58-4bc1-9a8e-f41ecbb4a101","text":"Reporting showed Poroshenko\'s approval ratings and political standing were weak in early April 2016 (analysis reported 7 April 2016).","date":"2016-04-07 00:00:00"},{"id":"edab6fc1-799c-47f3-8cab-19addfc4e3e3","text":"Russian and other foreign/state-aligned media amplified the Dutch result as evidence of Western unreliability on Ukraine (analysis and commentary in days after the vote, e.g. Financial Times 8 April 2016).","date":"2016-04-08 00:00:00"},{"id":"1972c4cb-49be-4b10-a2ef-e3f2114602b8","text":"Ukraine experienced visible political instability in early 2016 (Prime Minister Arseniy Yatsenyuk resigned/was asked to resign and government survived no-confidence votes in February 2016).","date":"2016-02-16 00:00:00"},{"id":"d0c21fa2-f9c2-40f1-a260-4a254df804f4","text":"Dutch advisory referendum rejected the EU\u2013Ukraine Association Agreement (61% against) on 6 April 2016.","date":"2016-04-06 00:00:00"},{"id":"f1960d27-fd97-4804-b057-6f7e9205cd00","text":"U.S. Secretary of State discussions tying sanctions relief and diplomatic pressure to implementation of Minsk political measures (Kerry remarks, 2015)","date":"2015-05-24 00:00:00"},{"id":"729b965e-10e0-4396-a476-538b41bef3e6","text":"U.S. leaders publicly ruled out direct military intervention in Ukraine (statements from 2014)","date":"2014-03-24 00:00:00"},{"id":"fd6c18d0-24fb-46be-a977-14bd1261a91c","text":"BMJ commentary highlighting that pregnant women were routinely excluded from COVID\u201119 vaccine trials (and calling for their inclusion).","date":"2020-08-25 00:00:00"},{"id":"9a290797-749c-42ed-a67d-75d66083b144","text":"Pfizer/BioNTech press release (Nov 9, 2020) announcing interim Phase 3 efficacy results for their mRNA vaccine encoding the SARS\u2011CoV\u20112 spike protein.","date":"2020-11-09 00:00:00"},{"id":"f339002b-ff86-4405-a3c8-36d40f57cb28","text":"UK government / ONS releases reporting ~945,000 people self\u2011reporting long COVID in July/August 2021 (publication 5 August 2021).","date":"2021-08-05 00:00:00"},{"id":"5bbf7340-f31b-4450-acae-7485768ed63b","text":"Early cohort studies (e.g., Lancet 6\u2011month outcomes, Jan 2021) reported wide-ranging, multi\u2011system persistent symptoms with unclear mechanisms.","date":"2021-01-08 00:00:00"},{"id":"8626ca71-1e52-4c5f-8f17-9dab6c266608","text":"WHO published a clinical case definition of post\u2011COVID\u201119 condition (long COVID) using Delphi consensus, noting heterogeneous symptoms and lack of a single diagnostic biomarker.","date":"2021-10-06 00:00:00"},{"id":"7fd9c91f-c316-400d-85b4-090ac628f432","text":"OSCE Special Monitoring Mission reports and situation updates documenting mines, UXO and restricted access along roads and rail in Donbas (2015 SMM reporting).","date":"2015-04-24 00:00:00"},{"id":"88bcba6f-3141-4a39-87f2-94e0f38fa00a","text":"Mine Action Review and national mine\u2011action reporting showing large-scale anti\u2011personnel/anti\u2011vehicle mine contamination in eastern Ukraine (Clearing the Mines report, 2017).","date":"2017-04-24 00:00:00"},{"id":"6a957da1-406d-4b72-bcbd-6596131f5345","text":"2014 Russian \'humanitarian\' convoy and other cross\u2011border convoys/shipments that entered eastern Ukraine without Kyiv\'s full control.","date":"2014-08-24 00:00:00"},{"id":"4efd2e64-a23b-485e-a038-428d2989b63b","text":"Analyses of Russian information operations documenting rapid, repetitive amplification tactics (the \'firehose of falsehood\' model).","date":"2016-04-24 00:00:00"},{"id":"ea149bda-238a-4057-acdf-0cd761b1b278","text":"Politico reporting (April 29, 2025) that several major European leaders declined Ukrainian President Zelensky\'s invitation to Kyiv on May 9.","date":"2025-04-29 00:00:00"},{"id":"ae10eee8-7eb6-4dd8-9f0f-947491a632cc","text":"Berliner Zeitung opinion column titled \'Herr Merz, zeigen Sie Mut \u2013 fliegen Sie am 9. Mai zu Putin nach Moskau!\' urging Merz to fly to Moscow for Victory Day (op-ed).","date":"2025-05-08 00:00:00"},{"id":"07681209-6c18-43df-bb34-a99640acf3fe","text":"Kremlin announcement (May 6, 2025) that 29 foreign leaders had been invited / would attend Moscow\'s Victory Day parade.","date":"2025-05-06 00:00:00"},{"id":"7145843c-da9a-4ce0-adb6-08bb4bf5900e","text":"Reuters reporting (Feb 20, 2025) that Friedrich Merz had been targeted by a coordinated pro\u2011Russian disinformation network during the German election period.","date":"2025-02-20 00:00:00"},{"id":"48f96080-2ff8-4413-bc68-8d45573e0ebc","text":"Official public-health recommendations for widespread mask use (CDC guidance published April 3, 2020).","date":"2020-04-24 00:00:00"},{"id":"3da6910b-ebe5-4265-97f9-9acc53fc146d","text":"High-profile news coverage of medical oxygen shortages during the COVID-19 crisis (notably India, April 2021).","date":"2021-04-24 00:00:00"},{"id":"4af56b7a-2b18-4614-94db-f8baaa510c21","text":"2010 Ukrainian law under President Yanukovych formalized a non\u2011aligned/neutral foreign policy position.","date":"2010-07-24 00:00:00"},{"id":"9a68762b-1125-44bc-9ce8-f0066c271623","text":"Key NATO allies (notably Germany and France) opposed offering a Membership Action Plan for Ukraine at the 2008 Bucharest summit.","date":"2008-04-24 00:00:00"},{"id":"d8249f1a-5fe7-4e68-83d4-bdb52e664065","text":"Earlier (2017) Mawson pilot study reporting similar vaccinated vs unvaccinated differences","date":"2017-04-24 00:00:00"},{"id":"848bee8c-b8e4-4f15-b80e-8fe019b2f406","text":"CDC and FDA investigation and public reporting of myocarditis/pericarditis cases after mRNA vaccination","date":"2021-06-23 00:00:00"},{"id":"a5560f22-1608-4dc4-b5e9-cab6fa9a2dc0","text":"Japan suspends and inspects Moderna batches after discovery of foreign (stainless-steel/black) particles in vials","date":"2021-09-01 00:00:00"},{"id":"85aff665-3933-40c8-8e0c-8ff42c619c23","text":"NASA press release: \'Satellite Shows High Productivity from U.S. Corn Belt\' (Goddard/JPL coverage)","date":"2014-03-24 00:00:00"},{"id":"c58754c0-7dd2-4b01-acbc-26a6b8b444fd","text":"Publication of Guanter et al. (PNAS) 2014 paper showing space\u2011based chlorophyll fluorescence detects very high peak photosynthetic activity in the U.S. Corn Belt","date":"2014-03-24 00:00:00"},{"id":"d1fe315e-4c15-48ad-8d28-30a44de19d7f","text":"U.S. and international tightening of vehicle tailpipe standards and multipollutant rules (March 2024 announcements and implementation plans)","date":"2024-03-24 00:00:00"},{"id":"ba15b1b5-c381-44f2-8797-a55499eeb225","text":"WHO updates Global Air Quality Guidelines highlighting health risks from PM2.5, NO2 and other pollutants","date":"2021-09-24 00:00:00"},{"id":"b4c5dcd8-e49f-402f-8388-945f21eb7598","text":"Investigations (2023) and NGO press releases alleging hundreds of thousands of vehicles still use defeat devices or emit far more pollution in real-world driving than tests indicate","date":"2023-04-24 00:00:00"},{"id":"920ad18c-187e-4ebb-a482-e5b78de11c13","text":"2023 systematic reviews and studies linking long-term traffic-related air pollution to higher dementia and cognitive decline risks","date":"2023-04-24 00:00:00"},{"id":"51a3f058-2f29-41f8-b540-5710b0e086b4","text":"Japan finds black/foreign particles in Moderna vaccine vials; batches put on hold","date":"2021-09-24 00:00:00"},{"id":"d499ec0e-dd4f-4f89-9447-aa1acdbacf68","text":"Japan suspends use and recalls batches of Moderna COVID-19 vaccine after detection of black/foreign particles in vials (multiple reports in early September 2021).","date":"2021-09-01 00:00:00"},{"id":"8f5c4c1d-7b1a-4349-94b7-5266cd637e54","text":"UK Health Security Agency Technical Briefing (31 Dec 2021) and contemporaneous studies reporting reduced vaccine effectiveness against symptomatic infection with Omicron and partial restoration after boosters.","date":"2021-12-31 00:00:00"},{"id":"9a17ae4b-8609-4a0a-bf32-9f7f03f3c630","text":"Publication of Israeli retrospective study (Gazit et al.) reporting previously infected people had substantially lower risk of Delta reinfection than vaccinated, often cited as \\"natural immunity 13 times\\" stronger.","date":"2021-08-25 00:00:00"},{"id":"1d831c31-4014-4bf2-96b8-24fc74385832","text":"CDC / ACIP acknowledgement and published review of myocarditis/pericarditis cases following mRNA COVID-19 vaccination (summarized in MMWR).","date":"2021-06-23 00:00:00"},{"id":"a3704883-02a5-429f-ab67-0b072f6a01b7","text":"Zelensky\'s high-profile visit to Washington and his address to the U.S. Congress on 21 December 2022, in which he sought continued Western political and military support.","date":"2022-12-21 00:00:00"},{"id":"3a76259e-a1ef-4eb7-9ae8-cfd3f4fcc6f3","text":"President Zelensky presented a diplomatic \\"10-point peace formula\\" to world leaders at the G20 summit (Bali) on 15 November 2022, emphasising diplomatic channels and international guarantees as part of a peace framework.","date":"2022-11-15 00:00:00"},{"id":"1de97582-9f71-4971-ba7d-d8f87885f543","text":"Cabinet of Ministers Resolution No. 318 \u2014 allows territorial recruitment centers to serve summons regardless of registration","date":"2023-07-04 00:00:00"},{"id":"a26d82c6-5a58-4bc7-a110-3dcb3a82fc08","text":"Media coverage that Ukraine was urgently drafting reinforcements for a spring offensive","date":"2023-10-04 00:00:00"},{"id":"54354ec4-f53b-4fc6-ac36-595bbd78d95d","text":"Legal regime of martial law (authorises requisition of property for public needs)","date":"2022-03-03 00:00:00"},{"id":"8c8bf809-7919-42f2-a350-25605cb083b1","text":"Official and watchdog reporting noted prior government measures and decisions restricting visible Muslim dress in sporting contexts (the 2023/2024 debate and a government decision referenced in the 2023 International Religious Freedom report regarding hijab and athletes at Paris 2024).","date":"2024-05-24 00:00:00"},{"id":"3793e03c-452d-447e-b83d-c0cc8f5b89f7","text":"French authorities announced heightened security and a dedicated police escort for the 2024 Olympic torch relay, noting specific selection and protection measures.","date":"2024-01-22 00:00:00"},{"id":"c297fcb9-e09b-4143-822c-7e1d023e3454","text":"Longstanding French la\xefcit\xe9 law and past controversies (2004 ban on conspicuous religious symbols in public schools) and continuing national debates about secularism and visible religious signs.","date":"2004-03-24 00:00:00"},{"id":"27b9463c-05b7-4f0f-9497-2876314c5a04","text":"Annual Environmental Working Group \'Dirty Dozen\' coverage (media reporting on pesticide residues in produce, e.g., CNN coverage of 2023 list).","date":"2023-03-15 00:00:00"},{"id":"e5b05f6c-bc32-4482-bb81-53d40b39c6da","text":"Scientific reviews and peer\u2011reviewed articles showing plant\u2011derived bioactive compounds can modulate immune responses (scholarly reviews on medicinal plants and immunomodulation, e.g., PMC review).","date":"2021-04-24 00:00:00"},{"id":"8bfe5c6e-d1d4-4b6f-b140-776c1fa1d289","text":"World Health Organization declared the novel coronavirus outbreak a Public Health Emergency of International Concern (PHEIC).","date":"2020-01-30 00:00:00"},{"id":"ec8c5f4d-a867-484e-80ac-6c81a9283a59","text":"Public political messaging from the U.S. president and other high\u2011profile figures asserting the outbreak was \'under control\' (e.g., Feb 26, 2020), amid increasing partisan debate.","date":"2020-02-26 00:00:00"},{"id":"72bc7424-651a-4c9d-9be9-ad3292abcb3c","text":"EU guidelines on handling Schengen visa applications from residents of Crimea","date":"2014-05-24 00:00:00"},{"id":"434bf18b-493d-4770-9c92-1fe63ecadd04","text":"EU travel bans and asset freezes on individuals linked to the annexation of Crimea","date":"2014-03-24 00:00:00"},{"id":"4fee8636-34b2-4cc0-ba43-397c53506220","text":"Published scientific and regulatory reports from 2021 documented rare cases of facial paralysis (Bell\'s palsy) reported after COVID\u201119 vaccination.","date":"2021-04-24 00:00:00"},{"id":"f0412d5b-93cf-42bc-8fc5-f98147a51f9e","text":"WHO publication of regulatory considerations for mRNA vaccines noting evolving guidance (post\u20112020 development)","date":"2021-11-24 00:00:00"},{"id":"ac85ad4b-cc9f-4f44-beb5-ea48d8a52c1a","text":"Japan suspension/recall of several Moderna COVID\u201119 vaccine lots after foreign particles (stainless\u2011steel) were found","date":"2021-09-24 00:00:00"},{"id":"df930dd9-6b0b-4827-afe1-5894953e01bd","text":"Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained 24 sailors.","date":"2018-11-25 00:00:00"},{"id":"f0a85fe6-b900-4e90-8e66-572bdecff90a","text":"Ukraine imposed bans and broad restrictions on major Russian websites, social networks and media.","date":"2017-05-24 00:00:00"},{"id":"47a448fb-b4a0-46e6-991d-57294a9fee24","text":"Volodymyr Zelensky elected President of Ukraine in a landslide (defeating incumbent Petro Poroshenko).","date":"2019-04-21 00:00:00"},{"id":"7164afa4-2a31-4d20-b9a6-e502eff8a2fb","text":"Ecumenical Patriarchate granted autocephaly to the Orthodox Church of Ukraine.","date":"2019-01-05 00:00:00"},{"id":"4f3686e5-d765-4276-9e88-28dad9622072","text":"Ukraine deepened ties with the EU by signing/implementing the EU\u2013Ukraine Association Agreement after 2014 (formal post\u2011Euromaidan pivot toward the EU).","date":"2014-03-21 00:00:00"},{"id":"8cd87dbf-abf3-458f-830b-3e2098fc7257","text":"Wuhan authorities report a cluster of \'pneumonia of unknown cause\' linked to a seafood market (Huanan) and notify WHO","date":"2019-12-31 00:00:00"},{"id":"be6c17e9-3126-4a99-b1ca-12ba3fb536fe","text":"U.S. CDC establishes an Incident Management Structure and begins active monitoring of the outbreak","date":"2020-01-07 00:00:00"},{"id":"6fdc860b-5d9d-42dc-b86d-6db1f215ec58","text":"Wuhan Municipal Health Commission statement saying there was \'no obvious evidence\' of human-to-human transmission","date":"2020-01-03 00:00:00"},{"id":"63dc2a08-412c-4d37-aca8-5ea865e1119a","text":"OSCE/Representative condemns killing of journalist Oles Buzina in Kyiv (16 April 2015)","date":"2015-04-16 00:00:00"},{"id":"00abef23-136a-4f82-b966-5af27dd83e4e","text":"Human Rights Watch: \'Ukraine: Rebel Forces Detain, Torture Civilians\' (reporting on abuses in 2014)","date":"2014-08-28 00:00:00"},{"id":"08cafcf3-2032-4f80-b02a-ba109f879f0f","text":"IAEA Director General Rafael Mariano Grossi confirmed \'physical impact\' from drone strikes at the Zaporizhzhia Nuclear Power Plant and called the incident \'serious\', noting hits on reactor-related structures.","date":"2024-04-07 00:00:00"},{"id":"87c66622-6253-4bb6-bc16-c751d87a2c32","text":"Reuters and other outlets reported that a Ukrainian drone crashed near the Zaporizhzhia nuclear plant in early April 2023 (reported 5 April 2023 by Russian media), indicating prior drone activity in the plant vicinity.","date":"2023-04-05 00:00:00"},{"id":"ade5df5c-bee8-45e8-a236-f3de837262e5","text":"IAEA and Reuters reporting documented earlier damage to off-site power infrastructure and backup power lines near Zaporizhzhia (notably on 7 September 2022), which affected the plant\'s power connections.","date":"2022-09-07 00:00:00"},{"id":"1d8c5c78-ea5d-491b-aaeb-1e9eb3d23fe6","text":"Reuters special report (Oct 2014) documenting flaws and gaps in Ukraine\'s investigations into the Maidan shootings","date":"2014-10-24 00:00:00"},{"id":"d7049be6-afc0-4f30-b738-0644dd7cfd9d","text":"Deaths of Serhiy Nigoyan and Mikhail Zhiznevsky on Hrushevskoho Street during Euromaidan (initial chaotic reporting)","date":"2014-01-22 00:00:00"},{"id":"7c9ba322-a838-4167-bcd3-92788ba88530","text":"Academic and analytical publications debating shooter locations and responsibility for the \'snipers\' massacre (analysis circulated online in 2014)","date":"2014-04-24 00:00:00"},{"id":"81607614-7e18-493b-80e8-1de64c0a754c","text":"Lancet Planetary Health commentary \'COVID\u201119, wet markets, and planetary health\' highlighting zoonotic risk at live\u2011animal markets","date":"2020-06-24 00:00:00"},{"id":"ff6e86bf-c27b-43f3-81c9-562060321b74","text":"Consumer watchdog reporting and class-action lawsuits against alkaline bottled-water marketing (coverage of multiple 2017\u20132018 suits)","date":"2018-04-24 00:00:00"},{"id":"9e8e0f65-b1dc-463d-b3b2-8da8207caf71","text":"Scientific/dental research highlighting that some bottled beverages (including waters) have low pH and can be erosive to teeth (JADA/published research)","date":"2015-04-24 00:00:00"},{"id":"8c67b977-c7a3-46a1-b02e-bcc7e336a6e5","text":"Axios reporting (Aug 18, 2025) that White House officials asked Ukrainian counterparts whether Zelensky would wear a suit for his Aug 18 meeting with President Trump.","date":"2025-08-18 00:00:00"},{"id":"353854f8-f85b-4d64-b740-e832c88a249a","text":"Publication of Northwestern-led JCI study (April 27, 2023) showing unresolving ventilator-associated secondary pneumonia was linked to mortality in severe pneumonia including COVID-19.","date":"2023-04-27 00:00:00"},{"id":"8f013e9d-8c5a-4353-8c8d-a79d4122b7e3","text":"Pandora Papers disclosure linking Zelensky and associates to offshore companies","date":"2021-10-03 00:00:00"},{"id":"ea97d934-450c-42f9-ba96-faa10aae7eb7","text":"News reporting of French aid totals to Ukraine (official French figures circulated)","date":"2024-03-03 00:00:00"},{"id":"9ed42510-3de7-453e-b41f-dbb975483b27","text":"Public statements by Russian officials and the State Duma in Feb\u2013Mar 2022 pushing narratives that Zelensky had \'refused\' Minsk or was open to concessions, and urging Russia to legitimise breakaway regions","date":"2022-02-18 00:00:00"},{"id":"675bdb85-f697-400f-8c7f-ed638f176b42","text":"Zelensky\'s March 8, 2022 address to the UK Parliament / House of Commons in which he appealed for stronger Western action (including implied criticism of slow/no\u2011fly\u2011zone decisions)","date":"2022-03-08 00:00:00"},{"id":"974fb635-cfd1-4b4c-8f0e-5fc7a4dd25b3","text":"Russian recognition of the self\u2011proclaimed Donetsk and Luhansk People\'s Republics (DPR/LPR) and related escalatory diplomacy in late February 2022","date":"2022-02-21 00:00:00"},{"id":"b6dce954-c6ce-479b-8ca4-eccecbf931a2","text":"U.S. FDA issues consumer warning against using veterinary ivermectin to treat or prevent COVID\u201119 (consumer update)","date":"2021-04-08 00:00:00"},{"id":"4bd27717-a688-4f9f-b97e-50fc5fdbd956","text":"Pierre Kory testimony to U.S. Senate Homeland Security committee advocating ivermectin as an \'early treatment\' (video + written testimony)","date":"2020-12-08 00:00:00"},{"id":"e629fd6e-2664-4427-806f-f053affa3ea2","text":"WHO identified vaccine hesitancy as a top-10 global health threat (2019) and warned about misinformation undermining vaccination programs","date":"2019-04-24 00:00:00"},{"id":"281fac33-7327-4d27-9270-fa396b74f594","text":"Gunmen attacked polio vaccination teams (and their police escorts) in the region, including a December 2019 attack in Pakistan that killed police escorting vaccinators","date":"2019-12-16 00:00:00"},{"id":"4bb77a37-80cf-4bc6-b14e-c32ddaed77ab","text":"Several European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine over reports of rare blood clots","date":"2021-03-11 00:00:00"},{"id":"81a32455-c62a-4641-9d18-34a0807e49af","text":"Multiple incidents of healthcare workers being spat at, harassed or attacked in India during the early COVID-19 pandemic","date":"2020-04-02 00:00:00"},{"id":"9f1162d3-4ee2-45b1-a94b-ea7e6ed8a86e","text":"Hungary and other neighbouring states publicly protested Ukraine\'s education/language measures and Hungary blocked NATO-Ukraine commission meetings in protest (April 2018).","date":"2018-04-23 00:00:00"},{"id":"1ef7e7ad-9c74-469e-b411-3852cc693702","text":"Nationwide implementation phase began for the education reform shifting instruction toward Ukrainian (mass implementation from 1 September 2018).","date":"2018-09-24 00:00:00"},{"id":"5ff7751a-3797-475b-ab31-608a4dc57d3b","text":"Verkhovna Rada adopts the Law \'On ensuring the functioning of Ukrainian as the state language\' strengthening Ukrainian\'s role in public life.","date":"2019-04-25 00:00:00"},{"id":"6e3b4786-415f-41fb-a8fd-11b0bfc99338","text":"Council of Europe\'s Venice Commission issues an opinion scrutinizing the 2019 language law (plenary opinion published December 2019).","date":"2019-12-24 00:00:00"},{"id":"70c094cd-4b0c-4efe-b783-c1d86fbd71a9","text":"Strong 2015\u20132016 El Ni\xf1o and record global temperatures (reported in early 2017)","date":"None"},{"id":"921da37f-25ef-46f2-9bbb-85d9c79411b9","text":"Hurricane Milton made landfall in Florida and produced a real outbreak of tornadoes on Oct 9, 2024, causing widespread damage and intense media attention.","date":"2024-10-09 00:00:00"},{"id":"1509ac98-4f23-4822-828c-092344605aa7","text":"Deputy speaker Andrey Kozenko publicly claimed about 120,000 Ukrainians had visited Crimea, representing about 10% of the peninsula\'s tourists.","date":"2016-06-24 00:00:00"},{"id":"59a4e5cb-be6d-4294-8ad4-9b78c05f450d","text":"RIA Novosti published a report quoting Crimean officials that border crossings had to increase personnel because of a \'flood of vacationers from Ukraine\'.","date":"2016-06-24 00:00:00"},{"id":"e82b7ca8-3c7a-4a8a-88a6-bdbc535b0a1d","text":"Boryspil International Airport workers staged strikes and picket lines over dismissals in early March 2015.","date":"2015-03-13 00:00:00"},{"id":"6452efc0-72d1-45b6-99ce-9f5ad68a2f87","text":"Recent intense fighting over airports (e.g., Donetsk airport battle in Jan 2015) made \'airport\' a charged and symbolic setting in Ukrainian public discourse.","date":"2015-01-22 00:00:00"},{"id":"1d7c8c65-fed9-4af9-b8a7-583efe0c156a","text":"On-camera exchange at Boryspil: Poroshenko told protesting workers \'Don\'t raise your voice at me, or else you\'ll quickly be taken out,\' which some outlets portrayed as a threat of arrest.","date":"2015-03-19 00:00:00"},{"id":"eb18cff0-382d-421f-a524-e99822ad547e","text":"United Nations senior officials (Secretary\u2011General and OHCHR) publicly called for an independent investigation into the civilian killings seen in Bucha.","date":"2022-04-04 00:00:00"},{"id":"a821f2f7-8a95-48e1-8289-86096d5c2221","text":"Russia announced it would ask the U.N. Security Council to meet over what Moscow called \'provocations\' in Bucha and denied responsibility, urging investigation of alleged staging.","date":"2022-04-04 00:00:00"},{"id":"317b32c6-c05b-44d3-8cad-09ffa5710de3","text":"International media published graphic on\u2011the\u2011ground footage and reports from Bucha (journalists and outlets entering the town after Russian withdrawal) documenting corpses and destruction.","date":"2022-04-03 00:00:00"},{"id":"f64eec97-d14d-4a81-af07-8f416d6890d9","text":"ICC Prosecutor Karim A. A. Khan announces opening of a formal investigation into the situation in Ukraine, but as of early April had not published a specific, on\u2011the\u2011ground Bucha investigative timeline.","date":"2022-03-02 00:00:00"},{"id":"a544e0c1-ed7e-491e-bdc6-50b79d4bf79a","text":"Ukrainian government forces launched operations and reclaimed parts of Mariupol in May\u2013June 2014 amid heavy fighting.","date":"2014-06-24 00:00:00"},{"id":"8c59f029-fa4c-424c-8712-979198438f2c","text":"Battle of Ilovaisk (August 2014) and open-source analyses showing use of Russian tanks and weapons in eastern Ukraine.","date":"2014-08-24 00:00:00"},{"id":"36aa4449-8818-4c98-90bc-fd2a05ea538a","text":"Formation and deployment of the Azov volunteer battalion in May\u2013June 2014, with operations around Mariupol.","date":"2014-05-24 00:00:00"},{"id":"eb8db62e-651f-4c8e-b669-48a2c8d291e2","text":"IPCC Special Report on Global Warming of 1.5\xb0C (SR15) emphasizing land-based mitigation options","date":"2018-10-08 00:00:00"},{"id":"277714f9-0805-48b1-aba6-c95997c08bbd","text":"Launch of the Trillion Trees initiative (WWF, BirdLife International, WCS)","date":"2017-11-15 00:00:00"},{"id":"0418b276-b637-4fb1-93a0-12fc0f74d214","text":"Heightened fiscal pressure and passage of an IMF\u2011compliant state budget in December 2015 (public calls for a \'fiscally sustainable\' budget; budget package passed late December 2015)","date":"2015-12-24 00:00:00"},{"id":"3c8a7cb1-f0ce-46d3-ab60-c06d45d6ed83","text":"Parliament adopted the emergency law \\"On Prevention of Financial Catastrophe...\\" that amended social protection rules and changed the structure/timing of some child benefits (law adopted 27 March 2014; some provisions effective later)","date":"2014-03-27 00:00:00"},{"id":"c3f09444-e6e0-4d2a-bee9-15b6356fc404","text":"FDA authorization for consumer genetic testing expanded in 2018 (e.g., March 6, 2018 FDA action on 23andMe), signalling regulatory acceptance of DTC genetic information.","date":"2018-03-06 00:00:00"},{"id":"10aa326f-e579-4f6c-bd1a-8aff80170494","text":"Publication of a clinical review: \'MTHFR genetic testing: Controversy and clinical implications\' (Aust Fam Physician, 2016) documenting widespread promotion of MTHFR testing by alternative practitioners and pharmacies.","date":"2016-04-24 00:00:00"},{"id":"c3172225-3693-4c6f-9238-7d90edfa3626","text":"German federal prosecutors publicly announced the arrest of three Ukrainian nationals suspected of planning parcel/explosive attacks and other acts of sabotage in Germany and Switzerland.","date":"2025-05-14 00:00:00"},{"id":"a86f7c23-4981-42fa-b161-51fc78cdad88","text":"Public warnings from German domestic-intelligence officials in late 2024 that Russian sabotage and intelligence activity targeting European logistics and critical infrastructure were an ongoing threat.","date":"2024-10-24 00:00:00"},{"id":"f508aab5-c242-4d88-8ad5-2a725c9a324b","text":"News coverage noting a recent string of fires and security incidents at European courier and freight depots in months prior to the arrests.","date":"2025-05-24 00:00:00"},{"id":"97b8430d-9275-46e1-8b79-3fb241ad08be","text":"Commander\u2011in\u2011Chief Valerii Zaluzhnyi publishes a high\u2011profile piece and interview in The Economist outlining that the war has entered \'positional\'/stalemate phase and calling for major technological/strategic changes","date":"2023-11-01 00:00:00"},{"id":"ee067d00-c0b5-47d3-9029-8fd5486855f9","text":"Western press coverage highlights growing tensions and public debate over the relationship between President Zelensky and Commander Zaluzhnyi amid frustration over the stalled counteroffensive","date":"2023-11-08 00:00:00"},{"id":"48b3571a-6ac3-44f5-9fe0-6c14f6140147","text":"Official national exit\u2011poll consortium (Razumkov/NI Consortia: DIF, KIIS, Razumkov) published large\u2011margin results showing Volodymyr Zelensky\u2019s landslide victory on April 21, 2019.","date":"2019-04-21 00:00:00"},{"id":"ce9b33b9-e85b-4046-ba77-e5f1868c6e56","text":"Pew Research Center survey (released July 29, 2024) showing wide partisan divisions on U.S. responsibility and support for the war in Ukraine.","date":"2024-07-29 00:00:00"},{"id":"19027ae8-4e58-4278-9f4f-f2109718cadf","text":"House Speaker Mike Johnson repeatedly delayed or conditioned votes on Ukraine aid and publicly signaled limited appetite for further Ukraine funding among House Republicans in spring 2024.","date":"2024-04-24 00:00:00"},{"id":"2e4da640-6c78-49c3-9e26-c35f40b8370e","text":"Republican infighting and public GOP messaging in early April 2024 explicitly citing polls and voter fatigue to justify delaying or opposing further Ukraine assistance.","date":"2024-04-05 00:00:00"},{"id":"97ee6eff-e540-44c5-90bc-350b44a7f2d1","text":"Joint Investigation Team (JIT) announced criminal investigation findings implicating a Buk missile from territory held by pro-Russian separatists (September 2016)","date":"2016-09-28 00:00:00"},{"id":"114d8811-9be0-485b-93ce-1556c4af6efd","text":"Media coverage of shifting Russian public opinion (Levada/Moscow Times report, Feb 2020) showing changes in who Russians say is responsible","date":"2020-02-14 00:00:00"},{"id":"aebfeb31-a7cc-40f5-85e1-ab17a9a81027","text":"Great Barrington Declaration (Oct 4, 2020) calling for \\"focused protection\\" and opposing lockdowns","date":"2020-10-04 00:00:00"},{"id":"f94dfaef-eb1f-479e-8c8d-c45f782c213e","text":"WHO interim guidance advised masks mainly for symptomatic people and healthcare settings (interim guidance PDF)","date":"2020-01-29 00:00:00"},{"id":"5a9a532b-3469-4108-a503-a8dee755d225","text":"CDC publicly recommended cloth face coverings for the general public (press release)","date":"2020-04-03 00:00:00"},{"id":"3d1e5490-2d11-4983-a889-245fb01aab25","text":"China temporarily bans wildlife trade nationwide in response to the novel coronavirus (reported by Reuters)","date":"2020-01-26 00:00:00"},{"id":"3140119f-8d47-4304-9e60-70eda24c916b","text":"IPBES 2019 Global Assessment report on biodiversity and ecosystem services publicly released","date":"2019-05-24 00:00:00"},{"id":"d4169ee9-5b6b-437d-8a9c-d6bda51ffd94","text":"IARC (WHO cancer agency) issued a press release classifying processed meat as \'carcinogenic to humans\' (Group 1).","date":"2015-10-26 00:00:00"},{"id":"d578f1e2-0edf-442f-8167-9730b07540ed","text":"WHO/IARC published clarifying Q&A and statements explaining that Group 1 classifies hazard (evidence of carcinogenicity) but does not indicate the magnitude of risk relative to other Group 1 agents (e.g., smoking).","date":"2015-10-26 00:00:00"},{"id":"80c98feb-aa13-4dbf-8e34-68d40b5993ae","text":"International Rescue Committee (IRC) and other NGOs issued warnings and reports (late Sep 2023) expressing concern about legal uncertainty and the future of support for Ukrainians in Poland.","date":"2023-09-28 00:00:00"},{"id":"97efe8fc-86dc-4752-8d07-932a84a1c46b","text":"Polish government spokesman Piotr (Piotr) M\xfcller publicly said Poland will likely not extend special support measures for Ukrainian refugees into 2024.","date":"2023-09-19 00:00:00"},{"id":"0baeefc1-adc3-4f98-b95a-d541cccf69ad","text":"Poland\'s Social Insurance Institution (ZUS) suspended childcare/family benefit payments for thousands of Ukrainian refugees who had left Poland.","date":"2023-08-23 00:00:00"},{"id":"3afa542c-0bdb-4bfe-99c5-ec4f8c07f3eb","text":"Multiple news outlets (e.g., Kyiv Independent) and regional reporting reproduced Polish officials\' remarks that support may be curtailed in 2024, producing headline-driven coverage in mid-September 2023.","date":"2023-09-19 00:00:00"},{"id":"8a6ad661-4866-4e53-a06e-fc4454d38987","text":"2015 U.S. Dietary Guidelines Advisory Committee recommended removing a quantitative limit on dietary cholesterol","date":"2015-02-24 00:00:00"},{"id":"1cccfa74-2117-468a-aefa-213b8307ea3d","text":"CDC/ACIP MMWR update on myocarditis after mRNA COVID\u201119 vaccination and policy guidance (MMWR report / ACIP review)","date":"2021-07-09 00:00:00"},{"id":"32db54f1-b369-4ca0-8b04-d474a4145f4f","text":"Renaming of Dnipropetrovsk to \'Dnipro\' under Ukraine\'s decommunization/renaming process","date":"2016-05-24 00:00:00"},{"id":"f464d68b-a2a1-43a1-b569-4d332d007b45","text":"Adoption of Ukraine\'s 2017 education law strengthening the use of Ukrainian in schools","date":"2017-09-24 00:00:00"},{"id":"558ff771-454a-4ef9-b800-b3b910ece8ee","text":"Pro\u2011Russian unrest and separatist seizures in eastern Ukraine (including activity in Dnipropetrovsk region)","date":"2014-04-24 00:00:00"},{"id":"51c347f2-e521-4dcb-ac82-57eae349c8e0","text":"Norwegian review of deaths in very frail elderly after Pfizer vaccination (widely reported mid\u2011January 2021)","date":"2021-01-15 00:00:00"},{"id":"455b2dd1-c3a1-474a-ab22-e9dfcad0d66d","text":"FDA issues Emergency Use Authorization (EUA) for the Pfizer\u2013BioNTech COVID-19 vaccine","date":"2020-12-11 00:00:00"},{"id":"e113e22b-2707-4663-a22b-b4c0f7bd2f1a","text":"First U.S. COVID-19 vaccinations administered and public rollout begins","date":"2020-12-14 00:00:00"},{"id":"03751e65-146b-4456-8dc1-c7c36cbb9273","text":"Press conference by Reserve Colonel Mykhailo Slobodianiuk in Lviv (March 11, 2015) in which he discussed adding additional grades/medals to the Order for Courage rather than annulling it.","date":"2015-03-11 00:00:00"},{"id":"d46d0c0f-98c6-4033-a3bc-33944da10810","text":"Widespread toppling and removal of Soviet-era monuments across Ukraine during 2013\u20132014 (including multiple high-profile Lenin statue removals).","date":"2014-09-24 00:00:00"},{"id":"099063c7-f4d6-452a-96b7-3cfbec499f70","text":"Target Malaria (a Gates Foundation\u2011supported research consortium) conducted the first small\u2011scale releases of genetically modified sterile male Anopheles mosquitoes in Bana, Burkina Faso (July 2019).","date":"2019-07-01 00:00:00"},{"id":"db5fae7e-79b7-4b72-ac6f-4886e201988a","text":"Oxitec conducted pilot releases and community engagement in the Florida Keys (2021) and faced local protests over planned releases of genetically modified Aedes aegypti.","date":"2021-04-24 00:00:00"},{"id":"5182eb84-9e91-4051-97a4-a787da6915f3","text":"Bill & Melinda Gates Foundation publicly funded Oxitec to develop genetically engineered mosquitoes for malaria control (reported 2018).","date":"2018-06-21 00:00:00"},{"id":"4e319c0c-fa97-49bd-8d1f-e297eb183d06","text":"Controversy over Oxitec field trials in Jacobina, Brazil (2013\u20132015) culminated in 2019 scientific disputes and papers suggesting rare viable progeny/hybridization, prompting public debate.","date":"2019-09-24 00:00:00"},{"id":"c1787c96-2590-4891-b3f5-806faabaad21","text":"ACAPS / briefings and national reports show large concentrations of Ukrainians remaining in Polish cities (May 2022 briefing)","date":"2022-05-25 00:00:00"},{"id":"e00f7faa-5d4d-4e79-8298-ad7c22d4d2c8","text":"Early UNHCR / IOM intention surveys (April\u2013May 2022) reporting many refugees\' immediate plans and diverse intentions to stay or return","date":"None"},{"id":"11a40aaf-f706-40cf-82a9-1a19cf63c3d5","text":"Poland introduces PESEL registration for Ukrainian arrivals, enabling access to services","date":"2022-03-16 00:00:00"},{"id":"861b0fc8-2713-435b-9bd0-27cef9356563","text":"EU Council adopts Temporary Protection Directive for people fleeing Ukraine","date":"2022-03-04 00:00:00"},{"id":"4e99c43a-52d4-4367-8e23-2a3c8bd45a8f","text":"Polish border guard reports over 2 million refugees have entered Poland since the invasion","date":"2022-03-18 00:00:00"},{"id":"8f90dc85-17db-45b6-861f-a79a145cbdfd","text":"China\'s documented prior practice of rejecting incoming grain shipments for reasons such as unapproved GMO varieties or contamination (e.g., several U.S. corn cargoes rejected in 2013).","date":"2013-12-04 00:00:00"},{"id":"3293095e-b726-41fe-9e73-a2632666ed8a","text":"Ukrainian inspectors / Consumer Protection Agency reported a small detection of pests/nematodes in certain fields designated for export.","date":"2016-08-30 00:00:00"},{"id":"1063765a-03a7-4469-a982-301b089febc9","text":"Human Rights Watch documents abuses by volunteer battalions and excessive detentions by Ukrainian security services","date":"2015-04-24 00:00:00"},{"id":"222d75b6-ccc3-4eff-bdfa-f2c7aed90156","text":"OSCE Special Monitoring Mission (SMM) publishes thematic reporting and daily monitoring documenting civilian casualties and incidents in Donetsk and Luhansk","date":"2017-04-24 00:00:00"},{"id":"ea73dc47-9ebe-4398-8854-410ce744a766","text":"Ukrainian officials and ombudsman reports attributing water supply interruptions in parts of Donetsk and Luhansk to artillery damage and actions by occupying forces (2014\u20132015)","date":"2015-04-24 00:00:00"},{"id":"d37b5259-c261-4f6f-9fb2-82a898d4a789","text":"Power cuts and shelling halted pumping stations and water supply in Luhansk (summer 2014)","date":"2014-07-24 00:00:00"},{"id":"a7a9313b-3363-4c37-9221-69cecc02c7b7","text":"U.S. Secretary of State Antony Blinken visits Kyiv and reaffirms support but makes no commitment on NATO membership","date":"2021-05-06 00:00:00"},{"id":"8e8d6642-8a2b-41f0-877a-508b282f4111","text":"Ukraine amends its constitution to enshrine EU and NATO membership aspirations (constitutional change enters into force)","date":"2019-02-19 00:00:00"},{"id":"51c342aa-f495-447c-a741-0f62d5867280","text":"Public opposition from major NATO members (e.g., Germany and France) to immediate Ukrainian accession around the 2008 summit","date":"2008-04-01 00:00:00"},{"id":"eae9effd-0408-4194-a055-2a43ac1db606","text":"Ukrainian officials publicly warned that individuals who visited temporarily occupied Crimea or separatist\u2011controlled Donbas without Kyiv\'s permission would be banned from observing Ukrainian elections","date":"2018-03-24 00:00:00"},{"id":"322841cd-72a9-4285-a807-cc62848423ce","text":"Ukraine\'s Central Election Commission had publicly registered hundreds of international observers ahead of the March 31, 2019 presidential vote","date":"2019-03-15 00:00:00"},{"id":"0af56191-0e0f-4fe2-b9e2-e821fd6db35c","text":"Verkhovna Rada passed amendments banning citizens of the Russian Federation from serving as official election observers in Ukraine","date":"2019-02-07 00:00:00"},{"id":"f8673471-5bf7-4c53-affb-4caa3100de22","text":"A specific German activist/politician (Andreas Maurer, Die Linke) who had previously visited occupied Ukrainian territories and held pro\u2011Russian positions was not accredited as an observer","date":"2018-11-11 00:00:00"},{"id":"5c352b85-72a5-4fe0-b247-e193012c1069","text":"Publication of small, legitimate human moringa studies for other outcomes (e.g., 2021 randomized trial on glycemic control)","date":"2021-04-24 00:00:00"},{"id":"4323d9ee-e5be-4bde-bd6b-7fa02e8e16ef","text":"Peer-reviewed research and clinical-trial literature on helminth (worm) immunomodulation and \'helminth therapy\' for autoimmune conditions (reviews and trials published in mid-2010s)","date":"2015-04-24 00:00:00"},{"id":"167cd11a-7bd8-448b-8a6e-495bbd0f3fa5","text":"Analysts and Ukrainian officials reported a sharp projected fall in spring sowing area (up to ~39% decline) because of the invasion, threatening the next harvest.","date":"2022-03-15 00:00:00"},{"id":"bb9d0cc8-29c7-493d-a706-4ce83cc9c18d","text":"Russian naval blockade of Black Sea ports blocked Ukrainian grain shipments, threatening export revenue and leaving grain on vessels.","date":"2022-03-21 00:00:00"},{"id":"3a9774e6-10f2-477a-ab6a-cca67b1c16fc","text":"Sanctions and the war disrupted fertilizer and fertilizer-ingredient supplies (Russia/Belarus are major suppliers), raising alarms about reduced crop yields globally and in Ukraine.","date":"2022-03-23 00:00:00"},{"id":"441e1bc0-70fe-44eb-ad34-0223b99e3ca4","text":"Reports from newly occupied areas (e.g., Kherson) of empty stores, local food shortages and looting after Russian forces captured territory.","date":"2022-03-01 00:00:00"},{"id":"2f871919-d116-40c0-a287-e1eba8a48b43","text":"Reports of long queues as Crimeans applied for Russian passports (coverage March 19\u201320, 2014)","date":"2014-03-20 00:00:00"},{"id":"917b61ae-ede9-4e14-9d70-7ec40dc181b3","text":"Defection of Ukraine navy commander Denys Berezovsky to pro\u2011Russian Crimean authorities (early March 2014)","date":"2014-03-02 00:00:00"},{"id":"59154926-987c-4187-b208-3ac364e6899a","text":"Verkhovna Rada vote to repeal the 2012 language law (widely reported as a \'ban\' on Russian)","date":"2014-02-23 00:00:00"},{"id":"2e0c40f0-7009-4245-826e-b1c693e22a37","text":"Deadly clashes and Trade Unions House fire in Odesa","date":"2014-05-02 00:00:00"},{"id":"5822f032-feb0-4fca-a9fe-b0db5146f9f1","text":"Reports of attacks, intimidation and disappearances of activists in Crimea during the March 2014 takeover","date":"2014-03-14 00:00:00"},{"id":"442ca6ad-3fc9-40f8-b29e-f5ebd7e26aaa","text":"Euromaidan protests, violent escalation and ouster of President Yanukovych","date":"2014-02-24 00:00:00"},{"id":"3269616a-cc39-4a25-bafb-f0ad27cb1b53","text":"CDC lab alert language recommending adoption of multiplex assays that can \'facilitate detection and differentiation of SARS\u2011CoV\u20112 and influenza viruses\'","date":"2021-07-21 00:00:00"},{"id":"9ca8200d-6dc1-4f59-9e0b-189a5928ba6d","text":"CDC Lab Alert announcing it will withdraw its request for EUA for the CDC 2019\u2011nCoV Real\u2011Time RT\u2011PCR Diagnostic Panel","date":"2021-07-21 00:00:00"},{"id":"f7e271ea-0a8c-411a-a7ec-e034b971ea88","text":"OSCE Special Monitoring Mission reports documenting weapons, movements and indicators of cross-border support to armed groups in Donbas","date":"2015-04-24 00:00:00"},{"id":"5bc21564-4705-4f88-b5a6-3c76db8c6999","text":"FIFA precedent of suspending a national association for government interference (Kuwait suspended)","date":"2015-10-16 00:00:00"},{"id":"3d6ca9ba-8938-41e5-a235-f30ae9f1bb9e","text":"UEFA opened fresh disciplinary proceedings and charges related to crowd disturbances and racist behaviour involving Dynamo Kyiv (follow-up enforcement actions)","date":"2016-02-24 00:00:00"},{"id":"8d744fb7-6fd9-4ba1-811c-9de7080dc2ec","text":"UEFA bans Crimean clubs from Russian competitions and declares Crimea a \'special zone\' for football","date":"2014-12-04 00:00:00"},{"id":"6c0d5bf5-6470-434d-a633-f24e61c3ddf5","text":"Publication of Lennerz et al. survey of 2,029 self\u2011identified carnivore dieters (Current Developments in Nutrition)","date":"2021-12-24 00:00:00"},{"id":"6210f009-184f-443b-b61e-725c791e1e92","text":"WHO highlights a multi\u2011country validation study of the OptiBP smartphone blood\u2011pressure application","date":"2023-04-21 00:00:00"},{"id":"af232223-fe84-4fea-9b31-bba82843063a","text":"European Society of Hypertension working\u2011group statement on cuffless blood\u2011pressure devices (review and guidance)","date":"2022-06-16 00:00:00"},{"id":"dc9e2ee2-6a52-44e1-bf09-83ac361b0ae3","text":"Peer\u2011reviewed npj Digital Medicine study (CamBP/OptiBP) reports ISO\u2011aligned accuracy in select populations","date":"2023-04-17 00:00:00"},{"id":"54f3a33a-e560-4653-8566-3949400427bb","text":"Approaching 30th anniversary of the Chornobyl disaster and official commemorations (Poroshenko declared 2016 \'Year of Remembrance\' for liquidators and victims)","date":"2015-12-14 00:00:00"},{"id":"92622502-9d1f-489c-91fb-e43fc2acf742","text":"President Petro Poroshenko vetoed law No.2093 and returned it to parliament with proposals","date":"2016-04-12 00:00:00"},{"id":"cf603f33-34e6-4183-a115-e3ac3538ba4b","text":"Verkhovna Rada (Ukrainian parliament) passed draft law No.2093 restoring certain Chernobyl benefits","date":"2016-03-17 00:00:00"},{"id":"e7875114-649f-4e5c-b759-b863b64561a7","text":"Publication of in vitro research showing antiviral activity of Melissa officinalis extracts against some influenza strains (e.g., lab studies on H1N1 / H9N2)","date":"2016-04-24 00:00:00"},{"id":"2acea521-b0fc-48ed-88e2-b8f6da9aa180","text":"Putin signed decree requiring buyers from \'unfriendly\' countries to pay for gas in roubles.","date":"2022-03-31 00:00:00"},{"id":"48218272-d962-4750-b578-752d4240e2e3","text":"Austrian government statement: Russian gas still flowing while Austria scrambles for alternatives.","date":"2022-04-27 00:00:00"},{"id":"93c43d6c-88d3-4dad-b18a-dd5596a062c4","text":"OMV (Austrian energy firm) said it had initial contact with Gazprom about rouble payment demands.","date":"2022-04-01 00:00:00"},{"id":"901c9158-8dd1-451e-89bc-9b3e6f7044ad","text":"OPEC (led by Saudi Arabia) decided not to cut output, triggering a sharp oil price fall","date":"2014-11-27 00:00:00"},{"id":"32022d9c-2c83-48a5-bc04-c8cc87a593d0","text":"Kremlin and Putin publicly blamed Western sanctions and falling oil prices for the rouble slump","date":"2014-12-18 00:00:00"},{"id":"07a56859-a3c7-4523-b943-001bfa91cf5a","text":"Reports Russia spent tens of billions defending the rouble in 2014 (estimates ~USD 80bn)","date":"2014-12-24 00:00:00"},{"id":"a390a2b6-e764-4521-bf88-b41e34e69af1","text":"Emergency Bank of Russia decision: key rate hiked to 17% as rouble plunged","date":"2014-12-16 00:00:00"},{"id":"16158f34-8015-44f8-a7dc-0e8a0536b905","text":"Western sanctions on Russia expanded through 2014 over Ukraine/Crimea","date":"2014-07-31 00:00:00"},{"id":"ddac4342-724b-4057-83bb-d517c82627bd","text":"NOAA press release and reports (Jan 2024) documenting 2023 as one of the warmest years on record while noting the roles of greenhouse gases and natural variability","date":"2024-01-12 00:00:00"},{"id":"0c4010c9-6257-4e87-bc84-a4b250e3d55b","text":"Peer\u2011reviewed opinion piece (Sherwood & Forest) in Atmospheric Chemistry and Physics (2024) discussing remaining uncertainty in equilibrium climate sensitivity (ECS)","date":"2024-04-24 00:00:00"},{"id":"1ca309d5-e3fc-451b-af76-e44786b894f6","text":"Investigative reports (April 2024) documenting widespread climate misinformation and enforcement failures on short\u2011form social platforms such as TikTok","date":"2024-04-24 00:00:00"},{"id":"39da4c3a-adf9-48d1-af3a-5afc6e3ac57e","text":"Republican-led U.S. congressional hearings on climate science that featured skeptical expert witnesses and took place across March\u2013April 2024","date":"None"},{"id":"1c5e2b7f-64ac-4508-957b-adfe716ec6e6","text":"Ukrainian parliament actions in September 2014 approving laws on special status/self-governance and amnesty provisions related to Donbas","date":"2014-09-24 00:00:00"},{"id":"5470ae14-4639-43f5-9525-c3f9199e1085","text":"Minsk II agreement (Package of Measures) contained an instruction to \'provide pardon and amnesty\' for persons involved in events in parts of Donetsk and Luhansk","date":"2015-02-12 00:00:00"},{"id":"a87df052-6792-4ff4-91c3-24581c4c4a31","text":"High-profile interviews and statements by Nadiya Savchenko urging peace talks and negotiation with separatists","date":"2016-05-24 00:00:00"},{"id":"68f92636-4e3a-467c-8168-cd1c2eb155c5","text":"Nadiya Savchenko\'s high-profile release and return to Ukraine in a prisoner swap (pardoned and flown back)","date":"2016-05-25 00:00:00"},{"id":"1e919862-a394-4d0e-8f88-dbbc7c1f3be9","text":"German Communist Party (DKP) launched a petition asking the Bundestag and government to lift sanctions that hinder exchange of medical supplies and cooperation during the COVID-19 crisis.","date":"2020-03-26 00:00:00"},{"id":"068432ed-79d3-4c40-b986-0b9f52b2b854","text":"Russian leadership/public diplomacy pushed a narrative that international sanctions hampered pandemic response \u2014 including Putin\u2019s appeals at G20/UN fora to suspend some sanctions for humanitarian reasons in late March 2020.","date":"2020-03-26 00:00:00"},{"id":"92de102e-5285-491c-92af-7f876326a055","text":"EU/commission reporting showed a sharp rise in applications by Ukrainians for Romanian citizenship in 2014\u20132015","date":"2015-01-24 00:00:00"},{"id":"9312344f-c2bd-4729-abeb-af172a7a75cb","text":"Local media reports of a \'Constituent conference\' of an \\"Assembly of the Romanians of Bukovina\\" in Chernivtsi allegedly deciding on autonomy","date":"2015-07-24 00:00:00"},{"id":"21f04535-1899-4f5e-a6ac-c45b5f9a784e","text":"Russian officials warn of a sharp increase in shelling in the Donbas and publicly blame Ukrainian forces (Russian statements about escalated shelling)","date":"2022-02-18 00:00:00"},{"id":"fd3b3d2d-9a82-43f6-b5e1-36eb81fa8ce2","text":"Moscow says a projectile fired from Ukraine destroyed a Russian border facility (Rostov region)","date":"2022-02-21 00:00:00"},{"id":"affc1bd7-931a-41ac-8a4b-149e1962f5f7","text":"Russia launches a full-scale invasion of Ukraine (24 February 2022); Ukrainian leaders publicly vow to repel and drive back Russian forces","date":"2022-02-24 00:00:00"},{"id":"98d9b1be-a091-42ae-a824-4add22826725","text":"Peer-reviewed laboratory study found a banana-derived lectin (BanLec) inhibits HIV replication in vitro","date":"2010-03-19 00:00:00"},{"id":"686243dd-c98a-4534-ab8e-261dce5d0be3","text":"Publication of peer-reviewed reviews and preclinical studies summarizing DMSO\'s immunomodulatory and in vitro anticancer effects (science literature available by 2020)","date":"2020-04-24 00:00:00"},{"id":"73f2581b-78ea-4073-b522-f122ba21942b","text":"1978 FDA approval of RIMSO-50 (a 50% DMSO solution) for intravesical use in interstitial cystitis","date":"1978-04-24 00:00:00"},{"id":"ff5616f8-a79b-47de-9ac9-273996d50120","text":"International Coral Reef Initiative (ICRI) published an update stating that bleaching-level heat stress impacted 84% of the world\u2019s coral reefs.","date":"2025-04-23 00:00:00"},{"id":"ad5984ee-a3ad-4ec4-b4ce-e130c1f67d09","text":"Wagner Group rebellion and armed column movement near Voronezh","date":"2023-06-24 00:00:00"},{"id":"28e8f541-e8c0-48fb-bce9-3fb0dd399191","text":"Explosions/drone incidents over central Moscow (including near the Kremlin) and official accusations","date":"2023-05-03 00:00:00"},{"id":"a742fb45-a461-43bc-b476-456e8ad028bc","text":"Fuel tank fire at a Rosneft oil depot in Voronezh region","date":"2023-06-24 00:00:00"},{"id":"cf4cac70-1fe0-44ec-afd7-3d70e3d867fa","text":"CDC One Health guidance noting most emerging infectious diseases are zoonotic","date":"2019-04-24 00:00:00"},{"id":"456df9fe-30b3-4415-9a39-52064e0cf327","text":"Two Ukrainian servicemen (including Dmytro Krasnohrud) were killed near Zaitseve on July 13, 2020; bodies were later handed over \u2014 a real battlefield casualty incident.","date":"2020-07-13 00:00:00"},{"id":"ca91c933-ac95-4353-bb69-1d9f393a79c8","text":"Mainstream health articles and reviews (e.g., Healthline overview updated June 29, 2023) summarizing promising lion\u2019s mane research for cognition and Alzheimer\u2019s","date":"2023-06-29 00:00:00"},{"id":"b17c0ea0-45a5-493f-91f7-b3daebbaf959","text":"2016 mouse study (Tsai\u2011Teng et al.) showing erinacine\u2011A enriched Hericium mycelia reduced amyloid pathology in APP/PS1 Alzheimer\u2019s model mice","date":"2016-04-24 00:00:00"},{"id":"91ad4b59-ea33-46ae-8242-9b46c76403f7","text":"July 20, 2021: FDA warning letter(s) and subsequent press attention about dietary\u2011supplement sellers making disease claims for mushroom products (including lion\u2019s mane)","date":"2021-07-20 00:00:00"},{"id":"098aa029-ec8e-4883-85bf-bc46490bd379","text":"Russia imposes bans on Ukrainian food imports after 2014 sanctions","date":"2014-08-24 00:00:00"},{"id":"42d52141-5e88-4a4d-962a-82996e2d62a9","text":"Sharp GDP contraction during 2014\u20132015 amid conflict and economic shock","date":"2015-04-24 00:00:00"},{"id":"7da97a72-cae2-46bf-99b9-531f8be4f1b1","text":"Provisional application of the EU\u2013Ukraine Association Agreement including the DCFTA","date":"2016-01-01 00:00:00"},{"id":"1106203c-1f11-4aac-adb2-d43dd7539134","text":"September 2021 reports of black/foreign particles found in some Moderna vials in Japan and large batches paused","date":"2021-09-01 00:00:00"},{"id":"34c1ed12-9336-4757-84db-c8b93a27ce8e","text":"Center for Economic Strategy published an assessment placing Ukraine\'s economic losses from the temporary occupation of Crimea at about $135 billion.","date":"2021-08-09 00:00:00"},{"id":"6f28a2f2-e539-4dee-9855-e6a65ab9e0a6","text":"U.S. EPA and other regulators/extension services have published fact sheets explaining corn gluten meal is a food/feed product, classified as minimum\u2011risk for pesticide use, and that its rodenticidal effects depend on a physical/dehydrating mode of action not applicable to humans (EPA fact sheet Nov 2002; Cornell IPM profile).","date":"2002-11-01 00:00:00"},{"id":"af890a05-332e-45e2-b324-34148f8f8edf","text":"IPCC Synthesis Report released attributing recent warming predominantly to human activities","date":"2023-03-20 00:00:00"},{"id":"15aaf9a0-6288-49ed-8e08-6988a0f54955","text":"Publication of Nicola Scafetta et al. paper in 2023 arguing a larger role for the Sun in recent climate change","date":"2023-06-14 00:00:00"},{"id":"49acb213-a59d-42fa-9fc4-f619d8791ba4","text":"Local reporting: large pro\u2011Ukraine demonstrators in Kherson outnumbered pro\u2011Russian activists (Svoboda Square, Kherson)","date":"2014-03-22 00:00:00"},{"id":"45e42270-f505-45f5-b918-6b0cda07bcfa","text":"BBC analysis \'Ukraine underplays role of far right in conflict\' documenting Azov and use of Nazi\u2011linked symbols (Wolf\'s Hook) in 2014","date":"2014-12-13 00:00:00"},{"id":"7870243e-8aad-4f25-8742-7767ce72c40c","text":"BBC profile of the ultra\u2011nationalist Right Sector and its role in the 2014 Maidan protests","date":"2014-04-28 00:00:00"},{"id":"0d9fc4a0-5fcb-4860-9631-c7f6c920d7d6","text":"Randomized, double\u2011blind clinical trial (Koytchev et al., Phytomedicine 1999) found topical lemon balm extract reduced symptoms and accelerated healing of herpes labialis (cold sores).","date":"1999-04-24 00:00:00"},{"id":"7e25a76a-37bc-4cb4-991b-75ca8cb4db06","text":"FDA warning letter to Applied Health Solutions (Oct 22, 2021) cites Grapefruit Seed Extract product claims including effectiveness against \'herpes\' and other viral diseases.","date":"2021-10-24 00:00:00"},{"id":"4454f0a8-ec22-4cb4-ac30-1ae88c0d8026","text":"UK Ministry of Defence announced it would send Challenger 2 tanks to Ukraine along with armour\u2011piercing rounds that contain depleted uranium.","date":"2023-03-21 00:00:00"},{"id":"50270f49-40d5-4d8a-865b-719e919b380d","text":"Historical precedent: Reporting and investigations documenting previous UK/US use of depleted uranium munitions in conflicts (Iraq, Balkans) were widely available.","date":"None"},{"id":"c14565f6-e945-46f4-a565-20182e7bfb5f","text":"Russian President Vladimir Putin publicly condemned the UK move and warned Moscow would be \'forced to react\', calling the ammunition a weapon with a \'nuclear component\'.","date":"2023-03-21 00:00:00"},{"id":"fb35e2a8-7820-467f-9f02-501f5db2d4ea","text":"Parliamentary elections scheduled for October 26, 2014 (the \'day of silence\' was October 25), creating heightened public attention and low tolerance for reports of interference.","date":"2014-10-25 00:00:00"},{"id":"b2a9a693-2f1e-4e6a-979d-58fca7b6cc79","text":"Publication of Nerem et al. (PNAS) showing recent acceleration of global sea-level rise (2018)","date":"2018-02-27 00:00:00"},{"id":"d901f911-ecfa-4d16-b71b-5d064dca9f25","text":"Release of the Bureau of Meteorology / CSIRO \'State of the Climate 2018\' report","date":"2018-12-20 00:00:00"},{"id":"21308ad2-ed8c-47ad-91ea-7d57d9647a29","text":"Marin County measles cases and public reporting on vaccine exemptions (2014\u20132015)","date":"2015-01-28 00:00:00"},{"id":"bd61c7cb-9e37-4312-a09a-5d9c22333eae","text":"Publication of Nevison & Parker county-level analysis showing plateau/decline in ASD prevalence among wealthy white California counties","date":"2020-11-24 00:00:00"},{"id":"545e7117-772c-412b-97f7-6e5cfd8279e3","text":"Ukraine adopts law and official policies on \'temporarily occupied territories\' and Donbas reintegration (2018)","date":"2018-02-24 00:00:00"},{"id":"9541024e-78b4-4a7d-9a0e-e5d0a23547c6","text":"Putin decree simplifying acquisition of Russian citizenship for residents of Donetsk and Luhansk (passportisation of Donbas)","date":"2019-04-24 00:00:00"},{"id":"d8922da7-0392-43c3-9ff9-6852d5dea24c","text":"Graphic reporting and images of women giving birth in bomb shelters, basements and damaged maternity hospitals (including Mariupol) during early 2022 attacks","date":"2022-04-07 00:00:00"},{"id":"2e715436-fede-4a04-baa0-2533450430f0","text":"Reporting that Ukraine was a major international destination for commercial surrogacy and fertility tourism","date":"2022-06-24 00:00:00"},{"id":"2bef7be2-37fe-4ae5-b341-834d95218f44","text":"President Petro Poroshenko granted Ukrainian citizenship to three foreign-born technocrats nominated for ministerial posts ahead of a 2014 cabinet vote.","date":"2014-12-02 00:00:00"},{"id":"825d43c3-608a-4dec-9135-afab70108a23","text":"Media coverage highlighted several foreign\u2011born ministers and officials (e.g., Natalia Yaresko, Aivaras Abromavicius) being granted citizenship to take government posts in late 2014.","date":"2014-12-02 00:00:00"},{"id":"22fc4451-39a9-429d-b999-ce653efa4de7","text":"Former Georgian president Mikheil Saakashvili was granted Ukrainian citizenship and appointed governor of Odesa region (later stripped and restored at different times).","date":"2015-05-30 00:00:00"},{"id":"9ff538ac-8666-450c-a6f0-7b725a52bbcc","text":"Minsk II agreement sets political steps for Donbas (Package of measures)","date":"2015-02-12 00:00:00"},{"id":"f5b27817-344c-4cd3-9b2e-52fdcecb069c","text":"OSCE deploys the Special Monitoring Mission (SMM) to Ukraine","date":"2014-03-24 00:00:00"},{"id":"1d0ef9c4-3fa5-499b-842d-f166010dea71","text":"UN General Assembly adopts Resolution 68/262 affirming Ukraine\'s territorial integrity","date":"2014-03-27 00:00:00"},{"id":"87e7d153-c4a2-4274-ae4d-e0c5a470e7fe","text":"UN Secretary\u2011General issues statements urging restraint on Crimea/Ukraine","date":"2014-03-10 00:00:00"},{"id":"5d91096d-88e2-463c-b965-592ebc181a91","text":"Russia summoned the German ambassador after Berlin\'s public statements on the Navalny case","date":"2020-09-08 00:00:00"},{"id":"3ab432b3-1325-4c73-923c-07971b892798","text":"Aleksey Navalny airlifted from Omsk to Berlin for medical treatment","date":"2020-08-22 00:00:00"},{"id":"bc17fe6c-6f26-4257-9fea-1bde09ac2b15","text":"Germany handed laboratory test data and facilitated OPCW technical assistance regarding Navalny\'s poisoning","date":"2020-09-24 00:00:00"},{"id":"8e6dfbb8-7653-496d-a494-14f06c6a9619","text":"Chancellor Angela Merkel said Navalny\'s poisoning was an attempted murder and called on Russia to explain","date":"2020-09-03 00:00:00"},{"id":"8e6ffcb5-2935-4da8-a2f6-37ced68f793b","text":"World Bank reported sharp GDP and industrial-production declines linked to the 2014 conflict","date":"2014-10-24 00:00:00"},{"id":"6329a629-8785-48c9-a520-51679aa960e5","text":"Avdiivka Coke and Chemical Plant heavily shelled and production repeatedly disrupted","date":"2015-04-24 00:00:00"},{"id":"4aef59f0-2f8a-49ee-aa33-c47e66af31b0","text":"Large share of Donbas industrial capacity cut off after 2014 fighting and separatist control","date":"None"},{"id":"2602f358-ce54-463f-aa87-f29b88d699bf","text":"Japan paused use of a large Moderna vaccine lot after pharmacists found black/foreign particles in vials (investigations later identified contaminants and some lots were recalled); mainstream outlets (BBC, others) reported the pause in Sept 2021.","date":"2021-09-24 00:00:00"},{"id":"99054d96-5995-400d-a538-9d426409a010","text":"Francis Fukuyama interview with Radio Svoboda published containing a cautious line that \'the issue that Ukraine will face in the future is the possibility that not 100 percent can be liberated\'","date":"2023-10-21 00:00:00"},{"id":"aad7e35d-8b80-43cd-b1f2-98b0b18220d7","text":"\u2018Support Free Ukraine\u2019 demonstration outside the Ukrainian embassy in Sofia","date":"2014-01-23 00:00:00"},{"id":"e9e5908f-edb5-4e1c-96b6-ae50ee50f43a","text":"Public rallies by the nationalist Ataka party in 2014 (large street demonstrations)","date":"2014-09-28 00:00:00"},{"id":"2ce347ab-01ce-4b4e-8d58-fc0e04cf8b5a","text":"Reporting on Bulgaria\u2019s divided stance over Crimea and visits by Bulgarian politicians","date":"2014-04-10 00:00:00"},{"id":"7907ff43-49d7-47f8-9ce0-20f40065d975","text":"Reports (2010\u20132011) linking the Pandemrix H1N1 influenza vaccine to increased narcolepsy cases in children in Finland and Sweden and subsequent EMA/GSK reviews","date":"None"},{"id":"4c6e1739-a25f-40f8-a4ea-6364e45bb003","text":"June 2013: Japan\'s Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine after reports of alleged adverse events","date":"2013-06-24 00:00:00"},{"id":"dd58e7fd-f420-4f6b-aefc-7a5dca83b488","text":"Public-health data and surveillance reports (UKHSA, ONS and CDC studies in 2021) showed waning vaccine effectiveness and higher absolute numbers of cases or deaths among vaccinated people in some age groups\u2014driven by high vaccine coverage and timing\u2014during late 2021.","date":"2021-11-24 00:00:00"},{"id":"456d3b04-8421-4838-812d-1f8e88ef43be","text":"Reports of contamination in vaccine batches in Japan (stainless-steel/foreign particles in Moderna vials) and subsequent recalls/suspensions during September\u2013October 2021.","date":"2021-09-24 00:00:00"},{"id":"e2d23983-7667-4870-a6cd-a7d2d20d2a5e","text":"International media reporting of Russia\'s seizure of three Ukrainian naval vessels and detention of crew (wounded sailors reported)","date":"2018-11-26 00:00:00"},{"id":"41a2a877-f1fd-4480-8fdb-278293229f68","text":"Coverage and analysis noting EU reluctance or political obstacles to imposing new Russia sanctions after the Kerch incident","date":"2018-12-24 00:00:00"},{"id":"6833344f-17e5-418f-b9ef-61fdf01954e9","text":"G7 foreign ministers\' joint statement expressing \'utmost concern\' about Russian actions in the Kerch Strait","date":"2018-11-26 00:00:00"},{"id":"069aad17-1ac4-4f2c-9eb3-8efe16201b92","text":"IMF and international lenders publicly warned Ukraine to accelerate reforms and tackle corruption to preserve investor confidence.","date":"2015-02-24 00:00:00"},{"id":"11f16641-f62e-4de3-81ce-e859e15762af","text":"Kyiv issued formal sanctions on Russian-owned banks (blocking capital outflows and imposing restrictions).","date":"2017-03-16 00:00:00"},{"id":"d73cc3b8-a1d8-4ac5-b390-0139a4ecdb07","text":"Sharp falls in foreign direct investment and international capital flows to Ukraine following the 2014 crisis (documented in UNCTAD/World Investment reports).","date":"2016-04-24 00:00:00"},{"id":"85fadf01-a4ad-4ed0-96a4-462d215554db","text":"Nationalisation of PrivatBank, Ukraine\'s largest commercial bank.","date":"2016-12-19 00:00:00"},{"id":"9f7f3797-8aaa-4201-81c8-c842f8a53406","text":"Reports that thousands of Mariupol residents, including children, were forcibly deported or taken through \'filtration\' after Russian forces captured parts of the city","date":"2022-03-20 00:00:00"},{"id":"1e88b0e6-9700-46f4-b372-9747c0551bcf","text":"Red Cross / national Red Cross societies publicized medical aid, psychosocial support and programs for displaced Ukrainian children and families in early 2022","date":"2022-04-24 00:00:00"},{"id":"26c377ea-9aa0-4ae5-a5ff-c70b5b9b037b","text":"Red Cross-led evacuation attempts to reach and extract civilians from besieged Mariupol failed or were halted amid heavy fighting","date":"2022-03-06 00:00:00"},{"id":"14b0574a-5497-4884-bec6-520c0f7e187b","text":"Bombing of the Donetsk Academic Regional Drama Theatre in Mariupol that sheltered civilians (including children), producing graphic images and uncertainty about many casualties","date":"2022-03-16 00:00:00"},{"id":"eb701ce1-cfe6-4f8f-9fa3-89c1820a7a0e","text":"ICRC activated a Central Tracing Agency (family\u2011tracing) bureau to collect information about missing people and reconnect families after the escalation in Ukraine","date":"2022-03-24 00:00:00"},{"id":"290f965d-5be0-464d-bdb8-163c06a62841","text":"CDC and advocacy groups warn that pandemic-related delays in cancer screening and care could produce downstream increases in advanced cancers and mortality","date":"2021-06-30 00:00:00"},{"id":"9171e567-8474-4dc0-aa10-9b5430fa19c7","text":"CDC releases provisional life expectancy estimates for 2021 showing a sharp decline in U.S. life expectancy","date":"2022-08-31 00:00:00"},{"id":"7b92fc65-a796-422b-9443-374ef57581b5","text":"OSCE SMM reporting of civilian casualties at/near checkpoints in Donetsk/Luhansk (2019 summaries)","date":"2019-12-26 00:00:00"},{"id":"7f30264e-f0a8-4066-90b6-0e6cdef570cb","text":"Karlivka (Karlivka/Karlivka area) checkpoint ambush and fatalities","date":"2014-05-23 00:00:00"},{"id":"488f65ef-7ae2-4e77-b989-9babfbb5e805","text":"Volnovakha bus attack near a Ukrainian checkpoint (passenger bus hit)","date":"2015-01-13 00:00:00"},{"id":"7b0ceb79-47c5-4f55-9476-3abeaeefd7d9","text":"Earlier (March\u2013April 2014) incidents where pro\u2011Russian activists raised Russian flags on government buildings in eastern Ukrainian cities (e.g., Kharkiv, Donetsk) were widely photographed and reported.","date":"2014-03-01 00:00:00"},{"id":"1f294a78-91a8-4caa-9aa1-e9b461ad1138","text":"Official visit of Bulgarian President Rosen Plevneliev to Kyiv (July 7\u20138, 2015) \u2014 Bulgarian flags and official decorations were displayed in central Kyiv for the visit.","date":"2015-07-07 00:00:00"},{"id":"982cb1ee-fd21-48f1-8a3d-bfd40e3429d6","text":"President Barack Obama met and publicly expressed support for Petro Poroshenko in meetings around mid-2014 (e.g., June 4, 2014 meeting during Poroshenko\'s European visits).","date":"2014-06-04 00:00:00"},{"id":"2d919daa-b594-4887-9ca5-f369a56561fe","text":"Poroshenko repeatedly and publicly vowed to restore Ukrainian control over Crimea (kept the topic in headlines through 2015).","date":"2015-02-23 00:00:00"},{"id":"2f078d96-b20e-4413-8048-be0643f7af7d","text":"Deputy Foreign Minister Olena Zerkal interviewed by the Financial Times, saying the EU delay on visa\u2011free travel \'feels like some kind of betrayal\'","date":"2016-12-16 00:00:00"},{"id":"c9b71fee-b2bd-4e51-bf29-7781c2e90c97","text":"EU\u2011Ukraine summit and statements in late November 2016 confirming Ukraine had met visa\u2011liberalisation criteria but formal implementation remained pending","date":"2016-11-24 00:00:00"},{"id":"b3aea6b4-75f7-4ddf-a535-2c6ca0fba585","text":"CDC review and guidance on COVID-19 vaccine administration errors and deviations","date":"2021-07-24 00:00:00"},{"id":"39db8ebf-a9e7-441c-886d-4ce08a5dc110","text":"Foreign particles found in Moderna vials in Japan leading to batch suspension and recall","date":"2021-09-24 00:00:00"},{"id":"c5c28d20-4097-4e54-a9b0-4de1dcaaa54e","text":"EU REACH restrictions on hazardous substances in tattoo inks came into force and ECHA held an industry webinar explaining implementation.","date":"2022-01-05 00:00:00"},{"id":"1cbab3a8-5125-41f5-a425-e491a7ed893e","text":"Peer-reviewed analysis identified hexavalent chromium (a known carcinogen) as an impurity in some tattoo inks and discussed dermal exposure risk.","date":"2018-04-24 00:00:00"},{"id":"00e0bfe7-02d5-4c5b-8823-5a7b0a8cafe9","text":"FDA warning letter (Ambaya Gold, Dec 5 2023) naming products promoted with claims that clinoptilolite (zeolite) \'removes heavy metals\' and warning the company about unapproved/misbranded therapeutic claims.","date":"2023-12-05 00:00:00"},{"id":"a7e56323-9b45-4421-9a5f-ac7b55680d47","text":"UNHCR report documents extensive \'collective centres\' for internally displaced people in Ukraine","date":"2014-08-24 00:00:00"},{"id":"81e24f29-a832-4e4a-a3f3-9ab6863e259b","text":"Widespread, dramatic coverage of refugee \'camps\' in Europe (Roszke, Hungary) during 2015 crisis","date":"2015-09-11 00:00:00"},{"id":"abd88480-a561-41ac-9ac5-e3ff578e9f8a","text":"Regulatory findings and widespread media coverage in March 2021 that the AstraZeneca vaccine was associated with very rare clotting events (VITT) and subsequent safety reviews.","date":"2021-03-24 00:00:00"},{"id":"3e77f882-da44-4f36-827d-0efb5922246f","text":"Ukraine\'s state rail company suspends passenger and cargo train services to Crimea","date":"2014-12-26 00:00:00"},{"id":"fb2493b5-37a0-4fd7-be13-669c7eca68f0","text":"U.S. provides non\u2011lethal aid including Humvees to Ukraine (March 2015 announcement)","date":"2015-03-11 00:00:00"},{"id":"c164484f-230a-409f-9758-d9661a1dfdbc","text":"Western-led training and re-tooling exercises with Ukrainian forces reported (early 2016 coverage)","date":"2016-01-24 00:00:00"},{"id":"eea65218-f61a-4b52-b873-6be6bacaa67d","text":"U.S. State Department approves sale of Javelin anti-tank missiles to Ukraine","date":"2017-12-22 00:00:00"},{"id":"b69d524c-6494-4c32-8608-033f7422210b","text":"Reports that separatists and Russian\u2011backed forces captured equipment from Ukrainian units","date":"2014-07-29 00:00:00"},{"id":"1216cb70-b558-48b1-a035-c50f00f83f02","text":"Early\u2011post\u2011Crimea (March 2014) statements by Transnistrian officials (e.g., Mikhail Burla) requesting accession to Russia and broader media discussion that Transnistria might be a candidate for \u2018the next Crimea.\u2019","date":"2014-03-18 00:00:00"},{"id":"29d71415-c815-4a13-bb80-4bc83e611763","text":"Reports of foreign/black particles found in some Moderna vials in Japan, triggering recalls and headlines (September 2021).","date":"2021-09-24 00:00:00"},{"id":"d4cd80eb-eaac-49af-b68c-dc1b44a1d8c1","text":"Early pregnancy\u2011safety surveillance of mRNA COVID\u201119 vaccines reported no safety signal in vaccinated pregnant persons (v\u2011safe/pregnancy registry; NEJM preliminary findings, June 2021).","date":"2021-06-24 00:00:00"},{"id":"7c04ae5d-4a31-4b8d-9b2b-48941ac82d8e","text":"UN OCHA Situation Report No.5 documenting rising fatalities and urban combat around Donetsk","date":"2014-08-01 00:00:00"},{"id":"317ef0dc-064a-4eec-ad55-b8802b8eaa8b","text":"Ukrainian and international leaders publicly warned that explosives or sabotage could threaten Dnipro dam infrastructure (public warnings and diplomatic appeals, Oct 2022)","date":"2022-10-19 00:00:00"},{"id":"de1aef64-ff12-45b5-af12-ecc0c0e0dd6a","text":"Russian forces captured the Kakhovka (Nova Kakhovka) hydroelectric power plant on the Dnipro early in the 2022 invasion","date":"2022-02-24 00:00:00"},{"id":"0f88ce35-bc1d-4580-9fa2-5a62b51ad3ff","text":"Satellite imagery and reporting showed Russian forces building pontoon/ferry crossings across the Dnipro in Kherson region (summer 2022)","date":"2022-07-29 00:00:00"},{"id":"0a3948be-fa4e-4cc4-acb8-1d150f116106","text":"Reports that the Russian-held Nova Kakhovka dam was damaged by shelling (reported in Russian media) and experienced operational problems","date":"2022-11-06 00:00:00"},{"id":"c80d4a05-71f3-4de0-99b0-46eefea2b55b","text":"Ukraine stopped water flow to Crimea via the North Crimean Canal after Russia\'s 2014 annexation (closure and water cut-offs widely reported)","date":"2014-05-24 00:00:00"},{"id":"f234ae8b-1609-4236-bc79-01d2349b02fa","text":"Public political downplaying of COVID-19 risk (early statements by high-profile politicians, March 2020)","date":"2020-03-24 00:00:00"},{"id":"21599273-58f4-4ab5-8c60-a98236a967d2","text":"Stanford (Santa Clara) seroprevalence preprint (Bendavid et al.) suggesting many more infections and lower IFR (April 2020)","date":"2020-04-24 00:00:00"},{"id":"2102a9f4-f2ce-437a-9e8a-bf94b26d2e85","text":"Release of the NIPCC report \'Climate Change Reconsidered\' (Heartland Institute / Nongovernmental International Panel on Climate Change)","date":"2009-04-24 00:00:00"},{"id":"25d1f51d-e212-4b08-afdc-65ff45ee0f4d","text":"Jacques Attali\'s well\u2011known public profile (former special adviser to President Fran\xe7ois Mitterrand, prolific author and commentator) and periodic controversial commentary on euthanasia/ageing (often cited out of context).","date":"None"},{"id":"e458de25-c9df-47f0-afe6-1796e559fcb1","text":"World Economic Forum launched the \'Great Reset\' initiative (public messaging beginning June 2020).","date":"2020-06-03 00:00:00"},{"id":"e6db8dbb-15ae-4e34-8aca-fdf86f5b9ebd","text":"Poroshenko cut short his Davos visit to return to Ukraine amid a \'worsening situation\', as reported by multiple outlets.","date":"2015-01-20 00:00:00"},{"id":"c527f6cf-f471-410a-825d-64d88a963398","text":"Students and activists disrupted and booed high\u2011profile figures at Zurich university events earlier (notably Sepp Blatter at ETH Zurich in November 2014).","date":"2014-11-05 00:00:00"},{"id":"ee5d46b3-019c-4079-a705-d2dfc0d8995b","text":"Protests and demonstrations around the World Economic Forum in Davos (anti\u2011WEF/anti\u2011globalisation actions) were occurring and widely reported in mid\u2011January 2015.","date":"2015-01-18 00:00:00"},{"id":"011dd188-f1c1-4ef7-9cf4-b23255a9d81d","text":"WHO mission on tuberculosis control and human rights in Ukraine","date":"2015-04-24 00:00:00"},{"id":"ae04373a-93b5-47da-9a0f-0e8036c84fd6","text":"IMF approves a US$17.5 billion Extended Fund Facility for Ukraine","date":"2015-03-11 00:00:00"},{"id":"a31e1259-d292-49ef-94fa-29c7e8cd09db","text":"Euromaidan protests escalate and government change in Kyiv","date":"2014-02-22 00:00:00"},{"id":"e79b0b35-8d39-4282-b94a-f53bee81a959","text":"Recent public casualty statements by Ukrainian leadership (e.g., Zaluzhnyi referenced cumulative losses) created uncertainty about true figures.","date":"2022-08-22 00:00:00"},{"id":"fd77cdad-ac76-4700-a8ca-f00ee60425bd","text":"High-profile extreme-event attribution coverage just before the campaign date: World Weather Attribution/Oxford analysis (published 2 August 2019) concluding the 2019 European heatwave was made far more likely by human-caused climate change.","date":"2019-08-02 00:00:00"},{"id":"e2a21ea9-3308-432d-8ebb-36f2b2454894","text":"Early March 2019 tornado outbreak across the U.S. Southeast (notably March 3, 2019) produced lethal tornadoes and extensive coverage of storm damage.","date":"2019-03-03 00:00:00"},{"id":"646a3db1-5b56-4be1-9ced-855abb1cfc03","text":"Publication/coverage of studies emphasizing that the Medieval Warm Period was not globally synchronous (e.g., Columbia Climate School coverage of regional MWP findings)","date":"2015-12-04 00:00:00"},{"id":"744b28c1-e44c-4d91-afb4-3e9432206ea4","text":"IPCC Fifth Assessment Report (AR5) release, including past\u2011millennium reconstructions","date":"2013-09-24 00:00:00"},{"id":"b13b8ba6-a597-4fbb-8b0f-2e3bd1ab8cf9","text":"Longstanding local debate in Lviv about the fate of Soviet-era memorials and periodic proposals to repurpose or relocate elements of the Hill/Monument of Glory (discussion ongoing for years prior to 2017).","date":"None"},{"id":"cd094e65-a841-43b3-9e0d-41d503722dad","text":"Passage and signing of Ukraine\'s \'decommunization\' laws that required removal of communist symbols and monuments.","date":"2015-05-15 00:00:00"},{"id":"bdbc72ed-e397-4bcd-b6eb-2f5ea4b6c477","text":"Lviv City Hall press office statement denying plans to dismantle the monument, noting the site was fenced off because it was in poor condition and that a committee would make recommendations.","date":"2017-07-11 00:00:00"},{"id":"782598c4-3b71-498b-91e6-1b5df6772bd2","text":"Russian airborne assault and fighting at Hostomel (Antonov) Airport","date":"2022-02-24 00:00:00"},{"id":"bc6770da-14e1-4f86-9e0c-dafc0b7fa65a","text":"Ilovaisk encirclement (\'Ilovaisk cauldron\') and heavy Ukrainian losses in August 2014","date":"2014-08-24 00:00:00"},{"id":"ab1b4aca-b869-4d1e-9822-0200cd4f4d27","text":"Authoritative trackers (e.g., New York Times / Johns Hopkins) showed a sustained period of daily new-case counts above 100,000 in early\u2013mid November.","date":"2020-11-12 00:00:00"},{"id":"a5930607-f04e-48b2-b3e8-851792a5f598","text":"IPCC Sixth Assessment Report (Working Group I) release asserting strong human attribution for recent warming","date":"2021-08-09 00:00:00"},{"id":"5a4298c2-30c7-43d1-ad99-2ff20e2ef3f8","text":"Publication and media coverage of studies showing \'global greening\' connected to CO2 fertilization (widely reported from 2016 onward)","date":"2016-04-24 00:00:00"},{"id":"b002bc7e-9203-4656-84b6-0a42fd4eea6d","text":"Japan suspended and recalled Moderna COVID-19 vaccine batches after foreign particles were found (September 2021)","date":"2021-09-24 00:00:00"},{"id":"90ef5e33-2377-4289-845e-3349a31525bd","text":"FDA approval of JYNNEOS (smallpox and monkeypox vaccine)","date":"2019-09-24 00:00:00"},{"id":"1fc8ca06-ea64-4a71-96be-945d2e3a2895","text":"NTI published summary/report of the 2021 tabletop exercise","date":"2021-11-24 00:00:00"},{"id":"2a0a6670-7ba1-4904-9910-0e88353ed5b8","text":"Historical arson attacks and anti-refugee incidents in Germany (e.g., Bautzen fire of Feb 2016)","date":"2016-02-24 00:00:00"},{"id":"0edbfb46-f456-4efb-881f-2b34fc87b18d","text":"Court orders and litigation over giving ivermectin to hospitalized COVID\u201119 patients (notably a widely reported Ohio case)","date":"2021-09-07 00:00:00"},{"id":"7abbfcf9-ee39-451c-a75a-35ff181a3d15","text":"Authoritative explanations that FDA does not regulate the practice of medicine / off\u2011label prescribing (Congressional Research Service and longstanding FDA position, 2021)","date":"2021-04-24 00:00:00"},{"id":"0c91468a-2a3c-435c-a993-912dda8a7cdf","text":"European Union places Vladislav Surkov on sanctions list in response to the Crimea/Ukraine crisis (EU decisions, March 2014).","date":"2014-03-21 00:00:00"},{"id":"9f70852a-2701-4ba9-9d9d-97b130038454","text":"Victoria Nuland\'s public visits and meetings with Ukrainian leaders and opposition figures in Kyiv (February 2014).","date":"2014-02-07 00:00:00"},{"id":"49e89fad-7de0-4303-8429-105554aaaf25","text":"NATO Wales Summit adopts the Readiness Action Plan and publicly increases reassurance measures for eastern allies (Wales Summit Declaration, September 2014).","date":"2014-09-05 00:00:00"},{"id":"70fab0a5-9570-4e18-aa9b-2a40a0ffb0dd","text":"Minsk II \'Package of measures\' signed, setting a ceasefire and political roadmap for Donbas.","date":"2015-02-12 00:00:00"},{"id":"9c35ac88-ea62-4815-b760-c00c9c418ca3","text":"Self-proclaimed Donetsk and Luhansk \'people\'s republics\' declared independence and maintained de facto control over parts of Donbas.","date":"2014-05-24 00:00:00"},{"id":"d340a967-11d6-4e32-9f59-5546d3b71998","text":"EU establishes the East StratCom Task Force (EUvsDisinfo) to counter Russian disinformation (and documents active Russian information operations).","date":"2015-09-28 00:00:00"},{"id":"530384a0-da14-4c11-95b2-1d4601ad9ad9","text":"Volodymyr Zelensky stars as a fictional president in the TV series \'Servant of the People\' (premiered 2015).","date":"2015-04-24 00:00:00"},{"id":"ab204757-11fb-43a8-aa32-1e0a1b33be3f","text":"UNHCR and humanitarian organizations published operational data and guidance in March 2022 showing how displaced Ukrainians were being registered and assisted across multiple countries (including coordination with Russian Red Cross in Russia).","date":"2022-03-24 00:00:00"},{"id":"2cceeef1-da92-4d2f-bda6-aacbc8937b8f","text":"Russian Human Rights Commissioner Tatyana Moskalkova publicly denied forced transfers and Russian media cited large numbers of Ukrainians having gone to Russia (statements reported in mid\u2011April 2022).","date":"2022-04-12 00:00:00"},{"id":"9543425d-8280-44dc-aab9-eeef9487b257","text":"U.S. State Department and other governments maintained high-level \'do not travel\' advisories for Ukraine","date":"2023-06-24 00:00:00"},{"id":"e9c1f3d6-96e3-4d8e-b076-fdbba6676c29","text":"UNHCR published guidance and cautioned about voluntary return amid ongoing safety, protection and infrastructure concerns in 2023","date":"2023-06-24 00:00:00"},{"id":"f58e959d-deed-43a8-af64-556af3a0477d","text":"Kyiv\'s mayor reported that a large share of the city\'s population fled after the Russian invasion","date":"2022-03-10 00:00:00"},{"id":"3f30c01d-d5b9-4759-8745-26f91c87bb64","text":"Widespread Russian strikes damaged Ukraine\'s energy infrastructure, causing prolonged blackouts in Kyiv","date":"2022-10-27 00:00:00"},{"id":"c56cb11d-788c-4728-87b2-17d8f03e5a3e","text":"University of Turin\'s publicly available rules on recognition of foreign degrees (procedures for evaluating and recognizing foreign diplomas).","date":"2018-04-24 00:00:00"},{"id":"4214672a-562c-4d52-ba43-6fa945b92796","text":"Donetsk higher-education institutions continued operations in exile (relocated to central Ukraine) and kept issuing Ukrainian diplomas after 2014.","date":"2014-09-24 00:00:00"},{"id":"6069bc47-89a4-4c4e-a60c-566e62b21b14","text":"EUvsDisinfo reported that Turin University\'s Department of Economics had admitted a student from occupied Donbas whose degrees were issued by Donetsk National University before 2014.","date":"2018-05-24 00:00:00"},{"id":"a5a64808-a7c7-4661-9b5f-05ea7b2697be","text":"Documented incidents earlier in the spring where Russian forces impeded or seized humanitarian/evacuation convoys (e.g., capture of drivers and buses at Mangush).","date":"2022-03-23 00:00:00"},{"id":"b1076592-2fd3-4abb-afeb-f82699e4392d","text":"Repeated breakdowns and contested humanitarian corridors and evacuations in Mariupol during March\u2013April 2022, with both sides blaming each other.","date":"None"},{"id":"0274fac9-ff73-42d8-ab6c-f9706fb26bd3","text":"OSCE monitors detained by pro\u2011Russian separatists (multiple incidents, including Slaviansk/Kramatorsk)","date":"2014-05-30 00:00:00"},{"id":"3e9a99da-f898-444b-a509-71165ab12c8a","text":"OSCE monitoring\u2011mission vehicles destroyed in Donetsk (apparent arson attack)","date":"2015-08-09 00:00:00"},{"id":"9de7a865-05de-4bfd-8512-7931d7ede270","text":"OSCE SMM reported nearby mortar impacts and SMM assets struck/damaged (examples of SMM being hit by indirect fire)","date":"2015-05-19 00:00:00"},{"id":"85b0b58a-88f4-44f0-9cb5-3b591e53a1e2","text":"Established concerns and reporting about illicit trafficking and unsecured radioactive materials in post\u2011Soviet states (IAEA Illicit Trafficking work, 1990s onward)","date":"None"},{"id":"6426368d-5503-45b4-825a-3f6508459459","text":"Ukraine relinquished Soviet-era nuclear weapons under the 1994 Budapest Memorandum","date":"1994-12-05 00:00:00"},{"id":"496b698b-bfc6-48ab-b701-a0216bacebd1","text":"ONS (UK) bulletin: \'Deaths involving COVID-19 by vaccination status, England\' showing monthly age-standardised mortality rates (ASMRs) by vaccination status (including notes that some ASMRs for vaccinated groups were similar to or higher than unvaccinated in certain months).","date":"2022-07-06 00:00:00"},{"id":"a64f47b0-62d9-4146-8c80-840ec0985236","text":"BBC coverage (Jan 10, 2023) reporting unusually high excess deaths in the UK during 2022 (\'Excess deaths in 2022 among worst in 50 years\').","date":"2023-01-10 00:00:00"},{"id":"a0e50427-37de-47e1-8628-65a45368f81f","text":"Japan reports and temporary suspension/recall of a Moderna vaccine lot after black/foreign particles were found (late August\u2013early September 2021).","date":"2021-09-24 00:00:00"},{"id":"fdae4493-7214-4d22-9884-468e8433f272","text":"NOAA releases ERSST version 4 sea-surface temperature dataset (ERSST v4) used in later global surface temperature products","date":"2014-10-24 00:00:00"},{"id":"7236ad73-10dd-4424-8400-fcca0d46b21c","text":"FDA expanded Emergency Use Authorization for the Pfizer\u2013BioNTech vaccine to adolescents aged 12\u201315 (May 10, 2021).","date":"2021-05-10 00:00:00"},{"id":"58935218-ac05-49c6-a4ef-438b8716d1fb","text":"CDC issues guidance (May 27, 2021) acknowledging increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination, particularly in adolescents and young adults.","date":"2021-05-27 00:00:00"},{"id":"f9f3a1dd-044e-4347-853e-d47068e767c4","text":"American Academy of Pediatrics (AAP) and Children\'s Hospital Association public report (May 20, 2021) summarizing COVID-19 cases and deaths in children.","date":"2021-05-20 00:00:00"},{"id":"4d20f04e-00ff-4651-a852-4ea4214217b3","text":"Assassination of pro\u2011Russian journalist Oles Buzyna in Kyiv","date":"2015-04-16 00:00:00"},{"id":"692bca93-f602-436a-b0f2-d5cbc808bcc1","text":"Reported vandalism of Holocaust and other memorials in Ukraine (2014 incidents)","date":"2014-04-09 00:00:00"},{"id":"32c704e2-9110-47ed-84c7-df34341bc74e","text":"Widespread toppling/removal of Lenin statues and other Soviet monuments in 2013\u20132014","date":"2014-09-24 00:00:00"},{"id":"eaab707c-78cc-4a71-a3a1-6e58581e9572","text":"Publication of the Antarctic Surface Accumulation and Ice Discharge (ASAID) map work/NASA Earth Observatory coverage that reported scientists connecting 3.5 million geographic points to estimate Antarctica\'s icy edge perimeter at ~53,610 km.","date":"2010-07-23 00:00:00"},{"id":"0fc411dc-0366-4f41-ba26-7fe26283c363","text":"Widespread public misunderstanding of the coastline paradox and map-projection distortions highlighted by reputable outlets (coverage during 2024\u2013early 2025 explaining why complex coastlines can yield large perimeter measurements).","date":"None"},{"id":"8df6167c-43a9-440a-83e3-dfb9c10de779","text":"Previous precedent: Russian missile strikes on Ukraine\u2019s energy infrastructure caused large Moldova blackouts in November 2022","date":"2022-11-23 00:00:00"},{"id":"fa07cd5b-e83f-475f-b9ea-4ba0d373d5e3","text":"Voltage collapse on the 400 kV Isaccea\u2013Vulcanesti\u2013MGRES transmission line that Moldova uses to import electricity","date":"2026-01-31 00:00:00"},{"id":"08fe87ea-bdb1-49c4-ba4a-8da08b598af8","text":"Russian Foreign Minister Sergey Lavrov publicly stated federalization was an important component of resolving the Ukrainian crisis (public remarks end of March 2014).","date":"2014-03-31 00:00:00"},{"id":"44a4cc47-ac51-408f-9d98-3af60f221d5a","text":"Pavel Gubarev proclaimed himself the \'people\'s governor\' of Donetsk and publicly called for a referendum on the region\'s status (early March 2014).","date":"2014-03-24 00:00:00"},{"id":"661bc774-cfb7-442b-b04d-b60a9966ae4a","text":"Russia/Gazprom sharply reduced and in places halted natural gas flows to Europe (Nord Stream 1 disruptions) in August 2022.","date":"2022-08-31 00:00:00"},{"id":"fce93629-dc10-4e52-8b7b-bba9217858c3","text":"EU leaders and institutions announced plans in spring 2022 (REPowerEU) to drastically reduce dependence on Russian fossil fuels.","date":"2022-05-24 00:00:00"},{"id":"8f85a016-f869-4492-a3bb-e9764dff12fa","text":"The 7 April 2018 Douma chemical attack (widely reported and later attributed by Western governments to the Syrian government)","date":"2018-04-07 00:00:00"},{"id":"aed65ccc-f1af-425a-893d-9abd19f90a0b","text":"Discovery and widespread publication of photos and videos showing dead civilians in Bucha after Russian forces withdrew","date":"2022-04-02 00:00:00"},{"id":"ea903ec9-a353-49e9-8bfe-6fda508a4947","text":"Zelensky\'s public appeals for faster, increased military aid from allies (NATO talks/weapons appeals)","date":"2023-01-29 00:00:00"},{"id":"b52a5a04-4c42-47d9-94b7-248dd3212a3a","text":"Turkey\'s prior military-technical support to Ukraine (notably Bayraktar TB2 drones supplied in 2021\u20132022)","date":"2022-10-28 00:00:00"},{"id":"5638859b-a4e7-442a-9258-7c016db35b11","text":"February 2023 T\xfcrkiye earthquakes \u2014 world leaders, including Zelensky, publicly expressed condolences and offered assistance","date":"2023-02-07 00:00:00"},{"id":"628a9231-baea-46d1-935b-0ca2ff01b00d","text":"AMA, APhA and ASHP issued a joint statement (June 23, 2020) noting FDA review and actions regarding hydroxychloroquine and other COVID-19 medications.","date":"2020-06-23 00:00:00"},{"id":"397d33bf-097c-4ee9-99e3-1a1d910daf3f","text":"Regulatory and industry safety reviews of wild yam (Dioscorea villosa) and public-facing summaries cautioning that wild yam extracts have hormonal activity and are not proven to treat fibroids.","date":"2023-06-24 00:00:00"},{"id":"7b77283b-32ba-4208-84fa-7ab5e7cab570","text":"Early reports of allergic and other adverse reactions after initial COVID-19 vaccine rollouts (for example, two NHS workers had allergic reactions after Pfizer shots in the UK).","date":"2020-12-09 00:00:00"},{"id":"517da9bc-9b77-4f9b-9fdb-7c76ed94c54e","text":"Public reporting that several COVID-19 vaccine candidates used historically derived human fetal cell lines (HEK-293, PER.C6) in development/manufacture.","date":"2020-06-05 00:00:00"},{"id":"46e40007-007b-4112-bdb6-e0353838f067","text":"UK \'Homes for Ukraine\' sponsorship scheme launched, enabling rapid arrival of large numbers of Ukrainian refugees to the UK (scheme launched 14 March 2022).","date":"2022-03-14 00:00:00"},{"id":"bdb28899-4f74-403d-b02b-ea957505918e","text":"Russian leadership publicly framed the invasion as needing to \'denazify\' Ukraine (Putin\'s rhetoric from late February 2022 onward).","date":"2022-02-24 00:00:00"},{"id":"2f38e888-600f-4e0c-aa5d-aea6ecf44f01","text":"Multiple reported incidents of swastika vandalism and a May 2022 prosecution for carving swastikas in a London shopping centre (Westfield) received local/national coverage.","date":"2022-05-05 00:00:00"},{"id":"6917898b-b050-4e24-b57f-67feaf1c1afe","text":"CDC reinstated recommendation on July 27, 2021 that fully vaccinated people wear masks in public indoor settings in areas of substantial or high transmission (mask guidance change due to Delta).","date":"2021-07-27 00:00:00"},{"id":"b2abf8f5-257b-4d02-9d1a-28829bf1cbb6","text":"Israeli public-health reports in July 2021 showing decreased Pfizer-BioNTech effectiveness against infection with the Delta variant (while remaining strong against severe disease).","date":"2021-07-24 00:00:00"},{"id":"d8c49565-8be5-4d93-93c4-be6dbc0ff16a","text":"Japan suspended and recalled Moderna vaccine batches in late August\u2013early September 2021 after discovery of foreign (stainless steel/black) particles in some vials.","date":"2021-09-24 00:00:00"},{"id":"f15d0ff0-d9e9-4d3f-b9c1-eb0345438bb9","text":"CDC MMWR report (published May 28, 2021) documenting COVID-19 vaccine \'breakthrough\' infections occurring January\u2013April 2021 and announcing a change in CDC surveillance focus.","date":"2021-05-24 00:00:00"},{"id":"43bd3e11-7f49-4856-aa33-d1602ac373d9","text":"IARC/WHO evaluation classifying formaldehyde as a Group 1 (carcinogenic to humans) agent (IARC working group meeting, 2004)","date":"2004-06-24 00:00:00"},{"id":"b9f18053-5037-47c8-8598-331be2a79964","text":"CDC Vaccine Excipient & Media Summary (Pink Book Appendix B) listing ingredients and substances used in vaccine manufacture (publicly available CDC excipient table)","date":"2014-04-24 00:00:00"},{"id":"40d37e86-1ea3-4247-b129-3142707eb05a","text":"1999 joint statement by the American Academy of Pediatrics and U.S. Public Health Service (reported by CDC) calling for removal of thimerosal from childhood vaccines as a precaution","date":"1999-07-24 00:00:00"},{"id":"5adb0ff7-d9bc-4670-85ce-aad1368b41a7","text":"Pause of high-profile vaccine trials (AstraZeneca paused global trials after an unexplained illness in a participant)","date":"2020-09-09 00:00:00"},{"id":"759c7475-0897-4647-8b0e-031cc9ba6232","text":"Public revelations (2015) that climate contrarian Willie Soon received substantial fossil-fuel industry funding.","date":"2015-02-21 00:00:00"},{"id":"14147b89-0d92-4319-8775-66863cf40aaa","text":"Major publishers (e.g., Springer Nature) publicly stated policies that AI tools cannot be credited as authors (January 2023), sparking debate over AI authorship in science.","date":"2023-01-26 00:00:00"},{"id":"197ea094-6998-46eb-9eb0-c42038338cc9","text":"Iran launched missile strikes on bases housing US forces in Iraq (retaliation)","date":"2020-01-08 00:00:00"},{"id":"aaac4db6-2c1e-41e7-8c9f-d6b353262207","text":"US drone strike killed Iranian General Qasem Soleimani","date":"2020-01-03 00:00:00"},{"id":"4c49be1c-4984-43c9-84ea-20cd6554a9bd","text":"Ukraine International Airlines Flight PS752 was shot down near Tehran, killing all 176 aboard","date":"2020-01-08 00:00:00"},{"id":"aef8d776-73de-4a9a-9ac9-77b9a76a5c9b","text":"UN Office of the High Commissioner for Human Rights (OHCHR) report on children\'s rights in Ukraine documenting large numbers of children killed, injured, deported and otherwise affected by hostilities","date":"2025-03-21 00:00:00"},{"id":"73b90fd6-25aa-4c74-9c05-806da37bc137","text":"Ukrainian authorities announce \\"Contract 18-24\\" recruitment drive offering one\u2011year voluntary contracts with financial incentives for recruits aged 18\u201324","date":"2025-02-07 00:00:00"},{"id":"efd598c6-13e3-4a3a-ba1d-f2040f478439","text":"Official Kyiv Eurovision preparations publicized large security measures (10,000 law\u2011enforcement personnel, thousands of cameras, road closures and \'clean\u2011up\' operations).","date":"2017-04-13 00:00:00"},{"id":"4153fc76-dd06-46a7-b833-59462ffcf3c0","text":"Kyiv placed under curfew and residents ordered to shelter/prepare to defend the city","date":"2022-02-25 00:00:00"},{"id":"3eb3429b-5a86-4636-823b-47d12f8e009d","text":"Airborne assault on Hostomel (Antonov) airport with helicopters and paratroopers near Kyiv","date":"2022-02-24 00:00:00"},{"id":"668ec28e-19b5-4953-b1fb-eb9dd4e4d330","text":"Multiple missile strikes reported on Kyiv and other Ukrainian cities","date":"2022-02-24 00:00:00"},{"id":"166c481a-983c-434e-ad60-01d7318a666d","text":"Apartment building in Kharkiv shelled; civilian casualties reported (boy killed)","date":"2022-02-24 00:00:00"},{"id":"14b9ea79-ae03-4f42-a138-9c2ffee5b826","text":"Russian President Vladimir Putin announces a \'special military operation\' in Ukraine","date":"2022-02-24 00:00:00"},{"id":"aa7457aa-e2b7-41e3-a76f-f250452d8ceb","text":"Federal court consolidated more than 140 lawsuits against Merck over the Gardasil HPV vaccine into a multidistrict litigation (MDL No. 3036), bringing sustained media attention to plaintiffs\' claims that Gardasil caused serious harms.","date":"2024-03-20 00:00:00"},{"id":"211749eb-0c84-433f-8c5b-67d3c20b7c6d","text":"Japan\'s Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine in June 2013 (a decision that drastically reduced uptake and has been repeatedly cited in vaccine-safety debates).","date":"2013-06-24 00:00:00"},{"id":"ffa893cc-5751-4cc7-9631-5cb0757e751c","text":"Russian missile strike on Kramatorsk railway station that killed dozens of civilians","date":"2022-04-08 00:00:00"},{"id":"ca6d6bb8-16d5-4838-b68f-17ff29aeff1a","text":"President Volodymyr Zelensky requested an extraordinary parliamentary session on May 21\u201322, 2019 to amend electoral legislation, producing a heated parliamentary session and partisan exchanges.","date":"2019-05-21 00:00:00"},{"id":"f606eaed-f36b-4ad7-974e-d69792b06e3b","text":"Opposition deputy Alexander Dolzhenkov publicly threatened to seek repeal of laws on decommunization and the language law during the May 22 debate, prompting Parubiy\u2019s defensive remarks.","date":"2019-05-22 00:00:00"},{"id":"6b6ffa0d-1e38-4bae-9088-3abde339c3da","text":"Andriy Parubiy\u2019s May 22, 2019 parliamentary remarks including the line \'You think the smell of revenge is in the air? Smell it! It\u2019s the smell of burning tires.\'","date":"2019-05-22 00:00:00"},{"id":"40d1fa1f-1ea6-492f-b43c-71d594b24f86","text":"Kerch Strait incident where Russian forces seized three Ukrainian naval vessels and detained crews","date":"2018-11-25 00:00:00"},{"id":"160bc68d-b04c-4782-87e2-8818ed161340","text":"Sea Breeze multinational naval and military exercises hosted by Ukraine and NATO partners in the Black Sea (Sea Breeze 2018)","date":"2018-07-24 00:00:00"},{"id":"15bad102-22bf-4306-9360-1f3c0adbfff3","text":"U.S. approval and delivery of Javelin anti-tank missiles to Ukraine","date":"2017-07-24 00:00:00"},{"id":"60688d2b-1218-4d31-a856-9c2cc98ed3c0","text":"Formation and integration of volunteer units such as the Azov Battalion into Ukraine\'s forces (2014 onward)","date":"2014-05-24 00:00:00"},{"id":"a46bf700-8a4f-418d-90fc-003b0bc7228f","text":"UN Human Rights Office report documenting multiple arbitrary arrests, detentions and prosecutions in Russian\u2011occupied Crimea","date":"2017-09-25 00:00:00"},{"id":"023efd2f-37f3-428a-93b9-9851efee1ab9","text":"Fitch Ratings sovereign rating actions and downgrades around the 2014\u20132015 crisis (example: Feb 13, 2015 Fitch rating action)","date":"2015-02-13 00:00:00"},{"id":"7e57b3b3-1ccc-4646-9659-c2d94da11186","text":"IMF statement concluding the 2016 Article IV consultation with Ukraine (April 3, 2017)","date":"2017-04-03 00:00:00"},{"id":"da22f955-e91b-407e-93b0-ab51c2c62a96","text":"Iran announced arrests related to the downing and police cracked down on protests over the incident.","date":"2020-01-14 00:00:00"},{"id":"4be45854-769b-4cdf-8d32-7ef709f38bad","text":"Ukraine International Airlines Flight PS752 was shot down shortly after takeoff from Tehran, killing all 176 aboard.","date":"2020-01-08 00:00:00"},{"id":"222e7b43-94bc-469a-9da2-e6c7522401f7","text":"Reporting noted many passengers were Iranian nationals, students and researchers (including academics), and several countries pressed for answers about passenger lists.","date":"2020-01-08 00:00:00"},{"id":"4ff9773a-68ff-4aac-9456-845b766f68d4","text":"EU published COM(2017)235 (12 May 2017) \u2014 a strategy to step up the fight against illicit tobacco trade affecting eastern EU borders","date":"2017-05-12 00:00:00"},{"id":"a2e3ca06-1e5b-4d34-80b4-412d59aa3a43","text":"Poland and Ukraine signed a memorandum on cooperation for the Via Carpathia transport corridor (signed Oct 22, 2017) and media reported growing cross\u2011border freight volumes","date":"2017-10-22 00:00:00"},{"id":"738e1a9a-7001-45f2-bb32-ff4e61d6b48f","text":"Ukraine\u2019s Infrastructure Minister Volodymyr Omelyan publicly discussed bilateral transport permit numbers (citing ~10,000 Polish permits for Ukrainian carriers) in the same period","date":"2017-11-18 00:00:00"},{"id":"8b3f89b9-71a0-4a88-96a2-948392d036cd","text":"Former Ukrainian Transport Minister Yevhen Chervonenko said on ZIK TV thousands of trucks were stuck on Ukraine\u2019s western borders and could not enter Europe","date":"2017-11-18 00:00:00"},{"id":"b0b99fd3-fa74-4103-ba15-cf12e47469ed","text":"Amnesty International press release calling on Ukraine to stop abuses by pro\u2011Ukrainian volunteer battalions (Aidar, etc.), citing unlawful detentions and summary killings.","date":"2014-09-08 00:00:00"},{"id":"41788b6a-450e-4c17-962d-bd412f1d352f","text":"Office of the High Commissioner for Human Rights (OHCHR) report documenting egregious human\u2011rights abuses in Donetsk and Luhansk, including killings, abductions and restrictions on movement.","date":"2014-07-15 00:00:00"},{"id":"bd3aba7c-ad6e-427a-a510-dc1e1bd9c7cd","text":"OHCHR/UN press release (2 March 2015) reporting that the death toll in eastern Ukraine had crossed 6,000 and documenting civilian casualties and impediments to people leaving conflict areas.","date":"2015-03-02 00:00:00"},{"id":"06f72312-a33d-446c-bb6e-dc7b4ca210c4","text":"Election of Andrzej Duda as President of Poland (conservative, Law and Justice party) in May 2015","date":"2015-05-25 00:00:00"},{"id":"cfdcf4da-e29e-4722-ac00-8cd76b398f94","text":"Public reporting and leadership statements about slow or delayed Western arms deliveries to Ukraine (widely covered in mid\u2011September 2024).","date":"2024-09-15 00:00:00"},{"id":"148553e6-d5d9-4816-96b4-c7c115faab4c","text":"Serhii Sternenko\'s profile as a high\u2011visibility Ukrainian activist with prior legal controversies and a large social following (making him a frequent target for smears and falsified attributions).","date":"2021-02-23 00:00:00"},{"id":"d1a30a6a-894e-49d5-8382-00a5d409b387","text":"EMA Article\u201131 referral and EU-wide review of combined hormonal contraceptives (procedure started Feb 2013; review communicated Nov 21, 2013)","date":"2013-11-21 00:00:00"},{"id":"b1f6ef8c-f80f-4565-a8e8-a1bec3e92ca7","text":"UK Drug Safety Update / MHRA communications and updated patient/prescriber leaflets on CHCs and VTE risk (published March 2014 and accompanying materials)","date":"2014-03-24 00:00:00"},{"id":"871edd95-2bef-4c86-80bb-e83c188a88cd","text":"European Commission adoption of legally binding decision to update CHC product information (decision adopted 16 January 2014)","date":"2014-01-16 00:00:00"},{"id":"416e955e-2300-409f-9ec1-c4fbafa37d57","text":"1995 UK \'pill scare\' \u2014 Committee on Safety of Medicines advised that pills containing desogestrel/gestodene were linked to doubled VTE risk","date":"1995-10-24 00:00:00"},{"id":"2be73865-8f17-4c3c-8ff5-59077c2c2638","text":"Large-scale lawsuits and media coverage alleging manufacturers downplayed clot risks from newer contraceptives (Bayer Yaz/Yasmin settlements reported 2012)","date":"2012-10-24 00:00:00"},{"id":"10350d56-fc35-41a1-959b-98a5220ab0e7","text":"Publication of a review summarizing research into engineered/measles-based oncolytic viruses as cancer immunotherapy (\\"Measles Virus as an Oncolytic Immunotherapy\\", PMC review).","date":"2021-01-24 00:00:00"},{"id":"3a092639-1cc6-485f-bf1a-d92f6a336b95","text":"Andrei Makarevich performed charity concerts for displaced children in eastern Ukraine (Slov\'yansk/Svyatohirsk).","date":"2014-08-24 00:00:00"},{"id":"8d7aa242-a4fa-4805-bf07-4ab3531b4a46","text":"Makarevich attracted hostility earlier for publicly showing pro\u2011Ukrainian symbols (attending a Moscow peace march wearing Ukrainian\u2011coloured ribbons).","date":"2014-03-24 00:00:00"},{"id":"80946d3c-7fd2-4079-b4a3-88da3b276d60","text":"Prominent pro\u2011Kremlin politicians publicly denounced Makarevich and called for stripping his state honors.","date":"2014-08-24 00:00:00"},{"id":"3e4a8be4-4ed0-4553-b03c-128ce3fd4985","text":"Clashes between Polish and Ukrainian football fans at Euro 2016 in Marseille (physical fights and arrests ahead of the Poland\u2013Ukraine match).","date":"2016-06-21 00:00:00"},{"id":"572cbeb6-e025-4c36-a959-9b84f9bac472","text":"Media reporting in 2016 of rising xenophobia and harassment directed at Ukrainians in Poland.","date":"2016-11-24 00:00:00"},{"id":"82615446-c1d3-4c85-8e0f-1e8ede770ad1","text":"Visible growth of far\u2011right and nationalist street movements and demonstrations in Poland during 2016.","date":"2016-04-24 00:00:00"},{"id":"ad67387f-fc3e-435c-a8bd-5e291653ae0b","text":"Hamas attack on Israel and mass abductions created a large population of hostages and distressed families","date":"2023-10-07 00:00:00"},{"id":"a865c1f1-ff02-4c09-aaf9-384d06d59fbf","text":"Publication of a large South Korean retrospective cohort study in Biomarker Research reporting associations between COVID-19 vaccination and increased one\u2011year risks for six cancer types","date":"2025-09-26 00:00:00"},{"id":"8b9464e0-9a15-4e61-923e-b378808a14b3","text":"FAO and other UN agencies warned of global food impacts from the Ukraine conflict and launched efforts to save Ukraine\'s harvest and keep exports flowing","date":"2022-07-05 00:00:00"},{"id":"dec9a639-6063-45f9-91b1-011da9866da1","text":"European Union temporarily lifted import duties / quotas on Ukrainian agricultural products to support Ukraine\'s economy","date":"2022-06-03 00:00:00"},{"id":"a3403f9f-ba0f-4ee4-82d4-1929b0c86826","text":"Signing of the UN\u2011brokered Black Sea Grain Initiative (Istanbul) enabling safe maritime export corridor from Ukrainian ports","date":"2022-07-22 00:00:00"},{"id":"641967ed-c666-4b21-9632-a88aaa4fe896","text":"Human rights reports documenting abuses by both separatist forces and Ukrainian government forces (Human Rights Watch / Amnesty reports, 2014\u20132015)","date":"None"},{"id":"29d024dd-2543-4a8c-97c4-a8b1bbf8dc29","text":"Polls reporting that many Ukrainians characterized the Donbas fighting as an \'intrastate\' or internal conflict (KIIS / Democratic Initiatives Foundation, October 2015)","date":"2015-10-09 00:00:00"},{"id":"4a6442f1-c198-4146-b8d8-0bb0b72e9000","text":"Signing of the Minsk II agreements (February 2015)","date":"2015-02-12 00:00:00"},{"id":"c68c064f-6ac6-46bf-9798-6cc7a03a8b57","text":"Self\u2011declared independence referendums and proclamations by Donetsk and Luhansk \'people\'s republics\' (May 2014)","date":"2014-05-11 00:00:00"},{"id":"b5fc4724-c9a3-462d-ab84-5bebcfdb6783","text":"WHO published a public timeline of COVID\u201119 events (WHO timeline) summarising early December 2019 detection milestones","date":"2020-04-27 00:00:00"},{"id":"52cf9b3e-9f25-43fa-8939-e7866cc8edc6","text":"News reports (May 4\u20135, 2020) that a French pneumonia sample from December 27, 2019 later tested positive for SARS\u2011CoV\u20112","date":"2020-05-05 00:00:00"},{"id":"1ac986cd-7418-4a77-a69d-a9308b8761cf","text":"European Union launched Permanent Structured Cooperation (PESCO) to deepen EU defence cooperation (formal decision adopted Dec 11, 2017).","date":"2017-12-11 00:00:00"},{"id":"e1ef5d87-f3ec-423c-9813-c9a4921268c1","text":"U.S. imposed tariffs on steel and aluminium (March 2018) and the EU adopted retaliatory measures.","date":"2018-03-08 00:00:00"},{"id":"07477746-79bf-40ea-a2a4-df204c59d1e4","text":"President Trump ordered the withdrawal of U.S. troops from Syria (announced Dec 19, 2018).","date":"2018-12-19 00:00:00"},{"id":"340bee43-d3fa-492a-b0c5-9beef5cdaf32","text":"President Trump publicly berates NATO allies at the Brussels summit, warning the U.S. might \'go it alone\' if allies do not meet defense spending targets.","date":"2018-07-12 00:00:00"},{"id":"f20f07e3-7db3-4e45-857e-a44b98c2bb8e","text":"U.S. announced it would withdraw from the Intermediate-Range Nuclear Forces (INF) Treaty (six\u2011month notice given Feb 2019).","date":"2019-02-02 00:00:00"},{"id":"b293d682-81e8-4ee7-98f5-08d38125f280","text":"Ukrainian carrier Supernova reported to have received permits to operate scheduled Lviv\u2013Prague and Kyiv\u2013Prague routes (announced in media)","date":"2024-10-22 00:00:00"},{"id":"477b8e23-3732-45bb-8214-4be4d59e06f8","text":"European (EASA) Part-TCO authorization for Supernova Airlines announced","date":"2024-10-17 00:00:00"},{"id":"4203c331-94df-4947-baaa-31ca888f30bd","text":"European Parliament / EU analyses and statistics showing significant trade and energy interdependence with Russia (2014\u20132017 trade data and briefings published in 2017).","date":"2017-04-24 00:00:00"},{"id":"bcd1fd82-eeae-492b-8e3b-aae60422d657","text":"Campaign and political support in parts of Germany and among some EU businesses for the Nord Stream 2 gas pipeline (prominent coverage and analysis in 2016).","date":"2016-11-24 00:00:00"},{"id":"2b5e3663-84d6-4872-8663-13535c6a2ef9","text":"CDC/ACIP recommend use of the updated (bivalent) COVID-19 boosters","date":"2022-09-01 00:00:00"},{"id":"4fb30839-ae13-419b-b046-54c5b4ab1faa","text":"Russian official and media reaction emphasizing Tillerson\'s comments as signaling possible U.S. softness","date":"2017-01-12 00:00:00"},{"id":"22e7c561-5c28-435c-a056-a2a7ac35b322","text":"Hungary repeatedly raised public complaints and blocked aspects of Ukraine\'s Western integration over alleged mistreatment of the Hungarian minority in Zakarpattia, increasing bilateral tensions.","date":"2023-12-24 00:00:00"},{"id":"6e1568f5-503f-41be-af1f-55c802c66507","text":"Reporting and analyses documented both an exodus of ethnic Hungarians from Transcarpathia after the 2022 invasion and cases of ethnic Hungarians voluntarily joining Ukrainian forces or local defense units.","date":"2024-04-24 00:00:00"},{"id":"9eb46b0c-d447-445d-aef2-1288e56731a2","text":"Ukraine\'s Security Service (SBU) and Ukrainian authorities reported Russian information\u2011operations specifically targeting the ethnic Hungarian community in Transcarpathia / Zakarpattia (including spoofed calls and other PSYOPs).","date":"2024-04-24 00:00:00"},{"id":"49ae5188-a2ca-4673-ae24-883f12ed99e9","text":"Ukraine imposed wartime restrictions and a de facto travel ban preventing most men aged 18\u201360 from leaving the country after the 2022 full\u2011scale invasion.","date":"2022-03-24 00:00:00"},{"id":"66942d3b-11e6-4000-89af-63719adda485","text":"Alfa/Leopolis Jazz Fest was scheduled and ran in late June 2017 (festival dates June 23\u201327, 2017), contrary to claims of cancellation.","date":"2017-06-23 00:00:00"},{"id":"f57ff950-9e13-483a-bec5-974eb37e4703","text":"Reuters photo/coverage showing volunteers cleaning piles of trash in Lviv in the days before the festival (coverage dated June 21, 2017).","date":"2017-06-21 00:00:00"},{"id":"a2076eeb-7774-4162-8451-feb0f732fdba","text":"CDC MMWR report on large Delta-era outbreak in Provincetown, Massachusetts with many breakthrough infections among fully vaccinated people","date":"2021-08-06 00:00:00"},{"id":"4eed5196-441c-471a-ae3f-d55887c0f063","text":"UK Health Security Agency vaccine surveillance reports showing sharp drops in vaccine effectiveness against symptomatic Omicron infection after two doses","date":"2021-11-18 00:00:00"},{"id":"efe09af4-3d29-4a10-9c20-6c42ab3563f5","text":"Pfizer\u2013BioNTech phase 3 trial press release reporting ~95% efficacy","date":"2020-11-09 00:00:00"},{"id":"630437eb-fd43-4d0f-83bc-76d2f57ecc70","text":"NEJM national Israel study showing measurable waning of BNT162b2 protection over months (Delta wave)","date":"2021-10-27 00:00:00"},{"id":"ea07027f-897a-42f0-af9e-4de7f1333cf6","text":"Pfizer\u2013BioNTech press release reporting markedly reduced two\u2011dose neutralization of Omicron and restored neutralization after a booster","date":"2021-12-08 00:00:00"},{"id":"c2c81ff6-a163-475a-8383-769d632a3191","text":"Publication of IRENA & IEA-PVPS report projecting up to 78 million tonnes of PV waste by 2050","date":"2016-06-24 00:00:00"},{"id":"9702a8e5-c44d-44a6-be11-b88dfba3d229","text":"NREL analysis and surveys showing low recycling rates (less than ~10% of decommissioned panels recycled in the U.S.)","date":"2021-06-24 00:00:00"},{"id":"a1a140b4-c1ac-491d-9ae3-3620a0004758","text":"BBC article \'Challenge to stop solar panels becoming a \\"waste mountain\\"\' reporting experts\' warnings","date":"2023-06-04 00:00:00"},{"id":"97ee6a53-1aab-4a11-bbc3-1775ff749efb","text":"Right Sector set up roadblocks and staged protests demanding the resignation of Interior Minister Arsen Avakov","date":"2015-07-12 00:00:00"},{"id":"1897c2f6-b5bc-491a-948b-25ea30ab87f9","text":"Prime Minister Yatsenyuk ordered dismissal/replacement of Zakarpattia customs officers and heads in response to the Mukachevo events","date":"2015-07-13 00:00:00"},{"id":"53e5fac3-f3b9-4170-acb1-fa39f2caaa62","text":"Mukachevo shootout between fighters linked to Right Sector and local police","date":"2015-07-11 00:00:00"},{"id":"dbb30e81-3924-4957-9510-c3ca70ff3cec","text":"Interior Minister Arsen Avakov suspended the Mukachevo police chief and launched an inspection of the regional police force","date":"2015-07-13 00:00:00"},{"id":"e930d6e7-85d6-4421-a247-e19e17bfca63","text":"Russian forces seize the Zaporizhzhia nuclear power plant (Europe\'s largest)","date":"2022-03-04 00:00:00"},{"id":"e6ac3ba2-6553-40c5-93b0-47155aea88ef","text":"Russian President Vladimir Putin orders Russia\'s nuclear deterrent forces put on high alert","date":"2022-02-27 00:00:00"},{"id":"776e7b52-5ed1-4439-9f2d-40f2b49ba7fd","text":"President Zelensky\u2019s public address to the Lowy Institute where he said NATO must \'eliminate the possibility\' of Russia using nuclear weapons (speech and Q&A)","date":"2022-10-06 00:00:00"},{"id":"1c08e4c5-9840-441f-9216-d5589e6804b8","text":"Reports of Chechen fighters volunteering in eastern Ukraine (Donbas)","date":"2014-05-31 00:00:00"},{"id":"d4e114a0-6a56-4ebe-9b0f-7f235be968c1","text":"Crimean court bans the Mejlis (representative body of Crimean Tatars) as \'extremist\' (April 2016)","date":"2016-04-26 00:00:00"},{"id":"9a26c070-19da-4eb1-83ac-f92c3c2f2535","text":"European Parliament written question citing concerns about ISIS/Islamist sympathizers in territories disputed by Russia and Ukraine (July 2015)","date":"2015-07-27 00:00:00"},{"id":"246072d5-0023-42d5-be4d-192210543c42","text":"Assassination of former Ukrainian parliament speaker Andriy Parubiy in Lviv","date":"2025-08-30 00:00:00"},{"id":"dc5b6b43-1d7f-4cc1-a0c8-5798df242073","text":"Odessa Trade Unions House fire (May 2, 2014) and its contested narratives","date":"2014-05-02 00:00:00"},{"id":"4e10df47-ecd3-420b-ace6-784d39da51ec","text":"The Federation Council of the Russian Federation approved President Vladimir Putin\'s request to use Russian armed forces in Ukraine.","date":"2014-03-01 00:00:00"},{"id":"8b1417ae-1c79-4395-bde9-31cc95079fcd","text":"Unmarked armed personnel occupied airports, checkpoints and key sites across Crimea (the so-called \'little green men\').","date":"2014-02-27 00:00:00"},{"id":"65ed18a6-46ca-42a4-b659-ffd3e80e398c","text":"Masked gunmen seized the Crimean parliament and other government buildings in Simferopol, raising Russian flags.","date":"2014-02-27 00:00:00"},{"id":"46862e25-4144-4ea1-8438-f36b6c8106e2","text":"Crimean parliament voted to hold a referendum (initially set for 16 March) on joining Russia and announced steps toward joining the Russian Federation.","date":"2014-03-06 00:00:00"},{"id":"6a5ffe53-8ea1-4ce2-b101-76838a82574d","text":"Large, atypical RSV surges in 2022 (U.S. and other countries) produced heightened public anxiety and searches for home remedies during and after the wave.","date":"2022-12-24 00:00:00"},{"id":"83a845fb-f008-4586-97a0-4ebed68224f1","text":"Ukrainian authorities (SBU / MFA) declared some foreign visitors persona non grata and warned of entry bans after delegations visited occupied Crimea (reported March 2017).","date":"2017-03-20 00:00:00"},{"id":"34141a13-a411-4858-8ce0-1aeb316e65b2","text":"INTERPOL issued Red Notices at Ukraine\'s request for former Ukrainian officials (including Yanukovych and Azarov).","date":"2015-01-12 00:00:00"},{"id":"4f1143e9-8a23-407d-97eb-ba5c9cd9c89d","text":"European parliamentarians and other EU politicians (including MEPs) made unsanctioned visits to Russian-occupied Crimea and to separatist-held Donbas in 2015.","date":"2015-05-24 00:00:00"},{"id":"2123eb04-aef5-4732-a991-e130cad08ea7","text":"Release of the IPCC Special Report \'Global Warming of 1.5\xb0C\' (high\u2011profile 2018 scientific assessment)","date":"2018-10-08 00:00:00"},{"id":"82382772-6dd8-4efc-ba22-7470418a4a77","text":"CDC updates mask guidance for fully vaccinated people, recommending indoor masking in areas of substantial/high transmission.","date":"2021-07-27 00:00:00"},{"id":"c3a9c214-92d4-48cd-a33c-f2855651a9cc","text":"Public Health England (PHE) monitoring and technical reports in mid\u20112021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant compared with Alpha, while retaining strong protection against severe disease.","date":"None"},{"id":"2824213e-2808-437e-bcd0-947ff4adac18","text":"MMWR report on a large July 2021 outbreak in Barnstable County, Massachusetts found that a high proportion of cases were in fully vaccinated persons (reported in late July).","date":"2021-07-30 00:00:00"},{"id":"ce2f9ef4-b333-407a-8bed-225eac1f4180","text":"FDA issued Guidance for Industry on \'Characterization and Qualification of Cell Substrates and Other Biological Materials Used in the Production of Viral Vaccines\' (published March 4, 2010).","date":"2010-03-04 00:00:00"},{"id":"fa2956eb-d0cb-4e35-ae43-0fb364f44bb6","text":"Academic researchers (reported March 2010) detected DNA from porcine circovirus type 1 (PCV1) in batches of the oral rotavirus vaccine Rotarix; WHO and other regulators issued interim statements and convened reviews.","date":"2010-03-24 00:00:00"},{"id":"3308e491-e157-43e0-9b6c-4a9d02687351","text":"Historical contamination of early polio vaccines with simian virus 40 (SV40) used monkey kidney cell cultures; exposure occurred in vaccines administered 1955\u20131963.","date":"None"},{"id":"1926b8d1-77b0-4125-9064-fd191cec71bf","text":"Presence of Polish pro\u2011Russia political figures (e.g., Mateusz Piskorski) among \'international observers\' who visited Crimea after the 2014 referendum.","date":"2014-03-24 00:00:00"},{"id":"8f273d19-4c8d-4d81-af8b-347364d3cf78","text":"Bill Gates invested in plant-based and cell-cultured meat companies (e.g., Impossible Foods, Beyond Meat, Memphis Meats/Upside Foods).","date":"2017-08-23 00:00:00"},{"id":"b41bba8e-2c4c-4c7b-84e6-ac57b3efe67c","text":"Gates-funded research on microneedle patches and \'quantum-dot\' vaccine markers that could encode vaccination history in skin.","date":"2020-02-24 00:00:00"},{"id":"0895f651-9e7a-4f35-85b9-11d230569161","text":"Development and trials of oral/tablet COVID-19 vaccine candidates (e.g., Vaxart dosing subjects in Phase II trials).","date":"2021-10-26 00:00:00"},{"id":"cecd8282-63f4-4288-a013-3c27da5e1ce6","text":"OHCHR reported lack of access to detainees held by armed groups in Donetsk and Luhansk, identifying numerous detention sites and documenting arbitrary detention","date":"2017-03-13 00:00:00"},{"id":"6c53d5bf-7d7d-48dc-9537-69146547313c","text":"ICRC participated in and confirmed large, complex detainee release/transfers in eastern Ukraine (largest exchange to date in 2017) at the request of the parties","date":"2017-12-12 00:00:00"},{"id":"d7276325-292a-412d-b146-87a0730b45b3","text":"Minsk II agreement (Feb 2015) required \'release and exchange of all hostages and illegally held persons\' (principle of \'all for all\')","date":"2015-02-12 00:00:00"},{"id":"6821b41c-0ed3-446b-b813-0315afb69e66","text":"European Parliament / international reporting on Russian restrictions and de facto blockade of shipping access to Ukrainian ports in the Sea of Azov.","date":"2018-10-25 00:00:00"},{"id":"6b1d0896-6534-4772-818d-a3b7f82c5da1","text":"Kerch Strait incident: Russian forces fired on and captured three Ukrainian naval vessels attempting to transit the Kerch Strait.","date":"2018-11-25 00:00:00"},{"id":"64d6f3c5-199a-4540-9425-eff3a9b82273","text":"Deployment of advanced Russian coastal and air\u2011defense systems (S-400/Bastion/Bal) to Crimea and surrounding Black Sea region.","date":"2016-08-13 00:00:00"},{"id":"fa1d9e95-860b-4b4f-9fe0-314d79b493c4","text":"IPCC Sixth Assessment Synthesis Report (AR6 SYR) published \u2014 clear attribution of recent warming to human activities","date":"2023-03-24 00:00:00"},{"id":"5f83450c-4831-4805-8e27-b404683bd245","text":"NOAA educational page summarising limits of weather\u2011forecast skill (noting 5\u20137 day forecasts are much more reliable than 10+ day forecasts)","date":"2023-04-24 00:00:00"},{"id":"815d733e-377e-4e24-a508-460979499d47","text":"Publication on multi\u2011centennial Holocene climate variability in proxy records (peer\u2011reviewed synthesis)","date":"2022-04-24 00:00:00"},{"id":"cf9f8c01-fefa-4717-9ec0-abd2ed4eb2cb","text":"Congressional scrutiny and subpoenas over the Karl et al. (2015) NOAA paper (House Science Committee inquiries led by Rep. Lamar Smith in summer\u2013fall 2015).","date":"None"},{"id":"74d88a1b-8f1b-4a10-9f4a-d925b87902c6","text":"IPCC AR5 (Working Group I) reported a reduced rate of surface warming during 1998\u20132012 compared with the late 20th century, noting variability and shorter-term trends.","date":"2013-09-24 00:00:00"},{"id":"952a8a66-4769-48c9-a0f2-2a80794fe380","text":"Public vaccine surveillance reports (e.g., UK Health Security Agency vaccine surveillance reports 2022) showing waning vaccine effectiveness against infection and, in some high\u2011coverage populations, increasing proportions of cases occurring in vaccinated people","date":"2022-09-24 00:00:00"},{"id":"1bd88c13-1b9b-45a7-8a44-855bc33bf360","text":"WHO classification and global reporting of the Omicron (B.1.1.529) variant showing substantial immune escape from prior infection and reducing vaccine neutralisation (press statement and technical brief)","date":"2021-11-24 00:00:00"},{"id":"520176c7-8c95-47d8-a5f6-2fa9bc33eb5c","text":"CDC confirmation and public communication about rare cases of myocarditis/pericarditis following mRNA COVID-19 vaccination (recognition, safety monitoring and guidance)","date":"2021-06-24 00:00:00"},{"id":"6687c73a-8126-4a8d-87d3-e6ef4a4a7541","text":"WHO publication and recognition of \'post\u2011COVID\u201119 condition\' (long COVID) with a clinical case definition (Delphi consensus)","date":"2021-10-24 00:00:00"},{"id":"a3da8389-1854-464f-9071-1facf1abd8ae","text":"Regulatory authorisations and public announcements of updated (bivalent) COVID-19 boosters for fall 2022 citing the need to match evolving variants (FDA/other regulators authorization and press releases)","date":"2022-09-24 00:00:00"},{"id":"30b11eff-e7ca-4bee-af73-c2f03f82b017","text":"Transparency International / Global Corruption Barometer findings (2016) documenting pervasive corruption in Ukraine","date":"2016-11-24 00:00:00"},{"id":"e9d4c9ca-1b2f-418e-89f2-0bd5a5ab3b60","text":"World Customs Organization press release on a large heroin seizure in Ukraine (Odessa/Illichivsk), June 2015","date":"2015-06-24 00:00:00"},{"id":"d229b959-f62a-4326-b165-185f589fa0ec","text":"Polish government/NGO training and support for Ukrainian forces (Poland offered to train Ukrainian military staff)","date":"2015-04-24 00:00:00"},{"id":"59c8ecd3-dcf1-4d46-a641-b8280912e98d","text":"Documented reports of individual Polish nationals killed or wounded while fighting in Donbas","date":"2014-09-24 00:00:00"},{"id":"76aaf235-16e7-4043-87b9-a037084179e2","text":"NATO\'s enhanced forward presence and increased multinational troop rotations in Poland (2016)","date":"2016-07-24 00:00:00"},{"id":"a777797a-1eff-4aae-ba9a-393c85e471c6","text":"Contamination reports and temporary suspension of some Moderna vaccine batches in Japan","date":"2021-08-26 00:00:00"},{"id":"e9b6d363-8833-4dcf-9fb9-f2f319d33e06","text":"Regulatory and public reporting of rare myocarditis/pericarditis cases after mRNA COVID-19 vaccination","date":"2021-06-24 00:00:00"},{"id":"696c28a3-2f20-4d42-8e0d-62f761eeea35","text":"Media reports in late 2022 highlighting rising non-COVID excess deaths (e.g., increased deaths at home and concerns about NHS pressures)","date":"2022-09-20 00:00:00"},{"id":"7421a086-6509-4f46-82bf-090c02c96be4","text":"2015 transfer of HAARP operations from the U.S. Air Force to the University of Alaska\u2013Fairbanks (publicized as HAARP reopening for civilian research).","date":"2015-08-11 00:00:00"},{"id":"b8889937-ecac-4ac9-bc3b-db5291b944cb","text":"Reporting on the so\u2011called \\"Havana Syndrome\\" (2016\u20132018) and investigations into possible microwave or directed\u2011energy causes, including a 2018 New York Times piece.","date":"2018-09-01 00:00:00"},{"id":"c6b77d57-513c-48e9-ab99-530e20b9b255","text":"Venezuelan President Hugo Ch\xe1vez suggested HAARP or a \\"tectonic weapon\\" was responsible for the 2010 Haiti earthquake.","date":"2010-01-24 00:00:00"},{"id":"2dd36943-0a3d-4022-ae72-3e3e82b508b8","text":"Intense Russian airstrikes and attacks on Zhytomyr region widely reported in international media (creating fear of occupation and evacuation)","date":"2022-03-14 00:00:00"},{"id":"50e9b1a5-58e6-449a-9592-f8df840c444c","text":"IARC/WHO press release classifying processed meat as a Group 1 carcinogen","date":"2015-10-26 00:00:00"},{"id":"224eb8e3-f200-461f-8907-508a2b9b3610","text":"Longstanding public-health/home\u2011remedy guidance and consumer health sites recommend salt\u2011water gargles to soothe sore throats (widely available on NHS and similar sites)","date":"None"},{"id":"68fb7d61-8a80-4806-b215-988216fa2da2","text":"Previous French domestic plots / trials over assassination attempts on Macron (far-right militants convicted/trialed)","date":"2023-01-18 00:00:00"},{"id":"ac80497e-d83e-4314-9f0a-5428faff4d10","text":"France announced plans to send long-range SCALP missiles to Ukraine","date":"2024-01-16 00:00:00"},{"id":"83e06432-af9d-49ee-8785-9660b34df3ae","text":"French presidency postpones Macron\'s planned visit to Kyiv citing security concerns","date":"2024-02-11 00:00:00"},{"id":"a0b81173-c01e-4db3-8d19-28bc14e6c940","text":"IMF approved a large $17.5 billion extended loan programme for Ukraine, making Kyiv dependent on sizeable external financing and programme conditionality.","date":"2015-03-11 00:00:00"},{"id":"303cdd50-f46a-425f-9a12-202c5b188a35","text":"National Bank of Ukraine unexpectedly raised its key policy rate to 17.5% to combat inflation risks and warned that delays with IMF support posed a risk to stability.","date":"2018-07-12 00:00:00"},{"id":"a661cd4d-5ccb-4040-b44c-68d69c09f27c","text":"Government nationalised PrivatBank, Ukraine\'s largest commercial bank, to protect financial stability after identifying large capital shortfalls at the lender.","date":"2016-12-18 00:00:00"},{"id":"dcf67d9a-523a-4117-a894-d3df96daa21b","text":"The hryvnia plunged sharply in 2014 after the central bank abandoned foreign-currency auctions and the exchange rate was allowed to adjust amid political and security shocks.","date":"2014-02-05 00:00:00"},{"id":"85de426c-4f43-4b35-8b87-06cac94c009b","text":"Ukraine\'s President signed a package of laws and administrative measures in late 2015 intended to meet benchmarks for EU visa liberalisation.","date":"2015-11-21 00:00:00"},{"id":"1bca1c02-5747-4e14-8c7b-90781e35a9ae","text":"Ukraine announced introduction of new plastic/passport-card style internal passports to be issued from January 2016.","date":"2015-12-15 00:00:00"},{"id":"45e8dbea-ef86-4a3e-b6a7-9ccc36f702a6","text":"Direct air links and other travel ties between Russia and Ukraine were suspended/curtailed in 2015 (e.g., bans on direct flights announced in October 2015).","date":"2015-10-25 00:00:00"},{"id":"eec3301c-6f87-4401-930d-03b7ef07c902","text":"European Commission published its final report/conclusions on Ukraine\'s readiness for a visa-free regime with the EU (COM(2015)905) and related publicity in mid-December 2015.","date":"2015-12-18 00:00:00"},{"id":"d58e0908-63ef-49a4-a04a-de9c56a52d19","text":"Ukraine\'s Finance Minister Oleksandr Danyliuk warns Ukraine may forgo hosting due to high costs and urges sober assessment","date":"2016-05-18 00:00:00"},{"id":"124d3e56-edc4-466b-b738-7ed87500a778","text":"Government announces open national selection for host city and says municipalities/investors/donors must share financial risks","date":"2016-05-18 00:00:00"},{"id":"e4f2e2d6-c597-453c-9d79-887992f836c2","text":"Ukraine wins Eurovision 2016 (Jamala) \u2014 international expectation that Ukraine must host Eurovision 2017","date":"2016-05-15 00:00:00"},{"id":"c59f8085-e8f1-47e5-9183-a3ddc5d7fe72","text":"White House OSTP releases the Congressionally-Mandated Report on Solar Radiation Modification (SRM) research plan","date":"2023-06-30 00:00:00"},{"id":"160f517a-6e02-4912-8876-ce86f1747260","text":"Mexican government announces a ban on solar geoengineering experiments (SEMARNAT press release)","date":"2023-01-13 00:00:00"},{"id":"4a818227-ff11-402e-a17a-fbc4c82f1188","text":"Israel\'s booster campaign and reporting in July\u2013August 2021 on reduced effectiveness of two doses vs Delta and need for third dose","date":"2021-08-24 00:00:00"},{"id":"d77a013e-9d44-4c1a-932a-64582226c64c","text":"CDC reverses earlier guidance and on July 27, 2021 recommends indoor masking for vaccinated people in areas of substantial/high transmission","date":"2021-07-27 00:00:00"},{"id":"64c78ccf-c8c4-4ead-8edb-781fec01ab6f","text":"U.S. federal Order requiring masks on conveyances and at transportation hubs (published in Federal Register, Feb 2021)","date":"2021-02-24 00:00:00"},{"id":"58e8eec0-3b18-4176-8e32-256e25f75ccf","text":"CDC MMWR report on Barnstable County (Provincetown) outbreak showing many vaccine breakthrough infections","date":"2021-07-24 00:00:00"},{"id":"5969a8a1-4412-4685-bc71-abc76f654bf5","text":"Japan suspended ~1.63 million doses of Moderna vaccine over reports of foreign particles (August 2021)","date":"2021-08-24 00:00:00"},{"id":"eb813a15-f200-42e5-aaa7-c964a2b141b5","text":"European Medicines Agency (EMA) concluded there was a possible link between AstraZeneca\'s vaccine and very rare blood clots (April 7, 2021)","date":"2021-04-07 00:00:00"},{"id":"949dcc31-8461-43ae-8be2-e1d0b363bfef","text":"NATO publicly said Viktor Orb\xe1n\u2019s planned Moscow trip had been flagged to the alliance in advance.","date":"2024-07-05 00:00:00"},{"id":"a4448971-d689-4aa9-b2a8-e18c28b5e01a","text":"Serbian President Aleksandar Vu\u010Di\u0107 attended Russia\u2019s Victory Day events in Moscow (including presence at May 9 commemorations) and posted images from the trip.","date":"2025-05-09 00:00:00"},{"id":"1d22170c-0274-426b-b23c-8246a6c999a1","text":"Slovak Prime Minister Robert Fico made a surprise visit to Moscow and met with President Vladimir Putin.","date":"2024-12-22 00:00:00"},{"id":"411db0b4-901a-44af-8084-684c94c06f35","text":"Amnesty International briefing calling on Ukrainian authorities to investigate abuses by Aidar and other volunteer battalions operating alongside regular forces","date":"2014-09-08 00:00:00"},{"id":"8653b865-d36c-4dbc-b92c-f6d7d328d961","text":"OSCE Special Monitoring Mission spot report on civilian fatalities and damage after shelling of residential areas in Donetsk","date":"2014-08-24 00:00:00"},{"id":"2dd99937-465a-40c8-a6d1-1ba80f7b7fff","text":"Assassination of Denis Voronenkov, a Russian defector, who was shot dead in Kyiv","date":"2017-03-23 00:00:00"},{"id":"2d2427a3-25b4-4670-834e-c8c9a8e08566","text":"UN General Assembly adopted a resolution (March 2, 2022) overwhelmingly deploring Russia\'s aggression and stating it was in violation of the UN Charter.","date":"2022-03-02 00:00:00"},{"id":"7d7620e7-0394-4b49-be2c-d52df53b66de","text":"Russia formally recognized the independence of the Donetsk and Luhansk People\'s Republics and ordered troop deployments to the regions.","date":"2022-02-21 00:00:00"},{"id":"508ef568-3b2c-4f93-8997-e4cfbd121e8f","text":"President Vladimir Putin announced a \'special military operation\' in Ukraine, describing aims like \'demilitarisation\' and protection of people in Donbas.","date":"2022-02-24 00:00:00"},{"id":"6239eff8-9991-47ad-9ee9-6bc9fa41b6eb","text":"Announcements that Ukraine would open additional consulates in Poland to assist large numbers of Ukrainian citizens/refugees.","date":"2022-05-24 00:00:00"},{"id":"0b3ba769-29b9-4fac-ba68-f45045bf2631","text":"Polish President Andrzej Duda visited Kyiv and addressed Ukraine\'s parliament, emphasizing deep political solidarity and saying only Ukraine should decide its future (public statements of unity).","date":"2022-05-22 00:00:00"},{"id":"760b1750-990f-45c0-9982-41b2b2e88cad","text":"Earlier Russian security/intelligence figures publicly alleged Polish preparations to annex parts of western Ukraine (remarks by Russian officials reported Nov 30, 2021 onward).","date":"2021-11-30 00:00:00"},{"id":"5969d7ad-90fb-4499-bbf5-9843fb61ef4d","text":"Pro\u2011Russian activists in Kharkiv occupied the regional administration and declared a short\u2011lived \'Kharkiv People\'s Republic\'.","date":"2014-04-07 00:00:00"},{"id":"6ff8e77e-ba6f-462b-a50c-91dc2a48055b","text":"Deadly clashes in Odesa on 2 May 2014, culminating in a Trade Unions House fire with dozens killed.","date":"2014-05-02 00:00:00"},{"id":"33b7cce7-6173-4e38-aa9d-73da5ad3355f","text":"Parliamentary moves in Feb 2014 to repeal the 2012 \'regional language\' law and intense debate over language rights.","date":"2014-02-24 00:00:00"},{"id":"3fdc70af-ac57-4ada-b88e-beebc38d0f90","text":"Widespread pro\u2011Russian \'anti\u2011Maidan\' protests and occupations across eastern and southern Ukraine (including demonstrations in Mykolaiv) in March\u2013April 2014.","date":"None"},{"id":"9535fc4f-b8d2-4d71-99c2-51c24b82dd25","text":"May 2014 \'referendums\' in parts of Donetsk and Luhansk and subsequent Russian recognition of separatist results.","date":"2014-05-11 00:00:00"},{"id":"ac8cea3c-51b4-4003-bc71-dc8e7da0cc9e","text":"Mass drone attacks and reported strikes on Kursk region (fires, evacuations)","date":"2022-04-15 00:00:00"},{"id":"0b6ab1bc-2c8c-43f5-9de1-58ee61492950","text":"Tymoshenko proposes creation of an \'operative headquarters\' of defense and military specialists to respond to Russian aggression","date":"2014-03-21 00:00:00"},{"id":"a2d53ef1-9deb-433a-bcf9-59077120797c","text":"A draft resolution to dismiss Prime Minister Yatsenyuk is registered in the Verkhovna Rada (parliament) after coalition tensions","date":"2016-02-22 00:00:00"},{"id":"bc1bbdf3-ee43-42da-a74c-f41e1bb52a7b","text":"Leader of Batkivshchyna (Yulia Tymoshenko) announces her party is quitting Ukraine\u2019s ruling coalition","date":"2016-02-17 00:00:00"},{"id":"2aac0bf8-5dda-4fc1-8da7-cdae83559eaa","text":"Parliament holds and fails to pass a no\u2011confidence motion against Prime Minister Arseniy Yatsenyuk, deepening government crisis","date":"2016-02-16 00:00:00"},{"id":"0ee0eddc-d7aa-4f78-aae9-6008e205e5c4","text":"National Snow and Ice Data Center (NSIDC) satellite record: Antarctic sea ice reached a daily/seasonal maximum record (20.11 million km\xb2) on 22 September 2014.","date":"2014-09-22 00:00:00"},{"id":"262af7ff-dfe7-464a-b640-3f6df9d3723b","text":"Peer-reviewed synthesis and high-profile press coverage showing Antarctic land-ice (ice sheet) mass loss accelerated in recent decades (IMBIE / Nature analysis publicized June 2018).","date":"2018-06-14 00:00:00"},{"id":"a77f5498-680a-46a4-8c8a-659c9ad02c00","text":"Research identifying the Southern Annular Mode (SAM), ozone\u2011hole effects, and wind-driven ocean processes as major drivers of Antarctic sea-ice variability (peer-reviewed work and reviews, mid-2010s).","date":"2015-04-24 00:00:00"},{"id":"04f22358-3b13-4ad6-bbda-ad0691b60927","text":"Amnesty International / IBGDH report documenting human-rights abuses and environmental harm linked to cobalt mining in the Democratic Republic of Congo.","date":"2024-01-22 00:00:00"},{"id":"f24b52b9-187c-4eec-8711-93153d4d2fee","text":"AP and international reporting on environmental concerns around large nickel/nickel-processing projects for EV batteries in Indonesia (coverage of environmental NGO warnings about mining/processing impacts).","date":"2024-07-24 00:00:00"},{"id":"2843540f-04ab-4329-b579-f43852502201","text":"Major media coverage summarising life\u2011cycle analyses that show EV battery manufacture can be carbon\u2011intensive (New York Times feature on EV battery emissions).","date":"2024-01-10 00:00:00"},{"id":"7e546993-ae27-482d-9f03-1b53ca0e72db","text":"IEA Electricity Mid\u2011Year Update 2024 noting faster global electricity demand growth and a temporary plateau in power\u2011sector emissions in 2024.","date":"2024-07-24 00:00:00"},{"id":"b6069ba0-2a14-45d6-b5a3-a9991a32bcd8","text":"IPCC Fifth Assessment Report (AR5) release documenting observed increases in sea\u2011level rise rate and attributing recent changes largely to human influence","date":"2013-09-27 00:00:00"},{"id":"87f67770-7faf-4358-9b25-7f35afac9ecb","text":"NOAA / national tide\u2011gauge and satellite datasets made public (NOAA sea level trends pages and graphics widely cited in media, 2013\u20132016)","date":"2016-06-24 00:00:00"},{"id":"2e3dcc2e-b0aa-4f90-82b8-edb47f445bdf","text":"Visa\u2011free travel for Ukrainian citizens to the Schengen area came into effect","date":"2017-06-11 00:00:00"},{"id":"927daa80-8d17-4253-a012-2b0496609a1f","text":"Launch of the European Union Advisory Mission (EUAM) to Ukraine (civilian security reform)","date":"2014-12-24 00:00:00"},{"id":"2dda5801-f3e2-4728-9ede-9738720b171d","text":"Signing of the EU\u2013Ukraine Association Agreement (including Justice, Freedom and Security provisions)","date":"2014-06-27 00:00:00"},{"id":"69a5cfbd-e0c9-413a-947b-94501669f10a","text":"2008 EFSA scientific opinion sets a tolerable weekly intake for aluminium and warns dietary exposure may exceed it","date":"2008-07-15 00:00:00"},{"id":"b81d08a2-2cb2-4ded-a06d-29e265a6d632","text":"State-level restaurant COVID\u201119 prevention checklist (published Aug 14, 2020) that included the specific line about inverted face shields for front\u2011of\u2011house staff.","date":"2020-08-14 00:00:00"},{"id":"5e70da93-c4f2-4f6b-9b2a-9f4c35177f2a","text":"Passage and implementation of laws and measures recognizing certain WWII-era Ukrainian nationalist formations (e.g., granting veteran status to surviving members of the Ukrainian Insurgent Army in 2019) and debates about nationalist memory.","date":"2019-03-26 00:00:00"},{"id":"4f9fbad5-3926-4330-9231-602c807d9d2e","text":"Earlier controversy over proposals to \'universalize\' the Babi Yar memorial (design competition and wording), which Jewish groups and historians publicly criticized as potentially downplaying the site\'s Holocaust significance.","date":"2016-02-08 00:00:00"},{"id":"92f66f72-43b4-497a-9e25-a38242dd5f57","text":"Decommunization laws and large-scale removal/renaming of Soviet-era monuments and symbols (2015) that shifted public commemorations and provoked international debate over historical memory in Ukraine.","date":"2015-04-13 00:00:00"},{"id":"169afb32-d558-4121-85b8-678d1f854a12","text":"NIA-AA (National Institute on Aging\u2013Alzheimer\'s Association) publishes revised diagnostic framework recognizing preclinical stages of Alzheimer\'s disease","date":"2011-03-24 00:00:00"},{"id":"abe79f6a-6008-4d68-8b84-c8dd5a00e893","text":"OSCE Special Monitoring Mission spot reports of repeated shelling incidents in Donetsk city (late January 2015)","date":"2015-01-31 00:00:00"},{"id":"47955cc0-e7b0-4d67-90f8-bf03cce5c3ad","text":"Amnesty International briefing documenting summary/extrajudicial killings in eastern Ukraine","date":"2014-10-24 00:00:00"},{"id":"686cbbb5-3b5e-483b-bc76-96a077264b04","text":"Shelling of Mariupol market and residential areas, killing dozens of civilians","date":"2015-01-24 00:00:00"},{"id":"bc31032f-4bbc-481c-82b3-4468226d167e","text":"Reports documented Ukrainian policemen and small military units in eastern Ukraine siding with or defecting to pro-Russian separatists during the spring 2014 unrest.","date":"2014-04-16 00:00:00"},{"id":"c2be8edd-44a2-4024-b0f0-bac5f6a20d1f","text":"Pro\u2011Russian separatists shot down a Ukrainian military helicopter in late May 2014 and widely publicized battlefield successes and captures.","date":"2014-05-29 00:00:00"},{"id":"ee1c0bf2-b738-419c-bb84-dd8840a8d165","text":"ISUOG/other professional statements discouraging non\u2011diagnostic/\'keepsake\' ultrasound use (position on non\u2011diagnostic ultrasound)","date":"2020-04-08 00:00:00"},{"id":"809ebb4c-3f56-4172-af62-1fc98346939d","text":"Small clinical study reporting increased apoptosis in human chorionic villus cells after transvaginal ultrasound exposure","date":"2015-12-29 00:00:00"},{"id":"d9deaf4c-cb27-4ca9-b33c-ee26766559df","text":"Reports that politicians and foreign diplomats joined or publicly supported Kyiv Pride 2019","date":"2019-06-23 00:00:00"},{"id":"e70b85f7-dbf0-4789-b87e-40b9be1f108a","text":"Eurovision Song Contest hosted in Kyiv with \'Celebrate Diversity\' messaging (Eurovision 2017)","date":"2017-05-11 00:00:00"},{"id":"78dd797c-54e9-4f5a-a617-5c04890789c2","text":"Kharkiv region introduced scheduled/rolling electricity restrictions (blackout schedules) for large numbers of consumers after infrastructure damage.","date":"2024-03-24 00:00:00"},{"id":"9641230b-18d7-4122-9fbb-ad268a1ededd","text":"Ukrenergo announced plans to export a record volume of electricity (planned 13,264 MWh) to neighboring EU countries on March 4, 2024.","date":"2024-03-04 00:00:00"},{"id":"2296956b-5cc1-4ebe-b1da-37bf012fbce7","text":"Russian missile/drone strikes on Kharkiv energy infrastructure knocked out power across the city.","date":"2024-03-23 00:00:00"},{"id":"8ee72d39-4d72-44c4-980c-975cb4158fdd","text":"Official public messaging (e.g., Ukrainian energy minister and Ukrenergo statements) emphasizing that exports occur only when domestic supply is sufficient and that domestic priority is maintained.","date":"2023-04-11 00:00:00"},{"id":"e1bd328a-fc69-4d68-98f7-b98c02516111","text":"National Weather Service offices issued multiple Flash Flood Warnings and at least one Flash Flood Emergency for the Guadalupe River corridor (noting automated gauges and forecasts indicated a large, deadly flood wave).","date":"2025-07-05 00:00:00"},{"id":"6fcc605f-4d96-49ba-a217-c52dcb746b17","text":"Reports of foreign/black particles found in some Moderna vials in Japan led to temporary suspension/recall of batches (September 2021).","date":"2021-09-17 00:00:00"},{"id":"daa821fd-4236-4099-99dd-b7d11d6b3c21","text":"Publication of Israeli population-based analyses documenting cases of myocarditis after BNT162b2 (Pfizer\u2013BioNTech) vaccination (peer\u2011reviewed NEJM report).","date":"2021-10-24 00:00:00"},{"id":"1f08bcd4-2a1d-4977-b630-3d154862b9ea","text":"U.S. FDA and other regulators moved in 2016\u20132018 to restrict or review certain antiseptic/antimicrobial ingredients (e.g., FDA final rule on triclosan and other antiseptic ingredients in consumer wash products in Sept 2016).","date":"2016-09-24 00:00:00"},{"id":"7fb40a00-2db2-4859-bcb8-efde1a71fcd3","text":"Ukraine\u2019s State Service for Drug Control recalled 18 products manufactured by the Bioorganic Chemistry Institute\u2019s experimental plant (licensing violations reported).","date":"2019-03-24 00:00:00"},{"id":"c186eca9-cb1d-40c3-8028-d9f201e6a3e2","text":"Public controversy and intense debate around Suprun\u2019s health\u2011care reforms (wide press and academic coverage, including critical and supportive pieces in 2017\u20132018).","date":"2018-04-24 00:00:00"},{"id":"21cd4a11-f1ba-46ec-a6dc-887af328374c","text":"FDA expanded Emergency Use Authorization for the Pfizer\u2013BioNTech COVID-19 vaccine to adolescents aged 12\u201315.","date":"2021-05-10 00:00:00"},{"id":"2fb180ca-ccca-473d-8d00-71aae8a614b0","text":"Discovery of foreign (stainless steel) particles in some Moderna vaccine vials in Japan led to temporary lot suspensions and recalls.","date":"2021-09-24 00:00:00"},{"id":"da5bdb7e-c330-4097-95b5-1c0cdf432346","text":"Public reports and CDC/ACIP review of rare myocarditis/pericarditis cases occurring after mRNA vaccination in adolescents and young adults.","date":"2021-06-24 00:00:00"},{"id":"1de7f983-9b61-4d4d-a604-7ae975daa70a","text":"The Orthodox Church of Ukraine and other Ukrainian church bodies publicly reiterated they do not endorse Halloween celebrations (OCU posted an explanatory statement on its official Facebook page on the eve of Halloween).","date":"2023-10-30 00:00:00"},{"id":"dac0ff89-f538-4798-8227-cd94c172c6b7","text":"WHO and national agencies adopted/issued interim coding guidance and the emergency ICD-10 code (U07.1) for COVID-19 to standardize mortality reporting in Spring 2020.","date":"2020-04-20 00:00:00"},{"id":"70beb357-6a2a-4e2e-93fd-f7fd7bfede7a","text":"Local jurisdictions (notably New York City) added \'probable\' COVID-19 deaths to counts in April 2020, producing sudden, large increases in reported death totals.","date":"2020-04-14 00:00:00"},{"id":"2619669f-b128-4efa-8cc9-544630bf09b8","text":"Launch of the EU External Investment Plan (EIP) / European Fund for Sustainable Development","date":"2017-09-24 00:00:00"},{"id":"1946fa2c-944a-4cb0-8bb6-4f8595248750","text":"EU\u2013Turkey migration statement and related migration-management deals","date":"2016-03-18 00:00:00"},{"id":"814b1bb7-0051-487e-ae27-1276aa74b620","text":"Establishment and deployment of EU military training missions in the Sahel (EUTM Mali)","date":"2013-02-18 00:00:00"},{"id":"1c362657-65ac-483d-b15c-54a082028700","text":"UK Health Security Agency technical briefing reporting substantially reduced vaccine effectiveness against symptomatic Omicron (Technical Briefing, Dec 31, 2021).","date":"2021-12-31 00:00:00"},{"id":"843a68e2-a58f-4338-b608-d0b676ff0f44","text":"Mainstream news coverage summarising Danish results and the impact of boosters (e.g., Reuters coverage, Dec 22, 2021).","date":"2021-12-22 00:00:00"},{"id":"1f642949-2156-4f56-b000-f294eb9b083d","text":"Poroshenko publicly sought NATO/allied military cooperation and repeatedly called for allied support at NATO meetings (joint press conference at NATO Headquarters).","date":"2016-07-09 00:00:00"},{"id":"ea0b0740-6fca-4192-a6bd-8b7c7e497256","text":"Visible NATO exercises and increased allied air policing on NATO\u2019s eastern flank (e.g., NATO and partner air forces training over the Baltic Sea, April 21, 2016).","date":"2016-04-21 00:00:00"},{"id":"f23e3f2b-f8a9-4d5a-b9d1-4e6e721675c4","text":"Frontiers in Microbiology review highlighting mechanisms and clinical interest in manuka honey\'s antibacterial properties.","date":"2016-04-24 00:00:00"},{"id":"a9eb3402-7303-4e26-985e-bfb6e2b7be5c","text":"FDA approval of Flucelvax Quadrivalent (cell\u2011based quadrivalent influenza vaccine) and release of package/clinical documents mentioning MDCK cells","date":"2016-05-24 00:00:00"},{"id":"3ea68c64-9773-43d9-b4c2-7c341b643338","text":"Russian forces seized and occupied the Kakhovka (Nova Kakhovka) Hydroelectric Power Plant; satellite imagery showed Russian troops and equipment at the facility.","date":"2022-02-26 00:00:00"},{"id":"f25fde5f-d782-4e1d-a20a-3752b8c3828e","text":"The Kakhovka HPP and Nova Kakhovka were repeatedly struck and reported damaged during summer 2022 (including reported HIMARS strikes on July 11, 2022).","date":"2022-07-11 00:00:00"},{"id":"356d7c96-6a41-41d1-9ef7-86159595457f","text":"Arson and vandalism of mobile phone masts reported in the UK","date":"2020-04-04 00:00:00"},{"id":"9f3650f7-0c90-47bb-af37-8f56e9051440","text":"Russian drone strike destroyed the Roman Shukhevych (UPA) Museum on the outskirts of Lviv.","date":"2024-01-01 00:00:00"},{"id":"28f26c81-8a2a-42ab-9758-c215f76bbf76","text":"Widespread reporting since 2022 documented Russian forces looting and removing artifacts from Ukrainian museums (establishing a precedent of cultural theft and illicit sales).","date":"2022-10-24 00:00:00"},{"id":"178ae6f4-e2fb-4589-8996-268c104878a0","text":"Implementation of the 2004 education reform increasing Latvian-language instruction in minority schools (the \'60/40\' reform)","date":"2004-09-24 00:00:00"},{"id":"716f9129-429d-4988-894a-cd8a8d7da4ab","text":"2012 constitutional referendum on making Russian a second official language, which was decisively rejected (18 February 2012)","date":"2012-02-18 00:00:00"},{"id":"f9fba1bc-a280-42e9-9fad-8c755abff63c","text":"A 2022 edition of 11th\u2011grade history outline maps was published by Kartohrafiya (ISBN 978-966-946-460-6), a commonly used educational map source in Ukraine.","date":"2022-04-24 00:00:00"},{"id":"5da27d33-a165-42f5-9ec2-6d118ebb37f9","text":"Precedent of flights from occupied Crimea to third countries (despite sanctions) documented in prior years (examples 2016\u20132018), showing routes and carriers operating non\u2011Ukrainian international services.","date":"2017-04-24 00:00:00"},{"id":"08515554-be3a-4ebe-a6df-471d24dee1cc","text":"Russian carrier Ikar (Pegas Fly) reported/planned to launch flights linking Yerevan and Simferopol (Crimea).","date":"2019-12-18 00:00:00"},{"id":"5b4121b9-67b7-407d-86b8-6053c136b87d","text":"Major cancer-care organizations publish warnings that there is no reliable clinical evidence soursop (graviola) cures cancer and note potential harms","date":"2017-07-24 00:00:00"},{"id":"074ea38c-520c-4e9a-9ef5-c4ca7b784287","text":"Peer-reviewed isolation and characterization of annonaceous acetogenins from Graviola showing potent in vitro anti-proliferative activity against human cancer cell lines","date":"2019-12-03 00:00:00"},{"id":"d791cfa0-d2a4-464f-ac69-75d53f3d4c82","text":"State\u2011level legislative changes and debates in 2024 expanding legality or easing restrictions on raw\u2011milk sales (e.g., new limited sales allowances in some states)","date":"2024-04-24 00:00:00"},{"id":"fde86755-d0a9-411a-af01-148da957be9e","text":"Large disruptions and later rebounds in cancer screening and diagnoses during the COVID\u201119 pandemic became widely reported (fewer screenings in 2020 then partial catch-up), creating confusing temporal patterns in cancer incidence data.","date":"2023-09-27 00:00:00"},{"id":"ae975e0a-9f37-43c4-b84a-500496a03681","text":"OSCE Special Monitoring Mission (SMM) spot reports documenting civilian casualties and intensified fighting in Donetsk and Luhansk in October 2014.","date":"2014-10-14 00:00:00"},{"id":"189499fe-3131-447b-81e9-4435db4e85e3","text":"UN Office of the High Commissioner for Human Rights (OHCHR) report on the human rights situation in the context of the anti\u2011terrorist operation (ATO) documenting detentions, abuses and civilian harm (July 2014).","date":"2014-07-15 00:00:00"},{"id":"4a4972c4-ebf7-4cb8-b0ee-1b43206b1ab9","text":"President Petro Poroshenko and other Ukrainian officials publicly described pro\u2011Russian fighters as \'terrorists\' in mid\u20112014 interviews and statements.","date":"2014-07-21 00:00:00"},{"id":"478dbf82-e1cb-4626-aad1-f4c4b525dc5d","text":"High\u2011profile activity and imagery of far\u2011right Ukrainian groups (e.g., Svoboda torchlit march, January 2014) widely reported in international media.","date":"2014-01-01 00:00:00"},{"id":"c06642ac-1f2d-495f-bf42-2bc2972cbcb7","text":"Russia blocked a Western-backed UN Security Council statement condemning the shelling of Mariupol.","date":"2015-01-25 00:00:00"},{"id":"a5ad7c31-c1a4-480a-8ab4-6e28f34870f9","text":"UN Secretary-General Ban Ki-moon publicly condemned the rocket attack on Mariupol in a UN spokesperson/secretariat statement.","date":"2015-01-24 00:00:00"},{"id":"296b6c7f-df17-4502-8c74-8f18015dfa39","text":"OSCE Special Monitoring Mission (SMM) spot report and multiple media outlets reported heavy MLRS/rocket shelling in Mariupol with dozens of civilian casualties.","date":"2015-01-24 00:00:00"},{"id":"e1934800-b8b0-4559-889b-9c4513fb2b1b","text":"CDC MMWR report on allergic reactions (including anaphylaxis) after first doses of Pfizer\u2011BioNTech vaccine (covering Dec 14\u201323, 2020)","date":"2021-01-06 00:00:00"},{"id":"58a96d05-0b9c-4ddb-ad56-31b85def6114","text":"FDA VRBPAC briefing and safety review documents for Moderna COVID-19 vaccine (presented to advisory committee)","date":"2020-12-17 00:00:00"},{"id":"000f23a7-2222-41ea-8898-e7d063735ef4","text":"Publication of Moderna (mRNA-1273) Phase 3 (COVE) trial reporting safety/reactogenicity data in NEJM","date":"2020-12-30 00:00:00"},{"id":"da7cdfd4-e436-4cad-bf96-fd39255cf969","text":"WHO/UNICEF reporting on Sudan circulating vaccine\u2011derived poliovirus type 2 (cVDPV2) outbreak (declared Aug 2020; press coverage Sept 2020)","date":"2020-09-08 00:00:00"},{"id":"a9d50388-6ca1-489b-898c-03077d503b07","text":"CFSRE (Center for Forensic Science Research & Education) issues Q2 2024 Trend Report documenting rising harms, emergency admissions and deaths linked to synthetic cannabinoids (K2/Spice), and distinguishes these products from plant cannabis.","date":"None"},{"id":"52ea576d-ff1d-436f-859a-e066258b724d","text":"Peer\u2011reviewed study (Journal of Cannabis Research) publishes results (April 6, 2024) reporting that a history of cannabis use was associated with lower in\u2011hospital mortality among hospitalized COVID\u201119 patients in a large national inpatient sample.","date":"2024-04-06 00:00:00"},{"id":"785991ad-3948-4077-af87-943e2698d44d","text":"White House issues \'Statement from President Biden on Marijuana Reform\' (October 6, 2022) and subsequent federal/state-level policy shifts and public discussions around decriminalization/rescheduling continue through 2023\u20132024.","date":"2022-10-06 00:00:00"},{"id":"d668f105-1438-4350-8827-74d6bed57b76","text":"Systematic reviews and clinical\u2011trial summaries (e.g., Antioxidants 2018; other reviews and NIH/NCI summaries) documenting safety, mixed/limited efficacy signals, and ongoing early\u2011phase trials of high\u2011dose IV ascorbate in cancer therapy.","date":"2018-07-12 00:00:00"},{"id":"280cc982-fb5f-405a-abd0-135f9de11b7c","text":"Longstanding promotion and clinical use of IV vitamin C by integrative clinics (e.g., Riordan Clinic) including published protocols and patient\u2011case material used to market IVC as an adjunctive cancer therapy.","date":"2020-09-24 00:00:00"},{"id":"e0131c57-979b-4eb6-b1b9-b63edb856c71","text":"Emergency use authorizations and publication of phase\u20113 results for mRNA COVID\u201119 vaccines (Pfizer/BioNTech and Moderna) in late 2020","date":"2020-12-11 00:00:00"},{"id":"3f2c5b38-deba-475d-9cd7-11385395e7d5","text":"WHO guidance advising that ivermectin should only be used to treat COVID\u201119 within clinical trials","date":"2021-03-31 00:00:00"},{"id":"137c84f5-23db-45e6-bf92-1ad74275d3e1","text":"WHO request and international attention on China\u2019s late\u20112023 surge in pediatric respiratory illnesses","date":"2023-11-24 00:00:00"},{"id":"fa0db7ed-df89-44b6-a5c6-2ada5165a15e","text":"High\u2011profile reporting in 2023 about widespread chemical contaminants in U.S. tap water (PFAS / \'forever chemicals\')","date":"2023-07-06 00:00:00"},{"id":"1feb038d-92fc-4cd4-b25c-1c1a29e47dd3","text":"August 2021 discovery of foreign particles in some Moderna COVID\u201119 vaccine vials in Japan (batches paused)","date":"2021-08-26 00:00:00"},{"id":"3d6a2ff0-9932-4048-b809-b1b21ab52912","text":"Event 201 pandemic tabletop exercise (Johns Hopkins/WEF/Bill & Melinda Gates Foundation)","date":"2019-10-18 00:00:00"},{"id":"b05052a3-07ad-456f-8def-ea0241666317","text":"Arrest and conviction of Ukrainian filmmaker Oleg Sentsov on terrorism charges (Crimea cases)","date":"2015-08-24 00:00:00"},{"id":"9dc7cfa4-60c3-46e9-93bd-b1dcaab98aee","text":"UAE action and reporting around Russian-linked assets and banks (examples: cancellation of MTS Bank licence)","date":"2023-03-31 00:00:00"},{"id":"4aac8468-0db8-44dd-a4a0-aa92932348ac","text":"Ukrainian authorities charged individuals in an embezzlement scheme linked to arms procurement (~$40 million)","date":"2024-01-27 00:00:00"},{"id":"4f074f04-ff3f-4ca6-9b9f-456a41c79af3","text":"Pentagon Inspector General report finding about $1 billion in U.S. weapons to Ukraine not properly tracked","date":"2024-01-11 00:00:00"},{"id":"3b1efc1f-a8b5-40d7-afb8-47b5c2d8c3eb","text":"Pandora Papers release showing extensive use of UAE-linked offshore structures","date":"2021-10-24 00:00:00"},{"id":"563ef7e7-3e70-4f08-8a0d-494367c53a15","text":"Greenpeace \'Dirty Laundry\' investigative reports exposing toxic discharges from textile supply chains","date":"2011-08-24 00:00:00"},{"id":"272d4ca0-a4cb-4498-a278-ed962e7fb8a9","text":"Publication of \'A New Textiles Economy\' report by the Ellen MacArthur Foundation (widely cited analysis of fashion\'s environmental footprint)","date":"2017-04-24 00:00:00"},{"id":"14e70229-d758-4a9f-b726-1a569c1c76d6","text":"Peer\u2011reviewed studies (2017) quantifying microfiber shedding from synthetic textiles as a major source of microplastics","date":"2017-04-24 00:00:00"},{"id":"d4ac0cf9-cde0-4c2c-8550-238510e5a0dc","text":"CDC/ACIP review and MMWR reporting of myocarditis and pericarditis cases following mRNA COVID-19 vaccination","date":"2021-06-24 00:00:00"},{"id":"43003400-9f69-4899-b6b9-65d8858ef0a2","text":"Regulatory findings and media coverage of rare blood\u2011clotting events linked to the AstraZeneca COVID-19 vaccine (EMA review)","date":"2021-04-24 00:00:00"},{"id":"22510ace-caed-4962-8f00-efe8b2b3bdc5","text":"Sinking of the Russian cruiser Moskva in mid-April 2022 near the Black Sea theatre","date":"2022-04-14 00:00:00"},{"id":"a5875c2f-fc37-4929-a261-fb5eb0b601e3","text":"Ukrainian forces raised the Ukrainian flag on Snake Island after Russian withdrawal","date":"2022-06-30 00:00:00"},{"id":"bf690599-cad5-45dd-ae9a-0dfd9300fe11","text":"Enactment of Ukraine\'s decommunization laws","date":"2015-05-15 00:00:00"},{"id":"34cc607d-07f1-4fcf-961e-cc2ed5410530","text":"Kyiv City Council renamed General Vatutin Avenue to Roman Shukhevych Avenue","date":"2017-06-01 00:00:00"},{"id":"f1e6c65f-d792-4cb8-9f39-7aafac76aea6","text":"OSCE Special Monitoring Mission observed civilian fatalities and bodies after shelling in Donetsk","date":"2014-08-23 00:00:00"},{"id":"67fe157c-0a35-49a8-8f21-5628c7797662","text":"Odessa Trade Union House fire and mass fatalities during clashes","date":"2014-05-02 00:00:00"},{"id":"1e8752b2-0404-4776-b8b8-8e69b8687848","text":"Killing and torture of local politician Volodymyr Rybak reported from Donetsk region","date":"2014-04-22 00:00:00"},{"id":"157ab812-4359-4349-aa5a-6276969f1acf","text":"Exhumation of a mass grave in Sloviansk, eastern Ukraine","date":"2014-07-24 00:00:00"},{"id":"7c180cef-775f-4dc0-b7a2-7d8d5e88625c","text":"UNICEF launched a humanitarian cash transfer programme in Ukraine (real cash payments to vulnerable families began in March 2022).","date":"2022-03-24 00:00:00"},{"id":"d4e97c40-281a-46e0-9b44-cf5ed299a47d","text":"Sharp rise in Telegram (early 2022) and already-dominant Viber use (Ukraine: high market share reported Sept 2021) as primary messaging channels in the region.","date":"None"},{"id":"76f11f64-6713-42b7-b4fe-4a91b078dc1d","text":"French farming unions warned they could stage further protests and blockades (reported March 3, 2024).","date":"2024-03-03 00:00:00"},{"id":"c7046dc0-2120-433b-b1ad-372ce5830178","text":"President Macron publicly said he did not \\"rule out\\" sending Western troops to Ukraine during a leaders\' meeting in Paris.","date":"2024-02-27 00:00:00"},{"id":"3c63c480-f1c1-4956-8ba8-123730a4a02a","text":"IUCN Polar Bear Specialist Group released its 2023 status/criteria report on polar bear subpopulations and abundance estimates (PBSG status report, Oct 2023).","date":"2023-10-17 00:00:00"},{"id":"c48786c0-3d01-4cc0-beef-55fd9048d74a","text":"The Oceanography Society / research syntheses in 2023 published accessible overviews of observational evidence for ongoing global surface ocean acidification.","date":"2023-04-24 00:00:00"},{"id":"8aebfe7f-59bd-447a-9883-1dfe71623e69","text":"NOAA/SWPC issued a revised forecast that Solar Cycle 25 would rise more quickly and peak higher than earlier predictions, and highlighted recent large solar flares (X\u2011class) in late 2023.","date":"2023-10-25 00:00:00"},{"id":"4ded90c5-3a0b-4383-8c98-2eb06d50795b","text":"Peer\u2011reviewed 2023 papers documented high spatial and temporal variability in coastal and upwelling pH (e.g., high\u2011frequency pH dynamics in regional systems), showing local short\u2011term pH fluctuations.","date":"2023-04-24 00:00:00"},{"id":"5b44d227-cd48-4625-802b-e02870b36ce5","text":"U.S. federal political actions and rhetoric undermining climate policy (example: President Trump announces withdrawal from Paris Agreement)","date":"2017-06-01 00:00:00"},{"id":"6c7bfa6f-971f-46b6-bd04-14ad038adf97","text":"Nature Climate Change paper: \'Temporary reduction in daily global CO2 emissions during the COVID\u201119 forced confinement\'","date":"2020-05-19 00:00:00"},{"id":"94bceffe-abc3-44c2-a2eb-2ddc58173a11","text":"Violent clash between rival Orthodox groups at St. Michael\'s Cathedral in Cherkasy","date":"2024-10-17 00:00:00"},{"id":"57923ade-9ad9-40e2-82c9-f707f057bcfe","text":"Local reporting about the contested transfer/seizure of the cathedral and services held in Ukrainian amid the dispute","date":"2024-10-17 00:00:00"},{"id":"e77c2457-bcbb-44c5-98ef-1183f378c60e","text":"Russia/occupation authorities ban the Mejlis of the Crimean Tatar people as \'extremist\'","date":"None"},{"id":"d42c2acc-9cb7-4e82-b0d1-beeb3deb20d8","text":"Surge in positive public attitudes toward Stalin in Russia (Levada poll, April 2019)","date":"2019-04-16 00:00:00"},{"id":"51ced9e6-1f43-4883-977d-d0e20fe66a54","text":"Release and public circulation of National Toxicology Program (NTP) draft monograph materials on fluoride and neurodevelopment (documents publicly posted and widely reported in 2023).","date":"None"},{"id":"30397b47-2751-48d5-b517-e38ed1c2ed3c","text":"Publication of mouse-study showing sodium bicarbonate reduced metastasis (Robert Gillies et al.)","date":"2011-08-23 00:00:00"},{"id":"ebc674c8-5c33-4f37-85b6-129b22993e97","text":"Case report of severe metabolic alkalosis from topical sodium bicarbonate use (clinical harm reported)","date":"2017-10-24 00:00:00"},{"id":"2c94f3e9-f2e4-478c-8e0b-0c78352e3b7d","text":"2018 conviction and sentencing news about Tullio Simoncini for treating cancer with bicarbonate","date":"2018-01-15 00:00:00"},{"id":"a5f5eee1-35a8-40c6-bf54-d56986cd75d6","text":"European Union re\u2011affirms and extends sanctions on Russia amid Minsk implementation stalemate (summer 2017)","date":"2017-07-03 00:00:00"},{"id":"59a9db05-0086-48fa-8c0c-ffbd3e3860e0","text":"German foreign minister Frank\u2011Walter Steinmeier publicly favours gradual phasing\u2011out of Russia sanctions if progress is made (Reuters)","date":"2016-06-06 00:00:00"},{"id":"535a210f-5332-48a8-b714-9cd94b6426f0","text":"Heavy fighting in Avdiivka, Donetsk region \u2014 major escalation reported (Battle of Avdiivka)","date":"2017-01-31 00:00:00"},{"id":"823bb143-78e8-4e11-9b72-5d0fd5f6deff","text":"\u2018Steinmeier formula\u2019 concept emerges in Normandy/Minsk negotiations (implementation idea for political clauses)","date":"None"},{"id":"6d5a827c-ea0b-42ce-a5a8-4c2933dddc23","text":"OSCE/UN reports of restricted access and harassment of journalists in eastern Ukraine (summer 2014).","date":"2014-08-28 00:00:00"},{"id":"3ceecee9-d165-47a0-8779-3f9b9fd7ff46","text":"Ukrainian National Guard reported taking control of Komsomolske (Donetsk region) after fighting.","date":"2014-08-29 00:00:00"},{"id":"b64599c0-5b8d-4f3b-97b9-a3e1d058ac89","text":"Large Russian military convoy and movement of heavy vehicles near the Ukraine border (August 2014) and competing official narratives about incursions.","date":"2014-08-24 00:00:00"},{"id":"48cc9fc9-b313-45c6-ab6c-98c8e73a1a81","text":"Ukrainian forces captured two Russian nationals identified as GRU officers (Yevgeny Yerofeyev and Aleksandr Aleksandrov) during fighting near Schastya.","date":"2015-05-16 00:00:00"},{"id":"1f57bde1-5a81-4359-9554-77b898be045a","text":"Large prisoner exchange between Kyiv and pro-Russian rebels around the end of December 2014, involving hundreds of detainees.","date":"2014-12-27 00:00:00"},{"id":"dea4f733-4356-40fe-91e7-6054577b69a7","text":"Signing of Minsk II (Package of Measures) which included clauses calling for \'release and exchange of all hostages and unlawfully detained persons\' on an \'all-for-all\' basis.","date":"2015-02-12 00:00:00"},{"id":"4531fbee-07ca-4f7f-ba48-99fd66c5beb6","text":"EuroMOMO surveillance reports flagged elevated excess all-cause mortality in parts of Europe during 2021","date":"2021-02-24 00:00:00"},{"id":"37483664-a7a7-4762-9906-e5dcae2780ff","text":"Office for National Statistics publishes \'Deaths involving COVID-19 by vaccination status\' dataset covering deaths occurring Jan 2021\u201331 May 2022","date":"2022-06-24 00:00:00"},{"id":"4a28a209-dbc3-45dd-b84a-d065c7a2ddd8","text":"Federal judge orders FDA to accelerate public release of Pfizer COVID-19 vaccine documents","date":"2022-01-24 00:00:00"},{"id":"883ec100-33d7-4964-82ca-f305eceae674","text":"CDC issues \'Preexposure Prophylaxis for the Prevention of HIV Infection\' clinical practice guideline","date":"2014-05-24 00:00:00"},{"id":"846c382b-bfeb-4264-ada7-0b383ff7fb90","text":"FDA approval of Descovy (emtricitabine/tenofovir alafenamide) for PrEP, with messaging highlighting improved renal and bone safety compared with TDF-based Truvada","date":"2019-10-03 00:00:00"},{"id":"8650053a-7f26-4698-9037-10695259e0b3","text":"Publication of reviews and studies documenting tenofovir disoproxil fumarate (TDF)\u2013associated renal dysfunction and decreases in bone mineral density","date":"2016-04-24 00:00:00"},{"id":"5245537c-9eb7-4eb1-8dc9-552ac10777ac","text":"CDC issues formal guidance on certifying COVID-19 deaths (death-certificate guidance)","date":"2020-04-24 00:00:00"},{"id":"2a8d0962-05f2-4f3b-83bc-0c984f50a683","text":"Italian Istituto Superiore di Sanit\xe0 (ISS) reports high prevalence of pre-existing conditions among COVID-19 fatalities","date":"2020-05-24 00:00:00"},{"id":"766905f5-fd25-46de-a4cb-f9e22321ddf7","text":"Poroshenko appeared publicly with wounded soldiers as guests at a Dynamo Kyiv match (visuals of him handing/being near gifts including a football).","date":"2015-03-19 00:00:00"},{"id":"47752977-8739-4c1f-8b4b-0b2984eea4d1","text":"Established medical context: febrile seizures are a known, usually benign reaction to fever and occur after many vaccines/infections (public understanding limited)","date":"None"},{"id":"f8643050-a94b-48c4-96c8-ffa6daa1c6c9","text":"Russian government statements alleging \'outside meddling\' in Belarus","date":"2020-08-13 00:00:00"},{"id":"32bba864-7aa2-4f36-b89b-224012fe2ca8","text":"President Petro Poroshenko signs Ukraine\'s \'decommunisation\' laws banning communist symbols and requiring removal/renaming of Soviet-era monuments and toponyms.","date":"2015-05-15 00:00:00"},{"id":"d257a9bf-a3d4-4874-be64-af6ba0f22f02","text":"Large Lenin statue toppled and demolished in Kharkiv during anti\u2011government protests.","date":"2014-09-28 00:00:00"},{"id":"a2d902e4-962f-4a18-a1c1-f622b3934f40","text":"Polish Sejm resolution recognising the Volyn (Volhynia) killings and raising attention to Volyn (22 July 2016)","date":"2016-07-22 00:00:00"},{"id":"5e4c2baf-dbe7-49e1-b269-4033ddb0632e","text":"Wider pro\u2011Russian unrest and short\u2011lived \'people\'s republic\' claims in cities such as Kharkiv and Odesa (April 2014)","date":"2014-04-24 00:00:00"},{"id":"4aa21b38-4b13-4d29-925c-aa699d9b3403","text":"WHO names vaccine hesitancy among the top global health threats in 2019, and public debate about vaccine \'toxins\' and \'detox\' ramps up on social platforms in the late 2010s.","date":"2019-04-24 00:00:00"},{"id":"532d5c4d-9d3f-4f2f-a279-bbeb95659887","text":"American College of Medical Genetics and Genomics (ACMG) issues a 2013 practice guideline stating there is a lack of evidence supporting clinical MTHFR polymorphism testing.","date":"2013-02-24 00:00:00"},{"id":"55e44c00-4fe6-496c-9dab-944c4b2cb2c7","text":"Ukrainian government approved a draft law narrowing eligibility for military deferments for students and educators","date":"2022-04-04 00:00:00"},{"id":"bd112641-f8c0-444d-8cb9-9503c72569a7","text":"Verkhovna Rada extended martial law and general mobilization and described categories (including students) eligible/exempt from mobilization","date":"2022-05-24 00:00:00"},{"id":"e718d11e-60bf-41ca-aae9-78820d070e08","text":"WHO interim guidance \'Advice on the use of masks in the context of COVID-19\' published (5 June 2020) noting there was \\"no direct evidence\\" from studies on universal masking of healthy people in the community.","date":"2020-06-05 00:00:00"},{"id":"f7c3ade4-9ecf-4e12-853b-8b75b47032a1","text":"Publication (Epub May 13, 2020) of Gao et al., \'A study on infectivity of asymptomatic SARS-CoV-2 carriers\' (Respiratory Medicine), reporting 455 contacts of an asymptomatic carrier tested negative.","date":"2020-05-13 00:00:00"},{"id":"46856529-2ef5-4366-a966-3ebc9ac5e9bb","text":"Complaints and regulator notices in the UK about inappropriate recruitment incentives (reports that children were offered large payments, e.g., \xa31,500, to join a Moderna pediatric trial) and subsequent PMCPA action.","date":"2023-08-24 00:00:00"},{"id":"3f1da2a4-fd20-4820-8b26-bef270380f34","text":"Publication of the KidCOVE phase 2/3 trial results showing mRNA\u20111273 (Moderna) was safe and immunogenic in children 6 months to 5 years (NEJM).","date":"2022-11-03 00:00:00"},{"id":"9c75c255-ad39-4e2a-a3f1-0b4d8b705a38","text":"Widespread civilian refugee exodus from Ukraine reported across media","date":"2022-03-14 00:00:00"},{"id":"02012bb7-6c7b-4ee5-afd2-88ea366a860e","text":"DOU industry survey (conducted March 23\u201326, 2022) found many IT specialists had moved to safer locations (61% reported leaving their homes)","date":"None"},{"id":"fd1c4e40-ebf0-4822-886a-cc9032160c1d","text":"Public statements and interviews by Ukrainian officials describing the size and mobilization of the IT sector (coverage citing ~300,000 IT professionals)","date":"2022-03-25 00:00:00"},{"id":"3495bbed-e666-46d8-898f-62fc06d697e3","text":"Multiple international tech firms publicly evacuated or offered relocation support for Ukrainian staff","date":"2022-03-01 00:00:00"},{"id":"e61ba6fa-b8da-435a-b8ad-f2f5ea81b708","text":"2010 laboratory work demonstrating water extraction methods recover shikimic acid from sweetgum bark/wood","date":"2010-05-27 00:00:00"},{"id":"fffbf361-a8e9-49f9-adb5-13838d571f1e","text":"2009 news coverage linking shikimic acid (from star anise) to Tamiflu production and documenting supply shortages during flu scares","date":"2009-05-18 00:00:00"},{"id":"ecd93e53-3d17-448c-b237-a63b3e8109e3","text":"Russia vetoed a UN Security Council draft resolution to establish an international tribunal for the downing of Malaysia Airlines Flight MH17","date":"2015-07-29 00:00:00"},{"id":"2125bdb0-7204-4e0a-91d8-28499c435729","text":"UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine\u2019s territorial integrity while the Security Council was unable to act","date":"2014-03-27 00:00:00"},{"id":"9af4bc62-9b31-46ce-8d09-a6acb48e4823","text":"Humanitarian situation reports documenting growing social tensions and incidents between host communities and IDPs in host areas","date":"2014-08-01 00:00:00"},{"id":"90a9b422-b922-4777-a14a-ef9498c5cc6a","text":"High\u2011profile cases earlier in 2014 of pro\u2011Russian protesters/separatists removing or replacing Ukrainian flags from government buildings in eastern Ukraine (Donetsk)","date":"2014-03-05 00:00:00"},{"id":"14413e39-16eb-48e6-b0b2-dcfc3fb3a951","text":"Large influx of internally displaced persons (IDPs) from Donbas and Crimea to Kyiv region (tens of thousands reported)","date":"2014-07-02 00:00:00"},{"id":"f1f73dc0-26bb-4aae-a4be-b03b92bf4da4","text":"Existing, well-known SANAE IV research station and local geology (Vesleskarvet nunatak composed of dolerite/diabase) available in public records and studies","date":"2018-04-24 00:00:00"},{"id":"ff3cedd3-b1c8-4195-a13a-18ec0932a118","text":"Angelina Jolie made an unannounced humanitarian visit to frontline cities in Ukraine (Kherson, Mykolaiv/Lviv region).","date":"2025-11-05 00:00:00"},{"id":"2445c1a3-6b24-4942-8f14-750807be5748","text":"UN reporting and human\u2011rights agencies warned of \'persistent and grave\' human rights violations and widespread deprivation in conflict\u2011affected areas of eastern Ukraine.","date":"2015-06-01 00:00:00"},{"id":"f65051ed-e0d4-4480-8343-0bb9a5c21786","text":"Verkhovna Rada submission/declaration to the UN indicating derogation from certain international obligations (official deposition notifying international bodies).","date":"2015-06-05 00:00:00"},{"id":"f921e3a9-8ef0-4155-b3e0-4e2525ea4be1","text":"Widespread suspension or non\u2011payment of pensions and social payments to people in non\u2011government controlled areas of Donetsk and Luhansk.","date":"2015-02-20 00:00:00"},{"id":"0f392d94-957e-4115-bb27-f1428a1f5994","text":"Western bilateral training missions inside Ukraine (for example, Canada\'s Operation UNIFIER launched in 2015 with rotating Canadian personnel training Ukrainian forces).","date":"2015-09-24 00:00:00"},{"id":"870b1f70-9513-4c14-bc26-c7ffdca2eaa9","text":"NATO formalized intensified political/military cooperation with Ukraine (NATO factsheets and liaison presence describing NATO-Ukraine dialogue and support).","date":"2016-06-24 00:00:00"},{"id":"e8e9e296-5042-4c13-add8-a1aa37276d9f","text":"Sea Breeze 2019 multinational naval and maritime exercise co-hosted by Ukraine and NATO/allied partners in the Black Sea (visible allied ships and aircraft operating near Ukraine).","date":"2019-07-24 00:00:00"},{"id":"5a73da15-6a60-4dac-b227-76a076b0d384","text":"Reports since 2014 of foreign fighters and international volunteers operating in Donbas (documented by major outlets such as the BBC).","date":"2014-09-24 00:00:00"},{"id":"6bf3097a-570b-4809-b237-d44db87a39eb","text":"Antarctic winter sea\u2011ice extent reached a satellite\u2011era record high (widely reported in 2014)","date":"2014-09-22 00:00:00"},{"id":"a5b57b1c-b032-4317-805d-278014d54408","text":"World Glacier Monitoring Service (WGMS) database expansion and 2019 reporting on glacier observations","date":"2019-04-24 00:00:00"},{"id":"a25c205a-715d-4d40-ae2c-d66a5469c6df","text":"CDC releases 2020\u20132021 flu vaccination recommendations calling for yearly flu vaccine for everyone 6 months and older","date":"2020-08-20 00:00:00"},{"id":"63118e54-0fd4-430b-95cb-919ab0a8306b","text":"NOAA \'State of the Climate \u2014 2012\' reporting on global sea level contributions noted that recent sea-level rise included large contributions from glacier and ice-sheet melt as well as thermal expansion","date":"2012-04-24 00:00:00"},{"id":"c4c91b8a-1cf8-4289-bb34-1c6dd48aedcd","text":"Research showing Pacific trade-wind/ENSO-driven decadal variability strongly affects regional sea-level trends (studies published 2016\u20132017 demonstrating wind-driven variability and model under-representation)","date":"2017-04-24 00:00:00"},{"id":"452dbeed-8292-4d02-90ab-791dbe013e25","text":"Coverage of apparent \'slowing\' or data-artifact issues in satellite altimeter sea-level records (widely reported articles in 2014\u20132015 discussing measurement corrections and inter-dataset differences)","date":"2015-04-24 00:00:00"},{"id":"b9b93ac0-20e7-473e-bcb0-a8cb0f7eb23c","text":"Verkhovna Rada adopted a resolution establishing \'Day of the Ukrainian Volunteer\' (Day of Volunteer Fighters)","date":"2017-01-17 00:00:00"},{"id":"83d411c4-399d-40a3-8c9c-d17510bac37a","text":"Presidential Decree No.806/2014 established \'Day of the Defender of Ukraine\' (14 October 2014)","date":"2014-10-14 00:00:00"},{"id":"f0bfcd0b-b8e2-4da4-9825-ade7ead748a9","text":"UK government announced new national lockdown in England on Jan 4, 2021 despite vaccine rollout","date":"2021-01-04 00:00:00"},{"id":"f0786557-6136-4304-81d6-22fc866a3b12","text":"IATA and airlines public plans for a digital \'travel pass\' / health pass tied to testing and vaccination (December 2020)","date":"2020-12-24 00:00:00"},{"id":"a114812e-0977-4ca1-8094-71ad9b83c0c8","text":"WHO warnings that vaccines are not a \'silver bullet\' and will not immediately end the pandemic","date":"2020-08-21 00:00:00"},{"id":"c0c0f3f8-c44b-4b66-ae74-4ad4f7191562","text":"Berlin authorities publicly considered or enforced bans on display of Russian/Soviet symbols around May 8\u20139 commemorations","date":"2024-05-07 00:00:00"},{"id":"c9344c2b-3875-489a-9343-306f5df5110f","text":"Major oil and gas companies (Shell, Exxon) suspend or pull back Black Sea projects after Crimea\u2019s annexation","date":"2014-07-24 00:00:00"},{"id":"20b2a735-379f-4fce-94bd-0bbe7f7c5b79","text":"Russian appropriation and U.S. sanctions on Chernomorneftegaz after the 2014 annexation of Crimea","date":"2014-03-24 00:00:00"},{"id":"1e5cedaa-a90f-4111-8959-84cd0f677370","text":"Peer\u2011reviewed review article published (Natural Product Communications) summarizing multiple Chinese herbal medicines and their potential mechanisms in COPD (preclinical and small clinical studies).","date":"2024-11-05 00:00:00"},{"id":"d77fb711-e1eb-4c1f-81a1-c1b44ddef513","text":"FDA issued high\u2011profile warning letters and enforcement actions in 2023\u20132024 against supplement makers for making unlawful disease\u2011treatment claims.","date":"2023-10-24 00:00:00"},{"id":"efcfd10c-3281-4c5a-9c0a-b8ea84055f5c","text":"CDC COVID-NET MMWR report on pediatric COVID-19 hospitalizations (March\u2013July 2020)","date":"2020-08-24 00:00:00"},{"id":"318c05c3-f561-4ede-a7e7-336765f0b9bd","text":"Publication of Moncrieff et al., \'The serotonin theory of depression: a systematic umbrella review of the evidence\' in Molecular Psychiatry, concluding no consistent evidence that depression is caused by decreased serotonin activity (widely reported July 2022).","date":"2022-07-24 00:00:00"},{"id":"b0e753ad-fa27-4f00-bbc3-e8d0ea27080b","text":"Royal College of Psychiatrists position statement \'Antidepressants and depression\' (PS04/19, May 2019) stating the \'chemical imbalance\' explanation is an oversimplification and not supported as a literal cause of depression.","date":"2019-05-24 00:00:00"},{"id":"84a49646-225a-47e5-9d89-f72e0b0f5cd3","text":"U.S. Senate passed a $95 billion foreign aid package including funds for Ukraine and security assistance","date":"2024-02-13 00:00:00"},{"id":"961ea034-93f4-409c-a1ca-a12bfda4eef2","text":"Ukrainian President Volodymyr Zelensky\'s visit to Washington to plead for more U.S. aid and meetings with lawmakers","date":"2023-12-12 00:00:00"},{"id":"4939d5d5-e9de-45e0-bd7e-a16ab0082411","text":"United Kingdom announced a formal 10-year security/cooperation arrangement with Ukraine (high-profile bilateral security pact coverage)","date":"2024-01-12 00:00:00"},{"id":"e16f10a8-1336-4abc-8110-4dc43103f841","text":"OSCE regular situation summaries noting continued shelling damage in Donetsk (SMM monitoring summaries in Jan\u2013Feb 2015)","date":"2015-01-24 00:00:00"},{"id":"6964c63e-6ac3-4676-95c7-8019b57baa90","text":"CDC/ACIP public report (MMWR) acknowledging increased reports of myocarditis after mRNA COVID-19 vaccination and concluding benefits outweigh risks","date":"2021-06-23 00:00:00"},{"id":"dcfb71f8-e742-4806-97c7-9c89af87b65a","text":"Discovery of black/foreign particles in some Moderna vaccine vials in Japan, triggering local pauses and recalls","date":"2021-09-01 00:00:00"},{"id":"c97c2a12-aae4-4eee-b04a-89da2678cf8e","text":"CDC/ACIP and MMWR reports (June 2021) documenting an elevated but rare risk of myocarditis after mRNA vaccination in young males","date":"2021-06-23 00:00:00"},{"id":"d26e0e0c-97ed-4101-aa66-03799c71230f","text":"EMA statement (April 2021) finding a possible link between AstraZeneca vaccine and very rare blood clots","date":"2021-04-07 00:00:00"},{"id":"bb8b9873-c9ae-4b32-aa5e-d093e4520db2","text":"Media coverage and public attention on regulatory/clinical debate about aluminum adjuvant safety (coverage of CDC/advisory discussions)","date":"2024-01-24 00:00:00"},{"id":"9e2ed00f-fb92-4f4d-a34e-6d11d893c403","text":"CDC guidance on infant formula and fluorosis advising caution with fluoridated water when preparing infant formula","date":"2015-07-24 00:00:00"},{"id":"0fbbec81-5c41-4156-b190-889bc78cf7de","text":"NTP (National Toxicology Program) systematic review/monograph assessing fluoride exposure and neurodevelopmental outcomes","date":"2021-04-24 00:00:00"},{"id":"5063cec6-b534-47e2-92b2-fcd5f77d4fb6","text":"EU and other Western emergency energy/aid packages delivered to Ukraine after strikes on energy infrastructure","date":"2024-04-09 00:00:00"},{"id":"6e0721bf-af2c-4613-aab8-fc5a60b352e1","text":"Public health briefings and technical reports about Omicron (Dec 2021\u2013Jan 2022) from agencies such as CDC/UKHSA describing reduced vaccine effectiveness against infection and many \'breakthrough\' cases","date":"2021-12-24 00:00:00"},{"id":"72ac546b-bca3-4948-aa0b-6469a29a2935","text":"Widespread driver-led protests and road blockades across Serbia over fuel-price hikes (early June 2018).","date":"2018-06-08 00:00:00"},{"id":"f218e618-b7a6-435a-9b95-d4d9450acaa2","text":"OSCE Special Monitoring Mission (SMM) reports (2014\u20132015) documenting heavy weapons and noting that withdrawal of foreign armed formations and verification remained incomplete (e.g., OSCE SMM updates in 2015).","date":"2015-06-24 00:00:00"},{"id":"b8b1f515-6eaa-4716-8eba-78cd0e360567","text":"Signing of the Minsk II package of measures (Normandy Format) on 12 February 2015, which called for withdrawal of \'all foreign armed formations, military equipment and mercenaries\' from Ukraine.","date":"2015-02-24 00:00:00"},{"id":"63f5d0a1-7dfe-4d45-9529-9e2ab1904d7d","text":"Ukraine released footage and publicly displayed captured Russian paratroopers in August 2014; Moscow described the detentions as a mistake or denied direct responsibility.","date":"2014-08-24 00:00:00"},{"id":"88f1f741-4ab7-4160-a0fa-c523bb32fe76","text":"Russia launched a direct military intervention and air campaign in Syria (widely reported on 30 Sept 2015).","date":"2015-09-30 00:00:00"},{"id":"577b06c1-df87-403c-abf0-46e4fc3e0b1b","text":"Apter et al. v. Department of Health & Human Services \u2014 lawsuit filed by three physicians (complaint filed June 2, 2022)","date":"2022-06-02 00:00:00"},{"id":"c1749acf-2e81-4a01-a6d7-be83d2e12cc8","text":"DOJ lawyer\'s remark during Fifth Circuit oral arguments (Apter v. HHS) that \u201CFDA explicitly recognizes that doctors do have the authority to prescribe ivermectin\u201D","date":"2023-08-08 00:00:00"},{"id":"881df9ed-9ac7-489a-b437-ca046e1322d5","text":"Calls in EU institutions and the Platform of European Memory and Conscience for EU-supported remembrance projects and funding (referenced in EP documents, 2019)","date":"2019-04-24 00:00:00"},{"id":"7ea3085a-234b-4fbe-8da9-c525603685fa","text":"International backlash to Poland\'s 2018 \'Holocaust law\' (Amendment to the Act on the Institute of National Remembrance) and subsequent diplomatic controversy","date":"2018-02-24 00:00:00"},{"id":"91bf62f3-7da8-4e84-85d2-709539cb36fc","text":"Ukrainian security forces moved to clear separatist/pro\u2011Russian protesters from the Kharkiv administration building and arrested dozens (early April 2014).","date":"None"},{"id":"81ef874f-fdd0-44e9-82c4-b0faf65cb9de","text":"Deadly clashes in Odesa on May 2, 2014, that left dozens dead in street fighting and a Trade Unions House fire between pro\u2011Ukrainian and pro\u2011Russian groups.","date":"2014-05-02 00:00:00"},{"id":"18a75e4e-6a6a-41e5-883e-66078a97f435","text":"Increased visibility and international coverage of Ukrainian nationalist groups (e.g., Right Sector, Svoboda) and their mobilizations in early 2014.","date":"None"},{"id":"29b2550c-f791-42b9-b02a-9900964c9675","text":"5G Appeal / International EMF scientists\' moratorium call","date":"2017-09-13 00:00:00"},{"id":"4eecc423-821c-4504-b820-67b8e5603b27","text":"China\'s commercial 5G launch in 50 cities","date":"2019-11-01 00:00:00"},{"id":"550b4b37-7548-45b1-a3f1-d8a06a510945","text":"US National Toxicology Program (NTP) cell-phone radiofrequency final reports","date":"2018-11-01 00:00:00"},{"id":"7d8ca47e-2ef9-442a-98b1-fa8f6205bbc5","text":"Public Health Ontario technical brief on interpreting PCR cycle threshold (Ct) values (Sept 2020)","date":"2020-09-24 00:00:00"},{"id":"6b22123e-880e-4acc-8153-bdb56362c2a5","text":"IDSA/AMP joint statement cautioning against using Ct values for clinical decision-making","date":"2020-10-24 00:00:00"},{"id":"198d3645-4cb6-45e1-a18e-223c98801648","text":"NEJM perspective arguing testing strategy should prioritize frequency/turnaround over analytic sensitivity (Mina et al., \\"Rethinking Covid-19 Test Sensitivity\\")","date":"2020-09-30 00:00:00"},{"id":"a3363a3c-98a2-48ba-9cc7-674f22a0088d","text":"Study showing PCR cycle threshold values correlate with loss of recoverable live virus (Bullard et al.)","date":"2020-07-24 00:00:00"},{"id":"d54a3518-9e0b-4c3d-ba7c-472fc7e562f4","text":"CDC/NCHS provisional counts showed the U.S. COVID-19 death tally reached roughly 1,000,000, prompting broad press coverage.","date":"2022-05-12 00:00:00"},{"id":"2808b341-8473-434f-8054-cf31c53e50bf","text":"President Biden and the White House publicly marked the milestone, issuing statements and remarks acknowledging \'one million Americans\' dead from COVID-19.","date":"2022-05-12 00:00:00"},{"id":"f4810664-25df-4885-84dd-d702f61fb326","text":"Lithuanian parliament unanimously declared Russia a \'terrorist state\'","date":"2022-05-10 00:00:00"},{"id":"c7b6a4e5-5073-48f9-906b-45c2c92af366","text":"Pattern of prior Kremlin disinformation accusing Ukrainian authorities of preparing to mobilize or militarize children (examples documented across 2022).","date":"2022-04-24 00:00:00"},{"id":"faddd9e3-735d-4866-bc42-9d9cdd5b2f9a","text":"A December 30, 2022 parliamentary decision changed the official summons form and administrative terminology (new Territorial Recruitment and Social Support Centers), making older or doctored forms appear superficially plausible to non-experts.","date":"2022-12-30 00:00:00"},{"id":"4532a5f5-e3d7-4a33-a245-a559061e325f","text":"Amnesty International documenting abuses by pro\u2011Ukrainian volunteer battalions in Donbas","date":"2014-09-08 00:00:00"},{"id":"e530d934-99db-4543-9afe-a2d89c6fc26f","text":"Passage of Ukraine\'s decommunization laws banning Soviet symbols","date":"2015-04-09 00:00:00"},{"id":"b7c50e63-6034-41ff-af30-9e1d8f461eaf","text":"Adoption of the Ukrainian \'lustration\' (vetting) law for officials","date":"2014-09-16 00:00:00"},{"id":"99f4732d-fcd3-41ff-a9ec-3a7637e9f664","text":"Adoption and implementation of the 2017 Education (language) law restricting minority\u2011language instruction","date":"2017-09-28 00:00:00"},{"id":"f426628c-d791-433d-9908-39f946c4bddf","text":"Ukrainian investigations and prosecutions for \'collaboration\' with occupying authorities in Crimea (starting 2014)","date":"None"},{"id":"0e355bfb-dda1-493a-9e8f-6a6055245a49","text":"Europol / international law\u2011enforcement warnings about the risk of diversion of weapons from the Ukraine conflict to black markets","date":"2022-04-24 00:00:00"},{"id":"724352b3-5c52-4b45-9ec1-ed51d8f8b631","text":"CBS Reports documentary \'Arming Ukraine\' (briefly released, then pulled) examined problems getting aid to frontline and described shipment shortfalls","date":"2022-08-04 00:00:00"},{"id":"5fadfb89-8910-4205-bfcb-e7b767a420a0","text":"Public debate over mobilisation/conscription policy in Ukraine (Reuters: \'Female conscription not part of Ukraine\'s new draft law\')","date":"2024-01-08 00:00:00"},{"id":"f4a6e102-743d-4a10-b1fc-da4b283c1748","text":"Widespread reporting of Russian strikes that damaged or destroyed Ukrainian grain storage facilities (grain silos)","date":"2022-07-19 00:00:00"},{"id":"8840e33f-2cd1-4b8d-93e8-dcad7cba5f3d","text":"Disruption of Black Sea grain exports after Russia\u2019s pullback from the UN/Turkey\u2011brokered Black Sea Grain Initiative","date":"2022-10-31 00:00:00"},{"id":"c2554150-da86-4ad4-9a8c-3abb18092cc9","text":"Reports and images early in the war of attacks on bakeries and food\u2011production infrastructure (bread factories/bakeries hit by strikes)","date":"2022-03-07 00:00:00"},{"id":"7bdd1f26-74a1-4f78-864b-931bf388e62d","text":"CDC MMWR and other US reports documenting racial/ethnic differences in vaccine uptake (published analyses in early 2023 showing complex patterns of uptake across age and race).","date":"2023-01-24 00:00:00"},{"id":"127c55ab-a974-4e8d-9a9d-a68dd053e4ab","text":"Office for National Statistics (ONS) release showing that, for some reporting periods, the majority of COVID-19 deaths in England occurred among vaccinated people (because most older people were vaccinated).","date":"2022-06-24 00:00:00"},{"id":"a0fd99fd-4064-4c31-beef-aea5b915d57c","text":"Czech arms firm Excalibur Group announced and began shipping refurbished T-72 tanks and other heavy equipment to Nigeria via Antonov An-225 flights out of Ostrava.","date":"2015-01-30 00:00:00"},{"id":"091c1cf6-adc8-4823-808f-b9bd34b2c68a","text":"Human Rights Watch report: \'Unguided rockets killing civilians\' in rebel-held Donetsk","date":"2014-07-24 00:00:00"},{"id":"7d52399e-9fd4-4ef6-ad61-e9c1004b479d","text":"OSCE Special Monitoring Mission spot report: residential area in Donetsk severely damaged by artillery","date":"2014-08-23 00:00:00"},{"id":"59840c00-da45-49b8-ba87-6e4ec07b3dd0","text":"Battle and shelling around Ilovaisk with documented civilian casualties","date":"2014-08-24 00:00:00"},{"id":"ce05174f-bd24-4296-a6ec-f3aa221ae8e7","text":"Russian statements alleging Ukrainian cross-border shelling into Rostov/Donetsk (Russian claims)","date":"2014-07-13 00:00:00"},{"id":"6d502776-1705-472f-a052-9bae2595eceb","text":"Medical organizations publish guidance clarifying medical\u2011emergency exceptions and clinical decision\u2011making after Dobbs (e.g., ACOG August 2022 resources)","date":"2022-08-24 00:00:00"},{"id":"e005d56e-7e0a-44da-9463-7e59e19f8e3a","text":"CMS issues July 2022 EMTALA guidance and related communications about emergency care for pregnant patients","date":"2022-07-24 00:00:00"},{"id":"4c593132-8ef2-4218-bc92-54e12c4ac457","text":"U.S. Supreme Court decision in Dobbs v. Jackson Women\'s Health Organization overturns Roe v. Wade","date":"2022-06-24 00:00:00"},{"id":"042276ae-6db4-40af-b408-aa46e970d2c5","text":"UN warning (Nov 2015) that hundreds of thousands of children in Donetsk and Luhansk were at risk from potential failure of heating systems due to conflict damage","date":"2015-11-24 00:00:00"},{"id":"9d3f9b7d-b953-4f66-8e82-2ef2c80bff16","text":"2009 Russia\u2013Ukraine gas dispute: Gazprom cut gas supplies to Ukraine (and affected transit to Europe)","date":"2009-01-24 00:00:00"},{"id":"d29d4cd2-9756-49f4-b174-98c43f065c21","text":"Reuters special report: \'Ukraine struggles to control maverick battalions\' documenting undisciplined volunteer units and links to criminality","date":"2015-07-29 00:00:00"},{"id":"6969d256-3deb-46fb-8044-e5876804511b","text":"UN OCHA situation reporting and media coverage documenting humanitarian access problems and reports of diverted/looted aid in Donbas (2014)","date":"2014-10-03 00:00:00"},{"id":"1a2792b6-491c-47e0-86c4-78505dcb126e","text":"Kyiv Post coverage of volunteer battalion leaders publicly declaring assets, showing some leaders with property and cash","date":"2015-04-24 00:00:00"},{"id":"26d837e2-51eb-4a5b-a3f4-6de34ff0ee08","text":"Randomized, double\u2011blind multicenter trial of the MCT-based product AC\u20111202 (Axona) reporting cognitive benefit in ApoE4\u2011negative Alzheimer\'s patients (Henderson et al., Nutrition & Metabolism)","date":"2009-08-24 00:00:00"},{"id":"011bd2a9-8271-4b4a-908b-aac429423860","text":"Mainstream media coverage of coconut oil as a \'health trend\'/\'miracle food\' that emphasized potential benefits while downplaying uncertainty (e.g., New York Times explainer on coconut oil)","date":"2018-08-21 00:00:00"},{"id":"6891d4bc-7f6e-4d54-a027-12dbe8eb3ab8","text":"SIPRI background paper and data documenting substantial Ukrainian arms supplies and military-technical cooperation with several sub-Saharan African countries (report published 2011).","date":"2011-02-24 00:00:00"},{"id":"d671635b-187f-40d0-a42b-732896025fed","text":"High-level Ukrainian diplomatic visits to Africa (e.g., Ukrainian Deputy Foreign Minister Viktor Maiko visited Dakar, Senegal on 22\u201323 February 2013).","date":"2013-02-22 00:00:00"},{"id":"5b397cc9-7288-426b-9112-16d6c2319144","text":"UN General Assembly adopted a resolution declaring the Crimea referendum invalid (27 March 2014), with many states (including African votes and abstentions) visible in the roll call.","date":"2014-03-27 00:00:00"},{"id":"61c236bc-6219-4f54-a37b-045a9c1bbf51","text":"Ukraine opened new embassies in African states (DRC, Ivory Coast) as part of a push to increase presence on the continent.","date":"2014-04-24 00:00:00"},{"id":"79db8dc4-4182-4930-a458-c1f0ecb32cd0","text":"U.S. delivery of Javelin anti-tank missiles to Ukraine (2018)","date":"2018-04-30 00:00:00"},{"id":"f33629de-ea68-4a4a-93e5-ebb4b7e2643d","text":"U.S. missile strike on a Syrian airbase (April 2017)","date":"2017-04-07 00:00:00"},{"id":"6d7f5a83-3bd8-4234-906d-f5ef9e8fa9f0","text":"U.S. B-52 bomber deployments and training flights in Northern Europe (March 2019)","date":"2019-03-20 00:00:00"},{"id":"ff786304-52cd-4ed8-bb6a-ddd0fd7207d3","text":"NATO\u2019s Trident Juncture 2018 large-scale exercise in Norway","date":"None"},{"id":"59aff547-9f80-46de-891e-008eb3c4a729","text":"Russian leadership accusations that Ukraine was plotting attacks in Crimea (August 2016)","date":"2016-08-10 00:00:00"},{"id":"f9ca1c34-8662-444d-8709-ffef60f2880c","text":"Several European countries paused use of the Oxford\u2013AstraZeneca COVID-19 vaccine over reports of rare blood clots.","date":"2021-03-15 00:00:00"},{"id":"57c599ce-4b87-4ab0-83de-22733cfdbd26","text":"Public availability of the VAERS adverse\u2011event reporting system and its raw data (VAERS data guide / public access documentation).","date":"2020-11-24 00:00:00"},{"id":"2d1f6464-f5ff-453c-b76b-cd8063d7cd66","text":"Kenya says over 200 of its nationals are fighting for Russia in Ukraine","date":"2025-11-12 00:00:00"},{"id":"219749c1-05e5-4ba0-b997-d3946448344b","text":"South African Presidency (SANews) confirmation that government is helping \'suspected\' nationals stranded after joining mercenary forces","date":"2025-11-06 00:00:00"},{"id":"537f0b42-2434-4896-bffb-ab81f1d7d892","text":"European Food Safety Authority (EFSA) published a comprehensive scientific opinion on acrylamide in food highlighting potential cancer risks from dietary acrylamide exposure and identifying roasted/heat-processed products (including coffee) as contributors.","date":"2015-06-24 00:00:00"},{"id":"17f9e020-02d1-458d-b904-b8170db4e607","text":"Major news coverage (CNN) in April 2024 about concerns over chemicals used in decaffeination (methylene chloride/ethyl acetate) and calls from some health groups to restrict certain decaffeination methods.","date":"2024-04-24 00:00:00"},{"id":"0c48fb0e-8be2-4bc4-89e9-5d59615b0b5e","text":"Public statement attributed to U.S. envoy Kurt Volker that Crimea \\"cannot be returned by force\\"","date":"2018-05-24 00:00:00"},{"id":"9908eef1-a11e-4fc8-aab4-0175f621abf1","text":"Apple Maps controversy and Ukrainian diplomatic protest after Crimea appeared as part of Russia on some platforms (Ukraine diplomat publicly criticized mapping depiction, Nov 2019)","date":"2019-11-29 00:00:00"},{"id":"ee3b0569-0453-4da2-80c0-4d2633c63d56","text":"Media reports that U.S. Secretary of State Mike Pompeo allegedly told Ukrainian interlocutors \\"Crimea is lost\\" (reported in press coverage)","date":"2020-02-05 00:00:00"},{"id":"5614cf21-6c14-4bdb-aeb4-bd24f098a256","text":"Widespread reporting of attacks on hospitals and medical personnel in Ukraine that cited Geneva Convention protections (60 Minutes / CBS News coverage).","date":"2022-04-03 00:00:00"},{"id":"ae0c2908-0718-455a-b0bb-f7b64da39d6d","text":"Ukraine\'s parliamentary ombudswoman and other officials publicly accused Russia of mistreating Ukrainian POWs, saying Russia\'s conduct may violate the Geneva Conventions.","date":"2022-04-04 00:00:00"},{"id":"2576ebe7-bdfa-4a54-9e77-ed200f2ebec3","text":"Release of policy/guidance analyses on solar climate intervention and governance (C2ES report)","date":"2020-07-24 00:00:00"},{"id":"fa9e5368-9529-4f06-8aa8-abbb99e2b39c","text":"Public reporting that Bill Gates funded geoengineering research (FICER / early funding disclosures)","date":"2010-01-24 00:00:00"},{"id":"c9e29398-01bf-45b5-b075-926abb3d6851","text":"1964 NEJM publication on a vegetable-oil adjuvant (Adjuvant 65) tested in influenza vaccine trials","date":"1964-09-24 00:00:00"},{"id":"29c519c1-42f1-483b-b79b-feb999358f8d","text":"Children\u2019s Hospital of Philadelphia (Vaccine Education Center) guidance explaining peanut/corn oils are not used in routine vaccines","date":"2019-04-24 00:00:00"},{"id":"a6c720fd-1686-4b05-8dc5-e93b64893521","text":"Ukraine\u2019s health regulators updated guidance on clinical trials (28 Sept 2020) and Ukraine received inquiries/applications related to vaccine trials in autumn 2020 (reported in contemporaneous summaries of trial activity).","date":"2020-09-28 00:00:00"},{"id":"45bba5a6-922d-4a36-aabf-384c9f1904cb","text":"Johnson & Johnson temporarily paused its global COVID\u201119 vaccine trials after an unexplained illness in a participant (widely reported Oct 12\u201313, 2020).","date":"2020-10-12 00:00:00"},{"id":"9c5dc79e-889f-435c-8d93-0b33904276d5","text":"Viktor Medvedchuk (pro\u2011Moscow Ukrainian politician) publicly criticized Kyiv\u2019s refusal to engage with Sputnik V and urged use of the Russian vaccine (comments reported Oct 26, 2020).","date":"2020-10-26 00:00:00"},{"id":"9a10f506-e196-4eae-9a1a-e0e31b3ec0cc","text":"First U.S. HIMARS systems delivered to Ukraine (first arrivals announced)","date":"2022-06-23 00:00:00"},{"id":"b2d3b6e1-3124-44b9-af89-bbc6c321f2a1","text":"U.S. National Security Adviser Jake Sullivan said the U.S. was \'not prepared to provide\' ATACMS long-range missiles to Ukraine","date":"2022-07-22 00:00:00"},{"id":"5540a615-7376-440a-b19c-ded561c593d8","text":"Russia\u2019s defence ministry claimed it destroyed four U.S.-supplied HIMARS launchers","date":"2022-07-22 00:00:00"},{"id":"a39b288b-6302-4b14-8a01-666ec983ae8a","text":"2018 global valsartan/ARB recalls for nitrosamine impurities (heightened nitrosamine scrutiny)","date":"2018-07-24 00:00:00"},{"id":"3d7197b7-34e5-4017-ab34-a9a7e4d5b38f","text":"Pfizer records settlement charges resolving thousands of Chantix lawsuits (~$273 million)","date":"2013-03-24 00:00:00"},{"id":"c92ccedf-1f2d-4cb1-94dd-2bb312a837a3","text":"FDA approves Chantix (varenicline) for smoking cessation","date":"2006-05-11 00:00:00"},{"id":"f93f030f-0add-4428-b8a0-bc210dd7288c","text":"FDA adds boxed warning for serious neuropsychiatric events (postmarketing, 2009)","date":"2009-07-24 00:00:00"},{"id":"bb8613b8-7b4f-4b81-b730-17ff3a4d9737","text":"Longstanding scientific practice of \'semen washing\'\u2014techniques to remove HIV from semen\u2014has been reported in the literature since 1989 and studied in subsequent reviews (e.g., 2015), information available before May 28, 2022.","date":"1989-04-24 00:00:00"},{"id":"9ccc3f5e-2ac4-47b3-9b19-acbb7736468c","text":"ONS regional excess-mortality update published showing higher-than-expected deaths through November 2022","date":"2022-12-24 00:00:00"},{"id":"676dc4eb-7bd3-478b-87cc-006ca3b200d0","text":"Peer\u2011reviewed reports of rare vaccine-associated myocarditis (published 2021\u20132022) received ongoing media attention","date":"2021-10-24 00:00:00"},{"id":"da116685-a998-4905-afdb-e5e3ec59e41d","text":"VAERS / adverse-event report releases and summaries through late 2022 widely circulated","date":"2022-11-24 00:00:00"},{"id":"0e161649-17f8-4509-a87d-586546770d4d","text":"Construction and commissioning of the North Crimean Canal (Soviet-era large-scale diversion of Dnieper waters to Crimea, main works 1961\u20131971)","date":"None"},{"id":"45a42fd9-f5a7-4cb6-8f87-a26fc49a727d","text":"PBS/NOVA special \'The Quest for Noah\'s Flood\' airs (TV documentary presenting the Black Sea deluge hypothesis to broad audiences)","date":"2001-10-24 00:00:00"},{"id":"63adbf4a-a48b-42d4-966e-1a8a3af9e07c","text":"French National Assembly (lower house) adopted a non\u2011binding resolution calling for non\u2011renewal of EU sanctions on Russia","date":"2016-04-28 00:00:00"},{"id":"69c09a97-0d88-40a5-967e-4b2414656a7f","text":"High-profile promotion of ivermectin as a COVID-19 treatment by advocacy groups and physicians (e.g., Dr. Pierre Kory\'s Senate testimony) increased public attention to the drug","date":"2020-12-08 00:00:00"},{"id":"370c1658-a5f6-4b11-a586-4bdde6133fc0","text":"Italy imposes national lockdown amid surging deaths in Lombardy","date":"2020-03-09 00:00:00"},{"id":"47cb6c7d-564c-46d9-afff-c29eb954648d","text":"Launch and widespread use of the Johns Hopkins global cases-and-deaths dashboard","date":"2020-01-22 00:00:00"},{"id":"2339fc15-a065-4003-b88b-a5a3b4b862e8","text":"Publication of legitimate but small, case\u2011based autopsy and myocarditis reports showing rare fatal events after vaccination (peer\u2011reviewed case reports and small series)","date":"2022-04-24 00:00:00"},{"id":"4173ffc9-354e-452a-a444-7d9dde76d9fd","text":"WHO publication \'Considerations regarding consent in vaccinating children and adolescents between 6 and 17 years old\' describes \'implied consent\' as one approach","date":"2014-05-12 00:00:00"},{"id":"32ee53b1-3b92-41bd-85c1-a621fc20e857","text":"Public controversy and regulatory curtailment of Delta water export pumping to protect endangered delta smelt","date":"2016-07-20 00:00:00"},{"id":"dad45bff-ff06-4b34-9960-c4c7ea3cf412","text":"2002 Klamath River fish kill and disputes over irrigation curtailment","date":"2002-02-05 00:00:00"},{"id":"bd67c3dc-14e3-4ded-86c5-85be907659f1","text":"Governor Jerry Brown issues Executive Order B-29-15 mandating 25% statewide urban water-use reductions","date":"2015-04-01 00:00:00"},{"id":"d925ee0d-72ad-4f96-bab2-3c5a09f04dc2","text":"Oroville Dam spillway failure and emergency releases that forced evacuations","date":"2017-02-24 00:00:00"},{"id":"cdd19715-7484-4236-b9cc-b7dac26ac393","text":"Regulatory debate and slow approval process for new sunscreen active ingredients (Sunscreen Innovation Act enacted Nov 26, 2014; ongoing FDA reviews of sunscreen ingredient safety).","date":"2014-11-26 00:00:00"},{"id":"6d08ef90-3b48-46b5-9e69-3c057632bca0","text":"Published toxicology and endocrine-disruption research and reviews (e.g., reviews summarizing in vitro/animal evidence that some chemical UV filters like oxybenzone have endocrine activity).","date":"2016-04-24 00:00:00"},{"id":"2894861a-c18c-4d08-94f5-8b2fd4789c0d","text":"April 2015 Calbuco eruption (Chile) \u2014 satellite and news reports quantified large volcanic gas/ash emissions during the explosive event.","date":"2015-04-24 00:00:00"},{"id":"7bac9831-eff4-4b20-8a3c-ab13ebb3c9f6","text":"Publication and dissemination (2011) of quantitative comparisons of volcanic vs. anthropogenic CO2 emissions (T.M. Gerlach, EOS/AGU summary and related USGS-hosted PDF).","date":"2011-04-24 00:00:00"},{"id":"72235e9f-d176-482b-963f-03bb21b928c3","text":"CDC and FDA recommend a temporary pause (April 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of a rare clotting disorder (TTS)","date":"2021-04-13 00:00:00"},{"id":"b05495fc-f92f-4944-b344-fb6bab4d2309","text":"European Medicines Agency (EMA) finds a possible link between the AstraZeneca vaccine and very rare blood clotting events and recommends listing them as very rare side effects","date":"2021-04-07 00:00:00"},{"id":"934e88c6-ea3a-405a-bc40-b792db0430c6","text":"Israel reports a probable link between the Pfizer-BioNTech vaccine and a small number of myocarditis cases following vaccination","date":"2021-06-24 00:00:00"},{"id":"b69ad494-a55b-41ce-b287-247101576271","text":"Japan finds foreign (black/stainless steel) particles in multiple Moderna vaccine vials, prompting suspension of specific lots","date":"2021-09-24 00:00:00"},{"id":"c8863369-10d7-4a7b-8a44-8be24f3cb312","text":"IPCC release of the Special Report \'Global Warming of 1.5\xb0C\' (SR1.5)","date":"2018-10-08 00:00:00"},{"id":"4d311c0d-a3bf-4639-886a-9ffc29181f73","text":"IPBES Global Assessment Report on Biodiversity and Ecosystem Services (press release)","date":"2019-05-06 00:00:00"},{"id":"d9adfed9-41e4-4849-9b15-4f60cb4702f5","text":"Regulatory updates and clarifications on convalescent plasma donor eligibility by U.S. regulators (FDA guidance changes)","date":"2021-02-24 00:00:00"},{"id":"27385007-232e-4547-9a01-a67e59484773","text":"American Red Cross public guidance clarifying vaccinated people are eligible to donate (FAQ)","date":"2021-04-24 00:00:00"},{"id":"48ac904f-cd28-45e1-8038-2afaf6d99d20","text":"Different national blood-service wait times after COVID vaccination (e.g., Australia Lifeblood 3\u2011day deferral)","date":"2021-04-24 00:00:00"},{"id":"ec8bc2d6-087b-49ee-bfc2-490c93c6fdd6","text":"National HIV surveillance/monitoring reporting showing ongoing variant diversity and surveillance activity in the Netherlands (HIV Monitoring Report 2021)","date":"2021-04-24 00:00:00"},{"id":"e91987c4-3173-40d3-a250-c5cc8957430f","text":"Earlier research documenting an HIV recombinant (CRF19_cpx) associated with rapid progression to AIDS in Cuba (2015)","date":"2015-01-28 00:00:00"},{"id":"043944c0-e98f-45d3-9b30-6dbd80f9fffa","text":"Earlier punitive COVID-era measures: France suspends about 3,000 unvaccinated healthcare workers without pay after mandatory vaccination rules (September 2021).","date":"2021-09-16 00:00:00"},{"id":"6fc0168e-30c0-49ba-975c-2c5f1930255e","text":"French National Assembly adopts (first reading) Article 4 creating a new offence of \\"provocation \xe0 l\'abandon ou \xe0 l\'abstention de soins\\" (encouraging people to abandon medical treatment).","date":"2024-02-14 00:00:00"},{"id":"9129f14c-e664-4d84-bab9-cdcd46688fce","text":"Large, recurring anti\u2011vaccine and anti\u2011pass protests in France (e.g., national rallies with >100,000 participants on 9 January 2022 and major protests in 2021).","date":"2022-01-09 00:00:00"},{"id":"d416a2a2-d6ef-44d4-882a-c230f7d1fa14","text":"Article 4\'s text (as adopted) includes penalties up to one year in prison and \u20AC15,000 fine, rising to three years and \u20AC45,000 when the provocation \'has been followed by effects\'.","date":"2024-02-15 00:00:00"},{"id":"96d7d449-804f-49f9-9105-1f5aaae069fb","text":"Ukraine files case and ITLOS issues provisional measures in dispute over detained Ukrainian naval vessels (Ukraine v. Russian Federation)","date":"None"},{"id":"953806d4-b8b0-49ec-a28a-62b9d8739402","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels","date":"2018-11-25 00:00:00"},{"id":"bf5fc7df-0949-4ea6-9783-f1e37cf285f7","text":"Coverage noting Russia\'s gain of maritime/sea resource claims after annexation (media analysis of rights to offshore resources)","date":"2014-05-24 00:00:00"},{"id":"961644d6-94f7-45ac-8d44-584c0512aad4","text":"Reporting on foreign volunteers and fighters joining both sides in the Donbas conflict (including fighters who joined Azov)","date":"2014-09-01 00:00:00"},{"id":"303f9a7b-45ce-4950-8a4a-bb3e22b7370e","text":"Publicised incidents in August 2014 where Ukraine displayed captured Russian servicemen","date":"2014-08-26 00:00:00"},{"id":"43a97283-6531-4832-a402-4714ce15cac8","text":"Norway investigation (January 2021) into deaths of 23 frail elderly patients shortly after Pfizer/BioNTech vaccination","date":"2021-01-15 00:00:00"},{"id":"62b46015-1ee6-4431-af95-060d712b7892","text":"World Bank reports sharp contraction in remittances to Ukraine in 2014\u20132015 (noting drops from Russia)","date":"2015-04-13 00:00:00"},{"id":"0e2438b5-a88a-40f5-ae90-35c5e5255069","text":"IMF approves a $17.5 billion loan program for Ukraine (March 2015)","date":"2015-03-11 00:00:00"},{"id":"e2e9ccf6-55ae-4c59-8a0b-d4e161dbfff1","text":"Russia announces and enforces bans/restrictions on Ukrainian food and agricultural imports","date":"2014-08-24 00:00:00"},{"id":"6890ec3a-637a-4135-bc44-7e9bf3e9ef98","text":"Gazprom reduced/cut natural gas supplies to Ukraine amid pricing and payment disputes","date":"2014-06-24 00:00:00"},{"id":"acb60d43-f74d-4842-9c21-e426c3fce095","text":"USDA launches the \'Partnerships for Climate\u2011Smart Commodities\' program and announces $1 billion investment to support climate\u2011smart practices, including regenerative approaches (Feb 7, 2022).","date":"2022-02-24 00:00:00"},{"id":"aa31224d-f16d-4fd4-b8fc-8ec81c1cd22d","text":"General Mills publicly commits to advancing regenerative agriculture on one million acres and launches partnerships and promotional materials (announced in 2020).","date":"2020-04-24 00:00:00"},{"id":"a18ae506-7470-4bde-894a-d0fb16051223","text":"Publication of scholarly review \'What Is Regenerative Agriculture? A Review of Scholar and Practitioner Definitions\' (Frontiers in Sustainable Food Systems, 2020) documenting inconsistent definitions and mixed empirical evidence on soil outcomes.","date":"2020-04-24 00:00:00"},{"id":"efa19fa1-4ef0-48ca-9ca2-1c43c0e27c71","text":"Case report: \'Development of High\u2011Grade Sarcoma After Second Dose of Moderna Vaccine\' (Cureus case report).","date":"2023-04-15 00:00:00"},{"id":"98fc72fc-2efd-493c-bb29-fc2db28bd4c0","text":"Publication describing diagnostic pitfalls after COVID\u201119 vaccination (e.g., post\u2011vaccine lymphadenopathy causing false\u2011positive oncologic imaging findings).","date":"2022-04-24 00:00:00"},{"id":"74c12cf0-8d3e-4381-954e-732587fd097a","text":"Ukrainian leadership publicly framed parts of the conflict as involving \'foreign mercenaries\' (statement by President Petro Poroshenko), drawing international attention to non\u2011Ukrainian fighters.","date":"2014-07-26 00:00:00"},{"id":"36b676e0-edfc-4f67-960d-c3088417a648","text":"Media reporting and profiles linked ASBS Othago to former Polish Interior Minister Bart\u0142omiej Sienkiewicz and documented the firm\'s past activity/contracts (company background coverage in June 2014).","date":"2014-06-05 00:00:00"},{"id":"e869fe57-fdea-4be6-b9b4-89324c3c6a7a","text":"Separatist commander Igor Strelkov (Girkin) and associated militia briefings in late July 2014 repeatedly alleged that foreign mercenaries (including Poles) were operating and being killed in Donbas.","date":"2014-07-28 00:00:00"},{"id":"84fe09cc-6641-4679-bf5d-a74ccb29a966","text":"IPCC Fifth Assessment Report (AR5) \u2014 Summary for Policymakers (WG1)","date":"2013-09-24 00:00:00"},{"id":"66f3d2eb-3679-4a14-beed-197acfbfb172","text":"U.S. announcement of withdrawal from the Paris Agreement (President Trump, June 2017)","date":"2017-06-01 00:00:00"},{"id":"59368157-bfa7-4514-9718-0d32036571aa","text":"Detailed reporting on Ukraine\'s use of electronic warfare to jam drones and communications","date":"2024-03-12 00:00:00"},{"id":"88bda5e5-84df-4482-abf8-c5cb471e32e9","text":"Explosion in Przewod\xf3w, Poland kills two amid Russia-Ukraine attacks","date":"2022-11-15 00:00:00"},{"id":"785c826a-c93a-4e09-924d-cc315c89df5c","text":"Coverage of the proliferation of small, portable EW systems (\'EW backpacks\') used by Ukrainian forces","date":"2024-05-17 00:00:00"},{"id":"8dbca90d-3ec2-43b8-9f94-fb7d415b2e13","text":"Reporting on routine use of drone swarms and the complexity of attribution in drone warfare","date":"2023-04-24 00:00:00"},{"id":"f83a2d02-d797-4320-8d6c-be5970798141","text":"Precedent: Ukraine imposed sanctions/entry bans on foreign politicians (e.g., three French MEPs) who visited Crimea without Kyiv\'s permission.","date":"2021-03-24 00:00:00"},{"id":"a5f9f3ff-df2f-4178-ba6d-e8691931802f","text":"ACT UP protests and high\u2011profile demonstrations targeting Burroughs Wellcome and regulators over AZT pricing, access and trial practices (1988\u20131989)","date":"1989-09-14 00:00:00"},{"id":"9ad1f0a0-0e76-42cb-83ff-5b8a42cece86","text":"FDA approval of AZT (zidovudine) in March 1987","date":"1987-03-19 00:00:00"},{"id":"0f7b511d-5740-4b53-b4cf-cf3668c1adb3","text":"2019 electoral performance of pro\u2011Russia parties (Opposition Platform \u2014 For Life) showing notable support in southern/eastern Ukraine in parliamentary elections.","date":"2019-07-21 00:00:00"},{"id":"0f2dbe89-ff54-4477-85a8-ff103a065928","text":"Release/presentation of the Resilient Ukraine \'National resilience characteristics\' survey including Odesa results (Resilient Ukraine/ICDS research presented mid-November 2021).","date":"2021-11-17 00:00:00"},{"id":"fd44c5b4-90fa-4d18-ac55-ea45f162f03f","text":"2001 Ukrainian census language data for Odesa region showing a high share of Russian speakers.","date":"2001-04-24 00:00:00"},{"id":"67a156bc-554c-4a0e-880a-2deb3629269a","text":"May 2, 2014 Odesa trade union building fire and subsequent portrayal in Russian/state and pro\u2011Kremlin media.","date":"2014-05-02 00:00:00"},{"id":"e0f319dd-3d5e-4152-ad63-50bb36218856","text":"Reporting on volunteer battalions and Ukrainian units using mixed, Soviet- or foreign-origin uniforms and equipment because of shortages (Reuters special report)","date":"2015-07-29 00:00:00"},{"id":"a0455b45-eed1-47ed-84bf-d090b89b9897","text":"OSCE Special Monitoring Mission reported observing convoys and personnel in Donetsk/Luhansk in unmarked dark-green uniforms and unmarked armoured vehicles (spot reports 2014)","date":"2014-11-08 00:00:00"},{"id":"15f25853-5fa9-4955-91a0-1e974c7bd1f3","text":"Publication of JAMA case series reporting 88.1% mortality among mechanically ventilated COVID\u201119 patients in New York (Richardson et al., 5700 patients).","date":"2020-04-22 00:00:00"},{"id":"6cc8284b-e23b-4ad8-9dd4-11f9c70af258","text":"Japan suspends use/shipments of some Moderna vaccine batches after reports of foreign particles in vials","date":"2021-08-26 00:00:00"},{"id":"9e3c9e1f-d156-4487-b047-454702c0a0c9","text":"Assassination of Arsen \'Motorola\' Pavlov in an elevator explosion in Donetsk","date":"2016-10-16 00:00:00"},{"id":"76936d38-bfd8-42aa-9bba-108527ac0852","text":"Reports by human rights groups documenting repression and propaganda targeting Crimean Tatars (2014)","date":"2014-11-24 00:00:00"},{"id":"ecda8d47-834e-45da-99ad-dde7a7cbc0d7","text":"Large pro\u2011Ukraine rally organised by the Mejlis (February 26, 2014)","date":"2014-02-26 00:00:00"},{"id":"834eac6b-77cc-451c-be6c-d70471e32525","text":"Japan suspends proactive recommendation for the HPV vaccine","date":"2013-06-24 00:00:00"},{"id":"b4eeaf9a-abd9-4af9-8860-51f96c268c6c","text":"Controversy and parliamentary inquiry into HPV vaccine projects in India (PATH studies)","date":"2010-04-24 00:00:00"},{"id":"b3dda178-d768-4eb7-bca5-8ff2b0536131","text":"Increased public reporting and media coverage of adverse events (VAERS data highlighted) around 2015\u20132016","date":"2016-04-24 00:00:00"},{"id":"2bbb8dae-7e72-4910-b0bd-6037e113a97b","text":"International Paralympic Committee (IPC) decision to allow Russian and Belarusian athletes to compete under their national flags at the Milano Cortina 2026 Paralympics.","date":"2026-02-17 00:00:00"},{"id":"c8174195-85b1-4480-a278-cc0c29fcb947","text":"Ukrainian government/officials announced they would boycott Paralympic officials\' attendance (ceremonies) in protest while specifying that athletes would still compete.","date":"2026-02-18 00:00:00"},{"id":"3753686f-7527-4b58-b712-4309746a6b70","text":"New York Times report (June 25, 2022) on a covert \'commando network\' of U.S. and allied forces coordinating weapons and assistance in Ukraine","date":"2022-06-25 00:00:00"},{"id":"2c3b42e6-f19c-4c91-af10-c7605a5f690c","text":"CIA Director William Burns publicly estimated roughly 15,000 Russian troops killed (U.S. intelligence estimate) at the Aspen Security Forum","date":"2022-07-20 00:00:00"},{"id":"11cdeae2-1dc8-48e1-83bc-5c70082acb0c","text":"FDA pediatric vaccine briefing document noted reported seizure events in surveillance/clinical data","date":"2022-06-15 00:00:00"},{"id":"6c002b89-e22d-4a9d-84d8-0614fa3eef05","text":"European Parliamentary Research Service brief explaining the religious split and the Tomos process (EPRS brief on Ukraine and religion published Jan 2019).","date":"2019-01-24 00:00:00"},{"id":"7485585c-3515-4adb-8b93-cd0ad5ed2408","text":"Media reports and commentary documented Poroshenko\'s \'Tomos tour\' and use of the Tomos in his re-election campaign (coverage in KyivPost, Financial Times and others in Jan\u2013Feb 2019).","date":"2019-01-25 00:00:00"},{"id":"d9a29223-ea58-43db-9109-11643672ca5c","text":"Ecumenical Patriarch Bartholomew signed and handed over the Tomos of Autocephaly for the Orthodox Church of Ukraine (Tomos ceremony and handover in Istanbul/Kyiv, early January 2019).","date":"2019-01-05 00:00:00"},{"id":"f391b9ef-3cd8-4617-99f0-84f6432c1ffc","text":"Ukrainska Pravda report that Polish special\u2011forces personnel guarded Ukrainian negotiators (Brest/early March 2022)","date":"2023-03-14 00:00:00"},{"id":"85fa9dad-7806-4138-a1ec-773a473535e7","text":"New York Times report revealing a \'commando network\' of Western special-operations personnel assisting Ukraine","date":"2022-06-25 00:00:00"},{"id":"cd74cf4e-d219-4588-8a7b-e6ec75763d78","text":"Persistent academic and policy\u2011community discussions in Russia and elsewhere promoting the \'deep/abiogenic oil\' idea (conferences, review articles and summaries circulated throughout the 2010s and continuing into the early 2020s)","date":"None"},{"id":"ed1855f7-791a-4785-b6c7-f6f9d8667199","text":"Experimental laboratory evidence (Kolesnikov et al., Nature Geoscience) showing that methane can produce heavier hydrocarbons under upper-mantle pressure\u2011temperature conditions (widely cited by abiogenic proponents)","date":"2009-04-24 00:00:00"},{"id":"8e772879-8642-4b48-aa61-c37c293a6f2b","text":"First confirmed delivery/arrival of German PzH 2000 howitzers to Ukraine","date":"2022-06-21 00:00:00"},{"id":"e1757ed1-c85d-4332-b917-71cf14dd2068","text":"Published research on extreme droughts and increased tree mortality in the Amazon (e.g., record\u2011breaking 2015/2016 drought analyses and 2016 Nature Scientific Reports paper).","date":"2016-01-24 00:00:00"},{"id":"ae57dcfd-b1b4-4602-8a3e-9f8286a28377","text":"Public interviews and quotes from climatologist Carlos Nobre (2019) stating that \'over fifty percent of the Amazon may be lost within decades\' if tipping points are crossed.","date":"2019-07-09 00:00:00"},{"id":"598d47df-b169-4963-92a9-f28dd18db4f1","text":"Passage of Ukraine\'s \'decommunisation\' laws and ensuing public debate, including renewed official attention to OUN/UPA memory","date":"2015-04-24 00:00:00"},{"id":"6453ddad-baec-4bc7-aa88-b3806c2802e7","text":"Existence and history of paramilitary/nationalist groups using \'tryzub\'\u2011related names and insignia (e.g., Tryzub organisation formed 1993)","date":"1993-04-24 00:00:00"},{"id":"1ee2f603-31c1-46f0-af51-ae84193e204d","text":"International reporting on the Azov volunteer unit\'s far\u2011right links and symbols (including 2014\u20132015 coverage)","date":"2014-12-24 00:00:00"},{"id":"01511c05-4227-4b01-abfa-7adc2de18c4b","text":"Spanish\u2011language press and analyses highlighting the rise/role of ultranationalist groups in Ukraine","date":"2014-04-24 00:00:00"},{"id":"93afcf6d-ba2e-447e-9995-a3ca6b4f9702","text":"Great Barrington Declaration advocating \'focused protection\' and natural herd immunity","date":"2020-10-04 00:00:00"},{"id":"ded3ab8c-bdcb-4c30-ad91-5fa73f6e12ae","text":"CDC launched the COVID-19 Seroprevalence Studies Hub (SeroHub)","date":"2020-12-01 00:00:00"},{"id":"c797fa3a-d06d-4add-b0a1-28f55b2dde2b","text":"SeroTracker dashboard providing compiled seroprevalence estimates","date":"2020-07-23 00:00:00"},{"id":"96100367-5a4e-4d78-a813-979f5efc1ecf","text":"Office for National Statistics (ONS) dataset \'Deaths by vaccination status, England\' (period analyses up to May 2023)","date":"2023-08-25 00:00:00"},{"id":"3e68195c-fd2b-4602-9af9-c8ad638afbf8","text":"Early patient\u2011led surveys and small observational preprints reporting mixed effects of vaccination on long\u2011COVID symptoms (e.g., Massey et al. medRxiv July 2021)","date":"2021-07-21 00:00:00"},{"id":"cd8a5b00-b145-4ba5-be1d-dd7b1127c2c1","text":"Publication of Choi et al., \'Developmental Fluoride Neurotoxicity: A Systematic Review and Meta\u2011Analysis\' in Environmental Health Perspectives (lead author Anna L. Choi, Harvard affiliation).","date":"2012-10-24 00:00:00"},{"id":"d74678a1-6036-40eb-8476-e2f1df401b29","text":"WHO Expert Committee review and public statements on cannabis (pre-review June 2018; outcomes published Jan 2019)","date":"2019-01-24 00:00:00"},{"id":"117c6960-98c5-407d-adbb-50403c4f60b8","text":"Preclinical studies showing cannabinoids can promote hippocampal neurogenesis (mid\u20112000s lab research)","date":"2005-04-24 00:00:00"},{"id":"b31b675a-f130-46e2-99f7-6f675e35c3d2","text":"Ukraine filed an application instituting proceedings against the Russian Federation at the International Court of Justice (ICJ).","date":"2017-01-16 00:00:00"},{"id":"5f37959e-6018-4d92-9ba7-3b806f923e57","text":"Reports that U.S. intelligence and law\u2011enforcement personnel were advising Ukraine","date":"2014-05-04 00:00:00"},{"id":"f9c4d73f-4e35-4fee-ad03-0cd1d0d52053","text":"U.S. Ambassador Geoffrey Pyatt photographed paying respects at Kyiv\'s Maidan","date":"2014-03-04 00:00:00"},{"id":"97d149af-33ce-4b66-b742-d5e7e4821c17","text":"Ukraine\'s State Emergency Service and local reporting confirmed an apartment building on Lobanovs\'koho Avenue was hit by a missile during strikes on Kyiv.","date":"2022-02-26 00:00:00"},{"id":"53c3ec33-616d-49b9-b0e1-6ad2c89a153d","text":"Russian missile strikes and intensified attacks in Sumy region (producing civilian casualties and damaged infrastructure)","date":"2025-05-14 00:00:00"},{"id":"db5eef14-6285-4126-bad7-44440b0749c8","text":"Previous high-profile deaths of Ukrainian servicewomen (example: combat medic Yana Rykhlitska killed in action)","date":"2023-03-03 00:00:00"},{"id":"09fd71bd-0dc1-4229-a155-1ce1f65d0043","text":"Public announcement and press coverage of Ukraine\'s new all-female drone unit (\'Harpies\') and recruitment drive","date":"2025-04-04 00:00:00"},{"id":"56e67f7c-8309-4451-ae4b-1d9856d6eeed","text":"Valentyn Nalyvaichenko had been appointed Head of the Security Service of Ukraine (SBU) in February 2014 and became a high-profile security official.","date":"2014-02-24 00:00:00"},{"id":"91f708ee-7cba-4390-b150-7deab02d3d24","text":"Publicly known foreign-volunteer pathways to serve in the IDF (the \'Mahal\' / volunteers-from-abroad tradition)","date":"1948-04-24 00:00:00"},{"id":"4461c591-8c87-42be-8bb5-4fdcd0527da2","text":"Large influx of Ukrainian refugees to Israel after Russia\'s 2022 invasion","date":"2022-03-13 00:00:00"},{"id":"d7495a8d-b6bf-45d5-82cc-77b0c6709d76","text":"Hamas surprise attack on Israel and ensuing nationwide mobilization (Oct 7, 2023)","date":"2023-10-07 00:00:00"},{"id":"106d0690-bc30-4ba9-b26a-bfd0aab06097","text":"Heavy fighting and Ukrainian forces retake Donetsk airport, with immediate reports of dozens killed and injured","date":"2014-05-27 00:00:00"},{"id":"e09c492d-dc02-4e43-a62f-0b99fce6e857","text":"Widespread reporting that Boris Nemtsov was a prominent Kremlin critic and vocal supporter of Ukraine","date":"2015-02-27 00:00:00"},{"id":"664a9a05-83f7-4192-a8aa-723b08092688","text":"U.S. Ambassador John Tefft publicly laid flowers at the makeshift Nemtsov memorial near the Kremlin","date":"2015-02-28 00:00:00"},{"id":"3664a7d9-e25a-4d5f-b859-f0974d7e61a7","text":"Reports of foreigners and \'protest tourists\' crossing from Russia into eastern Ukraine","date":"2014-03-04 00:00:00"},{"id":"2546d442-0582-40eb-a74c-4f9a3f2175f3","text":"High\u2011profile history and public memory of U.S. private military firms (e.g., Blackwater) from Iraq","date":"2007-10-01 00:00:00"},{"id":"c6c11fec-cd76-4fb3-b134-d707839cb5b9","text":"Pro\u2011Russian protesters and armed men seize Donetsk regional government building","date":"2014-03-03 00:00:00"},{"id":"0d8942c4-d969-40ab-9b61-d3b6492557d5","text":"Unmarked, heavily armed \'little green men\' operate in Crimea, raising questions about covert foreign forces","date":"2014-03-11 00:00:00"},{"id":"d2754557-5225-4fbc-b72c-765dc38aa10f","text":"CDC release and analyses of NHANES dental fluorosis data (analysis of 1999\u20132004 and 2011\u20132016 data; Vital and Health Statistics Series 2 No. 183).","date":"2019-04-24 00:00:00"},{"id":"d78ac63e-0777-404d-a654-3314aa76042a","text":"FDA\u2011required poison warning language on fluoride toothpastes and Poison Control guidance advising to contact poison control if a child swallows more than used for brushing.","date":"None"},{"id":"213e163f-1e64-4323-8b73-a5c2a90f2b24","text":"Later laboratory research reporting synergistic inhibitory effects of capsaicinoids on platelet aggregation (e.g., Blood Coag Fibrinolysis / related 2018 study).","date":"2018-06-24 00:00:00"},{"id":"5638d4fe-e14b-4e6d-94f2-5f9ec535a289","text":"Polish media coverage of the Bykivnia visit and related Polish\u2011Ukrainian historical memory issues (coverage in outlets such as Dziennik.pl / Polskie Radio).","date":"2015-09-17 00:00:00"},{"id":"1f4fadc4-9fc6-4b18-b2df-9e047f2a73a0","text":"CDC recommended community use of cloth face coverings (change in U.S. guidance)","date":"2020-04-03 00:00:00"},{"id":"38efd15b-f73c-4767-9fdb-679b3456f1cc","text":"CDC/NCHS issued expanded guidance on certifying deaths due to COVID-19","date":"2020-04-24 00:00:00"},{"id":"2617aa50-867a-4602-a99c-970cd4c26ee1","text":"WHO interim guidance stated limited direct evidence for universal masking in healthy community members","date":"2020-06-05 00:00:00"},{"id":"0c59c578-172e-4be5-b4ab-8cb8b1bee19b","text":"Official surveillance reporting showed an unusually low influenza season during the COVID-19 pandemic","date":"2020-12-12 00:00:00"},{"id":"d0b0335f-9ef1-4789-b5b2-1ae2f8c35f7d","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers states strong evidence of human influence on the climate system","date":"2013-09-27 00:00:00"},{"id":"8d0bcf05-53d3-4273-9d46-e6cf0ecd6408","text":"NSIDC and NASA report record-low Arctic sea ice extent in 2007","date":"2007-09-24 00:00:00"},{"id":"361c4fe2-6085-4074-9642-b1385f2801ec","text":"Adoption of the Paris Agreement at COP21, driving major political attention to climate policy","date":"2015-12-12 00:00:00"},{"id":"97bbf6bc-4a68-48cc-abcd-8c6783ec1632","text":"Ukrainian authorities released video footage they said showed a Buk missile launcher being moved in rebel\u2011held eastern Ukraine","date":"2014-07-18 00:00:00"},{"id":"db1344a5-89a1-4347-abea-67f0dd3f8aaf","text":"Pro\u2011Russian separatists and armed groups restricted and controlled access to the MH17 crash site, and international observers reported limited/unfettered access and allegations of tampering","date":"2014-07-18 00:00:00"},{"id":"06607014-2653-4fbd-a38d-5fc623dcd790","text":"Germany publicly approved and announced it would send Leopard 2 main battle tanks to Ukraine, prompting high-profile media coverage.","date":"2023-01-25 00:00:00"},{"id":"463b0a4d-fbae-49b8-8f14-ea008bffbf2a","text":"Russian leadership and state media advanced a \'denazification\' narrative about Ukraine beginning with Putin\'s public addresses in February 2022.","date":"2022-02-24 00:00:00"},{"id":"7a6466fb-3b7d-4380-8b37-aaa5ae4f5f3a","text":"FDA issued authorizations in September 2022 for updated (bivalent) COVID\u201119 booster doses under Emergency Use Authorization rather than new full biologics license approvals.","date":"2022-09-01 00:00:00"},{"id":"0fd9ac7f-c2d2-4356-9fd6-d37fb0923518","text":"FDA formally approved the Pfizer\u2013BioNTech COVID-19 vaccine (Comirnaty) \u2014 first COVID-19 vaccine to receive full FDA approval.","date":"2021-08-23 00:00:00"},{"id":"92b8025d-d2b5-4360-bcc2-16c84a7cef8d","text":"UN and international media reporting (May 2014) documenting allegations of abuses by volunteer battalions and armed groups in eastern Ukraine","date":"2014-05-24 00:00:00"},{"id":"348c5251-424b-4d51-ad66-ecc700fe6862","text":"Formation of the Dnipro\u20111 volunteer/special police battalion in April 2014, linked to local oligarchic support","date":"2014-04-24 00:00:00"},{"id":"bc6d6f5d-0060-46d6-9831-0165ac9c5060","text":"Violent crackdown on Euromaidan protesters in Feb 2014, including widely reported beatings with batons and sticks","date":"2014-02-24 00:00:00"},{"id":"2663a5a4-ee2d-4be2-824b-022f551c7755","text":"Ihor Kolomoisky appointed governor of Dnipropetrovsk Oblast, giving him formal regional authority and visibility","date":"2014-03-02 00:00:00"},{"id":"76636031-6955-46e5-a38f-1c8ceea4854d","text":"Odessa trade-union building fire and mass deaths during clashes","date":"2014-05-02 00:00:00"},{"id":"3dc6e4d7-c188-457b-aa1e-490262eebc3a","text":"Public torchlight marches and commemorations for Stepan Bandera in 2014 (Lviv and elsewhere)","date":"2014-01-01 00:00:00"},{"id":"45ed405d-d63f-4b74-ac4e-09d559d82b9f","text":"Prominent role and publicized violence of Right Sector during Euromaidan/early 2014","date":"2014-01-27 00:00:00"},{"id":"a12a73b8-1940-447d-b9e7-76cb08c90246","text":"Japan suspended use/withdrew batches of Moderna COVID\u201119 vaccine in August 2021 after reports of particulate contamination in some vials.","date":"2021-08-26 00:00:00"},{"id":"9c556d16-49aa-4261-978e-9d32978e28c2","text":"Publication of Tokyo autopsy series (Legal Medicine) reporting autopsy findings for deaths occurring shortly after COVID\u201119 vaccination and noting a small number of cases with possible vaccine\u2011related causes (e.g., myocarditis, thrombosis) \u2014 November 2022.","date":"2022-11-24 00:00:00"},{"id":"bedf361f-e294-471e-9129-126f1e8eff4b","text":"National Academies report (December 2020) assessing unexplained health incidents among U.S. government personnel concluded that directed, pulsed radio\u2011frequency (RF) energy is a plausible mechanism for some cases (\'Havana Syndrome\' assessment).","date":"2020-12-05 00:00:00"},{"id":"bd7f3a70-71e0-431d-87a6-31f1e99c6081","text":"Media reporting on China\u2019s expansion of large-scale weather\u2011modification programs (cloud\u2011seeding and the proposed \u2018Sky River/Tianhe\u2019 projects) intensified in late 2017\u20132020 (notably coverage in Dec 2020).","date":"2020-12-15 00:00:00"},{"id":"2be94a8c-a787-42cf-87d7-6040ce277c99","text":"University of Alaska Fairbanks (UAF) formally received operation of the HAARP facility from the U.S. Air Force and opened the site to civilian researchers and public outreach (transfer ceremony and subsequent open house).","date":"2015-08-11 00:00:00"},{"id":"8a98103c-3be3-41e1-bacb-d9b663a6a20b","text":"Venezuelan President Hugo Ch\xe1vez publicly suggested a \'tectonic weapon\' or U.S. involvement caused the 2010 Haiti earthquake, and political leaders and commentators repeated similar claims after major quakes (2010\u20132011).","date":"2010-01-24 00:00:00"},{"id":"f63d2f7e-ba61-4644-9687-b3fd07cde285","text":"Ukrainian Foreign Ministry summoned the Polish Ambassador to Kyiv (Jan Piek\u0142o) in response to statements by Poland\'s foreign minister.","date":"2017-07-06 00:00:00"},{"id":"9d638d6a-2493-48e4-a0b2-27751c44abe3","text":"Poland\'s Ambassador to Ukraine Jan Piek\u0142o publicly said Poland and the United States could be part of alternatives to the Minsk process and argued that Crimea should be on the Minsk talks agenda.","date":"2016-11-11 00:00:00"},{"id":"2e7d9d9c-e144-4fdb-a9ff-6415313fbafb","text":"Reports quoting former Polish foreign minister Rados\u0142aw Sikorski that Vladimir Putin in 2008 allegedly suggested dividing Ukraine with Poland (widely publicized in 2014).","date":"2014-10-24 00:00:00"},{"id":"b87b8799-7e39-4852-ac42-d2fad565035c","text":"Polish Foreign Minister Witold Waszczykowski gave a combative interview to weekly \'wSieci\', saying, among other remarks, \'With Bandera you won\'t enter Europe\' and criticizing Ukrainian historical politics.","date":"2017-07-03 00:00:00"},{"id":"c4307a80-d504-463a-92ff-83520b5b3bf0","text":"2012 \'Blood, Urine, and Sweat (BUS)\' studies reporting detectable levels of some toxicants in sweat","date":"2012-04-24 00:00:00"},{"id":"0b881e1e-e5dc-460a-afee-ba5cedcde849","text":"FDA warning letter (July 5, 2022) to a company marketing an infrared sauna with unapproved therapeutic/detox claims","date":"2022-07-05 00:00:00"},{"id":"957a492a-475c-41c8-9568-337092ec1cc5","text":"Publication of 2015 JAMA Internal Medicine study linking frequent sauna use to lower all-cause and cardiovascular mortality","date":"2015-02-23 00:00:00"},{"id":"2110a1e1-18e1-4cce-bc77-b88d972fa54b","text":"Amnesty International published reporting documenting civilian deaths and indiscriminate attacks in Donbas, Ukraine (providing background of real civilian suffering)","date":"2015-02-24 00:00:00"},{"id":"9d62ef5b-8cd6-418c-81fd-f90b01232f69","text":"Public U.S. warnings linking continued international support to Ukraine\'s anti\u2011corruption progress (December 2015 coverage)","date":"2015-12-08 00:00:00"},{"id":"af5749c3-42e7-462a-9271-b1a7eef7311e","text":"Hunter Biden appointed to the Burisma board (widely reported in 2014)","date":"2014-05-12 00:00:00"},{"id":"16306e57-4df7-442c-9b3d-6890127882dc","text":"Historical precedent of Ukrainian naval vessels being decommissioned and scrapped in prior years (public records and lists of former warships show multiple vessels written off or dismantled).","date":"None"},{"id":"a841d3b3-c4e2-40b0-90d5-36b500b9b56f","text":"The Okean (Ocean) Mykolaiv shipyard complex was sold at auction to Annona Trading House for UAH 122.195 million (about $4.3 million).","date":"2018-12-03 00:00:00"},{"id":"61cc0da6-6ed5-4bd2-97eb-538a915cb8e2","text":"Local reporting and commentary documented the shipyard\'s long-term decline and degraded equipment under previous ownership (public discussion by local officials and regional press about dereliction and need for investment).","date":"2018-12-24 00:00:00"},{"id":"cd86d5b0-77df-4ca8-8d16-327883347bba","text":"House Science Committee hearing and whistleblower accusations about NOAA data handling","date":"2017-02-24 00:00:00"},{"id":"f15b39c5-3294-48c0-b492-b81bbdf6d383","text":"NASA GISS documentation of methodological updates to the GISTEMP record","date":"2012-04-24 00:00:00"},{"id":"a9b9e630-c878-4243-b1d0-c7481e5d08d9","text":"NOAA Coral Reef Watch documents a global-scale coral bleaching episode affecting reefs worldwide during 2014\u20132016 (the largest recorded to date).","date":"None"},{"id":"46f32c1e-d465-4fc4-b968-907dc6b4f887","text":"ISW Russian Offensive Campaign Assessment (weekly assessments around Nov 11, 2024 noting Russian tactical gains such as leveraging Vuhledar seizure)","date":"2024-11-11 00:00:00"},{"id":"d71e7342-5b91-4f09-952e-face150e4892","text":"Reporting that Trump advisers proposed halting U.S. military aid to Ukraine unless Kyiv negotiated (June 25, 2024 Reuters)","date":"2024-06-25 00:00:00"},{"id":"3a0473ad-e8ad-48e5-a328-e6c97951e25a","text":"CNN publishes/airborne footage and reporting in early September 2024 showing videos of Ukrainian soldiers attempting to surrender and one apparent execution","date":"2024-09-06 00:00:00"},{"id":"e487dd26-9a73-4505-9dd4-ad1bdc612ce9","text":"Russian strikes on Kyiv (10 June 2025) damaged a building identified by some outlets as the \'former British visa centre\'","date":"2025-06-10 00:00:00"},{"id":"2f5b4398-ece6-448c-b575-e405459872ba","text":"Official suspension/relocation of UK visa/consular services from Kyiv during March 2022","date":"2022-03-24 00:00:00"},{"id":"551e0255-ced9-4f0b-8d2a-fdd55f8a8add","text":"CDC issued expanded guidance on certifying COVID-19 deaths allowing confirmed and probable cases to be recorded and included in counts.","date":"2020-04-24 00:00:00"},{"id":"258dc20c-5542-4f84-b93a-b9a7bf4d9980","text":"Italian National Institute of Health (ISS) reports showed a high proportion of COVID-19 deaths had multiple pre-existing conditions.","date":"2020-04-24 00:00:00"},{"id":"5a1b9213-c394-4034-ad93-9f5c23db6c2c","text":"FDA authorizes Pfizer-BioNTech and Moderna COVID-19 vaccines for children down to 6 months old","date":"2022-06-17 00:00:00"},{"id":"77273e0c-48f2-49d3-bed3-e1b2adffa13d","text":"CDC publishes MMWR update on cases of myocarditis after mRNA COVID-19 vaccination in adolescents and young adults","date":"2021-06-23 00:00:00"},{"id":"867d64b1-1e90-4105-980a-65a7665e1be7","text":"President Zelensky announced the creation of an \'International Legion\' and Ukraine openly called for foreign volunteers in late February 2022.","date":"2022-02-27 00:00:00"},{"id":"27a62bb6-250b-4b0d-9a85-ff22e9c61014","text":"Ukraine imposed martial law and restrictions on men aged 18\u201360 leaving the country after the full\u2011scale invasion, generating widespread reports that men could not leave to avoid conscription.","date":"2022-02-24 00:00:00"},{"id":"0fa828cb-652d-4343-bdf2-1b70c654f860","text":"UK Foreign Office advised British nationals to leave Ukraine and temporarily relocated its embassy office from Kyiv to Lviv amid the Russian build\u2011up.","date":"2022-02-18 00:00:00"},{"id":"4522a830-0495-4185-9d3b-e70ed737580f","text":"Ukraine enacted further mobilization/conscription measures and parliamentary changes to expand recruitment in mid\u20112024, attracting renewed international media attention.","date":"2024-07-24 00:00:00"},{"id":"50896647-c40e-4e4c-8cd3-a5b143cccb42","text":"Major anti-corruption probe and arrests tied to alleged fraud in Ukrainian arms procurement","date":"2023-12-24 00:00:00"},{"id":"b5b333e9-b9a1-4bbb-892a-f0a5c0cf934c","text":"Reporting on soldier and veteran grievances over pay, conditions and budget shortfalls","date":"2023-11-24 00:00:00"},{"id":"b2975098-e936-4fe2-9d6f-f693e951414e","text":"Media coverage that Western defence contractors and arms firms saw revenue gains linked to the Ukraine war","date":"2023-10-24 00:00:00"},{"id":"dba1fcfa-1008-4572-956b-b72a79251c5f","text":"Documentation of pro\u2011Kremlin narratives claiming Western military aid \u2018prolongs the war\u2019","date":"2023-03-24 00:00:00"},{"id":"bcdc6113-5e07-4cdb-921e-de72d3e763d5","text":"Mainstream reporting on official research into solar geoengineering / stratospheric aerosol injection (interpreted by some as \'admissions\' of atmospheric spraying).","date":"2022-10-20 00:00:00"},{"id":"4e17ab58-8c71-480c-bf10-fc4db6bed7b2","text":"Publication of the 2017 \'5G Appeal\' by >180 scientists and doctors calling for a moratorium on 5G","date":"2017-09-24 00:00:00"},{"id":"e3e89324-4656-4d27-a1d9-94722e6901ad","text":"Germany granted final permit for Nord Stream 2 (March 2018)","date":"2018-03-27 00:00:00"},{"id":"42ffdc91-3f9e-47d1-add9-ad79f41aaeec","text":"Naftogaz announced Ukraine would resume buying gas from Russia in 2018","date":"2018-03-24 00:00:00"},{"id":"76394907-afb7-4f37-aa2f-dfc7477afba4","text":"Late-November 2018 cold snap in Europe caused sharp rise in gas demand and prices","date":"2018-11-24 00:00:00"},{"id":"c98d893d-cd1a-40eb-b36d-90cf5c2bfe20","text":"Opinion polls in late January 2023 showing German public divided on sending heavy tanks to Ukraine","date":"2023-01-23 00:00:00"},{"id":"7b32af01-f3a7-43ff-b41e-0bc643bdd5f1","text":"Media coverage (e.g., The Guardian, Jan 25 2023) highlighting Chancellor Scholz\'s hesitation and street\u2011level opposition rhetoric","date":"2023-01-25 00:00:00"},{"id":"14cda19e-74cc-4ecf-8ee1-e7aa8c095c28","text":"Human Rights Watch report documenting use of unguided rockets in eastern Ukraine","date":"2014-07-24 00:00:00"},{"id":"e0b44114-1fb9-4ef0-871f-a8437348bcf5","text":"Amnesty International / civil\u2011society reporting of widespread artillery and rocket casualties in summer 2014","date":"2014-07-24 00:00:00"},{"id":"eafe14c6-be1c-4e43-948f-180d45325b0f","text":"Downing of Malaysia Airlines Flight MH17 over eastern Ukraine","date":"2014-07-17 00:00:00"},{"id":"287004c0-d2da-42f4-a8dc-a194c801f9ba","text":"Ukraine imposed a moratorium on repayment of a $3 billion eurobond held by Russia (Kyiv halted the payment).","date":"2015-12-31 00:00:00"},{"id":"0665bcfb-b907-4224-a4e8-51b2e0d54305","text":"The IMF publicly delayed/withheld a scheduled loan tranche to Ukraine in mid-2016 amid concerns over reform benchmarks and governance.","date":"2016-07-20 00:00:00"},{"id":"43352cae-dd71-4592-a427-b23d73f649d9","text":"Fitch Ratings downgraded Ukraine\'s long-term foreign-currency issuer default rating to \'CC\' (placing it close to default territory).","date":"2015-02-13 00:00:00"},{"id":"52fba235-b03c-49b6-ab3f-c6ceeb4c9806","text":"Ukraine agreed a major debt restructuring with private creditors (restructuring of roughly $15\u201318 billion of foreign debt).","date":"2015-08-28 00:00:00"},{"id":"c069ae08-6f59-4d93-8609-d8829dea6c9f","text":"Business Insider coverage highlights Starbucks filing multiple trademark/patent applications in Russia","date":"2024-06-06 00:00:00"},{"id":"00b33441-6dea-4d54-b5b9-21f710682ec4","text":"Starbucks suspends operations and announces exit from Russia after invasion of Ukraine","date":"2022-03-08 00:00:00"},{"id":"a55875c9-7d6b-4478-b251-ac04d3928e82","text":"MedRxiv preprint by Zhao et al. reported an association between ABO blood group and COVID-19 susceptibility (blood group O less frequent among cases).","date":"2020-03-27 00:00:00"},{"id":"98ec7a74-249a-4a7d-bd29-61f25b29ccdb","text":"FDA communication and draft guidance clarifying aluminum limits for parenteral nutrition (recommending total allowable aluminum exposure from parenteral nutrition should not exceed 5 mcg/kg/day)","date":"2023-02-09 00:00:00"},{"id":"2ad90890-99e8-4cc3-91d4-03708a493250","text":"Authoritative vaccine\u2011education pages comparing vaccine aluminum to dietary/environmental exposures (e.g., Children\'s Hospital of Philadelphia vaccine education center material explaining aluminum exposure context)","date":"None"},{"id":"bb6d5a06-ec73-4f94-806e-44f667b2d397","text":"Ukrainian authorities announced lists/blacklists of Russian artists (around 40) who were banned from entering Ukraine for illegal visits to Crimea (2014\u20132017 reporting).","date":"2017-05-24 00:00:00"},{"id":"a7020c38-115d-4d56-bbeb-0749cb7b1e62","text":"Ukraine and international reports (US State Department, EU statements) documented legal and administrative restrictions and sanctions related to Crimea as an occupied territory (2014\u20132018 reporting).","date":"2018-04-24 00:00:00"},{"id":"3c4d9422-aa3c-4dbd-8939-0d4599a471d0","text":"Hundreds of trucks were reported stranded/blocked at checkpoints on the Ukraine\u2013Crimea administrative border during the September 2015 blockade.","date":"2015-09-22 00:00:00"},{"id":"d06c2086-8592-4a20-9648-27a514db85d9","text":"President Petro Poroshenko signed Decree No. 549/2015 (September 16, 2015) introducing personal and economic sanctions related to the Crimea/Russia situation.","date":"2015-09-16 00:00:00"},{"id":"83d70978-7c6f-4749-a5c3-e16c0881df83","text":"EU and Western measures enacted in 2014 imposed trade and import bans on goods/services related to Crimea (broader international restrictions on commerce with the peninsula).","date":"2014-06-24 00:00:00"},{"id":"9dd231ed-6549-4426-b246-32f1eaded4e4","text":"Explosions damaged power lines on November 22, 2015, causing a near\u2011islandwide blackout in Crimea.","date":"2015-11-22 00:00:00"},{"id":"4680599f-6612-48bd-85c1-987e66f1852a","text":"Russia begins issuing passports to residents of occupied parts of Donetsk and Luhansk (first issuance mid\u2011June 2019)","date":"2019-06-14 00:00:00"},{"id":"8117f173-a92e-4259-a53e-252c36a5b242","text":"Reporting that the EU was developing guidance on non\u2011recognition and visa handling for Russia\u2011issued Donbas passports (summer 2019)","date":"2019-08-24 00:00:00"},{"id":"1a9a2509-178b-45b9-90b3-58c0c9cc178a","text":"March 2017 \u2014 Reporting on shelling risks to water\u2011treatment sites storing large chlorine stocks around Donetsk","date":"2017-03-10 00:00:00"},{"id":"58f7c1b7-d0ad-4051-acf9-3fdbd867dc54","text":"May 2015 \u2014 DPR (pro\u2011Russian) claims alleging Kyiv/US plotting to use chemical weapons against separatists","date":"2015-05-29 00:00:00"},{"id":"6edde202-5b09-4348-b751-085ef532a3d1","text":"Parliament adopted the Law of Ukraine \'On the Electricity Market\' (electricity market reform)","date":"2017-04-13 00:00:00"},{"id":"c35ca50a-39a1-42f0-8764-439d3656003d","text":"Ukrenergo / NCER announced a tariff rise for the national grid (12.2% increase) from April 2017","date":"2017-04-01 00:00:00"},{"id":"c20c54ac-f57e-4fb1-a13e-01290926d93d","text":"CDC/ACIP recommendation against using the FluMist (live attenuated intranasal) vaccine for the 2016\u20132017 season due to low effectiveness","date":"2016-06-22 00:00:00"},{"id":"1944b1ba-3007-48ba-baa6-e92a61fb0155","text":"Scientific and clinical literature reviews (2023) documenting that needle-biopsy \'seeding\' is rare and biopsies remain standard practice","date":"2023-04-24 00:00:00"},{"id":"133fb199-09bf-4edb-ba79-2d36ce99b94e","text":"Conviction and high-profile reporting on Tullio Simoncini, promoter of baking-soda and antifungal cancer theories","date":"2018-01-24 00:00:00"},{"id":"8b0c8798-1366-4de3-9ac0-fa3e96f20c52","text":"Israeli health ministry study reported a probable link between Pfizer-BioNTech vaccine and a small number of myocarditis cases","date":"2021-06-01 00:00:00"},{"id":"e1bcb563-e899-4015-86ae-5d076ad11cc1","text":"Public documentation of Western grants to Ukrainian civil society (e.g., National Endowment for Democracy annual reports listing grants to Ukraine-related groups).","date":"None"},{"id":"fdc26a8f-16d2-4d86-b728-870089471c1f","text":"Ukraine Prosecutor General announced identification of \'titushky\' operatives and people who hired them (investigations in March 2014).","date":"2014-03-13 00:00:00"},{"id":"654b6ee9-da37-475b-8ca0-1c7c9d1b92a4","text":"U.S. officials and media reported evidence that pro\u2011Russian demonstrators in eastern Ukraine were likely being paid (statements and coverage around 7\u20138 April 2014).","date":"2014-04-07 00:00:00"},{"id":"fecf7f2d-ea04-469b-810f-67960991e690","text":"IPCC Working Group II (AR6) report release \u2014 \'Climate Change 2022: Impacts, Adaptation and Vulnerability\' (press release)","date":"2022-02-28 00:00:00"},{"id":"9c1de945-a8c0-4007-85d2-ab4e1cc29c97","text":"Western/Central Europe extreme rainfall and floods (July 2021) and attribution analyses","date":"2021-07-24 00:00:00"},{"id":"cfefb447-4f9b-46cc-b663-96d20f429d34","text":"Pacific Northwest extreme heatwave (late June 2021) and rapid attribution studies","date":"2021-06-24 00:00:00"},{"id":"0305278e-ed35-4d8a-a0b3-2bfe4fe16224","text":"Early clinical reports and case series documented severe hypoxemia and respiratory failure in COVID\u201119 patients (e.g., Huang et al., The Lancet clinical features report).","date":"2020-01-24 00:00:00"},{"id":"8aa157bf-ab31-4e25-b3ed-663d0cba705e","text":"U.S. Ninth Circuit Court of Appeals opinion reviving lawsuit over LAUSD COVID-19 vaccine mandate (panel decision referenced plaintiffs\' arguments about whether mRNA COVID-19 shots meet a legal/medical definition of \\"vaccine\\").","date":"2024-06-07 00:00:00"},{"id":"b1753787-75a4-4d77-980e-1cdd9b70c499","text":"CDC wording change on its web definition of \\"vaccine\\" in 2021 (language shifted from phrasing that implied absolute prevention of disease to wording emphasizing stimulating an immune response / producing immunity).","date":"2021-08-26 00:00:00"},{"id":"31cb46a5-aa5c-4bd9-929a-941d8a026f3f","text":"Ukrainian tactical pullbacks around Bakhmut reported amid renewed Russian assaults","date":"2023-04-14 00:00:00"},{"id":"d0c92ac4-1992-4990-980b-2158d9d1f304","text":"Peer-reviewed case report: PNH diagnosis and hemolytic flare following mRNA COVID-19 vaccination","date":"2021-12-30 00:00:00"},{"id":"7af4f83d-eee1-4b0a-bd8d-b156233a65a2","text":"Prominent pro\u2011Russian journalist Oles Buzina shot dead in Kyiv","date":"2015-04-16 00:00:00"},{"id":"57482d6f-8527-49ca-b1e4-aa0481fb84af","text":"International press\u2011freedom monitors document multiple journalist deaths and attacks in Ukraine (2014\u20132015)","date":"None"},{"id":"e9f9a540-7ab3-4dad-a019-1dadae170d43","text":"Italian photojournalist Andrea Rocchelli killed while covering fighting in eastern Ukraine","date":"2014-05-24 00:00:00"},{"id":"ee13169e-2427-4386-bcbc-81d32c5240bf","text":"Verkhovna Rada passes Law No. 314\u2011VIII recognizing OUN\u2011UPA and other groups as \'fighters for Ukrainian independence\'","date":"2015-04-09 00:00:00"},{"id":"bc81656f-dcd2-4cdb-98cf-067c7fe2086a","text":"Ukraine enacts \'decommunization\' laws banning Soviet/Nazi symbols and mandating removal of related monuments","date":"2015-05-15 00:00:00"},{"id":"501932eb-8e4e-4348-bb4c-961a5d7a5c51","text":"Kyiv City Council renames Moskovskyi (Moscow) Prospekt to Stepan Bandera Avenue","date":"2016-07-07 00:00:00"},{"id":"e726a95b-d5c0-429e-b55e-aa22b0826505","text":"Ukrainian Il\u201176 transport aircraft carrying troops (including paratroopers) was shot down near Luhansk, killing dozens of soldiers.","date":"2014-06-14 00:00:00"},{"id":"32309a16-bc51-4681-a2db-b488abed842b","text":"Standoffs and non\u2011engagements by Ukrainian servicemen in Crimea (notably the Belbek air base confrontation) where troops were shown not to fire on Russian forces.","date":"2014-03-04 00:00:00"},{"id":"24401186-060e-4f23-8917-efbe8d9758cd","text":"CDC released guidance on certifying COVID-19 deaths that allowed listing confirmed or probable COVID-19 as the underlying cause","date":"2020-04-24 00:00:00"},{"id":"ed9e92b3-a72b-407b-950d-76f4ea220467","text":"Ukrainian government spokespeople and Ukrainian media reported that separatist/Pro\u2011Russian fighters were shelling residential areas in and around Donetsk, including Makeevka.","date":"2014-08-20 00:00:00"},{"id":"dfe5731b-cf2f-4ee4-9e26-12eaac68b4f7","text":"Wire and photo services (Reuters / Thomson Reuters Trust) published images and on\u2011the\u2011ground reporting showing apartment blocks and streets in Makiivka/Makeevka damaged by shelling (images dated 19\u201320 August 2014).","date":"2014-08-19 00:00:00"},{"id":"07fc3f18-2f76-41a0-accb-9c0bbadb3e41","text":"Kerry defends the US effort to forge a Syria ceasefire amid public and Pentagon skepticism.","date":"2016-02-23 00:00:00"},{"id":"2ba8d4cc-a5e3-419d-9e4c-ee2b544fdb4c","text":"US and Russia announce terms for a \'cessation of hostilities\' in Syria after talks in Munich.","date":"2016-02-12 00:00:00"},{"id":"b9773562-fdb8-4302-8c5e-e2c8aa0498bc","text":"Human Rights Watch report documenting abductions, arbitrary detentions and other abuses against Crimean Tatars and pro\u2011Ukrainian activists","date":"2014-11-24 00:00:00"},{"id":"7062595a-a23b-47c0-ab2b-7a0857b23c87","text":"Russian-appointed courts/authorities banned the Mejlis, the representative body of Crimean Tatars, as an \'extremist\' organization","date":"2016-04-26 00:00:00"},{"id":"39943a96-831a-40c6-9920-66942f6a22d9","text":"Blocking of international observers and incidents of violence during the March 2014 Crimea referendum (shots fired, OSCE observers blocked)","date":"2014-03-24 00:00:00"},{"id":"5f546275-52cd-41ca-8f20-759766d0002f","text":"Deployment of unmarked Russian troops (\'little green men\') who seized key sites in Crimea (parliament, airports, bases)","date":"2014-03-24 00:00:00"},{"id":"59355c20-922b-44e1-b999-e928553d0cd8","text":"Reports in Norway of deaths among frail elderly after Pfizer vaccination (23 deaths discussed)","date":"2021-01-24 00:00:00"},{"id":"6c831974-50b7-4289-8441-92a6a7f94885","text":"CDC and FDA recommended a pause on the Johnson & Johnson COVID-19 vaccine over rare blood clot reports","date":"2021-04-13 00:00:00"},{"id":"7221df48-3d44-4760-a98b-ac22ba59da87","text":"WHO updated its interim guidance on mask use for COVID-19, advising use of masks in community settings (interim guidance published 5 June 2020).","date":"2020-06-05 00:00:00"},{"id":"1b3983ea-9696-44d9-aa99-cf3a210e7702","text":"CDC recommended the public wear cloth face coverings in public settings (initial public recommendation announced April 3, 2020; guidance amplified through April\u2013June 2020).","date":"2020-04-03 00:00:00"},{"id":"b0da3d30-908a-4fb1-a15d-c4d117036668","text":"Coverage documented how face masks became a politicized symbol in the United States (e.g., New York Times feature, June 2, 2020).","date":"2020-06-02 00:00:00"},{"id":"0feb5d9e-c17d-4b4f-acbc-a62b41630ed6","text":"NASA / Earth Observatory and related agencies reported exceptionally low Antarctic sea\u2011ice extents in 2022\u20132023 (record lows for seasonal maxima/minima).","date":"2023-08-24 00:00:00"},{"id":"13abc88d-5f8c-44aa-8f59-2e6ba65eb693","text":"Concern about toxic rocket propellant and debris after Proton failures (public safety headlines)","date":"2013-07-02 00:00:00"},{"id":"385e9a11-a43e-4825-aaf7-8359018444f9","text":"IPCC Fourth Assessment Report (AR4) release (Working Group I) stating recent decades were likely the warmest in at least the past 1,300 years","date":"2007-02-24 00:00:00"},{"id":"0b6b7959-afc9-4a75-8422-6f7eb755102b","text":"Wegman report (US Congress/2006) critical of statistical methods in the \'hockey stick\' reconstructions","date":"2006-04-24 00:00:00"},{"id":"118c8dc4-7bd0-4d1c-b97d-24100912a230","text":"Ban on dashboard cameras (dashcams) in Ukraine (announced March 2022)","date":"2022-03-21 00:00:00"},{"id":"28b0308b-9327-4280-890d-cddac0e064a8","text":"Established pattern of Russian disinformation and use of staged footage to smear Ukrainian forces (documented by human rights and media watchdogs)","date":"2022-03-16 00:00:00"},{"id":"4d9f446a-ef9b-4448-80be-ef5fb381ad63","text":"Prior documented attacks on civilian evacuation convoys and cars during the 2022 invasion (widely reported, e.g., Reuters report of convoy strike)","date":"2022-03-12 00:00:00"},{"id":"dd2cbb34-56c8-45ad-a455-dae8ea105667","text":"TIME published its 2024 TIME100 list including Andriy Yermak in the \'Leaders\' category.","date":"2024-04-17 00:00:00"},{"id":"7055db5a-13ed-4e92-a63e-3b91d7c697c8","text":"Pre\u2011existing reporting and public scrutiny about Yermak and his circle (including a previously reported corruption investigation involving his brother) created an underlying credibility gap.","date":"2021-12-14 00:00:00"},{"id":"35f38b9b-5ae6-46db-b678-097ade3533ac","text":"CDC/NCHS guidance (April 2020) on certifying and reporting COVID\u201119 deaths that allowed listing COVID\u201119 as an underlying cause when clinically suspected (including \'probable\' cases).","date":"2020-04-03 00:00:00"},{"id":"305801b7-d80a-4635-87e0-37b6be94a5dd","text":"Repeated public downplaying of COVID\u201119 severity by political leaders (e.g., President Trump saying the virus \'will go away\' or \'disappear\').","date":"2020-03-17 00:00:00"},{"id":"98fd8acd-2549-45ad-b7d2-a8ccb35a1e5d","text":"Croatian officials acknowledge nationals fighting in Donbas","date":"2015-02-24 00:00:00"},{"id":"98910241-ea76-4661-865b-3fc6751e03ad","text":"Russian Defence Ministry summons Croatian military attach\xe9 alleging \'Croatian mercenaries\' in Ukraine","date":"2015-02-24 00:00:00"},{"id":"9dcf2d28-2e69-4f4a-a1e1-4004ea60c1ba","text":"Media coverage of the Azov battalion attracting foreign volunteers and far\u2011right fighters","date":"2015-03-24 00:00:00"},{"id":"95ee44fd-819e-4e69-a0c6-6d8628545637","text":"Media reports describing Latvia\'s non-citizen policy as leaving thousands feeling stateless","date":"2014-04-24 00:00:00"},{"id":"e884d029-e79f-46d4-936d-220f14127574","text":"FDA authorizes Pfizer\u2013BioNTech COVID-19 vaccine and releases EUA materials describing the product as a nucleoside-modified mRNA vaccine (technical briefings made public, Dec 2020).","date":"2020-12-11 00:00:00"},{"id":"9be285a8-7478-450c-bb98-6b02a901425e","text":"Animal and nanoparticle biodistribution studies showing lipid nanoparticle formulations can distribute beyond injection site (published/posted 2020\u20132021; e.g., peer-reviewed nanoparticle accumulation studies and regulator review summaries).","date":"2020-10-24 00:00:00"},{"id":"82fe0a68-7276-462b-b7b8-079ccc14ba74","text":"Peer-reviewed studies and preprints reporting trace detection of vaccine-derived mRNA fragments or spike protein components in human breast milk or blood samples after vaccination (published 2021).","date":"2021-12-24 00:00:00"},{"id":"6dfb7d0b-227e-4903-b292-de4b409d7199","text":"European Food Safety Authority (EFSA) establishes and publicizes a tolerable weekly intake (TWI) for aluminum from food","date":"2008-04-24 00:00:00"},{"id":"1b12ba3f-a1a1-4175-b690-984d1d530510","text":"2006 Meat Science study measuring aluminum content of baked meats wrapped in aluminum foil","date":"2006-12-24 00:00:00"},{"id":"6a1d3820-e6fe-467a-8267-67da1be9617f","text":"UK Health Security Agency report: Unusually high Group A streptococcal (GAS/iGAS) and scarlet fever activity in 2022\u201323 season","date":"2023-06-29 00:00:00"},{"id":"b38d6b33-790d-418e-99c1-38e44e1acffb","text":"Preclinical mouse studies showing mRNA\u2011LNP formulations strongly modulate innate immune responses (Ndeupen et al., iScience)","date":"2021-11-24 00:00:00"},{"id":"e64cb007-1837-4811-8867-43dd7497c313","text":"CDC Health Advisory: Early, elevated respiratory virus activity among children (co-circulation of RSV, influenza, SARS\u2011CoV\u20112)","date":"2022-11-04 00:00:00"},{"id":"c9c0fbf0-a89c-453f-ac22-5bf199990d55","text":"2009 H1N1 (swine flu) pandemic required development of an additional vaccine","date":"2009-04-24 00:00:00"},{"id":"ce059a55-a1c4-4eea-a508-a9ebacebdc74","text":"Very low measured effectiveness of the 2014\u20132015 seasonal influenza vaccine","date":"None"},{"id":"fe53b27f-bc03-44b1-8725-44e524ee2b8b","text":"U.S. congressional restrictions/amendments addressing assistance to units with alleged extremist links (e.g., Azov-related amendments)","date":"2015-04-24 00:00:00"},{"id":"40a5c718-7e22-4396-8c2e-32bf37f77173","text":"Clashes and far\u2011right attempts to disrupt Kyiv Pride (police detained far\u2011right activists)","date":"2018-06-24 00:00:00"},{"id":"721023c3-f992-4634-87a0-83197c3ded31","text":"Visible commemoration and monuments to Stepan Bandera in western Ukraine","date":"2007-10-24 00:00:00"},{"id":"e3d31e50-cadc-4608-9267-4e1ae603cea0","text":"Passage and signing of Ukraine\'s \'decommunization\' laws (removing Soviet-era names and symbols)","date":"2015-05-24 00:00:00"},{"id":"a1a6ea99-b4c3-49ec-b6f5-85eb901fbfe8","text":"Media reporting on the Azov Battalion\'s origins and extremist symbols","date":"2014-12-24 00:00:00"},{"id":"c54363fc-151a-4f51-bf9d-22d702af02da","text":"Russian government announces regulatory approval and promotion of Sputnik V (first COVID-19 vaccine) internationally","date":"2020-08-11 00:00:00"},{"id":"aeee00eb-e4d2-433e-836d-a4f0166aca4a","text":"Contamination reports and a large temporary suspension of Moderna vaccine doses in Japan after foreign particles were found in vials.","date":"2021-08-25 00:00:00"},{"id":"db7346d0-0b92-4165-828d-0e8f2f59205b","text":"Media reports in 2022 documenting large, pre-planned insider sales of Moderna shares by CEO St\xe9phane Bancel during the pandemic period.","date":"2022-03-17 00:00:00"},{"id":"1b2c529e-9c99-4ae9-93d7-b48b6a54d927","text":"IAEA mission and international attention at Zaporizhzhia Nuclear Power Plant (IAEA experts arrived and were stationed at ZNPP beginning 1 September 2022)","date":"2022-09-01 00:00:00"},{"id":"a5faa4e1-3e12-4dbe-85c7-2df6e0d41099","text":"Reporting of intimidation, abductions and coercion of Zaporizhzhia NPP staff under Russian occupation (including abduction of plant director)","date":"2022-10-05 00:00:00"},{"id":"96fff80f-1ce7-4ce1-9985-d1a73c44d044","text":"Changes to Ukrainian mobilization/reservation rules for critical infrastructure employees (Parliament adopted amendments on reserving/exempting conscripts, early November 2022)","date":"2022-11-04 00:00:00"},{"id":"2261ba1b-448f-4b56-9b53-4dd43a3f7a37","text":"2019 systematic review summarizing clinical uses and adverse reactions of DMSO in humans (F1000Research)","date":"2019-08-20 00:00:00"},{"id":"65423e9a-1634-45dc-9d3b-214efebd0a65","text":"FDA approval and long-standing labeling of RIMSO-50 (50% DMSO) for intravesical treatment of interstitial cystitis","date":"1978-04-24 00:00:00"},{"id":"5a29eb59-d254-473a-a747-e01c8152d4ec","text":"Investigative reporting on TikTok as a major vector for unverified/false medical cures in the Philippines (Rappler investigative feature)","date":"2024-04-08 00:00:00"},{"id":"15b48165-c232-44fb-94d6-ae4e9e5c63a4","text":"Russian authorities publicly pledged hundreds of billions of roubles (report: 680 billion roubles) of investment into Crimea up to 2020","date":"2016-08-24 00:00:00"},{"id":"da32d510-4c41-4b5a-a4b8-93aef86bc688","text":"Russian government raised pensions and some salaries for Crimean residents after the 2014 annexation","date":"2014-04-24 00:00:00"},{"id":"79267d8c-556f-4ae0-a361-17fd8204735e","text":"Israeli data reported reductions in Pfizer/BioNTech effectiveness against infection (Delta-era reports)","date":"2021-07-05 00:00:00"},{"id":"314c4b9b-05f0-4aee-92e9-aabd47c81cec","text":"CDC changed surveillance (May 1, 2021) to track only breakthrough cases resulting in hospitalization or death","date":"2021-05-01 00:00:00"},{"id":"6a4bbd14-52cc-407c-a5f9-92ee77c8a044","text":"CDC report on Barnstable County (Provincetown) outbreak showing many infections in fully vaccinated persons","date":"2021-07-30 00:00:00"},{"id":"0bee1005-e9ab-4e90-8495-090199b0897d","text":"Published and reported studies showing antibody levels wane within months after vaccination","date":"2021-07-24 00:00:00"},{"id":"0c174304-050e-418f-a279-afae9d4dad42","text":"IAEA expert mission visits and publishes a report on the Zaporizhzhia Nuclear Power Plant (IAEA mission and report published in September 2022).","date":"2022-09-06 00:00:00"},{"id":"1bd90170-ccea-4e04-b3d5-20ce31df06de","text":"Public announcements (July 2025) of deepening Ukraine\u2013Westinghouse cooperation on nuclear fuel supply and plans for domestic fuel assembly capability in Ukraine.","date":"2025-07-10 00:00:00"},{"id":"688031d5-81f7-4c53-a247-743c996e4563","text":"Russian delegation and state media publicly accused Ukraine of planning a \'dirty bomb\' at the United Nations Security Council.","date":"2022-10-25 00:00:00"},{"id":"ea47ac8c-9571-4a89-8a98-d768143ca1bd","text":"Reports and imagery in March\u2013April 2022 documenting Russian troops looting and disturbing equipment at the Chernobyl exclusion zone (including allegations of removal of radioactive monitoring equipment).","date":"2022-03-28 00:00:00"},{"id":"4c493219-0683-40a8-873a-f7ddd9e19aca","text":"Reporting on rapid, large Western arms shipments to Ukraine (e.g., New York Times: \'Arming Ukraine: 17,000 Anti\u2011Tank Weapons in 6 Days\').","date":"2022-03-06 00:00:00"},{"id":"f5a5d426-8a1a-4b25-8db3-4350603c6041","text":"Reuters reporting on Zelensky\'s \'dramatic call\' to EU leaders that prompted an unprecedented collective EU decision to provide arms to Ukraine.","date":"2022-03-02 00:00:00"},{"id":"86204680-fdb9-4340-b931-94cd92dad996","text":"Pandora Papers (ICIJ/OCCRP) reporting on Oct 3, 2021 linking Zelensky and close associates to offshore companies and property purchases.","date":"2021-10-03 00:00:00"},{"id":"cfad659c-cb91-411e-b838-43338e2259a5","text":"Politico profile \'The influencers behind the Ukrainian PR machine\' quoted former US Ambassador Michael McFaul describing people around Zelensky as \'intermediaries and interlocutors\'.","date":"2022-03-17 00:00:00"},{"id":"a16869db-0336-4704-baeb-5256f023e290","text":"CDC/NCHS issued guidance for certifying COVID-19 deaths clarifying how to report underlying versus contributing causes on death certificates (guidance and FAQs for certifiers).","date":"2020-04-24 00:00:00"},{"id":"67ddd5c7-214a-4d5d-b759-ee5548e2cde8","text":"Publication of large US seroprevalence analyses (blood-donor and CDC/JAMA analyses, mid-2021) showing a substantial proportion of Americans had SARS\u2011CoV\u20112 antibodies by spring\u2013early summer 2021.","date":"2021-07-13 00:00:00"},{"id":"cca4f7be-96e2-400d-b27b-e1defa7434a2","text":"EU launches Support Hub for Internal Security and Border Management in Moldova","date":"2022-07-11 00:00:00"},{"id":"e198a5f3-f610-4ce6-8505-b7ff7e34d9cd","text":"EU drugs agency warns the Ukraine war is shifting drug trafficking routes to Europe","date":"2022-06-14 00:00:00"},{"id":"3ccdb77d-b841-4282-ae76-ba8e2f8b361d","text":"European Commission announces EU financing for purchase and delivery of weapons to Ukraine","date":"2022-02-27 00:00:00"},{"id":"7f8d9241-333d-41c9-bcbc-7cc2af18e259","text":"Interpol warns of a likely surge in illicit arms linked to the Ukraine conflict","date":"2022-06-02 00:00:00"},{"id":"54774750-6451-4196-a2c5-8668041813b8","text":"Dutch Public Prosecution Service opens a criminal investigation into MH17 (Dutch-led criminal probe announced)","date":"2014-07-28 00:00:00"},{"id":"516e9191-4150-4f89-9a9d-06c8702e5117","text":"Establishment of the Joint Investigation Team (JIT) for MH17 including Ukraine as a participating partner","date":"2014-08-07 00:00:00"},{"id":"949e61da-22a2-4985-9fd4-de24d561015c","text":"Early reports of limited access and evidence handling at the MH17 crash site (security and access restrictions under rebel control)","date":"2014-07-18 00:00:00"},{"id":"26f51bef-6306-4cd6-bcb2-780b717ca091","text":"NATO announced increased patrols and a stepped-up maritime presence in the Black Sea in 2018 (Standing NATO Maritime Groups\' presence rose to ~120 days).","date":"2018-07-24 00:00:00"},{"id":"38198833-eb7c-425f-92e8-694e5ef24acb","text":"Russian and pro\u2011Kremlin media and official statements framed NATO Black Sea exercises as \'provocative\' and warned of \'consequences\' (July\u2013Nov 2018).","date":"None"},{"id":"2c9d2a6c-ddf0-4248-ae7d-b39d356c078f","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels, prompting NATO emergency meetings and condemnation.","date":"2018-11-25 00:00:00"},{"id":"df160e7a-2bcb-4e84-8d82-4201295192ed","text":"CDC/NCHS guidance on certifying deaths due to COVID-19 (guidance documents published early in the pandemic, April 2020).","date":"2020-04-24 00:00:00"},{"id":"a207afbe-4dd3-439f-a8e7-7336149b467c","text":"Russia\'s appeal argued at the UK Supreme Court that Ukraine should be forced to pay the $3bn \'Yanukovych\' bond","date":"2019-12-09 00:00:00"},{"id":"ed2ed877-46e8-4358-851e-d900f564ac83","text":"Earlier High Court summary-judgment proceedings (2017) and legal filings showing shifting rulings and dense legal language","date":"2017-03-24 00:00:00"},{"id":"53195865-e8f7-4076-9d02-8a49a466cb34","text":"Reporting and features on mounting disposal problems for decommissioned turbine blades (\'turbine graveyards\' / landfill stockpiles)","date":"2023-05-28 00:00:00"},{"id":"6dd2be4b-91b8-4c26-9050-a990c250143b","text":"Nantucket and other Cape Cod beaches closed while crews recovered fiberglass debris after the Vineyard Wind incident","date":"2024-07-17 00:00:00"},{"id":"45d81d20-c534-4029-800a-27e1f275a439","text":"Siemens Gamesa blade (72m, ~22 tonnes) detached and fell from a turbine at Odal Vind in Norway, prompting road closures and an investigation","date":"2024-04-11 00:00:00"},{"id":"657c0cbb-669f-40e7-9983-2bcc27688e5b","text":"Peer\u2011reviewed literature documenting therapy\u2011related secondary cancers (eg. therapy\u2011related AML) after certain chemotherapy agents","date":"2021-04-24 00:00:00"},{"id":"2f51cfb8-e217-4101-9ecd-ca150c2bf799","text":"Historical reporting about nitrogen mustard research at Yale and the 1940s origins of some chemotherapy agents","date":"2026-04-24 14:26:36.705720"},{"id":"c88721eb-b13e-44b2-854b-d3b82482fbfa","text":"Ukrainian Interior Ministry public briefings reporting scale of Russian strikes (Deputy Interior Minister: ~30,000 strikes)","date":"2024-04-05 00:00:00"},{"id":"4b08a871-b579-4d32-970a-01cfa0688fa4","text":"Widespread Russian missile and drone barrages across Ukrainian cities in late March 2024","date":"2024-03-21 00:00:00"},{"id":"f7a91795-523b-4b76-9f51-a9118e118291","text":"Financial Times publishes analysis of Russian \'glide bombs\' and upgrades to Soviet-era bombs","date":"2024-03-24 00:00:00"},{"id":"6f20fe88-be70-4d4c-a915-de8c4c5b535c","text":"2015 \'decommunization\' laws restricting public expression of Soviet symbols and related narratives","date":"2015-05-24 00:00:00"},{"id":"89a8455c-ba43-4744-9921-977a09d0deed","text":"2018 reports of SBU actions, searches and prosecutions of pro\u2011Russian journalists/organizations","date":"2018-04-24 00:00:00"},{"id":"e6a17aff-8b81-4824-bf2d-718dd2e011da","text":"2017 presidential decree blocking Russian social networks (VKontakte, Odnoklassniki)","date":"2017-05-24 00:00:00"},{"id":"64c4a54b-65dd-4e50-89a8-9a089b49855f","text":"2019 constitutional amendment enshrining Ukraine\u2019s EU and NATO course","date":"2019-02-24 00:00:00"},{"id":"75866a69-139a-4618-8081-25cdae28617f","text":"2014 ban on multiple Russian TV channels for spreading \'war propaganda\'","date":"2014-08-24 00:00:00"},{"id":"060a96ad-1d98-4702-8ccf-e51390aba2e6","text":"U.S. government announcement (October 2014) of a funding \'pause\' and review on certain gain-of-function (GOF) research involving influenza, MERS and SARS viruses (NOT-OD-15-011 and related guidance).","date":"2014-10-17 00:00:00"},{"id":"81510421-97b3-4279-9cc0-9f0343057db8","text":"Existence and circulation of U.S. government-held coronavirus patents (example: US Patent No. 7,220,852 B1, \'Coronavirus isolated from humans\', assigned to CDC, granted May 22, 2007).","date":"2007-05-22 00:00:00"},{"id":"650cbc5e-d8af-469e-90a4-504e75adc3b9","text":"NGO/OCCRP coverage linking major EU buyers (e.g., IKEA) to Ukrainian illegal wood supply chains","date":"2018-07-14 00:00:00"},{"id":"15a43cb1-bbea-4dcd-87c5-43ee5922e048","text":"President Petro Poroshenko vetoes bill on combating timber smuggling (Bill No. 5495)","date":"2018-07-03 00:00:00"},{"id":"6c534fc9-fcac-4607-902b-1272dbf1c0a7","text":"Earthsight publishes \'Complicit in Corruption\' investigative report on illegal logging in Ukraine","date":"2018-07-14 00:00:00"},{"id":"ffab163b-2bdb-4374-996b-8bf59d3c3b70","text":"Regulatory/authorization context: CDC/ACIP and FDA discussions and authorization decisions for COVID-19 vaccination in young children (June 2022), which increased scrutiny of pediatric trial data.","date":"2022-06-17 00:00:00"},{"id":"0e7761d8-4680-4c3f-8a17-955663c844a5","text":"Trial data-cutoff and interim analysis date reported in KidCOVE safety results (data included through February 21, 2022).","date":"2022-02-21 00:00:00"},{"id":"826edaba-f1d9-4729-883c-a9c6e7470cc0","text":"Publication of NEJM KidCOVE interim results for mRNA-1273 (Moderna) in children 6 months\u20135 years, reporting safety data including 8 serious adverse events in the 6\u201323 month mRNA-1273 group and none in the placebo group.","date":"2022-10-19 00:00:00"},{"id":"156ca787-e71d-40ea-95a2-7662712a1cf9","text":"Sea Breeze multinational naval/air exercises hosted in Ukraine with US/NATO participation (July 2017)","date":"2017-07-24 00:00:00"},{"id":"97d6446f-064c-4508-bdc4-990a4467f02e","text":"NATO\u2011Ukraine Trust Funds and tangible NATO assistance (established 2015)","date":"2015-04-24 00:00:00"},{"id":"9e777542-e2c4-44dd-886a-c7f38f623a25","text":"2019 constitutional amendment enshrining EU and NATO as Ukraine\'s strategic course","date":"2019-02-24 00:00:00"},{"id":"9f575cf0-b81e-4852-a51d-3cee646f2493","text":"Presence of foreign volunteers and fighters from Western countries in Donbas (documented 2014\u20132015)","date":"2014-08-24 00:00:00"},{"id":"4050775d-4d21-4e1d-bd3e-b7ac298dcf8e","text":"Japan suspension and recall of Moderna COVID-19 vaccine batches after reports of foreign particles","date":"None"},{"id":"5d6133ee-f749-4be1-8804-cc25d1fd0848","text":"Reports of circulating vaccine-derived poliovirus (cVDPV) outbreaks and WHO emergency committee statements","date":"2022-03-24 00:00:00"},{"id":"82eb5dca-d1e4-463b-8328-bb70084866ce","text":"Precautionary removal/reduction of thimerosal (a mercury-based preservative) from childhood vaccines","date":"None"},{"id":"b850f381-8f21-4d77-aaf7-601540816ff9","text":"Detection of porcine circovirus (PCV1) DNA in Rotarix rotavirus vaccine","date":"2010-03-24 00:00:00"},{"id":"0512a5fc-5926-412a-8411-346f9bf0b7fd","text":"Publication of Nerem et al., PNAS: \'Climate-change\u2013driven accelerated sea-level rise detected in the altimeter era\'.","date":"2018-02-24 00:00:00"},{"id":"1cbe5805-33d2-4a49-bedc-c8b721a9fcc9","text":"IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) released.","date":"2019-09-24 00:00:00"},{"id":"f1be433b-64d3-4ee2-b711-5bddbdc3b211","text":"Publication of Alberto Boretti\'s analyses challenging mainstream estimates of sea-level acceleration.","date":"2019-04-24 00:00:00"},{"id":"789d58fa-93fb-45bb-9abe-ff9b780c7054","text":"German measles-denier Stefan Lanka loses appeal after offering \u20AC100,000 prize over existence of measles virus; court rules in favour of claimant (widespread media coverage).","date":"2015-03-12 00:00:00"},{"id":"46008da7-e2a3-4b5c-804d-7d973706141a","text":"Ukraine\'s chief military prosecutor Anatoliy Matios publicly stated that two to three servicemen were committing suicide every week in the Donbas ATO zone.","date":"2017-07-24 00:00:00"},{"id":"5a61323f-1a46-47aa-9fd4-188965d42c37","text":"The battle of Ilovaisk (August 2014) in which Ukrainian units were encircled and suffered heavy losses became widely reported and politicized.","date":"2014-08-24 00:00:00"},{"id":"cd27c98c-714c-40db-9d27-c4aa5d05e25e","text":"EUvsDisinfo / DisinfoLab and other monitoring organisations catalogued repeated pro\u2011Kremlin narratives claiming Ukrainian forces were demoralized, corrupt or unwilling to fight (ongoing since 2014).","date":"None"},{"id":"61ee1818-cbe0-4db7-8b84-c29f877894c6","text":"Peer\u2011reviewed OCTA studies report retinal/ocular microvascular changes after COVID-19 infection (example: Guemes\u2011Villahoz et al.)","date":"2021-05-07 00:00:00"},{"id":"ccd7dda0-7348-4bda-996e-629c18077678","text":"Longstanding scientific review concluding iridology lacks diagnostic validity published (Ernst systematic review)","date":"1999-02-24 00:00:00"},{"id":"c8c9e73c-4cca-4518-a635-034e32de8980","text":"1996 USAF planning paper \'Weather as a Force Multiplier: Owning the Weather in 2025\' circulated publicly","date":"1996-04-24 00:00:00"},{"id":"ed852cdc-bfd8-4384-b486-65cf10530958","text":"Publication of Shearer et al., \'Quantifying expert consensus against the existence of a secret, large\u2011scale atmospheric spraying program\' (Environmental Research Letters)","date":"2016-08-24 00:00:00"},{"id":"0abeeb58-cd42-46a9-9bfa-159671d5c4fa","text":"Preexisting nanoparticle research showing some nanocarriers can accumulate in ovaries in animal models (Sch\xe4dlich et al., 2012)","date":"2012-04-24 00:00:00"},{"id":"4ef86bde-843b-46f4-a89b-ed61b420fd30","text":"U.S. Department of State 2018 Trafficking in Persons Report \u2014 Poland country narrative noting increased vulnerability of Ukrainian migrants to labor trafficking","date":"2018-06-24 00:00:00"},{"id":"fa0fd9da-5c67-4038-ad8d-9fb160b4ad27","text":"Financial Times coverage on Poland\u2019s heavy reliance on cheap Ukrainian labour and the precarious conditions many workers faced","date":"2018-06-24 00:00:00"},{"id":"17d38e55-503b-4ec7-8441-ce132a230a43","text":"June 26, 2016 \u2014 Attack on a Ukrainian religious procession in Przemy\u015Bl by local nationalist groups (documented by regional and international press)","date":"2016-06-26 00:00:00"},{"id":"46ba9c8a-38e6-4870-92f3-71c773e089ca","text":"Pfizer\u2013BioNTech received Emergency Use Authorisation while continuing to follow trial participants for safety/efficacy","date":"2020-12-24 00:00:00"},{"id":"3d69889f-6ef2-476c-82e0-6a27979e1cf6","text":"UK regulator (MHRA) issued guidance after two reports of anaphylaxis following Pfizer\u2013BioNTech vaccinations","date":"2020-12-24 00:00:00"},{"id":"fa532d5e-b78d-4fda-84c6-75f04dc47f1a","text":"Multiple reports in Norway of deaths among frail, elderly people after receiving the Pfizer\u2013BioNTech vaccine","date":"2021-01-24 00:00:00"},{"id":"3fb2d7f6-e88e-4db6-864c-66144ced3735","text":"AstraZeneca paused its global COVID\u201119 vaccine trials after a participant developed a serious neurological illness","date":"2020-09-24 00:00:00"},{"id":"a47f9cd3-6c32-4586-850b-a0ddd5db7fee","text":"NOAA technical report and public release of regional sea-level rise scenarios and tools (NOAA NOS CO-OPS Technical Report)","date":"2017-04-24 00:00:00"},{"id":"1a2742e3-d3fb-48e5-bf4b-b4fc1e5a362d","text":"Availability and public access to local tide-gauge records showing regional variability (example: Stockholm tide gauge, PSMSL station page)","date":"2018-05-01 00:00:00"},{"id":"e069958d-b137-45c6-98f8-d8ac1a244303","text":"Allegations and media coverage of NOAA data-handling controversy (John Bates / \'NOAA whistleblower\' coverage)","date":"2017-02-24 00:00:00"},{"id":"dac7a8e1-5257-459a-b46d-a95758256fd2","text":"OSCE Permanent Council decision to deploy the Special Monitoring Mission to Ukraine (SMM) following the outbreak of unrest in eastern Ukraine.","date":"2014-03-21 00:00:00"},{"id":"7d769798-8649-449b-9577-3ffe09615c87","text":"Self\u2011proclaimed Donetsk and Luhansk \'people\'s republics\' declared independence after May 2014 referendums and issued international statements.","date":"2014-05-12 00:00:00"},{"id":"2f81a6c8-caec-47d3-b457-3dc88dbebb32","text":"Minsk II talks (Package of Measures) signed in Minsk with representatives of the self\u2011proclaimed Donetsk and Luhansk People\u2019s Republics participating as signatories.","date":"2015-02-12 00:00:00"},{"id":"11e57b20-8edd-482f-8d82-40fbbc59b90d","text":"United Nations Security Council held emergency meetings and public briefings on the Ukraine/Crimea crisis (e.g., press briefing and meeting coverage in February\u2013April 2014).","date":"2014-02-28 00:00:00"},{"id":"437e98cd-85f2-47db-bac3-f5e207d213bb","text":"European Union adopts \u20AC1.8 billion macro\u2011financial assistance (MFA) for Ukraine","date":"2015-04-15 00:00:00"},{"id":"ee212c03-d1b9-4829-a450-4cf628f7fbc2","text":"EU visa\u2011free travel for Ukrainian citizens enters into force","date":"2017-06-11 00:00:00"},{"id":"3dcd7b1f-01b2-48b2-8627-6bb067f50b75","text":"Publication of Microsoft patent WO/2020/060606 (cryptocurrency system using body activity data)","date":"2020-03-26 00:00:00"},{"id":"47b0c8dd-d904-48c3-a850-620108d989e1","text":"Coverage of Gates/Foundation funding for genetically modified mosquito research (Oxitec grant reported 2018)","date":"2018-06-24 00:00:00"},{"id":"2bdbcfa2-b80a-4f15-87e9-4ead32abcd47","text":"Ukraine sharply increased \'reverse flow\' imports from EU in 2015","date":"2015-04-24 00:00:00"},{"id":"49f9b46a-f921-44a8-aaf1-5ea187468899","text":"January 2009 Russia\u2013Ukraine gas cut-offs","date":"2009-01-24 00:00:00"},{"id":"c06f10aa-ef48-49f7-8472-ebbd02c3d8b5","text":"Merck announces it will discontinue development of two COVID-19 vaccine candidates (V590 and V591)","date":"2021-01-25 00:00:00"},{"id":"e581a1e2-e362-4c93-9f84-238c6c5d5159","text":"1976 U.S. swine flu vaccination program linked to increased Guillain\u2013Barr\xe9 syndrome reports","date":"1976-04-24 00:00:00"},{"id":"a159547a-4af7-4274-b801-e11db333875c","text":"Pandemrix (2009 H1N1 vaccine) association with increased narcolepsy reports in some countries","date":"2010-04-24 00:00:00"},{"id":"34c5408c-1e1a-49f9-b0bd-04148f61a2b3","text":"2014\u20132015 influenza vaccine effectiveness decline due to antigenic drift","date":"None"},{"id":"2e6de9ab-0fc6-44c8-b407-aa303e166569","text":"European Medicines Agency (EMA) announces and uses \'rolling review\' procedures for COVID-19 vaccines","date":"2020-10-06 00:00:00"},{"id":"ae74430a-5949-4b95-a120-a6eb384fd9bb","text":"UK Medicines and Healthcare products Regulatory Agency (MHRA) grants temporary (emergency) authorization for the Pfizer\u2013BioNTech vaccine under Regulation 174","date":"2020-12-02 00:00:00"},{"id":"3bf4e4fe-3618-4cb8-8d2c-abcfe64d9596","text":"Publication of the Phase 3 trial results in NEJM showing vaccine efficacy against symptomatic COVID-19 (Polack et al.)","date":"2020-12-10 00:00:00"},{"id":"b728548a-c090-4038-9c76-17794be02f65","text":"Reporting on longstanding U.S. transfers of anti-armor and other defensive equipment to Ukraine (e.g., Politico coverage of U.S.-supplied weapons to Ukraine since 2018)","date":"2021-04-12 00:00:00"},{"id":"1e92e27b-0ddf-449b-83e9-404d8da25044","text":"U.S. intelligence warnings and press reporting that Russia was planning a large-scale offensive (wide coverage, Dec 3, 2021)","date":"2021-12-03 00:00:00"},{"id":"4c42f1d4-18f9-414a-8489-6a66fdc45116","text":"Bipartisan Senate delegation visited Kyiv and met President Zelensky (Portman, Shaheen, Murphy)","date":"2021-06-02 00:00:00"},{"id":"4c7d4d49-9392-47f0-94fe-c2a411854cab","text":"Russian navy holds Black Sea drills near Crimea amid rising tensions (April 2021).","date":"2021-04-27 00:00:00"},{"id":"1b2898f8-0b9e-4973-8d15-1d632394728d","text":"Russia publishes draft security proposals demanding NATO guarantees (including no eastward expansion).","date":"2021-12-17 00:00:00"},{"id":"5a950cce-9f3d-4ba0-a51e-e8a2b37a97bf","text":"Deployment of advanced S-400 surface-to-air missile systems and other air defenses to Crimea (reported in 2019 and earlier).","date":"2019-11-29 00:00:00"},{"id":"79e8c735-743c-476f-a650-01f059fa32c1","text":"Large-scale Russian troop buildup on and near the Ukrainian border reported in January 2022.","date":"2022-01-24 00:00:00"},{"id":"ad1ef3ff-142e-42f8-8b0c-469d655ebcc3","text":"Vladimir Putin publishes essay \'On the Historical Unity of Russians and Ukrainians\'.","date":"2021-07-12 00:00:00"},{"id":"cb13afd4-7f7a-447e-8c59-ffacf2dd9a71","text":"Czech Statistical Office published official vital statistics showing a marked decline in live births (drop in number of births) between 2021 and 2022/2023.","date":"2022-04-24 00:00:00"},{"id":"29f831dd-3583-4717-b70d-08c20c2277b5","text":"Peer-reviewed modelling paper published examining how COVID-19 vaccination timing and behavior could affect total fertility rate in Czechia (discusses scenarios like avoiding conception around vaccination).","date":"2024-04-24 00:00:00"},{"id":"8671ab76-5e75-4a4e-924f-ede3eddbd80e","text":"Public reporting and policy changes earlier in 2020 showing NATO/European military exercises were scaled back or adjusted because of COVID\u201119 (concern about cross\u2011border transmission).","date":"2020-04-24 00:00:00"},{"id":"4ee7de3b-1f60-445f-8a66-cc678fc92f3b","text":"Official reporting that Ukrainian units (e.g., the 80th Air Assault Brigade) were participating in Saber Junction / multinational exercises in Germany.","date":"2020-07-24 00:00:00"},{"id":"ef40271e-1b78-4d05-a4a9-d2bb3d847704","text":"Peer\u2011reviewed reports from Israel (NEJM and related surveillance studies, 2021\u20132022) documenting rare myocarditis cases after mRNA vaccination in adolescents and young men (e.g., NEJM letter on Israeli adolescents published Nov. 10, 2022)","date":"2022-11-10 00:00:00"},{"id":"b59a26bd-e33a-41d1-ad8e-57ce8f617df6","text":"CDC/ACIP Sept. 12, 2023 presentation slides on updated COVID-19 vaccines that included projections of hospitalizations, deaths prevented in adolescents and estimates of vaccine reactogenicity (Grade 3/4)","date":"2023-09-12 00:00:00"},{"id":"67c3c742-90ac-4337-9018-6e7ff134b06b","text":"IEA special report \'The Role of Critical Minerals in Clean Energy Transitions\' highlighting large and growing demand for minerals (copper, rare earths, etc.) used in wind turbines and other clean technologies.","date":"2021-05-24 00:00:00"},{"id":"444523ca-76e6-42a5-8557-f2d374e6f96b","text":"Reuters reporting (September 2023) on U.S. offshore wind projects facing major cost increases, cancellations and financial write\u2011downs amid inflation, supply\u2011chain problems and policy changes.","date":"2023-09-24 00:00:00"},{"id":"e28fde96-9f0f-4cda-b767-ef1e03a07eab","text":"C&EN feature (August 2022) documenting that many retired wind turbine blades have been landfilled and describing the technical and economic challenges of blade recycling.","date":"2022-08-24 00:00:00"},{"id":"6cf34b83-d38a-46dc-8302-a20288b0d780","text":"Arnett et al. review and field studies (circa 2008) documenting consistent patterns of bat fatalities at wind energy facilities and identifying operational conditions that drive bat collisions.","date":"2008-04-24 00:00:00"},{"id":"5b8a68bf-3608-469c-b027-3fec24302b2a","text":"Loss, Will & Marra (Biological Conservation, Dec 2013) published widely\u2011cited estimates of bird collision mortality at U.S. wind facilities (commonly quoted range ~140,000\u2013328,000 birds/year).","date":"2013-12-24 00:00:00"},{"id":"46c01df2-2feb-4f99-bc16-539c8ca2b867","text":"Israel Ministry of Health presentation on booster-dose effectiveness and evidence of waning two\u2011dose vaccine protection.","date":"2021-09-17 00:00:00"},{"id":"a6c232db-1a65-43e5-99aa-56186d183ca5","text":"Ukrainian authorities and security services announced investigations and potential legal action against Antonov company officials over failures linked to the Mriya\'s destruction.","date":"2022-03-24 00:00:00"},{"id":"79088632-2935-4ce9-9241-aa7bc44d76ba","text":"Hostomel (Antonov) airport was the scene of capture, heavy fighting and later reported withdrawal/retreat of Russian forces during March 2022.","date":"2022-03-31 00:00:00"},{"id":"9306dc4c-bbdb-436c-b00f-b410355002aa","text":"Ukraine suspends consular services for military\u2011age men living abroad","date":"2024-04-23 00:00:00"},{"id":"458aeba4-416b-46fa-a35b-ecd460f72be8","text":"President Zelensky signs a major overhaul of Ukraine\'s mobilization law","date":"2024-04-16 00:00:00"},{"id":"edb8e667-b21a-45e7-848a-98aac580af24","text":"BBC World Service \'BBC Eye\' investigation: nearly 20,000 men fled Ukraine to avoid conscription (investigation published Aug 2023)","date":"2023-08-31 00:00:00"},{"id":"8c142b12-a65a-4ce6-86ae-aae44f23c9cc","text":"NATO\u2011Ukraine Council (defence ministers) meets and publicly reiterates stepped-up support","date":"2024-04-19 00:00:00"},{"id":"e748127d-9540-4a39-9726-f81edd2c8e8f","text":"The UK Coronavirus Act 2020 received Royal Assent, creating expanded emergency powers for government pandemic response.","date":"2020-03-25 00:00:00"},{"id":"e3b3e9fa-930f-40cb-a960-487fe2683fab","text":"The White House issued a proclamation declaring a national emergency concerning COVID-19.","date":"2020-03-13 00:00:00"},{"id":"80f55654-6963-44a9-aadf-53eb4540c6cd","text":"President Trump and other US officials publicly expressed unusually optimistic timelines for a vaccine, saying a vaccine might be available in a few months.","date":"2020-03-31 00:00:00"},{"id":"942337db-4b80-4c5e-a142-04a5dc2df92c","text":"Moderna announced the first participant was dosed in its NIH-led Phase 1 trial of mRNA-1273.","date":"2020-03-16 00:00:00"},{"id":"ab5a60e5-1d17-46e0-8127-9a12fee20233","text":"Florida Department of Health press release stating VAERS reports from Florida increased 1,700% after COVID-19 vaccine rollout","date":"2023-02-15 00:00:00"},{"id":"2d9b57e8-c3c3-4496-889e-49cbb023c515","text":"Florida Surgeon General Joseph Ladapo issued mRNA COVID-19 vaccine guidance recommending against mRNA vaccines for males aged 18\u201339","date":"2022-10-07 00:00:00"},{"id":"9e528c86-3518-44cf-9457-649aebabe1ac","text":"Record-high public support for marijuana legalization reported by Gallup (64% in favor).","date":"2017-10-24 00:00:00"},{"id":"9c94162e-1144-4d01-9300-a5d1061c9b0b","text":"Publication of David Nutt et al.\'s Lancet paper ranking drug harms, which placed alcohol high and cannabis low.","date":"2007-03-24 00:00:00"},{"id":"70adf12e-fa53-43c7-8d7a-2f599125e473","text":"Sacking of Professor David Nutt from the UK Advisory Council on the Misuse of Drugs after public comments comparing alcohol\'s harms to those of illegal drugs.","date":"2009-10-24 00:00:00"},{"id":"84f271c8-1fba-4ded-a316-c79332085a5f","text":"Ukraine\'s parliament passed \'decommunization\' laws criminalizing propaganda of totalitarian symbols and prompting removal/renaming of Soviet\u2011era monuments and toponyms.","date":"2015-04-24 00:00:00"},{"id":"d9906cb0-4f96-4c12-af10-045c3e9830a5","text":"International outlets reported that nationalist and far\u2011right groups had gained influence and were under scrutiny in post\u2011Maidan Ukraine.","date":"2014-03-24 00:00:00"},{"id":"a994727b-62ac-4e99-9ff7-b623a3e7ce1e","text":"Right Sector, an umbrella of ultranationalist groups, played a prominent and public role during the Euromaidan protests.","date":"2014-02-24 00:00:00"},{"id":"a4650293-dc10-4ba0-8b5c-2a53b5c104ca","text":"Svoboda party members held ministerial posts in Ukraine\'s 2014 interim government after Yanukovych fled.","date":"2014-02-24 00:00:00"},{"id":"5d538b3b-083c-4c70-b5a9-0f0dfc1aa3f0","text":"Ukraine\'s Cabinet of Ministers increased administrative fines for quarantine breaches via Resolution No.255.","date":"2020-04-02 00:00:00"},{"id":"38e35b26-e0a3-478a-b08d-491381d5c88a","text":"Legal summaries and guidance published in April 2020 explaining strengthened quarantine rules and penalties in Ukraine (legal/firm briefings and PDF guides).","date":"2020-04-24 00:00:00"},{"id":"c51b41b1-9760-4339-854f-287b00ad0c84","text":"Publication of preliminary safety data on mRNA COVID\u201119 vaccines in pregnancy (v\u2011safe/VAERS analyses)","date":"2021-04-24 00:00:00"},{"id":"e02e3907-1835-46df-850e-452f3b834bf7","text":"Verkhovna Rada adopts \'decommunization\' laws banning Soviet symbols and renaming places (spring 2015)","date":"2015-04-24 00:00:00"},{"id":"541465c0-ead7-4c43-8610-39c68db9ae97","text":"Ukraine adopts the red poppy and promotes May 8 remembrance practices (media coverage, May 2015)","date":"2015-05-07 00:00:00"},{"id":"0fa1cb68-fd34-4681-8f0b-84ed327d371c","text":"Ukraine criminalises public promotion/use of the Russian/St. George ribbon (amendment creating administrative offence), reinforcing break with Soviet/Russian WWII symbolism","date":"2017-05-16 00:00:00"},{"id":"cb791cbb-0911-4b8e-97a7-752b4d22f599","text":"Wave of Lenin statue topplings across Ukraine during 2014 \'Leninfall\'","date":"2014-09-24 00:00:00"},{"id":"dad446c8-03c1-413f-9114-2f9d5e01bd8e","text":"Passage of the Law \'On Ensuring the Rights and Freedoms of Internally Displaced Persons\' (IDP law)","date":"2014-06-24 00:00:00"},{"id":"462e4a03-4d8c-4341-833f-f2ec89502281","text":"Cabinet of Ministers Resolution No. 302 (25 March 2015) on passport issuance and registration procedures","date":"2015-03-25 00:00:00"},{"id":"4e8ef4ff-dc82-4121-ab94-8ddfe30d3f14","text":"Law No. 1382\u2011IV \'On freedom of movement and free choice of place of residence\' (adopted)","date":"2003-12-11 00:00:00"},{"id":"68c425e7-db7f-4682-8099-2f8ee5563c2d","text":"Abolition of the Soviet \'propiska\' system and lingering public confusion about registration (historical/legal context)","date":"1991-04-24 00:00:00"},{"id":"8ab14ca7-177b-42cb-ba67-cf8818192e53","text":"Publication of large 2022 pan\u2011cancer mycobiome analyses showing tumor\u2011associated fungal signatures across multiple cancer types (pan\u2011cancer mycobiome studies).","date":"2022-09-29 00:00:00"},{"id":"818fdb67-5968-4972-ae07-798bd412f8b9","text":"Public debate and symbolic acts over Odesa\'s Russian imperial monuments (removal of Catherine II statue)","date":"2024-01-11 00:00:00"},{"id":"47af4d33-0512-41a8-a25f-30f4778003fc","text":"NATO Wales Summit pledges concrete support to Ukraine (Readiness Action Plan)","date":"2014-09-04 00:00:00"},{"id":"60c71afc-0960-4690-ac6b-3a2929556e3f","text":"US announces $53 million in non-lethal military assistance to Ukraine","date":"2014-09-18 00:00:00"},{"id":"c87b17f7-61ab-471b-91cd-5716b5aac344","text":"John McCain visits Maidan and publicly supports protesters","date":"2013-12-24 00:00:00"},{"id":"1188ef4a-afd9-4c2d-8d23-cb5ffb6c6df2","text":"Japan suspends use of some Moderna COVID-19 vaccine batches amid contamination concerns (reported by Reuters).","date":"2021-08-27 00:00:00"},{"id":"5cf794fe-3c11-47eb-9ac3-4d3c6c7f3126","text":"Office for National Statistics (ONS) public \'Deaths by vaccination status, England\' dataset and periodic releases (dataset page with major updates accessible 25 August 2023).","date":"2023-08-25 00:00:00"},{"id":"ed2bf98c-6e1f-4d37-a55e-fdd5b175f958","text":"UKHSA \'Vaccine surveillance report\' (Week 4) published figures showing substantially reduced or \'negative\' vaccine effectiveness against symptomatic Omicron infection in some analyses.","date":"2022-01-27 00:00:00"},{"id":"83bd32b7-c4ae-434d-9e02-3e01d321661e","text":"Publication of case series and reports documenting short-term inflammatory musculoskeletal events after COVID-19 vaccination (e.g., \'Spectrum of short-term inflammatory musculoskeletal manifestations after COVID-19 vaccine administration: a report of 66 cases\').","date":"2021-11-26 00:00:00"},{"id":"f1647966-4838-440a-aebf-82a10a8894dd","text":"Historic precedent of drownings at the Hungary\u2013Serbia/Tisza border route and UNHCR public concern (reported in 2016).","date":"2016-06-04 00:00:00"},{"id":"720a46b3-59b3-4358-870a-89c487e84d5c","text":"Recent regional examples of formal memorials for migrants who drowned in border rivers (AP coverage of a Drina River memorial in Bosnia).","date":"2024-02-04 00:00:00"},{"id":"8199722f-107b-4824-81cd-a4e9f21e452e","text":"Local reports in early May 2024 that multiple bodies were recovered from the Tisza River (State Border Guard Service reported three more drowned people).","date":"2024-05-07 00:00:00"},{"id":"f4760408-3b19-425e-931d-f5b85fa7ad2f","text":"Launch/inauguration of Hulhumal\xe9 Phase 3 land-reclamation works (government announcement, inaugurated September 22, 2023)","date":"2023-09-22 00:00:00"},{"id":"fd1e2a9c-0bc6-4fb6-8afb-685739fed911","text":"Publication of Duvat 2019 review \'A global assessment of atoll island planform changes over the past decades\' reporting that 88.6% of studied atoll islands were stable or increased in area","date":"2019-04-24 00:00:00"},{"id":"f2497bf6-410d-4898-9795-ebd88e880c0f","text":"MIT Self-Assembly Lab / National Geographic-supported \'Growing Islands\' projects in the Maldives (projects and demonstrations, including 2022 fieldwork)","date":"2022-04-24 00:00:00"},{"id":"364f0dcb-c131-4adf-a34b-8f19f88d52a7","text":"CDC public guidance for health departments/laboratories on reporting breakthrough cases which states: for cases with a known RT-PCR cycle threshold (Ct) value, submit only specimens with Ct value \u226428 to CDC for sequencing.","date":"2021-05-01 00:00:00"},{"id":"fc990176-3f23-4e69-9e6c-2950dbd56f07","text":"Mainstream media coverage and criticism of the CDC decision to limit active investigation and public reporting of breakthrough infections to hospitalized/fatal cases (coverage highlighting concerns this could \'hide\' milder breakthroughs).","date":"2021-05-27 00:00:00"},{"id":"592c3ce7-e4d1-4537-b9a6-6715c5ffd7e9","text":"Documented U.S. support for Ukrainian civil society and opposition groups via NGOs and grants (e.g., National Endowment for Democracy activities in Ukraine around 2013\u20132014).","date":"2014-04-24 00:00:00"},{"id":"bf0075d7-5c9c-4369-9994-3b19f20c9099","text":"Victoria Nuland public remark that the U.S. has invested about $5 billion in Ukraine since 1991.","date":"2013-12-24 00:00:00"},{"id":"8f987eb0-0364-48bf-936f-1e5b5fa5087a","text":"Removal of President Viktor Yanukovych after mass Euromaidan protests; Yanukovych flees Kyiv and parliament votes to remove him.","date":"2014-02-24 00:00:00"},{"id":"2327e9e9-0b9b-420b-b3be-0f9707fa55ec","text":"IPCC Fifth Assessment Report (AR5) notes a reduced rate of surface warming for 1998\u20132012 (the so\u2011called \'global warming hiatus\')","date":"2013-09-24 00:00:00"},{"id":"dc63181f-17bc-4343-b478-aac247e55192","text":"IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) published and approved","date":"2019-09-24 00:00:00"},{"id":"6399ab81-8bf9-4d35-8afa-a1c2d5c281b4","text":"2019\u201320 Australian \'Black Summer\' bushfires (widespread, high\u2011impact fires across eastern and southern Australia)","date":"None"},{"id":"99376817-68db-4068-9cbd-fb73baa6456e","text":"Major polar vortex breakdown and cold snap across North America and parts of Europe","date":"2019-01-24 00:00:00"},{"id":"869f4856-096a-4864-a678-c4826830fab0","text":"Dublin Declaration on Maternal Health Care issued (pro\u2011life clinicians declare \'abortion is not medically necessary\')","date":"2012-09-08 00:00:00"},{"id":"d7d8e3b9-ac2d-4fb0-ab2a-62ee7454889b","text":"Ohio \'heartbeat\' (Human Rights and Heartbeat Protection) bill signed into law","date":"2019-04-11 00:00:00"},{"id":"9a4403c6-b2ac-4ec5-b6b2-1619c342bcc2","text":"Alabama Human Life Protection Act signed into law (near\u2011total abortion ban)","date":"2019-05-15 00:00:00"},{"id":"b1b0c026-7199-4aa6-a048-93c13840edda","text":"Prior high\u2011profile \'map without Crimea\' incidents (e.g., Human Rights Watch map controversy) primed public sensitivity to any depiction of Ukraine that appears to exclude Crimea.","date":"2023-01-31 00:00:00"},{"id":"822740f5-e6a4-43e6-9bee-e14d64272496","text":"CDC MMWR report on a rapid COVID-19 outbreak in an Ohio Amish community (May 2020) showing very high attack rates after social gatherings.","date":"2020-05-24 00:00:00"},{"id":"dda7fcf7-59ad-43a1-ae33-26eaf103fcb7","text":"Local reporting claimed up to 90% of Lancaster County \'Plain\' households had been infected, suggesting community-level \'herd immunity\'.","date":"2021-03-27 00:00:00"},{"id":"79419e99-ecaf-4138-b2b3-f7cee50fa0b0","text":"Reporting of foreign volunteers and sympathizers (including Europeans) joining separatists in Donbas (2014)","date":"2014-06-24 00:00:00"},{"id":"78bf4fdf-0835-4b4c-a611-940cce285dd5","text":"Large government\u2011sanctioned pro\u2011Crimea/Putin demonstrations in Moscow (March 2014)","date":"2014-03-24 00:00:00"},{"id":"6bbb635f-e0f2-452c-b57b-b5a70779c142","text":"Nationalisation of PrivatBank after capital shortfall (18 December 2016)","date":"2016-12-18 00:00:00"},{"id":"26067bc5-831d-4b3a-b9b4-282d8ffa5e85","text":"Outbreak of large\u2011scale fighting in Donbas and its measured economic impact (2014\u20132015)","date":"None"},{"id":"52833197-6a55-4070-bad3-f5ad28d3d8bc","text":"Sharp hryvnia devaluation and currency crisis (February 2014)","date":"2014-02-24 00:00:00"},{"id":"6c30dbdc-810e-41d7-b83e-f6e17c80a0c9","text":"Background: Ukraine\'s International Legion and widespread coverage of thousands of foreign volunteers (Feb 2022)","date":"2022-02-27 00:00:00"},{"id":"93d12391-eef7-4c5a-8d23-3ca3ffb008bd","text":"NCHS/CDC published official guidance on how to certify deaths involving COVID-19 (guidance on listing COVID-19 on death certificates).","date":"2020-03-04 00:00:00"},{"id":"a0b3494f-3b25-43d0-9637-2573e7d8135b","text":"Official explanations and reporting about provisional mortality data and reporting lags in the NCHS/CDC mortality system.","date":"2020-04-24 00:00:00"},{"id":"2a7bc1e4-5c5e-40e4-acda-c53dafd3c9a0","text":"Clinical trial registration for high\u2011dose intravenous vitamin C in COVID-19 (NCT04264533) announced on ClinicalTrials.gov","date":"2020-02-14 00:00:00"},{"id":"8b65cbf9-7f63-4595-bd95-246ce73c6301","text":"Ukraine reported hundreds of its citizens were trapped in Gaza and said it was working to evacuate them (public statements, mid\u2011October 2023).","date":"2023-10-15 00:00:00"},{"id":"03d26c5d-dae0-43de-bb40-e12f1a0a1713","text":"Large, ongoing presence of Ukrainian refugees in Romania (official UNHCR and government figures published in 2022\u2013early 2023).","date":"2023-02-24 00:00:00"},{"id":"516f9430-7cb6-4c16-9ce3-0f1dc1d59ae7","text":"Brazil President Jair Bolsonaro publicly downplayed COVID\u201119, calling it \'a little cold\' and criticizing lockdowns in a March 24, 2020 address.","date":"2020-03-24 00:00:00"},{"id":"48c5dddc-78ed-48ff-a24d-21039089ec99","text":"WHO statement (and tweet) on January 14, 2020 saying preliminary investigations found no clear evidence of human\u2011to\u2011human transmission.","date":"2020-01-14 00:00:00"},{"id":"2f591cc6-766b-4de0-90aa-5e326145da63","text":"Russian missile strike on Dnipro (widely reported Nov 21, 2024)","date":"2024-11-21 00:00:00"},{"id":"988a9c58-5f46-4af4-afdc-75d17fc213df","text":"Rapid intensification and an unusual track of Tropical Storm Milton as documented by official National Hurricane Center advisories in early October 2024.","date":"2024-10-06 00:00:00"},{"id":"8cb449ff-d21b-476f-a26b-289f9014209e","text":"Hurricane Helene (late September 2024) severely impacted Florida days earlier, prompting online discussion about consecutive destructive storms.","date":"2024-09-26 00:00:00"},{"id":"6f925d02-63b7-45e9-afa7-ed6665196762","text":"WHO fact sheet reporting ~1.5 billion people globally infected with soil\u2011transmitted helminths","date":"2019-04-24 00:00:00"},{"id":"56b2e091-1cbe-40c4-a60d-667253b89be3","text":"FDA public warning about \'Miracle Mineral Solution\' (MMS) marketed as a cure-all including for parasites","date":"2019-08-12 00:00:00"},{"id":"153e7304-a747-45d2-89be-8d56d7ebf0c2","text":"Sharp surge in European wholesale gas and power prices, raising fears of winter supply shortages","date":"2021-09-22 00:00:00"},{"id":"20a7f975-5a4d-424d-95ab-5ceb6cc370e2","text":"Completion of Nord Stream 2 pipeline construction reported in early September 2021","date":"2021-09-06 00:00:00"},{"id":"caf47164-4bc5-4b92-a634-49bfbbc70e58","text":"Signing of the 2019 Russia\u2013Ukraine gas transit agreement (dec. 30, 2019) defining transit volumes through Ukraine for 2020\u201324","date":"2019-12-30 00:00:00"},{"id":"16df827f-bd7a-497f-802c-657b4b130b45","text":"The Crimean parliament, while under occupation, appointed pro\u2011Russian politician Sergey Aksyonov as prime minister.","date":"2014-02-27 00:00:00"},{"id":"350979a9-e5d0-450c-a30b-382c9e68589c","text":"Masked, unmarked armed men (the so-called \'little green men\') seized the Crimean parliament building in Simferopol, occupying the legislature and preventing normal sessions.","date":"2014-02-27 00:00:00"},{"id":"e227fb02-66b2-46f4-8ff0-3ba31e2db4da","text":"Ukraine announces a nearly $40 million embezzlement scheme tied to mortar-shell procurement (SBU investigation)","date":"2024-01-28 00:00:00"},{"id":"3f7fdfd4-3e46-4d00-9a45-83acab5ddb62","text":"Rising conservative/public skepticism about continued U.S. assistance to Ukraine documented in 2023 media coverage","date":"2023-08-18 00:00:00"},{"id":"239b27e8-d089-4e57-98c5-4c76455d13e1","text":"Rapid growth of labor migration from Ukraine to Poland (Poland issued ~1.8 million employers\' declarations in 2017; analysis 2018)","date":"2018-10-24 00:00:00"},{"id":"81417279-482b-47bb-824a-1e4360669d2c","text":"Large-scale internal displacement and civilian displacement from Donbas (UNHCR reports, 2015)","date":"2015-12-24 00:00:00"},{"id":"58629ba1-a876-4cf2-9e86-abbf1b321a0b","text":"EU Schengen visa\u2011free regime for Ukrainian citizens comes into force","date":"2017-06-11 00:00:00"},{"id":"e66d9fdb-3abd-4db8-96cc-31025be32b36","text":"U.S. decision and delivery timeline in spring 2018 to supply Javelin anti\u2011tank systems to Ukraine","date":"2018-04-24 00:00:00"},{"id":"cee4ea01-6eae-46e4-89a4-59a920fa04a0","text":"Kurt Volker\u2019s visit to Ukraine (mid\u2011May 2018) and on\u2011the\u2011ground briefings about Donbas/Crimea","date":"2018-05-14 00:00:00"},{"id":"2769c0f5-344b-4758-b766-c38b432afbdc","text":"Uman\u2019s profile as a major Hasidic pilgrimage site and reports of thousands of visitors in March 2022","date":"2022-03-09 00:00:00"},{"id":"8a516dda-7f66-40ad-8d0a-4790dec2af9e","text":"Putin\'s February 24, 2022 justification for the invasion invoking \'demilitarisation\' and \'denazification\' of Ukraine","date":"2022-02-24 00:00:00"},{"id":"a80a49a4-31da-41a9-8200-1b85ad04386d","text":"HAARP published a transmission notice / research campaign for May 8\u201310, 2024 (ionospheric heating experiments)","date":"2024-05-08 00:00:00"},{"id":"409eb38a-b470-4060-875d-2a70306e343e","text":"NOAA Space Weather Prediction Center issued a Severe (G4) Geomagnetic Storm Watch","date":"2024-05-09 00:00:00"},{"id":"9c039d26-a19a-4ab1-acab-9eeefb6098a9","text":"Registration of the Pfizer/BioNTech BNT162b2 Phase 1/2/3 clinical trial on ClinicalTrials.gov (NCT04368728), first posted in April 2020, with trial documents showing pregnancy as an exclusion criterion.","date":"2020-04-29 00:00:00"},{"id":"cdbc5470-c4bd-49b8-8dd1-ad1172e9f3e6","text":"2014 Kenya tetanus vaccine sterilization allegations and subsequent WHO/UNICEF denial (HCG claim) \u2014 high\u2011profile historical sterilization scare.","date":"2014-10-24 00:00:00"},{"id":"1e104b78-27ab-417a-b7a3-a811b036f8da","text":"NOAA/NCEI (Karl et al.) 2015 paper revising ocean temperature bias and updating the global surface-temperature record","date":"2015-06-26 00:00:00"},{"id":"c3b69cf1-ef52-4f7c-a3fa-6f15916226ce","text":"Prior high-profile contacts between Turkish officials and Crimean Tatar leaders (e.g., Turkish FM Mevl\xfct \xc7avu\u015Fo\u011Flu met Mustafa Dzhemilev, Jan 26, 2016)","date":"2016-01-26 00:00:00"},{"id":"a0dfc6e8-dd9e-4100-91c8-a8bbd3e7e379","text":"Public biographical records show Nalyvaychenko served at the Ukrainian Embassy in the United States (Consular service/Consul in Washington, D.C., 2001\u20132003).","date":"None"},{"id":"e5acb719-6e1b-4c0e-bf26-60b264eded67","text":"Press coverage in Feb 2014 publicised close cooperation between Ukraine\u2019s SBU and U.S. intelligence partners (coverage emphasising U.S.\u2013SBU ties).","date":"2014-02-25 00:00:00"},{"id":"0cf8c26e-fa57-4bfe-953a-ccd79ef5a5b1","text":"European Commission publishes staff analysis showing rising short\u2011term visa refusal rates for Ukrainian applicants (2013\u21922014)","date":"2015-04-24 00:00:00"},{"id":"c28361a9-b80f-4c17-bee5-aefd916e9766","text":"EU adopts Sixth Progress Report on Ukraine\'s Visa Liberalisation Action Plan (Commission decision communicated in December 2015)","date":"2015-12-18 00:00:00"},{"id":"064c7739-3b88-43cd-92ae-29cd789412f6","text":"Several Schengen states reintroduce internal border controls during the 2015 migration crisis","date":"None"},{"id":"2b83fc24-9c8d-42a4-beca-c56726ad2a54","text":"EU decision to prolong economic sanctions on Russia (June 2019)","date":"2019-06-27 00:00:00"},{"id":"0257f52c-89f6-4cfb-9c0d-5b86a9efee9d","text":"Kerch Strait naval confrontation \u2014 Russia seizes Ukrainian ships","date":"2018-11-25 00:00:00"},{"id":"9eb89195-f804-43aa-988f-f7e451bdbd64","text":"Skripal poisoning and mass expulsions of Russian diplomats","date":"2018-03-24 00:00:00"},{"id":"0c3f7ad0-7532-46c3-a25f-884ccee7bb9c","text":"Downing of Malaysia Airlines flight MH17 over eastern Ukraine","date":"2014-07-17 00:00:00"},{"id":"bbbf880f-a3d6-42f8-ad6e-06e0e077e13a","text":"Preprint and early reports (June\u2013July 2021) documented multiple vaccine \'breakthrough\' infections with the Delta variant, including clusters where fully vaccinated people became infected.","date":"2021-06-28 00:00:00"},{"id":"860ccafc-2b23-4002-942b-bb242f004289","text":"CDC clinical guidance (May 2021) noted people with recent SARS-CoV-2 infection may consider delaying vaccination for up to three months and that infection can confer temporary immunity.","date":"2021-05-24 00:00:00"},{"id":"a9f960be-0d8b-42d4-be70-d97e78e0155a","text":"Israeli Ministry of Health and Reuters reported in early July 2021 that measured effectiveness of the Pfizer\u2013BioNTech vaccine against infection had declined (headline figure reported ~64% in early July amid Delta spread).","date":"2021-07-05 00:00:00"},{"id":"4740cab1-8725-4fc8-a0f0-f1d554915a43","text":"SIREN study (healthcare workers) reported substantially lower reinfection rates among antibody-positive participants compared with antibody-negative participants.","date":"2021-03-24 00:00:00"},{"id":"8ad73028-8c12-4fa6-a432-5b4119bf63dc","text":"Lancet Rheumatology paper reported lower humoral (antibody) responses after COVID-19 vaccination in patients with immune\u2011mediated inflammatory diseases","date":"2022-03-17 00:00:00"},{"id":"33911966-bd3c-4971-abde-7b549abbf5c0","text":"Japan suspends use of some Moderna COVID-19 vaccine batches after discovery of foreign/black particles","date":"2021-08-26 00:00:00"},{"id":"b2f75d73-126f-423c-acc9-5075c262d520","text":"FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children 5\u201311","date":"2021-10-29 00:00:00"},{"id":"5ab3d19c-52f3-4215-b630-51123495bc58","text":"Public reporting and CDC guidance on rare myocarditis/pericarditis cases after mRNA vaccination in adolescents and young adults","date":"2021-06-24 00:00:00"},{"id":"4dde4a46-a612-4bf1-b453-efe74073f1dd","text":"U.S. publicly rejected Poland\u2019s proposal to transfer its MiG\u201129s via a U.S. base, citing NATO concerns","date":"2022-03-09 00:00:00"},{"id":"08f91ad3-d5ad-4436-88ab-157ab205095e","text":"NATO announced plans to reinforce its eastern flank with additional troops and assets in response to the Russian invasion","date":"2022-02-03 00:00:00"},{"id":"243dbeb3-88ad-400e-a589-41c8938ab022","text":"Analysis and reporting documented an uptick in Kremlin disinformation targeting Poland and Poland\u2013Ukraine relations","date":"2022-02-22 00:00:00"},{"id":"6aac85c1-f89b-434d-b528-04e5dff82c6c","text":"WHO-China Joint Mission final report noted roughly 80% of confirmed COVID-19 cases were mild.","date":"2020-02-28 00:00:00"},{"id":"e8b208e1-030d-4a27-bb7e-7787553dc27b","text":"Early WHO/CDC public guidance said masks were primarily for symptomatic people and caregivers and were not routinely required for healthy members of the public.","date":"2020-03-09 00:00:00"},{"id":"b6ee86a2-5295-4ca0-b93d-53914a4ebae5","text":"Industry/academic report \'Sustainable Decommissioning: Wind Turbine Blade Recycling\' (March 2021) documented technical and commercial barriers to large-scale blade recycling and called for solutions.","date":"2021-03-24 00:00:00"},{"id":"e8399eff-e7e6-4b21-b154-272768481766","text":"Public Health Scotland / national reports on births and pregnancy outcomes for year ending 31 March 2023 published (routine surveillance showing fluctuations in stillbirth/neonatal rates).","date":"2023-07-24 00:00:00"},{"id":"944d2dbe-3483-4e47-b538-7b8559e9d958","text":"Published medical case reports and toxicology literature documenting severe turpentine poisoning","date":"2015-04-24 00:00:00"},{"id":"1136f4cb-a49d-41f1-9cac-d70dcf211cbf","text":"Radiology literature (2021) documenting vaccine-associated axillary/supraclavicular lymphadenopathy and FDG PET/CT uptake","date":"2021-04-24 00:00:00"},{"id":"25a1caa7-d6f5-491d-9e2f-0a38fb2c651f","text":"Publication of a case report describing rapid progression of marginal zone B\u2011cell lymphoma following BNT162b2 vaccination (Frontiers in Medicine)","date":"2022-08-24 00:00:00"},{"id":"55ef6841-b095-4d5a-989c-cca41799f571","text":"Germany publicly approved supplying Leopard 2 tanks to Ukraine and allowed other countries to re-export their Leopard tanks.","date":"2023-01-25 00:00:00"},{"id":"1f092cf3-991e-4bd3-853d-2a376f8ad7f0","text":"High-profile coverage of Wagner Group operations and heavy losses around Bakhmut in February 2023 increased attention on Wagner\'s battlefield role.","date":"2023-02-17 00:00:00"},{"id":"b129bd74-7a51-4dec-969d-ea1fbdf47d0a","text":"EPA issues the 2009 Endangerment Finding that greenhouse gases (including CO2) threaten public health and welfare.","date":"2009-12-07 00:00:00"},{"id":"dac7813d-7275-44bb-ba70-9b18cb0b92f0","text":"Scientific and industry literature documenting routine CO2 enrichment in greenhouses to boost plant growth (longstanding agricultural practice; review articles dating back decades).","date":"1987-04-24 00:00:00"},{"id":"c1a76e96-5a4c-423f-ad79-fe2527f488fd","text":"U.S. Rep. John Shimkus publicly refers to carbon dioxide as \'plant food\' during a House Energy and Commerce subcommittee hearing.","date":"2009-04-02 00:00:00"},{"id":"59bfd6ec-34b7-470f-93e9-7f20adf47941","text":"Drone/sea\u2011drone attacks on ships and the Sevastopol/Black Sea Fleet anchorage","date":"2022-10-29 00:00:00"},{"id":"6ddc3e25-2e33-41f1-ad1e-666dd835a9a3","text":"Explosions at Saky (Novofedorivka) air base in western Crimea","date":"2022-08-09 00:00:00"},{"id":"c3b6dba7-c61a-48bc-a3b0-5cdb54988e2c","text":"Russian reports of arrests/detentions over alleged plots to sabotage Crimean infrastructure","date":"2022-11-02 00:00:00"},{"id":"50fe6559-6f9f-4660-9edb-49929b234b82","text":"Passage of the National Childhood Vaccine Injury Act (NCVIA) establishing the National Vaccine Injury Compensation Program (VICP)","date":"1986-11-14 00:00:00"},{"id":"88585fe8-9d78-4049-9dca-176f1d48d205","text":"FDA proposed sunscreen monograph update and limited \'GRASE\' designation (only zinc oxide and titanium dioxide)","date":"2019-02-26 00:00:00"},{"id":"f30159a5-55d8-4fa2-a777-19e4b9407855","text":"Edgewell (Banana Boat) voluntary recall for sunscreens due to benzene contamination","date":"2022-07-29 00:00:00"},{"id":"6f732b0b-8064-4b90-98d7-b3a056cfe23e","text":"Seizure of Sloviansk and other towns (April 2014) \u2014 separatists quickly occupied checkpoints and were reported driving captured Ukrainian armoured vehicles","date":"2014-04-16 00:00:00"},{"id":"10d02800-aa81-4b60-a52c-44f70d5a4ba9","text":"Battle of Ilovaisk (August 2014) \u2014 encirclement and heavy Ukrainian losses with numerous troops killed, wounded or captured","date":"2014-08-24 00:00:00"},{"id":"13e0a4f7-4725-4307-982d-1d8a5d9aea21","text":"UNESCO expert recommendation to list the Great Barrier Reef as \'in danger\'","date":"2021-06-22 00:00:00"},{"id":"9c39dcd3-3a13-408d-9f46-a0ff637bd8a7","text":"AIMS press release: \'Reef in recovery window after decade of disturbances\' (AIMS Long\u2011Term Monitoring Program results)","date":"2021-07-19 00:00:00"},{"id":"288c9dd9-3458-4f12-b4d6-e48643cca886","text":"Australian government and political backlash/lobbying over UNESCO recommendation","date":"None"},{"id":"b23955d7-beff-4040-9358-de291f6dad20","text":"Earlier inconsistent public messaging on mask use by health authorities (CDC guidance evolution, April 3, 2020 recommendation to wear cloth face coverings)","date":"2020-04-03 00:00:00"},{"id":"719f65fd-c5e6-45a9-9c6f-87b91510dcff","text":"Publication of the DANMASK-19 randomized trial (Danish mask study) in the Annals of Internal Medicine","date":"2020-11-18 00:00:00"},{"id":"a528a283-82b0-49e5-a211-6a00230e9650","text":"UN OHCHR Human Rights Monitoring Mission (HRMMU) report on Ukraine noting incomplete/inconclusive investigations into the Odessa 2 May deaths","date":"2014-06-15 00:00:00"},{"id":"f372bcce-24f2-4ed9-96cd-3179650f748f","text":"South African National Institute for Communicable Diseases (NICD) early assessment reported Omicron appeared less severe on average but produced a rapid surge in cases and hospitalisations (report released Dec 21, 2021).","date":"2021-12-21 00:00:00"},{"id":"4f338687-ee12-4164-af7c-22d507a2227f","text":"Publication of a major global study quantifying temperature-related mortality (Zhao et al.) in Lancet Planetary Health","date":"2021-07-07 00:00:00"},{"id":"111737aa-a6ea-4e79-96a0-0dda72e05afa","text":"EU agreement on visa\u2011free travel for Ukrainian citizens (visa liberalisation process confirmed in 2017)","date":"2017-05-11 00:00:00"},{"id":"a6b9ab6f-d230-4c51-9ca7-4e9937d5f5f6","text":"EU sanctions on Russia in response to the annexation of Crimea and destabilisation of eastern Ukraine (sanctions imposed and expanded in 2014)","date":"2014-07-24 00:00:00"},{"id":"3d76c853-db5b-4627-a972-02d243783eee","text":"Ukrainian Cabinet fixes one\u2011time payment of 15 million UAH for families of fallen servicemen (decree published)","date":"2022-02-28 00:00:00"},{"id":"a4af2e0f-25a6-4104-889b-f1dc8a920a6d","text":"Government measures earlier in 2022 to simplify/adjust compensation procedures for families (administrative changes and rolling implementation)","date":"2022-04-04 00:00:00"},{"id":"a9ea8e8d-e334-4f5c-a6e9-f5710636ce5f","text":"Amendments to the law on social/legal protection of servicemen came into force (changed wording about how one\u2011time payments are regulated)","date":"2022-08-25 00:00:00"},{"id":"8d1e8f58-b8ca-43a4-8e79-91e7ca0256c1","text":"Verkhovna Rada approved Ukraine\'s 2020 state budget (official figures: revenues ~UAH 1.093 trillion, expenditures ~UAH 1.18 trillion, UAH 141.5 billion allocated for debt servicing).","date":"2019-11-14 00:00:00"},{"id":"3d02c32a-ad40-424f-8606-b4f8dfd8d519","text":"IMF approved a US$3.9 billion Stand\u2011By arrangement for Ukraine (IMF press release documenting large external financing and conditionality).","date":"2018-12-18 00:00:00"},{"id":"250bbe9a-0721-433c-881e-aac280e1ea73","text":"World Bank / multilateral reporting (Ukraine Economic Update, Nov 2019) warned of sizable financing needs and public\u2011debt pressures for 2019\u201321.","date":"2019-11-24 00:00:00"},{"id":"ec45304d-e020-47c6-b28a-0fc4ef0617ac","text":"Reporting of social tensions and local backlash in Germany over the large influx of Ukrainian refugees (coverage throughout 2022 highlighting strains on communities and rising anti\u2011refugee sentiment).","date":"2022-11-24 00:00:00"},{"id":"1d3fd3d3-bcb5-4057-a3ae-cec350879713","text":"Rizzi restaurant in Baden\u2011Baden was reported to have fired a Ukrainian employee after he posted a video condemning Russia (reported and condemned by Ukrainian officials in March 2022).","date":"2022-03-24 00:00:00"},{"id":"0e1785c4-83ac-45e4-b0c6-3b992768e268","text":"Explosions and missile strikes at Odesa port and nearby industrial sites were widely reported (e.g., reported explosions at Odesa port on April 3, 2022 and a deadly strike on April 23, 2022).","date":"2022-04-03 00:00:00"},{"id":"1af1e3dc-71d8-4263-a2ec-a64fef34d4fd","text":"Media reports of Western deliveries of gas masks and CBRN protective equipment to Ukraine (e.g., UK announced sending thousands of gas masks in April 2022).","date":"2022-04-24 00:00:00"},{"id":"7a30875c-5e64-4fbc-8c8d-bed9b6f27cc3","text":"United Nations letter (dated 6 April 2022) referencing alleged planned provocations and preparations for chemical weapons use in Ukraine.","date":"2022-04-06 00:00:00"},{"id":"a1e8eb0a-4b10-43cd-8856-21172708d018","text":"Russian Ministry of Defence publicly claimed Ukrainian special services were preparing a chemical \'provocation\' using toxic chemicals near the Yuzhny (South) port outside Odesa.","date":"2022-04-23 00:00:00"},{"id":"2cc4e4af-dc46-4ad4-a36f-739242ed3129","text":"Release/presentation of a Queensland Health study reporting that rates of persistent symptoms 12 weeks after Omicron infection were similar to rates after influenza in a highly vaccinated Queensland population.","date":"2024-03-15 00:00:00"},{"id":"4e4dc1ce-8ec1-43b6-b148-db1a9cd086a0","text":"European officials and media flagged that the proposed U.S. sanctions could target firms involved in Nord Stream 2 and other European energy projects","date":"2017-07-26 00:00:00"},{"id":"b0540df9-eca6-4ced-b2d1-700014fcdf69","text":"U.S. Senate overwhelmingly passed a bill imposing new sanctions on Russia (CAATSA)","date":"2017-07-27 00:00:00"},{"id":"828a2b98-67aa-4664-83eb-541f6a3cd05a","text":"President Trump announced U.S. withdrawal from the Paris Climate Agreement, triggering strong EU criticism","date":"2017-06-01 00:00:00"},{"id":"45371774-43cb-4e3d-847c-91c826a691fc","text":"OSCE Special Monitoring Mission (SMM) spot reports document shelling incidents and civilian casualties in Donetsk","date":"2015-01-22 00:00:00"},{"id":"aec08892-b3ff-48a8-958c-46c7c40e6508","text":"UNICEF report: over 1,000 children sheltering underground in Donetsk city (bomb shelters) and urgent needs appeal","date":"2015-01-27 00:00:00"},{"id":"44ef036d-cabd-44bd-a118-83522dc907f7","text":"International media reports \'Ukraine, rebels trade blame over shelling of central Donetsk\' after July 2015 strikes","date":"2015-07-19 00:00:00"},{"id":"6c9977de-a8e4-46cc-9f3a-cce09947f9d5","text":"Signing of the Minsk II agreement (February 2015) and subsequent claims of non\u2011implementation and ongoing violations","date":"2015-02-12 00:00:00"},{"id":"c96a4fa8-d456-4ef1-a3af-9bb73753687a","text":"Official supply\u2011shortage notices for semaglutide (Ozempic) and related GLP\u20111 drugs in early 2023.","date":"2023-02-27 00:00:00"},{"id":"81ff8eb3-a8ec-45c9-b9ee-9e6c21e49496","text":"Deep energy and commercial ties between Italian energy firm Eni and Russia\'s Gazprom, including extensions of strategic agreements (reported 2011\u20132012).","date":"2011-12-23 00:00:00"},{"id":"16a94229-5252-47ee-a983-9a151fb50d8f","text":"Release of the U.S. Fourth National Climate Assessment (NCA4), emphasizing strong human influence on recent warming","date":"2018-11-23 00:00:00"},{"id":"6bd57e1e-7b5d-4081-bfc5-623ac8cac507","text":"Release of UAH Version 6.0 satellite temperature dataset showing a reduced lower-troposphere warming trend","date":"2015-04-28 00:00:00"},{"id":"c16cfff2-edc1-403d-a5a3-9b8fad5d5dec","text":"Publication of a 1980 study documenting systemic perfusion produced by vigorous coughing in humans and animals","date":"1980-03-24 00:00:00"},{"id":"bbb76c07-d3ca-4a1a-918a-4e1e65f81fd2","text":"Resuscitation Council UK public statement warning the public that \'cough CPR\' is incorrect advice and should not be used outside monitored clinical settings","date":"2018-07-24 00:00:00"},{"id":"daaadb9e-5604-406e-bf09-cd42d4374674","text":"OSCE Special Monitoring Mission reports from early 2015 described restricted access, movement limitations and damage affecting medical services in Donetsk region, complicating independent verification of medical treatment claims.","date":"2015-02-24 00:00:00"},{"id":"2f715b03-548e-49c1-9000-e306db6857fb","text":"The existence and release of wounded Ukrainian soldier Roman Kapatsiy (treated after captivity) \u2014 reports showed he had severe injuries, attracted media attention, and his condition and treatment became contested facts.","date":"2015-07-24 00:00:00"},{"id":"a965e587-80cf-4d10-8819-be9491ac2be8","text":"Community publications and documentation describing routine reprocessing and geophysical corrections for satellite altimetry (ESA/AVISO and ESA CCI overview papers, 2016)","date":"2016-04-24 00:00:00"},{"id":"1ba9a5f3-9a3b-4afd-9cf9-c318bb80db34","text":"PNAS paper reporting detectable acceleration in global mean sea level (Nerem et al., 2018)","date":"2018-02-13 00:00:00"},{"id":"5ca90261-fa6c-467b-9774-646ffb71e21b","text":"Shelling and a fire were reported at the Zaporizhzhia nuclear power plant during early March 2022 hostilities.","date":"2022-03-04 00:00:00"},{"id":"bd039d84-414e-4a80-9ac1-db3b9b1a85bb","text":"US Air Force B-52 bomber task force conducted long-range integration flights through Europe (Bomber Task Force Europe) in March 2022.","date":"2022-03-04 00:00:00"},{"id":"8575edeb-b639-4048-a541-0e8f08e0f1a6","text":"Russian President Vladimir Putin ordered Russian nuclear deterrence forces put on high alert.","date":"2022-02-27 00:00:00"},{"id":"6fad7068-796b-4e29-923e-b77c12c1b30c","text":"NATO annual nuclear exercise \'Steadfast Noon\' commenced, involving dozens of aircraft and allied nations.","date":"2022-10-17 00:00:00"},{"id":"d17e6883-586d-470e-9f32-e80ae8581b10","text":"NATO adopted its 2022 Strategic Concept at the Madrid Summit, explicitly addressing Russia as the most significant and direct threat to Allies\u2019 security.","date":"2022-06-29 00:00:00"},{"id":"b5b1d0f2-cb71-4b4b-b1b5-993a136abdb7","text":"CDC MMWR report documenting thousands of vaccine \'breakthrough\' infections reported January\u2013April 2021","date":"2021-05-28 00:00:00"},{"id":"dea66aaa-48a8-4cca-b92a-84b2590481b6","text":"NIH / Health Affairs summary reporting that COVID-19 vaccines prevented nearly 140,000 U.S. deaths in the first months of rollout","date":"2021-10-24 00:00:00"},{"id":"150c3315-1cf3-4765-a408-2f64186e4e68","text":"IPCC AR6 Synthesis Report released (summarizing strong attribution of recent warming to human greenhouse gas emissions)","date":"2023-03-20 00:00:00"},{"id":"92dd5a3e-1456-4443-8272-98133402a88b","text":"NOAA / NASA updates and public discussion of Solar Cycle 25 progress (solar-cycle forecasts/plots revised/updated in early 2023)","date":"2023-02-24 00:00:00"},{"id":"e09c49de-0aef-4b62-a700-bb102432743b","text":"Publication of Nicola Scafetta\'s paper arguing a large solar influence on recent climate change","date":"2023-06-14 00:00:00"},{"id":"fe76db37-fdb5-4340-9f9c-ce91489ba14b","text":"Kateryna Prokopenko (head of the Association of Azovstal Defenders\' Families) visited Germany in early April 2023 to hold meetings with German MPs and ministry representatives seeking humanitarian and rehabilitation support for families and released soldiers.","date":"None"},{"id":"f5356c05-dce7-44f5-a872-82e02ddd286e","text":"News reports of contamination concerns after foreign particles were found in some Moderna vials in Japan (leading to temporary pauses/collections of batches).","date":"2021-08-24 00:00:00"},{"id":"fc4117d2-87c7-44ce-867c-4f13ac0f1392","text":"Public HAARP transmission schedules / community notices in 2024 (routine test announcements, e.g., August 2024 transmission notice)","date":"2024-08-13 00:00:00"},{"id":"da11cc7b-0f34-421e-bf7b-cf23c6d6b060","text":"International Organization for Migration and other agencies repaired and expanded collective centres and integration/housing projects for internally displaced persons (IDPs) in Lviv region.","date":"2017-06-24 00:00:00"},{"id":"c9eb5159-568f-4148-a2fb-6859815f6398","text":"Adoption of Ukraine\'s \'On Education\' law (Sept 2017) which phases in greater use of Ukrainian as the language of instruction.","date":"2017-09-24 00:00:00"},{"id":"22b94445-9072-47f1-8db2-0a45e813b7e5","text":"Media reports (international and domestic) on national\u2011patriotic youth camps and \'patriotic education\' programs in Ukraine (coverage in 2018).","date":"2018-11-24 00:00:00"},{"id":"75924a82-3fcc-4240-91aa-b5e0dc0ddca6","text":"Government and research reports quantifying long COVID\'s prevalence and labour\u2011market impact in 2022 (UK ONS and research briefs)","date":"2022-07-24 00:00:00"},{"id":"11229a50-6227-4cda-b6f3-5925c6879785","text":"Japan discovered metal contaminants in multiple Moderna vaccine batches (led to recalls and paused use)","date":"2021-09-24 00:00:00"},{"id":"91e04afe-07d9-40e2-9618-693f13e31bb7","text":"EMA safety updates reporting millions of spontaneous adverse\u2011event reports in EudraVigilance (December 2022 update)","date":"2022-12-08 00:00:00"},{"id":"79b10fc4-9ac8-4f93-8668-0ed316cb376e","text":"Reporting in 2014 highlighted Svoboda\'s nationalist/controversial imagery and its roles in government after Euromaidan (e.g., BBC coverage of far\u2011right role in late 2014).","date":"2014-12-13 00:00:00"},{"id":"148f7765-0c59-4960-80af-85da467e859c","text":"Catalan child-protection agency (DGAIA) removed two schoolgirls from a Barcelona school and took them into protective custody on or after 17 June 2022.","date":"2022-06-17 00:00:00"},{"id":"96921c57-8997-4820-ae0d-3f734506e1d1","text":"Russian state television (Channel One, program Vremya) broadcast segments accusing Catalan authorities of \'Russophobia\' in connection with the Barcelona custody case (late July 2022 coverage).","date":"2022-07-24 00:00:00"},{"id":"0cec1eb4-0d43-4e73-b943-262808d31996","text":"Broader bilateral tensions between Spain/EU and Russia in 2022 (e.g., Spain expelled Russian diplomats in May 2022), increasing a receptive environment for claims of anti-Russian actions abroad.","date":"2022-05-18 00:00:00"},{"id":"a9648e62-fdd2-4d60-9d4f-2eee4b983df0","text":"Opinion op-ed in The Hill by Drs. Pierre Kory and Paul Marik claiming ~70% of patients in a private practice reported symptom onset after vaccination (coining/advancing \'long vax\').","date":"2024-03-06 00:00:00"},{"id":"9f8e5759-7324-42fc-a3a2-93d97062df5b","text":"Official reports that Ukrainian nationals were among foreign victims and contacts with the Ukrainian embassy (Zelenskiy statement)","date":"2023-10-08 00:00:00"},{"id":"e3138869-da14-4f17-97f1-26df7cad259b","text":"Large-scale Hamas-led attack on Israel caused mass casualties and chaos","date":"2023-10-07 00:00:00"},{"id":"ab57c0ee-23ff-4b12-8a23-b14c2fbe9ed6","text":"Parliamentary measures (July 2022) and legislative proposals expanding categories eligible for exemption or deferment during mobilization","date":"2022-07-29 00:00:00"},{"id":"bd45579f-c2f9-4ed6-8c28-c2cd8e8d68ee","text":"Cabinet of Ministers Resolution No. 76 establishing the procedure for reservation (deferment) of employees during mobilization","date":"2023-01-27 00:00:00"},{"id":"75910daf-346b-4c9a-b959-259c73a68ff9","text":"Law on Mobilization amendments and implementing rules entering into force clarifying grounds and procedures for booking/reserving conscripts","date":"2022-12-04 00:00:00"},{"id":"b8c349c1-0d1e-45cc-8f94-109672980d3c","text":"State license granted to the Kyiv Three Saints Theological Seminary to offer a first (bachelor\u2019s) level degree in Theology","date":"2024-01-15 00:00:00"},{"id":"dc7cdf80-8073-4d2a-80c5-aa72b4be7526","text":"International analyses documenting flows of foreign fighters into Syria/Iraq (The Soufan Group updates, 2014\u2013Dec 2015)","date":"2015-12-24 00:00:00"},{"id":"563ca22b-cb1b-4ac2-8562-688154bbb566","text":"Second World Congress of Crimean Tatars convened in Ankara with hundreds of delegates from many countries (international diaspora gathering, Aug 1\u20132, 2015)","date":"None"},{"id":"b48bf9de-0300-4962-a4bc-3b8c4ec05e4e","text":"Media reports that some Crimean Tatars (and other individuals from the region) had fought in the Syrian conflict","date":"2014-03-24 00:00:00"},{"id":"6baee768-4fae-40bd-99ae-34818b6c4ff1","text":"Lithuanian Riflemen\'s Union hosts a five-day camp for 30 children from eastern Ukraine (Donbass)","date":"2019-08-07 00:00:00"},{"id":"8556b458-d003-4b29-9c94-899b30ca4564","text":"Passage of Ukraine\'s \'decommunization\' laws banning public promotion of Soviet symbols and requiring removal/renaming of Soviet\u2011era memorials and street names.","date":"2015-04-09 00:00:00"},{"id":"2fef81c4-c4ab-4e3e-a3f9-2a1e32f501b2","text":"Ukrainian authorities (Ministry of Veterans Affairs / regional outlets) distributed Ukrainian commemorative medals to some WWII veterans in spring 2020.","date":"None"},{"id":"4c2eba41-b018-43bd-a059-2a1210432b9c","text":"Ukrainian lawmakers amended administrative code to prohibit public production and promotion of the St. George\'s (Victory) ribbon.","date":"2017-05-16 00:00:00"},{"id":"0f127d4d-6f8f-4773-a3e2-fa45c536924c","text":"OSCE Special Monitoring Mission (SMM) daily reports in late August\u2013early September 2018 documented continuing ceasefire violations along the contact line (Donetsk/Luhansk).","date":"2018-08-31 00:00:00"},{"id":"2cb073f1-14d4-4cbc-bad0-da4fc2360c56","text":"Russian Foreign Ministry and other Russian officials publicly condemned Kyiv\'s reintegration law, saying it \'untied the hands of the war party\' and undermined the Minsk process.","date":"2018-02-24 00:00:00"},{"id":"1bff33ad-7336-42d2-89c2-c045d3609bcd","text":"European Parliament / policy briefings in 2018 and commentary highlighted tensions between Ukraine\'s domestic reforms (e.g., decentralisation/legislation) and the interpretation/implementation of Minsk II.","date":"2018-04-24 00:00:00"},{"id":"229b9137-7527-41ad-a10d-d86236fbc4dc","text":"Ukraine signs the \'Law on the Reintegration of the Donbas\' which defines Russia as an \'aggressor\' and sets a new legal framework for retaking occupied territories.","date":"2018-02-20 00:00:00"},{"id":"d35bb153-32de-4344-b1d3-debda63670ad","text":"Legacy controversy over the 2012 Kivalov\u2013Kolesnichenko language law and its political fallout (language policy highly politicized since 2012)","date":"2012-08-10 00:00:00"},{"id":"fda7e305-9c69-414b-afbf-35c24c351e73","text":"Kyiv City Council member Yuriy Syrotiuk registers a draft proposal to require Ukrainian in city advertising, record keeping and official communications","date":"2016-03-11 00:00:00"},{"id":"3f21ec81-ede9-4aac-bcf6-7a87e74dc21d","text":"Publication and coverage of genetic\u2011risk research showing APOE and common variants alter Alzheimer\'s risk/timing (Lancet Neurology 2018 and related coverage)","date":"2018-04-24 00:00:00"},{"id":"27a83928-0416-47d3-b260-0232ab70d248","text":"Publication of the FINGER multidomain randomized trial showing diet, exercise, cognitive training and vascular monitoring improved cognition in at\u2011risk older adults","date":"2015-06-24 00:00:00"},{"id":"8c1de153-2b7d-4551-bd69-8006cafdaa5c","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers acknowledges smaller observed warming trends 1998\u20132012 than many model simulations and cites internal variability as a likely contributor.","date":"2013-09-27 00:00:00"},{"id":"f298143c-340d-4e92-9efd-15885f108949","text":"Amnesty International published a briefing documenting abuses and possible war crimes by pro-government volunteer battalions (e.g., Aidar) operating alongside official forces.","date":"2014-09-08 00:00:00"},{"id":"0d06a48e-8249-453f-8f23-72b0f5363f52","text":"Ukrainian President Petro Poroshenko publicly said Ukrainian forces were fighting \'foreign mercenaries\' in the east.","date":"2014-08-23 00:00:00"},{"id":"ec67ebfe-51fd-4eb8-bbf5-d55aa15d030e","text":"NASA/NOAA public messaging about Solar Cycle 25 and increased space weather activity","date":"2020-10-24 00:00:00"},{"id":"7c0055b8-d81a-4f20-aed1-36ad7842eb30","text":"Out\u2011of\u2011cycle update to the World Magnetic Model (WMM2020) after rapid movement of the magnetic north pole","date":"2019-12-24 00:00:00"},{"id":"cf210236-aec4-464b-9fcb-e21cafe07515","text":"Ukraine reinstated military conscription to meet manpower needs after unrest in the east","date":"2014-05-24 00:00:00"},{"id":"9bd5f8e4-ee62-425d-bc45-13ff354ae53d","text":"Summaries and timelines noted multiple, uneven waves of mobilization (including difficult autumn stages) with administrative complications","date":"None"},{"id":"e4acbee1-1dd2-49fa-bc31-34100ff94b89","text":"Feature reporting documented men hiding or fleeing to avoid conscription and the social backlash against mobilization","date":"2015-02-24 00:00:00"},{"id":"ef477121-218e-411a-9ccc-a92c33206c03","text":"Federal judge orders the FDA to accelerate release of Pfizer COVID-19 vaccine documents (55,000 pages per month).","date":"2022-01-24 00:00:00"},{"id":"fff9f7c7-d732-47f4-a729-523774c75283","text":"UKHSA published weekly COVID-19 surveillance tables (four weeks to 2 January 2022) showing counts of cases, hospitalisations and deaths broken down by vaccination status.","date":"2022-01-24 00:00:00"},{"id":"74b3efdf-3b9c-4f10-ae59-76311110302b","text":"UKHSA published guidance and commentary (Transparency & data blog, 2 November 2021) explaining that raw counts by vaccination status should not be used to estimate vaccine effectiveness because of differing risk, behaviour and testing patterns.","date":"2021-11-24 00:00:00"},{"id":"a1a78fcf-e1cd-4efe-8936-ae38451c07f2","text":"CDC and other public-health reports covering the Omicron period and bivalent booster era (e.g., MMWR analyses covering Oct 2021\u2013Dec 2022, published early 2023) documented many breakthrough infections and complex changing relative rates of cases and hospitalisations.","date":"2023-02-24 00:00:00"},{"id":"8d8d375a-a686-47da-bc9c-6eac5ea9a427","text":"NORAD and U.S. military routinely intercept and track Russian military aircraft operating near Alaska (documented intercepts in prior years).","date":"2023-05-14 00:00:00"},{"id":"88430b8d-2dfc-43e8-a450-708e825fe2dd","text":"Historical pattern of military formation flights and public aerobatic displays over Alaska (large multi\u2011aircraft formation exercises reported previously).","date":"2022-08-12 00:00:00"},{"id":"c9a568c2-86ca-45e2-9270-7f388f5fcb24","text":"Russian/Crimean resettlement and incentive programs announced for Crimea","date":"2015-04-24 00:00:00"},{"id":"3d00d19c-2b7a-4ee2-a2b6-ba039a96eaee","text":"Large\u2011scale issuance of Russian passports to Crimean residents after annexation","date":"2014-04-24 00:00:00"},{"id":"a7a074c1-90c6-4d6d-ab05-f1443b144afc","text":"Resumption and growth of scheduled flights and transport connections to Simferopol (2015 onward)","date":"2015-05-24 00:00:00"},{"id":"9880c14a-51e5-458d-a588-7777014cd037","text":"OSCE Special Monitoring Mission (SMM) reporting of increased ceasefire violations/explosions and damage in Luhansk frontline areas (SMM daily monitoring around mid\u2011February 2022, including Stanytsia Luhanska and Zolote).","date":"2022-02-18 00:00:00"},{"id":"54cac0cc-06e2-4fd6-ba5b-b0cb4461853c","text":"Leaders of the self\u2011proclaimed Donetsk and Luhansk \u2018people\u2019s republics\u2019 announced mass evacuations to Russia (official evacuation orders and state messaging).","date":"2022-02-18 00:00:00"},{"id":"d493f755-eed0-4944-bbd3-5a6c9974fdb4","text":"Historical precedent of bridges and rail infrastructure being blown up during fighting in eastern Ukraine (documented incidents in 2014 where rail/road bridges were destroyed).","date":"2014-07-07 00:00:00"},{"id":"ef8f4a79-fb2c-4f9d-859e-01abe99e9db1","text":"LifeNews crew detained near Kramatorsk by Ukrainian forces, drawing attention to the channel\u2019s activities in conflict zones.","date":"2014-05-18 00:00:00"},{"id":"d4b57753-8820-4e4f-902f-f424afd1ddfa","text":"Early-March videos and eyewitness accounts documented violent attacks by pro-Russian separatists on protesters and demonstrators in eastern Ukraine.","date":"2014-03-14 00:00:00"},{"id":"9ffdedc3-d9ef-4cb0-8934-d60d94a1b93e","text":"Self\u2011declared Donetsk and Luhansk \'people\'s republics\' announced independence after May 2014 referendums","date":"2014-05-24 00:00:00"},{"id":"2c19756c-d0bb-4c7e-8ae6-cd4e787411f7","text":"Trilateral Contact Group negotiations included representatives of the self\u2011proclaimed Donetsk and Luhansk authorities (OSCE mediation, mid\u20112014)","date":"2014-07-24 00:00:00"},{"id":"bb9dbd38-71bc-4327-b8f4-4e516c788831","text":"Publication and wide circulation of quantitative comparisons of volcanic vs anthropogenic CO2 (e.g., Gerlach 2011) providing concrete numbers showing volcanic CO2 is far smaller than human emissions.","date":"2011-06-24 00:00:00"},{"id":"3d1ea1a5-3946-4ee6-ae7e-484f3bdf70ce","text":"IPCC Special Report on Global Warming of 1.5\xb0C (high-profile report, October 2018) that refocused public debate on CO2 budgets and human emissions.","date":"2018-10-24 00:00:00"},{"id":"cafec841-66ca-4e56-8c7b-bec6678a1ec3","text":"Reports and recall after discovery of foreign (black) particles in Moderna vaccine vials in Japan (late August\u2013September 2021)","date":"2021-09-24 00:00:00"},{"id":"bc043127-5b23-4ee1-a4f9-b80ceb8089e6","text":"CDC reports increased cases of myocarditis/pericarditis after mRNA COVID-19 vaccination in adolescents and young adults (public reporting began June 2021)","date":"2021-06-24 00:00:00"},{"id":"1d886fb6-8166-4a0b-af08-e49f9b3409c4","text":"FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children aged 5\u201311","date":"2021-10-29 00:00:00"},{"id":"e12674be-e40a-4090-8e59-24ab738b83e1","text":"Technical advisory scrutiny and Bureau response on ACORN\u2011SAT adjustments (ACORN\u2011SAT Technical Advisory Forum response)","date":"2016-04-24 00:00:00"},{"id":"1027ff9f-a236-4e67-ad2e-f71bd98a31b0","text":"Release of the ACORN\u2011SAT homogenised temperature dataset by the Bureau of Meteorology","date":"2012-03-24 00:00:00"},{"id":"f6bb2a03-7781-47e1-a609-0faed1482e89","text":"Widespread use of distance learning by mid\u20112022 (reports noting that by June 2022 most districts were providing remote classes)","date":"2022-06-24 00:00:00"},{"id":"8a634101-cd54-46bc-a687-7d1b533d8ffe","text":"Ministry of Education and UNICEF launch \'Back to Learning Together\' initiative encouraging return to in-person schooling","date":"2022-08-22 00:00:00"},{"id":"16cfa5fb-2b2c-41bc-a45c-3bfbafe45d99","text":"WHO and World Customs Organization published an HS classification reference for COVID-19 medical supplies (including simplified labels) on April 9, 2020","date":"2020-04-09 00:00:00"},{"id":"ee28fe43-1894-4c95-8870-fc28fca4a76b","text":"Adoption/use of the sixth edition Harmonized System (HS) nomenclature for commodity codes (introduced in 2017) that underpins WITS historical trade classifications","date":"2017-04-24 00:00:00"},{"id":"079c2f4a-cf04-4744-a34d-d7c5e33f1dd3","text":"Russian flags and pro\u2011Russian banners were visibly displayed in Russian\u2011occupied Ukrainian cities (e.g., Melitopol, Kherson) after Russian forces took control.","date":"2022-07-24 00:00:00"},{"id":"30b5867c-0d85-4a47-b3b7-3c54f63a325f","text":"Reports the US was sending military advisers and gear to Ukraine","date":"2014-06-05 00:00:00"},{"id":"d752f6cc-4187-4afe-99fe-a1c6c2cae958","text":"U.S. Congress passes the Ukraine Support Act (H.R.4278)","date":"2014-03-27 00:00:00"},{"id":"ff6cae56-e952-42b3-83a5-9ac9435224e6","text":"President Obama meets President-elect Petro Poroshenko (bilateral meeting in Warsaw)","date":"2014-06-04 00:00:00"},{"id":"76ca0985-7e78-47e4-b755-2290bf824812","text":"CDC interim guidance recommending routine cleaning and disinfection of high-touch surfaces in public and private facilities","date":"2020-03-10 00:00:00"},{"id":"83d0ef0d-d105-451f-9865-94a7fb63fbf0","text":"Mainstream consumer guidance advising precautions when pumping gas (Consumer Reports article advising wipes/precautions)","date":"2020-03-21 00:00:00"},{"id":"3f2cefbe-b919-486c-b195-695bd3725bcf","text":"NEJM correspondence showing SARS-CoV-2 remains viable in aerosols and on surfaces (van Doremalen et al.)","date":"2020-03-17 00:00:00"},{"id":"976b90b1-ffc0-45e9-bae7-ba4cd7407f18","text":"News coverage and retailer actions showing grocery stores providing wipes and installing cart-sanitizing measures","date":"2020-03-24 00:00:00"},{"id":"4f5d7f54-0e07-4d45-8714-b56d3126678e","text":"WHO/UNICEF updated and re-emphasised global guidance recommending exclusive breastfeeding for the first 6 months and advising not to give additional water to infants under 6 months.","date":"2023-12-20 00:00:00"},{"id":"35397bc5-60fc-4557-99be-80f5907223d3","text":"CDC MMWR report summarising cases of hyponatremic seizures among infants fed excessive solute\u2011free water (including bottled water) in Wisconsin (1993) and urging clinicians to discourage use of solute\u2011free water as a supplement for infants under 6 months.","date":"None"},{"id":"425a5c11-f27d-4f43-be17-a3bb22e2b8c0","text":"Gates Foundation funding of genetically engineered mosquito/gene-drive research (2016\u20132018 coverage, e.g., Oxitec funding)","date":"2018-06-24 00:00:00"},{"id":"5446ec33-6405-427f-a4a7-b1516e31c796","text":"Study reporting very low methylphenidate (Ritalin) prescription prevalence in France based on drug reimbursement databases (published 2007\u20132008)","date":"2008-03-24 00:00:00"},{"id":"30eb27a7-d0ba-4d1f-8de8-bf1c8259d737","text":"CDC report \'Mental Health Surveillance Among Children \u2014 United States, 2005\u20132011\' stating \'up to 1 in 5 children suffer from a mental disorder\'","date":"2013-05-17 00:00:00"},{"id":"d4cca293-647c-438c-8750-2eb681311176","text":"French national telephone prevalence study (Lecendreux et al.) estimating childhood ADHD prevalence ~3.5%\u20135.6% (published 2011)","date":"2011-04-24 00:00:00"},{"id":"71d928fc-0847-486c-9da2-baf35bbab3b4","text":"Measles outbreak in the Gothenburg area (outbreak period Dec 2017\u2013Jan 2018) reported in Eurosurveillance (article published April 25, 2019).","date":"2019-04-25 00:00:00"},{"id":"6915995f-bfd0-4669-b7a3-0b66d95da7ea","text":"Public Health Agency of Sweden (Folkh\xe4lsomyndigheten) information emphasising that vaccinations in Sweden are recommended (not compulsory) and are implemented regionally.","date":"2019-04-24 00:00:00"},{"id":"1e340ec3-de70-4af2-9954-3014f5f13739","text":"European pauses and safety reviews of the AstraZeneca vaccine after rare clot reports (March\u2013April 2021)","date":"2021-03-15 00:00:00"},{"id":"86f7ea7d-367b-4e3c-a4c2-06a33148d191","text":"Japan recalls some Moderna COVID-19 vaccine doses after foreign particles found in vials (September 2021)","date":"2021-09-02 00:00:00"},{"id":"8901b6ba-a1b3-4591-9266-938a286911c6","text":"WHO designation of Omicron (B.1.1.529) as a Variant of Concern and early statements on mutations/immune escape","date":"2021-11-26 00:00:00"},{"id":"ef32505f-4b87-443f-980e-b5273bb66e97","text":"CDC/ACIP updates and MMWR reporting on myocarditis cases after mRNA vaccination","date":"2021-07-06 00:00:00"},{"id":"80aa0218-4894-4d93-9036-99596d3f9805","text":"Ukrainian law on temporarily occupied territories (Law No. 1207\u2011VII, 15 April 2014) \u2014 non\u2011recognition of documents issued by occupation authorities","date":"2014-04-15 00:00:00"},{"id":"e513feeb-a471-4ce8-94c8-d0308e293d7c","text":"Russian presidential decree (April 2019) simplifying and fast\u2011tracking Russian citizenship for residents of the self\u2011proclaimed Donetsk and Luhansk \'republics\'","date":"2019-04-24 00:00:00"},{"id":"54f64ead-5d9e-422d-ba85-10bf0e254bd0","text":"Publication of research using luciferase reporters in SARS\u2011CoV\u20112 laboratory assays","date":"2020-06-24 00:00:00"},{"id":"de8e82dd-5b36-4b6a-9e32-67075988ea63","text":"NFPA / Fire Protection Research Foundation published reports and guidance describing the unique firefighting challenges posed by electric vehicle \'stranded energy\' and battery fires.","date":"2021-04-24 00:00:00"},{"id":"e6b15468-d019-476d-a80d-5ca76fb645ad","text":"General Motors issued a high-profile recall of Chevrolet Bolt EVs over a risk of battery-related fires (recalls and repair campaigns announced starting November 2020 and updated subsequently).","date":"2020-11-24 00:00:00"},{"id":"6f1133cb-61a4-44f5-b5d1-c48a58b4bd78","text":"Ford announced recalls and investigations into a small number of F-150 Lightning pickups over battery-pack issues after several battery-related fire incidents and a temporary production halt (recall notices and reports in early 2025).","date":"2025-04-24 00:00:00"},{"id":"0d93e6dc-8136-49c8-a877-3309cd11622d","text":"Multiple electric buses in London caught fire (high-visibility incidents in May 2024), prompting safety checks of hundreds of vehicles and broad media coverage.","date":"2024-05-24 00:00:00"},{"id":"228efa10-aa8d-4e4a-a70f-9a434e61ab03","text":"Publication of Otto et al., \'Energy budget constraints on climate response\' (Nature Geoscience, May 2013), which produced observational energy-budget estimates of climate sensitivity on the lower end of model ranges.","date":"2013-05-24 00:00:00"},{"id":"3df77559-ea00-4e25-aee5-5af4521b40ab","text":"IPCC AR5 Summary for Policymakers (Sep 2013) stated it is \\"extremely likely\\" that more than half of the observed increase in global average surface temperature from 1951 to 2010 was caused by anthropogenic greenhouse gases.","date":"2013-09-24 00:00:00"},{"id":"f3187c0f-a7fa-4eb3-9659-2e4897884950","text":"ICEYE and Ukraine\'s Ministry of Defence sign a Memorandum of Cooperation to strengthen remote-sensing support for Ukraine (publicised July 2024)","date":"2024-07-08 00:00:00"},{"id":"56f97b95-7511-4f0d-90b0-29e6125e047c","text":"Reporting that the \'Prytula\' / \'People\'s Satellite\' warranty period expired while GUR continued to use the asset (media coverage raising questions about operational status, July 4, 2025)","date":"2025-07-04 00:00:00"},{"id":"f71e1b87-0731-4652-9fce-8e43d28e6513","text":"Ukraine\'s Defence Intelligence (GUR/DIU) and media reports state the \'People\'s Satellite\' supplied thousands of SAR images used to identify Russian military targets (mid\u20112024 reporting of ~4,000+ images)","date":"2024-06-26 00:00:00"},{"id":"16621546-2155-4af0-a522-ffbef36ca911","text":"Cultural/history articles revisiting Reich\'s orgone accumulator (e.g., Open Culture piece) were published in early 2021 and circulated thereafter, describing the accumulator, its devotees, and DIY plans online.","date":"2021-01-19 00:00:00"},{"id":"7043be3a-1348-4fbf-b4da-ad5f86f81265","text":"Documented paramilitary training and transnational links involving Azov/National Corps veterans (analyses and reports up to 2021)","date":"2021-12-24 00:00:00"},{"id":"d2dc63a2-a2b0-46f3-9c28-22af90aa8310","text":"Ukraine surrendered the Soviet-era nuclear arsenal under the 1994 Budapest Memorandum","date":"1994-12-05 00:00:00"},{"id":"43918ef3-c02d-446c-9939-aa0619c5f4fa","text":"A group of countries (UK, Poland, Netherlands and others) publicly pledged to pursue \'unprecedented\' military support including main battle tanks for Ukraine.","date":"2023-01-19 00:00:00"},{"id":"aa4f399d-477c-4275-904c-522b7565062b","text":"Germany approves sending Leopard 2 tanks to Ukraine, paving way for allied tank deliveries.","date":"2023-01-25 00:00:00"},{"id":"e84846ba-99ab-47fe-a730-6172d9ac3b35","text":"Russian officials publicly denounced Western promises to send tanks as an escalation and framed them as direct Western involvement in the conflict.","date":"2023-01-26 00:00:00"},{"id":"28dabced-e72d-40db-a769-1ed696cfb685","text":"UN Secretary-General Ant\xf3nio Guterres called for de\u2011escalation and warned about risks of wider war in public remarks at Davos.","date":"2023-01-18 00:00:00"},{"id":"dcb9c056-92d5-4729-b922-92cfe2886e27","text":"Peer\u2011reviewed retrospective study (Argentina) found higher rates of false\u2011positive HIV ELISA results among people with prior COVID\u201119 or detectable anti\u2011SARS\u2011CoV\u20112 antibodies","date":"2023-02-07 00:00:00"},{"id":"be2dc09e-34a3-4a1e-8396-9fa5bd1a5998","text":"NATO maritime group (including Turkish navy participation) visited the Bulgarian Black Sea port of Varna during Black Sea deployment","date":"2015-03-09 00:00:00"},{"id":"d3eeab90-548e-4b0c-b847-422addd6dde1","text":"Investigations and reporting showing Bulgarian-made weapons appearing in Middle Eastern conflict zones","date":"2015-12-16 00:00:00"},{"id":"f69ea3ae-6350-45cb-97f3-9a323713bb8d","text":"Ukraine detained a Turkish-owned cargo ship after it visited a Crimean port","date":"2015-03-27 00:00:00"},{"id":"89af2cfb-0121-4d57-83f1-725bd1f33b6d","text":"Reuters report that Turkey\'s state intelligence agency helped ship arms to Syrian rebel areas","date":"2014-01-28 00:00:00"},{"id":"2da829a2-d59e-4a98-921a-295d99a62943","text":"Investigative reporting on crowdfunding for alternative cancer treatments and rise in patient fundraising for unproven therapies.","date":"2018-09-14 00:00:00"},{"id":"a6ac98d3-f2a9-457d-800a-22ac55a5cff0","text":"WHO commentary warning against \'immunity passports\' and noting uncertainty about post\u2011infection immunity","date":"2020-04-24 00:00:00"},{"id":"fa43bf47-f53b-457f-92ba-d9060e873e45","text":"Publication: \'Seasonal coronavirus protective immunity is short\u2011lasting\' (Edridge et al., Nature Medicine, May 2020)","date":"2020-05-11 00:00:00"},{"id":"58d52923-309c-4639-b67f-3660c4b7a5db","text":"WHO told Reuters it had advised Ukraine in March 2022 to destroy certain high\u2011risk pathogens in public health laboratories to prevent accidental release during the war","date":"2022-03-11 00:00:00"},{"id":"106bd334-194a-46f9-89ae-c7207674e45d","text":"A prior 2020 incident: Ukrainian volunteers dropped ruble\u2011shaped leaflets over occupied Luhansk (Slavyanoserbsk/Stepove), which local separatist authorities later claimed were contaminated","date":"2020-04-24 00:00:00"},{"id":"605516b3-6350-4af2-a2a4-0e5e03f786c8","text":"FDA issues Emergency Use Authorization for Pfizer\u2013BioNTech COVID\u201119 vaccine (Dec 2020)","date":"2020-12-11 00:00:00"},{"id":"a1c1f03c-2199-42ea-b800-30e376e60e7b","text":"Publication of early seroprevalence studies suggesting lower infection fatality rates (e.g., Stanford/Santa Clara preprint)","date":"2020-04-17 00:00:00"},{"id":"4ff7f89e-7034-4984-b150-cf36a2108c68","text":"IMF / national energy-policy documents and regulator schedules (2015\u20132016) documented planned increases in household energy tariffs as part of energy-market reform and commitments to creditors.","date":"2016-04-24 00:00:00"},{"id":"f83a30b3-bda9-4d94-a290-fbc0c947dbd4","text":"Kyiv City Council approved additional municipal budget allocations for organizing and hosting Eurovision (including reported allocations for surveillance/security and event costs).","date":"2016-10-24 00:00:00"},{"id":"f5041c7d-5ced-42ef-b16b-265fff9faf50","text":"European Broadcasting Union (EBU) confirmed Kyiv as host city for the 2017 Eurovision Song Contest.","date":"2016-08-24 00:00:00"},{"id":"88cbd551-9a16-4dcb-bfde-6588777cc74f","text":"Russian strikes and shelling left Kharkiv without water and power, with dozens of civilian casualties reported","date":"2022-03-03 00:00:00"},{"id":"dda1be66-a107-41ec-93a7-19785aaf8620","text":"Evacuations and chaotic flight from Kharkiv, including reports of students and residents fleeing on foot after nearby shelling","date":"2022-03-03 00:00:00"},{"id":"d3451e34-9533-4766-974d-3fcdb0c014ea","text":"Frequent reporting and situation updates showing Ukrainian forces prioritizing defense and counterattacks around Kyiv while fighting continued in the northeast","date":"2022-03-31 00:00:00"},{"id":"4f1874ce-1d5b-4a37-93b6-1081e371c585","text":"Norwegian review of deaths among very frail elderly shortly after Pfizer vaccination (investigation reported March 2021)","date":"2021-03-24 00:00:00"},{"id":"7573ffd4-3209-4f1b-a704-f3bf46faa2c9","text":"CDC / ACIP communication and MMWR reports on myocarditis after mRNA vaccines (June 2021)","date":"2021-06-23 00:00:00"},{"id":"168afc39-23ad-42a9-a4c1-9cd89385981a","text":"OSCE Special Monitoring Mission reports and daily summaries recorded clashes, alleged atrocities and contested reports around Donetsk/Snizhne in Aug 2014","date":"2014-08-21 00:00:00"},{"id":"4c56dcfd-316c-4b0c-b293-23eccee791ef","text":"Airstrike hits residential buildings in Snizhne, killing civilians","date":"2014-07-15 00:00:00"},{"id":"9daad42d-18d2-4972-91b8-ef9a05123604","text":"Japan reports contamination (black/foreign particles) in batches of Moderna COVID-19 vaccine vials, prompting recalls and temporary suspension of some batches","date":"2021-09-24 00:00:00"},{"id":"44b5f8c2-b8bc-480b-98f6-1704d3629f4f","text":"Coverage and commentary noting a post-pandemic rise in late-stage and some rare/aggressive cancer diagnoses \u2014 analysts and clinicians pointed to missed screenings, delayed diagnoses and possible biological mechanisms tied to SARS\u2011CoV\u20112 infection","date":"2024-06-24 00:00:00"},{"id":"f7547891-fa78-414e-ab7a-62f3b8edde8d","text":"U.S. Government Accountability Office (GAO) report on cloud\u2011seeding technology (GAO\u201125\u2011107328) concluded in December 2024 that evidence for cloud\u2011seeding effectiveness is limited and uncertain.","date":"2024-12-19 00:00:00"},{"id":"80344cca-fd55-4c1f-bf37-13d5c04a010f","text":"A private cloud\u2011seeding company (Rainmaker Technology) conducted a brief cloud\u2011seeding flight over south\u2011central Texas two days before the floods.","date":"2025-07-02 00:00:00"},{"id":"2a009960-9048-4096-b8b0-842ff57f2b0e","text":"Russian president\'s decree simplifying the naturalization process for Ukrainians (widely reported July 2022)","date":"2022-07-11 00:00:00"},{"id":"c2b186f6-c022-4b2b-918e-01c7ae57ece6","text":"Local and national Ukrainian reports (mid-March 2022) documented that Russian shelling had heavily damaged parts of Rubizhne City Multidisciplinary Hospital (e.g., maternity/obstetrics department destroyed).","date":"2022-03-15 00:00:00"},{"id":"fcb1f017-02c2-49ef-a0de-5a8be0a4a3de","text":"Ramzan Kadyrov publicly announced Chechen forces\' deployment to Ukraine and frequently posted videos and claims via his Telegram/state-affiliated channels in Feb\u2013May 2022.","date":"2022-02-26 00:00:00"},{"id":"f6298f4e-34be-4bd5-a9e3-c09111e5e60b","text":"The Rubizhne Central City Hospital infectious diseases department had been renovated in 2017 with funds from UNDP and the Government of Japan (official works and signage).","date":"2017-04-24 00:00:00"},{"id":"3a0429c7-68cc-4b17-8842-8b698a3c682b","text":"IPCC AR5 and public messaging about decadal/short\u2011term variability vs. long\u2011term warming (IPCC WGI report, 2013)","date":"2013-09-24 00:00:00"},{"id":"6b716a22-76d1-466d-9ff6-7f7dc7399a03","text":"Commissioning and public release of the U.S. Climate Reference Network (USCRN) as a high\u2011quality, \u2018pristine\u2019 temperature station network (began 2005; ongoing rollout)","date":"2005-04-24 00:00:00"},{"id":"8ca1d7aa-9e43-46fb-86f4-1a2ef994f80c","text":"Publication of Karl et al. (NOAA) in Science revising global surface temperature records and rebutting the idea of a global \'hiatus\' (June 2015)","date":"2015-06-24 00:00:00"},{"id":"f13890cf-a339-4ac5-80b3-3630493f1039","text":"Local bans/restrictions on Russian\u2011language cultural products in parts of Ukraine (example: Lviv restrictions/public measures).","date":"2018-09-19 00:00:00"},{"id":"41481512-2ffe-410c-b574-b775d2ac0edd","text":"Constitutional Court declared the 2012 Kivalov\u2013Kolesnichenko \'regional languages\' law unconstitutional.","date":"2018-02-28 00:00:00"},{"id":"415369c8-30f6-4fa5-809e-a154f30d2fa5","text":"Public and parliamentary clashes around the second reading of the language bill, with pro\u2011Russian MPs and media framing the draft as discriminatory/anti\u2011Russian (disruption and heated debate around Feb\u2013Mar 2019).","date":"2019-02-28 00:00:00"},{"id":"902a1595-3dd5-4012-b0bd-83fe8948f71f","text":"Verkhovna Rada approved draft bill No. 5670-d (the new state language bill) at first reading.","date":"2018-10-04 00:00:00"},{"id":"89306a7f-432c-42e6-ad88-b078d6e35833","text":"Dutch Safety Board (Onderzoeksraad) formally took charge of the international investigation into the MH17 crash","date":"2014-07-23 00:00:00"},{"id":"4d09c518-222d-4ced-a7f4-12f71e9f4182","text":"Gazprom and Naftogaz sign settlement and five-year transit agreement","date":"2019-12-30 00:00:00"},{"id":"1c178e2e-5b14-4c6d-93fc-1b8fffd907e6","text":"Longstanding precedent: Russia cut gas to Ukraine and Europe in January 2009","date":"2009-01-24 00:00:00"},{"id":"732b85e8-3019-4568-8bdb-996dffebbe60","text":"Inauguration of TurkStream pipeline (alternative southern route)","date":"2020-01-08 00:00:00"},{"id":"ce4c5e9d-7414-42b4-976a-83c224c8bfb0","text":"Published analysis noting reduced guaranteed transit volumes from 2021 under the 2019 deal","date":"2020-02-24 00:00:00"},{"id":"aa115de9-cb33-42a2-b72f-cc1fcb53651f","text":"IUCN / Polar Bear Specialist Group published 2015 Red List assessment with a global population estimate (\u224822,000\u201331,000) and noted the overall population trend as \'unknown\'.","date":"2015-10-24 00:00:00"},{"id":"cf1859da-3e2c-4640-8d45-1b649c6efd89","text":"Amnesty International and Human Rights Watch published 2018 findings that Ukrainian authorities failed to investigate and punish far\u2011right violence","date":"2018-06-14 00:00:00"},{"id":"6c2d4573-fdb1-4022-b637-584a82b70b2c","text":"Volunteer battalions (including Azov) were brought under the Interior Ministry/National Guard command in 2014","date":"2014-05-15 00:00:00"},{"id":"f863cc41-925b-40e4-bfd1-d70664e0a384","text":"Reports that some volunteer regiments were financed or sponsored by political figures/oligarchs while operating under ministry structures (example: Dnipro-1)","date":"2016-02-18 00:00:00"},{"id":"02e90b1c-35ac-4c76-9490-e196796f07ca","text":"IPCC AR5 (2013) assessment noting divergence among lines of evidence for equilibrium climate sensitivity","date":"2013-09-24 00:00:00"},{"id":"6a6b6e27-e2ee-4fbc-9a8d-4c993f33ffc5","text":"Release of UAH Version 6 satellite temperature product (Spencer & Christy), reporting reduced tropospheric warming trend","date":"2015-04-24 00:00:00"},{"id":"f035e906-0b9e-4776-8f28-507ead8aa2bb","text":"Ukraine\'s 2018 national drug situation report (2017 data) noted transit and domestic production of various drugs","date":"2018-04-24 00:00:00"},{"id":"28b573f9-0e8f-42dc-85af-1fb345bfa138","text":"Large heroin seizure transiting through Odesa/Illichivsk port (reported 12 June 2015)","date":"2015-06-12 00:00:00"},{"id":"7c4cf18e-a1fc-4fd7-87c3-1d0205d000f7","text":"Growing media and scientific attention to microplastics in the food chain (scholarly reviews and coverage 2021\u20132024)","date":"2021-04-24 00:00:00"},{"id":"543fdefa-d58e-4d76-8071-bb86cf9e75be","text":"Public-health agencies (including the U.S. CDC) and research institutions historically filed patents on viral isolates or related sequences (e.g., CDC and others filed patent applications around the 2003 SARS outbreak to ensure public access to samples).","date":"2003-05-24 00:00:00"},{"id":"d33725f4-3fb6-4ab1-8fe5-92793806bd79","text":"Publication of the Independent Peer Review and technical reports documenting ACORN\u2011SAT methods (technical advisory documents made public).","date":"2011-07-24 00:00:00"},{"id":"79188f36-9dfb-4930-8fe5-4f28c5adf64f","text":"Release of the ACORN\u2011SAT homogenised temperature dataset by the Australian Bureau of Meteorology (the official long\u2011term Australian temperature series).","date":"2012-04-24 00:00:00"},{"id":"e5542718-0f4a-4a6a-b2a9-a7f74876d478","text":"Government discussion of investigating the Bureau after public controversy over temperature adjustments (reported discussions in 2015).","date":"2015-09-24 00:00:00"},{"id":"853229aa-e197-46e6-b730-86eb4a52ab20","text":"FDA enforcement actions and public warnings against numerous for\u2011profit stem cell clinics selling unapproved therapies","date":"2019-04-24 00:00:00"},{"id":"c543a8ff-a376-419e-8af9-95d851369395","text":"UN human-rights submissions and NGO reports (2012) documented development and piloting of restorative/diversion programmes for children in conflict with the law across multiple Ukrainian communities.","date":"2012-04-24 00:00:00"},{"id":"81a49100-18a5-401b-ad73-76867ece0bb2","text":"Parliament passed an amnesty law and released many protesters (including minors) detained during Euromaidan, creating visible cases of youths being freed from criminal charges.","date":"2014-02-14 00:00:00"},{"id":"c0ce502b-f8aa-44f6-b754-63a4956044f1","text":"Legislative activity and draft bills on child\u2011friendly procedures and mediation (alternative bills on mediation submitted to the Verkhovna Rada) were reported in 2013.","date":"2013-04-24 00:00:00"},{"id":"db80af84-e808-4fc4-9b3a-48ffda50ff52","text":"Longstanding NGO-led restorative justice pilot projects (first initiated in 2003) and subsequent local pilots expanded through the 2000s and early 2010s.","date":"2003-01-24 00:00:00"},{"id":"aa9876ba-55bc-43dc-b76f-e3374e78c9d1","text":"Japan suspends ~1.6 million Moderna doses over contamination reports","date":"2021-08-26 00:00:00"},{"id":"2be83f52-f77c-4552-82c3-949839d95a0b","text":"Israel study reports cases of myocarditis after Pfizer mRNA vaccine","date":"2021-10-06 00:00:00"},{"id":"e205fce5-7add-4723-b183-f8e3f4793203","text":"Study/analysis showing waning protection of BNT162b2 against Delta (Israel)","date":"2021-08-24 00:00:00"},{"id":"a62e7c0c-3014-426b-b4cb-f09f41a35640","text":"Arla Foods announced a UK trial of the methane-reducing feed additive Bovaer across ~30 farms (with Tesco, Aldi and Morrisons named partners).","date":"2024-11-26 00:00:00"},{"id":"171ecae6-87ff-409b-acdd-b6f06ea9c901","text":"The UK Food Standards Agency published a detailed technical safety assessment (RP1059) on 3\u2011nitrooxypropanol (3\u2011NOP, the active in Bovaer), including residue analysis and limits of quantification for milk.","date":"2023-03-24 00:00:00"},{"id":"610bcf42-e654-4fd1-864c-8c97bfc7e388","text":"dsm-firmenich (maker of Bovaer) announced that the US FDA had completed its review and that Bovaer met safety and efficacy requirements, paving the way for a US market launch.","date":"2024-05-29 00:00:00"},{"id":"e9af9077-dfe3-49a3-9da9-a8677be6d2ec","text":"EFSA / scientific assessments (including a 2021 EFSA feed-additive opinion / published scientific summaries) of 3\u2011NOP (Bovaer) were publicly available prior to 2024.","date":"2021-04-24 00:00:00"},{"id":"0a43eaac-9d11-4559-b4ca-8aac7ca1c563","text":"May 11, 2014 Donetsk and Luhansk \'referendums\' claiming overwhelming support for separation","date":"2014-05-11 00:00:00"},{"id":"7d7f1e0e-ae67-48b6-9123-ed59a792720f","text":"NIH COVID\u201119 Treatment Guidelines panel statement (early 2021) that there was insufficient evidence to recommend ivermectin for COVID\u201119 (revisions in/around February 2021).","date":"2021-02-24 00:00:00"},{"id":"66c3b2d9-9fd9-4ffb-a4fa-a50c1fac13ef","text":"Reported incident and grid disconnection at Zaporizhzhia nuclear plant (December 2014)","date":"2014-12-24 00:00:00"},{"id":"1e39ba56-9940-4fbf-8dd1-889dedcc9779","text":"Budapest Memorandum (security assurances to Ukraine)","date":"1994-12-05 00:00:00"},{"id":"53db27b4-4d8e-4ffc-958f-39a178f1fcb9","text":"CDC and FDA June 2021 review and public reporting of myocarditis and pericarditis cases after mRNA COVID\u201119 vaccination.","date":"2021-06-24 00:00:00"},{"id":"cb6e63a1-19db-4f46-a697-59d594fab471","text":"Federal judge orders accelerated public release of Pfizer vaccine documents (reported Jan 7, 2022), drawing attention to internal vaccine trial materials.","date":"2022-01-07 00:00:00"},{"id":"b91ff7ac-2550-4327-b693-f9c443c27bcd","text":"Ogata et al. (Clinical Infectious Diseases, 2021) reported detection of SARS\u2011CoV\u20112 vaccine antigens (spike protein fragments) in plasma of some mRNA\u20111273 recipients.","date":"2021-09-24 00:00:00"},{"id":"04585af3-b8d9-4baa-a6e6-186226f2c53a","text":"Genomic surveillance identified BA.2.86 in U.S. samples (pooled swabs collected Aug 10; individual sample confirmed Aug 20) and CDC reported early detections.","date":"2023-08-20 00:00:00"},{"id":"94106d8a-2fd8-4eaa-8ef3-f18642b87714","text":"Ukrainian President Volodymyr Zelensky appoints Chrystia Freeland as an economic development adviser","date":"2026-01-05 00:00:00"},{"id":"b0de1673-0cc8-41a9-b2c6-807fc598539d","text":"World Bank / government-backed moves to restructure Naftogaz (ownership unbundling debate, May 2019)","date":"2019-05-17 00:00:00"},{"id":"3a7c4f12-205f-44d7-893f-7c4955c0fb21","text":"Ukrainian government public administration reform (Strategy for Public Administration Reform 2019) including targets to streamline staff","date":"2019-04-24 00:00:00"},{"id":"811cffa0-d85d-4b68-a81f-9ecb5bab33b3","text":"World Bank: Ukraine Economic Update warns manufacturing and investment weak (press release)","date":"2019-11-19 00:00:00"},{"id":"9fbd23d2-85e0-4c53-bdb0-b8f0210aaa2a","text":"WHO declares COVID-19 a Public Health Emergency of International Concern (PHEIC)","date":"2020-01-30 00:00:00"},{"id":"2c7779d3-50fa-4978-a751-9def7aca0cc2","text":"Publication of a peer\u2011reviewed paper arguing a \'Modern Grand Solar Minimum\' could cause decades of cooling","date":"2020-04-24 00:00:00"},{"id":"cbf28224-359f-4af5-a68f-874ac3a7cfc2","text":"Nordic countries (Sweden, Denmark, Norway, Finland) limited or paused use of Moderna in younger people citing myocarditis signals (Oct 2021)","date":"2021-10-06 00:00:00"},{"id":"2e24dce7-d94c-4791-90e0-80af31835706","text":"CDC/ACIP report and guidance noting rare myocarditis cases after mRNA COVID-19 vaccination (June 2021)","date":"2021-06-23 00:00:00"},{"id":"2d51f614-a53b-41b7-a05c-e314d3acff13","text":"FDA emergency authorization of Pfizer\u2011BioNTech COVID\u201119 vaccine for children 5\u201311 (Oct 29, 2021)","date":"2021-10-29 00:00:00"},{"id":"5a766bde-8fc3-48c8-9691-33709b37f34e","text":"MedRxiv/academic preprint showing children have stronger pre\u2011activated innate airway antiviral responses to SARS\u2011CoV\u20112 (June 2021)","date":"2021-06-24 00:00:00"},{"id":"195dd2bf-8e9a-4ca1-89dd-d5527e18c2a1","text":"Local/municipal moves to formalise \'underground\' schooling in frontline areas (Kharkiv announced plans and preparatory works for an underground school; subway\u2011based classes were reported in Kharkiv).","date":"2023-10-24 00:00:00"},{"id":"03f59c33-5d82-4ad4-83bc-6a7b7862e369","text":"UNICEF photo essay and reporting documenting children sleeping and studying in basements, bomb shelters and other protected spaces in wartime Ukraine.","date":"2022-09-08 00:00:00"},{"id":"2fb6d1b3-35d3-4799-8513-846ab8a4d75f","text":"Commentary and analysis documenting a broader trend of \'atrocity denial\' and claims that wartime suffering (in Gaza and Ukraine) is \'staged\' \u2014 media pieces in November 2023 noted this pattern.","date":"2023-11-15 00:00:00"},{"id":"7c3b6688-d683-4382-903c-b975332dbc52","text":"Earlier 2025 federalized National Guard deployments to U.S. cities (e.g., Los Angeles in June 2025)","date":"2025-06-12 00:00:00"},{"id":"0573fdc1-393d-4cd7-8ccd-282f5126c66f","text":"Japan suspends use of multiple Moderna vaccine batches after reports of foreign particles/contamination found in vials.","date":"2021-08-26 00:00:00"},{"id":"afd7c698-e8d7-4547-9818-018bf39b410b","text":"CDC and FDA recommend a pause in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis (blood clots) in recipients.","date":"2021-04-13 00:00:00"},{"id":"e36d0b37-49fc-4dd8-bac5-bca15b1c8382","text":"European Medicines Agency (EMA) concludes that the Oxford\u2013AstraZeneca COVID-19 vaccine is associated with very rare unusual blood clots combined with low blood platelets and updates safety information.","date":"2021-04-07 00:00:00"},{"id":"c46920ea-8f61-469c-94c8-0f4df258b9bb","text":"EU Agency for Fundamental Rights (FRA) / EU research on \'severe forms of labour exploitation\' highlighted cases and structural vulnerabilities of migrant workers in Poland","date":"2016-04-24 00:00:00"},{"id":"9ce38159-4df2-4a30-b881-4e97c679c2c1","text":"Poland ratified the 2014 Protocol to the ILO Forced Labour Convention in October 2016 (official recognition and legal steps on forced labour)","date":"2016-10-24 00:00:00"},{"id":"d89eff74-1189-4fd5-b33f-6c3f55c0b6bb","text":"Polish government statistic: 420,000 Ukrainian citizens paid Social Insurance contributions in 2018 while estimates suggested up to 1\u20132 million Ukrainian migrants in Poland","date":"2018-04-24 00:00:00"},{"id":"bd07d283-3ff2-42c5-aad4-0c9508c49476","text":"Yatsenyuk faced pronounced political pressure and very low public approval in July 2015 (KIIS poll showed extremely low support), creating a background narrative of a weakened leader.","date":"2015-07-20 00:00:00"},{"id":"f5d06ae9-4e8c-4ace-ae65-7ad815033fde","text":"U.S. and Western officials had publicly warned in early February 2022 about the possibility of Russian \'false flag\' operations to justify invasion.","date":"2022-02-04 00:00:00"},{"id":"fbab0ba7-0a1a-42f7-b6c9-c7a2b136e760","text":"A Russian missile struck a high-rise apartment building in southwestern Kyiv and was widely reported on Feb 26, 2022.","date":"2022-02-26 00:00:00"},{"id":"ffa0b490-c0c6-4066-ac6b-412aa4813bee","text":"IPCC AR5 (2013) Summary for Policymakers: no single best estimate for equilibrium climate sensitivity given wide uncertainty across lines of evidence","date":"2013-09-24 00:00:00"},{"id":"0ad13d49-2b90-4845-b043-0b1effe7af40","text":"Reuters special reporting on the Ukrainian government\'s struggle to control independent volunteer/maverick battalions (reports of units operating beyond official command).","date":"2015-07-24 00:00:00"},{"id":"6dfa4668-6bbc-4e53-b326-efaf5323340d","text":"Amnesty International documented abuses by the Aidar volunteer battalion operating in Luhansk and areas around Donbas.","date":"2014-04-24 00:00:00"},{"id":"29b68f52-c694-4bd7-b9ec-4862a05b6aa1","text":"Human Rights Watch published \'You Don\'t Exist\' documenting arbitrary detentions, enforced disappearances and torture in eastern Ukraine by actors including pro\u2011government forces.","date":"2016-07-21 00:00:00"},{"id":"42f92565-64db-44cb-80c5-250dd9ed2225","text":"Minsk II agreement (February 12, 2015) set security, disarmament and withdrawal conditions as prerequisites for holding local elections in Donbas.","date":"2015-02-12 00:00:00"},{"id":"4c32bec3-72e5-4e9b-a048-dd4ffde7edc2","text":"Pro\u2011Russian separatists held disputed \'elections\' in Donetsk and Luhansk on 2 November 2014 amid reports of armed men at polling stations and chaotic scenes.","date":"2014-11-02 00:00:00"},{"id":"8fac81ca-74b5-4026-9d28-bca75cce2a4d","text":"Israel reintroduced indoor mask requirements amid a surge driven by the Delta variant.","date":"2021-06-25 00:00:00"},{"id":"a386b6c1-9b1f-4ced-979d-9ae27b682204","text":"Texas governor lifts statewide mask mandate and business restrictions (rescind mask orders).","date":"2021-03-02 00:00:00"},{"id":"1545f02a-2183-44e7-80eb-8e8017b06ace","text":"Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine showing limited protection for mask wearers (DANMASK-19).","date":"2020-11-18 00:00:00"},{"id":"8ed289d3-0cf6-469c-9cad-185096f11474","text":"Widespread visibility of Ukrainian nationalist symbols (UPA red-and-black flag, Bandera monuments) in Lviv and media coverage of those symbols","date":"2014-05-24 00:00:00"},{"id":"1d3c6131-e597-47a8-a1cd-17e85c114664","text":"Documented incidents of swastika graffiti and antisemitic vandalism in Ukraine in 2014\u20132015","date":"2015-04-24 00:00:00"},{"id":"5e163e86-8df2-4970-be19-1c721b67481a","text":"Air\u2011raid sirens sounded across Kyiv while President Biden and President Zelensky were visiting St. Michael\'s Cathedral (audio and footage captured live)","date":"2023-02-20 00:00:00"},{"id":"3a2dda61-d58e-4bbf-aedc-ee26a6054a9d","text":"IMF staff in Kyiv discussed draft anti-corruption court legislation as part of program-related conditions","date":"2018-02-15 00:00:00"},{"id":"f6f52da1-b69c-479b-9180-8690fc279e05","text":"IMF technical mission visited Kyiv to discuss continuation of the Extended Fund Facility (EFF) and held meetings with Ukrainian authorities","date":"2018-02-15 00:00:00"},{"id":"19ded8bb-b942-4c26-96bd-47fbac381987","text":"IMF public statements linking further financial support to Ukraine with implementation of pension reform and other policy conditions","date":"2018-01-18 00:00:00"},{"id":"c39f38e6-6801-43f0-b58d-85b1bb40ce68","text":"IMF said the timing of the next review of Ukraine\u2019s program (and related decisions) was \'not yet decided\', creating public uncertainty about disbursement timing","date":"2018-02-15 00:00:00"},{"id":"3cc71956-33bd-42f1-821f-772ffdb32426","text":"IMF approval of a $17.5 billion bailout program for Ukraine","date":"2015-03-11 00:00:00"},{"id":"41b1eb86-1e6e-4c67-9ead-477dc17e5c3c","text":"Russia\'s retaliatory ban on food imports from the EU, US and other countries","date":"2014-08-06 00:00:00"},{"id":"560ad3d8-ac49-48cb-80f6-697bbb5eba4c","text":"Sharp contraction of Ukraine\'s economy and currency devaluation during 2014\u20132015 (World Bank reporting)","date":"2015-04-24 00:00:00"},{"id":"72c161a4-0fe8-4234-98fd-234cda651549","text":"EU and US impose sanctions on Russia after the annexation of Crimea","date":"2014-03-24 00:00:00"},{"id":"beb0907e-2c5a-41e1-a3ac-cdb02446f79b","text":"Russia cuts natural gas supplies to Ukraine amid pricing/dispute","date":"2014-06-16 00:00:00"},{"id":"1078a74a-1bdd-4cf7-bb28-da7aacb1e369","text":"Ukrainian government policy and public statements (reported by major outlets) urging Ukrainian athletes to avoid competitions where they may face Russian or Belarusian competitors and, at times, withdrawing athletes from events for this reason.","date":"2022-03-24 00:00:00"},{"id":"6cdc6ca7-913e-463c-a1b6-6192ca4e8f38","text":"International Tennis Federation (ITF) suspends the Russian Tennis Federation and Belarus Tennis Federation from ITF membership and from participation in international team competition.","date":"2022-03-01 00:00:00"},{"id":"24ae4864-abfe-4abf-899b-ea8d7ab6dacb","text":"Federal judge orders the FDA to accelerate public release of Pfizer vaccine documents after a FOIA lawsuit (PHMPT), resulting in large batches of internal Pfizer/FDA files becoming publicly accessible.","date":"2022-01-24 00:00:00"},{"id":"042c20ef-1d96-448c-a138-f7fecca41e5c","text":"Parubiy\'s documented early political activism: co\u2011founding the Social\u2011National Party of Ukraine in 1991 and leading the paramilitary group \'Patriot of Ukraine\' (1998\u20132004).","date":"None"},{"id":"e1e7bc0f-5e62-472b-b2fe-0c1350bf36eb","text":"Established Kremlin disinformation pattern of portraying Ukraine (and Ukrainian officials) as \'neo\u2011Nazis\' used repeatedly since 2014.","date":"None"},{"id":"14836e2b-68e7-4472-951f-747a83eb318f","text":"Spanish authorities had opened and publicised large reception/assistance centres for Ukrainian refugees in spring 2022 (e.g., Malaga centre opened 6 April; PM visited 20 April).","date":"2022-04-20 00:00:00"},{"id":"31ec134e-e8d0-4347-ae2b-d7bb390827bf","text":"Science outlets published explanations (early September 2024) that a combination of factors\u2014dry Saharan air, pockets of wind shear, and short-term atmospheric anomalies\u2014had temporarily suppressed Atlantic tropical cyclone formation.","date":"2024-09-24 00:00:00"},{"id":"b4d900c3-7a33-4ac1-bbeb-2214891df708","text":"NOAA issues an \\"above-normal\\" 2024 Atlantic hurricane season outlook predicting 17\u201325 named storms and a high probability of above-normal activity.","date":"2024-05-23 00:00:00"},{"id":"7d8fc9d0-ee37-4617-bb57-bc9650a988a0","text":"An unusually quiet Labor Day weekend (early September 2024) with no named storms in the Atlantic\u2014reported as a seasonal rarity and record for recent decades.","date":"2024-09-03 00:00:00"},{"id":"6dd22e0c-75a1-42c5-9669-5ea344deb675","text":"Greta Thunberg\'s high-profile speech at the U.N. Climate Action Summit (widely covered and quoted in the days around Sep 23, 2019).","date":"2019-09-23 00:00:00"},{"id":"d50c791d-d408-460a-91cb-c316bbb2b74f","text":"Russian embassy in London publicly accused UK authorities of searching an Aeroflot aircraft at Heathrow and sent a diplomatic note demanding an explanation.","date":"2018-03-31 00:00:00"},{"id":"7c66dd47-55d8-4d79-b029-18c78b008ccd","text":"Ukrainian government creates Ministry of Information Policy (established 2 December 2014)","date":"2014-12-02 00:00:00"},{"id":"3daef752-184a-46a5-b49e-f5f3862e40e8","text":"NATO StratCom and academic reports documenting Russian information operations against Ukraine (2014\u20132016)","date":"2015-04-24 00:00:00"},{"id":"78ab6f1e-93c8-4b9d-a81e-c46d3f8a86b0","text":"UK government\u2019s March 14 expulsions of 23 Russian diplomats and strong public accusations against Russia over the Skripal poisoning.","date":"2018-03-14 00:00:00"},{"id":"46c4bbca-22a7-426e-b740-218b1943a208","text":"Porton Down (Defence Science and Technology Laboratory) public statements (early April) that its scientists identified the substance as a Novichok-type agent but said they had not verified the precise source of the agent.","date":"2018-04-03 00:00:00"},{"id":"f5a37044-43e2-48fe-9d3d-72dfb91550d8","text":"Civil service reform and new requirements for Ukrainian in public administration (law adopted Dec 2015, implemented 2016)","date":"2016-05-01 00:00:00"},{"id":"8acf3211-493a-42fb-86b7-ca69f528baf2","text":"Passage of Ukraine\'s \'Law on Education\' (which set Ukrainian as the primary language of instruction)","date":"2017-09-05 00:00:00"},{"id":"8aa39dc8-d60f-4378-93f2-4036d197cd07","text":"2015 \'decommunization\' laws and related campaigns to remove Soviet-era names and symbols","date":"2015-04-24 00:00:00"},{"id":"fb93dc07-736f-4e75-bc9e-feef9be33698","text":"Adoption and entry into force of the Kivalov\u2013Kolesnichenko \'regional languages\' law (widely debated and later contested)","date":"2012-08-10 00:00:00"},{"id":"e91cf261-b3d2-4dee-9fe5-9f289ce03b3c","text":"Radio Free Europe/Radio Liberty coverage of Oleksandr Hurov (May 2014) describing capture and alleged torture by pro\u2011Russian separatists (includes account of attempts to remove or mutilate markings).","date":"2014-05-24 00:00:00"},{"id":"148e0912-fcdd-487e-8009-0cb800636227","text":"Russian President Vladimir Putin publicly said Ukraine\'s counteroffensive had \'failed so far\', characterising Ukrainian losses as \'vast\'.","date":"2023-06-13 00:00:00"},{"id":"082ef11d-1ea9-487f-9952-17564fb9c4d5","text":"Rheinmetall had experienced a dramatic run-up in revenue, orders and share price since the 2022 invasion (company Q1/2023 reporting highlighted strong defence demand).","date":"2023-05-04 00:00:00"},{"id":"11203772-88f3-4d44-8521-49a5752d94b6","text":"Major international outlets reported the long\u2011awaited Ukrainian counteroffensive had begun in early June but initial progress looked limited and uncertain.","date":"2023-06-09 00:00:00"},{"id":"3af0d05e-647f-42af-a495-1c1b27f989b9","text":"Trilateral Contact Group and parties agreed a new ceasefire for eastern Ukraine effective 27 July 2020 (reported by Reuters/OSCE).","date":"2020-07-27 00:00:00"},{"id":"65f32e56-cec4-40c8-a0d4-a1b7f6d34a3f","text":"President Zelensky\'s endorsement/implementation of the \'Steinmeier Formula\' (October 2019) and related public statements about negotiating a settlement in Donbas.","date":"2019-10-24 00:00:00"},{"id":"d2ceb7c3-cbd1-4e64-b371-c92535e8b2a4","text":"Major prisoner exchange between Ukraine and Russia (reported 7 September 2019), widely covered as confidence-building step.","date":"2019-09-07 00:00:00"},{"id":"467fbfa1-667e-47f0-b679-4ccde1bc649d","text":"Appointment of Dmytro Kuleba as Ukraine\'s Foreign Minister (4 March 2020) and his public rhetoric emphasising diplomacy and dialogue alongside deterrence.","date":"2020-03-04 00:00:00"},{"id":"a8cdddc8-da0e-4ddb-bfb4-206b7861ec25","text":"Russia\'s 2014 agricultural import ban hit French farmers (loss of export markets), creating domestic political sensitivity to the cost of sanctions.","date":"2014-08-24 00:00:00"},{"id":"5621db93-38d4-44e3-b9ac-662f17d5b014","text":"Earlier Hollande statements (2015) publicly floated lifting sanctions if progress were made on Ukraine, establishing a precedent for claims he favored easing sanctions.","date":"2015-05-01 00:00:00"},{"id":"e1d13f5a-15e7-412e-ad2d-a9a7f7ee5cdc","text":"Publication and mailing of the \'European Climate Declaration\' / World Climate Declaration (organised by Guus Berkhout / CLINTEL) to the UN asserting \'There is no climate emergency\'.","date":"2019-09-23 00:00:00"},{"id":"dd0ea02a-5156-4ea0-9cf4-df3bf324ed09","text":"Greta Thunberg\'s high-profile speech to the U.N. Climate Action Summit in New York (widely covered and polarising).","date":"2019-09-23 00:00:00"},{"id":"3f36f821-5acd-4e03-8925-56a32a0d41df","text":"Global climate strikes and mass protests in the week of 20\u201327 September 2019 (Global Week for Future).","date":"2019-09-20 00:00:00"},{"id":"1deccd41-6b22-439d-b04a-607cec06cd4e","text":"U.S. Department of Defense Biological Threat Reduction Program (BTRP) provided funding, equipment upgrades and technical assistance to Ukrainian public\u2011health and research laboratories (BTRP cooperation with Ukraine began in 2005).","date":"2005-04-24 00:00:00"},{"id":"78f8bb60-19e7-45ae-b9a8-95d140afccb6","text":"Cooperative Biological Engagement Program project in Ukraine with defined implementation period (example: project implementation period listed as 06.03.2015\u201331.12.2020 on Ukrainian project pages).","date":"2015-03-06 00:00:00"},{"id":"457968e0-54e3-4b90-a69d-cd014e44b19f","text":"U.S. government announced Operation Warp Speed to accelerate COVID\u201119 vaccine development and manufacturing, with involvement from HHS, DOD and other agencies.","date":"2020-05-15 00:00:00"},{"id":"953e8dee-c92d-46d0-b41a-2675f2d8c7d3","text":"Novavax announced it was awarded a Department of Defense contract related to COVID\u201119 vaccine development.","date":"2020-06-04 00:00:00"},{"id":"765cde6f-4513-4c96-bc73-5efe2d1dcec2","text":"U.S. government apology (2010) for the Guatemala syphilis experiments, in which U.S.-linked researchers deliberately infected subjects decades earlier.","date":"2010-10-01 00:00:00"},{"id":"550a0233-ec91-4574-af34-084f9fb02324","text":"CDC updates guidance to discourage a test-based strategy for ending isolation, noting people can remain PCR-positive without being infectious","date":"2020-07-17 00:00:00"},{"id":"39701dce-c174-4858-a47c-7c287e0d6b46","text":"Published study (Bullard et al.) showing SARS-CoV-2 PCR cycle threshold (Ct) correlates with likelihood of culturing live virus (higher Ct \u2192 less likely infectious)","date":"2020-05-22 00:00:00"},{"id":"c7ddc375-ec76-4ba7-879a-f3acc3bcb9c6","text":"UNAIDS/Ukraine country report documents a large, growing HIV epidemic in Ukraine (estimated ~238,000 people living with HIV in 2016).","date":"2017-04-24 00:00:00"},{"id":"1edfed6a-a6f6-4d26-8e86-27912e5cb734","text":"Mass internal displacement after the 2014 conflict: hundreds of thousands of internally displaced persons (IDPs) from Donbas by 2015, disrupting continuity of care.","date":"2015-04-24 00:00:00"},{"id":"b3d4bccf-e6b3-444a-a446-db2eefd130aa","text":"WHO interim guidance recommending postponement of mass vaccination campaigns and adaptation/prioritization of immunization services during COVID-19","date":"2020-03-26 00:00:00"},{"id":"fc116fa8-1dc3-4222-a5c8-b35092c65b7d","text":"WHO and UNICEF joint press release warning of an alarming decline in routine childhood vaccinations worldwide","date":"2020-07-15 00:00:00"},{"id":"6d09cef3-542a-4122-bce5-4ed42b20a35c","text":"Ukraine erected flow-control measures/temporary dam in Kherson/Kalanchak to cut canal deliveries to occupied Crimea (2014)","date":"None"},{"id":"1171ed03-4a86-4377-9b2a-9890e9c06a3b","text":"Academic/technical assessments documenting socio\u2011economic and environmental impacts of Crimea\'s water shortages (peer\u2011reviewed/technical publications 2016)","date":"2016-04-24 00:00:00"},{"id":"a1e88781-f2b8-4925-a71d-1354138335e6","text":"Municipal regulations (Plan Especial del Centro Hist\xf3rico and local ordinances) prohibit unauthorised banners/flags on protected facades; the town hall cited these rules when ordering removal.","date":"2016-03-24 00:00:00"},{"id":"16eb1f91-9e75-48d9-8e6b-ba6883f107a2","text":"Clinical/dental literature and reviews (including proposals to use povidone\u2011iodine nasal/mouth preparations) circulated in spring 2020 reporting in\u2011vitro virucidal activity of certain antiseptic oral rinses against SARS\u2011CoV\u20112.","date":"2020-05-24 00:00:00"},{"id":"45192b72-d6e3-4aa8-adad-2ce5c94f6fed","text":"Regulatory and market environment: reports of unproven oral-spray and supplement COVID claims and subsequent enforcement/crackdowns (e.g., China crackdown on adverts making antiviral claims for oral sprays) in spring 2020.","date":"2020-04-07 00:00:00"},{"id":"35e7b213-800a-404a-91b4-d3bfc3e7d69e","text":"September 2021 reports that foreign/stainless\u2011steel particles were found in some Moderna vaccine vials in Japan and several lots were suspended.","date":"2021-09-01 00:00:00"},{"id":"37625bdb-3faf-444d-96c3-044a6680cd29","text":"Russian formal ban on imports of Ukrainian food products (announcement reported November 2015)","date":"2015-11-24 00:00:00"},{"id":"f15e48c3-97ff-4340-8055-fff4bf8c0515","text":"Ukrainian activists impose a land and transport blockade of supplies into Crimea","date":"2015-09-24 00:00:00"},{"id":"0ec3a1ba-22bc-42c9-8014-c02a2d6366c2","text":"IPCC AR5 (WG1) chapter on oceans noting that the oceans have absorbed the vast majority of excess heat from global warming","date":"2013-09-24 00:00:00"},{"id":"2112f65b-e3a2-4663-82fc-47099fd11849","text":"UKHSA update on scarlet fever and invasive Group A streptococcus noting increased cases in children","date":"2022-12-02 00:00:00"},{"id":"25ae9714-f988-4579-a283-17d3fac67c24","text":"Event 201 pandemic tabletop exercise (Johns Hopkins / World Economic Forum / Bill & Melinda Gates Foundation)","date":"2019-10-18 00:00:00"},{"id":"89f7be9b-a071-4364-9aed-c2503bc4bde2","text":"FDA and public\u2011health warnings against internal use of high\u2011strength hydrogen peroxide (35% \'food grade\') and warning letters to vendors.","date":"2006-07-24 00:00:00"},{"id":"c5eb6bc0-d315-4389-b537-4ff24b37b0ba","text":"Russian President Vladimir Putin asks the Federation Council to authorize the use of Russian armed forces in Ukraine; authorization granted","date":"2014-03-01 00:00:00"},{"id":"5d180492-af7a-41a3-8010-6039b9a42ac1","text":"Ousted Ukrainian president Viktor Yanukovych reportedly sends a letter requesting Russian assistance","date":"2014-03-01 00:00:00"},{"id":"129dbf83-ac42-498b-8af3-31b2930d0936","text":"ICJ advisory opinion on Kosovo\'s declaration of independence (found not to violate international law)","date":"2010-07-22 00:00:00"},{"id":"b899e414-1d1a-4e3f-9ad7-92dcb8567106","text":"Armed men seize the Crimean parliament building and raise the Russian flag","date":"2014-02-27 00:00:00"},{"id":"da8e4118-0138-42d0-9996-8b05153569cb","text":"EU representatives agree (Council conclusions of 20 July 2015) to resettle 22,504 persons in need of international protection from outside the EU (including Middle East, North Africa and Horn of Africa)","date":"2015-07-20 00:00:00"},{"id":"bd231caf-cb0b-40ad-80ec-357ede8ccc9c","text":"European Commission proposes mandatory relocation of 40,000 asylum-seekers from Italy and Greece","date":"2015-05-22 00:00:00"},{"id":"0ac65c20-e64f-4572-b4fa-95038cc94c87","text":"Strong public opposition from several member states (Visegrad group and others) to EU relocation/quota proposals in mid-2015","date":"2015-07-24 00:00:00"},{"id":"eb029676-869a-4779-a1c4-e6a9ef61658a","text":"Hungary orders closure of its border with Serbia and begins building a fence to stop migrants","date":"2015-06-17 00:00:00"},{"id":"1afe2096-97db-47e1-8782-51875848059a","text":"April 2015 Mediterranean shipwreck off Libya killing hundreds of migrants","date":"2015-04-18 00:00:00"},{"id":"caccea01-8968-4258-9488-740a1c367d1b","text":"Ukraine\'s Verkhovna Rada formally recognized the 1944 deportation of Crimean Tatars as genocide (resolution passed in November 2015).","date":"2015-11-12 00:00:00"},{"id":"e3500067-58e5-401e-be62-6ac02afe5f68","text":"Ukrainian law and parliamentary debate on the legal regime for \'temporarily occupied territories\' (Law No.1207\u2011VII and related 2014 legislative measures criminalizing collaboration with occupying authorities).","date":"2014-04-24 00:00:00"},{"id":"d124a1dd-2d17-4a0e-9b3f-3690566aae21","text":"Russia \'passportised\' Crimean residents after the 2014 annexation (widespread issuance of Russian passports), documented by human rights reporting in 2014.","date":"None"},{"id":"3dbf5840-202a-45c5-a392-6da5fc3384f4","text":"Andriy Senchenko made televised remarks on Shuster Live calling for \'tough\' measures toward people who moved to Crimea after Feb 20, 2014 (interpreted as calling for rapid removal).","date":"None"},{"id":"fe00d12a-4e33-4d24-8260-ce000bdafd3b","text":"Parliamentary Assembly of the Council of Europe (PACE) adopted a resolution (drafted by Michele Nicoletti) that set out mechanisms for reconciling participation rules between PACE and the Committee of Ministers and which media reported could pave the way to restore Russian delegation rights.","date":"2017-10-12 00:00:00"},{"id":"8c29246c-b612-4965-992f-1aae016849cb","text":"Pandora Papers and subsequent reporting (Oct 2021) documenting links between Zelensky\'s circle and offshore companies / expensive property purchases","date":"2021-10-04 00:00:00"},{"id":"90183469-2373-4c0a-9db7-66fda3723f82","text":"Earlier 2025 media coverage of Bill Cosby listing a second Manhattan townhouse for sale (about $7 million) amid foreclosure/legal troubles","date":"2025-04-22 00:00:00"},{"id":"76ed06f1-f37a-465b-ae48-e100e8377a44","text":"Poland says it cannot accept migrants under EU relocation quotas after the Paris attacks","date":"2015-11-14 00:00:00"},{"id":"dfcb69d0-f432-473d-a4bd-c9537e190c44","text":"Financial Times analysis highlighting Poland\'s low intake of Syrian refugees and rising anti-immigrant rhetoric","date":"2016-09-15 00:00:00"},{"id":"2c6b27af-38c8-4b38-b040-40f8bb33132c","text":"UK government technical note on the impact of false positives and false negatives in the RT-PCR testing programme (operational specificity discussion)","date":"2020-06-03 00:00:00"},{"id":"1a89a0c4-9240-40dc-97e5-5eb183d35328","text":"Publication of study linking RT-PCR cycle threshold (Ct) values to culturable virus (Singanayagam et al., correlating Ct and infectiousness)","date":"2020-08-13 00:00:00"},{"id":"5e7bee19-fa7d-4e24-b0f3-a535a59d61c9","text":"Publication and media amplification of the Great Barrington Declaration advocating \'focused protection\' (early October 2020)","date":"2020-10-04 00:00:00"},{"id":"988a32d5-7f90-44fe-ad3f-eae1713fb46f","text":"Swiss Federal Office of Public Health (BAG) / Swissmedic leaflet on COVID-19 testing published (Merkblatt, referenced wording on PCR/NAT)","date":"2020-08-31 00:00:00"},{"id":"2bd4165c-309c-4266-baea-489fc2660c0f","text":"High-profile political minimization and comparisons of COVID-19 to seasonal influenza (examples in March 2020, e.g., statements by then-US President Donald Trump)","date":"2020-03-09 00:00:00"},{"id":"fa789686-f4ff-4769-afea-b7a090848d27","text":"US security-assistance packages to Ukraine (e.g., $125M March 2021)","date":"2021-03-01 00:00:00"},{"id":"17959a76-3641-4e0b-abd2-b380896e1234","text":"Joint NATO/US public warnings calling on Russia to de-escalate (press points April 2021)","date":"2021-04-14 00:00:00"},{"id":"f2628ee0-eded-4b4c-b5c6-6967892ae038","text":"DEFENDER-Europe 21 large US/NATO exercises in Europe","date":"2021-03-15 00:00:00"},{"id":"214d1e31-24a0-4a9b-9959-ee0e01ed62fa","text":"NATO Brussels Summit communique reaffirming support for Ukraine","date":"2021-06-14 00:00:00"},{"id":"c2a74fe2-3c8d-4007-9006-5202a81e3db2","text":"Publication (September 7, 2022) of experiments showing ivermectin (alone or combined) enhanced paclitaxel efficacy in chemoresistant high\u2011grade serous carcinoma cell models (Nunes et al., Cancers).","date":"2022-09-07 00:00:00"},{"id":"8322049d-460b-4c14-89aa-784164e6301f","text":"U.S. Department of Health and Human Services ordered millions of doses of the JYNNEOS monkeypox vaccine for response and Strategic National Stockpile delivery.","date":"2022-06-28 00:00:00"},{"id":"37438bb9-ad89-4693-96ac-1f3e4de9e11c","text":"WHO declared the global monkeypox outbreak a Public Health Emergency of International Concern (PHEIC).","date":"2022-07-23 00:00:00"},{"id":"0ab2fa20-d314-4b6e-8ef9-3d0b3754a0a3","text":"WHO/FAO/WOAH and other agencies published repeated updates and risk assessments about avian influenza (H5Nx) outbreaks and zoonotic risk during 2023\u20132024.","date":"2024-03-30 00:00:00"},{"id":"df133827-888a-44b4-98ba-0bd4267a4b64","text":"European Centre for Disease Prevention and Control (ECDC) reported an increased circulation/rebound of human parvovirus B19 in multiple EU/EEA countries (public advisory/report).","date":"2024-06-05 00:00:00"},{"id":"8db5e96c-8ab9-49e2-be45-cb84446f42b4","text":"Rapid formation and public visibility of volunteer combat units (e.g., the Azov Battalion) in 2014 that appeared at checkpoints, rallies and front-line actions.","date":"2014-05-24 00:00:00"},{"id":"278fdcf9-885a-4a38-b620-4449c53c1fac","text":"Euromaidan protesters occupied Kyiv\'s Independence Square (Maidan) and established barricades, driving out police during the February 2014 protests.","date":"2014-02-24 00:00:00"},{"id":"9414863b-928c-4d55-a823-f666352f7066","text":"Pro\u2011Russian separatists seized Sloviansk and other towns in Donetsk oblast in April 2014, setting up armed checkpoints and exercising local control for months.","date":"None"},{"id":"73acaeeb-a18a-4e1f-aa58-d7ca76180f1e","text":"Ukraine blocked the North Crimean Canal in 2014 (built a dam/flow-control to stop water to Crimea)","date":"2014-04-24 00:00:00"},{"id":"20688556-fcd5-43d5-8b89-0603da011cff","text":"UN and humanitarian agencies publicly reported reaching and assisting civilians in Sievierodonetsk earlier in 2022 (e.g., UN humanitarian convoy reached Sievierodonetsk in April 2022).","date":"2022-04-05 00:00:00"},{"id":"9faacbf5-8470-4ede-8cfc-18027e35aca1","text":"United Nations had ceased operations in Siverodonetsk by the end of February 2022 (UN office vacated).","date":"2022-02-24 00:00:00"},{"id":"2e4afe6c-377c-41fb-a709-0aa17fe96c47","text":"Intense Russian shelling and urban combat in Sievierodonetsk in June 2022 produced extensive destruction of civilian and administrative buildings (including fires at the Azot plant).","date":"2022-06-25 00:00:00"},{"id":"b75ca8d7-d78d-4731-bbc5-827e3e8c284d","text":"Police in Abkhazia (de facto region) seize hundreds of crypto\u2011mining rigs amid power shortages (reported June 2023)","date":"2023-06-24 00:00:00"},{"id":"4c8fe5c9-7702-4b7f-89d7-34a3387550bd","text":"Europol / Ukrainian police arrest cryptojacker accused of mining ~\u20AC1.8M (cloud/cryptojacking) in Mykolaiv","date":"2024-01-24 00:00:00"},{"id":"4a85235b-d804-415b-ad8d-b80286344dda","text":"West Midlands Police (UK) uncover bitcoin mining operation stealing electricity at an industrial site","date":"2021-05-24 00:00:00"},{"id":"2f31b597-a1c6-4a14-bdb1-9926031bd733","text":"Global Climate Strikes led by youth (September 20\u201327, 2019)","date":"2019-09-20 00:00:00"},{"id":"876a0e31-fed0-492e-9930-125af3ca6ca0","text":"IPCC Special Report on Global Warming of 1.5\xb0C released","date":"2018-10-08 00:00:00"},{"id":"e63ed35c-d2ce-4cea-b973-b0de720980a4","text":"Publication of Nerem et al. (PNAS) reporting statistically significant acceleration in global mean sea level from satellite altimetry (1993\u20132016)","date":"2018-12-11 00:00:00"},{"id":"b8455709-3440-4c63-a8b8-4fde488d3279","text":"Release of the IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) summarizing recent acceleration and future sea-level projections","date":"2019-09-25 00:00:00"},{"id":"c8e1c6d5-165b-4699-9c2a-644ffc9bc590","text":"Publication of Houston & Dean (2011) analysis arguing little or no acceleration in U.S. tide-gauge records","date":"2011-04-24 00:00:00"},{"id":"5df08847-a67c-4353-9d9a-ac186bb7a0ac","text":"Peer\u2011reviewed 2009 review \'Omega\u20116 (n\u20116) and omega\u20113 (n\u20113) fatty acids in tilapia and human health\' (International Journal of Food Sciences and Nutrition)","date":"2009-09-21 00:00:00"},{"id":"76eb3d3a-2128-4f48-b28f-2e31e901d9e5","text":"2013 systematic review \'The omega\u20116/omega\u20113 ratio and dementia or cognitive decline\' (Loef & Walach) summarizing evidence linking n\u20116/n\u20113 balance to dementia risk","date":"2013-04-24 00:00:00"},{"id":"3b3306c5-39b2-428e-a46c-b4027bb3f7b2","text":"Japan finds stainless-steel/foreign particles in multiple Moderna vaccine vials leading to recalls (September 2021)","date":"2021-09-01 00:00:00"},{"id":"732ffe1f-e2ef-42d6-ace5-30f2f6397c5a","text":"Widespread pediatric RSV and other respiratory virus surges after COVID-19 restrictions lifted (late 2022)","date":"2022-10-24 00:00:00"},{"id":"584a07dd-348b-4a9c-bcef-72d38726e3f2","text":"Noted rise in invasive Group A Streptococcus (iGAS) and scarlet fever among children in late 2022\u2013early 2023","date":"None"},{"id":"a15ffdcd-dd35-4e0b-a278-d39f0b704449","text":"Publication showing systemic mRNA COVID-19 vaccines induce variable or limited mucosal (IgA) responses","date":"2022-04-25 00:00:00"},{"id":"52aeea6c-dbeb-49dc-b01b-d54c7468c757","text":"NATO and Western institutions publicly warn about \'weaponisation of information\' by Russia","date":"2015-01-24 00:00:00"},{"id":"43e6cdbe-7110-411f-9599-5f5644f1793c","text":"Reuters reported the U.S. was \'poised\' to drop opposition and start a process that could eventually send Abrams tanks to Ukraine (policy debate/turnaround coverage).","date":"2023-01-24 00:00:00"},{"id":"ab6e267d-4f9a-4e79-b0a0-5445c91f52a2","text":"Germany announced it would supply Leopard 2 tanks and permit partner countries to re-export theirs to Ukraine.","date":"2023-01-25 00:00:00"},{"id":"62f49896-fe28-4e51-8248-9a0dbb2ec952","text":"Media coverage warned that even if Abrams were provided, they were \'not expected in Ukraine for months\' because of training, logistics and suitability issues.","date":"2023-01-26 00:00:00"},{"id":"db5cdca6-47c0-4025-afb9-5cf4330d18fa","text":"Widespread attention to provisional NCHS/CDC all\u2011cause and excess death data for 2021\u20132022 (public NCHS/CDC provisional death tables and dashboards).","date":"None"},{"id":"e813eef7-8b07-43c9-9b52-89016dc23bfa","text":"CDC/FDA communications and studies acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID\u201119 vaccination in adolescents and young adults (public reporting in 2021).","date":"None"},{"id":"ed606e7d-2737-465a-8cb1-534e7a2a2bab","text":"WHO/air\u2011quality data (2016) flagged Ukraine among countries with very high air\u2011pollution\u2011related mortality","date":"2016-09-27 00:00:00"},{"id":"908e3499-9973-409e-9771-39750bd71773","text":"Investigations and reporting on illegal/low\u2011quality coal supply in Ukraine (Donbas) documented dirty, unregulated coal entering markets","date":"2014-05-26 00:00:00"},{"id":"ee66cc75-520a-448c-9cb3-5329fa946d27","text":"Kyiv officials describe mid\u2011January haze as a \'meteorological haze\' while experts point to coal\u2011fired heating plants","date":"2017-01-18 00:00:00"},{"id":"0877ed46-c1ba-45a3-ba4b-a8e0a6439edf","text":"Central Geophysical Observatory registered elevated formaldehyde, carbon monoxide and nitrogen dioxide levels in mid\u2011January 2017","date":"2017-01-13 00:00:00"},{"id":"6659a365-5a97-4293-a252-2be5c298330c","text":"State services report monitoring found \'no exceedances\' despite public reports of burning smell and breathing problems","date":"2017-01-17 00:00:00"},{"id":"7efe0478-8a2a-4d11-9c5f-52020e70d538","text":"European Parliament approves visa\u2011free travel for Ukrainians (vote)","date":"2017-04-06 00:00:00"},{"id":"4c51a416-fe78-476b-805d-de1b3b9c0517","text":"EU adopts a revised Visa Suspension Mechanism as a precondition to liberalisation","date":"2017-02-27 00:00:00"},{"id":"52f42ec6-780e-4efe-92d7-4226178815ae","text":"Documented large industrial wastewater discharges into the Sea of Azov (Azovstal and other metallurgical plants)","date":"2014-12-01 00:00:00"},{"id":"92dc8e00-b4c6-4a43-b561-1940fec3c8ef","text":"Scientific and media publications documenting rising pollution and ecological stress in the Sea of Azov (numerical/satellite assessments, 2017)","date":"2017-09-24 00:00:00"},{"id":"a955132e-e3fb-42db-a430-9bf42ff99559","text":"Isolation of toxigenic Vibrio cholerae O1 (Ogawa) from seawater near Taganrog after the 2011 outbreak","date":"None"},{"id":"96332f73-f924-443d-ace7-40cb4fa6d25f","text":"Amnesty International and other human rights organisations publicly highlighted mass graves and documented allegations of torture in recaptured Kharkiv oblast territory","date":"2022-09-16 00:00:00"},{"id":"52d4258b-d46d-4011-b482-c6f84ea88c41","text":"Passage of Ukraine\'s decommunization laws (April 2015) increasing attention to removal/renaming of monuments","date":"2015-04-09 00:00:00"},{"id":"b8fef55e-cb17-4144-b36d-efe1a1412aa7","text":"Heightened media coverage and public demonstrations around Stepan Bandera (e.g., anniversary marches) in early 2015","date":"2015-01-01 00:00:00"},{"id":"ac10fe98-7a59-438d-8e5a-e5d8ff108249","text":"IUCN Polar Bear Specialist Group (PBSG) population estimates and status reporting (Regehr et al. / PBSG updates) releasing updated global population ranges (~22,000\u201331,000)","date":"2016-06-24 00:00:00"},{"id":"1f99c609-d675-4aa2-8365-41180ff2b10f","text":"General Medical Council (GMC) publishes report on doctors who died while under investigation (report published March 2023; covers deaths through Dec 2022)","date":"2023-03-24 00:00:00"},{"id":"f84e3f68-1f12-4277-a0ad-1a2855816e89","text":"FDA/FTC public enforcement and warning letters against companies and individuals selling fraudulent COVID\u201119 cures and unapproved therapies (series of letters and press releases, 2020\u20132022)","date":"2020-04-28 00:00:00"},{"id":"2820709e-5d6b-4509-94a5-78cd96541477","text":"NASA/NSIDC reporting that Antarctic sea ice reached record high extent in 2014","date":"2014-09-24 00:00:00"},{"id":"2c7e26c3-b9b3-45c9-af2b-3b4ed695a329","text":"IPCC Special Report on the Ocean and Cryosphere (SROCC) documents complex impacts of ice melt on ocean circulation and regional climate","date":"2019-09-24 00:00:00"},{"id":"6f517cb4-a5d9-48b6-89f4-774edcbd04fc","text":"Nature paper reports fingerprint of a weakening Atlantic Meridional Overturning Circulation (AMOC)","date":"2018-04-24 00:00:00"},{"id":"90075709-94de-4eff-a784-7426de978ac8","text":"IAEA Director General Rafael Grossi publicly called for an urgent IAEA mission to the occupied Zaporizhzhia plant and warned about militarisation (June 2022).","date":"2022-06-01 00:00:00"},{"id":"2f96b357-c41a-445d-9c72-3c14267b0f04","text":"Satellite imagery and reporting in 2022 showed military vehicles and damage close to key Zaporizhzhia reactors and infrastructure.","date":"2022-08-24 00:00:00"},{"id":"52e92dba-398a-4cc5-b309-93a582942749","text":"Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the opening days of the 2022 invasion.","date":"2022-03-04 00:00:00"},{"id":"3a6f2a92-5754-452f-9004-2098c7d76d66","text":"Shelling and a fire at a training facility inside the Zaporizhzhia site during the March 4, 2022 assault.","date":"2022-03-04 00:00:00"},{"id":"443755da-213e-4f47-98c3-d9454d1eda94","text":"IAEA/Ukraine national reporting on ageing Soviet-era reactors and safety challenges (2005)","date":"2005-04-24 00:00:00"},{"id":"d86964a8-b40c-4f2d-92ed-481299aa8e92","text":"Verkhovna Rada adopts Law No. 6327 on state financial guarantees for medical services (healthcare reform)","date":"2017-10-19 00:00:00"},{"id":"992eb91d-44b1-4560-b199-36dfde7ead73","text":"New national classification of professions (reclassification of medical job titles) took effect on November 1, 2017","date":"2017-11-01 00:00:00"},{"id":"1a966d51-7954-47de-9b75-a0b764a89815","text":"U.S. FDA issues Emergency Use Authorization for Janssen (Johnson & Johnson) COVID-19 vaccine and publishes EUA fact sheets that reference the PER.C6 cell line used in production/testing.","date":"2021-02-27 00:00:00"},{"id":"4f3cec2d-39b0-4ba1-be54-1f87fb414f33","text":"Surveillance data showing higher-than-expected HIV diagnoses among people born in Ukraine reported by EU/EEA countries after the 2022 refugee movements (peer-reviewed / public health surveillance summary)","date":"2023-04-24 00:00:00"},{"id":"273108f2-182b-42a7-952a-9d33cd5b44da","text":"Russia had banned imports of Roshen products and Roshen faced factory/market disputes in Russia (2013\u20132014), including Roshen activity tied to Lipetsk","date":"2013-07-29 00:00:00"},{"id":"91b914d2-9ac6-48f9-9b90-2415008e69fe","text":"Poroshenko\u2019s ownership of Roshen and his 2014 pledge to sell/transfer the company after his election kept Roshen highly politicized and newsworthy","date":"None"},{"id":"c3b4ae9e-b56b-4724-80ab-d5e8fd58f441","text":"Pentagon Inspector General report that about $1 billion in U.S. weapons sent to Ukraine were not properly tracked.","date":"2024-01-11 00:00:00"},{"id":"0ec31977-3023-4316-89f2-6cd4539a5b72","text":"National Anti\u2011Corruption Bureau of Ukraine (NABU) announces a large-scale probe into alleged corruption in the energy sector.","date":"2025-11-11 00:00:00"},{"id":"3c3809b1-e474-4a0f-9fe2-ad9388296f1a","text":"Sean Penn\'s repeated, high\u2011profile visits to Ukraine (documented reporting on his November 2021 and subsequent trips).","date":"None"},{"id":"04179c15-22d3-4587-a3c0-a8d9de3bc862","text":"Ukraine uncovers embezzlement of nearly $40 million intended to buy mortar shells; arrests and charges announced.","date":"2024-01-27 00:00:00"},{"id":"0556168b-ddf4-403b-855e-fa07d47df59b","text":"Human Rights Watch reports intensifying prosecutions in Crimea accusing Crimean Tatars and others of \'terrorism\' or \'sabotage\' (2016\u20132017)","date":"2017-11-14 00:00:00"},{"id":"1c531e95-8a53-4fa7-9cf6-f56ecc7fc194","text":"FSB announces detention of a Ukrainian citizen in occupied Crimea on espionage/sabotage-related charges (Simferopol, February 2018)","date":"2018-02-11 00:00:00"},{"id":"2d287b25-96e4-4d14-b647-e585113cb393","text":"Large explosions at the Kalynivka ammunition depot in central Ukraine, causing evacuations and widespread coverage","date":"2017-09-27 00:00:00"},{"id":"214d4af3-d4fe-4edf-9b28-d410c6d5c5fa","text":"Exercise Sea Breeze 2018 \u2014 multinational naval exercises in the Black Sea co-hosted by the United States and Ukraine (July 2018)","date":"2018-07-17 00:00:00"},{"id":"ea0de8a9-d55b-4475-a20a-bb160d082ced","text":"Israeli reports of rising Delta-variant cases with a substantial share among vaccinated people","date":"2021-06-23 00:00:00"},{"id":"5abca650-7537-4d87-ba3b-ea71a51d8966","text":"CDC updates guidance for fully vaccinated people stating they can often refrain from testing and quarantine (interim guidance released)","date":"2021-05-13 00:00:00"},{"id":"d7f5b683-1482-4b26-8fcc-a98be03f2ee9","text":"Public Health England (PHE) vaccine surveillance reports with age-stratified case tables (week 26 / June 2021)","date":"2021-06-27 00:00:00"},{"id":"3b2a0ea9-b56f-4243-bafd-25eb3dfea4bf","text":"Provincetown, Massachusetts July 2021 COVID-19 outbreak where many positive cases were fully vaccinated","date":"2021-07-19 00:00:00"},{"id":"4b72e737-f1b9-470e-ba9a-2b4d5d50e353","text":"Long\u2011running pro\u2011Kremlin narrative that \'Ukraine\u2019s armed forces shell Donbas civilians\' (disinformation theme dating from 2014) was active in March 2022.","date":"None"},{"id":"17a480e6-1bf4-4c05-9ca4-8a1c574f0fc4","text":"Venice Commission (Council of Europe) issues an opinion urging changes to Ukraine\'s Education Law over minority-language provisions","date":"2017-12-08 00:00:00"},{"id":"39f0c8d6-5221-4a5e-bf65-ce98b09f7bd0","text":"Contextual sensitivity: Bulgaria\'s Liberation Day (March 3) commemorates liberation from Ottoman rule (historically 1878).","date":"None"},{"id":"9d220ba5-be35-4626-91c4-851a735df936","text":"President Erdo\u011Fan was on an official African tour (in Guinea) on March 3, 2016.","date":"2016-03-03 00:00:00"},{"id":"d27e4f87-9af4-40ef-9766-ee18cb24a24f","text":"WMO Greenhouse Gas Bulletin No. 21 reports a record-breaking annual CO2 increase and highlights contributions from continued human emissions plus an upsurge from wildfires and ecosystem feedbacks.","date":"2024-10-24 00:00:00"},{"id":"f54f7af1-1b71-478c-91f6-ce3375ebdda5","text":"Hunga Tonga\u2013Hunga Ha\u02BBapai submarine volcanic eruption (15 January 2022) injected exceptional amounts of water vapor and volcanic gases into the atmosphere and received intense global media coverage.","date":"2022-01-15 00:00:00"},{"id":"3d9743ea-263d-4b21-91a1-bdc5bbce2499","text":"Transport & Environment / press coverage (October 2017) of lifecycle studies reporting EVs emit significantly less GHG over their lifetime than diesel","date":"2017-10-27 00:00:00"},{"id":"a8b64150-84b7-4ad7-bdb1-c3756003b90a","text":"European Parliament / EU briefings and research in 2015 documented coordinated Russian disinformation campaigns targeting Ukraine and portraying Ukrainian authorities as corrupt or incompetent.","date":"2015-04-24 00:00:00"},{"id":"48ec065a-a22d-4b14-98ef-d1e57418b549","text":"Cabinet of Ministers Resolution No. 405 amended rules on \'military-transport duty\' allowing requisitioning of vehicles for army needs","date":"2015-06-17 00:00:00"},{"id":"58762de6-ddb0-4b06-9187-97497eb3ccc9","text":"High-profile seizure/attention to Viktor Yanukovych\'s car collection after his ouster in 2014","date":"2014-06-14 00:00:00"},{"id":"84d683de-68e5-4a20-8afc-f90d78ad11fe","text":"March 2016 \u2014 Large, well-documented mass coral bleaching across the Great Barrier Reef (AIMS/GBRMPA surveys)","date":"2016-03-24 00:00:00"},{"id":"057f2b8b-55d2-46a9-8ee2-57021db73494","text":"2019 \u2014 \'State of the Climate 2019\' (WMO/BoM/CSIRO) and related national summaries documenting global and regional ocean heating and record ocean heat content","date":"2019-04-24 00:00:00"},{"id":"9dfcd6c4-1585-4ebf-90b9-c35a0fa7b77c","text":"Lisbon Court of Appeal ruling (Portugal) referenced PCR test reliability in a quarantine case","date":"2020-11-24 00:00:00"},{"id":"7429b626-2a70-48db-931e-9e7f6919e3b1","text":"Early peer\u2011reviewed studies showing correlation between PCR cycle threshold (Ct) and viral culture/infectivity (e.g., Bullard et al.) published in 2020","date":"2020-05-24 00:00:00"},{"id":"6fea3a19-99f6-433e-b70b-f3608c3e60bb","text":"WHO information notice reminding labs to follow manufacturers\' instructions and consider Ct thresholds (WHO notice for IVD users)","date":"2021-01-24 00:00:00"},{"id":"d67b8388-c5ba-4ef3-9f99-518f8e6b9ec4","text":"CDC announced it would withdraw its EUA request for the original CDC-only RT\u2011PCR panel (laboratory notice, mid\u20112021)","date":"2021-07-24 00:00:00"},{"id":"6cf8907e-3799-472e-a142-6db5a32cf03d","text":"FDA paused enforcement of the in-person dispensing requirement during the COVID-19 pandemic enabling telemedicine and mail distribution","date":"2021-04-24 00:00:00"},{"id":"70355289-4e54-47cc-81ed-a7bb982902ee","text":"Government audit and historical regulatory reporting (GAO report) documenting FDA regulatory decisions on Mifeprex/mifepristone","date":"2018-03-24 00:00:00"},{"id":"21ef3182-d37f-4089-afa7-5293f6ec11a7","text":"Anti-abortion medical groups filed Alliance for Hippocratic Medicine v. FDA challenging FDA approval of mifepristone","date":"2022-11-18 00:00:00"},{"id":"6e5fec9c-b2f0-4e1b-852f-6806a7eef1f9","text":"Dobbs v. Jackson Women\'s Health Organization (Supreme Court decision overturning Roe v. Wade) intensified public debate over abortion","date":"2022-06-24 00:00:00"},{"id":"5f591bb2-1596-4e97-85e2-46ecbfcce715","text":"Regional NGOs and refugee policy briefs highlight ambiguities about the end or transition of Temporary Protection","date":"2022-04-25 00:00:00"},{"id":"29e1437a-f465-4e3c-87ba-8891e0ad54be","text":"Ukraine imposes martial law and restricts men aged 18\u201360 from leaving the country","date":"2022-02-24 00:00:00"},{"id":"81040900-a0c6-4475-991b-52fa81fe003d","text":"Ukraine imposes moratorium / signals risk of default on Russian\u2011held debt (December 2015)","date":"2015-12-18 00:00:00"},{"id":"4205ac4d-65c7-4014-8d2f-8cd32be87732","text":"Ukraine\'s parliament approves the 2016 budget tied to IMF\u2011agreed deficit targets (conditioning release of IMF tranche)","date":"2016-02-05 00:00:00"},{"id":"8736b397-0828-456b-b1a9-faca5adf593e","text":"World Bank forecasts a sharp GDP contraction for Ukraine in 2015 (projected ~12% decline)","date":"2015-10-05 00:00:00"},{"id":"e838e359-ee60-4cec-8c08-6dd107ae93cd","text":"The 2014 burning of the Odesa Trade Unions House (widely photographed and reported).","date":"2014-05-02 00:00:00"},{"id":"8e52fce7-6f34-4f80-8b7b-48f2857c305e","text":"U.S. Secretary of State Antony Blinken visited Veterano Pizza in Kyiv and was photographed having lunch with Ukrainian officials.","date":"2024-05-14 00:00:00"},{"id":"8386101e-8dd9-40ee-915f-daeafeaccb37","text":"U.S. FDA Emergency Use Authorization for the Pfizer\u2013BioNTech COVID-19 vaccine (vaccine moved from trials to public use under EUA in December 2020)","date":"2020-12-11 00:00:00"},{"id":"6080b396-b17c-4aa2-81b9-ba25672408a2","text":"Publication of preclinical animal study results showing BNT162b vaccine candidates protected rhesus macaques (Nature article)","date":"2021-02-01 00:00:00"},{"id":"4c386586-e3e9-4a25-9801-0eafde56c525","text":"EU Council / Commission adopted visa-free travel for Georgia (short stays up to 90 days)","date":"2017-02-27 00:00:00"},{"id":"aac25fda-3c07-4c31-aa1f-fd0594820879","text":"EU/agency reporting and media coverage noted increases in asylum/irregular-migration claims from Georgian nationals after visa liberalisation","date":"2017-04-24 00:00:00"},{"id":"e5d7503b-2f1f-4323-99c4-038ff15d4cce","text":"EU revised and strengthened the Visa Suspension (waiver) Mechanism","date":"2017-02-27 00:00:00"},{"id":"1a0a0196-5909-4768-b7fd-e4131e2d6c8e","text":"Reports of Chechen fighters present in Donbas fighting alongside pro\u2011Russian separatists","date":"2014-10-08 00:00:00"},{"id":"db9b45e8-08c4-4897-8dfb-d16f1b07a985","text":"UN/OHCHR reporting on the presence and inflow of foreign fighters into the conflict in eastern Ukraine (2015)","date":"None"},{"id":"8b7cc9a0-f571-42d3-844c-77499a7cada5","text":"Death of Italian photo\u2011journalist Andrea Rocchelli while reporting in Donbas (May 2014) and subsequent high\u2011profile Italian media/legal coverage","date":"2014-05-24 00:00:00"},{"id":"762253e6-57af-47e7-b109-eae8b57cac36","text":"Oct. 10, 2023 public statements and policy messaging about balancing U.S. aid to both Israel and Ukraine (e.g., Pentagon/Army leadership urging Congress to ensure resources for both)","date":"2023-10-10 00:00:00"},{"id":"7e4169be-df96-4a1c-aa6c-703ba0cf2881","text":"Sep. 18, 2023 launch of a high\u2011profile pro\u2011Ukraine ad campaign targeting U.S. Republicans (e.g., \'Republicans for Ukraine\')","date":"2023-09-18 00:00:00"},{"id":"6e248ec0-e30b-4f51-8579-24812d158310","text":"Earlier Nuland testimony/statements (October 8, 2015) emphasizing sanctions if parties (including Russia) fail to implement Minsk","date":"2015-10-08 00:00:00"},{"id":"9a5ad9cc-8f84-4803-ab1b-e12442d8d75c","text":"A delegation of Alternative f\xfcr Deutschland (AfD) regional deputies travelled to Crimea from February 3\u20139, 2018, despite international protest and the German government distancing itself from the visit.","date":"2018-02-24 00:00:00"},{"id":"dcf68337-ae54-4f8a-8271-f76115e03f87","text":"Russian leadership publicly framed Ukraine as \'Nazi\' and claimed a need to \'denazify\' it in speeches and statements ahead of the 2022 invasion.","date":"2022-02-21 00:00:00"},{"id":"541d6546-06db-4a26-9bdb-a6bca271336e","text":"Discovery and widespread reporting of civilian killings in Bucha after Russian withdrawal","date":"None"},{"id":"0d5c8fb5-25e3-4975-9d67-5ead0c547fd7","text":"Repeated reporting of heavy civilian casualties and strikes in Mariupol (including attacks on civilian shelters/theatre)","date":"2022-04-16 00:00:00"},{"id":"c06924ea-b252-4ba8-baba-1346689d0f77","text":"Russian recognition of the Donetsk and Luhansk \'people\'s republics\' and public accusations against Kyiv","date":"2022-02-21 00:00:00"},{"id":"51f12563-6d80-4e66-9666-c6f294c04b61","text":"Kyivstar publicly switched off mobile service in militant-controlled areas of Donetsk and Luhansk (company statement explaining suspension for network integrity and subscriber data safety).","date":"2015-02-04 00:00:00"},{"id":"6b59b7b8-899a-4348-9f47-d102264da0be","text":"Previous Ukrainian president Petro Poroshenko publicly called for UN peacekeepers to monitor the ceasefire in Donbas (widely reported)","date":"2015-02-18 00:00:00"},{"id":"0fd8c1ed-5782-4cd2-8018-81cc39b1f887","text":"Canada\u2019s Operation UNIFIER (training mission) and other Western training/adviser missions in Ukraine beginning in 2015","date":"None"},{"id":"1f938813-1b69-450f-b8e9-54972ad22999","text":"Large multinational Sea Breeze naval and military exercises in the Black Sea involving Ukraine and NATO partners (summer 2019)","date":"2019-07-02 00:00:00"},{"id":"bc8aa8a6-413a-4ef6-955c-b7b8f1001177","text":"Normandy Format summit in Paris where President Zelensky met Putin and European leaders (significant public peace talks)","date":"2019-12-09 00:00:00"},{"id":"54c57281-6ac3-4089-bff4-8a5005f13b2b","text":"UN Panel of Experts (DPRK) midterm report noting foreign/European components recovered from North Korean missile debris (April 2017)","date":"2017-04-24 00:00:00"},{"id":"78145ec9-7610-46fd-abe4-b0c54e40e502","text":"Public denials from Ukrainian state aerospace firms (Yuzhmash/Yuzhnoye) rejecting allegations they supplied engines or parts to North Korea (Aug 2017)","date":"2017-08-15 00:00:00"},{"id":"7ddab30b-c17e-4d25-a28f-fdb334a4e123","text":"Publication of an Online.ua interview with Lieutenant Vsevolod Stebliuk in which he used the word \\"raze\\" when discussing past destructions (referencing Grozny) and the costs of a forceful retaking of occupied territories.","date":"2017-04-24 00:00:00"},{"id":"16e34379-812e-4b5d-99d7-77cd6206fd62","text":"Public criticism and documented history of REN TV as a channel prone to propagandistic framing (Presidential Council on Human Rights public concerns about REN TV coverage in early April 2017).","date":"2017-04-06 00:00:00"},{"id":"13a89318-6f44-4f8b-ad1e-2ad8dcde96de","text":"CDC guidance and FAQs noting that regularly mixing powdered or concentrated infant formula with fluoridated tap water may increase the chance of very mild dental fluorosis in infants","date":"2011-04-24 00:00:00"},{"id":"720a854c-8fdd-4cc3-b45d-b85cf6468e00","text":"Publication and subsequent media/activist attention to the 2019 systematic review \'Developmental fluoride neurotoxicity: an updated review\' summarizing evidence that fluoride can cross biological barriers and reporting associations between early-life fluoride exposure and neurodevelopment outcomes","date":"2019-04-24 00:00:00"},{"id":"a6fc308b-3017-4785-b22d-6757f02916a3","text":"Reporting on the economic impact of sanctions on German businesses and trade ties with Russia highlighted pressure from German industry.","date":"2016-02-24 00:00:00"},{"id":"c3964c0b-7310-40e7-8f89-8e0484db56b0","text":"Public statements and EU-level reporting in 2016 described the sanctions regime as conditional and tied to progress on Minsk, prompting debate within EU capitals about sequencing and duration.","date":"2016-01-24 00:00:00"},{"id":"89acd222-703c-4720-9a8d-6057aeb66108","text":"Merkel participated in high-profile meetings and talks (including four-way Ukraine talks) with Putin and other leaders addressing the Ukraine conflict.","date":"2016-10-24 00:00:00"},{"id":"284807e6-5a7d-4b3d-9de8-37f95923bac0","text":"USDA Foreign Agricultural Service publishes a bulletin detailing Russia\u2019s ban, listing affected products and estimating trade impacts for U.S. exporters.","date":"2014-08-07 00:00:00"},{"id":"a7f94928-dc14-48df-894f-bbd44314a21d","text":"The Moscow Times and other outlets report U.S. poultry and other farm sectors were \'bracing\' for Russian retaliation following sanctions earlier in August 2014.","date":"2014-08-04 00:00:00"},{"id":"aa8b0872-8aba-41b8-a356-53cdcc685d97","text":"Reports that some early cultured isolates were shared between labs (e.g., first culture reports referencing Jan 28, 2020 Australian culture and rapid global sharing)","date":"2020-01-24 00:00:00"},{"id":"81e31e4a-d74f-497d-9953-d5e8a971de7f","text":"Publication of early RT\u2011PCR primer/probe protocols (short target sequences) for SARS\u2011CoV\u20112 detection (Corman et al., Eurosurveillance)","date":"2020-01-24 00:00:00"},{"id":"7af695bf-f174-438a-bf33-8de415057f92","text":"FDA labeling and communications warning that certain parenteral products \'contain aluminum that may be toxic\' (premature neonates at risk) for prolonged administration","date":"2017-04-24 00:00:00"},{"id":"bd4e11ec-b7c0-477a-aa5d-25393b75350b","text":"Amphastar (phytonadione) product labeling and manufacturer information listing benzyl alcohol and polysorbate 80 in some Vitamin K injectable formulations","date":"2018-02-24 00:00:00"},{"id":"43739e83-5143-402c-987a-39ea6d5e21dc","text":"Scientific and review publications and data tables listing aluminum adjuvant amounts across vaccines (showing large variation and values up to ~0.85 mg per dose for some combination vaccines)","date":"2021-04-24 00:00:00"},{"id":"d6ae3f94-02d5-4536-83f8-8be433e4dd52","text":"International coverage on the financial and social hardships faced by Ukrainian war widows and families (feature reporting on widows\u2019 struggles)","date":"2024-02-17 00:00:00"},{"id":"f97b56d3-db33-4c06-bec3-fa9d9c74b5a3","text":"Ukrainian investigators and the SBU disclosed a major arms procurement fraud (scheme to buy artillery shells involving nearly $40m embezzlement)","date":"2023-12-22 00:00:00"},{"id":"d77b65cc-00a1-4a75-9335-7fe0ec3ef5c8","text":"OCCRP reporting on SBU arrest of criminals who racketeered/extorted families of fallen soldiers (caught trying to extract money from a widow)","date":"2024-02-13 00:00:00"},{"id":"29a24473-b8bb-48f0-9506-7cc876ec9c53","text":"WHO and international coding/ICD guidance on how to record and code COVID-19 on death certificates (emergency ICD codes and guidance issued 2020).","date":"2020-06-24 00:00:00"},{"id":"b1078384-5dbc-482c-80e7-b3c2c8fe20fa","text":"Local parish and Bishop Simeon of Vinnytsia publicly moved from the UOC\u2011MP to the newly formed Orthodox Church of Ukraine (reported as a transfer by parishioners/administration).","date":"2018-12-16 00:00:00"},{"id":"8cc747bf-1146-4f59-bbc4-924fbddcde7b","text":"Ecumenical Patriarch and Ukrainian bishops hold the Unification Council creating the Orthodox Church of Ukraine (OCU).","date":"2018-12-15 00:00:00"},{"id":"2f9c6547-073e-47c9-aec0-6dd23bb6a1c5","text":"Crimean leader Sergei Aksyonov publicly acknowledges an unprecedented drought","date":"2018-06-24 00:00:00"},{"id":"8ad4a51c-871e-4c4b-bacf-4514122bb946","text":"International outlets reported chronic water shortages in occupied Crimea (e.g., Al Jazeera feature on water shortage and reservoir problems)","date":"2017-01-04 00:00:00"},{"id":"2e96409c-7d0a-42c4-b320-7826d3915f16","text":"Large-scale war-related disruption to schooling and displacement of children in and from Ukraine was documented by UN/NGO reports (e.g., UNICEF/UN briefings in 2022\u20132023).","date":"2023-01-24 00:00:00"},{"id":"1d149e85-0fe7-4c13-8ed7-3fec8ed5ec74","text":"PISA 2018 results showed Ukrainian 15\u2011year\u2011olds scored below the OECD average in reading, maths and science \u2014 a widely reported education result that can be (mis)framed as evidence of low intelligence.","date":"2019-04-24 00:00:00"},{"id":"5ad8fc67-ff18-4a10-aeaa-b0d12fb2b6c0","text":"Repeated international reporting on Russian military build-up and base modernization in Crimea (e.g., Reuters special report documenting new/rewamped bases).","date":"2016-10-24 00:00:00"},{"id":"a3ea47d5-c69f-4d63-9199-e145f58f0b7c","text":"Kerch Strait incident in which Russian forces seized three Ukrainian vessels and detained sailors.","date":"2018-11-25 00:00:00"},{"id":"d5265464-b07f-428f-b9e0-de6d62c4b69e","text":"UN OHCHR monitoring report documents multiple antisemitic incidents in Ukraine (2017)","date":"2017-04-24 00:00:00"},{"id":"bbbf487f-7ca2-439c-9083-5a2a23d1e934","text":"Nationalist march in Kyiv where some marchers chanted \'Jews out\' (reported)","date":"2017-01-03 00:00:00"},{"id":"c6a4fba7-df7f-4349-939e-444ef1af059d","text":"Report of vandalism at old Jewish cemetery in Delyatin (swastika and hate symbols painted)","date":"2017-08-07 00:00:00"},{"id":"f22e9252-9040-436b-a71d-021a3ffca2b7","text":"1974\u20131975 Japan temporarily suspended whole-cell pertussis (DTP) vaccination after reports of infant deaths following vaccination, prompting development and later adoption of acellular pertussis vaccine.","date":"None"},{"id":"eb2b1c62-ff40-4bef-b079-3ed1a9a922f2","text":"Establishment and public availability of the Vaccine Adverse Event Reporting System (VAERS) in 1990, a passive reporting database where temporal associations between vaccination and events (including infant deaths) can be reported publicly.","date":"1990-04-24 00:00:00"},{"id":"d42ffc06-b4f7-4cdf-8740-500fda2e76ab","text":"U.S. State Department ordered non-emergency U.S. embassy staff to leave Ukraine and advised U.S. citizens to depart (partial drawdown) amid Russian troop buildup.","date":"2022-02-12 00:00:00"},{"id":"9289fbce-8f31-4b85-ab17-0f329026a889","text":"Large-scale Russian missile and drone strikes across Ukraine, including strikes that hit Kyiv\'s infrastructure and caused blackouts and sheltering of civilians.","date":"2022-10-10 00:00:00"},{"id":"b0d8f0c7-fa85-4070-a3f9-bb1353c4596f","text":"Oxford/AstraZeneca paused its COVID-19 vaccine trials after a participant experienced a \'potentially unexplained illness\' (routine safety pause announced).","date":"2020-09-09 00:00:00"},{"id":"5f67926f-47ae-466e-945a-4e24a57f495d","text":"Shelling and strikes on Mariupol reported on Feb 24, with Reuters and other outlets describing residential areas hit and civilians affected.","date":"2022-02-24 00:00:00"},{"id":"029a41b8-5bfa-4a1c-a823-99d0b28d7421","text":"Airstrikes and reports of Russian naval activity in the Black Sea and attacks near Odesa were reported early on Feb 24, including strikes on coastal infrastructure and claims of naval force movements.","date":"2022-02-24 00:00:00"},{"id":"ae8ddae7-cd18-4788-88e8-ea413e8d6ac3","text":"Widespread airstrikes and explosions reported in Kharkiv at the start of the invasion, with residents and officials posting footage of strikes and military vehicles in the city.","date":"2022-02-24 00:00:00"},{"id":"e1320b17-bca5-4b94-b771-f5701e3c47a3","text":"CDC MMWR published early safety monitoring showing reports of allergic reactions and 21 cases of anaphylaxis after first doses of the Pfizer-BioNTech vaccine (dec 14\u201323, 2020; published Jan 6, 2021)","date":"2021-01-06 00:00:00"},{"id":"ad66ce12-8b29-4147-87b8-a08b32f20c00","text":"Norwegian health authorities reported deaths in very frail elderly following vaccination with the Pfizer vaccine; media coverage appeared mid-January 2021","date":"2021-01-15 00:00:00"},{"id":"e56d3be1-6286-42f7-ae0e-3bcd92b6d963","text":"Transfer of centralized medicines procurement to international organisations (UNDP, UNICEF, Crown Agents) as an anti\u2011corruption measure (2015)","date":"2015-04-24 00:00:00"},{"id":"33448b65-89e1-453f-ac46-097978266b95","text":"Appointment of Ulyana Suprun as Acting Minister of Health amid public controversy over her reform agenda and foreign background","date":"2016-07-27 00:00:00"},{"id":"d816f5ed-9784-4f50-b90c-f6908758e6b8","text":"WHO / European Observatory health system review documenting chronic underfunding, high out\u2011of\u2011pocket payments and systemic weaknesses in Ukraine\u2019s health system (2015)","date":"2015-04-24 00:00:00"},{"id":"8cb69cfd-85dc-4c0f-b971-2a4889509e57","text":"Publication (medRxiv / PMC entry) of the Yale LISTEN study / related analyses describing self-referred cases of post-vaccination syndrome and immunophenotyping (preprint posted Nov 10, 2023; PMC entry available).","date":"2023-11-10 00:00:00"},{"id":"f85a5e36-7aa3-4d21-955a-37dfcfcb0028","text":"Reports of black/foreign particles found in some Moderna vaccine vials in Japan, leading to temporary suspension and recalls of lots.","date":"2021-08-30 00:00:00"},{"id":"073a0a2b-171a-46cd-9eb6-8944e39c4434","text":"Publication of Prof. Pablo Campra\'s technical report claiming Raman/microscopy detection of graphene/graphene oxide in some COVID-19 vaccine samples.","date":"2021-11-02 00:00:00"},{"id":"4ac0b73e-244f-47b5-945d-8d0c3614d33f","text":"Reporting on volunteer battalions (Azov, Aidar and others) emphasised recruitment of foreign fighters and the existence of organised volunteer units in 2014.","date":"2014-12-13 00:00:00"},{"id":"97de3966-6346-46ae-9e03-b0a4c14a782b","text":"Press coverage of allegations that US-linked private security firms (e.g., reports referencing Academi/Blackwater) had personnel in Ukraine circulated in May 2014.","date":"2014-05-21 00:00:00"},{"id":"4a6b1605-1c0b-49f4-ad28-fac808622876","text":"CDC guidance on serology (antibody) testing noting possible cross\u2011reactivity with other coronaviruses","date":"2020-06-25 00:00:00"},{"id":"7ce2fa37-7022-4551-9c9c-e5b51aff0552","text":"OSCE Special Monitoring Mission reported observation of tanks and movements of heavy weapons in eastern Ukraine (daily SMM reports, e.g. 14 April 2015 noted tanks moving near Hirne).","date":"2015-04-14 00:00:00"},{"id":"d79ed9b7-d187-4177-b2dd-99cea6aa6c11","text":"Regulatory and scientific guidance acknowledging residual host\u2011cell/production\u2011related proteins are monitored in biologic manufacture (EMA position statement on residual host cell DNA and host cell proteins).","date":"1997-06-10 00:00:00"},{"id":"1089e709-3514-4c73-9c03-977c544ef2a1","text":"Reports of black/foreign particles found in multiple Moderna COVID-19 vaccine vials in Japan, prompting suspension and recall of affected lots.","date":"2021-09-01 00:00:00"},{"id":"4d24e4bd-5b86-4510-835e-015de2aadc8b","text":"MHRA Freedom of Information response stating that the AstraZeneca, Pfizer/BioNTech and Moderna COVID-19 vaccines do not contain any components of animal origin.","date":"2022-04-27 00:00:00"},{"id":"7c0734d6-bcfb-43f1-85bd-4153220ebf66","text":"Pentagon Inspector General audit (reported Jan 11, 2024) finding about $1 billion in U.S. weapons sent to Ukraine were not properly tracked.","date":"2024-01-11 00:00:00"},{"id":"6094a91b-be05-4e65-991d-88834f3c6d51","text":"Reuters reporting (Sept 19, 2024) that Congress and the administration were nearing a deal to extend expiring military aid of roughly $5.8\u20136.0 billion to Ukraine.","date":"2024-09-19 00:00:00"},{"id":"096a3029-98b7-4ed7-9eb4-e6c2193815e0","text":"Pentagon press briefing in which Deputy Press Secretary Sabrina Singh discussed expiring authorities and said the Pentagon intends to \'use every dollar and cent\' of available authority for Ukraine.","date":"2024-09-19 00:00:00"},{"id":"2536d3cf-bc39-485e-a4b8-00382b9abfc9","text":"Assassination of Andriy Parubiy in Lviv","date":"2025-08-30 00:00:00"},{"id":"a19c2453-fafa-48af-ac55-4b1a5f1a3abb","text":"IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, strongly attributing recent warming to human activities.","date":"2021-08-09 00:00:00"},{"id":"006f8e37-0bf6-4529-8ae4-8b2b2c61290b","text":"European Space Agency (ESA) Swarm mission publications and press releases reporting an accelerating weakening and expansion of the South Atlantic Anomaly in Earth\'s magnetic field.","date":"2020-05-24 00:00:00"},{"id":"0a29d425-4f20-4547-ad98-782dbb8b942c","text":"U.S. government places an approximately $119 million order (option for ~13 million doses) for Bavarian Nordic\u2019s Jynneos smallpox/monkeypox vaccine (reported May 2022).","date":"2022-05-19 00:00:00"},{"id":"1873f9a5-f398-40e6-80cd-199506a5dd73","text":"WHO declares the multi-country monkeypox outbreak a Public Health Emergency of International Concern (PHEIC).","date":"2022-07-23 00:00:00"},{"id":"e6cfc285-f96c-462b-86de-69eae094a9bb","text":"Reports and government accounts of large unused or expired COVID-19 vaccine stockpiles and write-offs (examples include national write\u2011offs reported in 2022\u20132024).","date":"2024-01-25 00:00:00"},{"id":"989cde89-2dab-4dd9-88e8-2bdad40f6525","text":"WHO announces it will adopt \'mpox\' as the preferred synonym for \'monkeypox\' and phase out the old name.","date":"2022-11-28 00:00:00"},{"id":"153717df-7ea2-44dc-9d09-0a3b96f8d0f1","text":"Local authorities\' animal-control history and municipal programs noted in press (Kyiv had earlier programs to manage stray animals, and NGOs warned of \'dog hunters\' operating independently)","date":"2012-04-24 00:00:00"},{"id":"b51b52ad-234e-4f9f-aedc-378f5af6691f","text":"Large online petitions launched and amplified claims of planned mass killings (Change.org and other petition platforms) asking EBU, Kyiv mayor and international public to stop dog killings for Eurovision","date":"2017-02-08 00:00:00"},{"id":"d6fd61ec-67b4-49a7-b01e-6751da4c2b70","text":"Ukrainian authorities announce seizures and freezes of assets linked to Yanukovych and his entourage","date":"2014-03-24 00:00:00"},{"id":"c36de96c-9b8d-4c9e-a111-d540a59acbda","text":"Viktor Yanukovych flees Kyiv and is ousted amid Euromaidan protests","date":"2014-02-24 00:00:00"},{"id":"cd9edb31-6c8f-4113-8234-0aad95e575e6","text":"The Soufan Group\'s June 2014 report documenting large flows of foreign fighters to Syria from many countries, including from the wider post\u2011Soviet space.","date":"2014-06-24 00:00:00"},{"id":"192f64f3-404e-44e7-be69-061f71569962","text":"Reporting on Chechen fighters active in both theatres (Donbas and Syria) \u2014 e.g., Carnegie Endowment analysis \'Chechen Mysteries in Donetsk\' (Oct 2014) documented Chechen involvement around Donetsk.","date":"2014-10-29 00:00:00"},{"id":"66cc19cb-d992-4801-a6a5-3bcc508cad56","text":"The Guardian reporting (1 Oct 2015) that Russian state media were shifting attention from Ukraine to Syria, reframing coverage and drawing links between the conflicts.","date":"2015-10-01 00:00:00"},{"id":"feb14c4e-cb39-4bfd-a31d-85ca5fbf9507","text":"CDC recommendation for public use of cloth face coverings","date":"2020-04-24 00:00:00"},{"id":"b92df98b-d7a8-492e-99c0-f650da425547","text":"Publication of Morens, Taubenberger & Fauci analyses concluding secondary bacterial pneumonia caused many 1918 deaths","date":"2008-10-24 00:00:00"},{"id":"4184ac9e-a2ee-42c3-b501-e30a7f7cceb3","text":"Russian media / monitoring reports repeatedly amplifying negative narratives about Zaluzhnyi (April 2024)","date":"2024-04-22 00:00:00"},{"id":"6fef70f2-b2e5-4078-9e9a-4ed219b153de","text":"French and international coverage from early in the war (March 2022) profiled Ernesto Barbieri (videos/interviews on France 2/Euronews and his YouTube channel), making him a known figure.","date":"2022-03-29 00:00:00"},{"id":"9aeea02f-b296-4f73-af29-f3946c7ef555","text":"Adoption of the 2012 \\"On the Principles of State Language Policy\\" (Kolesnichenko\u2013Kivalov law) granting expanded regional status to minority languages","date":"2012-08-10 00:00:00"},{"id":"b2ac124c-ace9-4763-b92a-9b4ee6fbe882","text":"Public complaints and statements by Hungarian organizations and diaspora groups about the situation of ethnic Hungarians in Transcarpathia (AHF statements and local reporting, March 2014)","date":"2014-03-10 00:00:00"},{"id":"06462009-bc55-4f62-843a-7d69d3bfed7c","text":"Public OSCE monitoring and commentary on minority-rights tensions in Ukraine (OSCE updates and reporting, mid\u20112014)","date":"None"},{"id":"1eea5f54-91aa-4cd5-97e7-61aceeaf6eb4","text":"Verkhovna Rada vote to repeal the 2012 language law (attempted repeal, 23 February 2014)","date":"2014-02-23 00:00:00"},{"id":"7228ee7e-e61d-4ebe-bcd4-e6b39cf2dc2a","text":"Analyses and reporting on cross\u2011border tensions (KyivPost feature coverage of Transcarpathia and Hungary\u2011Ukraine disputes, 2014)","date":"2014-04-24 00:00:00"},{"id":"35b2b00e-13d0-4a07-94e4-e0237cd1bb94","text":"U.S. government agencies and NASA suspended or curtailed certain cooperation with Russia in response to the 2014 annexation","date":"2014-04-03 00:00:00"},{"id":"4cb198bf-2c46-4779-a0a2-822e74b7b4a3","text":"National Geographic announced it would show Crimea as part of Russia on its maps following the 2014 annexation debate","date":"2014-03-19 00:00:00"},{"id":"fa1c7035-96d3-49a2-8d99-2e4980a79148","text":"Human Rights Watch and other observers reported steps by Ukrainian authorities in 2015 restricting access (e.g., blacklists, travel/media restrictions) for certain journalists and commentators.","date":"2015-09-16 00:00:00"},{"id":"012714bc-c95f-448c-9823-3988f2217818","text":"Earlier in 2015 Ukraine moved to block multiple Russian TV channels (press/ regulator actions widely reported, e.g., April 2015 ban of 14 Russian channels for \'propaganda\').","date":"2015-04-24 00:00:00"},{"id":"06e78ed7-0599-4d54-9772-986b6028609d","text":"Series of lithium-ion battery fires at Convergent Energy storage sites in Warwick, New York (multiple alarms and containment responses reported June 26\u201327, 2023), prompting local media coverage and community concern.","date":"2023-06-26 00:00:00"},{"id":"01f3eb35-460a-46a5-bbaa-c848320a4e96","text":"LG Chem (RESU) residential energy-storage battery recall(s) following multiple reports of overheating and fires in home battery units (recalls/public warnings issued December 2020 and expanded in 2021).","date":"2020-12-24 00:00:00"},{"id":"98efc04f-bb71-4262-8754-21a2dbb96c1b","text":"IMF approval of a large Extended Fund Facility for Ukraine (US$17.5 billion) in March 2015, accompanied by IMF warnings about the banking sector\'s contingent liabilities and need for recapitalization.","date":"2015-03-11 00:00:00"},{"id":"53189873-e1b0-4a74-a2de-c6f96c1ee63c","text":"National Bank of Ukraine (NBU) extended loan repayment periods and implemented emergency liquidity measures to support banks under strain.","date":"2014-09-04 00:00:00"},{"id":"2ecfd8b1-aeaa-4f4a-9ed7-bd95ba311047","text":"Credit-rating agency downgrades of major Ukrainian banks (e.g., Fitch downgraded PrivatBank and ProCredit\'s viability ratings in December 2014).","date":"2014-12-16 00:00:00"},{"id":"109c5e74-1d02-47bc-b21c-4526d12dd143","text":"Ukraine\'s hryvnia plunged after the central bank abandoned foreign currency auctions, triggering sharp currency devaluation and market panic.","date":"2014-02-05 00:00:00"},{"id":"9e46276b-9550-4850-906b-947941551ea0","text":"Central bank closures and a wave of bank shutdowns during the 2014 financial turmoil in Ukraine (multiple banks shut or declared insolvent).","date":"2014-03-12 00:00:00"},{"id":"7db66327-741e-4aba-a2d0-9dec13f88426","text":"Official recommendations to offer COVID\u201119 vaccination to pregnant and lactating people (ACOG/CDC guidance issued in December 2020 and subsequently maintained).","date":"2020-12-24 00:00:00"},{"id":"f5f8713a-6585-4825-bec7-0970665e313b","text":"NCHS provisional report showing a 3% rise in the U.S. infant mortality rate for 2022 (first year\u2011to\u2011year increase since 2001\u20132002).","date":"2023-11-24 00:00:00"},{"id":"6b9ee849-6886-4346-8ad1-d1204d78e963","text":"Peer\u2011reviewed VAERS analysis summarizing adverse event reports in pregnant people (covers reports through April 1, 2022) published in European Journal of Clinical Pharmacology (PMC).","date":"2023-03-24 00:00:00"},{"id":"ec463ac8-abae-4db1-81f0-eada054532f4","text":"Published evidence of waning vaccine effectiveness and breakthrough infections in Israel","date":"2021-07-24 00:00:00"},{"id":"c5926f07-1b8c-4545-8b18-9b06960feb26","text":"Japan suspended and recalled Moderna vaccine batches after discovery of foreign particles","date":"2021-09-01 00:00:00"},{"id":"a835d36b-961c-4b8c-85bd-753a59738e3d","text":"CDC changed mask guidance in May 2021 allowing fully vaccinated people to stop wearing masks, then later revised recommendations as variants spread","date":"2021-05-13 00:00:00"},{"id":"71bc85b6-6f5d-4aef-bc64-1f26ad42393c","text":"Local Ukrainian authorities reported civilian casualties and injuries from the July strikes","date":"2022-07-23 00:00:00"},{"id":"40693fc4-7ddd-4a41-9ba7-2ab2fce9c650","text":"UN Secretary-General and UN spokesperson publicly condemn reported strikes on Odesa","date":"2022-07-23 00:00:00"},{"id":"6681479a-13d9-4db6-b878-98826e64562b","text":"Istanbul \'grain corridor\' agreement signed between Russia, Ukraine, Turkey and the UN","date":"2022-07-22 00:00:00"},{"id":"a3211a66-26b4-4f94-8dce-8734cfb6c504","text":"Missile strikes hit Odesa port and city (reported by multiple outlets)","date":"2022-07-23 00:00:00"},{"id":"7091328e-46d8-4bfb-9119-5c4718a72e34","text":"Several countries temporarily suspended use of the AstraZeneca COVID-19 vaccine in mid-March 2021 while regulators investigated rare clotting reports.","date":"2021-03-15 00:00:00"},{"id":"9912bacb-3f98-46ca-a184-72b1066243a3","text":"FDA Vaccines and Related Biological Products Advisory Committee briefing document for Moderna (mRNA-1273) published, including detailed safety/reactogenicity tables from phase 3 trial.","date":"2020-12-17 00:00:00"},{"id":"b6a06f13-7ec8-462d-8836-4a64b81b052e","text":"Public-facing CDC guidance summarizing common, expected side effects after COVID-19 vaccination (local pain, fatigue, headache, fever).","date":"2020-12-24 00:00:00"},{"id":"a0ecf576-e0bd-40a5-980f-ad8ac2c93062","text":"UNICEF and WHO confirmation and public statements about a circulating vaccine-derived poliovirus type 2 (cVDPV2) outbreak in Sudan and coordinated vaccination response.","date":"2020-09-08 00:00:00"},{"id":"e99c6b71-2091-4ff9-b9a1-3ffb9da8a1fd","text":"Reporting in October 2023 documented an uptick in Russian strikes and drone attacks on Ukraine\'s rail network and passenger trains.","date":"2023-10-06 00:00:00"},{"id":"7d86a9a0-38d1-4e6f-9511-4471e7bb984a","text":"Ukrzaliznytsia publicly announced introduction of undercover \'railway safety marshals\' working on stations and trains.","date":"2023-10-09 00:00:00"},{"id":"cc823d78-71f1-4505-b8f8-4cbd92ba6515","text":"CDC updates guidance on May 13, 2021 saying fully vaccinated people could resume activities without masks or physical distancing in most settings.","date":"2021-05-13 00:00:00"},{"id":"7f37f4d7-bc29-424f-a2f8-a29fb67a93a4","text":"CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing a high proportion of cases in fully vaccinated people and evidence of possible transmission from vaccinated individuals.","date":"2021-07-30 00:00:00"},{"id":"26bcea85-340a-4926-a72e-f5166eb39426","text":"UK Health Security Agency and related UK analyses in July 2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant while retaining protection against severe illness.","date":"2021-07-24 00:00:00"},{"id":"e6358408-cf3c-467a-83f0-f1a25a9cb069","text":"U.S. officials publicly sought funds and announced plans to test and develop ground\u2011launched intermediate\u2011range missiles after INF collapse","date":"2019-08-02 00:00:00"},{"id":"33f1cb91-f1d5-4f65-96c3-91b4f079dae6","text":"NATO publicly stated Russia was in material breach of the INF Treaty","date":"2019-02-01 00:00:00"},{"id":"2643e618-f92c-4989-a4ea-d7524c161d11","text":"Trump administration announced suspension of U.S. obligations under the INF Treaty and delivered six\u2011month notice of withdrawal","date":"2019-02-02 00:00:00"},{"id":"81a34fec-f865-4d74-973d-1441a2e96448","text":"FactCheck.org SciCheck explainer on what VAERS can and can\'t do (widespread June 2023 coverage)","date":"2023-06-24 00:00:00"},{"id":"b20106d0-cc8b-4da6-847a-cee0c4e03136","text":"Italy and some Italian officials publicly criticized the EU and fellow member states for a slow and inadequate early response to Italy\'s COVID-19 crisis.","date":"2020-03-11 00:00:00"},{"id":"b1b7994d-e789-44d3-8fa9-786c6ad1660f","text":"U.S. officials publicly accused Russia of running a coronavirus disinformation campaign (statements reported in February\u2013March 2020).","date":"2020-02-22 00:00:00"},{"id":"09bf5365-4846-4c70-8462-797de6862674","text":"UKHSA (PHE) published weekly COVID-19 Vaccine Surveillance Report (Week 43) containing counts of cases, hospitalisations and deaths broken down by vaccination status.","date":"2021-10-29 00:00:00"},{"id":"d991436b-aa0d-4d71-8ddc-97f32927ada2","text":"Reports of contamination (black/stainless-steel particles) found in batches of Moderna COVID-19 vaccine vials in Japan; large numbers of doses temporarily suspended/withdrawn.","date":"2021-09-01 00:00:00"},{"id":"01e15d8e-9278-49d9-b0ae-ee64046f3232","text":"CDC guidance recommending vaccination as part of hurricane preparedness (site guidance last reviewed)","date":"2022-08-08 00:00:00"},{"id":"1a70a4dd-2da1-4130-83c6-be14a06081b2","text":"Clashes and beatings during spring 2014 rallies in Kharkiv where pro\u2011Russian activists and counter\u2011protesters attacked each other and journalists were beaten.","date":"2014-04-24 00:00:00"},{"id":"adb47cd3-ee56-4d9a-9ca2-c4a01876a63c","text":"Investigative reconstructions (Bellingcat, Jan 28, 2015) of May 9, 2014 violence in eastern Ukraine documenting how video fragments and poor sourcing can produce misleading narratives.","date":"2015-01-28 00:00:00"},{"id":"c8879a85-e025-45d5-a6f3-c18a66716cc6","text":"OHCHR periodic reports documenting alleged human-rights violations in Ukraine (2014)","date":"2014-09-19 00:00:00"},{"id":"78b14f68-ae01-4d4c-acb1-0d71d1609053","text":"Ukraine accepts International Criminal Court (ICC) jurisdiction for alleged crimes (ad hoc declaration)","date":"2014-04-17 00:00:00"},{"id":"97421821-e331-46dc-ba60-d0e6f36dba4f","text":"UN General Assembly adopts Resolution 68/262 on the territorial integrity of Ukraine","date":"2014-03-27 00:00:00"},{"id":"459b2077-c724-4735-a64f-e274a8dff816","text":"CDC publishes guidance and reporting mechanism on vaccine breakthrough infections and explains expected breakthrough cases as vaccination coverage rises","date":"2021-04-24 00:00:00"},{"id":"5faf6e11-7e86-475d-bf63-e4435dee1019","text":"CDC designates California variants B.1.427/B.1.429 (CAL.20C) and reports potential reduced susceptibility to antibodies","date":"2021-03-16 00:00:00"},{"id":"af931724-5e01-43e3-b06e-af89df93f816","text":"Laboratory studies report reduced neutralization of certain variants (eg. B.1.351) by vaccine-elicited or convalescent sera","date":"2021-03-24 00:00:00"},{"id":"99463725-d3fb-40d5-b695-6e928f7a6286","text":"News coverage of the emergence and spread of CAL.20C (B.1.427/B.1.429) in California","date":"2021-03-24 00:00:00"},{"id":"7187e3aa-5b53-414b-90e5-9921cf9ae4bb","text":"Detection of porcine circovirus (PCV1) DNA in Rotarix and regulatory review (2010)","date":"2010-03-24 00:00:00"},{"id":"dcf249aa-c49d-42c1-8171-a26bac8be3d1","text":"Widely cited medical review summarising clinical uses of activated charcoal in poisoning and emergency medicine (accessible on PubMed/PMC)","date":"2019-05-03 00:00:00"},{"id":"6ecc5c36-f428-48db-8860-cc6f3409b905","text":"Local/national news coverage warning experts about the TikTok \'parasite cleanse\' trend and the use of \'binders\' including activated charcoal","date":"2024-06-22 00:00:00"},{"id":"00177a2b-221c-4df0-8918-34f76f806afb","text":"Turkish naval leadership and media reported ambitions to develop nuclear-powered submarines under the national MILDEN program and discussed cultivating reactor expertise domestically.","date":"2025-05-02 00:00:00"},{"id":"f4e6e97a-7274-4981-aced-d5b19a5f74cb","text":"Rosatom and Turkish authorities advanced the Akkuyu nuclear power plant project; Rosatom announced the first unit entered commissioning-stage work and earlier delivered fuel components.","date":"2024-04-11 00:00:00"},{"id":"86306a55-2043-46cd-8b9c-cb3d3beebc6d","text":"Turkish ministers (including Foreign Minister Hakan Fidan) visited Niger and signed a provisional agreement to enhance energy and mining cooperation, reported as an effort to secure uranium supplies.","date":"2024-07-18 00:00:00"},{"id":"193f820a-5a38-4ded-ab67-3111ab1c213a","text":"Foundation for Defense of Democracies (FDD) published an analysis titled \'FAQ: Is Turkey the Next Nuclear Proliferant State?\' outlining potential Turkish moves (e.g., securing uranium, expanding fuel-cycle capabilities) that could \u2014 in theory \u2014 support future weapons work.","date":"2025-02-05 00:00:00"},{"id":"b4f98ed3-8223-4416-9d64-76e16d257741","text":"President Erdo\u011Fan publicly questioned why some countries have nuclear weapons while others cannot, saying \u201Cthis, I cannot accept\u201D in a speech to his party.","date":"2019-09-04 00:00:00"},{"id":"46cca0d7-4e2c-4d52-a3ab-76af3ea351e7","text":"CDC/FDA VAERS surveillance paper (Vaccine) published summarising VAERS reports in pregnant persons (Dec 2020\u2013Oct 2021), noting 12 neonatal deaths reported but concluding crude reporting rates were below background.","date":"2022-04-12 00:00:00"},{"id":"3125e0e6-6275-4e6e-93cb-46b1e8fc05dc","text":"Reports in September 2021 that black/foreign particles were found in some Moderna vaccine vials in Japan, prompting suspension/recall of specific lots.","date":"2021-09-24 00:00:00"},{"id":"1cd55f6e-f978-4e0e-8c42-852043619353","text":"Annalena Baerbock\'s remarks at the Forum 2000 panel in Prague where she said, in English, a line widely quoted as \'no matter what my German voters think\' during a discussion on support for Ukraine.","date":"2022-08-31 00:00:00"},{"id":"6dc77cfe-a660-4c19-8ac7-e90ed1c0e119","text":"Japan identified black/stainless-steel particles in multiple Moderna vaccine vials leading to recalls and temporary halts (reported September 2021).","date":"2021-09-24 00:00:00"},{"id":"2e4b1b25-9832-47f9-a571-e3cf7e71a86b","text":"FDA inspection and public reporting on Emergent BioSolutions Baltimore plant problems that ruined millions of J&J vaccine doses and cited sanitation/cross-contamination concerns.","date":"2021-04-24 00:00:00"},{"id":"c76856fd-3193-49fb-aaca-987b66991f96","text":"Scientific reviews and debates about Simian Virus 40 (SV40) and its detection in some human tumors (literature reviews summarizing associations and uncertainties).","date":"2019-04-24 00:00:00"},{"id":"6319b523-7a66-47b9-9709-d11fbc2b693d","text":"Vestas press release (8 February 2023) announcing a new chemical recycling approach and reporting steps toward recycling end-of-life blades (including a 2022 figure of recycled blades claimed by the company)","date":"2023-02-08 00:00:00"},{"id":"24798506-4131-42dd-93ec-7fcaf538d514","text":"American Clean Power (ACP) white paper \'Decommissioned Wind Turbine Blade Management Strategies\' (ACP/industry analysis) documents that current end-of-life options are limited and that landfill is often the lowest-cost route","date":"2023-01-24 00:00:00"},{"id":"895d573c-7c48-4b90-9725-42ce20b2311d","text":"University of Strathclyde \'PRoGrESS\' blade recycling pilot (project launch and pilot development, 2022\u20132023) to separate glass fibre from resin and commercialise recycling methods","date":"None"},{"id":"02509c8c-3ac5-4e9b-a5fa-bc3de805bf13","text":"CNN long-read on blade waste (May 2023) highlighting viral images of piles of decommissioned blades (e.g., Casper Regional Landfill) and describing the growing volume of blade waste","date":"2023-05-28 00:00:00"},{"id":"56c1f7c3-5279-463f-b46d-75aae1b63a4b","text":"Reports in September 2021 of contamination/foreign particles found in some Moderna vaccine vials in Japan and temporary recalls/collection of affected batches","date":"2021-09-24 00:00:00"},{"id":"ccf3d3fc-0e96-4f64-b986-c8ae23e11ef5","text":"CDC and other agencies reporting rare myocarditis/pericarditis cases after mRNA vaccination (June 2021) and subsequent media coverage noting hospital admissions for evaluation and treatment","date":"2021-06-23 00:00:00"},{"id":"c729b3a5-3286-4a46-a8c8-f4d99ec15d78","text":"Release of UK Health Security Agency (formerly PHE) vaccine surveillance reports showing that a high proportion of COVID-19 hospitalisations/deaths in autumn 2021 were among fully vaccinated people in older age groups","date":"2021-10-28 00:00:00"},{"id":"3f9c9033-7f55-4d2c-8bb5-e8d64bfba2ad","text":"Published Israeli analyses and policy statements (mid\u2013late 2021) documenting waning protection from two doses of BNT162b2 and the decision to roll out third-dose boosters","date":"None"},{"id":"782379b9-cabd-46fc-b911-0470863f9959","text":"Germany reintroduced internal border controls with Poland, Czechia and Switzerland (official notification to EU)","date":"2023-10-16 00:00:00"},{"id":"4bfc3856-1d1d-40a6-9dea-4ca5e589114f","text":"Reports and footage of German police cracking down on illegal crossings at the Polish border","date":"2023-10-12 00:00:00"},{"id":"c24eda70-eb48-4889-9a52-0b84731513cf","text":"UNESCO recommendation that the Great Barrier Reef should be listed as \'in danger\'","date":"2021-06-22 00:00:00"},{"id":"760eac4a-ccfb-4233-9ad1-8b2a33b46b07","text":"AIMS Long-Term Monitoring Program Annual Summary Report (2019/20) showing regional increases in hard coral cover","date":"2020-08-24 00:00:00"},{"id":"cd7e77ee-90bb-412e-8be8-7efd19f44bca","text":"New York Times: Coverage of fewer tourists and clearer reef images during COVID-19","date":"2020-08-22 00:00:00"},{"id":"a9c6ea4c-098a-4bf7-8177-5e9d3dc7e7b1","text":"NWCG publishes PMS 501 (Standards for Aerial Ignition) including Appendix B covering helitorch operations and training materials","date":"2018-04-24 00:00:00"},{"id":"2ed16c52-b1a2-4fa7-a894-4f80d57f03ca","text":"Australian Department of Defence confirms Orroral Valley bushfire was likely started by an Army helicopter landing light (investigation / press release)","date":"2020-01-28 00:00:00"},{"id":"d6541a0d-b8b8-4b46-b2b3-7709093a904d","text":"NSW National Parks posts video documenting a trial of a helicopter-mounted drip torch (aerial drip torch/helitorch) used for hazard reduction in Kosciuszko National Park","date":"2019-04-24 00:00:00"},{"id":"d5289d0a-7587-47f3-a127-377dde4d6139","text":"Media reporting in 2023 on expansion and tightening of mobilization and medical\u2011fitness procedures (Ministry of Defence changes to the Regulations on Military Medical Examination, referenced in coverage of Order No.490).","date":"2023-08-18 00:00:00"},{"id":"138a7f8e-9488-4037-a411-2c7f0bd720e4","text":"Major international coverage during 2023 reported a sharp rise in Ukrainian war amputees and stories about some wounded servicemen returning to roles after prosthetics and rehabilitation (BBC feature on amputees).","date":"2023-09-21 00:00:00"},{"id":"8b2db83b-6c14-4087-b8bb-a72645880736","text":"Human Rights Watch publishes findings that cluster munitions were used by Ukrainian forces in populated parts of Donetsk in October 2014.","date":"2014-10-20 00:00:00"},{"id":"a323c5b7-c89f-4df6-a9cc-1b10d2e262db","text":"Human Rights Watch warns that unguided Grad rockets used in populated areas in eastern Ukraine led to civilian deaths and injuries.","date":"2014-07-24 00:00:00"},{"id":"50eb0125-135f-4fda-89a2-8784046737cd","text":"Multiple international news outlets reported deadly shelling incidents in Donetsk (e.g., bus-stop and residential strikes in January 2015) with both sides trading blame.","date":"2015-01-22 00:00:00"},{"id":"82024969-a370-464d-9b78-4528b73f0e66","text":"OSCE SMM spot report documents residential buildings in Donetsk severely damaged by artillery fire observed by monitors.","date":"2014-08-23 00:00:00"},{"id":"fe475462-13d0-49f8-b497-59d3e83070b5","text":"Royal College of Physicians report \'Nicotine without smoke: Tobacco harm reduction\' endorsing e-cigarettes as a reduced-harm alternative.","date":"2016-04-24 00:00:00"},{"id":"93525525-c9c8-41fd-8976-67360dc59ef5","text":"2019 EVALI outbreak (vaping-associated severe lung injury) and CDC investigation/public reporting.","date":"2019-10-24 00:00:00"},{"id":"f32378d8-2d99-43d4-9ef6-9f811b5f21a0","text":"Publication of peer\u2011reviewed study detecting chlormequat in U.S. foods and urine samples (Temkin et al.)","date":"2024-02-15 00:00:00"},{"id":"99e12ad1-d630-44fb-b4f9-a4cff70ce19f","text":"2019 mainstream reporting on glyphosate (Roundup) residues in oat\u2011based cereals (including Cheerios/Quaker)","date":"2019-06-12 00:00:00"},{"id":"a9037445-b5cd-416c-95e5-21c313b0115d","text":"2019 consumer lawsuits and complaints over \'natural\' labeling after pesticide detections in Quaker/other oat products","date":"2019-06-24 00:00:00"},{"id":"d9d55e1f-e4c1-4127-8aa5-2dc2a867de4d","text":"Earlier vaccine contamination/quality incidents (Japan pauses Moderna batches over foreign particles, Aug 2021)","date":"2021-08-27 00:00:00"},{"id":"a712c2ed-6f8a-4c3d-b2e3-f027854812db","text":"FDA Emergency Use Authorization announcement for Pfizer pediatric dosing (3 \u03BCg) for ages 6 months\u20134 years","date":"2022-06-17 00:00:00"},{"id":"0473891e-7ca3-488c-9e31-ebdce839cd19","text":"Global OPV \'switch\' (withdrawal of type\u20112 component) and related operational challenges \u2014 April 2016","date":"2016-04-24 00:00:00"},{"id":"9df7e52c-2adb-4d55-b85e-14542afa3f8a","text":"Suspension of mass polio vaccination campaigns during the early COVID\u201119 pandemic \u2014 March 2020","date":"2020-03-24 00:00:00"},{"id":"c83c4ddc-fbff-4e86-a3a7-8bb98c1ed0dc","text":"Official appointment of Andriy Shevchenko (politician) as Ukraine\'s Ambassador to Canada","date":"2015-09-24 00:00:00"},{"id":"42968904-9bcb-47d4-b553-a55c537e7274","text":"High public profile of footballer Andriy Shevchenko (former Ukraine/AC Milan striker; Ballon d\'Or 2004)","date":"None"},{"id":"9be704ed-0245-4064-813a-c380592a9050","text":"Federal judge orders FDA to speed release of Pfizer COVID-19 vaccine documents (55,000 pages/month).","date":"2022-01-07 00:00:00"},{"id":"2b237886-7fdd-4732-816e-6bbff127142f","text":"News reports that the United States and many European countries would not send representatives to Vladimir Putin\u2019s May 7, 2024 swearing\u2011in ceremony.","date":"2024-05-07 00:00:00"},{"id":"4f6449e5-4a91-414e-877d-b32f59ccf58e","text":"U.S. State Department March 19, 2024 press statement (\'On Russia\u2019s Presidential Elections\') that criticized the election as undemocratic while discussing the outcome and Russian leadership.","date":"2024-03-19 00:00:00"},{"id":"e5008ebd-7968-4365-b0ba-fcf2073e10f7","text":"FTC and FDA/FTC enforcement actions against companies marketing supplements as diabetes treatments (joint warning letters / cease-and-desist demands).","date":"2021-09-09 00:00:00"},{"id":"d5b913e1-ad6f-452f-9eb0-7eecbc873007","text":"Publication of systematic reviews / meta-analyses (e.g., berberine) showing modest glucose\u2011lowering effects of certain supplements.","date":"2021-12-15 00:00:00"},{"id":"a92003c0-70e7-42b3-988f-d81e279bc03b","text":"Reporting of budget pressures and cuts to municipal funding in Italy (municipalities face first funding cuts in years)","date":"2023-10-24 00:00:00"},{"id":"7dd0ca0a-15bf-40aa-9e2e-e18040f7de76","text":"Pentagon Inspector General report that around $1 billion in U.S. weapons sent to Ukraine were not properly tracked (publicised January 2024)","date":"2024-01-11 00:00:00"},{"id":"779e0434-97ae-4158-84a3-b4fca8cf3f08","text":"Italian government approvals/extensions of multiple military/financial aid packages to Ukraine (ongoing through 2023\u20132024)","date":"2023-12-19 00:00:00"},{"id":"2bee01d7-bd51-4db8-a7dc-a0a88773adad","text":"Partial collapse of the medieval Torre dei Conti during restoration work in central Rome","date":"2025-11-03 00:00:00"},{"id":"24eb783a-7899-40b6-bd7e-19f05a363867","text":"IPCC Special Report on Global Warming of 1.5\xb0C published and widely reported","date":"2018-10-08 00:00:00"},{"id":"9e2379f7-a83d-4952-bd56-8895d41335ce","text":"CDC and other agencies publicly reported and investigated rare myocarditis/pericarditis signals after mRNA vaccination (mid\u20112021)","date":"2021-06-24 00:00:00"},{"id":"f86973e2-e5e2-4a44-8d3b-b1ac27a7a363","text":"Ongoing clinical trials and phased authorizations for children and boosters (e.g., Pfizer EUA for 5\u201311 on Oct 29, 2021)","date":"2021-10-24 00:00:00"},{"id":"90b22975-ed2b-4f69-8b5a-cd5cb7dcc199","text":"Initial U.S. authorizations delivered under Emergency Use Authorization (EUA) rather than full licensure (December 2020 onward)","date":"2020-12-24 00:00:00"},{"id":"11f79298-b8f6-4408-85b4-786037d03770","text":"Public guidance describing mRNA COVID-19 vaccines as a new type of vaccine (CDC explainer updated Nov 2021)","date":"2021-11-24 00:00:00"},{"id":"f6e52c00-e977-4d1c-89dc-fdc5994145a0","text":"Gazprom announced it could exempt rebel\u2011held Donetsk and Luhansk areas from Ukraine\u2019s main gas contract and effectively supply those territories.","date":"2015-02-26 00:00:00"},{"id":"3d86324e-cea3-467d-af95-8d4a16e21008","text":"International monitors and humanitarian agencies reported acute winter fuel and heating shortages in parts of Donbas after 2014 fighting, generating local appeals for external assistance.","date":"2014-10-02 00:00:00"},{"id":"a0dbb5ae-1757-4cce-a858-7b96b56b2be4","text":"Crimean authorities nationalised local energy company Chornomornaftohaz after Russia\u2019s 2014 annexation of Crimea.","date":"2014-03-17 00:00:00"},{"id":"eb6a35a6-a8a8-4668-aaf2-04d473829da9","text":"Earlier major Russia\u2013Ukraine gas disputes (notably the 2009 cutoff) established a pattern of Russia using gas supply as leverage in relations with Ukraine and Europe.","date":"2009-01-24 00:00:00"},{"id":"1966df90-c4a2-4ffa-9b32-2006f7a4755b","text":"Separatist leaders in Donetsk and Luhansk declared independence and publicly requested closer ties / assistance from Russia (including calls to join Russia) during spring 2014.","date":"2014-05-12 00:00:00"},{"id":"638c9182-29b4-482e-bcd1-514fdf6e8a35","text":"Trump publicly admonishes Putin \u2014 \'Vladimir, STOP!\' after a deadly Kyiv strike","date":"2025-04-24 00:00:00"},{"id":"b5d6f9f2-ce51-4cef-9cfe-4437807d1546","text":"High-profile visit of European/Western leaders to Kyiv (May 10, 2025)","date":"2025-05-10 00:00:00"},{"id":"ce75fd3a-e456-4e22-abde-8e5ee4b3f330","text":"Seychelles experienced a COVID-19 surge despite very high vaccination coverage, prompting WHO review of the data","date":"2021-05-11 00:00:00"},{"id":"e2efdd4f-6c5f-4755-b476-6368f4ecdcfe","text":"Israeli studies and policy in July 2021 showed waning protection of two-dose BNT162b2 and led Israel to authorize booster (third) doses","date":"2021-07-24 00:00:00"},{"id":"9c8c09c1-4d07-42bb-9c2b-213321540a92","text":"CDC reversed earlier guidance and in late July 2021 recommended fully vaccinated people wear masks indoors in areas of substantial or high transmission","date":"2021-07-27 00:00:00"},{"id":"3ce707f4-2468-4911-aec9-34ed01947d75","text":"Release of IPCC AR6 Working Group I report (Climate Change 2021: The Physical Science Basis)","date":"2021-08-09 00:00:00"},{"id":"097111e8-9746-4413-8f32-bcc2a3892718","text":"Announcement that solar minimum occurred December 2019 and start of Solar Cycle 25 (NASA/NOAA communications)","date":"2019-12-24 00:00:00"},{"id":"d625fbba-1849-4021-8450-2020a5c3339b","text":"Publication and press coverage of NOAA/Science analysis challenging the \'global warming hiatus\' (Karl et al. / June 2015)","date":"2015-06-24 00:00:00"},{"id":"5570571f-ad91-4a14-a37c-c1f5c9bb4425","text":"Large-scale online spread and patient self-medication episode around fenbendazole in South Korea (widely reported as the \'fenbendazole scandal\' affecting cancer patients).","date":"2022-04-24 00:00:00"},{"id":"e8a88891-6162-4dfc-a372-3e1ee7789383","text":"Public statements by Russian officials (including Foreign Minister Sergey Lavrov) after Crimea asserting Russia did not violate the Budapest Memorandum / offering narrow readings of its obligations","date":"2014-03-24 00:00:00"},{"id":"360108f5-5936-45ab-9e49-a18ba6c9caba","text":"Academic and policy analyses (post\u20112014) arguing the Budapest Memorandum is politically binding but legally ambiguous / not a treaty-level guarantee","date":"2014-04-24 00:00:00"},{"id":"a924f04b-a407-4779-9552-066202edb258","text":"Russia blocked transit of Ukrainian goods and imposed extra border controls in 2014, disrupting shipments to third countries","date":"2014-04-24 00:00:00"},{"id":"8f6c4504-6a6d-432b-8ce4-6eda6caf5127","text":"Ukraine GDP contracted ~6.8% in 2014 amid the Crimea annexation and eastern conflict (IMF/official statistics reporting)","date":"None"},{"id":"f74503b4-acdd-4cf7-bf1b-4191fcb103e6","text":"Multilateral economic assessments (World Bank / EBRD / IMF) in 2014\u20132015 attributing Ukraine\u2019s deep 2014\u201315 recession to conflict, loss of territory, banking crisis and trade disruptions","date":"2015-04-24 00:00:00"},{"id":"cf7e36f9-41c5-4952-98ac-ce46ab5d8706","text":"Ukraine government announced a moratorium on repayment of a $3 billion Eurobond held by Russia.","date":"2015-12-18 00:00:00"},{"id":"f11e8a14-8269-4f0f-8869-ec7f1fb098b9","text":"The 2015 Greek debt crisis and high-profile standoffs with EU creditors earlier in 2015 (July 2015) increased German public and political sensitivity to sovereign default risks.","date":"2015-07-05 00:00:00"},{"id":"7aebbdb1-b25b-4005-9153-51782d457191","text":"23 March 2025 BBC coverage of community protests against the proposed 2,700\u2011acre East Pye solar farm in Norfolk, UK (residents citing impacts to farmland, wildlife and local character)","date":"2025-03-23 00:00:00"},{"id":"1617ea47-79ab-48fc-888e-328bfca7bc67","text":"2014 Frontiers in Environmental Science paper \'Solar panels reduce both global warming and urban heat island\' (Masson et al.) concluding rooftop PV can reduce cooling demand and in some cases reduce UHI","date":"2014-06-04 00:00:00"},{"id":"8884e3f5-3f6c-40fb-bfb1-4a0b57f4d2b4","text":"FDA final rule: Over\u2011the\u2011counter drug products containing colloidal silver ingredients or silver salts declared not generally recognized as safe and effective.","date":"1999-08-17 00:00:00"},{"id":"9373fba0-2e0d-4d7e-96d5-8bcf4917d4e8","text":"Widespread clinical use of silver\u2011based products (e.g., nanocrystalline silver dressings like ACTICOAT) for wound care and device coatings documented in medical literature (early 2000s).","date":"2004-04-24 00:00:00"},{"id":"bf2df80d-2a61-4e41-a0d7-dc5f45bf0de5","text":"Publication of the Great Barrington Declaration advocating \'focused protection\' instead of broad restrictions","date":"2020-10-04 00:00:00"},{"id":"4f0d95da-c760-4882-b99e-b93c7996f4f7","text":"UK government\'s early \'herd immunity\' / mitigation messaging under Prime Minister Boris Johnson","date":"2020-03-16 00:00:00"},{"id":"0f190e11-1033-4f4f-bbfa-8bc82e08c298","text":"2014 ban and export\u2011freeze context (post\u2011Crimea) on Ukrainian arms sales to Russia, and related SIPRI footnotes noting many deliveries had been completed before the ban.","date":"2014-04-24 00:00:00"},{"id":"c73e787d-e802-4efc-847c-2e925026c04e","text":"Human Rights Watch reported exhumation of a mass grave in Sloviansk (eastern Ukraine).","date":"2014-07-24 00:00:00"},{"id":"c8b03c27-70ed-4cc4-abdf-0b332e2df9f5","text":"OSCE Special Monitoring Mission published observations about unmarked graves found near Komunar / Nyzhnia Krynka (Donetsk region).","date":"2014-09-24 00:00:00"},{"id":"6c536418-00e2-4a4c-830f-f6f6d96e6212","text":"Launch of the government \\"Eat Out to Help Out\\" dining subsidy scheme and public encouragement to return to restaurants (August 2020).","date":"2020-08-24 00:00:00"},{"id":"cc9da660-3aa5-478b-a33f-f2375ea97c0d","text":"Publication of the Great Barrington Declaration advocating \\"focused protection\\" and arguing against broad restrictions (4 October 2020).","date":"2020-10-24 00:00:00"},{"id":"109ca1ab-5d13-4ab6-aee4-4f2533791c9c","text":"Prime Minister Boris Johnson said the UK was \\"past the peak\\" of the outbreak in official briefings.","date":"2020-05-24 00:00:00"},{"id":"d2df8235-d61a-4ec7-bb0b-676cd6291b45","text":"Senior UK scientists publicly discussed \\"herd immunity\\" as part of early pandemic strategy (Sir Patrick Vallance interview/comments).","date":"2020-03-24 00:00:00"},{"id":"26a229b9-735a-4968-a540-4738197bdf77","text":"Stanford press release/clinical trial announcement (2010) recruiting mitochondrial\u2011disorder patients to study vaccine responses","date":"2010-10-24 00:00:00"},{"id":"f8a77d22-871c-46b3-a5cf-dc89b4e6fcf4","text":"Government concession and media coverage of the Hannah Poling VICP matter (discussed in NEJM and major outlets)","date":"2008-05-24 00:00:00"},{"id":"8e47d9e5-3537-4b6d-bc47-83cbb5ffc751","text":"Scientific American and other national outlets published explanatory pieces about the Poling case and its limits","date":"2008-04-24 00:00:00"},{"id":"c4938d22-e6a5-4ada-bc6d-52b2c6e18343","text":"1999\u20132000 public health statements recommending removal of thimerosal from some vaccines","date":"1999-07-24 00:00:00"},{"id":"25402d13-ecb6-491b-941f-43d94652249e","text":"1993 withdrawal of the MMR vaccine (Urabe AM9 mumps strain) in Japan after reports of aseptic meningitis","date":"1993-04-24 00:00:00"},{"id":"45ad507c-58bc-4146-b0bc-1acde214aa1a","text":"2010 post\u2011licensure findings of a small increased risk of febrile seizures after MMRV (leading to CDC guidance to consider separate MMR and varicella shots)","date":"2010-06-28 00:00:00"},{"id":"a364ab95-d103-44fe-9640-939150b981a0","text":"UK/academic analyses (early 2022) and UKHSA/NEJM reports showing substantially reduced vaccine effectiveness against symptomatic infection with the Omicron variant and rapid waning after two doses.","date":"2022-03-02 00:00:00"},{"id":"43e5222a-3087-4d0d-be64-dd7e1ebdc149","text":"UKHSA published the COVID-19 Vaccine Surveillance Report (Week 4) including unadjusted case rates by vaccination status that showed higher case rates in vaccinated people for some age groups.","date":"2022-01-28 00:00:00"},{"id":"93c996d4-1901-4294-800a-e38c0d1eb1c3","text":"FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine for donated supplies for hospitalized COVID\u201119 patients","date":"2020-03-28 00:00:00"},{"id":"f29ae353-3af8-40de-a699-50235d37af51","text":"EU decision to finance and supply lethal military assistance (European Peace Facility decisions, Feb\u2013Mar 2022)","date":"2022-02-27 00:00:00"},{"id":"cbc5e26f-f8e9-410f-8029-a182c58e7f57","text":"Visit of EU Commission President Ursula von der Leyen and HR/VP Josep Borrell to Kyiv","date":"2022-04-08 00:00:00"},{"id":"156ad354-9ff7-4d94-8f13-dca5079d271e","text":"Emerging reports and media coverage of myocarditis/pericarditis following mRNA COVID\u201119 vaccination (April\u2013May 2021), including Israeli surveillance data.","date":"2021-05-24 00:00:00"},{"id":"c589d99a-2705-45ba-81b4-d443003520f5","text":"Publication of Ogata et al. pilot study detecting SARS\u2011CoV\u20112 vaccine antigen (spike) in plasma of mRNA\u20111273 (Moderna) recipients.","date":"2021-05-20 00:00:00"},{"id":"2b508070-1d24-4290-aab2-515adf41a249","text":"Multiple European countries temporarily suspended use of the AstraZeneca vaccine in mid-March 2021 while authorities investigated clotting reports.","date":"2021-03-15 00:00:00"},{"id":"40bbd2b5-4d40-478f-a8e7-5b457a2b923c","text":"Office for National Statistics (ONS) Freedom of Information note and related discussion in June 2021 about deaths reported around the time of COVID-19 vaccination and the complexity of linking those deaths to vaccination.","date":"2021-06-24 00:00:00"},{"id":"ea8e2e5a-a9dd-4526-a2cd-4a0f2c009522","text":"MHRA and GOV.UK Yellow Card publications and vaccine-safety updates (May 2021) that published cumulative Yellow Card report summaries and guidance on interpreting them.","date":"2021-05-24 00:00:00"},{"id":"26917ce6-9219-482f-a419-ecda95079e6b","text":"MHRA press release (7 April 2021) concluding a possible link between the AstraZeneca COVID-19 vaccine and extremely rare blood clots (CVST with thrombocytopenia).","date":"2021-04-07 00:00:00"},{"id":"5b6f1824-6080-47bb-9bd9-545f522d2563","text":"Moderna U.S. patent US 9,587,003 (containing SEQ ID NO:11652) granted and publicly available (patent issued March 2017)","date":"2017-03-24 00:00:00"},{"id":"abfc4d83-1cae-4bb8-9238-c8a5c9338043","text":"Moderna publicly announced rapid efforts to make an mRNA vaccine for the novel coronavirus and received funding/collaboration in January 2020 (CEPI/NIH coverage)","date":"2020-01-23 00:00:00"},{"id":"bd3f8693-6a70-457b-9472-051a0ee3123a","text":"World Bank report showing uneven poverty recovery and slow household welfare rebound (2016\u20132019 analysis)","date":"2019-04-24 00:00:00"},{"id":"cc5c6626-cda2-4e18-b170-a6217c208baa","text":"Transparency International/other assessments showing persistent corruption and weak governance (CPI 2019 coverage)","date":"2020-01-23 00:00:00"},{"id":"8b090eeb-8bde-48d8-9cb9-d49beac3a162","text":"Sharp economic contraction in 2014\u20132015 after Crimea annexation and eastern conflict (World Bank reporting)","date":"None"},{"id":"48ffe91e-06f2-4568-87a2-8fff684bd1d7","text":"EU\u2013Ukraine Association Agreement (DCFTA) provisionally applied from 1 January 2016","date":"2016-01-01 00:00:00"},{"id":"04a20f10-9af8-461e-9f75-106717eddda0","text":"Statement by Crimea\u2019s chief rabbi Binyamin Volf at a November 2017 Chabad conference (badge reading \'Sevastopol, Russia\')","date":"2017-11-23 00:00:00"},{"id":"1bfed961-5720-4356-b6f4-d95c98c664e8","text":"Publicized meetings between World Jewish Congress leadership (Ronald Lauder) and Russian officials, including meetings at the Kremlin","date":"2016-04-19 00:00:00"},{"id":"e1bc5dee-6601-4bfc-b73b-ae86f55603ff","text":"2014 controversy: Ukrainian Jewish leaders criticized visits/statements by top rabbis to Crimea","date":"2014-07-23 00:00:00"},{"id":"d7f28da1-8d0b-41af-bb67-719a1bf0eec9","text":"Official communications and data about breakthrough infections and transmission by vaccinated people (e.g., CDC director statements and news coverage in early August 2021)","date":"2021-08-05 00:00:00"},{"id":"419233ba-dddf-45b5-b937-b0523f88b523","text":"Kyiv city council and local authorities publicly discussing and approving additional allocations/guarantees to cover Eurovision hosting costs","date":"2017-02-24 00:00:00"},{"id":"ed264221-5900-4c3b-a69d-1d1e819dfa15","text":"High-profile resignations from the Eurovision organising team amid disputes over transparency and finances","date":"2017-03-07 00:00:00"},{"id":"8742072b-178d-4ccf-8e74-9e3c57ed6936","text":"FDA final guidance on enforcement discretion for certain N\u2011acetyl\u2011L\u2011cysteine (NAC) products, which received industry and media attention.","date":"2022-08-01 00:00:00"},{"id":"3a53f701-0555-4825-9fb9-8eb7b3e437ef","text":"Registration/publication of randomized trial activity and small clinical studies evaluating NAC for severe COVID\u201119 (trial protocol/early trial entries 2021).","date":"2021-02-20 00:00:00"},{"id":"22c5464d-e954-45ee-870b-a2acd92f8c45","text":"CDC MMWR report of anaphylaxis after first doses of Pfizer-BioNTech COVID-19 vaccine","date":"2021-01-06 00:00:00"},{"id":"590263df-0e92-4dd7-990d-600412ace6e1","text":"CDC/ACIP recommendation and CDC endorsement for Pfizer pediatric vaccine for ages 5\u201311 (Nov 2, 2021)","date":"2021-11-02 00:00:00"},{"id":"e81f8871-f84e-4450-85d4-c8d87325236e","text":"FDA grants full approval to Pfizer\u2013BioNTech (Comirnaty) on Aug 23, 2021","date":"2021-08-23 00:00:00"},{"id":"a937e249-b4d6-4608-9a79-32283b312294","text":"HRSA/CDC guidance and public pages explaining COVID-19 vaccine injuries are handled under the Countermeasures Injury Compensation Program (CICP) rather than the National Vaccine Injury Compensation Program (VICP)","date":"2021-04-24 00:00:00"},{"id":"17c3c702-8396-4f43-ab42-57b0cf289a97","text":"April 3, 2020 CDC guidance changed to recommend cloth face coverings for the public","date":"2020-04-03 00:00:00"},{"id":"dfe43826-3357-4dfb-9662-7b175bbad4fb","text":"Russian strikes reportedly hit a radioactive\u2011waste / radioactive source facility near Kyiv in late February 2022.","date":"2022-02-24 00:00:00"},{"id":"13e1784f-2708-40cd-b623-00bac0d8e2e1","text":"EU outbreak reports and guidance showing increases in hepatitis A cases across Europe (not limited to Ukraine)","date":"2016-12-24 00:00:00"},{"id":"4ed31870-5df2-4a6f-ac03-b1ecbbd553d5","text":"Large numbers of internally displaced persons (IDPs) and documented WASH challenges in Ukraine (2014\u20132016)","date":"2016-04-24 00:00:00"},{"id":"22c9b0d7-d0b4-4cf1-950b-75d5a717ae6e","text":"IPCC Sixth Assessment Report (WG1) release summarising regional variation including land warming faster than oceans","date":"2021-08-09 00:00:00"},{"id":"2ff61d65-2058-42e1-806a-8af448124f72","text":"Pacific Northwest / Western North America extreme heat wave and record highs (June 25\u201330, 2021)","date":"2021-06-25 00:00:00"},{"id":"670ac9c1-bd3a-4135-8a85-df764f9ba9b6","text":"Arctic temperature record of +38\xb0C at Verkhoyansk (measured 20 June 2020, widely reported/confirmed later)","date":"2020-06-20 00:00:00"},{"id":"d80ca0d8-3306-445c-a9fe-e292f5a0f281","text":"IPCC AR5 Summary for Policymakers (September 2013) conclusion: \'It is extremely likely that human influence has been the dominant cause of the observed warming since the mid-20th century.\'","date":"2013-09-24 00:00:00"},{"id":"621d1a29-309b-45ac-820e-e5b6c27b4f53","text":"Media reports and clips referenced proposals to replace universal subsidies with targeted assistance (compared by some reports to \'food-stamp\' style programs)","date":"2017-08-24 00:00:00"},{"id":"614de7a2-fe04-47d7-99a2-bd83572fe921","text":"Analyses and reports documenting that Ukraine was used as a transit or logistical route by foreign fighters bound for Syria/Iraq (The Soufan Group foreign fighters updates, 2014\u20132015)","date":"2015-09-24 00:00:00"},{"id":"1909b66d-439b-4cf2-9305-d96c12a1f137","text":"European Parliament/public sources flagged presence of foreign Islamist volunteers or sympathizers in eastern Ukrainian conflict zones (July 2015 references to press reporting)","date":"2015-07-27 00:00:00"},{"id":"02748681-3f84-4280-a169-627e0e591319","text":"Ukrainian Security Service (SBU) detained and expelled several foreign nationals described as Islamic State supporters (SBU press reports)","date":"2016-04-27 00:00:00"},{"id":"9a3741b7-9194-44e7-8593-dd9623d85773","text":"Crimean official Ruslan Balbek publicly claimed there are ISIS training camps in Kherson (southern Ukraine)","date":"2016-07-24 00:00:00"},{"id":"0600aa2c-a25e-46f1-9217-9073c7c4a8c2","text":"US decision to withdraw troops from northern Syria (announced early October 2019) and the ensuing Turkish incursion drew rapid regional and global attention","date":"2019-10-06 00:00:00"},{"id":"dfa1261d-e732-4e6a-98fb-661c11837d82","text":"US impeachment inquiry into President Trump after the Ukraine whistleblower shifted US political and media attention away from foreign-policy issues such as Crimea","date":"2019-09-24 00:00:00"},{"id":"785426c5-8fb1-49d8-96d3-ca5cc2e642fb","text":"UK prorogation (suspension) of Parliament by Prime Minister Boris Johnson and the constitutional crisis around it in late August\u2013September 2019","date":"2019-08-28 00:00:00"},{"id":"f17c6a8e-99aa-4004-b2f7-bddcb8a8cf3c","text":"Public arrival and frontline deployment of US-supplied HIMARS in Ukraine was widely reported (first systems arrived in late June 2022).","date":"2022-06-23 00:00:00"},{"id":"76dd6ad1-96b1-4e31-af7e-dc4f3e810a68","text":"Russian Ministry of Defence later claimed it had destroyed four HIMARS launchers between July 5\u201320, 2022.","date":"2022-07-22 00:00:00"},{"id":"2bdc17db-1fc4-4641-83a8-1df42a5bc5f5","text":"WHO SAGE identifies vaccine hesitancy and misinformation as major threats (working group/report)","date":"2014-04-24 00:00:00"},{"id":"e401473b-9e1d-4fef-bad6-dcf3195d6dd1","text":"IARC classification of formaldehyde as \u2018carcinogenic to humans\u2019 (Group 1)","date":"2004-06-24 00:00:00"},{"id":"227d7b44-4791-4e82-aca0-1a384e087533","text":"1999 US Public Health Service and American Academy of Pediatrics recommend removal of thimerosal from many childhood vaccines as a precaution","date":"1999-04-24 00:00:00"},{"id":"d27443a0-c153-4dd5-a58f-873c1c8c288c","text":"UN/UNICEF warning that tens or hundreds of thousands of children in eastern Ukraine are threatened by landmines and explosive remnants of war","date":"2017-12-21 00:00:00"},{"id":"81465d6c-17c2-4277-a0cb-89b8c3188ee1","text":"Mine Action Review report \'Clearing the Mines 2017\' documents extensive contamination and cites OHCHR findings that Ukrainian armed forces and armed groups continued to lay landmines (including antipersonnel types) during 2016","date":"2017-04-24 00:00:00"},{"id":"0e030dbe-883c-45fb-aeb4-a79d3e1efada","text":"Bellingcat investigation & reporting on risks in Donbas (\'Donbas: A Ticking Toxic Time Bomb\') highlighting flooded and unmanaged minefields and environmental hazards in former coal-mining areas","date":"2017-03-30 00:00:00"},{"id":"5c4a33d0-ae11-4848-ab7f-92b7f6656e0e","text":"Minsk II text included provisions on decentralization / \'special status\' for Donbas that Poroshenko accepted to negotiate.","date":"2015-02-12 00:00:00"},{"id":"dc91dcdc-d82f-4f28-9d6e-a9132909f1b2","text":"Poroshenko announced a unilateral ceasefire (June 2014) and subsequent pauses/cessations of offensive actions.","date":"2014-06-20 00:00:00"},{"id":"fd99e615-cd03-41e8-ba27-8d4905da0e07","text":"Poroshenko and Putin met and were photographed/filmed together at international talks (including February 2015 Minsk meetings and earlier encounters such as the June 2014 D-Day meeting).","date":"None"},{"id":"0e2d0038-14e7-4b49-8a47-5d83cae03712","text":"Japan reports and temporary pauses after discovery of foreign/black particles in some Moderna vaccine vials","date":"2021-09-17 00:00:00"},{"id":"2ab59778-fd56-4c7e-a5a0-f41cd08542da","text":"CDC/ACIP public acknowledgement and MMWR report of increased myocarditis cases after mRNA COVID-19 vaccination","date":"2021-07-24 00:00:00"},{"id":"f78b6f97-84ba-4753-817e-24578857cf09","text":"Court dispute and media coverage over FDA\u2019s proposed slow timetable and subsequent judge\u2019s order to accelerate release of Pfizer vaccine documents","date":"2022-01-07 00:00:00"},{"id":"c373bead-d3a8-4bc7-a62f-cb894eb1cb73","text":"CDC Health Advisory and public warnings (late August 2021) about a sharp rise in ivermectin misuse, poisonings, and related emergency visits.","date":"2021-08-26 00:00:00"},{"id":"fabedc29-2132-4d32-a570-e39a997b3674","text":"OSCE armoured vehicle damaged by an explosion near Pryshyb (one monitor killed, two wounded)","date":"2017-04-23 00:00:00"},{"id":"e55109e1-cff9-4fb1-9079-03557de996f5","text":"Publication of the Harvard Pilgrim (ESP:VAERS) final report (AHRQ grant) finding that automated surveillance suggested many adverse events were not reported to passive VAERS.","date":"2011-04-24 00:00:00"},{"id":"ce012d51-5eb4-4a33-978b-a45c1c33b648","text":"Congressional/public pressure: Rep. Bill Posey\u2019s 2019 public questioning (and associated media coverage) that highlighted the multi\u2011billion dollar VICP figure and prompted scrutiny/discussion online.","date":"2019-10-24 00:00:00"},{"id":"2a3da052-2cc1-451a-ad49-b30e48ed2235","text":"OSCE SMM observed heavy weapons and armoured vehicles in violation of withdrawal lines (e.g., tanks near Avdiivka; a surface\u2011to\u2011air missile system near Hannivka) during the late\u2011January 2017 escalation.","date":"2017-01-29 00:00:00"},{"id":"beaa5346-30a8-4eec-8020-92b8e46b9061","text":"Ukrainian authorities declared a state of emergency in Avdiivka and organised evacuations as civilians were left without power, heating and water following the shelling.","date":"2017-01-31 00:00:00"},{"id":"e5df66d3-79dd-4a90-b930-61f103dd1f7c","text":"Multiple news outlets and local reporting documented both Ukrainian forces and pro\u2011Russian separatists accusing each other of initiating the offensive around the Avdiivka \'industrial zone\' (Almaz\u20112) and making competing claims of tactical gains.","date":"2017-01-31 00:00:00"},{"id":"58c36d61-3ba0-41e4-8f19-73255bc7b115","text":"Peer\u2011reviewed research and industry reports documented that Liquidambar (sweetgum) seedpods contain measurable shikimic acid and could be an alternative feedstock for industrial extraction (published research e.g., Appl Biochem Biotechnol, Epub May 27, 2010).","date":"2010-05-27 00:00:00"},{"id":"8f73c558-2be2-48cc-a73f-d9f7424080ad","text":"Mainstream coverage during flu/Tamiflu shortages (2005) highlighted that shikimic acid\u2014traditionally sourced from star anise\u2014was a critical precursor for manufacturing Tamiflu, prompting searches for alternative natural sources.","date":"2005-10-21 00:00:00"},{"id":"aa16c46d-0852-4634-a054-79960c11b758","text":"Zozulya was included in Ukraine\'s squad for the March 24, 2017 Croatia qualifier but did not play in the match.","date":"2017-03-24 00:00:00"},{"id":"4c1758ec-337d-4cbe-86fa-8244d71c7d7e","text":"Rayo Vallecano fans publicly protested and the club cancelled Zozulya\'s loan from Real Betis after accusations he had neo\u2011Nazi links.","date":"2017-02-01 00:00:00"},{"id":"7c17e2ac-c892-4e72-866b-714bec4a49a2","text":"Rapid Trident 2021 multinational land exercise in Ukraine (\u22486,000 personnel) with explicit COVID-19 mitigation measures","date":"2021-09-20 00:00:00"},{"id":"c6852aab-9969-47b4-b03d-a5a8020adfe1","text":"Sea Breeze 2021 multinational maritime exercise in the Black Sea (June\u2013July 2021) involving thousands of personnel, ships and aircraft","date":"None"},{"id":"b18bf41c-46b5-457c-a9b4-f8ac07e36180","text":"High-profile military COVID-19 outbreak: USS Theodore Roosevelt outbreak and ship quarantine (April 2020)","date":"2020-04-24 00:00:00"},{"id":"7fffa540-df86-4301-9664-fe0107c83f3a","text":"Post\u2011invasion \'derussification\' actions, including Kyiv renaming nearly 100 streets and removing Soviet/Russian monuments as part of wider cultural de\u2011Russification.","date":"2022-08-25 00:00:00"},{"id":"29d4087d-19b7-4267-bf79-8789d90e480a","text":"Kyiv City Council imposed a moratorium on the public use of Russian\u2011language cultural products (books, songs, films, theatrical works) in the capital.","date":"2023-07-13 00:00:00"},{"id":"73dadb3d-04c0-4928-8c72-5c56df523380","text":"Verkhovna Rada adopted the 2019 law \'On ensuring the functioning of Ukrainian as the state language\' strengthening use of Ukrainian in public life.","date":"2019-04-25 00:00:00"},{"id":"59013a8a-02c8-478e-9214-3f1e44cc7bb8","text":"President Zelensky imposed sanctions and broadcasting suspensions on three pro\u2011Russian TV channels (112 Ukraine, NewsOne, ZIK).","date":"2021-02-02 00:00:00"},{"id":"107d359d-42ec-4e77-8d57-506e01d2d46a","text":"Major criminal/civil enforcement actions against drugmakers for improper marketing (example: Novartis pleads guilty and agrees to pay $422.5M for off\u2011label marketing, Oct 2010)","date":"2010-10-24 00:00:00"},{"id":"0f501262-611a-4a6e-9a89-2f9d95963b85","text":"Publication of DSM\u20115 (May 2013) which changed ADHD diagnostic criteria (e.g., raising the age of onset criterion from 7 to 12 and adjusting symptom thresholds)","date":"2013-05-24 00:00:00"},{"id":"d0f5121a-6a67-4dd9-b3f3-d97ff6bc7c84","text":"Itaja\xed city government announcement and distribution program for ivermectin (mayor/prefeitura public rollout)","date":"2020-07-24 00:00:00"},{"id":"0fc29109-1260-4ee9-acd9-5213faa70a4f","text":"Itaja\xed municipal health department \'Nota de esclarecimento - tratamentos profil\xe1ticos\' (clarification note) revealing rapid drop-off in adherence to the distributed ivermectin regimen","date":"2021-01-21 00:00:00"},{"id":"0210aeca-dbc0-42c3-8104-a3c02981d594","text":"July 5, 2021 media reports (based on Israeli data) that Pfizer vaccine protection against infection had declined amid Delta variant spread, while still protecting strongly against severe disease.","date":"2021-07-05 00:00:00"},{"id":"84bdb65b-0a10-4d48-b2bb-f78fad599d25","text":"Sept 24, 2021 CDC/FDA authorizations and public communications expanding booster recommendations while acknowledging breakthrough infections and waning immunity.","date":"2021-09-24 00:00:00"},{"id":"96bab82b-1f4e-4ec3-85c9-55062690b2a1","text":"March 19, 2020 livestream interview where Fauci discussed antibody-dependent enhancement (ADE) as a theoretical vaccine safety concern during early COVID-19 vaccine development.","date":"2020-03-19 00:00:00"},{"id":"e18fbea4-d7f2-4a5f-99f5-217aa876360e","text":"Earlier documented exhumations/mass\u2011grave discoveries in Donbas (Sloviansk mass grave exhumed)","date":"2014-07-24 00:00:00"},{"id":"345b3179-253e-469f-89aa-87e71b1ea471","text":"Visible cemetery work (small tractor stuck in mud and manual removal of soil) at the Sumy cemetery","date":"2015-11-24 00:00:00"},{"id":"07b997fc-953c-401c-920f-f2dc1d0271e3","text":"Publication of a 2017 pilot study showing short\u2011term tinnitus reduction after intranasal oxytocin (peer\u2011reviewed)","date":"2017-09-21 00:00:00"},{"id":"b9810a46-1616-44e1-9b2b-e9684548ec05","text":"FDA clearance and media coverage in 2023 of Lenire (a novel device for treating tinnitus), elevating public interest in new tinnitus treatments","date":"2023-03-24 00:00:00"},{"id":"f2e7cf6a-6482-4f9b-a2c8-98e89811400c","text":"Surge of TikTok posts and hashtag activity (#tinnitushelp) in early\u2013mid 2024 promoting quick fixes, including nasal sprays/inhalers","date":"2024-05-24 00:00:00"},{"id":"cbac83c2-8c95-46bd-a630-356ea7d83495","text":"Public availability of Phytonadione (vitamin K) package insert listing polysorbate 80 (DailyMed / FDA label; label file updated Jan 19, 2017).","date":"2017-01-19 00:00:00"},{"id":"f2812f10-9f02-449c-be8a-d14b8f7f31b0","text":"IPCC Sixth Assessment WG1 (AR6) press release and summary (August 2021) asserting that human influence has unequivocally warmed the climate system.","date":"2021-08-09 00:00:00"},{"id":"1e3a38df-684e-48e2-a62e-3b767bade3aa","text":"Nature Geoscience and related studies (circa 2017) reporting large uncertainties about whether airborne mineral dust from deserts has a net warming or cooling radiative effect.","date":"2017-01-24 00:00:00"},{"id":"bd09c03f-ffcf-424d-b8b2-a9067f24572f","text":"Zhu et al. (2016) \'Greening of the Earth and its drivers\' (Nature Climate Change) documenting global increases in vegetation, including expansion in some dry regions, largely attributed to CO2 fertilization and land-use changes.","date":"2016-09-24 00:00:00"},{"id":"9ea7be29-7ac0-4db4-a44a-77f7e1b4a49d","text":"NASA/MODIS public data and Earth Observatory coverage showing deserts as among the highest-reflectivity (high albedo) land surfaces.","date":"2002-07-10 00:00:00"},{"id":"0b66de36-7adf-46d0-b0d8-a3e6ddacc929","text":"2017 peer-reviewed modelling studies and simulations proposing desert-focused geoengineering or land-surface modification (e.g., irrigating deserts or increasing desert albedo) to alter global/regional climate.","date":"2017-08-24 00:00:00"},{"id":"75f3a1a3-be94-48ab-a200-75e258aa57cb","text":"April 2017 reporting of new research (covered by AIDSMap) about long-term nitrate inhalant exposure and cancer risk that noted elevated cancer signals in some subgroups.","date":"2017-04-24 00:00:00"},{"id":"bc2852f1-4c0d-4924-a3e8-de82d6d55f58","text":"June 1994 coverage and activism (New York Native / related reports) documenting calls for research into a poppers\u2013Kaposi\'s sarcoma connection (NIDA-era attention to the hypothesis).","date":"1994-06-24 00:00:00"},{"id":"a5c174fb-00f8-4888-bff2-2b22c08b6bb2","text":"Russian Ministry of Defense announced first operational use of the Kh-47M2 \'Kinzhal\' hypersonic missile, claiming it destroyed an underground Ukrainian ammunition depot in Delyatyn.","date":"2022-03-18 00:00:00"},{"id":"1ab30c76-9d70-45bb-a0c9-9ba89ab29490","text":"President Joe Biden publicly acknowledged Russia\'s use of hypersonic missiles, saying the weapon was \\"a consequential weapon... almost impossible to stop,\\" as reported by news outlets in mid\u2011late March 2022.","date":"2022-03-21 00:00:00"},{"id":"6d3e772d-df2c-41fc-95f9-6ee4c1785af0","text":"Publication showing vaccine\u2011derived spike antigen detectable in plasma after mRNA vaccination (Ogata et al., Clinical Infectious Diseases)","date":"2021-09-24 00:00:00"},{"id":"0b394128-bfde-44cf-9e64-cb31e8b2af0d","text":"Publication of an in vitro study showing nattokinase degrades SARS\u2011CoV\u20112 spike protein (Tanikawa et al., Molecules)","date":"2022-08-24 00:00:00"},{"id":"eb90c2b0-f999-48b8-a156-260fc24dc989","text":"Publication reporting persistence of SARS\u2011CoV\u20112 S1 protein in CD16+ monocytes up to 15 months in PASC patients (Patterson et al., Frontiers in Immunology)","date":"2022-01-10 00:00:00"},{"id":"438d9319-2731-4376-8c2d-4a97f1f00888","text":"Judge Mark Pittman ordered the FDA to accelerate public release of Pfizer vaccine trial documents (court order reported Jan 7, 2022)","date":"2022-01-07 00:00:00"},{"id":"b93daa23-81e7-456d-94d1-02ee6cb323d7","text":"Public availability of large troves of Pfizer documents via the PHMPT/FOIA process (public repository of Pfizer documents made accessible in 2022)","date":"None"},{"id":"6b5be610-f1fa-4824-913d-7a70777884de","text":"UN General Assembly Resolution 68/262 reaffirming Ukraine\'s territorial integrity","date":"2014-03-27 00:00:00"},{"id":"aec2046c-231c-4694-b2e3-e33c096f3bbd","text":"Ukrainian government regains control of Mariupol (June 2014)","date":"2014-06-13 00:00:00"},{"id":"b275260a-c1dc-4478-979c-ce4b9174a3ee","text":"Ukrainian forces retake Sloviansk and Kramatorsk from pro\u2011Russian separatists","date":"2014-07-05 00:00:00"},{"id":"93c43d4a-fd19-4e65-988b-70a133b08499","text":"Minsk II ceasefire agreement and delineation of frontlines (February 2015)","date":"2015-02-12 00:00:00"},{"id":"66aeb4da-a41f-4447-b443-d3adc2c80766","text":"OSCE SMM: patrol vehicles and civilians hit by fire in eastern Ukraine (multiple incidents, Sept 2014 example)","date":"2014-09-15 00:00:00"},{"id":"a30a7def-f57c-446a-bba8-1523343fe253","text":"Amnesty International reporting on indiscriminate attacks and civilian deaths in Donbas","date":"2015-02-24 00:00:00"},{"id":"43190cf0-9e6b-4ae2-a7b4-2194945580eb","text":"Human Rights Watch report: unguided Grad rockets killed civilians in Donetsk suburbs","date":"2014-07-24 00:00:00"},{"id":"9f5d5685-ecd4-4a38-8303-f36d9c747912","text":"Volnovakha bus attack \u2014 passenger bus hit near checkpoint, 12 killed","date":"2015-01-13 00:00:00"},{"id":"2c93e391-b1d7-4f0f-b9a7-0f1628f74cb9","text":"Energoatom presents national report at the IAEA General Conference noting diversification of fuel supply and construction of centralized spent fuel storage (IAEA General Conference coverage)","date":"2018-09-18 00:00:00"},{"id":"140e89c6-1a07-409a-ab9a-52ec6b34998a","text":"Country profile and industry analyses documenting Ukraine\u2019s historical reliance on Russian fuel-cycle services (conversion/enrichment) and stated efforts to diversify suppliers","date":"2018-04-24 00:00:00"},{"id":"5d33b07c-4552-4834-89af-6820b593c9ef","text":"Japan suspended ~1.63 million Moderna vaccine doses after reports of contamination in vials","date":"2021-08-25 00:00:00"},{"id":"e5f0ac30-4bfe-4c41-80d1-ce405df9e260","text":"Norwegian Medicines Agency investigated deaths of frail elderly occurring shortly after Pfizer vaccination","date":"2021-01-18 00:00:00"},{"id":"b16aee51-f02c-4b7a-971e-f64d6361f22d","text":"CDC/ACIP acknowledged increased reports of myocarditis following mRNA COVID-19 vaccination","date":"2021-06-23 00:00:00"},{"id":"22edd4f8-a427-4083-982e-d2c4008dda92","text":"NOAA/NASA Solar Cycle 25 Prediction Panel preliminary forecast released","date":"2019-04-05 00:00:00"},{"id":"318a1f17-6477-4696-9106-44c6cafb8309","text":"Publication of randomized trial (Cowling et al.) reporting increased non-influenza respiratory infections in children after inactivated seasonal influenza vaccine","date":"2012-03-24 00:00:00"},{"id":"ddfa596f-da0f-4830-a839-c04542e52164","text":"NATO Readiness Action Plan (RAP) launched after Russia\'s 2014 actions","date":"2014-09-24 00:00:00"},{"id":"34d32d01-b9da-4558-aca2-018ef1620429","text":"Public statements by NATO Secretary General Jens Stoltenberg in June 2022 urging preparation for a \'long haul\'","date":"2022-06-19 00:00:00"},{"id":"a6c3e47d-8078-4640-ae31-397e6e88ebd5","text":"Decision to deploy NATO enhanced Forward Presence (eFP) battlegroups to the Baltic states and Poland","date":"2017-03-24 00:00:00"},{"id":"0afadd85-4bc8-422d-95a9-0f0b99baaff2","text":"Large NATO exercise Trident Juncture (2018) held near NATO\'s northern flank","date":"None"},{"id":"865c7c98-d8e0-4383-b0a6-ccf0a86c51e9","text":"Reporting in June 2018 that Crimea was expected to see a major tourism surge for summer 2018 while airlines cut flights\u2014intense media focus on the 2018 tourist season.","date":"2018-06-04 00:00:00"},{"id":"17ca6691-ccb7-40b4-b9a6-7145b0127e0f","text":"\u2018Day of Crimean Resistance\u2019 and related pro-Crimea/anti-occupation rallies and activism in Kyiv (26 February 2018 demonstrations of Kyiv-based support for Crimean Tatars and Ukrainian claims on Crimea).","date":"2018-02-26 00:00:00"},{"id":"d8ca6006-36e6-45ea-8307-1deb0c49b00d","text":"Trial/indictment proceedings in April 2018 against Yevhen (Evgenii) Panov, accused by Russian/Crimean authorities of preparing sabotage in Crimea.","date":"2018-04-16 00:00:00"},{"id":"d815205f-8cc2-4afb-aa3c-c0e6d70f107a","text":"Opening of the Kerch (Crimean) Bridge by President Putin, a high-profile infrastructure and tourist-access milestone for Crimea.","date":"2018-05-15 00:00:00"},{"id":"78221e24-b79b-43e4-a541-ad1ca0076618","text":"Prime Minister\'s housing/cost-of-living speech emphasizing domestic agenda","date":"2022-06-09 00:00:00"},{"id":"0d304d53-0699-4bac-bf54-d0c96ac245cb","text":"Conservative Party confidence vote in Boris Johnson\'s leadership","date":"2022-06-06 00:00:00"},{"id":"4abe3741-e47a-4a37-bca4-d5f10b6ed2cb","text":"Prime Minister issued a fixed penalty notice in the \'Partygate\' inquiry","date":"2022-04-12 00:00:00"},{"id":"5b97d9af-c5cd-4efc-9502-6bf1fabde9d7","text":"Surprise visit to Kyiv and public walk with President Zelensky","date":"2022-04-09 00:00:00"},{"id":"853c041e-9df3-4b29-a61e-74c8772e02d6","text":"NOAA PMEL published guidance \'Quality of pH Measurements in the NODC Data Archives\' explaining that many pre\u20111990 seawater pH measurements have large, poorly documented uncertainties and that consistent, high\u2011quality pH detection has only been possible since the 1990s.","date":"2013-04-24 00:00:00"},{"id":"ac495448-6773-45ff-afe1-a285915c6f3f","text":"Release/public availability of the World Ocean Database (WOD) 2013, which aggregated historic in\u2011situ ocean profiles (including pH) but documented large metadata gaps and methodological inconsistencies in older records.","date":"2013-04-24 00:00:00"},{"id":"f23f41f3-49f6-4043-a4d4-56791c2a1d06","text":"Small 2018 pilot study published in the Journal of Alzheimer\'s Disease reported cognitive improvements after a coconut oil\u2011enriched Mediterranean diet in a limited sample of Alzheimer\'s patients.","date":"2018-07-20 00:00:00"},{"id":"867498bb-0930-48be-8ea7-2ed4335eaca6","text":"Health Canada and other national bodies issued advisories/removals in spring 2021 concerning graphene\u2011coated face masks (potential inhalation risk), and some jurisdictions pulled graphene\u2011containing masks from distribution.","date":"2021-04-02 00:00:00"},{"id":"984b86ec-b655-469a-9772-7d7780484415","text":"Published scientific literature and reviews (pre\u20112021) described graphene oxide\'s biomedical research applications and its use in nanomaterials and delivery systems.","date":"2012-04-24 00:00:00"},{"id":"725c1c14-9fcd-4f5c-95e1-9590c9ef59d7","text":"WHO SAGE \'Roadmap for Prioritizing Uses of COVID-19 Vaccines\' (draft) updated 29 June 2021 emphasizing prioritization of high\u2011risk groups and limited vaccine supply.","date":"2021-06-29 00:00:00"},{"id":"cf29b817-5617-4b44-aa05-a0df376f7442","text":"Regulatory approvals in some countries for adolescent vaccination (Pfizer authorization/recommendation for ages 12\u201315 in May 2021) created divergent national vs. WHO messaging.","date":"2021-05-12 00:00:00"},{"id":"dcfb1112-c28a-4939-9d66-40a5f9e67ec2","text":"Ukrainian forces recaptured the television tower in Slovyansk (reported May 5, 2014)","date":"2014-05-05 00:00:00"},{"id":"23e62940-8b17-4720-ba2a-14719f390727","text":"Widespread photo galleries and agency images of pro\u2011Russian flag\u2011raising in Donetsk (e.g., BBC gallery, April 2014)","date":"2014-04-07 00:00:00"},{"id":"84d42f5b-d166-48df-94a7-ca07834d7629","text":"The World Health Organization told Reuters (March 11, 2022) it had advised Ukraine to destroy high\u2011risk pathogens in public health laboratories to prevent any potential spills amid the Russian invasion.","date":"2022-03-11 00:00:00"},{"id":"9232d564-a2b3-4587-a80d-ae2a5dc0f7ec","text":"Hawaii state law (SB2571/Act 104) banning sale of sunscreens containing oxybenzone and octinoxate (effective Jan 1, 2021).","date":"2018-05-24 00:00:00"},{"id":"60f2f09a-e48e-4b26-a07a-ce54f4efb8be","text":"Nambour randomized trial follow-up reporting reduced melanoma incidence with regular sunscreen use (long-term follow-up published 2011).","date":"2011-03-24 00:00:00"},{"id":"ceb0101b-f929-4ecd-b350-8037db80fcf6","text":"Clinical research linking low serum 25-hydroxyvitamin D levels with worse melanoma prognosis (ASCO/JCO abstracts and peer-reviewed studies published across 2014\u20132021).","date":"2014-04-24 00:00:00"},{"id":"dc455af0-4a77-4516-95aa-318963561a03","text":"Poroshenko\'s annual address to parliament included the line that retaking Crimea by force was \'realisticly \u2014 no\' (statement made in context of legal/diplomatic strategy).","date":"2017-09-07 00:00:00"},{"id":"6fa349ee-fdaf-4995-9580-28548d92c92a","text":"UKHSA/other national surveillance dashboards showing age breakdowns of respiratory\u2011virus hospital admission rates (including infants) during 2022\u20132024 seasons","date":"None"},{"id":"4067786c-a9a9-4504-ae37-8f00d85fa380","text":"\u2018Self-determination for Zakarpattia\u2019 rally held near Ukraine\'s embassy in Budapest (Oct 13, 2017)","date":"2017-10-13 00:00:00"},{"id":"cf7e4df3-4d73-45a5-a65a-42d1a2a5caf3","text":"OSW analysis: \'Zakarpattia \u2013 together, but separated\' noting low mobilisation and governance problems (Sept 30, 2015)","date":"2015-09-30 00:00:00"},{"id":"b57e910d-73c4-4c97-91e3-7dd5f2fb6804","text":"Armed shootout in Mukachevo (July 11, 2015)","date":"2015-07-11 00:00:00"},{"id":"5c549537-68db-436e-b803-7f7040d989fb","text":"Ukraine\'s 2017 education law and ensuing Hungarian protests (Oct 2017)","date":"2017-10-05 00:00:00"},{"id":"eabf220b-ccb7-4d7f-8222-41a150002c94","text":"OSCE Special Monitoring Mission statements and reports documenting detentions, restricted access and impediments to monitors in Donbas (e.g., SMM updates 21 June 2017)","date":"2017-06-21 00:00:00"},{"id":"e75a2f44-5442-4d31-b8fe-35119a74d3c6","text":"Attack on an OSCE SMM patrol in Yasynuvata where armed men engaged/attacked monitors (reported June 20\u201321, 2017)","date":"2017-06-21 00:00:00"},{"id":"cf0e1b85-b67a-4948-92f4-77b2300f4602","text":"Large-scale arrival and public statistics on Ukrainian refugees in France (UNHCR/France reports, early 2023)","date":"None"},{"id":"8756e902-2bbc-4510-8db0-127a384594ef","text":"Widespread France riots after the police shooting of teenager Nahel Merzouk that generated intense domestic and international attention","date":"None"},{"id":"9867fa2f-2d7f-4fe9-819f-6b125733fd08","text":"Local population in Zakarpattia (Transcarpathia) increasingly sought Hungarian citizenship and cross-border permits, highlighting strong economic and social ties with Hungary.","date":"2016-10-20 00:00:00"},{"id":"1ba67de0-3a50-4fd0-8935-215e201931da","text":"2015 Mukacheve armed clash (July 11, 2015) between local gunmen, police and paramilitary-linked groups over control of smuggling routes.","date":"2015-07-11 00:00:00"},{"id":"ae54faf8-0a6a-4db8-b437-7710c0bce29c","text":"Analyses and commentary (2015) documenting Zakarpattia\'s long\u2011standing cross\u2011border economic orientation and weak integration with central Kyiv policies.","date":"2015-09-30 00:00:00"},{"id":"2282d388-5b26-4bde-89a8-b928c9b17599","text":"OSCE Special Monitoring Mission (SMM) reporting in October 2020 documented multiple explosions and frequent ceasefire violations in Donetsk and Luhansk regions, with restricted access to some non\u2011government\u2011controlled areas.","date":"2020-10-05 00:00:00"},{"id":"d71b1d68-136b-401e-9be7-e317457e7d72","text":"Prior deadly Molot mortar accident at the Rivne training ground (Molot M120-15) prompted government tests and probes after a mortar blast that killed multiple service members.","date":"2018-07-06 00:00:00"},{"id":"7296af18-7182-4ad9-8e86-af7045ab2218","text":"VAERS reports of fetal loss increased in the 2009\u20132010 season and were summarized in a 2011 review of reports after H1N1 vaccination (Moro et al.)","date":"2011-04-24 00:00:00"},{"id":"18a11fb1-e4fe-4210-932f-b340cea2b154","text":"Authoritative guidance that VAERS is a passive reporting system and cannot be used alone to establish causation","date":"2012-04-24 00:00:00"},{"id":"bffa392d-838c-48bc-ab7d-e67e0f896155","text":"UN reports sharp rise in people fleeing eastern Ukraine to Rostov region, with tent camps and thousands accommodated","date":"2014-06-24 00:00:00"},{"id":"58c4f36a-d1e0-4676-a897-c83e02e84a19","text":"Well-documented historical use of \'filtration camps\' during the Chechnya wars (Human Rights Watch and Amnesty reporting from 2000)","date":"2000-04-24 00:00:00"},{"id":"9186ed71-5a4c-44b5-8c29-b644072d50f3","text":"Hungary and minority-rights actors publicly criticise the law and warn of harm to minority languages, prompting diplomatic pushback","date":"2019-04-29 00:00:00"},{"id":"3856ade0-91e1-463b-a8b0-c5a4515d31da","text":"Ukraine\'s Constitutional Court had recently struck down the 2012 Kivalov\u2013Kolesnichenko language law (decision of 28 February 2018)","date":"2018-02-28 00:00:00"},{"id":"bff99471-7e87-4f04-849c-7b2510eeda27","text":"Verkhovna Rada adopts the Law on Ensuring the Functioning of Ukrainian as the State Language","date":"2019-04-25 00:00:00"},{"id":"139677d6-2d70-4fca-9c76-d69fae62656b","text":"Media and analysts report the law requires Ukrainian in public sector, raises media quotas and tightens administrative penalties","date":"2019-04-25 00:00:00"},{"id":"e70794c7-1f61-4fa1-a956-d58bf8a67c02","text":"OSCE SMM daily reports in November 2019 documenting renewed ceasefire violations, weapons and troop movements near the contact line","date":"2019-11-14 00:00:00"},{"id":"5424fdea-3641-4e72-9221-e09f60ee8186","text":"Sea Breeze multinational military exercises in Ukraine (Sea Breeze 2019) involving NATO partners","date":"2019-07-01 00:00:00"},{"id":"5e1c916f-f839-4e2c-a1ac-1876dcaa95a0","text":"Verkhovna Rada adopts the Donbas \'reintegration\' law (commonly cited as ending Minsk framework)","date":"2018-01-18 00:00:00"},{"id":"900a8533-a169-4295-9576-1e08839a4aaf","text":"Public statements by President Volodymyr Zelensky and senior Ukrainian officials in mid\u20112019 expressing scepticism about Minsk (describing Minsk as a \'trap\' or calling for its overhaul)","date":"2019-06-24 00:00:00"},{"id":"a9161d70-4ab9-4fae-b953-1445e2713d7a","text":"Ukraine replaces the ATO with the Joint Forces Operation (JFO), moving military command and framing a more overt military response in Donbas","date":"2018-04-30 00:00:00"},{"id":"5749d3e4-6c81-44c4-8809-9f9327c7ebab","text":"Growing public and political debate within the U.S. GOP over further Ukraine aid in 2023\u2013early 2024, including prominent Republican calls to reduce or stop funding.","date":"2023-09-29 00:00:00"},{"id":"7af08beb-2910-4d2e-b488-0b5b72ab8c52","text":"Pope Francis placed public phone calls with President Volodymyr Zelensky shortly after Russia\'s full\u2011scale invasion (first reported 26 February 2022).","date":"2022-02-26 00:00:00"},{"id":"5f879db0-e8d7-4968-9b39-fb32fb26105d","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan and subsequent batch suspensions","date":"2021-09-24 00:00:00"},{"id":"6006ac32-7f50-414e-8a5f-bce4e8739ce9","text":"Legal filings and public petitions by the de Garay family and allied lawyers seeking Pfizer/FDA records about the 12\u201315 trial (documents and filings posted May 2023).","date":"2023-05-24 00:00:00"},{"id":"ae1ed688-55ec-443e-bf2e-95bb6b115680","text":"Several countries temporarily paused use of the AstraZeneca COVID-19 vaccine in March 2021 amid reports of rare blood-clot events; EMA and national agencies investigated and later issued conclusions balancing risks and benefits.","date":"2021-03-24 00:00:00"},{"id":"6ead3dde-bdab-43c9-b276-6f067caec9ef","text":"Norwegian health authorities reviewed several deaths of very frail, elderly nursing-home residents that occurred shortly after Pfizer\u2013BioNTech vaccination and issued more cautious guidance on vaccinating the most frail.","date":"2021-01-24 00:00:00"},{"id":"e23f167a-c7f0-425f-865f-377dfe1354a6","text":"CDC/NCHS published \'Guidance for Certifying Deaths Due to Coronavirus Disease 2019 (COVID-19)\' (NCHS Alert/Guidance allowing COVID-19 to be reported as probable or presumed when appropriate, not always requiring a positive lab test).","date":"2020-04-24 00:00:00"},{"id":"6b180a9c-1f42-41b4-9631-3cb6b8085d98","text":"Public Health England (PHE)/UK consolidated COVID death reporting to \'deaths within 28 days of a positive test\' (clarifying that different measures exist between PHE daily counts and ONS death-certificate-based counts).","date":"2020-08-24 00:00:00"},{"id":"d14997d7-7c3d-4360-85e9-3ab9ca2bdbc7","text":"UN/OHCHR and other international monitors reported a deterioration in human rights in eastern Ukraine during 2014, noting cases of torture, abduction and some incidents of sexual abuse","date":"2014-05-24 00:00:00"},{"id":"4218b537-7ace-44d1-98d2-9405a2047fff","text":"CDC guidance and longstanding vaccine-safety literature noting that fainting (syncope) can occur after injections and is often related to pain or anxiety rather than the vaccine itself.","date":"None"},{"id":"0ef8f617-1413-471f-9bef-929108ce8656","text":"President Zelensky announces creation of an International Legion / call for foreign volunteers","date":"2022-02-27 00:00:00"},{"id":"e948ea83-3f58-40b5-94af-f58552982c89","text":"2022 general mobilisation decree in Ukraine","date":"2022-02-24 00:00:00"},{"id":"aaaa23bf-b2ea-43c1-ab2a-85111934b433","text":"CDC/NCHS released provisional COVID-19 death counts and official guidance for certifying COVID-19 deaths","date":"2020-04-24 00:00:00"},{"id":"eea6c4f9-4a35-4400-95ee-9ab50ec658a1","text":"Preprint and early analyses showing large excess deaths in the US and New York City during March\u2013April 2020","date":"2020-04-24 00:00:00"},{"id":"b766d337-3425-459a-a20b-64921b60ee7a","text":"Widespread media coverage showing overwhelmed New York City hospitals and temporary morgues (refrigerated trucks) in early April 2020","date":"2020-04-06 00:00:00"},{"id":"50cb3fd3-25c4-48aa-8edf-a6d4c8f587b7","text":"Publication of Nicola Scafetta (2023) paper arguing a larger solar role in recent climate change","date":"2023-04-24 00:00:00"},{"id":"4417eab2-d162-47a3-868d-6d0e56e56239","text":"Implementation of pictorial/graphic cigarette pack warnings (example: Canada began pictorial warnings in early 2000s)","date":"2001-04-24 00:00:00"},{"id":"9b61ce15-d372-433d-8b4c-cb23419b4c82","text":"Publication describing bronchial anthracofibrosis/anthracosis with visibly blackened bronchial mucosa (Chung et al., Chest)","date":"1998-04-24 00:00:00"},{"id":"95e7740e-7f3f-4e83-84d3-9e1c8c0b03f9","text":"NIOSH/CDC public information and media coverage about \'Black Lung\' (coal workers\' pneumoconiosis)","date":"2003-04-24 00:00:00"},{"id":"2e12c729-9448-4e2d-9dc1-58e700aa8af7","text":"Battle of Ilovaisk (large Ukrainian military losses; widely published 2014 photos)","date":"2014-08-24 00:00:00"},{"id":"aec06af5-63df-4aed-bd46-53ed07ff420c","text":"Russian authorities publicly announced an investigation into the reported child death","date":"2021-04-05 00:00:00"},{"id":"cf59c68b-1168-4108-9634-206a5f6873bd","text":"CDC PLoS One investigation of \'unexplained dermopathy\' (commonly called Morgellons)","date":"2012-01-25 00:00:00"},{"id":"384f6de1-57e4-4ee2-93d3-3eff97c7f3f9","text":"President Biden publishes New York Times op-ed outlining U.S. role in Ukraine without explicitly repeating phrase \'within its internationally recognized borders\'","date":"2022-05-31 00:00:00"},{"id":"12a6796a-b0a7-4fa4-8f6f-5a6b53db5c76","text":"The Vatican had produced (and publicised) a papal commemorative \'peace\' medal in 2018 (designed by Chiara Principe) \u2014 a routine commemorative medal which can be given as a gift.","date":"2018-07-26 00:00:00"},{"id":"cafe9cf0-f603-4413-982b-454c48421ca9","text":"Publication of Mawson et al. \'Pilot comparative study on the health of vaccinated and unvaccinated 6- to 12-year-old U.S. children\' claiming higher odds of developmental delays, asthma and ear infections in vaccinated children.","date":"2017-04-24 00:00:00"},{"id":"de2e5971-af07-4798-bbf8-9f1a15702d82","text":"NOAA / Arctic Report Card and mainstream coverage documenting strong year\u2011to\u2011year variability in Greenland mass balance (including exceptional melt events)","date":"2023-04-24 00:00:00"},{"id":"c5cf44c4-4233-448f-b586-0f50146cc0b6","text":"Parliamentary records and news reports showed Boris Johnson\u2019s office/company received a \xa31 million donation from investor Christopher Harborne.","date":"2023-01-12 00:00:00"},{"id":"de2a44e6-f54b-4173-9d05-f8ca1c562304","text":"Reports disclosed large paid speaking advances and fees received by Boris Johnson after leaving office (including a \xa32.5m advance).","date":"2023-02-08 00:00:00"},{"id":"3c509fdc-1d85-4f81-affd-1aa97f89c3ea","text":"Coverage that Johnson was evasive with the advisory watchdog (Acoba) about proposed paid roles and consultancy work, including reports about a paid consultancy/hedge-fund role.","date":"2024-04-19 00:00:00"},{"id":"eeda5ffb-dc48-4a5f-b7a3-ef006537a7b1","text":"Dmytro Yarosh\'s public profile as leader of Right Sector and commander of volunteer units, including statements he could \'send several battalions to Kyiv\', was widely reported in the months before the Rada session.","date":"2014-10-18 00:00:00"},{"id":"8566fd4c-45b9-46eb-845c-f0bd362c0aec","text":"The first session of the newly elected Verkhovna Rada (8th convocation) on November 27, 2014 featured numerous newly elected MPs who were war veterans and volunteer battalion commanders attending in military fatigues.","date":"2014-11-27 00:00:00"},{"id":"2c0baa6b-7f4f-4feb-b924-7b97eabe182e","text":"Publication/press coverage (Nov 28, 2024) highlighting that oceans emit cooling aerosols (sulfur) and can have a stronger cooling effect than previously quantified","date":"2024-11-28 00:00:00"},{"id":"eb40bccd-ad4a-432b-9caf-b95812c43721","text":"NOAA report and data notes documenting record high sea surface temperatures in 2023","date":"2024-01-24 00:00:00"},{"id":"9ee8d736-3deb-4c91-b996-707bfa71c95e","text":"Strong negative Pacific Decadal Oscillation (PDO) signal in October 2024 noted by climate monitoring outlets","date":"2024-10-24 00:00:00"},{"id":"a8467897-9ea8-42cb-9988-97b34c32c24a","text":"Publication on improving full\u2011depth ocean observations using Deep Argo floats (Frontiers, 2023)","date":"2023-04-24 00:00:00"},{"id":"f73b0473-d7fe-4c01-b046-e854e955a1b6","text":"Peer\u2011reviewed pilot trial published showing intravaginal Lactobacillus crispatus (chen\u201101) transplantation reduced HPV viral load and improved clearance rates.","date":"2024-07-25 00:00:00"},{"id":"fd69e6d0-bc5a-4945-a092-e49c89bdef11","text":"Ukraine\'s 2015 \'decommunisation\' laws and the domestic/international controversy over honoring OUN/UPA figures (e.g., Bandera) and historical memory debates.","date":"2015-04-24 00:00:00"},{"id":"66d6a8c7-35dd-42f6-86c3-93cdfa8eea7f","text":"Ongoing Kremlin information campaign and pro-Kremlin media narratives portraying Ukraine as \'glorifying Nazism\' and repeatedly amplifying isolated incidents as systemic (documented in EUvsDisinfo reporting).","date":"2018-04-24 00:00:00"},{"id":"a40d51bc-33fe-45bb-beb4-197580111591","text":"Prior whistleblower allegations about CDC data handling (William Thompson statement alleging omissions in a 2004 CDC MMR study).","date":"2014-08-27 00:00:00"},{"id":"1f571773-a119-4b69-bb0f-e9dd9f0458f9","text":"Austria had launched a large-scale rapid antigen mass\u2011testing programme in early December 2020, putting antigen tests at the center of political and public debate.","date":"2020-12-04 00:00:00"},{"id":"3fb25a3c-74db-43ca-a199-f3b679d401e5","text":"Historical context: documented 1943 Volhynia massacres carried out by UPA (mass killings of Polish civilians in Volhynia and Eastern Galicia).","date":"1943-04-24 00:00:00"},{"id":"ba0128c9-056c-431b-acd4-0e45d9a2602a","text":"Mainstream reporting (BBC) highlighted disproportionate COVID-19 deaths among Black, Asian and minority ethnic (BAME) communities in early April 2020.","date":"2020-04-03 00:00:00"},{"id":"8335a29a-9177-4886-8913-7e0ec1819ab9","text":"Peer-reviewed analyses of \'normalized\' disaster losses (e.g., Nature Sustainability 2018 study on normalized hurricane damage) showing that rising economic losses are driven largely by increased exposure and wealth rather than a clear climate-driven increase in frequency.","date":"2018-12-06 00:00:00"},{"id":"4dbd090d-99e8-4241-892a-8f82bc069b3c","text":"Nature commentary \'Climate simulations: recognize the \\"hot model\\" problem\' highlighting that some new climate models run \'too hot\' relative to historical warming.","date":"2022-05-04 00:00:00"},{"id":"3cac4f82-dbc7-44f7-8ddf-b9626b06553b","text":"Veterans Affairs slide-deck (interim guidance + VAERS tables) cited in the Judicial Watch release (data described as \\"as of April 2021\\")","date":"2021-04-24 00:00:00"},{"id":"ef40cf5a-0ee6-4558-aade-5a61b53b4651","text":"European Court of Human Rights judgment (Mazepa and Others v. Russia) finding the investigation into Anna Politkovskaya\'s 2006 murder was inadequate and a violation of Article 2.","date":"2018-07-17 00:00:00"},{"id":"542cf79a-84c2-4e1e-b5f4-5192d3aae3af","text":"Earlier acquittals and retrials in the Russian domestic process (initial acquittals in 2008\u20132009 and a 2009 order for further investigation).","date":"None"},{"id":"adae471a-5fe3-404e-82bd-033d9d35bc19","text":"May 2014 convictions of five men for Politkovskaya\'s murder without identifying or prosecuting an alleged mastermind.","date":"2014-05-20 00:00:00"},{"id":"688fe4d0-074c-42df-90b8-b7269d511b8a","text":"Japan\u2019s temporary suspension/recall and public reporting of Moderna COVID-19 vaccine batches after discovery of black/foreign particles in vials.","date":"2021-09-24 00:00:00"},{"id":"acb3e29c-8b9b-4d65-84d9-b6150af17e1b","text":"U.S. FDA Drug Safety Communication adding label warnings to statins about rare risks including memory loss and increased blood sugar (potential diabetes risk).","date":"2012-02-28 00:00:00"},{"id":"4d9423eb-b550-4953-a068-8ba49767718d","text":"Fatal shooting of conservative activist Charlie Kirk at a Utah university event","date":"2025-09-10 00:00:00"},{"id":"bed08933-be98-4d9a-9300-806b428a35e5","text":"Series of arson and vandalism attacks on 5G masts in the UK amid COVID-19 lockdown","date":"2020-04-24 00:00:00"},{"id":"3c3516c5-011e-4b47-9eb8-cafee3504cda","text":"Russian law signed criminalizing \'knowingly false\' information about the military (encouraging tighter control of narratives)","date":"2022-03-04 00:00:00"},{"id":"7243f16f-cb06-42c4-abfa-ac76b287a6bf","text":"U.S. approval of Javelin anti\u2011tank missile sale to Ukraine (U.S. military assistance increases).","date":"2018-03-01 00:00:00"},{"id":"460cdb5d-07ab-4e6c-bc3a-d2feb9e90359","text":"Kerch Strait incident \u2014 Russian FSB seized three Ukrainian naval vessels after a clash in the Kerch Strait.","date":"2018-11-25 00:00:00"},{"id":"6380b9a7-b8f7-49c7-867a-0b0529f09f20","text":"Sea Breeze / NATO maritime activity in the Black Sea (mid\u20112018 exercises, increased SNMG presence).","date":"2018-07-24 00:00:00"},{"id":"910e2924-30e1-4d8f-bca1-846ccc34fb20","text":"Contamination reports and suspension of Moderna vaccine batches in Japan (Aug\u2013Sep 2021)","date":"2021-08-25 00:00:00"},{"id":"f3a9bff8-828a-4118-889c-5006a1d45963","text":"January 2020 paper suggested snakes as a possible reservoir based on codon\u2011usage analysis","date":"2020-01-22 00:00:00"},{"id":"8994ae42-a469-4d04-aef2-9892dfece0ec","text":"University of Arizona press release (Aug 2021) described an enzyme linked to severe COVID\u201119 that is similar to neurotoxins in rattlesnake venom","date":"2021-08-24 00:00:00"},{"id":"e241f247-6176-476e-8066-4a9677b0c4c0","text":"CDC and FDA acknowledged rare cases of myocarditis/pericarditis after mRNA COVID-19 vaccination and updated guidance/warnings (June 2021).","date":"2021-06-24 00:00:00"},{"id":"ff68c6bc-a3d8-4051-aaf4-2e4949c54c42","text":"High-visibility athlete cardiac incidents in 2021 (for example Christian Eriksen\'s on-field cardiac arrest at Euro 2020, June 12, 2021) and other sudden collapses widely reported.","date":"2021-06-12 00:00:00"},{"id":"3672d7e9-03cd-4914-8bea-500a7184d930","text":"Media coverage in 2021 of Moderna\'s patent filings and subsequent legal actions over mRNA intellectual property (e.g., Moderna sues Pfizer/BioNTech, patent filings/provisional applications cited dating before or during 2019\u20132020).","date":"2021-08-24 00:00:00"},{"id":"d8e1da89-224c-4a1c-931c-46d998d07095","text":"Increased promotion and discussion of ozone/oxygen therapies during COVID-19 (peer-reviewed reviews and preprints)","date":"2020-07-24 00:00:00"},{"id":"b9ebc8be-5976-45fe-96ca-c44cec68333f","text":"French audit and reporting of rising Paris 2024 budget concerns/overruns","date":"2023-06-21 00:00:00"},{"id":"523bb635-cdad-48be-a47f-38f6e33d4588","text":"Large-scale unrest and transport disruption in France (including the June 2023 riots after Nahel\'s killing and ongoing strikes)","date":"2023-06-27 00:00:00"},{"id":"458966e5-0956-4973-b03b-c5cc3028417f","text":"Ipsos global/European polling on attitudes toward Paris 2024 (May\u2013June 2024 survey period)","date":"None"},{"id":"d05082ca-4118-4750-9e59-3caabb1f72b0","text":"Anti-corruption police raid of the Paris 2024 organising committee headquarters","date":"2023-06-20 00:00:00"},{"id":"9b5d28dd-276e-4d6a-af5a-69614fe5b6fc","text":"South Africa suspends use of the AstraZeneca vaccine after a study suggested low efficacy against mild-to-moderate illness caused by the B.1.351 (Beta) variant.","date":"2021-02-07 00:00:00"},{"id":"cc89de56-27d3-450f-8f22-dc03a546f2b7","text":"Norwegian Medicines Agency reports (January 2021) deaths among very frail, elderly people shortly after receiving the Pfizer\u2013BioNTech vaccine; authorities reviewed whether reactions contributed to fatal outcomes.","date":"2021-01-18 00:00:00"},{"id":"886af67b-0325-41c9-9ed1-e0a1d01c8050","text":"CDC and FDA recommend a pause (April 13, 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis in some recipients.","date":"2021-04-13 00:00:00"},{"id":"4258cdeb-dc85-42d5-9bf0-ffb422d15786","text":"EMA PRAC releases safety review concluding a possible link between the AstraZeneca vaccine and very rare blood clots with low platelets.","date":"2021-03-18 00:00:00"},{"id":"021c1c3a-fd51-4941-9034-e50318b1dbba","text":"John R. Christy congressional testimony asserting climate models overestimate warming and that policy actions would have negligible temperature impacts","date":"2017-03-29 00:00:00"},{"id":"5d7cb6c6-c732-43bb-9df3-aada3e38d660","text":"CDC guidance shift and prior messaging that medical masks should be reserved for health workers; on 3 April 2020 CDC issued new guidance recommending cloth face coverings for the public.","date":"2020-04-03 00:00:00"},{"id":"d99b0120-f2a8-492d-96ed-003f61c955c0","text":"WHO updated advice (5 June 2020) noting \'there is no direct evidence (from studies on COVID\u201119 and in healthy people in the community) on the effectiveness of universal masking of healthy people\'.","date":"2020-06-05 00:00:00"},{"id":"27cfb698-04cd-4ab9-ac6d-56207c48fec7","text":"Swedish government proposal to raise the voluntary repatriation (repatriation) grant to 350,000 SEK per adult (announced in government/media coverage)","date":"2024-09-13 00:00:00"},{"id":"ac90fed3-bc85-4e29-a5e3-e3852870bd1b","text":"Immediate clarifications and explanatory articles noting who is eligible (coverage by outlets like The Local and Swedish Migration Agency pages)","date":"2024-09-12 00:00:00"},{"id":"66a43457-3d8b-4300-b113-987ff3935451","text":"Publicly known fact that Vega\u2019s AVUM upper stage uses a Ukrainian\u2011designed RD\u2011843 liquid engine (manufactured by Yuzhmash/Yuzhnoye)","date":"None"},{"id":"13db7249-b755-4f82-b994-bace920bf919","text":"Anti-Maidan tent camp at Kulykove (Kulikovo) Pole and sustained pro\u2011Russian protests","date":"None"},{"id":"13afdb0f-3788-4b98-94f3-d10f8635be0c","text":"Deadly clashes and Trade Unions building fire in Odesa (mass casualties)","date":"2014-05-02 00:00:00"},{"id":"7cb30f02-ea7e-483a-ac7c-9449553c6bed","text":"Pro\u2011Russian demonstrators stormed Odesa police headquarters and freed detainees","date":"2014-05-04 00:00:00"},{"id":"d3077dd1-f47d-4350-9a4d-dd1b33e2a59d","text":"Large\u2011scale rocket/shelling attack on Mariupol and OSCE spot reporting on Jan 24, 2015 (high civilian casualties; intense media attention).","date":"2015-01-24 00:00:00"},{"id":"2e2d89d2-803a-44e2-8a92-a2628ae2454d","text":"Donetsk bus-stop/mortar shelling that killed civilians and produced circulating images of victims (Donetsk bus station attack).","date":"2015-01-22 00:00:00"},{"id":"bb933fdf-bf4c-4870-a5f0-dd6bbdb1571d","text":"World Health Organization interim guidance (March 19, 2020) that did not recommend routine mask use by asymptomatic members of the public","date":"2020-03-19 00:00:00"},{"id":"8b6dbb3c-a32a-4feb-a3e0-41e11f84d8fa","text":"2006 study linking unmetabolized folic acid (UMFA) to reduced natural killer (NK) cell cytotoxicity","date":"2006-02-24 00:00:00"},{"id":"fde782d9-9fd7-487c-adf4-3e4592d9493b","text":"Clinical reviews and professional guidance highlighting controversy over MTHFR testing and folate form choice","date":"2019-04-24 00:00:00"},{"id":"8dd64eac-5d24-4388-aebb-09184a58300f","text":"Mid-season reports of low influenza vaccine effectiveness during the 2014\u20132015 Northern Hemisphere season (notably against A/H3N2)","date":"2015-01-24 00:00:00"},{"id":"f34149ca-790e-498e-85fd-747e2561dc0c","text":"Publication of BMJ individual participant data meta-analysis reporting that vitamin D supplementation reduced risk of acute respiratory tract infections","date":"2017-02-15 00:00:00"},{"id":"f8d87d4c-c6fd-4540-89e1-a95b51cdd11a","text":"Intensified Russian strikes and repeated damage to Kharkiv\'s energy and infrastructure in March\u2013April 2024 (blackouts, strikes on power plants and residential areas).","date":"2024-04-12 00:00:00"},{"id":"d8854f92-f1ea-44f0-9fa5-20817a1a5909","text":"U.S. and international lenders publicly urged Ukraine to accelerate anti\u2011corruption reforms amid threats of aid reduction","date":"2016-02-12 00:00:00"},{"id":"305e3a42-a8f7-4384-8727-a8b2837b3ee7","text":"U.S. Assistant Secretary Victoria Nuland publicly warned in Senate testimony that \'oligarchs\' and backsliding reforms threatened Ukraine\'s progress","date":"2016-03-15 00:00:00"},{"id":"b643aa80-1674-4a44-bc83-91d9e5e86d80","text":"Public opinion and polls in early 2016 showed a sharp decline in Poroshenko\u2019s approval ratings, signaling political vulnerability","date":"2016-04-07 00:00:00"},{"id":"097db6ca-eb11-44c5-adf8-a71db915c3f8","text":"Ukraine parliament dismisses Prosecutor General Viktor Shokin after months of pressure","date":"2016-03-29 00:00:00"},{"id":"9ab6ff72-6210-4869-bde8-98e72edd407b","text":"Panama Papers revealed President Poroshenko had registered an offshore company, prompting investigations and political criticism","date":"2016-04-04 00:00:00"},{"id":"058195ec-069f-4af7-a0fc-c241d129f928","text":"Amnesty International documents abductions, unlawful detention and makeshift detention facilities used by Ukrainian volunteer battalions (Aidar) in eastern Ukraine","date":"2014-09-24 00:00:00"},{"id":"18b5b3da-d419-4a47-8df3-72b832f336f0","text":"Russia issues large numbers of Russian passports to residents of Crimea after annexation","date":"2014-04-24 00:00:00"},{"id":"56942172-4f15-41ef-b903-cb1459c846d2","text":"Israeli observational study reported increased emergency cardiovascular events in people under 40 during the vaccine rollout and third COVID\u201119 wave (Sci Reports, 2022)","date":"2022-07-24 00:00:00"},{"id":"e8cef964-44ce-4e1c-9aa6-22f1e4bceecc","text":"Science/AAAS coverage noting that a subset of the newest climate models were running \'too hot\' and discussing implications for impact studies.","date":"2019-05-09 00:00:00"},{"id":"19b844df-9886-4baa-a563-1cb1efa79513","text":"Release of UAH Version 6.0 satellite temperature dataset (Roy Spencer & John Christy) showing lower tropospheric trends than some surface records.","date":"2015-04-28 00:00:00"},{"id":"42c7e95a-5884-4619-99f5-e3ff70fa2154","text":"1933 Soviet orthography reform (Kharkiv/1933 orthography) that altered Ukrainian spelling norms","date":"1933-04-24 00:00:00"},{"id":"c207827d-9d99-4f9b-888f-f91c5a2ea551","text":"Ems Ukaz banning many forms of Ukrainian-language print and performance (1876)","date":"1876-05-24 00:00:00"},{"id":"5fdbeaa7-2027-4559-bbea-f5f3db8a3408","text":"Valuev Circular limiting Ukrainian-language publications (1863)","date":"1863-07-24 00:00:00"},{"id":"d7d4d4a8-0021-4af4-aa40-a7aecde69956","text":"USDA published the National Bioengineered Food Disclosure Standard final rule (Dec 21, 2018)","date":"2018-12-21 00:00:00"},{"id":"374385f7-292b-4a9f-8779-030b8b2426dd","text":"June 2021 CDC/ACIP review and MMWR publications acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID-19 vaccination in younger males.","date":"2021-06-23 00:00:00"},{"id":"276c9734-ff08-4830-8f40-0007568e0ee6","text":"Associated Press published coverage (Jan 2025) that Ivanpah, once the world\'s largest concentrated solar facility, was likely headed for partial closure because it couldn\'t compete with cheaper photovoltaic (PV) technologies and faced environmental criticisms.","date":"2025-01-31 00:00:00"},{"id":"92dbb386-e617-4d97-9c27-c509b8ae9d5a","text":"Investigations and reporting (2014\u20132015) including U.S. Fish & Wildlife/press coverage documented elevated avian mortality at Ivanpah (widely reported estimates of thousands of bird deaths and descriptions of birds being burned by concentrated-solar \'streamers\').","date":"2015-04-23 00:00:00"},{"id":"efdd41cf-9be8-405d-8dbc-e5c76227a9dd","text":"NRG Energy and the U.S. Department of Energy announced they finalized negotiations with Pacific Gas & Electric to terminate two long-term Ivanpah power\u2011purchase agreements (PPAs), setting in motion shutdown of two units beginning in 2026 if regulators approve.","date":"2025-01-14 00:00:00"},{"id":"c71fbc94-fa99-4abb-a66c-e2701d9c67ea","text":"Public attention on waning Western political support for Ukraine (Zelensky\'s December 2023 pleas in Washington)","date":"2023-12-13 00:00:00"},{"id":"b894c62e-7e2a-4f49-b93c-8c019edb1b6c","text":"Bloomberg opinion column by retired Admiral James Stavridis noting Russia\'s current aviation advantage","date":"2023-12-14 00:00:00"},{"id":"8a253488-d483-41db-bd72-6b60bf09edb1","text":"Pro\u2011Russian protesters seized Donetsk regional administration and other government/SBU buildings and declared a \'People\'s Republic\'","date":"2014-04-07 00:00:00"},{"id":"0b0162cb-a1c8-49a5-841a-98214bc000d3","text":"Public visibility of far\u2011right groups and symbols during Euromaidan (Right Sector, Bandera portraits, Celtic cross flags)","date":"2014-01-21 00:00:00"},{"id":"bb93d367-6956-436d-996a-599f0fa232f7","text":"Pro\u2011Russian separatists seized Ukrainian armoured personnel carriers and drove them through towns in eastern Ukraine","date":"2014-04-16 00:00:00"},{"id":"b8be2070-d07b-4283-86e3-1b49f50d697c","text":"IAEA Director General Rafael Grossi publicly expressed \'grave\' or \'extreme\' concern about the safety and security situation at the Zaporizhzhia plant under military control.","date":"2022-03-04 00:00:00"},{"id":"a53c344d-45d0-4daa-a4ea-f6e9b933e2f3","text":"Russian forces seized the Zaporizhzhia Nuclear Power Plant after nearby shelling; a fire was reported at the site.","date":"2022-03-04 00:00:00"},{"id":"b6d91b71-04fd-4967-9a42-d4e4348dd2b7","text":"Visible participation of nationalist groups (e.g., Maidan Self\u2011Defence/Right Sector elements) in the Odessa march and subsequent clashes.","date":"2014-05-02 00:00:00"},{"id":"0f703776-b87a-4ba4-887e-cf1e9cef8a8a","text":"Indonesian drug regulator (BPOM) circulated guidance mentioning ivermectin among medicines for COVID-19-related distribution, prompting reports that it had been authorised for emergency use","date":"2021-07-24 00:00:00"},{"id":"e6965eb2-6707-4743-bba9-e2f55128db0c","text":"Official U.S. assistance and advisory activity for Ukraine was publicly documented (White House fact sheet on U.S. assistance to Ukraine, Nov 21, 2014).","date":"2014-11-21 00:00:00"},{"id":"48e9783a-c3e4-4fbf-9741-8c5b30bd9098","text":"German newspaper Bild am Sonntag published a report (citing unnamed intelligence sources) alleging ~400 Academi (ex-Blackwater) mercenaries were operating in eastern Ukraine.","date":"2014-05-24 00:00:00"},{"id":"e5cfd380-706b-4af4-b638-56533d6cb180","text":"YouGov poll (20 June 2022) showing Britons remain supportive of sanctions/assistance but growing wary as costs bite","date":"2022-06-20 00:00:00"},{"id":"67275948-5c00-497f-bff2-9ded64b9afd0","text":"Hansard parliamentary debate on UK and NATO military commitment regarding Ukraine (20 June 2022)","date":"2022-06-20 00:00:00"},{"id":"c44bb25c-c233-41fe-83da-332ae4cdc1f7","text":"UK Health Security Agency technical briefings and early reports (Dec 2021\u2013Jan 2022) documenting reduced vaccine effectiveness against symptomatic infection with the emergent Omicron variant","date":"2021-12-24 00:00:00"},{"id":"1fc2906a-4c9a-4530-ada6-424bf52e2b3e","text":"Office for National Statistics (ONS) age\u2011specific COVID\u201119 mortality data/releases showing very low death rates in younger age groups","date":"2021-01-24 00:00:00"},{"id":"bc846d24-6358-4f50-9da0-6f37026b1164","text":"Large cluster-randomized Bangladesh mask trial published in Science (Nov 2021) reporting a modest reduction in symptomatic SARS\u2011CoV\u20112 infections and differing effects by mask type","date":"2021-11-24 00:00:00"},{"id":"5d55214d-c331-4e56-ac03-0c5544cd5118","text":"Formation and large-scale fundraising by the \'Come Back Alive\' foundation (Povernys zhyvym) to support Ukrainian forces starting in 2014.","date":"2014-05-10 00:00:00"},{"id":"28a28ac4-d5b4-4d98-8f7e-c8c3bee9802d","text":"Street vendors and souvenir sales around Maidan popularized buying Ukrainian-themed goods for fundraising and solidarity.","date":"2014-06-15 00:00:00"},{"id":"159a1577-f120-44d3-acd4-9256546ba197","text":"Vyshyvanka Day / \'Give the vyshyvanka to a defender\' 2015 campaign increased sales/donations connected to traditional Ukrainian garments.","date":"2015-05-21 00:00:00"},{"id":"3208a2e6-8017-4011-9caf-ae4d6d4eda38","text":"Sharp decline in domestic automobile production in Ukraine documented in 2015\u20132016 (major contraction of car manufacturing).","date":"2016-05-27 00:00:00"},{"id":"7fcc26bf-3d16-4a63-bed6-eb9aad637370","text":"CDC guidance (May 13, 2021) stating fully vaccinated people could resume activities without wearing masks in most settings","date":"2021-05-13 00:00:00"},{"id":"7d282275-0ef0-4981-aaae-07a25a4cc2d7","text":"Regulatory investigations and temporary pauses over rare thrombotic events associated with the AstraZeneca COVID-19 vaccine (March\u2013April 2021)","date":"None"},{"id":"1063213e-2698-40c3-8381-4586e469f8f3","text":"Uttar Pradesh state government endorsed large-scale prophylactic and therapeutic use of ivermectin in its COVID-19 protocol and publicly attributed part of its relatively low case/fatality metrics to ivermectin use (reported May 12, 2021)","date":"2021-05-12 00:00:00"},{"id":"3682026f-f1f4-4c55-9007-6b73fb162e88","text":"Uttar Pradesh reports large number of \u2018COVID\u2011free\u2019 districts / very low active cases (official counts)","date":"2021-10-19 00:00:00"},{"id":"67f30ec6-95de-443c-8a45-01bd859d04c4","text":"WHO issues guidance advising ivermectin only be used for COVID\u201119 within clinical trials","date":"2021-03-31 00:00:00"},{"id":"9a92b1c5-d64b-4a8f-bff3-9d8cda00b308","text":"Surge in herbal and immune\u2011support supplement sales during the COVID-19 pandemic (record growth in 2020)","date":"2021-09-15 00:00:00"},{"id":"8cc23ae4-e70f-4570-bf83-5c2302b65dea","text":"Cochrane review reporting limited preventive effect of regular vitamin C on common cold incidence in ordinary population","date":"2013-04-24 00:00:00"},{"id":"0056a45e-1104-437c-84c0-4e7b7467c2a0","text":"Human Rights Watch (and other NGOs) called for a thorough investigation into the Odessa deaths, highlighting possible official inaction or failures","date":"2014-05-08 00:00:00"},{"id":"4959890f-ec07-4467-9894-7ea899d38684","text":"Deadly clashes and Trade Unions House fire in Odessa (dozens killed)","date":"2014-05-02 00:00:00"},{"id":"d651504e-7fd0-400c-a45a-bc201d982e7f","text":"Media reporting and analysis documenting police/authorities\' limited intervention and chaotic law\u2011enforcement response during the May 2 clashes","date":"2014-05-06 00:00:00"},{"id":"c1d3a62d-f31c-41f0-861d-08cae4ea448b","text":"Amnesty International and other human-rights organisations document police crackdowns, intimidation and legal pressure on peaceful protesters in Poland (reports published 2017 onward).","date":"2017-10-24 00:00:00"},{"id":"3b1c36c8-803b-475c-8fe3-1f57b4d5f437","text":"Poland\u2019s president signs laws giving the government power to appoint and dismiss public broadcaster executives, effectively placing public TV and radio under direct government control.","date":"2016-01-24 00:00:00"},{"id":"6420c8f8-d16e-4808-96f7-081e0dee8be5","text":"The European Union triggers the Article 7 procedure against Poland (December 2017) over concerns about rule-of-law breaches, judicial independence and broader institutional capture by the government.","date":"2017-12-24 00:00:00"},{"id":"ca9e16c0-b200-44cc-b1bc-b776e3da81ce","text":"Reporters Without Borders and other press-freedom indices record a marked decline in Poland\u2019s press freedom ranking in 2016, citing government interference in public media and political pressure on journalists.","date":"2016-04-24 00:00:00"},{"id":"03572d67-6c26-44ca-8afd-20dc0ac1ed0b","text":"Large public and veterans\' protests against Zelensky over anti\u2011corruption and governance moves","date":"2025-07-24 00:00:00"},{"id":"079bb245-d14a-4c7a-805a-0fe7162f6abd","text":"President Zelensky dismisses Ukraine\'s Commander-in-Chief Valerii Zaluzhnyi","date":"2024-02-08 00:00:00"},{"id":"e0c9f39d-5831-45a1-830b-2a67218024c1","text":"Analyses and warnings about growing far\u2011right mobilization and past armed clashes involving nationalist groups","date":"2024-10-11 00:00:00"},{"id":"6b3ae583-1ea9-4b3a-b5bf-f35462415eff","text":"Early limits and inconsistencies in U.S. testing guidance that undercounted cases","date":"2020-03-03 00:00:00"},{"id":"ef160d98-8f47-4fc5-8cad-1903cedc1f3b","text":"Authoritative agencies published comparisons noting similarities but important differences between COVID-19 and influenza","date":"2020-03-25 00:00:00"},{"id":"752d86e5-d35a-4109-9d79-724a0db1743a","text":"NOAA \'Sea Level Trends\' / Tides & Currents long\u2011term tide gauge dataset publication and guidance pages","date":"2018-04-24 00:00:00"},{"id":"0dc7ae0a-7caf-4637-9106-b9ac247f37cc","text":"Major media coverage summarizing Nerem et al. (2018) (e.g., The Guardian 27 Feb 2018)","date":"2018-02-27 00:00:00"},{"id":"8e1fa647-3216-4dff-87b3-a454db279570","text":"Publication of Nerem et al. (2018) PNAS \'Climate\u2011change\u2013driven accelerated sea\u2011level rise detected in the altimeter era\'","date":"2018-02-24 00:00:00"},{"id":"6f5ed3cd-536e-4444-9e06-51eccbcf6a6f","text":"Early\u2013mid March 2022: Evacuations of wounded Mariupol civilians (including children) to hospitals in other Ukrainian cities such as Zaporizhzhia; news outlets published photos of evacuees being treated elsewhere.","date":"2022-03-09 00:00:00"},{"id":"3409a217-a4f3-4f60-9101-52c1f87b9ab1","text":"CDC/NCHS release on 2020 firearm-related deaths (March 17, 2021)","date":"2021-03-24 00:00:00"},{"id":"ab4a0b17-1983-4011-8f28-2e73ed350490","text":"Journal of Patient Safety 2013 estimates of 210,000\u2013440,000 deaths from preventable harm","date":"2013-04-24 00:00:00"},{"id":"dc40a4e2-8449-44e5-b295-6541d540d7e9","text":"Record 2018 California wildfire season (e.g., Mendocino Complex Fire in July 2018)","date":"2018-07-27 00:00:00"},{"id":"a396cbb1-fb21-4080-86c7-b19d02400f19","text":"President Poroshenko had signed a demobilization decree (No. 328/2015) in June 2015 scheduling demobilization during July\u2013September 2015.","date":"2015-06-12 00:00:00"},{"id":"4cfee40f-c632-4d7e-adf7-57b73b8f2ee7","text":"Ukraine\u2019s Ministry of Defence and other officials issued immediate denials, stating that conscription schedules are governed by law and the General Staff cannot unilaterally extend conscript terms.","date":"2015-07-13 00:00:00"},{"id":"dcd5db79-1f5c-47b9-8191-7ed0df646471","text":"Widespread administrative complexity and public confusion over multiple mobilization/de\u2011mobilization orders since 2014 (partial mobilizations, different presidential decrees) created an environment where contradictory claims about service terms were plausible.","date":"None"},{"id":"1c66cc00-9fd5-477e-932c-30917929823a","text":"Peer\u2011reviewed reports describing isolation and characterization of the novel coronavirus (e.g., Zhu et al., NEJM)","date":"2020-01-24 00:00:00"},{"id":"7c8e8163-76b3-483c-83a5-7d5a604ec003","text":"Russia recognised Donetsk and Luhansk as independent and ordered troop deployments","date":"2022-02-21 00:00:00"},{"id":"0acc9dfe-649c-470f-ada8-59734a0d6699","text":"High\u2011profile Turkish Bayraktar TB2 drone use for Ukraine highlighted internationally","date":"2022-05-30 00:00:00"},{"id":"53564956-1238-4060-98a5-a257a368982d","text":"Public Turkish statements emphasising support for Crimean Tatars and calling for Crimea\'s return to Ukraine","date":"2022-03-24 00:00:00"},{"id":"a16e1903-461c-4506-8861-3d7902f86cd2","text":"Turkish President Erdo\u011Fan visited Kyiv and offered to mediate between Ukraine and Russia","date":"2022-02-03 00:00:00"},{"id":"509cdd4a-32cf-46bf-9061-87fd383f6da6","text":"U.S. Advisory Committee on Immunization Practices (ACIP) / CDC review and public statement (MMWR) in June 2021 acknowledging myocarditis reports after mRNA COVID\u201119 vaccines while concluding benefits outweigh risks.","date":"2021-06-23 00:00:00"},{"id":"3c19d2a4-f513-41a5-8faa-2464e56c7bd9","text":"In vitro studies published in 2021 reporting that isolated SARS\u2011CoV\u20112 spike protein can affect endothelial cells, pericytes or ACE2 signalling (e.g., Lei et al., Avolio et al.).","date":"2021-04-24 00:00:00"},{"id":"9e56dab0-5cf4-45b0-ad60-275fc36209c8","text":"U.S. Department of Defense announced a $250 million security-assistance package for Ukraine.","date":"2019-06-18 00:00:00"},{"id":"355f7a62-c215-4842-a84b-3c956c65a379","text":"Kerch Strait incident: Russian forces seized Ukrainian navy vessels and detained sailors.","date":"2018-11-25 00:00:00"},{"id":"a088dd02-6770-44a6-8d0e-c8ad5aec1597","text":"Earlier U.S. transfers of lethal defensive systems (e.g., Javelin anti-tank missiles in 2018).","date":"2018-07-24 00:00:00"},{"id":"5ec788d5-61e0-4e9b-a95e-da9cde6d8fc1","text":"Text of the FY2020 National Defense Authorization Act (NDAA) circulated with provisions directing security assistance and reporting on Ukraine.","date":"2019-06-24 00:00:00"},{"id":"bf8bb868-6a19-4b48-b3e3-e2d83c57bffd","text":"U.S. temporarily relocated embassy operations from Kyiv to Lviv amid Russian force buildup","date":"2022-02-14 00:00:00"},{"id":"28386613-34b5-4c1f-94d2-f879ca76a462","text":"Russian missile strikes and attacks on Odesa region in early July 2022 (civilian casualties reported)","date":"2022-07-01 00:00:00"},{"id":"e286a468-eebe-49e0-abe3-e91ef6536342","text":"U.S. ordered evacuation of most embassy staff in early February 2022","date":"2022-02-12 00:00:00"},{"id":"47a5bdde-eae2-4055-96f5-64228b6afaeb","text":"U.S. Embassy in Kyiv officially reopened after months of suspension (May 18, 2022)","date":"2022-05-18 00:00:00"},{"id":"74d182f5-abca-4486-bb63-20c04388f987","text":"ONS technical analysis (March 2022) \'Deaths involving COVID-19 by vaccination status\' explaining that differences in non-COVID mortality by vaccination status were driven by changing composition of vaccinated groups","date":"2022-03-16 00:00:00"},{"id":"f959a15a-811c-4320-96e0-b3d0d9234415","text":"Publication of the World Mortality Dataset and accompanying eLife paper (Karlinsky & Kobak) documenting cross-country excess-mortality estimates","date":"2021-06-30 00:00:00"},{"id":"3d1d9264-6372-4f7e-abba-8dff2736e471","text":"Reports that cities (including Lviv) were reusing or digging up old graves and opening new burial areas to accommodate war dead","date":"2023-06-19 00:00:00"},{"id":"c7fa7154-662d-458e-ad6e-b0f0bf4c0382","text":"Collapse of the Nova Kakhovka (Kakhovka) dam on the Dnipro River, releasing large volumes of water and exposing reservoir sediments","date":"2023-06-06 00:00:00"},{"id":"e92defb1-ef29-4c1a-904d-6e35d992e54f","text":"Forensic teams exhumed mass graves in Bucha after Russian forces withdrew","date":"2022-04-08 00:00:00"},{"id":"f9388985-6c3f-4aed-8bb1-2e0663b530b9","text":"Publication of scientific reviews and studies showing cemetery leachate can affect groundwater under certain conditions","date":"2012-04-24 00:00:00"},{"id":"8b3e60bf-ee95-4e09-942b-5d4da7895641","text":"BBC report on corruption allegations in Ukraine\'s defence procurement, highlighting opaque contracting and alleged diversion of funds.","date":"2016-12-24 00:00:00"},{"id":"ae583b19-b213-4b87-a650-af51e14d5d28","text":"Verkhovna Rada passes the 2017 state budget under IMF conditions, with tight fiscal limits on public spending.","date":"2016-12-21 00:00:00"},{"id":"98b4c645-ec3a-4052-8ecb-1f2e0cff86b0","text":"Media coverage (KyivPost) of targeted pay increases in 2017 that boosted frontline soldiers\' wages more than others.","date":"2017-09-12 00:00:00"},{"id":"99c384ac-d12e-412c-af0e-a29f870224a1","text":"IMF staff report and government commentary (2016) warning about a high public-sector wage bill and urging fiscal restraint and reform.","date":"2016-10-24 00:00:00"},{"id":"a768319a-bc88-4540-a568-c888c470e333","text":"Razumkov Center identity survey (fieldwork March 3\u20139, 2017) reported regionally varied answers on \'citizen of the former USSR\' (cited in coverage)","date":"None"},{"id":"188e2634-02b5-48cf-8416-b730583f7c01","text":"Gorshenin Institute / Friedrich\u2011Ebert\u2011Stiftung publicised a July 2017 survey (\'Ukrainian society and European values\') whose mixed subgroup breakdowns were publicly presented","date":"2017-07-11 00:00:00"},{"id":"b8d26489-766b-476e-9288-afe066be5436","text":"IPCC Sixth Assessment Report (AR6) Working Group I \u2013 Summary for Policymakers released, stating \'It is unequivocal that human influence has warmed the atmosphere, ocean and land\' while also presenting ranges/uncertainty for climate sensitivity and attribution details.","date":"2021-08-09 00:00:00"},{"id":"74d6300c-e54d-4b56-8ed9-29f1fa4731db","text":"Hunga Tonga\u2013Hunga Ha\'apai volcanic eruption (massive explosive eruption and atmospheric injection of water vapor and aerosols).","date":"2022-01-15 00:00:00"},{"id":"3d0cc3f9-607e-40c1-8d36-d6bc0ce97f45","text":"A small number of UN member states publicly recognized or expressed support for Russia\u2019s annexation of Crimea (reported examples e.g., statements by Syria, Venezuela)","date":"2018-05-15 00:00:00"},{"id":"d45a26ec-741e-44f4-bdb7-f46d3f67f74f","text":"UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine\u2019s territorial integrity","date":"2014-03-27 00:00:00"},{"id":"571e1cc8-8607-4611-b359-a9e35e278bfe","text":"UN Security Council veto blocked a draft resolution condemning the Crimea referendum","date":"2014-03-15 00:00:00"},{"id":"630c80c4-861f-415c-8316-30394a1d4966","text":"Ukraine\u2019s government signalled acceptance of the \'Steinmeier Formula\' (early October 2019) committing to steps on special status/elections for Donbas","date":"2019-10-01 00:00:00"},{"id":"76c2db9b-d26b-4f29-a2ee-da0ac761da2b","text":"High-profile Russia\u2013Ukraine prisoner exchanges in September 2019 (major swaps reported Sept 2019)","date":"2019-09-24 00:00:00"},{"id":"65f035a9-60f3-4966-bc30-bed468dc3092","text":"Atlantic Council analysis (Oct 30, 2019) summarising polls that show many Ukrainians want peace but with important caveats (e.g., polls indicating ~69% favour compromise in some formulations)","date":"2019-10-30 00:00:00"},{"id":"36e1b8f2-7b42-403e-b626-9551d4fbc24b","text":"Large \'Stop Capitulation\' / \'No Surrender\' protests across Ukraine opposing concessions (early October 2019, mass rally Oct 6, 2019)","date":"2019-10-06 00:00:00"},{"id":"21fceb45-0ee5-4715-845a-c3e404724968","text":"Ilko Kucheriv Democratic Initiatives Foundation / KIIS November 2019 public opinion survey (national) reported majorities on negotiating and preconditions for talks","date":"2019-11-24 00:00:00"},{"id":"e77ad024-62fa-46e0-96aa-65e8904c4383","text":"Preprint serosurvey reporting SARS\u2011CoV\u20112 antibodies in cats in Wuhan","date":"2020-04-24 00:00:00"},{"id":"c322107b-bbb2-44b7-aa46-c909b4d958d6","text":"Public health caveats and cautious messaging (CDC/WHO) about animals and COVID\u201119","date":"2020-03-24 00:00:00"},{"id":"d61751b1-ac99-48f8-84e8-8fba7b252705","text":"Belgian domestic cat tested positive after owner with COVID\u201119 (human\u2192cat transmission)","date":"2020-03-27 00:00:00"},{"id":"42a254be-8c82-46d6-948b-254dba5466d9","text":"Russian officials publicly demanded the release/publication of recordings and black box data, accusing investigators of withholding material.","date":"2014-09-01 00:00:00"},{"id":"7af65c91-6dfe-40e8-9056-5c636f903528","text":"Conflicting official statements about why MH17 was allowed to fly over conflict\u2011torn eastern Ukraine and whether Ukrainian authorities had closed relevant airspace.","date":"2014-07-18 00:00:00"},{"id":"f2ed9760-5610-4a2c-9354-e9247fc29368","text":"Japan suspended use of some Moderna COVID-19 vaccine batches after reports of particulate contamination in vials (August 2021).","date":"2021-08-26 00:00:00"},{"id":"086e3440-20ae-47d7-8188-96798400bd40","text":"Norwegian health authorities reviewed reports of 23 frail elderly patients who died shortly after receiving the Pfizer/BioNTech vaccine and issued guidance about vaccinating very frail elderly (January 2021).","date":"2021-01-24 00:00:00"},{"id":"9093e625-8ae4-4f6d-9b7d-8b396f3411e7","text":"December 2022 peer-reviewed autopsy study examining 35 people who died unexpectedly within 20 days of COVID-19 vaccination reported possible vaccine-induced myocarditis in a small number of cases and was widely shared.","date":"2022-12-24 00:00:00"},{"id":"6e550910-5543-4a06-a74a-00c18f1cde7b","text":"Russian leadership accuses Ukraine of plotting terrorist/armed incursions (Crimea)","date":"2016-08-11 00:00:00"},{"id":"374372cf-f681-4fc2-851d-a23fd9e14b8f","text":"Rapid Trident 2018: Ukraine\u2011NATO joint military exercises in Lviv region","date":"2018-09-03 00:00:00"},{"id":"d86e9609-77ec-4c34-b3f1-a779490eaedd","text":"FDA Vaccines and Related Biological Products Advisory Committee briefing documents (December 2020) for the Pfizer\u2011BioNTech vaccine noted transient changes in trial participants\' lymphocyte counts","date":"2020-12-10 00:00:00"},{"id":"9313994a-61f5-4078-acbd-c434cdaf8305","text":"Reports of contamination (black/foreign particles) found in multiple Moderna vaccine vials in Japan, prompting suspension and investigation of batches","date":"2021-09-01 00:00:00"},{"id":"0943c6ee-1b22-4a07-ae1f-fa4e9067bf92","text":"Public Health England (PHE) Technical Briefing 17 published with breakdowns of Delta cases, hospitalisations and vaccination status","date":"2021-06-25 00:00:00"},{"id":"406b1fbe-7199-4fa6-aef8-6543f5fb49a2","text":"Discovery of dozens of civilian bodies in Bucha after Russian forces withdrew","date":"None"},{"id":"d79ae8d2-9a53-4da3-a523-3505d8ef4e2a","text":"Pattern of Russian accusations that Ukraine stages \'provocations\' or \'false flag\' incidents","date":"2022-03-24 00:00:00"},{"id":"22add310-deff-4922-af09-bed7fb4c6eaf","text":"WMO/other agencies reported unusually low Antarctic sea\u2011ice extents in 2022\u20132023 (e.g., WMO note on record low winter extent, September 13, 2023).","date":"2023-09-13 00:00:00"},{"id":"c42c06b6-0c72-404c-b1e1-a6ea887ab989","text":"IPCC Sixth Assessment Report (AR6) Summary for Policymakers released, strongly attributing recent warming to human influence","date":"2021-08-24 00:00:00"},{"id":"a18eb799-3627-42c3-8e70-28d1b88e5971","text":"Publication/coverage of papers predicting a \'modern grand solar minimum\' and potential cooling (e.g., Zharkova et al. 2020)","date":"2020-08-04 00:00:00"},{"id":"ecf23699-b575-4ba7-a0fe-5d782f53736b","text":"CDC released guidance for certifying deaths due to COVID-19 (guidance on cause-of-death reporting, explaining comorbidities often listed alongside COVID-19).","date":"2020-04-24 00:00:00"},{"id":"7f00fee7-1728-4445-912d-7de5fff1b210","text":"Publication and wide circulation of the Great Barrington Declaration (Oct 4, 2020), advocating \'focused protection\' and highlighting differences in individual risk.","date":"2020-10-24 00:00:00"},{"id":"9f261b7b-2319-4085-ab37-11078a70c433","text":"CDC reverses mask guidance for vaccinated people (July 27, 2021) following Provincetown/Barnstable County outbreak and director\'s statement","date":"2021-07-27 00:00:00"},{"id":"8b34aad5-bf88-4f62-bdad-ef7da9225420","text":"Peer\u2011reviewed reports of myocarditis temporally associated with mRNA vaccination (Israel / NEJM reporting increased risk in young males)","date":"2021-10-06 00:00:00"},{"id":"90d2e97e-b523-4e6d-a6e6-06d952d0048d","text":"Russia blocked an OSCE council statement condemning the Mariupol attack and publicly blamed Kyiv for the shelling","date":"2015-01-25 00:00:00"},{"id":"3866bad7-b613-459d-b4e2-3a798895640b","text":"OSCE Special Monitoring Mission spot report (24 January 2015) published crater/direction analysis of the Mariupol strike (found impacts from north-east/east)","date":"2015-01-24 00:00:00"},{"id":"4a88d88f-26b0-40d4-b289-cf860b95d0de","text":"NOAA/NCDC summary reporting 2012 as the warmest and second-most-extreme year for the contiguous United States, citing ~34,008 daily record highs vs ~6,664 daily record lows.","date":"2013-01-24 00:00:00"},{"id":"b70369d8-27de-44c0-8c2d-d4f9015ecfbe","text":"Publication of Keeling et al. (PNAS, 2017) reporting a global secular increase in carbon isotopic discrimination by land photosynthesis.","date":"2017-09-24 00:00:00"},{"id":"59b4c0a6-0bf0-4b4e-ac15-bfba72030ec6","text":"Publication and broad media coverage of the 2016 \'Greening of the Earth\' study showing large CO2-driven vegetation increases (Zhu et al., Nature Climate Change) and NASA press releases highlighting a global \'greening\' trend.","date":"2016-04-24 00:00:00"},{"id":"186364e0-0496-4137-aedd-08a93acb45c7","text":"Coverage in mid\u20112024 of Morocco\u2019s expanded cloud\u2011seeding (Al\u2011Ghaith) programme and Spanish media concern that artificial rainfall efforts could affect neighbouring territories (reported August 28, 2024).","date":"2024-08-28 00:00:00"},{"id":"ce4bfadc-7156-4acb-ad54-dba35724c1fc","text":"Catastrophic late\u2011October 2024 floods in eastern Spain (DANA) that produced widespread destruction and many viral images/videos.","date":"2024-10-29 00:00:00"},{"id":"eaa30024-a42c-44dd-8614-b5fecfe93db1","text":"Ukrainian government reported a substantial increase in defence spending for 2018, publicly committing more resources to the armed forces.","date":"2018-09-24 00:00:00"},{"id":"6c975d06-5e6f-4180-a27f-af1e4cd6b6d1","text":"Verkhovna Rada adopted a new Law on National Security intended to bring Ukraine\'s security institutions closer to NATO standards (adopted June 2018; signed July 2018).","date":"None"},{"id":"1a1036fe-40f5-4390-b808-24415bb34512","text":"OSCE Special Monitoring Mission reported a noticeable rise in ceasefire violations and incidents in Donetsk and Luhansk during mid-2018.","date":"2018-06-24 00:00:00"},{"id":"4aaf367c-9686-43bc-82d2-29f6a2799c9c","text":"Russia held its Vostok-2018 strategic military exercises involving ~300,000 personnel, heavy air and naval assets, and participation from China and Mongolia.","date":"2018-09-24 00:00:00"},{"id":"9b2dabb6-5ae1-499d-8ced-0becc13dd579","text":"Russian authorities repeatedly announced large totals of \'humanitarian aid\' deliveries to Donbas (official claims in 2015 of tens of thousands of tonnes delivered)","date":"2015-12-21 00:00:00"},{"id":"569e374f-3c1a-41f9-a0dd-8382fa562bcd","text":"Putin signed a decree simplifying Russian citizenship for residents of Donetsk and Luhansk","date":"2019-04-24 00:00:00"},{"id":"c17ff997-a5f8-40a5-9388-6ea34db6656d","text":"Russian \'humanitarian convoy\' of hundreds of trucks crossed into eastern Ukraine without Kyiv\'s authorization","date":"2014-08-22 00:00:00"},{"id":"f9b65679-1631-449b-b807-d1fd4da4746a","text":"Kyiv City Council imposes moratorium on public use of Russian\u2011language cultural products in the capital (July 2023)","date":"2023-07-13 00:00:00"},{"id":"30bf2f64-e771-4949-8980-3b6ec5555aab","text":"Kyiv city renamed 95 streets as part of derussification campaign (August 2022)","date":"2022-08-25 00:00:00"},{"id":"5f01571b-6f20-48eb-a0f5-9bc528a2c9c7","text":"Presidential/National Security decision to sanction and take three pro\u2011Russian TV channels (112 Ukraine, NewsOne, ZIK) off the air (Feb 2021)","date":"2021-02-02 00:00:00"},{"id":"b74705cf-c363-4742-91c8-2cd15d504506","text":"Passage of Ukraine\'s 2019 language law strengthening the role of Ukrainian (Law No. 5670\u2011d)","date":"2019-04-25 00:00:00"},{"id":"6b51683f-1256-42bd-8b6a-91a6a7fa057f","text":"Court ban of the Opposition Platform \u2014 For Life political party (June 2022) following its suspension during martial law","date":"2022-06-20 00:00:00"},{"id":"bc772f26-1c54-4444-9adf-ebcab49ae7fe","text":"UNICEF/WHO joint statement announcing support to close a vaccine-derived polio outbreak in Sudan","date":"2020-09-08 00:00:00"},{"id":"292f24fb-5458-4a2a-8be5-7fc08f6f336f","text":"Government changes and public confusion over passport issuance procedures (Cabinet decision)","date":"2024-04-23 00:00:00"},{"id":"96c47ff2-e6b2-49e7-91b4-36c9da5cede1","text":"Major Enerhoatom/energy\u2011sector $100 million kickback probe by anti\u2011graft authorities","date":"2025-11-10 00:00:00"},{"id":"7f084599-1623-4d42-bf4b-4b862f5e8972","text":"Anti\u2011corruption agencies search Andriy Yermak\u2019s apartment/home","date":"2025-11-28 00:00:00"},{"id":"403c5420-2e53-4a20-9b5e-e35280f8134d","text":"Pandora Papers disclosure linking Zelensky and close associates to offshore companies","date":"2021-10-03 00:00:00"},{"id":"1835c7f4-de2b-4164-8b82-fa6adfc3ca0a","text":"House Science Committee oversight and subpoena of NOAA over the 2015 \'pause-buster\' study (Rep. Lamar Smith)","date":"2015-10-24 00:00:00"},{"id":"e1d1489b-8379-4150-be47-22d283933756","text":"CDC changes stance and recommends the public wear cloth face coverings (official recommendation)","date":"2020-04-03 00:00:00"},{"id":"5c4d273b-9230-4adf-b8f0-b49827a4ec76","text":"US Surgeon General Jerome Adams urges public to \'stop buying masks\' amid shortages","date":"2020-03-02 00:00:00"},{"id":"2b9f56ec-523f-4414-b969-1659e9a4f74d","text":"Antonov and media reports noted AN\u2011178 production and delivery disruptions under COVID\u201119/quarantine conditions in mid\u20112020","date":"2020-08-24 00:00:00"},{"id":"84caced5-1f11-4f30-85b3-e9cc1fb2b5f9","text":"Ukroboronprom / Spetstechnoexport signed the export contract with Peru for the Antonov AN\u2011178 (first reported publicly)","date":"2019-11-15 00:00:00"},{"id":"c49df9ee-84b6-4d61-803d-996fe5ae4ab4","text":"Poland\'s 2018 \'Holocaust speech\' / IPN amendment (criminalising some statements about Polish responsibility in the Holocaust)","date":"2018-02-24 00:00:00"},{"id":"ce0645ec-7609-47a5-9cc2-2fb81d723322","text":"Scientific coverage that some COVID-19 vaccine candidates used long\u2011established fetal cell lines (HEK\u2011293, PER.C6)","date":"2020-06-05 00:00:00"},{"id":"a8b1f4ae-bb24-4d01-985a-3ed5e9af9c13","text":"Russia\'s domestic gas prices reported far below European levels (Gazprom commentary)","date":"2014-12-24 00:00:00"},{"id":"8603a105-6ea7-414b-a010-6065851a6046","text":"Ukraine suspends/begins to reduce purchases of Russian gas and pivots to European reverse\u2011flows","date":"2015-07-24 00:00:00"},{"id":"9259f1ee-50e3-4e3a-810f-97d1deab67df","text":"Pre\u2011existing academic and public\u2011health research documenting lower vaccination uptake in some Amish communities (example: 2021 study of northeast Ohio Amish vaccination patterns).","date":"2021-04-24 00:00:00"},{"id":"2c6eb48c-219d-4624-a524-61374499a6c2","text":"Destruction of collateral sites (for example the Slovenian consulate in Kharkiv) and multiple simultaneous strikes in the city","date":"2022-03-01 00:00:00"},{"id":"4708fe1a-0f60-44da-9a08-02e513afa594","text":"Missile strike hit Kharkiv Regional State Administration building in Freedom Square (large explosion captured on CCTV)","date":"2022-03-01 00:00:00"},{"id":"4a823ed6-c42d-4cf4-9326-15b6ae845cd6","text":"Russian authorities designated Open Society Foundations \'undesirable\' and banned OSF activities in Russia (2015)","date":"2015-12-01 00:00:00"},{"id":"f1c193fc-6404-49a5-bbbf-d866acb13365","text":"Exiled Crimean Tatar leaders and other legitimate diaspora organizations publicly urged continuation or expansion of sanctions on Russia (e.g., calls from exiled Crimean Tatar leaders for more EU sanctions).","date":"2018-05-24 00:00:00"},{"id":"042ef20a-73df-4a71-abe5-0760038aad5b","text":"Large-scale humanitarian presence by Polish authorities, NGOs and aid projects operating in Western Ukraine (shelters, joint UK\u2011Polish projects in Lviv) as part of wartime assistance.","date":"None"},{"id":"81600820-95e9-4a12-901d-caaec68e738e","text":"Polish parliament (Sejm) adopted the \\"Act on aid for Ukrainian citizens\\" (special law) that simplified legal stay, work and social assistance for Ukrainians in Poland.","date":"2022-03-24 00:00:00"},{"id":"01c6a101-e7a1-490e-89be-3cdfa97902a8","text":"Leaders of Poland, Lithuania and Ukraine (the Lublin Triangle) issued a joint statement and high\u2011level meetings in Kyiv demonstrating accelerated political cooperation.","date":"2022-02-24 00:00:00"},{"id":"7c80c12a-d7df-4343-8b4b-2bb750a57e89","text":"Reporting that Ukrainian troops ran out of ammunition and fled posts in Luhansk (June 2014), including accounts of units abandoning positions.","date":"2014-06-04 00:00:00"},{"id":"ad38848b-442e-4629-88b4-3c66a4f9beef","text":"Reports in 2014 that several Ukrainian troops crossed the border into Russia during heavy fighting in eastern Ukraine.","date":"2014-08-24 00:00:00"},{"id":"950a4afb-6b16-4452-8c32-f06391a6eb0f","text":"Russia\'s formal recognition of the independence of the self-proclaimed Donetsk and Luhansk People\u2019s Republics on Feb 21, 2022.","date":"2022-02-21 00:00:00"},{"id":"6a3252b9-3000-4c23-9e4f-54b368b2f63f","text":"Japan suspends use of some Moderna vaccine lots after reports of foreign particulate matter found in vials.","date":"2021-09-24 00:00:00"},{"id":"9091d87e-8a09-4f86-97b4-a3695200402b","text":"EMA declares a possible link between the AstraZeneca vaccine and very rare cases of unusual blood clots with low platelets.","date":"2021-04-07 00:00:00"},{"id":"01eb0ae5-fa84-40a6-9c52-34656c07b795","text":"Transparency International publication of the Corruption Perceptions Index 2022 (released Jan 31, 2023) showing Ukraine\'s CPI score and ranking","date":"2023-01-31 00:00:00"},{"id":"a272c121-a877-4718-8464-1bd5a96ce2b9","text":"Release of the Joint Strategic Oversight Plan (JSOP) for the U.S. Ukraine response by the DoD/State/USAID Offices of Inspector General","date":"2023-03-27 00:00:00"},{"id":"8381663b-0d95-4b43-910e-511a5204c318","text":"Media reporting that U.S. Congress was turning attention to oversight of Ukraine aid (Roll Call coverage)","date":"2023-02-27 00:00:00"},{"id":"297d1ba2-974f-43a0-b62a-ba723ea87519","text":"Reporting that Kyiv and other areas organized distribution of rifles and ammunition to civilian militias (e.g., plans to distribute tens of thousands of small arms and millions of rounds).","date":"2022-02-26 00:00:00"},{"id":"d24c3b2a-6927-4d4f-8c94-e11959f856bc","text":"Analyses and expert commentary raised early concerns that weapons flowing into/conflict zones could be diverted to illicit markets and organized crime in the region.","date":"2022-03-24 00:00:00"},{"id":"102df67c-d144-4e2a-ae35-34d15662a08b","text":"Ukrainian president publicly urged citizens to \'take up arms\' and promised to arm those willing to defend the country.","date":"2022-02-24 00:00:00"},{"id":"f49591dc-a252-46d5-9c5b-8cdddafe669b","text":"Multiple reports described looting, chaotic seizures and movement of weapons during early weeks of the invasion, including eyewitness accounts of armory looting and seized materiel.","date":"2022-03-16 00:00:00"},{"id":"8aad2ff8-5dab-4507-aaa0-4b93cf9bd890","text":"WADA added meldonium to the prohibited list effective 1 January 2016 and high-profile meldonium cases (e.g., widespread media coverage in early\u2013mid 2016) kept doping in the headlines throughout 2016.","date":"2016-03-24 00:00:00"},{"id":"402383f6-7e8e-4fe5-98d1-2f49ecc8992b","text":"UEFA had run its largest-ever anti-doping programme at Euro 2016 and on 1 July 2016 published that all tournament doping tests had returned negative results.","date":"2016-07-01 00:00:00"},{"id":"654b1932-6580-4646-99d2-5e498312d281","text":"Publication of a health-technology rapid review recommending consideration of pre\u2011treatment mouth rinses in dental settings (CADTH report on pre\u2011treatment mouth rinses).","date":"2020-04-17 00:00:00"},{"id":"cf239229-aa46-44db-8fce-721d466fcdf9","text":"Publication of a peer\u2011reviewed review article (Use of mouthwashes against COVID\u201119 in dentistry) noting that povidone\u2011iodine mouthwash/nasal spray may reduce viral load and cross\u2011infection in dental settings (May 4, 2020).","date":"2020-05-04 00:00:00"},{"id":"46029ac4-9931-4eb9-a261-618a19919178","text":"Case series and literature review reporting 22 cases of new-onset inflammatory rheumatic diseases after COVID-19 vaccination (European Review for Medical and Pharmacological Sciences)","date":"2023-03-24 00:00:00"},{"id":"edef2453-14fd-47f1-87fe-2e982fe3cd5e","text":"Release of a medRxiv preprint protocol and early scoping material (Sept 3, 2023) on COVID-19 vaccines and autoimmune disorders","date":"2023-09-03 00:00:00"},{"id":"15cbd724-371f-49a4-a658-a30558418d7d","text":"The New York Times publishes an opinion essay \'Donor Organs Are Too Rare. We Need a New Definition of Death.\'","date":"2025-07-30 00:00:00"},{"id":"3e86ebe1-a67e-4d4b-848b-e3d840e4902d","text":"IPCC Special Report on Global Warming of 1.5 \xb0C released, emphasizing much greater risks at 2 \xb0C and urgency of rapid mitigation","date":"2018-10-08 00:00:00"},{"id":"cd18e4e1-b254-4b25-812f-84266b128a47","text":"United Nations Secretary-General and UN agencies issued high-profile warnings in 2018 about nearing a \'point of no return\' and called for emergency action","date":"2018-09-10 00:00:00"},{"id":"3cc24982-0e8e-402e-bc62-17a64ee6c945","text":"Peer\u2011reviewed reports of increased myocarditis cases after mRNA COVID\u201119 vaccination (large health\u2011care organization study)","date":"2021-10-24 00:00:00"},{"id":"66c5719f-412b-4670-af81-4531155c53ee","text":"Steven R. Gundry AHA (Circulation) abstract reporting raised PULS cardiac\u2011test inflammatory markers after mRNA vaccination (abstract 10712)","date":"2021-11-24 00:00:00"},{"id":"147db351-5f97-4654-b8d4-bcee7ef4a9c5","text":"Patent filings in 1989 listing Robert W. Malone as an inventor on early RNA/mRNA delivery and vaccine\u2011related patents.","date":"None"},{"id":"24f64892-fea8-41c8-be4a-4d4252def5c3","text":"Indexing and citation of Malone\'s 1989 work in biomedical databases (PubMed/Europe PMC) and secondary summaries.","date":"None"},{"id":"89096621-ccff-490a-834b-b5c0636df3a7","text":"Publication of \'Cationic liposome-mediated RNA transfection\' (Malone, Felgner, Verma) demonstrating mRNA can be delivered into cells.","date":"1989-08-15 00:00:00"},{"id":"60857a55-6193-4bd3-9d2f-63e1ba65d563","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan and temporary batch suspensions (September 2021)","date":"2021-09-24 00:00:00"},{"id":"b75e94f6-e39d-40f2-b811-999f17412dce","text":"Small pilot study reporting detectable SARS\u2011CoV\u20112 spike antigen in plasma of some mRNA\u20111273 (Moderna) vaccine recipients (Ogata et al.)","date":"2021-05-24 00:00:00"},{"id":"09cba8b1-bb6e-4bfd-8101-83de3c034186","text":"American Bird Conservancy (and other conservation NGOs) public statements and campaigns highlighting risks of wind farms to raptors and calling for \'bird\u2011smart\' planning (e.g., ABC \'Rethinking Wind Turbines\' materials and Vineyard Wind statement)","date":"2021-05-18 00:00:00"},{"id":"06a4bfe7-f036-450e-ad63-0e9898e7d636","text":"U.S. Fish & Wildlife Service final rule revising eagle incidental take permitting, including a general permit option for wind energy (Federal Register/public guidance)","date":"2024-02-12 00:00:00"},{"id":"d5bd185c-ef57-4e4a-b660-99b8fcb2005c","text":"Release of Loss et al. (2013) meta\u2011analysis estimating annual bird collision mortality at U.S. wind facilities (widely cited ranges: ~140,000\u2013328,000 birds/yr and broader ranges cited elsewhere)","date":"2013-12-24 00:00:00"},{"id":"137a6f5e-f49b-41b5-bf2c-02f074fe9c84","text":"Russian Defence Ministry public statement accusing Ukrainian forces of using phosphorus-filled munitions near Hostomel (Gostomel) airfield.","date":"2022-02-27 00:00:00"},{"id":"be2bced6-c4a5-48ad-8ede-83c8491b1c74","text":"Pre-existing precedent of mutual accusations over incendiary/phosphorus use in earlier Ukraine conflicts (2014\u20132015), documented by monitoring bodies.","date":"2015-05-24 00:00:00"},{"id":"e4d4d79d-b10f-4d08-a363-500fae00fb83","text":"UNICEF / UN agencies\' early displacement reporting (end\u2011March 2022) showed millions fled Ukraine but the largest single share went to neighbouring EU countries (e.g., ~2.3 million to Poland by March 30, 2022).","date":"2022-03-30 00:00:00"},{"id":"4490b780-f23f-4479-9e7d-54bdc8c5521d","text":"Multiple media reports in April\u2013May 2022 documented evacuations from besieged cities (notably Mariupol) in which some evacuation corridors or buses ended up routing civilians into Russia rather than to Ukrainian\u2011held territory.","date":"None"},{"id":"8dc629cc-6231-4ba2-a045-563637816f47","text":"Russian government issued a decree to simplify and fast\u2011track acquisition of Russian citizenship for residents of occupied Ukrainian regions (passportisation/policy announced May 2022).","date":"2022-05-25 00:00:00"},{"id":"80dfeeb7-ac38-42b1-b1ea-fa79408aa30e","text":"Russian foreign minister Sergey Lavrov publicly claimed that more than 1 million people had been \'evacuated\' from Ukraine into Russia.","date":"2022-04-30 00:00:00"},{"id":"8adca138-48cf-4cec-8ee7-f3b21d0c6e8b","text":"Publication of peer-reviewed lab research (Heliyon, PubMed Central) showing antimicrobial activity of onion skin extracts (in vitro).","date":"2020-11-12 00:00:00"},{"id":"8ad63261-9f3a-4a04-b6b0-8538bec06f31","text":"Ukrainian Ministry of Social Policy announced registration of 1.58 million IDPs from Donbas and Crimea.","date":"2017-06-19 00:00:00"},{"id":"aa124032-a0ad-44b6-8e8f-2e7e273ef0eb","text":"IOM National Monitoring System report (June 2017) identified unemployment as the most problematic issue for IDPs and documented barriers to employment.","date":"2017-06-24 00:00:00"},{"id":"9bb4a6f5-b8ce-4b2e-aabb-3bb74868c8bd","text":"Atlantic Council report (2015) and related studies documented employer discrimination and negative media portrayals against IDPs from Donbas (including job adverts excluding Donbas residents).","date":"2015-04-24 00:00:00"},{"id":"a65d0fc8-2448-4a5d-924a-b04069b6fc51","text":"International Tribunal for the Law of the Sea (ITLOS) ordered Russia to release three Ukrainian naval vessels and their crews","date":"2019-05-25 00:00:00"},{"id":"ea47cd6c-8c9d-45fd-90d1-ba14cea5fec8","text":"September 2019 Russia\u2013Ukraine prisoner swap that included the release of 24 Ukrainian sailors seized in the Kerch incident","date":"2019-09-07 00:00:00"},{"id":"a5c5b65b-1f44-4639-982c-5025cf54c182","text":"Anti\u2011NATO demonstration in front of the U.S. Embassy in Bratislava","date":"2015-03-24 00:00:00"},{"id":"302e2cc2-3c88-4d37-b183-ae8e562b26dd","text":"Washington Post reports Western countries supplying more and heavier weapons to Ukraine (coverage of weapons shipments and policy shifts).","date":"2022-04-26 00:00:00"},{"id":"af2c3128-fc8e-4faf-8982-9ba6b27e0e80","text":"NATO and the United States announced reinforcements to Eastern Europe (ships, fighter jets and additional troops put on alert).","date":"2022-01-24 00:00:00"},{"id":"cec36efa-53e2-4ab2-b41e-6b9e8bb2509a","text":"Reports that U.S. military trainers previously operating in Ukraine were being withdrawn as the invasion threat rose (indicating U.S. personnel had been present inside Ukraine).","date":"2022-02-12 00:00:00"},{"id":"d851bb9b-c1dd-4b50-b86d-d7e0a70fcc71","text":"Continued availability/promotion of Hoxsey therapy in Tijuana, Mexico (clinics offering the regimen)","date":"2022-04-24 00:00:00"},{"id":"2ce479fd-0786-42c1-ac4d-082e5c7da9a9","text":"Regulatory and enforcement actions against colloidal silver and related products marketed as COVID-19 treatments (FDA warning letters in 2020; DOJ injunction halting sale of silver product April 29, 2020).","date":"2020-08-14 00:00:00"},{"id":"dd0a5af4-8344-4b4c-a3db-f0654ea0fbe2","text":"Publication of randomized trials showing some benefit for inhaled budesonide in early COVID-19 (STOIC trial / Lancet Respiratory Medicine reporting, April 2021).","date":"2021-04-09 00:00:00"},{"id":"4d10fff5-7f39-4071-88fd-5dd756dceb9a","text":"Amnesty International briefing (October 2014) documenting summary killings in eastern Ukraine while cautioning that some atrocity reports had been misreported or exaggerated.","date":"2014-10-24 00:00:00"},{"id":"ff0dd947-d591-4a91-98f5-7e8568e5a3ee","text":"Discovery and media reporting of a mass grave near Sloviansk (exhumed July 24, 2014) during the eastern Ukraine fighting.","date":"2014-07-24 00:00:00"},{"id":"b6ed7ce5-601b-4916-aec6-97171aa1061b","text":"Formation and visible operations of the Azov volunteer battalion (formed May 2014) alongside National Guard units in 2014, generating reports about far\u2011right elements within volunteer units linked to the state security apparatus.","date":"2014-05-05 00:00:00"},{"id":"52ae8b98-0c2e-45b6-84d4-fd25071809c6","text":"Parliament adopts the 2019 \'On ensuring the functioning of Ukrainian as the State language\' law","date":"2019-04-25 00:00:00"},{"id":"cb5848bb-bde4-4f81-a8d8-dac5555f3d7b","text":"President Zelenskiy/NSDC sanctions and broadcasting blocks on three pro\u2011Russian TV channels","date":"2021-02-02 00:00:00"},{"id":"9f61cba0-938a-4422-abfa-db301ff868e1","text":"Passage of decommunization laws banning Soviet symbols and reshaping public memory","date":"2015-04-24 00:00:00"},{"id":"b4f1c228-054d-4b10-9e6d-9b2bcf5b05f3","text":"Adoption of the 2017 Education Law with provisions on language of instruction","date":"2017-09-05 00:00:00"},{"id":"9d9755e7-2d6b-471e-9d6e-6602173c5e12","text":"Zelensky withdrew or delayed controversial decentralization/reintegration bills (including a draft on decentralization/reintegration of Donbas) in early 2020 amid criticism and revision.","date":"2020-01-16 00:00:00"},{"id":"92f6dcbf-31fe-4a96-a55d-1a6bc36d8c2b","text":"Domestic controversy in Ukraine over the \u2018Steinmeier formula\u2019 (autumn 2019) and protests against implementing Minsk\u2011related measures.","date":"2019-10-24 00:00:00"},{"id":"55516b8d-0683-4117-ad3c-ec5487d82730","text":"Early 2021 reports and papers documenting vaccine\u2011induced immune thrombotic thrombocytopenia (VITT) after adenoviral-vector COVID-19 vaccines (e.g., AstraZeneca), including cases of cerebral venous sinus thrombosis.","date":"2021-03-24 00:00:00"},{"id":"c2401e50-09b0-40a7-9572-7e712e2d271a","text":"Israel ends mandatory water fluoridation (policy change reported August 2014)","date":"2014-08-24 00:00:00"},{"id":"8ec85d90-fc7b-4af1-9c84-98cf7584c0b7","text":"National Research Council (NRC) report \'Fluoride in Drinking Water: A Scientific Review of EPA\'s Standards\' (2006)","date":"2006-04-24 00:00:00"},{"id":"9b70c841-3399-48a6-9656-f80396fdc314","text":"Arrest of four men by the SBU alleged to be smuggling uranium\u2011238 in western Ukraine","date":"2015-08-05 00:00:00"},{"id":"5caeed35-980a-4cdc-8f83-12122d6ac3b7","text":"Reports that conflict damaged or destroyed radiation detection/monitoring equipment supplied to Ukraine","date":"None"},{"id":"3758d0d9-bc1d-4755-a92a-34b2b5b49878","text":"Peer\u2011reviewed assessment of radionuclide resuspension and atmospheric transport from the 2015 Chernobyl fires","date":"None"},{"id":"e00401eb-37ca-4d71-a936-54f7c6dcfb52","text":"WHO interim guidance on mask use updated (June 5, 2020)","date":"2020-06-05 00:00:00"},{"id":"8cb31e1c-ec7e-45e0-9991-a1721f0650c9","text":"Publication of the Great Barrington Declaration advocating \'focused protection\' (October 4, 2020)","date":"2020-10-04 00:00:00"},{"id":"edbe9a31-3a33-4d14-87f3-befeab22bef0","text":"Announcement of Operation Warp Speed / rapid vaccine development programs (May 15, 2020)","date":"2020-05-15 00:00:00"},{"id":"31852110-628f-48e8-a05c-31ccee743dce","text":"Public remarks by Ukraine\u2019s TCG representative Iryna Herashchenko noting lack of progress on exchanges","date":"2018-05-04 00:00:00"},{"id":"ecd54e83-ea75-438a-a38a-78890ca0d766","text":"Background context: prisoner exchanges had been irregular/stalled since late 2017 (last major swap Dec 27, 2017), creating a longer-term perception of negotiation breakdowns","date":"2018-02-28 00:00:00"},{"id":"7cf42c5e-169f-4ebe-ab61-f1a10e95149f","text":"Trilateral Contact Group (Minsk) humanitarian subgroup meeting (early May 2018) reported to have produced \'no results\' on prisoner lists","date":"2018-05-04 00:00:00"},{"id":"ce9d23e1-d0d6-401c-8f9e-9ade8ee9bfad","text":"WHO interim laboratory testing guidance (March 19, 2020) describing that nucleic acid detection indicates viral RNA presence but does not directly specify infectious virus for all sample types.","date":"2020-03-19 00:00:00"},{"id":"7c090bae-4199-4bf7-9604-5c65660aff00","text":"Publication of the WHO-recommended/early RT\u2011PCR assay protocols (Corman et al., Eurosurveillance) that specify short primer/probe targets.","date":"2020-01-23 00:00:00"},{"id":"98818f07-7366-4038-8c67-126e16ada268","text":"CDC and FDA recommended a temporary pause in the use of the Johnson & Johnson (Janssen) COVID-19 vaccine following reports of rare blood clotting events.","date":"2021-04-13 00:00:00"},{"id":"04806cd9-9b90-4ae0-af5f-b60428f4ac1a","text":"United Nations\u2019 admission of a role in the 2010\u20132016 Haiti cholera outbreak (U.N. acknowledgement, 2016)","date":"2016-08-24 00:00:00"},{"id":"d0771d19-f756-4cd3-9786-9fde6fbf2023","text":"1996 Pfizer Trovan drug trial in Kano, Nigeria (reports of child deaths and subsequent lawsuits)","date":"1996-04-24 00:00:00"},{"id":"0778b390-a2ee-4d01-98c9-cb1a9bde1902","text":"Release of the NIPCC report \'Climate Change Reconsidered II\' (skeptic alternative to IPCC) that downplays harms of rising CO2 and highlights perceived benefits.","date":"2013-09-24 00:00:00"},{"id":"35c1e621-4969-4e5c-9003-b0583ca8939c","text":"Public-health guidance and technical documents (e.g., UK \'Understanding cycle threshold (Ct) in SARS-CoV-2 RT\u2011PCR\') explaining Ct interpretation variability and assay differences circulated during 2020.","date":"2020-09-24 00:00:00"},{"id":"e9be2f07-0ef3-4c7e-aa68-19ae2471474c","text":"Peer\u2011reviewed/clinical comparisons published showing comparable detection rates between saliva and nasopharyngeal swabs (Journal of Infection letter, June 2020)","date":"2020-06-04 00:00:00"},{"id":"8e3d1db2-3b77-4d35-9896-79ee893fef39","text":"FDA issues Emergency Use Authorization for Rutgers\' saliva-based COVID-19 test","date":"2020-04-13 00:00:00"},{"id":"b423ba88-db77-4c34-a7a6-f53445b95467","text":"IPCC Fifth Assessment Report (AR5, 2013) presentation of sea-level projections with explicit uncertainty ranges and caveats.","date":"2013-04-24 00:00:00"},{"id":"8db37b71-9f12-49f1-bb1a-ba3ccda5847b","text":"US political signal: announcement of intent to withdraw from the Paris Agreement (President Trump, June 1, 2017) and sustained political amplification.","date":"2017-06-01 00:00:00"},{"id":"32e32477-4bb8-4504-a027-27fc77d8c334","text":"Poland\'s competition watchdog opens proceedings against Gazprom over Nord Stream 2","date":"2018-05-16 00:00:00"},{"id":"9e1996d1-59c5-4235-96d7-3177babcb7f3","text":"Poland\'s controversial \'Holocaust law\' sparks international criticism","date":"2018-01-27 00:00:00"},{"id":"b5679d9f-403a-48aa-a58b-18d8bee4635c","text":"European Commission triggers Article 7 procedure against Poland over judicial reforms","date":"2017-12-20 00:00:00"},{"id":"ccafa14f-33e2-4e2f-844e-8fca6079b32a","text":"Law and Justice (PiS) strong performance in the 2019 European Parliament elections","date":"2019-05-26 00:00:00"},{"id":"2a611ae1-745b-4bb1-ae10-25288b6cb9fc","text":"Reports of illicit trafficking and discovery of radioactive sources in scrap/transport (Ukraine, 2015)","date":"2015-04-24 00:00:00"},{"id":"682d7d53-1e3b-4d7c-ae9a-5c149108e4f9","text":"2015 wildfires in the Chernobyl Exclusion Zone and fears of radionuclide resuspension","date":"2015-04-24 00:00:00"},{"id":"dbd04912-2116-4721-be14-a71801cd3c32","text":"Calving of iceberg A\u201168 from the Larsen C ice shelf (July 2017).","date":"2017-07-12 00:00:00"},{"id":"69b95343-c252-4a88-8e33-88c27080b854","text":"California expanded laws and funding to increase prescribed and cultural burning (state bills and Newsom signings, October 2021) to reduce fuels.","date":"2021-10-11 00:00:00"},{"id":"08c4a7d8-a808-40c5-b31a-7003fa42378b","text":"California utilities implemented mass Public Safety Power Shutoffs (PSPS) in 2019 to prevent power\u2011line ignitions during high\u2011wind conditions.","date":"2019-10-24 00:00:00"},{"id":"aa7d3860-9a7b-4b71-9e39-2d706c63a28e","text":"Public statements and media interviews by frontline firefighters expressing that poor forest conditions and suppression policy (not climate change alone) drive severe fires (example: Sky News interview with California firefighter, Aug 2020).","date":"2020-08-24 00:00:00"},{"id":"c4b94532-7a76-4ebc-a460-d01465b113e2","text":"PG&E pleaded guilty to 84 counts of involuntary manslaughter and unlawfully starting the 2018 Camp Fire, confirming utility equipment ignition of a major California blaze.","date":"2020-06-16 00:00:00"},{"id":"12a88459-c669-4b94-9645-9be73587f944","text":"UNDP/SEESAC and other surveys (2012\u20132016) documenting large numbers of small arms and light weapons \u2014 including unregistered/illicit stockpiles \u2014 in Moldova and the region","date":"2016-04-24 00:00:00"},{"id":"e860db1a-8641-4f76-a140-b16a9d94307d","text":"Kuwait arrests members of an alleged ISIS-supporting cell who reportedly claimed to have bought weapons via Ukraine","date":"2015-11-19 00:00:00"},{"id":"5a8463b3-4d4f-4daf-b7b8-dd573ad540c6","text":"Public and political skepticism, local resistance and commentary about his appointment in Odesa (reports of local political tensions)","date":"2015-05-31 00:00:00"},{"id":"6db38e74-24f3-4a2f-ae3a-8d02b9d72dd8","text":"Appointment of Mikheil Saakashvili as Governor (head) of Odesa Oblast","date":"2015-05-30 00:00:00"},{"id":"603921ad-e52a-4410-99ec-8fd86d16e5c2","text":"Cabinet of Ministers submits Draft Law No. 10449 on mobilization to the Verkhovna Rada","date":"2024-01-30 00:00:00"},{"id":"74e64fca-287d-4d78-a676-00b2f615bdcf","text":"Israel / NEJM studies (2021) reporting a small increased incidence of myocarditis after Pfizer mRNA vaccination, especially in young males","date":"2021-10-06 00:00:00"},{"id":"59688e0a-e6b1-4686-9d80-3ed2b50a11b0","text":"Japan suspends and recalls Moderna vaccine batches after discovery of black/stainless\u2011steel particles in vials","date":"2021-09-01 00:00:00"},{"id":"cd5c2b41-5c7f-4a55-9ab2-88fc3ef91c4c","text":"UN/IAEA inspection mission planning and travel to Zaporizhzhia amid continued shelling and accusations by both sides.","date":"2022-08-29 00:00:00"},{"id":"65a33ed5-7059-4720-8664-71df06856cd6","text":"A fire and visible shelling at the Zaporizhzhia site during early March combat (surveillance footage showed a flare/impact on site).","date":"2022-03-04 00:00:00"},{"id":"9579faa0-0177-45b7-9056-8029d8924320","text":"Repeated losses of external (off\u2011site) power to the Zaporizhzhia plant and reports that the plant was at times disconnected from its last external power line.","date":"2022-08-24 00:00:00"},{"id":"95e05178-60f7-4cbe-bd9b-5bf961bdef01","text":"Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the Battle of Enerhodar.","date":"2022-03-04 00:00:00"},{"id":"e8a190db-bcc2-4cc0-8eb7-44c244f670d8","text":"CDC changes public guidance to recommend cloth face coverings in public settings (official guidance posted April 3, 2020)","date":"2020-04-03 00:00:00"},{"id":"a2bb928e-2e84-4e3e-81ee-b83ba79b568d","text":"Study estimating high proportion of asymptomatic SARS-CoV-2 infections on the Diamond Princess cruise ship (Mizumoto et al., Euro Surveill., published Feb 2020)","date":"2020-02-12 00:00:00"},{"id":"748a15bf-517c-467d-b641-dc29fcee8d35","text":"NEJM correspondence reporting transmission of 2019-nCoV from an apparently asymptomatic contact in Germany (Rothe et al., published Jan 30, 2020)","date":"2020-01-30 00:00:00"},{"id":"e1847ff0-930b-42fd-a04c-2eb5f02fd7e0","text":"OPCW Investigation and Identification Team (IIT) first report identifying Syrian government responsibility","date":"2020-04-08 00:00:00"},{"id":"735a9667-6b3e-4e28-89bd-78eefd76f362","text":"Human-rights organisations report abuses by volunteer battalions deployed in Donbas","date":"2015-04-24 00:00:00"},{"id":"da008d27-7472-4d62-996b-7ab8966b19c8","text":"Integration of volunteer battalions (including Azov) into Ukraine\'s National Guard","date":"2014-11-11 00:00:00"},{"id":"7731cec2-7cdd-4637-a82a-9e0a7fc3523b","text":"March 2015 incident where armed men linked to oligarch Ihor Kolomoisky occupied state oil company offices","date":"2015-03-23 00:00:00"},{"id":"31ee3b51-269e-4dfc-8198-05a6d28587ab","text":"Reports of timber import restrictions and new controls on Russian wood across Europe and the UK","date":"2022-03-24 00:00:00"},{"id":"c8625782-7e9f-43f8-9213-eb09f5957d9c","text":"UK and allies impose wide-ranging sanctions on Russia after the 2022 invasion","date":"2022-03-24 00:00:00"},{"id":"657382bb-d2cb-4305-9efb-21db8233240c","text":"News coverage of reusable/eco toilet-paper products appearing on the UK market","date":"2022-08-16 00:00:00"},{"id":"f3f664b5-f1c9-46f1-acd1-599ecafc9a9f","text":"Euronews published video coverage (Feb 5, 2022) of the Kharkiv Unity March showing large Ukrainian-language banners (e.g., \'Kharkiv is Ukraine\') and many Ukrainian flags, with only a small number of English-language signs visible in brief shots.","date":"2022-02-05 00:00:00"},{"id":"12b17193-4706-4f24-ad55-383db3074772","text":"Growing public debate and some evidence of souring Polish attitudes toward Ukrainian refugees documented in 2022 news reports and surveys.","date":"2022-08-04 00:00:00"},{"id":"1ca2ef26-0ed5-4d56-850e-a636b6eff698","text":"Leszek Sykulski and collaborators announced a Polish anti-war movement and proposed billboard campaign with the slogan \'This is not our war\'.","date":"2023-01-31 00:00:00"},{"id":"e81e7d4f-67c0-48fd-a9d7-8ff407f9d70b","text":"White House announces 50\u201352% economy-wide greenhouse gas reduction target (Leaders Summit on Climate fact sheet)","date":"2021-04-22 00:00:00"},{"id":"d3a08662-4d96-4236-96ba-063d7de46717","text":"Poore & Nemecek (Science) meta-analysis showing high emissions from beef and animal products","date":"2018-06-24 00:00:00"},{"id":"d745da97-1080-4d18-a214-49591427f1cc","text":"EAT-Lancet Commission releases \'planetary health diet\' recommendations (widely covered)","date":"2019-01-24 00:00:00"},{"id":"f842785f-7bc0-41b7-8adf-4be7195bfd1f","text":"Adoption of Ukraine\'s 2017 \'On Education\' law increasing Ukrainian-language instruction (and subsequent Venice Commission attention/criticism)","date":"2017-09-05 00:00:00"},{"id":"87e1ed4d-7fb1-495b-8e0a-a85a0d6596a2","text":"Lviv Oblast Council approves a moratorium on public use of Russian-language books, films and music in the region","date":"2018-09-18 00:00:00"},{"id":"a1029f55-fc1f-462b-a001-b99c9358ee2e","text":"2015 restrictions on Russian films and cultural imports (bans/curbs on films and some cultural products after 2014)","date":"2015-04-06 00:00:00"},{"id":"55d5c23f-5205-4f18-b5d6-5fd8b9299c4b","text":"Reversal of the 2012 regional-language law (the Kivalov\u2013Kolesnichenko law) after the 2014 Maidan changes","date":"2014-02-23 00:00:00"},{"id":"cb74013e-54c4-4e79-ad4f-9c3287eb0ec8","text":"U.S. safety monitoring system (CDC Vaccine Safety Datalink) detected a statistical signal for ischemic stroke in people aged 65+ after the Pfizer\u2013BioNTech bivalent booster; CDC/FDA announced they were investigating the signal.","date":"2023-01-13 00:00:00"},{"id":"18a6c232-9e9e-4d2e-bb6f-4c32c1876c91","text":"Earlier vaccine safety controversies (notably rare clotting events linked to adenovirus-vector COVID-19 vaccines such as AstraZeneca in 2021) remained widely recalled and were used as precedent by commentators to suggest COVID vaccines can cause serious cerebrovascular events.","date":"2021-04-24 00:00:00"},{"id":"1dc2d18f-7d20-40b4-b306-835da288cc24","text":"Russia\u2019s parliament approved President Putin\u2019s request to use armed forces in Ukraine","date":"2014-03-01 00:00:00"},{"id":"24afa0a8-4d76-40ce-9afa-3bf870a96fce","text":"Chinese Foreign Ministry urged restraint and avoided direct comment on the Crimea referendum","date":"2014-03-03 00:00:00"},{"id":"7caa6b44-edda-4b37-8343-03733cfae459","text":"Unidentified armed men (widely reported as Russian forces) seized Crimean airports (Simferopol and Belbek) and other sites","date":"2014-02-28 00:00:00"},{"id":"48103b8c-b7b1-4459-b902-e8dd3da7e54d","text":"CMS release of the Medicare COVID-19 Vaccine Public Use File (PUF) / Medicare COVID-19 vaccine analysis","date":"2021-08-06 00:00:00"},{"id":"950d7990-be2c-4d4d-b8cd-183b3456afd1","text":"April 2021 pause and review of the Johnson & Johnson (Janssen) COVID\u201119 vaccine after reports of rare blood\u2011clotting events (TTS).","date":"2021-04-13 00:00:00"},{"id":"84b11ee7-077e-47f6-80fc-01a20fe348eb","text":"Japan suspended and recalled multiple Moderna vaccine batches after reports of contamination (stainless\u2011steel particles) at some vaccination sites.","date":"2021-08-25 00:00:00"},{"id":"f9fb6469-9308-42c3-b83c-a05198123ffe","text":"Poland publicly pushed for coordinated EU action over Belarus and called for an extraordinary EU response after the election","date":"2020-08-10 00:00:00"},{"id":"9e531e8e-237f-4247-b459-eae80fadd5e9","text":"Belarus opposition figure Sviatlana Tsikhanouskaya flees Belarus to neighbouring Lithuania","date":"2020-08-11 00:00:00"},{"id":"a54a02cb-64db-4c71-b0e0-1adb45b0c3c3","text":"Lukashenko publicly accused opponents and foreign states of meddling in Belarusian affairs (blaming outside influence) in early August 2020","date":"2020-08-04 00:00:00"},{"id":"69ee9d16-acbf-4105-8a4e-7742e50c76c9","text":"Scientific and review literature summarizing Traditional Chinese Medicine meridian theory and the popular \\"tooth-to-organ/meridian\\" charts (peer-reviewed reviews / PMC article)","date":"2013-04-24 00:00:00"},{"id":"d80a8c53-92e9-4ff9-a558-32a8b1313d4a","text":"Peer\u2011reviewed survey showing TikTok is a major source of health information for young women (published May 21, 2024)","date":"2024-05-21 00:00:00"},{"id":"43f29fae-8a37-48a2-ac30-5cdadd238303","text":"Longstanding \'hockey stick\' controversy and critiques (McIntyre & McKitrick and public debate 2003\u20132007)","date":"None"},{"id":"e6edeb03-0ca9-422f-b5fa-4244d92faf5d","text":"OSCE SMM spot report on shelling incidents in Mariupol (Olimpiiska Street) reporting civilian casualties","date":"2015-01-24 00:00:00"},{"id":"2a5f7b1f-2bcb-48ea-84c8-82d1106b3c3f","text":"High-profile shelling of a bus/trolleybus stop in Donetsk reported to have killed civilians (media reports, Jan 22, 2015)","date":"2015-01-22 00:00:00"},{"id":"4006480a-753c-45ce-aa6b-ecf3456a9b65","text":"OSCE SMM statement (weekly update) noting 29 people had been killed \'this year\' as of mid-January","date":"2015-01-15 00:00:00"},{"id":"a38e8719-88d5-46ef-90f4-a32993b6cfdc","text":"IFRC deployment to assist Ukraine outbreak response (Red Cross mobilised to help contain largest measles outbreak in Europe)","date":"2019-03-05 00:00:00"},{"id":"6d355a7b-b9d4-4acc-853e-dd80ef633109","text":"EU visa\u2011suspension mechanism in law (Regulation creating a mechanism to temporarily suspend visa\u2011free travel, adopted 2013)","date":"2013-12-11 00:00:00"},{"id":"8a50c084-5b2c-4fdb-ad04-e211a34541ee","text":"Deployment/arrival of U.S. troops to Poland as part of NATO rotations (Zagan arrival reported)","date":"2017-01-12 00:00:00"},{"id":"34cb44d4-ecd2-467c-9936-4a6b286b6edb","text":"Polish government passes resolution to create the Central Communication Port (CPK) programme","date":"2017-11-09 00:00:00"},{"id":"3f46d12f-b64f-4d48-87e1-1c65835f7681","text":"NATO/US-led exercise Saber Strike 2017 mobilises thousands of troops and long tactical movements across Poland and the Baltics","date":"2017-06-24 00:00:00"},{"id":"ac8bf186-9f81-4e86-bcf8-9581ca6de9ba","text":"U.S. President Donald Trump\u2019s high\u2011profile visit to Warsaw and public expressions of closer US\u2011Poland ties","date":"2017-07-06 00:00:00"},{"id":"e2cc15df-04af-44fd-bb34-b2ad74cc09fe","text":"Public descriptions of CPK emphasise a large rail logistics centre and high\u2011speed rail links connecting the planned airport to the national network","date":"2017-04-24 00:00:00"},{"id":"5f00f9bc-f04d-4326-9b92-b94a44d73a3d","text":"IPCC AR6 Synthesis Report (approved and released March 2023) summarizing complex carbon cycle information","date":"2023-03-20 00:00:00"},{"id":"8f89cdbd-4592-4ad5-a926-7e091ad7e6ba","text":"Global Carbon Project publishes the Global Carbon Budget 2022 showing large natural carbon fluxes alongside high anthropogenic emissions","date":"2022-11-11 00:00:00"},{"id":"b96c12ae-9f4e-466b-ae2d-8134b211c5aa","text":"The Economist published analysis \'A Ukrainian attempt to retake Crimea would be bloody and difficult\' framing retaking Crimea as high\u2011risk and costly","date":"2022-11-27 00:00:00"},{"id":"4a1aec55-354a-4dcf-909d-a6903b8a9660","text":"Poland announced it would transfer Leopard tanks/Leopard tank company to Ukraine (President Duda\u2019s statement in Lviv)","date":"2023-01-11 00:00:00"},{"id":"11bae64a-bdb5-4f1c-ad4d-c94f6ca02f82","text":"Madrid (Spain) converted an Olympic-sized ice rink into a temporary morgue amid COVID-19 deaths (widely reported March 24, 2020).","date":"2020-03-24 00:00:00"},{"id":"b2b1a5d6-a348-471b-9c4e-fe7b3293beac","text":"Regulatory reviews and media coverage of rare AstraZeneca blood\u2011clotting events (European/UK reviews and reporting)","date":"2021-03-18 00:00:00"},{"id":"a92b3d5e-f95e-4a99-a370-4c0147a5b7ca","text":"Large overnight Russian attack on Odesa\'s power grid caused region-wide blackouts","date":"2025-12-13 00:00:00"},{"id":"a7cedfd2-fd1a-4ef5-97d2-795081566985","text":"Publication of a broad 2021 review (Nutrients) summarizing diverse immune effects of bovine colostrum","date":"2021-10-26 00:00:00"},{"id":"1c7b73b0-2310-446c-8277-54767060f75d","text":"Contamination and design problems with the CDC\'s initial COVID-19 test kits (early 2020)","date":"2020-02-24 00:00:00"},{"id":"b87164bf-f264-4ec3-bc7d-3b7891722a46","text":"Study showing RT-PCR cycle threshold (Ct) correlates with viral culture positivity (Bullard et al.)","date":"2020-07-24 00:00:00"},{"id":"0acef6c0-1f2d-4dcc-9a90-e29b93793897","text":"IAEA and Ukrainian authorities publicly highlighted nuclear\u2011safety and remediation needs for Ukraine\u2019s legacy nuclear and uranium sites, with heightened attention after 2014.","date":"2014-04-24 00:00:00"},{"id":"bc8de606-d518-472e-8e59-39337287205d","text":"Longstanding presence of large uranium mining and processing facilities in Zhovti Vody (Eastern Mining and Processing Plant), which has processed uranium ores since the late 1950s.","date":"1959-04-24 00:00:00"},{"id":"8207856c-0cb1-442f-97f6-17f538dd9ff6","text":"Ferrybridge motorway service station (UK) brought in a generator to power new EV chargers because of local grid-supply issues.","date":"2023-08-02 00:00:00"},{"id":"8ffdfd68-1b2a-4e92-9ff4-e3e811d91c70","text":"Reporting that Tesla\'s high-profile Harris Ranch \'Mega\' Supercharger location has historically been supplemented at times by diesel generation to meet peak demand.","date":"2023-09-06 00:00:00"},{"id":"17401565-66ca-437e-b0a6-136ef3724107","text":"BMJ coverage summarising tens of thousands of reports of menstrual changes after COVID-19 vaccination (BMJ report on MHRA Yellow Card reports).","date":"2021-09-15 00:00:00"},{"id":"82a4cb5a-2b30-4906-9627-1c8593ce8dc7","text":"Publication of a large Danish cohort study linking hormonal contraception with increased rates of antidepressant use and diagnoses of depression (Skovlund et al.).","date":"2016-09-28 00:00:00"},{"id":"f5ad2cce-9961-444b-8007-5874a232d25a","text":"Release of international PCOS management guidance and reviews identifying combined oral contraceptives as first-line therapy for menstrual regulation and hyperandrogenism in PCOS (International evidence\u2011based PCOS guideline, 2018).","date":"2018-04-24 00:00:00"},{"id":"19352e34-aca6-4dbd-a538-04e985ad70d7","text":"High\u2011profile scientific attention on rapid changes at Thwaites Glacier (BAS reporting, Sept 2019)","date":"2019-09-24 00:00:00"},{"id":"9a14913e-e877-4406-8c04-9675beb0ae54","text":"Poroshenko had a documented public engagement on 23 September 2015 \u2014 a meeting with U.S. Senator John McCain in Kyiv.","date":"2015-09-23 00:00:00"},{"id":"3280a9e5-4f53-42df-97d6-80dfad2b3a63","text":"Pentagon Inspector General report found that about $1 billion worth of U.S. weapons sent to Ukraine were not properly tracked.","date":"2024-01-11 00:00:00"},{"id":"69643293-59b1-4d82-b831-0d3d5c86ed29","text":"President Trump ordered a temporary \'pause\' on deliveries of U.S. military assistance to Ukraine following a heated Oval Office exchange.","date":"2025-03-04 00:00:00"},{"id":"b96a6933-b915-4bf3-8058-724297dab033","text":"Prominent U.S. conservative media figures and commentators publicly questioned the scope and effectiveness of U.S. aid to Ukraine (for example, Laura Ingraham called continued aid \'a losing cause\').","date":"2023-10-31 00:00:00"},{"id":"90b494bf-039b-4e54-a6f1-4c80e755714b","text":"IPCC Sixth Assessment Report (AR6 WG1) release summarizing model performance and attribution of recent warming","date":"2021-08-06 00:00:00"},{"id":"f50a5420-3ac2-4800-aa10-086f3b074789","text":"Publication (1989) of Malone et al., \'Cationic liposome-mediated RNA transfection\' (PNAS), an early demonstration of RNA delivery into cells.","date":"1989-08-15 00:00:00"},{"id":"b060cf25-4818-4962-a079-b0943a233663","text":"Think\u2011tank and Western analyst warnings that the Kremlin was building informational conditions to blame Ukraine for chemical or radiological false\u2011flag attacks","date":"2022-10-24 00:00:00"},{"id":"683c1f14-e8e4-4de8-8dad-c9e3a47ec671","text":"Multiple European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine after reports of blood clots (mid-March 2021)","date":"2021-03-24 00:00:00"},{"id":"bd33352a-5503-4615-89fc-28d9a8fc5de9","text":"Peer-reviewed genome-wide association studies (GWAS) identified an association between the ABO blood-group locus and COVID-19 susceptibility and severity, widely reported in the media in 2020.","date":"2020-06-17 00:00:00"},{"id":"5f06c143-7e85-43b4-bfd8-a9cc5030c2e9","text":"Pre-existing disinformation narratives and documented propaganda techniques had been actively denigrating Ukrainian refugees across Europe since 2022 (e.g., claims that refugees are violent or criminal).","date":"2023-02-19 00:00:00"},{"id":"4cbccbd9-75d6-4806-85d6-6e3f1ac612b0","text":"Rise of anti-Macron / far-right political sentiment in 2024 (EU and national election results and commentary)","date":"2024-06-09 00:00:00"},{"id":"9083b198-ef58-4d0a-b7b5-7f51f62c70a4","text":"WHO-China Joint Mission report (final report) published, summarizing early clinical findings and noting the role of underlying conditions and comorbidities among severe COVID-19 cases.","date":"2020-02-28 00:00:00"},{"id":"b636559f-f440-461e-8b2a-e27f8e0a5bba","text":"Mass issuance of Russian passports to Crimea residents after annexation, with many seen lining up to exchange Ukrainian passports for Russian ones","date":"2014-03-24 00:00:00"},{"id":"1b110999-77b0-4a7f-986f-a8f1d4d159cd","text":"Media reports of waning Pfizer vaccine effectiveness from Israel (mid\u20112021)","date":"2021-07-24 00:00:00"},{"id":"54befbf4-323e-4ec4-b0d5-6b075fbfff8e","text":"Human Rights Watch report on unguided rockets and civilian harm in Donetsk","date":"2014-07-24 00:00:00"},{"id":"97bcabff-36fe-4906-a8f1-49e45a2230c0","text":"Operation Protective Edge (Israel\u2013Gaza), heavy photographic coverage of urban shelling","date":"None"},{"id":"904c1337-d922-43ba-aaf3-bee846b59cc8","text":"UN OHCHR published reports documenting thousands of civilian casualties and human-rights violations in Donetsk and Luhansk since 2014","date":"2019-08-15 00:00:00"},{"id":"9c8061a4-b6c8-4b01-9126-324edde1a3da","text":"Government of Ukraine lodged an Article 12(3) declaration accepting ICC jurisdiction over alleged crimes on its territory (covering events since February 2014)","date":"2015-09-08 00:00:00"},{"id":"6be5c24a-fd13-42a4-aef3-2c7811909f68","text":"International Criminal Court opened a preliminary examination into the situation in Ukraine","date":"2014-04-24 00:00:00"},{"id":"6d97834d-047e-469c-966f-03494c01663a","text":"Multiple U.S. states sought to restrict or suspend abortion services as \'non-essential\' during COVID-19 emergency orders (March\u2013April 2020).","date":"2020-04-24 00:00:00"},{"id":"bcd00958-f1de-40a1-b1c1-5dbcc6a4a0f4","text":"Guttmacher Institute releases \'Abortion Worldwide 2017\' report estimating ~55.9 million abortions per year (2010\u20132014).","date":"2018-04-24 00:00:00"},{"id":"3b01f3e9-0884-4056-9947-42c14ea3c2f3","text":"World Health Organization declares COVID-19 a pandemic (March 11, 2020).","date":"2020-03-11 00:00:00"},{"id":"bf9263f8-2d55-4044-ab20-d275b56ab5b9","text":"European Court of Human Rights applied urgent interim measures (Rule 39) in the Ukraine v. Russia matter (13 March 2014)","date":"2014-03-13 00:00:00"},{"id":"39cddfdc-f4fe-4d95-890f-6f9b9e217019","text":"PACE (Parliamentary Assembly of the Council of Europe) suspension of the Russian delegation (10 April 2014)","date":"2014-04-10 00:00:00"},{"id":"995d8ddb-e382-4194-8310-0522f57d393b","text":"Public confusion about the ECHR\'s mandate versus courts that decide territorial sovereignty (March 2014)","date":"2014-03-24 00:00:00"},{"id":"364ac148-30c9-4ecf-92fa-825712d7a416","text":"Heightened political polarization and emotionally charged Victory Day (May 9, 2014) events in Kyiv, with veterans, Communist Party contingents and pro-Russian demonstrators present.","date":"2014-05-09 00:00:00"},{"id":"108ab024-87d1-47d4-8139-ad46f6e38c35","text":"Regulatory enforcement and warning letters by FDA/FTC in 2021 highlighted widespread illegal disease/treatment claims in supplement marketing.","date":"2021-09-24 00:00:00"},{"id":"07f7a1ed-d849-4bdc-b430-9b256fe4c083","text":"Reports of foreign fighters travelling to Donbas in 2014 (volunteers from Europe and beyond).","date":"2014-08-22 00:00:00"},{"id":"b9bad6ff-5e99-4b92-a9dc-1e6badc97e55","text":"U.S. convictions of former Blackwater guards (October 2014) renewed media attention on private contractors\' misconduct.","date":"2014-10-23 00:00:00"},{"id":"3dca0899-074f-4e9e-b91c-a9ca7458895b","text":"Nisour Square massacre: Blackwater contractors opened fire in Baghdad, killing civilians.","date":"2007-09-16 00:00:00"},{"id":"52a54493-a1f3-4f4c-a7d2-80b44206c556","text":"Heavy fighting and shifting control in Mariupol, May\u2013June 2014 (city taken and later retaken during the Donbas conflict).","date":"2014-06-13 00:00:00"},{"id":"d29718e5-79a9-4622-b7d2-f27b220d6d99","text":"Russian and pro\u2011separatist media claims in 2014 alleging American mercenaries operating in eastern Ukraine.","date":"2014-04-24 00:00:00"},{"id":"54363c74-3a5e-4a0e-a8b7-87b7a9ff59a3","text":"Interview in Berliner Morgenpost where Poroshenko made a nuanced comment about sanctions during an official visit to Germany (covered 2 Feb 2017)","date":"2017-02-02 00:00:00"},{"id":"d9355a2b-e19e-408d-9457-938ec41f605d","text":"High\u2011profile cases of Ukrainian artists (e.g., Ani Lorak) continuing to perform in Russia after 2014 and facing public criticism (documented controversies and petitions in 2014\u20132015).","date":"2015-08-24 00:00:00"},{"id":"386e3406-a1dd-4833-be25-35db72e451dc","text":"Publicised blacklists, bans and ambiguous records of cross\u2011border performances (e.g., compilation lists and public debates about banned performers from 2014\u20132015).","date":"2015-07-24 00:00:00"},{"id":"524949dd-fb0e-4480-b88d-7595fb098a45","text":"Deadly Maidan shootings and clashes (Feb 18\u201320) with widespread reporting that Berkut units used lethal force","date":"2014-02-18 00:00:00"},{"id":"8af73905-0721-418e-a51c-4db9d4d3e8a8","text":"Ukrainian government announced disbandment of the Berkut special police unit","date":"2014-02-26 00:00:00"},{"id":"415ec586-96fb-46fc-9faa-eaecc243e78e","text":"WHO published its COVID-19 excess mortality estimation methodology and model outputs (October 2021), highlighting gaps between reported COVID-19 deaths and modelled excess deaths across countries.","date":"2021-10-24 00:00:00"},{"id":"fcb12daf-7d52-4c56-b04d-e9777de122bf","text":"Divergent national blood-donation guidance on post-vaccination deferral times (e.g., NHS/Blood Services clarifying differences)","date":"2021-04-24 00:00:00"},{"id":"9629e5c8-186c-4e57-91bf-b18b548bc1b0","text":"Reports of vaccine vial contamination (e.g., Japan suspended use of some Moderna lots after foreign particles found)","date":"2021-08-26 00:00:00"},{"id":"385cdb80-f2c1-4e7b-87b1-c21abaad8d71","text":"Documented frequency of climate-skeptic segments on major cable/news programmes (analysis of Fox News coverage up to May 2021)","date":"2021-05-24 00:00:00"},{"id":"a82d71b0-e478-478a-86f2-1e56e05e450f","text":"IPCC Sixth Assessment Report (AR6) Working Group I release and media coverage","date":"2021-08-09 00:00:00"},{"id":"276f71ec-ec4b-4616-a67f-383f7d4c239c","text":"Release of CDC v\u2011safe pregnancy registry supplemental tables and data used in the NEJM report","date":"2021-06-17 00:00:00"},{"id":"65c1d41b-b2cc-460f-a33b-8c41a52344be","text":"Publication of NEJM \'Preliminary Findings of mRNA Covid-19 Vaccine Safety in Pregnant Persons\' (Shimabukuro et al.)","date":"2021-06-17 00:00:00"},{"id":"eae286d6-d908-4958-b808-2f866d9ef706","text":"FDA full approval of Pfizer\u2013BioNTech vaccine (Comirnaty)","date":"2021-08-23 00:00:00"},{"id":"55c5716f-2754-4c82-a473-893c45e6a6a7","text":"FDA expands emergency use authorization to adolescents (ages 12\u201315)","date":"2021-05-10 00:00:00"},{"id":"143587d4-ddc3-4475-9b44-e3d87618bc18","text":"HHS General Counsel Advisory Opinion clarifying PREP Act scope","date":"2020-04-14 00:00:00"},{"id":"5c6f0588-995c-4d20-a836-02ac80210bf5","text":"NATO deployed Enhanced Forward Presence battlegroups to Estonia, Latvia, Lithuania and Poland","date":"2017-07-24 00:00:00"},{"id":"cf2d3a88-17b8-4c10-8916-393a69b12b04","text":"Operation Atlantic Resolve rotations \u2014 U.S. armored and aviation rotations to Poland (2019)","date":"2019-10-24 00:00:00"},{"id":"49d63289-c9af-47f9-bc53-72830a13fe12","text":"Trident Juncture 2018 \u2014 large NATO exercise in Norway with ~50,000 participants, aircraft and ships","date":"None"},{"id":"05a7445f-f8e4-451a-84c5-621b59387db8","text":"Preprints and analyses estimating low infection fatality rates (IFR) from early seroprevalence data (John Ioannidis seroprevalence analysis, May 2020 preprint)","date":"2020-05-13 00:00:00"},{"id":"ed0d1125-13b6-49a3-9515-4aeb847b3975","text":"Historical precedent: 1976 swine\u2011flu vaccination program and Guillain\u2013Barr\xe9 reports","date":"None"},{"id":"cf5b4e71-5bd7-4fab-8dba-5b8915af2a53","text":"Professional guidance discouraging routine MTHFR testing (ACMG practice guideline)","date":"2013-01-03 00:00:00"},{"id":"45f128ba-256c-4b24-a061-347799ffdf5a","text":"Peer\u2011reviewed 2020 paper (Mesnage et al.) reporting glyphosate effects on the gut microbiome / shikimate pathway","date":"2020-04-22 00:00:00"},{"id":"fee2129d-d97d-4fb2-9d74-9637bdb59a06","text":"President Zelensky announced draft legislation proposing a route to Ukrainian citizenship for foreign fighters","date":"2024-01-22 00:00:00"},{"id":"e47653a8-b66a-4155-8f1d-5ee1ceff6d91","text":"Ukrainian Defence Minister Rustem Umerov interview saying Ukrainian men living abroad would be asked to report to recruitment offices","date":"2023-12-21 00:00:00"},{"id":"7482a314-6a20-4c76-a5d3-56a28a432af1","text":"Establishment and publicity around Ukraine\u2019s International Legion and the large number of foreign volunteers since Feb 2022","date":"2022-02-27 00:00:00"},{"id":"5cbb827c-948e-49c9-8dd5-d0a3c9f52987","text":"German Justice Minister Marco Buschmann public comments that Germany will not force Ukrainians in Germany to return or serve for Ukraine (Welt interview referenced)","date":"2024-01-24 00:00:00"},{"id":"7d9cd478-80c2-4f33-9da9-39dedaddc105","text":"Large multinational naval exercise Sea Breeze took place in the Black Sea (Sea Breeze 2018 concluded July 17, 2018), increasing military activity and public attention on the Black Sea/Crimea security situation.","date":"2018-07-17 00:00:00"},{"id":"00c6dc3b-e013-49d3-8cd8-6fc3710d5264","text":"Deputy Information Minister Emine Dzhaparova spoke at a round table titled \u2018Returning of Crimea: the vision of Ukrainians\u2019 and said Ukraine must be prepared for different scenarios to reclaim Crimea (ambiguous phrasing about readiness).","date":"2018-10-22 00:00:00"},{"id":"27eda906-14cf-4632-adc3-d243f4fd4936","text":"Nationalisation of PrivatBank, Ukraine\'s largest lender (government takeover announced/implemented).","date":"2016-12-19 00:00:00"},{"id":"05fac443-cceb-4ff9-82d6-297f6bd746a5","text":"S&P and other agencies moved some Ukraine instruments toward default status after missed payments on GDP\u2011linked securities in mid\u20112015.","date":"None"},{"id":"905ede65-2bde-4cde-a2cc-51e69c4841a3","text":"Moody\'s downgraded Ukraine\'s sovereign rating to Ca amid debt-restructuring talks.","date":"2015-03-24 00:00:00"},{"id":"aa7c39a7-b7ed-4147-af04-ffa29e0276fc","text":"American Journal of Medicine publishes McCullough et al., \'Pathophysiological Basis and Rationale for Early Outpatient Treatment\' (includes discussion of hydroxychloroquine)","date":"2021-01-24 00:00:00"},{"id":"30d3dcb3-51fd-4a00-b9eb-4fdee73e7b1f","text":"High-profile political promotion of hydroxychloroquine (notably President Trump) in March\u2013April 2020","date":"2020-03-24 00:00:00"},{"id":"75372dd7-921d-4010-b871-f744e8212413","text":"Pope Francis\u2019s earlier controversial \'white flag\' remarks (widely discussed in March 2024)","date":"2024-03-10 00:00:00"},{"id":"020ddec2-9bf4-4d55-8de8-775d6b46f6f7","text":"EU visa\u2011free travel for Ukrainian citizens comes into force","date":"2017-06-24 00:00:00"},{"id":"07e01120-bfaf-4cc6-aeb4-cbf712f42a74","text":"World Bank Ukraine Economic Update highlighting market and price pressures (Spring 2017)","date":"2017-04-24 00:00:00"},{"id":"ee7c1668-aa54-45b9-8b75-e6487c07fc4c","text":"Publicly available cost\u2011of\u2011living/grocery index comparisons (Numbeo 2017 country rankings)","date":"2017-04-24 00:00:00"},{"id":"98086365-8b60-42af-8a68-2b1e8ea49daf","text":"Provisional application of the EU\u2013Ukraine Association Agreement (DCFTA) reducing trade barriers","date":"2016-01-24 00:00:00"},{"id":"478e7f14-ad18-42c7-975d-dd83210d9522","text":"Ukraine installed a temporary dam and flow-control measures near Kalanchak in summer 2014 to block the North Crimean Canal.","date":"None"},{"id":"d2220db0-db5f-4c1e-bfc5-00cd3d3f4183","text":"\u62A5\u9053 and explainers in 2014 noting Crimea previously relied on the Dnipro (via the North Crimean Canal) for up to ~80\u201385% of its freshwater, creating an acute water-security crisis when the canal was blocked.","date":"2014-04-24 00:00:00"},{"id":"c30b115c-9aa9-44ae-9f91-7e78a0eda10e","text":"Historical wartime precedent: strategic destruction or manipulation of Dnieper/Dnipro dams (e.g., demolition of Dnieper infrastructure during WWII) documented in historical and reference sources.","date":"None"},{"id":"30a75522-3ed2-456c-b5c3-4efdf6159930","text":"U.S. House Science Committee and partisan media attention to NOAA\'s 2015 study and whistleblower allegations (2017)","date":"2017-02-24 00:00:00"},{"id":"28664f7e-95c3-41b0-b55f-90f977f597e5","text":"ICRC and Ukrainian Red Cross facilitated large evacuations from Sumy (joint operations to move civilians out)","date":"2022-03-15 00:00:00"},{"id":"2e8e07ef-cd9d-4f80-b243-70a6bca9511c","text":"Red Cross convoy to besieged Mariupol turned back and postponed evacuations after being unable to reach the city","date":"2022-04-01 00:00:00"},{"id":"9b370277-b0df-4b52-bb69-f004f8f111db","text":"VAERS is a public, passive adverse\u2011event reporting system (established 1990)","date":"1990-04-24 00:00:00"},{"id":"50c056c6-ad12-4d68-9434-436eb788332e","text":"U.S. measles outbreak (highest cases in 25 years)","date":"2019-05-30 00:00:00"},{"id":"092e9fe3-edeb-4793-935b-71936296b7ff","text":"NOAA reporting and headlines on record atmospheric CO2 milestones (Mauna Loa surpassing ~410 ppm) in 2019","date":"2019-06-24 00:00:00"},{"id":"59ac563e-6e2c-4f61-9004-22e54664af0b","text":"Ukrainian government files bill to make \'Glory to Ukraine \u2014 Glory to the heroes\' the official military greeting (bill No. 7549 registered)","date":"2018-02-07 00:00:00"},{"id":"dada36b1-14ac-4f44-a481-7bb7a0353c7d","text":"Public debate and media coverage about the historical/political meaning of \'Slava Ukraini\' (discussion of its origins and politicisation)","date":"None"},{"id":"bb32ebcf-afa1-4e74-a29d-d1b0fc8cb958","text":"Amnesty International report on abuses by the Aidar volunteer battalion operating under Ukrainian command","date":"2014-09-08 00:00:00"},{"id":"0f6ab3e3-d049-4145-b966-c0ba7cb300b0","text":"OSCE SMM Daily Report recorded outgoing artillery fire from government-controlled Svitlodarsk","date":"2017-01-31 00:00:00"},{"id":"2b04da7b-8c50-416b-bc8d-bca755e48292","text":"OSCE SMM documented fresh craters near a Ukrainian Armed Forces compound in Sartana assessed as caused by MLRS rounds fired from the south\u2011south\u2011east","date":"2017-03-10 00:00:00"},{"id":"5b3e40f9-1d49-4afa-8300-d5b214d9714d","text":"OSCE SMM reports noting the Mission was denied access on multiple occasions by Ukrainian Armed Forces personnel","date":"2017-01-31 00:00:00"},{"id":"720b8d6d-809c-4d3e-a583-77f63e7d2392","text":"NIA-AA (National Institute on Aging\u2013Alzheimer\'s Association) issues revised 2011 diagnostic framework introducing \'preclinical\' and biomarker-based stages of Alzheimer\'s disease.","date":"2011-04-24 00:00:00"},{"id":"d25e2ca8-7933-453e-bb0c-5bc632a1daa8","text":"FDA narrows Emergency Use Authorization for COVID\u201119 convalescent plasma to \'high\u2011titer\' units","date":"2021-02-24 00:00:00"},{"id":"2247aa0b-b1a9-4cc0-806f-c9d2d0cd4d6e","text":"Reports of foreign/black particles found in Moderna vaccine vials in Japan","date":"2021-09-24 00:00:00"},{"id":"03f4e181-d8ed-4586-bffa-fa817f4d5187","text":"Scientific and public messaging on which antibodies vaccines induce vs. which antibody tests detect (spike vs. nucleocapsid)","date":"2021-05-24 00:00:00"},{"id":"4b4fe4cd-6bc4-4296-91d2-9122b258caba","text":"Early New York State antibody study publicity suggesting many more infections than confirmed cases","date":"2020-04-23 00:00:00"},{"id":"3a2eafb7-4d99-4208-9c98-2089f8596efa","text":"Presidential election day (Ukraine) \u2014 March 31, 2019 \u2014 heightened political tension and information flows around polling stations.","date":"2019-03-31 00:00:00"},{"id":"d9a09b32-3bc4-42c4-b070-f0e1739402be","text":"Zaporizhzhia local authorities moved to implement the 2012 regional-language provisions (local implementation granting Russian regional status)","date":"2012-09-05 00:00:00"},{"id":"40ba8f2a-1fbe-4c32-b690-0f720622e862","text":"Vladimir Putin and Russian officials publicly labelled the post\u2011Maidan Ukrainian authorities \'fascist\' and repeatedly evoked Nazi-era language (Putin speech on Crimea)","date":"2014-03-18 00:00:00"},{"id":"82b4341a-53c0-4a59-ba23-8a73dc03fb2e","text":"Reporting on far\u2011right groups (Svoboda, torchlit marches) and far\u2011right figures appearing in the Maidan period","date":"2014-03-24 00:00:00"},{"id":"5719f0b2-0825-4704-b1e1-1faadcdd9013","text":"Danish Defence Minister publicly notified parliament that Denmark will significantly reduce its military support for Ukraine in 2026 (planned allocation cut to DKK 9.4 billion).","date":"2025-12-05 00:00:00"},{"id":"32904737-d2e6-461f-b57f-e569657b6a75","text":"Danish government publicised the multi\u2011year \u201CUkraine Fund\u201D and large cumulative commitments to Ukraine (multi\u2011billion euro/kroner pledges across 2023\u20132028).","date":"None"},{"id":"0dd6dd1c-6caa-490b-8269-f36c3a303578","text":"Official Danish Ministry of Defence material and public briefings documented multiple high\u2011profile equipment donations (F\u201116s, tanks, air\u2011defence, coastal missiles and other packages) and ongoing deliveries through 2022\u20132024.","date":"None"},{"id":"25ec6b3b-539a-46fb-84b7-3b8309c4cc13","text":"Analysts and media highlighted that non\u2011state\u2011party countries (e.g., India) are not legally bound to arrest ICC indictees","date":"2023-03-24 00:00:00"},{"id":"7fb28bbf-180c-4473-9113-882b65c5206b","text":"International Criminal Court issues arrest warrants for Vladimir Putin and Maria Lvova\u2011Belova","date":"2023-03-17 00:00:00"},{"id":"f10cb692-543d-49a4-857e-12877e380eb0","text":"Donetsk People\'s Republic leader Denis Pushilin announced DPR/Russian forces aimed to encircle Mariupol","date":"2022-03-01 00:00:00"},{"id":"08cac6a8-d53a-45df-8eb4-69e83b4100e8","text":"Russian troops entered the centre of Kherson and local officials reported rapid Russian advances","date":"2022-03-03 00:00:00"},{"id":"7c7355c8-7251-4b57-b625-15ffe8465010","text":"Reports and rapidly circulating images/videos showed Mariupol under heavy shelling and effectively blockaded by early March","date":"2022-03-02 00:00:00"},{"id":"a2d32119-8579-4773-a14d-17c148d585f6","text":"1979 U.S. Supreme Court decision (United States v. Rutherford) upholding federal restrictions on interstate shipment of laetrile","date":"1979-06-18 00:00:00"},{"id":"ecb1e2cc-e360-413a-9967-4b191fbe214c","text":"Publication of major clinical evaluations showing no clinical benefit and cyanide risk (e.g., Moertel et al., NEJM clinical trial 1982 and later systematic reviews)","date":"1982-01-28 00:00:00"},{"id":"80d79466-d5eb-40ec-9fa3-c2e30b7d4853","text":"Reports that around 1,000 Ukrainians had contacted the embassy in Israel seeking help","date":"2023-10-11 00:00:00"},{"id":"8334641f-a721-409e-8a0f-4f763cc30cd9","text":"Hamas attack on Israel triggers widespread conflict and civilian displacement","date":"2023-10-07 00:00:00"},{"id":"dd94afd5-f875-436b-a036-109f54ec57dd","text":"Mixed early reports about evacuation status: embassy statements that evacuation planning was underway alongside reports of delays","date":"2023-10-11 00:00:00"},{"id":"2ffb4703-e038-4783-a17d-d64c64fa7329","text":"Widespread Russian dehumanizing propaganda portraying Ukrainians and Zelensky as \'monstrous\' or \'cannibalistic\' figures","date":"2023-10-24 00:00:00"},{"id":"25c6347f-d38f-4f24-90a2-eab32988fe16","text":"WHO names \'vaccine hesitancy\' as a top global health threat (2019)","date":"2019-04-24 00:00:00"},{"id":"fafaffcc-17b9-4fc3-a16c-a6276bf6a408","text":"Publication of high-profile scientific reviews and discussions about aluminium adjuvants (e.g., 2018 Nature review)","date":"2018-04-24 00:00:00"},{"id":"25bba8d0-7a7b-45ed-9973-9c6ccc480852","text":"1999 US recommendation to reduce/eliminate thimerosal (a mercury-containing preservative) from childhood vaccines","date":"1999-07-24 00:00:00"},{"id":"1d8b5dfe-e2fb-44a5-8964-15e3019279e7","text":"Prominent climate scientist Michael E. Mann publicly stated that climate change worsened Hurricane Harvey in opinion/commentary and interviews.","date":"2017-08-28 00:00:00"},{"id":"41ffb9af-a0bd-4b01-9832-3827139dccf1","text":"General Medical Council (GMC) found Andrew Wakefield guilty of serious professional misconduct and struck him off the medical register.","date":"2010-05-24 00:00:00"},{"id":"51c91a8f-836d-4f3e-aa83-115580b2e75a","text":"FDA issued Emergency Use Authorization for the Pfizer\u2013BioNTech COVID\u201119 vaccine","date":"2020-12-11 00:00:00"},{"id":"8a5ddfe2-cfe1-4f96-9acd-23c0bdf4613d","text":"Japan suspended and recalled multiple Moderna vaccine batches after contamination reports","date":"2021-08-25 00:00:00"},{"id":"979b79bb-6bd4-4caa-b906-65b94d6ba290","text":"FDA VRBPAC briefing document noted median ~2 months safety follow\u2011up for Pfizer Phase 3 participants","date":"2020-12-10 00:00:00"},{"id":"ccfa9ab4-b725-46fe-9d4b-81f4301a7777","text":"CDC updated guidance allowing fully vaccinated people to resume many activities without masks","date":"2021-05-13 00:00:00"},{"id":"64904b12-3744-4597-9b3f-eab26aff9e46","text":"Sen. Ron Johnson and allied events highlighted raw VAERS report counts in hearings/press conferences","date":"2021-06-28 00:00:00"},{"id":"fef83bef-545f-48a1-a0a7-75f37f5f1858","text":"Publication of a Johns Hopkins patent application / patent covering an enhanced mebendazole polymorph (polymorph C) claimed to improve tumor delivery.","date":"2021-12-02 00:00:00"},{"id":"877b6b14-efb4-4221-ada1-e753e29887e7","text":"Publication of a widely-cited review \'Ivermectin, a potential anticancer drug derived from an antiparasitic drug\' summarizing in vitro and mechanistic evidence that ivermectin can affect cancer pathways.","date":"2020-09-21 00:00:00"},{"id":"bfa7eaac-7dce-4860-8984-9b0d09ebaf65","text":"Registration and start of a human clinical trial (ClinicalTrials.gov NCT05318469) testing ivermectin in combination with immune checkpoint inhibitors (balstilimab or pembrolizumab) for metastatic triple\u2011negative breast cancer (trial start listed Oct 13, 2023).","date":"2023-10-13 00:00:00"},{"id":"a3565498-b868-4dee-98d8-d5f4cfe859f7","text":"International attention and IOC intervention after Kharlan\'s disqualification (IOC awarded her Olympic qualification spot)","date":"2023-07-28 00:00:00"},{"id":"c09a83e1-da13-4197-9fc1-9729ee98abc0","text":"Olha (Olga) Kharlan disqualified at World Fencing Championships after refusing to shake Russian opponent\'s hand","date":"2023-07-27 00:00:00"},{"id":"6749d1a6-9d9c-4e30-9471-ba8f0b197ef7","text":"Brighton Beach \'Victory Day\' parade with visible Russian flags and veterans in Brooklyn","date":"2015-05-24 00:00:00"},{"id":"b0f38eca-6284-4ad5-967a-44d6f6e8f67e","text":"Small anti\u2011war/anti\u2011intervention rallies in Washington where some attendees praised Vladimir Putin (reported by U.S. outlets in 2015)","date":"2015-02-24 00:00:00"},{"id":"a8ae2e4b-0ae8-47a0-8895-855189d37016","text":"NATO\'s Enhanced Forward Presence (eFP) battlegroups deployed to the Baltic states and Poland (2017).","date":"2017-04-13 00:00:00"},{"id":"e108f330-7ee6-4e7b-9705-ed42439e9dc7","text":"Sea Breeze multinational naval exercise in Odesa and Black Sea (Sea Breeze 2018).","date":"2018-07-17 00:00:00"},{"id":"b172797b-ee7d-4a69-9af6-3a95726cb187","text":"Documented presence of foreign volunteers/foreign fighters in the Donbas conflict (2014 onwards).","date":"2014-08-24 00:00:00"},{"id":"b1c980d2-d3eb-497c-945b-254679571688","text":"Repeated Russian accusations and official statements alleging NATO or Western troops were operating in Ukraine (and NATO rebuttals in 2014).","date":"2014-12-01 00:00:00"},{"id":"b6091d9e-a2b3-424d-8756-d1f506d1b604","text":"Rapid Trident multinational exercise held in Yavoriv, Ukraine.","date":"2017-09-22 00:00:00"},{"id":"26ddee41-4525-4f23-aa2c-a446c14312eb","text":"G7 Science Academies statement: \'Future of the Ocean\' highlighting ocean acidification (G7, April 2015)","date":"2015-04-24 00:00:00"},{"id":"fe5d9d42-98ef-42db-91ca-5f80eda25774","text":"Oregon State University / NOAA-linked study on oyster hatchery failures attributed to ocean acidification","date":"2012-04-11 00:00:00"},{"id":"25b36395-e166-48c3-afce-86e3849d8755","text":"Ukraine enacts anti\u2011collaboration legislation (Article 111\u20111) criminalizing cooperation with an aggressor and occupation administrations.","date":"2022-03-24 00:00:00"},{"id":"41aaa320-17d7-49de-a85a-bbe111a655f4","text":"Administrative changes and practical disruptions to social payments (pensions) for residents in temporarily occupied territories (procedures changed and payments routed to bank accounts; suspension rules existed if no receipt for months).","date":"2022-04-24 00:00:00"},{"id":"38c15e85-f56c-4be8-9020-a8e980c44144","text":"High\u2011profile arrests/prosecutions for \'collaboration\' (example: Reuters report of an MP arrested on suspicion of collaborating with Russia).","date":"2023-07-25 00:00:00"},{"id":"066d3cca-8042-450a-8414-fb6add35cecb","text":"Reports of Russian control and disruption of communications in occupied areas (e.g., Russia rerouting/shutting down Ukrainian internet in Kherson and other occupied territories).","date":"2022-08-24 00:00:00"},{"id":"1b913efb-1993-4461-a72e-8aabce43888a","text":"Earlier precedent of arrests and accusations of \'sabotage\' in eastern Ukraine (April 2014): Ukrainian authorities detained suspected plotters in Luhansk.","date":"2014-04-05 00:00:00"},{"id":"620b1bc5-aa6e-441e-a9bd-de9626f41b53","text":"Reports of chaotic security conditions in Luhansk during 2014 (sieges, captures of observers, clashes) documented by international media and monitors.","date":"2014-06-03 00:00:00"},{"id":"0144f644-bffa-4efd-8e68-585abcf16d87","text":"U.S. Supreme Court upheld a federal ban on interstate shipment of laetrile (Amygdalin/\\"Laetrile\\" regulation upheld)","date":"1980-04-24 00:00:00"},{"id":"72bcb16a-5839-41d2-93dc-7d6b586981bb","text":"EFSA scientific opinion and public statement on acute health risks from cyanogenic glycosides in raw apricot kernels","date":"2016-04-27 00:00:00"},{"id":"f367d46a-f3fc-456a-856e-1c1287aadc11","text":"N Engl J Med clinical trial (Moertel et al.) showing no anticancer benefit for amygdalin/Laetrile and reporting toxicity concerns","date":"1982-01-28 00:00:00"},{"id":"dc14cbdb-9f5d-4046-bf54-40d22463897e","text":"Peer\u2011reviewed measurement study showing non\u2011zero scattered dose to the thyroid during mammography and that specialized collars reduce that scatter (but concluding routine collars are not mandatory)","date":"2018-06-28 00:00:00"},{"id":"4200e86a-175f-47da-99cd-bd8e9e246de6","text":"Pandemic\u2011related declines and disruptions in cancer screening and care were reported widely in 2020\u20132021","date":"2021-06-30 00:00:00"},{"id":"243e3702-8b47-4ed2-b0ec-a2b37d7ab8f0","text":"Court decision and transfer of seized Russian-owned ammonia to Odesa Portside Plant for safekeeping after seizure by Ukrainian authorities.","date":"2022-07-13 00:00:00"},{"id":"9b753a16-292c-484e-b4b7-02a71a1bad0e","text":"Russian-backed separatists reported an ammonia leak after alleged Ukrainian shelling of a brewery in Donetsk, warning of a corrosive ammonia cloud and local evacuations.","date":"2022-08-10 00:00:00"},{"id":"56462797-c178-4883-943c-1dca4ad80a4b","text":"Ukraine\'s intelligence accused Russia of rigging a Crimean chemical plant with mines that could release about 200 tonnes of ammonia, an allegation reported in international media.","date":"2023-06-24 00:00:00"},{"id":"d4769905-3316-4a21-8214-2138b5a9aa39","text":"Reports that the Togliatti\u2013Odesa ammonia pipeline was damaged during the conflict, with both Moscow and Kyiv trading blame for the disruption of large ammonia shipments.","date":"2023-06-07 00:00:00"},{"id":"cd638490-7a6a-4ada-8d87-7cdb447ed0b9","text":"EADaily publishes article repeating \'nearly 500\' protesters blocking central Kyiv street","date":"2015-03-17 00:00:00"},{"id":"d1ea88c1-6075-4f84-98f8-b0fa69033a82","text":"On-the-ground situation was two small rallies and only a brief blockage (StopFake reconstruction)","date":"2015-03-17 00:00:00"},{"id":"e91616a9-c2d0-434b-9538-31cde29fd76b","text":"United Nations reported \'persistent and grave\' human rights violations in eastern Ukraine, including civilian deaths from shelling (June 2015)","date":"2015-06-24 00:00:00"},{"id":"94e0f17e-33bc-4bef-98af-b586a683708d","text":"Bus-stop shelling in Donetsk that killed multiple civilians, widely reported and investigated by OSCE","date":"2015-01-22 00:00:00"},{"id":"4de50317-2d5e-4c28-81f0-b14104e62927","text":"Public health guidance (CDC/WHO) acknowledging limited data for infants and urging discussion between breastfeeding mothers and healthcare providers (CDC: COVID\u201119 vaccines while pregnant or breastfeeding guidance).","date":"2023-05-05 00:00:00"},{"id":"42ad553c-6f40-4a73-ae6f-7337824588c9","text":"Large street brawl in Kolonaki (central Athens) involving Dynamo Kyiv supporters, with 18 people detained","date":"2018-02-15 00:00:00"},{"id":"1b6b8aea-ce45-4e28-8040-ade69307404e","text":"Well-known past violent incidents involving Right Sector (e.g., Mukachevo shootout where Right Sector members exchanged fire with police)","date":"2015-07-11 00:00:00"},{"id":"e1b1a414-9823-46ba-81df-abb066162bf5","text":"IPCC Fifth Assessment Report (AR5, WGI) Summary for Policymakers published with cautious language on extremes, noting low confidence in long-term changes in tropical cyclone activity and stating current datasets indicate no significant observed trends in global tropical cyclone frequency over the past century.","date":"2013-09-24 00:00:00"},{"id":"407d66ee-056c-4ffa-9954-8a74ec5c3b1b","text":"High-profile political moments and media amplification of single cold/snow events used to dispute warming (for example, Senator Jim Inhofe throwing a snowball on the Senate floor in February 2015).","date":"2015-02-26 00:00:00"},{"id":"d6febbd5-eae9-4696-9e65-20492eaa8e26","text":"EU Emergency Trust Fund for Africa (EUTF) launched to address root causes of migration (Nov 2015)","date":"2015-11-24 00:00:00"},{"id":"27679405-42ca-4355-958e-fadb11d9dd69","text":"EU\u2013Turkey statement (migration deal) committing EU funds to Turkey to manage refugee flows","date":"2016-03-24 00:00:00"},{"id":"07b8c9bc-c879-41be-ba14-45abae032ec8","text":"Visa\u2011free travel for Ukrainian citizens to the EU came into force (June 11, 2017)","date":"2017-06-11 00:00:00"},{"id":"7a1ea26b-a1aa-469c-9031-a0db6bd82d4a","text":"EU macro-financial assistance and broader aid packages to Ukraine after 2014","date":"None"},{"id":"f86adeee-5f1c-4906-8955-07542f945de7","text":"2015 European migrant/refugee crisis with large arrivals to the EU","date":"2015-04-24 00:00:00"},{"id":"54e28690-5822-4639-b568-f547d5ecad19","text":"UK government statement (June 19, 2023) to keep Russian assets frozen until Russia compensates Ukraine","date":"2023-06-19 00:00:00"},{"id":"874f2a98-10f6-4186-b788-e5f7826dc4ed","text":"H.Con.Res.66 (118th Congress) expresses support for using reparations paid by Russia while urging the burden not fall on U.S. taxpayers","date":"2023-06-24 00:00:00"},{"id":"80f2e96a-02b8-4aab-9fb0-822357bd83e7","text":"Court orders and media coverage accelerating release of Pfizer vaccine trial and safety documents (judge ordered faster FDA disclosure)","date":"2022-01-07 00:00:00"},{"id":"78361e4d-90a1-4bab-8a32-903cf5747287","text":"Public reporting and CDC/ACIP discussion of myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination (young males)","date":"2021-06-23 00:00:00"},{"id":"b144c6b8-594b-4b18-a0e0-8759f18a0fef","text":"Contamination reports and suspension/recall of Moderna vaccine batches in Japan (August\u2013September 2021)","date":"2021-08-26 00:00:00"},{"id":"4353f89a-0b97-4c7c-bad8-576dbaac73df","text":"Public reporting of reduced/negative vaccine effectiveness against Omicron infections (UKHSA/early 2022 analyses)","date":"2022-02-10 00:00:00"},{"id":"5d294d4c-e97f-4a51-b0c8-88f18c467fb0","text":"In\u2011vitro report that Pfizer/BioNTech vaccine mRNA can be reverse\u2011transcribed in a human liver cell line (Ald\xe9n et al., Curr. Issues Mol. Biol./PMC)","date":"2022-03-24 00:00:00"},{"id":"95c58021-765b-4340-8db8-45534f0753f7","text":"Russian bans and embargoes on Ukrainian imports (food and other goods) in 2014\u20132015","date":"2015-11-24 00:00:00"},{"id":"a534d6f6-34a8-4f0f-b375-b2b83ea47d27","text":"Sharp national GDP contractions reported for 2014\u20132015 (double-digit annual declines in quarters)","date":"2015-04-24 00:00:00"},{"id":"f9d39220-fa21-4386-8859-b7e2ca80ef00","text":"Bilateral trade turnover between Russia and Ukraine collapsed (trade fell by around two-thirds in early 2015)","date":"2015-05-24 00:00:00"},{"id":"00318f36-a42f-4b3a-9739-a85e63103be5","text":"OFAC Crimean Sanctions Advisory (July 30, 2015) clarifying prohibitions on goods/services from Crimea","date":"2015-07-30 00:00:00"},{"id":"0ea469ee-c86a-4d73-980b-964935d52068","text":"U.S. tariffs on steel and aluminum announced under Section 232 (March 8, 2018)","date":"2018-03-08 00:00:00"},{"id":"51d90631-d52d-4811-8d5d-390241030925","text":"Department of Commerce antidumping petition \u2014 Carbon and Alloy Wire Rod from Ukraine (March 28, 2017)","date":"2017-03-28 00:00:00"},{"id":"eb7d24b5-dd65-427e-b171-f83cb4ce37ca","text":"Exhibition of captured heavy equipment at the National Museum of the History of Ukraine in the Second World War (Kyiv) showcasing tanks and large vehicles","date":"2014-07-14 00:00:00"},{"id":"1668bca7-ec75-4980-9c6f-2f91621c8981","text":"High-profile 2014 coverage of private ownership and legal disputes over WWII German tanks (Panzer IV auction / Paul Allen dispute, Sept 2014)","date":"2014-09-24 00:00:00"},{"id":"94beb342-e1fb-4100-aa6f-1661c906c314","text":"Publication of a peer\u2011reviewed rat study claiming prenatal exposure to Pfizer/BioNTech BNT162b2 produced \u2018autism\u2011like\u2019 behaviors in male neonatal rats.","date":"2024-01-10 00:00:00"},{"id":"d71e764e-7568-4baa-9373-b319e67238c8","text":"Rapid Trident 2020 multinational exercise at the Yavoriv training ground in western Ukraine involving thousands of troops, including airborne units","date":"None"},{"id":"e26652dd-c02a-45ad-a807-9f1b18347fb4","text":"Ukrainian Armed Forces reported 2,650 COVID\u201119 cases among personnel","date":"2020-11-20 00:00:00"},{"id":"136883a7-9c80-4cdf-9acc-9cb220febd7f","text":"Norwegian reports of deaths in very frail elderly after Pfizer/BioNTech vaccination and subsequent national guidance to use caution in the most frail","date":"2021-01-18 00:00:00"},{"id":"f44ef0e0-5322-4033-a778-bc956962c971","text":"Peer-reviewed reports of an association between mRNA vaccination and rare myocarditis cases (Israel, large health\u2011care database)","date":"2021-10-24 00:00:00"},{"id":"2c09731a-0975-4ada-93a5-34b70eec8e89","text":"CDC and other agencies expanding booster recommendations and reporting reduced protection against infection over time","date":"2021-11-19 00:00:00"},{"id":"fe263f5f-c718-4788-a50d-e142151e69f2","text":"CDC release of early real\u2011world effectiveness and policy messaging on RSV immunization (CDC newsroom release on nirsevimab effectiveness)","date":"2024-03-07 00:00:00"},{"id":"255d4da1-6d25-4946-9414-1fc9ca446238","text":"Russian seizure and loss of Ukrainian naval assets in Crimea (March 2014) weakened perceived Ukrainian naval capability","date":"2014-03-20 00:00:00"},{"id":"c716c947-f36c-40a2-b826-319d84ccd492","text":"Sea Breeze 2016 actually began on July 18 with US, NATO and partner forces participating","date":"2016-07-18 00:00:00"},{"id":"8551716c-4da8-4042-a80f-e628da5cfbb5","text":"Russian forces install local, pro\u2011Russian administrators in occupied Kherson (Volodymyr Saldo appointed)","date":"2022-04-26 00:00:00"},{"id":"ab4d7d4e-92fb-4d09-860c-470c3843c20a","text":"Mass refugee flows and internal displacement from Ukraine in March 2022 (millions fleeing abroad or displaced internally)","date":"2022-03-24 00:00:00"},{"id":"ac6ea0a5-f6a6-47e0-9521-c3143bb2d59e","text":"Arrest of pro\u2011Russian politician Viktor Medvedchuk by Ukraine\'s security service","date":"2022-04-12 00:00:00"},{"id":"0d812208-be9a-41ba-8217-ddce9b7193c7","text":"President Zelenskyy signs decrees blocking pro\u2011Russian TV channels and licences revoked","date":"2022-02-02 00:00:00"},{"id":"dfdd0511-b751-45f9-b860-20d88b28629c","text":"Suspension and later bans of multiple pro\u2011Russian political parties in Ukraine","date":"None"},{"id":"c2b67055-8042-4c98-8194-7993aceb4896","text":"WTO Panel report circulated in Ukraine \u2014 Anti-Dumping Measures on Ammonium Nitrate (panel report circulated 20 July 2018).","date":"2018-07-20 00:00:00"},{"id":"b7ec77ee-9594-4b8b-97ba-8ad5890bdfb3","text":"WTO dispute DS493 initiated/established (Russia files complaint; panel established 22 April 2016).","date":"2016-04-22 00:00:00"},{"id":"0cf49f83-68cd-4108-904c-11ec76282794","text":"Official recognition and investigation of rare myocarditis/pericarditis following mRNA COVID-19 vaccination (ACIP/CDC review)","date":"2021-06-23 00:00:00"},{"id":"31614f66-df4b-4087-9b57-e5c04c5b8624","text":"CDC/FDA recommended pause on the Johnson & Johnson (Janssen) COVID-19 vaccine over rare blood clots","date":"2021-04-13 00:00:00"},{"id":"85042650-cdcd-42cf-a92b-e576ab04ba3c","text":"Reports of deaths among frail, elderly Norwegian patients shortly after receiving COVID-19 vaccines","date":"2021-01-24 00:00:00"},{"id":"ab2a0598-91d2-4ea9-bd43-4e87e8119b4d","text":"World Bank Poverty and Equity briefs (published 2016) showing poverty rates rose sharply in 2014\u20132015 and remained a prominent policy concern.","date":"2016-04-24 00:00:00"},{"id":"d46e2345-2bfc-4730-ac5a-8fcd87c1305b","text":"Transparency International Corruption Perceptions Index 2016 (published January 2017) showing Ukraine with a low CPI score and poor governance indicators.","date":"2017-01-25 00:00:00"},{"id":"f041e3c4-8af0-49e2-a036-f8aad3b7c75a","text":"IMF staff report (July 2015) documenting deep recession, large output losses, and a challenging recovery path for Ukraine.","date":"2015-07-31 00:00:00"},{"id":"9ec6bca3-2ada-4c9b-b92b-1401c547e3ca","text":"Sharp economic contraction and macro crisis in 2014\u20132015: GDP collapsed and the hryvnia plunged after the central bank allowed it to float (February 2015 reports).","date":"2015-02-05 00:00:00"},{"id":"a7fe1c2a-2e3a-4fc2-b5bd-545f80fd50e3","text":"OSCE thematic report on the impact of mines and unexploded ordnance (2018\u20132019)","date":"2019-04-24 00:00:00"},{"id":"991600ba-725f-4885-bd82-8f65e7004314","text":"Vladimir Putin had previously been named TIME\'s Person of the Year (2007), a well-known precedent linking Putin with Time magazine covers in public memory.","date":"2007-12-19 00:00:00"},{"id":"e8b9df1e-a9df-41f2-a58d-9757cbfde177","text":"Study and media coverage showing Ukrainian refugees in some EU countries had to return to Ukraine to obtain abortions or contraception because of legal, cost and access barriers (Independent report, 18 May 2023).","date":"2023-05-18 00:00:00"},{"id":"3502743f-3377-4385-84ca-0faa22970d7d","text":"UN/OHCHR documented widespread conflict-related sexual violence (including rape) by Russian forces in occupied areas and published monitoring reports covering 2022\u20132023.","date":"2023-03-24 00:00:00"},{"id":"cf694b11-5df9-4934-becc-c79b9f39d996","text":"Airstrike on Mariupol maternity/children\'s hospital (Maternity Hospital No. 3) that injured pregnant women and resulted in deaths and a stillbirth \u2014 widely reported with graphic images (attack on 9 March 2022).","date":"2022-03-09 00:00:00"},{"id":"d5e301d8-602e-4994-b9c6-e12ad3ed9440","text":"EU launches \'Support Hub\' in Moldova to counter firearms trafficking and organised crime linked to the Ukraine conflict","date":"2022-07-11 00:00:00"},{"id":"831cecf9-8b31-4512-867c-607e42777deb","text":"Photographs of abandoned military equipment, shells and weapon boxes found near Andriivka (April 12, 2022)","date":"2022-04-12 00:00:00"},{"id":"6288e6e4-82d9-467a-8a64-a03fad274591","text":"Publication of an Israeli nationwide surveillance study (Mevorach et al., NEJM) showing increased myocarditis incidence after the second dose, concentrated in young males (published Oct 6, 2021).","date":"2021-10-06 00:00:00"},{"id":"b397d863-3c35-434f-b821-58e2a9adc787","text":"Reports that Russia offered/organized evacuation routes from Mariupol that included routes into Russia (early\u2013mid March 2022)","date":"2022-03-11 00:00:00"},{"id":"cf23fdff-9ba9-4d57-adea-fb5f00be4898","text":"Abduction and detention of Melitopol mayor Ivan Fedorov (reported March 11, 2022) and pressure on local officials in occupied towns","date":"2022-03-11 00:00:00"},{"id":"ef6647c9-5e6c-4e11-9d27-f848ac5a2df8","text":"Local occupation media and accounts in Kherson reported orchestrated or staged displays of support for Russian forces (early March 2022)","date":"2022-03-06 00:00:00"},{"id":"78b7211b-abf0-486e-9133-264e33b0dd2e","text":"2014 measles outbreak in an under\u2011immunized Amish community in Ohio (large local outbreak tied to travel and low MMR coverage)","date":"None"},{"id":"aea23b1b-a75a-44d1-a018-4b0952e651b8","text":"Publication of the peer\u2011reviewed study \'Low cancer incidence rates in Ohio Amish\' (Cancer Causes Control) reporting substantially lower cancer incidence in an Ohio Amish population (1996\u20132003)","date":"2009-09-25 00:00:00"},{"id":"a0145699-ea4f-41dd-9bb3-a1f701e8732a","text":"Dan Olmsted\u2019s 2005 \u2018Amish Anomaly\u2019 reporting (Age of Autism / UPI coverage) claiming an unusually low observed rate of autism in Amish communities","date":"2005-04-19 00:00:00"},{"id":"6b815d11-f965-414f-b04f-38078bccc1d2","text":"U.S.-led coalition strikes in mid\u2011November 2015 destroyed scores/hundreds of ISIS fuel tanker trucks in north\u2011east Syria (widely reported Nov 2015).","date":"2015-11-19 00:00:00"},{"id":"5d9d7d0c-e16b-4987-9c51-34a858aed7cc","text":"Russian General Staff publicly stated Russian air strikes hit Islamic State oil refining assets during its November 2015 campaign.","date":"2015-11-19 00:00:00"},{"id":"bcabb37c-2778-4f34-beae-87714ad4fa2a","text":"ISIS/ISIL militants deliberately set fire to oil fields and wells in 2015 (e.g., Ajil/Tikrit area, March 2015), producing widespread imagery of burning oil infrastructure.","date":"2015-03-04 00:00:00"},{"id":"5f28ddc2-3522-430f-87d6-316dc67120a0","text":"Hungary publicly refused to back an EU oil embargo, signalling a national veto risk","date":"2022-04-05 00:00:00"},{"id":"fd059fa0-37b3-4fc9-94f9-4d06b4db41a8","text":"Gazprom sharply cut Nord Stream 1 gas flows in late July 2022","date":"2022-07-25 00:00:00"},{"id":"11b4193a-8eda-40f7-895f-3eae3fc69a76","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly said EU sanctions on Russia had \'failed\'","date":"2022-07-23 00:00:00"},{"id":"42972dba-af6c-41fc-8772-d27c793c1d53","text":"Reporting that worries about winter energy shortages and rising bills were eroding domestic support for sanctions","date":"2022-07-28 00:00:00"},{"id":"9447caab-570e-4091-9c8b-4d5f9ad1e7ea","text":"YouGov polling shows public willingness to keep sanctions falls if they raise cost of living","date":"2022-07-24 00:00:00"},{"id":"f358d4c6-9a93-47fd-94b2-0195a51d308b","text":"Publication of Scafetta & West (2007) paper estimating a large solar contribution to 20th-century warming","date":"2007-11-24 00:00:00"},{"id":"80ef50db-23dc-47eb-aff4-2203eb2d93a3","text":"Nationwide Razumkov Center / Ilko Kucheriv Democratic Initiatives poll (fieldwork May 14\u201319, 2021) on attitudes toward Donbas and Russian aggression.","date":"2021-05-14 00:00:00"},{"id":"71ffd1b8-747c-4378-a479-dc3272327150","text":"President Volodymyr Zelensky\'s interview with foreign media (transcript published mid\u2011June 2021) in which he warned Ukraine may need to become a \'very strong, most powerful army in Europe\'.","date":"2021-06-14 00:00:00"},{"id":"a83dd8f1-3dca-4ac7-9e54-9a86b91766e7","text":"Earlier independent testing and reporting (2021\u20132022) found benzene contamination in sunscreens and other personal-care products, producing recalls and regulatory attention.","date":"2022-03-29 00:00:00"},{"id":"cc0250a3-78fb-45b6-bff5-ab59b69e6bbb","text":"News that IMF programme delays and conditionality were creating uncertainty for Ukraine\u2019s external financing in mid\u20112018","date":"2018-08-24 00:00:00"},{"id":"def94eb5-d1cf-4555-a291-c616a355a307","text":"NBU\'s August 2018 Macroeconomic and Monetary Review noting global volatility and risk of spillovers to Ukraine","date":"2018-08-24 00:00:00"},{"id":"3e32d9b4-ae18-4f58-b37a-7e9d55df3f0d","text":"Reporting on contagion fears from Turkey\u2019s currency turmoil to other emerging markets","date":"2018-08-13 00:00:00"},{"id":"46a4931e-56c9-4d44-ab93-dea353a3591b","text":"Germany announced an initial reversal of its pre\u2011invasion restraint by approving shipments from Bundeswehr stocks (1,000 anti\u2011tank weapons and 500 Stinger missiles)","date":"2022-02-26 00:00:00"},{"id":"a3edd026-9660-497c-ba20-f26eaeb8a066","text":"German Foreign Minister Annalena Baerbock publicly explained Germany\u2019s reluctance to supply arms, citing the country\u2019s WWII history (statement reported by Reuters)","date":"2022-02-18 00:00:00"},{"id":"8cbf4cf4-98fb-40c6-98b5-f4f3d4216956","text":"Swiss parliament votes in favour of several measures to tighten asylum policy (including proposals affecting temporary admissions and family reunification)","date":"2024-09-24 00:00:00"},{"id":"0dc10a52-de59-4fae-8678-4ab5b33e6bbe","text":"Media reports (June 20, 2025) covering proposals and parliamentary initiatives suggesting Switzerland \'may end\' or \'revoke\' S protection for Ukrainian refugees","date":"2025-06-20 00:00:00"},{"id":"62e0f624-06d0-4606-820f-7615dbc6bebf","text":"Federal Council decision (Nov 2023) to extend temporary protection status \'S\' for Ukrainians (clarifying it was provisional and subject to later review)","date":"2023-11-01 00:00:00"},{"id":"3cf927ce-0606-49c9-a8f3-2958023999a2","text":"Euromaidan \'Heavenly Hundred\' killings and makeshift morgues","date":"2014-02-20 00:00:00"},{"id":"0e39736e-26f4-4f9d-8ba1-967054b6d03a","text":"Odessa Trade Unions House fire and deaths","date":"2014-05-02 00:00:00"},{"id":"1add4e30-cd25-492a-8b9f-a4b8d5fe5750","text":"German police reported a rise in anti-Russian attacks and politically motivated assaults","date":"2022-03-16 00:00:00"},{"id":"2473eb4f-2c43-4bdc-988e-6373f7312394","text":"Large pro-Ukraine demonstrations and visible Ukrainian refugee presence in German cities","date":"2022-02-27 00:00:00"},{"id":"afaeb14c-7c75-408c-926e-a3e8c8a836a3","text":"Frontiers / parasitology commentary (2022) and coverage highlighting patient-driven helminth/\\"worm therapy\\" experiments and unregulated self\u2011treatment","date":"2022-04-24 00:00:00"},{"id":"76635dbe-afb2-4636-b758-4cb44e7787f7","text":"Major regulatory and media attention as U.S. agencies granted inspection/clearance for cell-cultivated meat products (June 2023)","date":"2023-06-30 00:00:00"},{"id":"49a0a2f5-6976-43f4-ab33-7721a4580cfd","text":"Industry disclosures and patent filings describing immortalization approaches for commercial cell lines (publicly cited in literature)","date":"None"},{"id":"99d4ff25-e52e-42cb-9bbb-331504d00d24","text":"Parliament approves TV language quotas requiring major channels to broadcast ~75% Ukrainian content","date":"2017-05-23 00:00:00"},{"id":"bfc5a568-ce9d-4379-81ae-c95f7db0f346","text":"Revocation of the 2012 \'Kivalov\u2013Kolesnichenko\' regional language law (removing legal regional status for Russian in some areas)","date":"2014-02-24 00:00:00"},{"id":"8e86b9c1-b8fd-4850-a0ce-9bd15d8e9fe1","text":"Passage of Ukraine\'s \'Law on Education\' (affecting language of instruction)","date":"2017-09-05 00:00:00"},{"id":"62b1c349-8a48-41c6-aff2-041f14d94129","text":"Presidential decree to block major Russian websites and social networks (VKontakte, Odnoklassniki, Yandex)","date":"2017-05-16 00:00:00"},{"id":"c5556274-2955-4223-93e9-febbbc593ac0","text":"Ban on import/distribution of 38 Russian books (listed as promoting \'hate\' or \'separatism\')","date":"2015-08-11 00:00:00"},{"id":"749c573f-6d99-43d1-93e1-1aeb776bd723","text":"UNEP/Ozone Secretariat and related press releases in Oct 2019 emphasized that the ozone layer is \'slowly healing\' and that the Montreal Protocol has been effective.","date":"2019-10-24 00:00:00"},{"id":"c50a2138-0b86-4f47-aee6-dda205328aef","text":"NOAA and NASA announced that the 2019 Antarctic ozone hole was the smallest on record (annual peak extent), attributed in part to unusual stratospheric warming.","date":"2019-10-24 00:00:00"},{"id":"af70fd3c-0f4e-49f3-b25a-63935cd5ea6c","text":"UN/OHCHR reporting of thousands killed in eastern Ukraine (2014\u20132015)","date":"2015-09-24 00:00:00"},{"id":"48c11cdf-4764-4cd2-911e-469e9ec3135c","text":"Defense and fall of Donetsk International Airport (\'Cyborgs\') with heavy casualties","date":"2015-01-24 00:00:00"},{"id":"f8862daa-afb5-49de-a80f-ef289a621c9e","text":"Battle of Avdiivka \u2014 intense frontline fighting and elevated casualties","date":"2017-01-24 00:00:00"},{"id":"7f4a044e-a00c-47ee-8282-f045a93d6dbb","text":"Battle of Debaltseve and Ukrainian withdrawal under pressure","date":"2015-02-24 00:00:00"},{"id":"daab206a-46c6-42b9-86bd-4772d61d43bf","text":"Reports of Ukrainian sailors being pressured to take Russian oaths or detained during Crimea takeover","date":"2014-03-24 00:00:00"},{"id":"4ff9dd85-321e-4fc1-b596-2519e34295c6","text":"Tense stand\u2011off aboard blockaded Ukrainian ship Slavutych in Sevastopol where crew resisted takeover","date":"2014-03-24 00:00:00"},{"id":"2cd437e5-7618-46c4-8169-8a22df9219c1","text":"NOAA/NCEI released a major update to its global surface temperature dataset (NOAAGlobalTemp update) that changed historical coverage/adjustments.","date":"2023-02-14 00:00:00"},{"id":"cc45c3e8-7e6b-4f81-b0b9-56a2ab01839f","text":"UN Human Rights Monitoring Mission reports on conflict-related killings and impunity in Donetsk and Luhansk","date":"2016-07-13 00:00:00"},{"id":"49c95f25-4fc2-48e0-a4c2-13cd04a0be14","text":"European Parliament adopts \'Importance of European remembrance\' resolution condemning both Nazi and Stalinist crimes","date":"2019-09-19 00:00:00"},{"id":"47cedce3-3262-4105-9c19-91971028dc17","text":"Lviv Oblast declares 2019 the \'Year of Stepan Bandera\', prompting protest from Israeli and Jewish groups","date":"2018-12-24 00:00:00"},{"id":"7eebea58-eccc-43d6-9605-78c5068074fc","text":"Ukraine passes \'decommunization\' laws banning communist symbols and reshaping public memory","date":"2015-05-24 00:00:00"},{"id":"91c29cf1-50ac-4fda-8387-a45e9eb86d48","text":"UN/OHCHR reporting on detentions, security operations and use of anti\u2011terror measures in eastern Ukraine","date":"2014-07-15 00:00:00"},{"id":"40301d4d-b88e-43bc-b381-d74e42463371","text":"Sanctions and regulatory restrictions targeting Crimea after Russia\'s 2014 annexation (EU/US measures from June 2014 onward)","date":"2014-06-23 00:00:00"},{"id":"100a5f92-308e-45c1-b373-656f0ac8ba61","text":"Media and veterinary reporting in 2022\u20132023 documented increasing use of cholecalciferol (vitamin D3) in commercial rodenticides and clinical cases of cholecalciferol poisoning in pets and wildlife.","date":"2023-04-24 00:00:00"},{"id":"a3431b87-2276-445d-8261-ac070ad38875","text":"Hawaii law banning oxybenzone and octinoxate in sunscreens (signed 2018; implementation and attention into 2020\u20132021)","date":"2018-07-24 00:00:00"},{"id":"3bc6623e-2517-4386-b3ef-1a6ef5e48177","text":"Johnson & Johnson voluntary recall of specific Neutrogena and Aveeno aerosol sunscreens after detecting low levels of benzene","date":"2021-07-14 00:00:00"},{"id":"100835ae-6e8a-409d-ab1f-849e3e442927","text":"2004 Mutat Res study finding dihydroxyacetone (DHA, active in sunless tanning) causes DNA damage, cell\u2011cycle arrest and apoptosis in cultured keratinocytes","date":"2004-06-13 00:00:00"},{"id":"b7badbe4-1480-4740-84af-86c7523a433a","text":"Large Russian military exercises near Europe (e.g., Zapad 2017)","date":"2017-09-24 00:00:00"},{"id":"5943d437-2833-43b2-b041-b1240a2a79a0","text":"Kerch Strait incident \u2014 Russia seized Ukrainian naval vessels","date":"2018-11-25 00:00:00"},{"id":"f8a12006-8d34-44eb-913e-a0e4597ccf85","text":"Minsk II ceasefire agreement (and its incomplete implementation)","date":"2015-02-24 00:00:00"},{"id":"ad2b7363-fc21-4dba-afa1-17fa408f20e2","text":"CDC guidance update allowing fully vaccinated people to stop wearing masks in most settings (May 13, 2021).","date":"2021-05-13 00:00:00"},{"id":"649a8931-8e47-40b4-b474-17f7ae5b39cd","text":"CDC/NCHS guidance on certifying COVID-19 deaths (April 2020) and subsequent public discussion of death-coding.","date":"2020-04-24 00:00:00"},{"id":"2911afdc-2774-462b-bd60-f60cf44428a5","text":"Great Barrington Declaration (Oct 4, 2020) promoting \'focused protection\' and criticizing lockdowns.","date":"2020-10-04 00:00:00"},{"id":"27ebf54a-7220-410b-bf97-38d6dd4708f2","text":"Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine reporting no statistically significant protective effect to wearers from recommending surgical masks (November 2020).","date":"2020-11-24 00:00:00"},{"id":"33dd84d3-8730-4bb5-9380-23b417b5e4d0","text":"Public reporting (e.g., Foreign Policy, OSINT coverage) that social media posts and geotagged content have been used to locate and target soldiers in the Ukraine war (OSINT used operationally).","date":"2023-03-02 00:00:00"},{"id":"a7239427-66bd-4600-aed2-581476f25b1d","text":"Independent reports in 2014 documenting summary killings, alleged mass graves and executions in eastern Ukraine (Amnesty International briefing, Oct 2014).","date":"2014-10-24 00:00:00"},{"id":"0b7dc1e2-ab56-4b33-ac54-7cdeb5f16390","text":"CDC MMWR (March 2012) reporting autism spectrum disorder prevalence of about 1 in 88 in US surveillance areas (data for 2008)","date":"2012-03-30 00:00:00"},{"id":"0a61ddef-0a7a-4d1f-8d16-65bd35c1ffc9","text":"Public reporting of rising measles cases in the UK attributed to declines in MMR uptake following the MMR scare","date":"2008-11-07 00:00:00"},{"id":"65c099f8-b04c-434c-82f1-db7b66e3bb75","text":"1999 precautionary recommendation to remove thimerosal (a mercury-containing preservative) from childhood vaccines in the United States","date":"1999-07-24 00:00:00"},{"id":"03770f87-b530-494b-839a-699441af95f4","text":"CDC/NCHS provisional reports and public pages in late 2022\u2013early 2023 highlighted continued high counts of non\u2011COVID causes of death (notably drug overdose and heart disease) in 2021\u20132022 (CDC provisional drug overdose data page updated Jan 2023).","date":"2023-01-24 00:00:00"},{"id":"97993de4-36d6-40a8-8ee4-74fe9a971f9d","text":"CDC published and maintained public, downloadable jurisdiction\u2011 and county\u2011level COVID\u201119 vaccine administration/coverage datasets and maps (e.g., CDC Stacks dataset release March 1, 2022).","date":"2022-03-01 00:00:00"},{"id":"17e66a98-25a6-493f-8ac5-75dac9dd5953","text":"UK guidance and primary\u2011care instructions on narrow criteria and formal processes for issuing COVID\u201119 medical exemption certificates (GPs required to follow specified criteria)","date":"2022-02-24 00:00:00"},{"id":"a0867cc2-91c4-4201-923c-2d77c2076461","text":"Temporary pause and safety review of the Johnson & Johnson (Janssen) COVID\u201119 vaccine after reports of rare blood clots (CVST)","date":"2021-04-13 00:00:00"},{"id":"e61b707f-b13b-4fbc-a817-8cb29c1838de","text":"News coverage of hospitals and transplant programs declining care (including organ transplants) for unvaccinated patients","date":"2022-01-24 00:00:00"},{"id":"66122d9b-07b9-4336-a64a-2554a7ecc4bb","text":"OSHA/NIOSH hazard communications and guidance on diatomaceous earth/silica hazards (e.g., OSHA interpretation clarifying DE silica content and hazard communication, April 5, 1999; NIOSH silica guidance)","date":"1999-04-05 00:00:00"},{"id":"8418add7-2b09-4307-b140-1777e2bffd7b","text":"Peer\u2011reviewed and technical studies showing diatomite/diatomaceous earth has sorption/adsorption properties in water treatment (e.g., fluoride/heavy\u2011metal removal studies, 2019)","date":"2019-04-24 00:00:00"},{"id":"236fab75-12fe-470c-a805-30e262f615e1","text":"GOV.UK Summary of the Public Assessment Report for the Pfizer/BioNTech COVID-19 vaccine (authorisation documents, Dec 2020) and WHO/regulatory guidance cited therein stating carcinogenicity/genotoxicity testing is generally not required for many vaccines.","date":"2020-12-01 00:00:00"},{"id":"4b0ef420-0f8d-4887-98c1-ba44f430b107","text":"UK MHRA Freedom of Information release (FOI_22-1223) and related correspondence (published 22 Dec 2023) stating \'Neither genotoxicity nor carcinogenicity studies were performed\' for certain Comirnaty components and that components \'are not expected to have genotoxic potential.\'","date":"2023-12-22 00:00:00"},{"id":"f7986f09-a424-4730-91d8-7184938981d1","text":"Public release/update of childhood cancer incidence data/registries (e.g., National Childhood Cancer Registry Explorer / US cancer surveillance datasets updated 2022\u20132023) showing short\u2011term fluctuations or small upticks in incidence that were reported in the media.","date":"2023-04-24 00:00:00"},{"id":"ad594a92-20eb-4c2a-a4ca-27bfaca1bb08","text":"Russia imposed an import ban on Roshen confectionery products (Rospotrebnadzor cited safety concerns).","date":"2013-07-29 00:00:00"},{"id":"6f6b7766-153e-495c-8bb7-c1fe489a04dd","text":"Armed police and plainclothes officials entered the Lipetsk Roshen factory amid court cases and commercial disputes (widely reported tensions at the Lipetsk site).","date":"2014-03-31 00:00:00"},{"id":"e109c0a7-b9f8-47fb-8dec-aabcf71b1533","text":"Roshen announced it would close its Lipetsk (Russia) factory and halt operations, laying off workers (company statement reported January 2017; operations stopped by April 2017).","date":"2017-01-20 00:00:00"},{"id":"0b7e45d3-6556-44e5-a308-6ecaeed877bd","text":"Petro Poroshenko transferred his Roshen stake into a blind trust managed by Rothschild Trust (announcement and confirmations in January 2016).","date":"2016-01-14 00:00:00"},{"id":"ea0c236f-635a-4b74-b1a1-5663336c4c92","text":"Pre\u2011existing, reputable polls with mixed results (GfK Ukraine 2018) showing regional variation in nostalgia","date":"2018-04-24 00:00:00"},{"id":"18ae0cbe-1331-4340-b56a-5c85bc9c3939","text":"Historical 1991 independence referendum (92% voted for independence) \u2014 widely reported figure available in public records","date":"1991-12-01 00:00:00"},{"id":"a15d5adb-b4d5-4ea9-97a6-1ea64e048da2","text":"Oleg Sentsov began an indefinite hunger strike on 14 May 2018 to demand the release of Ukrainian political prisoners, drawing intense international attention to his case.","date":"2018-05-14 00:00:00"},{"id":"5159d09a-626f-4ef3-b9eb-e1a360dd8787","text":"Human-rights organisations and public petitions mobilised around Sentsov in mid\u20112018 (Amnesty International and other advocacy actions in June 2018 used #FreeSentsov widely).","date":"2018-06-24 00:00:00"},{"id":"011a22da-0d5b-4885-a0b2-5f5f1cabb1f1","text":"Norway reports and investigations of frail elderly deaths temporally associated with vaccination","date":"2021-01-24 00:00:00"},{"id":"cbce4f11-1d44-4416-a418-76bdd1b80270","text":"U.S. pause of the Johnson & Johnson (Janssen) vaccine after rare blood clot reports","date":"2021-04-13 00:00:00"},{"id":"ef36060f-f210-48b4-9102-ace7aa5d8b7d","text":"Publication of Karl et al. (2015) NOAA/Science paper revising recent global surface temperature analyses and addressing the so\u2011called \'hiatus\'","date":"2015-06-24 00:00:00"},{"id":"7f1c8ce2-f14a-40ce-80d7-fcb2fcb8a938","text":"Local incidents and campaigns (e.g., Holy Rus\' Movement activity reported in Pastavy) around November 2014 that raised tensions over flags, national identity and pro\u2011Russian vs pro\u2011European messaging.","date":"2014-11-09 00:00:00"},{"id":"c248d4d9-7e12-4ee9-8273-2c7baa433d29","text":"Annual Shrovetide/Maslenitsa effigy\u2011burning traditions observed across Slavic countries (including Belarus) where effigies are publicly burned as part of festival rites.","date":"None"},{"id":"25ac0643-8c95-4de8-8761-28dfeb1e494c","text":"Visible use of alternative Belarusian opposition symbols (white\u2011red\u2011white flags) and frequent protest imagery in 2014 that foregrounded flags and symbols in public demonstrations.","date":"2014-04-24 00:00:00"},{"id":"94ae7d73-7c37-4d4d-81d5-f34cb67332c7","text":"U.S. Patent US4686605A (\'Method and apparatus for altering a region in the Earth\'s atmosphere, ionosphere, and/or magnetosphere\') granted to Bernard J. Eastlund (patent text describes possible weather-modification applications).","date":"1987-08-11 00:00:00"},{"id":"b5a0b1ab-b754-4668-8df3-ac0730010494","text":"IMF staff report on Ukraine\'s emergency financing needs under the Rapid Financing Instrument (IMF staff report published March 7, 2022)","date":"2022-03-07 00:00:00"},{"id":"11a0d2b6-f308-41e0-a22b-006339445092","text":"World Bank warning Ukraine economy could shrink sharply in 2022 (World Bank press release, April 10, 2022)","date":"2022-04-10 00:00:00"},{"id":"90adc281-7853-41dc-95c0-1d93ff441625","text":"Parliamentarian warning Ukraine needs $5 billion a month in external aid (reported by Reuters)","date":"2022-06-14 00:00:00"},{"id":"65f3b7a8-60c7-4efa-a179-748ce3d57066","text":"S&P Global Ratings cuts Ukraine\'s sovereign credit rating (Reuters)","date":"2022-05-27 00:00:00"},{"id":"b834e80c-57e4-4c4e-9364-a6ce35f05cef","text":"U.S.-led training of Ukrainian military personnel at sites such as the Yavoriv training center (Joint Multinational Training Group \u2013 Ukraine began operations in 2015).","date":"2015-04-24 00:00:00"},{"id":"d08075a0-da02-4f6d-9e2f-471a31fbe88a","text":"National Endowment for Democracy (NED) grants and NGO funding programs in Ukraine following Euromaidan (published in NED annual reports and grant records).","date":"2014-04-24 00:00:00"},{"id":"28b6dc91-8158-42e8-b45b-ef79f26080f6","text":"U.S. announces major economic assistance and loan guarantees to Ukraine as part of post-Maidan support (including a White House fact sheet detailing assistance).","date":"2014-11-24 00:00:00"},{"id":"1614d4e1-9ef9-4d1b-aef0-7beefdeafd27","text":"Visit by U.S. Senator John McCain to Kyiv\'s Maidan protests and public expressions of support for pro-European protesters.","date":"2013-12-24 00:00:00"},{"id":"771cadb6-a575-4af6-8466-113aa0936dcc","text":"Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels attempting to transit the Kerch Strait, injuring sailors and sharply escalating tensions.","date":"2018-11-25 00:00:00"},{"id":"7216020d-38a5-4789-8bf9-8b552e21b881","text":"Verkhovna Rada debated and adopted the Law on the Reintegration of Donbas (early 2018) and passed parliamentary resolutions emphasising de-occupation and reintegration of territories lost in 2014, including Crimea.","date":"2018-01-18 00:00:00"},{"id":"0a4165e4-da8d-4eda-b1fd-dd6020c834e2","text":"European Union extended sanctions related to Russia\'s 2014 annexation of Crimea after diplomatic deliberations in December 2019.","date":"2019-12-13 00:00:00"},{"id":"563d2ebd-745e-44e1-8475-c15c1c9fe8ef","text":"President Volodymyr Zelensky publicly vowed to restore Ukrainian control over Crimea during his inauguration, stressing Crimea remains part of Ukraine.","date":"2019-05-20 00:00:00"},{"id":"ac95df98-1a59-45d0-a7f8-02a1ccf486ac","text":"CDC Vital Signs (MMWR) documenting a sharp rise in firearm homicides in 2020","date":"2022-05-10 00:00:00"},{"id":"9d91cf96-9ac9-4dd9-b4b1-a62cb2f0b37e","text":"Reports and recall actions after discovery of foreign/black particles in Moderna vaccine vials in Japan (investigation and lot suspensions)","date":"2021-09-01 00:00:00"},{"id":"f3a22222-3f26-4d41-8ae4-ec2eec8e359d","text":"NEJM study showing substantial waning of Pfizer\u2013BioNTech (BNT162b2) protection against SARS\u2011CoV\u20112 infection over months in Qatar","date":"2021-10-24 00:00:00"},{"id":"c287a65d-6767-4792-a760-e5e5c06094fb","text":"ACIP/CDC review and MMWR reporting of myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination in young males","date":"2021-06-23 00:00:00"},{"id":"c3b6f443-30c4-40f4-ad7c-b75048fa6cd0","text":"Passage of Ukraine\'s decommunization laws (adopted April 9, 2015)","date":"2015-04-09 00:00:00"},{"id":"52949534-ad9a-45bf-97df-7560f69a8480","text":"Verkhovna Rada officially renamed the city of Kirovohrad to Kropyvnytskyi","date":"2016-07-14 00:00:00"},{"id":"7e554a7b-d9be-49df-877b-d884572747c1","text":"City council-organized public survey (Oct 25, 2015) reported that around 77% of participating respondents favoured restoring the historical name \'Yelysavetgrad\' (low turnout)","date":"2015-10-25 00:00:00"},{"id":"f5800722-6b8b-4a18-be9d-085c87f1ca2f","text":"Reports of foreign/black particles found in some vaccine vials (Japan, September 2021) and subsequent temporary suspensions/recalls","date":"2021-09-24 00:00:00"},{"id":"0dfb5183-818a-4a43-a434-b3172805c9d8","text":"Court-ordered public release of Pfizer/FDA review documents (rolling release beginning March 1, 2022)","date":"2022-03-24 00:00:00"},{"id":"057415f7-0a69-4ad7-81cf-5bf03120bb5b","text":"Reports and rights\u2011group coverage of extra-legal self\u2011defence units and weapons proliferation in occupied/contested areas (Human Rights Watch World Report 2015)","date":"2015-04-24 00:00:00"},{"id":"14cf000c-8c1e-4720-9adf-7bde0c3f5147","text":"Poroshenko sacks Ihor Kolomoisky as governor after armed men seize oil company offices; publicly warns no regional \'pocket armies\' will be tolerated","date":"2015-03-25 00:00:00"},{"id":"df08cb44-ecf0-470d-9612-05f33a1bd3be","text":"E\u2011petition filed calling for formalisation of citizens\' right to bear firearms (Reg. \u21161135-1 submitted)","date":"2015-02-05 00:00:00"},{"id":"71e43c54-8546-43f0-8584-9a3b81e73792","text":"Presidential decree and public events strengthening/celebrating the National Guard and deployment of National Guard battalions (march 2015)","date":"2015-03-18 00:00:00"},{"id":"015ad92d-8a43-4c86-8eca-57b3ed328aba","text":"Widespread formation and operation of volunteer battalions (e.g., Azov, Donbas) during 2014\u2013early 2015","date":"2014-12-13 00:00:00"},{"id":"52aa91a5-8d8b-4866-8a15-a467ddeb84d3","text":"Public debate and reporting on Ukraine\'s mobilization and need to replenish/rotate forces","date":"2023-04-11 00:00:00"},{"id":"1f00bdc8-2cc0-4ec2-ad34-86ee8a82ebdb","text":"Claims of territorial setbacks (Soledar) early 2023 that were amplified by Russian sources","date":"2023-01-13 00:00:00"},{"id":"75b4df13-6fdf-41f5-9548-45d77a05afef","text":"Summer\u2013autumn 2021 \'wind drought\' across the UK and parts of Western Europe produced unusually low wind output and a noticeable drop in renewable electricity generation.","date":"2021-10-24 00:00:00"},{"id":"7f5a768b-f8ae-4844-b7cb-a83633d09cbe","text":"February 2021 Texas winter storm caused widespread grid failures and stressed electricity supply; some industrial sites (including data centers) relied on backup power and experienced operational impacts.","date":"2021-02-24 00:00:00"},{"id":"c7300144-20ac-4f8d-b8db-56dc189b6f68","text":"NOAA / Coral Reef Watch reporting and technical briefs documenting the 2020 GBR marine heatwave and unprecedented bleaching risk (March 2020)","date":"2020-03-24 00:00:00"},{"id":"6d18bc06-08d9-49b1-a732-ce69be1a92bc","text":"UNESCO/World Heritage publicity around suggestion to list the Great Barrier Reef as \'in danger\' (July 2021)","date":"2021-07-24 00:00:00"},{"id":"21d7ba1d-2d43-4b90-874e-3fd3b70de5a7","text":"Reporting and congressional attention on EcoHealth Alliance and funded coronavirus research with the Wuhan Institute (NIH correspondence and investigations, Oct 2021 onward)","date":"2021-10-21 00:00:00"},{"id":"27413585-74ac-42fd-a64a-9526033ba7b5","text":"U.S. Department of Energy reported an assessment favoring a laboratory origin (covered in Feb 2023 press)","date":"2023-02-26 00:00:00"},{"id":"4b503e26-b164-4d01-8cfb-e3cb93f6f278","text":"Russian and other state\u2011backed media amplified allegations of U.S. biological labs and research being part of hostile programs (March 2022)","date":"2022-03-09 00:00:00"},{"id":"3daaf72f-9ed4-4402-bbfa-caa34aea8145","text":"Great Barrington Declaration (4 October 2020) \u2014 public statement by a group of scientists advocating \'focused protection\' instead of broad lockdowns.","date":"2020-10-04 00:00:00"},{"id":"b716df28-25f5-4342-9e96-aeffe85cc626","text":"Publication and media coverage of the DANMASK-19 randomized trial (Denmark) in November 2020, reporting limited protective effect of recommending surgical masks for wearers in a low-transmission setting.","date":"2020-11-24 00:00:00"},{"id":"7d12d99d-5ec0-47fb-a7fc-15b34faea721","text":"Imperial College COVID-19 Response Team Report 9 (16 March 2020) modelling high projected deaths and showing large effects from non-pharmaceutical interventions (NPIs), widely cited by policymakers and media.","date":"2020-03-16 00:00:00"},{"id":"28b169fe-6d66-4d61-9e75-cffde783f4a0","text":"Publicised requests to retract or critique the early Corman\u2013Drosten RT\u2011PCR protocol (late 2020) and widespread online debate about PCR sensitivity, cycle thresholds, and false positives.","date":"2020-11-24 00:00:00"},{"id":"81ea0346-0d3c-46da-ae67-a4e4511295e1","text":"Israeli Health Ministry report (June 2021) identifying a probable link between Pfizer vaccine and rare myocarditis cases","date":"2021-06-01 00:00:00"},{"id":"16bef4ff-b6fc-49ed-9739-8e7b0eeb5d41","text":"FDA Emergency Use Authorization (EUA) for the Pfizer\u2013BioNTech COVID-19 vaccine","date":"2020-12-11 00:00:00"},{"id":"78b444af-b57d-412a-8a93-e25c216c3f78","text":"CDC MMWR report on the Provincetown (Massachusetts) July 2021 outbreak with a high proportion of cases in fully vaccinated people","date":"2021-07-24 00:00:00"},{"id":"80cc3156-fe40-44e1-a335-8776a3897352","text":"Announcement of \'Operation Warp Speed\' to accelerate COVID-19 vaccine development","date":"2020-05-15 00:00:00"},{"id":"2344c640-395e-4645-a314-d1a54fc02b7b","text":"WHO designation and global spread of the Omicron variant (variant of concern declared 26 November 2021) and subsequent large waves of infections in late 2021\u2013early 2022","date":"2021-11-26 00:00:00"},{"id":"b0a3cf13-1a4a-49cf-9650-b4d47bd24a66","text":"Preprint released claiming a \'Worldwide Bayesian Causal Impact Analysis\' of 145 countries showing vaccine deployment increased COVID-19 cases and deaths","date":"2021-11-15 00:00:00"},{"id":"ae5557c6-998c-4b66-b2b7-a5aecbac8f3c","text":"Major meat company sustainability commitments and reports (example: JBS releases 2022 Sustainability Report and net\u2011zero framing)","date":"2022-04-24 00:00:00"},{"id":"b41e6423-16f3-4b35-870c-1142dc824e7e","text":"Wide media coverage and debate around the GWP* methane metric (interpretation and promotion of GWP* as an alternative to GWP100)","date":"2021-10-24 00:00:00"},{"id":"013c1cd9-b7c8-48fb-b8ce-475e23266ea5","text":"Publication of peer\u2011review studies and meta\u2011analyses showing mixed evidence on soil carbon gains from grazing/regenerative practices (example: Nature 2024 grazing/carbon meta\u2011analysis)","date":"2024-04-24 00:00:00"},{"id":"7de80b65-043f-4e5d-a9bc-d226ff6b6fdd","text":"Public U.S. statements (late 2014) denying provision of lethal weapons to Ukraine under Obama administration","date":"2014-12-24 00:00:00"},{"id":"5da602a2-f68a-4e2a-8e3a-9e3ace51e706","text":"Rapid Trident 2014 multinational exercise at Yavoriv (September 2014)","date":"2014-09-24 00:00:00"},{"id":"3b98511c-321a-4192-8fb8-abc95011c37e","text":"U.S. 2nd Cavalry Regiment Javelin live\u2011fire range at Grafenw\xf6hr/Vilseck (Sept 23, 2014)","date":"2014-09-23 00:00:00"},{"id":"0321a354-364a-4a30-b679-e623c1a70423","text":"Destruction of the Antonov AN-225 \'Mriya\' and visible damage at Hostomel/Antonov airport after Russian strikes","date":"2022-02-27 00:00:00"},{"id":"4711e8d3-bd16-4241-953d-c51c6c90d423","text":"FAO publishes \'Livestock\'s Long Shadow\' quantifying livestock\'s share of global greenhouse gases and comparing it to transport","date":"2006-09-24 00:00:00"},{"id":"7ddd12d2-cff6-49aa-b67f-7dfa800c3849","text":"June 2021 reports and ACIP discussions documenting rare cases of myocarditis/pericarditis after mRNA vaccination in adolescents and young adults.","date":"2021-06-24 00:00:00"},{"id":"10001215-1c6c-494d-b431-6dd94724db27","text":"October 29, 2021: FDA Emergency Use Authorization and ACIP recommendation for Pfizer\u2011BioNTech COVID\u201119 vaccine in children aged 5\u201311.","date":"2021-10-29 00:00:00"},{"id":"004ea1ef-02fa-47bf-a43c-2078a1530a3a","text":"Publication of Ogata et al. (May 20, 2021): small pilot study detecting SARS\u2011CoV\u20112 vaccine antigen (spike protein) in the plasma of 11 of 13 mRNA\u20111273 (Moderna) recipients.","date":"2021-05-20 00:00:00"},{"id":"975471e0-820a-4978-8aaa-066b30963821","text":"Published evidence of waning vaccine effectiveness and Israel\'s booster campaign (e.g., Bar\u2011On et al., NEJM showing booster restored protection after demonstrated waning).","date":"2021-10-07 00:00:00"},{"id":"bbe3e36a-e3e8-44b0-8d0b-6bb1acbbccd1","text":"Release and dissemination of the Great Barrington Declaration (October 2020), advocating \'focused protection\' and emphasizing immunity from infection.","date":"2020-10-04 00:00:00"},{"id":"27bab3dd-8905-4e53-8114-ad36b1d41d9b","text":"Publication of Israeli preprint by Gazit et al. reporting that, during the Delta wave, SARS\u2011CoV\u20112\u2011naive vaccinees had a 13.06\u2011fold increased risk of infection compared with previously infected individuals (medRxiv preprint).","date":"2021-08-25 00:00:00"},{"id":"130d090a-a725-48fd-97d3-ed44794213dd","text":"New York Attorney General pursued civil actions and publicized dozens of price-gouging complaints against gas stations after Hurricane Sandy (2012).","date":"2012-11-15 00:00:00"},{"id":"983f6e63-0d24-46b9-af13-db591b501c72","text":"Federal Reserve Bank of St. Louis discussion of the \'rockets and feathers\' effect (October 2014) showing retail gasoline prices often rise quickly but fall slowly after crude price declines.","date":"2014-10-24 00:00:00"},{"id":"fdc978ed-40a2-426b-9b52-d01d7ccc34ea","text":"UK government and consumer groups publicly urged petrol retailers to cut prices after steep falls in global oil prices (November 2014 coverage).","date":"2014-11-06 00:00:00"},{"id":"eb8f967f-2656-4a4b-91e8-a4cb188e9b89","text":"Release of the IPCC Fifth Assessment (AR5) Summary for Policymakers (September 2013) with quantified attributions and separate estimates for greenhouse gases and aerosol cooling","date":"2013-09-24 00:00:00"},{"id":"0d960c2e-82aa-4fcf-8f81-ab730c8a9dd5","text":"Russian seizure of three Ukrainian naval vessels in the Kerch Strait","date":"2018-11-25 00:00:00"},{"id":"0296336a-12f4-46da-8644-2db3b8318904","text":"Ukraine announced partial martial law in response to the incident","date":"2018-11-26 00:00:00"},{"id":"20b1fe96-adae-4346-97e2-6d250e59f29a","text":"Russian Foreign Ministry publicly accused Ukraine of deliberately provoking the incident","date":"2018-11-26 00:00:00"},{"id":"4e7dce9c-6656-4866-afe0-55c31488e64b","text":"FDA emergency use authorization (EUA) for Pfizer-BioNTech vaccine expanded to adolescents aged 12\u201315","date":"2021-05-10 00:00:00"},{"id":"51c2ac4b-6155-4d68-9e60-c8a889ca9cf1","text":"Publication of Israeli active-surveillance study reporting increased myocarditis cases after BNT162b2 (Pfizer) vaccination","date":"2021-10-06 00:00:00"},{"id":"71716b5e-5ae9-4ffa-8706-06583a089e68","text":"Air-raid alert sounded near central Kyiv while a group of Moscow\u2011aligned clergy were at the Presidential Office; Ukrainian air defences detected and shot down a drone.","date":"2023-03-20 00:00:00"},{"id":"949d656d-6c77-4e70-a816-4a946c24cafe","text":"Public fallout from Patriarch Kirill and parts of the Russian Orthodox leadership publicly backing Russia\u2019s invasion (2022), prompting Ukrainian clergy and parishioners to cut ties with Moscow.","date":"2022-04-24 00:00:00"},{"id":"96422655-db81-478f-b5cf-5ce26a64e857","text":"UNEP Global Methane Assessment names agriculture (including livestock) as a major short\u2011lived climate forcer","date":"2021-11-24 00:00:00"},{"id":"6d645f66-2fa2-4440-97b2-ff77af9e2264","text":"Launch of the Global Methane Pledge at COP26","date":"2021-11-02 00:00:00"},{"id":"4ac1ca20-eebb-45cd-a74b-79edf957b37b","text":"Industry advocacy/PR programs to defend beef (e.g., \'Masters of Beef Advocacy\' and NCBA campaigns)","date":"2019-04-24 00:00:00"},{"id":"2cc66c0f-4d03-4670-961a-363f22e74a7f","text":"Publication of major reports in 2019 (CDC/WHO) highlighting antimicrobial resistance as a growing global health threat","date":"2019-04-24 00:00:00"},{"id":"31783125-f695-4dd2-b83d-e9c62dacc5f6","text":"Japan\'s 2013 suspension of proactive HPV\u2011vaccine recommendation after media reports of adverse events, and the official resumption of active recommendations on Nov 26, 2021.","date":"None"},{"id":"fd9362a0-22e4-4461-9e09-8bb3013720c9","text":"April 2023 court developments in U.S. Gardasil litigation: plaintiffs secured orders/access to adverse\u2011event databases and internal documents related to Gardasil safety.","date":"2023-04-24 00:00:00"},{"id":"265a5bd9-2e5f-4b66-9802-32ce6519ab9f","text":"Publication of a November 2022 Journal of Autoimmunity paper (Mehlsen et al.) reporting clinical and pathophysiological findings in a cohort of patients who self\u2011reported long\u2011term complications after HPV vaccination.","date":"2022-11-07 00:00:00"},{"id":"0872d008-2206-414f-abe3-83a079ff4a39","text":"NCHS/CDC data summary noted that 94% of death certificates mentioning COVID-19 also listed other health conditions (widely reported Sept 2020).","date":"2020-09-24 00:00:00"},{"id":"5577f827-1608-4eba-b5ec-b6916810af2d","text":"Publication of seroprevalence analyses (JAMA/CDC-linked studies, mid\u2013late 2021) showing infection-induced antibodies were substantially more common than reported case counts indicated.","date":"2021-09-24 00:00:00"},{"id":"6be138f4-42ee-46f9-8ff5-ea2d160f4ea1","text":"Public debate and official briefings in 2021 (WHO and national public-health commentary) about the extent and durability of \'natural immunity\' after infection.","date":"2021-05-24 00:00:00"},{"id":"465c6fb0-520d-4a90-8ca7-5e568b69df28","text":"Human-rights reports documenting abuses (including looting) by some pro\u2011Ukrainian volunteer battalions (e.g., Aidar)","date":"2014-09-24 00:00:00"},{"id":"4b96c116-8ff6-4180-aa3a-b5e6d65f179b","text":"Reporting that Chechen fighters were present in eastern Ukraine (widely covered in 2014)","date":"2014-05-31 00:00:00"},{"id":"5ffd8aa4-ec97-4d8a-86a6-30eef06339a0","text":"Russian officials and state media accused the UK and US of involvement after the October 29, 2022 drone attack on the Sevastopol/Black Sea Fleet facilities; coverage noted Russian claims of foreign participation.","date":"2022-10-29 00:00:00"},{"id":"06489a60-fab7-4944-84a1-9059ed5014f1","text":"Reporting on leaked documents and media investigations that suggested UK special forces and other British personnel were operating in Ukraine (e.g., reporting that up to ~50 UK special forces were present).","date":"2023-04-11 00:00:00"},{"id":"f12b36ec-524f-4185-92f8-58f3b6597825","text":"Visegrad (Central European) leaders, including the Czech leadership, publicly underlined opposition to EU migrant/relocation quotas","date":"2015-09-04 00:00:00"},{"id":"243eb1c9-89ac-47a7-8b18-c1f944abe097","text":"Large and growing population of Ukrainian workers/residents in the Czech Republic (Ukrainians became the largest foreign national group)","date":"2017-12-24 00:00:00"},{"id":"7c03c0fd-ffe3-4565-acfa-cb3327161e79","text":"President Milo\u0161 Zeman and other officials made repeated anti-refugee/anti-Muslim public remarks during 2015","date":"2015-10-22 00:00:00"},{"id":"770b1abf-44f2-443a-ada7-f9de8408d8de","text":"European Court of Human Rights judgments finding domestic travel bans (imposed by bailiffs/authorities) problematic (e.g. Khlyustov v. Russia)","date":"2013-07-11 00:00:00"},{"id":"5bfadb85-2f13-495d-a5ed-3bb9abe6e895","text":"Passage of other high\u2011profile restrictive laws by the Duma (e.g. 2012 \'foreign agents\' NGO law)","date":"2012-07-20 00:00:00"},{"id":"e8eb7f37-56c7-4d36-8486-175416342713","text":"Widespread travel bans imposed by the Federal Bailiff Service on debtors (reports ~500,000 affected)","date":"2014-05-26 00:00:00"},{"id":"839b82be-8ea7-4cae-8cb7-5df1b1d8504d","text":"Public reporting in late June\u2013July 2022 that Ukraine had received and begun using U.S.-supplied HIMARS systems in combat.","date":"2022-07-25 00:00:00"},{"id":"c034b4f3-6230-449a-b8ac-837184dc0e06","text":"Media reporting that many of the victims/prisoners at Olenivka were fighters from the Azov Regiment captured after the fall of Mariupol/Azovstal.","date":"2022-07-29 00:00:00"},{"id":"b255b7c9-3282-4965-a14e-e386cae653f2","text":"International Committee of the Red Cross (ICRC) and other agencies reported limited or denied independent access to the Olenivka site and called for impartial investigation.","date":"2022-07-29 00:00:00"},{"id":"65adb4cf-7e23-4a79-a659-7fbf02ee5fd8","text":"WHO and regulatory guidance documents explicitly listing vaccine-associated enhanced disease/ADE as a safety consideration during COVID-19 vaccine development and evaluation","date":"2020-11-24 00:00:00"},{"id":"f9423227-1b63-4da3-a7f5-d507937f3480","text":"Preclinical animal studies (e.g., Tseng et al., PLoS ONE) reporting pulmonary immunopathology after SARS coronavirus vaccine challenge in mice","date":"2012-04-20 00:00:00"},{"id":"c6902fca-ab14-47ef-8569-a98135d90446","text":"International Republican Institute (IRI) / Rating Group national survey (September 2023) reporting strong majorities believe Ukraine can defeat Russia and support recapturing lost territory","date":"2023-09-24 00:00:00"},{"id":"0ff69dd0-d45a-4438-9242-dfcfdab7127a","text":"Atlantic Council / DFRLab analysis of pro\u2011Kremlin information operations (reporting on Russian info tactics aimed at undermining confidence in Ukraine, Feb 2023)","date":"2023-02-24 00:00:00"},{"id":"0e539a1b-8353-4717-8aa8-84f7274cff07","text":"Kyiv International Institute of Sociology (KIIS) omnibus poll on readiness for territorial concessions (data collection Nov 29\u2013Dec 9, 2023)","date":"None"},{"id":"3c61e333-2a92-4f9d-9a82-21dde68f2518","text":"President Volodymyr Zelenskyy\'s speech to the UN General Assembly (full text published Sept 20, 2023)","date":"2023-09-20 00:00:00"},{"id":"ceb9e85c-52f8-43ae-8501-cd165988bf17","text":"G7 public rejection of Russia\u2019s ruble-for-gas demand","date":"2022-03-28 00:00:00"},{"id":"b887f2b8-b1c5-4847-8a77-8f61e2bf908a","text":"Confusion about how the ruble-payment mechanism would work (Gazprombank conversion accounts)","date":"2022-03-31 00:00:00"},{"id":"c0781159-2fbb-43f9-b1d2-271979aef096","text":"UK government publicly called for investigation into allegations that Russia was stealing Ukrainian grain","date":"2022-06-24 00:00:00"},{"id":"2f5b44d4-cd77-4901-bf0b-5805d001fa71","text":"AP/PBS Frontline investigation documents large-scale removal of Ukrainian grain from occupied territories using satellite imagery and ship-tracking data","date":"2022-07-24 00:00:00"},{"id":"a6a090f2-250e-43f1-af87-da60443890f6","text":"UN\u2011brokered Black Sea Grain Initiative led to the first ship leaving Odesa carrying grain under the safe\u2011passage deal","date":"2022-08-24 00:00:00"},{"id":"1dcc4637-5075-408e-9c32-d48cdf9be951","text":"Longstanding public health and cultural practice in Japan of routine gargling to prevent respiratory infections, and official encouragement of gargling during the 2009 H1N1 outbreak (documented in peer\u2011reviewed literature).","date":"2009-04-24 00:00:00"},{"id":"7f72ea83-ff2f-4681-a254-a3b653f687c6","text":"Pre\u2011existing in\u2011vitro research (2015) showed povidone\u2011iodine (PVP\u2011I) oral rinses can rapidly inactivate related coronaviruses (SARS\u2011CoV, MERS\u2011CoV) in laboratory tests.","date":"2015-04-24 00:00:00"},{"id":"f0464042-16e0-4fe6-9cea-1520a58e9b6f","text":"2018 studies and media coverage reporting a significant slowdown of the Atlantic Meridional Overturning Circulation (AMOC)","date":"2018-04-25 00:00:00"},{"id":"aa518135-7417-406d-9511-8ae5af77f437","text":"2015 Scientific Reports paper by Zharkova et al. proposing a forthcoming \'modern grand solar minimum\' (linked to multi-decadal cooling)","date":"2015-10-22 00:00:00"},{"id":"c4b59a03-d07f-42af-8421-354a5780f962","text":"Late-January 2019 polar vortex cold snap widely covered in US media","date":"2019-01-29 00:00:00"},{"id":"99f7b628-7862-4faa-a1ab-c7a717ed8b26","text":"WHO scientific brief and multiple seroprevalence reports during mid-2020 indicating lower-than-feared infection fatality rates in some populations","date":"2020-08-24 00:00:00"},{"id":"0014feda-1b1b-42a4-aa95-a5b97781628e","text":"Ukrainian authorities publicly reported large-scale allocation of state land to ATO participants (land-for-soldiers program)","date":"2014-10-24 00:00:00"},{"id":"560e8ffd-ee97-4d01-a595-24d938c47d39","text":"May 2014 Land Agency initiative announced to provide mobilized servicemen and displaced soldiers with free land parcels (10\u201312 ares up to 2 hectares)","date":"2014-05-24 00:00:00"},{"id":"9ad9050f-5297-4565-a721-5483adf4a456","text":"Early volunteer recruitment drives and public discussions of material incentives for volunteers and battalions (wide volunteer mobilisation in March 2014)","date":"2014-03-17 00:00:00"},{"id":"ce541d26-e549-457b-a70d-d465ca8545c2","text":"Documented abductions, ill-treatment and forced labour by armed groups in Donbas during 2014","date":"None"},{"id":"182e124b-54fe-40db-a8a6-ec485c12f145","text":"NIH announces suspension/withdrawal of funding to EcoHealth Alliance projects involving the Wuhan Institute of Virology (political scrutiny and reporting intensified)","date":"2020-04-24 00:00:00"},{"id":"9dfaa4a0-ad0b-412b-91c7-424e2e092732","text":"Early suppression and censure of whistleblower doctor Li Wenliang and his subsequent death, widely reported internationally","date":"None"},{"id":"c00c097f-bcb6-4ed4-8fd5-dead73179f72","text":"Lancet clinical report and early epidemiology (first cluster descriptions) noting both links to the Huanan market and an earliest case with no market link, creating ambiguity about initial spillover","date":"2020-01-24 00:00:00"},{"id":"f854b645-473b-4244-a7c8-531d665d6b1d","text":"Douma suspected chemical attack and subsequent U.S./UK/France strikes","date":"2018-04-07 00:00:00"},{"id":"545df908-fabd-4031-bc78-cc2208ec4a29","text":"Salisbury Novichok poisonings linked to Russia (Sergei and Yulia Skripal)","date":"2018-03-04 00:00:00"},{"id":"29a4b5e8-3852-4ef7-8945-012494f68624","text":"IPCC Fifth Assessment Report (AR5) Summary for Policymakers released, synthesizing evidence on anthropogenic warming and acknowledging internal (natural) variability on decadal scales.","date":"2013-09-27 00:00:00"},{"id":"df02f620-4485-429f-8826-6f4ff9b9efaf","text":"Publication of Karl et al. (2015) in Science revising NOAA surface temperature dataset and concluding biases partly explained the so\u2011called \'hiatus\'.","date":"2015-06-04 00:00:00"},{"id":"5db43199-b0cb-4d87-b497-15807346afa5","text":"Release and publicity around discrepancies between satellite lower\u2011troposphere trends (UAH/RSS) and surface temperature records, including UAH Version 6.0 release (April 2015).","date":"2015-04-24 00:00:00"},{"id":"88bae962-c00b-49f9-b6d0-289953165ae8","text":"U.S. announces major defensive military assistance increases to Ukraine (e.g., $200 million package)","date":"2018-07-20 00:00:00"},{"id":"72caf4ba-911e-4116-ba62-9c8ff8286562","text":"U.S. Defense Threat Reduction Agency (DTRA) Biological Threat Reduction Program activities publicly documented in Ukraine","date":"None"},{"id":"5d954983-cb6e-4a77-ad29-8e94a7585934","text":"Westinghouse announced extended nuclear fuel supply to Ukraine (contract extension)","date":"2018-01-29 00:00:00"},{"id":"02b65303-b664-4292-a713-a0a542d88621","text":"Sea Breeze multinational naval exercises co-hosted by the U.S. and Ukraine (Black Sea)","date":"2018-07-24 00:00:00"},{"id":"20a849a7-46e3-40f7-a53a-ef9d656341e4","text":"U.S.\u2013Ukraine Nuclear Safety Arrangement signed (Rockville)","date":"2018-03-13 00:00:00"},{"id":"0237dae1-3387-43b5-85b5-cba8ff095863","text":"Event 201 pandemic tabletop exercise hosted by the Johns Hopkins Center for Health Security with the World Economic Forum and the Bill & Melinda Gates Foundation.","date":"2019-10-18 00:00:00"},{"id":"4ae6cdf7-a766-4c1c-8aee-3a3746dc2c7b","text":"Polish government rhetoric about protecting Poles and restricting entry for Ukrainians with \'anti\u2011Polish views\' (reported by Reuters).","date":"2016-11-10 00:00:00"},{"id":"5a1d42a5-3ff6-455a-8d97-b10540e1e8cd","text":"Polish Sejm passes a resolution on the Volhynia/Volyn killings (frames the 1943 massacres as \'genocide\'), heightening Polish\u2011Ukrainian historical tensions.","date":"2016-07-22 00:00:00"},{"id":"72293139-3b57-4eea-a823-2b901a0bd6cc","text":"Keeling Curve (Scripps/UC San Diego) update and commentary (June 6, 2024) reporting unusually large recent annual and multi-year jumps in atmospheric CO2 at Mauna Loa and in the Keeling record.","date":"2024-06-06 00:00:00"},{"id":"de60d725-248e-45d3-b701-2a13af9f5f3a","text":"Publication of a PNAS-backed study (led by Oregon State University and University of St Andrews) reporting that today\'s atmospheric CO2 increase is ~10 times faster than at any point in the last 50,000 years.","date":"2024-05-13 00:00:00"},{"id":"118bac1b-1c0e-46ec-995e-13205dbfa0fe","text":"Public familiarity and heightened sensitivity to the term \\"airborne\\" after prolonged COVID-19 airborne-transmission debates (CDC scientific brief acknowledging airborne transmission dynamics, May 2021)","date":"2021-05-07 00:00:00"},{"id":"36bae434-2756-408c-a259-d7ecb6730216","text":"WHO declares the monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)","date":"2022-07-23 00:00:00"},{"id":"0588b688-a1f1-4c74-bc0d-ab5b9fb67dee","text":"CDC public guidance stating infectious period normally lasts 2\u20134 weeks (not months)","date":"2022-07-29 00:00:00"},{"id":"1d9be90d-be78-4031-accf-9126f8346c89","text":"World Health Organization interim guidance on mask use updated (interim guidance published/updated in March\u2013June 2020, with a notable update 5 June 2020).","date":"2020-06-05 00:00:00"},{"id":"877e3f58-d245-4528-8d53-9ba2a6a0f325","text":"US CDC recommended on April 3, 2020 that members of the public should wear cloth face coverings in public settings where social distancing is difficult.","date":"2020-04-03 00:00:00"},{"id":"5bfee9de-e52b-47bc-9df0-6f7f5bcf7057","text":"The Great Barrington Declaration was published (October 4, 2020), advocating \'focused protection\' and opposing broad lockdowns and some mitigation measures.","date":"2020-10-04 00:00:00"},{"id":"cf1eee85-9662-465f-92bd-7755721934a6","text":"Adoption of the Kivalov\u2013Kolesnichenko language law expanding regional languages (2012)","date":"2012-08-24 00:00:00"},{"id":"45376586-0395-4dcd-b518-01cad0ca117a","text":"Verkhovna Rada voted to repeal the 2012 language law (23 February 2014)","date":"2014-02-23 00:00:00"},{"id":"fad7cf7f-dc96-4ebb-bc6d-b8b06657faef","text":"Pro\u2011Russian unrest and separatist seizures in eastern Ukraine; local councils declared Russian a regional language (March\u2013April 2014)","date":"None"},{"id":"528eceea-ad8d-4181-98a7-d21830e6b92c","text":"Poland\u2019s prime minister and other Eastern European leaders publicly call for an international tribunal to investigate Russia\u2019s actions","date":"2022-04-03 00:00:00"},{"id":"0e3e0511-d7db-4415-ada9-ee2e4a3be17a","text":"Legal analyses and reporting highlight that the ICC cannot currently prosecute the crime of aggression against a non\u2011party state like Russia without a UN Security Council referral","date":"2022-03-24 00:00:00"},{"id":"4af7ba6c-cb5c-47aa-864d-420317ab4551","text":"Divergent public language among Western leaders over strong legal labels (e.g., \'genocide\' versus \'possible genocide\') in April 2022","date":"2022-04-04 00:00:00"},{"id":"3410331e-c4bb-4b1b-9574-05e5018b3c78","text":"Major international media profiles and frontline reporting highlighted large numbers of Ukrainian women serving in combat roles.","date":"2023-08-02 00:00:00"},{"id":"734ada9f-5249-4622-87e4-59853bd3ca96","text":"Parliamentary debate and media attention around Ukraine\'s draft/mobilization laws, with officials explicitly saying female conscription was not part of the new draft law.","date":"2024-01-08 00:00:00"},{"id":"8e6134fe-fcea-496d-8c42-a0c71fc9314b","text":"Documented increases in pertussis (whooping cough) activity in 2023\u2013early 2024 reported by public health agencies","date":"2024-03-24 00:00:00"},{"id":"69e46ab7-fa2a-4486-aa2d-5674fe1d36ae","text":"Reports that Chinese firms/state-linked investors had shown interest in financing large Crimea projects (transport/energy/ports).","date":"2015-04-24 00:00:00"},{"id":"a79eec91-a9d0-4d1e-9151-c8ba4191eeae","text":"Siemens turbine deliveries controversy highlighted limits in enforcing sanctions on equipment shipments to Crimea.","date":"2017-06-24 00:00:00"},{"id":"4848d6dd-681c-4bfb-8f4c-088503283355","text":"RFE/RL investigation reporting that numerous EU firms and intermediaries were finding ways to do business in Crimea despite sanctions.","date":"2017-05-24 00:00:00"},{"id":"c84d033c-e6d4-4d02-87e5-bfbd16e5763c","text":"Publication of a broad scoping review \'Electric vehicles and health: A scoping review\' (Environmental Research) that summarized limited and mixed evidence about EV-specific health outcomes and pointed to evidence gaps (June 2024).","date":"2024-06-15 00:00:00"},{"id":"c4ae27ed-c685-40eb-b3f2-cd3a9e555b24","text":"A 2021 systematic review in Frontiers in Physiology summarized animal and limited human studies on radiofrequency electromagnetic radiation (RF\u2011EMR) from wireless devices and reported that many animal studies found reduced testosterone after RF\u2011EMR exposure (September 24, 2021).","date":"2021-09-24 00:00:00"},{"id":"edf44a9b-5a98-47e1-8ff2-e651a3916ab4","text":"U.S. ends COVID-19 national and public health emergencies","date":"2023-05-11 00:00:00"},{"id":"d2216b00-aa4e-4904-a59d-96640477b74f","text":"Court dispute over FDA\'s proposed slow release of Pfizer vaccine documents (initial 75\u2011year timeline)","date":"2022-01-07 00:00:00"},{"id":"51da7fb3-ba1c-4c01-bb2b-33e9987857e1","text":"Reports of black/metallic particles found in Moderna vaccine vials in Japan","date":"2021-09-24 00:00:00"},{"id":"120e6568-4927-46e5-9b8c-9209bae7ba65","text":"UNHCR / humanitarian agencies reporting large numbers of Ukrainians remaining under temporary protection across Europe (data briefs, 2024)","date":"2024-02-24 00:00:00"},{"id":"9ee5891d-a8c2-4320-bdf4-773e1c8b47a5","text":"Hungary tightens border-control procedures and increases checks for certain categories (early 2023)","date":"2023-01-24 00:00:00"},{"id":"74348668-7496-4786-bd40-a3af23277223","text":"Polish president vetoes law extending social benefits and protections for Ukrainian refugees","date":"2025-08-25 00:00:00"},{"id":"5f253ea7-44db-41d3-af44-c944763b5a9d","text":"Large-scale border disruption at Poland\u2013Ukraine crossings after Polish trucker protests temporarily blocked traffic","date":"2023-11-30 00:00:00"},{"id":"8b5a9367-1545-497c-928c-f030b8a8f17e","text":"EU Commission / Council actions on temporary protection timing (proposal/extension toward a defined transition period)","date":"2025-06-04 00:00:00"},{"id":"5d364e2a-f3de-43f7-b56a-969e6a87be50","text":"World Health Assembly adopted a package of amendments to the International Health Regulations (IHR)","date":"2024-06-01 00:00:00"},{"id":"ddc9cd67-afd2-4128-af33-fd1ad79e6eef","text":"A coordinated public letter and statements by many U.S. Republican governors saying they would not comply with a WHO pandemic agreement","date":"2024-05-22 00:00:00"},{"id":"9ba9a2bc-1b97-468e-8e27-647989e228f4","text":"WHO/PAHO international guidance on certification and coding of COVID-19 deaths published (guidelines on identifying COVID-19 as cause of death)","date":"2020-06-24 00:00:00"},{"id":"7f258dc4-cf55-47d7-be56-d97f72ce1266","text":"New York Times coverage that Russia was sending mercenaries and Syrian fighters to Ukraine","date":"2022-04-06 00:00:00"},{"id":"1bb93b9a-3781-44f3-9a0a-577dec3bc98e","text":"WHO Situation Report 132 (PDF) released on May 31, 2020, summarizing global confirmed COVID-19 cases and deaths through that date.","date":"2020-05-31 00:00:00"},{"id":"2c6af927-8707-4b2b-a140-05964d617e9d","text":"Media coverage in March\u2013April 2020 documenting overwhelmed hospitals and surging deaths in Lombardy and other early hotspots (e.g., New York, Lombardy) that highlighted acute local mortality spikes.","date":"2020-03-19 00:00:00"},{"id":"8697104c-7220-4b29-b05a-345b1a11c2eb","text":"Ukraine Health Ministry backs new organ-transplant law and announces 2018 pilot for cadaveric kidney donation","date":"2017-09-24 00:00:00"},{"id":"48f065e1-6239-40c3-8de3-d1143ae5a53c","text":"OSCE report and regional analysis on trafficking for organ removal (2013)","date":"2013-07-09 00:00:00"},{"id":"c9c22e9c-6197-4c83-b1bb-8e73c7a16c24","text":"French authorities and national media reported a sudden surge in bedbug sightings across Paris (including verified infestations in at least one school) that prompted government coordination meetings.","date":"2023-10-06 00:00:00"},{"id":"dcd2ed13-c5a6-4710-955f-f038ddd86c35","text":"Poroshenko\'s profile as a wealthy oligarch and highly polarising figure following his 2014 election (widely reported in 2014), which made character attacks and rumors about personal misconduct more plausible to hostile audiences.","date":"2014-06-24 00:00:00"},{"id":"4950e4b4-3064-47e2-b931-2dc32f30e301","text":"Canadian government issues travel advisories urging citizens to avoid travel to Ukraine","date":"2022-02-24 00:00:00"},{"id":"9823e290-a1be-4856-94c8-d7ef2125e053","text":"Ukrainian president signs decree on general mobilization","date":"2022-02-24 00:00:00"},{"id":"1c192a7f-6d7a-47cf-8ad1-f2b4242cc65c","text":"Large-scale Canadian charitable and advocacy campaigns raising funds and political support for Ukraine","date":"2022-03-01 00:00:00"},{"id":"ea77b17e-ecb8-4852-bf00-da2fb17cbbe1","text":"Reports of foreign/stainless\u2011steel particles found in some Moderna vaccine vials in Japan, prompting pauses of affected lots.","date":"2021-09-01 00:00:00"},{"id":"09d0628e-e7ad-4fc7-a135-0d7f8e2f9cc5","text":"FDA revises Emergency Use Authorization (EUA) for COVID-19 convalescent plasma, narrowing use to high\u2011titer units for specific hospitalized patients.","date":"2021-02-04 00:00:00"},{"id":"ea349321-89e6-4d71-9a4f-896fdd5e06e6","text":"American Red Cross published/updated guidance on COVID\u201119 vaccination and blood donation explaining eligibility rules and referring to FDA guidance (including notes about convalescent plasma collection changes).","date":"None"},{"id":"448ae192-3b42-4b2a-8680-e61ce109a521","text":"U.S. Fish and Wildlife Service 2008 Biological Opinion to protect the endangered Delta smelt","date":"2008-12-24 00:00:00"},{"id":"14e09847-a435-42c1-a835-bed3c468e5f7","text":"Media analysis and commentary on large volumes of stormwater/capture shortfalls (2015 coverage)","date":"2015-04-15 00:00:00"},{"id":"71d91ae6-6b54-4b70-b8aa-5a6814c43071","text":"California governor issues first-ever statewide mandatory urban water restrictions","date":"2015-04-24 00:00:00"},{"id":"df4460b4-7c1c-49af-be67-024ef6ef060f","text":"2017 Northern California \'Wine Country\' wildfires (Napa, Sonoma, Mendocino)","date":"2017-10-24 00:00:00"},{"id":"38d0ccc7-b6b8-4e53-8909-a8c39537ad0c","text":"Oroville Dam spillway failure and mass evacuation","date":"2017-02-24 00:00:00"},{"id":"855c1651-d97c-4cd5-b2de-b8ca61f51f95","text":"Cleveland Clinic (laboratory guidance/fact sheet) and other clinical bodies publishing guidance that MTHFR genotyping has limited clinical value (2020\u20132021).","date":"2021-02-24 00:00:00"},{"id":"6d616443-0575-4ec5-a830-05487037412b","text":"Publication of PNAS paper showing extremely slow and highly variable human DHFR activity (Bailey & Ayling, 2009).","date":"2009-09-24 00:00:00"},{"id":"b88a14bc-bc70-4f66-b011-56f47993a594","text":"BMC Public Health report on threshold doses above which unmetabolized folic acid appears in serum (Sweeney et al./BMC Public Health, 2007).","date":"2007-04-24 00:00:00"},{"id":"e0d555cc-8363-4331-aa93-dc1acfeeb692","text":"1979 and subsequent clinical reports: Published case reports and toxicology reviews documenting pennyroyal ingestion as a historical abortifacient and a cause of severe hepatotoxicity.","date":"None"},{"id":"79d5176e-9c81-4f30-8587-b5b143eec7e0","text":"July 15, 2004: Case report in the New England Journal of Medicine linking maternal use of blue cohosh to perinatal stroke and other neonatal harms.","date":"2004-07-15 00:00:00"},{"id":"5d1118ba-6b69-4321-84d6-7de9b1524f11","text":"CDC updated its \'Learn the Signs. Act Early.\' developmental milestone checklists, adding new checklists for 15- and 30-month visits and publishing revised milestone wording on the CDC site.","date":"2022-02-24 00:00:00"},{"id":"ce70bb4b-4946-4e75-a10c-b774ee576e03","text":"OSCE SMM reduced/ceased control of its Mariupol office amid the early invasion and reports that the Mission \'had not controlled its office\' in Mariupol since March 2022 (and the Mission publicly called for the release of detained SMM members in late May).","date":"2022-03-24 00:00:00"},{"id":"f91ac186-93e5-489b-ade1-ad29dde61184","text":"OSCE Special Monitoring Mission (SMM) publicly operated monitoring cameras and posts along the contact line prior to the 2022 full-scale invasion (public SMM daily reports noted monitors and equipment deployed).","date":"2022-02-24 00:00:00"},{"id":"34c56fa8-be6a-46c4-b26c-a4aeacac5d2e","text":"Release and reporting on 2018 U.S. diplomatic cables that raised safety and staffing concerns about the Wuhan Institute of Virology.","date":"None"},{"id":"82dddf7c-fd0c-4c46-9029-3fc44df72117","text":"Russian authorities begin large-scale issuance of Russian passports to Crimean residents and publicly announce high application numbers","date":"2014-03-24 00:00:00"},{"id":"52e91da0-9157-4d5e-a39e-0198037536bd","text":"Widespread reporting during 2022 that huge areas of Ukraine were contaminated with unexploded ordnance and mines (official estimates in Aug 2022).","date":"2022-08-12 00:00:00"},{"id":"c00d1032-387a-4c4f-b23f-57952627513c","text":"Russian missile strikes on Lviv damaged critical infrastructure and caused power outages (reported 11 Oct 2022).","date":"2022-10-11 00:00:00"},{"id":"2c94bfd2-8eb8-447c-94bd-aa14100c383e","text":"Anonymous bomb threats led to evacuations of Lviv supermarkets and shopping malls (mass evacuations reported 22 Oct 2022).","date":"2022-10-22 00:00:00"},{"id":"42160d7c-e28e-42d3-b0ab-b24654ac2dce","text":"CDC FluView weekly report showed influenza detections dropped to near zero by week 14 (week ending Apr 4, 2020).","date":"2020-04-04 00:00:00"},{"id":"3c6bf119-017a-4c56-87dd-60c0f339121f","text":"Council of State and Territorial Epidemiologists (CSTE) interim position statement published (Apr 5, 2020) updating COVID-19 case/death definitions to include probable cases.","date":"2020-04-05 00:00:00"},{"id":"067f96be-1ace-43fe-8105-2c02bc09f5c0","text":"CDC/NCHS released a provisional death counts report (PDF) with technical notes emphasizing that counts are provisional, delayed, and that multiple causes can be listed on death certificates (released Apr 10, 2020).","date":"2020-04-10 00:00:00"},{"id":"61fdaa4e-3c09-452e-a4aa-012df78ccdcc","text":"IPCC Sixth Assessment Report (AR6) Working Group I \u2014 Summary for Policymakers published","date":"2021-08-09 00:00:00"},{"id":"c4b9433f-a0c8-4d6d-9ec6-609949063e9e","text":"NOAA issues La Ni\xf1a advisory / \'double-dip\' La Ni\xf1a announcement","date":"2021-12-24 00:00:00"},{"id":"a084da89-c83b-4afd-b54c-2a8112ec592b","text":"Passage of Ukraine\'s \'decommunization\' laws (April 9, 2015) banning public display of Soviet symbols and changing commemorative practices.","date":"2015-04-09 00:00:00"},{"id":"40a2e79a-1c1f-48ac-bce5-99a7074fbb0c","text":"Verkhovna Rada passes sweeping \'anti-protest\' laws (known as the \'dictatorship laws\') restricting public assembly, internet access and media on January 16, 2014.","date":"2014-01-16 00:00:00"},{"id":"fd780cf9-e0e5-430e-a0f7-1871abe13666","text":"Deadly police crackdown on Euromaidan protests in Kyiv (notably February 18\u201320, 2014) where security forces used live fire against demonstrators.","date":"2014-02-18 00:00:00"},{"id":"a3bbeea1-6daf-47ac-8e8d-4efd4af5ad02","text":"April 2014 \'anti-terrorist operation\' (ATO) launched in eastern Ukraine (Donetsk/Luhansk) with security operations, checkpoints and restrictions on movement and gatherings.","date":"2014-04-15 00:00:00"},{"id":"3ba59ba3-06e5-4fcc-931b-19bf4789bc2f","text":"Rapid growth of the global \'detox\' / detox\u2011supplement market (industry reports and press releases 2020\u20132021 showing large and growing commercial market for detox supplements).","date":"2021-10-18 00:00:00"},{"id":"318d5425-4331-4f32-9398-ac802757f8bf","text":"Publication of a 2022 peer-reviewed review \'Can Antioxidants Reduce the Toxicity of Bisphenol?\' summarizing multiple studies that several dietary antioxidants (curcumin, quercetin, melatonin, lycopene, genistein, etc.) reduce BPA\u2011induced oxidative stress in vitro and in animal models.","date":"2022-02-18 00:00:00"},{"id":"d3c7f4fe-66ff-40a3-b62a-9d9b9d2739ca","text":"Regulatory controversy and mixed messaging about BPA safety after regulatory reviews (e.g., FDA\u2019s 2018 BPA assessment) prompted public debate and critical commentary from scientists.","date":"2018-04-24 00:00:00"},{"id":"dfb4efbb-bfbb-49c2-aab2-003dc944b974","text":"Takeda and Moderna publish investigation and voluntary recall statement after foreign-particle findings in Japan","date":"2021-10-24 00:00:00"},{"id":"76afb1a9-c1cb-49a5-b345-61590db5cb86","text":"Publication and reporting of excess-mortality analyses in Japan showing increased deaths during/after the pandemic with cardiovascular diseases among contributing causes","date":"2024-04-24 00:00:00"},{"id":"b8efd856-ccbb-42ac-8e04-a53a4c96b40b","text":"Public-health reports and peer-reviewed case reports document myocarditis/pericarditis occurring after mRNA COVID-19 vaccination (identified in 2021 monitoring and guidance)","date":"2021-06-24 00:00:00"},{"id":"8b1fc3f1-6e5d-4aba-947b-0a74c23dbd95","text":"Harvard launches the Solar Geoengineering Research Program (SGRP), formalizing academic research into stratospheric aerosol methods.","date":"2017-04-24 00:00:00"},{"id":"2d0e301b-eeab-47d1-8581-f4fd7ae239e4","text":"IPCC Special Report on Global Warming of 1.5\xb0C (SR1.5) discusses solar radiation management (SRM) as a theoretical option and highlights governance and uncertainty issues.","date":"2018-10-24 00:00:00"},{"id":"87aebf1a-2e8e-405f-924a-4588468d03be","text":"Major media coverage highlighting geoengineering as a contested climate option (e.g., The Guardian: \'Geoengineering may be used to combat global warming, experts say\').","date":"2018-10-08 00:00:00"},{"id":"92768a75-9f7f-4ab9-8595-46aa79de7699","text":"2018 pilot study published in the Journal of Alzheimer\'s Disease reporting cognitive improvements after a 21-day coconut oil\u2013enriched Mediterranean diet","date":"2018-07-20 00:00:00"},{"id":"1c7fbe04-ec94-48b6-9c05-105d999c6553","text":"International media and human-rights organizations reported abductions, torture and summary killings in eastern Ukraine (including areas around Slovyansk) during April\u2013May 2014.","date":"2014-05-24 00:00:00"},{"id":"47150385-ade3-432b-967e-9c1960df5be8","text":"Pro\u2011Russian militants abandoned Slovyansk and Ukrainian forces re-entered the city after the siege, leaving a chaotic information environment and reports of casualties and abuses.","date":"2014-07-05 00:00:00"},{"id":"725f30c6-6356-4be4-895a-af950908eac5","text":"Russia imposes a one\u2011year ban on many Western food imports (fruit, vegetables, meat, dairy) in retaliation to sanctions","date":"2014-08-07 00:00:00"},{"id":"6ee4125e-714c-4b39-a047-f03ce6530dd8","text":"Coverage in early 2015 highlighting that Russians were spending a much larger share of income on food amid economic turmoil","date":"2015-03-03 00:00:00"},{"id":"d4e1806a-1fa2-48fb-acb4-72f8364c744d","text":"Russian rouble crashes in December 2014, prompting emergency central\u2011bank action","date":"2014-12-24 00:00:00"},{"id":"9a4ed516-ccae-4da8-9436-a0e39e489053","text":"FDA published a draft guidance clarifying aluminum limits for small-volume parenteral products used in parenteral nutrition (widely covered Dec 2022)","date":"2022-12-07 00:00:00"},{"id":"611aa0d7-ac04-4701-aa64-cb64aaeee9c3","text":"Publication of Vaccine pharmacokinetic analysis that became the benchmark for vaccine aluminum safety assessments (Mitkus et al., 2011)","date":"2011-11-28 00:00:00"},{"id":"2c3a20fa-8de4-435e-86cc-ce4eceb9327f","text":"FDA warning about aluminum risk from an unapproved Hospira potassium phosphates product (FDA alert)","date":"2023-02-09 00:00:00"},{"id":"834c4a1d-d053-4003-9d3f-eec1ea5562f0","text":"European Commission progress report concluded Ukraine met the benchmarks for visa liberalisation and announced it would present a legislative proposal to lift short-stay visa requirements.","date":"2015-12-18 00:00:00"},{"id":"20037b8d-86d1-4760-a95b-9cc30382fe98","text":"Immediate Dutch government reaction was cautious \u2014 officials said they would reconsider ratification and seek a formal response, but announced no immediate legal block to EU-level procedures.","date":"2016-04-07 00:00:00"},{"id":"855fdde6-02a6-438e-9904-7d2c5d4f57c4","text":"Historical precedent: Ukraine suspended passenger and cargo rail/bus links to Crimea in December 2014 citing security concerns","date":"2014-12-26 00:00:00"},{"id":"3d8d34c5-ddad-4bcd-bff9-af8c13886dcc","text":"UK MHRA conditional authorisation and patient information leaflets published (regulatory materials listing ingredients and usage information)","date":"2020-12-02 00:00:00"},{"id":"6f8de6bf-7ebb-4122-91c9-32fceaad5497","text":"FDA/BioNTech briefing documents for the VRBPAC EUA review that list vaccine components (mRNA, lipid nanoparticle constituents including PEG, salts, and sucrose)","date":"2020-12-24 00:00:00"},{"id":"cd397027-fc2b-434a-be79-66a8dd895ed3","text":"Ukrainian President Volodymyr Zelensky publicly floated Rustem Umerov as a possible candidate to be Ukraine\'s ambassador to the United States during the International Ukraine Recovery Conference (URC2025) in Rome.","date":"2025-07-15 00:00:00"},{"id":"cf1abeac-55ef-4d5e-b26b-6b043978f7a0","text":"U.S. FDA public warning against using veterinary or unapproved ivermectin products to treat or prevent COVID\u201119","date":"2020-08-21 00:00:00"},{"id":"c32cfa0a-5731-42eb-9405-49aa1ae6fb3e","text":"CDC public information noting \'common human coronaviruses\' (229E, NL63, OC43, HKU1) have been identified for decades","date":"None"},{"id":"204cfb3e-51d0-4c06-9b34-b7f9f5bb562f","text":"Implementation of selective city-level bans on older diesel vehicles (example: Munich introduced restrictions on Euro 4 diesel vehicles in its low\u2011emission zone).","date":"2023-02-01 00:00:00"},{"id":"ff78ec41-dc42-40e6-a051-567be1db134e","text":"European Commission publishes proposal COM(2023)451 \u2014 a draft Regulation on circularity requirements for vehicle design and management of end\u2011of\u2011life vehicles (revising ELV rules).","date":"2023-07-13 00:00:00"},{"id":"bf818f5b-90da-4582-85fb-19fc52a635cb","text":"EU \u2018Fit for 55\u2019 / CO2 standards debate and widespread coverage of the EU aim for zero\u2011emission new cars by 2035.","date":"2022-10-19 00:00:00"},{"id":"14b273fe-7ada-41c4-be2e-e5e07b0f1e57","text":"Hungarian Prime Minister Viktor Orb\xe1n publicly opposed fast\u2011tracking Ukraine\u2019s EU accession (Dec 13, 2023)","date":"2023-12-13 00:00:00"},{"id":"d915c3ed-2ef6-414a-88a6-e1bbbcf055d2","text":"\u2018For Ukraine, for their Freedom and Ours!\u2019 campaign urged MEP candidates to sign a pro\u2011Ukraine Commitment Charter (May 11, 2024)","date":"2024-05-11 00:00:00"},{"id":"8df2d92d-4658-40ec-bde9-6f8142269924","text":"Yle launched/ran its European election \'compass\' showing candidate positions (May 2024)","date":"2024-05-24 00:00:00"},{"id":"fb31651d-30f2-4a99-b469-e59003f53a8a","text":"European Parliament Special Committee warned of foreign interference and disinformation ahead of the June 2024 elections (May 24, 2024)","date":"2024-05-24 00:00:00"},{"id":"39333550-34d4-4ce2-a36a-2c97e736d53c","text":"Public release/submission of the RaTG13 genome sequence to public databases (GenBank accession MN996532 / GISAID submission in January 2020).","date":"2020-01-27 00:00:00"},{"id":"700992d8-f1e0-497c-acbe-78b9492d07b9","text":"BMJ Case Report (2018) and wider media attention on Macrophagic Myofasciitis (MMF) case reports linking persistent aluminium deposits at injection sites to chronic symptoms.","date":"2018-07-24 00:00:00"},{"id":"9ca4877e-5f87-49b8-9445-275bce494d17","text":"2013 BMC Medicine study \'Slow CCL2\u2011dependent translocation of biopersistent particles from muscle to brain\' (Khan et al.).","date":"2013-08-08 00:00:00"},{"id":"ce966e10-c2bd-47c0-9418-9e74ef39232a","text":"Publication of 2015 review \'Biopersistence and Brain Translocation of Aluminum Adjuvants of Vaccines\' by Gherardi et al.","date":"2015-02-24 00:00:00"},{"id":"c315885c-f36f-4cb3-99a0-25ec60dfcd60","text":"EU publicly criticises Poroshenko\'s anti\u2011corruption court bill and signals consequences (January 2018)","date":"2018-01-24 00:00:00"},{"id":"25d666ca-7aed-47ca-a084-6bd9ce2c8274","text":"U.S. criminal indictment of Paul Manafort (October 2017) for unregistered lobbying related to Ukraine","date":"2017-10-24 00:00:00"},{"id":"0a737724-a683-4c0f-9a7c-ab1a2bd3b414","text":"Investigative expos\xe9 on defence procurement implicating son of Poroshenko ally (Hladkovskyi)","date":"2019-02-24 00:00:00"},{"id":"adcc03bd-1444-4f94-9c3a-79f6971eaabd","text":"Ukrainian President Petro Poroshenko signs a cooperation agreement with Ecumenical Patriarch Bartholomew in Istanbul to advance autocephaly for a Ukrainian church.","date":"2018-11-03 00:00:00"},{"id":"21b41621-8ee2-479f-8e02-e12c53da180f","text":"Reporting that President Poroshenko publicly used the Tomos and the new church as part of his 2019 re-election messaging.","date":"2019-01-24 00:00:00"},{"id":"ff095616-4af7-4f55-b51e-7f432b40a233","text":"U.S. administration ordered an intelligence review into the origins of COVID\u201119 (President Biden, public announcement and press coverage), which brought renewed political attention to lab\u2011origin claims (May 2021).","date":"2021-05-24 00:00:00"},{"id":"06771dc0-9d5e-45d4-88a8-d3ab9f85d2f3","text":"Reporting in mid\u20112023 that Ukraine\u2019s 2023 summer counteroffensive produced only limited gains (e.g., BBC and other outlets in August 2023) created a broader narrative of stalled Ukrainian progress","date":"2023-08-05 00:00:00"},{"id":"85028514-fcf2-460e-b88f-ec26291d1d1c","text":"Japan suspends and recalls Moderna vaccine doses after foreign particles found (August\u2013September 2021)","date":"2021-08-24 00:00:00"},{"id":"6435466e-2952-4414-a5f1-47d0171d8ffe","text":"CDC guidance allowing fully vaccinated people to resume most activities without masks (May 13, 2021) and subsequent reversals with Delta/Omicron","date":"2021-05-24 00:00:00"},{"id":"bcb14239-600a-4eab-b1b9-58e88135fa1b","text":"Federal judge orders expedited release of large batches of FDA/Pfizer vaccine documents after FOIA litigation (January 2022)","date":"2022-01-24 00:00:00"},{"id":"29f4ec77-37a2-4604-9bcc-2ce84dd4c238","text":"CDC/ACIP update and MMWR on myocarditis reports after mRNA vaccines (June 2021)","date":"2021-06-24 00:00:00"},{"id":"73c8b15d-1231-42da-a241-422b5c1fb69b","text":"CDC VISION Network MMWR showing waning mRNA vaccine effectiveness during Omicron (Feb 2022)","date":"2022-02-24 00:00:00"},{"id":"4f4ed72b-59e3-4046-aaf2-44942cd0b308","text":"Russia sends \'humanitarian convoy\' toward eastern Ukraine and insists on involvement (August 2014)","date":"2014-08-12 00:00:00"},{"id":"4a4e224e-7a32-4905-aa82-ff4c93672219","text":"Ukrainian parliament adopts law granting \'special status\' to certain areas of Donetsk and Luhansk","date":"2014-09-16 00:00:00"},{"id":"aff81321-a0f3-4580-8bcf-752f4e09fcf5","text":"President Vladimir Putin\u2019s public justification (March 2014) for actions in Crimea citing protection of Russian speakers/compatriots","date":"2014-03-18 00:00:00"},{"id":"361e2400-514c-4d1c-8260-a9666a5a4248","text":"Longstanding monitoring and studies at Altamont Pass Wind Resource Area documenting unusually high raptor (including golden eagle) mortality at that site (estimates cited of ~75\u2013110 golden eagles killed annually in some monitoring periods).","date":"None"},{"id":"1b6c2507-9795-4fb5-bccb-74065585080c","text":"U.S. Fish & Wildlife Service final eagle incidental-take rule (2024) \u2014 revised permitting framework and creation/clarification of general permits for qualifying wind projects (rulemaking completed Feb 2024).","date":"2024-02-12 00:00:00"},{"id":"c3bd5dcd-4149-4477-a659-7bb5246d1bb5","text":"Europe\u2019s 2022 energy-price shock and widespread reporting (Eurostat summary Apr 26, 2023) showing record household electricity and gas price increases in 2022.","date":"None"},{"id":"83473979-fb4b-4337-b7c1-cdf92eb9f099","text":"Winter Storm Uri (Feb 2021) \u2014 widespread reporting and official ERCOT analyses showing frozen equipment across fuel and renewable sources and public debate blaming frozen wind turbines for Texas outages.","date":"2021-02-22 00:00:00"},{"id":"19e439e9-e941-45d9-97d4-3d80f61e6139","text":"Adoption of Ukraine\'s \'decommunization\' laws banning communist symbols (including measures that led to restricting St. George\'s ribbon) by the Verkhovna Rada.","date":"2015-04-09 00:00:00"},{"id":"1e0aa012-871a-47c6-b3de-310a4b27a131","text":"High\u2011profile coverage in Western and regional media documenting the St. George\'s ribbon\'s revival in Russia and its adoption by pro\u2011Russian activists in eastern Ukraine around Victory Day (widely reported in 2014\u20132015).","date":"2015-05-24 00:00:00"},{"id":"08b338d4-ba23-461e-acd0-3aeb175af22a","text":"British intelligence assessment reported that Russia may have lost a third of the ground forces it committed to the Ukraine offensive","date":"2022-05-15 00:00:00"},{"id":"6473f1aa-081b-466b-b4fd-20d81d1581a2","text":"Ukrainian General Staff released casualty figures for Russian forces (tens of thousands) in mid\u2011May and publicized high cumulative loss numbers","date":"2022-05-18 00:00:00"},{"id":"ff3e0441-f529-4a70-9757-06710b824691","text":"Public drone and ground imagery showing multiple destroyed Russian tanks and armoured vehicles around Kyiv and in Bucha after Russian withdrawals","date":"2022-04-06 00:00:00"},{"id":"6c9a434b-1457-47b6-9dcc-1c75e4861937","text":"Maxar and other commercial satellite imagery releases in May 2022 showing destroyed equipment and damage across multiple frontline areas","date":"2022-05-12 00:00:00"},{"id":"01e425df-a493-4ceb-a10f-366132092c49","text":"WHO designation of Omicron as a variant of concern and rising discussion of immune escape (Nov 26, 2021)","date":"2021-11-26 00:00:00"},{"id":"bb447e51-3e43-43d2-aff6-cd68610c451a","text":"Public\u2011health guidance reiterating vaccination after prior infection (CDC and other authorities, 2021\u2013early 2022)","date":"2022-02-24 00:00:00"},{"id":"7907d9ef-600b-4c2d-a3be-9c4a176cd7be","text":"Publication of Dagan et al. (Israel) showing high real-world effectiveness of the BNT162b2 (Pfizer) vaccine","date":"2021-04-15 00:00:00"},{"id":"40f63a23-9a81-4612-a7c6-663a75472a70","text":"Hungary blocked a NATO\u2013Ukraine commission meeting over Ukraine\'s 2017 education law","date":"2017-12-24 00:00:00"},{"id":"33409e40-fa92-45b1-91e9-7281a7f9b3fd","text":"Hungarian government rhetoric defending the Hungarian minority in Zakarpattia and threatening to obstruct Ukraine\'s Euro-Atlantic integration (2017)","date":"2017-10-24 00:00:00"},{"id":"1e2ed96f-4bfd-4a09-b9fb-c73047552ac0","text":"Hungary\'s close energy and political ties with Russia (Paks II nuclear deal signed in January 2014)","date":"2014-01-14 00:00:00"},{"id":"aca0f8db-8cce-436e-9f36-c59945100e64","text":"Malaysia Airlines Flight MH17 shot down over eastern Ukraine","date":"2014-07-17 00:00:00"},{"id":"7d2c1726-d24b-411c-a5d2-91e783ff24e2","text":"EU/East StratCom and Western coverage documenting Russian disinformation campaigns in Europe (2015\u20132017)","date":"2017-06-24 00:00:00"},{"id":"51cada5f-bae0-4fe4-82f2-f424c9951e82","text":"The OSCE Parliamentary Assembly (OSCE PA) deployed a separate observer delegation and issued a statement describing the election as \'well administered\' while also noting it took place in an \'overly controlled environment\'.","date":"2018-03-19 00:00:00"},{"id":"517eda25-9e4e-4744-afea-9ec93d143de1","text":"CIS (Commonwealth of Independent States) and other regional observer missions publicly declared the election legitimate, transparent or free.","date":"2018-03-19 00:00:00"},{"id":"5d5f34ae-5d42-4d04-8dbc-2d17a2182cd3","text":"OSCE/ODIHR published a preliminary statement saying the 18 March 2018 Russian presidential election \'lacked real choice\' and noted pressure on critical voices.","date":"2018-03-19 00:00:00"},{"id":"c7bcd41b-1225-4ee5-a3f4-e24ba2264600","text":"Brazilian President Jair Bolsonaro publicly called COVID\u201119 \'a little flu\' and urged reopening despite rising cases.","date":"2020-04-24 00:00:00"},{"id":"46f0ed0e-6f42-49fb-bf9e-93ca1af2fdcf","text":"U.S. CDC published its estimated burden for the 2019\u20132020 influenza season (tens of thousands of flu deaths) during spring 2020.","date":"2020-04-24 00:00:00"},{"id":"2f6ae23a-6a6d-466b-a49c-0c243534c600","text":"U.S. CDC issued guidance for certifying deaths due to COVID\u201119 allowing certifiers to report COVID\u201119 on death certificates without laboratory confirmation in certain circumstances (Guidance for Certifying COVID\u201119 Deaths, April 2020).","date":"2020-04-24 00:00:00"},{"id":"0b34a825-fd9a-4fc3-881e-05b84a59c7a6","text":"International monitors curtailed/paused long-range drone surveillance after repeated shoot-downs and jamming","date":"2016-10-28 00:00:00"},{"id":"b2b60d66-d76d-450f-8e69-1ca976ccda79","text":"OSCE long-range UAV lost after spotting a surface-to-air missile system near Donetsk","date":"2018-10-27 00:00:00"},{"id":"efcf46a1-61b7-4d0b-a5aa-5529bf29d0d3","text":"Pentagon comments and reporting that a limited amount of Presidential Drawdown Authority/stockpiles remained to provide to Ukraine (public discussion of remaining resources)","date":"2023-09-24 00:00:00"},{"id":"b91d7bec-96a9-4d94-bdc2-5ed4eb968349","text":"President Biden formally requested roughly $24 billion in new aid for Ukraine (public request to Congress)","date":"2023-08-10 00:00:00"},{"id":"f6d5650a-6b0a-4043-9a6b-7eabb6c7a150","text":"U.S. State Department and other reports described Ukrainian procedures allowing some civil-status acts (for example, births) occurring in occupied areas to be registered using documents produced by occupation authorities to ensure access to services.","date":"2023-04-24 00:00:00"},{"id":"38f1cf54-5ad5-4c49-8a3d-e93657b103ee","text":"Ukrainian Ombudsman statement noting Ukraine does not recognize Russian passports issued in occupied territories, while discussing legislative options for how residents might renounce such documents after liberation.","date":"2023-04-17 00:00:00"},{"id":"3e5f3975-3edc-4cd0-a670-f2c1840c66e6","text":"Verkhovna Rada approved a mechanism to evaluate/validate educational documents issued in temporarily occupied territories (draft law passed to create testing/validation procedures).","date":"2023-11-21 00:00:00"},{"id":"9893fde8-e5de-4296-b569-f392ddf5393a","text":"Ukraine engaged in limited, practical negotiations and humanitarian arrangements (e.g., corridors for ships, humanitarian talks) with actors linked to occupied areas and with mediators in 2023.","date":"2023-08-11 00:00:00"},{"id":"f17fe3ad-a3a7-4472-b37d-5ca020d6ec9f","text":"Samoa measles outbreak and prior botched MMR injections that caused two infant deaths, undermining local vaccine confidence","date":"2019-09-24 00:00:00"},{"id":"49f61cde-4635-4a82-bb4c-63e3298cb768","text":"CDC reporting of rare myocarditis/pericarditis cases after mRNA COVID\u201119 vaccination in adolescents","date":"2021-06-24 00:00:00"},{"id":"676facc8-78a8-42f4-a283-637f67e1fb55","text":"New York Times feature \'In Washington, Olena Zelenska Dressed for Ukraine\' describing her Washington wardrobe, the role of her stylist, and the diplomatic messaging in her clothing choices.","date":"2022-07-21 00:00:00"},{"id":"5ad082db-f23f-46fd-b81a-fefc0f9075bb","text":"Tobacco industry pivot and public messaging promoting nicotine products (e.g., BAT reporting growth in vaping/oral nicotine)","date":"2022-02-24 00:00:00"},{"id":"e93e1943-e0ab-4308-b6d5-77afb1fb7c94","text":"Cochrane systematic review finding transdermal nicotine superior to placebo for active ulcerative colitis (with important limitations)","date":"2004-10-24 00:00:00"},{"id":"dbc8a9c3-8baa-41ca-badc-d94ab83818c3","text":"Small Phase 1 trial of an alpha7\u2011nicotinic agonist showing biomarker and attention effects in two adults with autism","date":"2016-12-24 00:00:00"},{"id":"92a4a455-c203-458c-9cc2-0914b6b1bb7b","text":"Early reporting and analysis warned that Russian tactics could include heavy artillery, siege and attrition that would \'grind down\' Ukrainian defenses and cities.","date":"2022-03-02 00:00:00"},{"id":"ebce9aef-82f3-4955-bb2b-a9c93b3f84f0","text":"U.S. Secretary of State Antony Blinken made multiple public remarks in early March emphasizing both the scale of Russian forces and U.S. support for Ukraine (including a March 6 interview where he said Putin \'is destined to lose\').","date":"2022-03-06 00:00:00"},{"id":"22021f3b-e8a1-4ebd-828a-825c45610f81","text":"USDA and FDA announce formal agreement on regulation of cell\u2011cultured food products","date":"2019-03-07 00:00:00"},{"id":"4420e0a2-5ba0-4a0d-a7d9-826e094acd08","text":"GFI (Good Food Institute) \'2022 Cultivated Meat State of the Industry\' report (published Jan 2023)","date":"2023-01-24 00:00:00"},{"id":"b737f51d-eda6-4784-92cf-3ef5948a13fe","text":"First PEGIDA offshoot rally in Sweden (Malm\xf6) and associated media coverage of anti\u2011Islam/anti\u2011migration street demonstrations","date":"2015-02-10 00:00:00"},{"id":"a829fdc9-636d-4a65-9100-e6491e27a82b","text":"U.S. FDA approval of VEKLURY (remdesivir) for COVID\u201119 treatment (press announcement and approval) in October 2020.","date":"2020-10-22 00:00:00"},{"id":"d3a0d501-6436-496b-99a9-51ec76f653d4","text":"PALM (Ebola) randomized trial (NEJM, 2019) stopped remdesivir arm after interim results showed higher 28\u2011day mortality in the remdesivir group compared with certain monoclonal antibody treatments.","date":"2019-11-27 00:00:00"},{"id":"1a242b20-5120-4ab9-a68a-4591c9689eea","text":"President Zelensky dismissed all regional military recruitment centre heads amid a corruption scandal (public firing announced 11 August 2023).","date":"2023-08-11 00:00:00"},{"id":"8c0cbb84-db13-44d4-b4cc-9904138a88e0","text":"Verified reports of real civilian fatalities in Bila Tserkva from previous Russian attacks (example: kamikaze drone/strike reported 05 October 2022 with at least one casualty).","date":"2022-10-05 00:00:00"},{"id":"50ba63ef-9d11-4bda-8ad8-fcc3de82fc84","text":"A separate, real violent incident linked to conscription/document checks was reported (draft officer fatally wounded during a papers check in Lviv).","date":"2023-12-04 00:00:00"},{"id":"c9647f6c-c432-434e-851c-eacfa8ab85bd","text":"President Obama and some Western leaders publicly deferred sending lethal weapons to Ukraine (reported agreement not to supply lethal defensive arms at that time).","date":"2015-03-09 00:00:00"},{"id":"2a98ff16-b946-4fcf-85bd-ccb288f0aa27","text":"Canada launched Operation UNIFIER, a Canadian Armed Forces training mission to Ukraine.","date":"2015-04-14 00:00:00"},{"id":"a1c06e67-80d5-4d8f-b0cd-8d383af5b2b5","text":"Pentagon suspended planned military exercises and activities with Russia amid the Ukraine crisis.","date":"2014-03-24 00:00:00"},{"id":"54f58f01-a70b-4df4-806c-2e9b85fcfb74","text":"NATO Secretary-General publicly stated NATO had no plans to deploy combat troops to Ukraine.","date":"2014-02-27 00:00:00"},{"id":"e462c37e-791b-4cc3-8ff0-c39070b5a7a5","text":"NSIDC analysis: unusually rapid December 2023 sea-ice expansion noted in early January 2024 (\'Fast December expansion\')","date":"2024-01-03 00:00:00"},{"id":"b797a527-44cf-4f53-99fe-1099c00679dd","text":"IPCC AR6 (WGI) projection showing Arctic likely to be \'practically ice-free\' in summer near mid-century (released Aug 2021)","date":"2021-08-24 00:00:00"},{"id":"a7284336-7028-4863-afb0-b32f48dc2e87","text":"Sterigenics / Willowbrook ethylene oxide emissions controversy and EPA/CDC assessments (facility operations suspended/closed amid cancer\u2011risk concerns).","date":"2019-09-24 00:00:00"},{"id":"1f783ba8-cb50-4762-b602-1e7f5ee916d5","text":"Ukrainian authorities agreed to implement the \'Steinmeier formula\' as part of efforts to restart Minsk-format negotiations (announced Oct 1\u20132, 2019).","date":"2019-10-02 00:00:00"},{"id":"4e12fd61-0875-4354-bb83-d269570c8eca","text":"Volodymyr Zelensky publicly proposed direct talks and a conciliatory approach to Russia after taking office, signalling a priority on negotiation and rapprochement.","date":"2019-07-08 00:00:00"},{"id":"4d7eb9b1-9a26-4e98-8fcf-a28104ea6824","text":"Russia and Ukraine carried out a high-profile prisoner exchange in early September 2019, swapping dozens of detainees.","date":"2019-09-07 00:00:00"},{"id":"26ef7b8d-385d-40b7-9fce-5868078df2c9","text":"Ukraine\'s legal framework largely prohibits/does not recognize dual citizenship (Law on Citizenship of Ukraine, enacted)","date":"2001-04-24 00:00:00"},{"id":"98a74f5c-953f-4fe8-aaf3-a6941ae420a2","text":"Russia begins mass issuance of Russian passports in annexed Crimea (widely reported)","date":"2014-03-24 00:00:00"},{"id":"8f20a6e9-2f1a-4b15-8d4c-21f4a02dbd58","text":"Italian TV documentary \'Ucraina, le verit\xe0 nascoste\' by Gian Micalessin aired on Canale 5 (Matrix) and presented testimony alleging Georgian snipers fired on Maidan protesters.","date":"2017-11-15 00:00:00"},{"id":"724bd55a-d073-4ffa-b8b1-841148e20041","text":"Zeman\'s high\u2011profile engagement with Russia (including attending Moscow Victory Day events and meeting Putin in May 2015).","date":"2015-05-09 00:00:00"},{"id":"4d8bbb1a-ffb1-40fc-969d-adc93352a468","text":"Zeman\'s October 2017 PACE remarks calling the annexation of Crimea a \'fait accompli\' and suggesting compensation.","date":"2017-10-10 00:00:00"},{"id":"67ff1894-21a6-4d09-9475-13c85ccf61b3","text":"Pro\u2011Kremlin Crimean Tatar group Kyrym Birligi was invited to the presidential Independence Day reception at Prague Castle.","date":"2019-10-28 00:00:00"},{"id":"2ad67026-a0ab-4011-8924-4046e01e566d","text":"Widespread news stories and headlines (e.g., Meduza) summarising Zelensky\'s comments emphasizing Ukraine could pursue a diplomatic return of Crimea rather than costly military operations","date":"2024-11-21 00:00:00"},{"id":"9ab622b4-abc7-402f-8d7d-9684c2d41515","text":"DFRLab report documenting increasing use of AI\u2011generated audio/video and synthetic media in the Ukraine information space (showing precedent and tools available for falsifying statements)","date":"2024-07-09 00:00:00"},{"id":"097e82e0-2a65-4af7-b3d9-e45351508ccd","text":"Pre-existing public commemorations of Stepan Bandera in Ukraine (e.g., Kyiv renaming Moscow Avenue to Bandera Avenue in 2016)","date":"2016-07-24 00:00:00"},{"id":"7b0520cd-ad41-461a-825b-0352b225d3f1","text":"India (Serum Institute) placed temporary export restrictions on AstraZeneca/COVISHIELD supplies as domestic COVID-19 cases surged, delaying shipments to COVAX and other countries.","date":"2021-04-24 00:00:00"},{"id":"87c456ee-ec34-4960-9903-f674eb55b2dd","text":"WHO leaders publicly warned that vaccine supply was limited and urged countries to prioritise high-risk groups and support equitable distribution rather than assume immediate universal coverage.","date":"2021-09-24 00:00:00"},{"id":"3736a909-47e1-4153-aad9-9a216d168057","text":"COVAX cut its 2021 delivery target after supply problems, announcing a lower-than-expected dose forecast and warning it would fall short of initial goals.","date":"2021-09-24 00:00:00"},{"id":"28857841-34c9-41d8-9e68-cfa18abcaec5","text":"Contamination and production errors at Emergent BioSolutions\' Baltimore plant led to the destruction or sequestering of millions of vaccine doses and an FDA-ordered manufacturing pause.","date":"2021-04-24 00:00:00"},{"id":"88b1fcd6-9e80-4dcd-b0c6-ddb5f0357550","text":"Reports in early 2021 that lipid nanoparticles and other specialized raw materials used in mRNA vaccines faced constrained global supply with few suppliers.","date":"2021-02-24 00:00:00"},{"id":"e36a25eb-ee71-4fe7-bbb6-c314b63dce60","text":"German Bundestag held a special session (27 February 2022) condemning Russia\u2019s full\u2011scale invasion and reaffirming Ukraine\u2019s territorial integrity","date":"2022-02-27 00:00:00"},{"id":"4a803032-82dc-41ba-bc17-2e372ad43c2a","text":"WHO declaration of a Public Health Emergency of International Concern (PHEIC) for the novel coronavirus","date":"2020-01-30 00:00:00"},{"id":"4d677b41-732f-4ee1-97b7-4fd5ff8d1409","text":"ClinicalTrials.gov registration NCT04264533: \'Vitamin C Infusion for the Treatment of Novel Coronavirus Pneumonia (COVID-19)\' (trial listing for high\u2011dose IV vitamin C in Wuhan)","date":"2020-02-14 00:00:00"},{"id":"76f98aa0-ea7d-4a0b-93c5-9ce285cc19d0","text":"Institute of Medicine (IOM) report \'Immunization Safety Review: SV40 Contamination of Polio Vaccine and Cancer\' published","date":"2003-04-24 00:00:00"},{"id":"3c187607-d8ec-4e0c-b353-44a07b79e282","text":"Major media coverage attributing growing fire severity to climate change (e.g., New York Times analysis, Nov 2018)","date":"2018-11-09 00:00:00"},{"id":"18124d06-13fc-41ab-b44c-aff8ae32b196","text":"Camp Fire (California, 2018) linked to failing utility equipment (PG&E)","date":"2018-11-08 00:00:00"},{"id":"fc0a4120-9ec2-4f77-9fbd-876df65975ca","text":"2019\u201320 Australian \'Black Summer\' bushfires and public debate blaming land management policies","date":"2020-01-08 00:00:00"},{"id":"c15512f2-a7aa-4a3c-ad09-aafeb17b3e5d","text":"Precedent of cross-border attribution confusion: Przewod\xf3w missile incident (Poland, Nov 2022)","date":"2022-11-16 00:00:00"},{"id":"f68f6bb0-ee84-44a6-bdfc-0335f50b7637","text":"Poland officially accused Russian intelligence of ordering the arson (government announcement)","date":"2025-05-11 00:00:00"},{"id":"46bf3e69-919b-40f6-8cbc-94bc7df26704","text":"Reports that Ukrainian nationals were among suspects detained/charged in connection with the fire","date":"2025-05-12 00:00:00"},{"id":"9bd4b6f8-ff03-4cb7-8027-a6405d7799a2","text":"Massive fire destroyed the Marywilska 44 shopping centre in Warsaw (original incident)","date":"2024-05-12 00:00:00"},{"id":"e8d62282-e799-457d-896f-e8a708cc67e0","text":"bioRxiv preprint demonstrating inhalable polymer nanoparticles for mRNA delivery (preprint posted March 23, 2022).","date":"2022-03-23 00:00:00"},{"id":"a612c80c-c96a-45df-8b65-d85878b6f8a7","text":"Regulatory findings and national pauses/age\u2011restrictions after reports of very rare thrombosis with thrombocytopenia syndrome (TTS) following the AstraZeneca vaccine.","date":"2021-03-24 00:00:00"},{"id":"284bc88d-467e-49c3-ae5d-9caf059afb7a","text":"Official statistics showing substantial \'excess deaths\' in 2022 (published reports covering March 2020\u2013Dec 2022), prompting public debate about causes of excess mortality.","date":"2023-03-24 00:00:00"},{"id":"f37a2456-cdc3-4b07-84d5-790cc7626871","text":"Published studies showing markedly reduced vaccine effectiveness at preventing infection with the Omicron variant (while protection against severe disease remained better).","date":"2022-03-24 00:00:00"},{"id":"c0fbdaf3-2a6e-49c9-8b79-ccaf2f5980ec","text":"Peer\u2011reviewed reports and surveillance data linking mRNA vaccines to rare cases of myocarditis, especially in adolescent and young adult males.","date":"2021-06-24 00:00:00"},{"id":"6c31bc58-e503-4860-8034-c01e5c6ee690","text":"Press coverage reporting ~1 million Ukrainians working legally in Poland (KyivPost article, April 27, 2017).","date":"2017-04-27 00:00:00"},{"id":"2895342f-dae4-4f6e-9d54-238a2df36de7","text":"ILO / national labour statistics for 2017 showing Ukraine\'s unemployment rate around ~9\u201310% (not a new historical high) and contrasting definitions between \'registered\' unemployment and ILO measures.","date":"2017-04-24 00:00:00"},{"id":"3bec23f6-94db-46ae-8550-11141e250027","text":"World Bank / Migration and Remittances Factbook 2016 and related World Bank migration data showing migrant stocks/remittances far lower than 45% of Ukraine\'s population (Migration & Remittances Factbook 2016).","date":"2016-04-24 00:00:00"},{"id":"37f83a32-8b11-40e4-af50-a6b2b88b897a","text":"US NTP/NIEHS 2018 partial findings on cell\u2011phone radiation and tumors in rats","date":"2018-11-01 00:00:00"},{"id":"6166d4af-6445-4c33-9d67-85848cce52d7","text":"IARC classifies radiofrequency electromagnetic fields as \'possibly carcinogenic\' (Group 2B)","date":"2011-05-24 00:00:00"},{"id":"01d0a6eb-2389-4849-88bb-8383c30c2816","text":"Publication: \'Static magnetic fields from earphones: Detailed measurements plus some open questions\' (Environmental Research)","date":"2022-11-24 00:00:00"},{"id":"2e3c1bd7-8fc2-4221-8481-354fa715b7da","text":"CDC laboratory/testing guidance updates in September 2020 clarifying testing recommendations for asymptomatic people (CDC posted a laboratory update clarifying testing for SARS-CoV-2 on Sept 18, 2020).","date":"2020-09-18 00:00:00"},{"id":"f7f6b47c-67d2-439a-8a91-067f81c1f7ab","text":"WHO EMRO (Eastern Mediterranean Regional Office) guidance page (June 11, 2020) summarised evidence as indicating \'most transmission occurs from symptomatic people\' while discussing asymptomatic cases.","date":"2020-06-11 00:00:00"},{"id":"e18a5763-a120-4afa-ae9f-76ba6dc6b6e8","text":"Kyiv renamed a major thoroughfare (Moskovskyi/Moscow Avenue) after Stepan Bandera (renaming enacted July 2016).","date":"2016-07-24 00:00:00"},{"id":"acac592c-0100-4856-ab1a-6b5fa03c2da3","text":"Torch\u2011lit nationalist marches in Kyiv commemorating Stepan Bandera and other WWII nationalist figures (widely reported torchlight marches, e.g. 14 October 2018).","date":"2018-10-14 00:00:00"},{"id":"363468c4-86f4-4e0e-93e1-66b5ad465c7a","text":"Passage of Ukraine\'s \'decommunization\' laws that banned Soviet symbols and rewrote certain aspects of public memory (April\u2013May 2015).","date":"2015-04-24 00:00:00"},{"id":"f7118670-bd48-4f56-8ea1-c88cb4a94303","text":"March 2019 law/instruments extending veteran status or recognition to surviving members/participants of the UPA/OUN (legal changes coming into force in March 2019).","date":"2019-03-26 00:00:00"},{"id":"45deba27-bd1c-41bb-b550-a741e75c34b1","text":"Media reports documenting neo\u2011Nazi links in the Azov volunteer unit (coverage of ideology, symbols and far\u2011right volunteers).","date":"2014-09-10 00:00:00"},{"id":"fd29e551-2e30-484a-b54c-d91f7965b7ab","text":"Swiss authorities announced an immediate freeze on assets linked to Yanukovych and members of his entourage (Switzerland froze assets and opened probes in February 2014).","date":"2014-02-28 00:00:00"},{"id":"67c88f53-54c2-4254-b8d0-28b7099f2ccc","text":"Ukrainian authorities announced confiscation/transfer of roughly $1.5 billion in assets allegedly linked to Yanukovych and his circle into state accounts (reported April 2017).","date":"2017-04-28 00:00:00"},{"id":"594062b0-e5fe-4bb0-98bd-b48cf11c1183","text":"Ukraine imposed a moratorium/default on repayment of the $3 billion Russian-held Eurobond that matured in December 2015.","date":"2015-12-18 00:00:00"},{"id":"da8b48ab-8103-48a8-8c27-32fde9d744b2","text":"Russia filed a lawsuit in London\'s High Court seeking repayment of a $3 billion Eurobond the Yanukovych-era government issued to Russia.","date":"2016-02-17 00:00:00"},{"id":"8ce2a5c8-0192-4588-b3b2-c420565968e7","text":"UN Secretary-General Antonio Guterres warned the shelling around Zaporizhzhia was \'suicidal\' and called for cessation of military activity","date":"2022-08-08 00:00:00"},{"id":"c344854f-6c0e-402b-9e03-dca2dddbf8a7","text":"March 4, 2022 shelling and fire at Zaporizhzhia during Russia\'s seizure of the plant (initial chaos and conflicting reports)","date":"2022-03-04 00:00:00"},{"id":"72efba2e-b5b1-4ef0-b026-c1fc2e9523f9","text":"Russian officials and state media publicly accused Ukrainian forces of shelling/damaging Zaporizhzhia and pushed narratives blaming Kyiv","date":"2022-08-05 00:00:00"},{"id":"f29db90f-23cf-400e-b67c-67dd1d817384","text":"Public opinion polls in early February 2024 showed Zaluzhnyi with very high trust ratings in Ukraine.","date":"2024-02-24 00:00:00"},{"id":"70dffb54-a419-4552-ba31-79e7a21bdabd","text":"President Zelensky dismissed Valerii Zaluzhnyi as Commander\u2011in\u2011Chief of the Armed Forces of Ukraine.","date":"2024-02-08 00:00:00"},{"id":"e95427a2-7836-413a-837c-230666204f49","text":"OSCE announced deployment/observer activity at Russian checkpoints on the Russia\u2013Ukraine border (Gukovo and Donetsk) and documented cross\u2011border security incidents in July 2014.","date":"2014-07-24 00:00:00"},{"id":"0cf6ea75-0326-4e12-97dd-53c68752285e","text":"Russian authorities reported mortar and artillery rounds fired from Ukrainian-held territory landing in Russia\'s Rostov region (claim that shells hit Russian towns, July 2014).","date":"2014-07-25 00:00:00"},{"id":"572faeb1-54e1-462a-ab9b-edf623e98835","text":"Media coverage in April 2014 and thereafter reported repeated airspace violations and frequent scrambling of jets around the Russia\u2013Ukraine border (Pentagon/BBC/other outlets described routine airspace breaches during the 2014 crisis).","date":"2014-04-26 00:00:00"},{"id":"f5f3f9d2-90dd-45c8-8b2f-ad00adb4be15","text":"WENRA (Western European Nuclear Regulators Association) published a position (11 March 2022) documenting the loss of external power supplies to facilities in the Chornobyl exclusion zone and assessed risks","date":"2022-03-11 00:00:00"},{"id":"7f522407-69d4-43cb-9599-99774ba97f2b","text":"Ukraine\'s national operator and officials said restoring the damaged transmission lines to the exclusion zone was not immediately possible","date":"2022-03-09 00:00:00"},{"id":"0d034d8a-bd04-4ca0-ace9-77618955193f","text":"Russian forces seized control of the Chornobyl site and exclusion zone early in the invasion (reported 24 February 2022)","date":"2022-02-24 00:00:00"},{"id":"2ba2eda7-5496-4127-833f-7dd6a93199da","text":"Belarus opposition candidate Sviatlana Tsikhanouskaya fled to Lithuania amid the crackdown on protesters.","date":"2020-08-11 00:00:00"},{"id":"5bd7e56b-cfe3-4a99-85b8-77854e9b9c25","text":"Public demonstrations of support for Belarusian protesters in neighbouring countries (large rallies and solidarity events in Poland and elsewhere around Aug 13).","date":"2020-08-13 00:00:00"},{"id":"334fa8a2-6915-4ff0-a436-a94597df2493","text":"Formation of the Lublin Triangle (Poland\u2013Lithuania\u2013Ukraine trilateral platform announced).","date":"2020-07-28 00:00:00"},{"id":"d421ea1b-32a9-4feb-82ce-44107a8ad25e","text":"Mass influx of Ukrainian refugees into Poland after Russia\'s full-scale invasion (activation of EU Temporary Protection, March 2022 onwards).","date":"2022-03-24 00:00:00"},{"id":"d4ac1d8a-babe-4df9-af15-5ac40c38b671","text":"Gazeta Wyborcza article reports rapid rise of Ukrainian residents in Wroc\u0142aw (\'Almost every third resident of Wroclaw is Ukrainian\').","date":"2022-07-25 00:00:00"},{"id":"ecd51516-8d6e-437d-b3e0-afcf936bd01c","text":"Polish media outlets and public services launched Ukrainian-language sections and information hubs (example: Polish newsrooms adding Ukrainian-language content, Ukrainian support centres established).","date":"2022-05-24 00:00:00"},{"id":"81ba9461-c241-4cff-88a5-330b7e9dcaab","text":"Explosions and missile strikes hit nearby cities (notably Mykolaiv and Odesa) on 12\u201313 May 2022; local officials said some strikes on Mykolaiv/Odesa were linked to launches from the Kherson area.","date":"2022-05-13 00:00:00"},{"id":"c02d1d63-2738-4342-b60c-5a5eafdb00d1","text":"Prominent international coverage of far\u2011right Ukrainian units (notably the Azov regiment) and their integration into national forces during spring 2022.","date":"2022-03-29 00:00:00"},{"id":"b978ef97-67af-4411-923d-63aa7bdd03a2","text":"Earlier Russian Defence Ministry / RIA-style reports accused Ukrainian forces of striking civilian sites in the Kherson region (e.g., schools, cemeteries) at the start of May 2022.","date":"2022-05-01 00:00:00"},{"id":"1c5866c2-1adf-4b31-a7e0-d2983c3c0093","text":"CDC recommends cloth face coverings for the public (source control)","date":"2020-04-03 00:00:00"},{"id":"050c1ca7-e45b-4239-9217-51063d96f085","text":"WHO issues \'COVID-19: considerations for tuberculosis (TB) care\' information note","date":"2020-03-19 00:00:00"},{"id":"2f6e9d10-fec3-4bbe-9247-78c04ce554c5","text":"July 2021 Provincetown, MA outbreak where many cases occurred among vaccinated people (CDC MMWR published August 2021)","date":"2021-07-24 00:00:00"},{"id":"9098c091-26df-4f1c-a647-9a4f2b23fc7a","text":"Large cluster-randomized Bangladesh mask promotion trial (Abaluck et al./Science) published August 2021 with nuanced results","date":"2021-08-13 00:00:00"},{"id":"02d9bad7-3aef-4517-b713-67abd5cafc2d","text":"CDC reversed earlier guidance and in July 2021 again recommended indoor masks for vaccinated people because of the Delta variant","date":"2021-07-27 00:00:00"},{"id":"4b1c18ef-7469-4c08-acae-8c60b14de0d2","text":"DANMASK-19 randomized trial (Denmark) published November 2020 found limited measurable protection to the wearer","date":"2020-11-18 00:00:00"},{"id":"33c7db4b-04dc-46e0-b03d-7f922a10de7a","text":"Earlier (2015) online reports claimed an \'Assembly of the Romanians of Bukovina\' had been formed and had previously voiced grievances about status/rights in northern Bukovina.","date":"2015-04-24 00:00:00"},{"id":"d57ad4ba-c8d9-40a2-b26f-8c7201cf2b36","text":"Following the awards, Gazprom refused/reserved deliveries and reduced transit pressure to Ukraine in early March 2018","date":"2018-03-13 00:00:00"},{"id":"5b58fb64-63d2-40e2-9f6f-e1a1fa007055","text":"Naftogaz published the full Stockholm award texts and initiated enforcement actions in multiple jurisdictions (e.g., Swiss/UK enforcement steps were announced)","date":"2018-03-24 00:00:00"},{"id":"5cb96c94-bbc2-4897-9e21-1b262e0d5d81","text":"The awards were legally complex and split across separate supply and transit rulings with offsetting liabilities rather than a single, simple judgment","date":"2018-03-24 00:00:00"},{"id":"10698ce2-70ce-40d7-9582-9301a7996d89","text":"U.S. National Toxicology Program (NTP) publishes high\u2011profile rodent RFR studies (final reports/public summaries circulated in 2018)","date":"2018-11-24 00:00:00"},{"id":"61c08dbf-7678-4cb8-a05d-7fb8581db29e","text":"International EMF Scientist Appeal (roughly 250 scientists sign public appeal calling for stricter RF limits, 2015)","date":"2015-05-24 00:00:00"},{"id":"223cd831-e143-4a96-899b-7fcab8bf14d4","text":"IARC (WHO) classifies radiofrequency electromagnetic fields as \'possibly carcinogenic to humans\' (Group 2B)","date":"2011-05-31 00:00:00"},{"id":"0080375e-d066-4489-a76b-8aca7c644953","text":"Major measles outbreak in Samoa (late 2019) that caused thousands of cases and dozens of deaths and led to a national state of emergency.","date":"2019-11-24 00:00:00"},{"id":"5c9bb56b-5a52-4110-9391-2fa563a25ec0","text":"Two infants in Samoa died after receiving MMR vaccine due to incorrect diluent administration, sparking local fear of vaccines.","date":"2018-07-24 00:00:00"},{"id":"3957f02b-d075-40ed-b8ee-c6ba3e8e07ea","text":"Nordic countries (Sweden, Denmark, Finland) restricted or paused use of Moderna\u2019s mRNA vaccine for younger people over myocarditis concerns","date":"2021-10-07 00:00:00"},{"id":"608d1ff8-dfa6-45e2-b5f9-0f8f07b43b6f","text":"Japan identifies stainless-steel/foreign particles in multiple Moderna vaccine vials, leading to suspension/recall of specific lots","date":"2021-09-24 00:00:00"},{"id":"35dd7506-6f6a-4fc6-95fa-ce3448ef69ca","text":"Verkhovna Rada adopts the Law \'On Ensuring the Functioning of Ukrainian as the State Language\'.","date":"2019-04-25 00:00:00"},{"id":"38787658-27c6-48e3-b543-52185e73d5b2","text":"The 2019 language law entered into force (implementation date announced/commenced).","date":"2019-07-16 00:00:00"},{"id":"2bd04379-926c-48bf-b44a-4c266364137c","text":"Passage of the 2017 Education Law that restricted minority\u2011language instruction (including limits affecting Russian\u2011language schooling).","date":"2017-09-25 00:00:00"},{"id":"8f64b154-1dec-4fb3-93ae-2e71705ff1f3","text":"OSCE monitor wounded after coming under fire leading the OSCE to review operations in the conflict zone","date":"2015-07-28 00:00:00"},{"id":"2edbd701-a7b0-43d0-b5f1-5f7fe48fd1b3","text":"OSCE spot report documenting heavy shelling and multiple shell craters near Donetsk (including school shelling)","date":"2014-11-07 00:00:00"},{"id":"bf9bf087-ec2e-4039-8d2e-b944f501ebb9","text":"OSCE SMM vehicles struck by artillery/mortar fragments near Kirovske while on patrol","date":"2014-09-15 00:00:00"},{"id":"f82b7bce-3fa4-4d11-b057-f19740ff07bf","text":"FDA issued an Emergency Use Authorization (EUA) for chloroquine/hydroxychloroquine to treat COVID\u201119 (announced in late March 2020)","date":"2020-03-28 00:00:00"},{"id":"3505d0a2-95b7-4974-900f-c320bbd8404c","text":"Wang et al. in vitro study showing remdesivir and chloroquine inhibit SARS-CoV-2 in cultured cells published (Cell Research)","date":"2020-02-04 00:00:00"},{"id":"88e2d6aa-7606-4bd8-a3c0-db8e791d0407","text":"National Academies report \'Reflecting Sunlight\' recommends a research program on solar geoengineering (including stratospheric aerosol injection)","date":"2021-06-28 00:00:00"},{"id":"44feb689-57ae-46a8-8a01-c7747c8a0790","text":"Operation Popeye (U.S. cloud-seeding program in Vietnam, 1967\u20131972) documented in declassified reporting","date":"None"},{"id":"d7317c6e-3db4-424b-90d9-b9b5753564c8","text":"HAARP facility transferred from US Air Force to University of Alaska (facility described publicly as a powerful ionospheric heater)","date":"2015-08-11 00:00:00"},{"id":"3f8b75b1-2c42-4fc8-a159-ed729971cff3","text":"1996 USAF paper \u2018Weather as a Force Multiplier: Owning the Weather in 2025\u2019 published","date":"1996-08-24 00:00:00"},{"id":"31222d1f-99d2-4a04-b6e1-26030ffb0631","text":"Harvard SCoPEx geoengineering balloon test in Sweden paused after public controversy and advisory review (SCoPEx advisory committee recommendation)","date":"2021-03-24 00:00:00"},{"id":"20a98e83-e847-4d32-aac4-5e9a640056d8","text":"Arkansas legislature passed HB1578 (2015), a law that required abortion providers to inform patients about the possibility of reversing a medication abortion.","date":"2015-04-24 00:00:00"},{"id":"d269abae-bf72-4f74-b43e-47c8f5a5f577","text":"Media reporting in December 2019 (e.g., NPR) that a randomized clinical trial testing progesterone to antagonize mifepristone was stopped early because several participants experienced severe bleeding.","date":"2019-12-05 00:00:00"},{"id":"28215652-fb49-4234-8a5b-10f2884a8360","text":"Publication of \'Medicinal smoke reduces airborne bacteria\' (Journal of Ethnopharmacology, 2007).","date":"2007-04-24 00:00:00"},{"id":"41b8d60b-18d2-40ac-b418-d4da3f42762a","text":"Early COVID-19 pandemic surge in March 2020 driving widespread sharing of home remedies and \'air-cleansing\' tips on social media and messaging apps.","date":"2020-03-24 00:00:00"},{"id":"a9cb4bb3-35f2-4375-b14a-963d4da29cdb","text":"IMF Article IV / Staff report highlighted Moldova\'s fiscal pressures and recommended pension-system sustainability measures.","date":"2023-12-24 00:00:00"},{"id":"6204c9c3-9b99-41ef-a2c1-32347b6acbac","text":"2023 budget law amendments that changed tax regulations (Law No. 212 / Gazette publication August 2023).","date":"2023-08-10 00:00:00"},{"id":"50a966b8-6689-49b7-ba48-7faa14b1eaf2","text":"Government conscription/draft calls in 2024\u20132025 (e.g., plans to conscript ~1,200 in Nov 2024\u2013Jan 2025 and further calls in spring 2025).","date":"2024-11-24 00:00:00"},{"id":"eb9fe205-5422-4321-96e2-10a79f80e6e7","text":"Legally scheduled gradual equalization and increases in retirement age for women (increment applied July 1, 2024).","date":"2024-07-01 00:00:00"},{"id":"d16e0eb9-872d-49bb-a544-0446fe86d911","text":"Public warnings by President Maia Sandu about anticipated Russian interference and disinformation in the 2025 election campaign.","date":"2025-07-30 00:00:00"},{"id":"c28026e9-686f-428a-a038-32f0dd36e3db","text":"Liguria Regional Council adopted a non\u2011binding motion urging the Italian government to review EU sanctions on Russia and to acknowledge Crimea\'s \'right to self\u2011determination\' (widely misreported as formal recognition).","date":"2016-06-29 00:00:00"},{"id":"664ccdb3-f880-4f25-8241-1dfeeab33b2b","text":"Lega Nord regional councillor (Giancarlo Piana/Piana) travelled to Crimea and publicly advocated closer ties and opposing sanctions; local press covered the visit and statements in late June 2016.","date":"2016-06-24 00:00:00"},{"id":"fc17a088-7b0d-4e61-b22a-7477b644e094","text":"Sharp rise in short-term employment registrations in 2018, dominated by Ukrainian nationals (Police and Border Guard Board data showing short-term employment registrations rose to 19,858 in 2018).","date":"None"},{"id":"bc617bf4-3191-4904-9fc7-0654c50e2050","text":"Statistics Estonia reported a small population increase and noted changing composition with rising numbers of foreign nationals/immigrants in the 2018 data release (Statistics Estonia news releases on population, January 2019).","date":"None"},{"id":"dc0b3b2f-1dad-4729-ac7e-4c2d9044f6e8","text":"Rise of the far-right EKRE party in the 2019 parliamentary elections and April 2019 coalition talks (EKRE entered coalition discussions on April 6, 2019), accompanied by strong anti-immigration rhetoric in campaign coverage.","date":"2019-04-06 00:00:00"},{"id":"3ae7ca99-f464-4299-8753-7a424e968ede","text":"Rail Baltica cross\u2011border integration steps and EU documentation advancing Poland\u2011Lithuania rail connection (project materials published, technical/operational coordination at border sections).","date":"2020-06-24 00:00:00"},{"id":"675e5392-530d-449b-bb1e-4d7a3588db91","text":"Original intergovernmental agreement establishing the Lithuanian\u2011Polish\u2011Ukrainian Brigade (LITPOLUKRBRIG) signed in Warsaw (formal creation and headquarters placement in Poland).","date":"2014-09-19 00:00:00"},{"id":"50b2647b-0332-4461-8a09-dea8dec0abd1","text":"Increased NATO/Polish military activity and formal commitments on the eastern flank in 2020 (Poland and Lithuania assigned brigades to NATO multinational structures; documented interoperability activities).","date":"2020-01-24 00:00:00"},{"id":"5583efb3-aa8e-4df3-858f-b8534029d887","text":"Kyiv shut metro services and further restricted public transportation in mid\u2011March 2020 (national/local announcements)","date":"2020-03-17 00:00:00"},{"id":"00d26f90-76bd-40ab-85fc-34766755bd4c","text":"Background existence of Kyiv \u2018Municipal Guard\u2019 (created 2015) with some members drawn from volunteer/veteran communities","date":"2015-04-24 00:00:00"},{"id":"6f5f9441-b84d-4d52-a65c-4867888ea635","text":"Authorities announced joint patrols involving the National Police, National Guard and Military Police beginning around March 22, 2020","date":"2020-03-22 00:00:00"},{"id":"1dd0b4ec-abd6-45d0-b7e9-4fa8a28c3461","text":"January 2021 reports from Norway that some very frail, elderly patients died after receiving the Pfizer/BioNTech vaccine and subsequent official reviews.","date":"2021-01-18 00:00:00"},{"id":"ed9f52e2-be9f-48ab-9f06-0402ef0d2399","text":"Russian leadership framed the 2022 invasion as a \'denazification\' mission.","date":"2022-02-24 00:00:00"},{"id":"3bfa73f9-4f36-4feb-8c73-b26d1c8763e2","text":"International reporting and analysis on the Azov regiment\'s far\u2011right imagery and controversies.","date":"2022-03-29 00:00:00"},{"id":"6c96e600-ea11-41eb-980c-50af62ee819b","text":"Reports and temporary suspension in Japan of some Moderna vaccine batches after detection of foreign particles (August 2021)","date":"2021-08-26 00:00:00"},{"id":"97cdfa22-5b79-4c43-8b73-b7397eabdb7f","text":"CDC reports and ACIP review of myocarditis signals after mRNA vaccination (June 2021 MMWR/ACIP update)","date":"2021-06-23 00:00:00"},{"id":"d8573a4e-9b56-470b-8c64-d08efb9b7470","text":"EMA determination of a possible link between AstraZeneca vaccine and very rare blood clots with low platelets (VITT), April 2021","date":"2021-04-07 00:00:00"},{"id":"6c403599-3e86-4bff-9361-055b9602ab30","text":"Poroshenko strips high-profile individuals of Ukrainian citizenship (e.g., Mikheil Saakashvili)","date":"2017-07-24 00:00:00"},{"id":"a12e33a5-60d5-4e0a-b96d-1234e7e986c3","text":"CDC interim guidance for election polling locations and voters recommending masks and other measures","date":"2020-06-22 00:00:00"},{"id":"4fe95fda-824f-4b32-b19b-ea9e2df97086","text":"Nature Medicine study showing face masks reduce respiratory virus shedding (Leung et al.)","date":"2020-04-03 00:00:00"},{"id":"3553acbd-cb2f-423e-93dc-1bb0a1ff29ab","text":"Wisconsin in-person primary conducted during pandemic with long lines and media coverage","date":"2020-04-07 00:00:00"},{"id":"73fa5f57-e48d-4a11-a85f-c6d43d487450","text":"CDC recommends cloth face coverings for the public","date":"2020-04-03 00:00:00"},{"id":"3d4f3856-5b2b-4ed4-a0f1-107b2258779e","text":"FDA\u2019s tissue\u2011agnostic accelerated approval of pembrolizumab for MSI\u2011H/dMMR tumors","date":"2017-05-24 00:00:00"},{"id":"e2ca9fca-e873-40f4-955e-4071550bf90b","text":"2018 Nobel Prize in Physiology or Medicine awarded to James Allison and Tasuku Honjo for cancer immunotherapy","date":"2018-10-24 00:00:00"},{"id":"d00f54ac-0e00-4021-9101-2d50a9e18898","text":"First US approval of a CAR\u2011T cell therapy (Kymriah, tisagenlecleucel)","date":"2017-08-24 00:00:00"},{"id":"32dd5dab-f7ef-4cd2-ac64-759def9b81d4","text":"AstraZeneca paused its COVID-19 vaccine trial after a volunteer developed an unexplained serious illness.","date":"2020-09-08 00:00:00"},{"id":"c0e1ea34-6e44-45af-8687-a6f6e0fdddbe","text":"Large, high-profile seroprevalence releases (e.g., New York State antibody study) showing many people with antibodies","date":"2020-04-23 00:00:00"},{"id":"7d6c1f51-a4aa-43b3-9db4-b7d6d51b4546","text":"Media reports and investigations documenting a flood of unvalidated/poor-quality COVID-19 antibody tests on the U.S. market after relaxed FDA oversight","date":"2020-04-27 00:00:00"},{"id":"bf2117fc-622a-4b9e-9739-256e8d0257fe","text":"CDC serology guidance updated to note possible cross-reactivity of antibody tests with other coronaviruses","date":"2020-06-25 00:00:00"},{"id":"cbc26084-c1da-48e0-83d5-389ba8f80250","text":"IARC (WHO) classified aspartame as \'possibly carcinogenic to humans\' (Group 2B), prompting widespread media coverage.","date":"2023-07-14 00:00:00"},{"id":"4e423bb5-cd06-447a-bbfc-080811c6884c","text":"WHO published a guideline (Use of non-sugar sweeteners) recommending that non-sugar sweeteners should not be used for weight control or reducing noncommunicable disease risk.","date":"2023-05-15 00:00:00"},{"id":"b16669f8-d75b-408a-9f4d-5bcb56342fa8","text":"U.S. Federal Trade Commission (FTC) sent warning letters (Nov 2023) to two trade associations and a dozen influencers about inadequate disclosures for paid posts promoting aspartame/sugar products.","date":"2023-11-13 00:00:00"},{"id":"177a8ead-2e4a-42b3-bd3a-431798790bde","text":"WHO updated interim guidance on mask use (June 5, 2020)","date":"2020-06-05 00:00:00"},{"id":"f37e84b5-e2d0-451c-8b32-7caaa0838264","text":"Systematic review and meta-analysis (Bartoszko et al.) on medical masks vs N95 respirators (Influenza and Other Respiratory Viruses, 2020)","date":"2020-04-24 00:00:00"},{"id":"5f6be7fe-2480-4b8b-847b-374e45a86e9e","text":"IARC (WHO) press release classifying processed meat as \'carcinogenic to humans\' (Group 1)","date":"2015-10-26 00:00:00"},{"id":"78a2eb57-fcd6-403f-8a54-0bb0e05d9bba","text":"Recent legal and public debate weakening restrictions on AI\u2011generated political deepfakes (U.S. court decision striking down a California restriction, reported Aug 7, 2025).","date":"2025-08-07 00:00:00"},{"id":"5dc728d9-13a8-47fc-b9f3-ae98951350e8","text":"U.S. begins or expands training of Ukrainian military and security forces","date":"2015-06-24 00:00:00"},{"id":"f7826dad-e7a6-4fe2-b275-f7114d3cd458","text":"Documented U.S.-funded democracy support by the National Endowment for Democracy (NED) in Ukraine","date":"None"},{"id":"74f394ba-ef3f-4ccd-8648-fc87425f5bc4","text":"U.S. and EU impose sanctions on Russian and Ukrainian actors after Crimea annexation","date":"2014-03-24 00:00:00"},{"id":"28fc4989-660b-4a74-adef-84b2073491a7","text":"2018 market reports showing a sharp rise in turmeric/curcumin supplement sales and mainstreaming of \'golden milk\' wellness trends","date":"2018-09-18 00:00:00"},{"id":"83e49db4-0946-4b37-82e5-819ad7c0a1da","text":"2004 Phase I clinical trial of oral curcumin in advanced colorectal cancer patients (Clinical Cancer Research)","date":"2004-10-22 00:00:00"},{"id":"629934f2-0d32-4a19-ac35-ea10dca79eb2","text":"Ukraine signed a contract to purchase about 1.8\u20131.9 million doses of China\u2019s Sinovac vaccine (announcement reported Dec 30, 2020).","date":"2020-12-30 00:00:00"},{"id":"a395c8b7-47b0-45a7-ad81-e26fe1c05a14","text":"Pfizer publicly reported supply-chain challenges and acknowledged it had cut its near-term production target (news reported Dec 3, 2020).","date":"2020-12-03 00:00:00"},{"id":"73d4fa9f-7af5-42a7-81b7-86eea7bb227f","text":"COVAX (WHO/Gavi/CEPI/UNICEF) announced additional advance purchase deals and said the global rollout was planned to begin in Q1 2021 (press release Dec 18, 2020).","date":"2020-12-18 00:00:00"},{"id":"a26e093a-2f0c-4a23-9373-f39313864c41","text":"Reporting of procurement dysfunction and delays within Ukraine\u2019s vaccine procurement machinery in late 2020 (media coverage of missed contracts, agency disputes and slow negotiations).","date":"2020-12-24 00:00:00"},{"id":"4c9cb6bf-730f-49fd-b0c7-590cf16349d1","text":"NOAA / Arctic Report Card 2023 coverage documenting seasonal and regional variability in sea ice (and that 2023 minimum ranked among the low end but not a new record).","date":"2023-12-24 00:00:00"},{"id":"7a212531-6953-4bb9-856f-9b6e406a2de8","text":"Publication of peer-reviewed study \'Comparing the carbon footprints of urban and conventional agriculture\' in Nature Cities","date":"2024-01-22 00:00:00"},{"id":"7659754a-1b7b-4a35-b4e4-4cc2050a0494","text":"Publication of Standard Eurobarometer 101 (Spring 2024) with headline EU-level percentages on attitudes to the war, security and EU unity","date":"2024-05-24 00:00:00"},{"id":"5768ff86-d67b-4a05-937e-a4fb8d057587","text":"Pew Research Center release \'Views of Russia and Putin\' (July 2, 2024) with country\u2011by\u2011country favorable/unfavorable figures","date":"2024-07-02 00:00:00"},{"id":"b7924395-6b9e-4846-a1b2-f40333373ccd","text":"Large pro\u2011Russia demonstrations in Belgrade and other European cities (e.g., Belgrade pro\u2011Russia march reported by Reuters and BBC in April 2022)","date":"2022-04-16 00:00:00"},{"id":"3b2d1c54-46a2-43c7-a34b-867520be9bd0","text":"South Africa pauses/limits rollout of the Oxford\u2013AstraZeneca COVID\u201119 vaccine after trial data showed minimal protection against mild\u2013moderate disease vs the 501Y.V2 variant","date":"2021-02-09 00:00:00"},{"id":"eb9d6929-d087-40ce-b49f-7c5fc19430ae","text":"UK NERVTAG / Public Health briefings (Jan 2021) indicating the B.1.1.7 (UK) variant may be associated with increased severity/mortality","date":"2021-01-20 00:00:00"},{"id":"c3c1733c-48df-47db-b327-bfd660fd8b91","text":"Ukraine\'s 2004 \'Orange Revolution\' \u2014 Supreme Court annulled disputed runoff and ordered a re-run","date":"2004-12-03 00:00:00"},{"id":"5a18ff76-6adf-49dd-8a47-80a852903057","text":"May 2014 early presidential election held amid armed conflict \u2014 polling could not be held in parts of Donbas and Crimea","date":"2014-05-25 00:00:00"},{"id":"615e3004-e4d4-4db8-8943-572e5aec2d74","text":"Crimea \'referendum\' (16 March 2014) and UN General Assembly non-recognition (Resolution 68/262)","date":"2014-03-27 00:00:00"},{"id":"6407b3ca-4fad-49b5-a549-1696186e016e","text":"Russian/state narratives calling the post\u2011Euromaidan Ukrainian authorities a \'coup\' and \'illegitimate\' (2014 onward)","date":"2014-04-24 00:00:00"},{"id":"5a8d686a-4332-4ef2-8c1e-a1e0be81eb8b","text":"Parliament and state moves in late 2014 to recognize OUN/UPA fighters with veteran/combatant status","date":"2014-12-06 00:00:00"},{"id":"a82be8e6-3e05-488d-b48a-34ee578ebe37","text":"International and regional criticism of Ukraine\'s decommunization bills as potentially glorifying WWII-era nationalists","date":"2015-04-20 00:00:00"},{"id":"c1f5270f-1a6c-46c0-ad52-8959a23725f7","text":"Poroshenko issues decree establishing May 8 as a Day of Remembrance and Reconciliation (shifting commemoration context)","date":"2015-03-24 00:00:00"},{"id":"842d5a71-e5da-45fa-9689-793dd7cb8c7a","text":"Verkhovna Rada passes \'decommunization\' package of laws equating Soviet and Nazi regimes and banning Soviet symbols","date":"2015-04-09 00:00:00"},{"id":"ae0daa7e-f26e-4939-a671-d1fc4de1b5f8","text":"Widespread use and international coverage of the red-and-black UPA/Bandera flag during Euromaidan and subsequent protests","date":"2014-02-24 00:00:00"},{"id":"f8c3f1aa-6921-4366-b729-0b15467ffe4b","text":"Alaska Supreme Court struck down a 2014 law/regulation attempting to define which abortions were \'medically necessary\' for Medicaid funding (ruling reported Feb 15\u201316, 2019).","date":"2019-02-15 00:00:00"},{"id":"39119401-4fb6-4c51-a4a2-509133c89916","text":"Alabama signed the near\u2011total Human Life Protection Act (near\u2011total abortion ban) on May 15, 2019.","date":"2019-05-15 00:00:00"},{"id":"91dbc818-5745-4cc2-b15b-8de90aea2e6e","text":"Amnesty International reports on apparent extrajudicial executions by Russian forces","date":"2022-04-12 00:00:00"},{"id":"301d794c-796d-4b52-acaf-189a06c32744","text":"Discovery of bound and shot civilian bodies in Bucha","date":"2022-04-04 00:00:00"},{"id":"15ae6b88-98af-4f02-a2c2-f7506b75b8f0","text":"Sharp surge in temporary employment declarations for Ukrainians in Poland (about 400,000 declarations in H1 2015)","date":"None"},{"id":"0f3c80b9-d33d-449e-b782-301a92767446","text":"International media human\u2011interest coverage (e.g., BBC) highlighting Ukrainians taking low\u2011paid/manual jobs in Poland","date":"2015-03-19 00:00:00"},{"id":"ab3c4bac-ce55-471e-a4b1-3a5fd3e4da3a","text":"Media reports of increased civilian familiarisation and voluntary training courses in Poland amid the war in Ukraine (surge in civilians getting military\u2011style training).","date":"2022-12-06 00:00:00"},{"id":"1e97059a-df1b-4ba0-927d-ef351d3203f1","text":"Polish Ministry of Defence draft/plans reported to call up or train up to 200,000 reservists and Territorial Defence volunteers in 2023.","date":"2022-12-08 00:00:00"},{"id":"39c3f37e-7863-4e24-b858-332a69edb7c5","text":"Large NATO/U.S.-led military exercises in Poland in 2022 (e.g., DEFENDER-Europe 2022 and SWIFT RESPONSE 2022 in May 2022).","date":"2022-05-24 00:00:00"},{"id":"a6ecafb3-06ef-4d15-9e90-c182ff9ac0cb","text":"Reports and sector assessments (Ministry/PPV/experts) documenting urgent appeals and emergency measures for the cultural and creative industries because of COVID\u201119 impact (spring 2020).","date":"2020-04-24 00:00:00"},{"id":"672cda8c-2973-45f8-975f-b039bb42d799","text":"Previous and well\u2011documented state support for patriotic films (example: state/State Film Agency funding for films such as \'Cyborgs\' in 2017).","date":"2017-02-12 00:00:00"},{"id":"f3deb717-f26d-4b0f-befb-f0a268840e2d","text":"Verkhovna Rada adopts amendments to the 2020 state budget to create an anti\u2011coronavirus fund and reallocate spending (April 2020).","date":"2020-04-13 00:00:00"},{"id":"c27871e8-9cf0-4e55-a941-37568e929639","text":"U.S. embassy cultural and education grant programs in Poland (U.S. Embassy cultural exchanges and museum/project funding).","date":"2017-04-24 00:00:00"},{"id":"b34290c9-5fc8-42cd-8ff4-b72800d5b3fc","text":"Public concern and criticism by international institutions and U.S.\u2011linked organisations (including the U.S. Holocaust Memorial Museum) over Poland\'s 2018 memory law.","date":"2018-02-24 00:00:00"},{"id":"519b445d-ab5a-4a25-82b4-b0946e2544b9","text":"Polish education reform (2016\u20132017) introducing a stronger \'patriotic education\' and changes to history curricula.","date":"None"},{"id":"b2a7af7a-992d-4172-a8ed-0632c7b9ebc8","text":"High\u2011profile U.S. governmental rhetoric in Poland on WWII memory: Vice President Mike Pence\'s speech at the 80th anniversary WWII commemoration in Warsaw.","date":"2019-09-01 00:00:00"},{"id":"d0debc7d-8581-4e61-8d60-6bb1817aca0e","text":"Russian courts declared the Mejlis of the Crimean Tatar people an \'extremist organization\' and effectively banned it (decision upheld by the Russian Supreme Court).","date":"2016-09-29 00:00:00"},{"id":"92773719-a9b2-48df-a401-3f607ad24f95","text":"Prominent Crimean Tatar figures (for example Ruslan Balbek) publicly endorsed the 2014 annexation of Crimea and later served in Russian administration or political posts.","date":"2014-03-19 00:00:00"},{"id":"c687e1f4-812e-4156-8c81-6e868ebc55e1","text":"Reports that Russian/occupation authorities organized or amplified a purported \'congress\' or staged meetings of Crimean Tatar delegates framed as endorsing the \'special operation\'.","date":"2022-04-30 00:00:00"},{"id":"93341980-21de-417e-89dd-7c82843bab90","text":"Ukrainian Ministry of Justice public discussion / press reporting on proposals to allow people with criminal records (non\u2011incarcerated) to be mobilised or volunteer for service","date":"2024-02-17 00:00:00"},{"id":"3303063f-dece-4c0c-874c-5f4e49c07bfa","text":"Justice Minister Denys Malyuska\'s telethon remarks suggesting mobilising people with criminal records and noting some could do non\u2011combat tasks (\'shovels\' mentioned in context)","date":"2024-02-17 00:00:00"},{"id":"09395cf0-ef39-49f1-a6fd-04e49cd0d3c7","text":"Precedent of Russian/Wagner recruitment of prisoners (widely reported in 2022\u20132023)","date":"2023-03-10 00:00:00"},{"id":"3effb45f-db2f-4404-8107-91ae40cfa171","text":"U.S. confirms delivery of Javelin anti-tank missiles to Ukraine","date":"2017-08-24 00:00:00"},{"id":"49d175f1-d0a6-4c28-afcb-542015206488","text":"U.S. passed the milestone of 1 million reported COVID-19 deaths in mid\u2011May 2022.","date":"2022-05-15 00:00:00"},{"id":"09a6eb61-e57e-43fa-b5d1-b1d1be8aa538","text":"CDC changed its COVID-19 data presentation and surveillance focus after the U.S. public health emergency ended (2023), shifting emphasis to severe outcomes and revising some reporting dashboards.","date":"2023-05-05 00:00:00"},{"id":"9ba3b0b4-5e3d-4272-9bf5-9290053494c1","text":"Publication of a randomized, double\u2011blind, placebo\u2011controlled Phase II trial reporting AHCC cleared persistent high\u2011risk HPV in a majority of treated patients","date":"2022-06-22 00:00:00"},{"id":"60aaf762-4c84-4913-9c90-e2761a239a3c","text":"Russian Defence Ministry spokesman Igor Konashenkov publicly announced that Russian forces had \\"liquidated\\" groups of foreign mercenaries including members of the \'Georgian Legion\' near Lysychansk.","date":"2022-06-27 00:00:00"},{"id":"3e927d59-e3bd-40df-8996-cea67027d88b","text":"French President Emmanuel Macron says \'we must not humiliate Russia\' (calls for dialogue)","date":"2022-06-04 00:00:00"},{"id":"500db672-9962-4d41-98c4-e78093be6282","text":"United Nations / humanitarian agencies warn of catastrophic humanitarian needs in Ukraine","date":"2022-06-08 00:00:00"},{"id":"7ceb8afa-28c7-4571-a76b-15da683cfcad","text":"Russian seizure and military control of the Zaporizhzhia nuclear power plant","date":"2022-03-04 00:00:00"},{"id":"8b330468-0e0e-41f2-8956-e0ca20857b53","text":"NATO Madrid Summit (new strategic concept and high\u2011level discussions)","date":"2022-06-29 00:00:00"},{"id":"7e95e9ef-ebaf-474e-a03e-601acfaf84a2","text":"Fall of Sievierodonetsk / Russian capture of a key Donbas city","date":"2022-06-25 00:00:00"},{"id":"9ae89725-23f8-4591-9414-683c87ced9f3","text":"European Commission emergency aid package for farmers affected by the Russian embargo (initial \u20AC125 million announced)","date":"2014-08-18 00:00:00"},{"id":"cd9cc4ee-63a4-440c-92b4-44665fd63c0e","text":"Finnish industry and producers (e.g., dairy sector) publicly warned of impacts and potential job talks after the Russian ban","date":"2014-08-07 00:00:00"},{"id":"adcfccef-d8d9-41c8-b300-cf27b6144577","text":"Sharp month\u2011on\u2011month fall in Finnish food exports to Russia after the ban (reported as exports plummeting over 60% in one month)","date":"2014-08-24 00:00:00"},{"id":"0b082ee4-9471-4fb4-9665-6a11af3aa134","text":"Turkey shot down a Russian Su\u201124 warplane on the Syria border, sharply escalating tensions between Moscow and Ankara.","date":"2015-11-24 00:00:00"},{"id":"ca306a40-dbf8-4c16-9e6d-e65f5d4718f6","text":"Russian Defence Ministry publicly accused President Erdo\u011Fan and his family of profiting from illegal oil shipments from Islamic State (IS/ISIL) in Syria and Iraq.","date":"2015-12-02 00:00:00"},{"id":"c42142ca-f5c0-47ab-b025-c6443592bce2","text":"WHO issued information notices clarifying interpretation of PCR cycle thresholds (advising careful interpretation of weak positives and use of clinical context)","date":"2021-01-20 00:00:00"},{"id":"db697b3c-4c20-4835-bfed-a2f70871c18a","text":"Peer\u2011reviewed study showing PCR cycle threshold (Ct) correlates with ability to culture live virus (low Ct more likely infectious)","date":"2020-05-22 00:00:00"},{"id":"3b36b5d8-defd-41c3-8289-6bca2d5ab655","text":"Kyiv City Council adopted a 2015 regulation and local initiatives promoting the use of Ukrainian in public life (programs 2015\u20132020).","date":"2015-04-24 00:00:00"},{"id":"f50f4def-0d40-4b2a-b554-6beb32d737a3","text":"Parliament passed and enacted quotas for Ukrainian-language songs on radio (law approved June 16, 2016; quota measures came into force in 2016\u20132017), increasing legal requirements for media language use.","date":"2016-11-08 00:00:00"},{"id":"d3876d96-c6ba-48b2-a7d4-25ba4800e435","text":"Adoption of the Kivalov\u2013Kolesnichenko Law on the Principles of State Language Policy (entered into force August 10, 2012).","date":"2012-08-10 00:00:00"},{"id":"a0290b8a-cab4-4576-b231-460d6fbba5b6","text":"Verkhovna Rada voted to repeal (23 February 2014) the 2012 language law amid the 2014 political upheaval (subsequent legal uncertainty and debates followed).","date":"2014-02-23 00:00:00"},{"id":"60c62a8d-67f0-456f-babc-92a83004c410","text":"Establishment of presidential and advisory bodies to promote Ukrainian language and national unity (e.g., Board for National Unity created by decree, December 2015) and public campaigns encouraging Ukrainian-language use.","date":"2015-12-24 00:00:00"},{"id":"ff1b1f16-e1f3-4645-aada-881b39125135","text":"Poland refused entry to the Night Wolves in late April 2015, blocking their planned land route to Germany.","date":"2015-04-24 00:00:00"},{"id":"9df6a373-ef95-4532-ac3b-a1e8c83604f1","text":"Night Wolves\' active, visible role in Crimea (2014) and frequent state-linked publicity established them as a high-profile, Kremlin\u2011linked biker group prior to 2015.","date":"2014-03-24 00:00:00"},{"id":"39a3616e-dad5-4fbd-ae4b-62f66f82c78e","text":"Prime Minister Mark Rutte publicly said the Netherlands was unlikely to ratify the Agreement and sought \'legally binding\' assurances from EU partners","date":"2016-06-28 00:00:00"},{"id":"dba5650a-2407-4da3-af31-96dc54bcb94e","text":"Dutch advisory referendum on the EU\u2013Ukraine Association Agreement produced a 61% \'No\' vote","date":"2016-04-06 00:00:00"},{"id":"4d01381b-d2ad-4d1e-a67a-51a9d99787d7","text":"The International Monetary Fund approved a $5 billion loan arrangement for Ukraine on June 9, 2020, contingent on economic reforms and anti-corruption measures.","date":"2020-06-09 00:00:00"},{"id":"42bd8f38-2fd4-41ff-b341-2b0082c32891","text":"The U.S. government temporarily froze nearly $400 million in security assistance to Ukraine in July 2019, around the time of the Trump\u2013Zelensky call.","date":"2019-07-24 00:00:00"},{"id":"a8fe53c0-7e4e-41fc-89e1-1ad373b9e8f8","text":"Then-Vice President Joe Biden publicly recounted in 2018 pressuring Ukraine to fire a prosecutor by threatening to withhold roughly $1 billion in loan guarantees.","date":"2018-04-24 00:00:00"},{"id":"4f983b79-5012-4e5e-b5da-900007e5a9e4","text":"A whistleblower complaint about the July 2019 call prompted a formal House impeachment inquiry into President Trump in September 2019.","date":"2019-09-24 00:00:00"},{"id":"9feefbd2-a7c6-4721-82ad-657290b14cef","text":"President Trump\u2019s July 25, 2019 phone call with President Zelensky in which Trump asked Ukraine to investigate Joe Biden and his son.","date":"2019-07-25 00:00:00"},{"id":"f165cf0e-f915-42f3-b7e5-f67a70b9c4de","text":"Zelensky cancelled a planned US Senate briefing amid a funding impasse (December 2023)","date":"2023-12-06 00:00:00"},{"id":"0a57fba4-28ce-4d8a-aff2-c670b52d4d49","text":"Domestic polls and reporting in late 2023 showed a measurable dip in Zelensky\'s approval/ trust indicators","date":"2023-12-24 00:00:00"},{"id":"2c659ec3-2327-40b7-86c2-5905cf7d48a3","text":"Pandora Papers (Oct 2021) revelations about offshore connections of Zelensky and associates","date":"2021-10-03 00:00:00"},{"id":"8c14d01d-d8dd-41c9-9cf7-c0401fcc6155","text":"Reuters Institute Digital News Report 2023 documented widespread \'news fatigue\' and falling news engagement","date":"2023-06-24 00:00:00"},{"id":"2bac8904-52f4-4bdb-9620-f27b4151693e","text":"Russian officials publicly accuse the West of direct involvement and hostile aims in Ukraine (e.g., Lavrov\'s public remarks at the UN accusing the West of \'de facto\' fighting)","date":"2023-09-23 00:00:00"},{"id":"47679c3a-7bc9-4d9d-a58e-3c4745dba065","text":"Russia announces annexation of Donetsk, Luhansk, Kherson and Zaporizhzhia following contested \'referendums\'","date":"2022-09-30 00:00:00"},{"id":"29d04490-fe48-4d3e-a171-75452dcd6f93","text":"NATO/Western officials publicly debate long\u2011term security packages for Ukraine, with reporting highlighting differences among allies","date":"2023-06-15 00:00:00"},{"id":"902d866c-4f3c-4638-9889-9bd14c3d0372","text":"Foreign embassies began withdrawing some staff and dependants from Kyiv","date":"2014-01-24 00:00:00"},{"id":"da9fdf94-cb84-42e7-b74d-f0cb8328f7e6","text":"UNHCR/IOM reporting of large-scale internal displacement from eastern Ukraine (Donbas) during 2014","date":"2014-10-24 00:00:00"},{"id":"7ff61552-88f3-4526-97b5-d9ca9ed9b4e2","text":"Violent Euromaidan clashes and clearing of Independence (Maidan) Square in central Kyiv","date":"2014-02-24 00:00:00"},{"id":"88bd205b-928f-47ae-ae3b-f31e27246468","text":"Cross-border refugee flows and media coverage of Ukrainians seeking refuge in neighbouring countries (2014)","date":"None"},{"id":"83f5e6cb-29b6-429f-8190-9a156717c61f","text":"Publication of Israeli cohort study reporting no increased incidence of myocarditis/pericarditis in unvaccinated patients after COVID-19 infection (Tuvali et al., Journal of Clinical Medicine)","date":"2022-04-15 00:00:00"},{"id":"bee4552b-57d9-478e-b893-2d4a9e1fc447","text":"University of Ljubljana press release describing Zelenska\'s meetings with faculty and projects (and not attributing the cancelled lecture to protests).","date":"2024-11-19 00:00:00"},{"id":"cbca741d-711d-4e4d-a4ce-33ef973ede59","text":"A man shouting anti\u2011Ukraine/pro\u2011Russia slogans appeared and was detained during Zelenska\'s visit to the National and University Library (reported by multiple outlets).","date":"2024-11-20 00:00:00"},{"id":"56411072-b42a-4fc6-8beb-80c750823803","text":"IAEA chief condemns shelling near Zaporizhzhia nuclear power plant","date":"2022-08-06 00:00:00"},{"id":"f4dd389c-4dcd-4760-b416-5688cb51f35f","text":"Zelensky publicly urges partners to allow truly long-range strikes (September 2024)","date":"2024-09-21 00:00:00"},{"id":"5f4ab424-0937-49e2-bb1c-22aac0430f2a","text":"Putin puts Russia\'s nuclear forces on high alert after invasion began","date":"2022-02-27 00:00:00"},{"id":"cc878b4f-d0f6-41bb-b48f-76ec35f80521","text":"Series of Ukrainian strikes against Russian targets in Crimea, including attacks on Sevastopol and military infrastructure (2023)","date":"2023-09-16 00:00:00"},{"id":"eb7ccb5b-2c32-4340-b596-3de38645f97f","text":"OSCE Special Monitoring Mission report (23 August 2014) noting heavily shelled residential areas in Donetsk and civilian reports of damage and danger","date":"2014-08-23 00:00:00"},{"id":"dea64148-7283-4119-b18e-ce084b537bc9","text":"Amnesty International research missions documenting summary killings and abuses in eastern Ukraine (late August\u2013September 2014)","date":"2014-09-24 00:00:00"},{"id":"f648a1ac-8647-4587-a65b-ec507e162328","text":"Court ban on the Mejlis of the Crimean Tatar people declared \'extremist\' (April 2016)","date":"2016-04-26 00:00:00"},{"id":"df7328ad-1fa1-4626-aa8c-2ad980e5b771","text":"Rapid issuance/acceptance of Russian passports in Crimea after annexation","date":"2014-03-20 00:00:00"},{"id":"f7c95d9c-7dc5-4e18-b611-d0a7efa36313","text":"Intense Russian offensive and heavy shelling around Rubizhne (Battle of Rubizhne) with reports Russian forces took large parts of the town","date":"2022-04-06 00:00:00"},{"id":"2fc4f6cd-cdf8-48ba-9ec6-11b2f95170b3","text":"Local authorities issued shelter and safety warnings after the explosion, noting toxic fumes and urging people to stay indoors","date":"2022-04-09 00:00:00"},{"id":"48fce21f-e832-4203-ab5e-123ee6696b54","text":"Nitric-acid tanker at Zarya chemical plant damaged/exploded after shelling in Rubizhne","date":"2022-04-09 00:00:00"},{"id":"17a34f6d-fb4c-4c30-974b-ae80f60a7a6c","text":"Publication of patent applications describing fusion proteins containing luciferase (public patent records, e.g., US patent applications from 2018\u20132020).","date":"2020-04-24 00:00:00"},{"id":"b286e45c-02e1-4f62-b4ea-fa0ec72bc252","text":"Publication of research using luciferase reporter systems to study SARS-CoV-2 entry and for rapid neutralization testing (e.g., nanoluciferase SARS-CoV-2 assays published in 2020).","date":"2020-04-24 00:00:00"},{"id":"a12b2da7-f04b-4c9c-a3db-7be295e9d41b","text":"Verkhovna Rada passed a package of four \'decommunization\' laws mandating removal/ban of communist symbols and renaming of public places","date":"2015-04-09 00:00:00"},{"id":"9d757536-fecb-4608-b5ca-c5958b49de0d","text":"Parliamentary action to establish May 8 as a Day of Remembrance and Reconciliation alongside changes to how May 9 was observed","date":"None"},{"id":"5ad427b1-5567-464f-a8cf-f114afd13bab","text":"Public dispute and protests around the future of the Vatutin grave/monument in Kyiv (rallies and media reports in April 2015)","date":"None"},{"id":"9e1f9fe9-4b99-4e49-b766-2b7dad31a05b","text":"Widespread toppling/removal of Lenin and other Soviet monuments across Ukraine in 2014\u20132015 (\'Leninfall\') and reporting on mass removals","date":"None"},{"id":"b004b539-eb19-47a1-acdb-991d13d2815d","text":"Ongoing wild poliovirus transmission in Pakistan and Afghanistan documented in GPEI 2019 annual report","date":"2019-04-24 00:00:00"},{"id":"c8d87d2a-7e82-4a07-8f54-5c5e1f05f12a","text":"COVID-19 pandemic disrupted mass immunization campaigns, prompting WHO/UNICEF warnings about millions of children at risk (May 2020)","date":"2020-05-24 00:00:00"},{"id":"d6de6342-d06f-4bed-a24d-eba7808ccee4","text":"European leaders and diplomats publicly debated conditions and timelines for easing Russia sanctions (e.g., calls to consider step-by-step easing if Minsk progress made).","date":"2015-02-24 00:00:00"},{"id":"99b7dd48-1e8a-402b-a5d1-fb3a5fb3a750","text":"Multiple foreign embassies ordered non\u2011essential staff to leave or relocated operations from Kyiv","date":"2022-02-24 00:00:00"},{"id":"cf200205-e78e-440d-a9d8-77fbd362cd37","text":"Heavy fighting around Hostomel (Antonov) airport and other approaches to Kyiv as Russian forces advanced","date":"2022-02-24 00:00:00"},{"id":"6a03b943-9d28-44b2-955d-574383777124","text":"Large numbers of civilians seen fleeing Kyiv and images/videos of chaotic departures","date":"2022-02-24 00:00:00"},{"id":"8f870ec8-fd54-4279-a357-b36e82e50b6c","text":"IOM / Ukrainian government data: registered internally displaced persons (IDPs) exceed one million (reported February 2015).","date":"2015-02-17 00:00:00"},{"id":"7b41400e-2890-44c4-b7d4-e6cf6521a629","text":"Council of Europe / pan-European analyses of 2015 refugee coverage identify uneven framing and limited humanising coverage in parts of the press during the 2015 refugee crisis.","date":"2015-04-24 00:00:00"},{"id":"8421a853-8511-404e-9609-fc28810cbc3a","text":"Monitoring by Thomson Foundation / MEMO 98 (published December 2015) reports problems and inconsistencies in Ukrainian regional media coverage of IDPs.","date":"2015-12-10 00:00:00"},{"id":"c671a1bc-8a98-4e54-9d69-e4564687579d","text":"Prominent alternative-health websites and how\u2011to blogs publishing step\u2011by\u2011step guides and testimonials for using castor oil against bone spurs, scars, cysts and tumors (2022\u20132023)","date":"2023-04-24 00:00:00"},{"id":"7f8fb298-3c7e-4e6e-a71c-b19879710ca2","text":"Public criticism from Jewish organizations and commentators about commemorations of Petliura (e.g., World Jewish Congress reaction and critical coverage following monument unveilings).","date":"2017-04-24 00:00:00"},{"id":"ff69865f-a5f6-4dc5-af62-644a5ef74c96","text":"Analysis and reporting on disputes over church affiliation, symbolism and politicization of religious spaces in Ukraine and the diaspora (e.g., \'Who Owns Tradition? Ukraine\'s Church Controversy\' \u2014 Wilson Center).","date":"2024-08-24 00:00:00"},{"id":"5db9ef79-d7f2-4def-b134-502dc745d2cb","text":"End-2020 decision and architectural competition announced for a Petliura monument in Poltava (projects selected in 2020\u20132021).","date":"None"},{"id":"27e05cb7-cd28-4625-856d-6a9df0dac555","text":"Gazprom sharply reduced Nord Stream 1 flows to around 20% capacity and publicly linked the cuts to maintenance delays and sanctions-related equipment issues.","date":"2022-07-26 00:00:00"},{"id":"a81f1365-15a1-40ca-a95b-7adf39048cba","text":"Ukraine\'s Center for Countering Disinformation (NSDC/CPD) and other monitoring bodies documented and warned about Russian propaganda narratives around Ukraine\'s winter preparedness and energy dependence.","date":"2022-08-24 00:00:00"},{"id":"bf2eeb0d-cb04-4809-9b17-e692478c342c","text":"Ukraine ended the 2021/2022 heating season with record\u2011low gas reserves in storage.","date":"2022-04-21 00:00:00"},{"id":"c489b02f-e1f9-4731-81d8-f8063e70fa24","text":"Publication of the review \'The endocannabinoid-CB1 receptor system in pre- and postnatal life\' (Fride et al.), which notes that endocannabinoids have been detected in maternal milk (mostly from animal studies).","date":"2004-04-24 00:00:00"},{"id":"2f2601e2-dcdf-4a53-ac93-2691da00cda1","text":"November 7, 2012 \u2014 Voter approval of recreational marijuana legalization measures in Colorado and Washington (major expansion of public debate on cannabis).","date":"2012-11-07 00:00:00"},{"id":"e4456bfe-2d43-4143-ab11-773ac7e34cd0","text":"Reports mentioning use of military equipment (helicopters, armoured vehicles) during the government response","date":"2015-07-11 00:00:00"},{"id":"fca78f43-297e-48a9-989c-20b2fe4e6e7e","text":"Mukachevo shootout between Right Sector-affiliated fighters and local police","date":"2015-07-11 00:00:00"},{"id":"db318a9a-5538-40ea-af8a-e1b6ab6c097b","text":"Media and hospital-system reporting during the Delta surge highlighting \'incidental\' COVID-19 hospital admissions (Florida example)","date":"2021-08-24 00:00:00"},{"id":"ba71ae78-0568-4ae9-b7e6-5633929adfdb","text":"Local officials and media reported Russian troops looting shops and homes in occupied towns such as Trostianets (Sumy region) in early March.","date":"2022-03-02 00:00:00"},{"id":"4d52f801-b5ec-4382-89ac-56c59fd5a2ba","text":"Ukrainian president Volodymyr Zelensky called on citizens to take up arms and promised weapons would be issued to those willing to defend cities.","date":"2022-02-24 00:00:00"},{"id":"8dec6f5d-64f6-4948-93f3-d08dfdb42d2d","text":"Videos and news reports documented civilians in Kyiv and other cities preparing Molotov cocktails and receiving basic instructions on improvised weapons.","date":"2022-02-26 00:00:00"},{"id":"a0a4f554-0227-41a3-b9b5-71d79a79b103","text":"A passenger bus was struck near a Ukrainian Armed Forces checkpoint outside Volnovakha, killing and wounding civilians (reported immediately after the incident).","date":"2015-01-13 00:00:00"},{"id":"37cdd7f1-dbbc-4d6f-bcd1-908d696cd044","text":"Since early 2022, President Zelensky and Ukrainian authorities publicly invited and organized foreign volunteers via the International Legion and appeals for foreign fighters.","date":"2022-06-24 00:00:00"},{"id":"3aea1afc-c5cf-4000-a51f-bfc4f3c546a9","text":"Irish media and security sources reported unidentified drones in Irish airspace on the night of Zelensky\'s arrival in Dublin, prompting government briefings and heightened coverage of his visit.","date":"2025-12-04 00:00:00"},{"id":"c3385f2a-4d50-4695-b459-86268d931b4f","text":"President Volodymyr Zelensky presented posthumous awards to the families of three Irish volunteer servicemembers during his official visit to Dublin.","date":"2025-12-02 00:00:00"},{"id":"cff3fd9a-d663-4f91-806f-f5df7aab29c8","text":"UK and Irish reporting had previously documented multiple Irish nationals serving and killed or missing while fighting in Ukraine (coverage naming Rory Mason, Finbar Cafferkey, Graham Dale and reporting Alex Ryzhuk as missing/presumed dead).","date":"2024-08-21 00:00:00"},{"id":"0ca2b759-ed1f-4533-a743-66057166e846","text":"Fluoride Action Network (FAN) national campaigning and reporting (2016\u20132017), including petitions and litigation efforts to challenge U.S. EPA regulation of fluoride.","date":"2017-04-24 00:00:00"},{"id":"b291b4aa-590a-45a3-be10-13ea049520f5","text":"CDC/NHANES analyses and reporting on increased prevalence of dental fluorosis in U.S. surveys.","date":"2015-04-24 00:00:00"},{"id":"57e1aa72-bd50-44f9-ac97-2321b745e8aa","text":"CDC public description of its Technology Transfer Office and the fact that CDC researchers can patent inventions and license technologies to industry.","date":"None"},{"id":"1b4f0df7-b4bd-4b1b-bc66-9bbbaf34be37","text":"Ukraine passed and the president signed constitutional amendments in February 2019 enshrining EU and NATO membership as state policy","date":"2019-02-19 00:00:00"},{"id":"d81661cf-5c0b-4a2b-9276-5eef0fe647d8","text":"ECHA (European Chemicals Agency) opinion/proposal to classify titanium dioxide as a suspected carcinogen by inhalation (RAC opinion)","date":"2017-04-24 00:00:00"},{"id":"250d30d1-b4d0-4780-afc9-7abb6bcb33c1","text":"Scientific Reports paper (Sciensano-led) found titanium dioxide particles in all examined face masks","date":"2022-02-15 00:00:00"},{"id":"f0b19778-b737-4355-aacb-1f94e50a3340","text":"EU and public\u2011health coverage reassuring that there was \u2018no evidence\u2019 masks pose health risks after TiO2 concerns were reported (widely reported by Reuters and others)","date":"2021-11-08 00:00:00"},{"id":"44bee4a0-5e9e-468b-827e-6d1884c6397a","text":"On 21 April 2019 (second round presidential voting) some polling stations near the contact line experienced delays or local disruptions (reports noted at-the-day irregularities in frontline areas).","date":"2019-04-21 00:00:00"},{"id":"002f0757-9088-4dfd-8861-b023ac2bc82b","text":"Voting did not take place in Crimea and large parts of Donetsk and Luhansk during Ukraine\'s early parliamentary election (26 October 2014).","date":"2014-10-26 00:00:00"},{"id":"80bc74d4-d262-4281-9d64-b4167293c1c5","text":"Russia\u2011backed authorities held another round of unrecognized \u2018elections\u2019 in occupied Donbas on 11 November 2018 that Western bodies condemned as illegitimate.","date":"2018-11-11 00:00:00"},{"id":"9c004883-e27b-4fa4-85dc-6237f9c3f8b3","text":"International analyses documenting large numbers of foreign fighters/volunteers in Donbas (ICCT and other reports, mid\u20112010s)","date":"2016-04-24 00:00:00"},{"id":"3d92343c-6406-4363-b6c0-f7f7774224be","text":"Canadian defence delegation visit to the Donbas withdrawal line (reported delegation visit led by Deputy Minister Peter Hammerschmidt) \u2014 December 2019","date":"2019-12-24 00:00:00"},{"id":"53aaa877-b359-4b19-9eb8-87dcb20c91b8","text":"Canada launches Operation UNIFIER (Canadian Armed Forces trainers deployed to Ukraine) in 2015","date":"2015-04-24 00:00:00"},{"id":"87526bfe-1ab6-4510-81cd-485fd8a2394a","text":"Deployment of Russian private military company Wagner to Crimea/Donbas in 2014\u20132015","date":"None"},{"id":"4db96af4-a2d9-4915-a235-99f285265170","text":"Satellite imagery and reporting in February 2022 showed substantial Russian troop and equipment deployments in Belarus and flights out of Belarusian bases toward Ukraine.","date":"2022-02-06 00:00:00"},{"id":"0243bba8-97b4-405c-988d-c502a37eba5d","text":"Ukrainian Defence Ministry\'s Military Intelligence published a roster naming Belarusian Air Force personnel allegedly involved in strikes, triggering circulation of lists linking Belarusian officers to combat operations.","date":"2022-03-01 00:00:00"},{"id":"f7ae7a77-e251-42f3-86f0-7ed24dafaa34","text":"Conflicting official messaging in late February 2022: Belarusian leadership publicly denied plans to send Belarusian troops, even while allowing Russian forces to mobilize on Belarusian soil.","date":"2022-02-27 00:00:00"},{"id":"c5ea45ad-3adf-499c-b7bf-7265e712f87a","text":"The 2009 Su-27 crash at the Radom air show (30 August 2009) that killed two Belarusian pilots (A. Marfitski and A. Zhuraulevich).","date":"2009-08-30 00:00:00"},{"id":"ac56868b-2125-4f50-b409-8de61b0026be","text":"High\u2011profile resignations of senior FDA vaccine officials amid booster controversy (Marion Gruber and Phillip Krause)","date":"2021-08-31 00:00:00"},{"id":"96d226e2-af95-4e8a-b05e-bb041137ed0b","text":"Audit published of USAID\'s \'Strengthening Civil Society in Ukraine\' project","date":"2014-05-29 00:00:00"},{"id":"b71bf3b1-a654-4fd7-98f6-f665993968dd","text":"Russian officials publicly accused the U.S. of meddling and funding protesters in Ukraine","date":"2014-02-24 00:00:00"},{"id":"578cb98d-fe9d-4880-98c9-f3933f0a0130","text":"U.S. Congress/administration announcements of large financial assistance to Ukraine (including a $1 billion loan guarantee)","date":"2014-03-28 00:00:00"},{"id":"088f6d76-5154-4348-a832-9c9c301aca64","text":"Public records and reporting of National Endowment for Democracy (NED) grants to Ukrainian groups during Euromaidan","date":"2014-04-24 00:00:00"},{"id":"83562bb3-47bc-4447-ae9a-346721e6e771","text":"IMF program in March 2015 tied continued financial support to debt restructuring and private\u2011sector involvement","date":"2015-03-24 00:00:00"},{"id":"7044d262-4ace-4d40-888a-aeb6c91aa16f","text":"Reuters reports Ukraine completed a major $15 billion debt restructuring in March 2015","date":"2015-03-12 00:00:00"},{"id":"d2001645-6b3c-4657-b183-bf1790f9f067","text":"DW reports Yatsenyuk warning Ukraine might suspend repayments and refusing to accept Russia\u2019s terms (October 2015 coverage)","date":"2015-10-26 00:00:00"},{"id":"740023ce-6df3-4ecd-ab09-6808b207dfde","text":"Ukrainian prime minister publicly rebuffs Putin\u2019s offer to restructure the $3bn Russian bond","date":"2015-11-20 00:00:00"},{"id":"7f53f839-1dd0-4b87-a92f-8d56914df42d","text":"Sharp decline in reported influenza activity in the U.S. during March 2020 as COVID-19 measures began","date":"2020-03-24 00:00:00"},{"id":"d387c4db-da26-4fe9-ba04-508b28a19630","text":"Nature Medicine study (Leung et al.) showing face masks reduce respiratory virus shedding in exhaled breath","date":"2020-04-03 00:00:00"},{"id":"a8656049-fc1b-42f8-a23c-d74e20da9f6f","text":"CDC recommends public use of nonmedical cloth face coverings","date":"2020-04-03 00:00:00"},{"id":"09b43b1f-b2fe-4c1e-bf61-ae46aab54da1","text":"High\u2011profile Pfizer/BioNTech vaccine efficacy announcement (press release and global media coverage) reporting ~90% effectiveness","date":"2020-11-09 00:00:00"},{"id":"d350bc36-e670-40d6-aa13-eea5cced5d3f","text":"Historical origin of the MRC\u20115 cell line (derived from a 14\u2011week male fetus in 1966) documented by cell banks (ATCC) and widely reported","date":"1966-04-24 00:00:00"},{"id":"e3730230-766d-47c0-925a-acd8f825e41d","text":"Release of a Research Square preprint (ChAdOx1 nCoV-19) showing experiments using MRC\u20115 and HEK293 cell lines (preclinical/transcriptomic analysis)","date":"2020-10-20 00:00:00"},{"id":"517160a7-add7-454a-ab4e-f0a0d7097b13","text":"CDC recommendation on July 27, 2021 for universal indoor masking in K\u201312 schools regardless of vaccination status due to Delta variant concerns.","date":"2021-07-27 00:00:00"},{"id":"5e4c7a2f-bb62-40cf-9046-3afa103259ec","text":"Publication of MacIntyre et al. (2015) cluster randomized trial finding cloth masks offered less protection than medical masks among healthcare workers.","date":"2015-04-22 00:00:00"},{"id":"5438d1e8-c35d-4f29-9ca5-d93e80592b4b","text":"Torchlight marches and public rallies honouring WWII-era nationalist Stepan Bandera attended by far\u2011right groups and covered in the media (e.g., Lviv torchlight march).","date":"2014-01-01 00:00:00"},{"id":"dde15ad3-c3ed-41c9-9c7e-212a0268b2f4","text":"Passage of Ukraine\'s \'decommunization\' laws in April 2015, banning Soviet symbols and changing official commemorations and place names.","date":"2015-04-24 00:00:00"},{"id":"148b32a4-73c6-4d27-b7da-71b2c9563b4d","text":"Profiles in 2014 highlighting the Right Sector movement\'s role in the Maidan protests and its radical nationalist ideology.","date":"2014-04-24 00:00:00"},{"id":"e0e902a1-1b92-4d20-b99e-b6ece30315f2","text":"Reports in 2014 that the Azov militia (later a National Guard unit) used symbols and insignia associated with neo\u2011Nazi groups and had leaders with far\u2011right views.","date":"2014-08-24 00:00:00"},{"id":"b925b8a6-b72d-4a5c-8669-aefd94275817","text":"World Health Assembly adoption of a package of amendments to the International Health Regulations (IHR) (adopted 1 June 2024)","date":"2024-06-01 00:00:00"},{"id":"1e030ebf-e8f3-4135-b352-2512fe72e38f","text":"Earlier high\u2011profile vaccine contamination reports (Japan paused some Moderna batches after black/foreign particles were found)","date":"2021-08-26 00:00:00"},{"id":"2635407d-4878-4b46-a0cc-e96df9241a26","text":"Publication of Danish research letter reporting batch-dependent variation in suspected adverse events after the Pfizer (BNT162b2) vaccine","date":"2023-03-30 00:00:00"},{"id":"87f10262-b62a-4311-a7c5-9dd935e92d24","text":"Publication and high-profile retraction (Surgisphere) of large observational studies on hydroxychloroquine (The Lancet retraction, June 2020)","date":"2020-06-24 00:00:00"},{"id":"f3e080a5-bdfc-4b11-aba5-8a1d672670be","text":"Publication of Didier Raoult / Gautret open-label non-randomized Marseille study reporting viral-load reduction after hydroxychloroquine \xb1 azithromycin","date":"2020-03-24 00:00:00"},{"id":"0f0735b0-0b64-43d9-b78c-c1bbb6bb8b3f","text":"Prior international reporting (2014\u20132015) documented Azov\'s origins in far\u2011right volunteer networks and the use of extremist symbols by some members.","date":"2015-03-13 00:00:00"},{"id":"a40a181c-1e52-4737-91a5-0bcbf75cfd68","text":"Dutch advisory referendum on the EU\u2013Ukraine Association Agreement had been activated and was widely reported (petition drive and referendum scheduled for April 2016).","date":"2015-10-07 00:00:00"},{"id":"52289c6e-47f6-4ffb-be6d-afc19102dfe1","text":"IPCC AR6 (Working Group I) released findings noting that internal variability can modulate near\u2011term global temperature trends, creating uncertainty in short\u2011term (years to a decade) temperature trajectories.","date":"2021-08-24 00:00:00"},{"id":"6f7e1a31-2f08-4dc1-9e88-4c22430a5a99","text":"Japan suspends use of about 1.63 million Moderna COVID\u201119 vaccine doses after \'foreign materials\' were found in some vials, prompting international media coverage and public concern about vaccine contamination.","date":"2021-08-24 00:00:00"},{"id":"5ab7b0d3-7047-4c61-accb-d237cbfddb63","text":"Two infants died shortly after receiving MMR vaccine in Samoa, prompting national investigation and temporary suspension of some vaccine supplies (widely reported and later traced to preparation error).","date":"2018-07-11 00:00:00"},{"id":"ae66610f-0227-4d7d-881b-f939887bbb73","text":"Reports of a July 2020 surge in Amazon deforestation and fires, and international concern about weakened enforcement under Brazil\'s government (reported August 2020)","date":"2020-08-02 00:00:00"},{"id":"22413a57-ade4-432b-b447-ae7f68c9ea9a","text":"Science Advances editorial \'Amazon Tipping Point: Last Chance for Action\' by Thomas Lovejoy and Carlos Nobre (Dec 2019)","date":"2019-12-20 00:00:00"},{"id":"d789af8a-74ca-4e8c-a53c-ce0d512a29c4","text":"Investigations and reporting documenting Cyprus as a secrecy hub for Russian and other foreign wealth (\u2018Cyprus Confidential\u2019 ICIJ series, 2023) highlighted Cyprus as a destination for opaque property holdings.","date":"2023-11-18 00:00:00"},{"id":"cecdd572-0e9c-408c-a648-d24aebebc4a5","text":"Ukraine\'s SBU announced it uncovered a scheme to embezzle about $40 million from weapons procurement (reported Jan 27, 2024).","date":"2024-01-27 00:00:00"},{"id":"cc6121cf-f17c-4f0b-8068-f9bedd0b0497","text":"The Pandora Papers (ICIJ coverage and major press, Oct 3, 2021) revealed offshore companies tied to Zelenskyy\u2019s inner circle.","date":"2021-10-03 00:00:00"},{"id":"29a7891b-c4f9-490d-9ea3-14bcdcf71170","text":"Russian Defence Minister Sergei Shoigu publicly said Russia was \\"deliberately slowing\\" its offensive to allow civilians to evacuate.","date":"2022-05-24 00:00:00"},{"id":"ae271609-4fdd-400d-8f29-7e52383382a3","text":"Negotiations and agreements (limited implementation) to open humanitarian corridors between Russia and Ukraine were publicly reported.","date":"2022-03-03 00:00:00"},{"id":"95dc57e4-ace0-4992-91bf-15cb68cf161c","text":"Precedent: Ukrainian church leaders previously (April 2022) urged faithful to forgo night Easter vigils in areas affected by fighting and to use online prayer options.","date":"2022-04-20 00:00:00"},{"id":"eca6695c-9485-46ba-88b1-f0b216c0df98","text":"Kyiv city administration published wartime guidance advising limited mass gatherings for Easter and urging online broadcasts (curfew remained in force).","date":"2023-04-11 00:00:00"},{"id":"1e525167-7028-4130-a290-89c0cc1f7b00","text":"Kyiv Military Administration clarified churches would be open but worshippers who entered before the midnight curfew could not leave until it ended (and urged switching to online broadcasts).","date":"2023-04-15 00:00:00"},{"id":"4e6ae5f8-c029-4c4c-911c-2249d87b3176","text":"U.S.\u2013Ukraine critical minerals/resources memorandum reported","date":"2025-04-30 00:00:00"},{"id":"8e44b3f6-8941-4118-9684-cee357148f2e","text":"Ukraine Recovery Conference (URC) \u2014 large Western reconstruction pledges and private\u2011sector investment commitments","date":"2023-06-21 00:00:00"},{"id":"d4dd7258-46f2-4967-b8a9-c22fbc3234a6","text":"Prominent think\u2011tank analyses raising \'partition\' as a plausible risk/outcome","date":"2024-01-08 00:00:00"},{"id":"5e8dfcf3-0b58-4cd5-9849-4dae8da9a114","text":"Russian customs effectively suspended or heavily restricted imports from Ukraine (placing Ukrainian exporters on a \'risk\' list), producing a de facto trade embargo in August 2013.","date":"2013-08-14 00:00:00"},{"id":"94cbd636-96c5-441e-8084-28d66e0a9c94","text":"Separatists and protestors had seized Ukrainian security service buildings and weapons stores in Luhansk in 2014","date":"2014-04-22 00:00:00"},{"id":"99e3cbee-8eeb-4283-b940-26f6d55860bb","text":"Public debate in 2015 about supplying Western weapons to Ukraine (media/policy discussions)","date":"2015-02-11 00:00:00"},{"id":"006a0af7-5134-4b95-ba70-99a654f66320","text":"Ukrainian government announces figure of 19,546 Ukrainian children deported/forcibly transferred","date":"2023-03-24 00:00:00"},{"id":"66fdb79c-7177-4e29-8db6-3361eb871144","text":"Russian officials and state media publicly characterize transfers as \'evacuations\', \'adoptions\', or humanitarian relocations and dispute foreign reports","date":"2023-02-15 00:00:00"},{"id":"4b78b22b-a78b-429d-ad70-d88d304eb04d","text":"U.S. FDA granted Emergency Use Authorization (EUA) for the first COVID-19 vaccine (Pfizer\u2013BioNTech).","date":"2020-12-11 00:00:00"},{"id":"7f21b2c9-2821-4403-ac30-03ac46bc7bbb","text":"CDC updated indoor masking guidance on July 27, 2021, advising fully vaccinated people to wear masks in public indoor settings in areas of substantial or high transmission due to Delta.","date":"2021-07-27 00:00:00"},{"id":"7b17fc30-706e-4de0-9711-467e629d4a85","text":"Israeli Ministry of Health and media reports (early July 2021) indicated reduced Pfizer vaccine effectiveness at preventing infection with the Delta variant (while still protecting against severe disease).","date":"2021-07-05 00:00:00"},{"id":"b55fb582-2646-4c5e-9bdf-fafa3084e7f7","text":"CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing many infections in fully vaccinated people (including high viral loads).","date":"2021-07-30 00:00:00"},{"id":"71fb2457-f74f-420b-b866-478d856b2ab9","text":"Publication of meta\u2011analyses / preprints (e.g., John Ioannidis\' seroprevalence\u2011based estimates in May 2020) reporting relatively low infection fatality rate (IFR) estimates in some settings.","date":"2020-05-13 00:00:00"},{"id":"2b6bdc01-aa57-4c64-9a80-48854762b219","text":"Swedish state epidemiologist Anders Tegnell publicly defended Sweden\'s decision not to impose a strict lockdown and said parts of Stockholm were showing signs of immunity","date":"2020-04-22 00:00:00"},{"id":"f65890dc-6fc9-4d6c-bd46-ea4e94f73923","text":"Global dashboards and WHO/academic mortality pages publishing country-level COVID death counts and per-capita metrics were widely circulated in summer 2020","date":"2020-08-08 00:00:00"},{"id":"90499542-92a5-4b43-b305-37be2a8caa3c","text":"Gordon Brown\'s public apology to former child migrants (UK government apology)","date":"2010-02-24 00:00:00"},{"id":"ff5f1c6b-a058-4e94-bdb9-0a1846fd8362","text":"Reuters reported Ukraine was in talks with Moscow over the return of 311 Ukrainian soldiers and border guards who had crossed into Russia, while Russian border authorities said the troops were seeking asylum.","date":"2014-08-04 00:00:00"},{"id":"fcd23f10-1869-43b2-b82a-c56c211ba8a5","text":"OSCE Special Monitoring Mission reported witnessing the passage of 437 Ukrainian servicemen through Russian checkpoints and stated it had inquired about asylum requests and found none.","date":"2014-08-04 00:00:00"},{"id":"4e9e4d5c-6e27-4e17-ad6e-b22d8489b781","text":"EU Foreign Ministers agree to begin targeted measures (reported in UK parliamentary scrutiny documents)","date":"2014-02-20 00:00:00"},{"id":"00258153-b0fa-4cef-b1ce-bc62bb041f10","text":"European Parliament adopts resolution condemning Russian actions in Ukraine","date":"2014-03-13 00:00:00"},{"id":"6ca83595-0bcb-428d-a4ec-ba254a2efbea","text":"UK Prime Minister David Cameron signals support for strong EU sanctions on Russia","date":"2014-03-04 00:00:00"},{"id":"e51f8b71-986d-410f-bd79-93c3e78b00f2","text":"Reporting of UK MPs meeting or engaging with Russian officials and pro\u2011Kremlin voices (summer 2014)","date":"2014-07-01 00:00:00"},{"id":"76508154-09da-49a0-95a1-066d078e00cd","text":"The Joint Investigation Team (JIT) held a public presentation of interim MH17 criminal-investigation results describing the likely weapon type and launch area.","date":"2016-09-28 00:00:00"},{"id":"c327f749-1b30-42e5-aa05-6fbb0eeacd7f","text":"Ukrainian authorities/activists compiled and publicised lists of Russian artists and cultural figures to be blacklisted from entry or broadcasting in Ukraine (summer 2014 announcements).","date":"2014-08-24 00:00:00"},{"id":"609fc20d-fab3-4131-b0c2-6231bd2b0971","text":"Repeal/controversy over the 2012 Kolesnichenko\u2013Kivalov \'regional language\' law and moves to strengthen the status of Ukrainian after February 2014.","date":"2014-02-24 00:00:00"},{"id":"1a261083-868b-4ca7-a6d1-1efed63eb1ca","text":"Kyiv city administration replaced Soviet-era Ded Moroz (Father Frost) in its official New Year program with the Orthodox figure Saint Mykolay.","date":"2014-11-20 00:00:00"},{"id":"9ba195c6-1326-42c5-960c-19e7c8042ded","text":"Widespread removal/toppling of Lenin statues across Ukraine (\'Leninopad\') during early 2014.","date":"None"},{"id":"cecf8006-3769-448b-bee9-c409927c3538","text":"Verkhovna Rada adopts four \'decommunization\' laws banning communist/Nazi symbols and related propaganda","date":"2015-04-09 00:00:00"},{"id":"3866f289-5721-43dd-8f2f-d438225475a7","text":"Assassination of pro\u2011Russian journalist Oles Buzina in Kyiv","date":"2015-04-16 00:00:00"},{"id":"761fbe9f-4e8a-4239-83af-c6e54f45e545","text":"Adoption of the \'lustration\' (cleansing) law removing/formally barring former officials from public office","date":"2014-10-16 00:00:00"},{"id":"2c06f34f-2f19-47ac-8693-44195e18db1c","text":"Reports of Ukrainian authorities detaining and denying entry to journalists (SBU detentions, denied access to some Russian reporters)","date":"2014-05-21 00:00:00"},{"id":"21f02906-61aa-4635-89e7-dfdef2f8e32f","text":"UNODC/trafficking and organized crime reports covering Ukraine (Global and regional reports up to 2014)","date":"2014-04-24 00:00:00"},{"id":"e969df4c-6bda-4fda-8faf-8a2f53079843","text":"U.S. State Department 2016 International Narcotics Control Strategy Report (INCSR) and related country assessments","date":"2016-03-24 00:00:00"},{"id":"bd127af5-f593-4936-8d80-4770971638b8","text":"Panama Papers revelations linking Ukrainian elites and offshore companies","date":"2016-04-24 00:00:00"},{"id":"71c7b3ea-9646-4c99-97af-5f9ae141a87c","text":"Mainstream press coverage of the booming \'sound bath\' and sound\u2011healing trend (New York Times feature, Aug 3, 2019)","date":"2019-08-03 00:00:00"},{"id":"a1f58177-6ee6-403c-b59f-e0c47e72f8e5","text":"Publication of a small 2018 study \'Effect of 528 Hz Music on the Endocrine System and Autonomic Nervous System\' reporting short\u2011term stress\u2011reduction biomarkers after exposure","date":"2018-04-24 00:00:00"},{"id":"465139ad-b844-408e-9047-05e13f2a1617","text":"Wellness platforms and apps published accessible explainers promoting 528 Hz as relaxing/\'healing\' (example: Calm blog explainer on 528 Hz)","date":"2021-07-30 00:00:00"},{"id":"b882c107-1688-4c7f-aa83-37f8179b332f","text":"Russian authorities completed a domestic switch of Crimea\'s public telephone numbering to the Russian system (transfer of city codes to Russian numbering, widely reported May 2015).","date":"2015-05-07 00:00:00"},{"id":"a67870d4-bdaa-40e8-8ed1-3008ad93ff8c","text":"United Nations General Assembly Resolution 68/262 (27 March 2014) reaffirmed Ukraine\'s territorial integrity and non\u2011recognition of the 2014 Crimean \'referendum\'.","date":"2014-03-27 00:00:00"},{"id":"fedf74b3-da5d-4791-bb62-b882627d82dd","text":"An ITU Operational Bulletin issue published information submitted by the Russian Federation about numbering in Crimea (the bulletin included Russian-requested codes but carried an ITU disclaimer that publication did not imply recognition of territorial status).","date":"2017-07-24 00:00:00"},{"id":"0fbd1e4c-5ae9-42d9-9da5-e0a879fe9a56","text":"Ukrenergo confirms restriction of power flow from the Ukrainian grid to Crimea","date":"2014-09-03 00:00:00"},{"id":"16e3a410-61e7-4567-9254-da415cc634a2","text":"Russia announced a fast-track citizenship/passport scheme for residents in occupied Kherson and Zaporizhzhia","date":"2022-05-25 00:00:00"},{"id":"d36dc697-e41c-4adc-903b-d65a6656346c","text":"The Russian-installed head of the occupied part of Zaporizhzhia signed a decree to begin preparations for a referendum on joining Russia","date":"2022-08-08 00:00:00"},{"id":"e0403980-e461-44f1-8f2a-cf3d14ecce4d","text":"Russian President Vladimir Putin recognized the self-proclaimed Donetsk and Luhansk \'people\'s republics\' as independent entities","date":"2022-02-21 00:00:00"},{"id":"d350a23c-53ae-49d3-a77b-96740cdef738","text":"NOAA and international reports showing greenhouse gas concentrations and ocean heat content reached record highs in 2021 despite pandemic-era emissions dip.","date":"2022-06-24 00:00:00"},{"id":"2b6a71aa-4472-4e68-99df-a6a0eaf88087","text":"IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, stating human influence on climate is \'unequivocal\'.","date":"2021-08-24 00:00:00"},{"id":"8e43ca38-477c-461c-b3bc-58e7cf786127","text":"Unprecedented Pacific Northwest heatwave that broke all-time temperature records across parts of the US and Canada.","date":"2021-06-24 00:00:00"},{"id":"cf666a58-2243-4a76-bb8f-1694da47cc0a","text":"The Pfizer\u2013BioNTech Phase 3 clinical trial protocol (NEJM supplementary material, published with the trial paper) contains wording that \'each lot of \\"Process 2\\"-manufactured BNT162b2 will be administered to approximately 250 participants...\'.","date":"2020-12-24 00:00:00"},{"id":"f37eb4c8-03bf-42cd-8294-6b6396362096","text":"Regulatory assessment documents (EMA/UK regulator summaries and later EMA follow-ups in 2022) described two manufacturing processes (Process 1 and Process 2) and required post\u2011authorization comparability analyses that were later reported as fulfilled.","date":"2022-09-24 00:00:00"},{"id":"8293ff46-9e9c-4729-be96-eb147e98babc","text":"Publication and long-running media attention to the Altamont Pass Wind Resource Area bird-fatality monitoring and final report showing substantial raptor deaths at a major U.S. wind zone.","date":"2016-04-24 00:00:00"},{"id":"2d781471-40cd-4135-ae10-5d54b0c2f161","text":"2020 study/news coverage showing that painting or visually marking turbine blades (Sm\xf8la, Norway) reduced raptor collisions by a large percentage.","date":"2020-08-24 00:00:00"},{"id":"7761aa3f-02a9-44a2-925d-b948230aa424","text":"U.S. Food and Drug Administration issued public statements and warning letters (Nov 2019 and subsequent actions) about companies illegally marketing CBD products with unproven health claims.","date":"2019-11-25 00:00:00"},{"id":"20935077-ae16-44a6-8f86-4b3958ab676a","text":"Mainstream consumer interest in \'clean\'/\'natural\' personal-care labels (clean-beauty trend coverage)","date":"2023-01-04 00:00:00"},{"id":"144f4ef3-3f8f-4bcd-af22-0f371f1acea7","text":"Ukrainian authorities/Parliament and agencies moved to blacklist or restrict performances by some Russian artists (summer 2015)","date":"2015-08-08 00:00:00"},{"id":"97fea7ed-0a59-4136-8d95-48012da6ae95","text":"Verkhovna Rada passed \'decommunization\' laws and other cultural-memory legislation","date":"2015-04-09 00:00:00"},{"id":"2c5df468-b52b-4d60-8845-9a4f8f790442","text":"Adoption and controversy around the Kivalov\u2013Kolesnichenko \'language policy\' law (entered into force August 2012)","date":"2012-08-10 00:00:00"},{"id":"ffe13c8a-2b52-4649-8da5-573147362c7f","text":"Ukraine\'s National Council for TV and Radio Broadcasting ordered cable operators to stop retransmitting several Russian TV channels","date":"2014-03-11 00:00:00"},{"id":"db5a3cdb-61d6-4430-98a2-5ca84df09264","text":"Russian leadership publicly denied deployment of regular Russian troops to eastern Ukraine (e.g. Vladimir Putin statements denying regular Russian troops are in Ukraine).","date":"2015-04-16 00:00:00"},{"id":"370fe09f-1815-44bc-966c-d5620e3f3523","text":"OSCE Secretary General Lamberto Zannier and OSCE Chief Monitor Ertugrul Apakan issue a joint statement after Minsk talks noting the SMM could not verify removal of \'foreign armed formations\' and stressing need for access to verify compliance.","date":"2015-02-13 00:00:00"},{"id":"a1799f97-c47e-4195-b20b-f0ad237b2d47","text":"Ukraine\'s ambassador to Italy publicly criticized Verona\'s revocation and called it orchestrated by external (Kremlin) influence.","date":"2018-09-24 00:00:00"},{"id":"8f6604c8-287d-433c-a86e-5fe6b1d8304e","text":"Ukraine recovered and returned 17 paintings stolen from Verona\'s Castelvecchio museum; Poroshenko took part in return ceremonies.","date":"2016-05-24 00:00:00"},{"id":"d41a1e23-eec6-446d-b7fd-b0cfd04fc347","text":"Widespread public fear and vaccine hesitancy in Samoa after the 2018 deaths\u2014many parents reportedly stopped taking children for routine immunisations.","date":"2019-06-06 00:00:00"},{"id":"e58137b7-32e2-47b4-97f5-63c8ce35448a","text":"Two senior Samoan nurses were sentenced to five years\' imprisonment for their role in the infants\' deaths after incorrectly administering the vaccine.","date":"2019-08-02 00:00:00"},{"id":"e9e683db-688a-4ca1-aab1-a2534d2cbe9c","text":"Published clinical case reports and reviews documented rare but real cardiac or severe complications occurring around dental procedures (e.g., cardiac arrest during recovery after tooth extraction).","date":"2019-04-24 00:00:00"},{"id":"f1f11a20-928c-4ed8-8c63-bd61be10cfdc","text":"U.S. Defense Threat Reduction Agency (DTRA) and the U.S. Embassy publicly documented long-running U.S. cooperative biological threat reduction work with Ukraine (lab upgrades, surveillance, diagnostics)","date":"None"},{"id":"cda9134c-6da8-4b17-8062-32c67f8575dc","text":"Ukraine experienced major vaccine-preventable disease outbreaks and entrenched vaccine hesitancy (notably large measles outbreaks in 2017\u20132019)","date":"None"},{"id":"cbf6ac36-0c7f-4daf-ada1-66917b3bcc6c","text":"AstraZeneca temporarily paused its global COVID-19 vaccine trials after an unexplained illness in a trial participant","date":"2020-09-09 00:00:00"},{"id":"055e26f4-de2a-481c-8228-76083549ff72","text":"U.S. FDA issued an Emergency Use Authorization (EUA) permitting distribution of donated hydroxychloroquine from the Strategic National Stockpile (EUA issued March 28, 2020).","date":"2020-03-28 00:00:00"},{"id":"f5272df2-6a70-4641-aa53-d3ac1bfc97e4","text":"Dr. Vladimir Zelenko publicly promoted his outpatient \'Zelenko protocol\'\u2014hydroxychloroquine + azithromycin + zinc\u2014for early COVID-19 and gained local/regional media attention.","date":"2020-04-30 00:00:00"},{"id":"10f7556d-46ff-442b-824c-344e5364e305","text":"Publication of Cowling et al. 2012 randomized trial reporting increased non\u2011influenza respiratory virus infections after inactivated influenza vaccination","date":"2012-11-24 00:00:00"},{"id":"ad767526-fcd8-4271-ac09-b4292b190878","text":"National Academies report \'Reflecting Sunlight: Recommendations for Solar Geoengineering Research\' (June 2021)","date":"2021-06-24 00:00:00"},{"id":"945dea35-f608-4c69-9696-2e53442a9e18","text":"Release of the 1996 Air Force study \'Weather as a Force Multiplier: Owning the Weather 2025\'","date":"1996-08-24 00:00:00"},{"id":"66746a10-66dc-404c-865a-e4f7f83380a1","text":"Declassification and press reporting on Operation Popeye (U.S. cloud\u2011seeding in Vietnam, 1967\u20131972)","date":"1972-07-24 00:00:00"},{"id":"78fe29da-84f2-4baa-be8d-6fb4ff124304","text":"President Zelensky\u2019s office formally responded to petitions about the Catherine II monument and forwarded them to the Odesa City Council for consideration (per presidential response practice).","date":"2022-08-01 00:00:00"},{"id":"07010ddd-e21f-403b-9593-a4541391803e","text":"Separate electronic petition to dismantle the Catherine II monument was registered on the President of Ukraine\u2019s petitions platform (petition 22/145072\u2011ep).","date":"2022-06-28 00:00:00"},{"id":"e0a99797-941a-4671-bf46-f0dd1bfb658a","text":"Online petition to replace Odesa\'s Catherine II statue with a monument of US gay adult performer Billy Herrington reached required threshold for presidential consideration.","date":"2022-07-13 00:00:00"},{"id":"1fcbb4c4-7fef-4053-8120-08f9f1c2b449","text":"Sustained local activism and public debate in Odesa in mid\u20112022 calling for removal or relocation of Russian\u2011imperial and Soviet monuments.","date":"None"},{"id":"b74b70e7-c83f-41d9-bcc8-9d6a97dabe5d","text":"Large releases of internal Pfizer/FDA documents following the PHMPT FOIA lawsuit and judge-ordered accelerated disclosure (documents began being released publicly in early 2022).","date":"2022-01-24 00:00:00"},{"id":"2fee70ad-af03-412e-8657-43b22638b4d7","text":"FDA briefing documents for the Dec. 2020 Vaccines and Related Biological Products Advisory Committee (VRBPAC) meeting that listed trial deaths and stated investigators assessed none as related to the study intervention.","date":"2020-12-08 00:00:00"},{"id":"65ee12b8-784e-47d4-94af-9f72ed77d148","text":"Early COVID-era clinical reports and reviews highlighted that the eye can show signs of infection (e.g., conjunctivitis as a presenting sign of COVID-19).","date":"2020-04-24 00:00:00"},{"id":"80063df5-4134-4cc5-881d-25ed98bc202c","text":"Popular science and health journalism pieces explaining how eye exams can reveal systemic health issues (diabetes, jaundice, hypertension) reached wide audiences.","date":"2019-04-24 00:00:00"},{"id":"f3500725-a4ae-4a93-9216-9c911a39872f","text":"Published analyses and meta\u2011analyses in 2022 documented reduced vaccine effectiveness against Omicron infection and waning protection over time, with lower effectiveness for preventing symptomatic infection and some reduction for hospitalization in older/longer\u2011since\u2011vaccinated groups.","date":"2022-09-24 00:00:00"},{"id":"86986485-7c53-4f97-bbb4-793d8c13c40a","text":"Academic commentary and public explanations (e.g., Lancet / public\u2011health pieces in 2021\u20132022) highlighted the \'base\u2011rate fallacy\'\u2014how, in highly vaccinated populations, the majority of cases can be vaccinated even when vaccines work.","date":"2022-03-24 00:00:00"},{"id":"6766c2ec-1ad6-43e5-8693-a08588802f0b","text":"DIVI (German intensive care registry) added fields to record COVID-19 patients\' vaccination status, enabling routine recording of vaccinated/unvaccinated counts on ICUs.","date":"2021-12-24 00:00:00"},{"id":"1cb913cd-a492-42ac-9a44-2a8d1e7c426d","text":"Scientists and aerial surveys announced a third mass bleaching event on the Great Barrier Reef during the 2019\u20132020 summer, widely reported as \'third mass bleaching in five years\'.","date":"2020-03-25 00:00:00"},{"id":"762c8547-06dc-43a5-ab8e-4135203aea66","text":"UNESCO and the Australian governments\u2019 2019 reporting on the Reef\u2019s deteriorating outlook (2019 Great Barrier Reef Outlook Report / World Heritage Committee concerns) signalled long-term decline.","date":"2019-04-24 00:00:00"},{"id":"b7733ee8-2287-4667-9f4f-bbc3ebf6720a","text":"Armenian NGOs and civil society groups (in early November 2020) issued public statements condemning Azerbaijan\u2019s reported use of white phosphorus munitions.","date":"2020-11-05 00:00:00"},{"id":"c53e1efc-7533-4582-8a01-4b4b6992f8d3","text":"Open-source satellite imagery and videos in November 2020 showed burn patterns and footage consistent with reported use of white phosphorus munitions in the Second Nagorno-Karabakh War.","date":"2020-11-24 00:00:00"},{"id":"4b1e5b8c-8a50-4fe6-98c4-02742ea41abc","text":"Azerbaijan formally responded to Armenia\'s accusations at an OPCW session, denying the claims and disputing evidence (official statement recorded in OPCW documentation).","date":"2021-11-24 00:00:00"},{"id":"fe6dfd64-bbf2-4a17-895c-c6ae88b7ec89","text":"IPCC Fifth Assessment Report (AR5) discussion of the 1998\u20132012 \'hiatus\' in surface warming","date":"2013-09-24 00:00:00"},{"id":"b15fb8e1-637f-40e7-8eb1-707011750283","text":"Hockey-stick controversy and critiques (McIntyre & McKitrick critiques and 2006 NRC review)","date":"2006-04-24 00:00:00"},{"id":"bfd8e40a-82ea-46ae-bf57-a5bd59789ca5","text":"Public Health England technical briefing (Technical Briefing 16) published with early variant case and death tables","date":"2021-06-18 00:00:00"},{"id":"78a9b4b8-6d87-4353-93a6-aa50966bc925","text":"Publication and press coverage of the Scottish EAVE II analysis showing Delta linked to higher hospitalisation risk","date":"2021-06-15 00:00:00"},{"id":"74f13c59-4f5d-4cc1-a371-290153702650","text":"UN OCHA/partners publish Ukraine Strategic Response Plan (humanitarian appeals for Ukraine, 2015)","date":"2014-12-24 00:00:00"},{"id":"fdf37f84-dd1e-4b1b-a0b5-8a2170318090","text":"UN Security Council action on Crimea blocked after Russia veto (UN inability to act on Ukraine-related measures)","date":"2014-03-16 00:00:00"},{"id":"bbbff07c-eb09-429e-8e43-4ddc8d113800","text":"IMF delayed/suspended loan tranches to Ukraine amid governance and reform concerns (2015\u20132016)","date":"2016-09-14 00:00:00"},{"id":"75ec15a9-628f-4f3c-89d3-eecc766a6421","text":"UN humanitarian funding shortfalls reported in 2017 (large gaps between appeal requirements and funding)","date":"2017-08-31 00:00:00"},{"id":"a0c42368-b067-43e0-8465-9dfd78e6852a","text":"UNDP policy guidance states UNDP will not contribute to general budget support (direct government budget transfers)","date":"2008-11-24 00:00:00"},{"id":"ffa46cbb-e67a-4ceb-ba55-1cac0877f028","text":"Poland passed the \'Special Act\' on assistance to Ukrainian citizens (granting temporary protection, PESEL registration and access to services) that entered into force in March 2022.","date":"2022-03-12 00:00:00"},{"id":"a6f2e0ff-430b-4750-9cff-d43cbf11e3f2","text":"Ukraine\'s Cabinet adopted Resolution No. 678 approving an experimental project to allow issuance of Ukrainian ID-cards and foreign passports to Ukrainian citizens abroad.","date":"2022-06-10 00:00:00"},{"id":"a22287a0-316a-4bc3-8877-40c3d8842ed4","text":"Major reporting on rapid mass issuance of Polish ID numbers (PESEL) to Ukrainian refugees and the setup of document/ID help points (e.g., coverage of refugees receiving IDs at Warsaw sites).","date":"2022-03-19 00:00:00"},{"id":"b3a49e5e-3812-42ea-835b-08791faac60a","text":"Ukrainian document service announced opening of a centre/representation in Warsaw (Blue Office / Blue City) to process Ukrainian passport and ID applications.","date":"2022-06-24 00:00:00"},{"id":"d907f214-9242-4da1-96dc-9f0bc33f61c2","text":"Publication of the NIC\u2011PD randomized, double\u2011blind trial (Transdermal Nicotine Treatment and Progression of Early Parkinson\'s Disease), published online Aug 22, 2023 (NEJM Evidence / PubMed).","date":"2023-08-22 00:00:00"},{"id":"4f53296c-a170-4dac-8b3c-95e6d1d09300","text":"Statement by Eduard Basurin (DPR deputy defence minister) claiming drunken Ukrainian soldiers stole a tank and crushed a civilian car in Zoria, near Mariupol.","date":"None"},{"id":"88b5ff8c-32f4-4cb5-a4c2-5102fb026e29","text":"Kerch ferry operator reports unusually high passenger volumes in summer 2016","date":"None"},{"id":"afffbb98-7a7c-49ca-9495-deb16124338d","text":"Crimean tourism minister (Sergei Strelbitsky) publicly claims sharp rises in Ukrainian visitors during 2016","date":"2016-08-15 00:00:00"},{"id":"64a38f3a-9456-49bb-ba68-f04e3e791b42","text":"Russian media cites security claims that alleged Ukrainian sabotage aimed to \'destroy tourism\' in Crimea (Reuters coverage)","date":"2016-08-24 00:00:00"},{"id":"83509a11-3f16-4bdb-80aa-2c8c01e9e78a","text":"Early, well\u2011publicized problems with the CDC\'s original PCR test rollout in February\u2013March 2020 (flawed reagents and re\u2011validation), widely reported in the press","date":"2020-12-26 00:00:00"},{"id":"51d7de32-25b2-49d1-95bf-bab4d50c8194","text":"CDC promotion and availability of a multiplex \'Influenza SARS\u2011CoV\u20112 (Flu SC2) Multiplex Assay\' that detects and differentiates influenza A/B and SARS\u2011CoV\u20112","date":"2021-07-13 00:00:00"},{"id":"fb3df18f-a0a2-4ce9-8600-c2a404c590ff","text":"Zelenskyy\'s public denunciations (Aug 2023) of corruption in military medical exemptions and announced reviews","date":"2023-08-30 00:00:00"},{"id":"e383b025-a9fa-4797-9875-e72189d9e9ab","text":"Law / parliamentary changes expanding categories eligible for exemption or deferment from mobilization (July 2022 amendments and related guidance)","date":"2022-07-29 00:00:00"},{"id":"e69f59d9-bb32-4254-9600-13a67472b7d6","text":"Canadian Parliament standing ovation for Yaroslav Hunka (a veteran who served in a WWII Galicia-linked formation)","date":"2023-09-24 00:00:00"},{"id":"4752aea3-c2b1-42ba-8ef3-78e974599ff3","text":"Japan suspended use of ~1.63 million doses of Moderna\'s COVID\u201119 vaccine after \'foreign materials\'/contaminant reports were found in some vials (batch recalls/inspections).","date":"2021-08-25 00:00:00"},{"id":"7eeb196f-3cdf-49d7-a679-20612e8b96a5","text":"Federal judge ordered the U.S. FDA to accelerate public release of internal documents related to Pfizer\'s COVID\u201119 vaccine (court\u2011ordered accelerated disclosure ruling).","date":"2022-01-07 00:00:00"},{"id":"9c4c835c-6721-41e1-bb6a-bdd9ff475b95","text":"Publication of an Israeli health\u2011system study (NEJM, Oct 6, 2021) reporting higher incidence of myocarditis among males 16\u201329 after BNT162b2 (Pfizer) vaccination, with most cases mild or moderate.","date":"2021-10-06 00:00:00"},{"id":"3b7e99b7-3b5d-4a57-96b9-059447a7b364","text":"Ukrainian adviser says counteroffensive is months behind because of slow Western arms deliveries","date":"2023-10-17 00:00:00"},{"id":"b30a505a-f1d5-4f10-b0ab-5bb234feccb8","text":"Analyses warn Western help for Ukraine may diminish due to production and political limits","date":"2023-09-21 00:00:00"},{"id":"bcdfb634-b57d-45e3-872b-b9f0ca36fafb","text":"UN Security Council briefings raise concerns about diversion and proliferation of weapons sent to Ukraine","date":"2023-05-18 00:00:00"},{"id":"93e3db06-166b-4430-8d6e-e05b9cbfc593","text":"EU admits it will miss target to supply Ukraine with one million artillery shells","date":"2023-11-14 00:00:00"},{"id":"6d58abe6-7936-49a0-ad10-40cde093f941","text":"Countries reimposing or tightening lockdowns despite earlier measures (e.g., Israel second lockdown September 2020)","date":"2020-09-18 00:00:00"},{"id":"a5716227-cc2d-487c-b4e1-90631c2bd7b7","text":"WHO interim guidance on mask use that did not recommend universal mask-wearing for healthy people (interim guidance)","date":"2020-03-19 00:00:00"},{"id":"23af19b4-6fa3-4db4-aed8-de51c0424a7d","text":"Great Barrington Declaration advocating \'focused protection\' instead of lockdowns","date":"2020-10-04 00:00:00"},{"id":"7594a110-7e80-429d-b658-24df2a302bad","text":"Sweden\'s no-lockdown approach widely publicized","date":"2020-03-30 00:00:00"},{"id":"8cbfae15-d083-4bb6-b577-bef32055b97c","text":"CDC recommendation for cloth face coverings in public (policy change)","date":"2020-04-03 00:00:00"},{"id":"fd9efe20-ee65-47ea-9fe4-4e89ddd86750","text":"Ukrainian authorities move to redeploy ships/hovercraft and increase patrols in the Sea of Azov (reported August\u2013September 2018)","date":"2018-08-12 00:00:00"},{"id":"4925b3b4-190f-4834-b9cc-c5c3b0a387cd","text":"Kerch (Crimea) bridge opening and its reported impact on navigation to Azov ports","date":"2018-05-15 00:00:00"},{"id":"638706de-f7d7-43e0-8478-a9ffc03ae9b6","text":"Public recall and investigation of foreign particles (stainless steel/black particles) found in some Moderna vaccine vials in Japan","date":"2021-09-24 00:00:00"},{"id":"63271fe9-df41-4ee1-841b-3153cb7da6d5","text":"Pfizer\u2013BioNTech and Moderna vaccine efficacy announcements showing ~90-95% protection in trials (Nov 2020)","date":"2020-11-09 00:00:00"},{"id":"9d10ef81-f6a2-4e49-a199-c1555635e9d8","text":"Large cohort study showing robust neutralizing antibodies to SARS-CoV-2 persist for several months after infection (Wajnberg et al., Science)","date":"2020-12-24 00:00:00"},{"id":"fa25748d-926a-44e1-8ddd-e4885b098639","text":"Arrests and terrorism charges against Crimean Tatars by Russian authorities","date":"None"},{"id":"0933da37-3475-4bcd-bbeb-bc4ec55f9176","text":"Ukrainian President Petro Poroshenko publicly vows to \'retake\' Crimea / \'de-occupy\' the peninsula","date":"2014-06-24 00:00:00"},{"id":"43f60add-d506-4911-8c3b-d18bfa4b5016","text":"Repeated legal actions and arrests of high-profile alternative practitioners (example: Harry Hoxsey prosecuted repeatedly for practicing without a license, 1920s\u20131950s)","date":"2026-04-24 14:26:33.419932"},{"id":"1544928a-effc-4c44-a675-e0ccd8e8deed","text":"Air New Zealand suspended its Auckland\u2013Buenos Aires service during the COVID-19 period (service brought forward in March 2020)","date":"2020-03-18 00:00:00"},{"id":"d31b6f35-3e22-4748-bfc3-2024cf70804d","text":"CDC filed and was assigned patents on coronavirus isolates/genomic sequences (e.g., patent US7220852B1).","date":"2007-04-24 00:00:00"},{"id":"e61b3736-c4de-40d8-8d91-d554ea3d8b2d","text":"Widespread availability and consumer use of over\u2011the\u2011counter vitamin C supplements (NIH/Oregon State fact sheets documenting common use and safety perceptions)","date":"2019-04-24 00:00:00"},{"id":"d05e54c9-b82c-42fb-95bf-184ccbc4a4ed","text":"Parliament vote to repeal the 2012 language law (February 2014) following the Maidan changes.","date":"2014-02-23 00:00:00"},{"id":"023a2ca0-6acc-4354-870f-1e990d38e0fc","text":"Adoption of the Kivalov\u2013Kolesnichenko language law in July 2012 (Law on the Principles of State Language Policy).","date":"2012-07-03 00:00:00"},{"id":"0751e686-1dba-4c04-87b2-2f60c4f1b69a","text":"Introduction and entry into force of Ukrainian-language content quotas for radio and media beginning in 2016 (e.g., Ukrainian music quotas on radio adopted Nov 2016).","date":"2016-11-08 00:00:00"},{"id":"fbeda688-b4df-4b53-a93d-d39c1dd97036","text":"Ukraine\'s 1996 Constitution declares Ukrainian the state language.","date":"1996-06-28 00:00:00"},{"id":"8cdde93c-a746-45b9-8205-898c4d500b29","text":"Visible nationalist rhetoric and high public sensitivity in Lviv and Western Ukraine during the Euromaidan/early\u20112014 period (local protests, symbolic actions by nationalist groups).","date":"None"},{"id":"1d947b67-af0d-4867-8813-556d0f253bd8","text":"Systematic review (Farsalinos et al.) published April 2020 summarizing multiple Chinese hospitalized case series and noting lower prevalence of current smokers among COVID-19 patients.","date":"2020-04-24 00:00:00"},{"id":"84969761-5489-4b13-af7f-07a03d61a79f","text":"Comptes Rendus paper by Changeux et al. (\'A nicotinic hypothesis for Covid-19\') proposing nicotine-receptor involvement and suggesting nicotine could have preventive or therapeutic implications (manuscript received 16 Apr; accepted 18 Apr 2020).","date":"2020-04-18 00:00:00"},{"id":"5184abd3-903e-4c4a-b1ff-8197c81ef5af","text":"Public reporting and official statistics showing very high vaccine uptake among older adults in the UK by early July 2021 (large majority of elderly vaccinated).","date":"2021-07-01 00:00:00"},{"id":"149ba182-0084-4f85-90d7-0f84d73ce5fb","text":"Ukrainian statements in late June warning that failure to stop Russian aggression risks broader geopolitical consequences (coverage in Ukrainian press)","date":"2022-06-26 00:00:00"},{"id":"b3395c9b-a855-4632-996a-a6880f01d05a","text":"Regulatory safety updates and post\u2011authorization adverse\u2011event summaries published by national agencies in June 2021 (compiled safety figures made public)","date":"2021-06-11 00:00:00"},{"id":"2d9d5a49-133f-4abc-9974-c9e6da8ea584","text":"Publication of Israeli real\u2011world vaccine effectiveness analyses estimating infections, hospitalisations and deaths averted by the national vaccination campaign","date":"2021-04-24 00:00:00"},{"id":"c9602f84-6cfc-428e-a39a-1e39f3036e63","text":"U.S. Fish and Wildlife Service listed polar bears as \'threatened\' under the Endangered Species Act (ESA)","date":"2008-05-15 00:00:00"},{"id":"039043c9-c57b-4e89-ba4a-d25747c93f7d","text":"Record-low Arctic sea ice minimum in September 2012 reported by NSIDC (new modern-era low extent)","date":"2012-09-24 00:00:00"},{"id":"6d93bf25-6d63-4bb6-a61c-e45006074172","text":"Natalie Jaresko was granted Ukrainian citizenship and appointed Minister of Finance in Poroshenko\u2019s new cabinet.","date":"2014-12-02 00:00:00"},{"id":"fa2b9915-d0fa-4520-ae95-970cb5f1f2be","text":"Kateryna Yushchenko (wife of former President Viktor Yushchenko) is publicly known to be American-born (born in Chicago).","date":"None"},{"id":"6c40ede5-fef0-46a2-bc20-6d2a842bfe85","text":"Reporting that Ukrainian authorities and units were struggling to vet, equip and deploy newly arrived foreign fighters.","date":"2022-03-07 00:00:00"},{"id":"d0f7b228-5da3-499d-ba68-8e855018863d","text":"Ukrainian president announces creation of an \\"International Legion\\" and publicly appeals for foreign volunteers.","date":"2022-02-27 00:00:00"},{"id":"6a6ef44f-4724-4794-aed6-454d1bb76673","text":"Analyses and warnings about the presence of extremist and fringe foreign volunteers (scholarly/think\u2011tank reporting noting far-right and other fringe actors among some volunteers).","date":"2022-06-24 00:00:00"},{"id":"c8580ed9-0a2e-4ce0-b659-b31678de8084","text":"German industry and officials warned that proposed U.S. sanctions (and pressure) risked harming projects such as the Nord Stream 2 pipeline","date":"2018-04-24 00:00:00"},{"id":"ec856f56-f10f-4dbb-a15b-27af935ffb06","text":"German Foreign Minister Sigmar Gabriel said sanctions on Russia could be eased if there is progress on implementing the Minsk agreements","date":"2018-02-17 00:00:00"},{"id":"ba6da7d6-7796-4008-a2b0-f496bf1d045a","text":"Chancellor Angela Merkel publicly urged dialogue with Russia after Vladimir Putin\'s 2018 re-election","date":"2018-03-20 00:00:00"}],"claim_clusters":[{"cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","members":["2dd13f4f-6426-4ac8-bd65-7ffb771370ad"]},{"cluster_id":"d7e9e6ed-b598-46a7-b7ea-6197df41d3ad","members":["f8b55df6-b25d-46c9-8f4f-c5c18799922d"]},{"cluster_id":"9d2cc997-e857-4b80-a227-cc6a1c61d16d","members":["6699828d-fb58-4517-baf8-bd0a114db78f"]},{"cluster_id":"5b34f4e8-867e-44ea-b5c2-c5295a09dd5e","members":["e27cdb49-5cc6-4d83-b740-fed69da1a64a"]},{"cluster_id":"854e712a-9c33-4e4e-be9f-d9dd40fa0112","members":["fbade069-95a0-4972-bade-52d4ac0638d8"]},{"cluster_id":"5d4f6733-5fbd-48ce-8468-590ebda279c7","members":["a3c090d0-0f8c-4dbd-aa26-87ca72378ff7"]},{"cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","members":["d6814ea5-c714-48f3-818f-cdcb5b6381e0"]},{"cluster_id":"2ea5d498-58e2-44a4-a51a-95bda7047686","members":["30728e5f-3db1-4c1c-befe-fbd1f7103a82","14f6527d-67cc-4960-8e60-bf244deff220"]},{"cluster_id":"6f3f0719-064d-478a-ae5f-d9aca0368d4e","members":["8d8470bd-ad2d-4dd4-adf5-eba8481b1e3a"]},{"cluster_id":"a5210919-ca86-4673-97e1-5b03ea7de143","members":["4de477ea-5b7b-45a2-be59-cf9bec7b2733"]},{"cluster_id":"76bc71d7-2c17-42b9-974c-d517911bab56","members":["3e5ff83b-0092-4c6a-b1d4-b3d8665c952a"]},{"cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","members":["bdc1437f-ed3b-4d98-b2c1-38d4365c70e6","0d4df62b-b694-4ca9-9337-0c8818b221ff","007d3cbd-daea-4b58-be01-f7c97d00c088","3936ffc9-8f11-4f63-9703-b7ede8f9de85"]},{"cluster_id":"601320a2-3fca-41ef-9387-a64a4c0b5cee","members":["d8d7bab0-1ed1-4bdf-8ccb-706d4da8ae8d","d9870079-2f16-4d1a-931b-bda57bea23e9"]},{"cluster_id":"478db2a7-a90d-4fbf-8954-0416daa97dcb","members":["29d4d54d-b45f-428f-9434-a2dbdbf76fdf"]},{"cluster_id":"a222dd36-fddd-41d8-956d-d735c7c4c6bb","members":["0424510d-cbfe-45c9-b03c-be316dbc1185"]},{"cluster_id":"c39e0166-c55b-4f71-8bb5-e23985802606","members":["3e01682a-99db-4588-812c-77898c084078"]},{"cluster_id":"8afc9e85-7241-4e3e-a1d2-c084e17d6f92","members":["735326d8-274b-43f4-bede-c04b3f51ff7b","1146bc76-1dfa-4bdd-a2d7-a97508b0ea72"]},{"cluster_id":"bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c","members":["57794fdf-6b32-4749-8b39-f7099cf8b282","d5dd2789-974b-4cac-84f8-12d91fe6053c"]},{"cluster_id":"b40ccc38-63a5-4a58-8bbb-6242768fb158","members":["255a4d2c-14ee-4bb3-88c2-3d03d8e031cf","b4889e7f-f86a-4fb9-819f-ef05968c529c"]},{"cluster_id":"6f9a5f86-ba12-43df-aa33-746615605f47","members":["3026b8de-985a-42c8-9ae3-d374746eedcc"]},{"cluster_id":"24a2e46d-b5a2-4677-a613-c39e311e8f1d","members":["1d8fae5b-ecc0-45be-ab13-eac5e4e79825"]},{"cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","members":["633ba20e-618f-46e5-ae02-75a3ffa9d1d7"]},{"cluster_id":"9d400cbf-08ea-4c02-941a-80cd2d3e517a","members":["ab0f775b-320d-44f7-ae2e-848211e10868"]},{"cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","members":["2361b0b7-d4fb-48be-a1a3-3f8003756366","0be7d364-75a2-4715-bfe6-b1ad97691bb5","fdd99a5d-dc39-4dd3-b1be-3a0f181eada2"]},{"cluster_id":"576d103a-5318-4b16-9313-434ff03a385d","members":["9d2a365a-6c46-411b-969d-d47a368e94ee"]},{"cluster_id":"3e200fec-9dad-4a2e-a5e4-655848ec7983","members":["f00ef639-900e-41c6-8781-9b27223d4353"]},{"cluster_id":"bfd3bb04-3c5a-410a-b26b-81f569186264","members":["7eb3a987-b322-44d2-b3d6-28c94d19b5d2"]},{"cluster_id":"b0c0fbc8-3a87-4290-a45f-69e062e04cee","members":["2dea096c-fd10-4480-803d-899cf695c6f5"]},{"cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","members":["c83fc427-5b49-4136-ac63-a6e82c9a6e68"]},{"cluster_id":"98a97f12-7d1b-49e9-8178-578b2d656f88","members":["25e64931-13f1-49ca-bc59-c9b3ea3df04a"]},{"cluster_id":"17c8775c-7a3a-4607-aa7f-5b24078a17f8","members":["ac7a6f3c-0121-4422-b49f-f6891df024f0"]},{"cluster_id":"df5cc82a-7ab7-41f6-8eae-c3445a8c7a05","members":["5d4a7f9d-370a-43f6-90d8-da41fa28b5bd"]},{"cluster_id":"5d21e7b3-dd0e-453e-8871-eb57102f00e7","members":["3f39fca1-a59d-4b69-90c6-21f814dc1270","216aea1c-b87f-4e12-be73-6f1d3ccdd66e"]},{"cluster_id":"51218502-220c-4467-8b26-b12d809fed98","members":["a4ec243a-71a4-4609-9a28-20d5f55f2c22"]},{"cluster_id":"96b36beb-a890-402f-9101-7aa7236863f1","members":["dd4e8c50-a762-41da-9994-99bdacd1c496"]},{"cluster_id":"bf1e5943-1881-4795-9e54-b7177a49b67f","members":["6eb1ba10-7e64-4410-8b77-b1f6131ff9d4"]},{"cluster_id":"dcbf5711-b1d2-4a7c-96f6-e8916f52c752","members":["38e14696-6be8-4733-897c-92ef59e9e984"]},{"cluster_id":"6aa59122-6821-4e76-8afb-2ad2b679a5aa","members":["f3ebd398-1ed0-4277-a8e8-14809c410ad5"]},{"cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","members":["938f6495-4d57-4ad6-94ce-863e8c50767c","8f8edbb5-e9e4-475e-90be-05f42d84a1a4","c73cc4c2-ee3a-40b7-aebb-35016faadea0","5562da73-c4f7-47a9-913d-2c215d69d25f"]},{"cluster_id":"43c40092-a570-4909-9a7c-2090f95182b4","members":["ff5ceed9-e757-4049-9059-07cabd2cf427"]},{"cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","members":["75b46fa0-cd0c-47a1-ab63-254ba2048ab1"]},{"cluster_id":"7fb4d786-0c9f-4d33-a3fb-8326f548d1e1","members":["b24a8a34-1afb-4438-a723-682fc5881418"]},{"cluster_id":"a9555cd5-7b65-4e84-9f89-ed03117c7e50","members":["85054e1d-aaca-4e4b-a973-d45747596c08"]},{"cluster_id":"9ca308d7-59f5-4df0-a87b-383b8575c88a","members":["72b56f8d-ad65-499b-a35f-204e110ed4f9"]},{"cluster_id":"947a0b8b-01e0-44c9-8ebc-c9da3eecde20","members":["67c33492-0941-478a-b43b-9c6c098446b3"]},{"cluster_id":"260b5cb2-3dad-42a1-a677-cfe24a203765","members":["14495f04-0a36-463e-8cac-99aaad053837","41c44f05-82ce-4b19-a650-b156f05efa75"]},{"cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","members":["f5ef64d6-4fc0-47d8-82b5-1d1453009204","427063bc-a537-4e80-a198-25b80179f288","f3fc68de-4d62-44bb-b25b-67ca2e4c5aff","1b4a2485-6962-4b36-8c3c-da83d1b18b70"]},{"cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","members":["f3805476-152f-4654-8435-8e4eda6f5ca1","ec947ed8-cc30-4eaf-8c9b-b928ea7c0068"]},{"cluster_id":"62d8fa29-aaab-4f66-9532-5fb34686e56f","members":["6f4ce223-338f-4a9d-86ba-d7426feb6a92"]},{"cluster_id":"d1c29947-a7e4-41cf-9656-837e51b2de11","members":["16b242fa-af97-47e6-8018-f63b40206b6d"]},{"cluster_id":"a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0","members":["a716ca45-b87f-4206-a22b-5e39e95ad953","7ee5a1fa-d164-4c90-a9aa-bf34d284a6bc","e5422914-be7b-4e48-a015-d663782e09ff"]},{"cluster_id":"33d1d4f9-5c45-44c0-8055-973e47d10907","members":["eae4b366-03da-41ec-a57a-cdebad1dee6f"]},{"cluster_id":"15f89230-b855-41bc-bc6f-7a68ea38aff0","members":["55cdc9d6-c77c-4770-86bf-4cdba85c8b07","9344c21f-e46e-492f-bab2-16d7ac5170ec"]},{"cluster_id":"767386e5-6b6b-4b02-8200-421222dc2720","members":["4d14b98b-05d6-4e63-a6ba-271d2f3cce83"]},{"cluster_id":"8610b5a0-f4b4-403e-94e5-57543da5eb32","members":["99f1aea2-02cf-4c31-88f9-42d9a3852e82"]},{"cluster_id":"2bc0b07d-c668-4651-b1c3-1844786b5acb","members":["48a13c83-219f-4cd9-b810-08909a8bf658"]},{"cluster_id":"666eb0cd-c596-43b7-a4bb-b7f35efd20da","members":["83d96580-7bb0-4e87-89df-9c881df71f99"]},{"cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","members":["1fcaf67b-c9d4-4a01-84e7-ca7f4a7e821b","7239e2a8-d011-4bfb-8aed-0a709402fe71","e0a5f231-75c6-437e-9eb2-f531cff87bb7","88a9b2a2-df3c-4e15-b439-11ecdb30f599"]},{"cluster_id":"f2363c7c-72d1-4e3a-b724-27c1d218c5fc","members":["f4764696-2605-4a43-b5a6-6bbf1d924003"]},{"cluster_id":"e8e14c71-2e64-412a-8769-000c5cda92ce","members":["a5abfd89-4a0f-415f-aaf0-91910c09c87c"]},{"cluster_id":"76a80e87-389e-4e6e-9595-1b220839fd20","members":["33680438-c7ab-4fcd-a771-3945d3bef0f7"]},{"cluster_id":"aea747b1-1cb4-4b3d-94df-5c33181b0976","members":["a3b34be8-6b96-4f4e-a354-cc5b2da887d5"]},{"cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","members":["6d400d4d-0b03-4ed8-be63-42efcf94ad65"]},{"cluster_id":"70534501-50ea-4dc4-9324-20539116bcb4","members":["c3634205-e3fe-4f6e-9305-71a997a86f33"]},{"cluster_id":"2a9019de-d820-4155-a78b-fc972ec57552","members":["e22c321d-c58f-4c33-bf80-69feae1815b9","f22dd4d4-244c-40ed-8a4a-66bbd3e6650c"]},{"cluster_id":"144a5089-d891-40d6-b31c-9c5381bee1d5","members":["24666e81-30f7-49a8-859c-d475e369c574"]},{"cluster_id":"03ac5e38-07fa-4023-b9bd-bdfc9810ba0c","members":["014c9faf-7ab9-40e4-b5e2-ab52af450862"]},{"cluster_id":"7938e6ef-80ff-4f50-b301-1e5bfc0774b3","members":["421e076f-843a-48a5-9a05-70bd6ce8be1f"]},{"cluster_id":"29d5756f-2c13-4cfb-b4e4-f439665752b9","members":["1774fac9-00c5-4fe7-b984-d6e29f173b3b","26523ffa-fb97-4562-ac10-420a038c9930"]},{"cluster_id":"b39e93e4-b791-4b1e-963b-d8f068ff0b1d","members":["9980c0d2-1404-49fb-a64d-b383664e39f9"]},{"cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","members":["a4765b18-7063-46d8-81d8-8476b2372331","32156e6d-316c-4228-b1bb-e4431b9f63e2","bf65226e-9669-4774-9ef3-570fbefeee38","14cb414f-ab88-4bba-a113-ee4dd72a7f1c"]},{"cluster_id":"d65c0d37-123c-4e39-9b2d-386613952a30","members":["9658b913-ceca-47ae-aad5-58877e1f4129"]},{"cluster_id":"71baf4d7-69f3-4524-9166-04fc35b4043a","members":["48a2defa-2a7d-41ab-9978-ec2d542176bb"]},{"cluster_id":"10cadbd2-7261-4295-9f88-df0f9a246b5b","members":["6c59ffd2-ce73-48cc-a300-744f6681f391"]},{"cluster_id":"f6a4aea6-92b4-4a70-a984-2326df1ee39e","members":["1b076485-e52c-4e15-83fa-3b97314161ad"]},{"cluster_id":"8a0c21a3-b47c-4676-b965-59f7699171ec","members":["ff7ee790-b265-4df5-ac00-39ccfe0170f0"]},{"cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","members":["008054d1-a07f-451e-803b-c9fb1c433e4c","54d4d5f8-b5e7-4362-ac10-def756c33689"]},{"cluster_id":"c6c8d065-8cfe-4224-9bcc-58df52f1a712","members":["6370015a-2183-4030-a2df-2b7769299fb2"]},{"cluster_id":"4e78b61e-317a-4417-b42d-464646384193","members":["1d0f2284-348e-4c83-8ce5-00731b733baa","3318f9ef-2c09-4485-ba0e-7a99ab035874"]},{"cluster_id":"e60065d4-ae50-40b0-8e77-8c2ad3e36235","members":["ee91da76-0c5f-40ba-9880-7e2b3cab4d92"]},{"cluster_id":"2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece","members":["488db398-b0e9-4d0f-b7a9-a7c9ae9505db"]},{"cluster_id":"a7043201-daf7-4ddc-86e1-fe3a850942e2","members":["f3faae8f-983b-4e63-9882-f25a25683959"]},{"cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","members":["6fd5984d-f566-40fc-bdf1-dd1142fcf39e","6ded1b12-376a-4451-8314-cf0630d9ad4b"]},{"cluster_id":"b4295bad-3940-4b00-ac2b-862c41b5597c","members":["8ffe5fea-1c1a-4af2-8604-de9174b2b2ff"]},{"cluster_id":"371b7329-3c6e-4297-b746-d77ae2db1f6f","members":["2a41015f-41b6-462b-9def-77dfe9cc7087"]},{"cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","members":["405b64fa-d3ac-4ec7-8bfb-15796d682cda"]},{"cluster_id":"4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8","members":["fc3a68ed-50cd-4532-b10b-94792d272195"]},{"cluster_id":"4d4a5a78-bde2-4ed8-943c-811738978e0d","members":["a2ba5697-2b9f-4b17-888e-0069ad71ff63"]},{"cluster_id":"05638bd6-42ef-4049-b6f6-4a5478e7b8a5","members":["e627a037-1cb0-4aaa-bf67-beaaca0ccfd3"]},{"cluster_id":"907c652a-92b6-4282-8b7b-0e7b268d4209","members":["2625714f-905e-4ecf-8b4a-09b9f0b7d704"]},{"cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","members":["8769ff38-1ce9-49aa-a968-179abff90664","34260db7-2ee9-4791-8c3a-2850e0eb9f7c","9d59eafd-dac1-4668-b3a4-5267c5102263","b860c9a3-51aa-4ed0-8d64-fa0098aca589","08ae05df-a1ec-493c-9222-3436a91c88e6","241a075b-b47b-4cdb-a812-edbf0a89feff","1e091d8f-eedd-4c4a-b128-1d8c08550b36"]},{"cluster_id":"c14aacf1-2f99-4e9a-ba35-1511bf4fd104","members":["3090ccd7-4429-4282-b507-a1d1ef4630a5"]},{"cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","members":["44024130-7111-4965-ba3b-ba55689def86"]},{"cluster_id":"f4f83538-936e-4149-94c2-66b6b2ac2571","members":["36e7cc9a-2789-4d66-a2dc-cef8cae9c4de"]},{"cluster_id":"a5124b94-6b98-447d-9c53-5100339210c5","members":["15ed79b6-2eb9-4164-a1a4-467f9b7b0b06"]},{"cluster_id":"9a73096a-390b-4f9e-a044-22f30734ce69","members":["0ef16c5a-76af-4d0e-9da7-79552051db26"]},{"cluster_id":"7ad2c49a-5636-41a0-bf37-19bfc98916c1","members":["369e2eec-1aad-41d6-b4db-37834e7e576d"]},{"cluster_id":"9b14cd61-494b-4ae7-a7c2-3720adae8787","members":["9e50f9b4-d7de-478f-b73b-ceb97b2f3b49"]},{"cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","members":["5ea10b5d-ae66-41c8-9896-2456985b0a16","22cddca1-b8a5-487a-9a1d-e468a1090200","e71a3ce7-7f1e-43f3-8da6-a130a2789a80"]},{"cluster_id":"54d52770-613a-47b1-aa64-0743cb644791","members":["fe1308fc-cebd-446f-aa58-03dfcd2677b7"]},{"cluster_id":"6f847ace-00e0-4009-b5e9-3729f7a9e244","members":["8c5c9816-2706-4384-90ec-5e9bbe788a7c"]},{"cluster_id":"2a0a6106-78d5-46ad-ad52-e0296bf7134a","members":["5f2a5eee-de1d-4f97-b32f-6c009a0199c8"]},{"cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","members":["8a041bee-f597-4ec5-90d6-abe85921d8c7"]},{"cluster_id":"fa530a1e-4be0-417c-bd45-2254a93d2324","members":["32295a18-4d4a-4a8f-9ee2-2ac75da02623"]},{"cluster_id":"273554c2-556d-4017-8422-f543fd17c4ef","members":["e33a6869-5d82-49ac-9098-dfa14bf71c71"]},{"cluster_id":"859c814e-e7af-4708-a58a-9f1f6973974f","members":["a9197e3e-a551-405a-bb28-fb13d389a62a"]},{"cluster_id":"407486e4-c133-4139-9739-41644f65fa24","members":["96970192-557a-4f02-91be-828d023f6d42"]},{"cluster_id":"346be717-a4b3-4210-bff0-be972806b6a4","members":["941aa92b-0585-4e26-a11e-56729498c38d"]},{"cluster_id":"6719c4cd-0e09-4c15-af9e-7f2bffedb3e3","members":["8503fdc1-5827-4df0-996b-b712232be44c"]},{"cluster_id":"fece6aa3-8787-449b-8b29-7c6c4bb28cc4","members":["ed0e3090-b70a-4b95-a165-cff164f8ad3c"]},{"cluster_id":"d392695f-75b7-4bbc-a991-2b3edbf01567","members":["31568ed6-d43c-4f68-b1e8-de4e1a916858"]},{"cluster_id":"957456fe-cb84-4fb9-bc2f-3e775154a824","members":["133f7d66-3c77-4da3-9b55-5fb9bdbf0e5c"]},{"cluster_id":"7811b1ac-b0e5-4c92-a933-500f6b892437","members":["2939a802-435b-45e7-9b5c-c5d0ac1ea5ef"]},{"cluster_id":"22874c8a-79fa-491a-a46f-cd92202bb1de","members":["0fac4e8a-db01-48e8-8e45-430e582f167b"]},{"cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","members":["5f0a5b6e-bda8-4624-a3b2-e9f281dbdf4d","1f726340-0f86-4d17-97d6-78a6f17df1a9","b42f4cb2-3538-4752-bdb5-ef52a30c50cc"]},{"cluster_id":"0407f887-a8ce-4c09-bc8f-570e66bd3e6b","members":["17e194a6-e388-46fd-9679-5eef686c73e5"]},{"cluster_id":"58a60e5c-9e5a-48ce-a07c-a7168b46ba2f","members":["cdde802e-a707-4b79-b972-73d645632c9d"]},{"cluster_id":"83965363-a851-4083-ae10-33f90da464da","members":["36b55499-9dde-45d0-8026-de7b1be48c8a"]},{"cluster_id":"1e099dec-1be9-48be-a1bc-00d89e3cc02f","members":["4d999f2d-af0b-4fb3-beeb-e7dbedb25424"]},{"cluster_id":"e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9","members":["258dfc02-dfdf-47ae-a212-a94fe1bd2b3f"]},{"cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","members":["8bf3adb8-0a8a-4311-8668-c3f1ced00528","c632fe7b-c702-4532-8547-784867df7f95"]},{"cluster_id":"a03d3de9-e5ad-47e0-9374-17e6c1998859","members":["6b07104c-66a7-4e14-9a76-a4b097a9082f"]},{"cluster_id":"a0b96ee6-2ea9-4035-b542-1107b0662e77","members":["24ecdd06-3496-4652-9275-eaa3f5d1d57d","2521adfa-8bda-42f8-bac6-02fbee2d28c5"]},{"cluster_id":"c8a67d7e-6b5c-49cc-b944-ad699ac9cff0","members":["f4ccd130-a946-4cd9-acbe-d171042fa1cf","07e8ef3c-b9bd-433f-9c12-4fbfc99e8481"]},{"cluster_id":"cdb08998-bbe0-4530-9534-7744fb962961","members":["d37e60ce-d379-42d0-b2cd-4f1eced529f9"]},{"cluster_id":"6950bc54-67bb-4e8e-b8cd-afd5c7d79d00","members":["65547e4c-1e4a-4a9f-8cea-498fa9a0a9ab"]},{"cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","members":["9fd1f789-a0bb-4e1f-b049-836033524d91"]},{"cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","members":["030c7378-cdeb-4204-9fb5-c2d2a13eb381","67e7e226-46eb-449a-b97b-11d2bb7990a4"]},{"cluster_id":"8143472f-9ddf-4467-8402-c46a70ccaf1e","members":["32b326b4-cfe6-46b4-b072-bb631dc1a035","f5ba79ec-ebb7-4b0b-b3d3-d8ef07952c7b"]},{"cluster_id":"b473cdd9-7369-4866-a926-04d86eb03c52","members":["0f3f4f2a-f380-4606-a16a-f3f4a09b5cd3"]},{"cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","members":["94cf5bc4-3fec-4cb8-8682-39ab0c9e9fe8","4d7b5e3d-682c-406e-84d1-1663d708b648"]},{"cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","members":["2f0f76bf-5aab-4dcd-b7be-b080f0e53220","a8f44394-f854-4c61-93e9-f08fa0649e2d"]},{"cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","members":["567f28dd-3ff7-4c5d-934f-c8951a7a3fc3","350050bd-a85a-4627-9297-e06afeb9261c"]},{"cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","members":["f2d96131-771d-4235-8f08-f3459b6cdcaa","3835bf8b-7501-4921-a504-e1f225fd8897"]},{"cluster_id":"cb25f623-bfdb-42c7-9873-fa48f80feade","members":["d7ac50a3-5ec4-4aa1-84b4-24d20c65c879"]},{"cluster_id":"77b557e0-b37f-4548-adca-2c9da9e04106","members":["b2f53ef8-1f48-4ce8-859a-e17b854f4683"]},{"cluster_id":"596489a9-6207-48fb-8cf4-2972a01326d9","members":["e65f1db1-d1aa-4982-9c7c-ec7daf4c88f0"]},{"cluster_id":"7698cb38-d25f-4849-ba30-99dd8e321533","members":["17259035-6c05-46e1-8f59-227f29b9c868"]},{"cluster_id":"9769a072-502e-4c26-bce2-57d4532d25f3","members":["c5048780-7c72-4d06-92f0-0a9ca1febeb3"]},{"cluster_id":"f0be01ea-d71b-4521-a52b-360c419bf286","members":["ac700103-fb9c-4fa3-8f17-e0d56a13ff26"]},{"cluster_id":"62e8f214-855a-45b7-8de5-a667d22dd7f0","members":["c3ccf30f-859c-4953-ac43-46d07b1fceaf"]},{"cluster_id":"98dac116-c6f6-46b8-945d-1ffe5cc5db7d","members":["e2969ce0-1fdd-4372-9690-7a254eda30c2","132f6cc9-f538-4c83-9617-8e62245449fd"]},{"cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","members":["697d695e-133f-4537-b15a-ada62b39e9ee","c8544f91-d53f-4fcc-939c-fe97e55c2b45"]},{"cluster_id":"338d5a8d-64c7-4bed-a37e-208196096015","members":["ffe65426-7493-4d0e-8c1b-da74a680ee17","9179a5f8-b7f0-4e62-8586-1a710c219f83"]},{"cluster_id":"ff92e2cd-b51d-4aba-9214-602e53d602c6","members":["6771039d-6c9f-4e75-84b1-565146a5b4b8","93327c19-f8d6-4cdc-a139-dead675a14cb"]},{"cluster_id":"d4dddb84-da14-4d5c-ac75-d999175b9558","members":["0a54c9e3-ab86-48a4-afc5-c00ca411ca59"]},{"cluster_id":"6926f592-0807-43c3-9eb1-74f903b009ff","members":["20447d43-60ab-4c29-bb62-2cd5e30f2991"]},{"cluster_id":"31cda056-0942-4d05-8579-66ba52eb0c7b","members":["7776d932-bca4-4232-a584-d33417e3a970"]},{"cluster_id":"a98eba10-9612-466e-bbba-6161ced90ab9","members":["16139180-2568-48f4-a5d4-86827015c935"]},{"cluster_id":"419a274e-afb4-4935-a491-f22b25792b9a","members":["b127fa85-ae98-4f2c-914c-0ec7ad3cc5df"]},{"cluster_id":"2f43e86f-24fc-4c3c-a77d-c5abbf46ef19","members":["e0bd2a14-1e6e-43a5-8a9d-ee6e1e28ceff"]},{"cluster_id":"886176d6-1057-4021-8312-570a3e3f4e10","members":["8e267560-56f4-452a-93ad-891b3c022aa4"]},{"cluster_id":"6826010f-2a38-48a2-a358-b062edaa9ed4","members":["5b87492e-f8bc-4b16-a83b-cd3ffd662321"]},{"cluster_id":"3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1","members":["e3f63fc0-40a8-4139-b45f-b65461c8b237"]},{"cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","members":["26e46f4d-5516-4ae3-8550-8b46fcac1abd"]},{"cluster_id":"761efa26-8da9-4e7d-a7d6-a4e67c04fce5","members":["14a22516-14a3-4e36-8cdd-74e064f7c3fd"]},{"cluster_id":"fc93709e-88fa-4e26-963a-2d3fcd9cde24","members":["4a2e4b95-6228-410f-87ce-26b326d2ed7e"]},{"cluster_id":"d07c5569-3547-4153-bb09-72f6d513ab57","members":["3c95092c-ff32-41c6-8efc-25cb0178c28c"]},{"cluster_id":"92ea76c7-4dfb-45af-849a-ece7083099c6","members":["1d044881-dfe8-4305-ad28-8f2e00ede837"]},{"cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","members":["6b6599c1-2cbf-4074-9936-6b7a7e6c19b5","5427876d-716b-4769-8748-2063f30c794c"]},{"cluster_id":"d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce","members":["b1862fbf-0847-4700-a44b-5e4acc6e83e5"]},{"cluster_id":"17a4104c-d678-44ba-8ae9-fd050d042961","members":["e160bd83-d2cd-443b-b281-8dcf13391611"]},{"cluster_id":"dd658abf-fc5a-4105-b976-357ecd016b6e","members":["6079acb8-4b45-4576-b047-34cc48dd3ae3"]},{"cluster_id":"1f956691-257e-4b52-8536-1a80ad662f9b","members":["f16f4ed3-b0bd-4d2a-95c9-3e274f0fa999"]},{"cluster_id":"1e9c3202-7611-4885-bb24-d9dd05b7eed3","members":["93ab0059-d11e-429a-b043-e435315e618d"]},{"cluster_id":"bcc58315-e1c3-44d9-8dc7-b3967b315e01","members":["149e0a0a-9b35-4fc6-b371-9576278ac3b2"]},{"cluster_id":"25a85f3d-1037-40c8-8b96-32b80bedc5b2","members":["c6015b39-2772-4ca9-9429-6a2fe456ee32","d30faa66-0ea0-482d-ac2a-7fcfdc7697d2"]},{"cluster_id":"cf6e572b-b045-42a6-b196-8d36d7693937","members":["39898d3c-26bd-4aa9-8a59-079a2126ae08"]},{"cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","members":["c7d2b250-f4c4-4684-b677-d6432e875d3e","85ce5b6f-3f89-426a-b5a2-8d84eb7699e1"]},{"cluster_id":"fca1885c-50ee-44f0-87aa-917cc35fd733","members":["3bb92e17-0489-4a5b-8099-61c3f5cf031c"]},{"cluster_id":"93eceb5b-454d-4e3d-b632-57c5588aea34","members":["46f7ef2c-a1b3-47cb-b8e5-645e4208bdb3","98071d1d-2071-4798-881e-ab5ac7c805c0"]},{"cluster_id":"a4400c47-658a-4ca0-9b29-fa8384838731","members":["26609638-fcc1-4b4e-89f4-60dec798d60b"]},{"cluster_id":"de700722-a9e2-4659-a181-3fb83efdd41f","members":["0b8df3f4-5271-428f-9336-8febdb1c264c","6bed48b2-0edd-431f-b71a-5f9ac3911493"]},{"cluster_id":"487393b6-56b8-4c3f-bdb3-88dbd2ac69d5","members":["24f83920-b618-404c-b49e-4adc756dedd6","fb0330ef-17c9-4066-bcdb-a7dce2c66aa6"]},{"cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","members":["166848c8-967e-40a4-8078-5821ec4e1929"]},{"cluster_id":"63024d1d-9398-49ae-8b27-efbfa0bffb4f","members":["e8cacb37-ea33-41f4-89f7-c7e6896b5a2f"]},{"cluster_id":"30f557eb-c83e-4cb4-b405-ec14f06f223d","members":["7e445445-ef7a-4933-8775-3e116ffc0192"]},{"cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","members":["f4b96ae3-a77d-4ccf-b96b-3b941f8b725f","e8a2b3a6-e7d5-4b94-a0c7-f91a8ea464c4"]},{"cluster_id":"50dbe9fb-6818-4777-990a-3ab01ab3659e","members":["faf88ade-24d7-4dcf-9599-5c9145f550b8"]},{"cluster_id":"d669c1ac-c710-4975-98db-1c778f28ee4c","members":["98ac321f-c36a-4bbd-ad93-609c6b5ddb69"]},{"cluster_id":"81238869-957b-4b83-948f-2551b38a7039","members":["41785fe5-5666-4005-b763-59f51cd8d1c9"]},{"cluster_id":"5da699cc-92ad-44e6-a24b-61100072b99f","members":["f705b36b-4f34-4a2b-a921-345967b48d1c"]},{"cluster_id":"e1572e16-5f85-4ebb-a6fe-2ab18bee1c48","members":["1ae9d1a6-7fc2-4779-b879-49a536c35b4b"]},{"cluster_id":"e9c84dbc-30d1-4e60-bbc8-700057190615","members":["d04fd66a-e811-454f-bb67-150f8782a32f"]},{"cluster_id":"3444a924-096b-4eda-877c-4c6412d885cd","members":["1d04e2f4-99d1-427c-a120-3b1a90135057"]},{"cluster_id":"7b0fb73a-9488-43a9-80ee-d1864bcbae49","members":["05cbc7b4-f6f2-49e7-a208-e0e250d7094f"]},{"cluster_id":"804db45c-717d-4c1d-9494-73592da3dad8","members":["209d22b1-d632-4c86-8bbc-6d1632ddfdfe"]},{"cluster_id":"c0414ded-b694-4e4a-b7f8-d2835618be1b","members":["2f4fbef0-ba6e-4ccd-b127-74b59e645f35"]},{"cluster_id":"e21ec8bb-ddf8-4115-9765-9a2f72eed10d","members":["e1682584-bfb8-4e0a-8866-adb98da6eb8a"]},{"cluster_id":"9d6e8c23-1cba-47c9-9f43-333717df0abc","members":["7a396800-85d2-4b39-8dcd-a7c1c8e96efa"]},{"cluster_id":"dcf2ee53-8023-43ee-94fe-0207a7fb5133","members":["cb409fed-3615-4245-84aa-61987e7e0223"]},{"cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","members":["12f1fdfb-4d29-4417-a781-ada75566bb48","9f5d4982-9ec4-446d-ac05-eb1dbf28db7e"]},{"cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","members":["fd69119f-620c-415d-bf99-0291b228baa8","a90cf2b5-cc77-405a-83f2-ba43c67a3100"]},{"cluster_id":"e495e756-f14b-4c10-8358-f906f837fdac","members":["ad80062a-3d8a-426a-99d1-f421c7309538"]},{"cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","members":["79914c75-18eb-49e1-8e63-9f9f43ae183a","963a13b5-0862-4aea-b670-0d618cc0c9cc","6c33f8ec-8406-40fd-858e-87acce3e0b2f","59345576-3c99-4f85-9c22-cb7f2ee69987","16f59642-6b9e-473c-98f4-16e38037a32a","3a64efca-f394-4b04-8fd4-e08edd670201"]},{"cluster_id":"e35fb8e9-42cf-4ef0-a512-d7be06ad99e3","members":["c3321f84-7849-4d8e-b6eb-0027f9a1ef41"]},{"cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","members":["97f8426c-3bff-4027-9f2c-c5a7dac7d103","99c6fb0c-60a6-423b-a576-f2c16489097e","b622741a-4170-49b3-9c00-2d16333e3e02","db3e2d4f-8f74-418a-94d6-6dd00d5ff23a"]},{"cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","members":["8af5625a-8215-452c-8f8b-b4605c6bc63e","513ca3cb-280b-43ff-9a2c-b0a564e9be78","925e1b24-bec0-496d-b5b2-3b514260a124"]},{"cluster_id":"ed50b251-f205-4952-987b-aed1c0461840","members":["a1c9ba4c-ca08-4e60-8252-ff4a687a94f1"]},{"cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","members":["4b42f203-d8d2-42d6-b819-9fe659c2bff7","65250e2b-f109-4e43-b765-be530433a66a"]},{"cluster_id":"e2dae5ce-65e5-4bf8-ac38-f452e98e9363","members":["54cb9373-b32a-4519-8401-caf5f482e5f9"]},{"cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","members":["08f4a80c-2870-4d62-a929-85f354fbb3c5"]},{"cluster_id":"a3cec669-c5d7-49cf-9b41-ed9298b7642a","members":["43d583a9-a247-4b3a-85e7-9e73dddf6f36"]},{"cluster_id":"3051427a-61ac-4a57-816c-f2ad62bba5e0","members":["5edb0b43-d38e-4c4b-a67c-1463dcb6c043"]},{"cluster_id":"c076834e-92b4-4b02-8416-1f251021c0cd","members":["8f2ca6f5-b8b6-4cc2-949e-0128e53ca515"]},{"cluster_id":"96423d41-ee08-4c5e-bcf0-4dd1b431abc6","members":["a8184d7c-394b-43c2-907e-e063d4a08e0f"]},{"cluster_id":"2c72a6d8-6edd-4d3a-9563-d326950bc8da","members":["03713cf1-3285-4b14-940e-b471322c77da"]},{"cluster_id":"38a07431-3ca7-46f3-a1e7-a6118a43b742","members":["9f7a5a66-3cd5-421f-8c1b-3e79b685556e"]},{"cluster_id":"cbb443ee-8a98-4074-9a33-690c1a4267b8","members":["73a580b4-4b69-44f4-a8fb-9a6977e542a9"]},{"cluster_id":"ab9886f5-759f-416b-88de-b9f771cf04e1","members":["e37c83ce-38f2-4423-9a84-da573f0ffa3b","d11029f7-4dc6-4be7-b1da-5b28664bb1b1"]},{"cluster_id":"7faff4ee-fc9e-4ba2-8e8e-36906d88936d","members":["3cd10504-7293-4120-b638-019e2e0a6147"]},{"cluster_id":"4848ddfa-b6c3-4770-996a-7e5c266b5b88","members":["f82373f6-9aeb-4db7-9675-92beba087616"]},{"cluster_id":"54e59784-1db4-41f0-a651-2d5e2138670a","members":["7d43e798-e609-400b-a48b-8f931e3ce23e","712a2f07-999d-4c15-a8fd-cf6ec4475529"]},{"cluster_id":"bd9462e2-36b0-48f7-92f9-c83dd2ee5550","members":["199e9a4b-d550-4e3a-bcf4-9a72423619f0"]},{"cluster_id":"89cac161-a6f0-4315-a880-1662cae50313","members":["6e95ebe5-99d2-466f-8e90-0cc917b69a94"]},{"cluster_id":"f3288e7a-a54c-44d1-8307-67aafb47c852","members":["c57dfaec-26b8-4aae-a726-47206540ec37"]},{"cluster_id":"f597184d-050f-4a51-9461-70b55cf2b05c","members":["aec8b90d-d8e0-46e0-a3cc-bcf61de165d7"]},{"cluster_id":"388f4cb2-36f0-4395-889f-3dc07bb54aff","members":["9d0bf5b2-91bb-41d1-b08c-7bdd2e0e3914"]},{"cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","members":["53217b2f-fca3-4909-967e-1e550b446afa"]},{"cluster_id":"2f8d9d1d-f145-459e-90bd-ebf833c6fe60","members":["f8967d69-a71c-4143-a9f7-83da2fc9cc4f"]},{"cluster_id":"c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a","members":["c971afc0-c52e-446f-8f42-9d8541b6b917"]},{"cluster_id":"930ae324-24b9-4353-aa17-35d5e069f64f","members":["baa60327-2fdf-4fe3-9312-99063b128b4d"]},{"cluster_id":"d2231d7f-5f03-4e76-b0ae-753fd54f4960","members":["78a45dbc-288c-4c0c-b746-47886b07ece5"]},{"cluster_id":"6302b733-5c75-40a5-a618-05d435c65be2","members":["16809459-35f7-426f-8329-a9c34309a67f"]},{"cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","members":["7a992198-c084-4876-b592-bf1f92cd55f1","f9bcc584-69cd-4b2b-a377-89b89ff8b19e","2994c2c0-f0d0-4e0b-9ece-0a4cdb450145"]},{"cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","members":["0b2c0175-e665-4892-bfbc-7808ae3dcb8a","e7eca5a0-30d0-431d-b66f-c8a1d6599ee5"]},{"cluster_id":"e7a774aa-82c9-41a0-9af6-f4f143016a1f","members":["8b584ea9-0889-4650-819c-54e341fdef62"]},{"cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","members":["094fbd3c-b35a-4c20-b0e0-214fa2f585c7"]},{"cluster_id":"d88ab7ef-052f-4839-b4dc-054794d4d289","members":["cda1a8e2-20e9-456b-b935-56edcef9cc47"]},{"cluster_id":"0d796efc-696b-45a8-bfd5-83987987e1ff","members":["9f5ab2aa-1d48-4a0f-8b36-d1bc0279abff"]},{"cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","members":["07771d5c-00b5-4b1e-841e-7e892647c698"]},{"cluster_id":"27f40e5e-f571-4385-aef9-fcc4114989bc","members":["90a5dc53-7d12-4963-ac35-1f73db9e52e4"]},{"cluster_id":"58cd12d0-b190-4e1f-826a-20e181a5c137","members":["e8f9b3de-5f77-45bd-a686-624be386842d"]},{"cluster_id":"a38c8b34-2d1e-4ee9-ac98-b7d045e07fb4","members":["0c24e548-0e2b-4979-93c1-c712a466c2ac"]},{"cluster_id":"e4ac4a3c-288d-4beb-9f3a-d8f26ff2f9c7","members":["9b2a0766-5559-458f-8740-214658f06894"]},{"cluster_id":"83ec8695-6d93-432e-a8be-81705e2e2a54","members":["a3c82ec4-1e3b-4b66-b0fa-725beb943034","80c32eed-7994-498e-84b0-b0a8048e0b19"]},{"cluster_id":"ac926db6-b36c-4519-9b56-13482c4acbd7","members":["a9e3760a-e3c6-406c-ae04-bff0fcfe20ff"]},{"cluster_id":"d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b","members":["431e486f-195a-4068-accc-839f3d5f6916"]},{"cluster_id":"c0057031-5868-445b-98d3-d536042f59f2","members":["68d0e0b1-9767-4047-b61c-46dfc5481041"]},{"cluster_id":"ab72f353-1b68-44ce-979f-a10883b99605","members":["77995af2-5f23-43fc-8391-2d7c615e9e55"]},{"cluster_id":"16e980af-79a1-4255-8ad0-56ca61ae3b8a","members":["af260482-351c-4dd5-84df-a3b880e0ea7d"]},{"cluster_id":"9ba4f992-6e11-40b2-8501-4e04321822e6","members":["7fdea1ea-c968-4c88-ae94-84e1ba514576"]},{"cluster_id":"fcb57169-c911-45f8-98e1-10aa6c573c38","members":["167a219a-eda7-4bf5-8331-da930d790371","af3dbf49-d094-4fbe-b7c6-25808686dfa6"]},{"cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","members":["0288195c-9fec-44db-a109-059e6777897b"]},{"cluster_id":"eb38bdfb-232f-4460-8d60-fc8806237786","members":["fd8db090-0452-4f9b-8abf-4408eacddb2d"]},{"cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","members":["85f37113-0f90-4278-a176-cff652db623b","5c5d284a-29b0-4fb3-8cb6-db0f0c797e77","2a34535b-7f20-42f9-a107-9b2729dfb4aa","1e126e36-eb40-4d99-8d99-4a44eb746256"]},{"cluster_id":"a74a2d72-1d86-4264-9389-b4fe594a7218","members":["c57e4357-ae8a-40b8-afda-c07666d2a827"]},{"cluster_id":"e3e4b634-fa33-47d8-9f29-eefdbb263769","members":["c034d650-02fb-406f-9caa-155c65dedc12"]},{"cluster_id":"5dac5b6d-e9df-41db-9225-7e413ca3cacb","members":["9fb54ee2-01b6-4987-980a-210dd5544835"]},{"cluster_id":"21745bb5-f9bc-46bd-a9de-95338ba8c016","members":["86bf145c-272c-480e-8366-65caa37d83f0"]},{"cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","members":["92b4d75e-1243-4b14-afa6-adbd966b3a65","f5d998c1-dba7-4576-b16a-89383c25a0fc","3c84cd9f-a0b5-44a8-9e90-7b1c22667bf1","5565423b-d1c5-4760-a05d-88362c28d64d","62df3fdc-6f66-41ed-a406-3be29d71c41a","66b83ca0-c680-4174-8829-30444f5d4a2f"]},{"cluster_id":"e1e2a57a-7e63-4b0b-b70f-2189a87649d4","members":["94959480-351d-4c80-95f4-11df21938b90"]},{"cluster_id":"b9cdce3c-8c52-4df4-89e7-a4bcf232dbef","members":["3227e8ec-3817-4e54-8ce8-38d6ff47fa16"]},{"cluster_id":"62ddd106-9df1-47e7-9e5a-9c12a19f488c","members":["63d19ccd-c1a3-49bd-bb47-e27b66c6bb53"]},{"cluster_id":"10e97fc5-5fa6-457f-aefb-257e90e8124b","members":["a9de1b60-bb45-4d6b-af0c-15438e753da4"]},{"cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","members":["6a794e4b-ffb0-47fa-8123-d9af2434ac33","900e1eee-866c-424a-8d33-57b367844e47","437d0d25-c2f2-4643-8e57-48cefb1d0e0f"]},{"cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","members":["864f9a63-a3cd-4ac6-8b3f-b1f18e4b0f44"]},{"cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","members":["1b13625d-b41e-4562-bf57-bdb6d1ca6e55","70eed460-6914-49b4-bb84-aaaec6fa2922"]},{"cluster_id":"7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1","members":["ae86ef0a-bda7-4932-9e91-a13e090502e9","af987d12-b231-4ec3-96e4-33aecad0ec38"]},{"cluster_id":"7ebece62-a589-49b3-b28f-b8f565ab7327","members":["e62e5eff-1bfa-4a5f-8f62-2c3b2ccc3405"]},{"cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","members":["da854a60-2bfd-47e5-93f4-3548662e814e"]},{"cluster_id":"40a361aa-d57e-4e3c-9740-34505f34913c","members":["aa6995a0-49dc-480e-a0a5-150071aa7162"]},{"cluster_id":"d8483e15-c78b-44e2-8070-c109cff73a66","members":["e5121df9-2e78-481b-8970-d2176c7e27ca","fb4ca0c3-80c4-4700-ae1a-6f5767428779"]},{"cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","members":["bd233fe4-3b35-4b5f-af8f-81ae82dca665","568d07cf-6cef-492d-b53a-8c7f0a97da4f"]},{"cluster_id":"6d37cc6e-940b-4af5-bb44-d183921f0d01","members":["e0368732-4c88-48f5-9c11-88c6067e6192","fe6a5012-e766-477b-9be1-1e6534f65aae"]},{"cluster_id":"35d18d7f-0f7d-4654-8e65-f6b4bcac032a","members":["00e4beef-c219-4e6b-8148-2fcb5fff7534"]},{"cluster_id":"b9eca2e7-5401-453f-8490-81ec97719e08","members":["842d6786-258c-4787-ab4f-513325aead98"]},{"cluster_id":"c55d7e50-ed13-4f98-a396-412d6e19decf","members":["2482a699-2eb6-4496-a7a1-14716440e37a"]},{"cluster_id":"6985338a-f2b9-47d5-b9ae-563c0a87748d","members":["a3f553b1-2992-4891-b063-96f989262aae"]},{"cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","members":["baa2a5aa-152e-4eb7-9032-0bd27e6694e3","ba09747b-f0b6-4dbd-b0a6-470d389066fe"]},{"cluster_id":"d622247c-7345-4e31-99b0-dfafa4dc550f","members":["dc5f398c-1b3c-4084-ad16-8f688b425043"]},{"cluster_id":"f5514b1c-3b40-41b8-9290-039c2c94a3e7","members":["cc147726-682e-4939-a5a6-0cc2cfc82c3f"]},{"cluster_id":"2ed3c98f-2c08-4da6-97f9-38e8a951f08e","members":["d03e52c8-f3b0-465d-8f87-43a35a1fc373"]},{"cluster_id":"141b690c-587b-4b7b-9ad4-7b1b333f6cd8","members":["34d53daf-8e5a-4230-baa9-8bfff9afe51e"]},{"cluster_id":"e9b05837-7f42-4f2f-bc7d-dca62a93d724","members":["a106285b-7181-4d15-984b-cc4c27f0e1c8"]},{"cluster_id":"38f73b32-c8c6-49f9-8452-aefe0c4fa642","members":["e1999d90-6147-49e7-b5ba-1610c953efa1"]},{"cluster_id":"31810a05-cebd-496b-bd75-5b647781b8ec","members":["c9551664-66c1-4022-be61-3504e4b8a7ac"]},{"cluster_id":"a65b71fa-08aa-4b20-91e3-c9e898591f07","members":["0cfea84b-cf2c-4f62-9d1a-21e329ead6c5"]},{"cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","members":["088c9d7e-17f1-4edc-8006-3419bd1f866f"]},{"cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","members":["8582e052-9742-4830-aa7b-63a3e3825d95","76d5d175-535e-46fd-ab6a-b99dfb4c17f2"]},{"cluster_id":"655e754e-33e7-4bf2-aabe-264f18d499a4","members":["bb7bcb7f-4e00-482e-91ba-f39ba58f5294"]},{"cluster_id":"4bcae16d-fb51-4ba8-8381-37355e0e9f18","members":["803e4526-61c3-4126-86fd-41849f1452d5"]},{"cluster_id":"ae58d35c-53bd-40b8-b6d5-7fe4e15e229a","members":["d268d9c5-c3c6-4411-8345-5a9251ac14da"]},{"cluster_id":"1405f96f-07a0-4454-a7cb-365f38772605","members":["f6483772-fddc-4c83-9b69-4ea7ee784909","7b01c26e-2bc4-4c62-a665-fa6ab7dc8026"]},{"cluster_id":"563cdc28-d88f-4781-9ab9-27eadd46ba73","members":["cb281f4e-f905-4eec-b469-2c16643d4c80"]},{"cluster_id":"d66fbbdf-0d3b-4c16-8077-654078280a83","members":["236567f4-2fcf-4060-8cab-0e0de7c945d5"]},{"cluster_id":"92df4e35-804e-4b67-b2a3-fbb89ed1961f","members":["2ea9032c-8c5f-4001-b001-e19ace030710","c964b8e9-62a4-426b-8aa4-338df852d011"]},{"cluster_id":"6b12e24b-6d9d-4b0e-a169-260972b9ab69","members":["da17caaa-038f-44dd-81fa-2b9a4d619340"]},{"cluster_id":"0b87672f-54fc-4c20-8d98-e54ab45bc52d","members":["25d1ffa1-ec83-4556-a329-729b2996fa94"]},{"cluster_id":"de4bbbfe-ba23-4e75-bdd5-72e767837661","members":["d37d1d9e-9c0c-49d3-9635-75549d7725c7"]},{"cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","members":["4f14b91f-d337-4555-83f5-4406531cb2eb"]},{"cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","members":["18fd783c-ce15-4f12-bece-7b5f5bbe65b4","d8318dcb-8196-4736-82e4-d6cc57aa76dd"]},{"cluster_id":"3c0cf1f8-c44a-4a0b-9f9b-6b44ff81b740","members":["dc5413c2-0794-4e1f-a694-bbec425f4ef0"]},{"cluster_id":"051c1a4e-08fc-4a09-9e34-8d3d8d646136","members":["43919de6-4762-4470-acd3-37a2872b14c9"]},{"cluster_id":"1f1f405f-6b99-4de2-b4fa-1bd105b3c577","members":["7b0c30c4-33d2-419c-af29-819d57a0adfe"]},{"cluster_id":"916339bd-3e65-4fc3-be04-12020f45e716","members":["4361dc11-5b10-466c-866d-bcef206f74ec"]},{"cluster_id":"32a2eefa-c8c7-482c-839f-be3b15138d40","members":["0707287b-fd2c-45a0-9848-e672b4be6745"]},{"cluster_id":"e9caf6d9-2282-4c7e-9cd5-97529119edff","members":["76d70905-af86-4ce6-b53b-47bfd1d81f41"]},{"cluster_id":"4157a1dd-b3d1-4769-8ef9-bd2189b4146b","members":["905652e7-0b27-4087-97dd-baa9e9748ae4"]},{"cluster_id":"da8da9c4-b0b1-404e-a289-e106bb2bfbb3","members":["5574fa8d-0c2a-4e81-9251-ca98d7716651"]},{"cluster_id":"36824238-8532-447a-aacf-ef3f59e89c60","members":["277c4d3b-7c36-4927-b020-8737f80c28eb","5ffe426c-467a-4aa8-a9e8-86fa1ed37679"]},{"cluster_id":"1c5a43cc-bd0f-4446-9eae-4f39a7691fd3","members":["4061b077-d654-4a60-b4ff-6d603ddea8c1"]},{"cluster_id":"9fc65438-2baa-4ecf-a802-ddd71c4ed907","members":["2f5db5ae-8ec4-4bc1-b85f-d2b962e49e81"]},{"cluster_id":"53a06fbe-813d-46c8-a459-0b312bf0c503","members":["508c530f-62a2-4f80-ad46-f2af4e2a0d81"]},{"cluster_id":"d0f7b20c-2bcb-454b-bc64-6c984732d241","members":["838a4c31-fdc8-4018-bf5d-f520ddd23e70"]},{"cluster_id":"6a2f7e2f-c113-4c0f-aa04-a2e337901c37","members":["37e13725-d8a0-42c4-896e-28b43b854daf"]},{"cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","members":["c92f6276-a72b-40c9-8eb3-52f11f64e39e","2f3194b6-9742-4bc1-b6f3-965c8e1ccc22","3c5f91b2-eb4d-4fe5-a274-f1526c2230d8"]},{"cluster_id":"f87de08e-1790-487e-a827-12378ebf4309","members":["96f6f419-8345-4abe-8f59-ee35ea18b71c"]},{"cluster_id":"09060ad9-5546-4c31-ae6b-321cd8a78d5b","members":["c522a826-3d94-442f-8c9d-1029702b5159","7adbc651-0db1-44f2-bdaa-bf7e41339d70"]},{"cluster_id":"ceabee0f-bc28-4b8e-8445-fc63ff551472","members":["55914f23-fc32-43e1-9e36-9f9f752bf43b"]},{"cluster_id":"71f31aff-9c20-4fff-82ff-b0bb971b0134","members":["4c2df153-9630-4525-9cc5-c62839a1318a"]},{"cluster_id":"ab8de566-e0cc-475b-b056-6b27916b484d","members":["aa6ae27a-ebdd-4bc3-aa8c-94795ca3005f"]},{"cluster_id":"61d63dd9-934f-4808-b6ab-ed734f2474b3","members":["9f30f1e3-612f-4f10-8077-f36166226813"]},{"cluster_id":"428a1c85-5fee-4a1d-bbe0-9e71872e75e9","members":["97b80d46-c4df-40f4-a396-952af4ac237a"]},{"cluster_id":"7e4a12f6-fe24-48f6-993c-d7197eb9c44e","members":["5b569460-6127-4883-ab59-9853548e4d9f"]},{"cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","members":["ab5521ed-0c5d-4fa6-8e45-5994d785c3a0"]},{"cluster_id":"af2dae39-7b57-4e0d-909b-c39b56de0088","members":["e5a07fbf-34c1-4129-aa0c-a60a22560819"]},{"cluster_id":"579db367-74ad-4432-9888-8af443f74bd8","members":["6fe6fe1d-5649-46c3-b803-cf5637648f66"]},{"cluster_id":"5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1","members":["f69d66c3-1c29-4ad0-8ed4-29471bb5254b"]},{"cluster_id":"99df608a-defa-4cea-b8ef-86519fa0e08a","members":["097ad6f5-be15-425b-9247-f5918bc3cf53"]},{"cluster_id":"6b5b4849-041c-4f1f-a05e-cd4913045e8f","members":["9addcae8-1045-4fe0-b2e5-557bb400cba4"]},{"cluster_id":"fa68205c-96de-4570-af4d-97691aaf5e3a","members":["68313ab6-a010-42dc-95fa-48d851f5286b","b015f81f-6b59-4434-a79a-66d9ba97c4b3"]},{"cluster_id":"6ca40c20-bd2c-4fa0-af88-bbe3820f05e6","members":["e1e22820-8161-46f5-b0cc-f1b859444517"]},{"cluster_id":"3428edf1-36a0-4018-889a-63913498a6c3","members":["1f0568f0-449e-417e-8c8a-42e640838fd5"]},{"cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","members":["7b26bbc6-19f7-43c0-a99f-5ee27fdfd37d"]},{"cluster_id":"07ec2e30-02bb-47d3-9b4c-32b7c841fb33","members":["976a8b54-0e02-4acc-823e-24c922f31dd2"]},{"cluster_id":"070a19a3-da4f-4314-9f9a-9f32850f97f0","members":["4b063b61-17b0-408f-86e0-66307335ebcc"]},{"cluster_id":"7966aa4e-476b-473f-85ad-b267835811ed","members":["2020bb2f-ce91-4d14-8fba-d22a6c3047e9"]},{"cluster_id":"824d7e98-fb11-413b-adeb-b8d12c8fb785","members":["af8e71ba-1347-49fb-872f-7d03c60cef83"]},{"cluster_id":"f3328626-3764-43c0-a7df-3730b34ea1fd","members":["8624e824-6fbb-4d02-b248-4ac44bba4445"]},{"cluster_id":"86d26636-5c9c-416b-94e0-e2a89a9628c3","members":["6d3ca843-ac74-414a-8a9a-f9b3d840ad72"]},{"cluster_id":"c6592686-c5bc-45c2-8341-7823b2936bde","members":["a500fdc9-536c-4504-8762-dcf75b30807b"]},{"cluster_id":"c13b80fa-280b-4c54-8a38-1ddd943c4782","members":["3a4ce92d-731a-4392-9594-1a7f1b5bc5b2"]},{"cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","members":["9f514e31-b4e8-4fc2-881b-695f8c5800df"]},{"cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","members":["38f377c1-4e31-4453-819e-2f821eff8ce0","455efb37-6619-499a-9e56-569078c9d715"]},{"cluster_id":"10f0700e-3ce2-47c7-8783-a4d08ef48748","members":["a3feeb4a-df50-4aab-a818-f764236f8ad6"]},{"cluster_id":"619d0e6c-df2c-4164-aaac-ccaba7c311a6","members":["8c52f7f8-5666-4eab-9f59-fe86a57dd17a"]},{"cluster_id":"b2036724-7c6c-4df4-b983-90c324253873","members":["e9b47af3-f5e1-42a4-8210-70ba8ef8ce4b","a4b9fd7e-9d5a-42c0-8b84-7afbda6514d2"]},{"cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","members":["2e952ecc-8a11-4728-a55a-b9070840e5cc","569c9fdc-c50c-40ec-8253-6f83dfb0844f"]},{"cluster_id":"b6a83d03-593e-48c8-ac84-66fa31a32a89","members":["396aad09-0fc9-4db0-9583-50b9bdd71a16"]},{"cluster_id":"489cefd4-e6ef-4f49-8a70-8d8f7bc512bd","members":["95810909-9f05-4822-a380-9d9f192410dd"]},{"cluster_id":"3ae89f52-245d-458f-80e9-2534c0d80104","members":["fb31b421-1b69-46bd-9c81-a9d77c6fcf57"]},{"cluster_id":"b5600099-12c0-41c7-bfb6-4b6bb66dc0dd","members":["23c60597-be74-48f6-97fc-3631ba451bb8"]},{"cluster_id":"947756fe-ff59-4dbf-90dc-9c0bdf20ace0","members":["2781ff7d-9d7a-4c4b-bcf3-c264eed0ba36"]},{"cluster_id":"2f3c2293-d820-4cb3-836f-6df8faee07a8","members":["9cd57b99-4d64-4360-96d8-f1e695967fb0"]},{"cluster_id":"7325cc3b-df7f-4451-948f-1ce21f12d10f","members":["e309b0fd-2252-4b9a-814a-9a55d2b4fba4"]},{"cluster_id":"d0dabf1a-0448-47c3-ae6f-96348eaf2cb1","members":["d59aa96a-97da-4753-a2ef-40d78a48c9a1"]},{"cluster_id":"340bfd8b-2131-4805-ab13-01e1c97ec008","members":["40678ed6-372d-4f7b-8d1c-78ccee23a635"]},{"cluster_id":"be9b7361-8150-4e4b-9111-bac990c11d3d","members":["0de62fd1-eac4-4208-ba57-878dbab8308c"]},{"cluster_id":"335213da-43c0-415b-b902-6fbd946881b7","members":["79af6b5b-af58-4e0f-8fb9-0441d3728d4e"]},{"cluster_id":"1b257e2e-69fd-4bc5-b57c-e7f5b2178161","members":["0fb4eb94-796c-4474-822d-d49532bbdf78"]},{"cluster_id":"6d2624a6-0551-4f8a-8ed4-2b7126ed6490","members":["e449ca29-0cdd-4df6-a8be-65ce5e2063ff"]},{"cluster_id":"0649ea17-dc60-458b-988f-5fb62bfa7199","members":["12f4269f-e670-4d9b-8ee1-fb1eb44c333b"]},{"cluster_id":"1809291b-a942-475c-989f-c974b3ec75b6","members":["3bd18ad9-4a9a-4f65-aed3-f97bfcfa2305"]},{"cluster_id":"d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc","members":["48e29c96-9fcd-47ae-88ac-52d0cf5d5625"]},{"cluster_id":"97fd88d2-827f-418a-aa85-784dc98e83f5","members":["f9769b02-c023-424d-918c-79424431d746"]},{"cluster_id":"489bde91-1bfc-48d6-aae7-de380d23d205","members":["9794657c-ae61-4302-9788-2e8896e74cdd"]},{"cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","members":["8f0975f6-6d6e-4857-b113-2188906ebfc8"]},{"cluster_id":"da4807bf-cc54-48c7-b3ca-69cd854da837","members":["28861c5b-e399-4e62-aa35-4e22dbd2274d"]},{"cluster_id":"d9f4e411-98bf-48bc-a372-2ef5b6cd17d9","members":["a9651ce2-41c6-4761-8d99-8fce6e172982"]},{"cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","members":["baa9cabd-e297-4048-a196-c125d4f55a45","24a948e1-bc0f-4d4b-9445-82619bac62bd","4f27b8c6-ed89-44ab-a475-ce01f510eb96"]},{"cluster_id":"820cd21b-12a7-4c4e-a98c-55a81599d692","members":["a1a4246c-cc65-437f-ade8-c42722b56648"]},{"cluster_id":"eb2e33e5-165b-4a02-aa96-d53bcd386da0","members":["1b60a8c8-ce1d-4b0a-aebf-8bab19ffb83e"]},{"cluster_id":"9af9ad02-7803-4d3d-9d58-fdfc300bef96","members":["ebbc58ff-b654-452d-826e-b4b7fb0c1dd4"]},{"cluster_id":"c7b90480-a4e5-4b5f-b840-fe13ad140b52","members":["4ddf07b6-49d8-41d6-a6ff-cd4a4f5849f4","aa15afe4-78f3-4f3a-b547-91e27dc69fe1"]},{"cluster_id":"afdf0794-a58d-44cd-b1d0-aec7b0adc12c","members":["19aa839c-e515-411d-bb73-8b1c0ef37901"]},{"cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","members":["36c0cd4a-8b15-43cc-ac7d-1fe603b67079"]},{"cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","members":["13dbfe73-0c74-42c4-8617-979b4f918ebb"]},{"cluster_id":"400218af-6cc1-4f06-8e3d-7804bde6ad17","members":["73ab226a-7dc0-426b-9964-0d1a732ae936"]},{"cluster_id":"868aacb9-ea8e-4ec3-a074-1e7f56bab03f","members":["5242cdbf-b4c2-48b2-8319-ef7cb0bb36db"]},{"cluster_id":"9867a541-4a4c-449d-a4af-a0263f8d23fb","members":["d50f8b96-1672-465a-8227-62e198faf14a"]},{"cluster_id":"8d565c91-b887-465d-a08e-aff09b1e9e5b","members":["2760dd91-0822-4c04-8c1a-3ee7deeebdd0","f5cc4086-25d9-4aee-94ab-c0c7ced1e49f"]},{"cluster_id":"a9d64d25-62ff-4c83-a924-9b0477ad4c22","members":["d284b953-af10-4aa8-9389-f4d2744e9454"]},{"cluster_id":"e3548f8e-cc3f-4307-a48a-a45cdf828859","members":["276aa55d-6a95-4170-9844-c67c54a5881d"]},{"cluster_id":"5d950548-da48-42e1-b748-275abdd34cfd","members":["1338c7bf-e4d8-4a04-a092-fad1f6993163"]},{"cluster_id":"38c71e65-4039-4578-b30f-f1a4d6dd193f","members":["b72f3359-fc17-4fa0-aa39-f3c1d260a395"]},{"cluster_id":"cd4aea0c-c90e-430b-95f8-4bff425c022e","members":["f6592f88-c9d5-436e-8cf1-f64e132ac10a","31a1ff2d-e616-4f27-85a4-b4e9a505c722","a6bfff66-26b1-4884-9570-878a4a484542"]},{"cluster_id":"d81a20c0-6869-45f5-b75d-d3dcf313d9ed","members":["b99ed213-2fc7-44fe-8158-11de1ce92fd8"]},{"cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","members":["fbda447a-c249-4c5a-a81d-63707fa8a879"]},{"cluster_id":"efcbf9db-15ac-473b-a9a9-0988dcab89df","members":["12de5676-5208-4063-93d7-48bcb3386041"]},{"cluster_id":"1991b6cd-3baa-475c-add7-d4b101a0de09","members":["cf13ec5a-1de0-4158-9907-0e98d2f0b2b2"]},{"cluster_id":"4a2e9d4b-d2bf-4512-a149-283851028578","members":["16a1d1b2-6f66-4f97-bc3a-1662c94b64a7","c500b931-6581-40b0-8b04-bbaad04970c7"]},{"cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","members":["7fd92c05-9204-46f4-9028-9475c4582ddd"]},{"cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","members":["13a6d66c-1a1c-4778-b975-22861081ce05","b270dea8-050d-4024-876f-14717220a796","17279c2a-f5dd-468e-a0a7-b2b33e72993e"]},{"cluster_id":"3d8a0674-b5ba-4875-8267-9c46797d5ef5","members":["e837d726-7aa9-4092-aa12-ef20fe1d288a"]},{"cluster_id":"89a7a448-be37-40e3-973f-79b15dac979d","members":["02177f79-3fcc-4614-bb58-b540b9b8a755"]},{"cluster_id":"d5458c27-5843-4ff6-b105-7703aeb6f588","members":["57ae1e09-8cba-4774-b8e9-155af7a9e12f"]},{"cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","members":["a9df46be-ed24-4685-bb08-5aac2eaaf343","b9a81b1d-f10a-4dcc-9fe4-d39ef8898b5f"]},{"cluster_id":"db608ced-e4c3-4573-8b19-bacdf06c1585","members":["7e6c3b85-9bc1-4c85-add5-4280090cc98d"]},{"cluster_id":"a83fedfc-0f0a-49b0-9dae-3932f2ba6983","members":["708a59bc-3706-407b-8bed-aca62b3a0e0b","31a46b11-b9d8-4184-9630-493ef7925f06"]},{"cluster_id":"c9534331-e465-4cc5-951b-fa24c4cd75bf","members":["078df374-e1cc-45cd-b89d-fc04a0086df0"]},{"cluster_id":"7d04ad0f-dee5-48f3-910e-0b2281b15f1e","members":["6722e272-3d35-49c3-97d1-95e27ae4caa5"]},{"cluster_id":"b3cc2793-d201-47e1-8b0f-b8bc6fd1bbe4","members":["27699f3d-62b2-4450-9a56-170616f84fde"]},{"cluster_id":"dfa47852-ac3f-4b74-bc17-22923a395552","members":["5d80c8af-4946-454c-85dd-5a000e0466a3"]},{"cluster_id":"202ead36-85d6-41b8-a59e-b60cf6559899","members":["40a1f1b1-475e-4194-80de-4218fe12446a"]},{"cluster_id":"aaa5b32a-96ba-4450-b886-70f714b65bf2","members":["c27701ba-9c1a-481d-b0a0-fb14a12af237","a5f5b63d-523a-4301-91c8-def1fdf47374"]},{"cluster_id":"80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921","members":["281cf79d-9b45-4672-9aa2-739fdb931d01"]},{"cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","members":["f430114c-0a7c-4439-b956-63fb68e8fe59"]},{"cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","members":["46ccbb30-6967-414e-a158-c7235dff817a","d0a5b883-e100-4fb8-b710-5da3ddf49704"]},{"cluster_id":"2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37","members":["7a0a519a-abe5-4d16-b25b-95b7dd5dd4f6"]},{"cluster_id":"a63004c7-9e1f-4600-bae4-f70655f0094e","members":["b1e6964f-cf85-4fe8-b3cd-e36bae98b74b"]},{"cluster_id":"729e67ef-32fc-4882-8297-9f443b6f2589","members":["a8c3c106-7f49-4e8d-b998-9325e7b29179"]},{"cluster_id":"066ea292-674c-44ee-8c3c-799b0ecf024c","members":["0c210184-be10-40d1-a5ef-5c5c5f272897"]},{"cluster_id":"6d2fdf64-8424-4971-a998-3fe674aff124","members":["7a88ce76-3d77-4aae-b093-fd98ef26f4d5"]},{"cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","members":["5ffb9f22-74b9-4d3f-8577-578f0aadeb63","b912dffc-b87d-482a-a16b-8acade76c109","05e621ba-ae52-4afa-9b17-06cbf18f9681"]},{"cluster_id":"bf53e706-320e-4307-85d6-fcee526f5f17","members":["8e94c22c-9394-4644-8c86-53923aa6f4c4","a3132792-ed94-47b6-879b-3555eb8e2014"]},{"cluster_id":"3bebcbeb-75f9-4e80-89da-65943e0843a7","members":["81e0ef7d-ddb3-4378-bd60-543568936e03"]},{"cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","members":["ac94c666-f650-45c6-b4b7-6e850d36774d","622159aa-c1c6-4f15-835f-7664880f27c2","70c1009e-90bb-45b3-9841-3a11d82b6d55","18c57d84-5c5e-4cb2-ab99-543cf4ad5dd6","1107377d-31cc-4177-abee-f8997c059202"]},{"cluster_id":"f465e3b9-9784-4302-b258-d34ad0adf726","members":["a4290403-d70c-4974-84e2-44718132a241"]},{"cluster_id":"c0e66b49-a2c1-49ba-be78-c28aff5c60cb","members":["852533f6-e8e6-43a6-a937-f11d74216ec4"]},{"cluster_id":"8d676e91-6fd3-47df-8a59-7b88ff3f09cc","members":["666a0302-51a9-4c85-b6d3-9d5c2ff3f4cc"]},{"cluster_id":"06ceeed7-8a02-425d-9be1-3881dcb38762","members":["5539f9d0-477d-421f-b465-b41852681b1d"]},{"cluster_id":"869cd99e-564a-4420-981f-b385e7b7bceb","members":["48426c97-7d6a-432e-b843-39c651e804b5"]},{"cluster_id":"38146e96-2791-4b11-ad91-87648834294e","members":["e85cc452-7f15-496d-99e7-e29d1ac05981"]},{"cluster_id":"48358541-e77a-4c9f-81e2-7af006f34920","members":["c3751919-18d3-47c2-9167-edfff84722d8"]},{"cluster_id":"756b0f02-73cb-49a8-bdd7-27690bdeb637","members":["aee0cb83-07c1-42bb-bf33-73e771d68a50"]},{"cluster_id":"6cade303-8a3e-4226-b5e8-0d3b189187cb","members":["a820a710-7fc3-4d8c-b0eb-29a62b39bc95"]},{"cluster_id":"f8121c44-24d3-465d-8607-2a909285d318","members":["a13c9705-08c7-4902-be92-bdd7400fe68c"]},{"cluster_id":"32902173-339e-4b9f-809d-01ac474ca7aa","members":["511ed949-e4e4-4397-9aea-9c078bc7cdba"]},{"cluster_id":"8f9f1940-08f3-4a29-938e-790645f67487","members":["edfc6794-b92b-4d2c-aa29-931e67ed4a5f"]},{"cluster_id":"c474ebeb-fd96-4c94-8aa4-35666d0af3d1","members":["23d2674e-201f-436f-8ba5-f9634b22452b"]},{"cluster_id":"3b3a75fc-8d67-4d12-8788-a11705a7cca1","members":["205ee47e-0b88-48c4-bc25-bd44daed69fd"]},{"cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","members":["4e5b22dd-ab03-436c-ac85-a6195d7b65cb"]},{"cluster_id":"bd06a127-0f18-48fa-b6d0-ff607d111775","members":["1ea025bc-37bf-4c08-96c3-faee33d6f7c1"]},{"cluster_id":"296dd26b-e540-4c2f-91af-43709d5e7555","members":["4e7475b9-3013-439d-bac9-d3f060ccf7e6"]},{"cluster_id":"b58aa973-7c2a-4a42-ac89-2aa7abeea2e5","members":["94b0599d-5280-4eb1-a5c4-ebb69a354aad"]},{"cluster_id":"e8c5e2f3-c4c1-4992-a125-b40d6d98bace","members":["425afd42-325e-44a6-a89b-4d35781ffd50"]},{"cluster_id":"73aeb014-9fc7-4042-b2b1-7016c4fa8dd2","members":["32ffa954-dc22-40d1-96e3-96b6f192825b"]},{"cluster_id":"77de10dc-6dcd-4902-a9d2-f5cf9384d343","members":["d80bebb7-3a6f-4623-80fa-7326d471c3a4"]},{"cluster_id":"b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4","members":["91924ffb-2ec1-49ed-8ca6-a0b9686c4c88"]},{"cluster_id":"a031766e-aaad-4e78-b0e4-bd1cf2fc1a66","members":["ba0ef9b9-0a68-4dbd-93b2-7b293f43f319"]},{"cluster_id":"4150f7a8-fd61-465a-8315-84a5d8cef80e","members":["15a2de90-4297-4571-9ce7-16e49442c14a"]},{"cluster_id":"6eb67c15-59c3-481b-bf8b-2e464b0775ec","members":["3982f6ff-e14a-4a9d-be0a-90a7aa933551"]},{"cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","members":["dcc4a80a-81d4-43fe-aa58-e3bd7b68cb02"]},{"cluster_id":"392d337b-80a2-4413-8e08-b0007e5c9b50","members":["2811b1f1-4d62-4902-b97a-4a3797d99845"]},{"cluster_id":"29e9fc0f-b1d3-428d-985b-aead08ce4e3c","members":["dfeb95b3-8fdd-4583-ac1f-66a47fff194b"]},{"cluster_id":"61c8550e-839e-4f39-803d-72ebbfa747a7","members":["bbc96af2-eb24-4264-884c-ef5aeec83436"]},{"cluster_id":"e17e07df-4805-4514-b3fc-c16cda9269a3","members":["7eb508d8-7356-4029-85fc-3cd4e5adabd7"]},{"cluster_id":"f1535355-abab-40c3-b4e5-ea2b4fe4994b","members":["ce34df8f-a86f-47f8-94f6-b6763533d968"]},{"cluster_id":"18f586c2-7862-4f1e-9fbe-94bf4981c3c4","members":["7df04e24-fd6c-4618-916b-acacd3af5fe6"]},{"cluster_id":"d92f99b3-bdef-4ca3-95aa-e303f2451b97","members":["3f2eac23-d6cf-49de-bae9-23f6f126613a"]},{"cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","members":["f08b015a-22f5-4f03-a884-d70f9da97189"]},{"cluster_id":"b1827766-8909-4c0a-8a55-23a0b5e81d4e","members":["a48c2d4a-ca9d-4583-ad77-e97dc4ceddad"]},{"cluster_id":"971c6a1a-3e95-4838-8131-b05eb89d55b7","members":["71cecf6b-1122-4c2c-8ea4-48558d89a707"]},{"cluster_id":"e935bf33-7d4f-4ee6-8636-94e91a064afd","members":["e630a528-9654-4292-b306-4be1aede0a0f","27728a69-61ad-4642-938c-0424e17198f4"]},{"cluster_id":"32c3480d-0d09-459f-9f53-79a49ae3f52b","members":["7d58789a-930b-4bde-b413-904cf956b97b"]},{"cluster_id":"b686bd17-fb36-4b7b-9caf-084f8d91c149","members":["94a5d13f-6c49-487a-b51a-ccb0748b111c"]},{"cluster_id":"03105f5f-d65d-4408-8071-b314d86ce573","members":["6c74371b-9156-4527-bd46-33afea027602"]},{"cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","members":["6ec4ed54-0f02-4ca4-a2e5-1713fca9e731"]},{"cluster_id":"2aeb94af-8d5b-40ce-b754-91495083b2a1","members":["7ae5ac2a-e77e-45f9-a09d-b48ed86247ed"]},{"cluster_id":"f46bebef-6c63-4778-a5c7-e0d7b893e969","members":["95e8dca6-eba1-4ae8-abe6-1699e963f71b"]},{"cluster_id":"2b9508d5-4552-4994-840b-08ab461e29c3","members":["f3693f4c-6543-41d1-afc8-120d2fb1edf8"]},{"cluster_id":"31d339ae-2342-44f9-a909-e299d2c4eccd","members":["e355827b-0900-4843-b234-fcf2d8dc9d3a"]},{"cluster_id":"a7867a02-8602-4251-af70-d100ee635a74","members":["d393ae41-2620-4022-acb5-4fcbc7c76ec6"]},{"cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","members":["54a197a9-396b-4264-872d-94d97c27fbfa","9cf70f7d-68f2-4feb-b383-fa49d02a1fe7","d39e87c1-3ebc-48c7-9d34-8a569966f06a"]},{"cluster_id":"e836e40b-bdcd-4eeb-bbb2-df3b385c12c6","members":["98383b6c-d1d4-471b-9076-e2507500a31b"]},{"cluster_id":"68d51d93-fcbe-411f-8a89-cb79bd347512","members":["e922300e-8398-4290-a14b-22c277ffc866"]},{"cluster_id":"1e13a15e-d3c1-4581-b460-13b01ca9aa54","members":["e1282797-5c59-4c8e-9869-25dd7feed8ec"]},{"cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","members":["534fe008-9f9d-43c8-98e6-feb5d976c1e5","151026d8-aa87-4c5e-a1ed-b5a85230e132"]},{"cluster_id":"1f8ce922-0e37-4ccb-b586-67da18764d96","members":["3d30e612-8d52-47bb-b24e-3c6c55d6798c"]},{"cluster_id":"f6f15ea6-27bd-499b-a6fe-74d144b5ac0b","members":["80f457ab-70e1-4f4d-b0b7-55e5496c3cc6","ef48ebaa-d46a-4bf8-b024-1f4517044afd"]},{"cluster_id":"b63983c2-35fa-4152-8cc2-8380b6cbde79","members":["15558040-1082-40ab-b3ee-92ad2117bd2e"]},{"cluster_id":"88a5288e-7f93-4e9a-8960-db23a08024fc","members":["32d2b9c5-4f9d-4841-b031-0779293587e4"]},{"cluster_id":"a1f0e0be-a8bf-4895-ad2d-4f83a0d63930","members":["eade3386-0e7c-4d86-b898-d4d10a95072a"]},{"cluster_id":"976d7c8a-cb17-41e5-9407-5cd8c141bb84","members":["2598f3d6-3972-4e7e-9a44-f2e6e903bf9f"]},{"cluster_id":"6a65158f-b873-42cb-b0bd-0cb1b60a0d86","members":["305207e2-9826-4409-b2f3-7a186de5ee2b"]},{"cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","members":["459a7c39-7561-4c42-8b32-f60835558e46"]},{"cluster_id":"7c9beeef-07c1-4872-bfac-86e8c63a87f9","members":["d424c471-7aaf-428d-9186-8d8442cbce27"]},{"cluster_id":"5fec9a51-560a-4b1e-ab7c-cafcf47ba675","members":["21d74062-be4e-4d10-a0d8-33bb9fd723b9"]},{"cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","members":["6d21c206-996c-4e4a-85fd-d9df9ec56bdb","73a83e9e-a797-4089-b84e-33a825dd6e1f"]},{"cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","members":["3cb094ff-b29e-486c-99cd-938e3eb40fb8","b4dc8335-e7e6-4ca1-ac0f-cda8fc61aa54"]},{"cluster_id":"e1f9f354-866e-470a-a516-a1c53f268840","members":["b286a749-9752-4d5c-a479-037bff83d4f5"]},{"cluster_id":"7a66905d-c83d-454d-9b6f-176a36e4d7b3","members":["a1b34fd3-9e14-4812-b52c-ed9c8fd128eb"]},{"cluster_id":"2a22127e-779b-461a-a858-c6dc0fc34ff0","members":["48aa8890-a376-420a-bea0-d18e73298f49"]},{"cluster_id":"e1ed1afc-85b6-4c69-a063-e486d1e3670f","members":["c6920b0d-019e-426e-a9f1-94a2c661ee47"]},{"cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","members":["761d7708-e063-40df-b169-11813b9c5a1a"]},{"cluster_id":"20b239ec-b263-4052-a330-5aad8ed1209b","members":["f834d89b-72a5-4444-9ae0-dc1689e04181"]},{"cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","members":["84f85dfb-f8b6-4bc9-8b68-c8f9e31f70ff","df6ef4b3-1e21-4196-a2e3-c276d1591248"]},{"cluster_id":"099db03e-baa7-498b-864d-6a091534741b","members":["49ed25a7-1dbd-41a6-8bb7-f47041bfa75d"]},{"cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","members":["5191a2b0-b6ba-406f-955e-eeea758651bd","d78af013-bc42-4660-b56a-e505039c4243"]},{"cluster_id":"2cd7a2ea-67d1-4d2a-8944-a71778dc20d7","members":["e347b4bf-00aa-43d1-b060-2fddcd12d86a"]},{"cluster_id":"bc2e7af6-3507-403a-b41c-f6013dcfcf6c","members":["aa552ce2-0693-4f24-b8aa-d44db6148533"]},{"cluster_id":"8c2b4e21-c9ea-4127-9440-e983688f714d","members":["f9bbeb23-497c-4d13-8beb-ceddba749004"]},{"cluster_id":"101b3e01-9e80-483b-82e6-39667fb77d18","members":["0a46dcee-f394-4142-a759-f623d40f2993"]},{"cluster_id":"a94e5bcb-b502-4cb7-a23d-3a1e29ce963a","members":["a7f471f0-c804-4bf4-9e64-75b4b344ca1e"]},{"cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","members":["80ddb716-250d-49cb-a86c-cefd8e85d239"]},{"cluster_id":"a020fdcd-2c2c-4311-bbc5-883c8bcd23ae","members":["b3b4dccc-edc1-4594-a17b-eb8a8871eb05"]},{"cluster_id":"adfa00d7-81da-47be-a9ec-4b8dfb8ee34a","members":["a34da33f-f9dd-4652-bf9b-d5fc598b1fa4"]},{"cluster_id":"7e979f93-4ad2-4933-833d-edddb9f37e0b","members":["a10fa490-b372-42ce-b4dd-106ad67c6d58"]},{"cluster_id":"ee3408ae-2ea4-4661-a58b-6e825aa4a0ff","members":["f8df93c6-49fd-4b41-8315-24f1be63730c"]},{"cluster_id":"f621aef8-63b8-4a2e-8e04-ca8b7ec1b346","members":["a17cc408-1d6a-490d-8453-7ec64b9273e6"]},{"cluster_id":"9fc7edf3-7209-4828-92b3-8d6dafded201","members":["6b0cb1c7-5e1c-4678-9dfe-c6f8b5a13b7b"]},{"cluster_id":"dbd98860-9de1-4289-bb60-99171790c782","members":["5d06354f-3729-4ab5-b52d-859acce95585","31531c60-58d7-4c6e-a9ae-1ce4ab397323"]},{"cluster_id":"4ece2a70-3ab9-4be4-bb31-9931add16159","members":["b743ccc3-2ad1-4531-aeb5-3f9ee4ef1afe"]},{"cluster_id":"3c4b8a98-54ef-4e72-a175-6c00ff85db75","members":["0d2969a9-c361-446f-b6d3-6b39780b39c9"]},{"cluster_id":"f72f8aec-c684-4bb6-92bb-742f08817b1d","members":["a28cffa1-f1e8-459e-884d-d1249a1d0ab2","3508161d-b09c-4ca1-b358-f8f40784f430"]},{"cluster_id":"9fa27866-4911-4f0d-8135-cff4b7e597db","members":["de00440f-228d-4c2d-ad87-5293bd2571a1"]},{"cluster_id":"95469f31-02a2-4069-8577-33c92dddd21d","members":["a9706be2-7458-4a21-babc-81684e231d94"]},{"cluster_id":"b1951710-a9b4-42e8-b9e1-6ca4e5f12a31","members":["b866256c-d159-42f2-9b79-b437f21f7e46"]},{"cluster_id":"138e6c92-a8bd-4f22-8e72-b320bdcf0b62","members":["77173a67-8198-4e1d-b0ef-7f2f6804027f"]},{"cluster_id":"fdae240e-8bc7-467c-b880-f3913e28e6ce","members":["339fd89e-9069-4cd1-adab-6b245515d392"]},{"cluster_id":"14c9c1ef-f94d-48f3-87f5-028b0baa8869","members":["64a08c8e-1e38-4b1e-9ea7-be63fab1aef1"]},{"cluster_id":"edbdc807-7fba-426c-a271-726e1f090eaf","members":["96d8b95e-2b0a-4a6d-bc0c-0a975baa522c"]},{"cluster_id":"f04728cc-e827-402c-9a97-187311920a0c","members":["c08b92a0-63c1-481e-8fbb-220d1bec1e18"]},{"cluster_id":"69c28a9e-902d-4ac0-9540-ae2854dbb59f","members":["bf409d71-b0a9-4311-a682-6b872b61d969"]},{"cluster_id":"c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970","members":["43e60ecb-14ff-495d-820e-25f786390e22"]},{"cluster_id":"00c920c5-f4fa-404a-9d1e-12f311ed5e11","members":["ac8a6a2a-4e83-470a-ad51-1f2339e8ceee"]},{"cluster_id":"55c660bf-50f6-447e-81a1-ddecdab998ee","members":["f477af0a-dd48-4c7d-a950-1f2cd381cbb2"]},{"cluster_id":"461bd859-868b-47e1-abbb-db550a7eb628","members":["61e43457-f3a7-4d90-a467-42a40846a89d"]},{"cluster_id":"76cf3691-7d2d-4e3e-a789-a9c5c731de64","members":["f6cba773-bc49-4608-83f0-216fe40c94c6"]},{"cluster_id":"283a7466-09a4-4b67-abff-ca96f1d8ade9","members":["01c7f4c3-c3d1-4952-9dc8-ac43685ce347"]},{"cluster_id":"32f9804d-d015-4846-99e2-90dd09953704","members":["e104a744-7f4e-4aae-b81d-466cb73a33a5"]},{"cluster_id":"d4c6919b-eb92-4688-a3f3-bcffc0362115","members":["07f2b85e-df16-4ab8-8ca2-bc976eb20284"]},{"cluster_id":"b2a7204e-e5ad-4d5f-8464-67520217c392","members":["d7f7cb52-20d0-41e8-8343-64bd00f61be3"]},{"cluster_id":"89c49eca-c41a-43b9-88d5-85536edafaa8","members":["f3afb427-c00f-455e-a50a-2380bd832be8"]},{"cluster_id":"af183b48-72bf-4947-8e38-5272b737f76b","members":["94fdde06-df4f-4df1-b0c4-693a467e696f"]},{"cluster_id":"197fe725-a0a9-40f8-a6e9-956dd052b066","members":["c64c6898-a3bc-4a01-8409-7233c926f445"]},{"cluster_id":"fcd78a45-418d-433f-807b-b94b3ba2cade","members":["35984706-6e13-4b33-807d-ff8ef361fb10"]},{"cluster_id":"c155f6c2-50ad-4998-b29d-ef85effa1839","members":["1e94c676-527c-4bd5-8763-e83bd1450b58"]},{"cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","members":["efd119c7-d615-439a-8aa4-990e680242d0"]},{"cluster_id":"a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc","members":["6c092750-6909-4156-9cc6-accd6e480dad"]},{"cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","members":["5ccbd8ac-cc11-4cf5-bbf6-831b95c0d4b7","7d7705c5-3255-46c4-a61d-08ef3d3eda8f"]},{"cluster_id":"2a265a62-6ee2-460d-b6fd-ab72b8f23578","members":["2652e037-d6c4-4911-907a-f5e747275327"]},{"cluster_id":"a1632082-229c-4e1d-b6b1-8334d7ed7db2","members":["573e3562-d1a1-46bf-8be0-fbcefbd16c8f"]},{"cluster_id":"2ac509be-786d-4ed0-abcc-15ecf7e6c4ff","members":["155846a9-19fb-4b95-9ea4-7b57e4c3bca4"]},{"cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","members":["3ba2c584-b208-4cf3-a984-fdd7ffd124ec"]},{"cluster_id":"bf1e9c00-6f00-48d6-9611-285baac7022b","members":["b5dd77fe-0b9b-4880-8785-6e1e0a99c6fe"]},{"cluster_id":"5238def0-ccfb-4f27-b836-f20f9b7dd70b","members":["d1de676d-b880-446c-a5a1-788e72def238"]},{"cluster_id":"b65de138-2e69-44b3-acdb-00d152bc8245","members":["d81be451-c47f-490c-94db-1a7d79073003"]},{"cluster_id":"6a2ad136-bcb6-47c4-8c1f-40e9c58978da","members":["69e680fa-5202-48b4-9763-5796b740d7b3"]},{"cluster_id":"210242d8-e5cc-4762-9912-b262084ebeb4","members":["aca610cb-ba4b-476e-8be6-a5049be6e4d6"]},{"cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","members":["d4ae80b3-251a-4204-ae6b-a6b712097b11","39dff10d-9b73-4d10-be22-8229252a8485"]},{"cluster_id":"db81e344-8970-492b-8ff5-c4f2bdbaa947","members":["5d3111bb-3a10-404d-a764-581bac6c54b3"]},{"cluster_id":"e65823f0-739f-4ed0-bd57-83b926046577","members":["b5f3114a-640d-4d7b-869f-0e131b24e550"]},{"cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","members":["b28bc3af-e32f-4a1b-b264-d4c096c65ae2","99ca030d-febe-460a-a6cc-7fb6bfd60359"]},{"cluster_id":"cca76b6b-f388-4f7e-8293-b55584460643","members":["372ed784-1786-455f-9495-acdeba1d2936"]},{"cluster_id":"58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e","members":["6ca9bb38-8395-4d31-b66b-202d55eccd5a"]},{"cluster_id":"c8c0e353-5277-4897-8ef8-4773b9d6e6cb","members":["5cf56acc-4b7a-4a64-9bad-4a8be36aadb8"]},{"cluster_id":"3e775727-96fa-467d-a309-22a5101e04e9","members":["feda4a1f-7f7d-491b-b1fd-6b694b094251"]},{"cluster_id":"4572f15a-5436-48cf-a1f9-d3e141616965","members":["5bc9d59d-3e08-49dc-a4ea-6d714073f5e3"]},{"cluster_id":"a0aafb48-1cc4-47f3-9cc7-073b87c64efc","members":["52aa1df0-f8ca-4316-bfea-510ee0dca9f8"]},{"cluster_id":"3b1f0ed9-3201-46c5-93e3-016f26c4d261","members":["f87cf1d0-7705-43a7-b299-66a0b8f410d1"]},{"cluster_id":"152e2cd2-1d15-4787-b90e-76e34ac56ace","members":["7603dbcf-c486-4b87-a70e-c184e0f84205"]},{"cluster_id":"55a53a4b-b30c-483d-9f7b-8c999d5c2f62","members":["b3df1efb-92d6-409e-9578-dee9453bab7a"]},{"cluster_id":"0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35","members":["a90738dc-e970-4f65-9ad7-87cad007cb06"]},{"cluster_id":"dde390b5-1a05-447f-86aa-a25992be6bfd","members":["ba3e719c-7b83-4dc2-a7a2-229abb53627c"]},{"cluster_id":"0addd203-38b6-4e2c-8fed-432e5b8aac5a","members":["0867dfb2-6550-4d16-96e0-9c112ebcc521"]},{"cluster_id":"6dd833f9-26f5-4505-8729-234f3f5eeeb4","members":["417104d8-a428-493b-a2bb-56e5b26cd68e","d133f617-ddcb-4c57-9aa9-ec5590508b88"]},{"cluster_id":"2c351118-b702-46fc-bce1-27477e956eb0","members":["593f6426-444c-4459-a892-de1960a92502"]},{"cluster_id":"7353e857-402f-4705-bd75-9efa4acaaedb","members":["4d989105-9804-4c26-8239-2884525d14ff"]},{"cluster_id":"1a807d7d-9b68-443c-ad9d-52b339476997","members":["2dbbe5cd-42f6-45aa-a8a6-147b66bc874d"]},{"cluster_id":"97b36cda-ba8c-4a83-864b-060595445ba9","members":["ee909956-ba2f-422d-b13b-3dd1f7c8b0a7"]},{"cluster_id":"3a7c04bf-2c54-4817-990d-55771d584811","members":["5dd54d37-08e5-4109-9c4b-4a0b1db9cb64"]},{"cluster_id":"2951f722-7d9f-4f1b-b69b-0dfe73efebd5","members":["df649152-fc96-44a7-bac6-d0373f7143d2"]},{"cluster_id":"98bac582-09cd-476d-9519-fe434dffcb9a","members":["b0a29215-1b63-4e99-a442-00bf3c3eb3fe"]},{"cluster_id":"df17af70-aa4f-46d9-b191-eb3b4eeac1ef","members":["7121db76-67ef-4f89-a205-949d1d9f7976","6841c086-c308-4290-86ec-48a20ac686f3"]},{"cluster_id":"5995c9ca-98e0-418d-a93b-a662311da0c9","members":["8b3c0685-eb3b-48cf-bcf7-908a949ba76e"]},{"cluster_id":"7f43c7d3-2a4b-493c-b3f0-a53355ae39a3","members":["34a941ed-42a4-4f53-9fa5-2137d04d7eeb"]},{"cluster_id":"7b6f6e44-c4b3-44b4-af65-8b15cce351d4","members":["b18f674e-cee6-4006-9361-fbfe9d0261c9"]},{"cluster_id":"05e481b3-f988-4990-a833-5d6d33d27a4c","members":["bcefaa54-3983-4328-9425-fb1201012286"]},{"cluster_id":"f58e8498-102b-4b72-96b4-c6d5b3fb97a9","members":["4860699b-f10d-435c-a3ac-45cdf365dbba"]},{"cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","members":["e576c123-4c10-4108-a4db-311f2e5292ce","7ae4bce7-e6cf-4723-b7da-3c62d70ebaa6"]},{"cluster_id":"e58c74de-137e-4144-8780-c4e86fcc480a","members":["c96db0fc-892b-41e2-bab9-94a5316354f5"]},{"cluster_id":"8499f04a-3cd9-4588-b8dd-3abc1c538bcf","members":["50f1174a-08eb-4deb-95ba-76f62d759c76","e70bbfc7-4a2f-41e6-b9fd-3d7557e55620"]},{"cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","members":["ea95d42d-e9aa-45b6-af5c-976b9c11f2ba","5d97ba40-893d-4e0a-9deb-9667147e6912"]},{"cluster_id":"212176d0-9b06-497d-a8bf-0b53076513ff","members":["b023faff-5b70-40e5-b254-11c7f10c29ec"]},{"cluster_id":"4a3bc772-20e9-4711-acc4-eb16f1a71bea","members":["b1e0d961-3385-472c-8e94-26289b31ec29"]},{"cluster_id":"cd4e973d-ac94-4c83-952d-356fab535a21","members":["fa2ae5c7-93c7-4595-a5db-6732ac0edaed"]},{"cluster_id":"ef502c1a-5f03-41b4-be90-14e6e1785625","members":["42750b95-0b11-44f0-8b26-122cab54ba96"]},{"cluster_id":"3a774e33-2c16-4d7b-91f8-38103798acd4","members":["f0663ed2-c5fa-4b7d-99ed-494d2b27231c"]},{"cluster_id":"4eb89d26-0914-45a8-8a2e-98708f9a3315","members":["aa03710a-4889-481e-a336-bbd930f5f797"]},{"cluster_id":"109acea7-1d98-4f39-a38c-6bb5919965c9","members":["a71525b5-768c-4767-8b13-031710af5365"]},{"cluster_id":"6103c4f7-8bea-436e-90d7-0ed75fe275c5","members":["31dfdbea-5af4-44b8-87f0-4cabe7e56d41"]},{"cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","members":["1d38276f-ddd7-4554-b6c6-5dd3f82835b5","f236c3eb-1e72-435c-8a05-422be25ed158"]},{"cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","members":["2c218d15-cd5a-4f9a-a7cd-8391abee9126","75deecc6-6c67-4640-8c9d-7b6492f73f3e"]},{"cluster_id":"c438220c-6784-49f7-a890-f0ef46c3304b","members":["d68d0851-8bb2-48b0-95f7-48e00ff3fa22"]},{"cluster_id":"9ce1a265-b79e-4040-a0e8-f1a6fbb59f67","members":["2de9d081-90ae-4725-be06-bc7997c3d9a4","602a284b-62dd-4480-a4ed-2f81e13007e2"]},{"cluster_id":"e15501de-8202-4040-803d-8b5cbf6cf53e","members":["86d3a938-31f3-42cc-be89-5a26acaefcd1"]},{"cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","members":["c56a3e4f-f384-41f3-9b59-2851b9d79bec","18a1c6d8-94f6-43cf-87cc-29cc134dcb1c"]},{"cluster_id":"0b400fd1-082b-403b-9ea9-8d3710e7cc9f","members":["2a7dd7bf-03be-44c6-a411-eac8687044be"]},{"cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","members":["d2aa06b0-d943-42f3-9874-e68f023ce72d","e6596626-ac9a-4f3a-a794-8b5b8e63711b"]},{"cluster_id":"0df84ab3-1fc9-4f33-8710-bd9c228e4c70","members":["8df4bac7-c73c-4dc0-87d2-f1212f551f20"]},{"cluster_id":"8fa6723f-9341-42e1-b24f-456c511e2eec","members":["14726b46-4a6d-4be0-9221-effff997629d"]},{"cluster_id":"ab1f8fac-3632-4188-90ae-a2c911b8425d","members":["b35936a9-3b33-43a1-ba7d-8853a326579d"]},{"cluster_id":"91b0db25-32e4-4e5d-a32d-911732cbec28","members":["bebac3fa-67e3-471d-9bb4-7990f8ab9e35","80600e8f-ca1c-4a49-a344-25d0c769ba95"]},{"cluster_id":"8ae7ec4c-38f4-4117-962e-b6f044038377","members":["f7acb1a4-fdd1-4438-b4c7-bddf4228c92d"]},{"cluster_id":"11b24695-ec58-4b46-8411-89fe4137f816","members":["1f60b707-aca0-4ce8-94a7-3c7ce5e28b30"]},{"cluster_id":"574951aa-9eb6-4bdd-ac47-891b328c28fb","members":["0846c7c9-d25d-40f7-ba2e-ef15baf62f6a"]},{"cluster_id":"8bc3dd02-5989-4bb6-8266-c27296d666f8","members":["5ad3a25c-7d15-4326-91f8-e874a44447dd"]},{"cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","members":["db4c87aa-d882-424a-95d5-b5578f4f2152","efa9739d-2b3c-43b3-985b-ccda54d8a4fe"]},{"cluster_id":"68892c5a-f791-4608-9e40-b67a54dd50f2","members":["24566c65-9f5d-4bd6-b64c-2a2e091b9728"]},{"cluster_id":"9a34d174-5513-4924-bed6-11de3ec56881","members":["1894f815-8eb4-4675-b927-6c8249ff84d1"]},{"cluster_id":"1ec4a683-16aa-481b-9033-75779c52f6c1","members":["dcf9c1d4-e6ca-4d30-ace3-96e46222ed7d"]},{"cluster_id":"21240c8f-29c6-42ef-b002-a537a743739b","members":["7322ffb4-986e-43b6-a289-c5827e12e8f1"]},{"cluster_id":"334a3914-b271-4b2a-83fd-f8bd4dbb0c53","members":["b3c6fc08-ff96-4920-a354-15b497d8edfe"]},{"cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","members":["fa2d3b46-ac03-4fcc-b33c-18d30b2c4e41"]},{"cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","members":["867931bb-b8a4-4cb6-ad3d-18694cdf5189","dfa79aab-78cc-4f1d-a545-ffcbdadc9fd2","4cdd0773-c021-4555-a38c-ec5f0bfad7cd"]},{"cluster_id":"1e8d5556-2c0c-4097-b606-9907a5dd2afc","members":["8ced6a55-2895-4cc2-a608-c1df3c474d3b"]},{"cluster_id":"04fd43b1-9ee7-43b3-b1fc-e9fca576658d","members":["20f56042-1a06-499a-9a53-f1e0b345af51"]},{"cluster_id":"0119782a-5d22-485c-b58b-6c82b20e788c","members":["6d859cbf-141e-4be3-88e0-87f0a8be70a7","402a5e79-9f4c-4cb8-9b67-00a92037de67","839ef5b4-46fb-4fc6-b490-2b3b13d09a4f"]},{"cluster_id":"ff47f0b3-49ae-48d8-b9cf-5707589bed0f","members":["2f03eb76-3789-418f-acd7-9c89021472ee"]},{"cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","members":["c2ffff69-9282-4c9a-8f22-78688403761d"]},{"cluster_id":"5ac433e4-bd1e-455d-8c24-e981eb354d77","members":["c5e44e6f-0c01-4822-b77a-dc30293d5ea7"]},{"cluster_id":"be29b74d-f560-4279-9339-cf00d4dac2b0","members":["f4c4875a-42a8-4b5b-b769-7eec26034c77"]},{"cluster_id":"492eadfb-99f3-4bc3-a9af-afa12d93eb99","members":["79d30802-4291-48d8-bf33-f5ca167da388"]},{"cluster_id":"de7a466b-9657-42fc-adc1-63e65b4ec1ea","members":["d229a86e-367a-47c8-903e-80f4d9e82156"]},{"cluster_id":"6b000975-482c-4a87-97ba-4b7f79318bd6","members":["b77e829a-afd0-4982-a1d0-632e6e32244c"]},{"cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","members":["ec0e07a0-d0c8-43d5-9844-0943301e2a36","94c87795-abb6-468e-b1bf-4a1f72916947"]},{"cluster_id":"43fa6264-b651-4eef-9023-b4483c40f5ce","members":["86784e6c-8177-4b9d-a572-6c55c2a97eb8"]},{"cluster_id":"ff70f7bd-e1b1-44ea-8b32-024f3d1917ed","members":["41fc545d-ae89-4a1f-8d9a-18c06042a01e"]},{"cluster_id":"1da5d8fa-d5b3-4c58-9989-3b5775687e42","members":["c2847424-d6f6-48ec-99f4-a78270737a29"]},{"cluster_id":"bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a","members":["c63562e7-2f47-4cef-bd74-f956b86a4576"]},{"cluster_id":"5197019b-eb26-4b32-8e4f-5890ab4e562a","members":["a9ca3233-bd0a-41f1-b2e0-8f1f725fb225"]},{"cluster_id":"24d4d508-a837-441b-b87c-de6ead3d7582","members":["7b7ca705-46e3-4c64-9380-8eb6e0d18334"]},{"cluster_id":"136829a8-989b-4ffa-8ef0-ec23f5f18819","members":["20358a0a-a0d9-4286-89ba-775b060e8441"]},{"cluster_id":"b570ae3c-f72b-47a9-b995-64ca6b5f3ae0","members":["a3f7a543-8c54-4f0f-8be8-28dc9d6c0dba","735c5752-3e87-4fc3-b8bf-149a8cb9936a"]},{"cluster_id":"059205f2-0c13-465b-ba40-83a1ffcbcaa3","members":["21b0d791-0ab6-4fbc-a453-4665aa2e2382"]},{"cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","members":["3442f73e-73e5-4882-8dab-66506922b48f","6b684f88-2189-44bc-ba7b-ff150306e2c6"]},{"cluster_id":"6bcd764d-320f-4851-ad8b-859177f022bf","members":["98ad1a45-cda6-4e1f-8781-f3b161967bcf"]},{"cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","members":["2edc3bf0-a4cb-4dd7-9c14-a4818bf63cad","4493c186-ce66-4d2c-8241-c61003cee988"]},{"cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","members":["88214d23-e54a-4adf-b1c6-03685d8f9c6c","02f967fe-336b-4f09-8746-3cbc504bfd90"]},{"cluster_id":"62ff82d6-7a81-4618-a5c7-dad49908ecf4","members":["43fe8af9-e5e1-46ca-9396-01915f4ec799"]},{"cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","members":["63f980ff-a871-4da2-8501-e19ef4784b0b","d4310cbd-b465-4be0-904c-ddd4775a9508"]},{"cluster_id":"59d7630c-86a6-4185-b052-67ad13c627a8","members":["244fcfc2-dd34-4fbe-98e4-81f80c8c08c9"]},{"cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","members":["709e80f4-fb04-445f-b9c8-885503b4171d","3b9d9666-2869-4df3-9b66-779b29564f56"]},{"cluster_id":"77ce5be7-73f4-4876-9446-d5aec1b02a1c","members":["b6e88a3f-5dab-496a-8af6-b690d55aa904"]},{"cluster_id":"644ce0a3-b992-4dbe-be7f-558277802f15","members":["e81c3aa2-be13-43d5-9a64-6562964c293a"]},{"cluster_id":"258085e5-fc49-48d1-b3f4-3f9862c3ba91","members":["50cc82f9-6fab-455a-bcc9-d17aed021f1d"]},{"cluster_id":"21228a2d-48c0-43f0-b18d-e85ff94cdb4e","members":["0503bed5-4d7d-47ad-bd61-fa9f13662226"]},{"cluster_id":"f8ceed1b-ae48-442b-9e71-03f2203d7e38","members":["823f891a-b607-43cf-9976-5c5774141517"]},{"cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","members":["d4ca06b7-dafd-4b18-9208-e5fda4a6070c"]},{"cluster_id":"42d845ed-aaed-4d48-a0e4-2928cc3ba602","members":["24994368-cbdc-4f55-9672-f292140ffb65"]},{"cluster_id":"af144d2c-f8aa-40f2-9250-f41cd71f8fd9","members":["0cd33477-f197-45bc-9d03-254b7ea91b03"]},{"cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","members":["ba2de5ac-a509-44a5-bbe8-5a1276566e62","da22d1f6-dbbe-49e7-89e8-194fddf2bee9"]},{"cluster_id":"b180d822-88c1-4c5f-a386-c975497c4a85","members":["3438a90c-54f2-4270-84a6-974f333b08d2"]},{"cluster_id":"14d8e253-98cf-4b3d-83df-8665b7ba0f5e","members":["142195bc-ce0a-446a-a197-82133bc1bfda"]},{"cluster_id":"21956ecc-f782-4f55-8347-f78333fc6d97","members":["0baf6d0b-4f91-4d6a-9da3-83f030ad66e1"]},{"cluster_id":"24f6a0c0-6612-4488-bc48-40d12340ab22","members":["717943a2-2909-4b7f-9745-882b8c2e2624"]},{"cluster_id":"f34203f2-30b3-4686-b2f0-e124d8a67272","members":["5f2ca378-ca40-4a54-88b9-ce966ac550a5"]},{"cluster_id":"3b793f1b-9892-4efb-9252-e394792997b5","members":["be381aea-1470-495b-a705-3f0402b74c43"]},{"cluster_id":"07438861-a868-47ed-8a1a-288138dc65c0","members":["6618192f-d9d0-4608-8d78-16d5b77810b4"]},{"cluster_id":"20c941a8-b922-48e3-8e56-e49e1a524fd9","members":["f4c3a3a5-c6ce-4414-b615-0c69fab214c7"]},{"cluster_id":"7a8e190a-4532-4e4a-b5bb-60a049f869c1","members":["5e5c4927-3a0c-428a-bf40-0eb609878217"]},{"cluster_id":"3c28af07-0879-4e0d-a892-8c0d97f3e49a","members":["0c5f39e5-63c0-4191-8b6c-40ae97875fb0"]},{"cluster_id":"c83250c9-87a2-4ec5-822a-e2413ca91c91","members":["588a55b7-6e3c-45c2-8364-c5ef65a60b7c"]},{"cluster_id":"958b1512-4a3e-4d41-927e-a3072dd9e9ef","members":["023c4c57-2967-428e-b72f-9beb8f0f4f20"]},{"cluster_id":"33c9ef05-1d84-4ad3-be17-1fea5c70facc","members":["a5277d1c-96d0-47fa-b6cf-3d93de47a11f"]},{"cluster_id":"87a15594-c8d7-4860-a888-b2469a7e65b5","members":["a9826696-7be0-438c-8926-1ad2257b1a62"]},{"cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","members":["ff2a806d-e6f1-460f-9f0e-712d721ec08f"]},{"cluster_id":"b523cd60-7c0d-4c50-b41c-3522aed9c4b1","members":["c3257842-d857-4799-8fb0-ecbada1492d5"]},{"cluster_id":"bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75","members":["0a533773-d2af-437e-b15b-24397d33e008","aec47440-0cf6-4af2-9a55-32c0280b3e20"]},{"cluster_id":"1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254","members":["a52a2dc4-9a7e-445b-840b-aa2a71bfc7b5","3aaf279a-f852-4457-8c74-5b5f4414f3a4"]},{"cluster_id":"e2621663-e9d9-45c1-9069-fa9d94c82303","members":["9f80744b-cde3-495c-a2c1-e651a81c9ae3"]},{"cluster_id":"693ef972-4622-4c6c-9268-e5c6a072dd31","members":["7f1b05bb-bbef-4f51-accd-291a84b9c779"]},{"cluster_id":"dde1cfea-875f-4bd7-a73a-639065b04c0c","members":["22a6c6a7-6139-48a0-ae57-b4c6ba1bde74"]},{"cluster_id":"b2568d68-53d4-487c-b724-0456b247a886","members":["ce65051a-c2b7-49c5-b4ce-6b061e39b289","7d7b06cf-63d6-4416-a5a1-d200e94b5a97"]},{"cluster_id":"10bf083b-35c8-4b77-a2d9-e4cb3813d9fb","members":["798f535c-e291-4f87-bb0b-4a6a4f468191"]},{"cluster_id":"15187e94-76d4-4323-bc9d-67428e138efd","members":["79fca050-3a9d-45f9-9935-b4b5b72a6503"]},{"cluster_id":"2fe8d49f-63a1-4171-af68-9824e47b825c","members":["c993fc46-d4e7-47cb-a26e-d3c5e2928b18"]},{"cluster_id":"93d1eed5-3c1d-4407-adac-a9d52f51c6e8","members":["553f676b-b93d-4694-8dc9-9f0bb6432591"]},{"cluster_id":"5acf0ec4-be26-4926-a6a6-508ec71aaa6e","members":["4976ee3a-3784-4d3f-9857-73c8195327ad"]},{"cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","members":["c20f1eec-25ed-42b6-ae82-6b5b0393c7d3"]},{"cluster_id":"e6bef1f7-9387-45ab-918c-0df479862034","members":["033f04c0-b501-478b-9f25-fa6b4d2ca4ad"]},{"cluster_id":"14a12b13-500d-4488-86b9-0f65fe548f9c","members":["37839e78-27f0-4435-b8ce-f71a4f116bed"]},{"cluster_id":"f1461740-3766-4178-84e8-17d9b70838ae","members":["e5d00f8a-9ceb-4743-83a6-8d6bf5883043"]},{"cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","members":["8e186830-bee5-4aca-9ba9-f6ab92a6da54"]},{"cluster_id":"81062452-735a-45ec-ae26-d06b90c45ed4","members":["e3a04279-fb73-4013-9f74-419385217d64"]},{"cluster_id":"9571d5a8-94c8-43e8-bdfc-93e045f2bdd4","members":["758b9d79-89df-4867-81a1-838437e6a859"]},{"cluster_id":"2ab59d09-09ca-4583-9e99-8189ce8c9335","members":["354932c8-6ae3-482e-80c2-1ec5fb490ed6"]},{"cluster_id":"ab1842ba-5e92-4ba8-ab55-1241a116a859","members":["ef3e88e0-f84d-4da8-96d8-9f775591b9f0"]},{"cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","members":["943c7207-e112-481d-9818-bf98c872d3f1"]},{"cluster_id":"637d133e-6c19-4fa2-b174-de1d016bd9bc","members":["c05b569b-31f7-4337-afce-74533292fc0b"]},{"cluster_id":"44a47e28-efc2-4e0c-b9c2-18a93b3b20be","members":["3f92c6cf-d089-4d51-afd0-5cc8bf719664"]},{"cluster_id":"5518570b-ceeb-400e-8720-a531292d57ce","members":["f579b180-4bcf-4616-8cca-c6611dc5d22e"]},{"cluster_id":"8ae88722-b8db-4d5b-b13e-130f65630e05","members":["9a51ca5a-08a2-471d-b0ef-7059646f9b98"]},{"cluster_id":"86e16ba9-dba8-4cea-a0d4-df8a8a69d565","members":["4d3c833c-1a92-4746-ad0d-5c2840c14110"]},{"cluster_id":"74f0249d-eead-4904-bdd3-cd8cfbdb6b82","members":["fb699657-8103-453e-938a-f5daa0ea13d1"]},{"cluster_id":"e6759e4c-f697-49ce-a969-2f596e5c4293","members":["cc684206-59ef-4f1d-9a3e-0ff4eafb7fca"]},{"cluster_id":"329c69a1-8578-4615-a95d-4068857af2c9","members":["85dae113-29da-4a75-b868-215745825ee0"]},{"cluster_id":"92b8820a-be27-4c75-96b0-6d6932996a93","members":["ac309972-39c0-4c22-a9a8-2e21189a182b"]},{"cluster_id":"baa116d7-3e4a-4d22-809b-fdab138f8d83","members":["23d5acde-9eb1-4641-b65c-7f5d94d7b611"]},{"cluster_id":"b2871022-57c5-48f7-adcd-caeceec2edeb","members":["0c3ae337-f9bd-4232-8dfb-2940624107d2"]},{"cluster_id":"99d9484d-46ae-4ca2-98a1-dd3e0aeee99d","members":["9f15f89c-d1c8-4a2d-8528-9d31c8654f08"]},{"cluster_id":"f8755b86-ae98-461e-a3ac-2bd5b6ec4310","members":["4e85a632-df9b-4b75-a026-4f6406a638e4"]},{"cluster_id":"da2845de-4e1b-492a-a6b0-06fd4584650e","members":["bfa02948-129d-4df1-8d02-32c7106ce1a7"]},{"cluster_id":"45d5305e-53a9-4659-a1a0-2bf0495c5055","members":["8f2a8ba8-3a4a-4936-bf7f-34faee9aa1e3","8317dd6d-21d3-4041-ba08-d341e9d5d4ec"]},{"cluster_id":"7123d027-fb9c-44c1-becb-087b98c76740","members":["f97d0478-9be5-4fc6-a5f1-680f08d3eb14"]},{"cluster_id":"cefbf586-5d05-477f-8675-6637fb8781a5","members":["e3ab94bd-6ae1-4890-93b1-11b533431a94"]},{"cluster_id":"5a861756-5d94-444c-84a0-fab63d482e8c","members":["dd5773a2-71e4-444d-8c08-6f13e54af348"]},{"cluster_id":"09f8ca5f-e359-4e32-b6bf-f706de588232","members":["0a1a6190-eb21-4894-b6b5-c8613a05b0a6"]},{"cluster_id":"0f388428-daa1-4ce6-a7b1-8c553ad3896d","members":["093d75a8-822f-4e74-8fc9-d38c1bd278b6"]},{"cluster_id":"370919c9-f171-4096-adac-3abd415be93c","members":["e3571f4c-65f1-4db3-897f-fe9736b10446"]},{"cluster_id":"a9096ed8-3c07-4fd9-a21c-9fdb59fe1353","members":["fe77b063-ffc7-45db-bf3c-30d1345de127","b93a9e77-ab9a-4624-b53a-56550ad2223d"]},{"cluster_id":"9f57df89-5e8e-4a14-b028-a41d27973fb5","members":["e598a674-f687-420e-961c-9e37ddf343d7"]},{"cluster_id":"5c0df4bf-ba62-40d1-a306-8313dfe790e6","members":["e3c43223-3600-4873-a0bc-96a7a3028392"]},{"cluster_id":"839faa06-15df-459d-8f1d-015981c670e0","members":["733f152b-a575-4502-b706-11073df8c68c"]},{"cluster_id":"424a981a-fddf-4933-92b1-158cbba9a861","members":["7c2428b6-5481-4361-bde2-ecc9321746bb"]},{"cluster_id":"5d8dea5a-b22d-41be-9ea5-91141c9a7614","members":["cd709fbf-cb82-4ab7-b2c2-2da875059189"]},{"cluster_id":"8b2d10cc-94ea-4d53-a196-ecebccd79020","members":["3ac406b0-e68e-49a0-bd1b-2528853d2cad"]},{"cluster_id":"a72e319a-9e87-40b0-a2c4-a95e4857ac8d","members":["65185d34-b527-468c-beb7-4b55954d027f"]},{"cluster_id":"dfd567bb-1650-495c-ac2d-4d240d441b79","members":["7b1d1801-aa76-41eb-9f0b-d7d9461b7987"]},{"cluster_id":"8d8dbda6-96b3-4738-b7a8-777f920a39be","members":["589edca3-47ff-4fbe-80de-c38bf691870b"]},{"cluster_id":"cc2021eb-f979-4db2-af0b-d0533b90627c","members":["d41f05ae-a077-4b43-a1ad-50f0a3215fad"]},{"cluster_id":"4a042392-1467-4ea4-a1a6-548cd972a82d","members":["0dda44fb-e789-409d-8884-402c50cfbf09"]},{"cluster_id":"ccd217d6-af54-4ddb-bc5c-7413749df148","members":["c8ab785c-bdf9-4974-a4a6-0fa8e1e04427"]},{"cluster_id":"009e9d6b-ab96-416d-b96e-b7eaada086cf","members":["0f5a9041-d107-4637-af27-c903436d7f31"]},{"cluster_id":"40860ef8-1ebc-45f7-84a0-735bcdaf070c","members":["a9f42078-b13a-4273-b720-2b85621b9479"]},{"cluster_id":"451cf0f3-38b6-4124-8f93-0e300d12c170","members":["96bbb94c-4f84-462e-8d41-121eef67b842"]},{"cluster_id":"d17d8e48-7844-4b9c-9bc0-e31d87299aef","members":["feef1b5d-6fca-48b3-b6e7-7e296b05c53c","ec89a7d0-444c-4a68-8ab2-49873e2d905c","4227afee-e3b9-478c-ab36-4fde24ad8ff0"]},{"cluster_id":"731adffa-9e59-4f19-8d10-ec191098b454","members":["b5ae45b2-5d16-4b5b-aa3a-5576d28dd426"]},{"cluster_id":"9f0480ce-b886-46fa-98f0-af8144766c6c","members":["c9e9a73a-9805-4a55-a450-6162c6ec9b71"]},{"cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","members":["17354fb2-74e2-4dea-b9f6-3b313bc2f042"]},{"cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","members":["6bf5be7b-0915-44fe-9e53-1db09cfb0aa9","fa5f8415-ce48-47e8-88c5-998e13fb6afc"]},{"cluster_id":"3045aa88-88d8-4410-9d93-f305adb15fd3","members":["f2352fef-7f02-4458-a866-639bd458c927","128b6e5c-66bf-47e9-8a97-73b4406df76d"]},{"cluster_id":"6e43ff1d-8cc2-4d06-859d-7e968536001b","members":["45820d42-2355-436e-9fd0-498d37c06918"]},{"cluster_id":"74c84f9c-121d-41ed-8a45-f4cdf85eb02c","members":["95cf57c8-db12-4b02-9ab4-5f125ec8e52f"]},{"cluster_id":"57eb29a4-6d1b-4f98-a507-b97e4235688c","members":["4c6cf093-805b-4e3a-992f-9702969ee316"]},{"cluster_id":"40739d2a-a8c2-4f74-ad24-d1d6db92d225","members":["de30d744-016b-4318-8ab1-056f6e5e884e"]},{"cluster_id":"5677f10d-93dc-4b72-b95a-8bc4291ec487","members":["4a4a457b-1325-44eb-8e2f-f16ac98bf1da","7c99c381-d341-4d06-986c-97983ad65b7d"]},{"cluster_id":"4736fddc-4878-48ef-a211-f6b0740cc434","members":["ff19f0d3-d83b-4d15-9bc7-3f167453c19b"]},{"cluster_id":"42b71be4-55d8-4880-8083-4a89c8557de9","members":["b5df04a7-2e6e-434f-b9a5-1ea3d3c335c4"]},{"cluster_id":"dac4f0e5-e31b-44cc-a055-3ac65eec9d11","members":["61c001bc-aaeb-4697-ad48-4e975f4f2e0e"]},{"cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","members":["f275225d-6b88-4d4e-a09f-ec6c1ba1b714","ee7c22a9-cb5f-4b56-968c-6ff4e664ea5b"]},{"cluster_id":"565acc40-efdc-4957-85fb-8602f0587aa9","members":["36ec8ad7-b079-409a-bf22-79874f231a2e"]},{"cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","members":["3a47fae3-bbb0-43a2-ba49-1814af0c3582"]},{"cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","members":["7729c1e6-daf9-43e8-8f05-13d5abb67363","eea5831c-1818-49ff-a840-70bc989108d8"]},{"cluster_id":"f4f13b9b-3296-4913-8eea-62ce1becaa2c","members":["ec3f7c59-e418-4dc7-9051-8e61a0e8e5e7"]},{"cluster_id":"4370b159-681b-41a0-8da8-22c407b09da9","members":["22c7b5e2-c0b8-486e-ae92-b3478ba3a159"]},{"cluster_id":"09e579b4-c608-4bc3-a02e-890bc6f5969d","members":["d7bc4506-898d-4cf0-99e3-6b4c693e9ba2"]},{"cluster_id":"0a0082f4-5a11-4bce-aa5d-1877fddb104d","members":["f99a79a4-6ea5-487c-9ad5-126653491c6c"]},{"cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","members":["df0444fa-0108-44fb-9a41-a5ccb4264275","628d2d95-6e88-45ac-9fba-404f17e734d5","9843893d-6690-400b-ba52-b3d060a45f1e","a6c78845-da38-43de-ba0f-357aff013c2a"]},{"cluster_id":"dfe5555f-7179-45b9-9f7a-919fa1cc1569","members":["320d86e9-05f0-40f0-a64d-f3a23a09f492"]},{"cluster_id":"4ea56329-d3e1-48ab-835d-a5cbc403dcf0","members":["e6b8b24f-3c1d-4b2f-8758-4cb1449207a6"]},{"cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","members":["aae86df3-6521-4ed4-a063-13ca198344bc","54cae87b-07e5-4e39-acd4-c29514c871df"]},{"cluster_id":"e968bf8c-b2a8-4330-bf71-9cab4f6826a5","members":["9333691c-9fac-48f5-b168-51ba9ba9ce6f"]},{"cluster_id":"c782b8c2-e8a6-49c0-98b9-40619e415dcd","members":["d1a16d25-6596-46f5-898f-d0b42f956fce"]},{"cluster_id":"83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2","members":["6d0f0417-0ad9-40ba-bddd-2050e41aaf92"]},{"cluster_id":"bbf49577-7eda-4f96-83ed-753d3b9cc708","members":["5767beb0-c933-4e88-9be9-fa25294894a5","2c6d6c0c-581c-4afe-a3a8-fea66abbc95f"]},{"cluster_id":"46a0b407-50f8-4cc9-968a-6955a0540862","members":["88586791-dac7-4eae-93f2-1f5088deaff3"]},{"cluster_id":"1d8a91a4-e2e3-49c2-838b-462dda682ab0","members":["d2b91e1b-119d-4b46-a45b-d31503811126"]},{"cluster_id":"affa89a3-9b82-426c-9616-b589325af10c","members":["e45969f9-8906-49c4-91cf-ca8b972acfa2"]},{"cluster_id":"f15167ff-a614-4854-ae28-529950f00bdc","members":["476a7a56-ac30-4d52-9a28-cb6771609992"]},{"cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","members":["8f48c0c7-9599-48e9-8266-33bb81928adb","4b32edf9-0d33-41e1-99d5-1ab79fdd6ba9"]},{"cluster_id":"13dd3c2f-f547-4b94-b763-665ce078453e","members":["56c79572-5c21-4aff-8ee3-d0693b0a5f53"]},{"cluster_id":"5284ded1-5c85-415c-af66-ad36ef47b3e7","members":["12ce5ef5-db4f-4329-b817-14e69033510a"]},{"cluster_id":"452c2457-4da2-4edb-a49f-86f139410e4f","members":["a2032602-1b45-4927-8fd7-e58380efe7e8"]},{"cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","members":["c9dc8b79-d140-4e6c-a007-cee5b5e4d7df"]},{"cluster_id":"fbea59dc-8fdc-4fcf-ac76-32627af107ae","members":["aa5e3ea1-6aa8-4949-b5ea-a17f75263501"]},{"cluster_id":"fde51b3d-8646-4df9-926d-484efbe86dc8","members":["1d741e3f-f006-4b3e-a634-e8430d392812"]},{"cluster_id":"71522ed0-7107-4dfb-8b87-e633332c4e3f","members":["5ffa8173-142d-46fc-8a46-e6ede611a7f7"]},{"cluster_id":"e633b9f2-d6c2-4c51-83af-0aed2e577009","members":["b88d61fc-871c-45c6-9a1f-465e76dfe0e5","fafcf85e-287c-4677-80fa-62bdaa6b7702"]},{"cluster_id":"ec67de7a-3e2b-4e45-9df6-6bb76aa7ed80","members":["01d346e1-324d-498c-9e77-d15d8c02410c"]},{"cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","members":["8752aaa7-c117-409c-97a5-33654f99a19e","80ea9af8-8a68-4a19-ab6f-12c7ca5127a2"]},{"cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","members":["39ab6769-1890-429e-b317-731e9a4eff85"]},{"cluster_id":"74f7c7d8-aba9-45e9-a386-fbb258dd884d","members":["22c52ca6-b7de-45b7-90e8-f17840ef578d"]},{"cluster_id":"c6a49139-3f4b-48cf-8d38-e5b344108df3","members":["f36689c9-d8fa-49ec-849b-0826304fa11d","01d989e5-2d84-4128-896a-c4bd413bca98"]},{"cluster_id":"b5be89cf-6e40-4238-b7c0-13411fa17ce6","members":["09b4e52e-8c85-4f99-a325-574e2b0f7690"]},{"cluster_id":"5a33a893-0ae3-4e2b-9f4c-02de9772f96c","members":["1ea2d7a3-eaf7-465f-82c9-4ff74a567e2b"]},{"cluster_id":"cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb","members":["95591809-ea32-440d-bc8a-6614f1dc69ff"]},{"cluster_id":"ced45aa6-b370-4a79-b76b-674fcd6c0668","members":["a98efa16-89b0-4b36-a563-e8a6964e5dda"]},{"cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","members":["4f973af5-b56d-47c9-bb96-aba7882312eb"]},{"cluster_id":"6442657f-3626-4ac3-8a02-28b3c72e00ba","members":["ef196b0f-45eb-4409-8ae0-5474c6c35470"]},{"cluster_id":"5ec8ba1f-609d-4689-8317-8045f6c09e77","members":["16c59c3d-069a-48a2-ae37-ad52d70c88d4"]},{"cluster_id":"a5706e56-c643-44be-8e44-3c19fd9dcc29","members":["30a36220-c2d9-44cd-b29f-46744923b417"]},{"cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","members":["9ee9fd26-4cda-4482-a159-a1dc52f4ac09"]},{"cluster_id":"f309b6e7-458c-4f62-9d98-f12cb2e89c08","members":["4c7b40f2-2b81-4a1a-b5cf-5c2a0da3733e"]},{"cluster_id":"a7436ce6-07d0-45e0-8628-2de252e4cb46","members":["7dd0ad39-1c10-4dde-b71b-8e7fc0ead843"]},{"cluster_id":"8ff59597-495c-4ba5-b797-afb88f6bfce0","members":["e4116e8a-c10c-46d3-98cc-ee87429a5fd8"]},{"cluster_id":"3d647896-bc7f-4815-a99e-768cb2498250","members":["f91205ea-2d89-4257-9aef-cc7efdc62003"]},{"cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","members":["efa402f0-22b5-44d8-83be-4aefe71ff19f"]},{"cluster_id":"7e245bdc-e727-4627-a96b-f1db937337df","members":["1cc700fb-8ae3-4f9f-9bbf-2d20e10fe90c"]},{"cluster_id":"e11a5f48-4afa-40b5-8724-9f7420d483fe","members":["ba278d3a-b34f-4a39-b924-1c268c771e7d"]},{"cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","members":["b4b64a7f-18d5-4109-8ab5-2151c1eb53e0"]},{"cluster_id":"194a083f-fee7-4bf0-b198-fa40c8bdfe21","members":["7e2549b0-4be4-4af1-a07d-178f191ff255"]},{"cluster_id":"33588f3c-4f55-41eb-b5d2-57696a57221d","members":["6ff33f56-8167-4fb4-a217-9e2fd0587ed6"]},{"cluster_id":"22fed294-324a-41e6-9f14-7b92ebc22681","members":["e4e4f22e-742d-4857-ac91-0adeb6cc7a75"]},{"cluster_id":"9fc7f408-c42c-485e-91c2-a72960ff3158","members":["2a6bc326-3688-4af4-a70b-a9128cad92ee"]},{"cluster_id":"82430ac1-c5b1-4777-ac21-a40819c2ad02","members":["d37b5b73-be79-4707-93d6-b1619e360bd7"]},{"cluster_id":"d61fc1c9-1533-4eaf-88f3-8d0340ce2de0","members":["9e9314e2-b3b4-4bb0-bbb6-80e2a791d407"]},{"cluster_id":"6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1","members":["6de9b109-7d60-4dbd-b946-2f2c248e99ab"]},{"cluster_id":"d5dab78c-a52b-4ef8-8000-44988a029a7c","members":["f2dd708b-da06-4d95-80e8-dccc8a2c283c"]},{"cluster_id":"8b93bbca-8559-4acc-9d3e-382347cd5269","members":["02712107-dcf0-4356-96ab-4e5cc05a1d3f"]},{"cluster_id":"af3aa521-118c-415e-b54b-524628af7168","members":["d6bd9722-09de-4f4d-ab20-04a79de1c458"]},{"cluster_id":"23dcfd5c-77ee-4590-92a1-d00d1da215c4","members":["d1a5138e-9a0e-41e7-9b59-b1ed6f92f735"]},{"cluster_id":"199eabc9-e7b3-44cb-a574-bbc02ea956e5","members":["d244e0c8-2ef0-4e93-ab92-9c12d8a1b325"]},{"cluster_id":"e3e8a87e-df24-4ad1-b44d-15176f0a0f6f","members":["86ce935c-a686-4874-b90f-73593cf768d2"]},{"cluster_id":"86cde8dd-df84-48da-a045-d001baaf3298","members":["49c51996-7793-4d11-83a8-f7fba16e94b6"]},{"cluster_id":"b98bb0fa-4594-47af-9069-f482aaa8d7c4","members":["46eefdcc-9153-4231-98d5-1f11bb28bd1e","d593ca1c-6b0f-4383-b405-05cd1d56f441"]},{"cluster_id":"0cffe066-8740-4f3f-9c12-d03f093733d5","members":["e6f87d0a-58ad-4a72-a8cb-9808b8bfb5ff"]},{"cluster_id":"ac35f635-837f-429d-a888-0720cf376532","members":["427dc044-8015-40ea-bc8e-7ba7b8003ea8"]},{"cluster_id":"c7d861d7-3b33-4585-89d3-87c9dcbcd126","members":["ab7deee3-6479-45e0-bbf4-5c661a4fe1fa"]},{"cluster_id":"8f15ddff-3bc7-4fbd-9371-1a897f8b9078","members":["bea9af0c-5656-4e03-9868-2e7e2295fa5c"]},{"cluster_id":"7a1e52a1-bd32-491f-a249-5ec36a49aa78","members":["52fc8483-9863-472b-9ed3-98c00e449547"]},{"cluster_id":"d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db","members":["0f25cb03-35c2-40e8-b96a-ad0f42f18adb"]},{"cluster_id":"b7768432-bcaf-4a4c-9bb2-1a6e02c6a003","members":["baef1fc2-a432-4ab8-a4e7-d7111ce18e8f"]},{"cluster_id":"0634cfd7-f7f7-48cb-bb92-7dc813e3271c","members":["c7adce15-79ab-4154-9212-55f8be8b0a39"]},{"cluster_id":"cbd140c9-7dba-47e8-97c2-10198c9c38d7","members":["b69575c4-a47e-4678-a8c6-9757e605d896"]},{"cluster_id":"c065f08a-341f-4084-99ca-ceef465c2c9a","members":["b318e9f9-9a66-430c-92d3-7da39e592574","52975b9d-d2e7-4174-ab1a-5fc71f2f29fc"]},{"cluster_id":"81d9d830-fe0d-4e6e-bc5b-8d4c5f74f4e0","members":["5fec1f94-3bb9-41d7-a93c-2d3f09830f11"]},{"cluster_id":"d0137977-4815-4376-8c2f-58b223088e62","members":["48523f9c-4b23-4591-8c13-f194abb060cd"]},{"cluster_id":"4effafac-8e45-4dfc-8f71-d8c9b1e37d7b","members":["9c1cd331-4595-471b-9ee7-95bb5b6787b6"]},{"cluster_id":"02c78b1c-dd55-4ba6-a345-d21fd27d3214","members":["d950f456-f04c-4ae2-833f-3356da97c464"]},{"cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","members":["236ca972-2169-4708-8479-769f3fde2bb3"]},{"cluster_id":"e8b8352a-472f-4b00-9dae-87cd809f920e","members":["8d553264-2775-4b89-bf31-4e2cde806720"]},{"cluster_id":"c66251b2-ab53-4ca9-91b8-4229e4242200","members":["ef58cdc4-b176-42c5-8d1d-6accb948d1b9"]},{"cluster_id":"61de2e2b-d2da-472d-882f-2c0c14730fee","members":["a0f1ab21-1861-4603-9fe3-8d7c1490bbf6"]},{"cluster_id":"4908cf56-f8a6-4b01-88c6-2c59a4acac65","members":["0ecf2a39-3371-4e9e-a01e-590af98a1838"]},{"cluster_id":"6663d8fb-8d11-459b-85ff-7054f5d07b06","members":["793a15d3-c559-4807-84a5-df29842c117f"]},{"cluster_id":"3afb5a7e-c2f9-4fc4-a379-b0fb650f805a","members":["ad2ec165-9afb-4dce-a0b6-657061bdadf9"]},{"cluster_id":"607ccd27-4dff-4901-8aad-e4dab1d3448a","members":["0f8d6861-6faa-489c-9dc2-42f3b063e07c"]},{"cluster_id":"8b798ea6-1045-45b9-a2f6-023a84ae6ad3","members":["e83d8224-5059-4b16-9c3d-c34ba2eea3df"]},{"cluster_id":"4fc00d95-d399-4677-9437-13f7e6f573c4","members":["90c5896e-279d-42dd-84f9-ee6335fea90f"]},{"cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","members":["1136e8fd-88de-4185-8a62-33c192bed1b7","ac73713b-73db-428f-97d2-fe95896fad23"]},{"cluster_id":"c6aa0cad-31b1-4d56-9f83-938881501dbd","members":["e52c46e8-b089-4f2e-aa03-838e33557d82"]},{"cluster_id":"0543c671-bbcf-49ea-a462-e4ab061c75a0","members":["0465fe3c-5a98-41aa-9475-7b4af42b25aa"]},{"cluster_id":"e8f2c1ac-40d6-4338-93ee-3033faec8f14","members":["e39e34ca-5c88-4450-80b0-ff376e57f4a9"]},{"cluster_id":"e490aee1-21a0-4624-906c-8f2d51f040e5","members":["65750d96-8d7d-46b0-baba-dc7162a0fa10"]},{"cluster_id":"17036568-8b0d-4108-9a16-98a16980ae3f","members":["61a29cad-2475-4939-bba5-941c823aaa57"]},{"cluster_id":"192dfe82-fc68-4d4d-ae38-d6077567ed10","members":["9636465b-c7ed-464d-bcaa-cf1340df799b"]},{"cluster_id":"d8b92399-bf69-4b82-b461-678acbb7e385","members":["4d465014-a97e-4e1f-97c5-c64103818a8f"]},{"cluster_id":"9aca5dda-f273-4941-9e97-91832c08621e","members":["67ecfa74-b6ed-41ce-b5a3-a2bcb926302a"]},{"cluster_id":"017c8345-ee2f-4b6f-8701-6def5bbd5082","members":["148a00ff-6a57-4d0c-a6ad-c35238e59683"]},{"cluster_id":"e5b48b2a-7f34-4409-a282-031c21d5b9f9","members":["d12d23f4-cc6b-44bd-8ae1-8a0ce222ac50"]},{"cluster_id":"41a156b3-5c3d-4d82-b8e4-7ad88953f690","members":["366db116-0531-410e-98dc-2cd7e903c0ac"]},{"cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","members":["2b8221a1-aa2e-4f59-a240-e1dc88d12ec7"]},{"cluster_id":"e40e6c83-dc7c-44e8-8637-389476dedd00","members":["1cb98ff2-9204-46ef-aea3-ac3cb341560b"]},{"cluster_id":"bf3a902c-c644-4da4-8d4f-8ccf8bbcec56","members":["5f32d335-0db0-4fb5-8d1e-89884723fc6e"]},{"cluster_id":"f96fdbdd-0664-4366-b80c-72a8405c4f44","members":["3386479a-ceca-414d-8f19-b6fc28b90bc9"]},{"cluster_id":"84a0c048-8b19-4f73-b588-caa191d08d54","members":["a9bc90da-6884-4eb7-a0ba-5cc5a970baca"]},{"cluster_id":"5521d112-0a05-4e5a-881c-de705171fc9a","members":["57ae861c-706d-4491-b16c-de1ddf59f0b0"]},{"cluster_id":"b7e4eaa1-1521-4096-9aa4-af78b70dfeb5","members":["bd89072d-c992-4588-90d6-5b903ad308c1"]},{"cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","members":["b66910e5-daae-4814-957b-1bf57d03d2d3"]},{"cluster_id":"735fb4c9-5d71-4b3e-b247-9bafaa632b98","members":["93046fd1-58f7-4e4d-ba19-9705a7d94046"]},{"cluster_id":"5863948c-f84b-495d-bfa9-facccb6313d4","members":["cedf273d-4281-489e-99a5-ba6e65e45127"]},{"cluster_id":"8870837d-d287-47f9-8134-1fe8a8f59e88","members":["298d1707-0fd3-4201-8a1e-4560d6ff3fa8"]},{"cluster_id":"d42f0707-162e-449e-86fe-0dd5e2885a21","members":["d5244cf2-bd56-4f1e-b7cd-8275b06653ff"]},{"cluster_id":"6d2792d9-4dcf-4980-9870-d295c7f8e2c0","members":["3ecb35d7-1dbb-4da7-af32-d8663dffc64d"]},{"cluster_id":"1b7b6166-a006-43a7-8e66-beaeaf966eff","members":["1cb65bfb-8150-4bfd-9987-88ff145e66b5"]},{"cluster_id":"574866ae-31fe-4cc6-8d31-fe21c9fdd682","members":["381647b0-5e40-44f4-bd33-12838044198c"]},{"cluster_id":"f833277e-e62d-4240-a8fa-fd6d79db3c79","members":["adfd4ae7-4210-4c62-bfa0-6781d45bcc59"]},{"cluster_id":"30011e47-1ff9-409e-8099-2eff6ab89e88","members":["15a4d950-ede9-4236-99cb-d4ddfab73b99"]},{"cluster_id":"1dd25bce-7fe6-46d2-9e28-e803262696c4","members":["fd40bdd0-c6cc-4711-b6da-f6636f70fdb8"]},{"cluster_id":"acc5b6d2-0057-4a25-83c7-3d3bbd4031e9","members":["350999e3-219f-4b31-962c-d52e4f548e1b"]},{"cluster_id":"011b48fb-6ec4-41cc-bd4d-394e371c18cb","members":["3f2abbd2-060e-4ad7-b5a8-a84b9511e597"]},{"cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","members":["7d9aec94-20fe-4c75-9332-62af6797dc14"]},{"cluster_id":"41dd785c-3146-4243-8bbd-56211fadb273","members":["db528ec0-3250-402d-a8d8-f12011ce042d"]},{"cluster_id":"b2a26561-1192-4739-962b-b9df80083243","members":["6d0a63d8-61a9-4d2d-aea6-4e60a12d2dea"]},{"cluster_id":"3505030f-425f-4631-b164-fc25bf6fbe55","members":["6004ac54-d4df-49b3-a497-d03e67091a98"]},{"cluster_id":"38c3007b-05b7-481e-b44e-c09d28628f5e","members":["da5d347b-5fb3-4187-bbba-c8b354ad6ff2"]},{"cluster_id":"29780617-dcdc-405a-a7d2-26d05fd8f9d4","members":["3e3f1040-d2fa-4f56-a06a-86ea44e3b71b"]},{"cluster_id":"990306d6-263b-4984-88f5-4be9fc326334","members":["e3155177-7923-4bed-b420-8405a93cc93d"]},{"cluster_id":"c5855521-5ebf-478e-a7af-b3f07554a912","members":["07988081-937a-46fe-bd74-5dbb0846b25d","75781163-5d59-4792-a3e9-6565f8963430"]},{"cluster_id":"62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3","members":["2b000b50-a42a-47c1-9d45-30baf3b84d49"]},{"cluster_id":"06b8ffc7-c987-44a2-a2cb-8721e54e7da6","members":["b35919e0-29c5-4cec-8c70-bbdaa9d266d4"]},{"cluster_id":"80abc80a-d540-4e4d-aa41-272690066eb0","members":["e1c039f7-5ea9-4d63-a8b8-4f2855a5116e"]},{"cluster_id":"11d45e31-1956-49e2-b94c-bc4a176c09fc","members":["1278c551-390c-4f62-98a2-54de97930a3b"]},{"cluster_id":"9621dd39-ccb5-4e12-9287-8a404c57bba0","members":["027e4c0a-e0ed-4794-9444-00c62128252f"]},{"cluster_id":"509e1b1d-c464-406d-8d4e-6ab2f46f2324","members":["a204bf60-6b27-4a6a-961c-8a95940917d9"]},{"cluster_id":"6b512fcc-e6a2-414b-8a86-90a11b76795a","members":["b11958aa-8fd4-4167-bad2-bb15154530cd","626c2407-8a4a-41e4-a847-e1a640dd970b"]},{"cluster_id":"62fc9d37-f7e6-43e7-a681-3c5679294ee9","members":["9ea310a4-45b5-4541-a5ba-50c286d295be"]},{"cluster_id":"aafcc6bc-c8f9-4a4c-acf7-9628f64db648","members":["eb6f8055-76c8-4f43-ad76-682bcd9695bd"]},{"cluster_id":"9cfc641f-8857-445d-a3fd-0b6e7a1c0cf7","members":["5632a5f8-a908-440e-af68-fffdfc0964ce"]},{"cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","members":["caa550e6-f9b4-4fbf-816f-cf2925782cd9","a6d49558-eef4-4a2e-9043-3c0c2b6b6bbe"]},{"cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","members":["5ea053a7-6ad0-4f32-b78e-4ce50ee30540"]},{"cluster_id":"7187c5ae-6f6b-4c6a-af65-98db1f5251db","members":["b1f832ca-8dcf-4377-8681-55076f981d74"]},{"cluster_id":"cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb","members":["6fe94112-1374-43cc-82b2-2247c364b004"]},{"cluster_id":"30bb9166-b600-41f8-a7cf-3befaaa1bcc2","members":["5f516e9d-dbaf-4874-9212-04e63b2c7ed0"]},{"cluster_id":"edd65f26-0117-4202-bd31-c3f265210b5e","members":["4f921cf8-8650-4d52-9ea8-4ce66ff4aaa7"]},{"cluster_id":"2b897077-ab7f-4c6d-8c0e-a3493d4e615a","members":["13a60e49-831f-4ce3-b846-219ccc7e8def","8cfdba26-6ba3-4e3a-ae44-73685c31f110"]},{"cluster_id":"290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45","members":["c2cedeb5-1b3a-4ad1-9e16-aff80d97d2c4"]},{"cluster_id":"0a3a7c87-61b9-4961-a698-61129e827319","members":["789c1f08-91d2-46b6-a5e1-6efb269f7290"]},{"cluster_id":"9b129e4b-0540-473c-90ae-ff21e622eb3c","members":["a3f50eaa-34ee-491d-893a-65e72e4e3030"]},{"cluster_id":"c7c25534-0ffc-4f97-99d9-6bf3f3de9b03","members":["92c70728-8a84-4c64-a3bb-73a55eb2027a"]},{"cluster_id":"da4bd748-3c84-4017-a93a-8247224fc32f","members":["54911bf9-a56d-41b9-9a2c-a90b0f8ff629"]},{"cluster_id":"f9e580f2-a45e-455c-a4fc-189d643f07ef","members":["c226c7d3-8328-4f02-8fb0-ed3d0a775a6d"]},{"cluster_id":"21ae851f-14b0-4e6c-8bf6-1ff87dabd880","members":["cd1bcd26-ed9e-4f8a-a582-7a3ef528fe8c"]},{"cluster_id":"95b38f6d-19e7-4fa7-a9de-ee665de84018","members":["5aeb6899-996b-4917-877b-404a648405a9"]},{"cluster_id":"97d6f1ef-2f69-4bd7-b5ce-8c3dd359bfcb","members":["476a39ea-cc28-4fd5-b04d-d950bf6daaba"]},{"cluster_id":"95690f3e-4515-4810-858c-28b7d1da49a5","members":["5cd436e7-5e8f-4fdd-844d-6a1feade2672"]},{"cluster_id":"262772f6-e21d-4ca8-a80f-06c1518ea90e","members":["1feaa18c-a348-4318-9eea-bfa6da8247cc"]},{"cluster_id":"738e60fd-1e3d-4820-98bf-d6bd9e7a3172","members":["52f5053c-34f5-43b5-adb6-de2278fbba70"]},{"cluster_id":"590ca39d-bd4d-431b-829a-90d0f3384aa4","members":["bca440e6-ccd3-48a9-9ea8-b8eae07dbc71"]},{"cluster_id":"2cb357c3-3958-45ce-bb44-f76facb84ed9","members":["8c8ca322-1ed3-4f34-ad77-733d428cd6a3"]},{"cluster_id":"9e4983ab-c919-470b-9bac-8b6c4b633a1e","members":["ddfbf23e-6ad9-4461-9171-4d97b7c80f0a"]},{"cluster_id":"945e1233-33d5-4259-ad28-2899aa78e0e9","members":["4e689837-4d10-45d5-81a1-62d56468abc3"]},{"cluster_id":"c153b607-ea7e-4a94-8f50-d29611d77fe7","members":["34069537-f1d4-4ac0-b377-fd2fd3a315de"]},{"cluster_id":"29c942d6-0549-4857-889a-2fc5fd4cf362","members":["6684e8c5-fb5f-4d58-93c0-7b7920bafabe"]},{"cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","members":["e7ca5d87-eb91-438b-8987-7d1c73be5b0f","ace2a506-60b7-423b-9530-21d89ee724c1"]},{"cluster_id":"36ece2d2-4cdb-4985-90ab-a6751ad5b290","members":["9e551c2b-9a5a-4862-9f0f-273c0b484cad"]},{"cluster_id":"ccf91c48-303e-4d94-8263-0e8c6de64e17","members":["dcc1afda-2113-499e-97e2-4c33cb4d20ac"]},{"cluster_id":"f9ff85c1-1de5-47fa-b9f9-f7450f5b0b3d","members":["d82c2aff-afb9-4f24-aebc-bca6be31b865","a76317c7-6638-441d-8afc-80e7f186b8cd"]},{"cluster_id":"c721dd3f-abaa-46f4-b0b3-0998badfc28c","members":["7ba82044-6885-45eb-ade4-041b922dc24a"]},{"cluster_id":"51207b82-ee2c-47cd-adf4-cdd41f93d43d","members":["f12e9165-d5cf-46fe-8144-3a54d7ebdfd8"]},{"cluster_id":"9adce26b-ced3-4b3b-ac9a-24b78e98224d","members":["9cba1fb6-7b09-4002-a021-c674684b00b4"]},{"cluster_id":"da3ee5ab-4748-4fea-9d14-3bdfe78a1c62","members":["eadbb245-11fd-4603-acc4-b3d1ed7503e7"]},{"cluster_id":"03725096-887b-4dc0-a3ec-0bc1ce57eec9","members":["04fed4bc-0a1c-4f79-ab8b-9dff75e1254f"]},{"cluster_id":"f210a15e-3afd-4f52-8da2-de7a59e25377","members":["a50bbbf2-704e-41b4-be4b-727c9b13dfe6","e2b9e1e1-cd0f-4bea-b60b-2b3a10752ecf"]},{"cluster_id":"7ac1c88c-d620-4c32-9f9d-5a780231627e","members":["763b4c59-9a19-4c6b-b298-ced52db844c1"]},{"cluster_id":"de3dfa95-4771-45cc-8a31-d6c35fbb0eb5","members":["7e91a24e-bb1d-4942-b158-6561c268f135"]},{"cluster_id":"dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd","members":["3e3a0ce3-9d32-4d33-9476-196214c4158c"]},{"cluster_id":"eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3","members":["8dc2dc12-4483-4e22-bfba-f8c668631bf0"]},{"cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","members":["1e0dd477-2919-414b-956e-29f90a306828","0a45144d-bc7b-48a7-a0d4-08f0e213397c"]},{"cluster_id":"bb382092-b4e0-4652-830e-be1eeb609ad0","members":["96e78690-52ca-41bf-bace-4b4e15b86c84"]},{"cluster_id":"a7b8095f-b682-4ca2-98b3-5d738490e008","members":["8c41652b-8e1e-4f0a-bc4e-03efedd1a9f6"]},{"cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","members":["da7775bf-58ca-49c7-a7d1-cffa7bccb3d2"]},{"cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","members":["b1d44d03-5ef9-4f9e-94eb-bd0d9585bf1f"]},{"cluster_id":"a9b66749-8bb9-4643-bb36-488cbf77974b","members":["6eada5c0-5e43-4d39-b534-e8c542c0d607"]},{"cluster_id":"0728a108-719d-49e5-9d88-9c4bc35fe771","members":["456955f3-fe8b-4164-8641-3c65f3983fbd"]},{"cluster_id":"a162a552-43bd-43b6-925a-ac7f9fbf4734","members":["dbe8856b-d464-4609-9e4b-30a8db6cc332"]},{"cluster_id":"62bf1a53-b840-4c52-b1a8-6f2e98e4c3d2","members":["febc22fd-b63e-4d33-8e8b-7830675da69f"]},{"cluster_id":"8a3175b7-b295-45aa-8bbc-c3d6d75486fa","members":["db3f6d14-a291-4aac-a1cd-cc354f4928bb"]},{"cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","members":["9880f810-d4a7-41fc-9722-9ddf250ed653","e1e225d7-a8c1-4486-b299-b092e0b88821"]},{"cluster_id":"6a51ac21-708a-4a11-b82e-7b2b043d6c15","members":["fb14b1c9-f797-411b-8b61-6c98d77e78be"]},{"cluster_id":"06b2f52b-0581-493e-b81d-57ece9f33f27","members":["82cf28c0-d675-4d81-b3a2-2c3ce4de4179"]},{"cluster_id":"9be076b9-65b6-4c8e-b3d7-1df3c547c0fc","members":["2c2fbc2c-4fb0-4048-b456-d2641031574f"]},{"cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","members":["5b6894f8-ea15-4af7-a6fc-9b6dc7515b6c","cb1c2aef-6959-401e-9589-022e23e0167c"]},{"cluster_id":"2d998acd-2150-418c-b2e7-db6c334526be","members":["c76b961e-fec1-4e74-8f71-d053b8c1967a"]},{"cluster_id":"4feed713-e2b7-4de9-a6e7-cb0e0ca52183","members":["bf52ac2c-e546-41f8-8dc2-c30eda90de58"]},{"cluster_id":"5765d283-f56d-43cd-b120-e8f9048e2325","members":["a261d10d-a831-4a54-83da-f0ffee4c073e"]},{"cluster_id":"adc640bf-2d33-45f1-87f4-f455e4d88f72","members":["c8c3633b-35c1-4db0-bae8-d6cbc4f54521"]},{"cluster_id":"8cb34140-24ef-4173-9390-c1f84800160e","members":["ee04ccaa-9e1e-40d6-bc45-0779559baad7"]},{"cluster_id":"5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb","members":["6aa78773-444f-4637-ab92-a135889b401f","040f7830-6a65-4a38-8b85-a619adac6e6f"]},{"cluster_id":"b0af2c27-e359-4cad-89ec-4abce503f0fb","members":["10b0216f-8bdd-4289-b76a-7acbcdf1e105"]},{"cluster_id":"c572351c-d373-4e8c-a918-68e53e31b822","members":["a565dbad-c465-41f8-ab11-beae94827d71"]},{"cluster_id":"4c8ca22f-065e-4c2a-bc2a-950d315204b8","members":["74c3de24-358f-46b6-8603-3b0cd61cf75e"]},{"cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","members":["9c0167dc-2624-4651-a063-941c0d8192e7"]},{"cluster_id":"e0a9ff6c-3760-4c9a-a79f-78340ef165ed","members":["c10efc8e-2c04-412f-8a5e-1fdbcadb67d7"]},{"cluster_id":"b0071c15-10b9-4a75-8b7f-486b9f2c04d1","members":["66e6c0ae-2678-4700-9d11-18f5479528f3"]},{"cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","members":["13d0543b-8f7c-4b3b-8217-7043d3174afc"]},{"cluster_id":"952d3c78-e97c-4ff6-a488-1e2f6353d3c9","members":["143e6559-fd81-4a95-a696-1296cc9459e1"]},{"cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","members":["4bea3e8c-e42b-49b3-a380-6f0df70085de"]},{"cluster_id":"aa7a9a4f-e437-468a-8a0c-4d2441978380","members":["5d1abb46-c8d8-49fb-839d-b17a174ec4be"]},{"cluster_id":"7fc9b449-7f4e-4cec-90a6-b1dab2836291","members":["06adc002-27b6-4763-98b3-60bd7be27eff"]},{"cluster_id":"840a2e45-449a-4234-be31-852cc48c1642","members":["0cb3d75e-b02c-4bd2-9810-c0e6a1fc51b6"]},{"cluster_id":"67674784-9e53-4907-a36a-9a45f8374e68","members":["b9b63002-39d8-4477-b533-c581d73fadcb"]},{"cluster_id":"8f97c05e-5860-4be0-8343-dc2050850d4f","members":["34309c9a-8492-41d0-bf23-bfbb78f5e9e8"]},{"cluster_id":"09a468db-6b0d-4230-a370-cfd6ba61219e","members":["72b9d4c9-c3e9-4906-b371-0a4ebf5cadc1","494b41ad-16b3-4f5d-ad03-def9e45d7031"]},{"cluster_id":"d281c55d-162e-4c45-bdc4-8fddc9bff858","members":["5b47b59e-568a-4e23-86a9-e5681f041b5f"]},{"cluster_id":"95b3c4c9-cd4a-4cfa-9eab-9df18c6c5d95","members":["fb9161f8-1e15-4476-8ce7-46aa19ef5010"]},{"cluster_id":"65cd54b0-2f90-4b59-a573-5917ec27f9bb","members":["36ecab96-07d2-4a35-9658-4f5c6d5c2ebe"]},{"cluster_id":"8db03bdc-0c69-45b1-8ccb-309f57132adb","members":["a1fada51-b45d-4d3c-8d3e-99b53f12db24"]},{"cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","members":["111fda95-ceec-4a7a-a541-30cbc5c08475"]},{"cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","members":["4c349d8a-0de2-4065-995e-b97ba18a3cc0"]},{"cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","members":["7061f9bc-a2c9-435d-8af9-d319c07d4cc2"]},{"cluster_id":"6774f916-a691-4d45-86c4-69c41fab58e3","members":["69e4cb91-92b2-441c-9c45-09d100040619"]},{"cluster_id":"a3657e1e-0716-4d64-9a9e-572ba20604c2","members":["76a47284-daa0-43c3-9a5e-dadf15ea7166"]},{"cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","members":["d0161276-0b14-45fc-83b7-284988ef9808"]},{"cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","members":["3646e827-9c28-481f-8a3c-14bf7f6ee1bb"]},{"cluster_id":"1bf7e0a5-55b7-4089-89cc-831b1626c195","members":["cf00a55a-5eca-43d0-8944-0a18bb229c40"]},{"cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","members":["b1f2e7d8-ccc3-4f08-bd0e-9f7c70793e5e","6f152311-cb32-47f6-9c08-27bfcab9d5fd"]},{"cluster_id":"098acc21-62ca-42b4-8206-4df179ae28c3","members":["c4eaaabc-9564-4e1d-a74c-5c61095c6428"]},{"cluster_id":"a8177a52-bb93-4070-be93-33bdb7e54f7f","members":["f9dd0eeb-eedd-4de8-87a3-03659e466189"]},{"cluster_id":"1dc1ea0e-ecc0-4a99-a555-3574b46d8688","members":["4a24d8e1-c038-41e2-a640-6c76d8c77f67"]},{"cluster_id":"c91afcbe-198a-44cd-83c8-42c89811dab9","members":["ae1bb1a8-77ee-45bc-aa36-64fb591ff555"]},{"cluster_id":"8f2a4264-d263-4757-889e-c18e3e101875","members":["e8c891f1-9ad9-492d-8bc2-d8322a1bb704"]},{"cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","members":["78823ae4-0c2e-438c-8dff-ca140c879d1c","2e8e6368-68dd-45d5-a2dc-d4ee5ee70dd7"]},{"cluster_id":"a3dda742-6a6a-4de7-ad48-8075110e3b35","members":["092ab2d2-2c35-4984-a0ff-3385c6274188"]},{"cluster_id":"ea3c1b05-c987-4377-9e48-b92ea47cc764","members":["cbf4a452-7652-4f82-bf67-0ee72a779846"]},{"cluster_id":"b36a42d8-1bb3-483d-b77f-bd28630b0e30","members":["56f44d3c-1882-468a-a39e-560f159b07a2"]},{"cluster_id":"9d6f335e-c5fe-40ff-9edc-7ee5892fafaf","members":["ae778ea3-ab1c-436e-83d2-b9abd6502a12"]},{"cluster_id":"7eefde16-5844-4305-a679-da87990a2640","members":["4cee97a5-599d-461c-a5d3-ddb7b61c587a"]},{"cluster_id":"734aba7a-e1ac-4a78-a926-3957017f7843","members":["82e47aee-7b6b-4936-a959-aa926002fb1a"]},{"cluster_id":"d93d391c-6b51-4713-bfdb-30f405cd2357","members":["59af9f9a-2c5d-4de7-ad4d-ab2be9537271"]},{"cluster_id":"583320d2-3b7c-4cef-9dd1-9eeedce9bc81","members":["0b3c50fe-9aa2-4a22-85b4-5b1c52ce2eec"]},{"cluster_id":"eb82caa7-6ef5-4182-a16e-ed0091be45ae","members":["38fb016f-f70f-4b9f-883c-9653381f4f08"]},{"cluster_id":"8e9b5986-8277-45da-82c2-ab199cd3287f","members":["4bdb1eae-1573-453a-a57b-0fef0cf1472c"]},{"cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","members":["fde1853f-3f82-49e0-8181-1fe237afda38","cf0181d7-c14c-4b9f-a69e-ef445f0dfd90"]},{"cluster_id":"a219ce5b-2b81-445f-a63d-19aecc15acb1","members":["4bc88004-3c8c-4dd1-8eab-01da2f931d7d"]},{"cluster_id":"d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5","members":["8c795228-b136-4584-a1ad-c731fa4c7164"]},{"cluster_id":"6a0b2cf5-23aa-458f-9dc9-7fde872ec6fc","members":["817546e0-c92b-45b2-b75c-ec6e8277d278"]},{"cluster_id":"ba205832-fc5f-46fb-90ac-d89622b9cebf","members":["36608fb6-7bae-43ec-a85a-51c36eac5007"]},{"cluster_id":"0f9ce830-116e-4bca-9110-b7d8c9c20025","members":["2392c3c4-f0d7-4741-8cee-c90dee84d1a7"]},{"cluster_id":"3d2576b2-1572-432b-98fe-db8e768274d5","members":["253af419-5990-4696-aff9-7240a057ebf0"]},{"cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","members":["5f053b98-cfbb-45e0-951c-1faf705854e7","f606b31a-b532-40dc-89ff-e88a3a8c71ec","ed3cdb9f-0609-4ee5-9a77-be64735a50fe","bacee7fe-c702-44a9-b89e-4b1a69c6b672"]},{"cluster_id":"4f0d57c0-3de2-45f7-85a5-01cd50cac457","members":["e7167790-1ca0-4758-83ef-cfaa7af0d4df"]},{"cluster_id":"2267c878-b6b0-4036-b4c7-3e3fec5d0865","members":["5dad1ba3-bf1a-4fbd-9515-e7df10901647"]},{"cluster_id":"a6d92a93-8990-407f-a2ca-8786c79330ee","members":["36792a75-7b7d-4724-b998-1097cb1b9753"]},{"cluster_id":"b0b4f902-9c94-4b57-b853-99cb04209992","members":["6d6197d3-178a-4827-a9cd-fdca21a90695"]},{"cluster_id":"680a1621-579c-4ffb-aa4c-f56de5d6dfe7","members":["cf3568b6-586d-4e58-84d4-3ca7d32b7860"]},{"cluster_id":"e3141392-e630-428b-ae45-6d5589bf7443","members":["f7a962f1-0d5e-4e60-a1ab-4627c38edd62"]},{"cluster_id":"8e7a25f4-c25d-43c4-890a-4d8d8364c5bf","members":["b56682ff-83eb-4170-ad31-c2232d6f06a0"]},{"cluster_id":"dfcf5731-89c0-4af2-a475-d7087b733644","members":["abec432b-4b97-461f-abc6-b475358b35a3","bfa609f9-2ee5-4041-9ead-29eb12891c57"]},{"cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","members":["f453153e-e454-43f9-bd11-d5c7ad57e0e0"]},{"cluster_id":"3e1e4180-7726-4298-9f55-4348fcd7185f","members":["177203bd-dbed-47b6-b095-908931f7ac38"]},{"cluster_id":"76ba9e0c-8b5a-4b06-92f8-9ce9caa47714","members":["7d250ec8-c856-41af-8374-190af4006461"]},{"cluster_id":"29223456-9a08-4f68-9ce7-d62d961fb6aa","members":["d73abf37-36d7-46b7-9f5f-4f684e8aae3c"]},{"cluster_id":"7924e4aa-9f0c-4bcf-8c0f-de382c8d6001","members":["dc8356c3-2a3a-4a60-a917-1d5d63aa5b8c"]},{"cluster_id":"f0e862e5-92ba-499e-8f7b-4935ce01c5fd","members":["dd4daa0b-4a2e-4926-ae14-fbaf8a713160"]},{"cluster_id":"ef49913c-d983-49cf-b90f-4529857c36a4","members":["1c63b173-4a48-4736-a466-44ebbe6903c8"]},{"cluster_id":"f570b12b-c8a8-4d99-9575-a11a563abe1c","members":["c9e8c139-5a8f-4e24-a65b-71191ef90c6b"]},{"cluster_id":"67c32fef-bbe8-4245-9a91-7d8aee491367","members":["16dd4b0f-e181-4766-9099-841c4684769f"]},{"cluster_id":"59078c61-208b-49cd-9d25-3d6a843d0590","members":["619d380c-ec49-4a86-88da-0727e240b714"]},{"cluster_id":"4de7b868-bb12-43db-9bc6-efbf0705904a","members":["22ae8bff-4d1e-440f-904e-57a100d2b74b"]},{"cluster_id":"37c89569-0090-439b-961a-5b1d66deea87","members":["35156c0f-4df8-4e6c-9d76-1c2aad0fde6b"]},{"cluster_id":"43b3601d-6d6e-43a4-8cdc-72cf4aa80640","members":["1f34b4f6-3429-4378-9c81-2d5bf161f570"]},{"cluster_id":"92a61686-4c12-431d-b205-279f1f28aaa9","members":["c787c8f0-b90d-4334-a10f-2082b393b36e"]},{"cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","members":["942f639f-af20-4b2c-81b7-6dc2458b2a9a"]},{"cluster_id":"c7bb1d74-7395-4554-a7ef-ec1f5c743579","members":["380629a1-e2b4-4cf7-b741-fff3c1754b5a"]},{"cluster_id":"b835c70a-6e2a-4461-9396-aa47cc9d876c","members":["aeeabafb-6f28-4525-a914-fdc35c3a9238"]},{"cluster_id":"93d03ec0-ac83-451a-87b2-a95e3d58859f","members":["a39f477b-71f2-4f8e-8040-d311ee44ffcf"]},{"cluster_id":"494d200b-d2e7-47ec-bdd7-86aef2459978","members":["8105f0c2-d335-44c3-889f-c2866cac8644"]},{"cluster_id":"2996196c-7b75-44d2-aa5b-560b18ce2763","members":["3220d5f1-68c5-408f-a687-456500ec5c1b","9b3cf5e0-dbb6-4926-a623-746f661ed710"]},{"cluster_id":"9cf07839-b78b-4d19-aeee-e70ec12a23d1","members":["55000f0b-6050-4bed-b661-724a55b279d1"]},{"cluster_id":"86944fd0-c689-49c4-894c-bd247f4057bb","members":["e9b0d563-f34b-4a35-a863-be0d2c997c10"]},{"cluster_id":"a6c6cdde-b7da-4e49-88cc-f029f6af6192","members":["28d5a32b-01e4-43e1-9fa7-c95e0e6ea554"]},{"cluster_id":"ac1f3497-64d3-4909-9d61-789e683556a9","members":["bd92b3cf-ed72-434d-bc50-2da71ce2e696"]},{"cluster_id":"fcc1829e-1835-42a8-bf49-00b5c2d30892","members":["abb0b365-0c91-4f0a-8c94-f9b199bbc275"]},{"cluster_id":"4a91c427-d613-4080-adab-a06fc13d13ac","members":["cee22ffa-0da1-4eaf-ba22-6194a76f12a4"]},{"cluster_id":"da5651eb-e7b2-446c-9fdb-dc89d46a36a7","members":["e0c3fe47-573f-4179-a8c8-d49f9e461981"]},{"cluster_id":"8c61663d-a5f4-43e3-9ca6-42de906f614c","members":["8e9b5a0b-9e0f-450a-9bcc-3aad11029c2e","e2404afc-9753-4d93-b38e-a46a7808158c"]},{"cluster_id":"1fc4c0cc-9a41-4ae8-9970-3b340b704e77","members":["d965751f-c358-4f95-8906-150192b1ac86"]},{"cluster_id":"e11231dd-53ef-41bf-966c-4a202aa2895c","members":["e08a454f-0375-4fe5-a9d8-9625252fb43e"]},{"cluster_id":"a84f79d2-3818-45bb-9cd9-eb739e78bee2","members":["f1d70199-6377-48ec-a1a0-c8babe771d93"]},{"cluster_id":"fd5eb376-88a6-437a-8af1-6b857c858d7f","members":["8db2a5b9-b06a-48f9-83cd-c7414db84203"]},{"cluster_id":"3c1f9759-2361-48c2-bc4a-c58a3d11b76f","members":["4926a962-88b8-4c44-8b25-a6100dd82789"]},{"cluster_id":"3d1eca97-f0cc-4fa8-9ff8-7ec9ee2b27e4","members":["b5629695-0b27-4487-bc7a-b41c6ea60fc9"]},{"cluster_id":"67c03f1c-cee9-4493-b4e6-4ff1b7971966","members":["19745271-da59-4f63-ac98-b7d12909a80d"]},{"cluster_id":"e0d3c894-0bdd-4f66-b7b2-a6bada2f1b37","members":["9ff13b89-dc60-484c-8fce-6f0a5669c623"]},{"cluster_id":"e6cb9f82-faa2-423b-984b-e379572890e7","members":["db9e5a23-3a2e-4931-94be-3d217cff127d"]},{"cluster_id":"6832730a-f3c3-49e8-8c1f-45ff7dac590c","members":["e9c08668-5d1c-498b-a7dd-5a1d19c0a798"]},{"cluster_id":"00a040a7-5456-47e8-b780-a67388e64219","members":["44736c58-751e-4ef6-b9fa-adde3127863f"]},{"cluster_id":"21eacc7c-c9da-4edc-ac35-3ab550e3b7af","members":["d3c8bcb7-2012-4617-ac2c-f4f9349cc592"]},{"cluster_id":"b3413e76-c570-4047-aa2b-63946d5b2c25","members":["fef26ec5-e59f-45c1-a5a4-646b7ba8ec8f"]},{"cluster_id":"695b3abb-f469-4406-b1ea-91e5eba8aa09","members":["850e683d-b2ea-44b2-aa45-fb224b8681fb"]},{"cluster_id":"c4bd1c97-a831-4763-9c03-6a3cf69f7caa","members":["214c593c-eba7-4ad5-bc36-3652a10e5726"]},{"cluster_id":"0a1db453-23bf-4b25-a04b-c4f13d273e88","members":["413ca3c8-8833-4fea-95cb-3d766a54756d"]},{"cluster_id":"52902c20-eb03-45dd-8441-6d06b77f992c","members":["782a8eea-e09b-47ad-9879-22709d78e759"]},{"cluster_id":"066e0772-a7cc-411e-9810-7c9b5b3dd73f","members":["559abe16-c942-41c8-868f-fae4d96b3a1c"]},{"cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","members":["56c5baf3-de4e-4dae-9140-e8515970c81c"]},{"cluster_id":"f7f1bbb8-f068-46fa-acbf-d579d1b4e308","members":["aae65b6c-d7b1-453e-aac3-d557018c16b8"]},{"cluster_id":"c78cce84-ea53-4b86-8393-67ca74594e0c","members":["049f4fc9-03e6-4f0a-83fc-2cbfee582f7e"]},{"cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","members":["4827d13a-0d89-4c69-8325-411684ffddba"]},{"cluster_id":"df13c28d-11fd-4cdc-a0c7-5076d0c46483","members":["b8cb1e37-a9ee-4866-95c5-1f5036695355"]},{"cluster_id":"818b32ce-b83e-40a4-b06b-dd4e2c09af00","members":["4b0493cc-0ec3-44ab-9682-69dbebada129"]},{"cluster_id":"dc73c39b-d234-4200-a04f-dc1af208480d","members":["39148726-18c2-47ab-95c4-5001bfb98ee1"]},{"cluster_id":"346f630a-2d46-4e8a-80ef-67a96ebf81ef","members":["cfa983d6-9dad-4763-bd75-c81a2285f59f"]},{"cluster_id":"e88c49ad-3df2-4059-82e4-46d0f3b59757","members":["c43216b5-fbbe-430d-843c-0ff3e82e28f5"]},{"cluster_id":"4bda17b5-0897-437b-9ad7-ab5783ada079","members":["f28554de-91a0-42ff-a02e-bef7bd3f1398"]},{"cluster_id":"983e06bd-8aef-468f-888f-6f39b0353693","members":["9246277b-632c-43ba-975d-947ba8474dcd"]},{"cluster_id":"67bef4c5-afcc-4a65-9538-ce302f965385","members":["ef6e2f62-e4da-4bca-b1ad-ab18c8fe45f2"]},{"cluster_id":"ee431334-0b63-4389-8c3c-60633233fd26","members":["2c06ff17-3a5e-4dac-a0b2-aa1321a05705"]},{"cluster_id":"52105c27-d937-4970-9bad-c139e21a6205","members":["1f151033-fa0f-432d-bfae-8dd97991bcee"]},{"cluster_id":"e37c8f7a-2656-421b-b216-1d87659bcb44","members":["fe32af40-4500-4d43-a1c5-ea02937c4c4b"]},{"cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","members":["3c4db7e6-ebcf-4c14-8c80-5acce367863a"]},{"cluster_id":"fb518ec1-f92f-4616-8a47-9c0563a7f0fa","members":["1ca70899-971e-41e3-a537-3ec6776c088e"]},{"cluster_id":"24daffdf-e642-42fa-ac82-39c90e12f420","members":["60cb9b77-25b6-4a6f-81a2-a7bb90327f82"]},{"cluster_id":"a316407d-a413-48ec-95c7-f1a3c83da782","members":["fe511ca5-5050-449f-a284-d8293d7b0c96"]},{"cluster_id":"93c53898-2dc6-423b-a4d6-b61dd90c6d6c","members":["2c581133-af8b-4910-a5b4-19bd1832f813","0b8cdef4-3750-4015-872a-477c40ea8043"]},{"cluster_id":"18108091-50d0-4bb5-a06f-5f2734380aef","members":["4aab92fc-d883-488e-bca0-15f56952fcc0"]},{"cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","members":["1e33ee40-e3ca-48f3-bfa4-a83d268f0b1e"]},{"cluster_id":"3fc70d09-8a93-4a60-b903-b03cd4187227","members":["490c32d7-44ee-43dd-9430-5b67acfadcbb"]},{"cluster_id":"a4e781c0-f96b-465a-94d9-bc076c57b2b1","members":["9a49c057-060b-4aa0-8605-bc212bdce2e7"]},{"cluster_id":"e21b1b35-31f0-4c02-9069-b35c0b38b172","members":["32ce6b58-43d6-484f-915c-0918e220fd62"]},{"cluster_id":"63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7","members":["96814f16-e24f-40de-ae84-fb0188df7399","9cb8eba0-6a9f-48a3-9ea5-9b83b2c1a0b9"]},{"cluster_id":"2adce5ae-1669-4c77-b898-ed9abf7276da","members":["4b0acc73-1804-4517-937f-1b5ad41cb490"]},{"cluster_id":"fbc30c99-229d-49c2-8ecb-ce9a62431408","members":["235efa02-9b47-4eac-b7bd-fa49f55a6b79"]},{"cluster_id":"0aa10a76-1680-4566-9d3a-ebaa3e486aaa","members":["09b7bc02-54e4-4f14-9a8c-ea0414b9cc0e"]},{"cluster_id":"44f7e426-bb87-4dd0-bf0c-80fb71c61eac","members":["c644a19e-7959-4dbe-bb1d-5da1d7e8db40"]},{"cluster_id":"9c8e3c4f-c6aa-493f-ae68-b49b723b4cde","members":["aca4f631-b4e0-46c0-9977-79908d2a056e"]},{"cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","members":["cff50cf1-148e-4d81-9d29-27a702bbb6ac"]},{"cluster_id":"dce81269-fe31-49af-8310-17a573139956","members":["31eed9a0-709b-4a3d-8b0b-39d363374e35"]},{"cluster_id":"a15b31ed-89e7-4c30-9559-8eac356b32e1","members":["c95a2f22-d6e8-4959-ad36-6fd6e6c0589a"]},{"cluster_id":"d8515ae8-12a5-4f84-b01f-bc10b41b19e0","members":["914b6f6f-2fca-4af8-9488-1a2ce148ed7f","0c8c8f99-e607-41e7-947f-ad2fc3b0e67a"]},{"cluster_id":"b93f59d3-e54a-4700-86ef-b20c995b73b6","members":["3f31c2fc-e518-44a9-b233-2088b1bfc18a"]},{"cluster_id":"20d6183f-1c47-41c9-bd8d-d5a8b68eff2e","members":["18cf1ce5-3c6a-4bdc-b913-675ce17f06f3"]},{"cluster_id":"71755eb8-e7df-4bfc-b448-f56fe2b8b242","members":["fad0d97a-967b-45f5-94a1-0ca5aca96640"]},{"cluster_id":"bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5","members":["679de09b-9b77-4640-b961-aec420f2fb00"]},{"cluster_id":"43beda49-4348-4ff0-94eb-8102078e161d","members":["eb010d8a-b114-4016-9f56-547f3f7b89df"]},{"cluster_id":"507dd458-2eaf-480a-89be-7acf52e56a97","members":["c3bcf198-1424-473c-8a8c-663e70803e87"]},{"cluster_id":"f367b654-8f0a-4a4d-816e-54c86d7f13ae","members":["3dfbb796-816a-4bcb-8e8c-6d0a8aa6706b"]},{"cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","members":["395ed66c-1d26-4d1f-870c-5401a963aec5"]},{"cluster_id":"0d813aeb-360a-48ec-afeb-778e533504c7","members":["f9dbc081-1611-4178-93da-896aed2eec7b"]},{"cluster_id":"0bb1f8c0-08c1-4f63-b6c8-052a5bad160c","members":["4d3c4642-883f-4145-98a3-9370b82ef841"]},{"cluster_id":"21361eee-5fe8-48f0-a512-8a8c4752daae","members":["0a8f55be-555c-4c88-b454-178bad2a9dd4"]},{"cluster_id":"6f548f26-3ad4-4adb-80dc-c3f3104f0d7f","members":["efa65091-ad55-46d9-b00b-8bf893d6fb30","7e985f17-a69e-4ed5-bf5c-461248b507a9"]},{"cluster_id":"285cd62d-96d8-4ff1-af84-3fd22f7b4f51","members":["3117bdd3-fe21-4976-ba21-ee3604b9e13c"]},{"cluster_id":"635833cc-6550-4cab-b41a-e51cbfca373a","members":["9f36031c-5916-4e74-935a-bb47d9d96ded"]},{"cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","members":["4e21a3b4-2946-4d8f-9487-14f91e7e9c72"]},{"cluster_id":"fa621ebf-8ee4-47c4-b584-f5012ff39561","members":["aa4040ac-5dc6-453b-ad32-33c50706dfe6"]},{"cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","members":["2fc64496-af63-4c5c-abb3-9f84496a307a"]},{"cluster_id":"94076701-ef33-45db-95b9-6fd0d66deba4","members":["13111903-7ec4-4b35-892c-1db611c8e2a8"]},{"cluster_id":"12e02de9-758e-49f6-b31c-fe52770a7aa7","members":["c6a08cf6-77ca-4409-9b0a-6fb71acf61e2"]},{"cluster_id":"fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b","members":["bf34edb9-658d-4a0b-97be-9cbefe833a99"]},{"cluster_id":"a615f0ed-7c6c-41b5-95d0-49cb25bb9feb","members":["c86e3c48-755c-4b5d-8c98-a72e6affa674"]},{"cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","members":["c18bc9a5-4f5c-4c49-bf4a-768caf8f8785","62670d51-2419-4ae6-9c54-f93a58e21695"]},{"cluster_id":"587bb9b0-b0dd-47bf-9ce3-29231f30f4a3","members":["3d7cfe24-7ccc-4715-a510-ea6e42271f97"]},{"cluster_id":"b7bef44a-7480-409a-8790-0a70b42045ee","members":["6f1d0218-2aaf-4ca5-b70b-202058baaf47","1f6c819f-22c5-4385-8e22-29e91daee72b"]},{"cluster_id":"7ae548ab-8f8f-4668-ba05-a2abf4b89759","members":["3dbaecae-f023-4a6d-99ee-f9c83ed6d59d"]},{"cluster_id":"07b6bde9-eeca-4fea-b3c2-39093320ea05","members":["1ed21ded-a58d-4450-9265-91ccc6e02072"]},{"cluster_id":"fc0f4ff8-8147-4b0b-be66-dcae01810fe6","members":["3af16777-d1d0-4e80-a9f5-2f99d1033c6d","d31ecd38-9b36-4434-b556-2ed92e43b61f"]},{"cluster_id":"42ec0ecc-4c37-4216-9671-a26ac18a9ead","members":["0dfca0dd-799d-48de-ad62-11e1841e3fd7"]},{"cluster_id":"7b4d9f3b-78aa-4507-8228-424f51cb5289","members":["355ea973-9d66-429b-9998-3ed67368dc37"]},{"cluster_id":"30ae8997-b16b-4477-bfec-33c1a345955b","members":["ca9ae69d-5e7d-4172-9055-bc081efdd1dd"]},{"cluster_id":"555fa82e-54c2-4aba-bcc8-bcfe1ec2186c","members":["559d7895-3171-45e9-a0d1-e435947066ac"]},{"cluster_id":"ab378ec8-ca7a-473f-b276-44d546196e26","members":["bf34a0d6-69de-4dbe-b228-ed90e9008781"]},{"cluster_id":"61784f3e-1c50-4b37-9db4-0fd1ec458127","members":["bdd349a7-4515-4da4-af05-4548d7083f52"]},{"cluster_id":"34e53235-60e8-4299-9389-633db39ab300","members":["65d1fbc1-c1ed-46c6-8363-e70bb39e0073"]},{"cluster_id":"e41399b8-77c7-4930-886f-cd94ab46ea34","members":["d48a5434-e0b7-4030-8162-a726e2a9395a"]},{"cluster_id":"9bcb7463-7e6a-4bab-b398-5dd6ead423be","members":["dbdae94d-af2c-4bc4-9cfb-bc5655793791"]},{"cluster_id":"cba79c22-94bf-4911-a28d-ebd794325eaa","members":["1d8e287e-62a1-463d-95e5-61e0cb648713"]},{"cluster_id":"ed42b61a-7c55-44a7-aac6-78560e6e139e","members":["7b9481f9-8112-4bc8-bd57-8107fcb6cb90"]},{"cluster_id":"f58ca21a-7af7-4062-9509-f6480d8a6390","members":["ab781808-3305-433b-88bd-941249abd97f"]},{"cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","members":["4846e35e-b5fd-4a27-b4eb-19ce31173495"]},{"cluster_id":"a75c6491-7fc4-4904-9a47-b176fcc90a36","members":["2377ee2f-c1b5-4984-9853-d503eb644658"]},{"cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","members":["705089db-d047-4aaf-9efe-0eba267d2e09","ceed53ab-4e93-475a-986c-3a214d121952"]},{"cluster_id":"f09098cc-f345-415b-a2a8-3f7563f7b80d","members":["f6062ca0-f886-40e4-8ded-a9ca73878d31"]},{"cluster_id":"289e5c59-c24f-465d-931a-b56b54bc982f","members":["e2288ded-588c-42ab-a0ea-06f15a3b8624"]},{"cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","members":["b1bfb305-5ccb-4cf7-9e9c-32d77fbea960"]},{"cluster_id":"a2f18fa4-3554-4400-be7d-a33cb07dfa44","members":["4d449963-3c83-4ca5-a518-09c04a8066bc"]},{"cluster_id":"9dae5050-ee2d-4e3c-8dd3-b9ea85a53752","members":["8d476653-8abd-46d5-ac3d-f0a4a2cd468d"]},{"cluster_id":"19581d0c-22b5-4ff0-8a68-de86fb01009c","members":["b1d44b1e-4296-4f67-8f78-0ddfb3a5d8e1"]},{"cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","members":["42bf77b3-e0b2-4e5a-86b1-fc489416a7d3"]},{"cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","members":["1a05352e-5ad5-457b-af01-e151d9a78829"]},{"cluster_id":"8806403a-c610-4055-9744-edc72cda745d","members":["95e9fe43-5bd9-4517-8c75-ad87b874e86c"]},{"cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","members":["9af9e18f-fa69-41e2-adf9-4a24e42c1b84","1c6bdb4c-9bfc-466a-a7ee-4d8b2e346cb9","601a74ac-c835-46a7-97d9-93b4633920f9","43595c4b-2a87-45eb-9d9b-3fd7a30f928b"]},{"cluster_id":"e0d4056d-6cdc-4a90-ba78-5aecf0b2092e","members":["5201ea05-3c66-4f33-8c67-ce6caf33f3f4"]},{"cluster_id":"183db562-aea1-4c36-b76a-f0deea54c6a4","members":["3f248e4c-edd5-4205-b450-821576e9195d"]},{"cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","members":["d6398523-0ffd-447a-8554-59fcfee589bd","5628795e-a7c7-44b0-ac00-289259aa71d5"]},{"cluster_id":"ea149597-1daf-4627-8587-59eb8a6bde8b","members":["f77f73a6-8d42-4767-9384-fbe2af0f6cd7"]},{"cluster_id":"26852476-f26f-4f97-92bf-7cc2d9373f4e","members":["f4029d86-fdce-4ef4-b075-d09aff0725af"]},{"cluster_id":"7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6","members":["f971b469-261f-43ef-98d8-2c5946168e63"]},{"cluster_id":"aa179085-85ff-43d4-ba04-8a3f88267ae8","members":["50acc255-34d5-4628-bcc1-a683011cf488"]},{"cluster_id":"663bc264-4933-4e53-8689-d8e35c02d013","members":["bfa7b823-2a59-436f-82ee-922dc42e266d"]},{"cluster_id":"796ddc52-9094-4fcb-af10-9fa6a06448ba","members":["18e1d515-c745-4151-88c1-8c9e9af7547d"]},{"cluster_id":"055b1edf-5e4a-4fd8-b913-a9d1df63a85a","members":["d40539dc-69f1-4f92-a72d-ae21d808cf04"]},{"cluster_id":"8165992e-6782-4b62-b794-6309bbfbaf5c","members":["20ad280a-9ca6-42d4-8560-8ef0babec400"]},{"cluster_id":"1ba178d9-d925-407c-bb75-60c655774cbf","members":["51cf9cc5-964d-487b-b0ac-9496efa28c40"]},{"cluster_id":"8ac816b2-de5c-4294-a968-e6279613b1d8","members":["3076ff95-fa54-4f38-8fda-8d49ad5f5f5b"]},{"cluster_id":"ade8c501-ccec-40ec-b096-cd50cd90be07","members":["91e15b87-d451-447d-83a5-56bb79569eed"]},{"cluster_id":"510b63b0-aea2-446d-8868-5c88431cc9fe","members":["9386cc51-2d6f-4bdf-9354-bbd0755c9cb1"]},{"cluster_id":"8f07bc53-1683-4b3a-b1de-2e1c15c0e13c","members":["a308b049-5da8-43ff-aba2-9a9c0276d910"]},{"cluster_id":"42c5367f-fb48-41ea-b66c-1b344a5b61cf","members":["f0666037-3fb1-462e-8c7b-66b127fba72e"]},{"cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","members":["37a3eb67-d193-4c87-a056-44ec271b6890"]},{"cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","members":["ed748149-b43c-4488-a119-7d3b55d695d9"]},{"cluster_id":"f07cc872-d3c5-4a88-8201-4dce67c0d460","members":["db8f6262-d359-4671-9a89-8e585aad0bc6"]},{"cluster_id":"99681bf5-4780-4832-b6fd-70acc37bfc27","members":["ee7b7f93-c6b9-4025-99d6-a2d067b69ab5"]},{"cluster_id":"126818cf-8924-40eb-8cb3-edad41027c0e","members":["f73337a1-ea01-41f8-8dfa-1089a6101eaf"]},{"cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","members":["60c414b2-02d3-43e3-ab59-2a05ea85c25d"]},{"cluster_id":"8b124bbc-d0ac-4d8c-bc1d-bbdf5f6ae201","members":["31a87aa3-2cdc-4a51-970b-c4552af60231"]},{"cluster_id":"2fc0be9d-df8b-440d-a58e-2ec4422f1712","members":["db7c86d1-007a-434b-9049-ab67281a99c1"]},{"cluster_id":"cdd48d7f-71ad-45d9-b5c0-d84849f26b67","members":["68f0d160-583d-481e-83df-68c4639466a7"]},{"cluster_id":"d6ec7b4a-689f-48d4-bb2a-ff95c991125c","members":["461c8397-4732-40d0-a312-c8fb8792a2bf"]},{"cluster_id":"66df7edf-0972-4fa2-846f-2e6326ee828b","members":["26a96b2d-3797-496d-8ac7-3ed2dd390863"]},{"cluster_id":"7940ac84-eeae-4d7a-9072-fc2e9ac63265","members":["f7763ef1-0586-4f10-96ef-9996f889cdfd"]},{"cluster_id":"749a09bf-2f2a-4d19-aa9f-a22ffc94264d","members":["e0831560-5a10-4b72-a32c-0beb2101c523"]},{"cluster_id":"3d9bd6b9-ad1e-4d65-b911-715849482ace","members":["9ba9c7a2-13ce-4eeb-bd31-2cddba33d2fb"]},{"cluster_id":"e205a390-4f4b-4898-961e-ef5a0bf3f3d0","members":["0b1a8480-5c98-4ba3-94af-4ddeb88f0fa3"]},{"cluster_id":"3fd55ffb-10d4-4e70-9352-8bd5b0751ffd","members":["f1306acb-108e-4ee9-a8a2-aafd43375285"]},{"cluster_id":"97b87ffd-da0c-47fa-86ae-0eedf718bf3e","members":["b2e81b33-d30a-4225-9bbc-48fb82b96209"]},{"cluster_id":"cf53004b-b29d-4fe7-a412-14956f8d2a9a","members":["15d51b8d-9bc0-4395-b6a2-58477343cae7"]},{"cluster_id":"83392417-156e-4467-96c4-b7a769a50f3f","members":["2f980e48-1150-4fff-be2a-30cbaff52bbb"]},{"cluster_id":"e8ac4064-b696-4a9d-9c57-bc79d628e859","members":["11f609b4-7a2c-4cef-9ec5-eabce404dbbf"]},{"cluster_id":"d63b1ded-8126-4556-8052-238b4f8872c9","members":["85c3d135-1fba-4982-b96a-cba7c669d7f0"]},{"cluster_id":"4fc703c8-a28e-4bc3-ba13-2190c2afdda4","members":["0e09f55d-e12d-4e27-b424-be835d42044b"]},{"cluster_id":"830f6edd-9e60-427e-9ff4-9fac93a52411","members":["864703a6-b3a5-4fa7-8ff1-321bdffd8e40"]},{"cluster_id":"2706ec99-75d3-433d-ab95-f5c524eb1832","members":["4a8f4191-7339-42e4-b14e-4481e9d543ed"]},{"cluster_id":"18d83743-88ff-4a61-999f-d69912fd6589","members":["c07e9dda-0c21-4c8c-8ea3-d415f66e9ade"]},{"cluster_id":"13672f1a-e63c-4ec7-9f85-d3ed61ff60fa","members":["221e2843-0d1d-4934-9175-536b037f0687"]},{"cluster_id":"7afb7680-3722-423f-b129-7076bfb88092","members":["0aa14ed9-8f5f-4f78-8937-57e0b1539d61"]},{"cluster_id":"c29b208b-6490-4cf8-b641-83fe57eafe9a","members":["8b61f97e-9475-4370-97c1-b0602d3861cf"]},{"cluster_id":"a0d964f3-2911-42e0-a686-2f4aa48a2f24","members":["896217cb-d2af-414f-b5d3-51faabbc1542"]},{"cluster_id":"84019696-e95b-4f09-b37b-dd61ce673e9c","members":["3ef38ce4-3be3-42aa-a325-e6d43d492fce"]},{"cluster_id":"a764eb56-b1bb-470b-bb17-4bd9f5369b4b","members":["e83d4367-7b6a-4345-a3f1-d00d0b00e230"]},{"cluster_id":"97f84153-8f49-432f-a8f7-a4e57fe7f769","members":["e36ec763-c008-4d62-bed9-5c270d796253"]},{"cluster_id":"af3f95a3-d597-4371-bf7f-e4f5d91a9b73","members":["f57eb09d-4839-4483-b263-99c536579018"]},{"cluster_id":"6c53a575-96c0-4b04-a196-adb1bbc90de7","members":["01c9a984-5ece-42de-9e7e-2449849d6790","629da89b-c0d1-4e00-a631-f9127df0bed1"]},{"cluster_id":"dcc40b89-996b-46da-af7f-ec64a05c6ee5","members":["4f7c4c9e-7e0b-4bbf-9bc8-39859ff7d243"]},{"cluster_id":"a3891be3-55f1-4794-b99d-304a26e4b465","members":["d699106d-5b88-4e20-9413-43a5243fe144"]},{"cluster_id":"6c41ffdc-392b-45d6-b68e-a4cccabb1714","members":["899d585b-f8a1-46d4-aecb-51c086aced46"]},{"cluster_id":"38841999-14cb-43f3-a2d5-27d9791973f6","members":["0192c2a6-abf8-487a-ae10-a2de71b9303e"]},{"cluster_id":"f3c74d17-b66b-49d5-9e91-ad7f843bbd39","members":["daf9f724-fde8-4531-bd2a-de74dd77c316"]},{"cluster_id":"d717bbe6-a62d-46c1-8d61-866b7d90a851","members":["0b056afe-9555-4444-a11b-8067678748fb"]},{"cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","members":["1c81eba8-a29a-49ee-aa9a-249eb28d0a95","736fc05c-c8ce-4304-910b-c143ec389610"]},{"cluster_id":"565749fa-0214-435c-be6b-1a2ffed6aba1","members":["04225ddb-8ca4-41ae-9ca5-314b7d1e53f0"]},{"cluster_id":"84a6bd0b-f777-46d5-bcae-3f166d028b6a","members":["de6d291f-4bac-4d72-95fd-85e7525fd5bc"]},{"cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","members":["b1f962d0-8550-4b2d-9191-63c14905d540"]},{"cluster_id":"d012c47c-3d49-4f8a-9fcf-db101ff82249","members":["68b8c45f-ffc4-4a92-a4b2-5ec0f20a0bb7"]},{"cluster_id":"3b4d0d09-6630-4f48-897e-19fe1449086b","members":["4cec07ca-d88e-48f0-93de-7efd62925b38"]},{"cluster_id":"dfd9bb6d-a08b-428d-8e19-e9eebd219088","members":["5d66c5b0-29b4-4fb6-a971-f86c924a9c20"]},{"cluster_id":"de6ada25-e81a-4f5a-97f6-0053df68ea0b","members":["36ed0712-67c2-4c18-8b10-d47f1abaa21d"]},{"cluster_id":"d01db0e4-579b-46e1-b0a0-4bf5732646a8","members":["b9965956-2e89-4214-91ce-8b4af2583f6f"]},{"cluster_id":"de17f70c-2147-4c34-a071-59d11378f1aa","members":["fb88fa48-6744-4cdd-90bd-b2e2eddc6477"]},{"cluster_id":"e632bc78-90b4-46bf-a31b-df8259ac6d90","members":["0d799b10-e143-43f0-a3f7-dfa3398a7ea2"]},{"cluster_id":"4892691c-c25d-434c-bfaf-8b1764a0e393","members":["a3589f11-b596-443e-978d-eaa153795255"]},{"cluster_id":"1d3c5fb8-134e-4cb9-8e15-b1a4488a82ec","members":["56f254a6-a740-484e-8f3d-5d3900878147"]},{"cluster_id":"d755be56-db7e-4317-8d05-387807a1a892","members":["dcfd6c52-886d-4da0-896b-e61501045564"]},{"cluster_id":"b3b1fd7c-7ffb-411d-b821-50b6108ebae7","members":["e6112557-b39b-4c67-98fe-f9aa53d6ef2f"]},{"cluster_id":"a3463468-dce8-4063-85c5-ecdc64691fed","members":["47702199-6d33-44d8-8aae-6b64c07f1e45"]},{"cluster_id":"14b46c0a-7b16-4722-b599-90d7d69970a1","members":["56780c55-2348-43c4-8452-d1280da550a8"]},{"cluster_id":"6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5","members":["7e015da3-09f9-424f-a950-64fac9192a16"]},{"cluster_id":"0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879","members":["22265ef5-f29e-463f-b350-1d766fff6dcb"]},{"cluster_id":"b433d9b9-0986-4c75-baab-f74fc73be2ca","members":["795bd233-4202-40bd-8378-0cfac2c7ae0e"]},{"cluster_id":"1e256780-a5db-4471-b8f2-5390a4dea1fb","members":["422fdfd1-eb02-4b3a-9f93-ed1833ef5a72"]},{"cluster_id":"980136c6-363f-4cda-bc50-cca417518993","members":["8a8a4d58-3c81-4041-bf47-6870a50bc623"]},{"cluster_id":"a536505f-e31a-400e-a4a5-1f74a9e29e7d","members":["9856cfa4-7841-4cd4-bd37-fefbd15ed23a"]},{"cluster_id":"2c9fc1d9-b4d4-4707-a2ac-1245937847ac","members":["e9248000-40b5-4f1d-a451-0c4d3506ff1c"]},{"cluster_id":"b34ea819-97f6-4215-92c0-351b2f770110","members":["91892df5-916f-4a03-b17e-bf8deae2e9c1"]},{"cluster_id":"970c1f51-0eea-45a8-842e-874c83ffa389","members":["ae143f57-f1cd-48e7-bd68-d27bf956dbd5"]},{"cluster_id":"856ae956-c845-42c3-8716-9e150f646a11","members":["95065231-541d-4d0c-9d43-2073939beee1","62e384e2-a7d6-4f5d-baaf-5e1405aaf635"]},{"cluster_id":"c7c24801-e07d-4e78-8de0-4a42e8b64272","members":["4afa5b76-da52-452b-afff-cd61d074bee8"]},{"cluster_id":"0d0fd5f0-0301-424f-b0b1-a60ab6ca045f","members":["c49e05e5-75c7-469a-aa86-55b964450bfa"]},{"cluster_id":"3356bac0-8ec4-475b-81a7-e146187a74ba","members":["e11d0c1e-57e7-4703-8ef4-16156adef49a"]},{"cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","members":["807b722b-d3a7-482e-9a03-1405557fdd75"]},{"cluster_id":"5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9","members":["3458447f-3248-4191-a1b3-f1fd8a0008ac"]},{"cluster_id":"d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9","members":["fbb9300f-ef97-4722-b7c1-d6227d91a0c8"]},{"cluster_id":"095169c0-0ce4-4362-b29d-486ce7d2b848","members":["4580f05a-5688-4a45-a4f4-f4e24ea7b4ed"]},{"cluster_id":"a70a3157-f4e4-4eef-b960-bdf74270bd58","members":["3fd0eb19-f467-4489-9035-efc27bd8312a"]},{"cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","members":["acd6cfba-d774-46ac-b0d1-bb30d348a186"]},{"cluster_id":"ac4174c2-4597-4a76-ac06-95cefda372c9","members":["9b0fbaf1-3523-4428-9061-25539ad38933"]},{"cluster_id":"bd13c9c1-afe0-4a04-acc3-453f611b1f14","members":["f4628d9e-3224-4456-9e45-eee7e8392a37"]},{"cluster_id":"98f59c42-164f-4444-8ecb-92a7e7c88a99","members":["9bd9610f-f0bb-42fb-939e-0d245615f203"]},{"cluster_id":"362947dd-8703-496a-89bc-c395dcec13b9","members":["5157bbae-9cf5-46ed-a5ad-28563ceb5c10"]},{"cluster_id":"a7d034a7-5705-462b-af06-b9277d91c75a","members":["f0ad29ad-7310-45a6-9b76-74881092c1ab"]},{"cluster_id":"5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7","members":["2653155b-5304-4055-b622-9ba7c16563d2"]},{"cluster_id":"27fad854-f733-4ec5-8acb-b36e0c043d26","members":["03f80d5d-9cd5-462d-8d22-644d5ef346fb"]},{"cluster_id":"33fe2055-c6c1-46ed-8871-fc741999d32b","members":["de700e1a-915e-4484-a367-da94b659fb6d"]},{"cluster_id":"e8898157-febc-4868-87fa-8effb0a882e8","members":["1f0a4898-00be-4da4-b5b6-f17606255acc"]},{"cluster_id":"4c9a1f90-fd90-464e-8a7b-831a736d5b19","members":["c2c1f1f4-4e8e-45cd-873d-f4bf901f568f"]},{"cluster_id":"1aadbdec-7f0b-43f3-98a7-709a1bcb5807","members":["5d2f265b-1852-475c-90e8-d0dc9ce73cb6"]},{"cluster_id":"673d8d19-d059-4065-9b0d-82b1376c6c55","members":["a8e84567-eb93-438f-9949-cebe49e48290"]},{"cluster_id":"268e1143-4495-4247-af6b-b6f6f368f74f","members":["c5ff2590-0a26-4d88-9f39-d098cd3fddf0"]},{"cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","members":["1cfecb95-178d-45b8-8ca5-332fe7d4466b"]},{"cluster_id":"1ff73cd5-87d3-47be-9b40-e0da957f6ed3","members":["e7e2a469-e7d8-4e18-ba82-631b19391ab3"]},{"cluster_id":"5d30cac5-2629-4bf5-9665-20ae87c1ec22","members":["0a9bd450-6735-4060-8152-3b9d3b22f36a"]},{"cluster_id":"caa1a8ea-e71f-480b-808e-8ce18b47a5eb","members":["4e28ac8e-2184-4ed8-bb9c-cc33dce59d2e"]},{"cluster_id":"18daf39a-f6c9-4439-8592-186d1ea3c4b4","members":["474d7066-f672-4876-af13-b242b9502032"]},{"cluster_id":"2c61e4c1-c73f-4292-be06-e4f072faf26c","members":["3b1ecd72-8468-4cb4-a8a8-a2a7b1087d5d"]},{"cluster_id":"c3c1a73e-287c-4b15-879c-42467ebdfb38","members":["a83232b1-08d5-4658-b88c-4a2f5e191dac"]},{"cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","members":["ba50652d-7543-43b6-9e02-0b28aaa41b56","49175056-e0aa-486d-86ef-95663f8e67dc"]},{"cluster_id":"b6f111d6-8112-47dc-baeb-43c77c6392ea","members":["1ba49034-44f7-4c43-af12-2f2e150e5d5b","1d9c6663-ae5a-4d9f-a856-e523287304a5"]},{"cluster_id":"c198c115-5575-4cd0-82cc-408f1b46a7a2","members":["3d46a623-76cd-4aa4-b111-1a23ab4bbef8"]},{"cluster_id":"d5fdaeff-23a7-415f-9e7b-758f603e5d4a","members":["94cbb44e-7ad1-4c2c-a84a-1197d216e7cf"]},{"cluster_id":"8457d857-0fdc-43af-97c5-93e3a3631f90","members":["4c4b0e97-6438-42fa-8e70-a270d6219668"]},{"cluster_id":"fbdddb76-bee9-4e1c-9f2e-03126700cbd1","members":["edc298c8-16c2-4af0-beda-99bf53575d1b"]},{"cluster_id":"06af9b74-e018-4919-8256-29acfecc76d7","members":["c358057c-8a9f-4907-9c34-ba7d372e0bc6"]},{"cluster_id":"6288e205-b9e8-41be-a3f8-80b06b50c037","members":["b9cf8b72-5d1b-4f16-86f0-e3f7be2b3dcf"]},{"cluster_id":"6547f895-7ab3-43c4-b3b1-d01e17f1e888","members":["b5f94b88-20a6-4777-8314-1e09fe92f4ce"]},{"cluster_id":"b8299ae1-9e2e-465d-af82-b9354f3e9c44","members":["70d44892-c7f8-445c-a4f1-d65699998e56"]},{"cluster_id":"4770d222-ba7d-4bbe-8acd-294b0fe141f8","members":["7b52ba03-0c7c-46a5-a9ad-c73a0081f33a"]},{"cluster_id":"af562818-5594-417a-b606-add10573c2db","members":["11daf81c-84f2-4989-87a3-077cc2fbea8d","22587ee9-0a3d-4963-818d-de36abce0d53"]},{"cluster_id":"a1a796af-13af-4bb2-ad74-b64193c2de86","members":["b73f5a87-73a5-46dd-9ecd-86efbd0a68c6"]},{"cluster_id":"bb72233d-9eb6-4e80-89c4-220c7a06b310","members":["bd301cfe-c8a0-402f-b39a-0737e1fb5f05"]},{"cluster_id":"e1f9f42d-4c64-42c8-80ee-89170b717dbd","members":["11d7296f-5403-45eb-b0d5-7b03b9ace4db"]},{"cluster_id":"970cf87e-f96a-4a62-8043-264e8de25eb5","members":["95871097-5992-4f40-b6bf-a888c22bf1f3","5878fdea-e073-45e4-8f36-4da02f629c97"]},{"cluster_id":"aa458090-4ea3-4829-9f88-662eb71a8370","members":["80745886-a9ac-4a94-953f-9c082ae76c8f"]},{"cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","members":["cbd1af56-17d1-4f2a-a53a-a88d39fc29f1","c093a054-ad4e-413d-97d1-2f0dce3b5245"]},{"cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","members":["ceb0fff5-46aa-4019-994b-affd318b42e1","fe0988b3-260b-4fff-8d24-d9fa3d1fa95c"]},{"cluster_id":"58655fd4-e92f-4f77-b848-bd4849b75655","members":["248f7289-5c06-491d-a0b6-436091b33dc7"]},{"cluster_id":"8e782418-3f83-48d1-a7d0-6c3daf34ed25","members":["67e51910-6f7d-4924-9721-ad00edf8bd7f"]},{"cluster_id":"838b4697-b296-48c1-b248-3458bd1a5a35","members":["22e4c461-4770-4ea0-b169-eaecdcb4f6ef"]},{"cluster_id":"86fac771-eb74-4809-8f31-be78d543ad7a","members":["d695ba75-31bb-430b-814c-f52894643bad"]},{"cluster_id":"435bc534-7da4-4fec-82cf-af0f2a0a282a","members":["e2cda163-bf74-48b3-9ce6-ba74a554f5dd"]},{"cluster_id":"ad4fa6da-197e-4295-b610-c2f934cdd3ea","members":["18a6e3e5-36aa-4e8d-a899-f48ada8bfd0d"]},{"cluster_id":"daf0b3a1-53f1-4b47-955e-785030ee3839","members":["8ae12054-2167-4984-b6b1-86008eddb2c3"]},{"cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","members":["99d4b89c-d792-42ec-966c-c524a13af148"]},{"cluster_id":"1eb307cf-2274-463b-9ab8-19aee3397703","members":["13a23c89-11fc-4641-8963-83530ec35be7"]},{"cluster_id":"4c86e2de-bdfc-40e3-b87c-fafaa9d03c41","members":["0bfed9e2-8163-47a6-a7ae-ff0cf9c7b894"]},{"cluster_id":"004d8db2-6d73-4ac4-955b-6d04e88a0716","members":["2b838aa3-e871-4afb-90e5-2b918262adde"]},{"cluster_id":"de116a88-705c-434f-9f3a-1fdabb457723","members":["6d25bfdb-3006-462e-bc9e-80e928211137"]},{"cluster_id":"8140cb8c-a254-4493-b790-598f4ef3676f","members":["ab55dba8-aedf-4992-9bb5-82d454a89462"]},{"cluster_id":"9562ace0-b924-497a-a3ab-5d483c835c5a","members":["2dccbc59-d9b3-4575-8d1f-b6fef6c515fe"]},{"cluster_id":"54c46b5a-065c-41a2-90e0-3fac031eb853","members":["7c597816-a45c-4e9b-9e6b-f17f838fa55a"]},{"cluster_id":"481f70cc-e9a5-439c-8065-a4dc8e63bd0b","members":["3d9b6b73-24b4-4c11-b015-9aff59721ad6"]},{"cluster_id":"f6a8a8da-c935-4c40-b9c2-79c93b84b629","members":["e07c3235-a892-4e9b-8d7d-27a0e973f4cd"]},{"cluster_id":"71cd6d97-dc20-4f7e-b7c6-5d5b5186e201","members":["6f8c28ec-1158-4082-93cb-dd5fe64ccb81"]},{"cluster_id":"7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd","members":["ba446c6e-d58f-4e5e-a537-f3c04ce2c398"]},{"cluster_id":"13b8e657-b1a1-46e6-ace5-fc6a57928a32","members":["99af38ad-538a-45e2-a467-40cb688f0fff"]},{"cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","members":["20289216-72a0-4039-8094-a0a3d5d764a9","26ee7189-c0fb-4ab1-858c-0111039380b6"]},{"cluster_id":"3cb553c8-9eb0-4dfe-8f4d-e85a8933799b","members":["49a4ff07-a9ee-4afe-b60a-c3912a9ecbee"]},{"cluster_id":"ed1ca8c0-7841-4109-ada2-99053838abfe","members":["284c6be1-b028-45d4-b945-0297660ee5b2"]},{"cluster_id":"9f4b1362-f866-4431-983b-c739ed7f376e","members":["09953f70-0b38-48b9-9a36-fb9a043eef1c"]},{"cluster_id":"e416c5ec-262b-4531-adef-7197fba310f0","members":["4c018036-8386-42a1-8fa4-de8efde36646"]},{"cluster_id":"f9f12741-3c28-4281-83bb-68cf30392853","members":["c49b54a1-a379-46b6-b5fa-385217856dd5"]},{"cluster_id":"f6541b8c-4e86-4aff-8593-e4f14f2ecc27","members":["5293996f-523f-4c90-94a4-6b297adb7e7e"]},{"cluster_id":"a999634d-6816-4a9d-9bf2-efbbb6f6917e","members":["73839936-e78d-4d7f-9f8c-b9590b821dab"]},{"cluster_id":"1e227a80-8d1d-4484-9608-82719d3b526e","members":["baeda9b3-f4c9-4ccb-8521-0505f25cbbb2"]},{"cluster_id":"ee1d7c5b-4d98-426c-bf43-b5350f89e9dc","members":["2ec69792-8fba-405a-9a8f-c01c2aac78fd"]},{"cluster_id":"a3272ef4-947f-46a0-b484-adddd74b2e08","members":["1553fd7f-8aaa-419f-9fa1-7c73e091b80a"]},{"cluster_id":"07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a","members":["b0524685-9242-4e30-a89f-72ec2d79f6ea"]},{"cluster_id":"aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868","members":["c34066bf-2577-4750-aee7-181b5235cb4f"]},{"cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","members":["1670e29b-19bd-4c53-a61a-438c242ee96a"]},{"cluster_id":"d9f5972a-ff26-4242-938a-7c9615591c15","members":["e88bbca7-cf56-4326-9c99-dc1647945e93"]},{"cluster_id":"e9dd9d87-b75e-47a9-883f-9edb14ac1be2","members":["a88ec512-6b19-40e8-9245-9b1926568095"]},{"cluster_id":"97037755-caf6-49ed-8d7a-bb7c0d42bf8c","members":["f578eb5f-3c4e-4ed6-86ac-07c7f1346e70"]},{"cluster_id":"3b1a4f1c-eb8e-4934-89a0-1d405c7425e6","members":["b60b2fd7-3a6c-4b1a-8bef-470c8fe13273","a9b84cf4-c9fc-42b0-b615-322ed7497c2f"]},{"cluster_id":"53da7ed0-9d8e-436f-b097-49ff62b95459","members":["d541576e-5c2c-4375-9f5a-a1cbb11155f2"]},{"cluster_id":"b6ac4f42-6e4c-4395-a71a-c8beca5b5336","members":["c2055234-7d19-4f2f-8f93-5a3d0367ee7e"]},{"cluster_id":"f0190a02-daf5-48b7-8174-720b52c75550","members":["903e1681-1758-4c3a-9728-9fa8fd825a8b"]},{"cluster_id":"b6fc681b-92ac-49a5-8881-3c1a5122bc59","members":["8170569f-1511-43b2-bdea-43d9e3bb8330"]},{"cluster_id":"60bb3151-34af-4d7b-9c68-da27390075bc","members":["660e4a47-1d5a-494e-8c42-4a00f7ce4a2d"]},{"cluster_id":"db7cc474-d6ec-47a2-b50b-7ed4c500c50a","members":["69c57963-6437-4eae-aabd-8176cc30e300"]},{"cluster_id":"4d988f33-ad00-4f89-acf1-b7ec63af7351","members":["04b07b43-91de-492d-b415-f6ff34cb0803"]},{"cluster_id":"657ed7b6-8b7c-41a6-8900-c8d11bb6982a","members":["5d2831f7-834e-409c-8e9d-48f747d564ea"]},{"cluster_id":"7511bd1f-13b7-402b-887d-d4fe077fcba7","members":["cf81ea82-4981-46af-b78d-7d932f523a9a"]},{"cluster_id":"c8d061af-6686-4c3f-a2d9-0d23ccbd3f19","members":["da359d6c-2a80-4518-96d9-6bbaad187c00"]},{"cluster_id":"73a6792a-38f3-4e05-a1bc-e5dc764c0b4d","members":["a9ee6543-ba8e-418a-a114-c3ac7cc71a12","2be5b181-7cfe-4239-a89f-a8d44870295b"]},{"cluster_id":"bcfd3520-6b2d-41d7-83ee-cfbd1d569332","members":["cf566c83-3925-4984-884d-925ab1e46541"]},{"cluster_id":"2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187","members":["0b3c6f5e-1e59-433f-90ac-0ec8710352ac"]},{"cluster_id":"1c24fe42-ed01-4d5e-85a3-6011ab09ff6f","members":["051a8eae-085f-42a9-9e38-77d1995dd83a"]},{"cluster_id":"fdb63c1f-d931-4ed0-b2b4-c60113cb73c4","members":["b38be4e2-e4d7-4855-be09-04a41de1d4a4"]},{"cluster_id":"57cf4546-a43b-4620-acde-18ad68b95dcc","members":["0fd4b274-a470-4ec8-941b-630f63142a34"]},{"cluster_id":"5f5fe60b-6bf8-4f80-be3b-0dcf885c1171","members":["a70e8b59-7cfd-4220-bbf1-2c239ec82ce5"]},{"cluster_id":"9ade6dc5-62e9-44b7-84fc-ef5e0c8fe1bd","members":["3d0c993b-38f6-4d18-976d-7c47411b31c3"]},{"cluster_id":"b65c1ae7-fe21-4ae4-9c7e-84c247b4a89b","members":["70200cb1-3041-48a7-9e28-2cae2ee138c8"]},{"cluster_id":"83412f4d-d0e2-456a-853f-c0ab5d6c2ff1","members":["da329360-2d3e-4b50-b7b3-6cce8f1aa433"]},{"cluster_id":"b524cac0-fbe6-4818-abc9-cf0d17bfecf0","members":["ac802fe2-63ab-4c69-9886-f5a4d7657337"]},{"cluster_id":"3e19b24f-ae64-464a-8536-97bf58aecdc0","members":["0b25b952-b8db-416d-8697-ee70e792870c"]},{"cluster_id":"842a47a3-77bb-4a2a-909b-98bce731301b","members":["af1aad82-b277-4834-9f9c-1ab8d24f2d7e"]},{"cluster_id":"07f06451-8b9c-4bc8-9f61-1661511a83c3","members":["1ba8d895-5f78-4f0b-bd05-4d1641e4ce5d"]},{"cluster_id":"b08cba5b-cde3-4318-9ea2-b4cf4efed9c3","members":["d1ba53b6-47f9-4280-9fc0-fd09d18c4fc2"]},{"cluster_id":"00386fb1-3dcc-4b4e-b74b-bc14dbc4e260","members":["36097c8c-85b0-431e-bd33-a9103b04ef79"]},{"cluster_id":"267d2942-984a-4564-b33c-69e9db79a066","members":["72127d66-fd32-491d-87df-078b95146b02"]},{"cluster_id":"03915ee1-228c-408f-b93a-594ce2e45136","members":["35864078-cc2c-41ff-88aa-8e1e32ed9739"]},{"cluster_id":"b213b3ba-db75-4c42-89bd-97de55c18b3e","members":["483f9100-c4ca-4586-ba84-682f095310ad"]},{"cluster_id":"db0a8d4e-9354-4c38-bb13-56ae176ed70b","members":["ece9466a-65bf-4d30-926e-70674b63d79c"]},{"cluster_id":"654ddafb-5d45-4313-9cd4-f144aab1e464","members":["73181885-0295-4b62-8463-85f7ebaa38d5"]},{"cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","members":["fc3e0635-9b91-40ff-87d2-363a6d9ac2f0"]},{"cluster_id":"40c73517-1c90-43a5-bf9c-4b7cd5dc13c4","members":["6212f3e0-6ac0-4064-9593-a4457754360f"]},{"cluster_id":"b4de3a2a-395f-4d49-9f4e-abbd190c57b5","members":["029d7549-48b7-4bf3-a6fb-f63d4e907818"]},{"cluster_id":"4dbd9499-a86a-4c48-b218-1b0a93aa0331","members":["4be3f643-2aa0-4579-98ca-14d97784ea1a"]},{"cluster_id":"96a4146b-b919-413a-b5a7-7801adae1906","members":["ffea4765-c803-4d76-adcb-556ad0a86333"]},{"cluster_id":"db07f4e5-716a-41e4-989c-98ced62f8fd5","members":["9134b5dd-9cec-45cb-a37a-823fcc4afdca"]},{"cluster_id":"185ce1be-2776-4956-849c-f83438c57def","members":["c4c0a228-b520-4446-9ced-f9600e63b724"]},{"cluster_id":"f61b95fd-4ab1-43f9-b2f8-53b5afb90d43","members":["52270120-a27d-4e6b-8201-b95d76e61a23"]},{"cluster_id":"2790abdc-e882-4d8a-90ac-fbfc5b896052","members":["b8b249d9-68ba-4bc6-8783-fc55db74b4c2"]},{"cluster_id":"843bcba9-c863-41a3-a76f-01fd61d56529","members":["2e35d598-1ead-4cc9-b263-0f8e9b46350c"]},{"cluster_id":"c267714a-b024-42fa-a678-5343e8a65754","members":["c85c2b54-faa7-4ad6-a66a-50cb0e2adde2"]},{"cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","members":["1dad3c34-9c46-4fae-b996-8d36deac0c7d"]},{"cluster_id":"55bc595b-aea0-4d83-938e-9ae3ab116813","members":["ed43efaa-4059-4449-a36f-e665653f8a9a"]},{"cluster_id":"25cbeeac-8021-4680-b7db-f334ae985da7","members":["2d283ea9-3c37-44f9-a526-ca0bf56a29a2"]},{"cluster_id":"53a5cd16-ea33-4c3e-8f8f-0d495c63c479","members":["6bcefa92-a75c-4f2c-b084-e57272699893"]},{"cluster_id":"b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d","members":["7034a168-c32c-46c5-97d5-7011a7e583e4"]},{"cluster_id":"2e74796b-6aa0-4e1f-8a55-22887fa2ebdf","members":["e95e4e59-1c46-4d1d-a26e-f51adfada1dc"]},{"cluster_id":"00e6b319-ea09-4ee6-8be1-7f243156f545","members":["1bd00c6c-59cd-4387-a54b-b32f98e0f725"]},{"cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","members":["147d519f-3a24-41c8-93ae-b6104a3af9aa"]},{"cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","members":["6cb08a1b-cb67-4b66-9997-d0d027691a7d","0b8030df-1877-44d1-bbaf-c0428144a920"]},{"cluster_id":"1ef5190b-3eed-45b4-b04e-14655cb38618","members":["d0c64c05-1611-406c-997b-2bcaddb144c5"]},{"cluster_id":"ef13681f-975e-44f8-8e95-a6963670af11","members":["d325b518-52fc-414b-a998-6a1c6cee814c"]},{"cluster_id":"f387c566-78b4-4549-b5d3-12ab9f1a83af","members":["61cdd9bb-d06d-4548-bf22-2ac0469d141d"]},{"cluster_id":"a90d4523-8e1f-4287-ae0c-72459f7c14c3","members":["2d0a4efb-49ce-4c42-9c72-09386900102c"]},{"cluster_id":"5bc0db5b-3192-42d4-a343-00cfcacc4499","members":["81ded9b1-7e19-4e85-a496-51915d145a74"]},{"cluster_id":"731ff8b9-92a5-4277-aa76-33602d261e5e","members":["cf74c828-a854-4b1d-b0ff-41334ff95896"]},{"cluster_id":"eee91c5f-8ac6-4779-af53-8a01aa4eaa03","members":["9a821e6d-27d9-4ef5-8b63-5522dba4f695"]},{"cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","members":["0c1583a0-e152-4d85-a208-4c1a7350543c","02822320-cd99-4d29-9bf9-f058f84e00bd"]},{"cluster_id":"493568a9-0e32-4b19-a041-15396f7c15b4","members":["ffe40741-bfba-408b-80dc-6d4c93a3476b"]},{"cluster_id":"5e43acaf-f806-47d1-be89-f2ab3ad82bd7","members":["a2a1873a-cb7f-4eea-b881-7962bae1b5e2"]},{"cluster_id":"7742ec5a-27ab-42d2-9779-df7d73a0cec4","members":["c04ab974-f5a6-4674-9617-93b3a84224ad"]},{"cluster_id":"04e64305-3df2-47b4-83e6-266ff2241406","members":["7ca392ad-9d19-4328-ac1c-38ebd5d5ff79"]},{"cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","members":["fa69523a-2b83-4e43-8a72-b11ce2258253","9de16975-a6f2-492e-886a-e269c2d474dc"]},{"cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","members":["b41a3136-a2a6-4ce4-aadb-8c179bf11bf1","3065442a-14b1-4449-b727-0b1cd300dd7c"]},{"cluster_id":"662000fc-1ecb-4634-b4e8-efc53b2b3287","members":["95a7d096-c622-46dd-9590-b080e9861d12"]},{"cluster_id":"e59930cd-f28a-4a44-8feb-24e860e36480","members":["b5b85d0e-e9b3-4a75-9ffb-e456c3336ec0"]},{"cluster_id":"057bcb05-f915-40a6-9a44-d57aa6602574","members":["619baab4-41a4-48c7-b3f9-7fdbfc3cd7a0"]},{"cluster_id":"369b1cc5-aae5-4361-aabf-b1ef5c5350f8","members":["521328fb-fec8-45c2-8804-3961edd8a930"]},{"cluster_id":"deb1b19f-f313-46a8-8e93-d75203af3775","members":["487d5ad2-aa34-46dc-91dd-b7dac83edd06"]},{"cluster_id":"48f8d3d4-cbd2-44f5-81bc-3adadbe6b6e7","members":["bb40c0b2-397b-4ba4-a644-11c4285e3229"]},{"cluster_id":"b54e5664-a40b-4682-b959-bcfb59ddd4b0","members":["feb9f397-7bc5-44bd-aa8f-04394b7447f4"]},{"cluster_id":"5881fb7d-2030-4406-a7ba-0a95befea17e","members":["fe5053f4-21b7-492d-9e91-012a110d99b6"]},{"cluster_id":"73c5657f-c795-4df0-b889-73c2f356f79a","members":["ab7fc75d-0dd5-476c-baac-dbac6bb06edb"]},{"cluster_id":"5dde6d54-8ecf-4f66-96dd-406048082082","members":["12228c9e-42ba-4dc3-86c1-e440002f2e43"]},{"cluster_id":"934665b5-3969-4817-9dd5-47b732fdd380","members":["f5dd556e-d81a-422c-a1df-38d595b542fa"]},{"cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","members":["a69c3605-cb8c-4cc4-af1a-49a5fd1ec2e3"]},{"cluster_id":"8ac7a573-0e67-4913-bd5a-4320d5df2ecd","members":["1860282a-df94-40d6-aefa-d33a780e797e"]},{"cluster_id":"5b6da2ab-36ee-4cfe-968a-ce42565405bc","members":["7200c0eb-fa7a-4eec-b545-f33baa33b876"]},{"cluster_id":"64a10d09-a49c-4bf3-80db-a2cb3188afbc","members":["8f562a60-4720-4b12-bf8e-97447354a6b4"]},{"cluster_id":"b9ef5935-c3ff-439a-95ae-5e53367b92ef","members":["9d71426d-92dc-4461-8d66-7cb7700cf2cf"]},{"cluster_id":"803c450b-2260-49a5-af48-6296f17fca97","members":["e79b7f1e-c540-48f9-99a0-eb9f272ff2a7"]},{"cluster_id":"e30f1c65-b396-4183-98d3-9deb2bc6322a","members":["08570a75-8b33-4e1e-90f0-ccc77c0eedee"]},{"cluster_id":"46e0dd28-4bd8-4986-88e7-a2e53ab8f4b8","members":["99c2d825-ffe1-40dc-9c1e-e1013924648c"]},{"cluster_id":"5edd935c-f1a4-4a6b-86a0-37894c0716f8","members":["4dd9f52f-d8e8-4544-9e2c-b1bb11889b2a"]},{"cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","members":["f027e67c-47bf-4105-881f-4d217b3544c9"]},{"cluster_id":"49b52e42-84db-4d97-b9a4-ffd3211b536e","members":["629f13af-3980-4d8c-bddd-b43cd3168dd4"]},{"cluster_id":"8bbb9fde-a60f-4687-9398-276e5d036952","members":["9f9e5b15-68b3-4929-ae84-37177d1d515b"]},{"cluster_id":"1c5a60ba-15c1-4cc2-b60f-b6a9d3303da1","members":["d1bc893f-3614-4a43-a75d-205bd1a7adcc"]},{"cluster_id":"23af5a3d-cb29-4974-bd99-35e9d9b06fde","members":["4d412db5-fc61-4fa9-81b0-e9bc9d2d50b1"]},{"cluster_id":"53ddceb6-33d2-42fd-849a-253f21907d2a","members":["fd30fa9d-5404-4600-a306-94fa14b3f60f"]},{"cluster_id":"b2ec8ccd-aef2-476a-b259-768aae14f39e","members":["a4b251cd-8f24-4aab-8d8e-a919692a5b87"]},{"cluster_id":"b60b834e-1991-44ea-a53f-68d101a440a4","members":["c980a339-5089-4aea-b722-8818f6df5b36"]},{"cluster_id":"791c0550-4877-4364-97d4-01b5b8435b0f","members":["8bb31240-1aee-45d9-9cbe-f51c9c7aaeae"]},{"cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","members":["1a4fd326-341e-417a-b590-42a241e07a85"]},{"cluster_id":"6d2143f7-a494-4413-af4e-40c695a4a5e3","members":["ba5e3a7c-42f8-4a47-9032-4c310b28c369"]},{"cluster_id":"2669ad24-9832-49ab-a24d-8ef6f0986ed6","members":["eeced08d-688c-409e-a85d-20f0a611f2bc"]},{"cluster_id":"e61d6703-69dd-4dea-8318-f7e671e98045","members":["b3724cba-b469-4f18-9cbe-c5a8feb6e61b"]},{"cluster_id":"3f043499-266e-455f-a558-699fac541c36","members":["432b9133-94d2-41a0-bb39-3fb754586948"]},{"cluster_id":"363f13f4-3f3c-4a28-a39a-e89279a7c9ad","members":["3bc8538e-2a63-4a8e-b482-f2312ef30972"]},{"cluster_id":"d8f02a31-c29f-429d-b5f0-720768af0f52","members":["db74244d-4130-44b3-a3be-416717218122"]},{"cluster_id":"0a173478-bf00-4e1f-be9a-c8305b945d9d","members":["eba77011-2a84-495d-a255-b0a33266a65b"]},{"cluster_id":"a288cd72-4282-4ba7-b449-a353419578cd","members":["e4a1ef12-8a66-4e6b-972b-df2ae81e6f7d"]},{"cluster_id":"6436c54d-cea9-4b06-8f6e-d82ef558f6c5","members":["18fafe7f-080f-4e66-9efb-f04c0f9fcb2e","af38f83b-dbcf-450a-b045-facb4eb4a1e6"]},{"cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","members":["885f411a-bf81-49ec-b44c-6940e82f3240"]},{"cluster_id":"1a247a51-e7fa-46f4-b0b3-659a03d784c6","members":["9743b311-cafb-4cfd-8609-7c80f2ff9d89"]},{"cluster_id":"bd50210c-37cf-46e2-9d31-0c6a6dd06e70","members":["cd1059a4-0e64-48b1-8826-fcf1496bab8a"]},{"cluster_id":"9ba84133-d9e2-4da7-8e9b-aeda3ebd4295","members":["20d51616-8577-4377-ac82-80c75ed27783"]},{"cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","members":["e5f5da0c-a863-47e1-a6d1-56961623cf7b"]},{"cluster_id":"2bb3dd08-3d90-4e2f-a0e2-ecef371c599f","members":["dde2b01d-d592-470e-bbc4-b54f19560170"]},{"cluster_id":"5b2c4526-459d-4b6f-8f31-bd40fccf12ff","members":["a1defc99-37ef-4f95-b417-6ff608a4c6e3"]},{"cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","members":["308308e1-766a-4770-bf8b-7e2599a012d9","3b3f6b3c-9e02-41b0-8583-5212dd3b4f6f"]},{"cluster_id":"a023722f-ed95-4d7c-9c3d-0d405ad7a2c4","members":["ab930dd7-1c58-49f1-888a-3ccb43f3e76f"]},{"cluster_id":"95b428d7-1d28-45e2-a9a0-dd59bb6a0176","members":["8344aced-aaf9-4585-8b7a-4ef53a11ef4b"]},{"cluster_id":"342cdbac-7da2-46b3-80b3-a9b75e8fee10","members":["6196be98-1cd7-4397-8565-f5ba5461fded"]},{"cluster_id":"881a8788-562f-4bf2-a8b1-590419007a87","members":["39744d7d-3fbf-4158-9ebf-d7a34bd509b3"]},{"cluster_id":"7b08a98a-0129-4cec-b114-1fff26d56746","members":["d2746d11-47fa-4951-baac-d714323e7a24"]},{"cluster_id":"4958a7ec-0cd2-487f-a59b-9bc34843a2b7","members":["8f21e90b-1a0f-4031-bfce-d0e4f75835aa"]},{"cluster_id":"f21a34f1-8f4b-45c1-80d1-4a2fc8e55091","members":["01508c85-b479-4298-b689-24d128545f43"]},{"cluster_id":"3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d","members":["0f5cc466-f266-46f0-bb36-c4c140c7386e"]},{"cluster_id":"a92df9a8-beac-475c-a620-574a5351def4","members":["b25d83b5-974d-4e6b-9335-6426f9c6b6bc"]},{"cluster_id":"a03aac32-b760-4f2a-8ae0-1194424402ab","members":["ff96108d-4f5c-4d0d-beef-451db8a86aa7"]},{"cluster_id":"b9a17741-2ab3-4713-9777-efc674860d38","members":["28b2429a-0096-4d7a-948d-059fa77fc5c9"]},{"cluster_id":"d8eb9cee-8720-428c-a044-b6a3e22a6bb8","members":["56f90ee6-1209-4b41-abc3-e377d4df66b2"]},{"cluster_id":"19ec7067-1e85-4e98-adf9-a107366a808b","members":["21b59191-bead-4584-9277-0995dc1dd492"]},{"cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","members":["d94c0bdd-38a8-4849-8dda-6b5e0a842602"]},{"cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","members":["8bacacff-aa61-4eac-b5ae-410a1358b09f"]},{"cluster_id":"30fdf9bb-e9b5-47e5-a899-e176ffa77eac","members":["2fd3b2a3-f58c-4367-bcd2-a0ab907918e8"]},{"cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","members":["b8d41819-464f-472d-85d4-4d8825b72dc8"]},{"cluster_id":"7440fefd-f7fe-4402-9218-79fa9f53df91","members":["28a9e1c3-f6b7-4263-a28e-da682072bcbf"]},{"cluster_id":"dfea6d47-10c8-4540-8a78-5667ac532c10","members":["561143dc-b82e-4c1b-972e-0d27441965bd"]},{"cluster_id":"27097c65-59e7-4824-9bbb-c0736b2c9f70","members":["82edf1b2-9625-43b0-b7fc-50b60fd2bbef"]},{"cluster_id":"c6f7c193-f407-447c-a10f-3ea5292ea3e8","members":["ded4eeef-c183-4ccc-8be3-7998293de30b"]},{"cluster_id":"e71ece34-2a4e-4762-87c7-693bfadf879f","members":["bbcd424c-29ad-4d41-adb4-c97781a4b967"]},{"cluster_id":"ce07721b-5347-4d52-81aa-7a7c68338485","members":["2581b35a-6fe9-496f-8afb-21345fa2a8dd"]},{"cluster_id":"dc8d69ed-9d9d-4c04-a104-2c89e796edf3","members":["52519e4a-6c58-4d1b-89f7-04d1a7410ce5"]},{"cluster_id":"c6d29068-aaee-4cd5-94e1-e4e031d50401","members":["54fa8502-66e3-4d23-bee4-4544f015286d"]},{"cluster_id":"63bcdf8d-5d7d-43eb-b5b5-735ed74b200a","members":["0382d146-798c-4e98-bf90-fba4cf45a308"]},{"cluster_id":"553489d8-ac8a-4e20-ab65-673fb4e17c1e","members":["b4a3e4f3-ace9-4d63-95ba-a78ebe688191"]},{"cluster_id":"60a1acab-79cf-438f-96de-dbff294bd2e7","members":["2248e2d6-276e-470a-8a5b-f73747019001"]},{"cluster_id":"f8e7dcff-d078-4ce8-9ad3-495ed7c19774","members":["6fa5ba65-1b87-4285-a9a5-3a94554c67ad"]},{"cluster_id":"b3d00803-b5be-4264-bbda-b09db5ed3a9b","members":["64ffb265-5a1a-495e-aa14-80d2aa155824"]},{"cluster_id":"fe10e346-5245-4859-9317-c6ffae804527","members":["861580e2-8611-46a7-b914-edb294d8b916"]},{"cluster_id":"428d818b-c2cf-41c7-bcd8-3f5cb0b144ef","members":["2beb2d9c-db42-4203-90eb-078a562de80f"]},{"cluster_id":"3b17ca99-a0cf-4b4c-a71f-c0181125d3ce","members":["f32ed7eb-c541-4c90-afa3-c2403a0cd3b2"]},{"cluster_id":"5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe","members":["114a2918-55aa-4649-81ee-2d5875a81cc9"]},{"cluster_id":"a1ac0514-0dd2-43ae-9f2d-5939e791e058","members":["3b5afae5-ebac-4413-bff8-cc414ef551ef"]},{"cluster_id":"be4a2385-74e7-4ed5-8c71-c890af870db7","members":["d5b22620-2260-4e65-a424-eaf06965e7e9"]},{"cluster_id":"78cbe3d8-37f7-4a89-956e-f6dab20ad8d1","members":["dded93d6-13c8-4f81-977e-0779477b6de6"]},{"cluster_id":"f83c19b1-e59e-4712-8a86-4c8c86ee0e2b","members":["1d59567a-e2a4-47f5-aec4-3e370cc9791e"]},{"cluster_id":"ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c","members":["d70bcda9-c233-4308-b6e9-0719754845a9"]},{"cluster_id":"2846d44d-8ccd-40e0-8486-7b360ffa4608","members":["3cf506c1-c396-4fbf-877c-ec2c229ed925"]},{"cluster_id":"41a55c60-75f3-48f5-817e-bc3dd4fc026d","members":["cd217be3-7c36-4052-868a-0f2a3b5364a3"]},{"cluster_id":"6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3","members":["a2ba01ad-c784-4902-81bb-447fade61de0"]},{"cluster_id":"b44cd59b-4971-4182-8766-9ffcf4ae83ce","members":["3dbae1d6-6af2-4492-ae17-f58230ea2ffa"]},{"cluster_id":"6a8ee3bf-31a7-42b7-b481-4b21e09f4484","members":["b3bc6c3c-8641-453e-a50d-dab1814cbc39"]},{"cluster_id":"5b28f56e-4dc0-41d8-b963-a4fc04cbaf08","members":["d8113053-efb3-41bd-b540-2e0ae0f26367"]},{"cluster_id":"46f91c43-019b-4419-b509-a0a1e806ff37","members":["0d5871ed-f21e-491e-b9fc-e8a4f2b3d8c5"]},{"cluster_id":"02c9b472-905f-4c41-8570-811b8d821196","members":["3b8b4ee9-f72f-4a96-93e5-cb907013d7db"]},{"cluster_id":"c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e","members":["dc8d8b18-4675-4d5e-907f-b718920445a9"]},{"cluster_id":"125b87a9-62f3-402f-a1ad-6a9130845e80","members":["a40df7e2-c699-4e3b-b6df-5ac58bd94ea2"]},{"cluster_id":"9f76cab0-c9b8-4e12-bd91-cd1c5474c649","members":["d3846972-39e3-4228-82e3-9e77c1f80743"]},{"cluster_id":"1993c1c6-e677-4697-9e0d-f4c2332e53fe","members":["72583dd3-23b1-46be-b38c-c5b9919c8154"]},{"cluster_id":"496ba3da-7431-46d2-8b63-afbe79f86c65","members":["be4ad66e-73c6-44a3-a8dc-610d40c2bf91"]},{"cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","members":["3e98e034-093e-4a49-863b-54bb8f347b6e"]},{"cluster_id":"68357dc5-3396-4365-90bb-f3b36dcbd7e4","members":["267d7407-8aec-414f-8ec6-99f325f4f78c","b9304938-a12f-4080-b0f9-37024e495985"]},{"cluster_id":"8b198c30-0c8c-4abd-b13a-0e55963e8bb8","members":["72d30220-98d5-4c06-b8e6-7eca12186b6e"]},{"cluster_id":"29f9cc11-a80b-4066-9284-acd0b0746933","members":["cb32487d-caf2-4e49-bdf0-5d334e61b2a0"]},{"cluster_id":"19dc451c-d076-4677-8e6a-44a760f27332","members":["622cd7c4-8d47-40c5-90fc-180cf3666da4"]},{"cluster_id":"f9c87407-e574-417b-a567-8221daa6ee9c","members":["35a0fed2-5de2-409c-bb51-5a52d2d37080"]},{"cluster_id":"72cf96af-c05b-405d-a5e3-785cb1c6c70e","members":["01474331-54c3-4a9d-883f-8cb0e4eaa86c"]},{"cluster_id":"666873ec-e76e-4f8a-8d96-7a31c5084ac4","members":["4ed9be65-3feb-4114-82c4-43f3f933184d"]},{"cluster_id":"afebac7c-8f71-44cd-beec-d242a1b97e86","members":["7b422af4-47b8-4029-b7a7-1c1ecae49496"]},{"cluster_id":"947b44c6-b504-4d59-ad29-0dd1f0776154","members":["f84d25e9-527c-422a-9cb1-9341de6a5cb0"]},{"cluster_id":"6e7164cb-9f1b-4f72-aef4-13243fbf321c","members":["3a70e7d2-ab8e-44f3-86b1-b2506b82321b"]},{"cluster_id":"3239dc2e-a961-4aab-990b-768c092064f8","members":["72019106-200a-441d-9dd4-5fa1efbe3efd"]},{"cluster_id":"13fc2321-1fdf-40d3-8576-3d7e5eb9e53d","members":["cc2f9126-be5f-4455-8daf-dde1a7c7dc68"]},{"cluster_id":"5272bbda-d47a-4619-a956-853dc9c29d18","members":["87d0c57c-b815-49a8-a97b-e6157315d1b6"]},{"cluster_id":"6c511b67-edc9-413f-96b2-94d272eb11e9","members":["2f5160f3-6a08-4202-9c85-ae24f8ffdd10"]},{"cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","members":["94a20783-3b70-4c03-afbe-6b03f5877f9f"]},{"cluster_id":"e6867616-fb8f-44d6-8b92-f5cca8ca9e6a","members":["0aebb9f1-91df-402d-9f33-9d92f0b25ce1"]},{"cluster_id":"ac5cef85-9755-4d73-a0c9-3b2d779220c4","members":["42b54835-5d4d-435b-8b6a-5cedf48f4ff0"]},{"cluster_id":"9860031c-3ecb-400d-a847-e88ace1049f2","members":["71cd85bd-d68c-4f80-96ef-5e4a0f20e449"]},{"cluster_id":"3e5167ea-d839-4cc5-b193-fda2f9c0b53b","members":["dde47415-3e34-42b0-91f6-8049defae740"]},{"cluster_id":"b9198f54-dcf7-43b1-9ba8-28ae1ef79e83","members":["311ef79d-3316-4ed0-aa50-6908a31ccf34"]},{"cluster_id":"c07ab2cc-cb47-49ae-9148-a023065f7018","members":["adcbad7e-4248-4175-a81f-d50b7c2de032"]},{"cluster_id":"6019fc4d-e3c3-4367-8970-ef89e2860014","members":["bbeef6fc-0381-4225-8d4d-c559818a9245"]},{"cluster_id":"55a6c384-27dd-4299-b28d-d3dcd1dd5947","members":["4890350c-f17f-4ee5-9907-ea4bee9f3c78"]},{"cluster_id":"984134b7-51eb-489d-965e-a939f985e06f","members":["8c4010bc-6c4c-4934-bd26-e4ab5f10b96b"]},{"cluster_id":"ddf6dff1-95bb-49d1-93d2-18eeac6d22bc","members":["97c8f3a5-99e3-4d37-8ef8-8f13a0f6f87b"]},{"cluster_id":"4594a001-49cb-45b8-a26a-b07a8a886360","members":["4c2290f7-c93b-4bcb-af31-dcb1673f4622"]},{"cluster_id":"a2a57731-90ff-4a12-a08f-721a9dfc0b06","members":["c675b624-2763-47c1-a4a8-832fa897333a"]},{"cluster_id":"42139453-8011-41e0-af88-1b45a4865158","members":["db746ea7-fad4-4ef3-9c9d-d6271b28d902"]},{"cluster_id":"6cf558a2-c2e5-4467-b5b0-ac3ede97ca96","members":["4e6afe48-56e8-44ee-891f-dd9bae3916b0"]},{"cluster_id":"5cf9fbcc-d33b-4ff7-b888-4b9e4e5ca4e1","members":["9ce36d9d-c25d-4bb5-888a-f10c126f5cdf"]},{"cluster_id":"ed7e3755-29e6-4b64-b965-226f2c61a6d0","members":["0c20dda0-d26d-4aa8-9ab5-36f5ecd7c1b5"]},{"cluster_id":"f4d9e677-79ed-4c5c-84a1-d127898975a0","members":["12a8a42b-01c8-443c-a58d-67b4d9241aef"]},{"cluster_id":"70b49961-b72f-4a9a-bed7-51b09a9f1ec7","members":["bae4b60e-2feb-413a-80e5-9ae5c5227f65"]},{"cluster_id":"68ff85cf-74e5-4234-a53f-6dba1aacb444","members":["40355d84-e0d1-4012-ba06-470990ff355d"]},{"cluster_id":"e126486d-8b99-4425-b6a3-54724b486b78","members":["49f5e80f-b75f-4e72-b737-6acbef1bf0a2"]},{"cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","members":["10bd837a-184b-4920-8305-30712092c033"]},{"cluster_id":"04fa98cf-7cbb-4ec9-b84f-6d1c0570075e","members":["71548d11-3d0c-40be-ad09-6aa892149ca2"]},{"cluster_id":"eb646312-9617-4ab9-b534-22cc250a28b0","members":["8438a8e5-7cc5-4ccc-9e88-93c1ecdd7a0f"]},{"cluster_id":"efb94acb-755c-41bd-b1f3-cb170deb0266","members":["82cc3ee8-b976-4209-ac1c-82cf81af5987"]},{"cluster_id":"88b5488c-d8fa-4baf-af94-ea104e983a2a","members":["884b5410-71ab-40b5-92bf-3fa3d31a42b2"]},{"cluster_id":"ab1e12a7-1d17-4758-97dc-5a8b5a8834bc","members":["1ca2752f-4af9-4d26-8544-6712cd8d5734"]},{"cluster_id":"300fdda9-fd92-4984-a9e6-86c9522fb6d4","members":["7b45f5c1-bb98-4361-b2ce-46d822b10ac7"]},{"cluster_id":"df846784-b644-4d2f-a077-f42db08f73a6","members":["d773d4e9-0cab-4365-8976-c8decb85d8e1"]},{"cluster_id":"7c9c690a-19a8-4aac-aba5-327f2a8b5923","members":["16cce81c-59f8-49fe-80c7-ebfa11deb63b"]},{"cluster_id":"1746dc9d-7bd5-45f4-a86e-d7bc4c937633","members":["ccf1aa54-dd43-4d8f-a738-dd4d80b24add"]},{"cluster_id":"e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a","members":["57c37915-30a2-40bf-974e-472454a96f8f"]},{"cluster_id":"078f370f-a761-435a-a7fd-aae948eb479b","members":["5830dc6f-03ec-4ac5-b7fd-5edf44bb0a83","d88d003f-e632-4853-b889-29b348e0ebd3"]},{"cluster_id":"51eec710-c7a6-436a-b700-e76c7c02bc82","members":["1a00a4c5-406d-4321-84ff-e533b4ecc22c"]},{"cluster_id":"2f6021e2-bde5-4c10-ae2b-194bf6a93505","members":["61b0468f-bf4f-46aa-8677-03c588718fbd"]},{"cluster_id":"3630ee9d-368f-4623-9704-06881bdf9264","members":["9a8b19ca-a3ca-4d44-98fb-4879ab5e716a"]},{"cluster_id":"2fdb1c74-dc8a-4068-93d3-ff9e7c3e4528","members":["38d3dbe3-6d8f-4c1a-ada7-82d3adc0c1a7"]},{"cluster_id":"0792eb98-3885-48f3-bc43-bf2a8c746720","members":["5984b168-5644-4269-bf75-69cbe7dc11b1"]},{"cluster_id":"66914632-689c-4d05-b834-b8904eae50cd","members":["86963e0e-78a0-4aa0-a5d7-18317e7a8435"]},{"cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","members":["bd9d61c0-b489-42b3-81d2-5037b5b9085f"]},{"cluster_id":"c043e411-6d15-46a6-be1e-7a8a943cc43f","members":["6d24cd62-df85-47ff-a576-096eb14cfac7"]},{"cluster_id":"51f92102-4c83-4bf3-8e2d-cf88f9368a7f","members":["ff08916e-80cd-4f56-9132-0d29f090108b","3bf74375-2e58-4af8-81f7-5bd09e663411"]},{"cluster_id":"67077d98-dd63-4eb1-bfae-12ca20649195","members":["1cd9e0d1-d0c7-4e5d-81a0-dd508b1c0103"]},{"cluster_id":"76e2cae3-f195-4448-9b25-588665927aca","members":["acd001cd-0290-40bf-a92f-fa64c5dd7162"]},{"cluster_id":"f65b5094-1e51-442e-b444-de0d25f1fea0","members":["a9df38b0-7eda-4e6c-86c7-f5aec5ef21d8"]},{"cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","members":["0ea3ca70-90dd-4685-8683-40c371c0a842"]},{"cluster_id":"1d4acd59-7bc7-421b-87d6-c6dcd6e61497","members":["52e3685b-c678-4af1-9111-fff0298d8c1d"]},{"cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","members":["f826d0dc-a8ed-4fd6-a3ef-8ea48b29d995","402d4cf2-b595-4a1b-9e0d-398cdaa5f715"]},{"cluster_id":"8aec1af3-93d7-45b8-8844-62e8b3ac6198","members":["77774563-df12-46ca-b652-d2aadb1356bf"]},{"cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","members":["d50c2267-ccfb-496b-ad5d-5b5cf780038b"]},{"cluster_id":"b61ba5b2-e28d-4cea-b7a2-78bed070aeca","members":["5f686620-22a4-4420-922c-3dcacdf705e4"]},{"cluster_id":"253e2fef-8100-4235-899c-96e9877535d1","members":["32c50326-30f2-4f12-8a82-643ec0ef2da7"]},{"cluster_id":"b459615c-cbbe-438d-9dbf-cc3051ba017f","members":["524904f4-9cad-40eb-9364-745fdd154360"]},{"cluster_id":"1dc0ed5e-e098-401c-9b18-3dd42ba6b01f","members":["3ea0bb8d-ace0-438b-837f-af1f609b2983"]},{"cluster_id":"284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5","members":["facbb5fb-ab2b-46f7-8ddb-36e37650f76b"]},{"cluster_id":"a24c9e44-7dfe-4825-ab38-82d2ff8a84cc","members":["7c0d759c-256c-45c0-962a-921ab04dec88"]},{"cluster_id":"af51e97e-2570-48ba-a0bd-ab0668831da9","members":["d8a8c4b2-0e1f-4c25-a277-efd7033a966c"]},{"cluster_id":"35ee8064-f9ff-4496-b4db-ba79f7f24de2","members":["f6afb794-bfad-4655-8a2e-7b3a4bbef5af"]},{"cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","members":["7eb45dca-8013-4bad-a452-af5178b0821e"]},{"cluster_id":"9abd543e-88ed-4716-b3f4-c8fea9769bf2","members":["b0bd9402-6ac9-4bfb-b7a3-46087e2efaeb"]},{"cluster_id":"f3cb984c-8736-4ad2-8cd8-5ca9f90033d5","members":["3e8127cd-0ac5-4ba6-9b1a-2f5ad353a380"]},{"cluster_id":"ca871236-c037-4fa9-b3bc-cfec982a8e55","members":["16b2210d-88f5-4ea8-8a34-f9036b31f1c2"]},{"cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","members":["9548af52-dc76-462b-b47d-4103c15106fb"]},{"cluster_id":"6fa7c53c-2f06-41c6-acf2-531da6482f4e","members":["f19de695-0fd5-4984-879f-5e7fe105d8bd"]},{"cluster_id":"8d98ef20-8cc0-4e51-b441-315a42837e56","members":["1242e98b-4861-4e72-918d-2cf17aa8ef2e"]},{"cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","members":["17369906-4440-4cf2-b756-2f07d9af8743"]},{"cluster_id":"ecf280bd-73fc-4028-90b4-eae0d740ef40","members":["2c5f2066-066d-45f1-97bd-e7d6dc3fdff5"]},{"cluster_id":"0511fc3f-517e-42e7-84fc-34ea436b847d","members":["70e18083-4534-4530-afa8-d8714b3040bf"]},{"cluster_id":"3be4473d-cbba-49ee-93e6-36d5bcd0dc0a","members":["7824b1f9-6e1f-4f01-b3d0-804dacae6c5e"]},{"cluster_id":"fcc58b11-54f2-420b-99e3-8acb8731fd15","members":["074932db-89fa-4c44-b3e2-4b9f5cf79713"]},{"cluster_id":"3bda7498-8cf1-4495-9ee2-307193fe0c3e","members":["ce5811c1-0450-4769-8a57-92c8068d2fb7"]},{"cluster_id":"da4e5cde-efc2-4363-87b4-b9935cc2b21d","members":["059dfdf0-3274-489c-a292-df035cfe622b"]},{"cluster_id":"f90167d0-30b7-4246-8eb8-7c564be9c434","members":["86c627e9-87ce-4feb-a64a-7c2e65cd051c"]},{"cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","members":["86bc7693-d3ed-489b-8275-42c965c94524"]},{"cluster_id":"c62acce0-70f2-44c3-9131-cec3cdb1f20f","members":["004bcedc-8ee2-4bfa-b1a3-bc80706b2c9e"]},{"cluster_id":"e60b32d7-dd12-4868-82cb-0b73bd6ac71a","members":["ea491e59-5762-4b62-ae8b-0e847b8f2306"]},{"cluster_id":"5d2ff6eb-cad6-467b-869b-d4782bae2371","members":["13882094-703c-4278-b683-549acc4d6b63"]},{"cluster_id":"3720666b-a4ac-4b21-9f19-2a86f32551a0","members":["ce6bdc17-d3f4-4f80-85f2-0aefcba95ef2"]},{"cluster_id":"b4c1b467-58b1-4e2c-a735-234cba24891c","members":["f442f5d7-694c-437b-8a57-42377f8836c1"]},{"cluster_id":"4f28eb95-dbc1-4a88-9ad2-cd53edd38fd5","members":["6a12640e-f7af-45fb-83c1-115eb23d04c6"]},{"cluster_id":"e2f88c16-103f-497d-a88a-e63349d63a62","members":["add1a8eb-5ffe-4d41-aeb3-0fe733ac602a"]},{"cluster_id":"62f1a663-dd6b-40a0-81fa-7660c589c0df","members":["11d918d0-91f4-4852-96b6-bcf4b48456db"]},{"cluster_id":"f10deefc-8ed5-4516-8cc2-3ba87195eac0","members":["b8e57973-bf23-43bb-b596-d626ffcada51"]},{"cluster_id":"be44c17b-cb3f-4a06-af5b-de816dfb4f56","members":["1ee64121-a4c9-46cf-b4b9-c13328eddf9c"]},{"cluster_id":"c831921a-fda1-47ba-83e1-1042bd97f245","members":["42e3681c-d6dc-4147-9cac-e4f3a55e2e41"]},{"cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","members":["c6089725-60b2-4ef2-aeab-d22120486baa"]},{"cluster_id":"59f4b586-ede4-4464-af30-2858db5799e0","members":["4af819d4-6ccb-4db4-82a7-142fd4cbfb48"]},{"cluster_id":"eb7fddda-fe98-408c-a2d5-471f6b5aac76","members":["8f3231dd-131f-4e50-afb2-362a175bcd25"]},{"cluster_id":"3c4e2f0e-5b8e-45e9-84a7-c71071caeba0","members":["deb108a4-d11d-4c83-8ef8-7fa28452ab2c"]},{"cluster_id":"70b45d78-dfac-4810-b7f6-abeea55c435f","members":["7fb9d117-424e-4364-ac58-0b3f7a4c9c6e"]},{"cluster_id":"aafb6f56-e150-4de6-8f24-4e8fe467b23f","members":["3840070e-e558-475e-92ef-eacb1b2de62f"]},{"cluster_id":"04c0a28d-e066-4279-bfee-f4757f197d7a","members":["531466cc-9728-4a80-a5cb-881ffd95a5a1"]},{"cluster_id":"a789dff6-b07a-42f9-812b-05be84eb01d1","members":["a2dcfbcd-6b87-4776-bcb4-d7f6a80bca1f"]},{"cluster_id":"3c925ff8-1b8c-47f3-b741-4544a596eae9","members":["4e7cc4da-de24-4edb-97bc-77ff4cea40f8"]},{"cluster_id":"48496823-a243-4e3b-bc74-d86ea0c9a269","members":["4f08f272-a5ef-42cf-bc10-d353d93fcf62"]},{"cluster_id":"b6e9f077-b94a-483e-a60f-d0f3f875ea60","members":["d3c0a979-4284-4184-960f-bc6e4c588e4a"]},{"cluster_id":"454ec49b-c8f2-4a1a-ae0e-928918575347","members":["50b63130-fc47-4ba7-997f-8819f7b44faa"]},{"cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","members":["062db82d-8f4c-48d6-87ac-3bd6f0352740"]},{"cluster_id":"40d2bc92-0cd6-4002-bff9-64332ddd7635","members":["2634c44b-89fb-4a8a-acef-e3b1e128d4a7"]},{"cluster_id":"fff4a6ed-31c6-43f6-93ef-bd50b7133298","members":["bf90dd61-5d8b-42d9-a2e3-6cf4f09f3a7b"]},{"cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","members":["99e744c6-cf62-4768-82a4-c5eb88881c17"]},{"cluster_id":"baef4ffa-45e6-4649-9ab7-8c1b3621d2d6","members":["24fa34fc-a0c4-4170-8982-e09e4b40ed9e"]},{"cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","members":["3f4c8053-b54e-4f92-9d93-277c513ddeb8"]},{"cluster_id":"6ac8924b-24d0-446a-8ffc-cf862b415737","members":["e398e6d7-0562-42c2-8dcf-06c2ea74ae41"]},{"cluster_id":"06f782f7-82f3-4b4d-a941-de5952ae3f6b","members":["3f7883b4-b31b-4845-91cf-194a57ceb24a"]},{"cluster_id":"f92684c8-da9a-477a-ba9a-9eb41a6f9f90","members":["0262071f-6554-4ca8-a776-25ce99af3953"]},{"cluster_id":"41b1a4cf-dc12-4277-ac68-40ba76c05f8c","members":["c1036166-682d-487e-a4b7-4361798cadaf"]},{"cluster_id":"beba9a76-4058-465a-8f4e-bc79ccf7a03f","members":["49c23f8f-23e4-4472-9c11-84c9cf2a0f08"]},{"cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","members":["48210888-cfa8-4ad3-b7a2-0dfa4a41a836"]},{"cluster_id":"4eb34d6f-2849-4a6f-9012-a59681fdeeff","members":["e3bcd447-c82c-491d-b3a4-0e5ed91fba70"]},{"cluster_id":"0ea60366-ef97-44ac-91be-b38d55efb0c3","members":["b2f2fad4-12fa-49b0-8884-c5321146ec35"]},{"cluster_id":"69517d67-11aa-4671-bb8a-815c7995a3b7","members":["55e92a8e-de98-4d80-964f-fa59d9c221d9"]},{"cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","members":["b74fa89f-1aa2-4623-8efd-ade7549355ff"]},{"cluster_id":"539a56ca-1f06-469d-a675-be2a20f5e808","members":["957aa997-f6ee-43d4-b6b5-c02eae63b50c"]},{"cluster_id":"6768580d-67cd-4040-b98a-9d8276f6f0bd","members":["e8ccab47-ba71-4ba0-b9c8-0bc1d09c4169"]},{"cluster_id":"6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a","members":["719af7a9-5749-4c5c-88fd-216b26487133"]},{"cluster_id":"171a2f66-23cb-47e8-a645-32fd4f7a8de7","members":["5380d40c-3912-4e89-8e11-23b13a276589"]},{"cluster_id":"dcadf3a6-188b-4a08-881c-e1acb19f186a","members":["d27d2ac6-9bc2-42df-8d5c-29642e076b66"]},{"cluster_id":"daa86fb1-df31-4a23-a926-1b9981f8df40","members":["7158dac5-0017-49f2-812d-206b0dca8204"]},{"cluster_id":"13db6364-301c-4a4a-b13f-69262abf41bd","members":["4e18d1c7-f31c-47ca-9940-d330060d9074"]},{"cluster_id":"103c6b31-e860-4fde-bc3f-de3b1bf5f689","members":["2b95dfa8-8baa-414d-b8d2-548820d26d91"]},{"cluster_id":"48e347cb-8237-47af-9eab-b23191638cd0","members":["bb99a2cc-c607-4cc6-9731-47b9facdcdcf"]},{"cluster_id":"bc0539c0-9358-42cb-bbfb-8c0b934c5e86","members":["274c14bf-8201-4583-9baf-7f5c6a4394d1"]},{"cluster_id":"0179bab7-45d2-4b90-aa4d-c6afb970dbc5","members":["64084a20-f346-4a33-a235-e62a7c7d2223"]},{"cluster_id":"847accaf-332c-4ec2-bd26-cd592d1fa2fc","members":["cebbe995-9fa9-4d98-b56f-692acb21274b"]},{"cluster_id":"a92d1a1e-f967-4044-9d5c-136fd4264137","members":["bb6e44b5-e6fa-41e5-b9b4-01888e573dc2","51c6b7ce-bcd6-4d3e-a738-a4be010d31de"]},{"cluster_id":"453d17a8-fa49-49dd-82fd-7c3661e026b6","members":["b1de1ae8-1407-49d3-bcca-295522f57b1c"]},{"cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","members":["93eb7a62-784b-41f3-ad72-e305d7708a90"]},{"cluster_id":"2f4a7179-3f3f-4eb6-8891-8b8d39467620","members":["7ba5b1af-4476-4bf4-91a0-406a281c4b05"]},{"cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","members":["1f252834-436a-4e67-a2c6-64a940bbed3e"]},{"cluster_id":"74ac8dc6-1d9b-435b-bae9-36745f271604","members":["8c9326f1-ae17-4b5a-a7ec-52c65d9325a4"]},{"cluster_id":"57bfc89a-d981-44e9-a425-3364b9a5bc24","members":["2db653b7-ee92-4ec9-b180-72c043d2d0c7"]},{"cluster_id":"f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34","members":["5cefc9a4-e804-4c37-a8c1-e474cf868791"]},{"cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","members":["b1af5fde-5c96-4e5a-8d9d-69f766f223b6"]},{"cluster_id":"c56c08cf-6265-4f43-9208-61aa17304ed8","members":["529747e6-c84c-4008-a3ec-058fe174bbff"]},{"cluster_id":"984e2a37-4883-4da4-8899-a3cc19bba978","members":["dcfe43e5-7b7b-4fe0-8bc0-50f6bb6f670c"]},{"cluster_id":"c1308dd1-2ebf-4164-b9e3-2284bbfb088b","members":["eecd938c-ba83-4a0a-8c06-727917605325"]},{"cluster_id":"42734325-e832-49e4-b0f3-d3af89abdf66","members":["37b437be-8af2-4ac3-89c0-21c2cea00254"]},{"cluster_id":"ca129396-101c-429f-8530-fe05aaa1c7cf","members":["789c2b70-403d-4eb1-9a24-21da93e3ad36"]},{"cluster_id":"4a05fcea-c8cb-4b88-bb80-cab978e72560","members":["4d39d39d-6cb0-4725-b395-c44a7955cbef"]},{"cluster_id":"7dc48717-c562-4f7c-bcb3-b4a13374cc42","members":["79cbda05-a678-4a17-b8c4-5f92dca28086"]},{"cluster_id":"8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576","members":["37915a45-2e81-47c4-924c-400eef8d84ff"]},{"cluster_id":"e7139494-8034-460e-8501-83d621dafede","members":["ffa4f281-0e0f-490e-be58-b80f76c9674a"]},{"cluster_id":"752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c","members":["ea35a604-407f-4c7b-a6af-da4d03840f1b"]},{"cluster_id":"c2ba86a6-df2c-40b6-bf30-1269c5ac3702","members":["ad1c1bc2-4a4f-4bdf-b6b9-e9f2d807bee5"]},{"cluster_id":"c18b334a-f61f-4400-b355-cea2e7375866","members":["e2df60bd-689b-44c5-a618-e4e1f0676cf5"]},{"cluster_id":"7ef8f454-db4c-44bc-85a5-523eff6a595c","members":["a221a2d7-fd93-4ffa-befb-59ad7e2b05c1"]},{"cluster_id":"f7811e36-516c-4780-b025-c2c198f87bba","members":["335fef47-0cc2-4ccb-a42f-50c52e23d7c1"]},{"cluster_id":"c6541e86-8e1b-4bd0-926a-c380aa103aa6","members":["872b8944-72a7-4d07-a1c4-a5ef2eea3320"]},{"cluster_id":"eb4aeb04-6d38-4eed-9989-773ac30f14e1","members":["8fc73765-f64d-469a-bdf3-d37328bf1161"]},{"cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","members":["41c6e347-6c57-4ab9-9e83-1eed3caab677"]},{"cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","members":["c7829b30-8d83-461a-a1dc-e5669dad7ba9"]},{"cluster_id":"41683dea-1259-4e44-9283-e6286d675c48","members":["941d2a71-a7d6-4664-bc9b-62c65c5ffca0"]},{"cluster_id":"a0c8c3de-8102-4a9b-b20a-80ade6132b4e","members":["f7deed28-897c-4051-bd3e-0a9ab0a70e8f"]},{"cluster_id":"5e7e70f4-b130-467a-9df9-f6078877ed61","members":["4c70dd4e-ea1f-43dc-98ff-7e84438541f5"]},{"cluster_id":"2b3c747b-9f75-4697-a22b-426999d9c671","members":["d2df6d4b-3f0b-453c-bf5b-701933c7e698"]},{"cluster_id":"e20ec3dc-5039-4e9b-be7d-622592bf425d","members":["25efad13-58c1-4831-9756-06e196594909"]},{"cluster_id":"6677095f-eafc-4bbb-8dde-f914b5103e89","members":["7f530241-1694-4141-8897-e029b0320e13"]},{"cluster_id":"17a14bb5-8594-4aa3-9c74-e077722ac66c","members":["e34e39b3-2fbd-4773-bb14-66e16fb66996"]},{"cluster_id":"2a250092-9fac-4905-871e-1b18221951a9","members":["83f2971d-2fc3-4df6-9e5f-97a52f7be26e"]},{"cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","members":["b23e65b1-6283-4c3b-b01e-46927d683e14"]},{"cluster_id":"19b19cf8-a65c-454e-84bf-36d3044b6f73","members":["c7dc4d17-3c9f-4f1a-8849-8edf3cbfdda5"]},{"cluster_id":"7afd3ded-a43a-4c9d-b365-6656ecd89e6f","members":["78aca2a1-2f9b-463a-85c4-8a95500256f3"]},{"cluster_id":"58a7d973-9fa3-4047-a219-579a31c4561b","members":["1819efd9-1057-4ec9-92a5-e84923e4c147"]},{"cluster_id":"50fd260f-831d-4cd6-a164-2aef0978fbe3","members":["772b5976-97f2-4a12-95c8-3f67f08ffee6"]},{"cluster_id":"162b03a4-86a7-4adf-9f73-3093aecba542","members":["41fa445b-dce3-4c84-82a5-bf1898a19393"]},{"cluster_id":"ad83e0a6-e572-4332-8ef0-01e05cdfa760","members":["407e8b61-b3db-4edd-950e-2c807109ba23"]},{"cluster_id":"655a46a8-9b52-4f61-b528-9f18ec9bf051","members":["11753fbd-fc9c-402d-9811-3a69df087b20"]},{"cluster_id":"7e98dc53-abf7-4bf8-8ac7-3c9623f6d068","members":["70a16720-d268-4f35-8e36-ad170ce32bcf"]},{"cluster_id":"850a1f31-fc4f-4578-baa4-da3b7a35e30a","members":["e95db749-5098-4ec6-9345-aec6a1d3b8b6"]},{"cluster_id":"f14e0258-b8de-48c8-96bd-31550d005b4b","members":["03dc2d2b-ec15-4eff-9790-593d2a773e75"]},{"cluster_id":"0605c233-63ed-4bdf-a0fe-665556a34a75","members":["61090b8f-c351-4d39-b293-02d496c4ca2d"]},{"cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","members":["e4d88dec-37e3-4c03-86f7-7faaa4a822a6"]},{"cluster_id":"a5a6c59f-7670-4f97-9c2b-c94700d73131","members":["dbe5cb87-6836-4dd6-a307-d04dc800cde1"]},{"cluster_id":"f66864ea-bc5a-4c3b-ba81-6aa44dc35cb3","members":["0747b3a4-c669-4df5-808a-d613cadeec1a"]},{"cluster_id":"3e304d73-a8bf-4d4a-8525-85d6c447ae6b","members":["51cd1cdb-d1fb-4f80-b303-18db54827cf5"]},{"cluster_id":"7b76e5cb-748d-468e-9baa-d34773d5f24e","members":["39f943a4-0a7d-4621-b7a7-5c0be2d61db5"]},{"cluster_id":"679dc735-ea4b-4b4e-88e2-45d26bcc5b41","members":["a4dcd6e9-eeda-4dfb-9c64-117707d0a66c"]},{"cluster_id":"ef57a08c-bb40-48bb-8784-c240ed933462","members":["d485c361-9b6d-4071-87fe-6aacd4cd6180"]},{"cluster_id":"ed1fef35-ea22-4436-b53a-1dc1f0380298","members":["b59a7553-ce15-4155-84ae-a924e79313a4"]},{"cluster_id":"f51d817f-9949-43cb-b16a-bfdefff947f1","members":["d7b4ec5f-6db9-4bd8-b2d1-46940bbd2d84"]},{"cluster_id":"0166ea62-85f0-412c-bd73-f3d7bc1bdf59","members":["cfd59ee6-711b-453c-8505-5bc0e9d0499b"]},{"cluster_id":"ce0417d2-5817-45d3-a01f-447b8d6d19ff","members":["5c9afadf-bdd1-4b6f-90a5-1539e037df31"]},{"cluster_id":"96b44dc8-1893-429c-83b5-6d58cef5fa9d","members":["fa6bd3a3-a782-4525-8065-d7c55a7d2524"]},{"cluster_id":"8944c246-4c2f-439b-bc21-590da536eede","members":["39ced119-b9ff-4dd5-bffb-c2b0dfac001e"]},{"cluster_id":"b4ecc989-8236-436c-a361-fdaa1e9413ad","members":["55db5b56-74ee-471d-b522-65a8bf2f70c4"]},{"cluster_id":"0a27f80b-b648-4764-8688-fd889dc32a39","members":["fc96abd7-8ce2-4450-bfd6-951a94697ffc"]},{"cluster_id":"bae449de-e29c-430c-9526-c8dc925bf231","members":["e11aef87-b457-45ce-bf4e-efda03b4bed1"]},{"cluster_id":"9c99e4fa-6c0d-4aa9-bb98-86450c898d1b","members":["260d2849-6e85-4bd7-a5e0-3533d6ec5909"]},{"cluster_id":"131fc120-2488-4970-ac79-410004aa6030","members":["90bdfa4e-b4a0-443d-84a2-56ac539d802a"]},{"cluster_id":"da745b4f-4158-4c1c-b2f1-ec13252863b3","members":["20f72b01-a541-48db-a97c-ad35b82d6dfe"]},{"cluster_id":"be467aaa-b350-4a63-875e-7aa61c3d868a","members":["27df6cfc-a1c0-4cca-9425-b5897788f1d8"]},{"cluster_id":"7c8b94c0-08bd-43e2-9b5a-418ff416c274","members":["0a2b3c34-28d6-4c0f-b765-6820ab6a46c7"]}],"event_clusters":[{"cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c","members":["38817e72-8ea6-4a91-8032-30eba5f54cb7","15c88d5d-4214-4f6a-8e3e-981cf10164b3","da41dc75-fcc4-41ab-88dd-ddf7161e36b0","883a896b-e817-45fc-b9ee-371155a7d074","d499ec0e-dd4f-4f89-9447-aa1acdbacf68","ac85ad4b-cc9f-4f44-beb5-ea48d8a52c1a","b002bc7e-9203-4656-84b6-0a42fd4eea6d","1feb038d-92fc-4cd4-b25c-1c1a29e47dd3","a12a73b8-1940-447d-b9e7-76cb08c90246","4050775d-4d21-4e1d-bd3e-b7ac298dcf8e","1188ef4a-afd9-4c2d-8d23-cb5ffb6c6df2","33911966-bd3c-4971-abde-7b549abbf5c0","86f7ea7d-367b-4e3c-a4c2-06a33148d191","9daad42d-18d2-4972-91b8-ef9a05123604","d991436b-aa0d-4d71-8ddc-97f32927ada2","5d33b07c-4552-4834-89af-6820b593c9ef","688fe4d0-074c-42df-90b8-b7269d511b8a","f2ed9760-5610-4a2c-9354-e9247fc29368","6f7e1a31-2f08-4dc1-9e88-4c22430a5a99","4752aea3-c2b1-42ba-8ef3-78e974599ff3"]},{"cluster_id":"b8ea1565-defe-4a1d-a235-40a614cdd9ce","members":["3a17acef-1782-4e5f-aa26-098cc82ab82a"]},{"cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5","members":["96c10070-a729-45d2-a388-f0bf828e9f4f","4a28a209-dbc3-45dd-b84a-d065c7a2ddd8","ef477121-218e-411a-9ccc-a92c33206c03","cb6e63a1-19db-4f46-a697-59d594fab471","24ae4864-abfe-4abf-899b-ea8d7ab6dacb","9be704ed-0245-4064-813a-c380592a9050","438d9319-2731-4376-8c2d-4a97f1f00888","bcb14239-600a-4eab-b1b9-58e88135fa1b","7eeb196f-3cdf-49d7-a679-20612e8b96a5"]},{"cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b","members":["2157e893-ff88-41ee-b94d-63bdd6b33a42","05801579-0283-4e6f-9252-e0ccd540942c","01616dfd-fc22-45d1-9fcd-1b2ad598a500","db688f4b-62e3-44b7-adcf-3ae0f870d11d","1c43e30e-6ec5-4b7b-8717-cc2a2a107d40","1d831c31-4014-4bf2-96b8-24fc74385832","1cccfa74-2117-468a-aefa-213b8307ea3d","58935218-ac05-49c6-a4ef-438b8716d1fb","520176c7-8c95-47d8-a5f6-2fa9bc33eb5c","e9b6d363-8833-4dcf-9fb9-f2f319d33e06","d4ac0cf9-cde0-4c2c-8550-238510e5a0dc","6964c63e-6ac3-4676-95c7-8019b57baa90","77273e0c-48f2-49d3-bed3-e1b2adffa13d","bc043127-5b23-4ee1-a4f9-b80ceb8089e6","53db27b4-4d8e-4ffc-958f-39a178f1fcb9","2e24dce7-d94c-4791-90e0-80af31835706","e813eef7-8b07-43c9-9b52-89016dc23bfa","156ad354-9ff7-4d94-8f13-dca5079d271e","2ab59778-fd56-4c7e-a5a0-f41cd08542da","b16aee51-f02c-4b7a-971e-f64d6361f22d","e241f247-6176-476e-8066-4a9677b0c4c0","374385f7-292b-4a9f-8779-030b8b2426dd","3cc24982-0e8e-402e-bc62-17a64ee6c945","78361e4d-90a1-4bab-8a32-903cf5747287","0cf49f83-68cd-4108-904c-11ec76282794","c287a65d-6767-4792-a760-e5e5c06094fb","b8efd856-ccbb-42ac-8e04-a53a4c96b40b","49f61cde-4635-4a82-bb4c-63e3298cb768"]},{"cluster_id":"2d27e988-7b20-4d35-8415-461b2756da32","members":["379de43d-cf89-4e1c-a6bd-ea204190dd70"]},{"cluster_id":"9103d8ef-aca0-41e2-a089-fa1568b1c90f","members":["936b959b-6c76-4051-89f6-fe1ec2bee40e"]},{"cluster_id":"40f8706e-4783-4eef-bf10-d2f20bfb78bb","members":["dce49401-863e-4c6f-893a-323fab28b5ec"]},{"cluster_id":"49b36199-c1c8-43a9-b1e6-9f3f63fb03d2","members":["b6971264-6ca4-4aa5-a164-3d9bd552bfa7"]},{"cluster_id":"de6de235-4f06-4b1a-9079-19678104136f","members":["7ab19c87-15df-4cbb-987d-eb9014edeb27"]},{"cluster_id":"ddf8f300-b701-4129-bf0a-f30da96bc031","members":["4b078541-759d-4b6e-b215-cf946dc4f2f7"]},{"cluster_id":"7a09649a-0d1c-4211-a9ef-65dbb223fc3d","members":["a40f6c4b-f04b-414e-86bb-e50d7519d701","e5febf9d-f8b5-44f5-91f7-a1784dc87110"]},{"cluster_id":"bf671abc-cf54-41ee-b308-c02abd68d48b","members":["6bbad3e4-8bce-455f-b619-561b2fa64940"]},{"cluster_id":"8c5f95da-6a16-42a9-82d6-b9a5a0c0b94c","members":["5b2a3322-05ed-40ad-a7e2-263881ca929a"]},{"cluster_id":"e8e30d44-65d0-4e66-baf3-7e0ae3df4a05","members":["db951ce3-0774-4b1b-8098-c783a8e0060a"]},{"cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f","members":["4ee8388c-21bf-46da-b34d-6c991d81c123","663f388b-8d33-4499-af44-cd69c04ac64f","5e8f4fa4-fa26-485e-8e61-7934f5c5bf39","4d8ffea9-6020-4546-8897-a13e1054d374","df930dd9-6b0b-4827-afe1-5894953e01bd","40d1fa1f-1ea6-492f-b43c-71d594b24f86","6b1d0896-6534-4772-818d-a3b7f82c5da1","953806d4-b8b0-49ec-a28a-62b9d8739402","2c9d2a6c-ddf0-4248-ae7d-b39d356c078f","0257f52c-89f6-4cfb-9c0d-5b86a9efee9d","a3ea47d5-c69f-4d63-9199-e145f58f0b7c","460cdb5d-07ab-4e6c-bc3a-d2feb9e90359","355f7a62-c215-4842-a84b-3c956c65a379","5943d437-2833-43b2-b041-b1240a2a79a0","771cadb6-a575-4af6-8466-113aa0936dcc","0d960c2e-82aa-4fcf-8f81-ab730c8a9dd5"]},{"cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07","members":["fec0b6e7-7749-48a6-a023-a4649ca36af7","2e0c40f0-7009-4245-826e-b1c693e22a37","6ff8e77e-ba6f-462b-a50c-91dc2a48055b","81ef874f-fdd0-44e9-82c4-b0faf65cb9de","13afdb0f-3788-4b98-94f3-d10f8635be0c"]},{"cluster_id":"7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a","members":["ad77c269-8758-44cf-ab9b-5ccaf6f7e0c7"]},{"cluster_id":"213244f7-7bbf-4ff3-935f-65e545a0abda","members":["d2a9eeda-e0d7-4adf-8acf-5dd5b1b69038"]},{"cluster_id":"125a4bc0-e32c-4a8b-80fc-60d23537d495","members":["6eb99b34-dbe3-49ad-a849-160d8c11f9bb"]},{"cluster_id":"f55b7553-3d55-4096-859e-954de960f09c","members":["f4b4255f-ed8a-498a-938a-a7347ca9e79f","9ab6ff72-6210-4869-bde8-98e72edd407b"]},{"cluster_id":"092404d0-7d21-433f-bfca-9a5d34d17b3b","members":["39785e4f-77f4-4b08-ad16-8fe094cb7be1"]},{"cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c","members":["684992a5-2c7c-47b9-9d0a-da99a5d62d04","dc1984b6-3a67-4928-bd53-8112534f27f8","f78b6f97-84ba-4753-817e-24578857cf09","80f2e96a-02b8-4aab-9fb0-822357bd83e7","d2216b00-aa4e-4904-a59d-96640477b74f"]},{"cluster_id":"976b0673-ef25-484d-9be8-afb6c791a214","members":["89efe27f-5d32-4380-9e65-7644e8368672","6e3b4786-415f-41fb-a8fd-11b0bfc99338"]},{"cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739","members":["ea8eba9e-8051-4f71-8589-621e0f0ca050","0213cd1b-8b7d-4c86-810f-98a80cf0764f","b74705cf-c363-4742-91c8-2cd15d504506","52ae8b98-0c2e-45b6-84d4-fd25071809c6"]},{"cluster_id":"0e248889-43a9-4087-a6b0-f1d7854daf2c","members":["45cd2538-8b5c-46ce-8c0a-b42354ca8b17"]},{"cluster_id":"38fab33e-077b-434b-814f-3bc3f8dfc415","members":["367805bd-60b6-459f-8aa6-ba7e91ca4158"]},{"cluster_id":"d0ed171a-d118-47d4-ad40-05768ad6c3f9","members":["dc10dd9a-4b20-48d2-b195-51777fbd3cc3"]},{"cluster_id":"c96cd646-4254-4e40-a0db-aa3d02c5b208","members":["db80f6e7-5b5a-4d3d-8a7f-0976038fa7ae"]},{"cluster_id":"5fc56973-0e2c-4845-a192-e7e5c5265d9b","members":["a0a156cd-e22a-4c3b-b5d6-ee9a61dfb941","4bd27717-a688-4f9f-b97e-50fc5fdbd956"]},{"cluster_id":"eb95d7a1-b24f-4167-89ab-cc60dc7c7822","members":["146f7a30-90f1-441d-b120-fdb2884775c6"]},{"cluster_id":"b996a367-b4a5-4361-bd3d-e0e97f9ed9ca","members":["3221eac8-87f2-4ae4-94a3-10488319adb7","66f3d2eb-3679-4a14-beed-197acfbfb172","8db37b71-9f12-49f1-bb1a-ba3ccda5847b"]},{"cluster_id":"6195dc7b-895b-4134-9995-738fed6389e2","members":["99d301bd-3e4f-4202-8c65-4e13eb4a35a6","70d2a4d5-b786-4e49-af2c-e2da94a512f9","021c1c3a-fd51-4941-9034-e50318b1dbba"]},{"cluster_id":"90bfcfdf-2a27-494a-a983-e0be2f5b4a32","members":["714c48f9-1de5-4102-baec-011c0b404f87"]},{"cluster_id":"05359182-fefa-4fca-a6e5-68210986bdca","members":["0d5d70aa-630c-4de6-b6ef-36b85c677f16"]},{"cluster_id":"64ce313a-9f62-48b5-ac72-4f4f23b43da9","members":["a3817884-5e86-4a0e-96a0-abc909757b10","6420c8f8-d16e-4808-96f7-081e0dee8be5","b5679d9f-403a-48aa-a58b-18d8bee4635c"]},{"cluster_id":"fae21323-4e89-4f46-9b05-1eb8df8ce6f1","members":["1ca906e2-b0d3-439a-9c6e-9948f1d03d8a"]},{"cluster_id":"2f8dc773-32fe-42ed-a085-3a10ca61c22d","members":["fb127d47-1234-4c65-9c3c-1877970b3eb0"]},{"cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2","members":["4735f952-560a-4efc-bd14-23bc7888a8c1","54574071-66b5-4e68-a984-ed6d330c2fdf","d4e114a0-6a56-4ebe-9b0f-7f235be968c1","e77c2457-bcbb-44c5-98ef-1183f378c60e","7062595a-a23b-47c0-ab2b-7a0857b23c87","d0debc7d-8581-4e61-8d60-6bb1817aca0e","f648a1ac-8647-4587-a65b-ec507e162328"]},{"cluster_id":"db23d549-f792-47f2-bc74-2fff4db9d0ef","members":["0810a5c9-b58b-4ec5-adbd-103a2842ffe2"]},{"cluster_id":"38653b72-3e71-45be-a6f6-9c4e86755c1b","members":["d887d1af-80cd-48ae-a8cc-124464d09ea2"]},{"cluster_id":"d3326047-f19e-4b54-a0ed-a16bb5dfd0de","members":["8170bace-2d7f-4f1f-857a-b06c0eb8d69f"]},{"cluster_id":"b50d8113-2ba3-4857-a6f8-d3c42cda7690","members":["ea179191-dd07-4d44-9c73-fe1f9a8d4df3","d5b913e1-ad6f-452f-9eb0-7eecbc873007"]},{"cluster_id":"3d02db59-a52e-46b0-b009-3a6b28cebb78","members":["3dd7b820-dbf9-418e-8570-ae937593e90f","e5008ebd-7968-4365-b0ba-fcf2073e10f7"]},{"cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc","members":["ee008479-2289-4446-9132-8c75ade20ed3","8e41cddf-c165-4805-86c2-74203f0c56af","0eb8db24-a286-43df-a6bc-012647f9c7cc","2eaec24e-b54e-436c-b85e-1fe26407abfd","4b795e2e-7eb3-45ee-ab80-4bdd2e3d9779","51a3f058-2f29-41f8-b540-5710b0e086b4","2602f358-ce54-463f-aa87-f29b88d699bf","456d3b04-8421-4838-812d-1f8e88ef43be","a0e50427-37de-47e1-8628-65a45368f81f","d8c49565-8be5-4d93-93c4-be6dbc0ff16a","a777797a-1eff-4aae-ba9a-393c85e471c6","5969a8a1-4412-4685-bc71-abc76f654bf5","2fb180ca-ccca-473d-8d00-71aae8a614b0","dcfb71f8-e742-4806-97c7-9c89af87b65a","b69ad494-a55b-41ce-b287-247101576271","6cc8284b-e23b-4ad8-9dd4-11f9c70af258","aeee00eb-e4d2-433e-836d-a4f0166aca4a","cafec841-66ca-4e56-8c7b-bec6678a1ec3","0573fdc1-393d-4cd7-8ccd-282f5126c66f","35e7b213-800a-404a-91b4-d3bfc3e7d69e","3b3306c5-39b2-428e-a46c-b4027bb3f7b2","f85a5e36-7aa3-4d21-955a-37dfcfcb0028","1089e709-3514-4c73-9c03-977c544ef2a1","c5926f07-1b8c-4545-8b18-9b06960feb26","3125e0e6-6275-4e6e-93cb-46b1e8fc05dc","6dc77cfe-a660-4c19-8ac7-e90ed1c0e119","56c1f7c3-5279-463f-b46d-75aae1b63a4b","d9d55e1f-e4c1-4127-8aa5-2dc2a867de4d","0e2d0038-14e7-4b49-8a47-5d83cae03712","5f879db0-e8d7-4968-9b39-fb32fb26105d","910e2924-30e1-4d8f-bca1-846ccc34fb20","9313994a-61f5-4078-acbd-c434cdaf8305","6a3252b9-3000-4c23-9e4f-54b368b2f63f","60857a55-6193-4bd3-9d2f-63e1ba65d563","59688e0a-e6b1-4686-9d80-3ed2b50a11b0","84b11ee7-077e-47f6-80fc-01a20fe348eb","9629e5c8-186c-4e57-91bf-b18b548bc1b0","2247aa0b-b1a9-4cc0-806f-c9d2d0cd4d6e","8a5ddfe2-cfe1-4f96-9acd-23c0bdf4613d","b144c6b8-594b-4b18-a0e0-8759f18a0fef","9d91cf96-9ac9-4dd9-b4b1-a62cb2f0b37e","f5800722-6b8b-4a18-be9d-085c87f1ca2f","51da7fb3-ba1c-4c01-bb2b-33e9987857e1","ea77b17e-ecb8-4852-bf00-da2fb17cbbe1","85028514-fcf2-460e-b88f-ec26291d1d1c","608d1ff8-dfa6-45e2-b5f9-0f8f07b43b6f","6c96e600-ea11-41eb-980c-50af62ee819b","1e030ebf-e8f3-4135-b352-2512fe72e38f","638706de-f7d7-43e0-8478-a9ffc03ae9b6"]},{"cluster_id":"d76d71cb-517d-47c2-8ed2-a260ceec7c7c","members":["f3ddd2b0-3e39-4f9e-8999-561d992acc38"]},{"cluster_id":"dd01fe5a-45fc-4f73-94e4-2d244f396aa4","members":["92e61383-3536-4054-8579-a904018b2e01"]},{"cluster_id":"b270ac4b-0013-48c8-8b62-49d992310a4e","members":["d4814cc2-fa4f-4b64-b524-fbfaf55aac53"]},{"cluster_id":"15b25c11-ec21-460c-ad6a-670c9cb77249","members":["c9b9ea97-f8e6-4d40-bb74-fc1ddbb5ea9b"]},{"cluster_id":"65ce1b56-2de9-4e86-a4bc-a0777c097c60","members":["829d31db-8aa2-40cc-9c88-773a9efc3573"]},{"cluster_id":"768c2664-8354-4bfc-8b47-96eb4e08e0ee","members":["c038129f-6a7c-4d41-b509-5fbbde62f12d","f5272df2-6a70-4641-aa53-d3ac1bfc97e4"]},{"cluster_id":"04e520d6-ffc4-485d-b6f9-73b32b9e56e3","members":["c4ec41ee-edc2-4e97-8286-6ebf940f58a5"]},{"cluster_id":"a2b34554-85cc-4429-8668-e4a20bf0d860","members":["482f123e-5c2e-4384-8d1e-b1cf8956ddab"]},{"cluster_id":"974fea38-71aa-4887-8998-28e03cf7c1b0","members":["1dc762ef-2efe-452d-b773-d99eb32c7cec"]},{"cluster_id":"0ed8b02e-9110-4797-abfa-1c73f2dafe4e","members":["cc7a9342-86ad-4560-8aad-fdee3a57eb19"]},{"cluster_id":"b85d6c69-8e92-437b-87b3-200c9509883f","members":["639887f4-84bc-4417-b01b-6cab4248b8af"]},{"cluster_id":"44d2e850-7a7c-430d-95ed-40c5cabf8096","members":["860f708b-df74-45ba-a4c1-de5320b64832"]},{"cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70","members":["cc943ea3-351c-42c4-814b-690a63727907","455b2dd1-c3a1-474a-ab22-e9dfcad0d66d","605516b3-6350-4af2-a2a4-0e5e03f786c8","8386101e-8dd9-40ee-915f-daeafeaccb37","51c91a8f-836d-4f3e-aa83-115580b2e75a","16bef4ff-b6fc-49ed-9739-8e7b0eeb5d41","4b78b22b-a78b-429d-ad70-d88d304eb04d"]},{"cluster_id":"bdc4ffb8-404a-4799-a92b-88d77e6c445d","members":["9ea199bf-97ff-446a-ade3-676524ef8e19","3d69889f-6ef2-476c-82e0-6a27979e1cf6"]},{"cluster_id":"e136ae61-7689-4d72-a14e-2120e6260be2","members":["6ee2c4a5-b657-4d1c-9444-ffcf3cf9fd89"]},{"cluster_id":"999e57b5-71fd-4f69-ac79-5d89ae8e3c67","members":["4ac88c8b-a6ca-479c-8ef1-3ec6317c887a"]},{"cluster_id":"d64cb1f8-2dc5-4222-88a6-8bc5208a2f30","members":["4ded304a-7c7a-4b94-b613-5b71b1cd02af"]},{"cluster_id":"2f4a9e86-aaa1-4911-a5a8-85e77f2e4012","members":["674d7e77-a807-4bcb-b2f0-db7fd01b99dc"]},{"cluster_id":"fae4a05b-8c8a-4da0-ae56-97672bb4bbb7","members":["f9f91961-5933-45e4-a97a-0833538d7593"]},{"cluster_id":"75366cd6-61ed-4e55-93f0-d40cb0af777b","members":["58f8bc90-56c1-4f8d-8932-e115eb1eb493"]},{"cluster_id":"adb05a60-b0e1-4623-b55a-6fea056e1f65","members":["8eaf0a96-0a0d-4ce1-91c1-5dddff9ddc32"]},{"cluster_id":"78d5de97-f7ee-44e0-8fbc-dba1797c97c4","members":["035c0704-fde6-402a-bd64-295dcc5ab480"]},{"cluster_id":"19360eb5-62d9-45d5-b2f6-b66b7fee7414","members":["00a36aae-c5bb-448e-ab16-0395d0b70515"]},{"cluster_id":"c317865e-d1be-4abc-b1b5-dece44444a1b","members":["bd2cfaed-5d7a-4929-beb3-86245cd1c054"]},{"cluster_id":"050d87c2-4ac3-4e0e-8673-b4a44b43bac0","members":["64d50dc5-383a-4f9d-80be-93d978bdc313","7870243e-8aad-4f25-8742-7767ce72c40c","148b32a4-73c6-4d27-b7da-71b2c9563b4d"]},{"cluster_id":"59a2b2e2-fda5-435b-a046-bc1854ba1410","members":["87fa4685-aa79-4eed-b5cb-50f8aef33b49"]},{"cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f","members":["768dac8b-d8e9-4bcb-97f6-1ed7eb45ef31","9bc2ab0f-ee95-4230-bd19-8f3d5b1383d7","04fa843d-c467-42fc-a11b-e2b4e326fd6d","d46d0c0f-98c6-4033-a3bc-33944da10810","32c704e2-9110-47ed-84c7-df34341bc74e","cb791cbb-0911-4b8e-97a7-752b4d22f599","9e1f9fe9-4b99-4e49-b766-2b7dad31a05b","9ba195c6-1326-42c5-960c-19e7c8042ded"]},{"cluster_id":"8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4","members":["6c0852dc-908f-4e43-8e65-b39c0a942d84"]},{"cluster_id":"b07f3d2b-07c7-4378-8e98-619949a67d5a","members":["28477e2e-b2d0-4bea-aa09-8f91c8ed2caf"]},{"cluster_id":"eac47a08-6ad5-4405-8bfb-82ab701b0507","members":["363e93cb-9979-4571-81a4-9becd07d7e1b"]},{"cluster_id":"1d45606c-718c-493d-8ad2-e61d4af0180a","members":["14394b9e-6ed0-474f-8195-ae45ad8886e8"]},{"cluster_id":"67852dd4-618d-4a28-8987-e12077575820","members":["9f75fed9-5379-4ae5-ad35-29573d717166","942337db-4b80-4c5e-a142-04a5dc2df92c"]},{"cluster_id":"d0dc34ca-6f25-427d-a56e-1d4f3210e605","members":["a865b697-9c11-451c-b357-6deb59025afe","6d5a827c-ea0b-42ce-a5a8-4c2933dddc23"]},{"cluster_id":"21a0cca0-78e3-4e0b-95d4-e1b42b08be47","members":["6bb25525-db36-48fa-928f-3c54ff5192b7"]},{"cluster_id":"f996f072-3b37-4e7f-900c-1cc05e40fa72","members":["557f5241-833b-4d75-bd17-d5e083a9c848","e9f9a540-7ab3-4dad-a019-1dadae170d43","8b7cc9a0-f571-42d3-844c-77499a7cada5"]},{"cluster_id":"5b55251a-6617-459a-a1fb-c10dc23dfbc7","members":["3aa14a59-17e4-4777-8e1d-8ae3f9be02bb"]},{"cluster_id":"a2e35d24-76f3-4ea6-99d1-6a5176010a02","members":["1197b256-f2e7-4f92-8cd6-82ff67958352"]},{"cluster_id":"352c9b63-ad06-4659-b8a6-286e7a80ff49","members":["7c7d2966-8267-4911-af9c-12c9f638b50a"]},{"cluster_id":"5a3236fa-e7d1-4fa1-bcc8-0cc89c18d852","members":["48aa818f-0004-46f4-b264-5cf6bfd86d44"]},{"cluster_id":"f1fd6338-9958-4c6d-8d13-636315f421f2","members":["c3652003-e9b3-4858-9187-97009a81a649"]},{"cluster_id":"e216b0a7-0193-4a30-a076-a872f378296d","members":["7d8c806e-235f-4780-b922-e4b749fe7829"]},{"cluster_id":"4da30c02-5a8f-4e15-af9d-b0a7ede85a55","members":["507f1d48-65d3-4331-b334-74205ccc9cf6","4b57f24f-9d8f-4e66-b607-5cbf5a7f73ee","4680599f-6612-48bd-85c1-987e66f1852a"]},{"cluster_id":"fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13","members":["be24cc5d-48a1-4fd2-98b6-c84005b2eb5a","62b46015-1ee6-4431-af95-060d712b7892"]},{"cluster_id":"fe911735-6fb7-4737-bc2c-bfe7c0b05844","members":["d79c60ce-8f4c-4997-83e8-d17fafb90523"]},{"cluster_id":"eec253c7-dea4-4bc8-94cd-e84946c84d8f","members":["1738a518-ba07-4ca3-9eca-d29ea746b6ce"]},{"cluster_id":"c5a49990-0bec-49b9-8797-00d71805007a","members":["308fd4d8-6903-4d8c-b2a4-0fbaee4b4fe2","c3a9c214-92d4-48cd-a33c-f2855651a9cc","26bcea85-340a-4926-a72e-f5166eb39426"]},{"cluster_id":"02063354-1cf2-4e4e-a749-ce91914994ae","members":["7448f12b-9dc9-42a3-b6de-962a71c7ed57","58e8eec0-3b18-4176-8e32-256e25f75ccf","6a4bbd14-52cc-407c-a5f9-92ee77c8a044"]},{"cluster_id":"028c83e2-81b7-4016-ad11-5ab7dddf6569","members":["1f06b3d0-c786-4d72-9b93-21be62274d4a"]},{"cluster_id":"60f1920a-6809-46d7-8c57-4dab4cfa8642","members":["4d8ec00f-12c2-4a55-8fe4-02c2c73feb6c"]},{"cluster_id":"c9770c33-6591-4102-923f-7ca010384410","members":["0fdaa2f0-ec41-4eeb-874c-df6ef607bdd9","87f10262-b62a-4311-a7c5-9dd935e92d24"]},{"cluster_id":"270b9be6-37c3-4ab7-9763-57943d7a38b9","members":["8197d19e-eceb-4bfe-aba8-d6ddc8230219","2bb42626-d925-4aff-a4e7-1c28444704c5","6f110a73-018f-47fd-9d6c-f95e95b1b2af","93c996d4-1901-4294-800a-e38c0d1eb1c3","f82b7bce-3fa4-4d11-b057-f19740ff07bf","055e26f4-de2a-481c-8228-76083549ff72"]},{"cluster_id":"d2dbc116-d919-422e-b972-f5d26fbf7db6","members":["a6af24d1-f9dc-483c-a4d8-a6f50fa7b678"]},{"cluster_id":"5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b","members":["55fab3e5-ba46-4262-ae1c-d37882c30805","dc0244e3-143a-4b9f-a10d-0fb551669113"]},{"cluster_id":"269ffe65-bf3c-4500-8f51-b6ef7e6175ed","members":["4c787be9-0d63-4d4d-bade-049a1d973e67"]},{"cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef","members":["fe136853-4ebb-4ed7-a1c3-5bea298e90e1","89b9c035-3efa-46e8-8eaa-18f76dbcf1a8","40d37e86-1ea3-4247-b129-3142707eb05a","c4938d22-e6a5-4ada-bc6d-52b2c6e18343","227d7b44-4791-4e82-aca0-1a384e087533"]},{"cluster_id":"72084673-8080-44fd-8f5b-97507abf262b","members":["24221e44-62c5-4978-8daf-953b9cb01868","fa2956eb-d0cb-4e35-ae43-0fb364f44bb6","b850f381-8f21-4d77-aaf7-601540816ff9","7187e3aa-5b53-414b-90e5-9921cf9ae4bb"]},{"cluster_id":"38be1a05-48d2-4f48-88ba-580b1bbdcf47","members":["e2efe459-f5bf-48f4-aabb-d2614f71c39a"]},{"cluster_id":"baac2920-a8d6-4667-acc5-460b63889a7e","members":["ebb90c43-c681-4398-a1a7-f903b4292d05"]},{"cluster_id":"41c769d8-9945-446f-ae71-144928242d0e","members":["bbc04673-2959-4bfd-9506-96a313508f38"]},{"cluster_id":"cba3863d-9ffc-4647-831b-d4da84c689e3","members":["b5c8ae6a-2bf6-428b-8893-ae8ae103b4e3","b324b72e-88e6-43e0-b030-70c39eb247b5"]},{"cluster_id":"b454bfa6-3d84-4f22-a166-5f84ce0bf756","members":["7413dd57-157d-4e44-a9c9-ba040174c5c7","2ae1a6a2-00dc-4716-8f58-ba4af4a22dfb"]},{"cluster_id":"bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2","members":["40f46eaa-714a-47d4-9a53-3e4de1e79681","aff81321-a0f3-4580-8bcf-752f4e09fcf5"]},{"cluster_id":"b25f50a2-6e79-4624-b63a-fcc433c2ee8b","members":["045f7b0d-d4a4-4285-9a62-8dabd3dae61c"]},{"cluster_id":"f2b7ea2e-02cf-4061-b076-60c350522e8d","members":["d8ac564c-5a0f-499d-86a5-8f9917a9bfb8","ec463ac8-abae-4db1-81f0-eada054532f4","2d9d5a49-133f-4abc-9974-c9e6da8ea584"]},{"cluster_id":"57d96007-f80d-4110-8583-3e280492b584","members":["2157720a-b31f-4765-9e5f-abe16965d54a","82f84f21-f75a-48ff-ae8a-b54bdf66ef25","aebfeb31-a7cc-40f5-85e1-ab17a9a81027","5e7bee19-fa7d-4e24-b0f3-a535a59d61c9","bf2df80d-2a61-4e41-a0d7-dc5f45bf0de5","cc9da660-3aa5-478b-a33f-f2375ea97c0d","7f00fee7-1728-4445-912d-7de5fff1b210","8cb31e1c-ec7e-45e0-9991-a1721f0650c9","2911afdc-2774-462b-bd60-f60cf44428a5","3daaf72f-9ed4-4402-bbfa-caa34aea8145","5bfee9de-e52b-47bc-9df0-6f7f5bcf7057","23af19b4-6fa3-4db4-aed8-de51c0424a7d"]},{"cluster_id":"33ed63b5-316c-47cd-80fa-2cb71259f8eb","members":["c63f59c1-d72b-41e4-a08e-84a2f41ddfe5"]},{"cluster_id":"b41760af-aaf8-4d45-b87f-633ebbf009f9","members":["3c1df8b6-9533-4c62-a317-a807afa5c317"]},{"cluster_id":"425c03b2-a548-4c2e-a981-8c6f7789018e","members":["b80a6589-2541-416c-a08b-60e2d631e5e3"]},{"cluster_id":"e13e1cb5-f52c-406f-a55a-701cb19f5226","members":["66670a2a-cbbd-44a6-82ca-4421126b801f"]},{"cluster_id":"08d02125-b1b5-40ee-8104-05de8b37f965","members":["90b7bf11-a8f9-4fa2-98e3-a4dc0f9f14e9"]},{"cluster_id":"8979de81-d14e-4323-ad09-17f46a1f718d","members":["b02e365e-b224-47a8-a9f6-af76ca7fc5de"]},{"cluster_id":"2fd99adc-b7aa-49ec-b4ae-d4607788e329","members":["b30d79c6-5159-4996-b79a-7752d1373f4f"]},{"cluster_id":"0b109e58-1cde-4c32-aed4-12ba82ed273a","members":["8f1395d8-01e0-4fab-89cd-d4455bc695bf","53e5fac3-f3b9-4170-acb1-fa39f2caaa62","b57e910d-73c4-4c97-91e3-7dd5f2fb6804","fca78f43-297e-48a9-989c-20b2fe4e6e7e"]},{"cluster_id":"f5bdb13c-8dca-44f0-8aa1-f75785f668e5","members":["c69fc9cd-d7d3-40ed-9c06-f6d6ec253b4d"]},{"cluster_id":"7a48cda2-7a7d-48c6-9ef2-e5b111d87d7c","members":["298d23b5-afbb-4e93-8cac-5e76326f04b6"]},{"cluster_id":"ab04829a-0137-4a23-b438-5c3602157062","members":["8b5a5f1a-b189-4ee1-a515-8f9cfff8233f"]},{"cluster_id":"54d73329-0451-4bab-a86d-4ce16b809e91","members":["1bb5060b-06f9-4023-b08d-f341eb37296f"]},{"cluster_id":"0c6f8f11-1c81-417d-bf01-df519f70e0fa","members":["7e545939-4ee8-40a2-9ae5-81e97f25288f","c7e229b8-8c07-4814-a24f-77bed644174e"]},{"cluster_id":"f24d06ae-13b1-4550-a06c-444a9041ab60","members":["eb0c521c-32dd-465b-9fe0-cf36781f6670","8aa157bf-ab31-4e25-b3ed-663d0cba705e"]},{"cluster_id":"20dbcfed-6463-4ba7-98e9-93b565b2719b","members":["a7d10e01-e281-4f96-a0fa-8dadd3bed992","b1753787-75a4-4d77-980e-1cdd9b70c499"]},{"cluster_id":"0947f9bf-7d2a-4b27-95a6-09e765742c84","members":["1c3ecb4f-819d-4245-a521-b26ef8088f65"]},{"cluster_id":"0af6351b-04c5-4f0a-8360-02d15acb3d1c","members":["56776a04-155a-40b6-a503-9bea56d3cf42"]},{"cluster_id":"60cef9d1-8d47-44f3-9820-0cdbe57600fb","members":["538f9251-4ba8-4d69-b12f-d9bcb8131631"]},{"cluster_id":"49bf0c40-75dc-453d-aa4a-9a6c01b9dda1","members":["03d8bffd-1eb9-4588-8236-62839cb3cb49"]},{"cluster_id":"9d38e0bf-2876-4c73-84e8-54044be3ef3d","members":["aaf575f9-f8ae-402f-9662-f4eb4217d6ee"]},{"cluster_id":"6f48a68c-7726-4316-a5e6-f406ee7e1e95","members":["f1abfe62-d77e-4798-bf5e-a3939e34fdf1"]},{"cluster_id":"f44c0680-07c7-4ea0-8054-7643f1b8eafd","members":["7598cb80-2cc0-4862-a471-68163a62bb1f","e227fb02-66b2-46f4-8ff0-3ba31e2db4da","cecdd572-0e9c-408c-a648-d24aebebc4a5"]},{"cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124","members":["4296771e-b956-4ba7-8671-013491e18853","4f074f04-ff3f-4ca6-9b9f-456a41c79af3","c3b4ae9e-b56b-4724-80ab-d5e8fd58f441","7c0734d6-bcfb-43f1-85bd-4153220ebf66","7dd0ca0a-15bf-40aa-9e2e-e18040f7de76","3280a9e5-4f53-42df-97d6-80dfad2b3a63"]},{"cluster_id":"54ebfb05-46bf-4d56-ade3-1d656b85cfb2","members":["871e41ff-6e5a-4f51-928d-541f50c7ff7f"]},{"cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c","members":["65983e1e-7638-476f-8f5a-1fd47c0c31f7","d44634d9-fe38-4821-82b8-1de3a6e41525","a5930607-f04e-48b2-b3e8-851792a5f598","a19c2453-fafa-48af-ac55-4b1a5f1a3abb","c42c06b6-0c72-404c-b1e1-a6ea887ab989"]},{"cluster_id":"5f698021-f0a7-4748-8344-6112bbe0b66e","members":["db00dd7f-a5ca-45af-87c3-d65662ede0a0"]},{"cluster_id":"a71276bb-c498-4f7f-840a-9e20eea63e3d","members":["cfa4b03e-f0df-4958-baeb-631c2383e698"]},{"cluster_id":"d1f35128-46aa-4b3e-8942-ed03c647bdc7","members":["d416ff45-9044-4499-bd89-65cfc821de7e","cfefb447-4f9b-46cc-b663-96d20f429d34","2ff61d65-2058-42e1-806a-8af448124f72"]},{"cluster_id":"9d8ee527-fdd4-4b2b-bd2c-0ad4ce6caf15","members":["ea68acd3-5234-4bf1-90b6-a175d94d0636"]},{"cluster_id":"eafeed04-4e89-4efc-a2ef-31ce78091f99","members":["04b78e68-7272-4b89-a850-e0751f938c15"]},{"cluster_id":"5afcd855-48b3-4e16-bfa6-1ae369574bba","members":["86b443f9-597c-4943-aa25-1e4de477c1d8"]},{"cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed","members":["a58b9b09-ff37-4144-b39c-50af1b458f87","b2c6dfe5-3e31-4b12-9fe6-1c1b13e8ba63","5a9a532b-3469-4108-a503-a8dee755d225","1f4fadc4-9fc6-4b18-b2df-9e047f2a73a0","1b3983ea-9696-44d9-aa99-cf3a210e7702","feb14c4e-cb39-4bfd-a31d-85ca5fbf9507","17c3c702-8396-4f43-ab42-57b0cf289a97","e1d1489b-8379-4150-be47-22d283933756","e8a190db-bcc2-4cc0-8eb7-44c244f670d8","877e3f58-d245-4528-8d53-9ba2a6a0f325","1c5866c2-1adf-4b31-a7e0-d2983c3c0093","73fa5f57-e48d-4a11-a85f-c6d43d487450","a8656049-fc1b-42f8-a23c-d74e20da9f6f","8cbfae15-d083-4bb6-b577-bef32055b97c"]},{"cluster_id":"a11d2091-08fe-4a3c-ae90-66e1118f2ac4","members":["98d47805-4cd7-4731-8c6b-fef8bc38b147"]},{"cluster_id":"fc5c504b-230e-408e-a170-afd09cbd04d4","members":["7f893751-008b-436b-bfd8-1ab6e0dd153a"]},{"cluster_id":"b7c9de19-8b29-40c8-92af-4119566c8604","members":["5744aada-6d04-4c83-b188-e9ab637f2c37"]},{"cluster_id":"4ecf3311-91d6-4f18-a13a-b2646404483d","members":["712ba18f-602d-464e-a145-9155d6ab150d"]},{"cluster_id":"138a4a3b-db1f-4c6f-b320-65bc4e554e6f","members":["b9def34b-f479-47c6-bfbd-c090b718f4cc"]},{"cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc","members":["8af7630a-888f-429b-8d22-a888b3422656","f218e618-b7a6-435a-9b95-d4d9450acaa2","0f127d4d-6f8f-4773-a3e2-fa45c536924c","9880c14a-51e5-458d-a588-7777014cd037","2282d388-5b26-4bde-89a8-b928c9b17599"]},{"cluster_id":"77e0e128-878a-417f-8723-91873f114032","members":["1d06b6ad-1c83-4e67-ad6e-27c1f6201f6a"]},{"cluster_id":"d415aa76-63ab-4b87-94b6-7d753e952a6a","members":["4e2bfcc6-057a-45c2-bc22-5f22eb478b96"]},{"cluster_id":"dd4670c3-7e44-4c76-a7d9-373ad6cb6c50","members":["1dd98959-def5-4e70-aaed-6ffb79b0a02c","65f32e56-cec4-40c8-a0d4-a1b7f6d34a3f"]},{"cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c","members":["0d979bf2-cdbb-4ec7-bf27-6837e71f1b0f","16158f34-8015-44f8-a7dc-0e8a0536b905","a6b9ab6f-d230-4c51-9ca7-4e9937d5f5f6","72c161a4-0fe8-4234-98fd-234cda651549","40301d4d-b88e-43bc-b381-d74e42463371","0a4165e4-da8d-4eda-b1fd-dd6020c834e2","74f394ba-ef3f-4ccd-8648-fc87425f5bc4"]},{"cluster_id":"75c3bddb-8c4a-4274-ab4c-3cc28aeb2126","members":["05c2fb4c-ae68-4663-861c-bbe293f5090b"]},{"cluster_id":"9164197b-fffd-43a5-9a7a-407af1a26959","members":["01e3cd24-74cd-4d13-8d26-bc216d1beebe"]},{"cluster_id":"4c6cef5a-0fb7-4222-87ca-9b217e095be3","members":["5dd8dff5-0130-4958-a9a7-9187ecb8464a"]},{"cluster_id":"f5bf5358-6837-4934-ac62-9ad98735b162","members":["d22b2d07-e729-43c3-bd3d-ae9c221521cf"]},{"cluster_id":"0795fae9-e716-4cba-98f8-5f27537dcd6b","members":["a915f3d1-92f2-4b83-9953-3e6ca65ded90"]},{"cluster_id":"28e348f7-86c8-4ff9-8b99-eb8b6c73b1bf","members":["c59ccbdb-f1d2-47c7-9ec4-47d9f9c56636"]},{"cluster_id":"21ef96d9-9c60-4110-9606-ce33a7d0a4f1","members":["ff0e2e4e-984a-4fef-b122-7b4aa3b38962"]},{"cluster_id":"1f6ddbe7-8535-46e4-9237-74c4562367e1","members":["5b4e9f1d-68d8-4d32-a100-156509555dbd"]},{"cluster_id":"0a7440da-026d-4b9e-86ae-aae908cc485e","members":["a805862a-118b-4af7-b9e4-4d70194d8057"]},{"cluster_id":"7cf8a49b-ec7b-4a56-af2a-3a198e9863e9","members":["720d0741-1485-4c41-9b9e-03674f20e31a","5ea46f6e-52b9-48b1-924d-c42581ba2e4f"]},{"cluster_id":"e4d59809-92d5-4450-8181-b93bc5f5d348","members":["959df3ef-c111-4c09-9a7b-5c51b969ad13"]},{"cluster_id":"7cd46da8-e046-45f9-87aa-b04395bcb25f","members":["8efe4067-cedc-49e6-beb8-83092672d3a5","9d62ef5b-8cd6-418c-81fd-f90b01232f69"]},{"cluster_id":"890e1bc7-85dc-4ae9-985a-8f81d088f89a","members":["bf90eb67-8da3-407c-899e-c20dcbec088e"]},{"cluster_id":"4cbf95dd-29fa-442e-b9e9-93eb4878a93e","members":["3c765d9f-0405-4c43-bf03-a83048ccf162"]},{"cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993","members":["88f9850f-41c4-4378-88a7-5102e569094f","5a6d25c0-72b5-47d0-9a25-00a946e8ebce","a2076eeb-7774-4162-8451-feb0f732fdba","2824213e-2808-437e-bcd0-947ff4adac18","7f37f4d7-bc29-424f-a2f8-a29fb67a93a4","78b444af-b57d-412a-8a93-e25c216c3f78","2f6e9d10-fec3-4bbe-9247-78c04ce554c5","b55fb582-2646-4c5e-9bdf-fafa3084e7f7"]},{"cluster_id":"e56fc955-148f-4ab7-9982-126189917297","members":["050ddb9e-c254-478d-8ffe-f8fdeabb33a5","867498bb-0930-48be-8ea7-2ed4335eaca6"]},{"cluster_id":"44663aba-7a2e-4439-ac72-295c1b77f6ca","members":["ec25c265-a8a3-44b8-9f5d-b63f1c3b884f"]},{"cluster_id":"e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107","members":["b7330117-f843-4dd9-ad4b-b81e578ca1d2","1f2bc923-735d-43cb-b434-90a5ade6316e"]},{"cluster_id":"60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548","members":["c068ace4-0df2-40f5-afeb-0ee9d0d4a8a3","4a1100bd-0d21-4a8e-a3be-dc65ae4acb3d","856f5595-5f44-4c10-b3c7-71b79aeaf5c7"]},{"cluster_id":"964aba3e-f62e-4ef6-b8f3-99237adf29ba","members":["852671f2-72e2-4c38-bbb7-7af113f7aaaf","3d1e5490-2d11-4983-a889-245fb01aab25"]},{"cluster_id":"3ef30c78-2900-4b45-bca9-f6701289533c","members":["3c9b6f82-65dc-45c5-a727-981f257afc22"]},{"cluster_id":"e72c5c13-765f-4dae-aecd-48d78cd16ece","members":["e4787dfa-2075-49af-8f60-4b153d6860f5","76ed06f1-f37a-465b-ae48-e100e8377a44"]},{"cluster_id":"d21b19ea-6813-4e8b-8df5-e67ed7dfc0f9","members":["161d37ba-03e3-4b00-a4ff-9688a7a5c6b1"]},{"cluster_id":"21916347-9bda-4844-a220-12a3c8d5bdd0","members":["99aacb30-8d04-4f24-ae70-df3b276e8586"]},{"cluster_id":"6c41a4c1-08f4-483e-b095-97806b1140bf","members":["5730ba58-c479-44ef-8060-17afa3bd67ca"]},{"cluster_id":"1337f10e-c559-4983-82e2-596f69e5c47a","members":["2107b5eb-6e43-490d-b9a3-b973d2ecd63f"]},{"cluster_id":"230aa320-84d5-49f6-9755-fd2e7a1037ab","members":["aa8a5f4e-1d86-4f50-b032-f1a9eb3fd837"]},{"cluster_id":"a362e63a-9f1e-4605-b063-7172229b335a","members":["46cfca21-6e5d-4cfe-8b41-0e72b801599e"]},{"cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970","members":["e7cba723-5ce7-41e0-9efe-ad11553b3672","8653b865-d36c-4dbc-b92c-f6d7d328d961","abe79f6a-6008-4d68-8b84-c8dd5a00e893","f1e6c65f-d792-4cb8-9f39-7aafac76aea6","e16f10a8-1336-4abc-8110-4dc43103f841","eb7ccb5b-2c32-4340-b596-3de38645f97f"]},{"cluster_id":"a7539db4-dfef-469c-b96d-9b13762fd242","members":["4de3e13e-8ea4-4d67-b5e3-4e4bfe4a3617"]},{"cluster_id":"5e115001-bb2f-45b1-be83-78b8766bff77","members":["91c788f9-e420-4e6d-b7aa-f07ca5a1a9fe"]},{"cluster_id":"ae87ce9d-8fb9-4394-9afe-202f1ec14722","members":["cda6e5ef-b9ea-4f23-89c9-4b8a87e4fa7b","0c59c578-172e-4be5-b4ab-8cb8b1bee19b","7f53f839-1dd0-4b87-a92f-8d56914df42d"]},{"cluster_id":"8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35","members":["b803b996-630b-4f05-b3b6-339f78b7c70f","88bcba6f-3141-4a39-87f2-94e0f38fa00a","81465d6c-17c2-4277-a0cb-89b8c3188ee1"]},{"cluster_id":"4c2902bb-5892-4765-99b2-69db31b95136","members":["eb69e2dd-44a4-48ed-a7c3-f4d6ab56fff7"]},{"cluster_id":"93fb31b6-e8df-4e78-9be7-574ea4c2f86b","members":["dda020cb-61b1-45bb-9d7d-677b7eda4255"]},{"cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4","members":["9606da73-a8c6-4443-a79c-78836db4e4f1","ac0bbf2a-9912-4968-bfc5-af50067156d3","51c347f2-e521-4dcb-ac82-57eae349c8e0","43a97283-6531-4832-a402-4714ce15cac8","59355c20-922b-44e1-b999-e928553d0cd8","fa532d5e-b78d-4fda-84c6-75f04dc47f1a","4f1874ce-1d5b-4a37-93b6-1081e371c585","ad66ce12-8b29-4147-87b8-a08b32f20c00","e5f0ac30-4bfe-4c41-80d1-ce405df9e260","6ead3dde-bdab-43c9-b276-6f067caec9ef","cc89de56-27d3-450f-8f22-dc03a546f2b7","086e3440-20ae-47d7-8188-96798400bd40","136883a7-9c80-4cdf-9acc-9cb220febd7f","85042650-cdcd-42cf-a92b-e576ab04ba3c","011a22da-0d5b-4885-a0b2-5f5f1cabb1f1","1dd0b4ec-abd6-45d0-b7e9-4fa8a28c3461"]},{"cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125","members":["36f5302a-e74a-46d1-b5b0-8f4c1e418fef","e1934800-b8b0-4559-889b-9c4513fb2b1b","e1320b17-bca5-4b94-b771-f5701e3c47a3","22c5464d-e954-45ee-870b-a2acd92f8c45"]},{"cluster_id":"2420d848-9bcf-484f-a278-33ad97459cda","members":["84317b32-9768-4166-ad55-4761a28d3ac8"]},{"cluster_id":"f4412fc5-966c-440c-829a-8ca0977913f0","members":["ed4ab4de-aac3-4757-add7-949e781db1b6","e9d4c9ca-1b2f-418e-89f2-0bd5a5ab3b60"]},{"cluster_id":"4e973d36-02eb-4b5c-bc20-63b35994dd87","members":["6dcc87dc-d2e1-4f7b-8285-ffd533b53b9b"]},{"cluster_id":"ff3c71b1-9872-4a9b-a091-8300e856f9b9","members":["2331d7d0-913d-4b46-8447-0f81b55cb1f0"]},{"cluster_id":"e2b19af5-6b63-47c0-a565-18520484a0a6","members":["4f1f0c64-1799-4bf9-a967-85e669866f8b"]},{"cluster_id":"27494d31-7904-40f7-8554-6f6c04a0e92b","members":["0707cb89-2884-4686-83c6-9d85575d164d"]},{"cluster_id":"9bfc8129-531e-4c98-b3c5-a6aa21e4674c","members":["977f9386-b21f-4059-92ba-0bcdf2e251f0"]},{"cluster_id":"89a9391f-b100-4030-bab0-22344532ac00","members":["d374c1c5-661e-4f36-a173-c02bb705d5c0"]},{"cluster_id":"74a8058f-9617-4020-8db9-456c0bc2deb9","members":["5879a899-c44a-4513-96d8-68524214fee4"]},{"cluster_id":"c1c6d1f6-6fc4-4a8f-bdca-cd82345bf948","members":["2c94f3c8-2366-48cc-bc7b-7cf118c80621"]},{"cluster_id":"b3a5dd46-4aa3-4884-9a77-ee986170d8d0","members":["5989c451-dfe0-430a-8257-bd4f4d152603"]},{"cluster_id":"100607e4-097e-42a6-9233-9486abc1cf03","members":["fde9903f-3e01-4d9e-88b2-b36a0e29f568"]},{"cluster_id":"dbfd0383-d4d3-4b5c-a820-54e5dc7d2adb","members":["74d79c55-b2dd-48dd-92c8-b4f3e8b9c05a"]},{"cluster_id":"660ce2a3-2e3d-4961-a97c-865ff4c461f6","members":["12c64edc-5bb0-43cd-803b-893bccf7130c"]},{"cluster_id":"03329c55-b9c0-4585-b5b1-817ec3b57899","members":["ddb12108-4ee7-4b41-9f71-e5f2ce89bd21"]},{"cluster_id":"edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c","members":["930d0ea6-3c45-418d-88d6-0511cd01d88e"]},{"cluster_id":"3f77000e-b7d1-457b-963f-2743a0bda688","members":["3892ead7-6fb3-4fbb-9d2c-4f5ba492af26","7a90859f-3959-4ce6-aac2-3e8c49a44d33","43bd3e11-7f49-4856-aa33-d1602ac373d9","e401473b-9e1d-4fef-bad6-dcf3195d6dd1"]},{"cluster_id":"f43f98cd-cb16-421c-a639-6c526509bfd7","members":["971bef39-e25e-447b-8a04-28c6ac8f9b3a","76f98aa0-ea7d-4a0b-93c5-9ce285cc19d0"]},{"cluster_id":"6b8874c6-0560-4ffd-876b-6651821a5f10","members":["5a46004d-e039-45ce-8424-3b5024c29c72"]},{"cluster_id":"7d3ca315-e2f1-442e-aa07-daf647abc039","members":["afe319fe-497d-4014-a28f-2ef0370ca5b1"]},{"cluster_id":"ef1b2d86-739d-4342-9581-88b77e5ebe93","members":["ff78363e-86bf-44d1-80b4-366fb6fcd5a3"]},{"cluster_id":"6f7f68fd-a840-40e2-a600-b19e0677f9c8","members":["ac1c347b-0422-4190-a91e-f118e3304387","49257e18-1694-46bd-8535-894c014ad982","84fe09cc-6641-4679-bf5d-a74ccb29a966","61fdaa4e-3c09-452e-a4aa-012df78ccdcc"]},{"cluster_id":"0656118b-9248-4fe1-a608-3abb014d1738","members":["8e22e8ab-95be-4a04-a8e8-56168661ba94"]},{"cluster_id":"ebf6d20f-e452-48e5-b5e3-66d4779751ef","members":["7c82ab5c-af1e-4524-918a-44d55dc03f4b"]},{"cluster_id":"5ec58447-e517-44c1-9394-8a5cf3cacde6","members":["f9982ced-7bf9-4aee-9566-6707fe08a315"]},{"cluster_id":"30a748c7-0edb-4c1b-9472-d1b4ca3f8032","members":["312815af-6e45-44c2-92d5-7498545d87c1"]},{"cluster_id":"6bf71f87-f205-4f8b-8249-8d960a41d7cc","members":["e4e75d3d-b6ca-4f6c-ae92-d8f6f3b8c92f"]},{"cluster_id":"a29f6f46-43ef-4252-a308-d9b452074037","members":["ff23b9e8-7e77-4ecc-bd42-56730cdc555c"]},{"cluster_id":"8191e288-4dd0-423e-bf77-953449ad8b80","members":["9c5bc019-b51b-429a-a892-504dbad1e62a"]},{"cluster_id":"bc29966a-d588-4e80-8feb-dd96bcffea23","members":["ab2ad3a9-afec-43d7-ba87-b35694ddb345"]},{"cluster_id":"16a78e87-1a7e-47fe-92e8-e8466b7bd20f","members":["370c7df3-223f-419c-81d1-734d1f0f1617"]},{"cluster_id":"8451ff8b-752e-4535-872c-ebc9efc7b9cd","members":["e5aaa05a-c658-49d0-9c32-d5ee0631d853"]},{"cluster_id":"35b669fa-cc15-4619-8262-2bd41f0ca610","members":["d9eafee5-2dab-4b8c-8840-234fecaf5047"]},{"cluster_id":"c849043f-d317-458e-b56e-651b8d73a135","members":["30b3ee18-387c-41b6-8f4c-a6b8e2b1a1fb"]},{"cluster_id":"45ef4556-631b-4297-8b2a-7cad68f3b517","members":["0f9b8ca1-b9e6-456e-b2cd-23b2bbda9fae"]},{"cluster_id":"32363fbb-b809-46d2-baba-aad9f54a7b98","members":["cd0a2e04-a1f5-4dd0-b90f-1e9dc59bf122"]},{"cluster_id":"dfe9b2aa-c1a4-44e1-97cf-0e0d2107befb","members":["e5f55024-d61f-4b4c-9bd6-c3bc739ba47d"]},{"cluster_id":"5ad7a663-479d-4397-bbe4-c19607b95013","members":["0fd0ca94-0033-4c14-8ca8-780602fd419e"]},{"cluster_id":"758c5e50-7f9a-4e26-9df7-02c7b0095788","members":["c7011f87-dfe4-405c-b47d-314e80fe1c8e"]},{"cluster_id":"46233164-6ed4-4e93-aaed-ca823711dcc5","members":["cb952111-bc62-4180-901e-11bb11e441e0"]},{"cluster_id":"36c07d65-523d-4b69-bf8b-7f1ec91d6954","members":["9dbdef61-bce6-476e-a310-53f87bb39f66"]},{"cluster_id":"82c4576a-a59c-436d-bb23-2d15a1d9c903","members":["81c07683-95ea-46f6-90e9-fdc32370f511"]},{"cluster_id":"265b7995-86ea-4269-bc72-cf439682655b","members":["e8f4d764-94e2-4c4a-b2b9-5356bdd53802"]},{"cluster_id":"27cb0d3d-03d0-4c0b-8af4-dae39953059e","members":["ffd9187e-8061-4751-8bd5-480198de9d08","f3e080a5-bdfc-4b11-aba5-8a1d672670be"]},{"cluster_id":"50cf17ff-24f7-4dfd-958b-756aec4fd4e0","members":["0cf24c17-1136-4554-8780-9a4ab07761a4"]},{"cluster_id":"f21f5e02-c7d3-439c-a7ce-450375c434a9","members":["6fc52d41-dc73-4780-b40d-2bc668e88f4a"]},{"cluster_id":"4d323d7a-dea3-4fd2-9928-7ad3b9eb62fb","members":["3e978252-371b-41d2-8241-2e77a77b7ccd"]},{"cluster_id":"820ef425-062e-4d05-87b0-a9e96fa7de31","members":["4f58034e-b5aa-4e77-a186-703865813663"]},{"cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc","members":["1b09beb4-96ed-4fb4-b461-3ad2dc8ee74c","e694a73b-cb53-4c33-9b40-f3f3dfcb771f","8f5c4c1d-7b1a-4349-94b7-5266cd637e54","ed2bf98c-6e1f-4d37-a55e-fdd5b175f958","a364ab95-d103-44fe-9640-939150b981a0","c44bb25c-c233-41fe-83da-332ae4cdc1f7","4353f89a-0b97-4c7c-bad8-576dbaac73df","f37a2456-cdc3-4b07-84d5-790cc7626871","f3500725-a4ae-4a93-9216-9c911a39872f"]},{"cluster_id":"f7b7014d-ad07-4661-9448-28c218c2eea5","members":["b2363639-5d44-418d-9673-4c7e709d3369"]},{"cluster_id":"58559460-f665-4bbd-8f9e-95791e57f99a","members":["f0ef8168-b5db-4007-9161-282e7132d6ef"]},{"cluster_id":"f50c160a-60a4-4be2-9f62-bc773e7ba48f","members":["0339315d-50ab-4e68-b9ac-4892ae9ff23b"]},{"cluster_id":"e8195223-1d62-4704-93af-859b0cc35da8","members":["20530a04-956c-471e-a28a-f5f92470b5f8"]},{"cluster_id":"57ce37d8-222f-4e0d-8fd8-04ee1ade37d4","members":["51a4924c-6fd8-4a57-81f7-141044a51459"]},{"cluster_id":"45be894d-986a-43be-b81b-3a8308fba0de","members":["9c4c19b1-1821-4f4f-b004-963fa07a0f1c"]},{"cluster_id":"72a5de9f-6386-4a16-880d-e374cb327abe","members":["30306750-7682-4b1c-9f3e-c1f7f931fb12"]},{"cluster_id":"4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568","members":["bf60c867-f02b-4e06-b2c1-b53995c2ccd9","3e9a99da-f898-444b-a509-71165ab12c8a"]},{"cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc","members":["853ec022-2633-424e-8070-53f10b976cd3","e22f7c32-c0cc-4765-b07e-35e06535254b","fa789686-f4ff-4769-afea-b7a090848d27","9e56dab0-5cf4-45b0-ad60-275fc36209c8","88bae962-c00b-49f9-b6d0-289953165ae8"]},{"cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87","members":["acdb7680-494f-4145-a91e-cd4d9b5e56d1","82532113-a968-4ea0-adb1-2e87cd0207dc","31c3b00e-f900-4850-9e73-0223030754b4","eea65218-f61a-4b52-b873-6be6bacaa67d","15bad102-22bf-4306-9360-1f3c0adbfff3","79db8dc4-4182-4930-a458-c1f0ecb32cd0","e66d9fdb-3abd-4db8-96cc-31025be32b36","7243f16f-cb06-42c4-abfa-ac76b287a6bf","3effb45f-db2f-4404-8107-91ae40cfa171"]},{"cluster_id":"c0ac6691-abf2-4873-a338-41a4997bcb24","members":["d584c3ea-5cb9-45d8-8efd-c3e473f0ccca","c6852aab-9969-47b4-b03d-a5a8020adfe1","e108f330-7ee6-4e7b-9705-ed42439e9dc7"]},{"cluster_id":"2a0edc6f-16ff-496d-b79c-24bffd830324","members":["16ca3990-e457-4039-8559-8ecff8153cd8"]},{"cluster_id":"1caeaded-5769-4cdd-b16d-b85f9a51e31c","members":["3558e28f-0f72-48b9-8286-981151d2baa1"]},{"cluster_id":"78aa3214-a8d5-4987-ad02-0d4cd5db66f9","members":["22e6e242-2014-4f49-b17e-405825cad96f"]},{"cluster_id":"7707109b-cc58-416a-9a9e-b9207b14baa6","members":["63ad495e-5acf-452f-8a88-e7061b051a88"]},{"cluster_id":"cc7c4fde-e26b-4dc1-acbf-81128ce5d657","members":["79deae72-5646-4192-a308-236ab1bef5fc"]},{"cluster_id":"1f7a4f93-ef7c-471e-9da0-10305825de04","members":["0305a8d5-e7b2-4fdd-bcd7-b0f71ec3ae48"]},{"cluster_id":"30b7ce37-8fca-4fe2-b499-bda00e36d905","members":["b7315bb3-0703-4c94-a09b-a1e2db430679","cc36a9db-6077-4ec9-adbe-c04f3ba9a177"]},{"cluster_id":"664cfcc2-edf1-43a6-a432-be97b535188e","members":["61b2cd92-abf7-4dcf-bc51-7644c0a54e5f"]},{"cluster_id":"083a8283-1aa3-4b94-9026-bbd5c3a07cbe","members":["e12ee799-3d50-4af8-a791-1c4bb686de2b","ad594a92-20eb-4c2a-a4ca-27bfaca1bb08"]},{"cluster_id":"a4dde064-8077-4a0c-97de-40075984b4cc","members":["d06a4c29-bb90-487d-98ff-88029fa06e0e"]},{"cluster_id":"fffc483f-c841-4109-b9e1-d2ab5730fe2b","members":["66ccfe61-ae20-4550-b79d-81b156c8a6cb","4d9423eb-b550-4953-a068-8ba49767718d"]},{"cluster_id":"b4673d7c-55f8-410a-a73b-4f4fccae0549","members":["8bb1e2ba-a0bb-40a4-940b-848d74f29241"]},{"cluster_id":"75e6960d-da7a-4d2f-8605-a94c9d2036f7","members":["85e3bb14-8ba3-4be5-bd50-f38e37acef59"]},{"cluster_id":"1847bb18-db3f-4048-bbaa-0206cb032b77","members":["ed0cb860-80c7-4566-a16a-1b0c0d31aa0b"]},{"cluster_id":"a74b8cc1-b628-4659-9793-8906816c7cde","members":["4813077d-e615-4b27-9b5b-b355712216fd"]},{"cluster_id":"655ccaf5-6cf6-444d-a7a8-cb79a1480f69","members":["e12a081c-41ee-4ea4-9677-a64baf83b41b"]},{"cluster_id":"70431f34-7e7b-4551-b35b-94e41cfb3c9a","members":["d76b65d4-41fc-4c3f-9acb-79c698179c29"]},{"cluster_id":"7ce5da07-bfd4-4121-8e0d-acd582b0b4a4","members":["ca1e6bab-694c-481b-842c-66218837103e"]},{"cluster_id":"9efa7058-0848-446b-a53c-deef9f0ad8fe","members":["44dab769-9a0b-477d-9ec2-b8feea0fb346"]},{"cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef","members":["e3c62d58-3418-453a-b65c-853a482b6baf","5a270b86-3ac0-429a-8fff-2627bc79785d","72235e9f-d176-482b-963f-03bb21b928c3","6c831974-50b7-4289-8441-92a6a7f94885","afd7c698-e8d7-4547-9818-018bf39b410b","886af67b-0325-41c9-9ed1-e0a1d01c8050","98818f07-7366-4038-8c67-126e16ada268","950d7990-be2c-4d4d-b8cd-183b3456afd1","31614f66-df4b-4087-9b57-e5c04c5b8624","a0867cc2-91c4-4201-923c-2d77c2076461","cbce4f11-1d44-4416-a418-76bdd1b80270"]},{"cluster_id":"c7bef51e-9aa9-4b77-85bc-5a1620f4b37e","members":["ba9d833c-6b5f-4977-907a-cd46f755300e"]},{"cluster_id":"4f2d75d0-04f7-4815-a71c-1d8be3e7aa00","members":["f89e6ea3-65e3-4ff1-ba9b-2d25e57b0933"]},{"cluster_id":"f10864eb-56bf-40a9-9f67-5dfe4ef70806","members":["2b26efa6-583b-41fc-88f0-91b856a9b861","f5041c7d-5ced-42ef-b16b-265fff9faf50"]},{"cluster_id":"745dc0ba-2e08-4d11-9168-0c12ad0b99a5","members":["f0db666b-0fd3-4f77-b06f-89c030b25d5c"]},{"cluster_id":"0be4cdd7-0577-44ad-9263-d020c0d38b8c","members":["5e8d37c6-8703-44ad-b67d-f727f80c34d8"]},{"cluster_id":"3b56c579-39c7-4dab-b918-56f22f3eec67","members":["6e4c5301-e3c3-4f6b-909d-23ea2b1309ac"]},{"cluster_id":"05ef45a3-5005-462b-9419-1640ee24156a","members":["48a764fe-1d3f-4265-b2da-69a49b1d5369"]},{"cluster_id":"003a7d07-44de-4091-ae03-27e916ffcfa5","members":["2c23f5f5-1fe8-4718-a592-39593387b290"]},{"cluster_id":"c56b515a-2e70-4a48-b4c2-0cbda45aaedc","members":["d4643a72-fa01-41a9-9cbf-99356de06c6b"]},{"cluster_id":"889e78e7-a427-42ef-b24d-0164df4f19bf","members":["a8863203-2f29-4df9-ae56-f28b95478ed0"]},{"cluster_id":"fef7b3de-7af1-40a4-a0ec-544cb6b0b0ff","members":["165d15d9-4ec9-4579-9519-a7e05f6304ee"]},{"cluster_id":"e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93","members":["3c719cdb-5047-46b4-a1d7-f8e44a60535b","a386b6c1-9b1f-4ced-979d-9ae27b682204"]},{"cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee","members":["c7afcae4-708e-49d8-8fd0-4dca5da09912","6917898b-b050-4e24-b57f-67feaf1c1afe","82382772-6dd8-4efc-ba22-7470418a4a77","d77a013e-9d44-4c1a-932a-64582226c64c","a835d36b-961c-4b8c-85bd-753a59738e3d","9c8c09c1-4d07-42bb-9c2b-213321540a92","ad2b7363-fc21-4dba-afa1-17fa408f20e2","02d9bad7-3aef-4517-b713-67abd5cafc2d","7f21b2c9-2821-4403-ac30-03ac46bc7bbb"]},{"cluster_id":"8be17819-9c73-4351-af94-f5573c4b0d17","members":["0dbce223-9c3e-4379-a0d6-719aff826410"]},{"cluster_id":"337fae10-d08a-4844-b763-fc332cdde523","members":["ed8db066-3572-46a8-98ff-01ad76662339"]},{"cluster_id":"fe0af648-ca07-4de6-9db2-4c1067118254","members":["cd24668d-5a2d-4d25-9e4f-161f11611d13"]},{"cluster_id":"54567e29-4033-493e-869f-078ef9153910","members":["5986747e-02d6-4ce7-aab0-db589195fba5","563ca22b-cb1b-4ac2-8562-688154bbb566"]},{"cluster_id":"3bf8d65a-8c84-4411-baf2-c3a55c8118b8","members":["3295240f-72b7-4247-9609-5e8312beadf4"]},{"cluster_id":"8a30c746-b21f-4f8b-b1ab-389110f61293","members":["3698a301-7a64-46ef-9f95-c34dc5ed8181"]},{"cluster_id":"f6b81252-d691-43eb-b603-bbd2ec2ea3c1","members":["18f82ef6-d088-4ea4-a1d8-2c2e76ae3a8c","1a9a2509-178b-45b9-90b3-58c0c9cc178a"]},{"cluster_id":"aeb7fb87-5c7f-4917-b661-3fe948376ad9","members":["129c65e8-0dfc-4fe2-92cd-7ba8bdd6b0ca"]},{"cluster_id":"1bb2fbd1-906a-4d81-b23d-f6c0a4024661","members":["c5b2e942-0a09-4814-b808-5dcefeb3d5ee","7fffa540-df86-4301-9664-fe0107c83f3a"]},{"cluster_id":"61608de3-ac5a-4b10-bba7-1b5580f57caa","members":["a87bdeee-b360-4bb2-8cc6-3965afae1f9f"]},{"cluster_id":"c95d237e-c855-46b9-95fd-6b8f66d537c6","members":["370b35db-401a-4dde-b9d8-be033b45ead1"]},{"cluster_id":"a1084837-f12e-45c4-9bfb-1677ce1c51ad","members":["70d39cc1-17a3-4c78-868b-524525fee81f"]},{"cluster_id":"781b12f4-b179-4668-8b0e-ea2f1da17240","members":["e19cdc91-b26c-4c06-af84-6bc813283f6f","2f81a6c8-caec-47d3-b457-3dc88dbebb32"]},{"cluster_id":"4a315717-0c5d-48f0-b376-1a12c3498c7c","members":["ff62d27d-55b2-45bd-a9ac-aaa477b9caab"]},{"cluster_id":"d339acab-2e15-4ce1-8cff-20a1b2fc2811","members":["4eab83b6-6e27-46f1-bdc6-5cbc5609e5ef","2635407d-4878-4b46-a0cc-e96df9241a26"]},{"cluster_id":"cf4eccba-19e9-4f9a-984a-135d1c838ee6","members":["221a865f-71a5-4c68-80f7-d7234ebe441b"]},{"cluster_id":"dbf82ccc-f0d2-4cf1-bdc7-044687b587cf","members":["8a7d0894-415e-4f16-b859-8f67461bc8e4"]},{"cluster_id":"69fc2536-52ab-49eb-8743-9e6f9bfcc4f5","members":["edc2d296-1347-4472-9cd6-ee8b4ce94306"]},{"cluster_id":"a99c031d-3fd7-4e53-9585-fd9ad40ad4d1","members":["f1781c7e-8053-4b57-a9c9-d07754f1449a"]},{"cluster_id":"54db3169-8794-4675-bba8-d68dda1009e7","members":["c470d7a4-b30f-4401-9705-0d43de6cab4e"]},{"cluster_id":"fcbaa14c-dec6-413c-9e80-6e8b3b617340","members":["58eaeb8a-7e9a-4fc8-bd33-f98733127de0"]},{"cluster_id":"b105a78c-297b-4eaf-9891-43407b9d8073","members":["c1435856-a581-4c7f-b78c-d5da6430d59d"]},{"cluster_id":"0450eb4e-f8b9-4b39-9c27-c75e30610c21","members":["7336bdd4-dcd5-495e-b819-17b1b8611550"]},{"cluster_id":"7d4d7620-64de-4dcb-824e-188535febe26","members":["bff091f3-e410-47a5-a7df-00cebb8fc2ed"]},{"cluster_id":"ee0681d9-e912-4091-8f01-0d69df3bcbee","members":["11630551-a0e1-4832-850e-eb02c61c8bfc"]},{"cluster_id":"50cf77d2-56a8-4588-8c16-f417874c0063","members":["19fe6b07-9b6f-4e03-90dc-0d843bac14f6"]},{"cluster_id":"7ecaa8a7-76e8-4332-a41f-2c347237e2a6","members":["3af86b28-8804-49b8-af9b-699fbba4dc69","d1574709-ef45-4df4-9dd4-56dc36bcdc85"]},{"cluster_id":"e10e77d8-6d39-499c-97ff-017e9cdbf650","members":["053e8850-c3b4-4cf3-8c98-02c7211e2065","5dd26957-ac5f-49e5-9148-5b3ea159693b","4f463dfc-a1b1-4a06-8341-3f8e5f3c168b","83e49db4-0946-4b37-82e5-819ad7c0a1da"]},{"cluster_id":"00ecc521-dbbb-417a-9961-132c4f488d88","members":["8378826f-6566-4850-b9ab-4aa8483aa62b"]},{"cluster_id":"29fa8f23-676f-4f6e-888b-58fd11dbd236","members":["88546c51-205a-44c2-ba5a-e49e1affa8c9"]},{"cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0","members":["97e0bbc0-1c97-4c2a-a768-23b1c5b6499d","daa821fd-4236-4099-99dd-b7d11d6b3c21","934e88c6-ea3a-405a-bc40-b792db0430c6","8b0c8798-1366-4de3-9ac0-fa3e96f20c52","2be83f52-f77c-4552-82c3-949839d95a0b","74e64fca-287d-4d78-a676-00b2f615bdcf","81ea0346-0d3c-46da-ae67-a4e4511295e1","51c2ac4b-6155-4d68-9e60-c8a889ca9cf1","9c4c835c-6721-41e1-bb6a-bdd9ff475b95"]},{"cluster_id":"d140ee70-1c2e-44c9-b163-573b275b6b17","members":["e908c0ca-d2a7-4260-ab1e-04cdfa8e34cf","d86e9609-77ec-4c34-b3f1-a779490eaedd"]},{"cluster_id":"95799deb-0b6c-4eb9-bc15-24b196417c4d","members":["8dbf0918-8f32-4fab-b4f2-d214db9bbec0"]},{"cluster_id":"9766dff3-64a6-4901-a68a-2702c328c3ac","members":["4599ab63-54f7-4a04-8f42-57009a6ae00d"]},{"cluster_id":"0257bfac-c84e-478c-a7f4-6a03847d3df0","members":["0ab3b765-e365-4034-93ce-2f660110ff93"]},{"cluster_id":"83ccf0a7-79d9-408a-a448-eb83f5e7d0d2","members":["bb69b414-1983-45be-910f-c2835efe19b9"]},{"cluster_id":"ad32e47f-d132-47f0-8dd9-2751c477fa34","members":["1404893a-c0b2-4814-ab64-359e2c36b158"]},{"cluster_id":"f9fcbf4e-cb96-4f3c-bad3-73737cdc4b3c","members":["2086e587-ce6e-4e06-9839-97ca25e372ba"]},{"cluster_id":"9041e9b2-f334-48f3-86f9-79b1ba825b51","members":["78d710de-a906-4132-bb3a-d2c714abfdcb"]},{"cluster_id":"ceb785f5-a630-41a5-8352-bf1ef25b04f9","members":["794f77f6-b8b0-4788-a6d2-c21ef39b677f"]},{"cluster_id":"8498dac7-1f62-4d7f-a27c-61f5ecb321c3","members":["48de5f88-6848-4e7f-b7fe-44f843b58155"]},{"cluster_id":"07c01120-e316-4bd2-9ebf-b979d08b4da8","members":["15006e59-2ab6-4689-b249-9373536c9841"]},{"cluster_id":"9d377c51-15d9-43e8-b309-1b51ed3849a9","members":["183646ae-2ec7-4672-b2e4-ba7db495d1a4"]},{"cluster_id":"074c64eb-8566-4f36-bf3a-fc5995c21e65","members":["4d8bff75-79ca-4497-8094-ddebeee2b85d"]},{"cluster_id":"d3c16aa9-3593-44e3-b641-54f418736f76","members":["de34351e-1dc0-47f4-b575-148dbdb62792"]},{"cluster_id":"c711195e-092a-41ee-984d-299705596d70","members":["8b4802a2-bf7e-4268-ba24-00b763e64ab1"]},{"cluster_id":"8d52f35b-3806-4a30-b931-3dfcb56775fd","members":["6491f48d-4baf-45b9-82b2-7251833f7208"]},{"cluster_id":"065f4f08-9205-4dff-8de0-542c6bb45da9","members":["9d9ce06a-8386-47b7-ae5d-017a2e744ce0"]},{"cluster_id":"21d0c066-9264-468d-b96a-f5f007531508","members":["12c09e06-1f61-42e8-9e16-e01afda25148"]},{"cluster_id":"7675ffec-ff62-4c58-a805-c5097a8fcd7e","members":["1be9d181-cdca-4b5c-9997-fba2dfa838b6"]},{"cluster_id":"0f5915ad-4edd-49f6-8855-92a02e00debd","members":["8259ef14-361b-47dc-a04e-4a24e1594092","37438bb9-ad89-4693-96ac-1f3e4de9e11c","1873f9a5-f398-40e6-80cd-199506a5dd73","36bae434-2756-408c-a259-d7ecb6730216"]},{"cluster_id":"11663b2b-28c7-494e-973e-2fc5dca8374b","members":["1e35f35f-ebd5-4ba3-8a18-976b164195a8","a7e5dcd6-f5cf-4787-8fcf-0e5969168051","ff095616-4af7-4f55-b51e-7f432b40a233"]},{"cluster_id":"5bae13a5-6b81-425d-a9bb-49850203205e","members":["71c8491e-9487-4a05-927c-953d05c4279a","c80d4a05-71f3-4de0-99b0-46eefea2b55b","6d09cef3-542a-4122-bce5-4ed42b20a35c","73acaeeb-a18a-4e1f-aa58-d7ca76180f1e","478e7f14-ad18-42c7-975d-dd83210d9522"]},{"cluster_id":"b4f7c43a-b96f-4977-a6a9-ad07015e8976","members":["47fe2c82-b778-47ae-a05a-e4741259bb31","1171ed03-4a86-4377-9b2a-9890e9c06a3b","8ad4a51c-871e-4c4b-bacf-4514122bb946"]},{"cluster_id":"8ef9691a-752f-475d-a3ef-753ff2032577","members":["1facc140-18cb-4bee-9e5c-073a9b6e2dc3"]},{"cluster_id":"56c5d781-120e-4c38-ba12-676cecb63cc8","members":["9d6a225c-723a-4f8a-a9a9-d31582f4cdec"]},{"cluster_id":"eb8c09b3-c22e-4c14-a55e-41e86bc54809","members":["44c83632-d3ba-44b3-8e8f-558ea7383cb3"]},{"cluster_id":"05b6ff5d-2ddf-4b71-b6f6-98defb612c16","members":["eb9276c3-6b9a-45cb-bd9d-ce6001fe6860"]},{"cluster_id":"0fa8aef0-deff-4ac5-a935-94011ed8be80","members":["ebe85d02-d260-458d-9fd8-a2eb30d8a874","b899e414-1d1a-4e3f-9ad7-92dcb8567106"]},{"cluster_id":"e0a8946b-f177-4ac9-88a3-5799d558da5c","members":["d65b82b8-3af6-47a7-b42d-b49325b3e69b"]},{"cluster_id":"c7ff0720-041e-4548-8592-cfa24a2712c7","members":["b2aadc38-7271-443b-98b6-00461b5d6cf8"]},{"cluster_id":"b687420f-e058-48a2-8c4c-4bc6f35624c2","members":["45de970a-321c-43c0-a66e-dfefc8535b91"]},{"cluster_id":"5d32a56f-b7fc-4a53-885f-d83367218f7c","members":["cc83063d-de60-4c37-af8f-2a928fc78fc1"]},{"cluster_id":"7186362f-7694-4259-bf65-9f7c8f813207","members":["854f3543-551f-4acd-a626-75d1a0990083"]},{"cluster_id":"94a48846-dd13-4363-a56c-c51f47f2440a","members":["952612b4-1f77-44c3-a040-369786992f85"]},{"cluster_id":"40978309-052c-4c0a-8f09-9f1d51e423d4","members":["f6b25295-4987-4865-950e-7ad582da48d9"]},{"cluster_id":"8c990025-029a-4aef-bcf5-41326b6234ac","members":["8731915f-2d7c-4772-a3fb-2041138609ad"]},{"cluster_id":"e0a1afab-5142-40ca-ad10-35061b0289f8","members":["11a7e18f-5da2-4c8f-bce2-78c9d221faef","572cbeb6-e025-4c36-a959-9b84f9bac472"]},{"cluster_id":"d9b500c1-45df-46d2-84a9-276291e99b35","members":["f533e2d1-5daf-4df0-98dd-6062d957663a"]},{"cluster_id":"51ad5e06-f7b5-461b-bde3-00f8284ec903","members":["40b8c52d-0e05-47b8-92c4-7a51a2673401"]},{"cluster_id":"6694e203-070f-4cf7-a327-66b5e005a5e4","members":["f2c53340-b5d5-447f-bfe1-81a987945b9f"]},{"cluster_id":"29eddc16-8def-4acb-9488-5c09c0cd7216","members":["5bb3b610-aa82-4d4b-aee8-97d997396356"]},{"cluster_id":"4edafa37-461a-4e41-b730-dd41cc60940c","members":["3311beac-ea56-47c7-b107-e24ced9d6551"]},{"cluster_id":"159512ee-03be-4a2a-b7f9-1691ffdb67cc","members":["9dacf18f-a0da-40e1-83fd-d4819d3fab00"]},{"cluster_id":"05babc1d-7e43-4754-b561-cd3371da4717","members":["271d8e72-d2e0-4b2a-bab4-8aad1c915ad7"]},{"cluster_id":"7b83d10a-e2be-4730-b52d-6f8b8b917c91","members":["55aefe89-aa6e-4c04-a7a5-a635b73bd5de","927daa80-8d17-4253-a012-2b0496609a1f"]},{"cluster_id":"d5b4afb5-46e3-4fab-9511-72f4984164cb","members":["68c9b6e8-dc09-4d64-a8d7-c197c95877c3"]},{"cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d","members":["0ec1ded8-6576-460e-be9d-3b5b853d3b05","0f392d94-957e-4115-bb27-f1428a1f5994","0fd8c1ed-5782-4cd2-8018-81cc39b1f887","2a98ff16-b946-4fcf-85bd-ccb288f0aa27","53aaa877-b359-4b19-9eb8-87dcb20c91b8"]},{"cluster_id":"bf2543e7-3701-40bf-a97c-164b45c21900","members":["0a8a26f2-5737-41b6-a719-b9c2adf6ee46"]},{"cluster_id":"4722732e-36ea-4a20-b934-96b47f115eac","members":["9f6f6f31-0f13-4951-922f-005787192b55"]},{"cluster_id":"f21fe246-03a7-43ce-b3fb-1decc7a9853e","members":["fa44083a-61f0-4701-bb91-19006e6597ec"]},{"cluster_id":"2760cb6d-72ed-43f8-94f6-443f59d74437","members":["629575ca-5c65-4ca0-b7ca-58a497854762"]},{"cluster_id":"6272f62e-bf00-43bc-ba48-d3f7c9c3ae02","members":["565e4399-de52-4508-9fd7-76f912ef3d00","74d88a1b-8f1b-4a10-9f4a-d925b87902c6","2327e9e9-0b9b-420b-b3be-0f9707fa55ec","fe6dfd64-bbf2-4a17-895c-c6ae88b7ec89"]},{"cluster_id":"1e56067f-4831-446b-a37b-b3b5e1d7166f","members":["5c67b5b9-d347-4c83-80e2-b45b0d5ec9b3"]},{"cluster_id":"b32443a3-fa40-4637-9b55-e58ec8393ffe","members":["9685729a-b9db-4a49-a949-2afbb17fc9df"]},{"cluster_id":"35df1ff6-45be-4230-aba5-19c41bc2020b","members":["8d9d41c6-da0f-401e-b936-f4807632bf31","4b08a871-b579-4d32-970a-01cfa0688fa4"]},{"cluster_id":"444282c8-5a59-483a-aa4f-acbf1655f118","members":["070deb89-5a21-450b-b8d1-72a1c7578939"]},{"cluster_id":"c057a22e-5c5b-4db2-8c44-1bbafad4ea91","members":["f8d94d2b-829f-4f01-bfb7-58a292aee5a2"]},{"cluster_id":"1d63f5ab-d2ec-4979-b939-ba16ea5a94d7","members":["071dbeb4-43d3-46f7-8d0b-56456f15f2bb"]},{"cluster_id":"76d75a5b-4dc1-4bbe-8b14-04af1d297ada","members":["04a45d39-7beb-4f4f-bead-78db2d4b7c6c"]},{"cluster_id":"ebe02d8b-ea82-4232-851f-f5ea26e54e8f","members":["39311e16-85f9-494a-bd0d-6c08537af9e0","98ec7a74-249a-4a7d-bd29-61f25b29ccdb","9a4ed516-ccae-4da8-9436-a0e39e489053"]},{"cluster_id":"308a615f-ca1b-4ef9-9f68-b4e3d4d08711","members":["bc395992-d8db-4064-be79-0eca3f5dea93"]},{"cluster_id":"40a69599-ced7-4b8f-b20e-fb9c99238bbb","members":["bf32c5da-6283-448d-8acb-44393b76d8a6"]},{"cluster_id":"a0a19a10-55fb-482a-b96b-5df57df087a3","members":["68ee3726-92bd-4c45-947c-6b2f5d426fdc"]},{"cluster_id":"010bfb3a-2b97-43f6-870c-f3dfb129b9df","members":["26ebec99-02a1-45a0-8717-5a3f6dbd0172","b88a14bc-bc70-4f66-b011-56f47993a594"]},{"cluster_id":"38bfd344-45fc-4c0a-8605-6354b8f22cb4","members":["cd83f40d-8334-4b57-9cd3-265c7647f9d5"]},{"cluster_id":"3f7e49c1-3bca-42b1-a2c6-b96fb1443ba2","members":["c7b0be5d-d9a8-4a18-be17-7e886aa98900"]},{"cluster_id":"93849a08-743b-4023-9ccb-ce323519297f","members":["2e14056b-ff7a-4e03-a1bf-ea1809a824f3"]},{"cluster_id":"bbc6fef6-c552-409d-9152-d8abd3a15ae3","members":["e658e375-6c2f-4f15-9f9d-05a7f91f8865"]},{"cluster_id":"773c7be2-511f-4315-b512-fcfb831f2cc3","members":["5672f72d-fdb3-40c3-a299-ccdace7d2199","20b1fe96-adae-4346-97e2-6d250e59f29a"]},{"cluster_id":"c77f0d47-36a0-4f9d-86dc-1f10b0aee675","members":["96b171d8-ea9d-45d2-a4ad-33902e09056a"]},{"cluster_id":"b6c2d87e-7d9e-4ac3-a24f-6f394e994f13","members":["fa5a6b57-1a47-493a-a36b-3025a63eb5da"]},{"cluster_id":"c367dcdd-b30e-4731-8d62-e633357c9a70","members":["42ce3983-1339-4c62-ad23-b361140f3706"]},{"cluster_id":"815f7381-c3c0-4b84-8b7d-44fda735e36e","members":["632f8c9e-0c8d-40c2-8faa-2fa2e56e9f15"]},{"cluster_id":"9d12c49f-ea33-4a41-83e1-0a953c37fd5e","members":["e52e5643-5b35-422e-a31c-76a074784133","28fc4989-660b-4a74-adef-84b2073491a7"]},{"cluster_id":"862e3561-6a46-4a47-8035-363b4e2c1786","members":["af84a2c0-20f1-445d-a47e-be722157f866"]},{"cluster_id":"97ed4747-8726-498d-80cf-261756e7962a","members":["123862a1-b1a1-466b-89e8-98bd635fdfa0"]},{"cluster_id":"1826eb0d-42e5-4b20-8a46-72b9e26a1dc6","members":["25eeb302-e32d-4093-9ccb-28a145392db1"]},{"cluster_id":"4fe1a1d1-0c63-4497-8366-24cf2914a93f","members":["bce70684-d785-4f5d-8b34-b37d39ad4b8d"]},{"cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb","members":["c347c984-61b9-4be7-9681-e09841c11eb9","4c51a416-fe78-476b-805d-de1b3b9c0517","e5d7503b-2f1f-4323-99c4-038ff15d4cce","6d355a7b-b9d4-4acc-853e-dd80ef633109"]},{"cluster_id":"21b62bf3-e16f-411a-a9aa-a2991cb252d2","members":["046ed115-be27-400a-9c8c-0cb80c6561c9"]},{"cluster_id":"7bd525d0-ac48-4787-9774-a8b37c4ff4a9","members":["4aa20286-0f2d-4b59-bae1-e84853948865"]},{"cluster_id":"fb4930fb-4b1e-4086-912b-c760c3b7850c","members":["0c97f7fb-82f0-4efe-b17a-2da2ba7482f6"]},{"cluster_id":"bbb004ba-d35c-43eb-a8fb-f8fc936100c1","members":["119c8926-bea7-4ad3-b11e-636b958ad8c1"]},{"cluster_id":"005d39b6-0b0e-4011-aaca-d596411fa607","members":["5333d473-984a-4b43-8d25-bf25f200d4a4"]},{"cluster_id":"91e856d9-7ba0-4d4e-ae44-31db4386dcaa","members":["6a3e6b2f-8f3a-428c-afa4-84fc7d2d5fe1"]},{"cluster_id":"3e87987a-c8cd-4616-922a-e297f103d0fa","members":["15cdcf77-2de5-4af8-a741-22b3b80db643","abd88480-a561-41ac-9ac5-e3ff578e9f8a","43003400-9f69-4899-b6b9-65d8858ef0a2"]},{"cluster_id":"c9760dda-4208-40ee-a4e1-20fd95324ecd","members":["58780262-bc3b-4b04-961b-43d2e249fc68"]},{"cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242","members":["70c8b6e0-2edd-47f7-a604-ef58a468a3c7","1a89a0c4-9240-40dc-97e5-5eb183d35328","7429b626-2a70-48db-931e-9e7f6919e3b1","b87164bf-f264-4ec3-bc7d-3b7891722a46","db697b3c-4c20-4835-bfed-a2f70871c18a"]},{"cluster_id":"7be54807-07de-4ad8-80e9-963285c4b2c3","members":["4624f61b-3248-4c50-94af-20616705fcde"]},{"cluster_id":"9e93a133-57d5-49fc-821c-7ad0cab51a96","members":["a027dc7b-c9a7-4547-9440-45d1f7341f8b"]},{"cluster_id":"a6896ca9-8851-4af3-bc86-04c953eef0ce","members":["2d75641d-f6d3-4c2c-9905-d28c78ee7d48"]},{"cluster_id":"373b4029-0616-4e8c-84dd-67212ba62068","members":["efb8e062-80c6-4169-878c-cfe628f51ca3"]},{"cluster_id":"4cdadb3d-d6d7-4b33-b2c9-1974e780d726","members":["a93d140c-7059-40a4-9fc7-f386305f99f1"]},{"cluster_id":"7679c732-4d78-416d-a31b-b4d49c72f3ed","members":["861036e7-6c6d-431d-86cc-846f663b7514"]},{"cluster_id":"81a59b64-1e50-4ead-afee-e08c8a24c430","members":["12a6998f-d040-4d06-899a-7db8d940defb"]},{"cluster_id":"692b8f3b-7c78-4cbb-b4e5-764b2d4124bb","members":["993f1d99-f715-4c38-a1fe-58a206840121"]},{"cluster_id":"054ed505-3504-4e27-9979-055c536c39eb","members":["8ec60233-7bae-41a9-80e9-b644a2146314"]},{"cluster_id":"ec3b133b-630e-4f2b-834a-c8cbcc0a0e64","members":["3a6c93e6-3546-46ae-9c1b-18f087ae34c0"]},{"cluster_id":"1ec0df43-8c4d-467b-94f6-ad15fb3c5b4a","members":["34b203bf-2d15-4e33-92ab-e2d68078324b"]},{"cluster_id":"51648166-6ec3-46d9-a3d1-905adbb2ede9","members":["bd4c7672-0948-4f47-a723-25801c90c440"]},{"cluster_id":"0f09675b-050c-4631-816f-5157cd231924","members":["ea2a43fb-c001-41f9-ac74-95a4e68619e1"]},{"cluster_id":"2d3a5941-caeb-4957-af01-00f1d2fdf8e4","members":["af9b47f0-f78b-405a-813a-dc4f6e375e37"]},{"cluster_id":"0621c61e-ad6e-41cd-8ff0-a60a7aa48a28","members":["8b0158bf-7d51-4aa1-ba16-ddd321c12f16"]},{"cluster_id":"d5b448d9-eec8-4c71-b5f7-f99ea16eb286","members":["5537b25c-7236-4628-8260-1c0ab6cefa6e"]},{"cluster_id":"1f13dc99-3c84-426e-b6fa-781deb8b786d","members":["64d50828-be74-4db2-bbf2-da64e9fa2f7d"]},{"cluster_id":"728de5c6-3345-44e8-91f4-5ab1fb0c6670","members":["72044b8d-c4b4-4a59-80fc-c235b79789a5"]},{"cluster_id":"30f48da9-bf4c-41d0-ae36-a76653721604","members":["4e688659-175b-45b5-95ad-46280a2e633c"]},{"cluster_id":"fddafbe9-dffd-4341-9619-bfc6fc256b34","members":["c684ac85-415e-4d8e-9af0-8aeb612bd6c9"]},{"cluster_id":"09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5","members":["b4170d9c-3b72-465a-809d-171f28b7a66b"]},{"cluster_id":"3dfd5a3b-6011-45c7-8661-03086fa25dc5","members":["6d750e2a-53c7-4e33-b3ad-f199faeee237"]},{"cluster_id":"ef161e9b-6253-45b0-9c42-d8e3db87f120","members":["5ece7e1d-f751-433f-a23d-a8b8429783f9"]},{"cluster_id":"8c441ed7-3996-46c2-abdc-191f54206cf6","members":["79853758-a1f1-4361-979e-67f91fdad3ab","f959a15a-811c-4320-96e0-b3d0d9234415"]},{"cluster_id":"c9ef551f-21d7-4986-8f7f-14a67206ac95","members":["ca6f1116-8965-4191-9f7a-2de14fbc69cd"]},{"cluster_id":"add56d26-1f85-486a-b862-703a0d62439d","members":["ffda74a4-dbc9-407e-b330-796ec4986f62"]},{"cluster_id":"97ff7137-390e-43dc-9ab5-05c730068c02","members":["0eac5b4f-7673-4393-8130-bd9ac9fe96d9"]},{"cluster_id":"f16a1de1-a4da-445c-ac5b-035b9edb7fc3","members":["009f8b89-e667-4b4b-a5e4-d6dfa011918d"]},{"cluster_id":"92c29e5b-570e-405e-92f0-4969ddf38528","members":["52ef3fd8-fb9b-4909-a130-323a330527e2"]},{"cluster_id":"5787a927-39a0-4bb7-92d5-230091f48a3e","members":["939b5de3-dfc6-4646-8e79-a15b536f10d3"]},{"cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2","members":["3fca1f99-4c3f-427d-9ab5-018b6b50369b","160bc68d-b04c-4782-87e2-8818ed161340","e8e9e296-5042-4c13-add8-a1aa37276d9f","156ca787-e71d-40ea-95a2-7662712a1cf9","214d4af3-d4fe-4edf-9b28-d410c6d5c5fa","1f938813-1b69-450f-b8e9-54972ad22999","5424fdea-3641-4e72-9221-e09f60ee8186","02b65303-b664-4292-a713-a0a542d88621"]},{"cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810","members":["6da95ac5-d396-43fa-bc70-0f96e1fd62e9","eb813a15-f200-42e5-aaa7-c964a2b141b5","d26e0e0c-97ed-4101-aa66-03799c71230f","b05495fc-f92f-4944-b344-fb6bab4d2309","e36d0b37-49fc-4dd8-bac5-bca15b1c8382","4258cdeb-dc85-42d5-9bf0-ffb422d15786","9091d87e-8a09-4f86-97b4-a3695200402b","d8573a4e-9b56-470b-8c64-d08efb9b7470"]},{"cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a","members":["0ea158f9-2cf9-4c14-943a-a6995d3d2c1e","e3e465f6-cf05-42d8-a17d-575f69d2fefe","a8b64150-84b7-4ad7-bdb1-c3756003b90a","7d2c1726-d24b-411c-a5d2-91e783ff24e2"]},{"cluster_id":"27c83a03-3f6f-4152-a678-12dc8e5912da","members":["57a76d29-9b46-4758-9cfa-c3502439191b"]},{"cluster_id":"963c86c9-b5f1-4cd9-ac43-10cc5c0f5aa1","members":["74a92bfe-e7e2-4a17-96f3-977bd6c75971"]},{"cluster_id":"b8f6ce4f-4115-477a-9fac-602b955a0de8","members":["3391df15-1751-44cb-ad85-ed274782fe12","b41e6423-16f3-4b35-870c-1142dc824e7e"]},{"cluster_id":"1c65b00f-4fc8-40b9-b323-8ff074f956ae","members":["99282d0d-b110-43d5-9e0d-5d05ffc5a116"]},{"cluster_id":"31531356-3930-43a1-9c28-b7ad9753b67e","members":["e767a553-5fcb-4e12-b80e-2a3793afb03d"]},{"cluster_id":"3582a60f-77c5-4a28-b692-e25a35716357","members":["593d53aa-de27-41d6-97e5-f1eb58f1f26e"]},{"cluster_id":"da455fdd-d1bf-4166-b24f-377899985b7c","members":["8f58bdbd-80dc-42f6-9f33-f1c5cc88f715"]},{"cluster_id":"88fadd59-b242-4ad4-ab5b-3465e7a2b5a6","members":["6a2c1a2d-6dae-481b-9511-8f7f6c41b31e"]},{"cluster_id":"997b033a-0811-49fe-bc36-8ee742156833","members":["56e46f91-f578-424b-ac97-61bd4ad09dda"]},{"cluster_id":"3bbfdf4b-7f9b-4300-9c99-cecf5843d988","members":["5f76fcd7-ca7d-4991-9748-23fdfb329e19"]},{"cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de","members":["6f1f4db2-f7ad-4038-88b1-e49cb9941fd0","e930d6e7-85d6-4421-a247-e19e17bfca63","52e92dba-398a-4cc5-b309-93a582942749","a53c344d-45d0-4daa-a4ea-f6e9b933e2f3","7ceb8afa-28c7-4571-a76b-15da683cfcad"]},{"cluster_id":"7df19845-e2c9-43df-ab08-20e640d2669c","members":["45d0fe49-586e-4392-aab0-6e2ee5485bc6"]},{"cluster_id":"53949001-7a01-495c-8cfe-7d81bd307f6f","members":["db76db46-d82b-43b1-95f1-a3ed8ba63240"]},{"cluster_id":"821d5bc2-820d-42b9-a931-b0991cb2d55a","members":["85210055-881e-4173-8e99-af2342aaa7f6"]},{"cluster_id":"1ff366e5-31ba-464c-8544-3d84f99a75c6","members":["b4699b79-c057-434f-9ab8-3ed0ed11dd05","5f01571b-6f20-48eb-a0f5-9bc528a2c9c7"]},{"cluster_id":"a5de3945-d8b3-45a7-9c18-edeaa4ccf742","members":["c7652e57-3b50-4af6-a37e-e5141018e8db"]},{"cluster_id":"edab64d5-5e0e-4c94-9892-79b39580b98e","members":["015d0d8a-b015-429a-ad12-eb03df372dd5"]},{"cluster_id":"2d202c5c-9305-4705-93d0-1781607fb294","members":["96eb0004-956e-4d80-a84f-7200a1e0ad40"]},{"cluster_id":"90c72bc2-1d1a-4a98-9edb-8381a34e2935","members":["196e5bb8-2507-4fea-9a34-465a3d1bbe5c"]},{"cluster_id":"ef5dda09-a763-4471-8324-78da714107dc","members":["1a4a8584-a47f-491a-ac01-9a7df33ccd94"]},{"cluster_id":"c0a9c99d-91fa-48ff-be0a-c6e00181d46d","members":["eb984b97-6ee7-479d-982d-52c0d85f4175"]},{"cluster_id":"6c08edb9-0ade-407d-af97-cbc1278990ac","members":["13d812f3-4c7f-4860-8bd9-c7296bdb1d82"]},{"cluster_id":"3efed4d3-9a2c-4fa8-bf3a-fb69d88128e8","members":["62ec7979-29e7-44f5-9061-97b8046f21dd"]},{"cluster_id":"35eea677-5b27-4587-9764-95116cb6b83e","members":["46074779-fb4f-457a-9f85-8c4299875b73"]},{"cluster_id":"971dde28-a3c6-404b-8a02-b24390ab3750","members":["0253ccf2-8231-4970-85c0-0d5faa424449"]},{"cluster_id":"a3f777dd-158e-459c-ae69-5df160dfccf8","members":["7eef192a-a093-4a72-bede-19b3ea62ea63"]},{"cluster_id":"1acc7240-f221-42ca-8a48-7f6a18f1f844","members":["16f49665-56cd-4020-a877-576647975e56"]},{"cluster_id":"1a1fe423-28a9-476d-a154-c1e0960501dc","members":["d0593d90-01d0-4ea8-ab77-4bc3ab40d85e","dcf249aa-c49d-42c1-8171-a26bac8be3d1"]},{"cluster_id":"722dcdeb-8c69-4fc9-878a-87c7aaade27b","members":["78cf8df1-f528-484a-a227-ce2148453ea9"]},{"cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a","members":["7736b01d-9d52-4191-8649-3935b5d7e4c6","7221df48-3d44-4760-a98b-ac22ba59da87","e00401eb-37ca-4d71-a936-54f7c6dcfb52","1d9be90d-be78-4031-accf-9126f8346c89","177a8ead-2e4a-42b3-bd3a-431798790bde"]},{"cluster_id":"909c2544-65ad-4eae-8bbb-f43d077750aa","members":["42ebe7bd-d97d-4f3e-bca0-87867d9d6902","3f2cefbe-b919-486c-b195-695bd3725bcf"]},{"cluster_id":"cf0c77f3-683e-467a-b83c-95b78a12d867","members":["2cc4fbb5-7e91-4eda-9477-41f4891308b9"]},{"cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6","members":["5d2cb133-194f-49c8-af45-598d4cbcec5a","7236ad73-10dd-4424-8400-fcca0d46b21c","21cd4a11-f1ba-46ec-a6dc-887af328374c","5a1b9213-c394-4034-ad93-9f5c23db6c2c","b2f75d73-126f-423c-acc9-5075c262d520","1d886fb6-8166-4a0b-af08-e49f9b3409c4","2d51f614-a53b-41b7-a05c-e314d3acff13","10001215-1c6c-494d-b431-6dd94724db27","4e7dce9c-6656-4866-afe0-55c31488e64b"]},{"cluster_id":"edcb6d77-94bd-47fa-ac30-bd310a6e83e6","members":["cb8462d1-d7fa-4332-8219-7feef998001d"]},{"cluster_id":"caa057e8-994e-43b8-803e-0ea0aeab7ec7","members":["7f66a7e6-69b0-4ed7-a76a-aba9aa79e5bc","4dde4a46-a612-4bf1-b453-efe74073f1dd"]},{"cluster_id":"90b17dac-ed93-4273-8df4-019652e30993","members":["0a63b17d-a0f7-4289-b7a2-009dcc402d58"]},{"cluster_id":"ce5f39de-c868-4feb-8d91-20b21e8b8ded","members":["c8cf1924-4a5f-46c3-a9c4-ca0488053763"]},{"cluster_id":"f51a6ac2-4516-4b4c-9fdb-e7e4932f790d","members":["21816fb2-338a-4b94-9ec9-1502305688e1"]},{"cluster_id":"d895f911-9139-47dd-8018-79b66f8588dd","members":["5416a5bc-9aa0-4b41-ad0e-0c9d8e8a4c38"]},{"cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87","members":["1c33447f-9b46-467a-b7f4-d907de6a50a4","eae286d6-d908-4958-b808-2f866d9ef706","09b43b1f-b2fe-4c1e-bf61-ae46aab54da1","63271fe9-df41-4ee1-841b-3153cb7da6d5"]},{"cluster_id":"e86748c4-2789-4941-b470-d29321693c17","members":["1fe462a1-82dd-4fab-bf7c-f7c9823fc4e0"]},{"cluster_id":"2cf37935-88f0-4aab-94bf-6c7a6da78e48","members":["4e10ed8d-4010-4c28-89a7-fa16335d2a33","b1456a7f-65ff-4e2b-8ece-58d52c4b4035"]},{"cluster_id":"b3bb12a8-9e61-4051-99f7-b8946e7edc6e","members":["d9b8ccf2-fd23-4c83-8acb-d8ad5e5b68ee"]},{"cluster_id":"bc3b9d73-137b-4059-890e-e7cbbf0bd7b2","members":["12cbac2e-c124-419b-bfba-8eb089e92750","c6c11fec-cd76-4fb3-b134-d707839cb5b9","8a253488-d483-41db-bd72-6b60bf09edb1"]},{"cluster_id":"5e0be9c9-87ac-49bb-a807-6e19f719434d","members":["43d05f96-9246-4049-9c56-c446ceea2a7d"]},{"cluster_id":"9bba558d-53eb-42ad-851e-623ab4e32bc6","members":["dfb7f452-6f07-44e5-93fc-19766ddf8227"]},{"cluster_id":"9b0314ac-478d-4c92-b0c0-490018094349","members":["585b62e4-af3f-4f88-a85a-202d5611bf92"]},{"cluster_id":"0867ca4e-1775-4423-92bf-6fc8d1d9c0e3","members":["06abf97f-1f34-46a7-858f-267e8104e7e5"]},{"cluster_id":"7050c8c6-a172-4da4-a04e-a8f348b2d49c","members":["020eaf7c-6638-408a-a07f-be78f52769c1"]},{"cluster_id":"9f394b1e-f3b6-4528-a71b-dd2fed1c81a5","members":["d04d7a00-5557-4055-b7ab-a0c7706180e8"]},{"cluster_id":"abb6468b-1949-4a51-9adf-d3e014a3003b","members":["cae9d058-4b9f-4631-8d47-bd0a5ebce50a"]},{"cluster_id":"a16d38f8-25ac-46b8-94d9-38eb77cacdcf","members":["8e0925f8-ca35-4b50-af54-c2a561cbd4f7","db9b45e8-08c4-4897-8dfb-d16f1b07a985"]},{"cluster_id":"9c71282b-fc72-4fb3-b7f8-7ff433782d1d","members":["7035f193-d0d8-4b29-9363-8b9997255920"]},{"cluster_id":"38b77626-e120-4759-a3a5-dc826b3463bb","members":["dfcd5ada-9ea3-465b-ac6e-ad0cb35806d4"]},{"cluster_id":"19f144a9-ec9c-4a9b-89c7-b1ca850240da","members":["e159d079-6ebd-4da8-b6f3-264cf95c3164"]},{"cluster_id":"0f0ff324-b8f3-41db-88cd-a895d1f4a2d9","members":["27779f6e-b1d1-4cb1-b2fd-22465de74412"]},{"cluster_id":"ccdd5d79-92b1-4503-a1ce-51ccf23fc823","members":["f6603684-e321-437b-beab-55794bdec1e6"]},{"cluster_id":"4a7864ed-3fb7-4536-8df0-aadd1c453c8f","members":["50d18c7f-3a6a-42f9-924a-ddef9d67bc1f"]},{"cluster_id":"35d3e890-e939-41bb-b28b-3ee99ba1783a","members":["7b152dcf-fc08-4a62-8dbc-17dc3c6ac19a"]},{"cluster_id":"7370dfbb-74ea-4d34-82b7-9398b71ecd5a","members":["8f37c27b-d364-44d6-b01e-ce0ee74d8907","c729b3a5-3286-4a46-a8c8-f4d99ec15d78","5184abd3-903e-4c4a-b1ff-8197c81ef5af"]},{"cluster_id":"9419d9bb-572a-4e79-aef7-f69f5e25eaa2","members":["ffb5ffce-b389-4d5d-bc1f-35c187f1ae5f"]},{"cluster_id":"93c79f3e-8eab-4299-bf58-7b2b18493bd8","members":["61b6a234-6058-48af-9ace-0901a6a84064"]},{"cluster_id":"55de19a2-d0de-4a1f-86be-06d3fbb117dd","members":["2a277377-d848-40da-9359-47a74c644917"]},{"cluster_id":"13765e0a-ad43-430b-8852-bfa85832f876","members":["2c11a22a-4451-4ea2-b25b-6f8260f7cbb3"]},{"cluster_id":"976b60d5-b934-4def-acec-d66f7c1f4346","members":["acb5312e-89e5-4784-9168-e6895d049d9c"]},{"cluster_id":"8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8","members":["52b9bf68-c607-4c69-8549-54c0506b97d6"]},{"cluster_id":"11d3cdd7-b203-4792-91e4-e32314bbcbc2","members":["8b331ebe-6540-4df7-9b68-a56dab66f6e2","a0455b45-eed1-47ed-84bf-d090b89b9897"]},{"cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028","members":["4f148573-3f7c-4b23-ab56-b786a94fe1ff","5a73da15-6a60-4dac-b227-76a076b0d384","9f575cf0-b81e-4852-a51d-3cee646f2493","07f7a1ed-d849-4bdc-b430-9b256fe4c083","b172797b-ee7d-4a69-9af6-3a95726cb187","9c004883-e27b-4fa4-85dc-6237f9c3f8b3"]},{"cluster_id":"39f63165-e875-40a7-84ed-ae42699b5d21","members":["f167a6f0-9e3f-45c6-b6d4-bb10c3231b5c"]},{"cluster_id":"5c607d5b-9632-4ec1-9939-05955e158cfd","members":["ced5d570-760d-413b-8f21-396ef27792cb"]},{"cluster_id":"5014ba85-27bc-43f2-9c05-0160a5aa15c8","members":["64be78f6-4a3d-4c4f-b406-88deb69e8d5c"]},{"cluster_id":"702c96ce-c667-4d06-adc3-0067ef68ea50","members":["dc80216c-cbb5-43e5-bc1e-0876557372d8"]},{"cluster_id":"2bcfeb62-5d3f-441a-a60f-796550a52e9a","members":["5f9ee440-cbcd-4357-b3c6-47414dce7052"]},{"cluster_id":"bda677c6-ab51-41f9-b0f0-3abc1ddda687","members":["5ec49e9a-2136-40d6-b6ea-0e88683b1cad"]},{"cluster_id":"0d311305-9085-42d3-8548-48b9fa06ff66","members":["04cf0118-62e6-4b3e-8d62-c2c2f4182169"]},{"cluster_id":"72796cab-1adb-4917-9d03-40c3dc952598","members":["e3189ef6-b119-49e3-afbc-0708491dd4dd"]},{"cluster_id":"cac94e48-7ce8-4cff-8e2e-49f3f784f217","members":["18de34e3-72c0-4edc-9373-1b7213da3d0e"]},{"cluster_id":"4ff57c09-958e-4a30-b35f-893da7a68a0a","members":["018d2f1a-a9c0-4dfe-8791-55e182f640b3"]},{"cluster_id":"89092280-296c-4fb1-844a-03436e7b7c26","members":["794304a8-b4ab-4f2b-a488-53bcd4b14383"]},{"cluster_id":"ee253c9f-7d80-4f50-99f1-722670916f95","members":["f4120b19-33c5-4df5-ae3f-cfcbe5523733"]},{"cluster_id":"e53e2876-2718-4f35-b4a4-ab220a980fd2","members":["f0cf4498-cfb4-4250-916e-551d1f56027c"]},{"cluster_id":"146f4299-6935-41c6-a1f2-cdd4079712f3","members":["33174958-b90e-4fc4-842b-245976472f54"]},{"cluster_id":"5982b5d4-204d-410d-a74c-8426e91d2bd1","members":["fc91703a-e115-4756-abf5-e385f67fcfa4"]},{"cluster_id":"2f690c44-ca18-4a31-a2b5-68ac60208360","members":["4db0a61c-539f-47d1-aa41-d61c371d389f","8ca1d7aa-9e43-46fb-86f4-1a2ef994f80c","ef36060f-f210-48b4-9102-ace7aa5d8b7d","df02f620-4485-429f-8826-6f4ff9b9efaf"]},{"cluster_id":"d735477d-2ee7-4e51-9aba-37176b8e5505","members":["fb4d2e98-e1a5-47cd-9b89-d6594993ba1a"]},{"cluster_id":"3092d2a7-23cc-41c3-b8bd-3096963a1b79","members":["309bed94-5394-402c-a7c9-3341fbf38902","92f66f72-43b4-497a-9e25-a38242dd5f57","52d4258b-d46d-4011-b482-c6f84ea88c41"]},{"cluster_id":"f62b3b08-7f29-4635-afdc-c0569af97743","members":["48cb2831-5726-4672-89cc-9915cc22036b"]},{"cluster_id":"e2d48429-fbf6-47b6-9165-78445c0d3741","members":["e1dc75f3-2554-453f-8935-20d9fe70c69a"]},{"cluster_id":"8995bbaa-d955-41cd-a920-b35b1fea2dc4","members":["49c6df3a-a2fa-4f8d-9ca8-3afc1db555d4"]},{"cluster_id":"18485212-7b1e-457d-88c0-98b9b231ec0b","members":["f14ab467-fd64-4211-914b-af28c8a43039"]},{"cluster_id":"35e49ef4-8290-45fe-a6cc-bdd77af41ebf","members":["57a6ef75-13f9-4589-a649-16cd436bdf59"]},{"cluster_id":"3b0ef1f4-8ed3-49f5-bef1-e5534eb3da65","members":["056d5d02-f776-4514-9547-3c9fe23ddfa3"]},{"cluster_id":"b4515840-1ee4-450a-89e4-256ed3a5260d","members":["3a2345a4-de53-4fe6-9211-ba1c526e0ff6"]},{"cluster_id":"57ad4e9d-2e3b-4f99-a5b5-f89a9fbe7c81","members":["a3447ac8-e37f-41ee-a185-6f2f2caabe42"]},{"cluster_id":"20324583-738f-4b71-89a8-1820cc1a827e","members":["24e3d945-c664-4acf-81f9-fa0c58e977fe"]},{"cluster_id":"d976c975-a582-4fc7-bfd4-75e1c6617efb","members":["7741a1fa-a410-43e0-9b0c-055949c8a4b0"]},{"cluster_id":"eaa2dbb7-40c0-4ebf-a0b3-5deddf646a17","members":["44dca193-2030-46c0-8d83-19daee4d948f"]},{"cluster_id":"4f77ad08-1df2-43ea-b042-db804953dbcf","members":["6204584f-fec5-4528-8eac-f71c21153c81"]},{"cluster_id":"3f03bd41-3bd2-497e-a6ae-2bf64a55fb55","members":["b9940263-75cd-473b-a824-3449476e51ae"]},{"cluster_id":"ceb2f368-5934-45f6-bda4-01a19f923b7e","members":["1aa9e6b8-41b1-47c4-921c-a435660b1572"]},{"cluster_id":"7c6d77d0-d878-49bf-a294-6d6456dfe66e","members":["efe9acbf-5c68-4535-b952-70577ca50625"]},{"cluster_id":"2d39c2e2-591e-4b57-a739-0d6203a1a49f","members":["5f38c603-2dcd-4665-8bef-e094caef7a8e"]},{"cluster_id":"5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b","members":["a137848e-0579-44c3-a4a8-77c46f0ee531"]},{"cluster_id":"49884f4f-86a8-42d4-b8a9-af42d91f50a2","members":["9b175709-e0ba-4408-aa1c-dfd76310493a"]},{"cluster_id":"6a7bb883-6ee7-43ec-b992-6e755312804e","members":["efb4f986-fd6a-468b-aa17-c623424d1033"]},{"cluster_id":"ef5b3681-b75b-471a-b383-e605cb2d8a70","members":["71e27d8d-0a62-4065-b6f0-754d4b25e80b"]},{"cluster_id":"e8299254-b0bc-4a3f-86b2-fedfa746efb0","members":["6ef174a1-4126-4bc3-9713-f1aeaf969ec9","3b01f3e9-0884-4056-9947-42c14ea3c2f3"]},{"cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7","members":["8b08fdbe-6074-461f-9420-8973568fec69","c97c2a12-aae4-4eee-b04a-89da2678cf8e","ef32505f-4b87-443f-980e-b5273bb66e97","7573ffd4-3209-4f1b-a704-f3bf46faa2c9","509cdd4a-32cf-46bf-9061-87fd383f6da6","29f4ec77-37a2-4604-9bcc-2ce84dd4c238","97cdfa22-5b79-4c43-8b73-b7397eabdb7f"]},{"cluster_id":"45aa87a3-e21a-4aa8-8a63-439b67ce1a6b","members":["e06a7277-5f24-48fb-9c78-13c76be81e98"]},{"cluster_id":"e7164e50-d6db-4c47-8686-c55d8dcb20f7","members":["099d05fd-55f3-40ef-beaa-1a522d6addf7"]},{"cluster_id":"9e771d92-eea3-45ec-b1c4-e7bba0011301","members":["e350c53e-e396-41e1-817f-9304ad844ea9"]},{"cluster_id":"a418885e-cbb2-4205-a118-ea8172eaff33","members":["3e432faf-9460-4d1b-a841-fbe9839fbcbd"]},{"cluster_id":"46d65520-43a8-4278-8ef5-8956356cec61","members":["6995508b-5d89-4444-9304-cba0e41fae35"]},{"cluster_id":"7e70d266-a12a-4562-93b6-0506f079359f","members":["1f26bf27-13ba-421b-9231-cf226ab52ad1"]},{"cluster_id":"29bfbe48-82ec-4d12-8240-7206925d2386","members":["90bfad8f-ac37-4d23-981d-a31dffe2cb8c"]},{"cluster_id":"4bf58da8-6849-40b7-a8ec-ddb3570d0f67","members":["c3b90585-ea0d-4a8a-8dd8-5970b472f13f"]},{"cluster_id":"53d674a1-75eb-4a57-96a7-960a78dc2faf","members":["4b9f26b8-447d-4e58-930b-ba76b8681145"]},{"cluster_id":"9af760e6-eb03-4959-a360-3cdeab7333f8","members":["f6f240d1-76eb-49ce-9de1-39ad685f1451"]},{"cluster_id":"9cf8c4fc-8448-4503-a774-71dc4b331a69","members":["6a6acfc5-0af5-46ce-857a-e2904f2b9c4b"]},{"cluster_id":"d9ddd310-7175-469a-9098-9a1bbbbc4809","members":["4cd90b44-31f1-4a01-909a-4d4270ab2c65"]},{"cluster_id":"c1501799-71e8-405f-bf26-2801ae66dcf6","members":["5d67f516-3b5f-4d8e-89da-3d90721cd993"]},{"cluster_id":"e7e91720-5f86-4e9b-b765-89e7169207fb","members":["ea09b041-c617-47d9-a76d-d81079f36fd8"]},{"cluster_id":"dabb30c4-8940-4d2a-81d7-5e54195fcdf5","members":["9644246f-94cc-4458-8e14-564eb1d861e6"]},{"cluster_id":"da81244a-ef78-429d-9f3d-b08a5c21a084","members":["3c0b8def-ab2d-45ba-94a6-da76f2b7dd29","15aaf9a0-6288-49ed-8e08-6988a0f54955","e09c49de-0aef-4b62-a700-bb102432743b","50cb3fd3-25c4-48aa-8edf-a6d4c8f587b7","f358d4c6-9a93-47fd-94b2-0195a51d308b"]},{"cluster_id":"5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb","members":["d30e401a-ef55-4f7f-9712-cd9cf7cb7d88","2102a9f4-f2ce-437a-9e8a-bf94b26d2e85"]},{"cluster_id":"b5f72321-d879-4344-b131-82dc3d0c1704","members":["ac80f77a-57a3-47c8-922e-ed3cd647d0d5"]},{"cluster_id":"349cfacb-551c-400e-8c1e-7b08765e6799","members":["671c1c28-dc15-477f-9030-30d9ad77a14e"]},{"cluster_id":"7013bebd-c68a-4b31-9e63-8c86c5d8c784","members":["1f6fc9c1-12a1-4b1b-921e-9b373c2ef256"]},{"cluster_id":"63114462-4942-4f84-9437-7c2bd611b2f3","members":["28952f14-1d58-4bc1-9a8e-f41ecbb4a101","b643aa80-1674-4a44-bc83-91d9e5e86d80"]},{"cluster_id":"c7968790-1b36-4325-9e94-aa1c52a513a9","members":["edab6fc1-799c-47f3-8cab-19addfc4e3e3"]},{"cluster_id":"d53538f2-6557-4a35-adbb-a2eefd4e49a8","members":["1972c4cb-49be-4b10-a2ef-e3f2114602b8"]},{"cluster_id":"01d5ac9b-578e-460b-921d-2d1cc5ecad34","members":["d0c21fa2-f9c2-40f1-a260-4a254df804f4","dba5650a-2407-4da3-af31-96dc54bcb94e"]},{"cluster_id":"cd4a5f4f-0722-49d0-a0a8-588c6f486479","members":["f1960d27-fd97-4804-b057-6f7e9205cd00"]},{"cluster_id":"9babf1db-b81e-42d8-a506-b9ddc52bfb22","members":["729b965e-10e0-4396-a476-538b41bef3e6"]},{"cluster_id":"22b52102-7c44-49d2-93e5-9785e4c6b4d0","members":["fd6c18d0-24fb-46be-a977-14bd1261a91c"]},{"cluster_id":"cc789a67-807e-4a18-9da3-ebd2233fa4d4","members":["9a290797-749c-42ed-a67d-75d66083b144"]},{"cluster_id":"4a1c13c8-b1bc-47b6-9e32-b9200ffdf048","members":["f339002b-ff86-4405-a3c8-36d40f57cb28"]},{"cluster_id":"e47fa355-bcc3-44bc-97e3-0029cf946325","members":["5bbf7340-f31b-4450-acae-7485768ed63b"]},{"cluster_id":"228f2026-3094-45be-9c29-b363d30f00b6","members":["8626ca71-1e52-4c5f-8f17-9dab6c266608","6687c73a-8126-4a8d-87d3-e6ef4a4a7541"]},{"cluster_id":"66034097-f5ff-415b-b7cc-7775692bf89e","members":["7fd9c91f-c316-400d-85b4-090ac628f432","eabf220b-ccb7-4d7f-8222-41a150002c94"]},{"cluster_id":"652f545a-2cde-41d4-9382-f23ab9d1b406","members":["6a957da1-406d-4b72-bcbd-6596131f5345","c17ff997-a5f8-40a5-9388-6ea34db6656d","4f4ed72b-59e3-4046-aaf2-44942cd0b308"]},{"cluster_id":"b997c44d-2fc1-4d45-8a7a-f72d1b5a079d","members":["4efd2e64-a23b-485e-a038-428d2989b63b"]},{"cluster_id":"3062f8bf-848f-45a7-a46b-1596767052bb","members":["ea149bda-238a-4057-acdf-0cd761b1b278"]},{"cluster_id":"f49b5f7f-d1d1-43b6-ba5c-a712f59a657a","members":["ae10eee8-7eb6-4dd8-9f0f-947491a632cc"]},{"cluster_id":"a2124c19-e133-4d10-984d-0d176559c1d9","members":["07681209-6c18-43df-bb34-a99640acf3fe"]},{"cluster_id":"885d31c0-aa76-425b-b76c-0ebfaadd310b","members":["7145843c-da9a-4ce0-adb6-08bb4bf5900e"]},{"cluster_id":"473560b4-10a2-4370-be8e-3ebeae00ae74","members":["48f96080-2ff8-4413-bc68-8d45573e0ebc","b23955d7-beff-4040-9358-de291f6dad20"]},{"cluster_id":"5e19ce7f-9db8-4e0b-8a22-b9bd4624ed1e","members":["3da6910b-ebe5-4265-97f9-9acc53fc146d"]},{"cluster_id":"56a7af82-50cb-4d0f-a5ea-28ea4cda014a","members":["4af56b7a-2b18-4614-94db-f8baaa510c21"]},{"cluster_id":"4f145c90-9c3b-47cb-b38a-e643a9aa6e27","members":["9a68762b-1125-44bc-9ce8-f0066c271623"]},{"cluster_id":"0f38c468-09df-4db1-af76-875811609b3a","members":["d8249f1a-5fe7-4e68-83d4-bdb52e664065"]},{"cluster_id":"4b93a421-107c-4185-912b-a73d039895b4","members":["848bee8c-b8e4-4f15-b80e-8fe019b2f406","da5bdb7e-c330-4097-95b5-1c0cdf432346","ef40271e-1b78-4d05-a4a9-d2bb3d847704","5ab3d19c-52f3-4215-b630-51123495bc58","ccf3d3fc-0e96-4f64-b986-c8ae23e11ef5","9e2379f7-a83d-4952-bd56-8895d41335ce","8b34aad5-bf88-4f62-bdad-ef7da9225420","f44ef0e0-5322-4033-a778-bc956962c971","7ddd12d2-cff6-49aa-b67f-7dfa800c3849","c0fbdaf3-2a6e-49c9-8b79-ccaf2f5980ec"]},{"cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4","members":["a5560f22-1608-4dc4-b5e9-cab6fa9a2dc0","1106203c-1f11-4aac-adb2-d43dd7539134","39db8ebf-a9e7-441c-886d-4ce08a5dc110","29d71415-c815-4a13-bb80-4bc83e611763","6fcc605f-4d96-49ba-a217-c52dcb746b17","f5356c05-dce7-44f5-a872-82e02ddd286e"]},{"cluster_id":"a6590632-faef-4956-b655-28617cdf7601","members":["85aff665-3933-40c8-8e0c-8ff42c619c23"]},{"cluster_id":"cc658fb1-6da2-4d31-8ee4-f6cd436408af","members":["c58754c0-7dd2-4b01-acbc-26a6b8b444fd"]},{"cluster_id":"009b82df-6fc2-417b-9cb7-3440f511ecfe","members":["d1fe315e-4c15-48ad-8d28-30a44de19d7f"]},{"cluster_id":"ef0e0cc6-010e-482e-ad0b-63895cd13988","members":["ba15b1b5-c381-44f2-8797-a55499eeb225"]},{"cluster_id":"fcd590cf-7159-4dd1-af40-6a6c770d2797","members":["b4c5dcd8-e49f-402f-8388-945f21eb7598"]},{"cluster_id":"59d52e20-3aae-46e2-90cc-c6f03ba747be","members":["920ad18c-187e-4ebb-a482-e5b78de11c13"]},{"cluster_id":"222d1da7-5333-49e1-a4ec-9ca508fd278c","members":["9a17ae4b-8609-4a0a-bf32-9f7f03f3c630"]},{"cluster_id":"2a187430-0a71-47a9-918a-414338300232","members":["a3704883-02a5-429f-ab67-0b072f6a01b7"]},{"cluster_id":"b4df60de-0b59-4910-b93a-2f4eaa711964","members":["3a76259e-a1ef-4eb7-9ae8-cfd3f4fcc6f3"]},{"cluster_id":"e91640d2-fa8e-426c-a0fb-7b9789e054bf","members":["1de97582-9f71-4971-ba7d-d8f87885f543"]},{"cluster_id":"545b9a1d-6aef-4146-8dab-6da3637008a3","members":["a26d82c6-5a58-4bc7-a110-3dcb3a82fc08"]},{"cluster_id":"2bec49d1-2f19-441e-9c0b-01eed5568c41","members":["54354ec4-f53b-4fc6-ac36-595bbd78d95d"]},{"cluster_id":"b243dfe5-ad7c-4377-9402-0fc9aefe73cc","members":["8c8bf809-7919-42f2-a350-25605cb083b1"]},{"cluster_id":"35e5848e-7f2d-49f3-b00e-f1ac80fdf555","members":["3793e03c-452d-447e-b83d-c0cc8f5b89f7"]},{"cluster_id":"16aa2006-ba94-49b3-a83c-9dc2e8c8bf21","members":["c297fcb9-e09b-4143-822c-7e1d023e3454"]},{"cluster_id":"deecc1db-c201-4092-b4f0-f1a952dbcc16","members":["27b9463c-05b7-4f0f-9497-2876314c5a04"]},{"cluster_id":"96ab7552-d195-40c5-b31e-9af997302842","members":["e5b05f6c-bc32-4482-bb81-53d40b39c6da"]},{"cluster_id":"4823b0d5-067d-49e8-9415-62a09183548f","members":["8bfe5c6e-d1d4-4b6f-b140-776c1fa1d289","4a803032-82dc-41ba-bc17-2e372ad43c2a"]},{"cluster_id":"eac477f8-1470-4d66-9ef8-e279e7d85edf","members":["ec8c5f4d-a867-484e-80ac-6c81a9283a59"]},{"cluster_id":"7ad20f50-14f4-4cdf-b21e-0c9b5f397fe9","members":["72bc7424-651a-4c9d-9be9-ad3292abcb3c"]},{"cluster_id":"1afcda67-b75d-4fbc-802a-288b7fcc1fcf","members":["434bf18b-493d-4770-9c92-1fe63ecadd04"]},{"cluster_id":"e6f515d5-9add-4fca-a2f4-3869c847ca29","members":["4fee8636-34b2-4cc0-ba43-397c53506220"]},{"cluster_id":"7c1469be-22eb-4ba2-a540-efc0b0d4e00e","members":["f0412d5b-93cf-42bc-8fc5-f98147a51f9e"]},{"cluster_id":"ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b","members":["f0a85fe6-b900-4e90-8e66-572bdecff90a"]},{"cluster_id":"3789471e-0775-4ba6-92d1-141ca5051de5","members":["47a448fb-b4a0-46e6-991d-57294a9fee24"]},{"cluster_id":"3c5a3b02-4d06-4799-a8fe-9f59c0de51d9","members":["7164afa4-2a31-4d20-b9a6-e502eff8a2fb"]},{"cluster_id":"5bbc7620-dddd-48b2-ab59-dca397c2985e","members":["4f3686e5-d765-4276-9e88-28dad9622072"]},{"cluster_id":"003d2fc7-16f8-4835-a770-b85123b3c250","members":["8cd87dbf-abf3-458f-830b-3e2098fc7257"]},{"cluster_id":"8602d3ff-0dd5-4315-8d50-17cd0d22f5ac","members":["be6c17e9-3126-4a99-b1ca-12ba3fb536fe"]},{"cluster_id":"bf3cbbb2-0711-45ee-a625-a3ccf159845b","members":["6fdc860b-5d9d-42dc-b86d-6db1f215ec58"]},{"cluster_id":"731d7658-b5f1-4356-b7c0-c3b8c97cac8d","members":["63dc2a08-412c-4d37-aca8-5ea865e1119a"]},{"cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337","members":["00abef23-136a-4f82-b966-5af27dd83e4e","1063765a-03a7-4469-a982-301b089febc9","641967ed-c666-4b21-9632-a88aaa4fe896","92b8025d-d2b5-4360-bcc2-16c84a7cef8d","465c6fb0-520d-4a90-8ca7-5e568b69df28"]},{"cluster_id":"e5a3c503-081f-45b6-97d7-1fab2efba3f8","members":["08cafcf3-2032-4f80-b02a-ba109f879f0f"]},{"cluster_id":"0016bf55-313e-4918-9759-9210715148d1","members":["87c66622-6253-4bb6-bc16-c751d87a2c32"]},{"cluster_id":"fd17e83e-78c7-4b20-8834-c8e041abcbf4","members":["ade5df5c-bee8-45e8-a236-f3de837262e5"]},{"cluster_id":"e12630d6-f5b6-4dae-9bf0-63dd6b0528b1","members":["1d8c5c78-ea5d-491b-aaeb-1e9eb3d23fe6"]},{"cluster_id":"5a3adc2a-ea19-4c5d-b7f5-3df2a2a10371","members":["d7049be6-afc0-4f30-b738-0644dd7cfd9d"]},{"cluster_id":"388b5477-b8ee-43a6-9b4b-3bf87541cc1a","members":["7c9ba322-a838-4167-bcd3-92788ba88530"]},{"cluster_id":"a130a6d0-55d6-47e5-9fb3-2d64b90c9bf0","members":["81607614-7e18-493b-80e8-1de64c0a754c"]},{"cluster_id":"55299e01-297a-4bb3-aad3-784bd43284fb","members":["ff6e86bf-c27b-43f3-81c9-562060321b74"]},{"cluster_id":"532b749b-85ba-48db-930c-9199fbff3bbe","members":["9e8e0f65-b1dc-463d-b3b2-8da8207caf71"]},{"cluster_id":"5c983b2a-2571-47de-87cb-902a1970e0f2","members":["8c67b977-c7a3-46a1-b02e-bcc7e336a6e5"]},{"cluster_id":"aeb82733-bdb6-43c5-a151-fceb87e14ebf","members":["353854f8-f85b-4d64-b740-e832c88a249a"]},{"cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9","members":["8f013e9d-8c5a-4353-8c8d-a79d4122b7e3","86204680-fdb9-4340-b931-94cd92dad996","8c29246c-b612-4965-992f-1aae016849cb","403c5420-2e53-4a20-9b5e-e35280f8134d","2c659ec3-2327-40b7-86c2-5905cf7d48a3","cc6121cf-f17c-4f0b-8068-f9bedd0b0497"]},{"cluster_id":"b76141ff-47b5-4e35-911a-5ea99a13c31e","members":["ea97d934-450c-42f9-ba96-faa10aae7eb7"]},{"cluster_id":"5bb4fd2c-606b-4f16-9ca5-b9abb9dd5181","members":["9ed42510-3de7-453e-b41f-dbb975483b27"]},{"cluster_id":"f3ff4daa-4e28-48b9-8086-b9beac549c23","members":["675bdb85-f697-400f-8c7f-ed638f176b42"]},{"cluster_id":"14b94d56-73bd-4f9f-9a3d-89c9827b210d","members":["974fb635-cfd1-4b4c-8f0e-5fc7a4dd25b3","950a4afb-6b16-4452-8c32-f06391a6eb0f"]},{"cluster_id":"fb3fc0aa-b013-4537-9abd-dcd64258a72b","members":["b6dce954-c6ce-479b-8ca4-eccecbf931a2","cf1abeac-55ef-4d5e-b26b-6b043978f7a0"]},{"cluster_id":"e0e899a0-65d4-45b2-b3be-ff8320d1837a","members":["e629fd6e-2664-4427-806f-f053affa3ea2","25c6347f-d38f-4f24-90a2-eab32988fe16"]},{"cluster_id":"633de8a7-7506-44cf-9918-6f3f17934029","members":["281fac33-7327-4d27-9270-fa396b74f594"]},{"cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f","members":["4bb77a37-80cf-4bc6-b14e-c32ddaed77ab","f9ca1c34-8662-444d-8709-ffef60f2880c","7091328e-46d8-4bfb-9119-5c4718a72e34","2b508070-1d24-4290-aab2-515adf41a249","ae1ed688-55ec-443e-bf2e-95bb6b115680","683c1f14-e8e4-4de8-8dad-c9e3a47ec671"]},{"cluster_id":"2bd1f4b8-00be-4a69-ba1f-d23c0361c606","members":["81a32455-c62a-4641-9d18-34a0807e49af"]},{"cluster_id":"0a6e93a7-4ca1-4ae8-937a-93b0852204d1","members":["9f1162d3-4ee2-45b1-a94b-ea7e6ed8a86e"]},{"cluster_id":"a41257e1-1e51-49b3-bf04-5fbb3ef2f25b","members":["1ef7e7ad-9c74-469e-b411-3852cc693702"]},{"cluster_id":"ee6ffddc-d717-4a7b-a161-3d1bdc24c500","members":["5ff7751a-3797-475b-ab31-608a4dc57d3b","73dadb3d-04c0-4928-8c72-5c56df523380","bff99471-7e87-4f04-849c-7b2510eeda27","35dd7506-6f6a-4fc6-95fa-ce3448ef69ca"]},{"cluster_id":"b0b9c7b4-b931-48a5-9e3c-e3d43990149f","members":["70c094cd-4b0c-4efe-b783-c1d86fbd71a9"]},{"cluster_id":"31c80f95-812a-49ce-aa97-208d1f8f4713","members":["921da37f-25ef-46f2-9bbb-85d9c79411b9"]},{"cluster_id":"ad80cb2a-c356-4006-9574-67d0198ed537","members":["1509ac98-4f23-4822-828c-092344605aa7"]},{"cluster_id":"3b00f0b1-76ec-42b4-8949-3a408087b558","members":["59a4e5cb-be6d-4294-8ad4-9b78c05f450d"]},{"cluster_id":"36f9b8df-5b64-4298-b779-2814d4de3b9d","members":["e82b7ca8-3c7a-4a8a-88a6-bdbc535b0a1d"]},{"cluster_id":"5b003616-1a21-4fdb-b479-c710fbcc5926","members":["6452efc0-72d1-45b6-99ce-9f5ad68a2f87"]},{"cluster_id":"62e37c68-3e37-4c4f-b64e-4d353bb38fcd","members":["1d7c8c65-fed9-4af9-b8a7-583efe0c156a"]},{"cluster_id":"83c177c0-ee20-4679-ad20-0c32e24ff101","members":["eb18cff0-382d-421f-a524-e99822ad547e"]},{"cluster_id":"081350a8-a16a-45fc-b513-065a8ddaebac","members":["a821f2f7-8a95-48e1-8289-86096d5c2221"]},{"cluster_id":"75649ebd-9ea4-425f-b0b4-b2dc8db1c23c","members":["317b32c6-c05b-44d3-8cad-09ffa5710de3"]},{"cluster_id":"3a29dca6-ced7-43ed-9cff-367044251da1","members":["f64eec97-d14d-4a81-af07-8f416d6890d9"]},{"cluster_id":"ff3032ee-a77e-4fe7-a5a1-205c35f0948e","members":["a544e0c1-ed7e-491e-bdc6-50b79d4bf79a","aec2046c-231c-4694-b2e3-e33c096f3bbd"]},{"cluster_id":"d211ea4f-25c6-49b0-b039-be55cbe6e301","members":["8c59f029-fa4c-424c-8712-979198438f2c"]},{"cluster_id":"11ad6c89-9a64-4385-9a81-dfa3787cc401","members":["36aa4449-8818-4c98-90bc-fd2a05ea538a","015ad92d-8a43-4c86-8eca-57b3ed328aba"]},{"cluster_id":"fce3f86a-8cbe-4d55-ab8f-cc8fde0d8d33","members":["eb8db62e-651f-4c8e-b669-48a2c8d291e2"]},{"cluster_id":"22a6dab9-0118-488c-a537-5d58e3ff3a75","members":["277714f9-0805-48b1-aba6-c95997c08bbd"]},{"cluster_id":"1fdd9b57-6c44-4ffe-9d2d-90b7efd6fa20","members":["0418b276-b637-4fb1-93a0-12fc0f74d214"]},{"cluster_id":"7cd85d56-7567-4824-894e-168d86ff8ac7","members":["3c8a7cb1-f0ce-46d3-ab60-c06d45d6ed83"]},{"cluster_id":"2950776a-25e4-4d62-bcaf-01e56ebd5b4c","members":["c3f09444-e6e0-4d2a-bee9-15b6356fc404"]},{"cluster_id":"19ab8a7a-3e63-46b0-894f-04742e58ad8b","members":["10aa326f-e579-4f6c-bd1a-8aff80170494"]},{"cluster_id":"64c57917-e9a2-445d-b946-386aef313815","members":["c3172225-3693-4c6f-9238-7d90edfa3626"]},{"cluster_id":"ed1adfd2-5ca7-48e4-ae90-60f2fca59b2a","members":["a86f7c23-4981-42fa-b161-51fc78cdad88"]},{"cluster_id":"5d6a4e52-504f-48f8-b46b-8c506a9ab7ad","members":["f508aab5-c242-4d88-8ad5-2a725c9a324b"]},{"cluster_id":"833754ff-abfd-4996-b62a-92904373fd3b","members":["97b8430d-9275-46e1-8b79-3fb241ad08be"]},{"cluster_id":"5bde126a-9b98-4602-8531-f11f0ccfd92e","members":["ee067d00-c0b5-47d3-9029-8fd5486855f9"]},{"cluster_id":"5cee41d6-0e60-41c4-b25d-8f1605700435","members":["48b3571a-6ac3-44f5-9fe0-6c14f6140147"]},{"cluster_id":"468199d3-d972-44c7-826d-cc58f22c25eb","members":["ce9b33b9-e85b-4046-ba77-e5f1868c6e56"]},{"cluster_id":"0e976646-d8b3-435d-b262-71720e81ac06","members":["19027ae8-4e58-4278-9f4f-f2109718cadf"]},{"cluster_id":"4e53d403-5bf1-47ce-a5d9-ecd50db35ad9","members":["2e4da640-6c78-49c3-9e26-c35f40b8370e"]},{"cluster_id":"a7c4ae5e-cf5f-4676-a2e4-88e256aaf381","members":["97ee6eff-e540-44c5-90bc-350b44a7f2d1"]},{"cluster_id":"b94a7962-9c49-4a90-a9cb-480e580b3877","members":["114d8811-9be0-485b-93ce-1556c4af6efd"]},{"cluster_id":"e5a54fcb-cbc0-4fb7-bfbf-7530efd090da","members":["f94dfaef-eb1f-479e-8c8d-c45f782c213e","bb933fdf-bf4c-4870-a5f0-dd6bbdb1571d","a5716227-cc2d-487c-b4e1-90631c2bd7b7"]},{"cluster_id":"9e250f91-2983-4cf6-9b29-817f4271a911","members":["3140119f-8d47-4304-9e60-70eda24c916b","4d311c0d-a3bf-4639-886a-9ffc29181f73"]},{"cluster_id":"e294ae03-93b8-4461-85ca-920f88826e8a","members":["d4169ee9-5b6b-437d-8a9c-d6bda51ffd94","50e9b1a5-58e6-449a-9592-f8df840c444c","5f6be7fe-2480-4b8b-847b-374e45a86e9e"]},{"cluster_id":"9a0e60e0-9d22-43df-bc7c-6bb5028125f2","members":["d578f1e2-0edf-442f-8167-9730b07540ed"]},{"cluster_id":"86a1cb16-ab28-4b30-be94-ef12abdf7cfc","members":["80c98feb-aa13-4dbf-8e34-68d40b5993ae"]},{"cluster_id":"9dbb5109-6fdf-484b-92c1-ec8b1bba2a62","members":["97efe8fc-86dc-4752-8d07-932a84a1c46b"]},{"cluster_id":"ad2a393e-2bc5-4c0d-addf-577399b7b41d","members":["0baeefc1-adc3-4f98-b95a-d541cccf69ad"]},{"cluster_id":"c2686424-538a-4d1b-80b6-8a6f5e252d7c","members":["3afa542c-0bdb-4bfe-99c5-ec4f8c07f3eb"]},{"cluster_id":"a3e7173c-3ffd-4346-9259-1d6261818acc","members":["8a6ad661-4866-4e53-a06e-fc4454d38987"]},{"cluster_id":"d101520b-7082-47e3-b848-813e8165e6a9","members":["32db54f1-b369-4ca0-8b04-d474a4145f4f"]},{"cluster_id":"35008b59-14cd-4674-801b-6fc7e159bf31","members":["f464d68b-a2a1-43a1-b569-4d332d007b45"]},{"cluster_id":"4ae526b6-129a-4522-b79c-5fa5e53d2329","members":["558ff771-454a-4ef9-b800-b3b910ece8ee","fad7cf7f-dc96-4ebb-bc6d-b8b06657faef"]},{"cluster_id":"612db375-37db-450a-9941-cc2bdb1c5d4b","members":["e113e22b-2707-4663-a22b-b4c0f7bd2f1a"]},{"cluster_id":"70408cf7-1954-491d-98bc-f78c50c03508","members":["03751e65-146b-4456-8dc1-c7c36cbb9273"]},{"cluster_id":"1034b1f8-bfe4-4bc4-80f2-8e57922001cc","members":["099063c7-f4d6-452a-96b7-3cfbec499f70"]},{"cluster_id":"8456fa39-debe-4543-9e31-bac207d1861c","members":["db5fae7e-79b7-4b72-ac6f-4886e201988a"]},{"cluster_id":"1b781e70-c91d-4aef-8e8b-426c2c695555","members":["5182eb84-9e91-4051-97a4-a787da6915f3"]},{"cluster_id":"0a39d2f3-be07-4455-859e-2055e083eec6","members":["4e319c0c-fa97-49bd-8d1f-e297eb183d06"]},{"cluster_id":"abbb0c2a-4609-4a58-819a-928af8ad2bfc","members":["c1787c96-2590-4891-b3f5-806faabaad21"]},{"cluster_id":"f3c78c9b-df0c-4382-a6ec-56b924bce811","members":["e00f7faa-5d4d-4e79-8298-ad7c22d4d2c8"]},{"cluster_id":"4f70ac27-41cb-48d8-871e-5b61b1c5a657","members":["11a40aaf-f706-40cf-82a9-1a19cf63c3d5"]},{"cluster_id":"36abfac2-7b3e-427a-a2be-ce55f5472e15","members":["861b0fc8-2713-435b-9bd0-27cef9356563"]},{"cluster_id":"f43dba3b-7d34-4eea-96eb-854a495fe8e2","members":["4e99c43a-52d4-4367-8e23-2a3c8bd45a8f"]},{"cluster_id":"e9ec4305-aed2-424a-9a57-210fed19fa52","members":["8f90dc85-17db-45b6-861f-a79a145cbdfd"]},{"cluster_id":"e9eacbea-e948-4bff-8064-db4af871a9d3","members":["3293095e-b726-41fe-9e73-a2632666ed8a"]},{"cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133","members":["222d75b6-ccc3-4eff-bdfa-f2c7aed90156","7b92fc65-a796-422b-9443-374ef57581b5","ae975e0a-9f37-43c4-b84a-500496a03681","45371774-43cb-4e3d-847c-91c826a691fc"]},{"cluster_id":"1231d1d1-38bd-406e-916f-d7769d05b29d","members":["ea73dc47-9ebe-4398-8854-410ce744a766"]},{"cluster_id":"5b07fdf4-9b41-49e1-b97c-866f63e0da14","members":["d37b5259-c261-4f6f-9fb2-82a898d4a789"]},{"cluster_id":"74c516ce-db78-4790-b130-64ce1c94e700","members":["a7a9313b-3363-4c37-9221-69cecc02c7b7"]},{"cluster_id":"bb551e75-48fa-42c3-a108-cb4b1462b529","members":["8e8d6642-8a2b-41f0-877a-508b282f4111","64c4a54b-65dd-4e50-89a8-9a089b49855f","9e777542-e2c4-44dd-886a-c7f38f623a25","1b4f0df7-b4bd-4b1b-bc66-9bbbaf34be37"]},{"cluster_id":"31e7b652-307d-4f5d-a4a6-215892b2e421","members":["51c342aa-f495-447c-a741-0f62d5867280"]},{"cluster_id":"18fb4791-02de-4e42-aeab-ba0112d12563","members":["eae9effd-0408-4194-a055-2a43ac1db606"]},{"cluster_id":"d9f5ad2b-430e-4145-acd5-2d92262e0952","members":["322841cd-72a9-4285-a807-cc62848423ce"]},{"cluster_id":"91b36e51-3bed-4937-9f60-9c0f824e451a","members":["0af56191-0e0f-4fe2-b9e2-e821fd6db35c"]},{"cluster_id":"1ee9efa3-f349-4351-93b7-a5f37a7326be","members":["f8673471-5bf7-4c53-affb-4caa3100de22"]},{"cluster_id":"ceeb5cde-733b-478e-9e0a-21930e3f91cd","members":["5c352b85-72a5-4fe0-b247-e193012c1069"]},{"cluster_id":"00cb3646-a2c2-4ca4-9bd3-507a4d1eade7","members":["4323d9ee-e5be-4bde-bd6b-7fa02e8e16ef","afaeb14c-7c75-408c-926e-a3e8c8a836a3"]},{"cluster_id":"693c26f4-40f7-4d45-b4b9-51440f45735e","members":["167cd11a-7bd8-448b-8a6e-495bbd0f3fa5"]},{"cluster_id":"0a3dfd8d-a3b5-4c2f-8fe0-7e8a2061b362","members":["bb9d0cc8-29c7-493d-a706-4ce83cc9c18d"]},{"cluster_id":"9297f5a6-da64-4942-8c55-fea3e2f0fc25","members":["3a9774e6-10f2-477a-ab6a-cca67b1c16fc"]},{"cluster_id":"b2ea914d-85db-4a5c-9a1a-857c4092e4d3","members":["441e1bc0-70fe-44eb-ad34-0223b99e3ca4"]},{"cluster_id":"cc554329-dead-4eef-88f0-c2d38423ce88","members":["2f871919-d116-40c0-a287-e1eba8a48b43"]},{"cluster_id":"65719321-4c0e-421c-be0d-ae0fd54b036d","members":["917b61ae-ede9-4e14-9d70-7ec40dc181b3"]},{"cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875","members":["59154926-987c-4187-b208-3ac364e6899a","1eea5f54-91aa-4cd5-97e7-61aceeaf6eb4","45376586-0395-4dcd-b518-01cad0ca117a","a0290b8a-cab4-4576-b231-460d6fbba5b6"]},{"cluster_id":"eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268","members":["5822f032-feb0-4fca-a9fe-b0db5146f9f1","f426628c-d791-433d-9908-39f946c4bddf"]},{"cluster_id":"9348816a-379b-4a83-98b4-cd843f9d8989","members":["442ca6ad-3fc9-40f8-b29e-f5ebd7e26aaa"]},{"cluster_id":"c623ca23-8a98-4b0e-b365-eb9b3c1cdd86","members":["3269616a-cc39-4a25-bafb-f0ad27cb1b53","51d7de32-25b2-49d1-95bf-bab4d50c8194"]},{"cluster_id":"31a83c0d-3856-4e30-82d4-769416b594bd","members":["9ca8200d-6dc1-4f59-9e0b-189a5928ba6d","d67b8388-c5ba-4ef3-9f99-518f8e6b9ec4"]},{"cluster_id":"e86a3db7-1b97-499b-90f0-337a1d71a604","members":["f7e271ea-0a8c-411a-a7ec-e034b971ea88"]},{"cluster_id":"a722bc41-1d66-412e-b713-184ed31bb855","members":["5bc21564-4705-4f88-b5a6-3c76db8c6999"]},{"cluster_id":"2ba645ab-6f15-47c5-96d6-7989f0a29459","members":["3d6ca9ba-8938-41e5-a235-f30ae9f1bb9e"]},{"cluster_id":"65f95c9d-be3f-40b0-b287-d80a74be8b4f","members":["8d744fb7-6fd9-4ba1-811c-9de7080dc2ec"]},{"cluster_id":"04e5de16-d046-4bc2-878e-0b328f3385ed","members":["6c0d5bf5-6470-434d-a633-f24e61c3ddf5"]},{"cluster_id":"52b6d3e6-8588-4bb5-9bb9-34f52aa88349","members":["6210f009-184f-443b-b61e-725c791e1e92"]},{"cluster_id":"1f48fb6b-ea22-46f3-a429-4b537e306680","members":["af232223-fe84-4fea-9b31-bba82843063a"]},{"cluster_id":"8a51d448-3e97-4522-acf3-ca3a46ef7aad","members":["dc9e2ee2-6a52-44e1-bf09-83ac361b0ae3"]},{"cluster_id":"bd8ae460-e56a-44c2-a9f6-3ae3b4d65792","members":["54f3a33a-e560-4653-8566-3949400427bb"]},{"cluster_id":"87e0267f-e999-4f76-8883-d246a2dc113c","members":["92622502-9d1f-489c-91fb-e43fc2acf742"]},{"cluster_id":"aee60c89-f292-46d6-9573-19871764aa64","members":["cf603f33-34e6-4183-a115-e3ac3538ba4b"]},{"cluster_id":"c08c0c57-ea8b-4938-93c9-7d2934450835","members":["e7875114-649f-4e5c-b759-b863b64561a7"]},{"cluster_id":"7011451c-4136-49ed-9d09-6db32baccfc3","members":["2acea521-b0fc-48ed-88e2-b8f6da9aa180"]},{"cluster_id":"7e1892c9-2b80-4467-8d86-e0034e324987","members":["48218272-d962-4750-b578-752d4240e2e3"]},{"cluster_id":"34a1b7dd-030b-404f-82f6-074c42d07051","members":["93c43d6c-88d3-4dad-b18a-dd5596a062c4"]},{"cluster_id":"9d8e9597-3167-4e1c-94bb-e686324d37e0","members":["901c9158-8dd1-451e-89bc-9b3e6f7044ad"]},{"cluster_id":"c9780602-10a7-414d-9965-0df44aadba9b","members":["32022d9c-2c83-48a5-bc04-c8cc87a593d0"]},{"cluster_id":"3a31c97f-6174-468b-bab1-90d8acc21560","members":["07a56859-a3c7-4523-b943-001bfa91cf5a"]},{"cluster_id":"07b3b643-33f3-45b2-87a3-3626fa492cb3","members":["a390a2b6-e764-4521-bf88-b41e34e69af1"]},{"cluster_id":"f44c0c51-4b5f-47de-9ff7-9cd4c4c2b58a","members":["ddac4342-724b-4057-83bb-d517c82627bd"]},{"cluster_id":"fb065855-6920-462f-84b1-383a66822ef8","members":["0c4010c9-6257-4e87-bc84-a4b250e3d55b"]},{"cluster_id":"62c55243-573a-47e9-9c3f-afe131b6a01d","members":["1ca309d5-e3fc-451b-af76-e44786b894f6"]},{"cluster_id":"08168b1f-73c6-4a8d-80e5-08594ac2f44e","members":["39da4c3a-adf9-48d1-af3a-5afc6e3ac57e"]},{"cluster_id":"673690cb-9b1b-4465-841b-31fb50a8d527","members":["1c5e2b7f-64ac-4508-957b-adfe716ec6e6"]},{"cluster_id":"6ad8a14d-0296-478c-a06f-959ddf23a8b3","members":["5470ae14-4639-43f5-9525-c3f9199e1085"]},{"cluster_id":"878945ad-a11c-4c5d-8d89-5e5ce4911878","members":["a87df052-6792-4ff4-91c3-24581c4c4a31"]},{"cluster_id":"a2d0ea3b-d935-4c42-8edc-70bff4ecb269","members":["68f92636-4e3a-467c-8168-cd1c2eb155c5"]},{"cluster_id":"ab96918c-daa5-4c62-989d-c9617e4f6b5e","members":["1e919862-a394-4d0e-8f88-dbbc7c1f3be9"]},{"cluster_id":"92a82b98-f457-4ad6-9e23-e80c7e1d25f5","members":["068432ed-79d3-4c40-b986-0b9f52b2b854"]},{"cluster_id":"9f415e0a-a04a-4d8b-b01c-2d2cc94bb46b","members":["92de102e-5285-491c-92af-7f876326a055"]},{"cluster_id":"64112ad0-ee1e-4f16-b30c-2adabd7eaabd","members":["9312344f-c2bd-4729-abeb-af172a7a75cb"]},{"cluster_id":"5256265d-d143-4d8d-91b5-fc2bd6f31e20","members":["21f04535-1899-4f5e-a6ac-c45b5f9a784e"]},{"cluster_id":"5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98","members":["fd3b3d2d-9a82-43f6-b5e1-36eb81fa8ce2"]},{"cluster_id":"b3b646eb-c723-4a14-ac13-d0b7985ef11c","members":["affc1bd7-931a-41ac-8a4b-149e1962f5f7"]},{"cluster_id":"76836166-e9eb-4d22-93c5-16c83ebc5bbe","members":["98d9b1be-a091-42ae-a824-4add22826725"]},{"cluster_id":"8eba8ddc-43e0-42e3-8917-7f76c17baf39","members":["686243dd-c98a-4534-ab8e-261dce5d0be3"]},{"cluster_id":"0dde3660-e0d6-4644-aa81-6e184dc6e068","members":["73f2581b-78ea-4073-b522-f122ba21942b","65423e9a-1634-45dc-9d3b-214efebd0a65"]},{"cluster_id":"853910fb-7ee6-4070-a774-47b5fca3aae1","members":["ff5616f8-a79b-47de-9ac9-273996d50120"]},{"cluster_id":"1743784f-0949-4ddb-93e5-a1fd3954d25b","members":["ad5984ee-a3ad-4ec4-b4ce-e130c1f67d09"]},{"cluster_id":"d33cb6f1-20b6-4555-be5a-7f0455de9471","members":["28e8f541-e8c0-48fb-bce9-3fb0dd399191"]},{"cluster_id":"42a6504a-75a7-4c6b-8491-655e6c73b864","members":["a742fb45-a461-43bc-b476-456e8ad028bc"]},{"cluster_id":"3765cbfd-a44a-49bf-b7ba-3bd606b4f80e","members":["cf4cac70-1fe0-44ec-afd7-3d70e3d867fa"]},{"cluster_id":"3f0053e9-5dcd-46d0-a2b7-d6cbd40dc3ff","members":["456df9fe-30b3-4415-9a39-52064e0cf327"]},{"cluster_id":"f9c1e4b6-836b-439a-971b-99d6ec437f1d","members":["ca91c933-ac95-4353-bb69-1d9f393a79c8"]},{"cluster_id":"3dfdc081-40e4-4a34-81ac-79b539cfc98e","members":["b17c0ea0-45a5-493f-91f7-b3daebbaf959"]},{"cluster_id":"b20a6598-dc24-40bc-a9eb-7fdc252fc7eb","members":["91ad4b59-ea33-46ae-8242-9b46c76403f7"]},{"cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49","members":["098aa029-ec8e-4883-85bf-bc46490bd379","e2e9ccf6-55ae-4c59-8a0b-d4e161dbfff1","41b1eb86-1e6e-4c67-9ead-477dc17e5c3c","37625bdb-3faf-444d-96c3-044a6680cd29","95c58021-765b-4340-8db8-45534f0753f7","725f30c6-6356-4be4-895a-af950908eac5"]},{"cluster_id":"248cf9f0-85b2-4eae-9028-789470700e69","members":["42d52141-5e88-4a4d-962a-82996e2d62a9"]},{"cluster_id":"af90686d-77e8-4713-873e-8c63e5dbe370","members":["7da97a72-cae2-46bf-99b9-531f8be4f1b1","48ffe91e-06f2-4568-87a2-8fff684bd1d7","98086365-8b60-42af-8a68-2b1e8ea49daf"]},{"cluster_id":"bbc9b8d3-6b58-4072-82ed-eb3aad9d21a5","members":["34c1ed12-9336-4757-84db-c8b93a27ce8e"]},{"cluster_id":"9e59aa88-1912-40bc-b111-4817591aae4d","members":["6f28a2f2-e539-4dee-9855-e6a65ab9e0a6"]},{"cluster_id":"3871454f-b8ca-4976-ba58-fba8307b403e","members":["af890a05-332e-45e2-b324-34148f8f8edf","fa1d9e95-860b-4b4f-9fe0-314d79b493c4"]},{"cluster_id":"357af95d-b02c-4002-bfc2-fdd9ff848257","members":["49acb213-a59d-42fa-9fc4-f619d8791ba4"]},{"cluster_id":"382c8bbe-8826-4b13-8317-0d73ee7eee77","members":["45e42270-f505-45f5-b918-6b0cda07bcfa"]},{"cluster_id":"03d03c63-2946-42c4-9a55-b127fdc45b21","members":["0d9fc4a0-5fcb-4860-9631-c7f6c920d7d6"]},{"cluster_id":"a80f445d-229b-4be7-a694-df00afa0ebff","members":["7e25a76a-37bc-4cb4-991b-75ca8cb4db06"]},{"cluster_id":"91a65b39-ae74-4a8d-812e-5ba1c8563d2e","members":["4454f0a8-ec22-4cb4-ac30-1ae88c0d8026"]},{"cluster_id":"31e15131-0797-4dd4-9297-5c40959ea3ba","members":["50270f49-40d5-4d8a-865b-719e919b380d"]},{"cluster_id":"512979c6-163f-4fe1-b34a-1c4e466e4650","members":["c14565f6-e945-46f4-a565-20182e7bfb5f"]},{"cluster_id":"56d8e5bc-dfb0-4e57-a911-a8a552ba1562","members":["fb35e2a8-7820-467f-9f02-501f5db2d4ea"]},{"cluster_id":"309e6017-5ba6-4aa5-918a-e978302b6d2d","members":["b2a9a693-2f1e-4e6a-979d-58fca7b6cc79","0512a5fc-5926-412a-8411-346f9bf0b7fd","8e1fa647-3216-4dff-87b3-a454db279570"]},{"cluster_id":"4a709253-d61a-4103-b072-d16f3cb55d28","members":["d901f911-ecfa-4d16-b71b-5d064dca9f25"]},{"cluster_id":"fad57477-d03d-4801-aeb1-50224d171446","members":["21308ad2-ed8c-47ad-91ea-7d57d9647a29"]},{"cluster_id":"ce085679-ae85-409d-b3f3-afb9e8562a5b","members":["bd61c7cb-9e37-4312-a09a-5d9c22333eae"]},{"cluster_id":"ab8af083-dfdc-4c18-95cd-32d551c130c1","members":["545e7117-772c-412b-97f7-6e5cfd8279e3","80aa0218-4894-4d93-9036-99596d3f9805","e3500067-58e5-401e-be62-6ac02afe5f68"]},{"cluster_id":"8e9141e0-2f9d-4d0a-920e-7ed046dbbcec","members":["9541024e-78b4-4a7d-9a0e-e5d0a23547c6","e513feeb-a471-4ce8-94c8-d0308e293d7c","569e374f-3c1a-41f9-a0dd-8382fa562bcd"]},{"cluster_id":"37a15ab9-c9e5-493e-bc55-f1d64743861b","members":["d8922da7-0392-43c3-9ff9-6852d5dea24c"]},{"cluster_id":"88b529dd-6a84-4eea-a385-80a5f7c68b68","members":["2e715436-fede-4a04-baa0-2533450430f0"]},{"cluster_id":"6fad579f-d261-4337-bd5f-1776b8d945c8","members":["2bef7be2-37fe-4ae5-b341-834d95218f44"]},{"cluster_id":"2d972490-4937-489e-9570-c5d28d63e725","members":["825d43c3-608a-4dec-9135-afab70108a23"]},{"cluster_id":"e0cfcc7e-1525-454e-82eb-71402504ae5b","members":["22fc4451-39a9-429d-b999-ce653efa4de7"]},{"cluster_id":"ef77006d-68d7-4c27-ae83-cb85890ca2b1","members":["9ff538ac-8666-450c-a6f0-7b725a52bbcc","70fab0a5-9570-4e18-aa9b-2a40a0ffb0dd"]},{"cluster_id":"f86db310-987e-41a6-a2fc-6f6bb14b7072","members":["f5b27817-344c-4cd3-9b2e-52fdcecb069c","dac7a8e1-5257-459a-b46d-a95758256fd2"]},{"cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6","members":["1d0ef9c4-3fa5-499b-842d-f166010dea71","2125bdb0-7204-4e0a-91d8-28499c435729","97421821-e331-46dc-ba60-d0e6f36dba4f","6b5be610-f1fa-4824-913d-7a70777884de","d45a26ec-741e-44f4-bdb7-f46d3f67f74f","a67870d4-bdaa-40e8-8ed1-3008ad93ff8c"]},{"cluster_id":"3989418a-395d-4448-a748-f8cca55ad517","members":["87e7d153-c4a2-4274-ae4d-e0c5a470e7fe"]},{"cluster_id":"608932d5-1e12-46e3-a718-377dfac71e8d","members":["5d91096d-88e2-463c-b965-592ebc181a91"]},{"cluster_id":"fdc48ebe-c88c-4c2e-883d-95e1b09e9ec8","members":["3ab432b3-1325-4c73-923c-07971b892798"]},{"cluster_id":"ce2d06aa-e26f-4ec8-8402-545cc5537de0","members":["bc17fe6c-6f26-4257-9fea-1bde09ac2b15"]},{"cluster_id":"dec5b760-e9f3-4528-b5d8-c2638f4598ab","members":["8e6dfbb8-7653-496d-a494-14f06c6a9619"]},{"cluster_id":"4f0f5e9d-5d96-4785-be2a-db5660d98439","members":["8e6ffcb5-2935-4da8-a2f6-37ced68f793b"]},{"cluster_id":"5b53e66c-0bb9-49bd-b149-91ceadd51fb9","members":["6329a629-8785-48c9-a520-51679aa960e5"]},{"cluster_id":"505d0868-59a0-4692-bf8c-7c412af4f91a","members":["4aef59f0-2f8a-49ee-aa33-c47e66af31b0"]},{"cluster_id":"dfc393f7-ef26-4ee1-ba36-c3a68f72795f","members":["99054d96-5995-400d-a538-9d426409a010"]},{"cluster_id":"67a5aa36-56f0-43ce-bcd7-a10ff634cd7e","members":["aad7e35d-8b80-43cd-b1f2-98b0b18220d7"]},{"cluster_id":"a44b23b8-a3e3-493e-b038-fc26f5c96d31","members":["e9e5908f-edb5-4e1c-96b6-ae50ee50f43a"]},{"cluster_id":"b6f98e35-378d-4bca-93ef-5b980f18f2b3","members":["2ce347ab-01ce-4b4e-8d58-fc0e04cf8b5a"]},{"cluster_id":"252647f3-b2d0-4fb9-8a73-8d20e5a61e96","members":["7907ff43-49d7-47f8-9ce0-20f40065d975","a159547a-4af7-4274-b801-e11db333875c"]},{"cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67","members":["4c6e1739-a25f-40f8-a4ea-6364e45bb003","211749eb-0c84-433f-8c5b-67d3c20b7c6d","834eac6b-77cc-451c-be6c-d70471e32525","31783125-f695-4dd2-b83d-e9c62dacc5f6"]},{"cluster_id":"1e061f92-2688-4d15-8cdc-93767b97df6b","members":["dd58e7fd-f420-4f6b-aefc-7a5dca83b488","952a8a66-4769-48c9-a0f2-2a80794fe380"]},{"cluster_id":"90ab0ebb-511c-4032-8a6b-928969e4d009","members":["e2d23983-7667-4870-a6cd-a7d2d20d2a5e"]},{"cluster_id":"e20487a3-4fd3-48eb-b5a7-8bf0da331808","members":["41a2a877-f1fd-4480-8fdb-278293229f68"]},{"cluster_id":"2007b8f4-ae8f-43aa-a61a-6788fb1351fe","members":["6833344f-17e5-418f-b9ef-61fdf01954e9"]},{"cluster_id":"705d1ff1-cf3d-455b-8c22-31feaaeb943f","members":["069aad17-1ac4-4f2c-9eb3-8efe16201b92","d8854f92-f1ea-44f0-9fa5-20817a1a5909"]},{"cluster_id":"d5777d75-d1f3-4884-9f6a-615b36a875d0","members":["11f16641-f62e-4de3-81ce-e859e15762af"]},{"cluster_id":"d74329dc-5b82-41ba-94bd-2cdd8306d3ee","members":["d73cc3b8-a1d8-4ac5-b390-0139a4ecdb07"]},{"cluster_id":"db3b032b-6eb1-469a-8fea-f26d907c46cc","members":["85fadf01-a4ad-4ed0-96a4-462d215554db","a661cd4d-5ccb-4040-b44c-68d69c09f27c","27eda906-14cf-4632-adc3-d243f4fd4936"]},{"cluster_id":"f957765a-9482-4d2f-9d6a-a1c90e6281d6","members":["9f7f3797-8aaa-4201-81c8-c842f8a53406"]},{"cluster_id":"7a4c0ada-5901-4c50-be04-047c13f1ba31","members":["1e88b0e6-9700-46f4-b372-9747c0551bcf"]},{"cluster_id":"1e5040f4-1599-4a16-abf2-bb352e20053c","members":["26c377ea-9aa0-4ae5-a5ff-c70b5b9b037b","2e8e07ef-cd9d-4f80-b243-70a6bca9511c"]},{"cluster_id":"cab4447a-5d42-4fe2-b9b3-fc86f17d0ac9","members":["14b0574a-5497-4884-bec6-520c0f7e187b"]},{"cluster_id":"f0140bf6-12ff-43a0-8d3c-60ad6ec418af","members":["eb701ce1-cfe6-4f8f-9fa3-89c1820a7a0e"]},{"cluster_id":"1ed52c55-1d90-4460-9e88-861e6d435eee","members":["290f965d-5be0-464d-bdb8-163c06a62841","4200e86a-175f-47da-99cd-bd8e9e246de6"]},{"cluster_id":"d6d62bcd-4470-422b-bfb3-13d5db2da751","members":["9171e567-8474-4dc0-aa10-9b5430fa19c7"]},{"cluster_id":"212b2ba7-fb93-422b-bfc0-bda99de8b498","members":["7f30264e-f0a8-4066-90b6-0e6cdef570cb"]},{"cluster_id":"82ba7adb-7963-4264-baad-21315bacde1d","members":["488f65ef-7ae2-4e77-b989-9babfbb5e805","9f5d5685-ecd4-4a38-8303-f36d9c747912","a0a4f554-0227-41a3-b9b5-71d79a79b103"]},{"cluster_id":"2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194","members":["7b0ceb79-47c5-4f55-9476-3abeaeefd7d9","23e62940-8b17-4720-ba2a-14719f390727"]},{"cluster_id":"fbce63cc-2f89-4118-a74f-d93b0d57a756","members":["1f294a78-91a8-4caa-9aa1-e9b461ad1138"]},{"cluster_id":"0c639465-7159-40b2-869b-06840b83505a","members":["982cb1ee-fd21-48f1-8a3d-bfd40e3429d6","ff6cae56-e952-42b3-83a5-9ac9435224e6"]},{"cluster_id":"88fa31fb-364c-47f5-bac4-4ecea848d93a","members":["2d919daa-b594-4887-9ca5-f369a56561fe"]},{"cluster_id":"8366909c-b1ee-46fa-ad8d-775e130e5096","members":["2f078d96-b20e-4413-8048-be0643f7af7d"]},{"cluster_id":"9cb46e58-ec9c-4071-b505-f4806f5522e9","members":["c9b71fee-b2bd-4e51-bf29-7781c2e90c97"]},{"cluster_id":"d18315fd-bf62-472b-bd6c-313e812011cc","members":["b3aea6b4-75f7-4ddf-a535-2c6ca0fba585"]},{"cluster_id":"c06d1b4c-ebff-4c43-a158-e1cf96a68d7f","members":["c5c28d20-4097-4e54-a9b0-4de1dcaaa54e"]},{"cluster_id":"a4d6044a-4bd0-435c-beb3-a719ddfd1f0d","members":["1cbab3a8-5125-41f5-a425-e491a7ed893e"]},{"cluster_id":"4367ebc4-e97e-4992-a822-025c7b42b1b8","members":["00e0bfe7-02d5-4c5b-8823-5a7b0a8cafe9"]},{"cluster_id":"b43cd636-593a-444c-9022-279eedcd0450","members":["a7e56323-9b45-4421-9a5f-ac7b55680d47"]},{"cluster_id":"a300ef79-1ea5-4eb4-b149-74426ea09a66","members":["81e24f29-a832-4e4a-a3f3-9ab6863e259b"]},{"cluster_id":"178a55a6-f879-45f8-85be-38fbb568a251","members":["3e77f882-da44-4f36-827d-0efb5922246f","855fdde6-02a6-438e-9904-7d2c5d4f57c4"]},{"cluster_id":"a608e3f3-dce6-4fd9-9684-b60e35b55c85","members":["fb2493b5-37a0-4fd7-be13-669c7eca68f0"]},{"cluster_id":"25f83819-e436-47d4-a6ab-ce489fc70293","members":["c164484f-230a-409f-9758-d9661a1dfdbc"]},{"cluster_id":"a174fdfb-5e90-4340-85c5-f1498bd04f82","members":["b69d524c-6494-4c32-8608-033f7422210b","bb93d367-6956-436d-996a-599f0fa232f7"]},{"cluster_id":"b175f6e9-a72d-4057-b833-76aad93255ef","members":["1216cb70-b558-48b1-a035-c50f00f83f02"]},{"cluster_id":"fca8c069-2da0-43e8-8cac-08662970bcda","members":["d4cd80eb-eaac-49af-b68c-dc1b44a1d8c1","c51b41b1-9760-4339-854f-287b00ad0c84","65c1d41b-b2cc-460f-a33b-8c41a52344be"]},{"cluster_id":"7e336202-10f1-4b91-9736-78eda34d2dbf","members":["7c04ae5d-4a31-4b8d-9b2b-48941ac82d8e"]},{"cluster_id":"f54fdd0e-ba75-4fde-af1b-64b83311ab6e","members":["317ef0dc-064a-4eec-ad55-b8802b8eaa8b"]},{"cluster_id":"26e9ba08-6532-4ec2-802f-bd0940d07dcb","members":["de1aef64-ff12-45b5-af12-ecc0c0e0dd6a"]},{"cluster_id":"b3d06a2c-7adf-4967-b1b6-b69e35711ca0","members":["0f88ce35-bc1d-4580-9fa2-5a62b51ad3ff"]},{"cluster_id":"d2b4f80e-7d68-4944-98c8-306c2b192c15","members":["0a3948be-fa4e-4cc4-acb8-1d150f116106"]},{"cluster_id":"fdb454eb-b6d8-4e69-94d9-d465733df395","members":["f234ae8b-1609-4236-bc79-01d2349b02fa","305801b7-d80a-4635-87e0-37b6be94a5dd"]},{"cluster_id":"448377aa-104a-47c8-b987-d7ae3a311686","members":["21599273-58f4-4ab5-8c60-a98236a967d2"]},{"cluster_id":"dbc38a4c-6662-4d84-ac44-e5687dc9ef37","members":["25d1f51d-e212-4b08-afdc-65ff45ee0f4d"]},{"cluster_id":"cf3bf537-5d66-4200-ab53-fd6a34c1b11b","members":["e458de25-c9df-47f0-afe6-1796e559fcb1"]},{"cluster_id":"4194b8ef-5709-47af-9e86-ee10aeeb4788","members":["e6db8dbb-15ae-4e34-8aca-fdf86f5b9ebd"]},{"cluster_id":"21b385c4-010f-457b-bf2e-d3d6a55a5ca1","members":["c527f6cf-f471-410a-825d-64d88a963398"]},{"cluster_id":"a20fa4a8-bba3-463b-b15a-06c8b4daad85","members":["ee5d46b3-019c-4079-a705-d2dfc0d8995b"]},{"cluster_id":"8b4dea1f-81ef-489e-9aba-a19d5e926009","members":["011dd188-f1c1-4ef7-9cf4-b23255a9d81d"]},{"cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638","members":["ae04373a-93b5-47da-9a0f-0e8036c84fd6","a0b81173-c01e-4db3-8d19-28bc14e6c940","0e2438b5-a88a-40f5-ae90-35c5e5255069","3d02c32a-ad40-424f-8606-b4f8dfd8d519","98efc04f-bb71-4262-8754-21a2dbb96c1b"]},{"cluster_id":"8b0583af-b0d6-4ff0-b992-807e026b5368","members":["a31e1259-d292-49ef-94fa-29c7e8cd09db"]},{"cluster_id":"d6c38bd4-e404-4cb6-beee-cca25c7586ab","members":["e79b0b35-8d39-4282-b94a-f53bee81a959"]},{"cluster_id":"1f127567-1266-42ac-9246-3f7f8bb52a6b","members":["fd77cdad-ac76-4700-a8ca-f00ee60425bd"]},{"cluster_id":"19de02b2-6078-4f7b-9502-207e4c4f5e72","members":["e2a21ea9-3308-432d-8ebb-36f2b2454894"]},{"cluster_id":"acad8d82-630a-486f-9b73-624703b74a12","members":["646a3db1-5b56-4be1-9ced-855abb1cfc03"]},{"cluster_id":"a24aba28-4a37-469a-9d41-dfd554a4594a","members":["744b28c1-e44c-4d91-afb4-3e9432206ea4"]},{"cluster_id":"21533f1c-ae42-4579-91e2-803b34beb003","members":["b13b8ba6-a597-4fbb-8b0f-2e3bd1ab8cf9"]},{"cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a","members":["cd094e65-a841-43b3-9e0d-41d503722dad","e530d934-99db-4543-9afe-a2d89c6fc26f","bc81656f-dcd2-4cdb-98cf-067c7fe2086a","e3d31e50-cadc-4608-9267-4e1ae603cea0","84f271c8-1fba-4ded-a316-c79332085a5f","8556b458-d003-4b29-9c94-899b30ca4564","9f61cba0-938a-4422-abfa-db301ff868e1","7eebea58-eccc-43d6-9605-78c5068074fc","a084da89-c83b-4afd-b54c-2a8112ec592b","363468c4-86f4-4e0e-93e1-66b5ad465c7a","dde15ad3-c3ed-41c9-9c7e-212a0268b2f4"]},{"cluster_id":"4f2789db-45a0-4f05-86be-a25e7794e0d7","members":["bdbc72ed-e397-4bcd-b6eb-2f5ea4b6c477"]},{"cluster_id":"ac17d012-fb03-4978-afab-d0ee9527705d","members":["782598c4-3b71-498b-91e6-1b5df6772bd2","79088632-2935-4ce9-9241-aa7bc44d76ba"]},{"cluster_id":"0829b680-8676-4565-bcc1-70f1f8778ca5","members":["bc6770da-14e1-4f86-9e0c-dafc0b7fa65a"]},{"cluster_id":"b7f11387-382d-4aee-bfa5-1f8b22da06c2","members":["ab1b4aca-b869-4d1e-9822-0200cd4f4d27"]},{"cluster_id":"86571ae0-c94d-4246-a1b9-4b9547fc239a","members":["5a4298c2-30c7-43d1-ad99-2ff20e2ef3f8"]},{"cluster_id":"0ca4759c-9c4f-421f-b2d0-dbefe4601911","members":["90ef5e33-2377-4289-845e-3349a31525bd"]},{"cluster_id":"8d1da449-ead9-4d20-b9d7-330964de7727","members":["1fc8ca06-ea64-4a71-96be-945d2e3a2895"]},{"cluster_id":"fea07608-613d-4c2c-b77c-a335119ce351","members":["2a0a6670-7ba1-4904-9910-0e88353ed5b8"]},{"cluster_id":"ea73cbad-05bd-4c4c-8cae-169119be8355","members":["0edbfb46-f456-4efb-881f-2b34fc87b18d"]},{"cluster_id":"f677d3a3-a108-4585-8030-41b82d49252c","members":["7abbfcf9-ee39-451c-a75a-35ff181a3d15"]},{"cluster_id":"c44f1953-a41f-47e0-ba2d-7e2e1a5e8ffd","members":["0c91468a-2a3c-435c-a993-912dda8a7cdf"]},{"cluster_id":"908eb720-8ab4-48f5-a6b7-fd316c77c27a","members":["9f70852a-2701-4ba9-9d9d-97b130038454"]},{"cluster_id":"1380f196-a8b4-4593-b276-1ee4b9b19dc0","members":["49e89fad-7de0-4303-8429-105554aaaf25"]},{"cluster_id":"3a1c123d-a3bb-42e2-911f-77ddeb67d2ee","members":["9c35ac88-ea62-4815-b760-c00c9c418ca3"]},{"cluster_id":"e3df2907-4da7-4352-a8ae-dd0543915bd1","members":["d340a967-11d6-4e32-9f59-5546d3b71998"]},{"cluster_id":"2f956586-babe-4398-aff8-0787b3e3a21b","members":["530384a0-da14-4c11-95b2-1d4601ad9ad9"]},{"cluster_id":"017489d6-d7b2-4b12-8669-3769c4704bdd","members":["ab204757-11fb-43a8-aa32-1e0a1b33be3f"]},{"cluster_id":"301dd553-d836-4dc3-8b50-cd3953d38a18","members":["2cceeef1-da92-4d2f-bda6-aacbc8937b8f"]},{"cluster_id":"41a86152-c66a-450d-8bf6-edd50f6928b1","members":["9543425d-8280-44dc-aab9-eeef9487b257"]},{"cluster_id":"428b927b-4796-43a8-8135-01b21725b127","members":["e9c1f3d6-96e3-4d8e-b076-fdbba6676c29"]},{"cluster_id":"fec39a26-1bf2-4183-bcb5-a33cc47fe4d3","members":["f58e959d-deed-43a8-af64-556af3a0477d"]},{"cluster_id":"836ea24a-dc8d-4499-b021-d9c9b600cc60","members":["3f30c01d-d5b9-4759-8745-26f91c87bb64"]},{"cluster_id":"5a784d1e-f3a9-480f-aa31-7625b9b944ce","members":["c56cb11d-788c-4728-87b2-17d8f03e5a3e"]},{"cluster_id":"1961443c-3bca-4540-a19e-508d4a0fa916","members":["4214672a-562c-4d52-ba43-6fa945b92796"]},{"cluster_id":"ad63a5c7-e4a9-4703-80f2-827fc6b1bf0d","members":["6069bc47-89a4-4c4e-a60c-566e62b21b14"]},{"cluster_id":"89133653-febf-4b4b-840d-0cb05ed61f86","members":["a5a64808-a7c7-4661-9b5f-05ea7b2697be"]},{"cluster_id":"ef9e5931-dbe9-4ba1-af73-3f6fcb8ed6f7","members":["b1076592-2fd3-4abb-afeb-f82699e4392d"]},{"cluster_id":"5d2d76b5-bc12-46bb-8cc2-844165ffb7e7","members":["0274fac9-ff73-42d8-ab6c-f9706fb26bd3"]},{"cluster_id":"3fab82c9-6db0-4a96-9fa3-7e0add6da8ba","members":["9de7a865-05de-4bfd-8512-7931d7ede270"]},{"cluster_id":"98c5d764-86f9-4cd2-ac58-1dae1f5811e9","members":["85b0b58a-88f4-44f0-9cb5-3b591e53a1e2","2a611ae1-745b-4bb1-ae10-25288b6cb9fc"]},{"cluster_id":"028ee870-e258-43cd-99d3-f13e457b70d7","members":["6426368d-5503-45b4-825a-3f6508459459","d2dc63a2-a2b0-46f3-9c28-22af90aa8310"]},{"cluster_id":"fd853489-07e0-4489-8d20-abb8f80a4213","members":["496b698b-bfc6-48ab-b701-a0216bacebd1","127c55ab-a974-4e8d-9a9d-a68dd053e4ab"]},{"cluster_id":"f3affcd0-acdc-481e-ad0d-c22c5984f9af","members":["a64f47b0-62d9-4146-8c80-840ec0985236","284bc88d-467e-49c3-ae5d-9caf059afb7a"]},{"cluster_id":"82261ab3-3caf-4c24-ac0e-14c29ebf6f44","members":["fdae4493-7214-4d22-9884-468e8433f272"]},{"cluster_id":"04fe8e71-8c72-481f-a6cf-1722df9454dc","members":["f9f3a1dd-044e-4347-853e-d47068e767c4","efcfd10c-3281-4c5a-9c0a-b8ea84055f5c"]},{"cluster_id":"3a4ae54e-e7b7-47e9-984e-62601ed45ab4","members":["4d20f04e-00ff-4651-a852-4ea4214217b3","7af4f83d-eee1-4b0a-bd8d-b156233a65a2","3866f289-5721-43dd-8f2f-d438225475a7"]},{"cluster_id":"b69dac95-ca24-49e5-b472-f36e5a0721b8","members":["692bca93-f602-436a-b0f2-d5cbc808bcc1"]},{"cluster_id":"35b184f1-0b55-4cee-b0ea-dcbb0d7633eb","members":["eaab707c-78cc-4a71-a3a1-6e58581e9572"]},{"cluster_id":"7050bafb-b05d-4691-a1ac-89175bc41e54","members":["0fc411dc-0366-4f41-ba26-7fe26283c363"]},{"cluster_id":"6fd0cd66-7572-4a5e-b9bd-53c174988cbc","members":["8df6167c-43a9-440a-83e3-dfb9c10de779"]},{"cluster_id":"baf69b75-285e-4447-b574-0c5bce010190","members":["fa07cd5b-e83f-475f-b9ea-4ba0d373d5e3"]},{"cluster_id":"dd07650f-5b24-4fc1-a78a-9b6fc6589ccf","members":["08fe87ea-bdb1-49c4-ba4a-8da08b598af8"]},{"cluster_id":"ac48c971-5c1c-4044-bc6f-2141fc11a1f0","members":["44a4cc47-ac51-408f-9d98-3af60f221d5a"]},{"cluster_id":"68995fc4-d783-494b-a9d8-283e32c04543","members":["661bc774-cfb7-442b-b04d-b60a9966ae4a","fd059fa0-37b3-4fc9-94f9-4d06b4db41a8"]},{"cluster_id":"16e3503e-05e1-4d3f-9a7c-01b21a85311a","members":["fce93629-dc10-4e52-8b7b-bba9217858c3"]},{"cluster_id":"0ab67aa0-2db3-4a91-9f5f-2305bd1d90bb","members":["8f85a016-f869-4492-a3bb-e9764dff12fa"]},{"cluster_id":"1a1de2a4-159f-4a0d-8a46-97165bf27583","members":["aed65ccc-f1af-425a-893d-9abd19f90a0b","541d6546-06db-4a26-9bdb-a6bca271336e","406b1fbe-7199-4fa6-aef8-6543f5fb49a2"]},{"cluster_id":"2077703d-3e6d-40f8-85a7-39edc747b3a1","members":["ea903ec9-a353-49e9-8bfe-6fda508a4947"]},{"cluster_id":"b93f0980-3e05-4353-b9af-768e6f562f26","members":["b52a5a04-4c42-47d9-94b7-248dd3212a3a","0acc9dfe-649c-470f-ada8-59734a0d6699"]},{"cluster_id":"2d8d907a-2ce9-4878-ba6b-55a8ba564f43","members":["5638859b-a4e7-442a-9258-7c016db35b11"]},{"cluster_id":"99d24268-130c-4375-a4e7-e999f58720e8","members":["628a9231-baea-46d1-935b-0ca2ff01b00d"]},{"cluster_id":"01f44311-0ef8-48af-a616-086ce88e4356","members":["397d33bf-097c-4ee9-99e3-1a1d910daf3f"]},{"cluster_id":"4785bab4-a99a-4e40-9619-5133dfc2b141","members":["7b77283b-32ba-4208-84fa-7ab5e7cab570"]},{"cluster_id":"41b103ed-acbb-4350-80df-1fd2deb0346c","members":["517da9bc-9b77-4f9b-9fdb-7c76ed94c54e","ce0645ec-7609-47a5-9cc2-2fb81d723322"]},{"cluster_id":"ac4b1f63-94c9-4cd0-938b-a716a9ba6a09","members":["46e40007-007b-4112-bdb6-e0353838f067"]},{"cluster_id":"635850fb-0b7d-4148-aae4-786dbec7ebb9","members":["bdb28899-4f74-403d-b02b-ea957505918e","463b0a4d-fbae-49b8-8f14-ea008bffbf2a","dcf68337-ae54-4f8a-8271-f76115e03f87"]},{"cluster_id":"67731679-09bb-4b58-92bb-6990e6c5fa20","members":["2f38e888-600f-4e0c-aa5d-aea6ecf44f01"]},{"cluster_id":"70862016-3977-4b4b-9e68-43859faa28ba","members":["b2abf8f5-257b-4d02-9d1a-28829bf1cbb6","79267d8c-556f-4ae0-a361-17fd8204735e"]},{"cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00","members":["f15d0ff0-d9e9-4d3f-b9c1-eb0345438bb9","b5b1d0f2-cb71-4b4b-b1b5-993a136abdb7","459b2077-c724-4735-a64f-e274a8dff816","d7f28da1-8d0b-41af-bb67-719a1bf0eec9"]},{"cluster_id":"08533bcb-cb39-43d6-9371-79f7aa905623","members":["b9f18053-5037-47c8-8598-331be2a79964"]},{"cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56","members":["5adb0ff7-d9bc-4670-85ce-aad1368b41a7","3fb2d7f6-e88e-4db6-864c-66144ced3735","b0d8f0c7-fa85-4070-a3f9-bb1353c4596f","32dd5dab-f7ef-4cd2-ac64-759def9b81d4","cbf6ac36-0c7f-4daf-ada1-66917b3bcc6c"]},{"cluster_id":"c1b67021-ee6c-440d-9e1a-3565b3ab3f41","members":["759c7475-0897-4647-8b0e-031cc9ba6232"]},{"cluster_id":"d990ed81-4fe6-482e-9afb-51f8ad32db00","members":["14147b89-0d92-4319-8775-66863cf40aaa"]},{"cluster_id":"71cbbb7d-55a3-4b3d-a593-9d2df11352a4","members":["197ea094-6998-46eb-9eb0-c42038338cc9"]},{"cluster_id":"923eb3f0-4a80-4604-845d-2264e5473406","members":["aaac4db6-2c1e-41e7-8c9f-d6b353262207"]},{"cluster_id":"ecf87520-6110-4dbb-8897-a76147b7c3f7","members":["4c49be1c-4984-43c9-84ea-20cd6554a9bd","4be45854-769b-4cdf-8d32-7ef709f38bad"]},{"cluster_id":"8a0a3a15-f4ec-4089-82e3-0da6ba69f921","members":["aef8d776-73de-4a9a-9ac9-77b9a76a5c9b"]},{"cluster_id":"ed5d05a0-5035-40ad-a517-d570266b42b4","members":["73b90fd6-25aa-4c74-9c05-806da37bc137"]},{"cluster_id":"0cacd6f0-a483-4fb9-8635-2cc0f4273b40","members":["efd598c6-13e3-4a3a-ba1d-f2040f478439"]},{"cluster_id":"f79fc6d6-3df1-4383-96eb-f3d73361c492","members":["4153fc76-dd06-46a7-b833-59462ffcf3c0"]},{"cluster_id":"42663758-9518-49e1-a45d-11b8ad2a2193","members":["3eb3429b-5a86-4636-823b-47d12f8e009d","cf200205-e78e-440d-a9d8-77fbd362cd37"]},{"cluster_id":"7e03d5b5-4b07-4e72-b62b-55465d7f9333","members":["668ec28e-19b5-4953-b1fb-eb9dd4e4d330","9289fbce-8f31-4b85-ab17-0f329026a889"]},{"cluster_id":"2702052c-d199-4761-be47-a9217e23735a","members":["166c481a-983c-434e-ad60-01d7318a666d"]},{"cluster_id":"84d8eefe-324c-44a5-b6d1-c374c46cc323","members":["14b9ea79-ae03-4f42-a138-9c2ffee5b826","508ef568-3b2c-4f93-8997-e4cfbd121e8f"]},{"cluster_id":"4b5a21e3-57c3-4239-8ed1-85b9925a8673","members":["aa7457aa-e2b7-41e3-a76f-f250452d8ceb"]},{"cluster_id":"995b974f-591b-482e-a707-9ef62e9bcb2f","members":["ffa893cc-5751-4cc7-9631-5cb0757e751c"]},{"cluster_id":"f7ba632a-cef8-4360-bbef-dd149ddc5163","members":["ca6d6bb8-16d5-4838-b68f-17ff29aeff1a"]},{"cluster_id":"7f8a206d-56f9-43fd-80ec-c184e678a121","members":["f606eaed-f36b-4ad7-974e-d69792b06e3b"]},{"cluster_id":"f44a9570-1523-4d3e-9b69-1e328e9b2946","members":["6b6ffa0d-1e38-4bae-9088-3abde339c3da"]},{"cluster_id":"335924d4-8c81-4bf0-8e93-746bc3bcb081","members":["60688d2b-1218-4d31-a856-9c2cc98ed3c0","da008d27-7472-4d62-996b-7ab8966b19c8"]},{"cluster_id":"93302bc5-2c4d-4a14-9964-fc677c0db641","members":["a46bf700-8a4f-418d-90fc-003b0bc7228f"]},{"cluster_id":"0e5c3365-93fa-488b-b635-43b68052b0bc","members":["023efd2f-37f3-428a-93b9-9851efee1ab9"]},{"cluster_id":"6659a589-3901-4e01-8d7f-eb3e9f204a10","members":["7e57b3b3-1ccc-4646-9659-c2d94da11186"]},{"cluster_id":"45b3db14-d0a0-477b-afcd-d5fc5dbd7f5e","members":["da22f955-e91b-407e-93b0-ab51c2c62a96"]},{"cluster_id":"ceeb447c-921b-4bff-b396-64b4ab69cf19","members":["222e7b43-94bc-469a-9da2-e6c7522401f7"]},{"cluster_id":"119547c4-e528-4d80-bc2b-d8dc41ee62fe","members":["4ff9773a-68ff-4aac-9456-845b766f68d4"]},{"cluster_id":"9821057e-b80c-444e-8823-153881d41c90","members":["a2e3ca06-1e5b-4d34-80b4-412d59aa3a43"]},{"cluster_id":"9c86d7d6-beed-46e5-8bf4-a9b09bb7cc58","members":["738e1a9a-7001-45f2-bb32-ff4e61d6b48f"]},{"cluster_id":"7c24e460-dec0-43da-b3ab-9acc84d4caeb","members":["8b3f89b9-71a0-4a88-96a2-948392d036cd"]},{"cluster_id":"be6b5f43-b5a5-43db-8bdd-0c041f0efa31","members":["b0b99fd3-fa74-4103-ba15-cf12e47469ed"]},{"cluster_id":"bb78b3cf-3fee-4d7e-b532-1ccb52ef3013","members":["41788b6a-450e-4c17-962d-bd412f1d352f","904c1337-d922-43ba-aaf3-bee846b59cc8"]},{"cluster_id":"8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d","members":["bd3aba7c-ad6e-427a-a510-dc1e1bd9c7cd"]},{"cluster_id":"d784ccaf-4509-4d9d-9ebf-0ffc15008e18","members":["06f72312-a33d-446c-bb6e-dc7b4ca210c4"]},{"cluster_id":"725d8a20-a3a3-4517-9549-74f8eede8ff7","members":["cfdcf4da-e29e-4722-ac00-8cd76b398f94","4c493219-0683-40a8-873a-f7ddd9e19aca"]},{"cluster_id":"432f6df5-1641-407a-a774-485c9d80d467","members":["148553e6-d5d9-4816-96b4-c7c115faab4c"]},{"cluster_id":"174c41e7-d29c-43ee-b99a-262cda821c4f","members":["d1a30a6a-894e-49d5-8382-00a5d409b387"]},{"cluster_id":"21ef710d-94c3-43ee-b3be-224e0c033195","members":["b1f6ef8c-f80f-4565-a8e8-a1bec3e92ca7"]},{"cluster_id":"94210717-ebb1-4a0a-897b-10e38931ad8b","members":["871edd95-2bef-4c86-80bb-e83c188a88cd"]},{"cluster_id":"b1ded912-0980-4dc6-8e8a-bb1ae1f015a9","members":["416e955e-2300-409f-9ec1-c4fbafa37d57"]},{"cluster_id":"94362393-c674-46bc-9e3a-666f4bf5a507","members":["2be73865-8f17-4c3c-8ff5-59077c2c2638"]},{"cluster_id":"c0bc02e5-e391-4352-8bc3-69ffab45a6e1","members":["10350d56-fc35-41a1-959b-98a5220ab0e7"]},{"cluster_id":"88637747-174c-4782-89a7-a4bbdeb1e9e1","members":["3a092639-1cc6-485f-bf1a-d92f6a336b95"]},{"cluster_id":"62318edf-fc49-441d-85dd-789c9859f09c","members":["8d7aa242-a4fa-4805-bf07-4ab3531b4a46"]},{"cluster_id":"9de91220-8362-4c94-b430-300c675c23e5","members":["80946d3c-7fd2-4079-b4a3-88da3b276d60"]},{"cluster_id":"29cd39ea-ce90-496a-a9f1-6917924ac984","members":["3e4a8be4-4ed0-4553-b03c-128ce3fd4985"]},{"cluster_id":"1044d7cc-fb67-48c7-a61d-abf5c9d0ee2c","members":["82615446-c1d3-4c85-8e0f-1e8ede770ad1"]},{"cluster_id":"4a783d2e-0380-4a57-9e6f-4b34c23f0ad1","members":["ad67387f-fc3e-435c-a8bd-5e291653ae0b"]},{"cluster_id":"ca8ae13a-f4c2-40ca-adf9-58a7907b79bb","members":["a865c1f1-ff02-4c09-aaf9-384d06d59fbf"]},{"cluster_id":"47b5e189-9eaf-4e69-b28f-1f2681036c7f","members":["8b9464e0-9a15-4e61-923e-b378808a14b3"]},{"cluster_id":"b8e61f96-24fd-4f99-870f-bc308a6c4198","members":["dec9a639-6063-45f9-91b1-011da9866da1"]},{"cluster_id":"fe4e513d-3365-4bb1-b29c-ae02d053a2e1","members":["a3403f9f-ba0f-4ee4-82d4-1929b0c86826"]},{"cluster_id":"bf711cc9-463c-4a50-a300-d24703735ee6","members":["29d024dd-2543-4a8c-97c4-a8b1bbf8dc29"]},{"cluster_id":"1118439e-1d54-4e33-bac7-0813c7dbb103","members":["4a6442f1-c198-4146-b8d8-0bb0b72e9000","6c9977de-a8e4-46cc-9f3a-cce09947f9d5"]},{"cluster_id":"0ba7abed-e798-4cd4-b041-3026081313b7","members":["c68c064f-6ac6-46bf-9798-6cc7a03a8b57","7d769798-8649-449b-9577-3ffe09615c87","9ffdedc3-d9ef-4cb0-8934-d60d94a1b93e"]},{"cluster_id":"210b8b9f-5f46-4fbd-8a43-aa4d24350d2d","members":["b5fc4724-c9a3-462d-ab84-5bebcfdb6783"]},{"cluster_id":"11c3011e-be2e-490b-b73b-6b530385f70c","members":["52cf9b3e-9f25-43fa-8939-e7866cc8edc6"]},{"cluster_id":"009adb33-ebed-4470-bd79-30fe1e0fa2d8","members":["1ac986cd-7418-4a77-a69d-a9308b8761cf"]},{"cluster_id":"deae8114-2508-4864-a544-401d4150e26c","members":["e1ef5d87-f3ec-423c-9813-c9a4921268c1"]},{"cluster_id":"f38958f6-adfc-406e-ab46-296dedeeb781","members":["07477746-79bf-40ea-a2a4-df204c59d1e4"]},{"cluster_id":"17c72ecc-bde7-4838-bd7c-6c235f6a23e1","members":["340bee43-d3fa-492a-b0c5-9beef5cdaf32"]},{"cluster_id":"a486e470-c569-4ed1-8cc9-0f9109ad027d","members":["f20f07e3-7db3-4e45-857e-a44b98c2bb8e"]},{"cluster_id":"02ee18ae-cb4c-43b0-8eeb-127e5d8f1ac9","members":["b293d682-81e8-4ee7-98f5-08d38125f280"]},{"cluster_id":"654fa001-54fb-4d51-b87a-8207c38aeb88","members":["477b8e23-3732-45bb-8214-4be4d59e06f8"]},{"cluster_id":"6bbdc559-2725-4b4d-bee7-05ff3de480c4","members":["4203c331-94df-4947-baaa-31ca888f30bd"]},{"cluster_id":"030691e7-b00a-48bd-99cd-b8a82a2565cc","members":["bcd1fd82-eeae-492b-8e3b-aae60422d657"]},{"cluster_id":"f70debef-4097-402b-81f2-0ddc396e0729","members":["2b5e3663-84d6-4872-8663-13535c6a2ef9"]},{"cluster_id":"2cfd963e-dc73-4d82-9776-ae618471ae77","members":["4fb30839-ae13-419b-b046-54c5b4ab1faa"]},{"cluster_id":"0033e72b-385a-41ce-8ba3-fd98c6521d05","members":["22e7c561-5c28-435c-a056-a2a7ac35b322"]},{"cluster_id":"1bbcbe31-d9c2-415e-aa16-c9d78fd6946a","members":["6e1568f5-503f-41be-af1f-55c802c66507"]},{"cluster_id":"76ddd218-4f5f-4047-8ee4-faeb581b90a7","members":["9eb46b0c-d447-445d-aef2-1288e56731a2"]},{"cluster_id":"a343f83f-a09c-4c76-ac05-045d273e90c8","members":["49ae5188-a2ca-4673-ae24-883f12ed99e9"]},{"cluster_id":"05840b29-9ac1-459e-98bf-cb3a11b4aeb6","members":["66942d3b-11e6-4000-89af-63719adda485"]},{"cluster_id":"c9299dd8-c218-46f0-b151-8c752a7421c0","members":["f57ff950-9e13-483a-bec5-974eb37e4703"]},{"cluster_id":"1fb65a9b-f85e-4764-8dae-68053166a895","members":["4eed5196-441c-471a-ae3f-d55887c0f063"]},{"cluster_id":"38bb4737-de3e-4b8d-b413-8281bb85ae27","members":["efe09af4-3d29-4a10-9c20-6c42ab3563f5"]},{"cluster_id":"827f6b49-228f-4d42-afa2-d86a5b588a72","members":["630437eb-fd43-4d0f-83bc-76d2f57ecc70","e205fce5-7add-4723-b183-f8e3f4793203"]},{"cluster_id":"c6262c2d-c819-43cf-9414-2109754b60a0","members":["ea07027f-897a-42f0-af9e-4de7f1333cf6"]},{"cluster_id":"83103bb6-3126-4ae8-b437-2a2305839cc6","members":["c2c81ff6-a163-475a-8383-769d632a3191"]},{"cluster_id":"e79e7825-9f83-4c5b-92dd-af1bdccc56ef","members":["9702a8e5-c44d-44a6-be11-b88dfba3d229"]},{"cluster_id":"8820c527-2e2c-4341-bec1-16e1d5309310","members":["a1a140b4-c1ac-491d-9ae3-3620a0004758"]},{"cluster_id":"2f612694-7e7c-42ff-aef8-a4f09e365266","members":["97ee6a53-1aab-4a11-bbc3-1775ff749efb"]},{"cluster_id":"fc7e97b6-8dfc-454f-b469-c14bd479fe70","members":["1897c2f6-b5bc-491a-948b-25ea30ab87f9"]},{"cluster_id":"31310d54-1285-4857-b35a-cbc2a3d3bfc2","members":["dbb30e81-3924-4957-9510-c3ca70ff3cec"]},{"cluster_id":"21f0a219-a107-4e6e-aa28-e010ad5aec66","members":["e6ac3ba2-6553-40c5-93b0-47155aea88ef","8575edeb-b639-4048-a541-0e8f08e0f1a6","5f4ab424-0937-49e2-bb1c-22aac0430f2a"]},{"cluster_id":"078eb0c7-fae2-4ffa-b527-48c6683af72e","members":["776e7b52-5ed1-4439-9f2d-40f2b49ba7fd"]},{"cluster_id":"5f181f74-d991-4908-aaf7-6917a17dca75","members":["1c08e4c5-9840-441f-9216-d5589e6804b8","4b96c116-8ff6-4180-aa3a-b5e6d65f179b"]},{"cluster_id":"0b719ed0-60f8-42bb-9426-ff2a477557b7","members":["9a26c070-19da-4eb1-83ac-f92c3c2f2535"]},{"cluster_id":"ddc5360a-1ac4-443b-9995-2e77ae3fa0fc","members":["246072d5-0023-42d5-be4d-192210543c42","2536d3cf-bc39-485e-a4b8-00382b9abfc9"]},{"cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03","members":["dc5b6b43-1d7f-4cc1-a0c8-5798df242073","67fe157c-0a35-49a8-8f21-5628c7797662","76636031-6955-46e5-a38f-1c8ceea4854d","4959890f-ec07-4467-9894-7ea899d38684","0e39736e-26f4-4f9d-8ba1-967054b6d03a"]},{"cluster_id":"a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f","members":["4e10df47-ecd3-420b-ace6-784d39da51ec","c5eb6bc0-d315-4389-b537-4ff24b37b0ba","1dc2d18f-7d20-40b4-b306-835da288cc24"]},{"cluster_id":"84ba9e08-7f87-4e91-abf6-4415ddb9a231","members":["8b1417ae-1c79-4395-bde9-31cc95079fcd","0d8942c4-d969-40ab-9b61-d3b6492557d5","5f546275-52cd-41ca-8f20-759766d0002f"]},{"cluster_id":"91638e17-92b1-4187-b7cf-b00589f88898","members":["65ed18a6-46ca-42a4-b659-ffd3e80e398c"]},{"cluster_id":"84a0d215-8113-4569-a05e-d15e5c91d360","members":["46862e25-4144-4ea1-8438-f36b6c8106e2"]},{"cluster_id":"905316e3-c2fa-42ca-821c-e5be344dac59","members":["6a5ffe53-8ea1-4ce2-b101-76838a82574d"]},{"cluster_id":"00853d63-b913-4804-b64a-2b243a93e06b","members":["83a845fb-f008-4586-97a0-4ebed68224f1"]},{"cluster_id":"e550706a-507b-4244-b8a2-1df630cff9aa","members":["34141a13-a411-4858-8ce0-1aeb316e65b2"]},{"cluster_id":"98c1c320-efc0-41d6-bc35-eaf849b7cea7","members":["4f1143e9-8a23-407d-97eb-ba5c9cd9c89d"]},{"cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f","members":["2123eb04-aef5-4732-a991-e130cad08ea7","c8863369-10d7-4a7b-8a44-8be24f3cb312","3d1ea1a5-3946-4ee6-ae7e-484f3bdf70ce","876a0e31-fed0-492e-9930-125af3ca6ca0","24eb783a-7899-40b6-bd7e-19f05a363867","3e86ebe1-a67e-4d4b-848b-e3d840e4902d"]},{"cluster_id":"27a5d354-dacf-469b-b094-7b2ad6fec31b","members":["ce2f9ef4-b333-407a-8bed-225eac1f4180"]},{"cluster_id":"6f960627-d475-4f28-8eb0-dcceb972aad4","members":["3308e491-e157-43e0-9b6c-4a9d02687351"]},{"cluster_id":"f5b9ae68-f130-44e1-85ad-1d8a741fcea1","members":["1926b8d1-77b0-4125-9064-fd191cec71bf"]},{"cluster_id":"65ee7ca1-956e-448d-a404-e5c643989efe","members":["8f273d19-4c8d-4d81-af8b-347364d3cf78"]},{"cluster_id":"9d7361f1-563b-4b70-8f5c-fc18e12402d2","members":["b41bba8e-2c4c-4c7b-84e6-ac57b3efe67c"]},{"cluster_id":"4e53dc9a-0b46-4ddf-8ff5-f5172619e371","members":["0895f651-9e7a-4f35-85b9-11d230569161"]},{"cluster_id":"b9239d36-ef30-4a43-92f9-8fe391efcc3e","members":["cecd8282-63f4-4288-a013-3c27da5e1ce6"]},{"cluster_id":"b20e50fd-ac66-49b1-9139-e41a882a2619","members":["6c53d5bf-7d7d-48dc-9537-69146547313c"]},{"cluster_id":"5b67eeb9-9da5-4079-bb66-f861e834a37c","members":["d7276325-292a-412d-b146-87a0730b45b3","dea4f733-4356-40fe-91e7-6054577b69a7"]},{"cluster_id":"80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e","members":["6821b41c-0ed3-446b-b813-0315afb69e66"]},{"cluster_id":"3ba005de-dec0-4cc4-8a3c-a3679d6f072a","members":["64d6f3c5-199a-4540-9425-eff3a9b82273","5a950cce-9f3d-4ba0-a51e-e8a2b37a97bf"]},{"cluster_id":"7a9ddc4d-79e3-45ee-a4d8-9a05a9685354","members":["5f83450c-4831-4805-8e27-b404683bd245"]},{"cluster_id":"3ea2f80e-f4b6-4835-b337-64fb3587f6b9","members":["815d733e-377e-4e24-a508-460979499d47"]},{"cluster_id":"184f7da5-f557-4593-8954-67601ea3d345","members":["cf9f8c01-fefa-4717-9ec0-abd2ed4eb2cb","1835c7f4-de2b-4164-8b82-fa6adfc3ca0a"]},{"cluster_id":"93f5bdee-4d35-454b-8f1b-0b318e24a68d","members":["1bd88c13-1b9b-45a7-8a44-855bc33bf360","8901b6ba-a1b3-4591-9266-938a286911c6","01e425df-a493-4ceb-a10f-366132092c49"]},{"cluster_id":"2bf4835a-c2d9-4984-a011-415e8a457306","members":["a3da8389-1854-464f-9071-1facf1abd8ae","7a6466fb-3b7d-4380-8b37-aaa5ae4f5f3a"]},{"cluster_id":"34aab7b4-5379-4f38-9914-ae9a14a7914c","members":["30b11eff-e7ca-4bee-af73-c2f03f82b017","01eb0ae5-fa84-40a6-9c52-34656c07b795","d46e2345-2bfc-4730-ac5a-8fcd87c1305b"]},{"cluster_id":"c9eb6d86-6b17-4232-b3a7-29de5feb80b0","members":["d229b959-f62a-4326-b165-185f589fa0ec"]},{"cluster_id":"6965d206-c7e5-406f-98ef-d70ab17200e5","members":["59c8ecd3-dcf1-4d46-a641-b8280912e98d"]},{"cluster_id":"0bc0d2a3-3712-46e5-ad94-41178e22eb84","members":["76aaf235-16e7-4043-87b9-a037084179e2"]},{"cluster_id":"e8352caf-0212-486c-8732-e56619b31e7c","members":["696c28a3-2f20-4d42-8e0d-62f761eeea35"]},{"cluster_id":"47332eaf-fc3b-42ad-bec7-2e81a4ab08e7","members":["7421a086-6509-4f46-82bf-090c02c96be4","2be94a8c-a787-42cf-87d7-6040ce277c99"]},{"cluster_id":"77f3be19-2659-460f-978e-d15cb9d38644","members":["b8889937-ecac-4ac9-bc3b-db5291b944cb"]},{"cluster_id":"2813da46-c92c-428a-9aa0-d5a6d2aae7d8","members":["c6b77d57-513c-48e9-ab99-530e20b9b255","8a98103c-3be3-41e1-bacb-d9b663a6a20b"]},{"cluster_id":"978700a4-02ac-4150-9d93-a90e4ee05431","members":["2dd36943-0a3d-4022-ae72-3e3e82b508b8"]},{"cluster_id":"125babf5-bc0d-45cd-ad83-2a6b21a3e2c7","members":["224eb8e3-f200-461f-8907-508a2b9b3610"]},{"cluster_id":"2311e718-cd29-45c2-b4e7-6c01097b3aea","members":["68fb7d61-8a80-4806-b215-988216fa2da2"]},{"cluster_id":"33b85444-739a-48a4-ba4a-144d6f0bde74","members":["ac80497e-d83e-4314-9f0a-5428faff4d10"]},{"cluster_id":"908547be-87be-4e95-b368-a0acc7033e35","members":["83e06432-af9d-49ee-8785-9660b34df3ae"]},{"cluster_id":"dffdac1b-ba6f-48b2-97f4-02cb8656a37e","members":["303cdd50-f46a-425f-9a12-202c5b188a35"]},{"cluster_id":"56c21a67-f093-4d7b-81de-a41cb3a3c896","members":["dcf67d9a-523a-4117-a894-d3df96daa21b","109c5e74-1d02-47bc-b21c-4526d12dd143"]},{"cluster_id":"cd8e42cd-c833-432a-b12d-6040bca4f918","members":["85de426c-4f43-4b35-8b87-06cac94c009b"]},{"cluster_id":"2b8a30d5-2b80-47ce-adf4-0612b97c7289","members":["1bca1c02-5747-4e14-8c7b-90781e35a9ae"]},{"cluster_id":"b558144e-22bc-4f5e-83f4-cf10e626dc01","members":["45e8dbea-ef86-4a3e-b6a7-9ccc36f702a6"]},{"cluster_id":"c4e46a56-8890-41d4-ba88-174baf1248f9","members":["eec3301c-6f87-4401-930d-03b7ef07c902"]},{"cluster_id":"dd21a7e1-c272-4900-8da2-788f661f4b0b","members":["d58e0908-63ef-49a4-a04a-de9c56a52d19"]},{"cluster_id":"5e9b1d6e-d8db-47a3-b950-64ca3a804787","members":["124d3e56-edc4-466b-b738-7ed87500a778"]},{"cluster_id":"2b3c9191-0f03-44e0-8e0e-82a5f8121907","members":["e4f2e2d6-c597-453c-9d79-887992f836c2"]},{"cluster_id":"f51ef59b-4e02-42dc-84d5-932727f453f6","members":["c59f8085-e8f1-47e5-9183-a3ddc5d7fe72"]},{"cluster_id":"ff5b2600-1cea-4a76-a9a5-9e02ca367e1c","members":["160f517a-6e02-4912-8876-ce86f1747260"]},{"cluster_id":"d56cc903-0bed-4718-9fc5-602c188caa16","members":["4a818227-ff11-402e-a17a-fbc4c82f1188"]},{"cluster_id":"2bdcdf0c-04af-47ca-abf1-8573ce94795d","members":["64c78ccf-c8c4-4ead-8edb-781fec01ab6f"]},{"cluster_id":"873c2a4d-0ea1-497c-90c1-2ef71ec73e8d","members":["949dcc31-8461-43ae-8be2-e1d0b363bfef"]},{"cluster_id":"d9ed1c39-189f-45e7-adb4-c0c7fc2d4155","members":["a4448971-d689-4aa9-b2a8-e18c28b5e01a"]},{"cluster_id":"afe97367-2dde-46dd-9395-2e46792da8d8","members":["1d22170c-0274-426b-b23c-8246a6c999a1"]},{"cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44","members":["411db0b4-901a-44af-8084-684c94c06f35","4532a5f5-e3d7-4a33-a245-a559061e325f","6dfa4668-6bbc-4e53-b326-efaf5323340d","bb32ebcf-afa1-4e74-a29d-d1b0fc8cb958"]},{"cluster_id":"6c48832c-2b96-4ee8-9b48-4611e67b38f0","members":["2dd99937-465a-40c8-a6d1-1ba80f7b7fff"]},{"cluster_id":"5e399677-5a8b-4a09-a43c-cb9c2afa95dc","members":["2d2427a3-25b4-4670-834e-c8c9a8e08566"]},{"cluster_id":"efecc9d7-3e88-45ed-b11f-77af1e65000e","members":["7d7620e7-0394-4b49-be2c-d52df53b66de","7c8e8163-76b3-483c-83a5-7d5a604ec003"]},{"cluster_id":"a397f3ea-2260-47ec-beca-b473be543d39","members":["6239eff8-9991-47ad-9ee9-6bc9fa41b6eb"]},{"cluster_id":"4c464446-66cf-4c9f-b4d9-3d5598eb4a8c","members":["0b3ba769-29b9-4fac-ba68-f45045bf2631"]},{"cluster_id":"3044ed83-9d35-4f0f-9d53-c999faefc097","members":["760b1750-990f-45c0-9982-41b2b2e88cad"]},{"cluster_id":"dd9ccaa5-025e-44c1-90b2-20d75d0c5291","members":["5969d7ad-90fb-4499-bbf5-9843fb61ef4d"]},{"cluster_id":"d44024e8-81f4-4d88-982c-a023f24b58cd","members":["33b7cce7-6173-4e38-aa9d-73da5ad3355f"]},{"cluster_id":"6d7e8844-23f0-4293-9d61-855d04598239","members":["3fdc70af-ac57-4ada-b88e-beebc38d0f90"]},{"cluster_id":"6e3b5d0b-67db-4d14-8384-2b3799aec6bd","members":["9535fc4f-b8d2-4d71-99c2-51c24b82dd25","0a43eaac-9d11-4559-b4ca-8aac7ca1c563"]},{"cluster_id":"376cbd95-afac-43da-8c2a-b0756127f429","members":["ac8cea3c-51b4-4003-bc71-dc8e7da0cc9e"]},{"cluster_id":"abbea790-2006-423f-9f7d-2f67dda5b47d","members":["0b6ab1bc-2c8c-43f5-9de1-58ee61492950"]},{"cluster_id":"91653172-78c7-443d-8db0-081fac7b81c6","members":["a2d53ef1-9deb-433a-bcf9-59077120797c"]},{"cluster_id":"5ce12af0-2b76-4e71-8a73-442efc1d859d","members":["bc1bbdf3-ee43-42da-a74c-f41e1bb52a7b"]},{"cluster_id":"4b392fdd-fe83-44be-b489-81067bf20cc4","members":["2aac0bf8-5dda-4fc1-8da7-cdae83559eaa"]},{"cluster_id":"9add2c84-55b8-4f75-bec3-d9a47e379ce8","members":["0ee0eddc-d7aa-4f78-aae9-6008e205e5c4","6bf3097a-570b-4809-b237-d44db87a39eb","2820709e-5d6b-4509-94a5-78cd96541477"]},{"cluster_id":"ba2e6df3-366f-4f05-b8ae-0693e1f8cec0","members":["262af7ff-dfe7-464a-b640-3f6df9d3723b"]},{"cluster_id":"e9486241-9c2f-4d3e-8704-e3be044f2405","members":["a77f5498-680a-46a4-8c8a-659c9ad02c00"]},{"cluster_id":"8affed0e-1741-45ae-9282-db13ed25555e","members":["04f22358-3b13-4ad6-bbda-ad0691b60927"]},{"cluster_id":"c6829bdd-21da-4a4f-9d8a-98920160c65d","members":["f24b52b9-187c-4eec-8711-93153d4d2fee"]},{"cluster_id":"2dbe786d-9065-4e0b-93e2-135a2fc6f7f3","members":["2843540f-04ab-4329-b579-f43852502201"]},{"cluster_id":"dfa3481f-adba-4f59-b051-83a57da84830","members":["7e546993-ae27-482d-9f03-1b53ca0e72db"]},{"cluster_id":"31016415-1e0c-4bc5-8f2a-e27a8e5ff775","members":["b6069ba0-2a14-45d6-b5a3-a9991a32bcd8"]},{"cluster_id":"b617ae42-60a1-4bd9-bcd3-a29cc6c02448","members":["87f67770-7faf-4358-9b25-7f35afac9ecb","752d86e5-d35a-4109-9d79-724a0db1743a"]},{"cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489","members":["2e3dcc2e-b0aa-4f90-82b8-edb47f445bdf","ee212c03-d1b9-4829-a450-4cf628f7fbc2","58629ba1-a876-4cf2-9e86-abbf1b321a0b","111737aa-a6ea-4e79-96a0-0dda72e05afa","7efe0478-8a2a-4d11-9c5f-52020e70d538","020ddec2-9bf4-4d55-8de8-775d6b46f6f7","07b8c9bc-c879-41be-ba14-45abae032ec8"]},{"cluster_id":"0630fbfc-9793-4e8b-bd28-898778d452da","members":["2dda5801-f3e2-4728-9ede-9738720b171d"]},{"cluster_id":"3c952e11-fec7-43b5-87d0-197de2b823da","members":["69a5cfbd-e0c9-413a-947b-94501669f10a"]},{"cluster_id":"0cda4135-c24b-4433-a2d2-edf8bce6961a","members":["b81d08a2-2cb2-4ded-a06d-29e265a6d632"]},{"cluster_id":"6207c1fd-d86c-4598-b9ed-72232636a976","members":["5e70da93-c4f2-4f6b-9b2a-9f4c35177f2a"]},{"cluster_id":"708bf439-5986-4d45-983d-18029794b540","members":["4f9fbad5-3926-4330-9231-602c807d9d2e"]},{"cluster_id":"2cd863fc-6aa3-4b22-ae05-f3da95690998","members":["169afb32-d558-4121-85b8-678d1f854a12","720b8d6d-809c-4d3e-a583-77f63e7d2392"]},{"cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf","members":["47955cc0-e7b0-4d67-90f8-bf03cce5c3ad","4d10fff5-7f39-4071-88fd-5dd756dceb9a","a7239427-66bd-4600-aed2-581476f25b1d","dea64148-7283-4119-b18e-ce084b537bc9"]},{"cluster_id":"ac3c4bde-8539-4baa-8848-6a9242884e47","members":["686cbbb5-3b5e-483b-bc76-96a077264b04"]},{"cluster_id":"5241cd80-7c22-4aa4-92c3-aaf01b6a8d68","members":["bc31032f-4bbc-481c-82b3-4468226d167e"]},{"cluster_id":"6d60b9fd-35cb-4875-8f6b-cc990ada4464","members":["c2be8edd-44a2-4024-b0f0-bac5f6a20d1f"]},{"cluster_id":"a47f9935-dbc9-43e1-b673-236035daf9b2","members":["ee1c0bf2-b738-419c-bb84-dd8840a8d165"]},{"cluster_id":"044fadd9-8b2a-4a97-a501-b787a29d182f","members":["809ebb4c-3f56-4172-af62-1fc98346939d"]},{"cluster_id":"77183e66-d172-4f0f-b205-95c246afc00a","members":["d9deaf4c-cb27-4ca9-b33c-ee26766559df"]},{"cluster_id":"3cb65e99-ccac-4aa2-91a0-7af465ad385d","members":["e70b85f7-dbf0-4789-b87e-40b9be1f108a"]},{"cluster_id":"03481317-8100-4f6a-8ba8-a8c9a52c0e90","members":["78dd797c-54e9-4f5a-a617-5c04890789c2"]},{"cluster_id":"10f7e4c6-143d-4ada-adc6-a0d81c4f5272","members":["9641230b-18d7-4122-9fbb-ad268a1ededd"]},{"cluster_id":"5605c591-48df-4465-a293-86fc68f1944a","members":["2296956b-5cc1-4ebe-b1da-37bf012fbce7"]},{"cluster_id":"e1583824-5e05-4c29-84a3-b27afc099adb","members":["8ee72d39-4d72-44c4-980c-975cb4158fdd"]},{"cluster_id":"ed76bc08-55bf-40dd-b156-814a949b24dd","members":["e1bd328a-fc69-4d68-98f7-b98c02516111"]},{"cluster_id":"6701d78c-ba82-4b89-b97a-8fd70b5e34f9","members":["1f08bcd4-2a1d-4977-b630-3d154862b9ea"]},{"cluster_id":"72cb3acd-6792-42e7-917e-0a257b0b418a","members":["7fb40a00-2db2-4859-bcb8-efde1a71fcd3"]},{"cluster_id":"2258427e-082d-4938-9009-29d50fe17645","members":["c186eca9-cb1d-40c3-8028-d9f201e6a3e2"]},{"cluster_id":"fd0c3806-b445-4899-9ddd-fa029d0bc38e","members":["1de7f983-9b61-4d4d-a604-7ae975daa70a"]},{"cluster_id":"439aa0a6-6e46-43ae-ba81-fc975c6669e1","members":["dac0ff89-f538-4798-8227-cd94c172c6b7"]},{"cluster_id":"da473e07-5f99-4854-b0f9-aaba62b413c0","members":["70beb357-6a2a-4e2e-93fd-f7fd7bfede7a"]},{"cluster_id":"989dfd54-88d2-416d-a172-4c7b7a520121","members":["2619669f-b128-4efa-8cc9-544630bf09b8"]},{"cluster_id":"bfddf849-1008-4d2d-bfce-830b42f8a421","members":["1946fa2c-944a-4cb0-8bb6-4f8595248750"]},{"cluster_id":"fbeea9d9-e3b5-41fa-b94f-503292015b12","members":["814b1bb7-0051-487e-ae27-1276aa74b620"]},{"cluster_id":"979b7171-b50b-4784-a226-a93eb757dfb4","members":["1c362657-65ac-483d-b15c-54a082028700","6e0721bf-af2c-4613-aab8-fc5a60b352e1"]},{"cluster_id":"83b8e4b4-0c78-4b19-aa89-21b8a62c50fe","members":["843a68e2-a58f-4338-b608-d0b676ff0f44"]},{"cluster_id":"490d433f-ce3e-4f27-9543-e9681e6eafc7","members":["1f642949-2156-4f56-b000-f294eb9b083d"]},{"cluster_id":"6274d1ce-c7d6-4cef-9ec4-e52018d2a528","members":["ea0b0740-6fca-4192-a6bd-8b7c7e497256"]},{"cluster_id":"8363a6a5-6462-4ebe-b358-821cefa34494","members":["f23e3f2b-f8a9-4d5a-b9d1-4e6e721675c4"]},{"cluster_id":"9d8cb077-725c-42df-adf9-cc02faf7d3d4","members":["a9eb3402-7303-4e26-985e-bfb6e2b7be5c"]},{"cluster_id":"b8695913-835b-4b14-be2f-fd0c828a71a6","members":["3ea68c64-9773-43d9-b4c2-7c341b643338"]},{"cluster_id":"3b245c17-07a2-4e26-a29a-946ef78835ee","members":["f25fde5f-d782-4e1d-a20a-3752b8c3828e"]},{"cluster_id":"2b3f127f-efff-44cc-83bb-012f860b4fc1","members":["356d7c96-6a41-41d1-9ef7-86159595457f"]},{"cluster_id":"1f60ebbf-51df-4e3e-95f0-d6e32c7fc5d9","members":["9f3650f7-0c90-47bb-af37-8f56e9051440"]},{"cluster_id":"1dcb2d84-ef9e-498b-a03a-7740ad5e2f55","members":["28f26c81-8a2a-42ab-9758-c215f76bbf76"]},{"cluster_id":"b0a9927e-dfb0-4578-8343-304f2917ace8","members":["178ae6f4-e2fb-4589-8996-268c104878a0"]},{"cluster_id":"7261d8c0-d619-4bef-bf36-5ab83467a9cd","members":["716f9129-429d-4988-894a-cd8a8d7da4ab"]},{"cluster_id":"99785983-351c-4201-b7c5-88255cfce2ce","members":["f9fba1bc-a280-42e9-9fad-8c755abff63c"]},{"cluster_id":"5ef9de99-de5e-4d31-bfda-1e87c2a63ead","members":["5da27d33-a165-42f5-9ec2-6d118ebb37f9"]},{"cluster_id":"13bc9125-818a-4eff-a1c9-96bf89586d78","members":["08515554-be3a-4ebe-a6df-471d24dee1cc"]},{"cluster_id":"290a2df9-939f-4569-965e-7d206087ead6","members":["5b4121b9-67b7-407d-86b8-6053c136b87d"]},{"cluster_id":"44955a88-3ba0-46cf-ac7e-906798513ae4","members":["074ea38c-520c-4e9a-9ef5-c4ca7b784287"]},{"cluster_id":"c8744ddc-73ca-4b76-bc5b-2e4d00f4bba9","members":["d791cfa0-d2a4-464f-ac69-75d53f3d4c82"]},{"cluster_id":"06512aa8-6f14-4dbc-8b0f-4ea2e772ba31","members":["fde86755-d0a9-411a-af01-148da957be9e"]},{"cluster_id":"27a6bdbf-c139-4b94-baa7-3715f52da9db","members":["189499fe-3131-447b-81e9-4435db4e85e3"]},{"cluster_id":"5c683e3b-456e-40af-9840-3af3a5900ece","members":["4a4972c4-ebf7-4cb8-b0ee-1b43206b1ab9"]},{"cluster_id":"bd48a2e4-20c5-4fa2-90a9-0725e3288c94","members":["478dbf82-e1cb-4626-aad1-f4c4b525dc5d"]},{"cluster_id":"ed839aef-f33d-482b-b6ad-3c8a3947da24","members":["c06642ac-1f2d-495f-bf42-2bc2972cbcb7"]},{"cluster_id":"d227604b-5869-4f99-9132-b0eb536e0289","members":["a5ad7c31-c1a4-480a-8ab4-6e28f34870f9"]},{"cluster_id":"25720bbc-2dcb-4fd3-bfdd-8ac413567afc","members":["296b6c7f-df17-4502-8c74-8f18015dfa39"]},{"cluster_id":"ad513fe4-8bef-4ca7-984b-94ef0cbb53d7","members":["58a96d05-0b9c-4ddb-ad56-31b85def6114"]},{"cluster_id":"66380cec-1745-4f20-be6e-01fcad9e1602","members":["000f23a7-2222-41ea-8898-e7d063735ef4"]},{"cluster_id":"651043d1-0d9f-42ac-bcb3-c7e39b7939ec","members":["da7cdfd4-e436-4cad-bf96-fd39255cf969","a0ecf576-e0bd-40a5-980f-ad8ac2c93062","bc772f26-1c54-4444-9adf-ebcab49ae7fe"]},{"cluster_id":"ca0536ea-7533-4baf-adac-d1ee11b1604e","members":["a9d50388-6ca1-489b-898c-03077d503b07"]},{"cluster_id":"d58b9b87-81e0-4589-8f81-7f8c5e6a86d0","members":["52ea576d-ff1d-436f-859a-e066258b724d"]},{"cluster_id":"41ecf095-1caf-4be8-93aa-128fb386e8aa","members":["785991ad-3948-4077-af87-943e2698d44d"]},{"cluster_id":"96772c7c-5021-4ae5-83ab-b845fd92f1f9","members":["d668f105-1438-4350-8827-74d6bed57b76"]},{"cluster_id":"5045a380-d054-4bd0-b13d-e42a8ff24888","members":["280cc982-fb5f-405a-abd0-135f9de11b7c"]},{"cluster_id":"7c34b0bc-12f1-458e-bef9-fafbba595b37","members":["e0131c57-979b-4eb6-b1b9-b63edb856c71"]},{"cluster_id":"d748d1bd-38e3-44b3-b268-429f4615acee","members":["3f2c5b38-deba-475d-9cd7-11385395e7d5","69c09a97-0d88-40a5-967e-4b2414656a7f","67f30ec6-95de-443c-8a45-01bd859d04c4"]},{"cluster_id":"217bc58f-d97f-49d7-9c91-2a55c225a54a","members":["137c84f5-23db-45e6-bf92-1ad74275d3e1"]},{"cluster_id":"83859ac4-ebe8-4ffc-91d6-38d67b7686ab","members":["fa0db7ed-df89-44b6-a5c6-2ada5165a15e"]},{"cluster_id":"6d1416a4-5911-49a5-a8dd-0b4e7d18279a","members":["3d6a2ff0-9932-4048-b809-b1b21ab52912","25ae9714-f988-4579-a283-17d3fac67c24","0237dae1-3387-43b5-85b5-cba8ff095863"]},{"cluster_id":"af7abfea-8aa3-4fe8-a9f8-4a548d23e03a","members":["b05052a3-07ad-456f-8def-ea0241666317"]},{"cluster_id":"8a0c3eda-5944-48c4-883c-6f01e773d494","members":["9dc7cfa4-60c3-46e9-93bd-b1dcaab98aee"]},{"cluster_id":"707b49ca-9999-4b93-b6af-d31c32d2cafb","members":["4aac8468-0db8-44dd-a4a0-aa92932348ac"]},{"cluster_id":"ef92d248-d529-47e5-9160-de6bb70cfa68","members":["3b1efc1f-a8b5-40d7-afb8-47b5c2d8c3eb"]},{"cluster_id":"80759b38-0166-40f3-aa37-31d3150e1679","members":["563ef7e7-3e70-4f08-8a0d-494367c53a15"]},{"cluster_id":"cc8b239f-30da-4a67-b3e7-b923954bf5fc","members":["272d4ca0-a4cb-4498-a278-ed962e7fb8a9"]},{"cluster_id":"35ae28c4-1a8d-4235-aadc-32d9b7b111fc","members":["14e70229-d758-4a9f-b726-1a569c1c76d6"]},{"cluster_id":"2e2cbe02-9179-4ff7-9128-2042160eb4d1","members":["22510ace-caed-4962-8f00-efe8b2b3bdc5"]},{"cluster_id":"efbd6030-d54d-4409-900a-396adc8a9b7e","members":["a5875c2f-fc37-4929-a261-fb5eb0b601e3"]},{"cluster_id":"00d660d9-94af-474c-8e79-c16ac62cbef7","members":["bf690599-cad5-45dd-ae9a-0dfd9300fe11","598d47df-b169-4963-92a9-f28dd18db4f1","c3b6f443-30c4-40f4-ad7c-b75048fa6cd0"]},{"cluster_id":"2947fe08-3f19-4a83-826c-8d5e7d1e3368","members":["34cc607d-07f1-4fcf-961e-cc2ed5410530"]},{"cluster_id":"05021641-3e64-47c1-b3de-9319980f7bf2","members":["1e8752b2-0404-4776-b8b8-8e69b8687848"]},{"cluster_id":"446a7c12-73f1-49f5-944a-5a0119281e12","members":["157ab812-4359-4349-aa5a-6276969f1acf","c73e787d-e802-4efc-847c-2e925026c04e","ff0dd947-d591-4a91-98f5-7e8568e5a3ee"]},{"cluster_id":"900b62cf-2f7f-4c8d-9d94-4cbb68246f3f","members":["7c180cef-775f-4dc0-b7a2-7d8d5e88625c"]},{"cluster_id":"db2c7499-73dd-49a7-b315-23a9a2089f45","members":["d4e97c40-281a-46e0-9b44-cf5ed299a47d"]},{"cluster_id":"7e3a0dda-730a-409c-87a4-d60847af0bea","members":["76f11f64-6713-42b7-b4fe-4a91b078dc1d"]},{"cluster_id":"696331dc-98cc-442f-bc75-87b9c239a45d","members":["c7046dc0-2120-433b-b1ad-372ce5830178"]},{"cluster_id":"9e950aab-bcb8-467d-b56c-2d0bc86754ee","members":["3c63c480-f1c1-4956-8ba8-123730a4a02a"]},{"cluster_id":"beafc838-f8fb-4f24-b442-c5d64c7e1a7b","members":["c48786c0-3d01-4cc0-beef-55fd9048d74a","26ddee41-4525-4f23-aa2c-a446c14312eb"]},{"cluster_id":"e197be16-bc11-494c-aa3f-5b8f744ffb1a","members":["8aebfe7f-59bd-447a-9883-1dfe71623e69"]},{"cluster_id":"b6f1959a-3736-48e6-bdb9-c384c993515b","members":["4ded90c5-3a0b-4383-8c98-2eb06d50795b"]},{"cluster_id":"f6427727-e128-4eae-8208-67e9a7ed1b14","members":["5b44d227-cd48-4625-802b-e02870b36ce5"]},{"cluster_id":"dfbec97c-7720-466c-b25a-2051f356476a","members":["6c7bfa6f-971f-46b6-bd04-14ad038adf97"]},{"cluster_id":"072b9770-c37e-4414-a35e-af21470d2ffc","members":["94bceffe-abc3-44c2-a2eb-2ddc58173a11"]},{"cluster_id":"ee0b2c4e-ce44-4f3d-90ff-fd0a1c204fa5","members":["57923ade-9ad9-40e2-82c9-f707f057bcfe"]},{"cluster_id":"127de610-39d3-4b48-be82-befef46aa586","members":["d42c2acc-9cb7-4e82-b0d1-beeb3deb20d8"]},{"cluster_id":"cdc110ac-1c3e-4435-8e2b-221f6de6a9c7","members":["51ced9e6-1f43-4883-977d-d0e20fe66a54","0fbbec81-5c41-4156-b190-889bc78cf7de","cd8a5b00-b145-4ba5-be1d-dd7b1127c2c1","720a854c-8fdd-4cc3-b45d-b85cf6468e00"]},{"cluster_id":"a6c32f96-492e-46e5-b580-0804b089cb50","members":["30397b47-2751-48d5-b517-e38ed1c2ed3c"]},{"cluster_id":"4edf6538-801f-49f6-932e-65747f37810f","members":["ebc674c8-5c33-4f37-85b6-129b22993e97"]},{"cluster_id":"e8809e83-36ee-4437-9f9a-9028a358d36b","members":["2c94f3e9-f2e4-478c-8e0b-0c78352e3b7d"]},{"cluster_id":"7fd1b210-1374-4030-b2c1-ddf3869ca13f","members":["a5f5eee1-35a8-40c6-bf54-d56986cd75d6"]},{"cluster_id":"6e5ac655-6dc6-4a9e-915a-357b2296a7b0","members":["59a9db05-0086-48fa-8c0c-ffbd3e3860e0"]},{"cluster_id":"a1c1162e-c36a-46e0-95af-7c5c08d5e6ff","members":["535a210f-5332-48a8-b714-9cd94b6426f0","f8862daa-afb5-49de-a80f-ef289a621c9e"]},{"cluster_id":"3e87c12e-871b-4773-8173-d484141c190e","members":["823bb143-78e8-4e11-9b72-5d0fd5f6deff"]},{"cluster_id":"f39cf9c7-18fb-4728-b88a-0bd586522d02","members":["3ceecee9-d165-47a0-8779-3f9b9fd7ff46"]},{"cluster_id":"48e9dba9-1fa3-402e-ae73-202c64781781","members":["b64599c0-5b8d-4f3b-97b9-a3e1d058ac89"]},{"cluster_id":"99bc4095-29c0-47b3-81af-1811b5d01f5f","members":["48cc9fc9-b313-45c6-ab6c-98c8e73a1a81"]},{"cluster_id":"07bac613-553a-4b5a-8942-deafd7506573","members":["1f57bde1-5a81-4359-9554-77b898be045a"]},{"cluster_id":"1bece78f-f648-4fbc-85c0-722698749525","members":["4531fbee-07ca-4f7f-ba48-99fd66c5beb6"]},{"cluster_id":"46812bda-c4dc-4bd2-a7c0-e250a28da359","members":["37483664-a7a7-4762-9906-e5dcae2780ff","74d182f5-abca-4486-bb63-20c04388f987"]},{"cluster_id":"1abde06f-fea9-40fc-b58c-ddb744004d48","members":["883ec100-33d7-4964-82ca-f305eceae674"]},{"cluster_id":"914330e6-94a6-406b-a8f3-ed188765a7fb","members":["846c382b-bfeb-4264-ada7-0b383ff7fb90"]},{"cluster_id":"182eb8ff-4f9c-4649-b5f9-31b5022006bd","members":["8650053a-7f26-4698-9037-10695259e0b3"]},{"cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a","members":["5245537c-9eb7-4eb1-8dc9-552ac10777ac","38efd15b-f73c-4767-9fdb-679b3456f1cc","551e0255-ced9-4f0b-8d2a-fdd55f8a8add","24401186-060e-4f23-8917-efbe8d9758cd","35f38b9b-5ae6-46db-b678-097ade3533ac","a16869db-0336-4704-baeb-5256f023e290","df160e7a-2bcb-4e84-8d82-4201295192ed","93d12391-eef7-4c5a-8d23-3ca3ffb008bd","e23f167a-c7f0-425f-865f-377dfe1354a6","aaaa23bf-b2ea-43c1-ab2a-85111934b433","ecf23699-b575-4ba7-a0fe-5d782f53736b","649a8931-8e47-40b4-b474-17f7ae5b39cd","2f6ae23a-6a6d-466b-a49c-0c243534c600"]},{"cluster_id":"192193af-777f-4b45-a866-b58926d838df","members":["2a8d0962-05f2-4f3b-83bc-0c984f50a683","258dc20c-5542-4f84-b93a-b9a7bf4d9980"]},{"cluster_id":"fc22f23f-3e70-4f58-9556-2d3e03c04167","members":["766905f5-fd25-46de-a4cb-f9e22321ddf7"]},{"cluster_id":"74b5a9f8-d64b-4e6b-9562-84c68b5337c2","members":["47752977-8739-4c1f-8b4b-0b2984eea4d1"]},{"cluster_id":"34ebf375-c746-4b55-870a-320a9407196d","members":["f8643050-a94b-48c4-96c8-ffa6daa1c6c9"]},{"cluster_id":"6d2c68aa-e5f1-4199-8a32-52bb8d80e934","members":["32bba864-7aa2-4f36-b89b-224012fe2ca8"]},{"cluster_id":"8cceec53-f974-47da-b9c4-5af02c151d1d","members":["d257a9bf-a3d4-4874-be64-af6ba0f22f02"]},{"cluster_id":"558a2b97-08fd-422a-b638-0c14ba645eaf","members":["a2d902e4-962f-4a18-a1c1-f622b3934f40","5a1d42a5-3ff6-455a-8d97-b10540e1e8cd"]},{"cluster_id":"a65f122a-8e28-4204-bec6-e6c89e03bce2","members":["5e4c2baf-dbe7-49e1-b269-4033ddb0632e"]},{"cluster_id":"f69599a7-433a-4819-a4c2-cea569bc6b06","members":["4aa21b38-4b13-4d29-925c-aa699d9b3403"]},{"cluster_id":"76435864-5754-43fe-ba96-2ebbad51c5b7","members":["532d5c4d-9d3f-4f2f-a279-bbeb95659887"]},{"cluster_id":"163f1d1d-a78f-492c-b769-5b6a7b1465fa","members":["55e44c00-4fe6-496c-9dab-944c4b2cb2c7"]},{"cluster_id":"ebecceb7-8e8e-4359-8ae4-54572c43828e","members":["bd112641-f8c0-444d-8cb9-9503c72569a7"]},{"cluster_id":"cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10","members":["e718d11e-60bf-41ca-aae9-78820d070e08","d99b0120-f2a8-492d-96ed-003f61c955c0"]},{"cluster_id":"3b570036-015c-4669-a1c7-9124e256f407","members":["f7c3ade4-9ecf-4e12-853b-8b75b47032a1"]},{"cluster_id":"a6f24255-af0b-46ae-a654-0f9f9280b4f0","members":["46856529-2ef5-4366-a966-3ebc9ac5e9bb"]},{"cluster_id":"e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5","members":["3f1da2a4-fd20-4820-8b26-bef270380f34","826edaba-f1d9-4729-883c-a9c6e7470cc0"]},{"cluster_id":"985e777f-c3e3-42f1-b650-98ac19e7f7b5","members":["9c75c255-ad39-4e2a-a3f1-0b4d8b705a38","88bd205b-928f-47ae-ae3b-f31e27246468"]},{"cluster_id":"d6164d22-4f2e-407f-abd5-0ff84a88c4a3","members":["02012bb7-6c7b-4ee5-afd2-88ea366a860e"]},{"cluster_id":"4d98cb2c-2f46-419d-a007-1ffd1128c767","members":["fd1c4e40-ebf0-4822-886a-cc9032160c1d"]},{"cluster_id":"3ae04ca7-f447-4b2b-85af-7e1f6c9004e8","members":["3495bbed-e666-46d8-898f-62fc06d697e3"]},{"cluster_id":"23f200a8-82be-479e-8c62-e16a5b3450e2","members":["e61ba6fa-b8da-435a-b8ad-f2f5ea81b708"]},{"cluster_id":"7c711c42-89fa-4d59-a561-9de6228e491d","members":["fffbf361-a8e9-49f9-adb5-13838d571f1e","8f73c558-2be2-48cc-a73f-d9f7424080ad"]},{"cluster_id":"5b28f584-d6d3-4f8c-b812-407015e7b243","members":["ecd93e53-3d17-448c-b237-a63b3e8109e3"]},{"cluster_id":"4551b9a3-cfb2-4080-a1f5-d94f9554a9e1","members":["9af4bc62-9b31-46ce-8d09-a6acb48e4823"]},{"cluster_id":"85f720a8-0b31-4d1b-a866-8a5f552a25e1","members":["90a9b422-b922-4777-a14a-ef9498c5cc6a"]},{"cluster_id":"ba20492f-063b-4fc0-8bd7-26d88daa19d1","members":["14413e39-16eb-48e6-b0b2-dcfc3fb3a951"]},{"cluster_id":"89a78cfb-c5b4-41b1-8a6d-eaa2669e99d8","members":["f1f73dc0-26bb-4aae-a4be-b03b92bf4da4"]},{"cluster_id":"ec27a280-5ff0-4aa8-9204-fa364980dc9d","members":["ff3cedd3-b1c8-4195-a13a-18ec0932a118"]},{"cluster_id":"6ad0010a-5d1b-4773-9ca4-976c212e4238","members":["2445c1a3-6b24-4942-8f14-750807be5748"]},{"cluster_id":"693353d7-9dc6-4a72-be1a-08fb1957eb6c","members":["f65051ed-e0d4-4480-8343-0bb9a5c21786"]},{"cluster_id":"cf3cadee-d476-45f2-a534-bfb4334bffb9","members":["f921e3a9-8ef0-4155-b3e0-4e2525ea4be1"]},{"cluster_id":"6c375d59-160f-4719-ac36-a62607acccb1","members":["870b1f70-9513-4c14-bc26-c7ffdca2eaa9"]},{"cluster_id":"f03d0193-877c-43d8-81d9-6519c6ca169a","members":["a5b57b1c-b032-4317-805d-278014d54408"]},{"cluster_id":"72f48981-b5f2-4358-be23-5c1438e13df0","members":["a25c205a-715d-4d40-ae2c-d66a5469c6df"]},{"cluster_id":"45236940-0b07-401a-92bf-42c8f73cf80a","members":["63118e54-0fd4-430b-95cb-919ab0a8306b"]},{"cluster_id":"bc2af5c9-9ff9-4d76-920f-873d731b0a39","members":["c4c91b8a-1cf8-4289-bb34-1c6dd48aedcd"]},{"cluster_id":"75ec5d34-37c4-464a-bbb5-d624ce06eeb5","members":["452dbeed-8292-4d02-90ab-791dbe013e25"]},{"cluster_id":"b7b39062-4917-41f9-8b87-39a562d00b9c","members":["b9b93ac0-20e7-473e-bcb0-a8cb0f7eb23c"]},{"cluster_id":"db558738-31a9-49b8-a8b4-9d79818e6da2","members":["83d411c4-399d-40a3-8c9c-d17510bac37a"]},{"cluster_id":"1dd3a1e1-df59-4ade-b082-02235345034a","members":["f0bfcd0b-b8e2-4da4-9825-ade7ead748a9"]},{"cluster_id":"66885820-7ee2-45b0-bbbf-efce4343c472","members":["f0786557-6136-4304-81d6-22fc866a3b12"]},{"cluster_id":"8e8986ad-07fc-46e6-a980-933b8035ee58","members":["a114812e-0977-4ca1-8094-71ad9b83c0c8"]},{"cluster_id":"25458cd1-1938-4e91-a3e1-aa6eb25c1608","members":["c0c0f3f8-c44b-4b66-ae74-4ad4f7191562"]},{"cluster_id":"517bce1b-0646-49a8-83b6-634d844a1495","members":["c9344c2b-3875-489a-9343-306f5df5110f"]},{"cluster_id":"1171e42a-be23-408d-8491-47db819af91c","members":["20b2a735-379f-4fce-94bd-0bbe7f7c5b79"]},{"cluster_id":"03d5681c-cee7-4784-a946-350af3b91054","members":["1e5cedaa-a90f-4111-8959-84cd0f677370"]},{"cluster_id":"7da5e969-ac3d-4ab8-86be-3712be90baa2","members":["d77fb711-e1eb-4c1f-81a1-c1b44ddef513","108ab024-87d1-47d4-8139-ad46f6e38c35"]},{"cluster_id":"967e4599-c3e1-4e81-bc7f-40bf2be021b8","members":["318c05c3-f561-4ede-a7e7-336765f0b9bd"]},{"cluster_id":"986a6ea4-399c-4998-bc4e-699677ef9178","members":["b0e753ad-fa27-4f00-bbc3-e8d0ea27080b"]},{"cluster_id":"69bdd771-bee0-4047-b696-6cda0e3de3f2","members":["84a49646-225a-47e5-9d89-f72e0b0f5cd3"]},{"cluster_id":"0e1517ba-8541-4c30-8eb8-cab31577fd7c","members":["961ea034-93f4-409c-a1ca-a12bfda4eef2"]},{"cluster_id":"1e79f665-5f29-410f-a52e-7981ca5d8478","members":["4939d5d5-e9de-45e0-bd7e-a16ab0082411"]},{"cluster_id":"b2825dcc-d8ef-4d2e-bf5e-a9bc43fa0aaa","members":["bb8b9873-c9ae-4b32-aa5e-d093e4520db2"]},{"cluster_id":"5ab902d4-7128-4b95-a738-a425f46dd496","members":["9e2ed00f-fb92-4f4d-a34e-6d11d893c403","13a89318-6f44-4f8b-ad1e-2ad8dcde96de"]},{"cluster_id":"56d99389-f62b-41f0-b4bc-d85869083e3e","members":["5063cec6-b534-47e2-92b2-fcd5f77d4fb6"]},{"cluster_id":"62babf7f-7431-44e7-bf3a-2b3d26f92e86","members":["72ac546b-bca3-4948-aa0b-6469a29a2935"]},{"cluster_id":"24f76117-6d13-47b7-8b5c-41608f921324","members":["b8b1f515-6eaa-4716-8eba-78cd0e360567"]},{"cluster_id":"5edd87a6-3d98-4e7d-9e60-b94920fc071d","members":["63f5d0a1-7dfe-4d45-9529-9e2ab1904d7d"]},{"cluster_id":"6e176932-b450-49d2-bc88-60ebe982b797","members":["88f1f741-4ab7-4160-a0fa-c523bb32fe76"]},{"cluster_id":"3761b79a-ed1e-4efa-a004-8d3634d88c5c","members":["577b06c1-df87-403c-abf0-46e4fc3e0b1b"]},{"cluster_id":"d83800f4-0756-4306-86c9-259b547db8df","members":["c1749acf-2e81-4a01-a6d7-be83d2e12cc8"]},{"cluster_id":"8922c103-923c-4f13-93a5-f90c7607556f","members":["881df9ed-9ac7-489a-b437-ca046e1322d5"]},{"cluster_id":"fe1c6b54-9f28-4390-8b18-685bcbf44298","members":["7ea3085a-234b-4fbe-8da9-c525603685fa","c49df9ee-84b6-4d61-803d-996fe5ae4ab4","9e1996d1-59c5-4235-96d7-3177babcb7f3"]},{"cluster_id":"cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1","members":["91bf62f3-7da8-4e84-85d2-709539cb36fc"]},{"cluster_id":"96c115c1-f9f9-479d-9ecc-98da549128b0","members":["18a75e4e-6a6a-41e5-883e-66078a97f435"]},{"cluster_id":"236dacbe-2c11-46fc-a4a4-42464ed6f51d","members":["29b2550c-f791-42b9-b02a-9900964c9675"]},{"cluster_id":"4f9e8ff6-b5d4-43cf-8ca3-6775ebba3b38","members":["4eecc423-821c-4504-b820-67b8e5603b27"]},{"cluster_id":"82ddd264-29cd-4540-b05e-dff896b42eb8","members":["550b4b37-7548-45b1-a3f1-d8a06a510945"]},{"cluster_id":"c8099c76-111d-47ec-a755-9357e7d74d90","members":["7d8ca47e-2ef9-442a-98b1-fa8f6205bbc5"]},{"cluster_id":"e9cf68ba-8958-4444-b683-81cefe80ccd2","members":["6b22123e-880e-4acc-8153-bdb56362c2a5"]},{"cluster_id":"227d1df9-e404-4f53-b880-3d4e96ed3405","members":["198d3645-4cb6-45e1-a18e-223c98801648"]},{"cluster_id":"11c149bd-c47a-4b6a-887d-8baf2ffc4481","members":["a3363a3c-98a2-48ba-9cc7-674f22a0088d"]},{"cluster_id":"6d5e0026-09e5-4a7b-b48d-75b8d03130d8","members":["d54a3518-9e0b-4c3d-ba7c-472fc7e562f4"]},{"cluster_id":"7ccbb20b-c467-4a12-8d6c-4afcbbe94813","members":["2808b341-8473-434f-8054-cf31c53e50bf"]},{"cluster_id":"82d125aa-a1b8-43bf-bc35-e274642ade2d","members":["f4810664-25df-4885-84dd-d702f61fb326"]},{"cluster_id":"b2e518c2-bee5-4258-9f37-d52e83d13a76","members":["c7b6a4e5-5073-48f9-906b-45c2c92af366"]},{"cluster_id":"52572bed-fd4b-4180-9ada-bef96be23270","members":["faddd9e3-735d-4866-bc42-9d9cdd5b2f9a"]},{"cluster_id":"af40ab83-4c48-4ac1-af3a-242491a35af4","members":["b7c50e63-6034-41ff-af30-9e1d8f461eaf"]},{"cluster_id":"114c895c-17f1-417b-8a4e-f626b06562d8","members":["99f4732d-fcd3-41ff-a9ec-3a7637e9f664","b4f1c228-054d-4b10-9e6d-9b2bcf5b05f3"]},{"cluster_id":"1e486a72-4d21-463d-8ec1-dd36ab1fc529","members":["0e355bfb-dda1-493a-9e8f-6a6055245a49"]},{"cluster_id":"d3045f09-979f-427c-94af-3cbb77214023","members":["724352b3-5c52-4b45-9ec1-ed51d8f8b631"]},{"cluster_id":"c97fb561-3217-4665-93fe-191384f9c143","members":["5fadfb89-8910-4205-bfcb-e7b767a420a0","734ada9f-5249-4622-87e4-59853bd3ca96"]},{"cluster_id":"261a6bc9-08bd-454b-9fec-f9f4a0fe9250","members":["f4a6e102-743d-4a10-b1fc-da4b283c1748"]},{"cluster_id":"442c376e-0da2-4461-a8fe-6d964ea3c00b","members":["8840e33f-2cd1-4b8d-93e8-dcad7cba5f3d"]},{"cluster_id":"b51f7dc2-d0c0-43ca-aba0-033ca0100d18","members":["c2554150-da86-4ad4-9a8c-3abb18092cc9"]},{"cluster_id":"d0b9d362-84b5-4285-90de-b70dc7fdf9db","members":["7bdd1f26-74a1-4f78-864b-931bf388e62d"]},{"cluster_id":"4d2908dd-c372-4065-827c-bbbe9d18c879","members":["a0fd99fd-4064-4c31-beef-aea5b915d57c"]},{"cluster_id":"af07ce28-0024-41ac-b51c-01e4bbf2c507","members":["091c1cf6-adc8-4823-808f-b9bd34b2c68a","43190cf0-9e6b-4ae2-a7b4-2194945580eb","54befbf4-323e-4ec4-b0d5-6b075fbfff8e"]},{"cluster_id":"bcc8a49a-201a-439b-bf04-a72b13e50b57","members":["7d52399e-9fd4-4ef6-ad61-e9c1004b479d","82024969-a370-464d-9b78-4528b73f0e66"]},{"cluster_id":"b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126","members":["59840c00-da45-49b8-ba87-6e4ec07b3dd0"]},{"cluster_id":"9c4f129c-13a2-41c2-aa00-330c197b8780","members":["ce05174f-bd24-4296-a6ec-f3aa221ae8e7"]},{"cluster_id":"7fd887a5-caaf-4dd7-967d-5f621c88bae6","members":["6d502776-1705-472f-a052-9bae2595eceb"]},{"cluster_id":"7e91212d-531e-468a-b19b-7f7bff3fda9d","members":["e005d56e-7e0a-44da-9463-7e59e19f8e3a"]},{"cluster_id":"7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd","members":["4c593132-8ef2-4218-bc92-54e12c4ac457","6e5fec9c-b2f0-4e1b-852f-6806a7eef1f9"]},{"cluster_id":"f239b4c3-e0cf-4725-9d59-2b1e32a9ad39","members":["042276ae-6db4-40af-b408-aa46e970d2c5"]},{"cluster_id":"c7c8c6d3-cdc9-47d7-8f45-165280d3560a","members":["9d3f9b7d-b953-4f66-8e82-2ef2c80bff16","6890ec3a-637a-4135-bc44-7e9bf3e9ef98"]},{"cluster_id":"e6120475-8d62-4b1d-84b3-4c53f22ff855","members":["d29d4cd2-9756-49f4-b174-98c43f065c21","0ad13d49-2b90-4845-b043-0b1effe7af40"]},{"cluster_id":"14b07b58-6d89-4f8a-8ddc-8c0a902ee333","members":["6969d256-3deb-46fb-8044-e5876804511b"]},{"cluster_id":"391672fd-aef8-4243-932a-77e726662902","members":["1a2792b6-491c-47e0-86c4-78505dcb126e"]},{"cluster_id":"788ae773-424f-4215-9262-5847e02b117b","members":["26d837e2-51eb-4a5b-a3f4-6de34ff0ee08"]},{"cluster_id":"4550eb60-072c-4e27-8e64-8c04270738c8","members":["011bd2a9-8271-4b4a-908b-aac429423860"]},{"cluster_id":"169e370f-8381-43b0-8425-6e6dcf0bee77","members":["6891d4bc-7f6e-4d54-a027-12dbe8eb3ab8"]},{"cluster_id":"a0aa3975-d232-4eed-a961-eca71bc27015","members":["d671635b-187f-40d0-a42b-732896025fed"]},{"cluster_id":"8621b776-3006-4d9b-93a8-f14394cb2f9a","members":["5b397cc9-7288-426b-9112-16d6c2319144","615e3004-e4d4-4db8-8943-572e5aec2d74"]},{"cluster_id":"fc91cfeb-b23d-4b4c-816a-7fa7dfbf9e8e","members":["61c236bc-6219-4f54-a37b-045a9c1bbf51"]},{"cluster_id":"93f03d20-e5b7-41c5-976e-5122f884847a","members":["f33629de-ea68-4a4a-93e5-ebb4b7e2643d"]},{"cluster_id":"94d152a0-b275-42d2-af1e-de4ffe6f8a22","members":["6d7f5a83-3bd8-4234-906d-f5ef9e8fa9f0","bd039d84-414e-4a80-9ac1-db3b9b1a85bb"]},{"cluster_id":"7ae0d854-6d40-40af-a578-9fbba79fb394","members":["ff786304-52cd-4ed8-bb6a-ddd0fd7207d3","0afadd85-4bc8-422d-95a9-0f0b99baaff2","49d63289-c9af-47f9-bc53-72830a13fe12"]},{"cluster_id":"9ee44494-957f-41e5-a680-3bacf709709f","members":["59aff547-9f80-46de-891e-008eb3c4a729","6e550910-5543-4a06-a74a-00c18f1cde7b"]},{"cluster_id":"8628cfa7-1952-4304-94e8-eca8c125fadb","members":["57c599ce-4b87-4ab0-83de-22733cfdbd26","9b370277-b0df-4b52-bb69-f004f8f111db"]},{"cluster_id":"9b558396-1afa-47bd-8065-f4f35e900fa5","members":["2d1f6464-f5ff-453c-b76b-cd8063d7cd66"]},{"cluster_id":"fc19cd3a-f641-4b19-a6bd-bcbcbc1d7fe6","members":["219749c1-05e5-4ba0-b997-d3946448344b"]},{"cluster_id":"418497da-ff5e-45fe-b7d6-b0ab00e9f812","members":["537f0b42-2434-4896-bffb-ab81f1d7d892"]},{"cluster_id":"bfcfc457-5e16-4c1c-83da-c1f90a8c2bc4","members":["17f9e020-02d1-458d-b904-b8170db4e607"]},{"cluster_id":"9e2dd54a-2362-436b-857d-0266fa2b8211","members":["0c48fb0e-8be2-4bc4-89e9-5d59615b0b5e"]},{"cluster_id":"9f5a552b-da22-4595-b590-da914506237b","members":["9908eef1-a11e-4fc8-aab4-0175f621abf1"]},{"cluster_id":"1f87ca5e-f76a-465d-9deb-690952b6b443","members":["ee3b0569-0453-4da2-80c0-4d2633c63d56"]},{"cluster_id":"7f8ccaf9-3143-4e85-8fba-3e95d1568fc9","members":["5614cf21-6c14-4bdb-aeb4-bd24f098a256"]},{"cluster_id":"3391436d-d1cd-41e7-87fc-ba5f4f2496cc","members":["ae0c2908-0718-455a-b0bb-f7b64da39d6d"]},{"cluster_id":"f3c363f3-4590-4428-9518-ecaf53bfcf69","members":["2576ebe7-bdfa-4a54-9e77-ed200f2ebec3"]},{"cluster_id":"d214ab5c-324d-4152-a542-c58284f4ca22","members":["fa9e5368-9529-4f06-8aa8-abbb99e2b39c"]},{"cluster_id":"ed56cb15-531d-4953-a25f-e17a3cb3fb76","members":["c9e29398-01bf-45b5-b075-926abb3d6851"]},{"cluster_id":"83f0ad4a-11d4-48a9-95b9-150f72ff58b7","members":["29c519c1-42f1-483b-b79b-feb999358f8d"]},{"cluster_id":"42817958-19f1-419d-a3c6-d4ed59f438b6","members":["a6c720fd-1686-4b05-8dc5-e93b64893521"]},{"cluster_id":"29cdab10-c4fa-43e0-a980-d1342b8aa258","members":["45bba5a6-922d-4a36-aabf-384c9f1904cb"]},{"cluster_id":"33e00989-9970-4b46-a3f1-4c221fc84217","members":["9c5dc79e-889f-435c-8d93-0b33904276d5"]},{"cluster_id":"0ae66dca-634f-424b-80e9-5fc4b2615b98","members":["9a10f506-e196-4eae-9a1a-e0e31b3ec0cc","f17c6a8e-99aa-4004-b2f7-bddcb8a8cf3c","839b82be-8ea7-4cae-8cb7-5df1b1d8504d"]},{"cluster_id":"578d69cb-06e2-4455-a662-a864e327b852","members":["b2d3b6e1-3124-44b9-af89-bbc6c321f2a1"]},{"cluster_id":"62c364ef-d86a-4575-aa30-edbcabb6f794","members":["5540a615-7376-440a-b19c-ded561c593d8","76dd6ad1-96b1-4e31-af7e-dc4f3e810a68"]},{"cluster_id":"89b14a97-e8c8-4e40-b25a-0dd26956ea7b","members":["a39b288b-6302-4b14-8a01-666ec983ae8a"]},{"cluster_id":"2981a7a3-8893-4aea-93c8-d180660c675f","members":["3d7197b7-34e5-4017-ab34-a9a7e4d5b38f"]},{"cluster_id":"a8f2c86c-3f8d-4f00-beaf-d0d6fffceae8","members":["c92ccedf-1f2d-4cb1-94dd-2bb312a837a3"]},{"cluster_id":"0646d462-dfca-47fe-a0c9-5ac11b42cb7e","members":["f93f030f-0add-4428-b8a0-bc210dd7288c"]},{"cluster_id":"828fd8b5-ddaf-4d75-8787-c4afd6bebc90","members":["bb8613b8-7b4f-4b81-b730-17ff3a4d9737"]},{"cluster_id":"eb796d64-358d-4578-ad2f-2c3665e77d5e","members":["9ccc3f5e-2ac4-47b3-9b19-acbb7736468c"]},{"cluster_id":"8a1337a6-24c6-4382-8169-4bec0e1a4fab","members":["676dc4eb-7bd3-478b-87cc-006ca3b200d0"]},{"cluster_id":"c160d7d3-0687-4ba7-86ad-32e9cddeaf56","members":["da116685-a998-4905-afdb-e5e3ec59e41d","b3dda178-d768-4eb7-bca5-8ff2b0536131"]},{"cluster_id":"94b72832-2531-4bc1-ae04-872ab9df9981","members":["0e161649-17f8-4509-a87d-586546770d4d"]},{"cluster_id":"615eb8c6-f4dc-46f8-a203-a52e0d6c79f7","members":["45a42fd9-f5a7-4cb6-8f87-a26fc49a727d"]},{"cluster_id":"dbfa0b87-7424-42ca-8827-733df18f150e","members":["63adbf4a-a48b-42d4-966e-1a8a3af9e07c"]},{"cluster_id":"d4448dff-7650-4f4b-b38f-b00c5af8c2b3","members":["370c1658-a5f6-4b11-a586-4bdde6133fc0"]},{"cluster_id":"55dcf158-5a10-408c-b74c-c53a42b859a3","members":["47cb6c7d-564c-46d9-afff-c29eb954648d"]},{"cluster_id":"4129284c-60dc-471f-99d0-fbb5e6ca7277","members":["2339fc15-a065-4003-b88b-a5a3b4b862e8"]},{"cluster_id":"96a7a0f7-738c-489b-9ddb-d5c4dba8d9f6","members":["4173ffc9-354e-452a-a444-7d9dde76d9fd"]},{"cluster_id":"c3b690f0-82c8-4db2-ba3e-5e52a89ca594","members":["32ee53b1-3b92-41bd-85c1-a621fc20e857"]},{"cluster_id":"0761665f-c4f6-45c8-aeaf-2676ae75e917","members":["dad45bff-ff06-4b34-9960-c4c7ea3cf412"]},{"cluster_id":"63282497-1e0a-4af5-b5c7-65b6b20ab63f","members":["bd67c3dc-14e3-4ded-86c5-85be907659f1"]},{"cluster_id":"acd745c5-1bfe-4e37-a6d1-38b30d091ba1","members":["d925ee0d-72ad-4f96-bab2-3c5a09f04dc2","38d0ccc7-b6b8-4e53-8909-a8c39537ad0c"]},{"cluster_id":"2f282f8f-f24b-4f4b-aa36-e5da41c21657","members":["cdd19715-7484-4236-b9cc-b7dac26ac393"]},{"cluster_id":"3a663e69-ed69-48a3-9c9e-25cdac30bcdd","members":["6d08ef90-3b48-46b5-9e69-3c057632bca0"]},{"cluster_id":"4aeb0c0d-181c-4cfb-9c1f-7338a1c0e097","members":["2894861a-c18c-4d08-94f5-8b2fd4789c0d"]},{"cluster_id":"7bd17062-e906-485a-b7b6-75d95fcf30ef","members":["7bac9831-eff4-4b20-8a3c-ab13ebb3c9f6","bb9dbd38-71bc-4327-b8f4-4e516c788831"]},{"cluster_id":"bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c","members":["d9adfed9-41e4-4849-9b15-4f60cb4702f5"]},{"cluster_id":"ec68f63c-4291-4d49-8068-2a2cf1250591","members":["27385007-232e-4547-9a01-a67e59484773"]},{"cluster_id":"05374434-df8d-4b22-b660-0ddc27139765","members":["48ac904f-cd28-45e1-8038-2afaf6d99d20"]},{"cluster_id":"499c9d29-7269-44cb-a1ca-192dc37f8892","members":["ec8bc2d6-087b-49ee-bfc2-490c93c6fdd6"]},{"cluster_id":"0a14d3f0-c71b-44cd-8eea-7fc2fbc8fa38","members":["e91987c4-3173-40d3-a250-c5cc8957430f"]},{"cluster_id":"7d49ce46-2d8e-42e4-a5d6-ea4a010fe5e5","members":["043944c0-e98f-45d3-9b30-6dbd80f9fffa"]},{"cluster_id":"a65da1cd-8a4f-401e-8439-da2c5c03bd1b","members":["6fc0168e-30c0-49ba-975c-2c5f1930255e"]},{"cluster_id":"9e47c442-5161-41a4-b305-ebf54f272e75","members":["9129f14c-e664-4d84-bab9-cdcd46688fce"]},{"cluster_id":"996e6c58-b099-4143-9641-865300e8a753","members":["d416a2a2-d6ef-44d4-882a-c230f7d1fa14"]},{"cluster_id":"ecb6a08c-9197-401c-afbc-cd0ee3d88f04","members":["96d7d449-804f-49f9-9105-1f5aaae069fb"]},{"cluster_id":"f9e1ae92-90cd-4553-9870-a06691bcf1d5","members":["bf5fc7df-0949-4ea6-9783-f1e37cf285f7"]},{"cluster_id":"9369f16b-6041-4a52-ab2e-d046a7246adb","members":["961644d6-94f7-45ac-8d44-584c0512aad4"]},{"cluster_id":"3f32031e-6be6-43ce-bffb-40370a2c9f89","members":["303f9a7b-45ce-4950-8a4a-bb3e22b7370e"]},{"cluster_id":"a8b93ec4-02b3-42be-92d5-d600d19a447b","members":["acb60d43-f74d-4842-9c21-e426c3fce095"]},{"cluster_id":"676e3412-2df4-4d29-844b-686d41a53c1e","members":["aa31224d-f16d-4fd4-b8fc-8ec81c1cd22d"]},{"cluster_id":"1417deae-6f6a-444b-92e3-0d85e814d6aa","members":["a18ae506-7470-4bde-894a-d0fb16051223"]},{"cluster_id":"81165fd5-dea5-41f8-ac75-66b97e1cca44","members":["efa19fa1-4ef0-48ca-9ca2-1c43c0e27c71"]},{"cluster_id":"64c8d619-fdbf-4e87-a23c-9bfa4369bc15","members":["98fc72fc-2efd-493c-bb29-fc2db28bd4c0"]},{"cluster_id":"dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76","members":["74c12cf0-8d3e-4381-954e-732587fd097a","0d06a48e-8249-453f-8f23-72b0f5363f52"]},{"cluster_id":"28b18897-b522-4746-b010-473d38b5a261","members":["36b676e0-edfc-4f67-960d-c3088417a648"]},{"cluster_id":"eef62b12-ce49-4113-8683-7c0cfeda9369","members":["e869fe57-fdea-4be6-b9b4-89324c3c6a7a"]},{"cluster_id":"f1c3e82c-0769-48c5-9831-5c2bc8453631","members":["59368157-bfa7-4514-9718-0d32036571aa"]},{"cluster_id":"82b01c38-1855-48d6-8ce7-6d564382bd37","members":["88bda5e5-84df-4482-abf8-c5cb471e32e9"]},{"cluster_id":"06f12bc8-88d8-4040-ac0a-c4dcaae5b13c","members":["785c826a-c93a-4e09-924d-cc315c89df5c"]},{"cluster_id":"dd183126-5d54-4c76-bc6b-357daae335e6","members":["8dbca90d-3ec2-43b8-9f94-fb7d415b2e13"]},{"cluster_id":"4eb605cc-1913-4af0-aeb3-6e1b6f05c980","members":["f83a2d02-d797-4320-8d6c-be5970798141"]},{"cluster_id":"865f10e6-6341-4c82-a7d2-80f23cacd415","members":["a5f9f3ff-df2f-4178-ba6d-e8691931802f"]},{"cluster_id":"071edf6a-a71e-44b7-923a-bff12eb8ede8","members":["9ad1f0a0-0e76-42cb-83ff-5b8a42cece86"]},{"cluster_id":"4197fab6-cdc4-4d7f-986d-0c9c57282306","members":["0f7b511d-5740-4b53-b4cf-cf3668c1adb3"]},{"cluster_id":"4bacc8d6-9346-41d5-8d0a-b2a14974c1c3","members":["0f2dbe89-ff54-4477-85a8-ff103a065928"]},{"cluster_id":"a7b8df05-a36b-47bb-9f07-210a97d31443","members":["fd44c5b4-90fa-4d18-ac55-ea45f162f03f"]},{"cluster_id":"60d29486-ed0b-4997-a613-db65a447090a","members":["67a156bc-554c-4a0e-880a-2deb3629269a"]},{"cluster_id":"cfd4b520-a181-4698-846e-ff280ba11189","members":["e0f319dd-3d5e-4152-ad63-50bb36218856"]},{"cluster_id":"ff17e739-87dd-44ff-b5d0-44c22b4a7bb5","members":["15f25853-5fa9-4955-91a0-1e974c7bd1f3"]},{"cluster_id":"71a8fcbe-7e01-4380-bb3a-befa2ea629f1","members":["9e3c9e1f-d156-4487-b047-454702c0a0c9"]},{"cluster_id":"41895296-6f09-4b44-a2d4-3d90f2e03b81","members":["76936d38-bfd8-42aa-9bba-108527ac0852","b9773562-fdb8-4302-8c5e-e2c8aa0498bc","0556168b-ddf4-403b-855e-fa07d47df59b"]},{"cluster_id":"e30d6b86-658d-4082-9c3e-5cf88f347945","members":["ecda8d47-834e-45da-99ad-dde7a7cbc0d7"]},{"cluster_id":"5a4fc98d-9bb2-48e0-88c4-2decb355b92d","members":["b4eeaf9a-abd9-4af9-8860-51f96c268c6c"]},{"cluster_id":"b2ed7816-e1d7-4d6f-8594-001922474b2c","members":["2bbb8dae-7e72-4910-b0bd-6037e113a97b"]},{"cluster_id":"943f941b-168f-4ff6-86c1-d9d6b4c6fa28","members":["c8174195-85b1-4480-a278-cc0c29fcb947"]},{"cluster_id":"fa62d81f-956c-46dd-ab58-7fb08e1ad844","members":["3753686f-7527-4b58-b712-4309746a6b70","85fa9dad-7806-4138-a1ec-773a473535e7"]},{"cluster_id":"1519b279-d6f7-427b-b68e-0ca8ed827547","members":["2c3b42e6-f19c-4c91-af10-c7605a5f690c"]},{"cluster_id":"6c6a46a0-71cb-45d2-a4dc-1eee1da7c7f4","members":["11cdeae2-1dc8-48e1-83bc-5c70082acb0c"]},{"cluster_id":"1a416b07-503e-4fc8-8b1f-de51772ab7ee","members":["6c002b89-e22d-4a9d-84d8-0614fa3eef05"]},{"cluster_id":"03b2228f-a968-4a30-82e2-cd3ee126f59d","members":["7485585c-3515-4adb-8b93-cd0ad5ed2408"]},{"cluster_id":"9324a7f5-d024-4c3e-9141-5fa03af67754","members":["d9a29223-ea58-43db-9109-11643672ca5c"]},{"cluster_id":"dec6b876-cff7-439a-bac8-9b6a2c289ef2","members":["f391b9ef-3cd8-4617-99f0-84f6432c1ffc"]},{"cluster_id":"ae8ea636-d211-440a-9860-24ae4efc00ff","members":["cd74cf4e-d219-4588-8a7b-e6ec75763d78"]},{"cluster_id":"52a2820c-2844-4d7a-9571-36ea2c51015e","members":["ed1855f7-791a-4785-b6c7-f6f9d8667199"]},{"cluster_id":"33f7acb6-a580-4b13-bf25-917d68f240ac","members":["8e772879-8642-4b48-aa61-c37c293a6f2b"]},{"cluster_id":"a22f4cef-ff1f-4c32-aa22-6cedb760ab4f","members":["e1757ed1-c85d-4332-b917-71cf14dd2068"]},{"cluster_id":"213f0d3a-e8ca-4bcb-b7c9-7c90117d668c","members":["ae57dcfd-b1b4-4602-8a3e-9f8286a28377"]},{"cluster_id":"5530b92f-dd56-42af-8c16-6aabb4ffa553","members":["6453ddad-baec-4bc7-aa88-b3806c2802e7"]},{"cluster_id":"c6d9c90d-92a1-44da-a5cd-12164b95f4d8","members":["1ee2f603-31c1-46f0-af51-ae84193e204d","45deba27-bd1c-41bb-b550-a741e75c34b1"]},{"cluster_id":"aacd7f08-5036-4563-9193-ec61d4e0ea80","members":["01511c05-4227-4b01-abfa-7adc2de18c4b"]},{"cluster_id":"1616bd8d-8966-4c95-b316-b97e2fb92058","members":["93afcf6d-ba2e-447e-9995-a3ca6b4f9702"]},{"cluster_id":"ce875605-9657-4d10-9c03-b203782b40e2","members":["ded3ab8c-bdcb-4c30-ad91-5fa73f6e12ae"]},{"cluster_id":"59f5b290-5ff4-47d6-96ce-35630701a6e9","members":["c797fa3a-d06d-4add-b0a1-28f55b2dde2b"]},{"cluster_id":"4ea6057d-751f-45d1-801b-72130ecef337","members":["96100367-5a4e-4d78-a813-979f5efc1ecf","5cf794fe-3c11-47eb-9ac3-4d3c6c7f3126"]},{"cluster_id":"fd5ddb7c-f743-498e-b007-014e9c97bbc8","members":["3e68195c-fd2b-4602-9af9-c8ad638afbf8"]},{"cluster_id":"323ed409-a965-47fb-afbb-d0b2c3bbefa4","members":["d74678a1-6036-40eb-8476-e2f1df401b29"]},{"cluster_id":"867c6623-6254-4965-b302-1483ede252cc","members":["117c6960-98c5-407d-adbb-50403c4f60b8"]},{"cluster_id":"d3262128-2dca-4e39-baaf-d15bcec2979d","members":["b31b675a-f130-46e2-99f7-6f675e35c3d2"]},{"cluster_id":"da41eb4a-56e1-401f-8c36-73d853bb3de7","members":["5f37959e-6018-4d92-9ba7-3b806f923e57"]},{"cluster_id":"ba19914f-8e64-44f6-86f3-04a0671b4419","members":["f9c4d73f-4e35-4fee-ad03-0cd1d0d52053"]},{"cluster_id":"5a676523-5e3b-4d60-979c-dc06042c89a3","members":["97d149af-33ce-4b66-b742-d5e7e4821c17"]},{"cluster_id":"43f42741-0a89-4a0f-bdee-4f8b6bc2f468","members":["53c3ec33-616d-49b9-b0e1-6ad2c89a153d"]},{"cluster_id":"7893a531-ebf0-48fb-8b91-b2f1e4865517","members":["db5eef14-6285-4126-bad7-44440b0749c8"]},{"cluster_id":"06234dad-1957-47b0-bd01-974e9b80e07e","members":["09fd71bd-0dc1-4229-a155-1ce1f65d0043"]},{"cluster_id":"80704d80-8bb5-443e-80be-d547a70828af","members":["56e67f7c-8309-4451-ae4b-1d9856d6eeed"]},{"cluster_id":"bec1d887-4d4c-48f4-9b0b-ebdd0a488702","members":["91f708ee-7cba-4390-b150-7deab02d3d24"]},{"cluster_id":"3de68a28-505a-4c32-bcec-da26bd58e42c","members":["4461c591-8c87-42be-8bb5-4fdcd0527da2"]},{"cluster_id":"59a61072-395d-4f52-9f54-81f2c2e5b76c","members":["d7495a8d-b6bf-45d5-82cc-77b0c6709d76"]},{"cluster_id":"53ac9504-7af3-4a7a-b7c0-a75d3fd36831","members":["106d0690-bc30-4ba9-b26a-bfd0aab06097"]},{"cluster_id":"21435744-bfd5-457c-9149-a1cc5945dbec","members":["e09c492d-dc02-4e43-a62f-0b99fce6e857"]},{"cluster_id":"4d12b965-7c97-4994-9361-6f5f0b2c17ee","members":["664a9a05-83f7-4192-a8aa-723b08092688"]},{"cluster_id":"c74997a7-7974-4e4a-80ee-0cf8f0af8af6","members":["3664a7d9-e25a-4d5f-b859-f0974d7e61a7"]},{"cluster_id":"bf617b93-4dcc-4186-81d8-7cd9fc2d425a","members":["2546d442-0582-40eb-a74c-4f9a3f2175f3"]},{"cluster_id":"0c50a72f-e964-4690-a33f-e878b2e74702","members":["d2754557-5225-4fbc-b72c-765dc38aa10f","b291b4aa-590a-45a3-be10-13ea049520f5"]},{"cluster_id":"3a18182f-409d-4665-970b-231ce6a7c108","members":["d78ac63e-0777-404d-a654-3314aa76042a"]},{"cluster_id":"e342f418-21fb-447a-a1a2-0cf67132d420","members":["213e163f-1e64-4323-8b73-a5c2a90f2b24"]},{"cluster_id":"4fd88af5-5edc-4995-92ea-057702ca240a","members":["5638d4fe-e14b-4e6d-94f2-5f9ec535a289"]},{"cluster_id":"733bc88b-24fe-4115-bf99-e05181e2177b","members":["2617aa50-867a-4602-a99c-970cd4c26ee1"]},{"cluster_id":"8a1cf3e4-81f5-4680-a43b-353cdda171be","members":["d0b0335f-9ef1-4789-b5b2-1ae2f8c35f7d"]},{"cluster_id":"ec9bc095-279f-474f-9706-4d758de892be","members":["8d0bcf05-53d3-4273-9d46-e6cf0ecd6408","039043c9-c57b-4e89-ba4a-d25747c93f7d"]},{"cluster_id":"18e3c7ef-4d72-40ea-ad9e-2d600cc1b21e","members":["361c4fe2-6085-4074-9642-b1385f2801ec"]},{"cluster_id":"808de745-ec3f-47f3-84ca-5bbec4878cae","members":["97bbf6bc-4a68-48cc-abcd-8c6783ec1632"]},{"cluster_id":"d8cf9191-20ce-4f00-be96-f15ca59147ae","members":["db1344a5-89a1-4347-abea-67f0dd3f8aaf"]},{"cluster_id":"e113cbe4-9797-46e8-ab87-8e31da3f22de","members":["06607014-2653-4fbd-a38d-5fc623dcd790","55ef6841-b095-4d5a-989c-cca41799f571","aa4f399d-477c-4275-904c-522b7565062b","ab6e267d-4f9a-4e79-b0a0-5445c91f52a2"]},{"cluster_id":"d467c165-3190-4bf1-b5b6-3c529b474781","members":["0fd9ac7f-c2d2-4356-9fd6-d37fb0923518"]},{"cluster_id":"771b0707-56ce-47d7-84ed-b75ab36dfd83","members":["348c5251-424b-4d51-ad66-ecc700fe6862"]},{"cluster_id":"360f1793-af7a-40dd-84eb-5e978218de67","members":["bc6d6f5d-0060-46d6-9831-0165ac9c5060"]},{"cluster_id":"061483cd-3b7a-44e0-857c-a5c4129b4272","members":["2663a5a4-ee2d-4be2-824b-022f551c7755"]},{"cluster_id":"7a87a2e6-b475-458d-ad14-3c21326625db","members":["3dc6e4d7-c188-457b-aa1e-490262eebc3a","5438d1e8-c35d-4f29-9ca5-d93e80592b4b"]},{"cluster_id":"ebdd6e62-4f71-4eeb-b5bb-afa4c515a612","members":["45ed405d-d63f-4b74-ac4e-09d559d82b9f"]},{"cluster_id":"92111d3f-ebb0-4617-aa4c-9df22ddccd03","members":["9c556d16-49aa-4261-978e-9d32978e28c2"]},{"cluster_id":"b7659926-8b67-4333-bd9e-74433a7b83a8","members":["bedf361f-e294-471e-9129-126f1e8eff4b"]},{"cluster_id":"c23b1bec-a608-4fc1-a229-2a8f9b59a27a","members":["bd7f3a70-71e0-431d-87a6-31f1e99c6081"]},{"cluster_id":"7cee2601-5005-4b9d-948b-2e69bb408fa6","members":["f63d2f7e-ba61-4644-9687-b3fd07cde285"]},{"cluster_id":"0ba56805-c27f-4d6b-bb0f-6903b4c54c1a","members":["9d638d6a-2493-48e4-a0b2-27751c44abe3"]},{"cluster_id":"e52a7c45-1c0e-4caf-a481-c7da67d6803c","members":["2e7d9d9c-e144-4fdb-a9ff-6415313fbafb"]},{"cluster_id":"0630459a-a055-49c4-959a-918cdf49936f","members":["b87b8799-7e39-4852-ac42-d2fad565035c"]},{"cluster_id":"54622f56-5371-48ad-b7b0-c52dd54c9e1b","members":["c4307a80-d504-463a-92ff-83520b5b3bf0"]},{"cluster_id":"45f9b0ec-ee3d-4cf9-bf46-990d297136a8","members":["0b881e1e-e5dc-460a-afee-ba5cedcde849"]},{"cluster_id":"57033778-ccb4-4eeb-beda-4c41cf31fd86","members":["957a492a-475c-41c8-9568-337092ec1cc5"]},{"cluster_id":"7e64d534-c786-4ebd-b549-3314cdd361e4","members":["2110a1e1-18e1-4cce-bc77-b88d972fa54b","a30a7def-f57c-446a-bba8-1523343fe253"]},{"cluster_id":"69acedef-de24-45bd-8d64-3a2e3c997d87","members":["af5749c3-42e7-462a-9271-b1a7eef7311e"]},{"cluster_id":"fba25849-5030-47b7-9871-3584f06bc4e7","members":["16306e57-4df7-442c-9b3d-6890127882dc"]},{"cluster_id":"83fa5a8b-b645-4ba9-9de1-a35b790ac1d5","members":["a841d3b3-c4e2-40b0-90d5-36b500b9b56f"]},{"cluster_id":"ff0f509e-a0f0-40cc-821a-6f046f5aa96a","members":["61cc0da6-6ed5-4bd2-97eb-538a915cb8e2"]},{"cluster_id":"45a4a2a8-b9e2-4fb3-a00b-44192e1fb005","members":["cd86d5b0-77df-4ca8-8d16-327883347bba","e069958d-b137-45c6-98f8-d8ac1a244303","30a75522-3ed2-456c-b5c3-4efdf6159930"]},{"cluster_id":"aac0ba40-d82f-4ba8-91e4-f92c6960338d","members":["f15b39c5-3294-48c0-b492-b81bbdf6d383"]},{"cluster_id":"ba26379e-e775-463f-9971-b8b46c709801","members":["a9b9e630-c878-4243-b1d0-c7481e5d08d9","84d683de-68e5-4a20-8afc-f90d78ad11fe"]},{"cluster_id":"fc95bbfe-5cb2-4a6b-a350-70ab1f4da4bc","members":["46f32c1e-d465-4fc4-b968-907dc6b4f887"]},{"cluster_id":"1356f60e-0cce-4f4c-95ff-047c73d507ce","members":["d71e7342-5b91-4f09-952e-face150e4892"]},{"cluster_id":"920d6e80-3d5e-4fd9-ac7b-57d21a7433b5","members":["3a0473ad-e8ad-48e5-a328-e6c97951e25a"]},{"cluster_id":"f3b31658-0ebb-4d41-9f46-459b160be01d","members":["e487dd26-9a73-4505-9dd4-ad1bdc612ce9"]},{"cluster_id":"d2b35337-7985-4ff0-934f-fef44d781bab","members":["2f5b4398-ece6-448c-b575-e405459872ba"]},{"cluster_id":"baae4a32-5168-4c2e-a607-5bdb0996a9ff","members":["867d64b1-1e90-4105-980a-65a7665e1be7","0ef8f617-1413-471f-9bef-929108ce8656","37cdd7f1-dbbc-4d6f-bcd1-908d696cd044"]},{"cluster_id":"21e6b94f-0371-4a78-aa0e-8082ef7b0068","members":["27a62bb6-250b-4b0d-9a85-ff22e9c61014","29e1437a-f465-4e3c-87ba-8891e0ad54be"]},{"cluster_id":"d1112bf6-9631-4abe-8c1e-925442961737","members":["0fa828cb-652d-4343-bdf2-1b70c654f860"]},{"cluster_id":"e71c3cd6-157e-4870-8807-668962f49dc4","members":["4522a830-0495-4185-9d3b-e70ed737580f"]},{"cluster_id":"ac066abb-a95e-4ab2-884e-0a0fd4b40f30","members":["50896647-c40e-4e4c-8cd3-a5b143cccb42","f97b56d3-db33-4c06-bec3-fa9d9c74b5a3"]},{"cluster_id":"d6b75ab4-918c-47fe-8efd-91ea4be62261","members":["b5b333e9-b9a1-4bbb-892a-f0a5c0cf934c"]},{"cluster_id":"9fb69606-a3db-4d92-926c-b003f3516e43","members":["b2975098-e936-4fe2-9d6f-f693e951414e"]},{"cluster_id":"856fcb01-3b6d-4fcd-80d4-8e260efa7cd2","members":["dba1fcfa-1008-4572-956b-b72a79251c5f"]},{"cluster_id":"164a85e9-df51-43f2-948d-bd9852808931","members":["bcdc6113-5e07-4cdb-921e-de72d3e763d5","88e2d6aa-7606-4bd8-a3c0-db8e791d0407"]},{"cluster_id":"23236a04-b4c7-41b8-81ee-60c41aaa7835","members":["4e17ab58-8c71-480c-bf10-fc4db6bed7b2"]},{"cluster_id":"a087c689-de45-45b8-a8c3-f348c23872b5","members":["e3e89324-4656-4d27-a1d9-94722e6901ad"]},{"cluster_id":"4f9d6840-2d0d-40e2-b786-9827419e3e78","members":["42ffdc91-3f9e-47d1-add9-ad79f41aaeec"]},{"cluster_id":"441ea463-41a5-4f39-8e7b-380142bd84bd","members":["76394907-afb7-4f37-aa2f-dfc7477afba4"]},{"cluster_id":"6ef25b46-a4b9-4af8-a6c3-f3258aa3145a","members":["c98d893d-cd1a-40eb-b36d-90cf5c2bfe20"]},{"cluster_id":"5cb65b5e-c51c-4fab-b738-dd41d64af22f","members":["7b32af01-f3a7-43ff-b41e-0bc643bdd5f1"]},{"cluster_id":"f65ebec2-0122-4441-975a-e196ab928bdb","members":["14cda19e-74cc-4ecf-8ee1-e7aa8c095c28"]},{"cluster_id":"bb4b93c0-732a-485f-b2ae-0ba6433c139f","members":["e0b44114-1fb9-4ef0-871f-a8437348bcf5"]},{"cluster_id":"91a2ed36-3e87-4baf-9999-c65078a62cbd","members":["eafe14c6-be1c-4e43-948f-180d45325b0f","0c3f7ad0-7532-46c3-a25f-884ccee7bb9c","aca0f8db-8cce-436e-9f36-c59945100e64"]},{"cluster_id":"b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90","members":["287004c0-d2da-42f4-a8dc-a194c801f9ba","cf7e36f9-41c5-4952-98ac-ce46ab5d8706","594062b0-e5fe-4bb0-98bd-b48cf11c1183"]},{"cluster_id":"e5320752-1012-4ce5-880c-e80ddb6ab4ee","members":["0665bcfb-b907-4224-a4e8-51b2e0d54305","bbbff07c-eb09-429e-8e43-4ddc8d113800"]},{"cluster_id":"b0ba837e-7026-4676-894c-bd729208b8f0","members":["43352cae-dd71-4592-a427-b23d73f649d9"]},{"cluster_id":"c974679a-a285-4dfd-882e-18a49abd08e5","members":["52fba235-b03c-49b6-ab3f-c6ceeb4c9806","7044d262-4ace-4d40-888a-aeb6c91aa16f"]},{"cluster_id":"64855ee7-ebba-445c-9213-c6921f4dbbae","members":["c069ae08-6f59-4d93-8609-d8829dea6c9f"]},{"cluster_id":"708ac391-bd79-4343-a52b-53252ffe59cb","members":["00b33441-6dea-4d54-b5b9-21f710682ec4"]},{"cluster_id":"c2b68e30-8952-4460-9fc7-b286c267a038","members":["a55875c9-7d6b-4478-b251-ac04d3928e82"]},{"cluster_id":"a5ce0433-5607-4061-b0d6-334f9dea23ec","members":["2ad90890-99e8-4cc3-91d4-03708a493250"]},{"cluster_id":"db101c75-2320-4597-b222-b7197dc49dc4","members":["bb6d5a06-ec73-4f94-806e-44f667b2d397","c327f749-1b30-42e5-aa05-6fbb0eeacd7f","144f4ef3-3f8f-4bcd-af22-0f371f1acea7"]},{"cluster_id":"1755b95e-bb0b-46e8-acd8-b7de1925ed67","members":["a7020c38-115d-4d56-bbeb-0749cb7b1e62"]},{"cluster_id":"b448b340-9010-448c-b955-573b9913feb0","members":["3c4d9422-aa3c-4dbd-8939-0d4599a471d0"]},{"cluster_id":"1dfcd0b1-4fc7-4be1-9e3b-b39ce16325cb","members":["d06c2086-8592-4a20-9648-27a514db85d9"]},{"cluster_id":"90c48754-a318-4dba-916a-e40680d8ea62","members":["83d70978-7c6f-4749-a5c3-e16c0881df83"]},{"cluster_id":"c75b3de8-57fe-4dc6-8aeb-f6022f783cc3","members":["9dd231ed-6549-4426-b246-32f1eaded4e4"]},{"cluster_id":"7957f359-526a-4b55-928e-2a84077427a5","members":["8117f173-a92e-4259-a53e-252c36a5b242"]},{"cluster_id":"7f12aafb-6273-4f93-bae0-fb2dee57d074","members":["58f7c1b7-d0ad-4051-acf9-3fdbd867dc54"]},{"cluster_id":"447c6034-ca16-41e8-ae39-d9800adee825","members":["6edde202-5b09-4348-b751-085ef532a3d1"]},{"cluster_id":"f2c360d4-d94d-4684-995c-edf2696b6aa4","members":["c35ca50a-39a1-42f0-8764-439d3656003d"]},{"cluster_id":"ddc509de-3359-4d1f-94b5-786fbe3bdc35","members":["c20c54ac-f57e-4fb1-a13e-01290926d93d"]},{"cluster_id":"73bf3278-1769-4596-8d67-3c3249542c2c","members":["1944b1ba-3007-48ba-baa6-e92a61fb0155"]},{"cluster_id":"eea0fa94-e771-4e8e-a675-3b0499fa98b9","members":["133fb199-09bf-4edb-ba79-2d36ce99b94e"]},{"cluster_id":"34dc1cb7-40ca-44c8-a250-8a0dace843a0","members":["e1bcb563-e899-4015-86ae-5d076ad11cc1","592c3ce7-e4d1-4537-b9a6-6715c5ffd7e9"]},{"cluster_id":"8258ee8e-37a7-4d85-b65c-6247bdf08da7","members":["fdc26a8f-16d2-4d86-b728-870089471c1f"]},{"cluster_id":"2e85430c-b3c5-4c1b-88d2-e366b82a50f9","members":["654b6ee9-da37-475b-8ca0-1c7c9d1b92a4"]},{"cluster_id":"fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a","members":["fecf7f2d-ea04-469b-810f-67960991e690","3ce707f4-2468-4911-aec9-34ed01947d75"]},{"cluster_id":"801c5c4b-a47b-4b2c-ae4b-a35937597f3d","members":["9c1de945-a8c0-4007-85d2-ab4e1cc29c97"]},{"cluster_id":"8cb39409-fba3-4dfe-91d4-98f7dbf55b5e","members":["0305278e-ed35-4d8a-a0b3-2bfe4fe16224"]},{"cluster_id":"9674610b-7b1f-4315-90d0-0aac1ad7fa99","members":["31cb46a5-aa5c-4bd9-929a-941d8a026f3f"]},{"cluster_id":"52dfdf47-104c-4ec5-bdb3-4d6a07a83d5c","members":["d0c92ac4-1992-4990-980b-2158d9d1f304"]},{"cluster_id":"2cf7e8e6-c492-424f-8353-8feea83e3711","members":["57482d6f-8527-49ca-b1e4-aa0481fb84af"]},{"cluster_id":"4d8a4d68-4905-4d57-b3f8-91de6feb19b0","members":["ee13169e-2427-4386-bcbc-81d32c5240bf"]},{"cluster_id":"9b321e6e-fd77-47ca-b965-6aceb0683d37","members":["501932eb-8e4e-4348-bb4c-961a5d7a5c51","e18a5763-a120-4afa-ae9f-76ba6dc6b6e8"]},{"cluster_id":"348d310b-39d2-427c-af87-143686fcd6a8","members":["e726a95b-d5c0-429e-b55e-aa22b0826505"]},{"cluster_id":"565785be-22aa-4015-82c3-a5551804b630","members":["32309a16-bc51-4681-a2db-b488abed842b"]},{"cluster_id":"6936f63c-d90c-47ad-bcda-def68b0ec222","members":["ed9e92b3-a72b-407b-950d-76f4ea220467"]},{"cluster_id":"f213c95c-e709-4a66-94d2-6982e6415c05","members":["dfe5731b-cf2f-4ee4-9e26-12eaac68b4f7"]},{"cluster_id":"7c25f378-94ec-4e09-b534-e05191ebdf2b","members":["07fc3f18-2f76-41a0-accb-9c0bbadb3e41"]},{"cluster_id":"f28068f5-d9fe-4cd5-a458-304fc4db522c","members":["2ba8d4cc-a5e3-419d-9e4c-ee2b544fdb4c"]},{"cluster_id":"b2e1f729-9431-42cc-affc-159e60e3c7e6","members":["39943a96-831a-40c6-9920-66942f6a22d9"]},{"cluster_id":"347d475b-a5aa-4035-8032-84126946c0db","members":["b0da3d30-908a-4fb1-a15d-c4d117036668"]},{"cluster_id":"3d26e147-f4b2-4b1e-ba9b-bf45396f5e59","members":["0feb5d9e-c17d-4b4f-acbc-a62b41630ed6","22add310-deff-4922-af09-bed7fb4c6eaf"]},{"cluster_id":"052da5ce-3d09-4c7e-bec6-952cf04794b4","members":["13abc88d-5f8c-44aa-8f59-2e6ba65eb693"]},{"cluster_id":"d116bd42-a280-499e-95f9-862eab4e8043","members":["385e9a11-a43e-4825-aaf7-8359018444f9"]},{"cluster_id":"b83a1d17-db6c-42cd-8ccd-d99d30b78f59","members":["0b6b7959-afc9-4a75-8422-6f7eb755102b"]},{"cluster_id":"ff03cd74-7869-49e2-a30a-40383add9c7d","members":["118c8dc4-7bd0-4d1c-b97d-24100912a230"]},{"cluster_id":"29912b0c-71dc-4757-ad86-50cb8c825cd7","members":["28b0308b-9327-4280-890d-cddac0e064a8"]},{"cluster_id":"89863001-f3cc-4b83-a5ba-601a96690a75","members":["4d9f446a-ef9b-4448-80be-ef5fb381ad63"]},{"cluster_id":"69dae690-93b2-445c-aba3-76b5fc2d7711","members":["dd2cbb34-56c8-45ad-a455-dae8ea105667"]},{"cluster_id":"e24b1f85-4581-4a8b-9bbd-39a7582f7249","members":["7055db5a-13ed-4e92-a63e-3b91d7c697c8"]},{"cluster_id":"ffd8b278-907b-41d6-9ed9-9d3e17a00678","members":["98fd8acd-2549-45ad-b7d2-a8ccb35a1e5d"]},{"cluster_id":"044cb84d-c3b3-4798-aaea-5e325bcd65af","members":["98910241-ea76-4661-865b-3fc6751e03ad"]},{"cluster_id":"95efba0b-bc1c-48bf-8e7f-8321983dc081","members":["9dcf2d28-2e69-4f4a-a1e1-4004ea60c1ba"]},{"cluster_id":"57c95e6d-bb6f-4da0-b18e-99b9d5c69c0c","members":["95ee44fd-819e-4e69-a0c6-6d8628545637"]},{"cluster_id":"f60ced9d-709d-49cc-bda8-183a3ced98f4","members":["e884d029-e79f-46d4-936d-220f14127574"]},{"cluster_id":"b49995a8-19fd-4ac2-ad8e-2c1b565ef509","members":["9be285a8-7478-450c-bb98-6b02a901425e"]},{"cluster_id":"17e824c4-f35e-49c3-9ffd-3049f0003451","members":["82fe0a68-7276-462b-b7b8-079ccc14ba74"]},{"cluster_id":"5716770d-1472-4c8b-9408-d81e71966a7e","members":["6dfb7d0b-227e-4903-b292-de4b409d7199"]},{"cluster_id":"d62e9da4-a6f4-4493-99df-7aea8cb8b7d5","members":["1b12ba3f-a1a1-4175-b690-984d1d530510"]},{"cluster_id":"a8758a01-da2e-4199-8bb4-bdf40b9dd8e6","members":["6a1d3820-e6fe-467a-8267-67da1be9617f"]},{"cluster_id":"73ac3211-808b-4905-b95e-ccdafdc4bd5d","members":["b38d6b33-790d-418e-99c1-38e44e1acffb"]},{"cluster_id":"ce538c96-9586-4a44-b4ec-f9e46a72b4b0","members":["e64cb007-1837-4811-8867-43dd7497c313"]},{"cluster_id":"869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f","members":["c9c0fbf0-a89c-453f-ac22-5bf199990d55"]},{"cluster_id":"92352325-85b6-4726-9aed-67119e9599f9","members":["ce059a55-a1c4-4eea-a508-a9ebacebdc74","34c5408c-1e1a-49f9-b0bd-04148f61a2b3"]},{"cluster_id":"1282bd1b-6e16-4c06-9f2c-9c9344b54fd8","members":["fe53b27f-bc03-44b1-8725-44e524ee2b8b"]},{"cluster_id":"5279c839-650e-45b8-a4b4-5af5d5649ea3","members":["40a5c718-7e22-4396-8c2e-32bf37f77173"]},{"cluster_id":"0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5","members":["721023c3-f992-4634-87a0-83197c3ded31","097e82e0-2a65-4af7-b3d9-e45351508ccd"]},{"cluster_id":"626701fe-ae3d-403d-9681-7d335f03c82a","members":["a1a6ea99-b4c3-49ec-b6f5-85eb901fbfe8","0f0735b0-0b64-43d9-b78c-c1bbb6bb8b3f"]},{"cluster_id":"3fb778a0-a02e-44fb-a706-5b4689fd37e9","members":["c54363fc-151a-4f51-bf9d-22d702af02da"]},{"cluster_id":"04b0fab9-75f9-45a3-8f7f-91f5ed199dc0","members":["db7346d0-0b92-4165-828d-0e8f2f59205b"]},{"cluster_id":"b627252e-5ed6-4562-833d-dbc3b3ef2c2f","members":["1b2c529e-9c99-4ae9-93d7-b48b6a54d927","0c174304-050e-418f-a279-afae9d4dad42"]},{"cluster_id":"1310ff3c-798d-4934-989d-8b8e4e0530a4","members":["a5faa4e1-3e12-4dbe-85c7-2df6e0d41099"]},{"cluster_id":"a7acdb17-a586-4af4-bbd7-68b913003d4e","members":["96fff80f-1ce7-4ce1-9985-d1a73c44d044"]},{"cluster_id":"5f1df598-4786-4f75-aed1-8eb66dff4278","members":["2261ba1b-448f-4b56-9b53-4dd43a3f7a37"]},{"cluster_id":"6aa1529b-b06b-446b-af24-0e7a95f9cc1a","members":["5a29eb59-d254-473a-a747-e01c8152d4ec"]},{"cluster_id":"82b56123-1ab0-4271-8360-fac7c8b1d118","members":["15b48165-c232-44fb-94d6-ae4e9e5c63a4"]},{"cluster_id":"ef3db80b-5215-490d-a636-85e6bcbe9e93","members":["da32d510-4c41-4b5a-a4b8-93aef86bc688"]},{"cluster_id":"a3015153-afe6-4168-9a99-d14bbbdd401f","members":["314c4b9b-05f0-4aee-92e9-aabd47c81cec"]},{"cluster_id":"62c5acb9-493e-43c7-9647-7858b2ea0c50","members":["0bee1005-e9ab-4e90-8495-090199b0897d"]},{"cluster_id":"d770e161-8ec1-425e-95c8-277c26523ee9","members":["1bd90170-ccea-4e04-b3d5-20ce31df06de"]},{"cluster_id":"91237aa3-bf57-4535-84ed-6b39c0f1b3fc","members":["688031d5-81f7-4c53-a247-743c996e4563"]},{"cluster_id":"85b491d8-b806-4e3f-b616-3cfa5f5fa60f","members":["ea47ac8c-9571-4a89-8a98-d768143ca1bd"]},{"cluster_id":"3422b937-ad13-407b-bc17-21e8928a73d8","members":["f5a5d426-8a1a-4b25-8db3-4350603c6041"]},{"cluster_id":"c7d67f17-53ce-45fd-95d4-ee1ed41ef6c6","members":["cfad659c-cb91-411e-b838-43338e2259a5"]},{"cluster_id":"f8d1571f-9c56-4682-8574-cd3b32ed6cc6","members":["67ddd5c7-214a-4d5d-b759-ee5548e2cde8"]},{"cluster_id":"a9876e6a-52b6-4181-945b-9e745a17434b","members":["cca4f7be-96e2-400d-b27b-e1defa7434a2"]},{"cluster_id":"9bfae508-3289-4175-a44f-b761d47a58ba","members":["e198a5f3-f610-4ce6-8505-b7ff7e34d9cd"]},{"cluster_id":"3bff863b-ef2c-4985-ab4b-24af72e149e9","members":["3ccdb77d-b841-4282-ae76-ba8e2f8b361d"]},{"cluster_id":"03ab33c5-869c-44e7-85ff-a26adc857fce","members":["7f8d9241-333d-41c9-bcbc-7cc2af18e259"]},{"cluster_id":"d769b36d-aea1-4403-834b-b416d2db1047","members":["54774750-6451-4196-a2c5-8668041813b8"]},{"cluster_id":"1edefbd4-7887-468f-8ea8-789dc55de3db","members":["516e9191-4150-4f89-9a9d-06c8702e5117"]},{"cluster_id":"65f75788-4ff6-47c1-8a6e-6bb7cdd19537","members":["949e61da-22a2-4985-9fd4-de24d561015c"]},{"cluster_id":"f21aa624-4667-4f48-bb4c-1942acec5158","members":["26f51bef-6306-4cd6-bcb2-780b717ca091"]},{"cluster_id":"216c68fc-7c8f-405c-8f46-568b32c69eb4","members":["38198833-eb7c-425f-92e8-694e5ef24acb"]},{"cluster_id":"ecec86b9-e0c2-4698-b5d8-0631850621a9","members":["a207afbe-4dd3-439f-a8e7-7336149b467c"]},{"cluster_id":"f4766e96-74eb-4ff2-aa7a-ed465ba83cbe","members":["ed2ed877-46e8-4358-851e-d900f564ac83"]},{"cluster_id":"88f7cf16-b8a2-4b9c-98ee-aad660820b7c","members":["53195865-e8f7-4076-9d02-8a49a466cb34"]},{"cluster_id":"92fc4500-350f-4d12-9690-7e529074f891","members":["6dd2be4b-91b8-4c26-9050-a990c250143b"]},{"cluster_id":"2ef61e30-e6d5-41b7-8ea0-69add1125af6","members":["45d81d20-c534-4029-800a-27e1f275a439"]},{"cluster_id":"72242d20-ab02-471e-ba74-fd7caad2c382","members":["657c0cbb-669f-40e7-9983-2bcc27688e5b"]},{"cluster_id":"c95c962f-c479-4151-9149-d13898c2a6b3","members":["2f51cfb8-e217-4101-9ecd-ca150c2bf799"]},{"cluster_id":"f7a6ba19-2cf9-487a-a498-908208872dae","members":["c88721eb-b13e-44b2-854b-d3b82482fbfa"]},{"cluster_id":"89ee63c1-fb19-4aa6-ab9c-62e22a3b7244","members":["f7a91795-523b-4b76-9f51-a9118e118291"]},{"cluster_id":"ccdc4717-b37b-4b1b-94a7-20dfafa305fe","members":["6f20fe88-be70-4d4c-a915-de8c4c5b535c","8aa39dc8-d60f-4378-93f2-4036d197cd07"]},{"cluster_id":"cec3a521-c732-4e0b-8192-f6efa6c46d10","members":["89a8455c-ba43-4744-9921-977a09d0deed"]},{"cluster_id":"983a818a-ed6d-40ec-af64-8e28da7e1bbd","members":["e6a17aff-8b81-4824-bf2d-718dd2e011da","62b1c349-8a48-41c6-aff2-041f14d94129"]},{"cluster_id":"356ce4de-dd2a-4caf-bb6c-703dee1f13f4","members":["75866a69-139a-4618-8081-25cdae28617f"]},{"cluster_id":"b7375a29-4c73-4062-a85e-7e1c1f79300d","members":["060a96ad-1d98-4702-8ccf-e51390aba2e6"]},{"cluster_id":"b07254f1-f996-464b-a61c-6949e39dcdb5","members":["81510421-97b3-4279-9cc0-9f0343057db8","d31b6f35-3e22-4748-bfc3-2024cf70804d"]},{"cluster_id":"d4f9c49d-3b78-4035-b051-f58469f25ba7","members":["650cbc5e-d8af-469e-90a4-504e75adc3b9"]},{"cluster_id":"ede13164-94fe-4382-9f88-120091c29cbc","members":["15a43cb1-bbea-4dcd-87c5-43ee5922e048"]},{"cluster_id":"83df36bd-a3ff-43cc-b6fd-c979f5dfd9da","members":["6c534fc9-fcac-4607-902b-1272dbf1c0a7"]},{"cluster_id":"50c706cf-6243-4e9d-81ec-789d3dbecc99","members":["ffab163b-2bdb-4374-996b-8bf59d3c3b70"]},{"cluster_id":"b01fa043-31ff-48da-8746-ca50ad89a48a","members":["0e7761d8-4680-4c3f-8a17-955663c844a5"]},{"cluster_id":"9087a989-a032-4a4f-877e-3dd17a8e6902","members":["97d6446f-064c-4508-bdc4-990a4467f02e"]},{"cluster_id":"a5da6c97-e954-417b-b043-c6eda504cf34","members":["5d6133ee-f749-4be1-8804-cc25d1fd0848"]},{"cluster_id":"128ade3d-bda4-4b71-b956-463eb584089c","members":["82eb5dca-d1e4-463b-8328-bb70084866ce","25bba8d0-7a7b-45ed-9973-9c6ccc480852","65c099f8-b04c-434c-82f1-db7b66e3bb75"]},{"cluster_id":"3d7436aa-4609-467d-a098-e24702a617e8","members":["1cbe5805-33d2-4a49-bedc-c8b721a9fcc9","dc63181f-17bc-4343-b478-aac247e55192","b8455709-3440-4c63-a8b8-4fde488d3279","2c7e26c3-b9b3-45c9-af2b-3b4ed695a329"]},{"cluster_id":"658c3b98-6196-42b5-b086-e8814a2a7b5e","members":["f1be433b-64d3-4ee2-b711-5bddbdc3b211"]},{"cluster_id":"0ecff957-070a-4e14-9ee5-9c4a7435ec3e","members":["789d58fa-93fb-45bb-9abe-ff9b780c7054"]},{"cluster_id":"a58a3450-f18a-4787-a5ff-ce87f4539ba9","members":["46008da7-e2a3-4b5c-804d-7d973706141a"]},{"cluster_id":"49c9cf48-a13c-439b-9db3-4000e6bfc74f","members":["5a61323f-1a46-47aa-9fd4-188965d42c37","10d02800-aa81-4b60-a52c-44f70d5a4ba9","2e12c729-9448-4e2d-9dc1-58e700aa8af7"]},{"cluster_id":"347d7cc9-3711-496c-bdf7-6c0c22b3750a","members":["cd27c98c-714c-40db-9d27-c4aa5d05e25e"]},{"cluster_id":"7ba2e807-ddc2-4313-891b-359c6bfa546b","members":["61ee1818-cbe0-4db7-8b84-c29f877894c6"]},{"cluster_id":"9c028d31-caed-4945-8a22-834a8ca119bc","members":["ccd7dda0-7348-4bda-996e-629c18077678"]},{"cluster_id":"e50f2f1a-20bb-46bb-82c9-6def0deadc19","members":["c8c9e73c-4cca-4518-a635-034e32de8980","3f8b75b1-2c42-4fc8-a159-ed729971cff3","945dea35-f608-4c69-9696-2e53442a9e18"]},{"cluster_id":"d6c8b67e-0b10-44df-8f54-3d630f15c443","members":["ed852cdc-bfd8-4384-b486-65cf10530958"]},{"cluster_id":"5eaafca6-4075-4128-8780-266e84f06a62","members":["0abeeb58-cd42-46a9-9bfa-159671d5c4fa"]},{"cluster_id":"fe7c0aa8-6a9f-47ad-ae53-9de7a81cea64","members":["4ef86bde-843b-46f4-a89b-ed61b420fd30"]},{"cluster_id":"f37c17ce-c0f0-4c37-a425-7857fc4bf5bd","members":["fa0fd9da-5c67-4038-ad8d-9fb160b4ad27"]},{"cluster_id":"a57199f1-f704-4a31-b1b8-b56b52a4b405","members":["17d38e55-503b-4ec7-8441-ce132a230a43"]},{"cluster_id":"c19838ee-ef85-408d-84a0-c28811354698","members":["46ba9c8a-38e6-4870-92f3-71c773e089ca"]},{"cluster_id":"af509b02-6699-4697-8018-d3a627ada0fd","members":["a47f9cd3-6c32-4586-850b-a0ddd5db7fee"]},{"cluster_id":"42322612-a5c4-4a48-abca-12e69bf326a1","members":["1a2742e3-d3fb-48e5-bf4b-b4fc1e5a362d"]},{"cluster_id":"ebcc0902-6e47-4925-9d19-ac06d520106b","members":["11e57b20-8edd-482f-8d82-40fbbc59b90d"]},{"cluster_id":"3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909","members":["437e98cd-85f2-47db-bac3-f5e207d213bb"]},{"cluster_id":"ac8a01c8-dc87-4d9e-80a6-4614b1d6d5e6","members":["3dcd7b1f-01b2-48b2-8627-6bb067f50b75"]},{"cluster_id":"9c02d7e0-91d2-4077-8adf-0916536016b1","members":["47b0c8dd-d904-48c3-a850-620108d989e1","425a5c11-f27d-4f43-be17-a3bb22e2b8c0"]},{"cluster_id":"8a222396-efb3-4d74-bc35-db09fb52168f","members":["2bdbcfa2-b80a-4f15-87e9-4ead32abcd47"]},{"cluster_id":"f7bc5745-3844-4596-a6d1-1d8cba63f4b6","members":["49f9b46a-f921-44a8-aaf1-5ea187468899","1c178e2e-5b14-4c6d-93fc-1b8fffd907e6","eb6a35a6-a8a8-4668-aaf2-04d473829da9"]},{"cluster_id":"f5cb17c5-09b2-438a-8af3-1ddc4e587641","members":["c06f10aa-ef48-49f7-8472-ebbd02c3d8b5"]},{"cluster_id":"3c9a1b13-b4b6-4090-861e-e35159e61286","members":["e581a1e2-e362-4c93-9f84-238c6c5d5159","ed0d1125-13b6-49a3-9515-4aeb847b3975"]},{"cluster_id":"e95aa789-4bbc-4c2d-aa4e-ab829c64ed4e","members":["2e6de9ab-0fc6-44c8-b407-aa303e166569"]},{"cluster_id":"bafef2bb-9288-4a42-8a15-be9d11a861ef","members":["ae74430a-5949-4b95-a120-a6eb384fd9bb"]},{"cluster_id":"36e8c4e1-79bb-4ee5-81d8-1178da8ce862","members":["3bf4e4fe-3618-4cb8-8d2c-abcfe64d9596"]},{"cluster_id":"81d7440a-8ada-45a3-8b2c-8318c7034ac9","members":["b728548a-c090-4038-9c76-17794be02f65"]},{"cluster_id":"8c588fd7-3da5-41c8-be96-210ededa9175","members":["1e92e27b-0ddf-449b-83e9-404d8da25044"]},{"cluster_id":"30adcb64-6b84-4937-a83e-146b8ce17e82","members":["4c42f1d4-18f9-414a-8489-6a66fdc45116"]},{"cluster_id":"5eac68c0-2a04-4e6c-af79-6d253e14522a","members":["4c7d4d49-9392-47f0-94fe-c2a411854cab"]},{"cluster_id":"09a67b60-49c6-4757-b8ff-5613fc63f6fe","members":["1b2898f8-0b9e-4973-8d15-1d632394728d"]},{"cluster_id":"71624d95-aa07-4fb2-8217-706e01ae4a63","members":["79e8c735-743c-476f-a650-01f059fa32c1"]},{"cluster_id":"2d65299b-2b98-4ff0-9197-e120b19ce3bb","members":["ad1ef3ff-142e-42f8-8b0c-469d655ebcc3"]},{"cluster_id":"7860ac7c-a8a6-4b0d-8952-927a859be338","members":["cb13afd4-7f7a-447e-8c59-ffacf2dd9a71"]},{"cluster_id":"70bf9f45-ce2c-4053-918f-69d225a10029","members":["29f831dd-3583-4717-b70d-08c20c2277b5"]},{"cluster_id":"52d598fd-9b16-4bac-b3f5-6b1dca718bc7","members":["8671ab76-5e75-4a4e-924f-ede3eddbd80e"]},{"cluster_id":"16d77388-3cab-4281-9420-51dc93557442","members":["4ee7de3b-1f60-445f-8a66-cc678fc92f3b"]},{"cluster_id":"a5e788fc-37bf-43d2-97b2-732f917263ab","members":["b59a26bd-e33a-41d1-ad8e-57ce8f617df6"]},{"cluster_id":"4b572207-fd2c-4388-8ae9-d177ee557903","members":["67c3c742-90ac-4337-9018-6e7ff134b06b"]},{"cluster_id":"4f8224c3-991e-41ac-a885-d9b58bba5d47","members":["444523ca-76e6-42a5-8557-f2d374e6f96b"]},{"cluster_id":"6da8eb62-757c-4652-8389-b32015cb40a9","members":["e28fde96-9f0f-4cda-b767-ef1e03a07eab","b6ee86a2-5295-4ca0-b93d-53914a4ebae5"]},{"cluster_id":"c7b52427-87e3-4932-9690-1d3cb09c79b7","members":["6cf34b83-d38a-46dc-8302-a20288b0d780"]},{"cluster_id":"20d38dd5-1da5-4494-8238-6be550e715af","members":["5b8a68bf-3608-469c-b027-3fec24302b2a","d5bd185c-ef57-4e4a-b660-99b8fcb2005c"]},{"cluster_id":"da057e1c-8692-4118-a2c6-f3b0fa767931","members":["46c01df2-2feb-4f99-bc16-539c8ca2b867"]},{"cluster_id":"315e3fc3-9356-409c-9b82-9011a9ad2a72","members":["a6c232db-1a65-43e5-99aa-56186d183ca5"]},{"cluster_id":"c537edf5-ee14-4fb6-9cf6-9d972fbc67cb","members":["9306dc4c-bbdb-436c-b00f-b410355002aa"]},{"cluster_id":"8e8f1a63-a25f-436d-856a-cda548ff35df","members":["458aeba4-416b-46fa-a35b-ecd460f72be8"]},{"cluster_id":"beec5e0e-fafa-473c-9a37-0736cf0853e3","members":["edb8e667-b21a-45e7-848a-98aac580af24"]},{"cluster_id":"d7c2bd39-22ec-4271-8c63-6ddb8efeced9","members":["8c142b12-a65a-4ce6-86ae-aae44f23c9cc"]},{"cluster_id":"a720530c-6855-4d9b-b222-ba31bac4c4c3","members":["e748127d-9540-4a39-9726-f81edd2c8e8f"]},{"cluster_id":"43a57714-f5d9-437b-8d5c-b293145616c2","members":["e3b3e9fa-930f-40cb-a960-487fe2683fab"]},{"cluster_id":"2293ca8e-aa2e-4ee2-b17a-f9a9255d1eb1","members":["80f55654-6963-44a9-aadf-53eb4540c6cd"]},{"cluster_id":"ef96e980-1163-49a7-829e-855a0719a797","members":["ab5a60e5-1d17-46e0-8127-9a12fee20233"]},{"cluster_id":"b3940e35-7d56-462c-b357-ee3bc8987319","members":["2d9b57e8-c3c3-4496-889e-49cbb023c515"]},{"cluster_id":"90d35003-13f9-4cd3-a3c1-b7524ac5bf16","members":["9e528c86-3518-44cf-9457-649aebabe1ac"]},{"cluster_id":"8711a577-7906-443a-8adc-19d760bca08d","members":["9c94162e-1144-4d01-9300-a5d1061c9b0b"]},{"cluster_id":"4b012ae0-8a3f-4446-8ab7-f0572ce911e0","members":["70adf12e-fa53-43c7-8d7a-2f599125e473"]},{"cluster_id":"3c02cb9f-d868-4d95-a235-953e540c09c9","members":["d9906cb0-4f96-4c12-af10-045c3e9830a5"]},{"cluster_id":"314e86f6-17d6-477f-8886-75643cc5dcde","members":["a994727b-62ac-4e99-9ff7-b623a3e7ce1e"]},{"cluster_id":"60a99f19-657e-458b-aa53-ca2a6063f380","members":["a4650293-dc10-4ba0-8b5c-2a53b5c104ca"]},{"cluster_id":"94346dc4-a4ac-4e3c-85da-06445ad201ba","members":["5d538b3b-083c-4c70-b5a9-0f0dfc1aa3f0"]},{"cluster_id":"1179f0df-1a7a-4032-9a7e-362081c484c8","members":["38e35b26-e0a3-478a-b08d-491381d5c88a"]},{"cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f","members":["e02e3907-1835-46df-850e-452f3b834bf7","842d5a71-e5da-45fa-9689-793dd7cb8c7a","a12b2da7-f04b-4c9c-a3db-7be295e9d41b","cecf8006-3769-448b-bee9-c409927c3538"]},{"cluster_id":"30d502a9-a0ce-4646-9e1c-b03b47f8dd5b","members":["541465c0-ead7-4c43-8610-39c68db9ae97"]},{"cluster_id":"154780a4-c583-40d6-b0cd-5a3d8a1994cb","members":["0fa1cb68-fd34-4681-8f0b-84ed327d371c"]},{"cluster_id":"2cca833d-ae9d-45ac-9501-885a938605a6","members":["dad446c8-03c1-413f-9114-2f9d5e01bd8e"]},{"cluster_id":"4a10d70f-5f46-496e-a6f4-0b982956d03f","members":["462e4a03-4d8c-4341-833f-f2ec89502281","292f24fb-5458-4a2a-8be5-7fc08f6f336f"]},{"cluster_id":"b6c6623b-ece7-4fbe-8627-8db59a5e3dc8","members":["4e8ef4ff-dc82-4121-ab94-8ddfe30d3f14"]},{"cluster_id":"1f7a9b1b-5ce3-47cc-9f13-4f47996738bf","members":["68c425e7-db7f-4682-8099-2f8ee5563c2d"]},{"cluster_id":"b5a04b5f-b3fb-4230-b364-c7b2ab5c4aea","members":["8ab14ca7-177b-42cb-ba67-cf8818192e53"]},{"cluster_id":"0b2d3f06-c549-429d-9974-6e988853ab88","members":["818fdb67-5968-4972-ae07-798bd412f8b9"]},{"cluster_id":"58d2f307-4ee3-44ad-a765-c7a292798624","members":["47af4d33-0512-41a8-a25f-30f4778003fc"]},{"cluster_id":"5fee0957-a733-4e61-bf4b-0025d615e97b","members":["60c71afc-0960-4690-ac6b-3a2929556e3f"]},{"cluster_id":"d6e4581d-8b56-4f44-aadb-7c57a4d3eb29","members":["c87b17f7-61ab-471b-91cd-5716b5aac344","1614d4e1-9ef9-4d1b-aef0-7beefdeafd27"]},{"cluster_id":"c09c5abe-d2d4-4b78-b32f-49fbbd5778a7","members":["83bd32b7-c4ae-434d-9e02-3e01d321661e"]},{"cluster_id":"4e1f9c12-6559-421b-814d-33b10f78b8a6","members":["f1647966-4838-440a-aebf-82a10a8894dd"]},{"cluster_id":"b8594232-f9f8-428c-83d8-cd858f613031","members":["720a46b3-59b3-4358-870a-89c487e84d5c"]},{"cluster_id":"e0ef928b-5c3a-4954-b041-cb096ddc889e","members":["8199722f-107b-4824-81cd-a4e9f21e452e"]},{"cluster_id":"281bccd6-4eea-4bfc-b9dd-b2e9300159fb","members":["f4760408-3b19-425e-931d-f5b85fa7ad2f"]},{"cluster_id":"d4c689b9-e4d7-4a70-913a-2c31aac2dfbf","members":["fd1e2a9c-0bc6-4fb6-8afb-685739fed911"]},{"cluster_id":"c355c9c0-a133-4a94-b40c-10d91addc7eb","members":["f2497bf6-410d-4898-9795-ebd88e880c0f"]},{"cluster_id":"f8fb699e-3174-4e1f-8079-1bb9372cf5ca","members":["364f0dcb-c131-4adf-a34b-8f19f88d52a7"]},{"cluster_id":"0c3b0687-d7a3-4aac-ace5-4b4027adcc13","members":["fc990176-3f23-4e69-9e6c-2950dbd56f07"]},{"cluster_id":"798603bf-ed29-47ab-b596-b02a192b8a20","members":["bf0075d7-5c9c-4369-9994-3b19f20c9099"]},{"cluster_id":"c5d49178-7807-406f-89c6-f05965bb7e2e","members":["8f987eb0-0364-48bf-936f-1e5b5fa5087a","c36de96c-9b8d-4c9e-a111-d540a59acbda"]},{"cluster_id":"4703becb-493e-4c1f-aff3-21e217d2c90f","members":["6399ab81-8bf9-4d35-8afa-a1c2d5c281b4"]},{"cluster_id":"212cb6aa-4aac-4425-b0fc-6bb9b68aeb36","members":["99376817-68db-4068-9cbd-fb73baa6456e"]},{"cluster_id":"5dad5c87-4292-488c-b998-f9a86f6c59b2","members":["869f4856-096a-4864-a678-c4826830fab0"]},{"cluster_id":"2f0fefda-5b83-4f80-8b8a-97c292bbda20","members":["d7d8e3b9-ac2d-4fb0-ab2a-62ee7454889b"]},{"cluster_id":"23451a3d-c01e-4597-9cbd-b34940e92d21","members":["9a4403c6-b2ac-4ec5-b6b2-1619c342bcc2","39119401-4fb6-4c51-a4a2-509133c89916"]},{"cluster_id":"b7612309-cc53-44f3-9740-76cdf065b6eb","members":["b1b0c026-7199-4aa6-a048-93c13840edda"]},{"cluster_id":"22523c97-d6bf-448a-b10a-ccd7fd668e2c","members":["822740f5-e6a4-43e6-9bee-e14d64272496"]},{"cluster_id":"147ac41a-7de3-4c4a-9213-48dfc49549a9","members":["dda7fcf7-59ad-43a1-ae33-26eaf103fcb7"]},{"cluster_id":"cecf5ab1-6a32-4285-b19c-a1e9eb89d592","members":["79419e99-ecaf-4138-b2b3-f7cee50fa0b0"]},{"cluster_id":"ff15e2e2-1cc8-45e2-9674-8847b94be12b","members":["78bf4fdf-0835-4b4c-a611-940cce285dd5"]},{"cluster_id":"a10aa5dd-2106-4783-8254-02da84449919","members":["6bbb635f-e0f2-452c-b57b-b5a70779c142"]},{"cluster_id":"f71cbd0f-7a85-414d-845f-e4694c67d02e","members":["26067bc5-831d-4b3a-b9b4-282d8ffa5e85"]},{"cluster_id":"7b54b660-7b67-4765-8335-f1bb9a8cf70a","members":["52833197-6a55-4070-bad3-f5ad28d3d8bc"]},{"cluster_id":"1fb31a41-f917-4cde-9190-f353f630be9a","members":["6c30dbdc-810e-41d7-b83e-f6e17c80a0c9","7482a314-6a20-4c76-a5d3-56a28a432af1","d0f7b228-5da3-499d-ba68-8e855018863d"]},{"cluster_id":"b38c991a-b869-4a3d-9864-3fdbb089a284","members":["a0b3494f-3b25-43d0-9637-2573e7d8135b"]},{"cluster_id":"36ad2a89-3229-40ad-9f6f-f2c33f4ebacd","members":["2a7bc1e4-5c5e-40e4-acda-c53dafd3c9a0"]},{"cluster_id":"ce27cd6a-2828-4d90-a12f-a0a6f593b1e0","members":["8b65cbf9-7f63-4595-bd95-246ce73c6301"]},{"cluster_id":"a801c6f6-51a8-4c16-ae79-750cf640303a","members":["03d26c5d-dae0-43de-bb40-e12f1a0a1713"]},{"cluster_id":"4b5e2cb0-217a-4cdc-81e2-027874f8da18","members":["516f9430-7cb6-4c16-9ce3-0f1dc1d59ae7"]},{"cluster_id":"48704c98-ccd1-4907-aeb2-d6276a1025d7","members":["48c5dddc-78ed-48ff-a24d-21039089ec99"]},{"cluster_id":"80f966d4-497a-4e7a-b9e2-4d30faf7da72","members":["2f591cc6-766b-4de0-90aa-5e326145da63"]},{"cluster_id":"8c65cc84-ce1a-4345-89d7-20ee4e2bcf15","members":["988a9c58-5f46-4af4-afdc-75d17fc213df"]},{"cluster_id":"569a8b8b-9b0e-41ed-a2cc-db56c71f5703","members":["8cb449ff-d21b-476f-a26b-289f9014209e"]},{"cluster_id":"3bbdb582-a477-4388-acb7-cf6123d0c022","members":["6f925d02-63b7-45e9-afa7-ed6665196762"]},{"cluster_id":"6ff7ccd9-f022-43dd-91cb-c864da8c63c2","members":["56b2e091-1cbe-40c4-a60d-667253b89be3"]},{"cluster_id":"c79e73ba-e1da-436e-8dc9-c8818873c182","members":["153e7304-a747-45d2-89be-8d56d7ebf0c2"]},{"cluster_id":"25a5b743-428c-47c7-abea-0b994fd987b8","members":["20a7f975-5a4d-424d-95ab-5ceb6cc370e2"]},{"cluster_id":"ac3c6b64-fc97-40dd-93ef-f777610b8337","members":["caf47164-4bc5-4b92-a634-49bfbbc70e58"]},{"cluster_id":"8e541384-70e4-4c7e-9ac4-ec79ad71649e","members":["16df827f-bd7a-497f-802c-657b4b130b45"]},{"cluster_id":"a8cc6e44-ab60-4366-aa46-06f9a46a5810","members":["350979a9-e5d0-450c-a30b-382c9e68589c"]},{"cluster_id":"84708f88-fae9-4536-bd01-2d6209b5f616","members":["3f7fdfd4-3e46-4d00-9a45-83acab5ddb62"]},{"cluster_id":"44317cdd-77fe-42f4-b1db-9819636d2f58","members":["239b27e8-d089-4e57-98c5-4c76455d13e1"]},{"cluster_id":"a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d","members":["81417279-482b-47bb-824a-1e4360669d2c"]},{"cluster_id":"72f778c7-a74a-4822-89c7-75defc5fed4a","members":["cee4ea01-6eae-46e4-89a4-59a920fa04a0"]},{"cluster_id":"14087e7a-3bac-4d48-a154-8c1e158e6c14","members":["2769c0f5-344b-4758-b766-c38b432afbdc"]},{"cluster_id":"82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc","members":["8a516dda-7f66-40ad-8d0a-4790dec2af9e","ed9f52e2-be9f-48ab-9f06-0402ef0d2399"]},{"cluster_id":"7e17abde-ea9a-4656-9558-6e168a28baae","members":["a80a49a4-31da-41a9-8200-1b85ad04386d"]},{"cluster_id":"777da0e0-2515-442a-8eed-8174f7063a5c","members":["409eb38a-b470-4060-875d-2a70306e343e"]},{"cluster_id":"ebca8a8b-8a95-480f-8cf1-c34e09e5822c","members":["9c039d26-a19a-4ab1-acab-9eeefb6098a9"]},{"cluster_id":"3c077d24-2d6b-4d5c-a441-5e0080a81669","members":["cdbc5470-c4bd-49b8-8dd1-ad1172e9f3e6"]},{"cluster_id":"6ca3fb21-cb25-40c5-9b5e-3ce14f640344","members":["1e104b78-27ab-417a-b7a3-a811b036f8da"]},{"cluster_id":"8b701600-84ba-4ca4-8c27-5ea0e1457d2b","members":["c3b69cf1-ef52-4f7c-a3fa-6f15916226ce"]},{"cluster_id":"5abfb564-f878-4ffd-9c7d-3328a283dbfe","members":["a0dfc6e8-dd9e-4100-91c8-a8bbd3e7e379"]},{"cluster_id":"e74b075b-e6e4-4efc-b7ef-f8a74fd509a0","members":["e5acb719-6e1b-4c0e-bf26-60b264eded67"]},{"cluster_id":"1d2ddf8d-adbb-42d0-bc0a-c14744855316","members":["0cf8c26e-fa57-4bfe-953a-ccd79ef5a5b1"]},{"cluster_id":"ac2593ad-b73a-4ed3-b199-eed400affdc8","members":["c28361a9-b80f-4c17-bee5-aefd916e9766"]},{"cluster_id":"398bd69e-f1d9-412f-8469-51469e37a88e","members":["064c7739-3b88-43cd-92ae-29cd789412f6"]},{"cluster_id":"4175d453-3f8e-438a-adde-113f24ef2a95","members":["2b83fc24-9c8d-42a4-beca-c56726ad2a54"]},{"cluster_id":"2e75fb89-d4ec-437b-bb34-741837209437","members":["9eb89195-f804-43aa-988f-f7e451bdbd64","78ab6f1e-93c8-4b9d-a81e-c46d3f8a86b0"]},{"cluster_id":"ae7124a9-0441-414c-a93e-4e31fac08e18","members":["bbbf880f-a3d6-42f8-ad6e-06e0e077e13a"]},{"cluster_id":"99042c58-6307-43ca-ac61-061cf8a5ba75","members":["860ccafc-2b23-4002-942b-bb242f004289"]},{"cluster_id":"38e3f6d2-565c-42d3-b90a-be4665a0d1bc","members":["a9f960be-0d8b-42d4-be70-d97e78e0155a"]},{"cluster_id":"b6472eb8-adb5-40da-b075-e00e04ed2920","members":["4740cab1-8725-4fc8-a0f0-f1d554915a43"]},{"cluster_id":"7b0bfb4f-e506-40fa-b633-0da23dace3d6","members":["8ad73028-8c12-4fa6-a432-5b4119bf63dc"]},{"cluster_id":"35a90496-100d-4386-a3d0-578c543e7dd4","members":["08f91ad3-d5ad-4436-88ab-157ab205095e"]},{"cluster_id":"a2a4882d-9cb0-4b1a-8852-37a056ca2ca7","members":["243dbeb3-88ad-400e-a589-41c8938ab022"]},{"cluster_id":"add21509-fc05-4fe6-a953-c98cc222477e","members":["6aac85c1-f89b-434d-b528-04e5dff82c6c","9083b198-ef58-4d0a-b7b5-7f51f62c70a4"]},{"cluster_id":"af6d1e09-650d-4e43-84a3-10adfa5661af","members":["e8b208e1-030d-4a27-bb7e-7787553dc27b"]},{"cluster_id":"e4e6149d-8b97-4295-847d-c2c2c5acb8ee","members":["e8399eff-e7e6-4b21-b154-272768481766"]},{"cluster_id":"f3a349ff-3152-4d09-b280-f92890a46edf","members":["944d2dbe-3483-4e47-b538-7b8559e9d958"]},{"cluster_id":"0c87e09a-5d40-4c46-abb8-ffdda4139e41","members":["1136f4cb-a49d-41f1-9cac-d70dcf211cbf"]},{"cluster_id":"a2925234-109d-4c57-aac5-814b5a99a831","members":["25a1caa7-d6f5-491d-9e2f-0a38fb2c651f"]},{"cluster_id":"5fedf7dd-6fac-4316-b725-5d2fe32ac129","members":["1f092cf3-991e-4bd3-853d-2a376f8ad7f0"]},{"cluster_id":"18554ac8-5c14-44ff-910f-06120f4b5680","members":["b129bd74-7a51-4dec-969d-ea1fbdf47d0a"]},{"cluster_id":"f9f6b7b6-ec7e-4aa5-91d2-9d2cf4d35a54","members":["dac7813d-7275-44bb-ba70-9b18cb0b92f0"]},{"cluster_id":"077c9500-5508-46b9-9207-39c50c9150fb","members":["c1a76e96-5a4c-423f-ad79-fe2527f488fd"]},{"cluster_id":"6a3f5b65-ac92-4e63-91ac-fe203f06931f","members":["59bfd6ec-34b7-470f-93e9-7f20adf47941"]},{"cluster_id":"01a95de5-1ee0-4431-afa3-a8234a4831ac","members":["6ddc3e25-2e33-41f1-ad1e-666dd835a9a3"]},{"cluster_id":"0e36f836-fa5b-40df-8bd7-860b08ef47db","members":["c3b6dba7-c61a-48bc-a3b0-5cdb54988e2c"]},{"cluster_id":"846c89d6-71e0-4858-9977-96bc0a6497b3","members":["50fe6559-6f9f-4660-9edb-49929b234b82"]},{"cluster_id":"8b3eb310-4541-41ce-8ebd-0c1cfe7b2a0d","members":["88585fe8-9d78-4049-9dca-176f1d48d205"]},{"cluster_id":"ed912a16-7c22-4013-aecd-05fbaf2f3003","members":["f30159a5-55d8-4fa2-a777-19e4b9407855","a83dd8f1-3dca-4ac7-9e54-9a86b91766e7"]},{"cluster_id":"a5739240-460a-4fd1-b5eb-223091bc040a","members":["6f732b0b-8064-4b90-98d7-b3a056cfe23e","9414863b-928c-4d55-a823-f666352f7066"]},{"cluster_id":"07ba7d5a-bc3c-4f63-a8e0-6487f494c700","members":["13e0a4f7-4725-4307-982d-1d8a5d9aea21","c24eda70-eb48-4889-9a52-0b84731513cf","6d18bc06-08d9-49b1-a732-ce69be1a92bc"]},{"cluster_id":"69c908c7-3fb6-49fa-b102-50233b107e27","members":["9c39dcd3-3a13-408d-9f46-a0ff637bd8a7"]},{"cluster_id":"b92e2016-2cf5-4f68-ae85-5c01d12bbd49","members":["288c9dd9-3458-4f12-b4d6-e48643cca886"]},{"cluster_id":"fb360de4-aab2-45d9-8f25-8bdd44c0ce45","members":["719f65fd-c5e6-45a9-9c6f-87b91510dcff"]},{"cluster_id":"b978e9a0-f48b-432c-b14c-50e4efff007d","members":["a528a283-82b0-49e5-a211-6a00230e9650","0056a45e-1104-437c-84c0-4e7b7467c2a0"]},{"cluster_id":"13862105-6364-499b-aec8-a649c26c5b3c","members":["f372bcce-24f2-4ed9-96cd-3179650f748f"]},{"cluster_id":"d855e2c8-0fb0-4813-99e3-3fa003818f71","members":["4f338687-ee12-4164-af7c-22d507a2227f"]},{"cluster_id":"3eb4bc87-51f4-4c2e-990b-944e8a053ab0","members":["3d76c853-db5b-4627-a972-02d243783eee"]},{"cluster_id":"c49a8079-c568-4dfa-a64f-74a395498785","members":["a4af2e0f-25a6-4104-889b-f1dc8a920a6d"]},{"cluster_id":"5c4c352e-d04c-4f9a-889b-492cb2fb067c","members":["a9ea8e8d-e334-4f5c-a6e9-f5710636ce5f"]},{"cluster_id":"d622193d-1629-4f0f-a5cd-b9751e388901","members":["8d1e8f58-b8ca-43a4-8e79-91e7ca0256c1"]},{"cluster_id":"cb346877-50ff-42c0-97e6-7abb95523efb","members":["250bbe9a-0721-433c-881e-aac280e1ea73"]},{"cluster_id":"daeaa2d2-9b6b-4a15-baa5-d0940fc45a77","members":["ec45304d-e020-47c6-b28a-0fc4ef0617ac"]},{"cluster_id":"9bc46e61-887b-42f5-8f08-16b384ac7b26","members":["1d3fd3d3-bcb5-4057-a3ae-cec350879713"]},{"cluster_id":"c98e55d1-dacb-46cd-b78b-7ec41169fc51","members":["0e1785c4-83ac-45e4-b0c6-3b992768e268"]},{"cluster_id":"c55fe718-0683-4449-8b87-8d1de09aac69","members":["1af1e3dc-71d8-4263-a2ec-a64fef34d4fd"]},{"cluster_id":"6d2e659d-b2ff-460e-98c9-72a4faf6173b","members":["7a30875c-5e64-4fbc-8c8d-bed9b6f27cc3"]},{"cluster_id":"b250fbe4-52ac-446e-8f1f-52af6aaeb77c","members":["a1e8eb0a-4b10-43cd-8856-21172708d018"]},{"cluster_id":"8059d799-8a2c-4df4-b587-415d278d1563","members":["2cc4e4af-dc46-4ad4-a36f-739242ed3129"]},{"cluster_id":"193b523c-c283-41d2-a3f3-b37ed50ae40d","members":["4e4dc1ce-8ec1-43b6-b148-db1a9cd086a0"]},{"cluster_id":"41026f02-6a91-44fd-aeaf-33bceaabf234","members":["b0540df9-eca6-4ced-b2d1-700014fcdf69"]},{"cluster_id":"662ce9d8-6ef2-47db-949f-92c2e48c1777","members":["828a2b98-67aa-4664-83eb-541f6a3cd05a"]},{"cluster_id":"ecaaad84-7e56-4f5a-84d0-609fbf620112","members":["aec08892-b3ff-48a8-958c-46c7c40e6508"]},{"cluster_id":"a1c74ee2-0da5-4362-bf0c-2f7caddeae61","members":["44ef036d-cabd-44bd-a118-83522dc907f7"]},{"cluster_id":"c66e7d20-399b-4cfc-80f9-620801afd3f6","members":["c96a4fa8-d456-4ef1-a3af-9bb73753687a"]},{"cluster_id":"6212a7fd-0f42-4186-898e-6bca1d985ded","members":["81ff8eb3-a8ec-45c9-b9ee-9e6c21e49496"]},{"cluster_id":"030634a5-ed95-477b-876c-290912b18446","members":["16a94229-5252-47ee-a983-9a151fb50d8f"]},{"cluster_id":"6aece148-00ae-441a-a570-cbee981c2154","members":["6bd57e1e-7b5d-4081-bfc5-623ac8cac507","6a6b6e27-e2ee-4fbc-9a8d-4c993f33ffc5","19b844df-9886-4baa-a563-1cb1efa79513","5db43199-b0cb-4d87-b497-15807346afa5"]},{"cluster_id":"c8fcfafc-5e25-4d83-82fb-dad89f0cb085","members":["c16cfff2-edc1-403d-a5a3-9b8fad5d5dec"]},{"cluster_id":"a327718c-a538-4929-8a9a-932fc2ef4a9a","members":["bbb76c07-d3ca-4a1a-918a-4e1e65f81fd2"]},{"cluster_id":"b6ada6e3-1455-491d-948b-45a74b134fab","members":["daaadb9e-5604-406e-bf09-cd42d4374674"]},{"cluster_id":"a13ff8f2-81e7-4186-a169-3843a9ddc359","members":["2f715b03-548e-49c1-9000-e306db6857fb"]},{"cluster_id":"b1babe59-a6e4-4d3d-9c56-c6ce7d8d64c4","members":["a965e587-80cf-4d10-8819-be9491ac2be8"]},{"cluster_id":"3ea76b8e-7bc3-4056-b872-c2ebb28f696a","members":["1ba9a5f3-9a3b-4afd-9cf9-c318bb80db34"]},{"cluster_id":"05f00def-a8b8-4cdc-94a6-9ead4bc629d3","members":["5ca90261-fa6c-467b-9774-646ffb71e21b","c344854f-6c0e-402b-9e03-dca2dddbf8a7"]},{"cluster_id":"e01a8825-f8eb-425d-b928-eda6b3f57929","members":["6fad7068-796b-4e29-923e-b77c12c1b30c"]},{"cluster_id":"c7ac427c-82e0-477a-a03d-4c9be54cce85","members":["d17e6883-586d-470e-9f32-e80ae8581b10"]},{"cluster_id":"6e881517-8e9f-47bf-854c-c29084f1a26d","members":["dea66aaa-48a8-4cca-b92a-84b2590481b6"]},{"cluster_id":"24b4e3df-c6d4-41de-8dc5-0dafe4754aeb","members":["150c3315-1cf3-4765-a408-2f64186e4e68"]},{"cluster_id":"d5f8926c-cfe4-4355-8a20-781d575d7616","members":["92dd5a3e-1456-4443-8272-98133402a88b","ec67ebfe-51fd-4eb8-bbf5-d55aa15d030e","22edd4f8-a427-4083-982e-d2c4008dda92"]},{"cluster_id":"756be7cc-dc0e-4799-bd5e-990554a6844d","members":["fe76db37-fdb5-4340-9f9c-ce91489ba14b"]},{"cluster_id":"eba7ffd7-9740-4070-bc0f-3ac660c28939","members":["fc4117d2-87c7-44ce-867c-4f13ac0f1392"]},{"cluster_id":"4d62f2bf-06ba-4e7d-b665-78a194b70483","members":["da11cc7b-0f34-421e-bf7b-cf23c6d6b060"]},{"cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb","members":["c9eb5159-568f-4148-a2fb-6859815f6398","8acf3211-493a-42fb-86b7-ca69f528baf2","f842785f-7bc0-41b7-8adf-4be7195bfd1f","8e86b9c1-b8fd-4850-a0ce-9bd15d8e9fe1"]},{"cluster_id":"e128e0c8-745a-4ce1-995d-c5a2ac809b5a","members":["22b94445-9072-47f1-8db2-0a45e813b7e5"]},{"cluster_id":"5f9c8cb9-e871-4d7e-8b36-9e411bdc35a8","members":["75924a82-3fcc-4240-91aa-b5e0dc0ddca6"]},{"cluster_id":"d485a542-5dc8-49cc-9ed2-7c434144d575","members":["11229a50-6227-4cda-b6f3-5925c6879785"]},{"cluster_id":"9bee1f85-c3a5-40f1-a8e3-aded362e94b6","members":["91e04afe-07d9-40e2-9618-693f13e31bb7"]},{"cluster_id":"c11121a4-e475-45d6-a46f-861982c7538c","members":["79b10fc4-9ac8-4f93-8668-0ed316cb376e"]},{"cluster_id":"a8cf67a0-14e4-4562-b59f-46b2a6b2b98a","members":["148f7765-0c59-4960-80af-85da467e859c"]},{"cluster_id":"82ce4ef2-05ed-42ad-830b-f78ec5322a5a","members":["96921c57-8997-4820-ae0d-3f734506e1d1"]},{"cluster_id":"fd964b79-d3b5-4267-ab70-39cd4b799f57","members":["0cec1eb4-0d43-4e73-b943-262808d31996"]},{"cluster_id":"7a0efb78-9055-433c-904f-79dc94ad2203","members":["a9648e62-fdd2-4d60-9d4f-2eee4b983df0"]},{"cluster_id":"cb120bb7-e884-4891-9573-61c67b37ce2a","members":["9f8e5759-7324-42fc-a3a2-93d97062df5b"]},{"cluster_id":"7815f5ae-d441-4f71-b0e2-771810097e05","members":["e3138869-da14-4f17-97f1-26df7cad259b","8334641f-a721-409e-8a0f-4f763cc30cd9"]},{"cluster_id":"dba5927e-43c7-4d0e-9ca1-e78a9cdb024a","members":["ab57c0ee-23ff-4b12-8a23-b14c2fbe9ed6","e383b025-a9fa-4797-9875-e72189d9e9ab"]},{"cluster_id":"0b6f158d-8877-48ca-80e8-7a4602b55765","members":["bd45579f-c2f9-4ed6-8c28-c2cd8e8d68ee"]},{"cluster_id":"2a871f4b-957a-43ae-bf82-09ab2ac57891","members":["75910daf-346b-4c9a-b959-259c73a68ff9"]},{"cluster_id":"130b5f11-d69b-4e29-8d13-05a09ea6b8ad","members":["b8c349c1-0d1e-45cc-8f94-109672980d3c"]},{"cluster_id":"24c54796-afba-46ba-9bb2-8854f3d0747a","members":["dc7cdf80-8073-4d2a-80c5-aa72b4be7526","cd9edb31-6c8f-4113-8234-0aad95e575e6"]},{"cluster_id":"2b0eed50-da8b-45e1-8588-42e0093ff921","members":["b48bf9de-0300-4962-a4bc-3b8c4ec05e4e"]},{"cluster_id":"47544927-be6e-4238-bfa2-7d12e902c9e4","members":["6baee768-4fae-40bd-99ae-34818b6c4ff1"]},{"cluster_id":"0587530d-6a6d-4aa0-9e34-087698c923aa","members":["2fef81c4-c4ab-4e3e-a3f9-2a1e32f501b2"]},{"cluster_id":"a1711988-408b-42c4-8682-720bf33be6bf","members":["4c2eba41-b018-43bd-a059-2a1210432b9c"]},{"cluster_id":"0807cdb8-6ddb-4585-ad14-90359bbf1c37","members":["2cb073f1-14d4-4cbc-bad0-da4fc2360c56"]},{"cluster_id":"b05a0ac1-6107-4a11-aa69-1115d8b00d86","members":["1bff33ad-7336-42d2-89c2-c045d3609bcd"]},{"cluster_id":"467eec25-d0de-412a-9f09-8a0db03d60ae","members":["229b9137-7527-41ad-a10d-d86236fbc4dc"]},{"cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597","members":["d35bb153-32de-4344-b1d3-debda63670ad","fb93dc07-736f-4e75-bc9e-feef9be33698","9aeea02f-b296-4f73-af29-f3946c7ef555","cf1eee85-9662-465f-92bd-7755721934a6","d3876d96-c6ba-48b2-a7d4-25ba4800e435","2c5df468-b52b-4d60-8845-9a4f8f790442","023a2ca0-6acc-4354-870f-1e990d38e0fc"]},{"cluster_id":"503b13e8-42e4-48e4-8ace-47ca9e49140f","members":["fda7e305-9c69-414b-afbf-35c24c351e73"]},{"cluster_id":"3fe0d18a-cf4e-4f24-a77f-892271df6bae","members":["3f21ec81-ede9-4aac-bcf6-7a87e74dc21d"]},{"cluster_id":"3aabf3aa-c1eb-4474-a134-a2e2ec8c19f6","members":["27a83928-0416-47d3-b260-0232ab70d248"]},{"cluster_id":"ab906a52-8ac1-4094-852d-28e22d75048c","members":["8c1de153-2b7d-4551-bd69-8006cafdaa5c","29a4b5e8-3852-4ef7-8945-012494f68624"]},{"cluster_id":"f6501847-7e90-4499-a97a-f42ac5217bb6","members":["f298143c-340d-4e92-9efd-15885f108949"]},{"cluster_id":"5a419c79-66fe-4be4-a3c1-02415535b5e5","members":["7c0055b8-d81a-4f20-aed1-36ad7842eb30"]},{"cluster_id":"6e37aa31-587a-4adf-8952-da7c9df371fd","members":["cf210236-aec4-464b-9fcb-e21cafe07515"]},{"cluster_id":"c29a246e-69bc-464d-a998-2ee789508141","members":["9bd5f8e4-ee62-425d-bc45-13ff354ae53d"]},{"cluster_id":"6cf1f120-eb6b-4ef5-8ea8-be39f36cebee","members":["e4acbee1-1dd2-49fa-bc31-34100ff94b89"]},{"cluster_id":"ed8ee9d8-3361-4c66-86fb-3b0c6210300d","members":["fff9f7c7-d732-47f4-a729-523774c75283","09bf5365-4846-4c70-8462-797de6862674","43e5222a-3087-4d0d-be64-dd7e1ebdc149"]},{"cluster_id":"3c7779af-1e2b-432f-abfc-f807e51488c7","members":["74b3efdf-3b9c-4f10-ae59-76311110302b"]},{"cluster_id":"e0932d8f-119b-4dcd-8100-b5fb6b62417a","members":["a1a78fcf-e1cd-4efe-8936-ae38451c07f2"]},{"cluster_id":"ed17271a-9f56-4fda-b3f2-e8dbe7b55084","members":["8d8d375a-a686-47da-bc9c-6eac5ea9a427"]},{"cluster_id":"61d385a5-d13c-453b-af42-53ad07fd1c25","members":["88430b8d-2dfc-43e8-a450-708e825fe2dd"]},{"cluster_id":"9a7cfd6f-8532-4052-b526-1e4576483709","members":["c9a568c2-86ca-45e2-9270-7f388f5fcb24"]},{"cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155","members":["3d00d19c-2b7a-4ee2-a2b6-ba039a96eaee","d124a1dd-2d17-4a0e-9b3f-3690566aae21","18b5b3da-d419-4a47-8df3-72b832f336f0","b636559f-f440-461e-8b2a-e27f8e0a5bba","82dddf7c-fd0c-4c46-9029-3fc44df72117","98a74f5c-953f-4fe8-aaf3-a6941ae420a2","df7328ad-1fa1-4626-aa8c-2ad980e5b771"]},{"cluster_id":"b2946046-f947-49a1-8176-588a2c66f974","members":["a7a074c1-90c6-4d6d-ab05-f1443b144afc"]},{"cluster_id":"794a59da-1667-4f55-8bfb-64bab3fe6d1a","members":["54cac0cc-06e2-4fd6-ba5b-b0cb4461853c"]},{"cluster_id":"0e839111-b99e-4caa-8ece-e80f0ea67970","members":["d493f755-eed0-4944-bbd3-5a6c9974fdb4"]},{"cluster_id":"261352e0-2751-4f21-88a5-03538b2fd63d","members":["ef8f4a79-fb2c-4f9d-859e-01abe99e9db1"]},{"cluster_id":"006e6ccb-eaf9-4a24-8ea9-fbee9be7d468","members":["d4b57753-8820-4e4f-902f-f424afd1ddfa"]},{"cluster_id":"5af9294b-b226-4926-b1d8-cd8badc5e35b","members":["2c19756c-d0bb-4c7e-8ae6-cd4e787411f7"]},{"cluster_id":"04b6753c-ecde-472f-9566-0e86e4ac2a52","members":["e12674be-e40a-4090-8e59-24ab738b83e1"]},{"cluster_id":"57a9720a-c11c-4e38-b871-7e3861e5df17","members":["1027ff9f-a236-4e67-ad2e-f71bd98a31b0","79188f36-9dfb-4930-8fe5-4f28c5adf64f"]},{"cluster_id":"e00b6e6b-19c3-46b7-8ed7-41551b5be8f8","members":["f6bb2a03-7781-47e1-a609-0faed1482e89"]},{"cluster_id":"fdc8411e-7a17-4fc6-bef2-367c46894068","members":["8a634101-cd54-46bc-a687-7d1b533d8ffe"]},{"cluster_id":"d58686a5-53bf-4314-a7f1-f0e899bc8c82","members":["16cfa5fb-2b2c-41bc-a45c-3bfbafe45d99"]},{"cluster_id":"f7143daf-c280-489f-9b7a-be507d7d1e7d","members":["ee28fe43-1894-4c95-8870-fc28fca4a76b"]},{"cluster_id":"51c88d49-73a0-41fe-a608-ab3aabe81173","members":["079c2f4a-cf04-4744-a34d-d7c5e33f1dd3"]},{"cluster_id":"fd231a27-03e0-4839-bed2-513e10b79733","members":["30b5867c-0d85-4a47-b3b7-3c54f63a325f"]},{"cluster_id":"4162c749-910d-4283-8cde-a365928f230d","members":["d752f6cc-4187-4afe-99fe-a1c6c2cae958"]},{"cluster_id":"58d169af-1f4c-430e-875d-88f013ef1388","members":["76ca0985-7e78-47e4-b755-2290bf824812"]},{"cluster_id":"532f519a-d7c1-4910-afdd-938e13222189","members":["83d0ef0d-d105-451f-9865-94a7fb63fbf0"]},{"cluster_id":"44a25f49-5174-4a81-bbe3-8d614f9c4116","members":["976b90b1-ffc0-45e9-bae7-ba4cd7407f18"]},{"cluster_id":"11da9fb2-c834-4c00-97b5-9d0eb78a5f81","members":["4f5d7f54-0e07-4d45-8714-b56d3126678e"]},{"cluster_id":"b38033d5-5b50-487f-be85-35eacb567316","members":["35397bc5-60fc-4557-99be-80f5907223d3"]},{"cluster_id":"e1f28336-0647-4e38-a5b1-a20d710717c4","members":["5446ec33-6405-427f-a4a7-b1516e31c796"]},{"cluster_id":"02036fb0-ba58-45fa-b4ad-534e30796546","members":["30eb27a7-d0ba-4d1f-8de8-bf1c8259d737"]},{"cluster_id":"60b00870-1636-4edd-b3bc-90daaa615659","members":["d4cca293-647c-438c-8750-2eb681311176"]},{"cluster_id":"bba407f7-696a-4116-b4f2-8e58c881a810","members":["71d928fc-0847-486c-9da2-baf35bbab3b4"]},{"cluster_id":"20999f16-0335-45ee-a0fa-171f40827993","members":["6915995f-bfd0-4669-b7a3-0b66d95da7ea"]},{"cluster_id":"814bcb42-2e0f-4cf8-87e3-c5b551e8ea66","members":["1e340ec3-de70-4af2-9954-3014f5f13739"]},{"cluster_id":"6e4775e9-09cc-45e6-927b-26fd1460b8e8","members":["54f64ead-5d9e-422d-ba85-10bf0e254bd0","b286e45c-02e1-4f62-b4ea-fa0ec72bc252"]},{"cluster_id":"42c9725b-d681-410b-871b-771e74124bd4","members":["de8e82dd-5b36-4b6a-9e32-67075988ea63"]},{"cluster_id":"519a0144-fd4c-4d5c-9042-6fb50ccd2f56","members":["e6b15468-d019-476d-a80d-5ca76fb645ad"]},{"cluster_id":"1e88b8f2-56ce-4d36-b086-ab1c91d0ff73","members":["6f1133cb-61a4-44f5-b5d1-c48a58b4bd78"]},{"cluster_id":"63959dc1-33f1-448d-b73f-370297a47c55","members":["0d93e6dc-8136-49c8-a877-3309cd11622d"]},{"cluster_id":"2fe604c5-b4d8-4806-815f-c3f9be0582ed","members":["228efa10-aa8d-4e4a-a70f-9a434e61ab03"]},{"cluster_id":"be6d3887-f154-45dd-b994-3e262cd683ab","members":["3df77559-ea00-4e25-aee5-5af4521b40ab"]},{"cluster_id":"e1d7b348-32fa-40c2-a6a1-5325b5923ab6","members":["f3187c0f-a7fa-4eb3-9659-2e4897884950"]},{"cluster_id":"c6d45751-df96-42cb-a762-00ec73441fe2","members":["56f97b95-7511-4f0d-90b0-29e6125e047c"]},{"cluster_id":"7fe9b7f3-5fcc-469d-bfc5-789d2c7ecb0c","members":["f71e1b87-0731-4652-9fce-8e43d28e6513"]},{"cluster_id":"3d5e9384-ac3e-4f4c-a500-50dfd267dfa4","members":["16621546-2155-4af0-a522-ffbef36ca911"]},{"cluster_id":"cebd1d98-7547-4761-a012-89e58bf86f29","members":["7043be3a-1348-4fbf-b4da-ad5f86f81265"]},{"cluster_id":"67882453-39e8-4614-ad83-1b5cd199486b","members":["43918ef3-c02d-446c-9939-aa0619c5f4fa"]},{"cluster_id":"4c34b512-0945-4457-90fe-e5531faf594d","members":["e84846ba-99ab-47fe-a730-6172d9ac3b35"]},{"cluster_id":"a9a6169f-2727-47ff-8df7-1f0dc7eaba02","members":["28dabced-e72d-40db-a769-1ed696cfb685"]},{"cluster_id":"028454b9-ae0f-4b68-8959-098c138f4548","members":["dcb9c056-92d5-4729-b922-92cfe2886e27"]},{"cluster_id":"47eacbaf-94c8-4453-9ff4-4a4d77904c0c","members":["be2dc09e-34a3-4a1e-8396-9fa5bd1a5998"]},{"cluster_id":"ceaf3416-5958-472f-8b27-d2e81ab1489c","members":["d3eeab90-548e-4b0c-b847-422addd6dde1"]},{"cluster_id":"1de0370a-30b3-4cf4-8852-224e559b9061","members":["f69ea3ae-6350-45cb-97f3-9a323713bb8d"]},{"cluster_id":"ce0d6d93-def3-45e3-8bfd-1c14d5d947ee","members":["89af2cfb-0121-4d57-83f1-725bd1f33b6d"]},{"cluster_id":"c00c750e-a740-40f2-8fc7-77d5f6c8fe81","members":["2da829a2-d59e-4a98-921a-295d99a62943"]},{"cluster_id":"2b8e0512-59eb-40b2-a0fe-0c0765fe2a41","members":["a6ac98d3-f2a9-457d-800a-22ac55a5cff0"]},{"cluster_id":"41d3a2f3-d7a3-4115-95f4-0cf0a84449a0","members":["fa43bf47-f53b-457f-92ba-d9060e873e45"]},{"cluster_id":"3ddf92d1-7fbd-4c44-857f-573095c914df","members":["58d52923-309c-4639-b67f-3660c4b7a5db","84d42f5b-d166-48df-94a7-ca07834d7629"]},{"cluster_id":"f5211fb7-fcad-4978-ad00-c77df1404c5e","members":["106bd334-194a-46f9-89ae-c7207674e45d"]},{"cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722","members":["a1c1f03c-2199-42ea-b800-30e376e60e7b","05a7445f-f8e4-451a-84c5-621b59387db8","99f7b628-7862-4faa-a1ab-c7a717ed8b26","71fb2457-f74f-420b-b866-478d856b2ab9"]},{"cluster_id":"53d925d3-b8ff-4816-9cb6-be1191e8d6ba","members":["4ff7f89e-7034-4984-b150-cf36a2108c68"]},{"cluster_id":"35f50160-5841-4836-b319-b5806e73bdd7","members":["f83a30b3-bda9-4d94-a290-fbc0c947dbd4","419233ba-dddf-45b5-b937-b0523f88b523"]},{"cluster_id":"13eaad2c-4351-4227-a2c2-4a8d3df4410b","members":["88cbd551-9a16-4dcb-bfde-6588777cc74f"]},{"cluster_id":"ac154c70-d6ce-41bc-949e-658cdd31e1f4","members":["dda1be66-a107-41ec-93a7-19785aaf8620"]},{"cluster_id":"26e8c638-0261-4ee0-9125-edc5ca8d7841","members":["d3451e34-9533-4766-974d-3fcdb0c014ea"]},{"cluster_id":"97cdd3f9-b13e-4b85-9e62-c48c3b34bca9","members":["168afc39-23ad-42a9-a4c1-9cd89385981a","1a1036fe-40f5-4390-b808-24415bb34512"]},{"cluster_id":"5d0d552f-6139-4148-bf05-7e9c5a14274a","members":["4c56dcfd-316c-4b0c-b293-23eccee791ef"]},{"cluster_id":"057662c4-0ac6-48b6-be90-a08641f47c88","members":["44b5f8c2-b8bc-480b-98f6-1704d3629f4f"]},{"cluster_id":"610fe915-6f9a-4623-a217-8c3cff21b2cb","members":["f7547891-fa78-414e-ab7a-62f3b8edde8d"]},{"cluster_id":"feb55b84-b173-4b70-b9c2-3b33225296b8","members":["80344cca-fd55-4c1f-bf37-13d5c04a010f"]},{"cluster_id":"c368702b-96c0-4866-81f4-7cb0750c1bcd","members":["2a009960-9048-4096-b8b0-842ff57f2b0e","8dc629cc-6231-4ba2-a045-563637816f47"]},{"cluster_id":"ec333963-a3e0-433d-a595-145497c56ca9","members":["c2b186f6-c022-4b2b-918e-01c7ae57ece6"]},{"cluster_id":"b6c807dd-0cb5-4622-8a2e-ef610ded44e5","members":["fcb1f017-02c2-49ef-a0de-5a8be0a4a3de"]},{"cluster_id":"96f47e0e-34da-4076-aa8a-d368df50bd46","members":["f6298f4e-34be-4bd5-a9e3-c09111e5e60b"]},{"cluster_id":"b8a8bbf1-a819-445d-874a-5ea5546196e8","members":["3a0429c7-68cc-4b17-8842-8b698a3c682b"]},{"cluster_id":"a5aa6b9e-3e33-4b44-ab88-d54a834f3817","members":["6b716a22-76d1-466d-9ff6-7f7dc7399a03"]},{"cluster_id":"3f98fdac-3f62-464c-bf56-dd3d2e686963","members":["f13890cf-a339-4ac5-80b3-3630493f1039"]},{"cluster_id":"be12c5b4-b051-4762-b77d-ca92a4063972","members":["41481512-2ffe-410c-b574-b775d2ac0edd","3856ade0-91e1-463b-a8b0-c5a4515d31da"]},{"cluster_id":"344dd5f7-3435-46c3-9f5a-4bd9bd357bed","members":["415369c8-30f6-4fa5-809e-a154f30d2fa5"]},{"cluster_id":"e440fb1d-afb5-4fce-9f0b-110db0f93b32","members":["902a1595-3dd5-4012-b0bd-83fe8948f71f"]},{"cluster_id":"409928b1-cabb-476d-812a-3340869af622","members":["89306a7f-432c-42e6-ad88-b078d6e35833"]},{"cluster_id":"a7fc7029-8fcf-4676-9e1a-d0be462bdd41","members":["4d09c518-222d-4ced-a7f4-12f71e9f4182"]},{"cluster_id":"b8ba4862-a01f-4bea-9d65-d965f8a811ea","members":["732b85e8-3019-4568-8bdb-996dffebbe60"]},{"cluster_id":"8b829799-1488-4866-83fa-531278dceac5","members":["ce4c5e9d-7414-42b4-976a-83c224c8bfb0"]},{"cluster_id":"087b9c92-fa35-4283-96fb-8d9c5297eb2d","members":["aa115de9-cb33-42a2-b72f-cc1fcb53651f","ac10fe98-7a59-438d-8e5a-e5d8ff108249"]},{"cluster_id":"6d0ecf89-9eab-4b55-8c05-ab0885982adf","members":["cf1859da-3e2c-4640-8d45-1b649c6efd89"]},{"cluster_id":"7d0b4f2d-8055-491e-a0df-31787da0b9a8","members":["6c2d4573-fdb1-4022-b637-584a82b70b2c","b6ed7ce5-601b-4916-aec6-97171aa1061b"]},{"cluster_id":"d2698d5d-a9c7-4753-8264-b469e84de09c","members":["f863cc41-925b-40e4-bfd1-d70664e0a384"]},{"cluster_id":"4c5edc98-f936-4e09-a25f-11ad3a0a3ce0","members":["02e90b1c-35ac-4c76-9490-e196796f07ca","ffa0b490-c0c6-4066-ac6b-412aa4813bee"]},{"cluster_id":"7dfb31d5-ddb8-4d40-bb81-cb884f7a73bd","members":["f035e906-0b9e-4776-8f28-507ead8aa2bb"]},{"cluster_id":"6190dfba-afce-482c-ab6b-30cfbc88a521","members":["28b573f9-0e8f-42dc-85af-1fb345bfa138"]},{"cluster_id":"a4f03b54-99da-409b-9d0f-4576a28453ea","members":["7c4cf18e-a1fc-4fd7-87c3-1d0205d000f7"]},{"cluster_id":"dc6983ab-b551-4091-91c6-65ee2055cfd0","members":["543fdefa-d58e-4d76-8071-bb86cf9e75be"]},{"cluster_id":"d481c919-0d2f-4cb2-bfd7-956740c2c572","members":["d33725f4-3fb6-4ab1-8fe5-92793806bd79"]},{"cluster_id":"095f5894-d729-421f-8a47-470e675d8afa","members":["e5542718-0f4a-4a6a-b2a9-a7f74876d478"]},{"cluster_id":"0e68f81d-43a7-45ed-8f07-1f52cfdcdd62","members":["853229aa-e197-46e6-b730-86eb4a52ab20"]},{"cluster_id":"4f70f4f5-9340-4c71-bf68-5b20071ff5b8","members":["c543a8ff-a376-419e-8af9-95d851369395"]},{"cluster_id":"291e783e-a633-4a70-baad-9d43cf49aa7b","members":["81a49100-18a5-401b-ad73-76867ece0bb2"]},{"cluster_id":"1fb14eaa-5808-4fba-b78b-8331f9693364","members":["c0ce502b-f8aa-44f6-b754-63a4956044f1"]},{"cluster_id":"e8a4287f-2df7-4875-81d6-e8b9ebf6b742","members":["db80af84-e808-4fc4-9b3a-48ffda50ff52"]},{"cluster_id":"9a26c9bd-36a9-4c64-8680-f0a2265878f1","members":["aa9876ba-55bc-43dc-b76f-e3374e78c9d1"]},{"cluster_id":"fed0576b-522f-4fd4-a6c9-50a73c58d504","members":["a62e7c0c-3014-426b-b4cb-f09f41a35640"]},{"cluster_id":"364b6018-e5e4-4d17-9b1f-0b9d5fe116fa","members":["171ecae6-87ff-409b-acdd-b6f06ea9c901"]},{"cluster_id":"f7cb56d3-2935-41a4-86b7-c9fe57c869f7","members":["610bcf42-e654-4fd1-864c-8c97bfc7e388"]},{"cluster_id":"56cddc1e-640e-4fd4-873b-51796886ff3a","members":["e9af9077-dfe3-49a3-9da9-a8677be6d2ec"]},{"cluster_id":"ccfbe60c-5479-4640-b831-00bbb4cb4ec1","members":["7d7f1e0e-ae67-48b6-9123-ed59a792720f"]},{"cluster_id":"9ce0798f-d0a5-4818-8a46-c633233caab5","members":["66c3b2d9-9fd9-4ffb-a4fa-a50c1fac13ef"]},{"cluster_id":"f2e7e2a5-1bc4-443d-b76a-ecb8995fbae8","members":["1e39ba56-9940-4fbf-8dd1-889dedcc9779"]},{"cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c","members":["b91ff7ac-2550-4327-b693-f9c443c27bcd","c589d99a-2705-45ba-81b4-d443003520f5","b75e94f6-e39d-40f2-b811-999f17412dce","004ea1ef-02fa-47bf-a43c-2078a1530a3a"]},{"cluster_id":"49f74be2-2b75-49a2-9647-991264918ba3","members":["04585af3-b8d9-4baa-a6e6-186226f2c53a"]},{"cluster_id":"676d848e-4839-407b-95b6-13d5d472f0e1","members":["94106d8a-2fd8-4eaa-8ef3-f18642b87714"]},{"cluster_id":"8269010c-d30d-4a8f-9628-b930192a8751","members":["b0de1673-0cc8-41a9-b2c6-807fc598539d"]},{"cluster_id":"46ef864f-186e-4179-bb52-04fed8b2c978","members":["3a7c4f12-205f-44d7-893f-7c4955c0fb21"]},{"cluster_id":"1020a2ca-3e92-4f76-98e4-6f44fdfd5f52","members":["811cffa0-d85d-4b68-a81f-9ecb5bab33b3"]},{"cluster_id":"00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea","members":["9fbd23d2-85e0-4c53-bdb0-b8f0210aaa2a","edf44a9b-5a98-47e1-8ff2-e651a3916ab4"]},{"cluster_id":"4d4b5f03-b89d-479d-93c3-2c3c9a038d46","members":["2c7779d3-50fa-4978-a751-9def7aca0cc2","a18eb799-3627-42c3-8e70-28d1b88e5971","aa518135-7417-406d-9511-8ae5af77f437"]},{"cluster_id":"94e66aa3-5079-4e1d-bdc8-702db352aa56","members":["cbf28224-359f-4af5-a68f-874ac3a7cfc2"]},{"cluster_id":"48eb1f9d-0125-4436-9ad0-db6bbdc685bf","members":["5a766bde-8fc3-48c8-9691-33709b37f34e"]},{"cluster_id":"ae4c214d-3e4b-416f-8e83-fe80cc92e55e","members":["195dd2bf-8e9a-4ca1-89dd-d5527e18c2a1"]},{"cluster_id":"92f1ca49-b0ab-4770-8539-01bf2c201c40","members":["03f59c33-5d82-4ad4-83bc-6a7b7862e369"]},{"cluster_id":"6985cd83-55db-4a59-b823-aed3b2386ee8","members":["2fb6d1b3-35d3-4799-8513-846ab8a4d75f"]},{"cluster_id":"15441f0b-d588-4f74-9e0c-951884dd5f0a","members":["7c3b6688-d683-4382-903c-b975332dbc52"]},{"cluster_id":"f5769a88-6f55-4990-ae69-e5747ba1c948","members":["c46920ea-8f61-469c-94c8-0f4df258b9bb"]},{"cluster_id":"2af31319-c3b3-4fb2-ab4d-68df1d72b458","members":["9ce38159-4df2-4a30-b881-4e97c679c2c1"]},{"cluster_id":"00c62945-b485-438a-9d05-87baa1d3d907","members":["d89eff74-1189-4fd5-b33f-6c3f55c0b6bb"]},{"cluster_id":"c9e1ed1d-b28e-452c-9f9c-c8e37181b84d","members":["bd07d283-3ff2-42c5-aad4-0c9508c49476"]},{"cluster_id":"4e9bc944-639b-4f8d-838e-a744f7d10ce2","members":["f5d06ae9-4e8c-4ace-ae65-7ad815033fde"]},{"cluster_id":"b8cb289e-e370-4b8e-aa6d-b4c268c9566e","members":["fbab0ba7-0a1a-42f7-b6c9-c7a2b136e760"]},{"cluster_id":"1ccdbc51-34c0-42ae-b81a-03edbb3df6d6","members":["29b68f52-c694-4bd7-b9ec-4862a05b6aa1"]},{"cluster_id":"9687983c-2f58-4f1f-9d09-86f19210af37","members":["42f92565-64db-44cb-80c5-250dd9ed2225"]},{"cluster_id":"4fc147e3-0b67-422d-b442-9aed1bd9ffee","members":["4c32bec3-72e5-4e9b-a048-dd4ffde7edc2"]},{"cluster_id":"d882f953-ff9f-4410-820f-ffce8c5ec321","members":["8fac81ca-74b5-4026-9d28-bca75cce2a4d"]},{"cluster_id":"e81e68ae-4e8a-4aef-a358-1455ad08bdc4","members":["1545f02a-2183-44e7-80eb-8e8017b06ace","27ebf54a-7220-410b-bf97-38d6dd4708f2","b716df28-25f5-4342-9e96-aeffe85cc626"]},{"cluster_id":"af9fdbaf-db80-451f-96bd-62636c3231f5","members":["8ed289d3-0cf6-469c-9cad-185096f11474"]},{"cluster_id":"b4e49473-fad9-44d2-a14a-baa57498bb09","members":["1d3c6131-e597-47a8-a1cd-17e85c114664"]},{"cluster_id":"8e5823ae-a392-4999-814a-2dee24b2385d","members":["5e163e86-8df2-4970-be19-1c721b67481a"]},{"cluster_id":"f0e4e625-f14f-486a-a02f-d6cf2c5a6b4f","members":["3a2dda61-d58e-4bbf-aedc-ee26a6054a9d"]},{"cluster_id":"c8767af3-0dda-4a2b-8768-e0cf749cfa1c","members":["f6f52da1-b69c-479b-9180-8690fc279e05"]},{"cluster_id":"a0fb845d-3984-4109-ad59-e77cf57e7687","members":["19ded8bb-b942-4c26-96bd-47fbac381987"]},{"cluster_id":"6b396f8a-a67e-4844-8d5a-43bb95030766","members":["c39f38e6-6801-43f0-b58d-85b1bb40ce68"]},{"cluster_id":"b6224aea-5841-4609-ba8b-ccc207ec597f","members":["3cc71956-33bd-42f1-821f-772ffdb32426"]},{"cluster_id":"897c7076-ce98-4405-aaa5-1e883a645242","members":["560ad3d8-ac49-48cb-80f6-697bbb5eba4c","8736b397-0828-456b-b1a9-faca5adf593e"]},{"cluster_id":"be379179-357e-431a-afc7-707de2663f0c","members":["beb0907e-2c5a-41e1-a3ac-cdb02446f79b"]},{"cluster_id":"178f9d9a-267a-4abb-8f58-8a32bd23bb57","members":["1078a74a-1bdd-4cf7-bb28-da7aacb1e369"]},{"cluster_id":"a3cbf831-a6f7-4981-a61a-3f2e1d67806a","members":["6cdc6ca7-913e-463c-a1b6-6192ca4e8f38"]},{"cluster_id":"b95118e4-bfa9-41d0-884f-00c06ed87e30","members":["042c20ef-1d96-448c-a138-f7fecca41e5c"]},{"cluster_id":"cfe9cc78-dae7-4fb3-9619-c934beac1286","members":["e1e7bc0f-5e62-472b-b2fe-0c1350bf36eb","66d6a8c7-35dd-42f6-86c3-93cdfa8eea7f"]},{"cluster_id":"0ded9d87-ef2c-4d88-b3db-79b2f8e48989","members":["14836e2b-68e7-4472-951f-747a83eb318f"]},{"cluster_id":"4da18b15-13e1-4abd-966a-5a691b26fe59","members":["31ec134e-e8d0-4347-ae2b-d7bb390827bf"]},{"cluster_id":"0912e80e-4475-48b0-94ea-99b244b18e7f","members":["b4d900c3-7a33-4ac1-bbeb-2214891df708"]},{"cluster_id":"347223d3-908d-4003-9d32-5f2929c89e51","members":["7d8fc9d0-ee37-4617-bb57-bc9650a988a0"]},{"cluster_id":"31b9f704-925c-4bf2-9f0b-e88e81f1b10a","members":["6dd22e0c-75a1-42c5-9669-5ea344deb675","dd0ea02a-5156-4ea0-9cf4-df3bf324ed09"]},{"cluster_id":"babc55aa-4d08-416f-96c5-50bd2182d4f8","members":["d50c791d-d408-460a-91cb-c316bbb2b74f"]},{"cluster_id":"3b11f37a-b3dd-481f-b924-f2c0105eea68","members":["7c66dd47-55d8-4d79-b029-18c78b008ccd"]},{"cluster_id":"81814091-7bc5-423c-85bb-9238ad6a9cae","members":["3daef752-184a-46a5-b49e-f5f3862e40e8"]},{"cluster_id":"1618106d-1c52-48f7-9d0e-a09294ca1167","members":["46c4bbca-22a7-426e-b740-218b1943a208"]},{"cluster_id":"4a717901-15d3-4fa4-8697-e234613c348b","members":["f5a37044-43e2-48fe-9d3d-72dfb91550d8"]},{"cluster_id":"6d58a40e-4432-43bc-9a0f-20467f608aca","members":["e91cf261-b3d2-4dee-9fe5-9f289ce03b3c"]},{"cluster_id":"cc939ca4-cdd3-4b86-b937-1aee89162501","members":["148e0912-fcdd-487e-8009-0cb800636227"]},{"cluster_id":"d2d14fb6-adb8-486b-8eee-e966dd2e339b","members":["082ef11d-1ea9-487f-9952-17564fb9c4d5"]},{"cluster_id":"7014c024-82bc-4f47-b6cf-23a09be951e3","members":["11203772-88f3-4d44-8521-49a5752d94b6"]},{"cluster_id":"ab120ec9-7f69-4d7e-880b-eb52320c48cd","members":["3af0d05e-647f-42af-a495-1c1b27f989b9"]},{"cluster_id":"626e9a9b-6995-4100-8ffb-53ed10359203","members":["d2ceb7c3-cbd1-4e64-b371-c92535e8b2a4","76c2db9b-d26b-4f29-a2ee-da0ac761da2b","4d7eb9b1-9a26-4e98-8fcf-a28104ea6824"]},{"cluster_id":"753b53ca-12e6-424b-989a-e076a991708d","members":["467fbfa1-667e-47f0-b679-4ccde1bc649d"]},{"cluster_id":"813768d2-b0f6-4924-af6d-45e5c38606af","members":["a8cdddc8-da0e-4ddb-bfb4-206b7861ec25"]},{"cluster_id":"d3561f7c-f545-493a-88e4-1feb8895eb1b","members":["5621db93-38d4-44e3-b9ac-662f17d5b014"]},{"cluster_id":"a4b1d7b9-3c74-43c7-9743-4531782b8384","members":["e1d13f5a-15e7-412e-ad2d-a9a7f7ee5cdc"]},{"cluster_id":"89bc3f77-435c-48cc-9674-3f733858f60d","members":["3f36f821-5acd-4e03-8925-56a32a0d41df"]},{"cluster_id":"cdf7dd0c-6255-42a0-bfbe-5e3b3bbee744","members":["1deccd41-6b22-439d-b04a-607cec06cd4e"]},{"cluster_id":"104c0221-a4dc-4285-9360-e1a7135d6b23","members":["78f8bb60-19e7-45ae-b9a8-95d140afccb6"]},{"cluster_id":"67ac99c8-c0bb-4383-9849-47ca12ce4b47","members":["457968e0-54e3-4b90-a69d-cd014e44b19f"]},{"cluster_id":"0ab26e4b-97a4-402f-89ba-c8bf505907da","members":["953e8dee-c92d-46d0-b41a-2675f2d8c7d3"]},{"cluster_id":"7767473b-b833-4047-b346-9abf204211fd","members":["765cde6f-4513-4c96-bc73-5efe2d1dcec2"]},{"cluster_id":"7bcdf864-ee5d-4016-9651-b86043d6e5f0","members":["550a0233-ec91-4574-af34-084f9fb02324"]},{"cluster_id":"6310600c-941f-4d69-826e-9f6645778d3e","members":["39701dce-c174-4858-a47c-7c287e0d6b46"]},{"cluster_id":"c466ec99-62a0-4318-a23d-1522e69e1a70","members":["c7ddc375-ec76-4ba7-879a-f3acc3bcb9c6"]},{"cluster_id":"cea72470-6f49-4d89-a6fb-4c1596600c5c","members":["1edfed6a-a6f6-4d26-8e86-27912e5cb734"]},{"cluster_id":"418909cf-6842-4d61-99c3-ee63c7926d9b","members":["b3d4bccf-e6b3-444a-a446-db2eefd130aa"]},{"cluster_id":"9c904ce8-82eb-4f73-b9ea-f510b0249486","members":["fc116fa8-1dc3-4222-a5c8-b35092c65b7d"]},{"cluster_id":"d6edcbd0-8a76-4410-b54b-26039bf9a1d1","members":["a1e88781-f2b8-4925-a71d-1354138335e6"]},{"cluster_id":"4f34a5b6-00cc-43cb-98d1-c250e5f2b08b","members":["16eb1f91-9e75-48d9-8e6b-ba6883f107a2"]},{"cluster_id":"907f966c-c5b8-4df2-817d-f2cfeeac3c35","members":["45192b72-d6e3-4aa8-adad-2ce5c94f6fed"]},{"cluster_id":"8ea45448-137b-4d92-9e93-e6f5676fad3b","members":["f15e48c3-97ff-4340-8055-fff4bf8c0515"]},{"cluster_id":"9a0ba2bb-c790-4711-b8e3-9a7c3fc3165b","members":["0ec3a1ba-22bc-42c9-8014-c02a2d6366c2"]},{"cluster_id":"254e946c-9e7a-429c-b142-d41e38953b50","members":["2112f65b-e3a2-4663-82fc-47099fd11849"]},{"cluster_id":"da1ad06e-43a1-466f-9487-046d8d125726","members":["89f7be9b-a071-4364-9aed-c2503bc4bde2"]},{"cluster_id":"0a129298-9d76-444c-8b1e-1ebbbe3bb953","members":["5d180492-af7a-41a3-8010-6039b9a42ac1"]},{"cluster_id":"ce4675a2-eebc-4f4f-bcc2-33cbe65f4024","members":["129dbf83-ac42-498b-8af3-31b2930d0936"]},{"cluster_id":"126a3f86-7f2c-4e93-8c54-043a34be7761","members":["da8e4118-0138-42d0-9996-8b05153569cb"]},{"cluster_id":"a9a9b1b1-c494-4c16-84ad-397e74093b98","members":["bd231caf-cb0b-40ad-80ec-357ede8ccc9c"]},{"cluster_id":"4efb4906-b539-4d71-8685-b4bd14aad476","members":["0ac65c20-e64f-4572-b4fa-95038cc94c87"]},{"cluster_id":"2ddd688c-7c02-487e-a8aa-11d74ae8915d","members":["eb029676-869a-4779-a1c4-e6a9ef61658a"]},{"cluster_id":"b2f5e997-51a9-4075-b2b0-b908ca91bac7","members":["1afe2096-97db-47e1-8782-51875848059a"]},{"cluster_id":"3909ddcb-f2e7-47b0-849d-f54906120921","members":["caccea01-8968-4258-9488-740a1c367d1b"]},{"cluster_id":"19380a4c-de83-43a7-ae00-058986b5206e","members":["3dbf5840-202a-45c5-a392-6da5fc3384f4"]},{"cluster_id":"c586556e-d0fb-4b9e-b41e-3635da810071","members":["fe00d12a-4e33-4d24-8260-ce000bdafd3b"]},{"cluster_id":"6e309345-7a1d-497c-b9aa-287116558129","members":["90183469-2373-4c0a-9db7-66fda3723f82"]},{"cluster_id":"012b2764-4f2e-4783-9281-b3cc16d33a77","members":["dfcb69d0-f432-473d-a4bd-c9537e190c44"]},{"cluster_id":"12cb5a16-807e-4b60-87c2-713f3796ebf1","members":["2c6b27af-38c8-4b38-b040-40f8bb33132c"]},{"cluster_id":"c91f4478-001c-4706-a4cf-7da14de01daa","members":["988a32d5-7f90-44fe-ad3f-eae1713fb46f"]},{"cluster_id":"01bab4ca-5ac0-4d57-8f20-7bea2afbd031","members":["2bd4165c-309c-4266-baea-489fc2660c0f"]},{"cluster_id":"b2a62820-6f02-4de4-99f3-aea0d67cd577","members":["17959a76-3641-4e0b-abd2-b380896e1234"]},{"cluster_id":"cc95457a-219b-4008-9216-67e0ee2bc74c","members":["f2628ee0-eded-4b4c-b5c6-6967892ae038"]},{"cluster_id":"23f623bb-83de-47ba-a19b-9df053aaf2d2","members":["214d1e31-24a0-4a9b-9959-ee0e01ed62fa"]},{"cluster_id":"90113fae-adfb-4eea-83c3-93afc851a256","members":["c2a74fe2-3c8d-4007-9006-5202a81e3db2"]},{"cluster_id":"bd99a1f5-0df7-4f4c-90f0-16afb1a5c96f","members":["8322049d-460b-4c14-89aa-784164e6301f"]},{"cluster_id":"cfc7b0c0-e0dc-44d8-bb40-008b16bc6352","members":["0ab2fa20-d314-4b6e-8ef9-3d0b3754a0a3"]},{"cluster_id":"b23ac12f-f63d-4693-a840-84942ee3fea1","members":["df133827-888a-44b4-98ba-0bd4267a4b64"]},{"cluster_id":"b3b9380c-37e2-402a-8ec8-0e1aeaee4ebd","members":["8db5e96c-8ab9-49e2-be45-cb84446f42b4"]},{"cluster_id":"af868606-4265-4854-b859-dd107b996ff4","members":["278fdcf9-885a-4a38-b620-4449c53c1fac"]},{"cluster_id":"3d51ea74-3b4e-41f4-8d23-b8b5e017e1be","members":["20688556-fcd5-43d5-8b89-0603da011cff"]},{"cluster_id":"bf10b6e6-7de4-499b-bb6d-a9e69524994d","members":["9faacbf5-8470-4ede-8cfc-18027e35aca1"]},{"cluster_id":"e8c08050-8918-4c52-bcd3-c5994c5cd40a","members":["2e4afe6c-377c-41fb-a709-0aa17fe96c47"]},{"cluster_id":"f5e1b739-645f-4391-b201-66a90f3725ef","members":["b75ca8d7-d78d-4731-bbc5-827e3e8c284d"]},{"cluster_id":"15826810-2be6-4996-948b-869e0ec64e02","members":["4c8fe5c9-7702-4b7f-89d7-34a3387550bd"]},{"cluster_id":"5cf04f55-a643-43d4-8d14-b18769ab1e2a","members":["4a85235b-d804-415b-ad8d-b80286344dda"]},{"cluster_id":"182a4780-6c12-4ebc-96a7-e01af3d000d2","members":["2f31b597-a1c6-4a14-bdb1-9926031bd733"]},{"cluster_id":"afcde980-e0c6-457d-998d-0d7991b35017","members":["e63ed35c-d2ce-4cea-b973-b0de720980a4"]},{"cluster_id":"50312364-9e82-4970-9daa-1275d0caaa37","members":["c8e1c6d5-165b-4699-9c2a-644ffc9bc590"]},{"cluster_id":"5c60b7c2-773f-4fa5-90cf-1511916b711a","members":["5df08847-a67c-4353-9d9a-ac186bb7a0ac"]},{"cluster_id":"b0fdd1fd-fb84-40ca-af9a-591f59bfb795","members":["76eb3d3a-2128-4f48-b28f-2e31e901d9e5"]},{"cluster_id":"05e83588-8d3e-4daa-9f6b-b9faf4c1da93","members":["732ffe1f-e2ef-42d6-ace5-30f2f6397c5a"]},{"cluster_id":"358c0eb2-869f-46fb-bab5-4fbe8881d4e8","members":["584a07dd-348b-4a9c-bcef-72d38726e3f2"]},{"cluster_id":"b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a","members":["a15ffdcd-dd35-4e0b-a278-d39f0b704449"]},{"cluster_id":"2529c3a6-becd-4a5a-81a7-ccc8f9b32cae","members":["52aeea6c-dbeb-49dc-b01b-d54c7468c757"]},{"cluster_id":"642bde4d-512c-4efe-a811-93209336bdce","members":["43e6cdbe-7110-411f-9599-5f5644f1793c"]},{"cluster_id":"9f888081-86ee-47a5-ac83-e1aec7d1b080","members":["62f49896-fe28-4e51-8248-9a0dbb2ec952"]},{"cluster_id":"0e128959-4be6-4a58-950e-03878e48a675","members":["db5cdca6-47c0-4025-afb9-5cf4330d18fa"]},{"cluster_id":"5e8c77df-b06c-4eb9-af9d-86a5548a4dfa","members":["ed606e7d-2737-465a-8cb1-534e7a2a2bab"]},{"cluster_id":"b419eced-65f4-49b5-ac60-2638f9c27f53","members":["908e3499-9973-409e-9771-39750bd71773"]},{"cluster_id":"410287df-601d-432b-a55d-63a15a95a255","members":["ee66cc75-520a-448c-9cb3-5329fa946d27"]},{"cluster_id":"f1e47970-325f-4291-8d1a-b29229c84e05","members":["0877ed46-c1ba-45a3-ba4b-a8e0a6439edf"]},{"cluster_id":"93067eb9-0c23-4760-88de-71a2925db3fb","members":["6659a365-5a97-4293-a252-2be5c298330c"]},{"cluster_id":"a0f403d2-a7ff-4e00-84e6-2783bef20b8e","members":["52f42ec6-780e-4efe-92d7-4226178815ae"]},{"cluster_id":"33fcdb26-eedb-4334-944b-e4ef875270b1","members":["92dc8e00-b4c6-4a43-b561-1940fec3c8ef"]},{"cluster_id":"f2d4f2cd-14c3-4d0d-9c96-d0df234f7a5c","members":["a955132e-e3fb-42db-a430-9bf42ff99559"]},{"cluster_id":"e95e8766-3999-437a-8b4f-72bf3c33a6a7","members":["96332f73-f924-443d-ace7-40cb4fa6d25f"]},{"cluster_id":"0d16b859-0b48-4545-ad3d-19b0d4601fe2","members":["b8fef55e-cb17-4144-b36d-efe1a1412aa7"]},{"cluster_id":"ec47ea11-5e31-4849-97a1-585ce227df93","members":["1f99c609-d675-4aa2-8365-41180ff2b10f"]},{"cluster_id":"be39314b-1ba0-4fb9-b326-3f0e244710fc","members":["f84e3f68-1f12-4277-a0ad-1a2855816e89"]},{"cluster_id":"3cd947fb-d46a-4f38-9705-3c1f8700f549","members":["6f517cb4-a5d9-48b6-89f4-774edcbd04fc","f0464042-16e0-4fe6-9cea-1520a58e9b6f"]},{"cluster_id":"e30d449c-eb81-4d62-9149-9437a1a2c593","members":["90075709-94de-4eff-a784-7426de978ac8"]},{"cluster_id":"6220afcf-2f7d-4d0b-9949-c9eea0785c4f","members":["2f96b357-c41a-445d-9c72-3c14267b0f04"]},{"cluster_id":"a49c6bf6-4bdf-4111-8400-ae8603304250","members":["3a6f2a92-5754-452f-9004-2098c7d76d66","65a33ed5-7059-4720-8664-71df06856cd6"]},{"cluster_id":"15f10d86-dc7c-499e-a621-4444d739de34","members":["443755da-213e-4f47-98c3-d9454d1eda94"]},{"cluster_id":"715be432-cabb-4dfb-94ca-fb3947c60120","members":["d86964a8-b40c-4f2d-92ed-481299aa8e92"]},{"cluster_id":"ad8eb55d-3403-4e48-a3d6-9bc723fa02c6","members":["992eb91d-44b1-4560-b199-36dfde7ead73"]},{"cluster_id":"7cb43f88-bfec-484a-965c-af899d9b8682","members":["1a966d51-7954-47de-9b75-a0b764a89815"]},{"cluster_id":"ff80368b-8a04-48e8-a451-431808c81ba2","members":["4f3cec2d-39b0-4ba1-be54-1f87fb414f33"]},{"cluster_id":"2723b56b-92db-42cf-852c-6b9603282fde","members":["273108f2-182b-42a7-952a-9d33cd5b44da"]},{"cluster_id":"9cb96178-90d1-49cc-8907-eb63419e86be","members":["91b914d2-9ac6-48f9-9b90-2415008e69fe"]},{"cluster_id":"f8f2a0f0-c3be-425d-86a8-e332c871c957","members":["0ec31977-3023-4316-89f2-6cd4539a5b72"]},{"cluster_id":"dfebeea4-e8fe-4891-915f-29504d1d80da","members":["3c3809b1-e474-4a0f-9fe2-ad9388296f1a"]},{"cluster_id":"29c9c847-8482-467d-b041-65b225a57d48","members":["04179c15-22d3-4587-a3c0-a8d9de3bc862"]},{"cluster_id":"109daecb-5285-41a5-9427-7fd6ab199a14","members":["1c531e95-8a53-4fa7-9cf6-f56ecc7fc194"]},{"cluster_id":"f0764df3-3340-4405-ac6d-daef15a6934d","members":["2d287b25-96e4-4d14-b647-e585113cb393"]},{"cluster_id":"f54e9fc4-9854-41c6-aa04-dba66f36cc19","members":["ea0de8a9-d55b-4475-a20a-bb160d082ced"]},{"cluster_id":"abea76a9-3994-48b0-b3bb-df2d7f55ad12","members":["5abca650-7537-4d87-ba3b-ea71a51d8966","bb447e51-3e43-43d2-aff6-cd68610c451a"]},{"cluster_id":"db855b90-bd37-485e-bb72-492eed958963","members":["d7f5b683-1482-4b26-8fcc-a98be03f2ee9"]},{"cluster_id":"9993ea09-c44e-4372-864a-21c7f72c7eef","members":["3b2a0ea9-b56f-4243-bafd-25eb3dfea4bf"]},{"cluster_id":"20bc1b1d-621a-4c85-b194-0b79b56d7c82","members":["4b72e737-f1b9-470e-ba9a-2b4d5d50e353"]},{"cluster_id":"5261c3b8-e566-4b27-8dcc-7c47abcca2e2","members":["17a480e6-1bf4-4c05-9ca4-8a1c574f0fc4"]},{"cluster_id":"beb95653-6e6e-44fe-9a2a-77a05c101fd4","members":["39f0c8d6-5221-4a5e-bf65-ce98b09f7bd0"]},{"cluster_id":"763eccef-6999-42f0-bf57-610e354559e9","members":["9d220ba5-be35-4626-91c4-851a735df936"]},{"cluster_id":"d0668eff-8d5e-4aa1-a4e9-eab28ee44705","members":["d27e4f87-9af4-40ef-9766-ee18cb24a24f"]},{"cluster_id":"7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e","members":["f54f7af1-1b71-478c-91f6-ce3375ebdda5","74d6300c-e54d-4b56-8ed9-29f1fa4731db"]},{"cluster_id":"a1bd8b84-b3b2-4726-a7b0-fe007bb23321","members":["3d9743ea-263d-4b21-91a1-bdc5bbce2499"]},{"cluster_id":"e4b7f8f2-bf69-40ad-a14f-a4a477fe73df","members":["48ec065a-a22d-4b14-98ef-d1e57418b549"]},{"cluster_id":"dcc8df2e-a077-47fc-8960-d90fac2ea1d8","members":["58762de6-ddb0-4b06-9187-97497eb3ccc9"]},{"cluster_id":"9cc8799b-e620-4e1a-8846-51eed506e0de","members":["057f2b8b-55d2-46a9-8ee2-57021db73494"]},{"cluster_id":"ea70a7dd-0151-4733-b8dd-c6143a306c66","members":["9dfcd6c4-1585-4ebf-90b9-c35a0fa7b77c"]},{"cluster_id":"497c65a0-d076-4ce0-b5c7-b89152ec15dc","members":["6fea3a19-99f6-433e-b70b-f3608c3e60bb"]},{"cluster_id":"c0b25dac-eed2-4056-a693-6719f5711bef","members":["6cf8907e-3799-472e-a142-6db5a32cf03d"]},{"cluster_id":"64d2c311-675b-43df-a715-09bca5e25a05","members":["70355289-4e54-47cc-81ed-a7bb982902ee"]},{"cluster_id":"8ee8c1bb-0d20-4333-9bfd-60f5cae2d370","members":["21ef3182-d37f-4089-afa7-5293f6ec11a7"]},{"cluster_id":"743f75a0-41d3-441e-9941-3043106cc340","members":["5f591bb2-1596-4e97-85e2-46ecbfcce715"]},{"cluster_id":"a83597bc-3768-4ee3-a01e-2fac92f73ab7","members":["81040900-a0c6-4475-991b-52fa81fe003d"]},{"cluster_id":"2ff54a92-503d-42da-bdb7-6138f7c69fb1","members":["4205ac4d-65c7-4014-8d2f-8cd32be87732"]},{"cluster_id":"3fd5b7b8-68be-4404-8df3-9480731b7b5a","members":["e838e359-ee60-4cec-8c08-6dd107ae93cd"]},{"cluster_id":"bc800212-afc6-410b-a69d-f8042afac330","members":["8e52fce7-6f34-4f80-8b7b-48f2857c305e"]},{"cluster_id":"25e8666d-6596-4996-8765-9de5aa51e568","members":["6080b396-b17c-4aa2-81b9-ba25672408a2"]},{"cluster_id":"cf6c1c0d-fc13-4eb6-a686-91e7d8509399","members":["4c386586-e3e9-4a25-9801-0eafde56c525"]},{"cluster_id":"95eac10f-08e8-4ebe-913d-90bbcf49cbbc","members":["aac25fda-3c07-4c31-aa1f-fd0594820879"]},{"cluster_id":"efd04eb7-8311-4730-bee6-1df74b27a996","members":["1a0a0196-5909-4768-b7fd-e4131e2d6c8e"]},{"cluster_id":"ebb2f2f8-c476-4b98-bd7c-c0a3ef8345f6","members":["762253e6-57af-47e7-b109-eae8b57cac36"]},{"cluster_id":"ffdeea6b-2666-497f-8afc-18b1b72c39c8","members":["7e4169be-df96-4a1c-aa6c-703ba0cf2881"]},{"cluster_id":"d4e4377a-959a-445e-9e4e-9d1461ec884e","members":["6e248ec0-e30b-4f51-8579-24812d158310"]},{"cluster_id":"2a58b8a4-48d6-4d79-a6a6-51d7d778b6e1","members":["9a5ad9cc-8f84-4803-ab1b-e12442d8d75c"]},{"cluster_id":"f1b5fe76-d258-4eb9-9621-ec9dac4e7f52","members":["0d5c8fb5-25e3-4975-9d67-5ead0c547fd7"]},{"cluster_id":"2160e916-6f22-443c-821e-3ddb5ec1cf74","members":["c06924ea-b252-4ba8-baba-1346689d0f77"]},{"cluster_id":"4c8c98df-55ae-4fb5-ba8d-8d914fda29e6","members":["51f12563-6d80-4e66-9666-c6f294c04b61"]},{"cluster_id":"cd745d99-6d4d-4cbd-964c-839c80021692","members":["6b59b7b8-899a-4348-9f47-d102264da0be"]},{"cluster_id":"0cf451c3-4981-46fc-b4ee-79c480a2a2b9","members":["bc8aa8a6-413a-4ef6-955c-b7b8f1001177"]},{"cluster_id":"0834a3ac-a924-43d8-bec6-6e7d0a1384ad","members":["54c57281-6ac3-4089-bff4-8a5005f13b2b"]},{"cluster_id":"903140f6-5deb-4b0a-b645-3ff3ded85a2c","members":["78145ec9-7610-46fd-abe4-b0c54e40e502"]},{"cluster_id":"985525fb-882c-4e38-8f11-fa12ae906da0","members":["7ddab30b-c17e-4d25-a28f-fdb334a4e123"]},{"cluster_id":"fca5231f-5992-4d7b-ae79-0b5b3aa11fb8","members":["16e34379-812e-4b5d-99d7-77cd6206fd62"]},{"cluster_id":"84e9da04-8cd3-4c61-8fa8-fb55a6309d3d","members":["a6fc308b-3017-4785-b22d-6757f02916a3"]},{"cluster_id":"a5c724f6-7c96-401f-918f-4b43072ac6cc","members":["c3964c0b-7310-40e7-8f89-8e0484db56b0"]},{"cluster_id":"d67d9854-246c-464b-b04d-764da1ea0a72","members":["89acd222-703c-4720-9a8d-6057aeb66108"]},{"cluster_id":"3cbece7e-7ff3-422e-bd74-b94ccde6f34a","members":["284807e6-5a7d-4b3d-9de8-37f95923bac0"]},{"cluster_id":"a1957de3-964f-4df5-ac8b-e165983c14d7","members":["a7f94928-dc14-48df-894f-bbd44314a21d"]},{"cluster_id":"64cf5e07-c73c-4733-9b23-8f12213cc336","members":["aa8b0872-8aba-41b8-a356-53cdcc685d97"]},{"cluster_id":"56a71fc3-1754-4e95-b0fd-27485ee352e9","members":["81e31e4a-d74f-497d-9953-d5e8a971de7f"]},{"cluster_id":"e63bcf8f-4e49-4048-bed7-415583eadc3f","members":["7af695bf-f174-438a-bf33-8de415057f92"]},{"cluster_id":"b2a104aa-8e99-4af3-a2f3-b3e4f2fb5af6","members":["bd4e11ec-b7c0-477a-aa5d-25393b75350b"]},{"cluster_id":"d05aef6f-059f-4fa1-b456-946956a2ded5","members":["43739e83-5143-402c-987a-39ea6d5e21dc"]},{"cluster_id":"65143df4-6c29-4538-b9c3-4cba1c56a8eb","members":["d6ae3f94-02d5-4536-83f8-8be433e4dd52"]},{"cluster_id":"dad9620e-fc93-4bb0-adf4-d1ba1da4f381","members":["d77b65cc-00a1-4a75-9335-7fe0ec3ef5c8"]},{"cluster_id":"367c1ab5-4267-4b68-a2ed-2893d2797c11","members":["29a24473-b8bb-48f0-9506-7cc876ec9c53","9ba9a2bc-1b97-468e-8e27-647989e228f4"]},{"cluster_id":"dbe0f86a-aebe-4564-9503-5702cd51713e","members":["b1078384-5dbc-482c-80e7-b3c2c8fe20fa"]},{"cluster_id":"6adcd904-be39-467c-bbbe-a9cce702dbdb","members":["8cc747bf-1146-4f59-bbc4-924fbddcde7b"]},{"cluster_id":"83f7014a-9a88-48b8-b5ab-b83620e2b1f6","members":["2f9c6547-073e-47c9-aec0-6dd23bb6a1c5"]},{"cluster_id":"c4d30aec-5c26-4bc5-895d-1e61d6d7b97e","members":["2e96409c-7d0a-42c4-b320-7826d3915f16"]},{"cluster_id":"ac7c5639-803c-4c6d-b9be-69ecbea167de","members":["1d149e85-0fe7-4c13-8ed7-3fec8ed5ec74"]},{"cluster_id":"b985b53e-1d8b-45e2-8b3f-823f5bdb2380","members":["5ad8fc67-ff18-4a10-aeaa-b0d12fb2b6c0"]},{"cluster_id":"aeb63f4c-fb27-45bb-903e-d98ab93f7138","members":["d5265464-b07f-428f-b9e0-de6d62c4b69e"]},{"cluster_id":"2dadee48-a44e-49fd-a481-3bd3ad498e90","members":["bbbf487f-7ca2-439c-9083-5a2a23d1e934"]},{"cluster_id":"6e62e8fc-d0f2-48d9-952d-5f14837f0f03","members":["c6a4fba7-df7f-4349-939e-444ef1af059d"]},{"cluster_id":"b366766f-15ce-4857-abc5-dda97885eda4","members":["f22e9252-9040-436b-a71d-021a3ffca2b7"]},{"cluster_id":"2dfb4996-f1b5-47a1-93fd-431ef2467700","members":["eb2b1c62-ff40-4bef-b079-3ed1a9a922f2"]},{"cluster_id":"e5eb9c21-045d-4a8f-b07b-6af55af6d48c","members":["d42ffc06-b4f7-4cdf-8740-500fda2e76ab"]},{"cluster_id":"094959dd-ba14-4dbb-83c9-b7363a4aff97","members":["5f67926f-47ae-466e-945a-4e24a57f495d"]},{"cluster_id":"da3e8993-13d7-42de-887c-a22169a3cf16","members":["029a41b8-5bfa-4a1c-a823-99d0b28d7421"]},{"cluster_id":"b8f80339-9419-4259-b0c6-1e550ab9ab7c","members":["ae8ddae7-cd18-4788-88e8-ea413e8d6ac3"]},{"cluster_id":"58f3dc82-7967-4488-b9f2-9a804334fb7a","members":["e56d3be1-6286-42f7-ae0e-3bcd92b6d963"]},{"cluster_id":"5f26f77b-0214-4097-94f1-7873a36d7969","members":["33448b65-89e1-453f-ac46-097978266b95"]},{"cluster_id":"70ea1622-08ba-432f-a3ce-0079b309daee","members":["d816f5ed-9784-4f50-b90c-f6908758e6b8"]},{"cluster_id":"77810a86-21b7-4267-8df5-dbf7f241aa35","members":["8cb69cfd-85dc-4c0f-b971-2a4889509e57"]},{"cluster_id":"528595cb-88e8-4fb8-9197-5baf87551c4a","members":["073a0a2b-171a-46cd-9eb6-8944e39c4434"]},{"cluster_id":"7b4ecda5-4408-4ecd-a695-939e312b6ac7","members":["4ac0b73e-244f-47b5-945d-8d0c3614d33f"]},{"cluster_id":"c7d55c3d-c95e-4814-b774-3a8773d025eb","members":["97de3966-6346-46ae-9e03-b0a4c14a782b"]},{"cluster_id":"c5169cd7-a9a1-476b-8658-0fe7fd1f0d44","members":["4a6b1605-1c0b-49f4-ad28-fac808622876","bf2117fc-622a-4b9e-9739-256e8d0257fe"]},{"cluster_id":"6e377c9a-0767-453d-bf0f-0a832d805a7b","members":["7ce2fa37-7022-4551-9c9c-e5b51aff0552"]},{"cluster_id":"45c15578-ca19-42ef-8fc5-04e77034e4c3","members":["d79ed9b7-d187-4177-b2dd-99cea6aa6c11"]},{"cluster_id":"1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3","members":["4d24e4bd-5b86-4510-835e-015de2aadc8b"]},{"cluster_id":"062e5bd8-abe2-403a-b6a1-7c176aafd049","members":["6094a91b-be05-4e65-991d-88834f3c6d51"]},{"cluster_id":"39d6e082-ff74-4db5-9429-ae565700afa5","members":["096a3029-98b7-4ed7-9eb4-e6c2193815e0"]},{"cluster_id":"4807cbce-9aad-467f-86b6-35d202d1cb91","members":["006f8e37-0bf6-4529-8ae4-8b2b2c61290b"]},{"cluster_id":"d1bd7e91-60d7-44c4-a3e3-fa4bad7dab38","members":["0a29d425-4f20-4547-ad98-782dbb8b942c"]},{"cluster_id":"c724c59d-be1d-40e0-8e89-b56ec9ff6193","members":["e6cfc285-f96c-462b-86de-69eae094a9bb"]},{"cluster_id":"0228c164-28e2-4e5a-b2e8-2f3ba9a5fbf3","members":["989cde89-2dab-4dd9-88e8-2bdad40f6525"]},{"cluster_id":"0e8cc365-638d-4d52-88e5-ee27a8dddfb2","members":["153717df-7ea2-44dc-9d09-0a3b96f8d0f1"]},{"cluster_id":"2e3c3c0c-9c80-46be-8b29-ebed3dc26978","members":["b51b52ad-234e-4f9f-aedc-378f5af6691f"]},{"cluster_id":"639a3221-3088-4eab-a13f-8485c80e01c5","members":["d6fd61ec-67b4-49a7-b01e-6751da4c2b70"]},{"cluster_id":"990108fa-17d4-4b4c-865d-d0668a8a4d9a","members":["192f64f3-404e-44e7-be69-061f71569962"]},{"cluster_id":"676e190d-f7b8-4cab-bf36-934dddda11c8","members":["66cc19cb-d992-4801-a6a5-3bcc508cad56"]},{"cluster_id":"269675ca-916b-4267-8970-bb97e2010767","members":["b92df98b-d7a8-492e-99c0-f650da425547"]},{"cluster_id":"6f7eecf9-9f3f-44ce-8b0e-5a71d6961aae","members":["4184ac9e-a2ee-42c3-b501-e30a7f7cceb3"]},{"cluster_id":"9f64a0ee-1ff6-468b-9bf7-001ce2c6ea58","members":["6fef70f2-b2e5-4078-9e9a-4ed219b153de"]},{"cluster_id":"abf9a23b-ae17-4adc-8775-9b47f6861ebe","members":["b2ac124c-ace9-4763-b92a-9b4ee6fbe882"]},{"cluster_id":"5a4d2a32-bac0-4370-915e-eb0f49138ccd","members":["06462009-bc55-4f62-843a-7d69d3bfed7c"]},{"cluster_id":"48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75","members":["7228ee7e-e61d-4ebe-bcd4-e6b39cf2dc2a"]},{"cluster_id":"0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a","members":["35b2b00e-13d0-4a07-94e4-e0237cd1bb94"]},{"cluster_id":"2ccc0520-5070-4b1d-b1b9-d9e9fc878c97","members":["4cb198bf-2c46-4779-a0a2-822e74b7b4a3"]},{"cluster_id":"52457cd6-b07c-4e34-b96e-c3d2ac06f2d5","members":["fa1c7035-96d3-49a2-8d99-2e4980a79148"]},{"cluster_id":"89deb9da-1363-4a27-b0dc-19089a829274","members":["012714bc-c95f-448c-9823-3988f2217818"]},{"cluster_id":"0e6b6876-fb14-4627-9900-55ce513c116c","members":["06e78ed7-0599-4d54-9772-986b6028609d"]},{"cluster_id":"993498fc-f160-4c04-b836-a36d850156e5","members":["01f3eb35-460a-46a5-bbaa-c848320a4e96"]},{"cluster_id":"dae1826c-9197-4507-aadd-a2ba9a01285b","members":["53189873-e1b0-4a74-a2de-c6f96c1ee63c"]},{"cluster_id":"2d8f3813-2525-407f-8769-b0281d589d42","members":["2ecfd8b1-aeaa-4f4a-9ed7-bd95ba311047"]},{"cluster_id":"59e2af7d-1c61-4602-808b-5369f9854fc9","members":["9e46276b-9550-4850-906b-947941551ea0"]},{"cluster_id":"9d75c554-9eb9-4082-9c04-6fe3e303845e","members":["7db66327-741e-4aba-a2d0-9dec13f88426"]},{"cluster_id":"213e0c4f-0911-44fc-89bf-cf985adbc12e","members":["f5f8713a-6585-4825-bec7-0970665e313b"]},{"cluster_id":"bfccbfa0-4d21-4c95-88ca-a83d95def684","members":["6b9ee849-6886-4346-8ad1-d1204d78e963"]},{"cluster_id":"3bf8a3ce-dee2-499e-bfb9-1c559ad0291c","members":["71bc85b6-6f5d-4aef-bc64-1f26ad42393c"]},{"cluster_id":"bca53d12-fc37-4cd1-9c2a-d9e494bc9ea8","members":["40693fc4-7ddd-4a41-9ba7-2ab2fce9c650"]},{"cluster_id":"201e4820-096b-4a76-8f83-d96f22acc64b","members":["6681479a-13d9-4db6-b878-98826e64562b"]},{"cluster_id":"5b4f8322-7c02-4a35-a585-89dc98ced769","members":["a3211a66-26b4-4f94-8dce-8734cfb6c504"]},{"cluster_id":"26b806a5-30f6-4312-bfd4-c6984e3b4d30","members":["9912bacb-3f98-46ca-a184-72b1066243a3"]},{"cluster_id":"52bfe357-189c-4c8a-a4ee-372f061bfc2c","members":["b6a06f13-7ec8-462d-8836-4a64b81b052e"]},{"cluster_id":"25e1da60-126d-485f-b6b4-e17bd08835f7","members":["e99c6b71-2091-4ff9-b9a1-3ffb9da8a1fd"]},{"cluster_id":"7d7dd851-9e80-401e-86ac-20fbd4d71580","members":["7d86a9a0-38d1-4e6f-9511-4471e7bb984a"]},{"cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c","members":["cc823d78-71f1-4505-b8f8-4cbd92ba6515","7fcc26bf-3d16-4a63-bed6-eb9aad637370","ccfa9ab4-b725-46fe-9d4b-81f4301a7777","6435466e-2952-4414-a5f1-47d0171d8ffe"]},{"cluster_id":"aead4c3f-44a7-4ce8-91b4-79e0aadcc982","members":["e6358408-cf3c-467a-83f0-f1a25a9cb069"]},{"cluster_id":"075ee2c5-b49b-44c4-9646-461463ce6ff8","members":["33f1cb91-f1d5-4f65-96c3-91b4f079dae6"]},{"cluster_id":"ebcf5883-5a67-45cd-af26-c257a5d38512","members":["2643e618-f92c-4989-a4ea-d7524c161d11"]},{"cluster_id":"7869af70-2ee4-4af6-b749-30538201cdc4","members":["81a34fec-f865-4d74-973d-1441a2e96448"]},{"cluster_id":"4df09684-8f05-4939-a1b1-6f51c32b4b06","members":["b20106d0-cc8b-4da6-847a-cee0c4e03136"]},{"cluster_id":"10b72ca8-fbc7-465b-bc23-1509272e1515","members":["b1b7994d-e789-44d3-8fa9-786c6ad1660f"]},{"cluster_id":"2d5f7bd3-4c30-4ae5-a057-0f3e35a0cb68","members":["01e15d8e-9278-49d9-b0ae-ee64046f3232"]},{"cluster_id":"aefe0bc6-fe98-4828-a554-094ca6f377d1","members":["1a70a4dd-2da1-4130-83c6-be14a06081b2"]},{"cluster_id":"a75f7771-ca28-43b6-99aa-f4f9b0398268","members":["adb47cd3-ee56-4d9a-9ca2-c4a01876a63c"]},{"cluster_id":"0d049984-1ab9-44da-bbd0-bb9c99a21317","members":["c8879a85-e025-45d5-a6f3-c18a66716cc6"]},{"cluster_id":"a28a5ed3-bc11-405d-9242-8b1a5ce91c01","members":["78b14f68-ae01-4d4c-acb1-0d71d1609053","9c8061a4-b6c8-4b01-9126-324edde1a3da"]},{"cluster_id":"148cbdc2-efc0-4f16-b29a-724816c7ee5d","members":["5faf6e11-7e86-475d-bf63-e4435dee1019"]},{"cluster_id":"92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c","members":["af931724-5e01-43e3-b06e-af89df93f816"]},{"cluster_id":"3e318927-1041-4535-a22e-049f32238ea2","members":["99463725-d3fb-40d5-b695-6e928f7a6286"]},{"cluster_id":"10d03545-859a-4c3f-b85f-14e8f49d3ac5","members":["6ecc5c36-f428-48db-8860-cc6f3409b905"]},{"cluster_id":"cc24e5f4-c0b5-4176-a975-3eb0a8f8713d","members":["00177a2b-221c-4df0-8918-34f76f806afb"]},{"cluster_id":"d345d980-af47-4c52-856b-f3fba326963f","members":["f4e6e97a-7274-4981-aced-d5b19a5f74cb"]},{"cluster_id":"7c3363eb-6e57-40c6-934c-69f3d1e89801","members":["86306a55-2043-46cd-8b9c-cb3d3beebc6d"]},{"cluster_id":"cda7a1d3-b038-4c3b-864e-35781faec81a","members":["193f820a-5a38-4ded-ab67-3111ab1c213a"]},{"cluster_id":"5a26984c-e60b-4dac-8536-2c84c78b7c2a","members":["b4f98ed3-8223-4416-9d64-76e16d257741"]},{"cluster_id":"ca0d7a2a-b8d2-4968-874b-aa3379e0dafa","members":["46cca0d7-4e2c-4d52-a3ab-76af3ea351e7"]},{"cluster_id":"b02a0b69-fccb-4794-8e75-23dec5c20147","members":["1cd55f6e-f978-4e0e-8c42-852043619353"]},{"cluster_id":"1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b","members":["2e4b1b25-9832-47f9-a571-e3cf7e71a86b","28857841-34c9-41d8-9e68-cfa18abcaec5"]},{"cluster_id":"016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc","members":["c76856fd-3193-49fb-aaca-987b66991f96"]},{"cluster_id":"3dc78939-89e4-4b07-a3e0-cad83ab8d427","members":["6319b523-7a66-47b9-9709-d11fbc2b693d"]},{"cluster_id":"244850ce-669b-481d-b002-ad90cb2a1ad2","members":["24798506-4131-42dd-93ec-7fcaf538d514"]},{"cluster_id":"10cff142-fdb6-4cd5-b991-a870f41801d0","members":["895d573c-7c48-4b90-9725-42ce20b2311d"]},{"cluster_id":"ee3497a5-19ab-4376-a948-4abe0f0d9b83","members":["02509c8c-3ac5-4e9b-a5fa-bc3de805bf13"]},{"cluster_id":"ebaf2aaf-acc5-40a1-b99f-157e33f793e4","members":["3f9c9033-7f55-4d2c-8bb5-e8d64bfba2ad","e2efdd4f-6c5f-4755-b476-6368f4ecdcfe"]},{"cluster_id":"6707f20d-c9f4-42bc-ba94-e97c87eae6e1","members":["782379b9-cabd-46fc-b911-0470863f9959"]},{"cluster_id":"42b0a0ff-74f3-41bf-9d03-2adc79284ead","members":["4bfc3856-1d1d-40a6-9dea-4ca5e589114f"]},{"cluster_id":"15b6ae6c-1463-4a8d-9552-d2739588b3e7","members":["760eac4a-ccfb-4233-9ad1-8b2a33b46b07"]},{"cluster_id":"c9d1dced-4dd7-4c70-87e5-a257d37a3ec7","members":["cd7e77ee-90bb-412e-8be8-7efd19f44bca"]},{"cluster_id":"5ed59d44-85f1-4b54-af2c-2965549e9825","members":["a9c6ea4c-098a-4bf7-8177-5e9d3dc7e7b1"]},{"cluster_id":"3d7847cc-aacf-44b1-8832-6089b6ace8d2","members":["2ed16c52-b1a2-4fa7-a894-4f80d57f03ca"]},{"cluster_id":"3706e344-49f2-43a5-a708-cb9ca4fbc648","members":["d6541a0d-b8b8-4b46-b2b3-7709093a904d"]},{"cluster_id":"c44517b3-ae07-46af-8dc8-9946743528e1","members":["d5289d0a-7587-47f3-a127-377dde4d6139"]},{"cluster_id":"3cee1037-34a3-4502-8ebe-36a15c95ec82","members":["138a7f8e-9488-4037-a411-2c7f0bd720e4"]},{"cluster_id":"0d8dd84c-b6a6-4b66-80f5-c84acd03da41","members":["8b2db83b-6c14-4087-b8bb-a72645880736"]},{"cluster_id":"37c144c2-5b3d-4b37-81ec-b6ea11090b3a","members":["a323c5b7-c89f-4df6-a9cc-1b10d2e262db"]},{"cluster_id":"5e83ce8b-b525-4867-8caf-5b4d780a4a6c","members":["50eb0125-135f-4fda-89a2-8784046737cd"]},{"cluster_id":"49b71ab3-8ddf-486a-9781-e873ef1c9042","members":["fe475462-13d0-49f8-b497-59d3e83070b5"]},{"cluster_id":"e9f5a5d3-fb2d-448b-ab54-b718baa4bcab","members":["93525525-c9c8-41fd-8976-67360dc59ef5"]},{"cluster_id":"e9e5cd65-c720-48d1-aff5-59d128103cd2","members":["f32378d8-2d99-43d4-9ef6-9f811b5f21a0"]},{"cluster_id":"da5f41fa-d075-4835-b977-9a11cca0ec10","members":["99e12ad1-d630-44fb-b4f9-a4cff70ce19f"]},{"cluster_id":"60da7061-2845-47bf-80c5-d5e550633128","members":["a9037445-b5cd-416c-95e5-21c313b0115d"]},{"cluster_id":"499883aa-4d50-44a0-85ba-67de7dd41a9e","members":["a712c2ed-6f8a-4c3d-b2e3-f027854812db"]},{"cluster_id":"2fef56aa-90d0-4ea0-9ef0-fc7608685f56","members":["0473891e-7ca3-488c-9e31-ebdce839cd19"]},{"cluster_id":"eebab277-5cd3-4cfd-9fb6-1c0154222c56","members":["9df7e52c-2adb-4d55-b85e-14542afa3f8a"]},{"cluster_id":"3a1850b4-8745-4145-98c4-7563773130a2","members":["c83c4ddc-fbff-4e86-a3a7-8bb98c1ed0dc"]},{"cluster_id":"cb26f67e-804c-4c0f-8dea-81103afdf8ce","members":["42968904-9bcb-47d4-b553-a55c537e7274"]},{"cluster_id":"2aa6b6de-5e53-433f-9477-ca28d007cfea","members":["2b237886-7fdd-4732-816e-6bbff127142f"]},{"cluster_id":"d5a1e042-b187-41b4-a6ad-f1f271f98a66","members":["4f6449e5-4a91-414e-877d-b32f59ccf58e"]},{"cluster_id":"36dc7f3c-7522-4964-8e5f-96eb7e85aa98","members":["a92003c0-70e7-42b3-988f-d81e279bc03b"]},{"cluster_id":"b6807769-e83f-4f7f-b7a3-1a4b782749ea","members":["779e0434-97ae-4158-84a3-b4fca8cf3f08"]},{"cluster_id":"fa7c00de-2843-41e3-9b90-64fc233c087b","members":["2bee01d7-bd51-4db8-a7dc-a0a88773adad"]},{"cluster_id":"32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08","members":["f86973e2-e5e2-4a44-8d3b-b1ac27a7a363"]},{"cluster_id":"4c9bd8ca-0977-4844-9921-072e396e0fac","members":["90b22975-ed2b-4f69-8b5a-cd5cb7dcc199"]},{"cluster_id":"e46f2bcf-e185-4401-89f0-e7da4fcba567","members":["11f79298-b8f6-4408-85b4-786037d03770"]},{"cluster_id":"e64379e3-7714-4ce4-9ee9-585f6bf488c8","members":["f6e52c00-e977-4d1c-89dc-fdc5994145a0"]},{"cluster_id":"4a618a75-71e5-4836-8396-68e00d05b814","members":["3d86324e-cea3-467d-af95-8d4a16e21008"]},{"cluster_id":"55bf2e02-8b8e-4a6c-b132-fd70d3faa280","members":["a0dbb5ae-1757-4cce-a858-7b96b56b2be4"]},{"cluster_id":"39e17317-299b-4c70-bf27-b813fd6d3c5f","members":["1966df90-c4a2-4ffa-9b32-2006f7a4755b"]},{"cluster_id":"d46a8e73-11be-40a1-8437-95dcedae232c","members":["638c9182-29b4-482e-bcd1-514fdf6e8a35"]},{"cluster_id":"99cf328e-cb8c-4fbf-b5e7-b5b12080a8e0","members":["b5d6f9f2-ce51-4cef-9cfe-4437807d1546"]},{"cluster_id":"c754fcc4-5c32-4f8a-ac01-348838a5d407","members":["ce75fd3a-e456-4e22-abde-8e5ee4b3f330"]},{"cluster_id":"3fceb0c7-e424-40ef-bf39-fd06469e3042","members":["097111e8-9746-4413-8f32-bcc2a3892718"]},{"cluster_id":"f0a2a4b5-aeb4-45ae-835f-525f0fd65d67","members":["d625fbba-1849-4021-8450-2020a5c3339b"]},{"cluster_id":"83bfa8ce-e39f-4c0f-b6f0-a55302bf1e3d","members":["5570571f-ad91-4a14-a37c-c1f5c9bb4425"]},{"cluster_id":"8b267081-f50e-4410-bb56-f7281271aae7","members":["e8a88891-6162-4dfc-a372-3e1ee7789383"]},{"cluster_id":"6511d484-25a2-4b72-9c08-df0d1ad4f8b5","members":["360108f5-5936-45ab-9e49-a18ba6c9caba"]},{"cluster_id":"7bdd8e86-1a5c-4cda-a846-8ddfcadc8007","members":["a924f04b-a407-4779-9552-066202edb258"]},{"cluster_id":"e5a713cd-2a21-42c0-89a2-7795a4250823","members":["8f6c4504-6a6d-432b-8ce4-6eda6caf5127"]},{"cluster_id":"65e251ce-15b5-4f60-b87b-ef28a1709b53","members":["f74503b4-acdd-4cf7-bf1b-4191fcb103e6"]},{"cluster_id":"23c989ae-ea8a-4829-80ac-944f7f9327cf","members":["f11e8a14-8269-4f0f-8869-ec7f1fb098b9"]},{"cluster_id":"d488f4da-dea7-4960-b3a2-50c35254e3ba","members":["7aebbdb1-b25b-4005-9153-51782d457191"]},{"cluster_id":"cc9b53cb-83c0-4db5-a0d0-5708d4af2a1e","members":["1617ea47-79ab-48fc-888e-328bfca7bc67"]},{"cluster_id":"27391c49-b3b4-4f4d-98c5-cbe7a8ecbb05","members":["8884e3f5-3f6c-40fb-bfb1-4a0b57f4d2b4"]},{"cluster_id":"1b9bf573-9c3b-4f5c-a46b-1677c3204c31","members":["9373fba0-2e0d-4d7e-96d5-8bcf4917d4e8"]},{"cluster_id":"db2b5d72-303d-4743-8188-e92d23a86e05","members":["4f0d95da-c760-4882-b99e-b93c7996f4f7"]},{"cluster_id":"55c3e6f5-571c-4234-bde1-164fbe090fa3","members":["0f190e11-1033-4f4f-bbfa-8bc82e08c298"]},{"cluster_id":"f6ad38c8-1553-418f-93f5-4a6bb4909e2b","members":["c8b03c27-70ed-4cc4-abdf-0b332e2df9f5"]},{"cluster_id":"aae30a17-ea30-48f8-8399-1f3de025df70","members":["6c536418-00e2-4a4c-830f-f6f6d96e6212"]},{"cluster_id":"bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5","members":["109ca1ab-5d13-4ab6-aee4-4f2533791c9c"]},{"cluster_id":"2a09de37-e0d8-48a4-b6d1-8773f6d954be","members":["d2df8235-d61a-4ec7-bb0b-676cd6291b45"]},{"cluster_id":"8af38eb1-9c6b-4cd9-9f2c-55e927900928","members":["26a229b9-735a-4968-a540-4738197bdf77"]},{"cluster_id":"fbff695d-2102-476c-be9c-1ec2e2a34e99","members":["f8a77d22-871c-46b3-a5cf-dc89b4e6fcf4"]},{"cluster_id":"68c5326d-ab98-438e-abd1-0e7a9ca85a98","members":["8e47d9e5-3537-4b6d-bc47-83cbb5ffc751"]},{"cluster_id":"35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4","members":["25402d13-ecb6-491b-941f-43d94652249e"]},{"cluster_id":"029ce0da-0ea0-4431-a895-310ff5fa4a56","members":["45ad507c-58bc-4146-b0bc-1acde214aa1a"]},{"cluster_id":"54af5dc3-58d2-4d68-acb1-aa5f30ea62f0","members":["f29ae353-3af8-40de-a699-50235d37af51"]},{"cluster_id":"0640a339-12f8-4d3e-8416-49b84425cfca","members":["cbc5e26f-f8e9-410f-8029-a182c58e7f57"]},{"cluster_id":"00d7befc-64bd-4735-b672-5969c77fe7d6","members":["40bbd2b5-4d40-478f-a8e7-5b457a2b923c"]},{"cluster_id":"a28912c7-742b-4153-9606-e82158276aad","members":["ea8e2e5a-a9dd-4526-a2cd-4a0f2c009522"]},{"cluster_id":"5d815b32-3a62-41d7-bd5e-64e320d9507a","members":["26917ce6-9219-482f-a419-ecda95079e6b"]},{"cluster_id":"344f9518-32e9-438c-95bf-e7b75fd500b8","members":["5b6f1824-6080-47bb-9bd9-545f522d2563"]},{"cluster_id":"e157316b-b52b-4e59-beec-7a600ea2ef49","members":["abfc4d83-1cae-4bb8-9238-c8a5c9338043"]},{"cluster_id":"c0322634-7754-4f2b-b97d-7786687b4f39","members":["bd3f8693-6a70-457b-9472-051a0ee3123a"]},{"cluster_id":"3a723b11-9c69-4419-ba9d-ccab21e2fc24","members":["cc5c6626-cda2-4e18-b170-a6217c208baa"]},{"cluster_id":"4d35ec7a-3721-4f70-b323-8070302a4c95","members":["8b090eeb-8bde-48d8-9cb9-d49beac3a162"]},{"cluster_id":"e7ba1693-6646-480a-91d9-2e51aafb0261","members":["04a20f10-9af8-461e-9f75-106717eddda0"]},{"cluster_id":"82abb955-d502-4dd6-84e4-ff5a58485230","members":["1bfed961-5720-4356-b6f4-d95c98c664e8"]},{"cluster_id":"31aa44e4-52ff-4a6d-a593-c7d1153c5dc2","members":["e1bc5dee-6601-4bfc-b73b-ae86f55603ff"]},{"cluster_id":"02ce3ced-8a21-496b-a44b-583010f8f279","members":["ed264221-5900-4c3b-a69d-1d1e819dfa15"]},{"cluster_id":"fb0c78fb-f7a8-4921-9cdf-94739c1d1c3e","members":["8742072b-178d-4ccf-8e74-9e3c57ed6936"]},{"cluster_id":"69cf6d84-6886-4dc2-b36b-3239cc3450b1","members":["3a53f701-0555-4825-9fb9-8eb7b3e437ef"]},{"cluster_id":"1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e","members":["590263df-0e92-4dd7-990d-600412ace6e1"]},{"cluster_id":"9d847e57-5fc5-4cc4-8919-603e5c8d93d2","members":["e81f8871-f84e-4450-85d4-c8d87325236e"]},{"cluster_id":"ddc5dfbd-77e6-466c-a4ac-12178d35c42e","members":["a937e249-b4d6-4608-9a79-32283b312294"]},{"cluster_id":"e1b47a9d-415d-4c0a-a801-d747a6f31d9a","members":["dfe43826-3357-4dfb-9662-7b175bbad4fb"]},{"cluster_id":"073ce102-b579-45e6-8aa7-6f1ca6f82280","members":["13e1784f-2708-40cd-b623-00bac0d8e2e1"]},{"cluster_id":"e0017f41-b71f-4659-b94d-36fcb62cb736","members":["4ed31870-5df2-4a6f-ac03-b1ecbbd553d5"]},{"cluster_id":"8f6347b0-b76f-45e2-b8d8-b8a8c9dc9e26","members":["22c9b0d7-d0b4-4cf1-950b-75d5a717ae6e"]},{"cluster_id":"f083dfd3-1f0b-4469-b557-e14ab47deef4","members":["670ac9c1-bd3a-4135-8a85-df764f9ba9b6"]},{"cluster_id":"03d40e2c-2130-4e6f-94d8-afd7a1bdc223","members":["d80ca0d8-3306-445c-a9fe-e292f5a0f281"]},{"cluster_id":"637c1c25-6bd5-446b-89ea-dbb02add4b34","members":["621d1a29-309b-45ac-820e-e5b6c27b4f53"]},{"cluster_id":"1622ce6e-697e-479a-95ba-4bfbcc9fd2c4","members":["614de7a2-fe04-47d7-99a2-bd83572fe921"]},{"cluster_id":"ea0293f2-f4d0-4ae5-968c-0648ac0ad125","members":["1909b66d-439b-4cf2-9305-d96c12a1f137"]},{"cluster_id":"af0e1637-dbe6-45fb-a04a-6bc7ad84725f","members":["02748681-3f84-4280-a169-627e0e591319"]},{"cluster_id":"5bcb47eb-6ba9-4c85-9880-f3ab015417ea","members":["9a3741b7-9194-44e7-8593-dd9623d85773"]},{"cluster_id":"34cd8ac5-1cee-4a93-bb46-48f954524f09","members":["0600aa2c-a25e-46f1-9217-9073c7c4a8c2"]},{"cluster_id":"3b22f285-4b36-49a0-9e8d-cceb33235419","members":["dfa1261d-e732-4e6a-98fb-661c11837d82"]},{"cluster_id":"add377ce-a507-4594-9a7c-9c1c608ed972","members":["785426c5-8fb1-49d8-96d3-ca5cc2e642fb"]},{"cluster_id":"596b866e-0c38-462e-b0b0-eee502c092aa","members":["2bdc17db-1fc4-4641-83a8-1df42a5bc5f5"]},{"cluster_id":"595a5404-b726-44ba-919a-07c9e6bedb55","members":["d27443a0-c153-4dd5-a58f-873c1c8c288c"]},{"cluster_id":"0fae2f14-66ec-4594-b5a0-1588a0fa8339","members":["0e030dbe-883c-45fb-aeb4-a79d3e1efada"]},{"cluster_id":"ce9cb999-3c9f-480e-9d89-8702d1c44875","members":["5c4a33d0-ae11-4848-ab7f-92b7f6656e0e"]},{"cluster_id":"4e138416-b193-43f0-bd9a-8249fe6a1748","members":["dc91dcdc-d82f-4f28-9d6e-a9132909f1b2"]},{"cluster_id":"2d4166ac-3dc3-45f4-a803-c8d77cddc0db","members":["fd99e615-cd03-41e8-ba27-8d4905da0e07"]},{"cluster_id":"8eb3c499-d3ba-4d18-824d-8a2db9101923","members":["c373bead-d3a8-4bc7-a62f-cb894eb1cb73"]},{"cluster_id":"a208cf67-b0d4-4139-aecf-8fec75c13ae1","members":["fabedc29-2132-4d32-a570-e39a997b3674"]},{"cluster_id":"9ac8d542-8a25-4298-bb19-b93232c0319a","members":["e55109e1-cff9-4fb1-9079-03557de996f5"]},{"cluster_id":"eee2bcf1-74da-4f68-9a16-f7f155a012a3","members":["ce012d51-5eb4-4a33-978b-a45c1c33b648"]},{"cluster_id":"525ead27-9fb0-4fe0-aa10-52b70492601c","members":["2a3da052-2cc1-451a-ad49-b30e48ed2235"]},{"cluster_id":"367b0f1c-f101-4396-807a-065b17daa4e8","members":["beaa5346-30a8-4eec-8020-92b8e46b9061"]},{"cluster_id":"7fb1b61e-8a8c-43db-8218-8780b6b4a6d9","members":["e5df66d3-79dd-4a90-b930-61f103dd1f7c"]},{"cluster_id":"ed212b87-d906-4b97-806f-edc87a49ab9e","members":["58c36d61-3ba0-41e4-8f19-73255bc7b115"]},{"cluster_id":"27b6b422-e78d-44a0-8d01-c53970357062","members":["aa16c46d-0852-4634-a054-79960c11b758"]},{"cluster_id":"4dc97343-8657-4d38-b2b2-1129b6d10818","members":["4c1758ec-337d-4cbe-86fa-8244d71c7d7e"]},{"cluster_id":"c0713b5c-a570-4865-83c9-eb36c347abcf","members":["7c17e2ac-c892-4e72-866b-714bec4a49a2"]},{"cluster_id":"bac748cb-b035-4e91-bb5a-ab935807284d","members":["b18bf41c-46b5-457c-a9b4-f8ac07e36180"]},{"cluster_id":"61b4a043-a586-425e-a2f1-9e0b66e038e5","members":["29d4087d-19b7-4267-bf79-8789d90e480a","f9b65679-1631-449b-b807-d1fd4da4746a"]},{"cluster_id":"921fce8d-f4e2-4dbe-b940-66b148c09f17","members":["59013a8a-02c8-478e-9214-3f1e44cc7bb8","cb5848bb-bde4-4f81-a8d8-dac5555f3d7b"]},{"cluster_id":"fc3e8d2c-52bf-485a-a373-7853e3f353ec","members":["107d359d-42ec-4e77-8d57-506e01d2d46a"]},{"cluster_id":"a70c5cd3-da81-4d6c-8001-3956de0c9692","members":["0f501262-611a-4a6e-9a89-2f9d95963b85"]},{"cluster_id":"209b24c3-c157-4c8e-9d85-993e19c6b8bb","members":["d0f5121a-6a67-4dd9-b3f3-d97ff6bc7c84"]},{"cluster_id":"b6fed6af-5368-4204-a338-2997b148a384","members":["0fc29109-1260-4ee9-acd9-5213faa70a4f"]},{"cluster_id":"0368ead8-8d25-41a1-9249-88baff9335b0","members":["0210aeca-dbc0-42c3-8104-a3c02981d594","7b17fc30-706e-4de0-9711-467e629d4a85"]},{"cluster_id":"c6d927b7-cd5d-4d4f-8175-fa9bbd32a788","members":["84bdb65b-0a10-4d48-b2bb-f78fad599d25"]},{"cluster_id":"7b19db75-3bd2-47e5-a306-0a2f241eda0e","members":["96bab82b-1f4e-4ec3-85c9-55062690b2a1"]},{"cluster_id":"ae643b18-4610-445d-bb91-7a6e08099006","members":["e18fbea4-d7f2-4a5f-99f5-217aa876360e"]},{"cluster_id":"3712fc59-da49-45a4-ae5a-90b1831dcece","members":["345b3179-253e-469f-89aa-87e71b1ea471"]},{"cluster_id":"3f6ce9ce-e151-4a9d-92cd-88c52ef40373","members":["07b997fc-953c-401c-920f-f2dc1d0271e3"]},{"cluster_id":"9f2f375c-af55-44d4-8d17-dfc761b029ac","members":["b9810a46-1616-44e1-9b2b-e9684548ec05"]},{"cluster_id":"0d5b0cde-5145-4f38-a41d-e29b3956da5e","members":["f2e7cf6a-6482-4f9b-a2c8-98e89811400c"]},{"cluster_id":"c4336836-69fe-4478-ae05-a9b8308b5fd7","members":["cbac83c2-8c95-46bd-a630-356ea7d83495"]},{"cluster_id":"8985495d-c23b-4b4d-8af8-d412abf8767b","members":["f2812f10-9f02-449c-be8a-d14b8f7f31b0","b8d26489-766b-476e-9288-afe066be5436","2b6a71aa-4472-4e68-99df-a6a0eaf88087"]},{"cluster_id":"ab98fd27-202d-413c-8332-5c4cfa41f02e","members":["1e3a38df-684e-48e2-a62e-3b767bade3aa"]},{"cluster_id":"3b5c9589-43fb-428f-a24d-ff67c6ec3e67","members":["bd09c03f-ffcf-424d-b8b2-a9067f24572f","59b4c0a6-0bf0-4b4e-ac15-bfba72030ec6"]},{"cluster_id":"9b2ccd60-9fd2-4e0d-8e91-bb564023a0ec","members":["9ea7be29-7ac0-4db4-a44a-77f7e1b4a49d"]},{"cluster_id":"9c0a11fb-cf7e-4f2f-b318-57e8160591d2","members":["0b66de36-7adf-46d0-b0d8-a3e6ddacc929"]},{"cluster_id":"a6e5fc0b-7c5e-4adc-9bd8-8c5b7afb7918","members":["75f3a1a3-be94-48ab-a200-75e258aa57cb"]},{"cluster_id":"0c515019-d4d8-4fdc-91ce-bd3ef7e8e081","members":["bc2852f1-4c0d-4924-a3e8-de82d6d55f58"]},{"cluster_id":"c178db65-d340-471f-b632-8b8dad1a5b51","members":["a5c174fb-00f8-4888-bff2-2b22c08b6bb2"]},{"cluster_id":"b40d77a1-3074-4669-a3a8-f64b6de7cd03","members":["1ab30c76-9d70-45bb-a0c9-9ba89ab29490"]},{"cluster_id":"0c73bba4-2142-4833-ab2a-f7dd03c24dac","members":["6d3e772d-df2c-41fc-95f9-6ee4c1785af0"]},{"cluster_id":"793d367c-aa36-4def-8927-25ed78dc0d58","members":["0b394128-bfde-44cf-9e64-cb31e8b2af0d"]},{"cluster_id":"24f4b8ea-3738-41ba-bfa8-f9286f4d2dc5","members":["eb90c2b0-f999-48b8-a156-260fc24dc989"]},{"cluster_id":"1e2e215d-02f8-41f2-bb72-8bb5cf8991d4","members":["b93daa23-81e7-456d-94d1-02ee6cb323d7"]},{"cluster_id":"13d74323-84c7-4461-a516-d07ee1ee8c43","members":["b275260a-c1dc-4478-979c-ce4b9174a3ee"]},{"cluster_id":"d2f70202-2b46-45a9-9905-a0ccfee90661","members":["93c43d4a-fd19-4e65-988b-70a133b08499","f8a12006-8d34-44eb-913e-a0e4597ccf85"]},{"cluster_id":"31c69d86-6651-4ebe-ab2e-087bf7193e24","members":["66aeb4da-a41f-4447-b443-d3adc2c80766"]},{"cluster_id":"669c3dae-6d04-400f-a1f0-a3b10120d902","members":["2c93e391-b1d7-4f0f-b9a7-0f1628f74cb9"]},{"cluster_id":"f97c3788-df6a-4dd4-b544-6d0397d5953e","members":["140e89c6-1a07-409a-ab9a-52ec6b34998a"]},{"cluster_id":"ea56561a-6c42-424b-a439-8949e0922884","members":["318a1f17-6477-4696-9106-44c6cafb8309","10f7556d-46ff-442b-824c-344e5364e305"]},{"cluster_id":"fff91b42-2999-4568-8b58-028bf8ca7046","members":["ddfa596f-da0f-4830-a839-c04542e52164"]},{"cluster_id":"16220929-8aa1-45e6-9f5e-8401f7ed50de","members":["34d32d01-b9da-4558-aca2-018ef1620429"]},{"cluster_id":"edae4987-7374-49c7-bd0c-6f6522213435","members":["a6c3e47d-8078-4640-ae31-397e6e88ebd5","5c6f0588-995c-4d20-a836-02ac80210bf5","a8ae2e4b-0ae8-47a0-8895-855189d37016"]},{"cluster_id":"6eae9125-d91f-4554-8584-e619f1d7940e","members":["865c7c98-d8e0-4383-b0a6-ccf0a86c51e9"]},{"cluster_id":"06d90458-c93e-4ddc-a393-97e8e0d06f91","members":["17ca6691-ccb7-40b4-b9a6-7145b0127e0f"]},{"cluster_id":"08a5fea6-9542-4505-b3ba-04e342c44cbf","members":["d8ca6006-36e6-45ea-8307-1deb0c49b00d"]},{"cluster_id":"2fc3625d-65ed-4d3b-9894-40d3d2d23ece","members":["d815205f-8cc2-4afb-aa3c-c0e6d70f107a"]},{"cluster_id":"8dafb957-e3d4-421d-a897-aa9e9def3c15","members":["78221e24-b79b-43e4-a541-ad1ca0076618"]},{"cluster_id":"f1b5b82d-47e0-49c5-b861-5e41e68dc753","members":["0d304d53-0699-4bac-bf54-d0c96ac245cb"]},{"cluster_id":"e493e014-2ee0-4066-9764-e3019f7467b2","members":["4abe3741-e47a-4a37-bca4-d5f10b6ed2cb"]},{"cluster_id":"7234c7f2-ec56-436a-abe4-d72c2e651247","members":["5b97d9af-c5cd-4efc-9502-6bf1fabde9d7"]},{"cluster_id":"31416837-c17d-49fc-a841-b231a9f41ff6","members":["853c041e-9df3-4b29-a61e-74c8772e02d6"]},{"cluster_id":"d494f4b2-e7a8-444d-9de4-a124202cacaf","members":["ac495448-6773-45ff-afe1-a285915c6f3f"]},{"cluster_id":"2f8e7728-120e-46dc-8103-038ff1bcf8a0","members":["f23f41f3-49f6-4043-a4d4-56791c2a1d06","92768a75-9f7f-4ab9-8595-46aa79de7699"]},{"cluster_id":"9d6d3278-c0e4-4003-a311-bf3945445bf7","members":["984b86ec-b655-469a-9772-7d7780484415"]},{"cluster_id":"5b750f94-6101-4383-bd0d-c980ad3ff8c2","members":["725c1c14-9fcd-4f5c-95e1-9590c9ef59d7"]},{"cluster_id":"7e9c2165-775e-4ecd-9551-bc96f366f674","members":["cf29b817-5617-4b44-aa05-a0df376f7442"]},{"cluster_id":"479e911e-126f-4188-8866-356ae46aef5b","members":["dcfb1112-c28a-4939-9d66-40a5f9e67ec2"]},{"cluster_id":"0ebcd390-0474-4d90-81dc-d03c9dac78e4","members":["9232d564-a2b3-4587-a80d-ae2a5dc0f7ec","a3431b87-2276-445d-8261-ac070ad38875"]},{"cluster_id":"ba39c004-53dc-4528-9f07-025d10ba4bfc","members":["60f2f09a-e48e-4b26-a07a-ce54f4efb8be"]},{"cluster_id":"80a198cc-8757-4f4b-9e5f-ba483e92361e","members":["ceb0101b-f929-4ecd-b350-8037db80fcf6"]},{"cluster_id":"13c0f70a-404a-4747-9850-32c93df93caa","members":["dc455af0-4a77-4516-95aa-318963561a03"]},{"cluster_id":"174ff9ad-6286-41da-ad67-0696f7875e1b","members":["6fa349ee-fdaf-4995-9580-28548d92c92a"]},{"cluster_id":"0dbd4f26-ef42-4c5e-a16b-4529c5e0d566","members":["4067786c-a9a9-4504-ae37-8f00d85fa380"]},{"cluster_id":"138ee12c-cc52-4ab9-bc9d-3ad91e9008d8","members":["cf7e4df3-4d73-45a5-a65a-42d1a2a5caf3"]},{"cluster_id":"325144ea-ecb8-45ca-8169-6bfec35e02d6","members":["5c549537-68db-436e-b803-7f7040d989fb"]},{"cluster_id":"dd63046f-83c4-4d5e-867a-2f14376d2ce2","members":["e75a2f44-5442-4d31-b8fe-35119a74d3c6"]},{"cluster_id":"c570bea5-83d0-40f8-b228-3cf401722ac2","members":["cf0e1b85-b67a-4948-92f4-77b2300f4602"]},{"cluster_id":"dd0a9eb8-6da6-4108-8f70-358d100bdfcb","members":["8756e902-2bbc-4510-8db0-127a384594ef"]},{"cluster_id":"991ffbe8-307f-44da-878c-ba99ad7d9638","members":["9867fa2f-2d7f-4fe9-819f-6b125733fd08"]},{"cluster_id":"6ce879b9-5872-4b84-9034-d22bedf950a0","members":["1ba67de0-3a50-4fd0-8935-215e201931da"]},{"cluster_id":"b995b076-2b5f-4341-abf4-0732ccee4318","members":["ae54faf8-0a6a-4db8-b437-7710c0bce29c"]},{"cluster_id":"1352067a-0981-4dfc-bf7b-193db2160af5","members":["d71b1d68-136b-401e-9be7-e317457e7d72"]},{"cluster_id":"ebc26e14-b86c-4a50-a196-d8cbcc8aab8c","members":["7296af18-7182-4ad9-8e86-af7045ab2218"]},{"cluster_id":"d1102194-5143-42ba-aac4-2f29e4d13736","members":["18a11fb1-e4fe-4210-932f-b340cea2b154"]},{"cluster_id":"da696f76-5f89-4c8f-bcd4-42e52baed665","members":["bffa392d-838c-48bc-ab7d-e67e0f896155"]},{"cluster_id":"be927411-ac53-461c-bb59-5232d4963861","members":["58c4f36a-d1e0-4676-a897-c83e02e84a19"]},{"cluster_id":"14266895-ce35-4bb7-b24c-c5684c3a1532","members":["9186ed71-5a4c-44b5-8c29-b644072d50f3"]},{"cluster_id":"3d43abac-8178-4ce6-a910-10e135a5266f","members":["139677d6-2d70-4fca-9c76-d69fae62656b"]},{"cluster_id":"4f0e7f6a-d847-4db7-a78d-684ba6b33ce7","members":["e70794c7-1f61-4fa1-a956-d58bf8a67c02"]},{"cluster_id":"2f7d7b19-3996-4824-8b2e-60b30c5d543d","members":["5e1c916f-f839-4e2c-a1ac-1876dcaa95a0"]},{"cluster_id":"6ff6589f-46b8-4e3d-bfc9-65288f58e33b","members":["900a8533-a169-4295-9576-1e08839a4aaf"]},{"cluster_id":"530c303c-a794-4be5-bbc2-ff618ab75d38","members":["a9161d70-4ab9-4fae-b953-1445e2713d7a"]},{"cluster_id":"65fcd3e0-1f44-416d-b2cc-adb2b3a6c31b","members":["5749d3e4-6c81-44c4-8809-9f9327c7ebab"]},{"cluster_id":"18a83b13-1adf-4e6a-9783-cc45f9fd9c79","members":["7af08beb-2910-4d2e-b488-0b5b72ab8c52"]},{"cluster_id":"3feb2513-5eb4-45bb-8249-92697ca5ccbf","members":["6006ac32-7f50-414e-8a5f-bce4e8739ce9"]},{"cluster_id":"46dc68c8-60bf-4c63-8f62-da2eefecf05e","members":["6b180a9c-1f42-41b4-9631-3cb6b8085d98"]},{"cluster_id":"69365007-aabc-4f8e-a4e7-3ac92aef1b47","members":["d14997d7-7c3d-4360-85e9-3ab9ca2bdbc7","1c7fbe04-ec94-48b6-9c05-105d999c6553"]},{"cluster_id":"975e2d06-2cf2-4b51-9705-f9ba57cf3e1e","members":["4218b537-7ace-44d1-98d2-9405a2047fff"]},{"cluster_id":"4da675eb-3ccd-4c4a-852a-837897424712","members":["e948ea83-3f58-40b5-94af-f58552982c89"]},{"cluster_id":"e285d3b2-02ce-4dd4-ad86-ac99b2199a66","members":["eea6c4f9-4a35-4400-95ee-9ab50ec658a1"]},{"cluster_id":"b95f4f5f-4d51-43a4-8c27-5ed3609dc286","members":["b766d337-3425-459a-a20b-64921b60ee7a"]},{"cluster_id":"5e59f3a9-c776-4791-b6c4-d58d75f185a7","members":["4417eab2-d162-47a3-868d-6d0e56e56239"]},{"cluster_id":"9f9c5798-7130-4fb5-8328-ae0dad688f2e","members":["9b61ce15-d372-433d-8b4c-cb23419b4c82"]},{"cluster_id":"a808e761-ea60-4cbe-9954-1bbb279e628e","members":["95e7740e-7f3f-4e83-84d3-9e1c8c0b03f9"]},{"cluster_id":"86f9f906-a751-49c5-9fab-90ea9e810607","members":["aec06af5-63df-4aed-bd46-53ed07ff420c"]},{"cluster_id":"9162951c-ce7d-463b-9880-335cc6cb0f80","members":["cf59c68b-1168-4108-9634-206a5f6873bd"]},{"cluster_id":"40cf4646-a4df-4be7-91e4-7dd54f7d4c16","members":["384f6de1-57e4-4ee2-93d3-3eff97c7f3f9"]},{"cluster_id":"f6d37781-75af-4b37-a9b4-49dbc27efba1","members":["12a6796a-b0a7-4fa4-8f6f-5a6b53db5c76"]},{"cluster_id":"1a4ac437-0820-43b9-93ff-945d37e52289","members":["cafe9cf0-f603-4413-982b-454c48421ca9"]},{"cluster_id":"7688d917-39a4-49c8-8503-8ffed77c6807","members":["de2e5971-af07-4798-bbf8-9f1a15702d82"]},{"cluster_id":"c9c64be3-e960-4772-bfe7-2c746234f3c3","members":["c5cf44c4-4233-448f-b586-0f50146cc0b6"]},{"cluster_id":"50df15a2-0759-4dd5-ad88-d8f125de1938","members":["de2a44e6-f54b-4173-9d05-f8ca1c562304"]},{"cluster_id":"1e3fd423-7c99-4849-95a3-92cb0dc03a82","members":["3c509fdc-1d85-4f81-affd-1aa97f89c3ea"]},{"cluster_id":"1b1dc316-6caa-4e05-8920-919dfeb09b67","members":["eeda5ffb-dc48-4a5f-b7a3-ef006537a7b1"]},{"cluster_id":"22c9858e-9aba-4253-8fc8-8d1d83a938f3","members":["8566fd4c-45b9-46eb-845c-f0bd362c0aec"]},{"cluster_id":"b29164d7-a1d8-4a41-a952-b0d04cde6fa1","members":["2c0baa6b-7f4f-4feb-b924-7b97eabe182e"]},{"cluster_id":"079ea0ae-5460-44fd-be95-17fec28e2122","members":["eb40bccd-ad4a-432b-9caf-b95812c43721"]},{"cluster_id":"924eda57-f860-4947-b8f8-b55352cbd0d8","members":["9ee8d736-3deb-4c91-b996-707bfa71c95e"]},{"cluster_id":"14a0f558-9894-4d04-9b27-d9a6b3531c2c","members":["a8467897-9ea8-42cb-9988-97b34c32c24a"]},{"cluster_id":"5d2a23b8-6ca9-4894-b0bc-a3b5c15dbf42","members":["f73b0473-d7fe-4c01-b046-e854e955a1b6"]},{"cluster_id":"bc727b98-bf68-42be-b2de-84ffed053ccd","members":["fd69e6d0-bc5a-4945-a092-e49c89bdef11"]},{"cluster_id":"ead9bd7e-2c4b-46c5-b951-360707780eb3","members":["a40d51bc-33fe-45bb-beb4-197580111591"]},{"cluster_id":"56102e40-6707-4ea5-b706-a21ac4c3fa0a","members":["1f571773-a119-4b69-bb0f-e9dd9f0458f9"]},{"cluster_id":"df289945-6d20-4db8-b12c-27190f4319e3","members":["3fb25a3c-74db-43ca-a199-f3b679d401e5"]},{"cluster_id":"3195f0c6-475f-480b-9f8a-4aa8231b8b3c","members":["ba0128c9-056c-431b-acd4-0e45d9a2602a"]},{"cluster_id":"700f4caf-4655-44d6-adcf-68f6a654752b","members":["8335a29a-9177-4886-8913-7e0ec1819ab9"]},{"cluster_id":"73900380-dcd7-40a9-bff7-af4dd25e907d","members":["4dbd090d-99e8-4241-892a-8f82bc069b3c","e8cef964-44ce-4e1c-9aa6-22f1e4bceecc"]},{"cluster_id":"dd335f66-9180-429a-8e21-b0e59da84aa2","members":["3cac4f82-dbc7-44f7-8ddf-b9626b06553b"]},{"cluster_id":"9b14b6b9-92d5-4da7-813f-eb820b5a4071","members":["ef40cf5a-0ee6-4558-aade-5a61b53b4651"]},{"cluster_id":"ad25bdfe-5d0f-4c75-8f1b-cb123f11cb06","members":["542cf79a-84c2-4e1e-b5f4-5192d3aae3af"]},{"cluster_id":"c1018981-9883-4b7e-8f5e-7f4837994e54","members":["adae471a-5fe3-404e-82bd-033d9d35bc19"]},{"cluster_id":"063191cf-9936-4d33-8783-201496475d0e","members":["acb3e29c-8b9b-4d65-84d9-b6150af17e1b"]},{"cluster_id":"33378b17-6e0e-486d-a122-a219ecc02e56","members":["bed08933-be98-4d9a-9300-806b428a35e5"]},{"cluster_id":"2032d3f2-f2a7-4cd8-9f0f-0fb6fbfe2fc9","members":["3c3516c5-011e-4b47-9eb8-cafee3504cda"]},{"cluster_id":"09a252ec-4d97-4380-a535-1e7222c476ea","members":["6380b9a7-b8f7-49c7-867a-0b0529f09f20"]},{"cluster_id":"402b3ff3-63dd-42e9-9d2c-888f81934ca4","members":["f3a9bff8-828a-4118-889c-5006a1d45963"]},{"cluster_id":"cd51f6af-e3ac-4df3-b356-fdbeb2599d37","members":["8994ae42-a469-4d04-aef2-9892dfece0ec"]},{"cluster_id":"59ac47e6-50e9-4884-a676-2542dc8e0aa3","members":["ff68c6bc-a3d8-4051-aaf4-2e4949c54c42"]},{"cluster_id":"389db9cc-996b-4a34-8f9a-361c5c8aa5ee","members":["3672d7e9-03cd-4914-8bea-500a7184d930"]},{"cluster_id":"e450bc0b-1319-494c-b418-fa5dced99fad","members":["d8e1da89-224c-4a1c-931c-46d998d07095"]},{"cluster_id":"c183c1f7-56d7-457d-9d98-1df02c7330bd","members":["b9ebc8be-5976-45fe-96ca-c44cec68333f"]},{"cluster_id":"ffccc68c-8962-496e-be7a-e09d954b9f4e","members":["523bb635-cdad-48be-a47f-38f6e33d4588"]},{"cluster_id":"2d61e1a4-f82f-42d3-8440-ae35b51fa374","members":["458966e5-0956-4973-b03b-c5cc3028417f"]},{"cluster_id":"88b53ede-d736-4ed2-9eb5-d53fe706d4c1","members":["d05082ca-4118-4750-9e59-3caabb1f72b0"]},{"cluster_id":"909f6739-4757-4400-a81c-4fdb3bbaad77","members":["9b5d28dd-276e-4d6a-af5a-69614fe5b6fc"]},{"cluster_id":"6bd1a1b9-8c5b-4543-9007-11872574ea9a","members":["5d7cb6c6-c732-43bb-9df3-aada3e38d660"]},{"cluster_id":"91533351-01ef-434b-b8d2-ca94698271b1","members":["27cfb698-04cd-4ab9-ac6d-56207c48fec7"]},{"cluster_id":"72297da3-3cc9-4cb4-a16b-56592581749c","members":["ac90fed3-bc85-4e29-a5e3-e3852870bd1b"]},{"cluster_id":"6a38e03b-c385-4edf-9cff-c8c006c566e3","members":["66a43457-3d8b-4300-b113-987ff3935451"]},{"cluster_id":"a9a48f40-5af3-4e72-b9f7-5b25295964a4","members":["13db7249-b755-4f82-b994-bace920bf919"]},{"cluster_id":"683abff9-679b-4270-b05d-4394a56a60b4","members":["7cb30f02-ea7e-483a-ac7c-9449553c6bed"]},{"cluster_id":"33c3bbfc-4975-4a68-9abe-5dd608b4ec62","members":["d3077dd1-f47d-4350-9a4d-dd1b33e2a59d"]},{"cluster_id":"2ed0e84f-d233-4164-b228-6208473d317d","members":["2e2d89d2-803a-44e2-8a92-a2628ae2454d","2a5f7b1f-2bcb-48ea-84c8-82d1106b3c3f","94e0f17e-33bc-4bef-98af-b586a683708d"]},{"cluster_id":"0c8a0c77-de1d-4094-93a5-9ea4a0ec06b4","members":["8b6dbb3c-a32a-4feb-a3e0-41e11f84d8fa"]},{"cluster_id":"4c1d018f-90d0-4f64-b7e5-c3877ba4474a","members":["fde782d9-9fd7-487c-adf4-3e4592d9493b"]},{"cluster_id":"a04779f3-83fb-4f0a-a9f8-fc91c7dd0fc4","members":["8dd64eac-5d24-4388-aebb-09184a58300f"]},{"cluster_id":"0005306c-9f05-4c24-afc9-11ea1bc90d4d","members":["f34149ca-790e-498e-85fd-747e2561dc0c"]},{"cluster_id":"81c0ca50-4b77-426d-ae3a-c52b1a992539","members":["f8d87d4c-c6fd-4540-89e1-a95b51cdd11a"]},{"cluster_id":"4fa8e557-bb3e-4afa-89cd-33ec7b315e73","members":["305e3a42-a8f7-4384-8727-a8b2837b3ee7"]},{"cluster_id":"d19dc1b6-21b1-49bc-aaf1-fb24f7c66396","members":["097db6ca-eb11-44c5-adf8-a71db915c3f8"]},{"cluster_id":"825bdd3b-f63b-4beb-b324-b276b6d235f7","members":["058195ec-069f-4af7-a0fc-c241d129f928"]},{"cluster_id":"3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5","members":["56942172-4f15-41ef-b903-cb1459c846d2"]},{"cluster_id":"df416ca2-a7ac-4dad-9783-c3e29d3f4084","members":["42c7e95a-5884-4619-99f5-e3ff70fa2154"]},{"cluster_id":"9dafd873-19fe-4111-b162-3c6894ed8aa4","members":["c207827d-9d99-4f9b-888f-f91c5a2ea551"]},{"cluster_id":"55dd7d4d-d0df-496a-b949-1f305611420e","members":["5fdbeaa7-2027-4559-bbea-f5f3db8a3408"]},{"cluster_id":"9179b891-9dc1-45be-ab4c-6b2e9fbc156a","members":["d7d4d4a8-0021-4af4-aa40-a7aecde69956"]},{"cluster_id":"ff420a7c-e6cc-45a2-bf06-8ce6ac712e7b","members":["276c9734-ff08-4830-8f40-0007568e0ee6"]},{"cluster_id":"f7e1186b-2980-41a7-bab5-cf7ae1ee1caf","members":["92dbb386-e617-4d97-9c27-c509b8ae9d5a"]},{"cluster_id":"f48f090b-b925-4ff6-946c-dfbb77137193","members":["efdd41cf-9be8-405d-8dbc-e5c76227a9dd"]},{"cluster_id":"9e24e052-7c2e-4232-a3f6-f90915a205eb","members":["c71fbc94-fa99-4abb-a66c-e2701d9c67ea"]},{"cluster_id":"590d0c11-1909-4486-98ca-6247b1d6bae0","members":["b894c62e-7e2a-4f49-b93c-8c019edb1b6c"]},{"cluster_id":"59906f79-e6e8-4390-a382-ef5bd2f7fff2","members":["0b0162cb-a1c8-49a5-841a-98214bc000d3"]},{"cluster_id":"c84778ea-ef3a-409f-9105-f5f4a9c3f19d","members":["b8be2070-d07b-4283-86e3-1b49f50d697c"]},{"cluster_id":"adb13810-0226-4fb2-9c77-e2af38089b83","members":["b6d91b71-04fd-4967-9a42-d4e4348dd2b7"]},{"cluster_id":"4a8a1810-6ec2-40d6-8159-dfec11d084c9","members":["0f703776-b87a-4ba4-887e-cf1e9cef8a8a"]},{"cluster_id":"a4d467e0-6666-461c-8177-8b0173dc05e3","members":["e6965eb2-6707-4743-bba9-e2f55128db0c"]},{"cluster_id":"4dd4cfc3-9e42-4844-9174-8c971ece9bc4","members":["48e9783a-c3e4-4fbf-9741-8c5b30bd9098"]},{"cluster_id":"9e87fb61-486a-4192-90bf-f05ee1b73406","members":["e5cfd380-706b-4af4-b638-56533d6cb180"]},{"cluster_id":"c974a5fd-a8a2-42a7-88dd-b3f3e7fd1ad6","members":["67275948-5c00-497f-bff2-9ded64b9afd0"]},{"cluster_id":"d7761b4c-72e0-44cd-b341-d16d8d7d63d7","members":["1fc2906a-4c9a-4530-ada6-424bf52e2b3e"]},{"cluster_id":"4941b2f5-904f-4963-b690-18f3bf3075c7","members":["bc846d24-6358-4f50-9da0-6f37026b1164"]},{"cluster_id":"d7adae26-7c5e-4cae-86db-8ddd899b1a73","members":["5d55214d-c331-4e56-ac03-0c5544cd5118"]},{"cluster_id":"0500f877-c2d0-4c97-b0d7-76dc88e38eae","members":["28a28ac4-d5b4-4d98-8f7e-c8c3bee9802d"]},{"cluster_id":"e6a8f39a-ea50-45d0-aa2c-f24fddc8d1e3","members":["159a1577-f120-44d3-acd4-9256546ba197"]},{"cluster_id":"59c32196-c345-4e2c-9ab5-46cd4d040be1","members":["3208a2e6-8017-4011-9caf-ae4d6d4eda38"]},{"cluster_id":"2c68a882-a903-4629-aeb4-3d0034f94771","members":["7d282275-0ef0-4981-aaae-07a25a4cc2d7"]},{"cluster_id":"06f36d72-4a36-4a11-89bc-28713f0d3ba2","members":["1063213e-2698-40c3-8381-4586e469f8f3"]},{"cluster_id":"07ffad90-34a3-4066-8c33-1761dfb6597a","members":["3682026f-f1f4-4c55-9007-6b73fb162e88"]},{"cluster_id":"73478ef3-3b02-4aa4-bc0d-55174048efc5","members":["9a92b1c5-d64b-4a8f-bff3-9d8cda00b308"]},{"cluster_id":"414a7988-da74-41bb-927b-725b66698cd7","members":["8cc23ae4-e70f-4570-bf83-5c2302b65dea"]},{"cluster_id":"f5a99e33-6c8e-438b-9a1b-7d2b95dadd27","members":["d651504e-7fd0-400c-a45a-bc201d982e7f"]},{"cluster_id":"3a46ccfd-5379-4ef0-aa09-8a1b6a5f409e","members":["c1d3a62d-f31c-41f0-861d-08cae4ea448b"]},{"cluster_id":"0a9d0582-fd67-429b-b378-1ed79f7e66aa","members":["3b1c36c8-803b-475c-8fe3-1f57b4d5f437"]},{"cluster_id":"0817085e-1f3f-40ef-a848-4b066c225ffe","members":["ca9e16c0-b200-44cc-b1bc-b776e3da81ce"]},{"cluster_id":"46c103db-5ea3-4b23-91e9-342a8a2c0506","members":["03572d67-6c26-44ca-8afd-20dc0ac1ed0b"]},{"cluster_id":"0313a78d-59e1-4fe7-8d40-5db79d99214e","members":["079bb245-d14a-4c7a-805a-0fe7162f6abd","70dffb54-a419-4552-ba31-79e7a21bdabd"]},{"cluster_id":"f4bded1f-3dd1-4137-af03-3dc33133634e","members":["e0c9f39d-5831-45a1-830b-2a67218024c1"]},{"cluster_id":"9555579e-0753-4a7b-be6a-da884e2c8547","members":["6b3ae583-1ea9-4b3a-b5bf-f35462415eff"]},{"cluster_id":"5326cc13-3625-47b1-ad75-82ef998d0dce","members":["ef160d98-8f47-4fc5-8cad-1903cedc1f3b"]},{"cluster_id":"58cd02fb-21db-4abe-ae72-bb8a28bb5670","members":["0dc7ae0a-7caf-4637-9106-b9ac247f37cc"]},{"cluster_id":"6d2a3a04-ff69-40ca-9d0c-a4d79e8318bd","members":["6f5ed3cd-536e-4444-9e06-51eccbcf6a6f"]},{"cluster_id":"80b5a69e-5f2f-4b54-a7e5-680323a8c096","members":["3409a217-a4f3-4f60-9101-52c1f87b9ab1"]},{"cluster_id":"4c6fd3f2-5818-45f3-b8d8-85a9b9075f57","members":["ab4a0b17-1983-4011-8f28-2e73ed350490"]},{"cluster_id":"e828a029-7aa6-4aae-b53b-df9804b3b858","members":["dc40a4e2-8449-44e5-b295-6541d540d7e9"]},{"cluster_id":"32697b9c-6810-416a-bedc-25a1c14600c3","members":["a396cbb1-fb21-4080-86c7-b19d02400f19"]},{"cluster_id":"1754af66-54e2-4f11-bdb1-7f116f325d12","members":["4cfee40f-c632-4d7e-adf7-57b73b8f2ee7"]},{"cluster_id":"8649324d-646d-4eb1-97c6-070697056cd2","members":["dcd5db79-1f5c-47b9-8191-7ed0df646471"]},{"cluster_id":"162d37ea-ce13-4d19-9a98-bb0e66720cc0","members":["1c66cc00-9fd5-477e-932c-30917929823a"]},{"cluster_id":"776ed0c0-bfbb-420d-8369-ebf0e4544c64","members":["53564956-1238-4060-98a5-a257a368982d"]},{"cluster_id":"f78fd02c-7e3c-43a4-8429-a28909b13242","members":["a16e1903-461c-4506-8861-3d7902f86cd2"]},{"cluster_id":"544fb937-88d2-4ddb-9c06-1ae58af8be2b","members":["3c19d2a4-f513-41a5-8faa-2464e56c7bd9"]},{"cluster_id":"2c6352c1-d120-47aa-8825-a58359bc7c7c","members":["a088dd02-6770-44a6-8d0e-c8ad5aec1597"]},{"cluster_id":"6d9d5966-6987-45bd-9e4b-02623878d470","members":["5ec788d5-61e0-4e9b-a95e-da9cde6d8fc1"]},{"cluster_id":"e0696dc9-5406-4bfa-a327-9114afed84e2","members":["bf8bb868-6a19-4b48-b3e3-e2d83c57bffd"]},{"cluster_id":"e9cee2c7-a58e-4a2b-a37b-7da09539aea3","members":["28386613-34b5-4c1f-94d2-f879ca76a462"]},{"cluster_id":"2fd5c32c-ec83-4d86-8836-741ba8422357","members":["e286a468-eebe-49e0-abe3-e91ef6536342"]},{"cluster_id":"82af2059-79b6-4403-9b30-9a9e111cc571","members":["47a5bdde-eae2-4055-96f5-64228b6afaeb"]},{"cluster_id":"18ce2062-068b-4c99-b15d-32e24b28817f","members":["3d1d9264-6372-4f7e-abba-8dff2736e471"]},{"cluster_id":"3a6ab8c1-b7af-4dae-9216-d55e6233e2d8","members":["c7fa7154-662d-458e-ad6e-b0f0bf4c0382"]},{"cluster_id":"4941aadf-8564-4b71-b807-8b98a3bc3396","members":["e92defb1-ef29-4c1a-904d-6e35d992e54f"]},{"cluster_id":"465bda3c-33ed-4e06-86ec-cc6c1d50e27d","members":["f9388985-6c3f-4aed-8bb1-2e0663b530b9"]},{"cluster_id":"f551f1f0-32f5-4ff3-b5c9-5aab61bb1bd6","members":["8b3e60bf-ee95-4e09-942b-5d4da7895641"]},{"cluster_id":"81215e4f-490f-4619-8a72-2aa513e8e164","members":["ae583b19-b213-4b87-a650-af51e14d5d28"]},{"cluster_id":"afd1f695-ea2e-42a9-8e8b-7c38a970fbb5","members":["98b4c645-ec3a-4052-8ecb-1f2e0cff86b0"]},{"cluster_id":"05b40a90-169b-48f1-8cb1-f86fad4e6b0a","members":["99c384ac-d12e-412c-af0e-a29f870224a1"]},{"cluster_id":"f5d2e5c5-6f09-4885-98b8-5062202897a8","members":["a768319a-bc88-4540-a568-c888c470e333"]},{"cluster_id":"1c4b6f2a-a55c-4baa-b0e5-6516b517f960","members":["188e2634-02b5-48cf-8416-b730583f7c01"]},{"cluster_id":"0d1a4169-975f-49a7-9f31-390c351eb65a","members":["3d0cc3f9-607e-40c1-8d36-d6bc0ce97f45"]},{"cluster_id":"bb078c76-36ef-4176-a9f6-192717c4f2b4","members":["571e1cc8-8607-4611-b359-a9e35e278bfe"]},{"cluster_id":"690dcbae-7356-41d9-9b3d-b2f6f77db887","members":["630c80c4-861f-415c-8316-30394a1d4966"]},{"cluster_id":"77fd60bb-096a-4b70-a630-b56ef3e8f647","members":["65f035a9-60f3-4966-bc30-bed468dc3092"]},{"cluster_id":"06ac8474-a3e8-472b-abca-69bac9927b06","members":["36e1b8f2-7b42-403e-b626-9551d4fbc24b"]},{"cluster_id":"40265b93-5ea0-4bd6-8b7d-972baab54b70","members":["21fceb45-0ee5-4715-845a-c3e404724968"]},{"cluster_id":"6e8c4432-d4c6-4fcd-9e26-cf2164b211ae","members":["e77ad024-62fa-46e0-96aa-65e8904c4383"]},{"cluster_id":"fc4f3449-d301-4936-a35f-47ca68ad88dd","members":["c322107b-bbb2-44b7-aa46-c909b4d958d6"]},{"cluster_id":"593f987b-f53c-49a9-a836-d17fb210c211","members":["d61751b1-ac99-48f8-84e8-8fba7b252705"]},{"cluster_id":"8a312b2a-4e43-4814-85a4-51669e80ab52","members":["42a254be-8c82-46d6-948b-254dba5466d9"]},{"cluster_id":"91289460-848a-4396-988d-42e28ce5078b","members":["7af65c91-6dfe-40e8-9056-5c636f903528"]},{"cluster_id":"8bd4a872-0209-415e-a7b8-b4acaf26a95b","members":["9093e625-8ae4-4f6d-9b7d-8b396f3411e7"]},{"cluster_id":"2aafed04-d3d3-4ae0-9825-6d6db215ea71","members":["374372cf-f681-4fc2-851d-a23fd9e14b8f"]},{"cluster_id":"758b1960-78c3-42a0-8a1a-c0d1f47c547d","members":["0943c6ee-1b22-4a07-ae1f-fa4e9067bf92"]},{"cluster_id":"920bd1eb-f625-4f7e-981d-fa931240bd9e","members":["d79ae8d2-9a53-4da3-a523-3505d8ef4e2a"]},{"cluster_id":"9d7867d5-5ab5-4b0e-9556-f3f45feb0160","members":["9f261b7b-2319-4085-ab37-11078a70c433"]},{"cluster_id":"709632d6-c88d-494b-82c2-d5300f49d1cc","members":["90d2e97e-b523-4e6d-a6e6-06d952d0048d"]},{"cluster_id":"19fb932a-d5d7-4981-804f-5245e467f600","members":["3866bad7-b613-459d-b4e2-3a798895640b"]},{"cluster_id":"678b3718-1825-40ce-8b76-3f1e30facae7","members":["4a88d88f-26b0-40d4-b289-cf860b95d0de"]},{"cluster_id":"84787050-e169-47c8-98ae-7a849294a5a9","members":["b70369d8-27de-44c0-8c2d-d4f9015ecfbe"]},{"cluster_id":"9f3b49b5-fd07-4adf-8183-7615100c8917","members":["186364e0-0496-4137-aedd-08a93acb45c7"]},{"cluster_id":"d5742cb8-e264-4816-b45a-8b7710ea66b3","members":["ce4bfadc-7156-4acb-ad54-dba35724c1fc"]},{"cluster_id":"91ce6b29-5884-4f1a-9443-ad0d26809886","members":["eaa30024-a42c-44dd-8614-b5fecfe93db1"]},{"cluster_id":"3dba838d-2eca-4f65-941b-d8fa64a15014","members":["6c975d06-5e6f-4180-a27f-af1e4cd6b6d1"]},{"cluster_id":"43cf9cfc-c9db-41b9-a566-9bec2d970db4","members":["4aaf367c-9686-43bc-82d2-29f6a2799c9c"]},{"cluster_id":"ec4ecacf-5ed7-4202-a803-a46089704d53","members":["9b2dabb6-5ae1-499d-8ced-0becc13dd579"]},{"cluster_id":"c4564515-d53f-4e98-999a-f38427deb89e","members":["30bf2f64-e771-4949-8980-3b6ec5555aab"]},{"cluster_id":"d2b6a98f-1634-4f3b-a41d-9b64375eff6e","members":["6b51683f-1256-42bd-8b6a-91a6a7fa057f"]},{"cluster_id":"a2a4403f-1592-434f-a0f9-d248d1684f8d","members":["96c47ff2-e6b2-49e7-91b4-36c9da5cede1"]},{"cluster_id":"8d9c34af-fae3-4e38-87d1-1e67774753aa","members":["7f084599-1623-4d42-bf4b-4b862f5e8972"]},{"cluster_id":"fcfd6d39-3e11-43c7-ac1f-026d265beb4f","members":["5c4d273b-9230-4adf-b8f0-b49827a4ec76"]},{"cluster_id":"94df14e2-7e46-450f-90de-ca92085eab78","members":["2b9f56ec-523f-4414-b969-1659e9a4f74d"]},{"cluster_id":"dc7ff2aa-1921-42d9-9518-a57c8197d5cd","members":["84caced5-1f11-4f30-85b3-e9cc1fb2b5f9"]},{"cluster_id":"79a31826-be43-4bb3-80ca-3a1482a7949f","members":["a8b1f4ae-bb24-4d01-985a-3ed5e9af9c13"]},{"cluster_id":"efd1564d-df50-445a-a638-9947d0e8404e","members":["8603a105-6ea7-414b-a010-6065851a6046"]},{"cluster_id":"afd94974-8e6c-4eb8-a657-4ac5f64e9000","members":["9259f1ee-50e3-4e3a-810f-97d1deab67df"]},{"cluster_id":"abe48ef5-28d3-473b-b5c1-22f7c985121d","members":["2c6eb48c-219d-4624-a524-61374499a6c2"]},{"cluster_id":"015ba6d4-e890-401b-9586-28896557504b","members":["4708fe1a-0f60-44da-9a08-02e513afa594"]},{"cluster_id":"2a9b1bd4-3cd7-481b-8cb7-5d5856650a4b","members":["4a823ed6-c42d-4cf4-9326-15b6ae845cd6"]},{"cluster_id":"b98b439c-bc5f-48c4-9882-c02eb0d9e36c","members":["f1c193fc-6404-49a5-bbbf-d866acb13365"]},{"cluster_id":"c20e1db7-e918-4c20-9b2a-23168ba5d1b5","members":["042ef20a-73df-4a71-abe5-0760038aad5b"]},{"cluster_id":"e77e1981-0ac9-43e4-bf55-8efb11926415","members":["81600820-95e9-4a12-901d-caaec68e738e"]},{"cluster_id":"0534bd48-c558-48f7-8bed-cd770b8d24ee","members":["01c6a101-e7a1-490e-89be-3cdfa97902a8"]},{"cluster_id":"707d96d6-8c9c-44bd-a592-b72a5c0a0e76","members":["7c80c12a-d7df-4343-8b4b-2bb750a57e89"]},{"cluster_id":"3449416a-5af1-418f-857a-770f02267ee7","members":["ad38848b-442e-4629-88b4-3c66a4f9beef"]},{"cluster_id":"829b9804-a574-4cfb-bb97-448e3e369540","members":["a272c121-a877-4718-8464-1bd5a96ce2b9"]},{"cluster_id":"40ab9766-1c85-4b8a-bb1d-2effee6c9d18","members":["8381663b-0d95-4b43-910e-511a5204c318"]},{"cluster_id":"3a1c15cf-9c77-4bd8-9e70-266829c039f2","members":["297d1ba2-974f-43a0-b62a-ba723ea87519"]},{"cluster_id":"1bfa372d-748e-4dfa-a2d8-05a78385d36f","members":["d24c3b2a-6927-4d4f-8c94-e11959f856bc"]},{"cluster_id":"4ce3dea7-0e2a-40e4-9e4a-2c61943d61e2","members":["102df67c-d144-4e2a-ae35-34d15662a08b"]},{"cluster_id":"f8ebc28b-35f4-46bd-95af-d6b109203645","members":["f49591dc-a252-46d5-9c5b-8cdddafe669b"]},{"cluster_id":"760f2c37-f953-4230-a4d7-e4bda98fc033","members":["8aad2ff8-5dab-4507-aaa0-4b93cf9bd890"]},{"cluster_id":"ccd75d9c-f680-4c7d-a6c6-f684f0c4b09f","members":["402383f6-7e8e-4fe5-98d1-2f49ecc8992b"]},{"cluster_id":"632ca25c-c259-4da1-adb8-67921865876c","members":["654b1932-6580-4646-99d2-5e498312d281"]},{"cluster_id":"323f50ac-8539-481b-b9dd-0528780df63d","members":["cf239229-aa46-44db-8fce-721d466fcdf9"]},{"cluster_id":"c768dbef-cff9-45a6-9583-58c568197a94","members":["46029ac4-9931-4eb9-a261-618a19919178"]},{"cluster_id":"53d09843-b0b4-4b4a-974f-76bfc4243e0c","members":["edef2453-14fd-47f1-87fe-2e982fe3cd5e"]},{"cluster_id":"8a726a08-8358-4b34-876f-420532834600","members":["15cbd724-371f-49a4-a658-a30558418d7d"]},{"cluster_id":"6acfc858-1016-4e78-a1e1-7d809680381e","members":["cd18e4e1-b254-4b25-812f-84266b128a47"]},{"cluster_id":"3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae","members":["66c5719f-412b-4670-af81-4531155c53ee"]},{"cluster_id":"1b1d9a06-de42-4de4-8ba5-73d34f084424","members":["147db351-5f97-4654-b8d4-bcee7ef4a9c5"]},{"cluster_id":"f1490876-f9ef-4974-a23e-79abce4ea951","members":["24f64892-fea8-41c8-be4a-4d4252def5c3"]},{"cluster_id":"df1455dc-0c9e-4e83-b885-6c9b28b69dbc","members":["89096621-ccff-490a-834b-b5c0636df3a7","f50a5420-3ac2-4800-aa10-086f3b074789"]},{"cluster_id":"3f26edd9-fb3e-47fd-a185-0a5f3a6ec746","members":["09cba8b1-bb6e-4bfd-8101-83de3c034186"]},{"cluster_id":"816b9948-b1f0-46c8-b6a3-18e652cd3289","members":["06a4bfe7-f036-450e-ad63-0e9898e7d636","1b6c2507-9795-4fb5-bccb-74065585080c"]},{"cluster_id":"9f713e34-d77c-4dee-b4cc-dc4204b450f3","members":["137a6f5e-f49b-41b5-bf2c-02f074fe9c84"]},{"cluster_id":"3ac894a5-bf0c-462e-b5eb-494aa29af425","members":["be2bced6-c4a5-48ad-8ede-83c8491b1c74"]},{"cluster_id":"ff2acca4-5f30-4167-8a23-b96f532a3929","members":["e4d4d79d-b10f-4d08-a363-500fae00fb83"]},{"cluster_id":"e539011c-4c48-4afd-9e8f-3e4ca7d332fe","members":["4490b780-f23f-4479-9e7d-54bdc8c5521d"]},{"cluster_id":"7645928f-b607-4113-a8d9-4afacf4bc042","members":["80dfeeb7-ac38-42b1-b1ea-fa79408aa30e"]},{"cluster_id":"3c7a34af-192b-4878-baca-1d31c499b7da","members":["8adca138-48cf-4cec-8ee7-f3b21d0c6e8b"]},{"cluster_id":"38e4e6a9-dd51-45eb-8aed-8f44b62fdfe6","members":["8ad63261-9f3a-4a04-b6b0-8538bec06f31"]},{"cluster_id":"2962a54a-b1d0-48df-9318-1e0f945ac7d0","members":["aa124032-a0ad-44b6-8e8f-2e7e273ef0eb"]},{"cluster_id":"1be22971-e6b7-4f57-b7f5-9c6d0cc3afbb","members":["9bb4a6f5-b8ce-4b2e-aabb-3bb74868c8bd"]},{"cluster_id":"30f5c3ba-9f54-4691-8863-1e644c87fbf8","members":["a65d0fc8-2448-4a5d-924a-b04069b6fc51"]},{"cluster_id":"5de51773-6a23-4bab-8c30-a41d42c69aaf","members":["ea47cd6c-8c9d-45fd-90d1-ba14cea5fec8"]},{"cluster_id":"cc163006-eb32-4037-8b14-d4cea8207017","members":["a5c5b65b-1f44-4639-982c-5025cf54c182"]},{"cluster_id":"b2b76ff9-4063-44de-a3e0-0b0a58a3a46a","members":["302e2cc2-3c88-4d37-b183-ae8e562b26dd"]},{"cluster_id":"1e5faa7b-e696-49d7-be88-e86b8468f738","members":["af2c3128-fc8e-4faf-8982-9ba6b27e0e80"]},{"cluster_id":"76455b31-1fcc-4337-adc1-b2686dd2563d","members":["cec36efa-53e2-4ab2-b41e-6b9e8bb2509a"]},{"cluster_id":"6f4705cb-b438-4a8d-84e2-59fd3445f3af","members":["d851bb9b-c1dd-4b50-b86d-d7e0a70fcc71"]},{"cluster_id":"8f6bdb99-b1de-47a0-840e-33678f79a92b","members":["2ce479fd-0786-42c1-ac4d-082e5c7da9a9"]},{"cluster_id":"d811e7ed-7bb2-4a03-a5a1-75a044ab14eb","members":["dd0a5af4-8344-4b4c-a3db-f0654ea0fbe2"]},{"cluster_id":"02ef40eb-a1c1-4bb1-9831-77fc91e127be","members":["9d9755e7-2d6b-471e-9d6e-6602173c5e12"]},{"cluster_id":"640f326d-efe1-4293-bfc4-0c4c7b9185f3","members":["92f6dcbf-31fe-4a96-a55d-1a6bc36d8c2b","1f783ba8-cb50-4762-b602-1e7f5ee916d5"]},{"cluster_id":"3d2e56c3-c257-4788-ac2d-72890e521046","members":["55516b8d-0683-4117-ad3c-ec5487d82730"]},{"cluster_id":"edbf2785-2875-4f94-8c61-364dee3abf1f","members":["c2401e50-09b0-40a7-9572-7e712e2d271a"]},{"cluster_id":"d13901ad-61f1-4fb1-ba52-f79a1d3671b7","members":["8ec85d90-fc7b-4af1-9c84-98cf7584c0b7"]},{"cluster_id":"0a78e568-4aaf-4a3c-a4c0-d484ec60f776","members":["9b70c841-3399-48a6-9656-f80396fdc314"]},{"cluster_id":"fc29eab9-06ef-4c87-8c16-ab4eb87c1683","members":["5caeed35-980a-4cdc-8f83-12122d6ac3b7"]},{"cluster_id":"e130a374-b2e7-4d68-8a8e-32dcab17656b","members":["3758d0d9-bc1d-4755-a92a-34b2b5b49878","682d7d53-1e3b-4d7c-ae9a-5c149108e4f9"]},{"cluster_id":"acf3ef41-5374-4f21-834c-c4a11d955ee1","members":["edbe9a31-3a33-4d14-87f3-befeab22bef0","80cc3156-fe40-44e1-a335-8776a3897352"]},{"cluster_id":"1f91813e-722c-47f3-81f9-6d98fd8c6b7d","members":["31852110-628f-48e8-a05c-31ccee743dce"]},{"cluster_id":"a1ea139e-e9aa-4250-ae2b-ff5069df6f63","members":["ecd54e83-ea75-438a-a38a-78890ca0d766"]},{"cluster_id":"5f674ba0-ccc9-4a42-8c81-55a71cb30d68","members":["7cf42c5e-169f-4ebe-ab61-f1a10e95149f"]},{"cluster_id":"2ef3ee94-6c9d-429b-95e7-08b756215251","members":["ce9d23e1-d0d6-401c-8f9e-9ade8ee9bfad"]},{"cluster_id":"532bc570-7cab-4e65-8d14-b6e22f9fc1d9","members":["7c090bae-4199-4bf7-9604-5c65660aff00"]},{"cluster_id":"e9e815cd-7183-4b06-a964-9cfc2d25bfab","members":["04806cd9-9b90-4ae0-af5f-b60428f4ac1a"]},{"cluster_id":"b5c5d896-8437-4aaa-ae03-95c8865a2ac0","members":["d0771d19-f756-4cd3-9786-9fde6fbf2023"]},{"cluster_id":"129ac9af-1e7f-4d17-aba1-4c71a6061174","members":["0778b390-a2ee-4d01-98c9-cb1a9bde1902"]},{"cluster_id":"325bf549-47cd-452f-95f4-f8b56d9739b0","members":["35c1e621-4969-4e5c-9003-b0583ca8939c"]},{"cluster_id":"d41f0247-c996-4fca-bb9a-db10717ce822","members":["e9be2f07-0ef3-4c7e-aa68-19ae2471474c"]},{"cluster_id":"3304ef73-a023-4ec9-bf07-27f713496a6e","members":["8e3d1db2-3b77-4d35-9896-79ee893fef39"]},{"cluster_id":"48b40da6-72cb-45c4-8c2b-8924870132bb","members":["b423ba88-db77-4c34-a7a6-f53445b95467"]},{"cluster_id":"6e17469d-ab2f-4f85-99c5-d4389227a162","members":["32e32477-4bb8-4504-a027-27fc77d8c334"]},{"cluster_id":"ce22089b-598c-40ef-ab32-85ce5e1f2d4f","members":["ccafa14f-33e2-4e2f-844e-8fca6079b32a"]},{"cluster_id":"a2fa0436-7d09-4549-9e78-5e411d846fe6","members":["dbd04912-2116-4721-be14-a71801cd3c32"]},{"cluster_id":"3050de99-7b86-4c4e-a101-b10c8a674e17","members":["69b95343-c252-4a88-8e33-88c27080b854"]},{"cluster_id":"53c8b8a1-19e0-48b3-8c8f-f90de56c4785","members":["08c4a7d8-a808-40c5-b31a-7003fa42378b"]},{"cluster_id":"1ac6b5e1-dffe-48e8-ab2a-c58a20b3c8dd","members":["aa7d3860-9a7b-4b71-9e39-2d706c63a28e"]},{"cluster_id":"54276cd3-4620-48dd-898d-2aae66e353c4","members":["c4b94532-7a76-4ebc-a460-d01465b113e2"]},{"cluster_id":"0bbfb864-d9fa-40cd-982d-22d96033b7a3","members":["12a88459-c669-4b94-9645-9be73587f944"]},{"cluster_id":"6f086810-1930-4192-ad91-ce3f0eefd1aa","members":["e860db1a-8641-4f76-a140-b16a9d94307d"]},{"cluster_id":"6e4dcb8c-7c71-4fa3-82ef-3a917a168bdb","members":["5a8463b3-4d4f-4daf-b7b8-dd573ad540c6"]},{"cluster_id":"39e358aa-4f67-47f5-a3b2-dea997ca44d0","members":["6db38e74-24f3-4a2f-ae3a-8d02b9d72dd8"]},{"cluster_id":"f067ac83-ba02-48cb-bb4d-1822eee31ec2","members":["603921ad-e52a-4410-99ec-8fd86d16e5c2"]},{"cluster_id":"67de48d7-3fc7-4d88-97a8-9350772b5bc5","members":["cd5c2b41-5c7f-4a55-9ab2-88fc3ef91c4c"]},{"cluster_id":"a4d91f10-cd48-4917-90ab-b14ea36168d9","members":["9579faa0-0177-45b7-9056-8029d8924320"]},{"cluster_id":"b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f","members":["95e05178-60f7-4cbe-bd9b-5bf961bdef01"]},{"cluster_id":"5f8dbb60-ef34-416a-9285-ed818708d337","members":["a2bb928e-2e84-4e3e-81ee-b83ba79b568d"]},{"cluster_id":"7e081e03-60f5-4239-923e-30df23ea9e14","members":["748a15bf-517c-467d-b641-dc29fcee8d35"]},{"cluster_id":"94834f96-c25c-4f04-80b8-c75b05787e8f","members":["e1847ff0-930b-42fd-a04c-2eb5f02fd7e0"]},{"cluster_id":"f0d97c3a-c630-45ac-8106-3c433d45bb57","members":["735a9667-6b3e-4e28-89bd-78eefd76f362"]},{"cluster_id":"b98bf259-2428-4cda-a309-5be4fdb0c3ef","members":["7731cec2-7cdd-4637-a82a-9e0a7fc3523b"]},{"cluster_id":"c4fe585b-23d9-4a10-a6b1-a3c43c70fda5","members":["31ee3b51-269e-4dfc-8198-05a6d28587ab"]},{"cluster_id":"341ca13e-66ab-4ded-b14a-e2210febdc82","members":["c8625782-7e9f-43f8-9213-eb09f5957d9c"]},{"cluster_id":"c6804538-62b8-4db5-a60b-8ce1803df0aa","members":["657382bb-d2cb-4305-9efb-21db8233240c"]},{"cluster_id":"4cdfe663-949e-4463-904d-7ad58162fcfa","members":["f3f664b5-f1c9-46f1-acd1-599ecafc9a9f"]},{"cluster_id":"f5c9b8a2-ba8a-4c9d-96f7-5fdcef771d06","members":["12b17193-4706-4f24-ad55-383db3074772"]},{"cluster_id":"0a3f5bd0-94f4-48e7-84b4-d317e0edec75","members":["1ca2ef26-0ed5-4d56-850e-a636b6eff698"]},{"cluster_id":"46a652d6-7e4e-45bf-93da-8368a900beab","members":["e81e7d4f-67c0-48fd-a9d7-8ff407f9d70b"]},{"cluster_id":"e5b92c5d-257a-4d84-a804-3e2462bb2954","members":["d3a08662-4d96-4236-96ba-063d7de46717"]},{"cluster_id":"1782182b-9c5f-4a6f-b547-bd10fc2d3b84","members":["d745da97-1080-4d18-a214-49591427f1cc"]},{"cluster_id":"556da1e6-535a-4511-ac9b-649cb3eafe84","members":["87e1ed4d-7fb1-495b-8e0a-a85a0d6596a2"]},{"cluster_id":"d169380d-3c63-4800-8f8c-5deedf749ffe","members":["a1029f55-fc1f-462b-a001-b99c9358ee2e"]},{"cluster_id":"a8476578-a217-4709-ac69-6e4d18f25dc6","members":["55d5c23f-5205-4f18-b5d6-5fd8b9299c4b"]},{"cluster_id":"d789b1ed-51e0-4f7f-953e-3eaabc59ca49","members":["cb74013e-54c4-4e79-ad4f-9c3287eb0ec8"]},{"cluster_id":"3da59556-c8b1-408c-95c7-5d8130035b46","members":["18a6c232-9e9e-4d2e-bb6f-4c32c1876c91"]},{"cluster_id":"6f5e39d0-2941-42e5-be3f-779525a745b7","members":["24afa0a8-4d76-40ce-9afa-3bf870a96fce"]},{"cluster_id":"f8a7db64-2922-40e3-9fc7-9a7934487f7f","members":["7caa6b44-edda-4b37-8343-03733cfae459"]},{"cluster_id":"3e66d569-f8f4-40ce-8d13-9d469cc2e340","members":["48103b8c-b7b1-4459-b902-e8dd3da7e54d"]},{"cluster_id":"f3668774-884d-4b84-a93b-1c5ea3e64309","members":["f9fb6469-9308-42c3-b83c-a05198123ffe"]},{"cluster_id":"70d7ea19-ed43-41ec-a695-147f9057dd3c","members":["9e531e8e-237f-4247-b459-eae80fadd5e9","2ba2eda7-5496-4127-833f-7dd6a93199da"]},{"cluster_id":"e12f223e-9c33-4c5f-9e5c-badae44a41f7","members":["a54a02cb-64db-4c71-b0e0-1adb45b0c3c3"]},{"cluster_id":"07969927-bc1e-48a3-8b9c-29bb62214363","members":["69ee9d16-acbf-4105-8a4e-7742e50c76c9"]},{"cluster_id":"416a789f-b094-4d93-9898-3707b0bf84ed","members":["d80a8c53-92e9-4ff9-a558-32a8b1313d4a"]},{"cluster_id":"c74eddc6-9017-4628-9942-40823cd7e30e","members":["43f29fae-8a37-48a2-ac30-5cdadd238303","b15fb8e1-637f-40e7-8eb1-707011750283"]},{"cluster_id":"09202e6f-2182-42ac-8af6-6622f1cfeb68","members":["e6edeb03-0ca9-422f-b5fa-4244d92faf5d"]},{"cluster_id":"96b17898-9707-4c42-8d78-5b035c3e7377","members":["4006480a-753c-45ce-aa6b-ecf3456a9b65"]},{"cluster_id":"96226cbe-6ce7-473a-a2c5-bcfa1fa15be9","members":["a38e8719-88d5-46ef-90f4-a32993b6cfdc"]},{"cluster_id":"05310a2e-9cf9-4ebe-9d39-aca58b7ee406","members":["8a50c084-5b2c-4fdb-ad04-e211a34541ee"]},{"cluster_id":"836422b4-fd08-4384-b536-467195ee18cb","members":["34cb44d4-ecd2-467c-9936-4a6b286b6edb"]},{"cluster_id":"6eb6f4d9-183a-4612-a4f7-dd59bbc26512","members":["3f46d12f-b64f-4d48-87e1-1c65835f7681"]},{"cluster_id":"50647687-d65a-47e2-b9a1-a4bddf5f53cc","members":["ac8bf186-9f81-4e86-bcf8-9581ca6de9ba"]},{"cluster_id":"2d87e550-62a5-4ab5-8323-4c18213fedcd","members":["e2cc15df-04af-44fd-bb34-b2ad74cc09fe"]},{"cluster_id":"1843ffaa-26d8-4da2-944c-1a88ec1c3413","members":["5f00f9bc-f04d-4326-9b92-b94a44d73a3d"]},{"cluster_id":"c2fb9cb0-a6ae-4469-84e3-3b523125b6df","members":["8f89cdbd-4592-4ad5-a926-7e091ad7e6ba"]},{"cluster_id":"9c99fda8-d219-4855-bf41-fafffb61b05a","members":["b96c12ae-9f4e-466b-ae2d-8134b211c5aa"]},{"cluster_id":"b29c3ed7-bdfb-48eb-87a7-3e6d5f2cf585","members":["4a1aec55-354a-4dcf-909d-a6903b8a9660"]},{"cluster_id":"6e8f5bec-2ba5-40f0-a873-4607c411beb7","members":["11bae64a-bdb5-4f1c-ad4d-c94f6ca02f82"]},{"cluster_id":"9a2fe341-e356-4c2f-afb2-12f391a85d04","members":["b2b1a5d6-a348-471b-9c4e-fe7b3293beac"]},{"cluster_id":"41c6f905-1ba5-4740-a4f5-bc35586af666","members":["a92b3d5e-f95e-4a99-a370-4c0147a5b7ca"]},{"cluster_id":"d8ef4018-d9a3-42e2-a7c5-aef1d93ff0d6","members":["a7cedfd2-fd1a-4ef5-97d2-795081566985"]},{"cluster_id":"f98db0f7-3865-4f81-b4c0-e009394ed065","members":["1c7b73b0-2310-446c-8277-54767060f75d"]},{"cluster_id":"ffb636ec-7472-41b4-ad69-f529b66bd46e","members":["0acef6c0-1f2d-4dcc-9a90-e29b93793897"]},{"cluster_id":"8e38f27f-adac-4956-8ff8-f509c611ee94","members":["bc8de606-d518-472e-8e59-39337287205d"]},{"cluster_id":"1a1ebb66-c1bd-4b57-a87b-865e10a35768","members":["8207856c-0cb1-442f-97f6-17f538dd9ff6"]},{"cluster_id":"60679d50-135f-43b4-962e-903dca327357","members":["8ffdfd68-1b2a-4e92-9ff4-e3e811d91c70"]},{"cluster_id":"928155fe-b009-4dae-a22f-c56106f4b853","members":["17401565-66ca-437e-b0a6-136ef3724107"]},{"cluster_id":"aa05692d-a142-425a-b2a4-b94b0045a440","members":["82a4cb5a-2b30-4906-9627-1c8593ce8dc7"]},{"cluster_id":"c0987cb3-5451-4fcf-a732-5bfbe94a56c9","members":["f5ad2cce-9961-444b-8007-5874a232d25a"]},{"cluster_id":"d013c87c-7dd2-4021-97c9-a4069e2ad7f2","members":["19352e34-aca6-4dbd-a538-04e985ad70d7"]},{"cluster_id":"fa5edee7-14cd-46f2-b781-a5794e463daa","members":["9a14913e-e877-4406-8c04-9675beb0ae54"]},{"cluster_id":"6ea5c303-0018-42cb-9161-d7d2a76673ac","members":["69643293-59b1-4d82-b831-0d3d5c86ed29"]},{"cluster_id":"bf5c16e4-64dc-4dad-a15b-31db258dc134","members":["b96a6933-b915-4bf3-8058-724297dab033"]},{"cluster_id":"a18cfe43-57c6-4582-9892-e05c06ecdee6","members":["90b494bf-039b-4e54-a6f1-4c80e755714b"]},{"cluster_id":"d4e2bc2e-5c21-4fa6-b48d-9b09603ae727","members":["b060cf25-4818-4962-a079-b0943a233663"]},{"cluster_id":"117f6cc5-ef88-4d83-9dfc-20f8e5fc488c","members":["bd33352a-5503-4615-89fc-28d9a8fc5de9"]},{"cluster_id":"b32b2c04-03a9-4e04-93d0-499cf1aa4cc2","members":["5f06c143-7e85-43b4-bfd8-a9cc5030c2e9"]},{"cluster_id":"7311a9b7-5d04-45ee-bfba-1bec0d5a0eda","members":["4cbccbd9-75d6-4806-85d6-6e3f1ac612b0"]},{"cluster_id":"2c20a8ae-1d47-4c90-a5e4-88e406d3334f","members":["1b110999-77b0-4a7f-986f-a8f1d4d159cd"]},{"cluster_id":"a5cfe32e-2f16-4644-a4e9-767621b4c4a7","members":["97bcabff-36fe-4906-a8f1-49e45a2230c0"]},{"cluster_id":"89448e79-f7ef-4836-aa0c-f4044c4e1e16","members":["6be5c24a-fd13-42a4-aef3-2c7811909f68"]},{"cluster_id":"0ecf145f-a19c-4bc9-bccf-6b5ec58579be","members":["6d97834d-047e-469c-966f-03494c01663a"]},{"cluster_id":"ee80f2ab-f1d2-4dfc-bb99-e00e767727e3","members":["bcd00958-f1de-40a1-b1c1-5dbcc6a4a0f4"]},{"cluster_id":"ab894abd-2889-40e1-91c4-3fbdf2be7626","members":["bf9263f8-2d55-4044-ab20-d275b56ab5b9"]},{"cluster_id":"27eeb806-4cb4-4391-b4c7-c7f87a7b6cc2","members":["39cddfdc-f4fe-4d95-890f-6f9b9e217019"]},{"cluster_id":"3cf933e5-8422-4f09-a822-8ef8b6385700","members":["995d8ddb-e382-4194-8310-0522f57d393b"]},{"cluster_id":"2fb5602e-e1ec-4e01-ab46-f8e35a0df948","members":["364ac148-30c9-4ecf-92fa-825712d7a416"]},{"cluster_id":"f2217761-bf63-4a79-b438-adbd2534e4d4","members":["b9bad6ff-5e99-4b92-a9dc-1e6badc97e55"]},{"cluster_id":"2b2067b5-dfbb-4340-b88b-e5f769120fc0","members":["3dca0899-074f-4e9e-b91c-a9ca7458895b"]},{"cluster_id":"55b3fec7-2c59-48a7-b144-2bc454de6078","members":["52a54493-a1f3-4f4c-a7d2-80b44206c556"]},{"cluster_id":"621f1c2a-981d-47da-bf43-de2d73f4a594","members":["d29718e5-79a9-4622-b7d2-f27b220d6d99"]},{"cluster_id":"d94f565d-7abc-403c-b060-eaad0916c690","members":["54363c74-3a5e-4a0e-a8b7-87b7a9ff59a3"]},{"cluster_id":"338b82e5-bda1-47c8-a375-1c6600743697","members":["d9355a2b-e19e-408d-9457-938ec41f605d"]},{"cluster_id":"6e905ee5-7953-41bc-bbb1-d9109f51ccff","members":["386e3406-a1dd-4833-be25-35db72e451dc"]},{"cluster_id":"24b0b407-5974-4623-9570-6a7574f03b45","members":["524949dd-fb0e-4480-b88d-7595fb098a45"]},{"cluster_id":"959de586-d5e2-49e4-92ad-27165bbe0cb1","members":["8af73905-0721-418e-a51c-4db9d4d3e8a8"]},{"cluster_id":"1a5017d7-a85f-401a-9c3e-9a087de588f6","members":["415ec586-96fb-46fc-9faa-eaecc243e78e"]},{"cluster_id":"5d455dbc-1091-4f62-8c3e-fdf2d7c2080e","members":["fcb12daf-7d52-4c56-b04d-e9777de122bf"]},{"cluster_id":"592ed206-56a1-4eac-9ef2-85b6be103dc1","members":["385cdb80-f2c1-4e7b-87b1-c21abaad8d71"]},{"cluster_id":"776ff44d-f39f-4f47-8ef5-a991b2a74ced","members":["a82d71b0-e478-478a-86f2-1e56e05e450f"]},{"cluster_id":"61f48759-d4cb-40cb-8dc9-13b564dd8c1b","members":["276f71ec-ec4b-4616-a67f-383f7d4c239c"]},{"cluster_id":"04b259ed-8fea-44d2-9f92-3e357be663b0","members":["55c5716f-2754-4c82-a473-893c45e6a6a7"]},{"cluster_id":"4dd58e9c-790c-4f52-9fba-7f267f15da6d","members":["143587d4-ddc3-4475-9b44-e3d87618bc18"]},{"cluster_id":"d191d96a-6233-4306-907d-1beabb6fc9c7","members":["cf2d3a88-17b8-4c10-8916-393a69b12b04"]},{"cluster_id":"f45f3567-6577-44bd-b711-4eefb24f7df6","members":["cf5b4e71-5bd7-4fab-8dba-5b8915af2a53"]},{"cluster_id":"546a15bc-833d-4e92-8945-cbee19b7d4ca","members":["45f128ba-256c-4b24-a061-347799ffdf5a"]},{"cluster_id":"9b965f11-f5af-4e06-af27-db2a333f5008","members":["fee2129d-d97d-4fb2-9d74-9637bdb59a06"]},{"cluster_id":"04c31a7d-6c2e-4822-91ce-feccb61d28bf","members":["e47653a8-b66a-4155-8f1d-5ee1ceff6d91"]},{"cluster_id":"cb2e6a9c-ffbe-4a9d-a4eb-32e21489b61a","members":["5cbb827c-948e-49c9-8dd5-d0a3c9f52987"]},{"cluster_id":"fd3d778c-3ff6-495b-bf3c-b5711ab1a974","members":["7d9cd478-80c2-4f33-9da9-39dedaddc105"]},{"cluster_id":"22edb9f0-7d37-46a0-a499-0bf470746f3e","members":["00c6dc3b-e013-49d3-8cd8-6fc3710d5264"]},{"cluster_id":"ec7f8d90-641e-4755-b398-833e150c7057","members":["05fac443-cceb-4ff9-82d6-297f6bd746a5"]},{"cluster_id":"776c4ee1-eeec-4f70-91d9-12fdaa179052","members":["905ede65-2bde-4cde-a2cc-51e69c4841a3"]},{"cluster_id":"49e33122-7ceb-4265-b315-038b5cf4ba76","members":["aa7c39a7-b7ed-4147-af04-ffa29e0276fc"]},{"cluster_id":"adde58fd-6daf-4b35-b4c1-a6e18d15a403","members":["30d3dcb3-51fd-4a00-b9eb-4fdee73e7b1f"]},{"cluster_id":"a6f8ca4a-31cf-437f-a2eb-06ee3b0285bd","members":["75372dd7-921d-4010-b871-f744e8212413"]},{"cluster_id":"2ca6b1f5-ce3d-4e72-98a8-f750a42081ac","members":["07e01120-bfaf-4cc6-aeb4-cbf712f42a74"]},{"cluster_id":"777a09d6-6401-47e3-a2d4-ee63f89442c3","members":["ee7c1668-aa54-45b9-8b75-e6487c07fc4c"]},{"cluster_id":"a8a5c0a8-339b-46a8-844d-e6af4072cfdd","members":["d2220db0-db5f-4c1e-bfc5-00cd3d3f4183"]},{"cluster_id":"23e0381e-2d65-4ba4-b3df-e26366f32cbc","members":["c30b115c-9aa9-44ae-9f91-7e78a0eda10e"]},{"cluster_id":"83f04811-c07b-4cf2-8679-7397fef07ebd","members":["28664f7e-95c3-41b0-b55f-90f977f597e5"]},{"cluster_id":"a6f2fc25-ee4d-4748-9248-d40e233dda78","members":["50c056c6-ad12-4d68-9434-436eb788332e"]},{"cluster_id":"105a185e-0869-4f78-8bc2-ef2d7bd72e38","members":["092e9fe3-edeb-4793-935b-71936296b7ff"]},{"cluster_id":"c112d6c9-6b2d-48f6-ae9b-5380b20f2025","members":["59ac563e-6e2c-4f61-9004-22e54664af0b"]},{"cluster_id":"cffc59b0-977d-47ae-8b01-886477ecbcba","members":["dada36b1-14ac-4f44-a481-7bb7a0353c7d"]},{"cluster_id":"11423356-cdd9-4f07-af4c-408d43e6e2c4","members":["0f6ab3e3-d049-4145-b966-c0ba7cb300b0"]},{"cluster_id":"8351f868-a72b-47b0-8a87-867df6862124","members":["2b04da7b-8c50-416b-bc8d-bca755e48292"]},{"cluster_id":"4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43","members":["5b3e40f9-1d49-4afa-8300-d5b214d9714d"]},{"cluster_id":"ae8f14c1-199b-4891-807b-1b7d4b91ad58","members":["d25e2ca8-7933-453e-bb0c-5bc632a1daa8","09d0628e-e7ad-4fc7-a135-0d7f8e2f9cc5"]},{"cluster_id":"e15d8f08-e424-41bc-9193-92e22c4d515c","members":["03f4e181-d8ed-4586-bffa-fa817f4d5187"]},{"cluster_id":"6c30eaa7-fa21-463e-8143-13ed2522dbff","members":["4b4fe4cd-6bc4-4296-91d2-9122b258caba"]},{"cluster_id":"2e0416ba-2a52-4d60-ab33-cf2ac09ef620","members":["3a2eafb7-4d99-4208-9c98-2089f8596efa"]},{"cluster_id":"5ff5f55b-42b2-4238-8f0e-2306bf47cc82","members":["d9a09b32-3bc4-42c4-b070-f0e1739402be"]},{"cluster_id":"0ed6d266-01da-4d89-816e-946754d220ce","members":["40ba8f2a-1fbe-4c32-b690-0f720622e862"]},{"cluster_id":"0e83eeb4-b212-4ca1-a4ab-db7a128c6db1","members":["82b4341a-53c0-4a59-ba23-8a73dc03fb2e"]},{"cluster_id":"ed5e7bda-f24a-4769-86cb-26613eecfebd","members":["5719f0b2-0825-4704-b1e1-1faadcdd9013"]},{"cluster_id":"f7fe1cc8-30c8-4879-8f22-1fc4904694c6","members":["32904737-d2e6-461f-b57f-e569657b6a75"]},{"cluster_id":"51cbaa1d-e1b7-494b-ab8c-dca8a0d96a68","members":["0dd6dd1c-6caa-490b-8269-f36c3a303578"]},{"cluster_id":"bfeab18a-6cab-4e4c-ab1a-32ad52ac07e1","members":["25ec6b3b-539a-46fb-84b7-3b8309c4cc13"]},{"cluster_id":"7db7f2ba-600c-4f51-9a31-321197123c7d","members":["7fb28bbf-180c-4473-9113-882b65c5206b"]},{"cluster_id":"3ed099b8-1d1d-4e40-a70d-caf7e4853619","members":["f10cb692-543d-49a4-857e-12877e380eb0"]},{"cluster_id":"e5554b00-9db0-47c0-964c-03cd848dbfe3","members":["08cac6a8-d53a-45df-8eb4-69e83b4100e8"]},{"cluster_id":"2f0a7237-fd9a-4068-942a-5cae35e4e123","members":["7c7355c8-7251-4b57-b625-15ffe8465010"]},{"cluster_id":"a04d6dcd-d345-4928-a6be-52f446062bc1","members":["a2d32119-8579-4773-a14d-17c148d585f6"]},{"cluster_id":"5fca9556-7877-4bc1-82fb-6f88c867de71","members":["ecb1e2cc-e360-413a-9967-4b191fbe214c"]},{"cluster_id":"524147a4-6ced-4285-aba9-4ef213b856f6","members":["80d79466-d5eb-40ec-9fa3-c2e30b7d4853"]},{"cluster_id":"ec8073ca-bd09-4811-94f5-faa29b947d90","members":["dd94afd5-f875-436b-a036-109f54ec57dd"]},{"cluster_id":"a7ec7df3-d64e-4466-8dc5-ac899f0c0d28","members":["2ffb4703-e038-4783-a17d-d64c64fa7329"]},{"cluster_id":"dd1b900d-edc5-41a8-a7b7-0e0de59cf33e","members":["fafaffcc-17b9-4fc3-a16c-a6276bf6a408"]},{"cluster_id":"de0d9b6c-1e5a-4ebd-af0a-cb9e36b1417c","members":["1d8b5dfe-e2fb-44a5-8964-15e3019279e7"]},{"cluster_id":"eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba","members":["41ffb9af-a0bd-4b01-9832-3827139dccf1"]},{"cluster_id":"56bced3d-5502-4c62-9756-ced2f88eec36","members":["979b79bb-6bd4-4caa-b906-65b94d6ba290"]},{"cluster_id":"86cdbb00-bf89-4bf4-b9b5-585743288546","members":["64904b12-3744-4597-9b3f-eab26aff9e46"]},{"cluster_id":"780710ee-898c-4548-a5aa-7eb3c45e169a","members":["fef83bef-545f-48a1-a0a7-75f37f5f1858"]},{"cluster_id":"25f3e976-9943-4b37-b0c9-b84c0952ccb4","members":["877b6b14-efb4-4221-ada1-e753e29887e7"]},{"cluster_id":"31d03aa7-f36f-4c28-8ed1-5c9c9c77acf6","members":["bfa7eaac-7dce-4860-8984-9b0d09ebaf65"]},{"cluster_id":"0e4e78e3-4606-4902-b549-07174e100568","members":["a3565498-b868-4dee-98d8-d5f4cfe859f7"]},{"cluster_id":"a8fe9f9c-6b4f-45e8-a4dc-fab2a57284cf","members":["c09a83e1-da13-4197-9fc1-9729ee98abc0"]},{"cluster_id":"2f2fd953-8be4-4011-bcf6-98e5b07a9282","members":["6749d1a6-9d9c-4e30-9471-ba8f0b197ef7"]},{"cluster_id":"eeeaa7c5-23d3-447d-ace4-2782329b8bb9","members":["b0f38eca-6284-4ad5-967a-44d6f6e8f67e"]},{"cluster_id":"8179c546-cd47-4baf-897a-a15a8afbb9e6","members":["b1c980d2-d3eb-497c-945b-254679571688"]},{"cluster_id":"3a13abc2-f39c-460b-8768-7ccf1b11b40f","members":["b6091d9e-a2b3-424d-8756-d1f506d1b604","5da602a2-f68a-4e2a-8e3a-9e3ace51e706"]},{"cluster_id":"54390be0-8660-4904-8b7d-c97b603bc1ce","members":["fe5d9d42-98ef-42db-91ca-5f80eda25774"]},{"cluster_id":"151926b8-a45a-4f2f-9fc4-2a654d1c3ebc","members":["25b36395-e166-48c3-afce-86e3849d8755"]},{"cluster_id":"5534af16-de3c-4c33-b0b7-ecff69356f24","members":["41aaa320-17d7-49de-a85a-bbe111a655f4"]},{"cluster_id":"7180dea2-3c60-4f47-892a-7e623057b51b","members":["38c15e85-f56c-4be8-9020-a8e980c44144"]},{"cluster_id":"4606c4da-4d5c-4ad6-8119-d1b70a950373","members":["066d3cca-8042-450a-8414-fb6add35cecb"]},{"cluster_id":"6fb56d95-1435-4a1c-8bf2-454a172c105f","members":["1b913efb-1993-4461-a72e-8aabce43888a"]},{"cluster_id":"13bb7753-ee8b-4817-baa5-471bea919fc8","members":["620b1bc5-aa6e-441e-a9bd-de9626f41b53"]},{"cluster_id":"7b6712d2-df6d-4fa5-944c-8d0321a2652c","members":["0144f644-bffa-4efd-8e68-585abcf16d87"]},{"cluster_id":"4ea543a7-37aa-415b-8870-050c7ede5ba0","members":["72bcb16a-5839-41d2-93dc-7d6b586981bb"]},{"cluster_id":"3e2b1f73-9c36-499a-910a-db947f38acee","members":["f367d46a-f3fc-456a-856e-1c1287aadc11"]},{"cluster_id":"1f558072-4f79-45c5-acb2-7e178149e980","members":["dc14cbdb-9f5d-4046-bf54-40d22463897e"]},{"cluster_id":"2006ffe8-e5ea-49eb-8208-12ce96b310e4","members":["243e3702-8b47-4ed2-b0ec-a2b37d7ab8f0"]},{"cluster_id":"2fb74668-36fe-4d43-9c95-f7bf88e2f60c","members":["9b753a16-292c-484e-b4b7-02a71a1bad0e"]},{"cluster_id":"7e9bdb50-a12f-4215-9c08-0927124e5707","members":["56462797-c178-4883-943c-1dca4ad80a4b"]},{"cluster_id":"4294101c-07cb-4434-a277-aca60564390c","members":["d4769905-3316-4a21-8214-2138b5a9aa39"]},{"cluster_id":"a3d2d431-d86a-4c7d-bd04-db410111f7fb","members":["cd638490-7a6a-4ada-8d87-7cdb447ed0b9"]},{"cluster_id":"2ff5a9aa-c10f-4f8d-a47a-0ec077d3ef51","members":["d1ea88c1-6075-4f84-98f8-b0fa69033a82"]},{"cluster_id":"4a075bc4-4bea-4ec1-8783-33d17452523a","members":["e91616a9-c2d0-434b-9538-31cde29fd76b"]},{"cluster_id":"06e477a1-87e5-42ae-a235-8227d3b39fe3","members":["4de50317-2d5e-4c28-81f0-b14104e62927"]},{"cluster_id":"12c2b7dd-5504-45ff-b24f-40b180021ec2","members":["42ad553c-6f40-4a73-ae6f-7337824588c9"]},{"cluster_id":"00c86245-5e91-487e-8809-1bcfd15888ae","members":["1b6b8aea-ce45-4e28-8040-ade69307404e"]},{"cluster_id":"5d7bc6cf-96a0-42e0-b05d-1ff4cdfe4b5f","members":["e1b1a414-9823-46ba-81df-abb066162bf5"]},{"cluster_id":"78e60a12-a4a3-4c5d-805d-471d75987612","members":["407d66ee-056c-4ffa-9954-8a74ec5c3b1b"]},{"cluster_id":"d7fa6886-1236-4402-9039-11c8f678ba45","members":["d6febbd5-eae9-4696-9e65-20492eaa8e26"]},{"cluster_id":"85949bd1-40e8-47bc-acf7-cb049a4e425e","members":["27679405-42ca-4355-958e-fadb11d9dd69"]},{"cluster_id":"ecd748e3-d837-4992-8ea5-50edc6e9e5f6","members":["7a1ea26b-a1aa-469c-9031-a0db6bd82d4a"]},{"cluster_id":"800819aa-dd64-46d5-8bb3-ebc4802f59be","members":["f86adeee-5f1c-4906-8955-07542f945de7"]},{"cluster_id":"9d45e016-7740-4b71-ac88-57c1dbc80615","members":["54e28690-5822-4639-b568-f547d5ecad19"]},{"cluster_id":"94fcf1c1-17a1-4318-9032-ad180a9a74cc","members":["874f2a98-10f6-4186-b788-e5f7826dc4ed"]},{"cluster_id":"3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c","members":["5d294d4c-e97f-4a51-b0c8-88f18c467fb0"]},{"cluster_id":"bfcb4fd5-03ad-4398-a7b4-f52617946935","members":["a534d6f6-34a8-4f0f-b375-b2b83ea47d27"]},{"cluster_id":"cfa7b687-2383-40f8-9684-b8b6e91149cc","members":["f9d39220-fa21-4386-8859-b7e2ca80ef00"]},{"cluster_id":"93758357-874e-446c-984f-888b0a1aee47","members":["00318f36-a42f-4b3a-9739-a85e63103be5"]},{"cluster_id":"c4a711fd-1857-4f2e-beaa-2df948c3bf31","members":["0ea469ee-c86a-4d73-980b-964935d52068"]},{"cluster_id":"e4e83b34-5f5f-4d12-be7d-278344e0b336","members":["51d90631-d52d-4811-8d5d-390241030925"]},{"cluster_id":"4236f047-bfc1-46a9-8b89-2b002fe42dc4","members":["eb7d24b5-dd65-427e-b171-f83cb4ce37ca"]},{"cluster_id":"b33db570-415f-43c3-b381-72179faa3148","members":["1668bca7-ec75-4980-9c6f-2f91621c8981"]},{"cluster_id":"49e46347-a3d3-4b80-a516-3dc4bfcbd3b7","members":["94beb342-e1fb-4100-aa6f-1661c906c314"]},{"cluster_id":"eb4cf940-96c8-499d-b7a7-939513787944","members":["d71e764e-7568-4baa-9373-b319e67238c8"]},{"cluster_id":"edf45ed0-2320-4899-9b2b-3485b276ff56","members":["e26652dd-c02a-45ad-a807-9f1b18347fb4"]},{"cluster_id":"fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d","members":["2c09731a-0975-4ada-93a5-34b70eec8e89"]},{"cluster_id":"60f1f675-db08-4cfb-a9e3-20e14baf899f","members":["fe263f5f-c718-4788-a50d-e142151e69f2"]},{"cluster_id":"3f6252b1-52a5-4e4b-a596-99c6a237551b","members":["255d4da1-6d25-4946-9414-1fc9ca446238"]},{"cluster_id":"95bbf098-c966-4fbc-93df-23d227e7ee92","members":["c716c947-f36c-40a2-b826-319d84ccd492"]},{"cluster_id":"388a333e-2008-4c61-8154-a9e224b365b3","members":["8551716c-4da8-4042-a80f-e628da5cfbb5"]},{"cluster_id":"ec6a0d33-6433-4fbc-b666-83c9c378399c","members":["ab4d7d4e-92fb-4d09-860c-470c3843c20a"]},{"cluster_id":"553f1291-956b-45d5-9567-97bf2439ca2b","members":["ac6ea0a5-f6a6-47e0-9521-c3143bb2d59e"]},{"cluster_id":"092693ec-ddb5-4cdf-be96-1d6ac20b489b","members":["0d812208-be9a-41ba-8217-ddce9b7193c7"]},{"cluster_id":"53ab10ad-1f0b-48bb-90af-3977fee7f1cb","members":["dfdd0511-b751-45f9-b860-20d88b28629c"]},{"cluster_id":"c1d6fe8d-9eec-42fb-a300-6a6e37dcd1f2","members":["c2b67055-8042-4c98-8194-7993aceb4896"]},{"cluster_id":"acdd7a89-aa71-4db5-beb7-130a3813dd88","members":["b7ec77ee-9594-4b8b-97ba-8ad5890bdfb3"]},{"cluster_id":"fcb8985c-e271-4f8a-9ba5-ab287203d1d8","members":["ab2a0598-91d2-4ea9-bd43-4e87e8119b4d"]},{"cluster_id":"089384c1-0ce2-49fe-812c-a7e86deaedaf","members":["f041e3c4-8af0-49e2-a036-f8aad3b7c75a"]},{"cluster_id":"b1c829c5-5bbf-4809-a139-ca7f221f5d55","members":["9ec6bca3-2ada-4c9b-b92b-1401c547e3ca"]},{"cluster_id":"5450c124-f70b-4739-a4ce-8408866030e3","members":["a7fe1c2a-2e3a-4fc2-b5bd-545f80fd50e3"]},{"cluster_id":"82cece60-3255-4d43-a228-e34efd18c27a","members":["991600ba-725f-4885-bd82-8f65e7004314"]},{"cluster_id":"4ca6827b-b30a-4210-a329-a338c23874a3","members":["e8b9df1e-a9df-41f2-a58d-9757cbfde177"]},{"cluster_id":"0060e859-7676-43d1-9a21-c2ddc4f18fbb","members":["3502743f-3377-4385-84ca-0faa22970d7d"]},{"cluster_id":"ea5e4d14-d784-48f0-ab38-f454314db96b","members":["cf694b11-5df9-4934-becc-c79b9f39d996"]},{"cluster_id":"3f91e02f-ab23-4d35-ac70-4b14b0545030","members":["d5e301d8-602e-4994-b9c6-e12ad3ed9440"]},{"cluster_id":"c7fea8d2-cc9a-4113-be0c-ac48857e6432","members":["831cecf9-8b31-4512-867c-607e42777deb"]},{"cluster_id":"add8105a-2d0f-4f9d-9f00-f11f0673121c","members":["6288e6e4-82d9-467a-8a64-a03fad274591"]},{"cluster_id":"ebed0c7e-1e7f-4dd0-9028-668b74f8c629","members":["b397d863-3c35-434f-b821-58e2a9adc787"]},{"cluster_id":"0d187a90-37da-4e4b-a2f0-e217ce5cbf79","members":["cf23fdff-9ba9-4d57-adea-fb5f00be4898"]},{"cluster_id":"f04b87e3-ae1b-4e57-8c7a-f468d2163699","members":["ef6647c9-5e6c-4e11-9d27-f848ac5a2df8"]},{"cluster_id":"7b8193fc-3e2e-459f-9d2c-f5d5c9d7a1b0","members":["78b7211b-abf0-486e-9133-264e33b0dd2e"]},{"cluster_id":"dfe985d2-9dfe-4657-be1d-a745b7ca1ca6","members":["aea23b1b-a75a-44d1-a018-4b0952e651b8"]},{"cluster_id":"1379aa81-833f-453a-8fb7-08ae39840196","members":["a0145699-ea4f-41dd-9bb3-a1f701e8732a"]},{"cluster_id":"afb76d5a-b98d-4292-ba1f-8d4ecc4a368a","members":["6b815d11-f965-414f-b04f-38078bccc1d2"]},{"cluster_id":"65c4b6f4-f33a-4b23-a073-15587ff25d75","members":["5d9d7d0c-e16b-4987-9c51-34a858aed7cc"]},{"cluster_id":"2b4c9e75-4679-4e5b-8a08-08bb2c621974","members":["bcabb37c-2778-4f34-beae-87714ad4fa2a"]},{"cluster_id":"5c9296c9-7461-4417-aa55-8ba44cdddfec","members":["5f28ddc2-3522-430f-87d6-316dc67120a0"]},{"cluster_id":"ea50bb1c-1d0d-46d0-8c9e-6b1bcd539913","members":["11b4193a-8eda-40f7-895f-3eae3fc69a76"]},{"cluster_id":"84f58721-c200-46df-b038-aa93f32b79c6","members":["42972dba-af6c-41fc-8772-d27c793c1d53"]},{"cluster_id":"c7898fe7-8ae8-4977-88ae-a56e6d146778","members":["9447caab-570e-4091-9c8b-4d5f9ad1e7ea"]},{"cluster_id":"2253ac9a-3adc-46d3-a973-f064ce69f740","members":["80ef50db-23dc-47eb-aff4-2203eb2d93a3"]},{"cluster_id":"5535ff65-262d-4c0d-a8e9-0c0a87d3ccdf","members":["71ffd1b8-747c-4378-a479-dc3272327150"]},{"cluster_id":"e014d650-8fca-4dde-a60f-f8576ce7542f","members":["cc0250a3-78fb-45b6-bff5-ab59b69e6bbb"]},{"cluster_id":"38a91236-7bbc-4335-9d5a-a470b70f608c","members":["def94eb5-d1cf-4555-a291-c616a355a307"]},{"cluster_id":"d88b95f4-1e38-4dd6-b178-e63adfad4ea7","members":["3e32d9b4-ae18-4f58-b37a-7e9d55df3f0d"]},{"cluster_id":"2ca744d4-a598-4453-abb6-08ac069370e3","members":["46a4931e-56c9-4d44-ab93-dea353a3591b"]},{"cluster_id":"5bee647b-e5d6-4ab0-b317-a48d3ac0cc11","members":["a3edd026-9660-497c-ba20-f26eaeb8a066"]},{"cluster_id":"e8d1e306-3805-48a6-8fe7-8350cb762a36","members":["8cbf4cf4-98fb-40c6-98b5-f4f3d4216956"]},{"cluster_id":"aa149821-edf1-47da-a3a7-3f82f411bb32","members":["0dc10a52-de59-4fae-8678-4ab5b33e6bbe"]},{"cluster_id":"bdc29925-59ca-47f1-8fcb-329866ae2601","members":["62e0f624-06d0-4606-820f-7615dbc6bebf"]},{"cluster_id":"e6294e0b-891d-4ba7-af93-8aa8ed47eeab","members":["3cf927ce-0606-49c9-a8f3-2958023999a2"]},{"cluster_id":"6ad9a81e-b42d-45d2-9083-3274cf3a2137","members":["1add4e30-cd25-492a-8b9f-a4b8d5fe5750"]},{"cluster_id":"0e8414db-df98-41e4-b595-a6e3b96bc6df","members":["2473eb4f-2c43-4bdc-988e-6373f7312394"]},{"cluster_id":"6b03b394-3970-4d06-bfbc-01183e585200","members":["76635dbe-afb2-4636-b758-4cb44e7787f7"]},{"cluster_id":"4f2c99ad-9a7b-43ad-b8d0-304aa8cd2c73","members":["49a0a2f5-6976-43f4-ab33-7721a4580cfd"]},{"cluster_id":"6150a21f-6d1d-4554-8cbb-b01623349756","members":["99d4ff25-e52e-42cb-9bbb-331504d00d24"]},{"cluster_id":"f5af21c1-57be-4378-ab8c-5400cfed6bff","members":["bfc5a568-ce9d-4379-81ae-c95f7db0f346","609fc20d-fab3-4131-b0c2-6231bd2b0971"]},{"cluster_id":"d73adbe1-7dcc-4345-a67c-e7d102fbc24d","members":["c5556274-2955-4223-93e9-febbbc593ac0"]},{"cluster_id":"eecfdbc7-a037-435d-b439-dc9fb3713fa6","members":["749c573f-6d99-43d1-93e1-1aeb776bd723"]},{"cluster_id":"199fa239-0e31-40e8-a4f6-178a14d58cc8","members":["c50a2138-0b86-4f47-aee6-dda205328aef"]},{"cluster_id":"b5d6d05a-3d31-4ce5-aa84-cf94365c8485","members":["af70fd3c-0f4e-49f3-b25a-63935cd5ea6c"]},{"cluster_id":"75482488-ef21-4630-bf12-4747cdb69136","members":["48c11cdf-4764-4cd2-911e-469e9ec3135c"]},{"cluster_id":"8c73e80e-645f-41d1-b314-c8d7737bd33f","members":["7f4a044e-a00c-47ee-8282-f045a93d6dbb"]},{"cluster_id":"fef26a04-5ec2-47de-9b9c-92eaaae9e544","members":["daab206a-46c6-42b9-86bd-4772d61d43bf"]},{"cluster_id":"3128448b-d77b-4666-b5fa-39d7bf0fea69","members":["4ff9dd85-321e-4fc1-b596-2519e34295c6"]},{"cluster_id":"2d485df8-2925-4317-a6b0-216006ba9fa5","members":["2cd437e5-7618-46c4-8169-8a22df9219c1"]},{"cluster_id":"d0699d4c-25e1-439a-a44a-9bca30bebb35","members":["cc45c3e8-7e6b-4f81-b0b9-56a2ab01839f"]},{"cluster_id":"38992305-30d9-47ce-bb30-bfa120506e54","members":["49c95f25-4fc2-48e0-a4c2-13cd04a0be14"]},{"cluster_id":"465883de-cd6a-47dc-b0f3-f22e0ff902ba","members":["47cedce3-3262-4105-9c19-91971028dc17"]},{"cluster_id":"7301fbf5-a19c-4247-aac6-e3d55981cf96","members":["91c29cf1-50ac-4fda-8387-a45e9eb86d48"]},{"cluster_id":"1a427c1e-6df0-4798-aa10-9a17d3c392c0","members":["100a5f92-308e-45c1-b373-656f0ac8ba61"]},{"cluster_id":"8693ba93-793a-4911-b2e4-5cb419139802","members":["3bc6623e-2517-4386-b3ef-1a6ef5e48177"]},{"cluster_id":"733fc34a-7676-43b2-bd68-29d000ed566d","members":["100835ae-6e8a-409d-ab1f-849e3e442927"]},{"cluster_id":"95cf8fc0-eadb-4c70-8762-0c3f65726aa4","members":["b7badbe4-1480-4740-84af-86c7523a433a"]},{"cluster_id":"43cb3cb0-9dc6-46db-91b7-d99bcaa7a443","members":["33dd84d3-8730-4bb5-9380-23b417b5e4d0"]},{"cluster_id":"d3157e1e-5fca-47d3-93bf-fb77fbc5070d","members":["0b7dc1e2-ab56-4b33-ac54-7cdeb5f16390"]},{"cluster_id":"40467831-07ba-4c26-8f13-029707ea2660","members":["0a61ddef-0a7a-4d1f-8d16-65bd35c1ffc9"]},{"cluster_id":"2d060fd1-76c9-470d-941c-4c8d800b380a","members":["03770f87-b530-494b-839a-699441af95f4"]},{"cluster_id":"6cadfbb6-c995-4a61-9bf9-357705f879c1","members":["97993de4-36d6-40a8-8ee4-74fe9a971f9d"]},{"cluster_id":"2dbc4a6b-98c2-45e2-be58-a00cfa47819c","members":["17e66a98-25a6-493f-8ac5-75dac9dd5953"]},{"cluster_id":"1e2f3c33-51a9-4ade-8539-40a4bc9cfff8","members":["e61b707f-b13b-4fbc-a817-8cb29c1838de"]},{"cluster_id":"8812088d-8004-44b8-9f99-4965a38e2031","members":["66122d9b-07b9-4336-a64a-2554a7ecc4bb"]},{"cluster_id":"67eaacee-8b2a-42e6-980c-72585c0bb525","members":["8418add7-2b09-4307-b140-1777e2bffd7b"]},{"cluster_id":"a8b81223-8089-44d9-8780-1c910b2a64e2","members":["236fab75-12fe-470c-a805-30e262f615e1"]},{"cluster_id":"a222cb65-167b-49af-b5d2-9f2a8169e28d","members":["4b0ef420-0f8d-4887-98c1-ba44f430b107"]},{"cluster_id":"1936e9be-7524-40a3-aeef-be93dc5f5e4c","members":["f7986f09-a424-4730-91d8-7184938981d1"]},{"cluster_id":"d56cee1a-0acc-4d28-9308-a2519fc04041","members":["6f6b7766-153e-495c-8bb7-c1fe489a04dd"]},{"cluster_id":"e1b119bd-f317-4a5f-8c26-1f7c12a78710","members":["e109c0a7-b9f8-47fb-8dec-aabcf71b1533"]},{"cluster_id":"984977b5-907e-47e8-b70e-4d24066b2265","members":["0b7e45d3-6556-44e5-a308-6ecaeed877bd"]},{"cluster_id":"cef3ea24-b5a3-4eec-87c9-03935082f43c","members":["ea0c236f-635a-4b74-b1a1-5663336c4c92"]},{"cluster_id":"d8c99eb9-8781-4abc-9592-b545d9c15ce0","members":["18ae0cbe-1331-4340-b56a-5c85bc9c3939"]},{"cluster_id":"747b93ff-87de-4a18-a76c-e68485fa2bed","members":["a15d5adb-b4d5-4ea9-97a6-1ea64e048da2"]},{"cluster_id":"7303fe0f-e412-4fb9-accf-41194e4059f2","members":["5159d09a-626f-4ef3-b9eb-e1a360dd8787"]},{"cluster_id":"268b0686-4ead-44df-9f34-76aeb864e839","members":["7f1c8ce2-f14a-40ce-80d7-fcb2fcb8a938"]},{"cluster_id":"69d7ee2c-955b-4d7c-a4fa-16491444b045","members":["c248d4d9-7e12-4ee9-8273-2c7baa433d29"]},{"cluster_id":"e500e465-a022-48fb-afd5-82c02df96bbc","members":["25ac0643-8c95-4de8-8761-28dfeb1e494c"]},{"cluster_id":"ff6f2ca1-7367-40eb-b2f8-72fa90168057","members":["94ae7d73-7c37-4d4d-81d5-f34cb67332c7"]},{"cluster_id":"28c6e890-bb36-4eff-b0b6-22f2850f023d","members":["b5a0b1ab-b754-4668-8df3-ac0730010494"]},{"cluster_id":"0594b862-5f0d-4a2a-9cbb-4d9d2192ea9f","members":["11a0d2b6-f308-41e0-a22b-006339445092"]},{"cluster_id":"6cd72072-03f7-4b6f-a5d4-4465c298c295","members":["90adc281-7853-41dc-95c0-1d93ff441625"]},{"cluster_id":"ab08e2a8-8249-4477-b0dc-0a3c5235d6a7","members":["65f3b7a8-60c7-4efa-a179-748ce3d57066"]},{"cluster_id":"4061c2fc-ed9c-4f22-92dd-291aa2df6a90","members":["b834e80c-57e4-4c4e-9364-a6ce35f05cef","5dc728d9-13a8-47fc-b9f3-ae98951350e8"]},{"cluster_id":"3775dc56-2d8e-428a-9c60-ba993c0f4ba7","members":["d08075a0-da02-4f6d-9e2f-471a31fbe88a","088f6d76-5154-4348-a832-9c9c301aca64"]},{"cluster_id":"c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f","members":["28b6dc91-8158-42e8-b45b-ef79f26080f6"]},{"cluster_id":"95caea6a-ff66-40ac-9167-0fca6baadbff","members":["7216020d-38a5-4789-8bf9-8b552e21b881"]},{"cluster_id":"314510db-f67d-4268-b068-13a87261ae5b","members":["563d2ebd-745e-44e1-8475-c15c1c9fe8ef"]},{"cluster_id":"9427cf91-1580-41ef-aaf0-2efa82b46d41","members":["ac95df98-1a59-45d0-a7f8-02a1ccf486ac"]},{"cluster_id":"028c0dd0-ac64-47ea-94f9-5c74b9d66731","members":["f3a22222-3f26-4d41-8ae4-ec2eec8e359d"]},{"cluster_id":"0bf33c34-9525-433f-a535-5885b1ee4732","members":["52949534-ad9a-45bf-97df-7560f69a8480"]},{"cluster_id":"1da8672c-062d-456c-b508-fef471a32245","members":["7e554a7b-d9be-49df-877b-d884572747c1"]},{"cluster_id":"4d3fc72a-c96e-4659-afda-27c7ce47c497","members":["0dfb5183-818a-4a43-a434-b3172805c9d8","b74b70e7-c83f-41d9-bcc8-9d6a97dabe5d"]},{"cluster_id":"8d628785-9843-475a-bf8c-f7eff1bc8e38","members":["057415f7-0a69-4ad7-81cf-5bf03120bb5b"]},{"cluster_id":"88a95916-de94-4c29-849b-89f8018ddf03","members":["14cf000c-8c1e-4720-9adf-7bde0c3f5147"]},{"cluster_id":"a9574820-7af4-4109-8e6e-9d95f9ba6cbd","members":["df08cb44-ecf0-470d-9612-05f33a1bd3be"]},{"cluster_id":"4c83d9ff-1e62-4a28-b3d2-a667fb4041d7","members":["71e43c54-8546-43f0-8584-9a3b81e73792"]},{"cluster_id":"1373b88b-91da-4b7d-bc67-e2f0449d0283","members":["52aa91a5-8d8b-4866-8a15-a467ddeb84d3"]},{"cluster_id":"2bd21a46-0627-4917-ba75-98775bf2627b","members":["1f00bdc8-2cc0-4ec2-ad34-86ee8a82ebdb"]},{"cluster_id":"ad2e25ad-1bb4-4fa6-8af1-bce0c9f8c697","members":["75b4df13-6fdf-41f5-9548-45d77a05afef"]},{"cluster_id":"ec7138ff-1f97-4076-a56b-198783100d75","members":["7f5a768b-f8ae-4844-b7cb-a83633d09cbe"]},{"cluster_id":"e73cd951-c537-451f-a279-08d6827059e5","members":["c7300144-20ac-4f8d-b8db-56dc189b6f68"]},{"cluster_id":"9b47f058-2394-458a-97b4-e9b218a76e1d","members":["21d7ba1d-2d43-4b90-874e-3fd3b70de5a7"]},{"cluster_id":"c0d885cd-8830-4032-af1c-4955d65db09a","members":["27413585-74ac-42fd-a64a-9526033ba7b5"]},{"cluster_id":"1e13c242-ece9-4014-9237-1eaa4afdacf0","members":["4b503e26-b164-4d01-8cfb-e3cb93f6f278"]},{"cluster_id":"729cc7ae-ca2f-4e76-9131-41ad0335ecdf","members":["7d12d99d-5ec0-47fb-a7fc-15b34faea721"]},{"cluster_id":"67cff5df-1bcb-4edc-af42-99ff9df792c5","members":["28b169fe-6d66-4d61-9e75-cffde783f4a0"]},{"cluster_id":"5062ec52-04a9-40ad-82e8-e7b18ce41e9a","members":["2344c640-395e-4645-a314-d1a54fc02b7b"]},{"cluster_id":"e4c393f3-a213-40f3-ae1e-bc16b0f13a4f","members":["b0a3cf13-1a4a-49cf-9650-b4d47bd24a66"]},{"cluster_id":"b9804a77-392b-4042-a24f-eda229eba1c8","members":["ae5557c6-998c-4b66-b2b7-a5aecbac8f3c"]},{"cluster_id":"60a5fa4a-02a4-4e44-b778-ab28e2e5eb27","members":["013c1cd9-b7c8-48fb-b8ce-475e23266ea5"]},{"cluster_id":"17a99d17-d7ec-4cf5-8a94-b29753d62b97","members":["7de80b65-043f-4e5d-a9bc-d226ff6b6fdd"]},{"cluster_id":"d21c817e-4d9f-4479-93a3-693ea677e1ba","members":["3b98511c-321a-4192-8fb8-abc95011c37e"]},{"cluster_id":"58062111-7e54-418d-9733-f5233a5838b1","members":["0321a354-364a-4a30-b679-e623c1a70423"]},{"cluster_id":"db91eebc-901f-4800-8b70-2d11c9945ab2","members":["4711e8d3-bd16-4241-953d-c51c6c90d423"]},{"cluster_id":"61eb35de-336f-40f6-88fb-ed35c226eeeb","members":["975471e0-820a-4978-8aaa-066b30963821"]},{"cluster_id":"62f74a8d-c7b3-449b-9454-ae631aea88c2","members":["bbe3e36a-e3e8-44b0-8d0b-6bb1acbbccd1"]},{"cluster_id":"923c46a3-c0b6-4907-a189-66afd503c6b7","members":["27bab3dd-8905-4e53-8114-ad36b1d41d9b"]},{"cluster_id":"d565264f-4050-472d-a250-87b812ab31fd","members":["130d090a-a725-48fd-97d3-ed44794213dd"]},{"cluster_id":"235b76d8-eadf-4d03-98a8-4198401ca562","members":["983f6e63-0d24-46b9-af13-db591b501c72"]},{"cluster_id":"8d301f71-3fd8-4bb2-b685-2bfee512c9e8","members":["fdc978ed-40a2-426b-9b52-d01d7ccc34ea"]},{"cluster_id":"605d1ffa-cf79-43de-a146-0eef92de2043","members":["eb8f967f-2656-4a4b-91e8-a4cb188e9b89"]},{"cluster_id":"7e3014ad-3100-4bc7-8edd-4e32af49ff75","members":["0296336a-12f4-46da-8644-2db3b8318904"]},{"cluster_id":"c7bbd075-2e34-4018-bab2-225944afb981","members":["71716b5e-5ae9-4ffa-8706-06583a089e68"]},{"cluster_id":"6988ebca-b8d5-4719-a15d-b25c13a58367","members":["949d656d-6c77-4e70-a816-4a946c24cafe"]},{"cluster_id":"02d5b346-4337-43cf-8a61-4391e125d41b","members":["96422655-db81-478f-b5cf-5ce26a64e857"]},{"cluster_id":"4305150f-f7f1-49f6-a09c-d2c5973a5934","members":["6d645f66-2fa2-4440-97b2-ff77af9e2264"]},{"cluster_id":"d020ba2c-1e1a-4bee-8860-bc381620b119","members":["4ac1ca20-eebb-45cd-a74b-79edf957b37b"]},{"cluster_id":"599b237d-3afe-449d-8cd9-becd796f27c7","members":["2cc66c0f-4d03-4670-961a-363f22e74a7f"]},{"cluster_id":"9a201ba4-4fa1-4a8f-b530-b70790363696","members":["fd9362a0-22e4-4461-9e09-8bb3013720c9"]},{"cluster_id":"9b7a4b49-e4e5-49c9-a089-9e908e59efcc","members":["265a5bd9-2e5f-4b66-9802-32ce6519ab9f"]},{"cluster_id":"15bdefb4-3c81-4573-bb02-e7a3789e75e2","members":["0872d008-2206-414f-abe3-83a079ff4a39"]},{"cluster_id":"75a5f06e-b690-4ab1-b016-65c86c1b4940","members":["5577f827-1608-4eba-b5ec-b6916810af2d"]},{"cluster_id":"f4253f2e-cf0c-4fcc-9979-cb25e723158b","members":["6be138f4-42ee-46f9-8ff5-ea2d160f4ea1"]},{"cluster_id":"8340119a-3207-4843-be46-581bcbb33e2b","members":["5ffd8aa4-ec97-4d8a-86a6-30eef06339a0"]},{"cluster_id":"6b078586-a71f-43ea-9363-faa3caa5fe58","members":["06489a60-fab7-4944-84a1-9059ed5014f1"]},{"cluster_id":"1a36fb41-5917-46f9-abb2-91e9032c6071","members":["f12b36ec-524f-4185-92f8-58f3b6597825"]},{"cluster_id":"779beaba-8043-4ec4-ab6b-1cb654ad8ccd","members":["243eb1c9-89ac-47a7-8b18-c1f944abe097"]},{"cluster_id":"5f6424e4-0455-4ee2-821d-018975472c03","members":["7c03c0fd-ffe3-4565-acfa-cb3327161e79"]},{"cluster_id":"8a11cb2d-17fc-4106-aa7c-42847d3ac867","members":["770b1abf-44f2-443a-ada7-f9de8408d8de"]},{"cluster_id":"87581b6b-a1c8-4620-9246-61483cbbfb0d","members":["5bfadb85-2f13-495d-a5ed-3bb9abe6e895"]},{"cluster_id":"fe94ed8f-3634-4c2e-acc1-318cbc76b2f2","members":["e8eb7f37-56c7-4d36-8486-175416342713"]},{"cluster_id":"4ea67e25-b76d-482e-ba32-1243cadbf594","members":["c034b4f3-6230-449a-b8ac-837184dc0e06"]},{"cluster_id":"12975b02-1543-4e2e-83d5-f31f56ef1664","members":["b255b7c9-3282-4965-a14e-e386cae653f2"]},{"cluster_id":"fc3a7125-d930-4cc4-ae3e-0da6ebe44d84","members":["65adb4cf-7e23-4a79-a659-7fbf02ee5fd8"]},{"cluster_id":"1c46973d-d9e6-4d0a-bc0b-63d9b4862b8d","members":["f9423227-1b63-4da3-a7f5-d507937f3480"]},{"cluster_id":"49af375a-1b87-4e0c-b77f-9747485eaee4","members":["c6902fca-ab14-47ef-8569-a98135d90446"]},{"cluster_id":"55be4945-34ca-4ac0-b3a5-86bcc22710f0","members":["0ff69dd0-d45a-4438-9242-dfcfdab7127a"]},{"cluster_id":"b03fae7d-ee9e-4f46-b206-fa4dec1a6c69","members":["0e539a1b-8353-4717-8aa8-84f7274cff07"]},{"cluster_id":"fc32a20d-bd13-4dc2-a851-03b63c1e329e","members":["3c61e333-2a92-4f9d-9a82-21dde68f2518"]},{"cluster_id":"9f734692-8c1b-45a5-98e1-623a0369fed0","members":["ceb9e85c-52f8-43ae-8501-cd165988bf17"]},{"cluster_id":"d6713b0d-513a-4166-b2c8-1c6b4cde08b8","members":["b887f2b8-b1c5-4847-8a77-8f61e2bf908a"]},{"cluster_id":"058f52a9-8a35-4f4c-823b-efe94ad1ee22","members":["c0781159-2fbb-43f9-b1d2-271979aef096"]},{"cluster_id":"e34b1053-1f91-4dd8-9190-a7ed9dea81f8","members":["2f5b44d4-cd77-4901-bf0b-5805d001fa71"]},{"cluster_id":"815bc458-4e48-4001-99cf-32e4675d4871","members":["a6a090f2-250e-43f1-af87-da60443890f6"]},{"cluster_id":"874c8d94-d252-41b3-bbae-89e33a5eba13","members":["1dcc4637-5075-408e-9c32-d48cdf9be951"]},{"cluster_id":"3a31904f-9e32-44e5-89a1-822aa5467c6f","members":["7f72ea83-ff2f-4681-a254-a3b653f687c6"]},{"cluster_id":"f3c400dc-7cb4-4e82-a493-b5e485fbdb96","members":["c4b59a03-d07f-42af-8421-354a5780f962"]},{"cluster_id":"98561354-101e-4568-a2cb-77ee7e2819a1","members":["0014feda-1b1b-42a4-aa95-a5b97781628e"]},{"cluster_id":"079b8e0f-e8e1-4996-9f11-531830a5cd53","members":["560e8ffd-ee97-4d01-a595-24d938c47d39"]},{"cluster_id":"e5391c1d-dcc6-47a7-9d8e-10697d160138","members":["9ad9050f-5297-4565-a721-5483adf4a456"]},{"cluster_id":"ba69550c-4232-407b-a518-7595f5dc57c8","members":["ce541d26-e549-457b-a70d-d465ca8545c2"]},{"cluster_id":"0fb15e05-a0f9-40af-9d1c-3b5766f5252f","members":["182e124b-54fe-40db-a8a6-ec485c12f145"]},{"cluster_id":"b3677c08-0eb1-4865-90d2-0d359e3678b8","members":["9dfaa4a0-ad0b-412b-91c7-424e2e092732"]},{"cluster_id":"c3a6bce1-7cb7-4d0d-a994-69caef25a8d5","members":["c00c097f-bcb6-4ed4-8fd5-dead73179f72"]},{"cluster_id":"8430f01b-f34e-4798-8729-04aadd64268d","members":["f854b645-473b-4244-a7c8-531d665d6b1d"]},{"cluster_id":"379e9bdd-f97e-4662-8fa6-c65318b2f0d3","members":["545df908-fabd-4031-bc78-cc2208ec4a29"]},{"cluster_id":"545232cb-5fc2-43ad-859e-11784f675852","members":["72caf4ba-911e-4116-ba62-9c8ff8286562","f1f11a20-928c-4ed8-8c63-bd61be10cfdc"]},{"cluster_id":"8c70df97-1c82-4e7f-b23d-acbf2024c8f6","members":["5d954983-cb6e-4a77-ad29-8e94a7585934"]},{"cluster_id":"872f71be-bb1a-40a1-8078-ee9f850ec42d","members":["20a849a7-46e3-40f7-a53a-ef9d656341e4"]},{"cluster_id":"735c3d6c-a597-44bd-92cc-d934d1e29409","members":["4ae6cdf7-a766-4c1c-8aee-3a3746dc2c7b"]},{"cluster_id":"ab265737-e0ba-43dc-8147-c642f185978a","members":["72293139-3b57-4eea-a823-2b901a0bd6cc"]},{"cluster_id":"299d788c-3d25-4b23-8898-a2eee18a0fda","members":["de60d725-248e-45d3-b701-2a13af9f5f3a"]},{"cluster_id":"9c08b4e1-94e3-4cf2-b505-4d6b5137534f","members":["118bac1b-1c0e-46ec-995e-13205dbfa0fe"]},{"cluster_id":"1af06082-428a-4dc1-a3c0-4aa29b512806","members":["0588b688-a1f1-4c74-bc0d-ab5b9fb67dee"]},{"cluster_id":"26032edd-a722-4f79-a364-7bd2114c1626","members":["528eceea-ad8d-4181-98a7-d21830e6b92c"]},{"cluster_id":"0fd165fb-7316-456d-917e-cb976d5b4983","members":["0e3e0511-d7db-4415-ada9-ee2e4a3be17a"]},{"cluster_id":"ff4b91c6-36e8-4903-a2ad-89bb3665e4d5","members":["4af7ba6c-cb5c-47aa-864d-420317ab4551"]},{"cluster_id":"1c08ccb0-286c-49ff-a95c-c82f67ced7f2","members":["3410331e-c4bb-4b1b-9574-05e5018b3c78"]},{"cluster_id":"8254f8c1-33e3-4176-8b1d-232b3b4367f4","members":["8e6134fe-fcea-496d-8c42-a0c71fc9314b"]},{"cluster_id":"41e9c8c9-45c4-4590-9393-a3b2281304ab","members":["69e46ab7-fa2a-4486-aa2d-5674fe1d36ae"]},{"cluster_id":"08cb653c-495a-4846-800e-e87a07c472be","members":["a79eec91-a9d0-4d1e-9151-c8ba4191eeae"]},{"cluster_id":"0786cda2-1538-4e16-9f54-d0704127539a","members":["4848d6dd-681c-4bfb-8f4c-088503283355"]},{"cluster_id":"b3995a19-7531-42df-8c11-d55b2b796806","members":["c84d033c-e6d4-4d02-87e5-bfbd16e5763c"]},{"cluster_id":"dd0e35ae-acba-486a-a98c-7ff8e0d969ad","members":["c4ae27ed-c685-40eb-b3f2-cd3a9e555b24"]},{"cluster_id":"3f015f88-0af0-482a-a4a6-663bbcc6d95b","members":["120e6568-4927-46e5-9b8c-9209bae7ba65"]},{"cluster_id":"af198123-e2b2-48b2-baf8-af5aa8446190","members":["9ee5891d-a8c2-4320-bdf4-773e1c8b47a5"]},{"cluster_id":"aef65abc-e7b7-4946-9c22-4ac367aaff7e","members":["74348668-7496-4786-bd40-a3af23277223"]},{"cluster_id":"55f690c0-9fbb-459a-ab42-db16e202e04f","members":["5f253ea7-44db-41d3-af44-c944763b5a9d"]},{"cluster_id":"06d0d746-6c6d-457b-ab07-13b3cadf3286","members":["8b5a9367-1545-497c-928c-f030b8a8f17e"]},{"cluster_id":"791db8c8-66c8-425a-80e1-d5e8778fe4a4","members":["5d364e2a-f3de-43f7-b56a-969e6a87be50","b925b8a6-b72d-4a5c-8669-aefd94275817"]},{"cluster_id":"43fafa8a-6241-480f-aa40-04f420f4ea5e","members":["ddc9cd67-afd2-4128-af33-fd1ad79e6eef"]},{"cluster_id":"58a5d45d-929c-4882-97bc-6346fc773e3e","members":["7f258dc4-cf55-47d7-be56-d97f72ce1266"]},{"cluster_id":"198dc8a2-e334-4b48-8e21-1b19bd36b74b","members":["1bb93b9a-3781-44f3-9a0a-577dec3bc98e"]},{"cluster_id":"713029fb-6b38-4883-a995-a264b7e6024e","members":["2c6af927-8707-4b2b-a140-05964d617e9d"]},{"cluster_id":"49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a","members":["8697104c-7220-4b29-b05a-345b1a11c2eb"]},{"cluster_id":"4272dbf3-0c9a-42d8-a9a1-b2b3a349e192","members":["48f065e1-6239-40c3-8de3-d1143ae5a53c"]},{"cluster_id":"17d6daaf-12c7-4c0b-88cb-bf8161dd5be6","members":["c9c22e9c-6197-4c83-b1bb-8e73c7a16c24"]},{"cluster_id":"80c4a4ac-f4f0-46b7-a4e0-1dc67ab16883","members":["dcd2ed13-c5a6-4710-955f-f038ddd86c35"]},{"cluster_id":"6fa6425c-c799-413f-9698-b7928b5c5770","members":["4950e4b4-3064-47e2-b931-2dc32f30e301"]},{"cluster_id":"30a2e818-400c-4443-9905-7ab130b7ac97","members":["9823e290-a1be-4856-94c8-d7ef2125e053"]},{"cluster_id":"e92990e4-6de9-4c7c-9c4a-006af1a579b1","members":["1c192a7f-6d7a-47cf-8ad1-f2b4242cc65c"]},{"cluster_id":"09f4e973-2393-41aa-bdcb-ccd0efbed300","members":["ea349321-89e6-4d71-9a4f-896fdd5e06e6"]},{"cluster_id":"344f18e9-fdfb-4043-b1ff-09516022ac50","members":["448ae192-3b42-4b2a-8680-e61ce109a521"]},{"cluster_id":"89cee3a2-4f95-4473-859f-f9c42c415bf7","members":["14e09847-a435-42c1-a835-bed3c468e5f7"]},{"cluster_id":"9096c294-fd2c-4311-a357-8c17726796f2","members":["71d91ae6-6b54-4b70-b8aa-5a6814c43071"]},{"cluster_id":"16428f67-cf62-4386-a190-51cc23ca4b78","members":["df4460b4-7c1c-49af-be67-024ef6ef060f"]},{"cluster_id":"eb435255-a9dd-404d-b762-acfa5ea790a6","members":["855c1651-d97c-4cd5-b2de-b8ca61f51f95"]},{"cluster_id":"8bade7cf-2f71-4a8c-ac8b-47b2764dd430","members":["6d616443-0575-4ec5-a830-05487037412b"]},{"cluster_id":"c981e733-ddfe-483b-a14f-615fd62cec72","members":["e0d555cc-8363-4331-aa93-dc1acfeeb692"]},{"cluster_id":"8f5bfc0f-9b63-4126-aa4e-caf3448c019e","members":["79d5176e-9c81-4f30-8587-b5b143eec7e0"]},{"cluster_id":"819f43eb-3e2d-4107-9997-bfc9d26133c5","members":["5d1118ba-6b69-4321-84d6-7de9b1524f11"]},{"cluster_id":"17aac7a0-8d3b-4164-8981-530ac6354022","members":["ce70bb4b-4946-4e75-a10c-b774ee576e03"]},{"cluster_id":"8c3d66ea-c0e3-4dbc-a773-e3cdcd8c311c","members":["f91ac186-93e5-489b-ade1-ad29dde61184"]},{"cluster_id":"c527d2cd-0df5-4184-a0f7-17002b9cf18b","members":["34c56fa8-be6a-46c4-b26c-a4aeacac5d2e"]},{"cluster_id":"3e481577-f346-4d0d-88ef-e1132e39baa4","members":["52e91da0-9157-4d5e-a39e-0198037536bd"]},{"cluster_id":"7ba51ccd-9b62-47f9-b011-21d9bbe02ded","members":["c00d1032-387a-4c4f-b23f-57952627513c"]},{"cluster_id":"e9b589b6-86cb-4a37-aa98-5330f27ba5fb","members":["2c94bfd2-8eb8-447c-94bd-aa14100c383e"]},{"cluster_id":"d80ef34a-3b0a-4891-bbe5-d2c01cec1b04","members":["42160d7c-e28e-42d3-b0ab-b24654ac2dce"]},{"cluster_id":"7dfc83e7-a64c-4018-a3c6-9d9e19ffc362","members":["3c6bf119-017a-4c56-87dd-60c0f339121f"]},{"cluster_id":"03b5f25b-079d-4d84-920e-062e0a19a251","members":["067f96be-1ace-43fe-8105-2c02bc09f5c0"]},{"cluster_id":"1f7ec3f0-fe34-486a-a953-3da4c977430e","members":["c4b9433f-a0c8-4d6d-9ec6-609949063e9e"]},{"cluster_id":"e47c3423-cbb6-4c9a-9b29-21416d12aba7","members":["40a2e79a-1c1f-48ac-bce5-99a7074fbb0c"]},{"cluster_id":"3cd5d7a9-3268-400e-a49f-8e37d420e392","members":["fd780cf9-e0e5-430e-a0f7-1871abe13666"]},{"cluster_id":"c1036fd0-74b9-4ac8-a4d8-2710377e38ff","members":["a3bbeea1-6daf-47ac-8e8d-4efd4af5ad02"]},{"cluster_id":"3f285813-2863-43e8-b0ba-5a13b63cb515","members":["3ba59ba3-06e5-4fcc-931b-19bf4789bc2f"]},{"cluster_id":"9da22551-1ead-40c0-8c8c-078150bb5988","members":["318d5425-4331-4f32-9398-ac802757f8bf"]},{"cluster_id":"a6a74d11-2c02-4502-9449-33d6b314f672","members":["d3c7f4fe-66ff-40a3-b62a-9d9b9d2739ca"]},{"cluster_id":"600431fd-692e-4209-97b9-71af21abedf4","members":["dfb4efbb-bfbb-49c2-aab2-003dc944b974"]},{"cluster_id":"abef27a8-3e24-43c9-9823-523dd607d49a","members":["76afb1a9-c1cb-49a5-b345-61590db5cb86"]},{"cluster_id":"6cba2b8f-402d-49a5-b1eb-4024641b28c9","members":["8b1fc3f1-6e5d-4aba-947b-0a74c23dbd95"]},{"cluster_id":"8e3409aa-fad3-40ba-9376-e395c709886e","members":["2d0e301b-eeab-47d1-8581-f4fd7ae239e4"]},{"cluster_id":"401a2d7b-5531-4488-bec8-d0c22a8122a3","members":["87aebf1a-2e8e-405f-924a-4588468d03be"]},{"cluster_id":"87e137e4-5f92-4e98-b206-3abd53542c67","members":["47150385-ade3-432b-967e-9c1960df5be8"]},{"cluster_id":"f16b94fa-630f-4218-860c-391c021de7f5","members":["6ee4125e-714c-4b39-a047-f03ce6530dd8"]},{"cluster_id":"800ccc5c-7e0c-49e0-a72a-3cfe964493e5","members":["d4e1806a-1fa2-48fb-acb4-72f8364c744d"]},{"cluster_id":"4bc67839-1a76-467a-8232-39c9eb846df7","members":["611aa0d7-ac04-4701-aa64-cb64aaeee9c3"]},{"cluster_id":"4cb50541-3268-48df-a49c-2b4593404e93","members":["2c3a20fa-8de4-435e-86cc-ce4eceb9327f"]},{"cluster_id":"86cb3ea2-a54e-4579-b9f8-fb1dc6c8c598","members":["834c4a1d-d053-4003-9d3f-eec1ea5562f0"]},{"cluster_id":"afa6f32e-961f-4c79-a6ff-7629b5b32022","members":["20037b8d-86d1-4760-a95b-9cc30382fe98"]},{"cluster_id":"65b2891f-5d2c-4752-ad93-3b8790a22071","members":["3d8d34c5-ddad-4bcd-bff9-af8c13886dcc"]},{"cluster_id":"95421986-cc6a-44ab-acd6-4d39bccc24ca","members":["6f8de6bf-7ebb-4122-91c9-32fceaad5497"]},{"cluster_id":"eb0d5379-1fcc-4fd5-a65b-238e9b2fe3a4","members":["cd397027-fc2b-434a-be79-66a8dd895ed3"]},{"cluster_id":"9611a4d5-e21a-4cd6-bbeb-709b60bd7dc1","members":["c32cfa0a-5731-42eb-9405-49aa1ae6fb3e"]},{"cluster_id":"4bbf6020-dd21-405a-9c26-bdeb387928db","members":["204cfb3e-51d0-4c06-9b34-b7f9f5bb562f"]},{"cluster_id":"2779687f-bfe0-419a-be7d-20cd79002462","members":["ff78ec41-dc42-40e6-a051-567be1db134e"]},{"cluster_id":"f9711d2c-1b60-4175-97f9-55453cace8aa","members":["bf818f5b-90da-4582-85fb-19fc52a635cb"]},{"cluster_id":"6f13f345-1f63-46f8-86e1-7e1ec801fbcc","members":["14b273fe-7ada-41c4-be2e-e5e07b0f1e57"]},{"cluster_id":"e0993394-090d-4043-91c6-3b265e1bac79","members":["d915c3ed-2ef6-414a-88a6-e1bbbcf055d2"]},{"cluster_id":"6d63d484-2e34-41a3-8d3d-7c1693933482","members":["8df2d92d-4658-40ec-bde9-6f8142269924"]},{"cluster_id":"827901e2-9d83-4ed3-ac71-af38455fbc22","members":["fb31651d-30f2-4a99-b469-e59003f53a8a"]},{"cluster_id":"cf554d67-1528-4e54-be08-db5967f3793c","members":["39333550-34d4-4ce2-a36a-2c97e736d53c"]},{"cluster_id":"85060527-feb7-4312-ad1a-ebd52c170e8b","members":["700992d8-f1e0-497c-acbe-78b9492d07b9"]},{"cluster_id":"127eab3b-6cf7-495a-80f3-a2735d4d1bcc","members":["9ca4877e-5f87-49b8-9445-275bce494d17"]},{"cluster_id":"10e8efce-e96d-4c64-a187-c3669a9d303c","members":["ce966e10-c2bd-47c0-9418-9e74ef39232a"]},{"cluster_id":"5379b888-9bc6-45e3-b445-a1f1b5983b84","members":["c315885c-f36f-4cb3-99a0-25ec60dfcd60"]},{"cluster_id":"a5494931-511f-4aa7-86a3-f3bae4df958e","members":["25d666ca-7aed-47ca-a084-6bd9ce2c8274"]},{"cluster_id":"d8d70374-6442-49f6-9ba4-aa78644e8a39","members":["0a737724-a683-4c0f-9a7c-ab1a2bd3b414"]},{"cluster_id":"7f0d4bc0-739c-4027-939f-98e2607340fa","members":["adcc03bd-1444-4f94-9c3a-79f6971eaabd"]},{"cluster_id":"c679edbc-b9a4-4c17-b40e-4029662513e4","members":["21b41621-8ee2-479f-8e02-e12c53da180f"]},{"cluster_id":"b3562e1f-34d6-4a29-b778-8824a2d004a7","members":["06771dc0-9d5e-45d4-88a8-d3ab9f85d2f3"]},{"cluster_id":"015317d7-08c9-4925-98a2-39e2a1fa7c6d","members":["73c8b15d-1231-42da-a241-422b5c1fb69b"]},{"cluster_id":"3aad1795-c40d-46c7-abc6-a9e8928bc743","members":["4a4e224e-7a32-4905-aa82-ff4c93672219"]},{"cluster_id":"45d7d6d0-989e-40f5-9e35-4f603b15d08b","members":["361e2400-514c-4d1c-8260-a9666a5a4248","8293ff46-9e9c-4729-be96-eb147e98babc"]},{"cluster_id":"49883883-56ad-4f95-b0d0-b90bb6b04064","members":["c3bd5dcd-4149-4477-a659-7bb5246d1bb5"]},{"cluster_id":"b695ff3b-957e-42cc-9bb5-c2dd8be994ea","members":["83473979-fb4b-4337-b7c1-cdf92eb9f099"]},{"cluster_id":"1b496ec2-f55a-4ab3-bead-1b1953daed07","members":["19e439e9-e941-45d9-97d4-3d80f61e6139"]},{"cluster_id":"c0200e7e-79d5-48fa-9957-b064b35b368f","members":["1e0aa012-871a-47c6-b3de-310a4b27a131"]},{"cluster_id":"6ca62e87-83be-4fb7-8924-3312fe9948b1","members":["08b338d4-ba23-461e-acd0-3aeb175af22a"]},{"cluster_id":"15c0ca40-4379-4a6f-82b3-46b365d5b8de","members":["6473f1aa-081b-466b-b4fd-20d81d1581a2"]},{"cluster_id":"bb5356e7-f071-485f-8695-919ba1db8606","members":["ff3e0441-f529-4a70-9757-06710b824691"]},{"cluster_id":"0893d96a-c001-4046-ba27-939b9e1f52d5","members":["6c9a434b-1457-47b6-9dcc-1c75e4861937"]},{"cluster_id":"d2828cf5-cc91-4e95-82bf-be47e19b88ee","members":["7907d9ef-600b-4c2d-a3be-9c4a176cd7be"]},{"cluster_id":"9eb9a341-e59f-4fbf-b178-ccb6bb25eb49","members":["40f63a23-9a81-4612-a7c6-663a75472a70"]},{"cluster_id":"c36b66d4-db22-4344-899e-be0f938cf47b","members":["33409e40-fa92-45b1-91e9-7281a7f9b3fd"]},{"cluster_id":"4c81571d-8516-4f35-b047-353d1a6e0a6a","members":["1e2ed96f-4bfd-4a09-b9fb-c73047552ac0"]},{"cluster_id":"0ebe4f88-dbfe-4a7c-a8eb-80bb48625a38","members":["51cada5f-bae0-4fe4-82f2-f424c9951e82"]},{"cluster_id":"659e57e4-8954-498d-b047-7eb33a601210","members":["517eda25-9e4e-4744-afea-9ec93d143de1"]},{"cluster_id":"3d7cf308-ff2c-4ac9-a835-6773cc669257","members":["5d5f34ae-5d42-4d04-8dbc-2d17a2182cd3"]},{"cluster_id":"00682147-64d4-4c37-88ac-2b9c31d6d40d","members":["c7bcd41b-1225-4ee5-a3f4-e24ba2264600"]},{"cluster_id":"c545f601-c30b-46cc-a181-949b8540bd95","members":["46f0ed0e-6f42-49fb-bf9e-93ca1af2fdcf"]},{"cluster_id":"ec93d3e9-0b7e-4779-b3cc-e888f246dd46","members":["0b34a825-fd9a-4fc3-881e-05b84a59c7a6"]},{"cluster_id":"a5e2f736-5d7e-4b45-8724-dcdb3a0aecd0","members":["b2b60d66-d76d-450f-8e69-1ca976ccda79"]},{"cluster_id":"57759056-0fd7-4dee-8b4f-b560736eb4f0","members":["efcf46a1-61b7-4d0b-a5aa-5529bf29d0d3"]},{"cluster_id":"b0157510-fe3e-44ad-a8a9-aabc1bfb9c12","members":["b91d7bec-96a9-4d94-bdc2-5ed4eb968349"]},{"cluster_id":"cb16ac50-aed8-4a03-a5d3-3ad483937d48","members":["f6d5650a-6b0a-4043-9a6b-7eabb6c7a150"]},{"cluster_id":"5e11f88d-24a6-418c-854d-c6d0fb898c80","members":["38f1cf54-5ad5-4c49-8a3d-e93657b103ee"]},{"cluster_id":"04e4f581-e2f4-41e4-90d7-172e50ff3c74","members":["3e5f3975-3edc-4cd0-a670-f2c1840c66e6"]},{"cluster_id":"29696d33-676a-411b-9f2f-5aad8a647ed0","members":["9893fde8-e5de-4296-b569-f392ddf5393a","ae271609-4fdd-400d-8f29-7e52383382a3"]},{"cluster_id":"d30fd077-478d-4784-a1a9-ce89125fa303","members":["f17fe3ad-a3a7-4472-b37d-5ca020d6ec9f","5c9bb56b-5a52-4110-9391-2fa563a25ec0","5ab7b0d3-7047-4c61-accb-d237cbfddb63"]},{"cluster_id":"771d6319-42e1-412d-8b6c-733124c3c173","members":["676facc8-78a8-42f4-a283-637f67e1fb55"]},{"cluster_id":"b523b8ba-6f7b-4630-8308-edf6d80a7a18","members":["5ad082db-f23f-46fd-b81a-fefc0f9075bb"]},{"cluster_id":"ad3d7029-44b1-4600-b68e-2dca24cb3b72","members":["e93e1943-e0ab-4308-b6d5-77afb1fb7c94"]},{"cluster_id":"e4b34178-e71f-4443-adb8-d0d805a5c827","members":["dbc8a9c3-8baa-41ca-badc-d94ab83818c3"]},{"cluster_id":"89769c6a-9183-49cc-94f1-4adf24a43953","members":["92a4a455-c203-458c-9cc2-0914b6b1bb7b"]},{"cluster_id":"a4e389ba-b81a-45e6-ab4f-901841ef5d44","members":["ebce9aef-82f3-4955-bb2b-a9c93b3f84f0"]},{"cluster_id":"b6b9e4e5-62b3-48a5-a508-9b40663b3e4f","members":["22021f3b-e8a1-4ebd-828a-825c45610f81"]},{"cluster_id":"7c3d2190-bdc7-4187-b1eb-1c6bf0944191","members":["4420e0a2-5ba0-4a0d-a7d9-826e094acd08"]},{"cluster_id":"adb1b0be-f075-4e0a-9c6e-397dd0fde17c","members":["b737f51d-eda6-4784-92cf-3ef5948a13fe"]},{"cluster_id":"0d8c9f9c-0b32-4507-8989-0e2529da4ed4","members":["a829fdc9-636d-4a65-9100-e6491e27a82b"]},{"cluster_id":"6c980521-41af-4980-91ad-a696c286064c","members":["d3a0d501-6436-496b-99a9-51ec76f653d4"]},{"cluster_id":"efe0fef4-f04e-4e85-bb20-f40d0e8f6c06","members":["1a242b20-5120-4ab9-a68a-4591c9689eea"]},{"cluster_id":"4a203e5c-111c-4719-91b2-5d364d288743","members":["8c0cbb84-db13-44d4-b4cc-9904138a88e0"]},{"cluster_id":"35f8d4db-40b2-4a70-ae12-49bc429a73a4","members":["50ba63ef-9d11-4bda-8ad8-fcc3de82fc84"]},{"cluster_id":"f81575fe-bf60-4052-8196-fa9040141b06","members":["c9647f6c-c432-434e-851c-eacfa8ab85bd"]},{"cluster_id":"5008f252-8b6e-4832-ae6f-1940fe20e4de","members":["a1c06e67-80d5-4d8f-b0cd-8d383af5b2b5"]},{"cluster_id":"c53a9c23-c3a5-4b85-9f93-40e51b50505c","members":["54f58f01-a70b-4df4-806c-2e9b85fcfb74"]},{"cluster_id":"1b56d151-49c8-4483-a185-2c0622a64692","members":["e462c37e-791b-4cc3-8ff0-c39070b5a7a5"]},{"cluster_id":"442c0a4f-c382-4b95-be13-3c18f2d71210","members":["b797a527-44cf-4f53-99fe-1099c00679dd"]},{"cluster_id":"eac07e3f-8adb-430d-96eb-dece778680b6","members":["a7284336-7028-4863-afb0-b32f48dc2e87"]},{"cluster_id":"0bc010ee-21eb-4a56-88df-bd3b94b15999","members":["4e12fd61-0875-4354-bb83-d269570c8eca"]},{"cluster_id":"5dc9068d-5bdc-499d-a865-8dc21a274dc1","members":["26ef7b8d-385d-40b7-9fce-5868078df2c9"]},{"cluster_id":"a99e560b-cb11-48f1-ac8e-d85b9a82ba77","members":["8f20a6e9-2f1a-4b15-8d4c-21f4a02dbd58"]},{"cluster_id":"19c1333f-bc11-4412-9e3b-c195d71596c2","members":["724bd55a-d073-4ffa-b8b1-841148e20041"]},{"cluster_id":"4d88384e-f212-4bd5-8d08-7d715e173b10","members":["4d8bbb1a-ffb1-40fc-969d-adc93352a468"]},{"cluster_id":"d436d0a6-3e58-4bd3-a6ad-0b596176235b","members":["67ff1894-21a6-4d09-9475-13c85ccf61b3"]},{"cluster_id":"4e34cec9-0108-4167-8bfb-d0fceb099fab","members":["2ad67026-a0ab-4011-8924-4046e01e566d"]},{"cluster_id":"88bd5511-0bcd-4336-b0a1-fbafb00aadc9","members":["9ab622b4-abc7-402f-8d7d-9684c2d41515"]},{"cluster_id":"06370214-3027-49a1-988e-c5188868372e","members":["7b0520cd-ad41-461a-825b-0352b225d3f1"]},{"cluster_id":"ab1bcfd5-bef2-4f73-aff0-790c6f681ce4","members":["87c456ee-ec34-4960-9903-f674eb55b2dd"]},{"cluster_id":"a258e4b2-c3eb-4705-92c4-2f0c1074629b","members":["3736a909-47e1-4153-aad9-9a216d168057"]},{"cluster_id":"29244a34-6c97-4370-9081-3f30eca9f0d9","members":["88b1fcd6-9e80-4dcd-b0c6-ddb5f0357550"]},{"cluster_id":"0486b789-e813-4404-9c89-b8c77f623251","members":["e36a25eb-ee71-4fe7-bbb6-c314b63dce60"]},{"cluster_id":"0e12a592-3820-4db2-a037-30590707df57","members":["4d677b41-732f-4ee1-97b7-4fd5ff8d1409"]},{"cluster_id":"485753eb-23f4-446f-a237-3a4fc59f9bd1","members":["3c187607-d8ec-4e0c-b353-44a07b79e282"]},{"cluster_id":"f75aca31-160c-495b-9583-b8cf66c2600b","members":["18124d06-13fc-41ab-b44c-aff8ae32b196"]},{"cluster_id":"31add754-e383-4634-98fa-f95a97ec4597","members":["fc0a4120-9ec2-4f77-9fbd-876df65975ca"]},{"cluster_id":"7dbbaf50-ba32-48e6-b203-1b81e86a3004","members":["c15512f2-a7aa-4a3c-ad09-aafeb17b3e5d"]},{"cluster_id":"ecc3ed38-6dd1-41d0-88a5-4aaeb65a608e","members":["f68f6bb0-ee84-44a6-bdfc-0335f50b7637"]},{"cluster_id":"87f98626-d2f4-4a84-8a1b-fba4417798d7","members":["46bf3e69-919b-40f6-8cbc-94bc7df26704"]},{"cluster_id":"d98e592a-9240-4307-b377-0c2f380a6db0","members":["9bd4b6f8-ff03-4cb7-8027-a6405d7799a2"]},{"cluster_id":"14b70932-c015-4ead-b1a7-d8a04640aacd","members":["e8d62282-e799-457d-896f-e8a708cc67e0"]},{"cluster_id":"6289781a-230a-4b8d-94dc-f3adadc4495d","members":["a612c80c-c96a-45df-8b65-d85878b6f8a7"]},{"cluster_id":"2ba9fcc4-8317-4968-94d5-129020e8a44a","members":["6c31bc58-e503-4860-8034-c01e5c6ee690"]},{"cluster_id":"b27be68c-0a41-440c-9295-b88b093fc572","members":["2895342f-dae4-4f6e-9d54-238a2df36de7"]},{"cluster_id":"e2805f19-13f7-489e-ba06-5921751ad393","members":["3bec23f6-94db-46ae-8550-11141e250027"]},{"cluster_id":"23f70c38-36fb-46d7-8b29-eb7e9349960a","members":["37f83a32-8b11-40e4-af50-a6b2b88b897a"]},{"cluster_id":"f2c3cbb3-1d32-4569-9d6e-97148e1d73ef","members":["6166d4af-6445-4c33-9d67-85848cce52d7","223cd831-e143-4a96-899b-7fcab8bf14d4"]},{"cluster_id":"fe288be5-fdf6-4f12-bacd-523a94599a41","members":["01d0a6eb-2389-4849-88bb-8383c30c2816"]},{"cluster_id":"e2995c43-c086-47bc-aceb-1e2374b7e24a","members":["2e3c1bd7-8fc2-4221-8481-354fa715b7da"]},{"cluster_id":"da0d09cf-ea98-4fb9-b2a8-2ae9009e9f87","members":["f7f6b47c-67d2-439a-8a91-067f81c1f7ab"]},{"cluster_id":"1502dc4e-242e-4ce0-baf9-c0d4847d8993","members":["acac592c-0100-4856-ab1a-6b5fa03c2da3"]},{"cluster_id":"287c467e-feff-43ca-835b-d713c03d0418","members":["f7118670-bd48-4f56-8ea1-c88cb4a94303"]},{"cluster_id":"096792cf-02d2-44be-b8c2-c02b17ea6cb5","members":["fd29e551-2e30-484a-b54c-d91f7965b7ab"]},{"cluster_id":"28aa9b69-c31d-45de-bec6-3308b64b4f24","members":["67c88f53-54c2-4254-b8d0-28b7099f2ccc"]},{"cluster_id":"8610e15b-1046-4caf-b039-527168f31d6b","members":["da8b48ab-8103-48a8-8c27-32fde9d744b2"]},{"cluster_id":"49c4c056-d70c-4a38-9178-06a4f74c1135","members":["8ce2a5c8-0192-4588-b3b2-c420565968e7"]},{"cluster_id":"632f52ad-dbbd-4d7f-af13-93bbeaa37163","members":["72efba2e-b5b1-4ef0-b026-c1fc2e9523f9"]},{"cluster_id":"51ab1b42-afd5-4a90-95d0-c298f52dc502","members":["f29db90f-23cf-400e-b67c-67dd1d817384"]},{"cluster_id":"fe8daec7-d83a-4b36-9a29-fc5d4f9d4d89","members":["e95427a2-7836-413a-837c-230666204f49"]},{"cluster_id":"a52cd2df-a03c-40f8-a7af-c56d32311c99","members":["0cf6ea75-0326-4e12-97dd-53c68752285e"]},{"cluster_id":"ea812d6b-ff93-45c5-87c2-85077592798a","members":["572faeb1-54e1-462a-ab9b-edf623e98835"]},{"cluster_id":"a8c2e9f8-294b-4cdb-94e4-c3571edcab24","members":["f5f3f9d2-90dd-45c8-8b2f-ad00adb4be15"]},{"cluster_id":"b2d9b3c8-468a-4cb2-9381-64f806a79262","members":["7f522407-69d4-43cb-9599-99774ba97f2b"]},{"cluster_id":"2e8ade9c-f86a-44fa-88a9-a501aee7cc66","members":["0d034d8a-bd04-4ca0-ace9-77618955193f"]},{"cluster_id":"3b497918-2e09-478b-9716-2fc578f66b62","members":["5bd7e56b-cfe3-4a99-85b8-77854e9b9c25"]},{"cluster_id":"28a15364-02e7-4073-a1fc-8cee3087565d","members":["334fa8a2-6915-4ff0-a436-a94597df2493"]},{"cluster_id":"63ec2628-3b3a-4ba2-959d-d95266568ef5","members":["d421ea1b-32a9-4feb-82ce-44107a8ad25e"]},{"cluster_id":"81d920c9-ff43-42e8-a37f-0d453a42e2ad","members":["d4ac1d8a-babe-4df9-af15-5ac40c38b671"]},{"cluster_id":"f9647705-1fb0-4b23-8449-1d162afd7139","members":["ecd51516-8d6e-437d-b3e0-afcf936bd01c"]},{"cluster_id":"3777e13c-2b9f-4604-9213-bea685bd3add","members":["81ba9461-c241-4cff-88a5-330b7e9dcaab"]},{"cluster_id":"2bacbc25-5943-4519-8b3a-2027cce6b51b","members":["c02d1d63-2738-4342-b60c-5a5eafdb00d1"]},{"cluster_id":"2598e9eb-952c-4ac9-abb5-957f4bef45b1","members":["b978ef97-67af-4411-923d-63aa7bdd03a2"]},{"cluster_id":"856b24f4-0a37-4fe1-9808-5b1d1715aafd","members":["050c1ca7-e45b-4239-9217-51063d96f085"]},{"cluster_id":"6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8","members":["9098c091-26df-4f1c-a647-9a4f2b23fc7a"]},{"cluster_id":"3594d516-c429-465e-9ac8-b4d9801acd0d","members":["4b1c18ef-7469-4c08-acae-8c60b14de0d2"]},{"cluster_id":"31f4be33-7681-4d97-9d26-1b6c02b644ca","members":["33c7db4b-04dc-46e0-b03d-7f922a10de7a"]},{"cluster_id":"b5f42c7a-e41e-420e-9b45-a7f2790588b6","members":["d57ad4ba-c8d9-40a2-b26f-8c7201cf2b36"]},{"cluster_id":"1e37f73d-f086-437d-9d39-f33d1960b443","members":["5b58fb64-63d2-40e2-9f6f-e1a1fa007055"]},{"cluster_id":"6ce0f5a3-c20c-456e-bcaf-26fa7ed36c33","members":["5cb96c94-bbc2-4897-9e21-1b262e0d5d81"]},{"cluster_id":"243170bd-2119-4d61-9620-baad736b6d51","members":["10698ce2-70ce-40d7-9582-9301a7996d89"]},{"cluster_id":"5eed6894-bd6e-4276-a4e0-693ad381c55c","members":["61c08dbf-7678-4cb8-a05d-7fb8581db29e"]},{"cluster_id":"f8140231-b4f8-4a5a-801c-39c992ba46a9","members":["0080375e-d066-4489-a76b-8aca7c644953"]},{"cluster_id":"69dda1ad-6a94-49a1-b2c4-c261984302cc","members":["3957f02b-d075-40ed-b8ee-c6ba3e8e07ea"]},{"cluster_id":"876dc47c-c65a-4a65-a882-eeeb837080aa","members":["38787658-27c6-48e3-b543-52185e73d5b2"]},{"cluster_id":"6c7b148b-0647-4c2a-ac9a-6341501bc035","members":["2bd04379-926c-48bf-b44a-4c266364137c"]},{"cluster_id":"d7ed508d-e43b-4e54-a0c0-6807c3338527","members":["8f64b154-1dec-4fb3-93ae-2e71705ff1f3"]},{"cluster_id":"f2d1742c-c9b1-44f7-a4e6-abf20a37a569","members":["2edbd701-a7b0-43d0-b5f1-5f7fe48fd1b3"]},{"cluster_id":"4a7affe3-fd43-41f4-8713-3066830d90f8","members":["bf9bf087-ec2e-4039-8d2e-b944f501ebb9"]},{"cluster_id":"717d4990-dc27-4922-b8a1-6a5e44493918","members":["3505d0a2-95b7-4974-900f-c320bbd8404c"]},{"cluster_id":"926c487a-2b3f-41e8-acd8-d984df721c84","members":["44feb689-57ae-46a8-8a01-c7747c8a0790","66746a10-66dc-404c-865a-e4f7f83380a1"]},{"cluster_id":"a0d0eaf1-4a40-484e-a752-fdb85cffa308","members":["d7317c6e-3db4-424b-90d9-b9b5753564c8"]},{"cluster_id":"c0afded3-b33f-49c5-9160-e59e42832c59","members":["31222d1f-99d2-4a04-b6e1-26030ffb0631"]},{"cluster_id":"10224329-dea4-42e7-8db6-693c6ba2c28f","members":["20a98e83-e847-4d32-aac4-5e9a640056d8"]},{"cluster_id":"e9b17550-2314-4f27-8f49-a28182e8193b","members":["d269abae-bf72-4f74-b43e-47c8f5a5f577"]},{"cluster_id":"ca872018-66c6-4a52-8d9c-e664e0716e90","members":["28215652-fb49-4234-8a5b-10f2884a8360"]},{"cluster_id":"938b5cdb-cc92-4431-8b11-03447ecda24f","members":["41b8d60b-18d2-40ac-b418-d4da3f42762a"]},{"cluster_id":"2a893b9d-8c8b-4435-a26b-4a75f061537a","members":["a9cb4bb3-35f2-4375-b14a-963d4da29cdb"]},{"cluster_id":"c6dfc604-6d8c-4b88-816b-1b53975cd28d","members":["6204c9c3-9b99-41ef-a2c1-32347b6acbac"]},{"cluster_id":"f643a51f-99d3-4180-8b6e-ad534e8f3dbe","members":["50a966b8-6689-49b7-ba48-7faa14b1eaf2"]},{"cluster_id":"dba7c6a5-c30c-4cba-8cd3-01cb02220cb4","members":["eb9fe205-5422-4321-96e2-10a79f80e6e7"]},{"cluster_id":"6658a062-982d-4300-bd7b-0596611a3512","members":["d16e0eb9-872d-49bb-a544-0446fe86d911"]},{"cluster_id":"7222826f-77d1-45bf-82db-ad09c33129da","members":["c28026e9-686f-428a-a038-32f0dd36e3db"]},{"cluster_id":"4a281b46-5b6c-4de0-b8bf-1d3cec2f1919","members":["664ccdb3-f880-4f25-8241-1dfeeab33b2b"]},{"cluster_id":"291420ab-2571-4d49-863c-5554d504b9b7","members":["fc17a088-7b0d-4e61-b22a-7477b644e094"]},{"cluster_id":"b4a2abb1-9a33-4e4b-a995-84324638b8d0","members":["bc617bf4-3191-4904-9fc7-0654c50e2050"]},{"cluster_id":"6d147aa6-716b-44eb-8f82-ac64993f2df1","members":["dc0b3b2f-1dad-4729-ac7e-4c2d9044f6e8"]},{"cluster_id":"5243db0f-4bbb-47bb-9e93-e78de6804d5c","members":["3ae7ca99-f464-4299-8753-7a424e968ede"]},{"cluster_id":"02b6e00f-ac14-433e-bf3b-9d12b116fbc4","members":["675e5392-530d-449b-bb1e-4d7a3588db91"]},{"cluster_id":"6c709b7a-7374-4394-a975-41a7ad1dae38","members":["50b2647b-0332-4461-8a09-dea8dec0abd1"]},{"cluster_id":"7b565f36-8167-44ac-aea6-3371642da65f","members":["5583efb3-aa8e-4df3-858f-b8534029d887"]},{"cluster_id":"7deb6d52-1ec6-4691-a2b6-0e60470c80a3","members":["00d26f90-76bd-40ab-85fc-34766755bd4c"]},{"cluster_id":"506ae2d6-92b1-4fbe-9d47-e321f93374d4","members":["6f5f9441-b84d-4d52-a65c-4867888ea635"]},{"cluster_id":"a335ca71-7c72-419b-8877-46ce4e71837d","members":["3bfa73f9-4f36-4feb-8c73-b26d1c8763e2"]},{"cluster_id":"9da8623f-1bd2-4a8e-be97-3ec68da5904b","members":["6c403599-3e86-4bff-9361-055b9602ab30"]},{"cluster_id":"8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf","members":["a12e33a5-60d5-4e0a-b96d-1234e7e986c3"]},{"cluster_id":"f1b261ff-b08d-4eda-9ef1-3dbeca804b57","members":["4fe95fda-824f-4b32-b19b-ea9e2df97086","d387c4db-da26-4fe9-ba04-508b28a19630"]},{"cluster_id":"73d00199-db31-4e40-9741-09d6ba45a825","members":["3553acbd-cb2f-423e-93dc-1bb0a1ff29ab"]},{"cluster_id":"ab143717-868d-4925-a6b6-6698ea0e9c74","members":["3d4f3856-5b2b-4ed4-a0f1-107b2258779e"]},{"cluster_id":"33942929-a46c-44b5-a491-297910f07b91","members":["e2ca9fca-e873-40f4-955e-4071550bf90b"]},{"cluster_id":"3f3bad08-f439-4b69-b562-c041c5e9279a","members":["d00f54ac-0e00-4021-9101-2d50a9e18898"]},{"cluster_id":"a9a77b18-5285-4973-8fbb-79f6651b38ea","members":["c0e1ea34-6e44-45af-8687-a6f6e0fdddbe"]},{"cluster_id":"5e785b56-6a28-4603-b028-fed3f12f5778","members":["7d6c1f51-a4aa-43b3-9db4-b7d6d51b4546"]},{"cluster_id":"babe889e-ec1c-438e-aff1-7ca2b0c30aa9","members":["cbc26084-c1da-48e0-83d5-389ba8f80250"]},{"cluster_id":"e7545678-2204-4c5b-ba0d-fefcb6897378","members":["4e423bb5-cd06-447a-bbfc-080811c6884c"]},{"cluster_id":"7534b1ef-c71f-474a-a574-a2a3d535cd1b","members":["b16669f8-d75b-408a-9f4d-5bcb56342fa8"]},{"cluster_id":"dddeb5a3-e00c-4234-b929-096fb52ccab4","members":["f37e84b5-e2d0-451c-8b32-7caaa0838264"]},{"cluster_id":"e0c47150-6ad9-45b1-bceb-7ca3ac1805f1","members":["78a2eb57-fcd6-403f-8a54-0bb0e05d9bba"]},{"cluster_id":"1288dccd-1b4b-44a8-94be-08411cd2073d","members":["f7826dad-e7a6-4fe2-b275-f7114d3cd458"]},{"cluster_id":"bf8826dc-7456-4789-a5d3-9f4e1ba1b8de","members":["629934f2-0d32-4a19-ac35-ea10dca79eb2"]},{"cluster_id":"9d264f30-800f-42b2-9098-6bb3eb170aa6","members":["a395c8b7-47b0-45a7-ad81-e26fe1c05a14"]},{"cluster_id":"263a8eb3-52c7-4ff6-ae64-6807df428530","members":["73d4fa9f-7af5-42a7-81b7-86eea7bb227f"]},{"cluster_id":"731fbc17-b401-45f0-a173-ab4385d11eac","members":["a26e093a-2f0c-4a23-9373-f39313864c41"]},{"cluster_id":"e2349307-7610-418e-8e9d-d6184ecce651","members":["4c9cb6bf-730f-49fd-b0c7-590cf16349d1"]},{"cluster_id":"6f5bbb87-6b1b-44e1-b1a8-1e74525f3d78","members":["7a212531-6953-4bb9-856f-9b6e406a2de8"]},{"cluster_id":"b95182bc-1bb5-417c-822b-57af63faceac","members":["7659754a-1b7b-4a35-b4e4-4cc2050a0494"]},{"cluster_id":"eeba7376-7fac-451b-96dc-72a9f7c32f92","members":["5768ff86-d67b-4a05-937e-a4fb8d057587"]},{"cluster_id":"6c18a3ce-fe35-45a7-99c1-4b725342cc8f","members":["b7924395-6b9e-4846-a1b2-f40333373ccd"]},{"cluster_id":"2490af01-fba6-4168-9f21-fb760726b38d","members":["3b2d1c54-46a2-43c7-a34b-867520be9bd0"]},{"cluster_id":"d48087d5-c16e-458f-9f3a-c0c434d8a01c","members":["eb9d6929-d087-40ce-b49f-7c5fc19430ae"]},{"cluster_id":"6d5fe755-2873-4033-93ec-3d174da34a66","members":["c3c1733c-48df-47db-b327-bfd660fd8b91"]},{"cluster_id":"d35e4c86-fef1-49fa-8134-2537759e6118","members":["5a18ff76-6adf-49dd-8a47-80a852903057"]},{"cluster_id":"48bb955f-2782-4b10-b519-1e1e1206fc7f","members":["6407b3ca-4fad-49b5-a549-1696186e016e"]},{"cluster_id":"66bbc9b1-3580-4b34-9ccc-f5983ea5120d","members":["5a8d686a-4332-4ef2-8c1e-a1e0be81eb8b"]},{"cluster_id":"465ba356-8493-40d2-9150-2a0b1fd6b413","members":["a82be8e6-3e05-488d-b48a-34ee578ebe37"]},{"cluster_id":"56c30444-c8fe-46f9-af30-b0924f71761d","members":["c1f5270f-1a6c-46c0-ad52-8959a23725f7"]},{"cluster_id":"07a40f3e-ce43-455d-8cb0-e9110e244817","members":["ae0daa7e-f26e-4939-a671-d1fc4de1b5f8"]},{"cluster_id":"28dd2f06-c107-43ce-af58-70e52ba1e785","members":["f8c3f1aa-6921-4366-b729-0b15467ffe4b"]},{"cluster_id":"14619d00-6463-4ba9-8ab1-f0816bb06540","members":["91dbc818-5745-4cc2-b15b-8de90aea2e6e"]},{"cluster_id":"689d132a-4055-4564-beb7-4778d700e367","members":["301d794c-796d-4b52-acaf-189a06c32744"]},{"cluster_id":"a29634dd-4c74-4380-8358-51cf5a9cb73c","members":["15ae6b88-98af-4f02-a2c2-f7506b75b8f0"]},{"cluster_id":"95532b75-d1c7-4667-9939-ac7ea0f83b09","members":["0f3c80b9-d33d-449e-b782-301a92767446"]},{"cluster_id":"0d24f0d8-e472-465e-a47b-526385fc7554","members":["ab3c4bac-ce55-471e-a4b1-3a5fd3e4da3a"]},{"cluster_id":"ab327c16-f48a-42a2-adc9-ef76eb93901e","members":["1e97059a-df1b-4ba0-927d-ef351d3203f1"]},{"cluster_id":"8aa22381-c7a3-4609-b694-2961fd740fc7","members":["39c3f37e-7863-4e24-b858-332a69edb7c5"]},{"cluster_id":"cb189bb7-f2fd-4426-9c9b-411ad929bddd","members":["a6ecafb3-06ef-4d15-9e90-c182ff9ac0cb"]},{"cluster_id":"5c1805d7-899d-486a-b79f-793a9703c022","members":["672cda8c-2973-45f8-975f-b039bb42d799"]},{"cluster_id":"7ce03874-cd65-4bdc-9ec5-e264566fa468","members":["f3deb717-f26d-4b0f-befb-f0a268840e2d"]},{"cluster_id":"f71ba398-a895-4de0-a397-50ea9f685ae0","members":["c27871e8-9cf0-4e55-a941-37568e929639"]},{"cluster_id":"54ac5876-c16b-4f4f-ac8b-44b5ec31d0a3","members":["b34290c9-5fc8-42cd-8ff4-b72800d5b3fc"]},{"cluster_id":"daa3efba-7375-4b5d-bf2a-6a5216d25c83","members":["519b445d-ab5a-4a25-82b4-b0946e2544b9"]},{"cluster_id":"91fe8e01-c220-435f-b390-7c4a84da3d33","members":["b2a7af7a-992d-4172-a8ed-0632c7b9ebc8"]},{"cluster_id":"30b7b8ee-8417-4cde-bc24-2f6b158ce6a0","members":["92773719-a9b2-48df-a401-3f607ad24f95"]},{"cluster_id":"fedc3a0d-9f9d-4e04-81a3-669b447f0bcb","members":["c687e1f4-812e-4156-8c81-6e868ebc55e1"]},{"cluster_id":"ce789309-8080-466e-a3b3-2975047285af","members":["93341980-21de-417e-89dd-7c82843bab90"]},{"cluster_id":"ea917d1e-f3f8-41ef-93c6-2a9bfc99aac6","members":["3303063f-dece-4c0c-874c-5f4e49c07bfa"]},{"cluster_id":"1fef267f-5c4c-4c0e-b98e-4a09e90f0341","members":["09395cf0-ef39-49f1-a6fd-04e49cd0d3c7"]},{"cluster_id":"df7272f7-c990-4a72-9f74-cce4b2e6b4b9","members":["49d175f1-d0a6-4c28-afcb-542015206488"]},{"cluster_id":"928ae685-c0c3-436a-ae8d-5a22e9f5f9eb","members":["09a6eb61-e57e-43fa-b5d1-b1d1be8aa538"]},{"cluster_id":"1e4d6697-c15f-4888-819c-dc2c8687c928","members":["9ba3b0b4-5e3d-4272-9bf5-9290053494c1"]},{"cluster_id":"eddd54f6-a534-43f3-a4ac-88a9769ba8d0","members":["60aaf762-4c84-4913-9c90-e2761a239a3c"]},{"cluster_id":"b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a","members":["3e927d59-e3bd-40df-8996-cea67027d88b"]},{"cluster_id":"6ac5b48b-0333-47a6-8d5d-318886958930","members":["500db672-9962-4d41-98c4-e78093be6282"]},{"cluster_id":"df8da41a-f9cc-4448-aae3-112ed4b0b247","members":["8b330468-0e0e-41f2-8956-e0ca20857b53"]},{"cluster_id":"6f908336-dbeb-4b80-ae57-9e0431081831","members":["7e95e9ef-ebaf-474e-a03e-601acfaf84a2"]},{"cluster_id":"0f364498-4c31-43db-a10b-2fd4536b05a1","members":["9ae89725-23f8-4591-9414-683c87ced9f3"]},{"cluster_id":"755be0e1-62e3-46db-9545-f7f494e88efd","members":["cd9cc4ee-63a4-440c-92b4-44665fd63c0e"]},{"cluster_id":"0d667a05-1c8f-4f3d-bb58-e8d67ce23069","members":["adcfccef-d8d9-41c8-b300-cf27b6144577"]},{"cluster_id":"372e4a6e-9817-40fa-807a-570a36d8b0f3","members":["0b082ee4-9471-4fb4-9665-6a11af3aa134"]},{"cluster_id":"4d8ae235-419c-4dbe-90f4-1201d0ccbf9d","members":["ca306a40-dbf8-4c16-9e6d-e65f5d4718f6"]},{"cluster_id":"43320422-2afc-457d-a5b5-902abc100632","members":["c42142ca-f5c0-47ab-b025-c6443592bce2"]},{"cluster_id":"9612bbf2-b65c-410c-9475-7ee689b849d9","members":["3b36b5d8-defd-41c3-8289-6bca2d5ab655"]},{"cluster_id":"41aaee2b-0ddb-4eee-87a5-d0d95635a46f","members":["f50f4def-0d40-4b2a-b554-6beb32d737a3","0751e686-1dba-4c04-87b2-2f60c4f1b69a"]},{"cluster_id":"c60d6252-d9ce-42b9-bf38-6fcee80b74b2","members":["60c62a8d-67f0-456f-babc-92a83004c410"]},{"cluster_id":"e1bd1fc6-e475-4d2c-871d-d09149cf8937","members":["ff1b1f16-e1f3-4645-aada-881b39125135"]},{"cluster_id":"1aacc2c6-cd51-47e7-bc26-be760d557e3c","members":["9df6a373-ef95-4532-ac3b-a1e8c83604f1"]},{"cluster_id":"23adce5a-77c2-4c07-98b6-ac6909360e17","members":["39a3616e-dad5-4fbd-ae4b-62f66f82c78e"]},{"cluster_id":"0400977a-dea9-4fe6-a6a6-61f4575e07a9","members":["4d01381b-d2ad-4d1e-a67a-51a9d99787d7"]},{"cluster_id":"24ff5666-c9a9-45c1-a6b9-bf154f310b8b","members":["42bd8f38-2fd4-41ff-b341-2b0082c32891"]},{"cluster_id":"888e25a1-a330-4c04-b43d-60fcd67cb2eb","members":["a8fe53c0-7e4e-41fc-89e1-1ad373b9e8f8"]},{"cluster_id":"4f34e75a-3485-4e52-8dc7-20e80c772c83","members":["4f983b79-5012-4e5e-b5da-900007e5a9e4"]},{"cluster_id":"c4b95ac5-8bd7-40cd-a7c2-2a05463c8dc3","members":["9feefbd2-a7c6-4721-82ad-657290b14cef"]},{"cluster_id":"fd30a023-a95b-44f7-ae05-f93dd9a3dd06","members":["f165cf0e-f915-42f3-b7e5-f67a70b9c4de"]},{"cluster_id":"32a7ec8d-3be3-4c19-8ad9-bb022a0c0c96","members":["0a57fba4-28ce-4d8a-aff2-c670b52d4d49"]},{"cluster_id":"9e8db3b9-526d-441d-81c7-ae6c80c59a34","members":["8c14d01d-d8dd-41c9-9cf7-c0401fcc6155"]},{"cluster_id":"f26edbd7-0fe4-4992-ad9b-b42b469ca47d","members":["2bac8904-52f4-4bdb-9620-f27b4151693e"]},{"cluster_id":"d47510b3-4df0-487a-a8c5-1177c915ed1b","members":["47679c3a-7bc9-4d9d-a58e-3c4745dba065"]},{"cluster_id":"320a3067-75cf-4293-9d53-8dd1f312af23","members":["29d04490-fe48-4d3e-a171-75452dcd6f93"]},{"cluster_id":"76bfb6cb-c00e-452f-b533-a19a6ee05a39","members":["902d866c-4f3c-4638-9889-9bd14c3d0372","99b7dd48-1e8a-402b-a5d1-fb3a5fb3a750"]},{"cluster_id":"4ee7469c-41d2-49f4-8462-c59869db80dd","members":["da9fdf94-cb84-42e7-b74d-f0cb8328f7e6"]},{"cluster_id":"9a404aa7-ec0d-4ed0-88e9-60d78850dee6","members":["7ff61552-88f3-4526-97b5-d9ca9ed9b4e2"]},{"cluster_id":"02eef8bd-0b3d-4ee2-ac5e-9d2a9e96e5e4","members":["83f5e6cb-29b6-429f-8190-9a156717c61f"]},{"cluster_id":"30a07eeb-43bd-4ffe-abd6-643a3e7fa413","members":["bee4552b-57d9-478e-b893-2d4a9e1fc447"]},{"cluster_id":"d9a77a4d-52c1-4a0d-b32b-684c4aa1d380","members":["cbca741d-711d-4e4d-a4ce-33ef973ede59"]},{"cluster_id":"213314ea-c0f8-4a72-832f-5b10a8bbeab5","members":["56411072-b42a-4fc6-8beb-80c750823803"]},{"cluster_id":"549c4c7b-f978-4fb0-adc2-18a978338670","members":["f4dd389c-4dcd-4760-b416-5688cb51f35f"]},{"cluster_id":"976266ce-5c9b-4a82-9062-52ac4f4dcbd6","members":["cc878b4f-d0f6-41bb-b48f-76ec35f80521"]},{"cluster_id":"75b0c0a9-3733-4700-8094-3d9376dffa97","members":["f7c95d9c-7dc5-4e18-b611-d0a7efa36313"]},{"cluster_id":"63223fc3-b9f1-47b4-9d17-af262f481c02","members":["2fc4f6cd-cdf8-48ba-9ec6-11b2f95170b3"]},{"cluster_id":"0abb1373-3acc-4d19-880c-819af07a267f","members":["48fce21f-e832-4203-ab5e-123ee6696b54"]},{"cluster_id":"9b4d29fb-4c29-4c0d-a4b1-3620ce290719","members":["17a34f6d-fb4c-4c30-974b-ae80f60a7a6c"]},{"cluster_id":"421f3ec9-adff-4513-86c4-d1e8d810a087","members":["9d757536-fecb-4608-b5ca-c5958b49de0d"]},{"cluster_id":"b4d4265f-dae0-43eb-9010-fb5c59968803","members":["5ad427b1-5567-464f-a8cf-f114afd13bab"]},{"cluster_id":"9be2ee3c-9f9c-4f35-baba-22913c8be73a","members":["b004b539-eb19-47a1-acdb-991d13d2815d"]},{"cluster_id":"bfefe16b-a245-4367-989a-c541df49bc59","members":["c8d87d2a-7e82-4a07-8f54-5c5e1f05f12a"]},{"cluster_id":"280b825c-cdaa-4737-977a-cbd99f073e0b","members":["d6de6342-d06f-4bed-a24d-eba7808ccee4"]},{"cluster_id":"e3021516-b122-4f63-8b18-ba2abaa0f893","members":["6a03b943-9d28-44b2-955d-574383777124"]},{"cluster_id":"44c9e76f-0fa5-4a17-a780-5705bb58dc3f","members":["8f870ec8-fd54-4279-a357-b36e82e50b6c"]},{"cluster_id":"203f76bb-0a3d-4ccd-8cba-09629dfeec98","members":["7b41400e-2890-44c4-b7d4-e6cf6521a629"]},{"cluster_id":"5970978a-16bb-49ab-af47-a2c975a2cb17","members":["8421a853-8511-404e-9609-fc28810cbc3a"]},{"cluster_id":"522766f6-ebcb-4a4a-8452-2b5650a5db3e","members":["c671a1bc-8a98-4e54-9d69-e4564687579d"]},{"cluster_id":"78e9a9c1-3b66-422f-8fa2-16501c3ff20e","members":["7f8fb298-3c7e-4e6e-a71c-b19879710ca2"]},{"cluster_id":"8b23f6cd-4b58-4e69-9587-6944141b8e4e","members":["ff69865f-a5f6-4dc5-af62-644a5ef74c96"]},{"cluster_id":"6b4e3603-7ed8-4a6d-b270-0425352e67bb","members":["5db9ef79-d7f2-4def-b134-502dc745d2cb"]},{"cluster_id":"7a023b40-1e52-4532-8692-d72ed2b9002b","members":["27e05cb7-cd28-4625-856d-6a9df0dac555"]},{"cluster_id":"5e9e2335-fc8c-44dd-9055-29d786472e4e","members":["a81f1365-15a1-40ca-a95b-7adf39048cba"]},{"cluster_id":"ea4d2231-ca8e-420c-8296-8d5576ce43ba","members":["bf2eeb0d-cb04-4809-9b17-e692478c342c"]},{"cluster_id":"ed0d704f-d33f-473d-9c87-1978cd551cbc","members":["c489b02f-e1f9-4731-81d8-f8063e70fa24"]},{"cluster_id":"296c5f75-cf3a-4fd3-89db-486389767949","members":["2f2601e2-dcdf-4a53-ac93-2691da00cda1"]},{"cluster_id":"97495308-ae0e-47c9-bef2-8d438cbb6ff8","members":["e4456bfe-2d43-4143-ab11-773ac7e34cd0"]},{"cluster_id":"eca77987-6ebf-478d-b553-30ae00ed1856","members":["db318a9a-5538-40ea-af8a-e1b6ab6c097b"]},{"cluster_id":"93863b1e-b8da-4bf9-893e-8c00bcaf88db","members":["ba71ae78-0568-4ae9-b7e6-5633929adfdb"]},{"cluster_id":"dc2c7323-e1d7-4179-aef0-ca2fc7077801","members":["4d52f801-b5ec-4382-89ac-56c59fd5a2ba"]},{"cluster_id":"2546e25b-7863-4f5c-b7d3-2a457e14f21b","members":["8dec6f5d-64f6-4948-93f3-d08dfdb42d2d"]},{"cluster_id":"6324da02-c8ae-4e7d-b1eb-1091e19c88ba","members":["3aea1afc-c5cf-4000-a51f-bfc4f3c546a9"]},{"cluster_id":"242e079a-1694-45b6-93b7-7c7320473a25","members":["c3385f2a-4d50-4695-b459-86268d931b4f"]},{"cluster_id":"fe93734b-6e24-497d-aea9-a8d5b75d7f64","members":["cff3fd9a-d663-4f91-806f-f5df7aab29c8"]},{"cluster_id":"9cb21d08-8a84-4302-8619-2f374e19a897","members":["0ca2b759-ed1f-4533-a743-66057166e846"]},{"cluster_id":"baac9deb-4b05-423b-be76-a9a8e41c6cea","members":["57e1aa72-bd50-44f9-ac97-2321b745e8aa"]},{"cluster_id":"f2060e6b-7cd9-444e-9e39-3784e110a3b5","members":["d81661cf-5c0b-4a2b-9276-5eef0fe647d8"]},{"cluster_id":"0d94dbde-ff2c-4ec4-88f7-65580876f8ea","members":["250d30d1-b4d0-4780-afc9-7abb6bcb33c1"]},{"cluster_id":"44b69b95-01cd-47b4-9aae-cbe7e39103ab","members":["f0b19778-b737-4355-aacb-1f94e50a3340"]},{"cluster_id":"c5ac1407-521f-4465-8124-83f30e719068","members":["44bee4a0-5e9e-468b-827e-6d1884c6397a"]},{"cluster_id":"086034d9-cc70-4cb5-b461-137099358741","members":["002f0757-9088-4dfd-8861-b023ac2bc82b"]},{"cluster_id":"b97c97e0-114f-4fea-812a-38dca08108e6","members":["80bc74d4-d262-4281-9d64-b4167293c1c5"]},{"cluster_id":"70a4982e-a051-4993-8a45-818426e08af0","members":["3d92343c-6406-4363-b6c0-f7f7774224be"]},{"cluster_id":"c42951ed-4fef-4240-bea1-d37921f9209f","members":["87526bfe-1ab6-4510-81cd-485fd8a2394a"]},{"cluster_id":"7a7dc1ab-df88-47fe-b1e9-3558ecae338f","members":["4db96af4-a2d9-4915-a235-99f285265170"]},{"cluster_id":"2d90579b-afff-4e63-bf7e-880641d4be4a","members":["0243bba8-97b4-405c-988d-c502a37eba5d"]},{"cluster_id":"d46df71d-8407-4df2-8b9c-164a3f2cc00f","members":["f7ae7a77-e251-42f3-86f0-7ed24dafaa34"]},{"cluster_id":"db2336a6-b759-4cc1-8b40-69f3eeb5bcf8","members":["c5ea45ad-3adf-499c-b7bf-7265e712f87a"]},{"cluster_id":"4c76d4e3-5632-4224-a22f-bc4b4614bcbb","members":["ac56868b-2125-4f50-b409-8de61b0026be"]},{"cluster_id":"8d63a231-4f96-4fb0-aa81-938182c806dd","members":["96d226e2-af95-4e8a-b05e-bb041137ed0b"]},{"cluster_id":"5a7cebd4-db2c-4dcc-8a5c-86e950acfb54","members":["b71bf3b1-a654-4fd7-98f6-f665993968dd"]},{"cluster_id":"1acc8146-9053-485f-9f26-6af5d30d0040","members":["578cb98d-fe9d-4880-98c9-f3933f0a0130"]},{"cluster_id":"9bdfdf22-7c63-4c9e-aaa0-b66cd67a0424","members":["83562bb3-47bc-4447-ae9a-346721e6e771"]},{"cluster_id":"5b21b1b3-5d6d-4813-8da8-9dbf1ce6934a","members":["d2001645-6b3c-4657-b183-bf1790f9f067"]},{"cluster_id":"d32f3312-d003-4447-b89b-9a6dbdae0450","members":["740023ce-6df3-4ecd-ab09-6808b207dfde"]},{"cluster_id":"540c45cf-a148-4629-8716-b1631ea44e45","members":["d350bc36-e670-40d6-aa13-eea5cced5d3f"]},{"cluster_id":"c5a76ba5-1fa2-4615-9254-21b572adf7ac","members":["e3730230-766d-47c0-925a-acd8f825e41d"]},{"cluster_id":"36133231-d5e7-4a50-b9f0-6f646f403eb7","members":["517160a7-add7-454a-ab4e-f0a0d7097b13"]},{"cluster_id":"a67a8b34-7ebc-467d-82f6-99ed35126409","members":["5e4c7a2f-bb62-40cf-9046-3afa103259ec"]},{"cluster_id":"66b7068d-b746-42ae-9f41-d88ed9a887f4","members":["e0e902a1-1b92-4d20-b99e-b6ece30315f2"]},{"cluster_id":"ade1903f-a52a-4bb6-9a56-0c62e47b69bb","members":["a40a181c-1e52-4737-91a5-0bcbf75cfd68"]},{"cluster_id":"b7624371-4e42-4625-b287-29a35994c39a","members":["52289c6e-47f6-4ffb-be6d-afc19102dfe1"]},{"cluster_id":"e0c1caae-a4c5-46c2-a58a-61bf54ce7094","members":["ae66610f-0227-4d7d-881b-f939887bbb73"]},{"cluster_id":"4d4564a4-dc41-47bf-ad98-75e34d4a1d0d","members":["22413a57-ade4-432b-b447-ae7f68c9ea9a"]},{"cluster_id":"60d688f1-af0a-4245-9b4c-47a36b4f063c","members":["d789af8a-74ca-4e8c-a53c-ce0d512a29c4"]},{"cluster_id":"a36c95c0-8daf-40fc-856f-176637a22c4c","members":["29a7891b-c4f9-490d-9ea3-14bcdcf71170"]},{"cluster_id":"e914c276-a8b7-4441-a77d-8a5108addc86","members":["95dc57e4-ace0-4992-91bf-15cb68cf161c"]},{"cluster_id":"82364b1e-49e1-409c-a0f8-eccc7c05ab76","members":["eca6695c-9485-46ba-88b1-f0b216c0df98"]},{"cluster_id":"414991c8-a3c9-4951-a5c6-7c03fe71ba09","members":["1e525167-7028-4130-a290-89c0cc1f7b00"]},{"cluster_id":"b84f23af-bd15-4231-83c8-7e4cd068a5f9","members":["4e6ae5f8-c029-4c4c-911c-2249d87b3176"]},{"cluster_id":"2a74c891-6384-471e-8d99-df457b1baa82","members":["8e44b3f6-8941-4118-9684-cee357148f2e"]},{"cluster_id":"473de348-b521-4729-af95-a1929f5cfcf4","members":["d4dd7258-46f2-4967-b8a9-c22fbc3234a6"]},{"cluster_id":"2e4d3514-9265-4850-95e7-fe8c0be93a5f","members":["5e8dfcf3-0b58-4cd5-9849-4dae8da9a114"]},{"cluster_id":"344ea9a5-7537-47d1-9d63-57fb7fadc321","members":["94cbd636-96c5-441e-8084-28d66e0a9c94"]},{"cluster_id":"b45560d5-3144-4d83-a41f-025765799050","members":["99e3cbee-8eeb-4283-b940-26f6d55860bb"]},{"cluster_id":"473550dc-4370-4fcb-8c1a-760765586a92","members":["006a0af7-5134-4b95-ba70-99a654f66320"]},{"cluster_id":"bde83207-e05b-485e-9b86-431574e6c995","members":["66fdb79c-7177-4e29-8db6-3361eb871144"]},{"cluster_id":"4a540701-996b-469b-acc0-9cc53e451ce9","members":["2b6bdc01-aa57-4c64-9a80-48854762b219"]},{"cluster_id":"580850a7-5c15-4040-b450-cddffd7f1f89","members":["f65890dc-6fc9-4d6c-bd46-ea4e94f73923"]},{"cluster_id":"ccd39f23-25f5-4e91-a253-3e3574d7d504","members":["90499542-92a5-4b43-b305-37be2a8caa3c"]},{"cluster_id":"306af663-29dc-401c-bb87-b5eb6547c25e","members":["ff5f1c6b-a058-4e94-bdb9-0a1846fd8362"]},{"cluster_id":"debb5df0-b239-4824-9667-dfdfbc4323cd","members":["fcd23f10-1869-43b2-b82a-c56c211ba8a5"]},{"cluster_id":"8b1384fb-f659-4943-948b-d2766f5d5af0","members":["4e9e4d5c-6e27-4e17-ad6e-b22d8489b781"]},{"cluster_id":"090c138f-cca2-4b65-9a79-43955026e502","members":["00258153-b0fa-4cef-b1ce-bc62bb041f10"]},{"cluster_id":"25a18cdf-150a-41da-b8d4-e997a6088c8a","members":["6ca83595-0bcb-428d-a4ec-ba254a2efbea"]},{"cluster_id":"37fbb780-673c-455c-ae4f-c83136095160","members":["e51f8b71-986d-410f-bd79-93c3e78b00f2"]},{"cluster_id":"8842f019-f536-48be-a730-88d7032d791e","members":["76508154-09da-49a0-95a1-066d078e00cd"]},{"cluster_id":"79e93acb-9f08-48c2-9984-2e0654fbc884","members":["1a261083-868b-4ca7-a6d1-1efed63eb1ca"]},{"cluster_id":"557fbe6b-8c80-48fe-945d-5c4d06e53e9a","members":["761fbe9f-4e8a-4239-83af-c6e54f45e545"]},{"cluster_id":"11415296-938e-40a3-84ae-06be10542d39","members":["2c06f34f-2f19-47ac-8693-44195e18db1c"]},{"cluster_id":"d8eb0da9-3210-4817-8cfc-d7a7f474f829","members":["21f02906-61aa-4635-89e7-dfdef2f8e32f"]},{"cluster_id":"a7e685cc-6af8-4b3d-9fec-fcb894e900d3","members":["e969df4c-6bda-4fda-8faf-8a2f53079843"]},{"cluster_id":"2dda2c1f-f0ae-49cc-b0e1-89a7a1ccbeaf","members":["bd127af5-f593-4936-8d80-4770971638b8"]},{"cluster_id":"b4d7baf4-91b3-4011-b5b5-664a10258241","members":["71c7b3ea-9646-4c99-97af-5f9ae141a87c"]},{"cluster_id":"6c2926f3-1ce9-4f60-a8e9-724e2273274d","members":["a1f58177-6ee6-403c-b59f-e0c47e72f8e5"]},{"cluster_id":"36b35892-f11e-4f98-83df-979e347100dc","members":["465139ad-b844-408e-9047-05e13f2a1617"]},{"cluster_id":"933ba991-e63b-4909-90b5-fbeb9eeea4c4","members":["b882c107-1688-4c7f-aa83-37f8179b332f"]},{"cluster_id":"50450ae6-8d18-4a4d-9adf-9937e9748bba","members":["fedf74b3-da5d-4791-bb62-b882627d82dd"]},{"cluster_id":"eb814822-d982-4fcd-a462-4fccf70598c6","members":["0fbd1e4c-5ae9-42d9-9da5-e0a879fe9a56"]},{"cluster_id":"2f03e50c-f48e-4212-9d22-0ac755bb8fe3","members":["16e3a410-61e7-4567-9254-da415cc634a2"]},{"cluster_id":"75154ca6-776f-46e4-8f4a-2221f93d7ff0","members":["d36dc697-e41c-4adc-903b-d65a6656346c"]},{"cluster_id":"1c223a5c-b5aa-49ca-99af-333b89e0351d","members":["e0403980-e461-44f1-8f2a-cf3d14ecce4d"]},{"cluster_id":"12d14e7e-4e0e-4f5f-8c1e-b4a56335bf02","members":["d350a23c-53ae-49d3-a77b-96740cdef738"]},{"cluster_id":"356f0068-5f51-4299-8ed5-ccb151ae18bd","members":["8e43ca38-477c-461c-b3bc-58e7cf786127"]},{"cluster_id":"74eb8465-812a-44ef-8d54-8544ae40c871","members":["cf666a58-2243-4a76-bb8f-1694da47cc0a"]},{"cluster_id":"74542328-97a3-4775-a89c-6406225efc20","members":["f37eb4c8-03bf-42cd-8294-6b6396362096"]},{"cluster_id":"ea5f2b05-0096-4117-a2fa-b72e433c4955","members":["2d781471-40cd-4135-ae10-5d54b0c2f161"]},{"cluster_id":"77f62262-b0e4-4158-9a7a-25a427bda979","members":["7761aa3f-02a9-44a2-925d-b948230aa424"]},{"cluster_id":"88abea30-b9d6-421a-b97f-a1fffe603d2d","members":["20935077-ae16-44a6-8f86-4b3958ab676a"]},{"cluster_id":"4ab5e1f1-d0b4-460e-98c6-70b27ad80057","members":["97fea7ed-0a59-4136-8d95-48012da6ae95"]},{"cluster_id":"0978a576-627e-40f6-a382-f39885473545","members":["ffe13c8a-2b52-4649-8da5-573147362c7f"]},{"cluster_id":"4e101b24-e99b-4526-bcbc-e5ddeec46f80","members":["db5a3cdb-61d6-4430-98a2-5ca84df09264"]},{"cluster_id":"f8ac7419-698c-4d8c-9bee-1803e1e62a78","members":["370fe09f-1815-44bc-966c-d5620e3f3523"]},{"cluster_id":"bff86a30-1fbf-4d67-9ee5-a1b9649be76d","members":["a1799f97-c47e-4195-b20b-f0ad237b2d47"]},{"cluster_id":"5dffba17-ccea-4d19-b8a2-e0d2197c568d","members":["8f6604c8-287d-433c-a86e-5fe6b1d8304e"]},{"cluster_id":"eda41dea-1eaf-4dc5-ae84-f7a6a29eea13","members":["d41a1e23-eec6-446d-b7fd-b0cfd04fc347"]},{"cluster_id":"f7be2595-331e-49c2-b3a3-087ec837250b","members":["e58137b7-32e2-47b4-97f5-63c8ce35448a"]},{"cluster_id":"15d67b19-b1ca-45ea-8cf1-55236390c45d","members":["e9e683db-688a-4ca1-aab1-a2534d2cbe9c"]},{"cluster_id":"b5f5c5e5-6c1a-4551-a786-04806a60e9b1","members":["cda9134c-6da8-4b17-8062-32c67f8575dc"]},{"cluster_id":"4018b382-2692-4cbc-af34-c3f4f61413b4","members":["ad767526-fcd8-4271-ac09-b4292b190878"]},{"cluster_id":"66406d6a-fd8e-4e61-aeac-decbaba1818b","members":["78fe29da-84f2-4baa-be8d-6fb4ff124304"]},{"cluster_id":"40ef8151-52fc-4fac-bd6f-6b5534d3b754","members":["07010ddd-e21f-403b-9593-a4541391803e"]},{"cluster_id":"b8e4cc10-e335-4506-831c-61365dc19547","members":["e0a99797-941a-4671-bf46-f0dd1bfb658a"]},{"cluster_id":"7eafb3e8-a45a-4448-82d1-c800c85a832e","members":["1fcbb4c4-7fef-4053-8120-08f9f1c2b449"]},{"cluster_id":"590acd5e-f716-496d-b821-297d8887167e","members":["2fee70ad-af03-412e-8657-43b22638b4d7"]},{"cluster_id":"b1eea9c0-c6c8-4d17-a1f4-b1ddcc163363","members":["65ee12b8-784e-47d4-94af-9f72ed77d148"]},{"cluster_id":"a9463f3d-e047-45f9-b0f1-8dca29a15e51","members":["80063df5-4134-4cc5-881d-25ed98bc202c"]},{"cluster_id":"b56f25e8-34c3-4cf5-b21e-1b0f46545150","members":["86986485-7c53-4f97-bbb4-793d8c13c40a"]},{"cluster_id":"2c62c383-cda1-4d02-9286-63fc5fe04c15","members":["6766c2ec-1ad6-43e5-8693-a08588802f0b"]},{"cluster_id":"d623d9ee-820d-4287-a726-51fa68088d0a","members":["1cb913cd-a492-42ac-9a44-2a8d1e7c426d"]},{"cluster_id":"7a9ab53b-bafd-4621-b334-948c7482958f","members":["762c8547-06dc-43a5-ab8e-4135203aea66"]},{"cluster_id":"185df82d-71c3-4fa5-ab56-a142dce4a50f","members":["b7733ee8-2287-4667-9f4f-bbc3ebf6720a"]},{"cluster_id":"2ce189ee-012a-443c-b12c-079c48f7f1a8","members":["c53e1efc-7533-4582-8a01-4b4b6992f8d3"]},{"cluster_id":"b7af27db-59d8-4e96-a280-4b5ae8db2302","members":["4b1e5b8c-8a50-4fe6-98c4-02742ea41abc"]},{"cluster_id":"ce593693-b91d-49af-acbe-d62e8f2dfd88","members":["bfd8e40a-82ea-46ae-bf57-a5bd59789ca5"]},{"cluster_id":"a25c3ac7-1dad-4c90-b412-99d2bc775053","members":["78a9b4b8-6d87-4353-93a6-aa50966bc925"]},{"cluster_id":"507a5fb7-2785-473f-8c2e-99215cff28b8","members":["74f13c59-4f5d-4cc1-a371-290153702650"]},{"cluster_id":"66095ea1-59d7-4068-855b-70fe6ff9d81b","members":["fdf37f84-dd1e-4b1b-a0b5-8a2170318090"]},{"cluster_id":"b46172e4-32c8-4e9a-a7a9-95ade2786490","members":["75ec15a9-628f-4f3c-89d3-eecc766a6421"]},{"cluster_id":"3a63a5d8-fef0-44dd-9aaa-21b0ee109283","members":["a0c42368-b067-43e0-8465-9dfd78e6852a"]},{"cluster_id":"25621853-a487-4563-8dfb-51e9404f5430","members":["ffa46cbb-e67a-4ceb-ba55-1cac0877f028"]},{"cluster_id":"81d59e77-2bcf-4755-b211-fc910c424229","members":["a6f2e0ff-430b-4750-9cff-d43cbf11e3f2"]},{"cluster_id":"357e7a15-3b62-4e9d-ab34-f83d8c925763","members":["a22287a0-316a-4bc3-8877-40c3d8842ed4"]},{"cluster_id":"f1fc4cb5-63a2-420e-a804-9502b1ff9992","members":["b3a49e5e-3812-42ea-835b-08791faac60a"]},{"cluster_id":"fd0c8abe-7ca4-4c28-8c57-cd7f45e50fde","members":["d907f214-9242-4da1-96dc-9f0bc33f61c2"]},{"cluster_id":"3e466027-ffe7-4ec1-877e-eae7c5a1c2c5","members":["4f53296c-a170-4dac-8b3c-95e6d1d09300"]},{"cluster_id":"02b14d03-5d87-4a88-8655-66e1b5dd7380","members":["88b5ff8c-32f4-4cb5-a4c2-5102fb026e29"]},{"cluster_id":"e83deec8-b564-42c6-8487-a1f4fc334b10","members":["afffbb98-7a7c-49ca-9495-deb16124338d"]},{"cluster_id":"51078797-5492-4e49-abad-e30c5a796113","members":["64a38f3a-9456-49bb-ba68-f04e3e791b42"]},{"cluster_id":"7564aa71-23fc-4383-a2a0-0245e543e0fe","members":["83509a11-3f16-4bdb-80aa-2c8c01e9e78a"]},{"cluster_id":"56b88351-b9dd-4f7a-84e1-7a2151d08fc3","members":["fb3df18f-a0a2-4ce9-8600-c2a404c590ff"]},{"cluster_id":"aa7f033a-fd05-4789-9ef5-cce771714a6b","members":["e69f59d9-bb32-4254-9600-13a67472b7d6"]},{"cluster_id":"dc760acb-b4e3-4975-bd26-80f29e06c63e","members":["3b7e99b7-3b5d-4a57-96b9-059447a7b364"]},{"cluster_id":"17e1ec75-19f3-468b-a8ac-9a834a96fe02","members":["b30a505a-f1d5-4f10-b0ab-5bb234feccb8"]},{"cluster_id":"93fda361-8597-486d-ac5b-c68926f25316","members":["bcdfb634-b57d-45e3-872b-b9f0ca36fafb"]},{"cluster_id":"7b3392aa-9600-4d0a-9098-a43e48acd086","members":["93e3db06-166b-4430-8d6e-e05b9cbfc593"]},{"cluster_id":"5219fa36-fd8a-41f9-b4a4-5e01b881c12c","members":["6d58abe6-7936-49a0-ad10-40cde093f941"]},{"cluster_id":"f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6","members":["7594a110-7e80-429d-b658-24df2a302bad"]},{"cluster_id":"ce82add7-3d2e-4c0b-8f3e-d449dd7f2ee7","members":["fd9efe20-ee65-47ea-9fe4-4e89ddd86750"]},{"cluster_id":"08e45a86-d42e-4e87-9b56-30c3cd685d1d","members":["4925b3b4-190f-4834-b9cc-c5c3b0a387cd"]},{"cluster_id":"21360818-47b1-476a-88aa-682feb18a966","members":["9d10ef81-f6a2-4e49-a199-c1555635e9d8"]},{"cluster_id":"8ef3f5ab-a5d7-4598-bbc0-95b969a66cac","members":["fa25748d-926a-44e1-8ddd-e4885b098639"]},{"cluster_id":"9afd9c54-2f8e-40e0-aff4-8479c84a56df","members":["0933da37-3475-4bcd-bbeb-bc4ec55f9176"]},{"cluster_id":"4eaf7a96-0e00-419f-b612-d0f41e00fc2d","members":["43f60add-d506-4911-8c3b-d18bfa4b5016"]},{"cluster_id":"c40cc82c-67d0-418e-9ae2-4c1dfebaaa5a","members":["1544928a-effc-4c44-a675-e0ccd8e8deed"]},{"cluster_id":"af0e1c10-c1e8-4d6e-955d-02d943d24f8d","members":["e61b3736-c4de-40d8-8d91-d554ea3d8b2d"]},{"cluster_id":"8c92c9ea-d03e-4ce1-b80a-21678d736eec","members":["d05e54c9-b82c-42fb-95bf-184ccbc4a4ed"]},{"cluster_id":"7f953e81-8c8d-4f0d-9b98-873627d95104","members":["fbeda688-b4df-4b53-a93d-d39c1dd97036"]},{"cluster_id":"821b8f2f-ed67-40fb-ac0f-fb14c5b4d7bf","members":["8cdde93c-a746-45b9-8205-898c4d500b29"]},{"cluster_id":"9651dd4d-7b1c-4486-aece-757b68331a49","members":["1d947b67-af0d-4867-8813-556d0f253bd8"]},{"cluster_id":"07db44cf-3ab0-45c7-b71b-6366e225a76c","members":["84969761-5489-4b13-af7f-07a03d61a79f"]},{"cluster_id":"2bad245e-4724-47d8-9180-69fc7c047187","members":["149ba182-0084-4f85-90d7-0f84d73ce5fb"]},{"cluster_id":"f2c109a3-30b0-4718-85b7-78d12406aef5","members":["b3395c9b-a855-4632-996a-a6880f01d05a"]},{"cluster_id":"16245af2-3fab-438a-9670-b11a52942486","members":["c9602f84-6cfc-428e-a39a-1e39f3036e63"]},{"cluster_id":"222e0df8-36ff-4110-93f1-22c42e9ea101","members":["6d93bf25-6d63-4bb6-a61c-e45006074172"]},{"cluster_id":"9da2ed03-3aa6-4daf-9488-c042585d10b9","members":["fa2b9915-d0fa-4520-ae95-970cb5f1f2be"]},{"cluster_id":"5a50b06e-be6d-445e-97b7-86a315a41b46","members":["6c40ede5-fef0-46a2-bc20-6d2a842bfe85"]},{"cluster_id":"73a3ba73-472c-4953-bc98-ef9a9d43fb52","members":["6a6ef44f-4724-4794-aed6-454d1bb76673"]},{"cluster_id":"53c60ecd-a401-4cd8-a176-63a07a0b82bf","members":["c8580ed9-0a2e-4ce0-b659-b31678de8084"]},{"cluster_id":"82a5c9f7-4f90-429a-b7a6-559b1c83bc8c","members":["ec856f56-f10f-4dbb-a15b-27af935ffb06"]},{"cluster_id":"3ce0cb1a-1f92-4f2d-a2e0-fbdd35527908","members":["ba6da7d6-7796-4008-a2b0-f496bf1d045a"]}],"cluster_links":[{"claim_cluster_id":"c55d7e50-ed13-4f98-a396-412d6e19decf","event_cluster_id":"59d52e20-3aae-46e2-90cc-c6f03ba747be"},{"claim_cluster_id":"d0dabf1a-0448-47c3-ae6f-96348eaf2cb1","event_cluster_id":"bbc9b8d3-6b58-4072-82ed-eb3aad9d21a5"},{"claim_cluster_id":"8ae7ec4c-38f4-4117-962e-b6f044038377","event_cluster_id":"c8099c76-111d-47ec-a755-9357e7d74d90"},{"claim_cluster_id":"e60065d4-ae50-40b0-8e77-8c2ad3e36235","event_cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125"},{"claim_cluster_id":"46f91c43-019b-4419-b509-a0a1e806ff37","event_cluster_id":"299d788c-3d25-4b23-8898-a2eee18a0fda"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"2ccc0520-5070-4b1d-b1b9-d9e9fc878c97"},{"claim_cluster_id":"42c5367f-fb48-41ea-b66c-1b344a5b61cf","event_cluster_id":"da696f76-5f89-4c8f-bcd4-42e52baed665"},{"claim_cluster_id":"907c652a-92b6-4282-8b7b-0e7b268d4209","event_cluster_id":"5ec58447-e517-44c1-9394-8a5cf3cacde6"},{"claim_cluster_id":"f4f13b9b-3296-4913-8eea-62ce1becaa2c","event_cluster_id":"04b0fab9-75f9-45a3-8f7f-91f5ed199dc0"},{"claim_cluster_id":"68d51d93-fcbe-411f-8a89-cb79bd347512","event_cluster_id":"00853d63-b913-4804-b64a-2b243a93e06b"},{"claim_cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","event_cluster_id":"705d1ff1-cf3d-455b-8c22-31feaaeb943f"},{"claim_cluster_id":"68ff85cf-74e5-4234-a53f-6dba1aacb444","event_cluster_id":"15c0ca40-4379-4a6f-82b3-46b365d5b8de"},{"claim_cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","event_cluster_id":"07b3b643-33f3-45b2-87a3-3626fa492cb3"},{"claim_cluster_id":"b9a17741-2ab3-4713-9777-efc674860d38","event_cluster_id":"69d7ee2c-955b-4d7c-a4fa-16491444b045"},{"claim_cluster_id":"fff4a6ed-31c6-43f6-93ef-bd50b7133298","event_cluster_id":"372e4a6e-9817-40fa-807a-570a36d8b0f3"},{"claim_cluster_id":"a1f0e0be-a8bf-4895-ad2d-4f83a0d63930","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"ac4174c2-4597-4a76-ac06-95cefda372c9","event_cluster_id":"593f987b-f53c-49a9-a836-d17fb210c211"},{"claim_cluster_id":"fd5eb376-88a6-437a-8af1-6b857c858d7f","event_cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125"},{"claim_cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","event_cluster_id":"14266895-ce35-4bb7-b24c-c5684c3a1532"},{"claim_cluster_id":"d07c5569-3547-4153-bb09-72f6d513ab57","event_cluster_id":"6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"},{"claim_cluster_id":"9d400cbf-08ea-4c02-941a-80cd2d3e517a","event_cluster_id":"0ed8b02e-9110-4797-abfa-1c73f2dafe4e"},{"claim_cluster_id":"71baf4d7-69f3-4524-9166-04fc35b4043a","event_cluster_id":"964aba3e-f62e-4ef6-b8f3-99237adf29ba"},{"claim_cluster_id":"e9c84dbc-30d1-4e60-bbc8-700057190615","event_cluster_id":"81a59b64-1e50-4ead-afee-e08c8a24c430"},{"claim_cluster_id":"e6759e4c-f697-49ce-a969-2f596e5c4293","event_cluster_id":"ff0f509e-a0f0-40cc-821a-6f046f5aa96a"},{"claim_cluster_id":"73a6792a-38f3-4e05-a1bc-e5dc764c0b4d","event_cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242"},{"claim_cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"663bc264-4933-4e53-8689-d8e35c02d013","event_cluster_id":"3ddf92d1-7fbd-4c44-857f-573095c914df"},{"claim_cluster_id":"6c53a575-96c0-4b04-a196-adb1bbc90de7","event_cluster_id":"6195dc7b-895b-4134-9995-738fed6389e2"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"},{"claim_cluster_id":"ac5cef85-9755-4d73-a0c9-3b2d779220c4","event_cluster_id":"600431fd-692e-4209-97b9-71af21abedf4"},{"claim_cluster_id":"daa86fb1-df31-4a23-a926-1b9981f8df40","event_cluster_id":"7a023b40-1e52-4532-8692-d72ed2b9002b"},{"claim_cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"2fe8d49f-63a1-4171-af68-9824e47b825c","event_cluster_id":"bec1d887-4d4c-48f4-9b0b-ebdd0a488702"},{"claim_cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","event_cluster_id":"009adb33-ebed-4470-bd79-30fe1e0fa2d8"},{"claim_cluster_id":"4effafac-8e45-4dfc-8f71-d8c9b1e37d7b","event_cluster_id":"5abfb564-f878-4ffd-9c7d-3328a283dbfe"},{"claim_cluster_id":"29c942d6-0549-4857-889a-2fc5fd4cf362","event_cluster_id":"a5aa6b9e-3e33-4b44-ab88-d54a834f3817"},{"claim_cluster_id":"493568a9-0e32-4b19-a041-15396f7c15b4","event_cluster_id":"7815f5ae-d441-4f71-b0e2-771810097e05"},{"claim_cluster_id":"b9cdce3c-8c52-4df4-89e7-a4bcf232dbef","event_cluster_id":"d9ddd310-7175-469a-9098-9a1bbbbc4809"},{"claim_cluster_id":"b433d9b9-0986-4c75-baab-f74fc73be2ca","event_cluster_id":"d748d1bd-38e3-44b3-b268-429f4615acee"},{"claim_cluster_id":"655a46a8-9b52-4f61-b528-9f18ec9bf051","event_cluster_id":"590acd5e-f716-496d-b821-297d8887167e"},{"claim_cluster_id":"738e60fd-1e3d-4820-98bf-d6bd9e7a3172","event_cluster_id":"53d925d3-b8ff-4816-9cb6-be1191e8d6ba"},{"claim_cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","event_cluster_id":"31a83c0d-3856-4e30-82d4-769416b594bd"},{"claim_cluster_id":"be9b7361-8150-4e4b-9111-bac990c11d3d","event_cluster_id":"357af95d-b02c-4002-bfc2-fdd9ff848257"},{"claim_cluster_id":"51207b82-ee2c-47cd-adf4-cdd41f93d43d","event_cluster_id":"6aece148-00ae-441a-a570-cbee981c2154"},{"claim_cluster_id":"7b0fb73a-9488-43a9-80ee-d1864bcbae49","event_cluster_id":"1ec0df43-8c4d-467b-94f6-ad15fb3c5b4a"},{"claim_cluster_id":"ca871236-c037-4fa9-b3bc-cfec982a8e55","event_cluster_id":"717d4990-dc27-4922-b8a1-6a5e44493918"},{"claim_cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","event_cluster_id":"3f015f88-0af0-482a-a4a6-663bbcc6d95b"},{"claim_cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","event_cluster_id":"7b6712d2-df6d-4fa5-944c-8d0321a2652c"},{"claim_cluster_id":"6f847ace-00e0-4009-b5e9-3729f7a9e244","event_cluster_id":"f7b7014d-ad07-4661-9448-28c218c2eea5"},{"claim_cluster_id":"590ca39d-bd4d-431b-829a-90d0f3384aa4","event_cluster_id":"13eaad2c-4351-4227-a2c2-4a8d3df4410b"},{"claim_cluster_id":"d5dab78c-a52b-4ef8-8000-44988a029a7c","event_cluster_id":"c5d49178-7807-406f-89c6-f05965bb7e2e"},{"claim_cluster_id":"48358541-e77a-4c9f-81e2-7af006f34920","event_cluster_id":"2077703d-3e6d-40f8-85a7-39edc747b3a1"},{"claim_cluster_id":"bd13c9c1-afe0-4a04-acc3-453f611b1f14","event_cluster_id":"91289460-848a-4396-988d-42e28ce5078b"},{"claim_cluster_id":"b7bef44a-7480-409a-8790-0a70b42045ee","event_cluster_id":"9ee44494-957f-41e5-a680-3bacf709709f"},{"claim_cluster_id":"f367b654-8f0a-4a4d-816e-54c86d7f13ae","event_cluster_id":"f6ad38c8-1553-418f-93f5-4a6bb4909e2b"},{"claim_cluster_id":"ab1842ba-5e92-4ba8-ab55-1241a116a859","event_cluster_id":"d467c165-3190-4bf1-b5b6-3c529b474781"},{"claim_cluster_id":"c6aa0cad-31b1-4d56-9f83-938881501dbd","event_cluster_id":"473560b4-10a2-4370-be8e-3ebeae00ae74"},{"claim_cluster_id":"7440fefd-f7fe-4402-9218-79fa9f53df91","event_cluster_id":"2bd21a46-0627-4917-ba75-98775bf2627b"},{"claim_cluster_id":"da2845de-4e1b-492a-a6b0-06fd4584650e","event_cluster_id":"856fcb01-3b6d-4fcd-80d4-8e260efa7cd2"},{"claim_cluster_id":"13672f1a-e63c-4ec7-9f85-d3ed61ff60fa","event_cluster_id":"9b14b6b9-92d5-4da7-813f-eb820b5a4071"},{"claim_cluster_id":"5bc0db5b-3192-42d4-a343-00cfcacc4499","event_cluster_id":"f7fe1cc8-30c8-4879-8f22-1fc4904694c6"},{"claim_cluster_id":"00c920c5-f4fa-404a-9d1e-12f311ed5e11","event_cluster_id":"83b8e4b4-0c78-4b19-aa89-21b8a62c50fe"},{"claim_cluster_id":"9e4983ab-c919-470b-9bac-8b6c4b633a1e","event_cluster_id":"610fe915-6f9a-4623-a217-8c3cff21b2cb"},{"claim_cluster_id":"6dd833f9-26f5-4505-8729-234f3f5eeeb4","event_cluster_id":"6c6a46a0-71cb-45d2-a4dc-1eee1da7c7f4"},{"claim_cluster_id":"3a774e33-2c16-4d7b-91f8-38103798acd4","event_cluster_id":"03d5681c-cee7-4784-a946-350af3b91054"},{"claim_cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"c7bb1d74-7395-4554-a7ef-ec1f5c743579","event_cluster_id":"0834a3ac-a924-43d8-bec6-6e7d0a1384ad"},{"claim_cluster_id":"3b1a4f1c-eb8e-4934-89a0-1d405c7425e6","event_cluster_id":"07969927-bc1e-48a3-8b9c-29bb62214363"},{"claim_cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","event_cluster_id":"66b7068d-b746-42ae-9f41-d88ed9a887f4"},{"claim_cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","event_cluster_id":"fff91b42-2999-4568-8b58-028bf8ca7046"},{"claim_cluster_id":"662000fc-1ecb-4634-b4e8-efc53b2b3287","event_cluster_id":"0e4e78e3-4606-4902-b549-07174e100568"},{"claim_cluster_id":"a38c8b34-2d1e-4ee9-ac98-b7d045e07fb4","event_cluster_id":"30b7ce37-8fca-4fe2-b499-bda00e36d905"},{"claim_cluster_id":"fa68205c-96de-4570-af4d-97691aaf5e3a","event_cluster_id":"00cb3646-a2c2-4ca4-9bd3-507a4d1eade7"},{"claim_cluster_id":"40a361aa-d57e-4e3c-9740-34505f34913c","event_cluster_id":"a2124c19-e133-4d10-984d-0d176559c1d9"},{"claim_cluster_id":"c78cce84-ea53-4b86-8393-67ca74594e0c","event_cluster_id":"993498fc-f160-4c04-b836-a36d850156e5"},{"claim_cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","event_cluster_id":"2702052c-d199-4761-be47-a9217e23735a"},{"claim_cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"f6541b8c-4e86-4aff-8593-e4f14f2ecc27","event_cluster_id":"5f8dbb60-ef34-416a-9285-ed818708d337"},{"claim_cluster_id":"2f6021e2-bde5-4c10-ae2b-194bf6a93505","event_cluster_id":"0bc010ee-21eb-4a56-88df-bd3b94b15999"},{"claim_cluster_id":"1e9c3202-7611-4885-bb24-d9dd05b7eed3","event_cluster_id":"40a69599-ced7-4b8f-b20e-fb9c99238bbb"},{"claim_cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","event_cluster_id":"08533bcb-cb39-43d6-9371-79f7aa905623"},{"claim_cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","event_cluster_id":"55b3fec7-2c59-48a7-b144-2bc454de6078"},{"claim_cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","event_cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"},{"claim_cluster_id":"b6f111d6-8112-47dc-baeb-43c77c6392ea","event_cluster_id":"dfe985d2-9dfe-4657-be1d-a745b7ca1ca6"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"0c87e09a-5d40-4c46-abb8-ffdda4139e41"},{"claim_cluster_id":"4736fddc-4878-48ef-a211-f6b0740cc434","event_cluster_id":"ffd8b278-907b-41d6-9ed9-9d3e17a00678"},{"claim_cluster_id":"1dc0ed5e-e098-401c-9b18-3dd42ba6b01f","event_cluster_id":"a52cd2df-a03c-40f8-a7af-c56d32311c99"},{"claim_cluster_id":"3720666b-a4ac-4b21-9f19-2a86f32551a0","event_cluster_id":"e7545678-2204-4c5b-ba0d-fefcb6897378"},{"claim_cluster_id":"7c9beeef-07c1-4872-bfac-86e8c63a87f9","event_cluster_id":"f4412fc5-966c-440c-829a-8ca0977913f0"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"9d6d3278-c0e4-4003-a311-bf3945445bf7"},{"claim_cluster_id":"b34ea819-97f6-4215-92c0-351b2f770110","event_cluster_id":"5326cc13-3625-47b1-ad75-82ef998d0dce"},{"claim_cluster_id":"2a0a6106-78d5-46ad-ad52-e0296bf7134a","event_cluster_id":"45be894d-986a-43be-b81b-3a8308fba0de"},{"claim_cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","event_cluster_id":"f43dba3b-7d34-4eea-96eb-854a495fe8e2"},{"claim_cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","event_cluster_id":"ab8af083-dfdc-4c18-95cd-32d551c130c1"},{"claim_cluster_id":"5a861756-5d94-444c-84a0-fab63d482e8c","event_cluster_id":"91a2ed36-3e87-4baf-9999-c65078a62cbd"},{"claim_cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"1d8a91a4-e2e3-49c2-838b-462dda682ab0","event_cluster_id":"2ef61e30-e6d5-41b7-8ea0-69add1125af6"},{"claim_cluster_id":"10cadbd2-7261-4295-9f88-df0f9a246b5b","event_cluster_id":"21916347-9bda-4844-a220-12a3c8d5bdd0"},{"claim_cluster_id":"33fe2055-c6c1-46ed-8871-fc741999d32b","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"657ed7b6-8b7c-41a6-8900-c8d11bb6982a","event_cluster_id":"9a2fe341-e356-4c2f-afb2-12f391a85d04"},{"claim_cluster_id":"bf53e706-320e-4307-85d6-fcee526f5f17","event_cluster_id":"1ed52c55-1d90-4460-9e88-861e6d435eee"},{"claim_cluster_id":"cc2021eb-f979-4db2-af0b-d0533b90627c","event_cluster_id":"8cb39409-fba3-4dfe-91d4-98f7dbf55b5e"},{"claim_cluster_id":"f14e0258-b8de-48c8-96bd-31550d005b4b","event_cluster_id":"c74eddc6-9017-4628-9942-40823cd7e30e"},{"claim_cluster_id":"3b4d0d09-6630-4f48-897e-19fe1449086b","event_cluster_id":"6aece148-00ae-441a-a570-cbee981c2154"},{"claim_cluster_id":"7742ec5a-27ab-42d2-9779-df7d73a0cec4","event_cluster_id":"dd1b900d-edc5-41a8-a7b7-0e0de59cf33e"},{"claim_cluster_id":"d8eb9cee-8720-428c-a044-b6a3e22a6bb8","event_cluster_id":"ff6f2ca1-7367-40eb-b2f8-72fa90168057"},{"claim_cluster_id":"52105c27-d937-4970-9bad-c139e21a6205","event_cluster_id":"0d049984-1ab9-44da-bbd0-bb9c99a21317"},{"claim_cluster_id":"b523cd60-7c0d-4c50-b41c-3522aed9c4b1","event_cluster_id":"59f5b290-5ff4-47d6-96ce-35630701a6e9"},{"claim_cluster_id":"dfd567bb-1650-495c-ac2d-4d240d441b79","event_cluster_id":"2e85430c-b3c5-4c1b-88d2-e366b82a50f9"},{"claim_cluster_id":"dde1cfea-875f-4bd7-a73a-639065b04c0c","event_cluster_id":"ba19914f-8e64-44f6-86f3-04a0671b4419"},{"claim_cluster_id":"dfd567bb-1650-495c-ac2d-4d240d441b79","event_cluster_id":"34dc1cb7-40ca-44c8-a250-8a0dace843a0"},{"claim_cluster_id":"761efa26-8da9-4e7d-a7d6-a4e67c04fce5","event_cluster_id":"bf2543e7-3701-40bf-a97c-164b45c21900"},{"claim_cluster_id":"e1e2a57a-7e63-4b0b-b70f-2189a87649d4","event_cluster_id":"9af760e6-eb03-4959-a360-3cdeab7333f8"},{"claim_cluster_id":"fd5eb376-88a6-437a-8af1-6b857c858d7f","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"f570b12b-c8a8-4d99-9575-a11a563abe1c","event_cluster_id":"efd04eb7-8311-4730-bee6-1df74b27a996"},{"claim_cluster_id":"29d5756f-2c13-4cfb-b4e4-f439665752b9","event_cluster_id":"e4d59809-92d5-4450-8181-b93bc5f5d348"},{"claim_cluster_id":"ef57a08c-bb40-48bb-8784-c240ed933462","event_cluster_id":"aa7f033a-fd05-4789-9ef5-cce771714a6b"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"56bced3d-5502-4c62-9756-ced2f88eec36"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c"},{"claim_cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","event_cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133"},{"claim_cluster_id":"6436c54d-cea9-4b06-8f6e-d82ef558f6c5","event_cluster_id":"4f2c99ad-9a7b-43ad-b8d0-304aa8cd2c73"},{"claim_cluster_id":"152e2cd2-1d15-4787-b90e-76e34ac56ace","event_cluster_id":"5b67eeb9-9da5-4079-bb66-f861e834a37c"},{"claim_cluster_id":"7c9c690a-19a8-4aac-aba5-327f2a8b5923","event_cluster_id":"adb1b0be-f075-4e0a-9c6e-397dd0fde17c"},{"claim_cluster_id":"a9d64d25-62ff-4c83-a924-9b0477ad4c22","event_cluster_id":"9cb46e58-ec9c-4071-b505-f4806f5522e9"},{"claim_cluster_id":"7ac1c88c-d620-4c32-9f9d-5a780231627e","event_cluster_id":"291e783e-a633-4a70-baad-9d43cf49aa7b"},{"claim_cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","event_cluster_id":"43a57714-f5d9-437b-8d5c-b293145616c2"},{"claim_cluster_id":"bae449de-e29c-430c-9526-c8dc925bf231","event_cluster_id":"2bad245e-4724-47d8-9180-69fc7c047187"},{"claim_cluster_id":"9cf07839-b78b-4d19-aeee-e70ec12a23d1","event_cluster_id":"b2a104aa-8e99-4af3-a2f3-b3e4f2fb5af6"},{"claim_cluster_id":"f3c74d17-b66b-49d5-9e91-ad7f843bbd39","event_cluster_id":"33c3bbfc-4975-4a68-9abe-5dd608b4ec62"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"952d3c78-e97c-4ff6-a488-1e2f6353d3c9","event_cluster_id":"d3561f7c-f545-493a-88e4-1feb8895eb1b"},{"claim_cluster_id":"86cde8dd-df84-48da-a045-d001baaf3298","event_cluster_id":"a801c6f6-51a8-4c16-ae79-750cf640303a"},{"claim_cluster_id":"21956ecc-f782-4f55-8347-f78333fc6d97","event_cluster_id":"865f10e6-6341-4c82-a7d2-80f23cacd415"},{"claim_cluster_id":"162b03a4-86a7-4adf-9f73-3093aecba542","event_cluster_id":"926c487a-2b3f-41e8-acd8-d984df721c84"},{"claim_cluster_id":"c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970","event_cluster_id":"fbeea9d9-e3b5-41fa-b94f-503292015b12"},{"claim_cluster_id":"54c46b5a-065c-41a2-90e0-3fac031eb853","event_cluster_id":"2ef3ee94-6c9d-429b-95e7-08b756215251"},{"claim_cluster_id":"42734325-e832-49e4-b0f3-d3af89abdf66","event_cluster_id":"4d4564a4-dc41-47bf-ad98-75e34d4a1d0d"},{"claim_cluster_id":"a92df9a8-beac-475c-a620-574a5351def4","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"51218502-220c-4467-8b26-b12d809fed98","event_cluster_id":"e216b0a7-0193-4a30-a076-a872f378296d"},{"claim_cluster_id":"b63983c2-35fa-4152-8cc2-8380b6cbde79","event_cluster_id":"9d7361f1-563b-4b70-8f5c-fc18e12402d2"},{"claim_cluster_id":"e2dae5ce-65e5-4bf8-ac38-f452e98e9363","event_cluster_id":"1c65b00f-4fc8-40b9-b323-8ff074f956ae"},{"claim_cluster_id":"de3dfa95-4771-45cc-8a31-d6c35fbb0eb5","event_cluster_id":"364b6018-e5e4-4d17-9b1f-0b9d5fe116fa"},{"claim_cluster_id":"9bcb7463-7e6a-4bab-b398-5dd6ead423be","event_cluster_id":"eee2bcf1-74da-4f68-9a16-f7f155a012a3"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"b617ae42-60a1-4bd9-bcd3-a29cc6c02448"},{"claim_cluster_id":"f6541b8c-4e86-4aff-8593-e4f14f2ecc27","event_cluster_id":"7e081e03-60f5-4239-923e-30df23ea9e14"},{"claim_cluster_id":"b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4","event_cluster_id":"9821057e-b80c-444e-8823-153881d41c90"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"23451a3d-c01e-4597-9cbd-b34940e92d21"},{"claim_cluster_id":"ccf91c48-303e-4d94-8263-0e8c6de64e17","event_cluster_id":"b8ba4862-a01f-4bea-9d65-d965f8a811ea"},{"claim_cluster_id":"3428edf1-36a0-4018-889a-63913498a6c3","event_cluster_id":"65719321-4c0e-421c-be0d-ae0fd54b036d"},{"claim_cluster_id":"49b52e42-84db-4d97-b9a4-ffd3211b536e","event_cluster_id":"c1d6fe8d-9eec-42fb-a300-6a6e37dcd1f2"},{"claim_cluster_id":"a1ac0514-0dd2-43ae-9f2d-5939e791e058","event_cluster_id":"49af375a-1b87-4e0c-b77f-9747485eaee4"},{"claim_cluster_id":"bc0539c0-9358-42cb-bbfb-8c0b934c5e86","event_cluster_id":"93863b1e-b8da-4bf9-893e-8c00bcaf88db"},{"claim_cluster_id":"e126486d-8b99-4425-b6a3-54724b486b78","event_cluster_id":"d2828cf5-cc91-4e95-82bf-be47e19b88ee"},{"claim_cluster_id":"ab9886f5-759f-416b-88de-b9f771cf04e1","event_cluster_id":"6c08edb9-0ade-407d-af97-cbc1278990ac"},{"claim_cluster_id":"61c8550e-839e-4f39-803d-72ebbfa747a7","event_cluster_id":"e0a1afab-5142-40ca-ad10-35061b0289f8"},{"claim_cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","event_cluster_id":"2bf4835a-c2d9-4984-a011-415e8a457306"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"8985495d-c23b-4b4d-8af8-d412abf8767b"},{"claim_cluster_id":"f6a4aea6-92b4-4a70-a984-2326df1ee39e","event_cluster_id":"230aa320-84d5-49f6-9755-fd2e7a1037ab"},{"claim_cluster_id":"aea747b1-1cb4-4b3d-94df-5c33181b0976","event_cluster_id":"4ecf3311-91d6-4f18-a13a-b2646404483d"},{"claim_cluster_id":"e8b8352a-472f-4b00-9dae-87cd809f920e","event_cluster_id":"caa057e8-994e-43b8-803e-0ea0aeab7ec7"},{"claim_cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","event_cluster_id":"4ea543a7-37aa-415b-8870-050c7ede5ba0"},{"claim_cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","event_cluster_id":"74c516ce-db78-4790-b130-64ce1c94e700"},{"claim_cluster_id":"c55d7e50-ed13-4f98-a396-412d6e19decf","event_cluster_id":"fcd590cf-7159-4dd1-af40-6a6c770d2797"},{"claim_cluster_id":"0407f887-a8ce-4c09-bc8f-570e66bd3e6b","event_cluster_id":"c7bef51e-9aa9-4b77-85bc-5a1620f4b37e"},{"claim_cluster_id":"d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5","event_cluster_id":"ad8eb55d-3403-4e48-a3d6-9bc723fa02c6"},{"claim_cluster_id":"deb1b19f-f313-46a8-8e93-d75203af3775","event_cluster_id":"6fb56d95-1435-4a1c-8bf2-454a172c105f"},{"claim_cluster_id":"4848ddfa-b6c3-4770-996a-7e5c266b5b88","event_cluster_id":"1acc7240-f221-42ca-8a48-7f6a18f1f844"},{"claim_cluster_id":"0bb1f8c0-08c1-4f63-b6c8-052a5bad160c","event_cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef"},{"claim_cluster_id":"dc73c39b-d234-4200-a04f-dc1af208480d","event_cluster_id":"25e1da60-126d-485f-b6b4-e17bd08835f7"},{"claim_cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","event_cluster_id":"1e061f92-2688-4d15-8cdc-93767b97df6b"},{"claim_cluster_id":"494d200b-d2e7-47ec-bdd7-86aef2459978","event_cluster_id":"a1957de3-964f-4df5-ac8b-e165983c14d7"},{"claim_cluster_id":"7b4d9f3b-78aa-4507-8228-424f51cb5289","event_cluster_id":"af0e1637-dbe6-45fb-a04a-6bc7ad84725f"},{"claim_cluster_id":"8bbb9fde-a60f-4687-9398-276e5d036952","event_cluster_id":"089384c1-0ce2-49fe-812c-a7e86deaedaf"},{"claim_cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","event_cluster_id":"9348816a-379b-4a83-98b4-cd843f9d8989"},{"claim_cluster_id":"011b48fb-6ec4-41cc-bd4d-394e371c18cb","event_cluster_id":"a1711988-408b-42c4-8682-720bf33be6bf"},{"claim_cluster_id":"41a55c60-75f3-48f5-817e-bc3dd4fc026d","event_cluster_id":"b3677c08-0eb1-4865-90d2-0d359e3678b8"},{"claim_cluster_id":"454ec49b-c8f2-4a1a-ae0e-928918575347","event_cluster_id":"eddd54f6-a534-43f3-a4ac-88a9769ba8d0"},{"claim_cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"6eb67c15-59c3-481b-bf8b-2e464b0775ec","event_cluster_id":"432f6df5-1641-407a-a774-485c9d80d467"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"d1f35128-46aa-4b3e-8942-ed03c647bdc7"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"9f394b1e-f3b6-4528-a71b-dd2fed1c81a5"},{"claim_cluster_id":"e41399b8-77c7-4930-886f-cd94ab46ea34","event_cluster_id":"a208cf67-b0d4-4139-aecf-8fec75c13ae1"},{"claim_cluster_id":"8143472f-9ddf-4467-8402-c46a70ccaf1e","event_cluster_id":"cf4eccba-19e9-4f9a-984a-135d1c838ee6"},{"claim_cluster_id":"f58e8498-102b-4b72-96b4-c6d5b3fb97a9","event_cluster_id":"cf3cadee-d476-45f2-a534-bfb4334bffb9"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"e539011c-4c48-4afd-9e8f-3e4ca7d332fe"},{"claim_cluster_id":"b40ccc38-63a5-4a58-8bbb-6242768fb158","event_cluster_id":"d76d71cb-517d-47c2-8ed2-a260ceec7c7c"},{"claim_cluster_id":"60a1acab-79cf-438f-96de-dbff294bd2e7","event_cluster_id":"9a201ba4-4fa1-4a8f-b530-b70790363696"},{"claim_cluster_id":"a7043201-daf7-4ddc-86e1-fe3a850942e2","event_cluster_id":"ff3c71b1-9872-4a9b-a091-8300e856f9b9"},{"claim_cluster_id":"fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b","event_cluster_id":"fb0c78fb-f7a8-4921-9cdf-94739c1d1c3e"},{"claim_cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","event_cluster_id":"00ecc521-dbbb-417a-9961-132c4f488d88"},{"claim_cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","event_cluster_id":"0cf451c3-4981-46fc-b4ee-79c480a2a2b9"},{"claim_cluster_id":"dcc40b89-996b-46da-af7f-ec64a05c6ee5","event_cluster_id":"cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10"},{"claim_cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","event_cluster_id":"174c41e7-d29c-43ee-b99a-262cda821c4f"},{"claim_cluster_id":"43fa6264-b651-4eef-9023-b4483c40f5ce","event_cluster_id":"ed56cb15-531d-4953-a25f-e17a3cb3fb76"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"f7bc5745-3844-4596-a6d1-1d8cba63f4b6"},{"claim_cluster_id":"8bc3dd02-5989-4bb6-8266-c27296d666f8","event_cluster_id":"52572bed-fd4b-4180-9ada-bef96be23270"},{"claim_cluster_id":"370919c9-f171-4096-adac-3abd415be93c","event_cluster_id":"c2b68e30-8952-4460-9fc7-b286c267a038"},{"claim_cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","event_cluster_id":"a720530c-6855-4d9b-b222-ba31bac4c4c3"},{"claim_cluster_id":"dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd","event_cluster_id":"6e3b5d0b-67db-4d14-8384-2b3799aec6bd"},{"claim_cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","event_cluster_id":"3582a60f-77c5-4a28-b692-e25a35716357"},{"claim_cluster_id":"cba79c22-94bf-4911-a28d-ebd794325eaa","event_cluster_id":"525ead27-9fb0-4fe0-aa10-52b70492601c"},{"claim_cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","event_cluster_id":"2293ca8e-aa2e-4ee2-b17a-f9a9255d1eb1"},{"claim_cluster_id":"a5124b94-6b98-447d-9c53-5100339210c5","event_cluster_id":"32363fbb-b809-46d2-baba-aad9f54a7b98"},{"claim_cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","event_cluster_id":"c1c6d1f6-6fc4-4a8f-bdca-cd82345bf948"},{"claim_cluster_id":"8140cb8c-a254-4493-b790-598f4ef3676f","event_cluster_id":"acf3ef41-5374-4f21-834c-c4a11d955ee1"},{"claim_cluster_id":"a0aafb48-1cc4-47f3-9cc7-073b87c64efc","event_cluster_id":"7fd1b210-1374-4030-b2c1-ddf3869ca13f"},{"claim_cluster_id":"b180d822-88c1-4c5f-a386-c975497c4a85","event_cluster_id":"dd183126-5d54-4c76-bc6b-357daae335e6"},{"claim_cluster_id":"cdb08998-bbe0-4530-9534-7744fb962961","event_cluster_id":"e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107"},{"claim_cluster_id":"a4e781c0-f96b-465a-94d9-bc076c57b2b1","event_cluster_id":"da5f41fa-d075-4835-b977-9a11cca0ec10"},{"claim_cluster_id":"f09098cc-f345-415b-a2a8-3f7563f7b80d","event_cluster_id":"3712fc59-da49-45a4-ae5a-90b1831dcece"},{"claim_cluster_id":"fcc1829e-1835-42a8-bf49-00b5c2d30892","event_cluster_id":"c4d30aec-5c26-4bc5-895d-1e61d6d7b97e"},{"claim_cluster_id":"09f8ca5f-e359-4e32-b6bf-f706de588232","event_cluster_id":"e5320752-1012-4ce5-880c-e80ddb6ab4ee"},{"claim_cluster_id":"761efa26-8da9-4e7d-a7d6-a4e67c04fce5","event_cluster_id":"4722732e-36ea-4a20-b934-96b47f115eac"},{"claim_cluster_id":"b6a83d03-593e-48c8-ac84-66fa31a32a89","event_cluster_id":"76836166-e9eb-4d22-93c5-16c83ebc5bbe"},{"claim_cluster_id":"574951aa-9eb6-4bdd-ac47-891b328c28fb","event_cluster_id":"82d125aa-a1b8-43bf-bc35-e274642ade2d"},{"claim_cluster_id":"15187e94-76d4-4323-bc9d-67428e138efd","event_cluster_id":"80704d80-8bb5-443e-80be-d547a70828af"},{"claim_cluster_id":"c153b607-ea7e-4a94-8f50-d29611d77fe7","event_cluster_id":"96f47e0e-34da-4076-aa8a-d368df50bd46"},{"claim_cluster_id":"c2ba86a6-df2c-40b6-bf30-1269c5ac3702","event_cluster_id":"bde83207-e05b-485e-9b86-431574e6c995"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"8c92c9ea-d03e-4ce1-b80a-21678d736eec"},{"claim_cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","event_cluster_id":"6289781a-230a-4b8d-94dc-f3adadc4495d"},{"claim_cluster_id":"99681bf5-4780-4832-b6fd-70acc37bfc27","event_cluster_id":"18a83b13-1adf-4e6a-9783-cc45f9fd9c79"},{"claim_cluster_id":"8d98ef20-8cc0-4e51-b441-315a42837e56","event_cluster_id":"938b5cdb-cc92-4431-8b11-03447ecda24f"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"28dd2f06-c107-43ce-af58-70e52ba1e785"},{"claim_cluster_id":"6ac8924b-24d0-446a-8ffc-cf862b415737","event_cluster_id":"32a7ec8d-3be3-4c19-8ad9-bb022a0c0c96"},{"claim_cluster_id":"fa621ebf-8ee4-47c4-b584-f5012ff39561","event_cluster_id":"e157316b-b52b-4e59-beec-7a600ea2ef49"},{"claim_cluster_id":"89cac161-a6f0-4315-a880-1662cae50313","event_cluster_id":"90b17dac-ed93-4273-8df4-019652e30993"},{"claim_cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"cd4aea0c-c90e-430b-95f8-4bff425c022e","event_cluster_id":"3e87987a-c8cd-4616-922a-e297f103d0fa"},{"claim_cluster_id":"859c814e-e7af-4708-a58a-9f1f6973974f","event_cluster_id":"cc7c4fde-e26b-4dc1-acbf-81128ce5d657"},{"claim_cluster_id":"24daffdf-e642-42fa-ac82-39c90e12f420","event_cluster_id":"10cff142-fdb6-4cd5-b991-a870f41801d0"},{"claim_cluster_id":"48496823-a243-4e3b-bc74-d86ea0c9a269","event_cluster_id":"928ae685-c0c3-436a-ae8d-5a22e9f5f9eb"},{"claim_cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","event_cluster_id":"69c908c7-3fb6-49fa-b102-50233b107e27"},{"claim_cluster_id":"22fed294-324a-41e6-9f14-7b92ebc22681","event_cluster_id":"0b2d3f06-c549-429d-9974-6e988853ab88"},{"claim_cluster_id":"4594a001-49cb-45b8-a26a-b07a8a886360","event_cluster_id":"cf554d67-1528-4e54-be08-db5967f3793c"},{"claim_cluster_id":"7e245bdc-e727-4627-a96b-f1db937337df","event_cluster_id":"94346dc4-a4ac-4e3c-85da-06445ad201ba"},{"claim_cluster_id":"8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576","event_cluster_id":"b84f23af-bd15-4231-83c8-7e4cd068a5f9"},{"claim_cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","event_cluster_id":"94210717-ebb1-4a0a-897b-10e38931ad8b"},{"claim_cluster_id":"cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb","event_cluster_id":"36e8c4e1-79bb-4ee5-81d8-1178da8ce862"},{"claim_cluster_id":"bc0539c0-9358-42cb-bbfb-8c0b934c5e86","event_cluster_id":"2546e25b-7863-4f5c-b7d3-2a457e14f21b"},{"claim_cluster_id":"7325cc3b-df7f-4451-948f-1ce21f12d10f","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"10f0700e-3ce2-47c7-8783-a4d08ef48748","event_cluster_id":"a2d0ea3b-d935-4c42-8edc-70bff4ecb269"},{"claim_cluster_id":"7b76e5cb-748d-468e-9baa-d34773d5f24e","event_cluster_id":"e83deec8-b564-42c6-8487-a1f4fc334b10"},{"claim_cluster_id":"5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9","event_cluster_id":"82af2059-79b6-4403-9b30-9a9e111cc571"},{"claim_cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","event_cluster_id":"c42951ed-4fef-4240-bea1-d37921f9209f"},{"claim_cluster_id":"baa116d7-3e4a-4d22-809b-fdab138f8d83","event_cluster_id":"1356f60e-0cce-4f4c-95ff-047c73d507ce"},{"claim_cluster_id":"46a0b407-50f8-4cc9-968a-6955a0540862","event_cluster_id":"f4766e96-74eb-4ff2-aa7a-ed465ba83cbe"},{"claim_cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","event_cluster_id":"b4d4265f-dae0-43eb-9010-fb5c59968803"},{"claim_cluster_id":"0634cfd7-f7f7-48cb-bb92-7dc813e3271c","event_cluster_id":"72f778c7-a74a-4822-89c7-75defc5fed4a"},{"claim_cluster_id":"f09098cc-f345-415b-a2a8-3f7563f7b80d","event_cluster_id":"ae643b18-4610-445d-bb91-7a6e08099006"},{"claim_cluster_id":"451cf0f3-38b6-4124-8f93-0e300d12c170","event_cluster_id":"348d310b-39d2-427c-af87-143686fcd6a8"},{"claim_cluster_id":"ab9886f5-759f-416b-88de-b9f771cf04e1","event_cluster_id":"a6e5fc0b-7c5e-4adc-9bd8-8c5b7afb7918"},{"claim_cluster_id":"5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9","event_cluster_id":"e0696dc9-5406-4bfa-a327-9114afed84e2"},{"claim_cluster_id":"0543c671-bbcf-49ea-a462-e4ab061c75a0","event_cluster_id":"b978e9a0-f48b-432c-b14c-50e4efff007d"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"05310a2e-9cf9-4ebe-9d39-aca58b7ee406"},{"claim_cluster_id":"7123d027-fb9c-44c1-becb-087b98c76740","event_cluster_id":"441ea463-41a5-4f39-8e7b-380142bd84bd"},{"claim_cluster_id":"9be076b9-65b6-4c8e-b3d7-1df3c547c0fc","event_cluster_id":"c8767af3-0dda-4a2b-8768-e0cf749cfa1c"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"ccdc4717-b37b-4b1b-94a7-20dfafa305fe"},{"claim_cluster_id":"be467aaa-b350-4a63-875e-7aa61c3d868a","event_cluster_id":"1fb31a41-f917-4cde-9190-f353f630be9a"},{"claim_cluster_id":"6cf558a2-c2e5-4467-b5b0-ac3ede97ca96","event_cluster_id":"c679edbc-b9a4-4c17-b40e-4029662513e4"},{"claim_cluster_id":"a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"38a07431-3ca7-46f3-a1e7-a6118a43b742","event_cluster_id":"90c72bc2-1d1a-4a98-9edb-8381a34e2935"},{"claim_cluster_id":"03915ee1-228c-408f-b93a-594ce2e45136","event_cluster_id":"ee80f2ab-f1d2-4dfc-bb99-e00e767727e3"},{"claim_cluster_id":"0407f887-a8ce-4c09-bc8f-570e66bd3e6b","event_cluster_id":"4f2d75d0-04f7-4815-a71c-1d8be3e7aa00"},{"claim_cluster_id":"7a1e52a1-bd32-491f-a249-5ec36a49aa78","event_cluster_id":"8e541384-70e4-4c7e-9ac4-ec79ad71649e"},{"claim_cluster_id":"92a61686-4c12-431d-b205-279f1f28aaa9","event_cluster_id":"4c8c98df-55ae-4fb5-ba8d-8d914fda29e6"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"7b4d9f3b-78aa-4507-8228-424f51cb5289","event_cluster_id":"1622ce6e-697e-479a-95ba-4bfbcc9fd2c4"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"93f5bdee-4d35-454b-8f1b-0b318e24a68d"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"1405f96f-07a0-4454-a7cb-365f38772605","event_cluster_id":"3765cbfd-a44a-49bf-b7ba-3bd606b4f80e"},{"claim_cluster_id":"68892c5a-f791-4608-9e40-b67a54dd50f2","event_cluster_id":"d3045f09-979f-427c-94af-3cbb77214023"},{"claim_cluster_id":"6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3","event_cluster_id":"8430f01b-f34e-4798-8729-04aadd64268d"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c"},{"claim_cluster_id":"21eacc7c-c9da-4edc-ac35-3ab550e3b7af","event_cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c"},{"claim_cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","event_cluster_id":"f3affcd0-acdc-481e-ad0d-c22c5984f9af"},{"claim_cluster_id":"6a51ac21-708a-4a11-b82e-7b2b043d6c15","event_cluster_id":"b4e49473-fad9-44d2-a14a-baa57498bb09"},{"claim_cluster_id":"58a7d973-9fa3-4047-a219-579a31c4561b","event_cluster_id":"545232cb-5fc2-43ad-859e-11784f675852"},{"claim_cluster_id":"3356bac0-8ec4-475b-81a7-e146187a74ba","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"e58c74de-137e-4144-8780-c4e86fcc480a","event_cluster_id":"9add2c84-55b8-4f75-bec3-d9a47e379ce8"},{"claim_cluster_id":"9562ace0-b924-497a-a3ab-5d483c835c5a","event_cluster_id":"a1ea139e-e9aa-4250-ae2b-ff5069df6f63"},{"claim_cluster_id":"b524cac0-fbe6-4818-abc9-cf0d17bfecf0","event_cluster_id":"117f6cc5-ef88-4d83-9dfc-20f8e5fc488c"},{"claim_cluster_id":"428d818b-c2cf-41c7-bcd8-3f5cb0b144ef","event_cluster_id":"fe94ed8f-3634-4c2e-acc1-318cbc76b2f2"},{"claim_cluster_id":"cdd48d7f-71ad-45d9-b5c0-d84849f26b67","event_cluster_id":"baae4a32-5168-4c2e-a607-5bdb0996a9ff"},{"claim_cluster_id":"80abc80a-d540-4e4d-aa41-272690066eb0","event_cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc"},{"claim_cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","event_cluster_id":"e15d8f08-e424-41bc-9193-92e22c4d515c"},{"claim_cluster_id":"aaa5b32a-96ba-4450-b886-70f714b65bf2","event_cluster_id":"f677d3a3-a108-4585-8030-41b82d49252c"},{"claim_cluster_id":"2f4a7179-3f3f-4eb6-8891-8b8d39467620","event_cluster_id":"db2336a6-b759-4cc1-8b40-69f3eeb5bcf8"},{"claim_cluster_id":"1b7b6166-a006-43a7-8e66-beaeaf966eff","event_cluster_id":"c11121a4-e475-45d6-a46f-861982c7538c"},{"claim_cluster_id":"fa621ebf-8ee4-47c4-b584-f5012ff39561","event_cluster_id":"344f9518-32e9-438c-95bf-e7b75fd500b8"},{"claim_cluster_id":"a6d92a93-8990-407f-a2ca-8786c79330ee","event_cluster_id":"beb95653-6e6e-44fe-9a2a-77a05c101fd4"},{"claim_cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","event_cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"},{"claim_cluster_id":"b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4","event_cluster_id":"119547c4-e528-4d80-bc2b-d8dc41ee62fe"},{"claim_cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","event_cluster_id":"7c6d77d0-d878-49bf-a294-6d6456dfe66e"},{"claim_cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","event_cluster_id":"a8476578-a217-4709-ac69-6e4d18f25dc6"},{"claim_cluster_id":"daa86fb1-df31-4a23-a926-1b9981f8df40","event_cluster_id":"5e9e2335-fc8c-44dd-9055-29d786472e4e"},{"claim_cluster_id":"02c9b472-905f-4c41-8570-811b8d821196","event_cluster_id":"0f5915ad-4edd-49f6-8855-92a02e00debd"},{"claim_cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","event_cluster_id":"a9574820-7af4-4109-8e6e-9d95f9ba6cbd"},{"claim_cluster_id":"76a80e87-389e-4e6e-9595-1b220839fd20","event_cluster_id":"a11d2091-08fe-4a3c-ae90-66e1118f2ac4"},{"claim_cluster_id":"b98bb0fa-4594-47af-9069-f482aaa8d7c4","event_cluster_id":"9611a4d5-e21a-4cd6-bbeb-709b60bd7dc1"},{"claim_cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","event_cluster_id":"b1ded912-0980-4dc6-8e8a-bb1ae1f015a9"},{"claim_cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","event_cluster_id":"633de8a7-7506-44cf-9918-6f3f17934029"},{"claim_cluster_id":"83ec8695-6d93-432e-a8be-81705e2e2a54","event_cluster_id":"2f690c44-ca18-4a31-a2b5-68ac60208360"},{"claim_cluster_id":"6768580d-67cd-4040-b98a-9d8276f6f0bd","event_cluster_id":"e3021516-b122-4f63-8b18-ba2abaa0f893"},{"claim_cluster_id":"a4e781c0-f96b-465a-94d9-bc076c57b2b1","event_cluster_id":"e9e5cd65-c720-48d1-aff5-59d128103cd2"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"67de48d7-3fc7-4d88-97a8-9350772b5bc5"},{"claim_cluster_id":"984134b7-51eb-489d-965e-a939f985e06f","event_cluster_id":"f9711d2c-1b60-4175-97f9-55453cace8aa"},{"claim_cluster_id":"7966aa4e-476b-473f-85ad-b267835811ed","event_cluster_id":"2ba645ab-6f15-47c5-96d6-7989f0a29459"},{"claim_cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","event_cluster_id":"edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c"},{"claim_cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","event_cluster_id":"9c4f129c-13a2-41c2-aa00-330c197b8780"},{"claim_cluster_id":"f6a4aea6-92b4-4a70-a984-2326df1ee39e","event_cluster_id":"1337f10e-c559-4983-82e2-596f69e5c47a"},{"claim_cluster_id":"27f40e5e-f571-4385-aef9-fcc4114989bc","event_cluster_id":"cac94e48-7ce8-4cff-8e2e-49f3f784f217"},{"claim_cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","event_cluster_id":"05f00def-a8b8-4cdc-94a6-9ead4bc629d3"},{"claim_cluster_id":"adfa00d7-81da-47be-a9ec-4b8dfb8ee34a","event_cluster_id":"4b392fdd-fe83-44be-b489-81067bf20cc4"},{"claim_cluster_id":"5d4f6733-5fbd-48ce-8468-590ebda279c7","event_cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07"},{"claim_cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","event_cluster_id":"74a8058f-9617-4020-8db9-456c0bc2deb9"},{"claim_cluster_id":"17a4104c-d678-44ba-8ae9-fd050d042961","event_cluster_id":"c057a22e-5c5b-4db2-8c44-1bbafad4ea91"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"73ac3211-808b-4905-b95e-ccdafdc4bd5d"},{"claim_cluster_id":"267d2942-984a-4564-b33c-69e9db79a066","event_cluster_id":"bb78b3cf-3fee-4d7e-b532-1ccb52ef3013"},{"claim_cluster_id":"77de10dc-6dcd-4902-a9d2-f5cf9384d343","event_cluster_id":"45b3db14-d0a0-477b-afcd-d5fc5dbd7f5e"},{"claim_cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","event_cluster_id":"55de19a2-d0de-4a1f-86be-06d3fbb117dd"},{"claim_cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","event_cluster_id":"e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93"},{"claim_cluster_id":"beba9a76-4058-465a-8f4e-bc79ccf7a03f","event_cluster_id":"30a07eeb-43bd-4ffe-abd6-643a3e7fa413"},{"claim_cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","event_cluster_id":"4f145c90-9c3b-47cb-b38a-e643a9aa6e27"},{"claim_cluster_id":"ae58d35c-53bd-40b8-b6d5-7fe4e15e229a","event_cluster_id":"5a3adc2a-ea19-4c5d-b7f5-3df2a2a10371"},{"claim_cluster_id":"a98eba10-9612-466e-bbba-6161ced90ab9","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"a1632082-229c-4e1d-b6b1-8334d7ed7db2","event_cluster_id":"96772c7c-5021-4ae5-83ab-b845fd92f1f9"},{"claim_cluster_id":"cba79c22-94bf-4911-a28d-ebd794325eaa","event_cluster_id":"367b0f1c-f101-4396-807a-065b17daa4e8"},{"claim_cluster_id":"a3463468-dce8-4063-85c5-ecdc64691fed","event_cluster_id":"9e87fb61-486a-4192-90bf-f05ee1b73406"},{"claim_cluster_id":"644ce0a3-b992-4dbe-be7f-558277802f15","event_cluster_id":"996e6c58-b099-4143-9641-865300e8a753"},{"claim_cluster_id":"0ea60366-ef97-44ac-91be-b38d55efb0c3","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879","event_cluster_id":"06f36d72-4a36-4a11-89bc-28713f0d3ba2"},{"claim_cluster_id":"dbd98860-9de1-4289-bb60-99171790c782","event_cluster_id":"d62e9da4-a6f4-4493-99df-7aea8cb8b7d5"},{"claim_cluster_id":"d1c29947-a7e4-41cf-9656-837e51b2de11","event_cluster_id":"7a48cda2-7a7d-48c6-9ef2-e5b111d87d7c"},{"claim_cluster_id":"c0e66b49-a2c1-49ba-be78-c28aff5c60cb","event_cluster_id":"35b184f1-0b55-4cee-b0ea-dcbb0d7633eb"},{"claim_cluster_id":"80abc80a-d540-4e4d-aa41-272690066eb0","event_cluster_id":"794a59da-1667-4f55-8bfb-64bab3fe6d1a"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"86944fd0-c689-49c4-894c-bd247f4057bb","event_cluster_id":"ac066abb-a95e-4ab2-884e-0a0fd4b40f30"},{"claim_cluster_id":"eb2e33e5-165b-4a02-aa96-d53bcd386da0","event_cluster_id":"b6f98e35-378d-4bca-93ef-5b980f18f2b3"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","event_cluster_id":"dd9ccaa5-025e-44c1-90b2-20d75d0c5291"},{"claim_cluster_id":"ef57a08c-bb40-48bb-8784-c240ed933462","event_cluster_id":"dba5927e-43c7-4d0e-9ca1-e78a9cdb024a"},{"claim_cluster_id":"a1ac0514-0dd2-43ae-9f2d-5939e791e058","event_cluster_id":"55be4945-34ca-4ac0-b3a5-86bcc22710f0"},{"claim_cluster_id":"91b0db25-32e4-4e5d-a32d-911732cbec28","event_cluster_id":"82ddd264-29cd-4540-b05e-dff896b42eb8"},{"claim_cluster_id":"e935bf33-7d4f-4ee6-8636-94e91a064afd","event_cluster_id":"3da59556-c8b1-408c-95c7-5d8130035b46"},{"claim_cluster_id":"3f043499-266e-455f-a558-699fac541c36","event_cluster_id":"e014d650-8fca-4dde-a60f-f8576ce7542f"},{"claim_cluster_id":"63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7","event_cluster_id":"2fef56aa-90d0-4ea0-9ef0-fc7608685f56"},{"claim_cluster_id":"e416c5ec-262b-4531-adef-7197fba310f0","event_cluster_id":"6e4dcb8c-7c71-4fa3-82ef-3a917a168bdb"},{"claim_cluster_id":"98bac582-09cd-476d-9519-fe434dffcb9a","event_cluster_id":"3ae04ca7-f447-4b2b-85af-7e1f6c9004e8"},{"claim_cluster_id":"31810a05-cebd-496b-bd75-5b647781b8ec","event_cluster_id":"e6f515d5-9add-4fca-a2f4-3869c847ca29"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"814bcb42-2e0f-4cf8-87e3-c5b551e8ea66"},{"claim_cluster_id":"57eb29a4-6d1b-4f98-a507-b97e4235688c","event_cluster_id":"ff03cd74-7869-49e2-a30a-40383add9c7d"},{"claim_cluster_id":"8bbb9fde-a60f-4687-9398-276e5d036952","event_cluster_id":"fcb8985c-e271-4f8a-9ba5-ab287203d1d8"},{"claim_cluster_id":"ce07721b-5347-4d52-81aa-7a7c68338485","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"9860031c-3ecb-400d-a847-e88ace1049f2","event_cluster_id":"87e137e4-5f92-4e98-b206-3abd53542c67"},{"claim_cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","event_cluster_id":"c7b52427-87e3-4932-9690-1d3cb09c79b7"},{"claim_cluster_id":"9be076b9-65b6-4c8e-b3d7-1df3c547c0fc","event_cluster_id":"6b396f8a-a67e-4844-8d5a-43bb95030766"},{"claim_cluster_id":"c6541e86-8e1b-4bd0-926a-c380aa103aa6","event_cluster_id":"37fbb780-673c-455c-ae4f-c83136095160"},{"claim_cluster_id":"ee431334-0b63-4389-8c3c-60633233fd26","event_cluster_id":"aefe0bc6-fe98-4828-a554-094ca6f377d1"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"04fe8e71-8c72-481f-a6cf-1722df9454dc"},{"claim_cluster_id":"b0c0fbc8-3a87-4290-a45f-69e062e04cee","event_cluster_id":"c317865e-d1be-4abc-b1b5-dece44444a1b"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"a57199f1-f704-4a31-b1b8-b56b52a4b405"},{"claim_cluster_id":"ed1fef35-ea22-4436-b53a-1dc1f0380298","event_cluster_id":"dc760acb-b4e3-4975-bd26-80f29e06c63e"},{"claim_cluster_id":"f8755b86-ae98-461e-a3ac-2bd5b6ec4310","event_cluster_id":"d1112bf6-9631-4abe-8c1e-925442961737"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"3f26edd9-fb3e-47fd-a185-0a5f3a6ec746"},{"claim_cluster_id":"1a807d7d-9b68-443c-ad9d-52b339476997","event_cluster_id":"a65f122a-8e28-4204-bec6-e6c89e03bce2"},{"claim_cluster_id":"87a15594-c8d7-4860-a888-b2469a7e65b5","event_cluster_id":"33f7acb6-a580-4b13-bf25-917d68f240ac"},{"claim_cluster_id":"c6c8d065-8cfe-4224-9bcc-58df52f1a712","event_cluster_id":"4c2902bb-5892-4765-99b2-69db31b95136"},{"claim_cluster_id":"4770d222-ba7d-4bbe-8acd-294b0fe141f8","event_cluster_id":"760f2c37-f953-4230-a4d7-e4bda98fc033"},{"claim_cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece","event_cluster_id":"4e973d36-02eb-4b5c-bc20-63b35994dd87"},{"claim_cluster_id":"0aa10a76-1680-4566-9d3a-ebaa3e486aaa","event_cluster_id":"d5a1e042-b187-41b4-a6ad-f1f271f98a66"},{"claim_cluster_id":"212176d0-9b06-497d-a8bf-0b53076513ff","event_cluster_id":"b7b39062-4917-41f9-8b87-39a562d00b9c"},{"claim_cluster_id":"9e4983ab-c919-470b-9bac-8b6c4b633a1e","event_cluster_id":"feb55b84-b173-4b70-b9c2-3b33225296b8"},{"claim_cluster_id":"10e97fc5-5fa6-457f-aefb-257e90e8124b","event_cluster_id":"da81244a-ef78-429d-9f3d-b08a5c21a084"},{"claim_cluster_id":"1dd25bce-7fe6-46d2-9e28-e803262696c4","event_cluster_id":"54567e29-4033-493e-869f-078ef9153910"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","event_cluster_id":"979b7171-b50b-4784-a226-a93eb757dfb4"},{"claim_cluster_id":"a9b66749-8bb9-4643-bb36-488cbf77974b","event_cluster_id":"92f1ca49-b0ab-4770-8539-01bf2c201c40"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"7bdd8e86-1a5c-4cda-a846-8ddfcadc8007"},{"claim_cluster_id":"83392417-156e-4467-96c4-b7a769a50f3f","event_cluster_id":"bc727b98-bf68-42be-b2de-84ffed053ccd"},{"claim_cluster_id":"d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9","event_cluster_id":"18ce2062-068b-4c99-b15d-32e24b28817f"},{"claim_cluster_id":"0b87672f-54fc-4c20-8d98-e54ab45bc52d","event_cluster_id":"f3ff4daa-4e28-48b9-8086-b9beac549c23"},{"claim_cluster_id":"2790abdc-e882-4d8a-90ac-fbfc5b896052","event_cluster_id":"22edb9f0-7d37-46a0-a499-0bf470746f3e"},{"claim_cluster_id":"46f91c43-019b-4419-b509-a0a1e806ff37","event_cluster_id":"ab265737-e0ba-43dc-8147-c642f185978a"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"7c9beeef-07c1-4872-bfac-86e8c63a87f9","event_cluster_id":"34aab7b4-5379-4f38-9914-ae9a14a7914c"},{"claim_cluster_id":"cefbf586-5d05-477f-8675-6637fb8781a5","event_cluster_id":"5cb65b5e-c51c-4fab-b738-dd41d64af22f"},{"claim_cluster_id":"26852476-f26f-4f97-92bf-7cc2d9373f4e","event_cluster_id":"f1b5b82d-47e0-49c5-b861-5e41e68dc753"},{"claim_cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","event_cluster_id":"800819aa-dd64-46d5-8bb3-ebc4802f59be"},{"claim_cluster_id":"a1ac0514-0dd2-43ae-9f2d-5939e791e058","event_cluster_id":"fc32a20d-bd13-4dc2-a851-03b63c1e329e"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337"},{"claim_cluster_id":"ab8de566-e0cc-475b-b056-6b27916b484d","event_cluster_id":"d101520b-7082-47e3-b848-813e8165e6a9"},{"claim_cluster_id":"1b257e2e-69fd-4bc5-b57c-e7f5b2178161","event_cluster_id":"512979c6-163f-4fe1-b34a-1c4e466e4650"},{"claim_cluster_id":"ade8c501-ccec-40ec-b096-cd50cd90be07","event_cluster_id":"dd0a9eb8-6da6-4108-8f70-358d100bdfcb"},{"claim_cluster_id":"6a51ac21-708a-4a11-b82e-7b2b043d6c15","event_cluster_id":"af9fdbaf-db80-451f-96bd-62636c3231f5"},{"claim_cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","event_cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c"},{"claim_cluster_id":"7440fefd-f7fe-4402-9218-79fa9f53df91","event_cluster_id":"1373b88b-91da-4b7d-bc67-e2f0449d0283"},{"claim_cluster_id":"e3548f8e-cc3f-4307-a48a-a45cdf828859","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"24daffdf-e642-42fa-ac82-39c90e12f420","event_cluster_id":"3dc78939-89e4-4b07-a3e0-cad83ab8d427"},{"claim_cluster_id":"a536505f-e31a-400e-a4a5-1f74a9e29e7d","event_cluster_id":"0a9d0582-fd67-429b-b378-1ed79f7e66aa"},{"claim_cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","event_cluster_id":"b29164d7-a1d8-4a41-a952-b0d04cde6fa1"},{"claim_cluster_id":"8c2b4e21-c9ea-4127-9440-e983688f714d","event_cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44"},{"claim_cluster_id":"ab72f353-1b68-44ce-979f-a10883b99605","event_cluster_id":"8995bbaa-d955-41cd-a920-b35b1fea2dc4"},{"claim_cluster_id":"4dbd9499-a86a-4c48-b218-1b0a93aa0331","event_cluster_id":"24b0b407-5974-4623-9570-6a7574f03b45"},{"claim_cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","event_cluster_id":"705d1ff1-cf3d-455b-8c22-31feaaeb943f"},{"claim_cluster_id":"53a5cd16-ea33-4c3e-8f8f-0d495c63c479","event_cluster_id":"83f04811-c07b-4cf2-8679-7397fef07ebd"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"86cdbb00-bf89-4bf4-b9b5-585743288546"},{"claim_cluster_id":"8f97c05e-5860-4be0-8343-dc2050850d4f","event_cluster_id":"4f34a5b6-00cc-43cb-98d1-c250e5f2b08b"},{"claim_cluster_id":"7faff4ee-fc9e-4ba2-8e8e-36906d88936d","event_cluster_id":"35eea677-5b27-4587-9764-95116cb6b83e"},{"claim_cluster_id":"89a7a448-be37-40e3-973f-79b15dac979d","event_cluster_id":"4194b8ef-5709-47af-9e86-ee10aeeb4788"},{"claim_cluster_id":"3a774e33-2c16-4d7b-91f8-38103798acd4","event_cluster_id":"7da5e969-ac3d-4ab8-86be-3712be90baa2"},{"claim_cluster_id":"d8515ae8-12a5-4f84-b01f-bc10b41b19e0","event_cluster_id":"25f3e976-9943-4b37-b0c9-b84c0952ccb4"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"f81575fe-bf60-4052-8196-fa9040141b06"},{"claim_cluster_id":"e9caf6d9-2282-4c7e-9cd5-97529119edff","event_cluster_id":"d211ea4f-25c6-49b0-b039-be55cbe6e301"},{"claim_cluster_id":"f46bebef-6c63-4778-a5c7-e0d7b893e969","event_cluster_id":"0b109e58-1cde-4c32-aed4-12ba82ed273a"},{"claim_cluster_id":"6832730a-f3c3-49e8-8c1f-45ff7dac590c","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"5d950548-da48-42e1-b748-275abdd34cfd","event_cluster_id":"a4d6044a-4bd0-435c-beb3-a719ddfd1f0d"},{"claim_cluster_id":"b9ef5935-c3ff-439a-95ae-5e53367b92ef","event_cluster_id":"4236f047-bfc1-46a9-8b89-2b002fe42dc4"},{"claim_cluster_id":"97b87ffd-da0c-47fa-86ae-0eedf718bf3e","event_cluster_id":"22c9858e-9aba-4253-8fc8-8d1d83a938f3"},{"claim_cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","event_cluster_id":"cc24e5f4-c0b5-4176-a975-3eb0a8f8713d"},{"claim_cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","event_cluster_id":"9c0a11fb-cf7e-4f2f-b318-57e8160591d2"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"b3413e76-c570-4047-aa2b-63946d5b2c25","event_cluster_id":"0e8cc365-638d-4d52-88e5-ee27a8dddfb2"},{"claim_cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","event_cluster_id":"079ea0ae-5460-44fd-be95-17fec28e2122"},{"claim_cluster_id":"68892c5a-f791-4608-9e40-b67a54dd50f2","event_cluster_id":"1e486a72-4d21-463d-8ec1-dd36ab1fc529"},{"claim_cluster_id":"4c86e2de-bdfc-40e3-b87c-fafaa9d03c41","event_cluster_id":"3d2e56c3-c257-4788-ac2d-72890e521046"},{"claim_cluster_id":"2951f722-7d9f-4f1b-b69b-0dfe73efebd5","event_cluster_id":"a6f24255-af0b-46ae-a654-0f9f9280b4f0"},{"claim_cluster_id":"48496823-a243-4e3b-bc74-d86ea0c9a269","event_cluster_id":"df7272f7-c990-4a72-9f74-cce4b2e6b4b9"},{"claim_cluster_id":"64a10d09-a49c-4bf3-80db-a2cb3188afbc","event_cluster_id":"c4a711fd-1857-4f2e-beaa-2df948c3bf31"},{"claim_cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","event_cluster_id":"5d815b32-3a62-41d7-bd5e-64e320d9507a"},{"claim_cluster_id":"04fa98cf-7cbb-4ec9-b84f-6d1c0570075e","event_cluster_id":"0ebe4f88-dbfe-4a7c-a8eb-80bb48625a38"},{"claim_cluster_id":"da745b4f-4158-4c1c-b2f1-ec13252863b3","event_cluster_id":"9da2ed03-3aa6-4daf-9488-c042585d10b9"},{"claim_cluster_id":"afdf0794-a58d-44cd-b1d0-aec7b0adc12c","event_cluster_id":"e20487a3-4fd3-48eb-b5a7-8bf0da331808"},{"claim_cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","event_cluster_id":"dd4670c3-7e44-4c76-a7d9-373ad6cb6c50"},{"claim_cluster_id":"d9f5972a-ff26-4242-938a-7c9615591c15","event_cluster_id":"6f5e39d0-2941-42e5-be3f-779525a745b7"},{"claim_cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","event_cluster_id":"db3b032b-6eb1-469a-8fea-f26d907c46cc"},{"claim_cluster_id":"baa116d7-3e4a-4d22-809b-fdab138f8d83","event_cluster_id":"fc95bbfe-5cb2-4a6b-a350-70ab1f4da4bc"},{"claim_cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","event_cluster_id":"3cd5d7a9-3268-400e-a49f-8e37d420e392"},{"claim_cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","event_cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f"},{"claim_cluster_id":"a9555cd5-7b65-4e84-9f89-ed03117c7e50","event_cluster_id":"5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b"},{"claim_cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","event_cluster_id":"4305150f-f7f1-49f6-a09c-d2c5973a5934"},{"claim_cluster_id":"a5a6c59f-7670-4f97-9c2b-c94700d73131","event_cluster_id":"f1fc4cb5-63a2-420e-a804-9502b1ff9992"},{"claim_cluster_id":"59078c61-208b-49cd-9d25-3d6a843d0590","event_cluster_id":"d4e4377a-959a-445e-9e4e-9d1461ec884e"},{"claim_cluster_id":"b9198f54-dcf7-43b1-9ba8-28ae1ef79e83","event_cluster_id":"86cb3ea2-a54e-4579-b9f8-fb1dc6c8c598"},{"claim_cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","event_cluster_id":"921fce8d-f4e2-4dbe-b940-66b148c09f17"},{"claim_cluster_id":"4d988f33-ad00-4f89-acf1-b7ec63af7351","event_cluster_id":"6e8f5bec-2ba5-40f0-a873-4607c411beb7"},{"claim_cluster_id":"ab378ec8-ca7a-473f-b276-44d546196e26","event_cluster_id":"3f77000e-b7d1-457b-963f-2743a0bda688"},{"claim_cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","event_cluster_id":"bf8826dc-7456-4789-a5d3-9f4e1ba1b8de"},{"claim_cluster_id":"d8483e15-c78b-44e2-8070-c109cff73a66","event_cluster_id":"5e19ce7f-9db8-4e0b-8a22-b9bd4624ed1e"},{"claim_cluster_id":"5da699cc-92ad-44e6-a24b-61100072b99f","event_cluster_id":"9e93a133-57d5-49fc-821c-7ad0cab51a96"},{"claim_cluster_id":"886176d6-1057-4021-8312-570a3e3f4e10","event_cluster_id":"d9b500c1-45df-46d2-84a9-276291e99b35"},{"claim_cluster_id":"3d647896-bc7f-4815-a99e-768cb2498250","event_cluster_id":"90d35003-13f9-4cd3-a3c1-b7524ac5bf16"},{"claim_cluster_id":"7ebece62-a589-49b3-b28f-b8f565ab7327","event_cluster_id":"4a1c13c8-b1bc-47b6-9e32-b9200ffdf048"},{"claim_cluster_id":"338d5a8d-64c7-4bed-a37e-208196096015","event_cluster_id":"0f5915ad-4edd-49f6-8855-92a02e00debd"},{"claim_cluster_id":"e3141392-e630-428b-ae45-6d5589bf7443","event_cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"e46f2bcf-e185-4401-89f0-e7da4fcba567"},{"claim_cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","event_cluster_id":"9b47f058-2394-458a-97b4-e9b218a76e1d"},{"claim_cluster_id":"284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5","event_cluster_id":"a8c2e9f8-294b-4cdb-94e4-c3571edcab24"},{"claim_cluster_id":"c18b334a-f61f-4400-b355-cea2e7375866","event_cluster_id":"580850a7-5c15-4040-b450-cddffd7f1f89"},{"claim_cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","event_cluster_id":"4f8224c3-991e-41ac-a885-d9b58bba5d47"},{"claim_cluster_id":"400218af-6cc1-4f06-8e3d-7804bde6ad17","event_cluster_id":"d6d62bcd-4470-422b-bfb3-13d5db2da751"},{"claim_cluster_id":"4157a1dd-b3d1-4769-8ef9-bd2189b4146b","event_cluster_id":"fce3f86a-8cbe-4d55-ab8f-cc8fde0d8d33"},{"claim_cluster_id":"574866ae-31fe-4cc6-8d31-fe21c9fdd682","event_cluster_id":"82ce4ef2-05ed-42ad-830b-f78ec5322a5a"},{"claim_cluster_id":"b7768432-bcaf-4a4c-9bb2-1a6e02c6a003","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"6288e205-b9e8-41be-a3f8-80b06b50c037","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"2706ec99-75d3-433d-ab95-f5c524eb1832","event_cluster_id":"700f4caf-4655-44d6-adcf-68f6a654752b"},{"claim_cluster_id":"9d6e8c23-1cba-47c9-9f43-333717df0abc","event_cluster_id":"30f48da9-bf4c-41d0-ae36-a76653721604"},{"claim_cluster_id":"d9f4e411-98bf-48bc-a372-2ef5b6cd17d9","event_cluster_id":"505d0868-59a0-4692-bf8c-7c412af4f91a"},{"claim_cluster_id":"55c660bf-50f6-447e-81a1-ddecdab998ee","event_cluster_id":"6274d1ce-c7d6-4cef-9ec4-e52018d2a528"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"9b129e4b-0540-473c-90ae-ff21e622eb3c","event_cluster_id":"e1d7b348-32fa-40c2-a6a1-5325b5923ab6"},{"claim_cluster_id":"76e2cae3-f195-4448-9b25-588665927aca","event_cluster_id":"31add754-e383-4634-98fa-f95a97ec4597"},{"claim_cluster_id":"066ea292-674c-44ee-8c3c-799b0ecf024c","event_cluster_id":"5d2d76b5-bc12-46bb-8cc2-844165ffb7e7"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"7370dfbb-74ea-4d34-82b7-9398b71ecd5a"},{"claim_cluster_id":"c4bd1c97-a831-4763-9c03-6a3cf69f7caa","event_cluster_id":"990108fa-17d4-4b4c-865d-d0668a8a4d9a"},{"claim_cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","event_cluster_id":"41aaee2b-0ddb-4eee-87a5-d0d95635a46f"},{"claim_cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","event_cluster_id":"89a9391f-b100-4030-bab0-22344532ac00"},{"claim_cluster_id":"098acc21-62ca-42b4-8206-4df179ae28c3","event_cluster_id":"b3b9380c-37e2-402a-8ec8-0e1aeaee4ebd"},{"claim_cluster_id":"8143472f-9ddf-4467-8402-c46a70ccaf1e","event_cluster_id":"dbf82ccc-f0d2-4cf1-bdc7-044687b587cf"},{"claim_cluster_id":"affa89a3-9b82-426c-9616-b589325af10c","event_cluster_id":"72242d20-ab02-471e-ba74-fd7caad2c382"},{"claim_cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","event_cluster_id":"d3157e1e-5fca-47d3-93bf-fb77fbc5070d"},{"claim_cluster_id":"93eceb5b-454d-4e3d-b632-57c5588aea34","event_cluster_id":"14b70932-c015-4ead-b1a7-d8a04640aacd"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"c474ebeb-fd96-4c94-8aa4-35666d0af3d1","event_cluster_id":"8a0a3a15-f4ec-4089-82e3-0da6ba69f921"},{"claim_cluster_id":"e2f88c16-103f-497d-a88a-e63349d63a62","event_cluster_id":"4061c2fc-ed9c-4f22-92dd-291aa2df6a90"},{"claim_cluster_id":"453d17a8-fa49-49dd-82fd-7c3661e026b6","event_cluster_id":"44b69b95-01cd-47b4-9aae-cbe7e39103ab"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"e440fb1d-afb5-4fce-9f0b-110db0f93b32"},{"claim_cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","event_cluster_id":"228f2026-3094-45be-9c29-b363d30f00b6"},{"claim_cluster_id":"a24c9e44-7dfe-4825-ab38-82d2ff8a84cc","event_cluster_id":"28a15364-02e7-4073-a1fc-8cee3087565d"},{"claim_cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","event_cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"},{"claim_cluster_id":"eb7fddda-fe98-408c-a2d5-471f6b5aac76","event_cluster_id":"95532b75-d1c7-4667-9939-ac7ea0f83b09"},{"claim_cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","event_cluster_id":"00d7befc-64bd-4735-b672-5969c77fe7d6"},{"claim_cluster_id":"2f3c2293-d820-4cb3-836f-6df8faee07a8","event_cluster_id":"f9c1e4b6-836b-439a-971b-99d6ec437f1d"},{"claim_cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","event_cluster_id":"652f545a-2cde-41d4-9382-f23ab9d1b406"},{"claim_cluster_id":"101b3e01-9e80-483b-82e6-39667fb77d18","event_cluster_id":"84d8eefe-324c-44a5-b6d1-c374c46cc323"},{"claim_cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","event_cluster_id":"c9d1dced-4dd7-4c70-87e5-a257d37a3ec7"},{"claim_cluster_id":"0a27f80b-b648-4764-8688-fd889dc32a39","event_cluster_id":"9651dd4d-7b1c-4486-aece-757b68331a49"},{"claim_cluster_id":"6b12e24b-6d9d-4b0e-a169-260972b9ab69","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"a84f79d2-3818-45bb-9cd9-eb739e78bee2","event_cluster_id":"b8f80339-9419-4259-b0c6-1e550ab9ab7c"},{"claim_cluster_id":"f92684c8-da9a-477a-ba9a-9eb41a6f9f90","event_cluster_id":"76bfb6cb-c00e-452f-b533-a19a6ee05a39"},{"claim_cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","event_cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a"},{"claim_cluster_id":"20c941a8-b922-48e3-8e56-e49e1a524fd9","event_cluster_id":"c160d7d3-0687-4ba7-86ad-32e9cddeaf56"},{"claim_cluster_id":"a7043201-daf7-4ddc-86e1-fe3a850942e2","event_cluster_id":"e2b19af5-6b63-47c0-a565-18520484a0a6"},{"claim_cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","event_cluster_id":"77f3be19-2659-460f-978e-d15cb9d38644"},{"claim_cluster_id":"4370b159-681b-41a0-8da8-22c407b09da9","event_cluster_id":"b627252e-5ed6-4562-833d-dbc3b3ef2c2f"},{"claim_cluster_id":"980136c6-363f-4cda-bc50-cca417518993","event_cluster_id":"f5a99e33-6c8e-438b-9a1b-7d2b95dadd27"},{"claim_cluster_id":"cdb08998-bbe0-4530-9534-7744fb962961","event_cluster_id":"60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"},{"claim_cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"5b34f4e8-867e-44ea-b5c2-c5295a09dd5e","event_cluster_id":"7a09649a-0d1c-4211-a9ef-65dbb223fc3d"},{"claim_cluster_id":"19b19cf8-a65c-454e-84bf-36d3044b6f73","event_cluster_id":"bff86a30-1fbf-4d67-9ee5-a1b9649be76d"},{"claim_cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"8499f04a-3cd9-4588-b8dd-3abc1c538bcf","event_cluster_id":"72f48981-b5f2-4358-be23-5c1438e13df0"},{"claim_cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"5d21e7b3-dd0e-453e-8871-eb57102f00e7","event_cluster_id":"f1fd6338-9958-4c6d-8d13-636315f421f2"},{"claim_cluster_id":"29780617-dcdc-405a-a7d2-26d05fd8f9d4","event_cluster_id":"d5f8926c-cfe4-4355-8a20-781d575d7616"},{"claim_cluster_id":"05638bd6-42ef-4049-b6f6-4a5478e7b8a5","event_cluster_id":"ebf6d20f-e452-48e5-b5e3-66d4779751ef"},{"claim_cluster_id":"c55d7e50-ed13-4f98-a396-412d6e19decf","event_cluster_id":"009b82df-6fc2-417b-9cb7-3440f511ecfe"},{"claim_cluster_id":"009e9d6b-ab96-416d-b96e-b7eaada086cf","event_cluster_id":"2cf7e8e6-c492-424f-8353-8feea83e3711"},{"claim_cluster_id":"5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb","event_cluster_id":"a4b1d7b9-3c74-43c7-9743-4531782b8384"},{"claim_cluster_id":"b34ea819-97f6-4215-92c0-351b2f770110","event_cluster_id":"9555579e-0753-4a7b-be6a-da884e2c8547"},{"claim_cluster_id":"5284ded1-5c85-415c-af66-ad36ef47b3e7","event_cluster_id":"d4f9c49d-3b78-4035-b051-f58469f25ba7"},{"claim_cluster_id":"88a5288e-7f93-4e9a-8960-db23a08024fc","event_cluster_id":"b20e50fd-ac66-49b1-9139-e41a882a2619"},{"claim_cluster_id":"33c9ef05-1d84-4ad3-be17-1fea5c70facc","event_cluster_id":"ae8ea636-d211-440a-9860-24ae4efc00ff"},{"claim_cluster_id":"8f07bc53-1683-4b3a-b1de-2e1c15c0e13c","event_cluster_id":"1352067a-0981-4dfc-bf7b-193db2160af5"},{"claim_cluster_id":"3c0cf1f8-c44a-4a0b-9f9b-6b44ff81b740","event_cluster_id":"b0b9c7b4-b931-48a5-9e3c-e3d43990149f"},{"claim_cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","event_cluster_id":"777a09d6-6401-47e3-a2d4-ee63f89442c3"},{"claim_cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","event_cluster_id":"af198123-e2b2-48b2-baf8-af5aa8446190"},{"claim_cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","event_cluster_id":"dba7c6a5-c30c-4cba-8cd3-01cb02220cb4"},{"claim_cluster_id":"8ae88722-b8db-4d5b-b13e-130f65630e05","event_cluster_id":"54622f56-5371-48ad-b7b0-c52dd54c9e1b"},{"claim_cluster_id":"4e78b61e-317a-4417-b42d-464646384193","event_cluster_id":"402b3ff3-63dd-42e9-9d2c-888f81934ca4"},{"claim_cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"2af31319-c3b3-4fb2-ab4d-68df1d72b458"},{"claim_cluster_id":"9cf07839-b78b-4d19-aeee-e70ec12a23d1","event_cluster_id":"e63bcf8f-4e49-4048-bed7-415583eadc3f"},{"claim_cluster_id":"c5855521-5ebf-478e-a7af-b3f07554a912","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"cdb08998-bbe0-4530-9534-7744fb962961","event_cluster_id":"f6b81252-d691-43eb-b603-bbd2ec2ea3c1"},{"claim_cluster_id":"21361eee-5fe8-48f0-a512-8a8c4752daae","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"199eabc9-e7b3-44cb-a574-bbc02ea956e5","event_cluster_id":"a10aa5dd-2106-4783-8254-02da84449919"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","event_cluster_id":"9eb9a341-e59f-4fbf-b178-ccb6bb25eb49"},{"claim_cluster_id":"916339bd-3e65-4fc3-be04-12020f45e716","event_cluster_id":"36f9b8df-5b64-4298-b779-2814d4de3b9d"},{"claim_cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","event_cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"},{"claim_cluster_id":"a162a552-43bd-43b6-925a-ac7f9fbf4734","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"da5651eb-e7b2-446c-9fdb-dc89d46a36a7","event_cluster_id":"2dadee48-a44e-49fd-a481-3bd3ad498e90"},{"claim_cluster_id":"644ce0a3-b992-4dbe-be7f-558277802f15","event_cluster_id":"7d49ce46-2d8e-42e4-a5d6-ea4a010fe5e5"},{"claim_cluster_id":"4e78b61e-317a-4417-b42d-464646384193","event_cluster_id":"93fb31b6-e8df-4e78-9be7-574ea4c2f86b"},{"claim_cluster_id":"19581d0c-22b5-4ff0-8a68-de86fb01009c","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"d8f02a31-c29f-429d-b5f0-720768af0f52","event_cluster_id":"aa149821-edf1-47da-a3a7-3f82f411bb32"},{"claim_cluster_id":"b0c0fbc8-3a87-4290-a45f-69e062e04cee","event_cluster_id":"78d5de97-f7ee-44e0-8fbc-dba1797c97c4"},{"claim_cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","event_cluster_id":"b8ea1565-defe-4a1d-a235-40a614cdd9ce"},{"claim_cluster_id":"c0057031-5868-445b-98d3-d536042f59f2","event_cluster_id":"e2d48429-fbf6-47b6-9165-78445c0d3741"},{"claim_cluster_id":"17a14bb5-8594-4aa3-9c74-e077722ac66c","event_cluster_id":"77f62262-b0e4-4158-9a7a-25a427bda979"},{"claim_cluster_id":"983e06bd-8aef-468f-888f-6f39b0353693","event_cluster_id":"10b72ca8-fbc7-465b-bc23-1509272e1515"},{"claim_cluster_id":"f8121c44-24d3-465d-8607-2a909285d318","event_cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56"},{"claim_cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"a5a6c59f-7670-4f97-9c2b-c94700d73131","event_cluster_id":"357e7a15-3b62-4e9d-ab34-f83d8c925763"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"75154ca6-776f-46e4-8f4a-2221f93d7ff0"},{"claim_cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","event_cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"},{"claim_cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","event_cluster_id":"e0e899a0-65d4-45b2-b3be-ff8320d1837a"},{"claim_cluster_id":"2a9019de-d820-4155-a78b-fc972ec57552","event_cluster_id":"9164197b-fffd-43a5-9a7a-407af1a26959"},{"claim_cluster_id":"fcb57169-c911-45f8-98e1-10aa6c573c38","event_cluster_id":"3f03bd41-3bd2-497e-a6ae-2bf64a55fb55"},{"claim_cluster_id":"d42f0707-162e-449e-86fe-0dd5e2885a21","event_cluster_id":"e128e0c8-745a-4ce1-995d-c5a2ac809b5a"},{"claim_cluster_id":"481f70cc-e9a5-439c-8065-a4dc8e63bd0b","event_cluster_id":"b5c5d896-8437-4aaa-ae03-95c8865a2ac0"},{"claim_cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","event_cluster_id":"21f0a219-a107-4e6e-aa28-e010ad5aec66"},{"claim_cluster_id":"6768580d-67cd-4040-b98a-9d8276f6f0bd","event_cluster_id":"76bfb6cb-c00e-452f-b533-a19a6ee05a39"},{"claim_cluster_id":"40a361aa-d57e-4e3c-9740-34505f34913c","event_cluster_id":"3062f8bf-848f-45a7-a46b-1596767052bb"},{"claim_cluster_id":"03915ee1-228c-408f-b93a-594ce2e45136","event_cluster_id":"0ecf145f-a19c-4bc9-bccf-6b5ec58579be"},{"claim_cluster_id":"5d8dea5a-b22d-41be-9ea5-91141c9a7614","event_cluster_id":"f2c360d4-d94d-4684-995c-edf2696b6aa4"},{"claim_cluster_id":"b213b3ba-db75-4c42-89bd-97de55c18b3e","event_cluster_id":"27eeb806-4cb4-4391-b4c7-c7f87a7b6cc2"},{"claim_cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","event_cluster_id":"425c03b2-a548-4c2e-a981-8c6f7789018e"},{"claim_cluster_id":"6cf558a2-c2e5-4467-b5b0-ac3ede97ca96","event_cluster_id":"7f0d4bc0-739c-4027-939f-98e2607340fa"},{"claim_cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","event_cluster_id":"d53538f2-6557-4a35-adbb-a2eefd4e49a8"},{"claim_cluster_id":"565acc40-efdc-4957-85fb-8602f0587aa9","event_cluster_id":"92352325-85b6-4726-9aed-67119e9599f9"},{"claim_cluster_id":"f07cc872-d3c5-4a88-8201-4dce67c0d460","event_cluster_id":"65fcd3e0-1f44-416d-b2cc-adb2b3a6c31b"},{"claim_cluster_id":"dfd9bb6d-a08b-428d-8e19-e9eebd219088","event_cluster_id":"9dafd873-19fe-4111-b162-3c6894ed8aa4"},{"claim_cluster_id":"6c53a575-96c0-4b04-a196-adb1bbc90de7","event_cluster_id":"48b40da6-72cb-45c4-8c2b-8924870132bb"},{"claim_cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","event_cluster_id":"f957765a-9482-4d2f-9d6a-a1c90e6281d6"},{"claim_cluster_id":"24f6a0c0-6612-4488-bc48-40d12340ab22","event_cluster_id":"60d29486-ed0b-4997-a613-db65a447090a"},{"claim_cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","event_cluster_id":"061483cd-3b7a-44e0-857c-a5c4129b4272"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"98bac582-09cd-476d-9519-fe434dffcb9a","event_cluster_id":"985e777f-c3e3-42f1-b650-98ac19e7f7b5"},{"claim_cluster_id":"b44cd59b-4971-4182-8766-9ffcf4ae83ce","event_cluster_id":"6aece148-00ae-441a-a570-cbee981c2154"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"16428f67-cf62-4386-a190-51cc23ca4b78"},{"claim_cluster_id":"9c99e4fa-6c0d-4aa9-bb98-86450c898d1b","event_cluster_id":"f2c109a3-30b0-4718-85b7-78d12406aef5"},{"claim_cluster_id":"88b5488c-d8fa-4baf-af94-ea104e983a2a","event_cluster_id":"29696d33-676a-411b-9f2f-5aad8a647ed0"},{"claim_cluster_id":"42c5367f-fb48-41ea-b66c-1b344a5b61cf","event_cluster_id":"be927411-ac53-461c-bb59-5232d4963861"},{"claim_cluster_id":"78cbe3d8-37f7-4a89-956e-f6dab20ad8d1","event_cluster_id":"815bc458-4e48-4001-99cf-32e4675d4871"},{"claim_cluster_id":"aa179085-85ff-43d4-ba04-8a3f88267ae8","event_cluster_id":"2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194"},{"claim_cluster_id":"fc0f4ff8-8147-4b0b-be66-dcae01810fe6","event_cluster_id":"03d40e2c-2130-4e6f-94d8-afd7a1bdc223"},{"claim_cluster_id":"5881fb7d-2030-4406-a7ba-0a95befea17e","event_cluster_id":"a3d2d431-d86a-4c7d-bd04-db410111f7fb"},{"claim_cluster_id":"93c53898-2dc6-423b-a4d6-b61dd90c6d6c","event_cluster_id":"3d7847cc-aacf-44b1-8832-6089b6ace8d2"},{"claim_cluster_id":"f87de08e-1790-487e-a827-12378ebf4309","event_cluster_id":"9e250f91-2983-4cf6-9b29-817f4271a911"},{"claim_cluster_id":"13fc2321-1fdf-40d3-8576-3d7e5eb9e53d","event_cluster_id":"e9b589b6-86cb-4a37-aa98-5330f27ba5fb"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"c9770c33-6591-4102-923f-7ca010384410"},{"claim_cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","event_cluster_id":"9612bbf2-b65c-410c-9475-7ee689b849d9"},{"claim_cluster_id":"d7e9e6ed-b598-46a7-b7ea-6197df41d3ad","event_cluster_id":"2d27e988-7b20-4d35-8415-461b2756da32"},{"claim_cluster_id":"2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37","event_cluster_id":"41a86152-c66a-450d-8bf6-edd50f6928b1"},{"claim_cluster_id":"f34203f2-30b3-4686-b2f0-e124d8a67272","event_cluster_id":"11d3cdd7-b203-4792-91e4-e32314bbcbc2"},{"claim_cluster_id":"0166ea62-85f0-412c-bd73-f3d7bc1bdf59","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"eee91c5f-8ac6-4779-af53-8a01aa4eaa03","event_cluster_id":"3ed099b8-1d1d-4e40-a70d-caf7e4853619"},{"claim_cluster_id":"e1572e16-5f85-4ebb-a6fe-2ab18bee1c48","event_cluster_id":"373b4029-0616-4e8c-84dd-67212ba62068"},{"claim_cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","event_cluster_id":"012b2764-4f2e-4783-9281-b3cc16d33a77"},{"claim_cluster_id":"2c9fc1d9-b4d4-4707-a2ac-1245937847ac","event_cluster_id":"46c103db-5ea3-4b23-91e9-342a8a2c0506"},{"claim_cluster_id":"3be4473d-cbba-49ee-93e6-36d5bcd0dc0a","event_cluster_id":"02b6e00f-ac14-433e-bf3b-9d12b116fbc4"},{"claim_cluster_id":"b686bd17-fb36-4b7b-9caf-084f8d91c149","event_cluster_id":"a343f83f-a09c-4c76-ac05-045d273e90c8"},{"claim_cluster_id":"478db2a7-a90d-4fbf-8954-0416daa97dcb","event_cluster_id":"fae21323-4e89-4f46-9b05-1eb8df8ce6f1"},{"claim_cluster_id":"03915ee1-228c-408f-b93a-594ce2e45136","event_cluster_id":"e8299254-b0bc-4a3f-86b2-fedfa746efb0"},{"claim_cluster_id":"843bcba9-c863-41a3-a76f-01fd61d56529","event_cluster_id":"ec7f8d90-641e-4755-b398-833e150c7057"},{"claim_cluster_id":"86d26636-5c9c-416b-94e0-e2a89a9628c3","event_cluster_id":"bd8ae460-e56a-44c2-a9f6-3ae3b4d65792"},{"claim_cluster_id":"c91afcbe-198a-44cd-83c8-42c89811dab9","event_cluster_id":"f5e1b739-645f-4391-b201-66a90f3725ef"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"1eb307cf-2274-463b-9ab8-19aee3397703","event_cluster_id":"640f326d-efe1-4293-bfc4-0c4c7b9185f3"},{"claim_cluster_id":"3e200fec-9dad-4a2e-a5e4-655848ec7983","event_cluster_id":"2f4a9e86-aaa1-4911-a5a8-85e77f2e4012"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"58cd02fb-21db-4abe-ae72-bb8a28bb5670"},{"claim_cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"f15167ff-a614-4854-ae28-529950f00bdc","event_cluster_id":"35df1ff6-45be-4230-aba5-19c41bc2020b"},{"claim_cluster_id":"b459615c-cbbe-438d-9dbf-cc3051ba017f","event_cluster_id":"51ab1b42-afd5-4a90-95d0-c298f52dc502"},{"claim_cluster_id":"984134b7-51eb-489d-965e-a939f985e06f","event_cluster_id":"4bbf6020-dd21-405a-9c26-bdeb387928db"},{"claim_cluster_id":"7fc9b449-7f4e-4cec-90a6-b1dab2836291","event_cluster_id":"cea72470-6f49-4d89-a6fb-4c1596600c5c"},{"claim_cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","event_cluster_id":"ea50bb1c-1d0d-46d0-8c9e-6b1bcd539913"},{"claim_cluster_id":"f46bebef-6c63-4778-a5c7-e0d7b893e969","event_cluster_id":"2f612694-7e7c-42ff-aef8-a4f09e365266"},{"claim_cluster_id":"fe10e346-5245-4859-9317-c6ffae804527","event_cluster_id":"5f6424e4-0455-4ee2-821d-018975472c03"},{"claim_cluster_id":"f309b6e7-458c-4f62-9d98-f12cb2e89c08","event_cluster_id":"ac17d012-fb03-4978-afab-d0ee9527705d"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"3d7436aa-4609-467d-a098-e24702a617e8"},{"claim_cluster_id":"346be717-a4b3-4210-bff0-be972806b6a4","event_cluster_id":"a4dde064-8077-4a0c-97de-40075984b4cc"},{"claim_cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","event_cluster_id":"556da1e6-535a-4511-ac9b-649cb3eafe84"},{"claim_cluster_id":"96a4146b-b919-413a-b5a7-7801adae1906","event_cluster_id":"fca8c069-2da0-43e8-8cac-08662970bcda"},{"claim_cluster_id":"df17af70-aa4f-46d9-b191-eb3b4eeac1ef","event_cluster_id":"23f200a8-82be-479e-8c62-e16a5b3450e2"},{"claim_cluster_id":"7811b1ac-b0e5-4c92-a933-500f6b892437","event_cluster_id":"7ce5da07-bfd4-4121-8e0d-acd582b0b4a4"},{"claim_cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","event_cluster_id":"48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75"},{"claim_cluster_id":"5d950548-da48-42e1-b748-275abdd34cfd","event_cluster_id":"4367ebc4-e97e-4992-a822-025c7b42b1b8"},{"claim_cluster_id":"44a47e28-efc2-4e0c-b9c2-18a93b3b20be","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"2f4a7179-3f3f-4eb6-8891-8b8d39467620","event_cluster_id":"7a7dc1ab-df88-47fe-b1e9-3558ecae338f"},{"claim_cluster_id":"7eefde16-5844-4305-a679-da87990a2640","event_cluster_id":"5e8c77df-b06c-4eb9-af9d-86a5548a4dfa"},{"claim_cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","event_cluster_id":"97ed4747-8726-498d-80cf-261756e7962a"},{"claim_cluster_id":"1d4acd59-7bc7-421b-87d6-c6dcd6e61497","event_cluster_id":"2ba9fcc4-8317-4968-94d5-129020e8a44a"},{"claim_cluster_id":"74ac8dc6-1d9b-435b-bae9-36745f271604","event_cluster_id":"c974679a-a285-4dfd-882e-18a49abd08e5"},{"claim_cluster_id":"290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45","event_cluster_id":"519a0144-fd4c-4d5c-9042-6fb50ccd2f56"},{"claim_cluster_id":"50fd260f-831d-4cd6-a164-2aef0978fbe3","event_cluster_id":"ea56561a-6c42-424b-a439-8949e0922884"},{"claim_cluster_id":"8f9f1940-08f3-4a29-938e-790645f67487","event_cluster_id":"ecf87520-6110-4dbb-8897-a76147b7c3f7"},{"claim_cluster_id":"03105f5f-d65d-4408-8071-b314d86ce573","event_cluster_id":"05840b29-9ac1-459e-98bf-cb3a11b4aeb6"},{"claim_cluster_id":"2f3c2293-d820-4cb3-836f-6df8faee07a8","event_cluster_id":"b20a6598-dc24-40bc-a9eb-7fdc252fc7eb"},{"claim_cluster_id":"44f7e426-bb87-4dd0-bf0c-80fb71c61eac","event_cluster_id":"36dc7f3c-7522-4964-8e5f-96eb7e85aa98"},{"claim_cluster_id":"424a981a-fddf-4933-92b1-158cbba9a861","event_cluster_id":"7f12aafb-6273-4f93-bae0-fb2dee57d074"},{"claim_cluster_id":"5dde6d54-8ecf-4f66-96dd-406048082082","event_cluster_id":"12c2b7dd-5504-45ff-b24f-40b180021ec2"},{"claim_cluster_id":"efb94acb-755c-41bd-b1f3-cb170deb0266","event_cluster_id":"b0157510-fe3e-44ad-a8a9-aabc1bfb9c12"},{"claim_cluster_id":"edbdc807-7fba-426c-a271-726e1f090eaf","event_cluster_id":"6701d78c-ba82-4b89-b97a-8fd70b5e34f9"},{"claim_cluster_id":"f210a15e-3afd-4f52-8da2-de7a59e25377","event_cluster_id":"ec47ea11-5e31-4849-97a1-585ce227df93"},{"claim_cluster_id":"596489a9-6207-48fb-8cf4-2972a01326d9","event_cluster_id":"07c01120-e316-4bd2-9ebf-b979d08b4da8"},{"claim_cluster_id":"428a1c85-5fee-4a1d-bbe0-9e71872e75e9","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","event_cluster_id":"128ade3d-bda4-4b71-b956-463eb584089c"},{"claim_cluster_id":"52902c20-eb03-45dd-8441-6d06b77f992c","event_cluster_id":"6f7eecf9-9f3f-44ce-8b0e-5a71d6961aae"},{"claim_cluster_id":"13fc2321-1fdf-40d3-8576-3d7e5eb9e53d","event_cluster_id":"7ba51ccd-9b62-47f9-b011-21d9bbe02ded"},{"claim_cluster_id":"af51e97e-2570-48ba-a0bd-ab0668831da9","event_cluster_id":"81d920c9-ff43-42e8-a37f-0d453a42e2ad"},{"claim_cluster_id":"d8483e15-c78b-44e2-8070-c109cff73a66","event_cluster_id":"473560b4-10a2-4370-be8e-3ebeae00ae74"},{"claim_cluster_id":"83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2","event_cluster_id":"216c68fc-7c8f-405c-8f46-568b32c69eb4"},{"claim_cluster_id":"1c24fe42-ed01-4d5e-85a3-6011ab09ff6f","event_cluster_id":"c0987cb3-5451-4fcf-a732-5bfbe94a56c9"},{"claim_cluster_id":"e3e4b634-fa33-47d8-9f29-eefdbb263769","event_cluster_id":"a418885e-cbb2-4205-a118-ea8172eaff33"},{"claim_cluster_id":"6f3f0719-064d-478a-ae5f-d9aca0368d4e","event_cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"2d060fd1-76c9-470d-941c-4c8d800b380a"},{"claim_cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"19ec7067-1e85-4e98-adf9-a107366a808b","event_cluster_id":"0594b862-5f0d-4a2a-9cbb-4d9d2192ea9f"},{"claim_cluster_id":"b2036724-7c6c-4df4-b983-90c324253873","event_cluster_id":"31f4be33-7681-4d97-9d26-1b6c02b644ca"},{"claim_cluster_id":"de116a88-705c-434f-9f3a-1fdabb457723","event_cluster_id":"e130a374-b2e7-4d68-8a8e-32dcab17656b"},{"claim_cluster_id":"a70a3157-f4e4-4eef-b960-bdf74270bd58","event_cluster_id":"1c4b6f2a-a55c-4baa-b0e5-6516b517f960"},{"claim_cluster_id":"c0057031-5868-445b-98d3-d536042f59f2","event_cluster_id":"f62b3b08-7f29-4635-afdc-c0569af97743"},{"claim_cluster_id":"509e1b1d-c464-406d-8d4e-6ab2f46f2324","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"38f73b32-c8c6-49f9-8452-aefe0c4fa642","event_cluster_id":"7ad20f50-14f4-4cdf-b21e-0c9b5f397fe9"},{"claim_cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","event_cluster_id":"38992305-30d9-47ce-bb30-bfa120506e54"},{"claim_cluster_id":"c831921a-fda1-47ba-83e1-1042bd97f245","event_cluster_id":"d35e4c86-fef1-49fa-8134-2537759e6118"},{"claim_cluster_id":"db608ced-e4c3-4573-8b19-bacdf06c1585","event_cluster_id":"1f127567-1266-42ac-9246-3f7f8bb52a6b"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"e8f2c1ac-40d6-4338-93ee-3033faec8f14","event_cluster_id":"13862105-6364-499b-aec8-a649c26c5b3c"},{"claim_cluster_id":"67674784-9e53-4907-a36a-9a45f8374e68","event_cluster_id":"d6edcbd0-8a76-4410-b54b-26039bf9a1d1"},{"claim_cluster_id":"aaa5b32a-96ba-4450-b886-70f714b65bf2","event_cluster_id":"3761b79a-ed1e-4efa-a004-8d3634d88c5c"},{"claim_cluster_id":"930ae324-24b9-4353-aa17-35d5e069f64f","event_cluster_id":"0f0ff324-b8f3-41db-88cd-a895d1f4a2d9"},{"claim_cluster_id":"aafcc6bc-c8f9-4a4c-acf7-9628f64db648","event_cluster_id":"d58686a5-53bf-4314-a7f1-f0e899bc8c82"},{"claim_cluster_id":"1dd25bce-7fe6-46d2-9e28-e803262696c4","event_cluster_id":"2b0eed50-da8b-45e1-8588-42e0093ff921"},{"claim_cluster_id":"6288e205-b9e8-41be-a3f8-80b06b50c037","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"a94e5bcb-b502-4cb7-a23d-3a1e29ce963a","event_cluster_id":"a397f3ea-2260-47ec-beca-b473be543d39"},{"claim_cluster_id":"2f8d9d1d-f145-459e-90bd-ebf833c6fe60","event_cluster_id":"abb6468b-1949-4a51-9adf-d3e014a3003b"},{"claim_cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","event_cluster_id":"2813da46-c92c-428a-9aa0-d5a6d2aae7d8"},{"claim_cluster_id":"4bcae16d-fb51-4ba8-8381-37355e0e9f18","event_cluster_id":"e5a3c503-081f-45b6-97d7-1fab2efba3f8"},{"claim_cluster_id":"3d2576b2-1572-432b-98fe-db8e768274d5","event_cluster_id":"f8f2a0f0-c3be-425d-86a8-e332c871c957"},{"claim_cluster_id":"29e9fc0f-b1d3-428d-985b-aead08ce4e3c","event_cluster_id":"88637747-174c-4782-89a7-a4bbdeb1e9e1"},{"claim_cluster_id":"a7867a02-8602-4251-af70-d100ee635a74","event_cluster_id":"ddc5360a-1ac4-443b-9995-2e77ae3fa0fc"},{"claim_cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","event_cluster_id":"ab98fd27-202d-413c-8332-5c4cfa41f02e"},{"claim_cluster_id":"136829a8-989b-4ffa-8ef0-ec23f5f18819","event_cluster_id":"dbfa0b87-7424-42ca-8827-733df18f150e"},{"claim_cluster_id":"e59930cd-f28a-4a44-8feb-24e860e36480","event_cluster_id":"2f2fd953-8be4-4011-bcf6-98e5b07a9282"},{"claim_cluster_id":"3630ee9d-368f-4623-9704-06881bdf9264","event_cluster_id":"5dc9068d-5bdc-499d-a865-8dc21a274dc1"},{"claim_cluster_id":"adc640bf-2d33-45f1-87f4-f455e4d88f72","event_cluster_id":"0ded9d87-ef2c-4d88-b3db-79b2f8e48989"},{"claim_cluster_id":"a70a3157-f4e4-4eef-b960-bdf74270bd58","event_cluster_id":"f5d2e5c5-6f09-4885-98b8-5062202897a8"},{"claim_cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","event_cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"},{"claim_cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","event_cluster_id":"be12c5b4-b051-4762-b77d-ca92a4063972"},{"claim_cluster_id":"17036568-8b0d-4108-9a16-98a16980ae3f","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"a2a57731-90ff-4a12-a08f-721a9dfc0b06","event_cluster_id":"10e8efce-e96d-4c64-a187-c3669a9d303c"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"a162a552-43bd-43b6-925a-ac7f9fbf4734","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","event_cluster_id":"84ba9e08-7f87-4e91-abf6-4415ddb9a231"},{"claim_cluster_id":"93d03ec0-ac83-451a-87b2-a95e3d58859f","event_cluster_id":"84e9da04-8cd3-4c61-8fa8-fb55a6309d3d"},{"claim_cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","event_cluster_id":"ebc26e14-b86c-4a50-a196-d8cbcc8aab8c"},{"claim_cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"b60b834e-1991-44ea-a53f-68d101a440a4","event_cluster_id":"ebed0c7e-1e7f-4dd0-9028-668b74f8c629"},{"claim_cluster_id":"da2845de-4e1b-492a-a6b0-06fd4584650e","event_cluster_id":"ac066abb-a95e-4ab2-884e-0a0fd4b40f30"},{"claim_cluster_id":"b5600099-12c0-41c7-bfb6-4b6bb66dc0dd","event_cluster_id":"42a6504a-75a7-4c6b-8491-655e6c73b864"},{"claim_cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","event_cluster_id":"1020a2ca-3e92-4f76-98e4-6f44fdfd5f52"},{"claim_cluster_id":"194a083f-fee7-4bf0-b198-fa40c8bdfe21","event_cluster_id":"1f7a9b1b-5ce3-47cc-9f13-4f47996738bf"},{"claim_cluster_id":"6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5","event_cluster_id":"0500f877-c2d0-4c97-b0d7-76dc88e38eae"},{"claim_cluster_id":"ca871236-c037-4fa9-b3bc-cfec982a8e55","event_cluster_id":"270b9be6-37c3-4ab7-9763-57943d7a38b9"},{"claim_cluster_id":"f833277e-e62d-4240-a8fa-fd6d79db3c79","event_cluster_id":"cb120bb7-e884-4891-9573-61c67b37ce2a"},{"claim_cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"ee6ffddc-d717-4a7b-a161-3d1bdc24c500"},{"claim_cluster_id":"1dc0ed5e-e098-401c-9b18-3dd42ba6b01f","event_cluster_id":"fe8daec7-d83a-4b36-9a29-fc5d4f9d4d89"},{"claim_cluster_id":"53ddceb6-33d2-42fd-849a-253f21907d2a","event_cluster_id":"4ca6827b-b30a-4210-a329-a338c23874a3"},{"claim_cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","event_cluster_id":"e50f2f1a-20bb-46bb-82c9-6def0deadc19"},{"claim_cluster_id":"f72f8aec-c684-4bb6-92bb-742f08817b1d","event_cluster_id":"2cd863fc-6aa3-4b22-ae05-f3da95690998"},{"claim_cluster_id":"7c8b94c0-08bd-43e2-9b5a-418ff416c274","event_cluster_id":"3ce0cb1a-1f92-4f2d-a2e0-fbdd35527908"},{"claim_cluster_id":"1a247a51-e7fa-46f4-b0b3-659a03d784c6","event_cluster_id":"eecfdbc7-a037-435d-b439-dc9fb3713fa6"},{"claim_cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","event_cluster_id":"da455fdd-d1bf-4166-b24f-377899985b7c"},{"claim_cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","event_cluster_id":"42663758-9518-49e1-a45d-11b8ad2a2193"},{"claim_cluster_id":"42d845ed-aaed-4d48-a0e4-2928cc3ba602","event_cluster_id":"1417deae-6f6a-444b-92e3-0d85e814d6aa"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"efd1564d-df50-445a-a638-9947d0e8404e"},{"claim_cluster_id":"7f43c7d3-2a4b-493c-b3f0-a53355ae39a3","event_cluster_id":"ba20492f-063b-4fc0-8bd7-26d88daa19d1"},{"claim_cluster_id":"f3328626-3764-43c0-a7df-3730b34ea1fd","event_cluster_id":"8a51d448-3e97-4522-acf3-ca3a46ef7aad"},{"claim_cluster_id":"95b38f6d-19e7-4fa7-a9de-ee665de84018","event_cluster_id":"ce0d6d93-def3-45e3-8bfd-1c14d5d947ee"},{"claim_cluster_id":"dfea6d47-10c8-4540-8a78-5667ac532c10","event_cluster_id":"ec7138ff-1f97-4076-a56b-198783100d75"},{"claim_cluster_id":"b0071c15-10b9-4a75-8b7f-486b9f2c04d1","event_cluster_id":"7014c024-82bc-4f47-b6cf-23a09be951e3"},{"claim_cluster_id":"30fdf9bb-e9b5-47e5-a899-e176ffa77eac","event_cluster_id":"0bf33c34-9525-433f-a535-5885b1ee4732"},{"claim_cluster_id":"da745b4f-4158-4c1c-b2f1-ec13252863b3","event_cluster_id":"222e0df8-36ff-4110-93f1-22c42e9ea101"},{"claim_cluster_id":"2f43e86f-24fc-4c3c-a77d-c5abbf46ef19","event_cluster_id":"8c990025-029a-4aef-bcf5-41326b6234ac"},{"claim_cluster_id":"b4295bad-3940-4b00-ac2b-862c41b5597c","event_cluster_id":"dbfd0383-d4d3-4b5c-a820-54e5dc7d2adb"},{"claim_cluster_id":"4ea56329-d3e1-48ab-835d-a5cbc403dcf0","event_cluster_id":"3422b937-ad13-407b-bc17-21e8928a73d8"},{"claim_cluster_id":"f10deefc-8ed5-4516-8cc2-3ba87195eac0","event_cluster_id":"b95182bc-1bb5-417c-822b-57af63faceac"},{"claim_cluster_id":"73aeb014-9fc7-4042-b2b1-7016c4fa8dd2","event_cluster_id":"0e5c3365-93fa-488b-b635-43b68052b0bc"},{"claim_cluster_id":"9d6f335e-c5fe-40ff-9edc-7ee5892fafaf","event_cluster_id":"0e128959-4be6-4a58-950e-03878e48a675"},{"claim_cluster_id":"b2568d68-53d4-487c-b724-0456b247a886","event_cluster_id":"5a676523-5e3b-4d60-979c-dc06042c89a3"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"8ef3f5ab-a5d7-4598-bbc0-95b969a66cac"},{"claim_cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","event_cluster_id":"db3b032b-6eb1-469a-8fea-f26d907c46cc"},{"claim_cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","event_cluster_id":"3a663e69-ed69-48a3-9c9e-25cdac30bcdd"},{"claim_cluster_id":"478db2a7-a90d-4fbf-8954-0416daa97dcb","event_cluster_id":"05359182-fefa-4fca-a6e5-68210986bdca"},{"claim_cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","event_cluster_id":"38bb4737-de3e-4b8d-b413-8281bb85ae27"},{"claim_cluster_id":"d2231d7f-5f03-4e76-b0ae-753fd54f4960","event_cluster_id":"ccdd5d79-92b1-4503-a1ce-51ccf23fc823"},{"claim_cluster_id":"5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1","event_cluster_id":"1231d1d1-38bd-406e-916f-d7769d05b29d"},{"claim_cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","event_cluster_id":"f7bc5745-3844-4596-a6d1-1d8cba63f4b6"},{"claim_cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","event_cluster_id":"c6d927b7-cd5d-4d4f-8175-fa9bbd32a788"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03"},{"claim_cluster_id":"ac4174c2-4597-4a76-ac06-95cefda372c9","event_cluster_id":"fc4f3449-d301-4936-a35f-47ca68ad88dd"},{"claim_cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","event_cluster_id":"3b5c9589-43fb-428f-a24d-ff67c6ec3e67"},{"claim_cluster_id":"96423d41-ee08-4c5e-bcf0-4dd1b431abc6","event_cluster_id":"a5de3945-d8b3-45a7-9c18-edeaa4ccf742"},{"claim_cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"6ca40c20-bd2c-4fa0-af88-bbe3820f05e6","event_cluster_id":"693c26f4-40f7-4d45-b4b9-51440f45735e"},{"claim_cluster_id":"a789dff6-b07a-42f9-812b-05be84eb01d1","event_cluster_id":"1fef267f-5c4c-4c0e-b98e-4a09e90f0341"},{"claim_cluster_id":"e30f1c65-b396-4183-98d3-9deb2bc6322a","event_cluster_id":"eb4cf940-96c8-499d-b7a7-939513787944"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"c0ac6691-abf2-4873-a338-41a4997bcb24"},{"claim_cluster_id":"cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb","event_cluster_id":"bafef2bb-9288-4a42-8a15-be9d11a861ef"},{"claim_cluster_id":"cefbf586-5d05-477f-8675-6637fb8781a5","event_cluster_id":"6ef25b46-a4b9-4af8-a6c3-f3258aa3145a"},{"claim_cluster_id":"d17d8e48-7844-4b9c-9bc0-e31d87299aef","event_cluster_id":"1a5017d7-a85f-401a-9c3e-9a087de588f6"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"eb95d7a1-b24f-4167-89ab-cc60dc7c7822"},{"claim_cluster_id":"f51d817f-9949-43cb-b16a-bfdefff947f1","event_cluster_id":"ce82add7-3d2e-4c0b-8f3e-d449dd7f2ee7"},{"claim_cluster_id":"6cade303-8a3e-4226-b5e8-0d3b189187cb","event_cluster_id":"ac4b1f63-94c9-4cd0-938b-a716a9ba6a09"},{"claim_cluster_id":"bd50210c-37cf-46e2-9d31-0c6a6dd06e70","event_cluster_id":"3128448b-d77b-4666-b5fa-39d7bf0fea69"},{"claim_cluster_id":"2aeb94af-8d5b-40ce-b754-91495083b2a1","event_cluster_id":"8820c527-2e2c-4341-bec1-16e1d5309310"},{"claim_cluster_id":"89a7a448-be37-40e3-973f-79b15dac979d","event_cluster_id":"a20fa4a8-bba3-463b-b15a-06c8b4daad85"},{"claim_cluster_id":"6a65158f-b873-42cb-b0bd-0cb1b60a0d86","event_cluster_id":"184f7da5-f557-4593-8954-67601ea3d345"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"bbb004ba-d35c-43eb-a8fb-f8fc936100c1"},{"claim_cluster_id":"d17d8e48-7844-4b9c-9bc0-e31d87299aef","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"},{"claim_cluster_id":"273554c2-556d-4017-8422-f543fd17c4ef","event_cluster_id":"78aa3214-a8d5-4987-ad02-0d4cd5db66f9"},{"claim_cluster_id":"655a46a8-9b52-4f61-b528-9f18ec9bf051","event_cluster_id":"4d3fc72a-c96e-4659-afda-27c7ce47c497"},{"claim_cluster_id":"42ec0ecc-4c37-4216-9671-a26ac18a9ead","event_cluster_id":"637c1c25-6bd5-446b-89ea-dbb02add4b34"},{"claim_cluster_id":"8d98ef20-8cc0-4e51-b441-315a42837e56","event_cluster_id":"ca872018-66c6-4a52-8d9c-e664e0716e90"},{"claim_cluster_id":"a1a796af-13af-4bb2-ad74-b64193c2de86","event_cluster_id":"53d09843-b0b4-4b4a-974f-76bfc4243e0c"},{"claim_cluster_id":"017c8345-ee2f-4b6f-8701-6def5bbd5082","event_cluster_id":"6d2e659d-b2ff-460e-98c9-72a4faf6173b"},{"claim_cluster_id":"3e5167ea-d839-4cc5-b193-fda2f9c0b53b","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","event_cluster_id":"56c21a67-f093-4d7b-81de-a41cb3a3c896"},{"claim_cluster_id":"6d2624a6-0551-4f8a-8ed4-2b7126ed6490","event_cluster_id":"56d8e5bc-dfb0-4e57-a911-a8a552ba1562"},{"claim_cluster_id":"7511bd1f-13b7-402b-887d-d4fe077fcba7","event_cluster_id":"41c6f905-1ba5-4740-a4f5-bc35586af666"},{"claim_cluster_id":"e8898157-febc-4868-87fa-8effb0a882e8","event_cluster_id":"19fb932a-d5d7-4981-804f-5245e467f600"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"4272dbf3-0c9a-42d8-a9a1-b2b3a349e192"},{"claim_cluster_id":"7e4a12f6-fe24-48f6-993c-d7197eb9c44e","event_cluster_id":"1034b1f8-bfe4-4bc4-80f2-8e57922001cc"},{"claim_cluster_id":"0f388428-daa1-4ce6-a7b1-8c553ad3896d","event_cluster_id":"64855ee7-ebba-445c-9213-c6921f4dbbae"},{"claim_cluster_id":"334a3914-b271-4b2a-83fd-f8bd4dbb0c53","event_cluster_id":"4d2908dd-c372-4065-827c-bbbe9d18c879"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"212cb6aa-4aac-4425-b0fc-6bb9b68aeb36"},{"claim_cluster_id":"8f15ddff-3bc7-4fbd-9371-1a897f8b9078","event_cluster_id":"ac3c6b64-fc97-40dd-93ef-f777610b8337"},{"claim_cluster_id":"c065f08a-341f-4084-99ca-ceef465c2c9a","event_cluster_id":"777da0e0-2515-442a-8eed-8174f7063a5c"},{"claim_cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","event_cluster_id":"e10e77d8-6d39-499c-97ff-017e9cdbf650"},{"claim_cluster_id":"33588f3c-4f55-41eb-b5d2-57696a57221d","event_cluster_id":"b5a04b5f-b3fb-4230-b364-c7b2ab5c4aea"},{"claim_cluster_id":"bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a","event_cluster_id":"0646d462-dfca-47fe-a0c9-5ac11b42cb7e"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"d1bd7e91-60d7-44c4-a3e3-fa4bad7dab38"},{"claim_cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","event_cluster_id":"d44024e8-81f4-4d88-982c-a023f24b58cd"},{"claim_cluster_id":"b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d","event_cluster_id":"a6f2fc25-ee4d-4748-9248-d40e233dda78"},{"claim_cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","event_cluster_id":"c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f"},{"claim_cluster_id":"83ec8695-6d93-432e-a8be-81705e2e2a54","event_cluster_id":"5982b5d4-204d-410d-a74c-8426e91d2bd1"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"003d2fc7-16f8-4835-a770-b85123b3c250"},{"claim_cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","event_cluster_id":"d5777d75-d1f3-4884-9f6a-615b36a875d0"},{"claim_cluster_id":"bf53e706-320e-4307-85d6-fcee526f5f17","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"2c9fc1d9-b4d4-4707-a2ac-1245937847ac","event_cluster_id":"f4bded1f-3dd1-4137-af03-3dc33133634e"},{"claim_cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","event_cluster_id":"f8ac7419-698c-4d8c-9bee-1803e1e62a78"},{"claim_cluster_id":"6663d8fb-8d11-459b-85ff-7054f5d07b06","event_cluster_id":"5fedf7dd-6fac-4316-b725-5d2fe32ac129"},{"claim_cluster_id":"e30f1c65-b396-4183-98d3-9deb2bc6322a","event_cluster_id":"edf45ed0-2320-4899-9b2b-3485b276ff56"},{"claim_cluster_id":"7d04ad0f-dee5-48f3-910e-0b2281b15f1e","event_cluster_id":"0829b680-8676-4565-bcc1-70f1f8778ca5"},{"claim_cluster_id":"c6f7c193-f407-447c-a10f-3ea5292ea3e8","event_cluster_id":"17a99d17-d7ec-4cf5-8a94-b29753d62b97"},{"claim_cluster_id":"856ae956-c845-42c3-8716-9e150f646a11","event_cluster_id":"80b5a69e-5f2f-4b54-a7e5-680323a8c096"},{"claim_cluster_id":"13b8e657-b1a1-46e6-ace5-fc6a57928a32","event_cluster_id":"ce22089b-598c-40ef-ab32-85ce5e1f2d4f"},{"claim_cluster_id":"aafb6f56-e150-4de6-8f24-4e8fe467b23f","event_cluster_id":"54ac5876-c16b-4f4f-ac8b-44b5ec31d0a3"},{"claim_cluster_id":"6b512fcc-e6a2-414b-8a86-90a11b76795a","event_cluster_id":"d481c919-0d2f-4cb2-bfd7-956740c2c572"},{"claim_cluster_id":"65cd54b0-2f90-4b59-a573-5917ec27f9bb","event_cluster_id":"254e946c-9e7a-429c-b142-d41e38953b50"},{"claim_cluster_id":"bc2e7af6-3507-403a-b41c-f6013dcfcf6c","event_cluster_id":"873c2a4d-0ea1-497c-90c1-2ef71ec73e8d"},{"claim_cluster_id":"3d8a0674-b5ba-4875-8267-9c46797d5ef5","event_cluster_id":"cf3bf537-5d66-4200-ab53-fd6a34c1b11b"},{"claim_cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","event_cluster_id":"5a7cebd4-db2c-4dcc-8a5c-86e950acfb54"},{"claim_cluster_id":"3051427a-61ac-4a57-816c-f2ad62bba5e0","event_cluster_id":"7df19845-e2c9-43df-ab08-20e640d2669c"},{"claim_cluster_id":"af3f95a3-d597-4371-bf7f-e4f5d91a9b73","event_cluster_id":"ffccc68c-8962-496e-be7a-e09d954b9f4e"},{"claim_cluster_id":"839faa06-15df-459d-8f1d-015981c670e0","event_cluster_id":"7957f359-526a-4b55-928e-2a84077427a5"},{"claim_cluster_id":"ceabee0f-bc28-4b8e-8445-fc63ff551472","event_cluster_id":"ad2a393e-2bc5-4c0d-addf-577399b7b41d"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"01a95de5-1ee0-4431-afa3-a8234a4831ac"},{"claim_cluster_id":"1dc1ea0e-ecc0-4a99-a555-3574b46d8688","event_cluster_id":"3d51ea74-3b4e-41f4-8d23-b8b5e017e1be"},{"claim_cluster_id":"e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9","event_cluster_id":"889e78e7-a427-42ef-b24d-0164df4f19bf"},{"claim_cluster_id":"77de10dc-6dcd-4902-a9d2-f5cf9384d343","event_cluster_id":"ceeb447c-921b-4bff-b396-64b4ab69cf19"},{"claim_cluster_id":"62ff82d6-7a81-4618-a5c7-dad49908ecf4","event_cluster_id":"4aeb0c0d-181c-4cfb-9c1f-7338a1c0e097"},{"claim_cluster_id":"b570ae3c-f72b-47a9-b995-64ca6b5f3ae0","event_cluster_id":"d748d1bd-38e3-44b3-b268-429f4615acee"},{"claim_cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"ecf280bd-73fc-4028-90b4-eae0d740ef40","event_cluster_id":"4a281b46-5b6c-4de0-b8bf-1d3cec2f1919"},{"claim_cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","event_cluster_id":"f1b261ff-b08d-4eda-9ef1-3dbeca804b57"},{"claim_cluster_id":"b2a7204e-e5ad-4d5f-8464-67520217c392","event_cluster_id":"b0a9927e-dfb0-4578-8343-304f2917ace8"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f597184d-050f-4a51-9461-70b55cf2b05c","event_cluster_id":"e86748c4-2789-4941-b470-d29321693c17"},{"claim_cluster_id":"579db367-74ad-4432-9888-8af443f74bd8","event_cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337"},{"claim_cluster_id":"ef49913c-d983-49cf-b90f-4529857c36a4","event_cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb"},{"claim_cluster_id":"d1c29947-a7e4-41cf-9656-837e51b2de11","event_cluster_id":"0c6f8f11-1c81-417d-bf01-df519f70e0fa"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c"},{"claim_cluster_id":"9c99e4fa-6c0d-4aa9-bb98-86450c898d1b","event_cluster_id":"f2b7ea2e-02cf-4061-b076-60c350522e8d"},{"claim_cluster_id":"f21a34f1-8f4b-45c1-80d1-4a2fc8e55091","event_cluster_id":"d8c99eb9-8781-4abc-9592-b545d9c15ce0"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"5219fa36-fd8a-41f9-b4a4-5e01b881c12c"},{"claim_cluster_id":"7ebece62-a589-49b3-b28f-b8f565ab7327","event_cluster_id":"e47fa355-bcc3-44bc-97e3-0029cf946325"},{"claim_cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","event_cluster_id":"aae30a17-ea30-48f8-8399-1f3de025df70"},{"claim_cluster_id":"5b28f56e-4dc0-41d8-b963-a4fc04cbaf08","event_cluster_id":"735c3d6c-a597-44bd-92cc-d934d1e29409"},{"claim_cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","event_cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc"},{"claim_cluster_id":"af2dae39-7b57-4e0d-909b-c39b56de0088","event_cluster_id":"e9ec4305-aed2-424a-9a57-210fed19fa52"},{"claim_cluster_id":"2c9fc1d9-b4d4-4707-a2ac-1245937847ac","event_cluster_id":"0313a78d-59e1-4fe7-8d40-5db79d99214e"},{"claim_cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","event_cluster_id":"2ce189ee-012a-443c-b12c-079c48f7f1a8"},{"claim_cluster_id":"1da5d8fa-d5b3-4c58-9989-3b5775687e42","event_cluster_id":"578d69cb-06e2-4455-a662-a864e327b852"},{"claim_cluster_id":"53da7ed0-9d8e-436f-b097-49ff62b95459","event_cluster_id":"416a789f-b094-4d93-9898-3707b0bf84ed"},{"claim_cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"e37c8f7a-2656-421b-b216-1d87659bcb44","event_cluster_id":"72084673-8080-44fd-8f5b-97507abf262b"},{"claim_cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","event_cluster_id":"2c20a8ae-1d47-4c90-a5e4-88e406d3334f"},{"claim_cluster_id":"19ec7067-1e85-4e98-adf9-a107366a808b","event_cluster_id":"ab08e2a8-8249-4477-b0dc-0a3c5235d6a7"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"9a73096a-390b-4f9e-a044-22f30734ce69","event_cluster_id":"82c4576a-a59c-436d-bb23-2d15a1d9c903"},{"claim_cluster_id":"8cb34140-24ef-4173-9390-c1f84800160e","event_cluster_id":"347223d3-908d-4003-9d32-5f2929c89e51"},{"claim_cluster_id":"5dac5b6d-e9df-41db-9225-7e413ca3cacb","event_cluster_id":"29bfbe48-82ec-4d12-8240-7206925d2386"},{"claim_cluster_id":"32a2eefa-c8c7-482c-839f-be3b15138d40","event_cluster_id":"081350a8-a16a-45fc-b513-065a8ddaebac"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"fb065855-6920-462f-84b1-383a66822ef8"},{"claim_cluster_id":"283a7466-09a4-4b67-abff-ca96f1d8ade9","event_cluster_id":"3b245c17-07a2-4e26-a29a-946ef78835ee"},{"claim_cluster_id":"a764eb56-b1bb-470b-bb17-4bd9f5369b4b","event_cluster_id":"09a252ec-4d97-4380-a535-1e7222c476ea"},{"claim_cluster_id":"7742ec5a-27ab-42d2-9779-df7d73a0cec4","event_cluster_id":"e0e899a0-65d4-45b2-b3be-ff8320d1837a"},{"claim_cluster_id":"82430ac1-c5b1-4777-ac21-a40819c2ad02","event_cluster_id":"e0ef928b-5c3a-4954-b041-cb096ddc889e"},{"claim_cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","event_cluster_id":"12cb5a16-807e-4b60-87c2-713f3796ebf1"},{"claim_cluster_id":"81062452-735a-45ec-ae26-d06b90c45ed4","event_cluster_id":"ec9bc095-279f-474f-9706-4d758de892be"},{"claim_cluster_id":"b2568d68-53d4-487c-b724-0456b247a886","event_cluster_id":"4e9bc944-639b-4f8d-838e-a744f7d10ce2"},{"claim_cluster_id":"66df7edf-0972-4fa2-846f-2e6326ee828b","event_cluster_id":"86f9f906-a751-49c5-9fab-90ea9e810607"},{"claim_cluster_id":"267d2942-984a-4564-b33c-69e9db79a066","event_cluster_id":"89448e79-f7ef-4836-aa0c-f4044c4e1e16"},{"claim_cluster_id":"af144d2c-f8aa-40f2-9250-f41cd71f8fd9","event_cluster_id":"eef62b12-ce49-4113-8683-7c0cfeda9369"},{"claim_cluster_id":"95469f31-02a2-4069-8577-33c92dddd21d","event_cluster_id":"6d60b9fd-35cb-4875-8f6b-cc990ada4464"},{"claim_cluster_id":"c782b8c2-e8a6-49c0-98b9-40619e415dcd","event_cluster_id":"1edefbd4-7887-468f-8ea8-789dc55de3db"},{"claim_cluster_id":"d61fc1c9-1533-4eaf-88f3-8d0340ce2de0","event_cluster_id":"d4c689b9-e4d7-4a70-913a-2c31aac2dfbf"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"9afd9c54-2f8e-40e0-aff4-8479c84a56df"},{"claim_cluster_id":"96b36beb-a890-402f-9101-7aa7236863f1","event_cluster_id":"fe911735-6fb7-4737-bc2c-bfe7c0b05844"},{"claim_cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","event_cluster_id":"465ba356-8493-40d2-9150-2a0b1fd6b413"},{"claim_cluster_id":"103c6b31-e860-4fde-bc3f-de3b1bf5f689","event_cluster_id":"97495308-ae0e-47c9-bef2-8d438cbb6ff8"},{"claim_cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","event_cluster_id":"c5a76ba5-1fa2-4615-9254-21b572adf7ac"},{"claim_cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","event_cluster_id":"f3c78c9b-df0c-4382-a6ec-56b924bce811"},{"claim_cluster_id":"8afc9e85-7241-4e3e-a1d2-c084e17d6f92","event_cluster_id":"3d02db59-a52e-46b0-b009-3a6b28cebb78"},{"claim_cluster_id":"6926f592-0807-43c3-9eb1-74f903b009ff","event_cluster_id":"0fa8aef0-deff-4ac5-a935-94011ed8be80"},{"claim_cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","event_cluster_id":"9d264f30-800f-42b2-9098-6bb3eb170aa6"},{"claim_cluster_id":"1e099dec-1be9-48be-a1bc-00d89e3cc02f","event_cluster_id":"c56b515a-2e70-4a48-b4c2-0cbda45aaedc"},{"claim_cluster_id":"749a09bf-2f2a-4d19-aa9f-a22ffc94264d","event_cluster_id":"40cf4646-a4df-4be7-91e4-7dd54f7d4c16"},{"claim_cluster_id":"fdae240e-8bc7-467c-b880-f3913e28e6ce","event_cluster_id":"e1583824-5e05-4c29-84a3-b27afc099adb"},{"claim_cluster_id":"d8f02a31-c29f-429d-b5f0-720768af0f52","event_cluster_id":"bdc29925-59ca-47f1-8fcb-329866ae2601"},{"claim_cluster_id":"984134b7-51eb-489d-965e-a939f985e06f","event_cluster_id":"2779687f-bfe0-419a-be7d-20cd79002462"},{"claim_cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","event_cluster_id":"626701fe-ae3d-403d-9681-7d335f03c82a"},{"claim_cluster_id":"cbb443ee-8a98-4074-9a33-690c1a4267b8","event_cluster_id":"c0a9c99d-91fa-48ff-be0a-c6e00181d46d"},{"claim_cluster_id":"7ac1c88c-d620-4c32-9f9d-5a780231627e","event_cluster_id":"e8a4287f-2df7-4875-81d6-e8b9ebf6b742"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"057662c4-0ac6-48b6-be90-a08641f47c88"},{"claim_cluster_id":"5b6da2ab-36ee-4cfe-968a-ce42565405bc","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"7ae548ab-8f8f-4668-ba05-a2abf4b89759","event_cluster_id":"073ce102-b579-45e6-8aa7-6f1ca6f82280"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"be12c5b4-b051-4762-b77d-ca92a4063972"},{"claim_cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","event_cluster_id":"88fadd59-b242-4ad4-ab5b-3465e7a2b5a6"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"70862016-3977-4b4b-9e68-43859faa28ba"},{"claim_cluster_id":"29c942d6-0549-4857-889a-2fc5fd4cf362","event_cluster_id":"b8a8bbf1-a819-445d-874a-5ea5546196e8"},{"claim_cluster_id":"804db45c-717d-4c1d-9494-73592da3dad8","event_cluster_id":"0f09675b-050c-4631-816f-5157cd231924"},{"claim_cluster_id":"42d845ed-aaed-4d48-a0e4-2928cc3ba602","event_cluster_id":"a8b93ec4-02b3-42be-92d5-d600d19a447b"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"91638e17-92b1-4187-b7cf-b00589f88898"},{"claim_cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","event_cluster_id":"b2a62820-6f02-4de4-99f3-aea0d67cd577"},{"claim_cluster_id":"7afb7680-3722-423f-b129-7076bfb88092","event_cluster_id":"063191cf-9936-4d33-8783-201496475d0e"},{"claim_cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","event_cluster_id":"ec6a0d33-6433-4fbc-b666-83c9c378399c"},{"claim_cluster_id":"de17f70c-2147-4c34-a071-59d11378f1aa","event_cluster_id":"590d0c11-1909-4486-98ca-6247b1d6bae0"},{"claim_cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","event_cluster_id":"9d8e9597-3167-4e1c-94bb-e686324d37e0"},{"claim_cluster_id":"b6fc681b-92ac-49a5-8881-3c1a5122bc59","event_cluster_id":"c2fb9cb0-a6ae-4469-84e3-3b523125b6df"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"bb078c76-36ef-4176-a9f6-192717c4f2b4"},{"claim_cluster_id":"7811b1ac-b0e5-4c92-a933-500f6b892437","event_cluster_id":"70431f34-7e7b-4551-b35b-94e41cfb3c9a"},{"claim_cluster_id":"bcc58315-e1c3-44d9-8dc7-b3967b315e01","event_cluster_id":"010bfb3a-2b97-43f6-870c-f3dfb129b9df"},{"claim_cluster_id":"36824238-8532-447a-aacf-ef3f59e89c60","event_cluster_id":"2950776a-25e4-4d62-bcaf-01e56ebd5b4c"},{"claim_cluster_id":"bcfd3520-6b2d-41d7-83ee-cfbd1d569332","event_cluster_id":"ffb636ec-7472-41b4-ad69-f529b66bd46e"},{"claim_cluster_id":"6c511b67-edc9-413f-96b2-94d272eb11e9","event_cluster_id":"1f7ec3f0-fe34-486a-a953-3da4c977430e"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"4ea6057d-751f-45d1-801b-72130ecef337"},{"claim_cluster_id":"e6867616-fb8f-44d6-8b92-f5cca8ca9e6a","event_cluster_id":"a6a74d11-2c02-4502-9449-33d6b314f672"},{"claim_cluster_id":"289e5c59-c24f-465d-931a-b56b54bc982f","event_cluster_id":"3f6ce9ce-e151-4a9d-92cd-88c52ef40373"},{"claim_cluster_id":"96b36beb-a890-402f-9101-7aa7236863f1","event_cluster_id":"fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13"},{"claim_cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","event_cluster_id":"771b0707-56ce-47d7-84ed-b75ab36dfd83"},{"claim_cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"6774f916-a691-4d45-86c4-69c41fab58e3","event_cluster_id":"c586556e-d0fb-4b9e-b41e-3635da810071"},{"claim_cluster_id":"b0071c15-10b9-4a75-8b7f-486b9f2c04d1","event_cluster_id":"d2d14fb6-adb8-486b-8eee-e966dd2e339b"},{"claim_cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","event_cluster_id":"6ac5b48b-0333-47a6-8d5d-318886958930"},{"claim_cluster_id":"842a47a3-77bb-4a2a-909b-98bce731301b","event_cluster_id":"7311a9b7-5d04-45ee-bfba-1bec0d5a0eda"},{"claim_cluster_id":"2e74796b-6aa0-4e1f-8a55-22887fa2ebdf","event_cluster_id":"105a185e-0869-4f78-8bc2-ef2d7bd72e38"},{"claim_cluster_id":"de17f70c-2147-4c34-a071-59d11378f1aa","event_cluster_id":"9e24e052-7c2e-4232-a3f6-f90915a205eb"},{"claim_cluster_id":"451cf0f3-38b6-4124-8f93-0e300d12c170","event_cluster_id":"565785be-22aa-4015-82c3-a5551804b630"},{"claim_cluster_id":"098acc21-62ca-42b4-8206-4df179ae28c3","event_cluster_id":"af868606-4265-4854-b859-dd107b996ff4"},{"claim_cluster_id":"7b76e5cb-748d-468e-9baa-d34773d5f24e","event_cluster_id":"51078797-5492-4e49-abad-e30c5a796113"},{"claim_cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","event_cluster_id":"856b24f4-0a37-4fe1-9808-5b1d1715aafd"},{"claim_cluster_id":"d4dddb84-da14-4d5c-ac75-d999175b9558","event_cluster_id":"8ef9691a-752f-475d-a3ef-753ff2032577"},{"claim_cluster_id":"3e1e4180-7726-4298-9f55-4348fcd7185f","event_cluster_id":"c0b25dac-eed2-4056-a693-6719f5711bef"},{"claim_cluster_id":"a24c9e44-7dfe-4825-ab38-82d2ff8a84cc","event_cluster_id":"3b497918-2e09-478b-9716-2fc578f66b62"},{"claim_cluster_id":"40860ef8-1ebc-45f7-84a0-735bcdaf070c","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"b2ec8ccd-aef2-476a-b259-768aae14f39e","event_cluster_id":"c7fea8d2-cc9a-4113-be0c-ac48857e6432"},{"claim_cluster_id":"b65de138-2e69-44b3-acdb-00d152bc8245","event_cluster_id":"35ae28c4-1a8d-4235-aadc-32d9b7b111fc"},{"claim_cluster_id":"8f97c05e-5860-4be0-8343-dc2050850d4f","event_cluster_id":"907f966c-c5b8-4df2-817d-f2cfeeac3c35"},{"claim_cluster_id":"eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3","event_cluster_id":"9ce0798f-d0a5-4818-8a46-c633233caab5"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"528595cb-88e8-4fb8-9197-5baf87551c4a"},{"claim_cluster_id":"dce81269-fe31-49af-8310-17a573139956","event_cluster_id":"d46a8e73-11be-40a1-8437-95dcedae232c"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87"},{"claim_cluster_id":"e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a","event_cluster_id":"35f8d4db-40b2-4a70-ae12-49bc429a73a4"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","event_cluster_id":"0a129298-9d76-444c-8b1e-1ebbbe3bb953"},{"claim_cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","event_cluster_id":"bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5"},{"claim_cluster_id":"a5210919-ca86-4673-97e1-5b03ea7de143","event_cluster_id":"38fab33e-077b-434b-814f-3bc3f8dfc415"},{"claim_cluster_id":"af3f95a3-d597-4371-bf7f-e4f5d91a9b73","event_cluster_id":"88b53ede-d736-4ed2-9eb5-d53fe706d4c1"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"3c7779af-1e2b-432f-abfc-f807e51488c7"},{"claim_cluster_id":"342cdbac-7da2-46b3-80b3-a9b75e8fee10","event_cluster_id":"1e2f3c33-51a9-4ade-8539-40a4bc9cfff8"},{"claim_cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","event_cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c"},{"claim_cluster_id":"07b6bde9-eeca-4fea-b3c2-39093320ea05","event_cluster_id":"d1f35128-46aa-4b3e-8942-ed03c647bdc7"},{"claim_cluster_id":"05e481b3-f988-4990-a833-5d6d33d27a4c","event_cluster_id":"ec27a280-5ff0-4aa8-9204-fa364980dc9d"},{"claim_cluster_id":"9abd543e-88ed-4716-b3f4-c8fea9769bf2","event_cluster_id":"b5f42c7a-e41e-420e-9b45-a7f2790588b6"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"f3affcd0-acdc-481e-ad0d-c22c5984f9af"},{"claim_cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","event_cluster_id":"aef65abc-e7b7-4946-9c22-4ac367aaff7e"},{"claim_cluster_id":"7924e4aa-9f0c-4bcf-8c0f-de382c8d6001","event_cluster_id":"bc800212-afc6-410b-a69d-f8042afac330"},{"claim_cluster_id":"5995c9ca-98e0-418d-a93b-a662311da0c9","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"c8c0e353-5277-4897-8ef8-4773b9d6e6cb","event_cluster_id":"127de610-39d3-4b48-be82-befef46aa586"},{"claim_cluster_id":"5d950548-da48-42e1-b748-275abdd34cfd","event_cluster_id":"c06d1b4c-ebff-4c43-a158-e1cf96a68d7f"},{"claim_cluster_id":"d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db","event_cluster_id":"84708f88-fae9-4536-bd01-2d6209b5f616"},{"claim_cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"d01db0e4-579b-46e1-b0a0-4bf5732646a8","event_cluster_id":"ff420a7c-e6cc-45a2-bf06-8ce6ac712e7b"},{"claim_cluster_id":"6f847ace-00e0-4009-b5e9-3729f7a9e244","event_cluster_id":"58559460-f665-4bbd-8f9e-95791e57f99a"},{"claim_cluster_id":"9abd543e-88ed-4716-b3f4-c8fea9769bf2","event_cluster_id":"6ce0f5a3-c20c-456e-bcaf-26fa7ed36c33"},{"claim_cluster_id":"5d30cac5-2629-4bf5-9665-20ae87c1ec22","event_cluster_id":"4a10d70f-5f46-496e-a6f4-0b982956d03f"},{"claim_cluster_id":"066ea292-674c-44ee-8c3c-799b0ecf024c","event_cluster_id":"4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568"},{"claim_cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","event_cluster_id":"b7af27db-59d8-4e96-a280-4b5ae8db2302"},{"claim_cluster_id":"3afb5a7e-c2f9-4fc4-a379-b0fb650f805a","event_cluster_id":"18554ac8-5c14-44ff-910f-06120f4b5680"},{"claim_cluster_id":"101b3e01-9e80-483b-82e6-39667fb77d18","event_cluster_id":"5e399677-5a8b-4a09-a43c-cb9c2afa95dc"},{"claim_cluster_id":"03725096-887b-4dc0-a3ec-0bc1ce57eec9","event_cluster_id":"dc6983ab-b551-4091-91c6-65ee2055cfd0"},{"claim_cluster_id":"ff70f7bd-e1b1-44ea-8b32-024f3d1917ed","event_cluster_id":"29cdab10-c4fa-43e0-a980-d1342b8aa258"},{"claim_cluster_id":"5b34f4e8-867e-44ea-b5c2-c5295a09dd5e","event_cluster_id":"8c5f95da-6a16-42a9-82d6-b9a5a0c0b94c"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"301dd553-d836-4dc3-8b50-cd3953d38a18"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"61d63dd9-934f-4808-b6ab-ed734f2474b3","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"af183b48-72bf-4947-8e38-5272b737f76b","event_cluster_id":"5ef9de99-de5e-4d31-bfda-1e87c2a63ead"},{"claim_cluster_id":"3c28af07-0879-4e0d-a892-8c0d97f3e49a","event_cluster_id":"fa62d81f-956c-46dd-ab58-7fb08e1ad844"},{"claim_cluster_id":"590ca39d-bd4d-431b-829a-90d0f3384aa4","event_cluster_id":"ac154c70-d6ce-41bc-949e-658cdd31e1f4"},{"claim_cluster_id":"9cf07839-b78b-4d19-aeee-e70ec12a23d1","event_cluster_id":"d05aef6f-059f-4fa1-b456-946956a2ded5"},{"claim_cluster_id":"3b4d0d09-6630-4f48-897e-19fe1449086b","event_cluster_id":"73900380-dcd7-40a9-bff7-af4dd25e907d"},{"claim_cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","event_cluster_id":"06ac8474-a3e8-472b-abca-69bac9927b06"},{"claim_cluster_id":"c6a49139-3f4b-48cf-8d38-e5b344108df3","event_cluster_id":"9c02d7e0-91d2-4077-8adf-0916536016b1"},{"claim_cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","event_cluster_id":"edae4987-7374-49c7-bd0c-6f6522213435"},{"claim_cluster_id":"baef4ffa-45e6-4649-9ab7-8c1b3621d2d6","event_cluster_id":"01d5ac9b-578e-460b-921d-2d1cc5ecad34"},{"claim_cluster_id":"13db6364-301c-4a4a-b13f-69262abf41bd","event_cluster_id":"296c5f75-cf3a-4fd3-89db-486389767949"},{"claim_cluster_id":"2a0a6106-78d5-46ad-ad52-e0296bf7134a","event_cluster_id":"57ce37d8-222f-4e0d-8fd8-04ee1ade37d4"},{"claim_cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","event_cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028"},{"claim_cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","event_cluster_id":"5e9b1d6e-d8db-47a3-b950-64ca3a804787"},{"claim_cluster_id":"43b3601d-6d6e-43a4-8cdc-72cf4aa80640","event_cluster_id":"2160e916-6f22-443c-821e-3ddb5ec1cf74"},{"claim_cluster_id":"2f6021e2-bde5-4c10-ae2b-194bf6a93505","event_cluster_id":"626e9a9b-6995-4100-8ffb-53ed10359203"},{"claim_cluster_id":"86cde8dd-df84-48da-a045-d001baaf3298","event_cluster_id":"ce27cd6a-2828-4d90-a12f-a0a6f593b1e0"},{"claim_cluster_id":"d669c1ac-c710-4975-98db-1c778f28ee4c","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","event_cluster_id":"0ba7abed-e798-4cd4-b041-3026081313b7"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"24b4e3df-c6d4-41de-8dc5-0dafe4754aeb"},{"claim_cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","event_cluster_id":"79e93acb-9f08-48c2-9984-2e0654fbc884"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"a0b96ee6-2ea9-4035-b542-1107b0662e77","event_cluster_id":"3bf8d65a-8c84-4411-baf2-c3a55c8118b8"},{"claim_cluster_id":"7123d027-fb9c-44c1-becb-087b98c76740","event_cluster_id":"a087c689-de45-45b8-a8c3-f348c23872b5"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"6c375d59-160f-4719-ac36-a62607acccb1"},{"claim_cluster_id":"494d200b-d2e7-47ec-bdd7-86aef2459978","event_cluster_id":"3cbece7e-7ff3-422e-bd74-b94ccde6f34a"},{"claim_cluster_id":"934665b5-3969-4817-9dd5-47b732fdd380","event_cluster_id":"5d7bc6cf-96a0-42e0-b05d-1ff4cdfe4b5f"},{"claim_cluster_id":"8bbb9fde-a60f-4687-9398-276e5d036952","event_cluster_id":"34aab7b4-5379-4f38-9914-ae9a14a7914c"},{"claim_cluster_id":"6ca40c20-bd2c-4fa0-af88-bbe3820f05e6","event_cluster_id":"b2ea914d-85db-4a5c-9a1a-857c4092e4d3"},{"claim_cluster_id":"5238def0-ccfb-4f27-b836-f20f9b7dd70b","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"e6759e4c-f697-49ce-a969-2f596e5c4293","event_cluster_id":"83fa5a8b-b645-4ba9-9de1-a35b790ac1d5"},{"claim_cluster_id":"731adffa-9e59-4f19-8d10-ec191098b454","event_cluster_id":"f213c95c-e709-4a66-94d2-6982e6415c05"},{"claim_cluster_id":"5ec8ba1f-609d-4689-8317-8045f6c09e77","event_cluster_id":"52d598fd-9b16-4bac-b3f5-6b1dca718bc7"},{"claim_cluster_id":"c7d861d7-3b33-4585-89d3-87c9dcbcd126","event_cluster_id":"3bbdb582-a477-4388-acb7-cf6123d0c022"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"edae4987-7374-49c7-bd0c-6f6522213435"},{"claim_cluster_id":"74f7c7d8-aba9-45e9-a386-fbb258dd884d","event_cluster_id":"3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909"},{"claim_cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","event_cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739"},{"claim_cluster_id":"38841999-14cb-43f3-a2d5-27d9791973f6","event_cluster_id":"683abff9-679b-4270-b05d-4394a56a60b4"},{"claim_cluster_id":"7fc9b449-7f4e-4cec-90a6-b1dab2836291","event_cluster_id":"c466ec99-62a0-4318-a23d-1522e69e1a70"},{"claim_cluster_id":"19b19cf8-a65c-454e-84bf-36d3044b6f73","event_cluster_id":"5dffba17-ccea-4d19-b8a2-e0d2197c568d"},{"claim_cluster_id":"a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc","event_cluster_id":"25720bbc-2dcb-4fd3-bfdd-8ac413567afc"},{"claim_cluster_id":"958b1512-4a3e-4d41-927e-a3072dd9e9ef","event_cluster_id":"fa62d81f-956c-46dd-ab58-7fb08e1ad844"},{"claim_cluster_id":"21eacc7c-c9da-4edc-ac35-3ab550e3b7af","event_cluster_id":"4807cbce-9aad-467f-86b6-35d202d1cb91"},{"claim_cluster_id":"2b897077-ab7f-4c6d-8c0e-a3493d4e615a","event_cluster_id":"6e4775e9-09cc-45e6-927b-26fd1460b8e8"},{"claim_cluster_id":"97037755-caf6-49ed-8d7a-bb7c0d42bf8c","event_cluster_id":"70d7ea19-ed43-41ec-a695-147f9057dd3c"},{"claim_cluster_id":"b6ac4f42-6e4c-4395-a71a-c8beca5b5336","event_cluster_id":"96b17898-9707-4c42-8d78-5b035c3e7377"},{"claim_cluster_id":"67c03f1c-cee9-4493-b4e6-4ff1b7971966","event_cluster_id":"c7d55c3d-c95e-4814-b774-3a8773d025eb"},{"claim_cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","event_cluster_id":"8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4"},{"claim_cluster_id":"1f1f405f-6b99-4de2-b4fa-1bd105b3c577","event_cluster_id":"ad80cb2a-c356-4006-9574-67d0198ed537"},{"claim_cluster_id":"f4f83538-936e-4149-94c2-66b6b2ac2571","event_cluster_id":"45ef4556-631b-4297-8b2a-7cad68f3b517"},{"claim_cluster_id":"a63004c7-9e1f-4600-bae4-f70655f0094e","event_cluster_id":"5a784d1e-f3a9-480f-aa31-7625b9b944ce"},{"claim_cluster_id":"af144d2c-f8aa-40f2-9250-f41cd71f8fd9","event_cluster_id":"dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76"},{"claim_cluster_id":"20c941a8-b922-48e3-8e56-e49e1a524fd9","event_cluster_id":"5a4fc98d-9bb2-48e0-88c4-2decb355b92d"},{"claim_cluster_id":"b473cdd9-7369-4866-a926-04d86eb03c52","event_cluster_id":"fcbaa14c-dec6-413c-9e80-6e8b3b617340"},{"claim_cluster_id":"daf0b3a1-53f1-4b47-955e-785030ee3839","event_cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf"},{"claim_cluster_id":"b3b1fd7c-7ffb-411d-b821-50b6108ebae7","event_cluster_id":"a4d467e0-6666-461c-8177-8b0173dc05e3"},{"claim_cluster_id":"ef49913c-d983-49cf-b90f-4529857c36a4","event_cluster_id":"cf6c1c0d-fc13-4eb6-a686-91e7d8509399"},{"claim_cluster_id":"d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce","event_cluster_id":"35df1ff6-45be-4230-aba5-19c41bc2020b"},{"claim_cluster_id":"a1f0e0be-a8bf-4895-ad2d-4f83a0d63930","event_cluster_id":"3ba005de-dec0-4cc4-8a3c-a3679d6f072a"},{"claim_cluster_id":"dde390b5-1a05-447f-86aa-a25992be6bfd","event_cluster_id":"192193af-777f-4b45-a866-b58926d838df"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"99d9484d-46ae-4ca2-98a1-dd3e0aeee99d","event_cluster_id":"192193af-777f-4b45-a866-b58926d838df"},{"claim_cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","event_cluster_id":"39e17317-299b-4c70-bf27-b813fd6d3c5f"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"bb551e75-48fa-42c3-a108-cb4b1462b529"},{"claim_cluster_id":"f5514b1c-3b40-41b8-9290-039c2c94a3e7","event_cluster_id":"545b9a1d-6aef-4146-8dab-6da3637008a3"},{"claim_cluster_id":"4150f7a8-fd61-465a-8315-84a5d8cef80e","event_cluster_id":"d784ccaf-4509-4d9d-9ebf-0ffc15008e18"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","event_cluster_id":"5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"c754fcc4-5c32-4f8a-ac01-348838a5d407"},{"claim_cluster_id":"8cb34140-24ef-4173-9390-c1f84800160e","event_cluster_id":"0912e80e-4475-48b0-94ea-99b244b18e7f"},{"claim_cluster_id":"bc0539c0-9358-42cb-bbfb-8c0b934c5e86","event_cluster_id":"dc2c7323-e1d7-4179-aef0-ca2fc7077801"},{"claim_cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","event_cluster_id":"b07f3d2b-07c7-4378-8e98-619949a67d5a"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"4d4b5f03-b89d-479d-93c3-2c3c9a038d46"},{"claim_cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"99df608a-defa-4cea-b8ef-86519fa0e08a","event_cluster_id":"91b36e51-3bed-4937-9f60-9c0f824e451a"},{"claim_cluster_id":"6ca40c20-bd2c-4fa0-af88-bbe3820f05e6","event_cluster_id":"0a3dfd8d-a3b5-4c2f-8fe0-7e8a2061b362"},{"claim_cluster_id":"24f6a0c0-6612-4488-bc48-40d12340ab22","event_cluster_id":"a7b8df05-a36b-47bb-9f07-210a97d31443"},{"claim_cluster_id":"b9ef5935-c3ff-439a-95ae-5e53367b92ef","event_cluster_id":"b33db570-415f-43c3-b381-72179faa3148"},{"claim_cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","event_cluster_id":"8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8"},{"claim_cluster_id":"61c8550e-839e-4f39-803d-72ebbfa747a7","event_cluster_id":"1044d7cc-fb67-48c7-a61d-abf5c9d0ee2c"},{"claim_cluster_id":"6e43ff1d-8cc2-4d06-859d-7e968536001b","event_cluster_id":"052da5ce-3d09-4c7e-bec6-952cf04794b4"},{"claim_cluster_id":"5881fb7d-2030-4406-a7ba-0a95befea17e","event_cluster_id":"2ff5a9aa-c10f-4f8d-a47a-0ec077d3ef51"},{"claim_cluster_id":"00e6b319-ea09-4ee6-8be1-7f243156f545","event_cluster_id":"cffc59b0-977d-47ae-8b01-886477ecbcba"},{"claim_cluster_id":"04c0a28d-e066-4279-bfee-f4757f197d7a","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","event_cluster_id":"5c9296c9-7461-4417-aa55-8ba44cdddfec"},{"claim_cluster_id":"7dc48717-c562-4f7c-bcb3-b4a13374cc42","event_cluster_id":"82364b1e-49e1-409c-a0f8-eccc7c05ab76"},{"claim_cluster_id":"f15167ff-a614-4854-ae28-529950f00bdc","event_cluster_id":"f7a6ba19-2cf9-487a-a498-908208872dae"},{"claim_cluster_id":"2267c878-b6b0-4036-b4c7-3e3fec5d0865","event_cluster_id":"5261c3b8-e566-4b27-8dcc-7c47abcca2e2"},{"claim_cluster_id":"a536505f-e31a-400e-a4a5-1f74a9e29e7d","event_cluster_id":"0817085e-1f3f-40ef-a848-4b066c225ffe"},{"claim_cluster_id":"a999634d-6816-4a9d-9bf2-efbbb6f6917e","event_cluster_id":"94834f96-c25c-4f04-80b8-c75b05787e8f"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"3a7c04bf-2c54-4817-990d-55771d584811","event_cluster_id":"cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10"},{"claim_cluster_id":"850a1f31-fc4f-4578-baa4-da3b7a35e30a","event_cluster_id":"7a9ab53b-bafd-4621-b334-948c7482958f"},{"claim_cluster_id":"11d45e31-1956-49e2-b94c-bc4a176c09fc","event_cluster_id":"261352e0-2751-4f21-88a5-03538b2fd63d"},{"claim_cluster_id":"d5fdaeff-23a7-415f-9e7b-758f603e5d4a","event_cluster_id":"2a9b1bd4-3cd7-481b-8cb7-5d5856650a4b"},{"claim_cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","event_cluster_id":"db101c75-2320-4597-b222-b7197dc49dc4"},{"claim_cluster_id":"2f4a7179-3f3f-4eb6-8891-8b8d39467620","event_cluster_id":"2d90579b-afff-4e63-bf7e-880641d4be4a"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"344dd5f7-3435-46c3-9f5a-4bd9bd357bed"},{"claim_cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","event_cluster_id":"c74997a7-7974-4e4a-80ee-0cf8f0af8af6"},{"claim_cluster_id":"9fc7edf3-7209-4828-92b3-8d6dafded201","event_cluster_id":"0630fbfc-9793-4e8b-bd28-898778d452da"},{"claim_cluster_id":"c18b334a-f61f-4400-b355-cea2e7375866","event_cluster_id":"4a540701-996b-469b-acc0-9cc53e451ce9"},{"claim_cluster_id":"601320a2-3fca-41ef-9387-a64a4c0b5cee","event_cluster_id":"b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"},{"claim_cluster_id":"0634cfd7-f7f7-48cb-bb92-7dc813e3271c","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"3b1a4f1c-eb8e-4934-89a0-1d405c7425e6","event_cluster_id":"15d67b19-b1ca-45ea-8cf1-55236390c45d"},{"claim_cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","event_cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"},{"claim_cluster_id":"6950bc54-67bb-4e8e-b8cd-afd5c7d79d00","event_cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739"},{"claim_cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","event_cluster_id":"cab4447a-5d42-4fe2-b9b3-fc86f17d0ac9"},{"claim_cluster_id":"6d2792d9-4dcf-4980-9870-d295c7f8e2c0","event_cluster_id":"5f9c8cb9-e871-4d7e-8b36-9e411bdc35a8"},{"claim_cluster_id":"268e1143-4495-4247-af6b-b6f6f368f74f","event_cluster_id":"8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"},{"claim_cluster_id":"41683dea-1259-4e44-9283-e6286d675c48","event_cluster_id":"d8eb0da9-3210-4817-8cfc-d7a7f474f829"},{"claim_cluster_id":"81238869-957b-4b83-948f-2551b38a7039","event_cluster_id":"7be54807-07de-4ad8-80e9-963285c4b2c3"},{"claim_cluster_id":"7938e6ef-80ff-4f50-b301-1e5bfc0774b3","event_cluster_id":"0a7440da-026d-4b9e-86ae-aae908cc485e"},{"claim_cluster_id":"a0c8c3de-8102-4a9b-b20a-80ade6132b4e","event_cluster_id":"6c2926f3-1ce9-4f60-a8e9-724e2273274d"},{"claim_cluster_id":"da2845de-4e1b-492a-a6b0-06fd4584650e","event_cluster_id":"d6b75ab4-918c-47fe-8efd-91ea4be62261"},{"claim_cluster_id":"1991b6cd-3baa-475c-add7-d4b101a0de09","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"e56fc955-148f-4ab7-9982-126189917297"},{"claim_cluster_id":"3cb553c8-9eb0-4dfe-8f4d-e85a8933799b","event_cluster_id":"a2fa0436-7d09-4549-9e78-5e411d846fe6"},{"claim_cluster_id":"152e2cd2-1d15-4787-b90e-76e34ac56ace","event_cluster_id":"07bac613-553a-4b5a-8942-deafd7506573"},{"claim_cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"83412f4d-d0e2-456a-853f-c0ab5d6c2ff1","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"c474ebeb-fd96-4c94-8aa4-35666d0af3d1","event_cluster_id":"ed5d05a0-5035-40ad-a517-d570266b42b4"},{"claim_cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","event_cluster_id":"4a7affe3-fd43-41f4-8713-3066830d90f8"},{"claim_cluster_id":"62d8fa29-aaab-4f66-9532-5fb34686e56f","event_cluster_id":"8979de81-d14e-4323-ad09-17f46a1f718d"},{"claim_cluster_id":"5f5fe60b-6bf8-4f80-be3b-0dcf885c1171","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"9f0480ce-b886-46fa-98f0-af8144766c6c","event_cluster_id":"f28068f5-d9fe-4cd5-a458-304fc4db522c"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"45236940-0b07-401a-92bf-42c8f73cf80a"},{"claim_cluster_id":"c267714a-b024-42fa-a678-5343e8a65754","event_cluster_id":"a6f8ca4a-31cf-437f-a2eb-06ee3b0285bd"},{"claim_cluster_id":"e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a","event_cluster_id":"4a203e5c-111c-4719-91b2-5d364d288743"},{"claim_cluster_id":"424a981a-fddf-4933-92b1-158cbba9a861","event_cluster_id":"f6b81252-d691-43eb-b603-bbd2ec2ea3c1"},{"claim_cluster_id":"30011e47-1ff9-409e-8099-2eff6ab89e88","event_cluster_id":"2a871f4b-957a-43ae-bf82-09ab2ac57891"},{"claim_cluster_id":"342cdbac-7da2-46b3-80b3-a9b75e8fee10","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"f6a4aea6-92b4-4a70-a984-2326df1ee39e","event_cluster_id":"a362e63a-9f1e-4605-b063-7172229b335a"},{"claim_cluster_id":"3444a924-096b-4eda-877c-4c6412d885cd","event_cluster_id":"054ed505-3504-4e27-9979-055c536c39eb"},{"claim_cluster_id":"6768580d-67cd-4040-b98a-9d8276f6f0bd","event_cluster_id":"42663758-9518-49e1-a45d-11b8ad2a2193"},{"claim_cluster_id":"11d45e31-1956-49e2-b94c-bc4a176c09fc","event_cluster_id":"006e6ccb-eaf9-4a24-8ea9-fbee9be7d468"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"4d3fc72a-c96e-4659-afda-27c7ce47c497"},{"claim_cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","event_cluster_id":"4c83d9ff-1e62-4a28-b3d2-a667fb4041d7"},{"claim_cluster_id":"6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5","event_cluster_id":"d7adae26-7c5e-4cae-86db-8ddd899b1a73"},{"claim_cluster_id":"46e0dd28-4bd8-4986-88e7-a2e53ab8f4b8","event_cluster_id":"60f1f675-db08-4cfb-a9e3-20e14baf899f"},{"claim_cluster_id":"10e97fc5-5fa6-457f-aefb-257e90e8124b","event_cluster_id":"dabb30c4-8940-4d2a-81d7-5e54195fcdf5"},{"claim_cluster_id":"97f84153-8f49-432f-a8f7-a4e57fe7f769","event_cluster_id":"389db9cc-996b-4a34-8f9a-361c5c8aa5ee"},{"claim_cluster_id":"86e16ba9-dba8-4cea-a0d4-df8a8a69d565","event_cluster_id":"7e64d534-c786-4ebd-b549-3314cdd361e4"},{"claim_cluster_id":"e8ac4064-b696-4a9d-9c57-bc79d628e859","event_cluster_id":"ead9bd7e-2c4b-46c5-b951-360707780eb3"},{"claim_cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","event_cluster_id":"f43f98cd-cb16-421c-a639-6c526509bfd7"},{"claim_cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"c572351c-d373-4e8c-a918-68e53e31b822","event_cluster_id":"81814091-7bc5-423c-85bb-9238ad6a9cae"},{"claim_cluster_id":"7e979f93-4ad2-4933-833d-edddb9f37e0b","event_cluster_id":"ba2e6df3-366f-4f05-b8ae-0693e1f8cec0"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"7e979f93-4ad2-4933-833d-edddb9f37e0b","event_cluster_id":"e9486241-9c2f-4d3e-8704-e3be044f2405"},{"claim_cluster_id":"67bef4c5-afcc-4a65-9538-ce302f965385","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"6e7164cb-9f1b-4f72-aef4-13243fbf321c","event_cluster_id":"8c3d66ea-c0e3-4dbc-a773-e3cdcd8c311c"},{"claim_cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","event_cluster_id":"0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5"},{"claim_cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","event_cluster_id":"23f623bb-83de-47ba-a19b-9df053aaf2d2"},{"claim_cluster_id":"af562818-5594-417a-b606-add10573c2db","event_cluster_id":"3a31904f-9e32-44e5-89a1-822aa5467c6f"},{"claim_cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","event_cluster_id":"976266ce-5c9b-4a82-9062-52ac4f4dcbd6"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268"},{"claim_cluster_id":"16e980af-79a1-4255-8ad0-56ca61ae3b8a","event_cluster_id":"57ad4e9d-2e3b-4f99-a5b5-f89a9fbe7c81"},{"claim_cluster_id":"c6f7c193-f407-447c-a10f-3ea5292ea3e8","event_cluster_id":"3a13abc2-f39c-460b-8768-7ccf1b11b40f"},{"claim_cluster_id":"3239dc2e-a961-4aab-990b-768c092064f8","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"30bb9166-b600-41f8-a7cf-3befaaa1bcc2","event_cluster_id":"20999f16-0335-45ee-a0fa-171f40827993"},{"claim_cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","event_cluster_id":"e3df2907-4da7-4352-a8ae-dd0543915bd1"},{"claim_cluster_id":"96423d41-ee08-4c5e-bcf0-4dd1b431abc6","event_cluster_id":"1ff366e5-31ba-464c-8544-3d84f99a75c6"},{"claim_cluster_id":"971c6a1a-3e95-4838-8131-b05eb89d55b7","event_cluster_id":"030691e7-b00a-48bd-99cd-b8a82a2565cc"},{"claim_cluster_id":"3e5167ea-d839-4cc5-b193-fda2f9c0b53b","event_cluster_id":"f16b94fa-630f-4218-860c-391c021de7f5"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","event_cluster_id":"e64379e3-7714-4ce4-9ee9-585f6bf488c8"},{"claim_cluster_id":"d01db0e4-579b-46e1-b0a0-4bf5732646a8","event_cluster_id":"f7e1186b-2980-41a7-bab5-cf7ae1ee1caf"},{"claim_cluster_id":"563cdc28-d88f-4781-9ab9-27eadd46ba73","event_cluster_id":"532b749b-85ba-48db-930c-9199fbff3bbe"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"fd231a27-03e0-4839-bed2-513e10b79733"},{"claim_cluster_id":"ea149597-1daf-4627-8587-59eb8a6bde8b","event_cluster_id":"2fc3625d-65ed-4d3b-9894-40d3d2d23ece"},{"claim_cluster_id":"55c660bf-50f6-447e-81a1-ddecdab998ee","event_cluster_id":"490d433f-ce3e-4f27-9543-e9681e6eafc7"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"97f84153-8f49-432f-a8f7-a4e57fe7f769","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","event_cluster_id":"8e3409aa-fad3-40ba-9376-e395c709886e"},{"claim_cluster_id":"a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0","event_cluster_id":"f24d06ae-13b1-4550-a06c-444a9041ab60"},{"claim_cluster_id":"27097c65-59e7-4824-9bbb-c0736b2c9f70","event_cluster_id":"b9804a77-392b-4042-a24f-eda229eba1c8"},{"claim_cluster_id":"32a2eefa-c8c7-482c-839f-be3b15138d40","event_cluster_id":"75649ebd-9ea4-425f-b0b4-b2dc8db1c23c"},{"claim_cluster_id":"199eabc9-e7b3-44cb-a574-bbc02ea956e5","event_cluster_id":"7b54b660-7b67-4765-8335-f1bb9a8cf70a"},{"claim_cluster_id":"b6f111d6-8112-47dc-baeb-43c77c6392ea","event_cluster_id":"afd94974-8e6c-4eb8-a657-4ac5f64e9000"},{"claim_cluster_id":"2f8d9d1d-f145-459e-90bd-ebf833c6fe60","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"6b5b4849-041c-4f1f-a05e-cd4913045e8f","event_cluster_id":"ceeb5cde-733b-478e-9e0a-21930e3f91cd"},{"claim_cluster_id":"1dc1ea0e-ecc0-4a99-a555-3574b46d8688","event_cluster_id":"e8c08050-8918-4c52-bcd3-c5994c5cd40a"},{"claim_cluster_id":"68d51d93-fcbe-411f-8a89-cb79bd347512","event_cluster_id":"98c1c320-efc0-41d6-bc35-eaf849b7cea7"},{"claim_cluster_id":"8d676e91-6fd3-47df-8a59-7b88ff3f09cc","event_cluster_id":"baf69b75-285e-4447-b574-0c5bce010190"},{"claim_cluster_id":"f6f15ea6-27bd-499b-a6fe-74d144b5ac0b","event_cluster_id":"d436d0a6-3e58-4bd3-a6ad-0b596176235b"},{"claim_cluster_id":"36824238-8532-447a-aacf-ef3f59e89c60","event_cluster_id":"f69599a7-433a-4819-a4c2-cea569bc6b06"},{"claim_cluster_id":"8870837d-d287-47f9-8134-1fe8a8f59e88","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"4eb89d26-0914-45a8-8a2e-98708f9a3315","event_cluster_id":"04fe8e71-8c72-481f-a6cf-1722df9454dc"},{"claim_cluster_id":"9c8e3c4f-c6aa-493f-ae68-b49b723b4cde","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"847accaf-332c-4ec2-bd26-cd592d1fa2fc","event_cluster_id":"6324da02-c8ae-4e7d-b1eb-1091e19c88ba"},{"claim_cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"452c2457-4da2-4edb-a49f-86f139410e4f","event_cluster_id":"b01fa043-31ff-48da-8746-ca50ad89a48a"},{"claim_cluster_id":"da5651eb-e7b2-446c-9fdb-dc89d46a36a7","event_cluster_id":"6e62e8fc-d0f2-48d9-952d-5f14837f0f03"},{"claim_cluster_id":"42139453-8011-41e0-af88-1b45a4865158","event_cluster_id":"d8d70374-6442-49f6-9ba4-aa78644e8a39"},{"claim_cluster_id":"68ff85cf-74e5-4234-a53f-6dba1aacb444","event_cluster_id":"0893d96a-c001-4046-ba27-939b9e1f52d5"},{"claim_cluster_id":"e490aee1-21a0-4624-906c-8f2d51f040e5","event_cluster_id":"d855e2c8-0fb0-4813-99e3-3fa003818f71"},{"claim_cluster_id":"aafcc6bc-c8f9-4a4c-acf7-9628f64db648","event_cluster_id":"f7143daf-c280-489f-9b7a-be507d7d1e7d"},{"claim_cluster_id":"731adffa-9e59-4f19-8d10-ec191098b454","event_cluster_id":"6936f63c-d90c-47ad-bcda-def68b0ec222"},{"claim_cluster_id":"d61fc1c9-1533-4eaf-88f3-8d0340ce2de0","event_cluster_id":"281bccd6-4eea-4bfc-b9dd-b2e9300159fb"},{"claim_cluster_id":"cf6e572b-b045-42a6-b196-8d36d7693937","event_cluster_id":"93849a08-743b-4023-9ccb-ce323519297f"},{"claim_cluster_id":"859c814e-e7af-4708-a58a-9f1f6973974f","event_cluster_id":"1f7a4f93-ef7c-471e-9da0-10305825de04"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"a8758a01-da2e-4199-8bb4-bdf40b9dd8e6"},{"claim_cluster_id":"c5855521-5ebf-478e-a7af-b3f07554a912","event_cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c"},{"claim_cluster_id":"d8b92399-bf69-4b82-b461-678acbb7e385","event_cluster_id":"d622193d-1629-4f0f-a5cd-b9751e388901"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"028c0dd0-ac64-47ea-94f9-5c74b9d66731"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"ff2acca4-5f30-4167-8a23-b96f532a3929"},{"claim_cluster_id":"23af5a3d-cb29-4974-bd99-35e9d9b06fde","event_cluster_id":"82cece60-3255-4d43-a228-e34efd18c27a"},{"claim_cluster_id":"9f76cab0-c9b8-4e12-bd91-cd1c5474c649","event_cluster_id":"1c08ccb0-286c-49ff-a95c-c82f67ced7f2"},{"claim_cluster_id":"fcc58b11-54f2-420b-99e3-8acb8731fd15","event_cluster_id":"7b565f36-8167-44ac-aea6-3371642da65f"},{"claim_cluster_id":"40d2bc92-0cd6-4002-bff9-64332ddd7635","event_cluster_id":"0d667a05-1c8f-4f3d-bb58-e8d67ce23069"},{"claim_cluster_id":"590ca39d-bd4d-431b-829a-90d0f3384aa4","event_cluster_id":"26e8c638-0261-4ee0-9125-edc5ca8d7841"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"4162c749-910d-4283-8cde-a365928f230d"},{"claim_cluster_id":"92b8820a-be27-4c75-96b0-6d6932996a93","event_cluster_id":"ba26379e-e775-463f-9971-b8b46c709801"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea"},{"claim_cluster_id":"419a274e-afb4-4935-a491-f22b25792b9a","event_cluster_id":"7186362f-7694-4259-bf65-9f7c8f813207"},{"claim_cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","event_cluster_id":"1bb2fbd1-906a-4d81-b23d-f6c0a4024661"},{"claim_cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","event_cluster_id":"94d152a0-b275-42d2-af1e-de4ffe6f8a22"},{"claim_cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","event_cluster_id":"a608e3f3-dce6-4fd9-9684-b60e35b55c85"},{"claim_cluster_id":"b63983c2-35fa-4152-8cc2-8380b6cbde79","event_cluster_id":"65ee7ca1-956e-448d-a404-e5c643989efe"},{"claim_cluster_id":"e3548f8e-cc3f-4307-a48a-a45cdf828859","event_cluster_id":"d18315fd-bf62-472b-bd6c-313e812011cc"},{"claim_cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5","event_cluster_id":"1b9bf573-9c3b-4f5c-a46b-1677c3204c31"},{"claim_cluster_id":"8b124bbc-d0ac-4d8c-bc1d-bbdf5f6ae201","event_cluster_id":"69365007-aabc-4f8e-a4e7-3ac92aef1b47"},{"claim_cluster_id":"70b49961-b72f-4a9a-bed7-51b09a9f1ec7","event_cluster_id":"c0200e7e-79d5-48fa-9957-b064b35b368f"},{"claim_cluster_id":"fc93709e-88fa-4e26-963a-2d3fcd9cde24","event_cluster_id":"f21fe246-03a7-43ce-b3fb-1decc7a9853e"},{"claim_cluster_id":"32902173-339e-4b9f-809d-01ac474ca7aa","event_cluster_id":"c1b67021-ee6c-440d-9e1a-3565b3ab3f41"},{"claim_cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","event_cluster_id":"00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea"},{"claim_cluster_id":"c8a67d7e-6b5c-49cc-b944-ad699ac9cff0","event_cluster_id":"213f0d3a-e8ca-4bcb-b7c9-7c90117d668c"},{"claim_cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"bc2e7af6-3507-403a-b41c-f6013dcfcf6c","event_cluster_id":"d9ed1c39-189f-45e7-adb4-c0c7fc2d4155"},{"claim_cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","event_cluster_id":"b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a"},{"claim_cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","event_cluster_id":"2d65299b-2b98-4ff0-9197-e120b19ce3bb"},{"claim_cluster_id":"42139453-8011-41e0-af88-1b45a4865158","event_cluster_id":"a5494931-511f-4aa7-86a3-f3bae4df958e"},{"claim_cluster_id":"0649ea17-dc60-458b-988f-5fb62bfa7199","event_cluster_id":"4a709253-d61a-4103-b072-d16f3cb55d28"},{"claim_cluster_id":"c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a","event_cluster_id":"38b77626-e120-4759-a3a5-dc826b3463bb"},{"claim_cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","event_cluster_id":"26e9ba08-6532-4ec2-802f-bd0940d07dcb"},{"claim_cluster_id":"d5458c27-5843-4ff6-b105-7703aeb6f588","event_cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638"},{"claim_cluster_id":"b58aa973-7c2a-4a42-ac89-2aa7abeea2e5","event_cluster_id":"f7ba632a-cef8-4360-bbef-dd149ddc5163"},{"claim_cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","event_cluster_id":"243170bd-2119-4d61-9620-baad736b6d51"},{"claim_cluster_id":"ef49913c-d983-49cf-b90f-4529857c36a4","event_cluster_id":"95eac10f-08e8-4ebe-913d-90bbcf49cbbc"},{"claim_cluster_id":"63024d1d-9398-49ae-8b27-efbfa0bffb4f","event_cluster_id":"21b62bf3-e16f-411a-a9aa-a2991cb252d2"},{"claim_cluster_id":"a9d64d25-62ff-4c83-a924-9b0477ad4c22","event_cluster_id":"8366909c-b1ee-46fa-ad8d-775e130e5096"},{"claim_cluster_id":"0511fc3f-517e-42e7-84fc-34ea436b847d","event_cluster_id":"6d147aa6-716b-44eb-8f82-ac64993f2df1"},{"claim_cluster_id":"1c5a43cc-bd0f-4446-9eae-4f39a7691fd3","event_cluster_id":"64c57917-e9a2-445d-b946-386aef313815"},{"claim_cluster_id":"496ba3da-7431-46d2-8b63-afbe79f86c65","event_cluster_id":"dd0e35ae-acba-486a-a98c-7ff8e0d969ad"},{"claim_cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","event_cluster_id":"b2f5e997-51a9-4075-b2b0-b908ca91bac7"},{"claim_cluster_id":"b0af2c27-e359-4cad-89ec-4abce503f0fb","event_cluster_id":"babc55aa-4d08-416f-96c5-50bd2182d4f8"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"4d323d7a-dea3-4fd2-9928-7ad3b9eb62fb"},{"claim_cluster_id":"de3dfa95-4771-45cc-8a31-d6c35fbb0eb5","event_cluster_id":"fed0576b-522f-4fd4-a6c9-50a73c58d504"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"},{"claim_cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","event_cluster_id":"46dc68c8-60bf-4c63-8f62-da2eefecf05e"},{"claim_cluster_id":"6547f895-7ab3-43c4-b3b1-d01e17f1e888","event_cluster_id":"829b9804-a574-4cfb-bb97-448e3e369540"},{"claim_cluster_id":"1ba178d9-d925-407c-bb75-60c655774cbf","event_cluster_id":"325144ea-ecb8-45ca-8169-6bfec35e02d6"},{"claim_cluster_id":"cca76b6b-f388-4f7e-8293-b55584460643","event_cluster_id":"f6427727-e128-4eae-8208-67e9a7ed1b14"},{"claim_cluster_id":"d93d391c-6b51-4713-bfdb-30f405cd2357","event_cluster_id":"33fcdb26-eedb-4334-944b-e4ef875270b1"},{"claim_cluster_id":"fece6aa3-8787-449b-8b29-7c6c4bb28cc4","event_cluster_id":"b4673d7c-55f8-410a-a73b-4f4fccae0549"},{"claim_cluster_id":"21228a2d-48c0-43f0-b18d-e85ff94cdb4e","event_cluster_id":"9369f16b-6041-4a52-ab2e-d046a7246adb"},{"claim_cluster_id":"41a55c60-75f3-48f5-817e-bc3dd4fc026d","event_cluster_id":"0fb15e05-a0f9-40af-9d1c-3b5766f5252f"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f621aef8-63b8-4a2e-8e04-ca8b7ec1b346","event_cluster_id":"b617ae42-60a1-4bd9-bcd3-a29cc6c02448"},{"claim_cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","event_cluster_id":"507a5fb7-2785-473f-8c2e-99215cff28b8"},{"claim_cluster_id":"296dd26b-e540-4c2f-91af-43709d5e7555","event_cluster_id":"995b974f-591b-482e-a707-9ef62e9bcb2f"},{"claim_cluster_id":"7eefde16-5844-4305-a679-da87990a2640","event_cluster_id":"410287df-601d-432b-a55d-63a15a95a255"},{"claim_cluster_id":"6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3","event_cluster_id":"379e9bdd-f97e-4662-8fa6-c65318b2f0d3"},{"claim_cluster_id":"ac35f635-837f-429d-a888-0720cf376532","event_cluster_id":"569a8b8b-9b0e-41ed-a2cc-db56c71f5703"},{"claim_cluster_id":"095169c0-0ce4-4362-b29d-486ce7d2b848","event_cluster_id":"05b40a90-169b-48f1-8cb1-f86fad4e6b0a"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"897c7076-ce98-4405-aaa5-1e883a645242"},{"claim_cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","event_cluster_id":"c4564515-d53f-4e98-999a-f38427deb89e"},{"claim_cluster_id":"36824238-8532-447a-aacf-ef3f59e89c60","event_cluster_id":"19ab8a7a-3e63-46b0-894f-04742e58ad8b"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"a2925234-109d-4c57-aac5-814b5a99a831"},{"claim_cluster_id":"2f43e86f-24fc-4c3c-a77d-c5abbf46ef19","event_cluster_id":"40978309-052c-4c0a-8f09-9f1d51e423d4"},{"claim_cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","event_cluster_id":"a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"},{"claim_cluster_id":"b570ae3c-f72b-47a9-b995-64ca6b5f3ae0","event_cluster_id":"8eb3c499-d3ba-4d18-824d-8a2db9101923"},{"claim_cluster_id":"b2036724-7c6c-4df4-b983-90c324253873","event_cluster_id":"64112ad0-ee1e-4f16-b30c-2adabd7eaabd"},{"claim_cluster_id":"8fa6723f-9341-42e1-b24f-456c511e2eec","event_cluster_id":"fe1c6b54-9f28-4390-8b18-685bcbf44298"},{"claim_cluster_id":"4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8","event_cluster_id":"7d3ca315-e2f1-442e-aa07-daf647abc039"},{"claim_cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","event_cluster_id":"3f77000e-b7d1-457b-963f-2743a0bda688"},{"claim_cluster_id":"a4e781c0-f96b-465a-94d9-bc076c57b2b1","event_cluster_id":"60da7061-2845-47bf-80c5-d5e550633128"},{"claim_cluster_id":"bb72233d-9eb6-4e80-89c4-220c7a06b310","event_cluster_id":"8a726a08-8358-4b34-876f-420532834600"},{"claim_cluster_id":"4958a7ec-0cd2-487f-a59b-9bc34843a2b7","event_cluster_id":"984977b5-907e-47e8-b70e-4d24066b2265"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"309e6017-5ba6-4aa5-918a-e978302b6d2d"},{"claim_cluster_id":"7698cb38-d25f-4849-ba30-99dd8e321533","event_cluster_id":"074c64eb-8566-4f36-bf3a-fc5995c21e65"},{"claim_cluster_id":"3e775727-96fa-467d-a309-22a5101e04e9","event_cluster_id":"cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"},{"claim_cluster_id":"09f8ca5f-e359-4e32-b6bf-f706de588232","event_cluster_id":"c974679a-a285-4dfd-882e-18a49abd08e5"},{"claim_cluster_id":"e65823f0-739f-4ed0-bd57-83b926046577","event_cluster_id":"696331dc-98cc-442f-bc75-87b9c239a45d"},{"claim_cluster_id":"6a2f7e2f-c113-4c0f-aa04-a2e337901c37","event_cluster_id":"a7c4ae5e-cf5f-4676-a2e4-88e256aaf381"},{"claim_cluster_id":"268e1143-4495-4247-af6b-b6f6f368f74f","event_cluster_id":"652f545a-2cde-41d4-9382-f23ab9d1b406"},{"claim_cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"3e304d73-a8bf-4d4a-8525-85d6c447ae6b","event_cluster_id":"3e466027-ffe7-4ec1-877e-eae7c5a1c2c5"},{"claim_cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","event_cluster_id":"a486e470-c569-4ed1-8cc9-0f9109ad027d"},{"claim_cluster_id":"60bb3151-34af-4d7b-9c68-da27390075bc","event_cluster_id":"9c99fda8-d219-4855-bf41-fafffb61b05a"},{"claim_cluster_id":"0a0082f4-5a11-4bce-aa5d-1877fddb104d","event_cluster_id":"ef3db80b-5215-490d-a636-85e6bcbe9e93"},{"claim_cluster_id":"6d37cc6e-940b-4af5-bb44-d183921f0d01","event_cluster_id":"1a4ac437-0820-43b9-93ff-945d37e52289"},{"claim_cluster_id":"300fdda9-fd92-4984-a9e6-86c9522fb6d4","event_cluster_id":"ad3d7029-44b1-4600-b68e-2dca24cb3b72"},{"claim_cluster_id":"32902173-339e-4b9f-809d-01ac474ca7aa","event_cluster_id":"d990ed81-4fe6-482e-9afb-51f8ad32db00"},{"claim_cluster_id":"4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8","event_cluster_id":"6b8874c6-0560-4ffd-876b-6651821a5f10"},{"claim_cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","event_cluster_id":"2f956586-babe-4398-aff8-0787b3e3a21b"},{"claim_cluster_id":"fbdddb76-bee9-4e1c-9f2e-03126700cbd1","event_cluster_id":"0534bd48-c558-48f7-8bed-cd770b8d24ee"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"e130a374-b2e7-4d68-8a8e-32dcab17656b"},{"claim_cluster_id":"1e227a80-8d1d-4484-9608-82719d3b526e","event_cluster_id":"f0d97c3a-c630-45ac-8106-3c433d45bb57"},{"claim_cluster_id":"49b52e42-84db-4d97-b9a4-ffd3211b536e","event_cluster_id":"acdd7a89-aa71-4db5-beb7-130a3813dd88"},{"claim_cluster_id":"57bfc89a-d981-44e9-a425-3364b9a5bc24","event_cluster_id":"f1b261ff-b08d-4eda-9ef1-3dbeca804b57"},{"claim_cluster_id":"2b897077-ab7f-4c6d-8c0e-a3493d4e615a","event_cluster_id":"9b4d29fb-4c29-4c0d-a4b1-3620ce290719"},{"claim_cluster_id":"c9534331-e465-4cc5-951b-fa24c4cd75bf","event_cluster_id":"21533f1c-ae42-4579-91e2-803b34beb003"},{"claim_cluster_id":"93c53898-2dc6-423b-a4d6-b61dd90c6d6c","event_cluster_id":"5ed59d44-85f1-4b54-af2c-2965549e9825"},{"claim_cluster_id":"d392695f-75b7-4bbc-a991-2b3edbf01567","event_cluster_id":"1847bb18-db3f-4048-bbaa-0206cb032b77"},{"claim_cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","event_cluster_id":"3ac894a5-bf0c-462e-b5eb-494aa29af425"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"66380cec-1745-4f20-be6e-01fcad9e1602"},{"claim_cluster_id":"596489a9-6207-48fb-8cf4-2972a01326d9","event_cluster_id":"ceb785f5-a630-41a5-8352-bf1ef25b04f9"},{"claim_cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","event_cluster_id":"ae8f14c1-199b-4891-807b-1b7d4b91ad58"},{"claim_cluster_id":"b6fc681b-92ac-49a5-8881-3c1a5122bc59","event_cluster_id":"1843ffaa-26d8-4da2-944c-1a88ec1c3413"},{"claim_cluster_id":"5d21e7b3-dd0e-453e-8871-eb57102f00e7","event_cluster_id":"146f4299-6935-41c6-a1f2-cdd4079712f3"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"ad513fe4-8bef-4ca7-984b-94ef0cbb53d7"},{"claim_cluster_id":"25cbeeac-8021-4680-b7db-f334ae985da7","event_cluster_id":"45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"},{"claim_cluster_id":"e7a774aa-82c9-41a0-9af6-f4f143016a1f","event_cluster_id":"976b60d5-b934-4def-acec-d66f7c1f4346"},{"claim_cluster_id":"6ca40c20-bd2c-4fa0-af88-bbe3820f05e6","event_cluster_id":"9297f5a6-da64-4942-8c55-fea3e2f0fc25"},{"claim_cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","event_cluster_id":"07ba7d5a-bc3c-4f63-a8e0-6487f494c700"},{"claim_cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","event_cluster_id":"753b53ca-12e6-424b-989a-e076a991708d"},{"claim_cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","event_cluster_id":"5bae13a5-6b81-425d-a9bb-49850203205e"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"448377aa-104a-47c8-b987-d7ae3a311686"},{"claim_cluster_id":"b9cdce3c-8c52-4df4-89e7-a4bcf232dbef","event_cluster_id":"9cf8c4fc-8448-4503-a774-71dc4b331a69"},{"claim_cluster_id":"346be717-a4b3-4210-bff0-be972806b6a4","event_cluster_id":"083a8283-1aa3-4b94-9026-bbd5c3a07cbe"},{"claim_cluster_id":"edd65f26-0117-4202-bd31-c3f265210b5e","event_cluster_id":"ab8af083-dfdc-4c18-95cd-32d551c130c1"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"b23ac12f-f63d-4693-a840-84942ee3fea1"},{"claim_cluster_id":"b7bef44a-7480-409a-8790-0a70b42045ee","event_cluster_id":"e1b47a9d-415d-4c0a-a801-d747a6f31d9a"},{"claim_cluster_id":"856ae956-c845-42c3-8716-9e150f646a11","event_cluster_id":"4c6fd3f2-5818-45f3-b8d8-85a9b9075f57"},{"claim_cluster_id":"267d2942-984a-4564-b33c-69e9db79a066","event_cluster_id":"a28a5ed3-bc11-405d-9242-8b1a5ce91c01"},{"claim_cluster_id":"6436c54d-cea9-4b06-8f6e-d82ef558f6c5","event_cluster_id":"b6b9e4e5-62b3-48a5-a508-9b40663b3e4f"},{"claim_cluster_id":"dde390b5-1a05-447f-86aa-a25992be6bfd","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"2fe8d49f-63a1-4171-af68-9824e47b825c","event_cluster_id":"3de68a28-505a-4c32-bcec-da26bd58e42c"},{"claim_cluster_id":"99d9484d-46ae-4ca2-98a1-dd3e0aeee99d","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"3d8a0674-b5ba-4875-8267-9c46797d5ef5","event_cluster_id":"dbc38a4c-6662-4d84-ac44-e5687dc9ef37"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"ebaf2aaf-acc5-40a1-b99f-157e33f793e4"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"bdc4ffb8-404a-4799-a92b-88d77e6c445d"},{"claim_cluster_id":"3f043499-266e-455f-a558-699fac541c36","event_cluster_id":"38a91236-7bbc-4335-9d5a-a470b70f608c"},{"claim_cluster_id":"824d7e98-fb11-413b-adeb-b8d12c8fb785","event_cluster_id":"04e5de16-d046-4bc2-878e-0b328f3385ed"},{"claim_cluster_id":"3afb5a7e-c2f9-4fc4-a379-b0fb650f805a","event_cluster_id":"f9f6b7b6-ec7e-4aa5-91d2-9d2cf4d35a54"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"},{"claim_cluster_id":"77de10dc-6dcd-4902-a9d2-f5cf9384d343","event_cluster_id":"ecf87520-6110-4dbb-8897-a76147b7c3f7"},{"claim_cluster_id":"0a173478-bf00-4e1f-be9a-c8305b945d9d","event_cluster_id":"e6294e0b-891d-4ba7-af93-8aa8ed47eeab"},{"claim_cluster_id":"e495e756-f14b-4c10-8358-f906f837fdac","event_cluster_id":"ef161e9b-6253-45b0-9c42-d8e3db87f120"},{"claim_cluster_id":"d9f5972a-ff26-4242-938a-7c9615591c15","event_cluster_id":"a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"},{"claim_cluster_id":"f92684c8-da9a-477a-ba9a-9eb41a6f9f90","event_cluster_id":"9a404aa7-ec0d-4ed0-88e9-60d78850dee6"},{"claim_cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","event_cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a"},{"claim_cluster_id":"8143472f-9ddf-4467-8402-c46a70ccaf1e","event_cluster_id":"69fc2536-52ab-49eb-8743-9e6f9bfcc4f5"},{"claim_cluster_id":"192dfe82-fc68-4d4d-ae38-d6077567ed10","event_cluster_id":"3eb4bc87-51f4-4c2e-990b-944e8a053ab0"},{"claim_cluster_id":"6436c54d-cea9-4b06-8f6e-d82ef558f6c5","event_cluster_id":"7c3d2190-bdc7-4187-b1eb-1c6bf0944191"},{"claim_cluster_id":"2f6021e2-bde5-4c10-ae2b-194bf6a93505","event_cluster_id":"640f326d-efe1-4293-bfc4-0c4c7b9185f3"},{"claim_cluster_id":"b6ac4f42-6e4c-4395-a71a-c8beca5b5336","event_cluster_id":"09202e6f-2182-42ac-8af6-6622f1cfeb68"},{"claim_cluster_id":"c62acce0-70f2-44c3-9131-cec3cdb1f20f","event_cluster_id":"33942929-a46c-44b5-a491-297910f07b91"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"8c441ed7-3996-46c2-abdc-191f54206cf6"},{"claim_cluster_id":"af3aa521-118c-415e-b54b-524628af7168","event_cluster_id":"22523c97-d6bf-448a-b10a-ccd7fd668e2c"},{"claim_cluster_id":"3e200fec-9dad-4a2e-a5e4-655848ec7983","event_cluster_id":"d64cb1f8-2dc5-4222-88a6-8bc5208a2f30"},{"claim_cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","event_cluster_id":"bdc4ffb8-404a-4799-a92b-88d77e6c445d"},{"claim_cluster_id":"be29b74d-f560-4279-9339-cf00d4dac2b0","event_cluster_id":"fc19cd3a-f641-4b19-a6bd-bcbcbc1d7fe6"},{"claim_cluster_id":"8f2a4264-d263-4757-889e-c18e3e101875","event_cluster_id":"182a4780-6c12-4ebc-96a7-e01af3d000d2"},{"claim_cluster_id":"aa458090-4ea3-4829-9f88-662eb71a8370","event_cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"},{"claim_cluster_id":"f3cb984c-8736-4ad2-8cd8-5ca9f90033d5","event_cluster_id":"d30fd077-478d-4784-a1a9-ce89125fa303"},{"claim_cluster_id":"74c84f9c-121d-41ed-8a45-f4cdf85eb02c","event_cluster_id":"d116bd42-a280-499e-95f9-862eab4e8043"},{"claim_cluster_id":"74f0249d-eead-4904-bdd3-cd8cfbdb6b82","event_cluster_id":"7cd46da8-e046-45f9-87aa-b04395bcb25f"},{"claim_cluster_id":"cf53004b-b29d-4fe7-a412-14956f8d2a9a","event_cluster_id":"5d2a23b8-6ca9-4894-b0bc-a3b5c15dbf42"},{"claim_cluster_id":"00e6b319-ea09-4ee6-8be1-7f243156f545","event_cluster_id":"c112d6c9-6b2d-48f6-ae9b-5380b20f2025"},{"claim_cluster_id":"c065f08a-341f-4084-99ca-ceef465c2c9a","event_cluster_id":"7e17abde-ea9a-4656-9558-6e168a28baae"},{"claim_cluster_id":"7f43c7d3-2a4b-493c-b3f0-a53355ae39a3","event_cluster_id":"85f720a8-0b31-4d1b-a866-8a5f552a25e1"},{"claim_cluster_id":"329c69a1-8578-4615-a95d-4068857af2c9","event_cluster_id":"45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"},{"claim_cluster_id":"da4bd748-3c84-4017-a93a-8247224fc32f","event_cluster_id":"028ee870-e258-43cd-99d3-f13e457b70d7"},{"claim_cluster_id":"27fad854-f733-4ec5-8acb-b36e0c043d26","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"aaa5b32a-96ba-4450-b886-70f714b65bf2","event_cluster_id":"d83800f4-0756-4306-86c9-259b547db8df"},{"claim_cluster_id":"cbd140c9-7dba-47e8-97c2-10198c9c38d7","event_cluster_id":"14087e7a-3bac-4d48-a154-8c1e158e6c14"},{"claim_cluster_id":"73a6792a-38f3-4e05-a1bc-e5dc764c0b4d","event_cluster_id":"f98db0f7-3865-4f81-b4c0-e009394ed065"},{"claim_cluster_id":"a536505f-e31a-400e-a4a5-1f74a9e29e7d","event_cluster_id":"3a46ccfd-5379-4ef0-aa09-8a1b6a5f409e"},{"claim_cluster_id":"a98eba10-9612-466e-bbba-6161ced90ab9","event_cluster_id":"b687420f-e058-48a2-8c4c-4bc6f35624c2"},{"claim_cluster_id":"1aadbdec-7f0b-43f3-98a7-709a1bcb5807","event_cluster_id":"d5742cb8-e264-4816-b45a-8b7710ea66b3"},{"claim_cluster_id":"300fdda9-fd92-4984-a9e6-86c9522fb6d4","event_cluster_id":"b523b8ba-6f7b-4630-8308-edf6d80a7a18"},{"claim_cluster_id":"2aeb94af-8d5b-40ce-b754-91495083b2a1","event_cluster_id":"e79e7825-9f83-4c5b-92dd-af1bdccc56ef"},{"claim_cluster_id":"5b2c4526-459d-4b6f-8f31-bd40fccf12ff","event_cluster_id":"95cf8fc0-eadb-4c70-8762-0c3f65726aa4"},{"claim_cluster_id":"a764eb56-b1bb-470b-bb17-4bd9f5369b4b","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"64a10d09-a49c-4bf3-80db-a2cb3188afbc","event_cluster_id":"e4e83b34-5f5f-4d12-be7d-278344e0b336"},{"claim_cluster_id":"980136c6-363f-4cda-bc50-cca417518993","event_cluster_id":"b978e9a0-f48b-432c-b14c-50e4efff007d"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","event_cluster_id":"7e64d534-c786-4ebd-b549-3314cdd361e4"},{"claim_cluster_id":"fbea59dc-8fdc-4fcf-ac76-32627af107ae","event_cluster_id":"3d7436aa-4609-467d-a098-e24702a617e8"},{"claim_cluster_id":"b60b834e-1991-44ea-a53f-68d101a440a4","event_cluster_id":"f04b87e3-ae1b-4e57-8c7a-f468d2163699"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028"},{"claim_cluster_id":"caa1a8ea-e71f-480b-808e-8ce18b47a5eb","event_cluster_id":"184f7da5-f557-4593-8954-67601ea3d345"},{"claim_cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","event_cluster_id":"86571ae0-c94d-4246-a1b9-4b9547fc239a"},{"claim_cluster_id":"f210a15e-3afd-4f52-8da2-de7a59e25377","event_cluster_id":"be39314b-1ba0-4fb9-b326-3f0e244710fc"},{"claim_cluster_id":"db0a8d4e-9354-4c38-bb13-56ae176ed70b","event_cluster_id":"2fb5602e-e1ec-4e01-ab46-f8e35a0df948"},{"claim_cluster_id":"77b557e0-b37f-4548-adca-2c9da9e04106","event_cluster_id":"ad32e47f-d132-47f0-8dd9-2751c477fa34"},{"claim_cluster_id":"a9555cd5-7b65-4e84-9f89-ed03117c7e50","event_cluster_id":"baac2920-a8d6-4667-acc5-460b63889a7e"},{"claim_cluster_id":"4a3bc772-20e9-4711-acc4-eb16f1a71bea","event_cluster_id":"8e8986ad-07fc-46e6-a980-933b8035ee58"},{"claim_cluster_id":"c91afcbe-198a-44cd-83c8-42c89811dab9","event_cluster_id":"5cf04f55-a643-43d4-8d14-b18769ab1e2a"},{"claim_cluster_id":"f8e7dcff-d078-4ce8-9ad3-495ed7c19774","event_cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337"},{"claim_cluster_id":"0511fc3f-517e-42e7-84fc-34ea436b847d","event_cluster_id":"b4a2abb1-9a33-4e4b-a995-84324638b8d0"},{"claim_cluster_id":"21240c8f-29c6-42ef-b002-a537a743739b","event_cluster_id":"d0b9d362-84b5-4285-90de-b70dc7fdf9db"},{"claim_cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","event_cluster_id":"9b2ccd60-9fd2-4e0d-8e91-bb564023a0ec"},{"claim_cluster_id":"f1535355-abab-40c3-b4e5-ea2b4fe4994b","event_cluster_id":"ca8ae13a-f4c2-40ca-adf9-58a7907b79bb"},{"claim_cluster_id":"ee3408ae-2ea4-4661-a58b-6e825aa4a0ff","event_cluster_id":"2dbe786d-9065-4e0b-93e2-135a2fc6f7f3"},{"claim_cluster_id":"ee3408ae-2ea4-4661-a58b-6e825aa4a0ff","event_cluster_id":"8affed0e-1741-45ae-9282-db13ed25555e"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"017489d6-d7b2-4b12-8669-3769c4704bdd"},{"claim_cluster_id":"3c28af07-0879-4e0d-a892-8c0d97f3e49a","event_cluster_id":"1519b279-d6f7-427b-b68e-0ca8ed827547"},{"claim_cluster_id":"9dae5050-ee2d-4e3c-8dd3-b9ea85a53752","event_cluster_id":"0c73bba4-2142-4833-ab2a-f7dd03c24dac"},{"claim_cluster_id":"29223456-9a08-4f68-9ce7-d62d961fb6aa","event_cluster_id":"a83597bc-3768-4ee3-a01e-2fac92f73ab7"},{"claim_cluster_id":"31cda056-0942-4d05-8579-66ba52eb0c7b","event_cluster_id":"e0a8946b-f177-4ac9-88a3-5799d558da5c"},{"claim_cluster_id":"de700722-a9e2-4659-a181-3fb83efdd41f","event_cluster_id":"9d12c49f-ea33-4a41-83e1-0a953c37fd5e"},{"claim_cluster_id":"619d0e6c-df2c-4164-aaac-ccaba7c311a6","event_cluster_id":"92a82b98-f457-4ad6-9e23-e80c7e1d25f5"},{"claim_cluster_id":"f4f13b9b-3296-4913-8eea-62ce1becaa2c","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"0d0fd5f0-0301-424f-b0b1-a60ab6ca045f","event_cluster_id":"776ed0c0-bfbb-420d-8369-ebf0e4544c64"},{"claim_cluster_id":"c2ba86a6-df2c-40b6-bf30-1269c5ac3702","event_cluster_id":"473550dc-4370-4fcb-8c1a-760765586a92"},{"claim_cluster_id":"ea149597-1daf-4627-8587-59eb8a6bde8b","event_cluster_id":"08a5fea6-9542-4505-b3ba-04e342c44cbf"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"545232cb-5fc2-43ad-859e-11784f675852"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"acd745c5-1bfe-4e37-a6d1-38b30d091ba1"},{"claim_cluster_id":"654ddafb-5d45-4313-9cd4-f144aab1e464","event_cluster_id":"7da5e969-ac3d-4ab8-86be-3712be90baa2"},{"claim_cluster_id":"934665b5-3969-4817-9dd5-47b732fdd380","event_cluster_id":"78e60a12-a4a3-4c5d-805d-471d75987612"},{"claim_cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","event_cluster_id":"f38958f6-adfc-406e-ab46-296dedeeb781"},{"claim_cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","event_cluster_id":"4129284c-60dc-471f-99d0-fbb5e6ca7277"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"46812bda-c4dc-4bd2-a7c0-e250a28da359"},{"claim_cluster_id":"af51e97e-2570-48ba-a0bd-ab0668831da9","event_cluster_id":"f9647705-1fb0-4b23-8449-1d162afd7139"},{"claim_cluster_id":"0addd203-38b6-4e2c-8fed-432e5b8aac5a","event_cluster_id":"fc22f23f-3e70-4f58-9556-2d3e03c04167"},{"claim_cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","event_cluster_id":"d74329dc-5b82-41ba-94bd-2cdd8306d3ee"},{"claim_cluster_id":"4572f15a-5436-48cf-a1f9-d3e141616965","event_cluster_id":"a6c32f96-492e-46e5-b580-0804b089cb50"},{"claim_cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","event_cluster_id":"5bbc7620-dddd-48b2-ab59-dca397c2985e"},{"claim_cluster_id":"98a97f12-7d1b-49e9-8178-578b2d656f88","event_cluster_id":"eac47a08-6ad5-4405-8bfb-82ab701b0507"},{"claim_cluster_id":"d4c6919b-eb92-4688-a3f3-bcffc0362115","event_cluster_id":"1f60ebbf-51df-4e3e-95f0-d6e32c7fc5d9"},{"claim_cluster_id":"258085e5-fc49-48d1-b3f4-3f9862c3ba91","event_cluster_id":"ecb6a08c-9197-401c-afbc-cd0ee3d88f04"},{"claim_cluster_id":"f465e3b9-9784-4302-b258-d34ad0adf726","event_cluster_id":"3a4ae54e-e7b7-47e9-984e-62601ed45ab4"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"2ea5d498-58e2-44a4-a51a-95bda7047686","event_cluster_id":"e4e6149d-8b97-4295-847d-c2c2c5acb8ee"},{"claim_cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","event_cluster_id":"06370214-3027-49a1-988e-c5188868372e"},{"claim_cluster_id":"c4bd1c97-a831-4763-9c03-6a3cf69f7caa","event_cluster_id":"24c54796-afba-46ba-9bb2-8854f3d0747a"},{"claim_cluster_id":"69c28a9e-902d-4ac0-9540-ae2854dbb59f","event_cluster_id":"439aa0a6-6e46-43ae-ba81-fc975c6669e1"},{"claim_cluster_id":"6950bc54-67bb-4e8e-b8cd-afd5c7d79d00","event_cluster_id":"1bb2fbd1-906a-4d81-b23d-f6c0a4024661"},{"claim_cluster_id":"48f8d3d4-cbd2-44f5-81bc-3adadbe6b6e7","event_cluster_id":"1f558072-4f79-45c5-acb2-7e178149e980"},{"claim_cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","event_cluster_id":"deae8114-2508-4864-a544-401d4150e26c"},{"claim_cluster_id":"d281c55d-162e-4c45-bdc4-8fddc9bff858","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"e88c49ad-3df2-4059-82e4-46d0f3b59757","event_cluster_id":"ebcf5883-5a67-45cd-af26-c257a5d38512"},{"claim_cluster_id":"a615f0ed-7c6c-41b5-95d0-49cb25bb9feb","event_cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125"},{"claim_cluster_id":"58a7d973-9fa3-4047-a219-579a31c4561b","event_cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56"},{"claim_cluster_id":"695b3abb-f469-4406-b1ea-91e5eba8aa09","event_cluster_id":"c5d49178-7807-406f-89c6-f05965bb7e2e"},{"claim_cluster_id":"0d813aeb-360a-48ec-afeb-778e533504c7","event_cluster_id":"68c5326d-ab98-438e-abd1-0e7a9ca85a98"},{"claim_cluster_id":"ad83e0a6-e572-4332-8ef0-01e05cdfa760","event_cluster_id":"66406d6a-fd8e-4e61-aeac-decbaba1818b"},{"claim_cluster_id":"83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","event_cluster_id":"d214ab5c-324d-4152-a542-c58284f4ca22"},{"claim_cluster_id":"f5514b1c-3b40-41b8-9290-039c2c94a3e7","event_cluster_id":"2bec49d1-2f19-441e-9c0b-01eed5568c41"},{"claim_cluster_id":"b459615c-cbbe-438d-9dbf-cc3051ba017f","event_cluster_id":"0313a78d-59e1-4fe7-8d40-5db79d99214e"},{"claim_cluster_id":"be44c17b-cb3f-4a06-af5b-de816dfb4f56","event_cluster_id":"2490af01-fba6-4168-9f21-fb760726b38d"},{"claim_cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"854e712a-9c33-4e4e-be9f-d9dd40fa0112","event_cluster_id":"e8e30d44-65d0-4e66-baf3-7e0ae3df4a05"},{"claim_cluster_id":"f3288e7a-a54c-44d1-8307-67aafb47c852","event_cluster_id":"f51a6ac2-4516-4b4c-9fdb-e7e4932f790d"},{"claim_cluster_id":"b686bd17-fb36-4b7b-9caf-084f8d91c149","event_cluster_id":"0033e72b-385a-41ce-8ba3-fd98c6521d05"},{"claim_cluster_id":"3be4473d-cbba-49ee-93e6-36d5bcd0dc0a","event_cluster_id":"5243db0f-4bbb-47bb-9e93-e78de6804d5c"},{"claim_cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","event_cluster_id":"77e0e128-878a-417f-8723-91873f114032"},{"claim_cluster_id":"9a73096a-390b-4f9e-a044-22f30734ce69","event_cluster_id":"36c07d65-523d-4b69-bf8b-7f1ec91d6954"},{"claim_cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","event_cluster_id":"1e5040f4-1599-4a16-abf2-bb352e20053c"},{"claim_cluster_id":"285cd62d-96d8-4ff1-af84-3fd22f7b4f51","event_cluster_id":"54af5dc3-58d2-4d68-acb1-aa5f30ea62f0"},{"claim_cluster_id":"9be076b9-65b6-4c8e-b3d7-1df3c547c0fc","event_cluster_id":"a0fb845d-3984-4109-ad59-e77cf57e7687"},{"claim_cluster_id":"5b6da2ab-36ee-4cfe-968a-ce42565405bc","event_cluster_id":"cfa7b687-2383-40f8-9684-b8b6e91149cc"},{"claim_cluster_id":"df13c28d-11fd-4cdc-a0c7-5076d0c46483","event_cluster_id":"f2b7ea2e-02cf-4061-b076-60c350522e8d"},{"claim_cluster_id":"eb38bdfb-232f-4460-8d60-fc8806237786","event_cluster_id":"e8299254-b0bc-4a3f-86b2-fedfa746efb0"},{"claim_cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","event_cluster_id":"314510db-f67d-4268-b068-13a87261ae5b"},{"claim_cluster_id":"666873ec-e76e-4f8a-8d96-7a31c5084ac4","event_cluster_id":"e92990e4-6de9-4c7c-9c4a-006af1a579b1"},{"claim_cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","event_cluster_id":"c36b66d4-db22-4344-899e-be0f938cf47b"},{"claim_cluster_id":"f6f15ea6-27bd-499b-a6fe-74d144b5ac0b","event_cluster_id":"4d88384e-f212-4bd5-8d08-7d715e173b10"},{"claim_cluster_id":"c065f08a-341f-4084-99ca-ceef465c2c9a","event_cluster_id":"eba7ffd7-9740-4070-bc0f-3ac660c28939"},{"claim_cluster_id":"dfcf5731-89c0-4af2-a475-d7087b733644","event_cluster_id":"ba26379e-e775-463f-9971-b8b46c709801"},{"claim_cluster_id":"dbd98860-9de1-4289-bb60-99171790c782","event_cluster_id":"3c952e11-fec7-43b5-87d0-197de2b823da"},{"claim_cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","event_cluster_id":"ab1bcfd5-bef2-4f73-aff0-790c6f681ce4"},{"claim_cluster_id":"bd06a127-0f18-48fa-b6d0-ff607d111775","event_cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67"},{"claim_cluster_id":"8d565c91-b887-465d-a08e-aff09b1e9e5b","event_cluster_id":"88fa31fb-364c-47f5-bac4-4ecea848d93a"},{"claim_cluster_id":"14c9c1ef-f94d-48f3-87f5-028b0baa8869","event_cluster_id":"ed76bc08-55bf-40dd-b156-814a949b24dd"},{"claim_cluster_id":"f83c19b1-e59e-4712-8a86-4c8c86ee0e2b","event_cluster_id":"3cd947fb-d46a-4f38-9705-3c1f8700f549"},{"claim_cluster_id":"8aec1af3-93d7-45b8-8844-62e8b3ac6198","event_cluster_id":"da0d09cf-ea98-4fb9-b2a8-2ae9009e9f87"},{"claim_cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","event_cluster_id":"bd48a2e4-20c5-4fa2-90a9-0725e3288c94"},{"claim_cluster_id":"6442657f-3626-4ac3-8a02-28b3c72e00ba","event_cluster_id":"70bf9f45-ce2c-4053-918f-69d225a10029"},{"claim_cluster_id":"7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1","event_cluster_id":"ebca8a8b-8a95-480f-8cf1-c34e09e5822c"},{"claim_cluster_id":"5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9","event_cluster_id":"2fd5c32c-ec83-4d86-8836-741ba8422357"},{"claim_cluster_id":"1f8ce922-0e37-4ccb-b586-67da18764d96","event_cluster_id":"6f960627-d475-4f28-8eb0-dcceb972aad4"},{"claim_cluster_id":"db81e344-8970-492b-8ff5-c4f2bdbaa947","event_cluster_id":"900b62cf-2f7f-4c8d-9d94-4cbb68246f3f"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"b39e93e4-b791-4b1e-963b-d8f068ff0b1d","event_cluster_id":"7cd46da8-e046-45f9-87aa-b04395bcb25f"},{"claim_cluster_id":"e2621663-e9d9-45c1-9069-fa9d94c82303","event_cluster_id":"867c6623-6254-4965-b302-1483ede252cc"},{"claim_cluster_id":"3b1f0ed9-3201-46c5-93e3-016f26c4d261","event_cluster_id":"48e9dba9-1fa3-402e-ae73-202c64781781"},{"claim_cluster_id":"489cefd4-e6ef-4f49-8a70-8d8f7bc512bd","event_cluster_id":"8eba8ddc-43e0-42e3-8917-7f76c17baf39"},{"claim_cluster_id":"fcc1829e-1835-42a8-bf49-00b5c2d30892","event_cluster_id":"ac7c5639-803c-4c6d-b9be-69ecbea167de"},{"claim_cluster_id":"d01db0e4-579b-46e1-b0a0-4bf5732646a8","event_cluster_id":"f48f090b-b925-4ff6-946c-dfbb77137193"},{"claim_cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","event_cluster_id":"94362393-c674-46bc-9e3a-666f4bf5a507"},{"claim_cluster_id":"c076834e-92b4-4b02-8416-1f251021c0cd","event_cluster_id":"821d5bc2-820d-42b9-a931-b0991cb2d55a"},{"claim_cluster_id":"ff70f7bd-e1b1-44ea-8b32-024f3d1917ed","event_cluster_id":"42817958-19f1-419d-a3c6-d4ed59f438b6"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"2f0fefda-5b83-4f80-8b8a-97c292bbda20"},{"claim_cluster_id":"ab72f353-1b68-44ce-979f-a10883b99605","event_cluster_id":"2cf37935-88f0-4aab-94bf-6c7a6da78e48"},{"claim_cluster_id":"5c0df4bf-ba62-40d1-a306-8313dfe790e6","event_cluster_id":"b448b340-9010-448c-b955-573b9913feb0"},{"claim_cluster_id":"edbdc807-7fba-426c-a271-726e1f090eaf","event_cluster_id":"72cb3acd-6792-42e7-917e-0a257b0b418a"},{"claim_cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"71522ed0-7107-4dfb-8b87-e633332c4e3f","event_cluster_id":"49c9cf48-a13c-439b-9db3-4000e6bfc74f"},{"claim_cluster_id":"e968bf8c-b2a8-4330-bf71-9cab4f6826a5","event_cluster_id":"3bff863b-ef2c-4985-ab4b-24af72e149e9"},{"claim_cluster_id":"55bc595b-aea0-4d83-938e-9ae3ab116813","event_cluster_id":"a8a5c0a8-339b-46a8-844d-e6af4072cfdd"},{"claim_cluster_id":"81062452-735a-45ec-ae26-d06b90c45ed4","event_cluster_id":"8a1cf3e4-81f5-4680-a43b-353cdda171be"},{"claim_cluster_id":"aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868","event_cluster_id":"46a652d6-7e4e-45bf-93da-8368a900beab"},{"claim_cluster_id":"290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45","event_cluster_id":"42c9725b-d681-410b-871b-771e74124bd4"},{"claim_cluster_id":"c7c24801-e07d-4e78-8de0-4a42e8b64272","event_cluster_id":"8649324d-646d-4eb1-97c6-070697056cd2"},{"claim_cluster_id":"55bc595b-aea0-4d83-938e-9ae3ab116813","event_cluster_id":"5bae13a5-6b81-425d-a9bb-49850203205e"},{"claim_cluster_id":"4a05fcea-c8cb-4b88-bb80-cab978e72560","event_cluster_id":"a36c95c0-8daf-40fc-856f-176637a22c4c"},{"claim_cluster_id":"e21ec8bb-ddf8-4115-9765-9a2f72eed10d","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"3d2576b2-1572-432b-98fe-db8e768274d5","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"6d2792d9-4dcf-4980-9870-d295c7f8e2c0","event_cluster_id":"d485a542-5dc8-49cc-9ed2-7c434144d575"},{"claim_cluster_id":"6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5","event_cluster_id":"e6a8f39a-ea50-45d0-aa2c-f24fddc8d1e3"},{"claim_cluster_id":"059205f2-0c13-465b-ba40-83a1ffcbcaa3","event_cluster_id":"d4448dff-7650-4f4b-b38f-b00c5af8c2b3"},{"claim_cluster_id":"18108091-50d0-4bb5-a06f-5f2734380aef","event_cluster_id":"c44517b3-ae07-46af-8dc8-9946743528e1"},{"claim_cluster_id":"db81e344-8970-492b-8ff5-c4f2bdbaa947","event_cluster_id":"db2c7499-73dd-49a7-b315-23a9a2089f45"},{"claim_cluster_id":"1991b6cd-3baa-475c-add7-d4b101a0de09","event_cluster_id":"fca8c069-2da0-43e8-8cac-08662970bcda"},{"claim_cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"6b000975-482c-4a87-97ba-4b7f79318bd6","event_cluster_id":"3391436d-d1cd-41e7-87fc-ba5f4f2496cc"},{"claim_cluster_id":"88a5288e-7f93-4e9a-8960-db23a08024fc","event_cluster_id":"5b67eeb9-9da5-4079-bb66-f861e834a37c"},{"claim_cluster_id":"5a861756-5d94-444c-84a0-fab63d482e8c","event_cluster_id":"f65ebec2-0122-4441-975a-e196ab928bdb"},{"claim_cluster_id":"b0b4f902-9c94-4b57-b853-99cb04209992","event_cluster_id":"d0668eff-8d5e-4aa1-a4e9-eab28ee44705"},{"claim_cluster_id":"2ed3c98f-2c08-4da6-97f9-38e8a951f08e","event_cluster_id":"16aa2006-ba94-49b3-a83c-9dc2e8c8bf21"},{"claim_cluster_id":"818b32ce-b83e-40a4-b06b-dd4e2c09af00","event_cluster_id":"201e4820-096b-4a76-8f83-d96f22acc64b"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae"},{"claim_cluster_id":"e8c5e2f3-c4c1-4992-a125-b40d6d98bace","event_cluster_id":"93302bc5-2c4d-4a14-9964-fc677c0db641"},{"claim_cluster_id":"e11231dd-53ef-41bf-966c-4a202aa2895c","event_cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56"},{"claim_cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","event_cluster_id":"e285d3b2-02ce-4dd4-ad86-ac99b2199a66"},{"claim_cluster_id":"e59930cd-f28a-4a44-8feb-24e860e36480","event_cluster_id":"eeeaa7c5-23d3-447d-ace4-2782329b8bb9"},{"claim_cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","event_cluster_id":"93f5bdee-4d35-454b-8f1b-0b318e24a68d"},{"claim_cluster_id":"83ec8695-6d93-432e-a8be-81705e2e2a54","event_cluster_id":"6f7f68fd-a840-40e2-a600-b19e0677f9c8"},{"claim_cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","event_cluster_id":"592ed206-56a1-4eac-9ef2-85b6be103dc1"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"9096c294-fd2c-4311-a357-8c17726796f2"},{"claim_cluster_id":"41a156b3-5c3d-4d82-b8e4-7ad88953f690","event_cluster_id":"41026f02-6a91-44fd-aeaf-33bceaabf234"},{"claim_cluster_id":"ab8de566-e0cc-475b-b056-6b27916b484d","event_cluster_id":"4ae526b6-129a-4522-b79c-5fa5e53d2329"},{"claim_cluster_id":"2b9508d5-4552-4994-840b-08ab461e29c3","event_cluster_id":"21f0a219-a107-4e6e-aa28-e010ad5aec66"},{"claim_cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","event_cluster_id":"aacd7f08-5036-4563-9193-ec61d4e0ea80"},{"claim_cluster_id":"df17af70-aa4f-46d9-b191-eb3b4eeac1ef","event_cluster_id":"ed212b87-d906-4b97-806f-edc87a49ab9e"},{"claim_cluster_id":"183db562-aea1-4c36-b76a-f0deea54c6a4","event_cluster_id":"ea56561a-6c42-424b-a439-8949e0922884"},{"claim_cluster_id":"c7c24801-e07d-4e78-8de0-4a42e8b64272","event_cluster_id":"32697b9c-6810-416a-bedc-25a1c14600c3"},{"claim_cluster_id":"ee3408ae-2ea4-4661-a58b-6e825aa4a0ff","event_cluster_id":"dfa3481f-adba-4f59-b051-83a57da84830"},{"claim_cluster_id":"9af9ad02-7803-4d3d-9d58-fdfc300bef96","event_cluster_id":"252647f3-b2d0-4fb9-8a73-8d20e5a61e96"},{"claim_cluster_id":"18d83743-88ff-4a61-999f-d69912fd6589","event_cluster_id":"dd335f66-9180-429a-8e21-b0e59da84aa2"},{"claim_cluster_id":"162b03a4-86a7-4adf-9f73-3093aecba542","event_cluster_id":"4018b382-2692-4cbc-af34-c3f4f61413b4"},{"claim_cluster_id":"435bc534-7da4-4fec-82cf-af0f2a0a282a","event_cluster_id":"76455b31-1fcc-4337-adc1-b2686dd2563d"},{"claim_cluster_id":"2f43e86f-24fc-4c3c-a77d-c5abbf46ef19","event_cluster_id":"94a48846-dd13-4363-a56c-c51f47f2440a"},{"claim_cluster_id":"388f4cb2-36f0-4395-889f-3dc07bb54aff","event_cluster_id":"b3bb12a8-9e61-4051-99f7-b8946e7edc6e"},{"claim_cluster_id":"df13c28d-11fd-4cdc-a0c7-5076d0c46483","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"daf0b3a1-53f1-4b47-955e-785030ee3839","event_cluster_id":"446a7c12-73f1-49f5-944a-5a0119281e12"},{"claim_cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","event_cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"},{"claim_cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"3045aa88-88d8-4410-9d93-f305adb15fd3","event_cluster_id":"3d26e147-f4b2-4b1e-ba9b-bf45396f5e59"},{"claim_cluster_id":"138e6c92-a8bd-4f22-8e72-b320bdcf0b62","event_cluster_id":"3cb65e99-ccac-4aa2-91a0-7af465ad385d"},{"claim_cluster_id":"92df4e35-804e-4b67-b2a3-fbb89ed1961f","event_cluster_id":"aeb82733-bdb6-43c5-a151-fceb87e14ebf"},{"claim_cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","event_cluster_id":"91a2ed36-3e87-4baf-9999-c65078a62cbd"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"be379179-357e-431a-afc7-707de2663f0c"},{"claim_cluster_id":"e6867616-fb8f-44d6-8b92-f5cca8ca9e6a","event_cluster_id":"3f285813-2863-43e8-b0ba-5a13b63cb515"},{"claim_cluster_id":"3c4e2f0e-5b8e-45e9-84a7-c71071caeba0","event_cluster_id":"ab327c16-f48a-42a2-adc9-ef76eb93901e"},{"claim_cluster_id":"89a7a448-be37-40e3-973f-79b15dac979d","event_cluster_id":"21b385c4-010f-457b-bf2e-d3d6a55a5ca1"},{"claim_cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","event_cluster_id":"050d87c2-4ac3-4e0e-8673-b4a44b43bac0"},{"claim_cluster_id":"e9c84dbc-30d1-4e60-bbc8-700057190615","event_cluster_id":"4cdadb3d-d6d7-4b33-b2c9-1974e780d726"},{"claim_cluster_id":"1ec4a683-16aa-481b-9033-75779c52f6c1","event_cluster_id":"b51f7dc2-d0c0-43ca-aba0-033ca0100d18"},{"claim_cluster_id":"b4ecc989-8236-436c-a361-fdaa1e9413ad","event_cluster_id":"821b8f2f-ed67-40fb-ac0f-fb14c5b4d7bf"},{"claim_cluster_id":"a83fedfc-0f0a-49b0-9dae-3932f2ba6983","event_cluster_id":"acad8d82-630a-486f-9b73-624703b74a12"},{"claim_cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"67c32fef-bbe8-4245-9a91-7d8aee491367","event_cluster_id":"ffdeea6b-2666-497f-8afc-18b1b72c39c8"},{"claim_cluster_id":"818b32ce-b83e-40a4-b06b-dd4e2c09af00","event_cluster_id":"5b4f8322-7c02-4a35-a585-89dc98ced769"},{"claim_cluster_id":"ba205832-fc5f-46fb-90ac-d89622b9cebf","event_cluster_id":"ff80368b-8a04-48e8-a451-431808c81ba2"},{"claim_cluster_id":"b9a17741-2ab3-4713-9777-efc674860d38","event_cluster_id":"268b0686-4ead-44df-9f34-76aeb864e839"},{"claim_cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","event_cluster_id":"421f3ec9-adff-4513-86c4-d1e8d810a087"},{"claim_cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","event_cluster_id":"6da8eb62-757c-4652-8389-b32015cb40a9"},{"claim_cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","event_cluster_id":"8351f868-a72b-47b0-8a87-867df6862124"},{"claim_cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","event_cluster_id":"9b0314ac-478d-4c92-b0c0-490018094349"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c"},{"claim_cluster_id":"17c8775c-7a3a-4607-aa7f-5b24078a17f8","event_cluster_id":"d0dc34ca-6f25-427d-a56e-1d4f3210e605"},{"claim_cluster_id":"e60065d4-ae50-40b0-8e77-8c2ad3e36235","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","event_cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028"},{"claim_cluster_id":"1e9c3202-7611-4885-bb24-d9dd05b7eed3","event_cluster_id":"308a615f-ca1b-4ef9-9f68-b4e3d4d08711"},{"claim_cluster_id":"8c61663d-a5f4-43e3-9ca6-42de906f614c","event_cluster_id":"2dfb4996-f1b5-47a1-93fd-431ef2467700"},{"claim_cluster_id":"d012c47c-3d49-4f8a-9fcf-db101ff82249","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"da4807bf-cc54-48c7-b3ca-69cd854da837","event_cluster_id":"608932d5-1e12-46e3-a718-377dfac71e8d"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"356ce4de-dd2a-4caf-bb6c-703dee1f13f4"},{"claim_cluster_id":"b9a17741-2ab3-4713-9777-efc674860d38","event_cluster_id":"e500e465-a022-48fb-afd5-82c02df96bbc"},{"claim_cluster_id":"eb646312-9617-4ab9-b534-22cc250a28b0","event_cluster_id":"a5e2f736-5d7e-4b45-8724-dcdb3a0aecd0"},{"claim_cluster_id":"3720666b-a4ac-4b21-9f19-2a86f32551a0","event_cluster_id":"7534b1ef-c71f-474a-a574-a2a3d535cd1b"},{"claim_cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","event_cluster_id":"ccdc4717-b37b-4b1b-94a7-20dfafa305fe"},{"claim_cluster_id":"847accaf-332c-4ec2-bd26-cd592d1fa2fc","event_cluster_id":"fe93734b-6e24-497d-aea9-a8d5b75d7f64"},{"claim_cluster_id":"5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7","event_cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c"},{"claim_cluster_id":"0df84ab3-1fc9-4f33-8710-bd9c228e4c70","event_cluster_id":"6e176932-b450-49d2-bc88-60ebe982b797"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"6f7f68fd-a840-40e2-a600-b19e0677f9c8"},{"claim_cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","event_cluster_id":"217bc58f-d97f-49d7-9c91-2a55c225a54a"},{"claim_cluster_id":"ea149597-1daf-4627-8587-59eb8a6bde8b","event_cluster_id":"06d90458-c93e-4ddc-a393-97e8e0d06f91"},{"claim_cluster_id":"70b45d78-dfac-4810-b7f6-abeea55c435f","event_cluster_id":"cb189bb7-f2fd-4426-9c9b-411ad929bddd"},{"claim_cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","event_cluster_id":"20324583-738f-4b71-89a8-1820cc1a827e"},{"claim_cluster_id":"fdae240e-8bc7-467c-b880-f3913e28e6ce","event_cluster_id":"03481317-8100-4f6a-8ba8-a8c9a52c0e90"},{"claim_cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","event_cluster_id":"19380a4c-de83-43a7-ae00-058986b5206e"},{"claim_cluster_id":"a7043201-daf7-4ddc-86e1-fe3a850942e2","event_cluster_id":"9bfc8129-531e-4c98-b3c5-a6aa21e4674c"},{"claim_cluster_id":"e7139494-8034-460e-8501-83d621dafede","event_cluster_id":"2e4d3514-9265-4850-95e7-fe8c0be93a5f"},{"claim_cluster_id":"5b34f4e8-867e-44ea-b5c2-c5295a09dd5e","event_cluster_id":"bf671abc-cf54-41ee-b308-c02abd68d48b"},{"claim_cluster_id":"d622247c-7345-4e31-99b0-dfafa4dc550f","event_cluster_id":"2a187430-0a71-47a9-918a-414338300232"},{"claim_cluster_id":"6bcd764d-320f-4851-ad8b-859177f022bf","event_cluster_id":"96a7a0f7-738c-489b-9ddb-d5c4dba8d9f6"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722"},{"claim_cluster_id":"587bb9b0-b0dd-47bf-9ce3-29231f30f4a3","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","event_cluster_id":"092693ec-ddb5-4cdf-be96-1d6ac20b489b"},{"claim_cluster_id":"83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2","event_cluster_id":"f21aa624-4667-4f48-bb4c-1942acec5158"},{"claim_cluster_id":"15f89230-b855-41bc-bc6f-7a68ea38aff0","event_cluster_id":"7b0bfb4f-e506-40fa-b633-0da23dace3d6"},{"claim_cluster_id":"f0e862e5-92ba-499e-8f7b-4935ce01c5fd","event_cluster_id":"25e8666d-6596-4996-8765-9de5aa51e568"},{"claim_cluster_id":"e40e6c83-dc7c-44e8-8637-389476dedd00","event_cluster_id":"c66e7d20-399b-4cfc-80f9-620801afd3f6"},{"claim_cluster_id":"d92f99b3-bdef-4ca3-95aa-e303f2451b97","event_cluster_id":"11c3011e-be2e-490b-b73b-6b530385f70c"},{"claim_cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","event_cluster_id":"827f6b49-228f-4d42-afa2-d86a5b588a72"},{"claim_cluster_id":"4958a7ec-0cd2-487f-a59b-9bc34843a2b7","event_cluster_id":"e1b119bd-f317-4a5f-8c26-1f7c12a78710"},{"claim_cluster_id":"a5a6c59f-7670-4f97-9c2b-c94700d73131","event_cluster_id":"81d59e77-2bcf-4755-b211-fc910c424229"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"},{"claim_cluster_id":"9bcb7463-7e6a-4bab-b398-5dd6ead423be","event_cluster_id":"9ac8d542-8a25-4298-bb19-b93232c0319a"},{"claim_cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","event_cluster_id":"c0322634-7754-4f2b-b97d-7786687b4f39"},{"claim_cluster_id":"13672f1a-e63c-4ec7-9f85-d3ed61ff60fa","event_cluster_id":"ad25bdfe-5d0f-4c75-8f1b-cb123f11cb06"},{"claim_cluster_id":"a92d1a1e-f967-4044-9d5c-136fd4264137","event_cluster_id":"b07254f1-f996-464b-a61c-6949e39dcdb5"},{"claim_cluster_id":"b5600099-12c0-41c7-bfb6-4b6bb66dc0dd","event_cluster_id":"1743784f-0949-4ddb-93e5-a1fd3954d25b"},{"claim_cluster_id":"41a55c60-75f3-48f5-817e-bc3dd4fc026d","event_cluster_id":"c3a6bce1-7cb7-4d0d-a994-69caef25a8d5"},{"claim_cluster_id":"d07c5569-3547-4153-bb09-72f6d513ab57","event_cluster_id":"1e56067f-4831-446b-a37b-b3b5e1d7166f"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"c3b690f0-82c8-4db2-ba3e-5e52a89ca594"},{"claim_cluster_id":"76bc71d7-2c17-42b9-974c-d517911bab56","event_cluster_id":"c96cd646-4254-4e40-a0db-aa3d02c5b208"},{"claim_cluster_id":"f367b654-8f0a-4a4d-816e-54c86d7f13ae","event_cluster_id":"446a7c12-73f1-49f5-944a-5a0119281e12"},{"claim_cluster_id":"004d8db2-6d73-4ac4-955b-6d04e88a0716","event_cluster_id":"edbf2785-2875-4f94-8c61-364dee3abf1f"},{"claim_cluster_id":"5765d283-f56d-43cd-b120-e8f9048e2325","event_cluster_id":"b95118e4-bfa9-41d0-884f-00c06ed87e30"},{"claim_cluster_id":"dc8d69ed-9d9d-4c04-a104-2c89e796edf3","event_cluster_id":"62f74a8d-c7b3-449b-9454-ae631aea88c2"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"f2b7ea2e-02cf-4061-b076-60c350522e8d"},{"claim_cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","event_cluster_id":"3a723b11-9c69-4419-ba9d-ccab21e2fc24"},{"claim_cluster_id":"3630ee9d-368f-4623-9704-06881bdf9264","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"6f847ace-00e0-4009-b5e9-3729f7a9e244","event_cluster_id":"f50c160a-60a4-4be2-9f62-bc773e7ba48f"},{"claim_cluster_id":"a0c8c3de-8102-4a9b-b20a-80ade6132b4e","event_cluster_id":"36b35892-f11e-4f98-83df-979e347100dc"},{"claim_cluster_id":"bcc58315-e1c3-44d9-8dc7-b3967b315e01","event_cluster_id":"a0a19a10-55fb-482a-b96b-5df57df087a3"},{"claim_cluster_id":"c782b8c2-e8a6-49c0-98b9-40619e415dcd","event_cluster_id":"65f75788-4ff6-47c1-8a6e-6bb7cdd19537"},{"claim_cluster_id":"8f15ddff-3bc7-4fbd-9371-1a897f8b9078","event_cluster_id":"25a5b743-428c-47c7-abea-0b994fd987b8"},{"claim_cluster_id":"916339bd-3e65-4fc3-be04-12020f45e716","event_cluster_id":"5b003616-1a21-4fdb-b479-c710fbcc5926"},{"claim_cluster_id":"ce0417d2-5817-45d3-a01f-447b8d6d19ff","event_cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87"},{"claim_cluster_id":"fbea59dc-8fdc-4fcf-ac76-32627af107ae","event_cluster_id":"658c3b98-6196-42b5-b086-e8814a2a7b5e"},{"claim_cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","event_cluster_id":"2a0edc6f-16ff-496d-b79c-24bffd830324"},{"claim_cluster_id":"679dc735-ea4b-4b4e-88e2-45d26bcc5b41","event_cluster_id":"7564aa71-23fc-4383-a2a0-0245e543e0fe"},{"claim_cluster_id":"efcbf9db-15ac-473b-a9a9-0988dcab89df","event_cluster_id":"b175f6e9-a72d-4057-b833-76aad93255ef"},{"claim_cluster_id":"24d4d508-a837-441b-b87c-de6ead3d7582","event_cluster_id":"615eb8c6-f4dc-46f8-a203-a52e0d6c79f7"},{"claim_cluster_id":"095169c0-0ce4-4362-b29d-486ce7d2b848","event_cluster_id":"f551f1f0-32f5-4ff3-b5c9-5aab61bb1bd6"},{"claim_cluster_id":"ff92e2cd-b51d-4aba-9214-602e53d602c6","event_cluster_id":"b4f7c43a-b96f-4977-a6a9-ad07015e8976"},{"claim_cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","event_cluster_id":"347d475b-a5aa-4035-8032-84126946c0db"},{"claim_cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","event_cluster_id":"2f7d7b19-3996-4824-8b2e-60b30c5d543d"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"c09c5abe-d2d4-4b78-b32f-49fbbd5778a7"},{"claim_cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","event_cluster_id":"7b83d10a-e2be-4730-b52d-6f8b8b917c91"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"cba3863d-9ffc-4647-831b-d4da84c689e3"},{"claim_cluster_id":"61d63dd9-934f-4808-b6ab-ed734f2474b3","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"7a66905d-c83d-454d-9b6f-176a36e4d7b3","event_cluster_id":"e294ae03-93b8-4461-85ca-920f88826e8a"},{"claim_cluster_id":"9867a541-4a4c-449d-a4af-a0263f8d23fb","event_cluster_id":"2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194"},{"claim_cluster_id":"4572f15a-5436-48cf-a1f9-d3e141616965","event_cluster_id":"4edf6538-801f-49f6-932e-65747f37810f"},{"claim_cluster_id":"9ce1a265-b79e-4040-a0e8-f1a6fbb59f67","event_cluster_id":"cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"},{"claim_cluster_id":"e633b9f2-d6c2-4c51-83af-0aed2e577009","event_cluster_id":"9c028d31-caed-4945-8a22-834a8ca119bc"},{"claim_cluster_id":"02c78b1c-dd55-4ba6-a345-d21fd27d3214","event_cluster_id":"398bd69e-f1d9-412f-8469-51469e37a88e"},{"claim_cluster_id":"62fc9d37-f7e6-43e7-a681-3c5679294ee9","event_cluster_id":"e00b6e6b-19c3-46b7-8ed7-41551b5be8f8"},{"claim_cluster_id":"92df4e35-804e-4b67-b2a3-fbb89ed1961f","event_cluster_id":"ff17e739-87dd-44ff-b5d0-44c22b4a7bb5"},{"claim_cluster_id":"a7436ce6-07d0-45e0-8628-2de252e4cb46","event_cluster_id":"beec5e0e-fafa-473c-9a37-0736cf0853e3"},{"claim_cluster_id":"8e782418-3f83-48d1-a7d0-6c3daf34ed25","event_cluster_id":"38e4e6a9-dd51-45eb-8aed-8f44b62fdfe6"},{"claim_cluster_id":"bfd3bb04-3c5a-410a-b26b-81f569186264","event_cluster_id":"75366cd6-61ed-4e55-93f0-d40cb0af777b"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"005d39b6-0b0e-4011-aaca-d596411fa607"},{"claim_cluster_id":"e11a5f48-4afa-40b5-8724-9f7420d483fe","event_cluster_id":"fca8c069-2da0-43e8-8cac-08662970bcda"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"af562818-5594-417a-b606-add10573c2db","event_cluster_id":"632ca25c-c259-4da1-adb8-67921865876c"},{"claim_cluster_id":"ac5cef85-9755-4d73-a0c9-3b2d779220c4","event_cluster_id":"abef27a8-3e24-43c9-9823-523dd607d49a"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"d140ee70-1c2e-44c9-b163-573b275b6b17"},{"claim_cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"5e7e70f4-b130-467a-9df9-f6078877ed61","event_cluster_id":"50450ae6-8d18-4a4d-9adf-9937e9748bba"},{"claim_cluster_id":"8ac7a573-0e67-4913-bd5a-4320d5df2ecd","event_cluster_id":"9d45e016-7740-4b71-ac88-57c1dbc80615"},{"claim_cluster_id":"afdf0794-a58d-44cd-b1d0-aec7b0adc12c","event_cluster_id":"2007b8f4-ae8f-43aa-a61a-6788fb1351fe"},{"claim_cluster_id":"04c0a28d-e066-4279-bfee-f4757f197d7a","event_cluster_id":"30b7b8ee-8417-4cde-bc24-2f6b158ce6a0"},{"claim_cluster_id":"18daf39a-f6c9-4439-8592-186d1ea3c4b4","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"9993ea09-c44e-4372-864a-21c7f72c7eef"},{"claim_cluster_id":"40d2bc92-0cd6-4002-bff9-64332ddd7635","event_cluster_id":"755be0e1-62e3-46db-9545-f7f494e88efd"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"41aaee2b-0ddb-4eee-87a5-d0d95635a46f"},{"claim_cluster_id":"2c61e4c1-c73f-4292-be06-e4f072faf26c","event_cluster_id":"dc7ff2aa-1921-42d9-9518-a57c8197d5cd"},{"claim_cluster_id":"5fec9a51-560a-4b1e-ab7c-cafcf47ba675","event_cluster_id":"6965d206-c7e5-406f-98ef-d70ab17200e5"},{"claim_cluster_id":"30f557eb-c83e-4cb4-b405-ec14f06f223d","event_cluster_id":"fb4930fb-4b1e-4086-912b-c760c3b7850c"},{"claim_cluster_id":"b0b4f902-9c94-4b57-b853-99cb04209992","event_cluster_id":"7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e"},{"claim_cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","event_cluster_id":"f0140bf6-12ff-43a0-8d3c-60ad6ec418af"},{"claim_cluster_id":"ab1e12a7-1d17-4758-97dc-5a8b5a8834bc","event_cluster_id":"771d6319-42e1-412d-8b6c-733124c3c173"},{"claim_cluster_id":"da3ee5ab-4748-4fea-9d14-3bdfe78a1c62","event_cluster_id":"a4f03b54-99da-409b-9d0f-4576a28453ea"},{"claim_cluster_id":"b0c0fbc8-3a87-4290-a45f-69e062e04cee","event_cluster_id":"adb05a60-b0e1-4623-b55a-6fea056e1f65"},{"claim_cluster_id":"06af9b74-e018-4919-8256-29acfecc76d7","event_cluster_id":"707d96d6-8c9c-44bd-a592-b72a5c0a0e76"},{"claim_cluster_id":"0119782a-5d22-485c-b58b-6c82b20e788c","event_cluster_id":"4550eb60-072c-4e27-8e64-8c04270738c8"},{"claim_cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","event_cluster_id":"3fb778a0-a02e-44fb-a706-5b4689fd37e9"},{"claim_cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"f65b5094-1e51-442e-b444-de0d25f1fea0","event_cluster_id":"7dbbaf50-ba32-48e6-b203-1b81e86a3004"},{"claim_cluster_id":"a5124b94-6b98-447d-9c53-5100339210c5","event_cluster_id":"5ad7a663-479d-4397-bbe4-c19607b95013"},{"claim_cluster_id":"1eb307cf-2274-463b-9ab8-19aee3397703","event_cluster_id":"02ef40eb-a1c1-4bb1-9831-77fc91e127be"},{"claim_cluster_id":"38c71e65-4039-4578-b30f-f1a4d6dd193f","event_cluster_id":"b43cd636-593a-444c-9022-279eedcd0450"},{"claim_cluster_id":"a75c6491-7fc4-4904-9a47-b176fcc90a36","event_cluster_id":"a70c5cd3-da81-4d6c-8001-3956de0c9692"},{"claim_cluster_id":"7b6f6e44-c4b3-44b4-af65-8b15cce351d4","event_cluster_id":"89a78cfb-c5b4-41b1-8a6d-eaa2669e99d8"},{"claim_cluster_id":"95b38f6d-19e7-4fa7-a9de-ee665de84018","event_cluster_id":"47eacbaf-94c8-4453-9ff4-4a4d77904c0c"},{"claim_cluster_id":"a1632082-229c-4e1d-b6b1-8334d7ed7db2","event_cluster_id":"5045a380-d054-4bd0-b13d-e42a8ff24888"},{"claim_cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","event_cluster_id":"c7968790-1b36-4325-9e94-aa1c52a513a9"},{"claim_cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"8fa6723f-9341-42e1-b24f-456c511e2eec","event_cluster_id":"8922c103-923c-4f13-93a5-f90c7607556f"},{"claim_cluster_id":"ed1ca8c0-7841-4109-ada2-99053838abfe","event_cluster_id":"3050de99-7b86-4c4e-a101-b10c8a674e17"},{"claim_cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"f83c19b1-e59e-4712-8a86-4c8c86ee0e2b","event_cluster_id":"f3c400dc-7cb4-4e82-a493-b5e485fbdb96"},{"claim_cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","event_cluster_id":"557fbe6b-8c80-48fe-945d-5c4d06e53e9a"},{"claim_cluster_id":"0728a108-719d-49e5-9d88-9c4bc35fe771","event_cluster_id":"15441f0b-d588-4f74-9e0c-951884dd5f0a"},{"claim_cluster_id":"31d339ae-2342-44f9-a909-e299d2c4eccd","event_cluster_id":"5f181f74-d991-4908-aaf7-6917a17dca75"},{"claim_cluster_id":"3b3a75fc-8d67-4d12-8788-a11705a7cca1","event_cluster_id":"0cacd6f0-a483-4fb9-8635-2cc0f4273b40"},{"claim_cluster_id":"94076701-ef33-45db-95b9-6fd0d66deba4","event_cluster_id":"31aa44e4-52ff-4a6d-a593-c7d1153c5dc2"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"e5a54fcb-cbc0-4fb7-bfbf-7530efd090da"},{"claim_cluster_id":"61d63dd9-934f-4808-b6ab-ed734f2474b3","event_cluster_id":"612db375-37db-450a-9941-cc2bdb1c5d4b"},{"claim_cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","event_cluster_id":"e13e1cb5-f52c-406f-a55a-701cb19f5226"},{"claim_cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","event_cluster_id":"1826eb0d-42e5-4b20-8a46-72b9e26a1dc6"},{"claim_cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","event_cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f"},{"claim_cluster_id":"10e97fc5-5fa6-457f-aefb-257e90e8124b","event_cluster_id":"5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb"},{"claim_cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","event_cluster_id":"04e520d6-ffc4-485d-b6f9-73b32b9e56e3"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"1c223a5c-b5aa-49ca-99af-333b89e0351d"},{"claim_cluster_id":"19ec7067-1e85-4e98-adf9-a107366a808b","event_cluster_id":"6cd72072-03f7-4b6f-a5d4-4465c298c295"},{"claim_cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","event_cluster_id":"ecaaad84-7e56-4f5a-84d0-609fbf620112"},{"claim_cluster_id":"655e754e-33e7-4bf2-aabe-264f18d499a4","event_cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337"},{"claim_cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"de4bbbfe-ba23-4e75-bdd5-72e767837661","event_cluster_id":"5fc56973-0e2c-4845-a192-e7e5c5265d9b"},{"claim_cluster_id":"ea3c1b05-c987-4377-9e48-b92ea47cc764","event_cluster_id":"2529c3a6-becd-4a5a-81a7-ccc8f9b32cae"},{"claim_cluster_id":"510b63b0-aea2-446d-8868-5c88431cc9fe","event_cluster_id":"991ffbe8-307f-44da-878c-ba99ad7d9638"},{"claim_cluster_id":"478db2a7-a90d-4fbf-8954-0416daa97dcb","event_cluster_id":"90bfcfdf-2a27-494a-a983-e0be2f5b4a32"},{"claim_cluster_id":"63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7","event_cluster_id":"eebab277-5cd3-4cfd-9fb6-1c0154222c56"},{"claim_cluster_id":"e1572e16-5f85-4ebb-a6fe-2ab18bee1c48","event_cluster_id":"a6896ca9-8851-4af3-bc86-04c953eef0ce"},{"claim_cluster_id":"3bebcbeb-75f9-4e80-89da-65943e0843a7","event_cluster_id":"82261ab3-3caf-4c24-ac0e-14c29ebf6f44"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5"},{"claim_cluster_id":"df17af70-aa4f-46d9-b191-eb3b4eeac1ef","event_cluster_id":"7c711c42-89fa-4d59-a561-9de6228e491d"},{"claim_cluster_id":"ac926db6-b36c-4519-9b56-13482c4acbd7","event_cluster_id":"d735477d-2ee7-4e51-9aba-37176b8e5505"},{"claim_cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","event_cluster_id":"91a2ed36-3e87-4baf-9999-c65078a62cbd"},{"claim_cluster_id":"eb82caa7-6ef5-4182-a16e-ed0091be45ae","event_cluster_id":"3092d2a7-23cc-41c3-b8bd-3096963a1b79"},{"claim_cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","event_cluster_id":"bfccbfa0-4d21-4c95-88ca-a83d95def684"},{"claim_cluster_id":"a3dda742-6a6a-4de7-ad48-8075110e3b35","event_cluster_id":"b0fdd1fd-fb84-40ca-af9a-591f59bfb795"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","event_cluster_id":"b454bfa6-3d84-4f22-a166-5f84ce0bf756"},{"claim_cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","event_cluster_id":"f4253f2e-cf0c-4fcc-9979-cb25e723158b"},{"claim_cluster_id":"10f0700e-3ce2-47c7-8783-a4d08ef48748","event_cluster_id":"673690cb-9b1b-4465-841b-31fb50a8d527"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"4703becb-493e-4c1f-aff3-21e217d2c90f"},{"claim_cluster_id":"cb25f623-bfdb-42c7-9873-fa48f80feade","event_cluster_id":"83ccf0a7-79d9-408a-a448-eb83f5e7d0d2"},{"claim_cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","event_cluster_id":"3d43abac-8178-4ce6-a910-10e135a5266f"},{"claim_cluster_id":"1809291b-a942-475c-989f-c974b3ec75b6","event_cluster_id":"fad57477-d03d-4801-aeb1-50224d171446"},{"claim_cluster_id":"62e8f214-855a-45b7-8de5-a667d22dd7f0","event_cluster_id":"8d52f35b-3806-4a30-b931-3dfcb56775fd"},{"claim_cluster_id":"cd4e973d-ac94-4c83-952d-356fab535a21","event_cluster_id":"25458cd1-1938-4e91-a3e1-aa6eb25c1608"},{"claim_cluster_id":"453d17a8-fa49-49dd-82fd-7c3661e026b6","event_cluster_id":"f2060e6b-7cd9-444e-9e39-3784e110a3b5"},{"claim_cluster_id":"a94e5bcb-b502-4cb7-a23d-3a1e29ce963a","event_cluster_id":"4c464446-66cf-4c9f-b4d9-3d5598eb4a8c"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"38841999-14cb-43f3-a2d5-27d9791973f6","event_cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07"},{"claim_cluster_id":"5272bbda-d47a-4619-a956-853dc9c29d18","event_cluster_id":"7dfc83e7-a64c-4018-a3c6-9d9e19ffc362"},{"claim_cluster_id":"86944fd0-c689-49c4-894c-bd247f4057bb","event_cluster_id":"65143df4-6c29-4538-b9c3-4cba1c56a8eb"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"},{"claim_cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","event_cluster_id":"15b25c11-ec21-460c-ad6a-670c9cb77249"},{"claim_cluster_id":"141b690c-587b-4b7b-9ad4-7b1b333f6cd8","event_cluster_id":"deecc1db-c201-4092-b4f0-f1a952dbcc16"},{"claim_cluster_id":"b9eca2e7-5401-453f-8490-81ec97719e08","event_cluster_id":"cc658fb1-6da2-4d31-8ee4-f6cd436408af"},{"claim_cluster_id":"a5124b94-6b98-447d-9c53-5100339210c5","event_cluster_id":"dfe9b2aa-c1a4-44e1-97cf-0e0d2107befb"},{"claim_cluster_id":"a03d3de9-e5ad-47e0-9374-17e6c1998859","event_cluster_id":"8be17819-9c73-4351-af94-f5573c4b0d17"},{"claim_cluster_id":"62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3","event_cluster_id":"61d385a5-d13c-453b-af42-53ad07fd1c25"},{"claim_cluster_id":"aa7a9a4f-e437-468a-8a0c-4d2441978380","event_cluster_id":"7bcdf864-ee5d-4016-9651-b86043d6e5f0"},{"claim_cluster_id":"6019fc4d-e3c3-4367-8970-ef89e2860014","event_cluster_id":"65b2891f-5d2c-4752-ad93-3b8790a22071"},{"claim_cluster_id":"da4e5cde-efc2-4363-87b4-b9935cc2b21d","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"a288cd72-4282-4ba7-b449-a353419578cd","event_cluster_id":"6ad9a81e-b42d-45d2-9083-3274cf3a2137"},{"claim_cluster_id":"09a468db-6b0d-4230-a370-cfd6ba61219e","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","event_cluster_id":"213e0c4f-0911-44fc-89bf-cf985adbc12e"},{"claim_cluster_id":"0179bab7-45d2-4b90-aa4d-c6afb970dbc5","event_cluster_id":"82ba7adb-7963-4264-baad-21315bacde1d"},{"claim_cluster_id":"b61ba5b2-e28d-4cea-b7a2-78bed070aeca","event_cluster_id":"8610e15b-1046-4caf-b039-527168f31d6b"},{"claim_cluster_id":"8d8dbda6-96b3-4738-b7a8-777f920a39be","event_cluster_id":"d1f35128-46aa-4b3e-8942-ed03c647bdc7"},{"claim_cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","event_cluster_id":"3909ddcb-f2e7-47b0-849d-f54906120921"},{"claim_cluster_id":"e836e40b-bdcd-4eeb-bbb2-df3b385c12c6","event_cluster_id":"905316e3-c2fa-42ca-821c-e5be344dac59"},{"claim_cluster_id":"c6c8d065-8cfe-4224-9bcc-58df52f1a712","event_cluster_id":"8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"},{"claim_cluster_id":"f4d9e677-79ed-4c5c-84a1-d127898975a0","event_cluster_id":"bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2"},{"claim_cluster_id":"1d4acd59-7bc7-421b-87d6-c6dcd6e61497","event_cluster_id":"e2805f19-13f7-489e-ba06-5921751ad393"},{"claim_cluster_id":"f65b5094-1e51-442e-b444-de0d25f1fea0","event_cluster_id":"ecc3ed38-6dd1-41d0-88a5-4aaeb65a608e"},{"claim_cluster_id":"affa89a3-9b82-426c-9616-b589325af10c","event_cluster_id":"c95c962f-c479-4151-9149-d13898c2a6b3"},{"claim_cluster_id":"4572f15a-5436-48cf-a1f9-d3e141616965","event_cluster_id":"e8809e83-36ee-4437-9f9a-9028a358d36b"},{"claim_cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","event_cluster_id":"388a333e-2008-4c61-8154-a9e224b365b3"},{"claim_cluster_id":"74ac8dc6-1d9b-435b-bae9-36745f271604","event_cluster_id":"5b21b1b3-5d6d-4813-8da8-9dbf1ce6934a"},{"claim_cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","event_cluster_id":"11d3cdd7-b203-4792-91e4-e32314bbcbc2"},{"claim_cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","event_cluster_id":"d73adbe1-7dcc-4345-a67c-e7d102fbc24d"},{"claim_cluster_id":"ab9886f5-759f-416b-88de-b9f771cf04e1","event_cluster_id":"3efed4d3-9a2c-4fa8-bf3a-fb69d88128e8"},{"claim_cluster_id":"d622247c-7345-4e31-99b0-dfafa4dc550f","event_cluster_id":"b4df60de-0b59-4910-b93a-2f4eaa711964"},{"claim_cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","event_cluster_id":"0ebcd390-0474-4d90-81dc-d03c9dac78e4"},{"claim_cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","event_cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242"},{"claim_cluster_id":"8c2b4e21-c9ea-4127-9440-e983688f714d","event_cluster_id":"6c48832c-2b96-4ee8-9b48-4611e67b38f0"},{"claim_cluster_id":"e6bef1f7-9387-45ab-918c-0df479862034","event_cluster_id":"3a18182f-409d-4665-970b-231ce6a7c108"},{"claim_cluster_id":"d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5","event_cluster_id":"715be432-cabb-4dfb-94ca-fb3947c60120"},{"claim_cluster_id":"38841999-14cb-43f3-a2d5-27d9791973f6","event_cluster_id":"a9a48f40-5af3-4e72-b9f7-5b25295964a4"},{"claim_cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","event_cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"109daecb-5285-41a5-9427-7fd6ab199a14"},{"claim_cluster_id":"d88ab7ef-052f-4839-b4dc-054794d4d289","event_cluster_id":"5c607d5b-9632-4ec1-9939-05955e158cfd"},{"claim_cluster_id":"1809291b-a942-475c-989f-c974b3ec75b6","event_cluster_id":"ce085679-ae85-409d-b3f3-afb9e8562a5b"},{"claim_cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","event_cluster_id":"781b12f4-b179-4668-8b0e-ea2f1da17240"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"b835c70a-6e2a-4461-9396-aa47cc9d876c","event_cluster_id":"fca5231f-5992-4d7b-ae79-0b5b3aa11fb8"},{"claim_cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","event_cluster_id":"2c6352c1-d120-47aa-8825-a58359bc7c7c"},{"claim_cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","event_cluster_id":"781b12f4-b179-4668-8b0e-ea2f1da17240"},{"claim_cluster_id":"ff47f0b3-49ae-48d8-b9cf-5707589bed0f","event_cluster_id":"a0aa3975-d232-4eed-a961-eca71bc27015"},{"claim_cluster_id":"4370b159-681b-41a0-8da8-22c407b09da9","event_cluster_id":"1310ff3c-798d-4934-989d-8b8e4e0530a4"},{"claim_cluster_id":"3afb5a7e-c2f9-4fc4-a379-b0fb650f805a","event_cluster_id":"077c9500-5508-46b9-9207-39c50c9150fb"},{"claim_cluster_id":"62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3","event_cluster_id":"ed17271a-9f56-4fda-b3f2-e8dbe7b55084"},{"claim_cluster_id":"96b44dc8-1893-429c-83b5-6d58cef5fa9d","event_cluster_id":"4eaf7a96-0e00-419f-b612-d0f41e00fc2d"},{"claim_cluster_id":"fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b","event_cluster_id":"69cf6d84-6886-4dc2-b36b-3239cc3450b1"},{"claim_cluster_id":"5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7","event_cluster_id":"4d4b5f03-b89d-479d-93c3-2c3c9a038d46"},{"claim_cluster_id":"34e53235-60e8-4299-9389-633db39ab300","event_cluster_id":"ce9cb999-3c9f-480e-9d89-8702d1c44875"},{"claim_cluster_id":"b1827766-8909-4c0a-8a55-23a0b5e81d4e","event_cluster_id":"654fa001-54fb-4d51-b87a-8207c38aeb88"},{"claim_cluster_id":"95690f3e-4515-4810-858c-28b7d1da49a5","event_cluster_id":"2b8e0512-59eb-40b2-a0fe-0c0765fe2a41"},{"claim_cluster_id":"17c8775c-7a3a-4607-aa7f-5b24078a17f8","event_cluster_id":"f996f072-3b37-4e7f-900c-1cc05e40fa72"},{"claim_cluster_id":"b65de138-2e69-44b3-acdb-00d152bc8245","event_cluster_id":"cc8b239f-30da-4a67-b3e7-b923954bf5fc"},{"claim_cluster_id":"509e1b1d-c464-406d-8d4e-6ab2f46f2324","event_cluster_id":"7bd17062-e906-485a-b7b6-75d95fcf30ef"},{"claim_cluster_id":"a3891be3-55f1-4794-b99d-304a26e4b465","event_cluster_id":"91533351-01ef-434b-b8d2-ca94698271b1"},{"claim_cluster_id":"aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868","event_cluster_id":"1782182b-9c5f-4a6f-b547-bd10fc2d3b84"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"729cc7ae-ca2f-4e76-9131-41ad0335ecdf"},{"claim_cluster_id":"947a0b8b-01e0-44c9-8ebc-c9da3eecde20","event_cluster_id":"bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2"},{"claim_cluster_id":"6826010f-2a38-48a2-a358-b062edaa9ed4","event_cluster_id":"4edafa37-461a-4e41-b730-dd41cc60940c"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"9d847e57-5fc5-4cc4-8919-603e5c8d93d2"},{"claim_cluster_id":"5dac5b6d-e9df-41db-9225-7e413ca3cacb","event_cluster_id":"7e70d266-a12a-4562-93b6-0506f079359f"},{"claim_cluster_id":"1d8a91a4-e2e3-49c2-838b-462dda682ab0","event_cluster_id":"88f7cf16-b8a2-4b9c-98ee-aad660820b7c"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"0e36f836-fa5b-40df-8bd7-860b08ef47db"},{"claim_cluster_id":"f621aef8-63b8-4a2e-8e04-ca8b7ec1b346","event_cluster_id":"31016415-1e0c-4bc5-8f2a-e27a8e5ff775"},{"claim_cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","event_cluster_id":"e01a8825-f8eb-425d-b928-eda6b3f57929"},{"claim_cluster_id":"98bac582-09cd-476d-9519-fe434dffcb9a","event_cluster_id":"d6164d22-4f2e-407f-abd5-0ff84a88c4a3"},{"claim_cluster_id":"0b87672f-54fc-4c20-8d98-e54ab45bc52d","event_cluster_id":"5bb4fd2c-606b-4f16-9ca5-b9abb9dd5181"},{"claim_cluster_id":"868aacb9-ea8e-4ec3-a074-1e7f56bab03f","event_cluster_id":"82ba7adb-7963-4264-baad-21315bacde1d"},{"claim_cluster_id":"1e8d5556-2c0c-4097-b606-9907a5dd2afc","event_cluster_id":"f239b4c3-e0cf-4725-9d59-2b1e32a9ad39"},{"claim_cluster_id":"f9ff85c1-1de5-47fa-b9f9-f7450f5b0b3d","event_cluster_id":"087b9c92-fa35-4283-96fb-8d9c5297eb2d"},{"claim_cluster_id":"57eb29a4-6d1b-4f98-a507-b97e4235688c","event_cluster_id":"89863001-f3cc-4b83-a5ba-601a96690a75"},{"claim_cluster_id":"77ce5be7-73f4-4876-9446-d5aec1b02a1c","event_cluster_id":"499c9d29-7269-44cb-a1ca-192dc37f8892"},{"claim_cluster_id":"388f4cb2-36f0-4395-889f-3dc07bb54aff","event_cluster_id":"2cf37935-88f0-4aab-94bf-6c7a6da78e48"},{"claim_cluster_id":"24d4d508-a837-441b-b87c-de6ead3d7582","event_cluster_id":"94b72832-2531-4bc1-ae04-872ab9df9981"},{"claim_cluster_id":"2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187","event_cluster_id":"1a1ebb66-c1bd-4b57-a87b-865e10a35768"},{"claim_cluster_id":"58a60e5c-9e5a-48ce-a07c-a7168b46ba2f","event_cluster_id":"745dc0ba-2e08-4d11-9168-0c12ad0b99a5"},{"claim_cluster_id":"ccf91c48-303e-4d94-8263-0e8c6de64e17","event_cluster_id":"8b829799-1488-4866-83fa-531278dceac5"},{"claim_cluster_id":"b3b1fd7c-7ffb-411d-b821-50b6108ebae7","event_cluster_id":"4dd4cfc3-9e42-4844-9174-8c971ece9bc4"},{"claim_cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"b7e4eaa1-1521-4096-9aa4-af78b70dfeb5","event_cluster_id":"3ea76b8e-7bc3-4056-b872-c2ebb28f696a"},{"claim_cluster_id":"9ade6dc5-62e9-44b7-84fc-ef5e0c8fe1bd","event_cluster_id":"a18cfe43-57c6-4582-9892-e05c06ecdee6"},{"claim_cluster_id":"b54e5664-a40b-4682-b959-bcfb59ddd4b0","event_cluster_id":"2006ffe8-e5ea-49eb-8208-12ce96b310e4"},{"claim_cluster_id":"1746dc9d-7bd5-45f4-a86e-d7bc4c937633","event_cluster_id":"0d8c9f9c-0b32-4507-8989-0e2529da4ed4"},{"claim_cluster_id":"0605c233-63ed-4bdf-a0fe-665556a34a75","event_cluster_id":"a25c3ac7-1dad-4c90-b412-99d2bc775053"},{"claim_cluster_id":"5a861756-5d94-444c-84a0-fab63d482e8c","event_cluster_id":"bb4b93c0-732a-485f-b2ae-0ba6433c139f"},{"claim_cluster_id":"7a1e52a1-bd32-491f-a249-5ec36a49aa78","event_cluster_id":"a8cc6e44-ab60-4366-aa46-06f9a46a5810"},{"claim_cluster_id":"a162a552-43bd-43b6-925a-ac7f9fbf4734","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"6302b733-5c75-40a5-a618-05d435c65be2","event_cluster_id":"35d3e890-e939-41bb-b28b-3ee99ba1783a"},{"claim_cluster_id":"b36a42d8-1bb3-483d-b77f-bd28630b0e30","event_cluster_id":"e113cbe4-9797-46e8-ab87-8e31da3f22de"},{"claim_cluster_id":"10bf083b-35c8-4b77-a2d9-e4cb3813d9fb","event_cluster_id":"7893a531-ebf0-48fb-8b91-b2f1e4865517"},{"claim_cluster_id":"15f89230-b855-41bc-bc6f-7a68ea38aff0","event_cluster_id":"0af6351b-04c5-4f0a-8360-02d15acb3d1c"},{"claim_cluster_id":"02c9b472-905f-4c41-8570-811b8d821196","event_cluster_id":"1af06082-428a-4dc1-a3c0-4aa29b512806"},{"claim_cluster_id":"6d37cc6e-940b-4af5-bb44-d183921f0d01","event_cluster_id":"0f38c468-09df-4db1-af76-875811609b3a"},{"claim_cluster_id":"194a083f-fee7-4bf0-b198-fa40c8bdfe21","event_cluster_id":"2cca833d-ae9d-45ac-9501-885a938605a6"},{"claim_cluster_id":"3c1f9759-2361-48c2-bc4a-c58a3d11b76f","event_cluster_id":"70ea1622-08ba-432f-a3ce-0079b309daee"},{"claim_cluster_id":"8db03bdc-0c69-45b1-8ccb-309f57132adb","event_cluster_id":"da1ad06e-43a1-466f-9487-046d8d125726"},{"claim_cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","event_cluster_id":"e81e68ae-4e8a-4aef-a358-1455ad08bdc4"},{"claim_cluster_id":"8165992e-6782-4b62-b794-6309bbfbaf5c","event_cluster_id":"174ff9ad-6286-41da-ad67-0696f7875e1b"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"c368702b-96c0-4866-81f4-7cb0750c1bcd"},{"claim_cluster_id":"6fa7c53c-2f06-41c6-acf2-531da6482f4e","event_cluster_id":"e9b17550-2314-4f27-8f49-a28182e8193b"},{"claim_cluster_id":"0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879","event_cluster_id":"2c68a882-a903-4629-aeb4-3d0034f94771"},{"claim_cluster_id":"a24c9e44-7dfe-4825-ab38-82d2ff8a84cc","event_cluster_id":"70d7ea19-ed43-41ec-a695-147f9057dd3c"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"2bdcdf0c-04af-47ca-abf1-8573ce94795d"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"5fc56973-0e2c-4845-a192-e7e5c5265d9b"},{"claim_cluster_id":"30f557eb-c83e-4cb4-b405-ec14f06f223d","event_cluster_id":"270b9be6-37c3-4ab7-9763-57943d7a38b9"},{"claim_cluster_id":"62ff82d6-7a81-4618-a5c7-dad49908ecf4","event_cluster_id":"7bd17062-e906-485a-b7b6-75d95fcf30ef"},{"claim_cluster_id":"5a33a893-0ae3-4e2b-9f4c-02de9772f96c","event_cluster_id":"252647f3-b2d0-4fb9-8a73-8d20e5a61e96"},{"claim_cluster_id":"5bc0db5b-3192-42d4-a343-00cfcacc4499","event_cluster_id":"51cbaa1d-e1b7-494b-ab8c-dca8a0d96a68"},{"claim_cluster_id":"881a8788-562f-4bf2-a8b1-590419007a87","event_cluster_id":"67eaacee-8b2a-42e6-980c-72585c0bb525"},{"claim_cluster_id":"a9b66749-8bb9-4643-bb36-488cbf77974b","event_cluster_id":"6985cd83-55db-4a59-b823-aed3b2386ee8"},{"claim_cluster_id":"9571d5a8-94c8-43e8-bdfc-93e045f2bdd4","event_cluster_id":"d8cf9191-20ce-4f00-be96-f15ca59147ae"},{"claim_cluster_id":"4c8ca22f-065e-4c2a-bc2a-950d315204b8","event_cluster_id":"2e75fb89-d4ec-437b-bb34-741837209437"},{"claim_cluster_id":"86d26636-5c9c-416b-94e0-e2a89a9628c3","event_cluster_id":"aee60c89-f292-46d6-9573-19871764aa64"},{"claim_cluster_id":"3aa4fde2-05d2-4c91-b69f-d61ecc64ca82","event_cluster_id":"17c72ecc-bde7-4838-bd7c-6c235f6a23e1"},{"claim_cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","event_cluster_id":"2bd1f4b8-00be-4a69-ba1f-d23c0361c606"},{"claim_cluster_id":"428a1c85-5fee-4a1d-bbe0-9e71872e75e9","event_cluster_id":"70408cf7-1954-491d-98bc-f78c50c03508"},{"claim_cluster_id":"d42f0707-162e-449e-86fe-0dd5e2885a21","event_cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"},{"claim_cluster_id":"d4c6919b-eb92-4688-a3f3-bcffc0362115","event_cluster_id":"1dcb2d84-ef9e-498b-a03a-7740ad5e2f55"},{"claim_cluster_id":"a3657e1e-0716-4d64-9a9e-572ba20604c2","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"3c4e2f0e-5b8e-45e9-84a7-c71071caeba0","event_cluster_id":"0d24f0d8-e472-465e-a47b-526385fc7554"},{"claim_cluster_id":"fff4a6ed-31c6-43f6-93ef-bd50b7133298","event_cluster_id":"4d8ae235-419c-4dbe-90f4-1201d0ccbf9d"},{"claim_cluster_id":"2adce5ae-1669-4c77-b898-ed9abf7276da","event_cluster_id":"3a1850b4-8745-4145-98c4-7563773130a2"},{"claim_cluster_id":"07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a","event_cluster_id":"0a3f5bd0-94f4-48e7-84b4-d317e0edec75"},{"claim_cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","event_cluster_id":"213244f7-7bbf-4ff3-935f-65e545a0abda"},{"claim_cluster_id":"32a2eefa-c8c7-482c-839f-be3b15138d40","event_cluster_id":"3a29dca6-ced7-43ed-9cff-367044251da1"},{"claim_cluster_id":"23dcfd5c-77ee-4590-92a1-d00d1da215c4","event_cluster_id":"cecf5ab1-6a32-4285-b19c-a1e9eb89d592"},{"claim_cluster_id":"98f59c42-164f-4444-8ecb-92a7e7c88a99","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"856ae956-c845-42c3-8716-9e150f646a11","event_cluster_id":"9427cf91-1580-41ef-aaf0-2efa82b46d41"},{"claim_cluster_id":"820cd21b-12a7-4c4e-a98c-55a81599d692","event_cluster_id":"dfc393f7-ef26-4ee1-ba36-c3a68f72795f"},{"claim_cluster_id":"574866ae-31fe-4cc6-8d31-fe21c9fdd682","event_cluster_id":"a8cf67a0-14e4-4562-b59f-46b2a6b2b98a"},{"claim_cluster_id":"574866ae-31fe-4cc6-8d31-fe21c9fdd682","event_cluster_id":"fd964b79-d3b5-4267-ab70-39cd4b799f57"},{"claim_cluster_id":"8c61663d-a5f4-43e3-9ca6-42de906f614c","event_cluster_id":"8254f8c1-33e3-4176-8b1d-232b3b4367f4"},{"claim_cluster_id":"1fc4c0cc-9a41-4ae8-9970-3b340b704e77","event_cluster_id":"e5eb9c21-045d-4a8f-b07b-6af55af6d48c"},{"claim_cluster_id":"5d21e7b3-dd0e-453e-8871-eb57102f00e7","event_cluster_id":"5a3236fa-e7d1-4fa1-bcc8-0cc89c18d852"},{"claim_cluster_id":"461bd859-868b-47e1-abbb-db550a7eb628","event_cluster_id":"8363a6a5-6462-4ebe-b358-821cefa34494"},{"claim_cluster_id":"e8b8352a-472f-4b00-9dae-87cd809f920e","event_cluster_id":"35a90496-100d-4386-a3d0-578c543e7dd4"},{"claim_cluster_id":"565749fa-0214-435c-be6b-1a2ffed6aba1","event_cluster_id":"a04779f3-83fb-4f0a-a9f8-fc91c7dd0fc4"},{"claim_cluster_id":"d755be56-db7e-4317-8d05-387807a1a892","event_cluster_id":"4a8a1810-6ec2-40d6-8159-dfec11d084c9"},{"claim_cluster_id":"d0f7b20c-2bcb-454b-bc64-6c984732d241","event_cluster_id":"468199d3-d972-44c7-826d-cc58f22c25eb"},{"claim_cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","event_cluster_id":"77fd60bb-096a-4b70-a630-b56ef3e8f647"},{"claim_cluster_id":"5d30cac5-2629-4bf5-9665-20ae87c1ec22","event_cluster_id":"8d9c34af-fae3-4e38-87d1-1e67774753aa"},{"claim_cluster_id":"6a0b2cf5-23aa-458f-9dc9-7fde872ec6fc","event_cluster_id":"7cb43f88-bfec-484a-965c-af899d9b8682"},{"claim_cluster_id":"bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a","event_cluster_id":"89b14a97-e8c8-4e40-b25a-0dd26956ea7b"},{"claim_cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","event_cluster_id":"2f282f8f-f24b-4f4b-aa36-e5da41c21657"},{"claim_cluster_id":"8e9b5986-8277-45da-82c2-ab199cd3287f","event_cluster_id":"9add2c84-55b8-4f75-bec3-d9a47e379ce8"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"8c441ed7-3996-46c2-abdc-191f54206cf6"},{"claim_cluster_id":"838b4697-b296-48c1-b248-3458bd1a5a35","event_cluster_id":"30f5c3ba-9f54-4691-8863-1e644c87fbf8"},{"claim_cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","event_cluster_id":"6e3b5d0b-67db-4d14-8384-2b3799aec6bd"},{"claim_cluster_id":"369b1cc5-aae5-4361-aabf-b1ef5c5350f8","event_cluster_id":"7180dea2-3c60-4f47-892a-7e623057b51b"},{"claim_cluster_id":"41a156b3-5c3d-4d82-b8e4-7ad88953f690","event_cluster_id":"662ce9d8-6ef2-47db-949f-92c2e48c1777"},{"claim_cluster_id":"a288cd72-4282-4ba7-b449-a353419578cd","event_cluster_id":"0e8414db-df98-41e4-b595-a6e3b96bc6df"},{"claim_cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","event_cluster_id":"8bade7cf-2f71-4a8c-ac8b-47b2764dd430"},{"claim_cluster_id":"41dd785c-3146-4243-8bbd-56211fadb273","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","event_cluster_id":"66bbc9b1-3580-4b34-9ccc-f5983ea5120d"},{"claim_cluster_id":"af3aa521-118c-415e-b54b-524628af7168","event_cluster_id":"147ac41a-7de3-4c4a-9213-48dfc49549a9"},{"claim_cluster_id":"3505030f-425f-4631-b164-fc25bf6fbe55","event_cluster_id":"ab906a52-8ac1-4094-852d-28e22d75048c"},{"claim_cluster_id":"30011e47-1ff9-409e-8099-2eff6ab89e88","event_cluster_id":"dba5927e-43c7-4d0e-9ca1-e78a9cdb024a"},{"claim_cluster_id":"059205f2-0c13-465b-ba40-83a1ffcbcaa3","event_cluster_id":"55dcf158-5a10-408c-b74c-c53a42b859a3"},{"claim_cluster_id":"838b4697-b296-48c1-b248-3458bd1a5a35","event_cluster_id":"5de51773-6a23-4bab-8c30-a41d42c69aaf"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"d30fd077-478d-4784-a1a9-ce89125fa303"},{"claim_cluster_id":"3be4473d-cbba-49ee-93e6-36d5bcd0dc0a","event_cluster_id":"6c709b7a-7374-4394-a975-41a7ad1dae38"},{"claim_cluster_id":"43beda49-4348-4ff0-94eb-8102078e161d","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"02063354-1cf2-4e4e-a749-ce91914994ae"},{"claim_cluster_id":"f58ca21a-7af7-4062-9509-f6480d8a6390","event_cluster_id":"bac748cb-b035-4e91-bb5a-ab935807284d"},{"claim_cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","event_cluster_id":"0978a576-627e-40f6-a382-f39885473545"},{"claim_cluster_id":"2a265a62-6ee2-460d-b6fd-ab72b8f23578","event_cluster_id":"41ecf095-1caf-4be8-93aa-128fb386e8aa"},{"claim_cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","event_cluster_id":"bcc8a49a-201a-439b-bf04-a72b13e50b57"},{"claim_cluster_id":"dac4f0e5-e31b-44cc-a055-3ac65eec9d11","event_cluster_id":"b49995a8-19fd-4ac2-ad8e-2c1b565ef509"},{"claim_cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","event_cluster_id":"2a893b9d-8c8b-4435-a26b-4a75f061537a"},{"claim_cluster_id":"ef502c1a-5f03-41b4-be90-14e6e1785625","event_cluster_id":"517bce1b-0646-49a8-83b6-634d844a1495"},{"claim_cluster_id":"3b17ca99-a0cf-4b4c-a71f-c0181125d3ce","event_cluster_id":"0ae66dca-634f-424b-80e9-5fc4b2615b98"},{"claim_cluster_id":"ee431334-0b63-4389-8c3c-60633233fd26","event_cluster_id":"a75f7771-ca28-43b6-99aa-f4f9b0398268"},{"claim_cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","event_cluster_id":"c6262c2d-c819-43cf-9414-2109754b60a0"},{"claim_cluster_id":"b61ba5b2-e28d-4cea-b7a2-78bed070aeca","event_cluster_id":"b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"},{"claim_cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","event_cluster_id":"23f70c38-36fb-46d7-8b29-eb7e9349960a"},{"claim_cluster_id":"346f630a-2d46-4e8a-80ef-67a96ebf81ef","event_cluster_id":"c5a49990-0bec-49b9-8797-00d71805007a"},{"claim_cluster_id":"6b512fcc-e6a2-414b-8a86-90a11b76795a","event_cluster_id":"095f5894-d729-421f-8a47-470e675d8afa"},{"claim_cluster_id":"20b239ec-b263-4052-a330-5aad8ed1209b","event_cluster_id":"c4e46a56-8890-41d4-ba88-174baf1248f9"},{"claim_cluster_id":"3d9bd6b9-ad1e-4d65-b911-715849482ace","event_cluster_id":"f6d37781-75af-4b37-a9b4-49dbc27efba1"},{"claim_cluster_id":"30fdf9bb-e9b5-47e5-a899-e176ffa77eac","event_cluster_id":"00d660d9-94af-474c-8e79-c16ac62cbef7"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"4dd58e9c-790c-4f52-9fba-7f267f15da6d"},{"claim_cluster_id":"673d8d19-d059-4065-9b0d-82b1376c6c55","event_cluster_id":"97cdd3f9-b13e-4b85-9e62-c48c3b34bca9"},{"claim_cluster_id":"b1951710-a9b4-42e8-b9e1-6ca4e5f12a31","event_cluster_id":"a47f9935-dbc9-43e1-b673-236035daf9b2"},{"claim_cluster_id":"7a8e190a-4532-4e4a-b5bb-60a049f869c1","event_cluster_id":"943f941b-168f-4ff6-86c1-d9d6b4c6fa28"},{"claim_cluster_id":"eb82caa7-6ef5-4182-a16e-ed0091be45ae","event_cluster_id":"0d16b859-0b48-4545-ad3d-19b0d4601fe2"},{"claim_cluster_id":"017c8345-ee2f-4b6f-8701-6def5bbd5082","event_cluster_id":"c98e55d1-dacb-46cd-b78b-7ec41169fc51"},{"claim_cluster_id":"21361eee-5fe8-48f0-a512-8a8c4752daae","event_cluster_id":"ed8ee9d8-3361-4c66-86fb-3b0c6210300d"},{"claim_cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","event_cluster_id":"d2f70202-2b46-45a9-9905-a0ccfee90661"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"30fdf9bb-e9b5-47e5-a899-e176ffa77eac","event_cluster_id":"1da8672c-062d-456c-b508-fef471a32245"},{"claim_cluster_id":"6c53a575-96c0-4b04-a196-adb1bbc90de7","event_cluster_id":"b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"},{"claim_cluster_id":"c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"75ec5d34-37c4-464a-bbb5-d624ce06eeb5"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"89cee3a2-4f95-4473-859f-f9c42c415bf7"},{"claim_cluster_id":"e9caf6d9-2282-4c7e-9cd5-97529119edff","event_cluster_id":"11ad6c89-9a64-4385-9a81-dfa3787cc401"},{"claim_cluster_id":"bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","event_cluster_id":"a1084837-f12e-45c4-9bfb-1677ce1c51ad"},{"claim_cluster_id":"b5600099-12c0-41c7-bfb6-4b6bb66dc0dd","event_cluster_id":"d33cb6f1-20b6-4555-be5a-7f0455de9471"},{"claim_cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","event_cluster_id":"c0d885cd-8830-4032-af1c-4955d65db09a"},{"claim_cluster_id":"70534501-50ea-4dc4-9324-20539116bcb4","event_cluster_id":"75c3bddb-8c4a-4274-ab4c-3cc28aeb2126"},{"claim_cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","event_cluster_id":"59a2b2e2-fda5-435b-a046-bc1854ba1410"},{"claim_cluster_id":"8499f04a-3cd9-4588-b8dd-3abc1c538bcf","event_cluster_id":"7e9c2165-775e-4ecd-9551-bc96f366f674"},{"claim_cluster_id":"268e1143-4495-4247-af6b-b6f6f368f74f","event_cluster_id":"ec4ecacf-5ed7-4202-a803-a46089704d53"},{"claim_cluster_id":"9f4b1362-f866-4431-983b-c739ed7f376e","event_cluster_id":"6f086810-1930-4192-ad91-ce3f0eefd1aa"},{"claim_cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"02c78b1c-dd55-4ba6-a345-d21fd27d3214","event_cluster_id":"ac2593ad-b73a-4ed3-b199-eed400affdc8"},{"claim_cluster_id":"6d2fdf64-8424-4971-a998-3fe674aff124","event_cluster_id":"028ee870-e258-43cd-99d3-f13e457b70d7"},{"claim_cluster_id":"8140cb8c-a254-4493-b790-598f4ef3676f","event_cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a"},{"claim_cluster_id":"69517d67-11aa-4671-bb8a-815c7995a3b7","event_cluster_id":"0abb1373-3acc-4d19-880c-819af07a267f"},{"claim_cluster_id":"2bc0b07d-c668-4651-b1c3-1844786b5acb","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"9562ace0-b924-497a-a3ab-5d483c835c5a","event_cluster_id":"1f91813e-722c-47f3-81f9-6d98fd8c6b7d"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"1118439e-1d54-4e33-bac7-0813c7dbb103"},{"claim_cluster_id":"6926f592-0807-43c3-9eb1-74f903b009ff","event_cluster_id":"05b6ff5d-2ddf-4b71-b6f6-98defb612c16"},{"claim_cluster_id":"3444a924-096b-4eda-877c-4c6412d885cd","event_cluster_id":"692b8f3b-7c78-4cbb-b4e5-764b2d4124bb"},{"claim_cluster_id":"2790abdc-e882-4d8a-90ac-fbfc5b896052","event_cluster_id":"fd3d778c-3ff6-495b-bf3c-b5711ab1a974"},{"claim_cluster_id":"40860ef8-1ebc-45f7-84a0-735bcdaf070c","event_cluster_id":"4d8a4d68-4905-4d57-b3f8-91de6feb19b0"},{"claim_cluster_id":"c7bb1d74-7395-4554-a7ef-ec1f5c743579","event_cluster_id":"903140f6-5deb-4b0a-b645-3ff3ded85a2c"},{"claim_cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","event_cluster_id":"b5d6d05a-3d31-4ce5-aa84-cf94365c8485"},{"claim_cluster_id":"d5458c27-5843-4ff6-b105-7703aeb6f588","event_cluster_id":"8b0583af-b0d6-4ff0-b992-807e026b5368"},{"claim_cluster_id":"dc8d69ed-9d9d-4c04-a104-2c89e796edf3","event_cluster_id":"923c46a3-c0b6-4907-a189-66afd503c6b7"},{"claim_cluster_id":"253e2fef-8100-4235-899c-96e9877535d1","event_cluster_id":"05f00def-a8b8-4cdc-94a6-9ead4bc629d3"},{"claim_cluster_id":"74f7c7d8-aba9-45e9-a386-fbb258dd884d","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"e1ed1afc-85b6-4c69-a063-e486d1e3670f","event_cluster_id":"2311e718-cd29-45c2-b4e7-6c01097b3aea"},{"claim_cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","event_cluster_id":"f5af21c1-57be-4378-ab8c-5400cfed6bff"},{"claim_cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","event_cluster_id":"5e0be9c9-87ac-49bb-a807-6e19f719434d"},{"claim_cluster_id":"09060ad9-5546-4c31-ae6b-321cd8a78d5b","event_cluster_id":"9a0e60e0-9d22-43df-bc7c-6bb5028125f2"},{"claim_cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","event_cluster_id":"997b033a-0811-49fe-bc36-8ee742156833"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"bf711cc9-463c-4a50-a300-d24703735ee6"},{"claim_cluster_id":"70b45d78-dfac-4810-b7f6-abeea55c435f","event_cluster_id":"5c1805d7-899d-486a-b79f-793a9703c022"},{"claim_cluster_id":"51207b82-ee2c-47cd-adf4-cdd41f93d43d","event_cluster_id":"4c5edc98-f936-4e09-a25f-11ad3a0a3ce0"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"3b793f1b-9892-4efb-9252-e394792997b5","event_cluster_id":"71a8fcbe-7e01-4380-bb3a-befa2ea629f1"},{"claim_cluster_id":"945e1233-33d5-4259-ad28-2899aa78e0e9","event_cluster_id":"c368702b-96c0-4866-81f4-7cb0750c1bcd"},{"claim_cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","event_cluster_id":"af90686d-77e8-4713-873e-8c63e5dbe370"},{"claim_cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","event_cluster_id":"8d63a231-4f96-4fb0-aa81-938182c806dd"},{"claim_cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"185ce1be-2776-4956-849c-f83438c57def","event_cluster_id":"546a15bc-833d-4e92-8945-cbee19b7d4ca"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"67c32fef-bbe8-4245-9a91-7d8aee491367","event_cluster_id":"ebb2f2f8-c476-4b98-bd7c-c0a3ef8345f6"},{"claim_cluster_id":"da4e5cde-efc2-4363-87b4-b9935cc2b21d","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"b97c97e0-114f-4fea-812a-38dca08108e6"},{"claim_cluster_id":"131fc120-2488-4970-ac79-410004aa6030","event_cluster_id":"ec9bc095-279f-474f-9706-4d758de892be"},{"claim_cluster_id":"a8177a52-bb93-4070-be93-33bdb7e54f7f","event_cluster_id":"5bae13a5-6b81-425d-a9bb-49850203205e"},{"claim_cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","event_cluster_id":"9f713e34-d77c-4dee-b4cc-dc4204b450f3"},{"claim_cluster_id":"8ac816b2-de5c-4294-a968-e6279613b1d8","event_cluster_id":"dd63046f-83c4-4d5e-867a-2f14376d2ce2"},{"claim_cluster_id":"729e67ef-32fc-4882-8297-9f443b6f2589","event_cluster_id":"89133653-febf-4b4b-840d-0cb05ed61f86"},{"claim_cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","event_cluster_id":"0c8a0c77-de1d-4094-93a5-9ea4a0ec06b4"},{"claim_cluster_id":"b8299ae1-9e2e-465d-af82-b9354f3e9c44","event_cluster_id":"3a1c15cf-9c77-4bd8-9e70-266829c039f2"},{"claim_cluster_id":"d8515ae8-12a5-4f84-b01f-bc10b41b19e0","event_cluster_id":"83bfa8ce-e39f-4c0f-b6f0-a55302bf1e3d"},{"claim_cluster_id":"8bc3dd02-5989-4bb6-8266-c27296d666f8","event_cluster_id":"b2e518c2-bee5-4258-9f37-d52e83d13a76"},{"claim_cluster_id":"aa7a9a4f-e437-468a-8a0c-4d2441978380","event_cluster_id":"6310600c-941f-4d69-826e-9f6645778d3e"},{"claim_cluster_id":"30ae8997-b16b-4477-bfec-33c1a345955b","event_cluster_id":"34cd8ac5-1cee-4a93-bb46-48f954524f09"},{"claim_cluster_id":"14b46c0a-7b16-4722-b599-90d7d69970a1","event_cluster_id":"4941b2f5-904f-4963-b690-18f3bf3075c7"},{"claim_cluster_id":"a536505f-e31a-400e-a4a5-1f74a9e29e7d","event_cluster_id":"64ce313a-9f62-48b5-ac72-4f4f23b43da9"},{"claim_cluster_id":"58a7d973-9fa3-4047-a219-579a31c4561b","event_cluster_id":"b5f5c5e5-6c1a-4551-a786-04806a60e9b1"},{"claim_cluster_id":"9a34d174-5513-4924-bed6-11de3ec56881","event_cluster_id":"c97fb561-3217-4665-93fe-191384f9c143"},{"claim_cluster_id":"2669ad24-9832-49ab-a24d-8ef6f0986ed6","event_cluster_id":"5535ff65-262d-4c0d-a8e9-0c0a87d3ccdf"},{"claim_cluster_id":"a9096ed8-3c07-4fd9-a21c-9fdb59fe1353","event_cluster_id":"4bc67839-1a76-467a-8232-39c9eb846df7"},{"claim_cluster_id":"8b2d10cc-94ea-4d53-a196-ecebccd79020","event_cluster_id":"ddc509de-3359-4d1f-94b5-786fbe3bdc35"},{"claim_cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","event_cluster_id":"5edd87a6-3d98-4e7d-9e60-b94920fc071d"},{"claim_cluster_id":"258085e5-fc49-48d1-b3f4-3f9862c3ba91","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"69c28a9e-902d-4ac0-9540-ae2854dbb59f","event_cluster_id":"da473e07-5f99-4854-b0f9-aaba62b413c0"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"983a818a-ed6d-40ec-af64-8e28da7e1bbd"},{"claim_cluster_id":"7fb4d786-0c9f-4d33-a3fb-8326f548d1e1","event_cluster_id":"38be1a05-48d2-4f48-88ba-580b1bbdcf47"},{"claim_cluster_id":"078f370f-a761-435a-a7fd-aae948eb479b","event_cluster_id":"e2349307-7610-418e-8e9d-d6184ecce651"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"5256265d-d143-4d8d-91b5-fc2bd6f31e20"},{"claim_cluster_id":"ced45aa6-b370-4a79-b76b-674fcd6c0668","event_cluster_id":"8c588fd7-3da5-41c8-be96-210ededa9175"},{"claim_cluster_id":"ac1f3497-64d3-4909-9d61-789e683556a9","event_cluster_id":"b4f7c43a-b96f-4977-a6a9-ad07015e8976"},{"claim_cluster_id":"3428edf1-36a0-4018-889a-63913498a6c3","event_cluster_id":"cc554329-dead-4eef-88f0-c2d38423ce88"},{"claim_cluster_id":"a7436ce6-07d0-45e0-8628-2de252e4cb46","event_cluster_id":"c537edf5-ee14-4fb6-9cf6-9d972fbc67cb"},{"claim_cluster_id":"eee91c5f-8ac6-4779-af53-8a01aa4eaa03","event_cluster_id":"2f0a7237-fd9a-4068-942a-5cae35e4e123"},{"claim_cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","event_cluster_id":"68995fc4-d783-494b-a9d8-283e32c04543"},{"claim_cluster_id":"5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe","event_cluster_id":"fc3a7125-d930-4cc4-ae3e-0da6ebe44d84"},{"claim_cluster_id":"63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7","event_cluster_id":"9be2ee3c-9f9c-4f35-baba-22913c8be73a"},{"claim_cluster_id":"a316407d-a413-48ec-95c7-f1a3c83da782","event_cluster_id":"6707f20d-c9f4-42bc-ba94-e97c87eae6e1"},{"claim_cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","event_cluster_id":"8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"},{"claim_cluster_id":"507dd458-2eaf-480a-89be-7acf52e56a97","event_cluster_id":"55c3e6f5-571c-4234-bde1-164fbe090fa3"},{"claim_cluster_id":"f7811e36-516c-4780-b025-c2c198f87bba","event_cluster_id":"306af663-29dc-401c-bb87-b5eb6547c25e"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"f61b95fd-4ab1-43f9-b2f8-53b5afb90d43","event_cluster_id":"cb2e6a9c-ffbe-4a9d-a4eb-32e21489b61a"},{"claim_cluster_id":"fbea59dc-8fdc-4fcf-ac76-32627af107ae","event_cluster_id":"309e6017-5ba6-4aa5-918a-e978302b6d2d"},{"claim_cluster_id":"63bcdf8d-5d7d-43eb-b5b5-735ed74b200a","event_cluster_id":"6988ebca-b8d5-4719-a15d-b25c13a58367"},{"claim_cluster_id":"4ea56329-d3e1-48ab-835d-a5cbc403dcf0","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"637d133e-6c19-4fa2-b174-de1d016bd9bc","event_cluster_id":"ebdd6e62-4f71-4eeb-b5bb-afa4c515a612"},{"claim_cluster_id":"10bf083b-35c8-4b77-a2d9-e4cb3813d9fb","event_cluster_id":"43f42741-0a89-4a0f-bdee-4f8b6bc2f468"},{"claim_cluster_id":"de7a466b-9657-42fc-adc1-63e65b4ec1ea","event_cluster_id":"1f87ca5e-f76a-465d-9deb-690952b6b443"},{"claim_cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","event_cluster_id":"60a99f19-657e-458b-aa53-ca2a6063f380"},{"claim_cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","event_cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44"},{"claim_cluster_id":"21ae851f-14b0-4e6c-8bf6-1ff87dabd880","event_cluster_id":"028454b9-ae0f-4b68-8959-098c138f4548"},{"claim_cluster_id":"a15b31ed-89e7-4c30-9559-8eac356b32e1","event_cluster_id":"fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a"},{"claim_cluster_id":"6d2fdf64-8424-4971-a998-3fe674aff124","event_cluster_id":"98c5d764-86f9-4cd2-ac58-1dae1f5811e9"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"5787a927-39a0-4bb7-92d5-230091f48a3e"},{"claim_cluster_id":"44a47e28-efc2-4e0c-b9c2-18a93b3b20be","event_cluster_id":"92111d3f-ebb0-4617-aa4c-9df22ddccd03"},{"claim_cluster_id":"e1f9f42d-4c64-42c8-80ee-89170b717dbd","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","event_cluster_id":"24f76117-6d13-47b7-8b5c-41608f921324"},{"claim_cluster_id":"e21b1b35-31f0-4c02-9069-b35c0b38b172","event_cluster_id":"499883aa-4d50-44a0-85ba-67de7dd41a9e"},{"claim_cluster_id":"13fc2321-1fdf-40d3-8576-3d7e5eb9e53d","event_cluster_id":"3e481577-f346-4d0d-88ef-e1132e39baa4"},{"claim_cluster_id":"260b5cb2-3dad-42a1-a677-cfe24a203765","event_cluster_id":"2d5f7bd3-4c30-4ae5-a057-0f3e35a0cb68"},{"claim_cluster_id":"ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c","event_cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722"},{"claim_cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"051c1a4e-08fc-4a09-9e34-8d3d8d646136","event_cluster_id":"31c80f95-812a-49ce-aa97-208d1f8f4713"},{"claim_cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","event_cluster_id":"3c02cb9f-d868-4d95-a235-953e540c09c9"},{"claim_cluster_id":"066ea292-674c-44ee-8c3c-799b0ecf024c","event_cluster_id":"3fab82c9-6db0-4a96-9fa3-7e0add6da8ba"},{"claim_cluster_id":"57cf4546-a43b-4620-acde-18ad68b95dcc","event_cluster_id":"fa5edee7-14cd-46f2-b781-a5794e463daa"},{"claim_cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","event_cluster_id":"8191e288-4dd0-423e-bf77-953449ad8b80"},{"claim_cluster_id":"1f8ce922-0e37-4ccb-b586-67da18764d96","event_cluster_id":"72084673-8080-44fd-8f5b-97507abf262b"},{"claim_cluster_id":"59d7630c-86a6-4185-b052-67ad13c627a8","event_cluster_id":"9e250f91-2983-4cf6-9b29-817f4271a911"},{"claim_cluster_id":"b39e93e4-b791-4b1e-963b-d8f068ff0b1d","event_cluster_id":"890e1bc7-85dc-4ae9-985a-8f81d088f89a"},{"claim_cluster_id":"e126486d-8b99-4425-b6a3-54724b486b78","event_cluster_id":"abea76a9-3994-48b0-b3bb-df2d7f55ad12"},{"claim_cluster_id":"fcc58b11-54f2-420b-99e3-8acb8731fd15","event_cluster_id":"7deb6d52-1ec6-4691-a2b6-0e60470c80a3"},{"claim_cluster_id":"be467aaa-b350-4a63-875e-7aa61c3d868a","event_cluster_id":"5a50b06e-be6d-445e-97b7-86a315a41b46"},{"claim_cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","event_cluster_id":"95caea6a-ff66-40ac-9167-0fca6baadbff"},{"claim_cluster_id":"e3e8a87e-df24-4ad1-b44d-15176f0a0f6f","event_cluster_id":"1fb31a41-f917-4cde-9190-f353f630be9a"},{"claim_cluster_id":"43beda49-4348-4ff0-94eb-8102078e161d","event_cluster_id":"db2b5d72-303d-4743-8188-e92d23a86e05"},{"claim_cluster_id":"42734325-e832-49e4-b0f3-d3af89abdf66","event_cluster_id":"e0c1caae-a4c5-46c2-a58a-61bf54ce7094"},{"claim_cluster_id":"258085e5-fc49-48d1-b3f4-3f9862c3ba91","event_cluster_id":"f9e1ae92-90cd-4553-9870-a06691bcf1d5"},{"claim_cluster_id":"289e5c59-c24f-465d-931a-b56b54bc982f","event_cluster_id":"9f2f375c-af55-44d4-8d17-dfc761b029ac"},{"claim_cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","event_cluster_id":"733fc34a-7676-43b2-bd68-29d000ed566d"},{"claim_cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","event_cluster_id":"8bd4a872-0209-415e-a7b8-b4acaf26a95b"},{"claim_cluster_id":"a7d034a7-5705-462b-af06-b9277d91c75a","event_cluster_id":"1a1de2a4-159f-4a0d-8a46-97165bf27583"},{"claim_cluster_id":"489bde91-1bfc-48d6-aae7-de380d23d205","event_cluster_id":"2d972490-4937-489e-9570-c5d28d63e725"},{"claim_cluster_id":"9f0480ce-b886-46fa-98f0-af8144766c6c","event_cluster_id":"7c25f378-94ec-4e09-b534-e05191ebdf2b"},{"claim_cluster_id":"c831921a-fda1-47ba-83e1-1042bd97f245","event_cluster_id":"6d5fe755-2873-4033-93ec-3d174da34a66"},{"claim_cluster_id":"b9eca2e7-5401-453f-8490-81ec97719e08","event_cluster_id":"a6590632-faef-4956-b655-28617cdf7601"},{"claim_cluster_id":"0d0fd5f0-0301-424f-b0b1-a60ab6ca045f","event_cluster_id":"efecc9d7-3e88-45ed-b11f-77af1e65000e"},{"claim_cluster_id":"f8755b86-ae98-461e-a3ac-2bd5b6ec4310","event_cluster_id":"21e6b94f-0371-4a78-aa0e-8082ef7b0068"},{"claim_cluster_id":"5edd935c-f1a4-4a6b-86a0-37894c0716f8","event_cluster_id":"95bbf098-c966-4fbc-93df-23d227e7ee92"},{"claim_cluster_id":"d0f7b20c-2bcb-454b-bc64-6c984732d241","event_cluster_id":"4e53d403-5bf1-47ce-a5d9-ecd50db35ad9"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"d5dab78c-a52b-4ef8-8000-44988a029a7c","event_cluster_id":"798603bf-ed29-47ab-b596-b02a192b8a20"},{"claim_cluster_id":"8e782418-3f83-48d1-a7d0-6c3daf34ed25","event_cluster_id":"2962a54a-b1d0-48df-9318-1e0f945ac7d0"},{"claim_cluster_id":"9adce26b-ced3-4b3b-ac9a-24b78e98224d","event_cluster_id":"6190dfba-afce-482c-ab6b-30cfbc88a521"},{"claim_cluster_id":"6f847ace-00e0-4009-b5e9-3729f7a9e244","event_cluster_id":"e8195223-1d62-4704-93af-859b0cc35da8"},{"claim_cluster_id":"21228a2d-48c0-43f0-b18d-e85ff94cdb4e","event_cluster_id":"3f32031e-6be6-43ce-bffb-40370a2c9f89"},{"claim_cluster_id":"5ec8ba1f-609d-4689-8317-8045f6c09e77","event_cluster_id":"16d77388-3cab-4281-9420-51dc93557442"},{"claim_cluster_id":"09060ad9-5546-4c31-ae6b-321cd8a78d5b","event_cluster_id":"e294ae03-93b8-4461-85ca-920f88826e8a"},{"claim_cluster_id":"5acf0ec4-be26-4926-a6a6-508ec71aaa6e","event_cluster_id":"21435744-bfd5-457c-9149-a1cc5945dbec"},{"claim_cluster_id":"194a083f-fee7-4bf0-b198-fa40c8bdfe21","event_cluster_id":"4a10d70f-5f46-496e-a6f4-0b982956d03f"},{"claim_cluster_id":"30ae8997-b16b-4477-bfec-33c1a345955b","event_cluster_id":"add377ce-a507-4594-9a7c-9c1c608ed972"},{"claim_cluster_id":"af3f95a3-d597-4371-bf7f-e4f5d91a9b73","event_cluster_id":"2d61e1a4-f82f-42d3-8440-ae35b51fa374"},{"claim_cluster_id":"9b14cd61-494b-4ae7-a7c2-3720adae8787","event_cluster_id":"50cf17ff-24f7-4dfd-958b-756aec4fd4e0"},{"claim_cluster_id":"40739d2a-a8c2-4f74-ad24-d1d6db92d225","event_cluster_id":"69dae690-93b2-445c-aba3-76b5fc2d7711"},{"claim_cluster_id":"6eb67c15-59c3-481b-bf8b-2e464b0775ec","event_cluster_id":"725d8a20-a3a3-4517-9549-74f8eede8ff7"},{"claim_cluster_id":"9f76cab0-c9b8-4e12-bd91-cd1c5474c649","event_cluster_id":"c97fb561-3217-4665-93fe-191384f9c143"},{"claim_cluster_id":"3b17ca99-a0cf-4b4c-a71f-c0181125d3ce","event_cluster_id":"12975b02-1543-4e2e-83d5-f31f56ef1664"},{"claim_cluster_id":"369b1cc5-aae5-4361-aabf-b1ef5c5350f8","event_cluster_id":"4606c4da-4d5c-4ad6-8119-d1b70a950373"},{"claim_cluster_id":"eb38bdfb-232f-4460-8d60-fc8806237786","event_cluster_id":"6a7bb883-6ee7-43ec-b992-6e755312804e"},{"claim_cluster_id":"840a2e45-449a-4234-be31-852cc48c1642","event_cluster_id":"9c904ce8-82eb-4f73-b9ea-f510b0249486"},{"claim_cluster_id":"38c71e65-4039-4578-b30f-f1a4d6dd193f","event_cluster_id":"a300ef79-1ea5-4eb4-b149-74426ea09a66"},{"claim_cluster_id":"ac5cef85-9755-4d73-a0c9-3b2d779220c4","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"162b03a4-86a7-4adf-9f73-3093aecba542","event_cluster_id":"e50f2f1a-20bb-46bb-82c9-6def0deadc19"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"41895296-6f09-4b44-a2d4-3d90f2e03b81"},{"claim_cluster_id":"ef13681f-975e-44f8-8e95-a6963670af11","event_cluster_id":"2e0416ba-2a52-4d60-ab33-cf2ac09ef620"},{"claim_cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","event_cluster_id":"53ab10ad-1f0b-48bb-90af-3977fee7f1cb"},{"claim_cluster_id":"97f84153-8f49-432f-a8f7-a4e57fe7f769","event_cluster_id":"59ac47e6-50e9-4884-a676-2542dc8e0aa3"},{"claim_cluster_id":"bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75","event_cluster_id":"fd5ddb7c-f743-498e-b007-014e9c97bbc8"},{"claim_cluster_id":"0d0fd5f0-0301-424f-b0b1-a60ab6ca045f","event_cluster_id":"f78fd02c-7e3c-43a4-8429-a28909b13242"},{"claim_cluster_id":"bc2e7af6-3507-403a-b41c-f6013dcfcf6c","event_cluster_id":"afe97367-2dde-46dd-9395-2e46792da8d8"},{"claim_cluster_id":"362947dd-8703-496a-89bc-c395dcec13b9","event_cluster_id":"758b1960-78c3-42a0-8a1a-c0d1f47c547d"},{"claim_cluster_id":"cbb443ee-8a98-4074-9a33-690c1a4267b8","event_cluster_id":"ef5dda09-a763-4471-8324-78da714107dc"},{"claim_cluster_id":"8ae88722-b8db-4d5b-b13e-130f65630e05","event_cluster_id":"45f9b0ec-ee3d-4cf9-bf46-990d297136a8"},{"claim_cluster_id":"78cbe3d8-37f7-4a89-956e-f6dab20ad8d1","event_cluster_id":"e34b1053-1f91-4dd8-9190-a7ed9dea81f8"},{"claim_cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","event_cluster_id":"95799deb-0b6c-4eb9-bc15-24b196417c4d"},{"claim_cluster_id":"d0f7b20c-2bcb-454b-bc64-6c984732d241","event_cluster_id":"0e976646-d8b3-435d-b262-71720e81ac06"},{"claim_cluster_id":"df13c28d-11fd-4cdc-a0c7-5076d0c46483","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"9adce26b-ced3-4b3b-ac9a-24b78e98224d","event_cluster_id":"7dfb31d5-ddb8-4d40-bb81-cb884f7a73bd"},{"claim_cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","event_cluster_id":"cc95457a-219b-4008-9216-67e0ee2bc74c"},{"claim_cluster_id":"947b44c6-b504-4d59-ad29-0dd1f0776154","event_cluster_id":"819f43eb-3e2d-4107-9997-bfc9d26133c5"},{"claim_cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","event_cluster_id":"35b669fa-cc15-4619-8262-2bd41f0ca610"},{"claim_cluster_id":"36824238-8532-447a-aacf-ef3f59e89c60","event_cluster_id":"76435864-5754-43fe-ba96-2ebbad51c5b7"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","event_cluster_id":"5eac68c0-2a04-4e6c-af79-6d253e14522a"},{"claim_cluster_id":"7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6","event_cluster_id":"d494f4b2-e7a8-444d-9de4-a124202cacaf"},{"claim_cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","event_cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638"},{"claim_cluster_id":"210242d8-e5cc-4762-9912-b262084ebeb4","event_cluster_id":"00d660d9-94af-474c-8e79-c16ac62cbef7"},{"claim_cluster_id":"a9096ed8-3c07-4fd9-a21c-9fdb59fe1353","event_cluster_id":"ebe02d8b-ea82-4232-851f-f5ea26e54e8f"},{"claim_cluster_id":"7b08a98a-0129-4cec-b114-1fff26d56746","event_cluster_id":"1936e9be-7524-40a3-aeef-be93dc5f5e4c"},{"claim_cluster_id":"a2f18fa4-3554-4400-be7d-a33cb07dfa44","event_cluster_id":"b40d77a1-3074-4669-a3a8-f64b6de7cd03"},{"claim_cluster_id":"c39e0166-c55b-4f71-8bb5-e23985802606","event_cluster_id":"38653b72-3e71-45be-a6f6-9c4e86755c1b"},{"claim_cluster_id":"e6bef1f7-9387-45ab-918c-0df479862034","event_cluster_id":"0c50a72f-e964-4690-a33f-e878b2e74702"},{"claim_cluster_id":"a03d3de9-e5ad-47e0-9374-17e6c1998859","event_cluster_id":"fe0af648-ca07-4de6-9db2-4c1067118254"},{"claim_cluster_id":"3fc70d09-8a93-4a60-b903-b03cd4187227","event_cluster_id":"49b71ab3-8ddf-486a-9781-e873ef1c9042"},{"claim_cluster_id":"a9096ed8-3c07-4fd9-a21c-9fdb59fe1353","event_cluster_id":"4cb50541-3268-48df-a49c-2b4593404e93"},{"claim_cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","event_cluster_id":"1e13c242-ece9-4014-9237-1eaa4afdacf0"},{"claim_cluster_id":"97d6f1ef-2f69-4bd7-b5ce-8c3dd359bfcb","event_cluster_id":"c00c750e-a740-40f2-8fc7-77d5f6c8fe81"},{"claim_cluster_id":"7ac1c88c-d620-4c32-9f9d-5a780231627e","event_cluster_id":"1fb14eaa-5808-4fba-b78b-8331f9693364"},{"claim_cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","event_cluster_id":"37c144c2-5b3d-4b37-81ec-b6ea11090b3a"},{"claim_cluster_id":"a0aafb48-1cc4-47f3-9cc7-073b87c64efc","event_cluster_id":"3e87c12e-871b-4773-8173-d484141c190e"},{"claim_cluster_id":"6826010f-2a38-48a2-a358-b062edaa9ed4","event_cluster_id":"6694e203-070f-4cf7-a327-66b5e005a5e4"},{"claim_cluster_id":"7325cc3b-df7f-4451-948f-1ce21f12d10f","event_cluster_id":"248cf9f0-85b2-4eae-9028-789470700e69"},{"claim_cluster_id":"58a60e5c-9e5a-48ce-a07c-a7168b46ba2f","event_cluster_id":"f10864eb-56bf-40a9-9f67-5dfe4ef70806"},{"claim_cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","event_cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597"},{"claim_cluster_id":"cdd48d7f-71ad-45d9-b5c0-d84849f26b67","event_cluster_id":"4da675eb-3ccd-4c4a-852a-837897424712"},{"claim_cluster_id":"f0190a02-daf5-48b7-8174-720b52c75550","event_cluster_id":"96226cbe-6ce7-473a-a2c5-bcfa1fa15be9"},{"claim_cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","event_cluster_id":"ee6ffddc-d717-4a7b-a161-3d1bdc24c500"},{"claim_cluster_id":"e205a390-4f4b-4898-961e-ef5a0bf3f3d0","event_cluster_id":"7688d917-39a4-49c8-8503-8ffed77c6807"},{"claim_cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","event_cluster_id":"ef77006d-68d7-4c27-ae83-cb85890ca2b1"},{"claim_cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","event_cluster_id":"3dfd5a3b-6011-45c7-8661-03086fa25dc5"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"cba79c22-94bf-4911-a28d-ebd794325eaa","event_cluster_id":"7fb1b61e-8a8c-43db-8218-8780b6b4a6d9"},{"claim_cluster_id":"6d2792d9-4dcf-4980-9870-d295c7f8e2c0","event_cluster_id":"9bee1f85-c3a5-40f1-a8e3-aded362e94b6"},{"claim_cluster_id":"9fa27866-4911-4f0d-8135-cff4b7e597db","event_cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf"},{"claim_cluster_id":"b180d822-88c1-4c5f-a386-c975497c4a85","event_cluster_id":"06f12bc8-88d8-4040-ac0a-c4dcaae5b13c"},{"claim_cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","event_cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"},{"claim_cluster_id":"2669ad24-9832-49ab-a24d-8ef6f0986ed6","event_cluster_id":"2253ac9a-3adc-46d3-a973-f064ce69f740"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"49e33122-7ceb-4265-b315-038b5cf4ba76"},{"claim_cluster_id":"5c0df4bf-ba62-40d1-a306-8313dfe790e6","event_cluster_id":"90c48754-a318-4dba-916a-e40680d8ea62"},{"claim_cluster_id":"c6d29068-aaee-4cd5-94e1-e4e031d50401","event_cluster_id":"d565264f-4050-472d-a250-87b812ab31fd"},{"claim_cluster_id":"d2231d7f-5f03-4e76-b0ae-753fd54f4960","event_cluster_id":"4a7864ed-3fb7-4536-8df0-aadd1c453c8f"},{"claim_cluster_id":"1ec4a683-16aa-481b-9033-75779c52f6c1","event_cluster_id":"442c376e-0da2-4461-a8fe-6d964ea3c00b"},{"claim_cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","event_cluster_id":"eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268"},{"claim_cluster_id":"ef57a08c-bb40-48bb-8784-c240ed933462","event_cluster_id":"56b88351-b9dd-4f7a-84e1-7a2151d08fc3"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"d42f0707-162e-449e-86fe-0dd5e2885a21","event_cluster_id":"4d62f2bf-06ba-4e7d-b665-78a194b70483"},{"claim_cluster_id":"a1f0e0be-a8bf-4895-ad2d-4f83a0d63930","event_cluster_id":"80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e"},{"claim_cluster_id":"10f0700e-3ce2-47c7-8783-a4d08ef48748","event_cluster_id":"6ad8a14d-0296-478c-a06f-959ddf23a8b3"},{"claim_cluster_id":"7325cc3b-df7f-4451-948f-1ce21f12d10f","event_cluster_id":"af90686d-77e8-4713-873e-8c63e5dbe370"},{"claim_cluster_id":"4fc703c8-a28e-4bc3-ba13-2190c2afdda4","event_cluster_id":"df289945-6d20-4db8-b12c-27190f4319e3"},{"claim_cluster_id":"c8c0e353-5277-4897-8ef8-4773b9d6e6cb","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","event_cluster_id":"287c467e-feff-43ca-835b-d713c03d0418"},{"claim_cluster_id":"4a3bc772-20e9-4711-acc4-eb16f1a71bea","event_cluster_id":"66885820-7ee2-45b0-bbbf-efce4343c472"},{"claim_cluster_id":"aafb6f56-e150-4de6-8f24-4e8fe467b23f","event_cluster_id":"91fe8e01-c220-435f-b390-7c4a84da3d33"},{"claim_cluster_id":"44f7e426-bb87-4dd0-bf0c-80fb71c61eac","event_cluster_id":"fa7c00de-2843-41e3-9b90-64fc233c087b"},{"claim_cluster_id":"c6d29068-aaee-4cd5-94e1-e4e031d50401","event_cluster_id":"8d301f71-3fd8-4bb2-b685-2bfee512c9e8"},{"claim_cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","event_cluster_id":"924eda57-f860-4947-b8f8-b55352cbd0d8"},{"claim_cluster_id":"601320a2-3fca-41ef-9387-a64a4c0b5cee","event_cluster_id":"84787050-e169-47c8-98ae-7a849294a5a9"},{"claim_cluster_id":"16e980af-79a1-4255-8ad0-56ca61ae3b8a","event_cluster_id":"3b0ef1f4-8ed3-49f5-bef1-e5534eb3da65"},{"claim_cluster_id":"493568a9-0e32-4b19-a041-15396f7c15b4","event_cluster_id":"ec8073ca-bd09-4811-94f5-faa29b947d90"},{"claim_cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","event_cluster_id":"690dcbae-7356-41d9-9b3d-b2f6f77db887"},{"claim_cluster_id":"adfa00d7-81da-47be-a9ec-4b8dfb8ee34a","event_cluster_id":"91653172-78c7-443d-8db0-081fac7b81c6"},{"claim_cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","event_cluster_id":"702c96ce-c667-4d06-adc3-0067ef68ea50"},{"claim_cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","event_cluster_id":"7b19db75-3bd2-47e5-a306-0a2f241eda0e"},{"claim_cluster_id":"03ac5e38-07fa-4023-b9bd-bdfc9810ba0c","event_cluster_id":"28e348f7-86c8-4ff9-8b99-eb8b6c73b1bf"},{"claim_cluster_id":"62d8fa29-aaab-4f66-9532-5fb34686e56f","event_cluster_id":"2fd99adc-b7aa-49ec-b4ae-d4607788e329"},{"claim_cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","event_cluster_id":"b6f1959a-3736-48e6-bdb9-c384c993515b"},{"claim_cluster_id":"1ec4a683-16aa-481b-9033-75779c52f6c1","event_cluster_id":"261a6bc9-08bd-454b-9fec-f9f4a0fe9250"},{"claim_cluster_id":"10f0700e-3ce2-47c7-8783-a4d08ef48748","event_cluster_id":"878945ad-a11c-4c5d-8d89-5e5ce4911878"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"afcde980-e0c6-457d-998d-0d7991b35017"},{"claim_cluster_id":"f92684c8-da9a-477a-ba9a-9eb41a6f9f90","event_cluster_id":"4ee7469c-41d2-49f4-8462-c59869db80dd"},{"claim_cluster_id":"d0137977-4815-4376-8c2f-58b223088e62","event_cluster_id":"8b701600-84ba-4ca4-8c27-5ea0e1457d2b"},{"claim_cluster_id":"adfa00d7-81da-47be-a9ec-4b8dfb8ee34a","event_cluster_id":"5ce12af0-2b76-4e71-8a73-442efc1d859d"},{"claim_cluster_id":"29223456-9a08-4f68-9ce7-d62d961fb6aa","event_cluster_id":"2ff54a92-503d-42da-bdb7-6138f7c69fb1"},{"claim_cluster_id":"576d103a-5318-4b16-9313-434ff03a385d","event_cluster_id":"999e57b5-71fd-4f69-ac79-5d89ae8e3c67"},{"claim_cluster_id":"33fe2055-c6c1-46ed-8871-fc741999d32b","event_cluster_id":"9d7867d5-5ab5-4b0e-9556-f3f45feb0160"},{"claim_cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","event_cluster_id":"c6dfc604-6d8c-4b88-816b-1b53975cd28d"},{"claim_cluster_id":"729e67ef-32fc-4882-8297-9f443b6f2589","event_cluster_id":"ef9e5931-dbe9-4ba1-af73-3f6fcb8ed6f7"},{"claim_cluster_id":"f309b6e7-458c-4f62-9d98-f12cb2e89c08","event_cluster_id":"315e3fc3-9356-409c-9b82-9011a9ad2a72"},{"claim_cluster_id":"e9c84dbc-30d1-4e60-bbc8-700057190615","event_cluster_id":"7679c732-4d78-416d-a31b-b4d49c72f3ed"},{"claim_cluster_id":"b433d9b9-0986-4c75-baab-f74fc73be2ca","event_cluster_id":"07ffad90-34a3-4066-8c33-1761dfb6597a"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"c545f601-c30b-46cc-a181-949b8540bd95"},{"claim_cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","event_cluster_id":"c5a49990-0bec-49b9-8797-00d71805007a"},{"claim_cluster_id":"4dbd9499-a86a-4c48-b218-1b0a93aa0331","event_cluster_id":"959de586-d5e2-49e4-92ad-27165bbe0cb1"},{"claim_cluster_id":"2d998acd-2150-418c-b2e7-db6c334526be","event_cluster_id":"178f9d9a-267a-4abb-8f58-8a32bd23bb57"},{"claim_cluster_id":"752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c","event_cluster_id":"b45560d5-3144-4d83-a41f-025765799050"},{"claim_cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","event_cluster_id":"5fca9556-7877-4bc1-82fb-6f88c867de71"},{"claim_cluster_id":"54d52770-613a-47b1-aa64-0743cb644791","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","event_cluster_id":"768c2664-8354-4bfc-8b47-96eb4e08e0ee"},{"claim_cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","event_cluster_id":"70a4982e-a051-4993-8a45-818426e08af0"},{"claim_cluster_id":"804db45c-717d-4c1d-9494-73592da3dad8","event_cluster_id":"2d3a5941-caeb-4957-af01-00f1d2fdf8e4"},{"claim_cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","event_cluster_id":"93f03d20-e5b7-41c5-976e-5122f884847a"},{"claim_cluster_id":"5521d112-0a05-4e5a-881c-de705171fc9a","event_cluster_id":"b6ada6e3-1455-491d-948b-45a74b134fab"},{"claim_cluster_id":"2f43e86f-24fc-4c3c-a77d-c5abbf46ef19","event_cluster_id":"e0a1afab-5142-40ca-ad10-35061b0289f8"},{"claim_cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","event_cluster_id":"39f63165-e875-40a7-84ed-ae42699b5d21"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"222d1da7-5333-49e1-a4ec-9ca508fd278c"},{"claim_cluster_id":"be9b7361-8150-4e4b-9111-bac990c11d3d","event_cluster_id":"050d87c2-4ac3-4e0e-8673-b4a44b43bac0"},{"claim_cluster_id":"dc8d69ed-9d9d-4c04-a104-2c89e796edf3","event_cluster_id":"61eb35de-336f-40f6-88fb-ed35c226eeeb"},{"claim_cluster_id":"df846784-b644-4d2f-a077-f42db08f73a6","event_cluster_id":"a4e389ba-b81a-45e6-ab4f-901841ef5d44"},{"claim_cluster_id":"329c69a1-8578-4615-a95d-4068857af2c9","event_cluster_id":"aac0ba40-d82f-4ba8-91e4-f92c6960338d"},{"claim_cluster_id":"f3cb984c-8736-4ad2-8cd8-5ca9f90033d5","event_cluster_id":"f8140231-b4f8-4a5a-801c-39c992ba46a9"},{"claim_cluster_id":"de7a466b-9657-42fc-adc1-63e65b4ec1ea","event_cluster_id":"9f5a552b-da22-4595-b590-da914506237b"},{"claim_cluster_id":"338d5a8d-64c7-4bed-a37e-208196096015","event_cluster_id":"c527d2cd-0df5-4184-a0f7-17002b9cf18b"},{"claim_cluster_id":"32c3480d-0d09-459f-9f53-79a49ae3f52b","event_cluster_id":"2cfd963e-dc73-4d82-9776-ae618471ae77"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"},{"claim_cluster_id":"07438861-a868-47ed-8a1a-288138dc65c0","event_cluster_id":"41895296-6f09-4b44-a2d4-3d90f2e03b81"},{"claim_cluster_id":"a5706e56-c643-44be-8e44-3c19fd9dcc29","event_cluster_id":"a5e788fc-37bf-43d2-97b2-732f917263ab"},{"claim_cluster_id":"c7c25534-0ffc-4f97-99d9-6bf3f3de9b03","event_cluster_id":"3d5e9384-ac3e-4f4c-a500-50dfd267dfa4"},{"claim_cluster_id":"6832730a-f3c3-49e8-8c1f-45ff7dac590c","event_cluster_id":"39d6e082-ff74-4db5-9429-ae565700afa5"},{"claim_cluster_id":"428d818b-c2cf-41c7-bcd8-3f5cb0b144ef","event_cluster_id":"87581b6b-a1c8-4620-9246-61483cbbfb0d"},{"claim_cluster_id":"c1308dd1-2ebf-4164-b9e3-2284bbfb088b","event_cluster_id":"d30fd077-478d-4784-a1a9-ce89125fa303"},{"claim_cluster_id":"662000fc-1ecb-4634-b4e8-efc53b2b3287","event_cluster_id":"a8fe9f9c-6b4f-45e8-a4dc-fab2a57284cf"},{"claim_cluster_id":"2a22127e-779b-461a-a858-c6dc0fc34ff0","event_cluster_id":"125babf5-bc0d-45cd-ad83-2a6b21a3e2c7"},{"claim_cluster_id":"843bcba9-c863-41a3-a76f-01fd61d56529","event_cluster_id":"776c4ee1-eeec-4f70-91d9-12fdaa179052"},{"claim_cluster_id":"e1ed1afc-85b6-4c69-a063-e486d1e3670f","event_cluster_id":"33b85444-739a-48a4-ba4a-144d6f0bde74"},{"claim_cluster_id":"095169c0-0ce4-4362-b29d-486ce7d2b848","event_cluster_id":"afd1f695-ea2e-42a9-8e8b-7c38a970fbb5"},{"claim_cluster_id":"58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e","event_cluster_id":"072b9770-c37e-4414-a35e-af21470d2ffc"},{"claim_cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","event_cluster_id":"731fbc17-b401-45f0-a173-ab4385d11eac"},{"claim_cluster_id":"c6541e86-8e1b-4bd0-926a-c380aa103aa6","event_cluster_id":"090c138f-cca2-4b65-9a79-43955026e502"},{"claim_cluster_id":"d93d391c-6b51-4713-bfdb-30f405cd2357","event_cluster_id":"f2d4f2cd-14c3-4d0d-9c96-d0df234f7a5c"},{"claim_cluster_id":"17c8775c-7a3a-4607-aa7f-5b24078a17f8","event_cluster_id":"21a0cca0-78e3-4e0b-95d4-e1b42b08be47"},{"claim_cluster_id":"971c6a1a-3e95-4838-8131-b05eb89d55b7","event_cluster_id":"6bbdc559-2725-4b4d-bee7-05ff3de480c4"},{"claim_cluster_id":"0792eb98-3885-48f3-bc43-bf2a8c746720","event_cluster_id":"4e34cec9-0108-4167-8bfb-d0fceb099fab"},{"claim_cluster_id":"de7a466b-9657-42fc-adc1-63e65b4ec1ea","event_cluster_id":"9e2dd54a-2362-436b-857d-0266fa2b8211"},{"claim_cluster_id":"20d6183f-1c47-41c9-bd8d-d5a8b68eff2e","event_cluster_id":"23c989ae-ea8a-4829-80ac-944f7f9327cf"},{"claim_cluster_id":"d65c0d37-123c-4e39-9b2d-386613952a30","event_cluster_id":"e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"63024d1d-9398-49ae-8b27-efbfa0bffb4f","event_cluster_id":"7bd525d0-ac48-4787-9774-a8b37c4ff4a9"},{"claim_cluster_id":"5995c9ca-98e0-418d-a93b-a662311da0c9","event_cluster_id":"5b28f584-d6d3-4f8c-b812-407015e7b243"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722"},{"claim_cluster_id":"b686bd17-fb36-4b7b-9caf-084f8d91c149","event_cluster_id":"76ddd218-4f5f-4047-8ee4-faeb581b90a7"},{"claim_cluster_id":"009e9d6b-ab96-416d-b96e-b7eaada086cf","event_cluster_id":"3a4ae54e-e7b7-47e9-984e-62601ed45ab4"},{"claim_cluster_id":"dbd98860-9de1-4289-bb60-99171790c782","event_cluster_id":"5716770d-1472-4c8b-9408-d81e71966a7e"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"bd99a1f5-0df7-4f4c-90f0-16afb1a5c96f"},{"claim_cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","event_cluster_id":"61b4a043-a586-425e-a2f1-9e0b66e038e5"},{"claim_cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","event_cluster_id":"af07ce28-0024-41ac-b51c-01e4bbf2c507"},{"claim_cluster_id":"8f07bc53-1683-4b3a-b1de-2e1c15c0e13c","event_cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc"},{"claim_cluster_id":"7b08a98a-0129-4cec-b114-1fff26d56746","event_cluster_id":"a222cb65-167b-49af-b5d2-9f2a8169e28d"},{"claim_cluster_id":"3e5167ea-d839-4cc5-b193-fda2f9c0b53b","event_cluster_id":"800ccc5c-7e0c-49e0-a72a-3cfe964493e5"},{"claim_cluster_id":"df5cc82a-7ab7-41f6-8eae-c3445a8c7a05","event_cluster_id":"352c9b63-ad06-4659-b8a6-286e7a80ff49"},{"claim_cluster_id":"f66864ea-bc5a-4c3b-ba81-6aa44dc35cb3","event_cluster_id":"fd0c8abe-7ca4-4c28-8c57-cd7f45e50fde"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"30a748c7-0edb-4c1b-9472-d1b4ca3f8032"},{"claim_cluster_id":"c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a","event_cluster_id":"9c71282b-fc72-4fb3-b7f8-7ff433782d1d"},{"claim_cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","event_cluster_id":"154780a4-c583-40d6-b0cd-5a3d8a1994cb"},{"claim_cluster_id":"80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921","event_cluster_id":"1380f196-a8b4-4593-b276-1ee4b9b19dc0"},{"claim_cluster_id":"c91afcbe-198a-44cd-83c8-42c89811dab9","event_cluster_id":"15826810-2be6-4996-948b-869e0ec64e02"},{"claim_cluster_id":"5b52495b-d578-4d45-975c-d2e0417f4501","event_cluster_id":"553f1291-956b-45d5-9567-97bf2439ca2b"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"ceabee0f-bc28-4b8e-8445-fc63ff551472","event_cluster_id":"9dbb5109-6fdf-484b-92c1-ec8b1bba2a62"},{"claim_cluster_id":"0119782a-5d22-485c-b58b-6c82b20e788c","event_cluster_id":"2f8e7728-120e-46dc-8103-038ff1bcf8a0"},{"claim_cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","event_cluster_id":"bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"},{"claim_cluster_id":"262772f6-e21d-4ca8-a80f-06c1518ea90e","event_cluster_id":"3ddf92d1-7fbd-4c44-857f-573095c914df"},{"claim_cluster_id":"55a6c384-27dd-4299-b28d-d3dcd1dd5947","event_cluster_id":"eb0d5379-1fcc-4fd5-a65b-238e9b2fe3a4"},{"claim_cluster_id":"13672f1a-e63c-4ec7-9f85-d3ed61ff60fa","event_cluster_id":"c1018981-9883-4b7e-8f5e-7f4837994e54"},{"claim_cluster_id":"8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576","event_cluster_id":"2a74c891-6384-471e-8d99-df457b1baa82"},{"claim_cluster_id":"a3cec669-c5d7-49cf-9b41-ed9298b7642a","event_cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de"},{"claim_cluster_id":"af2dae39-7b57-4e0d-909b-c39b56de0088","event_cluster_id":"e9eacbea-e948-4bff-8064-db4af871a9d3"},{"claim_cluster_id":"3b1f0ed9-3201-46c5-93e3-016f26c4d261","event_cluster_id":"f39cf9c7-18fb-4728-b88a-0bd586522d02"},{"claim_cluster_id":"197fe725-a0a9-40f8-a6e9-956dd052b066","event_cluster_id":"290a2df9-939f-4569-965e-7d206087ead6"},{"claim_cluster_id":"6677095f-eafc-4bbb-8dde-f914b5103e89","event_cluster_id":"ea5f2b05-0096-4117-a2fa-b72e433c4955"},{"claim_cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","event_cluster_id":"4c1d018f-90d0-4f64-b7e5-c3877ba4474a"},{"claim_cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","event_cluster_id":"06d0d746-6c6d-457b-ab07-13b3cadf3286"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"00682147-64d4-4c37-88ac-2b9c31d6d40d"},{"claim_cluster_id":"c13b80fa-280b-4c54-8a38-1ddd943c4782","event_cluster_id":"7011451c-4136-49ed-9d09-6db32baccfc3"},{"claim_cluster_id":"21240c8f-29c6-42ef-b002-a537a743739b","event_cluster_id":"fd853489-07e0-4489-8d20-abb8f80a4213"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"e5a713cd-2a21-42c0-89a2-7795a4250823"},{"claim_cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","event_cluster_id":"a0d0eaf1-4a40-484e-a752-fdb85cffa308"},{"claim_cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","event_cluster_id":"16a78e87-1a7e-47fe-92e8-e8466b7bd20f"},{"claim_cluster_id":"b61ba5b2-e28d-4cea-b7a2-78bed070aeca","event_cluster_id":"096792cf-02d2-44be-b8c2-c02b17ea6cb5"},{"claim_cluster_id":"4ece2a70-3ab9-4be4-bb31-9931add16159","event_cluster_id":"0cda4135-c24b-4433-a2d2-edf8bce6961a"},{"claim_cluster_id":"a020fdcd-2c2c-4311-bbc5-883c8bcd23ae","event_cluster_id":"376cbd95-afac-43da-8c2a-b0756127f429"},{"claim_cluster_id":"ea149597-1daf-4627-8587-59eb8a6bde8b","event_cluster_id":"6eae9125-d91f-4554-8584-e619f1d7940e"},{"claim_cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","event_cluster_id":"72796cab-1adb-4917-9d03-40c3dc952598"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"fdb454eb-b6d8-4e69-94d9-d465733df395"},{"claim_cluster_id":"c13b80fa-280b-4c54-8a38-1ddd943c4782","event_cluster_id":"7e1892c9-2b80-4467-8d86-e0034e324987"},{"claim_cluster_id":"4c8ca22f-065e-4c2a-bc2a-950d315204b8","event_cluster_id":"1618106d-1c52-48f7-9d0e-a09294ca1167"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"9419d9bb-572a-4e79-aef7-f69f5e25eaa2"},{"claim_cluster_id":"5acf0ec4-be26-4926-a6a6-508ec71aaa6e","event_cluster_id":"4d12b965-7c97-4994-9361-6f5f0b2c17ee"},{"claim_cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","event_cluster_id":"41895296-6f09-4b44-a2d4-3d90f2e03b81"},{"claim_cluster_id":"452c2457-4da2-4edb-a49f-86f139410e4f","event_cluster_id":"e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5"},{"claim_cluster_id":"eb38bdfb-232f-4460-8d60-fc8806237786","event_cluster_id":"49884f4f-86a8-42d4-b8a9-af42d91f50a2"},{"claim_cluster_id":"eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3","event_cluster_id":"f2e7e2a5-1bc4-443d-b76a-ecb8995fbae8"},{"claim_cluster_id":"b3de51b2-92ca-4cb1-b45e-50a0188ca28f","event_cluster_id":"7a4c0ada-5901-4c50-be04-047c13f1ba31"},{"claim_cluster_id":"18108091-50d0-4bb5-a06f-5f2734380aef","event_cluster_id":"3cee1037-34a3-4502-8ebe-36a15c95ec82"},{"claim_cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","event_cluster_id":"6150a21f-6d1d-4554-8cbb-b01623349756"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"05638bd6-42ef-4049-b6f6-4a5478e7b8a5","event_cluster_id":"7a09649a-0d1c-4211-a9ef-65dbb223fc3d"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"8602d3ff-0dd5-4315-8d50-17cd0d22f5ac"},{"claim_cluster_id":"52105c27-d937-4970-9bad-c139e21a6205","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576","event_cluster_id":"473de348-b521-4729-af95-a1929f5cfcf4"},{"claim_cluster_id":"12e02de9-758e-49f6-b31c-fe52770a7aa7","event_cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"95b3c4c9-cd4a-4cfa-9eab-9df18c6c5d95","event_cluster_id":"9a0ba2bb-c790-4711-b8e3-9a7c3fc3165b"},{"claim_cluster_id":"0d813aeb-360a-48ec-afeb-778e533504c7","event_cluster_id":"fbff695d-2102-476c-be9c-1ec2e2a34e99"},{"claim_cluster_id":"7e98dc53-abf7-4bf8-8ac7-3c9623f6d068","event_cluster_id":"b56f25e8-34c3-4cf5-b21e-1b0f46545150"},{"claim_cluster_id":"ff47f0b3-49ae-48d8-b9cf-5707589bed0f","event_cluster_id":"169e370f-8381-43b0-8425-6e6dcf0bee77"},{"claim_cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"a219ce5b-2b81-445f-a63d-19aecc15acb1","event_cluster_id":"15f10d86-dc7c-499e-a621-4444d739de34"},{"claim_cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","event_cluster_id":"16220929-8aa1-45e6-9f5e-8401f7ed50de"},{"claim_cluster_id":"5b2c4526-459d-4b6f-8f31-bd40fccf12ff","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"125b87a9-62f3-402f-a1ad-6a9130845e80","event_cluster_id":"0fd165fb-7316-456d-917e-cb976d5b4983"},{"claim_cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"e35fb8e9-42cf-4ef0-a512-d7be06ad99e3","event_cluster_id":"add56d26-1f85-486a-b862-703a0d62439d"},{"claim_cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","event_cluster_id":"61b4a043-a586-425e-a2f1-9e0b66e038e5"},{"claim_cluster_id":"f0190a02-daf5-48b7-8174-720b52c75550","event_cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb"},{"claim_cluster_id":"a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc","event_cluster_id":"ed839aef-f33d-482b-b6ad-3c8a3947da24"},{"claim_cluster_id":"cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb","event_cluster_id":"60b00870-1636-4edd-b3bc-90daaa615659"},{"claim_cluster_id":"e6759e4c-f697-49ce-a969-2f596e5c4293","event_cluster_id":"fba25849-5030-47b7-9871-3584f06bc4e7"},{"claim_cluster_id":"65cd54b0-2f90-4b59-a573-5917ec27f9bb","event_cluster_id":"6d1416a4-5911-49a5-a8dd-0b4e7d18279a"},{"claim_cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","event_cluster_id":"94e66aa3-5079-4e1d-bdc8-702db352aa56"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"52bfe357-189c-4c8a-a4ee-372f061bfc2c"},{"claim_cluster_id":"d92f99b3-bdef-4ca3-95aa-e303f2451b97","event_cluster_id":"210b8b9f-5f46-4fbd-8a43-aa4d24350d2d"},{"claim_cluster_id":"ff47f0b3-49ae-48d8-b9cf-5707589bed0f","event_cluster_id":"fc91cfeb-b23d-4b4c-816a-7fa7dfbf9e8e"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"03105f5f-d65d-4408-8071-b314d86ce573","event_cluster_id":"c9299dd8-c218-46f0-b151-8c752a7421c0"},{"claim_cluster_id":"6436c54d-cea9-4b06-8f6e-d82ef558f6c5","event_cluster_id":"6b03b394-3970-4d06-bfbc-01183e585200"},{"claim_cluster_id":"a15b31ed-89e7-4c30-9559-8eac356b32e1","event_cluster_id":"3fceb0c7-e424-40ef-bf39-fd06469e3042"},{"claim_cluster_id":"40860ef8-1ebc-45f7-84a0-735bcdaf070c","event_cluster_id":"9b321e6e-fd77-47ca-b965-6aceb0683d37"},{"claim_cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","event_cluster_id":"13d74323-84c7-4461-a516-d07ee1ee8c43"},{"claim_cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","event_cluster_id":"bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c"},{"claim_cluster_id":"04fd43b1-9ee7-43b3-b1fc-e9fca576658d","event_cluster_id":"e6120475-8d62-4b1d-84b3-4c53f22ff855"},{"claim_cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","event_cluster_id":"bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"},{"claim_cluster_id":"eee91c5f-8ac6-4779-af53-8a01aa4eaa03","event_cluster_id":"e5554b00-9db0-47c0-964c-03cd848dbfe3"},{"claim_cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","event_cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028"},{"claim_cluster_id":"9ba4f992-6e11-40b2-8501-4e04321822e6","event_cluster_id":"eaa2dbb7-40c0-4ebf-a0b3-5deddf646a17"},{"claim_cluster_id":"97037755-caf6-49ed-8d7a-bb7c0d42bf8c","event_cluster_id":"f3668774-884d-4b84-a93b-1c5ea3e64309"},{"claim_cluster_id":"97b36cda-ba8c-4a83-864b-060595445ba9","event_cluster_id":"ebecceb7-8e8e-4359-8ae4-54572c43828e"},{"claim_cluster_id":"f15167ff-a614-4854-ae28-529950f00bdc","event_cluster_id":"89ee63c1-fb19-4aa6-ab9c-62e22a3b7244"},{"claim_cluster_id":"916339bd-3e65-4fc3-be04-12020f45e716","event_cluster_id":"62e37c68-3e37-4c4f-b64e-4d353bb38fcd"},{"claim_cluster_id":"1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254","event_cluster_id":"9cb21d08-8a84-4302-8619-2f374e19a897"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"29fa8f23-676f-4f6e-888b-58fd11dbd236"},{"claim_cluster_id":"b3413e76-c570-4047-aa2b-63946d5b2c25","event_cluster_id":"2e3c3c0c-9c80-46be-8b29-ebed3dc26978"},{"claim_cluster_id":"2ab59d09-09ca-4583-9e99-8189ce8c9335","event_cluster_id":"e113cbe4-9797-46e8-ab87-8e31da3f22de"},{"claim_cluster_id":"f5514b1c-3b40-41b8-9290-039c2c94a3e7","event_cluster_id":"e91640d2-fa8e-426c-a0fb-7b9789e054bf"},{"claim_cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","event_cluster_id":"0807cdb8-6ddb-4585-ad14-90359bbf1c37"},{"claim_cluster_id":"3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1","event_cluster_id":"05babc1d-7e43-4754-b561-cd3371da4717"},{"claim_cluster_id":"b2568d68-53d4-487c-b724-0456b247a886","event_cluster_id":"b8cb289e-e370-4b8e-aa6d-b4c268c9566e"},{"claim_cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","event_cluster_id":"2bcfeb62-5d3f-441a-a60f-796550a52e9a"},{"claim_cluster_id":"9ce1a265-b79e-4040-a0e8-f1a6fbb59f67","event_cluster_id":"5ab902d4-7128-4b95-a738-a425f46dd496"},{"claim_cluster_id":"7eefde16-5844-4305-a679-da87990a2640","event_cluster_id":"b419eced-65f4-49b5-ac60-2638f9c27f53"},{"claim_cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","event_cluster_id":"5a4d2a32-bac0-4370-915e-eb0f49138ccd"},{"claim_cluster_id":"6aa59122-6821-4e76-8afb-2ad2b679a5aa","event_cluster_id":"60f1920a-6809-46d7-8c57-4dab4cfa8642"},{"claim_cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","event_cluster_id":"eb435255-a9dd-404d-b762-acfa5ea790a6"},{"claim_cluster_id":"35ee8064-f9ff-4496-b4db-ba79f7f24de2","event_cluster_id":"2598e9eb-952c-4ac9-abb5-957f4bef45b1"},{"claim_cluster_id":"099db03e-baa7-498b-864d-6a091534741b","event_cluster_id":"ff5b2600-1cea-4a76-a9a5-9e02ca367e1c"},{"claim_cluster_id":"8499f04a-3cd9-4588-b8dd-3abc1c538bcf","event_cluster_id":"5b750f94-6101-4383-bd0d-c980ad3ff8c2"},{"claim_cluster_id":"dce81269-fe31-49af-8310-17a573139956","event_cluster_id":"99cf328e-cb8c-4fbf-b5e7-b5b12080a8e0"},{"claim_cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","event_cluster_id":"1ff366e5-31ba-464c-8544-3d84f99a75c6"},{"claim_cluster_id":"7faff4ee-fc9e-4ba2-8e8e-36906d88936d","event_cluster_id":"971dde28-a3c6-404b-8a02-b24390ab3750"},{"claim_cluster_id":"84a6bd0b-f777-46d5-bcae-3f166d028b6a","event_cluster_id":"81c0ca50-4b77-426d-ae3a-c52b1a992539"},{"claim_cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","event_cluster_id":"092404d0-7d21-433f-bfca-9a5d34d17b3b"},{"claim_cluster_id":"b08cba5b-cde3-4318-9ea2-b4cf4efed9c3","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"285cd62d-96d8-4ff1-af84-3fd22f7b4f51","event_cluster_id":"0640a339-12f8-4d3e-8416-49b84425cfca"},{"claim_cluster_id":"f465e3b9-9784-4302-b258-d34ad0adf726","event_cluster_id":"b69dac95-ca24-49e5-b472-f36e5a0721b8"},{"claim_cluster_id":"b4c1b467-58b1-4e2c-a735-234cba24891c","event_cluster_id":"dddeb5a3-e00c-4234-b929-096fb52ccab4"},{"claim_cluster_id":"edbdc807-7fba-426c-a271-726e1f090eaf","event_cluster_id":"2258427e-082d-4938-9009-29d50fe17645"},{"claim_cluster_id":"4ea56329-d3e1-48ab-835d-a5cbc403dcf0","event_cluster_id":"725d8a20-a3a3-4517-9549-74f8eede8ff7"},{"claim_cluster_id":"fbdddb76-bee9-4e1c-9f2e-03126700cbd1","event_cluster_id":"e77e1981-0ac9-43e4-bf55-8efb11926415"},{"claim_cluster_id":"3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d","event_cluster_id":"747b93ff-87de-4a18-a76c-e68485fa2bed"},{"claim_cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","event_cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc"},{"claim_cluster_id":"e60065d4-ae50-40b0-8e77-8c2ad3e36235","event_cluster_id":"2420d848-9bcf-484f-a278-33ad97459cda"},{"claim_cluster_id":"7698cb38-d25f-4849-ba30-99dd8e321533","event_cluster_id":"9d377c51-15d9-43e8-b309-1b51ed3849a9"},{"claim_cluster_id":"11b24695-ec58-4b46-8411-89fe4137f816","event_cluster_id":"6d5e0026-09e5-4a7b-b48d-75b8d03130d8"},{"claim_cluster_id":"635833cc-6550-4cab-b41a-e51cbfca373a","event_cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"6826010f-2a38-48a2-a358-b062edaa9ed4","event_cluster_id":"29eddc16-8def-4acb-9488-5c09c0cd7216"},{"claim_cluster_id":"da8da9c4-b0b1-404e-a289-e106bb2bfbb3","event_cluster_id":"1fdd9b57-6c44-4ffe-9d2d-90b7efd6fa20"},{"claim_cluster_id":"29c942d6-0549-4857-889a-2fc5fd4cf362","event_cluster_id":"2f690c44-ca18-4a31-a2b5-68ac60208360"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"6f3f0719-064d-478a-ae5f-d9aca0368d4e","event_cluster_id":"976b0673-ef25-484d-9be8-afb6c791a214"},{"claim_cluster_id":"94076701-ef33-45db-95b9-6fd0d66deba4","event_cluster_id":"e7ba1693-6646-480a-91d9-2e51aafb0261"},{"claim_cluster_id":"9fc7edf3-7209-4828-92b3-8d6dafded201","event_cluster_id":"7b83d10a-e2be-4730-b52d-6f8b8b917c91"},{"claim_cluster_id":"881a8788-562f-4bf2-a8b1-590419007a87","event_cluster_id":"8812088d-8004-44b8-9f99-4965a38e2031"},{"claim_cluster_id":"60a1acab-79cf-438f-96de-dbff294bd2e7","event_cluster_id":"9b7a4b49-e4e5-49c9-a089-9e908e59efcc"},{"claim_cluster_id":"88b5488c-d8fa-4baf-af94-ea104e983a2a","event_cluster_id":"cb16ac50-aed8-4a03-a5d3-3ad483937d48"},{"claim_cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","event_cluster_id":"f2217761-bf63-4a79-b438-adbd2534e4d4"},{"claim_cluster_id":"8610b5a0-f4b4-403e-94e5-57543da5eb32","event_cluster_id":"9d38e0bf-2876-4c73-84e8-54044be3ef3d"},{"claim_cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","event_cluster_id":"bda677c6-ab51-41f9-b0f0-3abc1ddda687"},{"claim_cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","event_cluster_id":"59e2af7d-1c61-4602-808b-5369f9854fc9"},{"claim_cluster_id":"e2f88c16-103f-497d-a88a-e63349d63a62","event_cluster_id":"1288dccd-1b4b-44a8-94be-08411cd2073d"},{"claim_cluster_id":"4a2e9d4b-d2bf-4512-a149-283851028578","event_cluster_id":"7e336202-10f1-4b91-9736-78eda34d2dbf"},{"claim_cluster_id":"ceabee0f-bc28-4b8e-8445-fc63ff551472","event_cluster_id":"c2686424-538a-4d1b-80b6-8a6f5e252d7c"},{"claim_cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","event_cluster_id":"1fb65a9b-f85e-4764-8dae-68053166a895"},{"claim_cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","event_cluster_id":"29244a34-6c97-4370-9081-3f30eca9f0d9"},{"claim_cluster_id":"9621dd39-ccb5-4e12-9287-8a404c57bba0","event_cluster_id":"0ba7abed-e798-4cd4-b041-3026081313b7"},{"claim_cluster_id":"dfe5555f-7179-45b9-9f7a-919fa1cc1569","event_cluster_id":"d770e161-8ec1-425e-95c8-277c26523ee9"},{"claim_cluster_id":"3d2576b2-1572-432b-98fe-db8e768274d5","event_cluster_id":"29c9c847-8482-467d-b041-65b225a57d48"},{"claim_cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","event_cluster_id":"ab120ec9-7f69-4d7e-880b-eb52320c48cd"},{"claim_cluster_id":"3c4b8a98-54ef-4e72-a175-6c00ff85db75","event_cluster_id":"708bf439-5986-4d45-983d-18029794b540"},{"claim_cluster_id":"125b87a9-62f3-402f-a1ad-6a9130845e80","event_cluster_id":"26032edd-a722-4f79-a364-7bd2114c1626"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"5062ec52-04a9-40ad-82e8-e7b18ce41e9a"},{"claim_cluster_id":"2a9019de-d820-4155-a78b-fc972ec57552","event_cluster_id":"4c6cef5a-0fb7-4222-87ca-9b217e095be3"},{"claim_cluster_id":"6a2f7e2f-c113-4c0f-aa04-a2e337901c37","event_cluster_id":"b94a7962-9c49-4a90-a9cb-480e580b3877"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"05e83588-8d3e-4daa-9f6b-b9faf4c1da93"},{"claim_cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","event_cluster_id":"532f519a-d7c1-4910-afdd-938e13222189"},{"claim_cluster_id":"4ea56329-d3e1-48ab-835d-a5cbc403dcf0","event_cluster_id":"c7d67f17-53ce-45fd-95d4-ee1ed41ef6c6"},{"claim_cluster_id":"4eb34d6f-2849-4a6f-9012-a59681fdeeff","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"9d2cc997-e857-4b80-a227-cc6a1c61d16d","event_cluster_id":"49b36199-c1c8-43a9-b1e6-9f3f63fb03d2"},{"claim_cluster_id":"57bfc89a-d981-44e9-a425-3364b9a5bc24","event_cluster_id":"ae87ce9d-8fb9-4394-9afe-202f1ec14722"},{"claim_cluster_id":"43fa6264-b651-4eef-9023-b4483c40f5ce","event_cluster_id":"83f0ad4a-11d4-48a9-95b9-150f72ff58b7"},{"claim_cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","event_cluster_id":"f79fc6d6-3df1-4383-96eb-f3d73361c492"},{"claim_cluster_id":"3c925ff8-1b8c-47f3-b741-4544a596eae9","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"109acea7-1d98-4f39-a38c-6bb5919965c9","event_cluster_id":"986a6ea4-399c-4998-bc4e-699677ef9178"},{"claim_cluster_id":"8f9f1940-08f3-4a29-938e-790645f67487","event_cluster_id":"71cbbb7d-55a3-4b3d-a593-9d2df11352a4"},{"claim_cluster_id":"b65de138-2e69-44b3-acdb-00d152bc8245","event_cluster_id":"80759b38-0166-40f3-aa37-31d3150e1679"},{"claim_cluster_id":"24f6a0c0-6612-4488-bc48-40d12340ab22","event_cluster_id":"4197fab6-cdc4-4d7f-986d-0c9c57282306"},{"claim_cluster_id":"9abd543e-88ed-4716-b3f4-c8fea9769bf2","event_cluster_id":"1e37f73d-f086-437d-9d39-f33d1960b443"},{"claim_cluster_id":"2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37","event_cluster_id":"836ea24a-dc8d-4499-b021-d9c9b600cc60"},{"claim_cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","event_cluster_id":"114c895c-17f1-417b-8a4e-f626b06562d8"},{"claim_cluster_id":"40a361aa-d57e-4e3c-9740-34505f34913c","event_cluster_id":"885d31c0-aa76-425b-b76c-0ebfaadd310b"},{"claim_cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","event_cluster_id":"a2b34554-85cc-4429-8668-e4a20bf0d860"},{"claim_cluster_id":"1c24fe42-ed01-4d5e-85a3-6011ab09ff6f","event_cluster_id":"aa05692d-a142-425a-b2a4-b94b0045a440"},{"claim_cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","event_cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739"},{"claim_cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","event_cluster_id":"2a09de37-e0d8-48a4-b6d1-8773f6d954be"},{"claim_cluster_id":"7b76e5cb-748d-468e-9baa-d34773d5f24e","event_cluster_id":"02b14d03-5d87-4a88-8655-66e1b5dd7380"},{"claim_cluster_id":"05638bd6-42ef-4049-b6f6-4a5478e7b8a5","event_cluster_id":"0656118b-9248-4fe1-a608-3abb014d1738"},{"claim_cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","event_cluster_id":"0368ead8-8d25-41a1-9249-88baff9335b0"},{"claim_cluster_id":"0b400fd1-082b-403b-9ea9-8d3710e7cc9f","event_cluster_id":"62babf7f-7431-44e7-bf3a-2b3d26f92e86"},{"claim_cluster_id":"144a5089-d891-40d6-b31c-9c5381bee1d5","event_cluster_id":"f5bf5358-6837-4934-ac62-9ad98735b162"},{"claim_cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","event_cluster_id":"b2e1f729-9431-42cc-affc-159e60e3c7e6"},{"claim_cluster_id":"19dc451c-d076-4677-8e6a-44a760f27332","event_cluster_id":"713029fb-6b38-4883-a995-a264b7e6024e"},{"claim_cluster_id":"40d2bc92-0cd6-4002-bff9-64332ddd7635","event_cluster_id":"0f364498-4c31-43db-a10b-2fd4536b05a1"},{"claim_cluster_id":"400218af-6cc1-4f06-8e3d-7804bde6ad17","event_cluster_id":"1ed52c55-1d90-4460-9e88-861e6d435eee"},{"claim_cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","event_cluster_id":"360f1793-af7a-40dd-84eb-5e978218de67"},{"claim_cluster_id":"8ae88722-b8db-4d5b-b13e-130f65630e05","event_cluster_id":"57033778-ccb4-4eeb-beda-4c41cf31fd86"},{"claim_cluster_id":"8e7a25f4-c25d-43c4-890a-4d8d8364c5bf","event_cluster_id":"e4b7f8f2-bf69-40ad-a14f-a4a477fe73df"},{"claim_cluster_id":"b54e5664-a40b-4682-b959-bcfb59ddd4b0","event_cluster_id":"7e9bdb50-a12f-4215-9c08-0927124e5707"},{"claim_cluster_id":"7353e857-402f-4705-bd75-9efa4acaaedb","event_cluster_id":"6d2c68aa-e5f1-4199-8a32-52bb8d80e934"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"ddc5dfbd-77e6-466c-a4ac-12178d35c42e"},{"claim_cluster_id":"0792eb98-3885-48f3-bc43-bf2a8c746720","event_cluster_id":"88bd5511-0bcd-4336-b0a1-fbafb00aadc9"},{"claim_cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","event_cluster_id":"401a2d7b-5531-4488-bec8-d0c22a8122a3"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"ce538c96-9586-4a44-b4ec-f9e46a72b4b0"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"38f73b32-c8c6-49f9-8452-aefe0c4fa642","event_cluster_id":"1afcda67-b75d-4fbc-802a-288b7fcc1fcf"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"e8352caf-0212-486c-8732-e56619b31e7c"},{"claim_cluster_id":"38c3007b-05b7-481e-b44e-c09d28628f5e","event_cluster_id":"dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76"},{"claim_cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","event_cluster_id":"cd745d99-6d4d-4cbd-964c-839c80021692"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"7f953e81-8c8d-4f0d-9b98-873627d95104"},{"claim_cluster_id":"f3288e7a-a54c-44d1-8307-67aafb47c852","event_cluster_id":"ce5f39de-c868-4feb-8d91-20b21e8b8ded"},{"claim_cluster_id":"aa179085-85ff-43d4-ba04-8a3f88267ae8","event_cluster_id":"479e911e-126f-4188-8866-356ae46aef5b"},{"claim_cluster_id":"673d8d19-d059-4065-9b0d-82b1376c6c55","event_cluster_id":"43cf9cfc-c9db-41b9-a566-9bec2d970db4"},{"claim_cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","event_cluster_id":"7370dfbb-74ea-4d34-82b7-9398b71ecd5a"},{"claim_cluster_id":"54e59784-1db4-41f0-a651-2d5e2138670a","event_cluster_id":"722dcdeb-8c69-4fc9-878a-87c7aaade27b"},{"claim_cluster_id":"fe10e346-5245-4859-9317-c6ffae804527","event_cluster_id":"779beaba-8043-4ec4-ab6b-1cb654ad8ccd"},{"claim_cluster_id":"b473cdd9-7369-4866-a926-04d86eb03c52","event_cluster_id":"a99c031d-3fd7-4e53-9585-fd9ad40ad4d1"},{"claim_cluster_id":"e9b05837-7f42-4f2f-bc7d-dca62a93d724","event_cluster_id":"4823b0d5-067d-49e8-9415-62a09183548f"},{"claim_cluster_id":"8b198c30-0c8c-4abd-b13a-0e55963e8bb8","event_cluster_id":"367c1ab5-4267-4b68-a2ed-2893d2797c11"},{"claim_cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","event_cluster_id":"61608de3-ac5a-4b10-bba7-1b5580f57caa"},{"claim_cluster_id":"c153b607-ea7e-4a94-8f50-d29611d77fe7","event_cluster_id":"ec333963-a3e0-433d-a595-145497c56ca9"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"7fd887a5-caaf-4dd7-967d-5f621c88bae6"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"8a1337a6-24c6-4382-8169-4bec0e1a4fab"},{"claim_cluster_id":"6547f895-7ab3-43c4-b3b1-d01e17f1e888","event_cluster_id":"34aab7b4-5379-4f38-9914-ae9a14a7914c"},{"claim_cluster_id":"a1a796af-13af-4bb2-ad74-b64193c2de86","event_cluster_id":"c768dbef-cff9-45a6-9583-58c568197a94"},{"claim_cluster_id":"c6d29068-aaee-4cd5-94e1-e4e031d50401","event_cluster_id":"235b76d8-eadf-4d03-98a8-4198401ca562"},{"claim_cluster_id":"93d1eed5-3c1d-4407-adac-a9d52f51c6e8","event_cluster_id":"53ac9504-7af3-4a7a-b7c0-a75d3fd36831"},{"claim_cluster_id":"93d03ec0-ac83-451a-87b2-a95e3d58859f","event_cluster_id":"a5c724f6-7c96-401f-918f-4b43072ac6cc"},{"claim_cluster_id":"cd4aea0c-c90e-430b-95f8-4bff425c022e","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"e71ece34-2a4e-4762-87c7-693bfadf879f","event_cluster_id":"58062111-7e54-418d-9733-f5233a5838b1"},{"claim_cluster_id":"98dac116-c6f6-46b8-945d-1ffe5cc5db7d","event_cluster_id":"db91eebc-901f-4800-8b70-2d11c9945ab2"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"6c7b148b-0647-4c2a-ac9a-6341501bc035"},{"claim_cluster_id":"e126486d-8b99-4425-b6a3-54724b486b78","event_cluster_id":"93f5bdee-4d35-454b-8f1b-0b318e24a68d"},{"claim_cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","event_cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"446a7c12-73f1-49f5-944a-5a0119281e12"},{"claim_cluster_id":"300fdda9-fd92-4984-a9e6-86c9522fb6d4","event_cluster_id":"e4b34178-e71f-4443-adb8-d0d805a5c827"},{"claim_cluster_id":"1e227a80-8d1d-4484-9608-82719d3b526e","event_cluster_id":"b98bf259-2428-4cda-a309-5be4fdb0c3ef"},{"claim_cluster_id":"f46bebef-6c63-4778-a5c7-e0d7b893e969","event_cluster_id":"fc7e97b6-8dfc-454f-b469-c14bd479fe70"},{"claim_cluster_id":"eb2e33e5-165b-4a02-aa96-d53bcd386da0","event_cluster_id":"67a5aa36-56f0-43ce-bcd7-a10ff634cd7e"},{"claim_cluster_id":"9d2cc997-e857-4b80-a227-cc6a1c61d16d","event_cluster_id":"de6de235-4f06-4b1a-9079-19678104136f"},{"claim_cluster_id":"b4295bad-3940-4b00-ac2b-862c41b5597c","event_cluster_id":"b3a5dd46-4aa3-4884-9a77-ee986170d8d0"},{"claim_cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","event_cluster_id":"d6e4581d-8b56-4f44-aadb-7c57a4d3eb29"},{"claim_cluster_id":"b98bb0fa-4594-47af-9069-f482aaa8d7c4","event_cluster_id":"48704c98-ccd1-4907-aeb2-d6276a1025d7"},{"claim_cluster_id":"346f630a-2d46-4e8a-80ef-67a96ebf81ef","event_cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c"},{"claim_cluster_id":"194a083f-fee7-4bf0-b198-fa40c8bdfe21","event_cluster_id":"b6c6623b-ece7-4fbe-8627-8db59a5e3dc8"},{"claim_cluster_id":"2846d44d-8ccd-40e0-8486-7b360ffa4608","event_cluster_id":"e5391c1d-dcc6-47a7-9d8e-10697d160138"},{"claim_cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","event_cluster_id":"ebcc0902-6e47-4925-9d19-ac06d520106b"},{"claim_cluster_id":"4736fddc-4878-48ef-a211-f6b0740cc434","event_cluster_id":"044cb84d-c3b3-4798-aaea-5e325bcd65af"},{"claim_cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","event_cluster_id":"0d8dd84c-b6a6-4b66-80f5-c84acd03da41"},{"claim_cluster_id":"d81a20c0-6869-45f5-b75d-d3dcf313d9ed","event_cluster_id":"178a55a6-f879-45f8-85be-38fbb568a251"},{"claim_cluster_id":"bd06a127-0f18-48fa-b6d0-ff607d111775","event_cluster_id":"4b5a21e3-57c3-4239-8ed1-85b9925a8673"},{"claim_cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","event_cluster_id":"ea70a7dd-0151-4733-b8dd-c6143a306c66"},{"claim_cluster_id":"9dae5050-ee2d-4e3c-8dd3-b9ea85a53752","event_cluster_id":"793d367c-aa36-4def-8927-25ed78dc0d58"},{"claim_cluster_id":"16e980af-79a1-4255-8ad0-56ca61ae3b8a","event_cluster_id":"35e49ef4-8290-45fe-a6cc-bdd77af41ebf"},{"claim_cluster_id":"73a6792a-38f3-4e05-a1bc-e5dc764c0b4d","event_cluster_id":"43320422-2afc-457d-a5b5-902abc100632"},{"claim_cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","event_cluster_id":"24ff5666-c9a9-45c1-a6b9-bf154f310b8b"},{"claim_cluster_id":"4892691c-c25d-434c-bfaf-8b1764a0e393","event_cluster_id":"c84778ea-ef3a-409f-9105-f5f4a9c3f19d"},{"claim_cluster_id":"40739d2a-a8c2-4f74-ad24-d1d6db92d225","event_cluster_id":"e24b1f85-4581-4a8b-9bbd-39a7582f7249"},{"claim_cluster_id":"ff47f0b3-49ae-48d8-b9cf-5707589bed0f","event_cluster_id":"8621b776-3006-4d9b-93a8-f14394cb2f9a"},{"claim_cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","event_cluster_id":"ef77006d-68d7-4c27-ae83-cb85890ca2b1"},{"claim_cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","event_cluster_id":"d882f953-ff9f-4410-820f-ffce8c5ec321"},{"claim_cluster_id":"4736fddc-4878-48ef-a211-f6b0740cc434","event_cluster_id":"95efba0b-bc1c-48bf-8e7f-8321983dc081"},{"claim_cluster_id":"d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc","event_cluster_id":"8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"},{"claim_cluster_id":"68d51d93-fcbe-411f-8a89-cb79bd347512","event_cluster_id":"e550706a-507b-4244-b8a2-1df630cff9aa"},{"claim_cluster_id":"89c49eca-c41a-43b9-88d5-85536edafaa8","event_cluster_id":"99785983-351c-4201-b7c5-88255cfce2ce"},{"claim_cluster_id":"8f2a4264-d263-4757-889e-c18e3e101875","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"af144d2c-f8aa-40f2-9250-f41cd71f8fd9","event_cluster_id":"28b18897-b522-4746-b010-473d38b5a261"},{"claim_cluster_id":"67bef4c5-afcc-4a65-9538-ce302f965385","event_cluster_id":"ed8ee9d8-3361-4c66-86fb-3b0c6210300d"},{"claim_cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","event_cluster_id":"af90686d-77e8-4713-873e-8c63e5dbe370"},{"claim_cluster_id":"2c61e4c1-c73f-4292-be06-e4f072faf26c","event_cluster_id":"94df14e2-7e46-450f-90de-ca92085eab78"},{"claim_cluster_id":"fdb63c1f-d931-4ed0-b2b4-c60113cb73c4","event_cluster_id":"d013c87c-7dd2-4021-97c9-a4069e2ad7f2"},{"claim_cluster_id":"8c61663d-a5f4-43e3-9ca6-42de906f614c","event_cluster_id":"b366766f-15ce-4857-abc5-dda97885eda4"},{"claim_cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","event_cluster_id":"d169380d-3c63-4800-8f8c-5deedf749ffe"},{"claim_cluster_id":"93eceb5b-454d-4e3d-b632-57c5588aea34","event_cluster_id":"b6c2d87e-7d9e-4ac3-a24f-6f394e994f13"},{"claim_cluster_id":"aaa5b32a-96ba-4450-b886-70f714b65bf2","event_cluster_id":"ea73cbad-05bd-4c4c-8cae-169119be8355"},{"claim_cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"8ae7ec4c-38f4-4117-962e-b6f044038377","event_cluster_id":"11c149bd-c47a-4b6a-887d-8baf2ffc4481"},{"claim_cluster_id":"cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb","event_cluster_id":"02036fb0-ba58-45fa-b4ad-534e30796546"},{"claim_cluster_id":"d61fc1c9-1533-4eaf-88f3-8d0340ce2de0","event_cluster_id":"c355c9c0-a133-4a94-b40c-10d91addc7eb"},{"claim_cluster_id":"a15b31ed-89e7-4c30-9559-8eac356b32e1","event_cluster_id":"f0a2a4b5-aeb4-45ae-835f-525f0fd65d67"},{"claim_cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"9af9ad02-7803-4d3d-9d58-fdfc300bef96","event_cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67"},{"claim_cluster_id":"7353e857-402f-4705-bd75-9efa4acaaedb","event_cluster_id":"8cceec53-f974-47da-b9c4-5af02c151d1d"},{"claim_cluster_id":"9562ace0-b924-497a-a3ab-5d483c835c5a","event_cluster_id":"5f674ba0-ccc9-4a42-8c81-55a71cb30d68"},{"claim_cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","event_cluster_id":"3594d516-c429-465e-9ac8-b4d9801acd0d"},{"claim_cluster_id":"7b0fb73a-9488-43a9-80ee-d1864bcbae49","event_cluster_id":"51648166-6ec3-46d9-a3d1-905adbb2ede9"},{"claim_cluster_id":"99df608a-defa-4cea-b8ef-86519fa0e08a","event_cluster_id":"d9f5ad2b-430e-4145-acd5-2d92262e0952"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"4fc147e3-0b67-422d-b442-9aed1bd9ffee"},{"claim_cluster_id":"a0aafb48-1cc4-47f3-9cc7-073b87c64efc","event_cluster_id":"a1c1162e-c36a-46e0-95af-7c5c08d5e6ff"},{"claim_cluster_id":"0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35","event_cluster_id":"1abde06f-fea9-40fc-b58c-ddb744004d48"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"6cadfbb6-c995-4a61-9bf9-357705f879c1"},{"claim_cluster_id":"4a05fcea-c8cb-4b88-bb80-cab978e72560","event_cluster_id":"29696d33-676a-411b-9f2f-5aad8a647ed0"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"114c895c-17f1-417b-8a4e-f626b06562d8"},{"claim_cluster_id":"cdb08998-bbe0-4530-9534-7744fb962961","event_cluster_id":"aeb7fb87-5c7f-4917-b661-3fe948376ad9"},{"claim_cluster_id":"ec67de7a-3e2b-4e45-9df6-6bb76aa7ed80","event_cluster_id":"5eaafca6-4075-4128-8780-266e84f06a62"},{"claim_cluster_id":"a2f18fa4-3554-4400-be7d-a33cb07dfa44","event_cluster_id":"c178db65-d340-471f-b632-8b8dad1a5b51"},{"claim_cluster_id":"976d7c8a-cb17-41e5-9407-5cd8c141bb84","event_cluster_id":"3ea2f80e-f4b6-4835-b337-64fb3587f6b9"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"e6120475-8d62-4b1d-84b3-4c53f22ff855"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"1d8a91a4-e2e3-49c2-838b-462dda682ab0","event_cluster_id":"92fc4500-350f-4d12-9690-7e529074f891"},{"claim_cluster_id":"f58e8498-102b-4b72-96b4-c6d5b3fb97a9","event_cluster_id":"693353d7-9dc6-4a72-be1a-08fb1957eb6c"},{"claim_cluster_id":"c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a","event_cluster_id":"a16d38f8-25ac-46b8-94d9-38eb77cacdcf"},{"claim_cluster_id":"4770d222-ba7d-4bbe-8acd-294b0fe141f8","event_cluster_id":"ccd75d9c-f680-4c7d-a6c6-f684f0c4b09f"},{"claim_cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"d8b92399-bf69-4b82-b461-678acbb7e385","event_cluster_id":"cb346877-50ff-42c0-97e6-7abb95523efb"},{"claim_cluster_id":"a4400c47-658a-4ca0-9b29-fa8384838731","event_cluster_id":"c367dcdd-b30e-4731-8d62-e633357c9a70"},{"claim_cluster_id":"dcadf3a6-188b-4a08-881c-e1acb19f186a","event_cluster_id":"8b23f6cd-4b58-4e69-9587-6944141b8e4e"},{"claim_cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","event_cluster_id":"75482488-ef21-4630-bf12-4747cdb69136"},{"claim_cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","event_cluster_id":"63114462-4942-4f84-9437-7c2bd611b2f3"},{"claim_cluster_id":"fdae240e-8bc7-467c-b880-f3913e28e6ce","event_cluster_id":"10f7e4c6-143d-4ada-adc6-a0d81c4f5272"},{"claim_cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","event_cluster_id":"5d455dbc-1091-4f62-8c3e-fdf2d7c2080e"},{"claim_cluster_id":"a03aac32-b760-4f2a-8ae0-1194424402ab","event_cluster_id":"2f690c44-ca18-4a31-a2b5-68ac60208360"},{"claim_cluster_id":"8d565c91-b887-465d-a08e-aff09b1e9e5b","event_cluster_id":"bb551e75-48fa-42c3-a108-cb4b1462b529"},{"claim_cluster_id":"0649ea17-dc60-458b-988f-5fb62bfa7199","event_cluster_id":"309e6017-5ba6-4aa5-918a-e978302b6d2d"},{"claim_cluster_id":"c438220c-6784-49f7-a890-f0ef46c3304b","event_cluster_id":"b2825dcc-d8ef-4d2e-bf5e-a9bc43fa0aaa"},{"claim_cluster_id":"6d2143f7-a494-4413-af4e-40c695a4a5e3","event_cluster_id":"da81244a-ef78-429d-9f3d-b08a5c21a084"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"c53a9c23-c3a5-4b85-9f93-40e51b50505c"},{"claim_cluster_id":"e4ac4a3c-288d-4beb-9f3a-d8f26ff2f9c7","event_cluster_id":"ee253c9f-7d80-4f50-99f1-722670916f95"},{"claim_cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"07b6bde9-eeca-4fea-b3c2-39093320ea05","event_cluster_id":"f083dfd3-1f0b-4469-b557-e14ab47deef4"},{"claim_cluster_id":"3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1","event_cluster_id":"11663b2b-28c7-494e-973e-2fc5dca8374b"},{"claim_cluster_id":"7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd","event_cluster_id":"3304ef73-a023-4ec9-bf07-27f713496a6e"},{"claim_cluster_id":"fb518ec1-f92f-4616-8a47-9c0563a7f0fa","event_cluster_id":"b02a0b69-fccb-4794-8e75-23dec5c20147"},{"claim_cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"a92df9a8-beac-475c-a620-574a5351def4","event_cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"},{"claim_cluster_id":"b4de3a2a-395f-4d49-9f4e-abbd190c57b5","event_cluster_id":"6e905ee5-7953-41bc-bbb1-d9109f51ccff"},{"claim_cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","event_cluster_id":"eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba"},{"claim_cluster_id":"2f4a7179-3f3f-4eb6-8891-8b8d39467620","event_cluster_id":"d46df71d-8407-4df2-8b9c-164a3f2cc00f"},{"claim_cluster_id":"7e4a12f6-fe24-48f6-993c-d7197eb9c44e","event_cluster_id":"1b781e70-c91d-4aef-8e8b-426c2c695555"},{"claim_cluster_id":"101b3e01-9e80-483b-82e6-39667fb77d18","event_cluster_id":"efecc9d7-3e88-45ed-b11f-77af1e65000e"},{"claim_cluster_id":"7e98dc53-abf7-4bf8-8ac7-3c9623f6d068","event_cluster_id":"2c62c383-cda1-4d02-9286-63fc5fe04c15"},{"claim_cluster_id":"20d6183f-1c47-41c9-bd8d-d5a8b68eff2e","event_cluster_id":"b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"},{"claim_cluster_id":"58655fd4-e92f-4f77-b848-bd4849b75655","event_cluster_id":"3c7a34af-192b-4878-baca-1d31c499b7da"},{"claim_cluster_id":"f2363c7c-72d1-4e3a-b724-27c1d218c5fc","event_cluster_id":"9d8ee527-fdd4-4b2b-bd2c-0ad4ce6caf15"},{"claim_cluster_id":"29e9fc0f-b1d3-428d-985b-aead08ce4e3c","event_cluster_id":"62318edf-fc49-441d-85dd-789c9859f09c"},{"claim_cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"9aca5dda-f273-4941-9e97-91832c08621e","event_cluster_id":"9bc46e61-887b-42f5-8f08-16b384ac7b26"},{"claim_cluster_id":"de700722-a9e2-4659-a181-3fb83efdd41f","event_cluster_id":"e10e77d8-6d39-499c-97ff-017e9cdbf650"},{"claim_cluster_id":"735fb4c9-5d71-4b3e-b247-9bafaa632b98","event_cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"827f6b49-228f-4d42-afa2-d86a5b588a72"},{"claim_cluster_id":"262772f6-e21d-4ca8-a80f-06c1518ea90e","event_cluster_id":"f5211fb7-fcad-4978-ad00-c77df1404c5e"},{"claim_cluster_id":"5521d112-0a05-4e5a-881c-de705171fc9a","event_cluster_id":"a13ff8f2-81e7-4186-a169-3843a9ddc359"},{"claim_cluster_id":"3b17ca99-a0cf-4b4c-a71f-c0181125d3ce","event_cluster_id":"4ea67e25-b76d-482e-ba32-1243cadbf594"},{"claim_cluster_id":"c56c08cf-6265-4f43-9208-61aa17304ed8","event_cluster_id":"c9770c33-6591-4102-923f-7ca010384410"},{"claim_cluster_id":"290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45","event_cluster_id":"1e88b8f2-56ce-4d36-b086-ab1c91d0ff73"},{"claim_cluster_id":"bf01755f-02c0-4092-8a9f-ea50ff0a213d","event_cluster_id":"65ce1b56-2de9-4e86-a4bc-a0777c097c60"},{"claim_cluster_id":"818b32ce-b83e-40a4-b06b-dd4e2c09af00","event_cluster_id":"3bf8a3ce-dee2-499e-bfb9-1c559ad0291c"},{"claim_cluster_id":"f6541b8c-4e86-4aff-8593-e4f14f2ecc27","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"a031766e-aaad-4e78-b0e4-bd1cf2fc1a66","event_cluster_id":"bb78b3cf-3fee-4d7e-b532-1ccb52ef3013"},{"claim_cluster_id":"be29b74d-f560-4279-9339-cf00d4dac2b0","event_cluster_id":"9b558396-1afa-47bd-8065-f4f35e900fa5"},{"claim_cluster_id":"e0a9ff6c-3760-4c9a-a79f-78340ef165ed","event_cluster_id":"6d58a40e-4432-43bc-9a0f-20467f608aca"},{"claim_cluster_id":"5518570b-ceeb-400e-8720-a531292d57ce","event_cluster_id":"0ba56805-c27f-4d6b-bb0f-6903b4c54c1a"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"c5ac1407-521f-4465-8124-83f30e719068"},{"claim_cluster_id":"2ed3c98f-2c08-4da6-97f9-38e8a951f08e","event_cluster_id":"b243dfe5-ad7c-4377-9402-0fc9aefe73cc"},{"claim_cluster_id":"07438861-a868-47ed-8a1a-288138dc65c0","event_cluster_id":"e30d6b86-658d-4082-9c3e-5cf88f347945"},{"claim_cluster_id":"03b72068-02c5-403e-b844-88e40b030a18","event_cluster_id":"185df82d-71c3-4fa5-ab56-a142dce4a50f"},{"claim_cluster_id":"ee1d7c5b-4d98-426c-bf43-b5350f89e9dc","event_cluster_id":"c4fe585b-23d9-4a10-a6b1-a3c43c70fda5"},{"claim_cluster_id":"6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5","event_cluster_id":"59c32196-c345-4e2c-9ab5-46cd4d040be1"},{"claim_cluster_id":"41b1a4cf-dc12-4277-ac68-40ba76c05f8c","event_cluster_id":"02eef8bd-0b3d-4ee2-ac5e-9d2a9e96e5e4"},{"claim_cluster_id":"88a5288e-7f93-4e9a-8960-db23a08024fc","event_cluster_id":"b9239d36-ef30-4a43-92f9-8fe391efcc3e"},{"claim_cluster_id":"a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0","event_cluster_id":"20dbcfed-6463-4ba7-98e9-93b565b2719b"},{"claim_cluster_id":"8b93bbca-8559-4acc-9d3e-382347cd5269","event_cluster_id":"b7612309-cc53-44f3-9740-76cdf065b6eb"},{"claim_cluster_id":"35d18d7f-0f7d-4654-8e65-f6b4bcac032a","event_cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4"},{"claim_cluster_id":"7e98dc53-abf7-4bf8-8ac7-3c9623f6d068","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"4a2e9d4b-d2bf-4512-a149-283851028578","event_cluster_id":"4a075bc4-4bea-4ec1-8783-33d17452523a"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"49883883-56ad-4f95-b0d0-b90bb6b04064"},{"claim_cluster_id":"1ef5190b-3eed-45b4-b04e-14655cb38618","event_cluster_id":"6c30eaa7-fa21-463e-8143-13ed2522dbff"},{"claim_cluster_id":"d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","event_cluster_id":"71624d95-aa07-4fb2-8217-706e01ae4a63"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"3c4b8a98-54ef-4e72-a175-6c00ff85db75","event_cluster_id":"6207c1fd-d86c-4598-b9ed-72232636a976"},{"claim_cluster_id":"b8299ae1-9e2e-465d-af82-b9354f3e9c44","event_cluster_id":"1bfa372d-748e-4dfa-a2d8-05a78385d36f"},{"claim_cluster_id":"baa116d7-3e4a-4d22-809b-fdab138f8d83","event_cluster_id":"920d6e80-3d5e-4fd9-ac7b-57d21a7433b5"},{"claim_cluster_id":"6832730a-f3c3-49e8-8c1f-45ff7dac590c","event_cluster_id":"062e5bd8-abe2-403a-b6a1-7c176aafd049"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"f21f5e02-c7d3-439c-a7ce-450375c434a9"},{"claim_cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","event_cluster_id":"b32443a3-fa40-4637-9b55-e58ec8393ffe"},{"claim_cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","event_cluster_id":"94d152a0-b275-42d2-af1e-de4ffe6f8a22"},{"claim_cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","event_cluster_id":"621f1c2a-981d-47da-bf43-de2d73f4a594"},{"claim_cluster_id":"de4bbbfe-ba23-4e75-bdd5-72e767837661","event_cluster_id":"fb3fc0aa-b013-4537-9abd-dcd64258a72b"},{"claim_cluster_id":"9f57df89-5e8e-4a14-b028-a41d27973fb5","event_cluster_id":"1755b95e-bb0b-46e8-acd8-b7de1925ed67"},{"claim_cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","event_cluster_id":"6d9d5966-6987-45bd-9e4b-02623878d470"},{"claim_cluster_id":"f9e580f2-a45e-455c-a4fc-189d643f07ef","event_cluster_id":"4c34b512-0945-4457-90fe-e5531faf594d"},{"claim_cluster_id":"ccf91c48-303e-4d94-8263-0e8c6de64e17","event_cluster_id":"a7fc7029-8fcf-4676-9e1a-d0be462bdd41"},{"claim_cluster_id":"9fc7f408-c42c-485e-91c2-a72960ff3158","event_cluster_id":"5fee0957-a733-4e61-bf4b-0025d615e97b"},{"claim_cluster_id":"017c8345-ee2f-4b6f-8701-6def5bbd5082","event_cluster_id":"b250fbe4-52ac-446e-8f1f-52af6aaeb77c"},{"claim_cluster_id":"487393b6-56b8-4c3f-bdb3-88dbd2ac69d5","event_cluster_id":"a808e761-ea60-4cbe-9954-1bbb279e628e"},{"claim_cluster_id":"88b5488c-d8fa-4baf-af94-ea104e983a2a","event_cluster_id":"04e4f581-e2f4-41e4-90d7-172e50ff3c74"},{"claim_cluster_id":"2fc0be9d-df8b-440d-a58e-2ec4422f1712","event_cluster_id":"975e2d06-2cf2-4b51-9705-f9ba57cf3e1e"},{"claim_cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","event_cluster_id":"1acc8146-9053-485f-9f26-6af5d30d0040"},{"claim_cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","event_cluster_id":"09a67b60-49c6-4757-b8ff-5613fc63f6fe"},{"claim_cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","event_cluster_id":"fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13"},{"claim_cluster_id":"73aeb014-9fc7-4042-b2b1-7016c4fa8dd2","event_cluster_id":"6659a589-3901-4e01-8d7f-eb3e9f204a10"},{"claim_cluster_id":"8ff59597-495c-4ba5-b797-afb88f6bfce0","event_cluster_id":"b3940e35-7d56-462c-b357-ee3bc8987319"},{"claim_cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","event_cluster_id":"7a87a2e6-b475-458d-ad14-3c21326625db"},{"claim_cluster_id":"0605c233-63ed-4bdf-a0fe-665556a34a75","event_cluster_id":"ce593693-b91d-49af-acbe-d62e8f2dfd88"},{"claim_cluster_id":"d93d391c-6b51-4713-bfdb-30f405cd2357","event_cluster_id":"a0f403d2-a7ff-4e00-84e6-2783bef20b8e"},{"claim_cluster_id":"5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1","event_cluster_id":"5b07fdf4-9b41-49e1-b97c-866f63e0da14"},{"claim_cluster_id":"c7c24801-e07d-4e78-8de0-4a42e8b64272","event_cluster_id":"1754af66-54e2-4f11-bdb1-7f116f325d12"},{"claim_cluster_id":"b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4","event_cluster_id":"7c24e460-dec0-43da-b3ab-9acc84d4caeb"},{"claim_cluster_id":"e1ed1afc-85b6-4c69-a063-e486d1e3670f","event_cluster_id":"908547be-87be-4e95-b368-a0acc7033e35"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"976b0673-ef25-484d-9be8-afb6c791a214"},{"claim_cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","event_cluster_id":"83859ac4-ebe8-4ffc-91d6-38d67b7686ab"},{"claim_cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","event_cluster_id":"963c86c9-b5f1-4cd9-ac43-10cc5c0f5aa1"},{"claim_cluster_id":"c0414ded-b694-4e4a-b7f8-d2835618be1b","event_cluster_id":"1f13dc99-3c84-426e-b6fa-781deb8b786d"},{"claim_cluster_id":"95b38f6d-19e7-4fa7-a9de-ee665de84018","event_cluster_id":"ceaf3416-5958-472f-8b27-d2e81ab1489c"},{"claim_cluster_id":"d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9","event_cluster_id":"4941aadf-8564-4b71-b807-8b98a3bc3396"},{"claim_cluster_id":"aa458090-4ea3-4829-9f88-662eb71a8370","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","event_cluster_id":"c60d6252-d9ce-42b9-bf38-6fcee80b74b2"},{"claim_cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","event_cluster_id":"56a7af82-50cb-4d0f-a5ea-28ea4cda014a"},{"claim_cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","event_cluster_id":"c19838ee-ef85-408d-84a0-c28811354698"},{"claim_cluster_id":"76ba9e0c-8b5a-4b06-92f8-9ce9caa47714","event_cluster_id":"743f75a0-41d3-441e-9941-3043106cc340"},{"claim_cluster_id":"95690f3e-4515-4810-858c-28b7d1da49a5","event_cluster_id":"41d3a2f3-d7a3-4115-95f4-0cf0a84449a0"},{"claim_cluster_id":"ed50b251-f205-4952-987b-aed1c0461840","event_cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a"},{"claim_cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","event_cluster_id":"c0ac6691-abf2-4873-a338-41a4997bcb24"},{"claim_cluster_id":"ccd217d6-af54-4ddb-bc5c-7413749df148","event_cluster_id":"52dfdf47-104c-4ec5-bdb3-4d6a07a83d5c"},{"claim_cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","event_cluster_id":"a04d6dcd-d345-4928-a6be-52f446062bc1"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"b3cc2793-d201-47e1-8b0f-b8bc6fd1bbe4","event_cluster_id":"b7f11387-382d-4aee-bfa5-1f8b22da06c2"},{"claim_cluster_id":"88b5488c-d8fa-4baf-af94-ea104e983a2a","event_cluster_id":"5e11f88d-24a6-418c-854d-c6d0fb898c80"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"c0414ded-b694-4e4a-b7f8-d2835618be1b","event_cluster_id":"0621c61e-ad6e-41cd-8ff0-a60a7aa48a28"},{"claim_cluster_id":"7e979f93-4ad2-4933-833d-edddb9f37e0b","event_cluster_id":"9add2c84-55b8-4f75-bec3-d9a47e379ce8"},{"claim_cluster_id":"dde1cfea-875f-4bd7-a73a-639065b04c0c","event_cluster_id":"da41eb4a-56e1-401f-8c36-73d853bb3de7"},{"claim_cluster_id":"f597184d-050f-4a51-9461-70b55cf2b05c","event_cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87"},{"claim_cluster_id":"9ba4f992-6e11-40b2-8501-4e04321822e6","event_cluster_id":"4f77ad08-1df2-43ea-b042-db804953dbcf"},{"claim_cluster_id":"2846d44d-8ccd-40e0-8486-7b360ffa4608","event_cluster_id":"ba69550c-4232-407b-a518-7595f5dc57c8"},{"claim_cluster_id":"68357dc5-3396-4365-90bb-f3b36dcbd7e4","event_cluster_id":"791db8c8-66c8-425a-80e1-d5e8778fe4a4"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c"},{"claim_cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","event_cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"6220afcf-2f7d-4d0b-9949-c9eea0785c4f"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","event_cluster_id":"8451ff8b-752e-4535-872c-ebc9efc7b9cd"},{"claim_cluster_id":"b58aa973-7c2a-4a42-ac89-2aa7abeea2e5","event_cluster_id":"f44a9570-1523-4d3e-9b69-1e328e9b2946"},{"claim_cluster_id":"4a3bc772-20e9-4711-acc4-eb16f1a71bea","event_cluster_id":"1dd3a1e1-df59-4ade-b082-02235345034a"},{"claim_cluster_id":"59d7630c-86a6-4185-b052-67ad13c627a8","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","event_cluster_id":"f86db310-987e-41a6-a2fc-6f6bb14b7072"},{"claim_cluster_id":"5c0df4bf-ba62-40d1-a306-8313dfe790e6","event_cluster_id":"1dfcd0b1-4fc7-4be1-9e3b-b39ce16325cb"},{"claim_cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","event_cluster_id":"a5da6c97-e954-417b-b043-c6eda504cf34"},{"claim_cluster_id":"f9e580f2-a45e-455c-a4fc-189d643f07ef","event_cluster_id":"e113cbe4-9797-46e8-ab87-8e31da3f22de"},{"claim_cluster_id":"9ca308d7-59f5-4df0-a87b-383b8575c88a","event_cluster_id":"41c769d8-9945-446f-ae71-144928242d0e"},{"claim_cluster_id":"96a4146b-b919-413a-b5a7-7801adae1906","event_cluster_id":"61f48759-d4cb-40cb-8dc9-13b564dd8c1b"},{"claim_cluster_id":"6cade303-8a3e-4226-b5e8-0d3b189187cb","event_cluster_id":"67731679-09bb-4b58-92bb-6990e6c5fa20"},{"claim_cluster_id":"51f92102-4c83-4bf3-8e2d-cf88f9368a7f","event_cluster_id":"0e12a592-3820-4db2-a037-30590707df57"},{"claim_cluster_id":"71755eb8-e7df-4bfc-b448-f56fe2b8b242","event_cluster_id":"cc9b53cb-83c0-4db5-a0d0-5708d4af2a1e"},{"claim_cluster_id":"17036568-8b0d-4108-9a16-98a16980ae3f","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"64c8d619-fdbf-4e87-a23c-9bfa4369bc15"},{"claim_cluster_id":"dfe5555f-7179-45b9-9f7a-919fa1cc1569","event_cluster_id":"b627252e-5ed6-4562-833d-dbc3b3ef2c2f"},{"claim_cluster_id":"5c0df4bf-ba62-40d1-a306-8313dfe790e6","event_cluster_id":"c75b3de8-57fe-4dc6-8aeb-f6022f783cc3"},{"claim_cluster_id":"8e7a25f4-c25d-43c4-890a-4d8d8364c5bf","event_cluster_id":"dcc8df2e-a077-47fc-8960-d90fac2ea1d8"},{"claim_cluster_id":"40a361aa-d57e-4e3c-9740-34505f34913c","event_cluster_id":"f49b5f7f-d1d1-43b6-ba5c-a712f59a657a"},{"claim_cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","event_cluster_id":"4f70ac27-41cb-48d8-871e-5b61b1c5a657"},{"claim_cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","event_cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a"},{"claim_cluster_id":"6019fc4d-e3c3-4367-8970-ef89e2860014","event_cluster_id":"95421986-cc6a-44ab-acd6-4d39bccc24ca"},{"claim_cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","event_cluster_id":"47332eaf-fc3b-42ad-bec7-2e81a4ab08e7"},{"claim_cluster_id":"6ac8924b-24d0-446a-8ffc-cf862b415737","event_cluster_id":"fd30a023-a95b-44f7-ae05-f93dd9a3dd06"},{"claim_cluster_id":"baef4ffa-45e6-4649-9ab7-8c1b3621d2d6","event_cluster_id":"23adce5a-77c2-4c07-98b6-ac6909360e17"},{"claim_cluster_id":"b44cd59b-4971-4182-8766-9ffcf4ae83ce","event_cluster_id":"ab906a52-8ac1-4094-852d-28e22d75048c"},{"claim_cluster_id":"a2a57731-90ff-4a12-a08f-721a9dfc0b06","event_cluster_id":"85060527-feb7-4312-ad1a-ebd52c170e8b"},{"claim_cluster_id":"80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921","event_cluster_id":"c44f1953-a41f-47e0-ba2d-7e2e1a5e8ffd"},{"claim_cluster_id":"4f0d57c0-3de2-45f7-85a5-01cd50cac457","event_cluster_id":"20bc1b1d-621a-4c85-b194-0b79b56d7c82"},{"claim_cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","event_cluster_id":"c4b95ac5-8bd7-40cd-a7c2-2a05463c8dc3"},{"claim_cluster_id":"a92d1a1e-f967-4044-9d5c-136fd4264137","event_cluster_id":"baac9deb-4b05-423b-be76-a9a8e41c6cea"},{"claim_cluster_id":"5dac5b6d-e9df-41db-9225-7e413ca3cacb","event_cluster_id":"46d65520-43a8-4278-8ef5-8956356cec61"},{"claim_cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","event_cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87"},{"claim_cluster_id":"84a0c048-8b19-4f73-b588-caa191d08d54","event_cluster_id":"a327718c-a538-4929-8a9a-932fc2ef4a9a"},{"claim_cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","event_cluster_id":"6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8"},{"claim_cluster_id":"dfe5555f-7179-45b9-9f7a-919fa1cc1569","event_cluster_id":"91237aa3-bf57-4535-84ed-6b39c0f1b3fc"},{"claim_cluster_id":"b213b3ba-db75-4c42-89bd-97de55c18b3e","event_cluster_id":"ab894abd-2889-40e1-91c4-3fbdf2be7626"},{"claim_cluster_id":"009e9d6b-ab96-416d-b96e-b7eaada086cf","event_cluster_id":"f996f072-3b37-4e7f-900c-1cc05e40fa72"},{"claim_cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","event_cluster_id":"55bf2e02-8b8e-4a6c-b132-fd70d3faa280"},{"claim_cluster_id":"253e2fef-8100-4235-899c-96e9877535d1","event_cluster_id":"632f52ad-dbbd-4d7f-af13-93bbeaa37163"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"a41257e1-1e51-49b3-bf04-5fbb3ef2f25b"},{"claim_cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","event_cluster_id":"f2c3cbb3-1d32-4569-9d6e-97148e1d73ef"},{"claim_cluster_id":"970c1f51-0eea-45a8-842e-874c83ffa389","event_cluster_id":"6d2a3a04-ff69-40ca-9d0c-a4d79e8318bd"},{"claim_cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","event_cluster_id":"84d8eefe-324c-44a5-b6d1-c374c46cc323"},{"claim_cluster_id":"7e4a12f6-fe24-48f6-993c-d7197eb9c44e","event_cluster_id":"0a39d2f3-be07-4455-859e-2055e083eec6"},{"claim_cluster_id":"3c1f9759-2361-48c2-bc4a-c58a3d11b76f","event_cluster_id":"58f3dc82-7967-4488-b9f2-9a804334fb7a"},{"claim_cluster_id":"d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9","event_cluster_id":"465bda3c-33ed-4e06-86ec-cc6c1d50e27d"},{"claim_cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","event_cluster_id":"ceb2f368-5934-45f6-bda4-01a19f923b7e"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"53d674a1-75eb-4a57-96a7-960a78dc2faf"},{"claim_cluster_id":"1e13a15e-d3c1-4581-b460-13b01ca9aa54","event_cluster_id":"7c8be876-c0d6-46b2-8e28-be16ba79de4f"},{"claim_cluster_id":"bd9462e2-36b0-48f7-92f9-c83dd2ee5550","event_cluster_id":"edcb6d77-94bd-47fa-ac30-bd310a6e83e6"},{"claim_cluster_id":"791c0550-4877-4364-97d4-01b5b8435b0f","event_cluster_id":"afb76d5a-b98d-4292-ba1f-8d4ecc4a368a"},{"claim_cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","event_cluster_id":"d0699d4c-25e1-439a-a44a-9bca30bebb35"},{"claim_cluster_id":"481f70cc-e9a5-439c-8065-a4dc8e63bd0b","event_cluster_id":"e9e815cd-7183-4b06-a964-9cfc2d25bfab"},{"claim_cluster_id":"6663d8fb-8d11-459b-85ff-7054f5d07b06","event_cluster_id":"e113cbe4-9797-46e8-ab87-8e31da3f22de"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"e30d449c-eb81-4d62-9149-9437a1a2c593"},{"claim_cluster_id":"0ea60366-ef97-44ac-91be-b38d55efb0c3","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"0a27f80b-b648-4764-8688-fd889dc32a39","event_cluster_id":"07db44cf-3ab0-45c7-b71b-6366e225a76c"},{"claim_cluster_id":"a63004c7-9e1f-4600-bae4-f70655f0094e","event_cluster_id":"1961443c-3bca-4540-a19e-508d4a0fa916"},{"claim_cluster_id":"7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1","event_cluster_id":"3c077d24-2d6b-4d5c-a441-5e0080a81669"},{"claim_cluster_id":"ab1f8fac-3632-4188-90ae-a2c911b8425d","event_cluster_id":"cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1"},{"claim_cluster_id":"02c9b472-905f-4c41-8570-811b8d821196","event_cluster_id":"9c08b4e1-94e3-4cf2-b505-4d6b5137534f"},{"claim_cluster_id":"bbf49577-7eda-4f96-83ed-753d3b9cc708","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"18f586c2-7862-4f1e-9fbe-94bf4981c3c4","event_cluster_id":"b8e61f96-24fd-4f99-870f-bc308a6c4198"},{"claim_cluster_id":"7dc48717-c562-4f7c-bcb3-b4a13374cc42","event_cluster_id":"414991c8-a3c9-4951-a5c6-7c03fe71ba09"},{"claim_cluster_id":"fcb57169-c911-45f8-98e1-10aa6c573c38","event_cluster_id":"eb814822-d982-4fcd-a462-4fccf70598c6"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"f0764df3-3340-4405-ac6d-daef15a6934d"},{"claim_cluster_id":"5e7e70f4-b130-467a-9df9-f6078877ed61","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"fb3fc0aa-b013-4537-9abd-dcd64258a72b"},{"claim_cluster_id":"e35fb8e9-42cf-4ef0-a512-d7be06ad99e3","event_cluster_id":"f16a1de1-a4da-445c-ac5b-035b9edb7fc3"},{"claim_cluster_id":"6f3f0719-064d-478a-ae5f-d9aca0368d4e","event_cluster_id":"0e248889-43a9-4087-a6b0-f1d7854daf2c"},{"claim_cluster_id":"6a65158f-b873-42cb-b0bd-0cb1b60a0d86","event_cluster_id":"6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"},{"claim_cluster_id":"c155f6c2-50ad-4998-b29d-ef85effa1839","event_cluster_id":"06512aa8-6f14-4dbc-8b0f-4ea2e772ba31"},{"claim_cluster_id":"da4807bf-cc54-48c7-b3ca-69cd854da837","event_cluster_id":"dec5b760-e9f3-4528-b5d8-c2638f4598ab"},{"claim_cluster_id":"14b46c0a-7b16-4722-b599-90d7d69970a1","event_cluster_id":"d7761b4c-72e0-44cd-b341-d16d8d7d63d7"},{"claim_cluster_id":"947a0b8b-01e0-44c9-8ebc-c9da3eecde20","event_cluster_id":"cba3863d-9ffc-4647-831b-d4da84c689e3"},{"claim_cluster_id":"2f3c2293-d820-4cb3-836f-6df8faee07a8","event_cluster_id":"3dfdc081-40e4-4a34-81ac-79b539cfc98e"},{"claim_cluster_id":"8610b5a0-f4b4-403e-94e5-57543da5eb32","event_cluster_id":"6f48a68c-7726-4316-a5e6-f406ee7e1e95"},{"claim_cluster_id":"35ee8064-f9ff-4496-b4db-ba79f7f24de2","event_cluster_id":"2bacbc25-5943-4519-8b3a-2027cce6b51b"},{"claim_cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","event_cluster_id":"63114462-4942-4f84-9437-7c2bd611b2f3"},{"claim_cluster_id":"cb25f623-bfdb-42c7-9873-fa48f80feade","event_cluster_id":"9766dff3-64a6-4901-a68a-2702c328c3ac"},{"claim_cluster_id":"43b3601d-6d6e-43a4-8cdc-72cf4aa80640","event_cluster_id":"1a1de2a4-159f-4a0d-8a46-97165bf27583"},{"claim_cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","event_cluster_id":"07a40f3e-ce43-455d-8cb0-e9110e244817"},{"claim_cluster_id":"1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254","event_cluster_id":"0c50a72f-e964-4690-a33f-e878b2e74702"},{"claim_cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","event_cluster_id":"bcc8a49a-201a-439b-bf04-a72b13e50b57"},{"claim_cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","event_cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49"},{"claim_cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","event_cluster_id":"dffdac1b-ba6f-48b2-97f4-02cb8656a37e"},{"claim_cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","event_cluster_id":"af07ce28-0024-41ac-b51c-01e4bbf2c507"},{"claim_cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","event_cluster_id":"d2b6a98f-1634-4f3b-a41d-9b64375eff6e"},{"claim_cluster_id":"41683dea-1259-4e44-9283-e6286d675c48","event_cluster_id":"2dda2c1f-f0ae-49cc-b0e1-89a7a1ccbeaf"},{"claim_cluster_id":"2b3c747b-9f75-4697-a22b-426999d9c671","event_cluster_id":"12d14e7e-4e0e-4f5f-8c1e-b4a56335bf02"},{"claim_cluster_id":"dcbf5711-b1d2-4a7c-96f6-e8916f52c752","event_cluster_id":"02063354-1cf2-4e4e-a749-ce91914994ae"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"8a222396-efb3-4d74-bc35-db09fb52168f"},{"claim_cluster_id":"3c4b8a98-54ef-4e72-a175-6c00ff85db75","event_cluster_id":"3092d2a7-23cc-41c3-b8bd-3096963a1b79"},{"claim_cluster_id":"09e579b4-c608-4bc3-a02e-890bc6f5969d","event_cluster_id":"0dde3660-e0d6-4644-aa81-6e184dc6e068"},{"claim_cluster_id":"70b49961-b72f-4a9a-bed7-51b09a9f1ec7","event_cluster_id":"1b496ec2-f55a-4ab3-bead-1b1953daed07"},{"claim_cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"f37c17ce-c0f0-4c37-a425-7857fc4bf5bd"},{"claim_cluster_id":"9dae5050-ee2d-4e3c-8dd3-b9ea85a53752","event_cluster_id":"24f4b8ea-3738-41ba-bfa8-f9286f4d2dc5"},{"claim_cluster_id":"2996196c-7b75-44d2-aa5b-560b18ce2763","event_cluster_id":"56a71fc3-1754-4e95-b0fd-27485ee352e9"},{"claim_cluster_id":"e632bc78-90b4-46bf-a31b-df8259ac6d90","event_cluster_id":"a174fdfb-5e90-4340-85c5-f1498bd04f82"},{"claim_cluster_id":"637d133e-6c19-4fa2-b174-de1d016bd9bc","event_cluster_id":"7a87a2e6-b475-458d-ad14-3c21326625db"},{"claim_cluster_id":"09f8ca5f-e359-4e32-b6bf-f706de588232","event_cluster_id":"b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"},{"claim_cluster_id":"efb94acb-755c-41bd-b1f3-cb170deb0266","event_cluster_id":"57759056-0fd7-4dee-8b4f-b560736eb4f0"},{"claim_cluster_id":"06af9b74-e018-4919-8256-29acfecc76d7","event_cluster_id":"14b94d56-73bd-4f9f-9a3d-89c9827b210d"},{"claim_cluster_id":"dfd9bb6d-a08b-428d-8e19-e9eebd219088","event_cluster_id":"df416ca2-a7ac-4dad-9783-c3e29d3f4084"},{"claim_cluster_id":"666eb0cd-c596-43b7-a4bb-b7f35efd20da","event_cluster_id":"54ebfb05-46bf-4d56-ade3-1d656b85cfb2"},{"claim_cluster_id":"30011e47-1ff9-409e-8099-2eff6ab89e88","event_cluster_id":"0b6f158d-8877-48ca-80e8-7a4602b55765"},{"claim_cluster_id":"803c450b-2260-49a5-af48-6296f17fca97","event_cluster_id":"49e46347-a3d3-4b80-a516-3dc4bfcbd3b7"},{"claim_cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","event_cluster_id":"30d502a9-a0ce-4646-9e1c-b03b47f8dd5b"},{"claim_cluster_id":"9621dd39-ccb5-4e12-9287-8a404c57bba0","event_cluster_id":"5af9294b-b226-4926-b1d8-cd8badc5e35b"},{"claim_cluster_id":"a74a2d72-1d86-4264-9389-b4fe594a7218","event_cluster_id":"45aa87a3-e21a-4aa8-8a63-439b67ce1a6b"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"7afd3ded-a43a-4c9d-b365-6656ecd89e6f","event_cluster_id":"f7be2595-331e-49c2-b3a3-087ec837250b"},{"claim_cluster_id":"335213da-43c0-415b-b902-6fbd946881b7","event_cluster_id":"03d03c63-2946-42c4-9a55-b127fdc45b21"},{"claim_cluster_id":"de116a88-705c-434f-9f3a-1fdabb457723","event_cluster_id":"0a78e568-4aaf-4a3c-a4c0-d484ec60f776"},{"claim_cluster_id":"596489a9-6207-48fb-8cf4-2972a01326d9","event_cluster_id":"8498dac7-1f62-4d7f-a27c-61f5ecb321c3"},{"claim_cluster_id":"e9caf6d9-2282-4c7e-9cd5-97529119edff","event_cluster_id":"ff3032ee-a77e-4fe7-a5a1-205c35f0948e"},{"claim_cluster_id":"e5b48b2a-7f34-4409-a282-031c21d5b9f9","event_cluster_id":"8059d799-8a2c-4df4-b587-415d278d1563"},{"claim_cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","event_cluster_id":"6658a062-982d-4300-bd7b-0596611a3512"},{"claim_cluster_id":"a7d034a7-5705-462b-af06-b9277d91c75a","event_cluster_id":"920bd1eb-f625-4f7e-981d-fa931240bd9e"},{"claim_cluster_id":"51f92102-4c83-4bf3-8e2d-cf88f9368a7f","event_cluster_id":"4823b0d5-067d-49e8-9415-62a09183548f"},{"claim_cluster_id":"fc93709e-88fa-4e26-963a-2d3fcd9cde24","event_cluster_id":"2760cb6d-72ed-43f8-94f6-443f59d74437"},{"claim_cluster_id":"b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d","event_cluster_id":"8628cfa7-1952-4304-94e8-eca8c125fadb"},{"claim_cluster_id":"e8b8352a-472f-4b00-9dae-87cd809f920e","event_cluster_id":"a2a4882d-9cb0-4b1a-8852-37a056ca2ca7"},{"claim_cluster_id":"a3891be3-55f1-4794-b99d-304a26e4b465","event_cluster_id":"72297da3-3cc9-4cb4-a16b-56592581749c"},{"claim_cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","event_cluster_id":"b46172e4-32c8-4e9a-a7a9-95ade2786490"},{"claim_cluster_id":"3fd55ffb-10d4-4e70-9352-8bd5b0751ffd","event_cluster_id":"1e3fd423-7c99-4849-95a3-92cb0dc03a82"},{"claim_cluster_id":"29d5756f-2c13-4cfb-b4e4-f439665752b9","event_cluster_id":"820ef425-062e-4d05-87b0-a9e96fa7de31"},{"claim_cluster_id":"f58e8498-102b-4b72-96b4-c6d5b3fb97a9","event_cluster_id":"6ad0010a-5d1b-4773-9ca4-976c212e4238"},{"claim_cluster_id":"5272bbda-d47a-4619-a956-853dc9c29d18","event_cluster_id":"03b5f25b-079d-4d84-920e-062e0a19a251"},{"claim_cluster_id":"539a56ca-1f06-469d-a675-be2a20f5e808","event_cluster_id":"280b825c-cdaa-4737-977a-cbd99f073e0b"},{"claim_cluster_id":"1993c1c6-e677-4697-9e0d-f4c2332e53fe","event_cluster_id":"0786cda2-1538-4e16-9f54-d0704127539a"},{"claim_cluster_id":"80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921","event_cluster_id":"908eb720-8ab4-48f5-a6b7-fd316c77c27a"},{"claim_cluster_id":"e3e4b634-fa33-47d8-9f29-eefdbb263769","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"af509b02-6699-4697-8018-d3a627ada0fd"},{"claim_cluster_id":"6ac8924b-24d0-446a-8ffc-cf862b415737","event_cluster_id":"9e8db3b9-526d-441d-81c7-ae6c80c59a34"},{"claim_cluster_id":"2aeb94af-8d5b-40ce-b754-91495083b2a1","event_cluster_id":"83103bb6-3126-4ae8-b437-2a2305839cc6"},{"claim_cluster_id":"eb646312-9617-4ab9-b534-22cc250a28b0","event_cluster_id":"ec93d3e9-0b7e-4779-b3cc-e888f246dd46"},{"claim_cluster_id":"d669c1ac-c710-4975-98db-1c778f28ee4c","event_cluster_id":"c9760dda-4208-40ee-a4e1-20fd95324ecd"},{"claim_cluster_id":"b473cdd9-7369-4866-a926-04d86eb03c52","event_cluster_id":"54db3169-8794-4675-bba8-d68dda1009e7"},{"claim_cluster_id":"5d2ff6eb-cad6-467b-869b-d4782bae2371","event_cluster_id":"a9a77b18-5285-4973-8fbb-79f6651b38ea"},{"claim_cluster_id":"0bb1f8c0-08c1-4f63-b6c8-052a5bad160c","event_cluster_id":"029ce0da-0ea0-4431-a895-310ff5fa4a56"},{"claim_cluster_id":"f83c19b1-e59e-4712-8a86-4c8c86ee0e2b","event_cluster_id":"4d4b5f03-b89d-479d-93c3-2c3c9a038d46"},{"claim_cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","event_cluster_id":"6ff6589f-46b8-4e3d-bfc9-65288f58e33b"},{"claim_cluster_id":"9aca5dda-f273-4941-9e97-91832c08621e","event_cluster_id":"daeaa2d2-9b6b-4a15-baa5-d0940fc45a77"},{"claim_cluster_id":"6f548f26-3ad4-4adb-80dc-c3f3104f0d7f","event_cluster_id":"270b9be6-37c3-4ab7-9763-57943d7a38b9"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee"},{"claim_cluster_id":"2a0a6106-78d5-46ad-ad52-e0296bf7134a","event_cluster_id":"4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568"},{"claim_cluster_id":"283a7466-09a4-4b67-abff-ca96f1d8ade9","event_cluster_id":"b8695913-835b-4b14-be2f-fd0c828a71a6"},{"claim_cluster_id":"ed1ca8c0-7841-4109-ada2-99053838abfe","event_cluster_id":"53c8b8a1-19e0-48b3-8c8f-f90de56c4785"},{"claim_cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","event_cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875"},{"claim_cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","event_cluster_id":"f3c363f3-4590-4428-9518-ecaf53bfcf69"},{"claim_cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","event_cluster_id":"88a95916-de94-4c29-849b-89f8018ddf03"},{"claim_cluster_id":"b0c0fbc8-3a87-4290-a45f-69e062e04cee","event_cluster_id":"19360eb5-62d9-45d5-b2f6-b66b7fee7414"},{"claim_cluster_id":"1e256780-a5db-4471-b8f2-5390a4dea1fb","event_cluster_id":"414a7988-da74-41bb-927b-725b66698cd7"},{"claim_cluster_id":"95b38f6d-19e7-4fa7-a9de-ee665de84018","event_cluster_id":"1de0370a-30b3-4cf4-8852-224e559b9061"},{"claim_cluster_id":"731ff8b9-92a5-4277-aa76-33602d261e5e","event_cluster_id":"7db7f2ba-600c-4f51-9a31-321197123c7d"},{"claim_cluster_id":"a1ac0514-0dd2-43ae-9f2d-5939e791e058","event_cluster_id":"b03fae7d-ee9e-4f46-b206-fa4dec1a6c69"},{"claim_cluster_id":"06f782f7-82f3-4b4d-a941-de5952ae3f6b","event_cluster_id":"f26edbd7-0fe4-4992-ad9b-b42b469ca47d"},{"claim_cluster_id":"f9f12741-3c28-4281-83bb-68cf30392853","event_cluster_id":"f067ac83-ba02-48cb-bb4d-1822eee31ec2"},{"claim_cluster_id":"db07f4e5-716a-41e4-989c-98ced62f8fd5","event_cluster_id":"3c9a1b13-b4b6-4090-861e-e35159e61286"},{"claim_cluster_id":"04e64305-3df2-47b4-83e6-266ff2241406","event_cluster_id":"de0d9b6c-1e5a-4ebd-af0a-cb9e36b1417c"},{"claim_cluster_id":"680a1621-579c-4ffb-aa4c-f56de5d6dfe7","event_cluster_id":"a1bd8b84-b3b2-4726-a7b0-fe007bb23321"},{"claim_cluster_id":"69517d67-11aa-4671-bb8a-815c7995a3b7","event_cluster_id":"75b0c0a9-3733-4700-8094-3d9376dffa97"},{"claim_cluster_id":"8bbb9fde-a60f-4687-9398-276e5d036952","event_cluster_id":"b1c829c5-5bbf-4809-a139-ca7f221f5d55"},{"claim_cluster_id":"7b08a98a-0129-4cec-b114-1fff26d56746","event_cluster_id":"a8b81223-8089-44d9-8780-1c910b2a64e2"},{"claim_cluster_id":"f597184d-050f-4a51-9461-70b55cf2b05c","event_cluster_id":"d895f911-9139-47dd-8018-79b66f8588dd"},{"claim_cluster_id":"2cb357c3-3958-45ce-bb44-f76facb84ed9","event_cluster_id":"5d0d552f-6139-4148-bf05-7e9c5a14274a"},{"claim_cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","event_cluster_id":"41b103ed-acbb-4350-80df-1fd2deb0346c"},{"claim_cluster_id":"5d2ff6eb-cad6-467b-869b-d4782bae2371","event_cluster_id":"5e785b56-6a28-4603-b028-fed3f12f5778"},{"claim_cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","event_cluster_id":"2d39c2e2-591e-4b57-a739-0d6203a1a49f"},{"claim_cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","event_cluster_id":"4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43"},{"claim_cluster_id":"aafb6f56-e150-4de6-8f24-4e8fe467b23f","event_cluster_id":"f71ba398-a895-4de0-a397-50ea9f685ae0"},{"claim_cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","event_cluster_id":"72084673-8080-44fd-8f5b-97507abf262b"},{"claim_cluster_id":"673d8d19-d059-4065-9b0d-82b1376c6c55","event_cluster_id":"91ce6b29-5884-4f1a-9443-ad0d26809886"},{"claim_cluster_id":"3fd55ffb-10d4-4e70-9352-8bd5b0751ffd","event_cluster_id":"50df15a2-0759-4dd5-ad88-d8f125de1938"},{"claim_cluster_id":"76e2cae3-f195-4448-9b25-588665927aca","event_cluster_id":"f75aca31-160c-495b-9583-b8cf66c2600b"},{"claim_cluster_id":"5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9","event_cluster_id":"e9cee2c7-a58e-4a2b-a37b-7da09539aea3"},{"claim_cluster_id":"93c53898-2dc6-423b-a4d6-b61dd90c6d6c","event_cluster_id":"3706e344-49f2-43a5-a708-cb9ca4fbc648"},{"claim_cluster_id":"16e38b6b-7241-4f9f-8554-c33f05a6edb7","event_cluster_id":"4a618a75-71e5-4836-8396-68e00d05b814"},{"claim_cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"990306d6-263b-4984-88f5-4be9fc326334","event_cluster_id":"6e37aa31-587a-4adf-8952-da7c9df371fd"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"41b103ed-acbb-4350-80df-1fd2deb0346c"},{"claim_cluster_id":"4f28eb95-dbc1-4a88-9ad2-cd53edd38fd5","event_cluster_id":"e0c47150-6ad9-45b1-bceb-7ca3ac1805f1"},{"claim_cluster_id":"095169c0-0ce4-4362-b29d-486ce7d2b848","event_cluster_id":"81215e4f-490f-4619-8a72-2aa513e8e164"},{"claim_cluster_id":"1b257e2e-69fd-4bc5-b57c-e7f5b2178161","event_cluster_id":"31e15131-0797-4dd4-9297-5c40959ea3ba"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"af40ab83-4c48-4ac1-af3a-242491a35af4"},{"claim_cluster_id":"d012c47c-3d49-4f8a-9fcf-db101ff82249","event_cluster_id":"825bdd3b-f63b-4beb-b324-b276b6d235f7"},{"claim_cluster_id":"3356bac0-8ec4-475b-81a7-e146187a74ba","event_cluster_id":"544fb937-88d2-4ddb-9c06-1ae58af8be2b"},{"claim_cluster_id":"dcadf3a6-188b-4a08-881c-e1acb19f186a","event_cluster_id":"6b4e3603-7ed8-4a6d-b270-0425352e67bb"},{"claim_cluster_id":"f3288e7a-a54c-44d1-8307-67aafb47c852","event_cluster_id":"4da30c02-5a8f-4e15-af9d-b0a7ede85a55"},{"claim_cluster_id":"06b8ffc7-c987-44a2-a2cb-8721e54e7da6","event_cluster_id":"b2946046-f947-49a1-8176-588a2c66f974"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"7013bebd-c68a-4b31-9e63-8c86c5d8c784"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","event_cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f"},{"claim_cluster_id":"3720666b-a4ac-4b21-9f19-2a86f32551a0","event_cluster_id":"babe889e-ec1c-438e-aff1-7ca2b0c30aa9"},{"claim_cluster_id":"3c4e2f0e-5b8e-45e9-84a7-c71071caeba0","event_cluster_id":"8aa22381-c7a3-4609-b694-2961fd740fc7"},{"claim_cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","event_cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875"},{"claim_cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","event_cluster_id":"ecd748e3-d837-4992-8ea5-50edc6e9e5f6"},{"claim_cluster_id":"970cf87e-f96a-4a62-8043-264e8de25eb5","event_cluster_id":"1b1d9a06-de42-4de4-8ba5-73d34f084424"},{"claim_cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","event_cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"ccfbe60c-5479-4640-b831-00bbb4cb4ec1"},{"claim_cluster_id":"61784f3e-1c50-4b37-9db4-0fd1ec458127","event_cluster_id":"595a5404-b726-44ba-919a-07c9e6bedb55"},{"claim_cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","event_cluster_id":"84f58721-c200-46df-b038-aa93f32b79c6"},{"claim_cluster_id":"d9f4e411-98bf-48bc-a372-2ef5b6cd17d9","event_cluster_id":"5b53e66c-0bb9-49bd-b149-91ceadd51fb9"},{"claim_cluster_id":"b7bef44a-7480-409a-8790-0a70b42045ee","event_cluster_id":"2aafed04-d3d3-4ae0-9825-6d6db215ea71"},{"claim_cluster_id":"6c511b67-edc9-413f-96b2-94d272eb11e9","event_cluster_id":"6f7f68fd-a840-40e2-a600-b19e0677f9c8"},{"claim_cluster_id":"dd658abf-fc5a-4105-b976-357ecd016b6e","event_cluster_id":"1d63f5ab-d2ec-4979-b939-ba16ea5a94d7"},{"claim_cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","event_cluster_id":"d976c975-a582-4fc7-bfd4-75e1c6617efb"},{"claim_cluster_id":"ecf280bd-73fc-4028-90b4-eae0d740ef40","event_cluster_id":"7222826f-77d1-45bf-82db-ad09c33129da"},{"claim_cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","event_cluster_id":"fd853489-07e0-4489-8d20-abb8f80a4213"},{"claim_cluster_id":"33c9ef05-1d84-4ad3-be17-1fea5c70facc","event_cluster_id":"52a2820c-2844-4d7a-9571-36ea2c51015e"},{"claim_cluster_id":"dfe5555f-7179-45b9-9f7a-919fa1cc1569","event_cluster_id":"85b491d8-b806-4e3f-b616-3cfa5f5fa60f"},{"claim_cluster_id":"f9e580f2-a45e-455c-a4fc-189d643f07ef","event_cluster_id":"67882453-39e8-4614-ad83-1b5cd199486b"},{"claim_cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","event_cluster_id":"2ddd688c-7c02-487e-a8aa-11d74ae8915d"},{"claim_cluster_id":"e632bc78-90b4-46bf-a31b-df8259ac6d90","event_cluster_id":"bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"},{"claim_cluster_id":"565acc40-efdc-4957-85fb-8602f0587aa9","event_cluster_id":"869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f"},{"claim_cluster_id":"54e59784-1db4-41f0-a651-2d5e2138670a","event_cluster_id":"10d03545-859a-4c3f-b85f-14e8f49d3ac5"},{"claim_cluster_id":"97b87ffd-da0c-47fa-86ae-0eedf718bf3e","event_cluster_id":"1b1dc316-6caa-4e05-8920-919dfeb09b67"},{"claim_cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","event_cluster_id":"11423356-cdd9-4f07-af4c-408d43e6e2c4"},{"claim_cluster_id":"731ff8b9-92a5-4277-aa76-33602d261e5e","event_cluster_id":"bfeab18a-6cab-4e4c-ab1a-32ad52ac07e1"},{"claim_cluster_id":"42139453-8011-41e0-af88-1b45a4865158","event_cluster_id":"5379b888-9bc6-45e3-b445-a1f1b5983b84"},{"claim_cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","event_cluster_id":"dd4670c3-7e44-4c76-a7d9-373ad6cb6c50"},{"claim_cluster_id":"23bf4739-72bc-492b-9320-78f2bdc83074","event_cluster_id":"21ef710d-94c3-43ee-b3be-224e0c033195"},{"claim_cluster_id":"33d1d4f9-5c45-44c0-8055-973e47d10907","event_cluster_id":"0947f9bf-7d2a-4b27-95a6-09e765742c84"},{"claim_cluster_id":"59f4b586-ede4-4464-af30-2858db5799e0","event_cluster_id":"689d132a-4055-4564-beb7-4778d700e367"},{"claim_cluster_id":"f58ca21a-7af7-4062-9509-f6480d8a6390","event_cluster_id":"c0ac6691-abf2-4873-a338-41a4997bcb24"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"872f71be-bb1a-40a1-8078-ee9f850ec42d"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"1ccdbc51-34c0-42ae-b81a-03edbb3df6d6"},{"claim_cluster_id":"c8a67d7e-6b5c-49cc-b944-ad699ac9cff0","event_cluster_id":"a22f4cef-ff1f-4c32-aa22-6cedb760ab4f"},{"claim_cluster_id":"6985338a-f2b9-47d5-b9ae-563c0a87748d","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"5d8dea5a-b22d-41be-9ea5-91141c9a7614","event_cluster_id":"447c6034-ca16-41e8-ae39-d9800adee825"},{"claim_cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","event_cluster_id":"8269010c-d30d-4a8f-9628-b930192a8751"},{"claim_cluster_id":"f10deefc-8ed5-4516-8cc2-3ba87195eac0","event_cluster_id":"eeba7376-7fac-451b-96dc-72a9f7c32f92"},{"claim_cluster_id":"13dd3c2f-f547-4b94-b763-665ce078453e","event_cluster_id":"b7375a29-4c73-4062-a85e-7e1c1f79300d"},{"claim_cluster_id":"4acf918c-0778-4ee4-b773-26139df2ea2e","event_cluster_id":"93c79f3e-8eab-4299-bf58-7b2b18493bd8"},{"claim_cluster_id":"dfa47852-ac3f-4b74-bc17-22923a395552","event_cluster_id":"8d1da449-ead9-4d20-b9d7-330964de7727"},{"claim_cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","event_cluster_id":"6d7e8844-23f0-4293-9d61-855d04598239"},{"claim_cluster_id":"04c0a28d-e066-4279-bfee-f4757f197d7a","event_cluster_id":"fedc3a0d-9f9d-4e04-81a3-669b447f0bcb"},{"claim_cluster_id":"82430ac1-c5b1-4777-ac21-a40819c2ad02","event_cluster_id":"4e1f9c12-6559-421b-814d-33b10f78b8a6"},{"claim_cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","event_cluster_id":"5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb"},{"claim_cluster_id":"7123d027-fb9c-44c1-becb-087b98c76740","event_cluster_id":"4f9d6840-2d0d-40e2-b786-9827419e3e78"},{"claim_cluster_id":"ced45aa6-b370-4a79-b76b-674fcd6c0668","event_cluster_id":"30adcb64-6b84-4937-a83e-146b8ce17e82"},{"claim_cluster_id":"ab9886f5-759f-416b-88de-b9f771cf04e1","event_cluster_id":"0c515019-d4d8-4fdc-91ce-bd3ef7e8e081"},{"claim_cluster_id":"1c5a60ba-15c1-4cc2-b60f-b6a9d3303da1","event_cluster_id":"5450c124-f70b-4739-a4ce-8408866030e3"},{"claim_cluster_id":"3f043499-266e-455f-a558-699fac541c36","event_cluster_id":"d88b95f4-1e38-4dd6-b178-e63adfad4ea7"},{"claim_cluster_id":"553489d8-ac8a-4e20-ab65-673fb4e17c1e","event_cluster_id":"599b237d-3afe-449d-8cd9-becd796f27c7"},{"claim_cluster_id":"afebac7c-8f71-44cd-beec-d242a1b97e86","event_cluster_id":"c981e733-ddfe-483b-a14f-615fd62cec72"},{"claim_cluster_id":"b63983c2-35fa-4152-8cc2-8380b6cbde79","event_cluster_id":"4e53dc9a-0b46-4ddf-8ff5-f5172619e371"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"3a13abc2-f39c-460b-8768-7ccf1b11b40f"},{"claim_cluster_id":"c043e411-6d15-46a6-be1e-7a8a943cc43f","event_cluster_id":"0486b789-e813-4404-9c89-b8c77f623251"},{"claim_cluster_id":"796ddc52-9094-4fcb-af10-9fa6a06448ba","event_cluster_id":"80a198cc-8757-4f4b-9e5f-ba483e92361e"},{"claim_cluster_id":"970cf87e-f96a-4a62-8043-264e8de25eb5","event_cluster_id":"df1455dc-0c9e-4e83-b885-6c9b28b69dbc"},{"claim_cluster_id":"48e347cb-8237-47af-9eab-b23191638cd0","event_cluster_id":"eca77987-6ebf-478d-b553-30ae00ed1856"},{"claim_cluster_id":"5284ded1-5c85-415c-af66-ad36ef47b3e7","event_cluster_id":"83df36bd-a3ff-43cc-b6fd-c979f5dfd9da"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"62c5acb9-493e-43c7-9647-7858b2ea0c50"},{"claim_cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","event_cluster_id":"85949bd1-40e8-47bc-acf7-cb049a4e425e"},{"claim_cluster_id":"62ddd106-9df1-47e7-9e5a-9c12a19f488c","event_cluster_id":"e7e91720-5f86-4e9b-b765-89e7169207fb"},{"claim_cluster_id":"b58aa973-7c2a-4a42-ac89-2aa7abeea2e5","event_cluster_id":"7f8a206d-56f9-43fd-80ec-c184e678a121"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"81165fd5-dea5-41f8-ac75-66b97e1cca44"},{"claim_cluster_id":"e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a","event_cluster_id":"efe0fef4-f04e-4e85-bb20-f40d0e8f6c06"},{"claim_cluster_id":"260b5cb2-3dad-42a1-a677-cfe24a203765","event_cluster_id":"b25f50a2-6e79-4624-b63a-fcc433c2ee8b"},{"claim_cluster_id":"be4a2385-74e7-4ed5-8c71-c890af870db7","event_cluster_id":"d6713b0d-513a-4166-b2c8-1c6b4cde08b8"},{"claim_cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","event_cluster_id":"bb551e75-48fa-42c3-a108-cb4b1462b529"},{"claim_cluster_id":"b36a42d8-1bb3-483d-b77f-bd28630b0e30","event_cluster_id":"9f888081-86ee-47a5-ac83-e1aec7d1b080"},{"claim_cluster_id":"125b87a9-62f3-402f-a1ad-6a9130845e80","event_cluster_id":"ff4b91c6-36e8-4903-a2ad-89bb3665e4d5"},{"claim_cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","event_cluster_id":"82ba7adb-7963-4264-baad-21315bacde1d"},{"claim_cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","event_cluster_id":"626e9a9b-6995-4100-8ffb-53ed10359203"},{"claim_cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"6677095f-eafc-4bbb-8dde-f914b5103e89","event_cluster_id":"45d7d6d0-989e-40f5-9e35-4f603b15d08b"},{"claim_cluster_id":"ab8de566-e0cc-475b-b056-6b27916b484d","event_cluster_id":"35008b59-14cd-4674-801b-6fc7e159bf31"},{"claim_cluster_id":"8c2b4e21-c9ea-4127-9440-e983688f714d","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"5f5fe60b-6bf8-4f80-be3b-0dcf885c1171","event_cluster_id":"6ea5c303-0018-42cb-9161-d7d2a76673ac"},{"claim_cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","event_cluster_id":"a1c1162e-c36a-46e0-95af-7c5c08d5e6ff"},{"claim_cluster_id":"d1c29947-a7e4-41cf-9656-837e51b2de11","event_cluster_id":"54d73329-0451-4bab-a86d-4ce16b809e91"},{"claim_cluster_id":"0a3a7c87-61b9-4961-a698-61129e827319","event_cluster_id":"2fe604c5-b4d8-4806-815f-c3f9be0582ed"},{"claim_cluster_id":"144a5089-d891-40d6-b31c-9c5381bee1d5","event_cluster_id":"0795fae9-e716-4cba-98f8-5f27537dcd6b"},{"claim_cluster_id":"2ab59d09-09ca-4583-9e99-8189ce8c9335","event_cluster_id":"635850fb-0b7d-4148-aae4-786dbec7ebb9"},{"claim_cluster_id":"5b28f56e-4dc0-41d8-b963-a4fc04cbaf08","event_cluster_id":"558a2b97-08fd-422a-b638-0c14ba645eaf"},{"claim_cluster_id":"df5cc82a-7ab7-41f6-8eae-c3445a8c7a05","event_cluster_id":"a2e35d24-76f3-4ea6-99d1-6a5176010a02"},{"claim_cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","event_cluster_id":"888e25a1-a330-4c04-b43d-60fcd67cb2eb"},{"claim_cluster_id":"d7e9e6ed-b598-46a7-b7ea-6197df41d3ad","event_cluster_id":"9103d8ef-aca0-41e2-a089-fa1568b1c90f"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c"},{"claim_cluster_id":"53a06fbe-813d-46c8-a459-0b312bf0c503","event_cluster_id":"5cee41d6-0e60-41c4-b25d-8f1605700435"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"0f5915ad-4edd-49f6-8855-92a02e00debd"},{"claim_cluster_id":"8ac7a573-0e67-4913-bd5a-4320d5df2ecd","event_cluster_id":"94fcf1c1-17a1-4318-9032-ad180a9a74cc"},{"claim_cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","event_cluster_id":"213314ea-c0f8-4a72-832f-5b10a8bbeab5"},{"claim_cluster_id":"20b239ec-b263-4052-a330-5aad8ed1209b","event_cluster_id":"2b8a30d5-2b80-47ce-adf4-0612b97c7289"},{"claim_cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","event_cluster_id":"3a1c123d-a3bb-42e2-911f-77ddeb67d2ee"},{"claim_cluster_id":"3fd55ffb-10d4-4e70-9352-8bd5b0751ffd","event_cluster_id":"c9c64be3-e960-4772-bfe7-2c746234f3c3"},{"claim_cluster_id":"21745bb5-f9bc-46bd-a9de-95338ba8c016","event_cluster_id":"4bf58da8-6849-40b7-a8ec-ddb3570d0f67"},{"claim_cluster_id":"1ba178d9-d925-407c-bb75-60c655774cbf","event_cluster_id":"0dbd4f26-ef42-4c5e-a16b-4529c5e0d566"},{"claim_cluster_id":"7ad2c49a-5636-41a0-bf37-19bfc98916c1","event_cluster_id":"265b7995-86ea-4269-bc72-cf439682655b"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"da81244a-ef78-429d-9f3d-b08a5c21a084"},{"claim_cluster_id":"a84f79d2-3818-45bb-9cd9-eb739e78bee2","event_cluster_id":"094959dd-ba14-4dbb-83c9-b7363a4aff97"},{"claim_cluster_id":"c076834e-92b4-4b02-8416-1f251021c0cd","event_cluster_id":"53949001-7a01-495c-8cfe-7d81bd307f6f"},{"claim_cluster_id":"6c41ffdc-392b-45d6-b68e-a4cccabb1714","event_cluster_id":"6a38e03b-c385-4edf-9cff-c8c006c566e3"},{"claim_cluster_id":"011b48fb-6ec4-41cc-bd4d-394e371c18cb","event_cluster_id":"0587530d-6a6d-4aa0-9e34-087698c923aa"},{"claim_cluster_id":"b7768432-bcaf-4a4c-9bb2-1a6e02c6a003","event_cluster_id":"44317cdd-77fe-42f4-b1db-9819636d2f58"},{"claim_cluster_id":"99df608a-defa-4cea-b8ef-86519fa0e08a","event_cluster_id":"1ee9efa3-f349-4351-93b7-a5f37a7326be"},{"claim_cluster_id":"1b257e2e-69fd-4bc5-b57c-e7f5b2178161","event_cluster_id":"91a65b39-ae74-4a8d-812e-5ba1c8563d2e"},{"claim_cluster_id":"13dd3c2f-f547-4b94-b763-665ce078453e","event_cluster_id":"b07254f1-f996-464b-a61c-6949e39dcdb5"},{"claim_cluster_id":"e88c49ad-3df2-4059-82e4-46d0f3b59757","event_cluster_id":"075ee2c5-b49b-44c4-9646-461463ce6ff8"},{"claim_cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","event_cluster_id":"58d169af-1f4c-430e-875d-88f013ef1388"},{"claim_cluster_id":"428d818b-c2cf-41c7-bcd8-3f5cb0b144ef","event_cluster_id":"8a11cb2d-17fc-4106-aa7c-42847d3ac867"},{"claim_cluster_id":"71522ed0-7107-4dfb-8b87-e633332c4e3f","event_cluster_id":"347d7cc9-3711-496c-bdf7-6c0c22b3750a"},{"claim_cluster_id":"af562818-5594-417a-b606-add10573c2db","event_cluster_id":"874c8d94-d252-41b3-bbae-89e33a5eba13"},{"claim_cluster_id":"38146e96-2791-4b11-ad91-87648834294e","event_cluster_id":"0ab67aa0-2db3-4a91-9f5f-2305bd1d90bb"},{"claim_cluster_id":"df5cc82a-7ab7-41f6-8eae-c3445a8c7a05","event_cluster_id":"5b55251a-6617-459a-a1fb-c10dc23dfbc7"},{"claim_cluster_id":"7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6","event_cluster_id":"31416837-c17d-49fc-a841-b231a9f41ff6"},{"claim_cluster_id":"2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187","event_cluster_id":"60679d50-135f-43b4-962e-903dca327357"},{"claim_cluster_id":"947756fe-ff59-4dbf-90dc-9c0bdf20ace0","event_cluster_id":"3f0053e9-5dcd-46d0-a2b7-d6cbd40dc3ff"},{"claim_cluster_id":"8143472f-9ddf-4467-8402-c46a70ccaf1e","event_cluster_id":"c4336836-69fe-4478-ae05-a9b8308b5fd7"},{"claim_cluster_id":"496ba3da-7431-46d2-8b63-afbe79f86c65","event_cluster_id":"b3995a19-7531-42df-8c11-d55b2b796806"},{"claim_cluster_id":"bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75","event_cluster_id":"7a0efb78-9055-433c-904f-79dc94ad2203"},{"claim_cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","event_cluster_id":"4e101b24-e99b-4526-bcbc-e5ddeec46f80"},{"claim_cluster_id":"da8da9c4-b0b1-404e-a289-e106bb2bfbb3","event_cluster_id":"7cd85d56-7567-4824-894e-168d86ff8ac7"},{"claim_cluster_id":"6fa7c53c-2f06-41c6-acf2-531da6482f4e","event_cluster_id":"10224329-dea4-42e7-8db6-693c6ba2c28f"},{"claim_cluster_id":"171a2f66-23cb-47e8-a645-32fd4f7a8de7","event_cluster_id":"522766f6-ebcb-4a4a-8452-2b5650a5db3e"},{"claim_cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","event_cluster_id":"104c0221-a4dc-4285-9360-e1a7135d6b23"},{"claim_cluster_id":"976d7c8a-cb17-41e5-9407-5cd8c141bb84","event_cluster_id":"3871454f-b8ca-4976-ba58-fba8307b403e"},{"claim_cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","event_cluster_id":"46ef864f-186e-4179-bb52-04fed8b2c978"},{"claim_cluster_id":"738e60fd-1e3d-4820-98bf-d6bd9e7a3172","event_cluster_id":"f10864eb-56bf-40a9-9f67-5dfe4ef70806"},{"claim_cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","event_cluster_id":"add8105a-2d0f-4f9d-9f00-f11f0673121c"},{"claim_cluster_id":"b6f111d6-8112-47dc-baeb-43c77c6392ea","event_cluster_id":"7b8193fc-3e2e-459f-9d2c-f5d5c9d7a1b0"},{"claim_cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","event_cluster_id":"125a4bc0-e32c-4a8b-80fc-60d23537d495"},{"claim_cluster_id":"e8e14c71-2e64-412a-8769-000c5cda92ce","event_cluster_id":"5afcd855-48b3-4e16-bfa6-1ae369574bba"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"9babf1db-b81e-42d8-a506-b9ddc52bfb22"},{"claim_cluster_id":"54c46b5a-065c-41a2-90e0-3fac031eb853","event_cluster_id":"532bc570-7cab-4e65-8d14-b6e22f9fc1d9"},{"claim_cluster_id":"868aacb9-ea8e-4ec3-a074-1e7f56bab03f","event_cluster_id":"212b2ba7-fb93-422b-bfc0-bda99de8b498"},{"claim_cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"df846784-b644-4d2f-a077-f42db08f73a6","event_cluster_id":"89769c6a-9183-49cc-94f1-4adf24a43953"},{"claim_cluster_id":"3d647896-bc7f-4815-a99e-768cb2498250","event_cluster_id":"4b012ae0-8a3f-4446-8ab7-f0572ce911e0"},{"claim_cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","event_cluster_id":"a9a9b1b1-c494-4c16-84ad-397e74093b98"},{"claim_cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","event_cluster_id":"c7c8c6d3-cdc9-47d7-8f45-165280d3560a"},{"claim_cluster_id":"80abc80a-d540-4e4d-aa41-272690066eb0","event_cluster_id":"0e839111-b99e-4caa-8ece-e80f0ea67970"},{"claim_cluster_id":"4d4a5a78-bde2-4ed8-943c-811738978e0d","event_cluster_id":"6f7f68fd-a840-40e2-a600-b19e0677f9c8"},{"claim_cluster_id":"492eadfb-99f3-4bc3-a9af-afa12d93eb99","event_cluster_id":"bfcfc457-5e16-4c1c-83da-c1f90a8c2bc4"},{"claim_cluster_id":"41683dea-1259-4e44-9283-e6286d675c48","event_cluster_id":"a7e685cc-6af8-4b3d-9fec-fcb894e900d3"},{"claim_cluster_id":"c7b90480-a4e5-4b5f-b840-fe13ad140b52","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"dea6592f-a2fb-4ea8-b832-4f7df984c163","event_cluster_id":"8985495d-c23b-4b4d-8af8-d412abf8767b"},{"claim_cluster_id":"b54e5664-a40b-4682-b959-bcfb59ddd4b0","event_cluster_id":"4294101c-07cb-4434-a277-aca60564390c"},{"claim_cluster_id":"dcf2ee53-8023-43ee-94fe-0207a7fb5133","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"2ea5d498-58e2-44a4-a51a-95bda7047686","event_cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c"},{"claim_cluster_id":"0b87672f-54fc-4c20-8d98-e54ab45bc52d","event_cluster_id":"14b94d56-73bd-4f9f-9a3d-89c9827b210d"},{"claim_cluster_id":"41a156b3-5c3d-4d82-b8e4-7ad88953f690","event_cluster_id":"193b523c-c283-41d2-a3f3-b37ed50ae40d"},{"claim_cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","event_cluster_id":"f54fdd0e-ba75-4fde-af1b-64b83311ab6e"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"1c5a43cc-bd0f-4446-9eae-4f39a7691fd3","event_cluster_id":"5d6a4e52-504f-48f8-b46b-8c506a9ab7ad"},{"claim_cluster_id":"37c89569-0090-439b-961a-5b1d66deea87","event_cluster_id":"635850fb-0b7d-4148-aae4-786dbec7ebb9"},{"claim_cluster_id":"7d04ad0f-dee5-48f3-910e-0b2281b15f1e","event_cluster_id":"ac17d012-fb03-4978-afab-d0ee9527705d"},{"claim_cluster_id":"aea747b1-1cb4-4b3d-94df-5c33181b0976","event_cluster_id":"b7c9de19-8b29-40c8-92af-4119566c8604"},{"claim_cluster_id":"06ceeed7-8a02-425d-9be1-3881dcb38762","event_cluster_id":"ac48c971-5c1c-4044-bc6f-2141fc11a1f0"},{"claim_cluster_id":"3c1f9759-2361-48c2-bc4a-c58a3d11b76f","event_cluster_id":"5f26f77b-0214-4097-94f1-7873a36d7969"},{"claim_cluster_id":"ca129396-101c-429f-8530-fe05aaa1c7cf","event_cluster_id":"f44c0680-07c7-4ea0-8054-7643f1b8eafd"},{"claim_cluster_id":"6f548f26-3ad4-4adb-80dc-c3f3104f0d7f","event_cluster_id":"768c2664-8354-4bfc-8b47-96eb4e08e0ee"},{"claim_cluster_id":"ee1d7c5b-4d98-426c-bf43-b5350f89e9dc","event_cluster_id":"341ca13e-66ab-4ded-b14a-e2210febdc82"},{"claim_cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","event_cluster_id":"3c5a3b02-4d06-4799-a8fe-9f59c0de51d9"},{"claim_cluster_id":"45d5305e-53a9-4659-a1a0-2bf0495c5055","event_cluster_id":"e50f2f1a-20bb-46bb-82c9-6def0deadc19"},{"claim_cluster_id":"4bcae16d-fb51-4ba8-8381-37355e0e9f18","event_cluster_id":"0016bf55-313e-4918-9759-9210715148d1"},{"claim_cluster_id":"06f782f7-82f3-4b4d-a941-de5952ae3f6b","event_cluster_id":"320a3067-75cf-4293-9d53-8dd1f312af23"},{"claim_cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","event_cluster_id":"67ac99c8-c0bb-4383-9849-47ca12ce4b47"},{"claim_cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","event_cluster_id":"25f83819-e436-47d4-a6ab-ce489fc70293"},{"claim_cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","event_cluster_id":"909c2544-65ad-4eae-8bbb-f43d077750aa"},{"claim_cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","event_cluster_id":"09f4e973-2393-41aa-bdcb-ccd0efbed300"},{"claim_cluster_id":"b180d822-88c1-4c5f-a386-c975497c4a85","event_cluster_id":"f1c3e82c-0769-48c5-9831-5c2bc8453631"},{"claim_cluster_id":"b2a26561-1192-4739-962b-b9df80083243","event_cluster_id":"3fe0d18a-cf4e-4f24-a77f-892271df6bae"},{"claim_cluster_id":"4bcae16d-fb51-4ba8-8381-37355e0e9f18","event_cluster_id":"fd17e83e-78c7-4b20-8834-c8e041abcbf4"},{"claim_cluster_id":"f4d9e677-79ed-4c5c-84a1-d127898975a0","event_cluster_id":"652f545a-2cde-41d4-9382-f23ab9d1b406"},{"claim_cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","event_cluster_id":"e197be16-bc11-494c-aa3f-5b8f744ffb1a"},{"claim_cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","event_cluster_id":"467eec25-d0de-412a-9f09-8a0db03d60ae"},{"claim_cluster_id":"74c84f9c-121d-41ed-8a45-f4cdf85eb02c","event_cluster_id":"b83a1d17-db6c-42cd-8ccd-d99d30b78f59"},{"claim_cluster_id":"f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34","event_cluster_id":"36133231-d5e7-4a50-b9f0-6f646f403eb7"},{"claim_cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","event_cluster_id":"01d5ac9b-578e-460b-921d-2d1cc5ecad34"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"db855b90-bd37-485e-bb72-492eed958963"},{"claim_cluster_id":"bd50210c-37cf-46e2-9d31-0c6a6dd06e70","event_cluster_id":"fef26a04-5ec2-47de-9b9c-92eaaae9e544"},{"claim_cluster_id":"00386fb1-3dcc-4b4e-b74b-bc14dbc4e260","event_cluster_id":"af07ce28-0024-41ac-b51c-01e4bbf2c507"},{"claim_cluster_id":"f2363c7c-72d1-4e3a-b724-27c1d218c5fc","event_cluster_id":"eafeed04-4e89-4efc-a2ef-31ce78091f99"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"8806403a-c610-4055-9744-edc72cda745d","event_cluster_id":"f97c3788-df6a-4dd4-b544-6d0397d5953e"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"4958a7ec-0cd2-487f-a59b-9bc34843a2b7","event_cluster_id":"083a8283-1aa3-4b94-9026-bbd5c3a07cbe"},{"claim_cluster_id":"30011e47-1ff9-409e-8099-2eff6ab89e88","event_cluster_id":"130b5f11-d69b-4e29-8d13-05a09ea6b8ad"},{"claim_cluster_id":"a4400c47-658a-4ca0-9b29-fa8384838731","event_cluster_id":"815f7381-c3c0-4b84-8b7d-44fda735e36e"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"c9ef551f-21d7-4986-8f7f-14a67206ac95"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c"},{"claim_cluster_id":"9f4b1362-f866-4431-983b-c739ed7f376e","event_cluster_id":"0bbfb864-d9fa-40cd-982d-22d96033b7a3"},{"claim_cluster_id":"f8e7dcff-d078-4ce8-9ad3-495ed7c19774","event_cluster_id":"5f181f74-d991-4908-aaf7-6917a17dca75"},{"claim_cluster_id":"55a53a4b-b30c-483d-9f7b-8c999d5c2f62","event_cluster_id":"1bece78f-f648-4fbc-85c0-722698749525"},{"claim_cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","event_cluster_id":"21f0a219-a107-4e6e-aa28-e010ad5aec66"},{"claim_cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","event_cluster_id":"44a25f49-5174-4a81-bbe3-8d614f9c4116"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"202ead36-85d6-41b8-a59e-b60cf6559899","event_cluster_id":"fea07608-613d-4c2c-b77c-a335119ce351"},{"claim_cluster_id":"dac4f0e5-e31b-44cc-a055-3ac65eec9d11","event_cluster_id":"f60ced9d-709d-49cc-bda8-183a3ced98f4"},{"claim_cluster_id":"f87de08e-1790-487e-a827-12378ebf4309","event_cluster_id":"964aba3e-f62e-4ef6-b8f3-99237adf29ba"},{"claim_cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","event_cluster_id":"1502dc4e-242e-4ce0-baf9-c0d4847d8993"},{"claim_cluster_id":"1c5a43cc-bd0f-4446-9eae-4f39a7691fd3","event_cluster_id":"ed1adfd2-5ca7-48e4-ae90-60f2fca59b2a"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"a65b71fa-08aa-4b20-91e3-c9e898591f07","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"601320a2-3fca-41ef-9387-a64a4c0b5cee","event_cluster_id":"3b5c9589-43fb-428f-a24d-ff67c6ec3e67"},{"claim_cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","event_cluster_id":"4f34e75a-3485-4e52-8dc7-20e80c772c83"},{"claim_cluster_id":"369b1cc5-aae5-4361-aabf-b1ef5c5350f8","event_cluster_id":"5534af16-de3c-4c33-b0b7-ecff69356f24"},{"claim_cluster_id":"70898fa9-9960-49d5-b422-3f77d073d86b","event_cluster_id":"bc29966a-d588-4e80-8feb-dd96bcffea23"},{"claim_cluster_id":"284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5","event_cluster_id":"2e8ade9c-f86a-44fa-88a9-a501aee7cc66"},{"claim_cluster_id":"070a19a3-da4f-4314-9f9a-9f32850f97f0","event_cluster_id":"e86a3db7-1b97-499b-90f0-337a1d71a604"},{"claim_cluster_id":"3579f3e6-5ab6-488d-a555-602383a4e3bf","event_cluster_id":"7e03d5b5-4b07-4e72-b62b-55465d7f9333"},{"claim_cluster_id":"555fa82e-54c2-4aba-bcc8-bcfe1ec2186c","event_cluster_id":"0ae66dca-634f-424b-80e9-5fc4b2615b98"},{"claim_cluster_id":"0a0082f4-5a11-4bce-aa5d-1877fddb104d","event_cluster_id":"82b56123-1ab0-4271-8360-fac7c8b1d118"},{"claim_cluster_id":"f570b12b-c8a8-4d99-9575-a11a563abe1c","event_cluster_id":"a16d38f8-25ac-46b8-94d9-38eb77cacdcf"},{"claim_cluster_id":"8457d857-0fdc-43af-97c5-93e3a3631f90","event_cluster_id":"b98b439c-bc5f-48c4-9882-c02eb0d9e36c"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"adde58fd-6daf-4b35-b4c1-a6e18d15a403"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"e4c393f3-a213-40f3-ae1e-bc16b0f13a4f"},{"claim_cluster_id":"00c920c5-f4fa-404a-9d1e-12f311ed5e11","event_cluster_id":"979b7171-b50b-4784-a226-a93eb757dfb4"},{"claim_cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","event_cluster_id":"733bc88b-24fe-4115-bf99-e05181e2177b"},{"claim_cluster_id":"62f1a663-dd6b-40a0-81fa-7660c589c0df","event_cluster_id":"6f5bbb87-6b1b-44e1-b1a8-1e74525f3d78"},{"claim_cluster_id":"2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37","event_cluster_id":"fec39a26-1bf2-4183-bcb5-a33cc47fe4d3"},{"claim_cluster_id":"98f59c42-164f-4444-8ecb-92a7e7c88a99","event_cluster_id":"d140ee70-1c2e-44c9-b163-573b275b6b17"},{"claim_cluster_id":"06af9b74-e018-4919-8256-29acfecc76d7","event_cluster_id":"3449416a-5af1-418f-857a-770f02267ee7"},{"claim_cluster_id":"9860031c-3ecb-400d-a847-e88ace1049f2","event_cluster_id":"69365007-aabc-4f8e-a4e7-3ac92aef1b47"},{"claim_cluster_id":"b2871022-57c5-48f7-adcd-caeceec2edeb","event_cluster_id":"f3b31658-0ebb-4d41-9f46-459b160be01d"},{"claim_cluster_id":"0a1db453-23bf-4b25-a04b-c4f13d273e88","event_cluster_id":"269675ca-916b-4267-8970-bb97e2010767"},{"claim_cluster_id":"10bf083b-35c8-4b77-a2d9-e4cb3813d9fb","event_cluster_id":"06234dad-1957-47b0-bd01-974e9b80e07e"},{"claim_cluster_id":"03ac5e38-07fa-4023-b9bd-bdfc9810ba0c","event_cluster_id":"21ef96d9-9c60-4110-9606-ce33a7d0a4f1"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"3e87987a-c8cd-4616-922a-e297f103d0fa"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"e0d3c894-0bdd-4f66-b7b2-a6bada2f1b37","event_cluster_id":"c5169cd7-a9a1-476b-8658-0fe7fd1f0d44"},{"claim_cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","event_cluster_id":"d2b4f80e-7d68-4944-98c8-306c2b192c15"},{"claim_cluster_id":"1993c1c6-e677-4697-9e0d-f4c2332e53fe","event_cluster_id":"08cb653c-495a-4846-800e-e87a07c472be"},{"claim_cluster_id":"9cc8f400-4462-4501-9bf3-f6cf35f7a110","event_cluster_id":"f643a51f-99d3-4180-8b6e-ad534e8f3dbe"},{"claim_cluster_id":"2b3c747b-9f75-4697-a22b-426999d9c671","event_cluster_id":"8985495d-c23b-4b4d-8af8-d412abf8767b"},{"claim_cluster_id":"96b36beb-a890-402f-9101-7aa7236863f1","event_cluster_id":"4da30c02-5a8f-4e15-af9d-b0a7ede85a55"},{"claim_cluster_id":"ed50b251-f205-4952-987b-aed1c0461840","event_cluster_id":"27c83a03-3f6f-4152-a678-12dc8e5912da"},{"claim_cluster_id":"86944fd0-c689-49c4-894c-bd247f4057bb","event_cluster_id":"dad9620e-fc93-4bb0-adf4-d1ba1da4f381"},{"claim_cluster_id":"555fa82e-54c2-4aba-bcc8-bcfe1ec2186c","event_cluster_id":"62c364ef-d86a-4575-aa30-edbcabb6f794"},{"claim_cluster_id":"19dc451c-d076-4677-8e6a-44a760f27332","event_cluster_id":"198dc8a2-e334-4b48-8e21-1b19bd36b74b"},{"claim_cluster_id":"ccf91c48-303e-4d94-8263-0e8c6de64e17","event_cluster_id":"f7bc5745-3844-4596-a6d1-1d8cba63f4b6"},{"claim_cluster_id":"fa530a1e-4be0-417c-bd45-2254a93d2324","event_cluster_id":"1caeaded-5769-4cdd-b16d-b85f9a51e31c"},{"claim_cluster_id":"71f31aff-9c20-4fff-82ff-b0bb971b0134","event_cluster_id":"a3e7173c-3ffd-4346-9259-1d6261818acc"},{"claim_cluster_id":"11b24695-ec58-4b46-8411-89fe4137f816","event_cluster_id":"7ccbb20b-c467-4a12-8d6c-4afcbbe94813"},{"claim_cluster_id":"b7768432-bcaf-4a4c-9bb2-1a6e02c6a003","event_cluster_id":"a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d"},{"claim_cluster_id":"74f0249d-eead-4904-bdd3-cd8cfbdb6b82","event_cluster_id":"69acedef-de24-45bd-8d64-3a2e3c997d87"},{"claim_cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","event_cluster_id":"3f98fdac-3f62-464c-bf56-dd3d2e686963"},{"claim_cluster_id":"7c8b94c0-08bd-43e2-9b5a-418ff416c274","event_cluster_id":"82a5c9f7-4f90-429a-b7a6-559b1c83bc8c"},{"claim_cluster_id":"f570b12b-c8a8-4d99-9575-a11a563abe1c","event_cluster_id":"f996f072-3b37-4e7f-900c-1cc05e40fa72"},{"claim_cluster_id":"a03d3de9-e5ad-47e0-9374-17e6c1998859","event_cluster_id":"54567e29-4033-493e-869f-078ef9153910"},{"claim_cluster_id":"d8f02a31-c29f-429d-b5f0-720768af0f52","event_cluster_id":"e8d1e306-3805-48a6-8fe7-8350cb762a36"},{"claim_cluster_id":"957456fe-cb84-4fb9-bc2f-3e775154a824","event_cluster_id":"655ccaf5-6cf6-444d-a7a8-cb79a1480f69"},{"claim_cluster_id":"a316407d-a413-48ec-95c7-f1a3c83da782","event_cluster_id":"42b0a0ff-74f3-41bf-9d03-2adc79284ead"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"b41760af-aaf8-4d45-b87f-633ebbf009f9"},{"claim_cluster_id":"7faff4ee-fc9e-4ba2-8e8e-36906d88936d","event_cluster_id":"a3f777dd-158e-459c-ae69-5df160dfccf8"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"3d7436aa-4609-467d-a098-e24702a617e8"},{"claim_cluster_id":"a90d4523-8e1f-4287-ae0c-72459f7c14c3","event_cluster_id":"0e83eeb4-b212-4ca1-a4ab-db7a128c6db1"},{"claim_cluster_id":"9ba84133-d9e2-4da7-8e9b-aeda3ebd4295","event_cluster_id":"2d485df8-2925-4317-a6b0-216006ba9fa5"},{"claim_cluster_id":"131fc120-2488-4970-ac79-410004aa6030","event_cluster_id":"16245af2-3fab-438a-9670-b11a52942486"},{"claim_cluster_id":"f61b95fd-4ab1-43f9-b2f8-53b5afb90d43","event_cluster_id":"04c31a7d-6c2e-4822-91ce-feccb61d28bf"},{"claim_cluster_id":"192dfe82-fc68-4d4d-ae38-d6077567ed10","event_cluster_id":"c49a8079-c568-4dfa-a64f-74a395498785"},{"claim_cluster_id":"a3657e1e-0716-4d64-9a9e-572ba20604c2","event_cluster_id":"6e309345-7a1d-497c-b9aa-287116558129"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"0368ead8-8d25-41a1-9249-88baff9335b0"},{"claim_cluster_id":"958b1512-4a3e-4d41-927e-a3072dd9e9ef","event_cluster_id":"dec6b876-cff7-439a-bac8-9b6a2c289ef2"},{"claim_cluster_id":"869cd99e-564a-4420-981f-b385e7b7bceb","event_cluster_id":"68995fc4-d783-494b-a9d8-283e32c04543"},{"claim_cluster_id":"63bcdf8d-5d7d-43eb-b5b5-735ed74b200a","event_cluster_id":"c7bbd075-2e34-4018-bab2-225944afb981"},{"claim_cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","event_cluster_id":"4a315717-0c5d-48f0-b376-1a12c3498c7c"},{"claim_cluster_id":"d5dab78c-a52b-4ef8-8000-44988a029a7c","event_cluster_id":"34dc1cb7-40ca-44c8-a250-8a0dace843a0"},{"claim_cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","event_cluster_id":"56c30444-c8fe-46f9-af30-b0924f71761d"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"f5769a88-6f55-4990-ae69-e5747ba1c948"},{"claim_cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","event_cluster_id":"b8f6ce4f-4115-477a-9fac-602b955a0de8"},{"claim_cluster_id":"e60b32d7-dd12-4868-82cb-0b73bd6ac71a","event_cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56"},{"claim_cluster_id":"0d813aeb-360a-48ec-afeb-778e533504c7","event_cluster_id":"8af38eb1-9c6b-4cd9-9f2c-55e927900928"},{"claim_cluster_id":"5ac433e4-bd1e-455d-8c24-e981eb354d77","event_cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"},{"claim_cluster_id":"c0414ded-b694-4e4a-b7f8-d2835618be1b","event_cluster_id":"d5b448d9-eec8-4c71-b5f7-f99ea16eb286"},{"claim_cluster_id":"56d92634-56f1-4385-a700-927cf573e5bc","event_cluster_id":"010bfb3a-2b97-43f6-870c-f3dfb129b9df"},{"claim_cluster_id":"a222dd36-fddd-41d8-956d-d735c7c4c6bb","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"335213da-43c0-415b-b902-6fbd946881b7","event_cluster_id":"a80f445d-229b-4be7-a694-df00afa0ebff"},{"claim_cluster_id":"4fc00d95-d399-4677-9437-13f7e6f573c4","event_cluster_id":"a5739240-460a-4fd1-b5eb-223091bc040a"},{"claim_cluster_id":"6719c4cd-0e09-4c15-af9e-7f2bffedb3e3","event_cluster_id":"fffc483f-c841-4109-b9e1-d2ab5730fe2b"},{"claim_cluster_id":"04fa98cf-7cbb-4ec9-b84f-6d1c0570075e","event_cluster_id":"659e57e4-8954-498d-b047-7eb33a601210"},{"claim_cluster_id":"2a0a6106-78d5-46ad-ad52-e0296bf7134a","event_cluster_id":"72a5de9f-6386-4a16-880d-e374cb327abe"},{"claim_cluster_id":"bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a","event_cluster_id":"2981a7a3-8893-4aea-93c8-d180660c675f"},{"claim_cluster_id":"6dd833f9-26f5-4505-8729-234f3f5eeeb4","event_cluster_id":"74b5a9f8-d64b-4e6b-9562-84c68b5337c2"},{"claim_cluster_id":"d17d8e48-7844-4b9c-9bc0-e31d87299aef","event_cluster_id":"367c1ab5-4267-4b68-a2ed-2893d2797c11"},{"claim_cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","event_cluster_id":"01bab4ca-5ac0-4d57-8f20-7bea2afbd031"},{"claim_cluster_id":"95469f31-02a2-4069-8577-33c92dddd21d","event_cluster_id":"5241cd80-7c22-4aa4-92c3-aaf01b6a8d68"},{"claim_cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","event_cluster_id":"11ad6c89-9a64-4385-9a81-dfa3787cc401"},{"claim_cluster_id":"a789dff6-b07a-42f9-812b-05be84eb01d1","event_cluster_id":"ea917d1e-f3f8-41ef-93c6-2a9bfc99aac6"},{"claim_cluster_id":"46a0b407-50f8-4cc9-968a-6955a0540862","event_cluster_id":"ecec86b9-e0c2-4698-b5d8-0631850621a9"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"79a31826-be43-4bb3-80ca-3a1482a7949f"},{"claim_cluster_id":"4a042392-1467-4ea4-a1a6-548cd972a82d","event_cluster_id":"9674610b-7b1f-4315-90d0-0aac1ad7fa99"},{"claim_cluster_id":"a72e319a-9e87-40b0-a2c4-a95e4857ac8d","event_cluster_id":"eea0fa94-e771-4e8e-a675-3b0499fa98b9"},{"claim_cluster_id":"947a0b8b-01e0-44c9-8ebc-c9da3eecde20","event_cluster_id":"b454bfa6-3d84-4f22-a166-5f84ce0bf756"},{"claim_cluster_id":"4bda17b5-0897-437b-9ad7-ab5783ada079","event_cluster_id":"7869af70-2ee4-4af6-b749-30538201cdc4"},{"claim_cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","event_cluster_id":"00d660d9-94af-474c-8e79-c16ac62cbef7"},{"claim_cluster_id":"6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a","event_cluster_id":"203f76bb-0a3d-4ccd-8cba-09629dfeec98"},{"claim_cluster_id":"4370b159-681b-41a0-8da8-22c407b09da9","event_cluster_id":"a7acdb17-a586-4af4-bbd7-68b913003d4e"},{"claim_cluster_id":"02c78b1c-dd55-4ba6-a345-d21fd27d3214","event_cluster_id":"1d2ddf8d-adbb-42d0-bc0a-c14744855316"},{"claim_cluster_id":"1e8d5556-2c0c-4097-b606-9907a5dd2afc","event_cluster_id":"c7c8c6d3-cdc9-47d7-8f45-165280d3560a"},{"claim_cluster_id":"53ddceb6-33d2-42fd-849a-253f21907d2a","event_cluster_id":"ea5e4d14-d784-48f0-ab38-f454314db96b"},{"claim_cluster_id":"daf0b3a1-53f1-4b47-955e-785030ee3839","event_cluster_id":"7d0b4f2d-8055-491e-a0df-31787da0b9a8"},{"claim_cluster_id":"bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c","event_cluster_id":"1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b"},{"claim_cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"2706ec99-75d3-433d-ab95-f5c524eb1832","event_cluster_id":"73900380-dcd7-40a9-bff7-af4dd25e907d"},{"claim_cluster_id":"31d339ae-2342-44f9-a909-e299d2c4eccd","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"057bcb05-f915-40a6-9a44-d57aa6602574","event_cluster_id":"54390be0-8660-4904-8b7d-c97b603bc1ce"},{"claim_cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","event_cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de"},{"claim_cluster_id":"7c8b94c0-08bd-43e2-9b5a-418ff416c274","event_cluster_id":"53c60ecd-a401-4cd8-a176-63a07a0b82bf"},{"claim_cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","event_cluster_id":"3a4ae54e-e7b7-47e9-984e-62601ed45ab4"},{"claim_cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","event_cluster_id":"d7fa6886-1236-4402-9039-11c8f678ba45"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"a5124b94-6b98-447d-9c53-5100339210c5","event_cluster_id":"758c5e50-7f9a-4e26-9df7-02c7b0095788"},{"claim_cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","event_cluster_id":"75a5f06e-b690-4ab1-b016-65c86c1b4940"},{"claim_cluster_id":"68ff85cf-74e5-4234-a53f-6dba1aacb444","event_cluster_id":"bb5356e7-f071-485f-8695-919ba1db8606"},{"claim_cluster_id":"9fc65438-2baa-4ecf-a802-ddd71c4ed907","event_cluster_id":"833754ff-abfd-4996-b62a-92904373fd3b"},{"claim_cluster_id":"756b0f02-73cb-49a8-bdd7-27690bdeb637","event_cluster_id":"01f44311-0ef8-48af-a616-086ce88e4356"},{"claim_cluster_id":"098acc21-62ca-42b4-8206-4df179ae28c3","event_cluster_id":"a5739240-460a-4fd1-b5eb-223091bc040a"},{"claim_cluster_id":"76a80e87-389e-4e6e-9595-1b220839fd20","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"c831921a-fda1-47ba-83e1-1042bd97f245","event_cluster_id":"48bb955f-2782-4b10-b519-1e1e1206fc7f"},{"claim_cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","event_cluster_id":"4b572207-fd2c-4388-8ae9-d177ee557903"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"5238def0-ccfb-4f27-b836-f20f9b7dd70b","event_cluster_id":"8a0c3eda-5944-48c4-883c-6f01e773d494"},{"claim_cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","event_cluster_id":"4fa8e557-bb3e-4afa-89cd-33ec7b315e73"},{"claim_cluster_id":"f14e0258-b8de-48c8-96bd-31550d005b4b","event_cluster_id":"6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"},{"claim_cluster_id":"c721dd3f-abaa-46f4-b0b3-0998badfc28c","event_cluster_id":"d2698d5d-a9c7-4753-8264-b469e84de09c"},{"claim_cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","event_cluster_id":"626e9a9b-6995-4100-8ffb-53ed10359203"},{"claim_cluster_id":"32f9804d-d015-4846-99e2-90dd09953704","event_cluster_id":"2b3f127f-efff-44cc-83bb-012f860b4fc1"},{"claim_cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","event_cluster_id":"7301fbf5-a19c-4247-aac6-e3d55981cf96"},{"claim_cluster_id":"4c9a1f90-fd90-464e-8a7b-831a736d5b19","event_cluster_id":"678b3718-1825-40ce-8b76-3f1e30facae7"},{"claim_cluster_id":"b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4","event_cluster_id":"9c86d7d6-beed-46e5-8bf4-a9b09bb7cc58"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"e0932d8f-119b-4dcd-8100-b5fb6b62417a"},{"claim_cluster_id":"a023722f-ed95-4d7c-9c3d-0d405ad7a2c4","event_cluster_id":"43cb3cb0-9dc6-46db-91b7-d99bcaa7a443"},{"claim_cluster_id":"97b36cda-ba8c-4a83-864b-060595445ba9","event_cluster_id":"163f1d1d-a78f-492c-b769-5b6a7b1465fa"},{"claim_cluster_id":"b40ccc38-63a5-4a58-8bbb-6242768fb158","event_cluster_id":"6f4705cb-b438-4a8d-84e2-59fd3445f3af"},{"claim_cluster_id":"d669c1ac-c710-4975-98db-1c778f28ee4c","event_cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242"},{"claim_cluster_id":"489bde91-1bfc-48d6-aae7-de380d23d205","event_cluster_id":"6fad579f-d261-4337-bd5f-1776b8d945c8"},{"claim_cluster_id":"4de7b868-bb12-43db-9bc6-efbf0705904a","event_cluster_id":"2a58b8a4-48d6-4d79-a6a6-51d7d778b6e1"},{"claim_cluster_id":"b523cd60-7c0d-4c50-b41c-3522aed9c4b1","event_cluster_id":"1616bd8d-8966-4c95-b316-b97e2fb92058"},{"claim_cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","event_cluster_id":"926c487a-2b3f-41e8-acd8-d984df721c84"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"0d1a4169-975f-49a7-9f31-390c351eb65a"},{"claim_cluster_id":"fbc30c99-229d-49c2-8ecb-ce9a62431408","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"4a91c427-d613-4080-adab-a06fc13d13ac","event_cluster_id":"b985b53e-1d8b-45e2-8b3f-823f5bdb2380"},{"claim_cluster_id":"289e5c59-c24f-465d-931a-b56b54bc982f","event_cluster_id":"0d5b0cde-5145-4f38-a41d-e29b3956da5e"},{"claim_cluster_id":"435bc534-7da4-4fec-82cf-af0f2a0a282a","event_cluster_id":"1e5faa7b-e696-49d7-be88-e86b8468f738"},{"claim_cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"e1f9f42d-4c64-42c8-80ee-89170b717dbd","event_cluster_id":"6acfc858-1016-4e78-a1e1-7d809680381e"},{"claim_cluster_id":"1c24fe42-ed01-4d5e-85a3-6011ab09ff6f","event_cluster_id":"928155fe-b009-4dae-a22f-c56106f4b853"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"a3015153-afe6-4168-9a99-d14bbbdd401f"},{"claim_cluster_id":"9769a072-502e-4c26-bce2-57d4532d25f3","event_cluster_id":"d3c16aa9-3593-44e3-b641-54f418736f76"},{"claim_cluster_id":"07ec2e30-02bb-47d3-9b4c-32b7c841fb33","event_cluster_id":"31a83c0d-3856-4e30-82d4-769416b594bd"},{"claim_cluster_id":"81062452-735a-45ec-ae26-d06b90c45ed4","event_cluster_id":"18e3c7ef-4d72-40ea-ad9e-2d600cc1b21e"},{"claim_cluster_id":"f833277e-e62d-4240-a8fa-fd6d79db3c79","event_cluster_id":"7815f5ae-d441-4f71-b0e2-771810097e05"},{"claim_cluster_id":"3a7c04bf-2c54-4817-990d-55771d584811","event_cluster_id":"3b570036-015c-4669-a1c7-9124e256f407"},{"claim_cluster_id":"6103c4f7-8bea-436e-90d7-0ed75fe275c5","event_cluster_id":"69bdd771-bee0-4047-b696-6cda0e3de3f2"},{"claim_cluster_id":"e15501de-8202-4040-803d-8b5cbf6cf53e","event_cluster_id":"56d99389-f62b-41f0-b4bc-d85869083e3e"},{"claim_cluster_id":"62d8fa29-aaab-4f66-9532-5fb34686e56f","event_cluster_id":"f5bdb13c-8dca-44f0-8aa1-f75785f668e5"},{"claim_cluster_id":"fcd78a45-418d-433f-807b-b94b3ba2cade","event_cluster_id":"c8744ddc-73ca-4b76-bc5b-2e4d00f4bba9"},{"claim_cluster_id":"43b3601d-6d6e-43a4-8cdc-72cf4aa80640","event_cluster_id":"f1b5fe76-d258-4eb9-9621-ec9dac4e7f52"},{"claim_cluster_id":"340bfd8b-2131-4805-ab13-01e1c97ec008","event_cluster_id":"9e59aa88-1912-40bc-b111-4817591aae4d"},{"claim_cluster_id":"f7f1bbb8-f068-46fa-acbf-d579d1b4e308","event_cluster_id":"52457cd6-b07c-4e34-b96e-c3d2ac06f2d5"},{"claim_cluster_id":"f210a15e-3afd-4f52-8da2-de7a59e25377","event_cluster_id":"0e68f81d-43a7-45ed-8f07-1f52cfdcdd62"},{"claim_cluster_id":"7afb7680-3722-423f-b129-7076bfb88092","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e","event_cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875"},{"claim_cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","event_cluster_id":"40467831-07ba-4c26-8f13-029707ea2660"},{"claim_cluster_id":"6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1","event_cluster_id":"0c3b0687-d7a3-4aac-ace5-4b4027adcc13"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"02063354-1cf2-4e4e-a749-ce91914994ae"},{"claim_cluster_id":"83965363-a851-4083-ae10-33f90da464da","event_cluster_id":"3b56c579-39c7-4dab-b918-56f22f3eec67"},{"claim_cluster_id":"2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37","event_cluster_id":"428b927b-4796-43a8-8135-01b21725b127"},{"claim_cluster_id":"43c40092-a570-4909-9a7c-2090f95182b4","event_cluster_id":"d2dbc116-d919-422e-b972-f5d26fbf7db6"},{"claim_cluster_id":"71cd6d97-dc20-4f7e-b7c6-5d5b5186e201","event_cluster_id":"325bf549-47cd-452f-95f4-f8b56d9739b0"},{"claim_cluster_id":"fe10e346-5245-4859-9317-c6ffae804527","event_cluster_id":"1a36fb41-5917-46f9-abb2-91e9032c6071"},{"claim_cluster_id":"c56c08cf-6265-4f43-9208-61aa17304ed8","event_cluster_id":"27cb0d3d-03d0-4c0b-8af4-dae39953059e"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"84a0d215-8113-4569-a05e-d15e5c91d360"},{"claim_cluster_id":"81d9d830-fe0d-4e6e-bc5b-8d4c5f74f4e0","event_cluster_id":"6ca3fb21-cb25-40c5-9b5e-3ce14f640344"},{"claim_cluster_id":"7ef8f454-db4c-44bc-85a5-523eff6a595c","event_cluster_id":"ccd39f23-25f5-4e91-a253-3e3574d7d504"},{"claim_cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"ae7124a9-0441-414c-a93e-4e31fac08e18"},{"claim_cluster_id":"3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1","event_cluster_id":"159512ee-03be-4a2a-b7f9-1691ffdb67cc"},{"claim_cluster_id":"1fc4c0cc-9a41-4ae8-9970-3b340b704e77","event_cluster_id":"7e03d5b5-4b07-4e72-b62b-55465d7f9333"},{"claim_cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","event_cluster_id":"5e83ce8b-b525-4867-8caf-5b4d780a4a6c"},{"claim_cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","event_cluster_id":"2b2067b5-dfbb-4340-b88b-e5f769120fc0"},{"claim_cluster_id":"e35fb8e9-42cf-4ef0-a512-d7be06ad99e3","event_cluster_id":"92c29e5b-570e-405e-92f0-4969ddf38528"},{"claim_cluster_id":"f0be01ea-d71b-4521-a52b-360c419bf286","event_cluster_id":"c711195e-092a-41ee-984d-299705596d70"},{"claim_cluster_id":"5f5fe60b-6bf8-4f80-be3b-0dcf885c1171","event_cluster_id":"bf5c16e4-64dc-4dad-a15b-31db258dc134"},{"claim_cluster_id":"06f782f7-82f3-4b4d-a941-de5952ae3f6b","event_cluster_id":"d47510b3-4df0-487a-a8c5-1177c915ed1b"},{"claim_cluster_id":"16e980af-79a1-4255-8ad0-56ca61ae3b8a","event_cluster_id":"b4515840-1ee4-450a-89e4-256ed3a5260d"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"9a26c9bd-36a9-4c64-8680-f0a2265878f1"},{"claim_cluster_id":"d8515ae8-12a5-4f84-b01f-bc10b41b19e0","event_cluster_id":"31d03aa7-f36f-4c28-8ed1-5c9c9c77acf6"},{"claim_cluster_id":"860407b5-0931-4ba2-9dbd-a0078e94e9c6","event_cluster_id":"c7898fe7-8ae8-4977-88ae-a56e6d146778"},{"claim_cluster_id":"be4a2385-74e7-4ed5-8c71-c890af870db7","event_cluster_id":"9f734692-8c1b-45a5-98e1-623a0369fed0"},{"claim_cluster_id":"b5be89cf-6e40-4238-b7c0-13411fa17ce6","event_cluster_id":"f5cb17c5-09b2-438a-8af3-1ddc4e587641"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"98c5d764-86f9-4cd2-ac58-1dae1f5811e9"},{"claim_cluster_id":"bbf49577-7eda-4f96-83ed-753d3b9cc708","event_cluster_id":"6e881517-8e9f-47bf-854c-c29084f1a26d"},{"claim_cluster_id":"eb4aeb04-6d38-4eed-9989-773ac30f14e1","event_cluster_id":"8842f019-f536-48be-a730-88d7032d791e"},{"claim_cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","event_cluster_id":"d7ed508d-e43b-4e54-a0c0-6807c3338527"},{"claim_cluster_id":"a7436ce6-07d0-45e0-8628-2de252e4cb46","event_cluster_id":"d7c2bd39-22ec-4271-8c63-6ddb8efeced9"},{"claim_cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","event_cluster_id":"d56cc903-0bed-4718-9fc5-602c188caa16"},{"claim_cluster_id":"13db6364-301c-4a4a-b13f-69262abf41bd","event_cluster_id":"ed0d704f-d33f-473d-9c87-1978cd551cbc"},{"claim_cluster_id":"930ae324-24b9-4353-aa17-35d5e069f64f","event_cluster_id":"19f144a9-ec9c-4a9b-89c7-b1ca850240da"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a"},{"claim_cluster_id":"6f9a5f86-ba12-43df-aa33-746615605f47","event_cluster_id":"dd01fe5a-45fc-4f73-94e4-2d244f396aa4"},{"claim_cluster_id":"89cac161-a6f0-4315-a880-1662cae50313","event_cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a"},{"claim_cluster_id":"de6ada25-e81a-4f5a-97f6-0053df68ea0b","event_cluster_id":"9179b891-9dc1-45be-ab4c-6b2e9fbc156a"},{"claim_cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","event_cluster_id":"c7ac427c-82e0-477a-a03d-4c9be54cce85"},{"claim_cluster_id":"61784f3e-1c50-4b37-9db4-0fd1ec458127","event_cluster_id":"0fae2f14-66ec-4594-b5a0-1588a0fa8339"},{"claim_cluster_id":"ad4fa6da-197e-4295-b610-c2f934cdd3ea","event_cluster_id":"d811e7ed-7bb2-4a03-a5a1-75a044ab14eb"},{"claim_cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","event_cluster_id":"4c81571d-8516-4f35-b047-353d1a6e0a6a"},{"claim_cluster_id":"644ce0a3-b992-4dbe-be7f-558277802f15","event_cluster_id":"9e47c442-5161-41a4-b305-ebf54f272e75"},{"claim_cluster_id":"aafb6f56-e150-4de6-8f24-4e8fe467b23f","event_cluster_id":"daa3efba-7375-4b5d-bf2a-6a5216d25c83"},{"claim_cluster_id":"14d8e253-98cf-4b3d-83df-8665b7ba0f5e","event_cluster_id":"4eb605cc-1913-4af0-aeb3-6e1b6f05c980"},{"claim_cluster_id":"9d400cbf-08ea-4c02-941a-80cd2d3e517a","event_cluster_id":"44d2e850-7a7c-430d-95ed-40c5cabf8096"},{"claim_cluster_id":"07b6bde9-eeca-4fea-b3c2-39093320ea05","event_cluster_id":"8f6347b0-b76f-45e2-b8d8-b8a8c9dc9e26"},{"claim_cluster_id":"9fa27866-4911-4f0d-8135-cff4b7e597db","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","event_cluster_id":"bbc6fef6-c552-409d-9152-d8abd3a15ae3"},{"claim_cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","event_cluster_id":"c23b1bec-a608-4fc1-a229-2a8f9b59a27a"},{"claim_cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","event_cluster_id":"909c2544-65ad-4eae-8bbb-f43d077750aa"},{"claim_cluster_id":"b36a42d8-1bb3-483d-b77f-bd28630b0e30","event_cluster_id":"642bde4d-512c-4efe-a811-93209336bdce"},{"claim_cluster_id":"565749fa-0214-435c-be6b-1a2ffed6aba1","event_cluster_id":"0005306c-9f05-4c24-afc9-11ea1bc90d4d"},{"claim_cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","event_cluster_id":"4061c2fc-ed9c-4f22-92dd-291aa2df6a90"},{"claim_cluster_id":"c6f7c193-f407-447c-a10f-3ea5292ea3e8","event_cluster_id":"d21c817e-4d9f-4479-93a3-693ea677e1ba"},{"claim_cluster_id":"62e8f214-855a-45b7-8de5-a667d22dd7f0","event_cluster_id":"065f4f08-9205-4dff-8de0-542c6bb45da9"},{"claim_cluster_id":"2c72a6d8-6edd-4d3a-9563-d326950bc8da","event_cluster_id":"edab64d5-5e0e-4c94-9892-79b39580b98e"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"b6472eb8-adb5-40da-b075-e00e04ed2920"},{"claim_cluster_id":"f7f1bbb8-f068-46fa-acbf-d579d1b4e308","event_cluster_id":"89deb9da-1363-4a27-b0dc-19089a829274"},{"claim_cluster_id":"9cfc641f-8857-445d-a3fd-0b6e7a1c0cf7","event_cluster_id":"51c88d49-73a0-41fe-a608-ab3aabe81173"},{"claim_cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","event_cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875"},{"claim_cluster_id":"619d0e6c-df2c-4164-aaac-ccaba7c311a6","event_cluster_id":"ab96918c-daa5-4c62-989d-c9617e4f6b5e"},{"claim_cluster_id":"f96fdbdd-0664-4366-b80c-72a8405c4f44","event_cluster_id":"030634a5-ed95-477b-876c-290912b18446"},{"claim_cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","event_cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"26b806a5-30f6-4312-bfd4-c6984e3b4d30"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e"},{"claim_cluster_id":"ce07721b-5347-4d52-81aa-7a7c68338485","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"8d8dbda6-96b3-4738-b7a8-777f920a39be","event_cluster_id":"801c5c4b-a47b-4b2c-ae4b-a35937597f3d"},{"claim_cluster_id":"afdf0794-a58d-44cd-b1d0-aec7b0adc12c","event_cluster_id":"90ab0ebb-511c-4032-8a6b-928969e4d009"},{"claim_cluster_id":"c07ab2cc-cb47-49ae-9148-a023065f7018","event_cluster_id":"178a55a6-f879-45f8-85be-38fbb568a251"},{"claim_cluster_id":"8cb34140-24ef-4173-9390-c1f84800160e","event_cluster_id":"4da18b15-13e1-4abd-966a-5a691b26fe59"},{"claim_cluster_id":"a75c6491-7fc4-4904-9a47-b176fcc90a36","event_cluster_id":"fc3e8d2c-52bf-485a-a373-7853e3f353ec"},{"claim_cluster_id":"62bf1a53-b840-4c52-b1a8-6f2e98e4c3d2","event_cluster_id":"c9e1ed1d-b28e-452c-9f9c-c8e37181b84d"},{"claim_cluster_id":"655e754e-33e7-4bf2-aabe-264f18d499a4","event_cluster_id":"731d7658-b5f1-4356-b7c0-c3b8c97cac8d"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"a49c6bf6-4bdf-4111-8400-ae8603304250"},{"claim_cluster_id":"dcc40b89-996b-46da-af7f-ec64a05c6ee5","event_cluster_id":"6bd1a1b9-8c5b-4543-9007-11872574ea9a"},{"claim_cluster_id":"5bc0db5b-3192-42d4-a343-00cfcacc4499","event_cluster_id":"ed5e7bda-f24a-4769-86cb-26613eecfebd"},{"claim_cluster_id":"371b7329-3c6e-4297-b746-d77ae2db1f6f","event_cluster_id":"660ce2a3-2e3d-4961-a97c-865ff4c461f6"},{"claim_cluster_id":"2a9019de-d820-4155-a78b-fc972ec57552","event_cluster_id":"a29f6f46-43ef-4252-a308-d9b452074037"},{"claim_cluster_id":"e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9","event_cluster_id":"fef7b3de-7af1-40a4-a0ec-544cb6b0b0ff"},{"claim_cluster_id":"48358541-e77a-4c9f-81e2-7af006f34920","event_cluster_id":"b93f0980-3e05-4353-b9af-768e6f562f26"},{"claim_cluster_id":"c721dd3f-abaa-46f4-b0b3-0998badfc28c","event_cluster_id":"7d0b4f2d-8055-491e-a0df-31787da0b9a8"},{"claim_cluster_id":"53a5cd16-ea33-4c3e-8f8f-0d495c63c479","event_cluster_id":"1e5040f4-1599-4a16-abf2-bb352e20053c"},{"claim_cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","event_cluster_id":"7ae0d854-6d40-40af-a578-9fbba79fb394"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"4c9bd8ca-0977-4844-9921-072e396e0fac"},{"claim_cluster_id":"4a2e9d4b-d2bf-4512-a149-283851028578","event_cluster_id":"2ed0e84f-d233-4164-b228-6208473d317d"},{"claim_cluster_id":"94076701-ef33-45db-95b9-6fd0d66deba4","event_cluster_id":"82abb955-d502-4dd6-84e4-ff5a58485230"},{"claim_cluster_id":"3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d","event_cluster_id":"7303fe0f-e412-4fb9-accf-41194e4059f2"},{"claim_cluster_id":"c83250c9-87a2-4ec5-822a-e2413ca91c91","event_cluster_id":"9324a7f5-d024-4c3e-9141-5fa03af67754"},{"claim_cluster_id":"990306d6-263b-4984-88f5-4be9fc326334","event_cluster_id":"c29a246e-69bc-464d-a998-2ee789508141"},{"claim_cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","event_cluster_id":"d191d96a-6233-4306-907d-1beabb6fc9c7"},{"claim_cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","event_cluster_id":"5c683e3b-456e-40af-9840-3af3a5900ece"},{"claim_cluster_id":"8ff59597-495c-4ba5-b797-afb88f6bfce0","event_cluster_id":"ef96e980-1163-49a7-829e-855a0719a797"},{"claim_cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","event_cluster_id":"7ae0d854-6d40-40af-a578-9fbba79fb394"},{"claim_cluster_id":"666873ec-e76e-4f8a-8d96-7a31c5084ac4","event_cluster_id":"30a2e818-400c-4443-9905-7ab130b7ac97"},{"claim_cluster_id":"f65b5094-1e51-442e-b444-de0d25f1fea0","event_cluster_id":"87f98626-d2f4-4a84-8a1b-fba4417798d7"},{"claim_cluster_id":"103c6b31-e860-4fde-bc3f-de3b1bf5f689","event_cluster_id":"0b109e58-1cde-4c32-aed4-12ba82ed273a"},{"claim_cluster_id":"9a73096a-390b-4f9e-a044-22f30734ce69","event_cluster_id":"46233164-6ed4-4e93-aaed-ca823711dcc5"},{"claim_cluster_id":"10cadbd2-7261-4295-9f88-df0f9a246b5b","event_cluster_id":"d21b19ea-6813-4e8b-8df5-e67ed7dfc0f9"},{"claim_cluster_id":"e935bf33-7d4f-4ee6-8636-94e91a064afd","event_cluster_id":"d789b1ed-51e0-4f7f-953e-3eaabc59ca49"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"98a97f12-7d1b-49e9-8178-578b2d656f88","event_cluster_id":"67852dd4-618d-4a28-8987-e12077575820"},{"claim_cluster_id":"a031766e-aaad-4e78-b0e4-bd1cf2fc1a66","event_cluster_id":"8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"ee0681d9-e912-4091-8f01-0d69df3bcbee"},{"claim_cluster_id":"ed42b61a-7c55-44a7-aac6-78560e6e139e","event_cluster_id":"4dc97343-8657-4d38-b2b2-1129b6d10818"},{"claim_cluster_id":"1da5d8fa-d5b3-4c58-9989-3b5775687e42","event_cluster_id":"0ae66dca-634f-424b-80e9-5fc4b2615b98"},{"claim_cluster_id":"d281c55d-162e-4c45-bdc4-8fddc9bff858","event_cluster_id":"8ea45448-137b-4d92-9e93-e6f5676fad3b"},{"claim_cluster_id":"078f370f-a761-435a-a7fd-aae948eb479b","event_cluster_id":"1b56d151-49c8-4483-a185-2c0622a64692"},{"claim_cluster_id":"13b8e657-b1a1-46e6-ace5-fc6a57928a32","event_cluster_id":"fe1c6b54-9f28-4390-8b18-685bcbf44298"},{"claim_cluster_id":"5fec9a51-560a-4b1e-ab7c-cafcf47ba675","event_cluster_id":"c9eb6d86-6b17-4232-b3a7-29de5feb80b0"},{"claim_cluster_id":"60a1acab-79cf-438f-96de-dbff294bd2e7","event_cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67"},{"claim_cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","event_cluster_id":"e5320752-1012-4ce5-880c-e80ddb6ab4ee"},{"claim_cluster_id":"50dbe9fb-6818-4777-990a-3ab01ab3659e","event_cluster_id":"3e87987a-c8cd-4616-922a-e297f103d0fa"},{"claim_cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","event_cluster_id":"5e115001-bb2f-45b1-be83-78b8766bff77"},{"claim_cluster_id":"5518570b-ceeb-400e-8720-a531292d57ce","event_cluster_id":"0630459a-a055-49c4-959a-918cdf49936f"},{"claim_cluster_id":"983e06bd-8aef-468f-888f-6f39b0353693","event_cluster_id":"4df09684-8f05-4939-a1b1-6f51c32b4b06"},{"claim_cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","event_cluster_id":"02ce3ced-8a21-496b-a44b-583010f8f279"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"50cf77d2-56a8-4588-8c16-f417874c0063"},{"claim_cluster_id":"a3463468-dce8-4063-85c5-ecdc64691fed","event_cluster_id":"c974a5fd-a8a2-42a7-88dd-b3f3e7fd1ad6"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"4785bab4-a99a-4e40-9619-5133dfc2b141"},{"claim_cluster_id":"489cefd4-e6ef-4f49-8a70-8d8f7bc512bd","event_cluster_id":"0dde3660-e0d6-4644-aa81-6e184dc6e068"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"99042c58-6307-43ca-ac61-061cf8a5ba75"},{"claim_cluster_id":"acc5b6d2-0057-4a25-83c7-3d3bbd4031e9","event_cluster_id":"47544927-be6e-4238-bfa2-7d12e902c9e4"},{"claim_cluster_id":"8d676e91-6fd3-47df-8a59-7b88ff3f09cc","event_cluster_id":"6fd0cd66-7572-4a5e-b9bd-53c174988cbc"},{"claim_cluster_id":"6926f592-0807-43c3-9eb1-74f903b009ff","event_cluster_id":"eb8c09b3-c22e-4c14-a55e-41e86bc54809"},{"claim_cluster_id":"84a0c048-8b19-4f73-b588-caa191d08d54","event_cluster_id":"c8fcfafc-5e25-4d83-82fb-dad89f0cb085"},{"claim_cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","event_cluster_id":"fe288be5-fdf6-4f12-bacd-523a94599a41"},{"claim_cluster_id":"f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1","event_cluster_id":"7645928f-b607-4113-a8d9-4afacf4bc042"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"cd4a5f4f-0722-49d0-a0a8-588c6f486479"},{"claim_cluster_id":"1dc1ea0e-ecc0-4a99-a555-3574b46d8688","event_cluster_id":"bf10b6e6-7de4-499b-bb6d-a9e69524994d"},{"claim_cluster_id":"f10deefc-8ed5-4516-8cc2-3ba87195eac0","event_cluster_id":"6c18a3ce-fe35-45a7-99c1-4b725342cc8f"},{"claim_cluster_id":"82430ac1-c5b1-4777-ac21-a40819c2ad02","event_cluster_id":"b8594232-f9f8-428c-83d8-cd858f613031"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"d5f8926c-cfe4-4355-8a20-781d575d7616"},{"claim_cluster_id":"e6cb9f82-faa2-423b-984b-e379572890e7","event_cluster_id":"6e377c9a-0767-453d-bf0f-0a832d805a7b"},{"claim_cluster_id":"8e782418-3f83-48d1-a7d0-6c3daf34ed25","event_cluster_id":"1be22971-e6b7-4f57-b7f5-9c6d0cc3afbb"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"da057e1c-8692-4118-a2c6-f3b0fa767931"},{"claim_cluster_id":"ed1fef35-ea22-4436-b53a-1dc1f0380298","event_cluster_id":"17e1ec75-19f3-468b-a8ac-9a834a96fe02"},{"claim_cluster_id":"253e2fef-8100-4235-899c-96e9877535d1","event_cluster_id":"49c4c056-d70c-4a38-9178-06a4f74c1135"},{"claim_cluster_id":"42d845ed-aaed-4d48-a0e4-2928cc3ba602","event_cluster_id":"676e3412-2df4-4d29-844b-686d41a53c1e"},{"claim_cluster_id":"0119782a-5d22-485c-b58b-6c82b20e788c","event_cluster_id":"788ae773-424f-4215-9262-5847e02b117b"},{"claim_cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","event_cluster_id":"45c15578-ca19-42ef-8fc5-04e77034e4c3"},{"claim_cluster_id":"13b8e657-b1a1-46e6-ace5-fc6a57928a32","event_cluster_id":"6e17469d-ab2f-4f85-99c5-d4389227a162"},{"claim_cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","event_cluster_id":"0ab26e4b-97a4-402f-89ba-c8bf505907da"},{"claim_cluster_id":"be9b7361-8150-4e4b-9111-bac990c11d3d","event_cluster_id":"382c8bbe-8826-4b13-8317-0d73ee7eee77"},{"claim_cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","event_cluster_id":"32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08"},{"claim_cluster_id":"7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd","event_cluster_id":"d41f0247-c996-4fca-bb9a-db10717ce822"},{"claim_cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"e2dae5ce-65e5-4bf8-ac38-f452e98e9363","event_cluster_id":"31531356-3930-43a1-9c28-b7ad9753b67e"},{"claim_cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","event_cluster_id":"56c21a67-f093-4d7b-81de-a41cb3a3c896"},{"claim_cluster_id":"58cd12d0-b190-4e1f-826a-20e181a5c137","event_cluster_id":"89092280-296c-4fb1-844a-03436e7b7c26"},{"claim_cluster_id":"1da5d8fa-d5b3-4c58-9989-3b5775687e42","event_cluster_id":"62c364ef-d86a-4575-aa30-edbcabb6f794"},{"claim_cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","event_cluster_id":"31e7b652-307d-4f5d-a4a6-215892b2e421"},{"claim_cluster_id":"29e9fc0f-b1d3-428d-985b-aead08ce4e3c","event_cluster_id":"9de91220-8362-4c94-b430-300c675c23e5"},{"claim_cluster_id":"407486e4-c133-4139-9739-41644f65fa24","event_cluster_id":"664cfcc2-edf1-43a6-a432-be97b535188e"},{"claim_cluster_id":"a0d964f3-2911-42e0-a686-2f4aa48a2f24","event_cluster_id":"33378b17-6e0e-486d-a122-a219ecc02e56"},{"claim_cluster_id":"c4bd1c97-a831-4763-9c03-6a3cf69f7caa","event_cluster_id":"676e190d-f7b8-4cab-bf36-934dddda11c8"},{"claim_cluster_id":"1a247a51-e7fa-46f4-b0b3-659a03d784c6","event_cluster_id":"199fa239-0e31-40e8-a4f6-178a14d58cc8"},{"claim_cluster_id":"ae58d35c-53bd-40b8-b6d5-7fe4e15e229a","event_cluster_id":"388b5477-b8ee-43a6-9b4b-3bf87541cc1a"},{"claim_cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","event_cluster_id":"d1102194-5143-42ba-aac4-2f29e4d13736"},{"claim_cluster_id":"2a265a62-6ee2-460d-b6fd-ab72b8f23578","event_cluster_id":"ca0536ea-7533-4baf-adac-d1ee11b1604e"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"05021641-3e64-47c1-b3de-9319980f7bf2"},{"claim_cluster_id":"5765d283-f56d-43cd-b120-e8f9048e2325","event_cluster_id":"cfe9cc78-dae7-4fb3-9619-c934beac1286"},{"claim_cluster_id":"00a040a7-5456-47e8-b780-a67388e64219","event_cluster_id":"ddc5360a-1ac4-443b-9995-2e77ae3fa0fc"},{"claim_cluster_id":"14a12b13-500d-4488-86b9-0f65fe548f9c","event_cluster_id":"e342f418-21fb-447a-a1a2-0cf67132d420"},{"claim_cluster_id":"b61ba5b2-e28d-4cea-b7a2-78bed070aeca","event_cluster_id":"28aa9b69-c31d-45de-bec6-3308b64b4f24"},{"claim_cluster_id":"3bda7498-8cf1-4495-9ee2-307193fe0c3e","event_cluster_id":"82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc"},{"claim_cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","event_cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef"},{"claim_cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","event_cluster_id":"f2d1742c-c9b1-44f7-a4e6-abf20a37a569"},{"claim_cluster_id":"8d565c91-b887-465d-a08e-aff09b1e9e5b","event_cluster_id":"0c639465-7159-40b2-869b-06840b83505a"},{"claim_cluster_id":"f8755b86-ae98-461e-a3ac-2bd5b6ec4310","event_cluster_id":"baae4a32-5168-4c2e-a607-5bdb0996a9ff"},{"claim_cluster_id":"27fad854-f733-4ec5-8acb-b36e0c043d26","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"583320d2-3b7c-4cef-9dd1-9eeedce9bc81","event_cluster_id":"e95e8766-3999-437a-8b4f-72bf3c33a6a7"},{"claim_cluster_id":"95b428d7-1d28-45e2-a9a0-dd59bb6a0176","event_cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"00c62945-b485-438a-9d05-87baa1d3d907"},{"claim_cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","event_cluster_id":"983a818a-ed6d-40ec-af64-8e28da7e1bbd"},{"claim_cluster_id":"91b0db25-32e4-4e5d-a32d-911732cbec28","event_cluster_id":"236dacbe-2c11-46fc-a4a4-42464ed6f51d"},{"claim_cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","event_cluster_id":"4f0e7f6a-d847-4db7-a78d-684ba6b33ce7"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"493568a9-0e32-4b19-a041-15396f7c15b4","event_cluster_id":"524147a4-6ced-4285-aba9-4ef213b856f6"},{"claim_cluster_id":"c0e66b49-a2c1-49ba-be78-c28aff5c60cb","event_cluster_id":"7050bafb-b05d-4691-a1ac-89175bc41e54"},{"claim_cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","event_cluster_id":"497c65a0-d076-4ce0-b5c7-b89152ec15dc"},{"claim_cluster_id":"ad83e0a6-e572-4332-8ef0-01e05cdfa760","event_cluster_id":"40ef8151-52fc-4fac-bd6f-6b5534d3b754"},{"claim_cluster_id":"7dc48717-c562-4f7c-bcb3-b4a13374cc42","event_cluster_id":"e914c276-a8b7-4441-a77d-8a5108addc86"},{"claim_cluster_id":"7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1","event_cluster_id":"cc789a67-807e-4a18-9da3-ebd2233fa4d4"},{"claim_cluster_id":"a031766e-aaad-4e78-b0e4-bd1cf2fc1a66","event_cluster_id":"be6b5f43-b5a5-43db-8bdd-0c041f0efa31"},{"claim_cluster_id":"2a250092-9fac-4905-871e-1b18221951a9","event_cluster_id":"88abea30-b9d6-421a-b97f-a1fffe603d2d"},{"claim_cluster_id":"e9b05837-7f42-4f2f-bc7d-dca62a93d724","event_cluster_id":"eac477f8-1470-4d66-9ef8-e279e7d85edf"},{"claim_cluster_id":"07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a","event_cluster_id":"f5c9b8a2-ba8a-4c9d-96f7-5fdcef771d06"},{"claim_cluster_id":"b1951710-a9b4-42e8-b9e1-6ca4e5f12a31","event_cluster_id":"044fadd9-8b2a-4a97-a501-b787a29d182f"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"344f18e9-fdfb-4043-b1ff-09516022ac50"},{"claim_cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","event_cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"},{"claim_cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","event_cluster_id":"44663aba-7a2e-4439-ac72-295c1b77f6ca"},{"claim_cluster_id":"957456fe-cb84-4fb9-bc2f-3e775154a824","event_cluster_id":"a74b8cc1-b628-4659-9793-8906816c7cde"},{"claim_cluster_id":"06b8ffc7-c987-44a2-a2cb-8721e54e7da6","event_cluster_id":"9a7cfd6f-8532-4052-b526-1e4576483709"},{"claim_cluster_id":"a83fedfc-0f0a-49b0-9dae-3932f2ba6983","event_cluster_id":"c74eddc6-9017-4628-9942-40823cd7e30e"},{"claim_cluster_id":"8e9b5986-8277-45da-82c2-ab199cd3287f","event_cluster_id":"3cd947fb-d46a-4f38-9705-3c1f8700f549"},{"claim_cluster_id":"cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb","event_cluster_id":"e1f28336-0647-4e38-a5b1-a20d710717c4"},{"claim_cluster_id":"20b239ec-b263-4052-a330-5aad8ed1209b","event_cluster_id":"b558144e-22bc-4f5e-83f4-cf10e626dc01"},{"claim_cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","event_cluster_id":"1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3"},{"claim_cluster_id":"fca1885c-50ee-44f0-87aa-917cc35fd733","event_cluster_id":"c77f0d47-36a0-4f9d-86dc-1f10b0aee675"},{"claim_cluster_id":"7b4d9f3b-78aa-4507-8228-424f51cb5289","event_cluster_id":"ea0293f2-f4d0-4ae5-968c-0648ac0ad125"},{"claim_cluster_id":"27f40e5e-f571-4385-aef9-fcc4114989bc","event_cluster_id":"0c6f8f11-1c81-417d-bf01-df519f70e0fa"},{"claim_cluster_id":"d66fbbdf-0d3b-4c16-8077-654078280a83","event_cluster_id":"5c983b2a-2571-47de-87cb-902a1970e0f2"},{"claim_cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","event_cluster_id":"e47c3423-cbb6-4c9a-9b29-21416d12aba7"},{"claim_cluster_id":"210242d8-e5cc-4762-9912-b262084ebeb4","event_cluster_id":"2947fe08-3f19-4a83-826c-8d5e7d1e3368"},{"claim_cluster_id":"9fc7f408-c42c-485e-91c2-a72960ff3158","event_cluster_id":"58d2f307-4ee3-44ad-a765-c7a292798624"},{"claim_cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","event_cluster_id":"09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5"},{"claim_cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","event_cluster_id":"0fa8aef0-deff-4ac5-a935-94011ed8be80"},{"claim_cluster_id":"3d1eca97-f0cc-4fa8-9ff8-7ec9ee2b27e4","event_cluster_id":"77810a86-21b7-4267-8df5-dbf7f241aa35"},{"claim_cluster_id":"5edd935c-f1a4-4a6b-86a0-37894c0716f8","event_cluster_id":"3f6252b1-52a5-4e4b-a596-99c6a237551b"},{"claim_cluster_id":"04fa98cf-7cbb-4ec9-b84f-6d1c0570075e","event_cluster_id":"3d7cf308-ff2c-4ac9-a835-6773cc669257"},{"claim_cluster_id":"666873ec-e76e-4f8a-8d96-7a31c5084ac4","event_cluster_id":"6fa6425c-c799-413f-9698-b7928b5c5770"},{"claim_cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","event_cluster_id":"128ade3d-bda4-4b71-b956-463eb584089c"},{"claim_cluster_id":"42b71be4-55d8-4880-8083-4a89c8557de9","event_cluster_id":"57c95e6d-bb6f-4da0-b18e-99b9d5c69c0c"},{"claim_cluster_id":"76a80e87-389e-4e6e-9595-1b220839fd20","event_cluster_id":"fc5c504b-230e-408e-a170-afd09cbd04d4"},{"claim_cluster_id":"4feed713-e2b7-4de9-a6e7-cb0e0ca52183","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","event_cluster_id":"31c69d86-6651-4ebe-ab2e-087bf7193e24"},{"claim_cluster_id":"4a91c427-d613-4080-adab-a06fc13d13ac","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7","event_cluster_id":"bfefe16b-a245-4367-989a-c541df49bc59"},{"claim_cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","event_cluster_id":"ca0d7a2a-b8d2-4968-874b-aa3379e0dafa"},{"claim_cluster_id":"5d30cac5-2629-4bf5-9665-20ae87c1ec22","event_cluster_id":"a2a4403f-1592-434f-a0f9-d248d1684f8d"},{"claim_cluster_id":"152e2cd2-1d15-4787-b90e-76e34ac56ace","event_cluster_id":"99bc4095-29c0-47b3-81af-1811b5d01f5f"},{"claim_cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","event_cluster_id":"b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126"},{"claim_cluster_id":"c83250c9-87a2-4ec5-822a-e2413ca91c91","event_cluster_id":"1a416b07-503e-4fc8-8b1f-de51772ab7ee"},{"claim_cluster_id":"510b63b0-aea2-446d-8868-5c88431cc9fe","event_cluster_id":"6ce879b9-5872-4b84-9034-d22bedf950a0"},{"claim_cluster_id":"ed1ca8c0-7841-4109-ada2-99053838abfe","event_cluster_id":"54276cd3-4620-48dd-898d-2aae66e353c4"},{"claim_cluster_id":"be44c17b-cb3f-4a06-af5b-de816dfb4f56","event_cluster_id":"d48087d5-c16e-458f-9f3a-c0c434d8a01c"},{"claim_cluster_id":"7742ec5a-27ab-42d2-9779-df7d73a0cec4","event_cluster_id":"128ade3d-bda4-4b71-b956-463eb584089c"},{"claim_cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","event_cluster_id":"49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a"},{"claim_cluster_id":"ac35f635-837f-429d-a888-0720cf376532","event_cluster_id":"8c65cc84-ce1a-4345-89d7-20ee4e2bcf15"},{"claim_cluster_id":"5d2ff6eb-cad6-467b-869b-d4782bae2371","event_cluster_id":"c5169cd7-a9a1-476b-8658-0fe7fd1f0d44"},{"claim_cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","event_cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc"},{"claim_cluster_id":"734aba7a-e1ac-4a78-a926-3957017f7843","event_cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb"},{"claim_cluster_id":"3d2576b2-1572-432b-98fe-db8e768274d5","event_cluster_id":"dfebeea4-e8fe-4891-915f-29504d1d80da"},{"claim_cluster_id":"869cd99e-564a-4420-981f-b385e7b7bceb","event_cluster_id":"16e3503e-05e1-4d3f-9a7c-01b21a85311a"},{"claim_cluster_id":"84019696-e95b-4f09-b37b-dd61ce673e9c","event_cluster_id":"2032d3f2-f2a7-4cd8-9f0f-0fb6fbfe2fc9"},{"claim_cluster_id":"b6f111d6-8112-47dc-baeb-43c77c6392ea","event_cluster_id":"1379aa81-833f-453a-8fb7-08ae39840196"},{"claim_cluster_id":"818b32ce-b83e-40a4-b06b-dd4e2c09af00","event_cluster_id":"bca53d12-fc37-4cd1-9c2a-d9e494bc9ea8"},{"claim_cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","event_cluster_id":"66034097-f5ff-415b-b7cc-7775692bf89e"},{"claim_cluster_id":"da4bd748-3c84-4017-a93a-8247224fc32f","event_cluster_id":"cebd1d98-7547-4761-a012-89e58bf86f29"},{"claim_cluster_id":"bfd3bb04-3c5a-410a-b26b-81f569186264","event_cluster_id":"fae4a05b-8c8a-4da0-ae56-97672bb4bbb7"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"2d87e550-62a5-4ab5-8323-4c18213fedcd"},{"claim_cluster_id":"6103c4f7-8bea-436e-90d7-0ed75fe275c5","event_cluster_id":"0e1517ba-8541-4c30-8eb8-cab31577fd7c"},{"claim_cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","event_cluster_id":"f8d1571f-9c56-4682-8574-cd3b32ed6cc6"},{"claim_cluster_id":"2adce5ae-1669-4c77-b898-ed9abf7276da","event_cluster_id":"cb26f67e-804c-4c0f-8dea-81103afdf8ce"},{"claim_cluster_id":"bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75","event_cluster_id":"4ea6057d-751f-45d1-801b-72130ecef337"},{"claim_cluster_id":"dcf2ee53-8023-43ee-94fe-0207a7fb5133","event_cluster_id":"fddafbe9-dffd-4341-9619-bfc6fc256b34"},{"claim_cluster_id":"20b239ec-b263-4052-a330-5aad8ed1209b","event_cluster_id":"cd8e42cd-c833-432a-b12d-6040bca4f918"},{"claim_cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","event_cluster_id":"84ba9e08-7f87-4e91-abf6-4415ddb9a231"},{"claim_cluster_id":"66914632-689c-4d05-b834-b8904eae50cd","event_cluster_id":"0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5"},{"claim_cluster_id":"109acea7-1d98-4f39-a38c-6bb5919965c9","event_cluster_id":"967e4599-c3e1-4e81-bc7f-40bf2be021b8"},{"claim_cluster_id":"f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34","event_cluster_id":"a67a8b34-7ebc-467d-82f6-99ed35126409"},{"claim_cluster_id":"0aa10a76-1680-4566-9d3a-ebaa3e486aaa","event_cluster_id":"2aa6b6de-5e53-433f-9477-ca28d007cfea"},{"claim_cluster_id":"dfcf5731-89c0-4af2-a475-d7087b733644","event_cluster_id":"e73cd951-c537-451f-a279-08d6827059e5"},{"claim_cluster_id":"b98bb0fa-4594-47af-9069-f482aaa8d7c4","event_cluster_id":"4b5e2cb0-217a-4cdc-81e2-027874f8da18"},{"claim_cluster_id":"f6f15ea6-27bd-499b-a6fe-74d144b5ac0b","event_cluster_id":"f5b9ae68-f130-44e1-85ad-1d8a741fcea1"},{"claim_cluster_id":"c198c115-5575-4cd0-82cc-408f1b46a7a2","event_cluster_id":"abe48ef5-28d3-473b-b5c1-22f7c985121d"},{"claim_cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","event_cluster_id":"d020ba2c-1e1a-4bee-8860-bc381620b119"},{"claim_cluster_id":"7ac1c88c-d620-4c32-9f9d-5a780231627e","event_cluster_id":"4f70f4f5-9340-4c71-bf68-5b20071ff5b8"},{"claim_cluster_id":"6e7164cb-9f1b-4f72-aef4-13243fbf321c","event_cluster_id":"17aac7a0-8d3b-4164-8981-530ac6354022"},{"claim_cluster_id":"af183b48-72bf-4947-8e38-5272b737f76b","event_cluster_id":"13bc9125-818a-4eff-a1c9-96bf89586d78"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"086034d9-cc70-4cb5-b461-137099358741"},{"claim_cluster_id":"a789dff6-b07a-42f9-812b-05be84eb01d1","event_cluster_id":"ce789309-8080-466e-a3b3-2975047285af"},{"claim_cluster_id":"b686bd17-fb36-4b7b-9caf-084f8d91c149","event_cluster_id":"1bbcbe31-d9c2-415e-aa16-c9d78fd6946a"},{"claim_cluster_id":"c66251b2-ab53-4ca9-91b8-4229e4242200","event_cluster_id":"add21509-fc05-4fe6-a953-c98cc222477e"},{"claim_cluster_id":"9b129e4b-0540-473c-90ae-ff21e622eb3c","event_cluster_id":"c6d45751-df96-42cb-a762-00ec73441fe2"},{"claim_cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","event_cluster_id":"8d628785-9843-475a-bf8c-f7eff1bc8e38"},{"claim_cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"a3dda742-6a6a-4de7-ad48-8075110e3b35","event_cluster_id":"5c60b7c2-773f-4fa5-90cf-1511916b711a"},{"claim_cluster_id":"c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e","event_cluster_id":"4ae526b6-129a-4522-b79c-5fa5e53d2329"},{"claim_cluster_id":"6b12e24b-6d9d-4b0e-a169-260972b9ab69","event_cluster_id":"b76141ff-47b5-4e35-911a-5ea99a13c31e"},{"claim_cluster_id":"9fc65438-2baa-4ecf-a802-ddd71c4ed907","event_cluster_id":"5bde126a-9b98-4602-8531-f11f0ccfd92e"},{"claim_cluster_id":"2ac509be-786d-4ed0-abcc-15ecf7e6c4ff","event_cluster_id":"d748d1bd-38e3-44b3-b268-429f4615acee"},{"claim_cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","event_cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef"},{"claim_cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","event_cluster_id":"2d8f3813-2525-407f-8769-b0281d589d42"},{"claim_cluster_id":"e2f88c16-103f-497d-a88a-e63349d63a62","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"b1827766-8909-4c0a-8a55-23a0b5e81d4e","event_cluster_id":"02ee18ae-cb4c-43b0-8eeb-127e5d8f1ac9"},{"claim_cluster_id":"c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970","event_cluster_id":"bfddf849-1008-4d2d-bfce-830b42f8a421"},{"claim_cluster_id":"ce0417d2-5817-45d3-a01f-447b8d6d19ff","event_cluster_id":"21360818-47b1-476a-88aa-682feb18a966"},{"claim_cluster_id":"e7a774aa-82c9-41a0-9af6-f4f143016a1f","event_cluster_id":"13765e0a-ad43-430b-8852-bfa85832f876"},{"claim_cluster_id":"b2a7204e-e5ad-4d5f-8464-67520217c392","event_cluster_id":"7261d8c0-d619-4bef-bf36-5ab83467a9cd"},{"claim_cluster_id":"31d339ae-2342-44f9-a909-e299d2c4eccd","event_cluster_id":"0b719ed0-60f8-42bb-9426-ff2a477557b7"},{"claim_cluster_id":"f8755b86-ae98-461e-a3ac-2bd5b6ec4310","event_cluster_id":"e71c3cd6-157e-4870-8807-668962f49dc4"},{"claim_cluster_id":"0f9ce830-116e-4bca-9110-b7d8c9c20025","event_cluster_id":"9cb96178-90d1-49cc-8907-eb63419e86be"},{"claim_cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","event_cluster_id":"314e86f6-17d6-477f-8886-75643cc5dcde"},{"claim_cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","event_cluster_id":"5530b92f-dd56-42af-8c16-6aabb4ffa553"},{"claim_cluster_id":"c572351c-d373-4e8c-a918-68e53e31b822","event_cluster_id":"3b11f37a-b3dd-481f-b924-f2c0105eea68"},{"claim_cluster_id":"bd13c9c1-afe0-4a04-acc3-453f611b1f14","event_cluster_id":"8a312b2a-4e43-4814-85a4-51669e80ab52"},{"claim_cluster_id":"b3d00803-b5be-4264-bbda-b09db5ed3a9b","event_cluster_id":"6b078586-a71f-43ea-9363-faa3caa5fe58"},{"claim_cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","event_cluster_id":"164a85e9-df51-43f2-948d-bd9852808931"},{"claim_cluster_id":"a83fedfc-0f0a-49b0-9dae-3932f2ba6983","event_cluster_id":"a24aba28-4a37-469a-9d41-dfd554a4594a"},{"claim_cluster_id":"25a85f3d-1037-40c8-8b96-32b80bedc5b2","event_cluster_id":"3f7e49c1-3bca-42b1-a2c6-b96fb1443ba2"},{"claim_cluster_id":"6442657f-3626-4ac3-8a02-28b3c72e00ba","event_cluster_id":"7860ac7c-a8a6-4b0d-8952-927a859be338"},{"claim_cluster_id":"29f9cc11-a80b-4066-9284-acd0b0746933","event_cluster_id":"58a5d45d-929c-4882-97bc-6346fc773e3e"},{"claim_cluster_id":"99df608a-defa-4cea-b8ef-86519fa0e08a","event_cluster_id":"18fb4791-02de-4e42-aeab-ba0112d12563"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"b6224aea-5841-4609-ba8b-ccc207ec597f"},{"claim_cluster_id":"a98eba10-9612-466e-bbba-6161ced90ab9","event_cluster_id":"c7ff0720-041e-4548-8592-cfa24a2712c7"},{"claim_cluster_id":"5677f10d-93dc-4b72-b95a-8bc4291ec487","event_cluster_id":"fdb454eb-b6d8-4e69-94d9-d465733df395"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"42322612-a5c4-4a48-abca-12e69bf326a1"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"be467aaa-b350-4a63-875e-7aa61c3d868a","event_cluster_id":"73a3ba73-472c-4953-bc98-ef9a9d43fb52"},{"claim_cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","event_cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb"},{"claim_cluster_id":"ddf6dff1-95bb-49d1-93d2-18eeac6d22bc","event_cluster_id":"6d63d484-2e34-41a3-8d3d-7c1693933482"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"f54e9fc4-9854-41c6-aa04-dba66f36cc19"},{"claim_cluster_id":"984e2a37-4883-4da4-8899-a3cc19bba978","event_cluster_id":"626701fe-ae3d-403d-9681-7d335f03c82a"},{"claim_cluster_id":"18f586c2-7862-4f1e-9fbe-94bf4981c3c4","event_cluster_id":"fe4e513d-3365-4bb1-b29c-ae02d053a2e1"},{"claim_cluster_id":"24daffdf-e642-42fa-ac82-39c90e12f420","event_cluster_id":"244850ce-669b-481d-b002-ad90cb2a1ad2"},{"claim_cluster_id":"a84f79d2-3818-45bb-9cd9-eb739e78bee2","event_cluster_id":"da3e8993-13d7-42de-887c-a22169a3cf16"},{"claim_cluster_id":"fbdddb76-bee9-4e1c-9f2e-03126700cbd1","event_cluster_id":"c20e1db7-e918-4c20-9b2a-23168ba5d1b5"},{"claim_cluster_id":"38146e96-2791-4b11-ad91-87648834294e","event_cluster_id":"1a1de2a4-159f-4a0d-8a46-97165bf27583"},{"claim_cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","event_cluster_id":"7e3014ad-3100-4bc7-8edd-4e32af49ff75"},{"claim_cluster_id":"3444a924-096b-4eda-877c-4c6412d885cd","event_cluster_id":"ec3b133b-630e-4f2b-834a-c8cbcc0a0e64"},{"claim_cluster_id":"369b1cc5-aae5-4361-aabf-b1ef5c5350f8","event_cluster_id":"151926b8-a45a-4f2f-9fc4-2a654d1c3ebc"},{"claim_cluster_id":"984e2a37-4883-4da4-8899-a3cc19bba978","event_cluster_id":"ade1903f-a52a-4bb6-9a56-0c62e47b69bb"},{"claim_cluster_id":"58cd12d0-b190-4e1f-826a-20e181a5c137","event_cluster_id":"4ff57c09-958e-4a30-b35f-893da7a68a0a"},{"claim_cluster_id":"24daffdf-e642-42fa-ac82-39c90e12f420","event_cluster_id":"ee3497a5-19ab-4376-a948-4abe0f0d9b83"},{"claim_cluster_id":"004d8db2-6d73-4ac4-955b-6d04e88a0716","event_cluster_id":"d13901ad-61f1-4fb1-ba52-f79a1d3671b7"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","event_cluster_id":"c6d9c90d-92a1-44da-a5cd-12164b95f4d8"},{"claim_cluster_id":"51f92102-4c83-4bf3-8e2d-cf88f9368a7f","event_cluster_id":"af0e1c10-c1e8-4d6e-955d-02d943d24f8d"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"ddf6dff1-95bb-49d1-93d2-18eeac6d22bc","event_cluster_id":"6f13f345-1f63-46f8-86e1-7e1ec801fbcc"},{"claim_cluster_id":"af562818-5594-417a-b606-add10573c2db","event_cluster_id":"323f50ac-8539-481b-b9dd-0528780df63d"},{"claim_cluster_id":"363f13f4-3f3c-4a28-a39a-e89279a7c9ad","event_cluster_id":"5bee647b-e5d6-4ab0-b317-a48d3ac0cc11"},{"claim_cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","event_cluster_id":"465883de-cd6a-47dc-b0f3-f22e0ff902ba"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"67cff5df-1bcb-4edc-af42-99ff9df792c5"},{"claim_cluster_id":"44f7e426-bb87-4dd0-bf0c-80fb71c61eac","event_cluster_id":"b6807769-e83f-4f7f-b7a3-1a4b782749ea"},{"claim_cluster_id":"51eec710-c7a6-436a-b700-e76c7c02bc82","event_cluster_id":"eac07e3f-8adb-430d-96eb-dece778680b6"},{"claim_cluster_id":"840a2e45-449a-4234-be31-852cc48c1642","event_cluster_id":"418909cf-6842-4d61-99c3-ee63c7926d9b"},{"claim_cluster_id":"35d18d7f-0f7d-4654-8e65-f6b4bcac032a","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"358c0eb2-869f-46fb-bab5-4fbe8881d4e8"},{"claim_cluster_id":"6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a","event_cluster_id":"5970978a-16bb-49ab-af47-a2c975a2cb17"},{"claim_cluster_id":"f83f6c15-13c0-41a8-b991-8abeda0466c4","event_cluster_id":"38e3f6d2-565c-42d3-b90a-be4665a0d1bc"},{"claim_cluster_id":"c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970","event_cluster_id":"989dfd54-88d2-416d-a172-4c7b7a520121"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"08168b1f-73c6-4a8d-80e5-08594ac2f44e"},{"claim_cluster_id":"346f630a-2d46-4e8a-80ef-67a96ebf81ef","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"c782b8c2-e8a6-49c0-98b9-40619e415dcd","event_cluster_id":"d769b36d-aea1-4403-834b-b416d2db1047"},{"claim_cluster_id":"b93f59d3-e54a-4700-86ef-b20c995b73b6","event_cluster_id":"6511d484-25a2-4b72-9c08-df0d1ad4f8b5"},{"claim_cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","event_cluster_id":"540c45cf-a148-4629-8716-b1631ea44e45"},{"claim_cluster_id":"a7043201-daf7-4ddc-86e1-fe3a850942e2","event_cluster_id":"27494d31-7904-40f7-8554-6f6c04a0e92b"},{"claim_cluster_id":"62ddd106-9df1-47e7-9e5a-9c12a19f488c","event_cluster_id":"c1501799-71e8-405f-bf26-2801ae66dcf6"},{"claim_cluster_id":"32a2eefa-c8c7-482c-839f-be3b15138d40","event_cluster_id":"83c177c0-ee20-4679-ad20-0c32e24ff101"},{"claim_cluster_id":"55a53a4b-b30c-483d-9f7b-8c999d5c2f62","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","event_cluster_id":"27a6bdbf-c139-4b94-baa7-3715f52da9db"},{"claim_cluster_id":"ab1f8fac-3632-4188-90ae-a2c911b8425d","event_cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07"},{"claim_cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","event_cluster_id":"921fce8d-f4e2-4dbe-b940-66b148c09f17"},{"claim_cluster_id":"7ebece62-a589-49b3-b28f-b8f565ab7327","event_cluster_id":"228f2026-3094-45be-9c29-b363d30f00b6"},{"claim_cluster_id":"f04728cc-e827-402c-9a97-187311920a0c","event_cluster_id":"fd0c3806-b445-4899-9ddd-fa029d0bc38e"},{"claim_cluster_id":"b8299ae1-9e2e-465d-af82-b9354f3e9c44","event_cluster_id":"4ce3dea7-0e2a-40e4-9e4a-2c61943d61e2"},{"claim_cluster_id":"18f586c2-7862-4f1e-9fbe-94bf4981c3c4","event_cluster_id":"47b5e189-9eaf-4e69-b28f-1f2681036c7f"},{"claim_cluster_id":"26852476-f26f-4f97-92bf-7cc2d9373f4e","event_cluster_id":"8dafb957-e3d4-421d-a897-aa9e9def3c15"},{"claim_cluster_id":"e416c5ec-262b-4531-adef-7197fba310f0","event_cluster_id":"39e358aa-4f67-47f5-a3b2-dea997ca44d0"},{"claim_cluster_id":"6a2ad136-bcb6-47c4-8c1f-40e9c58978da","event_cluster_id":"efbd6030-d54d-4409-900a-396adc8a9b7e"},{"claim_cluster_id":"ff92e2cd-b51d-4aba-9214-602e53d602c6","event_cluster_id":"5bae13a5-6b81-425d-a9bb-49850203205e"},{"claim_cluster_id":"363f13f4-3f3c-4a28-a39a-e89279a7c9ad","event_cluster_id":"2ca744d4-a598-4453-abb6-08ac069370e3"},{"claim_cluster_id":"9be076b9-65b6-4c8e-b3d7-1df3c547c0fc","event_cluster_id":"f0e4e625-f14f-486a-a02f-d6cf2c5a6b4f"},{"claim_cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","event_cluster_id":"1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b"},{"claim_cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","event_cluster_id":"48eb1f9d-0125-4436-9ad0-db6bbdc685bf"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"0450eb4e-f8b9-4b39-9c27-c75e30610c21"},{"claim_cluster_id":"199eabc9-e7b3-44cb-a574-bbc02ea956e5","event_cluster_id":"f71cbd0f-7a85-414d-845f-e4694c67d02e"},{"claim_cluster_id":"db7cc474-d6ec-47a2-b50b-7ed4c500c50a","event_cluster_id":"b29c3ed7-bdfb-48eb-87a7-3e6d5f2cf585"},{"claim_cluster_id":"3b1f0ed9-3201-46c5-93e3-016f26c4d261","event_cluster_id":"d0dc34ca-6f25-427d-a56e-1d4f3210e605"},{"claim_cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"2ed3c98f-2c08-4da6-97f9-38e8a951f08e","event_cluster_id":"35e5848e-7f2d-49f3-b00e-f1ac80fdf555"},{"claim_cluster_id":"673d8d19-d059-4065-9b0d-82b1376c6c55","event_cluster_id":"3dba838d-2eca-4f65-941b-d8fa64a15014"},{"claim_cluster_id":"f7811e36-516c-4780-b025-c2c198f87bba","event_cluster_id":"debb5df0-b239-4824-9667-dfdfbc4323cd"},{"claim_cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","event_cluster_id":"b95f4f5f-4d51-43a4-8c27-5ed3609dc286"},{"claim_cluster_id":"0d0fd5f0-0301-424f-b0b1-a60ab6ca045f","event_cluster_id":"b93f0980-3e05-4353-b9af-768e6f562f26"},{"claim_cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","event_cluster_id":"8179c546-cd47-4baf-897a-a15a8afbb9e6"},{"claim_cluster_id":"74ac8dc6-1d9b-435b-bae9-36745f271604","event_cluster_id":"d32f3312-d003-4447-b89b-9a6dbdae0450"},{"claim_cluster_id":"8610b5a0-f4b4-403e-94e5-57543da5eb32","event_cluster_id":"49bf0c40-75dc-453d-aa4a-9a6c01b9dda1"},{"claim_cluster_id":"76bc71d7-2c17-42b9-974c-d517911bab56","event_cluster_id":"d0ed171a-d118-47d4-ad40-05768ad6c3f9"},{"claim_cluster_id":"8a3175b7-b295-45aa-8bbc-c3d6d75486fa","event_cluster_id":"4c5edc98-f936-4e09-a25f-11ad3a0a3ce0"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"836422b4-fd08-4384-b536-467195ee18cb"},{"claim_cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","event_cluster_id":"3a31c97f-6174-468b-bab1-90d8acc21560"},{"claim_cluster_id":"04fd43b1-9ee7-43b3-b1fc-e9fca576658d","event_cluster_id":"391672fd-aef8-4243-932a-77e726662902"},{"claim_cluster_id":"a74a2d72-1d86-4264-9389-b4fe594a7218","event_cluster_id":"e7164e50-d6db-4c47-8686-c55d8dcb20f7"},{"claim_cluster_id":"2d998acd-2150-418c-b2e7-db6c334526be","event_cluster_id":"a3cbf831-a6f7-4981-a61a-3f2e1d67806a"},{"claim_cluster_id":"7a8e190a-4532-4e4a-b5bb-60a049f869c1","event_cluster_id":"b2ed7816-e1d7-4d6f-8594-001922474b2c"},{"claim_cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"5518570b-ceeb-400e-8720-a531292d57ce","event_cluster_id":"7cee2601-5005-4b9d-948b-2e69bb408fa6"},{"claim_cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","event_cluster_id":"ff3032ee-a77e-4fe7-a5a1-205c35f0948e"},{"claim_cluster_id":"d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce","event_cluster_id":"444282c8-5a59-483a-aa4f-acbf1655f118"},{"claim_cluster_id":"6103c4f7-8bea-436e-90d7-0ed75fe275c5","event_cluster_id":"1e79f665-5f29-410f-a52e-7981ca5d8478"},{"claim_cluster_id":"601320a2-3fca-41ef-9387-a64a4c0b5cee","event_cluster_id":"6195dc7b-895b-4134-9995-738fed6389e2"},{"claim_cluster_id":"c6a49139-3f4b-48cf-8d38-e5b344108df3","event_cluster_id":"ac8a01c8-dc87-4d9e-80a6-4614b1d6d5e6"},{"claim_cluster_id":"859c814e-e7af-4708-a58a-9f1f6973974f","event_cluster_id":"7707109b-cc58-416a-9a9e-b9207b14baa6"},{"claim_cluster_id":"53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c","event_cluster_id":"50312364-9e82-4970-9daa-1275d0caaa37"},{"claim_cluster_id":"6f7b1c88-304f-4cf4-ba94-d6268fa5ae40","event_cluster_id":"b7659926-8b67-4333-bd9e-74433a7b83a8"},{"claim_cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"e633b9f2-d6c2-4c51-83af-0aed2e577009","event_cluster_id":"a9463f3d-e047-45f9-b0f1-8dca29a15e51"},{"claim_cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","event_cluster_id":"bf3cbbb2-0711-45ee-a625-a3ccf159845b"},{"claim_cluster_id":"78cbe3d8-37f7-4a89-956e-f6dab20ad8d1","event_cluster_id":"058f52a9-8a35-4f4c-823b-efe94ad1ee22"},{"claim_cluster_id":"d392695f-75b7-4bbc-a991-2b3edbf01567","event_cluster_id":"75e6960d-da7a-4d2f-8605-a94c9d2036f7"},{"claim_cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"97fd88d2-827f-418a-aa85-784dc98e83f5","event_cluster_id":"88b529dd-6a84-4eea-a385-80a5f7c68b68"},{"claim_cluster_id":"52105c27-d937-4970-9bad-c139e21a6205","event_cluster_id":"a28a5ed3-bc11-405d-9242-8b1a5ce91c01"},{"claim_cluster_id":"886176d6-1057-4021-8312-570a3e3f4e10","event_cluster_id":"51ad5e06-f7b5-461b-bde3-00f8284ec903"},{"claim_cluster_id":"185ce1be-2776-4956-849c-f83438c57def","event_cluster_id":"f45f3567-6577-44bd-b711-4eefb24f7df6"},{"claim_cluster_id":"738e60fd-1e3d-4820-98bf-d6bd9e7a3172","event_cluster_id":"35f50160-5841-4836-b319-b5806e73bdd7"},{"claim_cluster_id":"3d647896-bc7f-4815-a99e-768cb2498250","event_cluster_id":"8711a577-7906-443a-8adc-19d760bca08d"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"148cbdc2-efc0-4f16-b29a-724816c7ee5d"},{"claim_cluster_id":"61de2e2b-d2da-472d-882f-2c0c14730fee","event_cluster_id":"6da8eb62-757c-4652-8389-b32015cb40a9"},{"claim_cluster_id":"eb38bdfb-232f-4460-8d60-fc8806237786","event_cluster_id":"ef5b3681-b75b-471a-b383-e605cb2d8a70"},{"claim_cluster_id":"1dc0ed5e-e098-401c-9b18-3dd42ba6b01f","event_cluster_id":"ea812d6b-ff93-45c5-87c2-85077592798a"},{"claim_cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","event_cluster_id":"3789471e-0775-4ba6-92d1-141ca5051de5"},{"claim_cluster_id":"2996196c-7b75-44d2-aa5b-560b18ce2763","event_cluster_id":"64cf5e07-c73c-4733-9b23-8f12213cc336"},{"claim_cluster_id":"055b1edf-5e4a-4fd8-b913-a9d1df63a85a","event_cluster_id":"13c0f70a-404a-4747-9850-32c93df93caa"},{"claim_cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","event_cluster_id":"2b3c9191-0f03-44e0-8e0e-82a5f8121907"},{"claim_cluster_id":"77b557e0-b37f-4548-adca-2c9da9e04106","event_cluster_id":"f9fcbf4e-cb96-4f3c-bad3-73737cdc4b3c"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"45d7d6d0-989e-40f5-9e35-4f603b15d08b"},{"claim_cluster_id":"6ac8924b-24d0-446a-8ffc-cf862b415737","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"a2a57731-90ff-4a12-a08f-721a9dfc0b06","event_cluster_id":"127eab3b-6cf7-495a-80f3-a2735d4d1bcc"},{"claim_cluster_id":"d9f4e411-98bf-48bc-a372-2ef5b6cd17d9","event_cluster_id":"4f0f5e9d-5d96-4785-be2a-db5660d98439"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"e136ae61-7689-4d72-a14e-2120e6260be2"},{"claim_cluster_id":"aed74a8c-a339-4a19-a144-bb62990f8e50","event_cluster_id":"7ecaa8a7-76e8-4332-a41f-2c347237e2a6"},{"claim_cluster_id":"2bc0b07d-c668-4651-b1c3-1844786b5acb","event_cluster_id":"f44c0680-07c7-4ea0-8054-7643f1b8eafd"},{"claim_cluster_id":"daa86fb1-df31-4a23-a926-1b9981f8df40","event_cluster_id":"ea4d2231-ca8e-420c-8296-8d5576ce43ba"},{"claim_cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9","event_cluster_id":"3a6ab8c1-b7af-4dae-9216-d55e6233e2d8"},{"claim_cluster_id":"2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece","event_cluster_id":"f4412fc5-966c-440c-829a-8ca0977913f0"},{"claim_cluster_id":"c6541e86-8e1b-4bd0-926a-c380aa103aa6","event_cluster_id":"25a18cdf-150a-41da-b8d4-e997a6088c8a"},{"claim_cluster_id":"6b000975-482c-4a87-97ba-4b7f79318bd6","event_cluster_id":"7f8ccaf9-3143-4e85-8fba-3e95d1568fc9"},{"claim_cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","event_cluster_id":"5a26984c-e60b-4dac-8536-2c84c78b7c2a"},{"claim_cluster_id":"487393b6-56b8-4c3f-bdb3-88dbd2ac69d5","event_cluster_id":"9f9c5798-7130-4fb5-8328-ae0dad688f2e"},{"claim_cluster_id":"bcfd3520-6b2d-41d7-83ee-cfbd1d569332","event_cluster_id":"8e38f27f-adac-4956-8ff8-f509c611ee94"},{"claim_cluster_id":"7938e6ef-80ff-4f50-b301-1e5bfc0774b3","event_cluster_id":"1f6ddbe7-8535-46e4-9237-74c4562367e1"},{"claim_cluster_id":"f65b5094-1e51-442e-b444-de0d25f1fea0","event_cluster_id":"d98e592a-9240-4307-b377-0c2f380a6db0"},{"claim_cluster_id":"cca76b6b-f388-4f7e-8293-b55584460643","event_cluster_id":"dfbec97c-7720-466c-b25a-2051f356476a"},{"claim_cluster_id":"2fe8d49f-63a1-4171-af68-9824e47b825c","event_cluster_id":"59a61072-395d-4f52-9f54-81f2c2e5b76c"},{"claim_cluster_id":"c55d7e50-ed13-4f98-a396-412d6e19decf","event_cluster_id":"ef0e0cc6-010e-482e-ad0b-63895cd13988"},{"claim_cluster_id":"76cf3691-7d2d-4e3e-a789-a9c5c731de64","event_cluster_id":"9d8cb077-725c-42df-adf9-cc02faf7d3d4"},{"claim_cluster_id":"bf1e5943-1881-4795-9e54-b7177a49b67f","event_cluster_id":"eec253c7-dea4-4bc8-94cd-e84946c84d8f"},{"claim_cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","event_cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2"},{"claim_cluster_id":"bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c","event_cluster_id":"016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc"},{"claim_cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","event_cluster_id":"9ee44494-957f-41e5-a680-3bacf709709f"},{"claim_cluster_id":"19581d0c-22b5-4ff0-8a68-de86fb01009c","event_cluster_id":"1e2e215d-02f8-41f2-bb72-8bb5cf8991d4"},{"claim_cluster_id":"f21a34f1-8f4b-45c1-80d1-4a2fc8e55091","event_cluster_id":"cef3ea24-b5a3-4eec-87c9-03935082f43c"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"876dc47c-c65a-4a65-a882-eeeb837080aa"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"a4d91f10-cd48-4917-90ab-b14ea36168d9"},{"claim_cluster_id":"77b557e0-b37f-4548-adca-2c9da9e04106","event_cluster_id":"9041e9b2-f334-48f3-86f9-79b1ba825b51"},{"claim_cluster_id":"099db03e-baa7-498b-864d-6a091534741b","event_cluster_id":"f51ef59b-4e02-42dc-84d5-932727f453f6"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"63282497-1e0a-4af5-b5c7-65b6b20ab63f"},{"claim_cluster_id":"8afc9e85-7241-4e3e-a1d2-c084e17d6f92","event_cluster_id":"b50d8113-2ba3-4857-a6f8-d3c42cda7690"},{"claim_cluster_id":"cd4aea0c-c90e-430b-95f8-4bff425c022e","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","event_cluster_id":"33ed63b5-316c-47cd-80fa-2cb71259f8eb"},{"claim_cluster_id":"ac1f3497-64d3-4909-9d61-789e683556a9","event_cluster_id":"83f7014a-9a88-48b8-b5ab-b83620e2b1f6"},{"claim_cluster_id":"057bcb05-f915-40a6-9a44-d57aa6602574","event_cluster_id":"beafc838-f8fb-4f24-b442-c5d64c7e1a7b"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"970cf87e-f96a-4a62-8043-264e8de25eb5","event_cluster_id":"f1490876-f9ef-4974-a23e-79abce4ea951"},{"claim_cluster_id":"b2ec8ccd-aef2-476a-b259-768aae14f39e","event_cluster_id":"3f91e02f-ab23-4d35-ac70-4b14b0545030"},{"claim_cluster_id":"18413d30-3282-4a19-9301-8b0c9a57c941","event_cluster_id":"263a8eb3-52c7-4ff6-ae64-6807df428530"},{"claim_cluster_id":"3bda7498-8cf1-4495-9ee2-307193fe0c3e","event_cluster_id":"a335ca71-7c72-419b-8877-46ce4e71837d"},{"claim_cluster_id":"b65c1ae7-fe21-4ae4-9c7e-84c247b4a89b","event_cluster_id":"d4e2bc2e-5c21-4fa6-b48d-9b09603ae727"},{"claim_cluster_id":"fc0f4ff8-8147-4b0b-be66-dcae01810fe6","event_cluster_id":"605d1ffa-cf79-43de-a146-0eef92de2043"},{"claim_cluster_id":"e632bc78-90b4-46bf-a31b-df8259ac6d90","event_cluster_id":"59906f79-e6e8-4390-a382-ef5bd2f7fff2"},{"claim_cluster_id":"da4807bf-cc54-48c7-b3ca-69cd854da837","event_cluster_id":"ce2d06aa-e26f-4ec8-8402-545cc5537de0"},{"claim_cluster_id":"38c3007b-05b7-481e-b44e-c09d28628f5e","event_cluster_id":"f6501847-7e90-4499-a97a-f42ac5217bb6"},{"claim_cluster_id":"21c7b1a1-7d0b-407c-9669-93e385d68711","event_cluster_id":"776ff44d-f39f-4f47-8ef5-a991b2a74ced"},{"claim_cluster_id":"0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879","event_cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c"},{"claim_cluster_id":"149c2ce0-2083-4d57-aa68-de8fbf125008","event_cluster_id":"b3d06a2c-7adf-4967-b1b6-b69e35711ca0"},{"claim_cluster_id":"3e1e4180-7726-4298-9f55-4348fcd7185f","event_cluster_id":"64d2c311-675b-43df-a715-09bca5e25a05"},{"claim_cluster_id":"0f1cacf9-3df0-4d00-8952-b3fa5195f1fb","event_cluster_id":"bc2af5c9-9ff9-4d76-920f-873d731b0a39"},{"claim_cluster_id":"e1f9f354-866e-470a-a516-a1c53f268840","event_cluster_id":"978700a4-02ac-4150-9d93-a90e4ee05431"},{"claim_cluster_id":"25a85f3d-1037-40c8-8b96-32b80bedc5b2","event_cluster_id":"38bfd344-45fc-4c0a-8605-6354b8f22cb4"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"cec3a521-c732-4e0b-8192-f6efa6c46d10"},{"claim_cluster_id":"3543d3e3-081b-448e-9ec9-915bf37d6255","event_cluster_id":"55f690c0-9fbb-459a-ab42-db16e202e04f"},{"claim_cluster_id":"a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc","event_cluster_id":"d227604b-5869-4f99-9132-b0eb536e0289"},{"claim_cluster_id":"6a2ad136-bcb6-47c4-8c1f-40e9c58978da","event_cluster_id":"2e2cbe02-9179-4ff7-9128-2042160eb4d1"},{"claim_cluster_id":"34e53235-60e8-4299-9389-633db39ab300","event_cluster_id":"2d4166ac-3dc3-45f4-a803-c8d77cddc0db"},{"claim_cluster_id":"73c5657f-c795-4df0-b889-73c2f356f79a","event_cluster_id":"06e477a1-87e5-42ae-a235-8227d3b39fe3"},{"claim_cluster_id":"a0aafb48-1cc4-47f3-9cc7-073b87c64efc","event_cluster_id":"6e5ac655-6dc6-4a9e-915a-357b2296a7b0"},{"claim_cluster_id":"dfcf5731-89c0-4af2-a475-d7087b733644","event_cluster_id":"07ba7d5a-bc3c-4f63-a8e0-6487f494c700"},{"claim_cluster_id":"5284ded1-5c85-415c-af66-ad36ef47b3e7","event_cluster_id":"ede13164-94fe-4382-9f88-120091c29cbc"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"270b9be6-37c3-4ab7-9763-57943d7a38b9"},{"claim_cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","event_cluster_id":"69dda1ad-6a94-49a1-b2c4-c261984302cc"},{"claim_cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","event_cluster_id":"8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf"},{"claim_cluster_id":"09e579b4-c608-4bc3-a02e-890bc6f5969d","event_cluster_id":"5f1df598-4786-4f75-aed1-8eb66dff4278"},{"claim_cluster_id":"c29b208b-6490-4cf8-b641-83fe57eafe9a","event_cluster_id":"fffc483f-c841-4109-b9e1-d2ab5730fe2b"},{"claim_cluster_id":"19ec7067-1e85-4e98-adf9-a107366a808b","event_cluster_id":"28c6e890-bb36-4eff-b0b6-22f2850f023d"},{"claim_cluster_id":"f34203f2-30b3-4686-b2f0-e124d8a67272","event_cluster_id":"cfd4b520-a181-4698-846e-ff280ba11189"},{"claim_cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","event_cluster_id":"d415aa76-63ab-4b87-94b6-7d753e952a6a"},{"claim_cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","event_cluster_id":"f86db310-987e-41a6-a2fc-6f6bb14b7072"},{"claim_cluster_id":"af3f95a3-d597-4371-bf7f-e4f5d91a9b73","event_cluster_id":"c183c1f7-56d7-457d-9d98-1df02c7330bd"},{"claim_cluster_id":"5197019b-eb26-4b32-8e4f-5890ab4e562a","event_cluster_id":"828fd8b5-ddaf-4d75-8787-c4afd6bebc90"},{"claim_cluster_id":"dcadf3a6-188b-4a08-881c-e1acb19f186a","event_cluster_id":"78e9a9c1-3b66-422f-8fa2-16501c3ff20e"},{"claim_cluster_id":"2996196c-7b75-44d2-aa5b-560b18ce2763","event_cluster_id":"162d37ea-ce13-4d19-9a98-bb0e66720cc0"},{"claim_cluster_id":"a0b96ee6-2ea9-4035-b542-1107b0662e77","event_cluster_id":"1aacc2c6-cd51-47e7-bc26-be760d557e3c"},{"claim_cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"209b24c3-c157-4c8e-9d85-993e19c6b8bb"},{"claim_cluster_id":"d4dddb84-da14-4d5c-ac75-d999175b9558","event_cluster_id":"56c5d781-120e-4c38-ba12-676cecb63cc8"},{"claim_cluster_id":"7940ac84-eeae-4d7a-9072-fc2e9ac63265","event_cluster_id":"9162951c-ce7d-463b-9880-335cc6cb0f80"},{"claim_cluster_id":"d7e9e6ed-b598-46a7-b7ea-6197df41d3ad","event_cluster_id":"40f8706e-4783-4eef-bf10-d2f20bfb78bb"},{"claim_cluster_id":"b4de3a2a-395f-4d49-9f4e-abbd190c57b5","event_cluster_id":"338b82e5-bda1-47c8-a375-1c6600743697"},{"claim_cluster_id":"25a85f3d-1037-40c8-8b96-32b80bedc5b2","event_cluster_id":"36ad2a89-3229-40ad-9f6f-f2c33f4ebacd"},{"claim_cluster_id":"b4c1b467-58b1-4e2c-a735-234cba24891c","event_cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a"},{"claim_cluster_id":"de116a88-705c-434f-9f3a-1fdabb457723","event_cluster_id":"fc29eab9-06ef-4c87-8c16-ab4eb87c1683"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"b695ff3b-957e-42cc-9bb5-c2dd8be994ea"},{"claim_cluster_id":"9c9d4ed6-a861-4706-aee3-f148f1769c86","event_cluster_id":"349cfacb-551c-400e-8c1e-7b08765e6799"},{"claim_cluster_id":"20c941a8-b922-48e3-8e56-e49e1a524fd9","event_cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67"},{"claim_cluster_id":"26852476-f26f-4f97-92bf-7cc2d9373f4e","event_cluster_id":"7234c7f2-ec56-436a-abe4-d72c2e651247"},{"claim_cluster_id":"25d9faf4-4231-47e1-9e78-17114da0186c","event_cluster_id":"3e2b1f73-9c36-499a-910a-db947f38acee"},{"claim_cluster_id":"67c03f1c-cee9-4493-b4e6-4ff1b7971966","event_cluster_id":"7b4ecda5-4408-4ecd-a695-939e312b6ac7"},{"claim_cluster_id":"126818cf-8924-40eb-8cb3-edad41027c0e","event_cluster_id":"3feb2513-5eb4-45bb-8249-92697ca5ccbf"},{"claim_cluster_id":"27097c65-59e7-4824-9bbb-c0736b2c9f70","event_cluster_id":"b8f6ce4f-4115-477a-9fac-602b955a0de8"},{"claim_cluster_id":"f1461740-3766-4178-84e8-17d9b70838ae","event_cluster_id":"4fd88af5-5edc-4995-92ea-057702ca240a"},{"claim_cluster_id":"5dde6d54-8ecf-4f66-96dd-406048082082","event_cluster_id":"00c86245-5e91-487e-8809-1bcfd15888ae"},{"claim_cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","event_cluster_id":"1282bd1b-6e16-4c06-9f2c-9c9344b54fd8"},{"claim_cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","event_cluster_id":"d339acab-2e15-4ce1-8cff-20a1b2fc2811"},{"claim_cluster_id":"eb7fddda-fe98-408c-a2d5-471f6b5aac76","event_cluster_id":"a29634dd-4c74-4380-8358-51cf5a9cb73c"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"5dad5c87-4292-488c-b998-f9a86f6c59b2"},{"claim_cluster_id":"93c53898-2dc6-423b-a4d6-b61dd90c6d6c","event_cluster_id":"e828a029-7aa6-4aae-b53b-df9804b3b858"},{"claim_cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","event_cluster_id":"8c70df97-1c82-4e7f-b23d-acbf2024c8f6"},{"claim_cluster_id":"2846d44d-8ccd-40e0-8486-7b360ffa4608","event_cluster_id":"079b8e0f-e8e1-4996-9f11-531830a5cd53"},{"claim_cluster_id":"da2845de-4e1b-492a-a6b0-06fd4584650e","event_cluster_id":"9fb69606-a3db-4d92-926c-b003f3516e43"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"99d24268-130c-4375-a4e7-e999f58720e8"},{"claim_cluster_id":"deb1b19f-f313-46a8-8e93-d75203af3775","event_cluster_id":"13bb7753-ee8b-4817-baa5-471bea919fc8"},{"claim_cluster_id":"b3d00803-b5be-4264-bbda-b09db5ed3a9b","event_cluster_id":"8340119a-3207-4843-be46-581bcbb33e2b"},{"claim_cluster_id":"92ea76c7-4dfb-45af-849a-ece7083099c6","event_cluster_id":"21b4b954-5140-43e2-bd9b-c8ab79b3e70c"},{"claim_cluster_id":"6b512fcc-e6a2-414b-8a86-90a11b76795a","event_cluster_id":"57a9720a-c11c-4e38-b871-7e3861e5df17"},{"claim_cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"a72e319a-9e87-40b0-a2c4-a95e4857ac8d","event_cluster_id":"73bf3278-1769-4596-8d67-3c3249542c2c"},{"claim_cluster_id":"a6c6cdde-b7da-4e49-88cc-f029f6af6192","event_cluster_id":"6adcd904-be39-467c-bbbe-a9cce702dbdb"},{"claim_cluster_id":"212176d0-9b06-497d-a8bf-0b53076513ff","event_cluster_id":"db558738-31a9-49b8-a8b4-9d79818e6da2"},{"claim_cluster_id":"b213b3ba-db75-4c42-89bd-97de55c18b3e","event_cluster_id":"3cf933e5-8422-4f09-a822-8ef8b6385700"},{"claim_cluster_id":"ad4fa6da-197e-4295-b610-c2f934cdd3ea","event_cluster_id":"8f6bdb99-b1de-47a0-840e-33678f79a92b"},{"claim_cluster_id":"72cf96af-c05b-405d-a5e3-785cb1c6c70e","event_cluster_id":"80c4a4ac-f4f0-46b7-a4e0-1dc67ab16883"},{"claim_cluster_id":"71755eb8-e7df-4bfc-b448-f56fe2b8b242","event_cluster_id":"d488f4da-dea7-4960-b3a2-50c35254e3ba"},{"claim_cluster_id":"952d3c78-e97c-4ff6-a488-1e2f6353d3c9","event_cluster_id":"813768d2-b0f6-4924-af6d-45e5c38606af"},{"claim_cluster_id":"67077d98-dd63-4eb1-bfae-12ca20649195","event_cluster_id":"f43f98cd-cb16-421c-a639-6c526509bfd7"},{"claim_cluster_id":"fcc58b11-54f2-420b-99e3-8acb8731fd15","event_cluster_id":"506ae2d6-92b1-4fbe-9d47-e321f93374d4"},{"claim_cluster_id":"453d17a8-fa49-49dd-82fd-7c3661e026b6","event_cluster_id":"0d94dbde-ff2c-4ec4-88f7-65580876f8ea"},{"claim_cluster_id":"b180d822-88c1-4c5f-a386-c975497c4a85","event_cluster_id":"82b01c38-1855-48d6-8ce7-6d564382bd37"},{"claim_cluster_id":"98dac116-c6f6-46b8-945d-1ffe5cc5db7d","event_cluster_id":"21d0c066-9264-468d-b96a-f5f007531508"},{"claim_cluster_id":"a5706e56-c643-44be-8e44-3c19fd9dcc29","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"b44cd59b-4971-4182-8766-9ffcf4ae83ce","event_cluster_id":"2f690c44-ca18-4a31-a2b5-68ac60208360"},{"claim_cluster_id":"6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1","event_cluster_id":"f8fb699e-3174-4e1f-8079-1bb9372cf5ca"},{"claim_cluster_id":"68ff85cf-74e5-4234-a53f-6dba1aacb444","event_cluster_id":"6ca62e87-83be-4fb7-8924-3312fe9948b1"},{"claim_cluster_id":"dfd567bb-1650-495c-ac2d-4d240d441b79","event_cluster_id":"8258ee8e-37a7-4d85-b65c-6247bdf08da7"},{"claim_cluster_id":"5e7e70f4-b130-467a-9df9-f6078877ed61","event_cluster_id":"933ba991-e63b-4909-90b5-fbeb9eeea4c4"},{"claim_cluster_id":"c14aacf1-2f99-4e9a-ba35-1511bf4fd104","event_cluster_id":"6bf71f87-f205-4f8b-8249-8d960a41d7cc"},{"claim_cluster_id":"6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a","event_cluster_id":"44c9e76f-0fa5-4a17-a780-5705bb58dc3f"},{"claim_cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","event_cluster_id":"050d87c2-4ac3-4e0e-8673-b4a44b43bac0"},{"claim_cluster_id":"563cdc28-d88f-4781-9ab9-27eadd46ba73","event_cluster_id":"55299e01-297a-4bb3-aad3-784bd43284fb"},{"claim_cluster_id":"e968bf8c-b2a8-4330-bf71-9cab4f6826a5","event_cluster_id":"03ab33c5-869c-44e7-85ff-a26adc857fce"},{"claim_cluster_id":"98bac582-09cd-476d-9519-fe434dffcb9a","event_cluster_id":"4d98cb2c-2f46-419d-a007-1ffd1128c767"},{"claim_cluster_id":"796ddc52-9094-4fcb-af10-9fa6a06448ba","event_cluster_id":"ba39c004-53dc-4528-9f07-025d10ba4bfc"},{"claim_cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","event_cluster_id":"da81244a-ef78-429d-9f3d-b08a5c21a084"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"60b71403-253c-4f7c-b96e-fb2306a7cebf","event_cluster_id":"14a0f558-9894-4d04-9b27-d9a6b3531c2c"},{"claim_cluster_id":"452c2457-4da2-4edb-a49f-86f139410e4f","event_cluster_id":"50c706cf-6243-4e9d-81ec-789d3dbecc99"},{"claim_cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","event_cluster_id":"2ca6b1f5-ce3d-4e72-98a8-f750a42081ac"},{"claim_cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","event_cluster_id":"3775dc56-2d8e-428a-9c60-ba993c0f4ba7"},{"claim_cluster_id":"c39e0166-c55b-4f71-8bb5-e23985802606","event_cluster_id":"d3326047-f19e-4b54-a0ed-a16bb5dfd0de"},{"claim_cluster_id":"22874c8a-79fa-491a-a46f-cd92202bb1de","event_cluster_id":"9efa7058-0848-446b-a53c-deef9f0ad8fe"},{"claim_cluster_id":"c13b80fa-280b-4c54-8a38-1ddd943c4782","event_cluster_id":"34a1b7dd-030b-404f-82f6-074c42d07051"},{"claim_cluster_id":"30ae8997-b16b-4477-bfec-33c1a345955b","event_cluster_id":"3b22f285-4b36-49a0-9e8d-cceb33235419"},{"claim_cluster_id":"a6c6cdde-b7da-4e49-88cc-f029f6af6192","event_cluster_id":"dbe0f86a-aebe-4564-9503-5702cd51713e"},{"claim_cluster_id":"5b6da2ab-36ee-4cfe-968a-ce42565405bc","event_cluster_id":"bfcb4fd5-03ad-4398-a7b4-f52617946935"},{"claim_cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","event_cluster_id":"4c76d4e3-5632-4224-a22f-bc4b4614bcbb"},{"claim_cluster_id":"dfa47852-ac3f-4b74-bc17-22923a395552","event_cluster_id":"0ca4759c-9c4f-421f-b2d0-dbefe4601911"},{"claim_cluster_id":"8944c246-4c2f-439b-bc21-590da536eede","event_cluster_id":"c40cc82c-67d0-418e-9ae2-4c1dfebaaa5a"},{"claim_cluster_id":"ef502c1a-5f03-41b4-be90-14e6e1785625","event_cluster_id":"1171e42a-be23-408d-8491-47db819af91c"},{"claim_cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","event_cluster_id":"bf617b93-4dcc-4186-81d8-7cd9fc2d425a"},{"claim_cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"21956ecc-f782-4f55-8347-f78333fc6d97","event_cluster_id":"071edf6a-a71e-44b7-923a-bff12eb8ede8"},{"claim_cluster_id":"35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60","event_cluster_id":"02d5b346-4337-43cf-8a61-4391e125d41b"},{"claim_cluster_id":"dfcf5731-89c0-4af2-a475-d7087b733644","event_cluster_id":"9cc8799b-e620-4e1a-8846-51eed506e0de"},{"claim_cluster_id":"5d30cac5-2629-4bf5-9665-20ae87c1ec22","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"de3dfa95-4771-45cc-8a31-d6c35fbb0eb5","event_cluster_id":"56cddc1e-640e-4fd4-873b-51796886ff3a"},{"claim_cluster_id":"7e4a12f6-fe24-48f6-993c-d7197eb9c44e","event_cluster_id":"8456fa39-debe-4543-9e31-bac207d1861c"},{"claim_cluster_id":"b523cd60-7c0d-4c50-b41c-3522aed9c4b1","event_cluster_id":"ce875605-9657-4d10-9c03-b203782b40e2"},{"claim_cluster_id":"bf1e9c00-6f00-48d6-9611-285baac7022b","event_cluster_id":"af7abfea-8aa3-4fe8-a9f8-4a548d23e03a"},{"claim_cluster_id":"26852476-f26f-4f97-92bf-7cc2d9373f4e","event_cluster_id":"e493e014-2ee0-4066-9764-e3019f7467b2"},{"claim_cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","event_cluster_id":"36abfac2-7b3e-427a-a2be-ce55f5472e15"},{"claim_cluster_id":"6547f895-7ab3-43c4-b3b1-d01e17f1e888","event_cluster_id":"40ab9766-1c85-4b8a-bb1d-2effee6c9d18"},{"claim_cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","event_cluster_id":"530c303c-a794-4be5-bbc2-ff618ab75d38"},{"claim_cluster_id":"5d4f6733-5fbd-48ce-8468-590ebda279c7","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","event_cluster_id":"b997c44d-2fc1-4d45-8a7a-f72d1b5a079d"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"b3b646eb-c723-4a14-ac13-d0b7985ef11c"},{"claim_cluster_id":"41dd785c-3146-4243-8bbd-56211fadb273","event_cluster_id":"503b13e8-42e4-48e4-8ace-47ca9e49140f"},{"claim_cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","event_cluster_id":"db101c75-2320-4597-b222-b7197dc49dc4"},{"claim_cluster_id":"dcbf5711-b1d2-4a7c-96f6-e8916f52c752","event_cluster_id":"c5a49990-0bec-49b9-8797-00d71805007a"},{"claim_cluster_id":"487393b6-56b8-4c3f-bdb3-88dbd2ac69d5","event_cluster_id":"862e3561-6a46-4a47-8035-363b4e2c1786"},{"claim_cluster_id":"b2871022-57c5-48f7-adcd-caeceec2edeb","event_cluster_id":"d2b35337-7985-4ff0-934f-fef44d781bab"},{"claim_cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","event_cluster_id":"3ba005de-dec0-4cc4-8a3c-a3679d6f072a"},{"claim_cluster_id":"c3c1a73e-287c-4b15-879c-42467ebdfb38","event_cluster_id":"fe1c6b54-9f28-4390-8b18-685bcbf44298"},{"claim_cluster_id":"5d21e7b3-dd0e-453e-8871-eb57102f00e7","event_cluster_id":"e53e2876-2718-4f35-b4a4-ab220a980fd2"},{"claim_cluster_id":"89aabd59-2b1d-4122-9c03-b5ffeee5a650","event_cluster_id":"c0afded3-b33f-49c5-9160-e59e42832c59"},{"claim_cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","event_cluster_id":"ae87ce9d-8fb9-4394-9afe-202f1ec14722"},{"claim_cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","event_cluster_id":"f55b7553-3d55-4096-859e-954de960f09c"},{"claim_cluster_id":"f465e3b9-9784-4302-b258-d34ad0adf726","event_cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"},{"claim_cluster_id":"bf3a902c-c644-4da4-8d4f-8ccf8bbcec56","event_cluster_id":"6212a7fd-0f42-4186-898e-6bca1d985ded"},{"claim_cluster_id":"a65b71fa-08aa-4b20-91e3-c9e898591f07","event_cluster_id":"7c1469be-22eb-4ba2-a540-efc0b0d4e00e"},{"claim_cluster_id":"6a8ee3bf-31a7-42b7-b481-4b21e09f4484","event_cluster_id":"6d1416a4-5911-49a5-a8dd-0b4e7d18279a"},{"claim_cluster_id":"b7e4eaa1-1521-4096-9aa4-af78b70dfeb5","event_cluster_id":"b1babe59-a6e4-4d3d-9c56-c6ce7d8d64c4"},{"claim_cluster_id":"dc73c39b-d234-4200-a04f-dc1af208480d","event_cluster_id":"7d7dd851-9e80-401e-86ac-20fbd4d71580"},{"claim_cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","event_cluster_id":"ee6ffddc-d717-4a7b-a161-3d1bdc24c500"},{"claim_cluster_id":"5a33a893-0ae3-4e2b-9f4c-02de9772f96c","event_cluster_id":"3c9a1b13-b4b6-4090-861e-e35159e61286"},{"claim_cluster_id":"f58ca21a-7af7-4062-9509-f6480d8a6390","event_cluster_id":"c0713b5c-a570-4865-83c9-eb36c347abcf"},{"claim_cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","event_cluster_id":"11415296-938e-40a3-84ae-06be10542d39"},{"claim_cluster_id":"830f6edd-9e60-427e-9ff4-9fac93a52411","event_cluster_id":"3195f0c6-475f-480b-9f8a-4aa8231b8b3c"},{"claim_cluster_id":"89cac161-a6f0-4315-a880-1662cae50313","event_cluster_id":"caa057e8-994e-43b8-803e-0ea0aeab7ec7"},{"claim_cluster_id":"ab72f353-1b68-44ce-979f-a10883b99605","event_cluster_id":"18485212-7b1e-457d-88c0-98b9b231ec0b"},{"claim_cluster_id":"62d8fa29-aaab-4f66-9532-5fb34686e56f","event_cluster_id":"0b109e58-1cde-4c32-aed4-12ba82ed273a"},{"claim_cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","event_cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993"},{"claim_cluster_id":"635833cc-6550-4cab-b41a-e51cbfca373a","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"9571d5a8-94c8-43e8-bdfc-93e045f2bdd4","event_cluster_id":"808de745-ec3f-47f3-84ca-5bbec4878cae"},{"claim_cluster_id":"489bde91-1bfc-48d6-aae7-de380d23d205","event_cluster_id":"e0cfcc7e-1525-454e-82eb-71402504ae5b"},{"claim_cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","event_cluster_id":"6d1416a4-5911-49a5-a8dd-0b4e7d18279a"},{"claim_cluster_id":"de3dfa95-4771-45cc-8a31-d6c35fbb0eb5","event_cluster_id":"f7cb56d3-2935-41a4-86b7-c9fe57c869f7"},{"claim_cluster_id":"c9534331-e465-4cc5-951b-fa24c4cd75bf","event_cluster_id":"4f2789db-45a0-4f05-86be-a25e7794e0d7"},{"claim_cluster_id":"9d400cbf-08ea-4c02-941a-80cd2d3e517a","event_cluster_id":"b85d6c69-8e92-437b-87b3-200c9509883f"},{"claim_cluster_id":"7ae548ab-8f8f-4668-ba05-a2abf4b89759","event_cluster_id":"e0017f41-b71f-4659-b94d-36fcb62cb736"},{"claim_cluster_id":"e61d6703-69dd-4dea-8318-f7e671e98045","event_cluster_id":"ed912a16-7c22-4013-aecd-05fbaf2f3003"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"1ba178d9-d925-407c-bb75-60c655774cbf","event_cluster_id":"138ee12c-cc52-4ab9-bc9d-3ad91e9008d8"},{"claim_cluster_id":"9d400cbf-08ea-4c02-941a-80cd2d3e517a","event_cluster_id":"974fea38-71aa-4887-8998-28e03cf7c1b0"},{"claim_cluster_id":"847accaf-332c-4ec2-bd26-cd592d1fa2fc","event_cluster_id":"242e079a-1694-45b6-93b7-7c7320473a25"},{"claim_cluster_id":"c6541e86-8e1b-4bd0-926a-c380aa103aa6","event_cluster_id":"8b1384fb-f659-4943-948b-d2766f5d5af0"},{"claim_cluster_id":"679dc735-ea4b-4b4e-88e2-45d26bcc5b41","event_cluster_id":"c623ca23-8a98-4b0e-b365-eb9b3c1cdd86"},{"claim_cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","event_cluster_id":"f55b7553-3d55-4096-859e-954de960f09c"},{"claim_cluster_id":"f6a8a8da-c935-4c40-b9c2-79c93b84b629","event_cluster_id":"129ac9af-1e7f-4d17-aba1-4c71a6061174"},{"claim_cluster_id":"9fa27866-4911-4f0d-8135-cff4b7e597db","event_cluster_id":"ac3c4bde-8539-4baa-8848-6a9242884e47"},{"claim_cluster_id":"c153b607-ea7e-4a94-8f50-d29611d77fe7","event_cluster_id":"b6c807dd-0cb5-4622-8a2e-ef610ded44e5"},{"claim_cluster_id":"c6592686-c5bc-45c2-8341-7823b2936bde","event_cluster_id":"c08c0c57-ea8b-4938-93c9-7d2934450835"},{"claim_cluster_id":"13b8e657-b1a1-46e6-ace5-fc6a57928a32","event_cluster_id":"64ce313a-9f62-48b5-ac72-4f4f23b43da9"},{"claim_cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","event_cluster_id":"9d75c554-9eb9-4082-9c04-6fe3e303845e"},{"claim_cluster_id":"e6867616-fb8f-44d6-8b92-f5cca8ca9e6a","event_cluster_id":"9da22551-1ead-40c0-8c8c-078150bb5988"},{"claim_cluster_id":"b9198f54-dcf7-43b1-9ba8-28ae1ef79e83","event_cluster_id":"afa6f32e-961f-4c79-a6ff-7629b5b32022"},{"claim_cluster_id":"c8d061af-6686-4c3f-a2d9-0d23ccbd3f19","event_cluster_id":"d8ef4018-d9a3-42e2-a7c5-aef1d93ff0d6"},{"claim_cluster_id":"10cadbd2-7261-4295-9f88-df0f9a246b5b","event_cluster_id":"e72c5c13-765f-4dae-aecd-48d78cd16ece"},{"claim_cluster_id":"2b9508d5-4552-4994-840b-08ab461e29c3","event_cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de"},{"claim_cluster_id":"98a97f12-7d1b-49e9-8178-578b2d656f88","event_cluster_id":"1d45606c-718c-493d-8ad2-e61d4af0180a"},{"claim_cluster_id":"eb2e33e5-165b-4a02-aa96-d53bcd386da0","event_cluster_id":"a44b23b8-a3e3-493e-b038-fc26f5c96d31"},{"claim_cluster_id":"c6aa0cad-31b1-4d56-9f83-938881501dbd","event_cluster_id":"fb360de4-aab2-45d9-8f25-8bdd44c0ce45"},{"claim_cluster_id":"77ce5be7-73f4-4876-9446-d5aec1b02a1c","event_cluster_id":"0a14d3f0-c71b-44cd-8eea-7fc2fbc8fa38"},{"claim_cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","event_cluster_id":"ae87ce9d-8fb9-4394-9afe-202f1ec14722"},{"claim_cluster_id":"8ae7ec4c-38f4-4117-962e-b6f044038377","event_cluster_id":"227d1df9-e404-4f53-b880-3d4e96ed3405"},{"claim_cluster_id":"da5651eb-e7b2-446c-9fdb-dc89d46a36a7","event_cluster_id":"aeb63f4c-fb27-45bb-903e-d98ab93f7138"},{"claim_cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","event_cluster_id":"d19dc1b6-21b1-49bc-aaf1-fb24f7c66396"},{"claim_cluster_id":"e17e07df-4805-4514-b3fc-c16cda9269a3","event_cluster_id":"4a783d2e-0380-4a57-9e6f-4b34c23f0ad1"},{"claim_cluster_id":"59f4b586-ede4-4464-af30-2858db5799e0","event_cluster_id":"14619d00-6463-4ba9-8ab1-f0816bb06540"},{"claim_cluster_id":"aea747b1-1cb4-4b3d-94df-5c33181b0976","event_cluster_id":"138a4a3b-db1f-4c6f-b320-65bc4e554e6f"},{"claim_cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","event_cluster_id":"6f908336-dbeb-4b80-ae57-9e0431081831"},{"claim_cluster_id":"18daf39a-f6c9-4439-8592-186d1ea3c4b4","event_cluster_id":"fcfd6d39-3e11-43c7-ac1f-026d265beb4f"},{"claim_cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","event_cluster_id":"549c4c7b-f978-4fb0-adc2-18a978338670"},{"claim_cluster_id":"607ccd27-4dff-4901-8aad-e4dab1d3448a","event_cluster_id":"846c89d6-71e0-4858-9977-96bc0a6497b3"},{"claim_cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"8e9b5986-8277-45da-82c2-ab199cd3287f","event_cluster_id":"3d7436aa-4609-467d-a098-e24702a617e8"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"6a3f5b65-ac92-4e63-91ac-fe203f06931f"},{"claim_cluster_id":"637d133e-6c19-4fa2-b174-de1d016bd9bc","event_cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03"},{"claim_cluster_id":"b2036724-7c6c-4df4-b983-90c324253873","event_cluster_id":"9f415e0a-a04a-4d8b-b01c-2d2cc94bb46b"},{"claim_cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","event_cluster_id":"2e75fb89-d4ec-437b-bb34-741837209437"},{"claim_cluster_id":"2cd7a2ea-67d1-4d2a-8944-a71778dc20d7","event_cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810"},{"claim_cluster_id":"5238def0-ccfb-4f27-b836-f20f9b7dd70b","event_cluster_id":"707b49ca-9999-4b93-b6af-d31c32d2cafb"},{"claim_cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","event_cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638"},{"claim_cluster_id":"ed1fef35-ea22-4436-b53a-1dc1f0380298","event_cluster_id":"7b3392aa-9600-4d0a-9098-a43e48acd086"},{"claim_cluster_id":"d9f5972a-ff26-4242-938a-7c9615591c15","event_cluster_id":"f8a7db64-2922-40e3-9fc7-9a7934487f7f"},{"claim_cluster_id":"8ae7ec4c-38f4-4117-962e-b6f044038377","event_cluster_id":"e9cf68ba-8958-4444-b683-81cefe80ccd2"},{"claim_cluster_id":"542e81d5-bf51-451b-bb6a-204f6c8da58e","event_cluster_id":"abbb0c2a-4609-4a58-819a-928af8ad2bfc"},{"claim_cluster_id":"b60b834e-1991-44ea-a53f-68d101a440a4","event_cluster_id":"0d187a90-37da-4e4b-a2f0-e217ce5cbf79"},{"claim_cluster_id":"86fac771-eb74-4809-8f31-be78d543ad7a","event_cluster_id":"cc163006-eb32-4037-8b14-d4cea8207017"},{"claim_cluster_id":"ed1ca8c0-7841-4109-ada2-99053838abfe","event_cluster_id":"1ac6b5e1-dffe-48e8-ab2a-c58a20b3c8dd"},{"claim_cluster_id":"e21b1b35-31f0-4c02-9069-b35c0b38b172","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"c198c115-5575-4cd0-82cc-408f1b46a7a2","event_cluster_id":"015ba6d4-e890-401b-9586-28896557504b"},{"claim_cluster_id":"db07f4e5-716a-41e4-989c-98ced62f8fd5","event_cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722"},{"claim_cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","event_cluster_id":"72084673-8080-44fd-8f5b-97507abf262b"},{"claim_cluster_id":"435bc534-7da4-4fec-82cf-af0f2a0a282a","event_cluster_id":"b2b76ff9-4063-44de-a3e0-0b0a58a3a46a"},{"claim_cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f44705d5-ac0c-43e4-b025-c68545daa916","event_cluster_id":"67852dd4-618d-4a28-8987-e12077575820"},{"claim_cluster_id":"7b4d9f3b-78aa-4507-8228-424f51cb5289","event_cluster_id":"5bcb47eb-6ba9-4c85-9880-f3ab015417ea"},{"claim_cluster_id":"850a1f31-fc4f-4578-baa4-da3b7a35e30a","event_cluster_id":"d623d9ee-820d-4287-a726-51fa68088d0a"},{"claim_cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","event_cluster_id":"ce4675a2-eebc-4f4f-bcc2-33cbe65f4024"},{"claim_cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","event_cluster_id":"a258e4b2-c3eb-4705-92c4-2f0c1074629b"},{"claim_cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","event_cluster_id":"15bdefb4-3c81-4573-bb02-e7a3789e75e2"},{"claim_cluster_id":"4157a1dd-b3d1-4769-8ef9-bd2189b4146b","event_cluster_id":"22a6dab9-0118-488c-a537-5d58e3ff3a75"},{"claim_cluster_id":"97037755-caf6-49ed-8d7a-bb7c0d42bf8c","event_cluster_id":"e12f223e-9c33-4c5f-9e5c-badae44a41f7"},{"claim_cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","event_cluster_id":"4fe1a1d1-0c63-4497-8366-24cf2914a93f"},{"claim_cluster_id":"09a468db-6b0d-4230-a370-cfd6ba61219e","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"990306d6-263b-4984-88f5-4be9fc326334","event_cluster_id":"6cf1f120-eb6b-4ef5-8ea8-be39f36cebee"},{"claim_cluster_id":"1746dc9d-7bd5-45f4-a86e-d7bc4c937633","event_cluster_id":"6c980521-41af-4980-91ad-a696c286064c"},{"claim_cluster_id":"83965363-a851-4083-ae10-33f90da464da","event_cluster_id":"0be4cdd7-0577-44ad-9263-d020c0d38b8c"},{"claim_cluster_id":"76ba9e0c-8b5a-4b06-92f8-9ce9caa47714","event_cluster_id":"21e6b94f-0371-4a78-aa0e-8082ef7b0068"},{"claim_cluster_id":"70b45d78-dfac-4810-b7f6-abeea55c435f","event_cluster_id":"7ce03874-cd65-4bdc-9ec5-e264566fa468"},{"claim_cluster_id":"a764eb56-b1bb-470b-bb17-4bd9f5369b4b","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"a7436ce6-07d0-45e0-8628-2de252e4cb46","event_cluster_id":"8e8f1a63-a25f-436d-856a-cda548ff35df"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"3e318927-1041-4535-a22e-049f32238ea2"},{"claim_cluster_id":"138e6c92-a8bd-4f22-8e72-b320bdcf0b62","event_cluster_id":"77183e66-d172-4f0f-b205-95c246afc00a"},{"claim_cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","event_cluster_id":"126a3f86-7f2c-4e93-8c54-043a34be7761"},{"claim_cluster_id":"f387c566-78b4-4549-b5d3-12ab9f1a83af","event_cluster_id":"5ff5f55b-42b2-4238-8f0e-2306bf47cc82"},{"claim_cluster_id":"e633b9f2-d6c2-4c51-83af-0aed2e577009","event_cluster_id":"b1eea9c0-c6c8-4d17-a1f4-b1ddcc163363"},{"claim_cluster_id":"1405f96f-07a0-4454-a7cb-365f38772605","event_cluster_id":"a130a6d0-55d6-47e5-9fb3-2d64b90c9bf0"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"3871454f-b8ca-4976-ba58-fba8307b403e"},{"claim_cluster_id":"dfd9bb6d-a08b-428d-8e19-e9eebd219088","event_cluster_id":"55dd7d4d-d0df-496a-b949-1f305611420e"},{"claim_cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","event_cluster_id":"f5af21c1-57be-4378-ab8c-5400cfed6bff"},{"claim_cluster_id":"ddf6dff1-95bb-49d1-93d2-18eeac6d22bc","event_cluster_id":"e0993394-090d-4043-91c6-3b265e1bac79"},{"claim_cluster_id":"4e78b61e-317a-4417-b42d-464646384193","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"f6f15ea6-27bd-499b-a6fe-74d144b5ac0b","event_cluster_id":"19c1333f-bc11-4412-9e3b-c195d71596c2"},{"claim_cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","event_cluster_id":"3a63a5d8-fef0-44dd-9aaa-21b0ee109283"},{"claim_cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"d65c0d37-123c-4e39-9b2d-386613952a30","event_cluster_id":"60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"},{"claim_cluster_id":"c5855521-5ebf-478e-a7af-b3f07554a912","event_cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5"},{"claim_cluster_id":"e58c74de-137e-4144-8780-c4e86fcc480a","event_cluster_id":"f03d0193-877c-43d8-81d9-6519c6ca169a"},{"claim_cluster_id":"29223456-9a08-4f68-9ce7-d62d961fb6aa","event_cluster_id":"897c7076-ce98-4405-aaa5-1e883a645242"},{"claim_cluster_id":"0a1db453-23bf-4b25-a04b-c4f13d273e88","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"5008f252-8b6e-4832-ae6f-1940fe20e4de"},{"claim_cluster_id":"e20ec3dc-5039-4e9b-be7d-622592bf425d","event_cluster_id":"74542328-97a3-4775-a89c-6406225efc20"},{"claim_cluster_id":"23dcfd5c-77ee-4590-92a1-d00d1da215c4","event_cluster_id":"ff15e2e2-1cc8-45e2-9674-8847b94be12b"},{"claim_cluster_id":"14b46c0a-7b16-4722-b599-90d7d69970a1","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"f9c87407-e574-417b-a567-8221daa6ee9c","event_cluster_id":"17d6daaf-12c7-4c0b-88cb-bf8161dd5be6"},{"claim_cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","event_cluster_id":"b05a0ac1-6107-4a11-aa69-1115d8b00d86"},{"claim_cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","event_cluster_id":"015317d7-08c9-4925-98a2-39e2a1fa7c6d"},{"claim_cluster_id":"487393b6-56b8-4c3f-bdb3-88dbd2ac69d5","event_cluster_id":"5e59f3a9-c776-4791-b6c4-d58d75f185a7"},{"claim_cluster_id":"011b48fb-6ec4-41cc-bd4d-394e371c18cb","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"d8483e15-c78b-44e2-8070-c109cff73a66","event_cluster_id":"e450bc0b-1319-494c-b418-fa5dced99fad"},{"claim_cluster_id":"5863948c-f84b-495d-bfa9-facccb6313d4","event_cluster_id":"756be7cc-dc0e-4799-bd5e-990554a6844d"},{"claim_cluster_id":"ad83e0a6-e572-4332-8ef0-01e05cdfa760","event_cluster_id":"b8e4cc10-e335-4506-831c-61365dc19547"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"9087a989-a032-4a4f-877e-3dd17a8e6902"},{"claim_cluster_id":"29780617-dcdc-405a-a7d2-26d05fd8f9d4","event_cluster_id":"5a419c79-66fe-4be4-a3c1-02415535b5e5"},{"claim_cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","event_cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de"},{"claim_cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","event_cluster_id":"d5b4afb5-46e3-4fab-9511-72f4984164cb"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"84ba9e08-7f87-4e91-abf6-4415ddb9a231"},{"claim_cluster_id":"58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e","event_cluster_id":"ee0b2c4e-ce44-4f3d-90ff-fd0a1c204fa5"},{"claim_cluster_id":"a6d92a93-8990-407f-a2ca-8786c79330ee","event_cluster_id":"763eccef-6999-42f0-bf57-610e354559e9"},{"claim_cluster_id":"5b2c4526-459d-4b6f-8f31-bd40fccf12ff","event_cluster_id":"d2f70202-2b46-45a9-9905-a0ccfee90661"},{"claim_cluster_id":"767386e5-6b6b-4b02-8200-421222dc2720","event_cluster_id":"60cef9d1-8d47-44f3-9820-0cdbe57600fb"},{"claim_cluster_id":"f46bebef-6c63-4778-a5c7-e0d7b893e969","event_cluster_id":"31310d54-1285-4857-b35a-cbc2a3d3bfc2"},{"claim_cluster_id":"8b798ea6-1045-45b9-a2f6-023a84ae6ad3","event_cluster_id":"8b3eb310-4541-41ce-8ebd-0c1cfe7b2a0d"},{"claim_cluster_id":"dfa47852-ac3f-4b74-bc17-22923a395552","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"0f388428-daa1-4ce6-a7b1-8c553ad3896d","event_cluster_id":"708ac391-bd79-4343-a52b-53252ffe59cb"},{"claim_cluster_id":"06ceeed7-8a02-425d-9be1-3881dcb38762","event_cluster_id":"dd07650f-5b24-4fc1-a78a-9b6fc6589ccf"},{"claim_cluster_id":"f0e862e5-92ba-499e-8f7b-4935ce01c5fd","event_cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70"},{"claim_cluster_id":"1e9c3202-7611-4885-bb24-d9dd05b7eed3","event_cluster_id":"ebe02d8b-ea82-4232-851f-f5ea26e54e8f"},{"claim_cluster_id":"017c8345-ee2f-4b6f-8701-6def5bbd5082","event_cluster_id":"c55fe718-0683-4449-8b87-8d1de09aac69"},{"claim_cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","event_cluster_id":"abf9a23b-ae17-4adc-8775-9b47f6861ebe"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"2f03e50c-f48e-4212-9d22-0ac755bb8fe3"},{"claim_cluster_id":"f6a4aea6-92b4-4a70-a984-2326df1ee39e","event_cluster_id":"6c41a4c1-08f4-483e-b095-97806b1140bf"},{"claim_cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","event_cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07"},{"claim_cluster_id":"579db367-74ad-4432-9888-8af443f74bd8","event_cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133"},{"claim_cluster_id":"796ddc52-9094-4fcb-af10-9fa6a06448ba","event_cluster_id":"0ebcd390-0474-4d90-81dc-d03c9dac78e4"},{"claim_cluster_id":"8ac816b2-de5c-4294-a968-e6279613b1d8","event_cluster_id":"66034097-f5ff-415b-b7cc-7775692bf89e"},{"claim_cluster_id":"a03d3de9-e5ad-47e0-9374-17e6c1998859","event_cluster_id":"337fae10-d08a-4844-b763-fc332cdde523"},{"claim_cluster_id":"8aec1af3-93d7-45b8-8844-62e8b3ac6198","event_cluster_id":"e2995c43-c086-47bc-aceb-1e2374b7e24a"},{"claim_cluster_id":"192dfe82-fc68-4d4d-ae38-d6077567ed10","event_cluster_id":"5c4c352e-d04c-4f9a-889b-492cb2fb067c"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"651043d1-0d9f-42ac-bcb3-c7e39b7939ec"},{"claim_cluster_id":"338d5a8d-64c7-4bed-a37e-208196096015","event_cluster_id":"11663b2b-28c7-494e-973e-2fc5dca8374b"},{"claim_cluster_id":"1aadbdec-7f0b-43f3-98a7-709a1bcb5807","event_cluster_id":"9f3b49b5-fd07-4adf-8183-7615100c8917"},{"claim_cluster_id":"8a0c21a3-b47c-4676-b965-59f7699171ec","event_cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970"},{"claim_cluster_id":"8b798ea6-1045-45b9-a2f6-023a84ae6ad3","event_cluster_id":"ed912a16-7c22-4013-aecd-05fbaf2f3003"},{"claim_cluster_id":"a74a2d72-1d86-4264-9389-b4fe594a7218","event_cluster_id":"6195dc7b-895b-4134-9995-738fed6389e2"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"abea76a9-3994-48b0-b3bb-df2d7f55ad12"},{"claim_cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","event_cluster_id":"0ba7abed-e798-4cd4-b041-3026081313b7"},{"claim_cluster_id":"342cdbac-7da2-46b3-80b3-a9b75e8fee10","event_cluster_id":"2dbc4a6b-98c2-45e2-be58-a00cfa47819c"},{"claim_cluster_id":"9254d2c4-775d-4f48-975f-879f17b9f193","event_cluster_id":"66095ea1-59d7-4068-855b-70fe6ff9d81b"},{"claim_cluster_id":"dfea6d47-10c8-4540-8a78-5667ac532c10","event_cluster_id":"ad2e25ad-1bb4-4fa6-8af1-bce0c9f8c697"},{"claim_cluster_id":"cb25f623-bfdb-42c7-9873-fa48f80feade","event_cluster_id":"60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"},{"claim_cluster_id":"2cb357c3-3958-45ce-bb44-f76facb84ed9","event_cluster_id":"97cdd3f9-b13e-4b85-9e62-c48c3b34bca9"},{"claim_cluster_id":"1d4acd59-7bc7-421b-87d6-c6dcd6e61497","event_cluster_id":"b27be68c-0a41-440c-9295-b88b093fc572"},{"claim_cluster_id":"e65823f0-739f-4ed0-bd57-83b926046577","event_cluster_id":"7e3a0dda-730a-409c-87a4-d60847af0bea"},{"claim_cluster_id":"91b0db25-32e4-4e5d-a32d-911732cbec28","event_cluster_id":"23236a04-b4c7-41b8-81ee-60c41aaa7835"},{"claim_cluster_id":"53ddceb6-33d2-42fd-849a-253f21907d2a","event_cluster_id":"0060e859-7676-43d1-9a21-c2ddc4f18fbb"},{"claim_cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","event_cluster_id":"03329c55-b9c0-4585-b5b1-817ec3b57899"},{"claim_cluster_id":"4fc00d95-d399-4677-9437-13f7e6f573c4","event_cluster_id":"49c9cf48-a13c-439b-9db3-4000e6bfc74f"},{"claim_cluster_id":"e935bf33-7d4f-4ee6-8636-94e91a064afd","event_cluster_id":"f70debef-4097-402b-81f2-0ddc396e0729"},{"claim_cluster_id":"e2621663-e9d9-45c1-9069-fa9d94c82303","event_cluster_id":"323ed409-a965-47fb-afbb-d0b2c3bbefa4"},{"claim_cluster_id":"a9b66749-8bb9-4643-bb36-488cbf77974b","event_cluster_id":"ae4c214d-3e4b-416f-8e83-fe80cc92e55e"},{"claim_cluster_id":"a0c8c3de-8102-4a9b-b20a-80ade6132b4e","event_cluster_id":"b4d7baf4-91b3-4011-b5b5-664a10258241"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f"},{"claim_cluster_id":"290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45","event_cluster_id":"63959dc1-33f1-448d-b73f-370297a47c55"},{"claim_cluster_id":"61784f3e-1c50-4b37-9db4-0fd1ec458127","event_cluster_id":"8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"},{"claim_cluster_id":"4958a7ec-0cd2-487f-a59b-9bc34843a2b7","event_cluster_id":"d56cee1a-0acc-4d28-9308-a2519fc04041"},{"claim_cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","event_cluster_id":"4d35ec7a-3721-4f70-b323-8070302a4c95"},{"claim_cluster_id":"1f1f405f-6b99-4de2-b4fa-1bd105b3c577","event_cluster_id":"3b00f0b1-76ec-42b4-8949-3a408087b558"},{"claim_cluster_id":"ce07721b-5347-4d52-81aa-7a7c68338485","event_cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"},{"claim_cluster_id":"2c351118-b702-46fc-bce1-27477e956eb0","event_cluster_id":"34ebf375-c746-4b55-870a-320a9407196d"},{"claim_cluster_id":"b6e9f077-b94a-483e-a60f-d0f3f875ea60","event_cluster_id":"1e4d6697-c15f-4888-819c-dc2c8687c928"},{"claim_cluster_id":"f1afc4d0-4eaa-40ab-99e6-20e11c550ccb","event_cluster_id":"b6fed6af-5368-4204-a338-2997b148a384"},{"claim_cluster_id":"62fc9d37-f7e6-43e7-a681-3c5679294ee9","event_cluster_id":"fdc8411e-7a17-4fc6-bef2-367c46894068"},{"claim_cluster_id":"b93f59d3-e54a-4700-86ef-b20c995b73b6","event_cluster_id":"8b267081-f50e-4410-bb56-f7281271aae7"},{"claim_cluster_id":"839faa06-15df-459d-8f1d-015981c670e0","event_cluster_id":"4da30c02-5a8f-4e15-af9d-b0a7ede85a55"},{"claim_cluster_id":"a9096ed8-3c07-4fd9-a21c-9fdb59fe1353","event_cluster_id":"a5ce0433-5607-4061-b0d6-334f9dea23ec"},{"claim_cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","event_cluster_id":"b92e2016-2cf5-4f68-ae85-5c01d12bbd49"},{"claim_cluster_id":"54e59784-1db4-41f0-a651-2d5e2138670a","event_cluster_id":"1a1fe423-28a9-476d-a154-c1e0960501dc"},{"claim_cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","event_cluster_id":"9e950aab-bcb8-467d-b56c-2d0bc86754ee"},{"claim_cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","event_cluster_id":"3f77000e-b7d1-457b-963f-2743a0bda688"},{"claim_cluster_id":"dac4f0e5-e31b-44cc-a055-3ac65eec9d11","event_cluster_id":"17e824c4-f35e-49c3-9ffd-3049f0003451"},{"claim_cluster_id":"27097c65-59e7-4824-9bbb-c0736b2c9f70","event_cluster_id":"60a5fa4a-02a4-4e44-b778-ab28e2e5eb27"},{"claim_cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","event_cluster_id":"c9780602-10a7-414d-9965-0df44aadba9b"},{"claim_cluster_id":"6cade303-8a3e-4226-b5e8-0d3b189187cb","event_cluster_id":"635850fb-0b7d-4148-aae4-786dbec7ebb9"},{"claim_cluster_id":"976d7c8a-cb17-41e5-9407-5cd8c141bb84","event_cluster_id":"7a9ddc4d-79e3-45ee-a4d8-9a05a9685354"},{"claim_cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","event_cluster_id":"a1c74ee2-0da5-4362-bf0c-2f7caddeae61"},{"claim_cluster_id":"ac4174c2-4597-4a76-ac06-95cefda372c9","event_cluster_id":"6e8c4432-d4c6-4fcd-9e26-cf2164b211ae"},{"claim_cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","event_cluster_id":"c1036fd0-74b9-4ac8-a4d8-2710377e38ff"},{"claim_cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","event_cluster_id":"0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"f44c0c51-4b5f-47de-9ff7-9cd4c4c2b58a"},{"claim_cluster_id":"ceabee0f-bc28-4b8e-8445-fc63ff551472","event_cluster_id":"86a1cb16-ab28-4b30-be94-ef12abdf7cfc"},{"claim_cluster_id":"cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb","event_cluster_id":"e95aa789-4bbc-4c2d-aa4e-ab829c64ed4e"},{"claim_cluster_id":"c721dd3f-abaa-46f4-b0b3-0998badfc28c","event_cluster_id":"6d0ecf89-9eab-4b55-8c05-ab0885982adf"},{"claim_cluster_id":"a94e5bcb-b502-4cb7-a23d-3a1e29ce963a","event_cluster_id":"3044ed83-9d35-4f0f-9d53-c999faefc097"},{"claim_cluster_id":"6aa59122-6821-4e76-8afb-2ad2b679a5aa","event_cluster_id":"028c83e2-81b7-4016-ad11-5ab7dddf6569"},{"claim_cluster_id":"97fd88d2-827f-418a-aa85-784dc98e83f5","event_cluster_id":"37a15ab9-c9e5-493e-bc55-f1d64743861b"},{"claim_cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","event_cluster_id":"773c7be2-511f-4315-b512-fcfb831f2cc3"},{"claim_cluster_id":"44f7e426-bb87-4dd0-bf0c-80fb71c61eac","event_cluster_id":"a9c08567-c779-4007-8ddb-2cc8e3429124"},{"claim_cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","event_cluster_id":"dae1826c-9197-4507-aadd-a2ba9a01285b"},{"claim_cluster_id":"d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc","event_cluster_id":"ab8af083-dfdc-4c18-95cd-32d551c130c1"},{"claim_cluster_id":"09f8ca5f-e359-4e32-b6bf-f706de588232","event_cluster_id":"b0ba837e-7026-4676-894c-bd729208b8f0"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"a71276bb-c498-4f7f-840a-9e20eea63e3d"},{"claim_cluster_id":"e968bf8c-b2a8-4330-bf71-9cab4f6826a5","event_cluster_id":"a9876e6a-52b6-4181-945b-9e745a17434b"},{"claim_cluster_id":"078f370f-a761-435a-a7fd-aae948eb479b","event_cluster_id":"442c0a4f-c382-4b95-be13-3c18f2d71210"},{"claim_cluster_id":"f92684c8-da9a-477a-ba9a-9eb41a6f9f90","event_cluster_id":"985e777f-c3e3-42f1-b650-98ac19e7f7b5"},{"claim_cluster_id":"76e2cae3-f195-4448-9b25-588665927aca","event_cluster_id":"485753eb-23f4-446f-a237-3a4fc59f9bd1"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"6eb6f4d9-183a-4612-a4f7-dd59bbc26512"},{"claim_cluster_id":"00386fb1-3dcc-4b4e-b74b-bc14dbc4e260","event_cluster_id":"a5cfe32e-2f16-4644-a4e9-767621b4c4a7"},{"claim_cluster_id":"7f43c7d3-2a4b-493c-b3f0-a53355ae39a3","event_cluster_id":"4551b9a3-cfb2-4080-a1f5-d94f9554a9e1"},{"claim_cluster_id":"57eb29a4-6d1b-4f98-a507-b97e4235688c","event_cluster_id":"29912b0c-71dc-4757-ad86-50cb8c825cd7"},{"claim_cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","event_cluster_id":"8c73e80e-645f-41d1-b314-c8d7737bd33f"},{"claim_cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","event_cluster_id":"dd21a7e1-c272-4900-8da2-788f661f4b0b"},{"claim_cluster_id":"0cffe066-8740-4f3f-9c12-d03f093733d5","event_cluster_id":"80f966d4-497a-4e7a-b9e2-4d30faf7da72"},{"claim_cluster_id":"8f15ddff-3bc7-4fbd-9371-1a897f8b9078","event_cluster_id":"c79e73ba-e1da-436e-8dc9-c8818873c182"},{"claim_cluster_id":"8140cb8c-a254-4493-b790-598f4ef3676f","event_cluster_id":"57d96007-f80d-4110-8583-3e280492b584"},{"claim_cluster_id":"a63004c7-9e1f-4600-bae4-f70655f0094e","event_cluster_id":"ad63a5c7-e4a9-4703-80f2-827fc6b1bf0d"},{"claim_cluster_id":"89b28f7e-be14-417b-aeba-019498e50195","event_cluster_id":"8693ba93-793a-4911-b2e4-5cb419139802"},{"claim_cluster_id":"ee3408ae-2ea4-4661-a58b-6e825aa4a0ff","event_cluster_id":"c6829bdd-21da-4a4f-9d8a-98920160c65d"},{"claim_cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"6b512fcc-e6a2-414b-8a86-90a11b76795a","event_cluster_id":"04b6753c-ecde-472f-9566-0e86e4ac2a52"},{"claim_cluster_id":"d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b","event_cluster_id":"3092d2a7-23cc-41c3-b8bd-3096963a1b79"},{"claim_cluster_id":"c78cce84-ea53-4b86-8393-67ca74594e0c","event_cluster_id":"0e6b6876-fb14-4627-9900-55ce513c116c"},{"claim_cluster_id":"4effafac-8e45-4dfc-8f71-d8c9b1e37d7b","event_cluster_id":"e74b075b-e6e4-4efc-b7ef-f8a74fd509a0"},{"claim_cluster_id":"24a2e46d-b5a2-4677-a613-c39e311e8f1d","event_cluster_id":"b270ac4b-0013-48c8-8b62-49d992310a4e"},{"claim_cluster_id":"f4f83538-936e-4149-94c2-66b6b2ac2571","event_cluster_id":"c849043f-d317-458e-b56e-651b8d73a135"},{"claim_cluster_id":"2951f722-7d9f-4f1b-b69b-0dfe73efebd5","event_cluster_id":"e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5"},{"claim_cluster_id":"478db2a7-a90d-4fbf-8954-0416daa97dcb","event_cluster_id":"64ce313a-9f62-48b5-ac72-4f4f23b43da9"},{"claim_cluster_id":"ab1f8fac-3632-4188-90ae-a2c911b8425d","event_cluster_id":"96c115c1-f9f9-479d-9ecc-98da549128b0"},{"claim_cluster_id":"86d26636-5c9c-416b-94e0-e2a89a9628c3","event_cluster_id":"87e0267f-e999-4f76-8883-d246a2dc113c"},{"claim_cluster_id":"83392417-156e-4467-96c4-b7a769a50f3f","event_cluster_id":"cfe9cc78-dae7-4fb3-9619-c934beac1286"},{"claim_cluster_id":"afebac7c-8f71-44cd-beec-d242a1b97e86","event_cluster_id":"8f5bfc0f-9b63-4126-aa4e-caf3448c019e"},{"claim_cluster_id":"cb25f623-bfdb-42c7-9873-fa48f80feade","event_cluster_id":"0257bfac-c84e-478c-a7f4-6a03847d3df0"},{"claim_cluster_id":"1f956691-257e-4b52-8536-1a80ad662f9b","event_cluster_id":"76d75a5b-4dc1-4bbe-8b14-04af1d297ada"},{"claim_cluster_id":"aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868","event_cluster_id":"e5b92c5d-257a-4d84-a804-3e2462bb2954"},{"claim_cluster_id":"61c8550e-839e-4f39-803d-72ebbfa747a7","event_cluster_id":"29cd39ea-ce90-496a-a9f1-6917924ac984"},{"claim_cluster_id":"edd65f26-0117-4202-bd31-c3f265210b5e","event_cluster_id":"8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"},{"claim_cluster_id":"69517d67-11aa-4671-bb8a-815c7995a3b7","event_cluster_id":"63223fc3-b9f1-47b4-9d17-af262f481c02"},{"claim_cluster_id":"141b690c-587b-4b7b-9ad4-7b1b333f6cd8","event_cluster_id":"96ab7552-d195-40c5-b31e-9af997302842"},{"claim_cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","event_cluster_id":"a174fdfb-5e90-4340-85c5-f1498bd04f82"},{"claim_cluster_id":"392d337b-80a2-4413-8e08-b0007e5c9b50","event_cluster_id":"c0bc02e5-e391-4352-8bc3-69ffab45a6e1"},{"claim_cluster_id":"a90d4523-8e1f-4287-ae0c-72459f7c14c3","event_cluster_id":"0ed6d266-01da-4d89-816e-946754d220ce"},{"claim_cluster_id":"36ece2d2-4cdb-4985-90ab-a6751ad5b290","event_cluster_id":"409928b1-cabb-476d-812a-3340869af622"},{"claim_cluster_id":"4d4a5a78-bde2-4ed8-943c-811738978e0d","event_cluster_id":"ef1b2d86-739d-4342-9581-88b77e5ebe93"},{"claim_cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","event_cluster_id":"ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b"},{"claim_cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","event_cluster_id":"7767473b-b833-4047-b346-9abf204211fd"},{"claim_cluster_id":"a0b96ee6-2ea9-4035-b542-1107b0662e77","event_cluster_id":"e1bd1fc6-e475-4d2c-871d-d09149cf8937"},{"claim_cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","event_cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125"},{"claim_cluster_id":"492eadfb-99f3-4bc3-a9af-afa12d93eb99","event_cluster_id":"418497da-ff5e-45fe-b7d6-b0ab00e9f812"},{"claim_cluster_id":"bb382092-b4e0-4652-830e-be1eeb609ad0","event_cluster_id":"49f74be2-2b75-49a2-9647-991264918ba3"},{"claim_cluster_id":"f4d9e677-79ed-4c5c-84a1-d127898975a0","event_cluster_id":"3aad1795-c40d-46c7-abc6-a9e8928bc743"},{"claim_cluster_id":"7966aa4e-476b-473f-85ad-b267835811ed","event_cluster_id":"65f95c9d-be3f-40b0-b287-d80a74be8b4f"},{"claim_cluster_id":"d5458c27-5843-4ff6-b105-7703aeb6f588","event_cluster_id":"8b4dea1f-81ef-489e-9aba-a19d5e926009"},{"claim_cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","event_cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07"},{"claim_cluster_id":"af26e832-f248-48e8-93f5-fdb54d01a56f","event_cluster_id":"fe7c0aa8-6a9f-47ad-ae53-9de7a81cea64"},{"claim_cluster_id":"7e245bdc-e727-4627-a96b-f1db937337df","event_cluster_id":"1179f0df-1a7a-4032-9a7e-362081c484c8"},{"claim_cluster_id":"d6ec7b4a-689f-48d4-bb2a-ff95c991125c","event_cluster_id":"49c9cf48-a13c-439b-9db3-4000e6bfc74f"},{"claim_cluster_id":"f90167d0-30b7-4246-8eb8-7c564be9c434","event_cluster_id":"9da8623f-1bd2-4a8e-be97-3ec68da5904b"},{"claim_cluster_id":"2cd7a2ea-67d1-4d2a-8944-a71778dc20d7","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"11210f68-2915-41ff-b25a-a55a575f9528","event_cluster_id":"6cba2b8f-402d-49a5-b1eb-4024641b28c9"},{"claim_cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","event_cluster_id":"d345d980-af47-4c52-856b-f3fba326963f"},{"claim_cluster_id":"5833eaa5-8c9c-42b9-bd12-8cdf781ec725","event_cluster_id":"beafc838-f8fb-4f24-b442-c5d64c7e1a7b"},{"claim_cluster_id":"579069a3-1a62-4c32-8658-b35e45309ccb","event_cluster_id":"5f698021-f0a7-4748-8344-6112bbe0b66e"},{"claim_cluster_id":"f8ceed1b-ae48-442b-9e71-03f2203d7e38","event_cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4"},{"claim_cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","event_cluster_id":"df8da41a-f9cc-4448-aae3-112ed4b0b247"},{"claim_cluster_id":"c8a67d7e-6b5c-49cc-b944-ad699ac9cff0","event_cluster_id":"8a30c746-b21f-4f8b-b1ab-389110f61293"},{"claim_cluster_id":"791c0550-4877-4364-97d4-01b5b8435b0f","event_cluster_id":"65c4b6f4-f33a-4b23-a073-15587ff25d75"},{"claim_cluster_id":"4eb34d6f-2849-4a6f-9012-a59681fdeeff","event_cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf"},{"claim_cluster_id":"b54e5664-a40b-4682-b959-bcfb59ddd4b0","event_cluster_id":"2fb74668-36fe-4d43-9c95-f7bf88e2f60c"},{"claim_cluster_id":"284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5","event_cluster_id":"b2d9b3c8-468a-4cb2-9381-64f806a79262"},{"claim_cluster_id":"bd9462e2-36b0-48f7-92f9-c83dd2ee5550","event_cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"},{"claim_cluster_id":"adfa00d7-81da-47be-a9ec-4b8dfb8ee34a","event_cluster_id":"abbea790-2006-423f-9f7d-2f67dda5b47d"},{"claim_cluster_id":"1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254","event_cluster_id":"cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"},{"claim_cluster_id":"5677f10d-93dc-4b72-b95a-8bc4291ec487","event_cluster_id":"b38c991a-b869-4a3d-9864-3fdbb089a284"},{"claim_cluster_id":"d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db","event_cluster_id":"f44c0680-07c7-4ea0-8054-7643f1b8eafd"},{"claim_cluster_id":"2fdb1c74-dc8a-4068-93d3-ff9e7c3e4528","event_cluster_id":"a99e560b-cb11-48f1-ac8e-d85b9a82ba77"},{"claim_cluster_id":"ff70f7bd-e1b1-44ea-8b32-024f3d1917ed","event_cluster_id":"33e00989-9970-4b46-a3f1-4c221fc84217"},{"claim_cluster_id":"0a3a7c87-61b9-4961-a698-61129e827319","event_cluster_id":"be6d3887-f154-45dd-b994-3e262cd683ab"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"c724c59d-be1d-40e0-8e89-b56ec9ff6193"},{"claim_cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","event_cluster_id":"cda7a1d3-b038-4c3b-864e-35781faec81a"},{"claim_cluster_id":"980136c6-363f-4cda-bc50-cca417518993","event_cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03"},{"claim_cluster_id":"e633b9f2-d6c2-4c51-83af-0aed2e577009","event_cluster_id":"7ba2e807-ddc2-4313-891b-359c6bfa546b"},{"claim_cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"c160d7d3-0687-4ba7-86ad-32e9cddeaf56"},{"claim_cluster_id":"5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb","event_cluster_id":"89bc3f77-435c-48cc-9674-3f733858f60d"},{"claim_cluster_id":"4892691c-c25d-434c-bfaf-8b1764a0e393","event_cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de"},{"claim_cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","event_cluster_id":"4b93a421-107c-4185-912b-a73d039895b4"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"70862016-3977-4b4b-9e68-43859faa28ba"},{"claim_cluster_id":"9d2cc997-e857-4b80-a227-cc6a1c61d16d","event_cluster_id":"ddf8f300-b701-4129-bf0a-f30da96bc031"},{"claim_cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","event_cluster_id":"5279c839-650e-45b8-a4b4-5af5d5649ea3"},{"claim_cluster_id":"fdae240e-8bc7-467c-b880-f3913e28e6ce","event_cluster_id":"5605c591-48df-4465-a293-86fc68f1944a"},{"claim_cluster_id":"1e227a80-8d1d-4484-9608-82719d3b526e","event_cluster_id":"335924d4-8c81-4bf0-8e93-746bc3bcb081"},{"claim_cluster_id":"5518570b-ceeb-400e-8720-a531292d57ce","event_cluster_id":"e52a7c45-1c0e-4caf-a481-c7da67d6803c"},{"claim_cluster_id":"71522ed0-7107-4dfb-8b87-e633332c4e3f","event_cluster_id":"a58a3450-f18a-4787-a5ff-ce87f4539ba9"},{"claim_cluster_id":"7187c5ae-6f6b-4c6a-af65-98db1f5251db","event_cluster_id":"b38033d5-5b50-487f-be85-35eacb567316"},{"claim_cluster_id":"ddf6dff1-95bb-49d1-93d2-18eeac6d22bc","event_cluster_id":"827901e2-9d83-4ed3-ac71-af38455fbc22"},{"claim_cluster_id":"e3e4b634-fa33-47d8-9f29-eefdbb263769","event_cluster_id":"9e771d92-eea3-45ec-b1c4-e7bba0011301"},{"claim_cluster_id":"9b129e4b-0540-473c-90ae-ff21e622eb3c","event_cluster_id":"7fe9b7f3-5fcc-469d-bfc5-789d2c7ecb0c"},{"claim_cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","event_cluster_id":"40265b93-5ea0-4bd6-8b7d-972baab54b70"},{"claim_cluster_id":"a3272ef4-947f-46a0-b484-adddd74b2e08","event_cluster_id":"4cdfe663-949e-4463-904d-7ad58162fcfa"},{"claim_cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","event_cluster_id":"9b321e6e-fd77-47ca-b965-6aceb0683d37"},{"claim_cluster_id":"7b49f746-2118-4c08-9ef0-985906af7b07","event_cluster_id":"e72c5c13-765f-4dae-aecd-48d78cd16ece"},{"claim_cluster_id":"5a33a893-0ae3-4e2b-9f4c-02de9772f96c","event_cluster_id":"92352325-85b6-4726-9aed-67119e9599f9"},{"claim_cluster_id":"644ce0a3-b992-4dbe-be7f-558277802f15","event_cluster_id":"a65da1cd-8a4f-401e-8439-da2c5c03bd1b"},{"claim_cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","event_cluster_id":"cf0c77f3-683e-467a-b83c-95b78a12d867"},{"claim_cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","event_cluster_id":"9687983c-2f58-4f1f-9d09-86f19210af37"},{"claim_cluster_id":"5cf9fbcc-d33b-4ff7-b888-4b9e4e5ca4e1","event_cluster_id":"11663b2b-28c7-494e-973e-2fc5dca8374b"},{"claim_cluster_id":"fde51b3d-8646-4df9-926d-484efbe86dc8","event_cluster_id":"0ecff957-070a-4e14-9ee5-9c4a7435ec3e"},{"claim_cluster_id":"7eefde16-5844-4305-a679-da87990a2640","event_cluster_id":"93067eb9-0c23-4760-88de-71a2925db3fb"},{"claim_cluster_id":"24f6a0c0-6612-4488-bc48-40d12340ab22","event_cluster_id":"4bacc8d6-9346-41d5-8d0a-b2a14974c1c3"},{"claim_cluster_id":"10e97fc5-5fa6-457f-aefb-257e90e8124b","event_cluster_id":"b5f72321-d879-4344-b131-82dc3d0c1704"},{"claim_cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","event_cluster_id":"4175d453-3f8e-438a-adde-113f24ef2a95"},{"claim_cluster_id":"1993c1c6-e677-4697-9e0d-f4c2332e53fe","event_cluster_id":"41e9c8c9-45c4-4590-9393-a3b2281304ab"},{"claim_cluster_id":"a222dd36-fddd-41d8-956d-d735c7c4c6bb","event_cluster_id":"db23d549-f792-47f2-bc74-2fff4db9d0ef"},{"claim_cluster_id":"0a173478-bf00-4e1f-be9a-c8305b945d9d","event_cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03"},{"claim_cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","event_cluster_id":"0c639465-7159-40b2-869b-06840b83505a"},{"claim_cluster_id":"af51e97e-2570-48ba-a0bd-ab0668831da9","event_cluster_id":"63ec2628-3b3a-4ba2-959d-d95266568ef5"},{"claim_cluster_id":"1e099dec-1be9-48be-a1bc-00d89e3cc02f","event_cluster_id":"003a7d07-44de-4091-ae03-27e916ffcfa5"},{"claim_cluster_id":"bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5","event_cluster_id":"27391c49-b3b4-4f4d-98c5-cbe7a8ecbb05"},{"claim_cluster_id":"b39e93e4-b791-4b1e-963b-d8f068ff0b1d","event_cluster_id":"4cbf95dd-29fa-442e-b9e9-93eb4878a93e"},{"claim_cluster_id":"ced45aa6-b370-4a79-b76b-674fcd6c0668","event_cluster_id":"81d7440a-8ada-45a3-8b2c-8318c7034ac9"},{"claim_cluster_id":"ae58d35c-53bd-40b8-b6d5-7fe4e15e229a","event_cluster_id":"e12630d6-f5b6-4dae-9bf0-63dd6b0528b1"},{"claim_cluster_id":"a7867a02-8602-4251-af70-d100ee635a74","event_cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03"},{"claim_cluster_id":"c831921a-fda1-47ba-83e1-1042bd97f245","event_cluster_id":"8621b776-3006-4d9b-93a8-f14394cb2f9a"},{"claim_cluster_id":"b2a26561-1192-4739-962b-b9df80083243","event_cluster_id":"3aabf3aa-c1eb-4474-a134-a2e2ec8c19f6"},{"claim_cluster_id":"f9e580f2-a45e-455c-a4fc-189d643f07ef","event_cluster_id":"a9a6169f-2727-47ff-8df7-1f0dc7eaba02"},{"claim_cluster_id":"07ec2e30-02bb-47d3-9b4c-32b7c841fb33","event_cluster_id":"c623ca23-8a98-4b0e-b365-eb9b3c1cdd86"},{"claim_cluster_id":"1dd25bce-7fe6-46d2-9e28-e803262696c4","event_cluster_id":"24c54796-afba-46ba-9bb2-8854f3d0747a"},{"claim_cluster_id":"2846d44d-8ccd-40e0-8486-7b360ffa4608","event_cluster_id":"98561354-101e-4568-a2cb-77ee7e2819a1"},{"claim_cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","event_cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028"},{"claim_cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","event_cluster_id":"269ffe65-bf3c-4500-8f51-b6ef7e6175ed"},{"claim_cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","event_cluster_id":"4a717901-15d3-4fa4-8697-e234613c348b"},{"claim_cluster_id":"419a274e-afb4-4935-a491-f22b25792b9a","event_cluster_id":"5d32a56f-b7fc-4a53-885f-d83367218f7c"},{"claim_cluster_id":"695b3abb-f469-4406-b1ea-91e5eba8aa09","event_cluster_id":"639a3221-3088-4eab-a13f-8485c80e01c5"},{"claim_cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","event_cluster_id":"04b259ed-8fea-44d2-9f92-3e357be663b0"},{"claim_cluster_id":"ab1842ba-5e92-4ba8-ab55-1241a116a859","event_cluster_id":"2bf4835a-c2d9-4984-a011-415e8a457306"},{"claim_cluster_id":"9f57df89-5e8e-4a14-b028-a41d27973fb5","event_cluster_id":"db101c75-2320-4597-b222-b7197dc49dc4"},{"claim_cluster_id":"f96fdbdd-0664-4366-b80c-72a8405c4f44","event_cluster_id":"6aece148-00ae-441a-a570-cbee981c2154"},{"claim_cluster_id":"f61b95fd-4ab1-43f9-b2f8-53b5afb90d43","event_cluster_id":"1fb31a41-f917-4cde-9190-f353f630be9a"},{"claim_cluster_id":"2b3c747b-9f75-4697-a22b-426999d9c671","event_cluster_id":"356f0068-5f51-4299-8ed5-ccb151ae18bd"},{"claim_cluster_id":"2ac509be-786d-4ed0-abcc-15ecf7e6c4ff","event_cluster_id":"7c34b0bc-12f1-458e-bef9-fafbba595b37"},{"claim_cluster_id":"64a10d09-a49c-4bf3-80db-a2cb3188afbc","event_cluster_id":"93758357-874e-446c-984f-888b0a1aee47"},{"claim_cluster_id":"ed1fef35-ea22-4436-b53a-1dc1f0380298","event_cluster_id":"93fda361-8597-486d-ac5b-c68926f25316"},{"claim_cluster_id":"91b0db25-32e4-4e5d-a32d-911732cbec28","event_cluster_id":"4f9e8ff6-b5d4-43cf-8ca3-6775ebba3b38"},{"claim_cluster_id":"1bf7e0a5-55b7-4089-89cc-831b1626c195","event_cluster_id":"90113fae-adfb-4eea-83c3-93afc851a256"},{"claim_cluster_id":"0f9ce830-116e-4bca-9110-b7d8c9c20025","event_cluster_id":"2723b56b-92db-42cf-852c-6b9603282fde"},{"claim_cluster_id":"7924e4aa-9f0c-4bcf-8c0f-de382c8d6001","event_cluster_id":"3fd5b7b8-68be-4404-8df3-9480731b7b5a"},{"claim_cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","event_cluster_id":"909f6739-4757-4400-a81c-4fdb3bbaad77"},{"claim_cluster_id":"ee1d7c5b-4d98-426c-bf43-b5350f89e9dc","event_cluster_id":"c6804538-62b8-4db5-a60b-8ce1803df0aa"},{"claim_cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","event_cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87"},{"claim_cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","event_cluster_id":"7050c8c6-a172-4da4-a04e-a8f348b2d49c"},{"claim_cluster_id":"db608ced-e4c3-4573-8b19-bacdf06c1585","event_cluster_id":"19de02b2-6078-4f7b-9502-207e4c4f5e72"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"cfc7b0c0-e0dc-44d8-bb40-008b16bc6352"},{"claim_cluster_id":"391ac4c5-638b-42bc-b8d7-1972d56df43e","event_cluster_id":"62c55243-573a-47e9-9c3f-afe131b6a01d"},{"claim_cluster_id":"93d03ec0-ac83-451a-87b2-a95e3d58859f","event_cluster_id":"d67d9854-246c-464b-b04d-764da1ea0a72"},{"claim_cluster_id":"9fc7f408-c42c-485e-91c2-a72960ff3158","event_cluster_id":"d6e4581d-8b56-4f44-aadb-7c57a4d3eb29"},{"claim_cluster_id":"1d3c5fb8-134e-4cb9-8e15-b1a4488a82ec","event_cluster_id":"adb13810-0226-4fb2-9c77-e2af38089b83"},{"claim_cluster_id":"2bb3dd08-3d90-4e2f-a0e2-ecef371c599f","event_cluster_id":"1a427c1e-6df0-4798-aa10-9a17d3c392c0"},{"claim_cluster_id":"f51d817f-9949-43cb-b16a-bfdefff947f1","event_cluster_id":"08e45a86-d42e-4e87-9b56-30c3cd685d1d"},{"claim_cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","event_cluster_id":"3775dc56-2d8e-428a-9c60-ba993c0f4ba7"},{"claim_cluster_id":"5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe","event_cluster_id":"1c46973d-d9e6-4d0a-bc0b-63d9b4862b8d"},{"claim_cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","event_cluster_id":"73d00199-db31-4e40-9741-09d6ba45a825"},{"claim_cluster_id":"c83250c9-87a2-4ec5-822a-e2413ca91c91","event_cluster_id":"03b2228f-a968-4a30-82e2-cd3ee126f59d"},{"claim_cluster_id":"3ae89f52-245d-458f-80e9-2534c0d80104","event_cluster_id":"853910fb-7ee6-4070-a774-47b5fca3aae1"},{"claim_cluster_id":"c66251b2-ab53-4ca9-91b8-4229e4242200","event_cluster_id":"af6d1e09-650d-4e43-84a3-10adfa5661af"},{"claim_cluster_id":"f3328626-3764-43c0-a7df-3730b34ea1fd","event_cluster_id":"52b6d3e6-8588-4bb5-9bb9-34f52aa88349"},{"claim_cluster_id":"1a807d7d-9b68-443c-ad9d-52b339476997","event_cluster_id":"558a2b97-08fd-422a-b638-0c14ba645eaf"},{"claim_cluster_id":"1ba178d9-d925-407c-bb75-60c655774cbf","event_cluster_id":"0b109e58-1cde-4c32-aed4-12ba82ed273a"},{"claim_cluster_id":"847accaf-332c-4ec2-bd26-cd592d1fa2fc","event_cluster_id":"baae4a32-5168-4c2e-a607-5bdb0996a9ff"},{"claim_cluster_id":"86e5843a-553f-41b4-aec2-73c2638e9bca","event_cluster_id":"35f50160-5841-4836-b319-b5806e73bdd7"},{"claim_cluster_id":"d1c29947-a7e4-41cf-9656-837e51b2de11","event_cluster_id":"ab04829a-0137-4a23-b438-5c3602157062"},{"claim_cluster_id":"734aba7a-e1ac-4a78-a926-3957017f7843","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"5fec9a51-560a-4b1e-ab7c-cafcf47ba675","event_cluster_id":"0bc0d2a3-3712-46e5-ad94-41178e22eb84"},{"claim_cluster_id":"c62acce0-70f2-44c3-9131-cec3cdb1f20f","event_cluster_id":"3f3bad08-f439-4b69-b562-c041c5e9279a"},{"claim_cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","event_cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0"},{"claim_cluster_id":"0d796efc-696b-45a8-bfd5-83987987e1ff","event_cluster_id":"5014ba85-27bc-43f2-9c05-0160a5aa15c8"},{"claim_cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","event_cluster_id":"0867ca4e-1775-4423-92bf-6fc8d1d9c0e3"},{"claim_cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","event_cluster_id":"acf3ef41-5374-4f21-834c-c4a11d955ee1"},{"claim_cluster_id":"83965363-a851-4083-ae10-33f90da464da","event_cluster_id":"05ef45a3-5005-462b-9419-1640ee24156a"},{"claim_cluster_id":"868aacb9-ea8e-4ec3-a074-1e7f56bab03f","event_cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133"},{"claim_cluster_id":"e8d873fb-d6bf-4c6b-9328-dabcc490fe91","event_cluster_id":"6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"},{"claim_cluster_id":"3e1e4180-7726-4298-9f55-4348fcd7185f","event_cluster_id":"7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd"},{"claim_cluster_id":"2a265a62-6ee2-460d-b6fd-ab72b8f23578","event_cluster_id":"d58b9b87-81e0-4589-8f81-7f8c5e6a86d0"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"},{"claim_cluster_id":"d717bbe6-a62d-46c1-8d61-866b7d90a851","event_cluster_id":"e5a54fcb-cbc0-4fb7-bfbf-7530efd090da"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"20d38dd5-1da5-4494-8238-6be550e715af"},{"claim_cluster_id":"5238def0-ccfb-4f27-b836-f20f9b7dd70b","event_cluster_id":"ef92d248-d529-47e5-9160-de6bb70cfa68"},{"claim_cluster_id":"f3c74d17-b66b-49d5-9e91-ad7f843bbd39","event_cluster_id":"2ed0e84f-d233-4164-b228-6208473d317d"},{"claim_cluster_id":"83ec8695-6d93-432e-a8be-81705e2e2a54","event_cluster_id":"b7624371-4e42-4625-b287-29a35994c39a"},{"claim_cluster_id":"71baf4d7-69f3-4524-9166-04fc35b4043a","event_cluster_id":"3ef30c78-2900-4b45-bca9-f6701289533c"},{"claim_cluster_id":"0c6c9e5b-f8cc-4939-8319-4baf55259b87","event_cluster_id":"0761665f-c4f6-45c8-aeaf-2676ae75e917"},{"claim_cluster_id":"1ff73cd5-87d3-47be-9b40-e0da957f6ed3","event_cluster_id":"651043d1-0d9f-42ac-bcb3-c7e39b7939ec"},{"claim_cluster_id":"cbd140c9-7dba-47e8-97c2-10198c9c38d7","event_cluster_id":"82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc"},{"claim_cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","event_cluster_id":"c91f4478-001c-4706-a4cf-7da14de01daa"},{"claim_cluster_id":"d1f2b2ed-be0f-44a4-a171-4b848f482ca9","event_cluster_id":"0228c164-28e2-4e5a-b2e8-2f3ba9a5fbf3"},{"claim_cluster_id":"ab378ec8-ca7a-473f-b276-44d546196e26","event_cluster_id":"596b866e-0c38-462e-b0b0-eee502c092aa"},{"claim_cluster_id":"9d6f335e-c5fe-40ff-9edc-7ee5892fafaf","event_cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"},{"claim_cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","event_cluster_id":"91e856d9-7ba0-4d4e-ae44-31db4386dcaa"},{"claim_cluster_id":"0bb1f8c0-08c1-4f63-b6c8-052a5bad160c","event_cluster_id":"35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4"},{"claim_cluster_id":"e8898157-febc-4868-87fa-8effb0a882e8","event_cluster_id":"709632d6-c88d-494b-82c2-d5300f49d1cc"},{"claim_cluster_id":"7eefde16-5844-4305-a679-da87990a2640","event_cluster_id":"f1e47970-325f-4291-8d1a-b29229c84e05"},{"claim_cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","event_cluster_id":"7675ffec-ff62-4c58-a805-c5097a8fcd7e"},{"claim_cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","event_cluster_id":"3989418a-395d-4448-a748-f8cca55ad517"},{"claim_cluster_id":"a7b8095f-b682-4ca2-98b3-5d738490e008","event_cluster_id":"676d848e-4839-407b-95b6-13d5d472f0e1"},{"claim_cluster_id":"da4e5cde-efc2-4363-87b4-b9935cc2b21d","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"a5a6c59f-7670-4f97-9c2b-c94700d73131","event_cluster_id":"25621853-a487-4563-8dfb-51e9404f5430"},{"claim_cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","event_cluster_id":"c95d237e-c855-46b9-95fd-6b8f66d537c6"},{"claim_cluster_id":"da4807bf-cc54-48c7-b3ca-69cd854da837","event_cluster_id":"fdc48ebe-c88c-4c2e-883d-95e1b09e9ec8"},{"claim_cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","event_cluster_id":"0a6e93a7-4ca1-4ae8-937a-93b0852204d1"},{"claim_cluster_id":"d8b92399-bf69-4b82-b461-678acbb7e385","event_cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638"},{"claim_cluster_id":"e9dd9d87-b75e-47a9-883f-9edb14ac1be2","event_cluster_id":"3e66d569-f8f4-40ce-8d13-9d469cc2e340"},{"claim_cluster_id":"40c73517-1c90-43a5-bf9c-4b7cd5dc13c4","event_cluster_id":"d94f565d-7abc-403c-b060-eaad0916c690"},{"claim_cluster_id":"ebf0120f-ec3a-4a71-bd2b-88f212264387","event_cluster_id":"7e91212d-531e-468a-b19b-7f7bff3fda9d"},{"claim_cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","event_cluster_id":"65e251ce-15b5-4f60-b87b-ef28a1709b53"},{"claim_cluster_id":"5677f10d-93dc-4b72-b95a-8bc4291ec487","event_cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a"},{"claim_cluster_id":"5e43acaf-f806-47d1-be89-f2ab3ad82bd7","event_cluster_id":"a7ec7df3-d64e-4466-8dc5-ac899f0c0d28"},{"claim_cluster_id":"2e1084b1-c7f9-4543-8153-a6c840adb565","event_cluster_id":"27cb0d3d-03d0-4c0b-8af4-dae39953059e"},{"claim_cluster_id":"f3328626-3764-43c0-a7df-3730b34ea1fd","event_cluster_id":"1f48fb6b-ea22-46f3-a429-4b537e306680"},{"claim_cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","event_cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c"},{"claim_cluster_id":"4e78b61e-317a-4417-b42d-464646384193","event_cluster_id":"cd51f6af-e3ac-4df3-b356-fdbeb2599d37"},{"claim_cluster_id":"0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35","event_cluster_id":"914330e6-94a6-406b-a8f3-ed188765a7fb"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"50647687-d65a-47e2-b9a1-a4bddf5f53cc"},{"claim_cluster_id":"0511fc3f-517e-42e7-84fc-34ea436b847d","event_cluster_id":"291420ab-2571-4d49-863c-5554d504b9b7"},{"claim_cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","event_cluster_id":"b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a"},{"claim_cluster_id":"197fe725-a0a9-40f8-a6e9-956dd052b066","event_cluster_id":"44955a88-3ba0-46cf-ac7e-906798513ae4"},{"claim_cluster_id":"d8515ae8-12a5-4f84-b01f-bc10b41b19e0","event_cluster_id":"780710ee-898c-4548-a5aa-7eb3c45e169a"},{"claim_cluster_id":"693ef972-4622-4c6c-9268-e5c6a072dd31","event_cluster_id":"d3262128-2dca-4e39-baaf-d15bcec2979d"},{"claim_cluster_id":"5d4f6733-5fbd-48ce-8468-590ebda279c7","event_cluster_id":"7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a"},{"claim_cluster_id":"1f8ce922-0e37-4ccb-b586-67da18764d96","event_cluster_id":"27a5d354-dacf-469b-b094-7b2ad6fec31b"},{"claim_cluster_id":"06b2f52b-0581-493e-b81d-57ece9f33f27","event_cluster_id":"8e5823ae-a392-4999-814a-2dee24b2385d"},{"claim_cluster_id":"34e53235-60e8-4299-9389-633db39ab300","event_cluster_id":"4e138416-b193-43f0-bd9a-8249fe6a1748"},{"claim_cluster_id":"2b9508d5-4552-4994-840b-08ab461e29c3","event_cluster_id":"078eb0c7-fae2-4ffa-b527-48c6683af72e"},{"claim_cluster_id":"55a53a4b-b30c-483d-9f7b-8c999d5c2f62","event_cluster_id":"46812bda-c4dc-4bd2-a7c0-e250a28da359"},{"claim_cluster_id":"c7d861d7-3b33-4585-89d3-87c9dcbcd126","event_cluster_id":"6ff7ccd9-f022-43dd-91cb-c864da8c63c2"},{"claim_cluster_id":"ade8c501-ccec-40ec-b096-cd50cd90be07","event_cluster_id":"c570bea5-83d0-40f8-b228-3cf401722ac2"},{"claim_cluster_id":"a222dd36-fddd-41d8-956d-d735c7c4c6bb","event_cluster_id":"2f8dc773-32fe-42ed-a085-3a10ca61c22d"},{"claim_cluster_id":"30bb9166-b600-41f8-a7cf-3befaaa1bcc2","event_cluster_id":"bba407f7-696a-4116-b4f2-8e58c881a810"},{"claim_cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","event_cluster_id":"a28912c7-742b-4153-9606-e82158276aad"},{"claim_cluster_id":"e88c49ad-3df2-4059-82e4-46d0f3b59757","event_cluster_id":"aead4c3f-44a7-4ce8-91b4-79e0aadcc982"},{"claim_cluster_id":"9fc7edf3-7209-4828-92b3-8d6dafded201","event_cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489"},{"claim_cluster_id":"e20ec3dc-5039-4e9b-be7d-622592bf425d","event_cluster_id":"74eb8465-812a-44ef-8d54-8544ae40c871"},{"claim_cluster_id":"bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a","event_cluster_id":"a8f2c86c-3f8d-4f00-beaf-d0d6fffceae8"},{"claim_cluster_id":"c9534331-e465-4cc5-951b-fa24c4cd75bf","event_cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a"},{"claim_cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","event_cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7"},{"claim_cluster_id":"68357dc5-3396-4365-90bb-f3b36dcbd7e4","event_cluster_id":"43fafa8a-6241-480f-aa40-04f420f4ea5e"},{"claim_cluster_id":"8d8dbda6-96b3-4738-b7a8-777f920a39be","event_cluster_id":"fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a"},{"claim_cluster_id":"ed42b61a-7c55-44a7-aac6-78560e6e139e","event_cluster_id":"27b6b422-e78d-44a0-8d01-c53970357062"},{"claim_cluster_id":"3fc70d09-8a93-4a60-b903-b03cd4187227","event_cluster_id":"e9f5a5d3-fb2d-448b-ab54-b718baa4bcab"},{"claim_cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","event_cluster_id":"ec68f63c-4291-4d49-8068-2a2cf1250591"},{"claim_cluster_id":"e0d4056d-6cdc-4a90-ba78-5aecf0b2092e","event_cluster_id":"d5f8926c-cfe4-4355-8a20-781d575d7616"},{"claim_cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"585ea825-312e-47cf-9ba6-332afbfb9ed5","event_cluster_id":"0400977a-dea9-4fe6-a6a6-61f4575e07a9"},{"claim_cluster_id":"843bcba9-c863-41a3-a76f-01fd61d56529","event_cluster_id":"db3b032b-6eb1-469a-8fea-f26d907c46cc"},{"claim_cluster_id":"b473cdd9-7369-4866-a926-04d86eb03c52","event_cluster_id":"b105a78c-297b-4eaf-9891-43407b9d8073"},{"claim_cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","event_cluster_id":"5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b"},{"claim_cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","event_cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2"},{"claim_cluster_id":"45d5305e-53a9-4659-a1a0-2bf0495c5055","event_cluster_id":"d6c8b67e-0b10-44df-8f54-3d630f15c443"},{"claim_cluster_id":"74ac8dc6-1d9b-435b-bae9-36745f271604","event_cluster_id":"9bdfdf22-7c63-4c9e-aaa0-b66cd67a0424"},{"claim_cluster_id":"09e579b4-c608-4bc3-a02e-890bc6f5969d","event_cluster_id":"6aa1529b-b06b-446b-af24-0e7a95f9cc1a"},{"claim_cluster_id":"29d5756f-2c13-4cfb-b4e4-f439665752b9","event_cluster_id":"7cf8a49b-ec7b-4a56-af2a-3a198e9863e9"},{"claim_cluster_id":"ab24b6cb-fc70-48c9-8ee3-224b83a66b11","event_cluster_id":"08d02125-b1b5-40ee-8104-05de8b37f965"},{"claim_cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","event_cluster_id":"335924d4-8c81-4bf0-8e93-746bc3bcb081"},{"claim_cluster_id":"a3cec669-c5d7-49cf-9b41-ed9298b7642a","event_cluster_id":"3bbfdf4b-7f9b-4300-9c99-cecf5843d988"},{"claim_cluster_id":"95f30627-ec05-45c4-9f6e-28dd5c31e412","event_cluster_id":"cdf7dd0c-6255-42a0-bfbe-5e3b3bbee744"},{"claim_cluster_id":"7bf63345-7700-41f7-861e-b298dc68ad2d","event_cluster_id":"20d38dd5-1da5-4494-8238-6be550e715af"},{"claim_cluster_id":"35ee8064-f9ff-4496-b4db-ba79f7f24de2","event_cluster_id":"3777e13c-2b9f-4604-9213-bea685bd3add"},{"claim_cluster_id":"ab378ec8-ca7a-473f-b276-44d546196e26","event_cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef"},{"claim_cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","event_cluster_id":"05374434-df8d-4b22-b660-0ddc27139765"},{"claim_cluster_id":"88f4c27e-7029-43e0-805c-44699284d312","event_cluster_id":"4efb4906-b539-4d71-8685-b4bd14aad476"},{"claim_cluster_id":"3e1e4180-7726-4298-9f55-4348fcd7185f","event_cluster_id":"8ee8c1bb-0d20-4333-9bfd-60f5cae2d370"},{"claim_cluster_id":"c62acce0-70f2-44c3-9131-cec3cdb1f20f","event_cluster_id":"ab143717-868d-4925-a6b6-6698ea0e9c74"},{"claim_cluster_id":"ca129396-101c-429f-8530-fe05aaa1c7cf","event_cluster_id":"57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"},{"claim_cluster_id":"186330e2-1680-455d-ad21-27f2e0125a31","event_cluster_id":"7c3363eb-6e57-40c6-934c-69f3d1e89801"},{"claim_cluster_id":"8a0c21a3-b47c-4676-b965-59f7699171ec","event_cluster_id":"a7539db4-dfef-469c-b96d-9b13762fd242"},{"claim_cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","event_cluster_id":"1118439e-1d54-4e33-bac7-0813c7dbb103"},{"claim_cluster_id":"f61b95fd-4ab1-43f9-b2f8-53b5afb90d43","event_cluster_id":"9b965f11-f5af-4e06-af27-db2a333f5008"},{"claim_cluster_id":"510b63b0-aea2-446d-8868-5c88431cc9fe","event_cluster_id":"b995b076-2b5f-4341-abf4-0732ccee4318"},{"claim_cluster_id":"e35fb8e9-42cf-4ef0-a512-d7be06ad99e3","event_cluster_id":"97ff7137-390e-43dc-9ab5-05c730068c02"},{"claim_cluster_id":"a8c4b29d-3d45-4e5e-b6ef-06f93957d16a","event_cluster_id":"15b6ae6c-1463-4a8d-9552-d2739588b3e7"},{"claim_cluster_id":"8ef65ecd-3750-4a43-89ce-d81b333f2e1c","event_cluster_id":"816b9948-b1f0-46c8-b6a3-18e652cd3289"},{"claim_cluster_id":"5272bbda-d47a-4619-a956-853dc9c29d18","event_cluster_id":"d80ef34a-3b0a-4891-bbe5-d2c01cec1b04"},{"claim_cluster_id":"45d5305e-53a9-4659-a1a0-2bf0495c5055","event_cluster_id":"164a85e9-df51-43f2-948d-bd9852808931"},{"claim_cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","event_cluster_id":"c6d9c90d-92a1-44da-a5cd-12164b95f4d8"},{"claim_cluster_id":"ed7e3755-29e6-4b64-b965-226f2c61a6d0","event_cluster_id":"b3562e1f-34d6-4a29-b778-8824a2d004a7"},{"claim_cluster_id":"ad83e0a6-e572-4332-8ef0-01e05cdfa760","event_cluster_id":"7eafb3e8-a45a-4448-82d1-c800c85a832e"},{"claim_cluster_id":"e21ec8bb-ddf8-4115-9765-9a2f72eed10d","event_cluster_id":"728de5c6-3345-44e8-91f4-5ab1fb0c6670"},{"claim_cluster_id":"7966aa4e-476b-473f-85ad-b267835811ed","event_cluster_id":"a722bc41-1d66-412e-b713-184ed31bb855"},{"claim_cluster_id":"8f9f1940-08f3-4a29-938e-790645f67487","event_cluster_id":"923eb3f0-4a80-4604-845d-2264e5473406"},{"claim_cluster_id":"b6ac4f42-6e4c-4395-a71a-c8beca5b5336","event_cluster_id":"2ed0e84f-d233-4164-b228-6208473d317d"},{"claim_cluster_id":"752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c","event_cluster_id":"344ea9a5-7537-47d1-9d63-57fb7fadc321"},{"claim_cluster_id":"beba9a76-4058-465a-8f4e-bc79ccf7a03f","event_cluster_id":"d9a77a4d-52c1-4a0d-b32b-684c4aa1d380"},{"claim_cluster_id":"9867a541-4a4c-449d-a4af-a0263f8d23fb","event_cluster_id":"fbce63cc-2f89-4118-a74f-d93b0d57a756"},{"claim_cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","event_cluster_id":"4ab5e1f1-d0b4-460e-98c6-70b27ad80057"},{"claim_cluster_id":"48358541-e77a-4c9f-81e2-7af006f34920","event_cluster_id":"2d8d907a-2ce9-4878-ba6b-55a8ba564f43"},{"claim_cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","event_cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337"},{"claim_cluster_id":"c1308dd1-2ebf-4164-b9e3-2284bbfb088b","event_cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c"},{"claim_cluster_id":"ca129396-101c-429f-8530-fe05aaa1c7cf","event_cluster_id":"60d688f1-af0a-4245-9b4c-47a36b4f063c"},{"claim_cluster_id":"791c0550-4877-4364-97d4-01b5b8435b0f","event_cluster_id":"2b4c9e75-4679-4e5b-8a08-08bb2c621974"},{"claim_cluster_id":"0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35","event_cluster_id":"182eb8ff-4f9c-4649-b5f9-31b5022006bd"},{"claim_cluster_id":"07f06451-8b9c-4bc8-9f61-1661511a83c3","event_cluster_id":"add21509-fc05-4fe6-a953-c98cc222477e"},{"claim_cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","event_cluster_id":"e81e68ae-4e8a-4aef-a358-1455ad08bdc4"},{"claim_cluster_id":"5c533a3e-46e0-4800-bdb7-5c1521efbb3d","event_cluster_id":"5eed6894-bd6e-4276-a4e0-693ad381c55c"},{"claim_cluster_id":"7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1","event_cluster_id":"22b52102-7c44-49d2-93e5-9785e4c6b4d0"},{"claim_cluster_id":"c7b90480-a4e5-4b5f-b840-fe13ad140b52","event_cluster_id":"1e061f92-2688-4d15-8cdc-93767b97df6b"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"eb796d64-358d-4578-ad2f-2c3665e77d5e"},{"claim_cluster_id":"64b06601-97a9-452d-80ca-13c5f92ae356","event_cluster_id":"0d311305-9085-42d3-8548-48b9fa06ff66"},{"claim_cluster_id":"04fd43b1-9ee7-43b3-b1fc-e9fca576658d","event_cluster_id":"14b07b58-6d89-4f8a-8ddc-8c0a902ee333"},{"claim_cluster_id":"b0071c15-10b9-4a75-8b7f-486b9f2c04d1","event_cluster_id":"cc939ca4-cdd3-4b86-b937-1aee89162501"},{"claim_cluster_id":"3e19b24f-ae64-464a-8536-97bf58aecdc0","event_cluster_id":"b32b2c04-03a9-4e04-93d0-499cf1aa4cc2"},{"claim_cluster_id":"4908cf56-f8a6-4b01-88c6-2c59a4acac65","event_cluster_id":"f3a349ff-3152-4d09-b280-f92890a46edf"},{"claim_cluster_id":"d63b1ded-8126-4556-8052-238b4f8872c9","event_cluster_id":"56102e40-6707-4ea5-b706-a21ac4c3fa0a"},{"claim_cluster_id":"43784351-864b-42c8-bac5-2de22a3743c2","event_cluster_id":"d6c38bd4-e404-4cb6-beee-cca25c7586ab"},{"claim_cluster_id":"2c72a6d8-6edd-4d3a-9563-d326950bc8da","event_cluster_id":"2d202c5c-9305-4705-93d0-1781607fb294"},{"claim_cluster_id":"1e256780-a5db-4471-b8f2-5390a4dea1fb","event_cluster_id":"73478ef3-3b02-4aa4-bc0d-55174048efc5"},{"claim_cluster_id":"8806403a-c610-4055-9744-edc72cda745d","event_cluster_id":"669c3dae-6d04-400f-a1f0-a3b10120d902"},{"claim_cluster_id":"06b8ffc7-c987-44a2-a2cb-8721e54e7da6","event_cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155"},{"claim_cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","event_cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc"},{"claim_cluster_id":"57bfc89a-d981-44e9-a425-3364b9a5bc24","event_cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed"},{"claim_cluster_id":"407486e4-c133-4139-9739-41644f65fa24","event_cluster_id":"30b7ce37-8fca-4fe2-b499-bda00e36d905"},{"claim_cluster_id":"55bc595b-aea0-4d83-938e-9ae3ab116813","event_cluster_id":"23e0381e-2d65-4ba4-b3df-e26366f32cbc"},{"claim_cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","event_cluster_id":"ed8ee9d8-3361-4c66-86fb-3b0c6210300d"},{"claim_cluster_id":"b4295bad-3940-4b00-ac2b-862c41b5597c","event_cluster_id":"100607e4-097e-42a6-9233-9486abc1cf03"},{"claim_cluster_id":"7187c5ae-6f6b-4c6a-af65-98db1f5251db","event_cluster_id":"11da9fb2-c834-4c00-97b5-9d0eb78a5f81"},{"claim_cluster_id":"066e0772-a7cc-411e-9810-7c9b5b3dd73f","event_cluster_id":"9f64a0ee-1ff6-468b-9bf7-001ce2c6ea58"},{"claim_cluster_id":"b835c70a-6e2a-4461-9396-aa47cc9d876c","event_cluster_id":"985525fb-882c-4e38-8f11-fa12ae906da0"},{"claim_cluster_id":"7afd3ded-a43a-4c9d-b365-6656ecd89e6f","event_cluster_id":"eda41dea-1eaf-4dc5-ae84-f7a6a29eea13"},{"claim_cluster_id":"e968bf8c-b2a8-4330-bf71-9cab4f6826a5","event_cluster_id":"9bfae508-3289-4175-a44f-b761d47a58ba"},{"claim_cluster_id":"5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb","event_cluster_id":"31b9f704-925c-4bf2-9f0b-e88e81f1b10a"},{"claim_cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","event_cluster_id":"9bba558d-53eb-42ad-851e-623ab4e32bc6"},{"claim_cluster_id":"b8299ae1-9e2e-465d-af82-b9354f3e9c44","event_cluster_id":"f8ebc28b-35f4-46bd-95af-d6b109203645"},{"claim_cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","event_cluster_id":"7370dfbb-74ea-4d34-82b7-9398b71ecd5a"},{"claim_cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","event_cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"},{"claim_cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","event_cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56"},{"claim_cluster_id":"53963e43-0740-4b21-afdf-6b0bd3da400f","event_cluster_id":"7d4d7620-64de-4dcb-824e-188535febe26"},{"claim_cluster_id":"5ac433e4-bd1e-455d-8c24-e981eb354d77","event_cluster_id":"8628cfa7-1952-4304-94e8-eca8c125fadb"}]}');


var $232f777ea42b74fb$exports = {};
$232f777ea42b74fb$exports = JSON.parse('[{"cluster_id":"ee6ffddc-d717-4a7b-a161-3d1bdc24c500","title":"Ukraine Adopts State Language Law"},{"cluster_id":"3bbfdf4b-7f9b-4300-9c99-cecf5843d988","title":"IAEA Condemns Zaporizhzhia Shelling"},{"cluster_id":"69dda1ad-6a94-49a1-b2c4-c261984302cc","title":"Nordic Nations Pause Moderna for Youth"},{"cluster_id":"041cf2cd-18d4-495c-8ae7-5b69605020ea","title":"Zelensky Provoked Nuclear Crisis"},{"cluster_id":"97ed4747-8726-498d-80cf-261756e7962a","title":"EU-Ukrainian Visa Liberalisation Agreement"},{"cluster_id":"4a717901-15d3-4fa4-8697-e234613c348b","title":"Ukrainian Language Requirement in Civil Service"},{"cluster_id":"fdb454eb-b6d8-4e69-94d9-d465733df395","title":"Political Downplaying of COVID-19 Risk"},{"cluster_id":"9d6d3278-c0e4-4003-a311-bf3945445bf7","title":"Graphene Oxide for Biomedical Delivery"},{"cluster_id":"01d5ac9b-578e-460b-921d-2d1cc5ecad34","title":"Dutch Referendum Rejects EU\u2013Ukraine Agreement"},{"cluster_id":"bf711cc9-463c-4a50-a300-d24703735ee6","title":"Donbas War as Intrastate Conflict"},{"cluster_id":"148cbdc2-efc0-4f16-b29a-724816c7ee5d","title":"CAL.20C Designated; Reduced Antibody Susceptibility"},{"cluster_id":"e285d3b2-02ce-4dd4-ad86-ac99b2199a66","title":"US and NYC Excess Deaths 2020"},{"cluster_id":"84a0d215-8113-4569-a05e-d15e5c91d360","title":"Crimea Referendum to Join Russia"},{"cluster_id":"1502dc4e-242e-4ce0-baf9-c0d4847d8993","title":"Kyiv Torchlit Nationalist Marches for Bandera"},{"cluster_id":"114c895c-17f1-417b-8a4e-f626b06562d8","title":"2017 Education Law: Language of Instruction"},{"cluster_id":"bd06a127-0f18-48fa-b6d0-ff607d111775","title":"Contested claim: HPV vaccine risk"},{"cluster_id":"21f0a219-a107-4e6e-aa28-e010ad5aec66","title":"Putin Orders Nuclear Forces on Alert"},{"cluster_id":"d44024e8-81f4-4d88-982c-a023f24b58cd","title":"Debate on Regional Language Law Repeal"},{"cluster_id":"77e0e128-878a-417f-8723-91873f114032","title":"Paramilitary and Nationalist Groups in Ukraine"},{"cluster_id":"58d2f307-4ee3-44ad-a765-c7a292798624","title":"NATO Wales Summit backs Ukraine"},{"cluster_id":"e17360aa-cb4e-4e41-913f-f3e853c44fd4","title":"Japan Pauses Moderna Batches Over Particles"},{"cluster_id":"4175d453-3f8e-438a-adde-113f24ef2a95","title":"EU Prolongs Russia Sanctions 2019"},{"cluster_id":"1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e","title":"CDC/ACIP Recommends Pfizer for 5\u201311"},{"cluster_id":"d101520b-7082-47e3-b848-813e8165e6a9","title":"Dnipro Renaming Under Decommunization"},{"cluster_id":"c4a1de41-721e-4875-aa51-4449e3df85ed","title":"CDC Recommends Public Cloth Face Coverings"},{"cluster_id":"bba39c5a-fa92-4d86-80be-58952de97f7e","title":"Contested COVID-19 Survival Claims"},{"cluster_id":"dbe1780e-f93d-4eae-8780-d2a73e00ae56","title":"AstraZeneca COVID-19 Trial Pause"},{"cluster_id":"2cd7a2ea-67d1-4d2a-8944-a71778dc20d7","title":"Vaccine Myths: STI, Blood Effects, Immunity"},{"cluster_id":"38992305-30d9-47ce-bb30-bfa120506e54","title":"EU Condemns Nazi and Stalinist Crimes"},{"cluster_id":"d2b6a98f-1634-4f3b-a41d-9b64375eff6e","title":"Court bans OPFL after martial law"},{"cluster_id":"80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e","title":"EU Reports on Azov Sea Blockade"},{"cluster_id":"bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c","title":"Contested Vaccine Genome Alteration Claims"},{"cluster_id":"a162a552-43bd-43b6-925a-ac7f9fbf4734","title":"FDA: Pfizer Vaccine Causes Clots"},{"cluster_id":"bfccbfa0-4d21-4c95-88ca-a83d95def684","title":"VAERS Adverse Events in Pregnancy"},{"cluster_id":"9d7867d5-5ab5-4b0e-9556-f3f45feb0160","title":"CDC Reverses Mask Guidance for Vaccinated"},{"cluster_id":"735fb4c9-5d71-4b3e-b247-9bafaa632b98","title":"Unvaccinated Transmit Breakthrough Infections"},{"cluster_id":"fd11e091-21e1-40df-916b-90aba2945065","title":"Ukraine bans Russian-language music"},{"cluster_id":"e5a713cd-2a21-42c0-89a2-7795a4250823","title":"Ukraine GDP contracts 6.8% in 2014"},{"cluster_id":"a38268fe-ba89-4d63-8481-63c080523a0a","title":"Ukraine\'s shifting security partnerships"},{"cluster_id":"59d689c2-02ce-4e0f-83b7-9747d98bb8fb","title":"Ukraine Violates Russians\' Rights"},{"cluster_id":"46dc68c8-60bf-4c63-8f62-da2eefecf05e","title":"28-Day Window for COVID Deaths"},{"cluster_id":"777a09d6-6401-47e3-a2d4-ee63f89442c3","title":"2017 Numbeo Cost-of-Living Indices"},{"cluster_id":"a1f0e0be-a8bf-4895-ad2d-4f83a0d63930","title":"Predicted Loss of Ukraine\'s Sea Control"},{"cluster_id":"f597184d-050f-4a51-9461-70b55cf2b05c","title":"Pfizer Vaccine Prevented 90% Infections"},{"cluster_id":"9a26c9bd-36a9-4c64-8680-f0a2265878f1","title":"Japan halts 1.6 million Moderna doses"},{"cluster_id":"33ed63b5-316c-47cd-80fa-2cb71259f8eb","title":"COVID-19 Infection Fatality Rate ~0.68%"},{"cluster_id":"7c1469be-22eb-4ba2-a540-efc0b0d4e00e","title":"WHO mRNA vaccine regulatory guidance evolves"},{"cluster_id":"3789471e-0775-4ba6-92d1-141ca5051de5","title":"Ukraine Elects Zelensky President"},{"cluster_id":"4272dbf3-0c9a-42d8-a9a1-b2b3a349e192","title":"OSCE Regional Analysis of Organ Trafficking"},{"cluster_id":"314e86f6-17d6-477f-8886-75643cc5dcde","title":"Right Sector\'s Public Role in Euromaidan"},{"cluster_id":"6950bc54-67bb-4e8e-b8cd-afd5c7d79d00","title":"Ukraine bans calling hare \'rusak\'"},{"cluster_id":"38841999-14cb-43f3-a2d5-27d9791973f6","title":"Odesa Withdraws from Ukraine"},{"cluster_id":"ecaaad84-7e56-4f5a-84d0-609fbf620112","title":"UNICEF: Donetsk Children Sheltering Underground"},{"cluster_id":"4afb1f4b-4686-4338-bf49-bdd4d2091f0a","title":"Vaccine Deaths and SADS Claims"},{"cluster_id":"36d66c66-9c93-4123-875e-3e9fbe514722","title":"Early Seroprevalence Indicates Low IFR"},{"cluster_id":"a031766e-aaad-4e78-b0e4-bd1cf2fc1a66","title":"Ukraine govt violates rights in Southeast"},{"cluster_id":"705d1ff1-cf3d-455b-8c22-31feaaeb943f","title":"Lenders Urge Ukraine Anti-Corruption Reforms"},{"cluster_id":"8179c546-cd47-4baf-897a-a15a8afbb9e6","title":"NATO Rebuttals to Russian Claims"},{"cluster_id":"335924d4-8c81-4bf0-8e93-746bc3bcb081","title":"Volunteer Battalions Integrated into Ukraine\'s Forces"},{"cluster_id":"1118439e-1d54-4e33-bac7-0813c7dbb103","title":"Minsk II Signing and Violations"},{"cluster_id":"794a59da-1667-4f55-8bfb-64bab3fe6d1a","title":"Donetsk and Luhansk Evacuations to Russia"},{"cluster_id":"f4f13b9b-3296-4913-8eea-62ce1becaa2c","title":"Moderna\'s Pre-Pandemic COVID Vaccines"},{"cluster_id":"c6f7c193-f407-447c-a10f-3ea5292ea3e8","title":"US Trainers Train Ukrainians on Javelin"},{"cluster_id":"fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13","title":"Remittance Ties Between Ukraine and Russia"},{"cluster_id":"6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00","title":"Vaccine Breakthrough Infections and Surveillance"},{"cluster_id":"adcb219f-1d0a-4b1b-924d-ded66e2d2c1c","title":"Ukraine Train Carrying Mines to Russia"},{"cluster_id":"a9a48f40-5af3-4e72-b9f7-5b25295964a4","title":"Anti-Maidan Camp at Kulikovo Pole"},{"cluster_id":"5e83ce8b-b525-4867-8caf-5b4d780a4a6c","title":"Donetsk Shelling: Both Sides Blamed"},{"cluster_id":"5d455dbc-1091-4f62-8c3e-fdf2d7c2080e","title":"Divergent Post-Vaccination Blood Donation Guidelines"},{"cluster_id":"6926f592-0807-43c3-9eb1-74f903b009ff","title":"Crimean Tatar Territorial Autonomy"},{"cluster_id":"7564aa71-23fc-4383-a2a0-0245e543e0fe","title":"Flawed CDC PCR Test Rollout"},{"cluster_id":"3ffaa02c-962d-45fa-a9aa-01f8e41dda01","title":"US Urges NATO Deploy to Ukraine"},{"cluster_id":"bd9462e2-36b0-48f7-92f9-c83dd2ee5550","title":"Eight Antigens Overwhelm Baby\'s Immune System"},{"cluster_id":"8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0","title":"Ukrainian Soldiers Unpaid for a Month"},{"cluster_id":"83b8e4b4-0c78-4b19-aa89-21b8a62c50fe","title":"Danish Results and Booster Impact"},{"cluster_id":"46812bda-c4dc-4bd2-a7c0-e250a28da359","title":"COVID-19 Deaths by Vaccination Status"},{"cluster_id":"27c83a03-3f6f-4152-a678-12dc8e5912da","title":"Rabbit Hole Interview Published with Nikolaychuk"},{"cluster_id":"651043d1-0d9f-42ac-bcb3-c7e39b7939ec","title":"Sudan cVDPV2 Outbreak Response"},{"cluster_id":"46ef864f-186e-4179-bb52-04fed8b2c978","title":"Ukraine Public Administration Reform: Staffing Targets"},{"cluster_id":"6e3b5d0b-67db-4d14-8384-2b3799aec6bd","title":"Donetsk and Luhansk Referendums, Russian Recognition"},{"cluster_id":"ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d","title":"Canada\'s Operation UNIFIER: Ukraine Training"},{"cluster_id":"d3157e1e-5fca-47d3-93bf-fb77fbc5070d","title":"Autism Prevalence: 1 in 88"},{"cluster_id":"d19dc1b6-21b1-49bc-aaf1-fb24f7c66396","title":"Ukraine Dismisses Viktor Shokin"},{"cluster_id":"c36b66d4-db22-4344-899e-be0f938cf47b","title":"Hungary Defends Zakarpattia, Threatens EU Integration"},{"cluster_id":"caa057e8-994e-43b8-803e-0ea0aeab7ec7","title":"US Blocks Poland\'s MiG-29 Transfer"},{"cluster_id":"56a7af82-50cb-4d0f-a5ea-28ea4cda014a","title":"Ukraine Formalizes Neutral Foreign Policy"},{"cluster_id":"8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6","title":"UNICEF accuses Kyiv of Donbas aggression"},{"cluster_id":"1288dccd-1b4b-44a8-94be-08411cd2073d","title":"US-Funded Democracy Support in Ukraine"},{"cluster_id":"65cd54b0-2f90-4b59-a573-5917ec27f9bb","title":"Conspiracy Claim: Gates-Led Pandemic Targeting Children"},{"cluster_id":"df13c28d-11fd-4cdc-a0c7-5076d0c46483","title":"COVID-19 Lies and Policy Failures"},{"cluster_id":"5fee0957-a733-4e61-bf4b-0025d615e97b","title":"US $53M Non-Lethal Aid to Ukraine"},{"cluster_id":"4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43","title":"OSCE SMM Denied Access by Ukraine"},{"cluster_id":"90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410","title":"Kyiv admits shelling civilians in Donbas"},{"cluster_id":"5a4fc98d-9bb2-48e0-88c4-2decb355b92d","title":"India HPV Vaccine Controversy and Inquiry"},{"cluster_id":"1e8d5556-2c0c-4097-b606-9907a5dd2afc","title":"Ukraine Without Heat, Warming Centers Open"},{"cluster_id":"cc95457a-219b-4008-9216-67e0ee2bc74c","title":"Defender-Europe 21: Large European Exercises"},{"cluster_id":"342cdbac-7da2-46b3-80b3-a9b75e8fee10","title":"No exemptions for vaccine contraindications"},{"cluster_id":"9ec9965a-96db-46e5-965a-bc307986c26d","title":"Ukraine Cannot Use U.S. Weapons"},{"cluster_id":"217bc58f-d97f-49d7-9c91-2a55c225a54a","title":"WHO Flags China\'s Pediatric Respiratory Surge"},{"cluster_id":"9f394b1e-f3b6-4528-a71b-dd2fed1c81a5","title":"Open Access to VAERS Data"},{"cluster_id":"f81575fe-bf60-4052-8196-fa9040141b06","title":"Leaders defer lethal arms to Ukraine"},{"cluster_id":"7f180ad9-d196-4c1e-8dc6-209c613a3fa3","title":"Claims Crimea Is Russian Territory"},{"cluster_id":"cd4a5f4f-0722-49d0-a0a8-588c6f486479","title":"Sanctions Relief Tied to Minsk"},{"cluster_id":"c545f601-c30b-46cc-a181-949b8540bd95","title":"CDC Estimates 2019-20 Flu Burden"},{"cluster_id":"3a31c97f-6174-468b-bab1-90d8acc21560","title":"Russia Spent $80B Defending the Ruble"},{"cluster_id":"21360818-47b1-476a-88aa-682feb18a966","title":"Durable neutralizing antibodies after SARS-CoV-2 infection"},{"cluster_id":"7050c8c6-a172-4da4-a04e-a8f348b2d49c","title":"COVID-19 EUA VAERS Reporting Rules"},{"cluster_id":"9419d9bb-572a-4e79-aef7-f69f5e25eaa2","title":"Surges in Vaccinated Nations"},{"cluster_id":"1352067a-0981-4dfc-bf7b-193db2160af5","title":"Rivne Molot Blast Spurs Probes"},{"cluster_id":"f2d1742c-c9b1-44f7-a4e6-abf20a37a569","title":"OSCE Spot Report: Donetsk Shelling"},{"cluster_id":"c53a9c23-c3a5-4b85-9f93-40e51b50505c","title":"NATO: No Combat Troops in Ukraine"},{"cluster_id":"ca0d7a2a-b8d2-4968-874b-aa3379e0dafa","title":"Pregnancy VAERS: Neonatal Deaths Below Background"},{"cluster_id":"a174fdfb-5e90-4340-85c5-f1498bd04f82","title":"Separatists Seize Ukrainian Equipment"},{"cluster_id":"efb200e1-1771-49d7-a8fb-d8bd8317e7a0","title":"Disinformation: Child Vaccine Deaths"},{"cluster_id":"f5a99e33-6c8e-438b-9a1b-7d2b95dadd27","title":"Limited Police Intervention, May 2 Chaos"},{"cluster_id":"0e36f836-fa5b-40df-8bd7-860b08ef47db","title":"Arrests Over Crimean Sabotage Plots"},{"cluster_id":"27a5d354-dacf-469b-b094-7b2ad6fec31b","title":"FDA Guidance: Cell Substrates for Vaccines"},{"cluster_id":"1bece78f-f648-4fbc-85c0-722698749525","title":"EuroMOMO: 2021 Excess Mortality"},{"cluster_id":"c3affceb-2e1f-45a4-b7f3-9c91184bd8cc","title":"Omicron: Waning Vaccine Effectiveness"},{"cluster_id":"a418885e-cbb2-4205-a118-ea8172eaff33","title":"German Spring 2021 Vaccine Adverse Events"},{"cluster_id":"729cc7ae-ca2f-4e76-9131-41ad0335ecdf","title":"Imperial College COVID-19 Projections and NPIs"},{"cluster_id":"4ab5e1f1-d0b4-460e-98c6-70b27ad80057","title":"Ukraine passes decommunization and memory laws"},{"cluster_id":"87e51e32-d441-41a9-8026-a751a57b0ed2","title":"Ukraine Threatens War With Russia"},{"cluster_id":"f7dce48b-908d-410d-ae3b-0711d8dd8a49","title":"Russia Bans Ukrainian Food Imports"},{"cluster_id":"269675ca-916b-4267-8970-bb97e2010767","title":"Secondary Pneumonia Caused 1918 Deaths"},{"cluster_id":"9ef27775-8065-4722-bd90-8a9ae4a3c250","title":"Ukraine on Modern Nazism Map"},{"cluster_id":"8e9141e0-2f9d-4d0a-920e-7ed046dbbcec","title":"Putin Simplifies Donbas Citizenship"},{"cluster_id":"c21b5cff-dd9b-418d-82f4-ad5049c002d9","title":"Vaccines More Harmful Than Infection"},{"cluster_id":"1a5017d7-a85f-401a-9c3e-9a087de588f6","title":"WHO COVID-19 Excess Mortality Gaps"},{"cluster_id":"ae87ce9d-8fb9-4394-9afe-202f1ec14722","title":"Unusually Low Flu Activity During COVID-19"},{"cluster_id":"a8758a01-da2e-4199-8bb4-bdf40b9dd8e6","title":"Unusual GAS and Scarlet Fever Activity"},{"cluster_id":"f8121c44-24d3-465d-8607-2a909285d318","title":"American COVID-19 vaccine killed Ukrainian serviceman."},{"cluster_id":"eb82caa7-6ef5-4182-a16e-ed0091be45ae","title":"Lviv Dismantles Stepan Bandera Monument"},{"cluster_id":"80abc80a-d540-4e4d-aa41-272690066eb0","title":"Planned bombing of Luhansk rail overpass"},{"cluster_id":"d18315fd-bf62-472b-bd6c-313e812011cc","title":"COVID-19 Vaccine Administration Errors and Deviations"},{"cluster_id":"df8da41a-f9cc-4448-aae3-112ed4b0b247","title":"NATO Madrid Summit: New Strategic Concept"},{"cluster_id":"b4c1b467-58b1-4e2c-a735-234cba24891c","title":"Masks Do Not Stop COVID"},{"cluster_id":"96c115c1-f9f9-479d-9ecc-98da549128b0","title":"Global Spotlight on Ukrainian Nationalists"},{"cluster_id":"776c4ee1-eeec-4f70-91d9-12fdaa179052","title":"Moody\'s Downgrades Ukraine to Ca"},{"cluster_id":"402b3ff3-63dd-42e9-9d2c-888f81934ca4","title":"Snakes as Potential Reservoir"},{"cluster_id":"b56f25e8-34c3-4cf5-b21e-1b0f46545150","title":"Base-Rate Fallacy in Vaccinated Populations"},{"cluster_id":"b687420f-e058-48a2-8c4c-4bc6f35624c2","title":"Zaporizhzhia Unveils Film-Characters Bench"},{"cluster_id":"092404d0-7d21-433f-bfca-9a5d34d17b3b","title":"Oleksandr Onyshchenko Accuses Poroshenko of Corruption"},{"cluster_id":"8a0c21a3-b47c-4676-b965-59f7699171ec","title":"Donbas Cities Face Water Shortage"},{"cluster_id":"aa30bf70-0cba-416d-ab58-48d58cb2a343","title":"Ukrainian MP proposes mass Crimean deportation"},{"cluster_id":"17224e3f-1dd8-4970-a1c1-0cff20d6f438","title":"Vaccines Contain Aborted Fetus Claim"},{"cluster_id":"7742ec5a-27ab-42d2-9779-df7d73a0cec4","title":"Toxic Aluminum and Mercury in Vaccines"},{"cluster_id":"e8352caf-0212-486c-8732-e56619b31e7c","title":"Late 2022 Non-COVID Excess Deaths"},{"cluster_id":"a28912c7-742b-4153-9606-e82158276aad","title":"UK Yellow Card Safety Updates"},{"cluster_id":"0c63b123-d884-4e43-b541-3b36f23f2e96","title":"Russian Ded Moroz triggers Ukraine ban"},{"cluster_id":"af90686d-77e8-4713-873e-8c63e5dbe370","title":"Provisional EU\u2013Ukraine DCFTA Application"},{"cluster_id":"e5a54fcb-cbc0-4fb7-bfbf-7530efd090da","title":"Early WHO Mask Guidance: Limited Use"},{"cluster_id":"3f98fdac-3f62-464c-bf56-dd3d2e686963","title":"Local bans on Russian-language culture"},{"cluster_id":"cba3863d-9ffc-4647-831b-d4da84c689e3","title":"Fast-Track Citizenship for Crimeans and Ukrainians"},{"cluster_id":"38bb4737-de3e-4b8d-b413-8281bb85ae27","title":"Pfizer\u2013BioNTech Vaccine 95% Efficacy"},{"cluster_id":"30fdf9bb-e9b5-47e5-a899-e176ffa77eac","title":"Kirovograd Residents Prefer Tsarist-Era Name"},{"cluster_id":"25f83819-e436-47d4-a6ab-ce489fc70293","title":"Western-Led Training for Ukraine"},{"cluster_id":"d0b9d362-84b5-4285-90de-b70dc7fdf9db","title":"Racial/Ethnic Differences in Vaccine Uptake"},{"cluster_id":"640f326d-efe1-4293-bfc4-0c4c7b9185f3","title":"Steinmeier Formula Controversy in Ukraine"},{"cluster_id":"1282bd1b-6e16-4c06-9f2c-9c9344b54fd8","title":"Congressional Restrictions on Extremist-Linked Aid"},{"cluster_id":"976b0673-ef25-484d-9be8-afb6c791a214","title":"Venice Commission flags minority-language gaps"},{"cluster_id":"ce0417d2-5817-45d3-a01f-447b8d6d19ff","title":"Long-Lasting COVID-19 Immunity"},{"cluster_id":"30d502a9-a0ce-4646-9e1c-b03b47f8dd5b","title":"Ukraine Adopts Red Poppy Remembrance"},{"cluster_id":"5a8284e8-a150-41dc-8ee7-edbc3da33af5","title":"Minsk Abandoned, Donbas Occupation Planned"},{"cluster_id":"3775dc56-2d8e-428a-9c60-ba993c0f4ba7","title":"NED Grants in Ukraine During Euromaidan"},{"cluster_id":"222d1da7-5333-49e1-a4ec-9ca508fd278c","title":"Natural Immunity 13x Stronger Than Vaccination"},{"cluster_id":"5288ae46-832e-4436-95ed-05106d5e8d73","title":"COVID-19 vaccines Hospitalisations"},{"cluster_id":"fd853489-07e0-4489-8d20-abb8f80a4213","title":"COVID-19 Deaths by Vaccination Status"},{"cluster_id":"c160d7d3-0687-4ba7-86ad-32e9cddeaf56","title":"VAERS Reports Drive Public Attention"},{"cluster_id":"8602d3ff-0dd5-4315-8d50-17cd0d22f5ac","title":"CDC Establishes Incident Management, Monitors Outbreak"},{"cluster_id":"fbc30c99-229d-49c2-8ecb-ce9a62431408","title":"Pfizer vaccine linked to turbo cancer"},{"cluster_id":"2105abe4-014b-48d8-a8a2-6e113ac81f52","title":"Higher Vaccination Linked to Excess Mortality"},{"cluster_id":"a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0","title":"Court Rules mRNA Vaccines Aren\'t Vaccines"},{"cluster_id":"6d7e8844-23f0-4293-9d61-855d04598239","title":"Anti-Maidan Pro-Russian Protests in Ukraine"},{"cluster_id":"5edd87a6-3d98-4e7d-9e60-b94920fc071d","title":"Ukraine Displays Captured Russian Paratroopers"},{"cluster_id":"12c3a33b-fd70-46a3-a74c-86b922244369","title":"UN Demands Ukraine Recognize Occupied Territories"},{"cluster_id":"344dd5f7-3435-46c3-9f5a-4bd9bd357bed","title":"Language Bill Triggers Parliamentary Clashes"},{"cluster_id":"0543c671-bbcf-49ea-a462-e4ab061c75a0","title":"UN Confirms Russian Involvement in Odessa"},{"cluster_id":"011aa847-d3e3-4d34-bf5e-378f39ba8a3c","title":"CDC Guidance: Vaccinated Mask Optional"},{"cluster_id":"b6224aea-5841-4609-ba8b-ccc207ec597f","title":"IMF approves $17.5B Ukraine bailout"},{"cluster_id":"0bc010ee-21eb-4a56-88df-bd3b94b15999","title":"Zelensky Proposes Direct Talks with Russia"},{"cluster_id":"6c947694-8652-4e58-b4d1-40be43d3a77b","title":"Masks Stop Flu, Flu Labeled COVID-19"},{"cluster_id":"da1326c3-fa76-400d-b44c-881f6493a085","title":"Vaccine Death Claims"},{"cluster_id":"446a7c12-73f1-49f5-944a-5a0119281e12","title":"Exhumation of Sloviansk Mass Grave"},{"cluster_id":"32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08","title":"Pediatric Vaccine Trials and Authorizations"},{"cluster_id":"abb6468b-1949-4a51-9adf-d3e014a3003b","title":"Japan Approves First saRNA COVID Vaccine"},{"cluster_id":"7301fbf5-a19c-4247-aac6-e3d55981cf96","title":"UN OHCHR Detentions in Eastern Ukraine"},{"cluster_id":"12efff4b-e0b1-447e-aeb7-828004c5cfde","title":"Planned pandemic and contamination claim"},{"cluster_id":"5a4d2a32-bac0-4370-915e-eb0f49138ccd","title":"OSCE Monitors Ukraine Minority Rights"},{"cluster_id":"252647f3-b2d0-4fb9-8a73-8d20e5a61e96","title":"Pandemrix Narcolepsy Risk Investigations"},{"cluster_id":"edcb6d77-94bd-47fa-ac30-bd310a6e83e6","title":"Vaccines Do Not Overload Infants\' Immunity"},{"cluster_id":"565acc40-efdc-4957-85fb-8602f0587aa9","title":"Flu vaccine exists; flu persists"},{"cluster_id":"ce4675a2-eebc-4f4f-bcc2-33cbe65f4024","title":"ICJ: Kosovo Declaration Lawful"},{"cluster_id":"6985338a-f2b9-47d5-b9ae-563c0a87748d","title":"False claims about vaccine ingredients"},{"cluster_id":"bb4b93c0-732a-485f-b2ae-0ba6433c139f","title":"Amnesty reports civil-society artillery casualties, 2014"},{"cluster_id":"b05a0ac1-6107-4a11-aa69-1115d8b00d86","title":"Ukraine Reforms vs Minsk II"},{"cluster_id":"7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b","title":"Rare myocarditis after mRNA COVID-19 vaccines"},{"cluster_id":"980136c6-363f-4cda-bc50-cca417518993","title":"May 2 Events Caused Odessa Suicide"},{"cluster_id":"6d0ecf89-9eab-4b55-8c05-ab0885982adf","title":"Ukraine Fails to Investigate Far-Right Violence"},{"cluster_id":"9964a330-c7c3-4cd3-bf33-0b48084f4337","title":"Abuses by both sides in Ukraine"},{"cluster_id":"b08cba5b-cde3-4318-9ea2-b4cf4efed9c3","title":"Vatnik Renounces Ukrainian Citizenship"},{"cluster_id":"59906f79-e6e8-4390-a382-ef5bd2f7fff2","title":"Far-Right Symbols in Euromaidan"},{"cluster_id":"d9f5972a-ff26-4242-938a-7c9615591c15","title":"China backs Russia in Crimea"},{"cluster_id":"40467831-07ba-4c26-8f13-029707ea2660","title":"Measles Rise Linked to MMR Decline"},{"cluster_id":"d17d8e48-7844-4b9c-9bc0-e31d87299aef","title":"COVID-19 Deaths Overcounted"},{"cluster_id":"55a53a4b-b30c-483d-9f7b-8c999d5c2f62","title":"Study Links Vaccination Rates to Deaths"},{"cluster_id":"5677f10d-93dc-4b72-b95a-8bc4291ec487","title":"Claims of Zero Deaths During Pandemic"},{"cluster_id":"1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3","title":"COVID vaccines contain no animal ingredients"},{"cluster_id":"391672fd-aef8-4243-932a-77e726662902","title":"Volunteer Battalion Leaders Declare Assets"},{"cluster_id":"c298484d-a7d5-4e80-ac66-217221dc6d85","title":"Kolomoiskii Enforcers Beat Soldiers\' Mothers"},{"cluster_id":"4f0e7f6a-d847-4db7-a78d-684ba6b33ce7","title":"Violations and Movements Near Contact Line"},{"cluster_id":"6e881517-8e9f-47bf-854c-c29084f1a26d","title":"Vaccines Prevented Approximately 140,000 U.S. Deaths"},{"cluster_id":"708bf439-5986-4d45-983d-18029794b540","title":"Debate on Universalizing Babi Yar Memorial"},{"cluster_id":"028ee870-e258-43cd-99d3-f13e457b70d7","title":"Budapest Memorandum Nuclear Disarmament"},{"cluster_id":"97f84153-8f49-432f-a8f7-a4e57fe7f769","title":"COVID-19 Vaccine Myths and Conspiracies"},{"cluster_id":"86e16ba9-dba8-4cea-a0d4-df8a8a69d565","title":"Obama accuses Ukrainian authorities of genocide"},{"cluster_id":"ab1842ba-5e92-4ba8-ab55-1241a116a859","title":"No FDA-Approved COVID Vaccines in U.S."},{"cluster_id":"45339238-abb3-494b-a7ba-d3cde2ab18d9","title":"Kyiv Abandoned and Deceived Moscow"},{"cluster_id":"781b12f4-b179-4668-8b0e-ea2f1da17240","title":"Minsk II: Donetsk and Luhansk Signatories"},{"cluster_id":"ecc32ba8-bd1c-43c6-8192-e0502c1f14b7","title":"Ukraine Shells Donetsk and OSCE"},{"cluster_id":"b5f5c5e5-6c1a-4551-a786-04806a60e9b1","title":"Ukraine\'s Measles Outbreaks and Vaccine Hesitancy"},{"cluster_id":"67bef4c5-afcc-4a65-9538-ce302f965385","title":"Misinformation: Vaccines and AIDS"},{"cluster_id":"58160b77-275a-49fd-b4ad-b9a4e0aa40ef","title":"Removal of Thimerosal from Childhood Vaccines"},{"cluster_id":"c09c5abe-d2d4-4b78-b32f-49fbbd5778a7","title":"COVID-19 Vaccination-Related Musculoskeletal Inflammation Case Series"},{"cluster_id":"d2f70202-2b46-45a9-9905-a0ccfee90661","title":"Minsk II Ceasefire: Frontlines Partially Implemented"},{"cluster_id":"357af95d-b02c-4002-bfc2-fdd9ff848257","title":"Pro-Ukraine Demonstrators Outnumber Pro-Russian Activists"},{"cluster_id":"ec68f63c-4291-4d49-8068-2a2cf1250591","title":"Vaccinated Donors Eligible to Donate"},{"cluster_id":"2420d848-9bcf-484f-a278-33ad97459cda","title":"Public Release of VAERS Death Reports"},{"cluster_id":"7b19db75-3bd2-47e5-a306-0a2f241eda0e","title":"Fauci on ADE in early vaccines"},{"cluster_id":"41b103ed-acbb-4350-80df-1fd2deb0346c","title":"Fetal cell lines in COVID vaccines"},{"cluster_id":"4eb34d6f-2849-4a6f-9012-a59681fdeeff","title":"Dogs gnaw on fallen Ukrainian soldier"},{"cluster_id":"61784f3e-1c50-4b37-9db4-0fd1ec458127","title":"Donbas Mines Kill Soldiers and Children"},{"cluster_id":"4a315717-0c5d-48f0-b376-1a12c3498c7c","title":"Danish Adolescent Myopericarditis After Pfizer"},{"cluster_id":"1ff366e5-31ba-464c-8544-3d84f99a75c6","title":"Ukraine Bans Three Pro-Russian TV Channels"},{"cluster_id":"5d276603-9c3a-417d-bd11-e8b613249dd5","title":"COVID Vaccine Safety Misinformation"},{"cluster_id":"61d63dd9-934f-4808-b6ab-ed734f2474b3","title":"December VAERS: 3,916 Reports, 13 Deaths"},{"cluster_id":"48eb1f9d-0125-4436-9ad0-db6bbdc685bf","title":"Children\'s Pre-activated Innate Airway Antiviral Responses"},{"cluster_id":"ce5f39de-c868-4feb-8d91-20b21e8b8ded","title":"Ukraine bans entry for Russian men"},{"cluster_id":"75a5f06e-b690-4ab1-b016-65c86c1b4940","title":"Seroprevalence Reveals Hidden Infections"},{"cluster_id":"4f2789db-45a0-4f05-86be-a25e7794e0d7","title":"Lviv Denies Dismantling Monument"},{"cluster_id":"00c920c5-f4fa-404a-9d1e-12f311ed5e11","title":"Omicron protection wanes after 3 months"},{"cluster_id":"dec098ce-5baa-400b-a766-6543ab0afe00","title":"Vaccines Blamed for Global Crisis"},{"cluster_id":"5062ec52-04a9-40ad-82e8-e7b18ce41e9a","title":"Omicron: Global Spread and Surging Waves"},{"cluster_id":"d2698d5d-a9c7-4753-8264-b469e84de09c","title":"Oligarch-Funded Volunteer Regiments Under Ministries"},{"cluster_id":"03a036cd-d590-425f-afe9-9b90c0baa4ee","title":"Delta-Driven Vaccinated Mask Guidance Revisions"},{"cluster_id":"67077d98-dd63-4eb1-bfae-12ca20649195","title":"CDC Admits Contaminated Polio Vaccines"},{"cluster_id":"2f8d9d1d-f145-459e-90bd-ebf833c6fe60","title":"Alleged Self-Spreading saRNA Vaccine Without Consent"},{"cluster_id":"0c639465-7159-40b2-869b-06840b83505a","title":"Obama backs Poroshenko in 2014"},{"cluster_id":"66b7068d-b746-42ae-9f41-d88ed9a887f4","title":"Azov Linked to Neo-Nazi Groups"},{"cluster_id":"2f956586-babe-4398-aff8-0787b3e3a21b","title":"Zelensky as Fictional President"},{"cluster_id":"cfd4b520-a181-4698-846e-ff280ba11189","title":"Shortages Drive Mixed Uniforms in Ukraine"},{"cluster_id":"bbf49577-7eda-4f96-83ed-753d3b9cc708","title":"Vaccination Could Prevent One-Quarter Deaths"},{"cluster_id":"8351f868-a72b-47b0-8a87-867df6862124","title":"MLRS shelling near Sartana"},{"cluster_id":"c4564515-d53f-4e98-999a-f38427deb89e","title":"Kyiv Renames 95 Streets"},{"cluster_id":"655e754e-33e7-4bf2-aabe-264f18d499a4","title":"Ukraine allegedly tops rights violations"},{"cluster_id":"8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7","title":"False Claims of COVID Vaccine Harm"},{"cluster_id":"a764eb56-b1bb-470b-bb17-4bd9f5369b4b","title":"U.S. to Fight for Kerch Strait"},{"cluster_id":"df5b4e50-7d1b-4d7e-ae01-046530298250","title":"Natural Immunity, Misattributed COVID Deaths"},{"cluster_id":"14b07b58-6d89-4f8a-8ddc-8c0a902ee333","title":"Donbas 2014: Aid Access Crisis"},{"cluster_id":"e0e899a0-65d4-45b2-b3be-ff8320d1837a","title":"Vaccine Hesitancy: Global Health Threat"},{"cluster_id":"8140cb8c-a254-4493-b790-598f4ef3676f","title":"Masks, Vaccines, Handwashing Suppress Immunity"},{"cluster_id":"2f7d7b19-3996-4824-8b2e-60b30c5d543d","title":"Donbas reintegration law ends Minsk framework"},{"cluster_id":"0bc36847-debb-43d3-bab5-e1a736194eac","title":"Five Years of Ukraine-EU Disaster"},{"cluster_id":"ce07721b-5347-4d52-81aa-7a7c68338485","title":"Claims: mRNA vaccines harm children"},{"cluster_id":"06b8ffc7-c987-44a2-a2cb-8721e54e7da6","title":"Crimeans Return Home After Annexation"},{"cluster_id":"d5b4afb5-46e3-4fab-9511-72f4984164cb","title":"Launch of Kyiv Patrol Police Reform"},{"cluster_id":"dd63046f-83c4-4d5e-867a-2f14376d2ce2","title":"OSCE SMM Patrol Attack in Yasynuvata"},{"cluster_id":"f10a7215-4011-4959-9b86-e9f3848b78fb","title":"Suppression of Russian in Ukraine"},{"cluster_id":"5f8dbb60-ef34-416a-9285-ed818708d337","title":"Asymptomatic COVID-19 on Diamond Princess"},{"cluster_id":"87ccb180-4860-4e8d-af6f-a3acda89b6bf","title":"Summary Killings in Eastern Ukraine"},{"cluster_id":"50450ae6-8d18-4a4d-9adf-9937e9748bba","title":"ITU Bulletin: Crimea Numbering Codes"},{"cluster_id":"f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab","title":"Misinformation: Vaccines Cause Infant Deaths"},{"cluster_id":"635833cc-6550-4cab-b41a-e51cbfca373a","title":"Alleged Spike Protein Damage Claim"},{"cluster_id":"55b3fec7-2c59-48a7-b144-2bc454de6078","title":"Mariupol: Heavy fighting, control shifts"},{"cluster_id":"e6294e0b-891d-4ba7-af93-8aa8ed47eeab","title":"Euromaidan: Heavenly Hundred and Makeshift Morgues"},{"cluster_id":"8c441ed7-3996-46c2-abdc-191f54206cf6","title":"World Mortality Dataset: Cross-Country Estimates Published"},{"cluster_id":"228f2026-3094-45be-9c29-b363d30f00b6","title":"Delphi-Based Long COVID Definition by WHO"},{"cluster_id":"8b0583af-b0d6-4ff0-b992-807e026b5368","title":"Euromaidan Protests Escalate; Kyiv Government Change"},{"cluster_id":"f679dcc1-fbec-4813-8cbd-bf97a313606d","title":"Claims of Vaccines Causing Autism"},{"cluster_id":"8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8","title":"Atlantic Resolve: NATO Reassurance"},{"cluster_id":"93fb31b6-e8df-4e78-9be7-574ea4c2f86b","title":"SARS-CoV-2 Spike and Snake Neurotoxin Similarity"},{"cluster_id":"dde390b5-1a05-447f-86aa-a25992be6bfd","title":"Most Deaths From Other Illnesses"},{"cluster_id":"4b3edb14-747e-4c77-8e76-8b7c1d8c4155","title":"Mass Russian Passports in Crimea"},{"cluster_id":"b32443a3-fa40-4637-9b55-e58ec8393ffe","title":"WHO\'s Early Cautious Mask Guidance"},{"cluster_id":"0807cdb8-6ddb-4585-ad14-90359bbf1c37","title":"Russia condemns Kyiv reintegration law"},{"cluster_id":"ebaf2aaf-acc5-40a1-b99f-157e33f793e4","title":"Waning Two-Dose Protection Spurs Israel Boosters"},{"cluster_id":"20dbcfed-6463-4ba7-98e9-93b565b2719b","title":"CDC Updates Vaccine Terminology 2021"},{"cluster_id":"621f1c2a-981d-47da-bf43-de2d73f4a594","title":"Russian Media: American Mercenaries in Ukraine"},{"cluster_id":"2e75fb89-d4ec-437b-bb34-741837209437","title":"Skripal Poisoning and Diplomat Expulsions"},{"cluster_id":"a49c6bf6-4bdf-4111-8400-ae8603304250","title":"Fire and Shelling at Zaporizhzhia Site"},{"cluster_id":"2947fe08-3f19-4a83-826c-8d5e7d1e3368","title":"Kyiv Renames Vatutin Avenue to Shukhevych"},{"cluster_id":"56c30444-c8fe-46f9-af30-b0924f71761d","title":"May 8 Remembrance and Reconciliation"},{"cluster_id":"4061c2fc-ed9c-4f22-92dd-291aa2df6a90","title":"U.S.-Led Ukrainian Training"},{"cluster_id":"a3cec669-c5d7-49cf-9b41-ed9298b7642a","title":"Zaporizhzhia NPP Shelled by Ukraine"},{"cluster_id":"86cdbb00-bf89-4bf4-b9b5-585743288546","title":"Sen. Johnson Highlights Raw VAERS Counts"},{"cluster_id":"bfcb4fd5-03ad-4398-a7b4-f52617946935","title":"Sharp GDP Contractions, 2014\u20132015"},{"cluster_id":"d140ee70-1c2e-44c9-b163-573b275b6b17","title":"Transient lymphocyte decreases in vaccine trials"},{"cluster_id":"c721dd3f-abaa-46f4-b0b3-0998badfc28c","title":"Ukraine funds radical nationalist groups"},{"cluster_id":"a83597bc-3768-4ee3-a01e-2fac92f73ab7","title":"Ukraine moratorium on Russian-held debt"},{"cluster_id":"d7ed508d-e43b-4e54-a0c0-6807c3338527","title":"OSCE Monitor Wounded; Review of Operations"},{"cluster_id":"3c66cbc4-f759-4da9-9813-b36b4c322970","title":"Civilian Casualties from Donetsk Shelling"},{"cluster_id":"7e081e03-60f5-4239-923e-30df23ea9e14","title":"Asymptomatic Transmission of COVID-19"},{"cluster_id":"acca2114-d8e0-468a-8116-8a8e6ac23e1b","title":"EU Ties Ukraine Aid to Migrants"},{"cluster_id":"ecd748e3-d837-4992-8ea5-50edc6e9e5f6","title":"EU aid to Ukraine since 2014"},{"cluster_id":"a1c74ee2-0da5-4362-bf0c-2f7caddeae61","title":"Ukraine Rebels Blame Donetsk Shelling"},{"cluster_id":"94d152a0-b275-42d2-af1e-de4ffe6f8a22","title":"US B-52s in European Operations"},{"cluster_id":"db2b5d72-303d-4743-8188-e92d23a86e05","title":"Johnson\'s Early Herd Immunity Messaging"},{"cluster_id":"909c2544-65ad-4eae-8bbb-f43d077750aa","title":"SARS-CoV-2 stability in aerosols and surfaces"},{"cluster_id":"eb8c09b3-c22e-4c14-a55e-41e86bc54809","title":"Mejlis Calls for 2014 Referendum Boycott"},{"cluster_id":"44317cdd-77fe-42f4-b1db-9819636d2f58","title":"Ukraine to Poland Migration Surge"},{"cluster_id":"1f539237-1caf-4525-9adc-af33bb645e44","title":"Amnesty Reports Abuses by Volunteer Battalions"},{"cluster_id":"997b033a-0811-49fe-bc36-8ee742156833","title":"Soviet Mass Renaming of Crimean Toponyms"},{"cluster_id":"30f8d995-4c8b-4d55-9cc0-91236f828d24","title":"Ukraine shifts to Europe Day"},{"cluster_id":"4f4a8dcc-ad59-4dfb-b222-e025fb0c418e","title":"Ukrainian Forces Lead Ceasefire Violations"},{"cluster_id":"df895ffb-5333-4b2a-9ce5-f1108a894c34","title":"No Excess Mortality; Ineffective COVID Measures"},{"cluster_id":"128ade3d-bda4-4b71-b956-463eb584089c","title":"Thimerosal Reduction in Childhood Vaccines"},{"cluster_id":"0b719ed0-60f8-42bb-9426-ff2a477557b7","title":"EP questions ISIS in disputed territories"},{"cluster_id":"c91f4478-001c-4706-a4cf-7da14de01daa","title":"Swiss Guidance on COVID-19 PCR/NAT Testing"},{"cluster_id":"0634cfd7-f7f7-48cb-bb92-7dc813e3271c","title":"Ukraine Can\'t Regain Crimea and Donbas"},{"cluster_id":"af40ab83-4c48-4ac1-af3a-242491a35af4","title":"Ukraine Adopts Lustration for Officials"},{"cluster_id":"baac2920-a8d6-4667-acc5-460b63889a7e","title":"Vaccine Cell Lines: WI-38, MRC-5"},{"cluster_id":"21533f1c-ae42-4579-91e2-803b34beb003","title":"Lviv\'s Hill of Glory Debates"},{"cluster_id":"2d060fd1-76c9-470d-941c-4c8d800b380a","title":"Non-COVID Deaths Remain High"},{"cluster_id":"4d62f2bf-06ba-4e7d-b665-78a194b70483","title":"IDP Housing Centers Expanded in Lviv"},{"cluster_id":"83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2","title":"U.S. Condemns NATO in Black Sea"},{"cluster_id":"2ea5d498-58e2-44a4-a51a-95bda7047686","title":"Pregnancy Vaccination: No Benefit, Higher Readmissions"},{"cluster_id":"26b806a5-30f6-4312-bfd4-c6984e3b4d30","title":"FDA Briefing: Moderna mRNA-1273 Safety"},{"cluster_id":"83412f4d-d0e2-456a-853f-c0ab5d6c2ff1","title":"Birth Control: Greater Clot Risk"},{"cluster_id":"6695efed-b1b5-4469-a01b-a370dfb9c522","title":"Masks and Lockdowns Do Not Work"},{"cluster_id":"e30d449c-eb81-4d62-9149-9437a1a2c593","title":"Urgent IAEA Mission to Zaporizhzhia"},{"cluster_id":"3d43abac-8178-4ce6-a910-10e135a5266f","title":"Ukrainian Language Mandate for Public Sector"},{"cluster_id":"086034d9-cc70-4cb5-b461-137099358741","title":"Disrupted Voting in Crimea and Donbas"},{"cluster_id":"c9ef551f-21d7-4986-8f7f-14a67206ac95","title":"Lancet study: Vaccination saves lives"},{"cluster_id":"d73adbe1-7dcc-4345-a67c-e7d102fbc24d","title":"Ban on 38 Russian Books"},{"cluster_id":"0a129298-9d76-444c-8b1e-1ebbbe3bb953","title":"Yanukovych Seeks Russian Assistance"},{"cluster_id":"14b46c0a-7b16-4722-b599-90d7d69970a1","title":"Natural Immunity vs Vaccination Debate"},{"cluster_id":"c7b90480-a4e5-4b5f-b840-fe13ad140b52","title":"Misinformation: Vaccine-Induced AIDS Claim"},{"cluster_id":"ff3032ee-a77e-4fe7-a5a1-205c35f0948e","title":"Ukrainian Forces Reclaim Mariupol"},{"cluster_id":"17312825-7f0f-4a66-81df-09fa5dfc119d","title":"NATO\'s Illegal Occupation of Ukraine"},{"cluster_id":"557fbe6b-8c80-48fe-945d-5c4d06e53e9a","title":"Lustration Law Bans Former Officials"},{"cluster_id":"b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a","title":"Macron Urges Dialogue, Not Humiliation"},{"cluster_id":"947a0b8b-01e0-44c9-8ebc-c9da3eecde20","title":"Russians Demand Autonomy"},{"cluster_id":"89448e79-f7ef-4836-aa0c-f4044c4e1e16","title":"ICC Opens Ukraine Preliminary Examination"},{"cluster_id":"cd51f6af-e3ac-4df3-b356-fdbeb2599d37","title":"COVID-19 enzyme resembles rattlesnake neurotoxins"},{"cluster_id":"a9f88531-6abb-40c2-bba6-de053eb80cb0","title":"Ukraine\'s Currency Market Hinges on Russia"},{"cluster_id":"aa458090-4ea3-4829-9f88-662eb71a8370","title":"Contested COVID-19 Claims"},{"cluster_id":"1020a2ca-3e92-4f76-98e4-6f44fdfd5f52","title":"Ukraine: Weak Manufacturing and Investment"},{"cluster_id":"4fc147e3-0b67-422d-b442-9aed1bd9ffee","title":"Disputed Donetsk, Luhansk Elections 2014"},{"cluster_id":"6b22978f-c41a-4fd1-ac4e-29deafe60573","title":"Vaccine-caused excess deaths claim"},{"cluster_id":"51ff5b38-5ae5-4505-adc2-291731599e68","title":"Vaccination Prevents Convalescent Plasma Donation"},{"cluster_id":"8c70df97-1c82-4e7f-b23d-acbf2024c8f6","title":"Westinghouse extends Ukraine nuclear fuel contract"},{"cluster_id":"15bdefb4-3c81-4573-bb02-e7a3789e75e2","title":"Most COVID-19 Deaths Had Comorbidities"},{"cluster_id":"ca0d3bae-6f1d-4857-b362-c7e7718bca04","title":"Vaccines Trigger Beef Intolerance"},{"cluster_id":"40db941d-31ac-4f8f-a268-d60a6c9bd055","title":"NATO Nuclear Drills Threaten World War"},{"cluster_id":"27fad854-f733-4ec5-8acb-b36e0c043d26","title":"Virus: Necessary Factor, Not Cause"},{"cluster_id":"88fa31fb-364c-47f5-bac4-4ecea848d93a","title":"Vows to Reclaim Crimea"},{"cluster_id":"04c0a28d-e066-4279-bfee-f4757f197d7a","title":"Crimean Tatars Support Russia\'s Ukraine Operation"},{"cluster_id":"43320422-2afc-457d-a5b5-902abc100632","title":"WHO clarifies PCR cycle thresholds"},{"cluster_id":"6d1416a4-5911-49a5-a8dd-0b4e7d18279a","title":"Event 201 Pandemic Tabletop Exercise"},{"cluster_id":"448377aa-104a-47c8-b987-d7ae3a311686","title":"Stanford Seroprevalence: More Infections, Lower IFR"},{"cluster_id":"d53538f2-6557-4a35-adbb-a2eefd4e49a8","title":"Ukraine 2016 Political Instability"},{"cluster_id":"c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a","title":"UN Admits Islamists in Ukrainian Forces"},{"cluster_id":"07a40f3e-ce43-455d-8cb0-e9110e244817","title":"Red-Black UPA/Bandera Flag in Euromaidan"},{"cluster_id":"7e64d534-c786-4ebd-b549-3314cdd361e4","title":"Amnesty Reports Civilian Deaths in Donbas"},{"cluster_id":"2f4e138b-a8ca-4c68-be26-24de0c3b0489","title":"EU Visa-Free Travel for Ukrainians"},{"cluster_id":"29fa8f23-676f-4f6e-888b-58fd11dbd236","title":"Waning antibodies prompt booster guidance"},{"cluster_id":"44a25f49-5174-4a81-bbe3-8d614f9c4116","title":"Grocery Stores Install Cart Sanitizers"},{"cluster_id":"16220929-8aa1-45e6-9f5e-8401f7ed50de","title":"Stoltenberg Urges Long-Haul Readiness"},{"cluster_id":"5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98","title":"Ukraine projectile destroys Rostov border facility"},{"cluster_id":"a1084837-f12e-45c4-9bfb-1677ce1c51ad","title":"Sanctions Targeting Ukraine Authority Claims"},{"cluster_id":"4fa8e557-bb3e-4afa-89cd-33ec7b315e73","title":"Nuland Warns: Oligarchs, Reforms Threaten Ukraine"},{"cluster_id":"c5ac1407-521f-4465-8124-83f30e719068","title":"Polls Delayed Near Frontline"},{"cluster_id":"ed50b251-f205-4952-987b-aed1c0461840","title":"Ukraine Transfers Gold to Poland"},{"cluster_id":"94e66aa3-5079-4e1d-bdc8-702db352aa56","title":"Nordic Nations Pause Moderna for Youth"},{"cluster_id":"71b86c5b-0ae0-46d5-a172-4da94679db3d","title":"Danish Researchers Claim Pfizer Unsafe"},{"cluster_id":"187eb2a5-5a75-4a22-8ebb-7b83bc1068a8","title":"Debunking COVID Vaccine Myths"},{"cluster_id":"a11d2091-08fe-4a3c-ae90-66e1118f2ac4","title":"Mask Mouth and Oral Health Issues"},{"cluster_id":"baef4ffa-45e6-4649-9ab7-8c1b3621d2d6","title":"Netherlands Won\'t Ratify EU-Ukraine Association Agreement"},{"cluster_id":"59e2af7d-1c61-4602-808b-5369f9854fc9","title":"2014 Ukrainian Banking Crisis"},{"cluster_id":"213314ea-c0f8-4a72-832f-5b10a8bbeab5","title":"IAEA Chief Condemns Shelling Near Zaporizhzhia"},{"cluster_id":"d089f75e-69ee-4713-8c0e-27843b110a2a","title":"Cities Seek Return to Russia"},{"cluster_id":"fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f","title":"Ukraine Lenin Statues Removals 2013\u20132014"},{"cluster_id":"2f03e50c-f48e-4212-9d22-0ac755bb8fe3","title":"Fast-track citizenship in occupied Kherson, Zaporizhzhia"},{"cluster_id":"0a1db453-23bf-4b25-a04b-c4f13d273e88","title":"Masks Blamed for 1918 Deaths"},{"cluster_id":"11ad6c89-9a64-4385-9a81-dfa3787cc401","title":"Formation of Ukrainian Volunteer Battalions (2014\u20132015)"},{"cluster_id":"2c6352c1-d120-47aa-8825-a58359bc7c7c","title":"Earlier U.S. Lethal Defense Transfers"},{"cluster_id":"cf0c77f3-683e-467a-b83c-95b78a12d867","title":"Open Letter Urges Airborne Transmission Recognition"},{"cluster_id":"20c941a8-b922-48e3-8e56-e49e1a524fd9","title":"HPV Vaccine: Side Effects Outweigh Benefits"},{"cluster_id":"66380cec-1745-4f20-be6e-01fcad9e1602","title":"Moderna Phase 3 Safety Data NEJM"},{"cluster_id":"6d2fdf64-8424-4971-a998-3fe674aff124","title":"Nuclear Explosion in Ukraine"},{"cluster_id":"933ba991-e63b-4909-90b5-fbeb9eeea4c4","title":"Crimea switches to Russian phone numbers"},{"cluster_id":"5d8d730b-6674-4d5b-8f99-6c8e240e9080","title":"Ukrainian Repression of Hungarians in Transcarpathia"},{"cluster_id":"287c467e-feff-43ca-835b-d713c03d0418","title":"March 2019: UPA/OUN Veteran Status"},{"cluster_id":"5a9d340b-259a-49d7-894d-4e9c6dec6a07","title":"Odesa Clashes, Trade Unions Fire"},{"cluster_id":"4a7affe3-fd43-41f4-8713-3066830d90f8","title":"OSCE SMM vehicles struck near Kirovske"},{"cluster_id":"995a6788-c0da-4f2f-a729-9d6b9bf65efc","title":"Ukraine Seeks Peace With Russia"},{"cluster_id":"003d2fc7-16f8-4835-a770-b85123b3c250","title":"Wuhan Unknown Pneumonia; WHO Notified"},{"cluster_id":"d882f953-ff9f-4410-820f-ffce8c5ec321","title":"Israel Reinstates Masks Amid Delta Surge"},{"cluster_id":"bb78b3cf-3fee-4d7e-b532-1ccb52ef3013","title":"Donetsk-Luhansk Rights Violations"},{"cluster_id":"5ac433e4-bd1e-455d-8c24-e981eb354d77","title":"Myth: Vaccines Change DNA"},{"cluster_id":"0a6e93a7-4ca1-4ae8-937a-93b0852204d1","title":"Hungary Protests Ukraine Education Policies"},{"cluster_id":"36d5c8e6-5870-44de-bee8-1ba3638e2785","title":"Contested Graphene Oxide Vaccine Claim"},{"cluster_id":"f2c109a3-30b0-4718-85b7-78d12406aef5","title":"June 2021 Post-Authorization Adverse-Event Summaries"},{"cluster_id":"9ee44494-957f-41e5-a680-3bacf709709f","title":"Russia accuses Ukraine of Crimea plots"},{"cluster_id":"1ce4d643-96d1-4472-9df9-18efdd477875","title":"Ukraine Repeals 2012 Language Law"},{"cluster_id":"0d3f46d1-7a84-428a-aa26-c10a575083b5","title":"Expedited release of Pfizer vaccine documents"},{"cluster_id":"db855b90-bd37-485e-bb72-492eed958963","title":"PHE Age-Stratified Vaccine Surveillance"},{"cluster_id":"05f00def-a8b8-4cdc-94a6-9ead4bc629d3","title":"Zaporizhzhia Nuclear Plant Under Fire"},{"cluster_id":"c9780602-10a7-414d-9965-0df44aadba9b","title":"Kremlin Blames Sanctions for Rouble Slump"},{"cluster_id":"2a1de060-abb4-43d9-a91c-f13c074e7031","title":"UK Pandemic Over: Herd Immunity"},{"cluster_id":"f43f98cd-cb16-421c-a639-6c526509bfd7","title":"SV40 Contamination in Polio Vaccine"},{"cluster_id":"81fee6b1-629b-42a7-9a8d-c4a3008f59e3","title":"Vaccine Misinformation: False Risk Claims"},{"cluster_id":"9fc7edf3-7209-4828-92b3-8d6dafded201","title":"Ukraine Cedes Borders to the EU"},{"cluster_id":"0e248889-43a9-4087-a6b0-f1d7854daf2c","title":"Backlash Over Law Targeting Russian Speakers"},{"cluster_id":"679dc735-ea4b-4b4e-88e2-45d26bcc5b41","title":"PCR Tests Fail to Distinguish Flu"},{"cluster_id":"9c71282b-fc72-4fb3-b7f8-7ff433782d1d","title":"Isa Munayev Killed Near Debaltseve"},{"cluster_id":"79e93acb-9f08-48c2-9984-2e0654fbc884","title":"Kyiv substitutes Ded Moroz with Mykolay"},{"cluster_id":"f18636a0-1641-41b0-92a8-1218e6cdd54a","title":"Ukraine Decommunization: Banning Soviet Symbols"},{"cluster_id":"ab1f8fac-3632-4188-90ae-a2c911b8425d","title":"Kharkiv Marchers Chant Anti-Russian Slogan"},{"cluster_id":"19581d0c-22b5-4ff0-8a68-de86fb01009c","title":"Pfizer vaccine trial: 44% miscarriages"},{"cluster_id":"7c8877ae-f397-490e-9778-67a6e91ebe1c","title":"Sanctions on Russia After Crimea"},{"cluster_id":"02ef40eb-a1c1-4bb1-9831-77fc91e127be","title":"Zelensky Delays Donbas Decentralization Bills"},{"cluster_id":"0630fbfc-9793-4e8b-bd28-898778d452da","title":"EU\u2013Ukraine Association Agreement Signed"},{"cluster_id":"da33144e-1465-4006-aabf-42e89071cdf4","title":"Donbas Elections: Control or Sabotage"},{"cluster_id":"48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75","title":"Transcarpathia-Hungary Border Tensions"},{"cluster_id":"4fe1a1d1-0c63-4497-8366-24cf2914a93f","title":"UK and Ireland Exempt from Visa"},{"cluster_id":"109daecb-5285-41a5-9427-7fd6ab199a14","title":"Ukrainian Detained in Crimea for Espionage"},{"cluster_id":"3c02cb9f-d868-4d95-a235-953e540c09c9","title":"Far-Right Influence in Post-Maidan Ukraine"},{"cluster_id":"f8140231-b4f8-4a5a-801c-39c992ba46a9","title":"Samoa Measles Outbreak Triggers Emergency"},{"cluster_id":"70a4982e-a051-4993-8a45-818426e08af0","title":"Canada at Donbas withdrawal line"},{"cluster_id":"a8476578-a217-4709-ac69-6e4d18f25dc6","title":"Maidan Reverses 2012 Language Law"},{"cluster_id":"3c9a1b13-b4b6-4090-861e-e35159e61286","title":"Guillain-Barr\xe9 Linked to 1976 Swine Flu"},{"cluster_id":"6150a21f-6d1d-4554-8cbb-b01623349756","title":"Parliament approves 75% Ukrainian TV quotas"},{"cluster_id":"b471f42f-4da7-4b5a-a11e-18deef221da8","title":"Zaporizhzhia NPP: Mined and Rescued"},{"cluster_id":"011b48fb-6ec4-41cc-bd4d-394e371c18cb","title":"Ukraine Opposes WWII Victory Medals"},{"cluster_id":"0a173478-bf00-4e1f-be9a-c8305b945d9d","title":"Ukrainian National Guard throws dead bodies"},{"cluster_id":"d00bd384-4d89-4a56-8487-c419c52438e5","title":"Polio Vaccine Conspiracy Claims"},{"cluster_id":"95b428d7-1d28-45e2-a9a0-dd59bb6a0176","title":"Separatist Buried Alive in Ukraine"},{"cluster_id":"c0713b5c-a570-4865-83c9-eb36c347abcf","title":"Rapid Trident 2021 COVID Mitigation"},{"cluster_id":"66bbc9b1-3580-4b34-9ccc-f5983ea5120d","title":"2014 Parliament Recognizes OUN/UPA Veterans"},{"cluster_id":"56c21a67-f093-4d7b-81de-a41cb3a3c896","title":"Hryvnia Plunge After Auctions Abandoned"},{"cluster_id":"d415aa76-63ab-4b87-94b6-7d753e952a6a","title":"Ukraine Declares Donbas Occupied, Russia Aggressor"},{"cluster_id":"ab378ec8-ca7a-473f-b276-44d546196e26","title":"Claim: Flu Shot Causes Cancer"},{"cluster_id":"9e771d92-eea3-45ec-b1c4-e7bba0011301","title":"Germany Restricts AstraZeneca to Over-60s"},{"cluster_id":"99f11e8b-4375-4ee6-8be9-78b8355c6e63","title":"Allegations of Neo-Nazism in Ukraine\'s Government"},{"cluster_id":"fca8c069-2da0-43e8-8cac-08662970bcda","title":"Preliminary mRNA vaccine safety in pregnancy"},{"cluster_id":"a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4","title":"Liability Rules Under EUA"},{"cluster_id":"b69dac95-ca24-49e5-b472-f36e5a0721b8","title":"Vandalism of Holocaust Memorials, Ukraine, 2014"},{"cluster_id":"8d63a231-4f96-4fb0-aa81-938182c806dd","title":"USAID Ukraine Civil Society Audit"},{"cluster_id":"773c7be2-511f-4315-b512-fcfb831f2cc3","title":"Russia accuses Ukraine of Kerch provocation"},{"cluster_id":"3c4b8a98-54ef-4e72-a175-6c00ff85db75","title":"Culture Minister Falsified History, Denied Holocaust"},{"cluster_id":"9af9ad02-7803-4d3d-9d58-fdfc300bef96","title":"Post-vaccine Deaths Not Classified as Vaccine-Related"},{"cluster_id":"268e1143-4495-4247-af6b-b6f6f368f74f","title":"Russia\'s Sole Humanitarian Aid to Donbas"},{"cluster_id":"14aa16f3-35fc-4a1e-a17f-37a33c485e0a","title":"CDC Guidance for Certifying COVID-19 Deaths"},{"cluster_id":"ab2c49a9-2278-4839-bbdd-9674c0825abf","title":"COVID Vaccine Myths: Poison, Vanished Pandemic"},{"cluster_id":"92352325-85b6-4726-9aed-67119e9599f9","title":"Low Effectiveness: 2014\u201315 Flu Vaccine"},{"cluster_id":"d191d96a-6233-4306-907d-1beabb6fc9c7","title":"Atlantic Resolve: Poland Rotations 2019"},{"cluster_id":"a9574820-7af4-4109-8e6e-9d95f9ba6cbd","title":"Formalising Citizens\' Right to Bear Firearms"},{"cluster_id":"bbc6fef6-c552-409d-9152-d8abd3a15ae3","title":"Temporary martial law in border regions"},{"cluster_id":"0e128959-4be6-4a58-950e-03878e48a675","title":"Provisional All-Cause and Excess Deaths, 2021\u20132022"},{"cluster_id":"5279c839-650e-45b8-a4b4-5af5d5649ea3","title":"Kyiv Pride clashes; police detain far-right"},{"cluster_id":"258085e5-fc49-48d1-b3f4-3f9862c3ba91","title":"Maritime borders tied to Crimea annexation"},{"cluster_id":"61608de3-ac5a-4b10-bba7-1b5580f57caa","title":"Treasury designates DPR and LPR"},{"cluster_id":"983a818a-ed6d-40ec-af64-8e28da7e1bbd","title":"Presidential Blocking of Russian Platforms"},{"cluster_id":"bc3b9d73-137b-4059-890e-e7cbbf0bd7b2","title":"Pro-Russian Seizure of Donetsk"},{"cluster_id":"99d9484d-46ae-4ca2-98a1-dd3e0aeee99d","title":"COVID Death Toll Overreported"},{"cluster_id":"21361eee-5fe8-48f0-a512-8a8c4752daae","title":"Higher Infection Rates Among Vaccinated"},{"cluster_id":"2ccc0520-5070-4b1d-b1b9-d9e9fc878c97","title":"National Geographic Maps Crimea as Russia"},{"cluster_id":"eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268","title":"Crimea 2014: Abuses and Collaborations"},{"cluster_id":"71f12e75-d3eb-42eb-93dd-fc62f2343321","title":"Hungary to Shoot Down Ukrainian Airliner"},{"cluster_id":"edae4987-7374-49c7-bd0c-6f6522213435","title":"NATO eFP Deployments: Baltic States, Poland"},{"cluster_id":"71624d95-aa07-4fb2-8217-706e01ae4a63","title":"Russia Deploys Troops on Ukraine Border"},{"cluster_id":"a222dd36-fddd-41d8-956d-d735c7c4c6bb","title":"US Created Crimean Tatar Mejlis"},{"cluster_id":"0c87e09a-5d40-4c46-abb8-ffdda4139e41","title":"Vaccine-Associated Axillary/Supraclavicular Lymphadenopathy on PET/CT"},{"cluster_id":"e126486d-8b99-4425-b6a3-54724b486b78","title":"Vaccines Outperform Natural Immunity"},{"cluster_id":"d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc","title":"Rights Stripped From Russian Citizens"},{"cluster_id":"f8ceed1b-ae48-442b-9e71-03f2203d7e38","title":"VAERS Deaths Blamed on Vaccine"},{"cluster_id":"edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c","title":"EMA Guidance: Porcine Trypsin in Vaccines"},{"cluster_id":"254e946c-9e7a-429c-b142-d41e38953b50","title":"Rising Pediatric Scarlet Fever and GAS"},{"cluster_id":"2972b17d-9533-46fe-a896-a36d50916446","title":"Limited visa-free travel for Ukraine"},{"cluster_id":"b997c44d-2fc1-4d45-8a7a-f72d1b5a079d","title":"Firehose of Falsehood in Russia"},{"cluster_id":"a16d38f8-25ac-46b8-94d9-38eb77cacdcf","title":"Foreign Fighters in Eastern Ukraine"},{"cluster_id":"170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c","title":"Canadian Mercenaries in Donbas"},{"cluster_id":"4eb89d26-0914-45a8-8a2e-98708f9a3315","title":"Children: COVID-19 Less Mortality, Similar Hospitalizations"},{"cluster_id":"0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5","title":"Bandera Memorials Across Ukraine"},{"cluster_id":"f0e862e5-92ba-499e-8f7b-4935ce01c5fd","title":"Misinformation: Vaccines Allegedly Untested"},{"cluster_id":"02063354-1cf2-4e4e-a749-ce91914994ae","title":"Provincetown Outbreak: Breakthrough Infections"},{"cluster_id":"c99367c6-2c05-4a14-b047-7f8ff36ff133","title":"OSCE SMM Reports Donetsk/Luhansk Casualties"},{"cluster_id":"18daf39a-f6c9-4439-8592-186d1ea3c4b4","title":"Mask Wearing: CO2 Toxicity and Immunity"},{"cluster_id":"c2e5bef0-900b-4168-ac2b-5a5465221f87","title":"Pfizer-BioNTech COVID-19 Efficacy Announcements"},{"cluster_id":"cec3a521-c732-4e0b-8192-f6efa6c46d10","title":"2018 SBU Crackdown on Pro-Russian Media"},{"cluster_id":"6220afcf-2f7d-4d0b-9949-c9eea0785c4f","title":"Military Near Zaporizhzhia Reactors and Infrastructure"},{"cluster_id":"12e02de9-758e-49f6-b31c-fe52770a7aa7","title":"Harvard: higher cases in vaccinated areas"},{"cluster_id":"009e9d6b-ab96-416d-b96e-b7eaada086cf","title":"Freelance Journalist Shot Dead in Kyiv"},{"cluster_id":"b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb","title":"Ukraine\'s Education Law: Ukrainian Language"},{"cluster_id":"626701fe-ae3d-403d-9681-7d335f03c82a","title":"Azov Origins: Far-Right Ties and Symbols"},{"cluster_id":"e4e6149d-8b97-4295-847d-c2c2c5acb8ee","title":"Fluctuations in Stillbirth and Neonatal Rates"},{"cluster_id":"5d4f6733-5fbd-48ce-8468-590ebda279c7","title":"Kyiv Provocation: Moscow Blamed"},{"cluster_id":"e81e68ae-4e8a-4aef-a358-1455ad08bdc4","title":"DANMASK-19: Limited Mask Protection"},{"cluster_id":"bdc594bb-6aa7-4421-82b8-b7df34a7c93e","title":"Ukraine targets Russian language protections"},{"cluster_id":"35008b59-14cd-4674-801b-6fc7e159bf31","title":"2017 Ukrainian Education Law Promotes Ukrainian"},{"cluster_id":"c84778ea-ef3a-409f-9105-f5f4a9c3f19d","title":"IAEA Chief Warns on Zaporizhzhia Plant"},{"cluster_id":"44a47e28-efc2-4e0c-b9c2-18a93b3b20be","title":"Japan\'s vaccine death claim controversy"},{"cluster_id":"e56fc955-148f-4ab7-9982-126189917297","title":"Graphene Masks: Inhalation Risk Recalls"},{"cluster_id":"06f36d72-4a36-4a11-89bc-28713f0d3ba2","title":"Uttar Pradesh Credits Ivermectin Outcomes"},{"cluster_id":"aacd7f08-5036-4563-9193-ec61d4e0ea80","title":"Spanish Coverage of Ukrainian Ultranationalists"},{"cluster_id":"31e7b652-307d-4f5d-a4a6-215892b2e421","title":"NATO Opposes Immediate Ukraine Accession"},{"cluster_id":"e7def08b-a4be-4464-b5ad-7e8f1dfa8752","title":"Moderna Side Effects and Sudan Polio"},{"cluster_id":"909f6739-4757-4400-a81c-4fdb3bbaad77","title":"AstraZeneca suspended over Beta efficacy"},{"cluster_id":"7afb7680-3722-423f-b129-7076bfb88092","title":"Vaccines and Statins Misinformation"},{"cluster_id":"a28a5ed3-bc11-405d-9242-8b1a5ce91c01","title":"Ukraine Accepts ICC Jurisdiction Since 2014"},{"cluster_id":"9b7a4b49-e4e5-49c9-a089-9e908e59efcc","title":"Self-Reported Long-Term HPV Vaccine Complications"},{"cluster_id":"92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923","title":"Rushed Vaccines, VAERS Spike, No Threat"},{"cluster_id":"d74329dc-5b82-41ba-94bd-2cdd8306d3ee","title":"Ukraine FDI Collapse After 2014 Crisis"},{"cluster_id":"503b13e8-42e4-48e4-8ace-47ca9e49140f","title":"Kyiv Drafts Ukrainian-Language Mandate"},{"cluster_id":"f0d97c3a-c630-45ac-8106-3c433d45bb57","title":"Abuses by Donbas Volunteer Battalions"},{"cluster_id":"13d74323-84c7-4461-a516-d07ee1ee8c43","title":"Ukraine retakes Sloviansk and Kramatorsk"},{"cluster_id":"e8b8352a-472f-4b00-9dae-87cd809f920e","title":"Polish Military Order to Attack Ukraine"},{"cluster_id":"b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a","title":"Variable mucosal IgA after mRNA vaccines"},{"cluster_id":"6f5e39d0-2941-42e5-be3f-779525a745b7","title":"China urges restraint on Crimea referendum"},{"cluster_id":"af07ce28-0024-41ac-b51c-01e4bbf2c507","title":"Unguided Rockets Kill Civilians in Donetsk"},{"cluster_id":"253e2fef-8100-4235-899c-96e9877535d1","title":"UN Condemns Ukrainian Zaporizhzhia Attacks"},{"cluster_id":"7690b51f-82d1-4577-be9d-58b4d7bf11b2","title":"Crimean Tatar Mejlis Declared Extremist"},{"cluster_id":"876dc47c-c65a-4a65-a882-eeeb837080aa","title":"2019 Language Law Enters Into Force"},{"cluster_id":"aae30a17-ea30-48f8-8399-1f3de025df70","title":"Eat Out to Help Out Launch"},{"cluster_id":"a5cfe32e-2f16-4644-a4e9-767621b4c4a7","title":"Photo Coverage of Gaza Shelling"},{"cluster_id":"733bc88b-24fe-4115-bf99-e05181e2177b","title":"Limited evidence for universal masking"},{"cluster_id":"fe911735-6fb7-4737-bc2c-bfe7c0b05844","title":"Ukraine Census: Large Russian-Language Population"},{"cluster_id":"3a723b11-9c69-4419-ba9d-ccab21e2fc24","title":"Persistent corruption and weak governance"},{"cluster_id":"98c5d764-86f9-4cd2-ac58-1dae1f5811e9","title":"Illicit Trafficking of Radioactive Materials"},{"cluster_id":"5b2c4526-459d-4b6f-8f31-bd40fccf12ff","title":"Ukraine to lose regions to Russia"},{"cluster_id":"56e6ff33-547f-4d6b-a7a7-e1266368fdd7","title":"Kyiv Blackmails West Over Crimea"},{"cluster_id":"21a0cca0-78e3-4e0b-95d4-e1b42b08be47","title":"Two Russian journalists killed near Luhansk"},{"cluster_id":"0950755f-651f-455e-a7d5-47091afd7de2","title":"MHRA Declares COVID Vaccines Unsafe"},{"cluster_id":"5c683e3b-456e-40af-9840-3af3a5900ece","title":"Ukraine Calls Pro-Russian Fighters Terrorists"},{"cluster_id":"612db375-37db-450a-9941-cc2bdb1c5d4b","title":"First U.S. COVID-19 Vaccinations Begin"},{"cluster_id":"f367b654-8f0a-4a4d-816e-54c86d7f13ae","title":"Mass graves of women near Krasnoarmiisk"},{"cluster_id":"6c375d59-160f-4719-ac36-a62607acccb1","title":"Intensified NATO-Ukraine Cooperation"},{"cluster_id":"9c4f129c-13a2-41c2-aa00-330c197b8780","title":"Russian claims of Ukrainian cross-border shelling"},{"cluster_id":"bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb","title":"Ukraine Punishes Refusal to Speak Ukrainian"},{"cluster_id":"1f8ce922-0e37-4ccb-b586-67da18764d96","title":"Alleged cancer risk in cell-based vaccines"},{"cluster_id":"d7c36f98-9955-4c57-9dda-97bd7a1b6e4f","title":"Europe Suspends AstraZeneca Vaccine Over Clots"},{"cluster_id":"54c90db1-79c2-4dc0-b9f0-9cd9022a857f","title":"US Seeks to Oust Poroshenko"},{"cluster_id":"c6d927b7-cd5d-4d4f-8175-fa9bbd32a788","title":"Booster Expansion, Breakthroughs and Waning Immunity"},{"cluster_id":"d30fd077-478d-4784-a1a9-ce89125fa303","title":"Samoa MMR deaths spark investigation"},{"cluster_id":"15516ad5-b153-4147-8246-ecae0ddbf175","title":"Firing on Civilian Vehicles in Donbas"},{"cluster_id":"01a95de5-1ee0-4431-afa3-a8234a4831ac","title":"Explosions at Saky air base"},{"cluster_id":"3c7779af-1e2b-432f-abfc-f807e51488c7","title":"Raw Counts Mislead Vaccine Effectiveness Estimates"},{"cluster_id":"595a5404-b726-44ba-919a-07c9e6bedb55","title":"Children face landmines in eastern Ukraine"},{"cluster_id":"93f3d467-50ce-4038-8205-5814ad28dd43","title":"Masks Make In-Person Voting Safe"},{"cluster_id":"590acd5e-f716-496d-b821-297d8887167e","title":"Trial Deaths Deemed Unrelated to Intervention"},{"cluster_id":"b978e9a0-f48b-432c-b14c-50e4efff007d","title":"Odessa Deaths: Calls for Thorough Investigation"},{"cluster_id":"690dcbae-7356-41d9-9b3d-b2f6f77db887","title":"Ukraine backs Steinmeier Formula on Donbas"},{"cluster_id":"bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2","title":"Putin Justifies Crimea Annexation"},{"cluster_id":"0978a576-627e-40f6-a382-f39885473545","title":"Ukraine Bans Russian TV Channels"},{"cluster_id":"66034097-f5ff-415b-b7cc-7775692bf89e","title":"Donbas SMM: Mines, Detentions, Access"},{"cluster_id":"c7c8c6d3-cdc9-47d7-8f45-165280d3560a","title":"Gazprom Cuts Ukraine Gas Supplies"},{"cluster_id":"8ac816b2-de5c-4294-a968-e6279613b1d8","title":"OSCE Walked Out of Donbas Talks"},{"cluster_id":"cfa7b687-2383-40f8-9684-b8b6e91149cc","title":"Russia-Ukraine Trade Collapse, 2015"},{"cluster_id":"9c99e4fa-6c0d-4aa9-bb98-86450c898d1b","title":"Vaccination causes more deaths than prevented."},{"cluster_id":"ddc5360a-1ac4-443b-9995-2e77ae3fa0fc","title":"Parubiy Assassinated in Lviv"},{"cluster_id":"bf617b93-4dcc-4186-81d8-7cd9fc2d425a","title":"Public Memory of PMCs in Iraq"},{"cluster_id":"00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea","title":"COVID-19: PHEIC Declared; US Ends Emergencies"},{"cluster_id":"4129284c-60dc-471f-99d0-fbb5e6ca7277","title":"Rare Post-Vaccination Myocarditis: Autopsy Case Reports"},{"cluster_id":"fc45a344-4cfc-4865-9030-d033f0c8dff3","title":"COVID-19 Vaccine Misinformation Claims"},{"cluster_id":"dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e","title":"Ukraine Incites Donbas War for Sanctions"},{"cluster_id":"66914632-689c-4d05-b834-b8904eae50cd","title":"Bandera Canonized by Ukrainian Orthodox Church"},{"cluster_id":"5e7e70f4-b130-467a-9df9-f6078877ed61","title":"UN Recognizes Russia\'s Crimea Phone Code"},{"cluster_id":"fc72359d-8e34-4b21-8fce-8279f0329c9c","title":"Japan Suspends Moderna Vaccines Over Contamination"},{"cluster_id":"3909ddcb-f2e7-47b0-849d-f54906120921","title":"Ukraine recognizes 1944 Crimean Tatar genocide"},{"cluster_id":"a92df9a8-beac-475c-a620-574a5351def4","title":"Vaccine Harm Claims and Natural Immunity"},{"cluster_id":"827f6b49-228f-4d42-afa2-d86a5b588a72","title":"Waning Pfizer Protection Against Delta"},{"cluster_id":"60a1acab-79cf-438f-96de-dbff294bd2e7","title":"HPV Vaccine Harm Claims"},{"cluster_id":"0bf33c34-9525-433f-a535-5885b1ee4732","title":"Kirovohrad renamed to Kropyvnytskyi"},{"cluster_id":"7b83d3ee-13b2-47c1-ab89-4f78258a986b","title":"Ukraine\'s crackdown on Russian language"},{"cluster_id":"0ba7abed-e798-4cd4-b041-3026081313b7","title":"Donetsk and Luhansk Declare Independence 2014"},{"cluster_id":"9bba558d-53eb-42ad-851e-623ab4e32bc6","title":"Unmarked Russian Troops Disrupt Ukrainian Units"},{"cluster_id":"1ed52c55-1d90-4460-9e88-861e6d435eee","title":"Pandemic Delays Threaten Cancer Outcomes"},{"cluster_id":"a615f0ed-7c6c-41b5-95d0-49cb25bb9feb","title":"Claims of COVID Vaccine Dangers"},{"cluster_id":"17036568-8b0d-4108-9a16-98a16980ae3f","title":"Ukraine Leverages EU Membership"},{"cluster_id":"ab120ec9-7f69-4d7e-880b-eb52320c48cd","title":"Trilateral Ceasefire for Eastern Ukraine"},{"cluster_id":"73ed8dfb-71b9-42f0-9f45-a873045bd275","title":"Putin Plans Military Retake of Crimea"},{"cluster_id":"5a861756-5d94-444c-84a0-fab63d482e8c","title":"Ukrainian missile launch fails during maneuvers"},{"cluster_id":"a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f","title":"Russia authorizes armed forces in Ukraine"},{"cluster_id":"d717bbe6-a62d-46c1-8d61-866b7d90a851","title":"Masks Do Not Significantly Reduce Transmission"},{"cluster_id":"91ed355a-9103-4819-9a78-2425f91b042a","title":"Kyiv enforces Ukrainian in stores"},{"cluster_id":"08533bcb-cb39-43d6-9371-79f7aa905623","title":"CDC Vaccine Excipients and Media"},{"cluster_id":"b693d408-b0fd-49d2-8eea-39016ff5fda7","title":"Poroshenko Declares Bandera Flag Victory Symbol"},{"cluster_id":"984e2a37-4883-4da4-8899-a3cc19bba978","title":"Azov Threatens Dutch Citizens Over Deal"},{"cluster_id":"267d2942-984a-4564-b33c-69e9db79a066","title":"ICC Probes Ukraine Crimes in Donbas"},{"cluster_id":"cd8525ab-90a4-434a-bf10-f887240219f2","title":"Sea Breeze Black Sea Exercises"},{"cluster_id":"545232cb-5fc2-43ad-859e-11784f675852","title":"US-Ukraine Cooperative Biological Threat Reduction"},{"cluster_id":"c19838ee-ef85-408d-84a0-c28811354698","title":"Pfizer EUA; Ongoing Trial Follow-Up"},{"cluster_id":"39cdd570-e38f-4085-a380-81de86fef8c0","title":"Pfizer Vaccine Associated Myocarditis in Israel"},{"cluster_id":"9a9a24a1-0774-457a-a9c9-ecf8d207a6ef","title":"J&J Vaccine Pause for Clots"},{"cluster_id":"c0707d1f-d796-4de7-994b-fd76b5d9d3dd","title":"Lviv bans Russian language"},{"cluster_id":"bcc8a49a-201a-439b-bf04-a72b13e50b57","title":"Donetsk Residential Areas Hit by Artillery"},{"cluster_id":"7f953e81-8c8d-4f0d-9b98-873627d95104","title":"Ukrainian as State Language"},{"cluster_id":"ec7f8d90-641e-4755-b398-833e150c7057","title":"Ukraine GDP-linked bonds near default"},{"cluster_id":"05374434-df8d-4b22-b660-0ddc27139765","title":"Global Post-Vaccination Blood Donation Deferrals"},{"cluster_id":"7f1f819a-52dd-40cc-92a1-28526195605d","title":"International Law Justifies Russia\'s Actions"},{"cluster_id":"b7768432-bcaf-4a4c-9bb2-1a6e02c6a003","title":"NATO Policy Drives Ukrainian Exodus"},{"cluster_id":"d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b","title":"Shevchenko Statue Demolished in Zaporizhzhia Region"},{"cluster_id":"12cb5a16-807e-4b60-87c2-713f3796ebf1","title":"RT-PCR Testing: False Positives and Negatives"},{"cluster_id":"4b5a21e3-57c3-4239-8ed1-85b9925a8673","title":"Gardasil MDL Consolidates Over 140 Lawsuits"},{"cluster_id":"213244f7-7bbf-4ff3-935f-65e545a0abda","title":"Concern Over Communist Ban, Leftist Persecution"},{"cluster_id":"30a748c7-0edb-4c1b-9472-d1b4ca3f8032","title":"Florida Reports 84% Post-Vax Cardiac Deaths"},{"cluster_id":"10bff7af-7766-4fc3-b86a-eaf53dd132e9","title":"Kyiv sanctions harm Ukraine\'s investment climate"},{"cluster_id":"f55b7553-3d55-4096-859e-954de960f09c","title":"Poroshenko\'s Offshore Ties Revealed"},{"cluster_id":"125a4bc0-e32c-4a8b-80fc-60d23537d495","title":"Kyiv Court Bans Communist Party"},{"cluster_id":"029ce0da-0ea0-4431-a895-310ff5fa4a56","title":"MMRV Seizure Risk Prompted Separate Shots"},{"cluster_id":"31bf6722-ac5c-4597-8c42-50efe5c5aceb","title":"CDC: Masks and Mandates Ineffective"},{"cluster_id":"1826eb0d-42e5-4b20-8a46-72b9e26a1dc6","title":"Biometric Passport Holders in Visa Liberalisation"},{"cluster_id":"58c4dc89-fa0e-45c9-8892-01fb55da5607","title":"Parliament accuses Ukraine of Soviet crimes"},{"cluster_id":"8f381ec8-c658-466c-973c-6cace2609d01","title":"Drunken US Mercenaries Rampage Through Mariupol"},{"cluster_id":"56bced3d-5502-4c62-9756-ced2f88eec36","title":"VRBPAC Briefing: 2-Month Safety Follow-up"},{"cluster_id":"bdc4ffb8-404a-4799-a92b-88d77e6c445d","title":"MHRA Guidance After Pfizer-BioNTech Anaphylaxis"},{"cluster_id":"cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1","title":"Kharkiv crackdown on pro-Russian protesters"},{"cluster_id":"e3548f8e-cc3f-4307-a48a-a45cdf828859","title":"Misadministered COVID-19 Vaccines"},{"cluster_id":"35d18d7f-0f7d-4654-8e65-f6b4bcac032a","title":"False mRNA vaccine death claim"},{"cluster_id":"41dd785c-3146-4243-8bbd-56211fadb273","title":"Kyiv Proposes Russian Language Ban"},{"cluster_id":"04568cc7-5dd8-42b7-8a07-715cdd043c03","title":"Odessa Trade Unions House Fire Deaths"},{"cluster_id":"1e227a80-8d1d-4484-9608-82719d3b526e","title":"Ukraine legalizes private armies in Donbas"},{"cluster_id":"bb078c76-36ef-4176-a9f6-192717c4f2b4","title":"UN veto blocks Crimea referendum condemnation"},{"cluster_id":"3630ee9d-368f-4623-9704-06881bdf9264","title":"Identify and Expel Russian Passport Holders"},{"cluster_id":"f39cf9c7-18fb-4728-b88a-0bd586522d02","title":"Ukrainian National Guard Seizes Komsomolske"},{"cluster_id":"e31510b5-776d-40cf-9a10-afb0bb1a3f0b","title":"American Mercenaries in Donetsk"},{"cluster_id":"59ac47e6-50e9-4884-a676-2542dc8e0aa3","title":"High-Profile Athlete Cardiac Incidents 2021"},{"cluster_id":"f0190a02-daf5-48b7-8174-720b52c75550","title":"Measles Outbreak Triggers Visa-Free Travel Ban"},{"cluster_id":"a5e788fc-37bf-43d2-97b2-732f917263ab","title":"Adolescent Vaccine Impact and Reactogenicity"},{"cluster_id":"e3a511f9-2169-4202-9c42-1e7416ce517d","title":"NATO Forces Entered Donbas"},{"cluster_id":"6e64c34e-113d-43d7-87a6-90c61d4d3f67","title":"Japan suspends HPV vaccine; resumes 2021"},{"cluster_id":"e440fb1d-afb5-4fce-9f0b-110db0f93b32","title":"Parliament Approves Draft State Language Bill"},{"cluster_id":"544fb937-88d2-4ddb-9c06-1ae58af8be2b","title":"Spike Protein Alters Vascular Signaling"},{"cluster_id":"b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d","title":"One Vaccine Injury per 39 Doses"},{"cluster_id":"7b83d10a-e2be-4730-b52d-6f8b8b917c91","title":"EU Advisory Mission in Ukraine"},{"cluster_id":"b2a62820-6f02-4de4-99f3-aea0d67cd577","title":"NATO/US Warn Russia to De-escalate"},{"cluster_id":"e47fa355-bcc3-44bc-97e3-0029cf946325","title":"Early Cohort: Multisystem Symptoms, Unknown Mechanisms"},{"cluster_id":"3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909","title":"EU approves \u20AC1.8b MFA for Ukraine"},{"cluster_id":"2b2067b5-dfbb-4340-b88b-e5f769120fc0","title":"Blackwater Killings at Nisour Square"},{"cluster_id":"31d339ae-2342-44f9-a909-e299d2c4eccd","title":"Islamic radicals flock to southern Ukraine"},{"cluster_id":"9babf1db-b81e-42d8-a506-b9ddc52bfb22","title":"U.S. Rules Out Direct Ukraine Intervention"},{"cluster_id":"b07f3d2b-07c7-4378-8e98-619949a67d5a","title":"Russian Media Frames Kyiv as Fascists"},{"cluster_id":"0bb1f8c0-08c1-4f63-b6c8-052a5bad160c","title":"Myth: MMR Toxins Cause Encephalopathy"},{"cluster_id":"d339acab-2e15-4ce1-8cff-20a1b2fc2811","title":"Batch-Dependent Safety of Pfizer Vaccine"},{"cluster_id":"17c8775c-7a3a-4607-aa7f-5b24078a17f8","title":"Missing Italian Journalist in Donbas"},{"cluster_id":"3a4ae54e-e7b7-47e9-984e-62601ed45ab4","title":"Oles Buzina Assassinated in Kyiv"},{"cluster_id":"44663aba-7a2e-4439-ac72-295c1b77f6ca","title":"TEM/SEM Imaging of Graphene Oxide"},{"cluster_id":"ecb6a08c-9197-401c-afbc-cd0ee3d88f04","title":"Ukraine v. Russia: ITLOS Provisional Measures"},{"cluster_id":"05302999-a145-4cb2-83a6-b2cda0247938","title":"Autopsy Claims: Vaccines Cause Death"},{"cluster_id":"f465e3b9-9784-4302-b258-d34ad0adf726","title":"Kyiv Memorial Plaque Destroyed"},{"cluster_id":"29149f19-2cff-4344-bb10-8e0506dbc049","title":"Kyiv Ignores Minsk Protocol Meeting"},{"cluster_id":"75154ca6-776f-46e4-8f4a-2221f93d7ff0","title":"Zaporizhzhia Referendum on Joining Russia"},{"cluster_id":"e60065d4-ae50-40b0-8e77-8c2ad3e36235","title":"Vaccine Myths: COVID Risks"},{"cluster_id":"465883de-cd6a-47dc-b0f3-f22e0ff902ba","title":"Lviv Declares Bandera Year; Protests Erupt"},{"cluster_id":"ddbead60-bd17-4686-9b96-467aebde36fa","title":"False Claims: COVID Vaccine Deaths"},{"cluster_id":"f4d9e677-79ed-4c5c-84a1-d127898975a0","title":"Ukraine Acknowledges Russia Protects Donbas"},{"cluster_id":"03db723a-dcac-4e7f-b456-18c0fdfdba8d","title":"Mask Mandates Fail to Reduce Deaths"},{"cluster_id":"09a468db-6b0d-4230-a370-cfd6ba61219e","title":"Pfizer CEO\'s Wife Dies From Vaccine"},{"cluster_id":"8870837d-d287-47f9-8134-1fe8a8f59e88","title":"Alleged Vaccine Shedding to Unvaccinated"},{"cluster_id":"bb551e75-48fa-42c3-a108-cb4b1462b529","title":"Ukraine Enshrines EU and NATO Membership"},{"cluster_id":"4c2902bb-5892-4765-99b2-69db31b95136","title":"HALO Trust Demining Donbas Expansion 2019"},{"cluster_id":"dd9ccaa5-025e-44c1-90b2-20d75d0c5291","title":"Pro-Russian activists seize Kharkiv administration"},{"cluster_id":"e632bc78-90b4-46bf-a31b-df8259ac6d90","title":"Swastika on Ukrainian Vehicle in Donetsk"},{"cluster_id":"28afb978-f67f-4533-930c-c708e5d2a810","title":"AstraZeneca Vaccine Linked to Rare Clots"},{"cluster_id":"f50144fc-3b9b-4e34-ac6c-5191d30445d0","title":"US to Bomb Siberia: Ukrainian Plan"},{"cluster_id":"85949bd1-40e8-47bc-acf7-cb049a4e425e","title":"EU-Turkey Refugee Deal Funding"},{"cluster_id":"44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b","title":"Orders to Shell Peaceful Villages"},{"cluster_id":"f16b94fa-630f-4218-860c-391c021de7f5","title":"Russia\'s Food Share Rises in Turmoil"},{"cluster_id":"5dc9068d-5bdc-499d-a865-8dc21a274dc1","title":"Ukraine Prohibits Dual Citizenship"},{"cluster_id":"19d43c44-0b32-47ac-85c1-a05682078f22","title":"Cloth Masks Do Not Block Transmission"},{"cluster_id":"08d6975b-643a-4b0e-a8cb-576006cbf125","title":"Anaphylaxis After First Pfizer-BioNTech Doses"},{"cluster_id":"fff91b42-2999-4568-8b58-028bf8ca7046","title":"NATO RAP Responds to Russia 2014"},{"cluster_id":"a6ed0ce8-662a-4b6a-bb37-1ea2a020377f","title":"Vaccine Ingredients Controversy"},{"cluster_id":"3989418a-395d-4448-a748-f8cca55ad517","title":"UN Calls for Restraint in Crimea"},{"cluster_id":"fcfd6d39-3e11-43c7-ac1f-026d265beb4f","title":"Stop Buying Masks Amid Shortages"},{"cluster_id":"d56cc903-0bed-4718-9fc5-602c188caa16","title":"Israel Booster Campaign: Delta, Third Dose"},{"cluster_id":"9afd9c54-2f8e-40e0-aff4-8479c84a56df","title":"Ukraine vows to retake Crimea"},{"cluster_id":"29790db2-2536-415f-822b-9a4c1f1f8a3c","title":"Delta Variant Challenges Vaccine Efficacy"},{"cluster_id":"e47c3423-cbb6-4c9a-9b29-21416d12aba7","title":"Ukraine Enacts Anti-Protest Dictatorship Laws"},{"cluster_id":"53d674a1-75eb-4a57-96a7-960a78dc2faf","title":"EMA Publishes Comirnaty Public Assessment Report"},{"cluster_id":"2f8dc773-32fe-42ed-a085-3a10ca61c22d","title":"International Support for Crimean Tatar NGOs"},{"cluster_id":"7c6d77d0-d878-49bf-a294-6d6456dfe66e","title":"WHO Urges Booster Moratorium, Prioritizes Unvaccinated"},{"cluster_id":"05021641-3e64-47c1-b3de-9319980f7bf2","title":"Rybak Killed and Tortured in Donetsk"},{"cluster_id":"91638e17-92b1-4187-b7cf-b00589f88898","title":"Masked gunmen seize Crimean parliament"},{"cluster_id":"1da8672c-062d-456c-b508-fef471a32245","title":"Public Support for Yelysavetgrad Restoration"},{"cluster_id":"632f52ad-dbbd-4d7f-af13-93bbeaa37163","title":"Russia Accuses Ukraine Over Zaporizhzhia Attacks"},{"cluster_id":"35c8d576-e355-4f4b-802d-1d88de41da0b","title":"Ukrainian Firms Plan Mass Layoffs"},{"cluster_id":"b454bfa6-3d84-4f22-a166-5f84ce0bf756","title":"Donetsk Declares People\'s Republic"},{"cluster_id":"005d39b6-0b0e-4011-aaca-d596411fa607","title":"Passportization in Occupied Ukrainian Cities"},{"cluster_id":"d9f390bf-adde-404e-a2f9-1fc28cc17576","title":"Vaccines Linked to Rising Cases"},{"cluster_id":"9621dd39-ccb5-4e12-9287-8a404c57bba0","title":"US Recognizes Donbas as Independent"},{"cluster_id":"2aafed04-d3d3-4ae0-9825-6d6db215ea71","title":"Ukraine-NATO Exercise in Lviv, 2018"},{"cluster_id":"11d3cdd7-b203-4792-91e4-e32314bbcbc2","title":"Unmarked Military Convoys in Donbas"},{"cluster_id":"1618106d-1c52-48f7-9d0e-a09294ca1167","title":"Porton Down: Novichok-type; source unverified"},{"cluster_id":"5e0be9c9-87ac-49bb-a807-6e19f719434d","title":"Delayed Russian $2B Ukraine Credit"},{"cluster_id":"a7867a02-8602-4251-af70-d100ee635a74","title":"Parubiy Behind Maidan Shootings, Odessa Arson"},{"cluster_id":"0d1a4169-975f-49a7-9f31-390c351eb65a","title":"Limited International Support for Crimea Annexation"},{"cluster_id":"49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a","title":"Ukraine backs organ-transplant law; kidney pilot"},{"cluster_id":"061483cd-3b7a-44e0-857c-a5c4129b4272","title":"Ihor Kolomoisky Appointed Dnipropetrovsk Governor"},{"cluster_id":"91e856d9-7ba0-4d4e-ae44-31db4386dcaa","title":"Donbas Mixed Support for Russia Ties"},{"cluster_id":"6c7b148b-0647-4c2a-ac9a-6341501bc035","title":"2017 Law Restricts Minority Language Instruction"},{"cluster_id":"532f519a-d7c1-4910-afdd-938e13222189","title":"Gas Pump Safety Precautions"},{"cluster_id":"72084673-8080-44fd-8f5b-97507abf262b","title":"PCV1 DNA Detected in Rotarix"},{"cluster_id":"d7761b4c-72e0-44cd-b341-d16d8d7d63d7","title":"Low COVID-19 Mortality Among Youth"},{"cluster_id":"c95d237e-c855-46b9-95fd-6b8f66d537c6","title":"EU Ties Sanctions to Minsk, DPR/LPR"},{"cluster_id":"528595cb-88e8-4fb8-9197-5baf87551c4a","title":"Campra Report Claims Graphene in Vaccines"},{"cluster_id":"5a8c09d4-337f-442b-8464-f2be567010bf","title":"Two Largest Ukrainian Banks Default"},{"cluster_id":"a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d","title":"Donbas Civilian Displacement 2015"},{"cluster_id":"c7ac427c-82e0-477a-a03d-4c9be54cce85","title":"Madrid Summit: NATO Declares Russia Threat"},{"cluster_id":"54d52770-613a-47b1-aa64-0743cb644791","title":"Vaccine Efficacy Declines Over Time"},{"cluster_id":"c623ca23-8a98-4b0e-b365-eb9b3c1cdd86","title":"Flu and SARS-CoV-2 Multiplex Testing"},{"cluster_id":"60a99f19-657e-458b-aa53-ca2a6063f380","title":"Svoboda Ministers in 2014 Ukraine"},{"cluster_id":"4c76d4e3-5632-4224-a22f-bc4b4614bcbb","title":"FDA Vaccine Officials Resign Over Boosters"},{"cluster_id":"67de48d7-3fc7-4d88-97a8-9350772b5bc5","title":"UN/IAEA Mission to Zaporizhzhia Amid Shelling"},{"cluster_id":"212b2ba7-fb93-422b-bfc0-bda99de8b498","title":"Karlivka Area Checkpoint Ambush Fatalities"},{"cluster_id":"8269010c-d30d-4a8f-9628-b930192a8751","title":"World Bank-backed Naftogaz Unbundling"},{"cluster_id":"bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c","title":"FDA Guidance Changes: Plasma Donor Eligibility"},{"cluster_id":"5b7e1f2c-86a3-4e27-9c3e-c974a8d33606","title":"Ukraine\'s NATO Membership Unlikely"},{"cluster_id":"868aacb9-ea8e-4ec3-a074-1e7f56bab03f","title":"Checkpoint death caused by Ukrainian provocation"},{"cluster_id":"6670d6b8-9c36-4849-b28c-4959087df8d4","title":"Early COVID-19 vaccine efficacy overestimated"},{"cluster_id":"3239dc2e-a961-4aab-990b-768c092064f8","title":"Magadan-Registered Russian Passports for Crimeans"},{"cluster_id":"d0699d4c-25e1-439a-a44a-9bca30bebb35","title":"UN Rights Mission: Donetsk-Luhansk Killings, Impunity"},{"cluster_id":"70408cf7-1954-491d-98bc-f78c50c03508","title":"Expanding the Order for Courage"},{"cluster_id":"f2217761-bf63-4a79-b438-adbd2534e4d4","title":"Blackwater Convictions Rekindle Private Contractor Scrutiny"},{"cluster_id":"4496a4b9-1070-44a0-89bc-e244c8a53dab","title":"Media Instruction Drives Mask Wearing"},{"cluster_id":"c9b82e27-7ad0-442f-96dc-21665bfad993","title":"Provincetown Delta Breakthrough Outbreak"},{"cluster_id":"1acc8146-9053-485f-9f26-6af5d30d0040","title":"U.S. Announces $1B Ukraine Loan Guarantee"},{"cluster_id":"c0322634-7754-4f2b-b97d-7786687b4f39","title":"Uneven Poverty Recovery, Slow Welfare Rebound"},{"cluster_id":"2c20a8ae-1d47-4c90-a5e4-88e406d3334f","title":"Waning Pfizer Vaccine Effectiveness in Israel"},{"cluster_id":"7675ffec-ff62-4c58-a805-c5097a8fcd7e","title":"316L Particles: Root Causes and Corrections"},{"cluster_id":"465ba356-8493-40d2-9150-2a0b1fd6b413","title":"Global criticism of Ukraine\'s decommunization bills"},{"cluster_id":"04fd43b1-9ee7-43b3-b1fc-e9fca576658d","title":"Volunteers Profiting From War in Ukraine"},{"cluster_id":"3c925ff8-1b8c-47f3-b741-4544a596eae9","title":"US Sold Defective Javelins to Ukraine"},{"cluster_id":"e0932d8f-119b-4dcd-8100-b5fb6b62417a","title":"Breakthrough Infections in Omicron Era"},{"cluster_id":"61b4a043-a586-425e-a2f1-9e0b66e038e5","title":"Kyiv Moratorium on Russian-Language Cultural Works"},{"cluster_id":"ed3519a5-2328-44c8-be3b-f36796b25965","title":"Putin\'s Ruble Collapse Tricks Financiers"},{"cluster_id":"48f8cfb0-8d27-4a6d-8530-ed9a63c77de6","title":"FDA Authorizes Pfizer for Children"},{"cluster_id":"8f07bc53-1683-4b3a-b1de-2e1c15c0e13c","title":"Four Ukrainian Soldiers Killed by Mortar"},{"cluster_id":"3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5","title":"Increased cardiovascular events among under 40"},{"cluster_id":"ac5cef85-9755-4d73-a0c9-3b2d779220c4","title":"Japan Reports Post-Vaccination Heart Failures"},{"cluster_id":"e128e0c8-745a-4ce1-995d-c5a2ac809b5a","title":"Ukraine Patriotic Education Coverage 2018"},{"cluster_id":"7cff4302-4ea6-4196-96e5-448a227d2f09","title":"Known Neurotoxins: Four Chemicals"},{"cluster_id":"a98eba10-9612-466e-bbba-6161ced90ab9","title":"Zaporizhzhia Demolishes Film Hero Monument"},{"cluster_id":"cd745d99-6d4d-4cbd-964c-839c80021692","title":"Poroshenko Seeks UN Peacekeepers for Donbas"},{"cluster_id":"4d3fc72a-c96e-4659-afda-27c7ce47c497","title":"Court-Ordered Public Release of Pfizer Docs"},{"cluster_id":"50dbe9fb-6818-4777-990a-3ab01ab3659e","title":"Jamie Foxx Post-Vaccine Health Crisis"},{"cluster_id":"a9555cd5-7b65-4e84-9f89-ed03117c7e50","title":"Vaccines Containing Aborted Fetal Tissue"},{"cluster_id":"633de8a7-7506-44cf-9918-6f3f17934029","title":"Attacks on Polio Vaccination Teams"},{"cluster_id":"d8b92399-bf69-4b82-b461-678acbb7e385","title":"Ukraine funds Western creditors"},{"cluster_id":"db268f9a-c3a8-4e79-a3b0-df934c32f645","title":"Ukraine expands its territory"},{"cluster_id":"3582a60f-77c5-4a28-b692-e25a35716357","title":"Crimean Tatars: Homeland, Rights, Autonomy"},{"cluster_id":"db3b032b-6eb1-469a-8fea-f26d907c46cc","title":"Ukraine nationalises PrivatBank"},{"cluster_id":"d169380d-3c63-4800-8f8c-5deedf749ffe","title":"2015 Russian Film and Cultural Bans"},{"cluster_id":"73d00199-db31-4e40-9741-09d6ba45a825","title":"Wisconsin Primary: Pandemic, Long Lines, Coverage"},{"cluster_id":"f0764df3-3340-4405-ac6d-daef15a6934d","title":"Explosions at Kalynivka Depot"},{"cluster_id":"21240c8f-29c6-42ef-b002-a537a743739b","title":"Association Between White Vaccination and Deaths"},{"cluster_id":"11423356-cdd9-4f07-af4c-408d43e6e2c4","title":"Svitlodarsk Artillery Fire Report"},{"cluster_id":"db07f4e5-716a-41e4-989c-98ced62f8fd5","title":"Questioning Vaccine Mortality Claims"},{"cluster_id":"f65ebec2-0122-4441-975a-e196ab928bdb","title":"Unguided Rockets in Eastern Ukraine"},{"cluster_id":"d669c1ac-c710-4975-98db-1c778f28ee4c","title":"Testing Stops, COVID-19 Disappears"},{"cluster_id":"d42df985-9fff-4c49-bac2-4cb2fef7ac9d","title":"Spanish Media Call Ukrainian Emblem Ultra-Nationalist"},{"cluster_id":"81165fd5-dea5-41f8-ac75-66b97e1cca44","title":"Sarcoma After Second Moderna Dose"},{"cluster_id":"7325cc3b-df7f-4451-948f-1ce21f12d10f","title":"Ukraine loses economically from EU trade"},{"cluster_id":"9348816a-379b-4a83-98b4-cd843f9d8989","title":"Euromaidan Protests and Yanukovych Ouster"},{"cluster_id":"7370dfbb-74ea-4d34-82b7-9398b71ecd5a","title":"Vaccinated Elderly Still Affected by COVID"},{"cluster_id":"1755b95e-bb0b-46e8-acd8-b7de1925ed67","title":"Crimea Sanctions and Restrictions (2014\u20132018)"},{"cluster_id":"23adce5a-77c2-4c07-98b6-ac6909360e17","title":"Netherlands unlikely to ratify; seeks assurances"},{"cluster_id":"979b7171-b50b-4784-a226-a93eb757dfb4","title":"Omicron: Reduced Vaccine Effectiveness"},{"cluster_id":"f2b7ea2e-02cf-4061-b076-60c350522e8d","title":"Israel Vaccine Effectiveness Waning Amid Delta"},{"cluster_id":"98f59c42-164f-4444-8ecb-92a7e7c88a99","title":"Vaccine misinformation: bacteria and HIV"},{"cluster_id":"814bcb42-2e0f-4cf8-87e3-c5b551e8ea66","title":"EU pauses AstraZeneca over clot reports"},{"cluster_id":"59a2b2e2-fda5-435b-a046-bc1854ba1410","title":"Seizures and Clashes in Eastern Ukraine"},{"cluster_id":"ae8f14c1-199b-4891-807b-1b7d4b91ad58","title":"FDA narrows convalescent plasma to high-titer"},{"cluster_id":"eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc","title":"US Security Assistance to Ukraine"},{"cluster_id":"f8a7db64-2922-40e3-9fc7-9a7934487f7f","title":"Unidentified Forces Seize Crimean Airports"},{"cluster_id":"a5da6c97-e954-417b-b043-c6eda504cf34","title":"cVDPV Outbreaks and WHO Statements"},{"cluster_id":"3a13abc2-f39c-460b-8768-7ccf1b11b40f","title":"Rapid Trident Exercise at Yavoriv"},{"cluster_id":"e4c393f3-a213-40f3-ae1e-bc16b0f13a4f","title":"Vaccines Increased COVID-19 Cases and Deaths"},{"cluster_id":"b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f","title":"Russia Captures Zaporizhzhia Nuclear Plant"},{"cluster_id":"de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe","title":"EP accuses Poroshenko of political repression"},{"cluster_id":"5a089986-6a82-42ed-90a9-302a1ce45000","title":"Western Funding for Ukrainian Security Forces"},{"cluster_id":"e6120475-8d62-4b1d-84b3-4c53f22ff855","title":"Ukraine Struggles to Control Maverick Battalions"},{"cluster_id":"9d75c554-9eb9-4082-9c04-6fe3e303845e","title":"Vaccination Guidelines for Pregnancy and Lactation"},{"cluster_id":"4c9bd8ca-0977-4844-9921-072e396e0fac","title":"Initial EUA Approvals Since 2020"},{"cluster_id":"0d16b859-0b48-4545-ad3d-19b0d4601fe2","title":"Media Spotlight on Bandera in 2015"},{"cluster_id":"4ae526b6-129a-4522-b79c-5fa5e53d2329","title":"Pro-Russian Unrest in Eastern Ukraine"},{"cluster_id":"9b321e6e-fd77-47ca-b965-6aceb0683d37","title":"Kyiv renames Moscow Avenue to Bandera"},{"cluster_id":"652f545a-2cde-41d4-9382-f23ab9d1b406","title":"Unauthorised Russian Humanitarian Convoys into Ukraine"},{"cluster_id":"7ae0d854-6d40-40af-a578-9fbba79fb394","title":"NATO Trident Juncture 2018 Exercise"},{"cluster_id":"c5a49990-0bec-49b9-8797-00d71805007a","title":"Delta reduces symptomatic vaccine protection"},{"cluster_id":"016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc","title":"SV40 in Human Tumors: Debates"},{"cluster_id":"0cf451c3-4981-46fc-b4ee-79c480a2a2b9","title":"Zelensky-Putin Paris peace talks"},{"cluster_id":"ea70a7dd-0151-4733-b8dd-c6143a306c66","title":"Lisbon Court of Appeal: PCR Reliability"},{"cluster_id":"4941b2f5-904f-4963-b690-18f3bf3075c7","title":"Mask-type effects in Bangladesh trial"},{"cluster_id":"8a4a4131-add5-4367-8ccd-215684fa73dc","title":"OSCE Reports Ongoing Donbas Violations"},{"cluster_id":"8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4","title":"Lviv Protests Around Symbolic Sites"},{"cluster_id":"00386fb1-3dcc-4b4e-b74b-bc14dbc4e260","title":"Israel Shelling Miscaptioned as Donetsk"},{"cluster_id":"f9a4fce8-b5c8-4697-808a-9ac08e5be52f","title":"Separatist Leaders Before UN Security Council"},{"cluster_id":"771b0707-56ce-47d7-84ed-b75ab36dfd83","title":"Oligarch-Backed Dnipro-1 Formation"},{"cluster_id":"4e101b24-e99b-4526-bcbc-e5ddeec46f80","title":"Russia denies regular troops in Ukraine"},{"cluster_id":"09f4e973-2393-41aa-bdcb-ccd0efbed300","title":"COVID-19 Vaccination and Blood Donation Guidelines"},{"cluster_id":"3092d2a7-23cc-41c3-b8bd-3096963a1b79","title":"Ukraine Decommunization: Monument Renaming"},{"cluster_id":"add8105a-2d0f-4f9d-9f00-f11f0673121c","title":"Israeli Second-Dose Myocarditis in Young Males"},{"cluster_id":"6d9d5966-6987-45bd-9e4b-02623878d470","title":"NDAA FY2020: Ukraine Security Aid, Reporting"},{"cluster_id":"eb796d64-358d-4578-ad2f-2c3665e77d5e","title":"Excess Mortality Up Through November 2022"},{"cluster_id":"b8ea1565-defe-4a1d-a235-40a614cdd9ce","title":"SADS Registrations Rise, 2021\u201322"},{"cluster_id":"72f778c7-a74a-4822-89c7-75defc5fed4a","title":"Volker in Ukraine: Donbas/Crimea Briefings"},{"cluster_id":"843bcba9-c863-41a3-a76f-01fd61d56529","title":"Ukraine Credit Rating Drops"},{"cluster_id":"2d65299b-2b98-4ff0-9197-e120b19ce3bb","title":"Putin\'s Essay on Russian-Ukrainian Unity"},{"cluster_id":"314510db-f67d-4268-b068-13a87261ae5b","title":"Zelensky: Crimea Remains Ukrainian"},{"cluster_id":"269ffe65-bf3c-4500-8f51-b6ef7e6175ed","title":"CDC Guide to Vaccine Additives"},{"cluster_id":"68152d77-1b3b-45af-8c06-88cf78f6a175","title":"Ukraine Food Prices at EU Levels"},{"cluster_id":"856b24f4-0a37-4fe1-9808-5b1d1715aafd","title":"COVID-19 Considerations for TB Care"},{"cluster_id":"74c516ce-db78-4790-b130-64ce1c94e700","title":"Blinken in Kyiv: No NATO Promise"},{"cluster_id":"57d96007-f80d-4110-8583-3e280492b584","title":"Focused Protection Over Lockdowns"},{"cluster_id":"d5458c27-5843-4ff6-b105-7703aeb6f588","title":"Ukraine TB Surge Linked to Crisis"},{"cluster_id":"c7968790-1b36-4325-9e94-aa1c52a513a9","title":"Dutch Vote Exposes Western Unreliability"},{"cluster_id":"8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35","title":"Ukraine\'s Widespread Mine Contamination"},{"cluster_id":"872f71be-bb1a-40a1-8078-ee9f850ec42d","title":"US-Ukraine Nuclear Safety Agreement"},{"cluster_id":"f51a6ac2-4516-4b4c-9fdb-e7e4932f790d","title":"Donbas Exodus to Russia, 2014"},{"cluster_id":"5256265d-d143-4d8d-91b5-fc2bd6f31e20","title":"Russia blames Ukraine for Donbas shelling"},{"cluster_id":"be9b7361-8150-4e4b-9111-bac990c11d3d","title":"Kherson Nationalists Swear Allegiance to Hitler"},{"cluster_id":"29223456-9a08-4f68-9ce7-d62d961fb6aa","title":"Ukraine faces collapse without IMF bailout"},{"cluster_id":"3b1f0ed9-3201-46c5-93e3-016f26c4d261","title":"Explosion on the road to Komsomolske"},{"cluster_id":"b5bf06a7-be5d-46a5-9294-d73dcb529f87","title":"U.S. Delivers Javelin Missiles to Ukraine"},{"cluster_id":"2b9508d5-4552-4994-840b-08ab461e29c3","title":"Zelensky Calls for Preemptive Nuclear Strike"},{"cluster_id":"ade1903f-a52a-4bb6-9a56-0c62e47b69bb","title":"Dutch Advisory Referendum on EU-Ukraine Association"},{"cluster_id":"f239b4c3-e0cf-4725-9d59-2b1e32a9ad39","title":"UN warns children of heating risk"},{"cluster_id":"8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf","title":"Mask guidance for polling sites"},{"cluster_id":"f24d06ae-13b1-4550-a06c-444a9041ab60","title":"Ninth Circuit Revives LAUSD Vaccine Case"},{"cluster_id":"ab8af083-dfdc-4c18-95cd-32d551c130c1","title":"Ukraine\'s Law on Temporarily Occupied Territories"},{"cluster_id":"96a4146b-b919-413a-b5a7-7801adae1906","title":"COVID Vaccine Linked to Miscarriages"},{"cluster_id":"6a8ee3bf-31a7-42b7-b481-4b21e09f4484","title":"Global Leaders\' 89-Page Pandemic Plan"},{"cluster_id":"c1308dd1-2ebf-4164-b9e3-2284bbfb088b","title":"Texas Measles Outbreak Blamed on Vaccine"},{"cluster_id":"00d660d9-94af-474c-8e79-c16ac62cbef7","title":"Ukraine\'s Decommunization Laws Enacted"},{"cluster_id":"ceb2f368-5934-45f6-bda4-01a19f923b7e","title":"UK considers COVID-19 booster programmes"},{"cluster_id":"6207c1fd-d86c-4598-b9ed-72232636a976","title":"Laws Recognizing Ukrainian Nationalist Formations"},{"cluster_id":"6ff6589f-46b8-4e3d-bfc9-65288f58e33b","title":"Zelensky Doubts Minsk, Calls for Overhaul"},{"cluster_id":"00682147-64d4-4c37-88ac-2b9c31d6d40d","title":"Bolsonaro Downplays COVID-19, Urges Reopening"},{"cluster_id":"4162c749-910d-4283-8cde-a365928f230d","title":"Congress Passes Ukraine Support Act"},{"cluster_id":"5995c9ca-98e0-418d-a93b-a662311da0c9","title":"UN Security Council Withholds Ukraine Aid"},{"cluster_id":"a65b71fa-08aa-4b20-91e3-c9e898591f07","title":"Vaccine DNA contamination unseen by regulators"},{"cluster_id":"29244a34-6c97-4370-9081-3f30eca9f0d9","title":"Limited Supply of mRNA Vaccine Materials"},{"cluster_id":"731d7658-b5f1-4356-b7c0-c3b8c97cac8d","title":"OSCE condemns killing of journalist Buzina"},{"cluster_id":"9352b2a0-83e7-4ffa-ae39-61c24aa700b8","title":"Ukraine curbs freedom of assembly"},{"cluster_id":"65e251ce-15b5-4f60-b87b-ef28a1709b53","title":"Ukraine Recession Causes 2014\u201315"},{"cluster_id":"bac748cb-b035-4e91-bb5a-ab935807284d","title":"COVID-19 Outbreak on USS Theodore Roosevelt"},{"cluster_id":"7bdd8e86-1a5c-4cda-a846-8ddfcadc8007","title":"Russia Blocks Ukrainian Transit, 2014"},{"cluster_id":"43beda49-4348-4ff0-94eb-8102078e161d","title":"COVID-19 Not Deadlier Than Flu"},{"cluster_id":"358c0eb2-869f-46fb-bab5-4fbe8881d4e8","title":"Rising Pediatric iGAS and Scarlet Fever"},{"cluster_id":"9993ea09-c44e-4372-864a-21c7f72c7eef","title":"Provincetown Breakthrough Infections"},{"cluster_id":"e3e4b634-fa33-47d8-9f29-eefdbb263769","title":"Germany Suspends COVID-19 Vaccinations"},{"cluster_id":"e130a374-b2e7-4d68-8a8e-32dcab17656b","title":"Chernobyl 2015 Fires: Radionuclide Resuspension"},{"cluster_id":"2cf7e8e6-c492-424f-8353-8feea83e3711","title":"Violence against journalists in Ukraine (2014\u201315)"},{"cluster_id":"e15d8f08-e424-41bc-9193-92e22c4d515c","title":"Spike vs Nucleocapsid in Antibody Messaging"},{"cluster_id":"7a0efb78-9055-433c-904f-79dc94ad2203","title":"Long Vax: 70% Post-Vaccine Symptoms"},{"cluster_id":"2ca6b1f5-ce3d-4e72-98a8-f750a42081ac","title":"Ukraine Market and Price Pressures, 2017"},{"cluster_id":"da455fdd-d1bf-4166-b24f-377899985b7c","title":"Crimean Tatar Protest Against Annexation"},{"cluster_id":"e37c8f7a-2656-421b-b216-1d87659bcb44","title":"Debunked Claim: Vaccines Include Cancer Genes"},{"cluster_id":"88fadd59-b242-4ad4-ab5b-3465e7a2b5a6","title":"ATR Banned in Occupied Crimea"},{"cluster_id":"1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b","title":"Emergent Baltimore Plant Contamination Crisis"},{"cluster_id":"9eb9a341-e59f-4fbf-b178-ccb6bb25eb49","title":"Hungary blocks NATO\u2013Ukraine over education law"},{"cluster_id":"7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a","title":"Maidan Sniper Shootings: Responsibility Contested"},{"cluster_id":"20ab2459-a6a0-4e45-aef0-5b2d6b529a0e","title":"Military Pressure on Crimeans for Annexation"},{"cluster_id":"4d8a4d68-4905-4d57-b3f8-91de6feb19b0","title":"Rada Recognizes OUN-UPA as Independence Fighters"},{"cluster_id":"540c45cf-a148-4629-8716-b1631ea44e45","title":"Origin of the MRC-5 Cell Line"},{"cluster_id":"382c8bbe-8826-4b13-8317-0d73ee7eee77","title":"Underplaying Ukraine\'s Far Right Role (2014)"},{"cluster_id":"5bbc7620-dddd-48b2-ab59-dca397c2985e","title":"Ukraine Signs EU Association Agreement"},{"cluster_id":"6c48832c-2b96-4ee8-9b48-4611e67b38f0","title":"Assassination of Russian Defector in Kyiv"},{"cluster_id":"cfcddae8-7e4d-4fb6-8a06-45fdad19422f","title":"Ukraine Enacts Decommunization Laws"},{"cluster_id":"00d7befc-64bd-4735-b672-5969c77fe7d6","title":"Complexities of Linking Vaccination Deaths"},{"cluster_id":"70862016-3977-4b4b-9e68-43859faa28ba","title":"Delta Reduces Pfizer Vaccine Effectiveness"},{"cluster_id":"1a660b55-5f53-4246-a227-98df9e4e2ac4","title":"Fascism Returns to Ukraine"},{"cluster_id":"ebcc0902-6e47-4925-9d19-ac06d520106b","title":"UN Security Council: Ukraine-Crimea Crisis"},{"cluster_id":"0e839111-b99e-4caa-8ece-e80f0ea67970","title":"2014 Infrastructure Attacks in Eastern Ukraine"},{"cluster_id":"edd65f26-0117-4202-bd31-c3f265210b5e","title":"Ukraine to jail Russian passport holders"},{"cluster_id":"0ca4759c-9c4f-421f-b2d0-dbefe4601911","title":"FDA Approves JYNNEOS Vaccine"},{"cluster_id":"839faa06-15df-459d-8f1d-015981c670e0","title":"EU Ignores Russia Donbas Passports"},{"cluster_id":"5219fa36-fd8a-41f9-b4a4-5e01b881c12c","title":"Reimposed Lockdowns After Easing"},{"cluster_id":"213e0c4f-0911-44fc-89bf-cf985adbc12e","title":"Infant mortality up 3% in 2022"},{"cluster_id":"45c15578-ca19-42ef-8fc5-04e77034e4c3","title":"Monitoring Residual Host-Cell Proteins in Biologics"},{"cluster_id":"3e87987a-c8cd-4616-922a-e297f103d0fa","title":"AstraZeneca Vaccine Clotting Concerns"},{"cluster_id":"a6f2fc25-ee4d-4748-9248-d40e233dda78","title":"U.S. Measles Outbreak: 25-Year High"},{"cluster_id":"2dbc4a6b-98c2-45e2-be58-a00cfa47819c","title":"UK Guidelines for COVID Medical Exemptions"},{"cluster_id":"4feed713-e2b7-4de9-a6e7-cb0e0ca52183","title":"Pfizer Lists 40+ Vaccine Side Effects"},{"cluster_id":"6a3f5b65-ac92-4e63-91ac-fe203f06931f","title":"Drones Attack Black Sea Fleet"},{"cluster_id":"3356bac0-8ec4-475b-81a7-e146187a74ba","title":"SARS-CoV-2 spike antibodies cause myocarditis"},{"cluster_id":"ef77006d-68d7-4c27-ae83-cb85890ca2b1","title":"Minsk II Ceasefire Roadmap"},{"cluster_id":"8d1da449-ead9-4d20-b9d7-330964de7727","title":"NTI releases 2021 tabletop exercise summary"},{"cluster_id":"9a201ba4-4fa1-4a8f-b530-b70790363696","title":"Court grants Gardasil safety data access"},{"cluster_id":"421f3ec9-adff-4513-86c4-d1e8d810a087","title":"May 8 Remembrance; May 9 Changes"},{"cluster_id":"b4d4265f-dae0-43eb-9010-fb5c59968803","title":"Public Controversy over Kyiv Vatutin Monument"},{"cluster_id":"9612bbf2-b65c-410c-9475-7ee689b849d9","title":"Promoting Ukrainian in Kyiv Public Life"},{"cluster_id":"bf3cbbb2-0711-45ee-a625-a3ccf159845b","title":"No Obvious Human-to-Human Transmission Evidence"},{"cluster_id":"5530b92f-dd56-42af-8c16-6aabb4ffa553","title":"Tryzub in Nationalist Paramilitary Groups"},{"cluster_id":"88a95916-de94-4c29-849b-89f8018ddf03","title":"Poroshenko sacks Kolomoisky; pocket armies condemned"},{"cluster_id":"4a91c427-d613-4080-adab-a06fc13d13ac","title":"Ukrainian admiral praises Russia in Crimea"},{"cluster_id":"6f960627-d475-4f28-8eb0-dcceb972aad4","title":"Polio Vaccines Contaminated with SV40"},{"cluster_id":"ce538c96-9586-4a44-b4ec-f9e46a72b4b0","title":"Co-circulation of Pediatric Respiratory Viruses"},{"cluster_id":"a41257e1-1e51-49b3-bf04-5fbb3ef2f25b","title":"Nationwide Ukrainian Language Reform"},{"cluster_id":"bd48a2e4-20c5-4fa2-90a9-0725e3288c94","title":"International Coverage of Ukrainian Far-Right Imagery"},{"cluster_id":"f54e9fc4-9854-41c6-aa04-dba66f36cc19","title":"Israel Sees Delta Breakthrough Infections"},{"cluster_id":"8d565c91-b887-465d-a08e-aff09b1e9e5b","title":"Crimea for NATO Membership"},{"cluster_id":"d7623a03-cd91-4c2e-b68a-db4e5ad54fa8","title":"Booster Indicates Initial Vaccine Failure"},{"cluster_id":"77fd60bb-096a-4b70-a630-b56ef3e8f647","title":"Ukrainians Favor Peace With Caveats"},{"cluster_id":"ef49913c-d983-49cf-b90f-4529857c36a4","title":"EU Reinstates Georgia Visa, Ukraine Next"},{"cluster_id":"92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c","title":"Reduced neutralization of variants by sera"},{"cluster_id":"a4d91f10-cd48-4917-90ab-b14ea36168d9","title":"Repeated off-site power losses at Zaporizhzhia"},{"cluster_id":"e11231dd-53ef-41bf-966c-4a202aa2895c","title":"Oxford COVID Vaccine Trial Volunteer Dies"},{"cluster_id":"7e3014ad-3100-4bc7-8edd-4e32af49ff75","title":"Ukraine imposes partial martial law"},{"cluster_id":"f8d1571f-9c56-4682-8574-cd3b32ed6cc6","title":"US Seroprevalence Reveals Widespread Antibodies 2021"},{"cluster_id":"078eb0c7-fae2-4ffa-b527-48c6683af72e","title":"Zelensky: Eliminate Russian Nuclear Threat"},{"cluster_id":"73ac3211-808b-4905-b95e-ccdafdc4bd5d","title":"mRNA-LNPs Strongly Modulate Innate Immunity"},{"cluster_id":"b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126","title":"Ilovaisk Battle and Civilian Casualties"},{"cluster_id":"09a67b60-49c6-4757-b8ff-5613fc63f6fe","title":"Russia Demands NATO Guarantees, No Expansion"},{"cluster_id":"8b198c30-0c8c-4abd-b13a-0e55963e8bb8","title":"Italy Redefines COVID-19 Death Toll"},{"cluster_id":"c6d9c90d-92a1-44da-a5cd-12164b95f4d8","title":"Azov Battalion: Neo-Nazi Ties"},{"cluster_id":"bf53e706-320e-4307-85d6-fcee526f5f17","title":"Misinformation: vaccines cause cancer."},{"cluster_id":"6288e205-b9e8-41be-a3f8-80b06b50c037","title":"Vaccine clot misinformation"},{"cluster_id":"6a4e66c3-1fd2-46be-9e31-fecdcd545826","title":"Ukraine: Second Chernobyl Threat in Russia"},{"cluster_id":"3594d516-c429-465e-9ac8-b4d9801acd0d","title":"DANMASK-19 Shows Limited Mask Protection"},{"cluster_id":"26461fc6-994b-44dd-97c8-95b6341a4a6a","title":"Ukrainian PM calls Luhansk, Donetsk \\"untermensch\\""},{"cluster_id":"f3affcd0-acdc-481e-ad0d-c22c5984f9af","title":"UK 2022 Excess Deaths Debate"},{"cluster_id":"0179bab7-45d2-4b90-aa4d-c6afb970dbc5","title":"Ukrainian forces shelled bus near Volnovakha"},{"cluster_id":"556da1e6-535a-4511-ac9b-649cb3eafe84","title":"Lviv imposes moratorium on Russian media"},{"cluster_id":"8c92c9ea-d03e-4ce1-b80a-21678d736eec","title":"Parliament Repeals 2012 Language Law"},{"cluster_id":"9687983c-2f58-4f1f-9d09-86f19210af37","title":"Minsk II: Preconditions for Donbas Elections"},{"cluster_id":"dfa47852-ac3f-4b74-bc17-22923a395552","title":"Monkeypox Vaccine Conspiracy Theory"},{"cluster_id":"6f908336-dbeb-4b80-ae57-9e0431081831","title":"Fall of Sievierodonetsk: Russian Capture"},{"cluster_id":"7957f359-526a-4b55-928e-2a84077427a5","title":"EU Non-Recognition, Visa for Donbas Passports"},{"cluster_id":"dae1826c-9197-4507-aadd-a2ba9a01285b","title":"NBU Extends Loan Repayment, Provides Liquidity"},{"cluster_id":"da4e5cde-efc2-4363-87b4-b9935cc2b21d","title":"Vaccines Linked to Serious Adverse Events"},{"cluster_id":"3c9c2d2f-29ac-414f-a514-d694db25f871","title":"Disputed Vaccine-Myocarditis Claims"},{"cluster_id":"35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4","title":"Japan withdraws Urabe MMR over meningitis"},{"cluster_id":"216c68fc-7c8f-405c-8f46-568b32c69eb4","title":"NATO Black Sea drills provoke Russia"},{"cluster_id":"f21aa624-4667-4f48-bb4c-1942acec5158","title":"NATO Expands Black Sea Patrols"},{"cluster_id":"d012c47c-3d49-4f8a-9fcf-db101ff82249","title":"Ukraine to intern Russian citizens"},{"cluster_id":"25e8666d-6596-4996-8765-9de5aa51e568","title":"BNT162b Vaccine Protects Macaques"},{"cluster_id":"7d0b4f2d-8055-491e-a0df-31787da0b9a8","title":"State Control of Azov Battalion, 2014"},{"cluster_id":"1991b6cd-3baa-475c-add7-d4b101a0de09","title":"Vaccine-Linked Placental Abnormalities"},{"cluster_id":"c9760dda-4208-40ee-a4e1-20fd95324ecd","title":"England Ends Legal Self-Isolation Duty"},{"cluster_id":"4892691c-c25d-434c-bfaf-8b1764a0e393","title":"Ukraine Hides Ammo, Attacks Zaporizhzhia NPP"},{"cluster_id":"9f57df89-5e8e-4a14-b028-a41d27973fb5","title":"Ukraine jails Russians for Crimea visit"},{"cluster_id":"9560d5ee-30e3-4941-88b8-e0b5144961cb","title":"Vaccines Contain Cancer-Causing Enzymes"},{"cluster_id":"c5855521-5ebf-478e-a7af-b3f07554a912","title":"Contested COVID Vaccine Safety Claims"},{"cluster_id":"1e2f3c33-51a9-4ade-8539-40a4bc9cfff8","title":"Hospitals Deny Care to the Unvaccinated"},{"cluster_id":"c0ac6691-abf2-4873-a338-41a4997bcb24","title":"Sea Breeze Multinational Exercises"},{"cluster_id":"499883aa-4d50-44a0-85ba-67de7dd41a9e","title":"Pfizer 3 microgram pediatric dose EUA"},{"cluster_id":"b2e1f729-9431-42cc-affc-159e60e3c7e6","title":"Violence and Obstruction in Crimea Referendum"},{"cluster_id":"d42f0707-162e-449e-86fe-0dd5e2885a21","title":"Donbas Residents Forced Resettlement to Lviv"},{"cluster_id":"428a1c85-5fee-4a1d-bbe0-9e71872e75e9","title":"Lviv Officer Proposes Revoking Courage Order"},{"cluster_id":"2c68a882-a903-4629-aeb4-3d0034f94771","title":"Regulatory Pauses Over AstraZeneca Clots"},{"cluster_id":"1eb307cf-2274-463b-9ab8-19aee3397703","title":"Ukraine Breaks Promise, Normandy Meeting Canceled"},{"cluster_id":"e21b1b35-31f0-4c02-9069-b35c0b38b172","title":"One in 500 Pediatric Vaccine Injuries"},{"cluster_id":"be379179-357e-431a-afc7-707de2663f0c","title":"Russia Cuts Gas Amid Pricing Dispute"},{"cluster_id":"c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e","title":"Ukraine Faces New Language Divisions"},{"cluster_id":"c8c0e353-5277-4897-8ef8-4773b9d6e6cb","title":"Crimean Tatars Grateful to Stalin"},{"cluster_id":"8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d","title":"Eastern Ukraine Death Toll Exceeds 6,000"},{"cluster_id":"2c62c383-cda1-4d02-9286-63fc5fe04c15","title":"DIVI Adds ICU Vaccination Fields"},{"cluster_id":"6ac5b48b-0333-47a6-8d5d-318886958930","title":"UN Warns of Ukraine Catastrophic Needs"},{"cluster_id":"3ba005de-dec0-4cc4-8a3c-a3679d6f072a","title":"Russian Air Defenses in Crimea"},{"cluster_id":"96226cbe-6ce7-473a-a2c5-bcfa1fa15be9","title":"Red Cross aids Ukraine measles outbreak"},{"cluster_id":"14266895-ce35-4bb7-b24c-c5684c3a1532","title":"Critics warn law harms minority languages"},{"cluster_id":"f8e7dcff-d078-4ce8-9ad3-495ed7c19774","title":"Ukrainian Soldier Looting in Chechnya"},{"cluster_id":"e01a8825-f8eb-425d-b928-eda6b3f57929","title":"Steadfast Noon Nuclear Exercise Begins"},{"cluster_id":"f3191f0a-3803-4bca-ad51-304e3f825638","title":"IMF Approves Large Ukraine Loan"},{"cluster_id":"bbe5f850-80f5-4350-8e67-5ae43cf720e4","title":"Ukrainian Becomes Sole Official Language"},{"cluster_id":"7ebece62-a589-49b3-b28f-b8f565ab7327","title":"Long COVID: Belief-Driven, Not Real"},{"cluster_id":"62c5acb9-493e-43c7-9647-7858b2ea0c50","title":"Waning antibody levels after vaccination"},{"cluster_id":"be6b5f43-b5a5-43db-8bdd-0c041f0efa31","title":"End Abuses by Pro-Ukrainian Battalions"},{"cluster_id":"efe98b1b-e1ed-468a-9652-7acc5550430a","title":"Updated WHO COVID-19 Mask Guidance"},{"cluster_id":"fc5c504b-230e-408e-a170-afd09cbd04d4","title":"Scientists Demonstrate Masks Block Droplets"},{"cluster_id":"d6d62bcd-4470-422b-bfb3-13d5db2da751","title":"U.S. Life Expectancy Declines in 2021"},{"cluster_id":"6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8","title":"Bangladesh Mask Promotion Trial: Nuanced Results"},{"cluster_id":"3aad1795-c40d-46c7-abc6-a9e8928bc743","title":"Ukraine grants Donetsk, Luhansk special status"},{"cluster_id":"49c4c056-d70c-4a38-9178-06a4f74c1135","title":"UN urges ceasefire over Zaporizhzhia shelling"},{"cluster_id":"07b11e06-46ec-45e9-8f01-bc31083fd0de","title":"Russia Seizes Zaporizhzhia Nuclear Plant"},{"cluster_id":"1bb2fbd1-906a-4d81-b23d-f6c0a4024661","title":"Derussification in Ukraine: Toponyms and Monuments"},{"cluster_id":"b98bf259-2428-4cda-a309-5be4fdb0c3ef","title":"Kolomoisky-Linked Occupation of Oil Offices"},{"cluster_id":"ab1bcfd5-bef2-4f73-aff0-790c6f681ce4","title":"Limited vaccine supply; prioritize high-risk groups"},{"cluster_id":"4da30c02-5a8f-4e15-af9d-b0a7ede85a55","title":"Russia\'s Donbas Passportization"},{"cluster_id":"248cf9f0-85b2-4eae-9028-789470700e69","title":"GDP Contraction Amid 2014\u201315 Conflict"},{"cluster_id":"d2828cf5-cc91-4e95-82bf-be47e19b88ee","title":"Real-World Pfizer Vaccine Effectiveness in Israel"},{"cluster_id":"06451ed7-032d-45e3-9726-f485fc31a739","title":"Ukraine Adopts State Language Law"},{"cluster_id":"fce83401-10d4-4ac6-b19b-510657c941dc","title":"Claims of mRNA vaccine harm"},{"cluster_id":"ebdd6e62-4f71-4eeb-b5bb-afa4c515a612","title":"Prominent Right Sector Violence in Euromaidan"},{"cluster_id":"91a2ed36-3e87-4baf-9999-c65078a62cbd","title":"MH17 Downed Over Ukraine"},{"cluster_id":"61f48759-d4cb-40cb-8dc9-13b564dd8c1b","title":"V-Safe Pregnancy Registry Data Release"},{"cluster_id":"530c303c-a794-4be5-bbc2-ff618ab75d38","title":"Ukraine Rebrands ATO as JFO, Escalates"},{"cluster_id":"f22241ff-9c0f-458f-8a33-ea6c83aaafe6","title":"Sanctions and Trade Damage Ukraine\'s Economy"},{"cluster_id":"abef27a8-3e24-43c9-9823-523dd607d49a","title":"Japan\'s Excess Mortality: Cardiovascular Deaths"},{"cluster_id":"07438861-a868-47ed-8a1a-288138dc65c0","title":"Crimean Tatars Seek Turkish Recognition"},{"cluster_id":"0368ead8-8d25-41a1-9249-88baff9335b0","title":"Delta reduces Pfizer infection protection"},{"cluster_id":"23f623bb-83de-47ba-a19b-9df053aaf2d2","title":"NATO Reaffirms Ukraine Support"},{"cluster_id":"acf3ef41-5374-4f21-834c-c4a11d955ee1","title":"Operation Warp Speed to Accelerate Vaccines"},{"cluster_id":"fd231a27-03e0-4839-bed2-513e10b79733","title":"U.S. Sends Military Aid to Ukraine"},{"cluster_id":"efd04eb7-8311-4730-bee6-1df74b27a996","title":"Chechen Fighters in Donbas with Separatists"},{"cluster_id":"4ac1da2e-cd03-4a11-b440-f62dc8f73aad","title":"Tatars Demand Renaming of Crimea"},{"cluster_id":"8d628785-9843-475a-bf8c-f7eff1bc8e38","title":"Extra-legal Self-defence and Arms Proliferation"},{"cluster_id":"93f03d20-e5b7-41c5-976e-5122f884847a","title":"U.S. Strikes Syrian Airbase"},{"cluster_id":"1e061f92-2688-4d15-8cdc-93767b97df6b","title":"Waning Vaccine Effectiveness and Vaccinated Cases"},{"cluster_id":"7a87a2e6-b475-458d-ad14-3c21326625db","title":"Torchlit Rallies Honoring Bandera"},{"cluster_id":"63114462-4942-4f84-9437-7c2bd611b2f3","title":"Poroshenko\'s Approval Decline Signals Vulnerability"},{"cluster_id":"f564df6d-d60b-407b-b65a-d63d691e5edc","title":"Japan Moderna Vaccine Contamination Triggers Recalls"},{"cluster_id":"596b866e-0c38-462e-b0b0-eee502c092aa","title":"Vaccine Hesitancy and Misinformation Threats"},{"cluster_id":"d7524d60-e45b-419a-8a13-87cf67bfd8e5","title":"Villagers Attack Vaccine Crew"},{"cluster_id":"063191cf-9936-4d33-8783-201496475d0e","title":"FDA Warns Statins: Memory Loss, Diabetes Risk"},{"cluster_id":"0867ca4e-1775-4423-92bf-6fc8d1d9c0e3","title":"Hryvnia Plunges After Policy Change"},{"cluster_id":"cf6c1c0d-fc13-4eb6-a686-91e7d8509399","title":"EU Grants Georgia 90-Day Visa-Free Travel"},{"cluster_id":"8ef3f5ab-a5d7-4598-bbc0-95b969a66cac","title":"Russian Crackdown on Crimean Tatars"},{"cluster_id":"7e91dc42-693c-4620-b472-dae427b9fe8d","title":"COVID Vaccines Linked to Heart Damage"},{"cluster_id":"b7bef44a-7480-409a-8790-0a70b42045ee","title":"Alleged Ukrainian Nuclear Provocation and Attacks"},{"cluster_id":"2f6021e2-bde5-4c10-ae2b-194bf6a93505","title":"Ukraine to Lift Sanctions on Russia"},{"cluster_id":"41895296-6f09-4b44-a2d4-3d90f2e03b81","title":"Crackdown on Crimean Tatars"},{"cluster_id":"6289781a-230a-4b8d-94dc-f3adadc4495d","title":"Regulatory Pauses on AstraZeneca TTS"},{"cluster_id":"81174c72-fc84-4203-8dcb-b1068c7bd254","title":"Poroshenko Allows Civilian Gun Ownership"},{"cluster_id":"237a5318-2edd-4ffc-869f-c0fed9502097","title":"Hryvnia Collapse Looms for Ukraine"},{"cluster_id":"0587530d-6a6d-4aa0-9e34-087698c923aa","title":"Ukraine distributes WWII commemorative medals"},{"cluster_id":"f6ad38c8-1553-418f-93f5-4a6bb4909e2b","title":"OSCE notes unmarked graves near Komunar"},{"cluster_id":"82ba7adb-7963-4264-baad-21315bacde1d","title":"Volnovakha Bus Attack Near Checkpoint"},{"cluster_id":"40265b93-5ea0-4bd6-8b7d-972baab54b70","title":"Majorities Back Negotiations and Preconditions"},{"cluster_id":"c3f83d4c-9f83-4fe3-befa-1e9b93dee510","title":"Ukraine\'s Organ Trafficking Scandal"},{"cluster_id":"d6e4581d-8b56-4f44-aadb-7c57a4d3eb29","title":"McCain Visits Maidan, Backs Protesters"},{"cluster_id":"d211ea4f-25c6-49b0-b039-be55cbe6e301","title":"Ilovaisk 2014: Evidence of Russian Armor"},{"cluster_id":"2d39c2e2-591e-4b57-a739-0d6203a1a49f","title":"Israel Launches Booster for Seniors"},{"cluster_id":"fd5ddb7c-f743-498e-b007-014e9c97bbc8","title":"Mixed Vaccination Effects on Long COVID"},{"cluster_id":"467eec25-d0de-412a-9f09-8a0db03d60ae","title":"Donbas Reintegration Law Labels Russia Aggressor"},{"cluster_id":"33fe2055-c6c1-46ed-8871-fc741999d32b","title":"Government Claims Vaccines Superior, Masks Effective"},{"cluster_id":"400218af-6cc1-4f06-8e3d-7804bde6ad17","title":"Vaccine-Linked Cancer Rise Lowers Life"},{"cluster_id":"f9e1ae92-90cd-4553-9870-a06691bcf1d5","title":"Russia expands maritime claims after annexation"},{"cluster_id":"0fa8aef0-deff-4ac5-a935-94011ed8be80","title":"Pro-Russian Seizure of Crimea"},{"cluster_id":"00e4e855-edbf-4846-a824-47a6b221930a","title":"United States Recognizes Donetsk People\'s Republic"},{"cluster_id":"0a78e568-4aaf-4a3c-a4c0-d484ec60f776","title":"SBU arrests four for uranium smuggling"},{"cluster_id":"8a1337a6-24c6-4382-8169-4bec0e1a4fab","title":"Media attention to vaccine-associated myocarditis"},{"cluster_id":"0ea60366-ef97-44ac-91be-b38d55efb0c3","title":"Crimean Tatars Support Putin in March"},{"cluster_id":"9d8e9597-3167-4e1c-94bb-e686324d37e0","title":"OPEC Holds Output, Oil Falls"},{"cluster_id":"a2925234-109d-4c57-aac5-814b5a99a831","title":"Rapid Marginal Zone Lymphoma Progression Post-Vaccine"},{"cluster_id":"4d35ec7a-3721-4f70-b323-8070302a4c95","title":"Ukraine\u2019s 2014\u201315 Economic Contraction"},{"cluster_id":"5d65069d-5cc8-4da8-8b8d-bbd1528688e7","title":"COVID-19 Less Deadly Than Seasonal Flu"},{"cluster_id":"367c1ab5-4267-4b68-a2ed-2893d2797c11","title":"COVID-19 Death Certification and Coding"},{"cluster_id":"dffdac1b-ba6f-48b2-97f4-02cb8656a37e","title":"Ukraine Rate Hike, IMF Delay Risk"},{"cluster_id":"8bd4a872-0209-415e-a7b8-b4acaf26a95b","title":"Autopsy study: possible vaccine-induced myocarditis"},{"cluster_id":"fedc3a0d-9f9d-4e04-81a3-669b447f0bcb","title":"Staged Crimean Tatar Congress Propaganda"},{"cluster_id":"67cff5df-1bcb-4edc-af42-99ff9df792c5","title":"Controversy Over Early Corman\u2013Drosten PCR"},{"cluster_id":"9d6f335e-c5fe-40ff-9edc-7ee5892fafaf","title":"Unverified pediatric vaccine-death claim"},{"cluster_id":"734aba7a-e1ac-4a78-a926-3957017f7843","title":"EU Ends Ukrainian Visa-Free Travel"},{"cluster_id":"04b0fab9-75f9-45a3-8f7f-91f5ed199dc0","title":"Moderna CEO\'s Pre-Planned Insider Sales"},{"cluster_id":"f4253f2e-cf0c-4fcc-9979-cb25e723158b","title":"Debate Over Natural Immunity Durability"},{"cluster_id":"5b6da2ab-36ee-4cfe-968a-ce42565405bc","title":"Ukraine GDP halved by sanctions"},{"cluster_id":"db101c75-2320-4597-b222-b7197dc49dc4","title":"Ukraine Blacklists Russian Artists Over Crimea"},{"cluster_id":"a5706e56-c643-44be-8e44-3c19fd9dcc29","title":"Contested vaccine risk-benefit claim"},{"cluster_id":"1e2e215d-02f8-41f2-bb72-8bb5cf8991d4","title":"Public Pfizer Documents via FOIA 2022"},{"cluster_id":"976266ce-5c9b-4a82-9062-52ac4f4dcbd6","title":"Ukrainian Strikes in Crimea 2023"},{"cluster_id":"dd4670c3-7e44-4c76-a7d9-373ad6cb6c50","title":"Zelensky\'s 2019 Steinmeier Formula Stance"},{"cluster_id":"728de5c6-3345-44e8-91f4-5ab1fb0c6670","title":"Lund Study: mRNA Reverse Transcription"},{"cluster_id":"600431fd-692e-4209-97b9-71af21abedf4","title":"Investigation and Recall After Japan Findings"},{"cluster_id":"abea76a9-3994-48b0-b3bb-df2d7f55ad12","title":"Updated Vaccination Guidance After Infection"},{"cluster_id":"e3df2907-4da7-4352-a8ae-dd0543915bd1","title":"EU Establishes East StratCom Task Force"},{"cluster_id":"921fce8d-f4e2-4dbe-b940-66b148c09f17","title":"Zelensky sanctions, blocks pro-Russian channels"},{"cluster_id":"f3cb984c-8736-4ad2-8cd8-5ca9f90033d5","title":"Media Hype, Ignores Vaccine Injuries"},{"cluster_id":"825bdd3b-f63b-4beb-b324-b276b6d235f7","title":"Aidar Abductions and Detention Facilities"},{"cluster_id":"3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c","title":"mRNA Vaccine Reverse-Transcribed in Liver Cells"},{"cluster_id":"74f7c7d8-aba9-45e9-a386-fbb258dd884d","title":"EU Pressures Ukraine Into Submission"},{"cluster_id":"210242d8-e5cc-4762-9912-b262084ebeb4","title":"Ukraine dumps Soviet-era general remains"},{"cluster_id":"52105c27-d937-4970-9bad-c139e21a6205","title":"UN launches tribunal against Poroshenko"},{"cluster_id":"8ea45448-137b-4d92-9e93-e6f5676fad3b","title":"Ukrainian Activists Blockade Supplies into Crimea"},{"cluster_id":"d281c55d-162e-4c45-bdc4-8fddc9bff858","title":"Ukraine Leads Crimea\'s Agricultural Imports"},{"cluster_id":"7e98dc53-abf7-4bf8-8ac7-3c9623f6d068","title":"Vaccinated ICU Patients Question Vaccine Efficacy"},{"cluster_id":"e60b32d7-dd12-4868-82cb-0b73bd6ac71a","title":"Vaccine-Induced Zombie Outbreak"},{"cluster_id":"c6c8d065-8cfe-4224-9bcc-58df52f1a712","title":"Ukraine Refuses Donbas Mines; Finland Clears"},{"cluster_id":"9a7cfd6f-8532-4052-b526-1e4576483709","title":"Crimea Resettlement and Incentives Announced"},{"cluster_id":"e9caf6d9-2282-4c7e-9cd5-97529119edff","title":"Ukrainian Military Vehicles Near Mariupol"},{"cluster_id":"2052af74-0bc8-401c-a911-035e4f5f65d2","title":"Ukraine mandates 75% Ukrainian music airtime"},{"cluster_id":"9723a8c8-8969-4471-bc9d-732ca83fc5b6","title":"Court: PCR 97% Inaccurate; Media Silent"},{"cluster_id":"06370214-3027-49a1-988e-c5188868372e","title":"India restricts COVISHIELD exports amid surge"},{"cluster_id":"f1b261ff-b08d-4eda-9ef1-3dbeca804b57","title":"Face Masks Reduce Viral Shedding"},{"cluster_id":"154780a4-c583-40d6-b0cd-5a3d8a1994cb","title":"Ukraine bans Russian St. George Ribbon"},{"cluster_id":"a1711988-408b-42c4-8682-720bf33be6bf","title":"Ukraine Bans St. George Ribbon"},{"cluster_id":"57bfc89a-d981-44e9-a425-3364b9a5bc24","title":"Masks Do Not Replace Flu Shots"},{"cluster_id":"346f630a-2d46-4e8a-80ef-67a96ebf81ef","title":"Vaccine choice harms only self"},{"cluster_id":"ac3c4bde-8539-4baa-8848-6a9242884e47","title":"Mariupol Market Shelling Kills Dozens"},{"cluster_id":"9ef9c32c-d40a-4d36-a3db-c01367d4c96e","title":"NATO Prepares for War with Russia"},{"cluster_id":"93fddae5-a739-409c-a087-9a562d010a0e","title":"No Major Increase in 2020 Deaths"},{"cluster_id":"497c65a0-d076-4ce0-b5c7-b89152ec15dc","title":"Labs: Follow Manufacturers\' Instructions, Ct Thresholds"},{"cluster_id":"d21c817e-4d9f-4479-93a3-693ea677e1ba","title":"Javelin Live-Fire Range, Grafenw\xf6hr"},{"cluster_id":"db23d549-f792-47f2-bc74-2fff4db9d0ef","title":"Mejlis Diplomacy to International Bodies"},{"cluster_id":"869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f","title":"Development of an Additional H1N1 Vaccine"},{"cluster_id":"ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c","title":"Memory T Cells Provide Superior Immunity"},{"cluster_id":"dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd","title":"Lviv Officials Urge Crimea, Donbas Recognition"},{"cluster_id":"ebf11375-1fd2-4e33-a82e-1889d6d8f85a","title":"Russian Disinformation Targeting Poland and Ukraine"},{"cluster_id":"f6541b8c-4e86-4aff-8593-e4f14f2ecc27","title":"Misinformation: No Asymptomatic Spread"},{"cluster_id":"ab8de566-e0cc-475b-b056-6b27916b484d","title":"Dnipro in the Russian World"},{"cluster_id":"360f1793-af7a-40dd-84eb-5e978218de67","title":"Euromaidan Crackdown: Baton Beatings"},{"cluster_id":"fddafbe9-dffd-4341-9619-bfc6fc256b34","title":"Russia Claims Western Arms Threat"},{"cluster_id":"c64abad7-175d-470b-9931-9259e05b39f5","title":"Crimea Votes to Join Russia"},{"cluster_id":"01bab4ca-5ac0-4d57-8f20-7bea2afbd031","title":"Trump Downplayed COVID-19 as Flu"},{"cluster_id":"37c144c2-5b3d-4b37-81ec-b6ea11090b3a","title":"Civilian Deaths From Unguided Grad Rockets"},{"cluster_id":"d7fa6886-1236-4402-9039-11c8f678ba45","title":"EU Africa Migration Root Causes Fund"},{"cluster_id":"4c8ca22f-065e-4c2a-bc2a-950d315204b8","title":"OPCW cannot determine Skripal agent origin"},{"cluster_id":"5b28f584-d6d3-4f8c-b812-407015e7b243","title":"Russia vetoes MH17 tribunal"},{"cluster_id":"712f7b26-cec5-48c3-8025-43c35dea8246","title":"Ukrainian Law Criminalizes Government Criticism"},{"cluster_id":"41aaee2b-0ddb-4eee-87a5-d0d95635a46f","title":"Ukrainian Language Media Quotas"},{"cluster_id":"655a46a8-9b52-4f61-b528-9f18ec9bf051","title":"Equal Deaths, No Vaccine Benefit"},{"cluster_id":"89cac161-a6f0-4315-a880-1662cae50313","title":"US Intel: Poland Destroys Ukraine Forces"},{"cluster_id":"f4638fa7-3292-4d44-b3f1-771aa65146b0","title":"Dutch Referendum: Poroshenko\'s Last Chance"},{"cluster_id":"76a80e87-389e-4e6e-9595-1b220839fd20","title":"Mask-Wearing Linked to Health Issues"},{"cluster_id":"4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6","title":"UN Reaffirms Ukraine\'s Territorial Integrity"},{"cluster_id":"127de610-39d3-4b48-be82-befef46aa586","title":"Stalin Support Surges in Russia"},{"cluster_id":"100519ae-c1d6-4f8e-bcef-2f36e907e789","title":"SARS-CoV-2 Spreads via Surfaces"},{"cluster_id":"e3141392-e630-428b-ae45-6d5589bf7443","title":"Ukraine Administration Questions Canada\'s Founder"},{"cluster_id":"b95f4f5f-4d51-43a4-8c27-5ed3609dc286","title":"New York Hospitals Overwhelmed, Morgues Deployed"},{"cluster_id":"05b6ff5d-2ddf-4b71-b6f6-98defb612c16","title":"Putin Framed Referendum as Legitimate Territory"},{"cluster_id":"0166ea62-85f0-412c-bd73-f3d7bc1bdf59","title":"Spike Proteins: Nuclear DNA Damage"},{"cluster_id":"623ab1ae-1f19-46fc-b19b-929f64c7b525","title":"Pfizer Vaccine May Weaken Children\'s Cross-Immunity"},{"cluster_id":"8b4dea1f-81ef-489e-9aba-a19d5e926009","title":"WHO TB Rights Mission in Ukraine"},{"cluster_id":"e30d6b86-658d-4082-9c3e-5cf88f347945","title":"Crimean Tatars rally for Ukraine"},{"cluster_id":"a258e4b2-c3eb-4705-92c4-2f0c1074629b","title":"COVAX Cuts 2021 Delivery Forecast"},{"cluster_id":"38b77626-e120-4759-a3a5-dc826b3463bb","title":"Chechen Islamic Battalions Aid Ukraine"},{"cluster_id":"fc29eab9-06ef-4c87-8c16-ab4eb87c1683","title":"War damages Ukraine radiation monitoring gear"},{"cluster_id":"36641d64-6f2c-4f28-a210-946f0a644597","title":"Kivalov\u2013Kolesnichenko Language Policy Controversy"},{"cluster_id":"2d8f3813-2525-407f-8769-b0281d589d42","title":"Fitch Downgrades Ukrainian Banks"},{"cluster_id":"d467c165-3190-4bf1-b5b6-3c529b474781","title":"FDA Grants Full Approval for Comirnaty"},{"cluster_id":"95caea6a-ff66-40ac-9167-0fca6baadbff","title":"Ukraine Reintegration of Donbas and Crimea"},{"cluster_id":"bbb004ba-d35c-43eb-a8fb-f8fc936100c1","title":"Russian-backed administrations and propaganda in Kherson"},{"cluster_id":"da4bd748-3c84-4017-a93a-8247224fc32f","title":"Unverified claim: National Corps bomb"},{"cluster_id":"8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9","title":"COVID-19 Vaccinees Ineligible to Donate Blood"},{"cluster_id":"4f145c90-9c3b-47cb-b38a-e643a9aa6e27","title":"Opposition to Ukraine MAP, Bucharest"},{"cluster_id":"b0f153c6-cc18-4aee-9b69-e8f06c8e3149","title":"Zelensky Acknowledges Donbas Loss"},{"cluster_id":"2fc8ee47-5c74-46a4-91ea-72f94f9e2c27","title":"COVID-19 Misinformation and Testing Claims"},{"cluster_id":"0fae2f14-66ec-4594-b5a0-1588a0fa8339","title":"Donbas Minefields: Floods and Hazards"},{"cluster_id":"2a09de37-e0d8-48a4-b6d1-8773f6d954be","title":"UK Scientists Discussed Herd Immunity Strategy"},{"cluster_id":"028c0dd0-ac64-47ea-94f9-5c74b9d66731","title":"Waning Pfizer-BioNTech Protection in Qatar"},{"cluster_id":"3f77000e-b7d1-457b-963f-2743a0bda688","title":"Formaldehyde: IARC Group 1 Carcinogen"},{"cluster_id":"93f5bdee-4d35-454b-8f1b-0b318e24a68d","title":"Omicron: WHO VOC and Immune Escape"},{"cluster_id":"5f181f74-d991-4908-aaf7-6917a17dca75","title":"Chechen Fighters in Ukraine"},{"cluster_id":"96b36beb-a890-402f-9101-7aa7236863f1","title":"Ukrainians Maintain Ties with Russia"},{"cluster_id":"b3b646eb-c723-4a14-ac13-d0b7985ef11c","title":"Russia Invades Ukraine; Ukrainian Resolve"},{"cluster_id":"9087a989-a032-4a4f-877e-3dd17a8e6902","title":"NATO-Ukraine Trust Funds (2015)"},{"cluster_id":"a3015153-afe6-4168-9a99-d14bbbdd401f","title":"CDC tracks only severe breakthrough cases"},{"cluster_id":"dcf5235c-74f7-409c-bb59-9454cc01feed","title":"Donbas: Internal vs Civil War"},{"cluster_id":"f58ca21a-7af7-4062-9509-f6480d8a6390","title":"COVID-19 Outbreaks Among Ukrainian Troops"},{"cluster_id":"90b17dac-ed93-4273-8df4-019652e30993","title":"Documented Ukrainian Equipment Losses, 2022"},{"cluster_id":"3a1c123d-a3bb-42e2-911f-77ddeb67d2ee","title":"Donetsk and Luhansk Declare Independence"},{"cluster_id":"bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5","title":"UK Past the Outbreak Peak"},{"cluster_id":"b985b53e-1d8b-45e2-8b3f-823f5bdb2380","title":"Crimea Military Buildup and Base Modernization"},{"cluster_id":"35a90496-100d-4386-a3d0-578c543e7dd4","title":"NATO Reinforces the Eastern Flank"},{"cluster_id":"a34f85b1-92bb-47d3-b089-7365f6b9f51f","title":"Ukrainians Support Referendums in Occupied Territories"},{"cluster_id":"029b01a5-6f18-4a7f-96f8-6bde44853032","title":"West Urges Urgent Peace with Russia"},{"cluster_id":"07b3b643-33f3-45b2-87a3-3626fa492cb3","title":"Russia\'s emergency rate hike to 17%"},{"cluster_id":"83859ac4-ebe8-4ffc-91d6-38d67b7686ab","title":"PFAS Contamination in U.S. Tap Water"},{"cluster_id":"59f595d5-6ff2-4686-81ce-6150bd29db9d","title":"U.S. Destabilizes Black Sea Region"},{"cluster_id":"5aad8736-b18a-4e21-930e-320f4faaed1c","title":"Claims of Vaccine Harm in Children"},{"cluster_id":"95cf8fc0-eadb-4c70-8762-0c3f65726aa4","title":"Russian Military Exercises Near Europe"},{"cluster_id":"03329c55-b9c0-4585-b5b1-817ec3b57899","title":"Thimerosal Removal and Public Controversy"},{"cluster_id":"5d815b32-3a62-41d7-bd5e-64e320d9507a","title":"AstraZeneca vaccine rare clot link"},{"cluster_id":"389db9cc-996b-4a34-8f9a-361c5c8aa5ee","title":"Moderna mRNA IP Litigation 2021"},{"cluster_id":"5008f252-8b6e-4832-ae6f-1940fe20e4de","title":"Pentagon suspends Russia military drills"},{"cluster_id":"4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23","title":"Claims of COVID-19 vaccine harm"},{"cluster_id":"95eac10f-08e8-4ebe-913d-90bbcf49cbbc","title":"Georgian asylum claims rise post-visa liberalisation"},{"cluster_id":"c74997a7-7974-4e4a-80ee-0cf8f0af8af6","title":"Foreigners and Protest Tourists Enter Ukraine"},{"cluster_id":"c81b3fac-f8f7-4824-a157-6d31dd48689f","title":"US Prepares New Revolution in Ukraine"},{"cluster_id":"0686ff31-e224-48f2-ad84-a11eff3d54be","title":"Alleged Ukrainian Preparations in Crimea"},{"cluster_id":"de116a88-705c-434f-9f3a-1fdabb457723","title":"Europe accuses Ukraine of rising radioactivity"},{"cluster_id":"753b53ca-12e6-424b-989a-e076a991708d","title":"Kuleba: Diplomacy and Deterrence"},{"cluster_id":"00a040a7-5456-47e8-b780-a67388e64219","title":"Russia Cleared in Parubiy Case"},{"cluster_id":"e21ec8bb-ddf8-4115-9765-9a2f72eed10d","title":"Alleged GMOs in COVID-19 vaccines"},{"cluster_id":"52bfe357-189c-4c8a-a4ee-372f061bfc2c","title":"Common COVID-19 Vaccine Side Effects"},{"cluster_id":"5e115001-bb2f-45b1-be83-78b8766bff77","title":"Final US Mortality 2019 Report"},{"cluster_id":"09a252ec-4d97-4380-a535-1e7222c476ea","title":"NATO Black Sea Naval Drills 2018"},{"cluster_id":"800ccc5c-7e0c-49e0-a72a-3cfe964493e5","title":"Rouble Crash Triggers Emergency Action"},{"cluster_id":"9b0314ac-478d-4c92-b0c0-490018094349","title":"Ukrainian Interim Government Formation Delayed"},{"cluster_id":"cd099a56-0545-43d7-bbda-54857a323642","title":"COVID-19 Deaths Counted; Vaccine Excluded"},{"cluster_id":"ccdc4717-b37b-4b1b-94a7-20dfafa305fe","title":"2015 Decommunization: Removing Soviet Symbols"},{"cluster_id":"2ff54a92-503d-42da-bdb7-6138f7c69fb1","title":"Ukraine Budget Tied to IMF Deficit"},{"cluster_id":"f8ac7419-698c-4d8c-9bee-1803e1e62a78","title":"OSCE: Verification Access in Minsk"},{"cluster_id":"43836beb-3651-49f1-a0f8-ad3c4daaab70","title":"FDA Grants EUA for Pfizer-BioNTech"},{"cluster_id":"48e9dba9-1fa3-402e-ae73-202c64781781","title":"2014 Russian convoy, disputed incursions"},{"cluster_id":"2a0edc6f-16ff-496d-b79c-24bffd830324","title":"Routine US Navy Presence in Black Sea"},{"cluster_id":"c9534331-e465-4cc5-951b-fa24c4cd75bf","title":"Lviv Demolishes WWII Glory Monument"},{"cluster_id":"06ac8474-a3e8-472b-abca-69bac9927b06","title":"No Surrender in Ukraine"},{"cluster_id":"d935874a-c33c-4b74-9137-99d8fd9fc1f8","title":"Global COVID Vaccination Takes Decades"},{"cluster_id":"dd1b900d-edc5-41a8-a7b7-0e0de59cf33e","title":"High-Profile Reviews on Aluminium Adjuvants"},{"cluster_id":"bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75","title":"Post-Vaccination Long COVID Predominates"},{"cluster_id":"c42951ed-4fef-4240-bea1-d37921f9209f","title":"Wagner in Crimea and Donbas (2014\u201315)"},{"cluster_id":"9ee9fc47-27b6-4828-a30b-bd52c92ccfae","title":"Conspiracy Claims About COVID Vaccines"},{"cluster_id":"4dd58e9c-790c-4f52-9fba-7f267f15da6d","title":"HHS Clarifies PREP Act Scope"},{"cluster_id":"014863d4-ae1c-4c35-8738-d91dc371f2a4","title":"Norway investigates frail elderly vaccine deaths"},{"cluster_id":"abf9a23b-ae17-4adc-8775-9b47f6861ebe","title":"Transcarpathia Hungarians Speak Out"},{"cluster_id":"9fc7f408-c42c-485e-91c2-a72960ff3158","title":"Ukraine Divided by Kyiv and Washington"},{"cluster_id":"2bdcdf0c-04af-47ca-abf1-8573ce94795d","title":"Federal Mask Order for Transportation"},{"cluster_id":"057662c4-0ac6-48b6-be90-a08641f47c88","title":"Post-Pandemic Surge in Late-Stage Cancers"},{"cluster_id":"1fb65a9b-f85e-4764-8dae-68053166a895","title":"Declining vaccine effectiveness against Omicron"},{"cluster_id":"27a6bdbf-c139-4b94-baa7-3715f52da9db","title":"Detentions, Abuses, Civilian Harm in ATO"},{"cluster_id":"a49a51da-aad1-43de-81b7-51f95b22eabd","title":"World deems Ukraine Nazi state"},{"cluster_id":"11415296-938e-40a3-84ae-06be10542d39","title":"Ukraine Detains and Denies Journalists"},{"cluster_id":"e46f2bcf-e185-4401-89f0-e7da4fcba567","title":"CDC Explains New mRNA Vaccines"},{"cluster_id":"6f3f0719-064d-478a-ae5f-d9aca0368d4e","title":"Ukraine\'s Language Police Revive Great Terror"},{"cluster_id":"24f76117-6d13-47b7-8b5c-41608f921324","title":"Minsk II: Withdrawal of Foreign Forces"},{"cluster_id":"f86db310-987e-41a6-a2fc-6f6bb14b7072","title":"OSCE Deploys SMM to Ukraine"},{"cluster_id":"d622193d-1629-4f0f-a5cd-b9751e388901","title":"Ukraine 2020 budget approved"},{"cluster_id":"3cd5d7a9-3268-400e-a49f-8e37d420e392","title":"Kyiv Euromaidan: Deadly Police Crackdown"},{"cluster_id":"347d475b-a5aa-4035-8032-84126946c0db","title":"Masks as a Political Symbol"},{"cluster_id":"6cadfbb6-c995-4a61-9bf9-357705f879c1","title":"Public COVID-19 Vaccine Data by Jurisdiction"},{"cluster_id":"4f2403b6-f02f-46f5-a51a-edcea5995adb","title":"EU Visa Suspension Mechanism Revised"},{"cluster_id":"b38c991a-b869-4a3d-9864-3fdbb089a284","title":"NCHS/CDC Provisional Mortality Reporting Delays"},{"cluster_id":"30b7b8ee-8417-4cde-bc24-2f6b158ce6a0","title":"Crimean Tatars back annexation, join Russia"},{"cluster_id":"d3bded76-52fd-4f86-982f-558582eed404","title":"Zelensky Requested Foreign Troops Deployment"},{"cluster_id":"8628cfa7-1952-4304-94e8-eca8c125fadb","title":"Public Access to VAERS Data"},{"cluster_id":"668dd84f-417c-4a0b-ac12-78d246a5f46e","title":"Fauci Vaccine Claims, Natural Immunity"},{"cluster_id":"d895f911-9139-47dd-8018-79b66f8588dd","title":"Pfizer-BioNTech US Vaccine Deal"},{"cluster_id":"e2f88c16-103f-497d-a88a-e63349d63a62","title":"US Plans Color Revolution in Ukraine"},{"cluster_id":"09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5","title":"Flu Vaccination in Egg Allergy"},{"cluster_id":"587bb9b0-b0dd-47bf-9ce3-29231f30f4a3","title":"Fauci Wore a Mask for Appearances"},{"cluster_id":"9fa27866-4911-4f0d-8135-cff4b7e597db","title":"Genocide Allegations Against Ukrainian Forces"},{"cluster_id":"b41760af-aaf8-4d45-b87f-633ebbf009f9","title":"Low IFR for Younger People"},{"cluster_id":"3c5a3b02-4d06-4799-a8fe-9f59c0de51d9","title":"Ecumenical Patriarchate Grants Ukrainian Autocephaly"},{"cluster_id":"0d049984-1ab9-44da-bbd0-bb9c99a21317","title":"OHCHR Reports on Ukraine Violations 2014"},{"cluster_id":"a608e3f3-dce6-4fd9-9684-b60e35b55c85","title":"U.S. Non-Lethal Aid to Ukraine"},{"cluster_id":"31c69d86-6651-4ebe-ab2e-087bf7193e24","title":"Attacks on Patrols in Eastern Ukraine"},{"cluster_id":"5af9294b-b226-4926-b1d8-cd8badc5e35b","title":"OSCE-Mediated Talks with Donetsk and Luhansk"},{"cluster_id":"5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b","title":"Booster Program Elevates Antibody Titers"},{"cluster_id":"0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879","title":"COVID-19 Misinformation: Masks, Vaccines, Treatments"},{"cluster_id":"050d87c2-4ac3-4e0e-8673-b4a44b43bac0","title":"Right Sector in Maidan Protests"},{"cluster_id":"be12c5b4-b051-4762-b77d-ca92a4063972","title":"Constitutional Court voids 2012 language law"},{"cluster_id":"1ccdbc51-34c0-42ae-b81a-03edbb3df6d6","title":"Human Rights Violations in Eastern Ukraine"},{"cluster_id":"7a0376f1-1a7b-4181-a413-d3bc6cd70242","title":"Ct Values Correlate With Infectiousness"},{"cluster_id":"5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4","title":"No Russian Forces in Donbas"},{"cluster_id":"4785bab4-a99a-4e40-9619-5133dfc2b141","title":"Early Adverse Reactions to COVID Vaccines"},{"cluster_id":"ec4ecacf-5ed7-4202-a803-a46089704d53","title":"Donbas Aid Totals Propaganda"},{"cluster_id":"683abff9-679b-4270-b05d-4394a56a60b4","title":"Pro-Russian Demonstrators Storm Odesa Police"},{"cluster_id":"daf0b3a1-53f1-4b47-955e-785030ee3839","title":"Saurivka Massacre by National Guard"},{"cluster_id":"dddeb5a3-e00c-4234-b929-096fb52ccab4","title":"Medical Masks vs N95: Meta-analysis"},{"cluster_id":"e86748c4-2789-4941-b470-d29321693c17","title":"Pfizer\'s Warp Speed Funding Nuance"},{"cluster_id":"cebd1d98-7547-4761-a012-89e58bf86f29","title":"Azov Veterans\' Paramilitary Training and Ties"},{"cluster_id":"f3288e7a-a54c-44d1-8307-67aafb47c852","title":"Thousands of Russians Flee Ukraine"},{"cluster_id":"1da96a0b-d833-4078-afdc-5a85d522b86d","title":"Ukraine Provocation in Kerch Strait"},{"cluster_id":"4767808d-19a9-4e75-b8a7-7421cf37c72f","title":"Ukrainians Favor Compromise With Russia"},{"cluster_id":"4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c","title":"Moderna Vaccine Spike Detected in Plasma"},{"cluster_id":"39f6fc8d-27a2-4261-870e-362c0315c46f","title":"US Funds Ukraine War Against Russia"},{"cluster_id":"5787a927-39a0-4bb7-92d5-230091f48a3e","title":"Ukraine approves larger 2020 defence budget"},{"cluster_id":"a2a4882d-9cb0-4b1a-8852-37a056ca2ca7","title":"Kremlin Disinformation Targets Poland-Ukraine Relations"},{"cluster_id":"e136ae61-7689-4d72-a14e-2120e6260be2","title":"EUA: Limited pediatric safety data"},{"cluster_id":"5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b","title":"Vatican OKs Certain COVID Vaccines"},{"cluster_id":"c6262c2d-c819-43cf-9414-2109754b60a0","title":"Booster Restores Omicron Neutralization"},{"cluster_id":"05e83588-8d3e-4daa-9f6b-b9faf4c1da93","title":"Pediatric RSV Surge After Restrictions"},{"cluster_id":"3e5167ea-d839-4cc5-b193-fda2f9c0b53b","title":"Ukrainian Media: Starvation in Russia"},{"cluster_id":"4a1c13c8-b1bc-47b6-9e32-b9200ffdf048","title":"945,000 Self-Reported Long COVID in UK"},{"cluster_id":"2bd1f4b8-00be-4a69-ba1f-d23c0361c606","title":"Attacks on Indian healthcare workers"},{"cluster_id":"04b259ed-8fea-44d2-9f92-3e357be663b0","title":"FDA Expands EUA to Teens"},{"cluster_id":"dcbf5711-b1d2-4a7c-96f6-e8916f52c752","title":"Vaccinated Have Higher Nasal Viral Load"},{"cluster_id":"c7ff0720-041e-4548-8592-cfa24a2712c7","title":"Failed Toppling of Dzerzhinsky Monument"},{"cluster_id":"f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6","title":"Sweden\'s No-Lockdown Approach Widely Publicized"},{"cluster_id":"c5a76ba5-1fa2-4615-9254-21b572adf7ac","title":"ChAdOx1 nCoV-19 Transcriptomic Cell Line Study"},{"cluster_id":"c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f","title":"U.S. Provides Economic Aid to Ukraine"},{"cluster_id":"e4596864-8ee7-4544-832b-f1063fa0c90c","title":"Court-Ordered Acceleration of Pfizer Documents"},{"cluster_id":"31a83c0d-3856-4e30-82d4-769416b594bd","title":"CDC Withdraws EUA for RT-PCR Panels"},{"cluster_id":"5eac68c0-2a04-4e6c-af79-6d253e14522a","title":"Russian Navy Drills Near Crimea"},{"cluster_id":"c60d6252-d9ce-42b9-bf38-6fcee80b74b2","title":"Promoting Ukrainian Language and Unity"},{"cluster_id":"f34203f2-30b3-4686-b2f0-e124d8a67272","title":"Ukrainian Soldiers Wore Russian Uniforms"},{"cluster_id":"4ea6057d-751f-45d1-801b-72130ecef337","title":"Deaths by Vaccination Status in England"},{"cluster_id":"cd4aea0c-c90e-430b-95f8-4bff425c022e","title":"Embalmers\' Alleged Vaccine-Linked Clots"},{"cluster_id":"8c2b4e21-c9ea-4127-9440-e983688f714d","title":"Ukrainian Troops Kill Separatist Defector"},{"cluster_id":"626e9a9b-6995-4100-8ffb-53ed10359203","title":"Major Ukraine-Russia Prisoner Exchange"},{"cluster_id":"e1b47a9d-415d-4c0a-a801-d747a6f31d9a","title":"Russian strikes hit Kyiv radioactive facility"},{"cluster_id":"579db367-74ad-4432-9888-8af443f74bd8","title":"Leaked documents: Ukrainian troops violations uninvestigated"},{"cluster_id":"4c81571d-8516-4f35-b047-353d1a6e0a6a","title":"Hungary-Russia Energy and Politics"},{"cluster_id":"f7cbf601-ad96-47af-b877-ba63e1376028","title":"Foreign Fighters in Donbas"},{"cluster_id":"0d8dd84c-b6a6-4b66-80f5-c84acd03da41","title":"Ukraine Used Cluster Munitions in Donetsk"},{"cluster_id":"9d847e57-5fc5-4cc4-8919-603e5c8d93d2","title":"FDA Grants Full Approval to Comirnaty"},{"cluster_id":"58d169af-1f4c-430e-875d-88f013ef1388","title":"CDC Guidance: Clean High-Touch Surfaces"},{"cluster_id":"58a7d973-9fa3-4047-a219-579a31c4561b","title":"US Tests Vaccines in Ukraine"},{"cluster_id":"2bf4835a-c2d9-4984-a011-415e8a457306","title":"Bivalent COVID-19 Boosters Authorized Under EUA"},{"cluster_id":"ad513fe4-8bef-4ca7-984b-94ef0cbb53d7","title":"VRBPAC Briefing and Moderna Vaccine Safety"},{"cluster_id":"4c83d9ff-1e62-4a28-b3d2-a667fb4041d7","title":"Strengthening and Deploying National Guard"},{"cluster_id":"5a33a893-0ae3-4e2b-9f4c-02de9772f96c","title":"Alleged Harm from Flu Shot"},{"cluster_id":"19380a4c-de83-43a7-ae00-058986b5206e","title":"Tough Measures Against Crimea Migrants"},{"cluster_id":"4b93a421-107c-4185-912b-a73d039895b4","title":"Rare Myocarditis After mRNA Vaccination"},{"cluster_id":"1ff73cd5-87d3-47be-9b40-e0da957f6ed3","title":"Alleged UN Admitted Gates Vaccine Outbreak"},{"cluster_id":"d0dc34ca-6f25-427d-a56e-1d4f3210e605","title":"Attacks on Journalists in Eastern Ukraine"},{"cluster_id":"c754fcc4-5c32-4f8a-ac01-348838a5d407","title":"WHO reviews Seychelles vaccination surge data"},{"cluster_id":"0c685bcc-0513-4b5c-8ba7-c302c985ff66","title":"Vaccines Harm Children"},{"cluster_id":"04fe8e71-8c72-481f-a6cf-1722df9454dc","title":"COVID-19 Impact on Children"},{"cluster_id":"897c7076-ce98-4405-aaa5-1e883a645242","title":"Ukraine\'s 2014\u201315 Economic Contraction"},{"cluster_id":"637d133e-6c19-4fa2-b174-de1d016bd9bc","title":"Descendants of Banderovites Commit Atrocities"},{"cluster_id":"e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93","title":"Texas Lifts Mask Mandate"},{"cluster_id":"92111d3f-ebb0-4617-aa4c-9df22ddccd03","title":"Tokyo Autopsy Series: Vaccine-Related Deaths"},{"cluster_id":"b2946046-f947-49a1-8176-588a2c66f974","title":"Simferopol Flight and Transport Rebound"},{"cluster_id":"3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae","title":"PULS markers rise after mRNA vaccination"},{"cluster_id":"9e906023-8a3d-4a63-9309-18e9ee1c3641","title":"Ukraine\'s Language Law Violates Constitution"},{"cluster_id":"4e78b61e-317a-4417-b42d-464646384193","title":"COVID-19 Snake Venom Myth"},{"cluster_id":"a7539db4-dfef-469c-b96d-9b13762fd242","title":"Restoring Water in Donetsk and Luhansk"},{"cluster_id":"cb346877-50ff-42c0-97e6-7abb95523efb","title":"Ukraine Financing Needs, Debt Pressures 2019\u201321"},{"cluster_id":"fd5eb376-88a6-437a-8af1-6b857c858d7f","title":"COVID Vaccine Risk and Underreporting"},{"cluster_id":"07ec2e30-02bb-47d3-9b4c-32b7c841fb33","title":"CDC Withdraws COVID PCR Over Flu"},{"cluster_id":"199242cb-5b3e-40d9-bf38-e1eddcf574fc","title":"Ukraine Targets Crimea and Donbas Residents"},{"cluster_id":"39f63165-e875-40a7-84ed-ae42699b5d21","title":"Russian Media Alleging NATO Involvement"},{"cluster_id":"192193af-777f-4b45-a866-b58926d838df","title":"Preexisting Conditions Common in COVID-19 Deaths"},{"cluster_id":"64c8d619-fdbf-4e87-a23c-9bfa4369bc15","title":"Post-COVID-19 Vaccination Imaging Pitfalls"},{"cluster_id":"f570b12b-c8a8-4d99-9575-a11a563abe1c","title":"Alleged Ukrainian-ISIS Alliance"},{"cluster_id":"800819aa-dd64-46d5-8bb3-ebc4802f59be","title":"2015 European migrant crisis"},{"cluster_id":"0acd3055-185c-4d22-ad5f-a587ee5adc40","title":"Alleged Moderna Heart Damage"},{"cluster_id":"dcf2ee53-8023-43ee-94fe-0207a7fb5133","title":"Alleged Ukrainian Javelin Sales to Militants"},{"cluster_id":"88d87950-d2a5-4729-bb7a-8215d26b8898","title":"American Tanks Found in Donbas"},{"cluster_id":"eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba","title":"GMC Strikes Wakefield From Medical Register"},{"cluster_id":"40860ef8-1ebc-45f7-84a0-735bcdaf070c","title":"Allegations of Hatred by Memory Institute"},{"cluster_id":"d5777d75-d1f3-4884-9f6a-615b36a875d0","title":"Kyiv Sanctions Russian-Owned Banks"},{"cluster_id":"0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a","title":"U.S. suspends Russia cooperation after Crimea"},{"cluster_id":"015317d7-08c9-4925-98a2-39e2a1fa7c6d","title":"Waning mRNA vaccine effectiveness during Omicron"},{"cluster_id":"ed8ee9d8-3361-4c66-86fb-3b0c6210300d","title":"COVID-19 Surveillance by Vaccination Status"},{"cluster_id":"96423d41-ee08-4c5e-bcf0-4dd1b431abc6","title":"Gift Denied to Russian-Speaking Child"},{"cluster_id":"7b68c402-465e-4abb-ac74-c3e397c8afdd","title":"Neo-fascists Beat Woman at Lenin Monument"},{"cluster_id":"c1036fd0-74b9-4ac8-a4d8-2710377e38ff","title":"Eastern Ukraine ATO launched"},{"cluster_id":"17a99d17-d7ec-4cf5-8a94-b29753d62b97","title":"US Denies Providing Ukraine Lethal Weapons"},{"cluster_id":"e455cd44-cd3c-4e6c-a847-ff250278123c","title":"US Grants to Russian Soldiers\' Mothers"},{"cluster_id":"549c4c7b-f978-4fb0-adc2-18a978338670","title":"Zelensky calls for long-range strikes"},{"cluster_id":"356ce4de-dd2a-4caf-bb6c-703dee1f13f4","title":"2014 Ban on Russian War Propaganda"},{"cluster_id":"fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d","title":"Booster Guidance Expands as Immunity Wanes"},{"cluster_id":"f996f072-3b37-4e7f-900c-1cc05e40fa72","title":"Italian photojournalist killed in Donbas"},{"cluster_id":"c17fb294-56ef-42a8-aa4a-cafb4005de0f","title":"Kerch Strait Seizure of Ukrainian Vessels"},{"cluster_id":"84ba9e08-7f87-4e91-abf6-4415ddb9a231","title":"Little Green Men in Crimea"},{"cluster_id":"1c223a5c-b5aa-49ca-99af-333b89e0351d","title":"Putin Recognizes Donetsk and Luhansk Independence"},{"cluster_id":"3e318927-1041-4535-a22e-049f32238ea2","title":"California\'s CAL.20C Emergence and Spread"},{"cluster_id":"e11a5f48-4afa-40b5-8724-9f7420d483fe","title":"Reported miscarriages after vaccination"},{"cluster_id":"f5af21c1-57be-4378-ab8c-5400cfed6bff","title":"Regional Russian Language Repeal, Ukrainian Emphasis"},{"cluster_id":"ddc5dfbd-77e6-466c-a4ac-12178d35c42e","title":"COVID Vaccine Injuries Under CICP"},{"cluster_id":"5a7cebd4-db2c-4dcc-8a5c-86e950acfb54","title":"Russia accuses U.S. of meddling"},{"cluster_id":"94e768ad-42fa-42f8-83fa-89a3705b92a2","title":"Ukraine Cancels Victory Day, Dismantles Vatutin"},{"cluster_id":"a5de3945-d8b3-45a7-9c18-edeaa4ccf742","title":"Persecution Narratives Justifying Ukraine War"},{"cluster_id":"ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b","title":"Ukraine bans Russian sites and networks"},{"cluster_id":"86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5","title":"Deteriorating Russia-West Relations"},{"cluster_id":"b97c97e0-114f-4fea-812a-38dca08108e6","title":"Illegitimate Donbas Elections Condemned"},{"cluster_id":"34d9abee-6356-4941-91bd-4961dca2eec1","title":"COVID vaccines are useless"},{"cluster_id":"73a6792a-38f3-4e05-a1bc-e5dc764c0b4d","title":"PCR-Driven Pandemic"},{"cluster_id":"a63f5d9a-cff2-4275-97b2-48d300df1ba7","title":"Myocarditis Risk Outweighed by mRNA Vaccines"},{"cluster_id":"f98db0f7-3865-4f81-b4c0-e009394ed065","title":"Design Flaws in CDC COVID Tests"}]');







function $db08f6f394937c76$var$parseDateSafe(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return null;
    if (d.getFullYear() < 2016) return null; // filter erroneous
    return d;
}
function $db08f6f394937c76$var$buildLookupMaps(data) {
    const claimMap = new Map(data.claims.map((c)=>[
            c.id,
            c
        ]));
    const eventMap = new Map(data.events.map((e)=>[
            e.id,
            e
        ]));
    return {
        claimMap: claimMap,
        eventMap: eventMap
    };
}
function $db08f6f394937c76$var$computeClusterAvgDate(members, claimMap, eventMap) {
    const dates = [];
    members.forEach((id)=>{
        const c = claimMap.get(id);
        const e = eventMap.get(id);
        const raw = c?.date || e?.date;
        const parsed = $db08f6f394937c76$var$parseDateSafe(raw);
        if (parsed) dates.push(parsed.getTime());
    });
    if (!dates.length) return null;
    const avg = dates.reduce((a, b)=>a + b, 0) / dates.length;
    return new Date(avg);
}
function $db08f6f394937c76$var$buildGraph(data) {
    const nodes = [];
    const links = [];
    const titleMap = new Map((0, (/*@__PURE__*/$parcel$interopDefault($232f777ea42b74fb$exports))).map((t)=>[
            t.cluster_id,
            t.title
        ]));
    const { claimMap: claimMap, eventMap: eventMap } = $db08f6f394937c76$var$buildLookupMaps(data);
    data.claim_clusters.forEach((cluster)=>{
        const avgDate = $db08f6f394937c76$var$computeClusterAvgDate(cluster.members, claimMap, eventMap);
        nodes.push({
            id: cluster.cluster_id,
            label: titleMap.get(cluster.cluster_id) || cluster.title || "Unnamed Claim Cluster",
            type: "claim_cluster",
            type_nice: "Claim",
            members: cluster.members,
            avgDate: avgDate
        });
    });
    data.event_clusters.forEach((cluster)=>{
        const avgDate = $db08f6f394937c76$var$computeClusterAvgDate(cluster.members, claimMap, eventMap);
        nodes.push({
            id: cluster.cluster_id,
            label: titleMap.get(cluster.cluster_id) || cluster.title || "Unnamed Event Cluster",
            type: "event_cluster",
            type_nice: "Event",
            members: cluster.members,
            avgDate: avgDate
        });
    });
    data.cluster_links.forEach((link)=>{
        links.push({
            source: link.claim_cluster_id,
            target: link.event_cluster_id
        });
    });
    return {
        nodes: nodes,
        links: links
    };
}
function $db08f6f394937c76$export$8a445f1917e2e2cc() {
    const fgRef = (0, $acw62.useRef)();
    const detailsPanelRef = (0, $acw62.useRef)();
    const [selectedNode, setSelectedNode] = (0, $acw62.useState)(null);
    const [inputDate, setInputDate] = (0, $acw62.useState)(1682353753000); //some time in 2023
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    const [filterLeeway, setFilterLeeway] = (0, $acw62.useState)(6);
    const parsedInputDate = (0, $acw62.useMemo)(()=>{
        const d = new Date(inputDate);
        return isNaN(d.getTime()) ? null : d;
    }, [
        inputDate
    ]);
    const graphData = (0, $acw62.useMemo)(()=>{
        const full = $db08f6f394937c76$var$buildGraph((0, (/*@__PURE__*/$parcel$interopDefault($04ca73c2000c8168$exports))));
        const components = (0, $21f819a4461f8efa$export$cb4545c791e478f)(full.nodes, full.links);
        const validIds = new Set(components.filter((c)=>c.length > 1000).flat());
        return {
            nodes: full.nodes.filter((n)=>validIds.has(n.id)),
            links: full.links.filter((l)=>validIds.has(l.source) && validIds.has(l.target))
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!fgRef.current) return;
        fgRef.current.d3Force("charge", $78193c16de4a9cf2$export$2e2bcd8739ae039().strength(-30));
        fgRef.current.d3Force("link", $b1bbf836822558b1$export$2e2bcd8739ae039().distance(140));
        fgRef.current.d3Force("collision", $e71a2b6c9ad4b72d$export$2e2bcd8739ae039((node)=>{
            const dims = node.__bckgDimensions;
            return dims ? Math.max(dims[0], dims[1]) / 2 + 32 : 40;
        }));
        fgRef.current.d3ReheatSimulation();
    }, [
        graphData
    ]);
    const timeRange = (0, $acw62.useMemo)(()=>{
        let min = Infinity;
        let max = -Infinity;
        [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($04ca73c2000c8168$exports))).claims,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($04ca73c2000c8168$exports))).events
        ].forEach((d)=>{
            if (!d.date) return;
            const t = $db08f6f394937c76$var$parseDateSafe(d.date)?.getTime();
            if (t == null) return;
            if (t < min) min = t;
            if (t > max) max = t;
        });
        return {
            min: min,
            max: max
        };
    }, []);
    function isNodeHighlighted(node, referenceDate) {
        if (!referenceDate || !node.avgDate) return false;
        const diffMonths = Math.abs(referenceDate - node.avgDate) / 2630016000;
        return diffMonths <= filterLeeway;
    }
    const highlightedNodeIds = (0, $acw62.useMemo)(()=>{
        if (!parsedInputDate) return new Set();
        const set = new Set();
        graphData.nodes.forEach((n)=>{
            if (showAll || isNodeHighlighted(n, parsedInputDate)) set.add(n.id);
        });
        return set;
    }, [
        graphData.nodes,
        parsedInputDate,
        showAll,
        filterLeeway
    ]);
    (0, $acw62.useEffect)(()=>{
        if (fgRef.current) fgRef.current.zoom(0.01, 0);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5c879b82e9fecb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $002d9ae7155c4add$export$2e2bcd8739ae039), {
                ref: fgRef,
                graphData: graphData,
                nodeLabel: (node)=>node.label,
                nodeAutoColorBy: "type",
                linkDirectionalArrowLength: 500,
                linkDirectionalArrowRelPos: 0.9,
                linkColor: (link)=>{
                    const sourceId = typeof link.source === "object" ? link.source.id : link.source;
                    const targetId = typeof link.target === "object" ? link.target.id : link.target;
                    const bothHighlighted = highlightedNodeIds.has(sourceId) && highlightedNodeIds.has(targetId);
                    return bothHighlighted ? "black" : "rgba(0,0,0,0)";
                },
                linkWidth: 2.5,
                onNodeClick: (node)=>{
                    detailsPanelRef.current.open();
                    setSelectedNode(node);
                },
                nodeCanvasObject: (node, ctx)=>{
                    const label = node.label;
                    const fontSize = 32 + 64 * Math.min(node.members.length, 5);
                    ctx.font = `${fontSize}px Sans-Serif`;
                    const textWidth = ctx.measureText(label).width;
                    const padding = fontSize * 0.6;
                    const width = textWidth + padding;
                    const height = fontSize + padding;
                    const x = node.x - width / 2;
                    const y = node.y - height / 2;
                    const radius = node.type.includes("claim") ? fontSize * 6 : 0;
                    ctx.fillStyle = node.type.includes("claim") ? "DarkMagenta" : "green";
                    if (highlightedNodeIds.has(node.id)) {
                        (0, $21f819a4461f8efa$export$c40ecbf27f181c47)(ctx, x, y, width, height, radius);
                        ctx.fill();
                        ctx.strokeStyle = "white";
                        ctx.stroke();
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        ctx.fillStyle = "white";
                        ctx.fillText(label, node.x, node.y);
                    }
                    node.__bckgDimensions = [
                        width,
                        height
                    ];
                    node.__bckgPos = {
                        x: x,
                        y: y
                    };
                },
                nodePointerAreaPaint: (node, color, ctx)=>{
                    if (!highlightedNodeIds.has(node.id)) return;
                    const dims = node.__bckgDimensions;
                    const pos = node.__bckgPos;
                    if (!dims || !pos) return;
                    ctx.fillStyle = color;
                    (0, $21f819a4461f8efa$export$c40ecbf27f181c47)(ctx, pos.x, pos.y, dims[0], dims[1], 6);
                    ctx.fill();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5e037e99aaeb8b9f$export$cadf57dd3336ca84), {
                bot: "lg",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ad14db7d065b8e$export$e54a7f2505304e20), {
                        selectedNode: selectedNode,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($04ca73c2000c8168$exports))),
                        ref: detailsPanelRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
                        title: "Key",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    backgroundColor: "green"
                                },
                                className: "text-white p-1 text-xl mb-3",
                                children: "Trigger Event Cluster"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    backgroundColor: "DarkMagenta"
                                },
                                className: "text-white p-1 text-xl rounded-3xl",
                                children: "Claim Cluster"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
                        title: "Config",
                        defaultOpen: false,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mr-1 grow",
                                        children: "Show all"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: showAll,
                                        onChange: ()=>setShowAll(!showAll)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mr-1 grow",
                                        children: "Date Window (mos)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        className: "w-16 border-2",
                                        type: "number",
                                        value: filterLeeway,
                                        onChange: (e)=>setFilterLeeway(Number(e.target.value))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "fixed bottom-0 left-0 w-full bg-gray-600 p-3 z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "range",
                        min: timeRange.min,
                        max: timeRange.max,
                        value: inputDate,
                        onChange: (e)=>setInputDate(new Number(e.target.value)),
                        className: "w-full"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "text-white",
                        children: [
                            new Date(inputDate).toISOString().slice(0, 10),
                            " (\xb1 ",
                            filterLeeway,
                            " month(s) window)"
                        ]
                    })
                ]
            })
        ]
    });
}



function $93c05bd4543c9b04$export$b94310965bed44e6() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "m-3 bg-gray-200 rounded-3xl p-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "text-3xl text-center",
                            children: "LLMs for Disinformation Analysis"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "text-3xl text-center",
                            children: "Dataset Visualizations"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://jeynes.uk",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "underline text-center",
                                children: "By Will Jeynes"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-wrap justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "m-2 rounded-3xl w-full sm:w-[48%] bg-gray-200 p-10 flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#small",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-2xl text-center underline",
                                        children: "Default View"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#small",
                                    className: "m-5",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: "small.png",
                                        className: "border-2 h-64"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-center",
                                    children: "A filtered collection of the whole dataset, containing only reasonably sized components"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-center",
                                    children: "A great introduction to the dataset on a curated set of examples"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-center",
                                    children: [
                                        "Also ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            className: "underline",
                                            href: "#3d",
                                            children: "available in 3D"
                                        }),
                                        " (experimental)"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "m-2 rounded-3xl w-full sm:w-[48%] bg-gray-200 p-10 flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#time",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "text-2xl text-center underline",
                                        children: "Time Filtered"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "#time",
                                    className: "m-5",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: "time.png",
                                        className: "border-2 h-64"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-center",
                                    children: "A visualisation showing only the largest component, normally too large to be understandable"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-center",
                                    children: "Configurable, scrubber date filter allows migration to be seen over time"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "m-3 bg-gray-200 rounded-3xl p-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-xl font-semibold",
                            children: "Project Description"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-lg",
                            children: "Description coming soon"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-xl font-semibold mt-3",
                            children: "Sources"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-wrap",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://huggingface.co/datasets/WillJeynes/LLMsForDisinformationAnalysis-Dataset",
                                    className: "block bg-white rounded-xl px-4 py-2 underline text-center w-64 m-1",
                                    children: "Dataset (Hugging Face)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://github.com/WillJeynes/LLMsForDisinformationAnalysis/",
                                    className: "block bg-white rounded-xl px-4 py-2 underline text-center w-64 m-1",
                                    children: "Dataset GitHub"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "https://github.com/WillJeynes/LLMsForDisinformationPrediction/",
                                    className: "block bg-white rounded-xl px-4 py-2 underline text-center w-64 m-1",
                                    children: "Site Source Code"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $9ddd7e9b53f7a2d4$export$3545e07a80636437 = '184';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2 = 5;
/**
 * Represents material blending.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ec822fcd0c1d2914 = 6;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c = 1004;
const $9ddd7e9b53f7a2d4$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2 = 1005;
const $9ddd7e9b53f7a2d4$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$19a719f377145a13 = 1007;
const $9ddd7e9b53f7a2d4$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b = 1008;
const $9ddd7e9b53f7a2d4$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3 = 35902;
/**
 * An unsigned int 10_11_11 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f240f067f72abe41 = 35899;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8 = 37496;
/**
 * EAC R11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d5c566817123b2bf = 37488; // 0x9270
/**
 * EAC R11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f5668dc623297d86 = 37489; // 0x9271
/**
 * EAC RG11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf = 37490; // 0x9272
/**
 * EAC RG11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$211402338cb75433 = 37491; // 0x9273
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30 = 2302;
/**
 * Bezier interpolation mode for keyframe tracks.
 *
 * Uses cubic Bezier curves with explicit 2D control points.
 * Requires tangent data to be set on the track.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ad783ffd8f91a9e3 = 2303;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f0d8293634f88842 = 2;
/**
 * The depth value is inverted (1.0 - z) for visualization purposes.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$deeb383078690b50 = 3200;
/**
 * The depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8f910f4c4f73df11 = 3201;
/**
 * The depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$be2e2ddbc3983173 = 3202;
/**
 * The depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb = 'srgb';
/**
 * No normal map packing.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7f96a53e6ab01dca = '';
/**
 * Normal RG packing.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$bbd2d5168fed5fd6 = 'rg';
/**
 * Normal GA packing.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4f8d192b60f65626 = 'ga';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * Compatibility flags for features that may not be supported across all platforms.
 *
 * @type {Object}
 * @constant
 */ const $9ddd7e9b53f7a2d4$export$10255bda2baf681 = {
    TEXTURE_COMPARE: 'depthTextureCompare'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FIRST - Flat interpolation using the first vertex.
 * @property {string} EITHER - Flat interpolation using either vertex.
 */ /**
 * Checks if an array contains values that require Uint32 representation.
 *
 * This function determines whether the array contains any values >= 65535,
 * which would require a Uint32Array rather than a Uint16Array for proper storage.
 * The function iterates from the end of the array, assuming larger values are
 * typically located at the end.
 *
 * @private
 * @param {Array<number>} array - The array to check.
 * @return {boolean} True if the array contains values >= 65535, false otherwise.
 */ function $9ddd7e9b53f7a2d4$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
/**
 * Map of typed array constructor names to their constructors.
 * This mapping enables dynamic creation of typed arrays based on string type names.
 *
 * @private
 * @constant
 * @type {Object<string, TypedArrayConstructor>}
 */ const $9ddd7e9b53f7a2d4$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
/**
 * Creates a typed array of the specified type from the given buffer.
 *
 * @private
 * @param {string} type - The name of the typed array type (e.g., 'Float32Array', 'Uint16Array').
 * @param {ArrayBuffer} buffer - The buffer to create the typed array from.
 * @return {TypedArray} A new typed array of the specified type.
 */ function $9ddd7e9b53f7a2d4$var$getTypedArray(type, buffer) {
    return new $9ddd7e9b53f7a2d4$var$TYPED_ARRAYS[type](buffer);
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} array - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c(array) {
    return ArrayBuffer.isView(array) && !(array instanceof DataView);
}
/**
 * Creates an XHTML element with the specified tag name.
 *
 * This function uses the XHTML namespace to create DOM elements,
 * ensuring proper element creation in XML-based contexts.
 *
 * @private
 * @param {string} name - The tag name of the element to create (e.g., 'canvas', 'div').
 * @return {HTMLElement} The created XHTML element.
 */ function $9ddd7e9b53f7a2d4$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
/**
 * Creates a canvas element configured for block display.
 *
 * This is a convenience function that creates a canvas element with
 * display style set to 'block', which is commonly used in three.js
 * rendering contexts to avoid inline element spacing issues.
 *
 * @return {HTMLCanvasElement} A canvas element with display set to 'block'.
 */ function $9ddd7e9b53f7a2d4$export$1033a2df66368859() {
    const canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
/**
 * Internal cache for tracking warning messages to prevent duplicate warnings.
 *
 * @private
 * @type {Object<string, boolean>}
 */ const $9ddd7e9b53f7a2d4$var$_cache = {};
/**
 * Custom console function handler for intercepting log, warn, and error calls.
 *
 * @private
 * @type {Function|null}
 */ let $9ddd7e9b53f7a2d4$var$_setConsoleFunction = null;
/**
 * Sets a custom function to handle console output.
 *
 * This allows external code to intercept and handle console.log, console.warn,
 * and console.error calls made by three.js, which is useful for custom logging,
 * testing, or debugging workflows.
 *
 * @param {Function} fn - The function to handle console output. Should accept
 *                        (type, message, ...params) where type is 'log', 'warn', or 'error'.
 */ function $9ddd7e9b53f7a2d4$export$702823ffb42fb3aa(fn) {
    $9ddd7e9b53f7a2d4$var$_setConsoleFunction = fn;
}
/**
 * Gets the currently set custom console function.
 *
 * @return {Function|null} The custom console function, or null if not set.
 */ function $9ddd7e9b53f7a2d4$export$fa86edd994bb169f() {
    return $9ddd7e9b53f7a2d4$var$_setConsoleFunction;
}
/**
 * Logs an informational message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.log. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3(...params) {
    const message = 'THREE.' + params.shift();
    if ($9ddd7e9b53f7a2d4$var$_setConsoleFunction) $9ddd7e9b53f7a2d4$var$_setConsoleFunction('log', message, ...params);
    else console.log(message, ...params);
}
/**
 * Enhances log/warn/error messages related to TSL.
 *
 * @param {Array<any>} params - The original message parameters.
 * @returns {Array<any>} The filtered and enhanced message parameters.
 */ function $9ddd7e9b53f7a2d4$var$enhanceLogMessage(params) {
    const message = params[0];
    if (typeof message === 'string' && message.startsWith('TSL:')) {
        const stackTrace = params[1];
        if (stackTrace && stackTrace.isStackTrace) params[0] += ' ' + stackTrace.getLocation();
        else params[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
    }
    return params;
}
/**
 * Logs a warning message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.warn. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(...params) {
    params = $9ddd7e9b53f7a2d4$var$enhanceLogMessage(params);
    const message = 'THREE.' + params.shift();
    if ($9ddd7e9b53f7a2d4$var$_setConsoleFunction) $9ddd7e9b53f7a2d4$var$_setConsoleFunction('warn', message, ...params);
    else {
        const stackTrace = params[0];
        if (stackTrace && stackTrace.isStackTrace) console.warn(stackTrace.getError(message));
        else console.warn(message, ...params);
    }
}
/**
 * Logs an error message with the 'THREE.' prefix.
 *
 * If a custom console function is set via setConsoleFunction(), it will be used
 * instead of the native console.error. The first parameter is treated as the
 * method name and is automatically prefixed with 'THREE.'.
 *
 * @param {...any} params - The message components. The first param is used as
 *                          the method name and prefixed with 'THREE.'.
 */ function $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(...params) {
    params = $9ddd7e9b53f7a2d4$var$enhanceLogMessage(params);
    const message = 'THREE.' + params.shift();
    if ($9ddd7e9b53f7a2d4$var$_setConsoleFunction) $9ddd7e9b53f7a2d4$var$_setConsoleFunction('error', message, ...params);
    else {
        const stackTrace = params[0];
        if (stackTrace && stackTrace.isStackTrace) console.error(stackTrace.getError(message));
        else console.error(message, ...params);
    }
}
/**
 * Logs a warning message only once, preventing duplicate warnings.
 *
 * This function maintains an internal cache of warning messages and will only
 * output each unique warning message once. Useful for warnings that may be
 * triggered repeatedly but should only be shown to the user once.
 *
 * @param {...any} params - The warning message components.
 */ function $9ddd7e9b53f7a2d4$export$5b28268982f175ba(...params) {
    const message = params.join(' ');
    if (message in $9ddd7e9b53f7a2d4$var$_cache) return;
    $9ddd7e9b53f7a2d4$var$_cache[message] = true;
    $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(...params);
}
/**
 * Yields execution to the main thread to allow rendering and other tasks.
 * Uses scheduler.yield() when available (Chrome 115+), falls back to requestAnimationFrame.
 *
 * @return {Promise<void>}
 */ function $9ddd7e9b53f7a2d4$export$8af9927c09321dd4() {
    if (typeof self !== 'undefined' && typeof self.scheduler !== 'undefined' && typeof self.scheduler.yield !== 'undefined') return self.scheduler.yield();
    return new Promise((resolve)=>{
        requestAnimationFrame(resolve);
    });
}
/**
 * Asynchronously probes for WebGL sync object completion.
 *
 * This function creates a promise that resolves when the WebGL sync object
 * signals completion or rejects if the sync operation fails. It uses polling
 * at the specified interval to check the sync status without blocking the
 * main thread. This is useful for GPU-CPU synchronization in WebGL contexts.
 *
 * @private
 * @param {WebGL2RenderingContext} gl - The WebGL rendering context.
 * @param {WebGLSync} sync - The WebGL sync object to wait for.
 * @param {number} interval - The polling interval in milliseconds.
 * @return {Promise<void>} A promise that resolves when the sync completes or rejects if it fails.
 */ function $9ddd7e9b53f7a2d4$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * Used to select the correct depth functions
 * when reversed depth buffer is used.
 *
 * @private
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$export$611f4ad2374e11ff = {
    [$9ddd7e9b53f7a2d4$export$69025ce147cee220]: $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04,
    [$9ddd7e9b53f7a2d4$export$eedccec66ab7ebe]: $9ddd7e9b53f7a2d4$export$c5e2c52991f30937,
    [$9ddd7e9b53f7a2d4$export$a60d398fc7b7590e]: $9ddd7e9b53f7a2d4$export$2f843afa843d8916,
    [$9ddd7e9b53f7a2d4$export$296f78a0b892f81a]: $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4,
    [$9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04]: $9ddd7e9b53f7a2d4$export$69025ce147cee220,
    [$9ddd7e9b53f7a2d4$export$c5e2c52991f30937]: $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe,
    [$9ddd7e9b53f7a2d4$export$2f843afa843d8916]: $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e,
    [$9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4]: $9ddd7e9b53f7a2d4$export$296f78a0b892f81a
};
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js](https://github.com/mrdoob/eventdispatcher.js/)
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $9ddd7e9b53f7a2d4$var$_seed = 1234567;
const $9ddd7e9b53f7a2d4$var$DEG2RAD = Math.PI / 180;
const $9ddd7e9b53f7a2d4$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $9ddd7e9b53f7a2d4$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $9ddd7e9b53f7a2d4$var$_lut[d0 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 8 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d0 >> 24 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d1 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 8 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 16 & 0x0f | 0x40] + $9ddd7e9b53f7a2d4$var$_lut[d1 >> 24 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d2 & 0x3f | 0x80] + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 8 & 0xff] + '-' + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d2 >> 24 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 8 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 16 & 0xff] + $9ddd7e9b53f7a2d4$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $9ddd7e9b53f7a2d4$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $9ddd7e9b53f7a2d4$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value. `a2` must be greater than `a1`.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $9ddd7e9b53f7a2d4$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $9ddd7e9b53f7a2d4$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $9ddd7e9b53f7a2d4$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $9ddd7e9b53f7a2d4$var$damp(x, y, lambda, dt) {
    return $9ddd7e9b53f7a2d4$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($9ddd7e9b53f7a2d4$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
 *
 * @param {number} x - The value to evaluate based on its position between `min` and `max`.
 * @param {number} min - The min value. Any `x` value below `min` will be `0`. `min` must be lower than `max`.
 * @param {number} max - The max value. Any `x` value above `max` will be `1`. `max` must be greater than `min`.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
 * that has zero 1st and 2nd order derivatives at `x=0` and `x=1`.
 *
 * @param {number} x - The value to evaluate based on its position between `min` and `max`.
 * @param {number} min - The min value. Any `x` value below `min` will be `0`. `min` must be lower than `max`.
 * @param {number} max - The max value. Any `x` value above `max` will be `1`. `max` must be greater than `min`.
 * @return {number} The alternated value.
 */ function $9ddd7e9b53f7a2d4$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $9ddd7e9b53f7a2d4$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $9ddd7e9b53f7a2d4$var$seededRandom(s) {
    if (s !== undefined) $9ddd7e9b53f7a2d4$var$_seed = s;
    // Mulberry32 generator
    let t = $9ddd7e9b53f7a2d4$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $9ddd7e9b53f7a2d4$var$degToRad(degrees) {
    return degrees * $9ddd7e9b53f7a2d4$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $9ddd7e9b53f7a2d4$var$radToDeg(radians) {
    return radians * $9ddd7e9b53f7a2d4$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $9ddd7e9b53f7a2d4$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for. Must be greater than `0`.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $9ddd7e9b53f7a2d4$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for. Must be greater than `0`.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $9ddd7e9b53f7a2d4$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $9ddd7e9b53f7a2d4$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $9ddd7e9b53f7a2d4$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $9ddd7e9b53f7a2d4$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $9ddd7e9b53f7a2d4$var$DEG2RAD,
    RAD2DEG: $9ddd7e9b53f7a2d4$export$914076c8150813e5,
    /**
	 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $9ddd7e9b53f7a2d4$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $9ddd7e9b53f7a2d4$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $9ddd7e9b53f7a2d4$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $9ddd7e9b53f7a2d4$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $9ddd7e9b53f7a2d4$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $9ddd7e9b53f7a2d4$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $9ddd7e9b53f7a2d4$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $9ddd7e9b53f7a2d4$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $9ddd7e9b53f7a2d4$var$smoothstep,
    /**
	 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $9ddd7e9b53f7a2d4$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $9ddd7e9b53f7a2d4$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $9ddd7e9b53f7a2d4$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $9ddd7e9b53f7a2d4$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $9ddd7e9b53f7a2d4$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $9ddd7e9b53f7a2d4$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $9ddd7e9b53f7a2d4$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $9ddd7e9b53f7a2d4$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $9ddd7e9b53f7a2d4$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $9ddd7e9b53f7a2d4$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $9ddd7e9b53f7a2d4$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $9ddd7e9b53f7a2d4$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $9ddd7e9b53f7a2d4$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1.prototype.isVector2 = true;
    }
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9ddd7e9b53f7a2d4$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3 {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        let x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let dot = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1;
            if (dot < 0) {
                x1 = -x1;
                y1 = -y1;
                z1 = -z1;
                w1 = -w1;
                dot = -dot;
            }
            let s = 1 - t;
            if (dot < 0.9995) {
                // slerp
                const theta = Math.acos(dot);
                const sin = Math.sin(theta);
                s = Math.sin(s * theta) / sin;
                t = Math.sin(t * theta) / sin;
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
            } else {
                // for small angles, lerp then normalize
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($9ddd7e9b53f7a2d4$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between this quaternion and the target quaternion.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor. A value in the range `[0,1]` will interpolate. A value outside the range `[0,1]` will extrapolate.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        let x = qb._x, y = qb._y, z = qb._z, w = qb._w;
        let dot = this.dot(qb);
        if (dot < 0) {
            x = -x;
            y = -y;
            z = -z;
            w = -w;
            dot = -dot;
        }
        let s = 1 - t;
        if (dot < 0.9995) {
            // slerp
            const theta = Math.acos(dot);
            const sin = Math.sin(theta);
            s = Math.sin(s * theta) / sin;
            t = Math.sin(t * theta) / sin;
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this._onChangeCallback();
        } else {
            // for small angles, lerp then normalize
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this.normalize(); // normalize calls _onChangeCallback()
        }
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$64b5c384219d3699 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$64b5c384219d3699.prototype.isVector3 = true;
    }
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value.
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value.
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value.
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$5.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$5.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $9ddd7e9b53f7a2d4$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($9ddd7e9b53f7a2d4$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($9ddd7e9b53f7a2d4$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9ddd7e9b53f7a2d4$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$c = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$8ff26dafa08918 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$8ff26dafa08918.prototype.isMatrix3 = true;
    }
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($9ddd7e9b53f7a2d4$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $9ddd7e9b53f7a2d4$var$_m3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
const $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $9ddd7e9b53f7a2d4$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $9ddd7e9b53f7a2d4$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) {
                color.r = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.r);
                color.g = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.g);
                color.b = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) {
                color.r = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.r);
                color.g = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.g);
                color.b = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) return $9ddd7e9b53f7a2d4$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getToneMappingMode: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || 'standard';
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            $9ddd7e9b53f7a2d4$export$5b28268982f175ba('ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            $9ddd7e9b53f7a2d4$export$5b28268982f175ba('ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$9ddd7e9b53f7a2d4$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $9ddd7e9b53f7a2d4$export$f197347d588c1b4a,
            toXYZ: $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            }
        },
        [$9ddd7e9b53f7a2d4$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb,
            toXYZ: $9ddd7e9b53f7a2d4$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $9ddd7e9b53f7a2d4$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $9ddd7e9b53f7a2d4$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $9ddd7e9b53f7a2d4$export$5e6fd513f44698c = /*@__PURE__*/ $9ddd7e9b53f7a2d4$var$createColorManagement();
function $9ddd7e9b53f7a2d4$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $9ddd7e9b53f7a2d4$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $9ddd7e9b53f7a2d4$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($9ddd7e9b53f7a2d4$var$_canvas === undefined) $9ddd7e9b53f7a2d4$var$_canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
            $9ddd7e9b53f7a2d4$var$_canvas.width = image.width;
            $9ddd7e9b53f7a2d4$var$_canvas.height = image.height;
            const context = $9ddd7e9b53f7a2d4$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $9ddd7e9b53f7a2d4$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $9ddd7e9b53f7a2d4$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $9ddd7e9b53f7a2d4$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Returns the dimensions of the source into the given target vector.
	 *
	 * @param {(Vector2|Vector3)} target - The target object the result is written into.
	 * @return {(Vector2|Vector3)} The dimensions of the source.
	 */ getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight, 0);
        else if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) target.set(data.displayWidth, data.displayHeight, 0);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($9ddd7e9b53f7a2d4$var$serializeImage(data[i].image));
                else url.push($9ddd7e9b53f7a2d4$var$serializeImage(data[i]));
            } else // texture
            url = $9ddd7e9b53f7a2d4$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $9ddd7e9b53f7a2d4$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $9ddd7e9b53f7a2d4$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $9ddd7e9b53f7a2d4$var$_textureId = 0;
const $9ddd7e9b53f7a2d4$var$_tempVec3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$5431306cf43de24a extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06, wrapT = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06, magFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, minFilter = $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b, format = $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, type = $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10, anisotropy = $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_textureId++
        });
        /**
		 * The UUID of the texture.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the texture.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default Texture.DEFAULT_ANISOTROPY
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
        /**
		 * Whether the texture should use one of the 16 bit integer formats which are normalized
		 * to [0, 1] or [-1, 1] (depending on signed/unsigned) when sampled.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.normalized = false;
    }
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize($9ddd7e9b53f7a2d4$var$_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize($9ddd7e9b53f7a2d4$var$_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize($9ddd7e9b53f7a2d4$var$_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.normalized = source.normalized;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(`Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(`Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            normalized: this.normalized,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_MAPPING = $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $9ddd7e9b53f7a2d4$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3.prototype.isVector4 = true;
    }
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, min.x, max.x);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, min.y, max.y);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, min.z, max.z);
        this.w = $9ddd7e9b53f7a2d4$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $9ddd7e9b53f7a2d4$var$clamp(this.x, minVal, maxVal);
        this.y = $9ddd7e9b53f7a2d4$var$clamp(this.y, minVal, maxVal);
        this.z = $9ddd7e9b53f7a2d4$var$clamp(this.z, minVal, maxVal);
        this.w = $9ddd7e9b53f7a2d4$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($9ddd7e9b53f7a2d4$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a(image);
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                if (this.textures[i].isData3DTexture !== true) // TODO: Reconsider setting isArrayTexture flag here and in the ctor of Texture.
                // Maybe a method `isArrayTexture()` or just a getter could replace a flag since
                // both are evaluated on each call?
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        this.multiview = source.multiview;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f extends $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $9ddd7e9b53f7a2d4$export$c77a02c11ed180c7 extends $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$d7a3086320f856db extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $9ddd7e9b53f7a2d4$export$7ee06591009639df extends $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial](https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices)
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
    }
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        if (this.determinant() === 0) {
            xAxis.set(1, 0, 0);
            yAxis.set(0, 1, 0);
            zAxis.set(0, 0, 1);
            return this;
        }
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        if (m.determinant() === 0) return this.identity();
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $9ddd7e9b53f7a2d4$var$_v1$7.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $9ddd7e9b53f7a2d4$var$_v1$7.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $9ddd7e9b53f7a2d4$var$_v1$7.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($9ddd7e9b53f7a2d4$var$_zero, q, $9ddd7e9b53f7a2d4$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $9ddd7e9b53f7a2d4$var$_z.subVectors(eye, target);
        if ($9ddd7e9b53f7a2d4$var$_z.lengthSq() === 0) // eye and target are in the same position
        $9ddd7e9b53f7a2d4$var$_z.z = 1;
        $9ddd7e9b53f7a2d4$var$_z.normalize();
        $9ddd7e9b53f7a2d4$var$_x.crossVectors(up, $9ddd7e9b53f7a2d4$var$_z);
        if ($9ddd7e9b53f7a2d4$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $9ddd7e9b53f7a2d4$var$_z.x += 0.0001;
            else $9ddd7e9b53f7a2d4$var$_z.z += 0.0001;
            $9ddd7e9b53f7a2d4$var$_z.normalize();
            $9ddd7e9b53f7a2d4$var$_x.crossVectors(up, $9ddd7e9b53f7a2d4$var$_z);
        }
        $9ddd7e9b53f7a2d4$var$_x.normalize();
        $9ddd7e9b53f7a2d4$var$_y.crossVectors($9ddd7e9b53f7a2d4$var$_z, $9ddd7e9b53f7a2d4$var$_x);
        te[0] = $9ddd7e9b53f7a2d4$var$_x.x;
        te[4] = $9ddd7e9b53f7a2d4$var$_y.x;
        te[8] = $9ddd7e9b53f7a2d4$var$_z.x;
        te[1] = $9ddd7e9b53f7a2d4$var$_x.y;
        te[5] = $9ddd7e9b53f7a2d4$var$_y.y;
        te[9] = $9ddd7e9b53f7a2d4$var$_z.y;
        te[2] = $9ddd7e9b53f7a2d4$var$_x.z;
        te[6] = $9ddd7e9b53f7a2d4$var$_y.z;
        te[10] = $9ddd7e9b53f7a2d4$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        const t11 = n23 * n34 - n24 * n33;
        const t12 = n22 * n34 - n24 * n32;
        const t13 = n22 * n33 - n23 * n32;
        const t21 = n21 * n34 - n24 * n31;
        const t22 = n21 * n33 - n23 * n31;
        const t23 = n21 * n32 - n22 * n31;
        return n11 * (n42 * t11 - n43 * t12 + n44 * t13) - n12 * (n41 * t11 - n43 * t21 + n44 * t22) + n13 * (n41 * t12 - n42 * t21 + n44 * t23) - n14 * (n41 * t13 - n42 * t22 + n43 * t23);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on https://github.com/toji/gl-matrix
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t1 = n11 * n22 - n21 * n12, t2 = n11 * n32 - n31 * n12, t3 = n11 * n42 - n41 * n12, t4 = n21 * n32 - n31 * n22, t5 = n21 * n42 - n41 * n22, t6 = n31 * n42 - n41 * n32, t7 = n13 * n24 - n23 * n14, t8 = n13 * n34 - n33 * n14, t9 = n13 * n44 - n43 * n14, t10 = n23 * n34 - n33 * n24, t11 = n23 * n44 - n43 * n24, t12 = n33 * n44 - n43 * n34;
        const det = t1 * t12 - t2 * t11 + t3 * t10 + t4 * t9 - t5 * t8 + t6 * t7;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = (n22 * t12 - n32 * t11 + n42 * t10) * detInv;
        te[1] = (n31 * t11 - n21 * t12 - n41 * t10) * detInv;
        te[2] = (n24 * t6 - n34 * t5 + n44 * t4) * detInv;
        te[3] = (n33 * t5 - n23 * t6 - n43 * t4) * detInv;
        te[4] = (n32 * t9 - n12 * t12 - n42 * t8) * detInv;
        te[5] = (n11 * t12 - n31 * t9 + n41 * t8) * detInv;
        te[6] = (n34 * t3 - n14 * t6 - n44 * t2) * detInv;
        te[7] = (n13 * t6 - n33 * t3 + n43 * t2) * detInv;
        te[8] = (n12 * t11 - n22 * t9 + n42 * t7) * detInv;
        te[9] = (n21 * t9 - n11 * t11 - n41 * t7) * detInv;
        te[10] = (n14 * t5 - n24 * t3 + n44 * t1) * detInv;
        te[11] = (n23 * t3 - n13 * t5 - n43 * t1) * detInv;
        te[12] = (n22 * t8 - n12 * t10 - n32 * t7) * detInv;
        te[13] = (n11 * t10 - n21 * t8 + n31 * t7) * detInv;
        te[14] = (n24 * t2 - n14 * t4 - n34 * t1) * detInv;
        te[15] = (n13 * t4 - n23 * t2 + n33 * t1) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        const det = this.determinant();
        if (det === 0) {
            scale.set(1, 1, 1);
            quaternion.identity();
            return this;
        }
        let sx = $9ddd7e9b53f7a2d4$var$_v1$7.set(te[0], te[1], te[2]).length();
        const sy = $9ddd7e9b53f7a2d4$var$_v1$7.set(te[4], te[5], te[6]).length();
        const sz = $9ddd7e9b53f7a2d4$var$_v1$7.set(te[8], te[9], te[10]).length();
        // if determinant is negative, we need to invert one scale
        if (det < 0) sx = -sx;
        // scale the rotation part
        $9ddd7e9b53f7a2d4$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[0] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[1] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[2] *= invSX;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[4] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[5] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[6] *= invSY;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[8] *= invSZ;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[9] *= invSZ;
        $9ddd7e9b53f7a2d4$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = near / (far - near);
            d = far * near / (far - near);
        } else {
            if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
                c = -(far + near) / (far - near);
                d = -2 * far * near / (far - near);
            } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
                c = -far / (far - near);
                d = -far * near / (far - near);
            } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = 1 / (far - near);
            d = far / (far - near);
        } else {
            if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
                c = -2 / (far - near);
                d = -(far + near) / (far - near);
            } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
                c = -1 / (far - near);
                d = -near / (far - near);
            } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $9ddd7e9b53f7a2d4$var$_v1$7 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_m1$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_zero = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 0);
const $9ddd7e9b53f7a2d4$var$_one = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 1);
const $9ddd7e9b53f7a2d4$var$_x = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_y = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_z = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_matrix$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_quaternion$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($9ddd7e9b53f7a2d4$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$9ddd7e9b53f7a2d4$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $9ddd7e9b53f7a2d4$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $9ddd7e9b53f7a2d4$var$_quaternion$4.setFromEuler(this);
        return this.setFromQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$4, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $9ddd7e9b53f7a2d4$export$89312ce47c0ca777 {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let $9ddd7e9b53f7a2d4$var$_object3DId = 0;
const $9ddd7e9b53f7a2d4$var$_v1$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_q1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_m1$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_target = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_position$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_scale$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_xAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 0, 0);
const $9ddd7e9b53f7a2d4$var$_yAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0);
const $9ddd7e9b53f7a2d4$var$_zAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $9ddd7e9b53f7a2d4$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const rotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        const quaternion = new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
        const scale = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $9ddd7e9b53f7a2d4$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame. If set to `false`, the app is responsible for recomputing
		 * the local matrix by calling `updateMatrix()`.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy. If set to `false`, the app is responsible for
		 * recomputing the world matrix by directly updating the `matrixWorld` property.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $9ddd7e9b53f7a2d4$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * Whether the 3D object is supposed to be static or not. If set to `true`, it means
		 * the 3D object is not going to be changed after the initial renderer. This includes
		 * geometry and material settings. A static 3D object can be processed by the renderer
		 * slightly faster since certain state checks can be bypassed.
		 *
		 * Only relevant in context of {@link WebGPURenderer}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.static = false;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * The pivot point for rotation and scale transformations.
		 * When set, rotation and scale are applied around this point
		 * instead of the object's origin.
		 *
		 * @type {?Vector3}
		 * @default null
		 */ this.pivot = null;
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $9ddd7e9b53f7a2d4$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($9ddd7e9b53f7a2d4$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $9ddd7e9b53f7a2d4$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($9ddd7e9b53f7a2d4$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($9ddd7e9b53f7a2d4$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $9ddd7e9b53f7a2d4$var$_v1$6.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($9ddd7e9b53f7a2d4$var$_v1$6.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($9ddd7e9b53f7a2d4$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's world space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $9ddd7e9b53f7a2d4$var$_target.copy(x);
        else $9ddd7e9b53f7a2d4$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_position$4.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $9ddd7e9b53f7a2d4$var$_m1$1.lookAt($9ddd7e9b53f7a2d4$var$_position$4, $9ddd7e9b53f7a2d4$var$_target, this.up);
        else $9ddd7e9b53f7a2d4$var$_m1$1.lookAt($9ddd7e9b53f7a2d4$var$_target, $9ddd7e9b53f7a2d4$var$_position$4, this.up);
        this.quaternion.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$1);
        if (parent) {
            $9ddd7e9b53f7a2d4$var$_m1$1.extractRotation(parent.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_q1.setFromRotationMatrix($9ddd7e9b53f7a2d4$var$_m1$1);
            this.quaternion.premultiply($9ddd7e9b53f7a2d4$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($9ddd7e9b53f7a2d4$var$_addedEvent);
            $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = object;
            this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childaddedEvent);
            $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = null;
        } else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($9ddd7e9b53f7a2d4$var$_removedEvent);
            $9ddd7e9b53f7a2d4$var$_childremovedEvent.child = object;
            this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childremovedEvent);
            $9ddd7e9b53f7a2d4$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $9ddd7e9b53f7a2d4$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($9ddd7e9b53f7a2d4$var$_addedEvent);
        $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = object;
        this.dispatchEvent($9ddd7e9b53f7a2d4$var$_childaddedEvent);
        $9ddd7e9b53f7a2d4$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$4, target, $9ddd7e9b53f7a2d4$var$_scale$3);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$4, $9ddd7e9b53f7a2d4$var$_quaternion$3, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        const pivot = this.pivot;
        if (pivot !== null) {
            const px = pivot.x, py = pivot.y, pz = pivot.z;
            const te = this.matrix.elements;
            te[12] += px - te[0] * px - te[4] * py - te[8] * pz;
            te[13] += py - te[1] * px - te[5] * py - te[9] * pz;
            te[14] += pz - te[2] * px - te[6] * py - te[10] * pz;
        }
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldNeedsUpdate} is `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (this.static !== false) object.static = this.static;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.pivot !== null) object.pivot = this.pivot.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        if (this.morphTargetDictionary !== undefined) object.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary);
        if (this.morphTargetInfluences !== undefined) object.morphTargetInfluences = this.morphTargetInfluences.slice();
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>({
                    ...info,
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>({
                    ...info
                }));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.pivot = source.pivot !== null ? source.pivot.clone() : null;
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.static = source.static;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $9ddd7e9b53f7a2d4$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            this._grip.eventsEnabled = false;
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                    // grip update event if enabled
                    if (grip.eventsEnabled) grip.dispatchEvent({
                        type: 'gripUpdated',
                        data: inputSource,
                        target: this
                    });
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($9ddd7e9b53f7a2d4$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $9ddd7e9b53f7a2d4$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $9ddd7e9b53f7a2d4$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $9ddd7e9b53f7a2d4$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $9ddd7e9b53f7a2d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$892596cec99bc70e {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $9ddd7e9b53f7a2d4$var$euclideanModulo(h, 1);
        s = $9ddd7e9b53f7a2d4$var$clamp(s, 0, 1);
        l = $9ddd7e9b53f7a2d4$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h);
            this.b = $9ddd7e9b53f7a2d4$var$hue2rgb(q, p, h - 1 / 3);
        }
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        // color keywords
        const hex = $9ddd7e9b53f7a2d4$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.r);
        this.g = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.g);
        this.b = $9ddd7e9b53f7a2d4$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.r);
        this.g = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.g);
        this.b = $9ddd7e9b53f7a2d4$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingToColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        return Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.r * 255, 0, 255)) * 65536 + Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.g * 255, 0, 255)) * 256 + Math.round($9ddd7e9b53f7a2d4$var$clamp($9ddd7e9b53f7a2d4$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingToColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        const r = $9ddd7e9b53f7a2d4$var$_color.r, g = $9ddd7e9b53f7a2d4$var$_color.g, b = $9ddd7e9b53f7a2d4$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingToColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        target.r = $9ddd7e9b53f7a2d4$var$_color.r;
        target.g = $9ddd7e9b53f7a2d4$var$_color.g;
        target.b = $9ddd7e9b53f7a2d4$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) {
        $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingToColorSpace($9ddd7e9b53f7a2d4$var$_color.copy(this), colorSpace);
        const r = $9ddd7e9b53f7a2d4$var$_color.r, g = $9ddd7e9b53f7a2d4$var$_color.g, b = $9ddd7e9b53f7a2d4$var$_color.b;
        if (colorSpace !== $9ddd7e9b53f7a2d4$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($9ddd7e9b53f7a2d4$var$_hslA);
        return this.setHSL($9ddd7e9b53f7a2d4$var$_hslA.h + h, $9ddd7e9b53f7a2d4$var$_hslA.s + s, $9ddd7e9b53f7a2d4$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($9ddd7e9b53f7a2d4$var$_hslA);
        color.getHSL($9ddd7e9b53f7a2d4$var$_hslB);
        const h = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.h, $9ddd7e9b53f7a2d4$var$_hslB.h, alpha);
        const s = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.s, $9ddd7e9b53f7a2d4$var$_hslB.s, alpha);
        const l = $9ddd7e9b53f7a2d4$var$lerp($9ddd7e9b53f7a2d4$var$_hslA.l, $9ddd7e9b53f7a2d4$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $9ddd7e9b53f7a2d4$var$_color = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $9ddd7e9b53f7a2d4$export$892596cec99bc70e.NAMES = $9ddd7e9b53f7a2d4$var$_colorKeywords;
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$3c890837b09508d4 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$38af1803e3442a7f extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_v0$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v3$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vab = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vac = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vbc = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vap = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vbp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vcp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v40 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_v41 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_v42 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $9ddd7e9b53f7a2d4$export$5a465592bfe74b48 {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $9ddd7e9b53f7a2d4$var$_v0$2.subVectors(a, b);
        target.cross($9ddd7e9b53f7a2d4$var$_v0$2);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $9ddd7e9b53f7a2d4$var$_v0$2.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_v1$5.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_v2$4.subVectors(point, a);
        const dot00 = $9ddd7e9b53f7a2d4$var$_v0$2.dot($9ddd7e9b53f7a2d4$var$_v0$2);
        const dot01 = $9ddd7e9b53f7a2d4$var$_v0$2.dot($9ddd7e9b53f7a2d4$var$_v1$5);
        const dot02 = $9ddd7e9b53f7a2d4$var$_v0$2.dot($9ddd7e9b53f7a2d4$var$_v2$4);
        const dot11 = $9ddd7e9b53f7a2d4$var$_v1$5.dot($9ddd7e9b53f7a2d4$var$_v1$5);
        const dot12 = $9ddd7e9b53f7a2d4$var$_v1$5.dot($9ddd7e9b53f7a2d4$var$_v2$4);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $9ddd7e9b53f7a2d4$var$_v3$2) === null) return false;
        return $9ddd7e9b53f7a2d4$var$_v3$2.x >= 0 && $9ddd7e9b53f7a2d4$var$_v3$2.y >= 0 && $9ddd7e9b53f7a2d4$var$_v3$2.x + $9ddd7e9b53f7a2d4$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $9ddd7e9b53f7a2d4$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $9ddd7e9b53f7a2d4$var$_v3$2.x);
        target.addScaledVector(v2, $9ddd7e9b53f7a2d4$var$_v3$2.y);
        target.addScaledVector(v3, $9ddd7e9b53f7a2d4$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $9ddd7e9b53f7a2d4$var$_v40.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v41.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v42.setScalar(0);
        $9ddd7e9b53f7a2d4$var$_v40.fromBufferAttribute(attr, i1);
        $9ddd7e9b53f7a2d4$var$_v41.fromBufferAttribute(attr, i2);
        $9ddd7e9b53f7a2d4$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v40, barycoord.x);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v41, barycoord.y);
        target.addScaledVector($9ddd7e9b53f7a2d4$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $9ddd7e9b53f7a2d4$var$_v0$2.subVectors(c, b);
        $9ddd7e9b53f7a2d4$var$_v1$5.subVectors(a, b);
        // strictly front facing
        return $9ddd7e9b53f7a2d4$var$_v0$2.cross($9ddd7e9b53f7a2d4$var$_v1$5).dot(direction) < 0;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $9ddd7e9b53f7a2d4$var$_v0$2.subVectors(this.c, this.b);
        $9ddd7e9b53f7a2d4$var$_v1$5.subVectors(this.a, this.b);
        return $9ddd7e9b53f7a2d4$var$_v0$2.cross($9ddd7e9b53f7a2d4$var$_v1$5).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $9ddd7e9b53f7a2d4$var$_vab.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_vac.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_vap.subVectors(p, a);
        const d1 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vap);
        const d2 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $9ddd7e9b53f7a2d4$var$_vbp.subVectors(p, b);
        const d3 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vbp);
        const d4 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vab, v);
        }
        $9ddd7e9b53f7a2d4$var$_vcp.subVectors(p, c);
        const d5 = $9ddd7e9b53f7a2d4$var$_vab.dot($9ddd7e9b53f7a2d4$var$_vcp);
        const d6 = $9ddd7e9b53f7a2d4$var$_vac.dot($9ddd7e9b53f7a2d4$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $9ddd7e9b53f7a2d4$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($9ddd7e9b53f7a2d4$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($9ddd7e9b53f7a2d4$var$_vab, v).addScaledVector($9ddd7e9b53f7a2d4$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $9ddd7e9b53f7a2d4$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vector$b);
                else $9ddd7e9b53f7a2d4$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $9ddd7e9b53f7a2d4$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $9ddd7e9b53f7a2d4$var$_box$4.copy(geometry.boundingBox);
                }
                $9ddd7e9b53f7a2d4$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($9ddd7e9b53f7a2d4$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $9ddd7e9b53f7a2d4$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $9ddd7e9b53f7a2d4$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_extents.subVectors(this.max, $9ddd7e9b53f7a2d4$var$_center);
        // translate triangle to aabb origin
        $9ddd7e9b53f7a2d4$var$_v0$1.subVectors(triangle.a, $9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_v1$4.subVectors(triangle.b, $9ddd7e9b53f7a2d4$var$_center);
        $9ddd7e9b53f7a2d4$var$_v2$3.subVectors(triangle.c, $9ddd7e9b53f7a2d4$var$_center);
        // compute edge vectors for triangle
        $9ddd7e9b53f7a2d4$var$_f0.subVectors($9ddd7e9b53f7a2d4$var$_v1$4, $9ddd7e9b53f7a2d4$var$_v0$1);
        $9ddd7e9b53f7a2d4$var$_f1.subVectors($9ddd7e9b53f7a2d4$var$_v2$3, $9ddd7e9b53f7a2d4$var$_v1$4);
        $9ddd7e9b53f7a2d4$var$_f2.subVectors($9ddd7e9b53f7a2d4$var$_v0$1, $9ddd7e9b53f7a2d4$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$9ddd7e9b53f7a2d4$var$_f0.z,
            $9ddd7e9b53f7a2d4$var$_f0.y,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.z,
            $9ddd7e9b53f7a2d4$var$_f1.y,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.z,
            $9ddd7e9b53f7a2d4$var$_f2.y,
            $9ddd7e9b53f7a2d4$var$_f0.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f0.x,
            $9ddd7e9b53f7a2d4$var$_f1.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.x,
            $9ddd7e9b53f7a2d4$var$_f2.z,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.x,
            -$9ddd7e9b53f7a2d4$var$_f0.y,
            $9ddd7e9b53f7a2d4$var$_f0.x,
            0,
            -$9ddd7e9b53f7a2d4$var$_f1.y,
            $9ddd7e9b53f7a2d4$var$_f1.x,
            0,
            -$9ddd7e9b53f7a2d4$var$_f2.y,
            $9ddd7e9b53f7a2d4$var$_f2.x,
            0
        ];
        if (!$9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$1, $9ddd7e9b53f7a2d4$var$_v1$4, $9ddd7e9b53f7a2d4$var$_v2$3, $9ddd7e9b53f7a2d4$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$1, $9ddd7e9b53f7a2d4$var$_v1$4, $9ddd7e9b53f7a2d4$var$_v2$3, $9ddd7e9b53f7a2d4$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $9ddd7e9b53f7a2d4$var$_triangleNormal.crossVectors($9ddd7e9b53f7a2d4$var$_f0, $9ddd7e9b53f7a2d4$var$_f1);
        axes = [
            $9ddd7e9b53f7a2d4$var$_triangleNormal.x,
            $9ddd7e9b53f7a2d4$var$_triangleNormal.y,
            $9ddd7e9b53f7a2d4$var$_triangleNormal.z
        ];
        return $9ddd7e9b53f7a2d4$var$satForAxes(axes, $9ddd7e9b53f7a2d4$var$_v0$1, $9ddd7e9b53f7a2d4$var$_v1$4, $9ddd7e9b53f7a2d4$var$_v2$3, $9ddd7e9b53f7a2d4$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $9ddd7e9b53f7a2d4$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($9ddd7e9b53f7a2d4$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $9ddd7e9b53f7a2d4$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $9ddd7e9b53f7a2d4$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $9ddd7e9b53f7a2d4$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $9ddd7e9b53f7a2d4$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $9ddd7e9b53f7a2d4$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $9ddd7e9b53f7a2d4$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $9ddd7e9b53f7a2d4$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $9ddd7e9b53f7a2d4$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($9ddd7e9b53f7a2d4$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_points = [
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()
];
const $9ddd7e9b53f7a2d4$var$_vector$b = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_box$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $9ddd7e9b53f7a2d4$var$_v0$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
// triangle edge vectors
const $9ddd7e9b53f7a2d4$var$_f0 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_f1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_f2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_center = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_extents = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_triangleNormal = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_testAxis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
function $9ddd7e9b53f7a2d4$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $9ddd7e9b53f7a2d4$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.x) + extents.y * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.y) + extents.z * Math.abs($9ddd7e9b53f7a2d4$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        const p1 = v1.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        const p2 = v2.dot($9ddd7e9b53f7a2d4$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $9ddd7e9b53f7a2d4$var$_tables = /*@__PURE__*/ $9ddd7e9b53f7a2d4$var$_generateTables();
function $9ddd7e9b53f7a2d4$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $9ddd7e9b53f7a2d4$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('DataUtils.toHalfFloat(): Value out of range.');
    val = $9ddd7e9b53f7a2d4$var$clamp(val, -65504, 65504);
    $9ddd7e9b53f7a2d4$var$_tables.floatView[0] = val;
    const f = $9ddd7e9b53f7a2d4$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $9ddd7e9b53f7a2d4$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $9ddd7e9b53f7a2d4$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $9ddd7e9b53f7a2d4$var$fromHalfFloat(val) {
    const m = val >> 10;
    $9ddd7e9b53f7a2d4$var$_tables.uint32View[0] = $9ddd7e9b53f7a2d4$var$_tables.mantissaTable[$9ddd7e9b53f7a2d4$var$_tables.offsetTable[m] + (val & 0x3ff)] + $9ddd7e9b53f7a2d4$var$_tables.exponentTable[m];
    return $9ddd7e9b53f7a2d4$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $9ddd7e9b53f7a2d4$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $9ddd7e9b53f7a2d4$var$fromHalfFloat(val);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$a = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vector2$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
let $9ddd7e9b53f7a2d4$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        super();
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $9ddd7e9b53f7a2d4$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector2$1.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $9ddd7e9b53f7a2d4$var$_vector2$1.x, $9ddd7e9b53f7a2d4$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$a.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$a.applyMatrix3(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$a.x, $9ddd7e9b53f7a2d4$var$_vector$a.y, $9ddd7e9b53f7a2d4$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$a.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$a.applyMatrix4(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$a.x, $9ddd7e9b53f7a2d4$var$_vector$a.y, $9ddd7e9b53f7a2d4$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$a.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$a.applyNormalMatrix(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$a.x, $9ddd7e9b53f7a2d4$var$_vector$a.y, $9ddd7e9b53f7a2d4$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$a.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$a.transformDirection(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$a.x, $9ddd7e9b53f7a2d4$var$_vector$a.y, $9ddd7e9b53f7a2d4$var$_vector$a.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
    /**
	 * Disposes of the buffer attribute. Available only in {@link WebGPURenderer}.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$f9ff2d6a20248cbf extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$cacc90cf35d11cdd extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$baaa85a1a812c157 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$2b755a102ccdcefe extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$640a853f68025f2e extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$46b369aed2968a0a extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$dbd3698c64958d69 extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $9ddd7e9b53f7a2d4$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $9ddd7e9b53f7a2d4$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        this.array[index + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.array[index + 0] = $9ddd7e9b53f7a2d4$var$toHalfFloat(x);
        this.array[index + 1] = $9ddd7e9b53f7a2d4$var$toHalfFloat(y);
        this.array[index + 2] = $9ddd7e9b53f7a2d4$var$toHalfFloat(z);
        this.array[index + 3] = $9ddd7e9b53f7a2d4$var$toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
const $9ddd7e9b53f7a2d4$var$_box$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_v1$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $9ddd7e9b53f7a2d4$export$805e8b72413ccaba {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $9ddd7e9b53f7a2d4$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $9ddd7e9b53f7a2d4$var$_v1$3.subVectors(point, this.center);
        const lengthSq = $9ddd7e9b53f7a2d4$var$_v1$3.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($9ddd7e9b53f7a2d4$var$_v1$3, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $9ddd7e9b53f7a2d4$var$_v2$2.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($9ddd7e9b53f7a2d4$var$_v1$3.copy(sphere.center).add($9ddd7e9b53f7a2d4$var$_v2$2));
            this.expandByPoint($9ddd7e9b53f7a2d4$var$_v1$3.copy(sphere.center).sub($9ddd7e9b53f7a2d4$var$_v2$2));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Sphere} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
}
let $9ddd7e9b53f7a2d4$var$_id$1 = 0;
const $9ddd7e9b53f7a2d4$var$_m1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_obj = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
const $9ddd7e9b53f7a2d4$var$_offset = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_box$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_boxMorphTargets = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_vector$9 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$b7be63a67df8959 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {number|Array<number>}
		 * @default 0
		 */ this.indirectOffset = 0;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()`, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($9ddd7e9b53f7a2d4$var$arrayNeedsUint32(index) ? $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6 : $9ddd7e9b53f7a2d4$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect, indirectOffset = 0) {
        this.indirect = indirect;
        this.indirectOffset = indirectOffset;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationX(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationY(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $9ddd7e9b53f7a2d4$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $9ddd7e9b53f7a2d4$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $9ddd7e9b53f7a2d4$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $9ddd7e9b53f7a2d4$var$_obj.lookAt(vector);
        $9ddd7e9b53f7a2d4$var$_obj.updateMatrix();
        this.applyMatrix4($9ddd7e9b53f7a2d4$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($9ddd7e9b53f7a2d4$var$_offset).negate();
        this.translate($9ddd7e9b53f7a2d4$var$_offset.x, $9ddd7e9b53f7a2d4$var$_offset.y, $9ddd7e9b53f7a2d4$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9ddd7e9b53f7a2d4$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9ddd7e9b53f7a2d4$var$_vector$9.addVectors(this.boundingBox.min, $9ddd7e9b53f7a2d4$var$_box$2.min);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$9);
                    $9ddd7e9b53f7a2d4$var$_vector$9.addVectors(this.boundingBox.max, $9ddd7e9b53f7a2d4$var$_box$2.max);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$9);
                } else {
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_box$2.min);
                    this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $9ddd7e9b53f7a2d4$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9ddd7e9b53f7a2d4$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9ddd7e9b53f7a2d4$var$_vector$9.addVectors($9ddd7e9b53f7a2d4$var$_box$2.min, $9ddd7e9b53f7a2d4$var$_boxMorphTargets.min);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$9);
                    $9ddd7e9b53f7a2d4$var$_vector$9.addVectors($9ddd7e9b53f7a2d4$var$_box$2.max, $9ddd7e9b53f7a2d4$var$_boxMorphTargets.max);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$9);
                } else {
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_boxMorphTargets.min);
                    $9ddd7e9b53f7a2d4$var$_box$2.expandByPoint($9ddd7e9b53f7a2d4$var$_boxMorphTargets.max);
                }
            }
            $9ddd7e9b53f7a2d4$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$9));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $9ddd7e9b53f7a2d4$var$_offset.fromBufferAttribute(position, j);
                        $9ddd7e9b53f7a2d4$var$_vector$9.add($9ddd7e9b53f7a2d4$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$9));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            tan2[i] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        }
        const vA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), vB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), vC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), uvA = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), uvB = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), uvC = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), sdir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), tdir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), tmp2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const n = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), n2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), pB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), pC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const nA = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), nB = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), nC = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const cb = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), ab = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $9ddd7e9b53f7a2d4$var$_vector$9.fromBufferAttribute(normals, i);
            $9ddd7e9b53f7a2d4$var$_vector$9.normalize();
            normals.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$9.x, $9ddd7e9b53f7a2d4$var$_vector$9.y, $9ddd7e9b53f7a2d4$var$_vector$9.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics](https://blog.tojicode.com/2011/05/interleaved-array-basics.html)
 */ class $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$8 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $9ddd7e9b53f7a2d4$export$920b6d07334599c7 {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$8.x, $9ddd7e9b53f7a2d4$var$_vector$8.y, $9ddd7e9b53f7a2d4$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$8.x, $9ddd7e9b53f7a2d4$var$_vector$8.y, $9ddd7e9b53f7a2d4$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9ddd7e9b53f7a2d4$var$_vector$8.fromBufferAttribute(this, i);
            $9ddd7e9b53f7a2d4$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $9ddd7e9b53f7a2d4$var$_vector$8.x, $9ddd7e9b53f7a2d4$var$_vector$8.y, $9ddd7e9b53f7a2d4$var$_vector$8.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $9ddd7e9b53f7a2d4$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $9ddd7e9b53f7a2d4$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $9ddd7e9b53f7a2d4$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $9ddd7e9b53f7a2d4$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $9ddd7e9b53f7a2d4$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9ddd7e9b53f7a2d4$var$normalize(x, this.array);
            y = $9ddd7e9b53f7a2d4$var$normalize(y, this.array);
            z = $9ddd7e9b53f7a2d4$var$normalize(z, this.array);
            w = $9ddd7e9b53f7a2d4$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3('InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3('InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
let $9ddd7e9b53f7a2d4$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $9ddd7e9b53f7a2d4$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $9ddd7e9b53f7a2d4$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $9ddd7e9b53f7a2d4$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $9ddd7e9b53f7a2d4$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $9ddd7e9b53f7a2d4$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(`Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(`Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $9ddd7e9b53f7a2d4$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $9ddd7e9b53f7a2d4$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $9ddd7e9b53f7a2d4$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $9ddd7e9b53f7a2d4$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $9ddd7e9b53f7a2d4$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.allowOverride === false) data.allowOverride = false;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.allowOverride = source.allowOverride;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $9ddd7e9b53f7a2d4$var$_geometry;
const $9ddd7e9b53f7a2d4$var$_intersectPoint = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_worldScale = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_mvPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_alignedPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_rotatedPosition = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_viewWorldMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_vA$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vB$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vC$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_uvA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_uvB = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_uvC = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$3075603db8e6204c extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
	 */ constructor(material = new $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($9ddd7e9b53f7a2d4$var$_geometry === undefined) {
            $9ddd7e9b53f7a2d4$var$_geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f(float32Array, 5);
            $9ddd7e9b53f7a2d4$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $9ddd7e9b53f7a2d4$var$_geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $9ddd7e9b53f7a2d4$var$_geometry.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $9ddd7e9b53f7a2d4$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {(SpriteMaterial|SpriteNodeMaterial)}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $9ddd7e9b53f7a2d4$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $9ddd7e9b53f7a2d4$var$_worldScale.multiplyScalar(-$9ddd7e9b53f7a2d4$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vA$1.set(-0.5, -0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vB$1.set(0.5, -0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vC$1.set(0.5, 0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
        $9ddd7e9b53f7a2d4$var$_uvA.set(0, 0);
        $9ddd7e9b53f7a2d4$var$_uvB.set(1, 0);
        $9ddd7e9b53f7a2d4$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vB$1, $9ddd7e9b53f7a2d4$var$_vC$1, false, $9ddd7e9b53f7a2d4$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $9ddd7e9b53f7a2d4$var$transformVertex($9ddd7e9b53f7a2d4$var$_vB$1.set(-0.5, 0.5, 0), $9ddd7e9b53f7a2d4$var$_mvPosition, center, $9ddd7e9b53f7a2d4$var$_worldScale, sin, cos);
            $9ddd7e9b53f7a2d4$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vC$1, $9ddd7e9b53f7a2d4$var$_vB$1, false, $9ddd7e9b53f7a2d4$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $9ddd7e9b53f7a2d4$var$_intersectPoint.clone(),
            uv: $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolation($9ddd7e9b53f7a2d4$var$_intersectPoint, $9ddd7e9b53f7a2d4$var$_vA$1, $9ddd7e9b53f7a2d4$var$_vB$1, $9ddd7e9b53f7a2d4$var$_vC$1, $9ddd7e9b53f7a2d4$var$_uvA, $9ddd7e9b53f7a2d4$var$_uvB, $9ddd7e9b53f7a2d4$var$_uvC, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $9ddd7e9b53f7a2d4$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $9ddd7e9b53f7a2d4$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $9ddd7e9b53f7a2d4$var$_rotatedPosition.x = cos * $9ddd7e9b53f7a2d4$var$_alignedPosition.x - sin * $9ddd7e9b53f7a2d4$var$_alignedPosition.y;
        $9ddd7e9b53f7a2d4$var$_rotatedPosition.y = sin * $9ddd7e9b53f7a2d4$var$_alignedPosition.x + cos * $9ddd7e9b53f7a2d4$var$_alignedPosition.y;
    } else $9ddd7e9b53f7a2d4$var$_rotatedPosition.copy($9ddd7e9b53f7a2d4$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $9ddd7e9b53f7a2d4$var$_rotatedPosition.x;
    vertexPosition.y += $9ddd7e9b53f7a2d4$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($9ddd7e9b53f7a2d4$var$_viewWorldMatrix);
}
const $9ddd7e9b53f7a2d4$var$_v1$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$112e7237be0c5f30 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {?Object3D} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $9ddd7e9b53f7a2d4$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $9ddd7e9b53f7a2d4$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $9ddd7e9b53f7a2d4$var$_v1$2.distanceTo($9ddd7e9b53f7a2d4$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$7 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_segCenter = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_segDir = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_diff = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_edge1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_edge2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normal$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $9ddd7e9b53f7a2d4$export$a186db52eed6d40e {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), direction = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $9ddd7e9b53f7a2d4$var$_vector$7));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $9ddd7e9b53f7a2d4$var$_vector$7.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $9ddd7e9b53f7a2d4$var$_vector$7.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $9ddd7e9b53f7a2d4$var$_vector$7.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $9ddd7e9b53f7a2d4$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $9ddd7e9b53f7a2d4$var$_segDir.copy(v1).sub(v0).normalize();
        $9ddd7e9b53f7a2d4$var$_diff.copy(this.origin).sub($9ddd7e9b53f7a2d4$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($9ddd7e9b53f7a2d4$var$_segDir);
        const b0 = $9ddd7e9b53f7a2d4$var$_diff.dot(this.direction);
        const b1 = -$9ddd7e9b53f7a2d4$var$_diff.dot($9ddd7e9b53f7a2d4$var$_segDir);
        const c = $9ddd7e9b53f7a2d4$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($9ddd7e9b53f7a2d4$var$_segCenter).addScaledVector($9ddd7e9b53f7a2d4$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $9ddd7e9b53f7a2d4$var$_vector$7.subVectors(sphere.center, this.origin);
        const tca = $9ddd7e9b53f7a2d4$var$_vector$7.dot(this.direction);
        const d2 = $9ddd7e9b53f7a2d4$var$_vector$7.dot($9ddd7e9b53f7a2d4$var$_vector$7) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $9ddd7e9b53f7a2d4$var$_vector$7) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $9ddd7e9b53f7a2d4$var$_edge1.subVectors(b, a);
        $9ddd7e9b53f7a2d4$var$_edge2.subVectors(c, a);
        $9ddd7e9b53f7a2d4$var$_normal$1.crossVectors($9ddd7e9b53f7a2d4$var$_edge1, $9ddd7e9b53f7a2d4$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($9ddd7e9b53f7a2d4$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $9ddd7e9b53f7a2d4$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($9ddd7e9b53f7a2d4$var$_edge2.crossVectors($9ddd7e9b53f7a2d4$var$_diff, $9ddd7e9b53f7a2d4$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($9ddd7e9b53f7a2d4$var$_edge1.cross($9ddd7e9b53f7a2d4$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $9ddd7e9b53f7a2d4$var$_diff.dot($9ddd7e9b53f7a2d4$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshBasicMaterial
 */ class $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_sphereHitAt = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vB = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vC = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_tempA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_morphA = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectionPoint = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectionPointWorld = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$e176487c05830cc5 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $9ddd7e9b53f7a2d4$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $9ddd7e9b53f7a2d4$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $9ddd7e9b53f7a2d4$var$_morphA.addScaledVector($9ddd7e9b53f7a2d4$var$_tempA, influence);
                else $9ddd7e9b53f7a2d4$var$_morphA.addScaledVector($9ddd7e9b53f7a2d4$var$_tempA.sub(target), influence);
            }
            target.add($9ddd7e9b53f7a2d4$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$6.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $9ddd7e9b53f7a2d4$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($9ddd7e9b53f7a2d4$var$_sphere$6.containsPoint($9ddd7e9b53f7a2d4$var$_ray$3.origin) === false) {
            if ($9ddd7e9b53f7a2d4$var$_ray$3.intersectSphere($9ddd7e9b53f7a2d4$var$_sphere$6, $9ddd7e9b53f7a2d4$var$_sphereHitAt) === null) return;
            if ($9ddd7e9b53f7a2d4$var$_ray$3.origin.distanceToSquared($9ddd7e9b53f7a2d4$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$3.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($9ddd7e9b53f7a2d4$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9ddd7e9b53f7a2d4$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $9ddd7e9b53f7a2d4$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.copy(point);
    $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $9ddd7e9b53f7a2d4$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $9ddd7e9b53f7a2d4$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $9ddd7e9b53f7a2d4$var$_vA);
    object.getVertexPosition(b, $9ddd7e9b53f7a2d4$var$_vB);
    object.getVertexPosition(c, $9ddd7e9b53f7a2d4$var$_vC);
    const intersection = $9ddd7e9b53f7a2d4$var$checkIntersection$1(object, material, raycaster, ray, $9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vB, $9ddd7e9b53f7a2d4$var$_vC, $9ddd7e9b53f7a2d4$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getBarycoord($9ddd7e9b53f7a2d4$var$_intersectionPoint, $9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vB, $9ddd7e9b53f7a2d4$var$_vC, barycoord);
        if (uv) intersection.uv = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $9ddd7e9b53f7a2d4$export$5a465592bfe74b48.getNormal($9ddd7e9b53f7a2d4$var$_vA, $9ddd7e9b53f7a2d4$var$_vB, $9ddd7e9b53f7a2d4$var$_vC, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
const $9ddd7e9b53f7a2d4$var$_baseVector = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_skinIndex = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_skinWeight = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_vector4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
const $9ddd7e9b53f7a2d4$var$_matrix4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_vertex = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_sphere$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 * @demo scenes/bones-browser.html
 */ class $9ddd7e9b53f7a2d4$export$b303577035157ecf extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $9ddd7e9b53f7a2d4$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vertex);
            this.boundingBox.expandByPoint($9ddd7e9b53f7a2d4$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $9ddd7e9b53f7a2d4$var$_vertex);
            this.boundingSphere.expandByPoint($9ddd7e9b53f7a2d4$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$5.copy(this.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$2.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($9ddd7e9b53f7a2d4$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9ddd7e9b53f7a2d4$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $9ddd7e9b53f7a2d4$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $9ddd7e9b53f7a2d4$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vector. Can be used to transform positions or direction vectors by providing
	 * a Vector4 with 1 or 0 in the w component respectively. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3|Vector4} target - The target object that is used to store the method's result.
	 * @return {Vector3|Vector4} The updated vertex attribute data.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $9ddd7e9b53f7a2d4$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $9ddd7e9b53f7a2d4$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        if (target.isVector4) {
            $9ddd7e9b53f7a2d4$var$_baseVector.copy(target);
            target.set(0, 0, 0, 0);
        } else {
            $9ddd7e9b53f7a2d4$var$_baseVector.set(...target, 1);
            target.set(0, 0, 0);
        }
        $9ddd7e9b53f7a2d4$var$_baseVector.applyMatrix4(this.bindMatrix);
        for(let i = 0; i < 4; i++){
            const weight = $9ddd7e9b53f7a2d4$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $9ddd7e9b53f7a2d4$var$_skinIndex.getComponent(i);
                $9ddd7e9b53f7a2d4$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($9ddd7e9b53f7a2d4$var$_vector4.copy($9ddd7e9b53f7a2d4$var$_baseVector).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix4), weight);
            }
        }
        if (target.isVector4) // ensure the homogenous coordinate remains unchanged after vector operations
        target.w = $9ddd7e9b53f7a2d4$var$_baseVector.w;
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$b127726e56765aa4 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$b691f601014eabe1 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $9ddd7e9b53f7a2d4$var$_offsetMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_identityMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * An array buffer holding the bone data of the previous frame.
		 * Required for computing velocity. Maintained in {@link SkinningNode}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.previousBoneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $9ddd7e9b53f7a2d4$var$_identityMatrix;
            $9ddd7e9b53f7a2d4$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $9ddd7e9b53f7a2d4$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(boneMatrices, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Skeleton: No bone found with UUID:', uuid);
                bone = new $9ddd7e9b53f7a2d4$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a extends $9ddd7e9b53f7a2d4$export$8dea267bd6bde117 {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_instanceIntersects = [];
const $9ddd7e9b53f7a2d4$var$_box3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_identity = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_mesh$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e176487c05830cc5();
const $9ddd7e9b53f7a2d4$var$_sphere$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$f3c979c331175ad7 extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the local transformation of all instances of the previous frame.
		 * Required for computing velocity. Maintained in {@link InstanceNode}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.previousInstanceMatrix = null;
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $9ddd7e9b53f7a2d4$var$_identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_box3.copy(geometry.boundingBox).applyMatrix4($9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            this.boundingBox.union($9ddd7e9b53f7a2d4$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            this.boundingSphere.union($9ddd7e9b53f7a2d4$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.previousInstanceMatrix !== null) this.previousInstanceMatrix = source.previousInstanceMatrix.clone();
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} A reference to the target color.
	 */ getColorAt(index, color) {
        if (this.instanceColor === null) return color.setRGB(1, 1, 1);
        else return color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} A reference to the target matrix.
	 */ getMatrixAt(index, matrix) {
        return matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $9ddd7e9b53f7a2d4$var$_mesh$1.geometry = this.geometry;
        $9ddd7e9b53f7a2d4$var$_mesh$1.material = this.material;
        if ($9ddd7e9b53f7a2d4$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$4.copy(this.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $9ddd7e9b53f7a2d4$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $9ddd7e9b53f7a2d4$var$_mesh$1.matrixWorld = $9ddd7e9b53f7a2d4$var$_instanceWorldMatrix;
            $9ddd7e9b53f7a2d4$var$_mesh$1.raycast(raycaster, $9ddd7e9b53f7a2d4$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $9ddd7e9b53f7a2d4$var$_instanceIntersects.length; i < l; i++){
                const intersect = $9ddd7e9b53f7a2d4$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $9ddd7e9b53f7a2d4$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 * @return {InstancedMesh} A reference to this instanced mesh.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
        return this;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the matrices.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 * @return {InstancedMesh} A reference to this instanced mesh.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
        return this;
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 * @return {InstancedMesh} A reference to this instanced mesh.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
        return this;
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_vector1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vector2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normalMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form](http://mathworld.wolfram.com/HessianNormalForm.html)
 * by a unit length normal vector and a constant.
 */ class $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0 {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $9ddd7e9b53f7a2d4$var$_vector1.subVectors(c, b).cross($9ddd7e9b53f7a2d4$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @param {boolean} [clampToLine=true] - Whether to clamp the intersection to the line segment.
	 * @return {?Vector3} The intersection point. Returns `null` if no intersection is detected.
	 */ intersectLine(line, target, clampToLine = true) {
        const direction = line.delta($9ddd7e9b53f7a2d4$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (clampToLine === true && (t < 0 || t > 1)) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $9ddd7e9b53f7a2d4$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($9ddd7e9b53f7a2d4$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_sphere$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_defaultSpriteCenter = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0.5);
const $9ddd7e9b53f7a2d4$var$_vector$6 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2 {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p1 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p2 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p3 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p4 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0(), p5 = new $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
            planes[4].setComponents(me2, me6, me10, me14).normalize(); // far
            planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // near
        } else {
            planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // far
            if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize(); // near
            else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize(); // near
            else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        }
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $9ddd7e9b53f7a2d4$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $9ddd7e9b53f7a2d4$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $9ddd7e9b53f7a2d4$var$_sphere$3.center.set(0, 0, 0);
        const offset = $9ddd7e9b53f7a2d4$var$_defaultSpriteCenter.distanceTo(sprite.center);
        $9ddd7e9b53f7a2d4$var$_sphere$3.radius = 0.7071067811865476 + offset;
        $9ddd7e9b53f7a2d4$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $9ddd7e9b53f7a2d4$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $9ddd7e9b53f7a2d4$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $9ddd7e9b53f7a2d4$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($9ddd7e9b53f7a2d4$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_frustum$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class $9ddd7e9b53f7a2d4$export$2d7d04327620499c {
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $9ddd7e9b53f7a2d4$var$_frustum$1.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($9ddd7e9b53f7a2d4$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $9ddd7e9b53f7a2d4$var$_frustum$1.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($9ddd7e9b53f7a2d4$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $9ddd7e9b53f7a2d4$var$_frustum$1.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($9ddd7e9b53f7a2d4$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $9ddd7e9b53f7a2d4$var$_frustum$1.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($9ddd7e9b53f7a2d4$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $9ddd7e9b53f7a2d4$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $9ddd7e9b53f7a2d4$var$_frustum$1.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if ($9ddd7e9b53f7a2d4$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$2d7d04327620499c();
    }
}
function $9ddd7e9b53f7a2d4$var$ascIdSort(a, b) {
    return a - b;
}
function $9ddd7e9b53f7a2d4$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $9ddd7e9b53f7a2d4$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $9ddd7e9b53f7a2d4$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $9ddd7e9b53f7a2d4$var$_matrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_whiteColor = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
const $9ddd7e9b53f7a2d4$var$_frustum = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2();
const $9ddd7e9b53f7a2d4$var$_frustumArray = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2d7d04327620499c();
const $9ddd7e9b53f7a2d4$var$_box$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
const $9ddd7e9b53f7a2d4$var$_sphere$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_vector$5 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_forward$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_temp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_renderList = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$MultiDrawRenderList();
const $9ddd7e9b53f7a2d4$var$_mesh = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$e176487c05830cc5();
const $9ddd7e9b53f7a2d4$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $9ddd7e9b53f7a2d4$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $9ddd7e9b53f7a2d4$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$6e01c5ee52ed8f7b extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(matricesArray, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(indirectArray, size, size, $9ddd7e9b53f7a2d4$export$aa92e870a709d190, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(colorsArray, size, size, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        colorsTexture.colorSpace = $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_box$1).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            boundingBox.union($9ddd7e9b53f7a2d4$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            boundingSphere.union($9ddd7e9b53f7a2d4$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $9ddd7e9b53f7a2d4$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $9ddd7e9b53f7a2d4$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $9ddd7e9b53f7a2d4$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in BatchedMesh to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    index.needsUpdate = true;
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                    attribute.needsUpdate = true;
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
        }
        this._nextIndexStart = nextIndexStart;
        this._nextVertexStart = nextVertexStart;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {?Box3} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($9ddd7e9b53f7a2d4$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {?Sphere} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_box$1);
            $9ddd7e9b53f7a2d4$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $9ddd7e9b53f7a2d4$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($9ddd7e9b53f7a2d4$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color|Vector4} color - The color to set the instance to. Use a `Vector4` to also define alpha.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color|Vector4} color - The target object that is used to store the method's result.
	 * @return {Color|Vector4} The instance's color.  Use a `Vector4` to also retrieve alpha.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) {
            if (color.isVector4) return color.set(1, 1, 1, 1);
            else return color.setRGB(1, 1, 1);
        } else return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($9ddd7e9b53f7a2d4$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length - 1){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $9ddd7e9b53f7a2d4$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $9ddd7e9b53f7a2d4$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $9ddd7e9b53f7a2d4$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $9ddd7e9b53f7a2d4$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $9ddd7e9b53f7a2d4$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $9ddd7e9b53f7a2d4$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$9ddd7e9b53f7a2d4$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $9ddd7e9b53f7a2d4$var$_mesh.material = this.material;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.index = batchGeometry.index;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox === null) $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
        if ($9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere === null) $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $9ddd7e9b53f7a2d4$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_mesh.geometry.boundingSphere);
            $9ddd7e9b53f7a2d4$var$_mesh.raycast(raycaster, $9ddd7e9b53f7a2d4$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $9ddd7e9b53f7a2d4$var$_batchIntersects.length; j < l; j++){
                const intersect = $9ddd7e9b53f7a2d4$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $9ddd7e9b53f7a2d4$var$_batchIntersects.length = 0;
        }
        $9ddd7e9b53f7a2d4$var$_mesh.material = null;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.index = null;
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.attributes = {};
        $9ddd7e9b53f7a2d4$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        let bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        // the "wireframe" attribute implicitly creates a line attribute in the renderer, which is double
        // the vertices to draw (3 lines per triangle) so we multiply the draw counts / starts and make
        // assumptions about the index buffer byte size.
        let multiDrawMultiplier = 1;
        if (material.wireframe) {
            multiDrawMultiplier = 2;
            bytesPerElement = geometry.attributes.position.count > 65535 ? 4 : 2;
        }
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? $9ddd7e9b53f7a2d4$var$_frustumArray : $9ddd7e9b53f7a2d4$var$_frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            $9ddd7e9b53f7a2d4$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $9ddd7e9b53f7a2d4$var$_frustum.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_matrix$1, camera.coordinateSystem, camera.reversedDepth);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $9ddd7e9b53f7a2d4$var$_matrix$1.copy(this.matrixWorld).invert();
            $9ddd7e9b53f7a2d4$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
            $9ddd7e9b53f7a2d4$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($9ddd7e9b53f7a2d4$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $9ddd7e9b53f7a2d4$var$_temp.subVectors($9ddd7e9b53f7a2d4$var$_sphere$2.center, $9ddd7e9b53f7a2d4$var$_vector$5).dot($9ddd7e9b53f7a2d4$var$_forward$1);
                    $9ddd7e9b53f7a2d4$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $9ddd7e9b53f7a2d4$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $9ddd7e9b53f7a2d4$var$sortTransparent : $9ddd7e9b53f7a2d4$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement * multiDrawMultiplier;
                multiDrawCounts[multiDrawCount] = item.count * multiDrawMultiplier;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $9ddd7e9b53f7a2d4$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $9ddd7e9b53f7a2d4$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $9ddd7e9b53f7a2d4$var$_sphere$2).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix$1);
                    culled = !frustum.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement * multiDrawMultiplier;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count * multiDrawMultiplier;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_vStart = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_vEnd = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_inverseMatrix$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_intersectPointOnRay = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$17d680238e50603e extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $9ddd7e9b53f7a2d4$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $9ddd7e9b53f7a2d4$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $9ddd7e9b53f7a2d4$var$_vStart.distanceTo($9ddd7e9b53f7a2d4$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(lineDistances, 1));
        } else $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere$1.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere$1.applyMatrix4(matrixWorld);
        $9ddd7e9b53f7a2d4$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere$1) === false) return;
        //
        $9ddd7e9b53f7a2d4$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray$1.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $9ddd7e9b53f7a2d4$var$checkIntersection(this, raycaster, $9ddd7e9b53f7a2d4$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $9ddd7e9b53f7a2d4$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $9ddd7e9b53f7a2d4$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($9ddd7e9b53f7a2d4$var$_vStart, $9ddd7e9b53f7a2d4$var$_vEnd, $9ddd7e9b53f7a2d4$var$_intersectPointOnRay, $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $9ddd7e9b53f7a2d4$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($9ddd7e9b53f7a2d4$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $9ddd7e9b53f7a2d4$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $9ddd7e9b53f7a2d4$var$_start = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_end = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $9ddd7e9b53f7a2d4$var$_start.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $9ddd7e9b53f7a2d4$var$_start.distanceTo($9ddd7e9b53f7a2d4$var$_end);
            }
            geometry.setAttribute('lineDistance', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(lineDistances, 1));
        } else $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$f85a24d745e4f17d extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete).
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_inverseMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_ray = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e();
const $9ddd7e9b53f7a2d4$var$_sphere = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba();
const $9ddd7e9b53f7a2d4$var$_position$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$1c787534cb11aa3e extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959(), material = new $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9ddd7e9b53f7a2d4$var$_sphere.copy(geometry.boundingSphere);
        $9ddd7e9b53f7a2d4$var$_sphere.applyMatrix4(matrixWorld);
        $9ddd7e9b53f7a2d4$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($9ddd7e9b53f7a2d4$var$_sphere) === false) return;
        //
        $9ddd7e9b53f7a2d4$var$_inverseMatrix.copy(matrixWorld).invert();
        $9ddd7e9b53f7a2d4$var$_ray.copy(raycaster.ray).applyMatrix4($9ddd7e9b53f7a2d4$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $9ddd7e9b53f7a2d4$var$_position$3.fromBufferAttribute(positionAttribute, a);
                $9ddd7e9b53f7a2d4$var$testPoint($9ddd7e9b53f7a2d4$var$_position$3, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $9ddd7e9b53f7a2d4$var$_position$3.fromBufferAttribute(positionAttribute, i);
                $9ddd7e9b53f7a2d4$var$testPoint($9ddd7e9b53f7a2d4$var$_position$3, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $9ddd7e9b53f7a2d4$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $9ddd7e9b53f7a2d4$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        $9ddd7e9b53f7a2d4$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: When using video textures with {@link WebGPURenderer}, {@link Texture#colorSpace} must be
 * set to THREE.SRGBColorSpace.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$6e09d1edf8d5a25c extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The video frame request callback identifier, which is a positive integer.
		 *
		 * Value of 0 represents no scheduled rVFC.
		 *
		 * @private
		 * @type {number}
		 */ this._requestVideoFrameCallbackId = 0;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            scope._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) this._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    dispose() {
        if (this._requestVideoFrameCallbackId !== 0) {
            this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId);
            this._requestVideoFrameCallbackId = 0;
        }
        super.dispose();
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $9ddd7e9b53f7a2d4$export$68498d200b825382 extends $9ddd7e9b53f7a2d4$export$6e09d1edf8d5a25c {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} [width] - The width of the texture.
	 * @param {number} [height] - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $9ddd7e9b53f7a2d4$export$5fe6b8e34b274fcb extends $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $9ddd7e9b53f7a2d4$export$d80173634de65bff extends $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $9ddd7e9b53f7a2d4$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$f7189e49152d1c13 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture from an HTML element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately and listens for the parent canvas's paint events to trigger updates.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$8db0c065f2b1751d extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLElement} [element] - The HTML element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(element, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(element, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHTMLTexture = true;
        this.generateMipmaps = false;
        this.needsUpdate = true;
        const parent = element ? element.parentNode : null;
        if (parent !== null && 'requestPaint' in parent) {
            parent.onpaint = ()=>{
                this.needsUpdate = true;
            };
            parent.requestPaint();
        }
    }
    dispose() {
        const parent = this.image ? this.image.parentNode : null;
        if (parent !== null && 'onpaint' in parent) parent.onpaint = null;
        super.dispose();
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, anisotropy, format = $9ddd7e9b53f7a2d4$export$c1b6b5136be58045, depth = 1){
        if (format !== $9ddd7e9b53f7a2d4$export$c1b6b5136be58045 && format !== $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * cube rendering into a cube texture with depth format. Used for PointLight shadows.
 *
 * @augments DepthTexture
 */ class $9ddd7e9b53f7a2d4$export$c9f39eef7fb1d170 extends $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f {
    /**
	 * Constructs a new cube depth texture.
	 *
	 * @param {number} size - The size (width and height) of each cube face.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 */ constructor(size, type = $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96, mapping = $9ddd7e9b53f7a2d4$export$8759762a6477f2c4, wrapS, wrapT, magFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, minFilter = $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0, anisotropy, format = $9ddd7e9b53f7a2d4$export$c1b6b5136be58045){
        // Create 6 identical image descriptors for the cube faces
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        // Call DepthTexture constructor with width, height
        super(size, size, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format);
        // Replace the single image with the array of 6 images
        this.image = images;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeDepthTexture = true;
        /**
		 * Set to true for cube texture handling in WebGLTextures.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
    }
    /**
	 * Alias for {@link CubeDepthTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Represents a texture created externally with the same renderer context.
 *
 * This may be a texture from a protected media stream, device camera feed,
 * or other data feeds like a depth sensor.
 *
 * Note that this class is only supported in {@link WebGLRenderer}, and in
 * the {@link WebGPURenderer} WebGPU backend.
 *
 * @augments Texture
 */ class $9ddd7e9b53f7a2d4$export$cd10147cacf16ab2 extends $9ddd7e9b53f7a2d4$export$5431306cf43de24a {
    /**
	 * Creates a new raw texture.
	 *
	 * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
	 */ constructor(sourceTexture = null){
        super();
        /**
		 * The external source texture.
		 *
		 * @type {?(WebGLTexture|GPUTexture)}
		 * @default null
		 */ this.sourceTexture = sourceTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isExternalTexture = true;
    }
    copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
    }
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#BoxGeometry
 */ class $9ddd7e9b53f7a2d4$export$33e43285f7406bd5 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CapsuleGeometry
 */ class $9ddd7e9b53f7a2d4$export$41680e8551036033 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$41680e8551036033(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CircleGeometry
 */ class $9ddd7e9b53f7a2d4$export$d5c0e8d607467193 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CylinderGeometry
 */ class $9ddd7e9b53f7a2d4$export$68f745719dbe5198 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 * @demo scenes/geometry-browser.html#ConeGeometry
 */ class $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3 extends $9ddd7e9b53f7a2d4$export$68f745719dbe5198 {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const b = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const c = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const centroid = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const uvA = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const uvB = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            const uvC = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#DodecahedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $9ddd7e9b53f7a2d4$var$_v0 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v1$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_normal = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_triangle = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$4730b1542707547f extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($9ddd7e9b53f7a2d4$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $9ddd7e9b53f7a2d4$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $9ddd7e9b53f7a2d4$var$_triangle.getNormal($9ddd7e9b53f7a2d4$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $9ddd7e9b53f7a2d4$var$_triangle[vertKeys[j]];
                    const v1 = $9ddd7e9b53f7a2d4$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($9ddd7e9b53f7a2d4$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $9ddd7e9b53f7a2d4$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $9ddd7e9b53f7a2d4$var$_v0.fromBufferAttribute(positionAttr, index0);
                $9ddd7e9b53f7a2d4$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($9ddd7e9b53f7a2d4$var$_v0.x, $9ddd7e9b53f7a2d4$var$_v0.y, $9ddd7e9b53f7a2d4$var$_v0.z);
                vertices.push($9ddd7e9b53f7a2d4$var$_v1$1.x, $9ddd7e9b53f7a2d4$var$_v1$1.y, $9ddd7e9b53f7a2d4$var$_v1$1.z);
            }
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1() : new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const mat = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        binormals[0] = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($9ddd7e9b53f7a2d4$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($9ddd7e9b53f7a2d4$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$3f87a931616cde04 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $9ddd7e9b53f7a2d4$export$b1eedc9aab6300e8 extends $9ddd7e9b53f7a2d4$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $9ddd7e9b53f7a2d4$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $9ddd7e9b53f7a2d4$var$tmp = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$tmp2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$px = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
const $9ddd7e9b53f7a2d4$var$py = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
const $9ddd7e9b53f7a2d4$var$pz = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$b9146b27c24b744c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $9ddd7e9b53f7a2d4$var$tmp2.subVectors(points[0], points[1]).add(points[0]);
            p0 = $9ddd7e9b53f7a2d4$var$tmp2;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $9ddd7e9b53f7a2d4$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $9ddd7e9b53f7a2d4$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $9ddd7e9b53f7a2d4$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $9ddd7e9b53f7a2d4$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $9ddd7e9b53f7a2d4$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $9ddd7e9b53f7a2d4$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $9ddd7e9b53f7a2d4$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $9ddd7e9b53f7a2d4$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($9ddd7e9b53f7a2d4$var$px.calc(weight), $9ddd7e9b53f7a2d4$var$py.calc(weight), $9ddd7e9b53f7a2d4$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Interpolations contains spline and Bézier functions internally used by concrete curve classes.
 *
 * Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 *
 * @module Interpolations
 */ /**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $9ddd7e9b53f7a2d4$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $9ddd7e9b53f7a2d4$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, p0, p1, p2) {
    return $9ddd7e9b53f7a2d4$var$QuadraticBezierP0(t, p0) + $9ddd7e9b53f7a2d4$var$QuadraticBezierP1(t, p1) + $9ddd7e9b53f7a2d4$var$QuadraticBezierP2(t, p2);
}
//
function $9ddd7e9b53f7a2d4$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $9ddd7e9b53f7a2d4$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $9ddd7e9b53f7a2d4$var$CubicBezier(t, p0, p1, p2, p3) {
    return $9ddd7e9b53f7a2d4$var$CubicBezierP0(t, p0) + $9ddd7e9b53f7a2d4$var$CubicBezierP1(t, p1) + $9ddd7e9b53f7a2d4$var$CubicBezierP2(t, p2) + $9ddd7e9b53f7a2d4$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$e36650d36468bb39 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v3 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v3 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $9ddd7e9b53f7a2d4$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$1fdfd9d9cf487600 extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v1 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(), v2 = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), v2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $9ddd7e9b53f7a2d4$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($9ddd7e9b53f7a2d4$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $9ddd7e9b53f7a2d4$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $9ddd7e9b53f7a2d4$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $9ddd7e9b53f7a2d4$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $9ddd7e9b53f7a2d4$export$b9146b27c24b744c,
    CubicBezierCurve: $9ddd7e9b53f7a2d4$export$e36650d36468bb39,
    CubicBezierCurve3: $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c,
    EllipseCurve: $9ddd7e9b53f7a2d4$export$3f87a931616cde04,
    LineCurve: $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e,
    LineCurve3: $9ddd7e9b53f7a2d4$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc,
    SplineCurve: $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $9ddd7e9b53f7a2d4$export$4aaf9b66af1bbf2c extends $9ddd7e9b53f7a2d4$export$b0e83c3ef8d2db1 {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $9ddd7e9b53f7a2d4$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $9ddd7e9b53f7a2d4$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9 extends $9ddd7e9b53f7a2d4$export$4aaf9b66af1bbf2c {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $9ddd7e9b53f7a2d4$export$ab2e07e76531a47e(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $9ddd7e9b53f7a2d4$export$5938c4ee491a43ad(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCPx, aCPy), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $9ddd7e9b53f7a2d4$export$e36650d36468bb39(this.currentPoint.clone(), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCP1x, aCP1y), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aCP2x, aCP2y), new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $9ddd7e9b53f7a2d4$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $9ddd7e9b53f7a2d4$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa extends $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9 {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.2
// https://github.com/mapbox/earcut/tree/v3.0.2
function $9ddd7e9b53f7a2d4$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $9ddd7e9b53f7a2d4$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $9ddd7e9b53f7a2d4$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $9ddd7e9b53f7a2d4$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $9ddd7e9b53f7a2d4$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $9ddd7e9b53f7a2d4$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $9ddd7e9b53f7a2d4$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $9ddd7e9b53f7a2d4$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $9ddd7e9b53f7a2d4$var$equals(last, last.next)) {
        $9ddd7e9b53f7a2d4$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $9ddd7e9b53f7a2d4$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($9ddd7e9b53f7a2d4$var$equals(p, p.next) || $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) === 0)) {
            $9ddd7e9b53f7a2d4$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $9ddd7e9b53f7a2d4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $9ddd7e9b53f7a2d4$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $9ddd7e9b53f7a2d4$var$isEarHashed(ear, minX, minY, invSize) : $9ddd7e9b53f7a2d4$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $9ddd7e9b53f7a2d4$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $9ddd7e9b53f7a2d4$var$earcutLinked($9ddd7e9b53f7a2d4$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $9ddd7e9b53f7a2d4$var$cureLocalIntersections($9ddd7e9b53f7a2d4$var$filterPoints(ear), triangles);
                $9ddd7e9b53f7a2d4$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $9ddd7e9b53f7a2d4$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $9ddd7e9b53f7a2d4$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9ddd7e9b53f7a2d4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $9ddd7e9b53f7a2d4$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9ddd7e9b53f7a2d4$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $9ddd7e9b53f7a2d4$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $9ddd7e9b53f7a2d4$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $9ddd7e9b53f7a2d4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $9ddd7e9b53f7a2d4$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $9ddd7e9b53f7a2d4$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $9ddd7e9b53f7a2d4$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$9ddd7e9b53f7a2d4$var$equals(a, b) && $9ddd7e9b53f7a2d4$var$intersects(a, p, p.next, b) && $9ddd7e9b53f7a2d4$var$locallyInside(a, b) && $9ddd7e9b53f7a2d4$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $9ddd7e9b53f7a2d4$var$removeNode(p);
            $9ddd7e9b53f7a2d4$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $9ddd7e9b53f7a2d4$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $9ddd7e9b53f7a2d4$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $9ddd7e9b53f7a2d4$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $9ddd7e9b53f7a2d4$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $9ddd7e9b53f7a2d4$var$filterPoints(a, a.next);
                c = $9ddd7e9b53f7a2d4$var$filterPoints(c, c.next);
                // run earcut on each half
                $9ddd7e9b53f7a2d4$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $9ddd7e9b53f7a2d4$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $9ddd7e9b53f7a2d4$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $9ddd7e9b53f7a2d4$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($9ddd7e9b53f7a2d4$var$getLeftmost(list));
    }
    queue.sort($9ddd7e9b53f7a2d4$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $9ddd7e9b53f7a2d4$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $9ddd7e9b53f7a2d4$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $9ddd7e9b53f7a2d4$var$eliminateHole(hole, outerNode) {
    const bridge = $9ddd7e9b53f7a2d4$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $9ddd7e9b53f7a2d4$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $9ddd7e9b53f7a2d4$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $9ddd7e9b53f7a2d4$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $9ddd7e9b53f7a2d4$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($9ddd7e9b53f7a2d4$var$equals(hole, p)) return p;
    do {
        if ($9ddd7e9b53f7a2d4$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $9ddd7e9b53f7a2d4$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($9ddd7e9b53f7a2d4$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $9ddd7e9b53f7a2d4$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $9ddd7e9b53f7a2d4$var$sectorContainsSector(m, p) {
    return $9ddd7e9b53f7a2d4$var$area(m.prev, m, p.prev) < 0 && $9ddd7e9b53f7a2d4$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $9ddd7e9b53f7a2d4$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $9ddd7e9b53f7a2d4$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $9ddd7e9b53f7a2d4$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $9ddd7e9b53f7a2d4$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $9ddd7e9b53f7a2d4$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $9ddd7e9b53f7a2d4$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $9ddd7e9b53f7a2d4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $9ddd7e9b53f7a2d4$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $9ddd7e9b53f7a2d4$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $9ddd7e9b53f7a2d4$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$9ddd7e9b53f7a2d4$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($9ddd7e9b53f7a2d4$var$locallyInside(a, b) && $9ddd7e9b53f7a2d4$var$locallyInside(b, a) && $9ddd7e9b53f7a2d4$var$middleInside(a, b) && // locally visible
    ($9ddd7e9b53f7a2d4$var$area(a.prev, a, b.prev) || $9ddd7e9b53f7a2d4$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $9ddd7e9b53f7a2d4$var$equals(a, b) && $9ddd7e9b53f7a2d4$var$area(a.prev, a, a.next) > 0 && $9ddd7e9b53f7a2d4$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $9ddd7e9b53f7a2d4$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $9ddd7e9b53f7a2d4$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $9ddd7e9b53f7a2d4$var$intersects(p1, q1, p2, q2) {
    const o1 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p1, q1, p2));
    const o2 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p1, q1, q2));
    const o3 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p2, q2, p1));
    const o4 = $9ddd7e9b53f7a2d4$var$sign($9ddd7e9b53f7a2d4$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $9ddd7e9b53f7a2d4$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $9ddd7e9b53f7a2d4$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $9ddd7e9b53f7a2d4$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $9ddd7e9b53f7a2d4$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $9ddd7e9b53f7a2d4$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $9ddd7e9b53f7a2d4$var$locallyInside(a, b) {
    return $9ddd7e9b53f7a2d4$var$area(a.prev, a, a.next) < 0 ? $9ddd7e9b53f7a2d4$var$area(a, b, a.next) >= 0 && $9ddd7e9b53f7a2d4$var$area(a, a.prev, b) >= 0 : $9ddd7e9b53f7a2d4$var$area(a, b, a.prev) < 0 || $9ddd7e9b53f7a2d4$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $9ddd7e9b53f7a2d4$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $9ddd7e9b53f7a2d4$var$splitPolygon(a, b) {
    const a2 = $9ddd7e9b53f7a2d4$var$createNode(a.i, a.x, a.y), b2 = $9ddd7e9b53f7a2d4$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $9ddd7e9b53f7a2d4$var$insertNode(i, x, y, last) {
    const p = $9ddd7e9b53f7a2d4$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $9ddd7e9b53f7a2d4$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $9ddd7e9b53f7a2d4$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $9ddd7e9b53f7a2d4$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * An implementation of the earcut polygon triangulation algorithm.
 * The code is a port of [mapbox/earcut](https://github.com/mapbox/earcut).
 *
 * @see https://github.com/mapbox/earcut
 */ class $9ddd7e9b53f7a2d4$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $9ddd7e9b53f7a2d4$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $9ddd7e9b53f7a2d4$var$removeDupEndPts(contour);
        $9ddd7e9b53f7a2d4$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($9ddd7e9b53f7a2d4$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $9ddd7e9b53f7a2d4$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $9ddd7e9b53f7a2d4$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $9ddd7e9b53f7a2d4$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $9ddd7e9b53f7a2d4$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ExtrudeGeometry
 */ class $9ddd7e9b53f7a2d4$export$598697a1efa63ca7 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa([
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $9ddd7e9b53f7a2d4$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                const isClosed = extrudePath.isCatmullRomCurve3 ? extrudePath.closed : false;
                splineTube = extrudePath.computeFrenetFrames(steps, isClosed);
                // log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
                normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
                position2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $9ddd7e9b53f7a2d4$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $9ddd7e9b53f7a2d4$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $9ddd7e9b53f7a2d4$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $9ddd7e9b53f7a2d4$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_x, a_y),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_x, b_y),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $9ddd7e9b53f7a2d4$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#IcosahedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$9567cc828c9535da extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$9567cc828c9535da(data.radius, data.detail);
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#LatheGeometry
 */ class $9ddd7e9b53f7a2d4$export$6d839803fcd1882c extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, 0),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $9ddd7e9b53f7a2d4$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const curNormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const prevNormal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#OctahedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$1954e2b809fe361e extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#PlaneGeometry
 */ class $9ddd7e9b53f7a2d4$export$967d831af31f69ce extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#RingGeometry
 */ class $9ddd7e9b53f7a2d4$export$68cb731f50f614af extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ShapeGeometry
 */ class $9ddd7e9b53f7a2d4$export$57a29a1c803e9065 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa([
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0, 0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $9ddd7e9b53f7a2d4$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $9ddd7e9b53f7a2d4$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $9ddd7e9b53f7a2d4$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#SphereGeometry
 */ class $9ddd7e9b53f7a2d4$export$1b417fc3b307a251 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#TetrahedronGeometry
 */ class $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02 extends $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65 {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusGeometry
 */ class $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 * @param {number} [thetaStart=0] - Start of the tubular sweep in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Length of the tubular sweep in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++){
            const v = thetaStart + j / radialSegments * thetaLength;
            for(let i = 0; i <= tubularSegments; i++){
                const u = i / tubularSegments * arc;
                // vertex
                vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
                vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
                vertex.z = tube * Math.sin(v);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                center.x = radius * Math.cos(u);
                center.y = radius * Math.sin(u);
                normal.subVectors(vertex, center).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusKnotGeometry
 */ class $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const P1 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const P2 = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const B = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const T = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const N = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TubeGeometry
 */ class $9ddd7e9b53f7a2d4$export$7897d9d48904490c extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-1, -1, 0), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(-1, 1, 0), new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const normal = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        const uv = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
        let P = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $9ddd7e9b53f7a2d4$export$7897d9d48904490c(new $9ddd7e9b53f7a2d4$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $9ddd7e9b53f7a2d4$export$4b739da06d24892b extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            const end = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $9ddd7e9b53f7a2d4$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $9ddd7e9b53f7a2d4$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $9ddd7e9b53f7a2d4$export$33e43285f7406bd5,
    CapsuleGeometry: $9ddd7e9b53f7a2d4$export$41680e8551036033,
    CircleGeometry: $9ddd7e9b53f7a2d4$export$d5c0e8d607467193,
    ConeGeometry: $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3,
    CylinderGeometry: $9ddd7e9b53f7a2d4$export$68f745719dbe5198,
    DodecahedronGeometry: $9ddd7e9b53f7a2d4$export$c0babfeb8708fc9c,
    EdgesGeometry: $9ddd7e9b53f7a2d4$export$4730b1542707547f,
    ExtrudeGeometry: $9ddd7e9b53f7a2d4$export$598697a1efa63ca7,
    IcosahedronGeometry: $9ddd7e9b53f7a2d4$export$9567cc828c9535da,
    LatheGeometry: $9ddd7e9b53f7a2d4$export$6d839803fcd1882c,
    OctahedronGeometry: $9ddd7e9b53f7a2d4$export$1954e2b809fe361e,
    PlaneGeometry: $9ddd7e9b53f7a2d4$export$967d831af31f69ce,
    PolyhedronGeometry: $9ddd7e9b53f7a2d4$export$60e57a7d3f20ff65,
    RingGeometry: $9ddd7e9b53f7a2d4$export$68cb731f50f614af,
    ShapeGeometry: $9ddd7e9b53f7a2d4$export$57a29a1c803e9065,
    SphereGeometry: $9ddd7e9b53f7a2d4$export$1b417fc3b307a251,
    TetrahedronGeometry: $9ddd7e9b53f7a2d4$export$fb3f7adc68bd6e02,
    TorusGeometry: $9ddd7e9b53f7a2d4$export$a2312a2a1fa56495,
    TorusKnotGeometry: $9ddd7e9b53f7a2d4$export$77e9bfadfb9ab8c8,
    TubeGeometry: $9ddd7e9b53f7a2d4$export$7897d9d48904490c,
    WireframeGeometry: $9ddd7e9b53f7a2d4$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$e8564da406055a3 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * Provides utility functions for managing uniforms.
 *
 * @module UniformsUtils
 */ /**
 * Clones the given uniform definitions by performing a deep-copy. That means
 * if the value of a uniform refers to an object like a Vector3 or Texture,
 * the cloned uniform will refer to a new object reference.
 *
 * @param {Object} src - An object representing uniform definitions.
 * @return {Object} The cloned uniforms.
 */ function $9ddd7e9b53f7a2d4$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if ($9ddd7e9b53f7a2d4$var$isThreeObject(property)) {
                if (property.isRenderTargetTexture) {
                    $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) {
                if ($9ddd7e9b53f7a2d4$var$isThreeObject(property[0])) {
                    const clonedProperty = [];
                    for(let i = 0, l = property.length; i < l; i++)clonedProperty[i] = property[i].clone();
                    dst[u][p] = clonedProperty;
                } else dst[u][p] = property.slice();
            } else dst[u][p] = property;
        }
    }
    return dst;
}
/**
 * Merges the given uniform definitions into a single object. Since the
 * method internally uses cloneUniforms(), it performs a deep-copy when
 * producing the merged uniform definitions.
 *
 * @param {Array} uniforms - An array of objects containing uniform definitions.
 * @return {Object} The merged uniforms.
 */ function $9ddd7e9b53f7a2d4$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $9ddd7e9b53f7a2d4$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $9ddd7e9b53f7a2d4$var$isThreeObject(property) {
    return property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion);
}
function $9ddd7e9b53f7a2d4$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $9ddd7e9b53f7a2d4$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $9ddd7e9b53f7a2d4$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $9ddd7e9b53f7a2d4$export$d8ecdf8615bfea69 = {
    clone: $9ddd7e9b53f7a2d4$export$acda854380553452,
    merge: $9ddd7e9b53f7a2d4$export$8916ce6879271f43
};
var $9ddd7e9b53f7a2d4$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $9ddd7e9b53f7a2d4$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized](https://en.wikipedia.org/wiki/Normalized_loop).
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $9ddd7e9b53f7a2d4$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $9ddd7e9b53f7a2d4$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * Setting this property to `true` requires the definition of fog uniforms. It is
		 * recommended to use `UniformsUtils.merge()` to combine the custom shader uniforms
		 * with predefined fog uniforms.
		 *
		 * ```js
		 * const material = new ShaderMaterial( {
		 *     uniforms: UniformsUtils.merge( [ UniformsLib[ 'fog' ], shaderUniforms ] );
		 *     vertexShader: vertexShader,
		 *     fragmentShader: fragmentShader,
		 *     fog: true
		 * } );
		 * ```
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation)
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $9ddd7e9b53f7a2d4$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $9ddd7e9b53f7a2d4$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        this.defaultAttributeValues = Object.assign({}, source.defaultAttributeValues);
        this.index0AttributeName = source.index0AttributeName;
        this.uniformsNeedUpdate = source.uniformsNeedUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22 extends $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity](https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/),
 * [Unreal](https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/) and
 * [3D Studio Max](http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017).
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset](https://www.marmoset.co):
 *
 * - [Basic Theory of Physically Based Rendering](https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/)
 * - [Physically Based Rendering and You Can Too](https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/)
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney](https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf)
 * (pdf), by Brent Burley.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshStandardMaterial
 */ class $9ddd7e9b53f7a2d4$export$f2980790215acccd extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 * @demo scenes/material-browser.html#MeshPhysicalMaterial
 */ class $9ddd7e9b53f7a2d4$export$28d04986c4269c9f extends $9ddd7e9b53f7a2d4$export$f2980790215acccd {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $9ddd7e9b53f7a2d4$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong](https://en.wikipedia.org/wiki/Blinn-Phong_shading_model)
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshPhongMaterial
 */ class $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshToonMaterial
 */ class $9ddd7e9b53f7a2d4$export$df893cf97e765622 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@link NearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshNormalMaterial
 */ class $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian](https://en.wikipedia.org/wiki/Lambertian_reflectance)
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshLambertMaterial
 */ class $9ddd7e9b53f7a2d4$export$5023a9a8114806b8 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $9ddd7e9b53f7a2d4$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $9ddd7e9b53f7a2d4$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.envMapIntensity = source.envMapIntensity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshDepthMaterial
 */ class $9ddd7e9b53f7a2d4$export$2698c22ec13825db extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $9ddd7e9b53f7a2d4$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do not cast shadows.
 *
 * @augments Material
 */ class $9ddd7e9b53f7a2d4$export$33e187ed002f2a19 extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshMatcapMaterial
 */ class $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee extends $9ddd7e9b53f7a2d4$export$a2d8b23205c25948 {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $9ddd7e9b53f7a2d4$export$327886a3efaeaebe extends $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $9ddd7e9b53f7a2d4$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $9ddd7e9b53f7a2d4$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $9ddd7e9b53f7a2d4$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $9ddd7e9b53f7a2d4$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $9ddd7e9b53f7a2d4$var$convertArray(times, track.times.constructor);
        track.values = $9ddd7e9b53f7a2d4$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $9ddd7e9b53f7a2d4$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $9ddd7e9b53f7a2d4$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $9ddd7e9b53f7a2d4$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $9ddd7e9b53f7a2d4$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $9ddd7e9b53f7a2d4$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $9ddd7e9b53f7a2d4$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $9ddd7e9b53f7a2d4$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$3646682e7a3959 extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $9ddd7e9b53f7a2d4$export$7f795934b84ab523,
            endingEnd: $9ddd7e9b53f7a2d4$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$fb9758ef7ef8d5cc extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * A Bezier interpolant using cubic Bezier curves with 2D control points.
 *
 * This interpolant supports the COLLADA/Maya style of Bezier animation where
 * each keyframe has explicit in/out tangent control points specified as
 * 2D coordinates (time, value).
 *
 * The tangent data must be provided via the `settings` object:
 * - `settings.inTangents`: Float32Array with [time, value] pairs per keyframe per component
 * - `settings.outTangents`: Float32Array with [time, value] pairs per keyframe per component
 *
 * For a track with N keyframes and stride S:
 * - Each tangent array has N * S * 2 values
 * - Layout: [k0_c0_time, k0_c0_value, k0_c1_time, k0_c1_value, ..., k0_cS_time, k0_cS_value,
 *            k1_c0_time, k1_c0_value, ...]
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$9a963cfe8bd70b49 extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const offset1 = i1 * stride;
        const offset0 = offset1 - stride;
        const settings = this.settings || this.DefaultSettings_;
        const inTangents = settings.inTangents;
        const outTangents = settings.outTangents;
        // If no tangent data, fall back to linear interpolation
        if (!inTangents || !outTangents) {
            const weight1 = (t - t0) / (t1 - t0);
            const weight0 = 1 - weight1;
            for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
            return result;
        }
        const tangentStride = stride * 2;
        const i0 = i1 - 1;
        for(let i = 0; i !== stride; ++i){
            const v0 = values[offset0 + i];
            const v1 = values[offset1 + i];
            // outTangent of previous keyframe (C0)
            const outTangentOffset = i0 * tangentStride + i * 2;
            const c0x = outTangents[outTangentOffset];
            const c0y = outTangents[outTangentOffset + 1];
            // inTangent of current keyframe (C1)
            const inTangentOffset = i1 * tangentStride + i * 2;
            const c1x = inTangents[inTangentOffset];
            const c1y = inTangents[inTangentOffset + 1];
            // Solve for Bezier parameter s where Bx(s) = t using Newton-Raphson
            let s = (t - t0) / (t1 - t0);
            let s2, s3, oneMinusS, oneMinusS2, oneMinusS3;
            for(let iter = 0; iter < 8; iter++){
                s2 = s * s;
                s3 = s2 * s;
                oneMinusS = 1 - s;
                oneMinusS2 = oneMinusS * oneMinusS;
                oneMinusS3 = oneMinusS2 * oneMinusS;
                // Bezier X(s) = (1-s)³·t0 + 3(1-s)²s·c0x + 3(1-s)s²·c1x + s³·t1
                const bx = oneMinusS3 * t0 + 3 * oneMinusS2 * s * c0x + 3 * oneMinusS * s2 * c1x + s3 * t1;
                const error = bx - t;
                if (Math.abs(error) < 1e-10) break;
                // Derivative dX/ds
                const dbx = 3 * oneMinusS2 * (c0x - t0) + 6 * oneMinusS * s * (c1x - c0x) + 3 * s2 * (t1 - c1x);
                if (Math.abs(dbx) < 1e-10) break;
                s = s - error / dbx;
                s = Math.max(0, Math.min(1, s));
            }
            // Evaluate Bezier Y(s)
            result[i] = oneMinusS3 * v0 + 3 * oneMinusS2 * s * c0y + 3 * oneMinusS * s2 * c1y + s3 * v1;
        }
        return result;
    }
}
/**
 * Represents a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number|string|boolean>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $9ddd7e9b53f7a2d4$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $9ddd7e9b53f7a2d4$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $9ddd7e9b53f7a2d4$var$convertArray(track.times, Array),
                'values': $9ddd7e9b53f7a2d4$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $9ddd7e9b53f7a2d4$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $9ddd7e9b53f7a2d4$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new Bezier interpolant.
	 *
	 * The Bezier interpolant requires tangent data to be set via the `settings` property
	 * on the track before creating the interpolant. The settings should contain:
	 * - `inTangents`: Float32Array with [time, value] pairs per keyframe per component
	 * - `outTangents`: Float32Array with [time, value] pairs per keyframe per component
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {BezierInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodBezier(result) {
        const interpolant = new $9ddd7e9b53f7a2d4$export$9a963cfe8bd70b49(this.times, this.values, this.getValueSize(), result);
        // Pass tangent data from track settings to interpolant
        if (this.settings) interpolant.settings = this.settings;
        return interpolant;
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $9ddd7e9b53f7a2d4$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
            case $9ddd7e9b53f7a2d4$export$ad783ffd8f91a9e3:
                factoryMethod = this.InterpolantFactoryMethodBezier;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $9ddd7e9b53f7a2d4$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30;
            case this.InterpolantFactoryMethodBezier:
                return $9ddd7e9b53f7a2d4$export$ad783ffd8f91a9e3;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($9ddd7e9b53f7a2d4$export$b119cc7e1840e59c(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $9ddd7e9b53f7a2d4$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default ''
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth|InterpolateBezier)}
 * @default InterpolateLinear
 */ $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<boolean>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'bool'
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$995b32462a65e855;
$9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$9ddd7e9b53f7a2d4$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$83444c5d885347d8 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'color'
 */ $9ddd7e9b53f7a2d4$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'number'
 */ $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $9ddd7e9b53f7a2d4$export$2db1cfb7923d931e extends $9ddd7e9b53f7a2d4$export$b558baee9c0f72d3 {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7 extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $9ddd7e9b53f7a2d4$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'quaternion'
 */ $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<string>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'string'
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $9ddd7e9b53f7a2d4$export$995b32462a65e855;
$9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff extends $9ddd7e9b53f7a2d4$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'vector'
 */ $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $9ddd7e9b53f7a2d4$export$d942c706bf23829c {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        /**
		 * An object that can be used to store custom data about the animation clip.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($9ddd7e9b53f7a2d4$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        clip.userData = JSON.parse(json.userData || '{}');
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode,
            'userData': JSON.stringify(clip.userData)
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($9ddd7e9b53f7a2d4$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $9ddd7e9b53f7a2d4$var$getKeyframeOrder(times);
            times = $9ddd7e9b53f7a2d4$var$sortedArray(times, 1, order);
            values = $9ddd7e9b53f7a2d4$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bone>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $9ddd7e9b53f7a2d4$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        const clip = new this.constructor(this.name, this.duration, tracks, this.blendMode);
        clip.userData = JSON.parse(JSON.stringify(this.userData));
        return clip;
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $9ddd7e9b53f7a2d4$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $9ddd7e9b53f7a2d4$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $9ddd7e9b53f7a2d4$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $9ddd7e9b53f7a2d4$export$83444c5d885347d8;
        case 'quaternion':
            return $9ddd7e9b53f7a2d4$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $9ddd7e9b53f7a2d4$export$d3a344b98cf0b775;
        case 'string':
            return $9ddd7e9b53f7a2d4$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $9ddd7e9b53f7a2d4$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $9ddd7e9b53f7a2d4$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $9ddd7e9b53f7a2d4$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $9ddd7e9b53f7a2d4$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        if ($9ddd7e9b53f7a2d4$var$isBlobURL(key)) return;
        // log( 'Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        if ($9ddd7e9b53f7a2d4$var$isBlobURL(key)) return;
        // log( 'Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Returns true if the given cache key contains the blob: scheme.
 *
 * @private
 * @param {string} key - The cache key.
 * @return {boolean} Whether the given cache key contains the blob: scheme or not.
 */ function $9ddd7e9b53f7a2d4$var$isBlobURL(key) {
    try {
        const urlString = key.slice(key.indexOf(':') + 1); // remove type identifier
        const url = new URL(urlString);
        return url.protocol === 'blob:';
    } catch (e) {
        // If the string is not a valid URL, it throws an error
        return false;
    }
}
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $9ddd7e9b53f7a2d4$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * Used for aborting ongoing requests in loaders using this manager.
		 *
		 * @private
		 * @type {AbortController | null}
		 */ this._abortController = null;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
        /**
		 * Can be used to abort ongoing loading requests in loaders using this manager.
		 * The abort only works if the loaders implement {@link Loader#abort} and `AbortSignal.any()`
		 * is supported in the browser.
		 *
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.abort = function() {
            this.abortController.abort();
            this._abortController = null;
            return this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
	 * Used for aborting ongoing requests in loaders using this manager.
	 *
	 * @type {AbortController}
	 */ get abortController() {
        if (!this._abortController) this._abortController = new AbortController();
        return this._abortController;
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $9ddd7e9b53f7a2d4$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $9ddd7e9b53f7a2d4$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @abstract
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @abstract
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * This method can be implemented in loaders for aborting ongoing requests.
	 *
	 * @abstract
	 * @return {Loader} A reference to this instance.
	 */ abort() {
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $9ddd7e9b53f7a2d4$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $9ddd7e9b53f7a2d4$var$loading = {};
class $9ddd7e9b53f7a2d4$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type. Valid values can be found
		 * [here](https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#mimetype)
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return;
        }
        // Check if request is duplicate
        if ($9ddd7e9b53f7a2d4$var$loading[url] !== undefined) {
            $9ddd7e9b53f7a2d4$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $9ddd7e9b53f7a2d4$var$loading[url] = [];
        $9ddd7e9b53f7a2d4$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal: typeof AbortSignal.any === 'function' ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $9ddd7e9b53f7a2d4$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(`file:${url}`, data);
            const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
            delete $9ddd7e9b53f7a2d4$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $9ddd7e9b53f7a2d4$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $9ddd7e9b53f7a2d4$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {FileLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$29711c7e14f61db extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $9ddd7e9b53f7a2d4$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$bd73ce947a280350 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $9ddd7e9b53f7a2d4$export$3466bac9141a5cc4();
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
const $9ddd7e9b53f7a2d4$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639).
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = $9ddd7e9b53f7a2d4$var$_loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    $9ddd7e9b53f7a2d4$var$_loading.set(cached, arr);
                }
                arr.push({
                    onLoad: onLoad,
                    onError: onError
                });
            }
            return cached;
        }
        const image = $9ddd7e9b53f7a2d4$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = $9ddd7e9b53f7a2d4$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            $9ddd7e9b53f7a2d4$var$_loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.remove(`image:${url}`);
            //
            const callbacks = $9ddd7e9b53f7a2d4$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            $9ddd7e9b53f7a2d4$var$_loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$2ec114afc2cf6308 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049();
        texture.colorSpace = $9ddd7e9b53f7a2d4$export$561f394b24edfcaa;
        const loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$792d8a18f2c55855 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1();
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (e) {
                if (onError !== undefined) onError(e);
                else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(e);
                return;
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145).
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$fd1bfc71f64c538c extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a();
        const loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$8d474f55edbb9624 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.groundColor = this.groundColor.getHex();
        return data;
    }
}
const $9ddd7e9b53f7a2d4$var$_projScreenMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_lightPositionWorld = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_lookTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * A node version of `bias`. Only supported with `WebGPURenderer`.
		 *
		 * If a bias node is defined, `bias` has no effect.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.biasNode = null;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2();
        this._frameExtents = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $9ddd7e9b53f7a2d4$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($9ddd7e9b53f7a2d4$var$_lightPositionWorld);
        $9ddd7e9b53f7a2d4$var$_lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($9ddd7e9b53f7a2d4$var$_lookTarget);
        shadowCamera.updateMatrixWorld();
        $9ddd7e9b53f7a2d4$var$_projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($9ddd7e9b53f7a2d4$var$_projScreenMatrix, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac || shadowCamera.reversedDepth) shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        else shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($9ddd7e9b53f7a2d4$var$_projScreenMatrix);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        this.biasNode = source.biasNode;
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
const $9ddd7e9b53f7a2d4$var$_position$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_scale$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$79f141de891a5fed extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3;
        this._reversedDepth = false;
    }
    /**
	 * The flag that indicates whether the camera uses a reversed depth buffer.
	 *
	 * @type {boolean}
	 * @default false
	 */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        // exclude scale from view matrix to be glTF conform
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$2, $9ddd7e9b53f7a2d4$var$_quaternion$2, $9ddd7e9b53f7a2d4$var$_scale$2);
        if ($9ddd7e9b53f7a2d4$var$_scale$2.x === 1 && $9ddd7e9b53f7a2d4$var$_scale$2.y === 1 && $9ddd7e9b53f7a2d4$var$_scale$2.z === 1) this.matrixWorldInverse.copy(this.matrixWorld).invert();
        else this.matrixWorldInverse.compose($9ddd7e9b53f7a2d4$var$_position$2, $9ddd7e9b53f7a2d4$var$_quaternion$2, $9ddd7e9b53f7a2d4$var$_scale$2.set(1, 1, 1)).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        // exclude scale from view matrix to be glTF conform
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$2, $9ddd7e9b53f7a2d4$var$_quaternion$2, $9ddd7e9b53f7a2d4$var$_scale$2);
        if ($9ddd7e9b53f7a2d4$var$_scale$2.x === 1 && $9ddd7e9b53f7a2d4$var$_scale$2.y === 1 && $9ddd7e9b53f7a2d4$var$_scale$2.z === 1) this.matrixWorldInverse.copy(this.matrixWorld).invert();
        else this.matrixWorldInverse.compose($9ddd7e9b53f7a2d4$var$_position$2, $9ddd7e9b53f7a2d4$var$_quaternion$2, $9ddd7e9b53f7a2d4$var$_scale$2.set(1, 1, 1)).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_v3$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_minTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
const $9ddd7e9b53f7a2d4$var$_maxTarget = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection](https://en.wikipedia.org/wiki/Perspective_(graphical)).
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7 extends $9ddd7e9b53f7a2d4$export$79f141de891a5fed {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * Math.atan(Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $9ddd7e9b53f7a2d4$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($9ddd7e9b53f7a2d4$var$_v3$1.x, $9ddd7e9b53f7a2d4$var$_v3$1.y).multiplyScalar(-distance / $9ddd7e9b53f7a2d4$var$_v3$1.z);
        $9ddd7e9b53f7a2d4$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($9ddd7e9b53f7a2d4$var$_v3$1.x, $9ddd7e9b53f7a2d4$var$_v3$1.y).multiplyScalar(-distance / $9ddd7e9b53f7a2d4$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $9ddd7e9b53f7a2d4$var$_minTarget, $9ddd7e9b53f7a2d4$var$_maxTarget);
        return target.subVectors($9ddd7e9b53f7a2d4$var$_maxTarget, $9ddd7e9b53f7a2d4$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$SpotLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $9ddd7e9b53f7a2d4$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$81495cbb73897362 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.map = source.map;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.angle = this.angle;
        data.object.decay = this.decay;
        data.object.penumbra = this.penumbra;
        data.object.target = this.target.uuid;
        if (this.map && this.map.isTexture) data.object.map = this.map.toJSON(meta).uuid;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$PointLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.decay = this.decay;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Camera that uses [orthographic projection](https://en.wikipedia.org/wiki/Orthographic_projection).
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b extends $9ddd7e9b53f7a2d4$export$79f141de891a5fed {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $9ddd7e9b53f7a2d4$var$DirectionalLightShadow extends $9ddd7e9b53f7a2d4$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$3fea33cc9972c868 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($9ddd7e9b53f7a2d4$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $9ddd7e9b53f7a2d4$var$DirectionalLightShadow();
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.shadow = this.shadow.toJSON();
        data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$61db2d908bbd2429 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $9ddd7e9b53f7a2d4$export$64b5c384219d3699());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2 extends $9ddd7e9b53f7a2d4$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading materials. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.allowOverride !== undefined) material.allowOverride = json.allowOverride;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $9ddd7e9b53f7a2d4$export$e8564da406055a3,
            SpriteMaterial: $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22,
            ShaderMaterial: $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d,
            PointsMaterial: $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $9ddd7e9b53f7a2d4$export$28d04986c4269c9f,
            MeshStandardMaterial: $9ddd7e9b53f7a2d4$export$f2980790215acccd,
            MeshPhongMaterial: $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678,
            MeshToonMaterial: $9ddd7e9b53f7a2d4$export$df893cf97e765622,
            MeshNormalMaterial: $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $9ddd7e9b53f7a2d4$export$5023a9a8114806b8,
            MeshDepthMaterial: $9ddd7e9b53f7a2d4$export$2698c22ec13825db,
            MeshDistanceMaterial: $9ddd7e9b53f7a2d4$export$33e187ed002f2a19,
            MeshBasicMaterial: $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee,
            LineDashedMaterial: $9ddd7e9b53f7a2d4$export$327886a3efaeaebe,
            LineBasicMaterial: $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c,
            Material: $9ddd7e9b53f7a2d4$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $9ddd7e9b53f7a2d4$export$231f009cbe414146 extends $9ddd7e9b53f7a2d4$export$b7be63a67df8959 {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$dc275bb96327833a extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $9ddd7e9b53f7a2d4$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $9ddd7e9b53f7a2d4$export$231f009cbe414146() : new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a : $9ddd7e9b53f7a2d4$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $9ddd7e9b53f7a2d4$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $9ddd7e9b53f7a2d4$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
const $9ddd7e9b53f7a2d4$var$_customGeometries = {};
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format](https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4).
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$40110c8505c5ad19 extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (e) {
                if (onError !== undefined) onError(e);
                $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('ObjectLoader: Can\'t parse ' + url + '.', e.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $9ddd7e9b53f7a2d4$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        let json;
        try {
            json = JSON.parse(text);
        } catch (e) {
            throw new Error('ObjectLoader: Can\'t parse ' + url + '. ' + e.message);
        }
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    /**
	 * Registers the given geometry at the internal
	 * geometry library.
	 *
	 * @static
	 * @param {string} type - The geometry type.
	 * @param {BufferGeometry.constructor} geometryClass - The geometry class.
	 */ static registerGeometry(type, geometryClass) {
        $9ddd7e9b53f7a2d4$var$_customGeometries[type] = geometryClass;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $9ddd7e9b53f7a2d4$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $9ddd7e9b53f7a2d4$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $9ddd7e9b53f7a2d4$var$Geometries) geometry = $9ddd7e9b53f7a2d4$var$Geometries[data.type].fromJSON(data, shapes);
                        else if (data.type in $9ddd7e9b53f7a2d4$var$_customGeometries) geometry = $9ddd7e9b53f7a2d4$var$_customGeometries[data.type].fromJSON(data, shapes);
                        else $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d(`ObjectLoader: Unknown geometry type "${data.type}". Use .registerGeometry() before starting the deserialization process.`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $9ddd7e9b53f7a2d4$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $9ddd7e9b53f7a2d4$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $9ddd7e9b53f7a2d4$export$99cc795e99919eed(onLoad);
            loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $9ddd7e9b53f7a2d4$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $9ddd7e9b53f7a2d4$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9ddd7e9b53f7a2d4$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $9ddd7e9b53f7a2d4$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $9ddd7e9b53f7a2d4$export$b691f601014eabe1();
                else texture = new $9ddd7e9b53f7a2d4$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $9ddd7e9b53f7a2d4$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.normalized !== undefined) texture.normalized = data.normalized;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $9ddd7e9b53f7a2d4$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $9ddd7e9b53f7a2d4$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $9ddd7e9b53f7a2d4$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $9ddd7e9b53f7a2d4$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $9ddd7e9b53f7a2d4$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $9ddd7e9b53f7a2d4$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $9ddd7e9b53f7a2d4$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                const sh = new $9ddd7e9b53f7a2d4$export$ba61ce607e1f405a().fromArray(data.sh);
                object = new $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2(sh, data.intensity);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $9ddd7e9b53f7a2d4$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9ddd7e9b53f7a2d4$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                    return {
                        ...info,
                        boundingBox: box,
                        boundingSphere: sphere
                    };
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new $9ddd7e9b53f7a2d4$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new $9ddd7e9b53f7a2d4$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $9ddd7e9b53f7a2d4$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $9ddd7e9b53f7a2d4$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $9ddd7e9b53f7a2d4$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $9ddd7e9b53f7a2d4$export$b127726e56765aa4();
                break;
            default:
                object = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.pivot !== undefined) object.pivot = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699().fromArray(data.pivot);
        if (data.morphTargetDictionary !== undefined) object.morphTargetDictionary = Object.assign({}, data.morphTargetDictionary);
        if (data.morphTargetInfluences !== undefined) object.morphTargetInfluences = data.morphTargetInfluences.slice();
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.static !== undefined) object.static = data.static;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924();
            }
        });
    }
}
const $9ddd7e9b53f7a2d4$var$TEXTURE_MAPPING = {
    UVMapping: $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $9ddd7e9b53f7a2d4$export$8759762a6477f2c4,
    CubeRefractionMapping: $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $9ddd7e9b53f7a2d4$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $9ddd7e9b53f7a2d4$export$ee99d97d46898098,
    CubeUVReflectionMapping: $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79
};
const $9ddd7e9b53f7a2d4$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f
};
const $9ddd7e9b53f7a2d4$var$TEXTURE_FILTER = {
    NearestFilter: $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2,
    LinearFilter: $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $9ddd7e9b53f7a2d4$export$19a719f377145a13,
    LinearMipmapLinearFilter: $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b
};
const $9ddd7e9b53f7a2d4$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap).
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * These options need to be configured via {@link ImageBitmapLoader#setOptions} prior to loading,
 * unlike regular images which can be configured on the Texture to set these options on GPU upload instead.
 *
 * To match the default behaviour of {@link Texture}, the following options are needed:
 *
 * ```js
 * { imageOrientation: 'flipY', premultiplyAlpha: 'none' }
 * ```
 *
 * Also note that unlike {@link FileLoader}, this loader will only avoid multiple concurrent requests to the same URL if {@link Cache} is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$52286b55c4a9b51f extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
	 *
	 * Note: When caching is enabled, the cache key is based on the URL only. Loading the same URL with
	 * different options will return the cached result of the first request.
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9ddd7e9b53f7a2d4$export$94affb487e701bf2.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if ($9ddd7e9b53f7a2d4$var$_errorMap.has(cached) === true) {
                        if (onError) onError($9ddd7e9b53f7a2d4$var$_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetchOptions.signal = typeof AbortSignal.any === 'function' ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            $9ddd7e9b53f7a2d4$var$_errorMap.set(promise, e);
            $9ddd7e9b53f7a2d4$export$94affb487e701bf2.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $9ddd7e9b53f7a2d4$export$94affb487e701bf2.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {ImageBitmapLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
let $9ddd7e9b53f7a2d4$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {Window.AudioContext} The native audio context.
	 */ static getContext() {
        if ($9ddd7e9b53f7a2d4$var$_context === undefined) $9ddd7e9b53f7a2d4$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $9ddd7e9b53f7a2d4$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {Window.AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $9ddd7e9b53f7a2d4$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $9ddd7e9b53f7a2d4$export$d8d5fccfbf47714e extends $9ddd7e9b53f7a2d4$export$3b0d6d7590275603 {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f.getContext();
                const decodeUrl = url + '#decode';
                scope.manager.itemStart(decodeUrl); // prevent loading manager from completing too early, see #33378
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                    scope.manager.itemEnd(decodeUrl);
                }).catch(function(e) {
                    handleError(e);
                    scope.manager.itemEnd(decodeUrl);
                });
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc(e);
            scope.manager.itemError(url);
        }
    }
}
const $9ddd7e9b53f7a2d4$var$_eyeRight = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_eyeLeft = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_projectionMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph](https://en.wikipedia.org/wiki/Anaglyph_3D) or
 * [Parallax Barrier](https://en.wikipedia.org/wiki/parallax_barrier).
 */ class $9ddd7e9b53f7a2d4$export$bc7f73a1065bee0c {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($9ddd7e9b53f7a2d4$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $9ddd7e9b53f7a2d4$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $9ddd7e9b53f7a2d4$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($9ddd7e9b53f7a2d4$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9ddd7e9b53f7a2d4$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($9ddd7e9b53f7a2d4$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($9ddd7e9b53f7a2d4$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($9ddd7e9b53f7a2d4$var$_eyeRight);
    }
}
const $9ddd7e9b53f7a2d4$var$fov = -90; // negative fov is not an error
const $9ddd7e9b53f7a2d4$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7($9ddd7e9b53f7a2d4$var$fov, $9ddd7e9b53f7a2d4$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        let reversedDepthBuffer = false;
        if (renderer.isWebGLRenderer === true) reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        else reversedDepthBuffer = renderer.reversedDepthBuffer;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        if (reversedDepthBuffer && renderer.autoClear === false) renderer.clearDepth();
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $9ddd7e9b53f7a2d4$export$56b937d9e5581166 extends $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * This class is an alternative to {@link Clock} with a different API design and behavior.
 * The goal is to avoid the conceptual flaws that became apparent in `Clock` over time.
 *
 * - `Timer` has an `update()` method that updates its internal state. That makes it possible to
 * call `getDelta()` and `getElapsed()` multiple times per simulation step without getting different values.
 * - The class can make use of the Page Visibility API to avoid large time delta values when the app
 * is inactive (e.g. tab switched or browser hidden).
 *
 * ```js
 * const timer = new Timer();
 * timer.connect( document ); // use Page Visibility API
 * ```
 */ class $9ddd7e9b53f7a2d4$export$c57e9b2d8b9e4de {
    /**
	 * Constructs a new timer.
	 */ constructor(){
        this._previousTime = 0;
        this._currentTime = 0;
        this._startTime = performance.now();
        this._delta = 0;
        this._elapsed = 0;
        this._timescale = 1;
        this._document = null;
        this._pageVisibilityHandler = null;
    }
    /**
	 * Connect the timer to the given document.Calling this method is not mandatory to
	 * use the timer but enables the usage of the Page Visibility API to avoid large time
	 * delta values.
	 *
	 * @param {Document} document - The document.
	 */ connect(document1) {
        this._document = document1;
        // use Page Visibility API to avoid large time delta values
        if (document1.hidden !== undefined) {
            this._pageVisibilityHandler = $9ddd7e9b53f7a2d4$var$handleVisibilityChange.bind(this);
            document1.addEventListener('visibilitychange', this._pageVisibilityHandler, false);
        }
    }
    /**
	 * Disconnects the timer from the DOM and also disables the usage of the Page Visibility API.
	 */ disconnect() {
        if (this._pageVisibilityHandler !== null) {
            this._document.removeEventListener('visibilitychange', this._pageVisibilityHandler);
            this._pageVisibilityHandler = null;
        }
        this._document = null;
    }
    /**
	 * Returns the time delta in seconds.
	 *
	 * @return {number} The time delta in second.
	 */ getDelta() {
        return this._delta / 1000;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time in second.
	 */ getElapsed() {
        return this._elapsed / 1000;
    }
    /**
	 * Returns the timescale.
	 *
	 * @return {number} The timescale.
	 */ getTimescale() {
        return this._timescale;
    }
    /**
	 * Sets the given timescale which scale the time delta computation
	 * in `update()`.
	 *
	 * @param {number} timescale - The timescale to set.
	 * @return {Timer} A reference to this timer.
	 */ setTimescale(timescale) {
        this._timescale = timescale;
        return this;
    }
    /**
	 * Resets the time computation for the current simulation step.
	 *
	 * @return {Timer} A reference to this timer.
	 */ reset() {
        this._currentTime = performance.now() - this._startTime;
        return this;
    }
    /**
	 * Can be used to free all internal resources. Usually called when
	 * the timer instance isn't required anymore.
	 */ dispose() {
        this.disconnect();
    }
    /**
	 * Updates the internal state of the timer. This method should be called
	 * once per simulation step and before you perform queries against the timer
	 * (e.g. via `getDelta()`).
	 *
	 * @param {number} timestamp - The current time in milliseconds. Can be obtained
	 * from the `requestAnimationFrame` callback argument. If not provided, the current
	 * time will be determined with `performance.now`.
	 * @return {Timer} A reference to this timer.
	 */ update(timestamp) {
        if (this._pageVisibilityHandler !== null && this._document.hidden === true) this._delta = 0;
        else {
            this._previousTime = this._currentTime;
            this._currentTime = (timestamp !== undefined ? timestamp : performance.now()) - this._startTime;
            this._delta = (this._currentTime - this._previousTime) * this._timescale;
            this._elapsed += this._delta; // _elapsed is the accumulation of all previous deltas
        }
        return this;
    }
}
function $9ddd7e9b53f7a2d4$var$handleVisibilityChange() {
    if (this._document.hidden === false) this.reset();
}
const $9ddd7e9b53f7a2d4$var$_position$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_scale$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_forward = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_up = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$8a1b810c6fde8951 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $9ddd7e9b53f7a2d4$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._timer = new $9ddd7e9b53f7a2d4$export$c57e9b2d8b9e4de();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this._timer.update();
        const listener = this.context.listener;
        this.timeDelta = this._timer.getDelta();
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position$1, $9ddd7e9b53f7a2d4$var$_quaternion$1, $9ddd7e9b53f7a2d4$var$_scale$1);
        // the initial forward and up directions must be orthogonal
        $9ddd7e9b53f7a2d4$var$_forward.set(0, 0, -1).applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$1);
        $9ddd7e9b53f7a2d4$var$_up.set(0, 1, 0).applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_forward.z, endTime);
            listener.upX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_up.x, endTime);
            listener.upY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_up.y, endTime);
            listener.upZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_up.z, endTime);
        } else {
            listener.setPosition($9ddd7e9b53f7a2d4$var$_position$1.x, $9ddd7e9b53f7a2d4$var$_position$1.y, $9ddd7e9b53f7a2d4$var$_position$1.z);
            listener.setOrientation($9ddd7e9b53f7a2d4$var$_forward.x, $9ddd7e9b53f7a2d4$var$_forward.y, $9ddd7e9b53f7a2d4$var$_forward.z, $9ddd7e9b53f7a2d4$var$_up.x, $9ddd7e9b53f7a2d4$var$_up.y, $9ddd7e9b53f7a2d4$var$_up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API](https://www.w3.org/TR/webaudio-1.1/).
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$153755f98d9861de extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically set by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $9ddd7e9b53f7a2d4$var$_position = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_quaternion = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3();
const $9ddd7e9b53f7a2d4$var$_scale = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_orientation = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $9ddd7e9b53f7a2d4$export$4b3e397ef1832507 extends $9ddd7e9b53f7a2d4$export$153755f98d9861de {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec](https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype)
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($9ddd7e9b53f7a2d4$var$_position, $9ddd7e9b53f7a2d4$var$_quaternion, $9ddd7e9b53f7a2d4$var$_scale);
        $9ddd7e9b53f7a2d4$var$_orientation.set(0, 0, 1).applyQuaternion($9ddd7e9b53f7a2d4$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($9ddd7e9b53f7a2d4$var$_orientation.z, endTime);
        } else {
            panner.setPosition($9ddd7e9b53f7a2d4$var$_position.x, $9ddd7e9b53f7a2d4$var$_position.y, $9ddd7e9b53f7a2d4$var$_position.z);
            panner.setOrientation($9ddd7e9b53f7a2d4$var$_orientation.x, $9ddd7e9b53f7a2d4$var$_orientation.y, $9ddd7e9b53f7a2d4$var$_orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $9ddd7e9b53f7a2d4$export$d47da1ef3d382827 {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $9ddd7e9b53f7a2d4$export$dfe0af1ca1acb78a {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * Accumulated weight of the property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * Accumulated additive weight of the property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * Number of active keyframe tracks currently using this property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * Number of keyframe tracks referencing this property binding.
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $9ddd7e9b53f7a2d4$var$_reservedRe = new RegExp('[' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $9ddd7e9b53f7a2d4$var$_wordChar = '[^' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE + ']';
const $9ddd7e9b53f7a2d4$var$_wordCharOrDot = '[^' + $9ddd7e9b53f7a2d4$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $9ddd7e9b53f7a2d4$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $9ddd7e9b53f7a2d4$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $9ddd7e9b53f7a2d4$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $9ddd7e9b53f7a2d4$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $9ddd7e9b53f7a2d4$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $9ddd7e9b53f7a2d4$var$_wordChar);
const $9ddd7e9b53f7a2d4$var$_trackRe = new RegExp("^" + $9ddd7e9b53f7a2d4$var$_directoryRe + $9ddd7e9b53f7a2d4$var$_nodeRe + $9ddd7e9b53f7a2d4$var$_objectRe + $9ddd7e9b53f7a2d4$var$_propertyRe + '$');
const $9ddd7e9b53f7a2d4$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $9ddd7e9b53f7a2d4$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893 {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($9ddd7e9b53f7a2d4$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $9ddd7e9b53f7a2d4$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($9ddd7e9b53f7a2d4$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.Composite = $9ddd7e9b53f7a2d4$var$Composite;
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_direct,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_array,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $9ddd7e9b53f7a2d4$export$30619c2afd3f34db {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $9ddd7e9b53f7a2d4$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $9ddd7e9b53f7a2d4$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $9ddd7e9b53f7a2d4$export$6946940a69e799e {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $9ddd7e9b53f7a2d4$export$7f795934b84ab523,
            endingEnd: $9ddd7e9b53f7a2d4$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            // preserve interpolant settings (like tangent data from BezierInterpolant)
            if (interpolant.settings) Object.assign(interpolantSettings, interpolant.settings);
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $9ddd7e9b53f7a2d4$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Internal
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $9ddd7e9b53f7a2d4$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $9ddd7e9b53f7a2d4$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $9ddd7e9b53f7a2d4$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else {
                this._loopCount = loopCount;
                this.time = time;
            }
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5;
            settings.endingEnd = $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 : $9ddd7e9b53f7a2d4$export$7f795934b84ab523;
            else settings.endingStart = $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $9ddd7e9b53f7a2d4$export$24a4ccb5099273b5 : $9ddd7e9b53f7a2d4$export$7f795934b84ab523;
            else settings.endingEnd = $9ddd7e9b53f7a2d4$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $9ddd7e9b53f7a2d4$export$fbd77e5aefaa0102 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $9ddd7e9b53f7a2d4$export$dfe0af1ca1acb78a($9ddd7e9b53f7a2d4$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $9ddd7e9b53f7a2d4$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $9ddd7e9b53f7a2d4$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $9ddd7e9b53f7a2d4$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $9ddd7e9b53f7a2d4$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $9ddd7e9b53f7a2d4$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $9ddd7e9b53f7a2d4$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $9ddd7e9b53f7a2d4$export$6b116d2fdfef087c extends $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $9ddd7e9b53f7a2d4$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $9ddd7e9b53f7a2d4$export$2947cebfe91c02f8 {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $9ddd7e9b53f7a2d4$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $9ddd7e9b53f7a2d4$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$c412d5ffe1f79209 extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $9ddd7e9b53f7a2d4$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $9ddd7e9b53f7a2d4$export$25ec0e1af1389358 extends $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $9ddd7e9b53f7a2d4$export$6b7339ae8dbddf73 {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_matrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $9ddd7e9b53f7a2d4$export$8b7aaceff00bd2f {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $9ddd7e9b53f7a2d4$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are closer than far. Far can't be lower than near.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $9ddd7e9b53f7a2d4$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc('Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $9ddd7e9b53f7a2d4$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($9ddd7e9b53f7a2d4$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} normal - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $9ddd7e9b53f7a2d4$var$intersect(object, this, intersects, recursive);
        intersects.sort($9ddd7e9b53f7a2d4$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$9ddd7e9b53f7a2d4$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($9ddd7e9b53f7a2d4$var$ascSort);
        return intersects;
    }
}
function $9ddd7e9b53f7a2d4$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $9ddd7e9b53f7a2d4$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$9ddd7e9b53f7a2d4$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Class for keeping track of time.
 *
 * @deprecated since r183.
 */ class $9ddd7e9b53f7a2d4$export$9735c82c4bae3302 {
    /**
	 * Constructs a new clock.
	 *
	 * @deprecated since 183.
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
        $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Clock: This module has been deprecated. Please use THREE.Timer instead.'); // @deprecated, r183
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates](https://en.wikipedia.org/wiki/Spherical_coordinate_system).
 */ class $9ddd7e9b53f7a2d4$export$d712cd887b4a00f7 {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $9ddd7e9b53f7a2d4$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The y value.
	 * @param {number} z - The z value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($9ddd7e9b53f7a2d4$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates](https://en.wikipedia.org/wiki/Cylindrical_coordinate_system).
 */ class $9ddd7e9b53f7a2d4$export$287165bb2177f4fd {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38 {
    static{
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
    }
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$4 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $9ddd7e9b53f7a2d4$export$60f553fa130f08b0 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(Infinity, Infinity), max = new $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $9ddd7e9b53f7a2d4$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $9ddd7e9b53f7a2d4$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $9ddd7e9b53f7a2d4$var$_startP = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_startEnd = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_d1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_d2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_r = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_c1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_c2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $9ddd7e9b53f7a2d4$export$e0ba6359f1954fd3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(), end = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $9ddd7e9b53f7a2d4$var$_startP.subVectors(point, this.start);
        $9ddd7e9b53f7a2d4$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $9ddd7e9b53f7a2d4$var$_startEnd.dot($9ddd7e9b53f7a2d4$var$_startEnd);
        if (startEnd2 === 0) return 0;
        const startEnd_startP = $9ddd7e9b53f7a2d4$var$_startEnd.dot($9ddd7e9b53f7a2d4$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $9ddd7e9b53f7a2d4$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closest point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns the closest squared distance between this line segment and the given one.
	 *
	 * @param {Line3} line - The line segment to compute the closest squared distance to.
	 * @param {Vector3} [c1] - The closest point on this line segment.
	 * @param {Vector3} [c2] - The closest point on the given line segment.
	 * @return {number} The squared distance between this line segment and the given one.
	 */ distanceSqToLine3(line, c1 = $9ddd7e9b53f7a2d4$var$_c1, c2 = $9ddd7e9b53f7a2d4$var$_c2) {
        // from Real-Time Collision Detection by Christer Ericson, chapter 5.1.9
        // Computes closest points C1 and C2 of S1(s)=P1+s*(Q1-P1) and
        // S2(t)=P2+t*(Q2-P2), returning s and t. Function result is squared
        // distance between between S1(s) and S2(t)
        const EPSILON = 1e-8 * 1e-8; // must be squared since we compare squared length
        let s, t;
        const p1 = this.start;
        const p2 = line.start;
        const q1 = this.end;
        const q2 = line.end;
        $9ddd7e9b53f7a2d4$var$_d1.subVectors(q1, p1); // Direction vector of segment S1
        $9ddd7e9b53f7a2d4$var$_d2.subVectors(q2, p2); // Direction vector of segment S2
        $9ddd7e9b53f7a2d4$var$_r.subVectors(p1, p2);
        const a = $9ddd7e9b53f7a2d4$var$_d1.dot($9ddd7e9b53f7a2d4$var$_d1); // Squared length of segment S1, always nonnegative
        const e = $9ddd7e9b53f7a2d4$var$_d2.dot($9ddd7e9b53f7a2d4$var$_d2); // Squared length of segment S2, always nonnegative
        const f = $9ddd7e9b53f7a2d4$var$_d2.dot($9ddd7e9b53f7a2d4$var$_r);
        // Check if either or both segments degenerate into points
        if (a <= EPSILON && e <= EPSILON) {
            // Both segments degenerate into points
            c1.copy(p1);
            c2.copy(p2);
            c1.sub(c2);
            return c1.dot(c1);
        }
        if (a <= EPSILON) {
            // First segment degenerates into a point
            s = 0;
            t = f / e; // s = 0 => t = (b*s + f) / e = f / e
            t = $9ddd7e9b53f7a2d4$var$clamp(t, 0, 1);
        } else {
            const c = $9ddd7e9b53f7a2d4$var$_d1.dot($9ddd7e9b53f7a2d4$var$_r);
            if (e <= EPSILON) {
                // Second segment degenerates into a point
                t = 0;
                s = $9ddd7e9b53f7a2d4$var$clamp(-c / a, 0, 1); // t = 0 => s = (b*t - c) / a = -c / a
            } else {
                // The general nondegenerate case starts here
                const b = $9ddd7e9b53f7a2d4$var$_d1.dot($9ddd7e9b53f7a2d4$var$_d2);
                const denom = a * e - b * b; // Always nonnegative
                // If segments not parallel, compute closest point on L1 to L2 and
                // clamp to segment S1. Else pick arbitrary s (here 0)
                if (denom !== 0) s = $9ddd7e9b53f7a2d4$var$clamp((b * f - c * e) / denom, 0, 1);
                else s = 0;
                // Compute point on L2 closest to S1(s) using
                // t = Dot((P1 + D1*s) - P2,D2) / Dot(D2,D2) = (b*s + f) / e
                t = (b * s + f) / e;
                // If t in [0,1] done. Else clamp t, recompute s for the new value
                // of t using s = Dot((P2 + D2*t) - P1,D1) / Dot(D1,D1)= (t*b - c) / a
                // and clamp s to [0, 1]
                if (t < 0) {
                    t = 0.;
                    s = $9ddd7e9b53f7a2d4$var$clamp(-c / a, 0, 1);
                } else if (t > 1) {
                    t = 1;
                    s = $9ddd7e9b53f7a2d4$var$clamp((b - c) / a, 0, 1);
                }
            }
        }
        c1.copy(p1).addScaledVector($9ddd7e9b53f7a2d4$var$_d1, s);
        c2.copy(p2).addScaledVector($9ddd7e9b53f7a2d4$var$_d2, t);
        return c1.distanceToSquared(c2);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * When the spot light or its target are transformed or light properties are
 * changed, it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$4b14638ffdd81e68 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $9ddd7e9b53f7a2d4$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($9ddd7e9b53f7a2d4$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $9ddd7e9b53f7a2d4$var$_vector$2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_boneMatrix = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
const $9ddd7e9b53f7a2d4$var$_matrixWorldInv = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$5277df3c9e732259 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new skeleton helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $9ddd7e9b53f7a2d4$var$getBoneList(object);
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                colors.push(0, 0, 0);
            }
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
        // colors
        const color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x0000ff);
        const color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x00ff00);
        this.setColors(color1, color2);
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $9ddd7e9b53f7a2d4$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $9ddd7e9b53f7a2d4$var$_boneMatrix.multiplyMatrices($9ddd7e9b53f7a2d4$var$_matrixWorldInv, bone.matrixWorld);
                $9ddd7e9b53f7a2d4$var$_vector$2.setFromMatrixPosition($9ddd7e9b53f7a2d4$var$_boneMatrix);
                position.setXYZ(j, $9ddd7e9b53f7a2d4$var$_vector$2.x, $9ddd7e9b53f7a2d4$var$_vector$2.y, $9ddd7e9b53f7a2d4$var$_vector$2.z);
                $9ddd7e9b53f7a2d4$var$_boneMatrix.multiplyMatrices($9ddd7e9b53f7a2d4$var$_matrixWorldInv, bone.parent.matrixWorld);
                $9ddd7e9b53f7a2d4$var$_vector$2.setFromMatrixPosition($9ddd7e9b53f7a2d4$var$_boneMatrix);
                position.setXYZ(j + 1, $9ddd7e9b53f7a2d4$var$_vector$2.x, $9ddd7e9b53f7a2d4$var$_vector$2.y, $9ddd7e9b53f7a2d4$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} color1 - The first line color for each bone.
	 * @param {Color} color2 - The second line color for each bone.
	 * @return {SkeletonHelper} A reference to this helper.
	 */ setColors(color1, color2) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        for(let i = 0; i < colorAttribute.count; i += 2){
            colorAttribute.setXYZ(i, color1.r, color1.g, color1.b);
            colorAttribute.setXYZ(i + 1, color2.r, color2.g, color2.b);
        }
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $9ddd7e9b53f7a2d4$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$9ddd7e9b53f7a2d4$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $9ddd7e9b53f7a2d4$export$9a9291685b9e4023 extends $9ddd7e9b53f7a2d4$export$e176487c05830cc5 {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $9ddd7e9b53f7a2d4$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {PointLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $9ddd7e9b53f7a2d4$var$_vector$1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_color1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
const $9ddd7e9b53f7a2d4$var$_color2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * When the hemisphere light is transformed or its light properties are changed,
 * it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$8dca15f13f4f8172 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $9ddd7e9b53f7a2d4$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(colors, 3));
        this.add(new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $9ddd7e9b53f7a2d4$var$_color1.copy(this.light.color);
            $9ddd7e9b53f7a2d4$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $9ddd7e9b53f7a2d4$var$_color1 : $9ddd7e9b53f7a2d4$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($9ddd7e9b53f7a2d4$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$3875d39926561055 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color1);
        color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$361430a10f533cd3 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color1);
        color2 = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $9ddd7e9b53f7a2d4$var$_v1 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v2 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_v3 = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of a plane and a line representing the
 * light's position and direction.
 *
 * When the directional light or its target are transformed or light properties
 * are changed, it's necessary to call the `update()` method of the respective helper.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$f8e434dc14203e7d extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $9ddd7e9b53f7a2d4$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $9ddd7e9b53f7a2d4$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $9ddd7e9b53f7a2d4$var$_v3.subVectors($9ddd7e9b53f7a2d4$var$_v2, $9ddd7e9b53f7a2d4$var$_v1);
        this.lightPlane.lookAt($9ddd7e9b53f7a2d4$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($9ddd7e9b53f7a2d4$var$_v2);
        this.targetLine.scale.z = $9ddd7e9b53f7a2d4$var$_v3.length();
    }
}
const $9ddd7e9b53f7a2d4$var$_vector = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
const $9ddd7e9b53f7a2d4$var$_camera = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example](https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html).
 *
 * `CameraHelper` must be a child of the scene.
 *
 * When the camera is transformed or its projection matrix is changed, it's necessary
 * to call the `update()` method of the respective helper.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$ed8e93f853cd795 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xff0000);
        const colorUp = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0xffffff);
        const colorCross = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 * @return {CameraHelper} A reference to this helper.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        let nearZ, farZ;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $9ddd7e9b53f7a2d4$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        if (this.camera.reversedDepth === true) {
            nearZ = 1;
            farZ = 0;
        } else {
            if (this.camera.coordinateSystem === $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) {
                nearZ = -1;
                farZ = 1;
            } else if (this.camera.coordinateSystem === $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) {
                nearZ = 0;
                farZ = 1;
            } else throw new Error('THREE.CameraHelper.update(): Invalid coordinate system: ' + this.camera.coordinateSystem);
        }
        // center / target
        $9ddd7e9b53f7a2d4$var$setPoint('c', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('t', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, 0, farZ);
        // near
        $9ddd7e9b53f7a2d4$var$setPoint('n1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, -h, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, -h, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, h, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('n4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, h, nearZ);
        // far
        $9ddd7e9b53f7a2d4$var$setPoint('f1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, -h, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('f2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, -h, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('f3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, h, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('f4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, h, farZ);
        // up
        $9ddd7e9b53f7a2d4$var$setPoint('u1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w * 0.7, h * 1.1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('u2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('u3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h * 2, nearZ);
        // cross
        $9ddd7e9b53f7a2d4$var$setPoint('cf1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, 0, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cf2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, 0, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cf3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, -h, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cf4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h, farZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn1', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, -w, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn2', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, w, 0, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn3', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, -h, nearZ);
        $9ddd7e9b53f7a2d4$var$setPoint('cn4', pointMap, geometry, $9ddd7e9b53f7a2d4$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $9ddd7e9b53f7a2d4$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $9ddd7e9b53f7a2d4$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $9ddd7e9b53f7a2d4$var$_vector.x, $9ddd7e9b53f7a2d4$var$_vector.y, $9ddd7e9b53f7a2d4$var$_vector.z);
    }
}
const $9ddd7e9b53f7a2d4$var$_box = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$38a664cc862a6a9d extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $9ddd7e9b53f7a2d4$var$_box.setFromObject(this.object);
        if ($9ddd7e9b53f7a2d4$var$_box.isEmpty()) return;
        const min = $9ddd7e9b53f7a2d4$var$_box.min;
        const max = $9ddd7e9b53f7a2d4$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$ce39f4bb96c9a290 extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setIndex(new $9ddd7e9b53f7a2d4$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $9ddd7e9b53f7a2d4$export$a34fe8156c66e5d7 extends $9ddd7e9b53f7a2d4$export$17d680238e50603e {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(geometry2, new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $9ddd7e9b53f7a2d4$var$_axis = /*@__PURE__*/ new $9ddd7e9b53f7a2d4$export$64b5c384219d3699();
let $9ddd7e9b53f7a2d4$var$_lineGeometry, $9ddd7e9b53f7a2d4$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $9ddd7e9b53f7a2d4$export$a3008e7bd8d2cbe7 extends $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 1), origin = new $9ddd7e9b53f7a2d4$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($9ddd7e9b53f7a2d4$var$_lineGeometry === undefined) {
            $9ddd7e9b53f7a2d4$var$_lineGeometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
            $9ddd7e9b53f7a2d4$var$_lineGeometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $9ddd7e9b53f7a2d4$var$_coneGeometry = new $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $9ddd7e9b53f7a2d4$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $9ddd7e9b53f7a2d4$export$17d680238e50603e($9ddd7e9b53f7a2d4$var$_lineGeometry, new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5($9ddd7e9b53f7a2d4$var$_coneGeometry, new $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $9ddd7e9b53f7a2d4$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($9ddd7e9b53f7a2d4$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $9ddd7e9b53f7a2d4$export$6c8303f35b8578fd extends $9ddd7e9b53f7a2d4$export$ff1ed10fedfdd604 {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $9ddd7e9b53f7a2d4$export$b7be63a67df8959();
        geometry.setAttribute('position', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd(colors, 3));
        const material = new $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $9ddd7e9b53f7a2d4$export$148534a3c727230b {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $9ddd7e9b53f7a2d4$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $9ddd7e9b53f7a2d4$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $9ddd7e9b53f7a2d4$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $9ddd7e9b53f7a2d4$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f extends $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $9ddd7e9b53f7a2d4$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $9ddd7e9b53f7a2d4$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $9ddd7e9b53f7a2d4$export$988473390501ed4b:
            return width * height;
        case $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $9ddd7e9b53f7a2d4$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0:
        case $9ddd7e9b53f7a2d4$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c:
        case $9ddd7e9b53f7a2d4$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4:
        case $9ddd7e9b53f7a2d4$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573:
        case $9ddd7e9b53f7a2d4$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7:
        case $9ddd7e9b53f7a2d4$export$7800993ef8106a6a:
        case $9ddd7e9b53f7a2d4$export$d5c566817123b2bf:
        case $9ddd7e9b53f7a2d4$export$f5668dc623297d86:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8:
        case $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf:
        case $9ddd7e9b53f7a2d4$export$211402338cb75433:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $9ddd7e9b53f7a2d4$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $9ddd7e9b53f7a2d4$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $9ddd7e9b53f7a2d4$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $9ddd7e9b53f7a2d4$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $9ddd7e9b53f7a2d4$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $9ddd7e9b53f7a2d4$export$ce40b115e188bc81:
        case $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e:
        case $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $9ddd7e9b53f7a2d4$export$b1688df4c4c21670:
        case $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f:
        case $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $9ddd7e9b53f7a2d4$var$getTextureTypeByteLength(type) {
    switch(type){
        case $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10:
        case $9ddd7e9b53f7a2d4$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
        case $9ddd7e9b53f7a2d4$export$88572337f312435f:
        case $9ddd7e9b53f7a2d4$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$b3969b01faf587f2:
        case $9ddd7e9b53f7a2d4$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
        case $9ddd7e9b53f7a2d4$export$5c612977753abe2:
        case $9ddd7e9b53f7a2d4$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3:
        case $9ddd7e9b53f7a2d4$export$f240f067f72abe41:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $9ddd7e9b53f7a2d4$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $9ddd7e9b53f7a2d4$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $9ddd7e9b53f7a2d4$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $9ddd7e9b53f7a2d4$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $9ddd7e9b53f7a2d4$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $9ddd7e9b53f7a2d4$export$3545e07a80636437;
}

/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            if (context === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            if (context !== null) context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec4 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec4 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n\tvColor *= color;\n#elif defined( USE_COLOR )\n\tvColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * reflectVec );\n\t\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif\n#include <lightprobes_pars_fragment>";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\treturn 0.5 / max( gv + gl, EPSILON );\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t\t#ifdef USE_CLEARCOAT\n\t\t\tvec3 Ncc = geometryClearcoatNormal;\n\t\t\tvec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n\t\t\tvec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n\t\t\tvec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n\t\t\tmat3 mInvClearcoat = mat3(\n\t\t\t\tvec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n\t\t\t\tvec3(             0, 1,             0 ),\n\t\t\t\tvec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n\t\t\t);\n\t\t\tvec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n\t\t\tclearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n\t\t#endif\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#ifdef USE_LIGHT_PROBES_GRID\n\t\tvec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;\n\t\tvec3 probeWorldNormal = inverseTransformDirection( geometryNormal, viewMatrix );\n\t\tirradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\t#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n\t\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t\t#endif\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\t#if defined( LAMBERT ) || defined( PHONG )\n\t\tirradiance += iblIrradiance;\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$lightprobes_pars_fragment = "#ifdef USE_LIGHT_PROBES_GRID\nuniform highp sampler3D probesSH;\nuniform vec3 probesMin;\nuniform vec3 probesMax;\nuniform vec3 probesResolution;\nvec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {\n\tvec3 res = probesResolution;\n\tvec3 gridRange = probesMax - probesMin;\n\tvec3 resMinusOne = res - 1.0;\n\tvec3 probeSpacing = gridRange / resMinusOne;\n\tvec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;\n\tvec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );\n\tuvw = uvw * resMinusOne / res + 0.5 / res;\n\tfloat nz          = res.z;\n\tfloat paddedSlices = nz + 2.0;\n\tfloat atlasDepth  = 7.0 * paddedSlices;\n\tfloat uvZBase     = uvw.z * nz + 1.0;\n\tvec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );\n\tvec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );\n\tvec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );\n\tvec3 c0 = s0.xyz;\n\tvec3 c1 = vec3( s0.w, s1.xy );\n\tvec3 c2 = vec3( s1.zw, s2.x );\n\tvec3 c3 = s2.yzw;\n\tvec3 c4 = s3.xyz;\n\tvec3 c5 = vec3( s3.w, s4.xy );\n\tvec3 c6 = vec3( s4.zw, s5.x );\n\tvec3 c7 = s5.yzw;\n\tvec3 c8 = s6.xyz;\n\tfloat x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;\n\tvec3 result = c0 * 0.886227;\n\tresult += c1 * 2.0 * 0.511664 * y;\n\tresult += c2 * 2.0 * 0.511664 * z;\n\tresult += c3 * 2.0 * 0.511664 * x;\n\tresult += c4 * 2.0 * 0.429043 * x * y;\n\tresult += c5 * 2.0 * 0.429043 * y * z;\n\tresult += c6 * ( 0.743125 * z * z - 0.247708 );\n\tresult += c7 * 2.0 * 0.429043 * x * z;\n\tresult += c8 * 0.429043 * ( x * x - y * y );\n\treturn max( result, vec3( 0.0 ) );\n}\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#if defined( USE_PACKED_NORMALMAP )\n\t\tmapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );\n\t#endif\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\n\t\treturn depth * ( far - near ) - far;\n\t#else\n\t\treturn depth * ( near - far ) - near;\n\t#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\treturn ( near * far ) / ( ( near - far ) * depth - near );\n\t#else\n\t\treturn ( near * far ) / ( ( far - near ) * depth - far );\n\t#endif\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\t\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tfloat dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp -= shadowBias;\n\t\t\t#else\n\t\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp += shadowBias;\n\t\t\t#endif\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\tvec2 sample0 = vogelDiskSample( 0, 5, phi );\n\t\t\tvec2 sample1 = vogelDiskSample( 1, 5, phi );\n\t\t\tvec2 sample2 = vogelDiskSample( 2, 5, phi );\n\t\t\tvec2 sample3 = vogelDiskSample( 3, 5, phi );\n\t\t\tvec2 sample4 = vogelDiskSample( 4, 5, phi );\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tdepth = 1.0 - depth;\n\t\t\t#endif\n\t\t\tshadow = step( dp, depth );\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\t#ifdef HAS_NORMAL\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t#else\n\t\tvec3 shadowWorldNormal = vec3( 0.0 );\n\t#endif\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    batching_pars_vertex: $d5b33d7c30034067$var$batching_pars_vertex,
    batching_vertex: $d5b33d7c30034067$var$batching_vertex,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    lightprobes_pars_fragment: $d5b33d7c30034067$var$lightprobes_pars_fragment,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $d5b33d7c30034067$var$morphinstance_vertex,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distance_vert: $d5b33d7c30034067$var$vertex$d,
    distance_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        },
        dfgLUT: {
            value: null
        } // DFG LUT for physically-based rendering
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        },
        probesSH: {
            value: null
        },
        probesMin: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()
        },
        probesMax: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()
        },
        probesResolution: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x111111)
                },
                shininess: {
                    value: 30
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distance: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distance_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distance_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $9ddd7e9b53f7a2d4$export$8916ce6879271f43)([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $d5b33d7c30034067$var$_m$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)();
$d5b33d7c30034067$var$_m$1.set(-1, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0);
function $d5b33d7c30034067$var$WebGLBackground(renderer, environments, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = environments.get(background, usePMREM);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$33e43285f7406bd5)(1, 1, 1), new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $9ddd7e9b53f7a2d4$export$acda854380553452)($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            // note: since the matrix is orthonormal, we can use the more-efficient transpose() in lieu of invert()
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1$1.makeRotationFromEuler(scene.backgroundRotation)).transpose();
            if (background.isCubeTexture && background.isRenderTargetTexture === false) boxMesh.material.uniforms.backgroundRotation.value.premultiply($d5b33d7c30034067$var$_m$1);
            boxMesh.material.toneMapped = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$967d831af31f69ce)(2, 2), new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $9ddd7e9b53f7a2d4$export$acda854380553452)($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, (0, $9ddd7e9b53f7a2d4$export$a630742c640528c1)(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(object, geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(object, geometry, program, material) {
        const wireframe = material.wireframe === true;
        let objectMap = bindingStates[geometry.id];
        if (objectMap === undefined) {
            objectMap = {};
            bindingStates[geometry.id] = objectMap;
        }
        // Each InstancedMesh requires unique binding states because it contains instanced attributes.
        const objectId = object.isInstancedMesh === true ? object.id : 0;
        let programMap = objectMap[objectId];
        if (programMap === undefined) {
            programMap = {};
            objectMap[objectId] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            for(const objectId in objectMap){
                const programMap = objectMap[objectId];
                for(const programId in programMap){
                    const stateMap = programMap[programId];
                    for(const wireframe in stateMap){
                        deleteVertexArrayObject(stateMap[wireframe].object);
                        delete stateMap[wireframe];
                    }
                    delete programMap[programId];
                }
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const objectMap = bindingStates[geometry.id];
        for(const objectId in objectMap){
            const programMap = objectMap[objectId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            for(const objectId in objectMap){
                const programMap = objectMap[objectId];
                if (programMap[program.id] === undefined) continue;
                const stateMap = programMap[program.id];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[program.id];
            }
        }
    }
    function releaseStatesOfObject(object) {
        for(const geometryId in bindingStates){
            const objectMap = bindingStates[geometryId];
            const objectId = object.isInstancedMesh === true ? object.id : 0;
            const programMap = objectMap[objectId];
            if (programMap === undefined) continue;
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete objectMap[objectId];
            if (Object.keys(objectMap).length === 0) delete bindingStates[geometryId];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfObject: releaseStatesOfObject,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has('EXT_clip_control');
    if (parameters.reversedDepthBuffer === true && reversedDepthBuffer === false) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    const samples = gl.getParameter(gl.SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reversedDepthBuffer: reversedDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        maxSamples: maxSamples,
        samples: samples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0)(), viewNormalMatrix = new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $d5b33d7c30034067$var$GGX_SAMPLES = 256;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b)();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
let $d5b33d7c30034067$var$_oldTarget = null;
let $d5b33d7c30034067$var$_oldActiveCubeFace = 0;
let $d5b33d7c30034067$var$_oldActiveMipmapLevel = 0;
let $d5b33d7c30034067$var$_oldXrEnabled = false;
const $d5b33d7c30034067$var$_origin = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $d5b33d7c30034067$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._backgroundBox = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._blurMaterial = null;
        this._ggxMaterial = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $d5b33d7c30034067$var$_origin } = options;
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget, $d5b33d7c30034067$var$_oldActiveCubeFace, $d5b33d7c30034067$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $d5b33d7c30034067$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4) || texture.mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        $d5b33d7c30034067$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $d5b33d7c30034067$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $d5b33d7c30034067$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
            minFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
            generateMipmaps: false,
            type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
            format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
            colorSpace: (0, $9ddd7e9b53f7a2d4$export$42429b3acfb233a4),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
            this._ggxMaterial = $d5b33d7c30034067$var$_getGGXShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)(), material);
        this._renderer.compile(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        renderer.autoClear = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.clearDepth();
            renderer.setRenderTarget(null);
        }
        if (this._backgroundBox === null) this._backgroundBox = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$33e43285f7406bd5)(), new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
            name: 'PMREM.Background',
            side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4) || texture.mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = ggxMaterial.uniforms;
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        ggxUniforms['envMap'].value = cubeUVRenderTarget.texture;
        ggxUniforms['roughness'].value = adjustedRoughness;
        ggxUniforms['mipInt'].value = _lodMax - lodIn; // Sample from input LOD
        $d5b33d7c30034067$var$_setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $d5b33d7c30034067$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        ggxUniforms['envMap'].value = pingPongRenderTarget.texture;
        ggxUniforms['roughness'].value = 0.0; // Direct copy
        ggxUniforms['mipInt'].value = _lodMax - lodOut; // Read from the level we just wrote
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(planes, null));
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getGGXShader(lodMax, width, height) {
    const shaderMaterial = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
        name: 'PMREMGGXConvolution',
        defines: {
            'GGX_SAMPLES': $d5b33d7c30034067$var$GGX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'roughness': {
                value: 0.0
            },
            'mipInt': {
                value: 0
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 4.1: Orthonormal basis
				vec3 T1 = vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(V, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + V.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0);
    const shaderMaterial = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $d5b33d7c30034067$export$ac386671d651941e extends (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f) {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new (0, $9ddd7e9b53f7a2d4$export$33e43285f7406bd5)(5, 5, 5);
        const material = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
            name: 'CubemapFromEquirect',
            uniforms: (0, $9ddd7e9b53f7a2d4$export$acda854380553452)(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
            blending: (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)) texture.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        const camera = new (0, $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de)(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
function $d5b33d7c30034067$var$WebGLEnvironments(renderer) {
    let cubeMaps = new WeakMap();
    let pmremMaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture, usePMREM = false) {
        if (texture === null || texture === undefined) return null;
        if (usePMREM) return getPMREM(texture);
        return getCube(texture);
    }
    function getCube(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087) || mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098)) {
                if (cubeMaps.has(texture)) {
                    const cubemap = cubeMaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubeMaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onCubemapDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function getPMREM(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087) || mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098);
            const isCubeMap = mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4) || mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = pmremMaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    pmremMaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            pmremMaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onPMREMDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087)) texture.mapping = (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4);
        else if (mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098)) texture.mapping = (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onCubemapDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onCubemapDispose);
        const cubemap = cubeMaps.get(texture);
        if (cubemap !== undefined) {
            cubeMaps.delete(texture);
            cubemap.dispose();
        }
    }
    function onPMREMDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onPMREMDispose);
        const pmrem = pmremMaps.get(texture);
        if (pmrem !== undefined) {
            pmremMaps.delete(texture);
            pmrem.dispose();
        }
    }
    function dispose() {
        cubeMaps = new WeakMap();
        pmremMaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        const extension = gl.getExtension(name);
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryPosition === undefined) return;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        // check whether a 32 bit or 16 bit buffer is required to store the indices
        // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
        const attribute = new (geometryPosition.count >= 65535 ? (0, $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6) : (0, $9ddd7e9b53f7a2d4$export$640a853f68025f2e))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, bindingStates, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        bindingStates.releaseStatesOfObject(instancedMesh);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
const $d5b33d7c30034067$var$toneMappingMap = {
    [(0, $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca)]: 'LINEAR_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548)]: 'REINHARD_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$932b3dd283d4a366)]: 'CINEON_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64)]: 'ACES_FILMIC_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$212d53a513a325b2)]: 'AGX_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$f2863e1668a8e317)]: 'NEUTRAL_TONE_MAPPING',
    [(0, $9ddd7e9b53f7a2d4$export$2c7b09c1e9abfb5e)]: 'CUSTOM_TONE_MAPPING'
};
function $d5b33d7c30034067$var$WebGLOutput(type, width, height, depth, stencil) {
    // render targets for scene and post-processing
    const targetA = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(width, height, {
        type: type,
        depthBuffer: depth,
        stencilBuffer: stencil,
        depthTexture: depth ? new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(width, height) : undefined
    });
    const targetB = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(width, height, {
        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
        depthBuffer: false,
        stencilBuffer: false
    });
    // create fullscreen triangle geometry
    const geometry = new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)();
    geometry.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3));
    geometry.setAttribute('uv', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    // create output material with tone mapping support
    const material = new (0, $9ddd7e9b53f7a2d4$export$21c421a2e1df9d22)({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: /* glsl */ `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
        fragmentShader: /* glsl */ `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
        depthTest: false,
        depthWrite: false
    });
    const mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(geometry, material);
    const camera = new (0, $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
    let _outputColorSpace = null;
    let _outputToneMapping = null;
    let _isCompositing = false;
    let _savedToneMapping;
    let _savedRenderTarget = null;
    let _effects = [];
    let _hasRenderPass = false;
    this.setSize = function(width, height) {
        targetA.setSize(width, height);
        targetB.setSize(width, height);
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.setEffects = function(effects) {
        _effects = effects;
        _hasRenderPass = _effects.length > 0 && _effects[0].isRenderPass === true;
        const width = targetA.width;
        const height = targetA.height;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.begin = function(renderer, renderTarget) {
        // Don't begin during compositing phase (post-processing effects call render())
        if (_isCompositing) return false;
        if (renderer.toneMapping === (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2) && _effects.length === 0) return false;
        _savedRenderTarget = renderTarget;
        // resize internal buffers to match render target (e.g. XR resolution)
        if (renderTarget !== null) {
            const width = renderTarget.width;
            const height = renderTarget.height;
            if (targetA.width !== width || targetA.height !== height) this.setSize(width, height);
        }
        // if first effect is a RenderPass, it will set its own render target
        if (_hasRenderPass === false) renderer.setRenderTarget(targetA);
        // disable tone mapping during render - it will be applied in end()
        _savedToneMapping = renderer.toneMapping;
        renderer.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        return true;
    };
    this.hasRenderPass = function() {
        return _hasRenderPass;
    };
    this.end = function(renderer, deltaTime) {
        // restore tone mapping
        renderer.toneMapping = _savedToneMapping;
        _isCompositing = true;
        // run post-processing effects
        let readBuffer = targetA;
        let writeBuffer = targetB;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.enabled === false) continue;
            effect.render(renderer, writeBuffer, readBuffer, deltaTime);
            if (effect.needsSwap !== false) {
                const temp = readBuffer;
                readBuffer = writeBuffer;
                writeBuffer = temp;
            }
        }
        // update output material defines if settings changed
        if (_outputColorSpace !== renderer.outputColorSpace || _outputToneMapping !== renderer.toneMapping) {
            _outputColorSpace = renderer.outputColorSpace;
            _outputToneMapping = renderer.toneMapping;
            material.defines = {};
            if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(_outputColorSpace) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) material.defines.SRGB_TRANSFER = '';
            const toneMapping = $d5b33d7c30034067$var$toneMappingMap[_outputToneMapping];
            if (toneMapping) material.defines[toneMapping] = '';
            material.needsUpdate = true;
        }
        // final output to canvas (or XR render target)
        material.uniforms.tDiffuse.value = readBuffer.texture;
        renderer.setRenderTarget(_savedRenderTarget);
        renderer.render(mesh, camera);
        _savedRenderTarget = null;
        _isCompositing = false;
    };
    this.isCompositing = function() {
        return _isCompositing;
    };
    this.dispose = function() {
        if (targetA.depthTexture) targetA.depthTexture.dispose();
        targetA.dispose();
        targetB.dispose();
        geometry.dispose();
        material.dispose();
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a)();
const $d5b33d7c30034067$var$emptyShadowTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(1, 1);
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3)();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$d7a3086320f856db)();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $d5b33d7c30034067$var$emptyShadowTexture.compareFunction = textures.isReversedDepthBuffer() ? (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61) : (0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1);
        emptyTexture2D = $d5b33d7c30034067$var$emptyShadowTexture;
    } else emptyTexture2D = $d5b33d7c30034067$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) emptyTexture2D = $d5b33d7c30034067$var$emptyShadowTexture;
    else emptyTexture2D = $d5b33d7c30034067$var$emptyTexture;
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || emptyTexture2D, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
        // Sort uniforms to prioritize shadow samplers first (for optimal texture unit allocation)
        const shadowSamplers = [];
        const otherUniforms = [];
        for (const u of this.seq)if (u.type === gl.SAMPLER_2D_SHADOW || u.type === gl.SAMPLER_CUBE_SHADOW || u.type === gl.SAMPLER_2D_ARRAY_SHADOW) shadowSamplers.push(u);
        else otherUniforms.push(u);
        if (shadowSamplers.length > 0) this.seq = shadowSamplers.concat(otherUniforms);
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $d5b33d7c30034067$var$COMPLETION_STATUS_KHR = 0x91B1;
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $d5b33d7c30034067$var$_m0 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)();
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace) {
    (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c)._getMatrix($d5b33d7c30034067$var$_m0, (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$d5b33d7c30034067$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace)){
        case 0, $9ddd7e9b53f7a2d4$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
    const errors = shaderInfoLog.trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
const $d5b33d7c30034067$var$toneMappingFunctions = {
    [(0, $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca)]: 'Linear',
    [(0, $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548)]: 'Reinhard',
    [(0, $9ddd7e9b53f7a2d4$export$932b3dd283d4a366)]: 'Cineon',
    [(0, $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64)]: 'ACESFilmic',
    [(0, $9ddd7e9b53f7a2d4$export$212d53a513a325b2)]: 'AgX',
    [(0, $9ddd7e9b53f7a2d4$export$f2863e1668a8e317)]: 'Neutral',
    [(0, $9ddd7e9b53f7a2d4$export$2c7b09c1e9abfb5e)]: 'Custom'
};
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    const toneMappingName = $d5b33d7c30034067$var$toneMappingFunctions[toneMapping];
    if (toneMappingName === undefined) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLProgram: Unsupported toneMapping:', toneMapping);
        return 'vec3 ' + functionName + '( vec3 color ) { return LinearToneMapping( color ); }';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
function $d5b33d7c30034067$var$getLuminanceFunction() {
    (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getLuminanceCoefficients($d5b33d7c30034067$var$_v0);
    const r = $d5b33d7c30034067$var$_v0.x.toFixed(4);
    const g = $d5b33d7c30034067$var$_v0.y.toFixed(4);
    const b = $d5b33d7c30034067$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $d5b33d7c30034067$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // log( 'WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map();
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
const $d5b33d7c30034067$var$shadowMapTypeDefines = {
    [(0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88)]: 'SHADOWMAP_TYPE_PCF',
    [(0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)]: 'SHADOWMAP_TYPE_VSM'
};
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    return $d5b33d7c30034067$var$shadowMapTypeDefines[parameters.shadowMapType] || 'SHADOWMAP_TYPE_BASIC';
}
const $d5b33d7c30034067$var$envMapTypeDefines = {
    [(0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4)]: 'ENVMAP_TYPE_CUBE',
    [(0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d)]: 'ENVMAP_TYPE_CUBE',
    [(0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79)]: 'ENVMAP_TYPE_CUBE_UV'
};
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_TYPE_CUBE';
    return $d5b33d7c30034067$var$envMapTypeDefines[parameters.envMapMode] || 'ENVMAP_TYPE_CUBE';
}
const $d5b33d7c30034067$var$envMapModeDefines = {
    [(0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d)]: 'ENVMAP_MODE_REFRACTION'
};
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_MODE_REFLECTION';
    return $d5b33d7c30034067$var$envMapModeDefines[parameters.envMapMode] || 'ENVMAP_MODE_REFLECTION';
}
const $d5b33d7c30034067$var$envMapBlendingDefines = {
    [(0, $9ddd7e9b53f7a2d4$export$e50ac29801f1774d)]: 'ENVMAP_BLENDING_MULTIPLY',
    [(0, $9ddd7e9b53f7a2d4$export$9f9d94f963c85479)]: 'ENVMAP_BLENDING_MIX',
    [(0, $9ddd7e9b53f7a2d4$export$e641dc52bc3494aa)]: 'ENVMAP_BLENDING_ADD'
};
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_BLENDING_NONE';
    return $d5b33d7c30034067$var$envMapBlendingDefines[parameters.combine] || 'ENVMAP_BLENDING_NONE';
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $d5b33d7c30034067$var$generateVertexExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexNormals ? '#define HAS_NORMAL' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.packedNormalMap ? '#define USE_PACKED_NORMALMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas || parameters.batchingColor ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.numLightProbeGrids > 0 ? '#define USE_LIGHT_PROBES_GRID' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2) ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2) ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $d5b33d7c30034067$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $9ddd7e9b53f7a2d4$export$f63012db5506e7dd) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $9ddd7e9b53f7a2d4$export$f63012db5506e7dd) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // log( '*VERTEX*', vertexGlsl );
    // log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programInfoLog = gl.getProgramInfoLog(program) || '';
            const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || '';
            const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || '';
            const programLog = programInfoLog.trim();
            const vertexLog = vertexShaderInfoLog.trim();
            const fragmentLog = fragmentShaderInfoLog.trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $d5b33d7c30034067$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$isPackedRGFormat(format) {
    return format === (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0) || format === (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf) || format === (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f);
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, environments, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $9ddd7e9b53f7a2d4$export$89312ce47c0ca777)();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const programsMap = new Map();
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distance',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object, lightProbeGrids) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
        const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
        const envMap = environments.get(material.envMap || environment, usePMREM);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace,
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $9ddd7e9b53f7a2d4$export$9990ad26f9db5b2c),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8),
            packedNormalMap: HAS_NORMALMAP && material.normalMapType === (0, $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8) && $d5b33d7c30034067$var$isPackedRGFormat(material.normalMap.format),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexNormals: !!geometry.attributes.normal,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.wireframe === false && (material.flatShading === true || geometry.attributes.normal === undefined && HAS_NORMALMAP === false && (material.isMeshLambertMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isMeshPhysicalMaterial)),
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reversedDepthBuffer: reversedDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numLightProbeGrids: lightProbeGrids.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(material.map.colorSpace) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(material.emissiveMap.colorSpace) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03),
            flipSided: material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.instancing) _programLayers.enable(0);
        if (parameters.instancingColor) _programLayers.enable(1);
        if (parameters.instancingMorph) _programLayers.enable(2);
        if (parameters.matcap) _programLayers.enable(3);
        if (parameters.envMap) _programLayers.enable(4);
        if (parameters.normalMapObjectSpace) _programLayers.enable(5);
        if (parameters.normalMapTangentSpace) _programLayers.enable(6);
        if (parameters.clearcoat) _programLayers.enable(7);
        if (parameters.iridescence) _programLayers.enable(8);
        if (parameters.alphaTest) _programLayers.enable(9);
        if (parameters.vertexColors) _programLayers.enable(10);
        if (parameters.vertexAlphas) _programLayers.enable(11);
        if (parameters.vertexUv1s) _programLayers.enable(12);
        if (parameters.vertexUv2s) _programLayers.enable(13);
        if (parameters.vertexUv3s) _programLayers.enable(14);
        if (parameters.vertexTangents) _programLayers.enable(15);
        if (parameters.anisotropy) _programLayers.enable(16);
        if (parameters.alphaHash) _programLayers.enable(17);
        if (parameters.batching) _programLayers.enable(18);
        if (parameters.dispersion) _programLayers.enable(19);
        if (parameters.batchingColor) _programLayers.enable(20);
        if (parameters.gradientMap) _programLayers.enable(21);
        if (parameters.packedNormalMap) _programLayers.enable(22);
        if (parameters.vertexNormals) _programLayers.enable(23);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reversedDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        if (parameters.numLightProbeGrids > 0) _programLayers.enable(22);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $9ddd7e9b53f7a2d4$export$d8ecdf8615bfea69).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program = programsMap.get(cacheKey);
        if (program !== undefined) ++program.usedTimes;
        else {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
            programsMap.set(cacheKey, program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Remove from map
            programsMap.delete(program.cacheKey);
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.materialVariant !== b.materialVariant) return a.materialVariant - b.materialVariant;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function materialVariant(object) {
        let variant = 0;
        if (object.isInstancedMesh) variant += 2;
        if (object.isSkinnedMesh) variant += 1;
        return variant;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                materialVariant: materialVariant(object),
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.materialVariant = materialVariant(object);
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        color: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        direction: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        color: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        color: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        skyColor: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(),
                        groundColor: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(),
                        position: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        halfWidth: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(),
                        halfHeight: new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)());
    const vector3 = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
    const matrix4 = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
    const matrix42 = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            let shadowMap = null;
            if (light.shadow && light.shadow.map) {
                if (light.shadow.map.texture.format === (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0)) // VSM uses color texture with blurred mean/std_dev
                shadowMap = light.shadow.map.texture;
                else // Other types use depth texture
                shadowMap = light.shadow.map.depthTexture || light.shadow.map.texture;
            }
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    const lightProbeGridArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
        lightProbeGridArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function pushLightProbeGrid(volume) {
        lightProbeGridArray.push(volume);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lightProbeGridArray: lightProbeGridArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {},
        textureUnits: 0
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow,
        pushLightProbeGrid: pushLightProbeGrid
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}";
const $d5b33d7c30034067$var$_cubeDirections = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(-1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1)
];
const $d5b33d7c30034067$var$_cubeUps = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0)
];
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
function $d5b33d7c30034067$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2)();
    const _shadowMapSize = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(), _viewportSize = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(), _viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(), _depthMaterial = new (0, $9ddd7e9b53f7a2d4$export$2698c22ec13825db)(), _distanceMaterial = new (0, $9ddd7e9b53f7a2d4$export$33e187ed002f2a19)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901)]: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
        [(0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)]: (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901),
        [(0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03)]: (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03)
    };
    const shadowMaterialVertical = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)();
    fullScreenTri.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        if (this.type === (0, $9ddd7e9b53f7a2d4$export$a47c4b43a1be34f0)) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead.');
            this.type = (0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba));
        if (_state.buffers.depth.getReversed() === true) _state.buffers.color.setClear(0, 0, 0, 0);
        else _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const typeChanged = _previousType !== this.type;
        // When shadow map type changes, materials need recompilation because sampler types change
        // (sampler2DShadow for PCF vs sampler2D for Basic)
        if (typeChanged) scene.traverse(function(object) {
            if (object.material) {
                if (Array.isArray(object.material)) object.material.forEach((mat)=>mat.needsUpdate = true);
                else object.material.needsUpdate = true;
            }
        });
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
            shadow.camera._reversedDepth = reversedDepthBuffer;
            if (shadow.map === null || typeChanged === true) {
                if (shadow.map !== null) {
                    if (shadow.map.depthTexture !== null) {
                        shadow.map.depthTexture.dispose();
                        shadow.map.depthTexture = null;
                    }
                    shadow.map.dispose();
                }
                if (this.type === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) {
                    if (light.isPointLight) {
                        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.');
                        continue;
                    }
                    shadow.map = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, {
                        format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
                        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                        minFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
                        magFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
                        generateMipmaps: false
                    });
                    shadow.map.texture.name = light.name + '.shadowMap';
                    // Native depth texture for VSM - depth is captured here, then blurred into the color texture
                    shadow.map.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(_shadowMapSize.x, _shadowMapSize.y, (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596));
                    shadow.map.depthTexture.name = light.name + '.shadowMapDepth';
                    shadow.map.depthTexture.format = (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
                    shadow.map.depthTexture.compareFunction = null; // For regular sampling (not shadow comparison)
                    shadow.map.depthTexture.minFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
                    shadow.map.depthTexture.magFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
                } else {
                    if (light.isPointLight) {
                        shadow.map = new $d5b33d7c30034067$export$ac386671d651941e(_shadowMapSize.x);
                        shadow.map.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$c9f39eef7fb1d170)(_shadowMapSize.x, (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96));
                    } else {
                        shadow.map = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y);
                        shadow.map.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(_shadowMapSize.x, _shadowMapSize.y, (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96));
                    }
                    shadow.map.depthTexture.name = light.name + '.shadowMap';
                    shadow.map.depthTexture.format = (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
                    if (this.type === (0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88)) {
                        shadow.map.depthTexture.compareFunction = reversedDepthBuffer ? (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61) : (0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1);
                        shadow.map.depthTexture.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
                        shadow.map.depthTexture.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
                    } else {
                        shadow.map.depthTexture.compareFunction = null;
                        shadow.map.depthTexture.minFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
                        shadow.map.depthTexture.magFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
                    }
                }
                shadow.camera.updateProjectionMatrix();
            }
            // For cube render targets (PointLights), render all 6 faces. Otherwise, render once.
            const faceCount = shadow.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let face = 0; face < faceCount; face++){
                // For cube render targets, render to each face separately
                if (shadow.map.isWebGLCubeRenderTarget) {
                    renderer.setRenderTarget(shadow.map, face);
                    renderer.clear();
                } else {
                    // For 2D render targets, use viewports
                    if (face === 0) {
                        renderer.setRenderTarget(shadow.map);
                        renderer.clear();
                    }
                    const viewport = shadow.getViewport(face);
                    _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                    _state.viewport(_viewport);
                }
                if (light.isPointLight) {
                    const camera = shadow.camera;
                    const shadowMatrix = shadow.matrix;
                    const far = light.distance || camera.far;
                    if (far !== camera.far) {
                        camera.far = far;
                        camera.updateProjectionMatrix();
                    }
                    $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                    camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
                    $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
                    $d5b33d7c30034067$var$_lookTarget.add($d5b33d7c30034067$var$_cubeDirections[face]);
                    camera.up.copy($d5b33d7c30034067$var$_cubeUps[face]);
                    camera.lookAt($d5b33d7c30034067$var$_lookTarget);
                    camera.updateMatrixWorld();
                    shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
                    $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    shadow._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
                } else shadow.updateMatrices(light);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, {
            format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
            type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)
        });
        // vertical pass - read from native depth texture
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.depthTexture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
function $d5b33d7c30034067$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        let currentColorMask = null;
        const currentColorClear = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = (0, $9ddd7e9b53f7a2d4$export$611f4ad2374e11ff)[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $9ddd7e9b53f7a2d4$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $9ddd7e9b53f7a2d4$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    currentDepthClear = depth;
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let parameters = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)().fromArray(scissorParam);
    const currentViewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $9ddd7e9b53f7a2d4$export$296f78a0b892f81a));
    setFlipSided(false);
    setCullFace((0, $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b));
    enable(gl.CULL_FACE);
    setBlending((0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0)]: gl.FUNC_ADD,
        [(0, $9ddd7e9b53f7a2d4$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
        [(0, $9ddd7e9b53f7a2d4$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $9ddd7e9b53f7a2d4$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[0, $9ddd7e9b53f7a2d4$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [(0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d)]: gl.ZERO,
        [(0, $9ddd7e9b53f7a2d4$export$8805bad65e24940e)]: gl.ONE,
        [(0, $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
        [(0, $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
        [(0, $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
        [(0, $9ddd7e9b53f7a2d4$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $9ddd7e9b53f7a2d4$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $9ddd7e9b53f7a2d4$export$7dd8f434fd59075)]: gl.CONSTANT_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$99c8d898a9afbcee)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $9ddd7e9b53f7a2d4$export$310cd2be38d13b56)]: gl.CONSTANT_ALPHA,
        [(0, $9ddd7e9b53f7a2d4$export$db77b8fbcf45dbf4)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0) || currentBlendEquationAlpha !== (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
                    currentBlendEquationAlpha = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) && material.transparent === false ? setBlending((0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $9ddd7e9b53f7a2d4$export$3237e1f2c1ea1f44)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $9ddd7e9b53f7a2d4$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
                if (depthBuffer.getReversed()) factor = -factor;
                gl.polygonOffset(factor, units);
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState:', e);
        }
    }
    function getParameter(name) {
        if (parameters[name] !== undefined) return parameters[name];
        else return gl.getParameter(name);
    }
    function pixelStorei(name, value) {
        if (parameters[name] !== value) {
            gl.pixelStorei(name, value);
            parameters[name] = value;
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        gl.pixelStorei(gl.PACK_ALIGNMENT, 4);
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.BROWSER_DEFAULT_WEBGL);
        gl.pixelStorei(gl.PACK_ROW_LENGTH, 0);
        gl.pixelStorei(gl.PACK_SKIP_PIXELS, 0);
        gl.pixelStorei(gl.PACK_SKIP_ROWS, 0);
        gl.pixelStorei(gl.UNPACK_ROW_LENGTH, 0);
        gl.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, 0);
        gl.pixelStorei(gl.UNPACK_SKIP_PIXELS, 0);
        gl.pixelStorei(gl.UNPACK_SKIP_ROWS, 0);
        gl.pixelStorei(gl.UNPACK_SKIP_IMAGES, 0);
        // reset internals
        enabledCapabilities = {};
        parameters = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        pixelStorei: pixelStorei,
        getParameter: getParameter,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
    const _videoTextures = new WeakMap();
    const _htmlTextures = new Set();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : (0, $9ddd7e9b53f7a2d4$export$7094a064528c7fee)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, normalized, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let ext_texture_norm16;
        if (normalized) {
            ext_texture_norm16 = extensions.get('EXT_texture_norm16');
            if (!ext_texture_norm16) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
            if (glType === _gl.UNSIGNED_SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.R16_EXT;
            if (glType === _gl.SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.R16_SNORM_EXT;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
            if (glType === _gl.UNSIGNED_SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RG16_EXT;
            if (glType === _gl.SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RG16_SNORM_EXT;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RGB16_EXT;
            if (glType === _gl.SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RGB16_SNORM_EXT;
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
            if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $9ddd7e9b53f7a2d4$export$f197347d588c1b4a) : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RGBA16_EXT;
            if (glType === _gl.SHORT && ext_texture_norm16) internalFormat = ext_texture_norm16.RGBA16_SNORM_EXT;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96) || depthType === (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96) || depthType === (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0) && texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        if (texture.isHTMLTexture) _htmlTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function getTextureUnits() {
        return textureUnits;
    }
    function setTextureUnits(value) {
        textureUnits = value;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isCubeDepthTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5)]: _gl.REPEAT,
        [(0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06)]: _gl.CLAMP_TO_EDGE,
        [(0, $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0)]: _gl.NEAREST,
        [(0, $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8)]: _gl.LINEAR,
        [(0, $9ddd7e9b53f7a2d4$export$19a719f377145a13)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab)]: _gl.NEVER,
        [(0, $9ddd7e9b53f7a2d4$export$187b73a3e352c145)]: _gl.ALWAYS,
        [(0, $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7)]: _gl.LESS,
        [(0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1)]: _gl.LEQUAL,
        [(0, $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5)]: _gl.EQUAL,
        [(0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61)]: _gl.GEQUAL,
        [(0, $9ddd7e9b53f7a2d4$export$155af022118f3a38)]: _gl.GREATER,
        [(0, $9ddd7e9b53f7a2d4$export$67ab95dde6bed156)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$19a719f377145a13) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$19a719f377145a13) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b))) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = state.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = state.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = state.getParameter(_gl.UNPACK_SKIP_ROWS);
            state.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                state.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                state.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            state.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            state.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            state.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const isImageBitmap = typeof ImageBitmap !== 'undefined' && texture.image instanceof ImageBitmap;
            if (isImageBitmap === false) {
                const workingPrimaries = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace);
                const texturePrimaries = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) ? null : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
                const unpackConversion = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
                state.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
                state.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
                state.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            }
            state.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else if (texture.isHTMLTexture) {
                if ('texElementImage2D' in _gl) {
                    const canvas = _gl.canvas;
                    // Ensure the canvas supports HTML-in-Canvas and the element is a child.
                    if (!canvas.hasAttribute('layoutsubtree')) canvas.setAttribute('layoutsubtree', 'true');
                    if (image.parentNode !== canvas) {
                        canvas.appendChild(image);
                        // Register and set up a shared paint callback for all HTMLTextures.
                        _htmlTextures.add(texture);
                        canvas.onpaint = (event)=>{
                            const changed = event.changedElements;
                            for (const t of _htmlTextures)if (changed.includes(t.image)) t.needsUpdate = true;
                        };
                        canvas.requestPaint();
                        return;
                    }
                    const level = 0;
                    const internalFormat = _gl.RGBA;
                    const srcFormat = _gl.RGBA;
                    const srcType = _gl.UNSIGNED_BYTE;
                    _gl.texElementImage2D(_gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
                    _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_MIN_FILTER, _gl.LINEAR);
                    _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
                    _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) ? null : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            state.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            state.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            state.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            state.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, useMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget, cubeFace) {
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        if (isCube) {
            // For cube depth textures, initialize and bind without uploading image data
            if (textureProperties.__webglInit === undefined) {
                textureProperties.__webglInit = true;
                renderTarget.depthTexture.addEventListener('dispose', onTextureDispose);
            }
            // Only create and allocate storage once
            if (textureProperties.__webglTexture === undefined) {
                textureProperties.__webglTexture = _gl.createTexture();
                state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_CUBE_MAP, renderTarget.depthTexture);
                // Allocate storage for all 6 faces with correct depth texture format
                const glFormat = utils.convert(renderTarget.depthTexture.format);
                const glType = utils.convert(renderTarget.depthTexture.type);
                // Use proper internal format for depth textures
                let glInternalFormat;
                if (renderTarget.depthTexture.format === (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)) glInternalFormat = _gl.DEPTH_COMPONENT24;
                else if (renderTarget.depthTexture.format === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829)) glInternalFormat = _gl.DEPTH24_STENCIL8;
                for(let i = 0; i < 6; i++)_gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
            }
        } else setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        const glTextureType = isCube ? _gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace : _gl.TEXTURE_2D;
        const glAttachmentType = renderTarget.depthTexture.format === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        if (renderTarget.depthTexture.format === (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) // For cube render targets with depth texture, setup each face
            for(let i = 0; i < 6; i++)setupDepthTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, i);
            else {
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget, 0);
                else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 0);
            }
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                let glTextureType = _gl.TEXTURE_2D;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
                setTextureParameters(glTextureType, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(glTextureType);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $9ddd7e9b53f7a2d4$export$42429b3acfb233a4) && colorSpace !== (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51)) {
            // sRGB
            if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c) || type !== (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.getTextureUnits = getTextureUnits;
    this.setTextureUnits = setTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
    this.isReversedDepthBuffer = function() {
        return state.buffers.depth.getReversed();
    };
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51)) {
        let extension;
        const transfer = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $9ddd7e9b53f7a2d4$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $9ddd7e9b53f7a2d4$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $9ddd7e9b53f7a2d4$export$f240f067f72abe41)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $9ddd7e9b53f7a2d4$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0) || p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668) || p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c) || p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) {
            if (transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573) || p === (0, $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4) || p === (0, $9ddd7e9b53f7a2d4$export$b82296714358084c) || p === (0, $9ddd7e9b53f7a2d4$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7) || p === (0, $9ddd7e9b53f7a2d4$export$7800993ef8106a6a) || p === (0, $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8) || p === (0, $9ddd7e9b53f7a2d4$export$d5c566817123b2bf) || p === (0, $9ddd7e9b53f7a2d4$export$f5668dc623297d86) || p === (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf) || p === (0, $9ddd7e9b53f7a2d4$export$211402338cb75433)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7) || p === (0, $9ddd7e9b53f7a2d4$export$7800993ef8106a6a)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d5c566817123b2bf)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$f5668dc623297d86)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$211402338cb75433)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48) || p === (0, $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb) || p === (0, $9ddd7e9b53f7a2d4$export$7d2c0be323373d95) || p === (0, $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e) || p === (0, $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e) || p === (0, $9ddd7e9b53f7a2d4$export$118fff5afa255b63) || p === (0, $9ddd7e9b53f7a2d4$export$120713c829ae0667) || p === (0, $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9) || p === (0, $9ddd7e9b53f7a2d4$export$443cf6567cdd6424) || p === (0, $9ddd7e9b53f7a2d4$export$6573984fc9840780) || p === (0, $9ddd7e9b53f7a2d4$export$e7aee563f30091de) || p === (0, $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7) || p === (0, $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742) || p === (0, $9ddd7e9b53f7a2d4$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$7d2c0be323373d95)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$118fff5afa255b63)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$120713c829ae0667)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$443cf6567cdd6424)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$6573984fc9840780)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$e7aee563f30091de)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$18ab77abd087e467)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$ce40b115e188bc81) || p === (0, $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e) || p === (0, $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$ce40b115e188bc81)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d279c5c4bac5121e)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$cde52d17225fdbd3)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$b1688df4c4c21670) || p === (0, $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58) || p === (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f) || p === (0, $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$b1688df4c4c21670)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $d5b33d7c30034067$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $d5b33d7c30034067$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $d5b33d7c30034067$var$WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * An opaque texture representing the depth of the user's environment.
		 *
		 * @type {?ExternalTexture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $9ddd7e9b53f7a2d4$export$cd10147cacf16ab2)(depthData.texture);
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
                    vertexShader: $d5b33d7c30034067$var$_occlusion_vertex,
                    fragmentShader: $d5b33d7c30034067$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$967d831af31f69ce)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?ExternalTexture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $d5b33d7c30034067$var$WebXRManager extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        const depthSensing = new $d5b33d7c30034067$var$WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
        cameraL.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        const cameraR = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
        cameraR.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $9ddd7e9b53f7a2d4$export$56b937d9e5581166)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            for(const key in cameraAccessTextures)delete cameraAccessTextures[key];
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * This is an `XRProjectionLayer` when the targeted XR device supports the
		 * WebXR Layers API, or an `XRWebGLLayer` otherwise.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * Creates a new binding if needed and the browser is
		 * capable of doing so.
		 *
		 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
		 */ this.getBinding = function() {
            if (glBinding === null && supportsGlBinding) glBinding = new XRWebGLBinding(session, gl);
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const supportsLayers = supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!supportsLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
                        type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
                        depthType = attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = this.getBinding();
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
                        type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                        depthTexture: new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * See {@link WebXRDepthSensing#getDepthTexture}.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        const cameraRPos = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set `cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            // inherit camera layers and enable eye layers (1 = left, 2 = right)
            cameraXR.layers.mask = camera.layers.mask | 6;
            cameraL.layers.mask = cameraXR.layers.mask & -5;
            cameraR.layers.mask = cameraXR.layers.mask & -3;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $9ddd7e9b53f7a2d4$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number|undefined} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * See {@link WebXRDepthSensing#getMesh}.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        /**
		 * Retrieves an opaque texture from the view-aligned {@link XRCamera}.
		 * Only available during the current animation loop.
		 *
		 * @param {XRCamera} xrCamera - The camera to query.
		 * @return {?Texture} An opaque texture representing the current raw camera frame.
		 */ this.getCameraTexture = function(xrCamera) {
            return cameraAccessTextures[xrCamera];
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && supportsGlBinding) {
                    glBinding = scope.getBinding();
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(depthData, session.renderState);
                }
                const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes('camera-access');
                if (cameraAccessEnabled && supportsGlBinding) {
                    renderer.state.unbindTexture();
                    glBinding = scope.getBinding();
                    for(let i = 0; i < views.length; i++){
                        const camera = views[i].camera;
                        if (camera) {
                            let cameraTex = cameraAccessTextures[camera];
                            if (!cameraTex) {
                                cameraTex = new (0, $9ddd7e9b53f7a2d4$export$cd10147cacf16ab2)();
                                cameraAccessTextures[camera] = cameraTex;
                            }
                            const glTexture = glBinding.getCameraImage(camera);
                            cameraTex.sourceTexture = glTexture;
                        }
                    }
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $d5b33d7c30034067$var$_m = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)();
$d5b33d7c30034067$var$_m.set(-1, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0);
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $9ddd7e9b53f7a2d4$export$a630742c640528c1)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isNodeMaterial) material.uniformsNeedUpdate = false;
        else if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.envMap) uniforms.envMapIntensity.value = material.envMapIntensity;
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
            if (material.envMap) uniforms.envMapIntensity.value = material.envMapIntensity;
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            // note: since the matrix is orthonormal, we can use the more-efficient transpose() in lieu of invert()
            uniforms.envMapRotation.value.setFromMatrix4($d5b33d7c30034067$var$_m1.makeRotationFromEuler(envMapRotation)).transpose();
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) uniforms.envMapRotation.value.premultiply($d5b33d7c30034067$var$_m);
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else if (ArrayBuffer.isView(value)) // copy the buffer data using "set"
                        uniform.__data.set(new value.constructor(value.buffer, value.byteOffset, uniform.__data.length));
                        else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else if (ArrayBuffer.isView(value)) cache[indexString] = value.slice();
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (ArrayBuffer.isView(value)) // always update the array buffers
            return true;
            else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else if (ArrayBuffer.isView(value)) {
            info.boundary = 16;
            info.storage = value.byteLength;
        } else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $d5b33d7c30034067$var$DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let $d5b33d7c30034067$var$lut = null;
function $d5b33d7c30034067$var$getDFGLUT() {
    if ($d5b33d7c30034067$var$lut === null) {
        $d5b33d7c30034067$var$lut = new (0, $9ddd7e9b53f7a2d4$export$b691f601014eabe1)($d5b33d7c30034067$var$DATA, 16, 16, (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0), (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc));
        $d5b33d7c30034067$var$lut.name = 'DFG_LUT';
        $d5b33d7c30034067$var$lut.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        $d5b33d7c30034067$var$lut.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        $d5b33d7c30034067$var$lut.wrapS = (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
        $d5b33d7c30034067$var$lut.wrapT = (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
        $d5b33d7c30034067$var$lut.generateMipmaps = false;
        $d5b33d7c30034067$var$lut.needsUpdate = true;
    }
    return $d5b33d7c30034067$var$lut;
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $9ddd7e9b53f7a2d4$export$1033a2df66368859)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reversedDepthBuffer: reversedDepthBuffer = false, outputBufferType: outputBufferType = (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10) } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const _outputBufferType = outputBufferType;
        const INTEGER_FORMATS = new Set([
            (0, $9ddd7e9b53f7a2d4$export$c200e7d26f592f21),
            (0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7),
            (0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190)
        ]);
        const UNSIGNED_TYPES = new Set([
            (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
            (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96),
            (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d),
            (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301),
            (0, $9ddd7e9b53f7a2d4$export$b3969b01faf587f2),
            (0, $9ddd7e9b53f7a2d4$export$18886f8ae33e90de)
        ]);
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        const objectPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // internal render target for non-UnsignedByteType color buffer
        let output = null;
        // public properties
        /**
		 * A canvas where the renderer draws its output. This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link, it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        let _nodesHandler = null;
        // internal state cache
        this._outputColorSpace = (0, $9ddd7e9b53f7a2d4$export$561f394b24edfcaa);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        const _currentScissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        const _scissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
        const _vector3 = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        const _vector4 = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $9ddd7e9b53f7a2d4$export$3545e07a80636437)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer: ' + e.message);
            throw e;
        }
        let extensions, capabilities, state, info;
        let properties, textures, environments, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions);
            if (capabilities.reversedDepthBuffer && reversedDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            environments = new $d5b33d7c30034067$var$WebGLEnvironments(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, attributes);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, bindingStates, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, environments, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, environments, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // initialize internal render target for non-UnsignedByteType color buffer
        if (_outputBufferType !== (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) output = new $d5b33d7c30034067$var$WebGLOutput(_outputBufferType, canvas.width, canvas.height, depth, stencil);
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            if (output !== null) output.setSize(canvas.width, canvas.height);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Sets the post-processing effects to be applied after rendering.
		 *
		 * @param {Array} effects - An array of post-processing effects.
		 */ this.setEffects = function(effects) {
            if (_outputBufferType === (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.');
                return;
            }
            if (effects) {
                for(let i = 0; i < effects.length; i++)if (effects[i].isOutputPass === true) {
                    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.');
                    break;
                }
            }
            output.setEffects(effects || []);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = INTEGER_FORMATS.has(targetFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = UNSIGNED_TYPES.has(targetType);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) {
                bits |= _gl.DEPTH_BUFFER_BIT;
                this.state.buffers.depth.setMask(true);
            }
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            if (bits !== 0) _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Sets a compatibility node builder for rendering node materials with WebGLRenderer.
		 * This enables using TSL (Three.js Shading Language) node materials to prepare
		 * for migration to WebGPURenderer.
		 *
		 * @param {WebGLNodesHandler} nodesHandler - The node builder instance.
		 */ this.setNodesHandler = function(nodesHandler) {
            nodesHandler.setRenderer(this);
            _nodesHandler = nodesHandler;
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            environments.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            (0, $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3)('WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            (0, $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3)('WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        /**
		 * Applications are advised to always define the animation loop
		 * with this method and not manually with `requestAnimationFrame()`
		 * for best compatibility.
		 *
		 * @param {?onAnimationCallback} callback - The application's animation loop.
		 */ this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update node builder if available
            if (_nodesHandler !== null) _nodesHandler.renderStart(scene, camera);
            // use internal render target for HalfFloatType color buffer (only when tone mapping is enabled)
            const isXRPresenting = xr.enabled === true && xr.isPresenting === true;
            const useOutput = output !== null && (_currentRenderTarget === null || isXRPresenting) && output.begin(_this, _currentRenderTarget);
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true && (output === null || output.isCompositing() === false)) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            currentRenderState.state.textureUnits = textures.getTextureUnits();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix, (0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3), camera.reversedDepth);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene (skip if first effect is a render pass - it will render the scene itself)
            const skipSceneRender = useOutput && output.hasRenderPass();
            if (skipSceneRender === false) {
                const opaqueObjects = currentRenderList.opaque;
                const transmissiveObjects = currentRenderList.transmissive;
                currentRenderState.setupLights();
                if (camera.isArrayCamera) {
                    const cameras = camera.cameras;
                    if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                    }
                    if (_renderBackground) background.render(scene);
                    for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderScene(currentRenderList, scene, camera2, camera2.viewport);
                    }
                } else {
                    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                    if (_renderBackground) background.render(scene);
                    renderScene(currentRenderList, scene, camera);
                }
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            // copy from internal render target to canvas using fullscreen quad
            if (useOutput) output.end(_this);
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                textures.setTextureUnits(currentRenderState.state.textureUnits);
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
            if (_nodesHandler !== null) _nodesHandler.renderEnd();
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLightProbeGrid) currentRenderState.pushLightProbeGrid(object);
                else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const { opaque: opaqueObjects, transmissive: transmissiveObjects, transparent: transparentObjects } = currentRenderList;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) {
                const hasHalfFloatSupport = extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float');
                currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(1, 1, {
                    generateMipmaps: true,
                    type: hasHalfFloatSupport ? (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc) : (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                    minFilter: (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b),
                    samples: Math.max(4, capabilities.samples),
                    stencilBuffer: stencil,
                    resolveDepthBuffer: false,
                    resolveStencilBuffer: false,
                    colorSpace: (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const { object: object, geometry: geometry, material: material, group: group } = renderItem;
                    if (material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const { object: object, geometry: geometry, group: group } = renderItem;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object, currentRenderState.state.lightProbeGridArray);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
            materialProperties.envMap = environments.get(material.envMap || materialProperties.environment, usePMREM);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                // Use node builder for node materials if available
                if (_nodesHandler !== null && material.isNodeMaterial) _nodesHandler.build(material, object, parameters);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.lightProbeGrid = currentRenderState.state.lightProbeGridArray.length > 0;
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function findLightProbeGrid(volumes, object) {
            if (volumes.length === 0) return null;
            if (volumes.length === 1) return volumes[0].texture !== null ? volumes[0] : null;
            objectPosition.setFromMatrixPosition(object.matrixWorld);
            for(let i = 0, l = volumes.length; i < l; i++){
                const v = volumes[i];
                if (v.texture !== null && v.boundingBox.containsPoint(objectPosition)) return v;
            }
            return null;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
            const usePMREM = material.isMeshStandardMaterial || material.isMeshLambertMaterial && !material.envMap || material.isMeshPhongMaterial && !material.envMap;
            const envMap = environments.get(material.envMap || environment, usePMREM);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
                else if (!!materialProperties.lightProbeGrid !== currentRenderState.state.lightProbeGridArray.length > 0) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) {
                program = getProgram(material, scene, object);
                // notify the node builder that the program has changed so uniforms and update nodes can
                // be cached and triggered.
                if (_nodesHandler && material.isNodeMaterial) _nodesHandler.onUpdateProgram(material, program, materialProperties);
            }
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (materialProperties.needsLights) {
                const objectVolume = findLightProbeGrid(currentRenderState.state.lightProbeGridArray, object);
                if (materialProperties.lightProbeGrid !== objectVolume) {
                    materialProperties.lightProbeGrid = objectVolume;
                    refreshMaterial = true;
                }
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reversedDepthBuffer = state.buffers.depth.getReversed();
                if (reversedDepthBuffer && camera.reversedDepth !== true) {
                    camera._reversedDepth = true;
                    camera.updateProjectionMatrix();
                }
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // Pre-allocate texture units for shadow samplers before setting data textures
            if (materialProperties.needsLights) {
                // Set shadow map uniforms first to ensure they get the first texture units
                if (lights.state.directionalShadowMap.length > 0) p_uniforms.setValue(_gl, 'directionalShadowMap', lights.state.directionalShadowMap, textures);
                if (lights.state.spotShadowMap.length > 0) p_uniforms.setValue(_gl, 'spotShadowMap', lights.state.spotShadowMap, textures);
                if (lights.state.pointShadowMap.length > 0) p_uniforms.setValue(_gl, 'pointShadowMap', lights.state.pointShadowMap, textures);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            if ((material.isMeshStandardMaterial || material.isMeshLambertMaterial || material.isMeshPhongMaterial) && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            // Set DFG LUT for physically-based materials
            if (m_uniforms.dfgLUT !== undefined) m_uniforms.dfgLUT.value = $d5b33d7c30034067$var$getDFGLUT();
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                // light probe volume
                if (materialProperties.needsLights && materialProperties.lightProbeGrid) {
                    const volume = materialProperties.lightProbeGrid;
                    m_uniforms.probesSH.value = volume.texture;
                    m_uniforms.probesMin.value.copy(volume.boundingBox.min);
                    m_uniforms.probesMax.value.copy(volume.boundingBox.max);
                    m_uniforms.probesResolution.value.copy(volume.resolution);
                }
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.uniformsGroups !== undefined) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // Externally-managed framebuffer (e.g. XR)
                    // Bind to the stored framebuffer (may be null for default, or a WebGLFramebuffer)
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _currentViewport.copy(renderTarget.viewport);
                    _currentScissor.copy(renderTarget.scissor);
                    _currentScissorTest = renderTarget.scissorTest;
                    state.viewport(_currentViewport);
                    state.scissor(_currentScissor);
                    state.setScissorTest(_currentScissorTest);
                    _currentMaterialId = -1;
                    return;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const layer = activeCubeFace;
                for(let i = 0; i < renderTarget.textures.length; i++){
                    const textureProperties = properties.get(renderTarget.textures[i]);
                    _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
                }
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $9ddd7e9b53f7a2d4$export$d43f91ebeafb2c7)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=0] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            state.activeTexture(_gl.TEXTURE0); // see #33153
            state.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            state.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            state.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = state.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = state.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = state.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = state.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = state.getParameter(_gl.UNPACK_SKIP_IMAGES);
            state.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            state.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            state.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            state.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            state.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            state.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            state.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            state.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            state.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            state.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c)._getUnpackColorSpace();
    }
}



const $40043d5ea0db3d61$var$_plane = new (0, $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0)();
const $40043d5ea0db3d61$var$_pointer = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_offset = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_diff = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_previousPointer = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $40043d5ea0db3d61$var$_intersection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_worldPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_inverseMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $40043d5ea0db3d61$var$_up = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $40043d5ea0db3d61$var$_right = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
let $40043d5ea0db3d61$var$_selected = null, $40043d5ea0db3d61$var$_hovered = null;
const $40043d5ea0db3d61$var$_intersections = [];
const $40043d5ea0db3d61$var$STATE = {
    NONE: -1,
    PAN: 0,
    ROTATE: 1
};
/**
 * This class can be used to provide a drag'n'drop interaction.
 *
 * ```js
 * const controls = new DragControls( objects, camera, renderer.domElement );
 *
 * // add event listener to highlight dragged objects
 * controls.addEventListener( 'dragstart', function ( event ) {
 *
 * 	event.object.material.emissive.set( 0xaaaaaa );
 *
 * } );
 *
 * controls.addEventListener( 'dragend', function ( event ) {
 *
 * 	event.object.material.emissive.set( 0x000000 );
 *
 * } );
 * ```
 *
 * @augments Controls
 * @three_import import { DragControls } from 'three/addons/controls/DragControls.js';
 */ class $40043d5ea0db3d61$export$350d0cf1f91b53f4 extends (0, $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f) {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Array<Object3D>} objects - An array of draggable 3D objects.
	 * @param {Camera} camera - The camera of the rendered scene.
	 * @param {?HTMLElement} [domElement=null] - The HTML DOM element used for event listeners.
	 */ constructor(objects, camera, domElement = null){
        super(camera, domElement);
        /**
		 * An array of draggable 3D objects.
		 *
		 * @type {Array<Object3D>}
		 */ this.objects = objects;
        /**
		 * Whether children of draggable objects can be dragged independently from their parent.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.recursive = true;
        /**
		 * This option only works if the `objects` array contains a single draggable  group object.
		 * If set to `true`, the controls does not transform individual objects but the entire group.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transformGroup = false;
        /**
		 * The speed at which the object will rotate when dragged in `rotate` mode.
		 * The higher the number the faster the rotation.
		 *
		 * @type {number}
		 * @default 1
		 */ this.rotateSpeed = 1;
        /**
		 * The raycaster used for detecting 3D objects.
		 *
		 * @type {Raycaster}
		 */ this.raycaster = new (0, $9ddd7e9b53f7a2d4$export$8b7aaceff00bd2f)();
        // interaction
        this.mouseButtons = {
            LEFT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN,
            MIDDLE: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN,
            RIGHT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE
        };
        this.touches = {
            ONE: (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).PAN
        };
        // event listeners
        this._onPointerMove = $40043d5ea0db3d61$var$onPointerMove.bind(this);
        this._onPointerDown = $40043d5ea0db3d61$var$onPointerDown.bind(this);
        this._onPointerCancel = $40043d5ea0db3d61$var$onPointerCancel.bind(this);
        this._onContextMenu = $40043d5ea0db3d61$var$onContextMenu.bind(this);
        //
        if (domElement !== null) this.connect(domElement);
    }
    connect(element) {
        super.connect(element);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointerup', this._onPointerCancel);
        this.domElement.addEventListener('pointerleave', this._onPointerCancel);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // Disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointerup', this._onPointerCancel);
        this.domElement.removeEventListener('pointerleave', this._onPointerCancel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = ''; // Restore touch scroll
        this.domElement.style.cursor = '';
    }
    dispose() {
        this.disconnect();
    }
    _updatePointer(event) {
        const rect = this.domElement.getBoundingClientRect();
        $40043d5ea0db3d61$var$_pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
        $40043d5ea0db3d61$var$_pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
    }
    _updateState(event) {
        // determine action
        let action;
        if (event.pointerType === 'touch') action = this.touches.ONE;
        else switch(event.button){
            case 0:
                action = this.mouseButtons.LEFT;
                break;
            case 1:
                action = this.mouseButtons.MIDDLE;
                break;
            case 2:
                action = this.mouseButtons.RIGHT;
                break;
            default:
                action = null;
        }
        // determine state
        switch(action){
            case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN:
            case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).PAN:
                this.state = $40043d5ea0db3d61$var$STATE.PAN;
                break;
            case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE:
            case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).ROTATE:
                this.state = $40043d5ea0db3d61$var$STATE.ROTATE;
                break;
            default:
                this.state = $40043d5ea0db3d61$var$STATE.NONE;
        }
    }
}
function $40043d5ea0db3d61$var$onPointerMove(event) {
    const camera = this.object;
    const domElement = this.domElement;
    const raycaster = this.raycaster;
    if (this.enabled === false) return;
    this._updatePointer(event);
    raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
    if ($40043d5ea0db3d61$var$_selected) {
        if (this.state === $40043d5ea0db3d61$var$STATE.PAN) {
            if (raycaster.ray.intersectPlane($40043d5ea0db3d61$var$_plane, $40043d5ea0db3d61$var$_intersection)) {
                $40043d5ea0db3d61$var$_selected.position.copy($40043d5ea0db3d61$var$_intersection.sub($40043d5ea0db3d61$var$_offset).applyMatrix4($40043d5ea0db3d61$var$_inverseMatrix));
                this.dispatchEvent({
                    type: 'drag',
                    object: $40043d5ea0db3d61$var$_selected
                });
            }
        } else if (this.state === $40043d5ea0db3d61$var$STATE.ROTATE) {
            $40043d5ea0db3d61$var$_diff.subVectors($40043d5ea0db3d61$var$_pointer, $40043d5ea0db3d61$var$_previousPointer).multiplyScalar(this.rotateSpeed);
            $40043d5ea0db3d61$var$_selected.rotateOnWorldAxis($40043d5ea0db3d61$var$_up, $40043d5ea0db3d61$var$_diff.x);
            $40043d5ea0db3d61$var$_selected.rotateOnWorldAxis($40043d5ea0db3d61$var$_right.normalize(), -$40043d5ea0db3d61$var$_diff.y);
            this.dispatchEvent({
                type: 'drag',
                object: $40043d5ea0db3d61$var$_selected
            });
        }
        $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
    } else // hover support
    if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
        $40043d5ea0db3d61$var$_intersections.length = 0;
        raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
        raycaster.intersectObjects(this.objects, this.recursive, $40043d5ea0db3d61$var$_intersections);
        if ($40043d5ea0db3d61$var$_intersections.length > 0) {
            const object = $40043d5ea0db3d61$var$_intersections[0].object;
            $40043d5ea0db3d61$var$_plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection($40043d5ea0db3d61$var$_plane.normal), $40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition(object.matrixWorld));
            if ($40043d5ea0db3d61$var$_hovered !== object && $40043d5ea0db3d61$var$_hovered !== null) {
                this.dispatchEvent({
                    type: 'hoveroff',
                    object: $40043d5ea0db3d61$var$_hovered
                });
                domElement.style.cursor = 'auto';
                $40043d5ea0db3d61$var$_hovered = null;
            }
            if ($40043d5ea0db3d61$var$_hovered !== object) {
                this.dispatchEvent({
                    type: 'hoveron',
                    object: object
                });
                domElement.style.cursor = 'pointer';
                $40043d5ea0db3d61$var$_hovered = object;
            }
        } else if ($40043d5ea0db3d61$var$_hovered !== null) {
            this.dispatchEvent({
                type: 'hoveroff',
                object: $40043d5ea0db3d61$var$_hovered
            });
            domElement.style.cursor = 'auto';
            $40043d5ea0db3d61$var$_hovered = null;
        }
    }
    $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
}
function $40043d5ea0db3d61$var$onPointerDown(event) {
    const camera = this.object;
    const domElement = this.domElement;
    const raycaster = this.raycaster;
    if (this.enabled === false) return;
    this._updatePointer(event);
    this._updateState(event);
    $40043d5ea0db3d61$var$_intersections.length = 0;
    raycaster.setFromCamera($40043d5ea0db3d61$var$_pointer, camera);
    raycaster.intersectObjects(this.objects, this.recursive, $40043d5ea0db3d61$var$_intersections);
    if ($40043d5ea0db3d61$var$_intersections.length > 0) {
        if (this.transformGroup === true) // look for the outermost group in the object's upper hierarchy
        $40043d5ea0db3d61$var$_selected = $40043d5ea0db3d61$var$findGroup($40043d5ea0db3d61$var$_intersections[0].object);
        else $40043d5ea0db3d61$var$_selected = $40043d5ea0db3d61$var$_intersections[0].object;
        $40043d5ea0db3d61$var$_plane.setFromNormalAndCoplanarPoint(camera.getWorldDirection($40043d5ea0db3d61$var$_plane.normal), $40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition($40043d5ea0db3d61$var$_selected.matrixWorld));
        if (raycaster.ray.intersectPlane($40043d5ea0db3d61$var$_plane, $40043d5ea0db3d61$var$_intersection)) {
            if (this.state === $40043d5ea0db3d61$var$STATE.PAN) {
                $40043d5ea0db3d61$var$_inverseMatrix.copy($40043d5ea0db3d61$var$_selected.parent.matrixWorld).invert();
                $40043d5ea0db3d61$var$_offset.copy($40043d5ea0db3d61$var$_intersection).sub($40043d5ea0db3d61$var$_worldPosition.setFromMatrixPosition($40043d5ea0db3d61$var$_selected.matrixWorld));
                domElement.style.cursor = 'move';
                this.dispatchEvent({
                    type: 'dragstart',
                    object: $40043d5ea0db3d61$var$_selected
                });
            } else if (this.state === $40043d5ea0db3d61$var$STATE.ROTATE) {
                // the controls only support Y+ up
                $40043d5ea0db3d61$var$_up.set(0, 1, 0).applyQuaternion(camera.quaternion).normalize();
                $40043d5ea0db3d61$var$_right.set(1, 0, 0).applyQuaternion(camera.quaternion).normalize();
                domElement.style.cursor = 'move';
                this.dispatchEvent({
                    type: 'dragstart',
                    object: $40043d5ea0db3d61$var$_selected
                });
            }
        }
    }
    $40043d5ea0db3d61$var$_previousPointer.copy($40043d5ea0db3d61$var$_pointer);
}
function $40043d5ea0db3d61$var$onPointerCancel() {
    if (this.enabled === false) return;
    if ($40043d5ea0db3d61$var$_selected) {
        this.dispatchEvent({
            type: 'dragend',
            object: $40043d5ea0db3d61$var$_selected
        });
        $40043d5ea0db3d61$var$_selected = null;
    }
    this.domElement.style.cursor = $40043d5ea0db3d61$var$_hovered ? 'pointer' : 'auto';
    this.state = $40043d5ea0db3d61$var$STATE.NONE;
}
function $40043d5ea0db3d61$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $40043d5ea0db3d61$var$findGroup(obj, group = null) {
    if (obj.isGroup) group = obj;
    if (obj.parent === null) return group;
    return $40043d5ea0db3d61$var$findGroup(obj.parent, group);
}




/**
 * @fileOverview Contains definition of the core graph object.
 */ // TODO: need to change storage layer:
// 1. Be able to get all nodes O(1)
// 2. Be able to get number of links O(1)
/**
 * @example
 *  var graph = require('ngraph.graph')();
 *  graph.addNode(1);     // graph has one node.
 *  graph.addLink(2, 3);  // now graph contains three nodes and one link.
 *
 */ function $3f984ebf2aba86a9$export$2e2bcd8739ae039(subject) {
    $3f984ebf2aba86a9$var$validateSubject(subject);
    const eventsStorage = $3f984ebf2aba86a9$var$createEventsStorage(subject);
    subject.on = eventsStorage.on;
    subject.off = eventsStorage.off;
    subject.fire = eventsStorage.fire;
    return subject;
}
function $3f984ebf2aba86a9$var$createEventsStorage(subject) {
    // Store all event listeners to this hash. Key is event name, value is array
    // of callback records.
    //
    // A callback record consists of callback function and its optional context:
    // { 'eventName' => [{callback: function, ctx: object}] }
    let registeredEvents = Object.create(null);
    return {
        on: function(eventName, callback, ctx) {
            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
            let handlers = registeredEvents[eventName];
            if (!handlers) handlers = registeredEvents[eventName] = [];
            handlers.push({
                callback: callback,
                ctx: ctx
            });
            return subject;
        },
        off: function(eventName, callback) {
            const wantToRemoveAll = typeof eventName === 'undefined';
            if (wantToRemoveAll) {
                // Killing old events storage should be enough in this case:
                registeredEvents = Object.create(null);
                return subject;
            }
            if (registeredEvents[eventName]) {
                const deleteAllCallbacksForEvent = typeof callback !== 'function';
                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                else {
                    const callbacks = registeredEvents[eventName];
                    for(let i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                }
            }
            return subject;
        },
        fire: function(eventName) {
            const callbacks = registeredEvents[eventName];
            if (!callbacks) return subject;
            let fireArguments;
            if (arguments.length > 1) // copy all args after eventName
            fireArguments = Array.prototype.slice.call(arguments, 1);
            for(let i = 0; i < callbacks.length; ++i){
                const callbackInfo = callbacks[i];
                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
            }
            return subject;
        }
    };
}
function $3f984ebf2aba86a9$var$validateSubject(subject) {
    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
    const reservedWords = [
        'on',
        'fire',
        'off'
    ];
    for(let i = 0; i < reservedWords.length; ++i){
        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
    }
}


var $eba878becea76980$export$2e2bcd8739ae039 = $eba878becea76980$var$createGraph;
/**
 * Creates a new graph
 */ function $eba878becea76980$var$createGraph(options) {
    // Graph structure is maintained as Map of nodes and Map of links.
    // Each node has 'links' (Set) which holds all incident links. This is
    // efficient for lookups and iteration, while keeping the API simple.
    options = options || {};
    if ('uniqueLinkId' in options) {
        console.warn("ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n", '\n', "Note: there is also change in default behavior: From now on each graph\nis considered to be not a multigraph by default (each edge is unique).");
        options.multigraph = options.uniqueLinkId;
    }
    // Dear reader, the non-multigraphs do not guarantee that there is only
    // one link for a given pair of node. When this option is set to false
    // we can save some memory and CPU (18% faster for non-multigraph);
    if (options.multigraph === undefined) options.multigraph = false;
    if (typeof Map !== 'function') // TODO: Should we polyfill it ourselves? We don't use much operations there..
    throw new Error('ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph');
    var nodes = new Map(); // nodeId => Node
    var links = new Map(); // linkId => Link
    // Hash of multi-edges. Used to track ids of edges between same nodes
    var multiEdges = {};
    var suspendEvents = 0;
    var createLink = options.multigraph ? createUniqueLink : createSingleLink, // Our graph API provides means to listen to graph changes. Users can subscribe
    // to be notified about changes in the graph by using `on` method. However
    // in some cases they don't use it. To avoid unnecessary memory consumption
    // we will not record graph changes until we have at least one subscriber.
    // Code below supports this optimization.
    //
    // Accumulates all changes made during graph updates.
    // Each change element contains:
    //  changeType - one of the strings: 'add', 'remove' or 'update';
    //  node - if change is related to node this property is set to changed graph's node;
    //  link - if change is related to link this property is set to changed graph's link;
    changes = [], recordLinkChange = noop, recordNodeChange = noop, enterModification = noop, exitModification = noop;
    // this is our public API:
    var graphPart = {
        /**
     * Sometimes duck typing could be slow. Giving clients a hint about data structure
     * via explicit version number here:
     */ version: 20.0,
        /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */ addNode: addNode,
        /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */ addLink: addLink,
        /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */ removeLink: removeLink,
        /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */ removeNode: removeNode,
        /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */ getNode: getNode,
        /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */ getNodeCount: getNodeCount,
        /**
     * Gets total number of links in the graph.
     */ getLinkCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getEdgeCount: getLinkCount,
        /**
     * Synonym for `getLinkCount()`
     */ getLinksCount: getLinkCount,
        /**
     * Synonym for `getNodeCount()`
     */ getNodesCount: getNodeCount,
        /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Set of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */ getLinks: getLinks,
        /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */ forEachNode: forEachNode,
        /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */ forEachLinkedNode: forEachLinkedNode,
        /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */ forEachLink: forEachLink,
        /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */ beginUpdate: enterModification,
        /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */ endUpdate: exitModification,
        /**
     * Removes all nodes and links from the graph.
     */ clear: clear,
        /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonym for getLink()
     *
     * @returns link if there is one. null otherwise.
     */ hasLink: getLink,
        /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonym for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */ hasNode: getNode,
        /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one; undefined otherwise.
     */ getLink: getLink,
        /**
     * Gets a link by its id.
     *
     * @param {string} linkId link identifier
     *
     * @returns link if there is one; undefined otherwise.
     */ getLinkById: getLinkById
    };
    // this will add `on()` and `fire()` methods.
    (0, $3f984ebf2aba86a9$export$2e2bcd8739ae039)(graphPart);
    monitorSubscribers();
    return graphPart;
    function monitorSubscribers() {
        var realOn = graphPart.on;
        // replace real `on` with our temporary on, which will trigger change
        // modification monitoring:
        graphPart.on = on;
        function on() {
            // now it's time to start tracking stuff:
            graphPart.beginUpdate = enterModification = enterModificationReal;
            graphPart.endUpdate = exitModification = exitModificationReal;
            recordLinkChange = recordLinkChangeReal;
            recordNodeChange = recordNodeChangeReal;
            // this will replace current `on` method with real pub/sub from `eventify`.
            graphPart.on = realOn;
            // delegate to real `on` handler:
            return realOn.apply(graphPart, arguments);
        }
    }
    function recordLinkChangeReal(link, changeType) {
        changes.push({
            link: link,
            changeType: changeType
        });
    }
    function recordNodeChangeReal(node, changeType) {
        changes.push({
            node: node,
            changeType: changeType
        });
    }
    function addNode(nodeId, data) {
        if (nodeId === undefined) throw new Error('Invalid node identifier');
        enterModification();
        var node = getNode(nodeId);
        if (!node) {
            node = new $eba878becea76980$var$Node(nodeId, data);
            recordNodeChange(node, 'add');
        } else {
            node.data = data;
            recordNodeChange(node, 'update');
        }
        nodes.set(nodeId, node);
        exitModification();
        return node;
    }
    function getNode(nodeId) {
        return nodes.get(nodeId);
    }
    function removeNode(nodeId) {
        var node = getNode(nodeId);
        if (!node) return false;
        enterModification();
        var prevLinks = node.links;
        if (prevLinks) {
            prevLinks.forEach(removeLinkInstance);
            node.links = null;
        }
        nodes.delete(nodeId);
        recordNodeChange(node, 'remove');
        exitModification();
        return true;
    }
    function addLink(fromId, toId, data) {
        enterModification();
        var fromNode = getNode(fromId) || addNode(fromId);
        var toNode = getNode(toId) || addNode(toId);
        var link = createLink(fromId, toId, data);
        var isUpdate = links.has(link.id);
        links.set(link.id, link);
        // TODO: this is not cool. On large graphs potentially would consume more memory.
        $eba878becea76980$var$addLinkToNode(fromNode, link);
        if (fromId !== toId) // make sure we are not duplicating links for self-loops
        $eba878becea76980$var$addLinkToNode(toNode, link);
        recordLinkChange(link, isUpdate ? 'update' : 'add');
        exitModification();
        return link;
    }
    function createSingleLink(fromId, toId, data) {
        var linkId = $eba878becea76980$var$makeLinkId(fromId, toId);
        var prevLink = links.get(linkId);
        if (prevLink) {
            prevLink.data = data;
            return prevLink;
        }
        return new $eba878becea76980$var$Link(fromId, toId, data, linkId);
    }
    function createUniqueLink(fromId, toId, data) {
        // TODO: Find a better/faster way to store multigraphs
        var linkId = $eba878becea76980$var$makeLinkId(fromId, toId);
        var isMultiEdge = multiEdges.hasOwnProperty(linkId);
        if (isMultiEdge || getLink(fromId, toId)) {
            if (!isMultiEdge) multiEdges[linkId] = 0;
            var suffix = '@' + ++multiEdges[linkId];
            linkId = $eba878becea76980$var$makeLinkId(fromId + suffix, toId + suffix);
        }
        return new $eba878becea76980$var$Link(fromId, toId, data, linkId);
    }
    function getNodeCount() {
        return nodes.size;
    }
    function getLinkCount() {
        return links.size;
    }
    function getLinks(nodeId) {
        var node = getNode(nodeId);
        return node ? node.links : null;
    }
    function removeLink(link, otherId) {
        if (otherId !== undefined) link = getLink(link, otherId);
        return removeLinkInstance(link);
    }
    function removeLinkInstance(link) {
        if (!link) return false;
        if (!links.get(link.id)) return false;
        enterModification();
        links.delete(link.id);
        var fromNode = getNode(link.fromId);
        var toNode = getNode(link.toId);
        if (fromNode) fromNode.links.delete(link);
        if (toNode) toNode.links.delete(link);
        recordLinkChange(link, 'remove');
        exitModification();
        return true;
    }
    function getLink(fromNodeId, toNodeId) {
        if (fromNodeId === undefined || toNodeId === undefined) return undefined;
        return links.get($eba878becea76980$var$makeLinkId(fromNodeId, toNodeId));
    }
    function getLinkById(linkId) {
        if (linkId === undefined) return undefined;
        return links.get(linkId);
    }
    function clear() {
        enterModification();
        forEachNode(function(node) {
            removeNode(node.id);
        });
        exitModification();
    }
    function forEachLink(callback) {
        if (typeof callback === 'function') {
            var valuesIterator = links.values();
            var nextValue = valuesIterator.next();
            while(!nextValue.done){
                if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
                nextValue = valuesIterator.next();
            }
        }
    }
    function forEachLinkedNode(nodeId, callback, oriented) {
        var node = getNode(nodeId);
        if (node && node.links && typeof callback === 'function') {
            if (oriented) return forEachOrientedLink(node.links, nodeId, callback);
            else return forEachNonOrientedLink(node.links, nodeId, callback);
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachNonOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            var linkedNodeId = link.fromId === nodeId ? link.toId : link.fromId;
            quitFast = callback(nodes.get(linkedNodeId), link);
            if (quitFast) return true; // Client does not need more iterations. Break now.
            nextValue = valuesIterator.next();
        }
    }
    // eslint-disable-next-line no-shadow
    function forEachOrientedLink(links, nodeId, callback) {
        var quitFast;
        var valuesIterator = links.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            var link = nextValue.value;
            if (link.fromId === nodeId) {
                quitFast = callback(nodes.get(link.toId), link);
                if (quitFast) return true; // Client does not need more iterations. Break now.
            }
            nextValue = valuesIterator.next();
        }
    }
    // we will not fire anything until users of this library explicitly call `on()`
    // method.
    function noop() {}
    // Enter, Exit modification allows bulk graph updates without firing events.
    function enterModificationReal() {
        suspendEvents += 1;
    }
    function exitModificationReal() {
        suspendEvents -= 1;
        if (suspendEvents === 0 && changes.length > 0) {
            graphPart.fire('changed', changes);
            changes.length = 0;
        }
    }
    function forEachNode(callback) {
        if (typeof callback !== 'function') throw new Error('Function is expected to iterate over graph nodes. You passed ' + callback);
        var valuesIterator = nodes.values();
        var nextValue = valuesIterator.next();
        while(!nextValue.done){
            if (callback(nextValue.value)) return true; // client doesn't want to proceed. Return.
            nextValue = valuesIterator.next();
        }
    }
}
/**
 * Internal structure to represent node;
 */ function $eba878becea76980$var$Node(id, data) {
    this.id = id;
    this.links = null;
    this.data = data;
}
function $eba878becea76980$var$addLinkToNode(node, link) {
    if (node.links) node.links.add(link);
    else node.links = new Set([
        link
    ]);
}
/**
 * Internal structure to represent links;
 */ function $eba878becea76980$var$Link(fromId, toId, data, id) {
    this.fromId = fromId;
    this.toId = toId;
    this.data = data;
    this.id = id;
}
function $eba878becea76980$var$makeLinkId(fromId, toId) {
    return fromId.toString() + "\uD83D\uDC49 " + toId.toString();
}


var $6d47bf1a993b0381$exports = {};
$6d47bf1a993b0381$exports = $6d47bf1a993b0381$var$createLayout;

$6d47bf1a993b0381$exports.simulator = (parcelRequire("6y6y7"));

var $hG6VV = parcelRequire("hG6VV");

/**
 * Creates force based layout for a given graph.
 *
 * @param {ngraph.graph} graph which needs to be laid out
 * @param {object} physicsSettings if you need custom settings
 * for physics simulator you can pass your own settings here. If it's not passed
 * a default one will be created.
 */ function $6d47bf1a993b0381$var$createLayout(graph, physicsSettings) {
    if (!graph) throw new Error('Graph structure cannot be undefined');
    var createSimulator = physicsSettings && physicsSettings.createSimulator || (parcelRequire("6y6y7"));
    var physicsSimulator = createSimulator(physicsSettings);
    if (Array.isArray(physicsSettings)) throw new Error('Physics settings is expected to be an object');
    var nodeMass = graph.version > 19 ? defaultSetNodeMass : defaultArrayNodeMass;
    if (physicsSettings && typeof physicsSettings.nodeMass === 'function') nodeMass = physicsSettings.nodeMass;
    var nodeBodies = new Map();
    var springs = {};
    var bodiesCount = 0;
    var springTransform = physicsSimulator.settings.springTransform || $6d47bf1a993b0381$var$noop;
    // Initialize physics with what we have in the graph:
    initPhysics();
    listenToEvents();
    var wasStable = false;
    var api = {
        /**
     * Performs one step of iterative layout algorithm
     *
     * @returns {boolean} true if the system should be considered stable; False otherwise.
     * The system is stable if no further call to `step()` can improve the layout.
     */ step: function() {
            if (bodiesCount === 0) {
                updateStableStatus(true);
                return true;
            }
            var lastMove = physicsSimulator.step();
            // Save the movement in case if someone wants to query it in the step
            // callback.
            api.lastMove = lastMove;
            // Allow listeners to perform low-level actions after nodes are updated.
            api.fire('step');
            var ratio = lastMove / bodiesCount;
            var isStableNow = ratio <= 0.01; // TODO: The number is somewhat arbitrary...
            updateStableStatus(isStableNow);
            return isStableNow;
        },
        /**
     * For a given `nodeId` returns position
     */ getNodePosition: function(nodeId) {
            return getInitializedBody(nodeId).pos;
        },
        /**
     * Sets position of a node to a given coordinates
     * @param {string} nodeId node identifier
     * @param {number} x position of a node
     * @param {number} y position of a node
     * @param {number=} z position of node (only if applicable to body)
     */ setNodePosition: function(nodeId) {
            var body = getInitializedBody(nodeId);
            body.setPosition.apply(body, Array.prototype.slice.call(arguments, 1));
        },
        /**
     * @returns {Object} Link position by link id
     * @returns {Object.from} {x, y} coordinates of link start
     * @returns {Object.to} {x, y} coordinates of link end
     */ getLinkPosition: function(linkId) {
            var spring = springs[linkId];
            if (spring) return {
                from: spring.from.pos,
                to: spring.to.pos
            };
        },
        /**
     * @returns {Object} area required to fit in the graph. Object contains
     * `x1`, `y1` - top left coordinates
     * `x2`, `y2` - bottom right coordinates
     */ getGraphRect: function() {
            return physicsSimulator.getBBox();
        },
        /**
     * Iterates over each body in the layout simulator and performs a callback(body, nodeId)
     */ forEachBody: forEachBody,
        /*
     * Requests layout algorithm to pin/unpin node to its current position
     * Pinned nodes should not be affected by layout algorithm and always
     * remain at their position
     */ pinNode: function(node, isPinned) {
            var body = getInitializedBody(node.id);
            body.isPinned = !!isPinned;
        },
        /**
     * Checks whether given graph's node is currently pinned
     */ isNodePinned: function(node) {
            return getInitializedBody(node.id).isPinned;
        },
        /**
     * Request to release all resources
     */ dispose: function() {
            graph.off('changed', onGraphChanged);
            api.fire('disposed');
        },
        /**
     * Gets physical body for a given node id. If node is not found undefined
     * value is returned.
     */ getBody: getBody,
        /**
     * Gets spring for a given edge.
     *
     * @param {string} linkId link identifer. If two arguments are passed then
     * this argument is treated as formNodeId
     * @param {string=} toId when defined this parameter denotes head of the link
     * and first argument is treated as tail of the link (fromId)
     */ getSpring: getSpring,
        /**
     * Returns length of cumulative force vector. The closer this to zero - the more stable the system is
     */ getForceVectorLength: getForceVectorLength,
        /**
     * [Read only] Gets current physics simulator
     */ simulator: physicsSimulator,
        /**
     * Gets the graph that was used for layout
     */ graph: graph,
        /**
     * Gets amount of movement performed during last step operation
     */ lastMove: 0
    };
    $hG6VV(api);
    return api;
    function updateStableStatus(isStableNow) {
        if (wasStable !== isStableNow) {
            wasStable = isStableNow;
            onStableChanged(isStableNow);
        }
    }
    function forEachBody(cb) {
        nodeBodies.forEach(cb);
    }
    function getForceVectorLength() {
        var fx = 0, fy = 0;
        forEachBody(function(body) {
            fx += Math.abs(body.force.x);
            fy += Math.abs(body.force.y);
        });
        return Math.sqrt(fx * fx + fy * fy);
    }
    function getSpring(fromId, toId) {
        var linkId;
        if (toId === undefined) {
            if (typeof fromId !== 'object') // assume fromId as a linkId:
            linkId = fromId;
            else // assume fromId to be a link object:
            linkId = fromId.id;
        } else {
            // toId is defined, should grab link:
            var link = graph.hasLink(fromId, toId);
            if (!link) return;
            linkId = link.id;
        }
        return springs[linkId];
    }
    function getBody(nodeId) {
        return nodeBodies.get(nodeId);
    }
    function listenToEvents() {
        graph.on('changed', onGraphChanged);
    }
    function onStableChanged(isStable) {
        api.fire('stable', isStable);
    }
    function onGraphChanged(changes) {
        for(var i = 0; i < changes.length; ++i){
            var change = changes[i];
            if (change.changeType === 'add') {
                if (change.node) initBody(change.node.id);
                if (change.link) initLink(change.link);
            } else if (change.changeType === 'remove') {
                if (change.node) releaseNode(change.node);
                if (change.link) releaseLink(change.link);
            }
        }
        bodiesCount = graph.getNodesCount();
    }
    function initPhysics() {
        bodiesCount = 0;
        graph.forEachNode(function(node) {
            initBody(node.id);
            bodiesCount += 1;
        });
        graph.forEachLink(initLink);
    }
    function initBody(nodeId) {
        var body = nodeBodies.get(nodeId);
        if (!body) {
            var node = graph.getNode(nodeId);
            if (!node) throw new Error('initBody() was called with unknown node id');
            var pos = node.position;
            if (!pos) {
                var neighbors = getNeighborBodies(node);
                pos = physicsSimulator.getBestNewBodyPosition(neighbors);
            }
            body = physicsSimulator.addBodyAt(pos);
            body.id = nodeId;
            nodeBodies.set(nodeId, body);
            updateBodyMass(nodeId);
            if (isNodeOriginallyPinned(node)) body.isPinned = true;
        }
    }
    function releaseNode(node) {
        var nodeId = node.id;
        var body = nodeBodies.get(nodeId);
        if (body) {
            nodeBodies.delete(nodeId);
            physicsSimulator.removeBody(body);
        }
    }
    function initLink(link) {
        updateBodyMass(link.fromId);
        updateBodyMass(link.toId);
        var fromBody = nodeBodies.get(link.fromId), toBody = nodeBodies.get(link.toId), spring = physicsSimulator.addSpring(fromBody, toBody, link.length);
        springTransform(link, spring);
        springs[link.id] = spring;
    }
    function releaseLink(link) {
        var spring = springs[link.id];
        if (spring) {
            var from = graph.getNode(link.fromId), to = graph.getNode(link.toId);
            if (from) updateBodyMass(from.id);
            if (to) updateBodyMass(to.id);
            delete springs[link.id];
            physicsSimulator.removeSpring(spring);
        }
    }
    function getNeighborBodies(node) {
        // TODO: Could probably be done better on memory
        var neighbors = [];
        if (!node.links) return neighbors;
        var maxNeighbors = Math.min(node.links.length, 2);
        for(var i = 0; i < maxNeighbors; ++i){
            var link = node.links[i];
            var otherBody = link.fromId !== node.id ? nodeBodies.get(link.fromId) : nodeBodies.get(link.toId);
            if (otherBody && otherBody.pos) neighbors.push(otherBody);
        }
        return neighbors;
    }
    function updateBodyMass(nodeId) {
        var body = nodeBodies.get(nodeId);
        body.mass = nodeMass(nodeId);
        if (Number.isNaN(body.mass)) throw new Error('Node mass should be a number');
    }
    /**
   * Checks whether graph node has in its settings pinned attribute,
   * which means layout algorithm cannot move it. Node can be marked
   * as pinned, if it has "isPinned" attribute, or when node.data has it.
   *
   * @param {Object} node a graph node to check
   * @return {Boolean} true if node should be treated as pinned; false otherwise.
   */ function isNodeOriginallyPinned(node) {
        return node && (node.isPinned || node.data && node.data.isPinned);
    }
    function getInitializedBody(nodeId) {
        var body = nodeBodies.get(nodeId);
        if (!body) {
            initBody(nodeId);
            body = nodeBodies.get(nodeId);
        }
        return body;
    }
    /**
   * Calculates mass of a body, which corresponds to node with given id.
   *
   * @param {String|Number} nodeId identifier of a node, for which body mass needs to be calculated
   * @returns {Number} recommended mass of the body;
   */ function defaultArrayNodeMass(nodeId) {
        // This function is for older versions of ngraph.graph.
        var links = graph.getLinks(nodeId);
        if (!links) return 1;
        return 1 + links.length / 3.0;
    }
    function defaultSetNodeMass(nodeId) {
        var links = graph.getLinks(nodeId);
        if (!links) return 1;
        return 1 + links.size / 3.0;
    }
}
function $6d47bf1a993b0381$var$noop() {}






function $9244736ab465462e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9244736ab465462e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $9244736ab465462e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9244736ab465462e$var$_arrayLikeToArray(r);
}
function $9244736ab465462e$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $9244736ab465462e$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $9244736ab465462e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $9244736ab465462e$var$_classPrivateFieldGet2(s, a) {
    return s.get($9244736ab465462e$var$_assertClassBrand(s, a));
}
function $9244736ab465462e$var$_classPrivateFieldInitSpec(e, t, a) {
    $9244736ab465462e$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $9244736ab465462e$var$_classPrivateFieldSet2(s, a, r) {
    return s.set($9244736ab465462e$var$_assertClassBrand(s, a), r), r;
}
function $9244736ab465462e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $9244736ab465462e$var$_toPropertyKey(o.key), o);
    }
}
function $9244736ab465462e$var$_createClass(e, r, t) {
    return r && $9244736ab465462e$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $9244736ab465462e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $9244736ab465462e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9244736ab465462e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9244736ab465462e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9244736ab465462e$var$_slicedToArray(r, e) {
    return $9244736ab465462e$var$_arrayWithHoles(r) || $9244736ab465462e$var$_iterableToArrayLimit(r, e) || $9244736ab465462e$var$_unsupportedIterableToArray(r, e) || $9244736ab465462e$var$_nonIterableRest();
}
function $9244736ab465462e$var$_toConsumableArray(r) {
    return $9244736ab465462e$var$_arrayWithoutHoles(r) || $9244736ab465462e$var$_iterableToArray(r) || $9244736ab465462e$var$_unsupportedIterableToArray(r) || $9244736ab465462e$var$_nonIterableSpread();
}
function $9244736ab465462e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $9244736ab465462e$var$_toPropertyKey(t) {
    var i = $9244736ab465462e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9244736ab465462e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9244736ab465462e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9244736ab465462e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $9244736ab465462e$var$_dataMap = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$var$_objMap = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$var$_id = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$var$_createObj = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$var$_updateObj = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$var$_removeObj = /*#__PURE__*/ new WeakMap();
var $9244736ab465462e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DataBindMapper() {
        $9244736ab465462e$var$_classCallCheck(this, DataBindMapper);
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_dataMap, new Map());
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_objMap, new Map());
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_id, function(d) {
            return d;
        });
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_createObj, function() {
            return {};
        });
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_updateObj, function() {});
        $9244736ab465462e$var$_classPrivateFieldInitSpec(this, $9244736ab465462e$var$_removeObj, function() {});
    }
    return $9244736ab465462e$var$_createClass(DataBindMapper, [
        {
            key: "getObj",
            value: function getObj(d) {
                return $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_dataMap, this).get($9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_id, this).call(this, d));
            }
        },
        {
            key: "getData",
            value: function getData(o) {
                return $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_objMap, this).get(o);
            }
        },
        {
            key: "entries",
            value: function entries() {
                return $9244736ab465462e$var$_toConsumableArray($9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_objMap, this).entries()).map(function(_ref) {
                    var _ref2 = $9244736ab465462e$var$_slicedToArray(_ref, 2), o = _ref2[0], d = _ref2[1];
                    return [
                        d,
                        o
                    ];
                });
            }
        },
        {
            key: "id",
            value: function id(p) {
                $9244736ab465462e$var$_classPrivateFieldSet2($9244736ab465462e$var$_id, this, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(p));
                return this;
            }
        },
        {
            key: "onCreateObj",
            value: function onCreateObj(fn) {
                $9244736ab465462e$var$_classPrivateFieldSet2($9244736ab465462e$var$_createObj, this, fn);
                return this;
            }
        },
        {
            key: "onUpdateObj",
            value: function onUpdateObj(fn) {
                $9244736ab465462e$var$_classPrivateFieldSet2($9244736ab465462e$var$_updateObj, this, fn);
                return this;
            }
        },
        {
            key: "onRemoveObj",
            value: function onRemoveObj(fn) {
                $9244736ab465462e$var$_classPrivateFieldSet2($9244736ab465462e$var$_removeObj, this, fn);
                return this;
            }
        },
        {
            key: "digest",
            value: function digest(data) {
                var _this = this;
                data.filter(function(d) {
                    return !$9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_dataMap, _this).has($9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_id, _this).call(_this, d));
                }).forEach(function(d) {
                    var obj = $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_createObj, _this).call(_this, d);
                    $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_dataMap, _this).set($9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_id, _this).call(_this, d), obj);
                    $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_objMap, _this).set(obj, d);
                });
                var dataIdsMap = new Map(data.map(function(d) {
                    return [
                        $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_id, _this).call(_this, d),
                        d
                    ];
                }));
                $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_dataMap, this).forEach(function(o, dId) {
                    if (!dataIdsMap.has(dId)) {
                        $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_removeObj, _this).call(_this, o, dId);
                        $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_dataMap, _this)["delete"](dId);
                        $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_objMap, _this)["delete"](o);
                    } else $9244736ab465462e$var$_classPrivateFieldGet2($9244736ab465462e$var$_updateObj, _this).call(_this, o, dataIdsMap.get(dId));
                });
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.digest([]);
                return this;
            }
        }
    ]);
}();





function $e83b3346bbbc2544$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e83b3346bbbc2544$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e83b3346bbbc2544$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e83b3346bbbc2544$var$_arrayLikeToArray(r);
}
function $e83b3346bbbc2544$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $e83b3346bbbc2544$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $e83b3346bbbc2544$var$_callSuper(t, o, e) {
    return o = $e83b3346bbbc2544$var$_getPrototypeOf(o), $e83b3346bbbc2544$var$_possibleConstructorReturn(t, $e83b3346bbbc2544$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e83b3346bbbc2544$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e83b3346bbbc2544$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $e83b3346bbbc2544$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e83b3346bbbc2544$var$_classPrivateFieldGet2(s, a) {
    return s.get($e83b3346bbbc2544$var$_assertClassBrand(s, a));
}
function $e83b3346bbbc2544$var$_classPrivateFieldInitSpec(e, t, a) {
    $e83b3346bbbc2544$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $e83b3346bbbc2544$var$_classPrivateFieldSet2(s, a, r) {
    return s.set($e83b3346bbbc2544$var$_assertClassBrand(s, a), r), r;
}
function $e83b3346bbbc2544$var$_construct(t, e, r) {
    if ($e83b3346bbbc2544$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return p;
}
function $e83b3346bbbc2544$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $e83b3346bbbc2544$var$_toPropertyKey(o.key), o);
    }
}
function $e83b3346bbbc2544$var$_createClass(e, r, t) {
    return r && $e83b3346bbbc2544$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $e83b3346bbbc2544$var$_defineProperty(e, r, t) {
    return (r = $e83b3346bbbc2544$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $e83b3346bbbc2544$var$_get() {
    return $e83b3346bbbc2544$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $e83b3346bbbc2544$var$_superPropBase(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $e83b3346bbbc2544$var$_get.apply(null, arguments);
}
function $e83b3346bbbc2544$var$_getPrototypeOf(t) {
    return $e83b3346bbbc2544$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e83b3346bbbc2544$var$_getPrototypeOf(t);
}
function $e83b3346bbbc2544$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: true,
            configurable: true
        }
    }), Object.defineProperty(t, "prototype", {
        writable: false
    }), e && $e83b3346bbbc2544$var$_setPrototypeOf(t, e);
}
function $e83b3346bbbc2544$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e83b3346bbbc2544$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $e83b3346bbbc2544$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e83b3346bbbc2544$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e83b3346bbbc2544$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e83b3346bbbc2544$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e83b3346bbbc2544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e83b3346bbbc2544$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e83b3346bbbc2544$var$ownKeys(Object(t), true).forEach(function(r) {
            $e83b3346bbbc2544$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e83b3346bbbc2544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e83b3346bbbc2544$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $e83b3346bbbc2544$var$_assertThisInitialized(t);
}
function $e83b3346bbbc2544$var$_setPrototypeOf(t, e) {
    return $e83b3346bbbc2544$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e83b3346bbbc2544$var$_setPrototypeOf(t, e);
}
function $e83b3346bbbc2544$var$_slicedToArray(r, e) {
    return $e83b3346bbbc2544$var$_arrayWithHoles(r) || $e83b3346bbbc2544$var$_iterableToArrayLimit(r, e) || $e83b3346bbbc2544$var$_unsupportedIterableToArray(r, e) || $e83b3346bbbc2544$var$_nonIterableRest();
}
function $e83b3346bbbc2544$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $e83b3346bbbc2544$var$_getPrototypeOf(t)););
    return t;
}
function $e83b3346bbbc2544$var$_superPropGet(t, o, e, r) {
    var p = $e83b3346bbbc2544$var$_get($e83b3346bbbc2544$var$_getPrototypeOf(t.prototype), o, e);
    return "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
function $e83b3346bbbc2544$var$_toConsumableArray(r) {
    return $e83b3346bbbc2544$var$_arrayWithoutHoles(r) || $e83b3346bbbc2544$var$_iterableToArray(r) || $e83b3346bbbc2544$var$_unsupportedIterableToArray(r) || $e83b3346bbbc2544$var$_nonIterableSpread();
}
function $e83b3346bbbc2544$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e83b3346bbbc2544$var$_toPropertyKey(t) {
    var i = $e83b3346bbbc2544$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e83b3346bbbc2544$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e83b3346bbbc2544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e83b3346bbbc2544$var$_typeof(o);
}
function $e83b3346bbbc2544$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e83b3346bbbc2544$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e83b3346bbbc2544$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $e83b3346bbbc2544$var$_materialDispose = function materialDispose(material) {
    if (material instanceof Array) material.forEach($e83b3346bbbc2544$var$_materialDispose);
    else {
        if (material.map) material.map.dispose();
        material.dispose();
    }
};
var $e83b3346bbbc2544$var$_deallocate = function deallocate(obj) {
    if (obj.geometry) obj.geometry.dispose();
    if (obj.material) $e83b3346bbbc2544$var$_materialDispose(obj.material);
    if (obj.texture) obj.texture.dispose();
    if (obj.children) obj.children.forEach($e83b3346bbbc2544$var$_deallocate);
};
var $e83b3346bbbc2544$var$emptyObject = function emptyObject(obj) {
    while(obj.children.length){
        var childObj = obj.children[0];
        obj.remove(childObj);
        $e83b3346bbbc2544$var$_deallocate(childObj);
    }
};
var $e83b3346bbbc2544$var$_dataBindAttr = /*#__PURE__*/ new WeakMap();
var $e83b3346bbbc2544$var$_objBindAttr = /*#__PURE__*/ new WeakMap();
var $e83b3346bbbc2544$var$ThreeDigest = /*#__PURE__*/ function(_DataBindMapper) {
    function ThreeDigest(scene) {
        var _this;
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$dataBindAttr = _ref.dataBindAttr, dataBindAttr = _ref$dataBindAttr === void 0 ? '__data' : _ref$dataBindAttr, _ref$objBindAttr = _ref.objBindAttr, objBindAttr = _ref$objBindAttr === void 0 ? '__threeObj' : _ref$objBindAttr;
        $e83b3346bbbc2544$var$_classCallCheck(this, ThreeDigest);
        _this = $e83b3346bbbc2544$var$_callSuper(this, ThreeDigest);
        $e83b3346bbbc2544$var$_defineProperty(_this, "scene", void 0);
        $e83b3346bbbc2544$var$_classPrivateFieldInitSpec(_this, $e83b3346bbbc2544$var$_dataBindAttr, void 0);
        $e83b3346bbbc2544$var$_classPrivateFieldInitSpec(_this, $e83b3346bbbc2544$var$_objBindAttr, void 0);
        _this.scene = scene;
        $e83b3346bbbc2544$var$_classPrivateFieldSet2($e83b3346bbbc2544$var$_dataBindAttr, _this, dataBindAttr);
        $e83b3346bbbc2544$var$_classPrivateFieldSet2($e83b3346bbbc2544$var$_objBindAttr, _this, objBindAttr);
        _this.onRemoveObj(function() {});
        return _this;
    }
    $e83b3346bbbc2544$var$_inherits(ThreeDigest, _DataBindMapper);
    return $e83b3346bbbc2544$var$_createClass(ThreeDigest, [
        {
            key: "onCreateObj",
            value: function onCreateObj(fn) {
                var _this2 = this;
                $e83b3346bbbc2544$var$_superPropGet(ThreeDigest, "onCreateObj", this)([
                    function(d) {
                        var obj = fn(d);
                        d[$e83b3346bbbc2544$var$_classPrivateFieldGet2($e83b3346bbbc2544$var$_objBindAttr, _this2)] = obj;
                        obj[$e83b3346bbbc2544$var$_classPrivateFieldGet2($e83b3346bbbc2544$var$_dataBindAttr, _this2)] = d;
                        _this2.scene.add(obj);
                        return obj;
                    }
                ]);
                return this;
            }
        },
        {
            key: "onRemoveObj",
            value: function onRemoveObj(fn) {
                var _this3 = this;
                $e83b3346bbbc2544$var$_superPropGet(ThreeDigest, "onRemoveObj", this)([
                    function(obj, dId) {
                        var d = $e83b3346bbbc2544$var$_superPropGet(ThreeDigest, "getData", _this3)([
                            obj
                        ]);
                        fn(obj, dId);
                        _this3.scene.remove(obj);
                        $e83b3346bbbc2544$var$_deallocate(obj);
                        delete d[$e83b3346bbbc2544$var$_classPrivateFieldGet2($e83b3346bbbc2544$var$_objBindAttr, _this3)];
                    }
                ]);
                return this;
            }
        }
    ]);
}((0, $9244736ab465462e$export$2e2bcd8739ae039));
var $e83b3346bbbc2544$var$colorStr2Hex = function colorStr2Hex(str) {
    return isNaN(str) ? parseInt((0, $5ce907c1717e301d$export$2e2bcd8739ae039)(str).toHex(), 16) : str;
};
var $e83b3346bbbc2544$var$colorAlpha = function colorAlpha(str) {
    return isNaN(str) ? (0, $5ce907c1717e301d$export$2e2bcd8739ae039)(str).getAlpha() : 1;
};
var $e83b3346bbbc2544$var$autoColorScale = (0, $38404d762c7ac827$export$2e2bcd8739ae039)((0, $892d66d4b4370fa9$export$2e2bcd8739ae039));
// Autoset attribute colorField by colorByAccessor property
// If an object has already a color, don't set it
// Objects can be nodes or links
function $e83b3346bbbc2544$var$autoColorObjects(objects, colorByAccessor, colorField) {
    if (!colorByAccessor || typeof colorField !== 'string') return;
    objects.filter(function(obj) {
        return !obj[colorField];
    }).forEach(function(obj) {
        obj[colorField] = $e83b3346bbbc2544$var$autoColorScale(colorByAccessor(obj));
    });
}
function $e83b3346bbbc2544$var$getDagDepths(_ref, idAccessor) {
    var nodes = _ref.nodes, links = _ref.links;
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$nodeFilter = _ref2.nodeFilter, nodeFilter = _ref2$nodeFilter === void 0 ? function() {
        return true;
    } : _ref2$nodeFilter, _ref2$onLoopError = _ref2.onLoopError, onLoopError = _ref2$onLoopError === void 0 ? function(loopIds) {
        throw "Invalid DAG structure! Found cycle in node path: ".concat(loopIds.join(' -> '), ".");
    } : _ref2$onLoopError;
    // linked graph
    var graph = {};
    nodes.forEach(function(node) {
        return graph[idAccessor(node)] = {
            data: node,
            out: [],
            depth: -1,
            skip: !nodeFilter(node)
        };
    });
    links.forEach(function(_ref3) {
        var source = _ref3.source, target = _ref3.target;
        var sourceId = getNodeId(source);
        var targetId = getNodeId(target);
        if (!graph.hasOwnProperty(sourceId)) throw "Missing source node with id: ".concat(sourceId);
        if (!graph.hasOwnProperty(targetId)) throw "Missing target node with id: ".concat(targetId);
        var sourceNode = graph[sourceId];
        var targetNode = graph[targetId];
        sourceNode.out.push(targetNode);
        function getNodeId(node) {
            return $e83b3346bbbc2544$var$_typeof(node) === 'object' ? idAccessor(node) : node;
        }
    });
    var foundLoops = [];
    traverse(Object.values(graph));
    var nodeDepths = Object.assign.apply(Object, [
        {}
    ].concat($e83b3346bbbc2544$var$_toConsumableArray(Object.entries(graph).filter(function(_ref4) {
        var _ref5 = $e83b3346bbbc2544$var$_slicedToArray(_ref4, 2), node = _ref5[1];
        return !node.skip;
    }).map(function(_ref6) {
        var _ref7 = $e83b3346bbbc2544$var$_slicedToArray(_ref6, 2), id = _ref7[0], node = _ref7[1];
        return $e83b3346bbbc2544$var$_defineProperty({}, id, node.depth);
    }))));
    return nodeDepths;
    function traverse(nodes) {
        var nodeStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var currentDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var _loop = function _loop() {
            var node = nodes[i];
            if (nodeStack.indexOf(node) !== -1) {
                var loop = [].concat($e83b3346bbbc2544$var$_toConsumableArray(nodeStack.slice(nodeStack.indexOf(node))), [
                    node
                ]).map(function(d) {
                    return idAccessor(d.data);
                });
                if (!foundLoops.some(function(foundLoop) {
                    return foundLoop.length === loop.length && foundLoop.every(function(id, idx) {
                        return id === loop[idx];
                    });
                })) {
                    foundLoops.push(loop);
                    onLoopError(loop);
                }
                return 1; // continue
            }
            if (currentDepth > node.depth) {
                // Don't unnecessarily revisit chunks of the graph
                node.depth = currentDepth;
                traverse(node.out, [].concat($e83b3346bbbc2544$var$_toConsumableArray(nodeStack), [
                    node
                ]), currentDepth + (node.skip ? 0 : 1));
            }
        };
        for(var i = 0, l = nodes.length; i < l; i++){
            if (_loop()) continue;
        }
    }
}
var $e83b3346bbbc2544$var$three$1 = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    Group: (0, $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4),
    Mesh: (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5),
    MeshLambertMaterial: (0, $9ddd7e9b53f7a2d4$export$5023a9a8114806b8),
    Color: (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e),
    BufferGeometry: (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959),
    BufferAttribute: (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117),
    Matrix4: (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5),
    Vector3: (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699),
    SphereGeometry: (0, $9ddd7e9b53f7a2d4$export$1b417fc3b307a251),
    CylinderGeometry: (0, $9ddd7e9b53f7a2d4$export$68f745719dbe5198),
    TubeGeometry: (0, $9ddd7e9b53f7a2d4$export$7897d9d48904490c),
    ConeGeometry: (0, $9ddd7e9b53f7a2d4$export$a7a48974f285c9b3),
    Line: (0, $9ddd7e9b53f7a2d4$export$17d680238e50603e),
    LineBasicMaterial: (0, $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c),
    QuadraticBezierCurve3: (0, $9ddd7e9b53f7a2d4$export$bf3f4c7e459f90fc),
    CubicBezierCurve3: (0, $9ddd7e9b53f7a2d4$export$13d5f1c9525f246c),
    Box3: (0, $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3)
};
var $e83b3346bbbc2544$var$ngraph = {
    graph: (0, $eba878becea76980$export$2e2bcd8739ae039),
    forcelayout: (0, (/*@__PURE__*/$parcel$interopDefault($6d47bf1a993b0381$exports)))
};
//
var $e83b3346bbbc2544$var$DAG_LEVEL_NODE_RATIO = 2;
// support multiple method names for backwards threejs compatibility
var $e83b3346bbbc2544$var$setAttributeFn = new $e83b3346bbbc2544$var$three$1.BufferGeometry().setAttribute ? 'setAttribute' : 'addAttribute';
var $e83b3346bbbc2544$var$applyMatrix4Fn = new $e83b3346bbbc2544$var$three$1.BufferGeometry().applyMatrix4 ? 'applyMatrix4' : 'applyMatrix';
var $e83b3346bbbc2544$var$ForceGraph = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        jsonUrl: {
            onChange: function onChange(jsonUrl, state) {
                var _this = this;
                if (jsonUrl && !state.fetchingJson) {
                    // Load data asynchronously
                    state.fetchingJson = true;
                    state.onLoading();
                    fetch(jsonUrl).then(function(r) {
                        return r.json();
                    }).then(function(json) {
                        state.fetchingJson = false;
                        state.onFinishLoading(json);
                        _this.graphData(json);
                    });
                }
            },
            triggerUpdate: false
        },
        graphData: {
            "default": {
                nodes: [],
                links: []
            },
            onChange: function onChange(graphData, state) {
                state.engineRunning = false; // Pause simulation immediately
            }
        },
        numDimensions: {
            "default": 3,
            onChange: function onChange(numDim, state) {
                var chargeForce = state.d3ForceLayout.force('charge');
                // Increase repulsion on 3D mode for improved spatial separation
                if (chargeForce) chargeForce.strength(numDim > 2 ? -60 : -30);
                if (numDim < 3) eraseDimension(state.graphData.nodes, 'z');
                if (numDim < 2) eraseDimension(state.graphData.nodes, 'y');
                function eraseDimension(nodes, dim) {
                    nodes.forEach(function(d) {
                        delete d[dim]; // position
                        delete d["v".concat(dim)]; // velocity
                    });
                }
            }
        },
        dagMode: {
            onChange: function onChange(dagMode, state) {
                // td, bu, lr, rl, zin, zout, radialin, radialout
                !dagMode && state.forceEngine === 'd3' && (state.graphData.nodes || []).forEach(function(n) {
                    return n.fx = n.fy = n.fz = undefined;
                }); // unfix nodes when disabling dag mode
            }
        },
        dagLevelDistance: {},
        dagNodeFilter: {
            "default": function _default(node) {
                return true;
            }
        },
        onDagError: {
            triggerUpdate: false
        },
        nodeRelSize: {
            "default": 4
        },
        // volume per val unit
        nodeId: {
            "default": 'id'
        },
        nodeVal: {
            "default": 'val'
        },
        nodeResolution: {
            "default": 8
        },
        // how many slice segments in the sphere's circumference
        nodeColor: {
            "default": 'color'
        },
        nodeAutoColorBy: {},
        nodeOpacity: {
            "default": 0.75
        },
        nodeVisibility: {
            "default": true
        },
        nodeThreeObject: {},
        nodeThreeObjectExtend: {
            "default": false
        },
        nodePositionUpdate: {
            triggerUpdate: false
        },
        // custom function to call for updating the node's position. Signature: (threeObj, { x, y, z}, node). If the function returns a truthy value, the regular node position update will not run.
        linkSource: {
            "default": 'source'
        },
        linkTarget: {
            "default": 'target'
        },
        linkVisibility: {
            "default": true
        },
        linkColor: {
            "default": 'color'
        },
        linkAutoColorBy: {},
        linkOpacity: {
            "default": 0.2
        },
        linkWidth: {},
        // Rounded to nearest decimal. For falsy values use dimensionless line with 1px regardless of distance.
        linkResolution: {
            "default": 6
        },
        // how many radial segments in each line tube's geometry
        linkCurvature: {
            "default": 0,
            triggerUpdate: false
        },
        // line curvature radius (0: straight, 1: semi-circle)
        linkCurveRotation: {
            "default": 0,
            triggerUpdate: false
        },
        // line curve rotation along the line axis (0: interection with XY plane, PI: upside down)
        linkMaterial: {},
        linkThreeObject: {},
        linkThreeObjectExtend: {
            "default": false
        },
        linkPositionUpdate: {
            triggerUpdate: false
        },
        // custom function to call for updating the link's position. Signature: (threeObj, { start: { x, y, z},  end: { x, y, z }}, link). If the function returns a truthy value, the regular link position update will not run.
        linkDirectionalArrowLength: {
            "default": 0
        },
        linkDirectionalArrowColor: {},
        linkDirectionalArrowRelPos: {
            "default": 0.5,
            triggerUpdate: false
        },
        // value between 0<>1 indicating the relative pos along the (exposed) line
        linkDirectionalArrowResolution: {
            "default": 8
        },
        // how many slice segments in the arrow's conic circumference
        linkDirectionalParticles: {
            "default": 0
        },
        // animate photons travelling in the link direction
        linkDirectionalParticleSpeed: {
            "default": 0.01,
            triggerUpdate: false
        },
        // in link length ratio per frame
        linkDirectionalParticleOffset: {
            "default": 0,
            triggerUpdate: false
        },
        // starting position offset along the link's length, like a pre-delay. Values between [0, 1]
        linkDirectionalParticleWidth: {
            "default": 0.5
        },
        linkDirectionalParticleColor: {},
        linkDirectionalParticleResolution: {
            "default": 4
        },
        // how many slice segments in the particle sphere's circumference
        linkDirectionalParticleThreeObject: {},
        forceEngine: {
            "default": 'd3'
        },
        // d3 or ngraph
        d3AlphaMin: {
            "default": 0
        },
        d3AlphaDecay: {
            "default": 0.0228,
            triggerUpdate: false,
            onChange: function onChange(alphaDecay, state) {
                state.d3ForceLayout.alphaDecay(alphaDecay);
            }
        },
        d3AlphaTarget: {
            "default": 0,
            triggerUpdate: false,
            onChange: function onChange(alphaTarget, state) {
                state.d3ForceLayout.alphaTarget(alphaTarget);
            }
        },
        d3VelocityDecay: {
            "default": 0.4,
            triggerUpdate: false,
            onChange: function onChange(velocityDecay, state) {
                state.d3ForceLayout.velocityDecay(velocityDecay);
            }
        },
        ngraphPhysics: {
            "default": {
                // defaults from https://github.com/anvaka/ngraph.physics.simulator/blob/master/index.js
                timeStep: 20,
                gravity: -1.2,
                theta: 0.8,
                springLength: 30,
                springCoefficient: 0.0008,
                dragCoefficient: 0.02
            }
        },
        warmupTicks: {
            "default": 0,
            triggerUpdate: false
        },
        // how many times to tick the force engine at init before starting to render
        cooldownTicks: {
            "default": Infinity,
            triggerUpdate: false
        },
        cooldownTime: {
            "default": 15000,
            triggerUpdate: false
        },
        // ms
        onLoading: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onFinishLoading: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onFinishUpdate: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineTick: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onEngineStop: {
            "default": function _default() {},
            triggerUpdate: false
        }
    },
    methods: {
        refresh: function refresh(state) {
            state._flushObjects = true;
            state._rerender();
            return this;
        },
        // Expose d3 forces for external manipulation
        d3Force: function d3Force(state, forceName, forceFn) {
            if (forceFn === undefined) return state.d3ForceLayout.force(forceName); // Force getter
            state.d3ForceLayout.force(forceName, forceFn); // Force setter
            return this;
        },
        d3ReheatSimulation: function d3ReheatSimulation(state) {
            state.d3ForceLayout.alpha(1);
            this.resetCountdown();
            return this;
        },
        // reset cooldown state
        resetCountdown: function resetCountdown(state) {
            state.cntTicks = 0;
            state.startTickTime = new Date();
            state.engineRunning = true;
            return this;
        },
        tickFrame: function tickFrame(state) {
            var isD3Sim = state.forceEngine !== 'ngraph';
            if (state.engineRunning) layoutTick();
            updateArrows();
            updatePhotons();
            return this;
            //
            function layoutTick() {
                if (++state.cntTicks > state.cooldownTicks || new Date() - state.startTickTime > state.cooldownTime || isD3Sim && state.d3AlphaMin > 0 && state.d3ForceLayout.alpha() < state.d3AlphaMin) {
                    state.engineRunning = false; // Stop ticking graph
                    state.onEngineStop();
                } else {
                    state.layout[isD3Sim ? 'tick' : 'step'](); // Tick it
                    state.onEngineTick();
                }
                var nodeThreeObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObjectExtend);
                // Update nodes position
                state.nodeDataMapper.entries().forEach(function(_ref) {
                    var _ref2 = $e83b3346bbbc2544$var$_slicedToArray(_ref, 2), node = _ref2[0], obj = _ref2[1];
                    if (!obj) return;
                    var pos = isD3Sim ? node : state.layout.getNodePosition(node[state.nodeId]);
                    var extendedObj = nodeThreeObjectExtendAccessor(node);
                    if (!state.nodePositionUpdate || !state.nodePositionUpdate(extendedObj ? obj.children[0] : obj, {
                        x: pos.x,
                        y: pos.y,
                        z: pos.z
                    }, node) // pass child custom object if extending the default
                     || extendedObj) {
                        obj.position.x = pos.x;
                        obj.position.y = pos.y || 0;
                        obj.position.z = pos.z || 0;
                    }
                });
                // Update links position
                var linkWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth);
                var linkCurvatureAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCurvature);
                var linkCurveRotationAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkCurveRotation);
                var linkThreeObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObjectExtend);
                state.linkDataMapper.entries().forEach(function(_ref3) {
                    var _ref4 = $e83b3346bbbc2544$var$_slicedToArray(_ref3, 2), link = _ref4[0], lineObj = _ref4[1];
                    if (!lineObj) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    calcLinkCurve(link); // calculate link curve for all links, including custom replaced, so it can be used in directional functionality
                    var extendedObj = linkThreeObjectExtendAccessor(link);
                    if (state.linkPositionUpdate && state.linkPositionUpdate(extendedObj ? lineObj.children[1] : lineObj, // pass child custom object if extending the default
                    {
                        start: {
                            x: start.x,
                            y: start.y,
                            z: start.z
                        },
                        end: {
                            x: end.x,
                            y: end.y,
                            z: end.z
                        }
                    }, link) && !extendedObj) // exit if successfully custom updated position of non-extended obj
                    return;
                    var curveResolution = 30; // # line segments
                    var curve = link.__curve;
                    // select default line obj if it's an extended group
                    var line = lineObj.children.length ? lineObj.children[0] : lineObj;
                    if (line.type === 'Line') {
                        // Update line geometry
                        if (!curve) {
                            // straight line
                            var linePos = line.geometry.getAttribute('position');
                            if (!linePos || !linePos.array || linePos.array.length !== 6) line.geometry[$e83b3346bbbc2544$var$setAttributeFn]('position', linePos = new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(6), 3));
                            linePos.array[0] = start.x;
                            linePos.array[1] = start.y || 0;
                            linePos.array[2] = start.z || 0;
                            linePos.array[3] = end.x;
                            linePos.array[4] = end.y || 0;
                            linePos.array[5] = end.z || 0;
                            linePos.needsUpdate = true;
                        } else {
                            // bezier curve line
                            var curvePnts = curve.getPoints(curveResolution);
                            // resize buffer if needed
                            if (line.geometry.getAttribute('position').array.length !== curvePnts.length * 3) line.geometry[$e83b3346bbbc2544$var$setAttributeFn]('position', new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(curvePnts.length * 3), 3));
                            line.geometry.setFromPoints(curvePnts);
                        }
                        line.geometry.computeBoundingSphere();
                    } else if (line.type === 'Mesh') {
                        // Update cylinder geometry
                        if (!curve) {
                            // straight tube
                            if (!line.geometry.type.match(/^Cylinder(Buffer)?Geometry$/)) {
                                var linkWidth = Math.ceil(linkWidthAccessor(link) * 10) / 10;
                                var r = linkWidth / 2;
                                var geometry = new $e83b3346bbbc2544$var$three$1.CylinderGeometry(r, r, 1, state.linkResolution, 1, false);
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeTranslation(0, 0.5, 0));
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeRotationX(Math.PI / 2));
                                line.geometry.dispose();
                                line.geometry = geometry;
                            }
                            var vStart = new $e83b3346bbbc2544$var$three$1.Vector3(start.x, start.y || 0, start.z || 0);
                            var vEnd = new $e83b3346bbbc2544$var$three$1.Vector3(end.x, end.y || 0, end.z || 0);
                            var distance = vStart.distanceTo(vEnd);
                            line.position.x = vStart.x;
                            line.position.y = vStart.y;
                            line.position.z = vStart.z;
                            line.scale.z = distance;
                            line.parent.localToWorld(vEnd); // lookAt requires world coords
                            line.lookAt(vEnd);
                        } else {
                            // curved tube
                            if (!line.geometry.type.match(/^Tube(Buffer)?Geometry$/)) {
                                // reset object positioning
                                line.position.set(0, 0, 0);
                                line.rotation.set(0, 0, 0);
                                line.scale.set(1, 1, 1);
                            }
                            var _linkWidth = Math.ceil(linkWidthAccessor(link) * 10) / 10;
                            var _r = _linkWidth / 2;
                            var _geometry = new $e83b3346bbbc2544$var$three$1.TubeGeometry(curve, curveResolution, _r, state.linkResolution, false);
                            line.geometry.dispose();
                            line.geometry = _geometry;
                        }
                    }
                });
                //
                function calcLinkCurve(link) {
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var curvature = linkCurvatureAccessor(link);
                    if (!curvature) link.__curve = null; // Straight line
                    else {
                        // bezier curve line (only for line types)
                        var vStart = new $e83b3346bbbc2544$var$three$1.Vector3(start.x, start.y || 0, start.z || 0);
                        var vEnd = new $e83b3346bbbc2544$var$three$1.Vector3(end.x, end.y || 0, end.z || 0);
                        var l = vStart.distanceTo(vEnd); // line length
                        var curve;
                        var curveRotation = linkCurveRotationAccessor(link);
                        if (l > 0) {
                            var dx = end.x - start.x;
                            var dy = end.y - start.y || 0;
                            var vLine = new $e83b3346bbbc2544$var$three$1.Vector3().subVectors(vEnd, vStart);
                            var cp = vLine.clone().multiplyScalar(curvature).cross(dx !== 0 || dy !== 0 ? new $e83b3346bbbc2544$var$three$1.Vector3(0, 0, 1) : new $e83b3346bbbc2544$var$three$1.Vector3(0, 1, 0)) // avoid cross-product of parallel vectors (prefer Z, fallback to Y)
                            .applyAxisAngle(vLine.normalize(), curveRotation) // rotate along line axis according to linkCurveRotation
                            .add(new $e83b3346bbbc2544$var$three$1.Vector3().addVectors(vStart, vEnd).divideScalar(2));
                            curve = new $e83b3346bbbc2544$var$three$1.QuadraticBezierCurve3(vStart, cp, vEnd);
                        } else {
                            // Same point, draw a loop
                            var d = curvature * 70;
                            var endAngle = -curveRotation; // Rotate clockwise (from Z angle perspective)
                            var startAngle = endAngle + Math.PI / 2;
                            curve = new $e83b3346bbbc2544$var$three$1.CubicBezierCurve3(vStart, new $e83b3346bbbc2544$var$three$1.Vector3(d * Math.cos(startAngle), d * Math.sin(startAngle), 0).add(vStart), new $e83b3346bbbc2544$var$three$1.Vector3(d * Math.cos(endAngle), d * Math.sin(endAngle), 0).add(vStart), vEnd);
                        }
                        link.__curve = curve;
                    }
                }
            }
            function updateArrows() {
                // update link arrow position
                var arrowRelPosAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowRelPos);
                var arrowLengthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowLength);
                var nodeValAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
                state.arrowDataMapper.entries().forEach(function(_ref5) {
                    var _ref6 = $e83b3346bbbc2544$var$_slicedToArray(_ref5, 2), link = _ref6[0], arrowObj = _ref6[1];
                    if (!arrowObj) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var startR = Math.cbrt(Math.max(0, nodeValAccessor(start) || 1)) * state.nodeRelSize;
                    var endR = Math.cbrt(Math.max(0, nodeValAccessor(end) || 1)) * state.nodeRelSize;
                    var arrowLength = arrowLengthAccessor(link);
                    var arrowRelPos = arrowRelPosAccessor(link);
                    var getPosAlongLine = link.__curve ? function(t) {
                        return link.__curve.getPoint(t);
                    } // interpolate along bezier curve
                     : function(t) {
                        // straight line: interpolate linearly
                        var iplt = function iplt(dim, start, end, t) {
                            return start[dim] + (end[dim] - start[dim]) * t || 0;
                        };
                        return {
                            x: iplt('x', start, end, t),
                            y: iplt('y', start, end, t),
                            z: iplt('z', start, end, t)
                        };
                    };
                    var lineLen = link.__curve ? link.__curve.getLength() : Math.sqrt([
                        'x',
                        'y',
                        'z'
                    ].map(function(dim) {
                        return Math.pow((end[dim] || 0) - (start[dim] || 0), 2);
                    }).reduce(function(acc, v) {
                        return acc + v;
                    }, 0));
                    var posAlongLine = startR + arrowLength + (lineLen - startR - endR - arrowLength) * arrowRelPos;
                    var arrowHead = getPosAlongLine(posAlongLine / lineLen);
                    var arrowTail = getPosAlongLine((posAlongLine - arrowLength) / lineLen);
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(dim) {
                        return arrowObj.position[dim] = arrowTail[dim];
                    });
                    var headVec = $e83b3346bbbc2544$var$_construct($e83b3346bbbc2544$var$three$1.Vector3, $e83b3346bbbc2544$var$_toConsumableArray([
                        'x',
                        'y',
                        'z'
                    ].map(function(c) {
                        return arrowHead[c];
                    })));
                    arrowObj.parent.localToWorld(headVec); // lookAt requires world coords
                    arrowObj.lookAt(headVec);
                });
            }
            function updatePhotons() {
                // update link particle positions
                var particleSpeedAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleSpeed);
                var particleOffsetAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleOffset);
                state.graphData.links.forEach(function(link) {
                    var photonsObj = state.particlesDataMapper.getObj(link);
                    var cyclePhotons = photonsObj && photonsObj.children;
                    var singleHopPhotons = link.__singleHopPhotonsObj && link.__singleHopPhotonsObj.children;
                    if ((!singleHopPhotons || !singleHopPhotons.length) && (!cyclePhotons || !cyclePhotons.length)) return;
                    var pos = isD3Sim ? link : state.layout.getLinkPosition(state.layout.graph.getLink(link.source, link.target).id);
                    var start = pos[isD3Sim ? 'source' : 'from'];
                    var end = pos[isD3Sim ? 'target' : 'to'];
                    if (!start || !end || !start.hasOwnProperty('x') || !end.hasOwnProperty('x')) return; // skip invalid link
                    var particleSpeed = particleSpeedAccessor(link);
                    var particleOffset = Math.abs(particleOffsetAccessor(link));
                    var getPhotonPos = link.__curve ? function(t) {
                        return link.__curve.getPoint(t);
                    } // interpolate along bezier curve
                     : function(t) {
                        // straight line: interpolate linearly
                        var iplt = function iplt(dim, start, end, t) {
                            return start[dim] + (end[dim] - start[dim]) * t || 0;
                        };
                        return {
                            x: iplt('x', start, end, t),
                            y: iplt('y', start, end, t),
                            z: iplt('z', start, end, t)
                        };
                    };
                    var photons = [].concat($e83b3346bbbc2544$var$_toConsumableArray(cyclePhotons || []), $e83b3346bbbc2544$var$_toConsumableArray(singleHopPhotons || []));
                    photons.forEach(function(photon, idx) {
                        var singleHop = photon.parent.__linkThreeObjType === 'singleHopPhotons';
                        if (!photon.hasOwnProperty('__progressRatio')) photon.__progressRatio = singleHop ? particleSpeed < 0 ? 1 : 0 : (idx + particleOffset) / cyclePhotons.length;
                        photon.__progressRatio += particleSpeed;
                        if (photon.__progressRatio >= 1 || photon.__progressRatio < 0) {
                            if (!singleHop) {
                                photon.__progressRatio = photon.__progressRatio % 1;
                                photon.__progressRatio < 0 && photon.__progressRatio++;
                            } else {
                                // remove particle
                                photon.parent.remove(photon);
                                $e83b3346bbbc2544$var$emptyObject(photon);
                                return;
                            }
                        }
                        var photonPosRatio = photon.__progressRatio;
                        var pos = getPhotonPos(photonPosRatio);
                        // Orient asymmetrical particles to target
                        photon.geometry.type !== 'SphereGeometry' && photon.lookAt(pos.x, pos.y, pos.z);
                        [
                            'x',
                            'y',
                            'z'
                        ].forEach(function(dim) {
                            return photon.position[dim] = pos[dim];
                        });
                    });
                });
            }
        },
        emitParticle: function emitParticle(state, link) {
            if (link && state.graphData.links.includes(link)) {
                if (!link.__singleHopPhotonsObj) {
                    var obj = new $e83b3346bbbc2544$var$three$1.Group();
                    obj.__linkThreeObjType = 'singleHopPhotons';
                    link.__singleHopPhotonsObj = obj;
                    state.graphScene.add(obj);
                }
                var particleObj = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleThreeObject)(link);
                if (particleObj && state.linkDirectionalParticleThreeObject === particleObj) // clone object if it's a shared object among all links
                particleObj = particleObj.clone();
                if (!particleObj) {
                    var particleWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleWidth);
                    var photonR = Math.ceil(particleWidthAccessor(link) * 10) / 10 / 2;
                    var numSegments = state.linkDirectionalParticleResolution;
                    var particleGeometry = new $e83b3346bbbc2544$var$three$1.SphereGeometry(photonR, numSegments, numSegments);
                    var linkColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkColor);
                    var particleColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleColor);
                    var photonColor = particleColorAccessor(link) || linkColorAccessor(link) || '#f0f0f0';
                    var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(photonColor));
                    var opacity = state.linkOpacity * 3;
                    var particleMaterial = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                        color: materialColor,
                        transparent: true,
                        opacity: opacity
                    });
                    particleObj = new $e83b3346bbbc2544$var$three$1.Mesh(particleGeometry, particleMaterial);
                }
                // add a single hop particle
                link.__singleHopPhotonsObj.add(particleObj);
            }
            return this;
        },
        getGraphBbox: function getGraphBbox(state) {
            var nodeFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                return true;
            };
            if (!state.initialised) return null;
            // recursively collect all nested geometries bboxes
            var bboxes = function getBboxes(obj) {
                var bboxes = [];
                if (obj.geometry) {
                    obj.geometry.computeBoundingBox();
                    var box = new $e83b3346bbbc2544$var$three$1.Box3();
                    box.copy(obj.geometry.boundingBox).applyMatrix4(obj.matrixWorld);
                    bboxes.push(box);
                }
                return bboxes.concat.apply(bboxes, $e83b3346bbbc2544$var$_toConsumableArray((obj.children || []).filter(function(obj) {
                    return !obj.hasOwnProperty('__graphObjType') || obj.__graphObjType === 'node' && nodeFilter(obj.__data);
                } // exclude filtered out nodes
                ).map(getBboxes)));
            }(state.graphScene);
            if (!bboxes.length) return null;
            // extract global x,y,z min/max
            return Object.assign.apply(Object, $e83b3346bbbc2544$var$_toConsumableArray([
                'x',
                'y',
                'z'
            ].map(function(c) {
                return $e83b3346bbbc2544$var$_defineProperty({}, c, [
                    (0, $02ed355deaa9e190$export$2e2bcd8739ae039)(bboxes, function(bb) {
                        return bb.min[c];
                    }),
                    (0, $5a964dca3df4eea7$export$2e2bcd8739ae039)(bboxes, function(bb) {
                        return bb.max[c];
                    })
                ]);
            })));
        }
    },
    stateInit: function stateInit() {
        return {
            d3ForceLayout: (0, $a61c6b05e92f056e$export$2e2bcd8739ae039)().force('link', (0, $b1bbf836822558b1$export$2e2bcd8739ae039)()).force('charge', (0, $78193c16de4a9cf2$export$2e2bcd8739ae039)()).force('center', (0, $38b55043e008942d$export$2e2bcd8739ae039)()).force('dagRadial', null).stop(),
            engineRunning: false
        };
    },
    init: function init(threeObj, state) {
        // Main three object to manipulate
        state.graphScene = threeObj;
        state.nodeDataMapper = new $e83b3346bbbc2544$var$ThreeDigest(threeObj, {
            objBindAttr: '__threeObj'
        });
        state.linkDataMapper = new $e83b3346bbbc2544$var$ThreeDigest(threeObj, {
            objBindAttr: '__lineObj'
        });
        state.arrowDataMapper = new $e83b3346bbbc2544$var$ThreeDigest(threeObj, {
            objBindAttr: '__arrowObj'
        });
        state.particlesDataMapper = new $e83b3346bbbc2544$var$ThreeDigest(threeObj, {
            objBindAttr: '__photonsObj'
        });
    },
    update: function update(state, changedProps) {
        var hasAnyPropChanged = function hasAnyPropChanged(propList) {
            return propList.some(function(p) {
                return changedProps.hasOwnProperty(p);
            });
        };
        state.engineRunning = false; // pause simulation
        typeof state.onUpdate === "function" && state.onUpdate();
        if (state.nodeAutoColorBy !== null && hasAnyPropChanged([
            'nodeAutoColorBy',
            'graphData',
            'nodeColor'
        ])) // Auto add color to uncolored nodes
        $e83b3346bbbc2544$var$autoColorObjects(state.graphData.nodes, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeAutoColorBy), state.nodeColor);
        if (state.linkAutoColorBy !== null && hasAnyPropChanged([
            'linkAutoColorBy',
            'graphData',
            'linkColor'
        ])) // Auto add color to uncolored links
        $e83b3346bbbc2544$var$autoColorObjects(state.graphData.links, (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkAutoColorBy), state.linkColor);
        // Digest nodes WebGL objects
        if (state._flushObjects || hasAnyPropChanged([
            'graphData',
            'nodeThreeObject',
            'nodeThreeObjectExtend',
            'nodeVal',
            'nodeColor',
            'nodeVisibility',
            'nodeRelSize',
            'nodeResolution',
            'nodeOpacity'
        ])) {
            var customObjectAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObject);
            var customObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeThreeObjectExtend);
            var valAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVal);
            var colorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeColor);
            var visibilityAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.nodeVisibility);
            var sphereGeometries = {}; // indexed by node value
            var sphereMaterials = {}; // indexed by color
            if (state._flushObjects || hasAnyPropChanged([
                // recreate objects if any of these props have changed
                'nodeThreeObject',
                'nodeThreeObjectExtend'
            ])) state.nodeDataMapper.clear();
            state.nodeDataMapper.onCreateObj(function(node) {
                var customObj = customObjectAccessor(node);
                var extendObj = customObjectExtendAccessor(node);
                if (customObj && state.nodeThreeObject === customObj) // clone object if it's a shared object among all nodes
                customObj = customObj.clone();
                var obj;
                if (customObj && !extendObj) obj = customObj;
                else {
                    // Add default object (sphere mesh)
                    obj = new $e83b3346bbbc2544$var$three$1.Mesh();
                    obj.__graphDefaultObj = true;
                    if (customObj && extendObj) obj.add(customObj); // extend default with custom
                }
                obj.__graphObjType = 'node'; // Add object type
                return obj;
            }).onUpdateObj(function(obj, node) {
                if (obj.__graphDefaultObj) {
                    // bypass internal updates for custom node objects
                    var val = valAccessor(node) || 1;
                    var radius = Math.cbrt(val) * state.nodeRelSize;
                    var numSegments = state.nodeResolution;
                    if (!obj.geometry.type.match(/^Sphere(Buffer)?Geometry$/) || obj.geometry.parameters.radius !== radius || obj.geometry.parameters.widthSegments !== numSegments) {
                        if (!sphereGeometries.hasOwnProperty(val)) sphereGeometries[val] = new $e83b3346bbbc2544$var$three$1.SphereGeometry(radius, numSegments, numSegments);
                        obj.geometry.dispose();
                        obj.geometry = sphereGeometries[val];
                    }
                    var color = colorAccessor(node);
                    var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(color || '#ffffaa'));
                    var opacity = state.nodeOpacity * $e83b3346bbbc2544$var$colorAlpha(color);
                    if (obj.material.type !== 'MeshLambertMaterial' || !obj.material.color.equals(materialColor) || obj.material.opacity !== opacity) {
                        if (!sphereMaterials.hasOwnProperty(color)) sphereMaterials[color] = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                            color: materialColor,
                            transparent: true,
                            opacity: opacity
                        });
                        obj.material.dispose();
                        obj.material = sphereMaterials[color];
                    }
                }
            }).digest(state.graphData.nodes.filter(visibilityAccessor));
        }
        // Digest links WebGL objects
        if (state._flushObjects || hasAnyPropChanged([
            'graphData',
            'linkThreeObject',
            'linkThreeObjectExtend',
            'linkMaterial',
            'linkColor',
            'linkWidth',
            'linkVisibility',
            'linkResolution',
            'linkOpacity',
            'linkDirectionalArrowLength',
            'linkDirectionalArrowColor',
            'linkDirectionalArrowResolution',
            'linkDirectionalParticles',
            'linkDirectionalParticleWidth',
            'linkDirectionalParticleColor',
            'linkDirectionalParticleResolution',
            'linkDirectionalParticleThreeObject'
        ])) {
            var _customObjectAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObject);
            var _customObjectExtendAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkThreeObjectExtend);
            var customMaterialAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkMaterial);
            var _visibilityAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkVisibility);
            var _colorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkColor);
            var widthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkWidth);
            var cylinderGeometries = {}; // indexed by link width
            var lambertLineMaterials = {}; // for cylinder objects, indexed by link color
            var basicLineMaterials = {}; // for line objects, indexed by link color
            var visibleLinks = state.graphData.links.filter(_visibilityAccessor);
            // lines digest cycle
            if (state._flushObjects || hasAnyPropChanged([
                // recreate objects if any of these props have changed
                'linkThreeObject',
                'linkThreeObjectExtend',
                'linkWidth'
            ])) state.linkDataMapper.clear();
            state.linkDataMapper.onRemoveObj(function(obj) {
                // remove trailing single photons
                var singlePhotonsObj = obj.__data && obj.__data.__singleHopPhotonsObj;
                if (singlePhotonsObj) {
                    singlePhotonsObj.parent.remove(singlePhotonsObj);
                    $e83b3346bbbc2544$var$emptyObject(singlePhotonsObj);
                    delete obj.__data.__singleHopPhotonsObj;
                }
            }).onCreateObj(function(link) {
                var customObj = _customObjectAccessor(link);
                var extendObj = _customObjectExtendAccessor(link);
                if (customObj && state.linkThreeObject === customObj) // clone object if it's a shared object among all links
                customObj = customObj.clone();
                var defaultObj;
                if (!customObj || extendObj) {
                    // construct default line obj
                    var useCylinder = !!widthAccessor(link);
                    if (useCylinder) defaultObj = new $e83b3346bbbc2544$var$three$1.Mesh();
                    else {
                        // Use plain line (constant width)
                        var lineGeometry = new $e83b3346bbbc2544$var$three$1.BufferGeometry();
                        lineGeometry[$e83b3346bbbc2544$var$setAttributeFn]('position', new $e83b3346bbbc2544$var$three$1.BufferAttribute(new Float32Array(6), 3));
                        defaultObj = new $e83b3346bbbc2544$var$three$1.Line(lineGeometry);
                    }
                }
                var obj;
                if (!customObj) {
                    obj = defaultObj;
                    obj.__graphDefaultObj = true;
                } else if (!extendObj) // use custom object
                obj = customObj;
                else {
                    // extend default with custom in a group
                    obj = new $e83b3346bbbc2544$var$three$1.Group();
                    obj.__graphDefaultObj = true;
                    obj.add(defaultObj);
                    obj.add(customObj);
                }
                obj.renderOrder = 10; // Prevent visual glitches of dark lines on top of nodes by rendering them last
                obj.__graphObjType = 'link'; // Add object type
                return obj;
            }).onUpdateObj(function(updObj, link) {
                if (updObj.__graphDefaultObj) {
                    // bypass internal updates for custom link objects
                    // select default object if it's an extended group
                    var obj = updObj.children.length ? updObj.children[0] : updObj;
                    var linkWidth = Math.ceil(widthAccessor(link) * 10) / 10;
                    var useCylinder = !!linkWidth;
                    if (useCylinder) {
                        var r = linkWidth / 2;
                        var numSegments = state.linkResolution;
                        if (!obj.geometry.type.match(/^Cylinder(Buffer)?Geometry$/) || obj.geometry.parameters.radiusTop !== r || obj.geometry.parameters.radialSegments !== numSegments) {
                            if (!cylinderGeometries.hasOwnProperty(linkWidth)) {
                                var geometry = new $e83b3346bbbc2544$var$three$1.CylinderGeometry(r, r, 1, numSegments, 1, false);
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeTranslation(0, 0.5, 0));
                                geometry[$e83b3346bbbc2544$var$applyMatrix4Fn](new $e83b3346bbbc2544$var$three$1.Matrix4().makeRotationX(Math.PI / 2));
                                cylinderGeometries[linkWidth] = geometry;
                            }
                            obj.geometry.dispose();
                            obj.geometry = cylinderGeometries[linkWidth];
                        }
                    }
                    var customMaterial = customMaterialAccessor(link);
                    if (customMaterial) obj.material = customMaterial;
                    else {
                        var color = _colorAccessor(link);
                        var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(color || '#f0f0f0'));
                        var opacity = state.linkOpacity * $e83b3346bbbc2544$var$colorAlpha(color);
                        var materialType = useCylinder ? 'MeshLambertMaterial' : 'LineBasicMaterial';
                        if (obj.material.type !== materialType || !obj.material.color.equals(materialColor) || obj.material.opacity !== opacity) {
                            var lineMaterials = useCylinder ? lambertLineMaterials : basicLineMaterials;
                            if (!lineMaterials.hasOwnProperty(color)) lineMaterials[color] = new $e83b3346bbbc2544$var$three$1[materialType]({
                                color: materialColor,
                                transparent: opacity < 1,
                                opacity: opacity,
                                depthWrite: opacity >= 1 // Prevent transparency issues
                            });
                            obj.material.dispose();
                            obj.material = lineMaterials[color];
                        }
                    }
                }
            }).digest(visibleLinks);
            // Arrows digest cycle
            if (state.linkDirectionalArrowLength || changedProps.hasOwnProperty('linkDirectionalArrowLength')) {
                var arrowLengthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowLength);
                var arrowColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalArrowColor);
                state.arrowDataMapper.onCreateObj(function() {
                    var obj = new $e83b3346bbbc2544$var$three$1.Mesh(undefined, new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                        transparent: true
                    }));
                    obj.__linkThreeObjType = 'arrow'; // Add object type
                    return obj;
                }).onUpdateObj(function(obj, link) {
                    var arrowLength = arrowLengthAccessor(link);
                    var numSegments = state.linkDirectionalArrowResolution;
                    if (!obj.geometry.type.match(/^Cone(Buffer)?Geometry$/) || obj.geometry.parameters.height !== arrowLength || obj.geometry.parameters.radialSegments !== numSegments) {
                        var coneGeometry = new $e83b3346bbbc2544$var$three$1.ConeGeometry(arrowLength * 0.25, arrowLength, numSegments);
                        // Correct orientation
                        coneGeometry.translate(0, arrowLength / 2, 0);
                        coneGeometry.rotateX(Math.PI / 2);
                        obj.geometry.dispose();
                        obj.geometry = coneGeometry;
                    }
                    var arrowColor = arrowColorAccessor(link) || _colorAccessor(link) || '#f0f0f0';
                    obj.material.color = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(arrowColor));
                    obj.material.opacity = state.linkOpacity * 3 * $e83b3346bbbc2544$var$colorAlpha(arrowColor);
                }).digest(visibleLinks.filter(arrowLengthAccessor));
            }
            // Photon particles digest cycle
            if (state.linkDirectionalParticles || changedProps.hasOwnProperty('linkDirectionalParticles')) {
                var particlesAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticles);
                var particleWidthAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleWidth);
                var particleColorAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleColor);
                var particleObjectAccessor = (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.linkDirectionalParticleThreeObject);
                var particleMaterials = {}; // indexed by link color
                var particleGeometries = {}; // indexed by particle width
                state.particlesDataMapper.onCreateObj(function() {
                    var obj = new $e83b3346bbbc2544$var$three$1.Group();
                    obj.__linkThreeObjType = 'photons'; // Add object type
                    obj.__photonDataMapper = new $e83b3346bbbc2544$var$ThreeDigest(obj);
                    return obj;
                }).onUpdateObj(function(obj, link) {
                    var curPhoton = !!obj.children.length && obj.children[0];
                    var customObj = particleObjectAccessor(link);
                    var particleGeometry, particleMaterial;
                    if (customObj) {
                        particleGeometry = customObj.geometry;
                        particleMaterial = customObj.material;
                    } else {
                        var photonR = Math.ceil(particleWidthAccessor(link) * 10) / 10 / 2;
                        var numSegments = state.linkDirectionalParticleResolution;
                        if (curPhoton && curPhoton.geometry.parameters.radius === photonR && curPhoton.geometry.parameters.widthSegments === numSegments) particleGeometry = curPhoton.geometry;
                        else {
                            if (!particleGeometries.hasOwnProperty(photonR)) particleGeometries[photonR] = new $e83b3346bbbc2544$var$three$1.SphereGeometry(photonR, numSegments, numSegments);
                            particleGeometry = particleGeometries[photonR];
                        }
                        var photonColor = particleColorAccessor(link) || _colorAccessor(link) || '#f0f0f0';
                        var materialColor = new $e83b3346bbbc2544$var$three$1.Color($e83b3346bbbc2544$var$colorStr2Hex(photonColor));
                        var opacity = state.linkOpacity * 3;
                        if (curPhoton && curPhoton.material.color.equals(materialColor) && curPhoton.material.opacity === opacity) particleMaterial = curPhoton.material;
                        else {
                            if (!particleMaterials.hasOwnProperty(photonColor)) particleMaterials[photonColor] = new $e83b3346bbbc2544$var$three$1.MeshLambertMaterial({
                                color: materialColor,
                                transparent: true,
                                opacity: opacity
                            });
                            particleMaterial = particleMaterials[photonColor];
                        }
                    }
                    if (curPhoton) {
                        // Dispose of previous particles
                        curPhoton.geometry !== particleGeometry && curPhoton.geometry.dispose();
                        curPhoton.material !== particleMaterial && curPhoton.material.dispose();
                    }
                    // digest cycle for each photon
                    var numPhotons = Math.round(Math.abs(particlesAccessor(link)));
                    obj.__photonDataMapper.id(function(d) {
                        return d.idx;
                    }).onCreateObj(function() {
                        return new $e83b3346bbbc2544$var$three$1.Mesh(particleGeometry, particleMaterial);
                    }).onUpdateObj(function(obj) {
                        obj.geometry = particleGeometry;
                        obj.material = particleMaterial;
                    }).digest($e83b3346bbbc2544$var$_toConsumableArray(new Array(numPhotons)).map(function(_, idx) {
                        return {
                            idx: idx
                        };
                    }));
                }).digest(visibleLinks.filter(particlesAccessor));
            }
        }
        state._flushObjects = false; // reset objects refresh flag
        // simulation engine
        if (hasAnyPropChanged([
            'graphData',
            'nodeId',
            'linkSource',
            'linkTarget',
            'numDimensions',
            'forceEngine',
            'dagMode',
            'dagNodeFilter',
            'dagLevelDistance'
        ])) {
            state.engineRunning = false; // Pause simulation
            // parse links
            state.graphData.links.forEach(function(link) {
                link.source = link[state.linkSource];
                link.target = link[state.linkTarget];
            });
            // Feed data to force-directed layout
            var isD3Sim = state.forceEngine !== 'ngraph';
            var layout;
            if (isD3Sim) {
                // D3-force
                (layout = state.d3ForceLayout).stop().alpha(1) // re-heat the simulation
                .numDimensions(state.numDimensions).nodes(state.graphData.nodes);
                // add links (if link force is still active)
                var linkForce = state.d3ForceLayout.force('link');
                if (linkForce) linkForce.id(function(d) {
                    return d[state.nodeId];
                }).links(state.graphData.links);
                // setup dag force constraints
                var nodeDepths = state.dagMode && $e83b3346bbbc2544$var$getDagDepths(state.graphData, function(node) {
                    return node[state.nodeId];
                }, {
                    nodeFilter: state.dagNodeFilter,
                    onLoopError: state.onDagError || undefined
                });
                var maxDepth = Math.max.apply(Math, $e83b3346bbbc2544$var$_toConsumableArray(Object.values(nodeDepths || [])));
                var dagLevelDistance = state.dagLevelDistance || state.graphData.nodes.length / (maxDepth || 1) * $e83b3346bbbc2544$var$DAG_LEVEL_NODE_RATIO * ([
                    'radialin',
                    'radialout'
                ].indexOf(state.dagMode) !== -1 ? 0.7 : 1);
                // Reset relevant f* when swapping dag modes
                if ([
                    'lr',
                    'rl',
                    'td',
                    'bu',
                    'zin',
                    'zout'
                ].includes(changedProps.dagMode)) {
                    var resetProp = [
                        'lr',
                        'rl'
                    ].includes(changedProps.dagMode) ? 'fx' : [
                        'td',
                        'bu'
                    ].includes(changedProps.dagMode) ? 'fy' : 'fz';
                    state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                        return delete node[resetProp];
                    });
                }
                // Fix nodes to x,y,z for dag mode
                if ([
                    'lr',
                    'rl',
                    'td',
                    'bu',
                    'zin',
                    'zout'
                ].includes(state.dagMode)) {
                    var invert = [
                        'rl',
                        'td',
                        'zout'
                    ].includes(state.dagMode);
                    var fixFn = function fixFn(node) {
                        return (nodeDepths[node[state.nodeId]] - maxDepth / 2) * dagLevelDistance * (invert ? -1 : 1);
                    };
                    var _resetProp = [
                        'lr',
                        'rl'
                    ].includes(state.dagMode) ? 'fx' : [
                        'td',
                        'bu'
                    ].includes(state.dagMode) ? 'fy' : 'fz';
                    state.graphData.nodes.filter(state.dagNodeFilter).forEach(function(node) {
                        return node[_resetProp] = fixFn(node);
                    });
                }
                // Use radial force for radial dags
                state.d3ForceLayout.force('dagRadial', [
                    'radialin',
                    'radialout'
                ].indexOf(state.dagMode) !== -1 ? (0, $91cad9d8ddc689ca$export$2e2bcd8739ae039)(function(node) {
                    var nodeDepth = nodeDepths[node[state.nodeId]] || -1;
                    return (state.dagMode === 'radialin' ? maxDepth - nodeDepth : nodeDepth) * dagLevelDistance;
                }).strength(function(node) {
                    return state.dagNodeFilter(node) ? 1 : 0;
                }) : null);
            } else {
                // ngraph
                var _graph = $e83b3346bbbc2544$var$ngraph.graph();
                state.graphData.nodes.forEach(function(node) {
                    _graph.addNode(node[state.nodeId]);
                });
                state.graphData.links.forEach(function(link) {
                    _graph.addLink(link.source, link.target);
                });
                layout = $e83b3346bbbc2544$var$ngraph.forcelayout(_graph, $e83b3346bbbc2544$var$_objectSpread2({
                    dimensions: state.numDimensions
                }, state.ngraphPhysics));
                layout.graph = _graph; // Attach graph reference to layout
            }
            for(var i = 0; i < state.warmupTicks && !(isD3Sim && state.d3AlphaMin > 0 && state.d3ForceLayout.alpha() < state.d3AlphaMin); i++)layout[isD3Sim ? "tick" : "step"]();
             // Initial ticks before starting to render
            state.layout = layout;
            this.resetCountdown();
        }
        state.engineRunning = true; // resume simulation
        state.onFinishUpdate();
    }
});
function $e83b3346bbbc2544$var$fromKapsule(kapsule) {
    var baseClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;
    var initKapsuleWithSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var ForceGraph = /*#__PURE__*/ function(_baseClass) {
        function ForceGraph() {
            var _this;
            $e83b3346bbbc2544$var$_classCallCheck(this, ForceGraph);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $e83b3346bbbc2544$var$_callSuper(this, ForceGraph, [].concat(args));
            _this.__kapsuleInstance = $e83b3346bbbc2544$var$_construct(kapsule, [].concat($e83b3346bbbc2544$var$_toConsumableArray(initKapsuleWithSelf ? [
                _this
            ] : []), args));
            return _this;
        }
        $e83b3346bbbc2544$var$_inherits(ForceGraph, _baseClass);
        return $e83b3346bbbc2544$var$_createClass(ForceGraph);
    }(baseClass); // attach kapsule props/methods to class prototype
    Object.keys(kapsule()).forEach(function(m) {
        return ForceGraph.prototype[m] = function() {
            var _this$__kapsuleInstan;
            var returnVal = (_this$__kapsuleInstan = this.__kapsuleInstance)[m].apply(_this$__kapsuleInstan, arguments);
            return returnVal === this.__kapsuleInstance ? this // chain based on this class, not the kapsule obj
             : returnVal;
        };
    });
    return ForceGraph;
}
var $e83b3346bbbc2544$var$three = window.THREE ? window.THREE : {
    Group: (0, $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4)
}; // Prefer consumption from global THREE, if exists
var $e83b3346bbbc2544$export$2e2bcd8739ae039 = $e83b3346bbbc2544$var$fromKapsule($e83b3346bbbc2544$var$ForceGraph, $e83b3346bbbc2544$var$three.Group, true);



/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
const $03ccd63b0299d6a7$var$refreshUniforms = [
    'alphaMap',
    'alphaTest',
    'anisotropy',
    'anisotropyMap',
    'anisotropyRotation',
    'aoMap',
    'aoMapIntensity',
    'attenuationColor',
    'attenuationDistance',
    'bumpMap',
    'clearcoat',
    'clearcoatMap',
    'clearcoatNormalMap',
    'clearcoatNormalScale',
    'clearcoatRoughness',
    'color',
    'dispersion',
    'displacementMap',
    'emissive',
    'emissiveIntensity',
    'emissiveMap',
    'envMap',
    'envMapIntensity',
    'gradientMap',
    'ior',
    'iridescence',
    'iridescenceIOR',
    'iridescenceMap',
    'iridescenceThicknessMap',
    'lightMap',
    'lightMapIntensity',
    'map',
    'matcap',
    'metalness',
    'metalnessMap',
    'normalMap',
    'normalScale',
    'opacity',
    'roughness',
    'roughnessMap',
    'sheen',
    'sheenColor',
    'sheenColorMap',
    'sheenRoughnessMap',
    'shininess',
    'specular',
    'specularColor',
    'specularColorMap',
    'specularIntensity',
    'specularIntensityMap',
    'specularMap',
    'thickness',
    'transmission',
    'transmissionMap'
];
/**
 * A WeakMap to cache lights data for node materials.
 * Cache lights data by render ID to avoid unnecessary recalculations.
 *
 * @private
 * @type {WeakMap<LightsNode,Object>}
 */ const $03ccd63b0299d6a7$var$_lightsCache = new WeakMap();
/**
 * Holds the material data for comparison.
 *
 * @private
 * @type {WeakMap<Material,Object>}
 */ const $03ccd63b0299d6a7$var$_materialCache = new WeakMap();
/**
 * Holds the geometry data for comparison.
 *
 * @private
 * @type {WeakMap<BufferGeometry,Object>}
 */ const $03ccd63b0299d6a7$var$_geometryCache = new WeakMap();
/**
 * This class is used by {@link WebGPURenderer} as management component.
 * It's primary purpose is to determine whether render objects require a
 * refresh right before they are going to be rendered or not.
 */ class $03ccd63b0299d6a7$export$4f65c0b4ff530286 {
    /**
	 * Constructs a new node material observer.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 */ constructor(builder){
        /**
		 * A node material can be used by more than one render object so the
		 * monitor must maintain a list of render objects.
		 *
		 * @type {WeakMap<RenderObject,Object>}
		 */ this.renderObjects = new WeakMap();
        /**
		 * Whether the material uses node objects or not.
		 *
		 * @type {boolean}
		 */ this.hasNode = this.containsNode(builder);
        /**
		 * Whether the node builder's 3D object is animated or not.
		 *
		 * @type {boolean}
		 */ this.hasAnimation = builder.object.isSkinnedMesh === true;
        /**
		 * A list of all possible material uniforms
		 *
		 * @type {Array<string>}
		 */ this.refreshUniforms = $03ccd63b0299d6a7$var$refreshUniforms;
        /**
		 * Holds the current render ID from the node frame.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderId = 0;
    }
    /**
	 * Returns `true` if the given render object is verified for the first time of this observer.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the given render object is verified for the first time of this observer.
	 */ firstInitialization(renderObject) {
        const hasInitialized = this.renderObjects.has(renderObject);
        if (hasInitialized === false) {
            this.getRenderObjectData(renderObject);
            return true;
        }
        return false;
    }
    /**
	 * Returns `true` if the current rendering produces motion vectors.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @return {boolean} Whether the current rendering produces motion vectors or not.
	 */ needsVelocity(renderer) {
        const mrt = renderer.getMRT();
        return mrt !== null && mrt.has('velocity');
    }
    /**
	 * Returns monitoring data for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Object} The monitoring data.
	 */ getRenderObjectData(renderObject) {
        let data = this.renderObjects.get(renderObject);
        if (data === undefined) {
            const { geometry: geometry, object: object } = renderObject;
            data = {
                geometryId: geometry.id,
                worldMatrix: object.matrixWorld.clone()
            };
            if (object.center) data.center = object.center.clone();
            if (object.morphTargetInfluences) data.morphTargetInfluences = object.morphTargetInfluences.slice();
            if (renderObject.bundle !== null) data.version = renderObject.bundle.version;
            if (renderObject.material.transmission > 0) {
                const { width: width, height: height } = renderObject.context;
                data.bufferWidth = width;
                data.bufferHeight = height;
            }
            data.lights = this.getLightsData(renderObject.lightsNode.getLights());
            this.renderObjects.set(renderObject, data);
        }
        return data;
    }
    /**
	 * Returns an attribute data structure holding the attributes versions for
	 * monitoring.
	 *
	 * @param {Object} attributes - The geometry attributes.
	 * @return {Object} An object for monitoring the versions of attributes.
	 */ getAttributesData(attributes) {
        const attributesData = {};
        for(const name in attributes){
            const attribute = attributes[name];
            attributesData[name] = {
                id: attribute.id,
                version: attribute.version
            };
        }
        return attributesData;
    }
    /**
	 * Returns `true` if the node builder's material uses
	 * node properties.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether the node builder's material uses node properties or not.
	 */ containsNode(builder) {
        const material = builder.material;
        for(const property in material){
            if (material[property] && material[property].isNode) return true;
        }
        if (builder.context.modelViewMatrix || builder.context.modelNormalViewMatrix || builder.context.getAO || builder.context.getShadow) return true;
        return false;
    }
    /**
	 * Returns a geometry data structure holding the geometry property values for
	 * monitoring.
	 *
	 * @param {BufferGeometry} geometry - The geometry.
	 * @return {Object} An object for monitoring geometry properties.
	 */ getGeometryData(geometry) {
        let data = $03ccd63b0299d6a7$var$_geometryCache.get(geometry);
        if (data === undefined) {
            data = {
                _renderId: -1,
                _equal: false,
                attributes: this.getAttributesData(geometry.attributes),
                indexId: geometry.index ? geometry.index.id : null,
                indexVersion: geometry.index ? geometry.index.version : null,
                drawRange: {
                    start: geometry.drawRange.start,
                    count: geometry.drawRange.count
                }
            };
            $03ccd63b0299d6a7$var$_geometryCache.set(geometry, data);
        }
        return data;
    }
    /**
	 * Returns a material data structure holding the material property values for
	 * monitoring.
	 *
	 * @param {Material} material - The material.
	 * @return {Object} An object for monitoring material properties.
	 */ getMaterialData(material) {
        let data = $03ccd63b0299d6a7$var$_materialCache.get(material);
        if (data === undefined) {
            data = {
                _renderId: -1,
                _equal: false
            };
            for (const property of this.refreshUniforms){
                const value = material[property];
                if (value === null || value === undefined) continue;
                if (typeof value === 'object' && value.clone !== undefined) {
                    if (value.isTexture === true) data[property] = {
                        id: value.id,
                        version: value.version
                    };
                    else data[property] = value.clone();
                } else data[property] = value;
            }
            $03ccd63b0299d6a7$var$_materialCache.set(material, data);
        }
        return data;
    }
    /**
	 * Returns `true` if the given render object has not changed its state.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Light>} lightsData - The current material lights.
	 * @param {number} renderId - The current render ID.
	 * @return {boolean} Whether the given render object has changed its state or not.
	 */ equals(renderObject, lightsData, renderId) {
        const { object: object, material: material, geometry: geometry } = renderObject;
        const renderObjectData = this.getRenderObjectData(renderObject);
        // world matrix
        if (renderObjectData.worldMatrix.equals(object.matrixWorld) !== true) {
            renderObjectData.worldMatrix.copy(object.matrixWorld);
            return false;
        }
        // material
        const materialData = this.getMaterialData(renderObject.material);
        // check the material for the "equal" state just once per render for all render objects
        if (materialData._renderId !== renderId) {
            materialData._renderId = renderId;
            for(const property in materialData){
                const value = materialData[property];
                const mtlValue = material[property];
                if (property === '_renderId') continue;
                if (property === '_equal') continue;
                if (value.equals !== undefined) {
                    if (value.equals(mtlValue) === false) {
                        value.copy(mtlValue);
                        materialData._equal = false;
                        return false;
                    }
                } else if (mtlValue.isTexture === true) {
                    if (value.id !== mtlValue.id || value.version !== mtlValue.version) {
                        value.id = mtlValue.id;
                        value.version = mtlValue.version;
                        materialData._equal = false;
                        return false;
                    }
                } else if (value !== mtlValue) {
                    materialData[property] = mtlValue;
                    materialData._equal = false;
                    return false;
                }
            }
            if (materialData.transmission > 0) {
                const { width: width, height: height } = renderObject.context;
                if (renderObjectData.bufferWidth !== width || renderObjectData.bufferHeight !== height) {
                    renderObjectData.bufferWidth = width;
                    renderObjectData.bufferHeight = height;
                    materialData._equal = false;
                    return false;
                }
            }
            materialData._equal = true;
        } else {
            if (materialData._equal === false) return false;
        }
        // geometry
        if (renderObjectData.geometryId !== geometry.id) {
            renderObjectData.geometryId = geometry.id;
            return false;
        }
        const geometryData = this.getGeometryData(renderObject.geometry);
        // check the geoemtry for the "equal" state just once per render for all render objects
        if (geometryData._renderId !== renderId) {
            geometryData._renderId = renderId;
            // attributes
            const attributes = geometry.attributes;
            const storedAttributes = geometryData.attributes;
            let currentAttributeCount = 0;
            let storedAttributeCount = 0;
            for(const _ in attributes)currentAttributeCount++; // eslint-disable-line no-unused-vars
            for(const name in storedAttributes){
                storedAttributeCount++;
                const storedAttributeData = storedAttributes[name];
                const attribute = attributes[name];
                if (attribute === undefined) {
                    // attribute was removed
                    delete storedAttributes[name];
                    geometryData._equal = false;
                    return false;
                }
                if (storedAttributeData.id !== attribute.id || storedAttributeData.version !== attribute.version) {
                    storedAttributeData.id = attribute.id;
                    storedAttributeData.version = attribute.version;
                    geometryData._equal = false;
                    return false;
                }
            }
            if (storedAttributeCount !== currentAttributeCount) {
                geometryData.attributes = this.getAttributesData(attributes);
                geometryData._equal = false;
                return false;
            }
            // check index
            const index = geometry.index;
            const storedIndexId = geometryData.indexId;
            const storedIndexVersion = geometryData.indexVersion;
            const currentIndexId = index ? index.id : null;
            const currentIndexVersion = index ? index.version : null;
            if (storedIndexId !== currentIndexId || storedIndexVersion !== currentIndexVersion) {
                geometryData.indexId = currentIndexId;
                geometryData.indexVersion = currentIndexVersion;
                geometryData._equal = false;
                return false;
            }
            // check drawRange
            if (geometryData.drawRange.start !== geometry.drawRange.start || geometryData.drawRange.count !== geometry.drawRange.count) {
                geometryData.drawRange.start = geometry.drawRange.start;
                geometryData.drawRange.count = geometry.drawRange.count;
                geometryData._equal = false;
                return false;
            }
            geometryData._equal = true;
        } else {
            if (geometryData._equal === false) return false;
        }
        // morph targets
        if (renderObjectData.morphTargetInfluences) {
            let morphChanged = false;
            for(let i = 0; i < renderObjectData.morphTargetInfluences.length; i++)if (renderObjectData.morphTargetInfluences[i] !== object.morphTargetInfluences[i]) {
                renderObjectData.morphTargetInfluences[i] = object.morphTargetInfluences[i];
                morphChanged = true;
            }
            if (morphChanged) return false;
        }
        // lights
        if (renderObjectData.lights) for(let i = 0; i < lightsData.length; i++){
            if (renderObjectData.lights[i].map !== lightsData[i].map) return false;
        }
        // center
        if (renderObjectData.center) {
            if (renderObjectData.center.equals(object.center) === false) {
                renderObjectData.center.copy(object.center);
                return true;
            }
        }
        // bundle
        if (renderObject.bundle !== null) renderObjectData.version = renderObject.bundle.version;
        return true;
    }
    /**
	 * Returns the lights data for the given material lights.
	 *
	 * @param {Array<Light>} materialLights - The material lights.
	 * @return {Array<Object>} The lights data for the given material lights.
	 */ getLightsData(materialLights) {
        const lights = [];
        for (const light of materialLights)if (light.isSpotLight === true && light.map !== null) // only add lights that have a map
        lights.push({
            map: light.map.version
        });
        return lights;
    }
    /**
	 * Returns the lights for the given lights node and render ID.
	 *
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {number} renderId - The render ID.
	 * @return {Array<Object>} The lights for the given lights node and render ID.
	 */ getLights(lightsNode, renderId) {
        if ($03ccd63b0299d6a7$var$_lightsCache.has(lightsNode)) {
            const cached = $03ccd63b0299d6a7$var$_lightsCache.get(lightsNode);
            if (cached.renderId === renderId) return cached.lightsData;
        }
        const lightsData = this.getLightsData(lightsNode.getLights());
        $03ccd63b0299d6a7$var$_lightsCache.set(lightsNode, {
            renderId: renderId,
            lightsData: lightsData
        });
        return lightsData;
    }
    /**
	 * Checks if the given render object requires a refresh.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {NodeFrame} nodeFrame - The current node frame.
	 * @return {boolean} Whether the given render object requires a refresh or not.
	 */ needsRefresh(renderObject, nodeFrame) {
        if (this.hasNode || this.hasAnimation || this.firstInitialization(renderObject) || this.needsVelocity(nodeFrame.renderer)) return true;
        const { renderId: renderId } = nodeFrame;
        if (this.renderId !== renderId) {
            this.renderId = renderId;
            return true;
        }
        const isStatic = renderObject.object.static === true;
        const isBundle = renderObject.bundle !== null && renderObject.bundle.static === true && this.getRenderObjectData(renderObject).version === renderObject.bundle.version;
        if (isStatic || isBundle) return false;
        const lightsData = this.getLights(renderObject.lightsNode, renderId);
        const notEqual = this.equals(renderObject, lightsData, renderId) !== true;
        return notEqual;
    }
}
// Pre-compiled RegExp patterns for ignored files
const $03ccd63b0299d6a7$var$IGNORED_FILES = [
    /^StackTrace\.js$/,
    /^TSLCore\.js$/,
    /^.*Node\.js$/,
    /^three\.webgpu.*\.js$/
];
/**
 * Parses the stack trace and filters out ignored files.
 * Returns an array with function name, file, line, and column.
 */ function $03ccd63b0299d6a7$var$getFilteredStack(stack) {
    // Pattern to extract function name, file, line, and column from different browsers
    // Chrome: "at functionName (file.js:1:2)" or "at file.js:1:2"
    // Firefox: "functionName@file.js:1:2"
    const regex = /(?:at\s+(.+?)\s+\()?(?:(.+?)@)?([^@\s()]+):(\d+):(\d+)/;
    return stack.split('\n').map((line)=>{
        const match = line.match(regex);
        if (!match) return null; // Skip if line format is invalid
        // Chrome: match[1], Firefox: match[2]
        const fn = match[1] || match[2] || '';
        const file = match[3].split('?')[0]; // Clean file name (Vite/HMR)
        const lineNum = parseInt(match[4], 10);
        const column = parseInt(match[5], 10);
        // Extract only the filename from full path
        const fileName = file.split('/').pop();
        return {
            fn: fn,
            file: fileName,
            line: lineNum,
            column: column
        };
    }).filter((frame)=>{
        // Only keep frames that are valid and not in the ignore list
        return frame && !$03ccd63b0299d6a7$var$IGNORED_FILES.some((regex)=>regex.test(frame.file));
    });
}
/**
 * Class representing a stack trace for debugging purposes.
 */ class $03ccd63b0299d6a7$export$d540ba6c994dd81c {
    /**
	 * Creates a StackTrace instance by capturing and filtering the current stack trace.
	 *
	 * @param {Error|string|null} stackMessage - An optional stack trace to use instead of capturing a new one.
	 */ constructor(stackMessage = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStackTrace = true;
        /**
		 * The stack trace.
		 *
		 * @type {Array<{fn: string, file: string, line: number, column: number}>}
		 */ this.stack = $03ccd63b0299d6a7$var$getFilteredStack(stackMessage ? stackMessage : new Error().stack);
    }
    /**
	 * Returns a formatted location string of the top stack frame.
	 *
	 * @returns {string} The formatted stack trace message.
	 */ getLocation() {
        if (this.stack.length === 0) return '[Unknown location]';
        const mainStack = this.stack[0];
        const fn = mainStack.fn;
        const fnName = fn ? `"${fn}()" at ` : '';
        return `${fnName}"${mainStack.file}:${mainStack.line}"`; // :${mainStack.column}
    }
    /**
	 * Returns the full error message including the stack trace.
	 *
	 * @param {string} message - The error message.
	 * @returns {string} The full error message with stack trace.
	 */ getError(message) {
        if (this.stack.length === 0) return message;
        // Output: "Error: message\n    at functionName (file.js:line:column)"
        const stackString = this.stack.map((frame)=>{
            const location = `${frame.file}:${frame.line}:${frame.column}`;
            if (frame.fn) return `    at ${frame.fn} (${location})`;
            return `    at ${location}`;
        }).join('\n');
        return `${message}\n${stackString}`;
    }
}
// cyrb53 (c) 2018 bryc (github.com/bryc). License: Public domain. Attribution appreciated.
// A fast and simple 64-bit (or 53-bit) string hash function with decent collision resistance.
// Largely inspired by MurmurHash2/3, but with a focus on speed/simplicity.
// See https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript/52171480#52171480
// https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
function $03ccd63b0299d6a7$var$cyrb53(value, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    if (Array.isArray(value)) for(let i = 0, val; i < value.length; i++){
        val = value[i];
        h1 = Math.imul(h1 ^ val, 2654435761);
        h2 = Math.imul(h2 ^ val, 1597334677);
    }
    else for(let i = 0, ch; i < value.length; i++){
        ch = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
/**
 * Computes a hash for the given string.
 *
 * @private
 * @method
 * @param {string} str - The string to be hashed.
 * @return {number} The hash.
 */ const $03ccd63b0299d6a7$var$hashString = (str)=>$03ccd63b0299d6a7$var$cyrb53(str);
/**
 * Computes a hash for the given array.
 *
 * @private
 * @method
 * @param {Array<number>} array - The array to be hashed.
 * @return {number} The hash.
 */ const $03ccd63b0299d6a7$var$hashArray = (array)=>$03ccd63b0299d6a7$var$cyrb53(array);
/**
 * Computes a hash for the given list of parameters.
 *
 * @private
 * @method
 * @param {...number} params - A list of parameters.
 * @return {number} The hash.
 */ const $03ccd63b0299d6a7$var$hash$1 = (...params)=>$03ccd63b0299d6a7$var$cyrb53(params);
const $03ccd63b0299d6a7$var$typeFromLength = /*@__PURE__*/ new Map([
    [
        1,
        'float'
    ],
    [
        2,
        'vec2'
    ],
    [
        3,
        'vec3'
    ],
    [
        4,
        'vec4'
    ],
    [
        9,
        'mat3'
    ],
    [
        16,
        'mat4'
    ]
]);
const $03ccd63b0299d6a7$var$dataFromObject = /*@__PURE__*/ new WeakMap();
/**
 * Returns the data type for the given the length.
 *
 * @private
 * @method
 * @param {number} length - The length.
 * @return {string} The data type.
 */ function $03ccd63b0299d6a7$var$getTypeFromLength(length) {
    return $03ccd63b0299d6a7$var$typeFromLength.get(length);
}
/**
 * Returns the typed array for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {TypedArray} The typed array.
 */ function $03ccd63b0299d6a7$var$getTypedArrayFromType(type) {
    // Handle component type for vectors and matrices
    if (/[iu]?vec\d/.test(type)) {
        // Handle int vectors
        if (type.startsWith('ivec')) return Int32Array;
        // Handle uint vectors
        if (type.startsWith('uvec')) return Uint32Array;
        // Default to float vectors
        return Float32Array;
    }
    // Handle matrices (always float)
    if (/mat\d/.test(type)) return Float32Array;
    // Basic types
    if (/float/.test(type)) return Float32Array;
    if (/uint/.test(type)) return Uint32Array;
    if (/int/.test(type)) return Int32Array;
    throw new Error(`THREE.NodeUtils: Unsupported type: ${type}`);
}
/**
 * Returns the length for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The length.
 */ function $03ccd63b0299d6a7$var$getLengthFromType(type) {
    if (/float|int|uint/.test(type)) return 1;
    if (/vec2/.test(type)) return 2;
    if (/vec3/.test(type)) return 3;
    if (/vec4/.test(type)) return 4;
    if (/mat2/.test(type)) return 4;
    if (/mat3/.test(type)) return 9;
    if (/mat4/.test(type)) return 16;
    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Unsupported type: ${type}`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
}
/**
 * Returns the gpu memory length for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The length.
 */ function $03ccd63b0299d6a7$var$getMemoryLengthFromType(type) {
    if (/float|int|uint/.test(type)) return 1;
    if (/vec2/.test(type)) return 2;
    if (/vec3/.test(type)) return 3;
    if (/vec4/.test(type)) return 4;
    if (/mat2/.test(type)) return 4;
    if (/mat3/.test(type)) return 12;
    if (/mat4/.test(type)) return 16;
    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Unsupported type: ${type}`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
}
/**
 * Returns the alignment requirement for the given data type.
 *
 * @private
 * @method
 * @param {string} type - The data type.
 * @return {number} The alignment requirement in bytes.
 */ function $03ccd63b0299d6a7$var$getAlignmentFromType(type) {
    if (/float|int|uint/.test(type)) return 4;
    if (/vec2/.test(type)) return 8;
    if (/vec3/.test(type)) return 16;
    if (/vec4/.test(type)) return 16;
    if (/mat2/.test(type)) return 8;
    if (/mat3/.test(type)) return 16;
    if (/mat4/.test(type)) return 16;
    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Unsupported type: ${type}`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
}
/**
 * Returns the data type for the given value.
 *
 * @private
 * @method
 * @param {any} value - The value.
 * @return {?string} The data type.
 */ function $03ccd63b0299d6a7$var$getValueType(value) {
    if (value === undefined || value === null) return null;
    const typeOf = typeof value;
    if (value.isNode === true) return 'node';
    else if (typeOf === 'number') return 'float';
    else if (typeOf === 'boolean') return 'bool';
    else if (typeOf === 'string') return 'string';
    else if (typeOf === 'function') return 'shader';
    else if (value.isVector2 === true) return 'vec2';
    else if (value.isVector3 === true) return 'vec3';
    else if (value.isVector4 === true) return 'vec4';
    else if (value.isMatrix2 === true) return 'mat2';
    else if (value.isMatrix3 === true) return 'mat3';
    else if (value.isMatrix4 === true) return 'mat4';
    else if (value.isColor === true) return 'color';
    else if (value instanceof ArrayBuffer) return 'ArrayBuffer';
    return null;
}
/**
 * Returns the value/object for the given data type and parameters.
 *
 * @private
 * @method
 * @param {string} type - The given type.
 * @param {...any} params - A parameter list.
 * @return {any} The value/object.
 */ function $03ccd63b0299d6a7$var$getValueFromType(type, ...params) {
    const last4 = type ? type.slice(-4) : undefined;
    if (params.length === 1) {
        if (last4 === 'vec2') params = [
            params[0],
            params[0]
        ];
        else if (last4 === 'vec3') params = [
            params[0],
            params[0],
            params[0]
        ];
        else if (last4 === 'vec4') params = [
            params[0],
            params[0],
            params[0],
            params[0]
        ];
    }
    if (type === 'color') return new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(...params);
    else if (last4 === 'vec2') return new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(...params);
    else if (last4 === 'vec3') return new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(...params);
    else if (last4 === 'vec4') return new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(...params);
    else if (last4 === 'mat2') return new (0, $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38)(...params);
    else if (last4 === 'mat3') return new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)(...params);
    else if (last4 === 'mat4') return new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)(...params);
    else if (type === 'bool') return params[0] || false;
    else if (type === 'float' || type === 'int' || type === 'uint') return params[0] || 0;
    else if (type === 'string') return params[0] || '';
    else if (type === 'ArrayBuffer') return $03ccd63b0299d6a7$var$base64ToArrayBuffer(params[0]);
    return null;
}
/**
 * Gets the object data that can be shared between different rendering steps.
 *
 * @private
 * @param {Object} object - The object to get the data for.
 * @return {Object} The object data.
 */ function $03ccd63b0299d6a7$var$getDataFromObject(object) {
    let data = $03ccd63b0299d6a7$var$dataFromObject.get(object);
    if (data === undefined) {
        data = {};
        $03ccd63b0299d6a7$var$dataFromObject.set(object, data);
    }
    return data;
}
/**
 * Converts the given array buffer to a Base64 string.
 *
 * @private
 * @method
 * @param {ArrayBuffer} arrayBuffer - The array buffer.
 * @return {string} The Base64 string.
 */ function $03ccd63b0299d6a7$var$arrayBufferToBase64(arrayBuffer) {
    let chars = '';
    const array = new Uint8Array(arrayBuffer);
    for(let i = 0; i < array.length; i++)chars += String.fromCharCode(array[i]);
    return btoa(chars);
}
/**
 * Converts the given Base64 string to an array buffer.
 *
 * @private
 * @method
 * @param {string} base64 - The Base64 string.
 * @return {ArrayBuffer} The array buffer.
 */ function $03ccd63b0299d6a7$var$base64ToArrayBuffer(base64) {
    return Uint8Array.from(atob(base64), (c)=>c.charCodeAt(0)).buffer;
}
var $03ccd63b0299d6a7$export$78670c1cacf147e6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    arrayBufferToBase64: $03ccd63b0299d6a7$var$arrayBufferToBase64,
    base64ToArrayBuffer: $03ccd63b0299d6a7$var$base64ToArrayBuffer,
    getAlignmentFromType: $03ccd63b0299d6a7$var$getAlignmentFromType,
    getDataFromObject: $03ccd63b0299d6a7$var$getDataFromObject,
    getLengthFromType: $03ccd63b0299d6a7$var$getLengthFromType,
    getMemoryLengthFromType: $03ccd63b0299d6a7$var$getMemoryLengthFromType,
    getTypeFromLength: $03ccd63b0299d6a7$var$getTypeFromLength,
    getTypedArrayFromType: $03ccd63b0299d6a7$var$getTypedArrayFromType,
    getValueFromType: $03ccd63b0299d6a7$var$getValueFromType,
    getValueType: $03ccd63b0299d6a7$var$getValueType,
    hash: $03ccd63b0299d6a7$var$hash$1,
    hashArray: $03ccd63b0299d6a7$var$hashArray,
    hashString: $03ccd63b0299d6a7$var$hashString
});
/**
 * Possible shader stages.
 *
 * @property {string} VERTEX The vertex shader stage.
 * @property {string} FRAGMENT The fragment shader stage.
 */ const $03ccd63b0299d6a7$export$9e43649cde3e3072 = {
    VERTEX: 'vertex',
    FRAGMENT: 'fragment'
};
/**
 * Update types of a node.
 *
 * @property {string} NONE The update method is not executed.
 * @property {string} FRAME The update method is executed per frame.
 * @property {string} RENDER The update method is executed per render. A frame might be produced by multiple render calls so this value allows more detailed updates than FRAME.
 * @property {string} OBJECT The update method is executed per {@link Object3D} that uses the node for rendering.
 */ const $03ccd63b0299d6a7$export$26f7a8bbd9469530 = {
    NONE: 'none',
    FRAME: 'frame',
    RENDER: 'render',
    OBJECT: 'object'
};
/**
 * Data types of a node.
 *
 * @property {string} BOOLEAN Boolean type.
 * @property {string} INTEGER Integer type.
 * @property {string} FLOAT Float type.
 * @property {string} VECTOR2 Two-dimensional vector type.
 * @property {string} VECTOR3 Three-dimensional vector type.
 * @property {string} VECTOR4 Four-dimensional vector type.
 * @property {string} MATRIX2 2x2 matrix type.
 * @property {string} MATRIX3 3x3 matrix type.
 * @property {string} MATRIX4 4x4 matrix type.
 */ const $03ccd63b0299d6a7$export$f06e977173f1857c = {
    BOOLEAN: 'bool',
    INTEGER: 'int',
    FLOAT: 'float',
    VECTOR2: 'vec2',
    VECTOR3: 'vec3',
    VECTOR4: 'vec4',
    MATRIX2: 'mat2',
    MATRIX3: 'mat3',
    MATRIX4: 'mat4'
};
/**
 * Access types of a node. These are relevant for compute and storage usage.
 *
 * @property {string} READ_ONLY Read-only access
 * @property {string} WRITE_ONLY Write-only access.
 * @property {string} READ_WRITE Read and write access.
 */ const $03ccd63b0299d6a7$export$92538c74c63a703d = {
    READ_ONLY: 'readOnly',
    WRITE_ONLY: 'writeOnly',
    READ_WRITE: 'readWrite'
};
const $03ccd63b0299d6a7$export$565139d2263e2965 = [
    'fragment',
    'vertex'
];
const $03ccd63b0299d6a7$export$f2213ed98eb895d6 = [
    'setup',
    'analyze',
    'generate'
];
const $03ccd63b0299d6a7$export$48fd793f0255b86a = [
    ...$03ccd63b0299d6a7$export$565139d2263e2965,
    'compute'
];
const $03ccd63b0299d6a7$export$1c0adcb9073b646d = [
    'x',
    'y',
    'z',
    'w'
];
const $03ccd63b0299d6a7$var$_parentBuildStage = {
    analyze: 'setup',
    generate: 'analyze'
};
let $03ccd63b0299d6a7$var$_nodeId = 0;
/**
 * Base class for all nodes.
 *
 * @augments EventDispatcher
 */ class $03ccd63b0299d6a7$export$85c928794f8d04d4 extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    static get type() {
        return 'Node';
    }
    /**
	 * Constructs a new node.
	 *
	 * @param {?string} nodeType - The node type.
	 */ constructor(nodeType = null){
        super();
        /**
		 * The node type. This represents the result type of the node (e.g. `float` or `vec3`).
		 *
		 * @type {?string}
		 * @default null
		 */ this.nodeType = nodeType;
        /**
		 * The update type of the node's {@link Node#update} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
        /**
		 * The update type of the node's {@link Node#updateBefore} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
        /**
		 * The update type of the node's {@link Node#updateAfter} method. Possible values are listed in {@link NodeUpdateType}.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateAfterType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
        /**
		 * The version of the node. The version automatically is increased when {@link Node#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * The name of the node.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * Whether this node is global or not. This property is relevant for the internal
		 * node caching system. All nodes which should be declared just once should
		 * set this flag to `true` (a typical example is {@link AttributeNode}).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.global = false;
        /**
		 * Create a list of parents for this node during the build process.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.parents = false;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNode = true;
        // private
        this._beforeNodes = null;
        /**
		 * The cache key of this node.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._cacheKey = null;
        /**
		 * The UUID of the node.
		 *
		 * @type {string}
		 * @default null
		 * @private
		 */ this._uuid = null;
        /**
		 * The cache key's version.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cacheKeyVersion = 0;
        /**
		 * The unique ID of the node.
		 *
		 * @type {number}
		 * @readonly
		 */ this.id = $03ccd63b0299d6a7$var$_nodeId++;
        /**
		 * The stack trace of the node for debugging purposes.
		 *
		 * @type {?string}
		 * @default null
		 */ this.stackTrace = null;
        if ($03ccd63b0299d6a7$export$85c928794f8d04d4.captureStackTrace === true) this.stackTrace = new $03ccd63b0299d6a7$export$d540ba6c994dd81c();
    }
    /**
	 * Set this property to `true` when the node should be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * The UUID of the node.
	 *
	 * @type {string}
	 * @readonly
	 */ get uuid() {
        if (this._uuid === null) this._uuid = (0, $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07).generateUUID();
        return this._uuid;
    }
    /**
	 * The type of the class. The value is usually the constructor name.
	 *
	 * @type {string}
 	 * @readonly
	 */ get type() {
        return this.constructor.type;
    }
    /**
	 * Convenient method for defining {@link Node#update}.
	 *
	 * @param {Function} callback - The update method.
	 * @param {string} updateType - The update type.
	 * @return {Node} A reference to this node.
	 */ onUpdate(callback, updateType) {
        this.updateType = updateType;
        this.update = callback.bind(this);
        return this;
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `FRAME`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onFrameUpdate(callback) {
        return this.onUpdate(callback, $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME);
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `RENDER`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onRenderUpdate(callback) {
        return this.onUpdate(callback, $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER);
    }
    /**
	 * Convenient method for defining {@link Node#update}. Similar to {@link Node#onUpdate}, but
	 * this method automatically sets the update type to `OBJECT`.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onObjectUpdate(callback) {
        return this.onUpdate(callback, $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT);
    }
    /**
	 * Convenient method for defining {@link Node#updateReference}.
	 *
	 * @param {Function} callback - The update method.
	 * @return {Node} A reference to this node.
	 */ onReference(callback) {
        this.updateReference = callback.bind(this);
        return this;
    }
    /**
	 * Nodes might refer to other objects like materials. This method allows to dynamically update the reference
	 * to such objects based on a given state (e.g. the current node frame or builder).
	 *
	 * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
	 * @return {any} The updated reference.
	 */ updateReference() {
        return this;
    }
    /**
	 * By default this method returns the value of the {@link Node#global} flag. This method
	 * can be overwritten in derived classes if an analytical way is required to determine the
	 * global cache referring to the current shader-stage.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether this node is global or not.
	 */ isGlobal() {
        return this.global;
    }
    /**
	 * Generator function that can be used to iterate over the child nodes.
	 *
	 * @generator
	 * @yields {Node} A child node.
	 */ *getChildren() {
        for (const { childNode: childNode } of this._getChildren())yield childNode;
    }
    /**
	 * Calling this method dispatches the `dispose` event. This event can be used
	 * to register event listeners for clean up tasks.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Callback for {@link Node#traverse}.
	 *
	 * @callback traverseCallback
	 * @param {Node} node - The current node.
	 */ /**
	 * Can be used to traverse through the node's hierarchy.
	 *
	 * @param {traverseCallback} callback - A callback that is executed per node.
	 */ traverse(callback) {
        callback(this);
        for (const childNode of this.getChildren())childNode.traverse(callback);
    }
    /**
	 * Returns the child nodes of this node.
	 *
	 * @private
	 * @param {Set<Node>} [ignores=new Set()] - A set of nodes to ignore during the search to avoid circular references.
	 * @returns {Array<Object>} An array of objects describing the child nodes.
	 */ _getChildren(ignores = new Set()) {
        const children = [];
        // avoid circular references
        ignores.add(this);
        for (const property of Object.getOwnPropertyNames(this)){
            const object = this[property];
            // Ignore private properties and ignored nodes.
            if (property.startsWith('_') === true || ignores.has(object)) continue;
            if (Array.isArray(object) === true) for(let i = 0; i < object.length; i++){
                const child = object[i];
                if (child && child.isNode === true) children.push({
                    property: property,
                    index: i,
                    childNode: child
                });
            }
            else if (object && object.isNode === true) children.push({
                property: property,
                childNode: object
            });
            else if (object && Object.getPrototypeOf(object) === Object.prototype) for(const subProperty in object){
                // Ignore private sub-properties.
                if (subProperty.startsWith('_') === true) continue;
                const child = object[subProperty];
                if (child && child.isNode === true) children.push({
                    property: property,
                    index: subProperty,
                    childNode: child
                });
            }
        }
        //
        return children;
    }
    /**
	 * Returns the cache key for this node.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of the cache key is forced.
	 * @param {Set<Node>} [ignores=null] - A set of nodes to ignore during the computation of the cache key.
	 * @return {number} The cache key of the node.
	 */ getCacheKey(force = false, ignores = null) {
        force = force || this.version !== this._cacheKeyVersion;
        if (force === true || this._cacheKey === null) {
            if (ignores === null) ignores = new Set();
            //
            const values = [];
            for (const { property: property, childNode: childNode } of this._getChildren(ignores))values.push($03ccd63b0299d6a7$var$hashString(property.slice(0, -4)), childNode.getCacheKey(force, ignores));
            //
            this._cacheKey = $03ccd63b0299d6a7$var$hash$1($03ccd63b0299d6a7$var$hashArray(values), this.customCacheKey());
            this._cacheKeyVersion = this.version;
        }
        return this._cacheKey;
    }
    /**
	 * Generate a custom cache key for this node.
	 *
	 * @return {number} The cache key of the node.
	 */ customCacheKey() {
        return this.id;
    }
    /**
	 * Returns the references to this node which is by default `this`.
	 *
	 * @return {Node} A reference to this node.
	 */ getScope() {
        return this;
    }
    /**
	 * Returns the hash of the node which is used to identify the node. By default it's
	 * the {@link Node#uuid} however derived node classes might have to overwrite this method
	 * depending on their implementation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash() {
        return String(this.id);
    }
    /**
	 * Returns the update type of {@link Node#update}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateType() {
        return this.updateType;
    }
    /**
	 * Returns the update type of {@link Node#updateBefore}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateBeforeType() {
        return this.updateBeforeType;
    }
    /**
	 * Returns the update type of {@link Node#updateAfter}.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateAfterType() {
        return this.updateAfterType;
    }
    /**
	 * Certain types are composed of multiple elements. For example a `vec3`
	 * is composed of three `float` values. This method returns the type of
	 * these elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getElementType(builder) {
        const type = this.getNodeType(builder);
        const elementType = builder.getElementType(type);
        return elementType;
    }
    /**
	 * Returns the node member type for the given name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the node.
	 */ getMemberType() {
        return 'void';
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} [output=null] - The output of the node.
	 * @return {string} The type of the node.
	 */ getNodeType(builder, output = null) {
        const nodeData = builder.getDataFromNode(this);
        let type;
        if (output !== null) {
            nodeData.typeFromOutput = nodeData.typeFromOutput || {};
            type = nodeData.typeFromOutput[output];
            if (type === undefined) {
                type = this.generateNodeType(builder, output);
                nodeData.typeFromOutput[output] = type;
            }
        } else {
            type = nodeData.type;
            if (type === undefined) {
                type = this.generateNodeType(builder);
                nodeData.type = type;
            }
        }
        return type;
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} [output=null] - The output of the node.
	 * @return {string} The type of the node.
	 */ generateNodeType(builder, output = null) {
        const nodeProperties = builder.getNodeProperties(this);
        if (nodeProperties.outputNode) return nodeProperties.outputNode.getNodeType(builder, output);
        return this.nodeType;
    }
    /**
	 * This method is used during the build process of a node and ensures
	 * equal nodes are not built multiple times but just once. For example if
	 * `attribute( 'uv' )` is used multiple times by the user, the build
	 * process makes sure to process just the first node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The shared node if possible. Otherwise `this` is returned.
	 */ getShared(builder) {
        const hash = this.getHash(builder);
        const nodeFromHash = builder.getNodeFromHash(hash);
        return nodeFromHash || this;
    }
    /**
	 * Returns the number of elements in the node array.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?number} The number of elements in the node array.
	 */ getArrayCount() {
        return null;
    }
    /**
	 * Represents the setup stage which is the first step of the build process, see {@link Node#build} method.
	 * This method is often overwritten in derived modules to prepare the node which is used as a node's output/result.
	 * If an output node is prepared, then it must be returned in the `return` statement of the derived module's setup function.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?Node} The output node.
	 */ setup(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        let index = 0;
        for (const childNode of this.getChildren())nodeProperties['node' + index++] = childNode;
        // return a outputNode if exists or null
        return nodeProperties.outputNode || null;
    }
    /**
	 * Represents the analyze stage which is the second step of the build process, see {@link Node#build} method.
	 * This stage analyzes the node hierarchy and ensures descendent nodes are built.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?Node} output - The target output node.
	 */ analyze(builder, output = null) {
        const usageCount = builder.increaseUsage(this);
        if (this.parents === true) {
            const nodeData = builder.getDataFromNode(this, 'any');
            nodeData.stages = nodeData.stages || {};
            nodeData.stages[builder.shaderStage] = nodeData.stages[builder.shaderStage] || [];
            nodeData.stages[builder.shaderStage].push(output);
        }
        if (usageCount === 1) {
            // node flow children
            const nodeProperties = builder.getNodeProperties(this);
            for (const childNode of Object.values(nodeProperties))if (childNode && childNode.isNode === true) childNode.build(builder, this);
        }
    }
    /**
	 * Represents the generate stage which is the third step of the build process, see {@link Node#build} method.
	 * This state builds the output node and returns the resulting shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?string} [output] - Can be used to define the output type.
	 * @return {?string} The generated shader string.
	 */ generate(builder, output) {
        const { outputNode: outputNode } = builder.getNodeProperties(this);
        if (outputNode && outputNode.isNode === true) return outputNode.build(builder, output);
    }
    /**
	 * The method can be implemented to update the node's internal state before it is used to render an object.
	 * The {@link Node#updateBeforeType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ updateBefore() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * The method can be implemented to update the node's internal state after it was used to render an object.
	 * The {@link Node#updateAfterType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ updateAfter() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * The method can be implemented to update the node's internal state when it is used to render an object.
	 * The {@link Node#updateType} property defines how often the update is executed.
	 *
	 * @abstract
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 * @return {?boolean} An optional bool that indicates whether the implementation actually performed an update or not (e.g. due to caching).
	 */ update() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    before(node) {
        if (this._beforeNodes === null) this._beforeNodes = [];
        this._beforeNodes.push(node);
        return this;
    }
    /**
	 * This method performs the build of a node. The behavior and return value depend on the current build stage:
	 * - **setup**: Prepares the node and its children for the build process. This process can also create new nodes. Returns the node itself or a variant.
	 * - **analyze**: Analyzes the node hierarchy for optimizations in the code generation stage. Returns `null`.
	 * - **generate**: Generates the shader code for the node. Returns the generated shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?(string|Node)} [output=null] - Can be used to define the output type.
	 * @return {?(Node|string)} The result of the build process, depending on the build stage.
	 */ build(builder, output = null) {
        const refNode = this.getShared(builder);
        if (this !== refNode) return refNode.build(builder, output);
        //
        if (this._beforeNodes !== null) {
            const currentBeforeNodes = this._beforeNodes;
            this._beforeNodes = null;
            for (const beforeNode of currentBeforeNodes)beforeNode.build(builder, output);
            this._beforeNodes = currentBeforeNodes;
        }
        //
        const nodeData = builder.getDataFromNode(this);
        nodeData.buildStages = nodeData.buildStages || {};
        nodeData.buildStages[builder.buildStage] = true;
        const parentBuildStage = $03ccd63b0299d6a7$var$_parentBuildStage[builder.buildStage];
        if (parentBuildStage && nodeData.buildStages[parentBuildStage] !== true) {
            // force parent build stage (setup or analyze)
            const previousBuildStage = builder.getBuildStage();
            builder.setBuildStage(parentBuildStage);
            this.build(builder);
            builder.setBuildStage(previousBuildStage);
        }
        //
        builder.addChain(this);
        /* Build stages expected results:
			- "setup"		-> Node
			- "analyze"		-> null
			- "generate"	-> String
		*/ let result = null;
        const buildStage = builder.getBuildStage();
        if (buildStage === 'setup') {
            builder.addNode(this);
            this.updateReference(builder);
            const properties = builder.getNodeProperties(this);
            if (properties.initialized !== true) {
                //const stackNodesBeforeSetup = builder.stack.nodes.length;
                properties.initialized = true;
                properties.outputNode = this.setup(builder) || properties.outputNode || null;
                /*if ( isNodeOutput && builder.stack.nodes.length !== stackNodesBeforeSetup ) {

					// !! no outputNode !!
					//outputNode = builder.stack;

				}*/ for (const childNode of Object.values(properties))if (childNode && childNode.isNode === true) {
                    if (childNode.parents === true) {
                        const childProperties = builder.getNodeProperties(childNode);
                        childProperties.parents = childProperties.parents || [];
                        childProperties.parents.push(this);
                    }
                    childNode.build(builder);
                }
                builder.addSequentialNode(this);
            }
            result = properties.outputNode;
        } else if (buildStage === 'analyze') this.analyze(builder, output);
        else if (buildStage === 'generate') {
            // If generate has just one argument, it means the output type is not required.
            // This means that the node does not handle output conversions internally,
            // so the value is stored in a cache and the builder handles the conversion
            // for all requested output types.
            const isGenerateOnce = this.generate.length < 2;
            if (isGenerateOnce) {
                const type = this.getNodeType(builder);
                const nodeData = builder.getDataFromNode(this);
                result = nodeData.snippet;
                if (result === undefined) {
                    if (nodeData.generated === undefined) {
                        nodeData.generated = true;
                        result = this.generate(builder) || '';
                        nodeData.snippet = result;
                    } else {
                        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Node: Recursion detected.', this);
                        result = '/* Recursion detected. */';
                    }
                } else if (nodeData.flowCodes !== undefined && builder.context.nodeBlock !== undefined) builder.addFlowCodeHierarchy(this, builder.context.nodeBlock);
                result = builder.format(result, type, output);
            } else result = this.generate(builder, output) || '';
            if (result === '' && output !== null && output !== 'void' && output !== 'OutputType') {
                // if no snippet is generated, return a default value
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Invalid generated code, expected a "${output}".`);
                result = builder.generateConst(output);
            }
        }
        builder.removeChain(this);
        return result;
    }
    /**
	 * Returns the child nodes as a JSON object.
	 *
	 * @return {Generator<Object>} An iterable list of serialized child objects as JSON.
	 */ getSerializeChildren() {
        return this._getChildren();
    }
    /**
	 * Serializes the node to JSON.
	 *
	 * @param {Object} json - The output JSON object.
	 */ serialize(json) {
        const nodeChildren = this.getSerializeChildren();
        const inputNodes = {};
        for (const { property: property, index: index, childNode: childNode } of nodeChildren)if (index !== undefined) {
            if (inputNodes[property] === undefined) inputNodes[property] = Number.isInteger(index) ? [] : {};
            inputNodes[property][index] = childNode.toJSON(json.meta).uuid;
        } else inputNodes[property] = childNode.toJSON(json.meta).uuid;
        if (Object.keys(inputNodes).length > 0) json.inputNodes = inputNodes;
    }
    /**
	 * Deserializes the node from the given JSON.
	 *
	 * @param {Object} json - The JSON object.
	 */ deserialize(json) {
        if (json.inputNodes !== undefined) {
            const nodes = json.meta.nodes;
            for(const property in json.inputNodes){
                if (Array.isArray(json.inputNodes[property])) {
                    const inputArray = [];
                    for (const uuid of json.inputNodes[property])inputArray.push(nodes[uuid]);
                    this[property] = inputArray;
                } else if (typeof json.inputNodes[property] === 'object') {
                    const inputObject = {};
                    for(const subProperty in json.inputNodes[property]){
                        const uuid = json.inputNodes[property][subProperty];
                        inputObject[subProperty] = nodes[uuid];
                    }
                    this[property] = inputObject;
                } else {
                    const uuid = json.inputNodes[property];
                    this[property] = nodes[uuid];
                }
            }
        }
    }
    /**
	 * Serializes the node into the three.js JSON Object/Scene format.
	 *
	 * @param {?Object} meta - An optional JSON object that already holds serialized data from other scene objects.
	 * @return {Object} The serialized node.
	 */ toJSON(meta) {
        const { uuid: uuid, type: type } = this;
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        // serialize
        let data = meta.nodes[uuid];
        if (data === undefined) {
            data = {
                uuid: uuid,
                type: type,
                meta: meta,
                metadata: {
                    version: 4.7,
                    type: 'Node',
                    generator: 'Node.toJSON'
                }
            };
            if (isRoot !== true) meta.nodes[data.uuid] = data;
            this.serialize(data);
            delete data.meta;
        }
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
}
/**
 * Enables or disables the automatic capturing of stack traces for nodes.
 *
 * @type {boolean}
 * @default false
 */ $03ccd63b0299d6a7$export$85c928794f8d04d4.captureStackTrace = false;
/**
 * Base class for representing element access on an array-like
 * node data structures.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$f2edd1d22bf6d00b extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ArrayElementNode';
    }
    /**
	 * Constructs an array element node.
	 *
	 * @param {Node} node - The array-like node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(node, indexNode){
        super();
        /**
		 * The array-like node.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The index node that defines the element access.
		 *
		 * @type {Node}
		 */ this.indexNode = indexNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from the array-like node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return this.node.getElementType(builder);
    }
    /**
	 * This method is overwritten since the member type is inferred from the array-like node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The member name.
	 * @return {string} The member type.
	 */ getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    generate(builder) {
        const indexType = this.indexNode.getNodeType(builder);
        const nodeSnippet = this.node.build(builder);
        const indexSnippet = this.indexNode.build(builder, !builder.isVector(indexType) && builder.isInteger(indexType) ? indexType : 'uint');
        return `${nodeSnippet}[ ${indexSnippet} ]`;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a convert operation during the shader generation process
 * meaning it converts the data type of a node to a target data type.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$77fac4ed96fd2435 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ConvertNode';
    }
    /**
	 * Constructs a new convert node.
	 *
	 * @param {Node} node - The node which type should be converted.
	 * @param {string} convertTo - The target node type. Multiple types can be defined by separating them with a `|` sign.
	 */ constructor(node, convertTo){
        super();
        /**
		 * The node which type should be converted.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The target node type. Multiple types can be defined by separating them with a `|` sign.
		 *
		 * @type {string}
		 */ this.convertTo = convertTo;
    }
    /**
	 * This method is overwritten since the implementation tries to infer the best
	 * matching type from the {@link ConvertNode#convertTo} property.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        const requestType = this.node.getNodeType(builder);
        let convertTo = null;
        for (const overloadingType of this.convertTo.split('|'))if (convertTo === null || builder.getTypeLength(requestType) === builder.getTypeLength(overloadingType)) convertTo = overloadingType;
        return convertTo;
    }
    serialize(data) {
        super.serialize(data);
        data.convertTo = this.convertTo;
    }
    deserialize(data) {
        super.deserialize(data);
        this.convertTo = data.convertTo;
    }
    generate(builder, output) {
        const node = this.node;
        const type = this.getNodeType(builder);
        const snippet = node.build(builder, type);
        return builder.format(snippet, type, output);
    }
}
/**
 * This module uses cache management to create temporary variables
 * if the node is used more than once to prevent duplicate calculations.
 *
 * The class acts as a base class for many other nodes types.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$bbad94d2cd32d688 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'TempNode';
    }
    /**
	 * Constructs a temp node.
	 *
	 * @param {?string} nodeType - The node type.
	 */ constructor(nodeType = null){
        super(nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTempNode = true;
    }
    /**
	 * Whether this node is used more than once in context of other nodes.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @return {boolean} A flag that indicates if there is more than one dependency to other nodes.
	 */ hasDependencies(builder) {
        return builder.getDataFromNode(this).usageCount > 1;
    }
    build(builder, output) {
        const buildStage = builder.getBuildStage();
        if (buildStage === 'generate') {
            const type = builder.getVectorType(this.getNodeType(builder, output));
            const nodeData = builder.getDataFromNode(this);
            if (nodeData.propertyName !== undefined) return builder.format(nodeData.propertyName, type, output);
            else if (type !== 'void' && output !== 'void' && this.hasDependencies(builder)) {
                const snippet = super.build(builder, type);
                const nodeVar = builder.getVarFromNode(this, null, type);
                const propertyName = builder.getPropertyName(nodeVar);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
                return builder.format(nodeData.propertyName, type, output);
            }
        }
        return super.build(builder, output);
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a join operation during the shader generation process.
 * For example in can compose/join two single floats into a `vec2` type.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$737956ea59502441 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'JoinNode';
    }
    /**
	 * Constructs a new join node.
	 *
	 * @param {Array<Node>} nodes - An array of nodes that should be joined.
	 * @param {?string} [nodeType=null] - The node type.
	 */ constructor(nodes = [], nodeType = null){
        super(nodeType);
        /**
		 * An array of nodes that should be joined.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = nodes;
    }
    /**
	 * This method is overwritten since the node type must be inferred from the
	 * joined data length if not explicitly defined.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        if (this.nodeType !== null) return builder.getVectorType(this.nodeType);
        return builder.getTypeFromLength(this.nodes.reduce((count, cur)=>count + builder.getTypeLength(cur.getNodeType(builder)), 0));
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const maxLength = builder.getTypeLength(type);
        const nodes = this.nodes;
        const primitiveType = builder.getComponentType(type);
        const snippetValues = [];
        let length = 0;
        for (const input of nodes){
            if (length >= maxLength) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Length of parameters exceeds maximum length of function '${type}()' type.`, this.stackTrace);
                break;
            }
            let inputType = input.getNodeType(builder);
            let inputTypeLength = builder.getTypeLength(inputType);
            let inputSnippet;
            if (length + inputTypeLength > maxLength) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Length of '${type}()' data exceeds maximum length of output type.`, this.stackTrace);
                inputTypeLength = maxLength - length;
                inputType = builder.getTypeFromLength(inputTypeLength);
            }
            length += inputTypeLength;
            inputSnippet = input.build(builder, inputType);
            const inputPrimitiveType = builder.getComponentType(inputType);
            if (inputPrimitiveType !== primitiveType) {
                const targetType = builder.getTypeFromLength(inputTypeLength, primitiveType);
                inputSnippet = builder.format(inputSnippet, inputType, targetType);
            }
            snippetValues.push(inputSnippet);
        }
        const snippet = `${builder.getType(type)}( ${snippetValues.join(', ')} )`;
        return builder.format(snippet, type, output);
    }
}
const $03ccd63b0299d6a7$var$_stringVectorComponents = $03ccd63b0299d6a7$export$1c0adcb9073b646d.join('');
/**
 * This module is part of the TSL core and usually not used in app level code.
 * `SplitNode` represents a property access operation which means it is
 * used to implement any `.xyzw`, `.rgba` and `stpq` usage on node objects.
 * For example:
 * ```js
 * const redValue = color.r;
 * ```
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$3cd993069e2dfb64 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'SplitNode';
    }
    /**
	 * Constructs a new split node.
	 *
	 * @param {Node} node - The node that should be accessed.
	 * @param {string} [components='x'] - The components that should be accessed.
	 */ constructor(node, components = 'x'){
        super();
        /**
		 * The node that should be accessed.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The components that should be accessed.
		 *
		 * @type {string}
		 */ this.components = components;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplitNode = true;
    }
    /**
	 * Returns the vector length which is computed based on the requested components.
	 *
	 * @return {number} The vector length.
	 */ getVectorLength() {
        let vectorLength = this.components.length;
        for (const c of this.components)vectorLength = Math.max($03ccd63b0299d6a7$export$1c0adcb9073b646d.indexOf(c) + 1, vectorLength);
        return vectorLength;
    }
    /**
	 * Returns the component type of the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The component type.
	 */ getComponentType(builder) {
        return builder.getComponentType(this.node.getNodeType(builder));
    }
    /**
	 * This method is overwritten since the node type is inferred from requested components.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return builder.getTypeFromLength(this.components.length, this.getComponentType(builder));
    }
    /**
	 * Returns the scope of the node.
	 *
	 * @return {Node} The scope of the node.
	 */ getScope() {
        return this.node.getScope();
    }
    generate(builder, output) {
        const node = this.node;
        const nodeTypeLength = builder.getTypeLength(node.getNodeType(builder));
        let snippet = null;
        if (nodeTypeLength > 1) {
            let type = null;
            const componentsLength = this.getVectorLength();
            if (componentsLength >= nodeTypeLength) // needed expand the input node
            type = builder.getTypeFromLength(this.getVectorLength(), this.getComponentType(builder));
            const nodeSnippet = node.build(builder, type);
            if (this.components.length === nodeTypeLength && this.components === $03ccd63b0299d6a7$var$_stringVectorComponents.slice(0, this.components.length)) // unnecessary swizzle
            snippet = builder.format(nodeSnippet, type, output);
            else snippet = builder.format(`${nodeSnippet}.${this.components}`, this.getNodeType(builder), output);
        } else // ignore .components if .node returns float/integer
        snippet = node.build(builder, output);
        return snippet;
    }
    serialize(data) {
        super.serialize(data);
        data.components = this.components;
    }
    deserialize(data) {
        super.deserialize(data);
        this.components = data.components;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * `SetNode` represents a set operation which means it is used to implement any
 * `setXYZW()`, `setRGBA()` and `setSTPQ()` method invocations on node objects.
 * For example:
 * ```js
 * materialLine.colorNode = color( 0, 0, 0 ).setR( float( 1 ) );
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$dfddef9573185145 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'SetNode';
    }
    /**
	 * Constructs a new set node.
	 *
	 * @param {Node} sourceNode - The node that should be updated.
	 * @param {string} components - The components that should be updated.
	 * @param {Node} targetNode - The value node.
	 */ constructor(sourceNode, components, targetNode){
        super();
        /**
		 * The node that should be updated.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * The components that should be updated.
		 *
		 * @type {string}
		 */ this.components = components;
        /**
		 * The value node.
		 *
		 * @type {Node}
		 */ this.targetNode = targetNode;
    }
    /**
	 * This method is overwritten since the node type is inferred from {@link SetNode#sourceNode}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { sourceNode: sourceNode, components: components, targetNode: targetNode } = this;
        const sourceType = this.getNodeType(builder);
        const componentType = builder.getComponentType(targetNode.getNodeType(builder));
        const targetType = builder.getTypeFromLength(components.length, componentType);
        const targetSnippet = targetNode.build(builder, targetType);
        const sourceSnippet = sourceNode.build(builder, sourceType);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        for(let i = 0; i < length; i++){
            const component = $03ccd63b0299d6a7$export$1c0adcb9073b646d[i];
            if (component === components[0]) {
                snippetValues.push(targetSnippet);
                i += components.length - 1;
            } else snippetValues.push(sourceSnippet + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
/**
 * This module is part of the TSL core and usually not used in app level code.
 * It represents a flip operation during the shader generation process
 * meaning it flips normalized values with the following formula:
 * ```
 * x = 1 - x;
 * ```
 * `FlipNode` is internally used to implement any `flipXYZW()`, `flipRGBA()` and
 * `flipSTPQ()` method invocations on node objects. For example:
 * ```js
 * uvNode = uvNode.flipY();
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$86eec510a627fede extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'FlipNode';
    }
    /**
	 * Constructs a new flip node.
	 *
	 * @param {Node} sourceNode - The node which component(s) should be flipped.
	 * @param {string} components - The components that should be flipped e.g. `'x'` or `'xy'`.
	 */ constructor(sourceNode, components){
        super();
        /**
		 * The node which component(s) should be flipped.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * The components that should be flipped e.g. `'x'` or `'xy'`.
		 *
		 * @type {string}
		 */ this.components = components;
    }
    /**
	 * This method is overwritten since the node type is inferred from the source node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return this.sourceNode.getNodeType(builder);
    }
    generate(builder) {
        const { components: components, sourceNode: sourceNode } = this;
        const sourceType = this.getNodeType(builder);
        const sourceSnippet = sourceNode.build(builder);
        const sourceCache = builder.getVarFromNode(this);
        const sourceProperty = builder.getPropertyName(sourceCache);
        builder.addLineFlowCode(sourceProperty + ' = ' + sourceSnippet, this);
        const length = builder.getTypeLength(sourceType);
        const snippetValues = [];
        let componentIndex = 0;
        for(let i = 0; i < length; i++){
            const component = $03ccd63b0299d6a7$export$1c0adcb9073b646d[i];
            if (component === components[componentIndex]) {
                snippetValues.push('1.0 - ' + (sourceProperty + '.' + component));
                componentIndex++;
            } else snippetValues.push(sourceProperty + '.' + component);
        }
        return `${builder.getType(sourceType)}( ${snippetValues.join(', ')} )`;
    }
}
/**
 * Base class for representing data input nodes.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$7e3a4603a05bdb9e extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'InputNode';
    }
    /**
	 * Constructs a new input node.
	 *
	 * @param {any} value - The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInputNode = true;
        /**
		 * The value of this node. This can be any JS primitive, functions, array buffers or even three.js objects (vector, matrices, colors).
		 *
		 * @type {any}
		 */ this.value = value;
        /**
		 * The precision of the value in the shader.
		 *
		 * @type {?('low'|'medium'|'high')}
		 * @default null
		 */ this.precision = null;
    }
    generateNodeType() {
        if (this.nodeType === null) return $03ccd63b0299d6a7$var$getValueType(this.value);
        return this.nodeType;
    }
    /**
	 * Returns the input type of the node which is by default the node type. Derived modules
	 * might overwrite this method and use a fixed type or compute one analytically.
	 *
	 * A typical example for different input and node types are textures. The input type of a
	 * normal RGBA texture is `texture` whereas its node type is `vec4`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Sets the precision to the given value. The method can be
	 * overwritten in derived classes if the final precision must be computed
	 * analytically.
	 *
	 * @param {('low'|'medium'|'high')} precision - The precision of the input value in the shader.
	 * @return {InputNode} A reference to this node.
	 */ setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    serialize(data) {
        super.serialize(data);
        data.value = this.value;
        if (this.value && this.value.toArray) data.value = this.value.toArray();
        data.valueType = $03ccd63b0299d6a7$var$getValueType(this.value);
        data.nodeType = this.nodeType;
        if (data.valueType === 'ArrayBuffer') data.value = $03ccd63b0299d6a7$var$arrayBufferToBase64(data.value);
        data.precision = this.precision;
    }
    deserialize(data) {
        super.deserialize(data);
        this.nodeType = data.nodeType;
        this.value = Array.isArray(data.value) ? $03ccd63b0299d6a7$var$getValueFromType(data.valueType, ...data.value) : data.value;
        this.precision = data.precision || null;
        if (this.value && this.value.fromArray) this.value = this.value.fromArray(data.value);
    }
    generate() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
}
const $03ccd63b0299d6a7$var$_regNum = /float|u?int/;
/**
 * Class for representing a constant value in the shader.
 *
 * @augments InputNode
 */ class $03ccd63b0299d6a7$export$ec99b5196691da75 extends $03ccd63b0299d6a7$export$7e3a4603a05bdb9e {
    static get type() {
        return 'ConstNode';
    }
    /**
	 * Constructs a new input node.
	 *
	 * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(value, nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isConstNode = true;
    }
    /**
	 * Generates the shader string of the value with the current node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated value as a shader string.
	 */ generateConst(builder) {
        return builder.generateConst(this.getNodeType(builder), this.value);
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        if ($03ccd63b0299d6a7$var$_regNum.test(type) && $03ccd63b0299d6a7$var$_regNum.test(output)) return builder.generateConst(output, this.value);
        return builder.format(this.generateConst(builder), type, output);
    }
}
/**
 * Base class for representing member access on an object-like
 * node data structures.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$81fa5d002f21ba26 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'MemberNode';
    }
    /**
	 * Constructs a member node.
	 *
	 * @param {Node} structNode - The struct node.
	 * @param {string} property - The property name.
	 */ constructor(structNode, property){
        super();
        /**
		 * The struct node.
		 *
		 * @type {Node}
		 */ this.structNode = structNode;
        /**
		 * The property name.
		 *
		 * @type {Node}
		 */ this.property = property;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMemberNode = true;
    }
    hasMember(builder) {
        if (this.structNode.isMemberNode) {
            if (this.structNode.hasMember(builder) === false) return false;
        }
        return this.structNode.getMemberType(builder, this.property) !== 'void';
    }
    generateNodeType(builder) {
        if (this.hasMember(builder) === false) // default type if member does not exist
        return 'float';
        return this.structNode.getMemberType(builder, this.property);
    }
    getMemberType(builder, name) {
        if (this.hasMember(builder) === false) // default type if member does not exist
        return 'float';
        const type = this.getNodeType(builder);
        const struct = builder.getStructTypeNode(type);
        return struct.getMemberType(builder, name);
    }
    generate(builder) {
        if (this.hasMember(builder) === false) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`TSL: Member "${this.property}" does not exist in struct.`, this.stackTrace);
            const type = this.getNodeType(builder);
            return builder.generateConst(type);
        }
        const propertyName = this.structNode.build(builder);
        return propertyName + '.' + this.property;
    }
}
let $03ccd63b0299d6a7$var$currentStack = null;
const $03ccd63b0299d6a7$var$NodeElements = new Map();
// Extend Node Class for TSL using prototype
function $03ccd63b0299d6a7$var$addMethodChaining(name, nodeElement) {
    // No require StackTrace because this is internal API
    if ($03ccd63b0299d6a7$var$NodeElements.has(name)) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`TSL: Redefinition of method chaining '${name}'.`);
        return;
    }
    if (typeof nodeElement !== 'function') throw new Error(`THREE.TSL: Node element ${name} is not a function`);
    $03ccd63b0299d6a7$var$NodeElements.set(name, nodeElement);
    if (name !== 'assign') {
        // Changing Node prototype to add method chaining
        $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype[name] = function(...params) {
            //if ( name === 'toVarIntent' ) return this;
            return this.isStackNode ? this.addToStack(nodeElement(...params)) : nodeElement(this, ...params);
        };
        // Adding assign method chaining
        $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype[name + 'Assign'] = function(...params) {
            return this.isStackNode ? this.assign(params[0], nodeElement(...params)) : this.assign(nodeElement(this, ...params));
        };
    }
}
const $03ccd63b0299d6a7$var$parseSwizzle = (props)=>props.replace(/r|s/g, 'x').replace(/g|t/g, 'y').replace(/b|p/g, 'z').replace(/a|q/g, 'w');
const $03ccd63b0299d6a7$var$parseSwizzleAndSort = (props)=>$03ccd63b0299d6a7$var$parseSwizzle(props).split('').sort().join('');
$03ccd63b0299d6a7$export$85c928794f8d04d4.prototype.assign = function(...params) {
    if (this.isStackNode !== true) {
        if ($03ccd63b0299d6a7$var$currentStack !== null) $03ccd63b0299d6a7$var$currentStack.assign(this, ...params);
        else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: No stack defined for assign operation. Make sure the assign is inside a Fn().', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
        return this;
    } else {
        const nodeElement = $03ccd63b0299d6a7$var$NodeElements.get('assign');
        return this.addToStack(nodeElement(...params));
    }
};
$03ccd63b0299d6a7$export$85c928794f8d04d4.prototype.toVarIntent = function() {
    return this;
};
$03ccd63b0299d6a7$export$85c928794f8d04d4.prototype.get = function(value) {
    return new $03ccd63b0299d6a7$export$81fa5d002f21ba26(this, value);
};
// Cache prototype for TSL
const $03ccd63b0299d6a7$var$proto = {};
// Set swizzle properties for xyzw, rgba, and stpq.
function $03ccd63b0299d6a7$var$setProtoSwizzle(property, altA, altB) {
    // swizzle properties
    $03ccd63b0299d6a7$var$proto[property] = $03ccd63b0299d6a7$var$proto[altA] = $03ccd63b0299d6a7$var$proto[altB] = {
        get () {
            this._cache = this._cache || {};
            //
            let split = this._cache[property];
            if (split === undefined) {
                split = new $03ccd63b0299d6a7$export$3cd993069e2dfb64(this, property);
                this._cache[property] = split;
            }
            return split;
        },
        set (value) {
            this[property].assign($03ccd63b0299d6a7$var$nodeObject(value));
        }
    };
    // set properties ( swizzle ) and sort to xyzw sequence
    const propUpper = property.toUpperCase();
    const altAUpper = altA.toUpperCase();
    const altBUpper = altB.toUpperCase();
    // Set methods for swizzle properties
    $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['set' + propUpper] = $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['set' + altAUpper] = $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['set' + altBUpper] = function(value) {
        const swizzle = $03ccd63b0299d6a7$var$parseSwizzleAndSort(property);
        return new $03ccd63b0299d6a7$export$dfddef9573185145(this, swizzle, $03ccd63b0299d6a7$var$nodeObject(value));
    };
    // Set methods for flip properties
    $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['flip' + propUpper] = $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['flip' + altAUpper] = $03ccd63b0299d6a7$export$85c928794f8d04d4.prototype['flip' + altBUpper] = function() {
        const swizzle = $03ccd63b0299d6a7$var$parseSwizzleAndSort(property);
        return new $03ccd63b0299d6a7$export$86eec510a627fede(this, swizzle);
    };
}
const $03ccd63b0299d6a7$var$swizzleA = [
    'x',
    'y',
    'z',
    'w'
];
const $03ccd63b0299d6a7$var$swizzleB = [
    'r',
    'g',
    'b',
    'a'
];
const $03ccd63b0299d6a7$var$swizzleC = [
    's',
    't',
    'p',
    'q'
];
for(let a = 0; a < 4; a++){
    let prop = $03ccd63b0299d6a7$var$swizzleA[a];
    let altA = $03ccd63b0299d6a7$var$swizzleB[a];
    let altB = $03ccd63b0299d6a7$var$swizzleC[a];
    $03ccd63b0299d6a7$var$setProtoSwizzle(prop, altA, altB);
    for(let b = 0; b < 4; b++){
        prop = $03ccd63b0299d6a7$var$swizzleA[a] + $03ccd63b0299d6a7$var$swizzleA[b];
        altA = $03ccd63b0299d6a7$var$swizzleB[a] + $03ccd63b0299d6a7$var$swizzleB[b];
        altB = $03ccd63b0299d6a7$var$swizzleC[a] + $03ccd63b0299d6a7$var$swizzleC[b];
        $03ccd63b0299d6a7$var$setProtoSwizzle(prop, altA, altB);
        for(let c = 0; c < 4; c++){
            prop = $03ccd63b0299d6a7$var$swizzleA[a] + $03ccd63b0299d6a7$var$swizzleA[b] + $03ccd63b0299d6a7$var$swizzleA[c];
            altA = $03ccd63b0299d6a7$var$swizzleB[a] + $03ccd63b0299d6a7$var$swizzleB[b] + $03ccd63b0299d6a7$var$swizzleB[c];
            altB = $03ccd63b0299d6a7$var$swizzleC[a] + $03ccd63b0299d6a7$var$swizzleC[b] + $03ccd63b0299d6a7$var$swizzleC[c];
            $03ccd63b0299d6a7$var$setProtoSwizzle(prop, altA, altB);
            for(let d = 0; d < 4; d++){
                prop = $03ccd63b0299d6a7$var$swizzleA[a] + $03ccd63b0299d6a7$var$swizzleA[b] + $03ccd63b0299d6a7$var$swizzleA[c] + $03ccd63b0299d6a7$var$swizzleA[d];
                altA = $03ccd63b0299d6a7$var$swizzleB[a] + $03ccd63b0299d6a7$var$swizzleB[b] + $03ccd63b0299d6a7$var$swizzleB[c] + $03ccd63b0299d6a7$var$swizzleB[d];
                altB = $03ccd63b0299d6a7$var$swizzleC[a] + $03ccd63b0299d6a7$var$swizzleC[b] + $03ccd63b0299d6a7$var$swizzleC[c] + $03ccd63b0299d6a7$var$swizzleC[d];
                $03ccd63b0299d6a7$var$setProtoSwizzle(prop, altA, altB);
            }
        }
    }
}
// Set/get static properties for array elements (0-31).
for(let i = 0; i < 32; i++)$03ccd63b0299d6a7$var$proto[i] = {
    get () {
        this._cache = this._cache || {};
        //
        let element = this._cache[i];
        if (element === undefined) {
            element = new $03ccd63b0299d6a7$export$f2edd1d22bf6d00b(this, new $03ccd63b0299d6a7$export$ec99b5196691da75(i, 'uint'));
            this._cache[i] = element;
        }
        return element;
    },
    set (value) {
        this[i].assign($03ccd63b0299d6a7$var$nodeObject(value));
    }
};
/*
// Set properties for width, height, and depth.

function setProtoProperty( property, target ) {

	proto[ property ] = {

		get() {

			this._cache = this._cache || {};

			//

			let split = this._cache[ target ];

			if ( split === undefined ) {

				split = new SplitNode( this, target );

				this._cache[ target ] = split;

			}

			return split;

		},

		set( value ) {

			this[ target ].assign( nodeObject( value ) );

		}

	};

}

setProtoProperty( 'width', 'x' );
setProtoProperty( 'height', 'y' );
setProtoProperty( 'depth', 'z' );
*/ Object.defineProperties($03ccd63b0299d6a7$export$85c928794f8d04d4.prototype, $03ccd63b0299d6a7$var$proto);
// --- FINISH ---
const $03ccd63b0299d6a7$var$nodeBuilderFunctionsCacheMap = new WeakMap();
const $03ccd63b0299d6a7$var$ShaderNodeObject = function(obj, altType = null) {
    const type = $03ccd63b0299d6a7$var$getValueType(obj);
    if (type === 'node') return obj;
    else if (altType === null && (type === 'float' || type === 'boolean') || type && type !== 'shader' && type !== 'string') return $03ccd63b0299d6a7$var$nodeObject($03ccd63b0299d6a7$var$getConstNode(obj, altType));
    else if (type === 'shader') return obj.isFn ? obj : $03ccd63b0299d6a7$var$Fn(obj);
    return obj;
};
const $03ccd63b0299d6a7$var$ShaderNodeObjects = function(objects, altType = null) {
    for(const name in objects)objects[name] = $03ccd63b0299d6a7$var$nodeObject(objects[name], altType);
    return objects;
};
const $03ccd63b0299d6a7$var$ShaderNodeArray = function(array, altType = null) {
    const len = array.length;
    for(let i = 0; i < len; i++)array[i] = $03ccd63b0299d6a7$var$nodeObject(array[i], altType);
    return array;
};
const $03ccd63b0299d6a7$var$ShaderNodeProxy = function(NodeClass, scope = null, factor = null, settings = null) {
    function assignNode(node) {
        if (settings !== null) {
            node = $03ccd63b0299d6a7$var$nodeObject(Object.assign(node, settings));
            if (settings.intent === true) node = node.toVarIntent();
        } else node = $03ccd63b0299d6a7$var$nodeObject(node);
        return node;
    }
    let fn, name = scope, minParams, maxParams;
    function verifyParamsLimit(params) {
        let tslName;
        if (name) tslName = /[a-z]/i.test(name) ? name + '()' : name;
        else tslName = NodeClass.type;
        if (minParams !== undefined && params.length < minParams) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: "${tslName}" parameter length is less than minimum required.`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
            return params.concat(new Array(minParams - params.length).fill(0));
        } else if (maxParams !== undefined && params.length > maxParams) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: "${tslName}" parameter length exceeds limit.`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
            return params.slice(0, maxParams);
        }
        return params;
    }
    if (scope === null) fn = (...params)=>{
        return assignNode(new NodeClass(...$03ccd63b0299d6a7$var$nodeArray(verifyParamsLimit(params))));
    };
    else if (factor !== null) {
        factor = $03ccd63b0299d6a7$var$nodeObject(factor);
        fn = (...params)=>{
            return assignNode(new NodeClass(scope, ...$03ccd63b0299d6a7$var$nodeArray(verifyParamsLimit(params)), factor));
        };
    } else fn = (...params)=>{
        return assignNode(new NodeClass(scope, ...$03ccd63b0299d6a7$var$nodeArray(verifyParamsLimit(params))));
    };
    fn.setParameterLength = (...params)=>{
        if (params.length === 1) minParams = maxParams = params[0];
        else if (params.length === 2) [minParams, maxParams] = params;
        return fn;
    };
    fn.setName = (value)=>{
        name = value;
        return fn;
    };
    return fn;
};
const $03ccd63b0299d6a7$var$ShaderNodeImmutable = function(NodeClass, ...params) {
    return new NodeClass(...$03ccd63b0299d6a7$var$nodeArray(params));
};
class $03ccd63b0299d6a7$var$ShaderCallNodeInternal extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    constructor(shaderNode, rawInputs){
        super();
        this.shaderNode = shaderNode;
        this.rawInputs = rawInputs;
        this.isShaderCallNodeInternal = true;
    }
    generateNodeType(builder) {
        return this.shaderNode.nodeType || this.getOutputNode(builder).getNodeType(builder);
    }
    getElementType(builder) {
        return this.getOutputNode(builder).getElementType(builder);
    }
    getMemberType(builder, name) {
        return this.getOutputNode(builder).getMemberType(builder, name);
    }
    call(builder) {
        const { shaderNode: shaderNode, rawInputs: rawInputs } = this;
        const properties = builder.getNodeProperties(shaderNode);
        const subBuild = builder.getClosestSubBuild(shaderNode.subBuilds) || '';
        const subBuildProperty = subBuild || 'default';
        if (properties[subBuildProperty]) return properties[subBuildProperty];
        //
        const previousSubBuildFn = builder.subBuildFn;
        const previousFnCall = builder.fnCall;
        builder.subBuildFn = subBuild;
        builder.fnCall = this;
        let result = null;
        if (shaderNode.layout) {
            let functionNodesCacheMap = $03ccd63b0299d6a7$var$nodeBuilderFunctionsCacheMap.get(builder.constructor);
            if (functionNodesCacheMap === undefined) {
                functionNodesCacheMap = new WeakMap();
                $03ccd63b0299d6a7$var$nodeBuilderFunctionsCacheMap.set(builder.constructor, functionNodesCacheMap);
            }
            let functionNode = functionNodesCacheMap.get(shaderNode);
            if (functionNode === undefined) {
                functionNode = $03ccd63b0299d6a7$var$nodeObject(builder.buildFunctionNode(shaderNode));
                functionNodesCacheMap.set(shaderNode, functionNode);
            }
            builder.addInclude(functionNode);
            //
            const inputs = rawInputs ? $03ccd63b0299d6a7$var$getLayoutParameters(rawInputs) : null;
            result = $03ccd63b0299d6a7$var$nodeObject(functionNode.call(inputs));
        } else {
            const secureNodeBuilder = new Proxy(builder, {
                get: (target, property, receiver)=>{
                    let value;
                    if (Symbol.iterator === property) value = function*() {
                        yield undefined;
                    };
                    else value = Reflect.get(target, property, receiver);
                    return value;
                }
            });
            //
            const inputs = rawInputs ? $03ccd63b0299d6a7$var$getProxyParameters(rawInputs) : null;
            const hasParameters = Array.isArray(rawInputs) ? rawInputs.length > 0 : rawInputs !== null;
            const jsFunc = shaderNode.jsFunc;
            const outputNode = hasParameters || jsFunc.length > 1 ? jsFunc(inputs, secureNodeBuilder) : jsFunc(secureNodeBuilder);
            result = $03ccd63b0299d6a7$var$nodeObject(outputNode);
        }
        builder.subBuildFn = previousSubBuildFn;
        builder.fnCall = previousFnCall;
        if (shaderNode.once) properties[subBuildProperty] = result;
        return result;
    }
    setupOutput(builder) {
        builder.addStack();
        builder.stack.outputNode = this.call(builder);
        return builder.removeStack();
    }
    getOutputNode(builder) {
        const properties = builder.getNodeProperties(this);
        const subBuildOutput = builder.getSubBuildOutput(this);
        properties[subBuildOutput] = properties[subBuildOutput] || this.setupOutput(builder);
        properties[subBuildOutput].subBuild = builder.getClosestSubBuild(this);
        return properties[subBuildOutput];
    }
    build(builder, output = null) {
        let result = null;
        const buildStage = builder.getBuildStage();
        const properties = builder.getNodeProperties(this);
        const subBuildOutput = builder.getSubBuildOutput(this);
        const outputNode = this.getOutputNode(builder);
        const previousFnCall = builder.fnCall;
        builder.fnCall = this;
        if (buildStage === 'setup') {
            const subBuildInitialized = builder.getSubBuildProperty('initialized', this);
            if (properties[subBuildInitialized] !== true) {
                properties[subBuildInitialized] = true;
                properties[subBuildOutput] = this.getOutputNode(builder);
                properties[subBuildOutput].build(builder);
                // If the shaderNode has subBuilds, add them to the chaining nodes
                // so they can be built later in the build process.
                if (this.shaderNode.subBuilds) for (const node of builder.chaining){
                    const nodeData = builder.getDataFromNode(node, 'any');
                    nodeData.subBuilds = nodeData.subBuilds || new Set();
                    for (const subBuild of this.shaderNode.subBuilds)nodeData.subBuilds.add(subBuild);
                //builder.getDataFromNode( node ).subBuilds = nodeData.subBuilds;
                }
            }
            result = properties[subBuildOutput];
        } else if (buildStage === 'analyze') outputNode.build(builder, output);
        else if (buildStage === 'generate') result = outputNode.build(builder, output) || '';
        builder.fnCall = previousFnCall;
        return result;
    }
}
function $03ccd63b0299d6a7$var$getLayoutParameters(params) {
    let output;
    $03ccd63b0299d6a7$var$nodeObjects(params);
    const isArrayAsParameter = params[0] && (params[0].isNode || Object.getPrototypeOf(params[0]) !== Object.prototype);
    if (isArrayAsParameter) output = [
        ...params
    ];
    else output = params[0];
    return output;
}
function $03ccd63b0299d6a7$var$getProxyParameters(params) {
    let index = 0;
    $03ccd63b0299d6a7$var$nodeObjects(params);
    return new Proxy(params, {
        get: (target, property, receiver)=>{
            let value;
            if (property === 'length') {
                value = params.length;
                return value;
            }
            if (Symbol.iterator === property) value = function*() {
                for (const inputNode of params)yield $03ccd63b0299d6a7$var$nodeObject(inputNode);
            };
            else {
                if (params.length > 0) {
                    if (Object.getPrototypeOf(params[0]) === Object.prototype) {
                        const objectTarget = params[0];
                        if (objectTarget[property] === undefined) value = objectTarget[index++];
                        else value = Reflect.get(objectTarget, property, receiver);
                    } else if (params[0] instanceof $03ccd63b0299d6a7$export$85c928794f8d04d4) {
                        if (params[property] === undefined) value = params[index++];
                        else value = Reflect.get(params, property, receiver);
                    }
                } else value = Reflect.get(target, property, receiver);
                value = $03ccd63b0299d6a7$var$nodeObject(value);
            }
            return value;
        }
    });
}
class $03ccd63b0299d6a7$var$ShaderNodeInternal extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    constructor(jsFunc, nodeType){
        super(nodeType);
        this.jsFunc = jsFunc;
        this.layout = null;
        this.global = true;
        this.once = false;
    }
    setLayout(layout) {
        this.layout = layout;
        return this;
    }
    getLayout() {
        return this.layout;
    }
    call(rawInputs = null) {
        return new $03ccd63b0299d6a7$var$ShaderCallNodeInternal(this, rawInputs);
    }
    setup() {
        return this.call();
    }
}
const $03ccd63b0299d6a7$var$bools = [
    false,
    true
];
const $03ccd63b0299d6a7$var$uints = [
    0,
    1,
    2,
    3
];
const $03ccd63b0299d6a7$var$ints = [
    -1,
    -2
];
const $03ccd63b0299d6a7$var$floats = [
    0.5,
    1.5,
    1 / 3,
    1e-6,
    1e6,
    Math.PI,
    Math.PI * 2,
    1 / Math.PI,
    2 / Math.PI,
    1 / (Math.PI * 2),
    Math.PI / 2
];
const $03ccd63b0299d6a7$var$boolsCacheMap = new Map();
for (const bool of $03ccd63b0299d6a7$var$bools)$03ccd63b0299d6a7$var$boolsCacheMap.set(bool, new $03ccd63b0299d6a7$export$ec99b5196691da75(bool));
const $03ccd63b0299d6a7$var$uintsCacheMap = new Map();
for (const uint of $03ccd63b0299d6a7$var$uints)$03ccd63b0299d6a7$var$uintsCacheMap.set(uint, new $03ccd63b0299d6a7$export$ec99b5196691da75(uint, 'uint'));
const $03ccd63b0299d6a7$var$intsCacheMap = new Map([
    ...$03ccd63b0299d6a7$var$uintsCacheMap
].map((el)=>new $03ccd63b0299d6a7$export$ec99b5196691da75(el.value, 'int')));
for (const int of $03ccd63b0299d6a7$var$ints)$03ccd63b0299d6a7$var$intsCacheMap.set(int, new $03ccd63b0299d6a7$export$ec99b5196691da75(int, 'int'));
const $03ccd63b0299d6a7$var$floatsCacheMap = new Map([
    ...$03ccd63b0299d6a7$var$intsCacheMap
].map((el)=>new $03ccd63b0299d6a7$export$ec99b5196691da75(el.value)));
for (const float of $03ccd63b0299d6a7$var$floats)$03ccd63b0299d6a7$var$floatsCacheMap.set(float, new $03ccd63b0299d6a7$export$ec99b5196691da75(float));
for (const float of $03ccd63b0299d6a7$var$floats)$03ccd63b0299d6a7$var$floatsCacheMap.set(-float, new $03ccd63b0299d6a7$export$ec99b5196691da75(-float));
const $03ccd63b0299d6a7$var$cacheMaps = {
    bool: $03ccd63b0299d6a7$var$boolsCacheMap,
    uint: $03ccd63b0299d6a7$var$uintsCacheMap,
    ints: $03ccd63b0299d6a7$var$intsCacheMap,
    float: $03ccd63b0299d6a7$var$floatsCacheMap
};
const $03ccd63b0299d6a7$var$constNodesCacheMap = new Map([
    ...$03ccd63b0299d6a7$var$boolsCacheMap,
    ...$03ccd63b0299d6a7$var$floatsCacheMap
]);
const $03ccd63b0299d6a7$var$getConstNode = (value, type)=>{
    if ($03ccd63b0299d6a7$var$constNodesCacheMap.has(value)) return $03ccd63b0299d6a7$var$constNodesCacheMap.get(value);
    else if (value.isNode === true) return value;
    else return new $03ccd63b0299d6a7$export$ec99b5196691da75(value, type);
};
const $03ccd63b0299d6a7$var$ConvertType = function(type, cacheMap = null) {
    return (...params)=>{
        for (const param of params)if (param === undefined) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Invalid parameter for the type "${type}".`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
            return new $03ccd63b0299d6a7$export$ec99b5196691da75(0, type);
        }
        if (params.length === 0 || ![
            'bool',
            'float',
            'int',
            'uint'
        ].includes(type) && params.every((param)=>{
            const paramType = typeof param;
            return paramType !== 'object' && paramType !== 'function';
        })) params = [
            $03ccd63b0299d6a7$var$getValueFromType(type, ...params)
        ];
        if (params.length === 1 && cacheMap !== null && cacheMap.has(params[0])) return $03ccd63b0299d6a7$var$nodeObjectIntent(cacheMap.get(params[0]));
        if (params.length === 1) {
            const node = $03ccd63b0299d6a7$var$getConstNode(params[0], type);
            if (node.nodeType === type) return $03ccd63b0299d6a7$var$nodeObjectIntent(node);
            return $03ccd63b0299d6a7$var$nodeObjectIntent(new $03ccd63b0299d6a7$export$77fac4ed96fd2435(node, type));
        }
        const nodes = params.map((param)=>$03ccd63b0299d6a7$var$getConstNode(param));
        return $03ccd63b0299d6a7$var$nodeObjectIntent(new $03ccd63b0299d6a7$export$737956ea59502441(nodes, type));
    };
};
// exports
function $03ccd63b0299d6a7$var$defined(value) {
    if (value && value.isNode) value.traverse((node)=>{
        if (node.isConstNode) value = node.value;
    });
    return Boolean(value);
}
// utils
const $03ccd63b0299d6a7$var$getConstNodeType = (value)=>value !== undefined && value !== null ? value.nodeType || value.convertTo || (typeof value === 'string' ? value : null) : null;
// shader node base
function $03ccd63b0299d6a7$var$ShaderNode(jsFunc, nodeType) {
    return new $03ccd63b0299d6a7$var$ShaderNodeInternal(jsFunc, nodeType);
}
const $03ccd63b0299d6a7$var$nodeObject = (val, altType = null)=>/* new */ $03ccd63b0299d6a7$var$ShaderNodeObject(val, altType);
const $03ccd63b0299d6a7$var$nodeObjectIntent = (val, altType = null)=>/* new */ $03ccd63b0299d6a7$var$nodeObject(val, altType).toVarIntent();
const $03ccd63b0299d6a7$var$nodeObjects = (val, altType = null)=>new $03ccd63b0299d6a7$var$ShaderNodeObjects(val, altType);
const $03ccd63b0299d6a7$var$nodeArray = (val, altType = null)=>new $03ccd63b0299d6a7$var$ShaderNodeArray(val, altType);
const $03ccd63b0299d6a7$var$nodeProxy = (NodeClass, scope = null, factor = null, settings = null)=>new $03ccd63b0299d6a7$var$ShaderNodeProxy(NodeClass, scope, factor, settings);
const $03ccd63b0299d6a7$var$nodeImmutable = (NodeClass, ...params)=>new $03ccd63b0299d6a7$var$ShaderNodeImmutable(NodeClass, ...params);
const $03ccd63b0299d6a7$var$nodeProxyIntent = (NodeClass, scope = null, factor = null, settings = {})=>new $03ccd63b0299d6a7$var$ShaderNodeProxy(NodeClass, scope, factor, {
        ...settings,
        intent: true
    });
let $03ccd63b0299d6a7$var$fnId = 0;
class $03ccd63b0299d6a7$var$FnNode extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    constructor(jsFunc, layout = null){
        super();
        let nodeType = null;
        if (layout !== null) {
            if (typeof layout === 'object') nodeType = layout.return;
            else {
                if (typeof layout === 'string') nodeType = layout;
                else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: Invalid layout type.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
                layout = null;
            }
        }
        this.shaderNode = new $03ccd63b0299d6a7$var$ShaderNode(jsFunc, nodeType);
        if (layout !== null) this.setLayout(layout);
        this.isFn = true;
    }
    setLayout(layout) {
        const nodeType = this.shaderNode.nodeType;
        if (typeof layout.inputs !== 'object') {
            const fullLayout = {
                name: 'fn' + $03ccd63b0299d6a7$var$fnId++,
                type: nodeType,
                inputs: []
            };
            for(const name in layout){
                if (name === 'return') continue;
                fullLayout.inputs.push({
                    name: name,
                    type: layout[name]
                });
            }
            layout = fullLayout;
        }
        this.shaderNode.setLayout(layout);
        return this;
    }
    generateNodeType(builder) {
        return this.shaderNode.getNodeType(builder) || 'float';
    }
    call(...params) {
        const fnCall = this.shaderNode.call(params);
        if (this.shaderNode.nodeType === 'void') fnCall.toStack();
        return fnCall.toVarIntent();
    }
    once(subBuilds = null) {
        this.shaderNode.once = true;
        this.shaderNode.subBuilds = subBuilds;
        return this;
    }
    generate(builder) {
        const type = this.getNodeType(builder);
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: "Fn()" was declared but not invoked. Try calling it like "Fn()( ...params )".', this.stackTrace);
        return builder.generateConst(type);
    }
}
function $03ccd63b0299d6a7$var$Fn(jsFunc, layout = null) {
    const instance = new $03ccd63b0299d6a7$var$FnNode(jsFunc, layout);
    return new Proxy(()=>{}, {
        apply (target, thisArg, params) {
            return instance.call(...params);
        },
        get (target, prop, receiver) {
            return Reflect.get(instance, prop, receiver);
        },
        set (target, prop, value, receiver) {
            return Reflect.set(instance, prop, value, receiver);
        }
    });
}
//
const $03ccd63b0299d6a7$var$setCurrentStack = (stack)=>{
    $03ccd63b0299d6a7$var$currentStack = stack;
};
const $03ccd63b0299d6a7$var$getCurrentStack = ()=>$03ccd63b0299d6a7$var$currentStack;
/**
 * Represent a conditional node using if/else statements.
 *
 * ```js
 * If( condition, function )
 * 	.ElseIf( condition, function )
 * 	.Else( function )
 * ```
 * @tsl
 * @function
 * @param {...any} params - The parameters for the conditional node.
 * @returns {StackNode} The conditional node.
 */ const $03ccd63b0299d6a7$var$If = (...params)=>$03ccd63b0299d6a7$var$currentStack.If(...params);
/**
 * Represent a conditional node using switch/case statements.
 *
 * ```js
 * Switch( value )
 * 	.Case( 1, function )
 * 	.Case( 2, 3, 4, function )
 * 	.Default( function )
 * ```
 * @tsl
 * @function
 * @param {...any} params - The parameters for the conditional node.
 * @returns {StackNode} The conditional node.
 */ const $03ccd63b0299d6a7$var$Switch = (...params)=>$03ccd63b0299d6a7$var$currentStack.Switch(...params);
/**
 * Add the given node to the current stack.
 *
 * @param {Node} node - The node to add.
 * @returns {Node} The node that was added to the stack.
 */ function $03ccd63b0299d6a7$var$Stack(node) {
    if ($03ccd63b0299d6a7$var$currentStack) $03ccd63b0299d6a7$var$currentStack.addToStack(node);
    return node;
}
$03ccd63b0299d6a7$var$addMethodChaining('toStack', $03ccd63b0299d6a7$var$Stack);
// types
const $03ccd63b0299d6a7$var$color = new $03ccd63b0299d6a7$var$ConvertType('color');
const $03ccd63b0299d6a7$var$float = new $03ccd63b0299d6a7$var$ConvertType('float', $03ccd63b0299d6a7$var$cacheMaps.float);
const $03ccd63b0299d6a7$var$int = new $03ccd63b0299d6a7$var$ConvertType('int', $03ccd63b0299d6a7$var$cacheMaps.ints);
const $03ccd63b0299d6a7$var$uint = new $03ccd63b0299d6a7$var$ConvertType('uint', $03ccd63b0299d6a7$var$cacheMaps.uint);
const $03ccd63b0299d6a7$var$bool = new $03ccd63b0299d6a7$var$ConvertType('bool', $03ccd63b0299d6a7$var$cacheMaps.bool);
const $03ccd63b0299d6a7$var$vec2 = new $03ccd63b0299d6a7$var$ConvertType('vec2');
const $03ccd63b0299d6a7$var$ivec2 = new $03ccd63b0299d6a7$var$ConvertType('ivec2');
const $03ccd63b0299d6a7$var$uvec2 = new $03ccd63b0299d6a7$var$ConvertType('uvec2');
const $03ccd63b0299d6a7$var$bvec2 = new $03ccd63b0299d6a7$var$ConvertType('bvec2');
const $03ccd63b0299d6a7$var$vec3 = new $03ccd63b0299d6a7$var$ConvertType('vec3');
const $03ccd63b0299d6a7$var$ivec3 = new $03ccd63b0299d6a7$var$ConvertType('ivec3');
const $03ccd63b0299d6a7$var$uvec3 = new $03ccd63b0299d6a7$var$ConvertType('uvec3');
const $03ccd63b0299d6a7$var$bvec3 = new $03ccd63b0299d6a7$var$ConvertType('bvec3');
const $03ccd63b0299d6a7$var$vec4 = new $03ccd63b0299d6a7$var$ConvertType('vec4');
const $03ccd63b0299d6a7$var$ivec4 = new $03ccd63b0299d6a7$var$ConvertType('ivec4');
const $03ccd63b0299d6a7$var$uvec4 = new $03ccd63b0299d6a7$var$ConvertType('uvec4');
const $03ccd63b0299d6a7$var$bvec4 = new $03ccd63b0299d6a7$var$ConvertType('bvec4');
const $03ccd63b0299d6a7$var$mat2 = new $03ccd63b0299d6a7$var$ConvertType('mat2');
const $03ccd63b0299d6a7$var$mat3 = new $03ccd63b0299d6a7$var$ConvertType('mat3');
const $03ccd63b0299d6a7$var$mat4 = new $03ccd63b0299d6a7$var$ConvertType('mat4');
const $03ccd63b0299d6a7$var$string = (value = '')=>new $03ccd63b0299d6a7$export$ec99b5196691da75(value, 'string');
const $03ccd63b0299d6a7$var$arrayBuffer = (value)=>new $03ccd63b0299d6a7$export$ec99b5196691da75(value, 'ArrayBuffer');
$03ccd63b0299d6a7$var$addMethodChaining('toColor', $03ccd63b0299d6a7$var$color);
$03ccd63b0299d6a7$var$addMethodChaining('toFloat', $03ccd63b0299d6a7$var$float);
$03ccd63b0299d6a7$var$addMethodChaining('toInt', $03ccd63b0299d6a7$var$int);
$03ccd63b0299d6a7$var$addMethodChaining('toUint', $03ccd63b0299d6a7$var$uint);
$03ccd63b0299d6a7$var$addMethodChaining('toBool', $03ccd63b0299d6a7$var$bool);
$03ccd63b0299d6a7$var$addMethodChaining('toVec2', $03ccd63b0299d6a7$var$vec2);
$03ccd63b0299d6a7$var$addMethodChaining('toIVec2', $03ccd63b0299d6a7$var$ivec2);
$03ccd63b0299d6a7$var$addMethodChaining('toUVec2', $03ccd63b0299d6a7$var$uvec2);
$03ccd63b0299d6a7$var$addMethodChaining('toBVec2', $03ccd63b0299d6a7$var$bvec2);
$03ccd63b0299d6a7$var$addMethodChaining('toVec3', $03ccd63b0299d6a7$var$vec3);
$03ccd63b0299d6a7$var$addMethodChaining('toIVec3', $03ccd63b0299d6a7$var$ivec3);
$03ccd63b0299d6a7$var$addMethodChaining('toUVec3', $03ccd63b0299d6a7$var$uvec3);
$03ccd63b0299d6a7$var$addMethodChaining('toBVec3', $03ccd63b0299d6a7$var$bvec3);
$03ccd63b0299d6a7$var$addMethodChaining('toVec4', $03ccd63b0299d6a7$var$vec4);
$03ccd63b0299d6a7$var$addMethodChaining('toIVec4', $03ccd63b0299d6a7$var$ivec4);
$03ccd63b0299d6a7$var$addMethodChaining('toUVec4', $03ccd63b0299d6a7$var$uvec4);
$03ccd63b0299d6a7$var$addMethodChaining('toBVec4', $03ccd63b0299d6a7$var$bvec4);
$03ccd63b0299d6a7$var$addMethodChaining('toMat2', $03ccd63b0299d6a7$var$mat2);
$03ccd63b0299d6a7$var$addMethodChaining('toMat3', $03ccd63b0299d6a7$var$mat3);
$03ccd63b0299d6a7$var$addMethodChaining('toMat4', $03ccd63b0299d6a7$var$mat4);
// basic nodes
const $03ccd63b0299d6a7$var$element = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$f2edd1d22bf6d00b).setParameterLength(2);
const $03ccd63b0299d6a7$var$convert = (node, types)=>new $03ccd63b0299d6a7$export$77fac4ed96fd2435($03ccd63b0299d6a7$var$nodeObject(node), types);
const $03ccd63b0299d6a7$var$split = (node, channels)=>new $03ccd63b0299d6a7$export$3cd993069e2dfb64($03ccd63b0299d6a7$var$nodeObject(node), channels);
$03ccd63b0299d6a7$var$addMethodChaining('element', $03ccd63b0299d6a7$var$element);
$03ccd63b0299d6a7$var$addMethodChaining('convert', $03ccd63b0299d6a7$var$convert);
// deprecated
/**
 * @tsl
 * @function
 * @deprecated since r176. Use {@link Stack} instead.
 *
 * @param {Node} node - The node to add.
 * @returns {Function}
 */ const $03ccd63b0299d6a7$var$append = (node)=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: append() has been renamed to Stack().', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    return $03ccd63b0299d6a7$var$Stack(node);
};
$03ccd63b0299d6a7$var$addMethodChaining('append', (node)=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: .append() has been renamed to .toStack().', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    return $03ccd63b0299d6a7$var$Stack(node);
});
/**
 * This class represents a shader property. It can be used
 * to explicitly define a property and assign a value to it.
 *
 * ```js
 * const threshold = property( 'float', 'threshold' ).assign( THRESHOLD );
 *```
 * `PropertyNode` is used by the engine to predefined common material properties
 * for TSL code.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$c87c56924d182f24 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'PropertyNode';
    }
    /**
	 * Constructs a new property node.
	 *
	 * @param {string} nodeType - The type of the node.
	 * @param {?string} [name=null] - The name of the property in the shader.
	 * @param {boolean} [varying=false] - Whether this property is a varying or not.
	 */ constructor(nodeType, name = null, varying = false){
        super(nodeType);
        /**
		 * The name of the property in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * Whether this property is a varying or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.varying = varying;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPropertyNode = true;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    customCacheKey() {
        return $03ccd63b0299d6a7$var$hashString(this.type + ':' + (this.name || '') + ':' + (this.varying ? '1' : '0'));
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    generate(builder) {
        let nodeVar;
        if (this.varying === true) {
            nodeVar = builder.getVaryingFromNode(this, this.name);
            nodeVar.needsInterpolation = true;
        } else nodeVar = builder.getVarFromNode(this, this.name);
        return builder.getPropertyName(nodeVar);
    }
}
/**
 * TSL function for creating a property node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} [name=null] - The name of the property in the shader.
 * @returns {PropertyNode}
 */ const $03ccd63b0299d6a7$var$property = (type, name)=>new $03ccd63b0299d6a7$export$c87c56924d182f24(type, name);
/**
 * TSL function for creating a varying property node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} [name=null] - The name of the varying in the shader.
 * @returns {PropertyNode}
 */ const $03ccd63b0299d6a7$var$varyingProperty = (type, name)=>new $03ccd63b0299d6a7$export$c87c56924d182f24(type, name, true);
/**
 * TSL object that represents the shader variable `DiffuseColor`.
 *
 * @tsl
 * @type {PropertyNode<vec4>}
 */ const $03ccd63b0299d6a7$var$diffuseColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec4', 'DiffuseColor');
/**
 * TSL object that represents the shader variable `DiffuseContribution`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $03ccd63b0299d6a7$var$diffuseContribution = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec3', 'DiffuseContribution');
/**
 * TSL object that represents the shader variable `EmissiveColor`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $03ccd63b0299d6a7$var$emissive = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec3', 'EmissiveColor');
/**
 * TSL object that represents the shader variable `Roughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$roughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Roughness');
/**
 * TSL object that represents the shader variable `Metalness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$metalness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Metalness');
/**
 * TSL object that represents the shader variable `Clearcoat`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$clearcoat = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Clearcoat');
/**
 * TSL object that represents the shader variable `ClearcoatRoughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$clearcoatRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'ClearcoatRoughness');
/**
 * TSL object that represents the shader variable `Sheen`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $03ccd63b0299d6a7$var$sheen = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec3', 'Sheen');
/**
 * TSL object that represents the shader variable `SheenRoughness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$sheenRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'SheenRoughness');
/**
 * TSL object that represents the shader variable `Iridescence`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$iridescence = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Iridescence');
/**
 * TSL object that represents the shader variable `IridescenceIOR`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$iridescenceIOR = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'IridescenceIOR');
/**
 * TSL object that represents the shader variable `IridescenceThickness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$iridescenceThickness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'IridescenceThickness');
/**
 * TSL object that represents the shader variable `AlphaT`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$alphaT = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'AlphaT');
/**
 * TSL object that represents the shader variable `Anisotropy`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$anisotropy = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Anisotropy');
/**
 * TSL object that represents the shader variable `AnisotropyT`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $03ccd63b0299d6a7$var$anisotropyT = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec3', 'AnisotropyT');
/**
 * TSL object that represents the shader variable `AnisotropyB`.
 *
 * @tsl
 * @type {PropertyNode<vec3>}
 */ const $03ccd63b0299d6a7$var$anisotropyB = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec3', 'AnisotropyB');
/**
 * TSL object that represents the shader variable `SpecularColor`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $03ccd63b0299d6a7$var$specularColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'color', 'SpecularColor');
/**
 * TSL object that represents the shader variable `SpecularColorBlended`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $03ccd63b0299d6a7$var$specularColorBlended = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'color', 'SpecularColorBlended');
/**
 * TSL object that represents the shader variable `SpecularF90`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$specularF90 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'SpecularF90');
/**
 * TSL object that represents the shader variable `Shininess`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$shininess = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Shininess');
/**
 * TSL object that represents the shader variable `Output`.
 *
 * @tsl
 * @type {PropertyNode<vec4>}
 */ const $03ccd63b0299d6a7$var$output = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'vec4', 'Output');
/**
 * TSL object that represents the shader variable `dashSize`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$dashSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'dashSize');
/**
 * TSL object that represents the shader variable `gapSize`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$gapSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'gapSize');
/**
 * TSL object that represents the shader variable `pointWidth`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$pointWidth = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'pointWidth');
/**
 * TSL object that represents the shader variable `IOR`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$ior = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'IOR');
/**
 * TSL object that represents the shader variable `Transmission`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$transmission = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Transmission');
/**
 * TSL object that represents the shader variable `Thickness`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$thickness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Thickness');
/**
 * TSL object that represents the shader variable `AttenuationDistance`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$attenuationDistance = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'AttenuationDistance');
/**
 * TSL object that represents the shader variable `AttenuationColor`.
 *
 * @tsl
 * @type {PropertyNode<color>}
 */ const $03ccd63b0299d6a7$var$attenuationColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'color', 'AttenuationColor');
/**
 * TSL object that represents the shader variable `Dispersion`.
 *
 * @tsl
 * @type {PropertyNode<float>}
 */ const $03ccd63b0299d6a7$var$dispersion = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$c87c56924d182f24, 'float', 'Dispersion');
/**
 * This node can be used to group single instances of {@link UniformNode}
 * and manage them as a uniform buffer.
 *
 * In most cases, the predefined nodes `objectGroup`, `renderGroup` and `frameGroup`
 * will be used when defining the {@link UniformNode#groupNode} property.
 *
 * - `objectGroup`: Uniform buffer per object.
 * - `renderGroup`: Shared uniform buffer, updated once per render call.
 * - `frameGroup`: Shared uniform buffer, updated once per frame.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$15b35e9032996af8 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'UniformGroupNode';
    }
    /**
	 * Constructs a new uniform group node.
	 *
	 * @param {string} name - The name of the uniform group node.
	 * @param {boolean} [shared=false] - Whether this uniform group node is shared or not.
	 * @param {number} [order=1] - Influences the internal sorting.
	 * @param {string|null} [updateType=null] - The update type of the uniform group node.
	 */ constructor(name, shared = false, order = 1, updateType = null){
        super('string');
        /**
		 * The name of the uniform group node.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * Whether this uniform group node is shared or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.shared = shared;
        /**
		 * Influences the internal sorting.
		 * TODO: Add details when this property should be changed.
		 *
		 * @type {number}
		 * @default 1
		 */ this.order = order;
        /**
		 * The update type of the uniform group node.
		 *
		 * @type {string|null}
		 * @default null
		 */ this.updateType = updateType;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformGroup = true;
    }
    /**
	 * Marks the uniform group node as needing an update.
	 * This will trigger the necessary updates in the rendering process.
	 */ update() {
        this.needsUpdate = true;
    }
    /**
	 * Serializes the uniform group node to a JSON object.
	 *
	 * @param {Object} data - The object to store the serialized data.
	 */ serialize(data) {
        super.serialize(data);
        data.name = this.name;
        data.version = this.version;
        data.shared = this.shared;
    }
    /**
	 * Deserializes the uniform group node from a JSON object.
	 *
	 * @param {Object} data - The object containing the serialized data.
	 */ deserialize(data) {
        super.deserialize(data);
        this.name = data.name;
        this.version = data.version;
        this.shared = data.shared;
    }
}
/**
 * TSL function for creating a uniform group node with the given name.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the uniform group node.
 * @returns {UniformGroupNode}
 */ const $03ccd63b0299d6a7$var$uniformGroup = (name, order = 1, updateType = null)=>new $03ccd63b0299d6a7$export$15b35e9032996af8(name, false, order, updateType);
/**
 * TSL function for creating a shared uniform group node with the given name and order.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the uniform group node.
 * @param {number} [order=0] - Influences the internal sorting.
 * @returns {UniformGroupNode}
 */ const $03ccd63b0299d6a7$var$sharedUniformGroup = (name, order = 0, updateType = null)=>new $03ccd63b0299d6a7$export$15b35e9032996af8(name, true, order, updateType);
/**
 * TSL object that represents a shared uniform group node which is updated once per frame.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $03ccd63b0299d6a7$var$frameGroup = /*@__PURE__*/ $03ccd63b0299d6a7$var$sharedUniformGroup('frame', 0, $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME);
/**
 * TSL object that represents a shared uniform group node which is updated once per render.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $03ccd63b0299d6a7$var$renderGroup = /*@__PURE__*/ $03ccd63b0299d6a7$var$sharedUniformGroup('render', 0, $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER);
/**
 * TSL object that represents a uniform group node which is updated once per object.
 *
 * @tsl
 * @type {UniformGroupNode}
 */ const $03ccd63b0299d6a7$var$objectGroup = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniformGroup('object', 1, $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT);
/**
 * Class for representing a uniform.
 *
 * @augments InputNode
 */ class $03ccd63b0299d6a7$export$c0cca4cf699a03e1 extends $03ccd63b0299d6a7$export$7e3a4603a05bdb9e {
    static get type() {
        return 'UniformNode';
    }
    /**
	 * Constructs a new uniform node.
	 *
	 * @param {any} value - The value of this node. Usually a JS primitive or three.js object (vector, matrix, color, texture).
	 * @param {?string} nodeType - The node type. If no explicit type is defined, the node tries to derive the type from its value.
	 */ constructor(value, nodeType = null){
        super(value, nodeType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformNode = true;
        /**
		 * The name or label of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * The uniform group of this uniform. By default, uniforms are
		 * managed per object but they might belong to a shared group
		 * which is updated per frame or render call.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = $03ccd63b0299d6a7$var$objectGroup;
    }
    /**
	 * Sets the {@link UniformNode#name} property.
	 *
	 * @param {string} name - The name of the uniform.
	 * @return {UniformNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the {@link UniformNode#name} property.
	 *
	 * @deprecated
	 * @param {string} name - The name of the uniform.
	 * @return {UniformNode} A reference to this node.
	 */ label(name) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "label()" has been deprecated. Use "setName()" instead.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c()); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the {@link UniformNode#groupNode} property.
	 *
	 * @param {UniformGroupNode} group - The uniform group.
	 * @return {UniformNode} A reference to this node.
	 */ setGroup(group) {
        this.groupNode = group;
        return this;
    }
    /**
	 * Returns the {@link UniformNode#groupNode}.
	 *
	 * @return {UniformGroupNode} The uniform group.
	 */ getGroup() {
        return this.groupNode;
    }
    /**
	 * By default, this method returns the result of {@link Node#getHash} but derived
	 * classes might overwrite this method with a different implementation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The uniform hash.
	 */ getUniformHash(builder) {
        return this.getHash(builder);
    }
    onUpdate(callback, updateType) {
        callback = callback.bind(this);
        return super.onUpdate((frame)=>{
            const value = callback(frame, this);
            if (value !== undefined) this.value = value;
        }, updateType);
    }
    getInputType(builder) {
        let type = super.getInputType(builder);
        if (type === 'bool') type = 'uint';
        return type;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const hash = this.getUniformHash(builder);
        let sharedNode = builder.getNodeFromHash(hash);
        if (sharedNode === undefined) {
            builder.setHashNode(this, hash);
            sharedNode = this;
        }
        const sharedNodeType = sharedNode.getInputType(builder);
        const nodeUniform = builder.getUniformFromNode(sharedNode, sharedNodeType, builder.shaderStage, this.name || builder.context.nodeName);
        const uniformName = builder.getPropertyName(nodeUniform);
        if (builder.context.nodeName !== undefined) delete builder.context.nodeName;
        //
        let snippet = uniformName;
        if (type === 'bool') {
            // cache to variable
            const nodeData = builder.getDataFromNode(this);
            let propertyName = nodeData.propertyName;
            if (propertyName === undefined) {
                const nodeVar = builder.getVarFromNode(this, null, 'bool');
                propertyName = builder.getPropertyName(nodeVar);
                nodeData.propertyName = propertyName;
                snippet = builder.format(uniformName, sharedNodeType, type);
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
            }
            snippet = propertyName;
        }
        return builder.format(snippet, type, output);
    }
}
/**
 * TSL function for creating a uniform node.
 *
 * @tsl
 * @function
 * @param {any|string} value - The value of this uniform or your type. Usually a JS primitive or three.js object (vector, matrix, color, texture).
 * @param {string} [type] - The node type. If no explicit type is defined, the node tries to derive the type from its value.
 * @returns {UniformNode}
 */ const $03ccd63b0299d6a7$var$uniform = (value, type)=>{
    const nodeType = $03ccd63b0299d6a7$var$getConstNodeType(type || value);
    if (nodeType === value) // if the value is a type but no having a value
    value = $03ccd63b0299d6a7$var$getValueFromType(nodeType);
    if (value && value.isNode === true) {
        let v = value.value;
        value.traverse((n)=>{
            if (n.isConstNode === true) v = n.value;
        });
        value = v;
    }
    return new $03ccd63b0299d6a7$export$c0cca4cf699a03e1(value, nodeType);
};
/**
 * ArrayNode represents a collection of nodes, typically created using the {@link array} function.
 * ```js
 * const colors = array( [
 * 	vec3( 1, 0, 0 ),
 * 	vec3( 0, 1, 0 ),
 * 	vec3( 0, 0, 1 )
 * ] );
 *
 * const redColor = tintColors.element( 0 );
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$97d96bf9b84874d5 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'ArrayNode';
    }
    /**
	 * Constructs a new array node.
	 *
	 * @param {?string} nodeType - The data type of the elements.
	 * @param {number} count - Size of the array.
	 * @param {?Array<Node>} [values=null] - Array default values.
	 */ constructor(nodeType, count, values = null){
        super(nodeType);
        /**
		 * Array size.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Array default values.
		 *
		 * @type {?Array<Node>}
		 */ this.values = values;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayNode = true;
    }
    /**
	 * Returns the number of elements in the node array.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {number} The number of elements in the node array.
	 */ getArrayCount() {
        return this.count;
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ generateNodeType(builder) {
        if (this.nodeType === null) return this.values[0].getNodeType(builder);
        return this.nodeType;
    }
    /**
	 * Returns the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type of the node.
	 */ getElementType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Returns the type of a member variable.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member variable.
	 * @return {string} The type of the member variable.
	 */ getMemberType(builder, name) {
        if (this.nodeType === null) return this.values[0].getMemberType(builder, name);
        return super.getMemberType(builder, name);
    }
    /**
	 * This method builds the output node and returns the resulting array as a shader string.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated shader string.
	 */ generate(builder) {
        const type = this.getNodeType(builder);
        return builder.generateArray(type, this.count, this.values);
    }
}
/**
 * TSL function for creating an array node.
 *
 * @tsl
 * @function
 * @param {string|Array<Node>} nodeTypeOrValues - A string representing the element type (e.g., 'vec3')
 * or an array containing the default values (e.g., [ vec3() ]).
 * @param {?number} [count] - Size of the array.
 * @returns {ArrayNode}
 */ const $03ccd63b0299d6a7$var$array = (...params)=>{
    let node;
    if (params.length === 1) {
        const values = params[0];
        node = new $03ccd63b0299d6a7$export$97d96bf9b84874d5(null, values.length, values);
    } else {
        const nodeType = params[0];
        const count = params[1];
        node = new $03ccd63b0299d6a7$export$97d96bf9b84874d5(nodeType, count);
    }
    return $03ccd63b0299d6a7$var$nodeObject(node);
};
$03ccd63b0299d6a7$var$addMethodChaining('toArray', (node, count)=>$03ccd63b0299d6a7$var$array(Array(count).fill(node)));
/**
 * These node represents an assign operation. Meaning a node is assigned
 * to another node.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$ebe87770a40e383b extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'AssignNode';
    }
    /**
	 * Constructs a new assign node.
	 *
	 * @param {Node} targetNode - The target node.
	 * @param {Node} sourceNode - The source type.
	 */ constructor(targetNode, sourceNode){
        super();
        /**
		 * The target node.
		 *
		 * @type {Node}
		 */ this.targetNode = targetNode;
        /**
		 * The source node.
		 *
		 * @type {Node}
		 */ this.sourceNode = sourceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAssignNode = true;
    }
    /**
	 * Whether this node is used more than once in context of other nodes. This method
	 * is overwritten since it always returns `false` (assigns are unique).
	 *
	 * @return {boolean} A flag that indicates if there is more than one dependency to other nodes. Always `false`.
	 */ hasDependencies() {
        return false;
    }
    generateNodeType(builder, output) {
        return output !== 'void' ? this.targetNode.getNodeType(builder) : 'void';
    }
    /**
	 * Whether a split is required when assigning source to target. This can happen when the component length of
	 * target and source data type does not match.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether a split is required when assigning source to target.
	 */ needsSplitAssign(builder) {
        const { targetNode: targetNode } = this;
        if (builder.isAvailable('swizzleAssign') === false && targetNode.isSplitNode && targetNode.components.length > 1) {
            const targetLength = builder.getTypeLength(targetNode.node.getNodeType(builder));
            const assignDifferentVector = $03ccd63b0299d6a7$export$1c0adcb9073b646d.join('').slice(0, targetLength) !== targetNode.components;
            return assignDifferentVector;
        }
        return false;
    }
    setup(builder) {
        const { targetNode: targetNode, sourceNode: sourceNode } = this;
        const scope = targetNode.getScope();
        const scopeData = builder.getDataFromNode(scope);
        scopeData.assign = true;
        const properties = builder.getNodeProperties(this);
        properties.sourceNode = sourceNode;
        properties.targetNode = targetNode.context({
            assign: true
        });
    }
    generate(builder, output) {
        const { targetNode: targetNode, sourceNode: sourceNode } = builder.getNodeProperties(this);
        const needsSplitAssign = this.needsSplitAssign(builder);
        const target = targetNode.build(builder);
        const targetType = targetNode.getNodeType(builder);
        const source = sourceNode.build(builder, targetType);
        const sourceType = sourceNode.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        //
        let snippet;
        if (nodeData.initialized === true) {
            if (output !== 'void') snippet = target;
        } else if (needsSplitAssign) {
            const sourceVar = builder.getVarFromNode(this, null, targetType);
            const sourceProperty = builder.getPropertyName(sourceVar);
            builder.addLineFlowCode(`${sourceProperty} = ${source}`, this);
            const splitNode = targetNode.node;
            const splitTargetNode = splitNode.node.context({
                assign: true
            });
            const targetRoot = splitTargetNode.build(builder);
            for(let i = 0; i < splitNode.components.length; i++){
                const component = splitNode.components[i];
                builder.addLineFlowCode(`${targetRoot}.${component} = ${sourceProperty}[ ${i} ]`, this);
            }
            if (output !== 'void') snippet = target;
        } else {
            snippet = `${target} = ${source}`;
            if (output === 'void' || sourceType === 'void') {
                builder.addLineFlowCode(snippet, this);
                if (output !== 'void') snippet = target;
            }
        }
        nodeData.initialized = true;
        return builder.format(snippet, targetType, output);
    }
}
/**
 * TSL function for creating an assign node.
 *
 * @tsl
 * @function
 * @param {Node} targetNode - The target node.
 * @param {Node} sourceNode - The source type.
 * @returns {AssignNode}
 */ const $03ccd63b0299d6a7$var$assign = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$ebe87770a40e383b).setParameterLength(2);
$03ccd63b0299d6a7$var$addMethodChaining('assign', $03ccd63b0299d6a7$var$assign);
/**
 * This module represents the call of a {@link FunctionNode}. Developers are usually not confronted
 * with this module since they use the predefined TSL syntax `wgslFn` and `glslFn` which encapsulate
 * this logic.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$cc00f01476ebb746 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'FunctionCallNode';
    }
    /**
	 * Constructs a new function call node.
	 *
	 * @param {?FunctionNode} functionNode - The function node.
	 * @param {Object<string, Node>} [parameters={}] - The parameters for the function call.
	 */ constructor(functionNode = null, parameters = {}){
        super();
        /**
		 * The function node.
		 *
		 * @type {?FunctionNode}
		 * @default null
		 */ this.functionNode = functionNode;
        /**
		 * The parameters of the function call.
		 *
		 * @type {Object<string, Node>}
		 * @default {}
		 */ this.parameters = parameters;
    }
    /**
	 * Sets the parameters of the function call node.
	 *
	 * @param {Object<string, Node>} parameters - The parameters to set.
	 * @return {FunctionCallNode} A reference to this node.
	 */ setParameters(parameters) {
        this.parameters = parameters;
        return this;
    }
    /**
	 * Returns the parameters of the function call node.
	 *
	 * @return {Object<string, Node>} The parameters of this node.
	 */ getParameters() {
        return this.parameters;
    }
    /**
	 * Returns the type of this function call node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @returns {string} The type of this node.
	 */ generateNodeType(builder) {
        return this.functionNode.getNodeType(builder);
    }
    /**
	 * Returns the function node of this function call node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} [name] - The name of the member.
	 * @returns {string} The type of the member.
	 */ getMemberType(builder, name) {
        return this.functionNode.getMemberType(builder, name);
    }
    generate(builder) {
        const params = [];
        const functionNode = this.functionNode;
        const inputs = functionNode.getInputs(builder);
        const parameters = this.parameters;
        const generateInput = (node, inputNode)=>{
            const type = inputNode.type;
            const pointer = type === 'pointer';
            let output;
            if (pointer) output = '&' + node.build(builder);
            else output = node.build(builder, type);
            return output;
        };
        if (Array.isArray(parameters)) {
            if (parameters.length > inputs.length) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: The number of provided parameters exceeds the expected number of inputs in \'Fn()\'.');
                parameters.length = inputs.length;
            } else if (parameters.length < inputs.length) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: The number of provided parameters is less than the expected number of inputs in \'Fn()\'.');
                while(parameters.length < inputs.length)parameters.push($03ccd63b0299d6a7$var$float(0));
            }
            for(let i = 0; i < parameters.length; i++)params.push(generateInput(parameters[i], inputs[i]));
        } else for (const inputNode of inputs){
            const node = parameters[inputNode.name];
            if (node !== undefined) params.push(generateInput(node, inputNode));
            else {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Input '${inputNode.name}' not found in \'Fn()\'.`);
                params.push(generateInput($03ccd63b0299d6a7$var$float(0), inputNode));
            }
        }
        const functionName = functionNode.build(builder, 'property');
        return `${functionName}( ${params.join(', ')} )`;
    }
}
const $03ccd63b0299d6a7$var$call = (func, ...params)=>{
    params = params.length > 1 || params[0] && params[0].isNode === true ? $03ccd63b0299d6a7$var$nodeArray(params) : $03ccd63b0299d6a7$var$nodeObjects(params[0]);
    return new $03ccd63b0299d6a7$export$cc00f01476ebb746($03ccd63b0299d6a7$var$nodeObject(func), params);
};
$03ccd63b0299d6a7$var$addMethodChaining('call', $03ccd63b0299d6a7$var$call);
const $03ccd63b0299d6a7$var$_vectorOperators = {
    '==': 'equal',
    '!=': 'notEqual',
    '<': 'lessThan',
    '>': 'greaterThan',
    '<=': 'lessThanEqual',
    '>=': 'greaterThanEqual',
    '%': 'mod'
};
/**
 * This node represents basic mathematical and logical operations like addition,
 * subtraction or comparisons (e.g. `equal()`).
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$cd498840ad265e90 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'OperatorNode';
    }
    /**
	 * Constructs a new operator node.
	 *
	 * @param {string} op - The operator.
	 * @param {Node} aNode - The first input.
	 * @param {Node} bNode - The second input.
	 * @param {...Node} params - Additional input parameters.
	 */ constructor(op, aNode, bNode, ...params){
        super();
        if (params.length > 0) {
            let finalOp = new $03ccd63b0299d6a7$export$cd498840ad265e90(op, aNode, bNode);
            for(let i = 0; i < params.length - 1; i++)finalOp = new $03ccd63b0299d6a7$export$cd498840ad265e90(op, finalOp, params[i]);
            aNode = finalOp;
            bNode = params[params.length - 1];
        }
        /**
		 * The operator.
		 *
		 * @type {string}
		 */ this.op = op;
        /**
		 * The first input.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The second input.
		 *
		 * @type {Node}
		 */ this.bNode = bNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOperatorNode = true;
    }
    /**
	 * Returns the operator method name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The output type.
	 * @returns {string} The operator method name.
	 */ getOperatorMethod(builder, output) {
        return builder.getMethod($03ccd63b0299d6a7$var$_vectorOperators[this.op], output);
    }
    /**
	 * This method is overwritten since the node type is inferred from the operator
	 * and the input node types.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {?string} [output=null] - The output type.
	 * @return {string} The node type.
	 */ generateNodeType(builder, output = null) {
        const op = this.op;
        const aNode = this.aNode;
        const bNode = this.bNode;
        const typeA = aNode.getNodeType(builder);
        const typeB = bNode ? bNode.getNodeType(builder) : null;
        if (typeA === 'void' || typeB === 'void') return output || 'void';
        else if (op === '%') return typeA;
        else if (op === '~' || op === '&' || op === '|' || op === '^' || op === '>>' || op === '<<') return builder.getIntegerType(typeA);
        else if (op === '!' || op === '&&' || op === '||' || op === '^^') return 'bool';
        else if (op === '==' || op === '!=' || op === '<' || op === '>' || op === '<=' || op === '>=') {
            const typeLength = Math.max(builder.getTypeLength(typeA), builder.getTypeLength(typeB));
            return typeLength > 1 ? `bvec${typeLength}` : 'bool';
        } else {
            // Handle matrix operations
            if (builder.isMatrix(typeA)) {
                if (typeB === 'float') return typeA; // matrix * scalar = matrix
                else if (builder.isVector(typeB)) return builder.getVectorFromMatrix(typeA); // matrix * vector
                else if (builder.isMatrix(typeB)) return typeA; // matrix * matrix
            } else if (builder.isMatrix(typeB)) {
                if (typeA === 'float') return typeB; // scalar * matrix = matrix
                else if (builder.isVector(typeA)) return builder.getVectorFromMatrix(typeB); // vector * matrix
            }
            // Handle non-matrix cases
            if (builder.getTypeLength(typeB) > builder.getTypeLength(typeA)) // anytype x anytype: use the greater length vector
            return typeB;
            return typeA;
        }
    }
    generate(builder, output) {
        const op = this.op;
        const { aNode: aNode, bNode: bNode } = this;
        const type = this.getNodeType(builder, output);
        let typeA = null;
        let typeB = null;
        if (type !== 'void') {
            typeA = aNode.getNodeType(builder);
            typeB = bNode ? bNode.getNodeType(builder) : null;
            if (op === '<' || op === '>' || op === '<=' || op === '>=' || op === '==' || op === '!=') {
                if (builder.isVector(typeA)) typeB = typeA;
                else if (builder.isVector(typeB)) typeA = typeB;
                else if (typeA !== typeB) typeA = typeB = 'float';
            } else if (op === '>>' || op === '<<') {
                typeA = type;
                typeB = builder.changeComponentType(typeB, 'uint');
            } else if (op === '%') {
                typeA = type;
                typeB = builder.isInteger(typeA) && builder.isInteger(typeB) ? typeB : typeA;
            } else if (builder.isMatrix(typeA)) {
                if (typeB === 'float') // Keep matrix type for typeA, but ensure typeB stays float
                typeB = 'float';
                else if (builder.isVector(typeB)) // matrix x vector
                typeB = builder.getVectorFromMatrix(typeA);
                else if (builder.isMatrix(typeB)) ;
                else typeA = typeB = type;
            } else if (builder.isMatrix(typeB)) {
                if (typeA === 'float') // Keep matrix type for typeB, but ensure typeA stays float
                typeA = 'float';
                else if (builder.isVector(typeA)) // vector x matrix
                typeA = builder.getVectorFromMatrix(typeB);
                else typeA = typeB = type;
            } else // anytype x anytype
            typeA = typeB = type;
        } else typeA = typeB = type;
        const a = aNode.build(builder, typeA);
        const b = bNode ? bNode.build(builder, typeB) : null;
        const fnOpSnippet = builder.getFunctionOperator(op);
        if (output !== 'void') {
            const isGLSL = builder.renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3);
            if (op === '==' || op === '!=' || op === '<' || op === '>' || op === '<=' || op === '>=') {
                if (isGLSL) {
                    if (builder.isVector(typeA)) return builder.format(`${this.getOperatorMethod(builder, output)}( ${a}, ${b} )`, type, output);
                    else return builder.format(`( ${a} ${op} ${b} )`, type, output);
                } else // WGSL
                return builder.format(`( ${a} ${op} ${b} )`, type, output);
            } else if (op === '%') {
                if (builder.isInteger(typeB)) return builder.format(`( ${a} % ${b} )`, type, output);
                else return builder.format(`${this.getOperatorMethod(builder, type)}( ${a}, ${b} )`, type, output);
            } else if (op === '!' || op === '~') return builder.format(`(${op}${a})`, typeA, output);
            else if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else {
                // Handle matrix operations
                if (builder.isMatrix(typeA) && typeB === 'float') return builder.format(`( ${b} ${op} ${a} )`, type, output);
                else if (typeA === 'float' && builder.isMatrix(typeB)) return builder.format(`${a} ${op} ${b}`, type, output);
                else {
                    let snippet = `( ${a} ${op} ${b} )`;
                    if (!isGLSL && type === 'bool' && builder.isVector(typeA) && builder.isVector(typeB)) snippet = `all${snippet}`;
                    return builder.format(snippet, type, output);
                }
            }
        } else if (typeA !== 'void') {
            if (fnOpSnippet) return builder.format(`${fnOpSnippet}( ${a}, ${b} )`, type, output);
            else {
                if (builder.isMatrix(typeA) && typeB === 'float') return builder.format(`${b} ${op} ${a}`, type, output);
                else return builder.format(`${a} ${op} ${b}`, type, output);
            }
        }
    }
    serialize(data) {
        super.serialize(data);
        data.op = this.op;
    }
    deserialize(data) {
        super.deserialize(data);
        this.op = data.op;
    }
}
/**
 * Returns the addition of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$add = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '+').setParameterLength(2, Infinity).setName('add');
/**
 * Returns the subtraction of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$sub = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '-').setParameterLength(2, Infinity).setName('sub');
/**
 * Returns the multiplication of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$mul = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '*').setParameterLength(2, Infinity).setName('mul');
/**
 * Returns the division of two or more value.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @param {...Node} params - Additional input parameters.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$div = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '/').setParameterLength(2, Infinity).setName('div');
/**
 * Computes the remainder of dividing the first node by the second one.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$mod = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '%').setParameterLength(2).setName('mod');
/**
 * Checks if two nodes are equal.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$equal = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '==').setParameterLength(2).setName('equal');
/**
 * Checks if two nodes are not equal.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$notEqual = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '!=').setParameterLength(2).setName('notEqual');
/**
 * Checks if the first node is less than the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$lessThan = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '<').setParameterLength(2).setName('lessThan');
/**
 * Checks if the first node is greater than the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$greaterThan = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '>').setParameterLength(2).setName('greaterThan');
/**
 * Checks if the first node is less than or equal to the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$lessThanEqual = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '<=').setParameterLength(2).setName('lessThanEqual');
/**
 * Checks if the first node is greater than or equal to the second.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$greaterThanEqual = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '>=').setParameterLength(2).setName('greaterThanEqual');
/**
 * Performs a logical AND operation on multiple nodes.
 *
 * @tsl
 * @function
 * @param {...Node} nodes - The input nodes to be combined using AND.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$and = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '&&').setParameterLength(2, Infinity).setName('and');
/**
 * Performs a logical OR operation on multiple nodes.
 *
 * @tsl
 * @function
 * @param {...Node} nodes - The input nodes to be combined using OR.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$or = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '||').setParameterLength(2, Infinity).setName('or');
/**
 * Performs logical NOT on a node.
 *
 * @tsl
 * @function
 * @param {Node} value - The value.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$not = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '!').setParameterLength(1).setName('not');
/**
 * Performs logical XOR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$xor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '^^').setParameterLength(2).setName('xor');
/**
 * Performs bitwise AND on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$bitAnd = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '&').setParameterLength(2).setName('bitAnd');
/**
 * Performs bitwise NOT on a node.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$bitNot = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '~').setParameterLength(1).setName('bitNot');
/**
 * Performs bitwise OR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$bitOr = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '|').setParameterLength(2).setName('bitOr');
/**
 * Performs bitwise XOR on two nodes.
 *
 * @tsl
 * @function
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$bitXor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '^').setParameterLength(2).setName('bitXor');
/**
 * Shifts a node to the left.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to shift.
 * @param {Node} b - The value to shift.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$shiftLeft = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '<<').setParameterLength(2).setName('shiftLeft');
/**
 * Shifts a node to the right.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to shift.
 * @param {Node} b - The value to shift.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$shiftRight = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$cd498840ad265e90, '>>').setParameterLength(2).setName('shiftRight');
/**
 * Increments a node by 1.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to increment.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$incrementBefore = $03ccd63b0299d6a7$var$Fn(([a])=>{
    a.addAssign(1);
    return a;
});
/**
 * Decrements a node by 1.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to decrement.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$decrementBefore = $03ccd63b0299d6a7$var$Fn(([a])=>{
    a.subAssign(1);
    return a;
});
/**
 * Increments a node by 1 and returns the previous value.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to increment.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$increment = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([a])=>{
    const temp = $03ccd63b0299d6a7$var$int(a).toConst();
    a.addAssign(1);
    return temp;
});
/**
 * Decrements a node by 1 and returns the previous value.
 *
 * @tsl
 * @function
 * @param {Node} a - The node to decrement.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$decrement = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([a])=>{
    const temp = $03ccd63b0299d6a7$var$int(a).toConst();
    a.subAssign(1);
    return temp;
});
$03ccd63b0299d6a7$var$addMethodChaining('add', $03ccd63b0299d6a7$var$add);
$03ccd63b0299d6a7$var$addMethodChaining('sub', $03ccd63b0299d6a7$var$sub);
$03ccd63b0299d6a7$var$addMethodChaining('mul', $03ccd63b0299d6a7$var$mul);
$03ccd63b0299d6a7$var$addMethodChaining('div', $03ccd63b0299d6a7$var$div);
$03ccd63b0299d6a7$var$addMethodChaining('mod', $03ccd63b0299d6a7$var$mod);
$03ccd63b0299d6a7$var$addMethodChaining('equal', $03ccd63b0299d6a7$var$equal);
$03ccd63b0299d6a7$var$addMethodChaining('notEqual', $03ccd63b0299d6a7$var$notEqual);
$03ccd63b0299d6a7$var$addMethodChaining('lessThan', $03ccd63b0299d6a7$var$lessThan);
$03ccd63b0299d6a7$var$addMethodChaining('greaterThan', $03ccd63b0299d6a7$var$greaterThan);
$03ccd63b0299d6a7$var$addMethodChaining('lessThanEqual', $03ccd63b0299d6a7$var$lessThanEqual);
$03ccd63b0299d6a7$var$addMethodChaining('greaterThanEqual', $03ccd63b0299d6a7$var$greaterThanEqual);
$03ccd63b0299d6a7$var$addMethodChaining('and', $03ccd63b0299d6a7$var$and);
$03ccd63b0299d6a7$var$addMethodChaining('or', $03ccd63b0299d6a7$var$or);
$03ccd63b0299d6a7$var$addMethodChaining('not', $03ccd63b0299d6a7$var$not);
$03ccd63b0299d6a7$var$addMethodChaining('xor', $03ccd63b0299d6a7$var$xor);
$03ccd63b0299d6a7$var$addMethodChaining('bitAnd', $03ccd63b0299d6a7$var$bitAnd);
$03ccd63b0299d6a7$var$addMethodChaining('bitNot', $03ccd63b0299d6a7$var$bitNot);
$03ccd63b0299d6a7$var$addMethodChaining('bitOr', $03ccd63b0299d6a7$var$bitOr);
$03ccd63b0299d6a7$var$addMethodChaining('bitXor', $03ccd63b0299d6a7$var$bitXor);
$03ccd63b0299d6a7$var$addMethodChaining('shiftLeft', $03ccd63b0299d6a7$var$shiftLeft);
$03ccd63b0299d6a7$var$addMethodChaining('shiftRight', $03ccd63b0299d6a7$var$shiftRight);
$03ccd63b0299d6a7$var$addMethodChaining('incrementBefore', $03ccd63b0299d6a7$var$incrementBefore);
$03ccd63b0299d6a7$var$addMethodChaining('decrementBefore', $03ccd63b0299d6a7$var$decrementBefore);
$03ccd63b0299d6a7$var$addMethodChaining('increment', $03ccd63b0299d6a7$var$increment);
$03ccd63b0299d6a7$var$addMethodChaining('decrement', $03ccd63b0299d6a7$var$decrement);
/**
 * @tsl
 * @function
 * @deprecated since r175. Use {@link mod} instead.
 *
 * @param {Node} a - The first input.
 * @param {Node} b - The second input.
 * @returns {OperatorNode}
 */ const $03ccd63b0299d6a7$var$modInt = (a, b)=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "modInt()" is deprecated. Use "mod( int( ... ) )" instead.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    return $03ccd63b0299d6a7$var$mod($03ccd63b0299d6a7$var$int(a), $03ccd63b0299d6a7$var$int(b));
};
$03ccd63b0299d6a7$var$addMethodChaining('modInt', $03ccd63b0299d6a7$var$modInt);
/**
 * This node represents a variety of mathematical methods available in shaders.
 * They are divided into three categories:
 *
 * - Methods with one input like `sin`, `cos` or `normalize`.
 * - Methods with two inputs like `dot`, `cross` or `pow`.
 * - Methods with three inputs like `mix`, `clamp` or `smoothstep`.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$d9018c0f6b611cfb extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'MathNode';
    }
    /**
	 * Constructs a new math node.
	 *
	 * @param {string} method - The method name.
	 * @param {Node} aNode - The first input.
	 * @param {?Node} [bNode=null] - The second input.
	 * @param {?Node} [cNode=null] - The third input.
	 */ constructor(method, aNode, bNode = null, cNode = null){
        super();
        // Allow the max() and min() functions to take an arbitrary number of arguments.
        if ((method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MAX || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIN) && arguments.length > 3) {
            let finalOp = new $03ccd63b0299d6a7$export$d9018c0f6b611cfb(method, aNode, bNode);
            for(let i = 2; i < arguments.length - 1; i++)finalOp = new $03ccd63b0299d6a7$export$d9018c0f6b611cfb(method, finalOp, arguments[i]);
            aNode = finalOp;
            bNode = arguments[arguments.length - 1];
            cNode = null;
        }
        /**
		 * The method name.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * The first input.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The second input.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.bNode = bNode;
        /**
		 * The third input.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.cNode = cNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMathNode = true;
    }
    /**
	 * The input type is inferred from the node types of the input nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        const aType = this.aNode.getNodeType(builder);
        const bType = this.bNode ? this.bNode.getNodeType(builder) : null;
        const cType = this.cNode ? this.cNode.getNodeType(builder) : null;
        const aLen = builder.isMatrix(aType) ? 0 : builder.getTypeLength(aType);
        const bLen = builder.isMatrix(bType) ? 0 : builder.getTypeLength(bType);
        const cLen = builder.isMatrix(cType) ? 0 : builder.getTypeLength(cType);
        if (aLen > bLen && aLen > cLen) return aType;
        else if (bLen > cLen) return bType;
        else if (cLen > aLen) return cType;
        return aType;
    }
    /**
	 * The selected method as well as the input type determine the node type of this node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        const method = this.method;
        if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.LENGTH || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DISTANCE || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DOT) return 'float';
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.CROSS) return 'vec3';
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ALL || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ANY) return 'bool';
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.EQUALS) return builder.changeComponentType(this.aNode.getNodeType(builder), 'bool');
        else return this.getInputType(builder);
    }
    setup(builder) {
        const { aNode: aNode, bNode: bNode, method: method } = this;
        let outputNode = null;
        if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ONE_MINUS) outputNode = $03ccd63b0299d6a7$var$sub(1.0, aNode);
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.RECIPROCAL) outputNode = $03ccd63b0299d6a7$var$div(1.0, aNode);
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DIFFERENCE) outputNode = $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sub(aNode, bNode));
        else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRANSFORM_DIRECTION) {
            // dir can be either a direction vector or a normal vector
            // upper-left 3x3 of matrix is assumed to be orthogonal
            let tA = aNode;
            let tB = bNode;
            if (builder.isMatrix(tA.getNodeType(builder))) tB = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$vec3(tB), 0.0);
            else tA = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$vec3(tA), 0.0);
            const mulNode = $03ccd63b0299d6a7$var$mul(tA, tB).xyz;
            outputNode = $03ccd63b0299d6a7$var$normalize(mulNode);
        }
        if (outputNode !== null) return outputNode;
        else return super.setup(builder);
    }
    generate(builder, output) {
        const properties = builder.getNodeProperties(this);
        if (properties.outputNode) return super.generate(builder, output);
        let method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.aNode;
        const b = this.bNode;
        const c = this.cNode;
        const coordinateSystem = builder.renderer.coordinateSystem;
        if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.NEGATE) return builder.format('( - ' + a.build(builder, inputType) + ' )', type, output);
        else {
            const params = [];
            if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.CROSS) params.push(a.build(builder, type), b.build(builder, type));
            else if (coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) && method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.STEP) params.push(a.build(builder, builder.getTypeLength(a.getNodeType(builder)) === 1 ? 'float' : inputType), b.build(builder, inputType));
            else if (coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3) && (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIN || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MAX)) params.push(a.build(builder, inputType), b.build(builder, builder.getTypeLength(b.getNodeType(builder)) === 1 ? 'float' : inputType));
            else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.REFRACT) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, 'float'));
            else if (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIX) params.push(a.build(builder, inputType), b.build(builder, inputType), c.build(builder, builder.getTypeLength(c.getNodeType(builder)) === 1 ? 'float' : inputType));
            else {
                if (coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) && method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ATAN && b !== null) method = 'atan2';
                if (builder.shaderStage !== 'fragment' && (method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDX || method === $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDY)) {
                    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`TSL: '${method}' is not supported in the ${builder.shaderStage} stage.`, this.stackTrace);
                    method = '/*' + method + '*/';
                }
                params.push(a.build(builder, inputType));
                if (b !== null) params.push(b.build(builder, inputType));
                if (c !== null) params.push(c.build(builder, inputType));
            }
            return builder.format(`${builder.getMethod(method, type)}( ${params.join(', ')} )`, type, output);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.method = this.method;
    }
    deserialize(data) {
        super.deserialize(data);
        this.method = data.method;
    }
}
// 1 input
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ALL = 'all';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ANY = 'any';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.RADIANS = 'radians';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DEGREES = 'degrees';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.EXP = 'exp';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.EXP2 = 'exp2';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.LOG = 'log';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.LOG2 = 'log2';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.SQRT = 'sqrt';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.INVERSE_SQRT = 'inversesqrt';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.FLOOR = 'floor';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.CEIL = 'ceil';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.NORMALIZE = 'normalize';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.FRACT = 'fract';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.SIN = 'sin';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.SINH = 'sinh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.COS = 'cos';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.COSH = 'cosh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.TAN = 'tan';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.TANH = 'tanh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ASIN = 'asin';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ASINH = 'asinh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ACOS = 'acos';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ACOSH = 'acosh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ATAN = 'atan';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ATANH = 'atanh';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ABS = 'abs';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.SIGN = 'sign';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.LENGTH = 'length';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.NEGATE = 'negate';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ONE_MINUS = 'oneMinus';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDX = 'dFdx';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDY = 'dFdy';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.ROUND = 'round';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.RECIPROCAL = 'reciprocal';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRUNC = 'trunc';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.FWIDTH = 'fwidth';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRANSPOSE = 'transpose';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DETERMINANT = 'determinant';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.INVERSE = 'inverse';
// 2 inputs
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.EQUALS = 'equals';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIN = 'min';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.MAX = 'max';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.STEP = 'step';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.REFLECT = 'reflect';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DISTANCE = 'distance';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DIFFERENCE = 'difference';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.DOT = 'dot';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.CROSS = 'cross';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.POW = 'pow';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRANSFORM_DIRECTION = 'transformDirection';
// 3 inputs
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIX = 'mix';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.CLAMP = 'clamp';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.REFRACT = 'refract';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.SMOOTHSTEP = 'smoothstep';
$03ccd63b0299d6a7$export$d9018c0f6b611cfb.FACEFORWARD = 'faceforward';
// 1 inputs
/**
 * A small value used to handle floating-point precision errors.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$EPSILON = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(1e-6);
/**
 * Represents infinity.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$INFINITY = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(1e6);
/**
 * Represents PI.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$PI = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(Math.PI);
/**
 * Represents PI * 2. Please use the non-deprecated version `TWO_PI`.
 *
 * @tsl
 * @deprecated
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$PI2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(Math.PI * 2); // @deprecated r181
/**
 * Represents PI * 2.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$TWO_PI = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(Math.PI * 2);
/**
 * Represents PI / 2.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$HALF_PI = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(Math.PI * 0.5);
/**
 * Returns `true` if all components of `x` are `true`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node<bool>}
 */ const $03ccd63b0299d6a7$var$all = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ALL).setParameterLength(1);
/**
 * Returns `true` if any components of `x` are `true`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node<bool>}
 */ const $03ccd63b0299d6a7$var$any = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ANY).setParameterLength(1);
/**
 * Converts a quantity in degrees to radians.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input in degrees.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$radians = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.RADIANS).setParameterLength(1);
/**
 * Convert a quantity in radians to degrees.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input in radians.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$degrees = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DEGREES).setParameterLength(1);
/**
 * Returns the natural exponentiation of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$exp = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.EXP).setParameterLength(1);
/**
 * Returns 2 raised to the power of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$exp2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.EXP2).setParameterLength(1);
/**
 * Returns the natural logarithm of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$log = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.LOG).setParameterLength(1);
/**
 * Returns the base 2 logarithm of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$log2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.LOG2).setParameterLength(1);
/**
 * Returns the square root of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$sqrt = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.SQRT).setParameterLength(1);
/**
 * Returns the inverse of the square root of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$inverseSqrt = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.INVERSE_SQRT).setParameterLength(1);
/**
 * Finds the nearest integer less than or equal to the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$floor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.FLOOR).setParameterLength(1);
/**
 * Finds the nearest integer that is greater than or equal to the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$ceil = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.CEIL).setParameterLength(1);
/**
 * Calculates the unit vector in the same direction as the original vector.
 *
 * @tsl
 * @function
 * @param {Node} x - The input vector.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$normalize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.NORMALIZE).setParameterLength(1);
/**
 * Computes the fractional part of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$fract = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.FRACT).setParameterLength(1);
/**
 * Returns the sine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$sin = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.SIN).setParameterLength(1);
/**
 * Returns the hyperbolic sine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$sinh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.SINH).setParameterLength(1);
/**
 * Returns the cosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$cos = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.COS).setParameterLength(1);
/**
 * Returns the hyperbolic cosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$cosh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.COSH).setParameterLength(1);
/**
 * Returns the tangent of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$tan = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TAN).setParameterLength(1);
/**
 * Returns the hyperbolic tangent of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$tanh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TANH).setParameterLength(1);
/**
 * Returns the arcsine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$asin = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ASIN).setParameterLength(1);
/**
 * Returns the inverse hyperbolic sine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$asinh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ASINH).setParameterLength(1);
/**
 * Returns the arccosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$acos = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ACOS).setParameterLength(1);
/**
 * Returns the inverse hyperbolic cosine of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$acosh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ACOSH).setParameterLength(1);
/**
 * Returns the arc-tangent of the parameter.
 * If two parameters are provided, the result is `atan2(y/x)`.
 *
 * @tsl
 * @function
 * @param {Node | number} y - The y parameter.
 * @param {?(Node | number)} x - The x parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$atan = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ATAN).setParameterLength(1, 2);
/**
 * Returns the inverse hyperbolic tangent of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$atanh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ATANH).setParameterLength(1);
/**
 * Returns the absolute value of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$abs = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ABS).setParameterLength(1);
/**
 * Extracts the sign of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$sign = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.SIGN).setParameterLength(1);
/**
 * Calculates the length of a vector.
 *
 * @tsl
 * @function
 * @param {Node} x - The parameter.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$length = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.LENGTH).setParameterLength(1);
/**
 * Negates the value of the parameter (-x).
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$negate = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.NEGATE).setParameterLength(1);
/**
 * Return `1` minus the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$oneMinus = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ONE_MINUS).setParameterLength(1);
/**
 * Returns the partial derivative of the parameter with respect to x.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$dFdx = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDX).setParameterLength(1);
/**
 * Returns the partial derivative of the parameter with respect to y.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$dFdy = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DFDY).setParameterLength(1);
/**
 * Rounds the parameter to the nearest integer.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$round = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.ROUND).setParameterLength(1);
/**
 * Returns the reciprocal of the parameter `(1/x)`.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$reciprocal = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.RECIPROCAL).setParameterLength(1);
/**
 * Truncates the parameter, removing the fractional part.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$trunc = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRUNC).setParameterLength(1);
/**
 * Returns the sum of the absolute derivatives in x and y.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$fwidth = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.FWIDTH).setParameterLength(1);
/**
 * Returns the transpose of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$transpose = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRANSPOSE).setParameterLength(1);
/**
 * Returns the determinant of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$determinant = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DETERMINANT).setParameterLength(1);
/**
 * Returns the inverse of a matrix.
 *
 * @tsl
 * @function
 * @param {Node<mat2|mat3|mat4>} x - The parameter.
 * @returns {Node<mat2|mat3|mat4>}
 */ const $03ccd63b0299d6a7$var$inverse = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.INVERSE).setParameterLength(1);
// 2 inputs
/**
 * Returns the least of the given values.
 *
 * @tsl
 * @function
 * @param {...(Node | number)} values - The values to compare.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$min$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIN).setParameterLength(2, Infinity);
/**
 * Returns the greatest of the given values.
 *
 * @tsl
 * @function
 * @param {...(Node | number)} values - The values to compare.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$max$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MAX).setParameterLength(2, Infinity);
/**
 * Generate a step function by comparing two values.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The y parameter.
 * @param {Node | number} y - The x parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$step = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.STEP).setParameterLength(2);
/**
 * Calculates the reflection direction for an incident vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} N - The normal vector.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $03ccd63b0299d6a7$var$reflect = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.REFLECT).setParameterLength(2);
/**
 * Calculates the distance between two points.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} x - The first point.
 * @param {Node<vec2|vec3|vec4>} y - The second point.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$distance = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DISTANCE).setParameterLength(2);
/**
 * Calculates the absolute difference between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @param {Node | number} y - The second parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$difference = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DIFFERENCE).setParameterLength(2);
/**
 * Calculates the dot product of two vectors.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} x - The first vector.
 * @param {Node<vec2|vec3|vec4>} y - The second vector.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$dot = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.DOT).setParameterLength(2);
/**
 * Calculates the cross product of two vectors.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3>} x - The first vector.
 * @param {Node<vec2|vec3>} y - The second vector.
 * @returns {Node<float|vec3>}
 */ const $03ccd63b0299d6a7$var$cross = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.CROSS).setParameterLength(2);
/**
 * Return the value of the first parameter raised to the power of the second one.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @param {Node | number} y - The second parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$pow = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.POW).setParameterLength(2);
/**
 * Returns the square of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$pow2 = (x)=>$03ccd63b0299d6a7$var$mul(x, x);
/**
 * Returns the cube of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$pow3 = (x)=>$03ccd63b0299d6a7$var$mul(x, x, x);
/**
 * Returns the fourth power of the parameter.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The first parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$pow4 = (x)=>$03ccd63b0299d6a7$var$mul(x, x, x, x);
/**
 * Transforms the direction of a vector by a matrix and then normalizes the result.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} direction - The direction vector.
 * @param {Node<mat2|mat3|mat4>} matrix - The transformation matrix.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$transformDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.TRANSFORM_DIRECTION).setParameterLength(2);
/**
 * Returns the cube root of a number.
 *
 * @tsl
 * @function
 * @param {Node | number} a - The first parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$cbrt = (a)=>$03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$sign(a), $03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$abs(a), 1.0 / 3.0));
/**
 * Calculate the squared length of a vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} a - The vector.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$lengthSq = (a)=>$03ccd63b0299d6a7$var$dot(a, a);
/**
 * Linearly interpolates between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} a - The first parameter.
 * @param {Node | number} b - The second parameter.
 * @param {Node | number} t - The interpolation value.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$mix = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.MIX).setParameterLength(3);
/**
 * Constrains a value to lie between two further values.
 *
 * @tsl
 * @function
 * @param {Node | number} value - The value to constrain.
 * @param {Node | number} [low=0] - The lower bound.
 * @param {Node | number} [high=1] - The upper bound.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$clamp = (value, low = 0, high = 1)=>new $03ccd63b0299d6a7$export$d9018c0f6b611cfb($03ccd63b0299d6a7$export$d9018c0f6b611cfb.CLAMP, $03ccd63b0299d6a7$var$nodeObject(value), $03ccd63b0299d6a7$var$nodeObject(low), $03ccd63b0299d6a7$var$nodeObject(high));
/**
 * Constrains a value between `0` and `1`.
 *
 * @tsl
 * @function
 * @param {Node | number} value - The value to constrain.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$saturate = (value)=>$03ccd63b0299d6a7$var$clamp(value);
/**
 * Calculates the refraction direction for an incident vector.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} N - The normal vector.
 * @param {Node<float>} eta - The ratio of indices of refraction.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $03ccd63b0299d6a7$var$refract = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.REFRACT).setParameterLength(3);
/**
 * Performs a Hermite interpolation between two values.
 *
 * @tsl
 * @function
 * @param {Node | number} low - The value of the lower edge of the Hermite function.
 * @param {Node | number} high - The value of the upper edge of the Hermite function.
 * @param {Node | number} x - The source value for interpolation.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$smoothstep = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.SMOOTHSTEP).setParameterLength(3);
/**
 * Returns a vector pointing in the same direction as another.
 *
 * @tsl
 * @function
 * @param {Node<vec2|vec3|vec4>} N - The vector to orient.
 * @param {Node<vec2|vec3|vec4>} I - The incident vector.
 * @param {Node<vec2|vec3|vec4>} Nref - The reference vector.
 * @returns {Node<vec2|vec3|vec4>}
 */ const $03ccd63b0299d6a7$var$faceForward = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$d9018c0f6b611cfb, $03ccd63b0299d6a7$export$d9018c0f6b611cfb.FACEFORWARD).setParameterLength(3);
/**
 * Returns a random value for the given uv.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv node.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$rand = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv])=>{
    const a = 12.9898, b = 78.233, c = 43758.5453;
    const dt = $03ccd63b0299d6a7$var$dot(uv.xy, $03ccd63b0299d6a7$var$vec2(a, b)), sn = $03ccd63b0299d6a7$var$mod(dt, $03ccd63b0299d6a7$var$PI);
    return $03ccd63b0299d6a7$var$fract($03ccd63b0299d6a7$var$sin(sn).mul(c));
});
/**
 * Alias for `mix()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} t - The interpolation value.
 * @param {Node | number} e1 - The first parameter.
 * @param {Node | number} e2 - The second parameter.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$mixElement = (t, e1, e2)=>$03ccd63b0299d6a7$var$mix(e1, e2, t);
/**
 * Alias for `smoothstep()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The source value for interpolation.
 * @param {Node | number} low - The value of the lower edge of the Hermite function.
 * @param {Node | number} high - The value of the upper edge of the Hermite function.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$smoothstepElement = (x, low, high)=>$03ccd63b0299d6a7$var$smoothstep(low, high, x);
/**
 * Alias for `step()` with a different parameter order.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The source value for interpolation.
 * @param {Node | number} edge - The edge value.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$stepElement = (x, edge)=>$03ccd63b0299d6a7$var$step(edge, x);
// GLSL alias function
const $03ccd63b0299d6a7$var$faceforward = $03ccd63b0299d6a7$var$faceForward;
const $03ccd63b0299d6a7$var$inversesqrt = $03ccd63b0299d6a7$var$inverseSqrt;
// Method chaining
$03ccd63b0299d6a7$var$addMethodChaining('all', $03ccd63b0299d6a7$var$all);
$03ccd63b0299d6a7$var$addMethodChaining('any', $03ccd63b0299d6a7$var$any);
$03ccd63b0299d6a7$var$addMethodChaining('radians', $03ccd63b0299d6a7$var$radians);
$03ccd63b0299d6a7$var$addMethodChaining('degrees', $03ccd63b0299d6a7$var$degrees);
$03ccd63b0299d6a7$var$addMethodChaining('exp', $03ccd63b0299d6a7$var$exp);
$03ccd63b0299d6a7$var$addMethodChaining('exp2', $03ccd63b0299d6a7$var$exp2);
$03ccd63b0299d6a7$var$addMethodChaining('log', $03ccd63b0299d6a7$var$log);
$03ccd63b0299d6a7$var$addMethodChaining('log2', $03ccd63b0299d6a7$var$log2);
$03ccd63b0299d6a7$var$addMethodChaining('sqrt', $03ccd63b0299d6a7$var$sqrt);
$03ccd63b0299d6a7$var$addMethodChaining('inverseSqrt', $03ccd63b0299d6a7$var$inverseSqrt);
$03ccd63b0299d6a7$var$addMethodChaining('floor', $03ccd63b0299d6a7$var$floor);
$03ccd63b0299d6a7$var$addMethodChaining('ceil', $03ccd63b0299d6a7$var$ceil);
$03ccd63b0299d6a7$var$addMethodChaining('normalize', $03ccd63b0299d6a7$var$normalize);
$03ccd63b0299d6a7$var$addMethodChaining('fract', $03ccd63b0299d6a7$var$fract);
$03ccd63b0299d6a7$var$addMethodChaining('sin', $03ccd63b0299d6a7$var$sin);
$03ccd63b0299d6a7$var$addMethodChaining('sinh', $03ccd63b0299d6a7$var$sinh);
$03ccd63b0299d6a7$var$addMethodChaining('cos', $03ccd63b0299d6a7$var$cos);
$03ccd63b0299d6a7$var$addMethodChaining('cosh', $03ccd63b0299d6a7$var$cosh);
$03ccd63b0299d6a7$var$addMethodChaining('tan', $03ccd63b0299d6a7$var$tan);
$03ccd63b0299d6a7$var$addMethodChaining('tanh', $03ccd63b0299d6a7$var$tanh);
$03ccd63b0299d6a7$var$addMethodChaining('asin', $03ccd63b0299d6a7$var$asin);
$03ccd63b0299d6a7$var$addMethodChaining('asinh', $03ccd63b0299d6a7$var$asinh);
$03ccd63b0299d6a7$var$addMethodChaining('acos', $03ccd63b0299d6a7$var$acos);
$03ccd63b0299d6a7$var$addMethodChaining('acosh', $03ccd63b0299d6a7$var$acosh);
$03ccd63b0299d6a7$var$addMethodChaining('atan', $03ccd63b0299d6a7$var$atan);
$03ccd63b0299d6a7$var$addMethodChaining('atanh', $03ccd63b0299d6a7$var$atanh);
$03ccd63b0299d6a7$var$addMethodChaining('abs', $03ccd63b0299d6a7$var$abs);
$03ccd63b0299d6a7$var$addMethodChaining('sign', $03ccd63b0299d6a7$var$sign);
$03ccd63b0299d6a7$var$addMethodChaining('length', $03ccd63b0299d6a7$var$length);
$03ccd63b0299d6a7$var$addMethodChaining('lengthSq', $03ccd63b0299d6a7$var$lengthSq);
$03ccd63b0299d6a7$var$addMethodChaining('negate', $03ccd63b0299d6a7$var$negate);
$03ccd63b0299d6a7$var$addMethodChaining('oneMinus', $03ccd63b0299d6a7$var$oneMinus);
$03ccd63b0299d6a7$var$addMethodChaining('dFdx', $03ccd63b0299d6a7$var$dFdx);
$03ccd63b0299d6a7$var$addMethodChaining('dFdy', $03ccd63b0299d6a7$var$dFdy);
$03ccd63b0299d6a7$var$addMethodChaining('round', $03ccd63b0299d6a7$var$round);
$03ccd63b0299d6a7$var$addMethodChaining('reciprocal', $03ccd63b0299d6a7$var$reciprocal);
$03ccd63b0299d6a7$var$addMethodChaining('trunc', $03ccd63b0299d6a7$var$trunc);
$03ccd63b0299d6a7$var$addMethodChaining('fwidth', $03ccd63b0299d6a7$var$fwidth);
$03ccd63b0299d6a7$var$addMethodChaining('min', $03ccd63b0299d6a7$var$min$1);
$03ccd63b0299d6a7$var$addMethodChaining('max', $03ccd63b0299d6a7$var$max$1);
$03ccd63b0299d6a7$var$addMethodChaining('step', $03ccd63b0299d6a7$var$stepElement);
$03ccd63b0299d6a7$var$addMethodChaining('reflect', $03ccd63b0299d6a7$var$reflect);
$03ccd63b0299d6a7$var$addMethodChaining('distance', $03ccd63b0299d6a7$var$distance);
$03ccd63b0299d6a7$var$addMethodChaining('dot', $03ccd63b0299d6a7$var$dot);
$03ccd63b0299d6a7$var$addMethodChaining('cross', $03ccd63b0299d6a7$var$cross);
$03ccd63b0299d6a7$var$addMethodChaining('pow', $03ccd63b0299d6a7$var$pow);
$03ccd63b0299d6a7$var$addMethodChaining('pow2', $03ccd63b0299d6a7$var$pow2);
$03ccd63b0299d6a7$var$addMethodChaining('pow3', $03ccd63b0299d6a7$var$pow3);
$03ccd63b0299d6a7$var$addMethodChaining('pow4', $03ccd63b0299d6a7$var$pow4);
$03ccd63b0299d6a7$var$addMethodChaining('transformDirection', $03ccd63b0299d6a7$var$transformDirection);
$03ccd63b0299d6a7$var$addMethodChaining('mix', $03ccd63b0299d6a7$var$mixElement);
$03ccd63b0299d6a7$var$addMethodChaining('clamp', $03ccd63b0299d6a7$var$clamp);
$03ccd63b0299d6a7$var$addMethodChaining('refract', $03ccd63b0299d6a7$var$refract);
$03ccd63b0299d6a7$var$addMethodChaining('smoothstep', $03ccd63b0299d6a7$var$smoothstepElement);
$03ccd63b0299d6a7$var$addMethodChaining('faceForward', $03ccd63b0299d6a7$var$faceForward);
$03ccd63b0299d6a7$var$addMethodChaining('difference', $03ccd63b0299d6a7$var$difference);
$03ccd63b0299d6a7$var$addMethodChaining('saturate', $03ccd63b0299d6a7$var$saturate);
$03ccd63b0299d6a7$var$addMethodChaining('cbrt', $03ccd63b0299d6a7$var$cbrt);
$03ccd63b0299d6a7$var$addMethodChaining('transpose', $03ccd63b0299d6a7$var$transpose);
$03ccd63b0299d6a7$var$addMethodChaining('determinant', $03ccd63b0299d6a7$var$determinant);
$03ccd63b0299d6a7$var$addMethodChaining('inverse', $03ccd63b0299d6a7$var$inverse);
$03ccd63b0299d6a7$var$addMethodChaining('rand', $03ccd63b0299d6a7$var$rand);
/**
 * Represents a logical `if/else` statement. Can be used as an alternative
 * to the `If()`/`Else()` syntax.
 *
 * The corresponding TSL `select()` looks like so:
 * ```js
 * velocity = position.greaterThanEqual( limit ).select( velocity.negate(), velocity );
 * ```
 * The `select()` method is called in a chaining fashion on a condition. The parameter nodes of `select()`
 * determine the outcome of the entire statement.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$8e402c64e6081013 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ConditionalNode';
    }
    /**
	 * Constructs a new conditional node.
	 *
	 * @param {Node} condNode - The node that defines the condition.
	 * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
	 * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
	 */ constructor(condNode, ifNode, elseNode = null){
        super();
        /**
		 * The node that defines the condition.
		 *
		 * @type {Node}
		 */ this.condNode = condNode;
        /**
		 * The node that is evaluate when the condition ends up `true`.
		 *
		 * @type {Node}
		 */ this.ifNode = ifNode;
        /**
		 * The node that is evaluate when the condition ends up `false`.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.elseNode = elseNode;
    }
    /**
	 * This method is overwritten since the node type is inferred from the if/else
	 * nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        const { ifNode: ifNode, elseNode: elseNode } = builder.getNodeProperties(this);
        if (ifNode === undefined) {
            // fallback setup
            builder.flowBuildStage(this, 'setup');
            return this.getNodeType(builder);
        }
        const ifType = ifNode.getNodeType(builder);
        if (elseNode !== null) {
            const elseType = elseNode.getNodeType(builder);
            if (builder.getTypeLength(elseType) > builder.getTypeLength(ifType)) return elseType;
        }
        return ifType;
    }
    setup(builder) {
        const condNode = this.condNode;
        const ifNode = this.ifNode.isolate();
        const elseNode = this.elseNode ? this.elseNode.isolate() : null;
        //
        const currentNodeBlock = builder.context.nodeBlock;
        builder.getDataFromNode(ifNode).parentNodeBlock = currentNodeBlock;
        if (elseNode !== null) builder.getDataFromNode(elseNode).parentNodeBlock = currentNodeBlock;
        //
        const isUniformFlow = builder.context.uniformFlow;
        const properties = builder.getNodeProperties(this);
        properties.condNode = condNode;
        properties.ifNode = isUniformFlow ? ifNode : ifNode.context({
            nodeBlock: ifNode
        });
        properties.elseNode = elseNode ? isUniformFlow ? elseNode : elseNode.context({
            nodeBlock: elseNode
        }) : null;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const nodeData = builder.getDataFromNode(this);
        if (nodeData.nodeProperty !== undefined) return nodeData.nodeProperty;
        const { condNode: condNode, ifNode: ifNode, elseNode: elseNode } = builder.getNodeProperties(this);
        const functionNode = builder.currentFunctionNode;
        const needsOutput = output !== 'void';
        const nodeProperty = needsOutput ? $03ccd63b0299d6a7$var$property(type).build(builder) : '';
        nodeData.nodeProperty = nodeProperty;
        const nodeSnippet = condNode.build(builder, 'bool');
        const isUniformFlow = builder.context.uniformFlow;
        if (isUniformFlow && elseNode !== null) {
            const ifSnippet = ifNode.build(builder, type);
            const elseSnippet = elseNode.build(builder, type);
            const mathSnippet = builder.getTernary(nodeSnippet, ifSnippet, elseSnippet);
            // TODO: If node property already exists return something else
            return builder.format(mathSnippet, type, output);
        }
        builder.addFlowCode(`\n${builder.tab}if ( ${nodeSnippet} ) {\n\n`).addFlowTab();
        let ifSnippet = ifNode.build(builder, type);
        if (ifSnippet) {
            if (needsOutput) ifSnippet = nodeProperty + ' = ' + ifSnippet + ';';
            else {
                ifSnippet = 'return ' + ifSnippet + ';';
                if (functionNode === null) {
                    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: Return statement used in an inline \'Fn()\'. Define a layout struct to allow return values.', this.stackTrace);
                    ifSnippet = '// ' + ifSnippet;
                }
            }
        }
        builder.removeFlowTab().addFlowCode(builder.tab + '\t' + ifSnippet + '\n\n' + builder.tab + '}');
        if (elseNode !== null) {
            builder.addFlowCode(' else {\n\n').addFlowTab();
            let elseSnippet = elseNode.build(builder, type);
            if (elseSnippet) {
                if (needsOutput) elseSnippet = nodeProperty + ' = ' + elseSnippet + ';';
                else {
                    elseSnippet = 'return ' + elseSnippet + ';';
                    if (functionNode === null) {
                        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: Return statement used in an inline \'Fn()\'. Define a layout struct to allow return values.', this.stackTrace);
                        elseSnippet = '// ' + elseSnippet;
                    }
                }
            }
            builder.removeFlowTab().addFlowCode(builder.tab + '\t' + elseSnippet + '\n\n' + builder.tab + '}\n\n');
        } else builder.addFlowCode('\n\n');
        return builder.format(nodeProperty, type, output);
    }
}
/**
 * TSL function for creating a conditional node.
 *
 * @tsl
 * @function
 * @param {Node} condNode - The node that defines the condition.
 * @param {Node} ifNode - The node that is evaluate when the condition ends up `true`.
 * @param {?Node} [elseNode=null] - The node that is evaluate when the condition ends up `false`.
 * @returns {ConditionalNode}
 */ const $03ccd63b0299d6a7$var$select = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$8e402c64e6081013).setParameterLength(2, 3);
$03ccd63b0299d6a7$var$addMethodChaining('select', $03ccd63b0299d6a7$var$select);
/**
 * This node can be used as a context management component for another node.
 * {@link NodeBuilder} performs its node building process in a specific context and
 * this node allows the modify the context. A typical use case is to overwrite `getUV()` e.g.:
 *
 * ```js
 *node.context( { getUV: () => customCoord } );
 *\// or
 *material.contextNode = context( { getUV: () => customCoord } );
 *\// or
 *renderer.contextNode = context( { getUV: () => customCoord } );
 *\// or
 *scenePass.contextNode = context( { getUV: () => customCoord } );
 *```
 * @augments Node
 */ class $03ccd63b0299d6a7$export$17ecd2ebd87625d1 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ContextNode';
    }
    /**
	 * Constructs a new context node.
	 *
	 * @param {Node} node - The node whose context should be modified.
	 * @param {Object} [value={}] - The modified context data.
	 */ constructor(node = null, value = {}){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isContextNode = true;
        /**
		 * The node whose context should be modified.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The modified context data.
		 *
		 * @type {Object}
		 * @default {}
		 */ this.value = value;
    }
    /**
	 * This method is overwritten to ensure it returns the reference to {@link ContextNode#node}.
	 *
	 * @return {Node} A reference to {@link ContextNode#node}.
	 */ getScope() {
        return this.node.getScope();
    }
    /**
	 * This method is overwritten to ensure it returns the type of {@link ContextNode#node}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    /**
	 * Gathers the context data from all parent context nodes.
	 *
	 * @return {Object} The gathered context data.
	 */ getFlowContextData() {
        const children = [];
        this.traverse((node)=>{
            if (node.isContextNode === true) children.push(node.value);
        });
        return Object.assign({}, ...children);
    }
    /**
	 * This method is overwritten to ensure it returns the member type of {@link ContextNode#node}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The member name.
	 * @returns {string} The member type.
	 */ getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    analyze(builder) {
        const previousContext = builder.addContext(this.value);
        this.node.build(builder);
        builder.setContext(previousContext);
    }
    setup(builder) {
        const previousContext = builder.addContext(this.value);
        this.node.build(builder);
        builder.setContext(previousContext);
    }
    generate(builder, output) {
        const previousContext = builder.addContext(this.value);
        const snippet = this.node.build(builder, output);
        builder.setContext(previousContext);
        return snippet;
    }
}
/**
 * TSL function for creating a context node.
 *
 * @tsl
 * @function
 * @param {Node|Object} [nodeOrValue={}] - The node whose context should be modified or the modified context data.
 * @param {Object} [value={}] - The modified context data.
 * @returns {ContextNode}
 */ const $03ccd63b0299d6a7$var$context = (nodeOrValue = null, value = {})=>{
    let node = nodeOrValue;
    if (node === null || node.isNode !== true) {
        value = node || value;
        node = null;
    }
    return new $03ccd63b0299d6a7$export$17ecd2ebd87625d1(node, value);
};
/**
 * TSL function for defining a uniformFlow context value for a given node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node whose dependencies should all execute within a uniform control-flow path.
 * @returns {ContextNode}
 */ const $03ccd63b0299d6a7$var$uniformFlow = (node)=>$03ccd63b0299d6a7$var$context(node, {
        uniformFlow: true
    });
/**
 * TSL function for defining a name for the context value for a given node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node whose context should be modified.
 * @param {string} name - The name to set.
 * @returns {ContextNode}
 */ const $03ccd63b0299d6a7$var$setName = (node, name)=>$03ccd63b0299d6a7$var$context(node, {
        nodeName: name
    });
/**
 * TSL function for defining a built-in shadow context for a given node.
 *
 * @tsl
 * @function
 * @param {ShadowNode} shadowNode - The shadow node representing the light's shadow.
 * @param {Light} light - The light associated with the shadow.
 * @param {Node} [node=null] - The node whose context should be modified.
 * @returns {ContextNode}
 */ function $03ccd63b0299d6a7$var$builtinShadowContext(shadowNode, light, node = null) {
    return $03ccd63b0299d6a7$var$context(node, {
        getShadow: ({ light: shadowLight, shadowColorNode: shadowColorNode })=>{
            if (light === shadowLight) return shadowColorNode.mul(shadowNode);
            return shadowColorNode;
        }
    });
}
/**
 * TSL function for defining a built-in ambient occlusion context for a given node.
 *
 * @tsl
 * @function
 * @param {Node} aoNode - The ambient occlusion value node to apply.
 * @param {Node} [node=null] - The node whose context should be modified.
 * @returns {ContextNode}
 */ function $03ccd63b0299d6a7$var$builtinAOContext(aoNode, node = null) {
    return $03ccd63b0299d6a7$var$context(node, {
        getAO: (inputNode, { material: material })=>{
            if (material.transparent === true) return inputNode;
            return inputNode !== null ? inputNode.mul(aoNode) : aoNode;
        }
    });
}
/**
 * TSL function for defining a label context value for a given node.
 *
 * @tsl
 * @function
 * @deprecated
 * @param {Node} node - The node whose context should be modified.
 * @param {string} name - The name/label to set.
 * @returns {ContextNode}
 */ function $03ccd63b0299d6a7$var$label(node, name) {
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
    return $03ccd63b0299d6a7$var$setName(node, name);
}
$03ccd63b0299d6a7$var$addMethodChaining('context', $03ccd63b0299d6a7$var$context);
$03ccd63b0299d6a7$var$addMethodChaining('label', $03ccd63b0299d6a7$var$label);
$03ccd63b0299d6a7$var$addMethodChaining('uniformFlow', $03ccd63b0299d6a7$var$uniformFlow);
$03ccd63b0299d6a7$var$addMethodChaining('setName', $03ccd63b0299d6a7$var$setName);
$03ccd63b0299d6a7$var$addMethodChaining('builtinShadowContext', (node, shadowNode, light)=>$03ccd63b0299d6a7$var$builtinShadowContext(shadowNode, light, node));
$03ccd63b0299d6a7$var$addMethodChaining('builtinAOContext', (node, aoValue)=>$03ccd63b0299d6a7$var$builtinAOContext(aoValue, node));
/**
 * Class for representing shader variables as nodes. Variables are created from
 * existing nodes like the following:
 *
 * ```js
 * const depth = sampleDepth( uvNode ).toVar( 'depth' );
 * ```
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$fec192598c332c7e extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'VarNode';
    }
    /**
	 * Constructs a new variable node.
	 *
	 * @param {Node} node - The node for which a variable should be created.
	 * @param {?string} [name=null] - The name of the variable in the shader.
	 * @param {boolean} [readOnly=false] - The read-only flag.
	 */ constructor(node, name = null, readOnly = false){
        super();
        /**
		 * The node for which a variable should be created.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The name of the variable in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * `VarNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVarNode = true;
        /**
		 *
		 * The read-only flag.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.readOnly = readOnly;
        /**
		 *
		 * Add this flag to the node system to indicate that this node require parents.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parents = true;
        /**
		 * This flag is used to indicate that this node is used for intent.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.intent = false;
    }
    /**
	 * Sets the intent flag for this node.
	 *
	 * This flag is used to indicate that this node is used for intent
	 * and should not be built directly. Instead, it is used to indicate that
	 * the node should be treated as a variable intent.
	 *
	 * It's useful for assigning variables without needing creating a new variable node.
	 *
	 * @param {boolean} value - The value to set for the intent flag.
	 * @returns {VarNode} This node.
	 */ setIntent(value) {
        this.intent = value;
        return this;
    }
    /**
	 * Checks if this node is used for intent.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {boolean} Whether this node is used for intent.
	 */ isIntent(builder) {
        const data = builder.getDataFromNode(this);
        if (data.forceDeclaration === true) return false;
        return this.intent;
    }
    /**
	 * Returns the intent flag of this node.
	 *
	 * @return {boolean} The intent flag.
	 */ getIntent() {
        return this.intent;
    }
    getMemberType(builder, name) {
        return this.node.getMemberType(builder, name);
    }
    getElementType(builder) {
        return this.node.getElementType(builder);
    }
    generateNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    getArrayCount(builder) {
        return this.node.getArrayCount(builder);
    }
    isAssign(builder) {
        const data = builder.getDataFromNode(this);
        return data.assign;
    }
    build(...params) {
        const builder = params[0];
        if (this._hasStack(builder) === false && builder.buildStage === 'setup') {
            if (builder.context.nodeLoop || builder.context.nodeBlock) {
                let addBefore = false;
                if (this.node.isShaderCallNodeInternal && this.node.shaderNode.getLayout() === null) {
                    if (builder.fnCall && builder.fnCall.shaderNode) {
                        const shaderNodeData = builder.getDataFromNode(this.node.shaderNode);
                        if (shaderNodeData.hasLoop) {
                            const data = builder.getDataFromNode(this);
                            data.forceDeclaration = true;
                            addBefore = true;
                        }
                    }
                }
                const baseStack = builder.getBaseStack();
                if (addBefore) baseStack.addToStackBefore(this);
                else baseStack.addToStack(this);
            }
        }
        if (this.isIntent(builder)) {
            if (this.isAssign(builder) !== true) return this.node.build(...params);
        }
        return super.build(...params);
    }
    generate(builder) {
        const { node: node, name: name, readOnly: readOnly } = this;
        const { renderer: renderer } = builder;
        const isWebGPUBackend = renderer.backend.isWebGPUBackend === true;
        let isDeterministic = false;
        let shouldTreatAsReadOnly = false;
        if (readOnly) {
            isDeterministic = builder.isDeterministic(node);
            shouldTreatAsReadOnly = isWebGPUBackend ? readOnly : isDeterministic;
        }
        const nodeType = this.getNodeType(builder);
        if (nodeType == 'void') {
            if (this.isIntent(builder) !== true) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: ".toVar()" can not be used with void type.', this.stackTrace);
            const snippet = node.build(builder);
            return snippet;
        }
        const vectorType = builder.getVectorType(nodeType);
        const snippet = node.build(builder, vectorType);
        const nodeVar = builder.getVarFromNode(this, name, vectorType, undefined, shouldTreatAsReadOnly);
        const propertyName = builder.getPropertyName(nodeVar);
        let declarationPrefix = propertyName;
        if (shouldTreatAsReadOnly) {
            if (isWebGPUBackend) declarationPrefix = isDeterministic ? `const ${propertyName}` : `let ${propertyName}`;
            else {
                const count = node.getArrayCount(builder);
                declarationPrefix = `const ${builder.getVar(nodeVar.type, propertyName, count)}`;
            }
        }
        builder.addLineFlowCode(`${declarationPrefix} = ${snippet}`, this);
        return propertyName;
    }
    _hasStack(builder) {
        const nodeData = builder.getDataFromNode(this);
        return nodeData.stack !== undefined;
    }
}
/**
 * TSL function for creating a var node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $03ccd63b0299d6a7$var$createVar = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$fec192598c332c7e);
/**
 * TSL function for creating a var node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $03ccd63b0299d6a7$var$Var = (node, name = null)=>$03ccd63b0299d6a7$var$createVar(node, name).toStack();
/**
 * TSL function for creating a const node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a constant should be created.
 * @param {?string} name - The name of the constant in the shader.
 * @returns {VarNode}
 */ const $03ccd63b0299d6a7$var$Const = (node, name = null)=>$03ccd63b0299d6a7$var$createVar(node, name, true).toStack();
//
//
/**
 * TSL function for creating a var intent node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a variable should be created.
 * @param {?string} name - The name of the variable in the shader.
 * @returns {VarNode}
 */ const $03ccd63b0299d6a7$var$VarIntent = (node)=>{
    return $03ccd63b0299d6a7$var$createVar(node).setIntent(true).toStack();
};
// Method chaining
$03ccd63b0299d6a7$var$addMethodChaining('toVar', $03ccd63b0299d6a7$var$Var);
$03ccd63b0299d6a7$var$addMethodChaining('toConst', $03ccd63b0299d6a7$var$Const);
$03ccd63b0299d6a7$var$addMethodChaining('toVarIntent', $03ccd63b0299d6a7$var$VarIntent);
/**
 * This node is used to build a sub-build in the node system.
 *
 * @augments Node
 * @param {Node} node - The node to be built in the sub-build.
 * @param {string} name - The name of the sub-build.
 * @param {?string} [nodeType=null] - The type of the node, if known.
 */ class $03ccd63b0299d6a7$export$d8653cfb8ececbb6 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'SubBuild';
    }
    constructor(node, name, nodeType = null){
        super(nodeType);
        /**
		 * The node to be built in the sub-build.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The name of the sub-build.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSubBuildNode = true;
    }
    generateNodeType(builder) {
        if (this.nodeType !== null) return this.nodeType;
        builder.addSubBuild(this.name);
        const nodeType = this.node.getNodeType(builder);
        builder.removeSubBuild();
        return nodeType;
    }
    build(builder, ...params) {
        builder.addSubBuild(this.name);
        const data = this.node.build(builder, ...params);
        builder.removeSubBuild();
        return data;
    }
}
/**
 * Creates a new sub-build node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to be built in the sub-build.
 * @param {string} name - The name of the sub-build.
 * @param {?string} [type=null] - The type of the node, if known.
 * @returns {Node} A node object wrapping the SubBuildNode instance.
 */ const $03ccd63b0299d6a7$var$subBuild = (node, name, type = null)=>new $03ccd63b0299d6a7$export$d8653cfb8ececbb6($03ccd63b0299d6a7$var$nodeObject(node), name, type);
/**
 * Class for representing shader varyings as nodes. Varyings are create from
 * existing nodes like the following:
 *
 * ```js
 * const positionLocal = positionGeometry.toVarying( 'vPositionLocal' );
 * ```
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$c4d548faf21ac236 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'VaryingNode';
    }
    /**
	 * Constructs a new varying node.
	 *
	 * @param {Node} node - The node for which a varying should be created.
	 * @param {?string} name - The name of the varying in the shader.
	 */ constructor(node, name = null){
        super();
        /**
		 * The node for which a varying should be created.
		 *
		 * @type {Node}
		 */ this.node = $03ccd63b0299d6a7$var$subBuild(node, 'VERTEX');
        /**
		 * The name of the varying in the shader. If no name is defined,
		 * the node system auto-generates one.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVaryingNode = true;
        /**
		 * The interpolation type of the varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationType = null;
        /**
		 * The interpolation sampling type of varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationSampling = null;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Defines the interpolation type of the varying.
	 *
	 * @param {string} type - The interpolation type.
	 * @param {?string} sampling - The interpolation sampling type
	 * @return {VaryingNode} A reference to this node.
	 */ setInterpolation(type, sampling = null) {
        this.interpolationType = type;
        this.interpolationSampling = sampling;
        return this;
    }
    getHash(builder) {
        return this.name || super.getHash(builder);
    }
    generateNodeType(builder) {
        // VaryingNode is auto type
        return this.node.getNodeType(builder);
    }
    /**
	 * This method performs the setup of a varying node with the current node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeVarying} The node varying from the node builder.
	 */ setupVarying(builder) {
        const properties = builder.getNodeProperties(this);
        let varying = properties.varying;
        if (varying === undefined) {
            const name = this.name;
            const type = this.getNodeType(builder);
            const interpolationType = this.interpolationType;
            const interpolationSampling = this.interpolationSampling;
            properties.varying = varying = builder.getVaryingFromNode(this, name, type, interpolationType, interpolationSampling);
            properties.node = $03ccd63b0299d6a7$var$subBuild(this.node, 'VERTEX');
        }
        // this property can be used to check if the varying can be optimized for a variable
        varying.needsInterpolation || (varying.needsInterpolation = builder.shaderStage === 'fragment');
        return varying;
    }
    setup(builder) {
        this.setupVarying(builder);
        builder.flowNodeFromShaderStage($03ccd63b0299d6a7$export$9e43649cde3e3072.VERTEX, this.node);
    }
    analyze(builder) {
        this.setupVarying(builder);
        builder.flowNodeFromShaderStage($03ccd63b0299d6a7$export$9e43649cde3e3072.VERTEX, this.node);
    }
    generate(builder) {
        const propertyKey = builder.getSubBuildProperty('property', builder.currentStack);
        const properties = builder.getNodeProperties(this);
        const varying = this.setupVarying(builder);
        if (properties[propertyKey] === undefined) {
            const type = this.getNodeType(builder);
            const propertyName = builder.getPropertyName(varying, $03ccd63b0299d6a7$export$9e43649cde3e3072.VERTEX);
            // force node run in vertex stage
            builder.flowNodeFromShaderStage($03ccd63b0299d6a7$export$9e43649cde3e3072.VERTEX, properties.node, type, propertyName);
            properties[propertyKey] = propertyName;
        }
        return builder.getPropertyName(varying);
    }
}
/**
 * TSL function for creating a varying node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node for which a varying should be created.
 * @param {?string} name - The name of the varying in the shader.
 * @returns {VaryingNode}
 */ const $03ccd63b0299d6a7$var$varying = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$c4d548faf21ac236).setParameterLength(1, 2);
/**
 * Computes a node in the vertex stage.
 *
 * @tsl
 * @function
 * @param {Node} node - The node which should be executed in the vertex stage.
 * @returns {VaryingNode}
 */ const $03ccd63b0299d6a7$var$vertexStage = (node)=>$03ccd63b0299d6a7$var$varying(node);
$03ccd63b0299d6a7$var$addMethodChaining('toVarying', $03ccd63b0299d6a7$var$varying);
$03ccd63b0299d6a7$var$addMethodChaining('toVertexStage', $03ccd63b0299d6a7$var$vertexStage);
/**
 * Converts the given color value from sRGB to linear-sRGB color space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The sRGB color.
 * @return {Node<vec3>} The linear-sRGB color.
 */ const $03ccd63b0299d6a7$var$sRGBTransferEOTF = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    const a = color.mul(0.9478672986).add(0.0521327014).pow(2.4);
    const b = color.mul(0.0773993808);
    const factor = color.lessThanEqual(0.04045);
    const rgbResult = $03ccd63b0299d6a7$var$mix(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferEOTF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
/**
 * Converts the given color value from linear-sRGB to sRGB color space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The linear-sRGB color.
 * @return {Node<vec3>} The sRGB color.
 */ const $03ccd63b0299d6a7$var$sRGBTransferOETF = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    const a = color.pow(0.41666).mul(1.055).sub(0.055);
    const b = color.mul(12.92);
    const factor = color.lessThanEqual(0.0031308);
    const rgbResult = $03ccd63b0299d6a7$var$mix(a, b, factor);
    return rgbResult;
}).setLayout({
    name: 'sRGBTransferOETF',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$WORKING_COLOR_SPACE = 'WorkingColorSpace';
const $03ccd63b0299d6a7$var$OUTPUT_COLOR_SPACE = 'OutputColorSpace';
/**
 * This node represents a color space conversion. Meaning it converts
 * a color value from a source to a target color space.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$2caa30bfe4e17f17 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'ColorSpaceNode';
    }
    /**
	 * Constructs a new color space node.
	 *
	 * @param {Node} colorNode - Represents the color to convert.
	 * @param {string} source - The source color space.
	 * @param {string} target - The target color space.
	 */ constructor(colorNode, source, target){
        super('vec4');
        /**
		 * Represents the color to convert.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * The source color space.
		 *
		 * @type {string}
		 */ this.source = source;
        /**
		 * The target color space.
		 *
		 * @type {string}
		 */ this.target = target;
    }
    /**
	 * This method resolves the constants `WORKING_COLOR_SPACE` and
	 * `OUTPUT_COLOR_SPACE` based on the current configuration of the
	 * color management and renderer.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} colorSpace - The color space to resolve.
	 * @return {string} The resolved color space.
	 */ resolveColorSpace(builder, colorSpace) {
        if (colorSpace === $03ccd63b0299d6a7$var$WORKING_COLOR_SPACE) return (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
        else if (colorSpace === $03ccd63b0299d6a7$var$OUTPUT_COLOR_SPACE) return builder.context.outputColorSpace || builder.renderer.outputColorSpace;
        return colorSpace;
    }
    setup(builder) {
        const { colorNode: colorNode } = this;
        const source = this.resolveColorSpace(builder, this.source);
        const target = this.resolveColorSpace(builder, this.target);
        let outputNode = colorNode;
        if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).enabled === false || source === target || !source || !target) return outputNode;
        if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(source) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) outputNode = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$sRGBTransferEOTF(outputNode.rgb), outputNode.a);
        if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries(source) !== (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries(target)) outputNode = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$mat3((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c)._getMatrix(new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)(), source, target)).mul(outputNode.rgb), outputNode.a);
        if ((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(target) === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) outputNode = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$sRGBTransferOETF(outputNode.rgb), outputNode.a);
        return outputNode;
    }
}
/**
 * TSL function for converting a given color node from the current working color space to the given color space.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} targetColorSpace - The target color space.
 * @returns {ColorSpaceNode}
 */ const $03ccd63b0299d6a7$var$workingToColorSpace = (node, targetColorSpace)=>new $03ccd63b0299d6a7$export$2caa30bfe4e17f17($03ccd63b0299d6a7$var$nodeObject(node), $03ccd63b0299d6a7$var$WORKING_COLOR_SPACE, targetColorSpace);
/**
 * TSL function for converting a given color node from the given color space to the current working color space.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} sourceColorSpace - The source color space.
 * @returns {ColorSpaceNode}
 */ const $03ccd63b0299d6a7$var$colorSpaceToWorking = (node, sourceColorSpace)=>new $03ccd63b0299d6a7$export$2caa30bfe4e17f17($03ccd63b0299d6a7$var$nodeObject(node), sourceColorSpace, $03ccd63b0299d6a7$var$WORKING_COLOR_SPACE);
/**
 * TSL function for converting a given color node from one color space to another one.
 *
 * @tsl
 * @function
 * @param {Node} node - Represents the node to convert.
 * @param {string} sourceColorSpace - The source color space.
 * @param {string} targetColorSpace - The target color space.
 * @returns {ColorSpaceNode}
 */ const $03ccd63b0299d6a7$var$convertColorSpace = (node, sourceColorSpace, targetColorSpace)=>new $03ccd63b0299d6a7$export$2caa30bfe4e17f17($03ccd63b0299d6a7$var$nodeObject(node), sourceColorSpace, targetColorSpace);
$03ccd63b0299d6a7$var$addMethodChaining('workingToColorSpace', $03ccd63b0299d6a7$var$workingToColorSpace);
$03ccd63b0299d6a7$var$addMethodChaining('colorSpaceToWorking', $03ccd63b0299d6a7$var$colorSpaceToWorking);
// TODO: Avoid duplicated code and use only ReferenceBaseNode or ReferenceNode
/**
 * This class is only relevant if the referenced property is array-like.
 * In this case, `ReferenceElementNode` allows to refer to a specific
 * element inside the data structure via an index.
 *
 * @augments ArrayElementNode
 */ let $03ccd63b0299d6a7$var$ReferenceElementNode$1 = class ReferenceElementNode extends $03ccd63b0299d6a7$export$f2edd1d22bf6d00b {
    static get type() {
        return 'ReferenceElementNode';
    }
    /**
	 * Constructs a new reference element node.
	 *
	 * @param {ReferenceBaseNode} referenceNode - The reference node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        /**
		 * Similar to {@link ReferenceBaseNode#reference}, an additional
		 * property references to the current node.
		 *
		 * @type {?ReferenceBaseNode}
		 * @default null
		 */ this.referenceNode = referenceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isReferenceElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the uniform type of the reference node.
	 *
	 * @return {string} The node type.
	 */ generateNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType();
        const elementType = this.getNodeType();
        return builder.format(snippet, arrayType, elementType);
    }
};
/**
 * Base class for nodes which establishes a reference to a property of another object.
 * In this way, the value of the node is automatically linked to the value of
 * referenced object. Reference nodes internally represent the linked value
 * as a uniform.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$6e5b0aaca1b99672 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ReferenceBaseNode';
    }
    /**
	 * Constructs a new reference base node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} uniformType - The uniform type that should be used to represent the property value.
	 * @param {?Object} [object=null] - The object the property belongs to.
	 * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
	 */ constructor(property, uniformType, object = null, count = null){
        super();
        /**
		 * The name of the property the node refers to.
		 *
		 * @type {string}
		 */ this.property = property;
        /**
		 * The uniform type that should be used to represent the property value.
		 *
		 * @type {string}
		 */ this.uniformType = uniformType;
        /**
		 * The object the property belongs to.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.object = object;
        /**
		 * When the linked property is an array, this parameter defines its length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 * The property name might have dots so nested properties can be referred.
		 * The hierarchy of the names is stored inside this array.
		 *
		 * @type {Array<string>}
		 */ this.properties = property.split('.');
        /**
		 * Points to the current referred object. This property exists next to {@link ReferenceNode#object}
		 * since the final reference might be updated from calling code.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.reference = object;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {UniformNode}
		 * @default null
		 */ this.node = null;
        /**
		 * The uniform group of the internal uniform.
		 *
		 * @type {UniformGroupNode}
		 * @default null
		 */ this.group = null;
        /**
		 * Overwritten since reference nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * Sets the uniform group for this reference node.
	 *
	 * @param {UniformGroupNode} group - The uniform group to set.
	 * @return {ReferenceBaseNode} A reference to this node.
	 */ setGroup(group) {
        this.group = group;
        return this;
    }
    /**
	 * When the referred property is array-like, this method can be used
	 * to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {ReferenceElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $03ccd63b0299d6a7$var$ReferenceElementNode$1(this, $03ccd63b0299d6a7$var$nodeObject(indexNode));
    }
    /**
	 * Sets the node type which automatically defines the internal
	 * uniform type.
	 *
	 * @param {string} uniformType - The type to set.
	 */ setNodeType(uniformType) {
        const node = $03ccd63b0299d6a7$var$uniform(null, uniformType);
        if (this.group !== null) node.setGroup(this.group);
        this.node = node;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the type of the reference node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    /**
	 * Returns the property value from the given referred object.
	 *
	 * @param {Object} [object=this.reference] - The object to retrieve the property value from.
	 * @return {any} The value.
	 */ getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    /**
	 * Allows to update the reference based on the given state. The state is only
	 * evaluated {@link ReferenceBaseNode#object} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    /**
	 * The output of the reference node is the internal uniform node.
	 *
	 * @return {UniformNode} The output node.
	 */ setup() {
        this.updateValue();
        return this.node;
    }
    /**
	 * Overwritten to update the internal uniform value.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        this.updateValue();
    }
    /**
	 * Retrieves the value from the referred object property and uses it
	 * to updated the internal uniform.
	 */ updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
/**
 * TSL function for creating a reference base node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {Object} object - The object the property belongs to.
 * @returns {ReferenceBaseNode}
 */ const $03ccd63b0299d6a7$var$reference$1 = (name, type, object)=>new $03ccd63b0299d6a7$export$6e5b0aaca1b99672(name, type, object);
/**
 * This node is a special type of reference node which is intended
 * for linking renderer properties with node values.
 * ```js
 * const exposureNode = rendererReference( 'toneMappingExposure', 'float', renderer );
 * ```
 * When changing `renderer.toneMappingExposure`, the node value of `exposureNode` will
 * automatically be updated.
 *
 * @augments ReferenceBaseNode
 */ class $03ccd63b0299d6a7$export$97b2e7d082b6f330 extends $03ccd63b0299d6a7$export$6e5b0aaca1b99672 {
    static get type() {
        return 'RendererReferenceNode';
    }
    /**
	 * Constructs a new renderer reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} inputType - The uniform type that should be used to represent the property value.
	 * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
	 * the node refers to the renderer of the current state.
	 */ constructor(property, inputType, renderer = null){
        super(property, inputType, renderer);
        /**
		 * The renderer the property belongs to. When no renderer is set,
		 * the node refers to the renderer of the current state.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = renderer;
        this.setGroup($03ccd63b0299d6a7$var$renderGroup);
    }
    /**
	 * Updates the reference based on the given state. The state is only evaluated
	 * {@link RendererReferenceNode#renderer} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.renderer !== null ? this.renderer : state.renderer;
        return this.reference;
    }
}
/**
 * TSL function for creating a renderer reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Renderer} [renderer=null] - The renderer the property belongs to. When no renderer is set,
 * the node refers to the renderer of the current state.
 * @returns {RendererReferenceNode}
 */ const $03ccd63b0299d6a7$var$rendererReference = (name, type, renderer = null)=>new $03ccd63b0299d6a7$export$97b2e7d082b6f330(name, type, renderer);
/**
 * This node represents a tone mapping operation.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$efafcf9256d00888 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'ToneMappingNode';
    }
    /**
	 * Constructs a new tone mapping node.
	 *
	 * @param {number} toneMapping - The tone mapping type.
	 * @param {Node} exposureNode - The tone mapping exposure.
	 * @param {Node} [colorNode=null] - The color node to process.
	 */ constructor(toneMapping, exposureNode = $03ccd63b0299d6a7$var$toneMappingExposure, colorNode = null){
        super('vec3');
        /**
		 * The tone mapping type.
		 *
		 * @private
		 * @type {number}
		 */ this._toneMapping = toneMapping;
        /**
		 * The tone mapping exposure.
		 *
		 * @type {Node}
		 * @default null
		 */ this.exposureNode = exposureNode;
        /**
		 * Represents the color to process.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.colorNode = colorNode;
    }
    /**
	 * Overwrites the default `customCacheKey()` implementation by including the tone
	 * mapping type into the cache key.
	 *
	 * @return {number} The hash.
	 */ customCacheKey() {
        return $03ccd63b0299d6a7$var$hash$1(this._toneMapping);
    }
    /**
	 * Sets the tone mapping type.
	 *
	 * @param {number} value - The tone mapping type.
	 * @return {ToneMappingNode} A reference to this node.
	 */ setToneMapping(value) {
        this._toneMapping = value;
        return this;
    }
    /**
	 * Gets the tone mapping type.
	 *
	 * @returns {number} The tone mapping type.
	 */ getToneMapping() {
        return this._toneMapping;
    }
    setup(builder) {
        const colorNode = this.colorNode || builder.context.color;
        const toneMapping = this._toneMapping;
        if (toneMapping === (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2)) return colorNode;
        let outputNode = null;
        const toneMappingFn = builder.renderer.library.getToneMappingFunction(toneMapping);
        if (toneMappingFn !== null) outputNode = $03ccd63b0299d6a7$var$vec4(toneMappingFn(colorNode.rgb, this.exposureNode), colorNode.a);
        else {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('ToneMappingNode: Unsupported Tone Mapping configuration.', toneMapping);
            outputNode = colorNode;
        }
        return outputNode;
    }
}
/**
 * TSL function for creating a tone mapping node.
 *
 * @tsl
 * @function
 * @param {number} mapping - The tone mapping type.
 * @param {Node<float> | number} exposure - The tone mapping exposure.
 * @param {Node<vec3> | Color} color - The color node to process.
 * @returns {ToneMappingNode<vec3>}
 */ const $03ccd63b0299d6a7$var$toneMapping = (mapping, exposure, color)=>new $03ccd63b0299d6a7$export$efafcf9256d00888(mapping, $03ccd63b0299d6a7$var$nodeObject(exposure), $03ccd63b0299d6a7$var$nodeObject(color));
/**
 * TSL object that represents the global tone mapping exposure of the renderer.
 *
 * @tsl
 * @type {RendererReferenceNode<vec3>}
 */ const $03ccd63b0299d6a7$var$toneMappingExposure = /*@__PURE__*/ $03ccd63b0299d6a7$var$rendererReference('toneMappingExposure', 'float');
$03ccd63b0299d6a7$var$addMethodChaining('toneMapping', (color, mapping, exposure)=>$03ccd63b0299d6a7$var$toneMapping(mapping, exposure, color));
/**
 * Internal buffer attribute library.
 *
 * @private
 * @type {WeakMap<TypedArray, InterleavedBuffer>}
 */ const $03ccd63b0299d6a7$var$_bufferLib = new WeakMap();
/**
 * Internal method for retrieving or creating interleaved buffers.
 *
 * @private
 * @param {TypedArray} value - The attribute data.
 * @param {number} itemSize - The attribute item size.
 * @returns {InterleavedBuffer} The interleaved buffer.
 */ function $03ccd63b0299d6a7$var$_getBufferAttribute(value, itemSize) {
    let buffer = $03ccd63b0299d6a7$var$_bufferLib.get(value);
    if (buffer === undefined) {
        buffer = new (0, $9ddd7e9b53f7a2d4$export$3d5cd879f108f53f)(value, itemSize);
        $03ccd63b0299d6a7$var$_bufferLib.set(value, buffer);
    }
    return buffer;
}
/**
 * In earlier `three.js` versions it was only possible to define attribute data
 * on geometry level. With `BufferAttributeNode`, it is also possible to do this
 * on the node level.
 * ```js
 * const geometry = new THREE.PlaneGeometry();
 * const positionAttribute = geometry.getAttribute( 'position' );
 *
 * const colors = [];
 * for ( let i = 0; i < position.count; i ++ ) {
 * 	colors.push( 1, 0, 0 );
 * }
 *
 * material.colorNode = bufferAttribute( new THREE.Float32BufferAttribute( colors, 3 ) );
 * ```
 * This new approach is especially interesting when geometry data are generated via
 * compute shaders. The below line converts a storage buffer into an attribute node.
 * ```js
 * material.positionNode = positionBuffer.toAttribute();
 * ```
 * @augments InputNode
 */ class $03ccd63b0299d6a7$export$7d6c96ed9fce09e extends $03ccd63b0299d6a7$export$7e3a4603a05bdb9e {
    static get type() {
        return 'BufferAttributeNode';
    }
    /**
	 * Constructs a new buffer attribute node.
	 *
	 * @param {BufferAttribute|InterleavedBuffer|TypedArray} value - The attribute data.
	 * @param {?string} [bufferType=null] - The buffer type (e.g. `'vec3'`).
	 * @param {number} [bufferStride=0] - The buffer stride.
	 * @param {number} [bufferOffset=0] - The buffer offset.
	 */ constructor(value, bufferType = null, bufferStride = 0, bufferOffset = 0){
        super(value, bufferType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferNode = true;
        /**
		 * The buffer type (e.g. `'vec3'`).
		 *
		 * @type {?string}
		 * @default null
		 */ this.bufferType = bufferType;
        /**
		 * The buffer stride.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferStride = bufferStride;
        /**
		 * The buffer offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferOffset = bufferOffset;
        /**
		 * The usage property. Set this to `THREE.DynamicDrawUsage` via `.setUsage()`,
		 * if you are planning to update the attribute data per frame.
		 *
		 * @type {number}
		 * @default StaticDrawUsage
		 */ this.usage = (0, $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d);
        /**
		 * Whether the attribute is instanced or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.instanced = false;
        /**
		 * A reference to the buffer attribute.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.attribute = null;
        /**
		 * `BufferAttributeNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        if (value && value.isBufferAttribute === true && value.itemSize <= 4) {
            this.attribute = value;
            this.usage = value.usage;
            this.instanced = value.isInstancedBufferAttribute;
        }
    }
    /**
	 * This method is overwritten since the attribute data might be shared
	 * and thus the hash should be shared as well.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        let id;
        if (this.bufferStride === 0 && this.bufferOffset === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            id = bufferData.node.id;
        } else id = this.id;
        return String(id);
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the buffer attribute.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        if (this.bufferType === null) this.bufferType = builder.getTypeFromAttribute(this.attribute);
        return this.bufferType;
    }
    /**
	 * Depending on which value was passed to the node, `setup()` behaves
	 * differently. If no instance of `BufferAttribute` was passed, the method
	 * creates an internal attribute and configures it respectively.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        if (this.attribute !== null) return;
        //
        const type = this.getNodeType(builder);
        const itemSize = builder.getTypeLength(type);
        const value = this.value;
        const stride = this.bufferStride || itemSize;
        const offset = this.bufferOffset;
        let buffer;
        if (value.isInterleavedBuffer === true) buffer = value;
        else if (value.isBufferAttribute === true) buffer = $03ccd63b0299d6a7$var$_getBufferAttribute(value.array, stride);
        else buffer = $03ccd63b0299d6a7$var$_getBufferAttribute(value, stride);
        const bufferAttribute = new (0, $9ddd7e9b53f7a2d4$export$920b6d07334599c7)(buffer, itemSize, offset);
        buffer.setUsage(this.usage);
        this.attribute = bufferAttribute;
        this.attribute.isInstancedBufferAttribute = this.instanced; // @TODO: Add a possible: InstancedInterleavedBufferAttribute
    }
    /**
	 * Generates the code snippet of the buffer attribute node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        const nodeType = this.getNodeType(builder);
        const nodeAttribute = builder.getBufferAttributeFromNode(this, nodeType);
        const propertyName = builder.getPropertyName(nodeAttribute);
        let output = null;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') {
            this.name = propertyName;
            output = propertyName;
        } else {
            const nodeVarying = $03ccd63b0299d6a7$var$varying(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'bufferAttribute'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'bufferAttribute';
    }
    /**
	 * Sets the `usage` property to the given value.
	 *
	 * @param {number} value - The usage to set.
	 * @return {BufferAttributeNode} A reference to this node.
	 */ setUsage(value) {
        this.usage = value;
        if (this.attribute && this.attribute.isBufferAttribute === true) this.attribute.usage = value;
        return this;
    }
    /**
	 * Sets the `instanced` property to the given value.
	 *
	 * @param {boolean} value - The value to set.
	 * @return {BufferAttributeNode} A reference to this node.
	 */ setInstanced(value) {
        this.instanced = value;
        return this;
    }
}
/**
 * Internal method for creating buffer attribute nodes.
 *
 * @private
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @param {number} [usage=StaticDrawUsage] - The buffer usage.
 * @param {boolean} [instanced=false] - Whether the buffer is instanced.
 * @returns {BufferAttributeNode|Node} The buffer attribute node.
 */ function $03ccd63b0299d6a7$var$createBufferAttribute(array, type = null, stride = 0, offset = 0, usage = (0, $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d), instanced = false) {
    if (type === 'mat3' || type === null && array.itemSize === 9) return $03ccd63b0299d6a7$var$mat3(new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec3', 9, 0).setUsage(usage).setInstanced(instanced), new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec3', 9, 3).setUsage(usage).setInstanced(instanced), new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec3', 9, 6).setUsage(usage).setInstanced(instanced));
    else if (type === 'mat4' || type === null && array.itemSize === 16) return $03ccd63b0299d6a7$var$mat4(new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec4', 16, 0).setUsage(usage).setInstanced(instanced), new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec4', 16, 4).setUsage(usage).setInstanced(instanced), new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec4', 16, 8).setUsage(usage).setInstanced(instanced), new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, 'vec4', 16, 12).setUsage(usage).setInstanced(instanced));
    return new $03ccd63b0299d6a7$export$7d6c96ed9fce09e(array, type, stride, offset).setUsage(usage);
}
/**
 * TSL function for creating a buffer attribute node.
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $03ccd63b0299d6a7$var$bufferAttribute = (array, type = null, stride = 0, offset = 0)=>$03ccd63b0299d6a7$var$createBufferAttribute(array, type, stride, offset);
/**
 * TSL function for creating a buffer attribute node but with dynamic draw usage.
 * Use this function if attribute data are updated per frame.
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $03ccd63b0299d6a7$var$dynamicBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$03ccd63b0299d6a7$var$createBufferAttribute(array, type, stride, offset, (0, $9ddd7e9b53f7a2d4$export$8505d14ac8546ca));
/**
 * TSL function for creating a buffer attribute node but with enabled instancing
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $03ccd63b0299d6a7$var$instancedBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$03ccd63b0299d6a7$var$createBufferAttribute(array, type, stride, offset, (0, $9ddd7e9b53f7a2d4$export$763e8360f4d7f77d), true);
/**
 * TSL function for creating a buffer attribute node but with dynamic draw usage and enabled instancing
 *
 * @tsl
 * @function
 * @param {BufferAttribute|InterleavedBuffer|TypedArray} array - The attribute data.
 * @param {?string} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [stride=0] - The buffer stride.
 * @param {number} [offset=0] - The buffer offset.
 * @returns {BufferAttributeNode|Node}
 */ const $03ccd63b0299d6a7$var$instancedDynamicBufferAttribute = (array, type = null, stride = 0, offset = 0)=>$03ccd63b0299d6a7$var$createBufferAttribute(array, type, stride, offset, (0, $9ddd7e9b53f7a2d4$export$8505d14ac8546ca), true);
$03ccd63b0299d6a7$var$addMethodChaining('toAttribute', (bufferNode)=>$03ccd63b0299d6a7$var$bufferAttribute(bufferNode.value));
/**
 * This class represents shader indices of different types. The following predefined node
 * objects cover frequent use cases:
 *
 * - `vertexIndex`: The index of a vertex within a mesh.
 * - `instanceIndex`: The index of either a mesh instance or an invocation of a compute shader.
 * - `drawIndex`: The index of a draw call.
 * - `invocationLocalIndex`: The index of a compute invocation within the scope of a workgroup load.
 * - `invocationSubgroupIndex`: The index of a compute invocation within the scope of a subgroup.
 * - `subgroupIndex`: The index of a compute invocation's subgroup within its workgroup.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$929eaad981940a63 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'IndexNode';
    }
    /**
	 * Constructs a new index node.
	 *
	 * @param {('vertex'|'instance'|'subgroup'|'invocationLocal'|'invocationGlobal'|'invocationSubgroup'|'draw')} scope - The scope of the index node.
	 */ constructor(scope){
        super('uint');
        /**
		 * The scope of the index node.
		 *
		 * @type {string}
		 */ this.scope = scope;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIndexNode = true;
    }
    generate(builder) {
        const nodeType = this.getNodeType(builder);
        const scope = this.scope;
        let propertyName;
        if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.VERTEX) propertyName = builder.getVertexIndex();
        else if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.INSTANCE) propertyName = builder.getInstanceIndex();
        else if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.DRAW) propertyName = builder.getDrawIndex();
        else if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_LOCAL) propertyName = builder.getInvocationLocalIndex();
        else if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_SUBGROUP) propertyName = builder.getInvocationSubgroupIndex();
        else if (scope === $03ccd63b0299d6a7$export$929eaad981940a63.SUBGROUP) propertyName = builder.getSubgroupIndex();
        else throw new Error('THREE.IndexNode: Unknown scope: ' + scope);
        let output;
        if (builder.shaderStage === 'vertex' || builder.shaderStage === 'compute') output = propertyName;
        else {
            const nodeVarying = $03ccd63b0299d6a7$var$varying(this);
            output = nodeVarying.build(builder, nodeType);
        }
        return output;
    }
}
$03ccd63b0299d6a7$export$929eaad981940a63.VERTEX = 'vertex';
$03ccd63b0299d6a7$export$929eaad981940a63.INSTANCE = 'instance';
$03ccd63b0299d6a7$export$929eaad981940a63.SUBGROUP = 'subgroup';
$03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_LOCAL = 'invocationLocal';
$03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_SUBGROUP = 'invocationSubgroup';
$03ccd63b0299d6a7$export$929eaad981940a63.DRAW = 'draw';
/**
 * TSL object that represents the index of a vertex within a mesh.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$vertexIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.VERTEX);
/**
 * TSL object that represents the index of either a mesh instance or an invocation of a compute shader.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$instanceIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.INSTANCE);
/**
 * TSL object that represents the index of the subgroup the current compute invocation belongs to.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$subgroupIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.SUBGROUP);
/**
 * TSL object that represents the index of a compute invocation within the scope of a subgroup.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$invocationSubgroupIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_SUBGROUP);
/**
 * TSL object that represents the index of a compute invocation within the scope of a workgroup load.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$invocationLocalIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.INVOCATION_LOCAL);
/**
 * TSL object that represents the index of a draw call.
 *
 * @tsl
 * @type {IndexNode}
 */ const $03ccd63b0299d6a7$var$drawIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$929eaad981940a63, $03ccd63b0299d6a7$export$929eaad981940a63.DRAW);
/**
 * Represents a compute shader node.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$49fb11e9f3090754 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ComputeNode';
    }
    /**
	 * Constructs a new compute node.
	 *
	 * @param {Node} computeNode - The node that defines the compute shader logic.
	 * @param {Array<number>} workgroupSize - An array defining the X, Y, and Z dimensions of the workgroup for compute shader execution.
	 */ constructor(computeNode, workgroupSize){
        super('void');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isComputeNode = true;
        /**
		 * The node that defines the compute shader logic.
		 *
		 * @type {Node}
		 */ this.computeNode = computeNode;
        /**
		 * An array defining the X, Y, and Z dimensions of the workgroup for compute shader execution.
		 *
		 * @type {Array<number>}
		 * @default [ 64 ]
		 */ this.workgroupSize = workgroupSize;
        /**
		 * The total number of threads (invocations) to execute. If it is a number, it will be used
		 * to automatically generate bounds checking against `instanceIndex`.
		 *
		 * @type {number|Array<number>}
		 */ this.count = null;
        /**
		 * The dispatch size for workgroups on X, Y, and Z axes.
		 * Used directly if `count` is not provided.
		 *
		 * @type {number|Array<number>}
		 */ this.dispatchSize = null;
        /**
		 * The version of the node.
		 *
		 * @type {number}
		 */ this.version = 1;
        /**
		 * The name or label of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.OBJECT` since {@link ComputeNode#updateBefore}
		 * is executed once per object by default.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        /**
		 * A callback executed when the compute node finishes initialization.
		 *
		 * @type {?Function}
		 */ this.onInitFunction = null;
        /**
		 * A uniform node holding the dispatch count for bounds checking.
		 * Created automatically when `count` is a number.
		 *
		 * @type {?UniformNode}
		 */ this.countNode = null;
    }
    /**
	 * Executes the `dispose` event for this node.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Sets the {@link ComputeNode#name} property.
	 *
	 * @param {string} name - The name of the uniform.
	 * @return {ComputeNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the {@link ComputeNode#name} property.
	 *
	 * @deprecated
	 * @param {string} name - The name of the uniform.
	 * @return {ComputeNode} A reference to this node.
	 */ label(name) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "label()" has been deprecated. Use "setName()" instead.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c()); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the callback to run during initialization.
	 *
	 * @param {Function} callback - The callback function.
	 * @return {ComputeNode} A reference to this node.
	 */ onInit(callback) {
        this.onInitFunction = callback;
        return this;
    }
    /**
	 * The method execute the compute for this node.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateBefore({ renderer: renderer }) {
        renderer.compute(this);
    }
    setup(builder) {
        if (this.count !== null && this.countNode === null) this.countNode = $03ccd63b0299d6a7$var$uniform(this.count, 'uint').onObjectUpdate(()=>this.count);
        const result = this.computeNode.build(builder);
        if (result) {
            const properties = builder.getNodeProperties(this);
            properties.outputComputeNode = result.outputNode;
            result.outputNode = null;
        }
        return result;
    }
    generate(builder, output) {
        const { shaderStage: shaderStage } = builder;
        if (shaderStage === 'compute') {
            const snippet = this.computeNode.build(builder, 'void');
            if (snippet !== '') builder.addLineFlowCode(snippet, this);
            if (this.count !== null && builder.allowEarlyReturns === true) {
                const countSnippet = this.countNode.build(builder, 'uint');
                const indexSnippet = $03ccd63b0299d6a7$var$instanceIndex.build(builder, 'uint');
                builder.flow.code = `${builder.tab}if ( ${indexSnippet} >= ${countSnippet} ) { return; }\n\n${builder.flow.code}`;
            }
        } else {
            const properties = builder.getNodeProperties(this);
            const outputComputeNode = properties.outputComputeNode;
            if (outputComputeNode) return outputComputeNode.build(builder, output);
        }
    }
}
/**
 * TSL function for creating a compute kernel node.
 *
 * @tsl
 * @function
 * @param {Node} node - The TSL logic for the compute shader.
 * @param {Array<number>} [workgroupSize=[64]] - The workgroup size.
 * @returns {ComputeNode}
 */ const $03ccd63b0299d6a7$var$computeKernel = (node, workgroupSize = [
    64
])=>{
    if (workgroupSize.length === 0 || workgroupSize.length > 3) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: compute() workgroupSize must have 1, 2, or 3 elements', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    for(let i = 0; i < workgroupSize.length; i++){
        const val = workgroupSize[i];
        if (typeof val !== 'number' || val <= 0 || !Number.isInteger(val)) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: compute() workgroupSize element at index [ ${i} ] must be a positive integer`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    }
    // Implicit fill-up to [ x, y, z ] with 1s, just like WGSL treats @workgroup_size when fewer dimensions are specified
    while(workgroupSize.length < 3)workgroupSize.push(1);
    //
    return new $03ccd63b0299d6a7$export$49fb11e9f3090754($03ccd63b0299d6a7$var$nodeObject(node), workgroupSize);
};
/**
 * TSL function for creating a compute node.
 *
 * @tsl
 * @function
 * @param {Node} node - The TSL logic for the compute shader.
 * @param {number|Array<number>} count - The compute count or dispatch size.
 * @param {Array<number>} [workgroupSize=[64]] - The workgroup size.
 * @returns {ComputeNode}
,  */ const $03ccd63b0299d6a7$var$compute = (node, count, workgroupSize)=>{
    const computeNode = $03ccd63b0299d6a7$var$computeKernel(node, workgroupSize);
    if (typeof count === 'number') computeNode.count = count;
    else computeNode.dispatchSize = count;
    return computeNode;
};
$03ccd63b0299d6a7$var$addMethodChaining('compute', $03ccd63b0299d6a7$var$compute);
$03ccd63b0299d6a7$var$addMethodChaining('computeKernel', $03ccd63b0299d6a7$var$computeKernel);
/**
 * This node can be used as a cache management component for another node.
 * Caching is in general used by default in {@link NodeBuilder} but this node
 * allows the usage of a shared parent cache during the build process.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$473c54a186290bb7 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'IsolateNode';
    }
    /**
	 * Constructs a new cache node.
	 *
	 * @param {Node} node - The node that should be cached.
	 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
	 */ constructor(node, parent = true){
        super();
        /**
		 * The node that should be cached.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * Whether this node refers to a shared parent cache or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parent = parent;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIsolateNode = true;
    }
    generateNodeType(builder) {
        const previousCache = builder.getCache();
        const cache = builder.getCacheFromNode(this, this.parent);
        builder.setCache(cache);
        const nodeType = this.node.getNodeType(builder);
        builder.setCache(previousCache);
        return nodeType;
    }
    build(builder, ...params) {
        const previousCache = builder.getCache();
        const cache = builder.getCacheFromNode(this, this.parent);
        builder.setCache(cache);
        const data = this.node.build(builder, ...params);
        builder.setCache(previousCache);
        return data;
    }
    setParent(parent) {
        this.parent = parent;
        return this;
    }
    getParent() {
        return this.parent;
    }
}
/**
 * TSL function for creating a cache node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be cached.
 * @returns {IsolateNode}
 */ const $03ccd63b0299d6a7$var$isolate = (node)=>new $03ccd63b0299d6a7$export$473c54a186290bb7($03ccd63b0299d6a7$var$nodeObject(node));
/**
 * TSL function for creating a cache node.
 *
 * @tsl
 * @function
 * @deprecated
 * @param {Node} node - The node that should be cached.
 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
 * @returns {IsolateNode}
 */ function $03ccd63b0299d6a7$var$cache(node, parent = true) {
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "cache()" has been deprecated. Use "isolate()" instead.'); // @deprecated r181
    return $03ccd63b0299d6a7$var$isolate(node).setParent(parent);
}
$03ccd63b0299d6a7$var$addMethodChaining('cache', $03ccd63b0299d6a7$var$cache);
$03ccd63b0299d6a7$var$addMethodChaining('isolate', $03ccd63b0299d6a7$var$isolate);
/**
 * The class generates the code of a given node but returns another node in the output.
 * This can be used to call a method or node that does not return a value, i.e.
 * type `void` on an input where returning a value is required. Example:
 *
 * ```js
 * material.colorNode = myColor.bypass( runVoidFn() )
 *```
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$c5fec9e8f9ef1a13 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'BypassNode';
    }
    /**
	 * Constructs a new bypass node.
	 *
	 * @param {Node} outputNode - The output node.
	 * @param {Node} callNode - The call node.
	 */ constructor(outputNode, callNode){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBypassNode = true;
        /**
		 * The output node.
		 *
		 * @type {Node}
		 */ this.outputNode = outputNode;
        /**
		 * The call node.
		 *
		 * @type {Node}
		 */ this.callNode = callNode;
    }
    generateNodeType(builder) {
        return this.outputNode.getNodeType(builder);
    }
    generate(builder) {
        const snippet = this.callNode.build(builder, 'void');
        if (snippet !== '') builder.addLineFlowCode(snippet, this);
        return this.outputNode.build(builder);
    }
}
/**
 * TSL function for creating a bypass node.
 *
 * @tsl
 * @function
 * @param {Node} outputNode - The output node.
 * @param {Node} callNode - The call node.
 * @returns {BypassNode}
 */ const $03ccd63b0299d6a7$var$bypass = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$c5fec9e8f9ef1a13).setParameterLength(2);
$03ccd63b0299d6a7$var$addMethodChaining('bypass', $03ccd63b0299d6a7$var$bypass);
/**
 * This node allows to remap a node value from one range into another. E.g a value of
 * `0.4` in the range `[ 0.3, 0.5 ]` should be remapped into the normalized range `[ 0, 1 ]`.
 * `remap` takes care of that and converts the original value of `0.4` to `0.5`.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be remapped.
 * @param {Node} inLowNode - The source or current lower bound of the range.
 * @param {Node} inHighNode - The source or current upper bound of the range.
 * @param {?Node} [outLowNode=float(0)] - The target lower bound of the range.
 * @param {?Node} [outHighNode=float(1)] - The target upper bound of the range.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$remap = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([node, inLowNode, inHighNode, outLowNode = $03ccd63b0299d6a7$var$float(0), outHighNode = $03ccd63b0299d6a7$var$float(1), doClamp = $03ccd63b0299d6a7$var$bool(false)])=>{
    let t = node.sub(inLowNode).div(inHighNode.sub(inLowNode));
    if ($03ccd63b0299d6a7$var$defined(doClamp)) t = t.clamp();
    return t.mul(outHighNode.sub(outLowNode)).add(outLowNode);
});
/**
 * This node allows to remap a node value from one range into another but with enabled clamping. E.g a value of
 * `0.4` in the range `[ 0.3, 0.5 ]` should be remapped into the normalized range `[ 0, 1 ]`.
 * `remapClamp` takes care of that and converts the original value of `0.4` to `0.5`.
 *
 * @tsl
 * @function
 * @param {Node} node - The node that should be remapped.
 * @param {Node} inLowNode - The source or current lower bound of the range.
 * @param {Node} inHighNode - The source or current upper bound of the range.
 * @param {?Node} [outLowNode=float(0)] - The target lower bound of the range.
 * @param {?Node} [outHighNode=float(1)] - The target upper bound of the range.
 * @returns {Node}
 */ function $03ccd63b0299d6a7$var$remapClamp(node, inLowNode, inHighNode, outLowNode = $03ccd63b0299d6a7$var$float(0), outHighNode = $03ccd63b0299d6a7$var$float(1)) {
    return $03ccd63b0299d6a7$var$remap(node, inLowNode, inHighNode, outLowNode, outHighNode, true);
}
$03ccd63b0299d6a7$var$addMethodChaining('remap', $03ccd63b0299d6a7$var$remap);
$03ccd63b0299d6a7$var$addMethodChaining('remapClamp', $03ccd63b0299d6a7$var$remapClamp);
/**
 * This class can be used to implement basic expressions in shader code.
 * Basic examples for that are `return`, `continue` or `discard` statements.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$e59ba5d29a1947fc extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ExpressionNode';
    }
    /**
	 * Constructs a new expression node.
	 *
	 * @param {string} [snippet=''] - The native code snippet.
	 * @param {string} [nodeType='void'] - The node type.
	 */ constructor(snippet = '', nodeType = 'void'){
        super(nodeType);
        /**
		 * The native code snippet.
		 *
		 * @type {string}
		 * @default ''
		 */ this.snippet = snippet;
    }
    generate(builder, output) {
        const type = this.getNodeType(builder);
        const snippet = this.snippet;
        if (type === 'void') builder.addLineFlowCode(snippet, this);
        else return builder.format(snippet, type, output);
    }
}
/**
 * TSL function for creating an expression node.
 *
 * @tsl
 * @function
 * @param {string} [snippet] - The native code snippet.
 * @param {?string} [nodeType='void'] - The node type.
 * @returns {ExpressionNode}
 */ const $03ccd63b0299d6a7$var$expression = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$e59ba5d29a1947fc).setParameterLength(1, 2);
/**
 * Represents a `discard` shader operation in TSL.
 *
 * @tsl
 * @function
 * @param {?ConditionalNode} conditional - An optional conditional node. It allows to decide whether the discard should be executed or not.
 * @return {Node} The `discard` expression.
 */ const $03ccd63b0299d6a7$var$Discard = (conditional)=>(conditional ? $03ccd63b0299d6a7$var$select(conditional, $03ccd63b0299d6a7$var$expression('discard')) : $03ccd63b0299d6a7$var$expression('discard')).toStack();
/**
 * Represents a `return` shader operation in TSL.
 *
 * @tsl
 * @function
 * @return {ExpressionNode} The `return` expression.
 */ const $03ccd63b0299d6a7$var$Return = ()=>$03ccd63b0299d6a7$var$expression('return').toStack();
$03ccd63b0299d6a7$var$addMethodChaining('discard', $03ccd63b0299d6a7$var$Discard);
/**
 * Normally, tone mapping and color conversion happens automatically just
 * before outputting a pixel to the default (screen) framebuffer. In certain
 * post processing setups this is too late because some effects such as FXAA
 * require e.g. sRGB input. For such scenarios, `RenderOutputNode` can be used
 * to apply tone mapping and color space conversion at an arbitrary point
 * in the effect chain.
 *
 * When applying tone mapping and color space conversion manually with this node,
 * you have to set {@link RenderPipeline#outputColorTransform} to `false`.
 *
 * ```js
 * const postProcessing = new RenderPipeline( renderer );
 * postProcessing.outputColorTransform = false;
 *
 * const scenePass = pass( scene, camera );
 * const outputPass = renderOutput( scenePass );
 *
 * postProcessing.outputNode = outputPass;
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$4fab59b0950d11f6 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'RenderOutputNode';
    }
    /**
	 * Constructs a new render output node.
	 *
	 * @param {Node} colorNode - The color node to process.
	 * @param {?number} toneMapping - The tone mapping type.
	 * @param {?string} outputColorSpace - The output color space.
	 */ constructor(colorNode, toneMapping, outputColorSpace){
        super('vec4');
        /**
		 * The color node to process.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * The tone mapping type.
		 *
		 * @private
		 * @type {?number}
		 */ this._toneMapping = toneMapping;
        /**
		 * The output color space.
		 *
		 * @type {?string}
		 */ this.outputColorSpace = outputColorSpace;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderOutputNode = true;
    }
    /**
	 * Sets the tone mapping type.
	 *
	 * @param {number} value - The tone mapping type.
	 * @return {ToneMappingNode} A reference to this node.
	 */ setToneMapping(value) {
        this._toneMapping = value;
        return this;
    }
    /**
	 * Gets the tone mapping type.
	 *
	 * @returns {number} The tone mapping type.
	 */ getToneMapping() {
        return this._toneMapping;
    }
    setup({ context: context }) {
        let outputNode = this.colorNode || context.color;
        // tone mapping
        const toneMapping = (this._toneMapping !== null ? this._toneMapping : context.toneMapping) || (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        const outputColorSpace = (this.outputColorSpace !== null ? this.outputColorSpace : context.outputColorSpace) || (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51);
        if (toneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2)) outputNode = outputNode.toneMapping(toneMapping);
        // working to output color space
        if (outputColorSpace !== (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) && outputColorSpace !== (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace) outputNode = outputNode.workingToColorSpace(outputColorSpace);
        return outputNode;
    }
}
/**
 * TSL function for creating a render output node.
 *
 * @tsl
 * @function
 * @param {Node} color - The color node to process.
 * @param {?number} [toneMapping=null] - The tone mapping type.
 * @param {?string} [outputColorSpace=null] - The output color space.
 * @returns {RenderOutputNode}
 */ const $03ccd63b0299d6a7$var$renderOutput = (color, toneMapping = null, outputColorSpace = null)=>new $03ccd63b0299d6a7$export$4fab59b0950d11f6($03ccd63b0299d6a7$var$nodeObject(color), toneMapping, outputColorSpace);
$03ccd63b0299d6a7$var$addMethodChaining('renderOutput', $03ccd63b0299d6a7$var$renderOutput);
class $03ccd63b0299d6a7$export$953fa3790b4cf698 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'DebugNode';
    }
    constructor(node, callback = null){
        super();
        this.node = node;
        this.callback = callback;
    }
    generateNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    setup(builder) {
        return this.node.build(builder);
    }
    analyze(builder) {
        return this.node.build(builder);
    }
    generate(builder) {
        const callback = this.callback;
        const snippet = this.node.build(builder);
        if (callback !== null) callback(builder, snippet);
        else {
            const title = '--- TSL debug - ' + builder.shaderStage + ' shader ---';
            const border = '-'.repeat(title.length);
            let code = '';
            code += '// #' + title + '#\n';
            code += builder.flow.code.replace(/^\t/mg, '') + '\n';
            code += '/* ... */ ' + snippet + ' /* ... */\n';
            code += '// #' + border + '#\n';
            (0, $9ddd7e9b53f7a2d4$export$bef1f36f5486a6a3)(code);
        }
        return snippet;
    }
}
/**
 * TSL function for creating a debug node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to debug.
 * @param {?Function} [callback=null] - Optional callback function to handle the debug output.
 * @returns {DebugNode}
 */ const $03ccd63b0299d6a7$var$debug = (node, callback = null)=>new $03ccd63b0299d6a7$export$953fa3790b4cf698($03ccd63b0299d6a7$var$nodeObject(node), callback).toStack();
$03ccd63b0299d6a7$var$addMethodChaining('debug', $03ccd63b0299d6a7$var$debug);
/**
 * InspectorBase is the base class for all inspectors.
 *
 * @class InspectorBase
 * @augments EventDispatcher
 */ class $03ccd63b0299d6a7$export$660a27ce99fa210b extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    /**
	 * Creates a new InspectorBase.
	 */ constructor(){
        super();
        /**
		 * The renderer associated with this inspector.
		 *
		 * @type {WebGLRenderer}
		 * @private
		 */ this._renderer = null;
        /**
		 * The current frame being processed.
		 *
		 * @type {Object}
		 */ this.currentFrame = null;
    }
    /**
	 * Returns the node frame for the current renderer.
	 *
	 * @return {Object} The node frame.
	 */ get nodeFrame() {
        return this._renderer._nodes.nodeFrame;
    }
    /**
	 * Sets the renderer for this inspector.
	 *
	 * @param {WebGLRenderer} renderer - The renderer to associate with this inspector.
	 * @return {InspectorBase} This inspector instance.
	 */ setRenderer(renderer) {
        this._renderer = renderer;
        return this;
    }
    /**
	 * Returns the renderer associated with this inspector.
	 *
	 * @return {WebGLRenderer} The associated renderer.
	 */ getRenderer() {
        return this._renderer;
    }
    /**
	 * Initializes the inspector.
	 */ init() {}
    /**
	 * Called when a frame begins.
	 */ begin() {}
    /**
	 * Called when a frame ends.
	 */ finish() {}
    /**
	 * Inspects a node.
	 *
	 * @param {Node} node - The node to inspect.
	 */ inspect() {}
    /**
	 * When a compute operation is performed.
	 *
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 * @param {number|Array<number>} dispatchSizeOrCount - The dispatch size or count.
	 */ computeAsync() {}
    /**
	 * Called when a compute operation begins.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 */ beginCompute() {}
    /**
	 * Called when a compute operation ends.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {ComputeNode} computeNode - The compute node being executed.
	 */ finishCompute() {}
    /**
	 * Called when a render operation begins.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {Scene} scene - The scene being rendered.
	 * @param {Camera} camera - The camera being used for rendering.
	 * @param {?WebGLRenderTarget} renderTarget - The render target, if any.
	 */ beginRender() {}
    /**
	 * Called when an animation loop ends.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ finishRender() {}
    /**
	 * Called when a texture copy operation is performed.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 */ copyTextureToTexture() {}
    /**
	 * Called when a framebuffer copy operation is performed.
	 *
	 * @param {Texture} framebufferTexture - The texture associated with the framebuffer.
	 */ copyFramebufferToTexture() {}
}
/**
 * InspectorNode is a wrapper node that allows inspection of node values during rendering.
 * It can be used to debug or analyze node outputs in the rendering pipeline.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$ec4f9ba4742737d2 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    /**
	 * Returns the type of the node.
	 *
	 * @returns {string}
	 */ static get type() {
        return 'InspectorNode';
    }
    /**
	 * Creates an InspectorNode.
	 *
	 * @param {Node} node - The node to inspect.
	 * @param {string} [name=''] - Optional name for the inspector node.
	 * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
	 */ constructor(node, name = '', callback = null){
        super();
        this.node = node;
        this.name = name;
        this.callback = callback;
        this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        this.isInspectorNode = true;
    }
    /**
	 * Returns the name of the inspector node.
	 *
	 * @returns {string}
	 */ getName() {
        return this.name || this.node.name;
    }
    /**
	 * Updates the inspector node, allowing inspection of the wrapped node.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        frame.renderer.inspector.inspect(this);
    }
    /**
	 * Returns the type of the wrapped node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {string}
	 */ generateNodeType(builder) {
        return this.node.getNodeType(builder);
    }
    /**
	 * Sets up the inspector node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @returns {Node} The setup node.
	 */ setup(builder) {
        let node = this.node;
        if (builder.context.inspector === true && this.callback !== null) node = this.callback(node);
        if (builder.renderer.backend.isWebGPUBackend !== true && builder.renderer.inspector.constructor !== $03ccd63b0299d6a7$export$660a27ce99fa210b) (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('TSL: ".toInspector()" is only available with WebGPU.');
        return node;
    }
}
/**
 * Creates an inspector node to wrap around a given node for inspection purposes.
 *
 * @tsl
 * @param {Node} node - The node to inspect.
 * @param {string} [name=''] - Optional name for the inspector node.
 * @param {Function|null} [callback=null] - Optional callback to modify the node during setup.
 * @returns {Node} The inspector node.
 */ function $03ccd63b0299d6a7$var$inspector(node, name = '', callback = null) {
    node = $03ccd63b0299d6a7$var$nodeObject(node);
    return node.before(new $03ccd63b0299d6a7$export$ec4f9ba4742737d2(node, name, callback));
}
$03ccd63b0299d6a7$var$addMethodChaining('toInspector', $03ccd63b0299d6a7$var$inspector);
function $03ccd63b0299d6a7$var$addNodeElement(name /*, nodeElement*/ ) {
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: AddNodeElement has been removed in favor of tree-shaking. Trying add', name);
}
/**
 * Base class for representing shader attributes as nodes.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$dc88047a888cd46b extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'AttributeNode';
    }
    /**
	 * Constructs a new attribute node.
	 *
	 * @param {string} attributeName - The name of the attribute.
	 * @param {?string} nodeType - The node type.
	 */ constructor(attributeName, nodeType = null){
        super(nodeType);
        /**
		 * `AttributeNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        this._attributeName = attributeName;
    }
    getHash(builder) {
        return this.getAttributeName(builder);
    }
    generateNodeType(builder) {
        let nodeType = this.nodeType;
        if (nodeType === null) {
            const attributeName = this.getAttributeName(builder);
            if (builder.hasGeometryAttribute(attributeName)) {
                const attribute = builder.geometry.getAttribute(attributeName);
                nodeType = builder.getTypeFromAttribute(attribute);
            } else nodeType = 'float';
        }
        return nodeType;
    }
    /**
	 * Sets the attribute name to the given value. The method can be
	 * overwritten in derived classes if the final name must be computed
	 * analytically.
	 *
	 * @param {string} attributeName - The name of the attribute.
	 * @return {AttributeNode} A reference to this node.
	 */ setAttributeName(attributeName) {
        this._attributeName = attributeName;
        return this;
    }
    /**
	 * Returns the attribute name of this node. The method can be
	 * overwritten in derived classes if the final name must be computed
	 * analytically.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The attribute name.
	 */ getAttributeName() {
        return this._attributeName;
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const nodeType = this.getNodeType(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        if (geometryAttribute === true) {
            const attribute = builder.geometry.getAttribute(attributeName);
            const attributeType = builder.getTypeFromAttribute(attribute);
            const nodeAttribute = builder.getAttribute(attributeName, attributeType);
            if (builder.shaderStage === 'vertex') return builder.format(nodeAttribute.name, attributeType, nodeType);
            else {
                const nodeVarying = $03ccd63b0299d6a7$var$varying(this);
                return nodeVarying.build(builder, nodeType);
            }
        } else {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`AttributeNode: Vertex attribute "${attributeName}" not found on geometry.`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._attributeName = this._attributeName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._attributeName = data._attributeName;
    }
}
/**
 * TSL function for creating an attribute node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the attribute.
 * @param {?string} [nodeType=null] - The node type.
 * @returns {AttributeNode}
 */ const $03ccd63b0299d6a7$var$attribute = (name, nodeType = null)=>new $03ccd63b0299d6a7$export$dc88047a888cd46b(name, nodeType);
/**
 * TSL function for creating an uv attribute node with the given index.
 *
 * @tsl
 * @function
 * @param {number} [index=0] - The uv index.
 * @return {AttributeNode<vec2>} The uv attribute node.
 */ const $03ccd63b0299d6a7$var$uv$1 = (index = 0)=>$03ccd63b0299d6a7$var$attribute('uv' + (index > 0 ? index : ''), 'vec2');
/**
 * A node that represents the dimensions of a texture. The texture size is
 * retrieved in the shader via built-in shader functions like `textureDimensions()`
 * or `textureSize()`.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$d377702479943f75 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'TextureSizeNode';
    }
    /**
	 * Constructs a new texture size node.
	 *
	 * @param {TextureNode} textureNode - A texture node which size should be retrieved.
	 * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
	 */ constructor(textureNode, levelNode = null){
        super('uvec2');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTextureSizeNode = true;
        /**
		 * A texture node which size should be retrieved.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * A level node which defines the requested mip.
		 *
		 * @type {Node<int>}
		 * @default null
		 */ this.levelNode = levelNode;
    }
    generate(builder, output) {
        const textureProperty = this.textureNode.build(builder, 'property');
        const level = this.levelNode === null ? '0' : this.levelNode.build(builder, 'int');
        return builder.format(`${builder.getMethod('textureDimensions')}( ${textureProperty}, ${level} )`, this.getNodeType(builder), output);
    }
}
/**
 * TSL function for creating a texture size node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - A texture node which size should be retrieved.
 * @param {?Node<int>} [levelNode=null] - A level node which defines the requested mip.
 * @returns {TextureSizeNode}
 */ const $03ccd63b0299d6a7$var$textureSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$d377702479943f75).setParameterLength(1, 2);
/**
 * A special type of uniform node that computes the
 * maximum mipmap level for a given texture node.
 *
 * ```js
 * const level = maxMipLevel( textureNode );
 * ```
 *
 * @augments UniformNode
 */ class $03ccd63b0299d6a7$export$ded8507493c8fc0a extends $03ccd63b0299d6a7$export$c0cca4cf699a03e1 {
    static get type() {
        return 'MaxMipLevelNode';
    }
    /**
	 * Constructs a new max mip level node.
	 *
	 * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
	 */ constructor(textureNode){
        super(0);
        /**
		 * The texture node to compute the max mip level for.
		 *
		 * @private
		 * @type {TextureNode}
		 */ this._textureNode = textureNode;
        /**
		 * The `updateType` is set to `NodeUpdateType.FRAME` since the node updates
		 * the texture once per frame in its {@link MaxMipLevelNode#update} method.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
    }
    /**
	 * The texture node to compute the max mip level for.
	 *
	 * @readonly
	 * @type {TextureNode}
	 */ get textureNode() {
        return this._textureNode;
    }
    /**
	 * The texture.
	 *
	 * @readonly
	 * @type {Texture}
	 */ get texture() {
        return this._textureNode.value;
    }
    update() {
        const texture = this.texture;
        const images = texture.images;
        const image = images && images.length > 0 ? images[0] && images[0].image || images[0] : texture.image;
        if (image && image.width !== undefined) {
            const { width: width, height: height } = image;
            this.value = Math.log2(Math.max(width, height));
        }
    }
}
/**
 * TSL function for creating a max mip level node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node to compute the max mip level for.
 * @returns {MaxMipLevelNode}
 */ const $03ccd63b0299d6a7$var$maxMipLevel = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$ded8507493c8fc0a).setParameterLength(1);
/**
 * Custom error class for node-related errors, including stack trace information.
 */ class $03ccd63b0299d6a7$export$db6ca7d193ebb43f extends Error {
    constructor(message, stackTrace = null){
        super(message);
        /**
		 * The name of the error.
		 *
		 * @type {string}
		 */ this.name = 'NodeError';
        /**
		 * The stack trace associated with the error.
		 *
		 * @type {?StackTrace}
		 */ this.stackTrace = stackTrace;
    }
}
const $03ccd63b0299d6a7$var$EmptyTexture$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a)();
/**
 * This type of uniform node represents a 2D texture.
 *
 * @augments UniformNode
 */ class $03ccd63b0299d6a7$export$2dd903bc9e8140bc extends $03ccd63b0299d6a7$export$c0cca4cf699a03e1 {
    static get type() {
        return 'TextureNode';
    }
    /**
	 * Constructs a new texture node.
	 *
	 * @param {Texture} [value=EmptyTexture] - The texture.
	 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 * @param {?Node<float>} [biasNode=null] - The bias node.
	 */ constructor(value = $03ccd63b0299d6a7$var$EmptyTexture$1, uvNode = null, levelNode = null, biasNode = null){
        super(value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTextureNode = true;
        /**
		 * Represents the texture coordinates.
		 *
		 * @type {?Node<vec2|vec3>}
		 * @default null
		 */ this.uvNode = uvNode;
        /**
		 * Represents the mip level that should be selected.
		 *
		 * @type {?Node<int>}
		 * @default null
		 */ this.levelNode = levelNode;
        /**
		 * Represents the bias to be applied during level-of-detail computation.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.biasNode = biasNode;
        /**
		 * Represents a reference value a texture sample is compared to.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.compareNode = null;
        /**
		 * When using texture arrays, the depth node defines the layer to select.
		 *
		 * @type {?Node<int>}
		 * @default null
		 */ this.depthNode = null;
        /**
		 * When defined, a texture is sampled using explicit gradients.
		 *
		 * @type {?Array<Node<vec2>>}
		 * @default null
		 */ this.gradNode = null;
        /**
		 * Represents the optional texel offset applied to the unnormalized texture
		 * coordinate before sampling the texture.
		 *
		 * @type {?Node<ivec2|ivec3>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Whether texture values should be sampled or fetched.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sampler = true;
        /**
		 * Whether the uv transformation matrix should be
		 * automatically updated or not. Use `setUpdateMatrix()`
		 * if you want to change the value of the property.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.updateMatrix = false;
        /**
		 * By default the `update()` method is not executed. Depending on
		 * whether a uv transformation matrix and/or flipY is applied, `update()`
		 * is executed per object.
		 *
		 * @type {string}
		 * @default 'none'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
        /**
		 * The reference node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.referenceNode = null;
        /**
		 * The texture value is stored in a private property.
		 *
		 * @private
		 * @type {Texture}
		 */ this._value = value;
        /**
		 * The uniform node that represents the uv transformation matrix.
		 *
		 * @private
		 * @type {?UniformNode<mat3>}
		 * @default null
		 */ this._matrixUniform = null;
        /**
		 * The uniform node that represents the y-flip. Only required for WebGL.
		 *
		 * @private
		 * @type {?UniformNode<bool>}
		 * @default null
		 */ this._flipYUniform = null;
        this.setUpdateMatrix(uvNode === null);
    }
    set value(value) {
        if (this.referenceNode) this.referenceNode.value = value;
        else this._value = value;
    }
    /**
	 * The texture value.
	 *
	 * @type {Texture}
	 */ get value() {
        return this.referenceNode ? this.referenceNode.value : this._value;
    }
    /**
	 * Overwritten since the uniform hash is defined by the texture's UUID.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The uniform hash.
	 */ getUniformHash() {
        return this.value.uuid;
    }
    /**
	 * Overwritten since the node type is inferred from the texture type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType() {
        if (this.value.isDepthTexture === true) return 'float';
        if (this.value.type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) return 'uvec4';
        else if (this.value.type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) return 'ivec4';
        return 'vec4';
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'texture'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'texture';
    }
    /**
	 * Returns a default uvs based on the current texture's channel.
	 *
	 * @return {AttributeNode<vec2>} The default uvs.
	 */ getDefaultUV() {
        return $03ccd63b0299d6a7$var$uv$1(this.value.channel);
    }
    /**
	 * Overwritten to always return the texture reference of the node.
	 *
	 * @param {any} state - This method can be invocated in different contexts so `state` can refer to any object type.
	 * @return {Texture} The texture reference.
	 */ updateReference() {
        return this.value;
    }
    /**
	 * Transforms the given uv node with the texture transformation matrix.
	 *
	 * @param {Node} uvNode - The uv node to transform.
	 * @return {Node} The transformed uv node.
	 */ getTransformedUV(uvNode) {
        if (this._matrixUniform === null) this._matrixUniform = $03ccd63b0299d6a7$var$uniform(this.value.matrix);
        return this._matrixUniform.mul($03ccd63b0299d6a7$var$vec3(uvNode, 1)).xy;
    }
    /**
	 * Defines whether the uv transformation matrix should automatically be updated or not.
	 *
	 * @param {boolean} value - The update toggle.
	 * @return {TextureNode} A reference to this node.
	 */ setUpdateMatrix(value) {
        this.updateMatrix = value;
        return this;
    }
    /**
	 * Setups the uv node. Depending on the backend as well as texture's image and type, it might be necessary
	 * to modify the uv node for correct sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to setup.
	 * @return {Node} The updated uv node.
	 */ setupUV(builder, uvNode) {
        if (builder.isFlipY()) {
            if (this._flipYUniform === null) this._flipYUniform = $03ccd63b0299d6a7$var$uniform(false);
            uvNode = uvNode.toVar();
            if (this.sampler) uvNode = this._flipYUniform.select(uvNode.flipY(), uvNode);
            else uvNode = this._flipYUniform.select(uvNode.setY($03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$textureSize(this, this.levelNode).y).sub(uvNode.y).sub(1)), uvNode);
        }
        return uvNode;
    }
    /**
	 * Setups texture node by preparing the internal nodes for code generation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const properties = builder.getNodeProperties(this);
        properties.referenceNode = this.referenceNode;
        //
        const texture = this.value;
        if (!texture || texture.isTexture !== true) throw new $03ccd63b0299d6a7$export$db6ca7d193ebb43f('THREE.TSL: `texture( value )` function expects a valid instance of THREE.Texture().', this.stackTrace);
        //
        const uvNode = $03ccd63b0299d6a7$var$Fn(()=>{
            let uvNode = this.uvNode;
            if ((uvNode === null || builder.context.forceUVContext === true) && builder.context.getUV) uvNode = builder.context.getUV(this, builder);
            if (!uvNode) uvNode = this.getDefaultUV();
            if (this.updateMatrix === true) uvNode = this.getTransformedUV(uvNode);
            uvNode = this.setupUV(builder, uvNode);
            //
            this.updateType = this._matrixUniform !== null || this._flipYUniform !== null ? $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT : $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
            //
            return uvNode;
        })();
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        let compareNode = null;
        let compareStepNode = null;
        if (this.compareNode !== null) {
            if (builder.renderer.hasCompatibility((0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE)) compareNode = this.compareNode;
            else {
                const compareFunction = texture.compareFunction;
                if (compareFunction === null || compareFunction === (0, $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7) || compareFunction === (0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1) || compareFunction === (0, $9ddd7e9b53f7a2d4$export$155af022118f3a38) || compareFunction === (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61)) compareStepNode = this.compareNode;
                else {
                    compareNode = this.compareNode;
                    (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('TSL: Only "LessCompare", "LessEqualCompare", "GreaterCompare" and "GreaterEqualCompare" are supported for depth texture comparison fallback.');
                }
            }
        }
        properties.uvNode = uvNode;
        properties.levelNode = levelNode;
        properties.biasNode = this.biasNode;
        properties.compareNode = compareNode;
        properties.compareStepNode = compareStepNode;
        properties.gradNode = this.gradNode;
        properties.depthNode = this.depthNode;
        properties.offsetNode = this.offsetNode;
    }
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, uvNode) {
        return uvNode.build(builder, this.sampler === true ? 'vec2' : 'ivec2');
    }
    /**
	 * Generates the offset code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} offsetNode - The offset node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateOffset(builder, offsetNode) {
        return offsetNode.build(builder, 'ivec2');
    }
    /**
	 * Generates the snippet for the texture sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} textureProperty - The texture property.
	 * @param {string} uvSnippet - The uv snippet.
	 * @param {?string} levelSnippet - The level snippet.
	 * @param {?string} biasSnippet - The bias snippet.
	 * @param {?string} depthSnippet - The depth snippet.
	 * @param {?string} compareSnippet - The compare snippet.
	 * @param {?Array<string>} gradSnippet - The grad snippet.
	 * @param {?string} offsetSnippet - The offset snippet.
	 * @return {string} The generated code snippet.
	 */ generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet, offsetSnippet) {
        const texture = this.value;
        let snippet;
        if (biasSnippet) snippet = builder.generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, offsetSnippet);
        else if (gradSnippet) snippet = builder.generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, offsetSnippet);
        else if (compareSnippet) snippet = builder.generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet);
        else if (this.sampler === false) snippet = builder.generateTextureLoad(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet);
        else if (levelSnippet) snippet = builder.generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet);
        else snippet = builder.generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet);
        return snippet;
    }
    /**
	 * Generates the code snippet of the texture node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        const texture = this.value;
        const properties = builder.getNodeProperties(this);
        const textureProperty = super.generate(builder, 'property');
        if (/^sampler/.test(output)) return textureProperty + '_sampler';
        else if (builder.isReference(output)) return textureProperty;
        else {
            const nodeData = builder.getDataFromNode(this);
            const nodeType = this.getNodeType(builder);
            let propertyName = nodeData.propertyName;
            if (propertyName === undefined) {
                const { uvNode: uvNode, levelNode: levelNode, biasNode: biasNode, compareNode: compareNode, compareStepNode: compareStepNode, depthNode: depthNode, gradNode: gradNode, offsetNode: offsetNode } = properties;
                const uvSnippet = this.generateUV(builder, uvNode);
                const levelSnippet = levelNode ? levelNode.build(builder, 'float') : null;
                const biasSnippet = biasNode ? biasNode.build(builder, 'float') : null;
                const depthSnippet = depthNode ? depthNode.build(builder, 'int') : null;
                const compareSnippet = compareNode ? compareNode.build(builder, 'float') : null;
                const compareStepSnippet = compareStepNode ? compareStepNode.build(builder, 'float') : null;
                const gradSnippet = gradNode ? [
                    gradNode[0].build(builder, 'vec2'),
                    gradNode[1].build(builder, 'vec2')
                ] : null;
                const offsetSnippet = offsetNode ? this.generateOffset(builder, offsetNode) : null;
                let finalDepthSnippet = depthSnippet;
                if (finalDepthSnippet === null && texture.isArrayTexture && this.isTexture3DNode !== true) finalDepthSnippet = '0';
                const nodeVar = builder.getVarFromNode(this);
                propertyName = builder.getPropertyName(nodeVar);
                let snippet = this.generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, finalDepthSnippet, compareSnippet, gradSnippet, offsetSnippet);
                if (compareStepSnippet !== null) {
                    const compareFunction = texture.compareFunction;
                    if (compareFunction === (0, $9ddd7e9b53f7a2d4$export$155af022118f3a38) || compareFunction === (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61)) snippet = $03ccd63b0299d6a7$var$step($03ccd63b0299d6a7$var$expression(snippet, nodeType), $03ccd63b0299d6a7$var$expression(compareStepSnippet, 'float')).build(builder, nodeType);
                    else snippet = $03ccd63b0299d6a7$var$step($03ccd63b0299d6a7$var$expression(compareStepSnippet, 'float'), $03ccd63b0299d6a7$var$expression(snippet, nodeType)).build(builder, nodeType);
                }
                builder.addLineFlowCode(`${propertyName} = ${snippet}`, this);
                nodeData.snippet = snippet;
                nodeData.propertyName = propertyName;
            }
            let snippet = propertyName;
            if (builder.needsToWorkingColorSpace(texture)) snippet = $03ccd63b0299d6a7$var$colorSpaceToWorking($03ccd63b0299d6a7$var$expression(snippet, nodeType), texture.colorSpace).setup(builder).build(builder, nodeType);
            return builder.format(snippet, nodeType, output);
        }
    }
    /**
	 * Sets the sampler value.
	 *
	 * @param {boolean} value - The sampler value to set.
	 * @return {TextureNode} A reference to this texture node.
	 */ setSampler(value) {
        this.sampler = value;
        return this;
    }
    /**
	 * Returns the sampler value.
	 *
	 * @return {boolean} The sampler value.
	 */ getSampler() {
        return this.sampler;
    }
    // @TODO: Move to TSL
    /**
	 * Samples the texture with the given uv node.
	 *
	 * @param {Node} uvNode - The uv node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ sample(uvNode) {
        const textureNode = this.clone();
        textureNode.uvNode = $03ccd63b0299d6a7$var$nodeObject(uvNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * TSL function for creating a texture node that fetches/loads texels without interpolation.
	 *
	 * @param {Node<uvec2>} uvNode - The uv node.
	 * @returns {TextureNode} A texture node representing the texture load.
	 */ load(uvNode) {
        return this.sample(uvNode).setSampler(false);
    }
    /**
	 * Samples a blurred version of the texture by defining an internal bias.
	 *
	 * @param {Node<float>} amountNode - How blurred the texture should be.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ blur(amountNode) {
        const textureNode = this.clone();
        textureNode.biasNode = $03ccd63b0299d6a7$var$nodeObject(amountNode).mul($03ccd63b0299d6a7$var$maxMipLevel(textureNode));
        textureNode.referenceNode = this.getBase();
        const map = textureNode.value;
        if (textureNode.generateMipmaps === false && (map && map.generateMipmaps === false || map.minFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0) || map.magFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0))) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: texture().blur() requires mipmaps and sampling. Use .generateMipmaps=true and .minFilter/.magFilter=THREE.LinearFilter in the Texture.');
            textureNode.biasNode = null;
        }
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Samples a specific mip of the texture.
	 *
	 * @param {Node<int>} levelNode - The mip level to sample.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ level(levelNode) {
        const textureNode = this.clone();
        textureNode.levelNode = $03ccd63b0299d6a7$var$nodeObject(levelNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Returns the texture size of the requested level.
	 *
	 * @param {Node<int>} levelNode - The level to compute the size for.
	 * @return {TextureSizeNode} The texture size.
	 */ size(levelNode) {
        return $03ccd63b0299d6a7$var$textureSize(this, levelNode);
    }
    /**
	 * Samples the texture with the given bias.
	 *
	 * @param {Node<float>} biasNode - The bias node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ bias(biasNode) {
        const textureNode = this.clone();
        textureNode.biasNode = $03ccd63b0299d6a7$var$nodeObject(biasNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Returns the base texture of this node.
	 * @return {TextureNode} The base texture node.
	 */ getBase() {
        return this.referenceNode ? this.referenceNode.getBase() : this;
    }
    /**
	 * Samples the texture by executing a compare operation.
	 *
	 * @param {Node<float>} compareNode - The node that defines the compare value.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ compare(compareNode) {
        const textureNode = this.clone();
        textureNode.compareNode = $03ccd63b0299d6a7$var$nodeObject(compareNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture using an explicit gradient.
	 *
	 * @param {Node<vec2>} gradNodeX - The gradX node.
	 * @param {Node<vec2>} gradNodeY - The gradY node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ grad(gradNodeX, gradNodeY) {
        const textureNode = this.clone();
        textureNode.gradNode = [
            $03ccd63b0299d6a7$var$nodeObject(gradNodeX),
            $03ccd63b0299d6a7$var$nodeObject(gradNodeY)
        ];
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture by defining a depth node.
	 *
	 * @param {Node<int>} depthNode - The depth node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ depth(depthNode) {
        const textureNode = this.clone();
        textureNode.depthNode = $03ccd63b0299d6a7$var$nodeObject(depthNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    /**
	 * Samples the texture by defining an offset node.
	 *
	 * @param {Node<ivec2>} offsetNode - The offset node.
	 * @return {TextureNode} A texture node representing the texture sample.
	 */ offset(offsetNode) {
        const textureNode = this.clone();
        textureNode.offsetNode = $03ccd63b0299d6a7$var$nodeObject(offsetNode);
        textureNode.referenceNode = this.getBase();
        return $03ccd63b0299d6a7$var$nodeObject(textureNode);
    }
    // --
    serialize(data) {
        super.serialize(data);
        data.value = this.value.toJSON(data.meta).uuid;
        data.sampler = this.sampler;
        data.updateMatrix = this.updateMatrix;
        data.updateType = this.updateType;
    }
    deserialize(data) {
        super.deserialize(data);
        this.value = data.meta.textures[data.value];
        this.sampler = data.sampler;
        this.updateMatrix = data.updateMatrix;
        this.updateType = data.updateType;
    }
    /**
	 * The update is used to implement the update of the uv transformation matrix.
	 */ update() {
        const texture = this.value;
        const matrixUniform = this._matrixUniform;
        if (matrixUniform !== null) matrixUniform.value = texture.matrix;
        if (texture.matrixAutoUpdate === true) texture.updateMatrix();
        //
        const flipYUniform = this._flipYUniform;
        if (flipYUniform !== null) flipYUniform.value = texture.image instanceof ImageBitmap && texture.flipY === true || texture.isRenderTargetTexture === true || texture.isFramebufferTexture === true || texture.isDepthTexture === true;
    }
    /**
	 * Clones the texture node.
	 *
	 * @return {TextureNode} The cloned texture node.
	 */ clone() {
        const newNode = new this.constructor(this.value, this.uvNode, this.levelNode, this.biasNode);
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        return newNode;
    }
}
/**
 * TSL function for creating a texture node.
 *
 * @tsl
 * @function
 * @param {?Texture} value - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$textureBase = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2dd903bc9e8140bc).setParameterLength(1, 4).setName('texture');
/**
 * TSL function for creating a texture node or sample a texture node already existing.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$texture = (value = $03ccd63b0299d6a7$var$EmptyTexture$1, uvNode = null, levelNode = null, biasNode = null)=>{
    let textureNode;
    if (value && value.isTextureNode === true) {
        textureNode = $03ccd63b0299d6a7$var$nodeObject(value.clone());
        textureNode.referenceNode = value.getBase(); // Ensure the reference is set to the original node
        if (uvNode !== null) textureNode.uvNode = $03ccd63b0299d6a7$var$nodeObject(uvNode);
        if (levelNode !== null) textureNode.levelNode = $03ccd63b0299d6a7$var$nodeObject(levelNode);
        if (biasNode !== null) textureNode.biasNode = $03ccd63b0299d6a7$var$nodeObject(biasNode);
    } else textureNode = $03ccd63b0299d6a7$var$textureBase(value, uvNode, levelNode, biasNode);
    return textureNode;
};
/**
 * TSL function for creating a uniform texture node.
 *
 * @tsl
 * @function
 * @param {?Texture} value - The texture.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$uniformTexture = (value = $03ccd63b0299d6a7$var$EmptyTexture$1)=>$03ccd63b0299d6a7$var$texture(value);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$textureLoad = (...params)=>$03ccd63b0299d6a7$var$texture(...params).setSampler(false);
const $03ccd63b0299d6a7$var$textureLevel = (value, uv, level)=>$03ccd63b0299d6a7$var$texture(value, uv).level(level);
/**
 * Converts a texture or texture node to a sampler.
 *
 * @tsl
 * @function
 * @param {TextureNode|Texture} value - The texture or texture node to convert.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$sampler = (value)=>(value.isNode === true ? value : $03ccd63b0299d6a7$var$texture(value)).convert('sampler');
/**
 * Converts a texture or texture node to a sampler comparison.
 *
 * @tsl
 * @function
 * @param {TextureNode|Texture} value - The texture or texture node to convert.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$samplerComparison = (value)=>(value.isNode === true ? value : $03ccd63b0299d6a7$var$texture(value)).convert('samplerComparison');
/**
 * A special type of uniform node which represents array-like data
 * as uniform buffers. The access usually happens via `element()`
 * which returns an instance of {@link ArrayElementNode}. For example:
 *
 * ```js
 * const bufferNode = buffer( array, 'mat4', count );
 * const matrixNode = bufferNode.element( index ); // access a matrix from the buffer
 * ```
 * In general, it is recommended to use the more managed {@link UniformArrayNode}
 * since it handles more input types and automatically cares about buffer paddings.
 *
 * @augments UniformNode
 */ class $03ccd63b0299d6a7$export$715e91fa835e6409 extends $03ccd63b0299d6a7$export$c0cca4cf699a03e1 {
    static get type() {
        return 'BufferNode';
    }
    /**
	 * Constructs a new buffer node.
	 *
	 * @param {Array<number>} value - Array-like buffer data.
	 * @param {string} bufferType - The data type of the buffer.
	 * @param {number} [bufferCount=0] - The count of buffer elements.
	 */ constructor(value, bufferType, bufferCount = 0){
        super(value, bufferType);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferNode = true;
        /**
		 * The data type of the buffer.
		 *
		 * @type {string}
		 */ this.bufferType = bufferType;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferCount = bufferCount;
        /**
		 * An array of update ranges.
		 *
		 * @type {Array<{start: number, count: number}>}
		 */ this.updateRanges = [];
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * The data type of the buffer elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The element type.
	 */ getElementType(builder) {
        return this.getNodeType(builder);
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'buffer'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'buffer';
    }
}
/**
 * TSL function for creating a buffer node.
 *
 * @tsl
 * @function
 * @param {Array<number>} value - Array-like buffer data.
 * @param {string} type - The data type of a buffer element.
 * @param {number} count - The count of buffer elements.
 * @returns {BufferNode}
 */ const $03ccd63b0299d6a7$var$buffer = (value, type, count)=>new $03ccd63b0299d6a7$export$715e91fa835e6409(value, type, count);
/**
 * Represents the element access on uniform array nodes.
 *
 * @augments ArrayElementNode
 */ class $03ccd63b0299d6a7$var$UniformArrayElementNode extends $03ccd63b0299d6a7$export$f2edd1d22bf6d00b {
    static get type() {
        return 'UniformArrayElementNode';
    }
    /**
	 * Constructs a new buffer node.
	 *
	 * @param {UniformArrayNode} uniformArrayNode - The uniform array node to access.
	 * @param {IndexNode} indexNode - The index data that define the position of the accessed element in the array.
	 */ constructor(uniformArrayNode, indexNode){
        super(uniformArrayNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayBufferElementNode = true;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const type = this.getNodeType(builder);
        const paddedType = this.node.getPaddedType();
        return builder.format(snippet, paddedType, type);
    }
}
/**
 * Similar to {@link BufferNode} this module represents array-like data as
 * uniform buffers. Unlike {@link BufferNode}, it can handle more common
 * data types in the array (e.g `three.js` primitives) and automatically
 * manage buffer padding. It should be the first choice when working with
 * uniforms buffers.
 * ```js
 * const tintColors = uniformArray( [
 * 	new Color( 1, 0, 0 ),
 * 	new Color( 0, 1, 0 ),
 * 	new Color( 0, 0, 1 )
 * ], 'color' );
 *
 * const redColor = tintColors.element( 0 );
 *
 * @augments BufferNode
 */ class $03ccd63b0299d6a7$export$fa5dacdc1150ae22 extends $03ccd63b0299d6a7$export$715e91fa835e6409 {
    static get type() {
        return 'UniformArrayNode';
    }
    /**
	 * Constructs a new uniform array node.
	 *
	 * @param {Array<any>} value - Array holding the buffer data.
	 * @param {?string} [elementType=null] - The data type of a buffer element.
	 */ constructor(value, elementType = null){
        super(null);
        /**
		 * Array holding the buffer data. Unlike {@link BufferNode}, the array can
		 * hold number primitives as well as three.js objects like vectors, matrices
		 * or colors.
		 *
		 * @type {Array<any>}
		 */ this.array = value;
        /**
		 * The data type of an array element.
		 *
		 * @type {string}
		 */ this.elementType = elementType === null ? $03ccd63b0299d6a7$var$getValueType(value[0]) : elementType;
        /**
		 * The padded type. Uniform buffers must conform to a certain buffer layout
		 * so a separate type is computed to ensure correct buffer size.
		 *
		 * @type {string}
		 */ this.paddedType = this.getPaddedType();
        /**
		 * Overwritten since uniform array nodes are updated per render.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayBufferNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from the
	 * {@link UniformArrayNode#paddedType}.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType() {
        return this.paddedType;
    }
    /**
	 * The data type of the array elements.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The element type.
	 */ getElementType() {
        return this.elementType;
    }
    /**
	 * Returns the padded type based on the element type.
	 *
	 * @return {string} The padded type.
	 */ getPaddedType() {
        const elementType = this.elementType;
        let paddedType = 'vec4';
        if (elementType === 'mat2') paddedType = 'mat2';
        else if (/mat/.test(elementType) === true) paddedType = 'mat4';
        else if (elementType.charAt(0) === 'i') paddedType = 'ivec4';
        else if (elementType.charAt(0) === 'u') paddedType = 'uvec4';
        return paddedType;
    }
    /**
	 * The update makes sure to correctly transfer the data from the (complex) objects
	 * in the array to the internal, correctly padded value buffer.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        const { array: array, value: value } = this;
        const elementType = this.elementType;
        if (elementType === 'float' || elementType === 'int' || elementType === 'uint') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            value[index] = array[i];
        }
        else if (elementType === 'color') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.r;
            value[index + 1] = vector.g;
            value[index + 2] = vector.b || 0;
        //value[ index + 3 ] = vector.a || 0;
        }
        else if (elementType === 'mat2') for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const matrix = array[i];
            value[index] = matrix.elements[0];
            value[index + 1] = matrix.elements[1];
            value[index + 2] = matrix.elements[2];
            value[index + 3] = matrix.elements[3];
        }
        else if (elementType === 'mat3') for(let i = 0; i < array.length; i++){
            const index = i * 16;
            const matrix = array[i];
            value[index] = matrix.elements[0];
            value[index + 1] = matrix.elements[1];
            value[index + 2] = matrix.elements[2];
            value[index + 4] = matrix.elements[3];
            value[index + 5] = matrix.elements[4];
            value[index + 6] = matrix.elements[5];
            value[index + 8] = matrix.elements[6];
            value[index + 9] = matrix.elements[7];
            value[index + 10] = matrix.elements[8];
            value[index + 15] = 1;
        }
        else if (elementType === 'mat4') for(let i = 0; i < array.length; i++){
            const index = i * 16;
            const matrix = array[i];
            for(let i = 0; i < matrix.elements.length; i++)value[index + i] = matrix.elements[i];
        }
        else for(let i = 0; i < array.length; i++){
            const index = i * 4;
            const vector = array[i];
            value[index] = vector.x;
            value[index + 1] = vector.y;
            value[index + 2] = vector.z || 0;
            value[index + 3] = vector.w || 0;
        }
    }
    /**
	 * Implement the value buffer creation based on the array data.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {null}
	 */ setup(builder) {
        const length = this.array.length;
        const elementType = this.elementType;
        let arrayType = Float32Array;
        const paddedType = this.paddedType;
        const paddedElementLength = builder.getTypeLength(paddedType);
        if (elementType.charAt(0) === 'i') arrayType = Int32Array;
        if (elementType.charAt(0) === 'u') arrayType = Uint32Array;
        this.value = new arrayType(length * paddedElementLength);
        this.bufferCount = length;
        this.bufferType = paddedType;
        this.update(); // initialize the buffer values
        return super.setup(builder);
    }
    /**
	 * Overwrites the default `element()` method to provide element access
	 * based on {@link UniformArrayNode}.
	 *
	 * @param {IndexNode} indexNode - The index node.
	 * @return {UniformArrayElementNode}
	 */ element(indexNode) {
        return new $03ccd63b0299d6a7$var$UniformArrayElementNode(this, $03ccd63b0299d6a7$var$nodeObject(indexNode));
    }
}
/**
 * TSL function for creating an uniform array node.
 *
 * @tsl
 * @function
 * @param {Array<any>} values - Array-like data.
 * @param {?string} [nodeType] - The data type of the array elements.
 * @returns {UniformArrayNode}
 */ const $03ccd63b0299d6a7$var$uniformArray = (values, nodeType)=>new $03ccd63b0299d6a7$export$fa5dacdc1150ae22(values, nodeType);
/**
 * The node allows to set values for built-in shader variables. That is
 * required for features like hardware-accelerated vertex clipping.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$cb12b6a00a6a115f extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    /**
	 * Constructs a new builtin node.
	 *
	 * @param {string} name - The name of the built-in shader variable.
	 */ constructor(name){
        super('float');
        /**
		 * The name of the built-in shader variable.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBuiltinNode = true;
    }
    /**
	 * Generates the code snippet of the builtin node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate() {
        return this.name;
    }
}
/**
 * TSL function for creating a builtin node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the built-in shader variable.
 * @returns {BuiltinNode}
 */ const $03ccd63b0299d6a7$var$builtin = $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$cb12b6a00a6a115f).setParameterLength(1);
let $03ccd63b0299d6a7$var$_screenSizeVec, $03ccd63b0299d6a7$var$_viewportVec;
/**
 * This node provides a collection of screen related metrics.
 * Depending on {@link ScreenNode#scope}, the nodes can represent
 * resolution or viewport data as well as fragment or uv coordinates.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$80eb8887666700bd extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ScreenNode';
    }
    /**
	 * Constructs a new screen node.
	 *
	 * @param {('coordinate'|'viewport'|'size'|'uv'|'dpr')} scope - The node's scope.
	 */ constructor(scope){
        super();
        /**
		 * The node represents different metric depending on which scope is selected.
		 *
		 * - `ScreenNode.COORDINATE`: Window-relative coordinates of the current fragment according to WebGPU standards.
		 * - `ScreenNode.VIEWPORT`: The current viewport defined as a four-dimensional vector.
		 * - `ScreenNode.SIZE`: The dimensions of the current bound framebuffer.
		 * - `ScreenNode.UV`: Normalized coordinates.
		 * - `ScreenNode.DPR`: Device pixel ratio.
		 *
		 * @type {('coordinate'|'viewport'|'size'|'uv'|'dpr')}
		 */ this.scope = scope;
        /**
		 * This output node.
		 *
		 * @private
		 * @type {?Node}
		 * @default null
		 */ this._output = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isViewportNode = true;
    }
    /**
	 * This method is overwritten since the node type depends on the selected scope.
	 *
	 * @return {('float'|'vec2'|'vec4')} The node type.
	 */ generateNodeType() {
        if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.DPR) return 'float';
        if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT) return 'vec4';
        else return 'vec2';
    }
    /**
	 * This method is overwritten since the node's update type depends on the selected scope.
	 *
	 * @return {NodeUpdateType} The update type.
	 */ getUpdateType() {
        let updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE;
        if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.SIZE || this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT || this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.DPR) updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        this.updateType = updateType;
        return updateType;
    }
    /**
	 * `ScreenNode` implements {@link Node#update} to retrieve viewport and size information
	 * from the current renderer.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update({ renderer: renderer }) {
        const renderTarget = renderer.getRenderTarget();
        if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT) {
            if (renderTarget !== null) $03ccd63b0299d6a7$var$_viewportVec.copy(renderTarget.viewport);
            else {
                renderer.getViewport($03ccd63b0299d6a7$var$_viewportVec);
                $03ccd63b0299d6a7$var$_viewportVec.multiplyScalar(renderer.getPixelRatio());
            }
        } else if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.DPR) this._output.value = renderer.getPixelRatio();
        else if (renderTarget !== null) {
            $03ccd63b0299d6a7$var$_screenSizeVec.width = renderTarget.width;
            $03ccd63b0299d6a7$var$_screenSizeVec.height = renderTarget.height;
        } else renderer.getDrawingBufferSize($03ccd63b0299d6a7$var$_screenSizeVec);
    }
    setup() {
        const scope = this.scope;
        let output = null;
        if (scope === $03ccd63b0299d6a7$export$80eb8887666700bd.SIZE) output = $03ccd63b0299d6a7$var$uniform($03ccd63b0299d6a7$var$_screenSizeVec || ($03ccd63b0299d6a7$var$_screenSizeVec = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()));
        else if (scope === $03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT) output = $03ccd63b0299d6a7$var$uniform($03ccd63b0299d6a7$var$_viewportVec || ($03ccd63b0299d6a7$var$_viewportVec = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)()));
        else if (scope === $03ccd63b0299d6a7$export$80eb8887666700bd.DPR) output = $03ccd63b0299d6a7$var$uniform(1);
        else output = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$screenCoordinate.div($03ccd63b0299d6a7$var$screenSize));
        this._output = output;
        return output;
    }
    generate(builder) {
        if (this.scope === $03ccd63b0299d6a7$export$80eb8887666700bd.COORDINATE) {
            let coord = builder.getFragCoord();
            if (builder.isFlipY()) {
                // follow webgpu standards
                const size = builder.getNodeProperties($03ccd63b0299d6a7$var$screenSize).outputNode.build(builder);
                coord = `${builder.getType('vec2')}( ${coord}.x, ${size}.y - ${coord}.y )`;
            }
            return coord;
        }
        return super.generate(builder);
    }
}
$03ccd63b0299d6a7$export$80eb8887666700bd.COORDINATE = 'coordinate';
$03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT = 'viewport';
$03ccd63b0299d6a7$export$80eb8887666700bd.SIZE = 'size';
$03ccd63b0299d6a7$export$80eb8887666700bd.UV = 'uv';
$03ccd63b0299d6a7$export$80eb8887666700bd.DPR = 'dpr';
// Screen
/**
 * TSL object that represents the current DPR.
 *
 * @tsl
 * @type {ScreenNode<float>}
 */ const $03ccd63b0299d6a7$var$screenDPR = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$80eb8887666700bd, $03ccd63b0299d6a7$export$80eb8887666700bd.DPR);
/**
 * TSL object that represents normalized screen coordinates, unitless in `[0, 1]`.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$screenUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$80eb8887666700bd, $03ccd63b0299d6a7$export$80eb8887666700bd.UV);
/**
 * TSL object that represents the screen resolution in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$screenSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$80eb8887666700bd, $03ccd63b0299d6a7$export$80eb8887666700bd.SIZE);
/**
 * TSL object that represents the current `x`/`y` pixel position on the screen in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$screenCoordinate = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$80eb8887666700bd, $03ccd63b0299d6a7$export$80eb8887666700bd.COORDINATE);
// Viewport
/**
 * TSL object that represents the viewport rectangle as `x`, `y`, `width` and `height` in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec4>}
 */ const $03ccd63b0299d6a7$var$viewport = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$80eb8887666700bd, $03ccd63b0299d6a7$export$80eb8887666700bd.VIEWPORT);
/**
 * TSL object that represents the viewport resolution in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$viewportSize = $03ccd63b0299d6a7$var$viewport.zw;
/**
 * TSL object that represents the current `x`/`y` pixel position on the viewport in physical pixel units.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$viewportCoordinate = /*@__PURE__*/ $03ccd63b0299d6a7$var$screenCoordinate.sub($03ccd63b0299d6a7$var$viewport.xy);
/**
 * TSL object that represents normalized viewport coordinates, unitless in `[0, 1]`.
 *
 * @tsl
 * @type {ScreenNode<vec2>}
 */ const $03ccd63b0299d6a7$var$viewportUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$viewportCoordinate.div($03ccd63b0299d6a7$var$viewportSize);
// Deprecated
/**
 * @deprecated since r169. Use {@link screenSize} instead.
 */ const $03ccd63b0299d6a7$var$viewportResolution = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(()=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "viewportResolution" is deprecated. Use "screenSize" instead.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
    return $03ccd63b0299d6a7$var$screenSize;
}, 'vec2').once()();
// Cache node uniforms
let $03ccd63b0299d6a7$var$_cameraProjectionMatrixBase = null;
let $03ccd63b0299d6a7$var$_cameraProjectionMatrixArray = null;
let $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseBase = null;
let $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseArray = null;
let $03ccd63b0299d6a7$var$_cameraViewMatrixBase = null;
let $03ccd63b0299d6a7$var$_cameraViewMatrixArray = null;
let $03ccd63b0299d6a7$var$_cameraWorldMatrixBase = null;
let $03ccd63b0299d6a7$var$_cameraWorldMatrixArray = null;
let $03ccd63b0299d6a7$var$_cameraNormalMatrixBase = null;
let $03ccd63b0299d6a7$var$_cameraNormalMatrixArray = null;
let $03ccd63b0299d6a7$var$_cameraPositionBase = null;
let $03ccd63b0299d6a7$var$_cameraPositionArray = null;
let $03ccd63b0299d6a7$var$_cameraViewportBase = null;
let $03ccd63b0299d6a7$var$_cameraViewportArray = null;
/**
 * TSL object that represents the current `index` value of the camera if used ArrayCamera.
 *
 * @tsl
 * @type {UniformNode<uint>}
 */ const $03ccd63b0299d6a7$var$cameraIndex = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0, 'uint').setName('u_cameraIndex').setGroup($03ccd63b0299d6a7$var$sharedUniformGroup('cameraIndex')).toVarying('v_cameraIndex');
/**
 * TSL object that represents the `near` value of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $03ccd63b0299d6a7$var$cameraNear = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform('float').setName('cameraNear').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.near);
/**
 * TSL object that represents the `far` value of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $03ccd63b0299d6a7$var$cameraFar = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform('float').setName('cameraFar').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.far);
/**
 * TSL object that represents the projection matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $03ccd63b0299d6a7$var$cameraProjectionMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraProjectionMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.projectionMatrix);
        if ($03ccd63b0299d6a7$var$_cameraProjectionMatrixArray === null) $03ccd63b0299d6a7$var$_cameraProjectionMatrixArray = $03ccd63b0299d6a7$var$uniformArray(matrices).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraProjectionMatrices');
        else $03ccd63b0299d6a7$var$_cameraProjectionMatrixArray.array = matrices;
        cameraProjectionMatrix = $03ccd63b0299d6a7$var$_cameraProjectionMatrixArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraProjectionMatrix');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraProjectionMatrixBase === null) $03ccd63b0299d6a7$var$_cameraProjectionMatrixBase = $03ccd63b0299d6a7$var$uniform(camera.projectionMatrix).setName('cameraProjectionMatrix').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.projectionMatrix);
        cameraProjectionMatrix = $03ccd63b0299d6a7$var$_cameraProjectionMatrixBase;
    }
    return cameraProjectionMatrix;
}).once()();
/**
 * TSL object that represents the inverse projection matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $03ccd63b0299d6a7$var$cameraProjectionMatrixInverse = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraProjectionMatrixInverse;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.projectionMatrixInverse);
        if ($03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseArray === null) $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseArray = $03ccd63b0299d6a7$var$uniformArray(matrices).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraProjectionMatricesInverse');
        else $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseArray.array = matrices;
        cameraProjectionMatrixInverse = $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraProjectionMatrixInverse');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseBase === null) $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseBase = $03ccd63b0299d6a7$var$uniform(camera.projectionMatrixInverse).setName('cameraProjectionMatrixInverse').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.projectionMatrixInverse);
        cameraProjectionMatrixInverse = $03ccd63b0299d6a7$var$_cameraProjectionMatrixInverseBase;
    }
    return cameraProjectionMatrixInverse;
}).once()();
/**
 * TSL object that represents the view matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $03ccd63b0299d6a7$var$cameraViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraViewMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.matrixWorldInverse);
        if ($03ccd63b0299d6a7$var$_cameraViewMatrixArray === null) $03ccd63b0299d6a7$var$_cameraViewMatrixArray = $03ccd63b0299d6a7$var$uniformArray(matrices).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraViewMatrices');
        else $03ccd63b0299d6a7$var$_cameraViewMatrixArray.array = matrices;
        cameraViewMatrix = $03ccd63b0299d6a7$var$_cameraViewMatrixArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraViewMatrix');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraViewMatrixBase === null) $03ccd63b0299d6a7$var$_cameraViewMatrixBase = $03ccd63b0299d6a7$var$uniform(camera.matrixWorldInverse).setName('cameraViewMatrix').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.matrixWorldInverse);
        cameraViewMatrix = $03ccd63b0299d6a7$var$_cameraViewMatrixBase;
    }
    return cameraViewMatrix;
}).once()();
/**
 * TSL object that represents the world matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $03ccd63b0299d6a7$var$cameraWorldMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraWorldMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.matrixWorld);
        if ($03ccd63b0299d6a7$var$_cameraWorldMatrixArray === null) $03ccd63b0299d6a7$var$_cameraWorldMatrixArray = $03ccd63b0299d6a7$var$uniformArray(matrices).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraWorldMatrices');
        else $03ccd63b0299d6a7$var$_cameraWorldMatrixArray.array = matrices;
        cameraWorldMatrix = $03ccd63b0299d6a7$var$_cameraWorldMatrixArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraWorldMatrix');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraWorldMatrixBase === null) $03ccd63b0299d6a7$var$_cameraWorldMatrixBase = $03ccd63b0299d6a7$var$uniform(camera.matrixWorld).setName('cameraWorldMatrix').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.matrixWorld);
        cameraWorldMatrix = $03ccd63b0299d6a7$var$_cameraWorldMatrixBase;
    }
    return cameraWorldMatrix;
}).once()();
/**
 * TSL object that represents the normal matrix of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<mat3>}
 */ const $03ccd63b0299d6a7$var$cameraNormalMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraNormalMatrix;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const matrices = [];
        for (const subCamera of camera.cameras)matrices.push(subCamera.normalMatrix);
        if ($03ccd63b0299d6a7$var$_cameraNormalMatrixArray === null) $03ccd63b0299d6a7$var$_cameraNormalMatrixArray = $03ccd63b0299d6a7$var$uniformArray(matrices).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraNormalMatrices');
        else $03ccd63b0299d6a7$var$_cameraNormalMatrixArray.array = matrices;
        cameraNormalMatrix = $03ccd63b0299d6a7$var$_cameraNormalMatrixArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraNormalMatrix');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraNormalMatrixBase === null) $03ccd63b0299d6a7$var$_cameraNormalMatrixBase = $03ccd63b0299d6a7$var$uniform(camera.normalMatrix).setName('cameraNormalMatrix').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera })=>camera.normalMatrix);
        cameraNormalMatrix = $03ccd63b0299d6a7$var$_cameraNormalMatrixBase;
    }
    return cameraNormalMatrix;
}).once()();
/**
 * TSL object that represents the position in world space of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<vec3>}
 */ const $03ccd63b0299d6a7$var$cameraPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraPosition;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const positions = [];
        for(let i = 0, l = camera.cameras.length; i < l; i++)positions.push(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)());
        if ($03ccd63b0299d6a7$var$_cameraPositionArray === null) $03ccd63b0299d6a7$var$_cameraPositionArray = $03ccd63b0299d6a7$var$uniformArray(positions).setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraPositions').onRenderUpdate(({ camera: camera }, self1)=>{
            const subCameras = camera.cameras;
            const array = self1.array;
            for(let i = 0, l = subCameras.length; i < l; i++)array[i].setFromMatrixPosition(subCameras[i].matrixWorld);
        });
        else $03ccd63b0299d6a7$var$_cameraPositionArray.array = positions;
        cameraPosition = $03ccd63b0299d6a7$var$_cameraPositionArray.element(camera.isMultiViewCamera ? $03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR') : $03ccd63b0299d6a7$var$cameraIndex).toConst('cameraPosition');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraPositionBase === null) $03ccd63b0299d6a7$var$_cameraPositionBase = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setName('cameraPosition').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera }, self1)=>self1.value.setFromMatrixPosition(camera.matrixWorld));
        cameraPosition = $03ccd63b0299d6a7$var$_cameraPositionBase;
    }
    return cameraPosition;
}).once()();
/**
 * TSL object that represents the viewport of the camera used for the current render.
 *
 * @tsl
 * @type {UniformNode<vec4>}
 */ const $03ccd63b0299d6a7$var$cameraViewport = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ camera: camera })=>{
    let cameraViewport;
    if (camera.isArrayCamera && camera.cameras.length > 0) {
        const viewports = [];
        for (const subCamera of camera.cameras)viewports.push(subCamera.viewport);
        if ($03ccd63b0299d6a7$var$_cameraViewportArray === null) $03ccd63b0299d6a7$var$_cameraViewportArray = $03ccd63b0299d6a7$var$uniformArray(viewports, 'vec4').setGroup($03ccd63b0299d6a7$var$renderGroup).setName('cameraViewports');
        else $03ccd63b0299d6a7$var$_cameraViewportArray.array = viewports;
        cameraViewport = $03ccd63b0299d6a7$var$_cameraViewportArray.element($03ccd63b0299d6a7$var$cameraIndex).toConst('cameraViewport');
    } else {
        if ($03ccd63b0299d6a7$var$_cameraViewportBase === null) // Fallback for single camera
        $03ccd63b0299d6a7$var$_cameraViewportBase = $03ccd63b0299d6a7$var$vec4(0, 0, $03ccd63b0299d6a7$var$screenSize.x, $03ccd63b0299d6a7$var$screenSize.y).toConst('cameraViewport');
        cameraViewport = $03ccd63b0299d6a7$var$_cameraViewportBase;
    }
    return cameraViewport;
}).once()();
const $03ccd63b0299d6a7$var$_sphere = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$805e8b72413ccaba)();
/**
 * This node can be used to access transformation related metrics of 3D objects.
 * Depending on the selected scope, a different metric is represented as a uniform
 * in the shader. The following scopes are supported:
 *
 * - `POSITION`: The object's position in world space.
 * - `VIEW_POSITION`: The object's position in view/camera space.
 * - `DIRECTION`: The object's direction in world space.
 * - `SCALE`: The object's scale in world space.
 * - `WORLD_MATRIX`: The object's matrix in world space.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$2c22938328ec188a extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'Object3DNode';
    }
    /**
	 * Constructs a new object 3D node.
	 *
	 * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
	 * @param {?Object3D} [object3d=null] - The 3D object.
	 */ constructor(scope, object3d = null){
        super();
        /**
		 * The node reports a different type of transformation depending on the scope.
		 *
		 * @type {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')}
		 */ this.scope = scope;
        /**
		 * The 3D object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.object3d = object3d;
        /**
		 * Overwritten since this type of node is updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Holds the value of the node as a uniform.
		 *
		 * @type {UniformNode}
		 */ this.uniformNode = new $03ccd63b0299d6a7$export$c0cca4cf699a03e1(null);
    }
    /**
	 * Overwritten since the node type is inferred from the scope.
	 *
	 * @return {('mat4'|'vec3'|'float')} The node type.
	 */ generateNodeType() {
        const scope = this.scope;
        if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.WORLD_MATRIX) return 'mat4';
        else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.POSITION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.VIEW_POSITION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.DIRECTION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.SCALE) return 'vec3';
        else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.RADIUS) return 'float';
    }
    /**
	 * Updates the uniform value depending on the scope.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        const object = this.object3d;
        const uniformNode = this.uniformNode;
        const scope = this.scope;
        if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.WORLD_MATRIX) uniformNode.value = object.matrixWorld;
        else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.POSITION) {
            uniformNode.value = uniformNode.value || new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
        } else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.SCALE) {
            uniformNode.value = uniformNode.value || new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixScale(object.matrixWorld);
        } else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.DIRECTION) {
            uniformNode.value = uniformNode.value || new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
            object.getWorldDirection(uniformNode.value);
        } else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.VIEW_POSITION) {
            const camera = frame.camera;
            uniformNode.value = uniformNode.value || new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
            uniformNode.value.setFromMatrixPosition(object.matrixWorld);
            uniformNode.value.applyMatrix4(camera.matrixWorldInverse);
        } else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.RADIUS) {
            const geometry = frame.object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $03ccd63b0299d6a7$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
            uniformNode.value = $03ccd63b0299d6a7$var$_sphere.radius;
        }
    }
    /**
	 * Generates the code snippet of the uniform node. The node type of the uniform
	 * node also depends on the selected scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        const scope = this.scope;
        if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.WORLD_MATRIX) this.uniformNode.nodeType = 'mat4';
        else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.POSITION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.VIEW_POSITION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.DIRECTION || scope === $03ccd63b0299d6a7$export$2c22938328ec188a.SCALE) this.uniformNode.nodeType = 'vec3';
        else if (scope === $03ccd63b0299d6a7$export$2c22938328ec188a.RADIUS) this.uniformNode.nodeType = 'float';
        return this.uniformNode.build(builder);
    }
    serialize(data) {
        super.serialize(data);
        data.scope = this.scope;
    }
    deserialize(data) {
        super.deserialize(data);
        this.scope = data.scope;
    }
}
$03ccd63b0299d6a7$export$2c22938328ec188a.WORLD_MATRIX = 'worldMatrix';
$03ccd63b0299d6a7$export$2c22938328ec188a.POSITION = 'position';
$03ccd63b0299d6a7$export$2c22938328ec188a.SCALE = 'scale';
$03ccd63b0299d6a7$export$2c22938328ec188a.VIEW_POSITION = 'viewPosition';
$03ccd63b0299d6a7$export$2c22938328ec188a.DIRECTION = 'direction';
$03ccd63b0299d6a7$export$2c22938328ec188a.RADIUS = 'radius';
/**
 * TSL function for creating an object 3D node that represents the object's direction in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $03ccd63b0299d6a7$var$objectDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.DIRECTION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's world matrix.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<mat4>}
 */ const $03ccd63b0299d6a7$var$objectWorldMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.WORLD_MATRIX).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's position in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $03ccd63b0299d6a7$var$objectPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.POSITION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's scale in world space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $03ccd63b0299d6a7$var$objectScale = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.SCALE).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's position in view/camera space.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<vec3>}
 */ const $03ccd63b0299d6a7$var$objectViewPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.VIEW_POSITION).setParameterLength(1);
/**
 * TSL function for creating an object 3D node that represents the object's radius.
 *
 * @tsl
 * @function
 * @param {?Object3D} [object3d] - The 3D object.
 * @returns {Object3DNode<float>}
 */ const $03ccd63b0299d6a7$var$objectRadius = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$2c22938328ec188a, $03ccd63b0299d6a7$export$2c22938328ec188a.RADIUS).setParameterLength(1);
/**
 * This type of node is a specialized version of `Object3DNode`
 * with larger set of model related metrics. Unlike `Object3DNode`,
 * `ModelNode` extracts the reference to the 3D object from the
 * current node frame state.
 *
 * @augments Object3DNode
 */ class $03ccd63b0299d6a7$export$f15b179a1cc9e2bb extends $03ccd63b0299d6a7$export$2c22938328ec188a {
    static get type() {
        return 'ModelNode';
    }
    /**
	 * Constructs a new object model node.
	 *
	 * @param {('position'|'viewPosition'|'direction'|'scale'|'worldMatrix')} scope - The node represents a different type of transformation depending on the scope.
	 */ constructor(scope){
        super(scope);
    }
    /**
	 * Extracts the model reference from the frame state and then
	 * updates the uniform value depending on the scope.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        this.object3d = frame.object;
        super.update(frame);
    }
}
/**
 * TSL object that represents the object's direction in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $03ccd63b0299d6a7$var$modelDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.DIRECTION);
/**
 * TSL object that represents the object's world matrix.
 *
 * @tsl
 * @type {ModelNode<mat4>}
 */ const $03ccd63b0299d6a7$var$modelWorldMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.WORLD_MATRIX);
/**
 * TSL object that represents the object's position in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $03ccd63b0299d6a7$var$modelPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.POSITION);
/**
 * TSL object that represents the object's scale in world space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $03ccd63b0299d6a7$var$modelScale = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.SCALE);
/**
 * TSL object that represents the object's position in view/camera space.
 *
 * @tsl
 * @type {ModelNode<vec3>}
 */ const $03ccd63b0299d6a7$var$modelViewPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.VIEW_POSITION);
/**
 * TSL object that represents the object's radius.
 *
 * @tsl
 * @type {ModelNode<float>}
 */ const $03ccd63b0299d6a7$var$modelRadius = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$f15b179a1cc9e2bb, $03ccd63b0299d6a7$export$f15b179a1cc9e2bb.RADIUS);
/**
 * TSL object that represents the object's normal matrix.
 *
 * @tsl
 * @type {UniformNode<mat3>}
 */ const $03ccd63b0299d6a7$var$modelNormalMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()).onObjectUpdate(({ object: object }, self1)=>self1.value.getNormalMatrix(object.matrixWorld));
/**
 * TSL object that represents the object's inverse world matrix.
 *
 * @tsl
 * @type {UniformNode<mat4>}
 */ const $03ccd63b0299d6a7$var$modelWorldMatrixInverse = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)()).onObjectUpdate(({ object: object }, self1)=>self1.value.copy(object.matrixWorld).invert());
/**
 * TSL object that represents the object's model view matrix.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $03ccd63b0299d6a7$var$modelViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    return builder.context.modelViewMatrix || $03ccd63b0299d6a7$var$mediumpModelViewMatrix;
}).once()().toVar('modelViewMatrix');
// GPU Precision
/**
 * TSL object that represents the object's model view in `mediump` precision.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $03ccd63b0299d6a7$var$mediumpModelViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$cameraViewMatrix.mul($03ccd63b0299d6a7$var$modelWorldMatrix);
// CPU Precision
/**
 * TSL object that represents the object's model view in `highp` precision
 * which is achieved by computing the matrix in JS and not in the shader.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $03ccd63b0299d6a7$var$highpModelViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    builder.context.isHighPrecisionModelViewMatrix = true;
    return $03ccd63b0299d6a7$var$uniform('mat4').onObjectUpdate(({ object: object, camera: camera })=>{
        return object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    });
}).once()().toVar('highpModelViewMatrix');
/**
 * TSL object that represents the object's model normal view in `highp` precision
 * which is achieved by computing the matrix in JS and not in the shader.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $03ccd63b0299d6a7$var$highpModelNormalViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    const isHighPrecisionModelViewMatrix = builder.context.isHighPrecisionModelViewMatrix;
    return $03ccd63b0299d6a7$var$uniform('mat3').onObjectUpdate(({ object: object, camera: camera })=>{
        if (isHighPrecisionModelViewMatrix !== true) object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        return object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    });
}).once()().toVar('highpModelNormalViewMatrix');
/**
 * TSL object that represents the clip space position of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec4>}
 */ const $03ccd63b0299d6a7$var$clipSpace = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    if (builder.shaderStage !== 'fragment') {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('TSL: `clipSpace` is only available in fragment stage.');
        return $03ccd63b0299d6a7$var$vec4();
    }
    return builder.context.clipSpace.toVarying('v_clipSpace');
}).once()();
/**
 * TSL object that represents the position attribute of the current rendered object.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$attribute('position', 'vec3');
/**
 * TSL object that represents the vertex position in local space of the current rendered object.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionLocal = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionGeometry.toVarying('positionLocal');
/**
 * TSL object that represents the previous vertex position in local space of the current rendered object.
 * Used in context of {@link VelocityNode} for rendering motion vectors.
 *
 * @tsl
 * @type {AttributeNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionPrevious = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionGeometry.toVarying('positionPrevious');
/**
 * TSL object that represents the vertex position in world space of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionWorld = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    return $03ccd63b0299d6a7$var$modelWorldMatrix.mul($03ccd63b0299d6a7$var$positionLocal).xyz.toVarying(builder.getSubBuildProperty('v_positionWorld'));
}, 'vec3').once([
    'POSITION'
])();
/**
 * TSL object that represents the position world direction of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$positionWorldDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(()=>{
    const vertexPWD = $03ccd63b0299d6a7$var$positionLocal.transformDirection($03ccd63b0299d6a7$var$modelWorldMatrix).toVarying('v_positionWorldDirection');
    return vertexPWD.normalize().toVar('positionWorldDirection');
}, 'vec3').once([
    'POSITION'
])();
/**
 * TSL object that represents the vertex position in view space of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    if (builder.shaderStage === 'fragment' && builder.material.vertexNode) {
        // reconstruct view position from clip space
        const viewPos = $03ccd63b0299d6a7$var$cameraProjectionMatrixInverse.mul($03ccd63b0299d6a7$var$clipSpace);
        return viewPos.xyz.div(viewPos.w).toVar('positionView');
    }
    return builder.context.setupPositionView().toVarying('v_positionView');
}, 'vec3').once([
    'POSITION',
    'VERTEX'
])();
/**
 * TSL object that represents the position view direction of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec3>}
 */ const $03ccd63b0299d6a7$var$positionViewDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let output;
    if (builder.camera.isOrthographicCamera) output = $03ccd63b0299d6a7$var$vec3(0, 0, 1);
    else output = $03ccd63b0299d6a7$var$positionView.negate().toVarying('v_positionViewDirection').normalize();
    return output.toVar('positionViewDirection');
}, 'vec3').once([
    'POSITION'
])();
/**
 * This node can be used to evaluate whether a primitive is front or back facing.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$dd6b5700d49da9d0 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'FrontFacingNode';
    }
    /**
	 * Constructs a new front facing node.
	 */ constructor(){
        super('bool');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFrontFacingNode = true;
    }
    generate(builder) {
        if (builder.shaderStage !== 'fragment') return 'true';
        //
        const { material: material } = builder;
        if (material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)) return 'false';
        return builder.getFrontFacing();
    }
}
/**
 * TSL object that represents whether a primitive is front or back facing
 *
 * @tsl
 * @type {FrontFacingNode<bool>}
 */ const $03ccd63b0299d6a7$var$frontFacing = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$dd6b5700d49da9d0);
/**
 * TSL object that represents the front facing status as a number instead of a bool.
 * `1` means front facing, `-1` means back facing.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$faceDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$frontFacing).mul(2.0).sub(1.0);
/**
 * Converts a direction vector to a face direction vector based on the material's side.
 *
 * If the material is set to `BackSide`, the direction is inverted.
 * If the material is set to `DoubleSide`, the direction is multiplied by `faceDirection`.
 *
 * @tsl
 * @param {Node<vec3>} direction - The direction vector to convert.
 * @returns {Node<vec3>} The converted direction vector.
 */ const $03ccd63b0299d6a7$var$directionToFaceDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([direction], { material: material })=>{
    const side = material.side;
    if (side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)) direction = direction.mul(-1);
    else if (side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03)) direction = direction.mul($03ccd63b0299d6a7$var$faceDirection);
    return direction;
});
/**
 * TSL object that represents the normal attribute of the current rendered object in local space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$attribute('normal', 'vec3');
/**
 * TSL object that represents the vertex normal of the current rendered object in local space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalLocal = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: Vertex attribute "normal" not found on geometry.');
        return $03ccd63b0299d6a7$var$vec3(0, 1, 0);
    }
    return $03ccd63b0299d6a7$var$normalGeometry;
}, 'vec3').once()().toVar('normalLocal');
/**
 * TSL object that represents the flat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalFlat = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionView.dFdx().cross($03ccd63b0299d6a7$var$positionView.dFdy()).normalize().toVar('normalFlat');
/**
 * TSL object that represents the vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalViewGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let node;
    if (builder.isFlatShading()) node = $03ccd63b0299d6a7$var$normalFlat;
    else node = $03ccd63b0299d6a7$var$transformNormalToView($03ccd63b0299d6a7$var$normalLocal).toVarying('v_normalViewGeometry').normalize();
    return node;
}, 'vec3').once()().toVar('normalViewGeometry');
/**
 * TSL object that represents the vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalWorldGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let normal = $03ccd63b0299d6a7$var$normalViewGeometry.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix);
    if (builder.isFlatShading() !== true) normal = normal.toVarying('v_normalWorldGeometry');
    return normal.normalize().toVar('normalWorldGeometry');
}, 'vec3').once()();
/**
 * TSL object that represents the vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let node;
    if (builder.subBuildFn === 'NORMAL' || builder.subBuildFn === 'VERTEX') {
        node = $03ccd63b0299d6a7$var$normalViewGeometry;
        if (builder.isFlatShading() !== true) node = $03ccd63b0299d6a7$var$directionToFaceDirection(node);
    } else // Use custom context to avoid side effects from nodes overwriting getUV, getTextureLevel in the context (e.g. EnvironmentNode)
    node = builder.context.setupNormal().context({
        getUV: null,
        getTextureLevel: null
    });
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('normalView');
/**
 * TSL object that represents the vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$normalWorld = /*@__PURE__*/ $03ccd63b0299d6a7$var$normalView.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix).toVar('normalWorld');
/**
 * TSL object that represents the clearcoat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$clearcoatNormalView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ subBuildFn: subBuildFn, context: context })=>{
    let node;
    if (subBuildFn === 'NORMAL' || subBuildFn === 'VERTEX') node = $03ccd63b0299d6a7$var$normalView;
    else // Use custom context to avoid side effects from nodes overwriting getUV, getTextureLevel in the context (e.g. EnvironmentNode)
    node = context.setupClearcoatNormal().context({
        getUV: null,
        getTextureLevel: null
    });
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('clearcoatNormalView');
/**
 * Transforms the normal with the given matrix.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal.
 * @param {Node<mat3>} [matrix=modelWorldMatrix] - The matrix.
 * @return {Node<vec3>} The transformed normal.
 */ const $03ccd63b0299d6a7$var$transformNormal = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([normal, matrix = $03ccd63b0299d6a7$var$modelWorldMatrix])=>{
    const m = $03ccd63b0299d6a7$var$mat3(matrix);
    const transformedNormal = normal.div($03ccd63b0299d6a7$var$vec3(m[0].dot(m[0]), m[1].dot(m[1]), m[2].dot(m[2])));
    return m.mul(transformedNormal).xyz;
});
/**
 * Transforms the given normal from local to view space.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal.
 * @param {NodeBuilder} builder - The current node builder.
 * @return {Node<vec3>} The transformed normal.
 */ const $03ccd63b0299d6a7$var$transformNormalToView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([normal], builder)=>{
    const modelNormalViewMatrix = builder.context.modelNormalViewMatrix;
    if (modelNormalViewMatrix) return modelNormalViewMatrix.transformDirection(normal);
    //
    const transformedNormal = $03ccd63b0299d6a7$var$modelNormalMatrix.mul(normal);
    return $03ccd63b0299d6a7$var$cameraViewMatrix.transformDirection(transformedNormal);
});
// Deprecated
/**
 * TSL object that represents the transformed vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `normalView` instead.
 */ const $03ccd63b0299d6a7$var$transformedNormalView = $03ccd63b0299d6a7$var$Fn(()=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "transformedNormalView" is deprecated. Use "normalView" instead.');
    return $03ccd63b0299d6a7$var$normalView;
}).once([
    'NORMAL',
    'VERTEX'
])();
/**
 * TSL object that represents the transformed vertex normal of the current rendered object in world space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `normalWorld` instead.
 */ const $03ccd63b0299d6a7$var$transformedNormalWorld = $03ccd63b0299d6a7$var$Fn(()=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "transformedNormalWorld" is deprecated. Use "normalWorld" instead.');
    return $03ccd63b0299d6a7$var$normalWorld;
}).once([
    'NORMAL',
    'VERTEX'
])();
/**
 * TSL object that represents the transformed clearcoat vertex normal of the current rendered object in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 * @deprecated since r178. Use `clearcoatNormalView` instead.
 */ const $03ccd63b0299d6a7$var$transformedClearcoatNormalView = $03ccd63b0299d6a7$var$Fn(()=>{
    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "transformedClearcoatNormalView" is deprecated. Use "clearcoatNormalView" instead.');
    return $03ccd63b0299d6a7$var$clearcoatNormalView;
}).once([
    'NORMAL',
    'VERTEX'
])();
const $03ccd63b0299d6a7$var$_m1$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
/**
 * TSL object that represents the refraction ratio of the material used for rendering the current object.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $03ccd63b0299d6a7$var$materialRefractionRatio = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0).onReference(({ material: material })=>material).onObjectUpdate(({ material: material })=>material.refractionRatio);
/**
 * TSL object that represents the intensity of environment maps of PBR materials.
 * When `material.envMap` is set, the value is `material.envMapIntensity` otherwise `scene.environmentIntensity`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialEnvIntensity = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(1).onReference(({ material: material })=>material).onObjectUpdate(function({ material: material, scene: scene }) {
    return material.envMap ? material.envMapIntensity : scene.environmentIntensity;
});
/**
 * TSL object that represents the rotation of environment maps.
 * When `material.envMap` is set, the value is `material.envMapRotation`. `scene.environmentRotation` controls the
 * rotation of `scene.environment` instead.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $03ccd63b0299d6a7$var$materialEnvRotation = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)()).onReference(function(frame) {
    return frame.material;
}).onObjectUpdate(function({ material: material, scene: scene }) {
    const rotation = scene.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
    if (rotation) // note: since the matrix is orthonormal, we can use the more-efficient transpose() in lieu of invert()
    $03ccd63b0299d6a7$var$_m1$1.makeRotationFromEuler(rotation).transpose();
    else $03ccd63b0299d6a7$var$_m1$1.identity();
    return $03ccd63b0299d6a7$var$_m1$1;
});
/**
 * The reflect vector in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$reflectView = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionViewDirection.negate().reflect($03ccd63b0299d6a7$var$normalView);
/**
 * The refract vector in view space.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$refractView = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionViewDirection.negate().refract($03ccd63b0299d6a7$var$normalView, $03ccd63b0299d6a7$var$materialRefractionRatio);
/**
 * Used for sampling cube maps when using cube reflection mapping.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$reflectVector = /*@__PURE__*/ $03ccd63b0299d6a7$var$reflectView.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix).toVar('reflectVector');
/**
 * Used for sampling cube maps when using cube refraction mapping.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$refractVector = /*@__PURE__*/ $03ccd63b0299d6a7$var$refractView.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix).toVar('reflectVector');
const $03ccd63b0299d6a7$var$EmptyTexture = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)();
/**
 * This type of uniform node represents a cube texture.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$732dea7352dc5b2c extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'CubeTextureNode';
    }
    /**
	 * Constructs a new cube texture node.
	 *
	 * @param {CubeTexture} value - The cube texture.
	 * @param {?Node<vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 * @param {?Node<float>} [biasNode=null] - The bias node.
	 */ constructor(value, uvNode = null, levelNode = null, biasNode = null){
        super(value, uvNode, levelNode, biasNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTextureNode = true;
    }
    /**
	 * Overwrites the default implementation to return the appropriate cube texture type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        if (this.value.isDepthTexture === true) return 'cubeDepthTexture';
        return 'cubeTexture';
    }
    /**
	 * Returns a default uvs based on the mapping type of the cube texture.
	 *
	 * @return {Node<vec3>} The default uv attribute.
	 */ getDefaultUV() {
        const texture = this.value;
        if (texture.mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4)) return $03ccd63b0299d6a7$var$reflectVector;
        else if (texture.mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d)) return $03ccd63b0299d6a7$var$refractVector;
        else {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('CubeTextureNode: Mapping "%s" not supported.', texture.mapping);
            return $03ccd63b0299d6a7$var$vec3(0, 0, 0);
        }
    }
    /**
	 * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
	 * for cube textures. The uv transformation matrix is not applied to cube textures.
	 *
	 * @param {boolean} value - The update toggle.
	 */ setUpdateMatrix() {}
    /**
	 * Setups the uv node. Depending on the backend as well as the texture type, it might be necessary
	 * to modify the uv node for correct sampling.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to setup.
	 * @return {Node} The updated uv node.
	 */ setupUV(builder, uvNode) {
        const texture = this.value;
        // Depth textures (shadow maps) - no environment rotation, Y flip for WebGPU
        if (texture.isDepthTexture === true) {
            if (builder.renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac)) return $03ccd63b0299d6a7$var$vec3(uvNode.x, uvNode.y.negate(), uvNode.z);
            return uvNode;
        }
        // rotate first
        uvNode = $03ccd63b0299d6a7$var$materialEnvRotation.mul(uvNode);
        // flip
        if (builder.renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) || !texture.isRenderTargetTexture) uvNode = $03ccd63b0299d6a7$var$vec3(uvNode.x.negate(), uvNode.yz);
        return uvNode;
    }
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} cubeUV - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, cubeUV) {
        return cubeUV.build(builder, this.sampler === true ? 'vec3' : 'ivec3');
    }
}
/**
 * TSL function for creating a cube texture node.
 *
 * @tsl
 * @function
 * @param {CubeTexture} value - The cube texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {CubeTextureNode}
 */ const $03ccd63b0299d6a7$var$cubeTextureBase = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$732dea7352dc5b2c).setParameterLength(1, 4).setName('cubeTexture');
/**
 * TSL function for creating a cube texture uniform node.
 *
 * @tsl
 * @function
 * @param {?(CubeTexture|CubeTextureNode)} [value=EmptyTexture] - The cube texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {CubeTextureNode}
 */ const $03ccd63b0299d6a7$var$cubeTexture = (value = $03ccd63b0299d6a7$var$EmptyTexture, uvNode = null, levelNode = null, biasNode = null)=>{
    let textureNode;
    if (value && value.isCubeTextureNode === true) {
        textureNode = $03ccd63b0299d6a7$var$nodeObject(value.clone());
        textureNode.referenceNode = value; // Ensure the reference is set to the original node
        if (uvNode !== null) textureNode.uvNode = $03ccd63b0299d6a7$var$nodeObject(uvNode);
        if (levelNode !== null) textureNode.levelNode = $03ccd63b0299d6a7$var$nodeObject(levelNode);
        if (biasNode !== null) textureNode.biasNode = $03ccd63b0299d6a7$var$nodeObject(biasNode);
    } else textureNode = $03ccd63b0299d6a7$var$cubeTextureBase(value, uvNode, levelNode, biasNode);
    return textureNode;
};
/**
 * TSL function for creating a uniform cube texture node.
 *
 * @tsl
 * @function
 * @param {?CubeTexture} [value=EmptyTexture] - The cube texture.
 * @returns {CubeTextureNode}
 */ const $03ccd63b0299d6a7$var$uniformCubeTexture = (value = $03ccd63b0299d6a7$var$EmptyTexture)=>$03ccd63b0299d6a7$var$cubeTextureBase(value);
// TODO: Avoid duplicated code and use only ReferenceBaseNode or ReferenceNode
/**
 * This class is only relevant if the referenced property is array-like.
 * In this case, `ReferenceElementNode` allows to refer to a specific
 * element inside the data structure via an index.
 *
 * @augments ArrayElementNode
 */ class $03ccd63b0299d6a7$var$ReferenceElementNode extends $03ccd63b0299d6a7$export$f2edd1d22bf6d00b {
    static get type() {
        return 'ReferenceElementNode';
    }
    /**
	 * Constructs a new reference element node.
	 *
	 * @param {?ReferenceNode} referenceNode - The reference node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(referenceNode, indexNode){
        super(referenceNode, indexNode);
        /**
		 * Similar to {@link ReferenceNode#reference}, an additional
		 * property references to the current node.
		 *
		 * @type {?ReferenceNode}
		 * @default null
		 */ this.referenceNode = referenceNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isReferenceElementNode = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the uniform type of the reference node.
	 *
	 * @return {string} The node type.
	 */ generateNodeType() {
        return this.referenceNode.uniformType;
    }
    generate(builder) {
        const snippet = super.generate(builder);
        const arrayType = this.referenceNode.getNodeType(builder);
        const elementType = this.getNodeType(builder);
        return builder.format(snippet, arrayType, elementType);
    }
}
/**
 * This type of node establishes a reference to a property of another object.
 * In this way, the value of the node is automatically linked to the value of
 * referenced object. Reference nodes internally represent the linked value
 * as a uniform.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$81a720e7e5211d94 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ReferenceNode';
    }
    /**
	 * Constructs a new reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} uniformType - The uniform type that should be used to represent the property value.
	 * @param {?Object} [object=null] - The object the property belongs to.
	 * @param {?number} [count=null] - When the linked property is an array-like, this parameter defines its length.
	 */ constructor(property, uniformType, object = null, count = null){
        super();
        /**
		 * The name of the property the node refers to.
		 *
		 * @type {string}
		 */ this.property = property;
        /**
		 * The uniform type that should be used to represent the property value.
		 *
		 * @type {string}
		 */ this.uniformType = uniformType;
        /**
		 * The object the property belongs to.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.object = object;
        /**
		 * When the linked property is an array, this parameter defines its length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 * The property name might have dots so nested properties can be referred.
		 * The hierarchy of the names is stored inside this array.
		 *
		 * @type {Array<string>}
		 */ this.properties = property.split('.');
        /**
		 * Points to the current referred object. This property exists next to {@link ReferenceNode#object}
		 * since the final reference might be updated from calling code.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.reference = object;
        /**
		 * The uniform node that holds the value of the reference node.
		 *
		 * @type {UniformNode}
		 * @default null
		 */ this.node = null;
        /**
		 * The uniform group of the internal uniform.
		 *
		 * @type {UniformGroupNode}
		 * @default null
		 */ this.group = null;
        /**
		 * An optional label of the internal uniform node.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = null;
        /**
		 * Overwritten since reference nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * When the referred property is array-like, this method can be used
	 * to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {ReferenceElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $03ccd63b0299d6a7$var$ReferenceElementNode(this, $03ccd63b0299d6a7$var$nodeObject(indexNode));
    }
    /**
	 * Sets the uniform group for this reference node.
	 *
	 * @param {UniformGroupNode} group - The uniform group to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ setGroup(group) {
        this.group = group;
        return this;
    }
    /**
	 * Sets the name for the internal uniform.
	 *
	 * @param {string} name - The label to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the label for the internal uniform.
	 *
	 * @deprecated
	 * @param {string} name - The label to set.
	 * @return {ReferenceNode} A reference to this node.
	 */ label(name) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "label()" has been deprecated. Use "setName()" instead.'); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the node type which automatically defines the internal
	 * uniform type.
	 *
	 * @param {string} uniformType - The type to set.
	 */ setNodeType(uniformType) {
        let node = null;
        if (this.count !== null) node = $03ccd63b0299d6a7$var$buffer(null, uniformType, this.count);
        else if (Array.isArray(this.getValueFromReference())) node = $03ccd63b0299d6a7$var$uniformArray(null, uniformType);
        else if (uniformType === 'texture') node = $03ccd63b0299d6a7$var$texture(null);
        else if (uniformType === 'cubeTexture') node = $03ccd63b0299d6a7$var$cubeTexture(null);
        else node = $03ccd63b0299d6a7$var$uniform(null, uniformType);
        if (this.group !== null) node.setGroup(this.group);
        if (this.name !== null) node.setName(this.name);
        this.node = node;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the type of the reference node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        if (this.node === null) {
            this.updateReference(builder);
            this.updateValue();
        }
        return this.node.getNodeType(builder);
    }
    /**
	 * Returns the property value from the given referred object.
	 *
	 * @param {Object} [object=this.reference] - The object to retrieve the property value from.
	 * @return {any} The value.
	 */ getValueFromReference(object = this.reference) {
        const { properties: properties } = this;
        let value = object[properties[0]];
        for(let i = 1; i < properties.length; i++)value = value[properties[i]];
        return value;
    }
    /**
	 * Allows to update the reference based on the given state. The state is only
	 * evaluated {@link ReferenceNode#object} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.object !== null ? this.object : state.object;
        return this.reference;
    }
    /**
	 * The output of the reference node is the internal uniform node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {UniformNode} The output node.
	 */ setup() {
        this.updateValue();
        return this.node;
    }
    /**
	 * Overwritten to update the internal uniform value.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        this.updateValue();
    }
    /**
	 * Retrieves the value from the referred object property and uses it
	 * to updated the internal uniform.
	 */ updateValue() {
        if (this.node === null) this.setNodeType(this.uniformType);
        const value = this.getValueFromReference();
        if (Array.isArray(value)) this.node.array = value;
        else this.node.value = value;
    }
}
/**
 * TSL function for creating a reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Object} [object] - The object the property belongs to.
 * @returns {ReferenceNode}
 */ const $03ccd63b0299d6a7$var$reference = (name, type, object)=>new $03ccd63b0299d6a7$export$81a720e7e5211d94(name, type, object);
/**
 * TSL function for creating a reference node. Use this function if you want need a reference
 * to an array-like property that should be represented as a uniform buffer.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {number} count - The number of value inside the array-like object.
 * @param {Object} object - An array-like object the property belongs to.
 * @returns {ReferenceNode}
 */ const $03ccd63b0299d6a7$var$referenceBuffer = (name, type, count, object)=>new $03ccd63b0299d6a7$export$81a720e7e5211d94(name, type, object, count);
/**
 * This node is a special type of reference node which is intended
 * for linking material properties with node values.
 * ```js
 * const opacityNode = materialReference( 'opacity', 'float', material );
 * ```
 * When changing `material.opacity`, the node value of `opacityNode` will
 * automatically be updated.
 *
 * @augments ReferenceNode
 */ class $03ccd63b0299d6a7$export$a8e48e1870f9efa7 extends $03ccd63b0299d6a7$export$81a720e7e5211d94 {
    static get type() {
        return 'MaterialReferenceNode';
    }
    /**
	 * Constructs a new material reference node.
	 *
	 * @param {string} property - The name of the property the node refers to.
	 * @param {string} inputType - The uniform type that should be used to represent the property value.
	 * @param {?Material} [material=null] - The material the property belongs to. When no material is set,
	 * the node refers to the material of the current rendered object.
	 */ constructor(property, inputType, material = null){
        super(property, inputType, material);
        /**
		 * The material the property belongs to. When no material is set,
		 * the node refers to the material of the current rendered object.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.material = material;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterialReferenceNode = true;
    }
    /**
	 * Updates the reference based on the given state. The state is only evaluated
	 * {@link MaterialReferenceNode#material} is not set.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state.
	 * @return {Object} The updated reference.
	 */ updateReference(state) {
        this.reference = this.material !== null ? this.material : state.material;
        return this.reference;
    }
}
/**
 * TSL function for creating a material reference node.
 *
 * @tsl
 * @function
 * @param {string} name - The name of the property the node refers to.
 * @param {string} type - The uniform type that should be used to represent the property value.
 * @param {?Material} [material=null] - The material the property belongs to.
 * When no material is set, the node refers to the material of the current rendered object.
 * @returns {MaterialReferenceNode}
 */ const $03ccd63b0299d6a7$var$materialReference = (name, type, material = null)=>new $03ccd63b0299d6a7$export$a8e48e1870f9efa7(name, type, material);
// Normal Mapping Without Precomputed Tangents
// http://www.thetenthplanet.de/archives/1180
const $03ccd63b0299d6a7$var$uv = $03ccd63b0299d6a7$var$uv$1();
const $03ccd63b0299d6a7$var$q0 = $03ccd63b0299d6a7$var$positionView.dFdx();
const $03ccd63b0299d6a7$var$q1 = $03ccd63b0299d6a7$var$positionView.dFdy();
const $03ccd63b0299d6a7$var$st0 = $03ccd63b0299d6a7$var$uv.dFdx();
const $03ccd63b0299d6a7$var$st1 = $03ccd63b0299d6a7$var$uv.dFdy();
const $03ccd63b0299d6a7$var$N = $03ccd63b0299d6a7$var$normalView;
const $03ccd63b0299d6a7$var$q1perp = $03ccd63b0299d6a7$var$q1.cross($03ccd63b0299d6a7$var$N);
const $03ccd63b0299d6a7$var$q0perp = $03ccd63b0299d6a7$var$N.cross($03ccd63b0299d6a7$var$q0);
const $03ccd63b0299d6a7$var$T = $03ccd63b0299d6a7$var$q1perp.mul($03ccd63b0299d6a7$var$st0.x).add($03ccd63b0299d6a7$var$q0perp.mul($03ccd63b0299d6a7$var$st1.x));
const $03ccd63b0299d6a7$var$B = $03ccd63b0299d6a7$var$q1perp.mul($03ccd63b0299d6a7$var$st0.y).add($03ccd63b0299d6a7$var$q0perp.mul($03ccd63b0299d6a7$var$st1.y));
const $03ccd63b0299d6a7$var$det = $03ccd63b0299d6a7$var$T.dot($03ccd63b0299d6a7$var$T).max($03ccd63b0299d6a7$var$B.dot($03ccd63b0299d6a7$var$B));
const $03ccd63b0299d6a7$var$scale$1 = $03ccd63b0299d6a7$var$det.equal(0.0).select(0.0, $03ccd63b0299d6a7$var$det.inverseSqrt());
/**
 * Tangent vector in view space, computed dynamically from geometry and UV derivatives.
 * Useful for normal mapping without precomputed tangents.
 *
 * Reference: http://www.thetenthplanet.de/archives/1180
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$tangentViewFrame = /*@__PURE__*/ $03ccd63b0299d6a7$var$T.mul($03ccd63b0299d6a7$var$scale$1).toVar('tangentViewFrame');
/**
 * Bitangent vector in view space, computed dynamically from geometry and UV derivatives.
 * Complements the tangentViewFrame for constructing the tangent space basis.
 *
 * Reference: http://www.thetenthplanet.de/archives/1180
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$bitangentViewFrame = /*@__PURE__*/ $03ccd63b0299d6a7$var$B.mul($03ccd63b0299d6a7$var$scale$1).toVar('bitangentViewFrame');
/**
 * TSL object that represents the tangent attribute of the current rendered object.
 *
 * @tsl
 * @type {Node<vec4>}
 */ const $03ccd63b0299d6a7$var$tangentGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$attribute('tangent', 'vec4');
/**
 * TSL object that represents the vertex tangent in local space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$tangentLocal = /*@__PURE__*/ $03ccd63b0299d6a7$var$tangentGeometry.xyz.toVar('tangentLocal');
/**
 * TSL object that represents the vertex tangent in view space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$tangentView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let node;
    if (builder.subBuildFn === 'VERTEX' || builder.geometry.hasAttribute('tangent')) node = $03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$tangentLocal, 0)).xyz.toVarying('v_tangentView').normalize();
    else node = $03ccd63b0299d6a7$var$tangentViewFrame;
    if (builder.isFlatShading() !== true) node = $03ccd63b0299d6a7$var$directionToFaceDirection(node);
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('tangentView');
/**
 * TSL object that represents the vertex tangent in world space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$tangentWorld = /*@__PURE__*/ $03ccd63b0299d6a7$var$tangentView.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix).toVarying('v_tangentWorld').normalize().toVar('tangentWorld');
/**
 * Returns the bitangent node and assigns it to a varying if the material is not flat shaded.
 *
 * @tsl
 * @private
 * @param {Node<vec3>} crossNormalTangent - The cross product of the normal and tangent vectors.
 * @param {string} varyingName - The name of the varying to assign the bitangent to.
 * @returns {Node<vec3>} The bitangent node.
 */ const $03ccd63b0299d6a7$var$getBitangent = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([crossNormalTangent, varyingName], builder)=>{
    let bitangent = crossNormalTangent.mul($03ccd63b0299d6a7$var$tangentGeometry.w).xyz;
    if (builder.subBuildFn === 'NORMAL' && builder.isFlatShading() !== true) bitangent = bitangent.toVarying(varyingName);
    return bitangent;
}).once([
    'NORMAL'
]);
/**
 * TSL object that represents the bitangent attribute of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$bitangentGeometry = /*@__PURE__*/ $03ccd63b0299d6a7$var$getBitangent($03ccd63b0299d6a7$var$normalGeometry.cross($03ccd63b0299d6a7$var$tangentGeometry), 'v_bitangentGeometry').normalize().toVar('bitangentGeometry');
/**
 * TSL object that represents the vertex bitangent in local space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$bitangentLocal = /*@__PURE__*/ $03ccd63b0299d6a7$var$getBitangent($03ccd63b0299d6a7$var$normalLocal.cross($03ccd63b0299d6a7$var$tangentLocal), 'v_bitangentLocal').normalize().toVar('bitangentLocal');
/**
 * TSL object that represents the vertex bitangent in view space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$bitangentView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    let node;
    if (builder.subBuildFn === 'VERTEX' || builder.geometry.hasAttribute('tangent')) node = $03ccd63b0299d6a7$var$getBitangent($03ccd63b0299d6a7$var$normalView.cross($03ccd63b0299d6a7$var$tangentView), 'v_bitangentView').normalize();
    else node = $03ccd63b0299d6a7$var$bitangentViewFrame;
    if (builder.isFlatShading() !== true) node = $03ccd63b0299d6a7$var$directionToFaceDirection(node);
    return node;
}, 'vec3').once([
    'NORMAL',
    'VERTEX'
])().toVar('bitangentView');
/**
 * TSL object that represents the vertex bitangent in world space of the current rendered object.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$bitangentWorld = /*@__PURE__*/ $03ccd63b0299d6a7$var$getBitangent($03ccd63b0299d6a7$var$normalWorld.cross($03ccd63b0299d6a7$var$tangentWorld), 'v_bitangentWorld').normalize().toVar('bitangentWorld');
/**
 * TSL object that represents the TBN matrix in view space.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $03ccd63b0299d6a7$var$TBNViewMatrix = /*@__PURE__*/ $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$tangentView, $03ccd63b0299d6a7$var$bitangentView, $03ccd63b0299d6a7$var$normalView).toVar('TBNViewMatrix');
/**
 * TSL object that represents the parallax direction.
 *
 * @tsl
 * @type {Node<mat3>}
 */ const $03ccd63b0299d6a7$var$parallaxDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$positionViewDirection.mul($03ccd63b0299d6a7$var$TBNViewMatrix) /*.normalize()*/ ;
/**
 * TSL function for computing parallax uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - A uv node.
 * @param {Node<vec2>} scale - A scale node.
 * @returns {Node<vec2>} Parallax uv coordinates.
 */ const $03ccd63b0299d6a7$var$parallaxUV = (uv, scale)=>uv.sub($03ccd63b0299d6a7$var$parallaxDirection.mul(scale));
/**
 * TSL function for computing bent normals.
 *
 * @tsl
 * @function
 * @returns {Node<vec3>} Bent normals.
 */ const $03ccd63b0299d6a7$var$bentNormalView = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(()=>{
    // https://google.github.io/filament/Filament.md.html#lighting/imagebasedlights/anisotropy
    let bentNormal = $03ccd63b0299d6a7$var$anisotropyB.cross($03ccd63b0299d6a7$var$positionViewDirection);
    bentNormal = bentNormal.cross($03ccd63b0299d6a7$var$anisotropyB).normalize();
    bentNormal = $03ccd63b0299d6a7$var$mix(bentNormal, $03ccd63b0299d6a7$var$normalView, $03ccd63b0299d6a7$var$anisotropy.mul($03ccd63b0299d6a7$var$roughness.oneMinus()).oneMinus().pow2().pow2()).normalize();
    return bentNormal;
}).once()();
/**
 * Packs a direction vector into a color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - The direction to pack.
 * @return {Node<vec3>} The color.
 */ const $03ccd63b0299d6a7$var$directionToColor = (node)=>$03ccd63b0299d6a7$var$nodeObject(node).mul(0.5).add(0.5);
/**
 * Unpacks a color value into a direction vector.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - The color to unpack.
 * @return {Node<vec3>} The direction.
 */ const $03ccd63b0299d6a7$var$colorToDirection = (node)=>$03ccd63b0299d6a7$var$nodeObject(node).mul(2.0).sub(1);
/**
 * Unpacks a tangent space normal, reconstructing the Z component by projecting the X,Y coordinates onto the hemisphere.
 * The X,Y coordinates are expected to be in the [-1, 1] range.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} xy - The X,Y coordinates of the normal.
 * @return {Node<vec3>} The resulting normal.
 */ const $03ccd63b0299d6a7$var$unpackNormal = (xy)=>$03ccd63b0299d6a7$var$vec3(xy, $03ccd63b0299d6a7$var$sqrt($03ccd63b0299d6a7$var$saturate($03ccd63b0299d6a7$var$float(1.0).sub($03ccd63b0299d6a7$var$dot(xy, xy)))));
/**
 * This class can be used for applying normals maps to materials.
 *
 * ```js
 * material.normalNode = normalMap( texture( normalTex ) );
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$3561fb9303e3f13f extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'NormalMapNode';
    }
    /**
	 * Constructs a new normal map node.
	 *
	 * @param {Node<vec3>} node - Represents the normal map data.
	 * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
	 */ constructor(node, scaleNode = null){
        super('vec3');
        /**
		 * Represents the normal map data.
		 *
		 * @type {Node<vec3>}
		 */ this.node = node;
        /**
		 * Controls the intensity of the effect.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.scaleNode = scaleNode;
        /**
		 * The normal map type.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = (0, $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8);
        /**
		 * Controls how to unpack the sampled normal map values.
		 *
		 * @type {string}
		 * @default NoNormalPacking
		 */ this.unpackNormalMode = (0, $9ddd7e9b53f7a2d4$export$7f96a53e6ab01dca);
    }
    setup(builder) {
        const { normalMapType: normalMapType, scaleNode: scaleNode, unpackNormalMode: unpackNormalMode } = this;
        let normalMap = this.node.mul(2.0).sub(1.0);
        if (normalMapType === (0, $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8)) {
            if (unpackNormalMode === (0, $9ddd7e9b53f7a2d4$export$bbd2d5168fed5fd6)) normalMap = $03ccd63b0299d6a7$var$unpackNormal(normalMap.xy);
            else if (unpackNormalMode === (0, $9ddd7e9b53f7a2d4$export$4f8d192b60f65626)) normalMap = $03ccd63b0299d6a7$var$unpackNormal(normalMap.yw);
            else if (unpackNormalMode !== (0, $9ddd7e9b53f7a2d4$export$7f96a53e6ab01dca)) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`THREE.NodeMaterial: Unexpected unpack normal mode: ${unpackNormalMode}`);
        } else if (unpackNormalMode !== (0, $9ddd7e9b53f7a2d4$export$7f96a53e6ab01dca)) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`THREE.NodeMaterial: Normal map type '${normalMapType}' is not compatible with unpack normal mode '${unpackNormalMode}'`);
        if (scaleNode !== null) {
            let scale = scaleNode;
            if (builder.isFlatShading() === true) scale = $03ccd63b0299d6a7$var$directionToFaceDirection(scale);
            normalMap = $03ccd63b0299d6a7$var$vec3(normalMap.xy.mul(scale), normalMap.z);
        }
        let output = null;
        if (normalMapType === (0, $9ddd7e9b53f7a2d4$export$9990ad26f9db5b2c)) output = $03ccd63b0299d6a7$var$transformNormalToView(normalMap);
        else if (normalMapType === (0, $9ddd7e9b53f7a2d4$export$2852a58ebdac27b8)) output = $03ccd63b0299d6a7$var$TBNViewMatrix.mul(normalMap).normalize();
        else {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`NodeMaterial: Unsupported normal map type: ${normalMapType}`);
            output = $03ccd63b0299d6a7$var$normalView; // Fallback to default normal view
        }
        return output;
    }
}
/**
 * TSL function for creating a normal map node.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} node - Represents the normal map data.
 * @param {?Node<vec2>} [scaleNode=null] - Controls the intensity of the effect.
 * @returns {NormalMapNode}
 */ const $03ccd63b0299d6a7$var$normalMap = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$3561fb9303e3f13f).setParameterLength(1, 2);
// Bump Mapping Unparametrized Surfaces on the GPU by Morten S. Mikkelsen
// https://mmikk.github.io/papers3d/mm_sfgrad_bump.pdf
const $03ccd63b0299d6a7$var$dHdxy_fwd = $03ccd63b0299d6a7$var$Fn(({ textureNode: textureNode, bumpScale: bumpScale })=>{
    // It's used to preserve the same TextureNode instance
    const sampleTexture = (callback)=>textureNode.isolate().context({
            getUV: (texNode)=>callback(texNode.uvNode || $03ccd63b0299d6a7$var$uv$1()),
            forceUVContext: true
        });
    const Hll = $03ccd63b0299d6a7$var$float(sampleTexture((uvNode)=>uvNode));
    return $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$float(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdx()))).sub(Hll), $03ccd63b0299d6a7$var$float(sampleTexture((uvNode)=>uvNode.add(uvNode.dFdy()))).sub(Hll)).mul(bumpScale);
});
// Evaluate the derivative of the height w.r.t. screen-space using forward differencing (listing 2)
const $03ccd63b0299d6a7$var$perturbNormalArb = $03ccd63b0299d6a7$var$Fn((inputs)=>{
    const { surf_pos: surf_pos, surf_norm: surf_norm, dHdxy: dHdxy } = inputs;
    // normalize is done to ensure that the bump map looks the same regardless of the texture's scale
    const vSigmaX = surf_pos.dFdx().normalize();
    const vSigmaY = surf_pos.dFdy().normalize();
    const vN = surf_norm; // normalized
    const R1 = vSigmaY.cross(vN);
    const R2 = vN.cross(vSigmaX);
    const fDet = vSigmaX.dot(R1).mul($03ccd63b0299d6a7$var$faceDirection);
    const vGrad = fDet.sign().mul(dHdxy.x.mul(R1).add(dHdxy.y.mul(R2)));
    return fDet.abs().mul(surf_norm).sub(vGrad).normalize();
});
/**
 * This class can be used for applying bump maps to materials.
 *
 * ```js
 * material.normalNode = bumpMap( texture( bumpTex ) );
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$e4fc1565ab09c32f extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'BumpMapNode';
    }
    /**
	 * Constructs a new bump map node.
	 *
	 * @param {Node<float>} textureNode - Represents the bump map data.
	 * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
	 */ constructor(textureNode, scaleNode = null){
        super('vec3');
        /**
		 * Represents the bump map data.
		 *
		 * @type {Node<float>}
		 */ this.textureNode = textureNode;
        /**
		 * Controls the intensity of the bump effect.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.scaleNode = scaleNode;
    }
    setup() {
        const bumpScale = this.scaleNode !== null ? this.scaleNode : 1;
        const dHdxy = $03ccd63b0299d6a7$var$dHdxy_fwd({
            textureNode: this.textureNode,
            bumpScale: bumpScale
        });
        return $03ccd63b0299d6a7$var$perturbNormalArb({
            surf_pos: $03ccd63b0299d6a7$var$positionView,
            surf_norm: $03ccd63b0299d6a7$var$normalView,
            dHdxy: dHdxy
        });
    }
}
/**
 * TSL function for creating a bump map node.
 *
 * @tsl
 * @function
 * @param {Node<float>} textureNode - Represents the bump map data.
 * @param {?Node<float>} [scaleNode=null] - Controls the intensity of the bump effect.
 * @returns {BumpMapNode}
 */ const $03ccd63b0299d6a7$var$bumpMap = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$e4fc1565ab09c32f).setParameterLength(1, 2);
const $03ccd63b0299d6a7$var$_propertyCache = new Map();
/**
 * This class should simplify the node access to material properties.
 * It internal uses reference nodes to make sure  changes to material
 * properties are automatically reflected to predefined TSL objects
 * like e.g. `materialColor`.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$555471af30279064 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'MaterialNode';
    }
    /**
	 * Constructs a new material node.
	 *
	 * @param {string} scope - The scope defines what kind of material property is referred by the node.
	 */ constructor(scope){
        super();
        /**
		 * The scope defines what material property is referred by the node.
		 *
		 * @type {string}
		 */ this.scope = scope;
    }
    /**
	 * Returns a cached reference node for the given property and type.
	 *
	 * @param {string} property - The name of the material property.
	 * @param {string} type - The uniform type of the property.
	 * @return {MaterialReferenceNode} A material reference node representing the property access.
	 */ getCache(property, type) {
        let node = $03ccd63b0299d6a7$var$_propertyCache.get(property);
        if (node === undefined) {
            node = $03ccd63b0299d6a7$var$materialReference(property, type);
            $03ccd63b0299d6a7$var$_propertyCache.set(property, node);
        }
        return node;
    }
    /**
	 * Returns a float-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode<float>} A material reference node representing the property access.
	 */ getFloat(property) {
        return this.getCache(property, 'float');
    }
    /**
	 * Returns a color-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode<color>} A material reference node representing the property access.
	 */ getColor(property) {
        return this.getCache(property, 'color');
    }
    /**
	 * Returns a texture-typed material reference node for the given property name.
	 *
	 * @param {string} property - The name of the material property.
	 * @return {MaterialReferenceNode} A material reference node representing the property access.
	 */ getTexture(property) {
        return this.getCache(property === 'map' ? 'map' : property + 'Map', 'texture');
    }
    /**
	 * The node setup is done depending on the selected scope. Multiple material properties
	 * might be grouped into a single node composition if they logically belong together.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The node representing the selected scope.
	 */ setup(builder) {
        const material = builder.context.material;
        const scope = this.scope;
        let node = null;
        if (scope === $03ccd63b0299d6a7$export$555471af30279064.COLOR) {
            const colorNode = material.color !== undefined ? this.getColor(scope) : $03ccd63b0299d6a7$var$vec3();
            if (material.map && material.map.isTexture === true) node = colorNode.mul(this.getTexture('map'));
            else node = colorNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.OPACITY) {
            const opacityNode = this.getFloat(scope);
            if (material.alphaMap && material.alphaMap.isTexture === true) node = opacityNode.mul(this.getTexture('alpha'));
            else node = opacityNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_STRENGTH) {
            if (material.specularMap && material.specularMap.isTexture === true) node = this.getTexture('specular').r;
            else node = $03ccd63b0299d6a7$var$float(1);
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_INTENSITY) {
            const specularIntensityNode = this.getFloat(scope);
            if (material.specularIntensityMap && material.specularIntensityMap.isTexture === true) node = specularIntensityNode.mul(this.getTexture(scope).a);
            else node = specularIntensityNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_COLOR) {
            const specularColorNode = this.getColor(scope);
            if (material.specularColorMap && material.specularColorMap.isTexture === true) node = specularColorNode.mul(this.getTexture(scope).rgb);
            else node = specularColorNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.ROUGHNESS) {
            const roughnessNode = this.getFloat(scope);
            if (material.roughnessMap && material.roughnessMap.isTexture === true) node = roughnessNode.mul(this.getTexture(scope).g);
            else node = roughnessNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.METALNESS) {
            const metalnessNode = this.getFloat(scope);
            if (material.metalnessMap && material.metalnessMap.isTexture === true) node = metalnessNode.mul(this.getTexture(scope).b);
            else node = metalnessNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.EMISSIVE) {
            const emissiveIntensityNode = this.getFloat('emissiveIntensity');
            const emissiveNode = this.getColor(scope).mul(emissiveIntensityNode);
            if (material.emissiveMap && material.emissiveMap.isTexture === true) node = emissiveNode.mul(this.getTexture(scope));
            else node = emissiveNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.NORMAL) {
            if (material.normalMap) {
                node = $03ccd63b0299d6a7$var$normalMap(this.getTexture('normal'), this.getCache('normalScale', 'vec2'));
                node.normalMapType = material.normalMapType;
                if (material.normalMap.format == (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0) || material.normalMap.format == (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f) || material.normalMap.format == (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf)) node.unpackNormalMode = (0, $9ddd7e9b53f7a2d4$export$bbd2d5168fed5fd6);
            } else if (material.bumpMap) node = $03ccd63b0299d6a7$var$bumpMap(this.getTexture('bump').r, this.getFloat('bumpScale'));
            else node = $03ccd63b0299d6a7$var$normalView;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT) {
            const clearcoatNode = this.getFloat(scope);
            if (material.clearcoatMap && material.clearcoatMap.isTexture === true) node = clearcoatNode.mul(this.getTexture(scope).r);
            else node = clearcoatNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_ROUGHNESS) {
            const clearcoatRoughnessNode = this.getFloat(scope);
            if (material.clearcoatRoughnessMap && material.clearcoatRoughnessMap.isTexture === true) node = clearcoatRoughnessNode.mul(this.getTexture(scope).r);
            else node = clearcoatRoughnessNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_NORMAL) {
            if (material.clearcoatNormalMap) node = $03ccd63b0299d6a7$var$normalMap(this.getTexture(scope), this.getCache(scope + 'Scale', 'vec2'));
            else node = $03ccd63b0299d6a7$var$normalView;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.SHEEN) {
            const sheenNode = this.getColor('sheenColor').mul(this.getFloat('sheen')); // Move this mul() to CPU
            if (material.sheenColorMap && material.sheenColorMap.isTexture === true) node = sheenNode.mul(this.getTexture('sheenColor').rgb);
            else node = sheenNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.SHEEN_ROUGHNESS) {
            const sheenRoughnessNode = this.getFloat(scope);
            if (material.sheenRoughnessMap && material.sheenRoughnessMap.isTexture === true) node = sheenRoughnessNode.mul(this.getTexture(scope).a);
            else node = sheenRoughnessNode;
            node = node.clamp(0.0001, 1.0);
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.ANISOTROPY) {
            if (material.anisotropyMap && material.anisotropyMap.isTexture === true) {
                const anisotropyPolar = this.getTexture(scope);
                const anisotropyMat = $03ccd63b0299d6a7$var$mat2($03ccd63b0299d6a7$var$materialAnisotropyVector.x, $03ccd63b0299d6a7$var$materialAnisotropyVector.y, $03ccd63b0299d6a7$var$materialAnisotropyVector.y.negate(), $03ccd63b0299d6a7$var$materialAnisotropyVector.x);
                node = anisotropyMat.mul(anisotropyPolar.rg.mul(2.0).sub($03ccd63b0299d6a7$var$vec2(1.0)).normalize().mul(anisotropyPolar.b));
            } else node = $03ccd63b0299d6a7$var$materialAnisotropyVector;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE_THICKNESS) {
            const iridescenceThicknessMaximum = $03ccd63b0299d6a7$var$reference('1', 'float', material.iridescenceThicknessRange);
            if (material.iridescenceThicknessMap) {
                const iridescenceThicknessMinimum = $03ccd63b0299d6a7$var$reference('0', 'float', material.iridescenceThicknessRange);
                node = iridescenceThicknessMaximum.sub(iridescenceThicknessMinimum).mul(this.getTexture(scope).g).add(iridescenceThicknessMinimum);
            } else node = iridescenceThicknessMaximum;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.TRANSMISSION) {
            const transmissionNode = this.getFloat(scope);
            if (material.transmissionMap) node = transmissionNode.mul(this.getTexture(scope).r);
            else node = transmissionNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.THICKNESS) {
            const thicknessNode = this.getFloat(scope);
            if (material.thicknessMap) node = thicknessNode.mul(this.getTexture(scope).g);
            else node = thicknessNode;
        } else if (scope === $03ccd63b0299d6a7$export$555471af30279064.IOR) node = this.getFloat(scope);
        else if (scope === $03ccd63b0299d6a7$export$555471af30279064.LIGHT_MAP) node = this.getTexture(scope).rgb.mul(this.getFloat('lightMapIntensity'));
        else if (scope === $03ccd63b0299d6a7$export$555471af30279064.AO) node = this.getTexture(scope).r.sub(1.0).mul(this.getFloat('aoMapIntensity')).add(1.0);
        else if (scope === $03ccd63b0299d6a7$export$555471af30279064.LINE_DASH_OFFSET) node = material.dashOffset ? this.getFloat(scope) : $03ccd63b0299d6a7$var$float(0);
        else {
            const outputType = this.getNodeType(builder);
            node = this.getCache(scope, outputType);
        }
        return node;
    }
}
$03ccd63b0299d6a7$export$555471af30279064.ALPHA_TEST = 'alphaTest';
$03ccd63b0299d6a7$export$555471af30279064.COLOR = 'color';
$03ccd63b0299d6a7$export$555471af30279064.OPACITY = 'opacity';
$03ccd63b0299d6a7$export$555471af30279064.SHININESS = 'shininess';
$03ccd63b0299d6a7$export$555471af30279064.SPECULAR = 'specular';
$03ccd63b0299d6a7$export$555471af30279064.SPECULAR_STRENGTH = 'specularStrength';
$03ccd63b0299d6a7$export$555471af30279064.SPECULAR_INTENSITY = 'specularIntensity';
$03ccd63b0299d6a7$export$555471af30279064.SPECULAR_COLOR = 'specularColor';
$03ccd63b0299d6a7$export$555471af30279064.REFLECTIVITY = 'reflectivity';
$03ccd63b0299d6a7$export$555471af30279064.ROUGHNESS = 'roughness';
$03ccd63b0299d6a7$export$555471af30279064.METALNESS = 'metalness';
$03ccd63b0299d6a7$export$555471af30279064.NORMAL = 'normal';
$03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT = 'clearcoat';
$03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_ROUGHNESS = 'clearcoatRoughness';
$03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_NORMAL = 'clearcoatNormal';
$03ccd63b0299d6a7$export$555471af30279064.EMISSIVE = 'emissive';
$03ccd63b0299d6a7$export$555471af30279064.ROTATION = 'rotation';
$03ccd63b0299d6a7$export$555471af30279064.SHEEN = 'sheen';
$03ccd63b0299d6a7$export$555471af30279064.SHEEN_ROUGHNESS = 'sheenRoughness';
$03ccd63b0299d6a7$export$555471af30279064.ANISOTROPY = 'anisotropy';
$03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE = 'iridescence';
$03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE_IOR = 'iridescenceIOR';
$03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE_THICKNESS = 'iridescenceThickness';
$03ccd63b0299d6a7$export$555471af30279064.IOR = 'ior';
$03ccd63b0299d6a7$export$555471af30279064.TRANSMISSION = 'transmission';
$03ccd63b0299d6a7$export$555471af30279064.THICKNESS = 'thickness';
$03ccd63b0299d6a7$export$555471af30279064.ATTENUATION_DISTANCE = 'attenuationDistance';
$03ccd63b0299d6a7$export$555471af30279064.ATTENUATION_COLOR = 'attenuationColor';
$03ccd63b0299d6a7$export$555471af30279064.LINE_SCALE = 'scale';
$03ccd63b0299d6a7$export$555471af30279064.LINE_DASH_SIZE = 'dashSize';
$03ccd63b0299d6a7$export$555471af30279064.LINE_GAP_SIZE = 'gapSize';
$03ccd63b0299d6a7$export$555471af30279064.LINE_WIDTH = 'linewidth';
$03ccd63b0299d6a7$export$555471af30279064.LINE_DASH_OFFSET = 'dashOffset';
$03ccd63b0299d6a7$export$555471af30279064.POINT_SIZE = 'size';
$03ccd63b0299d6a7$export$555471af30279064.DISPERSION = 'dispersion';
$03ccd63b0299d6a7$export$555471af30279064.LIGHT_MAP = 'light';
$03ccd63b0299d6a7$export$555471af30279064.AO = 'ao';
/**
 * TSL object that represents alpha test of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialAlphaTest = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ALPHA_TEST);
/**
 * TSL object that represents the diffuse color of the current material.
 * The value is composed via `color` * `map`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.COLOR);
/**
 * TSL object that represents the shininess of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialShininess = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SHININESS);
/**
 * TSL object that represents the emissive color of the current material.
 * The value is composed via `emissive` * `emissiveIntensity` * `emissiveMap`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialEmissive = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.EMISSIVE);
/**
 * TSL object that represents the opacity of the current material.
 * The value is composed via `opacity` * `alphaMap`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialOpacity = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.OPACITY);
/**
 * TSL object that represents the specular of the current material.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialSpecular = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SPECULAR);
/**
 * TSL object that represents the specular intensity of the current material.
 * The value is composed via `specularIntensity` * `specularMap.a`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialSpecularIntensity = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_INTENSITY);
/**
 * TSL object that represents the specular color of the current material.
 * The value is composed via `specularColor` * `specularMap.rgb`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialSpecularColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_COLOR);
/**
 * TSL object that represents the specular strength of the current material.
 * The value is composed via `specularMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialSpecularStrength = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SPECULAR_STRENGTH);
/**
 * TSL object that represents the reflectivity of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialReflectivity = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.REFLECTIVITY);
/**
 * TSL object that represents the roughness of the current material.
 * The value is composed via `roughness` * `roughnessMap.g`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ROUGHNESS);
/**
 * TSL object that represents the metalness of the current material.
 * The value is composed via `metalness` * `metalnessMap.b`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialMetalness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.METALNESS);
/**
 * TSL object that represents the normal of the current material.
 * The value will be either `normalMap` * `normalScale`, `bumpMap` * `bumpScale` or `normalView`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialNormal = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.NORMAL);
/**
 * TSL object that represents the clearcoat of the current material.
 * The value is composed via `clearcoat` * `clearcoatMap.r`
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialClearcoat = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT);
/**
 * TSL object that represents the clearcoat roughness of the current material.
 * The value is composed via `clearcoatRoughness` * `clearcoatRoughnessMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialClearcoatRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_ROUGHNESS);
/**
 * TSL object that represents the clearcoat normal of the current material.
 * The value will be either `clearcoatNormalMap` or `normalView`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialClearcoatNormal = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.CLEARCOAT_NORMAL);
/**
 * TSL object that represents the rotation of the current sprite material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialRotation = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ROTATION);
/**
 * TSL object that represents the sheen color of the current material.
 * The value is composed via `sheen` * `sheenColor` * `sheenColorMap`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialSheen = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SHEEN);
/**
 * TSL object that represents the sheen roughness of the current material.
 * The value is composed via `sheenRoughness` * `sheenRoughnessMap.a`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialSheenRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.SHEEN_ROUGHNESS);
/**
 * TSL object that represents the anisotropy of the current material.
 *
 * @tsl
 * @type {Node<vec2>}
 */ const $03ccd63b0299d6a7$var$materialAnisotropy = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ANISOTROPY);
/**
 * TSL object that represents the iridescence of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialIridescence = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE);
/**
 * TSL object that represents the iridescence IOR of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialIridescenceIOR = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE_IOR);
/**
 * TSL object that represents the iridescence thickness of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialIridescenceThickness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.IRIDESCENCE_THICKNESS);
/**
 * TSL object that represents the transmission of the current material.
 * The value is composed via `transmission` * `transmissionMap.r`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialTransmission = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.TRANSMISSION);
/**
 * TSL object that represents the thickness of the current material.
 * The value is composed via `thickness` * `thicknessMap.g`.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialThickness = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.THICKNESS);
/**
 * TSL object that represents the IOR of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialIOR = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.IOR);
/**
 * TSL object that represents the attenuation distance of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialAttenuationDistance = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ATTENUATION_DISTANCE);
/**
 * TSL object that represents the attenuation color of the current material.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialAttenuationColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.ATTENUATION_COLOR);
/**
 * TSL object that represents the scale of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialLineScale = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LINE_SCALE);
/**
 * TSL object that represents the dash size of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialLineDashSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LINE_DASH_SIZE);
/**
 * TSL object that represents the gap size of the current dashed line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialLineGapSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LINE_GAP_SIZE);
/**
 * TSL object that represents the line width of the current line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialLineWidth = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LINE_WIDTH);
/**
 * TSL object that represents the dash offset of the current line material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialLineDashOffset = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LINE_DASH_OFFSET);
/**
 * TSL object that represents the point size of the current points material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialPointSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.POINT_SIZE);
/**
 * TSL object that represents the dispersion of the current material.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialDispersion = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.DISPERSION);
/**
 * TSL object that represents the light map of the current material.
 * The value is composed via `lightMapIntensity` * `lightMap.rgb`.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$materialLightMap = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.LIGHT_MAP);
/**
 * TSL object that represents the ambient occlusion map of the current material.
 * The value is composed via `aoMap.r` - 1 * `aoMapIntensity` + 1.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$materialAO = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$555471af30279064, $03ccd63b0299d6a7$export$555471af30279064.AO);
/**
 * TSL object that represents the anisotropy vector of the current material.
 *
 * @tsl
 * @type {Node<vec2>}
 */ const $03ccd63b0299d6a7$var$materialAnisotropyVector = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()).onReference(function(frame) {
    return frame.material;
}).onRenderUpdate(function({ material: material }) {
    this.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
});
/**
 * TSL object that represents the position in clip space after the model-view-projection transform of the current rendered object.
 *
 * @tsl
 * @type {VaryingNode<vec4>}
 */ const $03ccd63b0299d6a7$var$modelViewProjection = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    return builder.context.setupModelViewProjection();
}, 'vec4').once()().toVarying('v_modelViewProjection');
/**
 * This class enables element access on instances of {@link StorageBufferNode}.
 * In most cases, it is indirectly used when accessing elements with the
 * {@link StorageBufferNode#element} method.
 *
 * ```js
 * const position = positionStorage.element( instanceIndex );
 * ```
 *
 * @augments ArrayElementNode
 */ class $03ccd63b0299d6a7$export$24f341c51db48ae0 extends $03ccd63b0299d6a7$export$f2edd1d22bf6d00b {
    static get type() {
        return 'StorageArrayElementNode';
    }
    /**
	 * Constructs storage buffer element node.
	 *
	 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(storageBufferNode, indexNode){
        super(storageBufferNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageArrayElementNode = true;
    }
    /**
	 * The storage buffer node.
	 *
	 * @param {Node} value
	 * @type {StorageBufferNode}
	 */ set storageBufferNode(value) {
        this.node = value;
    }
    get storageBufferNode() {
        return this.node;
    }
    getMemberType(builder, name) {
        const structTypeNode = this.storageBufferNode.structTypeNode;
        if (structTypeNode) return structTypeNode.getMemberType(builder, name);
        return 'void';
    }
    setup(builder) {
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.isPBO === true) builder.setupPBO(this.node);
        }
        return super.setup(builder);
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        //
        if (builder.isAvailable('storageBuffer') === false) {
            if (this.node.isPBO === true && isAssignContext !== true && (this.node.value.isInstancedBufferAttribute || builder.shaderStage !== 'compute')) snippet = builder.generatePBO(this);
            else snippet = this.node.build(builder);
        } else snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        return snippet;
    }
}
/**
 * TSL function for creating a storage element node.
 *
 * @tsl
 * @function
 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
 * @param {Node} indexNode - The index node that defines the element access.
 * @returns {StorageArrayElementNode}
 */ const $03ccd63b0299d6a7$var$storageElement = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$24f341c51db48ae0).setParameterLength(2);
/**
 * This node is used in context of compute shaders and allows to define a
 * storage buffer for data. A typical workflow is to create instances of
 * this node with the convenience functions `attributeArray()` or `instancedArray()`,
 * setup up a compute shader that writes into the buffers and then convert
 * the storage buffers to attribute nodes for rendering.
 *
 * ```js
 * const positionBuffer = instancedArray( particleCount, 'vec3' ); // the storage buffer node
 *
 * const computeInit = Fn( () => { // the compute shader
 *
 * 	const position = positionBuffer.element( instanceIndex );
 *
 * 	// compute position data
 *
 * 	position.x = 1;
 * 	position.y = 1;
 * 	position.z = 1;
 *
 * } )().compute( particleCount );
 *
 * const particleMaterial = new THREE.SpriteNodeMaterial();
 * particleMaterial.positionNode = positionBuffer.toAttribute();
 *
 * renderer.computeAsync( computeInit );
 *
 * ```
 *
 * @augments BufferNode
 */ class $03ccd63b0299d6a7$export$d52c9b844d447cca extends $03ccd63b0299d6a7$export$715e91fa835e6409 {
    static get type() {
        return 'StorageBufferNode';
    }
    /**
	 * Constructs a new storage buffer node.
	 *
	 * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
	 * @param {?(string|Struct)} [bufferType=null] - The buffer type (e.g. `'vec3'`).
	 * @param {number} [bufferCount=0] - The buffer count.
	 */ constructor(value, bufferType = null, bufferCount = 0){
        let nodeType, structTypeNode = null;
        if (bufferType && bufferType.isStruct) {
            nodeType = 'struct';
            structTypeNode = bufferType.layout;
            if (value.isStorageBufferAttribute || value.isStorageInstancedBufferAttribute) bufferCount = value.count;
        } else if (bufferType === null && (value.isStorageBufferAttribute || value.isStorageInstancedBufferAttribute)) {
            nodeType = $03ccd63b0299d6a7$var$getTypeFromLength(value.itemSize);
            bufferCount = value.count;
        } else nodeType = bufferType;
        super(value, nodeType, bufferCount);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBufferNode = true;
        /**
		 * The buffer struct type.
		 *
		 * @type {?StructTypeNode}
		 * @default null
		 */ this.structTypeNode = structTypeNode;
        /**
		 * The access type of the texture node.
		 *
		 * @type {string}
		 * @default 'readWrite'
		 */ this.access = $03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE;
        /**
		 * Whether the node is atomic or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isAtomic = false;
        /**
		 * Whether the node represents a PBO or not.
		 * Only relevant for WebGL.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isPBO = false;
        /**
		 * A reference to the internal buffer attribute node.
		 *
		 * @private
		 * @type {?BufferAttributeNode}
		 * @default null
		 */ this._attribute = null;
        /**
		 * A reference to the internal varying node.
		 *
		 * @private
		 * @type {?VaryingNode}
		 * @default null
		 */ this._varying = null;
        /**
		 * `StorageBufferNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        if (value.isStorageBufferAttribute !== true && value.isStorageInstancedBufferAttribute !== true) {
            // TODO: Improve it, possibly adding a new property to the BufferAttribute to identify it as a storage buffer read-only attribute in Renderer
            if (value.isInstancedBufferAttribute) value.isStorageInstancedBufferAttribute = true;
            else value.isStorageBufferAttribute = true;
        }
    }
    /**
	 * This method is overwritten since the buffer data might be shared
	 * and thus the hash should be shared as well.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        let id;
        if (this.bufferCount === 0) {
            let bufferData = builder.globalCache.getData(this.value);
            if (bufferData === undefined) {
                bufferData = {
                    node: this
                };
                builder.globalCache.setData(this.value, bufferData);
            }
            id = bufferData.node.id;
        } else id = this.id;
        return String(id);
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'indirectStorageBuffer'` or `'storageBuffer'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return this.value.isIndirectStorageBufferAttribute ? 'indirectStorageBuffer' : 'storageBuffer';
    }
    /**
	 * Enables element access with the given index node.
	 *
	 * @param {IndexNode} indexNode - The index node.
	 * @return {StorageArrayElementNode} A node representing the element access.
	 */ element(indexNode) {
        return $03ccd63b0299d6a7$var$storageElement(this, indexNode);
    }
    /**
	 * Defines whether this node is a PBO or not. Only relevant for WebGL.
	 *
	 * @param {boolean} value - The value so set.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setPBO(value) {
        this.isPBO = value;
        return this;
    }
    /**
	 * Returns the `isPBO` value.
	 *
	 * @return {boolean} Whether the node represents a PBO or not.
	 */ getPBO() {
        return this.isPBO;
    }
    /**
	 * Defines the node access.
	 *
	 * @param {string} value - The node access.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setAccess(value) {
        this.access = value;
        return this;
    }
    /**
	 * Convenience method for configuring a read-only node access.
	 *
	 * @return {StorageBufferNode} A reference to this node.
	 */ toReadOnly() {
        return this.setAccess($03ccd63b0299d6a7$export$92538c74c63a703d.READ_ONLY);
    }
    /**
	 * Defines whether the node is atomic or not.
	 *
	 * @param {boolean} value - The atomic flag.
	 * @return {StorageBufferNode} A reference to this node.
	 */ setAtomic(value) {
        this.isAtomic = value;
        return this;
    }
    /**
	 * Convenience method for making this node atomic.
	 *
	 * @return {StorageBufferNode} A reference to this node.
	 */ toAtomic() {
        return this.setAtomic(true);
    }
    /**
	 * Returns attribute data for this storage buffer node.
	 *
	 * @return {{attribute: BufferAttributeNode, varying: VaryingNode}} The attribute data.
	 */ getAttributeData() {
        if (this._attribute === null) {
            this._attribute = $03ccd63b0299d6a7$var$bufferAttribute(this.value);
            this._varying = $03ccd63b0299d6a7$var$varying(this._attribute);
        }
        return {
            attribute: this._attribute,
            varying: this._varying
        };
    }
    /**
	 * This method is overwritten since the node type from the availability of storage buffers
	 * and the attribute data.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        if (this.structTypeNode !== null) return this.structTypeNode.getNodeType(builder);
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.generateNodeType(builder);
        const { attribute: attribute } = this.getAttributeData();
        return attribute.getNodeType(builder);
    }
    /**
	 * Returns the type of a member of the struct.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the member.
	 */ getMemberType(builder, name) {
        if (this.structTypeNode !== null) return this.structTypeNode.getMemberType(builder, name);
        return 'void';
    }
    /**
	 * Generates the code snippet of the storage buffer node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The generated code snippet.
	 */ generate(builder) {
        if (this.structTypeNode !== null) this.structTypeNode.build(builder);
        if (builder.isAvailable('storageBuffer') || builder.isAvailable('indirectStorageBuffer')) return super.generate(builder);
        const { attribute: attribute, varying: varying } = this.getAttributeData();
        const output = varying.build(builder);
        builder.registerTransform(output, attribute);
        return output;
    }
}
/**
 * TSL function for creating a storage buffer node.
 *
 * @tsl
 * @function
 * @param {StorageBufferAttribute|StorageInstancedBufferAttribute|BufferAttribute} value - The buffer data.
 * @param {?(string|Struct)} [type=null] - The buffer type (e.g. `'vec3'`).
 * @param {number} [count=0] - The buffer count.
 * @returns {StorageBufferNode}
 */ const $03ccd63b0299d6a7$var$storage = (value, type = null, count = 0)=>new $03ccd63b0299d6a7$export$d52c9b844d447cca(value, type, count);
/**
 * This node implements the vertex shader logic which is required
 * when rendering 3D objects via instancing. The code makes sure
 * vertex positions, normals and colors can be modified via instanced
 * data.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$fe90e00cec29e881 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'InstanceNode';
    }
    /**
	 * Constructs a new instance node.
	 *
	 * @param {number} count - The number of instances.
	 * @param {InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
	 * @param {?InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
	 */ constructor(count, instanceMatrix, instanceColor = null){
        super('void');
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Instanced buffer attribute representing the transformation of instances.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = instanceMatrix;
        /**
		 * Instanced buffer attribute representing the color of instances.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceColor = instanceColor;
        /**
		 * The node that represents the instance matrix data.
		 *
		 * @type {?Node}
		 */ this.instanceMatrixNode = null;
        /**
		 * The node that represents the instance color data.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.instanceColorNode = null;
        /**
		 * The update type is set to `frame` since an update
		 * of instanced buffer data must be checked per frame.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        /**
		 * A reference to a buffer that is used by `instanceMatrixNode`.
		 *
		 * @type {?InstancedInterleavedBuffer}
		 */ this.buffer = null;
        /**
		 * A reference to a buffer that is used by `instanceColorNode`.
		 *
		 * @type {?InstancedBufferAttribute}
		 */ this.bufferColor = null;
        /**
		 * The previous instance matrices. Required for computing motion vectors.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.previousInstanceMatrixNode = null;
    }
    /**
	 * Tracks whether the matrix data is provided via a storage buffer.
	 *
	 * @type {boolean}
	 */ get isStorageMatrix() {
        const { instanceMatrix: instanceMatrix } = this;
        return instanceMatrix && instanceMatrix.isStorageInstancedBufferAttribute === true;
    }
    /**
	 * Tracks whether the color data is provided via a storage buffer.
	 *
	 * @type {boolean}
	 */ get isStorageColor() {
        const { instanceColor: instanceColor } = this;
        return instanceColor && instanceColor.isStorageInstancedBufferAttribute === true;
    }
    /**
	 * Setups the internal buffers and nodes and assigns the transformed vertex data
	 * to predefined node variables for accumulation. That follows the same patterns
	 * like with morph and skinning nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        let { instanceMatrixNode: instanceMatrixNode, instanceColorNode: instanceColorNode } = this;
        // instance matrix
        if (instanceMatrixNode === null) {
            instanceMatrixNode = this._createInstanceMatrixNode(true, builder);
            this.instanceMatrixNode = instanceMatrixNode;
        }
        // instance color
        const { instanceColor: instanceColor, isStorageColor: isStorageColor } = this;
        if (instanceColor && instanceColorNode === null) {
            if (isStorageColor) instanceColorNode = $03ccd63b0299d6a7$var$storage(instanceColor, 'vec3', Math.max(instanceColor.count, 1)).element($03ccd63b0299d6a7$var$instanceIndex);
            else {
                const bufferAttribute = new (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a)(instanceColor.array, 3);
                const bufferFn = instanceColor.usage === (0, $9ddd7e9b53f7a2d4$export$8505d14ac8546ca) ? $03ccd63b0299d6a7$var$instancedDynamicBufferAttribute : $03ccd63b0299d6a7$var$instancedBufferAttribute;
                this.bufferColor = bufferAttribute;
                instanceColorNode = $03ccd63b0299d6a7$var$vec3(bufferFn(bufferAttribute, 'vec3', 3, 0));
            }
            this.instanceColorNode = instanceColorNode;
        }
        // POSITION
        const instancePosition = instanceMatrixNode.mul($03ccd63b0299d6a7$var$positionLocal).xyz;
        $03ccd63b0299d6a7$var$positionLocal.assign(instancePosition);
        if (builder.needsPreviousData()) $03ccd63b0299d6a7$var$positionPrevious.assign(this.getPreviousInstancedPosition(builder));
        // NORMAL
        if (builder.hasGeometryAttribute('normal')) {
            const instanceNormal = $03ccd63b0299d6a7$var$transformNormal($03ccd63b0299d6a7$var$normalLocal, instanceMatrixNode);
            // ASSIGNS
            $03ccd63b0299d6a7$var$normalLocal.assign(instanceNormal);
        }
        // COLOR
        if (this.instanceColorNode !== null) $03ccd63b0299d6a7$var$varyingProperty('vec3', 'vInstanceColor').assign(this.instanceColorNode);
    }
    /**
	 * Checks if the internal buffers require an update.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        if (this.buffer !== null && this.isStorageMatrix !== true) {
            this.buffer.clearUpdateRanges();
            this.buffer.updateRanges.push(...this.instanceMatrix.updateRanges);
            // update version if necessary
            if (this.instanceMatrix.version !== this.buffer.version) this.buffer.version = this.instanceMatrix.version;
        }
        if (this.instanceColor && this.bufferColor !== null && this.isStorageColor !== true) {
            this.bufferColor.clearUpdateRanges();
            this.bufferColor.updateRanges.push(...this.instanceColor.updateRanges);
            if (this.instanceColor.version !== this.bufferColor.version) this.bufferColor.version = this.instanceColor.version;
        }
        if (this.previousInstanceMatrixNode !== null) frame.object.previousInstanceMatrix.array.set(this.instanceMatrix.array);
    }
    /**
	 * Computes the transformed/instanced vertex position of the previous frame.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The instanced position from the previous frame.
	 */ getPreviousInstancedPosition(builder) {
        const instancedMesh = builder.object;
        if (this.previousInstanceMatrixNode === null) {
            instancedMesh.previousInstanceMatrix = this.instanceMatrix.clone();
            this.previousInstanceMatrixNode = this._createInstanceMatrixNode(false, builder);
        }
        return this.previousInstanceMatrixNode.mul($03ccd63b0299d6a7$var$positionPrevious).xyz;
    }
    /**
	 * Creates a node representing the instance matrix data.
	 *
	 * @private
	 * @param {boolean} assignBuffer - Whether the created interleaved buffer should be assigned to the `buffer` member or not.
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node} The instance matrix node.
	 */ _createInstanceMatrixNode(assignBuffer, builder) {
        let instanceMatrixNode;
        const { instanceMatrix: instanceMatrix } = this;
        const { count: count } = instanceMatrix;
        if (this.isStorageMatrix) instanceMatrixNode = $03ccd63b0299d6a7$var$storage(instanceMatrix, 'mat4', Math.max(count, 1)).element($03ccd63b0299d6a7$var$instanceIndex);
        else {
            const uniformBufferSize = count * 64; // count * 16 components * 4 bytes (float)
            if (uniformBufferSize <= builder.getUniformBufferLimit()) instanceMatrixNode = $03ccd63b0299d6a7$var$buffer(instanceMatrix.array, 'mat4', Math.max(count, 1)).element($03ccd63b0299d6a7$var$instanceIndex);
            else {
                const interleaved = new (0, $9ddd7e9b53f7a2d4$export$25ec0e1af1389358)(instanceMatrix.array, 16, 1);
                if (assignBuffer === true) this.buffer = interleaved;
                const bufferFn = instanceMatrix.usage === (0, $9ddd7e9b53f7a2d4$export$8505d14ac8546ca) ? $03ccd63b0299d6a7$var$instancedDynamicBufferAttribute : $03ccd63b0299d6a7$var$instancedBufferAttribute;
                const instanceBuffers = [
                    bufferFn(interleaved, 'vec4', 16, 0),
                    bufferFn(interleaved, 'vec4', 16, 4),
                    bufferFn(interleaved, 'vec4', 16, 8),
                    bufferFn(interleaved, 'vec4', 16, 12)
                ];
                instanceMatrixNode = $03ccd63b0299d6a7$var$mat4(...instanceBuffers);
            }
        }
        return instanceMatrixNode;
    }
}
/**
 * TSL function for creating an instance node.
 *
 * @tsl
 * @function
 * @param {number} count - The number of instances.
 * @param {InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceMatrix - Instanced buffer attribute representing the instance transformations.
 * @param {?InstancedBufferAttribute|StorageInstancedBufferAttribute} instanceColor - Instanced buffer attribute representing the instance colors.
 * @returns {InstanceNode}
 */ const $03ccd63b0299d6a7$var$instance = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$fe90e00cec29e881).setParameterLength(2, 3);
/**
 * This is a special version of `InstanceNode` which requires the usage of {@link InstancedMesh}.
 * It allows an easier setup of the instance node.
 *
 * @augments InstanceNode
 */ class $03ccd63b0299d6a7$export$85a732d53641b45d extends $03ccd63b0299d6a7$export$fe90e00cec29e881 {
    static get type() {
        return 'InstancedMeshNode';
    }
    /**
	 * Constructs a new instanced mesh node.
	 *
	 * @param {InstancedMesh} instancedMesh - The instanced mesh.
	 */ constructor(instancedMesh){
        const { count: count, instanceMatrix: instanceMatrix, instanceColor: instanceColor } = instancedMesh;
        super(count, instanceMatrix, instanceColor);
        /**
		 * A reference to the instanced mesh.
		 *
		 * @type {InstancedMesh}
		 */ this.instancedMesh = instancedMesh;
    }
}
/**
 * TSL function for creating an instanced mesh node.
 *
 * @tsl
 * @function
 * @param {InstancedMesh} instancedMesh - The instancedMesh.
 * @returns {InstancedMeshNode}
 */ const $03ccd63b0299d6a7$var$instancedMesh = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$85a732d53641b45d).setParameterLength(1);
/**
 * This node implements the vertex shader logic which is required
 * when rendering 3D objects via batching. `BatchNode` must be used
 * with instances of {@link BatchedMesh}.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$34fa8d2809c0a555 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'BatchNode';
    }
    /**
	 * Constructs a new batch node.
	 *
	 * @param {BatchedMesh} batchMesh - A reference to batched mesh.
	 */ constructor(batchMesh){
        super('void');
        /**
		 * A reference to batched mesh.
		 *
		 * @type {BatchedMesh}
		 */ this.batchMesh = batchMesh;
        /**
		 * The batching index node.
		 *
		 * @type {?IndexNode}
		 * @default null
		 */ this.batchingIdNode = null;
    }
    /**
	 * Setups the internal buffers and nodes and assigns the transformed vertex data
	 * to predefined node variables for accumulation. That follows the same patterns
	 * like with morph and skinning nodes.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        if (this.batchingIdNode === null) {
            if (builder.getDrawIndex() === null) this.batchingIdNode = $03ccd63b0299d6a7$var$instanceIndex;
            else this.batchingIdNode = $03ccd63b0299d6a7$var$drawIndex;
        }
        const getIndirectIndex = $03ccd63b0299d6a7$var$Fn(([id])=>{
            const size = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$textureSize($03ccd63b0299d6a7$var$textureLoad(this.batchMesh._indirectTexture), 0).x).toConst();
            const x = $03ccd63b0299d6a7$var$int(id).mod(size).toConst();
            const y = $03ccd63b0299d6a7$var$int(id).div(size).toConst();
            return $03ccd63b0299d6a7$var$textureLoad(this.batchMesh._indirectTexture, $03ccd63b0299d6a7$var$ivec2(x, y)).x;
        }).setLayout({
            name: 'getIndirectIndex',
            type: 'uint',
            inputs: [
                {
                    name: 'id',
                    type: 'int'
                }
            ]
        });
        const indirectId = getIndirectIndex($03ccd63b0299d6a7$var$int(this.batchingIdNode));
        const matricesTexture = this.batchMesh._matricesTexture;
        const size = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$textureSize($03ccd63b0299d6a7$var$textureLoad(matricesTexture), 0).x).toConst();
        const j = $03ccd63b0299d6a7$var$float(indirectId).mul(4).toInt().toConst();
        const x = j.mod(size).toConst();
        const y = j.div(size).toConst();
        const batchingMatrix = $03ccd63b0299d6a7$var$mat4($03ccd63b0299d6a7$var$textureLoad(matricesTexture, $03ccd63b0299d6a7$var$ivec2(x, y)), $03ccd63b0299d6a7$var$textureLoad(matricesTexture, $03ccd63b0299d6a7$var$ivec2(x.add(1), y)), $03ccd63b0299d6a7$var$textureLoad(matricesTexture, $03ccd63b0299d6a7$var$ivec2(x.add(2), y)), $03ccd63b0299d6a7$var$textureLoad(matricesTexture, $03ccd63b0299d6a7$var$ivec2(x.add(3), y)));
        const colorsTexture = this.batchMesh._colorsTexture;
        if (colorsTexture !== null) {
            const getBatchingColor = $03ccd63b0299d6a7$var$Fn(([id])=>{
                const size = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$textureSize($03ccd63b0299d6a7$var$textureLoad(colorsTexture), 0).x).toConst();
                const j = id;
                const x = j.mod(size).toConst();
                const y = j.div(size).toConst();
                return $03ccd63b0299d6a7$var$textureLoad(colorsTexture, $03ccd63b0299d6a7$var$ivec2(x, y)).rgb;
            }).setLayout({
                name: 'getBatchingColor',
                type: 'vec3',
                inputs: [
                    {
                        name: 'id',
                        type: 'int'
                    }
                ]
            });
            const color = getBatchingColor(indirectId);
            $03ccd63b0299d6a7$var$varyingProperty('vec3', 'vBatchColor').assign(color);
        }
        const bm = $03ccd63b0299d6a7$var$mat3(batchingMatrix);
        $03ccd63b0299d6a7$var$positionLocal.assign(batchingMatrix.mul($03ccd63b0299d6a7$var$positionLocal));
        const transformedNormal = $03ccd63b0299d6a7$var$normalLocal.div($03ccd63b0299d6a7$var$vec3(bm[0].dot(bm[0]), bm[1].dot(bm[1]), bm[2].dot(bm[2])));
        const batchingNormal = bm.mul(transformedNormal).xyz;
        $03ccd63b0299d6a7$var$normalLocal.assign(batchingNormal);
        if (builder.hasGeometryAttribute('tangent')) $03ccd63b0299d6a7$var$tangentLocal.mulAssign(bm);
    }
}
/**
 * TSL function for creating a batch node.
 *
 * @tsl
 * @function
 * @param {BatchedMesh} batchMesh - A reference to batched mesh.
 * @returns {BatchNode}
 */ const $03ccd63b0299d6a7$var$batch = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$34fa8d2809c0a555).setParameterLength(1);
const $03ccd63b0299d6a7$var$_frameId = new WeakMap();
/**
 * This node implements the vertex transformation shader logic which is required
 * for skinning/skeletal animation.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$39f3abd1a872ebbf extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'SkinningNode';
    }
    /**
	 * Constructs a new skinning node.
	 *
	 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
	 */ constructor(skinnedMesh){
        super('void');
        /**
		 * The skinned mesh.
		 *
		 * @type {SkinnedMesh}
		 */ this.skinnedMesh = skinnedMesh;
        /**
		 * The update type overwritten since skinning nodes are updated per object.
		 *
		 * @type {string}
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        //
        /**
		 * The skin index attribute.
		 *
		 * @type {AttributeNode}
		 */ this.skinIndexNode = $03ccd63b0299d6a7$var$attribute('skinIndex', 'uvec4');
        /**
		 * The skin weight attribute.
		 *
		 * @type {AttributeNode}
		 */ this.skinWeightNode = $03ccd63b0299d6a7$var$attribute('skinWeight', 'vec4');
        /**
		 * The bind matrix node.
		 *
		 * @type {Node<mat4>}
		 */ this.bindMatrixNode = $03ccd63b0299d6a7$var$reference('bindMatrix', 'mat4');
        /**
		 * The bind matrix inverse node.
		 *
		 * @type {Node<mat4>}
		 */ this.bindMatrixInverseNode = $03ccd63b0299d6a7$var$reference('bindMatrixInverse', 'mat4');
        /**
		 * The bind matrices as a uniform buffer node.
		 *
		 * @type {Node}
		 */ this.boneMatricesNode = $03ccd63b0299d6a7$var$referenceBuffer('skeleton.boneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        /**
		 * The current vertex position in local space.
		 *
		 * @type {Node<vec3>}
		 */ this.positionNode = $03ccd63b0299d6a7$var$positionLocal;
        /**
		 * The result of vertex position in local space.
		 *
		 * @type {Node<vec3>}
		 */ this.toPositionNode = $03ccd63b0299d6a7$var$positionLocal;
        /**
		 * The previous bind matrices as a uniform buffer node.
		 * Required for computing motion vectors.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.previousBoneMatricesNode = null;
    }
    /**
	 * Transforms the given vertex position via skinning.
	 *
	 * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
	 * @param {Node<vec3>} [position=this.positionNode] - The vertex position in local space.
	 * @return {Node<vec3>} The transformed vertex position.
	 */ getSkinnedPosition(boneMatrices = this.boneMatricesNode, position = this.positionNode) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // POSITION
        const skinVertex = bindMatrixNode.mul(position);
        const skinned = $03ccd63b0299d6a7$var$add(boneMatX.mul(skinWeightNode.x).mul(skinVertex), boneMatY.mul(skinWeightNode.y).mul(skinVertex), boneMatZ.mul(skinWeightNode.z).mul(skinVertex), boneMatW.mul(skinWeightNode.w).mul(skinVertex));
        return bindMatrixInverseNode.mul(skinned).xyz;
    }
    /**
	 * Transforms the given vertex normal and tangent via skinning.
	 *
	 * @param {Node} [boneMatrices=this.boneMatricesNode] - The bone matrices
	 * @param {Node<vec3>} [normal=normalLocal] - The vertex normal in local space.
	 * @param {Node<vec3>} [tangent=tangentLocal] - The vertex tangent in local space.
	 * @return {{skinNormal: Node<vec3>, skinTangent:Node<vec3>}} The transformed vertex normal and tangent.
	 */ getSkinnedNormalAndTangent(boneMatrices = this.boneMatricesNode, normal = $03ccd63b0299d6a7$var$normalLocal, tangent = $03ccd63b0299d6a7$var$tangentLocal) {
        const { skinIndexNode: skinIndexNode, skinWeightNode: skinWeightNode, bindMatrixNode: bindMatrixNode, bindMatrixInverseNode: bindMatrixInverseNode } = this;
        const boneMatX = boneMatrices.element(skinIndexNode.x);
        const boneMatY = boneMatrices.element(skinIndexNode.y);
        const boneMatZ = boneMatrices.element(skinIndexNode.z);
        const boneMatW = boneMatrices.element(skinIndexNode.w);
        // NORMAL and TANGENT
        let skinMatrix = $03ccd63b0299d6a7$var$add(skinWeightNode.x.mul(boneMatX), skinWeightNode.y.mul(boneMatY), skinWeightNode.z.mul(boneMatZ), skinWeightNode.w.mul(boneMatW));
        skinMatrix = bindMatrixInverseNode.mul(skinMatrix).mul(bindMatrixNode);
        const skinNormal = skinMatrix.transformDirection(normal).xyz;
        const skinTangent = skinMatrix.transformDirection(tangent).xyz;
        return {
            skinNormal: skinNormal,
            skinTangent: skinTangent
        };
    }
    /**
	 * Computes the transformed/skinned vertex position of the previous frame.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The skinned position from the previous frame.
	 */ getPreviousSkinnedPosition(builder) {
        const skinnedMesh = builder.object;
        if (this.previousBoneMatricesNode === null) {
            skinnedMesh.skeleton.previousBoneMatrices = new Float32Array(skinnedMesh.skeleton.boneMatrices);
            this.previousBoneMatricesNode = $03ccd63b0299d6a7$var$referenceBuffer('skeleton.previousBoneMatrices', 'mat4', skinnedMesh.skeleton.bones.length);
        }
        return this.getSkinnedPosition(this.previousBoneMatricesNode, $03ccd63b0299d6a7$var$positionPrevious);
    }
    /**
	 * Setups the skinning node by assigning the transformed vertex data to predefined node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The transformed vertex position.
	 */ setup(builder) {
        if (builder.needsPreviousData()) $03ccd63b0299d6a7$var$positionPrevious.assign(this.getPreviousSkinnedPosition(builder));
        const skinPosition = this.getSkinnedPosition();
        if (this.toPositionNode) this.toPositionNode.assign(skinPosition);
        //
        if (builder.hasGeometryAttribute('normal')) {
            const { skinNormal: skinNormal, skinTangent: skinTangent } = this.getSkinnedNormalAndTangent();
            $03ccd63b0299d6a7$var$normalLocal.assign(skinNormal);
            if (builder.hasGeometryAttribute('tangent')) $03ccd63b0299d6a7$var$tangentLocal.assign(skinTangent);
        }
        return skinPosition;
    }
    /**
	 * Generates the code snippet of the skinning node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        if (output !== 'void') return super.generate(builder, output);
    }
    /**
	 * Updates the state of the skinned mesh by updating the skeleton once per frame.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update(frame) {
        const skeleton = frame.object && frame.object.skeleton ? frame.object.skeleton : this.skinnedMesh.skeleton;
        if ($03ccd63b0299d6a7$var$_frameId.get(skeleton) === frame.frameId) return;
        $03ccd63b0299d6a7$var$_frameId.set(skeleton, frame.frameId);
        if (this.previousBoneMatricesNode !== null) {
            if (skeleton.previousBoneMatrices === null) // cloned skeletons miss "previousBoneMatrices" in their first updated
            skeleton.previousBoneMatrices = new Float32Array(skeleton.boneMatrices);
            skeleton.previousBoneMatrices.set(skeleton.boneMatrices);
        }
        skeleton.update();
    }
}
/**
 * TSL function for creating a skinning node.
 *
 * @tsl
 * @function
 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
 * @returns {SkinningNode}
 */ const $03ccd63b0299d6a7$var$skinning = (skinnedMesh)=>new $03ccd63b0299d6a7$export$39f3abd1a872ebbf(skinnedMesh);
/**
 * TSL function for computing skinning.
 *
 * @tsl
 * @function
 * @param {SkinnedMesh} skinnedMesh - The skinned mesh.
 * @param {Node<vec3>} [toPosition=null] - The target position.
 * @returns {SkinningNode}
 */ const $03ccd63b0299d6a7$var$computeSkinning = (skinnedMesh, toPosition = null)=>{
    const node = new $03ccd63b0299d6a7$export$39f3abd1a872ebbf(skinnedMesh);
    node.positionNode = $03ccd63b0299d6a7$var$storage(new (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a)(skinnedMesh.geometry.getAttribute('position').array, 3), 'vec3').setPBO(true).toReadOnly().element($03ccd63b0299d6a7$var$instanceIndex).toVar();
    node.skinIndexNode = $03ccd63b0299d6a7$var$storage(new (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a)(new Uint32Array(skinnedMesh.geometry.getAttribute('skinIndex').array), 4), 'uvec4').setPBO(true).toReadOnly().element($03ccd63b0299d6a7$var$instanceIndex).toVar();
    node.skinWeightNode = $03ccd63b0299d6a7$var$storage(new (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a)(skinnedMesh.geometry.getAttribute('skinWeight').array, 4), 'vec4').setPBO(true).toReadOnly().element($03ccd63b0299d6a7$var$instanceIndex).toVar();
    node.bindMatrixNode = $03ccd63b0299d6a7$var$uniform(skinnedMesh.bindMatrix, 'mat4');
    node.bindMatrixInverseNode = $03ccd63b0299d6a7$var$uniform(skinnedMesh.bindMatrixInverse, 'mat4');
    node.boneMatricesNode = $03ccd63b0299d6a7$var$buffer(skinnedMesh.skeleton.boneMatrices, 'mat4', skinnedMesh.skeleton.bones.length);
    node.toPositionNode = toPosition;
    return $03ccd63b0299d6a7$var$nodeObject(node);
};
/**
 * This module offers a variety of ways to implement loops in TSL. In it's basic form it's:
 * ```js
 * Loop( count, ( { i } ) => {
 *
 * } );
 * ```
 * However, it is also possible to define a start and end ranges, data types and loop conditions:
 * ```js
 * Loop( { start: int( 0 ), end: int( 10 ), type: 'int', condition: '<' }, ( { i } ) => {
 *
 * } );
 *```
 * Nested loops can be defined in a compacted form:
 * ```js
 * Loop( 10, 5, ( { i, j } ) => {
 *
 * } );
 * ```
 * Loops that should run backwards can be defined like so:
 * ```js
 * Loop( { start: 10 }, () => {} );
 * ```
 * It is possible to execute with boolean values, similar to the `while` syntax.
 * ```js
 * const value = float( 0 ).toVar();
 *
 * Loop( value.lessThan( 10 ), () => {
 *
 * 	value.addAssign( 1 );
 *
 * } );
 * ```
 * The module also provides `Break()` and `Continue()` TSL expression for loop control.
 * @augments Node
 */ class $03ccd63b0299d6a7$export$a281104ce5b2be39 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'LoopNode';
    }
    /**
	 * Constructs a new loop node.
	 *
	 * @param {Array<any>} params - Depending on the loop type, array holds different parameterization values for the loop.
	 */ constructor(params = []){
        super('void');
        this.params = params;
    }
    /**
	 * Returns a loop variable name based on an index. The pattern is
	 * `0` = `i`, `1`= `j`, `2`= `k` and so on.
	 *
	 * @param {number} index - The index.
	 * @return {string} The loop variable name.
	 */ getVarName(index) {
        return String.fromCharCode('i'.charCodeAt(0) + index);
    }
    /**
	 * Returns properties about this node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Object} The node properties.
	 */ getProperties(builder) {
        const properties = builder.getNodeProperties(this);
        if (properties.stackNode !== undefined) return properties;
        //
        const inputs = {};
        for(let i = 0, l = this.params.length - 1; i < l; i++){
            const param = this.params[i];
            const name = param.isNode !== true && param.name || this.getVarName(i);
            const type = param.isNode !== true && param.type || 'int';
            inputs[name] = $03ccd63b0299d6a7$var$expression(name, type);
        }
        const stack = builder.addStack();
        const fnCall = this.params[this.params.length - 1](inputs);
        properties.returnsNode = fnCall.context({
            nodeLoop: fnCall
        });
        properties.stackNode = stack;
        const baseParam = this.params[0];
        if (baseParam.isNode !== true && typeof baseParam.update === 'function') {
            const fnUpdateCall = $03ccd63b0299d6a7$var$Fn(this.params[0].update)(inputs);
            properties.updateNode = fnUpdateCall.context({
                nodeLoop: fnUpdateCall
            });
        }
        builder.removeStack();
        return properties;
    }
    setup(builder) {
        // setup properties
        this.getProperties(builder);
        if (builder.fnCall) {
            const shaderNodeData = builder.getDataFromNode(builder.fnCall.shaderNode);
            shaderNodeData.hasLoop = true;
        }
    }
    generate(builder) {
        const properties = this.getProperties(builder);
        const params = this.params;
        const stackNode = properties.stackNode;
        for(let i = 0, l = params.length - 1; i < l; i++){
            const param = params[i];
            let isWhile = false, start = null, end = null, name = null, type = null, condition = null, update = null;
            if (param.isNode) {
                if (param.getNodeType(builder) === 'bool') {
                    isWhile = true;
                    type = 'bool';
                    end = param.build(builder, type);
                } else {
                    type = 'int';
                    name = this.getVarName(i);
                    start = '0';
                    end = param.build(builder, type);
                    condition = '<';
                }
            } else {
                type = param.type || 'int';
                name = param.name || this.getVarName(i);
                start = param.start;
                end = param.end;
                condition = param.condition;
                update = param.update;
                if (typeof start === 'number') start = builder.generateConst(type, start);
                else if (start && start.isNode) start = start.build(builder, type);
                if (typeof end === 'number') end = builder.generateConst(type, end);
                else if (end && end.isNode) end = end.build(builder, type);
                if (start !== undefined && end === undefined) {
                    start = start + ' - 1';
                    end = '0';
                    condition = '>=';
                } else if (end !== undefined && start === undefined) {
                    start = '0';
                    condition = '<';
                }
                if (condition === undefined) {
                    if (Number(start) > Number(end)) condition = '>=';
                    else condition = '<';
                }
            }
            let loopSnippet;
            if (isWhile) loopSnippet = `while ( ${end} )`;
            else {
                const internalParam = {
                    start: start,
                    end: end
                };
                //
                const startSnippet = internalParam.start;
                const endSnippet = internalParam.end;
                let updateSnippet;
                const deltaOperator = ()=>condition.includes('<') ? '+=' : '-=';
                if (update !== undefined && update !== null) switch(typeof update){
                    case 'function':
                        const flow = builder.flowStagesNode(properties.updateNode, 'void');
                        const snippet = flow.code.replace(/\t|;/g, '');
                        updateSnippet = snippet;
                        break;
                    case 'number':
                        updateSnippet = name + ' ' + deltaOperator() + ' ' + builder.generateConst(type, update);
                        break;
                    case 'string':
                        updateSnippet = name + ' ' + update;
                        break;
                    default:
                        if (update.isNode) updateSnippet = name + ' ' + deltaOperator() + ' ' + update.build(builder);
                        else {
                            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: \'Loop( { update: ... } )\' is not a function, string or number.', this.stackTrace);
                            updateSnippet = 'break /* invalid update */';
                        }
                }
                else {
                    if (type === 'int' || type === 'uint') update = condition.includes('<') ? '++' : '--';
                    else update = deltaOperator() + ' 1.';
                    updateSnippet = name + ' ' + update;
                }
                const declarationSnippet = builder.getVar(type, name) + ' = ' + startSnippet;
                const conditionalSnippet = name + ' ' + condition + ' ' + endSnippet;
                loopSnippet = `for ( ${declarationSnippet}; ${conditionalSnippet}; ${updateSnippet} )`;
            }
            builder.addFlowCode((i === 0 ? '\n' : '') + builder.tab + loopSnippet + ' {\n\n').addFlowTab();
        }
        const stackSnippet = stackNode.build(builder, 'void');
        properties.returnsNode.build(builder, 'void');
        builder.removeFlowTab().addFlowCode('\n' + builder.tab + stackSnippet);
        for(let i = 0, l = this.params.length - 1; i < l; i++)builder.addFlowCode((i === 0 ? '' : builder.tab) + '}\n\n').removeFlowTab();
        builder.addFlowTab();
    }
}
/**
 * TSL function for creating a loop node.
 *
 * @tsl
 * @function
 * @param {...any} params - A list of parameters.
 * @returns {LoopNode}
 */ const $03ccd63b0299d6a7$var$Loop = (...params)=>new $03ccd63b0299d6a7$export$a281104ce5b2be39($03ccd63b0299d6a7$var$nodeArray(params, 'int')).toStack();
/**
 * TSL function for creating a `Continue()` expression.
 *
 * @tsl
 * @function
 * @returns {ExpressionNode}
 */ const $03ccd63b0299d6a7$var$Continue = ()=>$03ccd63b0299d6a7$var$expression('continue').toStack();
/**
 * TSL function for creating a `Break()` expression.
 *
 * @tsl
 * @function
 * @returns {ExpressionNode}
 */ const $03ccd63b0299d6a7$var$Break = ()=>$03ccd63b0299d6a7$var$expression('break').toStack();
const $03ccd63b0299d6a7$var$_morphTextures = /*@__PURE__*/ new WeakMap();
const $03ccd63b0299d6a7$var$_morphVec4 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
const $03ccd63b0299d6a7$var$getMorph = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ bufferMap: bufferMap, influence: influence, stride: stride, width: width, depth: depth, offset: offset })=>{
    const texelIndex = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$vertexIndex).mul(stride).add(offset);
    const y = texelIndex.div(width);
    const x = texelIndex.sub(y.mul(width));
    const bufferAttrib = $03ccd63b0299d6a7$var$textureLoad(bufferMap, $03ccd63b0299d6a7$var$ivec2(x, y)).depth(depth).xyz;
    return bufferAttrib.mul(influence);
});
function $03ccd63b0299d6a7$var$getEntry(geometry) {
    const hasMorphPosition = geometry.morphAttributes.position !== undefined;
    const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
    const hasMorphColors = geometry.morphAttributes.color !== undefined;
    // instead of using attributes, the WebGL 2 code path encodes morph targets
    // into an array of data textures. Each layer represents a single morph target.
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
    let entry = $03ccd63b0299d6a7$var$_morphTextures.get(geometry);
    if (entry === undefined || entry.count !== morphTargetsCount) {
        if (entry !== undefined) entry.texture.dispose();
        const morphTargets = geometry.morphAttributes.position || [];
        const morphNormals = geometry.morphAttributes.normal || [];
        const morphColors = geometry.morphAttributes.color || [];
        let vertexDataCount = 0;
        if (hasMorphPosition === true) vertexDataCount = 1;
        if (hasMorphNormals === true) vertexDataCount = 2;
        if (hasMorphColors === true) vertexDataCount = 3;
        let width = geometry.attributes.position.count * vertexDataCount;
        let height = 1;
        const maxTextureSize = 4096; // @TODO: Use 'capabilities.maxTextureSize'
        if (width > maxTextureSize) {
            height = Math.ceil(width / maxTextureSize);
            width = maxTextureSize;
        }
        const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
        const bufferTexture = new (0, $9ddd7e9b53f7a2d4$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
        bufferTexture.type = (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        bufferTexture.needsUpdate = true;
        // fill buffer
        const vertexDataStride = vertexDataCount * 4;
        for(let i = 0; i < morphTargetsCount; i++){
            const morphTarget = morphTargets[i];
            const morphNormal = morphNormals[i];
            const morphColor = morphColors[i];
            const offset = width * height * 4 * i;
            for(let j = 0; j < morphTarget.count; j++){
                const stride = j * vertexDataStride;
                if (hasMorphPosition === true) {
                    $03ccd63b0299d6a7$var$_morphVec4.fromBufferAttribute(morphTarget, j);
                    buffer[offset + stride + 0] = $03ccd63b0299d6a7$var$_morphVec4.x;
                    buffer[offset + stride + 1] = $03ccd63b0299d6a7$var$_morphVec4.y;
                    buffer[offset + stride + 2] = $03ccd63b0299d6a7$var$_morphVec4.z;
                    buffer[offset + stride + 3] = 0;
                }
                if (hasMorphNormals === true) {
                    $03ccd63b0299d6a7$var$_morphVec4.fromBufferAttribute(morphNormal, j);
                    buffer[offset + stride + 4] = $03ccd63b0299d6a7$var$_morphVec4.x;
                    buffer[offset + stride + 5] = $03ccd63b0299d6a7$var$_morphVec4.y;
                    buffer[offset + stride + 6] = $03ccd63b0299d6a7$var$_morphVec4.z;
                    buffer[offset + stride + 7] = 0;
                }
                if (hasMorphColors === true) {
                    $03ccd63b0299d6a7$var$_morphVec4.fromBufferAttribute(morphColor, j);
                    buffer[offset + stride + 8] = $03ccd63b0299d6a7$var$_morphVec4.x;
                    buffer[offset + stride + 9] = $03ccd63b0299d6a7$var$_morphVec4.y;
                    buffer[offset + stride + 10] = $03ccd63b0299d6a7$var$_morphVec4.z;
                    buffer[offset + stride + 11] = morphColor.itemSize === 4 ? $03ccd63b0299d6a7$var$_morphVec4.w : 1;
                }
            }
        }
        entry = {
            count: morphTargetsCount,
            texture: bufferTexture,
            stride: vertexDataCount,
            size: new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)(width, height)
        };
        $03ccd63b0299d6a7$var$_morphTextures.set(geometry, entry);
        function disposeTexture() {
            bufferTexture.dispose();
            $03ccd63b0299d6a7$var$_morphTextures.delete(geometry);
            geometry.removeEventListener('dispose', disposeTexture);
        }
        geometry.addEventListener('dispose', disposeTexture);
    }
    return entry;
}
/**
 * This node implements the vertex transformation shader logic which is required
 * for morph target animation.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$b07a0b8e32632807 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'MorphNode';
    }
    /**
	 * Constructs a new morph node.
	 *
	 * @param {Mesh} mesh - The mesh holding the morph targets.
	 */ constructor(mesh){
        super('void');
        /**
		 * The mesh holding the morph targets.
		 *
		 * @type {Mesh}
		 */ this.mesh = mesh;
        /**
		 * A uniform node which represents the morph base influence value.
		 *
		 * @type {UniformNode<float>}
		 */ this.morphBaseInfluence = $03ccd63b0299d6a7$var$uniform(1);
        /**
		 * The update type overwritten since morph nodes are updated per object.
		 *
		 * @type {string}
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
    }
    /**
	 * Setups the morph node by assigning the transformed vertex data to predefined node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const { geometry: geometry } = builder;
        const hasMorphPosition = geometry.morphAttributes.position !== undefined;
        const hasMorphNormals = geometry.hasAttribute('normal') && geometry.morphAttributes.normal !== undefined;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        // nodes
        const { texture: bufferMap, stride: stride, size: size } = $03ccd63b0299d6a7$var$getEntry(geometry);
        if (hasMorphPosition === true) $03ccd63b0299d6a7$var$positionLocal.mulAssign(this.morphBaseInfluence);
        if (hasMorphNormals === true) $03ccd63b0299d6a7$var$normalLocal.mulAssign(this.morphBaseInfluence);
        const width = $03ccd63b0299d6a7$var$int(size.width);
        $03ccd63b0299d6a7$var$Loop(morphTargetsCount, ({ i: i })=>{
            const influence = $03ccd63b0299d6a7$var$float(0).toVar();
            if (this.mesh.count > 1 && this.mesh.morphTexture !== null && this.mesh.morphTexture !== undefined) influence.assign($03ccd63b0299d6a7$var$textureLoad(this.mesh.morphTexture, $03ccd63b0299d6a7$var$ivec2($03ccd63b0299d6a7$var$int(i).add(1), $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$instanceIndex))).r);
            else influence.assign($03ccd63b0299d6a7$var$reference('morphTargetInfluences', 'float').element(i).toVar());
            $03ccd63b0299d6a7$var$If(influence.notEqual(0), ()=>{
                if (hasMorphPosition === true) $03ccd63b0299d6a7$var$positionLocal.addAssign($03ccd63b0299d6a7$var$getMorph({
                    bufferMap: bufferMap,
                    influence: influence,
                    stride: stride,
                    width: width,
                    depth: i,
                    offset: $03ccd63b0299d6a7$var$int(0)
                }));
                if (hasMorphNormals === true) $03ccd63b0299d6a7$var$normalLocal.addAssign($03ccd63b0299d6a7$var$getMorph({
                    bufferMap: bufferMap,
                    influence: influence,
                    stride: stride,
                    width: width,
                    depth: i,
                    offset: $03ccd63b0299d6a7$var$int(1)
                }));
            });
        });
    }
    /**
	 * Updates the state of the morphed mesh by updating the base influence.
	 *
	 * @param {NodeFrame} frame - The current node frame.
	 */ update() {
        const morphBaseInfluence = this.morphBaseInfluence;
        if (this.mesh.geometry.morphTargetsRelative) morphBaseInfluence.value = 1;
        else morphBaseInfluence.value = 1 - this.mesh.morphTargetInfluences.reduce((a, b)=>a + b, 0);
    }
}
/**
 * TSL function for creating a morph node.
 *
 * @tsl
 * @function
 * @param {Mesh} mesh - The mesh holding the morph targets.
 * @returns {MorphNode}
 */ const $03ccd63b0299d6a7$var$morphReference = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$b07a0b8e32632807).setParameterLength(1);
/**
 * Base class for lighting nodes.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$3fce9846d62aac91 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'LightingNode';
    }
    /**
	 * Constructs a new lighting node.
	 */ constructor(){
        super('vec3');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightingNode = true;
    }
}
/**
 * A generic class that can be used by nodes which contribute
 * ambient occlusion to the scene. E.g. an ambient occlusion map
 * node can be used as input for this module. Used in {@link NodeMaterial}.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$91e1d32e5b48fb53 extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'AONode';
    }
    /**
	 * Constructs a new AO node.
	 *
	 * @param {?Node<float>} [aoNode=null] - The ambient occlusion node.
	 */ constructor(aoNode = null){
        super();
        /**
		 * The ambient occlusion node.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.aoNode = aoNode;
    }
    setup(builder) {
        builder.context.ambientOcclusion.mulAssign(this.aoNode);
    }
}
/**
 * `LightingContextNode` represents an extension of the {@link ContextNode} module
 * by adding lighting specific context data. It represents the runtime context of
 * {@link LightsNode}.
 *
 * @augments ContextNode
 */ class $03ccd63b0299d6a7$export$cc99f7905cc5767b extends $03ccd63b0299d6a7$export$17ecd2ebd87625d1 {
    static get type() {
        return 'LightingContextNode';
    }
    /**
	 * Constructs a new lighting context node.
	 *
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {?LightingModel} [lightingModel=null] - The current lighting model.
	 * @param {?Node<vec3>} [backdropNode=null] - A backdrop node.
	 * @param {?Node<float>} [backdropAlphaNode=null] - A backdrop alpha node.
	 */ constructor(lightsNode, lightingModel = null, backdropNode = null, backdropAlphaNode = null){
        super(lightsNode);
        /**
		 * The current lighting model.
		 *
		 * @type {?LightingModel}
		 * @default null
		 */ this.lightingModel = lightingModel;
        /**
		 * A backdrop node.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.backdropNode = backdropNode;
        /**
		 * A backdrop alpha node.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.backdropAlphaNode = backdropAlphaNode;
        this._value = null;
    }
    /**
	 * Returns a lighting context object.
	 *
	 * @return {{
	 * radiance: Node<vec3>,
	 * irradiance: Node<vec3>,
	 * iblIrradiance: Node<vec3>,
	 * ambientOcclusion: Node<float>,
	 * reflectedLight: {directDiffuse: Node<vec3>, directSpecular: Node<vec3>, indirectDiffuse: Node<vec3>, indirectSpecular: Node<vec3>},
	 * backdrop: Node<vec3>,
	 * backdropAlpha: Node<float>
	 * }} The lighting context object.
	 */ getContext() {
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode } = this;
        const directDiffuse = $03ccd63b0299d6a7$var$vec3().toVar('directDiffuse'), directSpecular = $03ccd63b0299d6a7$var$vec3().toVar('directSpecular'), indirectDiffuse = $03ccd63b0299d6a7$var$vec3().toVar('indirectDiffuse'), indirectSpecular = $03ccd63b0299d6a7$var$vec3().toVar('indirectSpecular');
        const reflectedLight = {
            directDiffuse: directDiffuse,
            directSpecular: directSpecular,
            indirectDiffuse: indirectDiffuse,
            indirectSpecular: indirectSpecular
        };
        const context = {
            radiance: $03ccd63b0299d6a7$var$vec3().toVar('radiance'),
            irradiance: $03ccd63b0299d6a7$var$vec3().toVar('irradiance'),
            iblIrradiance: $03ccd63b0299d6a7$var$vec3().toVar('iblIrradiance'),
            ambientOcclusion: $03ccd63b0299d6a7$var$float(1).toVar('ambientOcclusion'),
            reflectedLight: reflectedLight,
            backdrop: backdropNode,
            backdropAlpha: backdropAlphaNode
        };
        return context;
    }
    setup(builder) {
        this.value = this._value || (this._value = this.getContext());
        this.value.lightingModel = this.lightingModel || builder.context.lightingModel;
        return super.setup(builder);
    }
}
const $03ccd63b0299d6a7$var$lightingContext = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$cc99f7905cc5767b);
/**
 * A generic class that can be used by nodes which contribute
 * irradiance to the scene. E.g. a light map node can be used
 * as input for this module. Used in {@link NodeMaterial}.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$26fe501f8a41ff48 extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'IrradianceNode';
    }
    /**
	 * Constructs a new irradiance node.
	 *
	 * @param {Node<vec3>} node - A node contributing irradiance.
	 */ constructor(node){
        super();
        /**
		 * A node contributing irradiance.
		 *
		 * @type {Node<vec3>}
		 */ this.node = node;
    }
    setup(builder) {
        builder.context.irradiance.addAssign(this.node);
    }
}
const $03ccd63b0299d6a7$var$_size$5 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
/**
 * A special type of texture node which represents the data of the current viewport
 * as a texture. The module extracts data from the current bound framebuffer with
 * a copy operation so no extra render pass is required to produce the texture data
 * (which is good for performance). `ViewportTextureNode` can be used as an input for a
 * variety of effects like refractive or transmissive materials.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$f873d674c2e6b04d extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'ViewportTextureNode';
    }
    /**
	 * Constructs a new viewport texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
	 */ constructor(uvNode = $03ccd63b0299d6a7$var$screenUV, levelNode = null, framebufferTexture = null){
        let defaultFramebuffer = null;
        if (framebufferTexture === null) {
            defaultFramebuffer = new (0, $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe)();
            defaultFramebuffer.minFilter = (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b);
            framebufferTexture = defaultFramebuffer;
        } else defaultFramebuffer = framebufferTexture;
        super(framebufferTexture, uvNode, levelNode);
        /**
		 * Whether to generate mipmaps or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The reference framebuffer texture. This is used to store the framebuffer texture
		 * for the current render target. If the render target changes, a new framebuffer texture
		 * is created automatically.
		 *
		 * @type {FramebufferTexture}
		 * @default null
		 */ this.defaultFramebuffer = defaultFramebuffer;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOutputTextureNode = true;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` since the node should extract
		 * the current contents of the bound framebuffer for each render call.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        /**
		 * The framebuffer texture for the current renderer context.
		 *
		 * @type {WeakMap<RenderTarget, FramebufferTexture>}
		 * @private
		 */ this._cacheTextures = new WeakMap();
    }
    /**
	 * This methods returns a texture for the given render target or canvas target reference.
	 *
	 * To avoid rendering errors, `ViewportTextureNode` must use unique framebuffer textures
	 * for different render contexts.
	 *
	 * @param {?(RenderTarget|CanvasTarget)} [reference=null] - The render target or canvas target reference.
	 * @return {Texture} The framebuffer texture.
	 */ getTextureForReference(reference = null) {
        let defaultFramebuffer;
        let cacheTextures;
        if (this.referenceNode) {
            defaultFramebuffer = this.referenceNode.defaultFramebuffer;
            cacheTextures = this.referenceNode._cacheTextures;
        } else {
            defaultFramebuffer = this.defaultFramebuffer;
            cacheTextures = this._cacheTextures;
        }
        if (reference === null) return defaultFramebuffer;
        if (cacheTextures.has(reference) === false) {
            const framebufferTexture = defaultFramebuffer.clone();
            cacheTextures.set(reference, framebufferTexture);
        }
        return cacheTextures.get(reference);
    }
    updateReference(frame) {
        const renderer = frame.renderer;
        const renderTarget = renderer.getRenderTarget();
        const canvasTarget = renderer.getCanvasTarget();
        const reference = renderTarget ? renderTarget : canvasTarget;
        this.value = this.getTextureForReference(reference);
        return this.value;
    }
    updateBefore(frame) {
        const renderer = frame.renderer;
        const renderTarget = renderer.getRenderTarget();
        const canvasTarget = renderer.getCanvasTarget();
        const reference = renderTarget ? renderTarget : canvasTarget;
        if (reference === null) renderer.getDrawingBufferSize($03ccd63b0299d6a7$var$_size$5);
        else if (reference.getDrawingBufferSize) reference.getDrawingBufferSize($03ccd63b0299d6a7$var$_size$5);
        else $03ccd63b0299d6a7$var$_size$5.set(reference.width, reference.height);
        //
        const framebufferTexture = this.getTextureForReference(reference);
        if (framebufferTexture.image.width !== $03ccd63b0299d6a7$var$_size$5.width || framebufferTexture.image.height !== $03ccd63b0299d6a7$var$_size$5.height) {
            framebufferTexture.image.width = $03ccd63b0299d6a7$var$_size$5.width;
            framebufferTexture.image.height = $03ccd63b0299d6a7$var$_size$5.height;
            framebufferTexture.needsUpdate = true;
        }
        //
        const currentGenerateMipmaps = framebufferTexture.generateMipmaps;
        framebufferTexture.generateMipmaps = this.generateMipmaps;
        renderer.copyFramebufferToTexture(framebufferTexture);
        framebufferTexture.generateMipmaps = currentGenerateMipmaps;
    }
    clone() {
        const viewportTextureNode = new this.constructor(this.uvNode, this.levelNode, this.value);
        viewportTextureNode.generateMipmaps = this.generateMipmaps;
        return viewportTextureNode;
    }
}
/**
 * TSL function for creating a viewport texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
 * @returns {ViewportTextureNode}
 */ const $03ccd63b0299d6a7$var$viewportTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$f873d674c2e6b04d).setParameterLength(0, 3);
/**
 * TSL function for creating a viewport texture node with enabled mipmap generation.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @param {?Texture} [framebufferTexture=null] - A framebuffer texture holding the viewport data. If not provided, a framebuffer texture is created automatically.
 * @returns {ViewportTextureNode}
 */ const $03ccd63b0299d6a7$var$viewportMipTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$f873d674c2e6b04d, null, null, {
    generateMipmaps: true
}).setParameterLength(0, 3);
// Singleton instances for common usage
const $03ccd63b0299d6a7$var$_singletonOpaqueViewportTextureNode = /*@__PURE__*/ $03ccd63b0299d6a7$var$viewportMipTexture();
/**
 * TSL function for creating a viewport texture node with enabled mipmap generation.
 * The texture should only contain the opaque rendering objects.
 *
 * This should be used just in transparent or transmissive materials.
 *
 * @tsl
 * @function
 * @param {?Node} [uv=screenUV] - The uv node.
 * @param {?Node} [level=null] - The level node.
 * @returns {ViewportTextureNode}
 */ const $03ccd63b0299d6a7$var$viewportOpaqueMipTexture = (uv = $03ccd63b0299d6a7$var$screenUV, level = null)=>$03ccd63b0299d6a7$var$_singletonOpaqueViewportTextureNode.sample(uv, level); // TODO: Use once() when sample() supports it
let $03ccd63b0299d6a7$var$_sharedDepthbuffer = null;
/**
 * Represents the depth of the current viewport as a texture. This module
 * can be used in combination with viewport texture to achieve effects
 * that require depth evaluation.
 *
 * @augments ViewportTextureNode
 */ class $03ccd63b0299d6a7$export$7cf1e34dae1b8553 extends $03ccd63b0299d6a7$export$f873d674c2e6b04d {
    static get type() {
        return 'ViewportDepthTextureNode';
    }
    /**
	 * Constructs a new viewport depth texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 * @param {?DepthTexture} [depthTexture=null] - A depth texture. If not provided, uses a shared depth texture.
	 */ constructor(uvNode = $03ccd63b0299d6a7$var$screenUV, levelNode = null, depthTexture = null){
        if (depthTexture === null) {
            if ($03ccd63b0299d6a7$var$_sharedDepthbuffer === null) $03ccd63b0299d6a7$var$_sharedDepthbuffer = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)();
            depthTexture = $03ccd63b0299d6a7$var$_sharedDepthbuffer;
        }
        super(uvNode, levelNode, depthTexture);
    }
}
/**
 * TSL function for a viewport depth texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @param {?DepthTexture} [depthTexture=null] - A depth texture. If not provided, a depth texture is created automatically.
 * @returns {ViewportDepthTextureNode}
 */ const $03ccd63b0299d6a7$var$viewportDepthTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$7cf1e34dae1b8553).setParameterLength(0, 3);
/**
 * This node offers a collection of features in context of the depth logic in the fragment shader.
 * Depending on {@link ViewportDepthNode#scope}, it can be used to define a depth value for the current
 * fragment or for depth evaluation purposes.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$43ab5aad252e8f95 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ViewportDepthNode';
    }
    /**
	 * Constructs a new viewport depth node.
	 *
	 * @param {('depth'|'depthBase'|'linearDepth')} scope - The node's scope.
	 * @param {?Node} [valueNode=null] - The value node.
	 */ constructor(scope, valueNode = null){
        super('float');
        /**
		 * The node behaves differently depending on which scope is selected.
		 *
		 * - `ViewportDepthNode.DEPTH_BASE`: Allows to define a value for the current fragment's depth.
		 * - `ViewportDepthNode.DEPTH`: Represents the depth value for the current fragment (`valueNode` is ignored).
		 * - `ViewportDepthNode.LINEAR_DEPTH`: Represents the linear (orthographic) depth value of the current fragment.
		 * If a `valueNode` is set, the scope can be used to convert perspective depth data to linear data.
		 *
		 * @type {('depth'|'depthBase'|'linearDepth')}
		 */ this.scope = scope;
        /**
		 * Can be used to define a custom depth value.
		 * The property is ignored in the `ViewportDepthNode.DEPTH` scope.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.valueNode = valueNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isViewportDepthNode = true;
    }
    generate(builder) {
        const { scope: scope } = this;
        if (scope === $03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH_BASE) return builder.getFragDepth();
        return super.generate(builder);
    }
    setup({ camera: camera }) {
        const { scope: scope } = this;
        const value = this.valueNode;
        let node = null;
        if (scope === $03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH_BASE) {
            if (value !== null) node = $03ccd63b0299d6a7$var$depthBase().assign(value);
        } else if (scope === $03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH) {
            if (camera.isPerspectiveCamera) node = $03ccd63b0299d6a7$var$viewZToPerspectiveDepth($03ccd63b0299d6a7$var$positionView.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
            else node = $03ccd63b0299d6a7$var$viewZToOrthographicDepth($03ccd63b0299d6a7$var$positionView.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
        } else if (scope === $03ccd63b0299d6a7$export$43ab5aad252e8f95.LINEAR_DEPTH) {
            if (value !== null) {
                if (camera.isPerspectiveCamera) {
                    const viewZ = $03ccd63b0299d6a7$var$perspectiveDepthToViewZ(value, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
                    node = $03ccd63b0299d6a7$var$viewZToOrthographicDepth(viewZ, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
                } else node = value;
            } else node = $03ccd63b0299d6a7$var$viewZToOrthographicDepth($03ccd63b0299d6a7$var$positionView.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
        }
        return node;
    }
}
$03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH_BASE = 'depthBase';
$03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH = 'depth';
$03ccd63b0299d6a7$export$43ab5aad252e8f95.LINEAR_DEPTH = 'linearDepth';
// NOTE: viewZ, the z-coordinate in camera space, is negative for points in front of the camera
/**
 * TSL function for converting a viewZ value to an orthographic depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$viewZToOrthographicDepth = (viewZ, near, far)=>viewZ.add(near).div(near.sub(far));
/**
 * TSL function for converting a viewZ value to a reversed orthographic depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$viewZToReversedOrthographicDepth = (viewZ, near, far)=>viewZ.add(far).div(far.sub(near));
/**
 * TSL function for converting an orthographic depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The orthographic depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$orthographicDepthToViewZ = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([depth, near, far], builder)=>{
    if (builder.renderer.reversedDepthBuffer === true) return far.sub(near).mul(depth).sub(far);
    else return near.sub(far).mul(depth).sub(near);
});
/**
 * TSL function for converting a viewZ value to a perspective depth value.
 *
 * Note: {link https://twitter.com/gonnavis/status/1377183786949959682}.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$viewZToPerspectiveDepth = (viewZ, near, far)=>near.add(viewZ).mul(far).div(far.sub(near).mul(viewZ));
/**
 * TSL function for converting a viewZ value to a reversed perspective depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$viewZToReversedPerspectiveDepth = (viewZ, near, far)=>near.mul(viewZ.add(far)).div(viewZ.mul(near.sub(far)));
/**
 * TSL function for converting a perspective depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The perspective depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$perspectiveDepthToViewZ = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([depth, near, far], builder)=>{
    if (builder.renderer.reversedDepthBuffer === true) return near.mul(far).div(near.sub(far).mul(depth).sub(near));
    else return near.mul(far).div(far.sub(near).mul(depth).sub(far));
});
/**
 * TSL function for converting a viewZ value to a logarithmic depth value.
 *
 * @tsl
 * @function
 * @param {Node<float>} viewZ - The viewZ node.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$viewZToLogarithmicDepth = (viewZ, near, far)=>{
    // NOTE: viewZ must be negative--see explanation at the end of this comment block.
    // The final logarithmic depth formula used here is adapted from one described in an
    // article by Thatcher Ulrich (see http://tulrich.com/geekstuff/log_depth_buffer.txt),
    // which was an improvement upon an earlier formula one described in an
    // Outerra article (https://outerra.blogspot.com/2009/08/logarithmic-z-buffer.html).
    // Ulrich's formula is the following:
    //     z = K * log( w / cameraNear ) / log( cameraFar / cameraNear )
    //     where K = 2^k - 1, and k is the number of bits in the depth buffer.
    // The Outerra variant ignored the camera near plane (it assumed it was 0) and instead
    // opted for a "C-constant" for resolution adjustment of objects near the camera.
    // Outerra states: "Notice that the 'C' variant doesn’t use a near plane distance, it has it
    // set at 0" (quote from https://outerra.blogspot.com/2012/11/maximizing-depth-buffer-range-and.html).
    // Ulrich's variant has the benefit of constant relative precision over the whole near-far range.
    // It was debated here whether Outerra's "C-constant" or Ulrich's "near plane" variant should
    // be used, and ultimately Ulrich's "near plane" version was chosen.
    // Outerra eventually made another improvement to their original "C-constant" variant,
    // but it still does not incorporate the camera near plane (for this version,
    // see https://outerra.blogspot.com/2013/07/logarithmic-depth-buffer-optimizations.html).
    // Here we make 4 changes to Ulrich's formula:
    // 1. Clamp the camera near plane so we don't divide by 0.
    // 2. Use log2 instead of log to avoid an extra multiply (shaders implement log using log2).
    // 3. Assume K is 1 (K = maximum value in depth buffer; see Ulrich's formula above).
    // 4. To maintain consistency with the functions "viewZToOrthographicDepth" and "viewZToPerspectiveDepth",
    //    we modify the formula here to use 'viewZ' instead of 'w'. The other functions expect a negative viewZ,
    //    so we do the same here, hence the 'viewZ.negate()' call.
    // For visual representation of this depth curve, see https://www.desmos.com/calculator/uyqk0vex1u
    near = near.max(1e-6).toVar();
    const numerator = $03ccd63b0299d6a7$var$log2(viewZ.negate().div(near));
    const denominator = $03ccd63b0299d6a7$var$log2(far.div(near));
    return numerator.div(denominator);
};
/**
 * TSL function for converting a logarithmic depth value to a viewZ value.
 *
 * @tsl
 * @function
 * @param {Node<float>} depth - The logarithmic depth.
 * @param {Node<float>} near - The camera's near value.
 * @param {Node<float>} far - The camera's far value.
 * @returns {Node<float>}
 */ const $03ccd63b0299d6a7$var$logarithmicDepthToViewZ = (depth, near, far)=>{
    // NOTE: we add a 'negate()' call to the return value here to maintain consistency with
    // the functions "orthographicDepthToViewZ" and "perspectiveDepthToViewZ" (they return
    // a negative viewZ).
    const exponent = depth.mul($03ccd63b0299d6a7$var$log(far.div(near)));
    return $03ccd63b0299d6a7$var$float(Math.E).pow(exponent).mul(near).negate();
};
/**
 * TSL function for defining a value for the current fragment's depth.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The depth value to set.
 * @returns {ViewportDepthNode<float>}
 */ const $03ccd63b0299d6a7$var$depthBase = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$43ab5aad252e8f95, $03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH_BASE);
/**
 * TSL object that represents the depth value for the current fragment.
 *
 * @tsl
 * @type {ViewportDepthNode}
 */ const $03ccd63b0299d6a7$var$depth = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$43ab5aad252e8f95, $03ccd63b0299d6a7$export$43ab5aad252e8f95.DEPTH);
/**
 * TSL function for converting a perspective depth value to linear depth.
 *
 * @tsl
 * @function
 * @param {?Node<float>} [value=null] - The perspective depth. If `null` is provided, the current fragment's depth is used.
 * @returns {ViewportDepthNode<float>}
 */ const $03ccd63b0299d6a7$var$linearDepth = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$43ab5aad252e8f95, $03ccd63b0299d6a7$export$43ab5aad252e8f95.LINEAR_DEPTH).setParameterLength(0, 1);
/**
 * TSL object that represents the linear (orthographic) depth value of the current fragment
 *
 * @tsl
 * @type {ViewportDepthNode}
 */ const $03ccd63b0299d6a7$var$viewportLinearDepth = /*@__PURE__*/ $03ccd63b0299d6a7$var$linearDepth($03ccd63b0299d6a7$var$viewportDepthTexture());
$03ccd63b0299d6a7$var$depth.assign = (value)=>$03ccd63b0299d6a7$var$depthBase(value);
/**
 * This node is used in {@link NodeMaterial} to setup the clipping
 * which can happen hardware-accelerated (if supported) and optionally
 * use alpha-to-coverage for anti-aliasing clipped edges.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$ab88ac7b14637396 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ClippingNode';
    }
    /**
	 * Constructs a new clipping node.
	 *
	 * @param {('default'|'hardware'|'alphaToCoverage')} [scope='default'] - The node's scope. Similar to other nodes,
	 * the selected scope influences the behavior of the node and what type of code is generated.
	 */ constructor(scope = $03ccd63b0299d6a7$export$ab88ac7b14637396.DEFAULT){
        super();
        /**
		 * The node's scope. Similar to other nodes, the selected scope influences
		 * the behavior of the node and what type of code is generated.
		 *
		 * @type {('default'|'hardware'|'alphaToCoverage')}
		 */ this.scope = scope;
    }
    /**
	 * Setups the node depending on the selected scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The result node.
	 */ setup(builder) {
        super.setup(builder);
        const clippingContext = builder.clippingContext;
        const { intersectionPlanes: intersectionPlanes, unionPlanes: unionPlanes } = clippingContext;
        this.hardwareClipping = builder.material.hardwareClipping;
        if (this.scope === $03ccd63b0299d6a7$export$ab88ac7b14637396.ALPHA_TO_COVERAGE) return this.setupAlphaToCoverage(intersectionPlanes, unionPlanes);
        else if (this.scope === $03ccd63b0299d6a7$export$ab88ac7b14637396.HARDWARE) return this.setupHardwareClipping(unionPlanes, builder);
        else return this.setupDefault(intersectionPlanes, unionPlanes);
    }
    /**
	 * Setups alpha to coverage.
	 *
	 * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @return {Node} The result node.
	 */ setupAlphaToCoverage(intersectionPlanes, unionPlanes) {
        return $03ccd63b0299d6a7$var$Fn(()=>{
            const distanceToPlane = $03ccd63b0299d6a7$var$float().toVar('distanceToPlane');
            const distanceGradient = $03ccd63b0299d6a7$var$float().toVar('distanceToGradient');
            const clipOpacity = $03ccd63b0299d6a7$var$float(1).toVar('clipOpacity');
            const numUnionPlanes = unionPlanes.length;
            if (this.hardwareClipping === false && numUnionPlanes > 0) {
                const clippingPlanes = $03ccd63b0299d6a7$var$uniformArray(unionPlanes).setGroup($03ccd63b0299d6a7$var$renderGroup);
                $03ccd63b0299d6a7$var$Loop(numUnionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    distanceToPlane.assign($03ccd63b0299d6a7$var$positionView.dot(plane.xyz).negate().add(plane.w));
                    distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                    clipOpacity.mulAssign($03ccd63b0299d6a7$var$smoothstep(distanceGradient.negate(), distanceGradient, distanceToPlane));
                });
            }
            const numIntersectionPlanes = intersectionPlanes.length;
            if (numIntersectionPlanes > 0) {
                const clippingPlanes = $03ccd63b0299d6a7$var$uniformArray(intersectionPlanes).setGroup($03ccd63b0299d6a7$var$renderGroup);
                const intersectionClipOpacity = $03ccd63b0299d6a7$var$float(1).toVar('intersectionClipOpacity');
                $03ccd63b0299d6a7$var$Loop(numIntersectionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    distanceToPlane.assign($03ccd63b0299d6a7$var$positionView.dot(plane.xyz).negate().add(plane.w));
                    distanceGradient.assign(distanceToPlane.fwidth().div(2.0));
                    intersectionClipOpacity.mulAssign($03ccd63b0299d6a7$var$smoothstep(distanceGradient.negate(), distanceGradient, distanceToPlane).oneMinus());
                });
                clipOpacity.mulAssign(intersectionClipOpacity.oneMinus());
            }
            $03ccd63b0299d6a7$var$diffuseColor.a.mulAssign(clipOpacity);
            $03ccd63b0299d6a7$var$diffuseColor.a.equal(0.0).discard();
        })();
    }
    /**
	 * Setups the default clipping.
	 *
	 * @param {Array<Vector4>} intersectionPlanes - The intersection planes.
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @return {Node} The result node.
	 */ setupDefault(intersectionPlanes, unionPlanes) {
        return $03ccd63b0299d6a7$var$Fn(()=>{
            const numUnionPlanes = unionPlanes.length;
            if (this.hardwareClipping === false && numUnionPlanes > 0) {
                const clippingPlanes = $03ccd63b0299d6a7$var$uniformArray(unionPlanes).setGroup($03ccd63b0299d6a7$var$renderGroup);
                $03ccd63b0299d6a7$var$Loop(numUnionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    $03ccd63b0299d6a7$var$positionView.dot(plane.xyz).greaterThan(plane.w).discard();
                });
            }
            const numIntersectionPlanes = intersectionPlanes.length;
            if (numIntersectionPlanes > 0) {
                const clippingPlanes = $03ccd63b0299d6a7$var$uniformArray(intersectionPlanes).setGroup($03ccd63b0299d6a7$var$renderGroup);
                const clipped = $03ccd63b0299d6a7$var$bool(true).toVar('clipped');
                $03ccd63b0299d6a7$var$Loop(numIntersectionPlanes, ({ i: i })=>{
                    const plane = clippingPlanes.element(i);
                    clipped.assign($03ccd63b0299d6a7$var$positionView.dot(plane.xyz).greaterThan(plane.w).and(clipped));
                });
                clipped.discard();
            }
        })();
    }
    /**
	 * Setups hardware clipping.
	 *
	 * @param {Array<Vector4>} unionPlanes - The union planes.
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The result node.
	 */ setupHardwareClipping(unionPlanes, builder) {
        const numUnionPlanes = unionPlanes.length;
        builder.enableHardwareClipping(numUnionPlanes);
        return $03ccd63b0299d6a7$var$Fn(()=>{
            const clippingPlanes = $03ccd63b0299d6a7$var$uniformArray(unionPlanes).setGroup($03ccd63b0299d6a7$var$renderGroup);
            const hw_clip_distances = $03ccd63b0299d6a7$var$builtin(builder.getClipDistance());
            $03ccd63b0299d6a7$var$Loop(numUnionPlanes, ({ i: i })=>{
                const plane = clippingPlanes.element(i);
                const distance = $03ccd63b0299d6a7$var$positionView.dot(plane.xyz).sub(plane.w).negate();
                hw_clip_distances.element(i).assign(distance);
            });
        })();
    }
}
$03ccd63b0299d6a7$export$ab88ac7b14637396.ALPHA_TO_COVERAGE = 'alphaToCoverage';
$03ccd63b0299d6a7$export$ab88ac7b14637396.DEFAULT = 'default';
$03ccd63b0299d6a7$export$ab88ac7b14637396.HARDWARE = 'hardware';
/**
 * TSL function for setting up the default clipping logic.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $03ccd63b0299d6a7$var$clipping = ()=>new $03ccd63b0299d6a7$export$ab88ac7b14637396();
/**
 * TSL function for setting up alpha to coverage.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $03ccd63b0299d6a7$var$clippingAlpha = ()=>new $03ccd63b0299d6a7$export$ab88ac7b14637396($03ccd63b0299d6a7$export$ab88ac7b14637396.ALPHA_TO_COVERAGE);
/**
 * TSL function for setting up hardware-based clipping.
 *
 * @tsl
 * @function
 * @returns {ClippingNode}
 */ const $03ccd63b0299d6a7$var$hardwareClipping = ()=>new $03ccd63b0299d6a7$export$ab88ac7b14637396($03ccd63b0299d6a7$export$ab88ac7b14637396.HARDWARE);
// See: https://casual-effects.com/research/Wyman2017Hashed/index.html
const $03ccd63b0299d6a7$var$ALPHA_HASH_SCALE = 0.05; // Derived from trials only, and may be changed.
const $03ccd63b0299d6a7$var$hash2D = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([value])=>{
    return $03ccd63b0299d6a7$var$fract($03ccd63b0299d6a7$var$mul(1.0e4, $03ccd63b0299d6a7$var$sin($03ccd63b0299d6a7$var$mul(17.0, value.x).add($03ccd63b0299d6a7$var$mul(0.1, value.y)))).mul($03ccd63b0299d6a7$var$add(0.1, $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sin($03ccd63b0299d6a7$var$mul(13.0, value.y).add(value.x))))));
});
const $03ccd63b0299d6a7$var$hash3D = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([value])=>{
    return $03ccd63b0299d6a7$var$hash2D($03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$hash2D(value.xy), value.z));
});
const $03ccd63b0299d6a7$var$getAlphaHashThreshold = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([position])=>{
    // Find the discretized derivatives of our coordinates
    const maxDeriv = $03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$length($03ccd63b0299d6a7$var$dFdx(position.xyz)), $03ccd63b0299d6a7$var$length($03ccd63b0299d6a7$var$dFdy(position.xyz)));
    const pixScale = $03ccd63b0299d6a7$var$float(1).div($03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$ALPHA_HASH_SCALE).mul(maxDeriv)).toVar('pixScale');
    // Find two nearest log-discretized noise scales
    const pixScales = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$exp2($03ccd63b0299d6a7$var$floor($03ccd63b0299d6a7$var$log2(pixScale))), $03ccd63b0299d6a7$var$exp2($03ccd63b0299d6a7$var$ceil($03ccd63b0299d6a7$var$log2(pixScale))));
    // Compute alpha thresholds at our two noise scales
    const alpha = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$hash3D($03ccd63b0299d6a7$var$floor(pixScales.x.mul(position.xyz))), $03ccd63b0299d6a7$var$hash3D($03ccd63b0299d6a7$var$floor(pixScales.y.mul(position.xyz))));
    // Factor to interpolate lerp with
    const lerpFactor = $03ccd63b0299d6a7$var$fract($03ccd63b0299d6a7$var$log2(pixScale));
    // Interpolate alpha threshold from noise at two scales
    const x = $03ccd63b0299d6a7$var$add($03ccd63b0299d6a7$var$mul(lerpFactor.oneMinus(), alpha.x), $03ccd63b0299d6a7$var$mul(lerpFactor, alpha.y));
    // Pass into CDF to compute uniformly distrib threshold
    const a = $03ccd63b0299d6a7$var$min$1(lerpFactor, lerpFactor.oneMinus());
    const cases = $03ccd63b0299d6a7$var$vec3(x.mul(x).div($03ccd63b0299d6a7$var$mul(2.0, a).mul($03ccd63b0299d6a7$var$sub(1.0, a))), x.sub($03ccd63b0299d6a7$var$mul(0.5, a)).div($03ccd63b0299d6a7$var$sub(1.0, a)), $03ccd63b0299d6a7$var$sub(1.0, $03ccd63b0299d6a7$var$sub(1.0, x).mul($03ccd63b0299d6a7$var$sub(1.0, x)).div($03ccd63b0299d6a7$var$mul(2.0, a).mul($03ccd63b0299d6a7$var$sub(1.0, a)))));
    // Find our final, uniformly distributed alpha threshold (ατ)
    const threshold = x.lessThan(a.oneMinus()).select(x.lessThan(a).select(cases.x, cases.y), cases.z);
    // Avoids ατ == 0. Could also do ατ =1-ατ
    return $03ccd63b0299d6a7$var$clamp(threshold, 1.0e-6, 1.0);
}).setLayout({
    name: 'getAlphaHashThreshold',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec3'
        }
    ]
});
/**
 * An attribute node for representing vertex colors.
 *
 * @augments AttributeNode
 */ class $03ccd63b0299d6a7$export$b7d0e1b17d89bc37 extends $03ccd63b0299d6a7$export$dc88047a888cd46b {
    static get type() {
        return 'VertexColorNode';
    }
    /**
	 * Constructs a new vertex color node.
	 *
	 * @param {number} index - The attribute index.
	 */ constructor(index){
        super(null, 'vec4');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVertexColorNode = true;
        /**
		 * The attribute index to enable more than one sets of vertex colors.
		 *
		 * @type {number}
		 * @default 0
		 */ this.index = index;
    }
    /**
	 * Overwrites the default implementation by honoring the attribute index.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The attribute name.
	 */ getAttributeName() {
        const index = this.index;
        return 'color' + (index > 0 ? index : '');
    }
    generate(builder) {
        const attributeName = this.getAttributeName(builder);
        const geometryAttribute = builder.hasGeometryAttribute(attributeName);
        let result;
        if (geometryAttribute === true) result = super.generate(builder);
        else // Vertex color fallback should be white
        result = builder.generateConst(this.nodeType, new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(1, 1, 1, 1));
        return result;
    }
    serialize(data) {
        super.serialize(data);
        data.index = this.index;
    }
    deserialize(data) {
        super.deserialize(data);
        this.index = data.index;
    }
}
/**
 * TSL function for creating a reference node.
 *
 * @tsl
 * @function
 * @param {number} [index=0] - The attribute index.
 * @returns {VertexColorNode}
 */ const $03ccd63b0299d6a7$var$vertexColor = (index = 0)=>new $03ccd63b0299d6a7$export$b7d0e1b17d89bc37(index);
/**
 * Represents a "Color Burn" blend mode.
 *
 * It's designed to darken the base layer's colors based on the color of the blend layer.
 * It significantly increases the contrast of the base layer, making the colors more vibrant and saturated.
 * The darker the color in the blend layer, the stronger the darkening and contrast effect on the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A white (#ffffff) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $03ccd63b0299d6a7$var$blendBurn = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([base, blend])=>{
    return $03ccd63b0299d6a7$var$min$1(1.0, base.oneMinus().div(blend)).oneMinus();
}).setLayout({
    name: 'blendBurn',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Color Dodge" blend mode.
 *
 * It's designed to lighten the base layer's colors based on the color of the blend layer.
 * It significantly increases the brightness of the base layer, making the colors lighter and more vibrant.
 * The brighter the color in the blend layer, the stronger the lightening and contrast effect on the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A black (#000000) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $03ccd63b0299d6a7$var$blendDodge = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([base, blend])=>{
    return $03ccd63b0299d6a7$var$min$1(base.div(blend.oneMinus()), 1.0);
}).setLayout({
    name: 'blendDodge',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Screen" blend mode.
 *
 * Similar to `blendDodge()`, this mode also lightens the base layer's colors based on the color of the blend layer.
 * The "Screen" blend mode is better for general brightening whereas the "Dodge" results in more subtle and nuanced
 * effects.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color. A black (#000000) blend color does not alter the base color.
 * @return {Node<vec3>} The result.
 */ const $03ccd63b0299d6a7$var$blendScreen = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([base, blend])=>{
    return base.oneMinus().mul(blend.oneMinus()).oneMinus();
}).setLayout({
    name: 'blendScreen',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * Represents a "Overlay" blend mode.
 *
 * It's designed to increase the contrast of the base layer based on the color of the blend layer.
 * It amplifies the existing colors and contrast in the base layer, making lighter areas lighter and darker areas darker.
 * The color of the blend layer significantly influences the resulting contrast and color shift in the base layer.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} base - The base color.
 * @param {Node<vec3>} blend - The blend color
 * @return {Node<vec3>} The result.
 */ const $03ccd63b0299d6a7$var$blendOverlay = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([base, blend])=>{
    return $03ccd63b0299d6a7$var$mix(base.mul(2.0).mul(blend), base.oneMinus().mul(2.0).mul(blend.oneMinus()).oneMinus(), $03ccd63b0299d6a7$var$step(0.5, base));
}).setLayout({
    name: 'blendOverlay',
    type: 'vec3',
    inputs: [
        {
            name: 'base',
            type: 'vec3'
        },
        {
            name: 'blend',
            type: 'vec3'
        }
    ]
});
/**
 * This function blends two color based on their alpha values by replicating the behavior of `THREE.NormalBlending`.
 * It assumes both input colors have non-premultiplied alpha.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} base - The base color.
 * @param {Node<vec4>} blend - The blend color
 * @return {Node<vec4>} The result.
 */ const $03ccd63b0299d6a7$var$blendColor = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([base, blend])=>{
    const outAlpha = blend.a.add(base.a.mul(blend.a.oneMinus()));
    return $03ccd63b0299d6a7$var$vec4(blend.rgb.mul(blend.a).add(base.rgb.mul(base.a).mul(blend.a.oneMinus())).div(outAlpha), outAlpha);
}).setLayout({
    name: 'blendColor',
    type: 'vec4',
    inputs: [
        {
            name: 'base',
            type: 'vec4'
        },
        {
            name: 'blend',
            type: 'vec4'
        }
    ]
});
/**
 * Premultiplies the RGB channels of a color by its alpha channel.
 *
 * This function is useful for converting a non-premultiplied alpha color
 * into a premultiplied alpha format, where the RGB values are scaled
 * by the alpha value. Premultiplied alpha is often used in graphics
 * rendering for certain operations, such as compositing and image processing.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color - The input color with non-premultiplied alpha.
 * @return {Node<vec4>} The color with premultiplied alpha.
 */ const $03ccd63b0299d6a7$var$premultiplyAlpha = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    return $03ccd63b0299d6a7$var$vec4(color.rgb.mul(color.a), color.a);
}, {
    color: 'vec4',
    return: 'vec4'
});
/**
 * Unpremultiplies the RGB channels of a color by its alpha channel.
 *
 * This function is useful for converting a premultiplied alpha color
 * back into a non-premultiplied alpha format, where the RGB values are
 * divided by the alpha value. Unpremultiplied alpha is often used in graphics
 * rendering for certain operations, such as compositing and image processing.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color - The input color with premultiplied alpha.
 * @return {Node<vec4>} The color with non-premultiplied alpha.
 */ const $03ccd63b0299d6a7$var$unpremultiplyAlpha = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    $03ccd63b0299d6a7$var$If(color.a.equal(0.0), ()=>$03ccd63b0299d6a7$var$vec4(0.0));
    return $03ccd63b0299d6a7$var$vec4(color.rgb.div(color.a), color.a);
}, {
    color: 'vec4',
    return: 'vec4'
});
/**
 * Base class for all node materials.
 *
 * @augments Material
 */ class $03ccd63b0299d6a7$export$caaf3b30a544c946 extends (0, $9ddd7e9b53f7a2d4$export$a2d8b23205c25948) {
    static get type() {
        return 'NodeMaterial';
    }
    /**
	 * Represents the type of the node material.
	 *
	 * @type {string}
	 */ get type() {
        return this.constructor.type;
    }
    set type(_value) {}
    /**
	 * Constructs a new node material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeMaterial = true;
        /**
		 * Whether this material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        /**
		 * Whether this material is affected by lights or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Whether this material uses hardware clipping or not.
		 * This property is managed by the engine and should not be
		 * modified by apps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.hardwareClipping = false;
        /**
		 * Node materials which set their `lights` property to `true`
		 * are affected by all lights of the scene. Sometimes selective
		 * lighting is wanted which means only _some_ lights in the scene
		 * affect a material. This can be achieved by creating an instance
		 * of {@link LightsNode} with a list of selective
		 * lights and assign the node to this property.
		 *
		 * ```js
		 * const customLightsNode = lights( [ light1, light2 ] );
		 * material.lightsNode = customLightsNode;
		 * ```
		 *
		 * @type {?LightsNode}
		 * @default null
		 */ this.lightsNode = null;
        /**
		 * The environment of node materials can be defined by an environment
		 * map assigned to the `envMap` property or by `Scene.environment`
		 * if the node material is a PBR material. This node property allows to overwrite
		 * the default behavior and define the environment with a custom node.
		 *
		 * ```js
		 * material.envNode = pmremTexture( renderTarget.texture );
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.envNode = null;
        /**
		 * The lighting of node materials might be influenced by ambient occlusion.
		 * The default AO is inferred from an ambient occlusion map assigned to `aoMap`
		 * and the respective `aoMapIntensity`. This node property allows to overwrite
		 * the default and define the ambient occlusion with a custom node instead.
		 *
		 * If you don't want to overwrite the diffuse color but modify the existing
		 * values instead, use {@link materialAO}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.aoNode = null;
        /**
		 * The diffuse color of node materials is by default inferred from the
		 * `color` and `map` properties. This node property allows to overwrite the default
		 * and define the diffuse color with a node instead.
		 *
		 * ```js
		 * material.colorNode = color( 0xff0000 ); // define red color
		 * ```
		 *
		 * If you don't want to overwrite the diffuse color but modify the existing
		 * values instead, use {@link materialColor}.
		 *
		 * ```js
		 * material.colorNode = materialColor.mul( color( 0xff0000 ) ); // give diffuse colors a red tint
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.colorNode = null;
        /**
		 * The normals of node materials are by default inferred from the `normalMap`/`normalScale`
		 * or `bumpMap`/`bumpScale` properties. This node property allows to overwrite the default
		 * and define the normals with a node instead.
		 *
		 * If you don't want to overwrite the normals but modify the existing values instead,
		 * use {@link materialNormal}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.normalNode = null;
        /**
		 * The opacity of node materials is by default inferred from the `opacity`
		 * and `alphaMap` properties. This node property allows to overwrite the default
		 * and define the opacity with a node instead.
		 *
		 * If you don't want to overwrite the opacity but modify the existing
		 * value instead, use {@link materialOpacity}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.opacityNode = null;
        /**
		 * This node can be used to implement a variety of filter-like effects. The idea is
		 * to store the current rendering into a texture e.g. via `viewportSharedTexture()`, use it
		 * to create an arbitrary effect and then assign the node composition to this property.
		 * Everything behind the object using this material will now be affected by a filter.
		 *
		 * ```js
		 * const material = new NodeMaterial()
		 * material.transparent = true;
		 *
		 * // everything behind the object will be monochromatic
		 * material.backdropNode = saturation( viewportSharedTexture().rgb, 0 );
		 * ```
		 *
		 * Backdrop computations are part of the lighting so only lit materials can use this property.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.backdropNode = null;
        /**
		 * This node allows to modulate the influence of `backdropNode` to the outgoing light.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.backdropAlphaNode = null;
        /**
		 * The alpha test of node materials is by default inferred from the `alphaTest`
		 * property. This node property allows to overwrite the default and define the
		 * alpha test with a node instead.
		 *
		 * If you don't want to overwrite the alpha test but modify the existing
		 * value instead, use {@link materialAlphaTest}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.alphaTestNode = null;
        /**
		 * Discards the fragment if the mask value is `false`.
		 *
		 * @type {?Node<bool>}
		 * @default null
		 */ this.maskNode = null;
        /**
		 * This node can be used to implement a shadow mask for the material.
		 *
		 * @type {?Node<bool>}
		 * @default null
		 */ this.maskShadowNode = null;
        /**
		 * The local vertex positions are computed based on multiple factors like the
		 * attribute data, morphing or skinning. This node property allows to overwrite
		 * the default and define local vertex positions with nodes instead.
		 *
		 * If you don't want to overwrite the vertex positions but modify the existing
		 * values instead, use {@link positionLocal}.
		 *
		 *```js
		 * material.positionNode = positionLocal.add( displace );
		 * ```
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.positionNode = null;
        /**
		 * This node property is intended for logic which modifies geometry data once or per animation step.
		 * Apps usually place such logic randomly in initialization routines or in the animation loop.
		 * `geometryNode` is intended as a dedicated API so there is an intended spot where geometry modifications
		 * can be implemented.
		 *
		 * The idea is to assign a `Fn` definition that holds the geometry modification logic. A typical example
		 * would be a GPU based particle system that provides a node material for usage on app level. The particle
		 * simulation would be implemented as compute shaders and managed inside a `Fn` function. This function is
		 * eventually assigned to `geometryNode`.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.geometryNode = null;
        /**
		 * Allows to overwrite depth values in the fragment shader.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.depthNode = null;
        /**
		 * Allows to overwrite the position used for shadow map rendering which
		 * is by default {@link positionWorld}, the vertex position
		 * in world space.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.receivedShadowPositionNode = null;
        /**
		 * Allows to overwrite the geometry position used for shadow map projection which
		 * is by default {@link positionLocal}, the vertex position in local space.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.castShadowPositionNode = null;
        /**
		 * This node can be used to influence how an object using this node material
		 * receive shadows.
		 *
		 * ```js
		 * const totalShadows = float( 1 ).toVar();
		 * material.receivedShadowNode = Fn( ( [ shadow ] ) => {
		 * 	totalShadows.mulAssign( shadow );
		 * 	//return float( 1 ); // bypass received shadows
		 * 	return shadow.mix( color( 0xff0000 ), 1 ); // modify shadow color
		 * } );
		 *
		 * @type {?(Function|FunctionNode<vec4>)}
		 * @default null
		 */ this.receivedShadowNode = null;
        /**
		 * This node can be used to influence how an object using this node material
		 * casts shadows. To apply a color to shadows, you can simply do:
		 *
		 * ```js
		 * material.castShadowNode = vec4( 1, 0, 0, 1 );
		 * ```
		 *
		 * Which can be nice to fake colored shadows of semi-transparent objects. It
		 * is also common to use the property with `Fn` function so checks are performed
		 * per fragment.
		 *
		 * ```js
		 * materialCustomShadow.castShadowNode = Fn( () => {
		 * 	hash( vertexIndex ).greaterThan( 0.5 ).discard();
		 * 	return materialColor;
		 * } )();
		 *  ```
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.castShadowNode = null;
        /**
		 * This node can be used to define the final output of the material.
		 *
		 * TODO: Explain the differences to `fragmentNode`.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.outputNode = null;
        /**
		 * MRT configuration is done on renderer or pass level. This node allows to
		 * overwrite what values are written into MRT targets on material level. This
		 * can be useful for implementing selective FX features that should only affect
		 * specific objects.
		 *
		 * @type {?MRTNode}
		 * @default null
		 */ this.mrtNode = null;
        /**
		 * This node property can be used if you need complete freedom in implementing
		 * the fragment shader. Assigning a node will replace the built-in material
		 * logic used in the fragment stage.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.fragmentNode = null;
        /**
		 * This node property can be used if you need complete freedom in implementing
		 * the vertex shader. Assigning a node will replace the built-in material logic
		 * used in the vertex stage.
		 *
		 * @type {?Node<vec4>}
		 * @default null
		 */ this.vertexNode = null;
        /**
		 * This node can be used as a global context management component for this material.
		 *
		 * @type {?ContextNode}
		 * @default null
		 */ this.contextNode = null;
    }
    /**
	 * Returns an array of child nodes for this material.
	 *
	 * @private
	 * @returns {Array<{property: string, childNode: Node}>}
	 */ _getNodeChildren() {
        const children = [];
        for (const property of Object.getOwnPropertyNames(this)){
            if (property.startsWith('_') === true) continue;
            const object = this[property];
            if (object && object.isNode === true) children.push({
                property: property,
                childNode: object
            });
        }
        return children;
    }
    /**
	 * Allows to define a custom cache key that influence the material key computation
	 * for render objects.
	 *
	 * @return {string} The custom cache key.
	 */ customProgramCacheKey() {
        const values = [];
        for (const { property: property, childNode: childNode } of this._getNodeChildren())values.push($03ccd63b0299d6a7$var$hashString(property.slice(0, -4)), childNode.getCacheKey());
        return this.type + $03ccd63b0299d6a7$var$hashArray(values);
    }
    /**
	 * Builds this material with the given node builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ build(builder) {
        this.setup(builder);
    }
    /**
	 * Setups a node material observer with the given builder.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeMaterialObserver} The node material observer.
	 */ setupObserver(builder) {
        return new $03ccd63b0299d6a7$export$4f65c0b4ff530286(builder);
    }
    /**
	 * Setups the vertex and fragment stage of this node material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        builder.context.setupNormal = ()=>$03ccd63b0299d6a7$var$subBuild(this.setupNormal(builder), 'NORMAL', 'vec3');
        builder.context.setupPositionView = ()=>this.setupPositionView(builder);
        builder.context.setupModelViewProjection = ()=>this.setupModelViewProjection(builder);
        const renderer = builder.renderer;
        const renderTarget = renderer.getRenderTarget();
        // < VERTEX STAGE >
        builder.addStack();
        const mvp = this.setupVertex(builder);
        const vertexNode = $03ccd63b0299d6a7$var$subBuild(this.vertexNode || mvp, 'VERTEX');
        builder.context.clipSpace = vertexNode;
        builder.stack.outputNode = vertexNode;
        this.setupHardwareClipping(builder);
        if (this.geometryNode !== null) builder.stack.outputNode = builder.stack.outputNode.bypass(this.geometryNode);
        builder.addFlow('vertex', builder.removeStack());
        // < FRAGMENT STAGE >
        builder.addStack();
        let resultNode;
        const clippingNode = this.setupClipping(builder);
        if (this.depthWrite === true || this.depthTest === true) {
            // only write depth if depth buffer is configured
            if (renderTarget !== null) {
                if (renderTarget.depthBuffer === true) this.setupDepth(builder);
            } else if (renderer.depth === true) this.setupDepth(builder);
        }
        if (this.fragmentNode === null) {
            this.setupDiffuseColor(builder);
            this.setupVariants(builder);
            const outgoingLightNode = this.setupLighting(builder);
            if (clippingNode !== null) builder.stack.addToStack(clippingNode);
            // force unsigned floats - useful for RenderTargets
            const basicOutput = $03ccd63b0299d6a7$var$vec4(outgoingLightNode, $03ccd63b0299d6a7$var$diffuseColor.a).max(0);
            resultNode = this.setupOutput(builder, basicOutput);
            // OUTPUT NODE
            $03ccd63b0299d6a7$var$output.assign(resultNode);
            //
            const isCustomOutput = this.outputNode !== null;
            if (isCustomOutput) resultNode = this.outputNode;
            //
            if (builder.context.getOutput) resultNode = builder.context.getOutput(resultNode, builder);
            // MRT
            if (renderTarget !== null) {
                const mrt = renderer.getMRT();
                const materialMRT = this.mrtNode;
                if (mrt !== null) {
                    if (isCustomOutput) $03ccd63b0299d6a7$var$output.assign(resultNode);
                    resultNode = mrt;
                    if (materialMRT !== null) resultNode = mrt.merge(materialMRT);
                } else if (materialMRT !== null) resultNode = materialMRT;
            }
        } else {
            let fragmentNode = this.fragmentNode;
            if (fragmentNode.isOutputStructNode !== true) fragmentNode = $03ccd63b0299d6a7$var$vec4(fragmentNode);
            resultNode = this.setupOutput(builder, fragmentNode);
        }
        builder.stack.outputNode = resultNode;
        builder.addFlow('fragment', builder.removeStack());
        // < OBSERVER >
        builder.observer = this.setupObserver(builder);
    }
    /**
	 * Setups the clipping node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {ClippingNode} The clipping node.
	 */ setupClipping(builder) {
        if (builder.clippingContext === null) return null;
        const { unionPlanes: unionPlanes, intersectionPlanes: intersectionPlanes } = builder.clippingContext;
        let result = null;
        if (unionPlanes.length > 0 || intersectionPlanes.length > 0) {
            const samples = builder.renderer.currentSamples;
            if (this.alphaToCoverage && samples > 1) // to be added to flow when the color/alpha value has been determined
            result = $03ccd63b0299d6a7$var$clippingAlpha();
            else builder.stack.addToStack($03ccd63b0299d6a7$var$clipping());
        }
        return result;
    }
    /**
	 * Setups the hardware clipping if available on the current device.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupHardwareClipping(builder) {
        this.hardwareClipping = false;
        if (builder.clippingContext === null) return;
        const candidateCount = builder.clippingContext.unionPlanes.length;
        // 8 planes supported by WebGL ANGLE_clip_cull_distance and WebGPU clip-distances
        if (candidateCount > 0 && candidateCount <= 8 && builder.isAvailable('clipDistance')) {
            builder.stack.addToStack($03ccd63b0299d6a7$var$hardwareClipping());
            this.hardwareClipping = true;
        }
        return;
    }
    /**
	 * Setups the depth of this material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupDepth(builder) {
        const { renderer: renderer, camera: camera } = builder;
        // Depth
        let depthNode = this.depthNode;
        if (depthNode === null) {
            const mrt = renderer.getMRT();
            if (mrt && mrt.has('depth')) depthNode = mrt.get('depth');
            else if (renderer.logarithmicDepthBuffer === true) {
                if (camera.isPerspectiveCamera) depthNode = $03ccd63b0299d6a7$var$viewZToLogarithmicDepth($03ccd63b0299d6a7$var$positionView.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
                else depthNode = $03ccd63b0299d6a7$var$viewZToOrthographicDepth($03ccd63b0299d6a7$var$positionView.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar);
            }
        }
        if (depthNode !== null) $03ccd63b0299d6a7$var$depth.assign(depthNode).toStack();
    }
    /**
	 * Setups the position node in view space. This method exists
	 * so derived node materials can modify the implementation e.g. sprite materials.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in view space.
	 */ setupPositionView() {
        return $03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$positionLocal).xyz;
    }
    /**
	 * Setups the position in clip space.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The position in view space.
	 */ setupModelViewProjection() {
        return $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul($03ccd63b0299d6a7$var$positionView);
    }
    /**
	 * Setups the logic for the vertex stage.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The position in clip space.
	 */ setupVertex(builder) {
        builder.addStack();
        this.setupPosition(builder);
        builder.context.position = builder.removeStack();
        return $03ccd63b0299d6a7$var$modelViewProjection;
    }
    /**
	 * Setups the computation of the position in local space.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in local space.
	 */ setupPosition(builder) {
        const { object: object, geometry: geometry } = builder;
        if (geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color) $03ccd63b0299d6a7$var$morphReference(object).toStack();
        if (object.isSkinnedMesh === true) $03ccd63b0299d6a7$var$skinning(object).toStack();
        if (this.displacementMap) {
            const displacementMap = $03ccd63b0299d6a7$var$materialReference('displacementMap', 'texture');
            const displacementScale = $03ccd63b0299d6a7$var$materialReference('displacementScale', 'float');
            const displacementBias = $03ccd63b0299d6a7$var$materialReference('displacementBias', 'float');
            $03ccd63b0299d6a7$var$positionLocal.addAssign($03ccd63b0299d6a7$var$normalLocal.normalize().mul(displacementMap.x.mul(displacementScale).add(displacementBias)));
        }
        if (object.isBatchedMesh) $03ccd63b0299d6a7$var$batch(object).toStack();
        if (object.isInstancedMesh && object.instanceMatrix && object.instanceMatrix.isInstancedBufferAttribute === true) $03ccd63b0299d6a7$var$instancedMesh(object).toStack();
        if (this.positionNode !== null) $03ccd63b0299d6a7$var$positionLocal.assign($03ccd63b0299d6a7$var$subBuild(this.positionNode, 'POSITION', 'vec3'));
        return $03ccd63b0299d6a7$var$positionLocal;
    }
    /**
	 * Setups the computation of the material's diffuse color.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {BufferGeometry} geometry - The geometry.
	 */ setupDiffuseColor(builder) {
        const { object: object, geometry: geometry } = builder;
        // MASK
        if (this.maskNode !== null) // Discard if the mask is `false`
        $03ccd63b0299d6a7$var$bool(this.maskNode).not().discard();
        // COLOR
        let colorNode = this.colorNode ? $03ccd63b0299d6a7$var$vec4(this.colorNode) : $03ccd63b0299d6a7$var$materialColor;
        // VERTEX COLORS
        if (this.vertexColors === true && geometry.hasAttribute('color')) colorNode = colorNode.mul($03ccd63b0299d6a7$var$vertexColor());
        // INSTANCED COLORS
        if (object.instanceColor) {
            const instanceColor = $03ccd63b0299d6a7$var$varyingProperty('vec3', 'vInstanceColor');
            colorNode = instanceColor.mul(colorNode);
        }
        if (object.isBatchedMesh && object._colorsTexture) {
            const batchColor = $03ccd63b0299d6a7$var$varyingProperty('vec3', 'vBatchColor');
            colorNode = batchColor.mul(colorNode);
        }
        // DIFFUSE COLOR
        $03ccd63b0299d6a7$var$diffuseColor.assign(colorNode);
        // OPACITY
        const opacityNode = this.opacityNode ? $03ccd63b0299d6a7$var$float(this.opacityNode) : $03ccd63b0299d6a7$var$materialOpacity;
        $03ccd63b0299d6a7$var$diffuseColor.a.assign($03ccd63b0299d6a7$var$diffuseColor.a.mul(opacityNode));
        // ALPHA TEST
        let alphaTestNode = null;
        if (this.alphaTestNode !== null || this.alphaTest > 0) {
            alphaTestNode = this.alphaTestNode !== null ? $03ccd63b0299d6a7$var$float(this.alphaTestNode) : $03ccd63b0299d6a7$var$materialAlphaTest;
            if (this.alphaToCoverage === true) {
                $03ccd63b0299d6a7$var$diffuseColor.a = $03ccd63b0299d6a7$var$smoothstep(alphaTestNode, alphaTestNode.add($03ccd63b0299d6a7$var$fwidth($03ccd63b0299d6a7$var$diffuseColor.a)), $03ccd63b0299d6a7$var$diffuseColor.a);
                $03ccd63b0299d6a7$var$diffuseColor.a.lessThanEqual(0).discard();
            } else $03ccd63b0299d6a7$var$diffuseColor.a.lessThanEqual(alphaTestNode).discard();
        }
        // ALPHA HASH
        if (this.alphaHash === true) $03ccd63b0299d6a7$var$diffuseColor.a.lessThan($03ccd63b0299d6a7$var$getAlphaHashThreshold($03ccd63b0299d6a7$var$positionLocal)).discard();
        // OPAQUE
        if (builder.isOpaque()) $03ccd63b0299d6a7$var$diffuseColor.a.assign(1.0);
    }
    /**
	 * Abstract interface method that can be implemented by derived materials
	 * to setup material-specific node variables.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
    // Interface function.
    }
    /**
	 * Setups the outgoing light node variable
	 *
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupOutgoingLight() {
        return this.lights === true ? $03ccd63b0299d6a7$var$vec3(0) : $03ccd63b0299d6a7$var$diffuseColor.rgb;
    }
    /**
	 * Setups the normal node from the material.
	 *
	 * @return {Node<vec3>} The normal node.
	 */ setupNormal() {
        return this.normalNode ? $03ccd63b0299d6a7$var$vec3(this.normalNode) : $03ccd63b0299d6a7$var$materialNormal;
    }
    /**
	 * Setups the environment node from the material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec4>} The environment node.
	 */ setupEnvironment() {
        let node = null;
        if (this.envNode) node = this.envNode;
        else if (this.envMap) node = this.envMap.isCubeTexture ? $03ccd63b0299d6a7$var$materialReference('envMap', 'cubeTexture') : $03ccd63b0299d6a7$var$materialReference('envMap', 'texture');
        return node;
    }
    /**
	 * Setups the light map node from the material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The light map node.
	 */ setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new $03ccd63b0299d6a7$export$26fe501f8a41ff48($03ccd63b0299d6a7$var$materialLightMap);
        return node;
    }
    /**
	 * Setups the lights node based on the scene, environment and material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {LightsNode} The lights node.
	 */ setupLights(builder) {
        const materialLightsNode = [];
        //
        const envNode = this.setupEnvironment(builder);
        if (envNode && envNode.isLightingNode) materialLightsNode.push(envNode);
        const lightMapNode = this.setupLightMap(builder);
        if (lightMapNode && lightMapNode.isLightingNode) materialLightsNode.push(lightMapNode);
        let aoNode = this.aoNode;
        if (aoNode === null && builder.material.aoMap) aoNode = $03ccd63b0299d6a7$var$materialAO;
        if (builder.context.getAO) aoNode = builder.context.getAO(aoNode, builder);
        if (aoNode) materialLightsNode.push(new $03ccd63b0299d6a7$export$91e1d32e5b48fb53(aoNode));
        let lightsN = this.lightsNode || builder.lightsNode;
        if (materialLightsNode.length > 0) lightsN = builder.renderer.lighting.createNode([
            ...lightsN.getLights(),
            ...materialLightsNode
        ]);
        return lightsN;
    }
    /**
	 * This method should be implemented by most derived materials
	 * since it defines the material's lighting model.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {LightingModel} The lighting model.
	 */ setupLightingModel() {
    // Interface function.
    }
    /**
	 * Setups the outgoing light node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupLighting(builder) {
        const { material: material } = builder;
        const { backdropNode: backdropNode, backdropAlphaNode: backdropAlphaNode, emissiveNode: emissiveNode } = this;
        // OUTGOING LIGHT
        const lights = this.lights === true || this.lightsNode !== null;
        const lightsNode = lights ? this.setupLights(builder) : null;
        let outgoingLightNode = this.setupOutgoingLight(builder);
        if (lightsNode && lightsNode.getScope().hasLights) {
            const lightingModel = this.setupLightingModel(builder) || null;
            outgoingLightNode = $03ccd63b0299d6a7$var$lightingContext(lightsNode, lightingModel, backdropNode, backdropAlphaNode);
        } else if (backdropNode !== null) outgoingLightNode = $03ccd63b0299d6a7$var$vec3(backdropAlphaNode !== null ? $03ccd63b0299d6a7$var$mix(outgoingLightNode, backdropNode, backdropAlphaNode) : backdropNode);
        // EMISSIVE
        if (emissiveNode && emissiveNode.isNode === true || material.emissive && material.emissive.isColor === true) {
            $03ccd63b0299d6a7$var$emissive.assign($03ccd63b0299d6a7$var$vec3(emissiveNode ? emissiveNode : $03ccd63b0299d6a7$var$materialEmissive));
            outgoingLightNode = outgoingLightNode.add($03ccd63b0299d6a7$var$emissive);
        }
        return outgoingLightNode;
    }
    /**
	 * Setup the fog.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupFog(builder, outputNode) {
        const fogNode = builder.fogNode;
        if (fogNode) {
            $03ccd63b0299d6a7$var$output.assign(outputNode);
            outputNode = $03ccd63b0299d6a7$var$vec4(fogNode.toVar());
        }
        return outputNode;
    }
    /**
	 * Setups premultiplied alpha.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupPremultipliedAlpha(builder, outputNode) {
        return $03ccd63b0299d6a7$var$premultiplyAlpha(outputNode);
    }
    /**
	 * Setups the output node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node<vec4>} outputNode - The existing output node.
	 * @return {Node<vec4>} The output node.
	 */ setupOutput(builder, outputNode) {
        // FOG
        if (this.fog === true) outputNode = this.setupFog(builder, outputNode);
        // PREMULTIPLIED ALPHA
        if (this.premultipliedAlpha === true) outputNode = this.setupPremultipliedAlpha(builder, outputNode);
        return outputNode;
    }
    /**
	 * Most classic material types have a node pendant e.g. for `MeshBasicMaterial`
	 * there is `MeshBasicNodeMaterial`. This utility method is intended for
	 * defining all material properties of the classic type in the node type.
	 *
	 * @param {Material} material - The material to copy properties with their values to this node material.
	 */ setDefaultValues(material) {
        // This approach is to reuse the native refreshUniforms*
        // and turn available the use of features like transmission and environment in core
        for(const property in material){
            const value = material[property];
            if (this[property] === undefined) {
                this[property] = value;
                if (value && value.clone) this[property] = value.clone();
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(material.constructor.prototype);
        for(const key in descriptors)if (Object.getOwnPropertyDescriptor(this.constructor.prototype, key) === undefined && descriptors[key].get !== undefined) Object.defineProperty(this.constructor.prototype, key, descriptors[key]);
    }
    /**
	 * Serializes this material to JSON.
	 *
	 * @param {?(Object|string)} meta - The meta information for serialization.
	 * @return {Object} The serialized node.
	 */ toJSON(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {},
            nodes: {}
        };
        const data = (0, $9ddd7e9b53f7a2d4$export$a2d8b23205c25948).prototype.toJSON.call(this, meta);
        data.inputNodes = {};
        for (const { property: property, childNode: childNode } of this._getNodeChildren())data.inputNodes[property] = childNode.toJSON(meta).uuid;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const nodes = extractFromCache(meta.nodes);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
            if (nodes.length > 0) data.nodes = nodes;
        }
        return data;
    }
    /**
	 * Copies the properties of the given node material to this instance.
	 *
	 * @param {NodeMaterial} source - The material to copy.
	 * @return {NodeMaterial} A reference to this node material.
	 */ copy(source) {
        this.lightsNode = source.lightsNode;
        this.envNode = source.envNode;
        this.aoNode = source.aoNode;
        this.colorNode = source.colorNode;
        this.normalNode = source.normalNode;
        this.opacityNode = source.opacityNode;
        this.backdropNode = source.backdropNode;
        this.backdropAlphaNode = source.backdropAlphaNode;
        this.alphaTestNode = source.alphaTestNode;
        this.maskNode = source.maskNode;
        this.maskShadowNode = source.maskShadowNode;
        this.positionNode = source.positionNode;
        this.geometryNode = source.geometryNode;
        this.depthNode = source.depthNode;
        this.receivedShadowPositionNode = source.receivedShadowPositionNode;
        this.castShadowPositionNode = source.castShadowPositionNode;
        this.receivedShadowNode = source.receivedShadowNode;
        this.castShadowNode = source.castShadowNode;
        this.outputNode = source.outputNode;
        this.mrtNode = source.mrtNode;
        this.fragmentNode = source.fragmentNode;
        this.vertexNode = source.vertexNode;
        this.contextNode = source.contextNode;
        return super.copy(source);
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$d = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$fbaaa33907730a0c)();
/**
 * Node material version of {@link LineBasicMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$511219d03f927a3f extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'LineBasicNodeMaterial';
    }
    /**
	 * Constructs a new line basic node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicNodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$d);
        this.setValues(parameters);
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$c = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$327886a3efaeaebe)();
/**
 * Node material version of  {@link LineDashedMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$19c85750bbe979a0 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'LineDashedNodeMaterial';
    }
    /**
	 * Constructs a new line dashed node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedNodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$c);
        /**
		 * The dash offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.dashOffset = 0;
        /**
		 * The offset of dash materials is by default inferred from the `dashOffset`
		 * property. This node property allows to overwrite the default
		 * and define the offset with a node instead.
		 *
		 * If you don't want to overwrite the offset but modify the existing
		 * value instead, use {@link materialLineDashOffset}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * The scale of dash materials is by default inferred from the `scale`
		 * property. This node property allows to overwrite the default
		 * and define the scale with a node instead.
		 *
		 * If you don't want to overwrite the scale but modify the existing
		 * value instead, use {@link materialLineScale}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashScaleNode = null;
        /**
		 * The dash size of dash materials is by default inferred from the `dashSize`
		 * property. This node property allows to overwrite the default
		 * and define the dash size with a node instead.
		 *
		 * If you don't want to overwrite the dash size but modify the existing
		 * value instead, use {@link materialLineDashSize}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashSizeNode = null;
        /**
		 * The gap size of dash materials is by default inferred from the `gapSize`
		 * property. This node property allows to overwrite the default
		 * and define the gap size with a node instead.
		 *
		 * If you don't want to overwrite the gap size but modify the existing
		 * value instead, use {@link materialLineGapSize}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.gapSizeNode = null;
        this.setValues(parameters);
    }
    /**
	 * Setups the dash specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        const offsetNode = this.offsetNode ? $03ccd63b0299d6a7$var$float(this.offsetNode) : $03ccd63b0299d6a7$var$materialLineDashOffset;
        const dashScaleNode = this.dashScaleNode ? $03ccd63b0299d6a7$var$float(this.dashScaleNode) : $03ccd63b0299d6a7$var$materialLineScale;
        const dashSizeNode = this.dashSizeNode ? $03ccd63b0299d6a7$var$float(this.dashSizeNode) : $03ccd63b0299d6a7$var$materialLineDashSize;
        const gapSizeNode = this.gapSizeNode ? $03ccd63b0299d6a7$var$float(this.gapSizeNode) : $03ccd63b0299d6a7$var$materialLineGapSize;
        $03ccd63b0299d6a7$var$dashSize.assign(dashSizeNode);
        $03ccd63b0299d6a7$var$gapSize.assign(gapSizeNode);
        const vLineDistance = $03ccd63b0299d6a7$var$varying($03ccd63b0299d6a7$var$attribute('lineDistance').mul(dashScaleNode));
        const vLineDistanceOffset = offsetNode ? vLineDistance.add(offsetNode) : vLineDistance;
        vLineDistanceOffset.mod($03ccd63b0299d6a7$var$dashSize.add($03ccd63b0299d6a7$var$gapSize)).greaterThan($03ccd63b0299d6a7$var$dashSize).discard();
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$b = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$327886a3efaeaebe)();
/**
 * This node material can be used to render lines with a size larger than one
 * by representing them as instanced meshes.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$48bba3cc4e1e48d9 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'Line2NodeMaterial';
    }
    /**
	 * Constructs a new node material for wide line rendering.
	 *
	 * @param {Object} [parameters={}] - The configuration parameter.
	 */ constructor(parameters = {}){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine2NodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$b);
        /**
		 * Whether vertex colors should be used or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = parameters.vertexColors;
        /**
		 * The dash offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.dashOffset = 0;
        /**
		 * Defines the lines color.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.lineColorNode = null;
        /**
		 * Defines the offset.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Defines the dash scale.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashScaleNode = null;
        /**
		 * Defines the dash size.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dashSizeNode = null;
        /**
		 * Defines the gap size.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.gapSizeNode = null;
        /**
		 * Blending is set to `NoBlending` since transparency
		 * is not supported, yet.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blending = (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
        this._useDash = parameters.dashed;
        this._useAlphaToCoverage = true;
        this._useWorldUnits = false;
        this.setValues(parameters);
    }
    /**
	 * Setups the vertex and fragment stage of this node material.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        const { renderer: renderer } = builder;
        const useAlphaToCoverage = this._useAlphaToCoverage;
        const vertexColors = this.vertexColors;
        const useDash = this._useDash;
        const useWorldUnits = this._useWorldUnits;
        const trimSegment = $03ccd63b0299d6a7$var$Fn(({ start: start, end: end })=>{
            const a = $03ccd63b0299d6a7$var$cameraProjectionMatrix.element(2).element(2); // 3nd entry in 3th column
            const b = $03ccd63b0299d6a7$var$cameraProjectionMatrix.element(3).element(2); // 3nd entry in 4th column
            const nearEstimate = b.mul(-0.5).div(a);
            const alpha = nearEstimate.sub(start.z).div(end.z.sub(start.z));
            return $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$mix(start.xyz, end.xyz, alpha), end.w);
        }).setLayout({
            name: 'trimSegment',
            type: 'vec4',
            inputs: [
                {
                    name: 'start',
                    type: 'vec4'
                },
                {
                    name: 'end',
                    type: 'vec4'
                }
            ]
        });
        this.vertexNode = $03ccd63b0299d6a7$var$Fn(()=>{
            const instanceStart = $03ccd63b0299d6a7$var$attribute('instanceStart');
            const instanceEnd = $03ccd63b0299d6a7$var$attribute('instanceEnd');
            // camera space
            const start = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec4(instanceStart, 1.0))).toVar('start');
            const end = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec4(instanceEnd, 1.0))).toVar('end');
            if (useDash) {
                const dashScaleNode = this.dashScaleNode ? $03ccd63b0299d6a7$var$float(this.dashScaleNode) : $03ccd63b0299d6a7$var$materialLineScale;
                const offsetNode = this.offsetNode ? $03ccd63b0299d6a7$var$float(this.offsetNode) : $03ccd63b0299d6a7$var$materialLineDashOffset;
                const instanceDistanceStart = $03ccd63b0299d6a7$var$attribute('instanceDistanceStart');
                const instanceDistanceEnd = $03ccd63b0299d6a7$var$attribute('instanceDistanceEnd');
                let lineDistance = $03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(dashScaleNode.mul(instanceDistanceStart), dashScaleNode.mul(instanceDistanceEnd));
                lineDistance = lineDistance.add(offsetNode);
                $03ccd63b0299d6a7$var$varyingProperty('float', 'lineDistance').assign(lineDistance);
            }
            if (useWorldUnits) {
                $03ccd63b0299d6a7$var$varyingProperty('vec3', 'worldStart').assign(start.xyz);
                $03ccd63b0299d6a7$var$varyingProperty('vec3', 'worldEnd').assign(end.xyz);
            }
            const aspect = $03ccd63b0299d6a7$var$viewport.z.div($03ccd63b0299d6a7$var$viewport.w);
            // special case for perspective projection, and segments that terminate either in, or behind, the camera plane
            // clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
            // but we need to perform ndc-space calculations in the shader, so we must address this issue directly
            // perhaps there is a more elegant solution -- WestLangley
            const perspective = $03ccd63b0299d6a7$var$cameraProjectionMatrix.element(2).element(3).equal(-1); // 4th entry in the 3rd column
            $03ccd63b0299d6a7$var$If(perspective, ()=>{
                $03ccd63b0299d6a7$var$If(start.z.lessThan(0.0).and(end.z.greaterThan(0.0)), ()=>{
                    end.assign(trimSegment({
                        start: start,
                        end: end
                    }));
                }).ElseIf(end.z.lessThan(0.0).and(start.z.greaterThanEqual(0.0)), ()=>{
                    start.assign(trimSegment({
                        start: end,
                        end: start
                    }));
                });
            });
            // clip space
            const clipStart = $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul(start);
            const clipEnd = $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul(end);
            // ndc space
            const ndcStart = clipStart.xyz.div(clipStart.w);
            const ndcEnd = clipEnd.xyz.div(clipEnd.w);
            // direction
            const dir = ndcEnd.xy.sub(ndcStart.xy).toVar();
            // account for clip-space aspect ratio
            dir.x.assign(dir.x.mul(aspect));
            dir.assign(dir.normalize());
            const clip = $03ccd63b0299d6a7$var$vec4().toVar();
            if (useWorldUnits) {
                // get the offset direction as perpendicular to the view vector
                const worldDir = end.xyz.sub(start.xyz).normalize();
                const tmpFwd = $03ccd63b0299d6a7$var$mix(start.xyz, end.xyz, 0.5).normalize();
                const worldUp = worldDir.cross(tmpFwd).normalize();
                const worldFwd = worldDir.cross(worldUp);
                const worldPos = $03ccd63b0299d6a7$var$varyingProperty('vec4', 'worldPos');
                worldPos.assign($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(start, end));
                // height offset
                const hw = $03ccd63b0299d6a7$var$materialLineWidth.mul(0.5);
                worldPos.addAssign($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$positionGeometry.x.lessThan(0.0).select(worldUp.mul(hw), worldUp.mul(hw).negate()), 0));
                // don't extend the line if we're rendering dashes because we
                // won't be rendering the endcaps
                if (!useDash) {
                    // cap extension
                    worldPos.addAssign($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(worldDir.mul(hw).negate(), worldDir.mul(hw)), 0));
                    // add width to the box
                    worldPos.addAssign($03ccd63b0299d6a7$var$vec4(worldFwd.mul(hw), 0));
                    // endcaps
                    $03ccd63b0299d6a7$var$If($03ccd63b0299d6a7$var$positionGeometry.y.greaterThan(1.0).or($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.0)), ()=>{
                        worldPos.subAssign($03ccd63b0299d6a7$var$vec4(worldFwd.mul(2.0).mul(hw), 0));
                    });
                }
                // project the worldpos
                clip.assign($03ccd63b0299d6a7$var$cameraProjectionMatrix.mul(worldPos));
                // shift the depth of the projected points so the line
                // segments overlap neatly
                const clipPose = $03ccd63b0299d6a7$var$vec3().toVar();
                clipPose.assign($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(ndcStart, ndcEnd));
                clip.z.assign(clipPose.z.mul(clip.w));
            } else {
                const offset = $03ccd63b0299d6a7$var$vec2(dir.y, dir.x.negate()).toVar('offset');
                // undo aspect ratio adjustment
                dir.x.assign(dir.x.div(aspect));
                offset.x.assign(offset.x.div(aspect));
                // sign flip
                offset.assign($03ccd63b0299d6a7$var$positionGeometry.x.lessThan(0.0).select(offset.negate(), offset));
                // endcaps
                $03ccd63b0299d6a7$var$If($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.0), ()=>{
                    offset.assign(offset.sub(dir));
                }).ElseIf($03ccd63b0299d6a7$var$positionGeometry.y.greaterThan(1.0), ()=>{
                    offset.assign(offset.add(dir));
                });
                // adjust for linewidth
                offset.assign(offset.mul($03ccd63b0299d6a7$var$materialLineWidth));
                // adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
                offset.assign(offset.div($03ccd63b0299d6a7$var$viewport.w.div($03ccd63b0299d6a7$var$screenDPR)));
                // select end
                clip.assign($03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(clipStart, clipEnd));
                // back to clip space
                offset.assign(offset.mul(clip.w));
                clip.assign(clip.add($03ccd63b0299d6a7$var$vec4(offset, 0, 0)));
            }
            return clip;
        })();
        const closestLineToLine = $03ccd63b0299d6a7$var$Fn(({ p1: p1, p2: p2, p3: p3, p4: p4 })=>{
            const p13 = p1.sub(p3);
            const p43 = p4.sub(p3);
            const p21 = p2.sub(p1);
            const d1343 = p13.dot(p43);
            const d4321 = p43.dot(p21);
            const d1321 = p13.dot(p21);
            const d4343 = p43.dot(p43);
            const d2121 = p21.dot(p21);
            const denom = d2121.mul(d4343).sub(d4321.mul(d4321));
            const numer = d1343.mul(d4321).sub(d1321.mul(d4343));
            const mua = numer.div(denom).clamp();
            const mub = d1343.add(d4321.mul(mua)).div(d4343).clamp();
            return $03ccd63b0299d6a7$var$vec2(mua, mub);
        });
        this.colorNode = $03ccd63b0299d6a7$var$Fn(()=>{
            const vUv = $03ccd63b0299d6a7$var$uv$1();
            if (useDash) {
                const dashSizeNode = this.dashSizeNode ? $03ccd63b0299d6a7$var$float(this.dashSizeNode) : $03ccd63b0299d6a7$var$materialLineDashSize;
                const gapSizeNode = this.gapSizeNode ? $03ccd63b0299d6a7$var$float(this.gapSizeNode) : $03ccd63b0299d6a7$var$materialLineGapSize;
                $03ccd63b0299d6a7$var$dashSize.assign(dashSizeNode);
                $03ccd63b0299d6a7$var$gapSize.assign(gapSizeNode);
                const vLineDistance = $03ccd63b0299d6a7$var$varyingProperty('float', 'lineDistance');
                vUv.y.lessThan(-1).or(vUv.y.greaterThan(1.0)).discard(); // discard endcaps
                vLineDistance.mod($03ccd63b0299d6a7$var$dashSize.add($03ccd63b0299d6a7$var$gapSize)).greaterThan($03ccd63b0299d6a7$var$dashSize).discard(); // todo - FIX
            }
            const alpha = $03ccd63b0299d6a7$var$float(1).toVar('alpha');
            if (useWorldUnits) {
                const worldStart = $03ccd63b0299d6a7$var$varyingProperty('vec3', 'worldStart');
                const worldEnd = $03ccd63b0299d6a7$var$varyingProperty('vec3', 'worldEnd');
                // Find the closest points on the view ray and the line segment
                const rayEnd = $03ccd63b0299d6a7$var$varyingProperty('vec4', 'worldPos').xyz.normalize().mul(1e5);
                const lineDir = worldEnd.sub(worldStart);
                const params = closestLineToLine({
                    p1: worldStart,
                    p2: worldEnd,
                    p3: $03ccd63b0299d6a7$var$vec3(0.0, 0.0, 0.0),
                    p4: rayEnd
                });
                const p1 = worldStart.add(lineDir.mul(params.x));
                const p2 = rayEnd.mul(params.y);
                const delta = p1.sub(p2);
                const len = delta.length();
                const norm = len.div($03ccd63b0299d6a7$var$materialLineWidth);
                if (!useDash) {
                    if (useAlphaToCoverage && renderer.currentSamples > 0) {
                        const dnorm = norm.fwidth();
                        alpha.assign($03ccd63b0299d6a7$var$smoothstep(dnorm.negate().add(0.5), dnorm.add(0.5), norm).oneMinus());
                    } else norm.greaterThan(0.5).discard();
                }
            } else // round endcaps
            if (useAlphaToCoverage && renderer.currentSamples > 0) {
                const a = vUv.x;
                const b = vUv.y.greaterThan(0.0).select(vUv.y.sub(1.0), vUv.y.add(1.0));
                const len2 = a.mul(a).add(b.mul(b));
                const dlen = $03ccd63b0299d6a7$var$float(len2.fwidth()).toVar('dlen');
                $03ccd63b0299d6a7$var$If(vUv.y.abs().greaterThan(1.0), ()=>{
                    alpha.assign($03ccd63b0299d6a7$var$smoothstep(dlen.oneMinus(), dlen.add(1), len2).oneMinus());
                });
            } else $03ccd63b0299d6a7$var$If(vUv.y.abs().greaterThan(1.0), ()=>{
                const a = vUv.x;
                const b = vUv.y.greaterThan(0.0).select(vUv.y.sub(1.0), vUv.y.add(1.0));
                const len2 = a.mul(a).add(b.mul(b));
                len2.greaterThan(1.0).discard();
            });
            let lineColorNode;
            if (this.lineColorNode) lineColorNode = this.lineColorNode;
            else if (vertexColors) {
                const instanceColorStart = $03ccd63b0299d6a7$var$attribute('instanceColorStart');
                const instanceColorEnd = $03ccd63b0299d6a7$var$attribute('instanceColorEnd');
                const instanceColor = $03ccd63b0299d6a7$var$positionGeometry.y.lessThan(0.5).select(instanceColorStart, instanceColorEnd);
                lineColorNode = instanceColor.mul($03ccd63b0299d6a7$var$materialColor);
            } else lineColorNode = $03ccd63b0299d6a7$var$materialColor;
            return $03ccd63b0299d6a7$var$vec4(lineColorNode, alpha);
        })();
        if (this.transparent) {
            const opacityNode = this.opacityNode ? $03ccd63b0299d6a7$var$float(this.opacityNode) : $03ccd63b0299d6a7$var$materialOpacity;
            this.outputNode = $03ccd63b0299d6a7$var$vec4(this.colorNode.rgb.mul(opacityNode).add($03ccd63b0299d6a7$var$viewportOpaqueMipTexture().rgb.mul(opacityNode.oneMinus())), this.colorNode.a);
        }
        super.setup(builder);
    }
    /**
	 * Whether the lines should sized in world units or not.
	 * When set to `false` the unit is pixel.
	 *
	 * @type {boolean}
	 * @default false
	 */ get worldUnits() {
        return this._useWorldUnits;
    }
    set worldUnits(value) {
        if (this._useWorldUnits !== value) {
            this._useWorldUnits = value;
            this.needsUpdate = true;
        }
    }
    /**
	 * Whether the lines should be dashed or not.
	 *
	 * @type {boolean}
	 * @default false
	 */ get dashed() {
        return this._useDash;
    }
    set dashed(value) {
        if (this._useDash !== value) {
            this._useDash = value;
            this.needsUpdate = true;
        }
    }
    /**
	 * Whether alpha to coverage should be used or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get alphaToCoverage() {
        return this._useAlphaToCoverage;
    }
    set alphaToCoverage(value) {
        if (this._useAlphaToCoverage !== value) {
            this._useAlphaToCoverage = value;
            this.needsUpdate = true;
        }
    }
    /**
	 * Copies the properties of the given material to this instance.
	 *
	 * @param {Line2NodeMaterial} source - The material to copy.
	 * @return {Line2NodeMaterial} A reference to this material.
	 */ copy(source) {
        super.copy(source);
        this.vertexColors = source.vertexColors;
        this.dashOffset = source.dashOffset;
        this.lineColorNode = source.lineColorNode;
        this.offsetNode = source.offsetNode;
        this.dashScaleNode = source.dashScaleNode;
        this.dashSizeNode = source.dashSizeNode;
        this.gapSizeNode = source.gapSizeNode;
        this._useDash = source._useDash;
        this._useAlphaToCoverage = source._useAlphaToCoverage;
        this._useWorldUnits = source._useWorldUnits;
        return this;
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$a = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$bfe8c0a091f41ae7)();
/**
 * Node material version of {@link MeshNormalMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$57e770545986d2b1 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshNormalNodeMaterial';
    }
    /**
	 * Constructs a new mesh normal node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalNodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$a);
        this.setValues(parameters);
    }
    /**
	 * Overwrites the default implementation by computing the diffuse color
	 * based on the normal data.
	 */ setupDiffuseColor() {
        const opacityNode = this.opacityNode ? $03ccd63b0299d6a7$var$float(this.opacityNode) : $03ccd63b0299d6a7$var$materialOpacity;
        // By convention, a normal packed to RGB is in sRGB color space. Convert it to working color space.
        $03ccd63b0299d6a7$var$diffuseColor.assign($03ccd63b0299d6a7$var$colorSpaceToWorking($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$directionToColor($03ccd63b0299d6a7$var$normalView), opacityNode), (0, $9ddd7e9b53f7a2d4$export$561f394b24edfcaa)));
    }
}
/**
 * TSL function for creating an equirect uv node.
 *
 * Can be used to compute texture coordinates for projecting an
 * equirectangular texture onto a mesh for using it as the scene's
 * background.
 *
 * ```js
 * scene.backgroundNode = texture( equirectTexture, equirectUV() );
 * ```
 *
 * @tsl
 * @function
 * @param {?Node<vec3>} [dirNode=positionWorldDirection] - A direction vector for sampling which is by default `positionWorldDirection`.
 * @returns {Node<vec2>}
 */ const $03ccd63b0299d6a7$var$equirectUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([dir = $03ccd63b0299d6a7$var$positionWorldDirection])=>{
    const u = dir.z.atan(dir.x).mul(1 / (Math.PI * 2)).add(0.5);
    const v = dir.y.clamp(-1, 1.0).asin().mul(1 / Math.PI).add(0.5);
    return $03ccd63b0299d6a7$var$vec2(u, v);
});
/**
 * This class represents a cube render target. It is a special version
 * of `WebGLCubeRenderTarget` which is compatible with `WebGPURenderer`.
 *
 * @augments RenderTarget
 */ class $03ccd63b0299d6a7$export$d4daf84839cea508 extends (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb) {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {CubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture$1) {
        const currentMinFilter = texture$1.minFilter;
        const currentGenerateMipmaps = texture$1.generateMipmaps;
        texture$1.generateMipmaps = true;
        this.texture.type = texture$1.type;
        this.texture.colorSpace = texture$1.colorSpace;
        this.texture.generateMipmaps = texture$1.generateMipmaps;
        this.texture.minFilter = texture$1.minFilter;
        this.texture.magFilter = texture$1.magFilter;
        const geometry = new (0, $9ddd7e9b53f7a2d4$export$33e43285f7406bd5)(5, 5, 5);
        const uvNode = $03ccd63b0299d6a7$var$equirectUV($03ccd63b0299d6a7$var$positionWorldDirection);
        const material = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
        material.colorNode = $03ccd63b0299d6a7$var$texture(texture$1, uvNode, 0);
        material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        material.blending = (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
        const mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(geometry, material);
        const scene = new (0, $9ddd7e9b53f7a2d4$export$38af1803e3442a7f)();
        scene.add(mesh);
        // Avoid blurred poles
        if (texture$1.minFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)) texture$1.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        const camera = new (0, $9ddd7e9b53f7a2d4$export$d0cdd0bd804995de)(1, 10, this);
        const currentMRT = renderer.getMRT();
        renderer.setMRT(null);
        camera.update(renderer, scene);
        renderer.setMRT(currentMRT);
        texture$1.minFilter = currentMinFilter;
        texture$1.generateMipmaps = currentGenerateMipmaps;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $03ccd63b0299d6a7$var$_cache$1 = new WeakMap();
/**
 * This node can be used to automatically convert environment maps in the
 * equirectangular format into the cube map format.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$aa4d2b67403515a extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'CubeMapNode';
    }
    /**
	 * Constructs a new cube map node.
	 *
	 * @param {Node} envNode - The node representing the environment map.
	 */ constructor(envNode){
        super('vec3');
        /**
		 * The node representing the environment map.
		 *
		 * @type {Node}
		 */ this.envNode = envNode;
        /**
		 * A reference to the internal cube texture.
		 *
		 * @private
		 * @type {?CubeTexture}
		 * @default null
		 */ this._cubeTexture = null;
        /**
		 * A reference to the internal cube texture node.
		 *
		 * @private
		 * @type {CubeTextureNode}
		 */ this._cubeTextureNode = $03ccd63b0299d6a7$var$cubeTexture(null);
        const defaultTexture = new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)();
        defaultTexture.isRenderTargetTexture = true;
        /**
		 * A default cube texture that acts as a placeholder.
		 * It is used when the conversion from equirectangular to cube
		 * map has not finished yet for a given texture.
		 *
		 * @private
		 * @type {CubeTexture}
		 */ this._defaultTexture = defaultTexture;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` since the node updates
		 * the texture once per render in its {@link CubeMapNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
    }
    updateBefore(frame) {
        const { renderer: renderer, material: material } = frame;
        const envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const texture = envNode.isTextureNode ? envNode.value : material[envNode.property];
            if (texture && texture.isTexture) {
                const mapping = texture.mapping;
                if (mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087) || mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098)) {
                    // check for converted cubemap map
                    if ($03ccd63b0299d6a7$var$_cache$1.has(texture)) {
                        const cubeMap = $03ccd63b0299d6a7$var$_cache$1.get(texture);
                        $03ccd63b0299d6a7$var$mapTextureMapping(cubeMap, texture.mapping);
                        this._cubeTexture = cubeMap;
                    } else {
                        // create cube map from equirectangular map
                        const image = texture.image;
                        if ($03ccd63b0299d6a7$var$isEquirectangularMapReady$1(image)) {
                            const renderTarget = new $03ccd63b0299d6a7$export$d4daf84839cea508(image.height);
                            renderTarget.fromEquirectangularTexture(renderer, texture);
                            $03ccd63b0299d6a7$var$mapTextureMapping(renderTarget.texture, texture.mapping);
                            this._cubeTexture = renderTarget.texture;
                            $03ccd63b0299d6a7$var$_cache$1.set(texture, renderTarget.texture);
                            texture.addEventListener('dispose', $03ccd63b0299d6a7$var$onTextureDispose);
                        } else // default cube texture as fallback when equirectangular texture is not yet loaded
                        this._cubeTexture = this._defaultTexture;
                    }
                    //
                    this._cubeTextureNode.value = this._cubeTexture;
                } else // envNode already refers to a cube map
                this._cubeTextureNode = this.envNode;
            }
        }
    }
    setup(builder) {
        this.updateBefore(builder);
        return this._cubeTextureNode;
    }
}
/**
 * Returns true if the given equirectangular image has been fully loaded
 * and is ready for further processing.
 *
 * @private
 * @param {Image} image - The equirectangular image to check.
 * @return {boolean} Whether the image is ready or not.
 */ function $03ccd63b0299d6a7$var$isEquirectangularMapReady$1(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
/**
 * This function is executed when `dispose()` is called on the equirectangular
 * texture. In this case, the generated cube map with its render target
 * is deleted as well.
 *
 * @private
 * @param {Object} event - The event object.
 */ function $03ccd63b0299d6a7$var$onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener('dispose', $03ccd63b0299d6a7$var$onTextureDispose);
    const renderTarget = $03ccd63b0299d6a7$var$_cache$1.get(texture);
    if (renderTarget !== undefined) {
        $03ccd63b0299d6a7$var$_cache$1.delete(texture);
        renderTarget.dispose();
    }
}
/**
 * This function makes sure the generated cube map uses the correct
 * texture mapping that corresponds to the equirectangular original.
 *
 * @private
 * @param {Texture} texture - The cube texture.
 * @param {number} mapping - The original texture mapping.
 */ function $03ccd63b0299d6a7$var$mapTextureMapping(texture, mapping) {
    if (mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087)) texture.mapping = (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4);
    else if (mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098)) texture.mapping = (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
}
/**
 * TSL function for creating a cube map node.
 *
 * @tsl
 * @function
 * @param {Node} envNode - The node representing the environment map.
 * @returns {CubeMapNode}
 */ const $03ccd63b0299d6a7$var$cubeMapNode = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$aa4d2b67403515a).setParameterLength(1);
/**
 * Represents a basic model for Image-based lighting (IBL). The environment
 * is defined via environment maps in the equirectangular or cube map format.
 * `BasicEnvironmentNode` is intended for non-PBR materials like {@link MeshBasicNodeMaterial}
 * or {@link MeshPhongNodeMaterial}.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$be91c1e31ea2d4a8 extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'BasicEnvironmentNode';
    }
    /**
	 * Constructs a new basic environment node.
	 *
	 * @param {Node} [envNode=null] - A node representing the environment.
	 */ constructor(envNode = null){
        super();
        /**
		 * A node representing the environment.
		 *
		 * @type {Node}
		 * @default null
		 */ this.envNode = envNode;
    }
    setup(builder) {
        // environment property is used in the finish() method of BasicLightingModel
        builder.context.environment = $03ccd63b0299d6a7$var$cubeMapNode(this.envNode);
    }
}
/**
 * A specific version of {@link IrradianceNode} that is only relevant
 * for {@link MeshBasicNodeMaterial}. Since the material is unlit, it
 * requires a special scaling factor for the light map.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$d8a99df53257517a extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'BasicLightMapNode';
    }
    /**
	 * Constructs a new basic light map node.
	 *
	 * @param {?Node<vec3>} [lightMapNode=null] - The light map node.
	 */ constructor(lightMapNode = null){
        super();
        /**
		 * The light map node.
		 *
		 * @type {?Node<vec3>}
		 */ this.lightMapNode = lightMapNode;
    }
    setup(builder) {
        // irradianceLightMap property is used in the indirectDiffuse() method of BasicLightingModel
        const RECIPROCAL_PI = $03ccd63b0299d6a7$var$float(1 / Math.PI);
        builder.context.irradianceLightMap = this.lightMapNode.mul(RECIPROCAL_PI);
    }
}
/**
 * Abstract class for implementing lighting models. The module defines
 * multiple methods that concrete lighting models can implement. These
 * methods are executed at different points during the light evaluation
 * process.
 */ class $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    /**
	 * This method is intended for setting up lighting model and context data
	 * which are later used in the evaluation process.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ start(builder) {
        // lights ( direct )
        builder.lightsNode.setupLights(builder, builder.lightsNode.getLightNodes(builder));
        // indirect
        this.indirect(builder);
    }
    /**
	 * This method is intended for executing final tasks like final updates
	 * to the outgoing light.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish() {}
    /**
	 * This method is intended for implementing the direct light term and
	 * executed during the build process of directional, point and spot light nodes.
	 *
	 * @abstract
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct() {}
    /**
	 * This method is intended for implementing the direct light term for
	 * rect area light nodes.
	 *
	 * @abstract
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ directRectArea() {}
    /**
	 * This method is intended for implementing the indirect light term.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect() {}
    /**
	 * This method is intended for implementing the ambient occlusion term.
	 * Unlike other methods, this method must be called manually by the lighting
	 * model in its indirect term.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The current node builder.
	 */ ambientOcclusion() {}
}
/**
 * Represents the lighting model for unlit materials. The only light contribution
 * is baked indirect lighting modulated with ambient occlusion and the material's
 * diffuse color. Environment mapping is supported. Used in {@link MeshBasicNodeMaterial}.
 *
 * @augments LightingModel
 */ class $03ccd63b0299d6a7$var$BasicLightingModel extends $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new basic lighting model.
	 */ constructor(){
        super();
    }
    /**
	 * Implements the baked indirect lighting with its modulation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect({ context: context }) {
        const ambientOcclusion = context.ambientOcclusion;
        const reflectedLight = context.reflectedLight;
        const irradianceLightMap = context.irradianceLightMap;
        reflectedLight.indirectDiffuse.assign($03ccd63b0299d6a7$var$vec4(0.0));
        // accumulation (baked indirect lighting only)
        if (irradianceLightMap) reflectedLight.indirectDiffuse.addAssign(irradianceLightMap);
        else reflectedLight.indirectDiffuse.addAssign($03ccd63b0299d6a7$var$vec4(1.0, 1.0, 1.0, 0.0));
        // modulation
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign($03ccd63b0299d6a7$var$diffuseColor.rgb);
    }
    /**
	 * Implements the environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish(builder) {
        const { material: material, context: context } = builder;
        const outgoingLight = context.outgoingLight;
        const envNode = builder.context.environment;
        if (envNode) switch(material.combine){
            case 0, $9ddd7e9b53f7a2d4$export$e50ac29801f1774d:
                outgoingLight.rgb.assign($03ccd63b0299d6a7$var$mix(outgoingLight.rgb, outgoingLight.rgb.mul(envNode.rgb), $03ccd63b0299d6a7$var$materialSpecularStrength.mul($03ccd63b0299d6a7$var$materialReflectivity)));
                break;
            case 0, $9ddd7e9b53f7a2d4$export$9f9d94f963c85479:
                outgoingLight.rgb.assign($03ccd63b0299d6a7$var$mix(outgoingLight.rgb, envNode.rgb, $03ccd63b0299d6a7$var$materialSpecularStrength.mul($03ccd63b0299d6a7$var$materialReflectivity)));
                break;
            case 0, $9ddd7e9b53f7a2d4$export$e641dc52bc3494aa:
                outgoingLight.rgb.addAssign(envNode.rgb.mul($03ccd63b0299d6a7$var$materialSpecularStrength.mul($03ccd63b0299d6a7$var$materialReflectivity)));
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('BasicLightingModel: Unsupported .combine value:', material.combine);
                break;
        }
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$9 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)();
/**
 * Node material version of {@link MeshBasicMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$14d4a26075247662 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshBasicNodeMaterial';
    }
    /**
	 * Constructs a new mesh basic node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicNodeMaterial = true;
        /**
		 * Although the basic material is by definition unlit, we set
		 * this property to `true` since we use a lighting model to compute
		 * the outgoing light of the fragment shader.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$9);
        this.setValues(parameters);
    }
    /**
	 * Basic materials are not affected by normal and bump maps so we
	 * return by default {@link normalViewGeometry}.
	 *
	 * @return {Node<vec3>} The normal node.
	 */ setupNormal() {
        return $03ccd63b0299d6a7$var$directionToFaceDirection($03ccd63b0299d6a7$var$normalViewGeometry); // see #28839
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $03ccd63b0299d6a7$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * This method must be overwritten since light maps are evaluated
	 * with a special scaling factor for basic materials.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicLightMapNode<vec3>} The light map node.
	 */ setupLightMap(builder) {
        let node = null;
        if (builder.material.lightMap) node = new $03ccd63b0299d6a7$export$d8a99df53257517a($03ccd63b0299d6a7$var$materialLightMap);
        return node;
    }
    /**
	 * The material overwrites this method because `lights` is set to `true` but
	 * we still want to return the diffuse color as the outgoing light.
	 *
	 * @return {Node<vec3>} The outgoing light node.
	 */ setupOutgoingLight() {
        return $03ccd63b0299d6a7$var$diffuseColor.rgb;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {BasicLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$var$BasicLightingModel();
    }
}
const $03ccd63b0299d6a7$var$F_Schlick = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ f0: f0, f90: f90, dotVH: dotVH })=>{
    // Original approximation by Christophe Schlick '94
    // float fresnel = pow( 1.0 - dotVH, 5.0 );
    // Optimized variant (presented by Epic at SIGGRAPH '13)
    // https://cdn2.unrealengine.com/Resources/files/2013SiggraphPresentationsNotes-26915738.pdf
    const fresnel = dotVH.mul(-5.55473).sub(6.98316).mul(dotVH).exp2();
    return f0.mul(fresnel.oneMinus()).add(f90.mul(fresnel));
}); // validated
const $03ccd63b0299d6a7$var$BRDF_Lambert = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((inputs)=>{
    return inputs.diffuseColor.mul(1 / Math.PI); // punctual light
}); // validated
const $03ccd63b0299d6a7$var$G_BlinnPhong_Implicit = ()=>$03ccd63b0299d6a7$var$float(0.25);
const $03ccd63b0299d6a7$var$D_BlinnPhong = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ dotNH: dotNH })=>{
    return $03ccd63b0299d6a7$var$shininess.mul($03ccd63b0299d6a7$var$float(0.5)).add(1.0).mul($03ccd63b0299d6a7$var$float(1 / Math.PI)).mul(dotNH.pow($03ccd63b0299d6a7$var$shininess));
});
const $03ccd63b0299d6a7$var$BRDF_BlinnPhong = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add($03ccd63b0299d6a7$var$positionViewDirection).normalize();
    const dotNH = $03ccd63b0299d6a7$var$normalView.dot(halfDir).clamp();
    const dotVH = $03ccd63b0299d6a7$var$positionViewDirection.dot(halfDir).clamp();
    const F = $03ccd63b0299d6a7$var$F_Schlick({
        f0: $03ccd63b0299d6a7$var$specularColor,
        f90: 1.0,
        dotVH: dotVH
    });
    const G = $03ccd63b0299d6a7$var$G_BlinnPhong_Implicit();
    const D = $03ccd63b0299d6a7$var$D_BlinnPhong({
        dotNH: dotNH
    });
    return F.mul(G).mul(D);
});
/**
 * Represents the lighting model for a phong material. Used in {@link MeshPhongNodeMaterial}.
 *
 * @augments BasicLightingModel
 */ class $03ccd63b0299d6a7$export$dd267abaadff98a7 extends $03ccd63b0299d6a7$var$BasicLightingModel {
    /**
	 * Constructs a new phong lighting model.
	 *
	 * @param {boolean} [specular=true] - Whether specular is supported or not.
	 */ constructor(specular = true){
        super();
        /**
		 * Whether specular is supported or not. Set this to `false` if you are
		 * looking for a Lambert-like material meaning a material for non-shiny
		 * surfaces, without specular highlights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.specular = specular;
    }
    /**
	 * Implements the direct lighting. The specular portion is optional an can be controlled
	 * with the {@link PhongLightingModel#specular} flag.
	 *
	 * @param {Object} lightData - The light data.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = $03ccd63b0299d6a7$var$normalView.dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseColor.rgb
        })));
        if (this.specular === true) reflectedLight.directSpecular.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_BlinnPhong({
            lightDirection: lightDirection
        })).mul($03ccd63b0299d6a7$var$materialSpecularStrength));
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        const { ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseColor
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$8 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$5023a9a8114806b8)();
/**
 * Node material version of {@link MeshLambertMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$ca28182707938248 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshLambertNodeMaterial';
    }
    /**
	 * Constructs a new mesh lambert node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertNodeMaterial = true;
        /**
		 * Set to `true` because lambert materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$8);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $03ccd63b0299d6a7$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhongLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$export$dd267abaadff98a7(false); // ( specular ) -> force lambert
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$7 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$24c72f71cbaf0678)();
/**
 * Node material version of {@link MeshPhongMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$eb6f457467ca986e extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshPhongNodeMaterial';
    }
    /**
	 * Constructs a new mesh lambert node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongNodeMaterial = true;
        /**
		 * Set to `true` because phong materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * The shininess of phong materials is by default inferred from the `shininess`
		 * property. This node property allows to overwrite the default
		 * and define the shininess with a node instead.
		 *
		 * If you don't want to overwrite the shininess but modify the existing
		 * value instead, use {@link materialShininess}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.shininessNode = null;
        /**
		 * The specular color of phong materials is by default inferred from the
		 * `specular` property. This node property allows to overwrite the default
		 * and define the specular color with a node instead.
		 *
		 * If you don't want to overwrite the specular color but modify the existing
		 * value instead, use {@link materialSpecular}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.specularNode = null;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$7);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link BasicEnvironmentNode}
	 * to implement the default environment mapping.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?BasicEnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        const envNode = super.setupEnvironment(builder);
        return envNode ? new $03ccd63b0299d6a7$export$be91c1e31ea2d4a8(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhongLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$export$dd267abaadff98a7();
    }
    /**
	 * Setups the phong specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        // SHININESS
        const shininessNode = (this.shininessNode ? $03ccd63b0299d6a7$var$float(this.shininessNode) : $03ccd63b0299d6a7$var$materialShininess).max(1e-4); // to prevent pow( 0.0, 0.0 )
        $03ccd63b0299d6a7$var$shininess.assign(shininessNode);
        // SPECULAR COLOR
        const specularNode = this.specularNode || $03ccd63b0299d6a7$var$materialSpecular;
        $03ccd63b0299d6a7$var$specularColor.assign(specularNode);
    }
    copy(source) {
        this.shininessNode = source.shininessNode;
        this.specularNode = source.specularNode;
        return super.copy(source);
    }
}
const $03ccd63b0299d6a7$var$getGeometryRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((builder)=>{
    if (builder.geometry.hasAttribute('normal') === false) return $03ccd63b0299d6a7$var$float(0);
    const dxy = $03ccd63b0299d6a7$var$normalViewGeometry.dFdx().abs().max($03ccd63b0299d6a7$var$normalViewGeometry.dFdy().abs());
    const geometryRoughness = dxy.x.max(dxy.y).max(dxy.z);
    return geometryRoughness;
});
const $03ccd63b0299d6a7$var$getRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((inputs)=>{
    const { roughness: roughness } = inputs;
    const geometryRoughness = $03ccd63b0299d6a7$var$getGeometryRoughness();
    let roughnessFactor = roughness.max(0.0525); // 0.0525 corresponds to the base mip of a 256 cubemap.
    roughnessFactor = roughnessFactor.add(geometryRoughness);
    roughnessFactor = roughnessFactor.min(1.0);
    return roughnessFactor;
});
// Moving Frostbite to Physically Based Rendering 3.0 - page 12, listing 2
// https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
const $03ccd63b0299d6a7$var$V_GGX_SmithCorrelated = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ alpha: alpha, dotNL: dotNL, dotNV: dotNV })=>{
    const a2 = alpha.pow2();
    const gv = dotNL.mul(a2.add(a2.oneMinus().mul(dotNV.pow2())).sqrt());
    const gl = dotNV.mul(a2.add(a2.oneMinus().mul(dotNL.pow2())).sqrt());
    return $03ccd63b0299d6a7$var$div(0.5, gv.add(gl).max($03ccd63b0299d6a7$var$EPSILON));
}).setLayout({
    name: 'V_GGX_SmithCorrelated',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        },
        {
            name: 'dotNV',
            type: 'float'
        }
    ]
}); // validated
// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $03ccd63b0299d6a7$var$V_GGX_SmithCorrelated_Anisotropic = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ alphaT: alphaT, alphaB: alphaB, dotTV: dotTV, dotBV: dotBV, dotTL: dotTL, dotBL: dotBL, dotNV: dotNV, dotNL: dotNL })=>{
    const gv = dotNL.mul($03ccd63b0299d6a7$var$vec3(alphaT.mul(dotTV), alphaB.mul(dotBV), dotNV).length());
    const gl = dotNV.mul($03ccd63b0299d6a7$var$vec3(alphaT.mul(dotTL), alphaB.mul(dotBL), dotNL).length());
    return $03ccd63b0299d6a7$var$div(0.5, gv.add(gl).max($03ccd63b0299d6a7$var$EPSILON));
}).setLayout({
    name: 'V_GGX_SmithCorrelated_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBL',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNV',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNL',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
// Microfacet Models for Refraction through Rough Surfaces - equation (33)
// http://graphicrants.blogspot.com/2013/08/specular-brdf-reference.html
// alpha is "roughness squared" in Disney’s reparameterization
const $03ccd63b0299d6a7$var$D_GGX = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ alpha: alpha, dotNH: dotNH })=>{
    const a2 = alpha.pow2();
    const denom = dotNH.pow2().mul(a2.oneMinus()).oneMinus(); // avoid alpha = 0 with dotNH = 1
    return a2.div(denom.pow2()).mul(1 / Math.PI);
}).setLayout({
    name: 'D_GGX',
    type: 'float',
    inputs: [
        {
            name: 'alpha',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
}); // validated
const $03ccd63b0299d6a7$var$RECIPROCAL_PI = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(1 / Math.PI);
// https://google.github.io/filament/Filament.md.html#materialsystem/anisotropicmodel/anisotropicspecularbrdf
const $03ccd63b0299d6a7$var$D_GGX_Anisotropic = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ alphaT: alphaT, alphaB: alphaB, dotNH: dotNH, dotTH: dotTH, dotBH: dotBH })=>{
    const a2 = alphaT.mul(alphaB);
    const v = $03ccd63b0299d6a7$var$vec3(alphaB.mul(dotTH), alphaT.mul(dotBH), a2.mul(dotNH));
    const v2 = v.dot(v);
    const w2 = a2.div(v2);
    return $03ccd63b0299d6a7$var$RECIPROCAL_PI.mul(a2.mul(w2.pow2()));
}).setLayout({
    name: 'D_GGX_Anisotropic',
    type: 'float',
    inputs: [
        {
            name: 'alphaT',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'alphaB',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotNH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotTH',
            type: 'float',
            qualifier: 'in'
        },
        {
            name: 'dotBH',
            type: 'float',
            qualifier: 'in'
        }
    ]
});
// GGX Distribution, Schlick Fresnel, GGX_SmithCorrelated Visibility
const $03ccd63b0299d6a7$var$BRDF_GGX = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ lightDirection: lightDirection, f0: f0, f90: f90, roughness: roughness, f: f, normalView: normalView$1 = $03ccd63b0299d6a7$var$normalView, USE_IRIDESCENCE: USE_IRIDESCENCE, USE_ANISOTROPY: USE_ANISOTROPY })=>{
    const alpha = roughness.pow2(); // UE4's roughness
    const halfDir = lightDirection.add($03ccd63b0299d6a7$var$positionViewDirection).normalize();
    const dotNL = normalView$1.dot(lightDirection).clamp();
    const dotNV = normalView$1.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
    const dotNH = normalView$1.dot(halfDir).clamp();
    const dotVH = $03ccd63b0299d6a7$var$positionViewDirection.dot(halfDir).clamp();
    let F = $03ccd63b0299d6a7$var$F_Schlick({
        f0: f0,
        f90: f90,
        dotVH: dotVH
    });
    let V, D;
    if ($03ccd63b0299d6a7$var$defined(USE_IRIDESCENCE)) F = $03ccd63b0299d6a7$var$iridescence.mix(F, f);
    if ($03ccd63b0299d6a7$var$defined(USE_ANISOTROPY)) {
        const dotTL = $03ccd63b0299d6a7$var$anisotropyT.dot(lightDirection);
        const dotTV = $03ccd63b0299d6a7$var$anisotropyT.dot($03ccd63b0299d6a7$var$positionViewDirection);
        const dotTH = $03ccd63b0299d6a7$var$anisotropyT.dot(halfDir);
        const dotBL = $03ccd63b0299d6a7$var$anisotropyB.dot(lightDirection);
        const dotBV = $03ccd63b0299d6a7$var$anisotropyB.dot($03ccd63b0299d6a7$var$positionViewDirection);
        const dotBH = $03ccd63b0299d6a7$var$anisotropyB.dot(halfDir);
        V = $03ccd63b0299d6a7$var$V_GGX_SmithCorrelated_Anisotropic({
            alphaT: $03ccd63b0299d6a7$var$alphaT,
            alphaB: alpha,
            dotTV: dotTV,
            dotBV: dotBV,
            dotTL: dotTL,
            dotBL: dotBL,
            dotNV: dotNV,
            dotNL: dotNL
        });
        D = $03ccd63b0299d6a7$var$D_GGX_Anisotropic({
            alphaT: $03ccd63b0299d6a7$var$alphaT,
            alphaB: alpha,
            dotNH: dotNH,
            dotTH: dotTH,
            dotBH: dotBH
        });
    } else {
        V = $03ccd63b0299d6a7$var$V_GGX_SmithCorrelated({
            alpha: alpha,
            dotNL: dotNL,
            dotNV: dotNV
        });
        D = $03ccd63b0299d6a7$var$D_GGX({
            alpha: alpha,
            dotNH: dotNH
        });
    }
    return F.mul(V).mul(D);
}); // validated
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const $03ccd63b0299d6a7$var$DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let $03ccd63b0299d6a7$var$lut = null;
const $03ccd63b0299d6a7$var$DFGLUT = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ roughness: roughness, dotNV: dotNV })=>{
    if ($03ccd63b0299d6a7$var$lut === null) {
        $03ccd63b0299d6a7$var$lut = new (0, $9ddd7e9b53f7a2d4$export$b691f601014eabe1)($03ccd63b0299d6a7$var$DATA, 16, 16, (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0), (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc));
        $03ccd63b0299d6a7$var$lut.name = 'DFG_LUT';
        $03ccd63b0299d6a7$var$lut.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        $03ccd63b0299d6a7$var$lut.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        $03ccd63b0299d6a7$var$lut.wrapS = (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
        $03ccd63b0299d6a7$var$lut.wrapT = (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
        $03ccd63b0299d6a7$var$lut.generateMipmaps = false;
        $03ccd63b0299d6a7$var$lut.needsUpdate = true;
    }
    const uv = $03ccd63b0299d6a7$var$vec2(roughness, dotNV);
    return $03ccd63b0299d6a7$var$texture($03ccd63b0299d6a7$var$lut, uv).rg;
});
// GGX BRDF with multi-scattering energy compensation for direct lighting
// This provides more accurate energy conservation, especially for rough materials
// Based on "Practical Multiple Scattering Compensation for Microfacet Models"
// https://blog.selfshadow.com/publications/turquin/ms_comp_final.pdf
const $03ccd63b0299d6a7$var$BRDF_GGX_Multiscatter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ lightDirection: lightDirection, f0: f0, f90: f90, roughness: _roughness, f: f, USE_IRIDESCENCE: USE_IRIDESCENCE, USE_ANISOTROPY: USE_ANISOTROPY })=>{
    // Single-scattering BRDF (standard GGX)
    const singleScatter = $03ccd63b0299d6a7$var$BRDF_GGX({
        lightDirection: lightDirection,
        f0: f0,
        f90: f90,
        roughness: _roughness,
        f: f,
        USE_IRIDESCENCE: USE_IRIDESCENCE,
        USE_ANISOTROPY: USE_ANISOTROPY
    });
    // Multi-scattering compensation
    const dotNL = $03ccd63b0299d6a7$var$normalView.dot(lightDirection).clamp();
    const dotNV = $03ccd63b0299d6a7$var$normalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp();
    // Precomputed DFG values for view and light directions
    const dfgV = $03ccd63b0299d6a7$var$DFGLUT({
        roughness: _roughness,
        dotNV: dotNV
    });
    const dfgL = $03ccd63b0299d6a7$var$DFGLUT({
        roughness: _roughness,
        dotNV: dotNL
    });
    // Single-scattering energy for view and light
    const FssEss_V = f0.mul(dfgV.x).add(f90.mul(dfgV.y));
    const FssEss_L = f0.mul(dfgL.x).add(f90.mul(dfgL.y));
    const Ess_V = dfgV.x.add(dfgV.y);
    const Ess_L = dfgL.x.add(dfgL.y);
    // Energy lost to multiple scattering
    const Ems_V = $03ccd63b0299d6a7$var$float(1.0).sub(Ess_V);
    const Ems_L = $03ccd63b0299d6a7$var$float(1.0).sub(Ess_L);
    // Average Fresnel reflectance
    const Favg = f0.add(f0.oneMinus().mul(0.047619)); // 1/21
    // Multiple scattering contribution
    // Uses geometric mean of view and light contributions for better energy distribution
    const Fms = FssEss_V.mul(FssEss_L).mul(Favg).div($03ccd63b0299d6a7$var$float(1.0).sub(Ems_V.mul(Ems_L).mul(Favg).mul(Favg)).add($03ccd63b0299d6a7$var$EPSILON));
    // Energy compensation factor
    const compensationFactor = Ems_V.mul(Ems_L);
    const multiScatter = Fms.mul(compensationFactor);
    return singleScatter.add(multiScatter);
});
const $03ccd63b0299d6a7$var$EnvironmentBRDF = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn((inputs)=>{
    const { dotNV: dotNV, specularColor: specularColor, specularF90: specularF90, roughness: roughness } = inputs;
    const fab = $03ccd63b0299d6a7$var$DFGLUT({
        dotNV: dotNV,
        roughness: roughness
    });
    return specularColor.mul(fab.x).add(specularF90.mul(fab.y));
});
const $03ccd63b0299d6a7$var$Schlick_to_F0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ f: f, f90: f90, dotVH: dotVH })=>{
    const x = dotVH.oneMinus().saturate();
    const x2 = x.mul(x);
    const x5 = x.mul(x2, x2).clamp(0, .9999);
    return f.sub($03ccd63b0299d6a7$var$vec3(f90).mul(x5)).div(x5.oneMinus());
}).setLayout({
    name: 'Schlick_to_F0',
    type: 'vec3',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        },
        {
            name: 'f90',
            type: 'float'
        },
        {
            name: 'dotVH',
            type: 'float'
        }
    ]
});
// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $03ccd63b0299d6a7$var$D_Charlie = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ roughness: roughness, dotNH: dotNH })=>{
    const alpha = roughness.pow2();
    // Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF"
    const invAlpha = $03ccd63b0299d6a7$var$float(1.0).div(alpha);
    const cos2h = dotNH.pow2();
    const sin2h = cos2h.oneMinus().max(0.0078125); // 2^(-14/2), so sin2h^2 > 0 in fp16
    return $03ccd63b0299d6a7$var$float(2.0).add(invAlpha).mul(sin2h.pow(invAlpha.mul(0.5))).div(2.0 * Math.PI);
}).setLayout({
    name: 'D_Charlie',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'dotNH',
            type: 'float'
        }
    ]
});
// https://github.com/google/filament/blob/master/shaders/src/brdf.fs
const $03ccd63b0299d6a7$var$V_Neubelt = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ dotNV: dotNV, dotNL: dotNL })=>{
    // Neubelt and Pettineo 2013, "Crafting a Next-gen Material Pipeline for The Order: 1886"
    return $03ccd63b0299d6a7$var$float(1.0).div($03ccd63b0299d6a7$var$float(4.0).mul(dotNL.add(dotNV).sub(dotNL.mul(dotNV))));
}).setLayout({
    name: 'V_Neubelt',
    type: 'float',
    inputs: [
        {
            name: 'dotNV',
            type: 'float'
        },
        {
            name: 'dotNL',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$BRDF_Sheen = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ lightDirection: lightDirection })=>{
    const halfDir = lightDirection.add($03ccd63b0299d6a7$var$positionViewDirection).normalize();
    const dotNL = $03ccd63b0299d6a7$var$normalView.dot(lightDirection).clamp();
    const dotNV = $03ccd63b0299d6a7$var$normalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp();
    const dotNH = $03ccd63b0299d6a7$var$normalView.dot(halfDir).clamp();
    const D = $03ccd63b0299d6a7$var$D_Charlie({
        roughness: $03ccd63b0299d6a7$var$sheenRoughness,
        dotNH: dotNH
    });
    const V = $03ccd63b0299d6a7$var$V_Neubelt({
        dotNV: dotNV,
        dotNL: dotNL
    });
    return $03ccd63b0299d6a7$var$sheen.mul(D).mul(V);
});
// Rect Area Light
// Real-Time Polygonal-Light Shading with Linearly Transformed Cosines
// by Eric Heitz, Jonathan Dupuy, Stephen Hill and David Neubelt
// code: https://github.com/selfshadow/ltc_code/
const $03ccd63b0299d6a7$var$LTC_Uv = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ N: N, V: V, roughness: roughness })=>{
    const LUT_SIZE = 64.0;
    const LUT_SCALE = (LUT_SIZE - 1.0) / LUT_SIZE;
    const LUT_BIAS = 0.5 / LUT_SIZE;
    const dotNV = N.dot(V).saturate();
    // texture parameterized by sqrt( GGX alpha ) and sqrt( 1 - cos( theta ) )
    const uv = $03ccd63b0299d6a7$var$vec2(roughness, dotNV.oneMinus().sqrt());
    uv.assign(uv.mul(LUT_SCALE).add(LUT_BIAS));
    return uv;
}).setLayout({
    name: 'LTC_Uv',
    type: 'vec2',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$LTC_ClippedSphereFormFactor = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ f: f })=>{
    // Real-Time Area Lighting: a Journey from Research to Production (p.102)
    // An approximation of the form factor of a horizon-clipped rectangle.
    const l = f.length();
    return $03ccd63b0299d6a7$var$max$1(l.mul(l).add(f.z).div(l.add(1.0)), 0);
}).setLayout({
    name: 'LTC_ClippedSphereFormFactor',
    type: 'float',
    inputs: [
        {
            name: 'f',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ v1: v1, v2: v2 })=>{
    const x = v1.dot(v2);
    const y = x.abs().toVar();
    // rational polynomial approximation to theta / sin( theta ) / 2PI
    const a = y.mul(0.0145206).add(0.4965155).mul(y).add(0.8543985).toVar();
    const b = y.add(4.1616724).mul(y).add(3.4175940).toVar();
    const v = a.div(b);
    const theta_sintheta = x.greaterThan(0.0).select(v, $03ccd63b0299d6a7$var$max$1(x.mul(x).oneMinus(), 1e-7).inverseSqrt().mul(0.5).sub(v));
    return v1.cross(v2).mul(theta_sintheta);
}).setLayout({
    name: 'LTC_EdgeVectorFormFactor',
    type: 'vec3',
    inputs: [
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$LTC_Evaluate = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ N: N, V: V, P: P, mInv: mInv, p0: p0, p1: p1, p2: p2, p3: p3 })=>{
    // bail if point is on back side of plane of light
    // assumes ccw winding order of light vertices
    const v1 = p1.sub(p0).toVar();
    const v2 = p3.sub(p0).toVar();
    const lightNormal = v1.cross(v2);
    const result = $03ccd63b0299d6a7$var$vec3().toVar();
    $03ccd63b0299d6a7$var$If(lightNormal.dot(P.sub(p0)).greaterThanEqual(0.0), ()=>{
        // construct orthonormal basis around N
        const T1 = V.sub(N.mul(V.dot(N))).normalize();
        const T2 = N.cross(T1).negate(); // negated from paper; possibly due to a different handedness of world coordinate system
        // compute transform
        const mat = mInv.mul($03ccd63b0299d6a7$var$mat3(T1, T2, N).transpose()).toVar();
        // transform rect
        // & project rect onto sphere
        const coords0 = mat.mul(p0.sub(P)).normalize().toVar();
        const coords1 = mat.mul(p1.sub(P)).normalize().toVar();
        const coords2 = mat.mul(p2.sub(P)).normalize().toVar();
        const coords3 = mat.mul(p3.sub(P)).normalize().toVar();
        // calculate vector form factor
        const vectorFormFactor = $03ccd63b0299d6a7$var$vec3(0).toVar();
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords0,
            v2: coords1
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords1,
            v2: coords2
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords2,
            v2: coords3
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords3,
            v2: coords0
        }));
        // adjust for horizon clipping
        result.assign($03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$LTC_ClippedSphereFormFactor({
            f: vectorFormFactor
        })));
    });
    return result;
}).setLayout({
    name: 'LTC_Evaluate',
    type: 'vec3',
    inputs: [
        {
            name: 'N',
            type: 'vec3'
        },
        {
            name: 'V',
            type: 'vec3'
        },
        {
            name: 'P',
            type: 'vec3'
        },
        {
            name: 'mInv',
            type: 'mat3'
        },
        {
            name: 'p0',
            type: 'vec3'
        },
        {
            name: 'p1',
            type: 'vec3'
        },
        {
            name: 'p2',
            type: 'vec3'
        },
        {
            name: 'p3',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$LTC_Evaluate_Volume = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ P: P, p0: p0, p1: p1, p2: p2, p3: p3 })=>{
    // bail if point is on back side of plane of light
    // assumes ccw winding order of light vertices
    const v1 = p1.sub(p0).toVar();
    const v2 = p3.sub(p0).toVar();
    const lightNormal = v1.cross(v2);
    const result = $03ccd63b0299d6a7$var$vec3().toVar();
    $03ccd63b0299d6a7$var$If(lightNormal.dot(P.sub(p0)).greaterThanEqual(0.0), ()=>{
        // transform rect
        // & project rect onto sphere
        const coords0 = p0.sub(P).normalize().toVar();
        const coords1 = p1.sub(P).normalize().toVar();
        const coords2 = p2.sub(P).normalize().toVar();
        const coords3 = p3.sub(P).normalize().toVar();
        // calculate vector form factor
        const vectorFormFactor = $03ccd63b0299d6a7$var$vec3(0).toVar();
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords0,
            v2: coords1
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords1,
            v2: coords2
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords2,
            v2: coords3
        }));
        vectorFormFactor.addAssign($03ccd63b0299d6a7$var$LTC_EdgeVectorFormFactor({
            v1: coords3,
            v2: coords0
        }));
        // adjust for horizon clipping
        result.assign($03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$LTC_ClippedSphereFormFactor({
            f: vectorFormFactor.abs()
        })));
    });
    return result;
}).setLayout({
    name: 'LTC_Evaluate',
    type: 'vec3',
    inputs: [
        {
            name: 'P',
            type: 'vec3'
        },
        {
            name: 'p0',
            type: 'vec3'
        },
        {
            name: 'p1',
            type: 'vec3'
        },
        {
            name: 'p2',
            type: 'vec3'
        },
        {
            name: 'p3',
            type: 'vec3'
        }
    ]
});
// Mipped Bicubic Texture Filtering by N8
// https://www.shadertoy.com/view/Dl2SDW
const $03ccd63b0299d6a7$var$bC = 1.0 / 6.0;
const $03ccd63b0299d6a7$var$w0 = (a)=>$03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$bC, $03ccd63b0299d6a7$var$mul(a, $03ccd63b0299d6a7$var$mul(a, a.negate().add(3.0)).sub(3.0)).add(1.0));
const $03ccd63b0299d6a7$var$w1 = (a)=>$03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$bC, $03ccd63b0299d6a7$var$mul(a, $03ccd63b0299d6a7$var$mul(a, $03ccd63b0299d6a7$var$mul(3.0, a).sub(6.0))).add(4.0));
const $03ccd63b0299d6a7$var$w2 = (a)=>$03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$bC, $03ccd63b0299d6a7$var$mul(a, $03ccd63b0299d6a7$var$mul(a, $03ccd63b0299d6a7$var$mul(-3, a).add(3.0)).add(3.0)).add(1.0));
const $03ccd63b0299d6a7$var$w3 = (a)=>$03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$bC, $03ccd63b0299d6a7$var$pow(a, 3));
const $03ccd63b0299d6a7$var$g0 = (a)=>$03ccd63b0299d6a7$var$w0(a).add($03ccd63b0299d6a7$var$w1(a));
const $03ccd63b0299d6a7$var$g1 = (a)=>$03ccd63b0299d6a7$var$w2(a).add($03ccd63b0299d6a7$var$w3(a));
// h0 and h1 are the two offset functions
const $03ccd63b0299d6a7$var$h0 = (a)=>$03ccd63b0299d6a7$var$add(-1, $03ccd63b0299d6a7$var$w1(a).div($03ccd63b0299d6a7$var$w0(a).add($03ccd63b0299d6a7$var$w1(a))));
const $03ccd63b0299d6a7$var$h1 = (a)=>$03ccd63b0299d6a7$var$add(1.0, $03ccd63b0299d6a7$var$w3(a).div($03ccd63b0299d6a7$var$w2(a).add($03ccd63b0299d6a7$var$w3(a))));
const $03ccd63b0299d6a7$var$bicubic = (textureNode, texelSize, lod)=>{
    const uv = textureNode.uvNode;
    const uvScaled = $03ccd63b0299d6a7$var$mul(uv, texelSize.zw).add(0.5);
    const iuv = $03ccd63b0299d6a7$var$floor(uvScaled);
    const fuv = $03ccd63b0299d6a7$var$fract(uvScaled);
    const g0x = $03ccd63b0299d6a7$var$g0(fuv.x);
    const g1x = $03ccd63b0299d6a7$var$g1(fuv.x);
    const h0x = $03ccd63b0299d6a7$var$h0(fuv.x);
    const h1x = $03ccd63b0299d6a7$var$h1(fuv.x);
    const h0y = $03ccd63b0299d6a7$var$h0(fuv.y);
    const h1y = $03ccd63b0299d6a7$var$h1(fuv.y);
    const p0 = $03ccd63b0299d6a7$var$vec2(iuv.x.add(h0x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p1 = $03ccd63b0299d6a7$var$vec2(iuv.x.add(h1x), iuv.y.add(h0y)).sub(0.5).mul(texelSize.xy);
    const p2 = $03ccd63b0299d6a7$var$vec2(iuv.x.add(h0x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const p3 = $03ccd63b0299d6a7$var$vec2(iuv.x.add(h1x), iuv.y.add(h1y)).sub(0.5).mul(texelSize.xy);
    const a = $03ccd63b0299d6a7$var$g0(fuv.y).mul($03ccd63b0299d6a7$var$add(g0x.mul(textureNode.sample(p0).level(lod)), g1x.mul(textureNode.sample(p1).level(lod))));
    const b = $03ccd63b0299d6a7$var$g1(fuv.y).mul($03ccd63b0299d6a7$var$add(g0x.mul(textureNode.sample(p2).level(lod)), g1x.mul(textureNode.sample(p3).level(lod))));
    return a.add(b);
};
/**
 * Applies mipped bicubic texture filtering to the given texture node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node that should be filtered.
 * @param {Node<float>} lodNode - Defines the LOD to sample from.
 * @return {Node} The filtered texture sample.
 */ const $03ccd63b0299d6a7$var$textureBicubicLevel = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([textureNode, lodNode])=>{
    const fLodSize = $03ccd63b0299d6a7$var$vec2(textureNode.size($03ccd63b0299d6a7$var$int(lodNode)));
    const cLodSize = $03ccd63b0299d6a7$var$vec2(textureNode.size($03ccd63b0299d6a7$var$int(lodNode.add(1.0))));
    const fLodSizeInv = $03ccd63b0299d6a7$var$div(1.0, fLodSize);
    const cLodSizeInv = $03ccd63b0299d6a7$var$div(1.0, cLodSize);
    const fSample = $03ccd63b0299d6a7$var$bicubic(textureNode, $03ccd63b0299d6a7$var$vec4(fLodSizeInv, fLodSize), $03ccd63b0299d6a7$var$floor(lodNode));
    const cSample = $03ccd63b0299d6a7$var$bicubic(textureNode, $03ccd63b0299d6a7$var$vec4(cLodSizeInv, cLodSize), $03ccd63b0299d6a7$var$ceil(lodNode));
    return $03ccd63b0299d6a7$var$fract(lodNode).mix(fSample, cSample);
});
/**
 * Applies mipped bicubic texture filtering to the given texture node.
 *
 * @tsl
 * @function
 * @param {TextureNode} textureNode - The texture node that should be filtered.
 * @param {Node<float>} [strength] - Defines the strength of the bicubic filtering.
 * @return {Node} The filtered texture sample.
 */ const $03ccd63b0299d6a7$var$textureBicubic = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([textureNode, strength])=>{
    const lod = strength.mul($03ccd63b0299d6a7$var$maxMipLevel(textureNode));
    return $03ccd63b0299d6a7$var$textureBicubicLevel(textureNode, lod);
});
//
// Transmission
//
const $03ccd63b0299d6a7$var$getVolumeTransmissionRay = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([n, v, thickness, ior, modelMatrix])=>{
    // Direction of refracted light.
    const refractionVector = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$refract(v.negate(), $03ccd63b0299d6a7$var$normalize(n), $03ccd63b0299d6a7$var$div(1.0, ior)));
    // Compute rotation-independent scaling of the model matrix.
    const modelScale = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$length(modelMatrix[0].xyz), $03ccd63b0299d6a7$var$length(modelMatrix[1].xyz), $03ccd63b0299d6a7$var$length(modelMatrix[2].xyz));
    // The thickness is specified in local space.
    return $03ccd63b0299d6a7$var$normalize(refractionVector).mul(thickness.mul(modelScale));
}).setLayout({
    name: 'getVolumeTransmissionRay',
    type: 'vec3',
    inputs: [
        {
            name: 'n',
            type: 'vec3'
        },
        {
            name: 'v',
            type: 'vec3'
        },
        {
            name: 'thickness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        },
        {
            name: 'modelMatrix',
            type: 'mat4'
        }
    ]
});
const $03ccd63b0299d6a7$var$applyIorToRoughness = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([roughness, ior])=>{
    // Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
    // an IOR of 1.5 results in the default amount of microfacet refraction.
    return roughness.mul($03ccd63b0299d6a7$var$clamp(ior.mul(2.0).sub(2.0), 0.0, 1.0));
}).setLayout({
    name: 'applyIorToRoughness',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        },
        {
            name: 'ior',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$viewportBackSideTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$viewportMipTexture();
const $03ccd63b0299d6a7$var$viewportFrontSideTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$viewportOpaqueMipTexture();
const $03ccd63b0299d6a7$var$getTransmissionSample = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([fragCoord, roughness, ior], { material: material })=>{
    const vTexture = material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace) ? $03ccd63b0299d6a7$var$viewportBackSideTexture : $03ccd63b0299d6a7$var$viewportFrontSideTexture;
    const transmissionSample = vTexture.sample(fragCoord);
    //const transmissionSample = viewportMipTexture( fragCoord );
    const lod = $03ccd63b0299d6a7$var$log2($03ccd63b0299d6a7$var$screenSize.x).mul($03ccd63b0299d6a7$var$applyIorToRoughness(roughness, ior));
    return $03ccd63b0299d6a7$var$textureBicubicLevel(transmissionSample, lod);
});
const $03ccd63b0299d6a7$var$volumeAttenuation = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([transmissionDistance, attenuationColor, attenuationDistance])=>{
    $03ccd63b0299d6a7$var$If(attenuationDistance.notEqual(0), ()=>{
        // Compute light attenuation using Beer's law.
        const attenuationCoefficient = $03ccd63b0299d6a7$var$log(attenuationColor).negate().div(attenuationDistance);
        const transmittance = $03ccd63b0299d6a7$var$exp(attenuationCoefficient.negate().mul(transmissionDistance));
        return transmittance;
    });
    // Attenuation distance is +∞, i.e. the transmitted color is not attenuated at all.
    return $03ccd63b0299d6a7$var$vec3(1.0);
}).setLayout({
    name: 'volumeAttenuation',
    type: 'vec3',
    inputs: [
        {
            name: 'transmissionDistance',
            type: 'float'
        },
        {
            name: 'attenuationColor',
            type: 'vec3'
        },
        {
            name: 'attenuationDistance',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$getIBLVolumeRefraction = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([n, v, roughness, diffuseColor, specularColor, specularF90, position, modelMatrix, viewMatrix, projMatrix, ior, thickness, attenuationColor, attenuationDistance, dispersion])=>{
    let transmittedLight, transmittance;
    if (dispersion) {
        transmittedLight = $03ccd63b0299d6a7$var$vec4().toVar();
        transmittance = $03ccd63b0299d6a7$var$vec3().toVar();
        const halfSpread = ior.sub(1.0).mul(dispersion.mul(0.025));
        const iors = $03ccd63b0299d6a7$var$vec3(ior.sub(halfSpread), ior, ior.add(halfSpread));
        $03ccd63b0299d6a7$var$Loop({
            start: 0,
            end: 3
        }, ({ i: i })=>{
            const ior = iors.element(i);
            const transmissionRay = $03ccd63b0299d6a7$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
            const refractedRayExit = position.add(transmissionRay);
            // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
            const ndcPos = projMatrix.mul(viewMatrix.mul($03ccd63b0299d6a7$var$vec4(refractedRayExit, 1.0)));
            const refractionCoords = $03ccd63b0299d6a7$var$vec2(ndcPos.xy.div(ndcPos.w)).toVar();
            refractionCoords.addAssign(1.0);
            refractionCoords.divAssign(2.0);
            refractionCoords.assign($03ccd63b0299d6a7$var$vec2(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
            // Sample framebuffer to get pixel the refracted ray hits.
            const transmissionSample = $03ccd63b0299d6a7$var$getTransmissionSample(refractionCoords, roughness, ior);
            transmittedLight.element(i).assign(transmissionSample.element(i));
            transmittedLight.a.addAssign(transmissionSample.a);
            transmittance.element(i).assign(diffuseColor.element(i).mul($03ccd63b0299d6a7$var$volumeAttenuation($03ccd63b0299d6a7$var$length(transmissionRay), attenuationColor, attenuationDistance).element(i)));
        });
        transmittedLight.a.divAssign(3.0);
    } else {
        const transmissionRay = $03ccd63b0299d6a7$var$getVolumeTransmissionRay(n, v, thickness, ior, modelMatrix);
        const refractedRayExit = position.add(transmissionRay);
        // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
        const ndcPos = projMatrix.mul(viewMatrix.mul($03ccd63b0299d6a7$var$vec4(refractedRayExit, 1.0)));
        const refractionCoords = $03ccd63b0299d6a7$var$vec2(ndcPos.xy.div(ndcPos.w)).toVar();
        refractionCoords.addAssign(1.0);
        refractionCoords.divAssign(2.0);
        refractionCoords.assign($03ccd63b0299d6a7$var$vec2(refractionCoords.x, refractionCoords.y.oneMinus())); // webgpu
        // Sample framebuffer to get pixel the refracted ray hits.
        transmittedLight = $03ccd63b0299d6a7$var$getTransmissionSample(refractionCoords, roughness, ior);
        transmittance = diffuseColor.mul($03ccd63b0299d6a7$var$volumeAttenuation($03ccd63b0299d6a7$var$length(transmissionRay), attenuationColor, attenuationDistance));
    }
    const attenuatedColor = transmittance.rgb.mul(transmittedLight.rgb);
    const dotNV = n.dot(v).clamp();
    // Get the specular component.
    const F = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$EnvironmentBRDF({
        dotNV: dotNV,
        specularColor: specularColor,
        specularF90: specularF90,
        roughness: roughness
    }));
    // As less light is transmitted, the opacity should be increased. This simple approximation does a decent job
    // of modulating a CSS background, and has no effect when the buffer is opaque, due to a solid object or clear color.
    const transmittanceFactor = transmittance.r.add(transmittance.g, transmittance.b).div(3.0);
    return $03ccd63b0299d6a7$var$vec4(F.oneMinus().mul(attenuatedColor), transmittedLight.a.oneMinus().mul(transmittanceFactor).oneMinus());
});
//
// Iridescence
//
// XYZ to linear-sRGB color space
const $03ccd63b0299d6a7$var$XYZ_TO_REC709 = /*@__PURE__*/ $03ccd63b0299d6a7$var$mat3(3.2404542, -0.969266, 0.0556434, -1.5371385, 1.8760108, -0.2040259, -0.4985314, 0.0415560, 1.0572252);
// Assume air interface for top
// Note: We don't handle the case fresnel0 == 1
const $03ccd63b0299d6a7$var$Fresnel0ToIor = (fresnel0)=>{
    const sqrtF0 = fresnel0.sqrt();
    return $03ccd63b0299d6a7$var$vec3(1.0).add(sqrtF0).div($03ccd63b0299d6a7$var$vec3(1.0).sub(sqrtF0));
};
// ior is a value between 1.0 and 3.0. 1.0 is air interface
const $03ccd63b0299d6a7$var$IorToFresnel0 = (transmittedIor, incidentIor)=>{
    return transmittedIor.sub(incidentIor).div(transmittedIor.add(incidentIor)).pow2();
};
// Fresnel equations for dielectric/dielectric interfaces.
// Ref: https://belcour.github.io/blog/research/2017/05/01/brdf-thin-film.html
// Evaluation XYZ sensitivity curves in Fourier space
const $03ccd63b0299d6a7$var$evalSensitivity = (OPD, shift)=>{
    const phase = OPD.mul(2.0 * Math.PI * 1.0e-9);
    const val = $03ccd63b0299d6a7$var$vec3(5.4856e-13, 4.4201e-13, 5.2481e-13);
    const pos = $03ccd63b0299d6a7$var$vec3(1.6810e+06, 1.7953e+06, 2.2084e+06);
    const VAR = $03ccd63b0299d6a7$var$vec3(4.3278e+09, 9.3046e+09, 6.6121e+09);
    const x = $03ccd63b0299d6a7$var$float(9.7470e-14 * Math.sqrt(2.0 * Math.PI * 4.5282e+09)).mul(phase.mul(2.2399e+06).add(shift.x).cos()).mul(phase.pow2().mul(-4528200000).exp());
    let xyz = val.mul(VAR.mul(2.0 * Math.PI).sqrt()).mul(pos.mul(phase).add(shift).cos()).mul(phase.pow2().negate().mul(VAR).exp());
    xyz = $03ccd63b0299d6a7$var$vec3(xyz.x.add(x), xyz.y, xyz.z).div(1.0685e-7);
    const rgb = $03ccd63b0299d6a7$var$XYZ_TO_REC709.mul(xyz);
    return rgb;
};
const $03ccd63b0299d6a7$var$evalIridescence = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ outsideIOR: outsideIOR, eta2: eta2, cosTheta1: cosTheta1, thinFilmThickness: thinFilmThickness, baseF0: baseF0 })=>{
    // Force iridescenceIOR -> outsideIOR when thinFilmThickness -> 0.0
    const iridescenceIOR = $03ccd63b0299d6a7$var$mix(outsideIOR, eta2, $03ccd63b0299d6a7$var$smoothstep(0.0, 0.03, thinFilmThickness));
    // Evaluate the cosTheta on the base layer (Snell law)
    const sinTheta2Sq = outsideIOR.div(iridescenceIOR).pow2().mul(cosTheta1.pow2().oneMinus());
    // Handle TIR:
    const cosTheta2Sq = sinTheta2Sq.oneMinus();
    $03ccd63b0299d6a7$var$If(cosTheta2Sq.lessThan(0), ()=>{
        return $03ccd63b0299d6a7$var$vec3(1.0);
    });
    const cosTheta2 = cosTheta2Sq.sqrt();
    // First interface
    const R0 = $03ccd63b0299d6a7$var$IorToFresnel0(iridescenceIOR, outsideIOR);
    const R12 = $03ccd63b0299d6a7$var$F_Schlick({
        f0: R0,
        f90: 1.0,
        dotVH: cosTheta1
    });
    //const R21 = R12;
    const T121 = R12.oneMinus();
    const phi12 = iridescenceIOR.lessThan(outsideIOR).select(Math.PI, 0.0);
    const phi21 = $03ccd63b0299d6a7$var$float(Math.PI).sub(phi12);
    // Second interface
    const baseIOR = $03ccd63b0299d6a7$var$Fresnel0ToIor(baseF0.clamp(0.0, 0.9999)); // guard against 1.0
    const R1 = $03ccd63b0299d6a7$var$IorToFresnel0(baseIOR, iridescenceIOR.toVec3());
    const R23 = $03ccd63b0299d6a7$var$F_Schlick({
        f0: R1,
        f90: 1.0,
        dotVH: cosTheta2
    });
    const phi23 = $03ccd63b0299d6a7$var$vec3(baseIOR.x.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.y.lessThan(iridescenceIOR).select(Math.PI, 0.0), baseIOR.z.lessThan(iridescenceIOR).select(Math.PI, 0.0));
    // Phase shift
    const OPD = iridescenceIOR.mul(thinFilmThickness, cosTheta2, 2.0);
    const phi = $03ccd63b0299d6a7$var$vec3(phi21).add(phi23);
    // Compound terms
    const R123 = R12.mul(R23).clamp(1e-5, 0.9999);
    const r123 = R123.sqrt();
    const Rs = T121.pow2().mul(R23).div($03ccd63b0299d6a7$var$vec3(1.0).sub(R123));
    // Reflectance term for m = 0 (DC term amplitude)
    const C0 = R12.add(Rs);
    const I = C0.toVar();
    // Reflectance term for m > 0 (pairs of diracs)
    const Cm = Rs.sub(T121).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: 1,
        end: 2,
        condition: '<=',
        name: 'm'
    }, ({ m: m })=>{
        Cm.mulAssign(r123);
        const Sm = $03ccd63b0299d6a7$var$evalSensitivity($03ccd63b0299d6a7$var$float(m).mul(OPD), $03ccd63b0299d6a7$var$float(m).mul(phi)).mul(2.0);
        I.addAssign(Cm.mul(Sm));
    });
    // Since out of gamut colors might be produced, negative color values are clamped to 0.
    return I.max($03ccd63b0299d6a7$var$vec3(0.0));
}).setLayout({
    name: 'evalIridescence',
    type: 'vec3',
    inputs: [
        {
            name: 'outsideIOR',
            type: 'float'
        },
        {
            name: 'eta2',
            type: 'float'
        },
        {
            name: 'cosTheta1',
            type: 'float'
        },
        {
            name: 'thinFilmThickness',
            type: 'float'
        },
        {
            name: 'baseF0',
            type: 'vec3'
        }
    ]
});
//
//	Sheen
//
// This is a curve-fit approximation to the "Charlie sheen" BRDF integrated over the hemisphere from
// Estevez and Kulla 2017, "Production Friendly Microfacet Sheen BRDF".
const $03ccd63b0299d6a7$var$IBLSheenBRDF = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ normal: normal, viewDir: viewDir, roughness: roughness })=>{
    const dotNV = normal.dot(viewDir).saturate();
    const r2 = roughness.mul(roughness);
    const rInv = roughness.add(0.1).reciprocal();
    const a = $03ccd63b0299d6a7$var$float(-1.9362).add(roughness.mul(1.0678)).add(r2.mul(0.4573)).sub(rInv.mul(0.8469));
    const b = $03ccd63b0299d6a7$var$float(-0.6014).add(roughness.mul(0.5538)).sub(r2.mul(0.4670)).sub(rInv.mul(0.1255));
    const DG = a.mul(dotNV).add(b).exp();
    return DG.saturate();
});
const $03ccd63b0299d6a7$var$clearcoatF0 = $03ccd63b0299d6a7$var$vec3(0.04);
const $03ccd63b0299d6a7$var$clearcoatF90 = $03ccd63b0299d6a7$var$float(1);
/**
 * Represents the lighting model for a PBR material.
 *
 * @augments LightingModel
 */ class $03ccd63b0299d6a7$export$b69e16149fd7d508 extends $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new physical lighting model.
	 *
	 * @param {boolean} [clearcoat=false] - Whether clearcoat is supported or not.
	 * @param {boolean} [sheen=false] - Whether sheen is supported or not.
	 * @param {boolean} [iridescence=false] - Whether iridescence is supported or not.
	 * @param {boolean} [anisotropy=false] - Whether anisotropy is supported or not.
	 * @param {boolean} [transmission=false] - Whether transmission is supported or not.
	 * @param {boolean} [dispersion=false] - Whether dispersion is supported or not.
	 */ constructor(clearcoat = false, sheen = false, iridescence = false, anisotropy = false, transmission = false, dispersion = false){
        super();
        /**
		 * Whether clearcoat is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clearcoat = clearcoat;
        /**
		 * Whether sheen is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.sheen = sheen;
        /**
		 * Whether iridescence is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.iridescence = iridescence;
        /**
		 * Whether anisotropy is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.anisotropy = anisotropy;
        /**
		 * Whether transmission is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transmission = transmission;
        /**
		 * Whether dispersion is supported or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dispersion = dispersion;
        /**
		 * The clear coat radiance.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatRadiance = null;
        /**
		 * The clear coat specular direct.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatSpecularDirect = null;
        /**
		 * The clear coat specular indirect.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.clearcoatSpecularIndirect = null;
        /**
		 * The sheen specular direct.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.sheenSpecularDirect = null;
        /**
		 * The sheen specular indirect.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.sheenSpecularIndirect = null;
        /**
		 * The iridescence Fresnel.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceFresnel = null;
        /**
		 * The iridescence F0.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0 = null;
        /**
		 * The iridescence F0 dielectric.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0Dielectric = null;
        /**
		 * The iridescence F0 metallic.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.iridescenceF0Metallic = null;
    }
    /**
	 * Depending on what features are requested, the method prepares certain node variables
	 * which are later used for lighting computations.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ start(builder) {
        if (this.clearcoat === true) {
            this.clearcoatRadiance = $03ccd63b0299d6a7$var$vec3().toVar('clearcoatRadiance');
            this.clearcoatSpecularDirect = $03ccd63b0299d6a7$var$vec3().toVar('clearcoatSpecularDirect');
            this.clearcoatSpecularIndirect = $03ccd63b0299d6a7$var$vec3().toVar('clearcoatSpecularIndirect');
        }
        if (this.sheen === true) {
            this.sheenSpecularDirect = $03ccd63b0299d6a7$var$vec3().toVar('sheenSpecularDirect');
            this.sheenSpecularIndirect = $03ccd63b0299d6a7$var$vec3().toVar('sheenSpecularIndirect');
        }
        if (this.iridescence === true) {
            const dotNVi = $03ccd63b0299d6a7$var$normalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp();
            const iridescenceFresnelDielectric = $03ccd63b0299d6a7$var$evalIridescence({
                outsideIOR: $03ccd63b0299d6a7$var$float(1.0),
                eta2: $03ccd63b0299d6a7$var$iridescenceIOR,
                cosTheta1: dotNVi,
                thinFilmThickness: $03ccd63b0299d6a7$var$iridescenceThickness,
                baseF0: $03ccd63b0299d6a7$var$specularColor
            });
            const iridescenceFresnelMetallic = $03ccd63b0299d6a7$var$evalIridescence({
                outsideIOR: $03ccd63b0299d6a7$var$float(1.0),
                eta2: $03ccd63b0299d6a7$var$iridescenceIOR,
                cosTheta1: dotNVi,
                thinFilmThickness: $03ccd63b0299d6a7$var$iridescenceThickness,
                baseF0: $03ccd63b0299d6a7$var$diffuseColor.rgb
            });
            this.iridescenceFresnel = $03ccd63b0299d6a7$var$mix(iridescenceFresnelDielectric, iridescenceFresnelMetallic, $03ccd63b0299d6a7$var$metalness);
            this.iridescenceF0Dielectric = $03ccd63b0299d6a7$var$Schlick_to_F0({
                f: iridescenceFresnelDielectric,
                f90: 1.0,
                dotVH: dotNVi
            });
            this.iridescenceF0Metallic = $03ccd63b0299d6a7$var$Schlick_to_F0({
                f: iridescenceFresnelMetallic,
                f90: 1.0,
                dotVH: dotNVi
            });
            this.iridescenceF0 = $03ccd63b0299d6a7$var$mix(this.iridescenceF0Dielectric, this.iridescenceF0Metallic, $03ccd63b0299d6a7$var$metalness);
        }
        if (this.transmission === true) {
            const position = $03ccd63b0299d6a7$var$positionWorld;
            const v = $03ccd63b0299d6a7$var$cameraPosition.sub($03ccd63b0299d6a7$var$positionWorld).normalize(); // TODO: Create Node for this, same issue in MaterialX
            const n = $03ccd63b0299d6a7$var$normalWorld;
            const context = builder.context;
            context.backdrop = $03ccd63b0299d6a7$var$getIBLVolumeRefraction(n, v, $03ccd63b0299d6a7$var$roughness, $03ccd63b0299d6a7$var$diffuseContribution, $03ccd63b0299d6a7$var$specularColorBlended, $03ccd63b0299d6a7$var$specularF90, position, $03ccd63b0299d6a7$var$modelWorldMatrix, $03ccd63b0299d6a7$var$cameraViewMatrix, $03ccd63b0299d6a7$var$cameraProjectionMatrix, $03ccd63b0299d6a7$var$ior, $03ccd63b0299d6a7$var$thickness, $03ccd63b0299d6a7$var$attenuationColor, $03ccd63b0299d6a7$var$attenuationDistance, this.dispersion ? $03ccd63b0299d6a7$var$dispersion : null);
            context.backdropAlpha = $03ccd63b0299d6a7$var$transmission;
            $03ccd63b0299d6a7$var$diffuseColor.a.mulAssign($03ccd63b0299d6a7$var$mix(1, context.backdrop.a, $03ccd63b0299d6a7$var$transmission));
        }
        super.start(builder);
    }
    // Fdez-Agüera's "Multiple-Scattering Microfacet Model for Real-Time Image Based Lighting"
    // Approximates multi-scattering in order to preserve energy.
    // http://www.jcgt.org/published/0008/01/03/
    computeMultiscattering(singleScatter, multiScatter, specularF90, f0, iridescenceF0 = null) {
        const dotNV = $03ccd63b0299d6a7$var$normalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
        const fab = $03ccd63b0299d6a7$var$DFGLUT({
            roughness: $03ccd63b0299d6a7$var$roughness,
            dotNV: dotNV
        });
        const Fr = iridescenceF0 ? $03ccd63b0299d6a7$var$iridescence.mix(f0, iridescenceF0) : f0;
        const FssEss = Fr.mul(fab.x).add(specularF90.mul(fab.y));
        const Ess = fab.x.add(fab.y);
        const Ems = Ess.oneMinus();
        const Favg = Fr.add(Fr.oneMinus().mul(0.047619)); // 1/21
        const Fms = FssEss.mul(Favg).div(Ems.mul(Favg).oneMinus());
        singleScatter.addAssign(FssEss);
        multiScatter.addAssign(Fms.mul(Ems));
    }
    /**
	 * Implements the direct light.
	 *
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }) {
        const dotNL = $03ccd63b0299d6a7$var$normalView.dot(lightDirection).clamp();
        const irradiance = dotNL.mul(lightColor).toVar();
        if (this.sheen === true) {
            this.sheenSpecularDirect.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Sheen({
                lightDirection: lightDirection
            })));
            const sheenAlbedoV = $03ccd63b0299d6a7$var$IBLSheenBRDF({
                normal: $03ccd63b0299d6a7$var$normalView,
                viewDir: $03ccd63b0299d6a7$var$positionViewDirection,
                roughness: $03ccd63b0299d6a7$var$sheenRoughness
            });
            const sheenAlbedoL = $03ccd63b0299d6a7$var$IBLSheenBRDF({
                normal: $03ccd63b0299d6a7$var$normalView,
                viewDir: lightDirection,
                roughness: $03ccd63b0299d6a7$var$sheenRoughness
            });
            const sheenEnergyComp = $03ccd63b0299d6a7$var$sheen.r.max($03ccd63b0299d6a7$var$sheen.g).max($03ccd63b0299d6a7$var$sheen.b).mul(sheenAlbedoV.max(sheenAlbedoL)).oneMinus();
            irradiance.mulAssign(sheenEnergyComp);
        }
        if (this.clearcoat === true) {
            const dotNLcc = $03ccd63b0299d6a7$var$clearcoatNormalView.dot(lightDirection).clamp();
            const ccIrradiance = dotNLcc.mul(lightColor);
            this.clearcoatSpecularDirect.addAssign(ccIrradiance.mul($03ccd63b0299d6a7$var$BRDF_GGX({
                lightDirection: lightDirection,
                f0: $03ccd63b0299d6a7$var$clearcoatF0,
                f90: $03ccd63b0299d6a7$var$clearcoatF90,
                roughness: $03ccd63b0299d6a7$var$clearcoatRoughness,
                normalView: $03ccd63b0299d6a7$var$clearcoatNormalView
            })));
        }
        reflectedLight.directDiffuse.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseContribution
        })));
        reflectedLight.directSpecular.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_GGX_Multiscatter({
            lightDirection: lightDirection,
            f0: $03ccd63b0299d6a7$var$specularColorBlended,
            f90: 1,
            roughness: $03ccd63b0299d6a7$var$roughness,
            f: this.iridescenceFresnel,
            USE_IRIDESCENCE: this.iridescence,
            USE_ANISOTROPY: this.anisotropy
        })));
    }
    /**
	 * This method is intended for implementing the direct light term for
	 * rect area light nodes.
	 *
	 * @param {Object} input - The input data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ directRectArea({ lightColor: lightColor, lightPosition: lightPosition, halfWidth: halfWidth, halfHeight: halfHeight, reflectedLight: reflectedLight, ltc_1: ltc_1, ltc_2: ltc_2 }) {
        const p0 = lightPosition.add(halfWidth).sub(halfHeight); // counterclockwise; light shines in local neg z direction
        const p1 = lightPosition.sub(halfWidth).sub(halfHeight);
        const p2 = lightPosition.sub(halfWidth).add(halfHeight);
        const p3 = lightPosition.add(halfWidth).add(halfHeight);
        const N = $03ccd63b0299d6a7$var$normalView;
        const V = $03ccd63b0299d6a7$var$positionViewDirection;
        const P = $03ccd63b0299d6a7$var$positionView.toVar();
        const uv = $03ccd63b0299d6a7$var$LTC_Uv({
            N: N,
            V: V,
            roughness: $03ccd63b0299d6a7$var$roughness
        });
        const t1 = ltc_1.sample(uv).toVar();
        const t2 = ltc_2.sample(uv).toVar();
        const mInv = $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(t1.x, 0, t1.y), $03ccd63b0299d6a7$var$vec3(0, 1, 0), $03ccd63b0299d6a7$var$vec3(t1.z, 0, t1.w)).toVar();
        // LTC Fresnel Approximation by Stephen Hill
        // http://blog.selfshadow.com/publications/s2016-advances/s2016_ltc_fresnel.pdf
        const fresnel = $03ccd63b0299d6a7$var$specularColorBlended.mul(t2.x).add($03ccd63b0299d6a7$var$specularF90.sub($03ccd63b0299d6a7$var$specularColorBlended).mul(t2.y)).toVar();
        reflectedLight.directSpecular.addAssign(lightColor.mul(fresnel).mul($03ccd63b0299d6a7$var$LTC_Evaluate({
            N: N,
            V: V,
            P: P,
            mInv: mInv,
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
        reflectedLight.directDiffuse.addAssign(lightColor.mul($03ccd63b0299d6a7$var$diffuseContribution).mul($03ccd63b0299d6a7$var$LTC_Evaluate({
            N: N,
            V: V,
            P: P,
            mInv: $03ccd63b0299d6a7$var$mat3(1, 0, 0, 0, 1, 0, 0, 0, 1),
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })));
        if (this.clearcoat === true) {
            const Ncc = $03ccd63b0299d6a7$var$clearcoatNormalView;
            const uvClearcoat = $03ccd63b0299d6a7$var$LTC_Uv({
                N: Ncc,
                V: V,
                roughness: $03ccd63b0299d6a7$var$clearcoatRoughness
            });
            const t1Clearcoat = ltc_1.sample(uvClearcoat);
            const t2Clearcoat = ltc_2.sample(uvClearcoat);
            const mInvClearcoat = $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(t1Clearcoat.x, 0, t1Clearcoat.y), $03ccd63b0299d6a7$var$vec3(0, 1, 0), $03ccd63b0299d6a7$var$vec3(t1Clearcoat.z, 0, t1Clearcoat.w));
            // LTC Fresnel Approximation for clearcoat
            const fresnelClearcoat = $03ccd63b0299d6a7$var$clearcoatF0.mul(t2Clearcoat.x).add($03ccd63b0299d6a7$var$clearcoatF90.sub($03ccd63b0299d6a7$var$clearcoatF0).mul(t2Clearcoat.y));
            this.clearcoatSpecularDirect.addAssign(lightColor.mul(fresnelClearcoat).mul($03ccd63b0299d6a7$var$LTC_Evaluate({
                N: Ncc,
                V: V,
                P: P,
                mInv: mInvClearcoat,
                p0: p0,
                p1: p1,
                p2: p2,
                p3: p3
            })));
        }
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        this.indirectDiffuse(builder);
        this.indirectSpecular(builder);
        this.ambientOcclusion(builder);
    }
    /**
	 * Implements the indirect diffuse term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirectDiffuse(builder) {
        const { irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        const diffuse = irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseContribution
        })).toVar();
        if (this.sheen === true) {
            const sheenAlbedo = $03ccd63b0299d6a7$var$IBLSheenBRDF({
                normal: $03ccd63b0299d6a7$var$normalView,
                viewDir: $03ccd63b0299d6a7$var$positionViewDirection,
                roughness: $03ccd63b0299d6a7$var$sheenRoughness
            });
            const sheenEnergyComp = $03ccd63b0299d6a7$var$sheen.r.max($03ccd63b0299d6a7$var$sheen.g).max($03ccd63b0299d6a7$var$sheen.b).mul(sheenAlbedo).oneMinus();
            diffuse.mulAssign(sheenEnergyComp);
        }
        reflectedLight.indirectDiffuse.addAssign(diffuse);
    }
    /**
	 * Implements the indirect specular term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirectSpecular(builder) {
        const { radiance: radiance, iblIrradiance: iblIrradiance, reflectedLight: reflectedLight } = builder.context;
        if (this.sheen === true) this.sheenSpecularIndirect.addAssign(iblIrradiance.mul($03ccd63b0299d6a7$var$sheen, $03ccd63b0299d6a7$var$IBLSheenBRDF({
            normal: $03ccd63b0299d6a7$var$normalView,
            viewDir: $03ccd63b0299d6a7$var$positionViewDirection,
            roughness: $03ccd63b0299d6a7$var$sheenRoughness
        })));
        if (this.clearcoat === true) {
            const dotNVcc = $03ccd63b0299d6a7$var$clearcoatNormalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp();
            const clearcoatEnv = $03ccd63b0299d6a7$var$EnvironmentBRDF({
                dotNV: dotNVcc,
                specularColor: $03ccd63b0299d6a7$var$clearcoatF0,
                specularF90: $03ccd63b0299d6a7$var$clearcoatF90,
                roughness: $03ccd63b0299d6a7$var$clearcoatRoughness
            });
            this.clearcoatSpecularIndirect.addAssign(this.clearcoatRadiance.mul(clearcoatEnv));
        }
        // Both indirect specular and indirect diffuse light accumulate here
        // Compute multiscattering separately for dielectric and metallic, then mix
        const singleScatteringDielectric = $03ccd63b0299d6a7$var$vec3().toVar('singleScatteringDielectric');
        const multiScatteringDielectric = $03ccd63b0299d6a7$var$vec3().toVar('multiScatteringDielectric');
        const singleScatteringMetallic = $03ccd63b0299d6a7$var$vec3().toVar('singleScatteringMetallic');
        const multiScatteringMetallic = $03ccd63b0299d6a7$var$vec3().toVar('multiScatteringMetallic');
        this.computeMultiscattering(singleScatteringDielectric, multiScatteringDielectric, $03ccd63b0299d6a7$var$specularF90, $03ccd63b0299d6a7$var$specularColor, this.iridescenceF0Dielectric);
        this.computeMultiscattering(singleScatteringMetallic, multiScatteringMetallic, $03ccd63b0299d6a7$var$specularF90, $03ccd63b0299d6a7$var$diffuseColor.rgb, this.iridescenceF0Metallic);
        // Mix based on metalness
        const singleScattering = $03ccd63b0299d6a7$var$mix(singleScatteringDielectric, singleScatteringMetallic, $03ccd63b0299d6a7$var$metalness);
        const multiScattering = $03ccd63b0299d6a7$var$mix(multiScatteringDielectric, multiScatteringMetallic, $03ccd63b0299d6a7$var$metalness);
        // Diffuse energy conservation uses dielectric path
        const totalScatteringDielectric = singleScatteringDielectric.add(multiScatteringDielectric);
        const diffuse = $03ccd63b0299d6a7$var$diffuseContribution.mul(totalScatteringDielectric.oneMinus());
        const cosineWeightedIrradiance = iblIrradiance.mul(1 / Math.PI);
        const indirectSpecular = radiance.mul(singleScattering).add(multiScattering.mul(cosineWeightedIrradiance)).toVar();
        const indirectDiffuse = diffuse.mul(cosineWeightedIrradiance).toVar();
        if (this.sheen === true) {
            const sheenAlbedo = $03ccd63b0299d6a7$var$IBLSheenBRDF({
                normal: $03ccd63b0299d6a7$var$normalView,
                viewDir: $03ccd63b0299d6a7$var$positionViewDirection,
                roughness: $03ccd63b0299d6a7$var$sheenRoughness
            });
            const sheenEnergyComp = $03ccd63b0299d6a7$var$sheen.r.max($03ccd63b0299d6a7$var$sheen.g).max($03ccd63b0299d6a7$var$sheen.b).mul(sheenAlbedo).oneMinus();
            indirectSpecular.mulAssign(sheenEnergyComp);
            indirectDiffuse.mulAssign(sheenEnergyComp);
        }
        reflectedLight.indirectSpecular.addAssign(indirectSpecular);
        reflectedLight.indirectDiffuse.addAssign(indirectDiffuse);
    }
    /**
	 * Implements the ambient occlusion term.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ ambientOcclusion(builder) {
        const { ambientOcclusion: ambientOcclusion, reflectedLight: reflectedLight } = builder.context;
        const dotNV = $03ccd63b0299d6a7$var$normalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp(); // @ TODO: Move to core dotNV
        const aoNV = dotNV.add(ambientOcclusion);
        const aoExp = $03ccd63b0299d6a7$var$roughness.mul(-16).oneMinus().negate().exp2();
        const aoNode = ambientOcclusion.sub(aoNV.pow(aoExp).oneMinus()).clamp();
        if (this.clearcoat === true) this.clearcoatSpecularIndirect.mulAssign(ambientOcclusion);
        if (this.sheen === true) this.sheenSpecularIndirect.mulAssign(ambientOcclusion);
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
        reflectedLight.indirectSpecular.mulAssign(aoNode);
    }
    /**
	 * Used for final lighting accumulations depending on the requested features.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish({ context: context }) {
        const { outgoingLight: outgoingLight } = context;
        if (this.clearcoat === true) {
            const dotNVcc = $03ccd63b0299d6a7$var$clearcoatNormalView.dot($03ccd63b0299d6a7$var$positionViewDirection).clamp();
            const Fcc = $03ccd63b0299d6a7$var$F_Schlick({
                dotVH: dotNVcc,
                f0: $03ccd63b0299d6a7$var$clearcoatF0,
                f90: $03ccd63b0299d6a7$var$clearcoatF90
            });
            const clearcoatLight = outgoingLight.mul($03ccd63b0299d6a7$var$clearcoat.mul(Fcc).oneMinus()).add(this.clearcoatSpecularDirect.add(this.clearcoatSpecularIndirect).mul($03ccd63b0299d6a7$var$clearcoat));
            outgoingLight.assign(clearcoatLight);
        }
        if (this.sheen === true) {
            const sheenLight = outgoingLight.add(this.sheenSpecularDirect, this.sheenSpecularIndirect.mul(1.0 / Math.PI));
            outgoingLight.assign(sheenLight);
        }
    }
}
// These defines must match with PMREMGenerator
const $03ccd63b0299d6a7$var$cubeUV_r0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(1.0);
const $03ccd63b0299d6a7$var$cubeUV_m0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(-2);
const $03ccd63b0299d6a7$var$cubeUV_r1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(0.8);
const $03ccd63b0299d6a7$var$cubeUV_m1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(-1);
const $03ccd63b0299d6a7$var$cubeUV_r4 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(0.4);
const $03ccd63b0299d6a7$var$cubeUV_m4 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(2.0);
const $03ccd63b0299d6a7$var$cubeUV_r5 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(0.305);
const $03ccd63b0299d6a7$var$cubeUV_m5 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(3.0);
const $03ccd63b0299d6a7$var$cubeUV_r6 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(0.21);
const $03ccd63b0299d6a7$var$cubeUV_m6 = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(4.0);
const $03ccd63b0299d6a7$var$cubeUV_minMipLevel = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(4.0);
const $03ccd63b0299d6a7$var$cubeUV_minTileSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$float(16.0);
// These shader functions convert between the UV coordinates of a single face of
// a cubemap, the 0-5 integer index of a cube face, and the direction vector for
// sampling a textureCube (not generally normalized ).
const $03ccd63b0299d6a7$var$getFace = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([direction])=>{
    const absDirection = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$abs(direction)).toVar();
    const face = $03ccd63b0299d6a7$var$float(-1).toVar();
    $03ccd63b0299d6a7$var$If(absDirection.x.greaterThan(absDirection.z), ()=>{
        $03ccd63b0299d6a7$var$If(absDirection.x.greaterThan(absDirection.y), ()=>{
            face.assign($03ccd63b0299d6a7$var$select(direction.x.greaterThan(0.0), 0.0, 3.0));
        }).Else(()=>{
            face.assign($03ccd63b0299d6a7$var$select(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    }).Else(()=>{
        $03ccd63b0299d6a7$var$If(absDirection.z.greaterThan(absDirection.y), ()=>{
            face.assign($03ccd63b0299d6a7$var$select(direction.z.greaterThan(0.0), 2.0, 5.0));
        }).Else(()=>{
            face.assign($03ccd63b0299d6a7$var$select(direction.y.greaterThan(0.0), 1.0, 4.0));
        });
    });
    return face;
}).setLayout({
    name: 'getFace',
    type: 'float',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        }
    ]
});
// RH coordinate system; PMREM face-indexing convention
const $03ccd63b0299d6a7$var$getUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([direction, face])=>{
    const uv = $03ccd63b0299d6a7$var$vec2().toVar();
    $03ccd63b0299d6a7$var$If(face.equal(0.0), ()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.z, direction.y).div($03ccd63b0299d6a7$var$abs(direction.x))); // pos x
    }).ElseIf(face.equal(1.0), ()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.x.negate(), direction.z.negate()).div($03ccd63b0299d6a7$var$abs(direction.y))); // pos y
    }).ElseIf(face.equal(2.0), ()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.x.negate(), direction.y).div($03ccd63b0299d6a7$var$abs(direction.z))); // pos z
    }).ElseIf(face.equal(3.0), ()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.z.negate(), direction.y).div($03ccd63b0299d6a7$var$abs(direction.x))); // neg x
    }).ElseIf(face.equal(4.0), ()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.x.negate(), direction.z).div($03ccd63b0299d6a7$var$abs(direction.y))); // neg y
    }).Else(()=>{
        uv.assign($03ccd63b0299d6a7$var$vec2(direction.x, direction.y).div($03ccd63b0299d6a7$var$abs(direction.z))); // neg z
    });
    return $03ccd63b0299d6a7$var$mul(0.5, uv.add(1.0));
}).setLayout({
    name: 'getUV',
    type: 'vec2',
    inputs: [
        {
            name: 'direction',
            type: 'vec3'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$roughnessToMip = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([roughness])=>{
    const mip = $03ccd63b0299d6a7$var$float(0.0).toVar();
    $03ccd63b0299d6a7$var$If(roughness.greaterThanEqual($03ccd63b0299d6a7$var$cubeUV_r1), ()=>{
        mip.assign($03ccd63b0299d6a7$var$cubeUV_r0.sub(roughness).mul($03ccd63b0299d6a7$var$cubeUV_m1.sub($03ccd63b0299d6a7$var$cubeUV_m0)).div($03ccd63b0299d6a7$var$cubeUV_r0.sub($03ccd63b0299d6a7$var$cubeUV_r1)).add($03ccd63b0299d6a7$var$cubeUV_m0));
    }).ElseIf(roughness.greaterThanEqual($03ccd63b0299d6a7$var$cubeUV_r4), ()=>{
        mip.assign($03ccd63b0299d6a7$var$cubeUV_r1.sub(roughness).mul($03ccd63b0299d6a7$var$cubeUV_m4.sub($03ccd63b0299d6a7$var$cubeUV_m1)).div($03ccd63b0299d6a7$var$cubeUV_r1.sub($03ccd63b0299d6a7$var$cubeUV_r4)).add($03ccd63b0299d6a7$var$cubeUV_m1));
    }).ElseIf(roughness.greaterThanEqual($03ccd63b0299d6a7$var$cubeUV_r5), ()=>{
        mip.assign($03ccd63b0299d6a7$var$cubeUV_r4.sub(roughness).mul($03ccd63b0299d6a7$var$cubeUV_m5.sub($03ccd63b0299d6a7$var$cubeUV_m4)).div($03ccd63b0299d6a7$var$cubeUV_r4.sub($03ccd63b0299d6a7$var$cubeUV_r5)).add($03ccd63b0299d6a7$var$cubeUV_m4));
    }).ElseIf(roughness.greaterThanEqual($03ccd63b0299d6a7$var$cubeUV_r6), ()=>{
        mip.assign($03ccd63b0299d6a7$var$cubeUV_r5.sub(roughness).mul($03ccd63b0299d6a7$var$cubeUV_m6.sub($03ccd63b0299d6a7$var$cubeUV_m5)).div($03ccd63b0299d6a7$var$cubeUV_r5.sub($03ccd63b0299d6a7$var$cubeUV_r6)).add($03ccd63b0299d6a7$var$cubeUV_m5));
    }).Else(()=>{
        mip.assign($03ccd63b0299d6a7$var$float(-2).mul($03ccd63b0299d6a7$var$log2($03ccd63b0299d6a7$var$mul(1.16, roughness)))); // 1.16 = 1.79^0.25
    });
    return mip;
}).setLayout({
    name: 'roughnessToMip',
    type: 'float',
    inputs: [
        {
            name: 'roughness',
            type: 'float'
        }
    ]
});
// RH coordinate system; PMREM face-indexing convention
const $03ccd63b0299d6a7$var$getDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv_immutable, face])=>{
    const uv = uv_immutable.toVar();
    uv.assign($03ccd63b0299d6a7$var$mul(2.0, uv).sub(1.0));
    const direction = $03ccd63b0299d6a7$var$vec3(uv, 1.0).toVar();
    $03ccd63b0299d6a7$var$If(face.equal(0.0), ()=>{
        direction.assign(direction.zyx); // ( 1, v, u ) pos x
    }).ElseIf(face.equal(1.0), ()=>{
        direction.assign(direction.xzy);
        direction.xz.mulAssign(-1); // ( -u, 1, -v ) pos y
    }).ElseIf(face.equal(2.0), ()=>{
        direction.x.mulAssign(-1); // ( -u, v, 1 ) pos z
    }).ElseIf(face.equal(3.0), ()=>{
        direction.assign(direction.zyx);
        direction.xz.mulAssign(-1); // ( -1, v, -u ) neg x
    }).ElseIf(face.equal(4.0), ()=>{
        direction.assign(direction.xzy);
        direction.xy.mulAssign(-1); // ( -u, -1, v ) neg y
    }).ElseIf(face.equal(5.0), ()=>{
        direction.z.mulAssign(-1); // ( u, v, -1 ) neg zS
    });
    return direction;
}).setLayout({
    name: 'getDirection',
    type: 'vec3',
    inputs: [
        {
            name: 'uv',
            type: 'vec2'
        },
        {
            name: 'face',
            type: 'float'
        }
    ]
});
//
const $03ccd63b0299d6a7$var$textureCubeUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([envMap, sampleDir_immutable, roughness_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const roughness = $03ccd63b0299d6a7$var$float(roughness_immutable);
    const sampleDir = $03ccd63b0299d6a7$var$vec3(sampleDir_immutable);
    const mip = $03ccd63b0299d6a7$var$clamp($03ccd63b0299d6a7$var$roughnessToMip(roughness), $03ccd63b0299d6a7$var$cubeUV_m0, CUBEUV_MAX_MIP);
    const mipF = $03ccd63b0299d6a7$var$fract(mip);
    const mipInt = $03ccd63b0299d6a7$var$floor(mip);
    const color0 = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$bilinearCubeUV(envMap, sampleDir, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
    $03ccd63b0299d6a7$var$If(mipF.notEqual(0.0), ()=>{
        const color1 = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$bilinearCubeUV(envMap, sampleDir, mipInt.add(1.0), CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP)).toVar();
        color0.assign($03ccd63b0299d6a7$var$mix(color0, color1, mipF));
    });
    return color0;
});
const $03ccd63b0299d6a7$var$bilinearCubeUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([envMap, direction_immutable, mipInt_immutable, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP])=>{
    const mipInt = $03ccd63b0299d6a7$var$float(mipInt_immutable).toVar();
    const direction = $03ccd63b0299d6a7$var$vec3(direction_immutable);
    const face = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$getFace(direction)).toVar();
    const filterInt = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$cubeUV_minMipLevel.sub(mipInt), 0.0)).toVar();
    mipInt.assign($03ccd63b0299d6a7$var$max$1(mipInt, $03ccd63b0299d6a7$var$cubeUV_minMipLevel));
    const faceSize = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$exp2(mipInt)).toVar();
    const uv = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$getUV(direction, face).mul(faceSize.sub(2.0)).add(1.0)).toVar();
    $03ccd63b0299d6a7$var$If(face.greaterThan(2.0), ()=>{
        uv.y.addAssign(faceSize);
        face.subAssign(3.0);
    });
    uv.x.addAssign(face.mul(faceSize));
    uv.x.addAssign(filterInt.mul($03ccd63b0299d6a7$var$mul(3.0, $03ccd63b0299d6a7$var$cubeUV_minTileSize)));
    uv.y.addAssign($03ccd63b0299d6a7$var$mul(4.0, $03ccd63b0299d6a7$var$exp2(CUBEUV_MAX_MIP).sub(faceSize)));
    uv.x.mulAssign(CUBEUV_TEXEL_WIDTH);
    uv.y.mulAssign(CUBEUV_TEXEL_HEIGHT);
    return envMap.sample(uv).grad($03ccd63b0299d6a7$var$vec2(), $03ccd63b0299d6a7$var$vec2()); // disable anisotropic filtering
});
const $03ccd63b0299d6a7$var$getSample = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ envMap: envMap, mipInt: mipInt, outputDirection: outputDirection, theta: theta, axis: axis, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const cosTheta = $03ccd63b0299d6a7$var$cos(theta);
    // Rodrigues' axis-angle rotation
    const sampleDirection = outputDirection.mul(cosTheta).add(axis.cross(outputDirection).mul($03ccd63b0299d6a7$var$sin(theta))).add(axis.mul(axis.dot(outputDirection).mul(cosTheta.oneMinus())));
    return $03ccd63b0299d6a7$var$bilinearCubeUV(envMap, sampleDirection, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP);
});
const $03ccd63b0299d6a7$var$blur = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ n: n, latitudinal: latitudinal, poleAxis: poleAxis, outputDirection: outputDirection, weights: weights, samples: samples, dTheta: dTheta, mipInt: mipInt, envMap: envMap, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const axis = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$select(latitudinal, poleAxis, $03ccd63b0299d6a7$var$cross(poleAxis, outputDirection))).toVar();
    $03ccd63b0299d6a7$var$If(axis.equal($03ccd63b0299d6a7$var$vec3(0.0)), ()=>{
        axis.assign($03ccd63b0299d6a7$var$vec3(outputDirection.z, 0.0, outputDirection.x.negate()));
    });
    axis.assign($03ccd63b0299d6a7$var$normalize(axis));
    const gl_FragColor = $03ccd63b0299d6a7$var$vec3().toVar();
    gl_FragColor.addAssign(weights.element(0).mul($03ccd63b0299d6a7$var$getSample({
        theta: 0.0,
        axis: axis,
        outputDirection: outputDirection,
        mipInt: mipInt,
        envMap: envMap,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    })));
    $03ccd63b0299d6a7$var$Loop({
        start: $03ccd63b0299d6a7$var$int(1),
        end: n
    }, ({ i: i })=>{
        $03ccd63b0299d6a7$var$If(i.greaterThanEqual(samples), ()=>{
            $03ccd63b0299d6a7$var$Break();
        });
        const theta = $03ccd63b0299d6a7$var$float(dTheta.mul($03ccd63b0299d6a7$var$float(i))).toVar();
        gl_FragColor.addAssign(weights.element(i).mul($03ccd63b0299d6a7$var$getSample({
            theta: theta.mul(-1),
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
        gl_FragColor.addAssign(weights.element(i).mul($03ccd63b0299d6a7$var$getSample({
            theta: theta,
            axis: axis,
            outputDirection: outputDirection,
            mipInt: mipInt,
            envMap: envMap,
            CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
            CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
            CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
        })));
    });
    return $03ccd63b0299d6a7$var$vec4(gl_FragColor, 1);
});
// GGX VNDF importance sampling functions
// Van der Corput radical inverse for generating quasi-random sequences
const $03ccd63b0299d6a7$var$radicalInverse_VdC = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([bits_immutable])=>{
    const bits = $03ccd63b0299d6a7$var$uint(bits_immutable).toVar();
    bits.assign(bits.shiftLeft($03ccd63b0299d6a7$var$uint(16)).bitOr(bits.shiftRight($03ccd63b0299d6a7$var$uint(16))));
    bits.assign(bits.bitAnd($03ccd63b0299d6a7$var$uint(0x55555555)).shiftLeft($03ccd63b0299d6a7$var$uint(1)).bitOr(bits.bitAnd($03ccd63b0299d6a7$var$uint(0xAAAAAAAA)).shiftRight($03ccd63b0299d6a7$var$uint(1))));
    bits.assign(bits.bitAnd($03ccd63b0299d6a7$var$uint(0x33333333)).shiftLeft($03ccd63b0299d6a7$var$uint(2)).bitOr(bits.bitAnd($03ccd63b0299d6a7$var$uint(0xCCCCCCCC)).shiftRight($03ccd63b0299d6a7$var$uint(2))));
    bits.assign(bits.bitAnd($03ccd63b0299d6a7$var$uint(0x0F0F0F0F)).shiftLeft($03ccd63b0299d6a7$var$uint(4)).bitOr(bits.bitAnd($03ccd63b0299d6a7$var$uint(0xF0F0F0F0)).shiftRight($03ccd63b0299d6a7$var$uint(4))));
    bits.assign(bits.bitAnd($03ccd63b0299d6a7$var$uint(0x00FF00FF)).shiftLeft($03ccd63b0299d6a7$var$uint(8)).bitOr(bits.bitAnd($03ccd63b0299d6a7$var$uint(0xFF00FF00)).shiftRight($03ccd63b0299d6a7$var$uint(8))));
    return $03ccd63b0299d6a7$var$float(bits).mul(2.3283064365386963e-10); // / 0x100000000
});
// Hammersley sequence for quasi-Monte Carlo sampling
const $03ccd63b0299d6a7$var$hammersley = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([i, N])=>{
    return $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$float(i).div($03ccd63b0299d6a7$var$float(N)), $03ccd63b0299d6a7$var$radicalInverse_VdC(i));
});
// GGX VNDF importance sampling (Eric Heitz 2018)
// "Sampling the GGX Distribution of Visible Normals"
// https://jcgt.org/published/0007/04/01/
const $03ccd63b0299d6a7$var$importanceSampleGGX_VNDF = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([Xi, V, roughness])=>{
    const alpha = roughness.mul(roughness).toConst();
    // Section 4.1: Orthonormal basis
    const T1 = $03ccd63b0299d6a7$var$vec3(1.0, 0.0, 0.0).toConst();
    const T2 = $03ccd63b0299d6a7$var$cross(V, T1).toConst();
    // Section 4.2: Parameterization of projected area
    const r = $03ccd63b0299d6a7$var$sqrt(Xi.x).toConst();
    const phi = $03ccd63b0299d6a7$var$mul(2.0, 3.14159265359).mul(Xi.y).toConst();
    const t1 = r.mul($03ccd63b0299d6a7$var$cos(phi)).toConst();
    const t2 = r.mul($03ccd63b0299d6a7$var$sin(phi)).toVar();
    const s = $03ccd63b0299d6a7$var$mul(0.5, V.z.add(1.0)).toConst();
    t2.assign(s.oneMinus().mul($03ccd63b0299d6a7$var$sqrt(t1.mul(t1).oneMinus())).add(s.mul(t2)));
    // Section 4.3: Reprojection onto hemisphere
    const Nh = T1.mul(t1).add(T2.mul(t2)).add(V.mul($03ccd63b0299d6a7$var$sqrt($03ccd63b0299d6a7$var$max$1(0.0, t1.mul(t1).add(t2.mul(t2)).oneMinus()))));
    // Section 3.4: Transform back to ellipsoid configuration
    return $03ccd63b0299d6a7$var$normalize($03ccd63b0299d6a7$var$vec3(alpha.mul(Nh.x), alpha.mul(Nh.y), $03ccd63b0299d6a7$var$max$1(0.0, Nh.z)));
});
// GGX convolution using VNDF importance sampling
const $03ccd63b0299d6a7$var$ggxConvolution = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ roughness: roughness, mipInt: mipInt, envMap: envMap, N_immutable: N_immutable, GGX_SAMPLES: GGX_SAMPLES, CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP: CUBEUV_MAX_MIP })=>{
    const N = $03ccd63b0299d6a7$var$vec3(N_immutable).toVar();
    const prefilteredColor = $03ccd63b0299d6a7$var$vec3(0.0).toVar();
    const totalWeight = $03ccd63b0299d6a7$var$float(0.0).toVar();
    // For very low roughness, just sample the environment directly
    $03ccd63b0299d6a7$var$If(roughness.lessThan(0.001), ()=>{
        prefilteredColor.assign($03ccd63b0299d6a7$var$bilinearCubeUV(envMap, N, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP));
    }).Else(()=>{
        // Tangent space basis for VNDF sampling
        const up = $03ccd63b0299d6a7$var$select($03ccd63b0299d6a7$var$abs(N.z).lessThan(0.999), $03ccd63b0299d6a7$var$vec3(0.0, 0.0, 1.0), $03ccd63b0299d6a7$var$vec3(1.0, 0.0, 0.0));
        const tangent = $03ccd63b0299d6a7$var$normalize($03ccd63b0299d6a7$var$cross(up, N)).toVar();
        const bitangent = $03ccd63b0299d6a7$var$cross(N, tangent).toVar();
        $03ccd63b0299d6a7$var$Loop({
            start: $03ccd63b0299d6a7$var$uint(0),
            end: GGX_SAMPLES
        }, ({ i: i })=>{
            const Xi = $03ccd63b0299d6a7$var$hammersley(i, GGX_SAMPLES);
            // For PMREM, V = N, so in tangent space V is always (0, 0, 1)
            const H_tangent = $03ccd63b0299d6a7$var$importanceSampleGGX_VNDF(Xi, $03ccd63b0299d6a7$var$vec3(0.0, 0.0, 1.0), roughness);
            // Transform H back to world space
            const H = $03ccd63b0299d6a7$var$normalize(tangent.mul(H_tangent.x).add(bitangent.mul(H_tangent.y)).add(N.mul(H_tangent.z)));
            const L = $03ccd63b0299d6a7$var$normalize(H.mul($03ccd63b0299d6a7$var$dot(N, H).mul(2.0)).sub(N));
            const NdotL = $03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$dot(N, L), 0.0);
            $03ccd63b0299d6a7$var$If(NdotL.greaterThan(0.0), ()=>{
                // Sample environment at fixed mip level
                // VNDF importance sampling handles the distribution filtering
                const sampleColor = $03ccd63b0299d6a7$var$bilinearCubeUV(envMap, L, mipInt, CUBEUV_TEXEL_WIDTH, CUBEUV_TEXEL_HEIGHT, CUBEUV_MAX_MIP);
                // Weight by NdotL for the split-sum approximation
                // VNDF PDF naturally accounts for the visible microfacet distribution
                prefilteredColor.addAssign(sampleColor.mul(NdotL));
                totalWeight.addAssign(NdotL);
            });
        });
        $03ccd63b0299d6a7$var$If(totalWeight.greaterThan(0.0), ()=>{
            prefilteredColor.assign(prefilteredColor.div(totalWeight));
        });
    });
    return $03ccd63b0299d6a7$var$vec4(prefilteredColor, 1.0);
});
const $03ccd63b0299d6a7$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const $03ccd63b0299d6a7$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const $03ccd63b0299d6a7$var$MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const $03ccd63b0299d6a7$var$GGX_SAMPLES = 512;
const $03ccd63b0299d6a7$var$_flatCamera = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
const $03ccd63b0299d6a7$var$_cubeCamera = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)(90, 1);
const $03ccd63b0299d6a7$var$_clearColor$2 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
let $03ccd63b0299d6a7$var$_oldTarget = null;
let $03ccd63b0299d6a7$var$_oldActiveCubeFace = 0;
let $03ccd63b0299d6a7$var$_oldActiveMipmapLevel = 0;
const $03ccd63b0299d6a7$var$_origin = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
// maps blur materials to their uniforms dictionary
const $03ccd63b0299d6a7$var$_uniformsMap = new WeakMap();
// WebGPU Face indices
const $03ccd63b0299d6a7$var$_faceLib = [
    3,
    1,
    5,
    0,
    4,
    2
];
const $03ccd63b0299d6a7$var$_direction = /*@__PURE__*/ $03ccd63b0299d6a7$var$getDirection($03ccd63b0299d6a7$var$uv$1(), $03ccd63b0299d6a7$var$attribute('faceIndex')).normalize();
const $03ccd63b0299d6a7$var$_outputDirection = /*@__PURE__*/ $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$_direction.x, $03ccd63b0299d6a7$var$_direction.y, $03ccd63b0299d6a7$var$_direction.z);
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class $03ccd63b0299d6a7$export$6add42717753e221 {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._blurMaterial = null;
        this._ggxMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._backgroundBox = null;
    }
    get _hasInitialized() {
        return this._renderer.hasInitialized();
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromScene}
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $03ccd63b0299d6a7$var$_origin, renderTarget: renderTarget = null } = options;
        this._setSize(size);
        if (this._hasInitialized === false) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('PMREMGenerator: ".fromScene()" called before the backend is initialized. Try using "await renderer.init()" instead.');
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            options.renderTarget = cubeUVRenderTarget;
            this.fromSceneAsync(scene, sigma, near, far, options);
            return cubeUVRenderTarget;
        }
        $03ccd63b0299d6a7$var$_oldTarget = this._renderer.getRenderTarget();
        $03ccd63b0299d6a7$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $03ccd63b0299d6a7$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTarget();
        cubeUVRenderTarget.depthBuffer = true;
        this._init(cubeUVRenderTarget);
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 *
	 * @deprecated
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @param {?RenderTarget} [options.renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} A Promise that resolve with the PMREM when the generation has been finished.
	 * @see {@link PMREMGenerator#fromScene}
	 */ async fromSceneAsync(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('PMREMGenerator: ".fromSceneAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this.fromScene(scene, sigma, near, far, options);
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromEquirectangularAsync}
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        if (this._hasInitialized === false) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('PMREMGenerator: .fromEquirectangular() called before the backend is initialized. Try using "await renderer.init()" instead.');
            this._setSizeFromTexture(equirectangular);
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            this.fromEquirectangularAsync(equirectangular, cubeUVRenderTarget);
            return cubeUVRenderTarget;
        }
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @deprecated
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromEquirectangular}
	 */ async fromEquirectangularAsync(equirectangular, renderTarget = null) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('PMREMGenerator: ".fromEquirectangularAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {RenderTarget} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromCubemapAsync}
	 */ fromCubemap(cubemap, renderTarget = null) {
        if (this._hasInitialized === false) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('PMREMGenerator: .fromCubemap() called before the backend is initialized. Try using .fromCubemapAsync() instead.');
            this._setSizeFromTexture(cubemap);
            const cubeUVRenderTarget = renderTarget || this._allocateTarget();
            this.fromCubemapAsync(cubemap, renderTarget);
            return cubeUVRenderTarget;
        }
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * with the 256 x 256 cubemap output.
	 *
	 * @deprecated
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?RenderTarget} [renderTarget=null] - The render target to use.
	 * @return {Promise<RenderTarget>} The resulting PMREM.
	 * @see {@link PMREMGenerator#fromCubemap}
	 */ async fromCubemapAsync(cubemap, renderTarget = null) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('PMREMGenerator: ".fromCubemapAsync()" is deprecated. Use "await renderer.init()" instead.'); // @deprecated r181
        await this._renderer.init();
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 *
	 * @returns {Promise}
	 */ async compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $03ccd63b0299d6a7$var$_getCubemapMaterial();
            await this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 *
	 * @returns {Promise}
	 */ async compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $03ccd63b0299d6a7$var$_getEquirectMaterial();
            await this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSizeFromTexture(texture) {
        if (texture.mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4) || texture.mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
    }
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($03ccd63b0299d6a7$var$_oldTarget, $03ccd63b0299d6a7$var$_oldActiveCubeFace, $03ccd63b0299d6a7$var$_oldActiveMipmapLevel);
        outputTarget.scissorTest = false;
        this._setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        this._setSizeFromTexture(texture);
        $03ccd63b0299d6a7$var$_oldTarget = this._renderer.getRenderTarget();
        $03ccd63b0299d6a7$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $03ccd63b0299d6a7$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        const cubeUVRenderTarget = renderTarget || this._allocateTarget();
        this._init(cubeUVRenderTarget);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTarget() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const cubeUVRenderTarget = $03ccd63b0299d6a7$var$_createRenderTarget(width, height);
        return cubeUVRenderTarget;
    }
    _init(renderTarget) {
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== renderTarget.width || this._pingPongRenderTarget.height !== renderTarget.height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $03ccd63b0299d6a7$var$_createRenderTarget(renderTarget.width, renderTarget.height);
            const { _lodMax: _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = $03ccd63b0299d6a7$var$_createPlanes(_lodMax));
            this._blurMaterial = $03ccd63b0299d6a7$var$_getBlurShader(_lodMax, renderTarget.width, renderTarget.height);
            this._ggxMaterial = $03ccd63b0299d6a7$var$_getGGXShader(_lodMax, renderTarget.width, renderTarget.height);
        }
    }
    async _compileMaterial(material) {
        const mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)(), material);
        await this._renderer.compile(mesh, $03ccd63b0299d6a7$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const cubeCamera = $03ccd63b0299d6a7$var$_cubeCamera;
        cubeCamera.near = near;
        cubeCamera.far = far;
        // px, py, pz, nx, ny, nz
        const upSign = [
            1,
            1,
            1,
            1,
            -1,
            1
        ];
        const forwardSign = [
            1,
            -1,
            1,
            -1,
            1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        renderer.getClearColor($03ccd63b0299d6a7$var$_clearColor$2);
        renderer.autoClear = false;
        if (this._backgroundBox === null) this._backgroundBox = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$33e43285f7406bd5)(), new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
            name: 'PMREM.Background',
            side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($03ccd63b0299d6a7$var$_clearColor$2);
            useSolidColor = true;
        }
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.clear();
        if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            this._setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.render(scene, cubeCamera);
        }
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $9ddd7e9b53f7a2d4$export$8759762a6477f2c4) || texture.mapping === (0, $9ddd7e9b53f7a2d4$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $03ccd63b0299d6a7$var$_getCubemapMaterial(texture);
        } else if (this._equirectMaterial === null) this._equirectMaterial = $03ccd63b0299d6a7$var$_getEquirectMaterial(texture);
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        material.fragmentNode.value = texture;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const size = this._cubeSize;
        this._setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $03ccd63b0299d6a7$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {RenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = $03ccd63b0299d6a7$var$_uniformsMap.get(ggxMaterial);
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax: _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $03ccd63b0299d6a7$var$LOD_MIN ? lodOut - _lodMax + $03ccd63b0299d6a7$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        cubeUVRenderTarget.texture.frame = (cubeUVRenderTarget.texture.frame || 0) + 1;
        ggxUniforms.envMap.value = cubeUVRenderTarget.texture;
        ggxUniforms.roughness.value = adjustedRoughness;
        ggxUniforms.mipInt.value = _lodMax - lodIn; // Sample from input LOD
        this._setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, $03ccd63b0299d6a7$var$_flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        pingPongRenderTarget.texture.frame = (pingPongRenderTarget.texture.frame || 0) + 1;
        ggxUniforms.envMap.value = pingPongRenderTarget.texture;
        ggxUniforms.roughness.value = 0.0; // Direct copy
        ggxUniforms.mipInt.value = _lodMax - lodOut; // Read from the level we just wrote
        this._setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, $03ccd63b0299d6a7$var$_flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {RenderTarget} cubeUVRenderTarget - The cubemap render target.
	 * @param {number} lodIn - The input level-of-detail.
	 * @param {number} lodOut - The output level-of-detail.
	 * @param {number} sigma - The blur radius in radians.
	 * @param {Vector3} [poleAxis] - The pole axis.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = $03ccd63b0299d6a7$var$_uniformsMap.get(blurMaterial);
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $03ccd63b0299d6a7$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $03ccd63b0299d6a7$var$MAX_SAMPLES;
        if (samples > $03ccd63b0299d6a7$var$MAX_SAMPLES) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$03ccd63b0299d6a7$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $03ccd63b0299d6a7$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        targetIn.texture.frame = (targetIn.texture.frame || 0) + 1;
        blurUniforms.envMap.value = targetIn.texture;
        blurUniforms.samples.value = samples;
        blurUniforms.weights.array = weights;
        blurUniforms.latitudinal.value = direction === 'latitudinal' ? 1 : 0;
        if (poleAxis) blurUniforms.poleAxis.value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms.dTheta.value = radiansPerPixel;
        blurUniforms.mipInt.value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $03ccd63b0299d6a7$var$LOD_MIN ? lodOut - _lodMax + $03ccd63b0299d6a7$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        this._setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $03ccd63b0299d6a7$var$_flatCamera);
    }
    _setViewport(target, x, y, width, height) {
        if (this._renderer.isWebGLRenderer) {
            target.viewport.set(x, target.height - height - y, width, height);
            target.scissor.set(x, target.height - height - y, width, height);
        } else {
            target.viewport.set(x, y, width, height);
            target.scissor.set(x, y, width, height);
        }
    }
}
function $03ccd63b0299d6a7$var$_createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - $03ccd63b0299d6a7$var$LOD_MIN + 1 + $03ccd63b0299d6a7$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $03ccd63b0299d6a7$var$LOD_MIN) sigma = $03ccd63b0299d6a7$var$EXTRA_LOD_SIGMA[i - lodMax + $03ccd63b0299d6a7$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            const faceIdx = $03ccd63b0299d6a7$var$_faceLib[face];
            position.set(coordinates, positionSize * vertices * faceIdx);
            uv.set(uv1, uvSize * vertices * faceIdx);
            const fill = [
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx,
                faceIdx
            ];
            faceIndex.set(fill, faceIndexSize * vertices * faceIdx);
        }
        const planes = new (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(planes, null));
        if (lod > $03ccd63b0299d6a7$var$LOD_MIN) lod--;
    }
    return {
        lodMeshes: lodMeshes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $03ccd63b0299d6a7$var$_createRenderTarget(width, height) {
    const params = {
        magFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
        minFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
        generateMipmaps: false,
        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
        format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
        colorSpace: (0, $9ddd7e9b53f7a2d4$export$42429b3acfb233a4)
    };
    const cubeUVRenderTarget = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.texture.isPMREMTexture = true;
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $03ccd63b0299d6a7$var$_getMaterial(type) {
    const material = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
    material.depthTest = false;
    material.depthWrite = false;
    material.blending = (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
    material.name = `PMREM_${type}`;
    return material;
}
function $03ccd63b0299d6a7$var$_getBlurShader(lodMax, width, height) {
    const weights = $03ccd63b0299d6a7$var$uniformArray(new Array($03ccd63b0299d6a7$var$MAX_SAMPLES).fill(0));
    const poleAxis = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0));
    const dTheta = $03ccd63b0299d6a7$var$uniform(0);
    const n = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$MAX_SAMPLES);
    const latitudinal = $03ccd63b0299d6a7$var$uniform(0); // false, bool
    const samples = $03ccd63b0299d6a7$var$uniform(1); // int
    const envMap = $03ccd63b0299d6a7$var$texture();
    const mipInt = $03ccd63b0299d6a7$var$uniform(0); // int
    const CUBEUV_TEXEL_WIDTH = $03ccd63b0299d6a7$var$float(1 / width);
    const CUBEUV_TEXEL_HEIGHT = $03ccd63b0299d6a7$var$float(1 / height);
    const CUBEUV_MAX_MIP = $03ccd63b0299d6a7$var$float(lodMax);
    const materialUniforms = {
        n: n,
        latitudinal: latitudinal,
        weights: weights,
        poleAxis: poleAxis,
        outputDirection: $03ccd63b0299d6a7$var$_outputDirection,
        dTheta: dTheta,
        samples: samples,
        envMap: envMap,
        mipInt: mipInt,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    };
    const material = $03ccd63b0299d6a7$var$_getMaterial('blur');
    material.fragmentNode = $03ccd63b0299d6a7$var$blur({
        ...materialUniforms,
        latitudinal: latitudinal.equal(1)
    });
    $03ccd63b0299d6a7$var$_uniformsMap.set(material, materialUniforms);
    return material;
}
function $03ccd63b0299d6a7$var$_getGGXShader(lodMax, width, height) {
    const envMap = $03ccd63b0299d6a7$var$texture();
    const roughness = $03ccd63b0299d6a7$var$uniform(0);
    const mipInt = $03ccd63b0299d6a7$var$uniform(0);
    const CUBEUV_TEXEL_WIDTH = $03ccd63b0299d6a7$var$float(1 / width);
    const CUBEUV_TEXEL_HEIGHT = $03ccd63b0299d6a7$var$float(1 / height);
    const CUBEUV_MAX_MIP = $03ccd63b0299d6a7$var$float(lodMax);
    const materialUniforms = {
        envMap: envMap,
        roughness: roughness,
        mipInt: mipInt,
        CUBEUV_TEXEL_WIDTH: CUBEUV_TEXEL_WIDTH,
        CUBEUV_TEXEL_HEIGHT: CUBEUV_TEXEL_HEIGHT,
        CUBEUV_MAX_MIP: CUBEUV_MAX_MIP
    };
    const material = $03ccd63b0299d6a7$var$_getMaterial('ggx');
    material.fragmentNode = $03ccd63b0299d6a7$var$ggxConvolution({
        ...materialUniforms,
        N_immutable: $03ccd63b0299d6a7$var$_outputDirection,
        GGX_SAMPLES: $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$GGX_SAMPLES)
    });
    $03ccd63b0299d6a7$var$_uniformsMap.set(material, materialUniforms);
    return material;
}
function $03ccd63b0299d6a7$var$_getCubemapMaterial(envTexture) {
    const material = $03ccd63b0299d6a7$var$_getMaterial('cubemap');
    material.fragmentNode = $03ccd63b0299d6a7$var$cubeTexture(envTexture, $03ccd63b0299d6a7$var$_outputDirection);
    return material;
}
function $03ccd63b0299d6a7$var$_getEquirectMaterial(envTexture) {
    const material = $03ccd63b0299d6a7$var$_getMaterial('equirect');
    material.fragmentNode = $03ccd63b0299d6a7$var$texture(envTexture, $03ccd63b0299d6a7$var$equirectUV($03ccd63b0299d6a7$var$_outputDirection), 0);
    return material;
}
const $03ccd63b0299d6a7$var$_cache = new WeakMap();
/**
 * Generates the cubeUV size based on the given image height.
 *
 * @private
 * @param {number} imageHeight - The image height.
 * @return {{texelWidth: number,texelHeight: number, maxMip: number}} The result object.
 */ function $03ccd63b0299d6a7$var$_generateCubeUVSize(imageHeight) {
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
/**
 * Generates a PMREM from the given texture.
 *
 * @private
 * @param {Texture} texture - The texture to create the PMREM for.
 * @param {Renderer} renderer - The renderer.
 * @param {PMREMGenerator} generator - The PMREM generator.
 * @return {?Texture} The PMREM.
 */ function $03ccd63b0299d6a7$var$_getPMREMFromTexture(texture, renderer, generator) {
    const cache = $03ccd63b0299d6a7$var$_getCache(renderer);
    let cacheTexture = cache.get(texture);
    const pmremVersion = cacheTexture !== undefined ? cacheTexture.pmremVersion : -1;
    if (pmremVersion !== texture.pmremVersion) {
        const image = texture.image;
        if (texture.isCubeTexture) {
            if ($03ccd63b0299d6a7$var$isCubeMapReady(image)) cacheTexture = generator.fromCubemap(texture, cacheTexture);
            else return null;
        } else {
            if ($03ccd63b0299d6a7$var$isEquirectangularMapReady(image)) cacheTexture = generator.fromEquirectangular(texture, cacheTexture);
            else return null;
        }
        cacheTexture.pmremVersion = texture.pmremVersion;
        cache.set(texture, cacheTexture);
    }
    return cacheTexture.texture;
}
/**
 * Returns a cache that stores generated PMREMs for the respective textures.
 * A cache must be maintained per renderer since PMREMs are render target textures
 * which can't be shared across render contexts.
 *
 * @private
 * @param {Renderer} renderer - The renderer.
 * @return {WeakMap<Texture, Texture>} The PMREM cache.
 */ function $03ccd63b0299d6a7$var$_getCache(renderer) {
    let rendererCache = $03ccd63b0299d6a7$var$_cache.get(renderer);
    if (rendererCache === undefined) {
        rendererCache = new WeakMap();
        $03ccd63b0299d6a7$var$_cache.set(renderer, rendererCache);
    }
    return rendererCache;
}
/**
 * This node represents a PMREM which is a special type of preprocessed
 * environment map intended for PBR materials.
 *
 * ```js
 * const material = new MeshStandardNodeMaterial();
 * material.envNode = pmremTexture( envMap );
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$34829f7f4dba1981 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'PMREMNode';
    }
    /**
	 * Constructs a new function overloading node.
	 *
	 * @param {Texture} value - The input texture.
	 * @param {Node<vec2>} [uvNode=null] - The uv node.
	 * @param {Node<float>} [levelNode=null] - The level node.
	 */ constructor(value, uvNode = null, levelNode = null){
        super('vec3');
        /**
		 * Reference to the input texture.
		 *
		 * @private
		 * @type {Texture}
		 */ this._value = value;
        /**
		 * Reference to the generated PMREM.
		 *
		 * @private
		 * @type {Texture | null}
		 * @default null
		 */ this._pmrem = null;
        /**
		 *  The uv node.
		 *
		 * @type {Node<vec2>}
		 */ this.uvNode = uvNode;
        /**
		 *  The level node.
		 *
		 * @type {Node<float>}
		 */ this.levelNode = levelNode;
        /**
		 * Reference to a PMREM generator.
		 *
		 * @private
		 * @type {?PMREMGenerator}
		 * @default null
		 */ this._generator = null;
        const defaultTexture = new (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a)();
        defaultTexture.isRenderTargetTexture = true;
        /**
		 * The texture node holding the generated PMREM.
		 *
		 * @private
		 * @type {TextureNode}
		 */ this._texture = $03ccd63b0299d6a7$var$texture(defaultTexture);
        /**
		 * A uniform representing the PMREM's width.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._width = $03ccd63b0299d6a7$var$uniform(0);
        /**
		 * A uniform representing the PMREM's height.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._height = $03ccd63b0299d6a7$var$uniform(0);
        /**
		 * A uniform representing the PMREM's max Mip.
		 *
		 * @private
		 * @type {UniformNode<float>}
		 */ this._maxMip = $03ccd63b0299d6a7$var$uniform(0);
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER`.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
    }
    set value(value) {
        this._value = value;
        this._pmrem = null;
    }
    /**
	 * The node's texture value.
	 *
	 * @type {Texture}
	 */ get value() {
        return this._value;
    }
    /**
	 * Uses the given PMREM texture to update internal values.
	 *
	 * @param {Texture} texture - The PMREM texture.
	 */ updateFromTexture(texture) {
        const cubeUVSize = $03ccd63b0299d6a7$var$_generateCubeUVSize(texture.image.height);
        this._texture.value = texture;
        this._width.value = cubeUVSize.texelWidth;
        this._height.value = cubeUVSize.texelHeight;
        this._maxMip.value = cubeUVSize.maxMip;
    }
    updateBefore(frame) {
        let pmrem = this._pmrem;
        const pmremVersion = pmrem ? pmrem.pmremVersion : -1;
        const texture = this._value;
        if (pmremVersion !== texture.pmremVersion) {
            if (texture.isPMREMTexture === true) pmrem = texture;
            else pmrem = $03ccd63b0299d6a7$var$_getPMREMFromTexture(texture, frame.renderer, this._generator);
            if (pmrem !== null) {
                this._pmrem = pmrem;
                this.updateFromTexture(pmrem);
            }
        }
    }
    setup(builder) {
        if (this._generator === null) this._generator = new $03ccd63b0299d6a7$export$6add42717753e221(builder.renderer);
        this.updateBefore(builder);
        //
        let uvNode = this.uvNode;
        if (uvNode === null && builder.context.getUV) uvNode = builder.context.getUV(this, builder);
        //
        uvNode = $03ccd63b0299d6a7$var$materialEnvRotation.mul($03ccd63b0299d6a7$var$vec3(uvNode.x, uvNode.y.negate(), uvNode.z));
        //
        let levelNode = this.levelNode;
        if (levelNode === null && builder.context.getTextureLevel) levelNode = builder.context.getTextureLevel(this);
        //
        return $03ccd63b0299d6a7$var$textureCubeUV(this._texture, uvNode, levelNode, this._width, this._height, this._maxMip);
    }
    dispose() {
        super.dispose();
        if (this._generator !== null) this._generator.dispose();
    }
}
/**
 * Returns `true` if the given cube map image has been fully loaded.
 *
 * @private
 * @param {?Array<(Image|Object)>} [image] - The cube map image.
 * @return {boolean} Whether the given cube map is ready or not.
 */ function $03ccd63b0299d6a7$var$isCubeMapReady(image) {
    if (image === null || image === undefined) return false;
    let count = 0;
    const length = 6;
    for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
    return count === length;
}
/**
 * Returns `true` if the given equirectangular image has been fully loaded.
 *
 * @private
 * @param {(Image|Object)} image - The equirectangular image.
 * @return {boolean} Whether the given cube map is ready or not.
 */ function $03ccd63b0299d6a7$var$isEquirectangularMapReady(image) {
    if (image === null || image === undefined) return false;
    return image.height > 0;
}
/**
 * TSL function for creating a PMREM node.
 *
 * @tsl
 * @function
 * @param {Texture} value - The input texture.
 * @param {?Node<vec2>} [uvNode=null] - The uv node.
 * @param {?Node<float>} [levelNode=null] - The level node.
 * @returns {PMREMNode}
 */ const $03ccd63b0299d6a7$var$pmremTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$34829f7f4dba1981).setParameterLength(1, 3);
const $03ccd63b0299d6a7$var$_rendererCache = new WeakMap();
/**
 * Represents a physical model for Image-based lighting (IBL). The environment
 * is defined via environment maps in the equirectangular, cube map or cubeUV (PMREM) format.
 * `EnvironmentNode` is intended for PBR materials like {@link MeshStandardNodeMaterial}.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$d2178f54b36ca231 extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'EnvironmentNode';
    }
    /**
	 * Constructs a new environment node.
	 *
	 * @param {Node} [envNode=null] - A node representing the environment.
	 */ constructor(envNode = null){
        super();
        /**
		 * A node representing the environment.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.envNode = envNode;
    }
    setup(builder) {
        const { material: material } = builder;
        let envNode = this.envNode;
        if (envNode.isTextureNode || envNode.isMaterialReferenceNode) {
            const value = envNode.isTextureNode ? envNode.value : material[envNode.property];
            const cache = this._getPMREMNodeCache(builder.renderer);
            let cacheEnvNode = cache.get(value);
            if (cacheEnvNode === undefined) {
                cacheEnvNode = $03ccd63b0299d6a7$var$pmremTexture(value);
                cache.set(value, cacheEnvNode);
            }
            envNode = cacheEnvNode;
        }
        //
        const useAnisotropy = material.useAnisotropy === true || material.anisotropy > 0;
        const radianceNormalView = useAnisotropy ? $03ccd63b0299d6a7$var$bentNormalView : $03ccd63b0299d6a7$var$normalView;
        const radiance = envNode.context($03ccd63b0299d6a7$var$createRadianceContext($03ccd63b0299d6a7$var$roughness, radianceNormalView)).mul($03ccd63b0299d6a7$var$materialEnvIntensity);
        const irradiance = envNode.context($03ccd63b0299d6a7$var$createIrradianceContext($03ccd63b0299d6a7$var$normalWorld)).mul(Math.PI).mul($03ccd63b0299d6a7$var$materialEnvIntensity);
        const isolateRadiance = $03ccd63b0299d6a7$var$isolate(radiance);
        const isolateIrradiance = $03ccd63b0299d6a7$var$isolate(irradiance);
        //
        builder.context.radiance.addAssign(isolateRadiance);
        builder.context.iblIrradiance.addAssign(isolateIrradiance);
        //
        const clearcoatRadiance = builder.context.lightingModel.clearcoatRadiance;
        if (clearcoatRadiance) {
            const clearcoatRadianceContext = envNode.context($03ccd63b0299d6a7$var$createRadianceContext($03ccd63b0299d6a7$var$clearcoatRoughness, $03ccd63b0299d6a7$var$clearcoatNormalView)).mul($03ccd63b0299d6a7$var$materialEnvIntensity);
            const isolateClearcoatRadiance = $03ccd63b0299d6a7$var$isolate(clearcoatRadianceContext);
            clearcoatRadiance.addAssign(isolateClearcoatRadiance);
        }
    }
    /**
	 * Returns the PMREM node cache of the current renderer.
	 *
	 * @private
	 * @param {Renderer} renderer - The current renderer.
	 * @return {WeakMap} The node cache.
	 */ _getPMREMNodeCache(renderer) {
        let pmremCache = $03ccd63b0299d6a7$var$_rendererCache.get(renderer);
        if (pmremCache === undefined) {
            pmremCache = new WeakMap();
            $03ccd63b0299d6a7$var$_rendererCache.set(renderer, pmremCache);
        }
        return pmremCache;
    }
}
const $03ccd63b0299d6a7$var$createRadianceContext = (roughnessNode, normalViewNode)=>{
    let reflectVec = null;
    return {
        getUV: ()=>{
            if (reflectVec === null) {
                reflectVec = $03ccd63b0299d6a7$var$positionViewDirection.negate().reflect(normalViewNode);
                // Mixing the reflection with the normal is more accurate and keeps rough objects from gathering light from behind their tangent plane.
                reflectVec = $03ccd63b0299d6a7$var$pow4(roughnessNode).mix(reflectVec, normalViewNode).normalize();
                reflectVec = reflectVec.transformDirection($03ccd63b0299d6a7$var$cameraViewMatrix);
            }
            return reflectVec;
        },
        getTextureLevel: ()=>{
            return roughnessNode;
        }
    };
};
const $03ccd63b0299d6a7$var$createIrradianceContext = (normalWorldNode)=>{
    return {
        getUV: ()=>{
            return normalWorldNode;
        },
        getTextureLevel: ()=>{
            return $03ccd63b0299d6a7$var$float(1.0);
        }
    };
};
const $03ccd63b0299d6a7$var$_defaultValues$6 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$f2980790215acccd)();
/**
 * Node material version of {@link MeshStandardMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$92edd3f060e85562 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshStandardNodeMaterial';
    }
    /**
	 * Constructs a new mesh standard node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardNodeMaterial = true;
        /**
		 * Set to `true` because standard materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * The emissive color of standard materials is by default inferred from the `emissive`,
		 * `emissiveIntensity` and `emissiveMap` properties. This node property allows to
		 * overwrite the default and define the emissive color with a node instead.
		 *
		 * If you don't want to overwrite the emissive color but modify the existing
		 * value instead, use {@link materialEmissive}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.emissiveNode = null;
        /**
		 * The metalness of standard materials is by default inferred from the `metalness`,
		 * and `metalnessMap` properties. This node property allows to
		 * overwrite the default and define the metalness with a node instead.
		 *
		 * If you don't want to overwrite the metalness but modify the existing
		 * value instead, use {@link materialMetalness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.metalnessNode = null;
        /**
		 * The roughness of standard materials is by default inferred from the `roughness`,
		 * and `roughnessMap` properties. This node property allows to
		 * overwrite the default and define the roughness with a node instead.
		 *
		 * If you don't want to overwrite the roughness but modify the existing
		 * value instead, use {@link materialRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.roughnessNode = null;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$6);
        this.setValues(parameters);
    }
    /**
	 * Overwritten since this type of material uses {@link EnvironmentNode}
	 * to implement the PBR (PMREM based) environment mapping. Besides, the
	 * method honors `Scene.environment`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {?EnvironmentNode<vec3>} The environment node.
	 */ setupEnvironment(builder) {
        let envNode = super.setupEnvironment(builder);
        if (envNode === null && builder.environmentNode) envNode = builder.environmentNode;
        return envNode ? new $03ccd63b0299d6a7$export$d2178f54b36ca231(envNode) : null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhysicalLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$export$b69e16149fd7d508();
    }
    /**
	 * Setups the specular related node variables.
	 */ setupSpecular() {
        const specularColorNode = $03ccd63b0299d6a7$var$mix($03ccd63b0299d6a7$var$vec3(0.04), $03ccd63b0299d6a7$var$diffuseColor.rgb, $03ccd63b0299d6a7$var$metalness);
        $03ccd63b0299d6a7$var$specularColor.assign($03ccd63b0299d6a7$var$vec3(0.04));
        $03ccd63b0299d6a7$var$specularColorBlended.assign(specularColorNode);
        $03ccd63b0299d6a7$var$specularF90.assign(1.0);
    }
    /**
	 * Setups the standard specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants() {
        // METALNESS
        const metalnessNode = this.metalnessNode ? $03ccd63b0299d6a7$var$float(this.metalnessNode) : $03ccd63b0299d6a7$var$materialMetalness;
        $03ccd63b0299d6a7$var$metalness.assign(metalnessNode);
        // ROUGHNESS
        let roughnessNode = this.roughnessNode ? $03ccd63b0299d6a7$var$float(this.roughnessNode) : $03ccd63b0299d6a7$var$materialRoughness;
        roughnessNode = $03ccd63b0299d6a7$var$getRoughness({
            roughness: roughnessNode
        });
        $03ccd63b0299d6a7$var$roughness.assign(roughnessNode);
        // SPECULAR COLOR
        this.setupSpecular();
        // DIFFUSE COLOR
        $03ccd63b0299d6a7$var$diffuseContribution.assign($03ccd63b0299d6a7$var$diffuseColor.rgb.mul(metalnessNode.oneMinus()));
    }
    copy(source) {
        this.emissiveNode = source.emissiveNode;
        this.metalnessNode = source.metalnessNode;
        this.roughnessNode = source.roughnessNode;
        return super.copy(source);
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$5 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$28d04986c4269c9f)();
/**
 * Node material version of {@link MeshPhysicalMaterial}.
 *
 * @augments MeshStandardNodeMaterial
 */ class $03ccd63b0299d6a7$export$f336706882be0d39 extends $03ccd63b0299d6a7$export$92edd3f060e85562 {
    static get type() {
        return 'MeshPhysicalNodeMaterial';
    }
    /**
	 * Constructs a new mesh physical node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalNodeMaterial = true;
        /**
		 * The clearcoat of physical materials is by default inferred from the `clearcoat`
		 * and `clearcoatMap` properties. This node property allows to overwrite the default
		 * and define the clearcoat with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat but modify the existing
		 * value instead, use {@link materialClearcoat}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.clearcoatNode = null;
        /**
		 * The clearcoat roughness of physical materials is by default inferred from the `clearcoatRoughness`
		 * and `clearcoatRoughnessMap` properties. This node property allows to overwrite the default
		 * and define the clearcoat roughness with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat roughness but modify the existing
		 * value instead, use {@link materialClearcoatRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.clearcoatRoughnessNode = null;
        /**
		 * The clearcoat normal of physical materials is by default inferred from the `clearcoatNormalMap`
		 * property. This node property allows to overwrite the default
		 * and define the clearcoat normal with a node instead.
		 *
		 * If you don't want to overwrite the clearcoat normal but modify the existing
		 * value instead, use {@link materialClearcoatNormal}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.clearcoatNormalNode = null;
        /**
		 * The sheen of physical materials is by default inferred from the `sheen`, `sheenColor`
		 * and `sheenColorMap` properties. This node property allows to overwrite the default
		 * and define the sheen with a node instead.
		 *
		 * If you don't want to overwrite the sheen but modify the existing
		 * value instead, use {@link materialSheen}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.sheenNode = null;
        /**
		 * The sheen roughness of physical materials is by default inferred from the `sheenRoughness` and
		 * `sheenRoughnessMap` properties. This node property allows to overwrite the default
		 * and define the sheen roughness with a node instead.
		 *
		 * If you don't want to overwrite the sheen roughness but modify the existing
		 * value instead, use {@link materialSheenRoughness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.sheenRoughnessNode = null;
        /**
		 * The iridescence of physical materials is by default inferred from the `iridescence`
		 * property. This node property allows to overwrite the default
		 * and define the iridescence with a node instead.
		 *
		 * If you don't want to overwrite the iridescence but modify the existing
		 * value instead, use {@link materialIridescence}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceNode = null;
        /**
		 * The iridescence IOR of physical materials is by default inferred from the `iridescenceIOR`
		 * property. This node property allows to overwrite the default
		 * and define the iridescence IOR with a node instead.
		 *
		 * If you don't want to overwrite the iridescence IOR but modify the existing
		 * value instead, use {@link materialIridescenceIOR}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceIORNode = null;
        /**
		 * The iridescence thickness of physical materials is by default inferred from the `iridescenceThicknessRange`
		 * and `iridescenceThicknessMap` properties. This node property allows to overwrite the default
		 * and define the iridescence thickness with a node instead.
		 *
		 * If you don't want to overwrite the iridescence thickness but modify the existing
		 * value instead, use {@link materialIridescenceThickness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iridescenceThicknessNode = null;
        /**
		 * The specular intensity of physical materials is by default inferred from the `specularIntensity`
		 * and `specularIntensityMap` properties. This node property allows to overwrite the default
		 * and define the specular intensity with a node instead.
		 *
		 * If you don't want to overwrite the specular intensity but modify the existing
		 * value instead, use {@link materialSpecularIntensity}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.specularIntensityNode = null;
        /**
		 * The specular color of physical materials is by default inferred from the `specularColor`
		 * and `specularColorMap` properties. This node property allows to overwrite the default
		 * and define the specular color with a node instead.
		 *
		 * If you don't want to overwrite the specular color but modify the existing
		 * value instead, use {@link materialSpecularColor}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.specularColorNode = null;
        /**
		 * The ior of physical materials is by default inferred from the `ior`
		 * property. This node property allows to overwrite the default
		 * and define the ior with a node instead.
		 *
		 * If you don't want to overwrite the ior but modify the existing
		 * value instead, use {@link materialIOR}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.iorNode = null;
        /**
		 * The transmission of physical materials is by default inferred from the `transmission` and
		 * `transmissionMap` properties. This node property allows to overwrite the default
		 * and define the transmission with a node instead.
		 *
		 * If you don't want to overwrite the transmission but modify the existing
		 * value instead, use {@link materialTransmission}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.transmissionNode = null;
        /**
		 * The thickness of physical materials is by default inferred from the `thickness` and
		 * `thicknessMap` properties. This node property allows to overwrite the default
		 * and define the thickness with a node instead.
		 *
		 * If you don't want to overwrite the thickness but modify the existing
		 * value instead, use {@link materialThickness}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.thicknessNode = null;
        /**
		 * The attenuation distance of physical materials is by default inferred from the
		 * `attenuationDistance` property. This node property allows to overwrite the default
		 * and define the attenuation distance with a node instead.
		 *
		 * If you don't want to overwrite the attenuation distance but modify the existing
		 * value instead, use {@link materialAttenuationDistance}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.attenuationDistanceNode = null;
        /**
		 * The attenuation color of physical materials is by default inferred from the
		 * `attenuationColor` property. This node property allows to overwrite the default
		 * and define the attenuation color with a node instead.
		 *
		 * If you don't want to overwrite the attenuation color but modify the existing
		 * value instead, use {@link materialAttenuationColor}.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.attenuationColorNode = null;
        /**
		 * The dispersion of physical materials is by default inferred from the
		 * `dispersion` property. This node property allows to overwrite the default
		 * and define the dispersion with a node instead.
		 *
		 * If you don't want to overwrite the dispersion but modify the existing
		 * value instead, use {@link materialDispersion}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.dispersionNode = null;
        /**
		 * The anisotropy of physical materials is by default inferred from the
		 * `anisotropy` property. This node property allows to overwrite the default
		 * and define the anisotropy with a node instead.
		 *
		 * If you don't want to overwrite the anisotropy but modify the existing
		 * value instead, use {@link materialAnisotropy}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.anisotropyNode = null;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$5);
        this.setValues(parameters);
    }
    /**
	 * Whether the lighting model should use clearcoat or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useClearcoat() {
        return this.clearcoat > 0 || this.clearcoatNode !== null;
    }
    /**
	 * Whether the lighting model should use iridescence or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useIridescence() {
        return this.iridescence > 0 || this.iridescenceNode !== null;
    }
    /**
	 * Whether the lighting model should use sheen or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useSheen() {
        return this.sheen > 0 || this.sheenNode !== null;
    }
    /**
	 * Whether the lighting model should use anisotropy or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useAnisotropy() {
        return this.anisotropy > 0 || this.anisotropyNode !== null;
    }
    /**
	 * Whether the lighting model should use transmission or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useTransmission() {
        return this.transmission > 0 || this.transmissionNode !== null;
    }
    /**
	 * Whether the lighting model should use dispersion or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useDispersion() {
        return this.dispersion > 0 || this.dispersionNode !== null;
    }
    /**
	 * Setups the specular related node variables.
	 */ setupSpecular() {
        const iorNode = this.iorNode ? $03ccd63b0299d6a7$var$float(this.iorNode) : $03ccd63b0299d6a7$var$materialIOR;
        $03ccd63b0299d6a7$var$ior.assign(iorNode);
        $03ccd63b0299d6a7$var$specularColor.assign($03ccd63b0299d6a7$var$min$1($03ccd63b0299d6a7$var$pow2($03ccd63b0299d6a7$var$ior.sub(1.0).div($03ccd63b0299d6a7$var$ior.add(1.0))).mul($03ccd63b0299d6a7$var$materialSpecularColor), $03ccd63b0299d6a7$var$vec3(1.0)).mul($03ccd63b0299d6a7$var$materialSpecularIntensity));
        $03ccd63b0299d6a7$var$specularColorBlended.assign($03ccd63b0299d6a7$var$mix($03ccd63b0299d6a7$var$specularColor, $03ccd63b0299d6a7$var$diffuseColor.rgb, $03ccd63b0299d6a7$var$metalness));
        $03ccd63b0299d6a7$var$specularF90.assign($03ccd63b0299d6a7$var$mix($03ccd63b0299d6a7$var$materialSpecularIntensity, 1.0, $03ccd63b0299d6a7$var$metalness));
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {PhysicalLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$export$b69e16149fd7d508(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion);
    }
    /**
	 * Setups the physical specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants(builder) {
        super.setupVariants(builder);
        // CLEARCOAT
        if (this.useClearcoat) {
            const clearcoatNode = this.clearcoatNode ? $03ccd63b0299d6a7$var$float(this.clearcoatNode) : $03ccd63b0299d6a7$var$materialClearcoat;
            const clearcoatRoughnessNode = this.clearcoatRoughnessNode ? $03ccd63b0299d6a7$var$float(this.clearcoatRoughnessNode) : $03ccd63b0299d6a7$var$materialClearcoatRoughness;
            $03ccd63b0299d6a7$var$clearcoat.assign(clearcoatNode);
            $03ccd63b0299d6a7$var$clearcoatRoughness.assign($03ccd63b0299d6a7$var$getRoughness({
                roughness: clearcoatRoughnessNode
            }));
        }
        // SHEEN
        if (this.useSheen) {
            const sheenNode = this.sheenNode ? $03ccd63b0299d6a7$var$vec3(this.sheenNode) : $03ccd63b0299d6a7$var$materialSheen;
            const sheenRoughnessNode = this.sheenRoughnessNode ? $03ccd63b0299d6a7$var$float(this.sheenRoughnessNode) : $03ccd63b0299d6a7$var$materialSheenRoughness;
            $03ccd63b0299d6a7$var$sheen.assign(sheenNode);
            $03ccd63b0299d6a7$var$sheenRoughness.assign(sheenRoughnessNode);
        }
        // IRIDESCENCE
        if (this.useIridescence) {
            const iridescenceNode = this.iridescenceNode ? $03ccd63b0299d6a7$var$float(this.iridescenceNode) : $03ccd63b0299d6a7$var$materialIridescence;
            const iridescenceIORNode = this.iridescenceIORNode ? $03ccd63b0299d6a7$var$float(this.iridescenceIORNode) : $03ccd63b0299d6a7$var$materialIridescenceIOR;
            const iridescenceThicknessNode = this.iridescenceThicknessNode ? $03ccd63b0299d6a7$var$float(this.iridescenceThicknessNode) : $03ccd63b0299d6a7$var$materialIridescenceThickness;
            $03ccd63b0299d6a7$var$iridescence.assign(iridescenceNode);
            $03ccd63b0299d6a7$var$iridescenceIOR.assign(iridescenceIORNode);
            $03ccd63b0299d6a7$var$iridescenceThickness.assign(iridescenceThicknessNode);
        }
        // ANISOTROPY
        if (this.useAnisotropy) {
            const anisotropyV = (this.anisotropyNode ? $03ccd63b0299d6a7$var$vec2(this.anisotropyNode) : $03ccd63b0299d6a7$var$materialAnisotropy).toVar();
            $03ccd63b0299d6a7$var$anisotropy.assign(anisotropyV.length());
            $03ccd63b0299d6a7$var$If($03ccd63b0299d6a7$var$anisotropy.equal(0.0), ()=>{
                anisotropyV.assign($03ccd63b0299d6a7$var$vec2(1.0, 0.0));
            }).Else(()=>{
                anisotropyV.divAssign($03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$anisotropy));
                $03ccd63b0299d6a7$var$anisotropy.assign($03ccd63b0299d6a7$var$anisotropy.saturate());
            });
            // Roughness along the anisotropy bitangent is the material roughness, while the tangent roughness increases with anisotropy.
            $03ccd63b0299d6a7$var$alphaT.assign($03ccd63b0299d6a7$var$anisotropy.pow2().mix($03ccd63b0299d6a7$var$roughness.pow2(), 1.0));
            $03ccd63b0299d6a7$var$anisotropyT.assign($03ccd63b0299d6a7$var$TBNViewMatrix[0].mul(anisotropyV.x).add($03ccd63b0299d6a7$var$TBNViewMatrix[1].mul(anisotropyV.y)));
            $03ccd63b0299d6a7$var$anisotropyB.assign($03ccd63b0299d6a7$var$TBNViewMatrix[1].mul(anisotropyV.x).sub($03ccd63b0299d6a7$var$TBNViewMatrix[0].mul(anisotropyV.y)));
        }
        // TRANSMISSION
        if (this.useTransmission) {
            const transmissionNode = this.transmissionNode ? $03ccd63b0299d6a7$var$float(this.transmissionNode) : $03ccd63b0299d6a7$var$materialTransmission;
            const thicknessNode = this.thicknessNode ? $03ccd63b0299d6a7$var$float(this.thicknessNode) : $03ccd63b0299d6a7$var$materialThickness;
            const attenuationDistanceNode = this.attenuationDistanceNode ? $03ccd63b0299d6a7$var$float(this.attenuationDistanceNode) : $03ccd63b0299d6a7$var$materialAttenuationDistance;
            const attenuationColorNode = this.attenuationColorNode ? $03ccd63b0299d6a7$var$vec3(this.attenuationColorNode) : $03ccd63b0299d6a7$var$materialAttenuationColor;
            $03ccd63b0299d6a7$var$transmission.assign(transmissionNode);
            $03ccd63b0299d6a7$var$thickness.assign(thicknessNode);
            $03ccd63b0299d6a7$var$attenuationDistance.assign(attenuationDistanceNode);
            $03ccd63b0299d6a7$var$attenuationColor.assign(attenuationColorNode);
            if (this.useDispersion) {
                const dispersionNode = this.dispersionNode ? $03ccd63b0299d6a7$var$float(this.dispersionNode) : $03ccd63b0299d6a7$var$materialDispersion;
                $03ccd63b0299d6a7$var$dispersion.assign(dispersionNode);
            }
        }
    }
    /**
	 * Setups the clearcoat normal node.
	 *
	 * @return {Node<vec3>} The clearcoat normal.
	 */ setupClearcoatNormal() {
        return this.clearcoatNormalNode ? $03ccd63b0299d6a7$var$vec3(this.clearcoatNormalNode) : $03ccd63b0299d6a7$var$materialClearcoatNormal;
    }
    setup(builder) {
        builder.context.setupClearcoatNormal = ()=>$03ccd63b0299d6a7$var$subBuild(this.setupClearcoatNormal(builder), 'NORMAL', 'vec3');
        super.setup(builder);
    }
    copy(source) {
        this.clearcoatNode = source.clearcoatNode;
        this.clearcoatRoughnessNode = source.clearcoatRoughnessNode;
        this.clearcoatNormalNode = source.clearcoatNormalNode;
        this.sheenNode = source.sheenNode;
        this.sheenRoughnessNode = source.sheenRoughnessNode;
        this.iridescenceNode = source.iridescenceNode;
        this.iridescenceIORNode = source.iridescenceIORNode;
        this.iridescenceThicknessNode = source.iridescenceThicknessNode;
        this.specularIntensityNode = source.specularIntensityNode;
        this.specularColorNode = source.specularColorNode;
        this.iorNode = source.iorNode;
        this.transmissionNode = source.transmissionNode;
        this.thicknessNode = source.thicknessNode;
        this.attenuationDistanceNode = source.attenuationDistanceNode;
        this.attenuationColorNode = source.attenuationColorNode;
        this.dispersionNode = source.dispersionNode;
        this.anisotropyNode = source.anisotropyNode;
        return super.copy(source);
    }
}
/**
 * Represents the lighting model for {@link MeshSSSNodeMaterial}.
 *
 * @augments PhysicalLightingModel
 */ class $03ccd63b0299d6a7$var$SSSLightingModel extends $03ccd63b0299d6a7$export$b69e16149fd7d508 {
    /**
	 * Constructs a new physical lighting model.
	 *
	 * @param {boolean} [clearcoat=false] - Whether clearcoat is supported or not.
	 * @param {boolean} [sheen=false] - Whether sheen is supported or not.
	 * @param {boolean} [iridescence=false] - Whether iridescence is supported or not.
	 * @param {boolean} [anisotropy=false] - Whether anisotropy is supported or not.
	 * @param {boolean} [transmission=false] - Whether transmission is supported or not.
	 * @param {boolean} [dispersion=false] - Whether dispersion is supported or not.
	 * @param {boolean} [sss=false] - Whether SSS is supported or not.
	 */ constructor(clearcoat = false, sheen = false, iridescence = false, anisotropy = false, transmission = false, dispersion = false, sss = false){
        super(clearcoat, sheen, iridescence, anisotropy, transmission, dispersion);
        /**
		 * Whether the lighting model should use SSS or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.useSSS = sss;
    }
    /**
	 * Extends the default implementation with a SSS term.
	 *
	 * Reference: [Approximating Translucency for a Fast, Cheap and Convincing Subsurface Scattering Look](https://colinbarrebrisebois.com/2011/03/07/gdc-2011-approximating-translucency-for-a-fast-cheap-and-convincing-subsurface-scattering-look/)
	 *
	 * @param {Object} input - The input data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }, builder) {
        if (this.useSSS === true) {
            const material = builder.material;
            const { thicknessColorNode: thicknessColorNode, thicknessDistortionNode: thicknessDistortionNode, thicknessAmbientNode: thicknessAmbientNode, thicknessAttenuationNode: thicknessAttenuationNode, thicknessPowerNode: thicknessPowerNode, thicknessScaleNode: thicknessScaleNode } = material;
            const scatteringHalf = lightDirection.add($03ccd63b0299d6a7$var$normalView.mul(thicknessDistortionNode)).normalize();
            const scatteringDot = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$positionViewDirection.dot(scatteringHalf.negate()).saturate().pow(thicknessPowerNode).mul(thicknessScaleNode));
            const scatteringIllu = $03ccd63b0299d6a7$var$vec3(scatteringDot.add(thicknessAmbientNode).mul(thicknessColorNode));
            reflectedLight.directDiffuse.addAssign(scatteringIllu.mul(thicknessAttenuationNode.mul(lightColor)));
        }
        super.direct({
            lightDirection: lightDirection,
            lightColor: lightColor,
            reflectedLight: reflectedLight
        }, builder);
    }
}
/**
 * This node material is an experimental extension of {@link MeshPhysicalNodeMaterial}
 * that implements a Subsurface scattering (SSS) term.
 *
 * @augments MeshPhysicalNodeMaterial
 */ class $03ccd63b0299d6a7$export$3b1fa10c015e327a extends $03ccd63b0299d6a7$export$f336706882be0d39 {
    static get type() {
        return 'MeshSSSNodeMaterial';
    }
    /**
	 * Constructs a new mesh SSS node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * Represents the thickness color.
		 *
		 * @type {?Node<vec3>}
		 * @default null
		 */ this.thicknessColorNode = null;
        /**
		 * Represents the distortion factor.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessDistortionNode = $03ccd63b0299d6a7$var$float(0.1);
        /**
		 * Represents the thickness ambient factor.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessAmbientNode = $03ccd63b0299d6a7$var$float(0.0);
        /**
		 * Represents the thickness attenuation.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessAttenuationNode = $03ccd63b0299d6a7$var$float(.1);
        /**
		 * Represents the thickness power.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessPowerNode = $03ccd63b0299d6a7$var$float(2.0);
        /**
		 * Represents the thickness scale.
		 *
		 * @type {?Node<float>}
		 */ this.thicknessScaleNode = $03ccd63b0299d6a7$var$float(10.0);
    }
    /**
	 * Whether the lighting model should use SSS or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get useSSS() {
        return this.thicknessColorNode !== null;
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {SSSLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$var$SSSLightingModel(this.useClearcoat, this.useSheen, this.useIridescence, this.useAnisotropy, this.useTransmission, this.useDispersion, this.useSSS);
    }
    copy(source) {
        this.thicknessColorNode = source.thicknessColorNode;
        this.thicknessDistortionNode = source.thicknessDistortionNode;
        this.thicknessAmbientNode = source.thicknessAmbientNode;
        this.thicknessAttenuationNode = source.thicknessAttenuationNode;
        this.thicknessPowerNode = source.thicknessPowerNode;
        this.thicknessScaleNode = source.thicknessScaleNode;
        return super.copy(source);
    }
}
const $03ccd63b0299d6a7$var$getGradientIrradiance = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ normal: normal, lightDirection: lightDirection, builder: builder })=>{
    // dotNL will be from -1.0 to 1.0
    const dotNL = normal.dot(lightDirection);
    const coord = $03ccd63b0299d6a7$var$vec2(dotNL.mul(0.5).add(0.5), 0.0);
    if (builder.material.gradientMap) {
        const gradientMap = $03ccd63b0299d6a7$var$materialReference('gradientMap', 'texture').context({
            getUV: ()=>coord
        });
        return $03ccd63b0299d6a7$var$vec3(gradientMap.r);
    } else {
        const fw = coord.fwidth().mul(0.5);
        return $03ccd63b0299d6a7$var$mix($03ccd63b0299d6a7$var$vec3(0.7), $03ccd63b0299d6a7$var$vec3(1.0), $03ccd63b0299d6a7$var$smoothstep($03ccd63b0299d6a7$var$float(0.7).sub(fw.x), $03ccd63b0299d6a7$var$float(0.7).add(fw.x), coord.x));
    }
});
/**
 * Represents the lighting model for a toon material. Used in {@link MeshToonNodeMaterial}.
 *
 * @augments LightingModel
 */ class $03ccd63b0299d6a7$var$ToonLightingModel extends $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    /**
	 * Implements the direct lighting. Instead of using a conventional smooth irradiance, the irradiance is
	 * reduced to a small number of discrete shades to create a comic-like, flat look.
	 *
	 * @param {Object} lightData - The light data.
	 * @param {NodeBuilder} builder - The current node builder.
	 */ direct({ lightDirection: lightDirection, lightColor: lightColor, reflectedLight: reflectedLight }, builder) {
        const irradiance = $03ccd63b0299d6a7$var$getGradientIrradiance({
            normal: $03ccd63b0299d6a7$var$normalGeometry,
            lightDirection: lightDirection,
            builder: builder
        }).mul(lightColor);
        reflectedLight.directDiffuse.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseColor.rgb
        })));
    }
    /**
	 * Implements the indirect lighting.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ indirect(builder) {
        const { ambientOcclusion: ambientOcclusion, irradiance: irradiance, reflectedLight: reflectedLight } = builder.context;
        reflectedLight.indirectDiffuse.addAssign(irradiance.mul($03ccd63b0299d6a7$var$BRDF_Lambert({
            diffuseColor: $03ccd63b0299d6a7$var$diffuseColor
        })));
        reflectedLight.indirectDiffuse.mulAssign(ambientOcclusion);
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$4 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$df893cf97e765622)();
/**
 * Node material version of {@link MeshToonMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$2dd2c8d143c7c392 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshToonNodeMaterial';
    }
    /**
	 * Constructs a new mesh toon node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonNodeMaterial = true;
        /**
		 * Set to `true` because toon materials react on lights.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$4);
        this.setValues(parameters);
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {ToonLightingModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$var$ToonLightingModel();
    }
}
/**
 * TSL function for creating a matcap uv node.
 *
 * Can be used to compute texture coordinates for projecting a
 * matcap onto a mesh. Used by {@link MeshMatcapNodeMaterial}.
 *
 * @tsl
 * @function
 * @returns {Node<vec2>} The matcap UV coordinates.
 */ const $03ccd63b0299d6a7$var$matcapUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(()=>{
    const x = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$positionViewDirection.z, 0, $03ccd63b0299d6a7$var$positionViewDirection.x.negate()).normalize();
    const y = $03ccd63b0299d6a7$var$positionViewDirection.cross(x);
    return $03ccd63b0299d6a7$var$vec2(x.dot($03ccd63b0299d6a7$var$normalView), y.dot($03ccd63b0299d6a7$var$normalView)).mul(0.495).add(0.5); // 0.495 to remove artifacts caused by undersized matcap disks
}).once([
    'NORMAL',
    'VERTEX'
])().toVar('matcapUV');
const $03ccd63b0299d6a7$var$_defaultValues$3 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$6f5fef6235ec12ee)();
/**
 * Node material version of {@link MeshMatcapMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$f7d65f3d82d7b0b0 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'MeshMatcapNodeMaterial';
    }
    /**
	 * Constructs a new mesh normal node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapNodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$3);
        this.setValues(parameters);
    }
    /**
	 * Setups the matcap specific node variables.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupVariants(builder) {
        const uv = $03ccd63b0299d6a7$var$matcapUV;
        let matcapColor;
        if (builder.material.matcap) matcapColor = $03ccd63b0299d6a7$var$materialReference('matcap', 'texture').context({
            getUV: ()=>uv
        });
        else matcapColor = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mix(0.2, 0.8, uv.y)); // default if matcap is missing
        $03ccd63b0299d6a7$var$diffuseColor.rgb.mulAssign(matcapColor.rgb);
    }
}
/**
 * Applies a rotation to the given position node.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$5210a1a3dd372bdd extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'RotateNode';
    }
    /**
	 * Constructs a new rotate node.
	 *
	 * @param {Node} positionNode - The position node.
	 * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
	 * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
	 */ constructor(positionNode, rotationNode){
        super();
        /**
		 * The position node.
		 *
		 * @type {Node}
		 */ this.positionNode = positionNode;
        /**
		 *  Represents the rotation that is applied to the position node.
		 *  Depending on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
		 *
		 * @type {Node}
		 */ this.rotationNode = rotationNode;
    }
    /**
	 * The type of the {@link RotateNode#positionNode} defines the node's type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node's type.
	 */ generateNodeType(builder) {
        return this.positionNode.getNodeType(builder);
    }
    setup(builder) {
        const { rotationNode: rotationNode, positionNode: positionNode } = this;
        const nodeType = this.getNodeType(builder);
        if (nodeType === 'vec2') {
            const cosAngle = rotationNode.cos();
            const sinAngle = rotationNode.sin();
            const rotationMatrix = $03ccd63b0299d6a7$var$mat2(cosAngle, sinAngle, sinAngle.negate(), cosAngle);
            return rotationMatrix.mul(positionNode);
        } else {
            const rotation = rotationNode;
            const rotationXMatrix = $03ccd63b0299d6a7$var$mat4($03ccd63b0299d6a7$var$vec4(1.0, 0.0, 0.0, 0.0), $03ccd63b0299d6a7$var$vec4(0.0, $03ccd63b0299d6a7$var$cos(rotation.x), $03ccd63b0299d6a7$var$sin(rotation.x).negate(), 0.0), $03ccd63b0299d6a7$var$vec4(0.0, $03ccd63b0299d6a7$var$sin(rotation.x), $03ccd63b0299d6a7$var$cos(rotation.x), 0.0), $03ccd63b0299d6a7$var$vec4(0.0, 0.0, 0.0, 1.0));
            const rotationYMatrix = $03ccd63b0299d6a7$var$mat4($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$cos(rotation.y), 0.0, $03ccd63b0299d6a7$var$sin(rotation.y), 0.0), $03ccd63b0299d6a7$var$vec4(0.0, 1.0, 0.0, 0.0), $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$sin(rotation.y).negate(), 0.0, $03ccd63b0299d6a7$var$cos(rotation.y), 0.0), $03ccd63b0299d6a7$var$vec4(0.0, 0.0, 0.0, 1.0));
            const rotationZMatrix = $03ccd63b0299d6a7$var$mat4($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$cos(rotation.z), $03ccd63b0299d6a7$var$sin(rotation.z).negate(), 0.0, 0.0), $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$sin(rotation.z), $03ccd63b0299d6a7$var$cos(rotation.z), 0.0, 0.0), $03ccd63b0299d6a7$var$vec4(0.0, 0.0, 1.0, 0.0), $03ccd63b0299d6a7$var$vec4(0.0, 0.0, 0.0, 1.0));
            return rotationXMatrix.mul(rotationYMatrix).mul(rotationZMatrix).mul($03ccd63b0299d6a7$var$vec4(positionNode, 1.0)).xyz;
        }
    }
}
/**
 * TSL function for creating a rotate node.
 *
 * @tsl
 * @function
 * @param {Node} positionNode - The position node.
 * @param {Node} rotationNode - Represents the rotation that is applied to the position node. Depending
 * on whether the position data are 2D or 3D, the rotation is expressed a single float value or an Euler value.
 * @returns {RotateNode}
 */ const $03ccd63b0299d6a7$var$rotate = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$5210a1a3dd372bdd).setParameterLength(2);
const $03ccd63b0299d6a7$var$_defaultValues$2 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e)();
/**
 * Node material version of {@link SpriteMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$80f4e36249294380 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'SpriteNodeMaterial';
    }
    /**
	 * Constructs a new sprite node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteNodeMaterial = true;
        this._useSizeAttenuation = true;
        /**
		 * This property makes it possible to define the position of the sprite with a
		 * node. That can be useful when the material is used with instanced rendering
		 * and node data are defined with an instanced attribute node:
		 * ```js
		 * const positionAttribute = new InstancedBufferAttribute( new Float32Array( positions ), 3 );
		 * material.positionNode = instancedBufferAttribute( positionAttribute );
		 * ```
		 * Another possibility is to compute the instanced data with a compute shader:
		 * ```js
		 * const positionBuffer = instancedArray( particleCount, 'vec3' );
		 * particleMaterial.positionNode = positionBuffer.toAttribute();
		 * ```
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.positionNode = null;
        /**
		 * The rotation of sprite materials is by default inferred from the `rotation`,
		 * property. This node property allows to overwrite the default and define
		 * the rotation with a node instead.
		 *
		 * If you don't want to overwrite the rotation but modify the existing
		 * value instead, use {@link materialRotation}.
		 *
		 * @type {?Node<float>}
		 * @default null
		 */ this.rotationNode = null;
        /**
		 * This node property provides an additional way to scale sprites next to
		 * `Object3D.scale`. The scale transformation based in `Object3D.scale`
		 * is multiplied with the scale value of this node in the vertex shader.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.scaleNode = null;
        /**
		 * In Sprites, the transparent property is enabled by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$2);
        this.setValues(parameters);
    }
    /**
	 * Setups the position node in view space. This method implements
	 * the sprite specific vertex shader.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node<vec3>} The position in view space.
	 */ setupPositionView(builder) {
        const { object: object, camera: camera } = builder;
        const { positionNode: positionNode, rotationNode: rotationNode, scaleNode: scaleNode, sizeAttenuation: sizeAttenuation } = this;
        const mvPosition = $03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec3(positionNode || 0));
        let scale = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$modelWorldMatrix[0].xyz.length(), $03ccd63b0299d6a7$var$modelWorldMatrix[1].xyz.length());
        if (scaleNode !== null) scale = scale.mul($03ccd63b0299d6a7$var$vec2(scaleNode));
        if (camera.isPerspectiveCamera && sizeAttenuation === false) scale = scale.mul(mvPosition.z.negate());
        let alignedPosition = $03ccd63b0299d6a7$var$positionGeometry.xy;
        if (object.center && object.center.isVector2 === true) {
            const center = $03ccd63b0299d6a7$var$reference$1('center', 'vec2', object);
            alignedPosition = alignedPosition.sub(center.sub(0.5));
        }
        alignedPosition = alignedPosition.mul(scale);
        const rotation = $03ccd63b0299d6a7$var$float(rotationNode || $03ccd63b0299d6a7$var$materialRotation);
        const rotatedPosition = $03ccd63b0299d6a7$var$rotate(alignedPosition, rotation);
        return $03ccd63b0299d6a7$var$vec4(mvPosition.xy.add(rotatedPosition), mvPosition.zw);
    }
    copy(source) {
        this.positionNode = source.positionNode;
        this.rotationNode = source.rotationNode;
        this.scaleNode = source.scaleNode;
        return super.copy(source);
    }
    /**
	 * Whether to use size attenuation or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get sizeAttenuation() {
        return this._useSizeAttenuation;
    }
    set sizeAttenuation(value) {
        if (this._useSizeAttenuation !== value) {
            this._useSizeAttenuation = value;
            this.needsUpdate = true;
        }
    }
}
const $03ccd63b0299d6a7$var$_defaultValues$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$a178c45366ce5d6b)();
const $03ccd63b0299d6a7$var$_size$4 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
/**
 * Node material version of {@link PointsMaterial}.
 *
 * This material can be used in two ways:
 *
 * - By rendering point primitives with {@link Points}. Since WebGPU only supports point primitives
 * with a pixel size of `1`, it's not possible to define a size.
 *
 * ```js
 * const pointCloud = new THREE.Points( geometry, new THREE.PointsNodeMaterial() );
 * ```
 *
 * - By rendering point primitives with {@link Sprites}. In this case, size is honored,
 * see {@link PointsNodeMaterial#sizeNode}.
 *
 * ```js
 * const instancedPoints = new THREE.Sprite( new THREE.PointsNodeMaterial( { positionNode: instancedBufferAttribute( positionAttribute ) } ) );
 * ```
 *
 * @augments SpriteNodeMaterial
 */ class $03ccd63b0299d6a7$export$986cd66fa4ca801b extends $03ccd63b0299d6a7$export$80f4e36249294380 {
    static get type() {
        return 'PointsNodeMaterial';
    }
    /**
	 * Constructs a new points node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This node property provides an additional way to set the point size.
		 *
		 * Note that WebGPU only supports point primitives with 1 pixel size. Consequently,
		 * this node has no effect when the material is used with {@link Points} and a WebGPU
		 * backend. If an application wants to render points with a size larger than 1 pixel,
		 * the material should be used with {@link Sprite} and instancing.
		 *
		 * @type {?Node<vec2>}
		 * @default null
		 */ this.sizeNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsNodeMaterial = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues$1);
        this.setValues(parameters);
    }
    setupPositionView() {
        const { positionNode: positionNode } = this;
        return $03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec3(positionNode || $03ccd63b0299d6a7$var$positionLocal)).xyz;
    }
    setupVertexSprite(builder) {
        const { material: material, camera: camera } = builder;
        const { rotationNode: rotationNode, scaleNode: scaleNode, sizeNode: sizeNode, sizeAttenuation: sizeAttenuation } = this;
        let mvp = super.setupVertex(builder);
        // skip further processing if the material is not a node material
        if (material.isNodeMaterial !== true) return mvp;
        // point size
        let pointSize = sizeNode !== null ? $03ccd63b0299d6a7$var$vec2(sizeNode) : $03ccd63b0299d6a7$var$materialPointSize;
        pointSize = pointSize.mul($03ccd63b0299d6a7$var$screenDPR);
        // size attenuation
        if (camera.isPerspectiveCamera && sizeAttenuation === true) // follow WebGLRenderer's implementation, and scale by half the canvas height in logical units
        pointSize = pointSize.mul($03ccd63b0299d6a7$var$scale.div($03ccd63b0299d6a7$var$positionView.z.negate()));
        // scale
        if (scaleNode && scaleNode.isNode) pointSize = pointSize.mul($03ccd63b0299d6a7$var$vec2(scaleNode));
        // compute offset
        let offset = $03ccd63b0299d6a7$var$positionGeometry.xy;
        // apply rotation
        if (rotationNode && rotationNode.isNode) {
            const rotation = $03ccd63b0299d6a7$var$float(rotationNode);
            offset = $03ccd63b0299d6a7$var$rotate(offset, rotation);
        }
        // account for point size
        offset = offset.mul(pointSize);
        // scale by viewport size
        offset = offset.div($03ccd63b0299d6a7$var$viewportSize.div(2));
        // compensate for the perspective divide
        offset = offset.mul(mvp.w);
        // add offset
        mvp = mvp.add($03ccd63b0299d6a7$var$vec4(offset, 0, 0));
        return mvp;
    }
    setupVertex(builder) {
        if (builder.object.isPoints) return super.setupVertex(builder);
        else return this.setupVertexSprite(builder);
    }
    /**
	 * Whether alpha to coverage should be used or not.
	 *
	 * @type {boolean}
	 * @default true
	 */ get alphaToCoverage() {
        return this._useAlphaToCoverage;
    }
    set alphaToCoverage(value) {
        if (this._useAlphaToCoverage !== value) {
            this._useAlphaToCoverage = value;
            this.needsUpdate = true;
        }
    }
}
const $03ccd63b0299d6a7$var$scale = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(1).onFrameUpdate(function({ renderer: renderer }) {
    const size = renderer.getSize($03ccd63b0299d6a7$var$_size$4); // logical units
    this.value = 0.5 * size.y;
});
/**
 * Represents lighting model for a shadow material. Used in {@link ShadowNodeMaterial}.
 *
 * @augments LightingModel
 */ class $03ccd63b0299d6a7$var$ShadowMaskModel extends $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    /**
	 * Constructs a new shadow mask model.
	 */ constructor(){
        super();
        /**
		 * The shadow mask node.
		 *
		 * @type {Node}
		 */ this.shadowNode = $03ccd63b0299d6a7$var$float(1).toVar('shadowMask');
    }
    /**
	 * Only used to save the shadow mask.
	 *
	 * @param {Object} input - The input data.
	 */ direct({ lightNode: lightNode }) {
        if (lightNode.shadowNode !== null) this.shadowNode.mulAssign(lightNode.shadowNode);
    }
    /**
	 * Uses the shadow mask to produce the final color.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ finish({ context: context }) {
        $03ccd63b0299d6a7$var$diffuseColor.a.mulAssign(this.shadowNode.oneMinus());
        context.outgoingLight.rgb.assign($03ccd63b0299d6a7$var$diffuseColor.rgb); // TODO: Optimize LightsNode to avoid this assignment
    }
}
const $03ccd63b0299d6a7$var$_defaultValues = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$e8564da406055a3)();
/**
 * Node material version of {@link ShadowMaterial}.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$6ba7483788b75e55 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'ShadowNodeMaterial';
    }
    /**
	 * Constructs a new shadow node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowNodeMaterial = true;
        /**
		 * Set to `true` because so it's possible to implement
		 * the shadow mask effect.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.lights = true;
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        this.setDefaultValues($03ccd63b0299d6a7$var$_defaultValues);
        this.setValues(parameters);
    }
    /**
	 * Setups the lighting model.
	 *
	 * @return {ShadowMaskModel} The lighting model.
	 */ setupLightingModel() {
        return new $03ccd63b0299d6a7$var$ShadowMaskModel();
    }
}
const $03ccd63b0299d6a7$var$scatteringDensity = $03ccd63b0299d6a7$var$property('vec3');
const $03ccd63b0299d6a7$var$linearDepthRay = $03ccd63b0299d6a7$var$property('vec3');
const $03ccd63b0299d6a7$var$outgoingRayLight = $03ccd63b0299d6a7$var$property('vec3');
/**
 * VolumetricLightingModel class extends the LightingModel to implement volumetric lighting effects.
 * This model calculates the scattering and transmittance of light through a volumetric medium.
 * It dynamically adjusts the direction of the ray based on the camera and object positions.
 * The model supports custom scattering and depth nodes to enhance the lighting effects.
 *
 * @augments LightingModel
 */ class $03ccd63b0299d6a7$var$VolumetricLightingModel extends $03ccd63b0299d6a7$export$d8f76c0bb8645ea7 {
    constructor(){
        super();
    }
    start(builder) {
        const { material: material } = builder;
        const startPos = $03ccd63b0299d6a7$var$property('vec3');
        const endPos = $03ccd63b0299d6a7$var$property('vec3');
        // This approach dynamically changes the direction of the ray,
        // prioritizing the ray from the camera to the object if it is inside the mesh, and from the object to the camera if it is far away.
        $03ccd63b0299d6a7$var$If($03ccd63b0299d6a7$var$cameraPosition.sub($03ccd63b0299d6a7$var$positionWorld).length().greaterThan($03ccd63b0299d6a7$var$modelRadius.mul(2)), ()=>{
            startPos.assign($03ccd63b0299d6a7$var$cameraPosition);
            endPos.assign($03ccd63b0299d6a7$var$positionWorld);
        }).Else(()=>{
            startPos.assign($03ccd63b0299d6a7$var$positionWorld);
            endPos.assign($03ccd63b0299d6a7$var$cameraPosition);
        });
        //
        const viewVector = endPos.sub(startPos);
        const steps = $03ccd63b0299d6a7$var$uniform('int').onRenderUpdate(({ material: material })=>material.steps);
        const stepSize = viewVector.length().div(steps).toVar();
        const rayDir = viewVector.normalize().toVar(); // TODO: toVar() should be automatic here ( in loop )
        const distTravelled = $03ccd63b0299d6a7$var$float(0.0).toVar();
        const transmittance = $03ccd63b0299d6a7$var$vec3(1).toVar();
        if (material.offsetNode) // reduce banding
        distTravelled.addAssign(material.offsetNode.mul(stepSize));
        $03ccd63b0299d6a7$var$Loop(steps, ()=>{
            const positionRay = startPos.add(rayDir.mul(distTravelled));
            const positionViewRay = $03ccd63b0299d6a7$var$cameraViewMatrix.mul($03ccd63b0299d6a7$var$vec4(positionRay, 1)).xyz;
            if (material.depthNode !== null) {
                $03ccd63b0299d6a7$var$linearDepthRay.assign($03ccd63b0299d6a7$var$linearDepth($03ccd63b0299d6a7$var$viewZToPerspectiveDepth(positionViewRay.z, $03ccd63b0299d6a7$var$cameraNear, $03ccd63b0299d6a7$var$cameraFar)));
                builder.context.sceneDepthNode = $03ccd63b0299d6a7$var$linearDepth(material.depthNode).toVar();
            }
            builder.context.positionWorld = positionRay;
            builder.context.shadowPositionWorld = positionRay;
            builder.context.positionView = positionViewRay;
            $03ccd63b0299d6a7$var$scatteringDensity.assign(0);
            let scatteringNode;
            if (material.scatteringNode) scatteringNode = material.scatteringNode({
                positionRay: positionRay
            });
            super.start(builder);
            if (scatteringNode) $03ccd63b0299d6a7$var$scatteringDensity.mulAssign(scatteringNode);
            // beer's law
            const falloff = $03ccd63b0299d6a7$var$scatteringDensity.mul(.01).negate().mul(stepSize).exp();
            transmittance.mulAssign(falloff);
            // move along the ray
            distTravelled.addAssign(stepSize);
        });
        $03ccd63b0299d6a7$var$outgoingRayLight.addAssign(transmittance.saturate().oneMinus());
    }
    scatteringLight(lightColor, builder) {
        const sceneDepthNode = builder.context.sceneDepthNode;
        if (sceneDepthNode) $03ccd63b0299d6a7$var$If(sceneDepthNode.greaterThanEqual($03ccd63b0299d6a7$var$linearDepthRay), ()=>{
            $03ccd63b0299d6a7$var$scatteringDensity.addAssign(lightColor);
        });
        else $03ccd63b0299d6a7$var$scatteringDensity.addAssign(lightColor);
    }
    direct({ lightNode: lightNode, lightColor: lightColor }, builder) {
        // Ignore lights with infinite distance
        if (lightNode.light.distance === undefined) return;
        // TODO: We need a viewportOpaque*() ( output, depth ) to fit with modern rendering approaches
        const directLight = lightColor.xyz.toVar();
        directLight.mulAssign(lightNode.shadowNode); // it no should be necessary if used in the same render pass
        this.scatteringLight(directLight, builder);
    }
    directRectArea({ lightColor: lightColor, lightPosition: lightPosition, halfWidth: halfWidth, halfHeight: halfHeight }, builder) {
        const p0 = lightPosition.add(halfWidth).sub(halfHeight); // counterclockwise; light shines in local neg z direction
        const p1 = lightPosition.sub(halfWidth).sub(halfHeight);
        const p2 = lightPosition.sub(halfWidth).add(halfHeight);
        const p3 = lightPosition.add(halfWidth).add(halfHeight);
        const P = builder.context.positionView;
        const directLight = lightColor.xyz.mul($03ccd63b0299d6a7$var$LTC_Evaluate_Volume({
            P: P,
            p0: p0,
            p1: p1,
            p2: p2,
            p3: p3
        })).pow(1.5);
        this.scatteringLight(directLight, builder);
    }
    finish(builder) {
        builder.context.outgoingLight.assign($03ccd63b0299d6a7$var$outgoingRayLight);
    }
}
/**
 * Volume node material.
 *
 * @augments NodeMaterial
 */ class $03ccd63b0299d6a7$export$21fbdfe5d9192491 extends $03ccd63b0299d6a7$export$caaf3b30a544c946 {
    static get type() {
        return 'VolumeNodeMaterial';
    }
    /**
	 * Constructs a new volume node material.
	 *
	 * @param {Object} [parameters] - The configuration parameter.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVolumeNodeMaterial = true;
        /**
		 * Number of steps used for raymarching.
		 *
		 * @type {number}
		 * @default 25
		 */ this.steps = 25;
        /**
		 * Offsets the distance a ray has been traveled through a volume.
		 * Can be used to implement dithering to reduce banding.
		 *
		 * @type {Node<float>}
		 * @default null
		 */ this.offsetNode = null;
        /**
		 * Node used for scattering calculations.
		 *
		 * @type {Function|FunctionNode<vec4>}
		 * @default null
		 */ this.scatteringNode = null;
        this.lights = true;
        this.transparent = true;
        this.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        this.depthTest = false;
        this.depthWrite = false;
        this.setValues(parameters);
    }
    setupLightingModel() {
        return new $03ccd63b0299d6a7$var$VolumetricLightingModel();
    }
}
/**
 * This module manages the internal animation loop of the renderer.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$Animation {
    /**
	 * Constructs a new animation loop management component.
	 *
	 * @param {Renderer} renderer - A reference to the main renderer.
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, nodes, info){
        /**
		 * A reference to the main renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A reference to the context from `requestAnimationFrame()` can
		 * be called (usually `window`).
		 *
		 * @type {?(Window|XRSession)}
		 */ this._context = typeof self !== 'undefined' ? self : null;
        /**
		 * The user-defined animation loop.
		 *
		 * @type {?Function}
		 * @default null
		 */ this._animationLoop = null;
        /**
		 * The requestId which is returned from the `requestAnimationFrame()` call.
		 * Can be used to cancel the stop the animation loop.
		 *
		 * @type {?number}
		 * @default null
		 */ this._requestId = null;
    }
    /**
	 * Starts the internal animation loop.
	 */ start() {
        const update = (time, xrFrame)=>{
            this._requestId = this._context.requestAnimationFrame(update);
            if (this.info.autoReset === true) this.info.reset();
            this.nodes.nodeFrame.update();
            this.info.frame = this.nodes.nodeFrame.frameId;
            this.renderer._inspector.begin();
            if (this._animationLoop !== null) this._animationLoop(time, xrFrame);
            this.renderer._inspector.finish();
        };
        update();
    }
    /**
	 * Stops the internal animation loop.
	 */ stop() {
        if (this._context !== null) this._context.cancelAnimationFrame(this._requestId);
        this._requestId = null;
    }
    /**
	 * Returns the user-level animation loop.
	 *
	 * @return {?Function} The animation loop.
	 */ getAnimationLoop() {
        return this._animationLoop;
    }
    /**
	 * Defines the user-level animation loop.
	 *
	 * @param {?Function} callback - The animation loop.
	 */ setAnimationLoop(callback) {
        this._animationLoop = callback;
    }
    /**
	 * Returns the animation context.
	 *
	 * @return {Window|XRSession} The animation context.
	 */ getContext() {
        return this._context;
    }
    /**
	 * Defines the context in which `requestAnimationFrame()` is executed.
	 *
	 * @param {Window|XRSession} context - The context to set.
	 */ setContext(context) {
        this._context = context;
    }
    /**
	 * Frees all internal resources and stops the animation loop.
	 */ dispose() {
        this.stop();
    }
}
/**
 * Data structure for the renderer. It allows defining values
 * with chained, hierarchical keys. Keys are meant to be
 * objects since the module internally works with Weak Maps
 * for performance reasons.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$ChainMap {
    /**
	 * Constructs a new Chain Map.
	 */ constructor(){
        /**
		 * A map of Weak Maps by their key length.
		 *
		 * @type {Object<number, WeakMap>}
		 */ this.weakMaps = {};
    }
    /**
	 * Returns the Weak Map for the given keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @return {WeakMap} The weak map.
	 */ _getWeakMap(keys) {
        const length = keys.length;
        let weakMap = this.weakMaps[length];
        if (weakMap === undefined) {
            weakMap = new WeakMap();
            this.weakMaps[length] = weakMap;
        }
        return weakMap;
    }
    /**
	 * Returns the value for the given array of keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @return {any} The value. Returns `undefined` if no value was found.
	 */ get(keys) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            map = map.get(keys[i]);
            if (map === undefined) return undefined;
        }
        return map.get(keys[keys.length - 1]);
    }
    /**
	 * Sets the value for the given keys.
	 *
	 * @param {Array<Object>} keys - List of keys.
	 * @param {any} value - The value to set.
	 * @return {ChainMap} A reference to this Chain Map.
	 */ set(keys, value) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            const key = keys[i];
            if (map.has(key) === false) map.set(key, new WeakMap());
            map = map.get(key);
        }
        map.set(keys[keys.length - 1], value);
        return this;
    }
    /**
	 * Deletes a value for the given keys.
	 *
	 * @param {Array<Object>} keys - The keys.
	 * @return {boolean} Returns `true` if the value has been removed successfully and `false` if the value has not be found.
	 */ delete(keys) {
        let map = this._getWeakMap(keys);
        for(let i = 0; i < keys.length - 1; i++){
            map = map.get(keys[i]);
            if (map === undefined) return false;
        }
        return map.delete(keys[keys.length - 1]);
    }
}
let $03ccd63b0299d6a7$var$_id$a = 0;
function $03ccd63b0299d6a7$var$getKeys(obj) {
    const keys = Object.keys(obj);
    let proto = Object.getPrototypeOf(obj);
    while(proto){
        const descriptors = Object.getOwnPropertyDescriptors(proto);
        for(const key in descriptors)if (descriptors[key] !== undefined) {
            const descriptor = descriptors[key];
            if (descriptor && typeof descriptor.get === 'function') keys.push(key);
        }
        proto = Object.getPrototypeOf(proto);
    }
    return keys;
}
/**
 * A render object is the renderer's representation of single entity that gets drawn
 * with a draw command. There is no unique mapping of render objects to 3D objects in the
 * scene since render objects also depend from the used material, the current render context
 * and the current scene's lighting.
 *
 * In general, the basic process of the renderer is:
 *
 * - Analyze the 3D objects in the scene and generate render lists containing render items.
 * - Process the render lists by calling one or more render commands for each render item.
 * - For each render command, request a render object and perform the draw.
 *
 * The module provides an interface to get data required for the draw command like the actual
 * draw parameters or vertex buffers. It also holds a series of caching related methods since
 * creating render objects should only be done when necessary.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderObject {
    /**
	 * Constructs a new render object.
	 *
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Renderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The 3D object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 */ constructor(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext){
        this.id = $03ccd63b0299d6a7$var$_id$a++;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 * @private
		 */ this._nodes = nodes;
        /**
		 * Renderer component for managing geometries.
		 *
		 * @type {Geometries}
		 * @private
		 */ this._geometries = geometries;
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The 3D object.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The 3D object's material.
		 *
		 * @type {Material}
		 */ this.material = material;
        /**
		 * The scene the 3D object belongs to.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera the 3D object should be rendered with.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The lights node.
		 *
		 * @type {LightsNode}
		 */ this.lightsNode = lightsNode;
        /**
		 * The render context.
		 *
		 * @type {RenderContext}
		 */ this.context = renderContext;
        /**
		 * The 3D object's geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = object.geometry;
        /**
		 * The render object's version.
		 *
		 * @type {number}
		 */ this.version = material.version;
        /**
		 * The draw range of the geometry.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.drawRange = null;
        /**
		 * An array holding the buffer attributes
		 * of the render object. This entails attribute
		 * definitions on geometry and node level.
		 *
		 * @type {?Array<BufferAttribute>}
		 * @default null
		 */ this.attributes = null;
        /**
		 * An object holding the version of the
		 * attributes. The keys are the attribute names
		 * and the values are the attribute versions.
		 *
		 * @type {?Object<string, number>}
		 * @default null
		 */ this.attributesId = null;
        /**
		 * A reference to a render pipeline the render
		 * object is processed with.
		 *
		 * @type {RenderPipeline}
		 * @default null
		 */ this.pipeline = null;
        /**
		 * Only relevant for objects using
		 * multiple materials. This represents a group entry
		 * from the respective `BufferGeometry`.
		 *
		 * @type {?{start: number, count: number}}
		 * @default null
		 */ this.group = null;
        /**
		 * An array holding the vertex buffers which can
		 * be buffer attributes but also interleaved buffers.
		 *
		 * @type {?Array<BufferAttribute|InterleavedBuffer>}
		 * @default null
		 */ this.vertexBuffers = null;
        /**
		 * The parameters for the draw command.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.drawParams = null;
        /**
		 * If this render object is used inside a render bundle,
		 * this property points to the respective bundle group.
		 *
		 * @type {?BundleGroup}
		 * @default null
		 */ this.bundle = null;
        /**
		 * The clipping context.
		 *
		 * @type {ClippingContext}
		 */ this.clippingContext = clippingContext;
        /**
		 * The clipping context's cache key.
		 *
		 * @type {string}
		 */ this.clippingContextCacheKey = clippingContext !== null ? clippingContext.cacheKey : '';
        /**
		 * The initial node cache key.
		 *
		 * @type {number}
		 */ this.initialNodesCacheKey = this.getDynamicCacheKey();
        /**
		 * The initial cache key.
		 *
		 * @type {number}
		 */ this.initialCacheKey = this.getCacheKey();
        /**
		 * The node builder state.
		 *
		 * @type {?NodeBuilderState}
		 * @private
		 * @default null
		 */ this._nodeBuilderState = null;
        /**
		 * An array of bindings.
		 *
		 * @type {?Array<BindGroup>}
		 * @private
		 * @default null
		 */ this._bindings = null;
        /**
		 * Reference to the node material observer.
		 *
		 * @type {?NodeMaterialObserver}
		 * @private
		 * @default null
		 */ this._monitor = null;
        /**
		 * An event listener which is defined by `RenderObjects`. It performs
		 * clean up tasks when `dispose()` on this render object.
		 *
		 * @method
		 */ this.onDispose = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderObject = true;
        /**
		 * An event listener which is executed when `dispose()` is called on
		 * the material of this render object.
		 *
		 * @method
		 */ this.onMaterialDispose = ()=>{
            this.dispose();
        };
        /**
		 * An event listener which is executed when `dispose()` is called on
		 * the geometry of this render object.
		 *
		 * @method
		 */ this.onGeometryDispose = ()=>{
            // clear geometry cache attributes
            this.attributes = null;
            this.attributesId = null;
        };
        this.material.addEventListener('dispose', this.onMaterialDispose);
        this.geometry.addEventListener('dispose', this.onGeometryDispose);
    }
    /**
	 * Updates the clipping context.
	 *
	 * @param {ClippingContext} context - The clipping context to set.
	 */ updateClipping(context) {
        this.clippingContext = context;
    }
    /**
	 * Whether the clipping requires an update or not.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get clippingNeedsUpdate() {
        if (this.clippingContext === null || this.clippingContext.cacheKey === this.clippingContextCacheKey) return false;
        this.clippingContextCacheKey = this.clippingContext.cacheKey;
        return true;
    }
    /**
	 * The number of clipping planes defined in context of hardware clipping.
	 *
	 * @type {number}
	 * @readonly
	 */ get hardwareClippingPlanes() {
        return this.material.hardwareClipping === true ? this.clippingContext.unionClippingCount : 0;
    }
    /**
	 * Returns the node builder state of this render object.
	 *
	 * @return {NodeBuilderState} The node builder state.
	 */ getNodeBuilderState() {
        return this._nodeBuilderState || (this._nodeBuilderState = this._nodes.getForRender(this));
    }
    /**
	 * Returns the node material observer of this render object.
	 *
	 * @return {NodeMaterialObserver} The node material observer.
	 */ getMonitor() {
        return this._monitor || (this._monitor = this.getNodeBuilderState().observer);
    }
    /**
	 * Returns an array of bind groups of this render object.
	 *
	 * @return {Array<BindGroup>} The bindings.
	 */ getBindings() {
        return this._bindings || (this._bindings = this.getNodeBuilderState().createBindings());
    }
    /**
	 * Returns a binding group by group name of this render object.
	 *
	 * @param {string} name - The name of the binding group.
	 * @return {?BindGroup} The bindings.
	 */ getBindingGroup(name) {
        for (const bindingGroup of this.getBindings()){
            if (bindingGroup.name === name) return bindingGroup;
        }
    }
    /**
	 * Returns the index of the render object's geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
	 */ getIndex() {
        return this._geometries.getIndex(this);
    }
    /**
	 * Returns the indirect buffer attribute.
	 *
	 * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
	 */ getIndirect() {
        return this._geometries.getIndirect(this);
    }
    /**
	 * Returns the byte offset into the indirect attribute buffer.
	 *
	 * @return {number|Array<number>} The byte offset into the indirect attribute buffer.
	 */ getIndirectOffset() {
        return this._geometries.getIndirectOffset(this);
    }
    /**
	 * Returns an array that acts as a key for identifying the render object in a chain map.
	 *
	 * @return {Array<Object>} An array with object references.
	 */ getChainArray() {
        return [
            this.object,
            this.material,
            this.context,
            this.lightsNode
        ];
    }
    /**
	 * This method is used when the geometry of a 3D object has been exchanged and the
	 * respective render object now requires an update.
	 *
	 * @param {BufferGeometry} geometry - The geometry to set.
	 */ setGeometry(geometry) {
        this.geometry = geometry;
        this.attributes = null;
        this.attributesId = null;
    }
    /**
	 * Returns the buffer attributes of the render object. The returned array holds
	 * attribute definitions on geometry and node level.
	 *
	 * @return {Array<BufferAttribute>} An array with buffer attributes.
	 */ getAttributes() {
        if (this.attributes !== null) return this.attributes;
        const nodeAttributes = this.getNodeBuilderState().nodeAttributes;
        const geometry = this.geometry;
        const attributes = [];
        const vertexBuffers = new Set();
        const attributesId = {};
        for (const nodeAttribute of nodeAttributes){
            let attribute;
            if (nodeAttribute.node && nodeAttribute.node.attribute) // node attribute
            attribute = nodeAttribute.node.attribute;
            else {
                // geometry attribute
                attribute = geometry.getAttribute(nodeAttribute.name);
                attributesId[nodeAttribute.name] = attribute.id;
            }
            if (attribute === undefined) continue;
            attributes.push(attribute);
            const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
            vertexBuffers.add(bufferAttribute);
        }
        this.attributes = attributes;
        this.attributesId = attributesId;
        this.vertexBuffers = Array.from(vertexBuffers.values());
        return attributes;
    }
    /**
	 * Returns the vertex buffers of the render object.
	 *
	 * @return {Array<BufferAttribute|InterleavedBuffer>} An array with buffer attribute or interleaved buffers.
	 */ getVertexBuffers() {
        if (this.vertexBuffers === null) this.getAttributes();
        return this.vertexBuffers;
    }
    /**
	 * Returns the draw parameters for the render object.
	 *
	 * @return {?{vertexCount: number, firstVertex: number, instanceCount: number, firstInstance: number}} The draw parameters.
	 */ getDrawParameters() {
        const { object: object, material: material, geometry: geometry, group: group, drawRange: drawRange } = this;
        const drawParams = this.drawParams || (this.drawParams = {
            vertexCount: 0,
            firstVertex: 0,
            instanceCount: 0,
            firstInstance: 0
        });
        const index = this.getIndex();
        const hasIndex = index !== null;
        let instanceCount = 1;
        if (geometry.isInstancedBufferGeometry === true) instanceCount = geometry.instanceCount;
        else if (object.count !== undefined) instanceCount = Math.max(0, object.count);
        if (instanceCount === 0) return null;
        drawParams.instanceCount = instanceCount;
        if (object.isBatchedMesh === true) return drawParams;
        let rangeFactor = 1;
        if (material.wireframe === true && !object.isPoints && !object.isLineSegments && !object.isLine && !object.isLineLoop) rangeFactor = 2;
        let firstVertex = drawRange.start * rangeFactor;
        let lastVertex = (drawRange.start + drawRange.count) * rangeFactor;
        if (group !== null) {
            firstVertex = Math.max(firstVertex, group.start * rangeFactor);
            lastVertex = Math.min(lastVertex, (group.start + group.count) * rangeFactor);
        }
        const position = geometry.attributes.position;
        let itemCount = Infinity;
        if (hasIndex) itemCount = index.count;
        else if (position !== undefined && position !== null) itemCount = position.count;
        firstVertex = Math.max(firstVertex, 0);
        lastVertex = Math.min(lastVertex, itemCount);
        const count = lastVertex - firstVertex;
        if (count < 0 || count === Infinity) return null;
        drawParams.vertexCount = count;
        drawParams.firstVertex = firstVertex;
        return drawParams;
    }
    /**
	 * Returns the render object's geometry cache key.
	 *
	 * The geometry cache key is part of the material cache key.
	 *
	 * @return {string} The geometry cache key.
	 */ getGeometryCacheKey() {
        const { geometry: geometry } = this;
        let cacheKey = '';
        for (const name of Object.keys(geometry.attributes).sort()){
            const attribute = geometry.attributes[name];
            cacheKey += name + ',';
            if (attribute.data) cacheKey += attribute.data.stride + ',';
            if (attribute.offset) cacheKey += attribute.offset + ',';
            if (attribute.itemSize) cacheKey += attribute.itemSize + ',';
            if (attribute.normalized) cacheKey += 'n,';
        }
        // structural equality isn't sufficient for morph targets since the
        // data are maintained in textures. only if the targets are all equal
        // the texture and thus the instance of `MorphNode` can be shared.
        for (const name of Object.keys(geometry.morphAttributes).sort()){
            const targets = geometry.morphAttributes[name];
            cacheKey += 'morph-' + name + ',';
            for(let i = 0, l = targets.length; i < l; i++){
                const attribute = targets[i];
                cacheKey += attribute.id + ',';
            }
        }
        if (geometry.index) cacheKey += 'index,';
        return cacheKey;
    }
    /**
	 * Returns the render object's material cache key.
	 *
	 * The material cache key is part of the render object cache key.
	 *
	 * @return {number} The material cache key.
	 */ getMaterialCacheKey() {
        const { object: object, material: material, renderer: renderer } = this;
        let cacheKey = material.customProgramCacheKey();
        for (const property of $03ccd63b0299d6a7$var$getKeys(material)){
            if (/^(is[A-Z]|_)|^(visible|version|uuid|name|opacity|userData)$/.test(property)) continue;
            const value = material[property];
            let valueKey;
            if (value !== null) {
                // some material values require a formatting
                const type = typeof value;
                if (type === 'number') valueKey = value !== 0 ? '1' : '0'; // Convert to on/off, important for clearcoat, transmission, etc
                else if (type === 'object') {
                    valueKey = '{';
                    if (value.isTexture) {
                        valueKey += value.mapping;
                        // WebGPU must honor the sampler data because they are part of the bindings
                        if (renderer.backend.isWebGPUBackend === true) {
                            valueKey += value.magFilter;
                            valueKey += value.minFilter;
                            valueKey += value.wrapS;
                            valueKey += value.wrapT;
                            valueKey += value.wrapR;
                        }
                    }
                    valueKey += '}';
                } else valueKey = String(value);
            } else valueKey = String(value);
            cacheKey += /*property + ':' +*/ valueKey + ',';
        }
        cacheKey += this.clippingContextCacheKey + ',';
        if (object.geometry) cacheKey += this.getGeometryCacheKey();
        if (object.skeleton) cacheKey += object.skeleton.bones.length + ',';
        if (object.isBatchedMesh) {
            cacheKey += object._matricesTexture.uuid + ',';
            if (object._colorsTexture !== null) cacheKey += object._colorsTexture.uuid + ',';
        }
        if (object.isInstancedMesh || object.count > 1 || Array.isArray(object.morphTargetInfluences)) // TODO: https://github.com/mrdoob/three.js/pull/29066#issuecomment-2269400850
        cacheKey += object.uuid + ',';
        cacheKey += this.context.id + ',';
        cacheKey += object.receiveShadow + ',';
        return $03ccd63b0299d6a7$var$hashString(cacheKey);
    }
    /**
	 * Whether the geometry requires an update or not.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get needsGeometryUpdate() {
        if (this.geometry.id !== this.object.geometry.id) return true;
        if (this.attributes !== null) {
            const attributesId = this.attributesId;
            for(const name in attributesId){
                const attribute = this.geometry.getAttribute(name);
                if (attribute === undefined || attributesId[name] !== attribute.id) return true;
            }
        }
        return false;
    }
    /**
	 * Whether the render object requires an update or not.
	 *
	 * Note: There are two distinct places where render objects are checked for an update.
	 *
	 * 1. In `RenderObjects.get()` which is executed when the render object is request. This
	 * method checks the `needsUpdate` flag and recreates the render object if necessary.
	 * 2. In `Renderer._renderObjectDirect()` right after getting the render object via
	 * `RenderObjects.get()`. The render object's NodeMaterialObserver is then used to detect
	 * a need for a refresh due to material, geometry or object related value changes.
	 *
	 * TODO: Investigate if it's possible to merge both steps so there is only a single place
	 * that performs the 'needsUpdate' check.
	 *
	 * @type {boolean}
	 * @readonly
	 */ get needsUpdate() {
        return /*this.object.static !== true &&*/ this.initialNodesCacheKey !== this.getDynamicCacheKey() || this.clippingNeedsUpdate;
    }
    /**
	 * Returns the dynamic cache key which represents a key that is computed per draw command.
	 *
	 * @return {number} The cache key.
	 */ getDynamicCacheKey() {
        let cacheKey = 0;
        // `Nodes.getCacheKey()` returns an environment cache key which is not relevant when
        // the renderer is inside a shadow pass.
        if (this.material.isShadowPassMaterial !== true) cacheKey = this._nodes.getCacheKey(this.scene, this.lightsNode);
        if (this.camera.isArrayCamera) cacheKey = $03ccd63b0299d6a7$var$hash$1(cacheKey, this.camera.cameras.length);
        if (this.object.receiveShadow) cacheKey = $03ccd63b0299d6a7$var$hash$1(cacheKey, 1);
        cacheKey = $03ccd63b0299d6a7$var$hash$1(cacheKey, this.renderer.contextNode.id, this.renderer.contextNode.version);
        return cacheKey;
    }
    /**
	 * Returns the render object's cache key.
	 *
	 * @return {number} The cache key.
	 */ getCacheKey() {
        return this.getMaterialCacheKey() + this.getDynamicCacheKey();
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.material.removeEventListener('dispose', this.onMaterialDispose);
        this.geometry.removeEventListener('dispose', this.onGeometryDispose);
        this.onDispose();
    }
}
const $03ccd63b0299d6a7$var$_chainKeys$3 = [];
/**
 * This module manages the render objects of the renderer.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderObjects {
    /**
	 * Constructs a new render object management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Pipelines} pipelines - Renderer component for managing pipelines.
	 * @param {Bindings} bindings - Renderer component for managing bindings.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, nodes, geometries, pipelines, bindings, info){
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing geometries.
		 *
		 * @type {Geometries}
		 */ this.geometries = geometries;
        /**
		 * Renderer component for managing pipelines.
		 *
		 * @type {Pipelines}
		 */ this.pipelines = pipelines;
        /**
		 * Renderer component for managing bindings.
		 *
		 * @type {Bindings}
		 */ this.bindings = bindings;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A dictionary that manages render contexts in chain maps
		 * for each pass ID.
		 *
		 * @type {Object<string,ChainMap>}
		 */ this.chainMaps = {};
    }
    /**
	 * Returns a render object for the given object and state data.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The 3D object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the 3D object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 * @return {RenderObject} The render object.
	 */ get(object, material, scene, camera, lightsNode, renderContext, clippingContext, passId) {
        const chainMap = this.getChainMap(passId);
        // set chain keys
        $03ccd63b0299d6a7$var$_chainKeys$3[0] = object;
        $03ccd63b0299d6a7$var$_chainKeys$3[1] = material;
        $03ccd63b0299d6a7$var$_chainKeys$3[2] = renderContext;
        $03ccd63b0299d6a7$var$_chainKeys$3[3] = lightsNode;
        //
        let renderObject = chainMap.get($03ccd63b0299d6a7$var$_chainKeys$3);
        if (renderObject === undefined) {
            renderObject = this.createRenderObject(this.nodes, this.geometries, this.renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext, passId);
            chainMap.set($03ccd63b0299d6a7$var$_chainKeys$3, renderObject);
        } else {
            // update references
            renderObject.camera = camera;
            //
            renderObject.updateClipping(clippingContext);
            if (renderObject.needsGeometryUpdate) renderObject.setGeometry(object.geometry);
            if (renderObject.version !== material.version || renderObject.needsUpdate) {
                if (renderObject.initialCacheKey !== renderObject.getCacheKey()) {
                    renderObject.dispose();
                    renderObject = this.get(object, material, scene, camera, lightsNode, renderContext, clippingContext, passId);
                } else renderObject.version = material.version;
            }
        }
        // reset chain array
        $03ccd63b0299d6a7$var$_chainKeys$3[0] = null;
        $03ccd63b0299d6a7$var$_chainKeys$3[1] = null;
        $03ccd63b0299d6a7$var$_chainKeys$3[2] = null;
        $03ccd63b0299d6a7$var$_chainKeys$3[3] = null;
        //
        return renderObject;
    }
    /**
	 * Returns a chain map for the given pass ID.
	 *
	 * @param {string} [passId='default'] - The pass ID.
	 * @return {ChainMap} The chain map.
	 */ getChainMap(passId = 'default') {
        return this.chainMaps[passId] || (this.chainMaps[passId] = new $03ccd63b0299d6a7$var$ChainMap());
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.chainMaps = {};
    }
    /**
	 * Factory method for creating render objects with the given list of parameters.
	 *
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Geometries} geometries - Renderer component for managing geometries.
	 * @param {Renderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 * @return {RenderObject} The render object.
	 */ createRenderObject(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext, passId) {
        const chainMap = this.getChainMap(passId);
        const renderObject = new $03ccd63b0299d6a7$var$RenderObject(nodes, geometries, renderer, object, material, scene, camera, lightsNode, renderContext, clippingContext);
        renderObject.onDispose = ()=>{
            this.pipelines.delete(renderObject);
            this.bindings.deleteForRender(renderObject);
            this.nodes.delete(renderObject);
            chainMap.delete(renderObject.getChainArray());
        };
        return renderObject;
    }
}
/**
 * Data structure for the renderer. It is intended to manage
 * data of objects in dictionaries.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new data map.
	 */ constructor(){
        /**
		 * `DataMap` internally uses a weak map
		 * to manage its data.
		 *
		 * @type {WeakMap<Object, Object>}
		 */ this.data = new WeakMap();
    }
    /**
	 * Returns the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {Object} The dictionary.
	 */ get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    /**
	 * Deletes the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        let map = null;
        if (this.data.has(object)) {
            map = this.data.get(object);
            this.data.delete(object);
        }
        return map;
    }
    /**
	 * Returns `true` if the given object has a dictionary defined.
	 *
	 * @param {Object} object - The object to test.
	 * @return {boolean} Whether a dictionary is defined or not.
	 */ has(object) {
        return this.data.has(object);
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.data = new WeakMap();
    }
}
const $03ccd63b0299d6a7$var$AttributeType = {
    VERTEX: 1,
    INDEX: 2,
    STORAGE: 3,
    INDIRECT: 4
};
// size of a chunk in bytes (STD140 layout)
const $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES = 16;
// @TODO: Move to src/constants.js
const $03ccd63b0299d6a7$var$BlendColorFactor = 211;
const $03ccd63b0299d6a7$var$OneMinusBlendColorFactor = 212;
/**
 * This renderer module manages geometry attributes.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Attributes extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new attribute management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(backend, info){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
    }
    /**
	 * Deletes the data for the given attribute.
	 *
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {?Object} The deleted attribute data.
	 */ delete(attribute) {
        const attributeData = super.delete(attribute);
        if (attributeData !== null) {
            this.backend.destroyAttribute(attribute);
            this.info.destroyAttribute(attribute);
        }
        return attributeData;
    }
    /**
	 * Updates the given attribute. This method creates attribute buffers
	 * for new attributes and updates data for existing ones.
	 *
	 * @param {BufferAttribute} attribute - The attribute to update.
	 * @param {number} type - The attribute type.
	 */ update(attribute, type) {
        const data = this.get(attribute);
        if (data.version === undefined) {
            if (type === $03ccd63b0299d6a7$var$AttributeType.VERTEX) {
                this.backend.createAttribute(attribute);
                this.info.createAttribute(attribute);
            } else if (type === $03ccd63b0299d6a7$var$AttributeType.INDEX) {
                this.backend.createIndexAttribute(attribute);
                this.info.createIndexAttribute(attribute);
            } else if (type === $03ccd63b0299d6a7$var$AttributeType.STORAGE) {
                this.backend.createStorageAttribute(attribute);
                this.info.createStorageAttribute(attribute);
            } else if (type === $03ccd63b0299d6a7$var$AttributeType.INDIRECT) {
                this.backend.createIndirectStorageAttribute(attribute);
                this.info.createIndirectStorageAttribute(attribute);
            }
            data.version = this._getBufferAttribute(attribute).version;
        } else {
            const bufferAttribute = this._getBufferAttribute(attribute);
            if (data.version < bufferAttribute.version || bufferAttribute.usage === (0, $9ddd7e9b53f7a2d4$export$8505d14ac8546ca)) {
                this.backend.updateAttribute(attribute);
                data.version = bufferAttribute.version;
            }
        }
    }
    /**
	 * Utility method for handling interleaved buffer attributes correctly.
	 * To process them, their `InterleavedBuffer` is returned.
	 *
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {BufferAttribute|InterleavedBuffer}
	 */ _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
/**
 * Returns the wireframe version for the given geometry.
 *
 * @private
 * @function
 * @param {BufferGeometry} geometry - The geometry.
 * @return {number} The version.
 */ function $03ccd63b0299d6a7$var$getWireframeVersion(geometry) {
    return geometry.index !== null ? geometry.index.version : geometry.attributes.position.version;
}
/**
 * Returns the wireframe ID for the given geometry.
 *
 * @private
 * @function
 * @param {BufferGeometry} geometry - The geometry.
 * @return {number} The ID.
 */ function $03ccd63b0299d6a7$var$getWireframeId(geometry) {
    return geometry.index !== null ? geometry.index.id : geometry.attributes.position.id;
}
/**
 * Returns a wireframe index attribute for the given geometry.
 *
 * @private
 * @function
 * @param {BufferGeometry} geometry - The geometry.
 * @return {BufferAttribute} The wireframe index attribute.
 */ function $03ccd63b0299d6a7$var$getWireframeIndex(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    if (geometryIndex !== null) {
        const array = geometryIndex.array;
        for(let i = 0, l = array.length; i < l; i += 3){
            const a = array[i + 0];
            const b = array[i + 1];
            const c = array[i + 2];
            indices.push(a, b, b, c, c, a);
        }
    } else {
        const array = geometryPosition.array;
        for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
            const a = i + 0;
            const b = i + 1;
            const c = i + 2;
            indices.push(a, b, b, c, c, a);
        }
    }
    const attribute = new (geometryPosition.count >= 65535 ? (0, $9ddd7e9b53f7a2d4$export$7eb8c9fa25cd5bd6) : (0, $9ddd7e9b53f7a2d4$export$640a853f68025f2e))(indices, 1);
    attribute.version = $03ccd63b0299d6a7$var$getWireframeVersion(geometry);
    attribute.__id = $03ccd63b0299d6a7$var$getWireframeId(geometry);
    return attribute;
}
/**
 * This renderer module manages geometries.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Geometries extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new geometry management component.
	 *
	 * @param {Attributes} attributes - Renderer component for managing attributes.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(attributes, info){
        super();
        /**
		 * Renderer component for managing attributes.
		 *
		 * @type {Attributes}
		 */ this.attributes = attributes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * Weak Map for managing attributes for wireframe rendering.
		 *
		 * @type {WeakMap<BufferGeometry,BufferAttribute>}
		 */ this.wireframes = new WeakMap();
        /**
		 * This Weak Map is used to make sure buffer attributes are
		 * updated only once per render call.
		 *
		 * @type {WeakMap<BufferAttribute,number>}
		 */ this.attributeCall = new WeakMap();
        /**
		 * Stores the event listeners attached to geometries.
		 *
		 * @private
		 * @type {Map<BufferGeometry,Function>}
		 */ this._geometryDisposeListeners = new Map();
    }
    /**
	 * Returns `true` if the given render object has an initialized geometry.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether if the given render object has an initialized geometry or not.
	 */ has(renderObject) {
        const geometry = renderObject.geometry;
        return super.has(geometry) && this.get(geometry).initialized === true;
    }
    /**
	 * Prepares the geometry of the given render object for rendering.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        if (this.has(renderObject) === false) this.initGeometry(renderObject);
        this.updateAttributes(renderObject);
    }
    /**
	 * Initializes the geometry of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ initGeometry(renderObject) {
        const geometry = renderObject.geometry;
        const geometryData = this.get(geometry);
        geometryData.initialized = true;
        this.info.memory.geometries++;
        const onDispose = ()=>{
            this.info.memory.geometries--;
            const index = geometry.index;
            const geometryAttributes = renderObject.getAttributes();
            if (index !== null) this.attributes.delete(index);
            for (const geometryAttribute of geometryAttributes)this.attributes.delete(geometryAttribute);
            const wireframeAttribute = this.wireframes.get(geometry);
            if (wireframeAttribute !== undefined) this.attributes.delete(wireframeAttribute);
            geometry.removeEventListener('dispose', onDispose);
            this._geometryDisposeListeners.delete(geometry);
        };
        geometry.addEventListener('dispose', onDispose);
        // see #31798 why tracking separate remove listeners is required right now
        // TODO: Re-evaluate how onDispose() is managed in this component
        this._geometryDisposeListeners.set(geometry, onDispose);
    }
    /**
	 * Updates the geometry attributes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateAttributes(renderObject) {
        // attributes
        const attributes = renderObject.getAttributes();
        for (const attribute of attributes)if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) this.updateAttribute(attribute, $03ccd63b0299d6a7$var$AttributeType.STORAGE);
        else this.updateAttribute(attribute, $03ccd63b0299d6a7$var$AttributeType.VERTEX);
        // indexes
        const index = this.getIndex(renderObject);
        if (index !== null) this.updateAttribute(index, $03ccd63b0299d6a7$var$AttributeType.INDEX);
        // indirect
        const indirect = renderObject.geometry.indirect;
        if (indirect !== null) this.updateAttribute(indirect, $03ccd63b0299d6a7$var$AttributeType.INDIRECT);
    }
    /**
	 * Updates the given attribute.
	 *
	 * @param {BufferAttribute} attribute - The attribute to update.
	 * @param {number} type - The attribute type.
	 */ updateAttribute(attribute, type) {
        const callId = this.info.render.calls;
        if (!attribute.isInterleavedBufferAttribute) {
            if (this.attributeCall.get(attribute) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            }
        } else {
            if (this.attributeCall.get(attribute) === undefined) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute, callId);
            } else if (this.attributeCall.get(attribute.data) !== callId) {
                this.attributes.update(attribute, type);
                this.attributeCall.set(attribute.data, callId);
                this.attributeCall.set(attribute, callId);
            }
        }
    }
    /**
	 * Returns the indirect buffer attribute of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {?BufferAttribute} The indirect attribute. `null` if no indirect drawing is used.
	 */ getIndirect(renderObject) {
        return renderObject.geometry.indirect;
    }
    /**
	 * Returns the byte offset into the indirect attribute buffer of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {number} The byte offset into the indirect attribute buffer.
	 */ getIndirectOffset(renderObject) {
        return renderObject.geometry.indirectOffset;
    }
    /**
	 * Returns the index of the given render object's geometry. This is implemented
	 * in a method to return a wireframe index if necessary.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {?BufferAttribute} The index. Returns `null` for non-indexed geometries.
	 */ getIndex(renderObject) {
        const { geometry: geometry, material: material } = renderObject;
        let index = geometry.index;
        if (material.wireframe === true) {
            const wireframes = this.wireframes;
            let wireframeAttribute = wireframes.get(geometry);
            if (wireframeAttribute === undefined) {
                wireframeAttribute = $03ccd63b0299d6a7$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            } else if (wireframeAttribute.version !== $03ccd63b0299d6a7$var$getWireframeVersion(geometry) || wireframeAttribute.__id !== $03ccd63b0299d6a7$var$getWireframeId(geometry)) {
                this.attributes.delete(wireframeAttribute);
                wireframeAttribute = $03ccd63b0299d6a7$var$getWireframeIndex(geometry);
                wireframes.set(geometry, wireframeAttribute);
            }
            index = wireframeAttribute;
        }
        return index;
    }
    dispose() {
        for (const [geometry, onDispose] of this._geometryDisposeListeners.entries())geometry.removeEventListener('dispose', onDispose);
        this._geometryDisposeListeners.clear();
    }
}
/**
 * This renderer module provides a series of statistical information
 * about the GPU memory and the rendering process. Useful for debugging
 * and monitoring.
 */ class $03ccd63b0299d6a7$var$Info {
    /**
	 * Constructs a new info component.
	 */ constructor(){
        /**
		 * Whether frame related metrics should automatically
		 * be resetted or not. This property should be set to `false`
		 * by apps which manage their own animation loop. They must
		 * then call `renderer.info.reset()` once per frame manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoReset = true;
        /**
		 * The current frame ID. This ID is managed
		 * by `NodeFrame`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.frame = 0;
        /**
		 * The number of render calls since the
		 * app has been started.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.calls = 0;
        /**
		 * Render related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} calls - The number of render calls since the app has been started.
		 * @property {number} frameCalls - The number of render calls of the current frame.
		 * @property {number} drawCalls - The number of draw calls of the current frame.
		 * @property {number} triangles - The number of rendered triangle primitives of the current frame.
		 * @property {number} points - The number of rendered point primitives of the current frame.
		 * @property {number} lines - The number of rendered line primitives of the current frame.
		 * @property {number} timestamp - The timestamp of the frame.
		 */ this.render = {
            calls: 0,
            frameCalls: 0,
            drawCalls: 0,
            triangles: 0,
            points: 0,
            lines: 0,
            timestamp: 0
        };
        /**
		 * Compute related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} calls - The number of compute calls since the app has been started.
		 * @property {number} frameCalls - The number of compute calls of the current frame.
		 * @property {number} timestamp - The timestamp of the frame when using `renderer.computeAsync()`.
		 */ this.compute = {
            calls: 0,
            frameCalls: 0,
            timestamp: 0
        };
        /**
		 * Memory related metrics.
		 *
		 * @type {Object}
		 * @readonly
		 * @property {number} geometries - The number of active geometries.
		 * @property {number} textures - The number of active textures.
		 * @property {number} attributes - The number of active attributes.
		 * @property {number} indexAttributes - The number of active index attributes.
		 * @property {number} storageAttributes - The number of active storage attributes.
		 * @property {number} indirectStorageAttributes - The number of active indirect storage attributes.
		 * @property {number} readbackBuffers - The number of active readback buffers.
		 * @property {number} programs - The number of active programs.
		 * @property {number} renderTargets - The number of active renderTargets.
		 * @property {number} total - The total memory size in bytes.
		 * @property {number} texturesSize - The memory size of active textures in bytes.
		 * @property {number} attributesSize - The memory size of active attributes in bytes.
		 * @property {number} indexAttributesSize - The memory size of active index attributes in bytes.
		 * @property {number} storageAttributesSize - The memory size of active storage attributes in bytes.
		 * @property {number} indirectStorageAttributesSize - The memory size of active indirect storage attributes in bytes.
		 * @property {number} readbackBuffersSize - The memory size of active readback buffers in bytes.
		 * @property {number} programsSize - The memory size of active programs in bytes.
		 */ this.memory = {
            geometries: 0,
            textures: 0,
            attributes: 0,
            indexAttributes: 0,
            storageAttributes: 0,
            indirectStorageAttributes: 0,
            readbackBuffers: 0,
            programs: 0,
            renderTargets: 0,
            total: 0,
            texturesSize: 0,
            attributesSize: 0,
            indexAttributesSize: 0,
            storageAttributesSize: 0,
            indirectStorageAttributesSize: 0,
            readbackBuffersSize: 0,
            programsSize: 0
        };
        /**
		 * Map for storing calculated byte sizes of tracked objects.
		 *
		 * @type {Map<Object, number>}
		 * @private
		 */ this.memoryMap = new Map();
    }
    /**
	 * This method should be executed per draw call and updates the corresponding metrics.
	 *
	 * @param {Object3D} object - The 3D object that is going to be rendered.
	 * @param {number} count - The vertex or index count.
	 * @param {number} instanceCount - The instance count.
	 */ update(object, count, instanceCount) {
        this.render.drawCalls++;
        if (object.isMesh || object.isSprite) this.render.triangles += instanceCount * (count / 3);
        else if (object.isPoints) this.render.points += instanceCount * count;
        else if (object.isLineSegments) this.render.lines += instanceCount * (count / 2);
        else if (object.isLine) this.render.lines += instanceCount * (count - 1);
        else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUInfo: Unknown object type.');
    }
    /**
	 * Resets frame related metrics.
	 */ reset() {
        this.render.drawCalls = 0;
        this.render.frameCalls = 0;
        this.compute.frameCalls = 0;
        this.render.triangles = 0;
        this.render.points = 0;
        this.render.lines = 0;
    }
    /**
	 * Performs a complete reset of the object.
	 */ dispose() {
        this.reset();
        this.calls = 0;
        this.render.calls = 0;
        this.compute.calls = 0;
        this.render.timestamp = 0;
        this.compute.timestamp = 0;
        for(const prop in this.memory)this.memory[prop] = 0;
        this.memoryMap.clear();
    }
    /**
	 * Tracks texture memory explicitly, updating counts and byte tracking.
	 *
	 * @param {Texture} texture
	 */ createTexture(texture) {
        const size = this._getTextureMemorySize(texture);
        this.memoryMap.set(texture, size);
        this.memory.textures++;
        this.memory.total += size;
        this.memory.texturesSize += size;
    }
    /**
	 * Tracks texture memory explicitly, updating counts and byte tracking.
	 *
	 * @param {Texture} texture
	 */ destroyTexture(texture) {
        const size = this.memoryMap.get(texture) || 0;
        this.memoryMap.delete(texture);
        this.memory.textures--;
        this.memory.total -= size;
        this.memory.texturesSize -= size;
    }
    /**
	 * Tracks attribute memory explicitly, updating counts and byte tracking.
	 *
	 * @param {BufferAttribute} attribute
	 * @param {string} type - type of attribute
	 * @private
	 */ _createAttribute(attribute, type) {
        const size = this._getAttributeMemorySize(attribute);
        this.memoryMap.set(attribute, {
            size: size,
            type: type
        });
        this.memory[type]++;
        this.memory.total += size;
        this.memory[type + 'Size'] += size;
    }
    /**
	 * Tracks a regular attribute memory explicitly.
	 *
	 * @param {BufferAttribute} attribute - The attribute to track.
	 */ createAttribute(attribute) {
        this._createAttribute(attribute, 'attributes');
    }
    /**
	 * Tracks an index attribute memory explicitly.
	 *
	 * @param {BufferAttribute} attribute - The index attribute to track.
	 */ createIndexAttribute(attribute) {
        this._createAttribute(attribute, 'indexAttributes');
    }
    /**
	 * Tracks a storage attribute memory explicitly.
	 *
	 * @param {BufferAttribute} attribute - The storage attribute to track.
	 */ createStorageAttribute(attribute) {
        this._createAttribute(attribute, 'storageAttributes');
    }
    /**
	 * Tracks an indirect storage attribute memory explicitly.
	 *
	 * @param {BufferAttribute} attribute - The indirect storage attribute to track.
	 */ createIndirectStorageAttribute(attribute) {
        this._createAttribute(attribute, 'indirectStorageAttributes');
    }
    /**
	 * Tracks attribute memory explicitly, updating counts and byte tracking.
	 *
	 * @param {BufferAttribute} attribute
	 */ destroyAttribute(attribute) {
        const data = this.memoryMap.get(attribute);
        if (data) {
            this.memoryMap.delete(attribute);
            this.memory[data.type]--;
            this.memory.total -= data.size;
            this.memory[data.type + 'Size'] -= data.size;
        }
    }
    /**
	 * Tracks a readback buffer memory explicitly.
	 *
	 * @param {ReadbackBuffer} readbackBuffer - The readback buffer to track.
	 */ createReadbackBuffer(readbackBuffer) {
        const maxByteLength = readbackBuffer.maxByteLength;
        this.memoryMap.set(readbackBuffer, {
            size: maxByteLength,
            type: 'readbackBuffers'
        });
        this.memory.readbackBuffers++;
        this.memory.total += maxByteLength;
        this.memory.readbackBuffersSize += maxByteLength;
    }
    /**
	 * Tracks a readback buffer memory explicitly.
	 *
	 * @param {ReadbackBuffer} readbackBuffer - The readback buffer to track.
	 */ destroyReadbackBuffer(readbackBuffer) {
        const { size: size } = this.memoryMap.get(readbackBuffer);
        this.memoryMap.delete(readbackBuffer);
        this.memory.readbackBuffers--;
        this.memory.total -= size;
        this.memory.readbackBuffersSize -= size;
    }
    /**
	 * Tracks program memory explicitly, updating counts and byte tracking.
	 *
	 * @param {ProgrammableStage} program - The program to track.
	 */ createProgram(program) {
        const size = program.code.length; // Approx size
        this.memoryMap.set(program, size);
        this.memory.programs++;
        this.memory.total += size;
        this.memory.programsSize += size;
    }
    /**
	 * Tracks program memory explicitly, updating counts and byte tracking.
	 *
	 * @param {Object} program - The program to track.
	 */ destroyProgram(program) {
        const size = this.memoryMap.get(program) || 0;
        this.memoryMap.delete(program);
        this.memory.programs--;
        this.memory.total -= size;
        this.memory.programsSize -= size;
    }
    /**
	 * Calculates the memory size of a texture in bytes.
	 *
	 * @param {Texture} texture - The texture to calculate the size for.
	 * @return {number} The calculated size in bytes.
	 * @private
	 */ _getTextureMemorySize(texture) {
        if (texture.isCompressedTexture) return 1; // Fallback estimate since exact format decompressed isn't readily available without format maps
        let bytesPerChannel = 1;
        if (texture.type === (0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a) || texture.type === (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) bytesPerChannel = 1;
        else if (texture.type === (0, $9ddd7e9b53f7a2d4$export$88572337f312435f) || texture.type === (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d) || texture.type === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)) bytesPerChannel = 2;
        else if (texture.type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2) || texture.type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96) || texture.type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) bytesPerChannel = 4;
        let channels = 4; // RGBA default
        if (texture.format === (0, $9ddd7e9b53f7a2d4$export$988473390501ed4b) || texture.format === (0, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b) || texture.format === (0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190) || texture.format === (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045) || texture.format === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829)) channels = 1;
        else if (texture.format === (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0) || texture.format === (0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7)) channels = 2;
        else if (texture.format === (0, $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb) || texture.format === (0, $9ddd7e9b53f7a2d4$export$d1fd40c11bfa798e)) channels = 3;
        let bytesPerPixel = bytesPerChannel * channels;
        // Packed overrides
        if (texture.type === (0, $9ddd7e9b53f7a2d4$export$b3969b01faf587f2) || texture.type === (0, $9ddd7e9b53f7a2d4$export$18886f8ae33e90de)) bytesPerPixel = 2;
        else if (texture.type === (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) || texture.type === (0, $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3) || texture.type === (0, $9ddd7e9b53f7a2d4$export$f240f067f72abe41)) bytesPerPixel = 4;
        const width = texture.width || 1;
        const height = texture.height || 1;
        const depth = texture.isCubeTexture ? 6 : texture.depth || 1;
        let size = width * height * depth * bytesPerPixel;
        const mipmaps = texture.mipmaps;
        if (mipmaps && mipmaps.length > 0) {
            let mipmapSize = 0;
            for(let i = 0; i < mipmaps.length; i++){
                const mipmap = mipmaps[i];
                if (mipmap.data) mipmapSize += mipmap.data.byteLength;
                else {
                    const mipWidth = mipmap.width || Math.max(1, width >> i);
                    const mipHeight = mipmap.height || Math.max(1, height >> i);
                    mipmapSize += mipWidth * mipHeight * depth * bytesPerPixel;
                }
            }
            size += mipmapSize;
        } else if (texture.generateMipmaps) size = size * 1.333; // MiP chain approximation
        return Math.round(size);
    }
    /**
	 * Calculates the memory size of an attribute in bytes.
	 *
	 * @param {BufferAttribute} attribute - The attribute to calculate the size for.
	 * @return {number} The calculated size in bytes.
	 * @private
	 */ _getAttributeMemorySize(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.array) return attribute.array.byteLength;
        else if (attribute.count && attribute.itemSize) return attribute.count * attribute.itemSize * 4; // Assume Float32
        return 0;
    }
}
/**
 * Abstract class for representing pipelines.
 *
 * @private
 * @abstract
 */ class $03ccd63b0299d6a7$var$Pipeline {
    /**
	 * Constructs a new pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 */ constructor(cacheKey){
        /**
		 * The pipeline's cache key.
		 *
		 * @type {string}
		 */ this.cacheKey = cacheKey;
        /**
		 * How often the pipeline is currently in use.
		 *
		 * @type {number}
		 * @default 0
		 */ this.usedTimes = 0;
    }
}
/**
 * Class for representing render pipelines.
 *
 * @private
 * @augments Pipeline
 */ class $03ccd63b0299d6a7$var$RenderObjectPipeline extends $03ccd63b0299d6a7$var$Pipeline {
    /**
	 * Constructs a new render object pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 * @param {ProgrammableStage} vertexProgram - The pipeline's vertex shader.
	 * @param {ProgrammableStage} fragmentProgram - The pipeline's fragment shader.
	 */ constructor(cacheKey, vertexProgram, fragmentProgram){
        super(cacheKey);
        /**
		 * The pipeline's vertex shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.vertexProgram = vertexProgram;
        /**
		 * The pipeline's fragment shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.fragmentProgram = fragmentProgram;
    }
}
/**
 * Class for representing compute pipelines.
 *
 * @private
 * @augments Pipeline
 */ class $03ccd63b0299d6a7$var$ComputePipeline extends $03ccd63b0299d6a7$var$Pipeline {
    /**
	 * Constructs a new compute pipeline.
	 *
	 * @param {string} cacheKey - The pipeline's cache key.
	 * @param {ProgrammableStage} computeProgram - The pipeline's compute shader.
	 */ constructor(cacheKey, computeProgram){
        super(cacheKey);
        /**
		 * The pipeline's compute shader.
		 *
		 * @type {ProgrammableStage}
		 */ this.computeProgram = computeProgram;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isComputePipeline = true;
    }
}
let $03ccd63b0299d6a7$var$_id$9 = 0;
/**
 * Class for representing programmable stages which are vertex,
 * fragment or compute shaders. Unlike fixed-function states (like blending),
 * they represent the programmable part of a pipeline.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$ProgrammableStage {
    /**
	 * Constructs a new programmable stage.
	 *
	 * @param {string} code - The shader code.
	 * @param {('vertex'|'fragment'|'compute')} stage - The type of stage.
	 * @param {string} name - The name of the shader.
	 * @param {?Array<Object>} [transforms=null] - The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
	 * @param {?Array<Object>} [attributes=null] - The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
	 */ constructor(code, stage, name, transforms = null, attributes = null){
        /**
		 * The id of the programmable stage.
		 *
		 * @type {number}
		 */ this.id = $03ccd63b0299d6a7$var$_id$9++;
        /**
		 * The shader code.
		 *
		 * @type {string}
		 */ this.code = code;
        /**
		 * The type of stage.
		 *
		 * @type {string}
		 */ this.stage = stage;
        /**
		 * The name of the stage.
		 * This is used for debugging purposes.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The transforms (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
		 *
		 * @type {?Array<Object>}
		 */ this.transforms = transforms;
        /**
		 * The attributes (only relevant for compute stages with WebGL 2 which uses Transform Feedback).
		 *
		 * @type {?Array<Object>}
		 */ this.attributes = attributes;
        /**
		 * How often the programmable stage is currently in use.
		 *
		 * @type {number}
		 * @default 0
		 */ this.usedTimes = 0;
    }
}
/**
 * This renderer module manages the pipelines of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Pipelines extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new pipeline management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(backend, nodes, info){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A references to the bindings management component.
		 * This reference will be set inside the `Bindings`
		 * constructor.
		 *
		 * @type {?Bindings}
		 * @default null
		 */ this.bindings = null;
        /**
		 * Internal cache for maintaining pipelines.
		 * The key of the map is a cache key, the value the pipeline.
		 *
		 * @type {Map<string,Pipeline>}
		 */ this.caches = new Map();
        /**
		 * This dictionary maintains for each shader stage type (vertex,
		 * fragment and compute) the programmable stage objects which
		 * represent the actual shader code.
		 *
		 * @type {Object<string,Map<string, ProgrammableStage>>}
		 */ this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    /**
	 * Returns a compute pipeline for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @return {ComputePipeline} The compute pipeline.
	 */ getForCompute(computeNode, bindings) {
        const { backend: backend } = this;
        const data = this.get(computeNode);
        if (this._needsComputeUpdate(computeNode)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.computeProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = this.nodes.getForCompute(computeNode);
            // programmable stage
            let stageCompute = this.programs.compute.get(nodeBuilderState.computeShader);
            if (stageCompute === undefined) {
                if (previousPipeline && previousPipeline.computeProgram.usedTimes === 0) this._releaseProgram(previousPipeline.computeProgram);
                stageCompute = new $03ccd63b0299d6a7$var$ProgrammableStage(nodeBuilderState.computeShader, 'compute', computeNode.name, nodeBuilderState.transforms, nodeBuilderState.nodeAttributes);
                this.programs.compute.set(nodeBuilderState.computeShader, stageCompute);
                backend.createProgram(stageCompute);
                this.info.createProgram(stageCompute);
            }
            // determine compute pipeline
            const cacheKey = this._getComputeCacheKey(computeNode, stageCompute);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getComputePipeline(computeNode, stageCompute, cacheKey, bindings);
            }
            // keep track of all used times
            pipeline.usedTimes++;
            stageCompute.usedTimes++;
            //
            data.version = computeNode.version;
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    /**
	 * Returns a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {?Array<Promise>} [promises=null] - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
	 * @return {RenderObjectPipeline} The render pipeline.
	 */ getForRender(renderObject, promises = null) {
        const { backend: backend } = this;
        const data = this.get(renderObject);
        if (this._needsRenderUpdate(renderObject)) {
            const previousPipeline = data.pipeline;
            if (previousPipeline) {
                previousPipeline.usedTimes--;
                previousPipeline.vertexProgram.usedTimes--;
                previousPipeline.fragmentProgram.usedTimes--;
            }
            // get shader
            const nodeBuilderState = renderObject.getNodeBuilderState();
            const name = renderObject.material ? renderObject.material.name : '';
            // programmable stages
            let stageVertex = this.programs.vertex.get(nodeBuilderState.vertexShader);
            if (stageVertex === undefined) {
                if (previousPipeline && previousPipeline.vertexProgram.usedTimes === 0) this._releaseProgram(previousPipeline.vertexProgram);
                stageVertex = new $03ccd63b0299d6a7$var$ProgrammableStage(nodeBuilderState.vertexShader, 'vertex', name);
                this.programs.vertex.set(nodeBuilderState.vertexShader, stageVertex);
                backend.createProgram(stageVertex);
                this.info.createProgram(stageVertex);
            }
            let stageFragment = this.programs.fragment.get(nodeBuilderState.fragmentShader);
            if (stageFragment === undefined) {
                if (previousPipeline && previousPipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(previousPipeline.fragmentProgram);
                stageFragment = new $03ccd63b0299d6a7$var$ProgrammableStage(nodeBuilderState.fragmentShader, 'fragment', name);
                this.programs.fragment.set(nodeBuilderState.fragmentShader, stageFragment);
                backend.createProgram(stageFragment);
                this.info.createProgram(stageFragment);
            }
            // determine render pipeline
            const cacheKey = this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
            let pipeline = this.caches.get(cacheKey);
            if (pipeline === undefined) {
                if (previousPipeline && previousPipeline.usedTimes === 0) this._releasePipeline(previousPipeline);
                pipeline = this._getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises);
            } else renderObject.pipeline = pipeline;
            // keep track of all used times
            pipeline.usedTimes++;
            stageVertex.usedTimes++;
            stageFragment.usedTimes++;
            //
            data.pipeline = pipeline;
        }
        return data.pipeline;
    }
    /**
	 * Checks if the render pipeline for the given render object is ready for drawing.
	 * Returns false if the GPU pipeline is still being compiled asynchronously.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} True if the pipeline is ready for drawing.
	 */ isReady(renderObject) {
        const data = this.get(renderObject);
        const pipeline = data.pipeline;
        if (pipeline === undefined) return false;
        const pipelineData = this.backend.get(pipeline);
        return pipelineData.pipeline !== undefined && pipelineData.pipeline !== null;
    }
    /**
	 * Deletes the pipeline for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        const pipeline = this.get(object).pipeline;
        if (pipeline) {
            // pipeline
            pipeline.usedTimes--;
            if (pipeline.usedTimes === 0) this._releasePipeline(pipeline);
            // programs
            if (pipeline.isComputePipeline) {
                pipeline.computeProgram.usedTimes--;
                if (pipeline.computeProgram.usedTimes === 0) this._releaseProgram(pipeline.computeProgram);
            } else {
                pipeline.fragmentProgram.usedTimes--;
                pipeline.vertexProgram.usedTimes--;
                if (pipeline.vertexProgram.usedTimes === 0) this._releaseProgram(pipeline.vertexProgram);
                if (pipeline.fragmentProgram.usedTimes === 0) this._releaseProgram(pipeline.fragmentProgram);
            }
        }
        return super.delete(object);
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        super.dispose();
        this.caches = new Map();
        this.programs = {
            vertex: new Map(),
            fragment: new Map(),
            compute: new Map()
        };
    }
    /**
	 * Updates the pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        this.getForRender(renderObject);
    }
    /**
	 * Returns a compute pipeline for the given parameters.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
	 * @param {string} cacheKey - The cache key.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @return {ComputePipeline} The compute pipeline.
	 */ _getComputePipeline(computeNode, stageCompute, cacheKey, bindings) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getComputeCacheKey(computeNode, stageCompute);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new $03ccd63b0299d6a7$var$ComputePipeline(cacheKey, stageCompute);
            this.caches.set(cacheKey, pipeline);
            this.backend.createComputePipeline(pipeline, bindings);
        }
        return pipeline;
    }
    /**
	 * Returns a render pipeline for the given parameters.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
	 * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
	 * @param {string} cacheKey - The cache key.
	 * @param {?Array<Promise>} promises - An array of compilation promises which is only relevant in context of `Renderer.compileAsync()`.
	 * @return {RenderObjectPipeline} The render pipeline.
	 */ _getRenderPipeline(renderObject, stageVertex, stageFragment, cacheKey, promises) {
        // check for existing pipeline
        cacheKey = cacheKey || this._getRenderCacheKey(renderObject, stageVertex, stageFragment);
        let pipeline = this.caches.get(cacheKey);
        if (pipeline === undefined) {
            pipeline = new $03ccd63b0299d6a7$var$RenderObjectPipeline(cacheKey, stageVertex, stageFragment);
            this.caches.set(cacheKey, pipeline);
            renderObject.pipeline = pipeline;
            // The `promises` array is `null` by default and only set to an empty array when
            // `Renderer.compileAsync()` is used. The next call actually fills the array with
            // pending promises that resolve when the render pipelines are ready for rendering.
            this.backend.createRenderPipeline(renderObject, promises);
        }
        return pipeline;
    }
    /**
	 * Computes a cache key representing a compute pipeline.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @param {ProgrammableStage} stageCompute - The programmable stage representing the compute shader.
	 * @return {string} The cache key.
	 */ _getComputeCacheKey(computeNode, stageCompute) {
        return computeNode.id + ',' + stageCompute.id;
    }
    /**
	 * Computes a cache key representing a render pipeline.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {ProgrammableStage} stageVertex - The programmable stage representing the vertex shader.
	 * @param {ProgrammableStage} stageFragment - The programmable stage representing the fragment shader.
	 * @return {string} The cache key.
	 */ _getRenderCacheKey(renderObject, stageVertex, stageFragment) {
        return stageVertex.id + ',' + stageFragment.id + ',' + this.backend.getRenderCacheKey(renderObject);
    }
    /**
	 * Releases the given pipeline.
	 *
	 * @private
	 * @param {Pipeline} pipeline - The pipeline to release.
	 */ _releasePipeline(pipeline) {
        this.caches.delete(pipeline.cacheKey);
    }
    /**
	 * Releases the shader program.
	 *
	 * @private
	 * @param {Object} program - The shader program to release.
	 */ _releaseProgram(program) {
        const code = program.code;
        const stage = program.stage;
        this.programs[stage].delete(code);
        this.info.destroyProgram(program);
    }
    /**
	 * Returns `true` if the compute pipeline for the given compute node requires an update.
	 *
	 * @private
	 * @param {Node} computeNode - The compute node.
	 * @return {boolean} Whether the compute pipeline for the given compute node requires an update or not.
	 */ _needsComputeUpdate(computeNode) {
        const data = this.get(computeNode);
        return data.pipeline === undefined || data.version !== computeNode.version;
    }
    /**
	 * Returns `true` if the render pipeline for the given render object requires an update.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render object for the given render object requires an update or not.
	 */ _needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        return data.pipeline === undefined || this.backend.needsRenderUpdate(renderObject);
    }
}
/**
 * This renderer module manages the bindings of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Bindings extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new bindings management component.
	 *
	 * @param {Backend} backend - The renderer's backend.
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 * @param {Textures} textures - Renderer component for managing textures.
	 * @param {Attributes} attributes - Renderer component for managing attributes.
	 * @param {Pipelines} pipelines - Renderer component for managing pipelines.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(backend, nodes, textures, attributes, pipelines, info){
        super();
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing textures.
		 *
		 * @type {Textures}
		 */ this.textures = textures;
        /**
		 * Renderer component for managing pipelines.
		 *
		 * @type {Pipelines}
		 */ this.pipelines = pipelines;
        /**
		 * Renderer component for managing attributes.
		 *
		 * @type {Attributes}
		 */ this.attributes = attributes;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 */ this.nodes = nodes;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        this.pipelines.bindings = this; // assign bindings to pipelines
    }
    /**
	 * Returns the bind groups for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Array<BindGroup>} The bind groups.
	 */ getForRender(renderObject) {
        const bindings = renderObject.getBindings();
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                // each object defines an array of bindings (ubos, textures, samplers etc.)
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings, 0);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    /**
	 * Returns the bind groups for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @return {Array<BindGroup>} The bind groups.
	 */ getForCompute(computeNode) {
        const bindings = this.nodes.getForCompute(computeNode).bindings;
        for (const bindGroup of bindings){
            const groupData = this.get(bindGroup);
            if (groupData.bindGroup === undefined) {
                this._init(bindGroup);
                this.backend.createBindings(bindGroup, bindings, 0);
                groupData.bindGroup = bindGroup;
            }
        }
        return bindings;
    }
    /**
	 * Updates the bindings for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ updateForCompute(computeNode) {
        this._updateBindings(this.getForCompute(computeNode));
    }
    /**
	 * Updates the bindings for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        this._updateBindings(this.getForRender(renderObject));
    }
    /**
	 * Deletes the bindings for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ deleteForCompute(computeNode) {
        const bindings = this.nodes.getForCompute(computeNode).bindings;
        for (const bindGroup of bindings){
            this.backend.deleteBindGroupData(bindGroup);
            this.delete(bindGroup);
        }
    }
    /**
	 * Deletes the bindings for the given renderObject node.
	 *
	 * @param {RenderObject} renderObject - The renderObject.
	 */ deleteForRender(renderObject) {
        const bindings = renderObject.getBindings();
        for (const bindGroup of bindings){
            this.backend.deleteBindGroupData(bindGroup);
            this.delete(bindGroup);
        }
    }
    /**
	 * Updates the given array of bindings.
	 *
	 * @param {Array<BindGroup>} bindings - The bind groups.
	 */ _updateBindings(bindings) {
        for (const bindGroup of bindings)this._update(bindGroup, bindings);
    }
    /**
	 * Initializes the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group to initialize.
	 */ _init(bindGroup) {
        for (const binding of bindGroup.bindings){
            if (binding.isSampledTexture) this.textures.updateTexture(binding.texture);
            else if (binding.isSampler) this.textures.updateSampler(binding.texture);
            else if (binding.isStorageBuffer) {
                const attribute = binding.attribute;
                const attributeType = attribute.isIndirectStorageBufferAttribute ? $03ccd63b0299d6a7$var$AttributeType.INDIRECT : $03ccd63b0299d6a7$var$AttributeType.STORAGE;
                this.attributes.update(attribute, attributeType);
            }
        }
    }
    /**
	 * Updates the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group to update.
	 * @param {Array<BindGroup>} bindings - The bind groups.
	 */ _update(bindGroup, bindings) {
        const { backend: backend } = this;
        let needsBindingsUpdate = false;
        let cacheBindings = true;
        let cacheIndex = 0;
        let version = 0;
        // iterate over all bindings and check if buffer updates or a new binding group is required
        for (const binding of bindGroup.bindings){
            const updatedGroup = this.nodes.updateGroup(binding);
            // every uniforms group is a uniform buffer. So if no update is required,
            // we move one with the next binding. Otherwise the next if block will update the group.
            if (updatedGroup === false) continue;
            //
            if (binding.isStorageBuffer) {
                const attribute = binding.attribute;
                const attributeType = attribute.isIndirectStorageBufferAttribute ? $03ccd63b0299d6a7$var$AttributeType.INDIRECT : $03ccd63b0299d6a7$var$AttributeType.STORAGE;
                const bindingData = backend.get(binding);
                this.attributes.update(attribute, attributeType);
                if (bindingData.attribute !== attribute) {
                    bindingData.attribute = attribute;
                    needsBindingsUpdate = true;
                }
            }
            if (binding.isUniformBuffer) {
                const updated = binding.update();
                if (updated) backend.updateBinding(binding);
            } else if (binding.isSampledTexture) {
                const updated = binding.update();
                // get the texture data after the update, to sync the texture reference from node
                const texture = binding.texture;
                const texturesTextureData = this.textures.get(texture);
                if (updated) {
                    // version: update the texture data or create a new one
                    this.textures.updateTexture(texture);
                    // generation: update the bindings if the binding refers to a different texture object
                    if (binding.generation !== texturesTextureData.generation) {
                        binding.generation = texturesTextureData.generation;
                        needsBindingsUpdate = true;
                    }
                    // keep track which bind groups refer to the current texture (this is needed for dispose)
                    texturesTextureData.bindGroups.add(bindGroup);
                }
                const textureData = backend.get(texture);
                if (textureData.externalTexture !== undefined || texturesTextureData.isDefaultTexture) cacheBindings = false;
                else {
                    cacheIndex = cacheIndex * 10 + texture.id;
                    version += texture.version;
                }
                if (texture.isStorageTexture === true && texture.mipmapsAutoUpdate === true) {
                    const textureData = this.get(texture);
                    if (binding.store === true) textureData.needsMipmap = true;
                    else if (this.textures.needsMipmaps(texture) && textureData.needsMipmap === true) {
                        this.backend.generateMipmaps(texture);
                        textureData.needsMipmap = false;
                    }
                }
            } else if (binding.isSampler) {
                const updated = binding.update();
                if (updated) {
                    const samplerKey = this.textures.updateSampler(binding.texture);
                    if (binding.samplerKey !== samplerKey) {
                        binding.samplerKey = samplerKey;
                        needsBindingsUpdate = true;
                    }
                }
            }
            if (binding.isBuffer && binding.updateRanges.length > 0) binding.clearUpdateRanges();
        }
        if (needsBindingsUpdate === true) this.backend.updateBindings(bindGroup, bindings, cacheBindings ? cacheIndex : 0, version);
    }
}
/**
 * Default sorting function for opaque render items.
 *
 * @private
 * @function
 * @param {Object} a - The first render item.
 * @param {Object} b - The second render item.
 * @return {number} A numeric value which defines the sort order.
 */ function $03ccd63b0299d6a7$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
/**
 * Default sorting function for transparent render items.
 *
 * @private
 * @function
 * @param {Object} a - The first render item.
 * @param {Object} b - The second render item.
 * @return {number} A numeric value which defines the sort order.
 */ function $03ccd63b0299d6a7$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
/**
 * Returns `true` if the given transparent material requires a double pass.
 *
 * @private
 * @function
 * @param {Material} material - The transparent material.
 * @return {boolean} Whether the given material requires a double pass or not.
 */ function $03ccd63b0299d6a7$var$needsDoublePass(material) {
    const hasTransmission = material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode;
    return hasTransmission && material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) && material.forceSinglePass === false;
}
/**
 * When the renderer analyzes the scene at the beginning of a render call,
 * it stores 3D object for further processing in render lists. Depending on the
 * properties of a 3D objects (like their transformation or material state), the
 * objects are maintained in ordered lists for the actual rendering.
 *
 * Render lists are unique per scene and camera combination.
 *
 * @private
 * @augments Pipeline
 */ class $03ccd63b0299d6a7$var$RenderList {
    /**
	 * Constructs a render list.
	 *
	 * @param {Lighting} lighting - The lighting management component.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ constructor(lighting, scene, camera){
        /**
		 * 3D objects are transformed into render items and stored in this array.
		 *
		 * @type {Array<Object>}
		 */ this.renderItems = [];
        /**
		 * The current render items index.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderItemsIndex = 0;
        /**
		 * A list with opaque render items.
		 *
		 * @type {Array<Object>}
		 */ this.opaque = [];
        /**
		 * A list with transparent render items which require
		 * double pass rendering (e.g. transmissive objects).
		 *
		 * @type {Array<Object>}
		 */ this.transparentDoublePass = [];
        /**
		 * A list with transparent render items.
		 *
		 * @type {Array<Object>}
		 */ this.transparent = [];
        /**
		 * A list with transparent render bundle data.
		 *
		 * @type {Array<Object>}
		 */ this.bundles = [];
        /**
		 * The render list's lights node. This node is later
		 * relevant for the actual analytical light nodes which
		 * compute the scene's lighting in the shader.
		 *
		 * @type {LightsNode}
		 */ this.lightsNode = lighting.getNode(scene, camera);
        /**
		 * The scene's lights stored in an array. This array
		 * is used to setup the lights node.
		 *
		 * @type {Array<Light>}
		 */ this.lightsArray = [];
        /**
		 * The scene.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera the scene is rendered with.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * How many objects perform occlusion query tests.
		 *
		 * @type {number}
		 * @default 0
		 */ this.occlusionQueryCount = 0;
    }
    /**
	 * This method is called right at the beginning of a render call
	 * before the scene is analyzed. It prepares the internal data
	 * structures for the upcoming render lists generation.
	 *
	 * @return {RenderList} A reference to this render list.
	 */ begin() {
        this.renderItemsIndex = 0;
        this.opaque.length = 0;
        this.transparentDoublePass.length = 0;
        this.transparent.length = 0;
        this.bundles.length = 0;
        this.lightsArray.length = 0;
        this.occlusionQueryCount = 0;
        return this;
    }
    /**
	 * Returns a render item for the giving render item state. The state is defined
	 * by a series of object-related parameters.
	 *
	 * The method avoids object creation by holding render items and reusing them in
	 * subsequent render calls (just with different property values).
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 * @return {Object} The render item.
	 */ getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext) {
        let renderItem = this.renderItems[this.renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group,
                clippingContext: clippingContext
            };
            this.renderItems[this.renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
            renderItem.clippingContext = clippingContext;
        }
        this.renderItemsIndex++;
        return renderItem;
    }
    /**
	 * Pushes the given object as a render item to the internal render lists.
	 * The selected lists depend on the object properties.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ push(object, geometry, material, groupOrder, z, group, clippingContext) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext);
        if (object.occlusionTest === true) this.occlusionQueryCount++;
        if (material.transparent === true || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode) {
            if ($03ccd63b0299d6a7$var$needsDoublePass(material)) this.transparentDoublePass.push(renderItem);
            this.transparent.push(renderItem);
        } else this.opaque.push(renderItem);
    }
    /**
	 * Inserts the given object as a render item at the start of the internal render lists.
	 * The selected lists depend on the object properties.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {number} groupOrder - The current group order.
	 * @param {number} z - Th 3D object's depth value (z value in clip space).
	 * @param {?number} group - {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ unshift(object, geometry, material, groupOrder, z, group, clippingContext) {
        const renderItem = this.getNextRenderItem(object, geometry, material, groupOrder, z, group, clippingContext);
        if (material.transparent === true || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode) {
            if ($03ccd63b0299d6a7$var$needsDoublePass(material)) this.transparentDoublePass.unshift(renderItem);
            this.transparent.unshift(renderItem);
        } else this.opaque.unshift(renderItem);
    }
    /**
	 * Pushes render bundle group data into the render list.
	 *
	 * @param {Object} group - Bundle group data.
	 */ pushBundle(group) {
        this.bundles.push(group);
    }
    /**
	 * Pushes a light into the render list.
	 *
	 * @param {Light} light - The light.
	 */ pushLight(light) {
        this.lightsArray.push(light);
    }
    /**
	 * Sorts the internal render lists.
	 *
	 * @param {?function(any, any): number} customOpaqueSort - A custom sort function for opaque objects.
	 * @param {?function(any, any): number} customTransparentSort -  A custom sort function for transparent objects.
	 */ sort(customOpaqueSort, customTransparentSort) {
        if (this.opaque.length > 1) this.opaque.sort(customOpaqueSort || $03ccd63b0299d6a7$var$painterSortStable);
        if (this.transparentDoublePass.length > 1) this.transparentDoublePass.sort(customTransparentSort || $03ccd63b0299d6a7$var$reversePainterSortStable);
        if (this.transparent.length > 1) this.transparent.sort(customTransparentSort || $03ccd63b0299d6a7$var$reversePainterSortStable);
    }
    /**
	 * This method performs finalizing tasks right after the render lists
	 * have been generated.
	 */ finish() {
        // update lights
        this.lightsNode.setLights(this.lightsArray);
        // Clear references from inactive renderItems in the list
        for(let i = this.renderItemsIndex, il = this.renderItems.length; i < il; i++){
            const renderItem = this.renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.groupOrder = null;
            renderItem.renderOrder = null;
            renderItem.z = null;
            renderItem.group = null;
            renderItem.clippingContext = null;
        }
    }
}
const $03ccd63b0299d6a7$var$_chainKeys$2 = [];
/**
 * This renderer module manages the render lists which are unique
 * per scene and camera combination.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderLists {
    /**
	 * Constructs a render lists management component.
	 *
	 * @param {Lighting} lighting - The lighting management component.
	 */ constructor(lighting){
        /**
		 * The lighting management component.
		 *
		 * @type {Lighting}
		 */ this.lighting = lighting;
        /**
		 * The internal chain map which holds the render lists.
		 *
		 * @type {ChainMap}
		 */ this.lists = new $03ccd63b0299d6a7$var$ChainMap();
    }
    /**
	 * Returns a render list for the given scene and camera.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera.
	 * @return {RenderList} The render list.
	 */ get(scene, camera) {
        const lists = this.lists;
        $03ccd63b0299d6a7$var$_chainKeys$2[0] = scene;
        $03ccd63b0299d6a7$var$_chainKeys$2[1] = camera;
        let list = lists.get($03ccd63b0299d6a7$var$_chainKeys$2);
        if (list === undefined) {
            list = new $03ccd63b0299d6a7$var$RenderList(this.lighting, scene, camera);
            lists.set($03ccd63b0299d6a7$var$_chainKeys$2, list);
        }
        $03ccd63b0299d6a7$var$_chainKeys$2[0] = null;
        $03ccd63b0299d6a7$var$_chainKeys$2[1] = null;
        return list;
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this.lists = new $03ccd63b0299d6a7$var$ChainMap();
    }
}
let $03ccd63b0299d6a7$var$_id$8 = 0;
/**
 * Any render or compute command is executed in a specific context that defines
 * the state of the renderer and its backend. Typical examples for such context
 * data are the current clear values or data from the active framebuffer. This
 * module is used to represent these contexts as objects.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderContext {
    /**
	 * Constructs a new render context.
	 */ constructor(){
        /**
		 * The context's ID.
		 *
		 * @type {number}
		 */ this.id = $03ccd63b0299d6a7$var$_id$8++;
        /**
		 * The MRT configuration.
		 *
		 * @type {?MRTNode}
		 * @default null
		 */ this.mrt = null;
        /**
		 * Whether the current active framebuffer has a color attachment.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.color = true;
        /**
		 * Whether the color attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearColor = true;
        /**
		 * The clear color value.
		 *
		 * @type {Object}
		 * @default true
		 */ this.clearColorValue = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        /**
		 * Whether the current active framebuffer has a depth attachment.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depth = true;
        /**
		 * Whether the depth attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearDepth = true;
        /**
		 * The clear depth value.
		 *
		 * @type {number}
		 * @default 1
		 */ this.clearDepthValue = 1;
        /**
		 * Whether the current active framebuffer has a stencil attachment.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencil = false;
        /**
		 * Whether the stencil attachment should be cleared or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clearStencil = true;
        /**
		 * The clear stencil value.
		 *
		 * @type {number}
		 * @default 1
		 */ this.clearStencilValue = 1;
        /**
		 * By default the viewport encloses the entire framebuffer If a smaller
		 * viewport is manually defined, this property is to `true` by the renderer.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.viewport = false;
        /**
		 * The viewport value. This value is in physical pixels meaning it incorporates
		 * the renderer's pixel ratio. The viewport property of render targets or
		 * the renderer is in logical pixels.
		 *
		 * @type {Vector4}
		 */ this.viewportValue = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        /**
		 * When the scissor test is active and scissor rectangle smaller than the
		 * framebuffers dimensions, this property is to `true` by the renderer.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissor = false;
        /**
		 * The scissor rectangle.
		 *
		 * @type {Vector4}
		 */ this.scissorValue = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        /**
		 * The active render target.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * The textures of the active render target.
		 * `null` when no render target is set.
		 *
		 * @type {?Array<Texture>}
		 * @default null
		 */ this.textures = null;
        /**
		 * The depth texture of the active render target.
		 * `null` when no render target is set.
		 *
		 * @type {?DepthTexture}
		 * @default null
		 */ this.depthTexture = null;
        /**
		 * The active cube face.
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeCubeFace = 0;
        /**
		 * The active mipmap level.
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        /**
		 * The number of MSAA samples. This value is always `1` when
		 * MSAA isn't used.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sampleCount = 1;
        /**
		 * The active render target's width in physical pixels.
		 *
		 * @type {number}
		 * @default 0
		 */ this.width = 0;
        /**
		 * The active render target's height in physical pixels.
		 *
		 * @type {number}
		 * @default 0
		 */ this.height = 0;
        /**
		 * The occlusion query count.
		 *
		 * @type {number}
		 * @default 0
		 */ this.occlusionQueryCount = 0;
        /**
		 * The current clipping context.
		 *
		 * @type {?ClippingContext}
		 * @default null
		 */ this.clippingContext = null;
        /**
		 * The current camera.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderContext = true;
    }
    /**
	 * Returns the cache key of this render context.
	 *
	 * @return {number} The cache key.
	 */ getCacheKey() {
        return $03ccd63b0299d6a7$var$getCacheKey(this);
    }
}
/**
 * Computes a cache key for the given render context. This key
 * should identify the render target state so it is possible to
 * configure the correct attachments in the respective backend.
 *
 * @param {RenderContext} renderContext - The render context.
 * @return {number} The cache key.
 */ function $03ccd63b0299d6a7$var$getCacheKey(renderContext) {
    const { textures: textures, activeCubeFace: activeCubeFace, activeMipmapLevel: activeMipmapLevel } = renderContext;
    const values = [
        activeCubeFace,
        activeMipmapLevel
    ];
    for (const texture of textures)values.push(texture.id);
    return $03ccd63b0299d6a7$var$hashArray(values);
}
/**
 * This module manages the render contexts of the renderer.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderContexts {
    /**
	 * Constructs a new render context management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(renderer){
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * A dictionary that manages render contexts.
		 *
		 * @type {Object<string,RenderContext>}
		 */ this._renderContexts = {};
    }
    /**
	 * Returns a render context for the given scene, camera and render target.
	 *
	 * @param {?RenderTarget} [renderTarget=null] - The active render target.
	 * @param {?MRTNode} [mrt=null] - The MRT configuration
	 * @param {?number} [callDepth=0] - The call depth of the renderer.
	 * @return {RenderContext} The render context.
	 */ get(renderTarget = null, mrt = null, callDepth = 0) {
        //
        let attachmentState;
        if (renderTarget === null) attachmentState = 'default';
        else {
            const format = renderTarget.texture.format;
            const type = renderTarget.texture.type;
            const count = renderTarget.textures.length;
            attachmentState = `${count}:${format}:${type}:${renderTarget.samples}:${renderTarget.depthBuffer}:${renderTarget.stencilBuffer}`;
        }
        //
        const mrtState = mrt !== null ? mrt.id : 'default';
        //
        const renderStateKey = attachmentState + '-' + mrtState + '-' + callDepth;
        let renderState = this._renderContexts[renderStateKey];
        if (renderState === undefined) {
            renderState = new $03ccd63b0299d6a7$var$RenderContext();
            renderState.mrt = mrt;
            this._renderContexts[renderStateKey] = renderState;
        }
        if (renderTarget !== null) renderState.sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        renderState.clearDepthValue = this.renderer.getClearDepth();
        renderState.clearStencilValue = this.renderer.getClearStencil();
        return renderState;
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this._renderContexts = {};
    }
}
const $03ccd63b0299d6a7$var$_size$3 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
/**
 * This module manages the textures of the renderer.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Textures extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new texture management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Backend} backend - The renderer's backend.
	 * @param {Info} info - Renderer component for managing metrics and monitoring data.
	 */ constructor(renderer, backend, info){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Renderer component for managing metrics and monitoring data.
		 *
		 * @type {Info}
		 */ this.info = info;
        /**
		 * A set of HTMLTextures that need paint updates.
		 *
		 * @type {Set<HTMLTexture>}
		 */ this._htmlTextures = new Set();
    }
    /**
	 * Updates the given render target. Based on the given render target configuration,
	 * it updates the texture states representing the attachments of the framebuffer.
	 *
	 * @param {RenderTarget} renderTarget - The render target to update.
	 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
	 */ updateRenderTarget(renderTarget, activeMipmapLevel = 0) {
        const renderTargetData = this.get(renderTarget);
        const sampleCount = renderTarget.samples === 0 ? 1 : renderTarget.samples;
        const depthTextureMips = renderTargetData.depthTextureMips || (renderTargetData.depthTextureMips = {});
        const textures = renderTarget.textures;
        const size = this.getSize(textures[0]);
        const mipWidth = size.width >> activeMipmapLevel;
        const mipHeight = size.height >> activeMipmapLevel;
        let depthTexture = renderTarget.depthTexture || depthTextureMips[activeMipmapLevel];
        const useDepthTexture = renderTarget.depthBuffer === true || renderTarget.stencilBuffer === true;
        let textureNeedsUpdate = false;
        if (depthTexture === undefined && useDepthTexture) {
            depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)();
            depthTexture.format = renderTarget.stencilBuffer ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
            depthTexture.type = renderTarget.stencilBuffer ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96); // FloatType
            depthTexture.image.width = mipWidth;
            depthTexture.image.height = mipHeight;
            depthTexture.image.depth = size.depth;
            depthTexture.renderTarget = renderTarget;
            depthTexture.isArrayTexture = renderTarget.multiview === true && size.depth > 1;
            depthTextureMips[activeMipmapLevel] = depthTexture;
        }
        if (renderTargetData.width !== size.width || size.height !== renderTargetData.height) {
            textureNeedsUpdate = true;
            if (depthTexture) {
                depthTexture.needsUpdate = true;
                depthTexture.image.width = mipWidth;
                depthTexture.image.height = mipHeight;
                depthTexture.image.depth = depthTexture.isArrayTexture ? depthTexture.image.depth : 1;
            }
        }
        renderTargetData.width = size.width;
        renderTargetData.height = size.height;
        renderTargetData.textures = textures;
        renderTargetData.depthTexture = depthTexture || null;
        renderTargetData.depth = renderTarget.depthBuffer;
        renderTargetData.stencil = renderTarget.stencilBuffer;
        renderTargetData.renderTarget = renderTarget;
        if (renderTargetData.sampleCount !== sampleCount) {
            textureNeedsUpdate = true;
            if (depthTexture) depthTexture.needsUpdate = true;
            renderTargetData.sampleCount = sampleCount;
        }
        //
        const options = {
            sampleCount: sampleCount
        };
        // XR render targets require no texture updates
        if (renderTarget.isXRRenderTarget !== true) {
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                if (textureNeedsUpdate) texture.needsUpdate = true;
                this.updateTexture(texture, options);
            }
            if (depthTexture) this.updateTexture(depthTexture, options);
        }
        // dispose handler
        if (renderTargetData.initialized !== true) {
            renderTargetData.initialized = true;
            this.info.memory.renderTargets++;
            // dispose
            renderTargetData.onDispose = ()=>{
                this._destroyRenderTarget(renderTarget);
            };
            renderTarget.addEventListener('dispose', renderTargetData.onDispose);
        }
    }
    /**
	 * Updates the given texture. Depending on the texture state, this method
	 * triggers the upload of texture data to the GPU memory. If the texture data are
	 * not yet ready for the upload, it uses default texture data for as a placeholder.
	 *
	 * @param {Texture} texture - The texture to update.
	 * @param {Object} [options={}] - The options.
	 */ updateTexture(texture, options = {}) {
        const textureData = this.get(texture);
        if (textureData.initialized === true && textureData.version === texture.version) return;
        const isRenderTarget = texture.isRenderTargetTexture || texture.isDepthTexture || texture.isFramebufferTexture;
        const backend = this.backend;
        if (isRenderTarget && textureData.initialized === true) // it's an update
        backend.destroyTexture(texture);
        //
        if (texture.isFramebufferTexture) {
            const renderTarget = this.renderer.getRenderTarget();
            if (renderTarget) texture.type = renderTarget.texture.type;
            else texture.type = (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10);
        }
        // Ensure HTMLTexture elements are in the canvas before measuring size.
        if (texture.isHTMLTexture && texture.image) {
            const canvas = this.renderer.domElement;
            if ('requestPaint' in canvas) {
                if (!canvas.hasAttribute('layoutsubtree')) canvas.setAttribute('layoutsubtree', 'true');
                if (texture.image.parentNode !== canvas) canvas.appendChild(texture.image);
                // Set up shared paint callback for all HTMLTextures.
                if (this._htmlTextures.size === 0) {
                    const htmlTextures = this._htmlTextures;
                    canvas.onpaint = (event)=>{
                        const changed = event && event.changedElements;
                        for (const t of htmlTextures)if (!changed || changed.includes(t.image)) t.needsUpdate = true;
                    };
                }
                this._htmlTextures.add(texture);
            }
        }
        //
        const { width: width, height: height, depth: depth } = this.getSize(texture);
        options.width = width;
        options.height = height;
        options.depth = depth;
        options.needsMipmaps = this.needsMipmaps(texture);
        options.levels = options.needsMipmaps ? this.getMipLevels(texture, width, height) : 1;
        // TODO: Uniformly handle mipmap definitions
        // Normal textures and compressed cube textures define base level + mips with their mipmap array
        // Uncompressed cube textures use their mipmap array only for mips (no base level)
        if (texture.isCubeTexture && texture.mipmaps.length > 0) options.levels++;
        //
        if (isRenderTarget || texture.isStorageTexture === true || texture.isExternalTexture === true) {
            backend.createTexture(texture, options);
            textureData.generation = texture.version;
        } else if (texture.version > 0) {
            const image = texture.image;
            if (image === undefined) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Renderer: Texture marked for update but image is undefined.');
            else if (image.complete === false) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Renderer: Texture marked for update but image is incomplete.');
            else {
                if (texture.images) {
                    const images = [];
                    for (const image of texture.images)images.push(image);
                    options.images = images;
                } else options.image = image;
                if (textureData.isDefaultTexture === undefined || textureData.isDefaultTexture === true) {
                    backend.createTexture(texture, options);
                    textureData.isDefaultTexture = false;
                    textureData.generation = texture.version;
                }
                if (texture.source.dataReady === true) backend.updateTexture(texture, options);
                const skipAutoGeneration = texture.isStorageTexture === true && texture.mipmapsAutoUpdate === false;
                if (options.needsMipmaps && texture.mipmaps.length === 0 && !skipAutoGeneration) backend.generateMipmaps(texture);
                if (texture.onUpdate) texture.onUpdate(texture);
            }
        } else {
            // async update
            backend.createDefaultTexture(texture);
            textureData.isDefaultTexture = true;
            textureData.generation = texture.version;
        }
        // dispose handler
        if (textureData.initialized !== true) {
            textureData.initialized = true;
            textureData.generation = texture.version;
            textureData.bindGroups = new Set();
            //
            this.info.createTexture(texture);
            //
            if (texture.isVideoTexture && (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).enabled === true && (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(texture.colorSpace) !== (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Video textures must use a color space with a sRGB transfer function, e.g. SRGBColorSpace.');
            // dispose
            textureData.onDispose = ()=>{
                this._destroyTexture(texture);
            };
            texture.addEventListener('dispose', textureData.onDispose);
        }
        //
        textureData.version = texture.version;
    }
    /**
	 * Updates the sampler for the given texture. This method has no effect
	 * for the WebGL backend since it has no concept of samplers. Texture
	 * parameters are configured with the `texParameter()` command for each
	 * texture.
	 *
	 * In WebGPU, samplers are objects like textures and it's possible to share
	 * them when the texture parameters match.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        return this.backend.updateSampler(texture);
    }
    /**
	 * Computes the size of the given texture and writes the result
	 * into the target vector. This vector is also returned by the
	 * method.
	 *
	 * If no texture data are available for the compute yet, the method
	 * returns default size values.
	 *
	 * @param {Texture} texture - The texture to compute the size for.
	 * @param {Vector3} target - The target vector.
	 * @return {Vector3} The target vector.
	 */ getSize(texture, target = $03ccd63b0299d6a7$var$_size$3) {
        let image = texture.images ? texture.images[0] : texture.image;
        if (image) {
            if (image.image !== undefined) image = image.image;
            if (texture.isHTMLTexture) {
                target.width = image.offsetWidth || 1;
                target.height = image.offsetHeight || 1;
                target.depth = 1;
            } else if (typeof HTMLVideoElement !== 'undefined' && image instanceof HTMLVideoElement) {
                target.width = image.videoWidth || 1;
                target.height = image.videoHeight || 1;
                target.depth = 1;
            } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                target.width = image.displayWidth || 1;
                target.height = image.displayHeight || 1;
                target.depth = 1;
            } else {
                target.width = image.width || 1;
                target.height = image.height || 1;
                target.depth = texture.isCubeTexture ? 6 : image.depth || 1;
            }
        } else target.width = target.height = target.depth = 1;
        return target;
    }
    /**
	 * Computes the number of mipmap levels for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} width - The texture's width.
	 * @param {number} height - The texture's height.
	 * @return {number} The number of mipmap levels.
	 */ getMipLevels(texture, width, height) {
        let mipLevelCount;
        if (texture.mipmaps.length > 0) mipLevelCount = texture.mipmaps.length;
        else if (texture.isCompressedTexture === true) // it is not possible to compute mipmaps for compressed textures. So
        // when no mipmaps are defined in "texture.mipmaps", force a texture
        // level of 1
        mipLevelCount = 1;
        else mipLevelCount = Math.floor(Math.log2(Math.max(width, height))) + 1;
        return mipLevelCount;
    }
    /**
	 * Returns `true` if the given texture makes use of mipmapping.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether mipmaps are required or not.
	 */ needsMipmaps(texture) {
        return texture.generateMipmaps === true || texture.mipmaps.length > 0;
    }
    /**
	 * Frees internal resources when the given render target isn't
	 * required anymore.
	 *
	 * @param {RenderTarget} renderTarget - The render target to destroy.
	 */ _destroyRenderTarget(renderTarget) {
        if (this.has(renderTarget) === true) {
            const renderTargetData = this.get(renderTarget);
            const textures = renderTargetData.textures;
            const depthTexture = renderTargetData.depthTexture;
            //
            renderTarget.removeEventListener('dispose', renderTargetData.onDispose);
            //
            for(let i = 0; i < textures.length; i++)this._destroyTexture(textures[i]);
            if (depthTexture) this._destroyTexture(depthTexture);
            this.delete(renderTarget);
            this.backend.delete(renderTarget);
            this.info.memory.renderTargets--;
        }
    }
    /**
	 * Frees internal resource when the given texture isn't
	 * required anymore.
	 *
	 * @param {Texture} texture - The texture to destroy.
	 */ _destroyTexture(texture) {
        if (this.has(texture) === true) {
            const textureData = this.get(texture);
            //
            texture.removeEventListener('dispose', textureData.onDispose);
            // if a texture is not ready for use, it falls back to a default texture so it's possible
            // to use it for rendering. If a texture in this state is disposed, it's important to
            // not destroy/delete the underlying GPU texture object since it is cached and shared with
            // other textures.
            const isDefaultTexture = textureData.isDefaultTexture;
            this.backend.destroyTexture(texture, isDefaultTexture);
            // delete cached bind groups so they don't point to destroyed textures
            if (textureData.bindGroups) for (const bindGroup of textureData.bindGroups){
                const bindingsData = this.backend.get(bindGroup);
                bindingsData.groups = undefined;
                bindingsData.versions = undefined;
            }
            this._htmlTextures.delete(texture);
            this.delete(texture);
            this.info.destroyTexture(texture);
        }
    }
}
/**
 * A four-component version of {@link Color} which is internally
 * used by the renderer to represents clear color with alpha as
 * one object.
 *
 * @private
 * @augments Color
 */ class $03ccd63b0299d6a7$var$Color4 extends (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e) {
    /**
	 * Constructs a new four-component color.
	 * You can also pass a single THREE.Color, hex or
	 * string argument to this constructor.
	 *
	 * @param {number|string} [r=1] - The red value.
	 * @param {number} [g=1] - The green value.
	 * @param {number} [b=1] - The blue value.
	 * @param {number} [a=1] - The alpha value.
	 */ constructor(r, g, b, a = 1){
        super(r, g, b);
        this.a = a;
    }
    /**
	 * Overwrites the default to honor alpha.
	 * You can also pass a single THREE.Color, hex or
	 * string argument to this method.
	 *
	 * @param {number|string|Color} r - The red value.
	 * @param {number} [g] - The green value.
	 * @param {number} [b] - The blue value.
	 * @param {number} [a=1] - The alpha value.
	 * @return {Color4} A reference to this object.
	 */ set(r, g, b, a = 1) {
        this.a = a;
        return super.set(r, g, b);
    }
    /**
	 * Overwrites the default to honor alpha.
	 *
	 * @param {Color4} color - The color to copy.
	 * @return {Color4} A reference to this object.
	 */ copy(color) {
        if (color.a !== undefined) this.a = color.a;
        return super.copy(color);
    }
    /**
	 * Overwrites the default to honor alpha.
	 *
	 * @return {Color4} The cloned color.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
}
/**
 * Special version of {@link PropertyNode} which is used for parameters.
 *
 * @augments PropertyNode
 */ class $03ccd63b0299d6a7$export$4b5f01ba1aca62ad extends $03ccd63b0299d6a7$export$c87c56924d182f24 {
    static get type() {
        return 'ParameterNode';
    }
    /**
	 * Constructs a new parameter node.
	 *
	 * @param {string} nodeType - The type of the node.
	 * @param {?string} [name=null] - The name of the parameter in the shader.
	 */ constructor(nodeType, name = null){
        super(nodeType, name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isParameterNode = true;
    }
    /**
	 * Gets the type of a member variable in the parameter node.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {string} name - The name of the member variable.
	 * @returns {string}
	 */ getMemberType(builder, name) {
        const type = this.getNodeType(builder);
        const struct = builder.getStructTypeNode(type);
        let memberType;
        if (struct !== null) memberType = struct.getMemberType(builder, name);
        else {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`TSL: Member "${name}" not found in struct "${type}".`, new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
            memberType = 'float';
        }
        return memberType;
    }
    getHash() {
        return String(this.id);
    }
    generate() {
        return this.name;
    }
}
/**
 * TSL function for creating a parameter node.
 *
 * @tsl
 * @function
 * @param {string} type - The type of the node.
 * @param {?string} name - The name of the parameter in the shader.
 * @returns {ParameterNode}
 */ const $03ccd63b0299d6a7$var$parameter = (type, name)=>new $03ccd63b0299d6a7$export$4b5f01ba1aca62ad(type, name);
/**
 * Stack is a helper for Nodes that need to produce stack-based code instead of continuous flow.
 * They are usually needed in cases like `If`, `Else`.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$6e11d1e78715185c extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'StackNode';
    }
    /**
	 * Constructs a new stack node.
	 *
	 * @param {?StackNode} [parent=null] - The parent stack node.
	 */ constructor(parent = null){
        super();
        /**
		 * List of nodes.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = [];
        /**
		 * The output node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.outputNode = null;
        /**
		 * The parent stack node.
		 *
		 * @type {?StackNode}
		 * @default null
		 */ this.parent = parent;
        /**
		 * The current conditional node.
		 *
		 * @private
		 * @type {ConditionalNode}
		 * @default null
		 */ this._currentCond = null;
        /**
		 * The expression node. Only
		 * relevant for Switch/Case.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._expressionNode = null;
        /**
		 * The current node being processed.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._currentNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStackNode = true;
    }
    getElementType(builder) {
        return this.hasOutput(builder) ? this.outputNode.getElementType(builder) : 'void';
    }
    generateNodeType(builder) {
        return this.hasOutput(builder) ? this.outputNode.getNodeType(builder) : 'void';
    }
    getMemberType(builder, name) {
        return this.hasOutput(builder) ? this.outputNode.getMemberType(builder, name) : 'void';
    }
    /**
	 * Adds a node to this stack.
	 *
	 * @param {Node} node - The node to add.
	 * @param {number} [index=this.nodes.length] - The index where the node should be added.
	 * @return {StackNode} A reference to this stack node.
	 */ addToStack(node, index = this.nodes.length) {
        if (node.isNode !== true) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: Invalid node added to stack.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
            return this;
        }
        this.nodes.splice(index, 0, node);
        return this;
    }
    /**
	 * Adds a node to the stack before the current node.
	 *
	 * @param {Node} node - The node to add.
	 * @return {StackNode} A reference to this stack node.
	 */ addToStackBefore(node) {
        const index = this._currentNode ? this.nodes.indexOf(this._currentNode) : 0;
        return this.addToStack(node, index);
    }
    /**
	 * Represent an `if` statement in TSL.
	 *
	 * @param {Node} boolNode - Represents the condition.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ If(boolNode, method) {
        const methodNode = new $03ccd63b0299d6a7$var$ShaderNode(method);
        this._currentCond = $03ccd63b0299d6a7$var$select(boolNode, methodNode);
        return this.addToStack(this._currentCond);
    }
    /**
	 * Represent an `elseif` statement in TSL.
	 *
	 * @param {Node} boolNode - Represents the condition.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ ElseIf(boolNode, method) {
        const methodNode = new $03ccd63b0299d6a7$var$ShaderNode(method);
        const ifNode = $03ccd63b0299d6a7$var$select(boolNode, methodNode);
        this._currentCond.elseNode = ifNode;
        this._currentCond = ifNode;
        return this;
    }
    /**
	 * Represent an `else` statement in TSL.
	 *
	 * @param {Function} method - TSL code which is executed in the `else` case.
	 * @return {StackNode} A reference to this stack node.
	 */ Else(method) {
        this._currentCond.elseNode = new $03ccd63b0299d6a7$var$ShaderNode(method);
        return this;
    }
    /**
	 * Represents a `switch` statement in TSL.
	 *
	 * @param {any} expression - Represents the expression.
	 * @param {Function} method - TSL code which is executed if the condition evaluates to `true`.
	 * @return {StackNode} A reference to this stack node.
	 */ Switch(expression) {
        this._expressionNode = $03ccd63b0299d6a7$var$nodeObject(expression);
        return this;
    }
    /**
	 * Represents a `case` statement in TSL. The TSL version accepts an arbitrary numbers of values.
	 * The last parameter must be the callback method that should be executed in the `true` case.
	 *
	 * @param {...any} params - The values of the `Case()` statement as well as the callback method.
	 * @return {StackNode} A reference to this stack node.
	 */ Case(...params) {
        const caseNodes = [];
        // extract case nodes from the parameter list
        if (params.length >= 2) for(let i = 0; i < params.length - 1; i++)caseNodes.push(this._expressionNode.equal($03ccd63b0299d6a7$var$nodeObject(params[i])));
        else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: Invalid parameter length. Case() requires at least two parameters.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c());
        // extract method
        const method = params[params.length - 1];
        const methodNode = new $03ccd63b0299d6a7$var$ShaderNode(method);
        // chain multiple cases when using Case( 1, 2, 3, () => {} )
        let caseNode = caseNodes[0];
        for(let i = 1; i < caseNodes.length; i++)caseNode = caseNode.or(caseNodes[i]);
        // build condition
        const condNode = $03ccd63b0299d6a7$var$select(caseNode, methodNode);
        if (this._currentCond === null) {
            this._currentCond = condNode;
            return this.addToStack(this._currentCond);
        } else {
            this._currentCond.elseNode = condNode;
            this._currentCond = condNode;
            return this;
        }
    }
    /**
	 * Represents the default code block of a Switch/Case statement.
	 *
	 * @param {Function} method - TSL code which is executed in the `else` case.
	 * @return {StackNode} A reference to this stack node.
	 */ Default(method) {
        this.Else(method);
        return this;
    }
    setup(builder) {
        const nodeProperties = builder.getNodeProperties(this);
        let index = 0;
        for (const childNode of this.getChildren()){
            if (childNode.isVarNode && childNode.isIntent(builder)) {
                if (childNode.isAssign(builder) !== true) continue;
            }
            nodeProperties['node' + index++] = childNode;
        }
        // return a outputNode if exists or null
        return nodeProperties.outputNode || null;
    }
    hasOutput(builder) {
        return this.outputNode && this.outputNode.isNode && this.outputNode.getNodeType(builder) !== 'void';
    }
    build(builder, ...params) {
        const previousStack = $03ccd63b0299d6a7$var$getCurrentStack();
        const buildStage = builder.buildStage;
        $03ccd63b0299d6a7$var$setCurrentStack(this);
        builder.setActiveStack(this);
        //
        const buildNode = (node)=>{
            this._currentNode = node;
            if (node.isVarNode && node.isIntent(builder)) {
                if (node.isAssign(builder) !== true) return;
            }
            if (buildStage === 'setup') node.build(builder);
            else if (buildStage === 'analyze') node.build(builder, this);
            else if (buildStage === 'generate') {
                const stages = builder.getDataFromNode(node, 'any').stages;
                const parents = stages && stages[builder.shaderStage];
                if (node.isVarNode && parents && parents.length === 1 && parents[0] && parents[0].isStackNode) return; // skip var nodes that are only used in .toVarying()
                node.build(builder, 'void');
            }
        };
        //
        const nodes = [
            ...this.nodes
        ];
        for (const node of nodes)buildNode(node);
        this._currentNode = null;
        const newNodes = this.nodes.filter((node)=>nodes.indexOf(node) === -1);
        for (const node of newNodes)buildNode(node);
        //
        let result;
        if (this.hasOutput(builder)) result = this.outputNode.build(builder, ...params);
        else result = super.build(builder, ...params);
        $03ccd63b0299d6a7$var$setCurrentStack(previousStack);
        builder.removeActiveStack(this);
        return result;
    }
}
/**
 * TSL function for creating a stack node.
 *
 * @tsl
 * @function
 * @param {?StackNode} [parent=null] - The parent stack node.
 * @returns {StackNode}
 */ const $03ccd63b0299d6a7$var$stack = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$6e11d1e78715185c).setParameterLength(0, 1);
/**
 * Generates a layout for struct members.
 * This function takes an object representing struct members and returns an array of member layouts.
 * Each member layout includes the member's name, type, and whether it is atomic.
 *
 * @param {Object.<string, string|Object>} members - An object where keys are member names and values are either types (as strings) or objects with type and atomic properties.
 * @returns {Array.<{name: string, type: string, atomic: boolean}>} An array of member layouts.
 */ function $03ccd63b0299d6a7$var$getMembersLayout(members) {
    return Object.entries(members).map(([name, value])=>{
        if (typeof value === 'string') return {
            name: name,
            type: value,
            atomic: false
        };
        return {
            name: name,
            type: value.type,
            atomic: value.atomic || false
        };
    });
}
/**
 * Represents a struct type node in the node-based system.
 * This class is used to define and manage the layout and types of struct members.
 * It extends the base Node class and provides methods to get the length of the struct,
 * retrieve member types, and generate the struct type for a builder.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$fe9ea5c95793e50f extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'StructTypeNode';
    }
    /**
	 * Creates an instance of StructTypeNode.
	 *
	 * @param {Object} membersLayout - The layout of the members for the struct.
	 * @param {?string} [name=null] - The optional name of the struct.
	 */ constructor(membersLayout, name = null){
        super('struct');
        /**
		 * The layout of the members for the struct
		 *
		 * @type {Array.<{name: string, type: string, atomic: boolean}>}
		 */ this.membersLayout = $03ccd63b0299d6a7$var$getMembersLayout(membersLayout);
        /**
		 * The name of the struct.
		 *
		 * @type {?string}
		 * @default null
		 */ this.name = name;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStructLayoutNode = true;
    }
    /**
	 * Returns the length of the struct.
	 * The length is calculated by summing the lengths of the struct's members.
	 *
	 * @returns {number} The length of the struct.
	 */ getLength() {
        const BYTES_PER_ELEMENT = Float32Array.BYTES_PER_ELEMENT;
        let maxAlignment = 1; // maximum alignment value in this struct
        let offset = 0; // global buffer offset in 4 byte elements
        for (const member of this.membersLayout){
            const type = member.type;
            const itemSize = $03ccd63b0299d6a7$var$getMemoryLengthFromType(type);
            const alignment = $03ccd63b0299d6a7$var$getAlignmentFromType(type) / BYTES_PER_ELEMENT;
            maxAlignment = Math.max(maxAlignment, alignment);
            const chunkOffset = offset % maxAlignment; // offset in the current chunk of maxAlignment elements
            const overhang = chunkOffset % alignment; // distance from the last aligned offset
            if (overhang !== 0) offset += alignment - overhang; // move to next aligned offset
            offset += itemSize;
        }
        return Math.ceil(offset / maxAlignment) * maxAlignment; // ensure length is a multiple of maxAlignment
    }
    getMemberType(builder, name) {
        const member = this.membersLayout.find((m)=>m.name === name);
        return member ? member.type : 'void';
    }
    generateNodeType(builder) {
        const structType = builder.getStructTypeFromNode(this, this.membersLayout, this.name);
        return structType.name;
    }
    setup(builder) {
        builder.getStructTypeFromNode(this, this.membersLayout, this.name);
        builder.addInclude(this);
    }
    generate(builder) {
        return this.getNodeType(builder);
    }
}
/**
 * StructNode allows to create custom structures with multiple members.
 * This can also be used to define structures in attribute and uniform data.
 *
 * ```js
 * // Define a custom struct
 * const BoundingBox = struct( { min: 'vec3', max: 'vec3' } );
 *
 * // Create a new instance of the struct
 * const bb = BoundingBox( vec3( 0 ), vec3( 1 ) ); // style 1
 * const bb = BoundingBox( { min: vec3( 0 ), max: vec3( 1 ) } ); // style 2
 *
 * // Access the struct members
 * const min = bb.get( 'min' );
 *
 * // Assign a new value to a member
 * min.assign( vec3() );
 * ```
 * @augments Node
 */ class $03ccd63b0299d6a7$export$e016575bf0061e5e extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'StructNode';
    }
    constructor(structTypeNode, values){
        super('vec3');
        this.structTypeNode = structTypeNode;
        this.values = values;
        this.isStructNode = true;
    }
    generateNodeType(builder) {
        return this.structTypeNode.getNodeType(builder);
    }
    getMemberType(builder, name) {
        return this.structTypeNode.getMemberType(builder, name);
    }
    _getChildren() {
        // Ensure struct type is the last child for correct code generation order
        const children = super._getChildren();
        const structTypeProperty = children.find((child)=>child.childNode === this.structTypeNode);
        children.splice(children.indexOf(structTypeProperty), 1);
        children.push(structTypeProperty);
        return children;
    }
    generate(builder) {
        const nodeVar = builder.getVarFromNode(this);
        const structType = nodeVar.type;
        const propertyName = builder.getPropertyName(nodeVar);
        builder.addLineFlowCode(`${propertyName} = ${builder.generateStruct(structType, this.structTypeNode.membersLayout, this.values)}`, this);
        return nodeVar.name;
    }
}
/**
 * TSL function for creating a struct node.
 *
 * @tsl
 * @function
 * @param {Object} membersLayout - The layout of the struct members.
 * @param {?string} [name=null] - The name of the struct.
 * @returns {Function} The struct function.
 */ const $03ccd63b0299d6a7$var$struct = (membersLayout, name = null)=>{
    const structLayout = new $03ccd63b0299d6a7$export$fe9ea5c95793e50f(membersLayout, name);
    const struct = (...params)=>{
        let values = null;
        if (params.length > 0) {
            if (params[0].isNode) {
                values = {};
                const names = Object.keys(membersLayout);
                for(let i = 0; i < params.length; i++)values[names[i]] = params[i];
            } else values = params[0];
        }
        return new $03ccd63b0299d6a7$export$e016575bf0061e5e(structLayout, values);
    };
    struct.layout = structLayout;
    struct.isStruct = true;
    return struct;
};
/**
 * This node can be used to define multiple outputs in a shader programs.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$ae7787fb8a88b867 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'OutputStructNode';
    }
    /**
	 * Constructs a new output struct node. The constructor can be invoked with an
	 * arbitrary number of nodes representing the members.
	 *
	 * @param {...Node} members - A parameter list of nodes.
	 */ constructor(...members){
        super();
        /**
		 * An array of nodes which defines the output.
		 *
		 * @type {Array<Node>}
		 */ this.members = members;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOutputStructNode = true;
    }
    generateNodeType() {
        return 'OutputType';
    }
    generate(builder) {
        const nodeData = builder.getDataFromNode(this);
        if (nodeData.membersLayout === undefined) {
            const members = this.members;
            const membersLayout = [];
            for(let i = 0; i < members.length; i++){
                const name = 'm' + i;
                const type = members[i].getNodeType(builder);
                membersLayout.push({
                    name: name,
                    type: type,
                    index: i
                });
            }
            nodeData.membersLayout = membersLayout;
            nodeData.structType = builder.getOutputStructTypeFromNode(this, nodeData.membersLayout);
        }
        //
        const propertyName = builder.getOutputStructName();
        const members = this.members;
        const structPrefix = propertyName !== '' ? propertyName + '.' : '';
        for(let i = 0; i < members.length; i++){
            const snippet = members[i].build(builder);
            builder.addLineFlowCode(`${structPrefix}m${i} = ${snippet}`, this);
        }
        return propertyName;
    }
}
/**
 * TSL function for creating an output struct node.
 *
 * @tsl
 * @function
 * @param {...Node} members - A parameter list of nodes.
 * @returns {OutputStructNode}
 */ const $03ccd63b0299d6a7$var$outputStruct = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$ae7787fb8a88b867);
/**
 * Represents blending configuration.
 *
 * This class encapsulates all blending-related properties that control how
 * a material's colors are combined with the colors already in the frame buffer.
 */ class $03ccd63b0299d6a7$export$c9b8fe72ac71821 {
    /**
	 * Constructs a new blending configuration.
	 *
	 * @param {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending|MaterialBlending)} [blending=NormalBlending] - The blending mode.
	 */ constructor(blending = (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0)){
        /**
		 * Defines the blending type.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link BlendMode#blendSrc}, {@link BlendMode#blendDst} or {@link BlendMode#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending|MaterialBlending)}
		 * @default NormalBlending
		 */ this.blending = blending;
        /**
		 * Defines the blending source factor.
		 *
		 * This determines how the source (incoming) fragment color is factored before being added
		 * to the destination (existing) fragment color in the frame buffer.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = (0, $9ddd7e9b53f7a2d4$export$d5773124e86cf28c);
        /**
		 * Defines the blending destination factor.
		 *
		 * This determines how the destination (existing) fragment color in the frame buffer
		 * is factored before being combined with the source (incoming) fragment color.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = (0, $9ddd7e9b53f7a2d4$export$11d468cc7f19e971);
        /**
		 * Defines the blending equation.
		 *
		 * This determines how the source and destination colors are combined.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
        /**
		 * Defines the blending source alpha factor.
		 *
		 * When set, this allows separate control of the alpha channel's source blending factor.
		 * If `null`, {@link BlendMode#blendSrc} is used for the alpha channel as well.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * When set, this allows separate control of the alpha channel's destination blending factor.
		 * If `null`, {@link BlendMode#blendDst} is used for the alpha channel as well.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * When set, this allows separate control of the alpha channel's blending equation.
		 * If `null`, {@link BlendMode#blendEquation} is used for the alpha channel as well.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Defines whether to premultiply the alpha (transparency) value.
		 *
		 * If `true`, the RGB color of the texture or material is multiplied by its alpha value.
		 * This is useful for transparent textures/materials where the color data
		 * should already include the transparency information.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
    }
    /**
	 * Copies the blending properties from the given source to this instance.
	 *
	 * @param {BlendMode} source - The blending configuration to copy from.
	 * @return {BlendMode} A reference to this instance.
	 */ copy(source) {
        this.blending = source.blending;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.premultiplyAlpha = source.premultiplyAlpha;
        return this;
    }
    /**
	 * Returns a clone of this blending configuration.
	 *
	 * @return {BlendMode} A new Blending instance with the same properties.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
// Predefined blend modes for MRT nodes.
const $03ccd63b0299d6a7$var$_noBlending = /**@__PURE__*/ new $03ccd63b0299d6a7$export$c9b8fe72ac71821((0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba));
const $03ccd63b0299d6a7$var$_materialBlending = /**@__PURE__*/ new $03ccd63b0299d6a7$export$c9b8fe72ac71821((0, $9ddd7e9b53f7a2d4$export$ec822fcd0c1d2914));
/**
 * Returns the MRT texture index for the given name.
 *
 * @param {Array<Texture>} textures - The textures of a MRT-configured render target.
 * @param {string} name - The name of the MRT texture which index is requested.
 * @return {number} The texture index.
 */ function $03ccd63b0299d6a7$var$getTextureIndex(textures, name) {
    for(let i = 0; i < textures.length; i++){
        if (textures[i].name === name) return i;
    }
    return -1;
}
/**
 * This node can be used setup a MRT context for rendering. A typical MRT setup for
 * post-processing is shown below:
 * ```js
 * const mrtNode = mrt( {
 *   output: output,
 *   normal: normalView
 * } ) ;
 * ```
 * The MRT output is defined as a dictionary.
 *
 * @augments OutputStructNode
 */ class $03ccd63b0299d6a7$export$48063f712ed265fc extends $03ccd63b0299d6a7$export$ae7787fb8a88b867 {
    static get type() {
        return 'MRTNode';
    }
    /**
	 * Constructs a new output struct node.
	 *
	 * @param {Object<string, Node>} outputNodes - The MRT outputs.
	 */ constructor(outputNodes){
        super();
        /**
		 * A dictionary representing the MRT outputs. The key
		 * is the name of the output, the value the node which produces
		 * the output result.
		 *
		 * @type {Object<string, Node>}
		 */ this.outputNodes = outputNodes;
        /**
		 * A dictionary storing the blend modes for each output.
		 *
		 * @type {Object<string, BlendMode>}
		 */ this.blendModes = {
            output: $03ccd63b0299d6a7$var$_materialBlending
        };
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMRTNode = true;
    }
    /**
	 * Sets the blend mode for the given output name.
	 *
	 * @param {string} name - The name of the output.
	 * @param {BlendMode} blend - The blending mode.
	 * @return {MRTNode} The current MRT node.
	 */ setBlendMode(name, blend) {
        this.blendModes[name] = blend;
        return this;
    }
    /**
	 * Returns the blend mode for the given output name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {BlendMode} The blend mode.
	 */ getBlendMode(name) {
        return this.blendModes[name] || $03ccd63b0299d6a7$var$_noBlending;
    }
    /**
	 * Returns `true` if the MRT node has an output with the given name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {NodeBuilder} Whether the MRT node has an output for the given name or not.
	 */ has(name) {
        return this.outputNodes[name] !== undefined;
    }
    /**
	 * Returns the output node for the given name.
	 *
	 * @param {string} name - The name of the output.
	 * @return {Node} The output node.
	 */ get(name) {
        return this.outputNodes[name];
    }
    /**
	 * Merges the outputs of the given MRT node with the outputs of this node.
	 *
	 * @param {MRTNode} mrtNode - The MRT to merge.
	 * @return {MRTNode} A new MRT node with merged outputs..
	 */ merge(mrtNode) {
        const outputs = {
            ...this.outputNodes,
            ...mrtNode.outputNodes
        };
        const blendings = {
            ...this.blendModes,
            ...mrtNode.blendModes
        };
        const mrtTarget = $03ccd63b0299d6a7$var$mrt(outputs);
        mrtTarget.blendings = blendings;
        return mrtTarget;
    }
    setup(builder) {
        const outputNodes = this.outputNodes;
        const mrt = builder.renderer.getRenderTarget();
        const members = [];
        const textures = mrt.textures;
        for(const name in outputNodes){
            const index = $03ccd63b0299d6a7$var$getTextureIndex(textures, name);
            members[index] = $03ccd63b0299d6a7$var$vec4(outputNodes[name]);
        }
        this.members = members;
        return super.setup(builder);
    }
}
/**
 * TSL function for creating a MRT node.
 *
 * @tsl
 * @function
 * @param {Object<string, Node>} outputNodes - The MRT outputs.
 * @returns {MRTNode}
 */ const $03ccd63b0299d6a7$var$mrt = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$48063f712ed265fc);
/**
 * This node represents an operation that reinterprets the bit representation of a value
 * in one type as a value in another type.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$81c03d9ee746256f extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'BitcastNode';
    }
    /**
	 * Constructs a new bitcast node.
	 *
	 * @param {Node} valueNode - The value to convert.
	 * @param {string} conversionType - The type to convert to.
	 * @param {?string} [inputType = null] - The expected input data type of the bitcast operation.
	 */ constructor(valueNode, conversionType, inputType = null){
        super();
        /**
		 * The data to bitcast to a new type.
		 *
		 * @type {Node}
		 */ this.valueNode = valueNode;
        /**
		 * The type the value will be converted to.
		 *
		 * @type {string}
		 */ this.conversionType = conversionType;
        /**
		 * The expected input data type of the bitcast operation.
		 *
		 *
		 * @type {string}
		 * @default null
		 */ this.inputType = inputType;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBitcastNode = true;
    }
    generateNodeType(builder) {
        // GLSL aliasing
        if (this.inputType !== null) {
            const valueType = this.valueNode.getNodeType(builder);
            const valueLength = builder.getTypeLength(valueType);
            return builder.getTypeFromLength(valueLength, this.conversionType);
        }
        return this.conversionType;
    }
    generate(builder) {
        const type = this.getNodeType(builder);
        let inputType = '';
        if (this.inputType !== null) {
            const valueType = this.valueNode.getNodeType(builder);
            const valueTypeLength = builder.getTypeLength(valueType);
            inputType = valueTypeLength === 1 ? this.inputType : builder.changeComponentType(valueType, this.inputType);
        } else inputType = this.valueNode.getNodeType(builder);
        return `${builder.getBitcastMethod(type, inputType)}( ${this.valueNode.build(builder, inputType)} )`;
    }
}
/**
 * Reinterpret the bit representation of a value in one type as a value in another type.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The parameter.
 * @param {string} y - The new type.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$bitcast = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$81c03d9ee746256f).setParameterLength(2);
/**
 * Bitcasts a float or a vector of floats to a corresponding integer type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The float or vector of floats to bitcast.
 * @returns {BitcastNode}
 */ const $03ccd63b0299d6a7$var$floatBitsToInt = (value)=>new $03ccd63b0299d6a7$export$81c03d9ee746256f(value, 'int', 'float');
/**
 * Bitcasts a float or a vector of floats to a corresponding unsigned integer type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<float>} value - The float or vector of floats to bitcast.
 * @returns {BitcastNode}
 */ const $03ccd63b0299d6a7$var$floatBitsToUint = (value)=>new $03ccd63b0299d6a7$export$81c03d9ee746256f(value, 'uint', 'float');
/**
 * Bitcasts an integer or a vector of integers to a corresponding float type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<int>} value - The integer or vector of integers to bitcast.
 * @returns {BitcastNode}
 */ const $03ccd63b0299d6a7$var$intBitsToFloat = (value)=>new $03ccd63b0299d6a7$export$81c03d9ee746256f(value, 'float', 'int');
/**
 * Bitcast an unsigned integer or a vector of unsigned integers to a corresponding float type with the same element size.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer or vector of unsigned integers to bitcast.
 * @returns {BitcastNode}
 */ const $03ccd63b0299d6a7$var$uintBitsToFloat = (value)=>new $03ccd63b0299d6a7$export$81c03d9ee746256f(value, 'float', 'uint');
const $03ccd63b0299d6a7$var$registeredBitcountFunctions = {};
/**
 * This node represents an operation that counts the bits of a piece of shader data.
 *
 * @augments MathNode
 */ class $03ccd63b0299d6a7$export$adfce42cb92758a7 extends $03ccd63b0299d6a7$export$d9018c0f6b611cfb {
    static get type() {
        return 'BitcountNode';
    }
    /**
	 * Constructs a new math node.
	 *
	 * @param {'countTrailingZeros'|'countLeadingZeros'|'countOneBits'} method - The method name.
	 * @param {Node} aNode - The first input.
	 */ constructor(method, aNode){
        super(method, aNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBitcountNode = true;
    }
    /**
	 * Casts the input value of the function to an integer if necessary.
	 *
	 * @private
	 * @param {Node<uint>|Node<int>} inputNode - The input value.
	 * @param {Node<uint>} outputNode - The output value.
	 * @param {string} elementType - The type of the input value.
	 */ _resolveElementType(inputNode, outputNode, elementType) {
        if (elementType === 'int') outputNode.assign($03ccd63b0299d6a7$var$bitcast(inputNode, 'uint'));
        else outputNode.assign(inputNode);
    }
    _returnDataNode(inputType) {
        switch(inputType){
            case 'uint':
                return $03ccd63b0299d6a7$var$uint;
            case 'int':
                return $03ccd63b0299d6a7$var$int;
            case 'uvec2':
                return $03ccd63b0299d6a7$var$uvec2;
            case 'uvec3':
                return $03ccd63b0299d6a7$var$uvec3;
            case 'uvec4':
                return $03ccd63b0299d6a7$var$uvec4;
            case 'ivec2':
                return $03ccd63b0299d6a7$var$ivec2;
            case 'ivec3':
                return $03ccd63b0299d6a7$var$ivec3;
            case 'ivec4':
                return $03ccd63b0299d6a7$var$ivec4;
        }
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countTrailingZeros.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createTrailingZerosBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $03ccd63b0299d6a7$var$Fn(([value])=>{
            const v = $03ccd63b0299d6a7$var$uint(0.0);
            this._resolveElementType(value, v, elementType);
            const f = $03ccd63b0299d6a7$var$float(v.bitAnd($03ccd63b0299d6a7$var$negate(v)));
            const uintBits = $03ccd63b0299d6a7$var$floatBitsToUint(f);
            const numTrailingZeros = uintBits.shiftRight(23).sub(127);
            return outputConvertNode(numTrailingZeros);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countLeadingZeros.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createLeadingZerosBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $03ccd63b0299d6a7$var$Fn(([value])=>{
            $03ccd63b0299d6a7$var$If(value.equal($03ccd63b0299d6a7$var$uint(0)), ()=>{
                return $03ccd63b0299d6a7$var$uint(32);
            });
            const v = $03ccd63b0299d6a7$var$uint(0);
            const n = $03ccd63b0299d6a7$var$uint(0);
            this._resolveElementType(value, v, elementType);
            $03ccd63b0299d6a7$var$If(v.shiftRight(16).equal(0), ()=>{
                n.addAssign(16);
                v.shiftLeftAssign(16);
            });
            $03ccd63b0299d6a7$var$If(v.shiftRight(24).equal(0), ()=>{
                n.addAssign(8);
                v.shiftLeftAssign(8);
            });
            $03ccd63b0299d6a7$var$If(v.shiftRight(28).equal(0), ()=>{
                n.addAssign(4);
                v.shiftLeftAssign(4);
            });
            $03ccd63b0299d6a7$var$If(v.shiftRight(30).equal(0), ()=>{
                n.addAssign(2);
                v.shiftLeftAssign(2);
            });
            $03ccd63b0299d6a7$var$If(v.shiftRight(31).equal(0), ()=>{
                n.addAssign(1);
            });
            return outputConvertNode(n);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of countOneBits.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} elementType - The type of the input value.
	 * @returns {Function} - The generated function
	 */ _createOneBitsBaseLayout(method, elementType) {
        const outputConvertNode = this._returnDataNode(elementType);
        const fnDef = $03ccd63b0299d6a7$var$Fn(([value])=>{
            const v = $03ccd63b0299d6a7$var$uint(0.0);
            this._resolveElementType(value, v, elementType);
            v.assign(v.sub(v.shiftRight($03ccd63b0299d6a7$var$uint(1)).bitAnd($03ccd63b0299d6a7$var$uint(0x55555555))));
            v.assign(v.bitAnd($03ccd63b0299d6a7$var$uint(0x33333333)).add(v.shiftRight($03ccd63b0299d6a7$var$uint(2)).bitAnd($03ccd63b0299d6a7$var$uint(0x33333333))));
            const numBits = v.add(v.shiftRight($03ccd63b0299d6a7$var$uint(4))).bitAnd($03ccd63b0299d6a7$var$uint(0xF0F0F0F)).mul($03ccd63b0299d6a7$var$uint(0x1010101)).shiftRight($03ccd63b0299d6a7$var$uint(24));
            return outputConvertNode(numBits);
        }).setLayout({
            name: method,
            type: elementType,
            inputs: [
                {
                    name: 'value',
                    type: elementType
                }
            ]
        });
        return fnDef;
    }
    /**
	 * Creates and registers a reusable GLSL function that emulates the behavior of the specified bitcount function.
	 * including considerations for component-wise bitcounts on vector type inputs.
	 *
	 * @private
	 * @param {string} method - The name of the function to create.
	 * @param {string} inputType - The type of the input value.
	 * @param {number} typeLength - The vec length of the input value.
	 * @param {Function} baseFn - The base function that operates on an individual component of the vector.
	 * @returns {Function} - The alias function for the specified bitcount method.
	 */ _createMainLayout(method, inputType, typeLength, baseFn) {
        const outputConvertNode = this._returnDataNode(inputType);
        const fnDef = $03ccd63b0299d6a7$var$Fn(([value])=>{
            if (typeLength === 1) return outputConvertNode(baseFn(value));
            else {
                const vec = outputConvertNode(0);
                const components = [
                    'x',
                    'y',
                    'z',
                    'w'
                ];
                for(let i = 0; i < typeLength; i++){
                    const component = components[i];
                    vec[component].assign(baseFn(value[component]));
                }
                return vec;
            }
        }).setLayout({
            name: method,
            type: inputType,
            inputs: [
                {
                    name: 'value',
                    type: inputType
                }
            ]
        });
        return fnDef;
    }
    setup(builder) {
        const { method: method, aNode: aNode } = this;
        const { renderer: renderer } = builder;
        if (renderer.backend.isWebGPUBackend) // use built-in WGSL functions for WebGPU
        return super.setup(builder);
        const inputType = this.getInputType(builder);
        const elementType = builder.getElementType(inputType);
        const typeLength = builder.getTypeLength(inputType);
        const baseMethod = `${method}_base_${elementType}`;
        const newMethod = `${method}_${inputType}`;
        let baseFn = $03ccd63b0299d6a7$var$registeredBitcountFunctions[baseMethod];
        if (baseFn === undefined) {
            switch(method){
                case $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_LEADING_ZEROS:
                    baseFn = this._createLeadingZerosBaseLayout(baseMethod, elementType);
                    break;
                case $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_TRAILING_ZEROS:
                    baseFn = this._createTrailingZerosBaseLayout(baseMethod, elementType);
                    break;
                case $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_ONE_BITS:
                    baseFn = this._createOneBitsBaseLayout(baseMethod, elementType);
                    break;
            }
            $03ccd63b0299d6a7$var$registeredBitcountFunctions[baseMethod] = baseFn;
        }
        let fn = $03ccd63b0299d6a7$var$registeredBitcountFunctions[newMethod];
        if (fn === undefined) {
            fn = this._createMainLayout(newMethod, inputType, typeLength, baseFn);
            $03ccd63b0299d6a7$var$registeredBitcountFunctions[newMethod] = fn;
        }
        const output = $03ccd63b0299d6a7$var$Fn(()=>{
            return fn(aNode);
        });
        return output();
    }
}
$03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_TRAILING_ZEROS = 'countTrailingZeros';
$03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_LEADING_ZEROS = 'countLeadingZeros';
$03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_ONE_BITS = 'countOneBits';
/**
 * Finds the number of consecutive 0 bits from the least significant bit of the input value,
 * which is also the index of the least significant bit of the input value.
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input value.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$countTrailingZeros = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$adfce42cb92758a7, $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_TRAILING_ZEROS).setParameterLength(1);
/**
 * Finds the number of consecutive 0 bits starting from the most significant bit of the input value.
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @param {Node | number} x - The input value.
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$countLeadingZeros = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$adfce42cb92758a7, $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_LEADING_ZEROS).setParameterLength(1);
/**
 * Finds the number of '1' bits set in the input value
 *
 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
 *
 * @tsl
 * @function
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$countOneBits = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$adfce42cb92758a7, $03ccd63b0299d6a7$export$adfce42cb92758a7.COUNT_ONE_BITS).setParameterLength(1);
/**
 * Generates a hash value in the range `[0, 1]` from the given seed.
 *
 * @tsl
 * @function
 * @param {Node<float>} seed - The seed.
 * @return {Node<float>} The hash value.
 */ const $03ccd63b0299d6a7$var$hash = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([seed])=>{
    // Taken from https://www.shadertoy.com/view/XlGcRh, originally from pcg-random.org
    const state = seed.toUint().mul(747796405).add(2891336453);
    const word = state.shiftRight(state.shiftRight(28).add(4)).bitXor(state).mul(277803737);
    const result = word.shiftRight(22).bitXor(word);
    return result.toFloat().mul(1 / 2 ** 32); // Convert to range [0, 1)
});
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * The corners are mapped to `0` and the center to `1`.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} k - Allows to control the remapping functions shape by rising the parabola to a power `k`.
 * @return {Node<float>} The remapped value.
 */ const $03ccd63b0299d6a7$var$parabola = (x, k)=>$03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$mul(4.0, x.mul($03ccd63b0299d6a7$var$sub(1.0, x))), k);
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * Expands the sides and compresses the center, and keeps `0.5` mapped to `0.5`.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} k - `k=1` is the identity curve,`k<1` produces the classic `gain()` shape, and `k>1` produces "s" shaped curves.
 * @return {Node<float>} The remapped value.
 */ const $03ccd63b0299d6a7$var$gain = (x, k)=>x.lessThan(0.5) ? $03ccd63b0299d6a7$var$parabola(x.mul(2.0), k).div(2.0) : $03ccd63b0299d6a7$var$sub(1.0, $03ccd63b0299d6a7$var$parabola($03ccd63b0299d6a7$var$mul($03ccd63b0299d6a7$var$sub(1.0, x), 2.0), k).div(2.0));
/**
 * A function that remaps the `[0,1]` interval into the `[0,1]` interval.
 * A generalization of the `parabola()`. Keeps the corners mapped to 0 but allows the control of the shape one either side of the curve.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to remap.
 * @param {Node<float>} a - First control parameter.
 * @param {Node<float>} b - Second control parameter.
 * @return {Node<float>} The remapped value.
 */ const $03ccd63b0299d6a7$var$pcurve = (x, a, b)=>$03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$div($03ccd63b0299d6a7$var$pow(x, a), $03ccd63b0299d6a7$var$add($03ccd63b0299d6a7$var$pow(x, a), $03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$sub(1.0, x), b))), 1.0 / a);
/**
 * A phase shifted sinus curve that starts at zero and ends at zero, with bouncing behavior.
 * Reference: {@link https://iquilezles.org/articles/functions/}.
 *
 * @tsl
 * @function
 * @param {Node<float>} x - The value to compute the sin for.
 * @param {Node<float>} k - Controls the amount of bounces.
 * @return {Node<float>} The result value.
 */ const $03ccd63b0299d6a7$var$sinc = (x, k)=>$03ccd63b0299d6a7$var$sin($03ccd63b0299d6a7$var$PI.mul(k.mul(x).sub(1.0))).div($03ccd63b0299d6a7$var$PI.mul(k.mul(x).sub(1.0)));
/**
 * This node represents an operation that packs floating-point values of a vector into an unsigned 32-bit integer
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$ecd6a17cae035ee8 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'PackFloatNode';
    }
    /**
	 *
	 * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @param {Node} vectorNode - The vector node to be packed
	 */ constructor(encoding, vectorNode){
        super();
        /**
		 * The vector to be packed.
		 *
		 * @type {Node}
		 */ this.vectorNode = vectorNode;
        /**
		 * The numeric encoding.
		 *
		 * @type {string}
		 */ this.encoding = encoding;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPackFloatNode = true;
    }
    generateNodeType() {
        return 'uint';
    }
    generate(builder) {
        const inputType = this.vectorNode.getNodeType(builder);
        return `${builder.getFloatPackingMethod(this.encoding)}(${this.vectorNode.build(builder, inputType)})`;
    }
}
/**
 * Converts each component of the normalized float to 16-bit integer values. The results are packed into a single unsigned integer.
 * round(clamp(c, -1, +1) * 32767.0)
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$packSnorm2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$ecd6a17cae035ee8, 'snorm').setParameterLength(1);
/**
 * Converts each component of the normalized float to 16-bit integer values. The results are packed into a single unsigned integer.
 * round(clamp(c, 0, +1) * 65535.0)
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$packUnorm2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$ecd6a17cae035ee8, 'unorm').setParameterLength(1);
/**
 * Converts each component of the vec2 to 16-bit floating-point values. The results are packed into a single unsigned integer.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} value - The 2-component vector to be packed
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$packHalf2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$ecd6a17cae035ee8, 'float16').setParameterLength(1);
/**
 * This node represents an operation that unpacks values from a 32-bit unsigned integer, reinterpreting the results as a floating-point vector
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$93da41ed864f51d0 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'UnpackFloatNode';
    }
    /**
	 *
	 * @param {'snorm' | 'unorm' | 'float16'} encoding - The numeric encoding that describes how the integer values are mapped to the float range
	 * @param {Node} uintNode - The uint node to be unpacked
	 */ constructor(encoding, uintNode){
        super();
        /**
		 * The unsigned integer to be unpacked.
		 *
		 * @type {Node}
		 */ this.uintNode = uintNode;
        /**
		 * The numeric encoding.
		 *
		 * @type {string}
		 */ this.encoding = encoding;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUnpackFloatNode = true;
    }
    generateNodeType() {
        return 'vec2';
    }
    generate(builder) {
        const inputType = this.uintNode.getNodeType(builder);
        return `${builder.getFloatUnpackingMethod(this.encoding)}(${this.uintNode.build(builder, inputType)})`;
    }
}
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as normalized signed integers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$unpackSnorm2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$93da41ed864f51d0, 'snorm').setParameterLength(1);
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as normalized unsigned integers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$unpackUnorm2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$93da41ed864f51d0, 'unorm').setParameterLength(1);
/**
 * Unpacks a 32-bit unsigned integer into two 16-bit values, interpreted as 16-bit floating-point numbers. Returns a vec2 with both values.
 *
 * @tsl
 * @function
 * @param {Node<uint>} value - The unsigned integer to be unpacked
 * @returns {Node}
 */ const $03ccd63b0299d6a7$var$unpackHalf2x16 = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$93da41ed864f51d0, 'float16').setParameterLength(1);
// https://github.com/cabbibo/glsl-tri-noise-3d
const $03ccd63b0299d6a7$var$tri = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x])=>{
    return x.fract().sub(.5).abs();
}).setLayout({
    name: 'tri',
    type: 'float',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$tri3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p])=>{
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$tri(p.z.add($03ccd63b0299d6a7$var$tri(p.y.mul(1.)))), $03ccd63b0299d6a7$var$tri(p.z.add($03ccd63b0299d6a7$var$tri(p.x.mul(1.)))), $03ccd63b0299d6a7$var$tri(p.y.add($03ccd63b0299d6a7$var$tri(p.x.mul(1.)))));
}).setLayout({
    name: 'tri3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
/**
 * Generates a noise value from the given position, speed and time parameters.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} position - The position.
 * @param {Node<float>} speed - The speed.
 * @param {Node<float>} time - The time.
 * @return {Node<float>} The generated noise.
 */ const $03ccd63b0299d6a7$var$triNoise3D = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([position, speed, time])=>{
    const p = $03ccd63b0299d6a7$var$vec3(position).toVar();
    const z = $03ccd63b0299d6a7$var$float(1.4).toVar();
    const rz = $03ccd63b0299d6a7$var$float(0.0).toVar();
    const bp = $03ccd63b0299d6a7$var$vec3(p).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: $03ccd63b0299d6a7$var$float(0.0),
        end: $03ccd63b0299d6a7$var$float(3.0),
        type: 'float',
        condition: '<='
    }, ()=>{
        const dg = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$tri3(bp.mul(2.0))).toVar();
        p.addAssign(dg.add(time.mul($03ccd63b0299d6a7$var$float(0.1).mul(speed))));
        bp.mulAssign(1.8);
        z.mulAssign(1.5);
        p.mulAssign(1.2);
        const t = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$tri(p.z.add($03ccd63b0299d6a7$var$tri(p.x.add($03ccd63b0299d6a7$var$tri(p.y)))))).toVar();
        rz.addAssign(t.div(z));
        bp.addAssign(0.14);
    });
    return rz;
}).setLayout({
    name: 'triNoise3D',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec3'
        },
        {
            name: 'speed',
            type: 'float'
        },
        {
            name: 'time',
            type: 'float'
        }
    ]
});
/**
 * This class allows to define multiple overloaded versions
 * of the same function. Depending on the parameters of the function
 * call, the node picks the best-fit overloaded version.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$83ec1b7751f4e8e2 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'FunctionOverloadingNode';
    }
    /**
	 * Constructs a new function overloading node.
	 *
	 * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
	 * @param {...Node} parametersNodes - A list of parameter nodes.
	 */ constructor(functionNodes = [], ...parametersNodes){
        super();
        /**
		 * Array of `Fn` function definitions.
		 *
		 * @type {Array<Function>}
		 */ this.functionNodes = functionNodes;
        /**
		 * A list of parameter nodes.
		 *
		 * @type {Array<Node>}
		 */ this.parametersNodes = parametersNodes;
        /**
		 * The selected overloaded function call.
		 *
		 * @private
		 * @type {ShaderCallNodeInternal}
		 */ this._candidateFn = null;
        /**
		 * This node is marked as global.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * This method is overwritten since the node type is inferred from
	 * the function's return type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        const candidateFn = this.getCandidateFn(builder);
        return candidateFn.shaderNode.layout.type;
    }
    /**
	 * Returns the candidate function for the current parameters.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {FunctionNode} The candidate function.
	 */ getCandidateFn(builder) {
        const params = this.parametersNodes;
        let candidateFn = this._candidateFn;
        if (candidateFn === null) {
            let bestCandidateFn = null;
            let bestScore = -1;
            for (const functionNode of this.functionNodes){
                const shaderNode = functionNode.shaderNode;
                const layout = shaderNode.layout;
                if (layout === null) throw new Error('FunctionOverloadingNode: FunctionNode must be a layout.');
                const inputs = layout.inputs;
                if (params.length === inputs.length) {
                    let currentScore = 0;
                    for(let i = 0; i < params.length; i++){
                        const param = params[i];
                        const input = inputs[i];
                        if (param.getNodeType(builder) === input.type) currentScore++;
                    }
                    if (currentScore > bestScore) {
                        bestCandidateFn = functionNode;
                        bestScore = currentScore;
                    }
                }
            }
            this._candidateFn = candidateFn = bestCandidateFn;
        }
        return candidateFn;
    }
    /**
	 * Sets up the node for the current parameters.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Node} The setup node.
	 */ setup(builder) {
        const candidateFn = this.getCandidateFn(builder);
        return candidateFn(...this.parametersNodes);
    }
}
const $03ccd63b0299d6a7$var$overloadingBaseFn = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$83ec1b7751f4e8e2);
/**
 * TSL function for creating a function overloading node.
 *
 * @tsl
 * @function
 * @param {Array<Function>} functionNodes - Array of `Fn` function definitions.
 * @returns {FunctionOverloadingNode}
 */ const $03ccd63b0299d6a7$var$overloadingFn = (functionNodes)=>(...params)=>$03ccd63b0299d6a7$var$overloadingBaseFn(functionNodes, ...params);
/**
 * Represents the elapsed time in seconds.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $03ccd63b0299d6a7$var$time = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((frame)=>frame.time);
/**
 * Represents the delta time in seconds.
 *
 * @tsl
 * @type {UniformNode<float>}
 */ const $03ccd63b0299d6a7$var$deltaTime = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((frame)=>frame.deltaTime);
/**
 * Represents the current frame ID.
 *
 * @tsl
 * @type {UniformNode<uint>}
 */ const $03ccd63b0299d6a7$var$frameId = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0, 'uint').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((frame)=>frame.frameId);
/**
 * Generates a sine wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $03ccd63b0299d6a7$var$oscSine = (t = $03ccd63b0299d6a7$var$time)=>t.add(0.75).mul(Math.PI * 2).sin().mul(0.5).add(0.5);
/**
 * Generates a square wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $03ccd63b0299d6a7$var$oscSquare = (t = $03ccd63b0299d6a7$var$time)=>t.fract().round();
/**
 * Generates a triangle wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $03ccd63b0299d6a7$var$oscTriangle = (t = $03ccd63b0299d6a7$var$time)=>t.add(0.5).fract().mul(2).sub(1).abs();
/**
 * Generates a sawtooth wave oscillation based on a timer.
 *
 * @tsl
 * @function
 * @param {Node<float>} t - The timer to generate the oscillation with.
 * @return {Node<float>} The oscillation node.
 */ const $03ccd63b0299d6a7$var$oscSawtooth = (t = $03ccd63b0299d6a7$var$time)=>t.fract();
/**
 * Replaces the default UV coordinates used in texture lookups.
 *
 * ```js
 *material.contextNode = replaceDefaultUV( ( textureNode ) => {
 *
 *	// ...
 *	return customUVCoordinates;
 *
 *} );
 *```
 *
 * @tsl
 * @function
 * @param {function(Node):Node<vec2>|Node<vec2>} callback - A callback that receives the texture node
 * and must return the new uv coordinates.
 * @param {Node} [node=null] - An optional node to which the context will be applied.
 * @return {ContextNode} A context node that replaces the default UV coordinates.
 */ function $03ccd63b0299d6a7$var$replaceDefaultUV(callback, node = null) {
    const getUV = typeof callback === 'function' ? callback : ()=>callback;
    return $03ccd63b0299d6a7$var$context(node, {
        getUV: getUV
    });
}
/**
 * Rotates the given uv coordinates around a center point
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv coordinates.
 * @param {Node<float>} rotation - The rotation defined in radians.
 * @param {Node<vec2>} center - The center of rotation
 * @return {Node<vec2>} The rotated uv coordinates.
 */ const $03ccd63b0299d6a7$var$rotateUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv, rotation, center = $03ccd63b0299d6a7$var$vec2(0.5)])=>{
    return $03ccd63b0299d6a7$var$rotate(uv.sub(center), rotation).add(center);
});
/**
 * Applies a spherical warping effect to the given uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The uv coordinates.
 * @param {Node<float>} strength - The strength of the effect.
 * @param {Node<vec2>} center - The center point
 * @return {Node<vec2>} The updated uv coordinates.
 */ const $03ccd63b0299d6a7$var$spherizeUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv, strength, center = $03ccd63b0299d6a7$var$vec2(0.5)])=>{
    const delta = uv.sub(center);
    const delta2 = delta.dot(delta);
    const delta4 = delta2.mul(delta2);
    const deltaOffset = delta4.mul(strength);
    return uv.add(delta.mul(deltaOffset));
});
/**
 * This can be used to achieve a billboarding behavior for flat meshes. That means they are
 * oriented always towards the camera.
 *
 * ```js
 * material.vertexNode = billboarding();
 * ```
 *
 * @tsl
 * @function
 * @param {Object} config - The configuration object.
 * @param {?Node<vec3>} [config.position=null] - Can be used to define the vertex positions in world space.
 * @param {boolean} [config.horizontal=true] - Whether to follow the camera rotation horizontally or not.
 * @param {boolean} [config.vertical=false] - Whether to follow the camera rotation vertically or not.
 * @return {Node<vec3>} The updated vertex position in clip space.
 */ const $03ccd63b0299d6a7$var$billboarding = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ position: position = null, horizontal: horizontal = true, vertical: vertical = false })=>{
    let worldMatrix;
    if (position !== null) {
        worldMatrix = $03ccd63b0299d6a7$var$modelWorldMatrix.toVar();
        worldMatrix[3][0] = position.x;
        worldMatrix[3][1] = position.y;
        worldMatrix[3][2] = position.z;
    } else worldMatrix = $03ccd63b0299d6a7$var$modelWorldMatrix;
    const modelViewMatrix = $03ccd63b0299d6a7$var$cameraViewMatrix.mul(worldMatrix);
    if ($03ccd63b0299d6a7$var$defined(horizontal)) {
        modelViewMatrix[0][0] = $03ccd63b0299d6a7$var$modelWorldMatrix[0].length();
        modelViewMatrix[0][1] = 0;
        modelViewMatrix[0][2] = 0;
    }
    if ($03ccd63b0299d6a7$var$defined(vertical)) {
        modelViewMatrix[1][0] = 0;
        modelViewMatrix[1][1] = $03ccd63b0299d6a7$var$modelWorldMatrix[1].length();
        modelViewMatrix[1][2] = 0;
    }
    modelViewMatrix[2][0] = 0;
    modelViewMatrix[2][1] = 0;
    modelViewMatrix[2][2] = 1;
    return $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul(modelViewMatrix).mul($03ccd63b0299d6a7$var$positionLocal);
});
/**
 * A special version of a screen uv function that involves a depth comparison
 * when computing the final uvs. The function mitigates visual errors when
 * using viewport texture nodes for refraction purposes. Without this function
 * objects in front of a refractive surface might appear on the refractive surface
 * which is incorrect.
 *
 * @tsl
 * @function
 * @param {?Node<vec2>} uv - Optional uv coordinates. By default `screenUV` is used.
 * @return {Node<vec2>} The update uv coordinates.
 */ const $03ccd63b0299d6a7$var$viewportSafeUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv = null])=>{
    const depth = $03ccd63b0299d6a7$var$linearDepth();
    const depthDiff = $03ccd63b0299d6a7$var$linearDepth($03ccd63b0299d6a7$var$viewportDepthTexture(uv)).sub(depth);
    const finalUV = depthDiff.lessThan(0).select($03ccd63b0299d6a7$var$screenUV, uv);
    return finalUV;
});
/**
 * TSL function for computing texture coordinates for animated sprite sheets.
 *
 * ```js
 * const uvNode = spritesheetUV( vec2( 6, 6 ), uv(), time.mul( animationSpeed ) );
 *
 * material.colorNode = texture( spriteSheet, uvNode );
 * ```
 *
 * @tsl
 * @function
 * @param {Node<vec2>} countNode - The node that defines the number of sprites in the x and y direction (e.g 6x6).
 * @param {?Node<vec2>} [uvNode=uv()] - The uv node.
 * @param {?Node<float>} [frameNode=float(0)] - The node that defines the current frame/sprite.
 * @returns {Node<vec2>}
 */ const $03ccd63b0299d6a7$var$spritesheetUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([countNode, uvNode = $03ccd63b0299d6a7$var$uv$1(), frameNode = $03ccd63b0299d6a7$var$float(0)])=>{
    const width = countNode.x;
    const height = countNode.y;
    const frameNum = frameNode.mod(width.mul(height)).floor();
    const column = frameNum.mod(width);
    const row = height.sub(frameNum.add(1).div(width).ceil());
    const scale = countNode.reciprocal();
    const uvFrameOffset = $03ccd63b0299d6a7$var$vec2(column, row);
    return uvNode.add(uvFrameOffset).mul(scale);
});
/**
 * TSL function for creating a triplanar textures node.
 *
 * Can be used for triplanar texture mapping.
 *
 * ```js
 * material.colorNode = triplanarTexture( texture( diffuseMap ) );
 * ```
 *
 * @tsl
 * @function
 * @param {Node} textureXNode - First texture node.
 * @param {?Node} [textureYNode=null] - Second texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node} [textureZNode=null] - Third texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node<float>} [scaleNode=float(1)] - The scale node.
 * @param {?Node<vec3>} [positionNode=positionLocal] - Vertex positions in local space.
 * @param {?Node<vec3>} [normalNode=normalLocal] - Normals in local space.
 * @returns {Node<vec4>}
 */ const $03ccd63b0299d6a7$var$triplanarTextures = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([textureXNode, textureYNode = null, textureZNode = null, scaleNode = $03ccd63b0299d6a7$var$float(1), positionNode = $03ccd63b0299d6a7$var$positionLocal, normalNode = $03ccd63b0299d6a7$var$normalLocal])=>{
    // Reference: https://github.com/keijiro/StandardTriplanar
    // Blending factor of triplanar mapping
    let bf = normalNode.abs().normalize();
    bf = bf.div(bf.dot($03ccd63b0299d6a7$var$vec3(1.0)));
    // Triplanar mapping
    const tx = positionNode.yz.mul(scaleNode);
    const ty = positionNode.zx.mul(scaleNode);
    const tz = positionNode.xy.mul(scaleNode);
    // Base color
    const textureX = textureXNode.value;
    const textureY = textureYNode !== null ? textureYNode.value : textureX;
    const textureZ = textureZNode !== null ? textureZNode.value : textureX;
    const cx = $03ccd63b0299d6a7$var$texture(textureX, tx).mul(bf.x);
    const cy = $03ccd63b0299d6a7$var$texture(textureY, ty).mul(bf.y);
    const cz = $03ccd63b0299d6a7$var$texture(textureZ, tz).mul(bf.z);
    return $03ccd63b0299d6a7$var$add(cx, cy, cz);
});
/**
 * TSL function for creating a triplanar textures node.
 *
 * @tsl
 * @function
 * @param {Node} textureXNode - First texture node.
 * @param {?Node} [textureYNode=null] - Second texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node} [textureZNode=null] - Third texture node. When not set, the shader will sample from `textureXNode` instead.
 * @param {?Node<float>} [scaleNode=float(1)] - The scale node.
 * @param {?Node<vec3>} [positionNode=positionLocal] - Vertex positions in local space.
 * @param {?Node<vec3>} [normalNode=normalLocal] - Normals in local space.
 * @returns {Node<vec4>}
 */ const $03ccd63b0299d6a7$var$triplanarTexture = (...params)=>$03ccd63b0299d6a7$var$triplanarTextures(...params);
const $03ccd63b0299d6a7$var$_reflectorPlane = new (0, $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0)();
const $03ccd63b0299d6a7$var$_normal = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_reflectorWorldPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_cameraWorldPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_rotationMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $03ccd63b0299d6a7$var$_lookAtPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1);
const $03ccd63b0299d6a7$var$clipPlane = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
const $03ccd63b0299d6a7$var$_view = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_target = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_q = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
const $03ccd63b0299d6a7$var$_size$2 = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $03ccd63b0299d6a7$var$_defaultRT = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)();
const $03ccd63b0299d6a7$var$_defaultUV = $03ccd63b0299d6a7$var$screenUV.flipX();
$03ccd63b0299d6a7$var$_defaultRT.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(1, 1);
let $03ccd63b0299d6a7$var$_inReflector = false;
/**
 * This node can be used to implement mirror-like flat reflective surfaces.
 *
 * ```js
 * const groundReflector = reflector();
 * material.colorNode = groundReflector;
 *
 * const plane = new Mesh( geometry, material );
 * plane.add( groundReflector.target );
 * ```
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$69f7e4bb85146c53 extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'ReflectorNode';
    }
    /**
	 * Constructs a new reflector node.
	 *
	 * @param {Object} [parameters={}] - An object holding configuration parameters.
	 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
	 * @param {number} [parameters.resolutionScale=1] - The resolution scale.
	 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
	 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
	 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
	 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
	 * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
	 * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
	 */ constructor(parameters = {}){
        super(parameters.defaultTexture || $03ccd63b0299d6a7$var$_defaultRT.texture, $03ccd63b0299d6a7$var$_defaultUV);
        /**
		 * A reference to the internal reflector base node which holds the actual implementation.
		 *
		 * @private
		 * @type {ReflectorBaseNode}
		 * @default ReflectorBaseNode
		 */ this._reflectorBaseNode = parameters.reflector || new $03ccd63b0299d6a7$var$ReflectorBaseNode(this, parameters);
        /**
		 * A reference to the internal depth node.
		 *
		 * @private
		 * @type {?Node}
		 * @default null
		 */ this._depthNode = null;
        this.setUpdateMatrix(false);
    }
    /**
	 * A reference to the internal reflector node.
	 *
	 * @type {ReflectorBaseNode}
	 */ get reflector() {
        return this._reflectorBaseNode;
    }
    /**
	 * A reference to 3D object the reflector is linked to.
	 *
	 * @type {Object3D}
	 */ get target() {
        return this._reflectorBaseNode.target;
    }
    /**
	 * Returns a node representing the mirror's depth. That can be used
	 * to implement more advanced reflection effects like distance attenuation.
	 *
	 * @return {Node} The depth node.
	 */ getDepthNode() {
        if (this._depthNode === null) {
            if (this._reflectorBaseNode.depth !== true) throw new Error('THREE.ReflectorNode: Depth node can only be requested when the reflector is created with { depth: true }. ');
            this._depthNode = new $03ccd63b0299d6a7$export$69f7e4bb85146c53({
                defaultTexture: $03ccd63b0299d6a7$var$_defaultRT.depthTexture,
                reflector: this._reflectorBaseNode
            });
        }
        return this._depthNode;
    }
    setup(builder) {
        // ignore if used in post-processing
        if (!builder.object.isQuadMesh) this._reflectorBaseNode.build(builder);
        return super.setup(builder);
    }
    clone() {
        const newNode = new this.constructor(this.reflectorNode);
        newNode.uvNode = this.uvNode;
        newNode.levelNode = this.levelNode;
        newNode.biasNode = this.biasNode;
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        newNode._reflectorBaseNode = this._reflectorBaseNode;
        return newNode;
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        super.dispose();
        this._reflectorBaseNode.dispose();
    }
}
/**
 * Holds the actual implementation of the reflector.
 *
 * TODO: Explain why `ReflectorBaseNode`. Originally the entire logic was implemented
 * in `ReflectorNode`, see #29619.
 *
 * @private
 * @augments Node
 */ class $03ccd63b0299d6a7$var$ReflectorBaseNode extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ReflectorBaseNode';
    }
    /**
	 * Constructs a new reflector base node.
	 *
	 * @param {TextureNode} textureNode - Represents the rendered reflections as a texture node.
	 * @param {Object} [parameters={}] - An object holding configuration parameters.
	 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
	 * @param {number} [parameters.resolutionScale=1] - The resolution scale.
	 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
	 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
	 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
	 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
	 */ constructor(textureNode, parameters = {}){
        super();
        const { target: target = new (0, $9ddd7e9b53f7a2d4$export$e4dd07dff30cc924)(), resolutionScale: resolutionScale = 1, generateMipmaps: generateMipmaps = false, bounces: bounces = true, depth: depth = false, samples: samples = 0 } = parameters;
        /**
		 * Represents the rendered reflections as a texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The 3D object the reflector is linked to.
		 *
		 * @type {Object3D}
		 * @default {new Object3D()}
		 */ this.target = target;
        /**
		 * The resolution scale.
		 *
		 * @type {number}
		 * @default {1}
		 */ this.resolutionScale = resolutionScale;
        if (parameters.resolution !== undefined) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('ReflectorNode: The "resolution" parameter has been renamed to "resolutionScale".'); // @deprecated r180
            this.resolutionScale = parameters.resolution;
        }
        /**
		 * Whether mipmaps should be generated or not.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.generateMipmaps = generateMipmaps;
        /**
		 * Whether reflectors can render other reflector nodes or not.
		 *
		 * @type {boolean}
		 * @default {true}
		 */ this.bounces = bounces;
        /**
		 * Whether depth data should be generated or not.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.depth = depth;
        /**
		 * The number of anti-aliasing samples for the render-target
		 *
		 * @type {number}
		 * @default {0}
		 */ this.samples = samples;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` when {@link ReflectorBaseNode#bounces}
		 * is `true`. Otherwise it's `NodeUpdateType.FRAME`.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = bounces ? $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER : $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        /**
		 * Weak map for managing virtual cameras.
		 *
		 * @type {WeakMap<Camera, Camera>}
		 */ this.virtualCameras = new WeakMap();
        /**
		 * Weak map for managing render targets.
		 *
		 * @type {Map<Camera, RenderTarget>}
		 */ this.renderTargets = new Map();
        /**
		 * Force render even if reflector is facing away from camera.
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.forceUpdate = false;
        /**
		 * Whether the reflector has been rendered or not.
		 *
		 * When the reflector is facing away from the camera,
		 * this flag is set to `false` and the texture will be empty(black).
		 *
		 * @type {boolean}
		 * @default {false}
		 */ this.hasOutput = false;
    }
    /**
	 * Updates the resolution of the internal render target.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The render target to resize.
	 * @param {Renderer} renderer - The renderer that is used to determine the new size.
	 */ _updateResolution(renderTarget, renderer) {
        const resolution = this.resolutionScale;
        renderer.getDrawingBufferSize($03ccd63b0299d6a7$var$_size$2);
        renderTarget.setSize(Math.round($03ccd63b0299d6a7$var$_size$2.width * resolution), Math.round($03ccd63b0299d6a7$var$_size$2.height * resolution));
    }
    setup(builder) {
        this._updateResolution($03ccd63b0299d6a7$var$_defaultRT, builder.renderer);
        return super.setup(builder);
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        super.dispose();
        for (const renderTarget of this.renderTargets.values())renderTarget.dispose();
    }
    /**
	 * Returns a virtual camera for the given camera. The virtual camera is used to
	 * render the scene from the reflector's view so correct reflections can be produced.
	 *
	 * @param {Camera} camera - The scene's camera.
	 * @return {Camera} The corresponding virtual camera.
	 */ getVirtualCamera(camera) {
        let virtualCamera = this.virtualCameras.get(camera);
        if (virtualCamera === undefined) {
            virtualCamera = camera.clone();
            this.virtualCameras.set(camera, virtualCamera);
        }
        return virtualCamera;
    }
    /**
	 * Returns a render target for the given camera. The reflections are rendered
	 * into this render target.
	 *
	 * @param {Camera} camera - The scene's camera.
	 * @return {RenderTarget} The render target.
	 */ getRenderTarget(camera) {
        let renderTarget = this.renderTargets.get(camera);
        if (renderTarget === undefined) {
            renderTarget = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(0, 0, {
                type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                samples: this.samples
            });
            if (this.generateMipmaps === true) {
                renderTarget.texture.minFilter = (0, $9ddd7e9b53f7a2d4$export$90d80f1e3506775f);
                renderTarget.texture.generateMipmaps = true;
            }
            if (this.depth === true) renderTarget.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)();
            this.renderTargets.set(camera, renderTarget);
        }
        return renderTarget;
    }
    updateBefore(frame) {
        if (this.bounces === false && $03ccd63b0299d6a7$var$_inReflector) return false;
        $03ccd63b0299d6a7$var$_inReflector = true;
        const { scene: scene, camera: camera, renderer: renderer, material: material } = frame;
        const { target: target } = this;
        const virtualCamera = this.getVirtualCamera(camera);
        const renderTarget = this.getRenderTarget(virtualCamera);
        renderer.getDrawingBufferSize($03ccd63b0299d6a7$var$_size$2);
        this._updateResolution(renderTarget, renderer);
        //
        $03ccd63b0299d6a7$var$_reflectorWorldPosition.setFromMatrixPosition(target.matrixWorld);
        $03ccd63b0299d6a7$var$_cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
        $03ccd63b0299d6a7$var$_rotationMatrix.extractRotation(target.matrixWorld);
        $03ccd63b0299d6a7$var$_normal.set(0, 0, 1);
        $03ccd63b0299d6a7$var$_normal.applyMatrix4($03ccd63b0299d6a7$var$_rotationMatrix);
        $03ccd63b0299d6a7$var$_view.subVectors($03ccd63b0299d6a7$var$_reflectorWorldPosition, $03ccd63b0299d6a7$var$_cameraWorldPosition);
        // Avoid rendering when reflector is facing away unless forcing an update
        const isFacingAway = $03ccd63b0299d6a7$var$_view.dot($03ccd63b0299d6a7$var$_normal) > 0;
        let needsClear = false;
        if (isFacingAway === true && this.forceUpdate === false) {
            if (this.hasOutput === false) {
                $03ccd63b0299d6a7$var$_inReflector = false;
                return;
            }
            needsClear = true;
        }
        $03ccd63b0299d6a7$var$_view.reflect($03ccd63b0299d6a7$var$_normal).negate();
        $03ccd63b0299d6a7$var$_view.add($03ccd63b0299d6a7$var$_reflectorWorldPosition);
        $03ccd63b0299d6a7$var$_rotationMatrix.extractRotation(camera.matrixWorld);
        $03ccd63b0299d6a7$var$_lookAtPosition.set(0, 0, -1);
        $03ccd63b0299d6a7$var$_lookAtPosition.applyMatrix4($03ccd63b0299d6a7$var$_rotationMatrix);
        $03ccd63b0299d6a7$var$_lookAtPosition.add($03ccd63b0299d6a7$var$_cameraWorldPosition);
        $03ccd63b0299d6a7$var$_target.subVectors($03ccd63b0299d6a7$var$_reflectorWorldPosition, $03ccd63b0299d6a7$var$_lookAtPosition);
        $03ccd63b0299d6a7$var$_target.reflect($03ccd63b0299d6a7$var$_normal).negate();
        $03ccd63b0299d6a7$var$_target.add($03ccd63b0299d6a7$var$_reflectorWorldPosition);
        //
        virtualCamera.coordinateSystem = camera.coordinateSystem;
        virtualCamera.position.copy($03ccd63b0299d6a7$var$_view);
        virtualCamera.up.set(0, 1, 0);
        virtualCamera.up.applyMatrix4($03ccd63b0299d6a7$var$_rotationMatrix);
        virtualCamera.up.reflect($03ccd63b0299d6a7$var$_normal);
        virtualCamera.lookAt($03ccd63b0299d6a7$var$_target);
        virtualCamera.near = camera.near;
        virtualCamera.far = camera.far;
        virtualCamera.updateMatrixWorld();
        virtualCamera.projectionMatrix.copy(camera.projectionMatrix);
        // Now update projection matrix with new clip plane, implementing code from: http://www.terathon.com/code/oblique.html
        // Paper explaining this technique: http://www.terathon.com/lengyel/Lengyel-Oblique.pdf
        $03ccd63b0299d6a7$var$_reflectorPlane.setFromNormalAndCoplanarPoint($03ccd63b0299d6a7$var$_normal, $03ccd63b0299d6a7$var$_reflectorWorldPosition);
        $03ccd63b0299d6a7$var$_reflectorPlane.applyMatrix4(virtualCamera.matrixWorldInverse);
        $03ccd63b0299d6a7$var$clipPlane.set($03ccd63b0299d6a7$var$_reflectorPlane.normal.x, $03ccd63b0299d6a7$var$_reflectorPlane.normal.y, $03ccd63b0299d6a7$var$_reflectorPlane.normal.z, $03ccd63b0299d6a7$var$_reflectorPlane.constant);
        const projectionMatrix = virtualCamera.projectionMatrix;
        $03ccd63b0299d6a7$var$_q.x = (Math.sign($03ccd63b0299d6a7$var$clipPlane.x) + projectionMatrix.elements[8]) / projectionMatrix.elements[0];
        $03ccd63b0299d6a7$var$_q.y = (Math.sign($03ccd63b0299d6a7$var$clipPlane.y) + projectionMatrix.elements[9]) / projectionMatrix.elements[5];
        $03ccd63b0299d6a7$var$_q.z = -1;
        $03ccd63b0299d6a7$var$_q.w = (1.0 + projectionMatrix.elements[10]) / projectionMatrix.elements[14];
        // Calculate the scaled plane vector
        $03ccd63b0299d6a7$var$clipPlane.multiplyScalar(1.0 / $03ccd63b0299d6a7$var$clipPlane.dot($03ccd63b0299d6a7$var$_q));
        const clipBias = 0;
        // Replacing the third row of the projection matrix
        projectionMatrix.elements[2] = $03ccd63b0299d6a7$var$clipPlane.x;
        projectionMatrix.elements[6] = $03ccd63b0299d6a7$var$clipPlane.y;
        projectionMatrix.elements[10] = renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac) ? $03ccd63b0299d6a7$var$clipPlane.z - clipBias : $03ccd63b0299d6a7$var$clipPlane.z + 1.0 - clipBias;
        projectionMatrix.elements[14] = $03ccd63b0299d6a7$var$clipPlane.w;
        //
        this.textureNode.value = renderTarget.texture;
        if (this.depth === true) this.textureNode.getDepthNode().value = renderTarget.depthTexture;
        material.visible = false;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        const currentAutoClear = renderer.autoClear;
        renderer.setMRT(null);
        renderer.setRenderTarget(renderTarget);
        renderer.autoClear = true;
        const previousName = scene.name;
        scene.name = (scene.name || 'Scene') + ' [ Reflector ]'; // TODO: Add bounce index
        if (needsClear) {
            renderer.clear();
            this.hasOutput = false;
        } else {
            renderer.render(scene, virtualCamera);
            this.hasOutput = true;
        }
        scene.name = previousName;
        renderer.setMRT(currentMRT);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.autoClear = currentAutoClear;
        material.visible = true;
        $03ccd63b0299d6a7$var$_inReflector = false;
        this.forceUpdate = false;
    }
    /**
	 * The resolution scale.
	 *
	 * @deprecated
	 * @type {number}
	 * @default {1}
	 */ get resolution() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'); // @deprecated r180
        return this.resolutionScale;
    }
    set resolution(value) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('ReflectorNode: The "resolution" property has been renamed to "resolutionScale".'); // @deprecated r180
        this.resolutionScale = value;
    }
}
/**
 * TSL function for creating a reflector node.
 *
 * @tsl
 * @function
 * @param {Object} [parameters={}] - An object holding configuration parameters.
 * @param {Object3D} [parameters.target=new Object3D()] - The 3D object the reflector is linked to.
 * @param {number} [parameters.resolution=1] - The resolution scale.
 * @param {boolean} [parameters.generateMipmaps=false] - Whether mipmaps should be generated or not.
 * @param {boolean} [parameters.bounces=true] - Whether reflectors can render other reflector nodes or not.
 * @param {boolean} [parameters.depth=false] - Whether depth data should be generated or not.
 * @param {number} [parameters.samples] - Anti-Aliasing samples of the internal render-target.
 * @param {TextureNode} [parameters.defaultTexture] - The default texture node.
 * @param {ReflectorBaseNode} [parameters.reflector] - The reflector base node.
 * @returns {ReflectorNode}
 */ const $03ccd63b0299d6a7$var$reflector = (parameters)=>new $03ccd63b0299d6a7$export$69f7e4bb85146c53(parameters);
const $03ccd63b0299d6a7$var$_camera = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
/**
 * The purpose of this special geometry is to fill the entire viewport with a single triangle.
 *
 * Reference: {@link https://github.com/mrdoob/three.js/pull/21358}
 *
 * @private
 * @augments BufferGeometry
 */ class $03ccd63b0299d6a7$var$QuadGeometry extends (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959) {
    /**
	 * Constructs a new quad geometry.
	 *
	 * @param {boolean} [flipY=false] - Whether the uv coordinates should be flipped along the vertical axis or not.
	 */ constructor(flipY = false){
        super();
        const uv = flipY === false ? [
            0,
            -1,
            0,
            1,
            2,
            1
        ] : [
            0,
            2,
            0,
            0,
            2,
            0
        ];
        this.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)(uv, 2));
    }
}
const $03ccd63b0299d6a7$var$_geometry = /*@__PURE__*/ new $03ccd63b0299d6a7$var$QuadGeometry();
/**
 * This module is a helper for passes which need to render a full
 * screen effect which is quite common in context of post processing.
 *
 * The intended usage is to reuse a single quad mesh for rendering
 * subsequent passes by just reassigning the `material` reference.
 *
 * Note: This module can only be used with `WebGPURenderer`.
 *
 * @augments Mesh
 */ class $03ccd63b0299d6a7$export$266ce19fe399ee9a extends (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5) {
    /**
	 * Constructs a new quad mesh.
	 *
	 * @param {?Material} [material=null] - The material to render the quad mesh with.
	 */ constructor(material = null){
        super($03ccd63b0299d6a7$var$_geometry, material);
        /**
		 * The camera to render the quad mesh with.
		 *
		 * @type {OrthographicCamera}
		 * @readonly
		 */ this.camera = $03ccd63b0299d6a7$var$_camera;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadMesh = true;
    }
    /**
	 * Async version of `render()`.
	 *
	 * @async
	 * @deprecated
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync(renderer) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('QuadMesh: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await renderer.init();
        renderer.render(this, $03ccd63b0299d6a7$var$_camera);
    }
    /**
	 * Renders the quad mesh
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ render(renderer) {
        renderer.render(this, $03ccd63b0299d6a7$var$_camera);
    }
}
const $03ccd63b0299d6a7$var$_size$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
/**
 * `RTTNode` takes another node and uses it with a `QuadMesh` to render into a texture (RTT).
 * This module is especially relevant in context of post processing where certain nodes require
 * texture input for their effects. With the helper function `convertToTexture()` which is based
 * on this module, the node system can automatically ensure texture input if required.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$14d053dc5e3b4165 extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'RTTNode';
    }
    /**
	 * Constructs a new RTT node.
	 *
	 * @param {Node} node - The node to render a texture with.
	 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
	 * @param {?number} [height=null] - The height of the internal render target.
	 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
	 */ constructor(node, width = null, height = null, options = {
        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)
    }){
        const renderTarget = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(width, height, options);
        super(renderTarget.texture, $03ccd63b0299d6a7$var$uv$1());
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRTTNode = true;
        /**
		 * The node to render a texture with.
		 *
		 * @type {Node}
		 */ this.node = node;
        /**
		 * The width of the internal render target.
		 * If not width is applied, the render target is automatically resized.
		 *
		 * @type {?number}
		 * @default null
		 */ this.width = width;
        /**
		 * The height of the internal render target.
		 *
		 * @type {?number}
		 * @default null
		 */ this.height = height;
        /**
		 * The pixel ratio
		 *
		 * @type {number}
		 * @default 1
		 */ this.pixelRatio = 1;
        /**
		 * The render target
		 *
		 * @type {RenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * Whether the texture requires an update or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.textureNeedsUpdate = true;
        /**
		 * Whether the texture should automatically be updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * The node which is used with the quad mesh for RTT.
		 *
		 * @private
		 * @type {Node}
		 * @default null
		 */ this._rttNode = null;
        /**
		 * The internal quad mesh for RTT.
		 *
		 * @private
		 * @type {QuadMesh}
		 */ this._quadMesh = new $03ccd63b0299d6a7$export$266ce19fe399ee9a(new $03ccd63b0299d6a7$export$caaf3b30a544c946());
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.RENDER` since the node updates
		 * the texture once per render in its {@link RTTNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
    }
    /**
	 * Whether the internal render target should automatically be resized or not.
	 *
	 * @type {boolean}
	 * @readonly
	 * @default true
	 */ get autoResize() {
        return this.width === null;
    }
    setup(builder) {
        this._rttNode = this.node.context(builder.getSharedContext());
        this._quadMesh.material.name = 'RTT';
        this._quadMesh.material.needsUpdate = true;
        return super.setup(builder);
    }
    /**
	 * Sets the size of the internal render target
	 *
	 * @param {number} width - The width to set.
	 * @param {number} height - The width to set.
	 */ setSize(width, height) {
        this.width = width;
        this.height = height;
        const effectiveWidth = width * this.pixelRatio;
        const effectiveHeight = height * this.pixelRatio;
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
        this.textureNeedsUpdate = true;
    }
    /**
	 * Sets the pixel ratio. This will also resize the render target.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this.pixelRatio = pixelRatio;
        this.setSize(this.width, this.height);
    }
    updateBefore({ renderer: renderer }) {
        if (this.textureNeedsUpdate === false && this.autoUpdate === false) return;
        this.textureNeedsUpdate = false;
        //
        if (this.autoResize === true) {
            const pixelRatio = renderer.getPixelRatio();
            const size = renderer.getSize($03ccd63b0299d6a7$var$_size$1);
            const effectiveWidth = Math.floor(size.width * pixelRatio);
            const effectiveHeight = Math.floor(size.height * pixelRatio);
            if (effectiveWidth !== this.renderTarget.width || effectiveHeight !== this.renderTarget.height) {
                this.renderTarget.setSize(effectiveWidth, effectiveHeight);
                this.textureNeedsUpdate = true;
            }
        }
        //
        let name = 'RTT';
        if (this.node.name) name = this.node.name + ' [ ' + name + ' ]';
        this._quadMesh.material.fragmentNode = this._rttNode;
        this._quadMesh.name = name;
        //
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(this.renderTarget);
        this._quadMesh.render(renderer);
        renderer.setRenderTarget(currentRenderTarget);
    }
    clone() {
        const newNode = new $03ccd63b0299d6a7$export$2dd903bc9e8140bc(this.value, this.uvNode, this.levelNode);
        newNode.sampler = this.sampler;
        newNode.referenceNode = this;
        return newNode;
    }
}
/**
 * TSL function for creating a RTT node.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to render a texture with.
 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
 * @param {?number} [height=null] - The height of the internal render target.
 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
 * @returns {RTTNode}
 */ const $03ccd63b0299d6a7$var$rtt = (node, ...params)=>new $03ccd63b0299d6a7$export$14d053dc5e3b4165($03ccd63b0299d6a7$var$nodeObject(node), ...params);
/**
 * TSL function for converting nodes to textures nodes.
 *
 * @tsl
 * @function
 * @param {Node} node - The node to render a texture with.
 * @param {?number} [width=null] - The width of the internal render target. If not width is applied, the render target is automatically resized.
 * @param {?number} [height=null] - The height of the internal render target.
 * @param {Object} [options={type:HalfFloatType}] - The options for the internal render target.
 * @returns {RTTNode}
 */ const $03ccd63b0299d6a7$var$convertToTexture = (node, ...params)=>{
    if (node.isSampleNode || node.isTextureNode) return node;
    if (node.isPassNode) return node.getTextureNode();
    return $03ccd63b0299d6a7$var$rtt(node, ...params);
};
/**
 * Computes a position in view space based on a fragment's screen position expressed as uv coordinates, the fragments
 * depth value and the camera's inverse projection matrix.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} screenPosition - The fragment's screen position expressed as uv coordinates.
 * @param {Node<float>} depth - The fragment's depth value.
 * @param {Node<mat4>} projectionMatrixInverse - The camera's inverse projection matrix.
 * @return {Node<vec3>} The fragments position in view space.
 */ const $03ccd63b0299d6a7$var$getViewPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([screenPosition, depth, projectionMatrixInverse], builder)=>{
    let clipSpacePosition;
    if (builder.renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac)) {
        screenPosition = $03ccd63b0299d6a7$var$vec2(screenPosition.x, screenPosition.y.oneMinus()).mul(2.0).sub(1.0);
        clipSpacePosition = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$vec3(screenPosition, depth), 1.0);
    } else clipSpacePosition = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$vec3(screenPosition.x, screenPosition.y.oneMinus(), depth).mul(2.0).sub(1.0), 1.0);
    const viewSpacePosition = $03ccd63b0299d6a7$var$vec4(projectionMatrixInverse.mul(clipSpacePosition));
    return viewSpacePosition.xyz.div(viewSpacePosition.w);
});
/**
 * Computes a screen position expressed as uv coordinates based on a fragment's position in view space
 * and the camera's projection matrix
 *
 * @tsl
 * @function
 * @param {Node<vec3>} viewPosition - The fragments position in view space.
 * @param {Node<mat4>} projectionMatrix - The camera's projection matrix.
 * @return {Node<vec2>} The fragment's screen position expressed as uv coordinates.
 */ const $03ccd63b0299d6a7$var$getScreenPosition = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([viewPosition, projectionMatrix])=>{
    const sampleClipPos = projectionMatrix.mul($03ccd63b0299d6a7$var$vec4(viewPosition, 1.0));
    const sampleUv = sampleClipPos.xy.div(sampleClipPos.w).mul(0.5).add(0.5).toVar();
    return $03ccd63b0299d6a7$var$vec2(sampleUv.x, sampleUv.y.oneMinus());
});
/**
 * Computes a normal vector based on depth data. Can be used as a fallback when no normal render
 * target is available or if flat surface normals are required.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} uv - The texture coordinate.
 * @param {DepthTexture} depthTexture - The depth texture.
 * @param {Node<mat4>} projectionMatrixInverse - The camera's inverse projection matrix.
 * @return {Node<vec3>} The computed normal vector.
 */ const $03ccd63b0299d6a7$var$getNormalFromDepth = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([uv, depthTexture, projectionMatrixInverse])=>{
    const size = $03ccd63b0299d6a7$var$textureSize($03ccd63b0299d6a7$var$textureLoad(depthTexture));
    const p = $03ccd63b0299d6a7$var$ivec2(uv.mul(size)).toVar();
    const c0 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p).toVar();
    const l2 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.sub($03ccd63b0299d6a7$var$ivec2(2, 0))).toVar();
    const l1 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.sub($03ccd63b0299d6a7$var$ivec2(1, 0))).toVar();
    const r1 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.add($03ccd63b0299d6a7$var$ivec2(1, 0))).toVar();
    const r2 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.add($03ccd63b0299d6a7$var$ivec2(2, 0))).toVar();
    const b2 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.add($03ccd63b0299d6a7$var$ivec2(0, 2))).toVar();
    const b1 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.add($03ccd63b0299d6a7$var$ivec2(0, 1))).toVar();
    const t1 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.sub($03ccd63b0299d6a7$var$ivec2(0, 1))).toVar();
    const t2 = $03ccd63b0299d6a7$var$textureLoad(depthTexture, p.sub($03ccd63b0299d6a7$var$ivec2(0, 2))).toVar();
    const dl = $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(2).mul(l1).sub(l2), c0)).toVar();
    const dr = $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(2).mul(r1).sub(r2), c0)).toVar();
    const db = $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(2).mul(b1).sub(b2), c0)).toVar();
    const dt = $03ccd63b0299d6a7$var$abs($03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(2).mul(t1).sub(t2), c0)).toVar();
    const ce = $03ccd63b0299d6a7$var$getViewPosition(uv, c0, projectionMatrixInverse).toVar();
    const dpdx = dl.lessThan(dr).select(ce.sub($03ccd63b0299d6a7$var$getViewPosition(uv.sub($03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$float(1).div(size.x), 0)), l1, projectionMatrixInverse)), ce.negate().add($03ccd63b0299d6a7$var$getViewPosition(uv.add($03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$float(1).div(size.x), 0)), r1, projectionMatrixInverse)));
    const dpdy = db.lessThan(dt).select(ce.sub($03ccd63b0299d6a7$var$getViewPosition(uv.add($03ccd63b0299d6a7$var$vec2(0, $03ccd63b0299d6a7$var$float(1).div(size.y))), b1, projectionMatrixInverse)), ce.negate().add($03ccd63b0299d6a7$var$getViewPosition(uv.sub($03ccd63b0299d6a7$var$vec2(0, $03ccd63b0299d6a7$var$float(1).div(size.y))), t1, projectionMatrixInverse)));
    return $03ccd63b0299d6a7$var$normalize($03ccd63b0299d6a7$var$cross(dpdx, dpdy));
});
/**
 * Interleaved Gradient Noise (IGN) from Jimenez 2014.
 *
 * IGN has "low discrepancy" resulting in evenly distributed samples. It's superior compared to
 * default white noise, blue noise or Bayer.
 *
 * References:
 * - {@link https://www.iryoku.com/next-generation-post-processing-in-call-of-duty-advanced-warfare/}
 * - {@link https://blog.demofox.org/2022/01/01/interleaved-gradient-noise-a-different-kind-of-low-discrepancy-sequence/}
 *
 * @tsl
 * @function
 * @param {Node<vec2>} position - The input position, usually screen coordinates.
 * @return {Node<float>} The noise value.
 */ const $03ccd63b0299d6a7$var$interleavedGradientNoise = $03ccd63b0299d6a7$var$Fn(([position])=>{
    return $03ccd63b0299d6a7$var$fract($03ccd63b0299d6a7$var$float(52.9829189).mul($03ccd63b0299d6a7$var$fract($03ccd63b0299d6a7$var$dot(position, $03ccd63b0299d6a7$var$vec2(0.06711056, 0.00583715)))));
}).setLayout({
    name: 'interleavedGradientNoise',
    type: 'float',
    inputs: [
        {
            name: 'position',
            type: 'vec2'
        }
    ]
});
/**
 * Vogel disk sampling for uniform circular distribution.
 *
 * This function generates sample points distributed uniformly on a disk using the golden angle,
 * resulting in an efficient low-discrepancy sequence for sampling. The rotation parameter (phi)
 * allows randomizing the pattern per-pixel when combined with IGN.
 *
 * @tsl
 * @function
 * @param {Node<int>} sampleIndex - The index of the current sample (0-based).
 * @param {Node<int>} samplesCount - The total number of samples.
 * @param {Node<float>} phi - Rotation angle in radians (typically from IGN * 2π).
 * @return {Node<vec2>} A 2D point on the unit disk.
 */ const $03ccd63b0299d6a7$var$vogelDiskSample = $03ccd63b0299d6a7$var$Fn(([sampleIndex, samplesCount, phi])=>{
    const goldenAngle = $03ccd63b0299d6a7$var$float(2.399963229728653); // 2π * (2 - φ) where φ is golden ratio
    const r = $03ccd63b0299d6a7$var$sqrt($03ccd63b0299d6a7$var$float(sampleIndex).add(0.5).div($03ccd63b0299d6a7$var$float(samplesCount)));
    const theta = $03ccd63b0299d6a7$var$float(sampleIndex).mul(goldenAngle).add(phi);
    return $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$cos(theta), $03ccd63b0299d6a7$var$sin(theta)).mul(r);
}).setLayout({
    name: 'vogelDiskSample',
    type: 'vec2',
    inputs: [
        {
            name: 'sampleIndex',
            type: 'int'
        },
        {
            name: 'samplesCount',
            type: 'int'
        },
        {
            name: 'phi',
            type: 'float'
        }
    ]
});
/**
 * Class representing a node that samples a value using a provided callback function.
 *
 * @extends Node
 */ class $03ccd63b0299d6a7$export$f8e5968e33512433 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    /**
	 * Returns the type of the node.
	 *
	 * @type {string}
	 * @readonly
	 * @static
	 */ static get type() {
        return 'SampleNode';
    }
    /**
	 * Creates an instance of SampleNode.
	 *
	 * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
	 * @param {?Node<vec2>} [uvNode=null] - The UV node to be used in the texture sampling.
	 */ constructor(callback, uvNode = null){
        super();
        this.callback = callback;
        /**
		 * Represents the texture coordinates.
		 *
		 * @type {?Node<vec2|vec3>}
		 * @default null
		 */ this.uvNode = uvNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampleNode = true;
    }
    /**
	 * Sets up the node by sampling with the default UV accessor.
	 *
	 * @returns {Node} The result of the callback function when called with the UV node.
	 */ setup() {
        return this.sample($03ccd63b0299d6a7$var$uv$1());
    }
    /**
	 * Calls the callback function with the provided UV node.
	 *
	 * @param {Node<vec2>} uv - The UV node or value to be passed to the callback.
	 * @returns {Node} The result of the callback function.
	 */ sample(uv) {
        return this.callback(uv);
    }
}
/**
 * Helper function to create a SampleNode wrapped as a node object.
 *
 * @function
 * @param {Function} callback - The function to be called when sampling. Should accept a UV node and return a value.
 * @param {?Node<vec2>} [uv=null] - The UV node to be used in the texture sampling.
 * @returns {SampleNode} The created SampleNode instance wrapped as a node object.
 */ const $03ccd63b0299d6a7$var$sample = (callback, uv = null)=>new $03ccd63b0299d6a7$export$f8e5968e33512433(callback, $03ccd63b0299d6a7$var$nodeObject(uv));
/**
 * EventNode is a node that executes a callback during specific update phases.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$5deccdd1dfcccf57 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'EventNode';
    }
    /**
	 * Creates an EventNode.
	 *
	 * @param {string} eventType - The type of event
	 * @param {Function} callback - The callback to execute on update.
	 */ constructor(eventType, callback){
        super('void');
        this.eventType = eventType;
        this.callback = callback;
        if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.OBJECT) this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        else if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.MATERIAL) this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        else if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.FRAME) this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        else if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_OBJECT) this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        else if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_MATERIAL) this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        else if (eventType === $03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_FRAME) this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
    }
    update(frame) {
        this.callback(frame);
    }
    updateBefore(frame) {
        this.callback(frame);
    }
}
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.OBJECT = 'object';
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.MATERIAL = 'material';
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.FRAME = 'frame';
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_OBJECT = 'beforeObject';
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_MATERIAL = 'beforeMaterial';
$03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_FRAME = 'beforeFrame';
/**
 * Helper to create an EventNode and add it to the stack.
 *
 * @param {string} type - The event type.
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$createEvent = (type, callback)=>new $03ccd63b0299d6a7$export$5deccdd1dfcccf57(type, callback).toStack();
/**
 * Creates an event that triggers a function every time an object (Mesh|Sprite) is rendered.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnObjectUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.OBJECT, callback);
/**
 * Creates an event that triggers a function when the first object that uses the material is rendered.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnMaterialUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.MATERIAL, callback);
/**
 * Creates an event that triggers a function every frame.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnFrameUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.FRAME, callback);
/**
 * Creates an event that triggers a function before an object (Mesh|Sprite) is updated.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnBeforeObjectUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_OBJECT, callback);
/**
 * Creates an event that triggers a function before the material is updated.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnBeforeMaterialUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_MATERIAL, callback);
/**
 * Creates an event that triggers a function before every frame.
 *
 * The event will be bound to the declared TSL function `Fn()`; it must be declared within a `Fn()` or the JS function call must be inherited from one.
 *
 * @param {Function} callback - The callback function.
 * @returns {EventNode}
 */ const $03ccd63b0299d6a7$var$OnBeforeFrameUpdate = (callback)=>$03ccd63b0299d6a7$var$createEvent($03ccd63b0299d6a7$export$5deccdd1dfcccf57.BEFORE_FRAME, callback);
/**
 * This special type of instanced buffer attribute is intended for compute shaders.
 * In earlier three.js versions it was only possible to update attribute data
 * on the CPU via JavaScript and then upload the data to the GPU. With the
 * new material system and renderer it is now possible to use compute shaders
 * to compute the data for an attribute more efficiently on the GPU.
 *
 * The idea is to create an instance of this class and provide it as an input
 * to {@link StorageBufferNode}.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`.
 *
 * @augments InstancedBufferAttribute
 */ class $03ccd63b0299d6a7$export$281e97eb7155319a extends (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a) {
    /**
	 * Constructs a new storage instanced buffer attribute.
	 *
	 * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
	 * The subsequent parameters are then obsolete.
	 * @param {number} itemSize - The item size.
	 * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
	 */ constructor(count, itemSize, typeClass = Float32Array){
        const array = ArrayBuffer.isView(count) ? count : new typeClass(count * itemSize);
        super(array, itemSize);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageInstancedBufferAttribute = true;
    }
}
/**
 * This special type of buffer attribute is intended for compute shaders.
 * In earlier three.js versions it was only possible to update attribute data
 * on the CPU via JavaScript and then upload the data to the GPU. With the
 * new material system and renderer it is now possible to use compute shaders
 * to compute the data for an attribute more efficiently on the GPU.
 *
 * The idea is to create an instance of this class and provide it as an input
 * to {@link StorageBufferNode}.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`.
 *
 * @augments BufferAttribute
 */ class $03ccd63b0299d6a7$export$5eb1a076d3725e22 extends (0, $9ddd7e9b53f7a2d4$export$8dea267bd6bde117) {
    /**
	 * Constructs a new storage buffer attribute.
	 *
	 * @param {number|TypedArray} count - The item count. It is also valid to pass a typed array as an argument.
	 * The subsequent parameters are then obsolete.
	 * @param {number} itemSize - The item size.
	 * @param {TypedArray.constructor} [typeClass=Float32Array] - A typed array constructor.
	 */ constructor(count, itemSize, typeClass = Float32Array){
        const array = ArrayBuffer.isView(count) ? count : new typeClass(count * itemSize);
        super(array, itemSize);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBufferAttribute = true;
    }
}
/**
 * TSL function for creating a storage buffer node with a configured `StorageBufferAttribute`.
 *
 * @tsl
 * @function
 * @param {number|TypedArray} count - The data count. It is also valid to pass a typed array as an argument.
 * @param {string|Struct} [type='float'] - The data type.
 * @returns {StorageBufferNode}
 */ const $03ccd63b0299d6a7$var$attributeArray = (count, type = 'float')=>{
    let itemSize, typedArray;
    if (type.isStruct === true) {
        itemSize = type.layout.getLength();
        typedArray = $03ccd63b0299d6a7$var$getTypedArrayFromType('float');
    } else {
        itemSize = $03ccd63b0299d6a7$var$getLengthFromType(type);
        typedArray = $03ccd63b0299d6a7$var$getTypedArrayFromType(type);
    }
    const buffer = new $03ccd63b0299d6a7$export$5eb1a076d3725e22(count, itemSize, typedArray);
    const node = $03ccd63b0299d6a7$var$storage(buffer, type, count);
    return node;
};
/**
 * TSL function for creating a storage buffer node with a configured `StorageInstancedBufferAttribute`.
 *
 * @tsl
 * @function
 * @param {number|TypedArray} count - The data count. It is also valid to pass a typed array as an argument.
 * @param {string|Struct} [type='float'] - The data type.
 * @returns {StorageBufferNode}
 */ const $03ccd63b0299d6a7$var$instancedArray = (count, type = 'float')=>{
    let itemSize, typedArray;
    if (type.isStruct === true) {
        itemSize = type.layout.getLength();
        typedArray = $03ccd63b0299d6a7$var$getTypedArrayFromType('float');
    } else {
        itemSize = $03ccd63b0299d6a7$var$getLengthFromType(type);
        typedArray = $03ccd63b0299d6a7$var$getTypedArrayFromType(type);
    }
    const buffer = new $03ccd63b0299d6a7$export$281e97eb7155319a(count, itemSize, typedArray);
    const node = $03ccd63b0299d6a7$var$storage(buffer, type, buffer.count);
    return node;
};
/**
 * A node for representing the uv coordinates of points.
 *
 * Can only be used with a WebGL backend. In WebGPU, point
 * primitives always have the size of one pixel and can thus
 * can't be used as sprite-like objects that display textures.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$5e50f6b6071cd75 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'PointUVNode';
    }
    /**
	 * Constructs a new point uv node.
	 */ constructor(){
        super('vec2');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointUVNode = true;
    }
    generate() {
        return 'vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y )';
    }
}
/**
 * TSL object that represents the uv coordinates of points.
 *
 * @tsl
 * @type {PointUVNode}
 */ const $03ccd63b0299d6a7$var$pointUV = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$5e50f6b6071cd75);
const $03ccd63b0299d6a7$var$_m1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
/**
 * TSL object that represents the scene's background blurriness.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$backgroundBlurriness = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ scene: scene })=>scene.backgroundBlurriness);
/**
 * TSL object that represents the scene's background intensity.
 *
 * @tsl
 * @type {Node<float>}
 */ const $03ccd63b0299d6a7$var$backgroundIntensity = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(1).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ scene: scene })=>scene.backgroundIntensity);
/**
 * TSL object that represents the scene's background rotation.
 *
 * @tsl
 * @type {Node<mat4>}
 */ const $03ccd63b0299d6a7$var$backgroundRotation = /*@__PURE__*/ $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)()).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ scene: scene })=>{
    const background = scene.background;
    if (background !== null && background.isTexture && background.mapping !== (0, $9ddd7e9b53f7a2d4$export$1beec6768cbb3d2d)) // note: since the matrix is orthonormal, we can use the more-efficient transpose() in lieu of invert()
    $03ccd63b0299d6a7$var$_m1.makeRotationFromEuler(scene.backgroundRotation).transpose();
    else $03ccd63b0299d6a7$var$_m1.identity();
    return $03ccd63b0299d6a7$var$_m1;
});
/**
 * This special version of a texture node can be used to
 * write data into a storage texture with a compute shader.
 *
 * ```js
 * const storageTexture = new THREE.StorageTexture( width, height );
 *
 * const computeTexture = Fn( ( { storageTexture } ) => {
 *
 * 	const posX = instanceIndex.mod( width );
 * 	const posY = instanceIndex.div( width );
 * 	const indexUV = uvec2( posX, posY );
 *
 * 	// generate RGB values
 *
 * 	const r = 1;
 * 	const g = 1;
 * 	const b = 1;
 *
 * 	textureStore( storageTexture, indexUV, vec4( r, g, b, 1 ) ).toWriteOnly();
 *
 * } );
 *
 * const computeNode = computeTexture( { storageTexture } ).compute( width * height );
 * renderer.computeAsync( computeNode );
 * ```
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$f9d0185498cbffc2 extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'StorageTextureNode';
    }
    /**
	 * Constructs a new storage texture node.
	 *
	 * @param {StorageTexture} value - The storage texture.
	 * @param {Node<vec2|vec3>} uvNode - The uv node.
	 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
	 */ constructor(value, uvNode, storeNode = null){
        super(value, uvNode);
        /**
		 * The value node that should be stored in the texture.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.storeNode = storeNode;
        /**
		 * The mip level to write to for storage textures.
		 *
		 * @type {number}
		 * @default 0
		 */ this.mipLevel = 0;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTextureNode = true;
        /**
		 * The access type of the texture node.
		 *
		 * @type {string}
		 * @default 'writeOnly'
		 */ this.access = $03ccd63b0299d6a7$export$92538c74c63a703d.WRITE_ONLY;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'storageTexture'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'storageTexture';
    }
    setup(builder) {
        super.setup(builder);
        const properties = builder.getNodeProperties(this);
        properties.storeNode = this.storeNode;
        return properties;
    }
    /**
	 * Defines the node access.
	 *
	 * @param {string} value - The node access.
	 * @return {StorageTextureNode} A reference to this node.
	 */ setAccess(value) {
        this.access = value;
        return this;
    }
    /**
	 * Sets the mip level to write to.
	 *
	 * @param {number} level - The mip level.
	 * @return {StorageTextureNode} A reference to this node.
	 */ setMipLevel(level) {
        this.mipLevel = level;
        return this;
    }
    /**
	 * Generates the code snippet of the storage node. If no `storeNode`
	 * is defined, the texture node is generated as normal texture.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} output - The current output.
	 * @return {string} The generated code snippet.
	 */ generate(builder, output) {
        if (this.storeNode !== null) {
            this.generateStore(builder);
            return '';
        }
        return super.generate(builder, output);
    }
    /**
	 * Generates the snippet for the storage texture.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} textureProperty - The texture property.
	 * @param {string} uvSnippet - The uv snippet.
	 * @param {?string} levelSnippet - The level snippet.
	 * @param {?string} biasSnippet - The bias snippet.
	 * @param {?string} depthSnippet - The depth snippet.
	 * @param {?string} compareSnippet - The compare snippet.
	 * @param {?Array<string>} gradSnippet - The grad snippet.
	 * @param {?string} offsetSnippet - The offset snippet.
	 * @return {string} The generated code snippet.
	 */ generateSnippet(builder, textureProperty, uvSnippet, levelSnippet, biasSnippet, depthSnippet, compareSnippet, gradSnippet, offsetSnippet) {
        const texture = this.value;
        return builder.generateStorageTextureLoad(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet);
    }
    /**
	 * Convenience method for configuring a read/write node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toReadWrite() {
        return this.setAccess($03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE);
    }
    /**
	 * Convenience method for configuring a read-only node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toReadOnly() {
        return this.setAccess($03ccd63b0299d6a7$export$92538c74c63a703d.READ_ONLY);
    }
    /**
	 * Convenience method for configuring a write-only node access.
	 *
	 * @return {StorageTextureNode} A reference to this node.
	 */ toWriteOnly() {
        return this.setAccess($03ccd63b0299d6a7$export$92538c74c63a703d.WRITE_ONLY);
    }
    /**
	 * Generates the code snippet of the storage texture node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ generateStore(builder) {
        const properties = builder.getNodeProperties(this);
        const { uvNode: uvNode, storeNode: storeNode, depthNode: depthNode } = properties;
        const textureProperty = super.generate(builder, 'property');
        const uvSnippet = uvNode.build(builder, this.value.is3DTexture === true ? 'uvec3' : 'uvec2');
        const storeSnippet = storeNode.build(builder, 'vec4');
        const depthSnippet = depthNode ? depthNode.build(builder, 'int') : null;
        const snippet = builder.generateTextureStore(this.value, textureProperty, uvSnippet, depthSnippet, storeSnippet);
        builder.addLineFlowCode(snippet, this);
    }
    clone() {
        const newNode = super.clone();
        newNode.storeNode = this.storeNode;
        newNode.mipLevel = this.mipLevel;
        newNode.access = this.access;
        return newNode;
    }
}
/**
 * TSL function for creating a storage texture node.
 *
 * @tsl
 * @function
 * @param {StorageTexture} value - The storage texture.
 * @param {?Node<vec2|vec3>} uvNode - The uv node.
 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
 * @returns {StorageTextureNode}
 */ const $03ccd63b0299d6a7$var$storageTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$f9d0185498cbffc2).setParameterLength(1, 3);
/**
 * TODO: Explain difference to `storageTexture()`.
 *
 * @tsl
 * @function
 * @param {StorageTexture} value - The storage texture.
 * @param {Node<vec2|vec3>} uvNode - The uv node.
 * @param {?Node} [storeNode=null] - The value node that should be stored in the texture.
 * @returns {StorageTextureNode}
 */ const $03ccd63b0299d6a7$var$textureStore = (value, uvNode, storeNode)=>{
    let node;
    if (value.isStorageTextureNode === true) {
        // Derive new storage texture node from existing one
        node = value.clone();
        node.uvNode = uvNode;
        node.storeNode = storeNode;
    } else node = $03ccd63b0299d6a7$var$storageTexture(value, uvNode, storeNode);
    if (storeNode !== null) node.toStack();
    return node;
};
const $03ccd63b0299d6a7$var$normal = $03ccd63b0299d6a7$var$Fn(({ texture: texture, uv: uv })=>{
    const epsilon = 0.0001;
    const ret = $03ccd63b0299d6a7$var$vec3().toVar();
    $03ccd63b0299d6a7$var$If(uv.x.lessThan(epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(1, 0, 0));
    }).ElseIf(uv.y.lessThan(epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(0, 1, 0));
    }).ElseIf(uv.z.lessThan(epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(0, 0, 1));
    }).ElseIf(uv.x.greaterThan(1 - epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(-1, 0, 0));
    }).ElseIf(uv.y.greaterThan(1 - epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(0, -1, 0));
    }).ElseIf(uv.z.greaterThan(1 - epsilon), ()=>{
        ret.assign($03ccd63b0299d6a7$var$vec3(0, 0, -1));
    }).Else(()=>{
        const step = 0.01;
        const x = texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(-step, 0.0, 0.0))).r.sub(texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(step, 0.0, 0.0))).r);
        const y = texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(0.0, -step, 0.0))).r.sub(texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(0.0, step, 0.0))).r);
        const z = texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(0.0, 0.0, -step))).r.sub(texture.sample(uv.add($03ccd63b0299d6a7$var$vec3(0.0, 0.0, step))).r);
        ret.assign($03ccd63b0299d6a7$var$vec3(x, y, z));
    });
    return ret.normalize();
});
/**
 * This type of uniform node represents a 3D texture.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$export$5449572dfc267b6b extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'Texture3DNode';
    }
    /**
	 * Constructs a new 3D texture node.
	 *
	 * @param {Data3DTexture} value - The 3D texture.
	 * @param {?Node<vec2|vec3>} [uvNode=null] - The uv node.
	 * @param {?Node<int>} [levelNode=null] - The level node.
	 */ constructor(value, uvNode = null, levelNode = null){
        super(value, uvNode, levelNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture3DNode = true;
    }
    /**
	 * Overwrites the default implementation to return a fixed value `'texture3D'`.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return 'texture3D';
    }
    /**
	 * Returns a default uv node which is in context of 3D textures a three-dimensional
	 * uv node.
	 *
	 * @return {Node<vec3>} The default uv node.
	 */ getDefaultUV() {
        return $03ccd63b0299d6a7$var$vec3(0.5, 0.5, 0.5);
    }
    /**
	 * Overwritten with an empty implementation since the `updateMatrix` flag is ignored
	 * for 3D textures. The uv transformation matrix is not applied to 3D textures.
	 *
	 * @param {boolean} value - The update toggle.
	 */ setUpdateMatrix() {}
    /**
	 * Generates the uv code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} uvNode - The uv node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateUV(builder, uvNode) {
        return uvNode.build(builder, this.sampler === true ? 'vec3' : 'ivec3');
    }
    /**
	 * Generates the offset code snippet.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {Node} offsetNode - The offset node to generate code for.
	 * @return {string} The generated code snippet.
	 */ generateOffset(builder, offsetNode) {
        return offsetNode.build(builder, 'ivec3');
    }
    /**
	 * Computes the normal for the given uv. These texture coordiantes represent a
	 * position inside the 3D texture. Unlike geometric normals, this normal
	 * represents a slope or gradient of scalar data inside the 3D texture.
	 *
	 * @param {Node<vec3>} uvNode - The uv node that defines a position in the 3D texture.
	 * @return {Node<vec3>} The normal representing the slope/gradient in the data.
	 */ normal(uvNode) {
        return $03ccd63b0299d6a7$var$normal({
            texture: this,
            uv: uvNode
        });
    }
}
/**
 * TSL function for creating a 3D texture node.
 *
 * @tsl
 * @function
 * @param {Data3DTexture} value - The 3D texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @returns {Texture3DNode}
 */ const $03ccd63b0299d6a7$var$texture3D = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$5449572dfc267b6b).setParameterLength(1, 3);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @param {?Node<float>} [biasNode=null] - The bias node.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$texture3DLoad = (...params)=>$03ccd63b0299d6a7$var$texture3D(...params).setSampler(false);
/**
 * TSL function for creating a texture node that fetches/loads texels without interpolation.
 *
 * @tsl
 * @function
 * @param {?(Texture|TextureNode)} [value=EmptyTexture] - The texture.
 * @param {?Node<vec3>} [uvNode=null] - The uv node.
 * @param {?Node<int>} [levelNode=null] - The level node.
 * @returns {TextureNode}
 */ const $03ccd63b0299d6a7$var$texture3DLevel = (value, uvNode, levelNode)=>$03ccd63b0299d6a7$var$texture3D(value, uvNode).level(levelNode);
/**
 * A special type of reference node that allows to link values in
 * `userData` fields to node objects.
 * ```js
 * sprite.userData.rotation = 1; // stores individual rotation per sprite
 *
 * const material = new THREE.SpriteNodeMaterial();
 * material.rotationNode = userData( 'rotation', 'float' );
 * ```
 * Since `UserDataNode` is extended from {@link ReferenceNode}, the node value
 * will automatically be updated when the `rotation` user data field changes.
 *
 * @augments ReferenceNode
 */ class $03ccd63b0299d6a7$export$5c6a4f8c7fea25ce extends $03ccd63b0299d6a7$export$81a720e7e5211d94 {
    static get type() {
        return 'UserDataNode';
    }
    /**
	 * Constructs a new user data node.
	 *
	 * @param {string} property - The property name that should be referenced by the node.
	 * @param {string} inputType - The node data type of the reference.
	 * @param {?Object} [userData=null] - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
	 */ constructor(property, inputType, userData = null){
        super(property, inputType, userData);
        /**
		 * A reference to the `userData` object. If not provided, the `userData`
		 * property of the 3D object that uses the node material is evaluated.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.userData = userData;
    }
    /**
	 * Overwritten to make sure {@link ReferenceNode#reference} points to the correct
	 * `userData` field.
	 *
	 * @param {(NodeFrame|NodeBuilder)} state - The current state to evaluate.
	 * @return {Object} A reference to the `userData` field.
	 */ updateReference(state) {
        this.reference = this.userData !== null ? this.userData : state.object.userData;
        return this.reference;
    }
}
/**
 * TSL function for creating a user data node.
 *
 * @tsl
 * @function
 * @param {string} name - The property name that should be referenced by the node.
 * @param {string} inputType - The node data type of the reference.
 * @param {?Object} userData - A reference to the `userData` object. If not provided, the `userData` property of the 3D object that uses the node material is evaluated.
 * @returns {UserDataNode}
 */ const $03ccd63b0299d6a7$var$userData = (name, inputType, userData)=>new $03ccd63b0299d6a7$export$5c6a4f8c7fea25ce(name, inputType, userData);
const $03ccd63b0299d6a7$var$_objectData = new WeakMap();
/**
 * A node for representing motion or velocity vectors. Foundation
 * for advanced post processing effects like motion blur or TRAA.
 *
 * The node keeps track of the model, view and projection matrices
 * of the previous frame and uses them to compute offsets in NDC space.
 * These offsets represent the final velocity.
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$9755d3219c797ef extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'VelocityNode';
    }
    /**
	 * Constructs a new vertex color node.
	 */ constructor(){
        super('vec2');
        /**
		 * The current projection matrix.
		 *
		 * @type {?Matrix4}
		 * @default null
		 */ this.projectionMatrix = null;
        /**
		 * Overwritten since velocity nodes are updated per object.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Overwritten since velocity nodes save data after the update.
		 *
		 * @type {string}
		 * @default 'object'
		 */ this.updateAfterType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT;
        /**
		 * Uniform node representing the previous model matrix in world space.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousModelWorldMatrix = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)());
        /**
		 * Uniform node representing the previous projection matrix.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousProjectionMatrix = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)()).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the previous view matrix.
		 *
		 * @type {UniformNode<mat4>}
		 * @default null
		 */ this.previousCameraViewMatrix = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)());
    }
    /**
	 * Sets the given projection matrix.
	 *
	 * @param {Matrix4} projectionMatrix - The projection matrix to set.
	 */ setProjectionMatrix(projectionMatrix) {
        this.projectionMatrix = projectionMatrix;
    }
    /**
	 * Updates velocity specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update({ frameId: frameId, camera: camera, object: object }) {
        const previousModelMatrix = $03ccd63b0299d6a7$var$getPreviousMatrix(object);
        this.previousModelWorldMatrix.value.copy(previousModelMatrix);
        //
        const cameraData = $03ccd63b0299d6a7$var$getData(camera);
        if (cameraData.frameId !== frameId) {
            cameraData.frameId = frameId;
            if (cameraData.previousProjectionMatrix === undefined) {
                cameraData.previousProjectionMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
                cameraData.previousCameraViewMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
                cameraData.currentProjectionMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
                cameraData.currentCameraViewMatrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
                cameraData.previousProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
                cameraData.previousCameraViewMatrix.copy(camera.matrixWorldInverse);
            } else {
                cameraData.previousProjectionMatrix.copy(cameraData.currentProjectionMatrix);
                cameraData.previousCameraViewMatrix.copy(cameraData.currentCameraViewMatrix);
            }
            cameraData.currentProjectionMatrix.copy(this.projectionMatrix || camera.projectionMatrix);
            cameraData.currentCameraViewMatrix.copy(camera.matrixWorldInverse);
            this.previousProjectionMatrix.value.copy(cameraData.previousProjectionMatrix);
            this.previousCameraViewMatrix.value.copy(cameraData.previousCameraViewMatrix);
        }
    }
    /**
	 * Overwritten to updated velocity specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateAfter({ object: object }) {
        $03ccd63b0299d6a7$var$getPreviousMatrix(object).copy(object.matrixWorld);
    }
    /**
	 * Implements the velocity computation based on the previous and current vertex data.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec2>} The motion vector.
	 */ setup() {
        const projectionMatrix = this.projectionMatrix === null ? $03ccd63b0299d6a7$var$cameraProjectionMatrix : $03ccd63b0299d6a7$var$uniform(this.projectionMatrix);
        const previousModelViewMatrix = this.previousCameraViewMatrix.mul(this.previousModelWorldMatrix);
        const clipPositionCurrent = projectionMatrix.mul($03ccd63b0299d6a7$var$modelViewMatrix).mul($03ccd63b0299d6a7$var$positionLocal);
        const clipPositionPrevious = this.previousProjectionMatrix.mul(previousModelViewMatrix).mul($03ccd63b0299d6a7$var$positionPrevious);
        const ndcPositionCurrent = clipPositionCurrent.xy.div(clipPositionCurrent.w);
        const ndcPositionPrevious = clipPositionPrevious.xy.div(clipPositionPrevious.w);
        const velocity = $03ccd63b0299d6a7$var$sub(ndcPositionCurrent, ndcPositionPrevious);
        return velocity;
    }
}
function $03ccd63b0299d6a7$var$getData(object) {
    let objectData = $03ccd63b0299d6a7$var$_objectData.get(object);
    if (objectData === undefined) {
        objectData = {};
        $03ccd63b0299d6a7$var$_objectData.set(object, objectData);
    }
    return objectData;
}
function $03ccd63b0299d6a7$var$getPreviousMatrix(object, index = 0) {
    const objectData = $03ccd63b0299d6a7$var$getData(object);
    let matrix = objectData[index];
    if (matrix === undefined) {
        objectData[index] = matrix = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
        objectData[index].copy(object.matrixWorld);
    }
    return matrix;
}
/**
 * TSL object that represents the velocity of a render pass.
 *
 * @tsl
 * @type {VelocityNode}
 */ const $03ccd63b0299d6a7$var$velocity = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeImmutable($03ccd63b0299d6a7$export$9755d3219c797ef);
/**
 * Computes a grayscale value for the given RGB color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color value to compute the grayscale for.
 * @return {Node<vec3>} The grayscale color.
 */ const $03ccd63b0299d6a7$var$grayscale = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    return $03ccd63b0299d6a7$var$luminance(color.rgb);
});
/**
 * Super-saturates or desaturates the given RGB color.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Specifies the amount of the conversion. A value under `1` desaturates the color, a value over `1` super-saturates it.
 * @return {Node<vec3>} The saturated color.
 */ const $03ccd63b0299d6a7$var$saturation = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, adjustment = $03ccd63b0299d6a7$var$float(1)])=>{
    return adjustment.mix($03ccd63b0299d6a7$var$luminance(color.rgb), color.rgb);
});
/**
 * Selectively enhance the intensity of less saturated RGB colors. Can result
 * in a more natural and visually appealing image with enhanced color depth
 * compared to {@link ColorAdjustment#saturation}.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Controls the intensity of the vibrance effect.
 * @return {Node<vec3>} The updated color.
 */ const $03ccd63b0299d6a7$var$vibrance = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, adjustment = $03ccd63b0299d6a7$var$float(1)])=>{
    const average = $03ccd63b0299d6a7$var$add(color.r, color.g, color.b).div(3.0);
    const mx = color.r.max(color.g.max(color.b));
    const amt = mx.sub(average).mul(adjustment).mul(-3);
    return $03ccd63b0299d6a7$var$mix(color.rgb, mx, amt);
});
/**
 * Updates the hue component of the given RGB color while preserving its luminance and saturation.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The input color.
 * @param {Node<float>} [adjustment=1] - Defines the degree of hue rotation in radians. A positive value rotates the hue clockwise, while a negative value rotates it counterclockwise.
 * @return {Node<vec3>} The updated color.
 */ const $03ccd63b0299d6a7$var$hue = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, adjustment = $03ccd63b0299d6a7$var$float(1)])=>{
    const k = $03ccd63b0299d6a7$var$vec3(0.57735, 0.57735, 0.57735);
    const cosAngle = adjustment.cos();
    return $03ccd63b0299d6a7$var$vec3(color.rgb.mul(cosAngle).add(k.cross(color.rgb).mul(adjustment.sin()).add(k.mul($03ccd63b0299d6a7$var$dot(k, color.rgb).mul(cosAngle.oneMinus())))));
});
/**
 * Computes the luminance for the given RGB color value.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color value to compute the luminance for.
 * @param {?Node<vec3>} luminanceCoefficients - The luminance coefficients. By default predefined values of the current working color space are used.
 * @return {Node<float>} The luminance.
 */ const $03ccd63b0299d6a7$var$luminance = (color, luminanceCoefficients = $03ccd63b0299d6a7$var$vec3((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getLuminanceCoefficients(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)())))=>$03ccd63b0299d6a7$var$dot(color, luminanceCoefficients);
/**
 * Color Decision List (CDL) v1.2
 *
 * Compact representation of color grading information, defined by slope, offset, power, and
 * saturation. The CDL should be typically be given input in a log space (such as LogC, ACEScc,
 * or AgX Log), and will return output in the same space. Output may require clamping >=0.
 *
 * @tsl
 * @function
 * @param {Node<vec4>} color Input (-Infinity < input < +Infinity)
 * @param {Node<vec3>} slope Slope (0 ≤ slope < +Infinity)
 * @param {Node<vec3>} offset Offset (-Infinity < offset < +Infinity; typically -1 < offset < 1)
 * @param {Node<vec3>} power Power (0 < power < +Infinity)
 * @param {Node<float>} saturation Saturation (0 ≤ saturation < +Infinity; typically 0 ≤ saturation < 4)
 * @param {Node<vec3>} luminanceCoefficients Luminance coefficients for saturation term, typically Rec. 709
 * @return {Node<vec4>} Output, -Infinity < output < +Infinity
 *
 * References:
 * - ASC CDL v1.2
 * - {@link https://blender.stackexchange.com/a/55239/43930}
 * - {@link https://docs.acescentral.com/specifications/acescc/}
 */ const $03ccd63b0299d6a7$var$cdl = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, slope = $03ccd63b0299d6a7$var$vec3(1), offset = $03ccd63b0299d6a7$var$vec3(0), power = $03ccd63b0299d6a7$var$vec3(1), saturation = $03ccd63b0299d6a7$var$float(1), // ASC CDL v1.2 explicitly requires Rec. 709 luminance coefficients.
luminanceCoefficients = $03ccd63b0299d6a7$var$vec3((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getLuminanceCoefficients(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(), (0, $9ddd7e9b53f7a2d4$export$42429b3acfb233a4)))])=>{
    // NOTE: The ASC CDL v1.2 defines a [0, 1] clamp on the slope+offset term, and another on the
    // saturation term. Per the ACEScc specification and Filament, limits may be omitted to support
    // values outside [0, 1], requiring a workaround for negative values in the power expression.
    const luma = color.rgb.dot($03ccd63b0299d6a7$var$vec3(luminanceCoefficients));
    const v = $03ccd63b0299d6a7$var$max$1(color.rgb.mul(slope).add(offset), 0.0).toVar();
    const pv = v.pow(power).toVar();
    $03ccd63b0299d6a7$var$If(v.r.greaterThan(0.0), ()=>{
        v.r.assign(pv.r);
    }); // eslint-disable-line
    $03ccd63b0299d6a7$var$If(v.g.greaterThan(0.0), ()=>{
        v.g.assign(pv.g);
    }); // eslint-disable-line
    $03ccd63b0299d6a7$var$If(v.b.greaterThan(0.0), ()=>{
        v.b.assign(pv.b);
    }); // eslint-disable-line
    v.assign(luma.add(v.sub(luma).mul(saturation)));
    return $03ccd63b0299d6a7$var$vec4(v.rgb, color.a);
});
/**
 * TSL function for creating a posterize effect which reduces the number of colors
 * in an image, resulting in a more blocky and stylized appearance.
 *
 * @tsl
 * @function
 * @param {Node} sourceNode - The input color.
 * @param {Node} stepsNode - Controls the intensity of the posterization effect. A lower number results in a more blocky appearance.
 * @returns {Node} The posterized color.
 */ const $03ccd63b0299d6a7$var$posterize = $03ccd63b0299d6a7$var$Fn(([source, steps])=>{
    return source.mul(steps).floor().div(steps);
});
let $03ccd63b0299d6a7$var$_sharedFramebuffer = null;
/**
 * `ViewportTextureNode` creates an internal texture for each node instance. This module
 * shares a texture across all instances of `ViewportSharedTextureNode`. It should
 * be the first choice when using data of the default/screen framebuffer for performance reasons.
 *
 * @augments ViewportTextureNode
 */ class $03ccd63b0299d6a7$export$1efcb5d20eaaf706 extends $03ccd63b0299d6a7$export$f873d674c2e6b04d {
    static get type() {
        return 'ViewportSharedTextureNode';
    }
    /**
	 * Constructs a new viewport shared texture node.
	 *
	 * @param {Node} [uvNode=screenUV] - The uv node.
	 * @param {?Node} [levelNode=null] - The level node.
	 */ constructor(uvNode = $03ccd63b0299d6a7$var$screenUV, levelNode = null){
        if ($03ccd63b0299d6a7$var$_sharedFramebuffer === null) $03ccd63b0299d6a7$var$_sharedFramebuffer = new (0, $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe)();
        super(uvNode, levelNode, $03ccd63b0299d6a7$var$_sharedFramebuffer);
    }
    /**
	 * Overwritten so the method always returns the unique shared
	 * framebuffer texture.
	 *
	 * @return {FramebufferTexture} The shared framebuffer texture.
	 */ getTextureForReference() {
        return $03ccd63b0299d6a7$var$_sharedFramebuffer;
    }
    updateReference() {
        return this;
    }
}
/**
 * TSL function for creating a shared viewport texture node.
 *
 * @tsl
 * @function
 * @param {?Node} [uvNode=screenUV] - The uv node.
 * @param {?Node} [levelNode=null] - The level node.
 * @returns {ViewportSharedTextureNode}
 */ const $03ccd63b0299d6a7$var$viewportSharedTexture = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$1efcb5d20eaaf706).setParameterLength(0, 2);
const $03ccd63b0299d6a7$var$_size = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
/**
 * Represents the texture of a pass node.
 *
 * @augments TextureNode
 */ class $03ccd63b0299d6a7$var$PassTextureNode extends $03ccd63b0299d6a7$export$2dd903bc9e8140bc {
    static get type() {
        return 'PassTextureNode';
    }
    /**
	 * Constructs a new pass texture node.
	 *
	 * @param {PassNode} passNode - The pass node.
	 * @param {Texture} texture - The output texture.
	 */ constructor(passNode, texture){
        super(texture);
        /**
		 * A reference to the pass node.
		 *
		 * @type {PassNode}
		 */ this.passNode = passNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @default true
		 * @readonly
		 */ this.isPassTextureNode = true;
        this.setUpdateMatrix(false);
    }
    setup(builder) {
        const properties = builder.getNodeProperties(this);
        properties.passNode = this.passNode;
        return super.setup(builder);
    }
    clone() {
        return new this.constructor(this.passNode, this.value);
    }
}
/**
 * An extension of `PassTextureNode` which allows to manage more than one
 * internal texture. Relevant for the `getPreviousTexture()` related API.
 *
 * @augments PassTextureNode
 */ class $03ccd63b0299d6a7$var$PassMultipleTextureNode extends $03ccd63b0299d6a7$var$PassTextureNode {
    static get type() {
        return 'PassMultipleTextureNode';
    }
    /**
	 * Constructs a new pass texture node.
	 *
	 * @param {PassNode} passNode - The pass node.
	 * @param {string} textureName - The output texture name.
	 * @param {boolean} [previousTexture=false] - Whether previous frame data should be used or not.
	 */ constructor(passNode, textureName, previousTexture = false){
        // null is passed to the super call since this class does not
        // use an external texture for rendering pass data into. Instead
        // the texture is managed by the pass node itself
        super(passNode, null);
        /**
		 * The output texture name.
		 *
		 * @type {string}
		 */ this.textureName = textureName;
        /**
		 * Whether previous frame data should be used or not.
		 *
		 * @type {boolean}
		 */ this.previousTexture = previousTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @default true
		 * @readonly
		 */ this.isPassMultipleTextureNode = true;
    }
    /**
	 * Updates the texture reference of this node.
	 */ updateTexture() {
        this.value = this.previousTexture ? this.passNode.getPreviousTexture(this.textureName) : this.passNode.getTexture(this.textureName);
    }
    setup(builder) {
        this.updateTexture();
        return super.setup(builder);
    }
    clone() {
        const newNode = new this.constructor(this.passNode, this.textureName, this.previousTexture);
        newNode.uvNode = this.uvNode;
        newNode.levelNode = this.levelNode;
        newNode.biasNode = this.biasNode;
        newNode.sampler = this.sampler;
        newNode.depthNode = this.depthNode;
        newNode.compareNode = this.compareNode;
        newNode.gradNode = this.gradNode;
        newNode.offsetNode = this.offsetNode;
        return newNode;
    }
}
/**
 * Represents a render pass (sometimes called beauty pass) in context of post processing.
 * This pass produces a render for the given scene and camera and can provide multiple outputs
 * via MRT for further processing.
 *
 * ```js
 * const postProcessing = new RenderPipeline( renderer );
 *
 * const scenePass = pass( scene, camera );
 *
 * postProcessing.outputNode = scenePass;
 * ```
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$1a977c3276cbac94 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'PassNode';
    }
    /**
	 * Constructs a new pass node.
	 *
	 * @param {('color'|'depth')} scope - The scope of the pass. The scope determines whether the node outputs color or depth.
	 * @param {Scene} scene - A reference to the scene.
	 * @param {Camera} camera - A reference to the camera.
	 * @param {Object} options - Options for the internal render target.
	 */ constructor(scope, scene, camera, options = {}){
        super('vec4');
        /**
		 * The scope of the pass. The scope determines whether the node outputs color or depth.
		 *
		 * @type {('color'|'depth')}
		 */ this.scope = scope;
        /**
		 * A reference to the scene.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * A reference to the camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * Options for the internal render target.
		 *
		 * @type {Object}
		 */ this.options = options;
        /**
		 * The pass's pixel ratio. Will be kept automatically kept in sync with the renderer's pixel ratio.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._pixelRatio = 1;
        /**
		 * The pass's pixel width. Will be kept automatically kept in sync with the renderer's width.
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._width = 1;
        /**
		 * The pass's pixel height. Will be kept automatically kept in sync with the renderer's height.
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._height = 1;
        const depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)();
        depthTexture.isRenderTargetTexture = true;
        //depthTexture.type = FloatType;
        depthTexture.name = 'depth';
        const renderTarget = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
            type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
            ...options
        });
        renderTarget.texture.name = 'output';
        renderTarget.depthTexture = depthTexture;
        /**
		 * The pass's render target.
		 *
		 * @type {RenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * An optional override material for the pass.
		 *
		 * @type {Material|null}
		 */ this.overrideMaterial = null;
        /**
		 * Whether the pass is transparent.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = true;
        /**
		 * Whether the pass is opaque.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.opaque = true;
        /**
		 * An optional global context for the pass.
		 *
		 * @type {ContextNode|null}
		 */ this.contextNode = null;
        /**
		 * A cache for the context node.
		 *
		 * @private
		 * @type {?Object}
		 * @default null
		 */ this._contextNodeCache = null;
        /**
		 * A dictionary holding the internal result textures.
		 *
		 * @private
		 * @type {Object<string, Texture>}
		 */ this._textures = {
            output: renderTarget.texture,
            depth: depthTexture
        };
        /**
		 * A dictionary holding the internal texture nodes.
		 *
		 * @private
		 * @type {Object<string, TextureNode>}
		 */ this._textureNodes = {};
        /**
		 * A dictionary holding the internal depth nodes.
		 *
		 * @private
		 * @type {Object}
		 */ this._linearDepthNodes = {};
        /**
		 * A dictionary holding the internal viewZ nodes.
		 *
		 * @private
		 * @type {Object}
		 */ this._viewZNodes = {};
        /**
		 * A dictionary holding the texture data of the previous frame.
		 * Used for computing velocity/motion vectors.
		 *
		 * @private
		 * @type {Object<string, Texture>}
		 */ this._previousTextures = {};
        /**
		 * A dictionary holding the texture nodes of the previous frame.
		 * Used for computing velocity/motion vectors.
		 *
		 * @private
		 * @type {Object<string, TextureNode>}
		 */ this._previousTextureNodes = {};
        /**
		 * The `near` property of the camera as a uniform.
		 *
		 * @private
		 * @type {UniformNode}
		 */ this._cameraNear = $03ccd63b0299d6a7$var$uniform(0);
        /**
		 * The `far` property of the camera as a uniform.
		 *
		 * @private
		 * @type {UniformNode}
		 */ this._cameraFar = $03ccd63b0299d6a7$var$uniform(0);
        /**
		 * A MRT node configuring the MRT settings.
		 *
		 * @private
		 * @type {?MRTNode}
		 * @default null
		 */ this._mrt = null;
        /**
		 * Layer object for configuring the camera that is used
		 * to produce the pass.
		 *
		 * @private
		 * @type {?Layers}
		 * @default null
		 */ this._layers = null;
        /**
		 * Scales the resolution of the internal render target.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._resolutionScale = 1;
        /**
		 * Custom viewport definition.
		 *
		 * @private
		 * @type {?Vector4}
		 * @default null
		 */ this._viewport = null;
        /**
		 * Custom scissor definition.
		 *
		 * @private
		 * @type {?Vector4}
		 * @default null
		 */ this._scissor = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPassNode = true;
        /**
		 * The `updateBeforeType` is set to `NodeUpdateType.FRAME` since the node renders the
		 * scene once per frame in its {@link PassNode#updateBefore} method.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Sets the resolution scale for the pass.
	 * The resolution scale is a factor that is multiplied with the renderer's width and height.
	 *
	 * @param {number} resolutionScale - The resolution scale to set. A value of `1` means full resolution.
	 * @return {PassNode} A reference to this pass.
	 */ setResolutionScale(resolutionScale) {
        this._resolutionScale = resolutionScale;
        return this;
    }
    /**
	 * Gets the current resolution scale of the pass.
	 *
	 * @return {number} The current resolution scale. A value of `1` means full resolution.
	 */ getResolutionScale() {
        return this._resolutionScale;
    }
    /**
	 * Sets the resolution for the pass.
	 * The resolution is a factor that is multiplied with the renderer's width and height.
	 *
	 * @param {number} resolution - The resolution to set. A value of `1` means full resolution.
	 * @return {PassNode} A reference to this pass.
	 * @deprecated since r181. Use {@link PassNode#setResolutionScale `setResolutionScale()`} instead.
	 */ setResolution(resolution) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('PassNode: .setResolution() is deprecated. Use .setResolutionScale() instead.');
        return this.setResolutionScale(resolution);
    }
    /**
	 * Gets the current resolution of the pass.
	 *
	 * @return {number} The current resolution. A value of `1` means full resolution.
	 * @deprecated since r181. Use {@link PassNode#getResolutionScale `getResolutionScale()`} instead.
	 */ getResolution() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('PassNode: .getResolution() is deprecated. Use .getResolutionScale() instead.');
        return this.getResolutionScale();
    }
    /**
	 * Sets the layer configuration that should be used when rendering the pass.
	 *
	 * @param {Layers} layers - The layers object to set.
	 * @return {PassNode} A reference to this pass.
	 */ setLayers(layers) {
        this._layers = layers;
        return this;
    }
    /**
	 * Gets the current layer configuration of the pass.
	 *
	 * @return {?Layers} .
	 */ getLayers() {
        return this._layers;
    }
    /**
	 * Sets the given MRT node to setup MRT for this pass.
	 *
	 * @param {MRTNode} mrt - The MRT object.
	 * @return {PassNode} A reference to this pass.
	 */ setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    /**
	 * Returns the current MRT node.
	 *
	 * @return {MRTNode} The current MRT node.
	 */ getMRT() {
        return this._mrt;
    }
    /**
	 * Returns the texture for the given output name.
	 *
	 * @param {string} name - The output name to get the texture for.
	 * @return {Texture} The texture.
	 */ getTexture(name) {
        let texture = this._textures[name];
        if (texture === undefined) {
            const refTexture = this.renderTarget.texture;
            texture = refTexture.clone();
            texture.name = name;
            this._textures[name] = texture;
            this.renderTarget.textures.push(texture);
        }
        return texture;
    }
    /**
	 * Returns the texture holding the data of the previous frame for the given output name.
	 *
	 * @param {string} name - The output name to get the texture for.
	 * @return {Texture} The texture holding the data of the previous frame.
	 */ getPreviousTexture(name) {
        let texture = this._previousTextures[name];
        if (texture === undefined) {
            texture = this.getTexture(name).clone();
            this._previousTextures[name] = texture;
        }
        return texture;
    }
    /**
	 * Switches current and previous textures for the given output name.
	 *
	 * @param {string} name - The output name.
	 */ toggleTexture(name) {
        const prevTexture = this._previousTextures[name];
        if (prevTexture !== undefined) {
            const texture = this._textures[name];
            const index = this.renderTarget.textures.indexOf(texture);
            this.renderTarget.textures[index] = prevTexture;
            this._textures[name] = prevTexture;
            this._previousTextures[name] = texture;
            this._textureNodes[name].updateTexture();
            this._previousTextureNodes[name].updateTexture();
        }
    }
    /**
	 * Returns the texture node for the given output name.
	 *
	 * @param {string} [name='output'] - The output name to get the texture node for.
	 * @return {TextureNode} The texture node.
	 */ getTextureNode(name = 'output') {
        let textureNode = this._textureNodes[name];
        if (textureNode === undefined) {
            textureNode = new $03ccd63b0299d6a7$var$PassMultipleTextureNode(this, name);
            textureNode.updateTexture();
            this._textureNodes[name] = textureNode;
        }
        return textureNode;
    }
    /**
	 * Returns the previous texture node for the given output name.
	 *
	 * @param {string} [name='output'] - The output name to get the previous texture node for.
	 * @return {TextureNode} The previous texture node.
	 */ getPreviousTextureNode(name = 'output') {
        let textureNode = this._previousTextureNodes[name];
        if (textureNode === undefined) {
            if (this._textureNodes[name] === undefined) this.getTextureNode(name);
            textureNode = new $03ccd63b0299d6a7$var$PassMultipleTextureNode(this, name, true);
            textureNode.updateTexture();
            this._previousTextureNodes[name] = textureNode;
        }
        return textureNode;
    }
    /**
	 * Returns a viewZ node of this pass.
	 *
	 * @param {string} [name='depth'] - The output name to get the viewZ node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
	 * @return {Node} The viewZ node.
	 */ getViewZNode(name = 'depth') {
        let viewZNode = this._viewZNodes[name];
        if (viewZNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            this._viewZNodes[name] = viewZNode = $03ccd63b0299d6a7$var$perspectiveDepthToViewZ(this.getTextureNode(name), cameraNear, cameraFar);
        }
        return viewZNode;
    }
    /**
	 * Returns a linear depth node of this pass.
	 *
	 * @param {string} [name='depth'] - The output name to get the linear depth node for. In most cases the default `'depth'` can be used however the parameter exists for custom depth outputs.
	 * @return {Node} The linear depth node.
	 */ getLinearDepthNode(name = 'depth') {
        let linearDepthNode = this._linearDepthNodes[name];
        if (linearDepthNode === undefined) {
            const cameraNear = this._cameraNear;
            const cameraFar = this._cameraFar;
            const viewZNode = this.getViewZNode(name);
            // TODO: just if ( builder.camera.isPerspectiveCamera )
            this._linearDepthNodes[name] = linearDepthNode = $03ccd63b0299d6a7$var$viewZToOrthographicDepth(viewZNode, cameraNear, cameraFar);
        }
        return linearDepthNode;
    }
    /**
	 * Precompiles the pass.
	 *
	 * Note that this method must be called after the pass configuration is complete.
	 * So calls like `setMRT()` and `getTextureNode()` must proceed the precompilation.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the compile has been finished.
	 * @see {@link Renderer#compileAsync}
	 */ async compileAsync(renderer) {
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        renderer.setRenderTarget(this.renderTarget);
        renderer.setMRT(this._mrt);
        await renderer.compileAsync(this.scene, this.camera);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.setMRT(currentMRT);
    }
    setup({ renderer: renderer }) {
        this.renderTarget.samples = this.options.samples === undefined ? renderer.samples : this.options.samples;
        this.renderTarget.texture.type = renderer.getOutputBufferType();
        if (renderer.reversedDepthBuffer === true) this.renderTarget.depthTexture.type = (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596);
        return this.scope === $03ccd63b0299d6a7$export$1a977c3276cbac94.COLOR ? this.getTextureNode() : this.getLinearDepthNode();
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const { scene: scene } = this;
        let camera;
        let pixelRatio;
        const outputRenderTarget = renderer.getOutputRenderTarget();
        if (outputRenderTarget && outputRenderTarget.isXRRenderTarget === true) {
            pixelRatio = 1;
            camera = renderer.xr.getCamera();
            renderer.xr.updateCamera(camera);
            $03ccd63b0299d6a7$var$_size.set(outputRenderTarget.width, outputRenderTarget.height);
        } else {
            camera = this.camera;
            pixelRatio = renderer.getPixelRatio();
            renderer.getSize($03ccd63b0299d6a7$var$_size);
        }
        this._pixelRatio = pixelRatio;
        this.setSize($03ccd63b0299d6a7$var$_size.width, $03ccd63b0299d6a7$var$_size.height);
        const currentRenderTarget = renderer.getRenderTarget();
        const currentMRT = renderer.getMRT();
        const currentAutoClear = renderer.autoClear;
        const currentTransparent = renderer.transparent;
        const currentOpaque = renderer.opaque;
        const currentMask = camera.layers.mask;
        const currentContextNode = renderer.contextNode;
        const currentOverrideMaterial = scene.overrideMaterial;
        this._cameraNear.value = camera.near;
        this._cameraFar.value = camera.far;
        if (this._layers !== null) camera.layers.mask = this._layers.mask;
        for(const name in this._previousTextures)this.toggleTexture(name);
        if (this.overrideMaterial !== null) scene.overrideMaterial = this.overrideMaterial;
        renderer.setRenderTarget(this.renderTarget);
        renderer.setMRT(this._mrt);
        renderer.autoClear = true;
        renderer.transparent = this.transparent;
        renderer.opaque = this.opaque;
        if (this.contextNode !== null) {
            if (this._contextNodeCache === null || this._contextNodeCache.version !== this.version) this._contextNodeCache = {
                version: this.version,
                context: $03ccd63b0299d6a7$var$context({
                    ...renderer.contextNode.getFlowContextData(),
                    ...this.contextNode.getFlowContextData()
                })
            };
            renderer.contextNode = this._contextNodeCache.context;
        }
        const currentSceneName = scene.name;
        scene.name = this.name ? this.name : scene.name;
        renderer.render(scene, camera);
        scene.name = currentSceneName;
        scene.overrideMaterial = currentOverrideMaterial;
        renderer.setRenderTarget(currentRenderTarget);
        renderer.setMRT(currentMRT);
        renderer.autoClear = currentAutoClear;
        renderer.transparent = currentTransparent;
        renderer.opaque = currentOpaque;
        renderer.contextNode = currentContextNode;
        camera.layers.mask = currentMask;
    }
    /**
	 * Sets the size of the pass's render target. Honors the pixel ratio.
	 *
	 * @param {number} width - The width to set.
	 * @param {number} height - The height to set.
	 */ setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = Math.floor(this._width * this._pixelRatio * this._resolutionScale);
        const effectiveHeight = Math.floor(this._height * this._pixelRatio * this._resolutionScale);
        this.renderTarget.setSize(effectiveWidth, effectiveHeight);
        // scissor
        if (this._scissor !== null) {
            this.renderTarget.scissor.copy(this._scissor).multiplyScalar(this._pixelRatio * this._resolutionScale).floor();
            this.renderTarget.scissorTest = true;
        } else this.renderTarget.scissorTest = false;
        // viewport
        if (this._viewport !== null) this.renderTarget.viewport.copy(this._viewport).multiplyScalar(this._pixelRatio * this._resolutionScale).floor();
    }
    /**
	 * This method allows to define the pass's scissor rectangle. By default, the scissor rectangle is kept
	 * in sync with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
	 * with `null` as the single argument.
	 *
	 * @param {?(number | Vector4)} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        if (x === null) this._scissor = null;
        else {
            if (this._scissor === null) this._scissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
            if (x.isVector4) this._scissor.copy(x);
            else this._scissor.set(x, y, width, height);
        }
    }
    /**
	 * This method allows to define the pass's viewport. By default, the viewport is kept in sync
	 * with the pass's dimensions. To reverse the process and use auto-sizing again, call the method
	 * with `null` as the single argument.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 */ setViewport(x, y, width, height) {
        if (x === null) this._viewport = null;
        else {
            if (this._viewport === null) this._viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
            if (x.isVector4) this._viewport.copy(x);
            else this._viewport.set(x, y, width, height);
        }
    }
    /**
	 * Sets the pixel ratio the pass's render target and updates the size.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    /**
	 * Frees internal resources. Should be called when the node is no longer in use.
	 */ dispose() {
        this.renderTarget.dispose();
    }
}
/**
 * @static
 * @type {'color'}
 * @default 'color'
 */ $03ccd63b0299d6a7$export$1a977c3276cbac94.COLOR = 'color';
/**
 * @static
 * @type {'depth'}
 * @default 'depth'
 */ $03ccd63b0299d6a7$export$1a977c3276cbac94.DEPTH = 'depth';
/**
 * TSL function for creating a pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Object} options - Options for the internal render target.
 * @returns {PassNode}
 */ const $03ccd63b0299d6a7$var$pass = (scene, camera, options)=>new $03ccd63b0299d6a7$export$1a977c3276cbac94($03ccd63b0299d6a7$export$1a977c3276cbac94.COLOR, scene, camera, options);
/**
 * TSL function for creating a pass texture node.
 *
 * @tsl
 * @function
 * @param {PassNode} pass - The pass node.
 * @param {Texture} texture - The output texture.
 * @returns {PassTextureNode}
 */ const $03ccd63b0299d6a7$var$passTexture = (pass, texture)=>new $03ccd63b0299d6a7$var$PassTextureNode(pass, texture);
/**
 * TSL function for creating a depth pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Object} options - Options for the internal render target.
 * @returns {PassNode}
 */ const $03ccd63b0299d6a7$var$depthPass = (scene, camera, options)=>new $03ccd63b0299d6a7$export$1a977c3276cbac94($03ccd63b0299d6a7$export$1a977c3276cbac94.DEPTH, scene, camera, options);
/**
 * Represents a render pass for producing a toon outline effect on compatible objects.
 * Only 3D objects with materials of type `MeshToonMaterial` and `MeshToonNodeMaterial`
 * will receive the outline.
 *
 * ```js
 * const postProcessing = new RenderPipeline( renderer );
 *
 * const scenePass = toonOutlinePass( scene, camera );
 *
 * postProcessing.outputNode = scenePass;
 * ```
 * @augments PassNode
 */ class $03ccd63b0299d6a7$export$60ef0b3e8999f37 extends $03ccd63b0299d6a7$export$1a977c3276cbac94 {
    static get type() {
        return 'ToonOutlinePassNode';
    }
    /**
	 * Constructs a new outline pass node.
	 *
	 * @param {Scene} scene - A reference to the scene.
	 * @param {Camera} camera - A reference to the camera.
	 * @param {Node} colorNode - Defines the outline's color.
	 * @param {Node} thicknessNode - Defines the outline's thickness.
	 * @param {Node} alphaNode - Defines the outline's alpha.
	 */ constructor(scene, camera, colorNode, thicknessNode, alphaNode){
        super($03ccd63b0299d6a7$export$1a977c3276cbac94.COLOR, scene, camera);
        /**
		 * Defines the outline's color.
		 *
		 * @type {Node}
		 */ this.colorNode = colorNode;
        /**
		 * Defines the outline's thickness.
		 *
		 * @type {Node}
		 */ this.thicknessNode = thicknessNode;
        /**
		 * Defines the outline's alpha.
		 *
		 * @type {Node}
		 */ this.alphaNode = alphaNode;
        /**
		 * An internal material cache.
		 *
		 * @private
		 * @type {WeakMap<Material, NodeMaterial>}
		 */ this._materialCache = new WeakMap();
        /**
		 * The name of this pass.
		 *
		 * @type {string}
		 * @default 'Outline Pass'
		 */ this.name = 'Outline Pass';
    }
    updateBefore(frame) {
        const { renderer: renderer } = frame;
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        renderer.setRenderObjectFunction((object, scene, camera, geometry, material, group, lightsNode, clippingContext)=>{
            // only render outline for supported materials
            if (material.isMeshToonMaterial || material.isMeshToonNodeMaterial) {
                if (material.wireframe === false) {
                    const outlineMaterial = this._getOutlineMaterial(material);
                    renderer.renderObject(object, scene, camera, geometry, outlineMaterial, group, lightsNode, clippingContext);
                }
            }
            // default
            renderer.renderObject(object, scene, camera, geometry, material, group, lightsNode, clippingContext);
        });
        super.updateBefore(frame);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
    }
    /**
	 * Creates the material used for outline rendering.
	 *
	 * @private
	 * @return {NodeMaterial} The outline material.
	 */ _createMaterial() {
        const material = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
        material.isMeshToonOutlineMaterial = true;
        material.name = 'Toon_Outline';
        material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        // vertex node
        const outlineNormal = $03ccd63b0299d6a7$var$normalLocal.negate();
        const mvp = $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul($03ccd63b0299d6a7$var$modelViewMatrix);
        const ratio = $03ccd63b0299d6a7$var$float(1.0); // TODO: support outline thickness ratio for each vertex
        const pos = mvp.mul($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$positionLocal, 1.0));
        const pos2 = mvp.mul($03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$positionLocal.add(outlineNormal), 1.0));
        const norm = $03ccd63b0299d6a7$var$normalize(pos.sub(pos2)); // NOTE: subtract pos2 from pos because BackSide objectNormal is negative
        material.vertexNode = pos.add(norm.mul(this.thicknessNode).mul(pos.w).mul(ratio));
        // color node
        material.colorNode = $03ccd63b0299d6a7$var$vec4(this.colorNode, this.alphaNode);
        return material;
    }
    /**
	 * For the given toon material, this method returns a corresponding
	 * outline material.
	 *
	 * @private
	 * @param {(MeshToonMaterial|MeshToonNodeMaterial)} originalMaterial - The toon material.
	 * @return {NodeMaterial} The outline material.
	 */ _getOutlineMaterial(originalMaterial) {
        let outlineMaterial = this._materialCache.get(originalMaterial);
        if (outlineMaterial === undefined) {
            outlineMaterial = this._createMaterial();
            this._materialCache.set(originalMaterial, outlineMaterial);
        }
        return outlineMaterial;
    }
}
/**
 * TSL function for creating a toon outline pass node.
 *
 * @tsl
 * @function
 * @param {Scene} scene - A reference to the scene.
 * @param {Camera} camera - A reference to the camera.
 * @param {Color} color - Defines the outline's color.
 * @param {number} [thickness=0.003] - Defines the outline's thickness.
 * @param {number} [alpha=1] - Defines the outline's alpha.
 * @returns {ToonOutlinePassNode}
 */ const $03ccd63b0299d6a7$var$toonOutlinePass = (scene, camera, color = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)(0, 0, 0), thickness = 0.003, alpha = 1)=>new $03ccd63b0299d6a7$export$60ef0b3e8999f37(scene, camera, $03ccd63b0299d6a7$var$nodeObject(color), $03ccd63b0299d6a7$var$nodeObject(thickness), $03ccd63b0299d6a7$var$nodeObject(alpha));
/**
 * Linear tone mapping, exposure only.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$linearToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    return color.mul(exposure).clamp();
}).setLayout({
    name: 'linearToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Reinhard tone mapping.
 *
 * Reference: {@link https://www.cs.utah.edu/docs/techreports/2002/pdf/UUCS-02-001.pdf}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$reinhardToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    color = color.mul(exposure);
    return color.div(color.add(1.0)).clamp();
}).setLayout({
    name: 'reinhardToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Cineon tone mapping.
 *
 * Reference: {@link http://filmicworlds.com/blog/filmic-tonemapping-operators/}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$cineonToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    // filmic operator by Jim Hejl and Richard Burgess-Dawson
    color = color.mul(exposure);
    color = color.sub(0.004).max(0.0);
    const a = color.mul(color.mul(6.2).add(0.5));
    const b = color.mul(color.mul(6.2).add(1.7)).add(0.06);
    return a.div(b).pow(2.2);
}).setLayout({
    name: 'cineonToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
// source: https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs
const $03ccd63b0299d6a7$var$RRTAndODTFit = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color])=>{
    const a = color.mul(color.add(0.0245786)).sub(0.000090537);
    const b = color.mul(color.add(0.4329510).mul(0.983729)).add(0.238081);
    return a.div(b);
});
/**
 * ACESFilmic tone mapping.
 *
 * Reference: {@link https://github.com/selfshadow/ltc_code/blob/master/webgl/shaders/ltc/ltc_blit.fs}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$acesFilmicToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    // sRGB => XYZ => D65_2_D60 => AP1 => RRT_SAT
    const ACESInputMat = $03ccd63b0299d6a7$var$mat3(0.59719, 0.35458, 0.04823, 0.07600, 0.90834, 0.01566, 0.02840, 0.13383, 0.83777);
    // ODT_SAT => XYZ => D60_2_D65 => sRGB
    const ACESOutputMat = $03ccd63b0299d6a7$var$mat3(1.60475, -0.53108, -0.07367, -0.10208, 1.10813, -0.00605, -0.00327, -0.07276, 1.07602);
    color = color.mul(exposure).div(0.6);
    color = ACESInputMat.mul(color);
    // Apply RRT and ODT
    color = $03ccd63b0299d6a7$var$RRTAndODTFit(color);
    color = ACESOutputMat.mul(color);
    // Clamp to [0, 1]
    return color.clamp();
}).setLayout({
    name: 'acesFilmicToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$LINEAR_REC2020_TO_LINEAR_SRGB = /*@__PURE__*/ $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(1.6605, -0.1246, -0.0182), $03ccd63b0299d6a7$var$vec3(-0.5876, 1.1329, -0.1006), $03ccd63b0299d6a7$var$vec3(-0.0728, -0.0083, 1.1187));
const $03ccd63b0299d6a7$var$LINEAR_SRGB_TO_LINEAR_REC2020 = /*@__PURE__*/ $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(0.6274, 0.0691, 0.0164), $03ccd63b0299d6a7$var$vec3(0.3293, 0.9195, 0.0880), $03ccd63b0299d6a7$var$vec3(0.0433, 0.0113, 0.8956));
const $03ccd63b0299d6a7$var$agxDefaultContrastApprox = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable])=>{
    const x = $03ccd63b0299d6a7$var$vec3(x_immutable).toVar();
    const x2 = $03ccd63b0299d6a7$var$vec3(x.mul(x)).toVar();
    const x4 = $03ccd63b0299d6a7$var$vec3(x2.mul(x2)).toVar();
    return $03ccd63b0299d6a7$var$float(15.5).mul(x4.mul(x2)).sub($03ccd63b0299d6a7$var$mul(40.14, x4.mul(x))).add($03ccd63b0299d6a7$var$mul(31.96, x4).sub($03ccd63b0299d6a7$var$mul(6.868, x2.mul(x))).add($03ccd63b0299d6a7$var$mul(0.4298, x2).add($03ccd63b0299d6a7$var$mul(0.1191, x).sub(0.00232))));
});
/**
 * AgX tone mapping.
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$agxToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    const colortone = $03ccd63b0299d6a7$var$vec3(color).toVar();
    const AgXInsetMatrix = $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(0.856627153315983, 0.137318972929847, 0.11189821299995), $03ccd63b0299d6a7$var$vec3(0.0951212405381588, 0.761241990602591, 0.0767994186031903), $03ccd63b0299d6a7$var$vec3(0.0482516061458583, 0.101439036467562, 0.811302368396859));
    const AgXOutsetMatrix = $03ccd63b0299d6a7$var$mat3($03ccd63b0299d6a7$var$vec3(1.1271005818144368, -0.1413297634984383, -0.14132976349843826), $03ccd63b0299d6a7$var$vec3(-0.11060664309660323, 1.157823702216272, -0.11060664309660294), $03ccd63b0299d6a7$var$vec3(-0.016493938717834573, -0.016493938717834257, 1.2519364065950405));
    const AgxMinEv = $03ccd63b0299d6a7$var$float(-12.47393);
    const AgxMaxEv = $03ccd63b0299d6a7$var$float(4.026069);
    colortone.mulAssign(exposure);
    colortone.assign($03ccd63b0299d6a7$var$LINEAR_SRGB_TO_LINEAR_REC2020.mul(colortone));
    colortone.assign(AgXInsetMatrix.mul(colortone));
    colortone.assign($03ccd63b0299d6a7$var$max$1(colortone, 1e-10));
    colortone.assign($03ccd63b0299d6a7$var$log2(colortone));
    colortone.assign(colortone.sub(AgxMinEv).div(AgxMaxEv.sub(AgxMinEv)));
    colortone.assign($03ccd63b0299d6a7$var$clamp(colortone, 0.0, 1.0));
    colortone.assign($03ccd63b0299d6a7$var$agxDefaultContrastApprox(colortone));
    colortone.assign(AgXOutsetMatrix.mul(colortone));
    colortone.assign($03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$vec3(0.0), colortone), $03ccd63b0299d6a7$var$vec3(2.2)));
    colortone.assign($03ccd63b0299d6a7$var$LINEAR_REC2020_TO_LINEAR_SRGB.mul(colortone));
    colortone.assign($03ccd63b0299d6a7$var$clamp(colortone, 0.0, 1.0));
    return colortone;
}).setLayout({
    name: 'agxToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * Neutral tone mapping.
 *
 * Reference: {@link https://modelviewer.dev/examples/tone-mapping}
 *
 * @tsl
 * @function
 * @param {Node<vec3>} color - The color that should be tone mapped.
 * @param {Node<float>} exposure - The exposure.
 * @return {Node<vec3>} The tone mapped color.
 */ const $03ccd63b0299d6a7$var$neutralToneMapping = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color, exposure])=>{
    const StartCompression = $03ccd63b0299d6a7$var$float(0.76);
    const Desaturation = $03ccd63b0299d6a7$var$float(0.15);
    color = color.mul(exposure);
    const x = $03ccd63b0299d6a7$var$min$1(color.r, $03ccd63b0299d6a7$var$min$1(color.g, color.b));
    const offset = $03ccd63b0299d6a7$var$select(x.lessThan(0.08), x.sub($03ccd63b0299d6a7$var$mul(6.25, x.mul(x))), 0.04);
    color.subAssign(offset);
    const peak = $03ccd63b0299d6a7$var$max$1(color.r, $03ccd63b0299d6a7$var$max$1(color.g, color.b));
    $03ccd63b0299d6a7$var$If(peak.lessThan(StartCompression), ()=>{
        return color;
    });
    const d = $03ccd63b0299d6a7$var$sub(1, StartCompression);
    const newPeak = $03ccd63b0299d6a7$var$sub(1, d.mul(d).div(peak.add(d.sub(StartCompression))));
    color.mulAssign(newPeak.div(peak));
    const g = $03ccd63b0299d6a7$var$sub(1, $03ccd63b0299d6a7$var$div(1, Desaturation.mul(peak.sub(newPeak)).add(1)));
    return $03ccd63b0299d6a7$var$mix(color, $03ccd63b0299d6a7$var$vec3(newPeak), g);
}).setLayout({
    name: 'neutralToneMapping',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        },
        {
            name: 'exposure',
            type: 'float'
        }
    ]
});
/**
 * This class represents native code sections. It is the base
 * class for modules like {@link FunctionNode} which allows to implement
 * functions with native shader languages.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$347eb46a3090e941 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'CodeNode';
    }
    /**
	 * Constructs a new code node.
	 *
	 * @param {string} [code=''] - The native code.
	 * @param {Array<Node>} [includes=[]] - An array of includes.
	 * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
	 */ constructor(code = '', includes = [], language = ''){
        super('code');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCodeNode = true;
        /**
		 * This flag is used for global cache.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
        /**
		 * The native code.
		 *
		 * @type {string}
		 * @default ''
		 */ this.code = code;
        /**
		 * An array of includes
		 *
		 * @type {Array<Node>}
		 * @default []
		 */ this.includes = includes;
        /**
		 * The used language.
		 *
		 * @type {('js'|'wgsl'|'glsl')}
		 * @default ''
		 */ this.language = language;
    }
    /**
	 * Sets the includes of this code node.
	 *
	 * @param {Array<Node>} includes - The includes to set.
	 * @return {CodeNode} A reference to this node.
	 */ setIncludes(includes) {
        this.includes = includes;
        return this;
    }
    /**
	 * Returns the includes of this code node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Array<Node>} The includes.
	 */ getIncludes() {
        return this.includes;
    }
    generate(builder) {
        const includes = this.getIncludes(builder);
        for (const include of includes)include.build(builder);
        const nodeCode = builder.getCodeFromNode(this, this.getNodeType(builder));
        nodeCode.code = this.code;
        return nodeCode.code;
    }
    serialize(data) {
        super.serialize(data);
        data.code = this.code;
        data.language = this.language;
    }
    deserialize(data) {
        super.deserialize(data);
        this.code = data.code;
        this.language = data.language;
    }
}
/**
 * TSL function for creating a code node.
 *
 * @tsl
 * @function
 * @param {string} [code] - The native code.
 * @param {?Array<Node>} [includes=[]] - An array of includes.
 * @param {?('js'|'wgsl'|'glsl')} [language=''] - The used language.
 * @returns {CodeNode}
 */ const $03ccd63b0299d6a7$var$code = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$347eb46a3090e941).setParameterLength(1, 3);
/**
 * TSL function for creating a JS code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $03ccd63b0299d6a7$var$js = (src, includes)=>$03ccd63b0299d6a7$var$code(src, includes, 'js');
/**
 * TSL function for creating a WGSL code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $03ccd63b0299d6a7$var$wgsl = (src, includes)=>$03ccd63b0299d6a7$var$code(src, includes, 'wgsl');
/**
 * TSL function for creating a GLSL code node.
 *
 * @tsl
 * @function
 * @param {string} src - The native code.
 * @param {Array<Node>} includes - An array of includes.
 * @returns {CodeNode}
 */ const $03ccd63b0299d6a7$var$glsl = (src, includes)=>$03ccd63b0299d6a7$var$code(src, includes, 'glsl');
/**
 * This class represents a native shader function. It can be used to implement
 * certain aspects of a node material with native shader code. There are two predefined
 * TSL functions for easier usage.
 *
 * - `wgslFn`: Creates a WGSL function node.
 * - `glslFn`: Creates a GLSL function node.
 *
 * A basic example with one include looks like so:
 *
 * ```js
 * const desaturateWGSLFn = wgslFn( `
 *	fn desaturate( color:vec3<f32> ) -> vec3<f32> {
 *		let lum = vec3<f32>( 0.299, 0.587, 0.114 );
 *		return vec3<f32>( dot( lum, color ) );
 *	}`
 *);
 * const someWGSLFn = wgslFn( `
 *	fn someFn( color:vec3<f32> ) -> vec3<f32> {
 * 		return desaturate( color );
 * 	}
 * `, [ desaturateWGSLFn ] );
 * material.colorNode = someWGSLFn( { color: texture( map ) } );
 *```
 * @augments CodeNode
 */ class $03ccd63b0299d6a7$export$f2972be796679c12 extends $03ccd63b0299d6a7$export$347eb46a3090e941 {
    static get type() {
        return 'FunctionNode';
    }
    /**
	 * Constructs a new function node.
	 *
	 * @param {string} [code=''] - The native code.
	 * @param {Array<Node>} [includes=[]] - An array of includes.
	 * @param {('js'|'wgsl'|'glsl')} [language=''] - The used language.
	 */ constructor(code = '', includes = [], language = ''){
        super(code, includes, language);
    }
    /**
	 * Returns the type of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The type.
	 */ generateNodeType(builder) {
        return this.getNodeFunction(builder).type;
    }
    /**
	 * Returns the type of a member of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @param {string} name - The name of the member.
	 * @return {string} The type of the member.
	 */ getMemberType(builder, name) {
        const type = this.getNodeType(builder);
        const structType = builder.getStructTypeNode(type);
        return structType.getMemberType(builder, name);
    }
    /**
	 * Returns the inputs of this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {Array<NodeFunctionInput>} The inputs.
	 */ getInputs(builder) {
        return this.getNodeFunction(builder).inputs;
    }
    /**
	 * Returns the node function for this function node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {NodeFunction} The node function.
	 */ getNodeFunction(builder) {
        const nodeData = builder.getDataFromNode(this);
        let nodeFunction = nodeData.nodeFunction;
        if (nodeFunction === undefined) {
            nodeFunction = builder.parser.parseFunction(this.code);
            nodeData.nodeFunction = nodeFunction;
        }
        return nodeFunction;
    }
    generate(builder, output) {
        super.generate(builder);
        const nodeFunction = this.getNodeFunction(builder);
        const name = nodeFunction.name;
        const type = nodeFunction.type;
        const nodeCode = builder.getCodeFromNode(this, type);
        if (name !== '') // use a custom property name
        nodeCode.name = name;
        const propertyName = builder.getPropertyName(nodeCode);
        const code = this.getNodeFunction(builder).getCode(propertyName);
        nodeCode.code = code + '\n';
        if (output === 'property') return propertyName;
        else return builder.format(`${propertyName}()`, type, output);
    }
}
const $03ccd63b0299d6a7$var$nativeFn = (code, includes = [], language = '')=>{
    for(let i = 0; i < includes.length; i++){
        const include = includes[i];
        // TSL Function: glslFn, wgslFn
        if (typeof include === 'function') includes[i] = include.functionNode;
    }
    const functionNode = new $03ccd63b0299d6a7$export$f2972be796679c12(code, includes, language);
    const fn = (...params)=>functionNode.call(...params);
    fn.functionNode = functionNode;
    return fn;
};
const $03ccd63b0299d6a7$var$glslFn = (code, includes)=>$03ccd63b0299d6a7$var$nativeFn(code, includes, 'glsl');
const $03ccd63b0299d6a7$var$wgslFn = (code, includes)=>$03ccd63b0299d6a7$var$nativeFn(code, includes, 'wgsl');
/**
 * Returns a node that represents the `z` coordinate in view space
 * for the current fragment. It's a different representation of the
 * default depth value.
 *
 * This value can be part of a computation that defines how the fog
 * density increases when moving away from the camera.
 *
 * @param {NodeBuilder} builder - The current node builder.
 * @return {Node} The viewZ node.
 */ function $03ccd63b0299d6a7$var$getViewZNode(builder) {
    let viewZ;
    const getViewZ = builder.context.getViewZ;
    if (getViewZ !== undefined) viewZ = getViewZ(this);
    return (viewZ || $03ccd63b0299d6a7$var$positionView.z).negate();
}
/**
 * Constructs a new range factor node.
 *
 * @tsl
 * @function
 * @param {Node} near - Defines the near value.
 * @param {Node} far - Defines the far value.
 */ const $03ccd63b0299d6a7$var$rangeFogFactor = $03ccd63b0299d6a7$var$Fn(([near, far], builder)=>{
    const viewZ = $03ccd63b0299d6a7$var$getViewZNode(builder);
    return $03ccd63b0299d6a7$var$smoothstep(near, far, viewZ);
});
/**
 * Represents an exponential squared fog. This type of fog gives
 * a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * @tsl
 * @function
 * @param {Node} density - Defines the fog density.
 */ const $03ccd63b0299d6a7$var$densityFogFactor = $03ccd63b0299d6a7$var$Fn(([density], builder)=>{
    const viewZ = $03ccd63b0299d6a7$var$getViewZNode(builder);
    return density.mul(density, viewZ, viewZ).negate().exp().oneMinus();
});
/**
 * Constructs a new height fog factor node. This fog factor requires a Y-up coordinate system.
 *
 * @tsl
 * @function
 * @param {Node} density - Defines the fog density.
 * @param {Node} height - The height threshold in world space. Everything below this y-coordinate is affected by fog.
 */ const $03ccd63b0299d6a7$var$exponentialHeightFogFactor = $03ccd63b0299d6a7$var$Fn(([density, height], builder)=>{
    const viewZ = $03ccd63b0299d6a7$var$getViewZNode(builder);
    const distance = height.sub($03ccd63b0299d6a7$var$positionWorld.y).max(0).toConst();
    const m = distance.mul(viewZ).toConst();
    return density.mul(density, m, m).negate().exp().oneMinus();
});
/**
 * This class can be used to configure a fog for the scene.
 * Nodes of this type are assigned to `Scene.fogNode`.
 *
 * @tsl
 * @function
 * @param {Node} color - Defines the color of the fog.
 * @param {Node} factor - Defines how the fog is factored in the scene.
 */ const $03ccd63b0299d6a7$var$fog = $03ccd63b0299d6a7$var$Fn(([color, factor])=>{
    return $03ccd63b0299d6a7$var$vec4(factor.toFloat().mix($03ccd63b0299d6a7$var$output.rgb, color.toVec3()), $03ccd63b0299d6a7$var$output.a);
});
let $03ccd63b0299d6a7$var$min = null;
let $03ccd63b0299d6a7$var$max = null;
/**
 * `RangeNode` generates random instanced attribute data in a defined range.
 * An exemplary use case for this utility node is to generate random per-instance
 * colors:
 * ```js
 * const material = new MeshBasicNodeMaterial();
 * material.colorNode = range( new Color( 0x000000 ), new Color( 0xFFFFFF ) );
 * const mesh = new InstancedMesh( geometry, material, count );
 * ```
 * @augments Node
 */ class $03ccd63b0299d6a7$export$d0e9917d83c120a0 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'RangeNode';
    }
    /**
	 * Constructs a new range node.
	 *
	 * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
	 * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
	 */ constructor(minNode = $03ccd63b0299d6a7$var$float(), maxNode = $03ccd63b0299d6a7$var$float()){
        super();
        /**
		 *  A node defining the lower bound of the range.
		 *
		 * @type {Node<any>}
		 * @default float()
		 */ this.minNode = minNode;
        /**
		 *  A node defining the upper bound of the range.
		 *
		 * @type {Node<any>}
		 * @default float()
		 */ this.maxNode = maxNode;
    }
    /**
	 * Returns the vector length which is computed based on the range definition.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {number} The vector length.
	 */ getVectorLength(builder) {
        const minNode = this.getConstNode(this.minNode);
        const maxNode = this.getConstNode(this.maxNode);
        const minLength = builder.getTypeLength($03ccd63b0299d6a7$var$getValueType(minNode.value));
        const maxLength = builder.getTypeLength($03ccd63b0299d6a7$var$getValueType(maxNode.value));
        return minLength > maxLength ? minLength : maxLength;
    }
    /**
	 * This method is overwritten since the node type is inferred from range definition.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return builder.object.count > 1 ? builder.getTypeFromLength(this.getVectorLength(builder)) : 'float';
    }
    /**
	 * Returns a constant node from the given node by traversing it.
	 *
	 * @param {Node} node - The node to traverse.
	 * @returns {Node} The constant node, if found.
	 */ getConstNode(node) {
        let output = null;
        node.traverse((n)=>{
            if (n.isConstNode === true) output = n;
        });
        if (output === null) throw new $03ccd63b0299d6a7$export$db6ca7d193ebb43f('THREE.TSL: No "ConstNode" found in node graph.', this.stackTrace);
        return output;
    }
    setup(builder) {
        const object = builder.object;
        let output = null;
        if (object.count > 1) {
            const minNode = this.getConstNode(this.minNode);
            const maxNode = this.getConstNode(this.maxNode);
            const minValue = minNode.value;
            const maxValue = maxNode.value;
            const minLength = builder.getTypeLength($03ccd63b0299d6a7$var$getValueType(minValue));
            const maxLength = builder.getTypeLength($03ccd63b0299d6a7$var$getValueType(maxValue));
            $03ccd63b0299d6a7$var$min = $03ccd63b0299d6a7$var$min || new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
            $03ccd63b0299d6a7$var$max = $03ccd63b0299d6a7$var$max || new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
            $03ccd63b0299d6a7$var$min.setScalar(0);
            $03ccd63b0299d6a7$var$max.setScalar(0);
            if (minLength === 1) $03ccd63b0299d6a7$var$min.setScalar(minValue);
            else if (minValue.isColor) $03ccd63b0299d6a7$var$min.set(minValue.r, minValue.g, minValue.b, 1);
            else $03ccd63b0299d6a7$var$min.set(minValue.x, minValue.y, minValue.z || 0, minValue.w || 0);
            if (maxLength === 1) $03ccd63b0299d6a7$var$max.setScalar(maxValue);
            else if (maxValue.isColor) $03ccd63b0299d6a7$var$max.set(maxValue.r, maxValue.g, maxValue.b, 1);
            else $03ccd63b0299d6a7$var$max.set(maxValue.x, maxValue.y, maxValue.z || 0, maxValue.w || 0);
            const stride = 4;
            const length = stride * object.count;
            const array = new Float32Array(length);
            for(let i = 0; i < length; i++){
                const index = i % stride;
                const minElementValue = $03ccd63b0299d6a7$var$min.getComponent(index);
                const maxElementValue = $03ccd63b0299d6a7$var$max.getComponent(index);
                array[i] = (0, $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07).lerp(minElementValue, maxElementValue, Math.random());
            }
            const nodeType = this.getNodeType(builder);
            const uniformBufferSize = object.count * 16; // count * 4 components * 4 bytes (float)
            if (uniformBufferSize <= builder.getUniformBufferLimit()) output = $03ccd63b0299d6a7$var$buffer(array, 'vec4', object.count).element($03ccd63b0299d6a7$var$instanceIndex).convert(nodeType);
            else {
                // TODO: Improve anonymous buffer attribute creation removing this part
                const bufferAttribute = new (0, $9ddd7e9b53f7a2d4$export$32ea87a8b54d744a)(array, 4);
                builder.geometry.setAttribute('__range' + this.id, bufferAttribute);
                output = $03ccd63b0299d6a7$var$instancedBufferAttribute(bufferAttribute).convert(nodeType);
            }
        } else output = $03ccd63b0299d6a7$var$float(0);
        return output;
    }
}
/**
 * TSL function for creating a range node.
 *
 * @tsl
 * @function
 * @param {Node<any>} [minNode=float()] - A node defining the lower bound of the range.
 * @param {Node<any>} [maxNode=float()] - A node defining the upper bound of the range.
 * @returns {RangeNode}
 */ const $03ccd63b0299d6a7$var$range = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$d0e9917d83c120a0).setParameterLength(2);
/**
 * `ComputeBuiltinNode` represents a compute-scope builtin value that expose information
 * about the currently running dispatch and/or the device it is running on.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$8461208f5d9851e9 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ComputeBuiltinNode';
    }
    /**
	 * Constructs a new compute builtin node.
	 *
	 * @param {string} builtinName - The built-in name.
	 * @param {string} nodeType - The node type.
	 */ constructor(builtinName, nodeType){
        super(nodeType);
        /**
		 * The built-in name.
		 *
		 * @private
		 * @type {string}
		 */ this._builtinName = builtinName;
    }
    /**
	 * This method is overwritten since hash is derived from the built-in name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The hash.
	 */ getHash(builder) {
        return this.getBuiltinName(builder);
    }
    /**
	 * This method is overwritten since the node type is simply derived from `nodeType`..
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType() {
        return this.nodeType;
    }
    /**
	 * Sets the builtin name.
	 *
	 * @param {string} builtinName - The built-in name.
	 * @return {ComputeBuiltinNode} A reference to this node.
	 */ setBuiltinName(builtinName) {
        this._builtinName = builtinName;
        return this;
    }
    /**
	 * Returns the builtin name.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The builtin name.
	 */ getBuiltinName() {
        return this._builtinName;
    }
    /**
	 * Whether the current node builder has the builtin or not.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {boolean} Whether the builder has the builtin or not.
	 */ hasBuiltin(builder) {
        return builder.hasBuiltin(this._builtinName);
    }
    generate(builder, output) {
        const builtinName = this.getBuiltinName(builder);
        const nodeType = this.getNodeType(builder);
        if (builder.shaderStage === 'compute') return builder.format(builtinName, nodeType, output);
        else {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`ComputeBuiltinNode: Compute built-in value ${builtinName} can not be accessed in the ${builder.shaderStage} stage`);
            return builder.generateConst(nodeType);
        }
    }
    serialize(data) {
        super.serialize(data);
        data.global = this.global;
        data._builtinName = this._builtinName;
    }
    deserialize(data) {
        super.deserialize(data);
        this.global = data.global;
        this._builtinName = data._builtinName;
    }
}
/**
 * TSL function for creating a compute builtin node.
 *
 * @tsl
 * @function
 * @param {string} name - The built-in name.
 * @param {string} nodeType - The node type.
 * @returns {ComputeBuiltinNode}
 */ const $03ccd63b0299d6a7$var$computeBuiltin = (name, nodeType)=>new $03ccd63b0299d6a7$export$8461208f5d9851e9(name, nodeType);
/**
 * Represents the number of workgroups dispatched by the compute shader.
 * ```js
 * // Run 512 invocations/threads with a workgroup size of 128.
 * const computeFn = Fn(() => {
 *
 *     // numWorkgroups.x = 4
 *     storageBuffer.element(0).assign(numWorkgroups.x)
 *
 * })().compute(512, [128]);
 *
 * // Run 512 invocations/threads with the default workgroup size of 64.
 * const computeFn = Fn(() => {
 *
 *     // numWorkgroups.x = 8
 *     storageBuffer.element(0).assign(numWorkgroups.x)
 *
 * })().compute(512);
 * ```
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $03ccd63b0299d6a7$var$numWorkgroups = /*@__PURE__*/ $03ccd63b0299d6a7$var$computeBuiltin('numWorkgroups', 'uvec3');
/**
 * Represents the 3-dimensional index of the workgroup the current compute invocation belongs to.
 * ```js
 * // Execute 12 compute threads with a workgroup size of 3.
 * const computeFn = Fn( () => {
 *
 * 	If( workgroupId.x.mod( 2 ).equal( 0 ), () => {
 *
 * 		storageBuffer.element( instanceIndex ).assign( instanceIndex );
 *
 * 	} ).Else( () => {
 *
 * 		storageBuffer.element( instanceIndex ).assign( 0 );
 *
 * 	} );
 *
 * } )().compute( 12, [ 3 ] );
 *
 * // workgroupId.x =  [0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3];
 * // Buffer Output =  [0, 1, 2, 0, 0, 0, 6, 7, 8, 0, 0, 0];
 * ```
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $03ccd63b0299d6a7$var$workgroupId = /*@__PURE__*/ $03ccd63b0299d6a7$var$computeBuiltin('workgroupId', 'uvec3');
/**
 * A non-linearized 3-dimensional representation of the current invocation's position within a 3D global grid.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $03ccd63b0299d6a7$var$globalId = /*@__PURE__*/ $03ccd63b0299d6a7$var$computeBuiltin('globalId', 'uvec3');
/**
 * A non-linearized 3-dimensional representation of the current invocation's position within a 3D workgroup grid.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uvec3>}
 */ const $03ccd63b0299d6a7$var$localId = /*@__PURE__*/ $03ccd63b0299d6a7$var$computeBuiltin('localId', 'uvec3');
/**
 * A device dependent variable that exposes the size of the current invocation's subgroup.
 *
 * @tsl
 * @type {ComputeBuiltinNode<uint>}
 */ const $03ccd63b0299d6a7$var$subgroupSize = /*@__PURE__*/ $03ccd63b0299d6a7$var$computeBuiltin('subgroupSize', 'uint');
/**
 * Represents a GPU control barrier that synchronizes compute operations within a given scope.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$a846f05859f677a3 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    /**
	 * Constructs a new barrier node.
	 *
	 * @param {string} scope - The scope defines the behavior of the node.
	 */ constructor(scope){
        super();
        this.scope = scope;
        this.isBarrierNode = true;
    }
    setup(builder) {
        builder.allowEarlyReturns = false;
        builder.allowGlobalVariables = false;
    }
    generate(builder) {
        const { scope: scope } = this;
        const { renderer: renderer } = builder;
        if (renderer.backend.isWebGLBackend === true) builder.addFlowCode(`\t// ${scope}Barrier \n`);
        else builder.addLineFlowCode(`${scope}Barrier()`, this);
    }
}
/**
 * TSL function for creating a barrier node.
 *
 * @tsl
 * @function
 * @param {string} scope - The scope defines the behavior of the node..
 * @returns {BarrierNode}
 */ const $03ccd63b0299d6a7$var$barrier = $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$a846f05859f677a3);
/**
 * TSL function for creating a workgroup barrier. All compute shader
 * invocations must wait for each invocation within a workgroup to
 * complete before the barrier can be surpassed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $03ccd63b0299d6a7$var$workgroupBarrier = ()=>$03ccd63b0299d6a7$var$barrier('workgroup').toStack();
/**
 * TSL function for creating a storage barrier. All invocations must
 * wait for each access to variables within the 'storage' address space
 * to complete before the barrier can be passed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $03ccd63b0299d6a7$var$storageBarrier = ()=>$03ccd63b0299d6a7$var$barrier('storage').toStack();
/**
 * TSL function for creating a texture barrier. All invocations must
 * wait for each access to variables within the 'texture' address space
 * to complete before the barrier can be passed.
 *
 * @tsl
 * @function
 * @returns {BarrierNode}
 */ const $03ccd63b0299d6a7$var$textureBarrier = ()=>$03ccd63b0299d6a7$var$barrier('texture').toStack();
/**
 * Represents an element of a 'workgroup' scoped buffer.
 *
 * @augments ArrayElementNode
 */ class $03ccd63b0299d6a7$var$WorkgroupInfoElementNode extends $03ccd63b0299d6a7$export$f2edd1d22bf6d00b {
    /**
	 * Constructs a new workgroup info element node.
	 *
	 * @param {Node} workgroupInfoNode - The workgroup info node.
	 * @param {Node} indexNode - The index node that defines the element access.
	 */ constructor(workgroupInfoNode, indexNode){
        super(workgroupInfoNode, indexNode);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWorkgroupInfoElementNode = true;
    }
    generate(builder, output) {
        let snippet;
        const isAssignContext = builder.context.assign;
        snippet = super.generate(builder);
        if (isAssignContext !== true) {
            const type = this.getNodeType(builder);
            snippet = builder.format(snippet, type, output);
        }
        // TODO: Possibly activate clip distance index on index access rather than from clipping context
        return snippet;
    }
}
/**
 * A node allowing the user to create a 'workgroup' scoped buffer within the
 * context of a compute shader. Typically, workgroup scoped buffers are
 * created to hold data that is transferred from a global storage scope into
 * a local workgroup scope. For invocations within a workgroup, data
 * access speeds on 'workgroup' scoped buffers can be significantly faster
 * than similar access operations on globally accessible storage buffers.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$2049e715720537d8 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    /**
	 * Constructs a new buffer scoped to type scope.
	 *
	 * @param {string} scope - TODO.
	 * @param {string} bufferType - The data type of a 'workgroup' scoped buffer element.
	 * @param {number} [bufferCount=0] - The number of elements in the buffer.
	 */ constructor(scope, bufferType, bufferCount = 0){
        super(bufferType);
        /**
		 * The buffer type.
		 *
		 * @type {string}
		 */ this.bufferType = bufferType;
        /**
		 * The buffer count.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bufferCount = bufferCount;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWorkgroupInfoNode = true;
        /**
		 * The data type of the array buffer.
		 *
		 * @type {string}
		 */ this.elementType = bufferType;
        /**
		 * TODO.
		 *
		 * @type {string}
		 */ this.scope = scope;
        /**
		 * The name of the workgroup scoped buffer.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = '';
    }
    /**
	 * Sets the name of this node.
	 *
	 * @param {string} name - The name to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the name/label of this node.
	 *
	 * @deprecated
	 * @param {string} name - The name to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ label(name) {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('TSL: "label()" has been deprecated. Use "setName()" instead.', new $03ccd63b0299d6a7$export$d540ba6c994dd81c()); // @deprecated r179
        return this.setName(name);
    }
    /**
	 * Sets the scope of this node.
	 *
	 * @param {string} scope - The scope to set.
	 * @return {WorkgroupInfoNode} A reference to this node.
	 */ setScope(scope) {
        this.scope = scope;
        return this;
    }
    /**
	 * The data type of the array buffer.
	 *
	 * @return {string} The element type.
	 */ getElementType() {
        return this.elementType;
    }
    /**
	 * Overwrites the default implementation since the input type
	 * is inferred from the scope.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType() {
        return `${this.scope}Array`;
    }
    /**
	 * This method can be used to access elements via an index node.
	 *
	 * @param {IndexNode} indexNode - indexNode.
	 * @return {WorkgroupInfoElementNode} A reference to an element.
	 */ element(indexNode) {
        return new $03ccd63b0299d6a7$var$WorkgroupInfoElementNode(this, indexNode);
    }
    generate(builder) {
        const name = this.name !== '' ? this.name : `${this.scope}Array_${this.id}`;
        return builder.getScopedArray(name, this.scope.toLowerCase(), this.bufferType, this.bufferCount);
    }
}
/**
 * TSL function for creating a workgroup info node.
 * Creates a new 'workgroup' scoped array buffer.
 *
 * @tsl
 * @function
 * @param {string} type - The data type of a 'workgroup' scoped buffer element.
 * @param {number} [count=0] - The number of elements in the buffer.
 * @returns {WorkgroupInfoNode}
 */ const $03ccd63b0299d6a7$var$workgroupArray = (type, count)=>new $03ccd63b0299d6a7$export$2049e715720537d8('Workgroup', type, count);
/**
 * `AtomicFunctionNode` represents any function that can operate on atomic variable types
 * within a shader. In an atomic function, any modification to an atomic variable will
 * occur as an indivisible step with a defined order relative to other modifications.
 * Accordingly, even if multiple atomic functions are modifying an atomic variable at once
 * atomic operations will not interfere with each other.
 *
 * This node can only be used with a WebGPU backend.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$97626cd9c8abc8a extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'AtomicFunctionNode';
    }
    /**
	 * Constructs a new atomic function node.
	 *
	 * @param {string} method - The signature of the atomic function to construct.
	 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
	 * @param {Node} valueNode - The value that mutates the atomic variable.
	 */ constructor(method, pointerNode, valueNode){
        super('uint');
        /**
		 * The signature of the atomic function to construct.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * An atomic variable or element of an atomic buffer.
		 *
		 * @type {Node}
		 */ this.pointerNode = pointerNode;
        /**
		 * A value that modifies the atomic variable.
		 *
		 * @type {Node}
		 */ this.valueNode = valueNode;
        /**
		 * Creates a list of the parents for this node for detecting if the node needs to return a value.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.parents = true;
    }
    /**
	 * Overwrites the default implementation to return the type of
	 * the pointer node.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The input type.
	 */ getInputType(builder) {
        return this.pointerNode.getNodeType(builder);
    }
    /**
	 * Overwritten since the node type is inferred from the input type.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 * @return {string} The node type.
	 */ generateNodeType(builder) {
        return this.getInputType(builder);
    }
    generate(builder) {
        const properties = builder.getNodeProperties(this);
        const parents = properties.parents;
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.pointerNode;
        const b = this.valueNode;
        const params = [];
        params.push(`&${a.build(builder, inputType)}`);
        if (b !== null) params.push(b.build(builder, inputType));
        const methodSnippet = `${builder.getMethod(method, type)}( ${params.join(', ')} )`;
        const isVoid = parents ? parents.length === 1 && parents[0].isStackNode === true : false;
        if (isVoid) builder.addLineFlowCode(methodSnippet, this);
        else {
            if (properties.constNode === undefined) properties.constNode = $03ccd63b0299d6a7$var$expression(methodSnippet, type).toConst();
            return properties.constNode.build(builder);
        }
    }
}
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_LOAD = 'atomicLoad';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_STORE = 'atomicStore';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_ADD = 'atomicAdd';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_SUB = 'atomicSub';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_MAX = 'atomicMax';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_MIN = 'atomicMin';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_AND = 'atomicAnd';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_OR = 'atomicOr';
$03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_XOR = 'atomicXor';
/**
 * TSL function for creating an atomic function node.
 *
 * @tsl
 * @function
 * @param {string} method - The signature of the atomic function to construct.
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicNode = $03ccd63b0299d6a7$var$nodeProxy($03ccd63b0299d6a7$export$97626cd9c8abc8a);
/**
 * TSL function for appending an atomic function call into the programmatic flow of a compute shader.
 *
 * @tsl
 * @function
 * @param {string} method - The signature of the atomic function to construct.
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicFunc = (method, pointerNode, valueNode)=>{
    return $03ccd63b0299d6a7$var$atomicNode(method, pointerNode, valueNode).toStack();
};
/**
 * Loads the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicLoad = (pointerNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_LOAD, pointerNode, null);
/**
 * Stores a value in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicStore = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_STORE, pointerNode, valueNode);
/**
 * Increments the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicAdd = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_ADD, pointerNode, valueNode);
/**
 * Decrements the value stored in the atomic variable.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicSub = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_SUB, pointerNode, valueNode);
/**
 * Stores in an atomic variable the maximum between its current value and a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicMax = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_MAX, pointerNode, valueNode);
/**
 * Stores in an atomic variable the minimum between its current value and a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicMin = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_MIN, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise AND of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicAnd = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_AND, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise OR of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicOr = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_OR, pointerNode, valueNode);
/**
 * Stores in an atomic variable the bitwise XOR of its value with a parameter.
 *
 * @tsl
 * @function
 * @param {Node} pointerNode - An atomic variable or element of an atomic buffer.
 * @param {Node} valueNode - The value that mutates the atomic variable.
 * @returns {AtomicFunctionNode}
 */ const $03ccd63b0299d6a7$var$atomicXor = (pointerNode, valueNode)=>$03ccd63b0299d6a7$var$atomicFunc($03ccd63b0299d6a7$export$97626cd9c8abc8a.ATOMIC_XOR, pointerNode, valueNode);
/**
 * This class represents a set of built in WGSL shader functions that sync
 * synchronously execute an operation across a subgroup, or 'warp', of compute
 * or fragment shader invocations within a workgroup. Typically, these functions
 * will synchronously execute an operation using data from all active invocations
 * within the subgroup, then broadcast that result to all active invocations. In
 * other graphics APIs, subgroup functions are also referred to as wave intrinsics
 * (DirectX/HLSL) or warp intrinsics (CUDA).
 *
 * @augments TempNode
 */ class $03ccd63b0299d6a7$export$a8a46826852666b1 extends $03ccd63b0299d6a7$export$bbad94d2cd32d688 {
    static get type() {
        return 'SubgroupFunctionNode';
    }
    /**
	 * Constructs a new function node.
	 *
	 * @param {string} method - The subgroup/wave intrinsic method to construct.
	 * @param {Node} [aNode=null] - The method's first argument.
	 * @param {Node} [bNode=null] - The method's second argument.
	 */ constructor(method, aNode = null, bNode = null){
        super();
        /**
		 * The subgroup/wave intrinsic method to construct.
		 *
		 * @type {string}
		 */ this.method = method;
        /**
		 * The method's first argument.
		 *
		 * @type {Node}
		 */ this.aNode = aNode;
        /**
		 * The method's second argument.
		 *
		 * @type {Node}
		 */ this.bNode = bNode;
    }
    getInputType(builder) {
        const aType = this.aNode ? this.aNode.getNodeType(builder) : null;
        const bType = this.bNode ? this.bNode.getNodeType(builder) : null;
        const aLen = builder.isMatrix(aType) ? 0 : builder.getTypeLength(aType);
        const bLen = builder.isMatrix(bType) ? 0 : builder.getTypeLength(bType);
        if (aLen > bLen) return aType;
        else return bType;
    }
    generateNodeType(builder) {
        const method = this.method;
        if (method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ELECT) return 'bool';
        else if (method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BALLOT) return 'uvec4';
        else return this.getInputType(builder);
    }
    generate(builder, output) {
        const method = this.method;
        const type = this.getNodeType(builder);
        const inputType = this.getInputType(builder);
        const a = this.aNode;
        const b = this.bNode;
        const params = [];
        if (method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BROADCAST || method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE || method === $03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_BROADCAST) {
            const bType = b.getNodeType(builder);
            params.push(a.build(builder, type), b.build(builder, bType === 'float' ? 'int' : type));
        } else if (method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_XOR || method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_DOWN || method === $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_UP) params.push(a.build(builder, type), b.build(builder, 'uint'));
        else {
            if (a !== null) params.push(a.build(builder, inputType));
            if (b !== null) params.push(b.build(builder, inputType));
        }
        const paramsString = params.length === 0 ? '()' : `( ${params.join(', ')} )`;
        return builder.format(`${builder.getMethod(method, type)}${paramsString}`, type, output);
    }
    serialize(data) {
        super.serialize(data);
        data.method = this.method;
    }
    deserialize(data) {
        super.deserialize(data);
        this.method = data.method;
    }
}
// 0 inputs
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ELECT = 'subgroupElect';
// 1 input
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BALLOT = 'subgroupBallot';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ADD = 'subgroupAdd';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_INCLUSIVE_ADD = 'subgroupInclusiveAdd';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_EXCLUSIVE_AND = 'subgroupExclusiveAdd';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MUL = 'subgroupMul';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_INCLUSIVE_MUL = 'subgroupInclusiveMul';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_EXCLUSIVE_MUL = 'subgroupExclusiveMul';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_AND = 'subgroupAnd';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_OR = 'subgroupOr';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_XOR = 'subgroupXor';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MIN = 'subgroupMin';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MAX = 'subgroupMax';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ALL = 'subgroupAll';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ANY = 'subgroupAny';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BROADCAST_FIRST = 'subgroupBroadcastFirst';
$03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_X = 'quadSwapX';
$03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_Y = 'quadSwapY';
$03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_DIAGONAL = 'quadSwapDiagonal';
// 2 inputs
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BROADCAST = 'subgroupBroadcast';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE = 'subgroupShuffle';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_XOR = 'subgroupShuffleXor';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_UP = 'subgroupShuffleUp';
$03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_DOWN = 'subgroupShuffleDown';
$03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_BROADCAST = 'quadBroadcast';
/**
 * Returns true if this invocation has the lowest subgroup_invocation_id
 * among active invocations in the subgroup.
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $03ccd63b0299d6a7$var$subgroupElect = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ELECT).setParameterLength(0);
/**
 * Returns a set of bitfields where the bit corresponding to subgroup_invocation_id
 * is 1 if pred is true for that active invocation and 0 otherwise.
 *
 * @tsl
 * @method
 * @param {bool} pred - A boolean that sets the bit corresponding to the invocations subgroup invocation id.
 * @return {vec4<u32>}- A bitfield corresponding to the pred value of each subgroup invocation.
 */ const $03ccd63b0299d6a7$var$subgroupBallot = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BALLOT).setParameterLength(1);
/**
 * A reduction that adds e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The accumulated result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupAdd = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ADD).setParameterLength(1);
/**
 * An inclusive scan returning the sum of e for all active invocations with subgroup_invocation_id less than or equal to this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the inclusive scan by the current invocation.
 * @return {number} The accumulated result of the inclusive scan operation.
 */ const $03ccd63b0299d6a7$var$subgroupInclusiveAdd = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_INCLUSIVE_ADD).setParameterLength(1);
/**
 * An exclusive scan that returns the sum of e for all active invocations with subgroup_invocation_id less than this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the exclusive scan by the current invocation.
 * @return {number} The accumulated result of the exclusive scan operation.
 */ const $03ccd63b0299d6a7$var$subgroupExclusiveAdd = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_EXCLUSIVE_AND).setParameterLength(1);
/**
 * A reduction that multiplies e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The accumulated result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupMul = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MUL).setParameterLength(1);
/**
 * An inclusive scan returning the product of e for all active invocations with subgroup_invocation_id less than or equal to this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the inclusive scan by the current invocation.
 * @return {number} The accumulated result of the inclusive scan operation.
 */ const $03ccd63b0299d6a7$var$subgroupInclusiveMul = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_INCLUSIVE_MUL).setParameterLength(1);
/**
 * An exclusive scan that returns the product of e for all active invocations with subgroup_invocation_id less than this invocation.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the exclusive scan by the current invocation.
 * @return {number} The accumulated result of the exclusive scan operation.
 */ const $03ccd63b0299d6a7$var$subgroupExclusiveMul = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_EXCLUSIVE_MUL).setParameterLength(1);
/**
 * A reduction that performs a bitwise and of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupAnd = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_AND).setParameterLength(1);
/**
 * A reduction that performs a bitwise or of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupOr = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_OR).setParameterLength(1);
/**
 * A reduction that performs a bitwise xor of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupXor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_XOR).setParameterLength(1);
/**
 * A reduction that performs a min of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupMin = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MIN).setParameterLength(1);
/**
 * A reduction that performs a max of e among all active invocations and returns that result.
 *
 * @tsl
 * @method
 * @param {number} e - The value provided to the reduction by the current invocation.
 * @return {number} The result of the reduction operation.
 */ const $03ccd63b0299d6a7$var$subgroupMax = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_MAX).setParameterLength(1);
/**
 * Returns true if e is true for all active invocations in the subgroup.
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $03ccd63b0299d6a7$var$subgroupAll = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ALL).setParameterLength(0);
/**
 * Returns true if e is true for any active invocation in the subgroup
 *
 * @tsl
 * @method
 * @return {bool} The result of the computation.
 */ const $03ccd63b0299d6a7$var$subgroupAny = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_ANY).setParameterLength(0);
/**
 * Broadcasts e from the active invocation with the lowest subgroup_invocation_id in the subgroup to all other active invocations.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast from the lowest subgroup invocation.
 * @param {number} id - The subgroup invocation to broadcast from.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupBroadcastFirst = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BROADCAST_FIRST).setParameterLength(2);
/**
 * Swaps e between invocations in the quad in the X direction.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $03ccd63b0299d6a7$var$quadSwapX = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_X).setParameterLength(1);
/**
 * Swaps e between invocations in the quad in the Y direction.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $03ccd63b0299d6a7$var$quadSwapY = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_Y).setParameterLength(1);
/**
 * Swaps e between invocations in the quad diagonally.
 *
 * @tsl
 * @method
 * @param {number} e - The value to swap from the current invocation.
 * @return {number} The value received from the swap operation.
 */ const $03ccd63b0299d6a7$var$quadSwapDiagonal = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_SWAP_DIAGONAL).setParameterLength(1);
/**
 * Broadcasts e from the invocation whose subgroup_invocation_id matches id, to all active invocations.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast from subgroup invocation 'id'.
 * @param {number} id - The subgroup invocation to broadcast from.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupBroadcast = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_BROADCAST).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches id
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} id - The subgroup invocation which returns the value v.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupShuffle = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id ^ mask.
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} mask - A bitmask that determines the target invocation via a XOR operation.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupShuffleXor = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_XOR).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id - delta
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} delta - A value that offsets the current in.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupShuffleUp = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_UP).setParameterLength(2);
/**
 * Returns v from the active invocation whose subgroup_invocation_id matches subgroup_invocation_id + delta
 *
 * @tsl
 * @method
 * @param {number} v - The value to return from subgroup invocation id^mask.
 * @param {number} delta - A value that offsets the current subgroup invocation.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$subgroupShuffleDown = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.SUBGROUP_SHUFFLE_DOWN).setParameterLength(2);
/**
 * Broadcasts e from the quad invocation with id equal to id.
 *
 * @tsl
 * @method
 * @param {number} e - The value to broadcast.
 * @return {number} The broadcast value.
 */ const $03ccd63b0299d6a7$var$quadBroadcast = /*@__PURE__*/ $03ccd63b0299d6a7$var$nodeProxyIntent($03ccd63b0299d6a7$export$a8a46826852666b1, $03ccd63b0299d6a7$export$a8a46826852666b1.QUAD_BROADCAST).setParameterLength(1);
let $03ccd63b0299d6a7$var$uniformsLib;
function $03ccd63b0299d6a7$var$getLightData(light) {
    $03ccd63b0299d6a7$var$uniformsLib = $03ccd63b0299d6a7$var$uniformsLib || new WeakMap();
    let uniforms = $03ccd63b0299d6a7$var$uniformsLib.get(light);
    if (uniforms === undefined) $03ccd63b0299d6a7$var$uniformsLib.set(light, uniforms = {});
    return uniforms;
}
/**
 * TSL function for getting a shadow matrix uniform node for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<mat4>} The shadow matrix uniform node.
 */ function $03ccd63b0299d6a7$var$lightShadowMatrix(light) {
    const data = $03ccd63b0299d6a7$var$getLightData(light);
    return data.shadowMatrix || (data.shadowMatrix = $03ccd63b0299d6a7$var$uniform('mat4').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((frame)=>{
        // normally, shadow matrices are updated in ShadowNode. However, if the shadow matrix is used outside
        // of shadow rendering (like in ProjectorLightNode), the shadow matrix still requires an update
        if (light.castShadow !== true || frame.renderer.shadowMap.enabled === false) {
            if (light.shadow.camera.coordinateSystem !== frame.camera.coordinateSystem) {
                light.shadow.camera.coordinateSystem = frame.camera.coordinateSystem;
                light.shadow.camera.updateProjectionMatrix();
            }
            light.shadow.updateMatrices(light);
        }
        return light.shadow.matrix;
    }));
}
/**
 * TSL function for getting projected uv coordinates for the given light.
 * Relevant when using maps with spot lights.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @param {Node<vec3>} [position=positionWorld] -The position to project.
 * @returns {Node<vec3>} The projected uvs.
 */ function $03ccd63b0299d6a7$var$lightProjectionUV(light, position = $03ccd63b0299d6a7$var$positionWorld) {
    const spotLightCoord = $03ccd63b0299d6a7$var$lightShadowMatrix(light).mul(position);
    const projectionUV = spotLightCoord.xyz.div(spotLightCoord.w);
    return projectionUV;
}
/**
 * TSL function for getting the position in world space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<vec3>} The light's position in world space.
 */ function $03ccd63b0299d6a7$var$lightPosition(light) {
    const data = $03ccd63b0299d6a7$var$getLightData(light);
    return data.position || (data.position = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((_, self1)=>self1.value.setFromMatrixPosition(light.matrixWorld)));
}
/**
 * TSL function for getting the light target position in world space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {UniformNode<vec3>} The light target position in world space.
 */ function $03ccd63b0299d6a7$var$lightTargetPosition(light) {
    const data = $03ccd63b0299d6a7$var$getLightData(light);
    return data.targetPosition || (data.targetPosition = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate((_, self1)=>self1.value.setFromMatrixPosition(light.target.matrixWorld)));
}
/**
 * TSL function for getting the position in view space for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light - The light source.
 * @returns {UniformNode<vec3>} The light's position in view space.
 */ function $03ccd63b0299d6a7$var$lightViewPosition(light) {
    const data = $03ccd63b0299d6a7$var$getLightData(light);
    return data.viewPosition || (data.viewPosition = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(({ camera: camera }, self1)=>{
        self1.value = self1.value || new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        self1.value.setFromMatrixPosition(light.matrixWorld);
        self1.value.applyMatrix4(camera.matrixWorldInverse);
    }));
}
/**
 * TSL function for getting the light target direction for the given light.
 *
 * @tsl
 * @function
 * @param {Light} light -The light source.
 * @returns {Node<vec3>} The light's target direction.
 */ const $03ccd63b0299d6a7$var$lightTargetDirection = (light)=>$03ccd63b0299d6a7$var$cameraViewMatrix.transformDirection($03ccd63b0299d6a7$var$lightPosition(light).sub($03ccd63b0299d6a7$var$lightTargetPosition(light)));
const $03ccd63b0299d6a7$var$sortLights = (lights)=>{
    return lights.sort((a, b)=>a.id - b.id);
};
const $03ccd63b0299d6a7$var$getLightNodeById = (id, lightNodes)=>{
    for (const lightNode of lightNodes){
        if (lightNode.isAnalyticLightNode && lightNode.light.id === id) return lightNode;
    }
    return null;
};
const $03ccd63b0299d6a7$var$_lightsNodeRef = /*@__PURE__*/ new WeakMap();
const $03ccd63b0299d6a7$var$_hashData = [];
/**
 * This node represents the scene's lighting and manages the lighting model's life cycle
 * for the current build 3D object. It is responsible for computing the total outgoing
 * light in a given lighting context.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$577c410712851cc4 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'LightsNode';
    }
    /**
	 * Constructs a new lights node.
	 */ constructor(){
        super('vec3');
        /**
		 * A node representing the total diffuse light.
		 *
		 * @type {Node<vec3>}
		 */ this.totalDiffuseNode = $03ccd63b0299d6a7$var$property('vec3', 'totalDiffuse');
        /**
		 * A node representing the total specular light.
		 *
		 * @type {Node<vec3>}
		 */ this.totalSpecularNode = $03ccd63b0299d6a7$var$property('vec3', 'totalSpecular');
        /**
		 * A node representing the outgoing light.
		 *
		 * @type {Node<vec3>}
		 */ this.outgoingLightNode = $03ccd63b0299d6a7$var$property('vec3', 'outgoingLight');
        /**
		 * An array representing the lights in the scene.
		 *
		 * @private
		 * @type {Array<Light>}
		 */ this._lights = [];
        /**
		 * For each light in the scene, this node will create a
		 * corresponding light node.
		 *
		 * @private
		 * @type {?Array<LightingNode>}
		 * @default null
		 */ this._lightNodes = null;
        /**
		 * A hash for identifying the current light nodes setup.
		 *
		 * @private
		 * @type {?string}
		 * @default null
		 */ this._lightNodesHash = null;
        /**
		 * `LightsNode` sets this property to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.global = true;
    }
    /**
	 * Overwrites the default {@link Node#customCacheKey} implementation by including
	 * light data into the cache key.
	 *
	 * @return {number} The custom cache key.
	 */ customCacheKey() {
        const lights = this._lights;
        for(let i = 0; i < lights.length; i++){
            const light = lights[i];
            $03ccd63b0299d6a7$var$_hashData.push(light.id);
            $03ccd63b0299d6a7$var$_hashData.push(light.castShadow ? 1 : 0);
            if (light.isSpotLight === true) {
                const hashMap = light.map !== null ? light.map.id : -1;
                const hashColorNode = light.colorNode ? light.colorNode.getCacheKey() : -1;
                $03ccd63b0299d6a7$var$_hashData.push(hashMap, hashColorNode);
            }
        }
        const cacheKey = $03ccd63b0299d6a7$var$hashArray($03ccd63b0299d6a7$var$_hashData);
        $03ccd63b0299d6a7$var$_hashData.length = 0;
        return cacheKey;
    }
    /**
	 * Computes a hash value for identifying the current light nodes setup.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {string} The computed hash.
	 */ getHash(builder) {
        if (this._lightNodesHash === null) {
            if (this._lightNodes === null) this.setupLightsNode(builder);
            const hash = [];
            for (const lightNode of this._lightNodes)hash.push(lightNode.getHash());
            this._lightNodesHash = 'lights-' + hash.join(',');
        }
        return this._lightNodesHash;
    }
    analyze(builder) {
        const properties = builder.getNodeProperties(this);
        for (const node of properties.nodes)node.build(builder);
        properties.outputNode.build(builder);
    }
    /**
	 * Creates lighting nodes for each scene light. This makes it possible to further
	 * process lights in the node system.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 */ setupLightsNode(builder) {
        const lightNodes = [];
        const previousLightNodes = this._lightNodes;
        const lights = $03ccd63b0299d6a7$var$sortLights(this._lights);
        const nodeLibrary = builder.renderer.library;
        for (const light of lights)if (light.isNode) lightNodes.push($03ccd63b0299d6a7$var$nodeObject(light));
        else {
            let lightNode = null;
            if (previousLightNodes !== null) lightNode = $03ccd63b0299d6a7$var$getLightNodeById(light.id, previousLightNodes);
            if (lightNode === null) {
                const lightNodeClass = nodeLibrary.getLightNodeClass(light.constructor);
                if (lightNodeClass === null) {
                    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`LightsNode.setupNodeLights: Light node not found for ${light.constructor.name}`);
                    continue;
                }
                if ($03ccd63b0299d6a7$var$_lightsNodeRef.has(light) === false) $03ccd63b0299d6a7$var$_lightsNodeRef.set(light, new lightNodeClass(light));
                lightNode = $03ccd63b0299d6a7$var$_lightsNodeRef.get(light);
            }
            lightNodes.push(lightNode);
        }
        this._lightNodes = lightNodes;
    }
    /**
	 * Sets up a direct light in the lighting model.
	 *
	 * @param {Object} builder - The builder object containing the context and stack.
	 * @param {Object} lightNode - The light node.
	 * @param {Object} lightData - The light object containing color and direction properties.
	 */ setupDirectLight(builder, lightNode, lightData) {
        const { lightingModel: lightingModel, reflectedLight: reflectedLight } = builder.context;
        lightingModel.direct({
            ...lightData,
            lightNode: lightNode,
            reflectedLight: reflectedLight
        }, builder);
    }
    setupDirectRectAreaLight(builder, lightNode, lightData) {
        const { lightingModel: lightingModel, reflectedLight: reflectedLight } = builder.context;
        lightingModel.directRectArea({
            ...lightData,
            lightNode: lightNode,
            reflectedLight: reflectedLight
        }, builder);
    }
    /**
	 * Setups the internal lights by building all respective
	 * light nodes.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Array<LightingNode>} lightNodes - An array of lighting nodes.
	 */ setupLights(builder, lightNodes) {
        for (const lightNode of lightNodes)lightNode.build(builder);
    }
    getLightNodes(builder) {
        if (this._lightNodes === null) this.setupLightsNode(builder);
        return this._lightNodes;
    }
    /**
	 * The implementation makes sure that for each light in the scene
	 * there is a corresponding light node. By building the light nodes
	 * and evaluating the lighting model the outgoing light is computed.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec3>} A node representing the outgoing light.
	 */ setup(builder) {
        const currentLightsNode = builder.lightsNode;
        builder.lightsNode = this;
        let outgoingLightNode = this.outgoingLightNode;
        const context = builder.context;
        const lightingModel = context.lightingModel;
        const properties = builder.getNodeProperties(this);
        if (lightingModel) {
            const { totalDiffuseNode: totalDiffuseNode, totalSpecularNode: totalSpecularNode } = this;
            context.outgoingLight = outgoingLightNode;
            const stack = builder.addStack();
            properties.nodes = stack.nodes;
            lightingModel.start(builder);
            const { backdrop: backdrop, backdropAlpha: backdropAlpha } = context;
            const { directDiffuse: directDiffuse, directSpecular: directSpecular, indirectDiffuse: indirectDiffuse, indirectSpecular: indirectSpecular } = context.reflectedLight;
            let totalDiffuse = directDiffuse.add(indirectDiffuse);
            if (backdrop !== null) {
                if (backdropAlpha !== null) totalDiffuse = $03ccd63b0299d6a7$var$vec3(backdropAlpha.mix(totalDiffuse, backdrop));
                else totalDiffuse = $03ccd63b0299d6a7$var$vec3(backdrop);
            }
            totalDiffuseNode.assign(totalDiffuse);
            totalSpecularNode.assign(directSpecular.add(indirectSpecular));
            outgoingLightNode.assign(totalDiffuseNode.add(totalSpecularNode));
            lightingModel.finish(builder);
            outgoingLightNode = outgoingLightNode.bypass(builder.removeStack());
        } else properties.nodes = [];
        builder.lightsNode = currentLightsNode;
        return outgoingLightNode;
    }
    /**
	 * Configures this node with an array of lights.
	 *
	 * @param {Array<Light>} lights - An array of lights.
	 * @return {LightsNode} A reference to this node.
	 */ setLights(lights) {
        this._lights = lights;
        this._lightNodes = null;
        this._lightNodesHash = null;
        return this;
    }
    /**
	 * Returns an array of the scene's lights.
	 *
	 * @return {Array<Light>} The scene's lights.
	 */ getLights() {
        return this._lights;
    }
    /**
	 * Whether the scene has lights or not.
	 *
	 * @type {boolean}
	 */ get hasLights() {
        return this._lights.length > 0;
    }
}
/**
 * TSL function for creating an instance of `LightsNode` and configuring
 * it with the given array of lights.
 *
 * @tsl
 * @function
 * @param {Array<Light>} lights - An array of lights.
 * @return {LightsNode} The created lights node.
 */ const $03ccd63b0299d6a7$var$lights = (lights = [])=>new $03ccd63b0299d6a7$export$577c410712851cc4().setLights(lights);
/**
 * Base class for all shadow nodes.
 *
 * Shadow nodes encapsulate shadow related logic and are always coupled to lighting nodes.
 * Lighting nodes might share the same shadow node type or use specific ones depending on
 * their requirements.
 *
 * @augments Node
 */ class $03ccd63b0299d6a7$export$71d9cb9897322c99 extends $03ccd63b0299d6a7$export$85c928794f8d04d4 {
    static get type() {
        return 'ShadowBaseNode';
    }
    /**
	 * Constructs a new shadow base node.
	 *
	 * @param {Light} light - The shadow casting light.
	 */ constructor(light){
        super();
        /**
		 * The shadow casting light.
		 *
		 * @type {Light}
		 */ this.light = light;
        /**
		 * Overwritten since shadows are updated by default per render.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateBeforeType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowBaseNode = true;
    }
    /**
	 * Setups the shadow position node which is by default the predefined TSL node object `shadowPositionWorld`.
	 *
	 * @param {NodeBuilder} object - A configuration object that must at least hold a material reference.
	 */ setupShadowPosition({ context: context, material: material }) {
        // Use assign inside an Fn()
        $03ccd63b0299d6a7$var$shadowPositionWorld.assign(material.receivedShadowPositionNode || context.shadowPositionWorld || $03ccd63b0299d6a7$var$positionWorld);
    }
}
/**
 * TSL object that represents the vertex position in world space during the shadow pass.
 *
 * @tsl
 * @type {Node<vec3>}
 */ const $03ccd63b0299d6a7$var$shadowPositionWorld = /*@__PURE__*/ $03ccd63b0299d6a7$var$property('vec3', 'shadowPositionWorld');
/**
 * Saves the state of the given renderer and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$saveRendererState(renderer, state = {}) {
    state.toneMapping = renderer.toneMapping;
    state.toneMappingExposure = renderer.toneMappingExposure;
    state.outputColorSpace = renderer.outputColorSpace;
    state.renderTarget = renderer.getRenderTarget();
    state.activeCubeFace = renderer.getActiveCubeFace();
    state.activeMipmapLevel = renderer.getActiveMipmapLevel();
    state.renderObjectFunction = renderer.getRenderObjectFunction();
    state.pixelRatio = renderer.getPixelRatio();
    state.mrt = renderer.getMRT();
    state.clearColor = renderer.getClearColor(state.clearColor || new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)());
    state.clearAlpha = renderer.getClearAlpha();
    state.autoClear = renderer.autoClear;
    state.scissorTest = renderer.getScissorTest();
    return state;
}
/**
 * Saves the state of the given renderer and stores it into the given state object.
 * Besides, the function also resets the state of the renderer to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$resetRendererState(renderer, state) {
    state = $03ccd63b0299d6a7$var$saveRendererState(renderer, state);
    renderer.setMRT(null);
    renderer.setRenderObjectFunction(null);
    renderer.setClearColor(0x000000, 1);
    renderer.autoClear = true;
    return state;
}
/**
 * Restores the state of the given renderer from the given state object.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Object} state - The state to restore.
 */ function $03ccd63b0299d6a7$var$restoreRendererState(renderer, state) {
    renderer.toneMapping = state.toneMapping;
    renderer.toneMappingExposure = state.toneMappingExposure;
    renderer.outputColorSpace = state.outputColorSpace;
    renderer.setRenderTarget(state.renderTarget, state.activeCubeFace, state.activeMipmapLevel);
    renderer.setRenderObjectFunction(state.renderObjectFunction);
    renderer.setPixelRatio(state.pixelRatio);
    renderer.setMRT(state.mrt);
    renderer.setClearColor(state.clearColor, state.clearAlpha);
    renderer.autoClear = state.autoClear;
    renderer.setScissorTest(state.scissorTest);
}
/**
 * Saves the state of the given scene and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$saveSceneState(scene, state = {}) {
    state.background = scene.background;
    state.backgroundNode = scene.backgroundNode;
    state.overrideMaterial = scene.overrideMaterial;
    return state;
}
/**
 * Saves the state of the given scene and stores it into the given state object.
 * Besides, the function also resets the state of the scene to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$resetSceneState(scene, state) {
    state = $03ccd63b0299d6a7$var$saveSceneState(scene, state);
    scene.background = null;
    scene.backgroundNode = null;
    scene.overrideMaterial = null;
    return state;
}
/**
 * Restores the state of the given scene from the given state object.
 *
 * @private
 * @function
 * @param {Scene} scene - The scene.
 * @param {Object} state - The state to restore.
 */ function $03ccd63b0299d6a7$var$restoreSceneState(scene, state) {
    scene.background = state.background;
    scene.backgroundNode = state.backgroundNode;
    scene.overrideMaterial = state.overrideMaterial;
}
/**
 * Saves the state of the given renderer and scene and stores it into the given state object.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$saveRendererAndSceneState(renderer, scene, state = {}) {
    state = $03ccd63b0299d6a7$var$saveRendererState(renderer, state);
    state = $03ccd63b0299d6a7$var$saveSceneState(scene, state);
    return state;
}
/**
 * Saves the state of the given renderer and scene and stores it into the given state object.
 * Besides, the function also resets the state of the renderer and scene to its default values.
 *
 * If not state object is provided, the function creates one.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} [state={}] - The state.
 * @return {Object} The state.
 */ function $03ccd63b0299d6a7$var$resetRendererAndSceneState(renderer, scene, state) {
    state = $03ccd63b0299d6a7$var$resetRendererState(renderer, state);
    state = $03ccd63b0299d6a7$var$resetSceneState(scene, state);
    return state;
}
/**
 * Restores the state of the given renderer and scene from the given state object.
 *
 * @private
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {Scene} scene - The scene.
 * @param {Object} state - The state to restore.
 */ function $03ccd63b0299d6a7$var$restoreRendererAndSceneState(renderer, scene, state) {
    $03ccd63b0299d6a7$var$restoreRendererState(renderer, state);
    $03ccd63b0299d6a7$var$restoreSceneState(scene, state);
}
var $03ccd63b0299d6a7$export$921fe00ccd8e59c1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    resetRendererAndSceneState: $03ccd63b0299d6a7$var$resetRendererAndSceneState,
    resetRendererState: $03ccd63b0299d6a7$var$resetRendererState,
    resetSceneState: $03ccd63b0299d6a7$var$resetSceneState,
    restoreRendererAndSceneState: $03ccd63b0299d6a7$var$restoreRendererAndSceneState,
    restoreRendererState: $03ccd63b0299d6a7$var$restoreRendererState,
    restoreSceneState: $03ccd63b0299d6a7$var$restoreSceneState,
    saveRendererAndSceneState: $03ccd63b0299d6a7$var$saveRendererAndSceneState,
    saveRendererState: $03ccd63b0299d6a7$var$saveRendererState,
    saveSceneState: $03ccd63b0299d6a7$var$saveSceneState
});
const $03ccd63b0299d6a7$var$shadowMaterialLib = /*@__PURE__*/ new WeakMap();
/**
 * A shadow filtering function performing basic filtering. This is in fact an unfiltered version of the shadow map
 * with a binary `[0,1]` result.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @return {Node<float>} The filtering result.
 */ const $03ccd63b0299d6a7$var$BasicShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, depthLayer: depthLayer })=>{
    let basic = $03ccd63b0299d6a7$var$texture(depthTexture, shadowCoord.xy).setName('t_basic');
    if (depthTexture.isArrayTexture) basic = basic.depth(depthLayer);
    return basic.compare(shadowCoord.z);
});
/**
 * A shadow filtering function performing PCF filtering with Vogel disk sampling and IGN.
 *
 * Uses 5 samples distributed via Vogel disk pattern, rotated per-pixel using Interleaved
 * Gradient Noise (IGN) to break up banding artifacts. Combined with hardware PCF (4-tap
 * filtering per sample), this effectively provides 20 filtered taps with better distribution.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $03ccd63b0299d6a7$var$PCFShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer })=>{
    const depthCompare = (uv, compare)=>{
        let depth = $03ccd63b0299d6a7$var$texture(depthTexture, uv);
        if (depthTexture.isArrayTexture) depth = depth.depth(depthLayer);
        return depth.compare(compare);
    };
    const mapSize = $03ccd63b0299d6a7$var$reference('mapSize', 'vec2', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const radius = $03ccd63b0299d6a7$var$reference('radius', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const texelSize = $03ccd63b0299d6a7$var$vec2(1).div(mapSize);
    const radiusScaled = radius.mul(texelSize.x);
    // Use IGN to rotate sampling pattern per pixel (phi = IGN * 2π)
    const phi = $03ccd63b0299d6a7$var$interleavedGradientNoise($03ccd63b0299d6a7$var$screenCoordinate.xy).mul(6.28318530718);
    // 5 samples using Vogel disk distribution
    return $03ccd63b0299d6a7$var$add(depthCompare(shadowCoord.xy.add($03ccd63b0299d6a7$var$vogelDiskSample(0, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($03ccd63b0299d6a7$var$vogelDiskSample(1, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($03ccd63b0299d6a7$var$vogelDiskSample(2, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($03ccd63b0299d6a7$var$vogelDiskSample(3, 5, phi).mul(radiusScaled)), shadowCoord.z), depthCompare(shadowCoord.xy.add($03ccd63b0299d6a7$var$vogelDiskSample(4, 5, phi).mul(radiusScaled)), shadowCoord.z)).mul(0.2);
});
/**
 * A shadow filtering function performing PCF soft filtering.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $03ccd63b0299d6a7$var$PCFSoftShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer })=>{
    const depthCompare = (uv, compare)=>{
        let depth = $03ccd63b0299d6a7$var$texture(depthTexture, uv);
        if (depthTexture.isArrayTexture) depth = depth.depth(depthLayer);
        return depth.compare(compare);
    };
    const mapSize = $03ccd63b0299d6a7$var$reference('mapSize', 'vec2', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const texelSize = $03ccd63b0299d6a7$var$vec2(1).div(mapSize);
    const dx = texelSize.x;
    const dy = texelSize.y;
    const uv = shadowCoord.xy;
    const f = $03ccd63b0299d6a7$var$fract(uv.mul(mapSize).add(0.5));
    uv.subAssign(f.mul(texelSize));
    return $03ccd63b0299d6a7$var$add(depthCompare(uv, shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx, 0)), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(0, dy)), shadowCoord.z), depthCompare(uv.add(texelSize), shadowCoord.z), $03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.negate(), 0)), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.mul(2), 0)), shadowCoord.z), f.x), $03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.negate(), dy)), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.mul(2), dy)), shadowCoord.z), f.x), $03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(0, dy.negate())), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(0, dy.mul(2))), shadowCoord.z), f.y), $03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx, dy.negate())), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx, dy.mul(2))), shadowCoord.z), f.y), $03ccd63b0299d6a7$var$mix($03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.negate(), dy.negate())), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.mul(2), dy.negate())), shadowCoord.z), f.x), $03ccd63b0299d6a7$var$mix(depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.negate(), dy.mul(2))), shadowCoord.z), depthCompare(uv.add($03ccd63b0299d6a7$var$vec2(dx.mul(2), dy.mul(2))), shadowCoord.z), f.x), f.y)).mul(1 / 9);
});
/**
 * A shadow filtering function performing VSM filtering.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
 * @param {Node<vec3>} inputs.shadowCoord - The shadow coordinates.
 * @return {Node<float>} The filtering result.
 */ const $03ccd63b0299d6a7$var$VSMShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, shadowCoord: shadowCoord, depthLayer: depthLayer }, builder)=>{
    let distribution = $03ccd63b0299d6a7$var$texture(depthTexture).sample(shadowCoord.xy);
    if (depthTexture.isArrayTexture) distribution = distribution.depth(depthLayer);
    distribution = distribution.rg;
    const mean = distribution.x;
    const variance = $03ccd63b0299d6a7$var$max$1(0.0000001, distribution.y.mul(distribution.y));
    const hardShadow = builder.renderer.reversedDepthBuffer ? $03ccd63b0299d6a7$var$step(mean, shadowCoord.z) : $03ccd63b0299d6a7$var$step(shadowCoord.z, mean);
    const output = $03ccd63b0299d6a7$var$float(1).toVar(); // default, fully lit
    $03ccd63b0299d6a7$var$If(hardShadow.notEqual(1.0), ()=>{
        // Distance from mean
        const d = shadowCoord.z.sub(mean);
        // Chebyshev's inequality for upper bound on probability
        let p_max = variance.div(variance.add(d.mul(d)));
        // Reduce light bleeding by remapping [amount, 1] to [0, 1]
        p_max = $03ccd63b0299d6a7$var$clamp($03ccd63b0299d6a7$var$sub(p_max, 0.3).div(0.65));
        output.assign($03ccd63b0299d6a7$var$max$1(hardShadow, p_max));
    });
    return output;
});
/**
 * Retrieves or creates a shadow material for the given light source.
 *
 * This function checks if a shadow material already exists for the provided light.
 * If not, it creates a new `NodeMaterial` configured for shadow rendering and stores it
 * in the `shadowMaterialLib` for future use.
 *
 * @tsl
 * @function
 * @param {Light} light - The light source for which the shadow material is needed.
 *                         If the light is a point light, a depth node is calculated
 *                         using the linear shadow distance.
 * @returns {NodeMaterial} The shadow material associated with the given light.
 */ const $03ccd63b0299d6a7$var$getShadowMaterial = (light)=>{
    let material = $03ccd63b0299d6a7$var$shadowMaterialLib.get(light);
    if (material === undefined) {
        material = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
        material.colorNode = $03ccd63b0299d6a7$var$vec4(0, 0, 0, 1);
        material.isShadowPassMaterial = true; // Use to avoid other overrideMaterial override material.colorNode unintentionally when using material.shadowNode
        material.name = 'ShadowMaterial';
        material.blending = (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
        material.fog = false;
        $03ccd63b0299d6a7$var$shadowMaterialLib.set(light, material);
    }
    return material;
};
/**
 * Disposes the shadow material for the given light source.
 *
 * @param {Light} light - The light source.
 */ const $03ccd63b0299d6a7$var$disposeShadowMaterial = (light)=>{
    const material = $03ccd63b0299d6a7$var$shadowMaterialLib.get(light);
    if (material !== undefined) {
        material.dispose();
        $03ccd63b0299d6a7$var$shadowMaterialLib.delete(light);
    }
};
//
const $03ccd63b0299d6a7$var$_shadowRenderObjectLibrary = /*@__PURE__*/ new $03ccd63b0299d6a7$var$ChainMap();
const $03ccd63b0299d6a7$var$_shadowRenderObjectKeys = [];
/**
 * Creates a function to render shadow objects in a scene.
 *
 * @tsl
 * @function
 * @param {Renderer} renderer - The renderer.
 * @param {LightShadow} shadow - The light shadow object containing shadow properties.
 * @param {number} shadowType - The type of shadow map (e.g., BasicShadowMap).
 * @param {boolean} useVelocity - Whether to use velocity data for rendering.
 * @return {shadowRenderObjectFunction} A function that renders shadow objects.
 */ const $03ccd63b0299d6a7$var$getShadowRenderObjectFunction = (renderer, shadow, shadowType, useVelocity)=>{
    $03ccd63b0299d6a7$var$_shadowRenderObjectKeys[0] = renderer;
    $03ccd63b0299d6a7$var$_shadowRenderObjectKeys[1] = shadow;
    let renderObjectFunction = $03ccd63b0299d6a7$var$_shadowRenderObjectLibrary.get($03ccd63b0299d6a7$var$_shadowRenderObjectKeys);
    if (renderObjectFunction === undefined || renderObjectFunction.shadowType !== shadowType || renderObjectFunction.useVelocity !== useVelocity) {
        renderObjectFunction = (object, scene, _camera, geometry, material, group, ...params)=>{
            if (object.castShadow === true || object.receiveShadow && shadowType === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) {
                if (useVelocity) $03ccd63b0299d6a7$var$getDataFromObject(object).useVelocity = true;
                object.onBeforeShadow(renderer, object, _camera, shadow.camera, geometry, scene.overrideMaterial, group);
                renderer.renderObject(object, scene, _camera, geometry, material, group, ...params);
                object.onAfterShadow(renderer, object, _camera, shadow.camera, geometry, scene.overrideMaterial, group);
            }
        };
        renderObjectFunction.shadowType = shadowType;
        renderObjectFunction.useVelocity = useVelocity;
        $03ccd63b0299d6a7$var$_shadowRenderObjectLibrary.set($03ccd63b0299d6a7$var$_shadowRenderObjectKeys, renderObjectFunction);
    }
    $03ccd63b0299d6a7$var$_shadowRenderObjectKeys[0] = null;
    $03ccd63b0299d6a7$var$_shadowRenderObjectKeys[1] = null;
    return renderObjectFunction;
};
/**
 * Represents the shader code for the first VSM render pass.
 *
 * @private
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.samples - The number of samples
 * @param {Node<float>} inputs.radius - The radius.
 * @param {Node<float>} inputs.size - The size.
 * @param {TextureNode} inputs.shadowPass - A reference to the render target's depth data.
 * @return {Node<vec2>} The VSM output.
 */ const $03ccd63b0299d6a7$var$VSMPassVertical = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass, depthLayer: depthLayer })=>{
    const mean = $03ccd63b0299d6a7$var$float(0).toVar('meanVertical');
    const squaredMean = $03ccd63b0299d6a7$var$float(0).toVar('squareMeanVertical');
    const uvStride = samples.lessThanEqual($03ccd63b0299d6a7$var$float(1)).select($03ccd63b0299d6a7$var$float(0), $03ccd63b0299d6a7$var$float(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual($03ccd63b0299d6a7$var$float(1)).select($03ccd63b0299d6a7$var$float(0), $03ccd63b0299d6a7$var$float(-1));
    $03ccd63b0299d6a7$var$Loop({
        start: $03ccd63b0299d6a7$var$int(0),
        end: $03ccd63b0299d6a7$var$int(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add($03ccd63b0299d6a7$var$float(i).mul(uvStride));
        let depth = shadowPass.sample($03ccd63b0299d6a7$var$add($03ccd63b0299d6a7$var$screenCoordinate.xy, $03ccd63b0299d6a7$var$vec2(0, uvOffset).mul(radius)).div(size));
        if (shadowPass.value.isArrayTexture) depth = depth.depth(depthLayer);
        depth = depth.x;
        mean.addAssign(depth);
        squaredMean.addAssign(depth.mul(depth));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = $03ccd63b0299d6a7$var$sqrt(squaredMean.sub(mean.mul(mean)).max(0));
    return $03ccd63b0299d6a7$var$vec2(mean, std_dev);
});
/**
 * Represents the shader code for the second VSM render pass.
 *
 * @private
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.samples - The number of samples
 * @param {Node<float>} inputs.radius - The radius.
 * @param {Node<float>} inputs.size - The size.
 * @param {TextureNode} inputs.shadowPass - The result of the first VSM render pass.
 * @return {Node<vec2>} The VSM output.
 */ const $03ccd63b0299d6a7$var$VSMPassHorizontal = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ samples: samples, radius: radius, size: size, shadowPass: shadowPass, depthLayer: depthLayer })=>{
    const mean = $03ccd63b0299d6a7$var$float(0).toVar('meanHorizontal');
    const squaredMean = $03ccd63b0299d6a7$var$float(0).toVar('squareMeanHorizontal');
    const uvStride = samples.lessThanEqual($03ccd63b0299d6a7$var$float(1)).select($03ccd63b0299d6a7$var$float(0), $03ccd63b0299d6a7$var$float(2).div(samples.sub(1)));
    const uvStart = samples.lessThanEqual($03ccd63b0299d6a7$var$float(1)).select($03ccd63b0299d6a7$var$float(0), $03ccd63b0299d6a7$var$float(-1));
    $03ccd63b0299d6a7$var$Loop({
        start: $03ccd63b0299d6a7$var$int(0),
        end: $03ccd63b0299d6a7$var$int(samples),
        type: 'int',
        condition: '<'
    }, ({ i: i })=>{
        const uvOffset = uvStart.add($03ccd63b0299d6a7$var$float(i).mul(uvStride));
        let distribution = shadowPass.sample($03ccd63b0299d6a7$var$add($03ccd63b0299d6a7$var$screenCoordinate.xy, $03ccd63b0299d6a7$var$vec2(uvOffset, 0).mul(radius)).div(size));
        if (shadowPass.value.isArrayTexture) distribution = distribution.depth(depthLayer);
        mean.addAssign(distribution.x);
        squaredMean.addAssign($03ccd63b0299d6a7$var$add(distribution.y.mul(distribution.y), distribution.x.mul(distribution.x)));
    });
    mean.divAssign(samples);
    squaredMean.divAssign(samples);
    const std_dev = $03ccd63b0299d6a7$var$sqrt(squaredMean.sub(mean.mul(mean)).max(0));
    return $03ccd63b0299d6a7$var$vec2(mean, std_dev);
});
const $03ccd63b0299d6a7$var$_shadowFilterLib = [
    $03ccd63b0299d6a7$var$BasicShadowFilter,
    $03ccd63b0299d6a7$var$PCFShadowFilter,
    $03ccd63b0299d6a7$var$PCFSoftShadowFilter,
    $03ccd63b0299d6a7$var$VSMShadowFilter
];
//
let $03ccd63b0299d6a7$var$_rendererState;
const $03ccd63b0299d6a7$var$_quadMesh = /*@__PURE__*/ new $03ccd63b0299d6a7$export$266ce19fe399ee9a();
/**
 * Represents the default shadow implementation for lighting nodes.
 *
 * @augments ShadowBaseNode
 */ class $03ccd63b0299d6a7$export$d4d1a61f129c85f2 extends $03ccd63b0299d6a7$export$71d9cb9897322c99 {
    static get type() {
        return 'ShadowNode';
    }
    /**
	 * Constructs a new shadow node.
	 *
	 * @param {Light} light - The shadow casting light.
	 * @param {?LightShadow} [shadow=null] - An optional light shadow.
	 */ constructor(light, shadow = null){
        super(light);
        /**
		 * The light shadow which defines the properties light's
		 * shadow.
		 *
		 * @type {?LightShadow}
		 * @default null
		 */ this.shadow = shadow || light.shadow;
        /**
		 * A reference to the shadow map which is a render target.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.shadowMap = null;
        /**
		 * Only relevant for VSM shadows. Render target for the
		 * first VSM render pass.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.vsmShadowMapVertical = null;
        /**
		 * Only relevant for VSM shadows. Render target for the
		 * second VSM render pass.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.vsmShadowMapHorizontal = null;
        /**
		 * Only relevant for VSM shadows. Node material which
		 * is used to render the first VSM pass.
		 *
		 * @type {?NodeMaterial}
		 * @default null
		 */ this.vsmMaterialVertical = null;
        /**
		 * Only relevant for VSM shadows. Node material which
		 * is used to render the second VSM pass.
		 *
		 * @type {?NodeMaterial}
		 * @default null
		 */ this.vsmMaterialHorizontal = null;
        /**
		 * A reference to the output node which defines the
		 * final result of this shadow node.
		 *
		 * @type {?Node}
		 * @private
		 * @default null
		 */ this._node = null;
        /**
		 * The current shadow map type of this shadow node.
		 *
		 * @type {?number}
		 * @private
		 * @default null
		 */ this._currentShadowType = null;
        /**
		 * A Weak Map holding the current frame ID per camera. Used
		 * to control the update of shadow maps.
		 *
		 * @type {WeakMap<Camera,number>}
		 * @private
		 */ this._cameraFrameId = new WeakMap();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowNode = true;
        /**
		 * This index can be used when overriding setupRenderTarget with a RenderTarget Array to specify the depth layer.
		 *
		 * @type {number}
		 * @readonly
		 * @default true
		 */ this.depthLayer = 0;
    }
    /**
	 * Setups the shadow filtering.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Object} inputs - A configuration object that defines the shadow filtering.
	 * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
	 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's texture data.
	 * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
	 * @param {LightShadow} inputs.shadow - The light shadow.
	 * @return {Node<float>} The result node of the shadow filtering.
	 */ setupShadowFilter(builder, { filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow, depthLayer: depthLayer }) {
        const frustumTest = shadowCoord.x.greaterThanEqual(0).and(shadowCoord.x.lessThanEqual(1)).and(shadowCoord.y.greaterThanEqual(0)).and(shadowCoord.y.lessThanEqual(1)).and(shadowCoord.z.lessThanEqual(1));
        const shadowNode = filterFn({
            depthTexture: depthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow,
            depthLayer: depthLayer
        });
        return frustumTest.select(shadowNode, $03ccd63b0299d6a7$var$float(1));
    }
    /**
	 * Setups the shadow coordinates.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
	 * @return {Node<vec3>} The shadow coordinates.
	 */ setupShadowCoord(builder, shadowPosition) {
        const { shadow: shadow } = this;
        const { renderer: renderer } = builder;
        const bias = shadow.biasNode || $03ccd63b0299d6a7$var$reference('bias', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
        let shadowCoord = shadowPosition;
        let coordZ;
        if (shadow.camera.isOrthographicCamera || renderer.logarithmicDepthBuffer !== true) {
            shadowCoord = shadowCoord.xyz.div(shadowCoord.w);
            coordZ = shadowCoord.z;
        } else {
            const w = shadowCoord.w;
            shadowCoord = shadowCoord.xy.div(w); // <-- Only divide X/Y coords since we don't need Z
            // The normally available "cameraNear" and "cameraFar" nodes cannot be used here because they do not get
            // updated to use the shadow camera. So, we have to declare our own "local" ones here.
            // TODO: How do we get the cameraNear/cameraFar nodes to use the shadow camera so we don't have to declare local ones here?
            const cameraNearLocal = $03ccd63b0299d6a7$var$reference('near', 'float', shadow.camera).setGroup($03ccd63b0299d6a7$var$renderGroup);
            const cameraFarLocal = $03ccd63b0299d6a7$var$reference('far', 'float', shadow.camera).setGroup($03ccd63b0299d6a7$var$renderGroup);
            coordZ = $03ccd63b0299d6a7$var$viewZToLogarithmicDepth(w.negate(), cameraNearLocal, cameraFarLocal);
        }
        shadowCoord = $03ccd63b0299d6a7$var$vec3(shadowCoord.x, shadowCoord.y.oneMinus(), renderer.reversedDepthBuffer ? coordZ.sub(bias) : coordZ.add(bias));
        return shadowCoord;
    }
    /**
	 * Returns the shadow filtering function for the given shadow type.
	 *
	 * @param {number} type - The shadow type.
	 * @return {Function} The filtering function.
	 */ getShadowFilterFn(type) {
        return $03ccd63b0299d6a7$var$_shadowFilterLib[type];
    }
    setupRenderTarget(shadow, builder) {
        const depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(shadow.mapSize.width, shadow.mapSize.height);
        depthTexture.name = 'ShadowDepthTexture';
        depthTexture.compareFunction = builder.renderer.reversedDepthBuffer ? (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61) : (0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1);
        const shadowMap = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height);
        shadowMap.texture.name = 'ShadowMap';
        shadowMap.texture.type = shadow.mapType;
        shadowMap.depthTexture = depthTexture;
        return {
            shadowMap: shadowMap,
            depthTexture: depthTexture
        };
    }
    /**
	 * Setups the shadow output node.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Node<vec3>} The shadow output node.
	 */ setupShadow(builder) {
        const { renderer: renderer, camera: camera } = builder;
        const { light: light, shadow: shadow } = this;
        const { depthTexture: depthTexture, shadowMap: shadowMap } = this.setupRenderTarget(shadow, builder);
        const shadowMapType = renderer.shadowMap.type;
        const hasTextureCompare = renderer.hasCompatibility((0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE);
        if ((shadowMapType === (0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88) || shadowMapType === (0, $9ddd7e9b53f7a2d4$export$a47c4b43a1be34f0)) && hasTextureCompare) {
            depthTexture.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
            depthTexture.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        } else {
            depthTexture.minFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
            depthTexture.magFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
        }
        shadow.camera.coordinateSystem = camera.coordinateSystem;
        shadow.camera.updateProjectionMatrix();
        // VSM
        if (shadowMapType === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4) && shadow.isPointLightShadow !== true) {
            depthTexture.compareFunction = null; // VSM does not use textureSampleCompare()/texture2DCompare()
            if (shadowMap.depth > 1) {
                if (!shadowMap._vsmShadowMapVertical) {
                    shadowMap._vsmShadowMapVertical = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                        format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
                        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                        depth: shadowMap.depth,
                        depthBuffer: false
                    });
                    shadowMap._vsmShadowMapVertical.texture.name = 'VSMVertical';
                }
                this.vsmShadowMapVertical = shadowMap._vsmShadowMapVertical;
                if (!shadowMap._vsmShadowMapHorizontal) {
                    shadowMap._vsmShadowMapHorizontal = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                        format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
                        type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                        depth: shadowMap.depth,
                        depthBuffer: false
                    });
                    shadowMap._vsmShadowMapHorizontal.texture.name = 'VSMHorizontal';
                }
                this.vsmShadowMapHorizontal = shadowMap._vsmShadowMapHorizontal;
            } else {
                this.vsmShadowMapVertical = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                    format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
                    type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                    depthBuffer: false
                });
                this.vsmShadowMapHorizontal = builder.createRenderTarget(shadow.mapSize.width, shadow.mapSize.height, {
                    format: (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0),
                    type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc),
                    depthBuffer: false
                });
            }
            let shadowPassVertical = $03ccd63b0299d6a7$var$texture(depthTexture);
            if (depthTexture.isArrayTexture) shadowPassVertical = shadowPassVertical.depth(this.depthLayer);
            let shadowPassHorizontal = $03ccd63b0299d6a7$var$texture(this.vsmShadowMapVertical.texture);
            if (depthTexture.isArrayTexture) shadowPassHorizontal = shadowPassHorizontal.depth(this.depthLayer);
            const samples = $03ccd63b0299d6a7$var$reference('blurSamples', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
            const radius = $03ccd63b0299d6a7$var$reference('radius', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
            const size = $03ccd63b0299d6a7$var$reference('mapSize', 'vec2', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
            let material = this.vsmMaterialVertical || (this.vsmMaterialVertical = new $03ccd63b0299d6a7$export$caaf3b30a544c946());
            material.fragmentNode = $03ccd63b0299d6a7$var$VSMPassVertical({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassVertical,
                depthLayer: this.depthLayer
            }).context(builder.getSharedContext());
            material.name = 'VSMVertical';
            material = this.vsmMaterialHorizontal || (this.vsmMaterialHorizontal = new $03ccd63b0299d6a7$export$caaf3b30a544c946());
            material.fragmentNode = $03ccd63b0299d6a7$var$VSMPassHorizontal({
                samples: samples,
                radius: radius,
                size: size,
                shadowPass: shadowPassHorizontal,
                depthLayer: this.depthLayer
            }).context(builder.getSharedContext());
            material.name = 'VSMHorizontal';
        }
        //
        const shadowIntensity = $03ccd63b0299d6a7$var$reference('intensity', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
        const normalBias = $03ccd63b0299d6a7$var$reference('normalBias', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
        const shadowMatrix = $03ccd63b0299d6a7$var$lightShadowMatrix(light);
        const shadowNormalBias = $03ccd63b0299d6a7$var$normalWorld.mul(normalBias);
        let shadowPosition;
        if (!renderer.highPrecision || builder.material.receivedShadowPositionNode || builder.context.shadowPositionWorld) shadowPosition = shadowMatrix.mul($03ccd63b0299d6a7$var$shadowPositionWorld.add(shadowNormalBias));
        else {
            const highpShadowModelMatrix = $03ccd63b0299d6a7$var$uniform('mat4').onObjectUpdate(({ object: object }, self1)=>{
                return self1.value.multiplyMatrices(shadowMatrix.value, object.matrixWorld);
            });
            shadowPosition = highpShadowModelMatrix.mul($03ccd63b0299d6a7$var$positionLocal).add(shadowMatrix.mul($03ccd63b0299d6a7$var$vec4(shadowNormalBias, 0)));
        }
        const shadowCoord = this.setupShadowCoord(builder, shadowPosition);
        //
        const filterFn = shadow.filterNode || this.getShadowFilterFn(renderer.shadowMap.type) || null;
        if (filterFn === null) throw new Error('THREE.WebGPURenderer: Shadow map type not supported yet.');
        const shadowDepthTexture = shadowMapType === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4) && shadow.isPointLightShadow !== true ? this.vsmShadowMapHorizontal.texture : depthTexture;
        const shadowNode = this.setupShadowFilter(builder, {
            filterFn: filterFn,
            shadowTexture: shadowMap.texture,
            depthTexture: shadowDepthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow,
            depthLayer: this.depthLayer
        });
        let shadowColor;
        if (renderer.shadowMap.transmitted === true) {
            if (shadowMap.texture.isCubeTexture) // For cube shadow maps (point lights), use cubeTexture with vec3 coordinates
            shadowColor = $03ccd63b0299d6a7$var$cubeTexture(shadowMap.texture, shadowCoord.xyz);
            else {
                shadowColor = $03ccd63b0299d6a7$var$texture(shadowMap.texture, shadowCoord);
                if (depthTexture.isArrayTexture) shadowColor = shadowColor.depth(this.depthLayer);
            }
        }
        //
        let shadowOutput;
        if (shadowColor) shadowOutput = $03ccd63b0299d6a7$var$mix(1, shadowNode.rgb.mix(shadowColor, 1), shadowIntensity.mul(shadowColor.a)).toVar();
        else shadowOutput = $03ccd63b0299d6a7$var$mix(1, shadowNode, shadowIntensity).toVar();
        this.shadowMap = shadowMap;
        this.shadow.map = shadowMap;
        // Shadow Output + Inspector
        const inspectName = `${this.light.type} Shadow [ ${this.light.name || 'ID: ' + this.light.id} ]`;
        if (shadowColor) shadowOutput.toInspector(`${inspectName} / Color`, ()=>{
            if (this.shadowMap.texture.isCubeTexture) return $03ccd63b0299d6a7$var$cubeTexture(this.shadowMap.texture);
            return $03ccd63b0299d6a7$var$texture(this.shadowMap.texture);
        });
        return shadowOutput.toInspector(`${inspectName} / Depth`, ()=>{
            // TODO: Use linear depth
            if (this.shadowMap.texture.isCubeTexture) return $03ccd63b0299d6a7$var$cubeTexture(this.shadowMap.texture).r.oneMinus();
            return $03ccd63b0299d6a7$var$textureLoad(this.shadowMap.depthTexture, $03ccd63b0299d6a7$var$uv$1().mul($03ccd63b0299d6a7$var$textureSize($03ccd63b0299d6a7$var$texture(this.shadowMap.depthTexture)))).r.oneMinus();
        });
    }
    /**
	 * The implementation performs the setup of the output node. An output is only
	 * produces if shadow mapping is globally enabled in the renderer.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {ShaderCallNodeInternal} The output node.
	 */ setup(builder) {
        if (builder.renderer.shadowMap.enabled === false) return;
        return $03ccd63b0299d6a7$var$Fn(()=>{
            const currentShadowType = builder.renderer.shadowMap.type;
            if (this._currentShadowType !== currentShadowType) {
                this._reset();
                this._node = null;
            }
            let node = this._node;
            this.setupShadowPosition(builder);
            if (node === null) {
                this._node = node = this.setupShadow(builder);
                this._currentShadowType = currentShadowType;
            }
            if (builder.material.receivedShadowNode) node = builder.material.receivedShadowNode(node);
            return node;
        })();
    }
    /**
	 * Renders the shadow. The logic of this function could be included
	 * into {@link ShadowNode#updateShadow} however more specialized shadow
	 * nodes might require a custom shadow map rendering. By having a
	 * dedicated method, it's easier to overwrite the default behavior.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ renderShadow(frame) {
        const { shadow: shadow, shadowMap: shadowMap, light: light } = this;
        const { renderer: renderer, scene: scene } = frame;
        shadow.updateMatrices(light);
        shadowMap.setSize(shadow.mapSize.width, shadow.mapSize.height, shadowMap.depth);
        const currentSceneName = scene.name;
        scene.name = `Shadow Map [ ${light.name || 'ID: ' + light.id} ]`;
        renderer.render(scene, shadow.camera);
        scene.name = currentSceneName;
    }
    /**
	 * Updates the shadow.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateShadow(frame) {
        const { shadowMap: shadowMap, light: light, shadow: shadow } = this;
        const { renderer: renderer, scene: scene, camera: camera } = frame;
        const shadowType = renderer.shadowMap.type;
        const depthVersion = shadowMap.depthTexture.version;
        this._depthVersionCached = depthVersion;
        const _shadowCameraLayer = shadow.camera.layers.mask;
        if ((shadow.camera.layers.mask & 0xFFFFFFFE) === 0) shadow.camera.layers.mask = camera.layers.mask;
        const currentRenderObjectFunction = renderer.getRenderObjectFunction();
        const currentMRT = renderer.getMRT();
        const useVelocity = currentMRT ? currentMRT.has('velocity') : false;
        $03ccd63b0299d6a7$var$_rendererState = $03ccd63b0299d6a7$var$resetRendererAndSceneState(renderer, scene, $03ccd63b0299d6a7$var$_rendererState);
        scene.overrideMaterial = $03ccd63b0299d6a7$var$getShadowMaterial(light);
        renderer.setRenderObjectFunction($03ccd63b0299d6a7$var$getShadowRenderObjectFunction(renderer, shadow, shadowType, useVelocity));
        renderer.setClearColor(0x000000, 0);
        renderer.setRenderTarget(shadowMap);
        this.renderShadow(frame);
        renderer.setRenderObjectFunction(currentRenderObjectFunction);
        // vsm blur pass
        if (shadowType === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4) && shadow.isPointLightShadow !== true) this.vsmPass(renderer);
        shadow.camera.layers.mask = _shadowCameraLayer;
        $03ccd63b0299d6a7$var$restoreRendererAndSceneState(renderer, scene, $03ccd63b0299d6a7$var$_rendererState);
    }
    /**
	 * For VSM additional render passes are required.
	 *
	 * @param {Renderer} renderer - A reference to the current renderer.
	 */ vsmPass(renderer) {
        const { shadow: shadow } = this;
        const depth = this.shadowMap.depth;
        this.vsmShadowMapVertical.setSize(shadow.mapSize.width, shadow.mapSize.height, depth);
        this.vsmShadowMapHorizontal.setSize(shadow.mapSize.width, shadow.mapSize.height, depth);
        renderer.setRenderTarget(this.vsmShadowMapVertical);
        $03ccd63b0299d6a7$var$_quadMesh.material = this.vsmMaterialVertical;
        $03ccd63b0299d6a7$var$_quadMesh.render(renderer);
        renderer.setRenderTarget(this.vsmShadowMapHorizontal);
        $03ccd63b0299d6a7$var$_quadMesh.material = this.vsmMaterialHorizontal;
        $03ccd63b0299d6a7$var$_quadMesh.render(renderer);
    }
    /**
	 * Frees the internal resources of this shadow node.
	 */ dispose() {
        this._reset();
        super.dispose();
    }
    /**
	 * Resets the resouce state of this shadow node.
	 *
	 * @private
	 */ _reset() {
        this._currentShadowType = null;
        $03ccd63b0299d6a7$var$disposeShadowMaterial(this.light);
        if (this.shadowMap) {
            this.shadowMap.dispose();
            this.shadowMap = null;
        }
        if (this.vsmShadowMapVertical !== null) {
            this.vsmShadowMapVertical.dispose();
            this.vsmShadowMapVertical = null;
            this.vsmMaterialVertical.dispose();
            this.vsmMaterialVertical = null;
        }
        if (this.vsmShadowMapHorizontal !== null) {
            this.vsmShadowMapHorizontal.dispose();
            this.vsmShadowMapHorizontal = null;
            this.vsmMaterialHorizontal.dispose();
            this.vsmMaterialHorizontal = null;
        }
    }
    /**
	 * The implementation performs the update of the shadow map if necessary.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ updateBefore(frame) {
        const { shadow: shadow } = this;
        let needsUpdate = shadow.needsUpdate || shadow.autoUpdate;
        if (needsUpdate) {
            if (this._cameraFrameId[frame.camera] === frame.frameId) needsUpdate = false;
            this._cameraFrameId[frame.camera] = frame.frameId;
        }
        if (needsUpdate) {
            this.updateShadow(frame);
            if (this.shadowMap.depthTexture.version === this._depthVersionCached) shadow.needsUpdate = false;
        }
    }
}
/**
 * Shadow Render Object Function.
 *
 * @function shadowRenderObjectFunction
 * @param {Object3D} object - The 3D object to render.
 * @param {Scene} scene - The scene containing the object.
 * @param {Camera} _camera - The camera used for rendering.
 * @param {BufferGeometry} geometry - The geometry of the object.
 * @param {Material} material - The material of the object.
 * @param {Group} group - The group the object belongs to.
 * @param {...any} params - Additional parameters for rendering.
 */ /**
 * TSL function for creating an instance of `ShadowNode`.
 *
 * @tsl
 * @function
 * @param {Light} light - The shadow casting light.
 * @param {?LightShadow} [shadow] - The light shadow.
 * @return {ShadowNode} The created shadow node.
 */ const $03ccd63b0299d6a7$var$shadow = (light, shadow)=>new $03ccd63b0299d6a7$export$d4d1a61f129c85f2(light, shadow);
const $03ccd63b0299d6a7$var$_clearColor$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
const $03ccd63b0299d6a7$var$_projScreenMatrix$1 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $03ccd63b0299d6a7$var$_lightPositionWorld = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_lookTarget = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
// Cube map face directions and up vectors for point light shadows
// Face order: +X, -X, +Y, -Y, +Z, -Z
// WebGPU coordinate system - Y faces swapped to match texture sampling convention
const $03ccd63b0299d6a7$var$_cubeDirectionsWebGPU = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(-1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1)
];
const $03ccd63b0299d6a7$var$_cubeUpsWebGPU = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0)
];
// WebGL coordinate system - standard OpenGL convention
const $03ccd63b0299d6a7$var$_cubeDirectionsWebGL = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(-1, 0, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1)
];
const $03ccd63b0299d6a7$var$_cubeUpsWebGL = [
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, -1),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0),
    /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, -1, 0)
];
const $03ccd63b0299d6a7$var$BasicPointShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, bd3D: bd3D, dp: dp })=>{
    return $03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D).compare(dp);
});
/**
 * A shadow filtering function for point lights using Vogel disk sampling and IGN.
 *
 * Uses 5 samples distributed via Vogel disk pattern in tangent space around the
 * sample direction, rotated per-pixel using Interleaved Gradient Noise (IGN).
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {CubeDepthTexture} inputs.depthTexture - A reference to the shadow cube map.
 * @param {Node<vec3>} inputs.bd3D - The normalized direction from light to fragment.
 * @param {Node<float>} inputs.dp - The depth value to compare against.
 * @param {LightShadow} inputs.shadow - The light shadow.
 * @return {Node<float>} The filtering result.
 */ const $03ccd63b0299d6a7$var$PointShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ depthTexture: depthTexture, bd3D: bd3D, dp: dp, shadow: shadow })=>{
    const radius = $03ccd63b0299d6a7$var$reference('radius', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const mapSize = $03ccd63b0299d6a7$var$reference('mapSize', 'vec2', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const texelSize = radius.div(mapSize.x);
    // Build a tangent-space coordinate system for applying offsets
    const absDir = $03ccd63b0299d6a7$var$abs(bd3D);
    const tangent = $03ccd63b0299d6a7$var$normalize($03ccd63b0299d6a7$var$cross(bd3D, absDir.x.greaterThan(absDir.z).select($03ccd63b0299d6a7$var$vec3(0, 1, 0), $03ccd63b0299d6a7$var$vec3(1, 0, 0))));
    const bitangent = $03ccd63b0299d6a7$var$cross(bd3D, tangent);
    // Use IGN to rotate sampling pattern per pixel (phi = IGN * 2π)
    const phi = $03ccd63b0299d6a7$var$interleavedGradientNoise($03ccd63b0299d6a7$var$screenCoordinate.xy).mul(6.28318530718);
    // 5 samples using Vogel disk distribution in tangent space
    const sample0 = $03ccd63b0299d6a7$var$vogelDiskSample(0, 5, phi);
    const sample1 = $03ccd63b0299d6a7$var$vogelDiskSample(1, 5, phi);
    const sample2 = $03ccd63b0299d6a7$var$vogelDiskSample(2, 5, phi);
    const sample3 = $03ccd63b0299d6a7$var$vogelDiskSample(3, 5, phi);
    const sample4 = $03ccd63b0299d6a7$var$vogelDiskSample(4, 5, phi);
    return $03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample0.x).add(bitangent.mul(sample0.y)).mul(texelSize))).compare(dp).add($03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample1.x).add(bitangent.mul(sample1.y)).mul(texelSize))).compare(dp)).add($03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample2.x).add(bitangent.mul(sample2.y)).mul(texelSize))).compare(dp)).add($03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample3.x).add(bitangent.mul(sample3.y)).mul(texelSize))).compare(dp)).add($03ccd63b0299d6a7$var$cubeTexture(depthTexture, bd3D.add(tangent.mul(sample4.x).add(bitangent.mul(sample4.y)).mul(texelSize))).compare(dp)).mul(0.2);
});
const $03ccd63b0299d6a7$var$pointShadowFilter = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow }, builder)=>{
    // for point lights, the uniform @vShadowCoord is re-purposed to hold
    // the vector from the light to the world-space position of the fragment.
    const shadowPosition = shadowCoord.xyz.toConst();
    const shadowPositionAbs = shadowPosition.abs().toConst();
    const viewZ = shadowPositionAbs.x.max(shadowPositionAbs.y).max(shadowPositionAbs.z);
    const shadowCameraNear = $03ccd63b0299d6a7$var$uniform('float').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(()=>shadow.camera.near);
    const shadowCameraFar = $03ccd63b0299d6a7$var$uniform('float').setGroup($03ccd63b0299d6a7$var$renderGroup).onRenderUpdate(()=>shadow.camera.far);
    const bias = $03ccd63b0299d6a7$var$reference('bias', 'float', shadow).setGroup($03ccd63b0299d6a7$var$renderGroup);
    const result = $03ccd63b0299d6a7$var$float(1.0).toVar();
    $03ccd63b0299d6a7$var$If(viewZ.sub(shadowCameraFar).lessThanEqual(0.0).and(viewZ.sub(shadowCameraNear).greaterThanEqual(0.0)), ()=>{
        let dp;
        if (builder.renderer.reversedDepthBuffer) {
            dp = $03ccd63b0299d6a7$var$viewZToReversedPerspectiveDepth(viewZ.negate(), shadowCameraNear, shadowCameraFar);
            dp.subAssign(bias);
        } else {
            dp = $03ccd63b0299d6a7$var$viewZToPerspectiveDepth(viewZ.negate(), shadowCameraNear, shadowCameraFar);
            dp.addAssign(bias);
        }
        // bd3D = base direction 3D (direction from light to fragment)
        const bd3D = shadowPosition.normalize();
        // percentage-closer filtering using cube texture sampling
        result.assign(filterFn({
            depthTexture: depthTexture,
            bd3D: bd3D,
            dp: dp,
            shadow: shadow
        }));
    });
    return result;
});
/**
 * Represents the shadow implementation for point light nodes.
 *
 * @augments ShadowNode
 */ class $03ccd63b0299d6a7$export$8952ddb14855053a extends $03ccd63b0299d6a7$export$d4d1a61f129c85f2 {
    static get type() {
        return 'PointShadowNode';
    }
    /**
	 * Constructs a new point shadow node.
	 *
	 * @param {PointLight} light - The shadow casting point light.
	 * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
	 */ constructor(light, shadow = null){
        super(light, shadow);
    }
    /**
	 * Overwrites the default implementation to return point light shadow specific
	 * filtering functions.
	 *
	 * @param {number} type - The shadow type.
	 * @return {Function} The filtering function.
	 */ getShadowFilterFn(type) {
        return type === (0, $9ddd7e9b53f7a2d4$export$346307dbae2b7447) ? $03ccd63b0299d6a7$var$BasicPointShadowFilter : $03ccd63b0299d6a7$var$PointShadowFilter;
    }
    /**
	 * Overwrites the default implementation so the unaltered shadow position is used.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Node<vec3>} shadowPosition - A node representing the shadow position.
	 * @return {Node<vec3>} The shadow coordinates.
	 */ setupShadowCoord(builder, shadowPosition) {
        return shadowPosition;
    }
    /**
	 * Overwrites the default implementation to only use point light specific
	 * shadow filter functions.
	 *
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @param {Object} inputs - A configuration object that defines the shadow filtering.
	 * @param {Function} inputs.filterFn - This function defines the filtering type of the shadow map e.g. PCF.
	 * @param {DepthTexture} inputs.depthTexture - A reference to the shadow map's depth texture.
	 * @param {Node<vec3>} inputs.shadowCoord - Shadow coordinates which are used to sample from the shadow map.
	 * @param {LightShadow} inputs.shadow - The light shadow.
	 * @return {Node<float>} The result node of the shadow filtering.
	 */ setupShadowFilter(builder, { filterFn: filterFn, depthTexture: depthTexture, shadowCoord: shadowCoord, shadow: shadow }) {
        return $03ccd63b0299d6a7$var$pointShadowFilter({
            filterFn: filterFn,
            depthTexture: depthTexture,
            shadowCoord: shadowCoord,
            shadow: shadow
        });
    }
    /**
	 * Overwrites the default implementation to create a CubeRenderTarget with CubeDepthTexture.
	 *
	 * @param {LightShadow} shadow - The light shadow object.
	 * @param {NodeBuilder} builder - A reference to the current node builder.
	 * @return {Object} An object containing the shadow map and depth texture.
	 */ setupRenderTarget(shadow, builder) {
        const depthTexture = new (0, $9ddd7e9b53f7a2d4$export$c9f39eef7fb1d170)(shadow.mapSize.width);
        depthTexture.name = 'PointShadowDepthTexture';
        depthTexture.compareFunction = builder.renderer.reversedDepthBuffer ? (0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61) : (0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1);
        const shadowMap = builder.createCubeRenderTarget(shadow.mapSize.width);
        shadowMap.texture.name = 'PointShadowMap';
        shadowMap.depthTexture = depthTexture;
        return {
            shadowMap: shadowMap,
            depthTexture: depthTexture
        };
    }
    /**
	 * Overwrites the default implementation with point light specific
	 * rendering code.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ renderShadow(frame) {
        const { shadow: shadow, shadowMap: shadowMap, light: light } = this;
        const { renderer: renderer, scene: scene } = frame;
        const camera = shadow.camera;
        const shadowMatrix = shadow.matrix;
        // Select cube directions/ups based on coordinate system
        const isWebGPU = renderer.coordinateSystem === (0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac);
        const cubeDirections = isWebGPU ? $03ccd63b0299d6a7$var$_cubeDirectionsWebGPU : $03ccd63b0299d6a7$var$_cubeDirectionsWebGL;
        const cubeUps = isWebGPU ? $03ccd63b0299d6a7$var$_cubeUpsWebGPU : $03ccd63b0299d6a7$var$_cubeUpsWebGL;
        shadowMap.setSize(shadow.mapSize.width, shadow.mapSize.width);
        //
        const previousAutoClear = renderer.autoClear;
        const previousClearColor = renderer.getClearColor($03ccd63b0299d6a7$var$_clearColor$1);
        const previousClearAlpha = renderer.getClearAlpha();
        renderer.autoClear = false;
        renderer.setClearColor(shadow.clearColor, shadow.clearAlpha);
        // Render each cube face
        for(let face = 0; face < 6; face++){
            // Set render target to the specific cube face
            renderer.setRenderTarget(shadowMap, face);
            renderer.clear();
            // Update shadow camera matrices for this face
            const far = light.distance || camera.far;
            if (far !== camera.far) {
                camera.far = far;
                camera.updateProjectionMatrix();
            }
            $03ccd63b0299d6a7$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
            camera.position.copy($03ccd63b0299d6a7$var$_lightPositionWorld);
            $03ccd63b0299d6a7$var$_lookTarget.copy(camera.position);
            $03ccd63b0299d6a7$var$_lookTarget.add(cubeDirections[face]);
            camera.up.copy(cubeUps[face]);
            camera.lookAt($03ccd63b0299d6a7$var$_lookTarget);
            camera.updateMatrixWorld();
            shadowMatrix.makeTranslation(-$03ccd63b0299d6a7$var$_lightPositionWorld.x, -$03ccd63b0299d6a7$var$_lightPositionWorld.y, -$03ccd63b0299d6a7$var$_lightPositionWorld.z);
            $03ccd63b0299d6a7$var$_projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            shadow._frustum.setFromProjectionMatrix($03ccd63b0299d6a7$var$_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            //
            const currentSceneName = scene.name;
            scene.name = `Point Light Shadow [ ${light.name || 'ID: ' + light.id} ] - Face ${face + 1}`;
            renderer.render(scene, camera);
            scene.name = currentSceneName;
        }
        //
        renderer.autoClear = previousAutoClear;
        renderer.setClearColor(previousClearColor, previousClearAlpha);
    }
}
/**
 * TSL function for creating an instance of `PointShadowNode`.
 *
 * @tsl
 * @function
 * @param {PointLight} light - The shadow casting point light.
 * @param {?PointLightShadow} [shadow=null] - An optional point light shadow.
 * @return {PointShadowNode} The created point shadow node.
 */ const $03ccd63b0299d6a7$var$pointShadow = (light, shadow)=>new $03ccd63b0299d6a7$export$8952ddb14855053a(light, shadow);
/**
 * Base class for analytic light nodes.
 *
 * @augments LightingNode
 */ class $03ccd63b0299d6a7$export$126552cbaf08eb8 extends $03ccd63b0299d6a7$export$3fce9846d62aac91 {
    static get type() {
        return 'AnalyticLightNode';
    }
    /**
	 * Constructs a new analytic light node.
	 *
	 * @param {?Light} [light=null] - The light source.
	 */ constructor(light = null){
        super();
        /**
		 * The light source.
		 *
		 * @type {?Light}
		 * @default null
		 */ this.light = light;
        /**
		 * The light's color value.
		 *
		 * @type {Color}
		 */ this.color = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
        /**
		 * The light's color node. Points to `colorNode` of the light source, if set. Otherwise
		 * it creates a uniform node based on {@link AnalyticLightNode#color}.
		 *
		 * @type {Node}
		 */ this.colorNode = light && light.colorNode || $03ccd63b0299d6a7$var$uniform(this.color).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * This property is used to retain a reference to the original value of {@link AnalyticLightNode#colorNode}.
		 * The final color node is represented by a different node when using shadows.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.baseColorNode = null;
        /**
		 * Represents the light's shadow.
		 *
		 * @type {?ShadowNode}
   		 * @default null
		 */ this.shadowNode = null;
        /**
		 * Represents the light's shadow color.
		 *
		 * @type {?Node}
   		 * @default null
		 */ this.shadowColorNode = null;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnalyticLightNode = true;
        /**
		 * Overwritten since analytic light nodes are updated
		 * once per frame.
		 *
		 * @type {string}
		 * @default 'frame'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME;
        if (light && light.shadow) {
            this._shadowDisposeListener = ()=>{
                this.disposeShadow();
            };
            light.addEventListener('dispose', this._shadowDisposeListener);
        }
    }
    dispose() {
        if (this._shadowDisposeListener) this.light.removeEventListener('dispose', this._shadowDisposeListener);
        super.dispose();
    }
    /**
	 * Frees internal resources related to shadows.
	 */ disposeShadow() {
        if (this.shadowNode !== null) {
            this.shadowNode.dispose();
            this.shadowNode = null;
        }
        this.shadowColorNode = null;
        if (this.baseColorNode !== null) {
            this.colorNode = this.baseColorNode;
            this.baseColorNode = null;
        }
    }
    getHash() {
        return this.light.uuid;
    }
    /**
	 * Returns a node representing a direction vector which points from the current
	 * position in view space to the light's position in view space.
	 *
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Node<vec3>} The light vector node.
	 */ getLightVector(builder) {
        return $03ccd63b0299d6a7$var$lightViewPosition(this.light).sub(builder.context.positionView || $03ccd63b0299d6a7$var$positionView);
    }
    /**
	 * Sets up the direct lighting for the analytic light node.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Object|undefined} The direct light data (color and direction).
	 */ setupDirect() {}
    /**
	 * Sets up the direct rect area lighting for the analytic light node.
	 *
	 * @abstract
	 * @param {NodeBuilder} builder - The builder object used for setting up the light.
	 * @return {Object|undefined} The direct rect area light data.
	 */ setupDirectRectArea() {}
    /**
	 * Setups the shadow node for this light. The method exists so concrete light classes
	 * can setup different types of shadow nodes.
	 *
	 * @return {ShadowNode} The created shadow node.
	 */ setupShadowNode() {
        return $03ccd63b0299d6a7$var$shadow(this.light);
    }
    /**
	 * Setups the shadow for this light. This method is only executed if the light
	 * cast shadows and the current build object receives shadows. It incorporates
	 * shadows into the lighting computation.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setupShadow(builder) {
        const { renderer: renderer } = builder;
        if (renderer.shadowMap.enabled === false) return;
        let shadowColorNode = this.shadowColorNode;
        if (shadowColorNode === null) {
            const customShadowNode = this.light.shadow.shadowNode;
            let shadowNode;
            if (customShadowNode !== undefined) shadowNode = $03ccd63b0299d6a7$var$nodeObject(customShadowNode);
            else shadowNode = this.setupShadowNode();
            this.shadowNode = shadowNode;
            this.shadowColorNode = shadowColorNode = this.colorNode.mul(shadowNode);
            this.baseColorNode = this.colorNode;
        }
        //
        if (builder.context.getShadow) shadowColorNode = builder.context.getShadow(this, builder);
        this.colorNode = shadowColorNode;
    }
    /**
	 * Unlike most other nodes, lighting nodes do not return a output node in {@link Node#setup}.
	 * The main purpose of lighting nodes is to configure the current {@link LightingModel} and/or
	 * invocate the respective interface methods.
	 *
	 * @param {NodeBuilder} builder - The current node builder.
	 */ setup(builder) {
        this.colorNode = this.baseColorNode || this.colorNode;
        if (this.light.castShadow) {
            if (builder.object.receiveShadow) this.setupShadow(builder);
        } else if (this.shadowNode !== null) {
            this.shadowNode.dispose();
            this.shadowNode = null;
            this.shadowColorNode = null;
        }
        const directLightData = this.setupDirect(builder);
        const directRectAreaLightData = this.setupDirectRectArea(builder);
        if (directLightData) builder.lightsNode.setupDirectLight(builder, this, directLightData);
        if (directRectAreaLightData) builder.lightsNode.setupDirectRectAreaLight(builder, this, directRectAreaLightData);
    }
    /**
	 * The update method is used to update light uniforms per frame.
	 * Potentially overwritten in concrete light nodes to update light
	 * specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update() {
        const { light: light } = this;
        this.color.copy(light.color).multiplyScalar(light.intensity);
    }
}
/**
 * Represents a `discard` shader operation in TSL.
 *
 * @method
 * @param {Object} inputs - The input parameter object.
 * @param {Node<float>} inputs.lightDistance - The distance of the light's position to the current fragment position.
 * @param {Node<float>} inputs.cutoffDistance - The light's cutoff distance.
 * @param {Node<float>} inputs.decayExponent - The light's decay exponent.
 * @return {Node<float>} The distance falloff.
 */ const $03ccd63b0299d6a7$var$getDistanceAttenuation = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(({ lightDistance: lightDistance, cutoffDistance: cutoffDistance, decayExponent: decayExponent })=>{
    // based upon Frostbite 3 Moving to Physically-based Rendering
    // page 32, equation 26: E[window1]
    // https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
    const distanceFalloff = lightDistance.pow(decayExponent).max(0.01).reciprocal();
    return cutoffDistance.greaterThan(0).select(distanceFalloff.mul(lightDistance.div(cutoffDistance).pow4().oneMinus().clamp().pow2()), distanceFalloff);
}); // validated
const $03ccd63b0299d6a7$var$directPointLight = ({ color: color, lightVector: lightVector, cutoffDistance: cutoffDistance, decayExponent: decayExponent })=>{
    const lightDirection = lightVector.normalize();
    const lightDistance = lightVector.length();
    const attenuation = $03ccd63b0299d6a7$var$getDistanceAttenuation({
        lightDistance: lightDistance,
        cutoffDistance: cutoffDistance,
        decayExponent: decayExponent
    });
    const lightColor = color.mul(attenuation);
    return {
        lightDirection: lightDirection,
        lightColor: lightColor
    };
};
/**
 * Module for representing point lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$8613ba691750588b extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'PointLightNode';
    }
    /**
	 * Constructs a new point light node.
	 *
	 * @param {?PointLight} [light=null] - The point light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the cutoff distance.
		 *
		 * @type {UniformNode<float>}
		 */ this.cutoffDistanceNode = $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the decay exponent.
		 *
		 * @type {UniformNode<float>}
		 */ this.decayExponentNode = $03ccd63b0299d6a7$var$uniform(2).setGroup($03ccd63b0299d6a7$var$renderGroup);
    }
    /**
	 * Overwritten to updated point light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    /**
	 * Overwritten to setup point light specific shadow.
	 *
	 * @return {PointShadowNode}
	 */ setupShadowNode() {
        return $03ccd63b0299d6a7$var$pointShadow(this.light);
    }
    setupDirect(builder) {
        return $03ccd63b0299d6a7$var$directPointLight({
            color: this.colorNode,
            lightVector: this.getLightVector(builder),
            cutoffDistance: this.cutoffDistanceNode,
            decayExponent: this.decayExponentNode
        });
    }
}
/**
 * Creates a 2x2 checkerboard pattern that can be used as procedural texture data.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} coord - The uv coordinates.
 * @return {Node<float>} The result data.
 */ const $03ccd63b0299d6a7$var$checker = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([coord = $03ccd63b0299d6a7$var$uv$1()])=>{
    const uv = coord.mul(2.0);
    const cx = uv.x.floor();
    const cy = uv.y.floor();
    const result = cx.add(cy).mod(2.0);
    return result.sign();
});
/**
 * Generates a circle based on the uv coordinates.
 *
 * @tsl
 * @function
 * @param {Node<vec2>} coord - The uv to generate the circle.
 * @return {Node<float>} The circle shape.
 */ const $03ccd63b0299d6a7$var$shapeCircle = $03ccd63b0299d6a7$var$Fn(([coord = $03ccd63b0299d6a7$var$uv$1()], { renderer: renderer, material: material })=>{
    const len2 = $03ccd63b0299d6a7$var$lengthSq(coord.mul(2).sub(1));
    let alpha;
    if (material.alphaToCoverage && renderer.currentSamples > 0) {
        const dlen = $03ccd63b0299d6a7$var$float(len2.fwidth()).toVar();
        alpha = $03ccd63b0299d6a7$var$smoothstep(dlen.oneMinus(), dlen.add(1), len2).oneMinus();
    } else alpha = $03ccd63b0299d6a7$var$select(len2.greaterThan(1.0), 0, 1);
    return alpha;
});
// Three.js Transpiler
// https://raw.githubusercontent.com/AcademySoftwareFoundation/MaterialX/main/libraries/stdlib/genglsl/lib/mx_noise.glsl
const $03ccd63b0299d6a7$var$mx_select = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([b_immutable, t_immutable, f_immutable])=>{
    const f = $03ccd63b0299d6a7$var$float(f_immutable).toVar();
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    const b = $03ccd63b0299d6a7$var$bool(b_immutable).toVar();
    return $03ccd63b0299d6a7$var$select(b, t, f);
}).setLayout({
    name: 'mx_select',
    type: 'float',
    inputs: [
        {
            name: 'b',
            type: 'bool'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'f',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_negate_if = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([val_immutable, b_immutable])=>{
    const b = $03ccd63b0299d6a7$var$bool(b_immutable).toVar();
    const val = $03ccd63b0299d6a7$var$float(val_immutable).toVar();
    return $03ccd63b0299d6a7$var$select(b, val.negate(), val);
}).setLayout({
    name: 'mx_negate_if',
    type: 'float',
    inputs: [
        {
            name: 'val',
            type: 'float'
        },
        {
            name: 'b',
            type: 'bool'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_floor = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable])=>{
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    return $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$floor(x));
}).setLayout({
    name: 'mx_floor',
    type: 'int',
    inputs: [
        {
            name: 'x',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_floorfrac = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, i])=>{
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    i.assign($03ccd63b0299d6a7$var$mx_floor(x));
    return x.sub($03ccd63b0299d6a7$var$float(i));
});
const $03ccd63b0299d6a7$var$mx_bilerp_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    const s = $03ccd63b0299d6a7$var$float(s_immutable).toVar();
    const v3 = $03ccd63b0299d6a7$var$float(v3_immutable).toVar();
    const v2 = $03ccd63b0299d6a7$var$float(v2_immutable).toVar();
    const v1 = $03ccd63b0299d6a7$var$float(v1_immutable).toVar();
    const v0 = $03ccd63b0299d6a7$var$float(v0_immutable).toVar();
    const s1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, s)).toVar();
    return $03ccd63b0299d6a7$var$sub(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_bilerp_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, s_immutable, t_immutable])=>{
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    const s = $03ccd63b0299d6a7$var$float(s_immutable).toVar();
    const v3 = $03ccd63b0299d6a7$var$vec3(v3_immutable).toVar();
    const v2 = $03ccd63b0299d6a7$var$vec3(v2_immutable).toVar();
    const v1 = $03ccd63b0299d6a7$var$vec3(v1_immutable).toVar();
    const v0 = $03ccd63b0299d6a7$var$vec3(v0_immutable).toVar();
    const s1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, s)).toVar();
    return $03ccd63b0299d6a7$var$sub(1.0, t).mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))));
}).setLayout({
    name: 'mx_bilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_bilerp = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_bilerp_0,
    $03ccd63b0299d6a7$var$mx_bilerp_1
]);
const $03ccd63b0299d6a7$var$mx_trilerp_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = $03ccd63b0299d6a7$var$float(r_immutable).toVar();
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    const s = $03ccd63b0299d6a7$var$float(s_immutable).toVar();
    const v7 = $03ccd63b0299d6a7$var$float(v7_immutable).toVar();
    const v6 = $03ccd63b0299d6a7$var$float(v6_immutable).toVar();
    const v5 = $03ccd63b0299d6a7$var$float(v5_immutable).toVar();
    const v4 = $03ccd63b0299d6a7$var$float(v4_immutable).toVar();
    const v3 = $03ccd63b0299d6a7$var$float(v3_immutable).toVar();
    const v2 = $03ccd63b0299d6a7$var$float(v2_immutable).toVar();
    const v1 = $03ccd63b0299d6a7$var$float(v1_immutable).toVar();
    const v0 = $03ccd63b0299d6a7$var$float(v0_immutable).toVar();
    const s1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, s)).toVar();
    const t1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, t)).toVar();
    const r1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_0',
    type: 'float',
    inputs: [
        {
            name: 'v0',
            type: 'float'
        },
        {
            name: 'v1',
            type: 'float'
        },
        {
            name: 'v2',
            type: 'float'
        },
        {
            name: 'v3',
            type: 'float'
        },
        {
            name: 'v4',
            type: 'float'
        },
        {
            name: 'v5',
            type: 'float'
        },
        {
            name: 'v6',
            type: 'float'
        },
        {
            name: 'v7',
            type: 'float'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_trilerp_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v0_immutable, v1_immutable, v2_immutable, v3_immutable, v4_immutable, v5_immutable, v6_immutable, v7_immutable, s_immutable, t_immutable, r_immutable])=>{
    const r = $03ccd63b0299d6a7$var$float(r_immutable).toVar();
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    const s = $03ccd63b0299d6a7$var$float(s_immutable).toVar();
    const v7 = $03ccd63b0299d6a7$var$vec3(v7_immutable).toVar();
    const v6 = $03ccd63b0299d6a7$var$vec3(v6_immutable).toVar();
    const v5 = $03ccd63b0299d6a7$var$vec3(v5_immutable).toVar();
    const v4 = $03ccd63b0299d6a7$var$vec3(v4_immutable).toVar();
    const v3 = $03ccd63b0299d6a7$var$vec3(v3_immutable).toVar();
    const v2 = $03ccd63b0299d6a7$var$vec3(v2_immutable).toVar();
    const v1 = $03ccd63b0299d6a7$var$vec3(v1_immutable).toVar();
    const v0 = $03ccd63b0299d6a7$var$vec3(v0_immutable).toVar();
    const s1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, s)).toVar();
    const t1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, t)).toVar();
    const r1 = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$sub(1.0, r)).toVar();
    return r1.mul(t1.mul(v0.mul(s1).add(v1.mul(s))).add(t.mul(v2.mul(s1).add(v3.mul(s))))).add(r.mul(t1.mul(v4.mul(s1).add(v5.mul(s))).add(t.mul(v6.mul(s1).add(v7.mul(s))))));
}).setLayout({
    name: 'mx_trilerp_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v0',
            type: 'vec3'
        },
        {
            name: 'v1',
            type: 'vec3'
        },
        {
            name: 'v2',
            type: 'vec3'
        },
        {
            name: 'v3',
            type: 'vec3'
        },
        {
            name: 'v4',
            type: 'vec3'
        },
        {
            name: 'v5',
            type: 'vec3'
        },
        {
            name: 'v6',
            type: 'vec3'
        },
        {
            name: 'v7',
            type: 'vec3'
        },
        {
            name: 's',
            type: 'float'
        },
        {
            name: 't',
            type: 'float'
        },
        {
            name: 'r',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_trilerp = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_trilerp_0,
    $03ccd63b0299d6a7$var$mx_trilerp_1
]);
const $03ccd63b0299d6a7$var$mx_gradient_float_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([hash_immutable, x_immutable, y_immutable])=>{
    const y = $03ccd63b0299d6a7$var$float(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    const hash = $03ccd63b0299d6a7$var$uint(hash_immutable).toVar();
    const h = $03ccd63b0299d6a7$var$uint(hash.bitAnd($03ccd63b0299d6a7$var$uint(7))).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_select(h.lessThan($03ccd63b0299d6a7$var$uint(4)), x, y)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mul(2.0, $03ccd63b0299d6a7$var$mx_select(h.lessThan($03ccd63b0299d6a7$var$uint(4)), y, x))).toVar();
    return $03ccd63b0299d6a7$var$mx_negate_if(u, $03ccd63b0299d6a7$var$bool(h.bitAnd($03ccd63b0299d6a7$var$uint(1)))).add($03ccd63b0299d6a7$var$mx_negate_if(v, $03ccd63b0299d6a7$var$bool(h.bitAnd($03ccd63b0299d6a7$var$uint(2)))));
}).setLayout({
    name: 'mx_gradient_float_0',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_float_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = $03ccd63b0299d6a7$var$float(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$float(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    const hash = $03ccd63b0299d6a7$var$uint(hash_immutable).toVar();
    const h = $03ccd63b0299d6a7$var$uint(hash.bitAnd($03ccd63b0299d6a7$var$uint(15))).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_select(h.lessThan($03ccd63b0299d6a7$var$uint(8)), x, y)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_select(h.lessThan($03ccd63b0299d6a7$var$uint(4)), y, $03ccd63b0299d6a7$var$mx_select(h.equal($03ccd63b0299d6a7$var$uint(12)).or(h.equal($03ccd63b0299d6a7$var$uint(14))), x, z))).toVar();
    return $03ccd63b0299d6a7$var$mx_negate_if(u, $03ccd63b0299d6a7$var$bool(h.bitAnd($03ccd63b0299d6a7$var$uint(1)))).add($03ccd63b0299d6a7$var$mx_negate_if(v, $03ccd63b0299d6a7$var$bool(h.bitAnd($03ccd63b0299d6a7$var$uint(2)))));
}).setLayout({
    name: 'mx_gradient_float_1',
    type: 'float',
    inputs: [
        {
            name: 'hash',
            type: 'uint'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_float = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_gradient_float_0,
    $03ccd63b0299d6a7$var$mx_gradient_float_1
]);
const $03ccd63b0299d6a7$var$mx_gradient_vec3_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([hash_immutable, x_immutable, y_immutable])=>{
    const y = $03ccd63b0299d6a7$var$float(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    const hash = $03ccd63b0299d6a7$var$uvec3(hash_immutable).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_gradient_float(hash.x, x, y), $03ccd63b0299d6a7$var$mx_gradient_float(hash.y, x, y), $03ccd63b0299d6a7$var$mx_gradient_float(hash.z, x, y));
}).setLayout({
    name: 'mx_gradient_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_vec3_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([hash_immutable, x_immutable, y_immutable, z_immutable])=>{
    const z = $03ccd63b0299d6a7$var$float(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$float(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$float(x_immutable).toVar();
    const hash = $03ccd63b0299d6a7$var$uvec3(hash_immutable).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_gradient_float(hash.x, x, y, z), $03ccd63b0299d6a7$var$mx_gradient_float(hash.y, x, y, z), $03ccd63b0299d6a7$var$mx_gradient_float(hash.z, x, y, z));
}).setLayout({
    name: 'mx_gradient_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'hash',
            type: 'uvec3'
        },
        {
            name: 'x',
            type: 'float'
        },
        {
            name: 'y',
            type: 'float'
        },
        {
            name: 'z',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_vec3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_gradient_vec3_0,
    $03ccd63b0299d6a7$var$mx_gradient_vec3_1
]);
const $03ccd63b0299d6a7$var$mx_gradient_scale2d_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v_immutable])=>{
    const v = $03ccd63b0299d6a7$var$float(v_immutable).toVar();
    return $03ccd63b0299d6a7$var$mul(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_scale3d_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v_immutable])=>{
    const v = $03ccd63b0299d6a7$var$float(v_immutable).toVar();
    return $03ccd63b0299d6a7$var$mul(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_0',
    type: 'float',
    inputs: [
        {
            name: 'v',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_scale2d_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v_immutable])=>{
    const v = $03ccd63b0299d6a7$var$vec3(v_immutable).toVar();
    return $03ccd63b0299d6a7$var$mul(0.6616, v);
}).setLayout({
    name: 'mx_gradient_scale2d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_scale2d = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_gradient_scale2d_0,
    $03ccd63b0299d6a7$var$mx_gradient_scale2d_1
]);
const $03ccd63b0299d6a7$var$mx_gradient_scale3d_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([v_immutable])=>{
    const v = $03ccd63b0299d6a7$var$vec3(v_immutable).toVar();
    return $03ccd63b0299d6a7$var$mul(0.9820, v);
}).setLayout({
    name: 'mx_gradient_scale3d_1',
    type: 'vec3',
    inputs: [
        {
            name: 'v',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_gradient_scale3d = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_gradient_scale3d_0,
    $03ccd63b0299d6a7$var$mx_gradient_scale3d_1
]);
const $03ccd63b0299d6a7$var$mx_rotl32 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, k_immutable])=>{
    const k = $03ccd63b0299d6a7$var$int(k_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$uint(x_immutable).toVar();
    return x.shiftLeft(k).bitOr(x.shiftRight($03ccd63b0299d6a7$var$int(32).sub(k)));
}).setLayout({
    name: 'mx_rotl32',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'uint'
        },
        {
            name: 'k',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_bjmix = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([a, b, c])=>{
    a.subAssign(c);
    a.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(c, $03ccd63b0299d6a7$var$int(4)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(a, $03ccd63b0299d6a7$var$int(6)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(b, $03ccd63b0299d6a7$var$int(8)));
    b.addAssign(a);
    a.subAssign(c);
    a.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(c, $03ccd63b0299d6a7$var$int(16)));
    c.addAssign(b);
    b.subAssign(a);
    b.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(a, $03ccd63b0299d6a7$var$int(19)));
    a.addAssign(c);
    c.subAssign(b);
    c.bitXorAssign($03ccd63b0299d6a7$var$mx_rotl32(b, $03ccd63b0299d6a7$var$int(4)));
    b.addAssign(a);
});
const $03ccd63b0299d6a7$var$mx_bjfinal = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([a_immutable, b_immutable, c_immutable])=>{
    const c = $03ccd63b0299d6a7$var$uint(c_immutable).toVar();
    const b = $03ccd63b0299d6a7$var$uint(b_immutable).toVar();
    const a = $03ccd63b0299d6a7$var$uint(a_immutable).toVar();
    c.bitXorAssign(b);
    c.subAssign($03ccd63b0299d6a7$var$mx_rotl32(b, $03ccd63b0299d6a7$var$int(14)));
    a.bitXorAssign(c);
    a.subAssign($03ccd63b0299d6a7$var$mx_rotl32(c, $03ccd63b0299d6a7$var$int(11)));
    b.bitXorAssign(a);
    b.subAssign($03ccd63b0299d6a7$var$mx_rotl32(a, $03ccd63b0299d6a7$var$int(25)));
    c.bitXorAssign(b);
    c.subAssign($03ccd63b0299d6a7$var$mx_rotl32(b, $03ccd63b0299d6a7$var$int(16)));
    a.bitXorAssign(c);
    a.subAssign($03ccd63b0299d6a7$var$mx_rotl32(c, $03ccd63b0299d6a7$var$int(4)));
    b.bitXorAssign(a);
    b.subAssign($03ccd63b0299d6a7$var$mx_rotl32(a, $03ccd63b0299d6a7$var$int(14)));
    c.bitXorAssign(b);
    c.subAssign($03ccd63b0299d6a7$var$mx_rotl32(b, $03ccd63b0299d6a7$var$int(24)));
    return c;
}).setLayout({
    name: 'mx_bjfinal',
    type: 'uint',
    inputs: [
        {
            name: 'a',
            type: 'uint'
        },
        {
            name: 'b',
            type: 'uint'
        },
        {
            name: 'c',
            type: 'uint'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_bits_to_01 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([bits_immutable])=>{
    const bits = $03ccd63b0299d6a7$var$uint(bits_immutable).toVar();
    return $03ccd63b0299d6a7$var$float(bits).div($03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xffffffff))));
}).setLayout({
    name: 'mx_bits_to_01',
    type: 'float',
    inputs: [
        {
            name: 'bits',
            type: 'uint'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_fade = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([t_immutable])=>{
    const t = $03ccd63b0299d6a7$var$float(t_immutable).toVar();
    return t.mul(t).mul(t).mul(t.mul(t.mul(6.0).sub(15.0)).add(10.0));
}).setLayout({
    name: 'mx_fade',
    type: 'float',
    inputs: [
        {
            name: 't',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable])=>{
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const len = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint(1)).toVar();
    const seed = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xdeadbeef)).add(len.shiftLeft($03ccd63b0299d6a7$var$uint(2))).add($03ccd63b0299d6a7$var$uint(13))).toVar();
    return $03ccd63b0299d6a7$var$mx_bjfinal(seed.add($03ccd63b0299d6a7$var$uint(x)), seed, seed);
}).setLayout({
    name: 'mx_hash_int_0',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable])=>{
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const len = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint(2)).toVar();
    const a = $03ccd63b0299d6a7$var$uint().toVar(), b = $03ccd63b0299d6a7$var$uint().toVar(), c = $03ccd63b0299d6a7$var$uint().toVar();
    a.assign(b.assign(c.assign($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xdeadbeef)).add(len.shiftLeft($03ccd63b0299d6a7$var$uint(2))).add($03ccd63b0299d6a7$var$uint(13)))));
    a.addAssign($03ccd63b0299d6a7$var$uint(x));
    b.addAssign($03ccd63b0299d6a7$var$uint(y));
    return $03ccd63b0299d6a7$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_1',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int_2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable, z_immutable])=>{
    const z = $03ccd63b0299d6a7$var$int(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const len = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint(3)).toVar();
    const a = $03ccd63b0299d6a7$var$uint().toVar(), b = $03ccd63b0299d6a7$var$uint().toVar(), c = $03ccd63b0299d6a7$var$uint().toVar();
    a.assign(b.assign(c.assign($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xdeadbeef)).add(len.shiftLeft($03ccd63b0299d6a7$var$uint(2))).add($03ccd63b0299d6a7$var$uint(13)))));
    a.addAssign($03ccd63b0299d6a7$var$uint(x));
    b.addAssign($03ccd63b0299d6a7$var$uint(y));
    c.addAssign($03ccd63b0299d6a7$var$uint(z));
    return $03ccd63b0299d6a7$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_2',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int_3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable, z_immutable, xx_immutable])=>{
    const xx = $03ccd63b0299d6a7$var$int(xx_immutable).toVar();
    const z = $03ccd63b0299d6a7$var$int(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const len = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint(4)).toVar();
    const a = $03ccd63b0299d6a7$var$uint().toVar(), b = $03ccd63b0299d6a7$var$uint().toVar(), c = $03ccd63b0299d6a7$var$uint().toVar();
    a.assign(b.assign(c.assign($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xdeadbeef)).add(len.shiftLeft($03ccd63b0299d6a7$var$uint(2))).add($03ccd63b0299d6a7$var$uint(13)))));
    a.addAssign($03ccd63b0299d6a7$var$uint(x));
    b.addAssign($03ccd63b0299d6a7$var$uint(y));
    c.addAssign($03ccd63b0299d6a7$var$uint(z));
    $03ccd63b0299d6a7$var$mx_bjmix(a, b, c);
    a.addAssign($03ccd63b0299d6a7$var$uint(xx));
    return $03ccd63b0299d6a7$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_3',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int_4 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable, z_immutable, xx_immutable, yy_immutable])=>{
    const yy = $03ccd63b0299d6a7$var$int(yy_immutable).toVar();
    const xx = $03ccd63b0299d6a7$var$int(xx_immutable).toVar();
    const z = $03ccd63b0299d6a7$var$int(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const len = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$uint(5)).toVar();
    const a = $03ccd63b0299d6a7$var$uint().toVar(), b = $03ccd63b0299d6a7$var$uint().toVar(), c = $03ccd63b0299d6a7$var$uint().toVar();
    a.assign(b.assign(c.assign($03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$int(0xdeadbeef)).add(len.shiftLeft($03ccd63b0299d6a7$var$uint(2))).add($03ccd63b0299d6a7$var$uint(13)))));
    a.addAssign($03ccd63b0299d6a7$var$uint(x));
    b.addAssign($03ccd63b0299d6a7$var$uint(y));
    c.addAssign($03ccd63b0299d6a7$var$uint(z));
    $03ccd63b0299d6a7$var$mx_bjmix(a, b, c);
    a.addAssign($03ccd63b0299d6a7$var$uint(xx));
    b.addAssign($03ccd63b0299d6a7$var$uint(yy));
    return $03ccd63b0299d6a7$var$mx_bjfinal(a, b, c);
}).setLayout({
    name: 'mx_hash_int_4',
    type: 'uint',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xx',
            type: 'int'
        },
        {
            name: 'yy',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_int = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_hash_int_0,
    $03ccd63b0299d6a7$var$mx_hash_int_1,
    $03ccd63b0299d6a7$var$mx_hash_int_2,
    $03ccd63b0299d6a7$var$mx_hash_int_3,
    $03ccd63b0299d6a7$var$mx_hash_int_4
]);
const $03ccd63b0299d6a7$var$mx_hash_vec3_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable])=>{
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const h = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$mx_hash_int(x, y)).toVar();
    const result = $03ccd63b0299d6a7$var$uvec3().toVar();
    result.x.assign(h.bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    result.y.assign(h.shiftRight($03ccd63b0299d6a7$var$int(8)).bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    result.z.assign(h.shiftRight($03ccd63b0299d6a7$var$int(16)).bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_0',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_vec3_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([x_immutable, y_immutable, z_immutable])=>{
    const z = $03ccd63b0299d6a7$var$int(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const h = $03ccd63b0299d6a7$var$uint($03ccd63b0299d6a7$var$mx_hash_int(x, y, z)).toVar();
    const result = $03ccd63b0299d6a7$var$uvec3().toVar();
    result.x.assign(h.bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    result.y.assign(h.shiftRight($03ccd63b0299d6a7$var$int(8)).bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    result.z.assign(h.shiftRight($03ccd63b0299d6a7$var$int(16)).bitAnd($03ccd63b0299d6a7$var$int(0xFF)));
    return result;
}).setLayout({
    name: 'mx_hash_vec3_1',
    type: 'uvec3',
    inputs: [
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_hash_vec3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_hash_vec3_0,
    $03ccd63b0299d6a7$var$mx_hash_vec3_1
]);
const $03ccd63b0299d6a7$var$mx_perlin_noise_float_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar();
    const fx = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fx)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fy)).toVar();
    const result = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_bilerp($03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y), fx, fy), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y), fx.sub(1.0), fy), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y.add($03ccd63b0299d6a7$var$int(1))), fx, fy.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $03ccd63b0299d6a7$var$mx_gradient_scale2d(result);
}).setLayout({
    name: 'mx_perlin_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_perlin_noise_float_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar(), Z = $03ccd63b0299d6a7$var$int().toVar();
    const fx = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const fz = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.z, Z)).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fx)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fy)).toVar();
    const w = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fz)).toVar();
    const result = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_trilerp($03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y, Z), fx, fy, fz), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y, Z), fx.sub(1.0), fy, fz), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y.add($03ccd63b0299d6a7$var$int(1)), Z), fx, fy.sub(1.0), fz), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y, Z.add($03ccd63b0299d6a7$var$int(1))), fx, fy, fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y, Z.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy, fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X, Y.add($03ccd63b0299d6a7$var$int(1)), Z.add($03ccd63b0299d6a7$var$int(1))), fx, fy.sub(1.0), fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_float($03ccd63b0299d6a7$var$mx_hash_int(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1)), Z.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $03ccd63b0299d6a7$var$mx_gradient_scale3d(result);
}).setLayout({
    name: 'mx_perlin_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_perlin_noise_float = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_perlin_noise_float_0,
    $03ccd63b0299d6a7$var$mx_perlin_noise_float_1
]);
const $03ccd63b0299d6a7$var$mx_perlin_noise_vec3_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar();
    const fx = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fx)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fy)).toVar();
    const result = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_bilerp($03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y), fx, fy), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y), fx.sub(1.0), fy), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y.add($03ccd63b0299d6a7$var$int(1))), fx, fy.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy.sub(1.0)), u, v)).toVar();
    return $03ccd63b0299d6a7$var$mx_gradient_scale2d(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_perlin_noise_vec3_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar(), Z = $03ccd63b0299d6a7$var$int().toVar();
    const fx = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X)).toVar();
    const fy = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const fz = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_floorfrac(p.z, Z)).toVar();
    const u = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fx)).toVar();
    const v = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fy)).toVar();
    const w = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fade(fz)).toVar();
    const result = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_trilerp($03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y, Z), fx, fy, fz), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y, Z), fx.sub(1.0), fy, fz), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y.add($03ccd63b0299d6a7$var$int(1)), Z), fx, fy.sub(1.0), fz), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1)), Z), fx.sub(1.0), fy.sub(1.0), fz), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y, Z.add($03ccd63b0299d6a7$var$int(1))), fx, fy, fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y, Z.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy, fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X, Y.add($03ccd63b0299d6a7$var$int(1)), Z.add($03ccd63b0299d6a7$var$int(1))), fx, fy.sub(1.0), fz.sub(1.0)), $03ccd63b0299d6a7$var$mx_gradient_vec3($03ccd63b0299d6a7$var$mx_hash_vec3(X.add($03ccd63b0299d6a7$var$int(1)), Y.add($03ccd63b0299d6a7$var$int(1)), Z.add($03ccd63b0299d6a7$var$int(1))), fx.sub(1.0), fy.sub(1.0), fz.sub(1.0)), u, v, w)).toVar();
    return $03ccd63b0299d6a7$var$mx_gradient_scale3d(result);
}).setLayout({
    name: 'mx_perlin_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_perlin_noise_vec3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_perlin_noise_vec3_0,
    $03ccd63b0299d6a7$var$mx_perlin_noise_vec3_1
]);
const $03ccd63b0299d6a7$var$mx_cell_noise_float_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$float(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p)).toVar();
    return $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix));
}).setLayout({
    name: 'mx_cell_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_float_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    return $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy));
}).setLayout({
    name: 'mx_cell_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_float_2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    const iz = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.z)).toVar();
    return $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz));
}).setLayout({
    name: 'mx_cell_noise_float_2',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_float_3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec4(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    const iz = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.z)).toVar();
    const iw = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.w)).toVar();
    return $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, iw));
}).setLayout({
    name: 'mx_cell_noise_float_3',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_float$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_cell_noise_float_0,
    $03ccd63b0299d6a7$var$mx_cell_noise_float_1,
    $03ccd63b0299d6a7$var$mx_cell_noise_float_2,
    $03ccd63b0299d6a7$var$mx_cell_noise_float_3
]);
const $03ccd63b0299d6a7$var$mx_cell_noise_vec3_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$float(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p)).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, $03ccd63b0299d6a7$var$int(0))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, $03ccd63b0299d6a7$var$int(1))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, $03ccd63b0299d6a7$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_vec3_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, $03ccd63b0299d6a7$var$int(0))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, $03ccd63b0299d6a7$var$int(1))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, $03ccd63b0299d6a7$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_vec3_2 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    const iz = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.z)).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, $03ccd63b0299d6a7$var$int(0))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, $03ccd63b0299d6a7$var$int(1))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, $03ccd63b0299d6a7$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_2',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_vec3_3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable])=>{
    const p = $03ccd63b0299d6a7$var$vec4(p_immutable).toVar();
    const ix = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.x)).toVar();
    const iy = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.y)).toVar();
    const iz = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.z)).toVar();
    const iw = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$mx_floor(p.w)).toVar();
    return $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, iw, $03ccd63b0299d6a7$var$int(0))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, iw, $03ccd63b0299d6a7$var$int(1))), $03ccd63b0299d6a7$var$mx_bits_to_01($03ccd63b0299d6a7$var$mx_hash_int(ix, iy, iz, iw, $03ccd63b0299d6a7$var$int(2))));
}).setLayout({
    name: 'mx_cell_noise_vec3_3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec4'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_cell_noise_vec3 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_cell_noise_vec3_0,
    $03ccd63b0299d6a7$var$mx_cell_noise_vec3_1,
    $03ccd63b0299d6a7$var$mx_cell_noise_vec3_2,
    $03ccd63b0299d6a7$var$mx_cell_noise_vec3_3
]);
const $03ccd63b0299d6a7$var$mx_fractal_noise_float$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const result = $03ccd63b0299d6a7$var$float(0.0).toVar();
    const amplitude = $03ccd63b0299d6a7$var$float(1.0).toVar();
    $03ccd63b0299d6a7$var$Loop(octaves, ()=>{
        result.addAssign(amplitude.mul($03ccd63b0299d6a7$var$mx_perlin_noise_float(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_float',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec3$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const result = $03ccd63b0299d6a7$var$vec3(0.0).toVar();
    const amplitude = $03ccd63b0299d6a7$var$float(1.0).toVar();
    $03ccd63b0299d6a7$var$Loop(octaves, ()=>{
        result.addAssign(amplitude.mul($03ccd63b0299d6a7$var$mx_perlin_noise_vec3(p)));
        amplitude.mulAssign(diminish);
        p.mulAssign(lacunarity);
    });
    return result;
}).setLayout({
    name: 'mx_fractal_noise_vec3',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec2$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    return $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$mx_fractal_noise_float$1(p, octaves, lacunarity, diminish), $03ccd63b0299d6a7$var$mx_fractal_noise_float$1(p.add($03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$int(19), $03ccd63b0299d6a7$var$int(193), $03ccd63b0299d6a7$var$int(17))), octaves, lacunarity, diminish));
}).setLayout({
    name: 'mx_fractal_noise_vec2',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec4$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const c = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_fractal_noise_vec3$1(p, octaves, lacunarity, diminish)).toVar();
    const f = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_fractal_noise_float$1(p.add($03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$int(19), $03ccd63b0299d6a7$var$int(193), $03ccd63b0299d6a7$var$int(17))), octaves, lacunarity, diminish)).toVar();
    return $03ccd63b0299d6a7$var$vec4(c, f);
}).setLayout({
    name: 'mx_fractal_noise_vec4',
    type: 'vec4',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_distance_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, x_immutable, y_immutable, xoff_immutable, yoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const yoff = $03ccd63b0299d6a7$var$int(yoff_immutable).toVar();
    const xoff = $03ccd63b0299d6a7$var$int(xoff_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const tmp = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_cell_noise_vec3($03ccd63b0299d6a7$var$vec2(x.add(xoff), y.add(yoff)))).toVar();
    const off = $03ccd63b0299d6a7$var$vec2(tmp.x, tmp.y).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$float(x), $03ccd63b0299d6a7$var$float(y)).add(off)).toVar();
    const diff = $03ccd63b0299d6a7$var$vec2(cellpos.sub(p)).toVar();
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(2)), ()=>{
        return $03ccd63b0299d6a7$var$abs(diff.x).add($03ccd63b0299d6a7$var$abs(diff.y));
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(3)), ()=>{
        return $03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$abs(diff.x), $03ccd63b0299d6a7$var$abs(diff.y));
    });
    return $03ccd63b0299d6a7$var$dot(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_distance_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, x_immutable, y_immutable, z_immutable, xoff_immutable, yoff_immutable, zoff_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const zoff = $03ccd63b0299d6a7$var$int(zoff_immutable).toVar();
    const yoff = $03ccd63b0299d6a7$var$int(yoff_immutable).toVar();
    const xoff = $03ccd63b0299d6a7$var$int(xoff_immutable).toVar();
    const z = $03ccd63b0299d6a7$var$int(z_immutable).toVar();
    const y = $03ccd63b0299d6a7$var$int(y_immutable).toVar();
    const x = $03ccd63b0299d6a7$var$int(x_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const off = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_cell_noise_vec3($03ccd63b0299d6a7$var$vec3(x.add(xoff), y.add(yoff), z.add(zoff)))).toVar();
    off.subAssign(0.5);
    off.mulAssign(jitter);
    off.addAssign(0.5);
    const cellpos = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$float(x), $03ccd63b0299d6a7$var$float(y), $03ccd63b0299d6a7$var$float(z)).add(off)).toVar();
    const diff = $03ccd63b0299d6a7$var$vec3(cellpos.sub(p)).toVar();
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(2)), ()=>{
        return $03ccd63b0299d6a7$var$abs(diff.x).add($03ccd63b0299d6a7$var$abs(diff.y)).add($03ccd63b0299d6a7$var$abs(diff.z));
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(3)), ()=>{
        return $03ccd63b0299d6a7$var$max$1($03ccd63b0299d6a7$var$abs(diff.x), $03ccd63b0299d6a7$var$abs(diff.y), $03ccd63b0299d6a7$var$abs(diff.z));
    });
    return $03ccd63b0299d6a7$var$dot(diff, diff);
}).setLayout({
    name: 'mx_worley_distance_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'x',
            type: 'int'
        },
        {
            name: 'y',
            type: 'int'
        },
        {
            name: 'z',
            type: 'int'
        },
        {
            name: 'xoff',
            type: 'int'
        },
        {
            name: 'yoff',
            type: 'int'
        },
        {
            name: 'zoff',
            type: 'int'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_distance = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_worley_distance_0,
    $03ccd63b0299d6a7$var$mx_worley_distance_1
]);
const $03ccd63b0299d6a7$var$mx_worley_noise_float_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$float(1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            sqdist.assign($03ccd63b0299d6a7$var$min$1(sqdist, dist));
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_0',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_vec2_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$vec2(1e6, 1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            $03ccd63b0299d6a7$var$If(dist.lessThan(sqdist.x), ()=>{
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.y.assign(dist);
            });
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_0',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_vec3_0 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec2(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec2($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$vec3(1e6, 1e6, 1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, X, Y, jitter, metric)).toVar();
            $03ccd63b0299d6a7$var$If(dist.lessThan(sqdist.x), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(sqdist.x);
                sqdist.x.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                sqdist.z.assign(sqdist.y);
                sqdist.y.assign(dist);
            }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                sqdist.z.assign(dist);
            });
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_0',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_float_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar(), Z = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y), $03ccd63b0299d6a7$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$float(1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $03ccd63b0299d6a7$var$Loop({
                start: -1,
                end: $03ccd63b0299d6a7$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                sqdist.assign($03ccd63b0299d6a7$var$min$1(sqdist, dist));
            });
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_float_1',
    type: 'float',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_float$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_worley_noise_float_0,
    $03ccd63b0299d6a7$var$mx_worley_noise_float_1
]);
const $03ccd63b0299d6a7$var$mx_worley_noise_vec2_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar(), Z = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y), $03ccd63b0299d6a7$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$vec2(1e6, 1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $03ccd63b0299d6a7$var$Loop({
                start: -1,
                end: $03ccd63b0299d6a7$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                $03ccd63b0299d6a7$var$If(dist.lessThan(sqdist.x), ()=>{
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.y.assign(dist);
                });
            });
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec2_1',
    type: 'vec2',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_vec2$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_worley_noise_vec2_0,
    $03ccd63b0299d6a7$var$mx_worley_noise_vec2_1
]);
const $03ccd63b0299d6a7$var$mx_worley_noise_vec3_1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p_immutable, jitter_immutable, metric_immutable])=>{
    const metric = $03ccd63b0299d6a7$var$int(metric_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const p = $03ccd63b0299d6a7$var$vec3(p_immutable).toVar();
    const X = $03ccd63b0299d6a7$var$int().toVar(), Y = $03ccd63b0299d6a7$var$int().toVar(), Z = $03ccd63b0299d6a7$var$int().toVar();
    const localpos = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$mx_floorfrac(p.x, X), $03ccd63b0299d6a7$var$mx_floorfrac(p.y, Y), $03ccd63b0299d6a7$var$mx_floorfrac(p.z, Z)).toVar();
    const sqdist = $03ccd63b0299d6a7$var$vec3(1e6, 1e6, 1e6).toVar();
    $03ccd63b0299d6a7$var$Loop({
        start: -1,
        end: $03ccd63b0299d6a7$var$int(1),
        name: 'x',
        condition: '<='
    }, ({ x: x })=>{
        $03ccd63b0299d6a7$var$Loop({
            start: -1,
            end: $03ccd63b0299d6a7$var$int(1),
            name: 'y',
            condition: '<='
        }, ({ y: y })=>{
            $03ccd63b0299d6a7$var$Loop({
                start: -1,
                end: $03ccd63b0299d6a7$var$int(1),
                name: 'z',
                condition: '<='
            }, ({ z: z })=>{
                const dist = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$mx_worley_distance(localpos, x, y, z, X, Y, Z, jitter, metric)).toVar();
                $03ccd63b0299d6a7$var$If(dist.lessThan(sqdist.x), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(sqdist.x);
                    sqdist.x.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.y), ()=>{
                    sqdist.z.assign(sqdist.y);
                    sqdist.y.assign(dist);
                }).ElseIf(dist.lessThan(sqdist.z), ()=>{
                    sqdist.z.assign(dist);
                });
            });
        });
    });
    $03ccd63b0299d6a7$var$If(metric.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        sqdist.assign($03ccd63b0299d6a7$var$sqrt(sqdist));
    });
    return sqdist;
}).setLayout({
    name: 'mx_worley_noise_vec3_1',
    type: 'vec3',
    inputs: [
        {
            name: 'p',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'metric',
            type: 'int'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_worley_noise_vec3$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$overloadingFn([
    $03ccd63b0299d6a7$var$mx_worley_noise_vec3_0,
    $03ccd63b0299d6a7$var$mx_worley_noise_vec3_1
]);
// Unified Noise 2D
const $03ccd63b0299d6a7$var$mx_unifiednoise2d$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([noiseType_immutable, texcoord_immutable, freq_immutable, offset_immutable, jitter_immutable, outmin_immutable, outmax_immutable, clampoutput_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const noiseType = $03ccd63b0299d6a7$var$int(noiseType_immutable).toVar();
    const texcoord = $03ccd63b0299d6a7$var$vec2(texcoord_immutable).toVar();
    const freq = $03ccd63b0299d6a7$var$vec2(freq_immutable).toVar();
    const offset = $03ccd63b0299d6a7$var$vec2(offset_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const outmin = $03ccd63b0299d6a7$var$float(outmin_immutable).toVar();
    const outmax = $03ccd63b0299d6a7$var$float(outmax_immutable).toVar();
    const clampoutput = $03ccd63b0299d6a7$var$bool(clampoutput_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    // Compute input position
    const p = texcoord.mul(freq).add(offset);
    const result = $03ccd63b0299d6a7$var$float(0.0).toVar();
    // Perlin
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_perlin_noise_vec3(p));
    });
    // Cell
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(1)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_cell_noise_vec3(p));
    });
    // Worley (metric=0 = euclidean)
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(2)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_worley_noise_vec3$1(p, jitter, $03ccd63b0299d6a7$var$int(0)));
    });
    // Fractal (use vec3(p, 0.0) for 2D input)
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(3)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_fractal_noise_vec3$1($03ccd63b0299d6a7$var$vec3(p, 0.0), octaves, lacunarity, diminish));
    });
    // Remap output to [outmin, outmax]
    result.assign(result.mul(outmax.sub(outmin)).add(outmin));
    // Clamp if requested
    $03ccd63b0299d6a7$var$If(clampoutput, ()=>{
        result.assign($03ccd63b0299d6a7$var$clamp(result, outmin, outmax));
    });
    return result;
}).setLayout({
    name: 'mx_unifiednoise2d',
    type: 'float',
    inputs: [
        {
            name: 'noiseType',
            type: 'int'
        },
        {
            name: 'texcoord',
            type: 'vec2'
        },
        {
            name: 'freq',
            type: 'vec2'
        },
        {
            name: 'offset',
            type: 'vec2'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'outmin',
            type: 'float'
        },
        {
            name: 'outmax',
            type: 'float'
        },
        {
            name: 'clampoutput',
            type: 'bool'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
// Unified Noise 3D
const $03ccd63b0299d6a7$var$mx_unifiednoise3d$1 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([noiseType_immutable, position_immutable, freq_immutable, offset_immutable, jitter_immutable, outmin_immutable, outmax_immutable, clampoutput_immutable, octaves_immutable, lacunarity_immutable, diminish_immutable])=>{
    const noiseType = $03ccd63b0299d6a7$var$int(noiseType_immutable).toVar();
    const position = $03ccd63b0299d6a7$var$vec3(position_immutable).toVar();
    const freq = $03ccd63b0299d6a7$var$vec3(freq_immutable).toVar();
    const offset = $03ccd63b0299d6a7$var$vec3(offset_immutable).toVar();
    const jitter = $03ccd63b0299d6a7$var$float(jitter_immutable).toVar();
    const outmin = $03ccd63b0299d6a7$var$float(outmin_immutable).toVar();
    const outmax = $03ccd63b0299d6a7$var$float(outmax_immutable).toVar();
    const clampoutput = $03ccd63b0299d6a7$var$bool(clampoutput_immutable).toVar();
    const octaves = $03ccd63b0299d6a7$var$int(octaves_immutable).toVar();
    const lacunarity = $03ccd63b0299d6a7$var$float(lacunarity_immutable).toVar();
    const diminish = $03ccd63b0299d6a7$var$float(diminish_immutable).toVar();
    // Compute input position
    const p = position.mul(freq).add(offset);
    const result = $03ccd63b0299d6a7$var$float(0.0).toVar();
    // Perlin
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_perlin_noise_vec3(p));
    });
    // Cell
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(1)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_cell_noise_vec3(p));
    });
    // Worley (metric=0 = euclidean)
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(2)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_worley_noise_vec3$1(p, jitter, $03ccd63b0299d6a7$var$int(0)));
    });
    // Fractal
    $03ccd63b0299d6a7$var$If(noiseType.equal($03ccd63b0299d6a7$var$int(3)), ()=>{
        result.assign($03ccd63b0299d6a7$var$mx_fractal_noise_vec3$1(p, octaves, lacunarity, diminish));
    });
    // Remap output to [outmin, outmax]
    result.assign(result.mul(outmax.sub(outmin)).add(outmin));
    // Clamp if requested
    $03ccd63b0299d6a7$var$If(clampoutput, ()=>{
        result.assign($03ccd63b0299d6a7$var$clamp(result, outmin, outmax));
    });
    return result;
}).setLayout({
    name: 'mx_unifiednoise3d',
    type: 'float',
    inputs: [
        {
            name: 'noiseType',
            type: 'int'
        },
        {
            name: 'position',
            type: 'vec3'
        },
        {
            name: 'freq',
            type: 'vec3'
        },
        {
            name: 'offset',
            type: 'vec3'
        },
        {
            name: 'jitter',
            type: 'float'
        },
        {
            name: 'outmin',
            type: 'float'
        },
        {
            name: 'outmax',
            type: 'float'
        },
        {
            name: 'clampoutput',
            type: 'bool'
        },
        {
            name: 'octaves',
            type: 'int'
        },
        {
            name: 'lacunarity',
            type: 'float'
        },
        {
            name: 'diminish',
            type: 'float'
        }
    ]
});
// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_hsv.glsl
const $03ccd63b0299d6a7$var$mx_hsvtorgb = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([hsv])=>{
    const s = hsv.y;
    const v = hsv.z;
    const result = $03ccd63b0299d6a7$var$vec3().toVar();
    $03ccd63b0299d6a7$var$If(s.lessThan(0.0001), ()=>{
        result.assign($03ccd63b0299d6a7$var$vec3(v, v, v));
    }).Else(()=>{
        let h = hsv.x;
        h = h.sub($03ccd63b0299d6a7$var$floor(h)).mul(6.0).toVar(); // TODO: check what .toVar() is needed in node system cache
        const hi = $03ccd63b0299d6a7$var$int($03ccd63b0299d6a7$var$trunc(h));
        const f = h.sub($03ccd63b0299d6a7$var$float(hi));
        const p = v.mul(s.oneMinus());
        const q = v.mul(s.mul(f).oneMinus());
        const t = v.mul(s.mul(f.oneMinus()).oneMinus());
        $03ccd63b0299d6a7$var$If(hi.equal($03ccd63b0299d6a7$var$int(0)), ()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(v, t, p));
        }).ElseIf(hi.equal($03ccd63b0299d6a7$var$int(1)), ()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(q, v, p));
        }).ElseIf(hi.equal($03ccd63b0299d6a7$var$int(2)), ()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(p, v, t));
        }).ElseIf(hi.equal($03ccd63b0299d6a7$var$int(3)), ()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(p, q, v));
        }).ElseIf(hi.equal($03ccd63b0299d6a7$var$int(4)), ()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(t, p, v));
        }).Else(()=>{
            result.assign($03ccd63b0299d6a7$var$vec3(v, p, q));
        });
    });
    return result;
}).setLayout({
    name: 'mx_hsvtorgb',
    type: 'vec3',
    inputs: [
        {
            name: 'hsv',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_rgbtohsv = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([c_immutable])=>{
    const c = $03ccd63b0299d6a7$var$vec3(c_immutable).toVar();
    const r = $03ccd63b0299d6a7$var$float(c.x).toVar();
    const g = $03ccd63b0299d6a7$var$float(c.y).toVar();
    const b = $03ccd63b0299d6a7$var$float(c.z).toVar();
    const mincomp = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$min$1(r, $03ccd63b0299d6a7$var$min$1(g, b))).toVar();
    const maxcomp = $03ccd63b0299d6a7$var$float($03ccd63b0299d6a7$var$max$1(r, $03ccd63b0299d6a7$var$max$1(g, b))).toVar();
    const delta = $03ccd63b0299d6a7$var$float(maxcomp.sub(mincomp)).toVar();
    const h = $03ccd63b0299d6a7$var$float().toVar(), s = $03ccd63b0299d6a7$var$float().toVar(), v = $03ccd63b0299d6a7$var$float().toVar();
    v.assign(maxcomp);
    $03ccd63b0299d6a7$var$If(maxcomp.greaterThan(0.0), ()=>{
        s.assign(delta.div(maxcomp));
    }).Else(()=>{
        s.assign(0.0);
    });
    $03ccd63b0299d6a7$var$If(s.lessThanEqual(0.0), ()=>{
        h.assign(0.0);
    }).Else(()=>{
        $03ccd63b0299d6a7$var$If(r.greaterThanEqual(maxcomp), ()=>{
            h.assign(g.sub(b).div(delta));
        }).ElseIf(g.greaterThanEqual(maxcomp), ()=>{
            h.assign($03ccd63b0299d6a7$var$add(2.0, b.sub(r).div(delta)));
        }).Else(()=>{
            h.assign($03ccd63b0299d6a7$var$add(4.0, r.sub(g).div(delta)));
        });
        h.mulAssign(1.0 / 6.0);
        $03ccd63b0299d6a7$var$If(h.lessThan(0.0), ()=>{
            h.addAssign(1.0);
        });
    });
    return $03ccd63b0299d6a7$var$vec3(h, s, v);
}).setLayout({
    name: 'mx_rgbtohsv',
    type: 'vec3',
    inputs: [
        {
            name: 'c',
            type: 'vec3'
        }
    ]
});
// Three.js Transpiler
// https://github.com/AcademySoftwareFoundation/MaterialX/blob/main/libraries/stdlib/genglsl/lib/mx_transform_color.glsl
const $03ccd63b0299d6a7$var$mx_srgb_texture_to_lin_rec709 = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([color_immutable])=>{
    const color = $03ccd63b0299d6a7$var$vec3(color_immutable).toVar();
    const isAbove = $03ccd63b0299d6a7$var$bvec3($03ccd63b0299d6a7$var$greaterThan(color, $03ccd63b0299d6a7$var$vec3(0.04045))).toVar();
    const linSeg = $03ccd63b0299d6a7$var$vec3(color.div(12.92)).toVar();
    const powSeg = $03ccd63b0299d6a7$var$vec3($03ccd63b0299d6a7$var$pow($03ccd63b0299d6a7$var$max$1(color.add($03ccd63b0299d6a7$var$vec3(0.055)), $03ccd63b0299d6a7$var$vec3(0.0)).div(1.055), $03ccd63b0299d6a7$var$vec3(2.4))).toVar();
    return $03ccd63b0299d6a7$var$mix(linSeg, powSeg, isAbove);
}).setLayout({
    name: 'mx_srgb_texture_to_lin_rec709',
    type: 'vec3',
    inputs: [
        {
            name: 'color',
            type: 'vec3'
        }
    ]
});
const $03ccd63b0299d6a7$var$mx_aastep = (threshold, value)=>{
    threshold = $03ccd63b0299d6a7$var$float(threshold);
    value = $03ccd63b0299d6a7$var$float(value);
    const afwidth = $03ccd63b0299d6a7$var$vec2(value.dFdx(), value.dFdy()).length().mul(0.70710678118654757);
    return $03ccd63b0299d6a7$var$smoothstep(threshold.sub(afwidth), threshold.add(afwidth), value);
};
const $03ccd63b0299d6a7$var$_ramp = (a, b, uv, p)=>$03ccd63b0299d6a7$var$mix(a, b, uv[p].clamp());
const $03ccd63b0299d6a7$var$mx_ramplr = (valuel, valuer, texcoord = $03ccd63b0299d6a7$var$uv$1())=>$03ccd63b0299d6a7$var$_ramp(valuel, valuer, texcoord, 'x');
const $03ccd63b0299d6a7$var$mx_ramptb = (valuet, valueb, texcoord = $03ccd63b0299d6a7$var$uv$1())=>$03ccd63b0299d6a7$var$_ramp(valuet, valueb, texcoord, 'y');
// Bilinear ramp: interpolate between four corners (tl, tr, bl, br) using texcoord.x and texcoord.y
const $03ccd63b0299d6a7$var$mx_ramp4 = (valuetl, valuetr, valuebl, valuebr, texcoord = $03ccd63b0299d6a7$var$uv$1())=>{
    const u = texcoord.x.clamp();
    const v = texcoord.y.clamp();
    const top = $03ccd63b0299d6a7$var$mix(valuetl, valuetr, u);
    const bottom = $03ccd63b0299d6a7$var$mix(valuebl, valuebr, u);
    return $03ccd63b0299d6a7$var$mix(top, bottom, v);
};
const $03ccd63b0299d6a7$var$_split = (a, b, center, uv, p)=>$03ccd63b0299d6a7$var$mix(a, b, $03ccd63b0299d6a7$var$mx_aastep(center, uv[p]));
const $03ccd63b0299d6a7$var$mx_splitlr = (valuel, valuer, center, texcoord = $03ccd63b0299d6a7$var$uv$1())=>$03ccd63b0299d6a7$var$_split(valuel, valuer, center, texcoord, 'x');
const $03ccd63b0299d6a7$var$mx_splittb = (valuet, valueb, center, texcoord = $03ccd63b0299d6a7$var$uv$1())=>$03ccd63b0299d6a7$var$_split(valuet, valueb, center, texcoord, 'y');
const $03ccd63b0299d6a7$var$mx_transform_uv = (uv_scale = 1, uv_offset = 0, uv_geo = $03ccd63b0299d6a7$var$uv$1())=>uv_geo.mul(uv_scale).add(uv_offset);
const $03ccd63b0299d6a7$var$mx_safepower = (in1, in2 = 1)=>{
    in1 = $03ccd63b0299d6a7$var$float(in1);
    return in1.abs().pow(in2).mul(in1.sign());
};
const $03ccd63b0299d6a7$var$mx_contrast = (input, amount = 1, pivot = .5)=>$03ccd63b0299d6a7$var$float(input).sub(pivot).mul(amount).add(pivot);
const $03ccd63b0299d6a7$var$mx_noise_float = (texcoord = $03ccd63b0299d6a7$var$uv$1(), amplitude = 1, pivot = 0)=>$03ccd63b0299d6a7$var$mx_perlin_noise_float(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
//export const mx_noise_vec2 = ( texcoord = uv(), amplitude = 1, pivot = 0 ) => mx_perlin_noise_vec3( texcoord.convert( 'vec2|vec3' ) ).mul( amplitude ).add( pivot );
const $03ccd63b0299d6a7$var$mx_noise_vec3 = (texcoord = $03ccd63b0299d6a7$var$uv$1(), amplitude = 1, pivot = 0)=>$03ccd63b0299d6a7$var$mx_perlin_noise_vec3(texcoord.convert('vec2|vec3')).mul(amplitude).add(pivot);
const $03ccd63b0299d6a7$var$mx_noise_vec4 = (texcoord = $03ccd63b0299d6a7$var$uv$1(), amplitude = 1, pivot = 0)=>{
    texcoord = texcoord.convert('vec2|vec3'); // overloading type
    const noise_vec4 = $03ccd63b0299d6a7$var$vec4($03ccd63b0299d6a7$var$mx_perlin_noise_vec3(texcoord), $03ccd63b0299d6a7$var$mx_perlin_noise_float(texcoord.add($03ccd63b0299d6a7$var$vec2(19, 73))));
    return noise_vec4.mul(amplitude).add(pivot);
};
const $03ccd63b0299d6a7$var$mx_unifiednoise2d = (noiseType, texcoord = $03ccd63b0299d6a7$var$uv$1(), freq = $03ccd63b0299d6a7$var$vec2(1, 1), offset = $03ccd63b0299d6a7$var$vec2(0, 0), jitter = 1, outmin = 0, outmax = 1, clampoutput = false, octaves = 1, lacunarity = 2, diminish = .5)=>$03ccd63b0299d6a7$var$mx_unifiednoise2d$1(noiseType, texcoord.convert('vec2|vec3'), freq, offset, jitter, outmin, outmax, clampoutput, octaves, lacunarity, diminish);
const $03ccd63b0299d6a7$var$mx_unifiednoise3d = (noiseType, texcoord = $03ccd63b0299d6a7$var$uv$1(), freq = $03ccd63b0299d6a7$var$vec2(1, 1), offset = $03ccd63b0299d6a7$var$vec2(0, 0), jitter = 1, outmin = 0, outmax = 1, clampoutput = false, octaves = 1, lacunarity = 2, diminish = .5)=>$03ccd63b0299d6a7$var$mx_unifiednoise3d$1(noiseType, texcoord.convert('vec2|vec3'), freq, offset, jitter, outmin, outmax, clampoutput, octaves, lacunarity, diminish);
const $03ccd63b0299d6a7$var$mx_worley_noise_float = (texcoord = $03ccd63b0299d6a7$var$uv$1(), jitter = 1)=>$03ccd63b0299d6a7$var$mx_worley_noise_float$1(texcoord.convert('vec2|vec3'), jitter, $03ccd63b0299d6a7$var$int(1));
const $03ccd63b0299d6a7$var$mx_worley_noise_vec2 = (texcoord = $03ccd63b0299d6a7$var$uv$1(), jitter = 1)=>$03ccd63b0299d6a7$var$mx_worley_noise_vec2$1(texcoord.convert('vec2|vec3'), jitter, $03ccd63b0299d6a7$var$int(1));
const $03ccd63b0299d6a7$var$mx_worley_noise_vec3 = (texcoord = $03ccd63b0299d6a7$var$uv$1(), jitter = 1)=>$03ccd63b0299d6a7$var$mx_worley_noise_vec3$1(texcoord.convert('vec2|vec3'), jitter, $03ccd63b0299d6a7$var$int(1));
const $03ccd63b0299d6a7$var$mx_cell_noise_float = (texcoord = $03ccd63b0299d6a7$var$uv$1())=>$03ccd63b0299d6a7$var$mx_cell_noise_float$1(texcoord.convert('vec2|vec3'));
const $03ccd63b0299d6a7$var$mx_fractal_noise_float = (position = $03ccd63b0299d6a7$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$03ccd63b0299d6a7$var$mx_fractal_noise_float$1(position, $03ccd63b0299d6a7$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec2 = (position = $03ccd63b0299d6a7$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$03ccd63b0299d6a7$var$mx_fractal_noise_vec2$1(position, $03ccd63b0299d6a7$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec3 = (position = $03ccd63b0299d6a7$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$03ccd63b0299d6a7$var$mx_fractal_noise_vec3$1(position, $03ccd63b0299d6a7$var$int(octaves), lacunarity, diminish).mul(amplitude);
const $03ccd63b0299d6a7$var$mx_fractal_noise_vec4 = (position = $03ccd63b0299d6a7$var$uv$1(), octaves = 3, lacunarity = 2, diminish = .5, amplitude = 1)=>$03ccd63b0299d6a7$var$mx_fractal_noise_vec4$1(position, $03ccd63b0299d6a7$var$int(octaves), lacunarity, diminish).mul(amplitude);
// === Moved from MaterialXLoader.js ===
// Math ops
const $03ccd63b0299d6a7$var$mx_add = (in1, in2 = $03ccd63b0299d6a7$var$float(0))=>$03ccd63b0299d6a7$var$add(in1, in2);
const $03ccd63b0299d6a7$var$mx_subtract = (in1, in2 = $03ccd63b0299d6a7$var$float(0))=>$03ccd63b0299d6a7$var$sub(in1, in2);
const $03ccd63b0299d6a7$var$mx_multiply = (in1, in2 = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$mul(in1, in2);
const $03ccd63b0299d6a7$var$mx_divide = (in1, in2 = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$div(in1, in2);
const $03ccd63b0299d6a7$var$mx_modulo = (in1, in2 = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$mod(in1, in2);
const $03ccd63b0299d6a7$var$mx_power = (in1, in2 = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$pow(in1, in2);
const $03ccd63b0299d6a7$var$mx_atan2 = (in1 = $03ccd63b0299d6a7$var$float(0), in2 = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$atan(in1, in2);
const $03ccd63b0299d6a7$var$mx_timer = ()=>$03ccd63b0299d6a7$var$time;
const $03ccd63b0299d6a7$var$mx_frame = ()=>$03ccd63b0299d6a7$var$frameId;
const $03ccd63b0299d6a7$var$mx_invert = (in1, amount = $03ccd63b0299d6a7$var$float(1))=>$03ccd63b0299d6a7$var$sub(amount, in1);
const $03ccd63b0299d6a7$var$mx_ifgreater = (value1, value2, in1, in2)=>value1.greaterThan(value2).mix(in1, in2);
const $03ccd63b0299d6a7$var$mx_ifgreatereq = (value1, value2, in1, in2)=>value1.greaterThanEqual(value2).mix(in1, in2);
const $03ccd63b0299d6a7$var$mx_ifequal = (value1, value2, in1, in2)=>value1.equal(value2).mix(in1, in2);
// Enhanced separate node to support multi-output referencing (outx, outy, outz, outw)
const $03ccd63b0299d6a7$var$mx_separate = (in1, channelOrOut = null)=>{
    if (typeof channelOrOut === 'string') {
        const map = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        };
        const c = channelOrOut.replace(/^out/, '').toLowerCase();
        if (map[c] !== undefined) return in1.element(map[c]);
    }
    if (typeof channelOrOut === 'number') return in1.element(channelOrOut);
    if (typeof channelOrOut === 'string' && channelOrOut.length === 1) {
        const map = {
            x: 0,
            r: 0,
            y: 1,
            g: 1,
            z: 2,
            b: 2,
            w: 3,
            a: 3
        };
        if (map[channelOrOut] !== undefined) return in1.element(map[channelOrOut]);
    }
    return in1;
};
const $03ccd63b0299d6a7$var$mx_place2d = (texcoord, pivot = $03ccd63b0299d6a7$var$vec2(0.5, 0.5), scale = $03ccd63b0299d6a7$var$vec2(1, 1), rotate = $03ccd63b0299d6a7$var$float(0), offset = $03ccd63b0299d6a7$var$vec2(0, 0))=>{
    let uv = texcoord;
    if (pivot) uv = uv.sub(pivot);
    if (scale) uv = uv.mul(scale);
    if (rotate) {
        const rad = rotate.mul(Math.PI / 180.0);
        const cosR = rad.cos();
        const sinR = rad.sin();
        uv = $03ccd63b0299d6a7$var$vec2(uv.x.mul(cosR).sub(uv.y.mul(sinR)), uv.x.mul(sinR).add(uv.y.mul(cosR)));
    }
    if (pivot) uv = uv.add(pivot);
    if (offset) uv = uv.add(offset);
    return uv;
};
const $03ccd63b0299d6a7$var$mx_rotate2d = (input, amount)=>{
    input = $03ccd63b0299d6a7$var$vec2(input);
    amount = $03ccd63b0299d6a7$var$float(amount);
    const radians = amount.mul(Math.PI / 180.0);
    return $03ccd63b0299d6a7$var$rotate(input, radians);
};
const $03ccd63b0299d6a7$var$mx_rotate3d = (input, amount, axis)=>{
    input = $03ccd63b0299d6a7$var$vec3(input);
    amount = $03ccd63b0299d6a7$var$float(amount);
    axis = $03ccd63b0299d6a7$var$vec3(axis);
    const radians = amount.mul(Math.PI / 180.0);
    const nAxis = axis.normalize();
    const cosA = radians.cos();
    const sinA = radians.sin();
    const oneMinusCosA = $03ccd63b0299d6a7$var$float(1).sub(cosA);
    const rot = input.mul(cosA).add(nAxis.cross(input).mul(sinA)).add(nAxis.mul(nAxis.dot(input)).mul(oneMinusCosA));
    return rot;
};
const $03ccd63b0299d6a7$var$mx_heighttonormal = (input, scale /*, texcoord*/ )=>{
    input = $03ccd63b0299d6a7$var$vec3(input);
    scale = $03ccd63b0299d6a7$var$float(scale);
    return $03ccd63b0299d6a7$var$bumpMap(input, scale);
};
/**
 * This computes a parallax corrected normal which is used for box-projected cube mapping (BPCEM).
 *
 * Reference: {@link https://devlog-martinsh.blogspot.com/2011/09/box-projected-cube-environment-mapping.html}
 *
 * ```js
 * const uvNode = getParallaxCorrectNormal( reflectVector, vec3( 200, 100, 100 ), vec3( 0, - 50, 0 ) );
 * material.envNode = pmremTexture( renderTarget.texture, uvNode );
 * ```
 *
 * @tsl
 * @function
 * @param {Node<vec3>} normal - The normal to correct.
 * @param {Node<vec3>} cubeSize - The cube size should reflect the size of the environment (BPCEM is usually applied in closed environments like rooms).
 * @param {Node<vec3>} cubePos - The cube position.
 * @return {Node<vec3>} The parallax corrected normal.
 */ const $03ccd63b0299d6a7$var$getParallaxCorrectNormal = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([normal, cubeSize, cubePos])=>{
    const nDir = $03ccd63b0299d6a7$var$normalize(normal).toVar();
    const rbmax = $03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(0.5).mul(cubeSize.sub(cubePos)), $03ccd63b0299d6a7$var$positionWorld).div(nDir).toVar();
    const rbmin = $03ccd63b0299d6a7$var$sub($03ccd63b0299d6a7$var$float(-0.5).mul(cubeSize.sub(cubePos)), $03ccd63b0299d6a7$var$positionWorld).div(nDir).toVar();
    const rbminmax = $03ccd63b0299d6a7$var$vec3().toVar();
    rbminmax.x = nDir.x.greaterThan($03ccd63b0299d6a7$var$float(0)).select(rbmax.x, rbmin.x);
    rbminmax.y = nDir.y.greaterThan($03ccd63b0299d6a7$var$float(0)).select(rbmax.y, rbmin.y);
    rbminmax.z = nDir.z.greaterThan($03ccd63b0299d6a7$var$float(0)).select(rbmax.z, rbmin.z);
    const correction = $03ccd63b0299d6a7$var$min$1(rbminmax.x, rbminmax.y, rbminmax.z).toVar();
    const boxIntersection = $03ccd63b0299d6a7$var$positionWorld.add(nDir.mul(correction)).toVar();
    return boxIntersection.sub(cubePos);
});
const $03ccd63b0299d6a7$var$getShIrradianceAt = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([normal, shCoefficients])=>{
    // normal is assumed to have unit length
    const x = normal.x, y = normal.y, z = normal.z;
    // band 0
    let result = shCoefficients.element(0).mul(0.886227);
    // band 1
    result = result.add(shCoefficients.element(1).mul(1.023328).mul(y));
    result = result.add(shCoefficients.element(2).mul(1.023328).mul(z));
    result = result.add(shCoefficients.element(3).mul(1.023328).mul(x));
    // band 2
    result = result.add(shCoefficients.element(4).mul(0.858086).mul(x).mul(y));
    result = result.add(shCoefficients.element(5).mul(0.858086).mul(y).mul(z));
    result = result.add(shCoefficients.element(6).mul(z.mul(z).mul(0.743125).sub(0.247708)));
    result = result.add(shCoefficients.element(7).mul(0.858086).mul(x).mul(z));
    result = result.add(shCoefficients.element(8).mul(0.429043).mul($03ccd63b0299d6a7$var$mul(x, x).sub($03ccd63b0299d6a7$var$mul(y, y))));
    return result;
});
// constants
var $03ccd63b0299d6a7$export$d844e3d2f3ba8c41 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BRDF_GGX: $03ccd63b0299d6a7$var$BRDF_GGX,
    BRDF_Lambert: $03ccd63b0299d6a7$var$BRDF_Lambert,
    BasicPointShadowFilter: $03ccd63b0299d6a7$var$BasicPointShadowFilter,
    BasicShadowFilter: $03ccd63b0299d6a7$var$BasicShadowFilter,
    Break: $03ccd63b0299d6a7$var$Break,
    Const: $03ccd63b0299d6a7$var$Const,
    Continue: $03ccd63b0299d6a7$var$Continue,
    DFGLUT: $03ccd63b0299d6a7$var$DFGLUT,
    D_GGX: $03ccd63b0299d6a7$var$D_GGX,
    Discard: $03ccd63b0299d6a7$var$Discard,
    EPSILON: $03ccd63b0299d6a7$var$EPSILON,
    F_Schlick: $03ccd63b0299d6a7$var$F_Schlick,
    Fn: $03ccd63b0299d6a7$var$Fn,
    HALF_PI: $03ccd63b0299d6a7$var$HALF_PI,
    INFINITY: $03ccd63b0299d6a7$var$INFINITY,
    If: $03ccd63b0299d6a7$var$If,
    Loop: $03ccd63b0299d6a7$var$Loop,
    NodeAccess: $03ccd63b0299d6a7$export$92538c74c63a703d,
    NodeShaderStage: $03ccd63b0299d6a7$export$9e43649cde3e3072,
    NodeType: $03ccd63b0299d6a7$export$f06e977173f1857c,
    NodeUpdateType: $03ccd63b0299d6a7$export$26f7a8bbd9469530,
    OnBeforeFrameUpdate: $03ccd63b0299d6a7$var$OnBeforeFrameUpdate,
    OnBeforeMaterialUpdate: $03ccd63b0299d6a7$var$OnBeforeMaterialUpdate,
    OnBeforeObjectUpdate: $03ccd63b0299d6a7$var$OnBeforeObjectUpdate,
    OnFrameUpdate: $03ccd63b0299d6a7$var$OnFrameUpdate,
    OnMaterialUpdate: $03ccd63b0299d6a7$var$OnMaterialUpdate,
    OnObjectUpdate: $03ccd63b0299d6a7$var$OnObjectUpdate,
    PCFShadowFilter: $03ccd63b0299d6a7$var$PCFShadowFilter,
    PCFSoftShadowFilter: $03ccd63b0299d6a7$var$PCFSoftShadowFilter,
    PI: $03ccd63b0299d6a7$var$PI,
    PI2: $03ccd63b0299d6a7$var$PI2,
    PointShadowFilter: $03ccd63b0299d6a7$var$PointShadowFilter,
    Return: $03ccd63b0299d6a7$var$Return,
    Schlick_to_F0: $03ccd63b0299d6a7$var$Schlick_to_F0,
    ShaderNode: $03ccd63b0299d6a7$var$ShaderNode,
    Stack: $03ccd63b0299d6a7$var$Stack,
    Switch: $03ccd63b0299d6a7$var$Switch,
    TBNViewMatrix: $03ccd63b0299d6a7$var$TBNViewMatrix,
    TWO_PI: $03ccd63b0299d6a7$var$TWO_PI,
    VSMShadowFilter: $03ccd63b0299d6a7$var$VSMShadowFilter,
    V_GGX_SmithCorrelated: $03ccd63b0299d6a7$var$V_GGX_SmithCorrelated,
    Var: $03ccd63b0299d6a7$var$Var,
    VarIntent: $03ccd63b0299d6a7$var$VarIntent,
    abs: $03ccd63b0299d6a7$var$abs,
    acesFilmicToneMapping: $03ccd63b0299d6a7$var$acesFilmicToneMapping,
    acos: $03ccd63b0299d6a7$var$acos,
    acosh: $03ccd63b0299d6a7$var$acosh,
    add: $03ccd63b0299d6a7$var$add,
    addMethodChaining: $03ccd63b0299d6a7$var$addMethodChaining,
    addNodeElement: $03ccd63b0299d6a7$var$addNodeElement,
    agxToneMapping: $03ccd63b0299d6a7$var$agxToneMapping,
    all: $03ccd63b0299d6a7$var$all,
    alphaT: $03ccd63b0299d6a7$var$alphaT,
    and: $03ccd63b0299d6a7$var$and,
    anisotropy: $03ccd63b0299d6a7$var$anisotropy,
    anisotropyB: $03ccd63b0299d6a7$var$anisotropyB,
    anisotropyT: $03ccd63b0299d6a7$var$anisotropyT,
    any: $03ccd63b0299d6a7$var$any,
    append: $03ccd63b0299d6a7$var$append,
    array: $03ccd63b0299d6a7$var$array,
    arrayBuffer: $03ccd63b0299d6a7$var$arrayBuffer,
    asin: $03ccd63b0299d6a7$var$asin,
    asinh: $03ccd63b0299d6a7$var$asinh,
    assign: $03ccd63b0299d6a7$var$assign,
    atan: $03ccd63b0299d6a7$var$atan,
    atanh: $03ccd63b0299d6a7$var$atanh,
    atomicAdd: $03ccd63b0299d6a7$var$atomicAdd,
    atomicAnd: $03ccd63b0299d6a7$var$atomicAnd,
    atomicFunc: $03ccd63b0299d6a7$var$atomicFunc,
    atomicLoad: $03ccd63b0299d6a7$var$atomicLoad,
    atomicMax: $03ccd63b0299d6a7$var$atomicMax,
    atomicMin: $03ccd63b0299d6a7$var$atomicMin,
    atomicOr: $03ccd63b0299d6a7$var$atomicOr,
    atomicStore: $03ccd63b0299d6a7$var$atomicStore,
    atomicSub: $03ccd63b0299d6a7$var$atomicSub,
    atomicXor: $03ccd63b0299d6a7$var$atomicXor,
    attenuationColor: $03ccd63b0299d6a7$var$attenuationColor,
    attenuationDistance: $03ccd63b0299d6a7$var$attenuationDistance,
    attribute: $03ccd63b0299d6a7$var$attribute,
    attributeArray: $03ccd63b0299d6a7$var$attributeArray,
    backgroundBlurriness: $03ccd63b0299d6a7$var$backgroundBlurriness,
    backgroundIntensity: $03ccd63b0299d6a7$var$backgroundIntensity,
    backgroundRotation: $03ccd63b0299d6a7$var$backgroundRotation,
    batch: $03ccd63b0299d6a7$var$batch,
    bentNormalView: $03ccd63b0299d6a7$var$bentNormalView,
    billboarding: $03ccd63b0299d6a7$var$billboarding,
    bitAnd: $03ccd63b0299d6a7$var$bitAnd,
    bitNot: $03ccd63b0299d6a7$var$bitNot,
    bitOr: $03ccd63b0299d6a7$var$bitOr,
    bitXor: $03ccd63b0299d6a7$var$bitXor,
    bitangentGeometry: $03ccd63b0299d6a7$var$bitangentGeometry,
    bitangentLocal: $03ccd63b0299d6a7$var$bitangentLocal,
    bitangentView: $03ccd63b0299d6a7$var$bitangentView,
    bitangentWorld: $03ccd63b0299d6a7$var$bitangentWorld,
    bitcast: $03ccd63b0299d6a7$var$bitcast,
    blendBurn: $03ccd63b0299d6a7$var$blendBurn,
    blendColor: $03ccd63b0299d6a7$var$blendColor,
    blendDodge: $03ccd63b0299d6a7$var$blendDodge,
    blendOverlay: $03ccd63b0299d6a7$var$blendOverlay,
    blendScreen: $03ccd63b0299d6a7$var$blendScreen,
    blur: $03ccd63b0299d6a7$var$blur,
    bool: $03ccd63b0299d6a7$var$bool,
    buffer: $03ccd63b0299d6a7$var$buffer,
    bufferAttribute: $03ccd63b0299d6a7$var$bufferAttribute,
    builtin: $03ccd63b0299d6a7$var$builtin,
    builtinAOContext: $03ccd63b0299d6a7$var$builtinAOContext,
    builtinShadowContext: $03ccd63b0299d6a7$var$builtinShadowContext,
    bumpMap: $03ccd63b0299d6a7$var$bumpMap,
    bvec2: $03ccd63b0299d6a7$var$bvec2,
    bvec3: $03ccd63b0299d6a7$var$bvec3,
    bvec4: $03ccd63b0299d6a7$var$bvec4,
    bypass: $03ccd63b0299d6a7$var$bypass,
    cache: $03ccd63b0299d6a7$var$cache,
    call: $03ccd63b0299d6a7$var$call,
    cameraFar: $03ccd63b0299d6a7$var$cameraFar,
    cameraIndex: $03ccd63b0299d6a7$var$cameraIndex,
    cameraNear: $03ccd63b0299d6a7$var$cameraNear,
    cameraNormalMatrix: $03ccd63b0299d6a7$var$cameraNormalMatrix,
    cameraPosition: $03ccd63b0299d6a7$var$cameraPosition,
    cameraProjectionMatrix: $03ccd63b0299d6a7$var$cameraProjectionMatrix,
    cameraProjectionMatrixInverse: $03ccd63b0299d6a7$var$cameraProjectionMatrixInverse,
    cameraViewMatrix: $03ccd63b0299d6a7$var$cameraViewMatrix,
    cameraViewport: $03ccd63b0299d6a7$var$cameraViewport,
    cameraWorldMatrix: $03ccd63b0299d6a7$var$cameraWorldMatrix,
    cbrt: $03ccd63b0299d6a7$var$cbrt,
    cdl: $03ccd63b0299d6a7$var$cdl,
    ceil: $03ccd63b0299d6a7$var$ceil,
    checker: $03ccd63b0299d6a7$var$checker,
    cineonToneMapping: $03ccd63b0299d6a7$var$cineonToneMapping,
    clamp: $03ccd63b0299d6a7$var$clamp,
    clearcoat: $03ccd63b0299d6a7$var$clearcoat,
    clearcoatNormalView: $03ccd63b0299d6a7$var$clearcoatNormalView,
    clearcoatRoughness: $03ccd63b0299d6a7$var$clearcoatRoughness,
    clipSpace: $03ccd63b0299d6a7$var$clipSpace,
    code: $03ccd63b0299d6a7$var$code,
    color: $03ccd63b0299d6a7$var$color,
    colorSpaceToWorking: $03ccd63b0299d6a7$var$colorSpaceToWorking,
    colorToDirection: $03ccd63b0299d6a7$var$colorToDirection,
    compute: $03ccd63b0299d6a7$var$compute,
    computeKernel: $03ccd63b0299d6a7$var$computeKernel,
    computeSkinning: $03ccd63b0299d6a7$var$computeSkinning,
    context: $03ccd63b0299d6a7$var$context,
    convert: $03ccd63b0299d6a7$var$convert,
    convertColorSpace: $03ccd63b0299d6a7$var$convertColorSpace,
    convertToTexture: $03ccd63b0299d6a7$var$convertToTexture,
    cos: $03ccd63b0299d6a7$var$cos,
    cosh: $03ccd63b0299d6a7$var$cosh,
    countLeadingZeros: $03ccd63b0299d6a7$var$countLeadingZeros,
    countOneBits: $03ccd63b0299d6a7$var$countOneBits,
    countTrailingZeros: $03ccd63b0299d6a7$var$countTrailingZeros,
    cross: $03ccd63b0299d6a7$var$cross,
    cubeTexture: $03ccd63b0299d6a7$var$cubeTexture,
    cubeTextureBase: $03ccd63b0299d6a7$var$cubeTextureBase,
    dFdx: $03ccd63b0299d6a7$var$dFdx,
    dFdy: $03ccd63b0299d6a7$var$dFdy,
    dashSize: $03ccd63b0299d6a7$var$dashSize,
    debug: $03ccd63b0299d6a7$var$debug,
    decrement: $03ccd63b0299d6a7$var$decrement,
    decrementBefore: $03ccd63b0299d6a7$var$decrementBefore,
    defaultBuildStages: $03ccd63b0299d6a7$export$f2213ed98eb895d6,
    defaultShaderStages: $03ccd63b0299d6a7$export$565139d2263e2965,
    defined: $03ccd63b0299d6a7$var$defined,
    degrees: $03ccd63b0299d6a7$var$degrees,
    deltaTime: $03ccd63b0299d6a7$var$deltaTime,
    densityFogFactor: $03ccd63b0299d6a7$var$densityFogFactor,
    depth: $03ccd63b0299d6a7$var$depth,
    depthPass: $03ccd63b0299d6a7$var$depthPass,
    determinant: $03ccd63b0299d6a7$var$determinant,
    difference: $03ccd63b0299d6a7$var$difference,
    diffuseColor: $03ccd63b0299d6a7$var$diffuseColor,
    diffuseContribution: $03ccd63b0299d6a7$var$diffuseContribution,
    directPointLight: $03ccd63b0299d6a7$var$directPointLight,
    directionToColor: $03ccd63b0299d6a7$var$directionToColor,
    directionToFaceDirection: $03ccd63b0299d6a7$var$directionToFaceDirection,
    dispersion: $03ccd63b0299d6a7$var$dispersion,
    disposeShadowMaterial: $03ccd63b0299d6a7$var$disposeShadowMaterial,
    distance: $03ccd63b0299d6a7$var$distance,
    div: $03ccd63b0299d6a7$var$div,
    dot: $03ccd63b0299d6a7$var$dot,
    drawIndex: $03ccd63b0299d6a7$var$drawIndex,
    dynamicBufferAttribute: $03ccd63b0299d6a7$var$dynamicBufferAttribute,
    element: $03ccd63b0299d6a7$var$element,
    emissive: $03ccd63b0299d6a7$var$emissive,
    equal: $03ccd63b0299d6a7$var$equal,
    equirectUV: $03ccd63b0299d6a7$var$equirectUV,
    exp: $03ccd63b0299d6a7$var$exp,
    exp2: $03ccd63b0299d6a7$var$exp2,
    exponentialHeightFogFactor: $03ccd63b0299d6a7$var$exponentialHeightFogFactor,
    expression: $03ccd63b0299d6a7$var$expression,
    faceDirection: $03ccd63b0299d6a7$var$faceDirection,
    faceForward: $03ccd63b0299d6a7$var$faceForward,
    faceforward: $03ccd63b0299d6a7$var$faceforward,
    float: $03ccd63b0299d6a7$var$float,
    floatBitsToInt: $03ccd63b0299d6a7$var$floatBitsToInt,
    floatBitsToUint: $03ccd63b0299d6a7$var$floatBitsToUint,
    floor: $03ccd63b0299d6a7$var$floor,
    fog: $03ccd63b0299d6a7$var$fog,
    fract: $03ccd63b0299d6a7$var$fract,
    frameGroup: $03ccd63b0299d6a7$var$frameGroup,
    frameId: $03ccd63b0299d6a7$var$frameId,
    frontFacing: $03ccd63b0299d6a7$var$frontFacing,
    fwidth: $03ccd63b0299d6a7$var$fwidth,
    gain: $03ccd63b0299d6a7$var$gain,
    gapSize: $03ccd63b0299d6a7$var$gapSize,
    getConstNodeType: $03ccd63b0299d6a7$var$getConstNodeType,
    getCurrentStack: $03ccd63b0299d6a7$var$getCurrentStack,
    getDirection: $03ccd63b0299d6a7$var$getDirection,
    getDistanceAttenuation: $03ccd63b0299d6a7$var$getDistanceAttenuation,
    getGeometryRoughness: $03ccd63b0299d6a7$var$getGeometryRoughness,
    getNormalFromDepth: $03ccd63b0299d6a7$var$getNormalFromDepth,
    getParallaxCorrectNormal: $03ccd63b0299d6a7$var$getParallaxCorrectNormal,
    getRoughness: $03ccd63b0299d6a7$var$getRoughness,
    getScreenPosition: $03ccd63b0299d6a7$var$getScreenPosition,
    getShIrradianceAt: $03ccd63b0299d6a7$var$getShIrradianceAt,
    getShadowMaterial: $03ccd63b0299d6a7$var$getShadowMaterial,
    getShadowRenderObjectFunction: $03ccd63b0299d6a7$var$getShadowRenderObjectFunction,
    getTextureIndex: $03ccd63b0299d6a7$var$getTextureIndex,
    getViewPosition: $03ccd63b0299d6a7$var$getViewPosition,
    ggxConvolution: $03ccd63b0299d6a7$var$ggxConvolution,
    globalId: $03ccd63b0299d6a7$var$globalId,
    glsl: $03ccd63b0299d6a7$var$glsl,
    glslFn: $03ccd63b0299d6a7$var$glslFn,
    grayscale: $03ccd63b0299d6a7$var$grayscale,
    greaterThan: $03ccd63b0299d6a7$var$greaterThan,
    greaterThanEqual: $03ccd63b0299d6a7$var$greaterThanEqual,
    hash: $03ccd63b0299d6a7$var$hash,
    highpModelNormalViewMatrix: $03ccd63b0299d6a7$var$highpModelNormalViewMatrix,
    highpModelViewMatrix: $03ccd63b0299d6a7$var$highpModelViewMatrix,
    hue: $03ccd63b0299d6a7$var$hue,
    increment: $03ccd63b0299d6a7$var$increment,
    incrementBefore: $03ccd63b0299d6a7$var$incrementBefore,
    inspector: $03ccd63b0299d6a7$var$inspector,
    instance: $03ccd63b0299d6a7$var$instance,
    instanceIndex: $03ccd63b0299d6a7$var$instanceIndex,
    instancedArray: $03ccd63b0299d6a7$var$instancedArray,
    instancedBufferAttribute: $03ccd63b0299d6a7$var$instancedBufferAttribute,
    instancedDynamicBufferAttribute: $03ccd63b0299d6a7$var$instancedDynamicBufferAttribute,
    instancedMesh: $03ccd63b0299d6a7$var$instancedMesh,
    int: $03ccd63b0299d6a7$var$int,
    intBitsToFloat: $03ccd63b0299d6a7$var$intBitsToFloat,
    interleavedGradientNoise: $03ccd63b0299d6a7$var$interleavedGradientNoise,
    inverse: $03ccd63b0299d6a7$var$inverse,
    inverseSqrt: $03ccd63b0299d6a7$var$inverseSqrt,
    inversesqrt: $03ccd63b0299d6a7$var$inversesqrt,
    invocationLocalIndex: $03ccd63b0299d6a7$var$invocationLocalIndex,
    invocationSubgroupIndex: $03ccd63b0299d6a7$var$invocationSubgroupIndex,
    ior: $03ccd63b0299d6a7$var$ior,
    iridescence: $03ccd63b0299d6a7$var$iridescence,
    iridescenceIOR: $03ccd63b0299d6a7$var$iridescenceIOR,
    iridescenceThickness: $03ccd63b0299d6a7$var$iridescenceThickness,
    isolate: $03ccd63b0299d6a7$var$isolate,
    ivec2: $03ccd63b0299d6a7$var$ivec2,
    ivec3: $03ccd63b0299d6a7$var$ivec3,
    ivec4: $03ccd63b0299d6a7$var$ivec4,
    js: $03ccd63b0299d6a7$var$js,
    label: $03ccd63b0299d6a7$var$label,
    length: $03ccd63b0299d6a7$var$length,
    lengthSq: $03ccd63b0299d6a7$var$lengthSq,
    lessThan: $03ccd63b0299d6a7$var$lessThan,
    lessThanEqual: $03ccd63b0299d6a7$var$lessThanEqual,
    lightPosition: $03ccd63b0299d6a7$var$lightPosition,
    lightProjectionUV: $03ccd63b0299d6a7$var$lightProjectionUV,
    lightShadowMatrix: $03ccd63b0299d6a7$var$lightShadowMatrix,
    lightTargetDirection: $03ccd63b0299d6a7$var$lightTargetDirection,
    lightTargetPosition: $03ccd63b0299d6a7$var$lightTargetPosition,
    lightViewPosition: $03ccd63b0299d6a7$var$lightViewPosition,
    lightingContext: $03ccd63b0299d6a7$var$lightingContext,
    lights: $03ccd63b0299d6a7$var$lights,
    linearDepth: $03ccd63b0299d6a7$var$linearDepth,
    linearToneMapping: $03ccd63b0299d6a7$var$linearToneMapping,
    localId: $03ccd63b0299d6a7$var$localId,
    log: $03ccd63b0299d6a7$var$log,
    log2: $03ccd63b0299d6a7$var$log2,
    logarithmicDepthToViewZ: $03ccd63b0299d6a7$var$logarithmicDepthToViewZ,
    luminance: $03ccd63b0299d6a7$var$luminance,
    mat2: $03ccd63b0299d6a7$var$mat2,
    mat3: $03ccd63b0299d6a7$var$mat3,
    mat4: $03ccd63b0299d6a7$var$mat4,
    matcapUV: $03ccd63b0299d6a7$var$matcapUV,
    materialAO: $03ccd63b0299d6a7$var$materialAO,
    materialAlphaTest: $03ccd63b0299d6a7$var$materialAlphaTest,
    materialAnisotropy: $03ccd63b0299d6a7$var$materialAnisotropy,
    materialAnisotropyVector: $03ccd63b0299d6a7$var$materialAnisotropyVector,
    materialAttenuationColor: $03ccd63b0299d6a7$var$materialAttenuationColor,
    materialAttenuationDistance: $03ccd63b0299d6a7$var$materialAttenuationDistance,
    materialClearcoat: $03ccd63b0299d6a7$var$materialClearcoat,
    materialClearcoatNormal: $03ccd63b0299d6a7$var$materialClearcoatNormal,
    materialClearcoatRoughness: $03ccd63b0299d6a7$var$materialClearcoatRoughness,
    materialColor: $03ccd63b0299d6a7$var$materialColor,
    materialDispersion: $03ccd63b0299d6a7$var$materialDispersion,
    materialEmissive: $03ccd63b0299d6a7$var$materialEmissive,
    materialEnvIntensity: $03ccd63b0299d6a7$var$materialEnvIntensity,
    materialEnvRotation: $03ccd63b0299d6a7$var$materialEnvRotation,
    materialIOR: $03ccd63b0299d6a7$var$materialIOR,
    materialIridescence: $03ccd63b0299d6a7$var$materialIridescence,
    materialIridescenceIOR: $03ccd63b0299d6a7$var$materialIridescenceIOR,
    materialIridescenceThickness: $03ccd63b0299d6a7$var$materialIridescenceThickness,
    materialLightMap: $03ccd63b0299d6a7$var$materialLightMap,
    materialLineDashOffset: $03ccd63b0299d6a7$var$materialLineDashOffset,
    materialLineDashSize: $03ccd63b0299d6a7$var$materialLineDashSize,
    materialLineGapSize: $03ccd63b0299d6a7$var$materialLineGapSize,
    materialLineScale: $03ccd63b0299d6a7$var$materialLineScale,
    materialLineWidth: $03ccd63b0299d6a7$var$materialLineWidth,
    materialMetalness: $03ccd63b0299d6a7$var$materialMetalness,
    materialNormal: $03ccd63b0299d6a7$var$materialNormal,
    materialOpacity: $03ccd63b0299d6a7$var$materialOpacity,
    materialPointSize: $03ccd63b0299d6a7$var$materialPointSize,
    materialReference: $03ccd63b0299d6a7$var$materialReference,
    materialReflectivity: $03ccd63b0299d6a7$var$materialReflectivity,
    materialRefractionRatio: $03ccd63b0299d6a7$var$materialRefractionRatio,
    materialRotation: $03ccd63b0299d6a7$var$materialRotation,
    materialRoughness: $03ccd63b0299d6a7$var$materialRoughness,
    materialSheen: $03ccd63b0299d6a7$var$materialSheen,
    materialSheenRoughness: $03ccd63b0299d6a7$var$materialSheenRoughness,
    materialShininess: $03ccd63b0299d6a7$var$materialShininess,
    materialSpecular: $03ccd63b0299d6a7$var$materialSpecular,
    materialSpecularColor: $03ccd63b0299d6a7$var$materialSpecularColor,
    materialSpecularIntensity: $03ccd63b0299d6a7$var$materialSpecularIntensity,
    materialSpecularStrength: $03ccd63b0299d6a7$var$materialSpecularStrength,
    materialThickness: $03ccd63b0299d6a7$var$materialThickness,
    materialTransmission: $03ccd63b0299d6a7$var$materialTransmission,
    max: $03ccd63b0299d6a7$var$max$1,
    maxMipLevel: $03ccd63b0299d6a7$var$maxMipLevel,
    mediumpModelViewMatrix: $03ccd63b0299d6a7$var$mediumpModelViewMatrix,
    metalness: $03ccd63b0299d6a7$var$metalness,
    min: $03ccd63b0299d6a7$var$min$1,
    mix: $03ccd63b0299d6a7$var$mix,
    mixElement: $03ccd63b0299d6a7$var$mixElement,
    mod: $03ccd63b0299d6a7$var$mod,
    modInt: $03ccd63b0299d6a7$var$modInt,
    modelDirection: $03ccd63b0299d6a7$var$modelDirection,
    modelNormalMatrix: $03ccd63b0299d6a7$var$modelNormalMatrix,
    modelPosition: $03ccd63b0299d6a7$var$modelPosition,
    modelRadius: $03ccd63b0299d6a7$var$modelRadius,
    modelScale: $03ccd63b0299d6a7$var$modelScale,
    modelViewMatrix: $03ccd63b0299d6a7$var$modelViewMatrix,
    modelViewPosition: $03ccd63b0299d6a7$var$modelViewPosition,
    modelViewProjection: $03ccd63b0299d6a7$var$modelViewProjection,
    modelWorldMatrix: $03ccd63b0299d6a7$var$modelWorldMatrix,
    modelWorldMatrixInverse: $03ccd63b0299d6a7$var$modelWorldMatrixInverse,
    morphReference: $03ccd63b0299d6a7$var$morphReference,
    mrt: $03ccd63b0299d6a7$var$mrt,
    mul: $03ccd63b0299d6a7$var$mul,
    mx_aastep: $03ccd63b0299d6a7$var$mx_aastep,
    mx_add: $03ccd63b0299d6a7$var$mx_add,
    mx_atan2: $03ccd63b0299d6a7$var$mx_atan2,
    mx_cell_noise_float: $03ccd63b0299d6a7$var$mx_cell_noise_float,
    mx_contrast: $03ccd63b0299d6a7$var$mx_contrast,
    mx_divide: $03ccd63b0299d6a7$var$mx_divide,
    mx_fractal_noise_float: $03ccd63b0299d6a7$var$mx_fractal_noise_float,
    mx_fractal_noise_vec2: $03ccd63b0299d6a7$var$mx_fractal_noise_vec2,
    mx_fractal_noise_vec3: $03ccd63b0299d6a7$var$mx_fractal_noise_vec3,
    mx_fractal_noise_vec4: $03ccd63b0299d6a7$var$mx_fractal_noise_vec4,
    mx_frame: $03ccd63b0299d6a7$var$mx_frame,
    mx_heighttonormal: $03ccd63b0299d6a7$var$mx_heighttonormal,
    mx_hsvtorgb: $03ccd63b0299d6a7$var$mx_hsvtorgb,
    mx_ifequal: $03ccd63b0299d6a7$var$mx_ifequal,
    mx_ifgreater: $03ccd63b0299d6a7$var$mx_ifgreater,
    mx_ifgreatereq: $03ccd63b0299d6a7$var$mx_ifgreatereq,
    mx_invert: $03ccd63b0299d6a7$var$mx_invert,
    mx_modulo: $03ccd63b0299d6a7$var$mx_modulo,
    mx_multiply: $03ccd63b0299d6a7$var$mx_multiply,
    mx_noise_float: $03ccd63b0299d6a7$var$mx_noise_float,
    mx_noise_vec3: $03ccd63b0299d6a7$var$mx_noise_vec3,
    mx_noise_vec4: $03ccd63b0299d6a7$var$mx_noise_vec4,
    mx_place2d: $03ccd63b0299d6a7$var$mx_place2d,
    mx_power: $03ccd63b0299d6a7$var$mx_power,
    mx_ramp4: $03ccd63b0299d6a7$var$mx_ramp4,
    mx_ramplr: $03ccd63b0299d6a7$var$mx_ramplr,
    mx_ramptb: $03ccd63b0299d6a7$var$mx_ramptb,
    mx_rgbtohsv: $03ccd63b0299d6a7$var$mx_rgbtohsv,
    mx_rotate2d: $03ccd63b0299d6a7$var$mx_rotate2d,
    mx_rotate3d: $03ccd63b0299d6a7$var$mx_rotate3d,
    mx_safepower: $03ccd63b0299d6a7$var$mx_safepower,
    mx_separate: $03ccd63b0299d6a7$var$mx_separate,
    mx_splitlr: $03ccd63b0299d6a7$var$mx_splitlr,
    mx_splittb: $03ccd63b0299d6a7$var$mx_splittb,
    mx_srgb_texture_to_lin_rec709: $03ccd63b0299d6a7$var$mx_srgb_texture_to_lin_rec709,
    mx_subtract: $03ccd63b0299d6a7$var$mx_subtract,
    mx_timer: $03ccd63b0299d6a7$var$mx_timer,
    mx_transform_uv: $03ccd63b0299d6a7$var$mx_transform_uv,
    mx_unifiednoise2d: $03ccd63b0299d6a7$var$mx_unifiednoise2d,
    mx_unifiednoise3d: $03ccd63b0299d6a7$var$mx_unifiednoise3d,
    mx_worley_noise_float: $03ccd63b0299d6a7$var$mx_worley_noise_float,
    mx_worley_noise_vec2: $03ccd63b0299d6a7$var$mx_worley_noise_vec2,
    mx_worley_noise_vec3: $03ccd63b0299d6a7$var$mx_worley_noise_vec3,
    negate: $03ccd63b0299d6a7$var$negate,
    neutralToneMapping: $03ccd63b0299d6a7$var$neutralToneMapping,
    nodeArray: $03ccd63b0299d6a7$var$nodeArray,
    nodeImmutable: $03ccd63b0299d6a7$var$nodeImmutable,
    nodeObject: $03ccd63b0299d6a7$var$nodeObject,
    nodeObjectIntent: $03ccd63b0299d6a7$var$nodeObjectIntent,
    nodeObjects: $03ccd63b0299d6a7$var$nodeObjects,
    nodeProxy: $03ccd63b0299d6a7$var$nodeProxy,
    nodeProxyIntent: $03ccd63b0299d6a7$var$nodeProxyIntent,
    normalFlat: $03ccd63b0299d6a7$var$normalFlat,
    normalGeometry: $03ccd63b0299d6a7$var$normalGeometry,
    normalLocal: $03ccd63b0299d6a7$var$normalLocal,
    normalMap: $03ccd63b0299d6a7$var$normalMap,
    normalView: $03ccd63b0299d6a7$var$normalView,
    normalViewGeometry: $03ccd63b0299d6a7$var$normalViewGeometry,
    normalWorld: $03ccd63b0299d6a7$var$normalWorld,
    normalWorldGeometry: $03ccd63b0299d6a7$var$normalWorldGeometry,
    normalize: $03ccd63b0299d6a7$var$normalize,
    not: $03ccd63b0299d6a7$var$not,
    notEqual: $03ccd63b0299d6a7$var$notEqual,
    numWorkgroups: $03ccd63b0299d6a7$var$numWorkgroups,
    objectDirection: $03ccd63b0299d6a7$var$objectDirection,
    objectGroup: $03ccd63b0299d6a7$var$objectGroup,
    objectPosition: $03ccd63b0299d6a7$var$objectPosition,
    objectRadius: $03ccd63b0299d6a7$var$objectRadius,
    objectScale: $03ccd63b0299d6a7$var$objectScale,
    objectViewPosition: $03ccd63b0299d6a7$var$objectViewPosition,
    objectWorldMatrix: $03ccd63b0299d6a7$var$objectWorldMatrix,
    oneMinus: $03ccd63b0299d6a7$var$oneMinus,
    or: $03ccd63b0299d6a7$var$or,
    orthographicDepthToViewZ: $03ccd63b0299d6a7$var$orthographicDepthToViewZ,
    oscSawtooth: $03ccd63b0299d6a7$var$oscSawtooth,
    oscSine: $03ccd63b0299d6a7$var$oscSine,
    oscSquare: $03ccd63b0299d6a7$var$oscSquare,
    oscTriangle: $03ccd63b0299d6a7$var$oscTriangle,
    output: $03ccd63b0299d6a7$var$output,
    outputStruct: $03ccd63b0299d6a7$var$outputStruct,
    overloadingFn: $03ccd63b0299d6a7$var$overloadingFn,
    packHalf2x16: $03ccd63b0299d6a7$var$packHalf2x16,
    packSnorm2x16: $03ccd63b0299d6a7$var$packSnorm2x16,
    packUnorm2x16: $03ccd63b0299d6a7$var$packUnorm2x16,
    parabola: $03ccd63b0299d6a7$var$parabola,
    parallaxDirection: $03ccd63b0299d6a7$var$parallaxDirection,
    parallaxUV: $03ccd63b0299d6a7$var$parallaxUV,
    parameter: $03ccd63b0299d6a7$var$parameter,
    pass: $03ccd63b0299d6a7$var$pass,
    passTexture: $03ccd63b0299d6a7$var$passTexture,
    pcurve: $03ccd63b0299d6a7$var$pcurve,
    perspectiveDepthToViewZ: $03ccd63b0299d6a7$var$perspectiveDepthToViewZ,
    pmremTexture: $03ccd63b0299d6a7$var$pmremTexture,
    pointShadow: $03ccd63b0299d6a7$var$pointShadow,
    pointUV: $03ccd63b0299d6a7$var$pointUV,
    pointWidth: $03ccd63b0299d6a7$var$pointWidth,
    positionGeometry: $03ccd63b0299d6a7$var$positionGeometry,
    positionLocal: $03ccd63b0299d6a7$var$positionLocal,
    positionPrevious: $03ccd63b0299d6a7$var$positionPrevious,
    positionView: $03ccd63b0299d6a7$var$positionView,
    positionViewDirection: $03ccd63b0299d6a7$var$positionViewDirection,
    positionWorld: $03ccd63b0299d6a7$var$positionWorld,
    positionWorldDirection: $03ccd63b0299d6a7$var$positionWorldDirection,
    posterize: $03ccd63b0299d6a7$var$posterize,
    pow: $03ccd63b0299d6a7$var$pow,
    pow2: $03ccd63b0299d6a7$var$pow2,
    pow3: $03ccd63b0299d6a7$var$pow3,
    pow4: $03ccd63b0299d6a7$var$pow4,
    premultiplyAlpha: $03ccd63b0299d6a7$var$premultiplyAlpha,
    property: $03ccd63b0299d6a7$var$property,
    quadBroadcast: $03ccd63b0299d6a7$var$quadBroadcast,
    quadSwapDiagonal: $03ccd63b0299d6a7$var$quadSwapDiagonal,
    quadSwapX: $03ccd63b0299d6a7$var$quadSwapX,
    quadSwapY: $03ccd63b0299d6a7$var$quadSwapY,
    radians: $03ccd63b0299d6a7$var$radians,
    rand: $03ccd63b0299d6a7$var$rand,
    range: $03ccd63b0299d6a7$var$range,
    rangeFogFactor: $03ccd63b0299d6a7$var$rangeFogFactor,
    reciprocal: $03ccd63b0299d6a7$var$reciprocal,
    reference: $03ccd63b0299d6a7$var$reference,
    referenceBuffer: $03ccd63b0299d6a7$var$referenceBuffer,
    reflect: $03ccd63b0299d6a7$var$reflect,
    reflectVector: $03ccd63b0299d6a7$var$reflectVector,
    reflectView: $03ccd63b0299d6a7$var$reflectView,
    reflector: $03ccd63b0299d6a7$var$reflector,
    refract: $03ccd63b0299d6a7$var$refract,
    refractVector: $03ccd63b0299d6a7$var$refractVector,
    refractView: $03ccd63b0299d6a7$var$refractView,
    reinhardToneMapping: $03ccd63b0299d6a7$var$reinhardToneMapping,
    remap: $03ccd63b0299d6a7$var$remap,
    remapClamp: $03ccd63b0299d6a7$var$remapClamp,
    renderGroup: $03ccd63b0299d6a7$var$renderGroup,
    renderOutput: $03ccd63b0299d6a7$var$renderOutput,
    rendererReference: $03ccd63b0299d6a7$var$rendererReference,
    replaceDefaultUV: $03ccd63b0299d6a7$var$replaceDefaultUV,
    rotate: $03ccd63b0299d6a7$var$rotate,
    rotateUV: $03ccd63b0299d6a7$var$rotateUV,
    roughness: $03ccd63b0299d6a7$var$roughness,
    round: $03ccd63b0299d6a7$var$round,
    rtt: $03ccd63b0299d6a7$var$rtt,
    sRGBTransferEOTF: $03ccd63b0299d6a7$var$sRGBTransferEOTF,
    sRGBTransferOETF: $03ccd63b0299d6a7$var$sRGBTransferOETF,
    sample: $03ccd63b0299d6a7$var$sample,
    sampler: $03ccd63b0299d6a7$var$sampler,
    samplerComparison: $03ccd63b0299d6a7$var$samplerComparison,
    saturate: $03ccd63b0299d6a7$var$saturate,
    saturation: $03ccd63b0299d6a7$var$saturation,
    screenCoordinate: $03ccd63b0299d6a7$var$screenCoordinate,
    screenDPR: $03ccd63b0299d6a7$var$screenDPR,
    screenSize: $03ccd63b0299d6a7$var$screenSize,
    screenUV: $03ccd63b0299d6a7$var$screenUV,
    select: $03ccd63b0299d6a7$var$select,
    setCurrentStack: $03ccd63b0299d6a7$var$setCurrentStack,
    setName: $03ccd63b0299d6a7$var$setName,
    shaderStages: $03ccd63b0299d6a7$export$48fd793f0255b86a,
    shadow: $03ccd63b0299d6a7$var$shadow,
    shadowPositionWorld: $03ccd63b0299d6a7$var$shadowPositionWorld,
    shapeCircle: $03ccd63b0299d6a7$var$shapeCircle,
    sharedUniformGroup: $03ccd63b0299d6a7$var$sharedUniformGroup,
    sheen: $03ccd63b0299d6a7$var$sheen,
    sheenRoughness: $03ccd63b0299d6a7$var$sheenRoughness,
    shiftLeft: $03ccd63b0299d6a7$var$shiftLeft,
    shiftRight: $03ccd63b0299d6a7$var$shiftRight,
    shininess: $03ccd63b0299d6a7$var$shininess,
    sign: $03ccd63b0299d6a7$var$sign,
    sin: $03ccd63b0299d6a7$var$sin,
    sinc: $03ccd63b0299d6a7$var$sinc,
    sinh: $03ccd63b0299d6a7$var$sinh,
    skinning: $03ccd63b0299d6a7$var$skinning,
    smoothstep: $03ccd63b0299d6a7$var$smoothstep,
    smoothstepElement: $03ccd63b0299d6a7$var$smoothstepElement,
    specularColor: $03ccd63b0299d6a7$var$specularColor,
    specularColorBlended: $03ccd63b0299d6a7$var$specularColorBlended,
    specularF90: $03ccd63b0299d6a7$var$specularF90,
    spherizeUV: $03ccd63b0299d6a7$var$spherizeUV,
    split: $03ccd63b0299d6a7$var$split,
    spritesheetUV: $03ccd63b0299d6a7$var$spritesheetUV,
    sqrt: $03ccd63b0299d6a7$var$sqrt,
    stack: $03ccd63b0299d6a7$var$stack,
    step: $03ccd63b0299d6a7$var$step,
    stepElement: $03ccd63b0299d6a7$var$stepElement,
    storage: $03ccd63b0299d6a7$var$storage,
    storageBarrier: $03ccd63b0299d6a7$var$storageBarrier,
    storageTexture: $03ccd63b0299d6a7$var$storageTexture,
    string: $03ccd63b0299d6a7$var$string,
    struct: $03ccd63b0299d6a7$var$struct,
    sub: $03ccd63b0299d6a7$var$sub,
    subBuild: $03ccd63b0299d6a7$var$subBuild,
    subgroupAdd: $03ccd63b0299d6a7$var$subgroupAdd,
    subgroupAll: $03ccd63b0299d6a7$var$subgroupAll,
    subgroupAnd: $03ccd63b0299d6a7$var$subgroupAnd,
    subgroupAny: $03ccd63b0299d6a7$var$subgroupAny,
    subgroupBallot: $03ccd63b0299d6a7$var$subgroupBallot,
    subgroupBroadcast: $03ccd63b0299d6a7$var$subgroupBroadcast,
    subgroupBroadcastFirst: $03ccd63b0299d6a7$var$subgroupBroadcastFirst,
    subgroupElect: $03ccd63b0299d6a7$var$subgroupElect,
    subgroupExclusiveAdd: $03ccd63b0299d6a7$var$subgroupExclusiveAdd,
    subgroupExclusiveMul: $03ccd63b0299d6a7$var$subgroupExclusiveMul,
    subgroupInclusiveAdd: $03ccd63b0299d6a7$var$subgroupInclusiveAdd,
    subgroupInclusiveMul: $03ccd63b0299d6a7$var$subgroupInclusiveMul,
    subgroupIndex: $03ccd63b0299d6a7$var$subgroupIndex,
    subgroupMax: $03ccd63b0299d6a7$var$subgroupMax,
    subgroupMin: $03ccd63b0299d6a7$var$subgroupMin,
    subgroupMul: $03ccd63b0299d6a7$var$subgroupMul,
    subgroupOr: $03ccd63b0299d6a7$var$subgroupOr,
    subgroupShuffle: $03ccd63b0299d6a7$var$subgroupShuffle,
    subgroupShuffleDown: $03ccd63b0299d6a7$var$subgroupShuffleDown,
    subgroupShuffleUp: $03ccd63b0299d6a7$var$subgroupShuffleUp,
    subgroupShuffleXor: $03ccd63b0299d6a7$var$subgroupShuffleXor,
    subgroupSize: $03ccd63b0299d6a7$var$subgroupSize,
    subgroupXor: $03ccd63b0299d6a7$var$subgroupXor,
    tan: $03ccd63b0299d6a7$var$tan,
    tangentGeometry: $03ccd63b0299d6a7$var$tangentGeometry,
    tangentLocal: $03ccd63b0299d6a7$var$tangentLocal,
    tangentView: $03ccd63b0299d6a7$var$tangentView,
    tangentWorld: $03ccd63b0299d6a7$var$tangentWorld,
    tanh: $03ccd63b0299d6a7$var$tanh,
    texture: $03ccd63b0299d6a7$var$texture,
    texture3D: $03ccd63b0299d6a7$var$texture3D,
    texture3DLevel: $03ccd63b0299d6a7$var$texture3DLevel,
    texture3DLoad: $03ccd63b0299d6a7$var$texture3DLoad,
    textureBarrier: $03ccd63b0299d6a7$var$textureBarrier,
    textureBicubic: $03ccd63b0299d6a7$var$textureBicubic,
    textureBicubicLevel: $03ccd63b0299d6a7$var$textureBicubicLevel,
    textureCubeUV: $03ccd63b0299d6a7$var$textureCubeUV,
    textureLevel: $03ccd63b0299d6a7$var$textureLevel,
    textureLoad: $03ccd63b0299d6a7$var$textureLoad,
    textureSize: $03ccd63b0299d6a7$var$textureSize,
    textureStore: $03ccd63b0299d6a7$var$textureStore,
    thickness: $03ccd63b0299d6a7$var$thickness,
    time: $03ccd63b0299d6a7$var$time,
    toneMapping: $03ccd63b0299d6a7$var$toneMapping,
    toneMappingExposure: $03ccd63b0299d6a7$var$toneMappingExposure,
    toonOutlinePass: $03ccd63b0299d6a7$var$toonOutlinePass,
    transformDirection: $03ccd63b0299d6a7$var$transformDirection,
    transformNormal: $03ccd63b0299d6a7$var$transformNormal,
    transformNormalToView: $03ccd63b0299d6a7$var$transformNormalToView,
    transformedClearcoatNormalView: $03ccd63b0299d6a7$var$transformedClearcoatNormalView,
    transformedNormalView: $03ccd63b0299d6a7$var$transformedNormalView,
    transformedNormalWorld: $03ccd63b0299d6a7$var$transformedNormalWorld,
    transmission: $03ccd63b0299d6a7$var$transmission,
    transpose: $03ccd63b0299d6a7$var$transpose,
    triNoise3D: $03ccd63b0299d6a7$var$triNoise3D,
    triplanarTexture: $03ccd63b0299d6a7$var$triplanarTexture,
    triplanarTextures: $03ccd63b0299d6a7$var$triplanarTextures,
    trunc: $03ccd63b0299d6a7$var$trunc,
    uint: $03ccd63b0299d6a7$var$uint,
    uintBitsToFloat: $03ccd63b0299d6a7$var$uintBitsToFloat,
    uniform: $03ccd63b0299d6a7$var$uniform,
    uniformArray: $03ccd63b0299d6a7$var$uniformArray,
    uniformCubeTexture: $03ccd63b0299d6a7$var$uniformCubeTexture,
    uniformFlow: $03ccd63b0299d6a7$var$uniformFlow,
    uniformGroup: $03ccd63b0299d6a7$var$uniformGroup,
    uniformTexture: $03ccd63b0299d6a7$var$uniformTexture,
    unpackHalf2x16: $03ccd63b0299d6a7$var$unpackHalf2x16,
    unpackNormal: $03ccd63b0299d6a7$var$unpackNormal,
    unpackSnorm2x16: $03ccd63b0299d6a7$var$unpackSnorm2x16,
    unpackUnorm2x16: $03ccd63b0299d6a7$var$unpackUnorm2x16,
    unpremultiplyAlpha: $03ccd63b0299d6a7$var$unpremultiplyAlpha,
    userData: $03ccd63b0299d6a7$var$userData,
    uv: $03ccd63b0299d6a7$var$uv$1,
    uvec2: $03ccd63b0299d6a7$var$uvec2,
    uvec3: $03ccd63b0299d6a7$var$uvec3,
    uvec4: $03ccd63b0299d6a7$var$uvec4,
    varying: $03ccd63b0299d6a7$var$varying,
    varyingProperty: $03ccd63b0299d6a7$var$varyingProperty,
    vec2: $03ccd63b0299d6a7$var$vec2,
    vec3: $03ccd63b0299d6a7$var$vec3,
    vec4: $03ccd63b0299d6a7$var$vec4,
    vectorComponents: $03ccd63b0299d6a7$export$1c0adcb9073b646d,
    velocity: $03ccd63b0299d6a7$var$velocity,
    vertexColor: $03ccd63b0299d6a7$var$vertexColor,
    vertexIndex: $03ccd63b0299d6a7$var$vertexIndex,
    vertexStage: $03ccd63b0299d6a7$var$vertexStage,
    vibrance: $03ccd63b0299d6a7$var$vibrance,
    viewZToLogarithmicDepth: $03ccd63b0299d6a7$var$viewZToLogarithmicDepth,
    viewZToOrthographicDepth: $03ccd63b0299d6a7$var$viewZToOrthographicDepth,
    viewZToPerspectiveDepth: $03ccd63b0299d6a7$var$viewZToPerspectiveDepth,
    viewZToReversedOrthographicDepth: $03ccd63b0299d6a7$var$viewZToReversedOrthographicDepth,
    viewZToReversedPerspectiveDepth: $03ccd63b0299d6a7$var$viewZToReversedPerspectiveDepth,
    viewport: $03ccd63b0299d6a7$var$viewport,
    viewportCoordinate: $03ccd63b0299d6a7$var$viewportCoordinate,
    viewportDepthTexture: $03ccd63b0299d6a7$var$viewportDepthTexture,
    viewportLinearDepth: $03ccd63b0299d6a7$var$viewportLinearDepth,
    viewportMipTexture: $03ccd63b0299d6a7$var$viewportMipTexture,
    viewportOpaqueMipTexture: $03ccd63b0299d6a7$var$viewportOpaqueMipTexture,
    viewportResolution: $03ccd63b0299d6a7$var$viewportResolution,
    viewportSafeUV: $03ccd63b0299d6a7$var$viewportSafeUV,
    viewportSharedTexture: $03ccd63b0299d6a7$var$viewportSharedTexture,
    viewportSize: $03ccd63b0299d6a7$var$viewportSize,
    viewportTexture: $03ccd63b0299d6a7$var$viewportTexture,
    viewportUV: $03ccd63b0299d6a7$var$viewportUV,
    vogelDiskSample: $03ccd63b0299d6a7$var$vogelDiskSample,
    wgsl: $03ccd63b0299d6a7$var$wgsl,
    wgslFn: $03ccd63b0299d6a7$var$wgslFn,
    workgroupArray: $03ccd63b0299d6a7$var$workgroupArray,
    workgroupBarrier: $03ccd63b0299d6a7$var$workgroupBarrier,
    workgroupId: $03ccd63b0299d6a7$var$workgroupId,
    workingToColorSpace: $03ccd63b0299d6a7$var$workingToColorSpace,
    xor: $03ccd63b0299d6a7$var$xor
});
const $03ccd63b0299d6a7$var$_clearColor = /*@__PURE__*/ new $03ccd63b0299d6a7$var$Color4();
/**
 * This renderer module manages the background.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$Background extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new background management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {NodeManager} nodes - Renderer component for managing nodes related logic.
	 */ constructor(renderer, nodes){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * Renderer component for managing nodes related logic.
		 *
		 * @type {NodeManager}
		 */ this.nodes = nodes;
    }
    /**
	 * Updates the background for the given scene. Depending on how `Scene.background`
	 * or `Scene.backgroundNode` are configured, this method might configure a simple clear
	 * or add a mesh to the render list for rendering the background as a textured plane
	 * or skybox.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {RenderList} renderList - The current render list.
	 * @param {RenderContext} renderContext - The current render context.
	 */ update(scene, renderList, renderContext) {
        const renderer = this.renderer;
        const background = this.nodes.getBackgroundNode(scene) || scene.background;
        let forceClear = false;
        if (background === null) {
            // no background settings, use clear color configuration from the renderer
            renderer._clearColor.getRGB($03ccd63b0299d6a7$var$_clearColor);
            $03ccd63b0299d6a7$var$_clearColor.a = renderer._clearColor.a;
        } else if (background.isColor === true) {
            // background is an opaque color
            background.getRGB($03ccd63b0299d6a7$var$_clearColor);
            $03ccd63b0299d6a7$var$_clearColor.a = 1;
            forceClear = true;
        } else if (background.isNode === true) {
            const sceneData = this.get(scene);
            const backgroundNode = background;
            $03ccd63b0299d6a7$var$_clearColor.copy(renderer._clearColor);
            let backgroundMesh = sceneData.backgroundMesh;
            if (backgroundMesh === undefined) {
                const backgroundMeshNode = $03ccd63b0299d6a7$var$vec4(backgroundNode).mul($03ccd63b0299d6a7$var$backgroundIntensity).context({
                    // @TODO: Add Texture2D support using node context
                    getUV: ()=>$03ccd63b0299d6a7$var$backgroundRotation.mul($03ccd63b0299d6a7$var$normalWorldGeometry),
                    getTextureLevel: ()=>$03ccd63b0299d6a7$var$backgroundBlurriness
                });
                // when using orthographic cameras, we must scale the skybox sphere
                // up to exceed the dimensions of the camera's viewing box.
                const isOrtho = $03ccd63b0299d6a7$var$cameraProjectionMatrix.element(3).element(3).equal(1.0);
                // calculate the orthographic scale
                // projectionMatrix[1][1] is (1 / top). Invert it to get the height and multiply by 3.0
                // (an arbitrary safety factor) to ensure the skybox is large enough to cover the corners
                // of the rectangular screen
                const orthoScale = $03ccd63b0299d6a7$var$div(1.0, $03ccd63b0299d6a7$var$cameraProjectionMatrix.element(1).element(1)).mul(3.0);
                // compute vertex position
                const modifiedPosition = isOrtho.select($03ccd63b0299d6a7$var$positionLocal.mul(orthoScale), $03ccd63b0299d6a7$var$positionLocal);
                // by using a w component of 0, the skybox will not translate when the camera moves through the scene
                const viewPosition = $03ccd63b0299d6a7$var$modelViewMatrix.mul($03ccd63b0299d6a7$var$vec4(modifiedPosition, 0.0));
                // we force w=1.0 here to prevent the w_clip=0 divide-by-zero error for ortho cameras.
                let viewProj = $03ccd63b0299d6a7$var$cameraProjectionMatrix.mul($03ccd63b0299d6a7$var$vec4(viewPosition.xyz, 1.0));
                // force background to far plane so it does not occlude objects
                viewProj = viewProj.setZ(viewProj.w);
                const nodeMaterial = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
                nodeMaterial.name = 'Background.material';
                nodeMaterial.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
                nodeMaterial.depthTest = false;
                nodeMaterial.depthWrite = false;
                nodeMaterial.allowOverride = false;
                nodeMaterial.fog = false;
                nodeMaterial.lights = false;
                nodeMaterial.vertexNode = viewProj;
                nodeMaterial.colorNode = backgroundMeshNode;
                sceneData.backgroundMeshNode = backgroundMeshNode;
                sceneData.backgroundMesh = backgroundMesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(new (0, $9ddd7e9b53f7a2d4$export$1b417fc3b307a251)(1, 32, 32), nodeMaterial);
                backgroundMesh.frustumCulled = false;
                backgroundMesh.name = 'Background.mesh';
                function onBackgroundDispose() {
                    background.removeEventListener('dispose', onBackgroundDispose);
                    backgroundMesh.material.dispose();
                    backgroundMesh.geometry.dispose();
                }
                background.addEventListener('dispose', onBackgroundDispose);
            }
            const backgroundCacheKey = backgroundNode.getCacheKey();
            if (sceneData.backgroundCacheKey !== backgroundCacheKey) {
                sceneData.backgroundMeshNode.node = $03ccd63b0299d6a7$var$vec4(backgroundNode).mul($03ccd63b0299d6a7$var$backgroundIntensity);
                sceneData.backgroundMeshNode.needsUpdate = true;
                backgroundMesh.material.needsUpdate = true;
                sceneData.backgroundCacheKey = backgroundCacheKey;
            }
            renderList.unshift(backgroundMesh, backgroundMesh.geometry, backgroundMesh.material, 0, 0, null, null);
        } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Renderer: Unsupported background configuration.', background);
        //
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') $03ccd63b0299d6a7$var$_clearColor.set(0, 0, 0, 1);
        else if (environmentBlendMode === 'alpha-blend') $03ccd63b0299d6a7$var$_clearColor.set(0, 0, 0, 0);
        //
        if (renderer.autoClear === true || forceClear === true) {
            const clearColorValue = renderContext.clearColorValue;
            clearColorValue.r = $03ccd63b0299d6a7$var$_clearColor.r;
            clearColorValue.g = $03ccd63b0299d6a7$var$_clearColor.g;
            clearColorValue.b = $03ccd63b0299d6a7$var$_clearColor.b;
            clearColorValue.a = $03ccd63b0299d6a7$var$_clearColor.a;
            // premultiply alpha
            if (renderer.backend.isWebGLBackend === true || renderer.alpha === true) {
                clearColorValue.r *= clearColorValue.a;
                clearColorValue.g *= clearColorValue.a;
                clearColorValue.b *= clearColorValue.a;
            }
            //
            renderContext.depthClearValue = renderer.getClearDepth();
            renderContext.stencilClearValue = renderer.getClearStencil();
            renderContext.clearColor = renderer.autoClearColor === true;
            renderContext.clearDepth = renderer.autoClearDepth === true;
            renderContext.clearStencil = renderer.autoClearStencil === true;
        } else {
            renderContext.clearColor = false;
            renderContext.clearDepth = false;
            renderContext.clearStencil = false;
        }
    }
}
let $03ccd63b0299d6a7$var$_id$7 = 0;
/**
 * A bind group represents a collection of bindings and thus a collection
 * or resources. Bind groups are assigned to pipelines to provide them
 * with the required resources (like uniform buffers or textures).
 *
 * @private
 */ class $03ccd63b0299d6a7$var$BindGroup {
    /**
	 * Constructs a new bind group.
	 *
	 * @param {string} name - The bind group's name.
	 * @param {Array<Binding>} bindings - An array of bindings.
	 * @param {number} index - The group index.
	 */ constructor(name = '', bindings = []){
        /**
		 * The bind group's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * An array of bindings.
		 *
		 * @type {Array<Binding>}
		 */ this.bindings = bindings;
        /**
		 * The group's ID.
		 *
		 * @type {number}
		 */ this.id = $03ccd63b0299d6a7$var$_id$7++;
    }
}
/**
 * This module represents the state of a node builder after it was
 * used to build the nodes for a render object. The state holds the
 * results of the build for further processing in the renderer.
 *
 * Render objects with identical cache keys share the same node builder state.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$NodeBuilderState {
    /**
	 * Constructs a new node builder state.
	 *
	 * @param {string} vertexShader - The native vertex shader code.
	 * @param {string} fragmentShader - The native fragment shader code.
	 * @param {string} computeShader - The native compute shader code.
	 * @param {Array<NodeAttribute>} nodeAttributes - An array of node attributes.
	 * @param {Array<BindGroup>} bindings - An array of bind groups.
	 * @param {Array<Node>} updateNodes - An array of nodes that implement their `update()` method.
	 * @param {Array<Node>} updateBeforeNodes - An array of nodes that implement their `updateBefore()` method.
	 * @param {Array<Node>} updateAfterNodes - An array of nodes that implement their `updateAfter()` method.
	 * @param {NodeMaterialObserver} observer - A node material observer.
	 * @param {Array<Object>} transforms - An array with transform attribute objects. Only relevant when using compute shaders with WebGL 2.
	 */ constructor(vertexShader, fragmentShader, computeShader, nodeAttributes, bindings, updateNodes, updateBeforeNodes, updateAfterNodes, observer, transforms = []){
        /**
		 * The native vertex shader code.
		 *
		 * @type {string}
		 */ this.vertexShader = vertexShader;
        /**
		 * The native fragment shader code.
		 *
		 * @type {string}
		 */ this.fragmentShader = fragmentShader;
        /**
		 * The native compute shader code.
		 *
		 * @type {string}
		 */ this.computeShader = computeShader;
        /**
		 * An array with transform attribute objects.
		 * Only relevant when using compute shaders with WebGL 2.
		 *
		 * @type {Array<Object>}
		 */ this.transforms = transforms;
        /**
		 * An array of node attributes representing
		 * the attributes of the shaders.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.nodeAttributes = nodeAttributes;
        /**
		 * An array of bind groups representing the uniform or storage
		 * buffers, texture or samplers of the shader.
		 *
		 * @type {Array<BindGroup>}
		 */ this.bindings = bindings;
        /**
		 * An array of nodes that implement their `update()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateNodes = updateNodes;
        /**
		 * An array of nodes that implement their `updateBefore()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateBeforeNodes = updateBeforeNodes;
        /**
		 * An array of nodes that implement their `updateAfter()` method.
		 *
		 * @type {Array<Node>}
		 */ this.updateAfterNodes = updateAfterNodes;
        /**
		 * A node material observer.
		 *
		 * @type {NodeMaterialObserver}
		 */ this.observer = observer;
        /**
		 * How often this state is used by render objects.
		 *
		 * @type {number}
		 */ this.usedTimes = 0;
    }
    /**
	 * This method is used to create a array of bind groups based
	 * on the existing bind groups of this state. Shared groups are
	 * not cloned.
	 *
	 * @return {Array<BindGroup>} A array of bind groups.
	 */ createBindings() {
        const bindings = [];
        for (const instanceGroup of this.bindings){
            const shared = instanceGroup.bindings[0].groupNode.shared; // All bindings in the group must have the same groupNode.
            if (shared !== true) {
                const bindingsGroup = new $03ccd63b0299d6a7$var$BindGroup(instanceGroup.name, []);
                bindings.push(bindingsGroup);
                for (const instanceBinding of instanceGroup.bindings)bindingsGroup.bindings.push(instanceBinding.clone());
            } else bindings.push(instanceGroup);
        }
        return bindings;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader attributes that are going to be generated
 * by the builder. Arrays of node attributes is maintained in {@link NodeBuilder#attributes}
 * and {@link NodeBuilder#bufferAttributes} for this purpose.
 */ class $03ccd63b0299d6a7$export$7a439a3cecb5f184 {
    /**
	 * Constructs a new node attribute.
	 *
	 * @param {string} name - The name of the attribute.
	 * @param {string} type - The type of the attribute.
	 * @param {?Node} node - An optional reference to the node.
	 */ constructor(name, type, node = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeAttribute = true;
        /**
		 * The name of the attribute.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the attribute.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * An optional reference to the node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.node = node;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader uniforms that are going to be generated
 * by the builder. A dictionary of node uniforms is maintained in {@link NodeBuilder#uniforms}
 * for this purpose.
 */ class $03ccd63b0299d6a7$export$68c170317a5fc074 {
    /**
	 * Constructs a new node uniform.
	 *
	 * @param {string} name - The name of the uniform.
	 * @param {string} type - The type of the uniform.
	 * @param {UniformNode} node - An reference to the node.
	 */ constructor(name, type, node){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniform = true;
        /**
		 * The name of the uniform.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the uniform.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * An reference to the node.
		 *
		 * @type {UniformNode}
		 */ this.node = node;
    }
    /**
	 * The value of the uniform node.
	 *
	 * @type {any}
	 */ get value() {
        return this.node.value;
    }
    set value(val) {
        this.node.value = val;
    }
    /**
	 * The id of the uniform node.
	 *
	 * @type {number}
	 */ get id() {
        return this.node.id;
    }
    /**
	 * The uniform node's group.
	 *
	 * @type {UniformGroupNode}
	 */ get groupNode() {
        return this.node.groupNode;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader variables that are going to be generated
 * by the builder. A dictionary of node variables is maintained in {@link NodeBuilder#vars} for
 * this purpose.
 */ class $03ccd63b0299d6a7$export$b6d311b93c4db99a {
    /**
	 * Constructs a new node variable.
	 *
	 * @param {string} name - The name of the variable.
	 * @param {string} type - The type of the variable.
	 * @param {boolean} [readOnly=false] - The read-only flag.
	 * @param {?number} [count=null] - The size.
	 */ constructor(name, type, readOnly = false, count = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeVar = true;
        /**
		 * The name of the variable.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The type of the variable.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 *  The read-only flag.
		 *
		 * @type {boolean}
		 */ this.readOnly = readOnly;
        /**
		 * The size.
		 *
		 * @type {?number}
		 */ this.count = count;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent the final shader varyings that are going to be generated
 * by the builder. An array of node varyings is maintained in {@link NodeBuilder#varyings} for
 * this purpose.
 *
 * @augments NodeVar
 */ class $03ccd63b0299d6a7$export$486c6ccd7c84a9e3 extends $03ccd63b0299d6a7$export$b6d311b93c4db99a {
    /**
	 * Constructs a new node varying.
	 *
	 * @param {string} name - The name of the varying.
	 * @param {string} type - The type of the varying.
	 * @param {?string} interpolationType - The interpolation type of the varying.
	 * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
	 */ constructor(name, type, interpolationType = null, interpolationSampling = null){
        super(name, type);
        /**
		 * Whether this varying requires interpolation or not. This property can be used
		 * to check if the varying can be optimized for a variable.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsInterpolation = false;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeVarying = true;
        /**
		 * The interpolation type of the varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationType = interpolationType;
        /**
		 * The interpolation sampling type of varying data.
		 *
		 * @type {?string}
		 * @default null
		 */ this.interpolationSampling = interpolationSampling;
    }
}
/**
 * {@link NodeBuilder} is going to create instances of this class during the build process
 * of nodes. They represent user-defined, native shader code portions that are going to be
 * injected by the builder. A dictionary of node codes is maintained in {@link NodeBuilder#codes}
 * for this purpose.
 */ class $03ccd63b0299d6a7$export$46b16f31af73381b {
    /**
	 * Constructs a new code node.
	 *
	 * @param {string} name - The name of the code.
	 * @param {string} type - The node type.
	 * @param {string} [code=''] - The native shader code.
	 */ constructor(name, type, code = ''){
        /**
		 * The name of the code.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The node type.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The native shader code.
		 *
		 * @type {string}
		 * @default ''
		 */ this.code = code;
        Object.defineProperty(this, 'isNodeCode', {
            value: true
        });
    }
}
let $03ccd63b0299d6a7$var$_id$6 = 0;
/**
 * This utility class is used in {@link NodeBuilder} as an internal
 * cache data structure for node data.
 */ class $03ccd63b0299d6a7$export$1d1d74a0a581fcfd {
    /**
	 * Constructs a new node cache.
	 *
	 * @param {?NodeCache} parent - A reference to a parent cache.
	 */ constructor(parent = null){
        /**
		 * The id of the cache.
		 *
		 * @type {number}
		 * @readonly
		 */ this.id = $03ccd63b0299d6a7$var$_id$6++;
        /**
		 * A weak map for managing node data.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.nodesData = new WeakMap();
        /**
		 * Reference to a parent node cache.
		 *
		 * @type {?NodeCache}
		 * @default null
		 */ this.parent = parent;
    }
    /**
	 * Returns the data for the given node.
	 *
	 * @param {Node} node - The node.
	 * @return {?Object} The data for the node.
	 */ getData(node) {
        let data = this.nodesData.get(node);
        if (data === undefined && this.parent !== null) data = this.parent.getData(node);
        return data;
    }
    /**
	 * Sets the data for a given node.
	 *
	 * @param {Node} node - The node.
	 * @param {Object} data - The data that should be cached.
	 */ setData(node, data) {
        this.nodesData.set(node, data);
    }
}
class $03ccd63b0299d6a7$var$StructType {
    constructor(name, members){
        this.name = name;
        this.members = members;
        this.output = false;
    }
}
/**
 * Abstract base class for uniforms.
 *
 * @abstract
 * @private
 */ class $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {any} value - The uniform's value.
	 */ constructor(name, value){
        /**
		 * The uniform's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The uniform's value.
		 *
		 * @type {any}
		 */ this.value = value;
        /**
		 * Used to build the uniform buffer according to the STD140 layout.
		 * Derived uniforms will set this property to a data type specific
		 * value.
		 *
		 * @type {number}
		 */ this.boundary = 0;
        /**
		 * The item size. Derived uniforms will set this property to a data
		 * type specific value.
		 *
		 * @type {number}
		 */ this.itemSize = 0;
        /**
		 * This property is set by {@link UniformsGroup} and marks
		 * the start position in the uniform buffer.
		 *
		 * @type {number}
		 */ this.offset = 0;
        /**
		 * This property is set by {@link UniformsGroup} and marks
		 * the index position in the uniform array.
		 *
		 * @type {number}
		 */ this.index = -1;
    }
    /**
	 * Sets the uniform's value.
	 *
	 * @param {any} value - The value to set.
	 */ setValue(value) {
        this.value = value;
    }
    /**
	 * Returns the uniform's value.
	 *
	 * @return {any} The value.
	 */ getValue() {
        return this.value;
    }
}
/**
 * Represents a Number uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$NumberUniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {number} value - The uniform's value.
	 */ constructor(name, value = 0){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNumberUniform = true;
        this.boundary = 4;
        this.itemSize = 1;
    }
}
/**
 * Represents a Vector2 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Vector2Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector2} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector2Uniform = true;
        this.boundary = 8;
        this.itemSize = 2;
    }
}
/**
 * Represents a Vector3 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Vector3Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector3} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector3Uniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
/**
 * Represents a Vector4 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Vector4Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Vector4} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVector4Uniform = true;
        this.boundary = 16;
        this.itemSize = 4;
    }
}
/**
 * Represents a Color uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$ColorUniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Color} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColorUniform = true;
        this.boundary = 16;
        this.itemSize = 3;
    }
}
/**
 * Represents a Matrix2 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Matrix2Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix2} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$cbcc6560bf79fb38)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix2Uniform = true;
        this.boundary = 8;
        this.itemSize = 4;
    }
}
/**
 * Represents a Matrix3 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Matrix3Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix3} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix3Uniform = true;
        this.boundary = 48;
        this.itemSize = 12;
    }
}
/**
 * Represents a Matrix4 uniform.
 *
 * @private
 * @augments Uniform
 */ class $03ccd63b0299d6a7$var$Matrix4Uniform extends $03ccd63b0299d6a7$var$Uniform {
    /**
	 * Constructs a new Number uniform.
	 *
	 * @param {string} name - The uniform's name.
	 * @param {Matrix4} value - The uniform's value.
	 */ constructor(name, value = new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)()){
        super(name, value);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMatrix4Uniform = true;
        this.boundary = 64;
        this.itemSize = 16;
    }
}
/**
 * A special form of Number uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments NumberUniform
 */ class $03ccd63b0299d6a7$var$NumberNodeUniform extends $03ccd63b0299d6a7$var$NumberUniform {
    /**
	 * Constructs a new node-based Number uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {number} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector2 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector2Uniform
 */ class $03ccd63b0299d6a7$var$Vector2NodeUniform extends $03ccd63b0299d6a7$var$Vector2Uniform {
    /**
	 * Constructs a new node-based Vector2 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector2} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector3 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector3Uniform
 */ class $03ccd63b0299d6a7$var$Vector3NodeUniform extends $03ccd63b0299d6a7$var$Vector3Uniform {
    /**
	 * Constructs a new node-based Vector3 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector3} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Vector4 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Vector4Uniform
 */ class $03ccd63b0299d6a7$var$Vector4NodeUniform extends $03ccd63b0299d6a7$var$Vector4Uniform {
    /**
	 * Constructs a new node-based Vector4 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Vector4} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Color uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments ColorUniform
 */ class $03ccd63b0299d6a7$var$ColorNodeUniform extends $03ccd63b0299d6a7$var$ColorUniform {
    /**
	 * Constructs a new node-based Color uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Color} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix2 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix2Uniform
 */ class $03ccd63b0299d6a7$var$Matrix2NodeUniform extends $03ccd63b0299d6a7$var$Matrix2Uniform {
    /**
	 * Constructs a new node-based Matrix2 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix2} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix3 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix3Uniform
 */ class $03ccd63b0299d6a7$var$Matrix3NodeUniform extends $03ccd63b0299d6a7$var$Matrix3Uniform {
    /**
	 * Constructs a new node-based Matrix3 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix3} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
/**
 * A special form of Matrix4 uniform binding type.
 * It's value is managed by a node object.
 *
 * @private
 * @augments Matrix4Uniform
 */ class $03ccd63b0299d6a7$var$Matrix4NodeUniform extends $03ccd63b0299d6a7$var$Matrix4Uniform {
    /**
	 * Constructs a new node-based Matrix4 uniform.
	 *
	 * @param {NodeUniform} nodeUniform - The node uniform.
	 */ constructor(nodeUniform){
        super(nodeUniform.name, nodeUniform.value);
        /**
		 * The node uniform.
		 *
		 * @type {NodeUniform}
		 */ this.nodeUniform = nodeUniform;
    }
    /**
	 * Overwritten to return the value of the node uniform.
	 *
	 * @return {Matrix4} The value.
	 */ getValue() {
        return this.nodeUniform.value;
    }
    /**
	 * Returns the node uniform data type.
	 *
	 * @return {string} The data type.
	 */ getType() {
        return this.nodeUniform.type;
    }
}
let $03ccd63b0299d6a7$var$_id$5 = 0;
const $03ccd63b0299d6a7$var$_bindingGroupsCache = new WeakMap();
const $03ccd63b0299d6a7$var$sharedNodeData = new WeakMap();
const $03ccd63b0299d6a7$var$typeFromArray = new Map([
    [
        Int8Array,
        'int'
    ],
    [
        Int16Array,
        'int'
    ],
    [
        Int32Array,
        'int'
    ],
    [
        Uint8Array,
        'uint'
    ],
    [
        Uint16Array,
        'uint'
    ],
    [
        Uint32Array,
        'uint'
    ],
    [
        Float32Array,
        'float'
    ]
]);
const $03ccd63b0299d6a7$var$toFloat = (value)=>{
    if (/e/g.test(value)) return String(value).replace(/\+/g, '');
    else {
        value = Number(value);
        return value + (value % 1 ? '' : '.0');
    }
};
/**
 * Base class for builders which generate a shader program based
 * on a 3D object and its node material definition.
 */ class $03ccd63b0299d6a7$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new node builder.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The current renderer.
	 * @param {NodeParser} parser - A reference to a node parser.
	 */ constructor(object, renderer, parser){
        /**
		 * The 3D object.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The material of the 3D object.
		 *
		 * @type {?Material}
		 */ this.material = object && object.material || null;
        /**
		 * The geometry of the 3D object.
		 *
		 * @type {?BufferGeometry}
		 */ this.geometry = object && object.geometry || null;
        /**
		 * The current renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * A reference to a node parser.
		 *
		 * @type {NodeParser}
		 */ this.parser = parser;
        /**
		 * The scene the 3D object belongs to.
		 *
		 * @type {?Scene}
		 * @default null
		 */ this.scene = null;
        /**
		 * The camera the 3D object is rendered with.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * A list of all nodes the builder is processing
		 * for this 3D object.
		 *
		 * @type {Array<Node>}
		 */ this.nodes = [];
        /**
		 * A list of all nodes the builder is processing in sequential order.
		 *
		 * This is used to determine the update order of nodes, which is important for
		 * {@link NodeUpdateType#UPDATE_BEFORE} and {@link NodeUpdateType#UPDATE_AFTER}.
		 *
		 * @type {Array<Node>}
		 */ this.sequentialNodes = [];
        /**
		 * A list of all nodes which {@link Node#update} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateNodes = [];
        /**
		 * A list of all nodes which {@link Node#updateBefore} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateBeforeNodes = [];
        /**
		 * A list of all nodes which {@link Node#updateAfter} method should be executed.
		 *
		 * @type {Array<Node>}
		 */ this.updateAfterNodes = [];
        /**
		 * A dictionary that assigns each node to a unique hash.
		 *
		 * @type {Object<number,Node>}
		 */ this.hashNodes = {};
        /**
		 * A reference to a node material observer.
		 *
		 * @type {?NodeMaterialObserver}
		 * @default null
		 */ this.observer = null;
        /**
		 * A reference to the current lights node.
		 *
		 * @type {?LightsNode}
		 * @default null
		 */ this.lightsNode = null;
        /**
		 * A reference to the current environment node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.environmentNode = null;
        /**
		 * A reference to the current fog node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.fogNode = null;
        /**
		 * The current clipping context.
		 *
		 * @type {?ClippingContext}
		 */ this.clippingContext = null;
        /**
		 * The generated vertex shader.
		 *
		 * @type {?string}
		 */ this.vertexShader = null;
        /**
		 * The generated fragment shader.
		 *
		 * @type {?string}
		 */ this.fragmentShader = null;
        /**
		 * The generated compute shader.
		 *
		 * @type {?string}
		 */ this.computeShader = null;
        /**
		 * Nodes used in the primary flow of code generation.
		 *
		 * @type {Object<string,Array<Node>>}
		 */ this.flowNodes = {
            vertex: [],
            fragment: [],
            compute: []
        };
        /**
		 * Nodes code from `.flowNodes`.
		 *
		 * @type {Object<string,string>}
		 */ this.flowCode = {
            vertex: '',
            fragment: '',
            compute: ''
        };
        /**
		 * This dictionary holds the node uniforms of the builder.
		 * The uniforms are maintained in an array for each shader stage.
		 *
		 * @type {Object}
		 */ this.uniforms = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the output structs of the builder.
		 * The structs are maintained in an array for each shader stage.
		 *
		 * @type {Object}
		 */ this.structs = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the types of the builder.
		 *
		 * @type {Object}
		 */ this.types = {
            vertex: [],
            fragment: [],
            compute: [],
            index: 0
        };
        /**
		 * This dictionary holds the bindings for each shader stage.
		 *
		 * @type {Object}
		 */ this.bindings = {
            vertex: {},
            fragment: {},
            compute: {}
        };
        /**
		 * This dictionary maintains the binding indices per bind group.
		 *
		 * @type {Object}
		 */ this.bindingsIndexes = {};
        /**
		 * Reference to the array of bind groups.
		 *
		 * @type {?Array<BindGroup>}
		 */ this.bindGroups = null;
        /**
		 * This array holds the node attributes of this builder
		 * created via {@link AttributeNode}.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.attributes = [];
        /**
		 * This array holds the node attributes of this builder
		 * created via {@link BufferAttributeNode}.
		 *
		 * @type {Array<NodeAttribute>}
		 */ this.bufferAttributes = [];
        /**
		 * This array holds the node varyings of this builder.
		 *
		 * @type {Array<NodeVarying>}
		 */ this.varyings = [];
        /**
		 * This dictionary holds the (native) node codes of this builder.
		 * The codes are maintained in an array for each shader stage.
		 *
		 * @type {Object<string,Array<NodeCode>>}
		 */ this.codes = {};
        /**
		 * This dictionary holds the node variables of this builder.
		 * The variables are maintained in an array for each shader stage.
		 * This dictionary is also used to count the number of variables
		 * according to their type (const, vars).
		 *
		 * @type {Object<string,Array<NodeVar>|number>}
		 */ this.vars = {};
        /**
		 * This dictionary holds the declarations for each shader stage.
		 *
		 * @type {Object}
		 */ this.declarations = {};
        /**
		 * Current code flow.
		 * All code generated in this stack will be stored in `.flow`.
		 *
		 * @type {{code: string}}
		 */ this.flow = {
            code: ''
        };
        /**
		 * A chain of nodes.
		 * Used to check recursive calls in node-graph.
		 *
		 * @type {Array<Node>}
		 */ this.chaining = [];
        /**
		 * The current stack.
		 * This reflects the current process in the code block hierarchy,
		 * it is useful to know if the current process is inside a conditional for example.
		 *
		 * @type {StackNode}
		 */ this.stack = $03ccd63b0299d6a7$var$stack();
        /**
		 * List of stack nodes.
		 * The current stack hierarchy is stored in an array.
		 *
		 * @type {Array<StackNode>}
		 */ this.stacks = [];
        /**
		 * A tab value. Used for shader string generation.
		 *
		 * @type {string}
		 * @default '\t'
		 */ this.tab = '\t';
        /**
		 * Reference to the current function node.
		 *
		 * @type {?FunctionNode}
		 * @default null
		 */ this.currentFunctionNode = null;
        /**
		 * The builder's context.
		 *
		 * @type {Object}
		 */ this.context = {
            material: this.material
        };
        /**
		 * The builder's cache.
		 *
		 * @type {NodeCache}
		 */ this.cache = new $03ccd63b0299d6a7$export$1d1d74a0a581fcfd();
        /**
		 * Since the {@link NodeBuilder#cache} might be temporarily
		 * overwritten by other caches, this member retains the reference
		 * to the builder's own cache.
		 *
		 * @type {NodeCache}
		 * @default this.cache
		 */ this.globalCache = this.cache;
        this.flowsData = new WeakMap();
        /**
		 * The current shader stage.
		 *
		 * @type {?('vertex'|'fragment'|'compute'|'any')}
		 */ this.shaderStage = null;
        /**
		 * The current build stage.
		 *
		 * @type {?('setup'|'analyze'|'generate')}
		 */ this.buildStage = null;
        /**
		 * The sub-build layers.
		 *
		 * @type {Array<SubBuildNode>}
		 * @default []
		 */ this.subBuildLayers = [];
        /**
		 * The active stack nodes.
		 *
		 * @type {Array<StackNode>}
		 */ this.activeStacks = [];
        /**
		 * The current sub-build TSL function(Fn).
		 *
		 * @type {?string}
		 * @default null
		 */ this.subBuildFn = null;
        /**
		 * The current TSL function(Fn) call node.
		 *
		 * @type {?Node}
		 * @default null
		 */ this.fnCall = null;
        Object.defineProperty(this, 'id', {
            value: $03ccd63b0299d6a7$var$_id$5++
        });
    }
    /**
	 * Whether the material is using flat shading or not.
	 *
	 * @returns {boolean} Whether the material is using flat shading or not.
	 */ isFlatShading() {
        return this.material.flatShading === true || this.geometry.hasAttribute('normal') === false;
    }
    /**
	 * Whether the material is opaque or not.
	 *
	 * @return {boolean} Whether the material is opaque or not.
	 */ isOpaque() {
        const material = this.material;
        return material.transparent === false && material.blending === (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) && material.alphaToCoverage === false;
    }
    /**
	 * Factory method for creating an instance of {@link RenderTarget} with the given
	 * dimensions and options.
	 *
	 * @param {number} width - The width of the render target.
	 * @param {number} height - The height of the render target.
	 * @param {Object} options - The options of the render target.
	 * @return {RenderTarget} The render target.
	 */ createRenderTarget(width, height, options) {
        return new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(width, height, options);
    }
    /**
	 * Factory method for creating an instance of {@link CubeRenderTarget} with the given
	 * dimensions and options.
	 *
	 * @param {number} size - The size of the cube render target.
	 * @param {Object} options - The options of the cube render target.
	 * @return {CubeRenderTarget} The cube render target.
	 */ createCubeRenderTarget(size, options) {
        return new $03ccd63b0299d6a7$export$d4daf84839cea508(size, options);
    }
    /**
	 * Whether the given node is included in the internal array of nodes or not.
	 *
	 * @param {Node} node - The node to test.
	 * @return {boolean} Whether the given node is included in the internal array of nodes or not.
	 */ includes(node) {
        return this.nodes.includes(node);
    }
    /**
	 * Returns the output struct name which is required by
	 * {@link OutputStructNode}.
	 *
	 * @abstract
	 * @return {string} The name of the output struct.
	 */ getOutputStructName() {}
    /**
	 * Returns a bind group for the given group name and binding.
	 *
	 * @private
	 * @param {string} groupName - The group name.
	 * @param {Array<NodeUniformsGroup>} bindings - List of bindings.
	 * @return {BindGroup} The bind group
	 */ _getBindGroup(groupName, bindings) {
        const groupNode = bindings[0].groupNode;
        let sharedGroup = groupNode.shared;
        if (sharedGroup) {
            for(let i = 1; i < bindings.length; i++)if (groupNode !== bindings[i].groupNode) sharedGroup = false;
        }
        //
        let bindGroup;
        if (sharedGroup) {
            let cacheKeyString = '';
            for (const binding of bindings)if (binding.isNodeUniformsGroup) {
                binding.uniforms.sort((a, b)=>a.nodeUniform.node.id - b.nodeUniform.node.id);
                for (const uniform of binding.uniforms)cacheKeyString += uniform.nodeUniform.node.id;
            } else cacheKeyString += binding.nodeUniform.id;
            // TODO: Remove this hack ._currentRenderContext
            const currentContext = this.renderer._currentRenderContext || this.renderer; // use renderer as fallback until we have a compute context
            let bindingGroupsCache = $03ccd63b0299d6a7$var$_bindingGroupsCache.get(currentContext);
            if (bindingGroupsCache === undefined) {
                bindingGroupsCache = new Map();
                $03ccd63b0299d6a7$var$_bindingGroupsCache.set(currentContext, bindingGroupsCache);
            }
            //
            const cacheKey = $03ccd63b0299d6a7$var$hashString(cacheKeyString);
            bindGroup = bindingGroupsCache.get(cacheKey);
            if (bindGroup === undefined) {
                bindGroup = new $03ccd63b0299d6a7$var$BindGroup(groupName, bindings);
                bindingGroupsCache.set(cacheKey, bindGroup);
            }
        } else bindGroup = new $03ccd63b0299d6a7$var$BindGroup(groupName, bindings);
        return bindGroup;
    }
    /**
	 * Returns an array of node uniform groups for the given group name and shader stage.
	 *
	 * @param {string} groupName - The group name.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {Array<NodeUniformsGroup>} The array of node uniform groups.
	 */ getBindGroupArray(groupName, shaderStage) {
        const bindings = this.bindings[shaderStage];
        let bindGroup = bindings[groupName];
        if (bindGroup === undefined) {
            if (this.bindingsIndexes[groupName] === undefined) this.bindingsIndexes[groupName] = {
                binding: 0,
                group: Object.keys(this.bindingsIndexes).length
            };
            bindings[groupName] = bindGroup = [];
        }
        return bindGroup;
    }
    /**
	 * Returns a list bindings of all shader stages separated by groups.
	 *
	 * @return {Array<BindGroup>} The list of bindings.
	 */ getBindings() {
        let bindingsGroups = this.bindGroups;
        if (bindingsGroups === null) {
            const groups = {};
            const bindings = this.bindings;
            for (const shaderStage of $03ccd63b0299d6a7$export$48fd793f0255b86a)for(const groupName in bindings[shaderStage]){
                const uniforms = bindings[shaderStage][groupName];
                const groupUniforms = groups[groupName] || (groups[groupName] = []);
                for (const uniform of uniforms)if (groupUniforms.includes(uniform) === false) groupUniforms.push(uniform);
            }
            bindingsGroups = [];
            for(const groupName in groups){
                const group = groups[groupName];
                const bindingsGroup = this._getBindGroup(groupName, group);
                bindingsGroups.push(bindingsGroup);
            }
            this.bindGroups = bindingsGroups;
        }
        return bindingsGroups;
    }
    /**
	 * Sorts the bind groups and updates {@link NodeBuilder#bindingsIndexes}.
	 */ sortBindingGroups() {
        const bindingsGroups = this.getBindings();
        bindingsGroups.sort((a, b)=>a.bindings[0].groupNode.order - b.bindings[0].groupNode.order);
        for(let i = 0; i < bindingsGroups.length; i++){
            const bindingGroup = bindingsGroups[i];
            this.bindingsIndexes[bindingGroup.name].group = i;
        }
    }
    /**
	 * The builder maintains each node in a hash-based dictionary.
	 * This method sets the given node (value) with the given hash (key) into this dictionary.
	 *
	 * @param {Node} node - The node to add.
	 * @param {number} hash - The hash of the node.
	 */ setHashNode(node, hash) {
        this.hashNodes[hash] = node;
    }
    /**
	 * Adds a node to this builder.
	 *
	 * @param {Node} node - The node to add.
	 */ addNode(node) {
        if (this.nodes.includes(node) === false) {
            this.nodes.push(node);
            this.setHashNode(node, node.getHash(this));
        }
    }
    /**
	 * It is used to add Nodes that will be used as FRAME and RENDER events,
	 * and need to follow a certain sequence in the calls to work correctly.
	 * This function should be called after 'setup()' in the 'build()' process to ensure that the child nodes are processed first.
	 *
	 * @param {Node} node - The node to add.
	 */ addSequentialNode(node) {
        const updateBeforeType = node.getUpdateBeforeType();
        const updateAfterType = node.getUpdateAfterType();
        if (updateBeforeType !== $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE || updateAfterType !== $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE) {
            if (this.sequentialNodes.includes(node) === false) this.sequentialNodes.push(node);
        }
    }
    /**
	 * Checks the update types of nodes
	 */ buildUpdateNodes() {
        for (const node of this.nodes){
            const updateType = node.getUpdateType();
            if (updateType !== $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE) this.updateNodes.push(node);
        }
        for (const node of this.sequentialNodes){
            const updateBeforeType = node.getUpdateBeforeType();
            const updateAfterType = node.getUpdateAfterType();
            if (updateBeforeType !== $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE) this.updateBeforeNodes.push(node);
            if (updateAfterType !== $03ccd63b0299d6a7$export$26f7a8bbd9469530.NONE) this.updateAfterNodes.push(node);
        }
    }
    /**
	 * A reference the current node which is the
	 * last node in the chain of nodes.
	 *
	 * @type {Node}
	 */ get currentNode() {
        return this.chaining[this.chaining.length - 1];
    }
    /**
	 * Whether the given texture is filtered or not.
	 *
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture is filtered or not.
	 */ isFilteredTexture(texture) {
        return texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$19a719f377145a13) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$19a719f377145a13) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b);
    }
    /**
	 * Returns the maximum number of bytes available for uniform buffers.
	 *
	 * @return {number} The maximum number of bytes available for uniform buffers.
	 */ getUniformBufferLimit() {
        return this.renderer.backend.capabilities.getUniformBufferLimit();
    }
    /**
	 * Adds the given node to the internal node chain.
	 * This is used to check recursive calls in node-graph.
	 *
	 * @param {Node} node - The node to add.
	 */ addChain(node) {
        /*
		if ( this.chaining.indexOf( node ) !== - 1 ) {

			warn( 'Recursive node: ', node );

		}
		*/ this.chaining.push(node);
    }
    /**
	 * Removes the given node from the internal node chain.
	 *
	 * @param {Node} node - The node to remove.
	 */ removeChain(node) {
        const lastChain = this.chaining.pop();
        if (lastChain !== node) throw new Error('NodeBuilder: Invalid node chaining!');
    }
    /**
	 * Returns the native shader method name for a given generic name. E.g.
	 * the method name `textureDimensions` matches the WGSL name but must be
	 * resolved to `textureSize` in GLSL.
	 *
	 * @abstract
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved method name.
	 */ getMethod(method) {
        return method;
    }
    /**
	 * Returns the native snippet for a ternary operation. E.g. GLSL would output
	 * a ternary op as `cond ? x : y` whereas WGSL would output it as `select(y, x, cond)`
	 *
	 * @abstract
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary() {
        return null;
    }
    /**
	 * Returns a node for the given hash, see {@link NodeBuilder#setHashNode}.
	 *
	 * @param {number} hash - The hash of the node.
	 * @return {Node} The found node.
	 */ getNodeFromHash(hash) {
        return this.hashNodes[hash];
    }
    /**
	 * Adds the Node to a target flow so that it can generate code in the 'generate' process.
	 *
	 * @param {('vertex'|'fragment'|'compute')} shaderStage - The shader stage.
	 * @param {Node} node - The node to add.
	 * @return {Node} The node.
	 */ addFlow(shaderStage, node) {
        this.flowNodes[shaderStage].push(node);
        return node;
    }
    /**
	 * Sets builder's context.
	 *
	 * @param {Object} context - The context to set.
	 */ setContext(context) {
        this.context = context;
    }
    /**
	 * Returns the builder's current context.
	 *
	 * @return {Object} The builder's current context.
	 */ getContext() {
        return this.context;
    }
    /**
	 * Adds context data to the builder's current context.
	 *
	 * @param {Object} context - The context to add.
	 * @return {Object} The previous context.
	 */ addContext(context) {
        const previousContext = this.getContext();
        this.setContext({
            ...this.context,
            ...context
        });
        return previousContext;
    }
    /**
	 * Gets a context used in shader construction that can be shared across different materials.
	 * This is necessary since the renderer cache can reuse shaders generated in one material and use them in another.
	 *
	 * @return {Object} The builder's current context without material.
	 */ getSharedContext() {
        const context = {
            ...this.context
        };
        delete context.material;
        delete context.getUV;
        delete context.getOutput;
        delete context.getTextureLevel;
        delete context.getAO;
        delete context.getShadow;
        return context;
    }
    /**
	 * Sets builder's cache.
	 *
	 * @param {NodeCache} cache - The cache to set.
	 */ setCache(cache) {
        this.cache = cache;
    }
    /**
	 * Returns the builder's current cache.
	 *
	 * @return {NodeCache} The builder's current cache.
	 */ getCache() {
        return this.cache;
    }
    /**
	 * Returns a cache for the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {boolean} [parent=true] - Whether this node refers to a shared parent cache or not.
	 * @return {NodeCache} The cache.
	 */ getCacheFromNode(node, parent = true) {
        const data = this.getDataFromNode(node);
        if (data.cache === undefined) data.cache = new $03ccd63b0299d6a7$export$1d1d74a0a581fcfd(parent ? this.getCache() : null);
        return data.cache;
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @abstract
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable() {
        return false;
    }
    /**
	 * Returns the vertexIndex input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The instanceIndex shader string.
	 */ getVertexIndex() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @abstract
	 * @return {string} The instanceIndex shader string.
	 */ getInstanceIndex() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the drawIndex input variable as a native shader string.
	 * Only relevant for WebGL and its `WEBGL_multi_draw` extension.
	 *
	 * @abstract
	 * @return {?string} The drawIndex shader string.
	 */ getDrawIndex() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the frontFacing input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The frontFacing shader string.
	 */ getFrontFacing() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the fragCoord input variable as a native shader string.
	 *
	 * @abstract
	 * @return {string} The fragCoord shader string.
	 */ getFragCoord() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Whether to flip texture data along its vertical axis or not. WebGL needs
	 * this method evaluate to `true`, WebGPU to `false`.
	 *
	 * @abstract
	 * @return {boolean} Whether to flip texture data along its vertical axis or not.
	 */ isFlipY() {
        return false;
    }
    /**
	 * Calling this method increases the usage count for the given node by one.
	 *
	 * @param {Node} node - The node to increase the usage count for.
	 * @return {number} The updated usage count.
	 */ increaseUsage(node) {
        const nodeData = this.getDataFromNode(node);
        nodeData.usageCount = nodeData.usageCount === undefined ? 1 : nodeData.usageCount + 1;
        return nodeData.usageCount;
    }
    /**
	 * Generates a texture sample shader string for the given texture data.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The texture property name.
	 * @param {string} uvSnippet - Snippet defining the texture coordinates.
	 * @return {string} The generated shader string.
	 */ generateTexture() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Generates a texture LOD shader string for the given texture data.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The texture property name.
	 * @param {string} uvSnippet - Snippet defining the texture coordinates.
	 * @param {?string} depthSnippet - Snippet defining the 0-based texture array index to sample.
	 * @param {string} levelSnippet - Snippet defining the mip level.
	 * @return {string} The generated shader string.
	 */ generateTextureLod() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Generates the array declaration string.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @return {string} The generated value as a shader string.
	 */ generateArrayDeclaration(type, count) {
        return this.getType(type) + '[ ' + count + ' ]';
    }
    /**
	 * Generates the array shader string for the given type and value.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @param {?Array<Node>} [values=null] - The default values.
	 * @return {string} The generated value as a shader string.
	 */ generateArray(type, count, values = null) {
        let snippet = this.generateArrayDeclaration(type, count) + '( ';
        for(let i = 0; i < count; i++){
            const value = values ? values[i] : null;
            if (value !== null) snippet += value.build(this, type);
            else snippet += this.generateConst(type);
            if (i < count - 1) snippet += ', ';
        }
        snippet += ' )';
        return snippet;
    }
    /**
	 * Generates the struct shader string.
	 *
	 * @param {string} type - The type.
	 * @param {Array<Object>} [membersLayout] - The count.
	 * @param {?Array<Node>} [values=null] - The default values.
	 * @return {string} The generated value as a shader string.
	 */ generateStruct(type, membersLayout, values = null) {
        const snippets = [];
        for (const member of membersLayout){
            const { name: name, type: type } = member;
            if (values && values[name] && values[name].isNode) snippets.push(values[name].build(this, type));
            else snippets.push(this.generateConst(type));
        }
        return type + '( ' + snippets.join(', ') + ' )';
    }
    /**
	 * Generates the shader string for the given type and value.
	 *
	 * @param {string} type - The type.
	 * @param {?any} [value=null] - The value.
	 * @return {string} The generated value as a shader string.
	 */ generateConst(type, value = null) {
        if (value === null) {
            if (type === 'float' || type === 'int' || type === 'uint') value = 0;
            else if (type === 'bool') value = false;
            else if (type === 'color') value = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
            else if (type === 'vec2' || type === 'uvec2' || type === 'ivec2') value = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
            else if (type === 'vec3' || type === 'uvec3' || type === 'ivec3') value = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
            else if (type === 'vec4' || type === 'uvec4' || type === 'ivec4') value = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        }
        if (type === 'float') return $03ccd63b0299d6a7$var$toFloat(value);
        if (type === 'int') return `${Math.round(value)}`;
        if (type === 'uint') return value >= 0 ? `${Math.round(value)}u` : '0u';
        if (type === 'bool') return value ? 'true' : 'false';
        if (type === 'color') return `${this.getType('vec3')}( ${$03ccd63b0299d6a7$var$toFloat(value.r)}, ${$03ccd63b0299d6a7$var$toFloat(value.g)}, ${$03ccd63b0299d6a7$var$toFloat(value.b)} )`;
        const typeLength = this.getTypeLength(type);
        const componentType = this.getComponentType(type);
        const generateConst = (value)=>this.generateConst(componentType, value);
        if (typeLength === 2) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)} )`;
        else if (typeLength === 3) return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)} )`;
        else if (typeLength === 4 && type !== 'mat2') return `${this.getType(type)}( ${generateConst(value.x)}, ${generateConst(value.y)}, ${generateConst(value.z)}, ${generateConst(value.w)} )`;
        else if (typeLength >= 4 && value && (value.isMatrix2 || value.isMatrix3 || value.isMatrix4)) return `${this.getType(type)}( ${value.elements.map(generateConst).join(', ')} )`;
        else if (typeLength > 4) return `${this.getType(type)}()`;
        throw new Error(`NodeBuilder: Type '${type}' not found in generate constant attempt.`);
    }
    /**
	 * It might be necessary to convert certain data types to different ones
	 * so this method can be used to hide the conversion.
	 *
	 * @param {string} type - The type.
	 * @return {string} The updated type.
	 */ getType(type) {
        if (type === 'color') return 'vec3';
        return type;
    }
    /**
	 * Whether the given attribute name is defined in the geometry or not.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether the given attribute name is defined in the geometry.
	 */ hasGeometryAttribute(name) {
        return this.geometry && this.geometry.getAttribute(name) !== undefined;
    }
    /**
	 * Returns a node attribute for the given name and type.
	 *
	 * @param {string} name - The attribute's name.
	 * @param {string} type - The attribute's type.
	 * @return {NodeAttribute} The node attribute.
	 */ getAttribute(name, type) {
        const attributes = this.attributes;
        // find attribute
        for (const attribute of attributes){
            if (attribute.name === name) return attribute;
        }
        // create a new if no exist
        const attribute = new $03ccd63b0299d6a7$export$7a439a3cecb5f184(name, type);
        this.registerDeclaration(attribute);
        attributes.push(attribute);
        return attribute;
    }
    /**
	 * Returns for the given node and shader stage the property name for the shader.
	 *
	 * @param {Node} node - The node.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The property name.
	 */ getPropertyName(node /*, shaderStage*/ ) {
        return node.name;
    }
    /**
	 * Whether the given type is a vector type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a vector type or not.
	 */ isVector(type) {
        return /vec\d/.test(type);
    }
    /**
	 * Whether the given type is a matrix type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a matrix type or not.
	 */ isMatrix(type) {
        return /mat\d/.test(type);
    }
    /**
	 * Whether the given type is a reference type or not.
	 *
	 * @param {string} type - The type to check.
	 * @return {boolean} Whether the given type is a reference type or not.
	 */ isReference(type) {
        return type === 'void' || type === 'property' || type === 'sampler' || type === 'samplerComparison' || type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'depthTexture' || type === 'texture3D';
    }
    /**
	 * Checks if the given texture requires a manual conversion to the working color space.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture requires a conversion to working color space or not.
	 */ needsToWorkingColorSpace() {
        return false;
    }
    /**
	 * Returns the component type of a given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {string} The component type.
	 */ getComponentTypeFromTexture(texture) {
        const type = texture.type;
        if (texture.isDataTexture) {
            if (type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) return 'int';
            if (type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) return 'uint';
        }
        return 'float';
    }
    /**
	 * Returns the element type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The element type.
	 */ getElementType(type) {
        if (type === 'mat2') return 'vec2';
        if (type === 'mat3') return 'vec3';
        if (type === 'mat4') return 'vec4';
        return this.getComponentType(type);
    }
    /**
	 * Returns the component type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The component type.
	 */ getComponentType(type) {
        type = this.getVectorType(type);
        if (type === 'float' || type === 'bool' || type === 'int' || type === 'uint') return type;
        const componentType = /(b|i|u|)(vec|mat)([2-4])/.exec(type);
        if (componentType === null) return null;
        if (componentType[1] === 'b') return 'bool';
        if (componentType[1] === 'i') return 'int';
        if (componentType[1] === 'u') return 'uint';
        return 'float';
    }
    /**
	 * Returns the vector type for a given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The vector type.
	 */ getVectorType(type) {
        if (type === 'color') return 'vec3';
        if (type === 'texture' || type === 'cubeTexture' || type === 'storageTexture' || type === 'texture3D') return 'vec4';
        return type;
    }
    /**
	 * Returns the data type for the given the length and component type.
	 *
	 * @param {number} length - The length.
	 * @param {string} [componentType='float'] - The component type.
	 * @return {string} The type.
	 */ getTypeFromLength(length, componentType = 'float') {
        if (length === 1) return componentType;
        let baseType = $03ccd63b0299d6a7$var$getTypeFromLength(length);
        const prefix = componentType === 'float' ? '' : componentType[0];
        // fix edge case for mat2x2 being same size as vec4
        if (/mat2/.test(componentType) === true) baseType = baseType.replace('vec', 'mat');
        return prefix + baseType;
    }
    /**
	 * Returns the type for a given typed array.
	 *
	 * @param {TypedArray} array - The typed array.
	 * @return {string} The type.
	 */ getTypeFromArray(array) {
        return $03ccd63b0299d6a7$var$typeFromArray.get(array.constructor);
    }
    /**
	 * Returns the type is an integer type.
	 *
	 * @param {string} type - The type.
	 * @return {boolean} Whether the type is an integer type or not.
	 */ isInteger(type) {
        return /int|uint|(i|u)vec/.test(type);
    }
    /**
	 * Returns the type for a given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @return {string} The type.
	 */ getTypeFromAttribute(attribute) {
        let dataAttribute = attribute;
        if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
        const array = dataAttribute.array;
        const itemSize = attribute.itemSize;
        const normalized = attribute.normalized;
        let arrayType;
        if (!(attribute instanceof (0, $9ddd7e9b53f7a2d4$export$dbd3698c64958d69)) && normalized !== true) arrayType = this.getTypeFromArray(array);
        return this.getTypeFromLength(itemSize, arrayType);
    }
    /**
	 * Returns the length for the given data type.
	 *
	 * @param {string} type - The data type.
	 * @return {number} The length.
	 */ getTypeLength(type) {
        const vecType = this.getVectorType(type);
        const vecNum = /vec([2-4])/.exec(vecType);
        if (vecNum !== null) return Number(vecNum[1]);
        if (vecType === 'float' || vecType === 'bool' || vecType === 'int' || vecType === 'uint') return 1;
        if (/mat2/.test(type) === true) return 4;
        if (/mat3/.test(type) === true) return 9;
        if (/mat4/.test(type) === true) return 16;
        return 0;
    }
    /**
	 * Returns the vector type for a given matrix type.
	 *
	 * @param {string} type - The matrix type.
	 * @return {string} The vector type.
	 */ getVectorFromMatrix(type) {
        return type.replace('mat', 'vec');
    }
    /**
	 * For a given type this method changes the component type to the
	 * given value. E.g. `vec4` should be changed to the new component type
	 * `uint` which results in `uvec4`.
	 *
	 * @param {string} type - The type.
	 * @param {string} newComponentType - The new component type.
	 * @return {string} The new type.
	 */ changeComponentType(type, newComponentType) {
        return this.getTypeFromLength(this.getTypeLength(type), newComponentType);
    }
    /**
	 * Returns the integer type pendant for the given type.
	 *
	 * @param {string} type - The type.
	 * @return {string} The integer type.
	 */ getIntegerType(type) {
        const componentType = this.getComponentType(type);
        if (componentType === 'int' || componentType === 'uint') return type;
        return this.changeComponentType(type, 'int');
    }
    /**
	 * Adds an active stack to the internal stack.
	 *
	 * @param {StackNode} stack - The stack node to add.
	 */ setActiveStack(stack) {
        this.activeStacks.push(stack);
    }
    /**
	 * Removes the active stack from the internal stack.
	 *
	 * @param {StackNode} stack - The stack node to remove.
	 */ removeActiveStack(stack) {
        if (this.activeStacks[this.activeStacks.length - 1] === stack) this.activeStacks.pop();
        else throw new Error('NodeBuilder: Invalid active stack removal.');
    }
    /**
	 * Returns the active stack.
	 *
	 * @return {StackNode} The active stack.
	 */ getActiveStack() {
        return this.activeStacks[this.activeStacks.length - 1];
    }
    /**
	 * Returns the base stack.
	 *
	 * @return {StackNode} The base stack.
	 */ getBaseStack() {
        return this.activeStacks[0];
    }
    /**
	 * Adds a stack node to the internal stack.
	 *
	 * @return {StackNode} The added stack node.
	 */ addStack() {
        this.stack = $03ccd63b0299d6a7$var$stack(this.stack);
        const previousStack = $03ccd63b0299d6a7$var$getCurrentStack();
        this.stacks.push(previousStack);
        $03ccd63b0299d6a7$var$setCurrentStack(this.stack);
        return this.stack;
    }
    /**
	 * Removes the last stack node from the internal stack.
	 *
	 * @return {StackNode} The removed stack node.
	 */ removeStack() {
        const lastStack = this.stack;
        for (const node of lastStack.nodes){
            const nodeData = this.getDataFromNode(node);
            nodeData.stack = lastStack;
        }
        this.stack = lastStack.parent;
        $03ccd63b0299d6a7$var$setCurrentStack(this.stacks.pop());
        return lastStack;
    }
    /**
	 * The builder maintains (cached) data for each node during the building process. This method
	 * can be used to get these data for a specific shader stage and cache.
	 *
	 * @param {Node} node - The node to get the data for.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {?NodeCache} cache - An optional cache.
	 * @return {Object} The node data.
	 */ getDataFromNode(node, shaderStage = this.shaderStage, cache = null) {
        cache = cache === null ? node.isGlobal(this) ? this.globalCache : this.cache : cache;
        let nodeData = cache.getData(node);
        if (nodeData === undefined) {
            nodeData = {};
            cache.setData(node, nodeData);
        }
        if (nodeData[shaderStage] === undefined) nodeData[shaderStage] = {};
        //
        let data = nodeData[shaderStage];
        const subBuilds = nodeData.any ? nodeData.any.subBuilds : null;
        const subBuild = this.getClosestSubBuild(subBuilds);
        if (subBuild) {
            if (data.subBuildsCache === undefined) data.subBuildsCache = {};
            data = data.subBuildsCache[subBuild] || (data.subBuildsCache[subBuild] = {});
            data.subBuilds = subBuilds;
        }
        return data;
    }
    /**
	 * Returns the properties for the given node and shader stage.
	 *
	 * Properties are typically used within a build stage to reference a node's
	 * child node or nodes manually assigned to the properties in a separate build stage.
	 * A typical usage pattern for defining nodes manually would be assigning dependency nodes
	 * to the current node's properties in the setup stage and building those properties in the generate stage.
	 *
	 * @param {Node} node - The node to get the properties for.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage='any'] - The shader stage.
	 * @return {Object} The node properties.
	 */ getNodeProperties(node, shaderStage = 'any') {
        const nodeData = this.getDataFromNode(node, shaderStage);
        return nodeData.properties || (nodeData.properties = {
            outputNode: null
        });
    }
    /**
	 * Returns an instance of {@link NodeAttribute} for the given buffer attribute node.
	 *
	 * @param {BufferAttributeNode} node - The buffer attribute node.
	 * @param {string} type - The node type.
	 * @return {NodeAttribute} The node attribute.
	 */ getBufferAttributeFromNode(node, type) {
        const nodeData = this.getDataFromNode(node, 'vertex');
        let bufferAttribute = nodeData.bufferAttribute;
        if (bufferAttribute === undefined) {
            const index = this.uniforms.index++;
            bufferAttribute = new $03ccd63b0299d6a7$export$7a439a3cecb5f184('nodeAttribute' + index, type, node);
            this.bufferAttributes.push(bufferAttribute);
            nodeData.bufferAttribute = bufferAttribute;
        }
        return bufferAttribute;
    }
    /**
	 * Returns an instance of {@link StructType} for the given struct name and shader stage
	 * or null if not found.
	 *
	 * @param {string} name - The name of the struct.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {?StructType} The struct type or null if not found.
	 */ getStructTypeNode(name, shaderStage = this.shaderStage) {
        return this.types[shaderStage][name] || null;
    }
    /**
	 * Returns an instance of {@link StructType} for the given output struct node.
	 *
	 * @param {OutputStructNode} node - The output struct node.
	 * @param {Array<Object>} membersLayout - The output struct types.
	 * @param {?string} [name=null] - The name of the struct.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {StructType} The struct type attribute.
	 */ getStructTypeFromNode(node, membersLayout, name = null, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let structType = nodeData.structType;
        if (structType === undefined) {
            const index = this.structs.index++;
            if (name === null) name = 'StructType' + index;
            structType = new $03ccd63b0299d6a7$var$StructType(name, membersLayout);
            this.structs[shaderStage].push(structType);
            this.types[shaderStage][name] = node;
            nodeData.structType = structType;
        }
        return structType;
    }
    /**
	 * Returns an instance of {@link StructType} for the given output struct node.
	 *
	 * @param {OutputStructNode} node - The output struct node.
	 * @param {Array<Object>} membersLayout - The output struct types.
	 * @return {StructType} The struct type attribute.
	 */ getOutputStructTypeFromNode(node, membersLayout) {
        const structType = this.getStructTypeFromNode(node, membersLayout, 'OutputType', 'fragment');
        structType.output = true;
        return structType;
    }
    /**
	 * Returns an instance of {@link NodeUniform} for the given uniform node.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The uniform type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {?string} name - The name of the uniform.
	 * @return {NodeUniform} The node uniform.
	 */ getUniformFromNode(node, type, shaderStage = this.shaderStage, name = null) {
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let nodeUniform = nodeData.uniform;
        if (nodeUniform === undefined) {
            const index = this.uniforms.index++;
            nodeUniform = new $03ccd63b0299d6a7$export$68c170317a5fc074(name || 'nodeUniform' + index, type, node);
            this.uniforms[shaderStage].push(nodeUniform);
            this.registerDeclaration(nodeUniform);
            nodeData.uniform = nodeUniform;
        }
        return nodeUniform;
    }
    /**
	 * Returns an instance of {@link NodeVar} for the given variable node.
	 *
	 * @param {VarNode} node - The variable node.
	 * @param {?string} name - The variable's name.
	 * @param {string} [type=node.getNodeType( this )] - The variable's type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @param {boolean} [readOnly=false] - Whether the variable is read-only or not.
	 *
	 * @return {NodeVar} The node variable.
	 */ getVarFromNode(node, name = null, type = node.getNodeType(this), shaderStage = this.shaderStage, readOnly = false) {
        const nodeData = this.getDataFromNode(node, shaderStage);
        const subBuildVariable = this.getSubBuildProperty('variable', nodeData.subBuilds);
        let nodeVar = nodeData[subBuildVariable];
        if (nodeVar === undefined) {
            const idNS = readOnly ? '_const' : '_var';
            const vars = this.vars[shaderStage] || (this.vars[shaderStage] = []);
            const id = this.vars[idNS] || (this.vars[idNS] = 0);
            if (name === null) {
                name = (readOnly ? 'nodeConst' : 'nodeVar') + id;
                this.vars[idNS]++;
            }
            //
            if (subBuildVariable !== 'variable') name = this.getSubBuildProperty(name, nodeData.subBuilds);
            //
            const count = node.getArrayCount(this);
            nodeVar = new $03ccd63b0299d6a7$export$b6d311b93c4db99a(name, type, readOnly, count);
            if (!readOnly) vars.push(nodeVar);
            this.registerDeclaration(nodeVar);
            nodeData[subBuildVariable] = nodeVar;
        }
        return nodeVar;
    }
    /**
	 * Returns whether a Node or its flow is deterministic, useful for use in `const`.
	 *
	 * @param {Node} node - The varying node.
	 * @return {boolean} Returns true if deterministic.
	 */ isDeterministic(node) {
        if (node.isMathNode) return this.isDeterministic(node.aNode) && (node.bNode ? this.isDeterministic(node.bNode) : true) && (node.cNode ? this.isDeterministic(node.cNode) : true);
        else if (node.isOperatorNode) return this.isDeterministic(node.aNode) && (node.bNode ? this.isDeterministic(node.bNode) : true);
        else if (node.isArrayNode) {
            if (node.values !== null) for (const n of node.values){
                if (!this.isDeterministic(n)) return false;
            }
            return true;
        } else if (node.isConstNode) return true;
        return false;
    }
    /**
	 * Returns an instance of {@link NodeVarying} for the given varying node.
	 *
	 * @param {(VaryingNode|PropertyNode)} node - The varying node.
	 * @param {?string} name - The varying's name.
	 * @param {string} [type=node.getNodeType( this )] - The varying's type.
	 * @param {?string} interpolationType - The interpolation type of the varying.
	 * @param {?string} interpolationSampling - The interpolation sampling type of the varying.
	 * @return {NodeVar} The node varying.
	 */ getVaryingFromNode(node, name = null, type = node.getNodeType(this), interpolationType = null, interpolationSampling = null) {
        const nodeData = this.getDataFromNode(node, 'any');
        const subBuildVarying = this.getSubBuildProperty('varying', nodeData.subBuilds);
        let nodeVarying = nodeData[subBuildVarying];
        if (nodeVarying === undefined) {
            const varyings = this.varyings;
            const index = varyings.length;
            if (name === null) name = 'nodeVarying' + index;
            //
            if (subBuildVarying !== 'varying') name = this.getSubBuildProperty(name, nodeData.subBuilds);
            //
            nodeVarying = new $03ccd63b0299d6a7$export$486c6ccd7c84a9e3(name, type, interpolationType, interpolationSampling);
            varyings.push(nodeVarying);
            this.registerDeclaration(nodeVarying);
            nodeData[subBuildVarying] = nodeVarying;
        }
        return nodeVarying;
    }
    /**
	 * Registers a node declaration in the current shader stage.
	 *
	 * @param {Object} node - The node to be registered.
	 */ registerDeclaration(node) {
        const shaderStage = this.shaderStage;
        const declarations = this.declarations[shaderStage] || (this.declarations[shaderStage] = {});
        const property = this.getPropertyName(node);
        let index = 1;
        let name = property;
        // Automatically renames the property if the name is already in use.
        while(declarations[name] !== undefined)name = property + '_' + index++;
        if (index > 1) {
            node.name = name;
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`TSL: Declaration name '${property}' of '${node.type}' already in use. Renamed to '${name}'.`);
        }
        declarations[name] = node;
    }
    /**
	 * Returns an instance of {@link NodeCode} for the given code node.
	 *
	 * @param {CodeNode} node - The code node.
	 * @param {string} type - The node type.
	 * @param {('vertex'|'fragment'|'compute'|'any')} [shaderStage=this.shaderStage] - The shader stage.
	 * @return {NodeCode} The node code.
	 */ getCodeFromNode(node, type, shaderStage = this.shaderStage) {
        const nodeData = this.getDataFromNode(node);
        let nodeCode = nodeData.code;
        if (nodeCode === undefined) {
            const codes = this.codes[shaderStage] || (this.codes[shaderStage] = []);
            const index = codes.length;
            nodeCode = new $03ccd63b0299d6a7$export$46b16f31af73381b('nodeCode' + index, type);
            codes.push(nodeCode);
            nodeData.code = nodeCode;
        }
        return nodeCode;
    }
    /**
	 * Adds a code flow based on the code-block hierarchy.

	 * This is used so that code-blocks like If,Else create their variables locally if the Node
	 * is only used inside one of these conditionals in the current shader stage.
	 *
	 * @param {Node} node - The node to add.
	 * @param {Node} nodeBlock - Node-based code-block. Usually 'ConditionalNode'.
	 */ addFlowCodeHierarchy(node, nodeBlock) {
        const { flowCodes: flowCodes, flowCodeBlock: flowCodeBlock } = this.getDataFromNode(node);
        let needsFlowCode = true;
        let nodeBlockHierarchy = nodeBlock;
        while(nodeBlockHierarchy){
            if (flowCodeBlock.get(nodeBlockHierarchy) === true) {
                needsFlowCode = false;
                break;
            }
            nodeBlockHierarchy = this.getDataFromNode(nodeBlockHierarchy).parentNodeBlock;
        }
        if (needsFlowCode) for (const flowCode of flowCodes)this.addLineFlowCode(flowCode);
    }
    /**
	 * Add a inline-code to the current flow code-block.
	 *
	 * @param {Node} node - The node to add.
	 * @param {string} code - The code to add.
	 * @param {Node} nodeBlock - Current ConditionalNode
	 */ addLineFlowCodeBlock(node, code, nodeBlock) {
        const nodeData = this.getDataFromNode(node);
        const flowCodes = nodeData.flowCodes || (nodeData.flowCodes = []);
        const codeBlock = nodeData.flowCodeBlock || (nodeData.flowCodeBlock = new WeakMap());
        flowCodes.push(code);
        codeBlock.set(nodeBlock, true);
    }
    /**
	 * Add a inline-code to the current flow.
	 *
	 * @param {string} code - The code to add.
	 * @param {?Node} [node= null] - Optional Node, can help the system understand if the Node is part of a code-block.
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addLineFlowCode(code, node = null) {
        if (code === '') return this;
        if (node !== null && this.context.nodeBlock) this.addLineFlowCodeBlock(node, code, this.context.nodeBlock);
        code = this.tab + code;
        if (!/;\s*$/.test(code)) code = code + ';\n';
        this.flow.code += code;
        return this;
    }
    /**
	 * Adds a code to the current code flow.
	 *
	 * @param {string} code - Shader code.
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addFlowCode(code) {
        this.flow.code += code;
        return this;
    }
    /**
	 * Add tab in the code that will be generated so that other snippets respect the current tabulation.
	 * Typically used in codes with If,Else.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ addFlowTab() {
        this.tab += '\t';
        return this;
    }
    /**
	 * Removes a tab.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ removeFlowTab() {
        this.tab = this.tab.slice(0, -1);
        return this;
    }
    /**
	 * Gets the current flow data based on a Node.
	 *
	 * @param {Node} node - Node that the flow was started.
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {Object} The flow data.
	 */ getFlowData(node /*, shaderStage*/ ) {
        return this.flowsData.get(node);
    }
    /**
	 * Executes the node flow based on a root node to generate the final shader code.
	 *
	 * @param {Node} node - The node to execute.
	 * @return {Object} The code flow.
	 */ flowNode(node) {
        const output = node.getNodeType(this);
        const flowData = this.flowChildNode(node, output);
        this.flowsData.set(node, flowData);
        return flowData;
    }
    /**
	 * Includes a node in the current function node.
	 *
	 * @param {Node} node - The node to include.
	 * @returns {void}
	 */ addInclude(node) {
        if (this.currentFunctionNode !== null) this.currentFunctionNode.includes.push(node);
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 * It is a similar type of method like {@link NodeBuilder#getMethod}.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node to build the function node with.
	 * @return {FunctionNode} The build function node.
	 */ buildFunctionNode(shaderNode) {
        const fn = new $03ccd63b0299d6a7$export$f2972be796679c12();
        const previous = this.currentFunctionNode;
        this.currentFunctionNode = fn;
        fn.code = this.buildFunctionCode(shaderNode);
        this.currentFunctionNode = previous;
        return fn;
    }
    /**
	 * Generates a code flow based on a TSL function: Fn().
	 *
	 * @param {ShaderNodeInternal} shaderNode - A function code will be generated based on the input.
	 * @return {Object}
	 */ flowShaderNode(shaderNode) {
        const layout = shaderNode.layout;
        const inputs = {
            [Symbol.iterator] () {
                let index = 0;
                const values = Object.values(this);
                return {
                    next: ()=>({
                            value: values[index],
                            done: index++ >= values.length
                        })
                };
            }
        };
        for (const input of layout.inputs)inputs[input.name] = new $03ccd63b0299d6a7$export$4b5f01ba1aca62ad(input.type, input.name);
        //
        shaderNode.layout = null;
        const callNode = shaderNode.call(inputs);
        const flowData = this.flowStagesNode(callNode, layout.type);
        shaderNode.layout = layout;
        return flowData;
    }
    /**
	 * Executes the node in a specific build stage.
	 *
	 * This function can be used to arbitrarily execute the specified build stage
	 * outside of the standard build process. For instance, if a node's type depends
	 * on properties created by the 'setup' stage, then flowBuildStage(node, 'setup')
	 * can be used to execute the setup build stage and access its generated nodes
	 * before the standard build process begins.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {string} buildStage - The build stage to execute the node in.
	 * @param {?(Node|string)} [output=null] - Expected output type. For example 'vec3'.
	 * @return {?(Node|string)} The result of the node build.
	 */ flowBuildStage(node, buildStage, output = null) {
        const previousBuildStage = this.getBuildStage();
        this.setBuildStage(buildStage);
        const result = node.build(this, output);
        this.setBuildStage(previousBuildStage);
        return result;
    }
    /**
	 * Runs the node flow through all the steps of creation, 'setup', 'analyze', 'generate'.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @return {Object}
	 */ flowStagesNode(node, output = null) {
        const previousFlow = this.flow;
        const previousVars = this.vars;
        const previousDeclarations = this.declarations;
        const previousCache = this.cache;
        const previousBuildStage = this.buildStage;
        const previousStack = this.stack;
        const flow = {
            code: ''
        };
        this.flow = flow;
        this.vars = {};
        this.declarations = {};
        this.cache = new $03ccd63b0299d6a7$export$1d1d74a0a581fcfd();
        this.stack = $03ccd63b0299d6a7$var$stack();
        for (const buildStage of $03ccd63b0299d6a7$export$f2213ed98eb895d6){
            this.setBuildStage(buildStage);
            flow.result = node.build(this, output);
        }
        flow.vars = this.getVars(this.shaderStage);
        this.flow = previousFlow;
        this.vars = previousVars;
        this.declarations = previousDeclarations;
        this.cache = previousCache;
        this.stack = previousStack;
        this.setBuildStage(previousBuildStage);
        return flow;
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 * It is a similar type of method like {@link NodeBuilder#getMethod}.
	 *
	 * @abstract
	 * @param {string} op - The operator name to resolve.
	 * @return {?string} The resolved operator name.
	 */ getFunctionOperator() {
        return null;
    }
    /**
	 * Builds the given shader node.
	 *
	 * @abstract
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The function code.
	 */ buildFunctionCode() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Generates a code flow based on a child Node.
	 *
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @return {Object} The code flow.
	 */ flowChildNode(node, output = null) {
        const previousFlow = this.flow;
        const flow = {
            code: ''
        };
        this.flow = flow;
        flow.result = node.build(this, output);
        this.flow = previousFlow;
        return flow;
    }
    /**
	 * Executes a flow of code in a different stage.
	 *
	 * Some nodes like `varying()` have the ability to compute code in vertex-stage and
	 * return the value in fragment-stage even if it is being executed in an input fragment.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @param {Node} node - The node to execute.
	 * @param {?string} output - Expected output type. For example 'vec3'.
	 * @param {?string} propertyName - The property name to assign the result.
	 * @return {?(Object|Node)} The code flow or node.build() result.
	 */ flowNodeFromShaderStage(shaderStage, node, output = null, propertyName = null) {
        const previousTab = this.tab;
        const previousCache = this.cache;
        const previousShaderStage = this.shaderStage;
        const previousContext = this.context;
        this.setShaderStage(shaderStage);
        const context = {
            ...this.context
        };
        delete context.nodeBlock;
        this.cache = this.globalCache;
        this.tab = '\t';
        this.context = context;
        let result = null;
        if (this.buildStage === 'generate') {
            const flowData = this.flowChildNode(node, output);
            if (propertyName !== null) flowData.code += `${this.tab + propertyName} = ${flowData.result};\n`;
            this.flowCode[shaderStage] = this.flowCode[shaderStage] + flowData.code;
            result = flowData;
        } else result = node.build(this);
        this.setShaderStage(previousShaderStage);
        this.cache = previousCache;
        this.tab = previousTab;
        this.context = previousContext;
        return result;
    }
    /**
	 * Returns an array holding all node attributes of this node builder.
	 *
	 * @return {Array<NodeAttribute>} The node attributes of this builder.
	 */ getAttributesArray() {
        return this.attributes.concat(this.bufferAttributes);
    }
    /**
	 * Returns the attribute definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The attribute code section.
	 */ getAttributes() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the varying definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The varying code section.
	 */ getVaryings() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns a single variable definition as a shader string for the given variable type and name.
	 *
	 * @param {string} type - The variable's type.
	 * @param {string} name - The variable's name.
	 * @param {?number} [count=null] - The array length.
	 * @return {string} The shader string.
	 */ getVar(type, name, count = null) {
        return `${count !== null ? this.generateArrayDeclaration(type, count) : this.getType(type)} ${name}`;
    }
    /**
	 * Returns the variable definitions as a shader string for the given shader stage.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @param {boolean} [global=false] - Whether the variables are global.
	 * @return {string} The variable code section.
	 */ getVars(shaderStage, global = false) {
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`${this.getVar(variable.type, variable.name, variable.count)};`);
        return snippets.join(global ? '\n' : '\n\t');
    }
    /**
	 * Returns the uniform definitions as a shader string for the given shader stage.
	 *
	 * @abstract
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The uniform code section.
	 */ getUniforms() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the native code definitions as a shader string for the given shader stage.
	 *
	 * @param {('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage.
	 * @return {string} The native code section.
	 */ getCodes(shaderStage) {
        const codes = this.codes[shaderStage];
        let code = '';
        if (codes !== undefined) for (const nodeCode of codes)code += nodeCode.code + '\n';
        return code;
    }
    /**
	 * Returns the hash of this node builder.
	 *
	 * @return {string} The hash.
	 */ getHash() {
        return this.vertexShader + this.fragmentShader + this.computeShader;
    }
    /**
	 * Sets the current shader stage.
	 *
	 * @param {?('vertex'|'fragment'|'compute'|'any')} shaderStage - The shader stage to set.
	 */ setShaderStage(shaderStage) {
        this.shaderStage = shaderStage;
    }
    /**
	 * Returns the current shader stage.
	 *
	 * @return {?('vertex'|'fragment'|'compute'|'any')} The current shader stage.
	 */ getShaderStage() {
        return this.shaderStage;
    }
    /**
	 * Sets the current build stage.
	 *
	 * @param {?('setup'|'analyze'|'generate')} buildStage - The build stage to set.
	 */ setBuildStage(buildStage) {
        this.buildStage = buildStage;
    }
    /**
	 * Returns the current build stage.
	 *
	 * @return {?('setup'|'analyze'|'generate')} The current build stage.
	 */ getBuildStage() {
        return this.buildStage;
    }
    /**
	 * Controls the code build of the shader stages.
	 *
	 * @abstract
	 */ buildCode() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
    /**
	 * Returns the current sub-build layer.
	 *
	 * @return {SubBuildNode} The current sub-build layers.
	 */ get subBuild() {
        return this.subBuildLayers[this.subBuildLayers.length - 1] || null;
    }
    /**
	 * Adds a sub-build layer to the node builder.
	 *
	 * @param {SubBuildNode} subBuild - The sub-build layer to add.
	 */ addSubBuild(subBuild) {
        this.subBuildLayers.push(subBuild);
    }
    /**
	 * Removes the last sub-build layer from the node builder.
	 *
	 * @return {SubBuildNode} The removed sub-build layer.
	 */ removeSubBuild() {
        return this.subBuildLayers.pop();
    }
    /**
	 * Returns the closest sub-build layer for the given data.
	 *
	 * @param {Node|Set<string>|Array<string>} data - The data to get the closest sub-build layer from.
	 * @return {?string} The closest sub-build name or null if none found.
	 */ getClosestSubBuild(data) {
        let subBuilds;
        if (data && data.isNode) {
            if (data.isShaderCallNodeInternal) subBuilds = data.shaderNode.subBuilds;
            else if (data.isStackNode) subBuilds = [
                data.subBuild
            ];
            else subBuilds = this.getDataFromNode(data, 'any').subBuilds;
        } else if (data instanceof Set) subBuilds = [
            ...data
        ];
        else subBuilds = data;
        if (!subBuilds) return null;
        const subBuildLayers = this.subBuildLayers;
        for(let i = subBuilds.length - 1; i >= 0; i--){
            const subBuild = subBuilds[i];
            if (subBuildLayers.includes(subBuild)) return subBuild;
        }
        return null;
    }
    /**
	 * Returns the output node of a sub-build layer.
	 *
	 * @param {Node} node - The node to get the output from.
	 * @return {string} The output node name.
	 */ getSubBuildOutput(node) {
        return this.getSubBuildProperty('outputNode', node);
    }
    /**
	 * Returns the sub-build property name for the given property and node.
	 *
	 * @param {string} [property=''] - The property name.
	 * @param {?Node} [node=null] - The node to get the sub-build from.
	 * @return {string} The sub-build property name.
	 */ getSubBuildProperty(property = '', node = null) {
        let subBuild;
        if (node !== null) subBuild = this.getClosestSubBuild(node);
        else subBuild = this.subBuildFn;
        let result;
        if (subBuild) result = property ? subBuild + '_' + property : subBuild;
        else result = property;
        return result;
    }
    /**
	 * Prebuild the node builder.
	 */ prebuild() {
        const { object: object, renderer: renderer, material: material } = this;
        // < renderer.contextNode >
        if (renderer.contextNode.isContextNode === true) this.context = {
            ...this.context,
            ...renderer.contextNode.getFlowContextData()
        };
        else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('NodeBuilder: "renderer.contextNode" must be an instance of `context()`.');
        // < material.contextNode >
        if (material && material.contextNode) {
            if (material.contextNode.isContextNode === true) this.context = {
                ...this.context,
                ...material.contextNode.getFlowContextData()
            };
            else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('NodeBuilder: "material.contextNode" must be an instance of `context()`.');
        }
        // < nodeMaterial >
        if (material !== null) {
            let nodeMaterial = renderer.library.fromMaterial(material);
            if (nodeMaterial === null) {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`NodeBuilder: Material "${material.type}" is not compatible.`);
                nodeMaterial = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
            }
            nodeMaterial.build(this);
        } else this.addFlow('compute', object);
    }
    /**
	 * Central build method which controls the build for the given object.
	 *
	 * @return {NodeBuilder} A reference to this node builder.
	 */ build() {
        this.prebuild();
        // setup() -> stage 1: create possible new nodes and/or return an output reference node
        // analyze()   -> stage 2: analyze nodes to possible optimization and validation
        // generate()  -> stage 3: generate shader
        for (const buildStage of $03ccd63b0299d6a7$export$f2213ed98eb895d6){
            this.setBuildStage(buildStage);
            if (this.context.position && this.context.position.isNode) this.flowNodeFromShaderStage('vertex', this.context.position);
            for (const shaderStage of $03ccd63b0299d6a7$export$48fd793f0255b86a){
                this.setShaderStage(shaderStage);
                const flowNodes = this.flowNodes[shaderStage];
                for (const node of flowNodes)if (buildStage === 'generate') this.flowNode(node);
                else node.build(this);
            }
        }
        this.setBuildStage(null);
        this.setShaderStage(null);
        // stage 4: build code for a specific output
        this.buildCode();
        this.buildUpdateNodes();
        return this;
    }
    /**
	 * Async version of build() that yields to main thread between shader stages.
	 * Use this in compileAsync() to prevent blocking the main thread.
	 *
	 * @return {Promise<NodeBuilder>} A promise that resolves to this node builder.
	 */ async buildAsync() {
        this.prebuild();
        // setup() -> stage 1: create possible new nodes and/or return an output reference node
        // analyze()   -> stage 2: analyze nodes to possible optimization and validation
        // generate()  -> stage 3: generate shader
        for (const buildStage of $03ccd63b0299d6a7$export$f2213ed98eb895d6){
            this.setBuildStage(buildStage);
            if (this.context.position && this.context.position.isNode) this.flowNodeFromShaderStage('vertex', this.context.position);
            for (const shaderStage of $03ccd63b0299d6a7$export$48fd793f0255b86a){
                this.setShaderStage(shaderStage);
                const flowNodes = this.flowNodes[shaderStage];
                for (const node of flowNodes)if (buildStage === 'generate') this.flowNode(node);
                else node.build(this);
                // Yield to main thread after each shader stage to prevent blocking
                await (0, $9ddd7e9b53f7a2d4$export$8af9927c09321dd4)();
            }
        }
        this.setBuildStage(null);
        this.setShaderStage(null);
        // stage 4: build code for a specific output
        this.buildCode();
        this.buildUpdateNodes();
        return this;
    }
    /**
	 * Returns shared data object for the given node.
	 *
	 * @param {Node} node - The node to get shared data from.
	 * @return {Object} The shared data.
	 */ getSharedDataFromNode(node) {
        let data = $03ccd63b0299d6a7$var$sharedNodeData.get(node);
        if (data === undefined) data = {};
        return data;
    }
    /**
	 * Returns a uniform representation which is later used for UBO generation and rendering.
	 *
	 * @param {NodeUniform} uniformNode - The uniform node.
	 * @param {string} type - The requested type.
	 * @return {Uniform} The uniform.
	 */ getNodeUniform(uniformNode, type) {
        const nodeData = this.getSharedDataFromNode(uniformNode);
        let node = nodeData.cache;
        if (node === undefined) {
            if (type === 'float' || type === 'int' || type === 'uint') node = new $03ccd63b0299d6a7$var$NumberNodeUniform(uniformNode);
            else if (type === 'vec2' || type === 'ivec2' || type === 'uvec2') node = new $03ccd63b0299d6a7$var$Vector2NodeUniform(uniformNode);
            else if (type === 'vec3' || type === 'ivec3' || type === 'uvec3') node = new $03ccd63b0299d6a7$var$Vector3NodeUniform(uniformNode);
            else if (type === 'vec4' || type === 'ivec4' || type === 'uvec4') node = new $03ccd63b0299d6a7$var$Vector4NodeUniform(uniformNode);
            else if (type === 'color') node = new $03ccd63b0299d6a7$var$ColorNodeUniform(uniformNode);
            else if (type === 'mat2') node = new $03ccd63b0299d6a7$var$Matrix2NodeUniform(uniformNode);
            else if (type === 'mat3') node = new $03ccd63b0299d6a7$var$Matrix3NodeUniform(uniformNode);
            else if (type === 'mat4') node = new $03ccd63b0299d6a7$var$Matrix4NodeUniform(uniformNode);
            else throw new Error(`Uniform "${type}" not implemented.`);
            nodeData.cache = node;
        }
        return node;
    }
    /**
	 * Formats the given shader snippet from a given type into another one. E.g.
	 * this method might be used to convert a simple float string `"1.0"` into a
	 * `vec3` representation: `"vec3<f32>( 1.0 )"`.
	 *
	 * @param {string} snippet - The shader snippet.
	 * @param {string} fromType - The source type.
	 * @param {string} toType - The target type.
	 * @return {string} The updated shader string.
	 */ format(snippet, fromType, toType) {
        fromType = this.getVectorType(fromType);
        toType = this.getVectorType(toType);
        if (fromType === toType || toType === null || this.isReference(toType)) return snippet;
        const fromTypeLength = this.getTypeLength(fromType);
        const toTypeLength = this.getTypeLength(toType);
        if (fromTypeLength === 16 && toTypeLength === 9) return `${this.getType(toType)}( ${snippet}[ 0 ].xyz, ${snippet}[ 1 ].xyz, ${snippet}[ 2 ].xyz )`;
        if (fromTypeLength === 9 && toTypeLength === 4) return `${this.getType(toType)}( ${snippet}[ 0 ].xy, ${snippet}[ 1 ].xy )`;
        if (fromTypeLength > 4) // @TODO: ignore for now
        return snippet;
        if (toTypeLength > 4 || toTypeLength === 0) // @TODO: ignore for now
        return snippet;
        if (fromTypeLength === toTypeLength) return `${this.getType(toType)}( ${snippet} )`;
        if (fromTypeLength > toTypeLength) {
            snippet = toType === 'bool' ? `all( ${snippet} )` : `${snippet}.${'xyz'.slice(0, toTypeLength)}`;
            return this.format(snippet, this.getTypeFromLength(toTypeLength, this.getComponentType(fromType)), toType);
        }
        if (toTypeLength === 4 && fromTypeLength > 1) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec3')}, 1.0 )`;
        if (fromTypeLength === 2) return `${this.getType(toType)}( ${this.format(snippet, fromType, 'vec2')}, 0.0 )`;
        if (fromTypeLength === 1 && toTypeLength > 1 && fromType !== this.getComponentType(toType)) // convert a number value to vector type, e.g:
        // vec3( 1u ) -> vec3( float( 1u ) )
        snippet = `${this.getType(this.getComponentType(toType))}( ${snippet} )`;
        return `${this.getType(toType)}( ${snippet} )`; // fromType is float-like
    }
    /**
	 * Returns a signature with the engine's current revision.
	 *
	 * @return {string} The signature.
	 */ getSignature() {
        return `// Three.js r${0, $9ddd7e9b53f7a2d4$export$3545e07a80636437} - Node System\n`;
    }
    /**
	 * Returns `true` if data from the previous frame are required. Relevant
	 * when computing motion vectors with {@link VelocityNode}.
	 *
	 * @return {boolean} Whether data from the previous frame are required or not.
	 */ needsPreviousData() {
        const mrt = this.renderer.getMRT();
        return mrt && mrt.has('velocity') || $03ccd63b0299d6a7$var$getDataFromObject(this.object).useVelocity === true;
    }
}
/**
 * Management class for updating nodes. The module tracks metrics like
 * the elapsed time, delta time, the render and frame ID to correctly
 * call the node update methods {@link Node#updateBefore}, {@link Node#update}
 * and {@link Node#updateAfter} depending on the node's configuration.
 */ class $03ccd63b0299d6a7$export$20d1e096ab9d190e {
    /**
	 * Constructs a new node fame.
	 */ constructor(){
        /**
		 * The elapsed time in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * The delta time in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.deltaTime = 0;
        /**
		 * The frame ID.
		 *
		 * @type {number}
		 * @default 0
		 */ this.frameId = 0;
        /**
		 * The render ID.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderId = 0;
        /**
		 * Used to control the {@link Node#update} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateMap = new WeakMap();
        /**
		 * Used to control the {@link Node#updateBefore} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateBeforeMap = new WeakMap();
        /**
		 * Used to control the {@link Node#updateAfter} call.
		 *
		 * @type {WeakMap<Node, Object>}
		 */ this.updateAfterMap = new WeakMap();
        /**
		 * A reference to the current renderer.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = null;
        /**
		 * A reference to the current material.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.material = null;
        /**
		 * A reference to the current camera.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * A reference to the current 3D object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.object = null;
        /**
		 * A reference to the current scene.
		 *
		 * @type {?Scene}
		 * @default null
		 */ this.scene = null;
    }
    /**
	 * Returns a dictionary for a given node and update map which
	 * is used to correctly call node update methods per frame or render.
	 *
	 * @private
	 * @param {WeakMap<Node, Object>} referenceMap - The reference weak map.
	 * @param {Node} nodeRef - The reference to the current node.
	 * @return {Object<string,WeakMap<Object, number>>} The dictionary.
	 */ _getMaps(referenceMap, nodeRef) {
        let maps = referenceMap.get(nodeRef);
        if (maps === undefined) {
            maps = {
                renderId: 0,
                frameId: 0
            };
            referenceMap.set(nodeRef, maps);
        }
        return maps;
    }
    /**
	 * This method executes the {@link Node#updateBefore} for the given node.
	 * It makes sure {@link Node#updateBeforeType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateBeforeNode(node) {
        const updateType = node.getUpdateBeforeType();
        const reference = node.updateReference(this);
        if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateBeforeMap = this._getMaps(this.updateBeforeMap, reference);
            if (nodeUpdateBeforeMap.frameId !== this.frameId) {
                const previousFrameId = nodeUpdateBeforeMap.frameId;
                nodeUpdateBeforeMap.frameId = this.frameId;
                if (node.updateBefore(this) === false) nodeUpdateBeforeMap.frameId = previousFrameId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateBeforeMap = this._getMaps(this.updateBeforeMap, reference);
            if (nodeUpdateBeforeMap.renderId !== this.renderId) {
                const previousRenderId = nodeUpdateBeforeMap.renderId;
                nodeUpdateBeforeMap.renderId = this.renderId;
                if (node.updateBefore(this) === false) nodeUpdateBeforeMap.renderId = previousRenderId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT) node.updateBefore(this);
    }
    /**
	 * This method executes the {@link Node#updateAfter} for the given node.
	 * It makes sure {@link Node#updateAfterType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateAfterNode(node) {
        const updateType = node.getUpdateAfterType();
        const reference = node.updateReference(this);
        if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateAfterMap = this._getMaps(this.updateAfterMap, reference);
            if (nodeUpdateAfterMap.frameId !== this.frameId) {
                if (node.updateAfter(this) !== false) nodeUpdateAfterMap.frameId = this.frameId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateAfterMap = this._getMaps(this.updateAfterMap, reference);
            if (nodeUpdateAfterMap.renderId !== this.renderId) {
                if (node.updateAfter(this) !== false) nodeUpdateAfterMap.renderId = this.renderId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT) node.updateAfter(this);
    }
    /**
	 * This method executes the {@link Node#update} for the given node.
	 * It makes sure {@link Node#updateType} is honored meaning the update
	 * is only executed once per frame, render or object depending on the update
	 * type.
	 *
	 * @param {Node} node - The node that should be updated.
	 */ updateNode(node) {
        const updateType = node.getUpdateType();
        const reference = node.updateReference(this);
        if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.FRAME) {
            const nodeUpdateMap = this._getMaps(this.updateMap, reference);
            if (nodeUpdateMap.frameId !== this.frameId) {
                if (node.update(this) !== false) nodeUpdateMap.frameId = this.frameId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER) {
            const nodeUpdateMap = this._getMaps(this.updateMap, reference);
            if (nodeUpdateMap.renderId !== this.renderId) {
                if (node.update(this) !== false) nodeUpdateMap.renderId = this.renderId;
            }
        } else if (updateType === $03ccd63b0299d6a7$export$26f7a8bbd9469530.OBJECT) node.update(this);
    }
    /**
	 * Updates the internal state of the node frame. This method is
	 * called by the renderer in its internal animation loop.
	 */ update() {
        this.frameId++;
        if (this.lastTime === undefined) this.lastTime = performance.now();
        this.deltaTime = (performance.now() - this.lastTime) / 1000;
        this.lastTime = performance.now();
        this.time += this.deltaTime;
    }
}
/**
 * Describes the input of a {@link NodeFunction}.
 */ class $03ccd63b0299d6a7$export$9909d560ff36ee5e {
    /**
	 * Constructs a new node function input.
	 *
	 * @param {string} type - The input type.
	 * @param {string} name - The input name.
	 * @param {?number} [count=null] - If the input is an Array, count will be the length.
	 * @param {('in'|'out'|'inout')} [qualifier=''] - The parameter qualifier (only relevant for GLSL).
	 * @param {boolean} [isConst=false] - Whether the input uses a const qualifier or not (only relevant for GLSL).
	 */ constructor(type, name, count = null, qualifier = '', isConst = false){
        /**
		 *  The input type.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The input name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * If the input is an Array, count will be the length.
		 *
		 * @type {?number}
		 * @default null
		 */ this.count = count;
        /**
		 *The parameter qualifier (only relevant for GLSL).
		 *
		 * @type {('in'|'out'|'inout')}
		 * @default ''
		 */ this.qualifier = qualifier;
        /**
		 * Whether the input uses a const qualifier or not (only relevant for GLSL).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isConst = isConst;
    }
}
$03ccd63b0299d6a7$export$9909d560ff36ee5e.isNodeFunctionInput = true;
/**
 * Module for representing ambient lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$ade3bbc96c5c4bf1 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'AmbientLightNode';
    }
    /**
	 * Constructs a new ambient light node.
	 *
	 * @param {?AmbientLight} [light=null] - The ambient light source.
	 */ constructor(light = null){
        super(light);
    }
    setup({ context: context }) {
        context.irradiance.addAssign(this.colorNode);
    }
}
/**
 * Module for representing directional lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$6e67a8efcfed4d14 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'DirectionalLightNode';
    }
    /**
	 * Constructs a new directional light node.
	 *
	 * @param {?DirectionalLight} [light=null] - The directional light source.
	 */ constructor(light = null){
        super(light);
    }
    setupDirect() {
        const lightColor = this.colorNode;
        const lightDirection = $03ccd63b0299d6a7$var$lightTargetDirection(this.light);
        return {
            lightDirection: lightDirection,
            lightColor: lightColor
        };
    }
}
/**
 * Module for representing hemisphere lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$8c237e4e9b54f548 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'HemisphereLightNode';
    }
    /**
	 * Constructs a new hemisphere light node.
	 *
	 * @param {?HemisphereLight} [light=null] - The hemisphere light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the light's position.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.lightPositionNode = $03ccd63b0299d6a7$var$lightPosition(light);
        /**
		 * A node representing the light's direction.
		 *
		 * @type {Node<vec3>}
		 */ this.lightDirectionNode = this.lightPositionNode.normalize();
        /**
		 * Uniform node representing the light's ground color.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.groundColorNode = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)()).setGroup($03ccd63b0299d6a7$var$renderGroup);
    }
    /**
	 * Overwritten to updated hemisphere light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        this.lightPositionNode.object3d = light;
        this.groundColorNode.value.copy(light.groundColor).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const { colorNode: colorNode, groundColorNode: groundColorNode, lightDirectionNode: lightDirectionNode } = this;
        const dotNL = $03ccd63b0299d6a7$var$normalWorld.dot(lightDirectionNode);
        const hemiDiffuseWeight = dotNL.mul(0.5).add(0.5);
        const irradiance = $03ccd63b0299d6a7$var$mix(groundColorNode, colorNode, hemiDiffuseWeight);
        builder.context.irradiance.addAssign(irradiance);
    }
}
/**
 * Module for representing spot lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$df1aa5fd66541854 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'SpotLightNode';
    }
    /**
	 * Constructs a new spot light node.
	 *
	 * @param {?SpotLight} [light=null] - The spot light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the cone cosine.
		 *
		 * @type {UniformNode<float>}
		 */ this.coneCosNode = $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the penumbra cosine.
		 *
		 * @type {UniformNode<float>}
		 */ this.penumbraCosNode = $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the cutoff distance.
		 *
		 * @type {UniformNode<float>}
		 */ this.cutoffDistanceNode = $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the decay exponent.
		 *
		 * @type {UniformNode<float>}
		 */ this.decayExponentNode = $03ccd63b0299d6a7$var$uniform(0).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the light color.
		 *
		 * @type {UniformNode<Color>}
		 */ this.colorNode = $03ccd63b0299d6a7$var$uniform(this.color).setGroup($03ccd63b0299d6a7$var$renderGroup);
    }
    /**
	 * Overwritten to updated spot light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        super.update(frame);
        const { light: light } = this;
        this.coneCosNode.value = Math.cos(light.angle);
        this.penumbraCosNode.value = Math.cos(light.angle * (1 - light.penumbra));
        this.cutoffDistanceNode.value = light.distance;
        this.decayExponentNode.value = light.decay;
    }
    /**
	 * Computes the spot attenuation for the given angle.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder, angleCosine) {
        const { coneCosNode: coneCosNode, penumbraCosNode: penumbraCosNode } = this;
        return $03ccd63b0299d6a7$var$smoothstep(coneCosNode, penumbraCosNode, angleCosine);
    }
    getLightCoord(builder) {
        const properties = builder.getNodeProperties(this);
        let projectionUV = properties.projectionUV;
        if (projectionUV === undefined) {
            projectionUV = $03ccd63b0299d6a7$var$lightProjectionUV(this.light, builder.context.positionWorld);
            properties.projectionUV = projectionUV;
        }
        return projectionUV;
    }
    setupDirect(builder) {
        const { colorNode: colorNode, cutoffDistanceNode: cutoffDistanceNode, decayExponentNode: decayExponentNode, light: light } = this;
        const lightVector = this.getLightVector(builder);
        const lightDirection = lightVector.normalize();
        const angleCos = lightDirection.dot($03ccd63b0299d6a7$var$lightTargetDirection(light));
        const spotAttenuation = this.getSpotAttenuation(builder, angleCos);
        const lightDistance = lightVector.length();
        const lightAttenuation = $03ccd63b0299d6a7$var$getDistanceAttenuation({
            lightDistance: lightDistance,
            cutoffDistance: cutoffDistanceNode,
            decayExponent: decayExponentNode
        });
        let lightColor = colorNode.mul(spotAttenuation).mul(lightAttenuation);
        let projected, lightCoord;
        if (light.colorNode) {
            lightCoord = this.getLightCoord(builder);
            projected = light.colorNode(lightCoord);
        } else if (light.map) {
            lightCoord = this.getLightCoord(builder);
            projected = $03ccd63b0299d6a7$var$texture(light.map, lightCoord.xy).onRenderUpdate(()=>light.map);
        }
        if (projected) {
            const inSpotLightMap = lightCoord.mul(2.).sub(1.).abs().lessThan(1.).all();
            lightColor = inSpotLightMap.select(lightColor.mul(projected), lightColor);
        }
        return {
            lightColor: lightColor,
            lightDirection: lightDirection
        };
    }
}
/**
 * An IES version of the default spot light node.
 *
 * @augments SpotLightNode
 */ class $03ccd63b0299d6a7$export$5d7cdca61c24be58 extends $03ccd63b0299d6a7$export$df1aa5fd66541854 {
    static get type() {
        return 'IESSpotLightNode';
    }
    /**
	 * Overwrites the default implementation to compute an IES conform spot attenuation.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @param {Node<float>} angleCosine - The angle to compute the spot attenuation for.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder, angleCosine) {
        const iesMap = this.light.iesMap;
        let spotAttenuation = null;
        if (iesMap && iesMap.isTexture === true) {
            const angle = angleCosine.acos().mul(1.0 / Math.PI);
            spotAttenuation = $03ccd63b0299d6a7$var$texture(iesMap, $03ccd63b0299d6a7$var$vec2(angle, 0), 0).r;
        } else spotAttenuation = super.getSpotAttenuation(angleCosine);
        return spotAttenuation;
    }
}
/**
 * Module for representing light probes as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$c2c4ca9136f2b869 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'LightProbeNode';
    }
    /**
	 * Constructs a new light probe node.
	 *
	 * @param {?LightProbe} [light=null] - The light probe.
	 */ constructor(light = null){
        super(light);
        const array = [];
        for(let i = 0; i < 9; i++)array.push(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)());
        /**
		 * Light probe represented as a uniform of spherical harmonics.
		 *
		 * @type {UniformArrayNode}
		 */ this.lightProbe = $03ccd63b0299d6a7$var$uniformArray(array);
    }
    /**
	 * Overwritten to updated light probe specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        const { light: light } = this;
        super.update(frame);
        //
        for(let i = 0; i < 9; i++)this.lightProbe.array[i].copy(light.sh.coefficients[i]).multiplyScalar(light.intensity);
    }
    setup(builder) {
        const irradiance = $03ccd63b0299d6a7$var$getShIrradianceAt($03ccd63b0299d6a7$var$normalWorld, this.lightProbe);
        builder.context.irradiance.addAssign(irradiance);
    }
}
const $03ccd63b0299d6a7$var$sdBox = /*@__PURE__*/ $03ccd63b0299d6a7$var$Fn(([p, b])=>{
    const d = p.abs().sub(b);
    return $03ccd63b0299d6a7$var$length($03ccd63b0299d6a7$var$max$1(d, 0.0)).add($03ccd63b0299d6a7$var$min$1($03ccd63b0299d6a7$var$max$1(d.x, d.y), 0.0));
});
/**
 * An implementation of a projector light node.
 *
 * @augments SpotLightNode
 */ class $03ccd63b0299d6a7$export$e6df2aceb76fe9a0 extends $03ccd63b0299d6a7$export$df1aa5fd66541854 {
    static get type() {
        return 'ProjectorLightNode';
    }
    update(frame) {
        super.update(frame);
        const light = this.light;
        this.penumbraCosNode.value = Math.min(Math.cos(light.angle * (1 - light.penumbra)), .99999);
        if (light.aspect === null) {
            let aspect = 1;
            if (light.map !== null) aspect = light.map.width / light.map.height;
            light.shadow.aspect = aspect;
        } else light.shadow.aspect = light.aspect;
    }
    /**
	 * Overwrites the default implementation to compute projection attenuation.
	 *
	 * @param {NodeBuilder} builder - The node builder.
	 * @return {Node<float>} The spot attenuation.
	 */ getSpotAttenuation(builder) {
        const attenuation = $03ccd63b0299d6a7$var$float(0);
        const penumbraCos = this.penumbraCosNode;
        // compute the fragment's position in the light's clip space
        const spotLightCoord = $03ccd63b0299d6a7$var$lightShadowMatrix(this.light).mul(builder.context.positionWorld || $03ccd63b0299d6a7$var$positionWorld);
        // the sign of w determines whether the current fragment is in front or behind the light.
        // to avoid a back-projection, it's important to only compute an attenuation if w is positive
        $03ccd63b0299d6a7$var$If(spotLightCoord.w.greaterThan(0), ()=>{
            const projectionUV = spotLightCoord.xyz.div(spotLightCoord.w);
            const boxDist = $03ccd63b0299d6a7$var$sdBox(projectionUV.xy.sub($03ccd63b0299d6a7$var$vec2(0.5)), $03ccd63b0299d6a7$var$vec2(0.5));
            const angleFactor = $03ccd63b0299d6a7$var$div(-1, $03ccd63b0299d6a7$var$sub(1.0, $03ccd63b0299d6a7$var$acos(penumbraCos)).sub(1.0));
            attenuation.assign($03ccd63b0299d6a7$var$saturate(boxDist.mul(-2).mul(angleFactor)));
        });
        return attenuation;
    }
}
const $03ccd63b0299d6a7$var$_matrix41 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $03ccd63b0299d6a7$var$_matrix42 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
let $03ccd63b0299d6a7$var$_ltcLib = null;
/**
 * Module for representing rect area lights as nodes.
 *
 * @augments AnalyticLightNode
 */ class $03ccd63b0299d6a7$export$1029ea47a4dd9399 extends $03ccd63b0299d6a7$export$126552cbaf08eb8 {
    static get type() {
        return 'RectAreaLightNode';
    }
    /**
	 * Constructs a new rect area light node.
	 *
	 * @param {?RectAreaLight} [light=null] - The rect area light source.
	 */ constructor(light = null){
        super(light);
        /**
		 * Uniform node representing the half height of the are light.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.halfHeight = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * Uniform node representing the half width of the are light.
		 *
		 * @type {UniformNode<vec3>}
		 */ this.halfWidth = $03ccd63b0299d6a7$var$uniform(new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)()).setGroup($03ccd63b0299d6a7$var$renderGroup);
        /**
		 * The `updateType` is set to `NodeUpdateType.RENDER` since the light
		 * relies on `viewMatrix` which might vary per render call.
		 *
		 * @type {string}
		 * @default 'render'
		 */ this.updateType = $03ccd63b0299d6a7$export$26f7a8bbd9469530.RENDER;
    }
    /**
	 * Overwritten to updated rect area light specific uniforms.
	 *
	 * @param {NodeFrame} frame - A reference to the current node frame.
	 */ update(frame) {
        super.update(frame);
        const { light: light } = this;
        const viewMatrix = frame.camera.matrixWorldInverse;
        $03ccd63b0299d6a7$var$_matrix42.identity();
        $03ccd63b0299d6a7$var$_matrix41.copy(light.matrixWorld);
        $03ccd63b0299d6a7$var$_matrix41.premultiply(viewMatrix);
        $03ccd63b0299d6a7$var$_matrix42.extractRotation($03ccd63b0299d6a7$var$_matrix41);
        this.halfWidth.value.set(light.width * 0.5, 0.0, 0.0);
        this.halfHeight.value.set(0.0, light.height * 0.5, 0.0);
        this.halfWidth.value.applyMatrix4($03ccd63b0299d6a7$var$_matrix42);
        this.halfHeight.value.applyMatrix4($03ccd63b0299d6a7$var$_matrix42);
    }
    setupDirectRectArea(builder) {
        let ltc_1, ltc_2;
        if (builder.isAvailable('float32Filterable')) {
            ltc_1 = $03ccd63b0299d6a7$var$texture($03ccd63b0299d6a7$var$_ltcLib.LTC_FLOAT_1);
            ltc_2 = $03ccd63b0299d6a7$var$texture($03ccd63b0299d6a7$var$_ltcLib.LTC_FLOAT_2);
        } else {
            ltc_1 = $03ccd63b0299d6a7$var$texture($03ccd63b0299d6a7$var$_ltcLib.LTC_HALF_1);
            ltc_2 = $03ccd63b0299d6a7$var$texture($03ccd63b0299d6a7$var$_ltcLib.LTC_HALF_2);
        }
        const { colorNode: colorNode, light: light } = this;
        const lightPosition = $03ccd63b0299d6a7$var$lightViewPosition(light);
        return {
            lightColor: colorNode,
            lightPosition: lightPosition,
            halfWidth: this.halfWidth,
            halfHeight: this.halfHeight,
            ltc_1: ltc_1,
            ltc_2: ltc_2
        };
    }
    /**
	 * Used to configure the internal BRDF approximation texture data.
	 *
	 * @param {RectAreaLightTexturesLib} ltc - The BRDF approximation texture data.
	 */ static setLTC(ltc) {
        $03ccd63b0299d6a7$var$_ltcLib = ltc;
    }
}
/**
 * Base class for node parsers. A derived parser must be implemented
 * for each supported native shader language.
 */ class $03ccd63b0299d6a7$var$NodeParser {
    /**
	 * The method parses the given native code an returns a node function.
	 *
	 * @abstract
	 * @param {string} source - The native shader code.
	 * @return {NodeFunction} A node function.
	 */ parseFunction() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
}
/**
 * Base class for node functions. A derived module must be implemented
 * for each supported native shader language. Similar to other `Node*` modules,
 * this class is only relevant during the building process and not used
 * in user-level code.
 */ class $03ccd63b0299d6a7$var$NodeFunction {
    /**
	 * Constructs a new node function.
	 *
	 * @param {string} type - The node type. This type is the return type of the node function.
	 * @param {Array<NodeFunctionInput>} inputs - The function's inputs.
	 * @param {string} [name=''] - The function's name.
	 * @param {string} [precision=''] - The precision qualifier.
	 */ constructor(type, inputs, name = '', precision = ''){
        /**
		 * The node type. This type is the return type of the node function.
		 *
		 * @type {string}
		 */ this.type = type;
        /**
		 * The function's inputs.
		 *
		 * @type {Array<NodeFunctionInput>}
		 */ this.inputs = inputs;
        /**
		 * The name of the uniform.
		 *
		 * @type {string}
		 * @default ''
		 */ this.name = name;
        /**
		 * The precision qualifier.
		 *
		 * @type {string}
		 * @default ''
		 */ this.precision = precision;
    }
    /**
	 * This method returns the native code of the node function.
	 *
	 * @abstract
	 * @param {string} name - The function's name.
	 * @return {string} A shader code.
	 */ getCode() {
        (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Abstract function.');
    }
}
$03ccd63b0299d6a7$var$NodeFunction.isNodeFunction = true;
const $03ccd63b0299d6a7$var$declarationRegexp$1 = /^\s*(highp|mediump|lowp)?\s*([a-z_0-9]+)\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)/i;
const $03ccd63b0299d6a7$var$propertiesRegexp$1 = /[a-z_0-9]+/ig;
const $03ccd63b0299d6a7$var$pragmaMain = '#pragma main';
const $03ccd63b0299d6a7$var$parse$1 = (source)=>{
    source = source.trim();
    const pragmaMainIndex = source.indexOf($03ccd63b0299d6a7$var$pragmaMain);
    const mainCode = pragmaMainIndex !== -1 ? source.slice(pragmaMainIndex + $03ccd63b0299d6a7$var$pragmaMain.length) : source;
    const declaration = mainCode.match($03ccd63b0299d6a7$var$declarationRegexp$1);
    if (declaration !== null && declaration.length === 5) {
        // tokenizer
        const inputsCode = declaration[4];
        const propsMatches = [];
        let nameMatch = null;
        while((nameMatch = $03ccd63b0299d6a7$var$propertiesRegexp$1.exec(inputsCode)) !== null)propsMatches.push(nameMatch);
        // parser
        const inputs = [];
        let i = 0;
        while(i < propsMatches.length){
            const isConst = propsMatches[i][0] === 'const';
            if (isConst === true) i++;
            let qualifier = propsMatches[i][0];
            if (qualifier === 'in' || qualifier === 'out' || qualifier === 'inout') i++;
            else qualifier = '';
            const type = propsMatches[i++][0];
            let count = Number.parseInt(propsMatches[i][0]);
            if (Number.isNaN(count) === false) i++;
            else count = null;
            const name = propsMatches[i++][0];
            inputs.push(new $03ccd63b0299d6a7$export$9909d560ff36ee5e(type, name, count, qualifier, isConst));
        }
        //
        const blockCode = mainCode.substring(declaration[0].length);
        const name = declaration[3] !== undefined ? declaration[3] : '';
        const type = declaration[2];
        const precision = declaration[1] !== undefined ? declaration[1] : '';
        const headerCode = pragmaMainIndex !== -1 ? source.slice(0, pragmaMainIndex) : '';
        return {
            type: type,
            inputs: inputs,
            name: name,
            precision: precision,
            inputsCode: inputsCode,
            blockCode: blockCode,
            headerCode: headerCode
        };
    } else throw new Error('FunctionNode: Function is not a GLSL code.');
};
/**
 * This class represents a GLSL node function.
 *
 * @augments NodeFunction
 */ class $03ccd63b0299d6a7$var$GLSLNodeFunction extends $03ccd63b0299d6a7$var$NodeFunction {
    /**
	 * Constructs a new GLSL node function.
	 *
	 * @param {string} source - The GLSL source.
	 */ constructor(source){
        const { type: type, inputs: inputs, name: name, precision: precision, inputsCode: inputsCode, blockCode: blockCode, headerCode: headerCode } = $03ccd63b0299d6a7$var$parse$1(source);
        super(type, inputs, name, precision);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.headerCode = headerCode;
    }
    /**
	 * This method returns the GLSL code of the node function.
	 *
	 * @param {string} [name=this.name] - The function's name.
	 * @return {string} The shader code.
	 */ getCode(name = this.name) {
        let code;
        const blockCode = this.blockCode;
        if (blockCode !== '') {
            const { type: type, inputsCode: inputsCode, headerCode: headerCode, precision: precision } = this;
            let declarationCode = `${type} ${name} ( ${inputsCode.trim()} )`;
            if (precision !== '') declarationCode = `${precision} ${declarationCode}`;
            code = headerCode + declarationCode + blockCode;
        } else // interface function
        code = '';
        return code;
    }
}
/**
 * A GLSL node parser.
 *
 * @augments NodeParser
 */ class $03ccd63b0299d6a7$export$18a74e8f50eca178 extends $03ccd63b0299d6a7$var$NodeParser {
    /**
	 * The method parses the given GLSL code an returns a node function.
	 *
	 * @param {string} source - The GLSL code.
	 * @return {GLSLNodeFunction} A node function.
	 */ parseFunction(source) {
        return new $03ccd63b0299d6a7$var$GLSLNodeFunction(source);
    }
}
const $03ccd63b0299d6a7$var$_chainKeys$1 = [];
const $03ccd63b0299d6a7$var$_cacheKeyValues = [];
/**
 * This renderer module manages node-related objects and is the
 * primary interface between the renderer and the node system.
 *
 * @private
 * @augments DataMap
 */ class $03ccd63b0299d6a7$var$NodeManager extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new nodes management component.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {Backend} backend - The renderer's backend.
	 */ constructor(renderer, backend){
        super();
        /**
		 * The renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * The renderer's backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * The node frame.
		 *
		 * @type {Renderer}
		 */ this.nodeFrame = new $03ccd63b0299d6a7$export$20d1e096ab9d190e();
        /**
		 * A cache for managing node builder states.
		 *
		 * @type {Map<number,NodeBuilderState>}
		 */ this.nodeBuilderCache = new Map();
        /**
		 * A cache for managing data cache key data.
		 *
		 * @type {ChainMap}
		 */ this.callHashCache = new $03ccd63b0299d6a7$var$ChainMap();
        /**
		 * A cache for managing node uniforms group data.
		 *
		 * @type {ChainMap}
		 */ this.groupsData = new $03ccd63b0299d6a7$var$ChainMap();
        /**
		 * Queue for pending async builds to limit concurrent compilation.
		 *
		 * @private
		 * @type {Array<Function>}
		 */ this._buildQueue = [];
        /**
		 * Whether an async build is currently in progress.
		 *
		 * @private
		 * @type {boolean}
		 */ this._buildInProgress = false;
        /**
		 * A cache for managing node objects of
		 * scene properties like fog or environments.
		 *
		 * @type {Object<string,WeakMap>}
		 */ this.cacheLib = {};
    }
    /**
	 * Returns `true` if the given node uniforms group must be updated or not.
	 *
	 * @param {NodeUniformsGroup} nodeUniformsGroup - The node uniforms group.
	 * @return {boolean} Whether the node uniforms group requires an update or not.
	 */ updateGroup(nodeUniformsGroup) {
        const groupNode = nodeUniformsGroup.groupNode;
        $03ccd63b0299d6a7$var$_chainKeys$1[0] = groupNode;
        $03ccd63b0299d6a7$var$_chainKeys$1[1] = nodeUniformsGroup;
        let groupData = this.groupsData.get($03ccd63b0299d6a7$var$_chainKeys$1);
        if (groupData === undefined) this.groupsData.set($03ccd63b0299d6a7$var$_chainKeys$1, groupData = {});
        $03ccd63b0299d6a7$var$_chainKeys$1[0] = null;
        $03ccd63b0299d6a7$var$_chainKeys$1[1] = null;
        if (groupData.version !== groupNode.version) {
            groupData.version = groupNode.version;
            return true;
        }
        return false;
    }
    /**
	 * Returns the cache key for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {number} The cache key.
	 */ getForRenderCacheKey(renderObject) {
        return renderObject.initialCacheKey;
    }
    /**
	 * Creates a node builder configured for the given render object and material.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Material} material - The material to use.
	 * @return {NodeBuilder} The configured node builder.
	 */ _createNodeBuilder(renderObject, material) {
        const nodeBuilder = this.backend.createNodeBuilder(renderObject.object, this.renderer);
        nodeBuilder.scene = renderObject.scene;
        nodeBuilder.material = material;
        nodeBuilder.camera = renderObject.camera;
        nodeBuilder.context.material = material;
        nodeBuilder.lightsNode = renderObject.lightsNode;
        nodeBuilder.environmentNode = this.getEnvironmentNode(renderObject.scene);
        nodeBuilder.fogNode = this.getFogNode(renderObject.scene);
        nodeBuilder.clippingContext = renderObject.clippingContext;
        if (this.renderer.getOutputRenderTarget() ? this.renderer.getOutputRenderTarget().multiview : false) nodeBuilder.enableMultiview();
        return nodeBuilder;
    }
    /**
	 * Returns a node builder state for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {boolean} [useAsync=false] - Whether to use async build with yielding.
	 * @return {NodeBuilderState|Promise<NodeBuilderState>} The node builder state (or Promise if async).
	 */ getForRender(renderObject, useAsync = false) {
        const renderObjectData = this.get(renderObject);
        let nodeBuilderState = renderObjectData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const { nodeBuilderCache: nodeBuilderCache } = this;
            const cacheKey = this.getForRenderCacheKey(renderObject);
            nodeBuilderState = nodeBuilderCache.get(cacheKey);
            if (nodeBuilderState === undefined) {
                const buildNodeBuilder = async ()=>{
                    let nodeBuilder = this._createNodeBuilder(renderObject, renderObject.material);
                    try {
                        if (useAsync) await nodeBuilder.buildAsync();
                        else nodeBuilder.build();
                    } catch (e) {
                        nodeBuilder = this._createNodeBuilder(renderObject, new $03ccd63b0299d6a7$export$caaf3b30a544c946());
                        if (useAsync) await nodeBuilder.buildAsync();
                        else nodeBuilder.build();
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: ' + e);
                    }
                    return nodeBuilder;
                };
                if (useAsync) return buildNodeBuilder().then((nodeBuilder)=>{
                    nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
                    nodeBuilderCache.set(cacheKey, nodeBuilderState);
                    nodeBuilderState.usedTimes++;
                    renderObjectData.nodeBuilderState = nodeBuilderState;
                    return nodeBuilderState;
                });
                else {
                    // Synchronous path - call buildNodeBuilder but don't await
                    let nodeBuilder = this._createNodeBuilder(renderObject, renderObject.material);
                    try {
                        nodeBuilder.build();
                    } catch (e) {
                        nodeBuilder = this._createNodeBuilder(renderObject, new $03ccd63b0299d6a7$export$caaf3b30a544c946());
                        nodeBuilder.build();
                        let stackTrace = e.stackTrace;
                        if (!stackTrace && e.stack) // Capture stack trace for JavaScript errors
                        stackTrace = new $03ccd63b0299d6a7$export$d540ba6c994dd81c(e.stack);
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('TSL: ' + e, stackTrace);
                    }
                    nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
                    nodeBuilderCache.set(cacheKey, nodeBuilderState);
                }
            }
            nodeBuilderState.usedTimes++;
            renderObjectData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    /**
	 * Async version of getForRender() that yields to main thread during build.
	 * Use this in compileAsync() to prevent blocking the main thread.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Promise<NodeBuilderState>} A promise that resolves to the node builder state.
	 */ getForRenderAsync(renderObject) {
        const result = this.getForRender(renderObject, true);
        // Ensure we always return a Promise (cache hit returns nodeBuilderState directly)
        if (result.then) return result;
        return Promise.resolve(result);
    }
    /**
	 * Returns nodeBuilderState if ready, null if pending async build.
	 * Queues async build on first call for cache miss.
	 * Use this in render() path to enable non-blocking compilation.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {?NodeBuilderState} The node builder state, or null if still building.
	 */ getForRenderDeferred(renderObject) {
        const renderObjectData = this.get(renderObject);
        // Already built for this renderObject
        if (renderObjectData.nodeBuilderState !== undefined) return renderObjectData.nodeBuilderState;
        // Check cache with stable key
        const cacheKey = this.getForRenderCacheKey(renderObject);
        const nodeBuilderState = this.nodeBuilderCache.get(cacheKey);
        if (nodeBuilderState !== undefined) {
            // Cache hit - use it
            nodeBuilderState.usedTimes++;
            renderObjectData.nodeBuilderState = nodeBuilderState;
            return nodeBuilderState;
        }
        // Cache miss - check if async build already queued
        if (renderObjectData.pendingBuild !== true) {
            // Mark as pending and add to build queue
            renderObjectData.pendingBuild = true;
            this._buildQueue.push(()=>{
                return this.getForRenderAsync(renderObject).then(()=>{
                    renderObjectData.pendingBuild = false;
                });
            });
            // Start processing queue if not already running
            this._processBuildQueue();
        }
        return null; // Not ready
    }
    /**
	 * Processes the build queue one item at a time.
	 * This ensures builds don't all run simultaneously and freeze the main thread.
	 *
	 * @private
	 */ _processBuildQueue() {
        if (this._buildInProgress || this._buildQueue.length === 0) return;
        this._buildInProgress = true;
        const buildFn = this._buildQueue.shift();
        buildFn().then(()=>{
            this._buildInProgress = false;
            // Process next item in queue
            this._processBuildQueue();
        });
    }
    /**
	 * Deletes the given object from the internal data map
	 *
	 * @param {any} object - The object to delete.
	 * @return {?Object} The deleted dictionary.
	 */ delete(object) {
        if (object.isRenderObject) {
            const nodeBuilderState = this.get(object).nodeBuilderState;
            if (nodeBuilderState !== undefined) {
                nodeBuilderState.usedTimes--;
                if (nodeBuilderState.usedTimes === 0) this.nodeBuilderCache.delete(this.getForRenderCacheKey(object));
            }
        }
        return super.delete(object);
    }
    /**
	 * Returns a node builder state for the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 * @return {NodeBuilderState} The node builder state.
	 */ getForCompute(computeNode) {
        const computeData = this.get(computeNode);
        let nodeBuilderState = computeData.nodeBuilderState;
        if (nodeBuilderState === undefined) {
            const nodeBuilder = this.backend.createNodeBuilder(computeNode, this.renderer);
            nodeBuilder.build();
            nodeBuilderState = this._createNodeBuilderState(nodeBuilder);
            computeData.nodeBuilderState = nodeBuilderState;
        }
        return nodeBuilderState;
    }
    /**
	 * Creates a node builder state for the given node builder.
	 *
	 * @private
	 * @param {NodeBuilder} nodeBuilder - The node builder.
	 * @return {NodeBuilderState} The node builder state.
	 */ _createNodeBuilderState(nodeBuilder) {
        return new $03ccd63b0299d6a7$var$NodeBuilderState(nodeBuilder.vertexShader, nodeBuilder.fragmentShader, nodeBuilder.computeShader, nodeBuilder.getAttributesArray(), nodeBuilder.getBindings(), nodeBuilder.updateNodes, nodeBuilder.updateBeforeNodes, nodeBuilder.updateAfterNodes, nodeBuilder.observer, nodeBuilder.transforms);
    }
    /**
	 * Returns an environment node for the current configured
	 * scene environment.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene environment.
	 */ getEnvironmentNode(scene) {
        this.updateEnvironment(scene);
        let environmentNode = null;
        if (scene.environmentNode && scene.environmentNode.isNode) environmentNode = scene.environmentNode;
        else {
            const sceneData = this.get(scene);
            if (sceneData.environmentNode) environmentNode = sceneData.environmentNode;
        }
        return environmentNode;
    }
    /**
	 * Returns a background node for the current configured
	 * scene background.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene background.
	 */ getBackgroundNode(scene) {
        this.updateBackground(scene);
        let backgroundNode = null;
        if (scene.backgroundNode && scene.backgroundNode.isNode) backgroundNode = scene.backgroundNode;
        else {
            const sceneData = this.get(scene);
            if (sceneData.backgroundNode) backgroundNode = sceneData.backgroundNode;
        }
        return backgroundNode;
    }
    /**
	 * Returns a fog node for the current configured scene fog.
	 *
	 * @param {Scene} scene - The scene.
	 * @return {Node} A node representing the current scene fog.
	 */ getFogNode(scene) {
        this.updateFog(scene);
        return scene.fogNode || this.get(scene).fogNode || null;
    }
    /**
	 * Returns a cache key for the given scene and lights node.
	 * This key is used by `RenderObject` as a part of the dynamic
	 * cache key (a key that must be checked every time the render
	 * objects is drawn).
	 *
	 * @param {Scene} scene - The scene.
	 * @param {LightsNode} lightsNode - The lights node.
	 * @return {number} The cache key.
	 */ getCacheKey(scene, lightsNode) {
        $03ccd63b0299d6a7$var$_chainKeys$1[0] = scene;
        $03ccd63b0299d6a7$var$_chainKeys$1[1] = lightsNode;
        const callId = this.renderer.info.calls;
        const cacheKeyData = this.callHashCache.get($03ccd63b0299d6a7$var$_chainKeys$1) || {};
        if (cacheKeyData.callId !== callId) {
            const environmentNode = this.getEnvironmentNode(scene);
            const fogNode = this.getFogNode(scene);
            if (lightsNode) $03ccd63b0299d6a7$var$_cacheKeyValues.push(lightsNode.getCacheKey(true));
            if (environmentNode) $03ccd63b0299d6a7$var$_cacheKeyValues.push(environmentNode.getCacheKey());
            if (fogNode) $03ccd63b0299d6a7$var$_cacheKeyValues.push(fogNode.getCacheKey());
            $03ccd63b0299d6a7$var$_cacheKeyValues.push(this.renderer.getOutputRenderTarget() && this.renderer.getOutputRenderTarget().multiview ? 1 : 0);
            $03ccd63b0299d6a7$var$_cacheKeyValues.push(this.renderer.shadowMap.enabled ? 1 : 0);
            $03ccd63b0299d6a7$var$_cacheKeyValues.push(this.renderer.shadowMap.type);
            cacheKeyData.callId = callId;
            cacheKeyData.cacheKey = $03ccd63b0299d6a7$var$hashArray($03ccd63b0299d6a7$var$_cacheKeyValues);
            this.callHashCache.set($03ccd63b0299d6a7$var$_chainKeys$1, cacheKeyData);
            $03ccd63b0299d6a7$var$_cacheKeyValues.length = 0;
        }
        $03ccd63b0299d6a7$var$_chainKeys$1[0] = null;
        $03ccd63b0299d6a7$var$_chainKeys$1[1] = null;
        return cacheKeyData.cacheKey;
    }
    /**
	 * A boolean that indicates whether tone mapping should be enabled
	 * or not.
	 *
	 * @type {boolean}
	 */ get isToneMappingState() {
        return this.renderer.getRenderTarget() ? false : true;
    }
    /**
	 * If a scene background is configured, this method makes sure to
	 * represent the background with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateBackground(scene) {
        const sceneData = this.get(scene);
        const background = scene.background;
        if (background) {
            const forceUpdate = scene.backgroundBlurriness === 0 && sceneData.backgroundBlurriness > 0 || scene.backgroundBlurriness > 0 && sceneData.backgroundBlurriness === 0;
            if (sceneData.background !== background || forceUpdate) {
                const backgroundNode = this.getCacheNode('background', background, ()=>{
                    if (background.isCubeTexture === true || background.mapping === (0, $9ddd7e9b53f7a2d4$export$d64030b316d3b087) || background.mapping === (0, $9ddd7e9b53f7a2d4$export$ee99d97d46898098) || background.mapping === (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79)) {
                        if (scene.backgroundBlurriness > 0 || background.mapping === (0, $9ddd7e9b53f7a2d4$export$dbf3e70ff37af79)) return $03ccd63b0299d6a7$var$pmremTexture(background);
                        else {
                            let envMap;
                            if (background.isCubeTexture === true) envMap = $03ccd63b0299d6a7$var$cubeTexture(background);
                            else envMap = $03ccd63b0299d6a7$var$texture(background);
                            return $03ccd63b0299d6a7$var$cubeMapNode(envMap);
                        }
                    } else if (background.isTexture === true) return $03ccd63b0299d6a7$var$texture(background, $03ccd63b0299d6a7$var$screenUV.flipY()).setUpdateMatrix(true);
                    else if (background.isColor !== true) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUNodes: Unsupported background configuration.', background);
                }, forceUpdate);
                sceneData.backgroundNode = backgroundNode;
                sceneData.background = background;
                sceneData.backgroundBlurriness = scene.backgroundBlurriness;
            }
        } else if (sceneData.backgroundNode) {
            delete sceneData.backgroundNode;
            delete sceneData.background;
        }
    }
    /**
	 * This method is part of the caching of nodes which are used to represents the
	 * scene's background, fog or environment.
	 *
	 * @param {string} type - The type of object to cache.
	 * @param {Object} object - The object.
	 * @param {Function} callback - A callback that produces a node representation for the given object.
	 * @param {boolean} [forceUpdate=false] - Whether an update should be enforced or not.
	 * @return {Node} The node representation.
	 */ getCacheNode(type, object, callback, forceUpdate = false) {
        const nodeCache = this.cacheLib[type] || (this.cacheLib[type] = new WeakMap());
        let node = nodeCache.get(object);
        if (node === undefined || forceUpdate) {
            node = callback();
            nodeCache.set(object, node);
        }
        return node;
    }
    /**
	 * If a scene fog is configured, this method makes sure to
	 * represent the fog with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateFog(scene) {
        const sceneData = this.get(scene);
        const sceneFog = scene.fog;
        if (sceneFog) {
            if (sceneData.fog !== sceneFog) {
                const fogNode = this.getCacheNode('fog', sceneFog, ()=>{
                    if (sceneFog.isFogExp2) {
                        const color = $03ccd63b0299d6a7$var$reference('color', 'color', sceneFog).setGroup($03ccd63b0299d6a7$var$renderGroup);
                        const density = $03ccd63b0299d6a7$var$reference('density', 'float', sceneFog).setGroup($03ccd63b0299d6a7$var$renderGroup);
                        return $03ccd63b0299d6a7$var$fog(color, $03ccd63b0299d6a7$var$densityFogFactor(density));
                    } else if (sceneFog.isFog) {
                        const color = $03ccd63b0299d6a7$var$reference('color', 'color', sceneFog).setGroup($03ccd63b0299d6a7$var$renderGroup);
                        const near = $03ccd63b0299d6a7$var$reference('near', 'float', sceneFog).setGroup($03ccd63b0299d6a7$var$renderGroup);
                        const far = $03ccd63b0299d6a7$var$reference('far', 'float', sceneFog).setGroup($03ccd63b0299d6a7$var$renderGroup);
                        return $03ccd63b0299d6a7$var$fog(color, $03ccd63b0299d6a7$var$rangeFogFactor(near, far));
                    } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Renderer: Unsupported fog configuration.', sceneFog);
                });
                sceneData.fogNode = fogNode;
                sceneData.fog = sceneFog;
            }
        } else {
            delete sceneData.fogNode;
            delete sceneData.fog;
        }
    }
    /**
	 * If a scene environment is configured, this method makes sure to
	 * represent the environment with a corresponding node-based implementation.
	 *
	 * @param {Scene} scene - The scene.
	 */ updateEnvironment(scene) {
        const sceneData = this.get(scene);
        const environment = scene.environment;
        if (environment) {
            if (sceneData.environment !== environment) {
                const environmentNode = this.getCacheNode('environment', environment, ()=>{
                    if (environment.isCubeTexture === true) return $03ccd63b0299d6a7$var$cubeTexture(environment);
                    else if (environment.isTexture === true) return $03ccd63b0299d6a7$var$texture(environment);
                    else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Nodes: Unsupported environment configuration.', environment);
                });
                sceneData.environmentNode = environmentNode;
                sceneData.environment = environment;
            }
        } else if (sceneData.environmentNode) {
            delete sceneData.environmentNode;
            delete sceneData.environment;
        }
    }
    getNodeFrame(renderer = this.renderer, scene = null, object = null, camera = null, material = null) {
        const nodeFrame = this.nodeFrame;
        nodeFrame.renderer = renderer;
        nodeFrame.scene = scene;
        nodeFrame.object = object;
        nodeFrame.camera = camera;
        nodeFrame.material = material;
        return nodeFrame;
    }
    getNodeFrameForRender(renderObject) {
        return this.getNodeFrame(renderObject.renderer, renderObject.scene, renderObject.object, renderObject.camera, renderObject.material);
    }
    /**
	 * Returns the current output cache key.
	 *
	 * @return {string} The output cache key.
	 */ getOutputCacheKey() {
        const renderer = this.renderer;
        return renderer.toneMapping + ',' + renderer.currentColorSpace + ',' + renderer.xr.isPresenting;
    }
    /**
	 * Returns a node that represents the output configuration (tone mapping and
	 * color space) for the current target.
	 *
	 * @param {Texture} outputTarget - The output target.
	 * @return {Node} The output node.
	 */ getOutputNode(outputTarget) {
        const renderer = this.renderer;
        const output = outputTarget.isArrayTexture ? $03ccd63b0299d6a7$var$texture(outputTarget, $03ccd63b0299d6a7$var$screenUV).depth($03ccd63b0299d6a7$var$builtin('gl_ViewID_OVR')).renderOutput(renderer.toneMapping, renderer.currentColorSpace) : $03ccd63b0299d6a7$var$texture(outputTarget, $03ccd63b0299d6a7$var$screenUV).renderOutput(renderer.toneMapping, renderer.currentColorSpace);
        return output;
    }
    /**
	 * Triggers the call of `updateBefore()` methods
	 * for all nodes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateBefore(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateBeforeNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateBeforeNode(node);
    }
    /**
	 * Triggers the call of `updateAfter()` methods
	 * for all nodes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateAfter(renderObject) {
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateAfterNodes)// update frame state for each node
        this.getNodeFrameForRender(renderObject).updateAfterNode(node);
    }
    /**
	 * Triggers the call of `update()` methods
	 * for all nodes of the given compute node.
	 *
	 * @param {Node} computeNode - The compute node.
	 */ updateForCompute(computeNode) {
        const nodeFrame = this.getNodeFrame();
        const nodeBuilder = this.getForCompute(computeNode);
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    /**
	 * Triggers the call of `update()` methods
	 * for all nodes of the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 */ updateForRender(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const nodeBuilder = renderObject.getNodeBuilderState();
        for (const node of nodeBuilder.updateNodes)nodeFrame.updateNode(node);
    }
    /**
	 * Returns `true` if the given render object requires a refresh.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the given render object requires a refresh or not.
	 */ needsRefresh(renderObject) {
        const nodeFrame = this.getNodeFrameForRender(renderObject);
        const monitor = renderObject.getMonitor();
        return monitor.needsRefresh(renderObject, nodeFrame);
    }
    /**
	 * Frees the internal resources.
	 */ dispose() {
        super.dispose();
        this.nodeFrame = new $03ccd63b0299d6a7$export$20d1e096ab9d190e();
        this.nodeBuilderCache = new Map();
        this.cacheLib = {};
    }
}
const $03ccd63b0299d6a7$var$_plane = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0)();
/**
 * Represents the state that is used to perform clipping via clipping planes.
 * There is a default clipping context for each render context. When the
 * scene holds instances of `ClippingGroup`, there will be a context for each
 * group.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$ClippingContext {
    /**
	 * Constructs a new clipping context.
	 *
	 * @param {?ClippingContext} [parentContext=null] - A reference to the parent clipping context.
	 */ constructor(parentContext = null){
        /**
		 * The clipping context's version.
		 *
		 * @type {number}
		 * @readonly
		 */ this.version = 0;
        /**
		 * Whether the intersection of the clipping planes is used to clip objects, rather than their union.
		 *
		 * @type {?boolean}
		 * @default null
		 */ this.clipIntersection = null;
        /**
		 * The clipping context's cache key.
		 *
		 * @type {string}
		 */ this.cacheKey = '';
        /**
		 * Whether the shadow pass is active or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.shadowPass = false;
        /**
		 * The view normal matrix.
		 *
		 * @type {Matrix3}
		 */ this.viewNormalMatrix = new (0, $9ddd7e9b53f7a2d4$export$8ff26dafa08918)();
        /**
		 * Internal cache for maintaining clipping contexts.
		 *
		 * @type {WeakMap<ClippingGroup,ClippingContext>}
		 */ this.clippingGroupContexts = new WeakMap();
        /**
		 * The intersection planes.
		 *
		 * @type {Array<Vector4>}
		 */ this.intersectionPlanes = [];
        /**
		 * The intersection planes.
		 *
		 * @type {Array<Vector4>}
		 */ this.unionPlanes = [];
        /**
		 * The version of the clipping context's parent context.
		 *
		 * @type {?number}
		 * @readonly
		 */ this.parentVersion = null;
        if (parentContext !== null) {
            this.viewNormalMatrix = parentContext.viewNormalMatrix;
            this.clippingGroupContexts = parentContext.clippingGroupContexts;
            this.shadowPass = parentContext.shadowPass;
            this.viewMatrix = parentContext.viewMatrix;
        }
    }
    /**
	 * Projects the given source clipping planes and writes the result into the
	 * destination array.
	 *
	 * @param {Array<Plane>} source - The source clipping planes.
	 * @param {Array<Vector4>} destination - The destination.
	 * @param {number} offset - The offset.
	 */ projectPlanes(source, destination, offset) {
        const l = source.length;
        for(let i = 0; i < l; i++){
            $03ccd63b0299d6a7$var$_plane.copy(source[i]).applyMatrix4(this.viewMatrix, this.viewNormalMatrix);
            const v = destination[offset + i];
            const normal = $03ccd63b0299d6a7$var$_plane.normal;
            v.x = -normal.x;
            v.y = -normal.y;
            v.z = -normal.z;
            v.w = $03ccd63b0299d6a7$var$_plane.constant;
        }
    }
    /**
	 * Updates the root clipping context of a scene.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 */ updateGlobal(scene, camera) {
        this.shadowPass = scene.overrideMaterial !== null && scene.overrideMaterial.isShadowPassMaterial;
        this.viewMatrix = camera.matrixWorldInverse;
        this.viewNormalMatrix.getNormalMatrix(this.viewMatrix);
    }
    /**
	 * Updates the clipping context.
	 *
	 * @param {ClippingContext} parentContext - The parent context.
	 * @param {ClippingGroup} clippingGroup - The clipping group this context belongs to.
	 */ update(parentContext, clippingGroup) {
        let update = false;
        if (parentContext.version !== this.parentVersion) {
            this.intersectionPlanes = Array.from(parentContext.intersectionPlanes);
            this.unionPlanes = Array.from(parentContext.unionPlanes);
            this.parentVersion = parentContext.version;
        }
        if (this.clipIntersection !== clippingGroup.clipIntersection) {
            this.clipIntersection = clippingGroup.clipIntersection;
            if (this.clipIntersection) this.unionPlanes.length = parentContext.unionPlanes.length;
            else this.intersectionPlanes.length = parentContext.intersectionPlanes.length;
        }
        const srcClippingPlanes = clippingGroup.clippingPlanes;
        const l = srcClippingPlanes.length;
        let dstClippingPlanes;
        let offset;
        if (this.clipIntersection) {
            dstClippingPlanes = this.intersectionPlanes;
            offset = parentContext.intersectionPlanes.length;
        } else {
            dstClippingPlanes = this.unionPlanes;
            offset = parentContext.unionPlanes.length;
        }
        if (dstClippingPlanes.length !== offset + l) {
            dstClippingPlanes.length = offset + l;
            for(let i = 0; i < l; i++)dstClippingPlanes[offset + i] = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
            update = true;
        }
        this.projectPlanes(srcClippingPlanes, dstClippingPlanes, offset);
        if (update) {
            this.version++;
            this.cacheKey = `${this.intersectionPlanes.length}:${this.unionPlanes.length}`;
        }
    }
    /**
	 * Returns a clipping context for the given clipping group.
	 *
	 * @param {ClippingGroup} clippingGroup - The clipping group.
	 * @return {ClippingContext} The clipping context.
	 */ getGroupContext(clippingGroup) {
        if (this.shadowPass && !clippingGroup.clipShadows) return this;
        let context = this.clippingGroupContexts.get(clippingGroup);
        if (context === undefined) {
            context = new $03ccd63b0299d6a7$var$ClippingContext(this);
            this.clippingGroupContexts.set(clippingGroup, context);
        }
        context.update(this, clippingGroup);
        return context;
    }
    /**
	 * The count of union clipping planes.
	 *
	 * @type {number}
	 * @readonly
	 */ get unionClippingCount() {
        return this.unionPlanes.length;
    }
}
/**
 * This module is used to represent render bundles inside the renderer
 * for further processing.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderBundle {
    /**
	 * Constructs a new bundle group.
	 *
	 * @param {BundleGroup} bundleGroup - The bundle group.
	 * @param {Camera} camera - The camera the bundle group is rendered with.
	 * @param {RenderContext} renderContext - The render context the bundle is rendered with.
	 */ constructor(bundleGroup, camera, renderContext){
        this.bundleGroup = bundleGroup;
        this.camera = camera;
        this.renderContext = renderContext;
    }
}
const $03ccd63b0299d6a7$var$_chainKeys = [];
/**
 * This renderer module manages render bundles.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$RenderBundles {
    /**
	 * Constructs a new render bundle management component.
	 */ constructor(){
        /**
		 * A chain map for maintaining the render bundles.
		 *
		 * @type {ChainMap}
		 */ this.bundles = new $03ccd63b0299d6a7$var$ChainMap();
    }
    /**
	 * Returns a render bundle for the given bundle group and camera.
	 *
	 * @param {BundleGroup} bundleGroup - The bundle group.
	 * @param {Camera} camera - The camera the bundle group is rendered with.
	 * @param {RenderContext} renderContext - The render context the bundle is rendered with.
	 * @return {RenderBundle} The render bundle.
	 */ get(bundleGroup, camera, renderContext) {
        const bundles = this.bundles;
        $03ccd63b0299d6a7$var$_chainKeys[0] = bundleGroup;
        $03ccd63b0299d6a7$var$_chainKeys[1] = camera;
        $03ccd63b0299d6a7$var$_chainKeys[2] = renderContext;
        let bundle = bundles.get($03ccd63b0299d6a7$var$_chainKeys);
        if (bundle === undefined) {
            bundle = new $03ccd63b0299d6a7$var$RenderBundle(bundleGroup, camera, renderContext);
            bundles.set($03ccd63b0299d6a7$var$_chainKeys, bundle);
        }
        $03ccd63b0299d6a7$var$_chainKeys[0] = null;
        $03ccd63b0299d6a7$var$_chainKeys[1] = null;
        $03ccd63b0299d6a7$var$_chainKeys[2] = null;
        return bundle;
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this.bundles = new $03ccd63b0299d6a7$var$ChainMap();
    }
}
/**
 * The purpose of a node library is to assign node implementations
 * to existing library features. In `WebGPURenderer` lights, materials
 * which are not based on `NodeMaterial` as well as tone mapping techniques
 * are implemented with node-based modules.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$NodeLibrary {
    /**
	 * Constructs a new node library.
	 */ constructor(){
        /**
		 * A weak map that maps lights to light nodes.
		 *
		 * @type {WeakMap<Light.constructor,AnalyticLightNode.constructor>}
		 */ this.lightNodes = new WeakMap();
        /**
		 * A map that maps materials to node materials.
		 *
		 * @type {Map<string,NodeMaterial.constructor>}
		 */ this.materialNodes = new Map();
        /**
		 * A map that maps tone mapping techniques (constants)
		 * to tone mapping node functions.
		 *
		 * @type {Map<number,Function>}
		 */ this.toneMappingNodes = new Map();
    }
    /**
	 * Returns a matching node material instance for the given material object.
	 *
	 * This method also assigns/copies the properties of the given material object
	 * to the node material. This is done to make sure the current material
	 * configuration carries over to the node version.
	 *
	 * @param {Material} material - A material.
	 * @return {NodeMaterial} The corresponding node material.
	 */ fromMaterial(material) {
        if (material.isNodeMaterial) return material;
        let nodeMaterial = null;
        const nodeMaterialClass = this.getMaterialNodeClass(material.type);
        if (nodeMaterialClass !== null) {
            nodeMaterial = new nodeMaterialClass();
            for(const key in material)nodeMaterial[key] = material[key];
        }
        return nodeMaterial;
    }
    /**
	 * Adds a tone mapping node function for a tone mapping technique (constant).
	 *
	 * @param {Function} toneMappingNode - The tone mapping node function.
	 * @param {number} toneMapping - The tone mapping.
	 */ addToneMapping(toneMappingNode, toneMapping) {
        this.addType(toneMappingNode, toneMapping, this.toneMappingNodes);
    }
    /**
	 * Returns a tone mapping node function for a tone mapping technique (constant).
	 *
	 * @param {number} toneMapping - The tone mapping.
	 * @return {?Function} The tone mapping node function. Returns `null` if no node function is found.
	 */ getToneMappingFunction(toneMapping) {
        return this.toneMappingNodes.get(toneMapping) || null;
    }
    /**
	 * Returns a node material class definition for a material type.
	 *
	 * @param {string} materialType - The material type.
	 * @return {?NodeMaterial.constructor} The node material class definition. Returns `null` if no node material is found.
	 */ getMaterialNodeClass(materialType) {
        return this.materialNodes.get(materialType) || null;
    }
    /**
	 * Adds a node material class definition for a given material type.
	 *
	 * @param {NodeMaterial.constructor} materialNodeClass - The node material class definition.
	 * @param {string} materialClassType - The material type.
	 */ addMaterial(materialNodeClass, materialClassType) {
        this.addType(materialNodeClass, materialClassType, this.materialNodes);
    }
    /**
	 * Returns a light node class definition for a light class definition.
	 *
	 * @param {Light.constructor} light - The light class definition.
	 * @return {?AnalyticLightNode.constructor} The light node class definition. Returns `null` if no light node is found.
	 */ getLightNodeClass(light) {
        return this.lightNodes.get(light) || null;
    }
    /**
	 * Adds a light node class definition for a given light class definition.
	 *
	 * @param {AnalyticLightNode.constructor} lightNodeClass - The light node class definition.
	 * @param {Light.constructor} lightClass - The light class definition.
	 */ addLight(lightNodeClass, lightClass) {
        this.addClass(lightNodeClass, lightClass, this.lightNodes);
    }
    /**
	 * Adds a node class definition for the given type to the provided type library.
	 *
	 * @param {Node.constructor} nodeClass - The node class definition.
	 * @param {number|string} type - The object type.
	 * @param {Map<number|string,Node.constructor>} library - The type library.
	 */ addType(nodeClass, type, library) {
        if (library.has(type)) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`Redefinition of node ${type}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof type === 'function' || typeof type === 'object') throw new Error(`Base class ${type} is not a class.`);
        library.set(type, nodeClass);
    }
    /**
	 * Adds a node class definition for the given class definition to the provided type library.
	 *
	 * @param {Node.constructor} nodeClass - The node class definition.
	 * @param {Node.constructor} baseClass - The class definition.
	 * @param {WeakMap<Node.constructor, Node.constructor>} library - The type library.
	 */ addClass(nodeClass, baseClass, library) {
        if (library.has(baseClass)) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`Redefinition of node ${baseClass.name}`);
            return;
        }
        if (typeof nodeClass !== 'function') throw new Error(`Node class ${nodeClass.name} is not a class.`);
        if (typeof baseClass !== 'function') throw new Error(`Base class ${baseClass.name} is not a class.`);
        library.set(baseClass, nodeClass);
    }
}
const $03ccd63b0299d6a7$var$_defaultLights = /*@__PURE__*/ new $03ccd63b0299d6a7$export$577c410712851cc4();
const $03ccd63b0299d6a7$var$_weakMap = /*@__PURE__*/ new WeakMap();
/**
 * This renderer module manages the lights nodes which are unique
 * per scene and camera combination.
 *
 * The lights node itself is later configured in the render list
 * with the actual lights from the scene.
 *
 * @private
 */ class $03ccd63b0299d6a7$export$10b79c914aa1f585 {
    /**
	 * Creates a new lights node for the given array of lights.
	 *
	 * @param {Array<Light>} lights - The render object.
	 * @return {LightsNode} The lights node.
	 */ createNode(lights = []) {
        return new $03ccd63b0299d6a7$export$577c410712851cc4().setLights(lights);
    }
    /**
	 * Returns a lights node for the given scene and camera.
	 *
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera.
	 * @return {LightsNode} The lights node.
	 */ getNode(scene) {
        // ignore post-processing
        if (scene.isQuadMesh) return $03ccd63b0299d6a7$var$_defaultLights;
        let node = $03ccd63b0299d6a7$var$_weakMap.get(scene);
        if (node === undefined) {
            node = this.createNode();
            $03ccd63b0299d6a7$var$_weakMap.set(scene, node);
        }
        return node;
    }
}
/**
 * A special type of render target that is used when rendering
 * with the WebXR Device API.
 *
 * @private
 * @augments RenderTarget
 */ class $03ccd63b0299d6a7$var$XRRenderTarget extends (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb) {
    /**
	 * Constructs a new XR render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {Object} [options={}] - The configuration options.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isXRRenderTarget = true;
        /**
		 * Whether the attachments of the render target
		 * are defined by external textures. This flag is
		 * set to `true` when using the WebXR Layers API.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._hasExternalTextures = false;
        /**
		 * Whether a depth buffer should automatically be allocated
		 * for this XR render target or not.
		 *
		 * Allocating a depth buffer is the default behavior of XR render
		 * targets. However, when using the WebXR Layers API, this flag
		 * must be set to `false` when the `ignoreDepthValues` property of
		 * the projection layers evaluates to `false`.
		 *
		 * Reference: {@link https://www.w3.org/TR/webxrlayers-1/#dom-xrprojectionlayer-ignoredepthvalues}.
		 *
		 * @private
		 * @type {boolean}
		 * @default true
		 */ this._autoAllocateDepthBuffer = true;
        /**
		 * Whether this render target is associated with a XRWebGLLayer.
		 *
		 * A XRWebGLLayer points to an opaque framebuffer. Basically,
		 * this means that you don't have access to its bound color,
		 * stencil and depth buffers. We need to handle this framebuffer
		 * differently since its textures are always bound.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 * */ this._isOpaqueFramebuffer = false;
    }
    copy(source) {
        super.copy(source);
        this._hasExternalTextures = source._hasExternalTextures;
        this._autoAllocateDepthBuffer = source._autoAllocateDepthBuffer;
        this._isOpaqueFramebuffer = source._isOpaqueFramebuffer;
        return this;
    }
}
const $03ccd63b0299d6a7$var$_cameraLPos = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_cameraRPos = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $03ccd63b0299d6a7$var$_contextNodeLib = /*@__PURE__*/ new WeakMap();
/**
 * The XR manager is built on top of the WebXR Device API to
 * manage XR sessions with `WebGPURenderer`.
 *
 * XR is currently only supported with a WebGL 2 backend.
 *
 * @augments EventDispatcher
 */ class $03ccd63b0299d6a7$var$XRManager extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    /**
	 * Constructs a new XR manager.
	 *
	 * @param {Renderer} renderer - The renderer.
	 * @param {boolean} [multiview=false] - Enables multiview if the device supports it.
	 */ constructor(renderer, multiview = false){
        super();
        /**
		 * This flag globally enables XR rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether the XR device is currently presenting or not.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.isPresenting = false;
        /**
		 * Whether the XR camera should automatically be updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * The renderer.
		 *
		 * @private
		 * @type {Renderer}
		 */ this._renderer = renderer;
        // camera
        /**
		 * Represents the camera for the left eye.
		 *
		 * @private
		 * @type {PerspectiveCamera}
		 */ this._cameraL = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
        this._cameraL.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        /**
		 * Represents the camera for the right eye.
		 *
		 * @private
		 * @type {PerspectiveCamera}
		 */ this._cameraR = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
        this._cameraR.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
        /**
		 * A list of cameras used for rendering the XR views.
		 *
		 * @private
		 * @type {Array<Camera>}
		 */ this._cameras = [
            this._cameraL,
            this._cameraR
        ];
        /**
		 * The main XR camera.
		 *
		 * @private
		 * @type {ArrayCamera}
		 */ this._cameraXR = new (0, $9ddd7e9b53f7a2d4$export$56b937d9e5581166)();
        /**
		 * The current near value of the XR camera.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentDepthNear = null;
        /**
		 * The current far value of the XR camera.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentDepthFar = null;
        /**
		 * A list of WebXR controllers requested by the application.
		 *
		 * @private
		 * @type {Array<WebXRController>}
		 */ this._controllers = [];
        /**
		 * A list of XR input source. Each input source belongs to
		 * an instance of WebXRController.
		 *
		 * @private
		 * @type {Array<XRInputSource?>}
		 */ this._controllerInputSources = [];
        /**
		 * The XR render target that represents the rendering destination
		 * during an active XR session.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._xrRenderTarget = null;
        /**
		 * An array holding all the non-projection layers
		 *
		 * @private
		 * @type {Array<Object>}
		 * @default []
		 */ this._layers = [];
        /**
		 * Whether the XR session uses layers.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._sessionUsesLayers = false;
        /**
		 * Whether the device supports binding gl objects.
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        /**
		 * Helper function to create native WebXR Layer.
		 *
		 * @private
		 * @type {Function}
		 */ this._createXRLayer = $03ccd63b0299d6a7$var$createXRLayer.bind(this);
        /**
		* The current WebGL context.
		*
		* @private
		* @type {?WebGL2RenderingContext}
		* @default null
		*/ this._gl = null;
        /**
		 * The current animation context.
		 *
		 * @private
		 * @type {?Window}
		 * @default null
		 */ this._currentAnimationContext = null;
        /**
		 * The current animation loop.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._currentAnimationLoop = null;
        /**
		 * The current pixel ratio.
		 *
		 * @private
		 * @type {?number}
		 * @default null
		 */ this._currentPixelRatio = null;
        /**
		 * The current size of the renderer's canvas
		 * in logical pixel unit.
		 *
		 * @private
		 * @type {Vector2}
		 */ this._currentSize = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        /**
		 * The default event listener for handling events inside a XR session.
		 *
		 * @private
		 * @type {Function}
		 */ this._onSessionEvent = $03ccd63b0299d6a7$var$onSessionEvent.bind(this);
        /**
		 * The event listener for handling the end of a XR session.
		 *
		 * @private
		 * @type {Function}
		 */ this._onSessionEnd = $03ccd63b0299d6a7$var$onSessionEnd.bind(this);
        /**
		 * The event listener for handling the `inputsourceschange` event.
		 *
		 * @private
		 * @type {Function}
		 */ this._onInputSourcesChange = $03ccd63b0299d6a7$var$onInputSourcesChange.bind(this);
        /**
		 * The animation loop which is used as a replacement for the default
		 * animation loop of the application. It is only used when a XR session
		 * is active.
		 *
		 * @private
		 * @type {Function}
		 */ this._onAnimationFrame = $03ccd63b0299d6a7$var$onAnimationFrame.bind(this);
        /**
		 * The current XR reference space.
		 *
		 * @private
		 * @type {?XRReferenceSpace}
		 * @default null
		 */ this._referenceSpace = null;
        /**
		 * The current XR reference space type.
		 *
		 * @private
		 * @type {XRReferenceSpaceType}
		 * @default 'local-floor'
		 */ this._referenceSpaceType = 'local-floor';
        /**
		 * A custom reference space defined by the application.
		 *
		 * @private
		 * @type {?XRReferenceSpace}
		 * @default null
		 */ this._customReferenceSpace = null;
        /**
		 * The framebuffer scale factor.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._framebufferScaleFactor = 1;
        /**
		 * The foveation factor.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._foveation = 1.0;
        /**
		 * A reference to the current XR session.
		 *
		 * @private
		 * @type {?XRSession}
		 * @default null
		 */ this._session = null;
        /**
		 * A reference to the current XR base layer.
		 *
		 * @private
		 * @type {?XRWebGLLayer}
		 * @default null
		 */ this._glBaseLayer = null;
        /**
		 * A reference to the current XR binding.
		 *
		 * @private
		 * @type {?XRWebGLBinding}
		 * @default null
		 */ this._glBinding = null;
        /**
		 * A reference to the current XR projection layer.
		 *
		 * @private
		 * @type {?XRProjectionLayer}
		 * @default null
		 */ this._glProjLayer = null;
        /**
		 * A reference to the current XR frame.
		 *
		 * @private
		 * @type {?XRFrame}
		 * @default null
		 */ this._xrFrame = null;
        /**
		 * Whether the browser supports the APIs necessary to use XRProjectionLayers.
		 *
		 * Note: this does not represent XRSession explicitly requesting
		 * `'layers'` as a feature - see `_sessionUsesLayers` and #30112
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._supportsLayers = this._supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype; // eslint-disable-line compat/compat
        /**
		 * Whether the usage of multiview has been requested by the application or not.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this._useMultiviewIfPossible = multiview;
        /**
		 * Whether the usage of multiview is actually enabled. This flag only evaluates to `true`
		 * if multiview has been requested by the application and the `OVR_multiview2` is available.
		 *
		 * @private
		 * @type {boolean}
		 * @readonly
		 */ this._useMultiview = false;
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in target ray space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getController(index) {
        const controller = this._getController(index);
        return controller.getTargetRaySpace();
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in grip space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getControllerGrip(index) {
        const controller = this._getController(index);
        return controller.getGripSpace();
    }
    /**
	 * Returns an instance of `THREE.Group` that represents the transformation
	 * of a XR controller in hand space. The requested controller is defined
	 * by the given index.
	 *
	 * @param {number} index - The index of the XR controller.
	 * @return {Group} A group that represents the controller's transformation.
	 */ getHand(index) {
        const controller = this._getController(index);
        return controller.getHandSpace();
    }
    /**
	 * Returns the foveation value.
	 *
	 * @return {number|undefined} The foveation value. Returns `undefined` if no base or projection layer is defined.
	 */ getFoveation() {
        if (this._glProjLayer === null && this._glBaseLayer === null) return undefined;
        return this._foveation;
    }
    /**
	 * Sets the foveation value.
	 *
	 * @param {number} foveation - A number in the range `[0,1]` where `0` means no foveation (full resolution)
	 * and `1` means maximum foveation (the edges render at lower resolution).
	 */ setFoveation(foveation) {
        this._foveation = foveation;
        if (this._glProjLayer !== null) this._glProjLayer.fixedFoveation = foveation;
        if (this._glBaseLayer !== null && this._glBaseLayer.fixedFoveation !== undefined) this._glBaseLayer.fixedFoveation = foveation;
    }
    /**
	 * Returns the framebuffer scale factor.
	 *
	 * @return {number} The framebuffer scale factor.
	 */ getFramebufferScaleFactor() {
        return this._framebufferScaleFactor;
    }
    /**
	 * Sets the framebuffer scale factor.
	 *
	 * This method can not be used during a XR session.
	 *
	 * @param {number} factor - The framebuffer scale factor.
	 */ setFramebufferScaleFactor(factor) {
        this._framebufferScaleFactor = factor;
        if (this.isPresenting === true) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('XRManager: Cannot change framebuffer scale while presenting.');
    }
    /**
	 * Returns the reference space type.
	 *
	 * @return {XRReferenceSpaceType} The reference space type.
	 */ getReferenceSpaceType() {
        return this._referenceSpaceType;
    }
    /**
	 * Sets the reference space type.
	 *
	 * This method can not be used during a XR session.
	 *
	 * @param {XRReferenceSpaceType} type - The reference space type.
	 */ setReferenceSpaceType(type) {
        this._referenceSpaceType = type;
        if (this.isPresenting === true) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('XRManager: Cannot change reference space type while presenting.');
    }
    /**
	 * Returns the XR reference space.
	 *
	 * @return {XRReferenceSpace} The XR reference space.
	 */ getReferenceSpace() {
        return this._customReferenceSpace || this._referenceSpace;
    }
    /**
	 * Sets a custom XR reference space.
	 *
	 * @param {XRReferenceSpace} space - The XR reference space.
	 */ setReferenceSpace(space) {
        this._customReferenceSpace = space;
    }
    /**
	 * Returns the XR camera.
	 *
	 * @return {ArrayCamera} The XR camera.
	 */ getCamera() {
        return this._cameraXR;
    }
    /**
	 * Returns the environment blend mode from the current XR session.
	 *
	 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
	 */ getEnvironmentBlendMode() {
        if (this._session !== null) return this._session.environmentBlendMode;
    }
    /**
	 * Returns the current XR binding.
	 *
	 * Creates a new binding if needed and the browser is
	 * capable of doing so.
	 *
	 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
	 */ getBinding() {
        if (this._glBinding === null && this._supportsGlBinding) this._glBinding = new XRWebGLBinding(this._session, this._gl);
        return this._glBinding;
    }
    /**
	 * Returns the current XR frame.
	 *
	 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
	 */ getFrame() {
        return this._xrFrame;
    }
    /**
	 * Returns `true` if the engine renders to a multiview target.
	 *
	 * @return {boolean} Whether the engine renders to a multiview render target or not.
	 */ useMultiview() {
        return this._useMultiview;
    }
    /**
	 * This method can be used in XR applications to create a quadratic layer that presents a separate
	 * rendered scene.
	 *
	 * @param {number} width - The width of the layer plane in world units.
	 * @param {number} height - The height of the layer plane in world units.
	 * @param {Vector3} translation - The position/translation of the layer plane in world units.
	 * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
	 * @param {number} pixelwidth - The width of the layer's render target in pixels.
	 * @param {number} pixelheight - The height of the layer's render target in pixels.
	 * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
	 * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
	 * @param {Object} [attributes={}] - Allows to configure the layer's render target.
	 * @return {Mesh} A mesh representing the quadratic XR layer. This mesh should be added to the XR scene.
	 */ createQuadLayer(width, height, translation, quaternion, pixelwidth, pixelheight, rendercall, attributes = {}) {
        const geometry = new (0, $9ddd7e9b53f7a2d4$export$967d831af31f69ce)(width, height);
        const renderTarget = new $03ccd63b0299d6a7$var$XRRenderTarget(pixelwidth, pixelheight, {
            format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
            type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
            depthTexture: new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(pixelwidth, pixelheight, attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96), undefined, undefined, undefined, undefined, undefined, undefined, attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)),
            stencilBuffer: attributes.stencil,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        renderTarget._autoAllocateDepthBuffer = true;
        const material = new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
            color: 0xffffff,
            side: (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901)
        });
        material.map = renderTarget.texture;
        material.map.offset.y = 1;
        material.map.repeat.y = -1;
        const plane = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(geometry, material);
        plane.position.copy(translation);
        plane.quaternion.copy(quaternion);
        const layer = {
            type: 'quad',
            width: width,
            height: height,
            translation: translation,
            quaternion: quaternion,
            pixelwidth: pixelwidth,
            pixelheight: pixelheight,
            plane: plane,
            material: material,
            rendercall: rendercall,
            renderTarget: renderTarget
        };
        this._layers.push(layer);
        if (this._session !== null) {
            layer.plane.material = new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
                color: 0xffffff,
                side: (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901)
            });
            layer.plane.material.blending = (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2);
            layer.plane.material.blendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
            layer.plane.material.blendSrc = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
            layer.plane.material.blendDst = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
            layer.xrlayer = this._createXRLayer(layer);
            const xrlayers = this._session.renderState.layers;
            xrlayers.unshift(layer.xrlayer);
            this._session.updateRenderState({
                layers: xrlayers
            });
        } else renderTarget.isXRRenderTarget = false;
        return plane;
    }
    /**
	 * This method can be used in XR applications to create a cylindrical layer that presents a separate
	 * rendered scene.
	 *
	 * @param {number} radius - The radius of the cylinder in world units.
	 * @param {number} centralAngle - The central angle of the cylinder in radians.
	 * @param {number} aspectratio - The aspect ratio.
	 * @param {Vector3} translation - The position/translation of the layer plane in world units.
	 * @param {Quaternion} quaternion - The orientation of the layer plane expressed as a quaternion.
	 * @param {number} pixelwidth - The width of the layer's render target in pixels.
	 * @param {number} pixelheight - The height of the layer's render target in pixels.
	 * @param {Function} rendercall - A callback function that renders the layer. Similar to code in
	 * the default animation loop, this method can be used to update/transform 3D object in the layer's scene.
	 * @param {Object} [attributes={}] - Allows to configure the layer's render target.
	 * @return {Mesh} A mesh representing the cylindrical XR layer. This mesh should be added to the XR scene.
	 */ createCylinderLayer(radius, centralAngle, aspectratio, translation, quaternion, pixelwidth, pixelheight, rendercall, attributes = {}) {
        const geometry = new (0, $9ddd7e9b53f7a2d4$export$68f745719dbe5198)(radius, radius, radius * centralAngle / aspectratio, 64, 64, true, Math.PI - centralAngle / 2, centralAngle);
        const renderTarget = new $03ccd63b0299d6a7$var$XRRenderTarget(pixelwidth, pixelheight, {
            format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
            type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
            depthTexture: new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(pixelwidth, pixelheight, attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96), undefined, undefined, undefined, undefined, undefined, undefined, attributes.stencil ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)),
            stencilBuffer: attributes.stencil,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        renderTarget._autoAllocateDepthBuffer = true;
        const material = new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
            color: 0xffffff,
            side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)
        });
        material.map = renderTarget.texture;
        material.map.offset.y = 1;
        material.map.repeat.y = -1;
        const plane = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)(geometry, material);
        plane.position.copy(translation);
        plane.quaternion.copy(quaternion);
        const layer = {
            type: 'cylinder',
            radius: radius,
            centralAngle: centralAngle,
            aspectratio: aspectratio,
            translation: translation,
            quaternion: quaternion,
            pixelwidth: pixelwidth,
            pixelheight: pixelheight,
            plane: plane,
            material: material,
            rendercall: rendercall,
            renderTarget: renderTarget
        };
        this._layers.push(layer);
        if (this._session !== null) {
            layer.plane.material = new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
                color: 0xffffff,
                side: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)
            });
            layer.plane.material.blending = (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2);
            layer.plane.material.blendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
            layer.plane.material.blendSrc = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
            layer.plane.material.blendDst = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
            layer.xrlayer = this._createXRLayer(layer);
            const xrlayers = this._session.renderState.layers;
            xrlayers.unshift(layer.xrlayer);
            this._session.updateRenderState({
                layers: xrlayers
            });
        } else renderTarget.isXRRenderTarget = false;
        return plane;
    }
    /**
	 * Renders the XR layers that have been previously added to the scene.
	 *
	 * This method is usually called in your animation loop before rendering
	 * the actual scene via `renderer.render( scene, camera );`.
	 */ renderLayers() {
        const translationObject = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        const quaternionObject = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)();
        const renderer = this._renderer;
        const wasPresenting = this.isPresenting;
        this.isPresenting = false;
        const rendererSize = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        renderer.getSize(rendererSize);
        const currentRenderTarget = renderer.getRenderTarget();
        for (const layer of this._layers){
            layer.renderTarget.isXRRenderTarget = this._session !== null;
            layer.renderTarget._hasExternalTextures = layer.renderTarget.isXRRenderTarget;
            const currentContextNode = renderer.contextNode;
            let contextNode;
            if (layer.renderTarget.isXRRenderTarget && this._sessionUsesLayers) {
                layer.xrlayer.transform = new XRRigidTransform(layer.plane.getWorldPosition(translationObject), layer.plane.getWorldQuaternion(quaternionObject));
                const glSubImage = this._glBinding.getSubImage(layer.xrlayer, this._xrFrame);
                renderer.backend.setXRRenderTargetTextures(layer.renderTarget, glSubImage.colorTexture, undefined);
                renderer._setXRLayerSize(layer.renderTarget.width, layer.renderTarget.height);
                contextNode = $03ccd63b0299d6a7$var$_contextNodeLib.get(currentContextNode);
                if (contextNode === undefined) {
                    // Apply ToneMapping and OutputColorSpace directly in the material shader
                    contextNode = currentContextNode.context({
                        getOutput: (outputNode)=>{
                            return $03ccd63b0299d6a7$var$renderOutput(outputNode, renderer.toneMapping, renderer.outputColorSpace);
                        }
                    });
                    $03ccd63b0299d6a7$var$_contextNodeLib.set(currentContextNode, contextNode);
                }
            } else contextNode = currentContextNode;
            renderer.contextNode = contextNode;
            renderer.setRenderTarget(layer.renderTarget);
            layer.rendercall();
            renderer.contextNode = currentContextNode;
        }
        renderer.setRenderTarget(currentRenderTarget);
        renderer._setXRLayerSize(rendererSize.x, rendererSize.y);
        this.isPresenting = wasPresenting;
    }
    /**
	 * Returns the current XR session.
	 *
	 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
	 */ getSession() {
        return this._session;
    }
    /**
	 * After a XR session has been requested usually with one of the `*Button` modules, it
	 * is injected into the renderer with this method. This method triggers the start of
	 * the actual XR rendering.
	 *
	 * @async
	 * @param {XRSession} session - The XR session to set.
	 * @return {Promise} A Promise that resolves when the session has been set.
	 */ async setSession(session) {
        const renderer = this._renderer;
        const backend = renderer.backend;
        this._gl = renderer.getContext();
        const gl = this._gl;
        const attributes = gl.getContextAttributes();
        this._session = session;
        if (session !== null) {
            if (backend.isWebGPUBackend === true) throw new Error('THREE.XRManager: XR is currently not supported with a WebGPU backend. Use WebGL by passing "{ forceWebGL: true }" to the constructor of the renderer.');
            session.addEventListener('select', this._onSessionEvent);
            session.addEventListener('selectstart', this._onSessionEvent);
            session.addEventListener('selectend', this._onSessionEvent);
            session.addEventListener('squeeze', this._onSessionEvent);
            session.addEventListener('squeezestart', this._onSessionEvent);
            session.addEventListener('squeezeend', this._onSessionEvent);
            session.addEventListener('end', this._onSessionEnd);
            session.addEventListener('inputsourceschange', this._onInputSourcesChange);
            await backend.makeXRCompatible();
            this._currentPixelRatio = renderer.getPixelRatio();
            renderer.getSize(this._currentSize);
            this._currentAnimationContext = renderer._animation.getContext();
            this._currentAnimationLoop = renderer._animation.getAnimationLoop();
            renderer._animation.stop();
            //
            if (this._supportsLayers === true) {
                // default path using XRProjectionLayer
                let depthFormat = null;
                let depthType = null;
                let glDepthFormat = null;
                if (renderer.depth) {
                    glDepthFormat = renderer.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                    depthFormat = renderer.stencil ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
                    depthType = renderer.stencil ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
                }
                const projectionlayerInit = {
                    colorFormat: gl.RGBA8,
                    depthFormat: glDepthFormat,
                    scaleFactor: this._framebufferScaleFactor,
                    clearOnAccess: false
                };
                if (this._useMultiviewIfPossible && renderer.hasFeature('OVR_multiview2')) {
                    projectionlayerInit.textureType = 'texture-array';
                    this._useMultiview = true;
                }
                this._glBinding = this.getBinding();
                const glProjLayer = this._glBinding.createProjectionLayer(projectionlayerInit);
                const layersArray = [
                    glProjLayer
                ];
                this._glProjLayer = glProjLayer;
                renderer.setPixelRatio(1);
                renderer._setXRLayerSize(glProjLayer.textureWidth, glProjLayer.textureHeight);
                const depth = this._useMultiview ? 2 : 1;
                const depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat, depth);
                this._xrRenderTarget = new $03ccd63b0299d6a7$var$XRRenderTarget(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                    format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
                    type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                    colorSpace: renderer.outputColorSpace,
                    depthTexture: depthTexture,
                    stencilBuffer: renderer.stencil,
                    samples: attributes.antialias ? 4 : 0,
                    resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                    resolveStencilBuffer: glProjLayer.ignoreDepthValues === false,
                    depth: this._useMultiview ? 2 : 1,
                    multiview: this._useMultiview
                });
                this._xrRenderTarget._hasExternalTextures = true;
                this._xrRenderTarget.depth = this._useMultiview ? 2 : 1;
                this._sessionUsesLayers = session.enabledFeatures.includes('layers');
                this._referenceSpace = await session.requestReferenceSpace(this.getReferenceSpaceType());
                if (this._sessionUsesLayers) // switch layers to native
                for (const layer of this._layers){
                    // change material so it "punches" out a hole to show the XR Layer.
                    layer.plane.material = new (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5)({
                        color: 0xffffff,
                        side: layer.type === 'cylinder' ? (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace) : (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901)
                    });
                    layer.plane.material.blending = (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2);
                    layer.plane.material.blendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
                    layer.plane.material.blendSrc = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
                    layer.plane.material.blendDst = (0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d);
                    layer.xrlayer = this._createXRLayer(layer);
                    layersArray.unshift(layer.xrlayer);
                }
                session.updateRenderState({
                    layers: layersArray
                });
            } else {
                // fallback to XRWebGLLayer
                const layerInit = {
                    antialias: renderer.currentSamples > 0,
                    alpha: true,
                    depth: renderer.depth,
                    stencil: renderer.stencil,
                    framebufferScaleFactor: this.getFramebufferScaleFactor()
                };
                const glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                this._glBaseLayer = glBaseLayer;
                session.updateRenderState({
                    baseLayer: glBaseLayer
                });
                renderer.setPixelRatio(1);
                renderer._setXRLayerSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight);
                this._xrRenderTarget = new $03ccd63b0299d6a7$var$XRRenderTarget(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                    format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
                    type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                    colorSpace: renderer.outputColorSpace,
                    stencilBuffer: renderer.stencil,
                    resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                    resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                });
                this._xrRenderTarget._isOpaqueFramebuffer = true;
                this._referenceSpace = await session.requestReferenceSpace(this.getReferenceSpaceType());
            }
            //
            this.setFoveation(this.getFoveation());
            renderer._animation.setAnimationLoop(this._onAnimationFrame);
            renderer._animation.setContext(session);
            renderer._animation.start();
            this.isPresenting = true;
            this.dispatchEvent({
                type: 'sessionstart'
            });
        }
    }
    /**
	 * This method is called by the renderer per frame and updates the XR camera
	 * and it sub cameras based on the given camera. The given camera is the "user"
	 * camera created on application level and used for non-XR rendering.
	 *
	 * @param {PerspectiveCamera} camera - The camera.
	 */ updateCamera(camera) {
        const session = this._session;
        if (session === null) return;
        const depthNear = camera.near;
        const depthFar = camera.far;
        const cameraXR = this._cameraXR;
        const cameraL = this._cameraL;
        const cameraR = this._cameraR;
        cameraXR.near = cameraR.near = cameraL.near = depthNear;
        cameraXR.far = cameraR.far = cameraL.far = depthFar;
        cameraXR.isMultiViewCamera = this._useMultiview;
        if (this._currentDepthNear !== cameraXR.near || this._currentDepthFar !== cameraXR.far) {
            // Note that the new renderState won't apply until the next frame. See #18320
            session.updateRenderState({
                depthNear: cameraXR.near,
                depthFar: cameraXR.far
            });
            this._currentDepthNear = cameraXR.near;
            this._currentDepthFar = cameraXR.far;
        }
        // inherit camera layers and enable eye layers (1 = left, 2 = right)
        cameraXR.layers.mask = camera.layers.mask | 6;
        cameraL.layers.mask = cameraXR.layers.mask & -5;
        cameraR.layers.mask = cameraXR.layers.mask & -3;
        const parent = camera.parent;
        const cameras = cameraXR.cameras;
        $03ccd63b0299d6a7$var$updateCamera(cameraXR, parent);
        for(let i = 0; i < cameras.length; i++)$03ccd63b0299d6a7$var$updateCamera(cameras[i], parent);
        // update projection matrix for proper view frustum culling
        if (cameras.length === 2) $03ccd63b0299d6a7$var$setProjectionFromUnion(cameraXR, cameraL, cameraR);
        else // assume single camera setup (AR)
        cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
        // update user camera and its children
        $03ccd63b0299d6a7$var$updateUserCamera(camera, cameraXR, parent);
    }
    /**
	 * Returns a WebXR controller for the given controller index.
	 *
	 * @private
	 * @param {number} index - The controller index.
	 * @return {WebXRController} The XR controller.
	 */ _getController(index) {
        let controller = this._controllers[index];
        if (controller === undefined) {
            controller = new (0, $9ddd7e9b53f7a2d4$export$cb626c57dcc48b9f)();
            this._controllers[index] = controller;
        }
        return controller;
    }
}
/**
 * Assumes 2 cameras that are parallel and share an X-axis, and that
 * the cameras' projection and world matrices have already been set.
 * And that near and far planes are identical for both cameras.
 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
 *
 * @param {ArrayCamera} camera - The camera to update.
 * @param {PerspectiveCamera} cameraL - The left camera.
 * @param {PerspectiveCamera} cameraR - The right camera.
 */ function $03ccd63b0299d6a7$var$setProjectionFromUnion(camera, cameraL, cameraR) {
    $03ccd63b0299d6a7$var$_cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
    $03ccd63b0299d6a7$var$_cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
    const ipd = $03ccd63b0299d6a7$var$_cameraLPos.distanceTo($03ccd63b0299d6a7$var$_cameraRPos);
    const projL = cameraL.projectionMatrix.elements;
    const projR = cameraR.projectionMatrix.elements;
    // VR systems will have identical far and near planes, and
    // most likely identical top and bottom frustum extents.
    // Use the left camera for these values.
    const near = projL[14] / (projL[10] - 1);
    const far = projL[14] / (projL[10] + 1);
    const topFov = (projL[9] + 1) / projL[5];
    const bottomFov = (projL[9] - 1) / projL[5];
    const leftFov = (projL[8] - 1) / projL[0];
    const rightFov = (projR[8] + 1) / projR[0];
    const left = near * leftFov;
    const right = near * rightFov;
    // Calculate the new camera's position offset from the
    // left camera. xOffset should be roughly half `ipd`.
    const zOffset = ipd / (-leftFov + rightFov);
    const xOffset = zOffset * -leftFov;
    // TODO: Better way to apply this offset?
    cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
    camera.translateX(xOffset);
    camera.translateZ(zOffset);
    camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
    camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    // Check if the projection uses an infinite far plane.
    if (projL[10] === -1) {
        // Use the projection matrix from the left eye.
        // The camera offset is sufficient to include the view volumes
        // of both eyes (assuming symmetric projections).
        camera.projectionMatrix.copy(cameraL.projectionMatrix);
        camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
    } else {
        // Find the union of the frustum values of the cameras and scale
        // the values so that the near plane's position does not change in world space,
        // although must now be relative to the new union camera.
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
    }
}
/**
 * Updates the world matrices for the given camera based on the parent 3D object.
 *
 * @inner
 * @param {Camera} camera - The camera to update.
 * @param {Object3D} parent - The parent 3D object.
 */ function $03ccd63b0299d6a7$var$updateCamera(camera, parent) {
    if (parent === null) camera.matrixWorld.copy(camera.matrix);
    else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
    camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
}
/**
 * Updates the given camera with the transformation of the XR camera and parent object.
 *
 * @inner
 * @param {Camera} camera - The camera to update.
 * @param {ArrayCamera} cameraXR - The XR camera.
 * @param {Object3D} parent - The parent 3D object.
 */ function $03ccd63b0299d6a7$var$updateUserCamera(camera, cameraXR, parent) {
    if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
    else {
        camera.matrix.copy(parent.matrixWorld);
        camera.matrix.invert();
        camera.matrix.multiply(cameraXR.matrixWorld);
    }
    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
    camera.updateMatrixWorld(true);
    camera.projectionMatrix.copy(cameraXR.projectionMatrix);
    camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
    if (camera.isPerspectiveCamera) {
        camera.fov = (0, $9ddd7e9b53f7a2d4$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
        camera.zoom = 1;
    }
}
function $03ccd63b0299d6a7$var$onSessionEvent(event) {
    const controllerIndex = this._controllerInputSources.indexOf(event.inputSource);
    if (controllerIndex === -1) return;
    const controller = this._controllers[controllerIndex];
    if (controller !== undefined) {
        const referenceSpace = this.getReferenceSpace();
        controller.update(event.inputSource, event.frame, referenceSpace);
        controller.dispatchEvent({
            type: event.type,
            data: event.inputSource
        });
    }
}
function $03ccd63b0299d6a7$var$onSessionEnd() {
    const session = this._session;
    const renderer = this._renderer;
    session.removeEventListener('select', this._onSessionEvent);
    session.removeEventListener('selectstart', this._onSessionEvent);
    session.removeEventListener('selectend', this._onSessionEvent);
    session.removeEventListener('squeeze', this._onSessionEvent);
    session.removeEventListener('squeezestart', this._onSessionEvent);
    session.removeEventListener('squeezeend', this._onSessionEvent);
    session.removeEventListener('end', this._onSessionEnd);
    session.removeEventListener('inputsourceschange', this._onInputSourcesChange);
    for(let i = 0; i < this._controllers.length; i++){
        const inputSource = this._controllerInputSources[i];
        if (inputSource === null) continue;
        this._controllerInputSources[i] = null;
        this._controllers[i].disconnect(inputSource);
    }
    this._currentDepthNear = null;
    this._currentDepthFar = null;
    // restore framebuffer/rendering state
    renderer._resetXRState();
    this._session = null;
    this._xrRenderTarget = null;
    this._glBinding = null;
    this._glBaseLayer = null;
    this._glProjLayer = null;
    // switch layers back to emulated
    if (this._sessionUsesLayers === true) for (const layer of this._layers){
        // Recreate layer render target to reset state
        layer.renderTarget = new $03ccd63b0299d6a7$var$XRRenderTarget(layer.pixelwidth, layer.pixelheight, {
            format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
            type: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
            depthTexture: new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)(layer.pixelwidth, layer.pixelheight, layer.stencilBuffer ? (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96), undefined, undefined, undefined, undefined, undefined, undefined, layer.stencilBuffer ? (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829) : (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)),
            stencilBuffer: layer.stencilBuffer,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false
        });
        layer.renderTarget.isXRRenderTarget = false;
        layer.plane.material = layer.material;
        layer.material.map = layer.renderTarget.texture;
        layer.material.map.offset.y = 1;
        layer.material.map.repeat.y = -1;
        delete layer.xrlayer;
    }
    //
    this.isPresenting = false;
    this._useMultiview = false;
    renderer._animation.stop();
    renderer._animation.setAnimationLoop(this._currentAnimationLoop);
    renderer._animation.setContext(this._currentAnimationContext);
    renderer._animation.start();
    renderer.setPixelRatio(this._currentPixelRatio);
    renderer.setSize(this._currentSize.width, this._currentSize.height, false);
    this.dispatchEvent({
        type: 'sessionend'
    });
}
function $03ccd63b0299d6a7$var$onInputSourcesChange(event) {
    const controllers = this._controllers;
    const controllerInputSources = this._controllerInputSources;
    // Notify disconnected
    for(let i = 0; i < event.removed.length; i++){
        const inputSource = event.removed[i];
        const index = controllerInputSources.indexOf(inputSource);
        if (index >= 0) {
            controllerInputSources[index] = null;
            controllers[index].disconnect(inputSource);
        }
    }
    // Notify connected
    for(let i = 0; i < event.added.length; i++){
        const inputSource = event.added[i];
        let controllerIndex = controllerInputSources.indexOf(inputSource);
        if (controllerIndex === -1) {
            // Assign input source a controller that currently has no input source
            for(let i = 0; i < controllers.length; i++){
                if (i >= controllerInputSources.length) {
                    controllerInputSources.push(inputSource);
                    controllerIndex = i;
                    break;
                } else if (controllerInputSources[i] === null) {
                    controllerInputSources[i] = inputSource;
                    controllerIndex = i;
                    break;
                }
            }
            // If all controllers do currently receive input we ignore new ones
            if (controllerIndex === -1) break;
        }
        const controller = controllers[controllerIndex];
        if (controller) controller.connect(inputSource);
    }
}
// Creation method for native WebXR layers
function $03ccd63b0299d6a7$var$createXRLayer(layer) {
    if (layer.type === 'quad') return this._glBinding.createQuadLayer({
        transform: new XRRigidTransform(layer.translation, layer.quaternion),
        width: layer.width / 2,
        height: layer.height / 2,
        space: this._referenceSpace,
        viewPixelWidth: layer.pixelwidth,
        viewPixelHeight: layer.pixelheight,
        clearOnAccess: false
    });
    else return this._glBinding.createCylinderLayer({
        transform: new XRRigidTransform(layer.translation, layer.quaternion),
        radius: layer.radius,
        centralAngle: layer.centralAngle,
        aspectRatio: layer.aspectRatio,
        space: this._referenceSpace,
        viewPixelWidth: layer.pixelwidth,
        viewPixelHeight: layer.pixelheight,
        clearOnAccess: false
    });
}
// Animation Loop
function $03ccd63b0299d6a7$var$onAnimationFrame(time, frame) {
    if (frame === undefined) return;
    const cameraXR = this._cameraXR;
    const renderer = this._renderer;
    const backend = renderer.backend;
    const glBaseLayer = this._glBaseLayer;
    const referenceSpace = this.getReferenceSpace();
    const pose = frame.getViewerPose(referenceSpace);
    this._xrFrame = frame;
    if (pose !== null) {
        const views = pose.views;
        if (this._glBaseLayer !== null) backend.setXRTarget(glBaseLayer.framebuffer);
        let cameraXRNeedsUpdate = false;
        // check if it's necessary to rebuild cameraXR's camera list
        if (views.length !== cameraXR.cameras.length) {
            cameraXR.cameras.length = 0;
            cameraXRNeedsUpdate = true;
        }
        for(let i = 0; i < views.length; i++){
            const view = views[i];
            let viewport;
            if (this._supportsLayers === true) {
                const glSubImage = this._glBinding.getViewSubImage(this._glProjLayer, view);
                viewport = glSubImage.viewport;
                // For side-by-side projection, we only produce a single texture for both eyes.
                if (i === 0) backend.setXRRenderTargetTextures(this._xrRenderTarget, glSubImage.colorTexture, this._glProjLayer.ignoreDepthValues && !this._useMultiview ? undefined : glSubImage.depthStencilTexture);
            } else viewport = glBaseLayer.getViewport(view);
            let camera = this._cameras[i];
            if (camera === undefined) {
                camera = new (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7)();
                camera.layers.enable(i);
                camera.viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
                this._cameras[i] = camera;
            }
            camera.matrix.fromArray(view.transform.matrix);
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.projectionMatrix.fromArray(view.projectionMatrix);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
            if (i === 0) {
                cameraXR.matrix.copy(camera.matrix);
                cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
            }
            if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
        }
        renderer.setOutputRenderTarget(this._xrRenderTarget);
    }
    //
    for(let i = 0; i < this._controllers.length; i++){
        const inputSource = this._controllerInputSources[i];
        const controller = this._controllers[i];
        if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, referenceSpace);
    }
    if (this._currentAnimationLoop) this._currentAnimationLoop(time, frame);
    if (frame.detectedPlanes) this.dispatchEvent({
        type: 'planesdetected',
        data: frame
    });
    this._xrFrame = null;
}
/**
 * CanvasTarget is a class that represents the final output destination of the renderer.
 *
 * @augments EventDispatcher
 */ class $03ccd63b0299d6a7$export$f3b3d4d0fe604238 extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    /**
	 * Constructs a new CanvasTarget.
	 *
	 * @param {HTMLCanvasElement|OffscreenCanvas} domElement - The canvas element to render to.
	 */ constructor(domElement){
        super();
        /**
		 * A reference to the canvas element the renderer is drawing to.
		 * This value of this property will automatically be created by
		 * the renderer.
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = domElement;
        /**
		 * The renderer's pixel ratio.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._pixelRatio = 1;
        /**
		 * The width of the renderer's default framebuffer in logical pixel unit.
		 *
		 * @private
		 * @type {number}
		 */ this._width = this.domElement.width;
        /**
		 * The height of the renderer's default framebuffer in logical pixel unit.
		 *
		 * @private
		 * @type {number}
		 */ this._height = this.domElement.height;
        /**
		 * The viewport of the renderer in logical pixel unit.
		 *
		 * @private
		 * @type {Vector4}
		 */ this._viewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(0, 0, this._width, this._height);
        /**
		 * The scissor rectangle of the renderer in logical pixel unit.
		 *
		 * @private
		 * @type {Vector4}
		 */ this._scissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)(0, 0, this._width, this._height);
        /**
		 * Whether the scissor test should be enabled or not.
		 *
		 * @private
		 * @type {boolean}
		 */ this._scissorTest = false;
        /**
		 * The color texture of the default framebuffer.
		 *
		 * @type {FramebufferTexture}
		 */ this.colorTexture = new (0, $9ddd7e9b53f7a2d4$export$9270d786f73ce6fe)();
        /**
		 * The depth texture of the default framebuffer.
		 *
		 * @type {DepthTexture}
		 */ this.depthTexture = new (0, $9ddd7e9b53f7a2d4$export$fc830aa069cc8c2f)();
    }
    /**
	 * Returns the pixel ratio.
	 *
	 * @return {number} The pixel ratio.
	 */ getPixelRatio() {
        return this._pixelRatio;
    }
    /**
	 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize(target) {
        return target.set(this._width * this._pixelRatio, this._height * this._pixelRatio).floor();
    }
    /**
	 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The renderer's size in logical pixels.
	 */ getSize(target) {
        return target.set(this._width, this._height);
    }
    /**
	 * Sets the given pixel ratio and resizes the canvas if necessary.
	 *
	 * @param {number} [value=1] - The pixel ratio.
	 */ setPixelRatio(value = 1) {
        if (this._pixelRatio === value) return;
        this._pixelRatio = value;
        this.setSize(this._width, this._height, false);
    }
    /**
	 * This method allows to define the drawing buffer size by specifying
	 * width, height and pixel ratio all at once. The size of the drawing
	 * buffer is computed with this formula:
	 * ```js
	 * size.x = width * pixelRatio;
	 * size.y = height * pixelRatio;
	 * ```
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {number} pixelRatio - The pixel ratio.
	 */ setDrawingBufferSize(width, height, pixelRatio) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._width = width;
        this._height = height;
        this._pixelRatio = pixelRatio;
        this.domElement.width = Math.floor(width * pixelRatio);
        this.domElement.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
        this._dispatchResize();
    }
    /**
	 * Sets the size of the renderer.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
	 */ setSize(width, height, updateStyle = true) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._width = width;
        this._height = height;
        this.domElement.width = Math.floor(width * this._pixelRatio);
        this.domElement.height = Math.floor(height * this._pixelRatio);
        if (updateStyle === true) {
            this.domElement.style.width = width + 'px';
            this.domElement.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
        this._dispatchResize();
    }
    /**
	 * Returns the scissor rectangle.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The scissor rectangle.
	 */ getScissor(target) {
        const scissor = this._scissor;
        target.x = scissor.x;
        target.y = scissor.y;
        target.width = scissor.width;
        target.height = scissor.height;
        return target;
    }
    /**
	 * Defines the scissor rectangle.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the lower left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        const scissor = this._scissor;
        if (x.isVector4) scissor.copy(x);
        else scissor.set(x, y, width, height);
    }
    /**
	 * Returns the scissor test value.
	 *
	 * @return {boolean} Whether the scissor test should be enabled or not.
	 */ getScissorTest() {
        return this._scissorTest;
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        this._scissorTest = boolean;
    }
    /**
	 * Returns the viewport definition.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The viewport definition.
	 */ getViewport(target) {
        return target.copy(this._viewport);
    }
    /**
	 * Defines the viewport.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
	 * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
	 */ setViewport(x, y, width, height, minDepth = 0, maxDepth = 1) {
        const viewport = this._viewport;
        if (x.isVector4) viewport.copy(x);
        else viewport.set(x, y, width, height);
        viewport.minDepth = minDepth;
        viewport.maxDepth = maxDepth;
    }
    /**
	 * Dispatches the resize event.
	 *
	 * @private
	 */ _dispatchResize() {
        this.dispatchEvent({
            type: 'resize'
        });
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $03ccd63b0299d6a7$var$_scene = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$38af1803e3442a7f)();
const $03ccd63b0299d6a7$var$_drawingBufferSize = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $03ccd63b0299d6a7$var$_screen = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
const $03ccd63b0299d6a7$var$_frustum = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$35efe6f4c85463d2)();
const $03ccd63b0299d6a7$var$_frustumArray = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2d7d04327620499c)();
const $03ccd63b0299d6a7$var$_projScreenMatrix = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$2ae72fc923e5eb5)();
const $03ccd63b0299d6a7$var$_vector4 = /*@__PURE__*/ new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
const $03ccd63b0299d6a7$var$_shadowSide = {
    [(0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901)]: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
    [(0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace)]: (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901),
    [(0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03)]: (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03)
};
/**
 * Base class for renderers.
 */ class $03ccd63b0299d6a7$var$Renderer {
    /**
	 * Renderer options.
	 *
	 * @typedef {Object} Renderer~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [reversedDepthBuffer=false] - Whether reversed depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. This parameter can set to any other integer value than 0
	 * to overwrite the default.
	 * @property {?Function} [getFallback=null] - This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
	 * @property {number} [outputBufferType=HalfFloatType] - Defines the type of output buffers. The default `HalfFloatType` is recommend for best
	 * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
	 * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
	 */ /**
	 * Constructs a new renderer.
	 *
	 * @param {Backend} backend - The backend the renderer is targeting (e.g. WebGPU or WebGL 2).
	 * @param {Renderer~Options} [parameters] - The configuration parameter.

	 */ constructor(backend, parameters = {}){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderer = true;
        //
        const { logarithmicDepthBuffer: logarithmicDepthBuffer = false, reversedDepthBuffer: reversedDepthBuffer = false, alpha: alpha = true, depth: depth = true, stencil: stencil = false, antialias: antialias = false, samples: samples = 0, getFallback: getFallback = null, outputBufferType: outputBufferType = (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc), multiview: multiview = false } = parameters;
        /**
		 * A reference to the current backend.
		 *
		 * @type {Backend}
		 */ this.backend = backend;
        /**
		 * Whether the renderer should automatically clear the current rendering target
		 * before execute a `render()` call. The target can be the canvas (default framebuffer)
		 * or the current bound render target (custom framebuffer).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the color buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the depth buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * When `autoClear` is set to `true`, this property defines whether the renderer
		 * should clear the stencil buffer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        /**
		 * Whether the default framebuffer should be transparent or opaque.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.alpha = alpha;
        /**
		 * Whether logarithmic depth buffer is enabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.logarithmicDepthBuffer = logarithmicDepthBuffer;
        /**
		 * Whether reversed depth buffer is enabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.reversedDepthBuffer = reversedDepthBuffer;
        /**
		 * Defines the output color space of the renderer.
		 *
		 * @type {string}
		 * @default SRGBColorSpace
		 */ this.outputColorSpace = (0, $9ddd7e9b53f7a2d4$export$561f394b24edfcaa);
        /**
		 * Defines the tone mapping of the renderer.
		 *
		 * @type {number}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        /**
		 * Defines the tone mapping exposure.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        /**
		 * Whether the renderer should sort its render lists or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some degree of transparency.
		 * By definition, sorting objects may not work in all cases. Depending on the needs of application,
		 * it may be necessary to turn off sorting and use other methods to deal with transparency rendering
		 * e.g. manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * Whether the default framebuffer should have a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depth = depth;
        /**
		 * Whether the default framebuffer should have a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencil = stencil;
        /**
		 * Holds a series of statistical information about the GPU memory
		 * and the rendering process. Useful for debugging and monitoring.
		 *
		 * @type {Info}
		 */ this.info = new $03ccd63b0299d6a7$var$Info();
        /**
		 * A global context node that stores override nodes for specific transformations or calculations.
		 * These nodes can be used to replace default behavior in the rendering pipeline.
		 *
		 * @type {ContextNode}
		 * @property {Object} value - The context value object.
		 */ this.contextNode = $03ccd63b0299d6a7$var$context();
        /**
		 * The node library defines how certain library objects like materials, lights
		 * or tone mapping functions are mapped to node types. This is required since
		 * although instances of classes like `MeshBasicMaterial` or `PointLight` can
		 * be part of the scene graph, they are internally represented as nodes for
		 * further processing.
		 *
		 * @type {NodeLibrary}
		 */ this.library = new $03ccd63b0299d6a7$var$NodeLibrary();
        /**
		 * A map-like data structure for managing lights.
		 *
		 * @type {Lighting}
		 */ this.lighting = new $03ccd63b0299d6a7$export$10b79c914aa1f585();
        // internals
        /**
		 * The number of MSAA samples.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._samples = samples || antialias === true ? 4 : 0;
        /**
		 * OnCanvasTargetResize callback function.
		 *
		 * @private
		 * @type {Function}
		 */ this._onCanvasTargetResize = this._onCanvasTargetResize.bind(this);
        /**
		 * The canvas target for rendering.
		 *
		 * @private
		 * @type {CanvasTarget}
		 */ this._canvasTarget = new $03ccd63b0299d6a7$export$f3b3d4d0fe604238(backend.getDomElement());
        this._canvasTarget.addEventListener('resize', this._onCanvasTargetResize);
        this._canvasTarget.isDefaultCanvasTarget = true;
        /**
		 * The inspector provides information about the internal renderer state.
		 *
		 * @private
		 * @type {InspectorBase}
		 */ this._inspector = new $03ccd63b0299d6a7$export$660a27ce99fa210b();
        this._inspector.setRenderer(this);
        /**
		 * This callback function can be used to provide a fallback backend, if the primary backend can't be targeted.
		 *
		 * @private
		 * @type {?Function}
		 */ this._getFallback = getFallback;
        /**
		 * A reference to a renderer module for managing shader attributes.
		 *
		 * @private
		 * @type {?Attributes}
		 * @default null
		 */ this._attributes = null;
        /**
		 * A reference to a renderer module for managing geometries.
		 *
		 * @private
		 * @type {?Geometries}
		 * @default null
		 */ this._geometries = null;
        /**
		 * A reference to a renderer module for managing node related logic.
		 *
		 * @private
		 * @type {?NodeManager}
		 * @default null
		 */ this._nodes = null;
        /**
		 * A reference to a renderer module for managing the internal animation loop.
		 *
		 * @private
		 * @type {?Animation}
		 * @default null
		 */ this._animation = null;
        /**
		 * A reference to a renderer module for managing shader program bindings.
		 *
		 * @private
		 * @type {?Bindings}
		 * @default null
		 */ this._bindings = null;
        /**
		 * A reference to a renderer module for managing render objects.
		 *
		 * @private
		 * @type {?RenderObjects}
		 * @default null
		 */ this._objects = null;
        /**
		 * A reference to a renderer module for managing render and compute pipelines.
		 *
		 * @private
		 * @type {?Pipelines}
		 * @default null
		 */ this._pipelines = null;
        /**
		 * A reference to a renderer module for managing render bundles.
		 *
		 * @private
		 * @type {?RenderBundles}
		 * @default null
		 */ this._bundles = null;
        /**
		 * A reference to a renderer module for managing render lists.
		 *
		 * @private
		 * @type {?RenderLists}
		 * @default null
		 */ this._renderLists = null;
        /**
		 * A reference to a renderer module for managing render contexts.
		 *
		 * @private
		 * @type {?RenderContexts}
		 * @default null
		 */ this._renderContexts = null;
        /**
		 * A reference to a renderer module for managing textures.
		 *
		 * @private
		 * @type {?Textures}
		 * @default null
		 */ this._textures = null;
        /**
		 * A reference to a renderer module for backgrounds.
		 *
		 * @private
		 * @type {?Background}
		 * @default null
		 */ this._background = null;
        /**
		 * Cache for the fullscreen quad.
		 * This fullscreen quad is used for internal render passes
		 * like the tone mapping and color space output pass.
		 *
		 * @private
		 * @type {Map<Texture,QuadMesh>}
		 */ this._quadCache = new Map();
        /**
		 * A reference to the current render context.
		 *
		 * @private
		 * @type {?RenderContext}
		 * @default null
		 */ this._currentRenderContext = null;
        /**
		 * A custom sort function for the opaque render list.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._opaqueSort = null;
        /**
		 * A custom sort function for the transparent render list.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._transparentSort = null;
        /**
		 * Cache of framebuffer targets per canvas target.
		 *
		 * @private
		 * @type {Map<CanvasTarget, RenderTarget>}
		 */ this._frameBufferTargets = new Map();
        const alphaClear = this.alpha === true ? 0 : 1;
        /**
		 * The clear color value.
		 *
		 * @private
		 * @type {Color4}
		 */ this._clearColor = new $03ccd63b0299d6a7$var$Color4(0, 0, 0, alphaClear);
        /**
		 * The clear depth value.
		 *
		 * @private
		 * @type {number}
		 * @default 1
		 */ this._clearDepth = 1;
        /**
		 * The clear stencil value.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._clearStencil = 0;
        /**
		 * The current render target.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._renderTarget = null;
        /**
		 * The active cube face.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._activeCubeFace = 0;
        /**
		 * The active mipmap level.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._activeMipmapLevel = 0;
        /**
		 * The current output render target.
		 *
		 * @private
		 * @type {?RenderTarget}
		 * @default null
		 */ this._outputRenderTarget = null;
        /**
		 * The MRT setting.
		 *
		 * @private
		 * @type {?MRTNode}
		 * @default null
		 */ this._mrt = null;
        /**
		 * This function defines how a render object is going
		 * to be rendered.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._renderObjectFunction = null;
        /**
		 * Used to keep track of the current render object function.
		 *
		 * @private
		 * @type {?Function}
		 * @default null
		 */ this._currentRenderObjectFunction = null;
        /**
		 * Used to keep track of the current render bundle.
		 *
		 * @private
		 * @type {?RenderBundle}
		 * @default null
		 */ this._currentRenderBundle = null;
        /**
		 * Next to `_renderObjectFunction()`, this function provides another hook
		 * for influencing the render process of a render object. It is meant for internal
		 * use and only relevant for `compileAsync()` right now. Instead of using
		 * the default logic of `_renderObjectDirect()` which actually draws the render object,
		 * a different function might be used which performs no draw but just the node
		 * and pipeline updates.
		 *
		 * @private
		 * @type {Function}
		 */ this._handleObjectFunction = this._renderObjectDirect;
        /**
		 * Indicates whether the device has been lost or not. In WebGL terms, the device
		 * lost is considered as a context lost. When this is set to `true`, rendering
		 * isn't possible anymore.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._isDeviceLost = false;
        /**
		 * A callback function that defines what should happen when a device/context lost occurs.
		 *
		 * @type {Function}
		 */ this.onDeviceLost = this._onDeviceLost;
        /**
		 * Defines the type of output buffers. The default `HalfFloatType` is recommend for
		 * best quality. To save memory and bandwidth, `UnsignedByteType` might be used.
		 * This will reduce rendering quality though.
		 *
		 * @private
		 * @type {number}
		 * @default HalfFloatType
		 */ this._outputBufferType = outputBufferType;
        /**
		 * A cache for shadow nodes per material
		 *
		 * @private
		 * @type {WeakMap<Material, Object>}
		 */ this._cacheShadowNodes = new WeakMap();
        /**
		 * Whether the renderer has been initialized or not.
		 *
		 * @private
		 * @type {boolean}
		 * @default false
		 */ this._initialized = false;
        /**
		 * The call depth of the renderer. Counts the number of
		 * nested render calls.
		 *
		 * @private
		 * @type {number}
		 * @default - 1
		 */ this._callDepth = -1;
        /**
		 * A reference to the promise which initializes the renderer.
		 *
		 * @private
		 * @type {?Promise<this>}
		 * @default null
		 */ this._initPromise = null;
        /**
		 * An array of compilation promises which are used in `compileAsync()`.
		 *
		 * @private
		 * @type {?Array<Promise>}
		 * @default null
		 */ this._compilationPromises = null;
        /**
		 * Whether the renderer should render transparent render objects or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the renderer should render opaque render objects or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.opaque = true;
        /**
		 * Shadow map configuration
		 * @typedef {Object} ShadowMapConfig
		 * @property {boolean} enabled - Whether to globally enable shadows or not.
		 * @property {boolean} transmitted - Whether to enable light transmission through non-opaque materials.
		 * @property {number} type - The shadow map type.
		 */ /**
		 * The renderer's shadow configuration.
		 *
		 * @type {ShadowMapConfig}
		 */ this.shadowMap = {
            enabled: false,
            transmitted: false,
            type: (0, $9ddd7e9b53f7a2d4$export$5813f879eee7cd88)
        };
        /**
		 * XR configuration.
		 * @typedef {Object} XRConfig
		 * @property {boolean} enabled - Whether to globally enable XR or not.
		 */ /**
		 * The renderer's XR manager.
		 *
		 * @type {XRManager}
		 */ this.xr = new $03ccd63b0299d6a7$var$XRManager(this, multiview);
        /**
		 * Debug configuration.
		 * @typedef {Object} DebugConfig
		 * @property {boolean} checkShaderErrors - Whether shader errors should be checked or not.
		 * @property {?Function} onShaderError - A callback function that is executed when a shader error happens. Only supported with WebGL 2 right now.
		 * @property {Function} getShaderAsync - Allows the get the raw shader code for the given scene, camera and 3D object.
		 */ /**
		 * The renderer's debug configuration.
		 *
		 * @type {DebugConfig}
		 */ this.debug = {
            checkShaderErrors: true,
            onShaderError: null,
            getShaderAsync: async (scene, camera, object)=>{
                await this.compileAsync(scene, camera);
                const renderList = this._renderLists.get(scene, camera);
                const renderContext = this._renderContexts.get(this._renderTarget, this._mrt);
                const material = scene.overrideMaterial || object.material;
                const renderObject = this._objects.get(object, material, scene, camera, renderList.lightsNode, renderContext, renderContext.clippingContext);
                const { fragmentShader: fragmentShader, vertexShader: vertexShader } = renderObject.getNodeBuilderState();
                return {
                    fragmentShader: fragmentShader,
                    vertexShader: vertexShader
                };
            }
        };
    }
    /**
	 * Initializes the renderer so it is ready for usage.
	 *
	 * @async
	 * @return {Promise<this>} A Promise that resolves when the renderer has been initialized.
	 */ async init() {
        if (this._initPromise !== null) return this._initPromise;
        this._initPromise = new Promise(async (resolve, reject)=>{
            let backend = this.backend;
            try {
                await backend.init(this);
            } catch (error) {
                if (this._getFallback !== null) // try the fallback
                try {
                    this.backend = backend = this._getFallback(error);
                    await backend.init(this);
                } catch (error) {
                    reject(error);
                    return;
                }
                else {
                    reject(error);
                    return;
                }
            }
            this._nodes = new $03ccd63b0299d6a7$var$NodeManager(this, backend);
            this._animation = new $03ccd63b0299d6a7$var$Animation(this, this._nodes, this.info);
            this._attributes = new $03ccd63b0299d6a7$var$Attributes(backend, this.info);
            this._background = new $03ccd63b0299d6a7$var$Background(this, this._nodes);
            this._geometries = new $03ccd63b0299d6a7$var$Geometries(this._attributes, this.info);
            this._textures = new $03ccd63b0299d6a7$var$Textures(this, backend, this.info);
            this._pipelines = new $03ccd63b0299d6a7$var$Pipelines(backend, this._nodes, this.info);
            this._bindings = new $03ccd63b0299d6a7$var$Bindings(backend, this._nodes, this._textures, this._attributes, this._pipelines, this.info);
            this._objects = new $03ccd63b0299d6a7$var$RenderObjects(this, this._nodes, this._geometries, this._pipelines, this._bindings, this.info);
            this._renderLists = new $03ccd63b0299d6a7$var$RenderLists(this.lighting);
            this._bundles = new $03ccd63b0299d6a7$var$RenderBundles();
            this._renderContexts = new $03ccd63b0299d6a7$var$RenderContexts(this);
            //
            this._animation.start();
            this._initialized = true;
            //
            this._inspector.init();
            //
            resolve(this);
        });
        return this._initPromise;
    }
    /**
	 * A reference to the canvas element the renderer is drawing to.
	 * This value of this property will automatically be created by
	 * the renderer.
	 *
	 * @type {HTMLCanvasElement|OffscreenCanvas}
	 */ get domElement() {
        return this._canvasTarget.domElement;
    }
    /**
	 * The coordinate system of the renderer. The value of this property
	 * depends on the selected backend. Either `THREE.WebGLCoordinateSystem` or
	 * `THREE.WebGPUCoordinateSystem`.
	 *
	 * @readonly
	 * @type {number}
	 */ get coordinateSystem() {
        return this.backend.coordinateSystem;
    }
    /**
	 * Compiles all materials in the given scene. This can be useful to avoid a
	 * phenomenon which is called "shader compilation stutter", which occurs when
	 * rendering an object with a new shader for the first time.
	 *
	 * If you want to add a 3D object to an existing scene, use the third optional
	 * parameter for applying the target scene. Note that the (target) scene's lighting
	 * and environment must be configured before calling this method.
	 *
	 * @async
	 * @param {Object3D} scene - The scene or 3D object to precompile.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {?Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
	 * @return {Promise} A Promise that resolves when the compile has been finished.
	 */ async compileAsync(scene, camera, targetScene = null) {
        if (this._isDeviceLost === true) return;
        if (this._initialized === false) await this.init();
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        const previousHandleObjectFunction = this._handleObjectFunction;
        const previousCompilationPromises = this._compilationPromises;
        //
        if (targetScene === null) targetScene = scene;
        // Use the actual scene for caching when compiling individual objects
        // This ensures cache keys match between compileAsync and render
        const sceneRef = scene.isScene === true ? scene : targetScene.isScene === true ? targetScene : $03ccd63b0299d6a7$var$_scene;
        // Match render()'s logic: use frameBufferTarget when needsFrameBufferTarget is true
        const useFrameBufferTarget = this.needsFrameBufferTarget && this._renderTarget === null;
        const renderTarget = useFrameBufferTarget ? this._getFrameBufferTarget() : this._renderTarget || this._outputRenderTarget;
        const renderContext = this._renderContexts.get(renderTarget, this._mrt);
        const activeMipmapLevel = this._activeMipmapLevel;
        const compilationPromises = [];
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this.renderObject;
        this._handleObjectFunction = this._createObjectPipeline;
        this._compilationPromises = compilationPromises;
        nodeFrame.renderId++;
        //
        nodeFrame.update();
        //
        renderContext.depth = this.depth;
        renderContext.stencil = this.stencil;
        if (!renderContext.clippingContext) renderContext.clippingContext = new $03ccd63b0299d6a7$var$ClippingContext();
        renderContext.clippingContext.updateGlobal(sceneRef, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        // Use sceneRef for render list to ensure lightsNode matches between compileAsync and render
        const renderList = this._renderLists.get(sceneRef, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList, renderContext.clippingContext);
        // include lights from target scene
        if (targetScene !== scene) targetScene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) renderList.pushLight(object);
        });
        renderList.finish();
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
        }
        //
        if (targetScene !== scene) this._background.update(targetScene, renderList, renderContext);
        else this._background.update(sceneRef, renderList, renderContext);
        // process render lists - _createObjectPipeline will push async promises to _compilationPromises
        const opaqueObjects = renderList.opaque;
        const transparentObjects = renderList.transparent;
        const transparentDoublePassObjects = renderList.transparentDoublePass;
        const lightsNode = renderList.lightsNode;
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        this._handleObjectFunction = previousHandleObjectFunction;
        this._compilationPromises = previousCompilationPromises;
        // Process compilation work items sequentially to avoid freezing
        // Yields between objects to keep animation smooth
        for (const item of compilationPromises){
            const renderObject = this._objects.get(item.object, item.material, item.scene, item.camera, item.lightsNode, item.renderContext, item.clippingContext, item.passId);
            renderObject.drawRange = item.object.geometry.drawRange;
            renderObject.group = item.group;
            this._geometries.updateForRender(renderObject);
            // Use async node building to yield to main thread
            await this._nodes.getForRenderAsync(renderObject);
            this._nodes.updateBefore(renderObject);
            this._nodes.updateForRender(renderObject);
            this._bindings.updateForRender(renderObject);
            // Wait for pipeline creation
            const pipelinePromises = [];
            this._pipelines.getForRender(renderObject, pipelinePromises);
            if (pipelinePromises.length > 0) await Promise.all(pipelinePromises);
            this._nodes.updateAfter(renderObject);
            // Yield between objects to allow animation frames
            await (0, $9ddd7e9b53f7a2d4$export$8af9927c09321dd4)();
        }
    }
    /**
	 * Renders the scene in an async fashion.
	 *
	 * @async
	 * @deprecated
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera.
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync(scene, camera) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.render(scene, camera);
    }
    /**
	 * Can be used to synchronize CPU operations with GPU tasks. So when this method is called,
	 * the CPU waits for the GPU to complete its operation (e.g. a compute task).
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when synchronization has been finished.
	 */ async waitForGPU() {
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Renderer: waitForGPU() has been removed. Read https://github.com/mrdoob/three.js/issues/32012 for more information.');
    }
    //
    set inspector(value) {
        if (this._inspector !== null) this._inspector.setRenderer(null);
        this._inspector = value;
        this._inspector.setRenderer(this);
    }
    /**
	 * The inspector instance. The inspector can be any class that extends from `InspectorBase`.
	 *
	 * @type {InspectorBase}
	 */ get inspector() {
        return this._inspector;
    }
    /**
	 * Enables or disables high precision for model-view and normal-view matrices.
	 * When enabled, will use CPU 64-bit precision for higher precision instead of GPU 32-bit for higher performance.
	 *
	 * NOTE: 64-bit precision is not compatible with `InstancedMesh` and `SkinnedMesh`.
	 *
	 * @param {boolean} value - Whether to enable or disable high precision.
	 * @type {boolean}
	 */ set highPrecision(value) {
        const contextNodeData = this.contextNode.value;
        if (value === true) {
            contextNodeData.modelViewMatrix = $03ccd63b0299d6a7$var$highpModelViewMatrix;
            contextNodeData.modelNormalViewMatrix = $03ccd63b0299d6a7$var$highpModelNormalViewMatrix;
        } else if (this.highPrecision) {
            delete contextNodeData.modelViewMatrix;
            delete contextNodeData.modelNormalViewMatrix;
        }
    }
    /**
	 * Returns whether high precision is enabled or not.
	 *
	 * @return {boolean} Whether high precision is enabled or not.
	 * @type {boolean}
	 */ get highPrecision() {
        const contextNodeData = this.contextNode.value;
        return contextNodeData.modelViewMatrix === $03ccd63b0299d6a7$var$highpModelViewMatrix && contextNodeData.modelNormalViewMatrix === $03ccd63b0299d6a7$var$highpModelNormalViewMatrix;
    }
    /**
	 * Sets the given MRT configuration.
	 *
	 * @param {MRTNode} mrt - The MRT node to set.
	 * @return {Renderer} A reference to this renderer.
	 */ setMRT(mrt) {
        this._mrt = mrt;
        return this;
    }
    /**
	 * Returns the MRT configuration.
	 *
	 * @return {MRTNode} The MRT configuration.
	 */ getMRT() {
        return this._mrt;
    }
    /**
	 * Returns the output buffer type.
	 *
	 * @return {number} The output buffer type.
	 */ getOutputBufferType() {
        return this._outputBufferType;
    }
    /**
	 * Returns the output buffer type.
	 *
	 * @deprecated since r182. Use `.getOutputBufferType()` instead.
	 * @return {number} The output buffer type.
	 */ getColorBufferType() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: ".getColorBufferType()" has been renamed to ".getOutputBufferType()".');
        return this.getOutputBufferType();
    }
    /**
	 * Default implementation of the device lost callback.
	 *
	 * @private
	 * @param {Object} info - Information about the context lost.
	 */ _onDeviceLost(info) {
        let errorMessage = `THREE.WebGPURenderer: ${info.api} Device Lost:\n\nMessage: ${info.message}`;
        if (info.reason) errorMessage += `\nReason: ${info.reason}`;
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(errorMessage);
        this._isDeviceLost = true;
    }
    /**
	 * Renders the given render bundle.
	 *
	 * @private
	 * @param {Object} bundle - Render bundle data.
	 * @param {Scene} sceneRef - The scene the render bundle belongs to.
	 * @param {LightsNode} lightsNode - The lights node.
	 */ _renderBundle(bundle, sceneRef, lightsNode) {
        const { bundleGroup: bundleGroup, camera: camera, renderList: renderList } = bundle;
        const renderContext = this._currentRenderContext;
        //
        const renderBundle = this._bundles.get(bundleGroup, camera, renderContext);
        const renderBundleData = this.backend.get(renderBundle);
        const needsUpdate = bundleGroup.version !== renderBundleData.version;
        const renderBundleNeedsUpdate = needsUpdate || renderBundleData.bundleGPU === undefined;
        if (renderBundleNeedsUpdate) {
            this.backend.beginBundle(renderContext);
            if (renderBundleData.renderObjects === undefined || needsUpdate) renderBundleData.renderObjects = [];
            this._currentRenderBundle = renderBundle;
            const { transparentDoublePass: transparentDoublePassObjects, transparent: transparentObjects, opaque: opaqueObjects } = renderList;
            if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
            if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
            this._currentRenderBundle = null;
            //
            this.backend.finishBundle(renderContext, renderBundle);
            renderBundleData.version = bundleGroup.version;
        } else {
            const { renderObjects: renderObjects } = renderBundleData;
            for(let i = 0, l = renderObjects.length; i < l; i++){
                const renderObject = renderObjects[i];
                if (this._nodes.needsRefresh(renderObject)) {
                    this._nodes.updateBefore(renderObject);
                    this._nodes.updateForRender(renderObject);
                    this._bindings.updateForRender(renderObject);
                    this._nodes.updateAfter(renderObject);
                }
            }
        }
        this.backend.addBundle(renderContext, renderBundle);
    }
    /**
	 * Renders the scene or 3D object with the given camera. This method can only be called
	 * if the renderer has been initialized. When using `render()` inside an animation loop,
	 * it's guaranteed the renderer will be initialized. The animation loop must be defined
	 * with {@link Renderer#setAnimationLoop} though.
	 *
	 * For all other use cases (like when using on-demand rendering), you must call
	 * {@link Renderer#init} before rendering.
	 *
	 * The target of the method is the default framebuffer (meaning the canvas)
	 * or alternatively a render target when specified via `setRenderTarget()`.
	 *
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera to render the scene with.
	 */ render(scene, camera) {
        if (this._initialized === false) throw new Error('Renderer: .render() called before the backend is initialized. Use "await renderer.init();" before rendering.');
        this._renderScene(scene, camera);
    }
    /**
	 * Returns whether the renderer has been initialized or not.
	 *
	 * @readonly
	 * @return {boolean} Whether the renderer has been initialized or not.
	 */ get initialized() {
        return this._initialized;
    }
    /**
	 * Returns an internal render target which is used when computing the output tone mapping
	 * and color space conversion. Unlike in `WebGLRenderer`, this is done in a separate render
	 * pass and not inline to achieve more correct results.
	 *
	 * @private
	 * @return {?RenderTarget} The render target. The method returns `null` if no output conversion should be applied.
	 */ _getFrameBufferTarget() {
        const { currentToneMapping: currentToneMapping, currentColorSpace: currentColorSpace } = this;
        const useToneMapping = currentToneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        const useColorSpace = currentColorSpace !== (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
        if (useToneMapping === false && useColorSpace === false) return null;
        const { width: width, height: height } = this.getDrawingBufferSize($03ccd63b0299d6a7$var$_drawingBufferSize);
        const { depth: depth, stencil: stencil } = this;
        // TODO: Unify CanvasTarget and OutputRenderTarget
        const target = this._outputRenderTarget || this._canvasTarget;
        let frameBufferTarget = this._frameBufferTargets.get(target);
        if (frameBufferTarget === undefined) {
            frameBufferTarget = new (0, $9ddd7e9b53f7a2d4$export$efcb1f8bf367cbfb)(width, height, {
                depthBuffer: depth,
                stencilBuffer: stencil,
                type: this._outputBufferType,
                format: (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c),
                colorSpace: (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace,
                generateMipmaps: false,
                minFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
                magFilter: (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8),
                samples: this.samples
            });
            frameBufferTarget.isPostProcessingRenderTarget = true;
            const dispose = ()=>{
                target.removeEventListener('dispose', dispose);
                frameBufferTarget.dispose();
                this._frameBufferTargets.delete(target);
            };
            target.addEventListener('dispose', dispose);
            this._frameBufferTargets.set(target, frameBufferTarget);
        }
        const outputRenderTarget = this.getOutputRenderTarget();
        frameBufferTarget.depthBuffer = depth;
        frameBufferTarget.stencilBuffer = stencil;
        if (outputRenderTarget !== null) frameBufferTarget.setSize(outputRenderTarget.width, outputRenderTarget.height, outputRenderTarget.depth);
        else frameBufferTarget.setSize(width, height, 1);
        // RenderTarget || CanvasTarget
        const viewport = this._outputRenderTarget ? this._outputRenderTarget.viewport : target._viewport;
        const scissor = this._outputRenderTarget ? this._outputRenderTarget.scissor : target._scissor;
        const pixelRatio = this._outputRenderTarget ? 1 : target._pixelRatio;
        const scissorTest = this._outputRenderTarget ? this._outputRenderTarget.scissorTest : target._scissorTest;
        frameBufferTarget.viewport.copy(viewport);
        frameBufferTarget.scissor.copy(scissor);
        frameBufferTarget.viewport.multiplyScalar(pixelRatio);
        frameBufferTarget.scissor.multiplyScalar(pixelRatio);
        frameBufferTarget.scissorTest = scissorTest;
        frameBufferTarget.multiview = outputRenderTarget !== null ? outputRenderTarget.multiview : false;
        frameBufferTarget.resolveDepthBuffer = outputRenderTarget !== null ? outputRenderTarget.resolveDepthBuffer : true;
        frameBufferTarget._autoAllocateDepthBuffer = outputRenderTarget !== null ? outputRenderTarget._autoAllocateDepthBuffer : false;
        return frameBufferTarget;
    }
    /**
	 * Renders the scene or 3D object with the given camera.
	 *
	 * @private
	 * @param {Object3D} scene - The scene or 3D object to render.
	 * @param {Camera} camera - The camera to render the scene with.
	 * @param {boolean} [useFrameBufferTarget=true] - Whether to use a framebuffer target or not.
	 * @return {RenderContext} The current render context.
	 */ _renderScene(scene, camera, useFrameBufferTarget = true) {
        if (this._isDeviceLost === true) return;
        //
        const frameBufferTarget = useFrameBufferTarget ? this._getFrameBufferTarget() : null;
        // preserve render tree
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        const previousRenderContext = this._currentRenderContext;
        const previousRenderObjectFunction = this._currentRenderObjectFunction;
        const previousHandleObjectFunction = this._handleObjectFunction;
        //
        this._callDepth++;
        const sceneRef = scene.isScene === true ? scene : $03ccd63b0299d6a7$var$_scene;
        const outputRenderTarget = this._renderTarget || this._outputRenderTarget;
        const activeCubeFace = this._activeCubeFace;
        const activeMipmapLevel = this._activeMipmapLevel;
        //
        let renderTarget;
        if (frameBufferTarget !== null) {
            renderTarget = frameBufferTarget;
            this.setRenderTarget(renderTarget);
        } else renderTarget = outputRenderTarget;
        // make sure a new render target has correct default depth values
        if (renderTarget !== null && renderTarget.depthBuffer === true) {
            const renderTargetData = this._textures.get(renderTarget);
            if (renderTargetData.depthInitialized !== true) {
                // we need a single manual clear if auto clear depth is disabled
                if (this.autoClear === false || this.autoClear === true && this.autoClearDepth === false) this.clearDepth();
                renderTargetData.depthInitialized = true;
            }
        }
        //
        const renderContext = this._renderContexts.get(renderTarget, this._mrt, this._callDepth);
        this._currentRenderContext = renderContext;
        this._currentRenderObjectFunction = this._renderObjectFunction || this.renderObject;
        this._handleObjectFunction = this._renderObjectDirect;
        //
        this.info.calls++;
        this.info.render.calls++;
        this.info.render.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        this.backend.updateTimeStampUID(renderContext);
        this.inspector.beginRender(this.backend.getTimestampUID(renderContext), scene, camera, renderTarget);
        //
        const xr = this.xr;
        if (xr.isPresenting === false) {
            let projectionMatrixNeedsUpdate = false;
            // reversed depth
            if (this.reversedDepthBuffer === true && camera.reversedDepth !== true) {
                camera._reversedDepth = true;
                if (camera.isArrayCamera) for (const subCamera of camera.cameras)subCamera._reversedDepth = true;
                projectionMatrixNeedsUpdate = true;
            }
            // WebGPU/WebGL coordinate system
            const coordinateSystem = this.coordinateSystem;
            if (camera.coordinateSystem !== coordinateSystem) {
                camera.coordinateSystem = coordinateSystem;
                if (camera.isArrayCamera) for (const subCamera of camera.cameras)subCamera.coordinateSystem = coordinateSystem;
                projectionMatrixNeedsUpdate = true;
            }
            // camera update
            if (projectionMatrixNeedsUpdate === true) {
                camera.updateProjectionMatrix();
                if (camera.isArrayCamera) for (const subCamera of camera.cameras)subCamera.updateProjectionMatrix();
            }
        }
        //
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        const canvasTarget = this._canvasTarget;
        let viewport = canvasTarget._viewport;
        let scissor = canvasTarget._scissor;
        let pixelRatio = canvasTarget._pixelRatio;
        if (renderTarget !== null) {
            viewport = renderTarget.viewport;
            scissor = renderTarget.scissor;
            pixelRatio = 1;
        }
        this.getDrawingBufferSize($03ccd63b0299d6a7$var$_drawingBufferSize);
        $03ccd63b0299d6a7$var$_screen.set(0, 0, $03ccd63b0299d6a7$var$_drawingBufferSize.width, $03ccd63b0299d6a7$var$_drawingBufferSize.height);
        const minDepth = viewport.minDepth === undefined ? 0 : viewport.minDepth;
        const maxDepth = viewport.maxDepth === undefined ? 1 : viewport.maxDepth;
        renderContext.viewportValue.copy(viewport).multiplyScalar(pixelRatio).floor();
        renderContext.viewportValue.width >>= activeMipmapLevel;
        renderContext.viewportValue.height >>= activeMipmapLevel;
        renderContext.viewportValue.minDepth = minDepth;
        renderContext.viewportValue.maxDepth = maxDepth;
        renderContext.viewport = renderContext.viewportValue.equals($03ccd63b0299d6a7$var$_screen) === false;
        renderContext.scissorValue.copy(scissor).multiplyScalar(pixelRatio).floor();
        renderContext.scissor = canvasTarget._scissorTest && renderContext.scissorValue.equals($03ccd63b0299d6a7$var$_screen) === false;
        renderContext.scissorValue.width >>= activeMipmapLevel;
        renderContext.scissorValue.height >>= activeMipmapLevel;
        if (!renderContext.clippingContext) renderContext.clippingContext = new $03ccd63b0299d6a7$var$ClippingContext();
        renderContext.clippingContext.updateGlobal(sceneRef, camera);
        //
        sceneRef.onBeforeRender(this, scene, camera, renderTarget);
        //
        const frustum = camera.isArrayCamera ? $03ccd63b0299d6a7$var$_frustumArray : $03ccd63b0299d6a7$var$_frustum;
        if (!camera.isArrayCamera) {
            $03ccd63b0299d6a7$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            frustum.setFromProjectionMatrix($03ccd63b0299d6a7$var$_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
        }
        const renderList = this._renderLists.get(scene, camera);
        renderList.begin();
        this._projectObject(scene, camera, 0, renderList, renderContext.clippingContext);
        renderList.finish();
        if (this.sortObjects === true) renderList.sort(this._opaqueSort, this._transparentSort);
        //
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget, activeMipmapLevel);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
            renderContext.width = renderTargetData.width;
            renderContext.height = renderTargetData.height;
            renderContext.renderTarget = renderTarget;
            renderContext.depth = renderTarget.depthBuffer;
            renderContext.stencil = renderTarget.stencilBuffer;
        } else {
            renderContext.textures = null;
            renderContext.depthTexture = null;
            renderContext.width = $03ccd63b0299d6a7$var$_drawingBufferSize.width;
            renderContext.height = $03ccd63b0299d6a7$var$_drawingBufferSize.height;
            renderContext.depth = this.depth;
            renderContext.stencil = this.stencil;
        }
        renderContext.width >>= activeMipmapLevel;
        renderContext.height >>= activeMipmapLevel;
        renderContext.activeCubeFace = activeCubeFace;
        renderContext.activeMipmapLevel = activeMipmapLevel;
        renderContext.occlusionQueryCount = renderList.occlusionQueryCount;
        //
        renderContext.scissorValue.max($03ccd63b0299d6a7$var$_vector4.set(0, 0, 0, 0));
        if (renderContext.scissorValue.x + renderContext.scissorValue.width > renderContext.width) renderContext.scissorValue.width = Math.max(renderContext.width - renderContext.scissorValue.x, 0);
        if (renderContext.scissorValue.y + renderContext.scissorValue.height > renderContext.height) renderContext.scissorValue.height = Math.max(renderContext.height - renderContext.scissorValue.y, 0);
        //
        this._background.update(sceneRef, renderList, renderContext);
        //
        renderContext.camera = camera;
        this.backend.beginRender(renderContext);
        // process render lists
        const { bundles: bundles, lightsNode: lightsNode, transparentDoublePass: transparentDoublePassObjects, transparent: transparentObjects, opaque: opaqueObjects } = renderList;
        if (bundles.length > 0) this._renderBundles(bundles, sceneRef, lightsNode);
        if (this.opaque === true && opaqueObjects.length > 0) this._renderObjects(opaqueObjects, camera, sceneRef, lightsNode);
        if (this.transparent === true && transparentObjects.length > 0) this._renderTransparents(transparentObjects, transparentDoublePassObjects, camera, sceneRef, lightsNode);
        // finish render pass
        this.backend.finishRender(renderContext);
        // restore render tree
        nodeFrame.renderId = previousRenderId;
        this._currentRenderContext = previousRenderContext;
        this._currentRenderObjectFunction = previousRenderObjectFunction;
        this._handleObjectFunction = previousHandleObjectFunction;
        //
        this._callDepth--;
        if (frameBufferTarget !== null) {
            this.setRenderTarget(outputRenderTarget, activeCubeFace, activeMipmapLevel);
            this._renderOutput(renderTarget);
        }
        //
        sceneRef.onAfterRender(this, scene, camera, renderTarget);
        //
        this.inspector.finishRender(this.backend.getTimestampUID(renderContext));
        //
        return renderContext;
    }
    _setXRLayerSize(width, height) {
        // TODO: Find a better solution to resize the canvas when in XR.
        this._canvasTarget._width = width;
        this._canvasTarget._height = height;
        this.setViewport(0, 0, width, height);
    }
    /**
	 * The output pass performs tone mapping and color space conversion.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The current render target.
	 */ _renderOutput(renderTarget) {
        const cacheKey = this._nodes.getOutputCacheKey();
        let quadData = this._quadCache.get(renderTarget.texture);
        let quad;
        if (quadData === undefined) {
            quad = new $03ccd63b0299d6a7$export$266ce19fe399ee9a(new $03ccd63b0299d6a7$export$caaf3b30a544c946());
            quad.name = 'Output Color Transform';
            quad.material.name = 'outputColorTransform';
            quad.material.fragmentNode = this._nodes.getOutputNode(renderTarget.texture);
            quadData = {
                quad: quad,
                cacheKey: cacheKey
            };
            this._quadCache.set(renderTarget.texture, quadData);
            // dispose logic
            const dispose = ()=>{
                quad.material.dispose();
                this._quadCache.delete(renderTarget.texture);
                renderTarget.texture.removeEventListener('dispose', dispose);
            };
            renderTarget.texture.addEventListener('dispose', dispose);
        } else {
            quad = quadData.quad;
            if (quadData.cacheKey !== cacheKey) {
                quad.material.fragmentNode = this._nodes.getOutputNode(renderTarget.texture);
                quad.material.needsUpdate = true;
                quadData.cacheKey = cacheKey;
            }
        }
        // a clear operation clears the intermediate renderTarget texture, but should not update the screen canvas.
        const currentAutoClear = this.autoClear;
        const currentXR = this.xr.enabled;
        this.autoClear = false;
        this.xr.enabled = false;
        this._renderScene(quad, quad.camera, false);
        this.autoClear = currentAutoClear;
        this.xr.enabled = currentXR;
    }
    /**
	 * Returns the maximum available anisotropy for texture filtering.
	 *
	 * @return {number} The maximum available anisotropy.
	 */ getMaxAnisotropy() {
        return this.backend.capabilities.getMaxAnisotropy();
    }
    /**
	 * Returns the active cube face.
	 *
	 * @return {number} The active cube face.
	 */ getActiveCubeFace() {
        return this._activeCubeFace;
    }
    /**
	 * Returns the active mipmap level.
	 *
	 * @return {number} The active mipmap level.
	 */ getActiveMipmapLevel() {
        return this._activeMipmapLevel;
    }
    /**
	 * Applications are advised to always define the animation loop
	 * with this method and not manually with `requestAnimationFrame()`
	 * for best compatibility.
	 *
	 * @async
	 * @param {?onAnimationCallback} callback - The application's animation loop.
	 * @return {Promise} A Promise that resolves when the set has been executed.
	 */ async setAnimationLoop(callback) {
        if (this._initialized === false) await this.init();
        this._animation.setAnimationLoop(callback);
    }
    /**
	 * Returns the current animation loop callback.
	 *
	 * @return {?Function} The current animation loop callback.
	 */ getAnimationLoop() {
        return this._animation.getAnimationLoop();
    }
    /**
	 * Can be used to transfer buffer data from a storage buffer attribute
	 * from the GPU to the CPU in context of compute shaders.
	 *
	 * @async
	 * @param {BufferAttribute} attribute - The storage buffer attribute to read frm.
	 * @param {ReadbackBuffer|ArrayBuffer} target - The storage buffer attribute.
	 * @param {number} offset - The storage buffer attribute.
	 * @param {number} count - The offset from which to start reading the
	 * @return {Promise<ArrayBuffer|ReadbackBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute, target = null, offset = 0, count = -1) {
        // tally the memory for this readback buffer
        if (target !== null && target.isReadbackBuffer) {
            if (this.info.memoryMap.has(target) === false) {
                this.info.createReadbackBuffer(target);
                const disposeInfo = ()=>{
                    target.removeEventListener('dispose', disposeInfo);
                    this.info.destroyReadbackBuffer(target);
                };
                target.addEventListener('dispose', disposeInfo);
            }
        }
        if (offset % 4 !== 0 || count > 0 && count % 4 !== 0) throw new Error('THREE.Renderer: "getArrayBufferAsync()" offset and count must be a multiple of 4.');
        return await this.backend.getArrayBufferAsync(attribute, target, offset, count);
    }
    /**
	 * Returns the rendering context.
	 *
	 * @return {GPUCanvasContext|WebGL2RenderingContext} The rendering context.
	 */ getContext() {
        return this.backend.getContext();
    }
    /**
	 * Returns the pixel ratio.
	 *
	 * @return {number} The pixel ratio.
	 */ getPixelRatio() {
        return this._canvasTarget.getPixelRatio();
    }
    /**
	 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize(target) {
        return this._canvasTarget.getDrawingBufferSize(target);
    }
    /**
	 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
	 *
	 * @param {Vector2} target - The method writes the result in this target object.
	 * @return {Vector2} The renderer's size in logical pixels.
	 */ getSize(target) {
        return this._canvasTarget.getSize(target);
    }
    /**
	 * Sets the given pixel ratio and resizes the canvas if necessary.
	 *
	 * @param {number} [value=1] - The pixel ratio.
	 */ setPixelRatio(value = 1) {
        this._canvasTarget.setPixelRatio(value);
    }
    /**
	 * This method allows to define the drawing buffer size by specifying
	 * width, height and pixel ratio all at once. The size of the drawing
	 * buffer is computed with this formula:
	 * ```js
	 * size.x = width * pixelRatio;
	 * size.y = height * pixelRatio;
	 * ```
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {number} pixelRatio - The pixel ratio.
	 */ setDrawingBufferSize(width, height, pixelRatio) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._canvasTarget.setDrawingBufferSize(width, height, pixelRatio);
    }
    /**
	 * Sets the size of the renderer.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
	 */ setSize(width, height, updateStyle = true) {
        // Renderer can't be resized while presenting in XR.
        if (this.xr && this.xr.isPresenting) return;
        this._canvasTarget.setSize(width, height, updateStyle);
    }
    /**
	 * Defines a manual sort function for the opaque render list.
	 * Pass `null` to use the default sort.
	 *
	 * @param {Function} method - The sort function.
	 */ setOpaqueSort(method) {
        this._opaqueSort = method;
    }
    /**
	 * Defines a manual sort function for the transparent render list.
	 * Pass `null` to use the default sort.
	 *
	 * @param {Function} method - The sort function.
	 */ setTransparentSort(method) {
        this._transparentSort = method;
    }
    /**
	 * Returns the scissor rectangle.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The scissor rectangle.
	 */ getScissor(target) {
        return this._canvasTarget.getScissor(target);
    }
    /**
	 * Defines the scissor rectangle.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the upper left corner of the box in logical pixel unit.
	 * Instead of passing four arguments, the method also works with a single four-dimensional vector.
	 * @param {number} y - The vertical coordinate for the upper left corner of the box in logical pixel unit.
	 * @param {number} width - The width of the scissor box in logical pixel unit.
	 * @param {number} height - The height of the scissor box in logical pixel unit.
	 */ setScissor(x, y, width, height) {
        this._canvasTarget.setScissor(x, y, width, height);
    }
    /**
	 * Returns the scissor test value.
	 *
	 * @return {boolean} Whether the scissor test should be enabled or not.
	 */ getScissorTest() {
        return this._canvasTarget.getScissorTest();
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        this._canvasTarget.setScissorTest(boolean);
        // TODO: Move it to CanvasTarget event listener.
        this.backend.setScissorTest(boolean);
    }
    /**
	 * Returns the viewport definition.
	 *
	 * @param {Vector4} target - The method writes the result in this target object.
	 * @return {Vector4} The viewport definition.
	 */ getViewport(target) {
        return this._canvasTarget.getViewport(target);
    }
    /**
	 * Defines the viewport.
	 *
	 * @param {number | Vector4} x - The horizontal coordinate for the upper left corner of the viewport origin in logical pixel unit.
	 * @param {number} y - The vertical coordinate for the upper left corner of the viewport origin in logical pixel unit.
	 * @param {number} width - The width of the viewport in logical pixel unit.
	 * @param {number} height - The height of the viewport in logical pixel unit.
	 * @param {number} minDepth - The minimum depth value of the viewport. WebGPU only.
	 * @param {number} maxDepth - The maximum depth value of the viewport. WebGPU only.
	 */ setViewport(x, y, width, height, minDepth = 0, maxDepth = 1) {
        this._canvasTarget.setViewport(x, y, width, height, minDepth, maxDepth);
    }
    /**
	 * Returns the clear color.
	 *
	 * @param {Color} target - The method writes the result in this target object.
	 * @return {Color} The clear color.
	 */ getClearColor(target) {
        return target.copy(this._clearColor);
    }
    /**
	 * Defines the clear color and optionally the clear alpha.
	 *
	 * @param {Color} color - The clear color.
	 * @param {number} [alpha=1] - The clear alpha.
	 */ setClearColor(color, alpha = 1) {
        this._clearColor.set(color);
        this._clearColor.a = alpha;
    }
    /**
	 * Returns the clear alpha.
	 *
	 * @return {number} The clear alpha.
	 */ getClearAlpha() {
        return this._clearColor.a;
    }
    /**
	 * Defines the clear alpha.
	 *
	 * @param {number} alpha - The clear alpha.
	 */ setClearAlpha(alpha) {
        this._clearColor.a = alpha;
    }
    /**
	 * Returns the clear depth.
	 *
	 * @return {number} The clear depth.
	 */ getClearDepth() {
        return this.reversedDepthBuffer === true ? 1 - this._clearDepth : this._clearDepth;
    }
    /**
	 * Defines the clear depth.
	 *
	 * @param {number} depth - The clear depth.
	 */ setClearDepth(depth) {
        this._clearDepth = depth;
    }
    /**
	 * Returns the clear stencil.
	 *
	 * @return {number} The clear stencil.
	 */ getClearStencil() {
        return this._clearStencil;
    }
    /**
	 * Defines the clear stencil.
	 *
	 * @param {number} stencil - The clear stencil.
	 */ setClearStencil(stencil) {
        this._clearStencil = stencil;
    }
    /**
	 * This method performs an occlusion query for the given 3D object.
	 * It returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(object) {
        const renderContext = this._currentRenderContext;
        return renderContext && this.backend.isOccluded(renderContext, object);
    }
    /**
	 * Performs a manual clear operation. This method ignores `autoClear` properties.
	 *
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(color = true, depth = true, stencil = true) {
        if (this._initialized === false) throw new Error('Renderer: .clear() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        const renderTarget = this._renderTarget || this._getFrameBufferTarget();
        let renderContext = null;
        if (renderTarget !== null) {
            this._textures.updateRenderTarget(renderTarget);
            const renderTargetData = this._textures.get(renderTarget);
            renderContext = this._renderContexts.get(renderTarget, null, -1); // using - 1 for the call depth to get a render context for the clear operation
            renderContext.textures = renderTargetData.textures;
            renderContext.depthTexture = renderTargetData.depthTexture;
            renderContext.width = renderTargetData.width;
            renderContext.height = renderTargetData.height;
            renderContext.renderTarget = renderTarget;
            renderContext.depth = renderTarget.depthBuffer;
            renderContext.stencil = renderTarget.stencilBuffer;
            // #30329
            const color = this.backend.getClearColor();
            renderContext.clearColorValue.r = color.r;
            renderContext.clearColorValue.g = color.g;
            renderContext.clearColorValue.b = color.b;
            renderContext.clearColorValue.a = color.a;
            renderContext.clearDepthValue = this.getClearDepth();
            renderContext.clearStencilValue = this.getClearStencil();
            renderContext.activeCubeFace = this.getActiveCubeFace();
            renderContext.activeMipmapLevel = this.getActiveMipmapLevel();
            if (renderTarget.depthBuffer === true) renderTargetData.depthInitialized = true;
        }
        this.backend.clear(color, depth, stencil, renderContext);
        if (renderTarget !== null && this._renderTarget === null) this._renderOutput(renderTarget);
    }
    /**
	 * Performs a manual clear operation of the color buffer. This method ignores `autoClear` properties.
	 */ clearColor() {
        this.clear(true, false, false);
    }
    /**
	 * Performs a manual clear operation of the depth buffer. This method ignores `autoClear` properties.
	 */ clearDepth() {
        this.clear(false, true, false);
    }
    /**
	 * Performs a manual clear operation of the stencil buffer. This method ignores `autoClear` properties.
	 */ clearStencil() {
        this.clear(false, false, true);
    }
    /**
	 * Async version of {@link Renderer#clear}.
	 *
	 * @async
	 * @deprecated
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearAsync(color = true, depth = true, stencil = true) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "clearAsync()" has been deprecated. Use "clear()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.clear(color, depth, stencil);
    }
    /**
	 * Async version of {@link Renderer#clearColor}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearColorAsync() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "clearColorAsync()" has been deprecated. Use "clearColor()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(true, false, false);
    }
    /**
	 * Async version of {@link Renderer#clearDepth}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearDepthAsync() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "clearDepthAsync()" has been deprecated. Use "clearDepth()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(false, true, false);
    }
    /**
	 * Async version of {@link Renderer#clearStencil}.
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the clear operation has been executed.
	 */ async clearStencilAsync() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "clearStencilAsync()" has been deprecated. Use "clearStencil()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        this.clear(false, false, true);
    }
    /**
	 * Returns `true` if a framebuffer target is needed to perform tone mapping or color space conversion.
	 * If this is the case, the renderer allocates an internal render target for that purpose.
	 *
	 */ get needsFrameBufferTarget() {
        const useToneMapping = this.currentToneMapping !== (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        const useColorSpace = this.currentColorSpace !== (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
        return useToneMapping || useColorSpace;
    }
    /**
	 * The number of samples used for multi-sample anti-aliasing (MSAA).
	 *
	 * @type {number}
	 * @default 0
	 */ get samples() {
        return this._samples;
    }
    /**
	 * The current number of samples used for multi-sample anti-aliasing (MSAA).
	 *
	 * When rendering to a custom render target, the number of samples of that render target is used.
	 * If the renderer needs an internal framebuffer target for tone mapping or color space conversion,
	 * the number of samples is set to 0.
	 *
	 * @type {number}
	 */ get currentSamples() {
        let samples = this._samples;
        if (this._renderTarget !== null) samples = this._renderTarget.samples;
        else if (this.needsFrameBufferTarget) samples = 0;
        return samples;
    }
    /**
	 * The current tone mapping of the renderer. When not producing screen output,
	 * the tone mapping is always `NoToneMapping`.
	 *
	 * @type {number}
	 */ get currentToneMapping() {
        return this.isOutputTarget ? this.toneMapping : (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
    }
    /**
	 * The current color space of the renderer. When not producing screen output,
	 * the color space is always the working color space.
	 *
	 * @type {string}
	 */ get currentColorSpace() {
        return this.isOutputTarget ? this.outputColorSpace : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
    }
    /**
	 * Returns `true` if the rendering settings are set to screen output.
	 *
	 * @returns {boolean} True if the current render target is the same of output render target or `null`, otherwise false.
	 */ get isOutputTarget() {
        return this._renderTarget === this._outputRenderTarget || this._renderTarget === null;
    }
    /**
	 * Frees all internal resources of the renderer. Call this method if the renderer
	 * is no longer in use by your app.
	 */ dispose() {
        if (this._initialized === true) {
            this.info.dispose();
            this.backend.dispose();
            this._animation.dispose();
            this._objects.dispose();
            this._geometries.dispose();
            this._pipelines.dispose();
            this._nodes.dispose();
            this._bindings.dispose();
            this._renderLists.dispose();
            this._renderContexts.dispose();
            this._textures.dispose();
            for (const canvasTarget of this._frameBufferTargets.keys())canvasTarget.dispose();
            Object.values(this.backend.timestampQueryPool).forEach((queryPool)=>{
                if (queryPool !== null) queryPool.dispose();
            });
        }
        this.setRenderTarget(null);
        this.setAnimationLoop(null);
    }
    /**
	 * Sets the given render target. Calling this method means the renderer does not
	 * target the default framebuffer (meaning the canvas) anymore but a custom framebuffer.
	 * Use `null` as the first argument to reset the state.
	 *
	 * @param {?RenderTarget} renderTarget - The render target to set.
	 * @param {number} [activeCubeFace=0] - The active cube face.
	 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
	 */ setRenderTarget(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        this._renderTarget = renderTarget;
        this._activeCubeFace = activeCubeFace;
        this._activeMipmapLevel = activeMipmapLevel;
    }
    /**
	 * Returns the current render target.
	 *
	 * @return {?RenderTarget} The render target. Returns `null` if no render target is set.
	 */ getRenderTarget() {
        return this._renderTarget;
    }
    /**
	 * Sets the output render target for the renderer.
	 *
	 * @param {?RenderTarget} renderTarget - The render target to set as the output target.
	 */ setOutputRenderTarget(renderTarget) {
        this._outputRenderTarget = renderTarget;
    }
    /**
	 * Returns the current output target.
	 *
	 * @return {?RenderTarget} The current output render target. Returns `null` if no output target is set.
	 */ getOutputRenderTarget() {
        return this._outputRenderTarget;
    }
    /**
	 * Sets the canvas target. The canvas target manages the HTML canvas
	 * or the offscreen canvas the renderer draws into.
	 *
	 * @param {CanvasTarget} canvasTarget - The canvas target.
	 */ setCanvasTarget(canvasTarget) {
        this._canvasTarget.removeEventListener('resize', this._onCanvasTargetResize);
        this._canvasTarget = canvasTarget;
        this._canvasTarget.addEventListener('resize', this._onCanvasTargetResize);
    }
    /**
	 * Returns the current canvas target.
	 *
	 * @return {CanvasTarget} The current canvas target.
	 */ getCanvasTarget() {
        return this._canvasTarget;
    }
    /**
	 * Resets the renderer to the initial state before WebXR started.
	 *
	 * @private
	 */ _resetXRState() {
        this.backend.setXRTarget(null);
        this.setOutputRenderTarget(null);
        this.setRenderTarget(null);
        for (const canvasTarget of this._frameBufferTargets.keys())canvasTarget.dispose();
    }
    /**
	 * Callback for {@link Renderer#setRenderObjectFunction}.
	 *
	 * @callback renderObjectFunction
	 * @param {Object3D} object - The 3D object.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {BufferGeometry} geometry - The object's geometry.
	 * @param {Material} material - The object's material.
	 * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ /**
	 * Sets the given render object function. Calling this method overwrites the default implementation
	 * which is {@link Renderer#renderObject}. Defining a custom function can be useful
	 * if you want to modify the way objects are rendered. For example you can define things like "every
	 * object that has material of a certain type should perform a pre-pass with a special overwrite material".
	 * The custom function must always call `renderObject()` in its implementation.
	 *
	 * Use `null` as the first argument to reset the state.
	 *
	 * @param {?renderObjectFunction} renderObjectFunction - The render object function.
	 */ setRenderObjectFunction(renderObjectFunction) {
        this._renderObjectFunction = renderObjectFunction;
    }
    /**
	 * Returns the current render object function.
	 *
	 * @return {?Function} The current render object function. Returns `null` if no function is set.
	 */ getRenderObjectFunction() {
        return this._renderObjectFunction;
    }
    /**
	 * Execute a single or an array of compute nodes. This method can only be called
	 * if the renderer has been initialized.
	 *
	 * @param {Node|Array<Node>} computeNodes - The compute node(s).
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 * @return {Promise|undefined} A Promise that resolve when the compute has finished. Only returned when the renderer has not been initialized.
	 */ compute(computeNodes, dispatchSize = null) {
        if (this._isDeviceLost === true) return;
        if (this._initialized === false) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('Renderer: .compute() called before the backend is initialized. Try using .computeAsync() instead.');
            return this.computeAsync(computeNodes, dispatchSize);
        }
        //
        const nodeFrame = this._nodes.nodeFrame;
        const previousRenderId = nodeFrame.renderId;
        //
        this.info.calls++;
        this.info.compute.calls++;
        this.info.compute.frameCalls++;
        nodeFrame.renderId = this.info.calls;
        //
        this.backend.updateTimeStampUID(computeNodes);
        this.inspector.beginCompute(this.backend.getTimestampUID(computeNodes), computeNodes);
        //
        const backend = this.backend;
        const pipelines = this._pipelines;
        const bindings = this._bindings;
        const nodes = this._nodes;
        const computeList = Array.isArray(computeNodes) ? computeNodes : [
            computeNodes
        ];
        if (computeList[0] === undefined || computeList[0].isComputeNode !== true) throw new Error('THREE.Renderer: .compute() expects a ComputeNode.');
        backend.beginCompute(computeNodes);
        for (const computeNode of computeList){
            // onInit
            if (pipelines.has(computeNode) === false) {
                const dispose = ()=>{
                    computeNode.removeEventListener('dispose', dispose);
                    pipelines.delete(computeNode);
                    bindings.deleteForCompute(computeNode);
                    nodes.delete(computeNode);
                };
                computeNode.addEventListener('dispose', dispose);
                //
                const onInitFn = computeNode.onInitFunction;
                if (onInitFn !== null) onInitFn.call(computeNode, {
                    renderer: this
                });
            }
            nodes.updateForCompute(computeNode);
            bindings.updateForCompute(computeNode);
            const computeBindings = bindings.getForCompute(computeNode);
            const computePipeline = pipelines.getForCompute(computeNode, computeBindings);
            backend.compute(computeNodes, computeNode, computeBindings, computePipeline, dispatchSize);
        }
        backend.finishCompute(computeNodes);
        //
        nodeFrame.renderId = previousRenderId;
        //
        this.inspector.finishCompute(this.backend.getTimestampUID(computeNodes));
    }
    /**
	 * Execute a single or an array of compute nodes.
	 *
	 * @async
	 * @param {Node|Array<Node>} computeNodes - The compute node(s).
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 * @return {Promise} A Promise that resolve when the compute has finished.
	 */ async computeAsync(computeNodes, dispatchSize = null) {
        if (this._initialized === false) await this.init();
        this.compute(computeNodes, dispatchSize);
    }
    /**
	 * Checks if the given feature is supported by the selected backend.
	 *
	 * @async
	 * @deprecated
	 * @param {string} name - The feature's name.
	 * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
	 */ async hasFeatureAsync(name) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "hasFeatureAsync()" has been deprecated. Use "hasFeature()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        return this.hasFeature(name);
    }
    async resolveTimestampsAsync(type = 'render') {
        if (this._initialized === false) await this.init();
        return this.backend.resolveTimestampsAsync(type);
    }
    /**
	 * Checks if the given feature is supported by the selected backend. If the
	 * renderer has not been initialized, this method always returns `false`.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        if (this._initialized === false) throw new Error('Renderer: .hasFeature() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        return this.backend.hasFeature(name);
    }
    /**
	 * Returns `true` when the renderer has been initialized.
	 *
	 * @return {boolean} Whether the renderer has been initialized or not.
	 */ hasInitialized() {
        return this._initialized;
    }
    /**
	 * Initializes the given textures. Useful for preloading a texture rather than waiting until first render
	 * (which can cause noticeable lags due to decode and GPU upload overhead).
	 *
	 * @async
	 * @deprecated
	 * @param {Texture} texture - The texture.
	 * @return {Promise} A Promise that resolves when the texture has been initialized.
	 */ async initTextureAsync(texture) {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: "initTextureAsync()" has been deprecated. Use "initTexture()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.init();
        this.initTexture(texture);
    }
    /**
	 * Initializes the given texture. Useful for preloading a texture rather than waiting until first render
	 * (which can cause noticeable lags due to decode and GPU upload overhead).
	 *
	 * This method can only be used if the renderer has been initialized.
	 *
	 * @param {Texture} texture - The texture.
	 */ initTexture(texture) {
        if (this._initialized === false) throw new Error('Renderer: .initTexture() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        this._textures.updateTexture(texture);
    }
    /**
	 * Initializes the given render target.
	 *
	 * @param {RenderTarget} renderTarget - The render target to intialize.
	 */ initRenderTarget(renderTarget) {
        if (this._initialized === false) throw new Error('Renderer: .initRenderTarget() called before the backend is initialized. Use "await renderer.init();" before before using this method.');
        this._textures.updateRenderTarget(renderTarget);
        const renderTargetData = this._textures.get(renderTarget);
        const renderContext = this._renderContexts.get(renderTarget);
        renderContext.textures = renderTargetData.textures;
        renderContext.depthTexture = renderTargetData.depthTexture;
        renderContext.width = renderTargetData.width;
        renderContext.height = renderTargetData.height;
        renderContext.renderTarget = renderTarget;
        renderContext.depth = renderTarget.depthBuffer;
        renderContext.stencil = renderTarget.stencilBuffer;
        this.backend.initRenderTarget(renderContext);
    }
    /**
	 * Copies the current bound framebuffer into the given texture.
	 *
	 * @param {FramebufferTexture} framebufferTexture - The texture.
	 * @param {?(Vector2|Vector4)} [rectangle=null] - A two or four dimensional vector that defines the rectangular portion of the framebuffer that should be copied.
	 */ copyFramebufferToTexture(framebufferTexture, rectangle = null) {
        if (rectangle !== null) {
            if (rectangle.isVector2) rectangle = $03ccd63b0299d6a7$var$_vector4.set(rectangle.x, rectangle.y, framebufferTexture.image.width, framebufferTexture.image.height).floor();
            else if (rectangle.isVector4) rectangle = $03ccd63b0299d6a7$var$_vector4.copy(rectangle).floor();
            else {
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Renderer.copyFramebufferToTexture: Invalid rectangle.');
                return;
            }
        } else rectangle = $03ccd63b0299d6a7$var$_vector4.set(0, 0, framebufferTexture.image.width, framebufferTexture.image.height);
        //
        let renderContext = this._currentRenderContext;
        let renderTarget;
        if (renderContext !== null) renderTarget = renderContext.renderTarget;
        else {
            renderTarget = this._renderTarget || this._getFrameBufferTarget();
            if (renderTarget !== null) {
                this._textures.updateRenderTarget(renderTarget);
                renderContext = this._textures.get(renderTarget);
            }
        }
        //
        this._textures.updateTexture(framebufferTexture, {
            renderTarget: renderTarget
        });
        this.backend.copyFramebufferToTexture(framebufferTexture, renderContext, rectangle);
        this._inspector.copyFramebufferToTexture(framebufferTexture);
    }
    /**
	 * Copies data of the given source texture into a destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {Box2|Box3} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
	 * @param {Vector2|Vector3} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        this._textures.updateTexture(srcTexture);
        this._textures.updateTexture(dstTexture);
        this.backend.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, srcLevel, dstLevel);
        this._inspector.copyTextureToTexture(srcTexture, dstTexture);
    }
    /**
	 * Reads pixel data from the given render target.
	 *
	 * @async
	 * @param {RenderTarget} renderTarget - The render target to read from.
	 * @param {number} x - The `x` coordinate of the copy region's origin.
	 * @param {number} y - The `y` coordinate of the copy region's origin.
	 * @param {number} width - The width of the copy region.
	 * @param {number} height - The height of the copy region.
	 * @param {number} [textureIndex=0] - The texture index of a MRT render target.
	 * @param {number} [faceIndex=0] - The active cube face index.
	 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
	 */ async readRenderTargetPixelsAsync(renderTarget, x, y, width, height, textureIndex = 0, faceIndex = 0) {
        return this.backend.copyTextureToBuffer(renderTarget.textures[textureIndex], x, y, width, height, faceIndex);
    }
    /**
	 * Analyzes the given 3D object's hierarchy and builds render lists from the
	 * processed hierarchy.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object to process (usually a scene).
	 * @param {Camera} camera - The camera the object is rendered with.
	 * @param {number} groupOrder - The group order is derived from the `renderOrder` of groups and is used to group 3D objects within groups.
	 * @param {RenderList} renderList - The current render list.
	 * @param {ClippingContext} clippingContext - The current clipping context.
	 */ _projectObject(object, camera, groupOrder, renderList, clippingContext) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) {
                groupOrder = object.renderOrder;
                if (object.isClippingGroup && object.enabled) clippingContext = clippingContext.getGroupContext(object);
            } else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) renderList.pushLight(object);
            else if (object.isSprite) {
                const frustum = camera.isArrayCamera ? $03ccd63b0299d6a7$var$_frustumArray : $03ccd63b0299d6a7$var$_frustum;
                if (!object.frustumCulled || frustum.intersectsSprite(object, camera)) {
                    if (this.sortObjects === true) $03ccd63b0299d6a7$var$_vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4($03ccd63b0299d6a7$var$_projScreenMatrix);
                    const { geometry: geometry, material: material } = object;
                    if (material.visible) renderList.push(object, geometry, material, groupOrder, $03ccd63b0299d6a7$var$_vector4.z, null, clippingContext);
                }
            } else if (object.isLineLoop) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Renderer: Objects of type THREE.LineLoop are not supported. Please use THREE.Line or THREE.LineSegments.');
            else if (object.isMesh || object.isLine || object.isPoints) {
                const frustum = camera.isArrayCamera ? $03ccd63b0299d6a7$var$_frustumArray : $03ccd63b0299d6a7$var$_frustum;
                if (!object.frustumCulled || frustum.intersectsObject(object, camera)) {
                    const { geometry: geometry, material: material } = object;
                    if (this.sortObjects === true) {
                        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                        $03ccd63b0299d6a7$var$_vector4.copy(geometry.boundingSphere.center).applyMatrix4(object.matrixWorld).applyMatrix4($03ccd63b0299d6a7$var$_projScreenMatrix);
                    }
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) renderList.push(object, geometry, groupMaterial, groupOrder, $03ccd63b0299d6a7$var$_vector4.z, group, clippingContext);
                        }
                    } else if (material.visible) renderList.push(object, geometry, material, groupOrder, $03ccd63b0299d6a7$var$_vector4.z, null, clippingContext);
                }
            }
        }
        if (object.isBundleGroup === true && this.backend.beginBundle !== undefined) {
            const baseRenderList = renderList;
            // replace render list
            renderList = this._renderLists.get(object, camera);
            renderList.begin();
            baseRenderList.pushBundle({
                bundleGroup: object,
                camera: camera,
                renderList: renderList
            });
            renderList.finish();
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this._projectObject(children[i], camera, groupOrder, renderList, clippingContext);
    }
    /**
	 * Renders the given render bundles.
	 *
	 * @private
	 * @param {Array<Object>} bundles - Array with render bundle data.
	 * @param {Scene} sceneRef - The scene the render bundles belong to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 */ _renderBundles(bundles, sceneRef, lightsNode) {
        for (const bundle of bundles)this._renderBundle(bundle, sceneRef, lightsNode);
    }
    /**
	 * Renders the transparent objects from the given render lists.
	 *
	 * @private
	 * @param {Array<Object>} renderList - The transparent render list.
	 * @param {Array<Object>} doublePassList - The list of transparent objects which require a double pass (e.g. because of transmission).
	 * @param {Camera} camera - The camera the render list should be rendered with.
	 * @param {Scene} scene - The scene the render list belongs to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 */ _renderTransparents(renderList, doublePassList, camera, scene, lightsNode) {
        if (doublePassList.length > 0) {
            // render back side
            for (const { material: material } of doublePassList)material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
            this._renderObjects(doublePassList, camera, scene, lightsNode, 'backSide');
            // render front side
            for (const { material: material } of doublePassList)material.side = (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901);
            this._renderObjects(renderList, camera, scene, lightsNode);
            // restore
            for (const { material: material } of doublePassList)material.side = (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03);
        } else this._renderObjects(renderList, camera, scene, lightsNode);
    }
    /**
	 * Renders the objects from the given render list.
	 *
	 * @private
	 * @param {Array<Object>} renderList - The render list.
	 * @param {Camera} camera - The camera the render list should be rendered with.
	 * @param {Scene} scene - The scene the render list belongs to.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ _renderObjects(renderList, camera, scene, lightsNode, passId = null) {
        for(let i = 0, il = renderList.length; i < il; i++){
            const { object: object, geometry: geometry, material: material, group: group, clippingContext: clippingContext } = renderList[i];
            this._currentRenderObjectFunction(object, scene, camera, geometry, material, group, lightsNode, clippingContext, passId);
        }
    }
    /**
	 * Retrieves shadow nodes for the given material. This is used to setup shadow passes.
	 * The result is cached per material and updated when the material's version changes.
	 *
	 * @private
	 * @param {Material} material
	 * @returns {Object} - The shadow nodes for the material.
	 */ _getShadowNodes(material) {
        const version = material.version;
        let cache = this._cacheShadowNodes.get(material);
        if (cache === undefined || cache.version !== version) {
            const hasMap = material.map !== null;
            const hasColorNode = material.colorNode && material.colorNode.isNode;
            const hasCastShadowNode = material.castShadowNode && material.castShadowNode.isNode;
            const hasMaskNode = material.maskShadowNode && material.maskShadowNode.isNode || material.maskNode && material.maskNode.isNode;
            let positionNode = null;
            let colorNode = null;
            let depthNode = null;
            if (hasMap || hasColorNode || hasCastShadowNode || hasMaskNode) {
                let shadowRGB;
                let shadowAlpha;
                if (hasCastShadowNode) {
                    shadowRGB = material.castShadowNode.rgb;
                    shadowAlpha = material.castShadowNode.a;
                    if (this.shadowMap.transmitted !== true) (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('Renderer: `shadowMap.transmitted` needs to be set to `true` when using `material.castShadowNode`.');
                } else {
                    shadowRGB = $03ccd63b0299d6a7$var$vec3(0);
                    shadowAlpha = $03ccd63b0299d6a7$var$float(1);
                }
                if (hasMap) shadowAlpha = shadowAlpha.mul($03ccd63b0299d6a7$var$reference('map', 'texture', material).a);
                if (hasColorNode) shadowAlpha = shadowAlpha.mul(material.colorNode.a);
                colorNode = $03ccd63b0299d6a7$var$vec4(shadowRGB, shadowAlpha);
                if (hasMaskNode) {
                    const maskNode = material.maskShadowNode || material.maskNode;
                    colorNode = $03ccd63b0299d6a7$var$Fn(([color])=>{
                        maskNode.not().discard();
                        return color;
                    })(colorNode);
                }
            }
            if (material.depthNode && material.depthNode.isNode) depthNode = material.depthNode;
            if (material.castShadowPositionNode && material.castShadowPositionNode.isNode) positionNode = material.castShadowPositionNode;
            else if (material.positionNode && material.positionNode.isNode) positionNode = material.positionNode;
            cache = {
                version: version,
                colorNode: colorNode,
                depthNode: depthNode,
                positionNode: positionNode
            };
            this._cacheShadowNodes.set(material, cache);
        }
        return cache;
    }
    /**
	 * This method represents the default render object function that manages the render lifecycle
	 * of the object.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {BufferGeometry} geometry - The object's geometry.
	 * @param {Material} material - The object's material.
	 * @param {?Object} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?ClippingContext} clippingContext - The clipping context.
	 * @param {?string} [passId=null] - An optional ID for identifying the pass.
	 */ renderObject(object, scene, camera, geometry, material, group, lightsNode, clippingContext = null, passId = null) {
        let materialOverride = false;
        let materialColorNode;
        let materialDepthNode;
        let materialPositionNode;
        let materialSide;
        //
        object.onBeforeRender(this, scene, camera, geometry, material, group);
        //
        if (material.allowOverride === true && scene.overrideMaterial !== null) {
            const overrideMaterial = scene.overrideMaterial;
            materialOverride = true;
            // store original nodes
            materialColorNode = overrideMaterial.isNodeMaterial ? overrideMaterial.colorNode : null;
            materialDepthNode = overrideMaterial.isNodeMaterial ? overrideMaterial.depthNode : null;
            materialPositionNode = overrideMaterial.isNodeMaterial ? overrideMaterial.positionNode : null;
            materialSide = scene.overrideMaterial.side;
            if (material.positionNode && material.positionNode.isNode) overrideMaterial.positionNode = material.positionNode;
            overrideMaterial.alphaTest = material.alphaTest;
            overrideMaterial.alphaMap = material.alphaMap;
            overrideMaterial.transparent = material.transparent || material.transmission > 0 || material.transmissionNode && material.transmissionNode.isNode || material.backdropNode && material.backdropNode.isNode;
            if (overrideMaterial.isShadowPassMaterial) {
                const { colorNode: colorNode, depthNode: depthNode, positionNode: positionNode } = this._getShadowNodes(material);
                if (this.shadowMap.type === (0, $9ddd7e9b53f7a2d4$export$896ae1ade6c829c4)) overrideMaterial.side = material.shadowSide !== null ? material.shadowSide : material.side;
                else overrideMaterial.side = material.shadowSide !== null ? material.shadowSide : $03ccd63b0299d6a7$var$_shadowSide[material.side];
                if (colorNode !== null) overrideMaterial.colorNode = colorNode;
                if (depthNode !== null) overrideMaterial.depthNode = depthNode;
                if (positionNode !== null) overrideMaterial.positionNode = positionNode;
            }
            material = overrideMaterial;
        }
        //
        if (material.transparent === true && material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
            material.side = (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, 'backSide'); // create backSide pass id
            material.side = (0, $9ddd7e9b53f7a2d4$export$2ede184fc2998901);
            this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, passId); // use default pass id
            material.side = (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03);
        } else this._handleObjectFunction(object, material, scene, camera, lightsNode, group, clippingContext, passId);
        //
        if (materialOverride) {
            scene.overrideMaterial.colorNode = materialColorNode;
            scene.overrideMaterial.depthNode = materialDepthNode;
            scene.overrideMaterial.positionNode = materialPositionNode;
            scene.overrideMaterial.side = materialSide;
        }
        //
        object.onAfterRender(this, scene, camera, geometry, material, group);
    }
    /**
	 * Checks if the given compatibility is supported by the selected backend.
	 *
	 * @param {string} name - The compatibility's name.
	 * @return {boolean} Whether the compatibility is supported or not.
	 */ hasCompatibility(name) {
        if (this._initialized === false) throw new Error('Renderer: .hasCompatibility() called before the backend is initialized. Use "await renderer.init();" before using this method.');
        return this.backend.hasCompatibility(name);
    }
    /**
	 * This method represents the default `_handleObjectFunction` implementation which creates
	 * a render object from the given data and performs the draw command with the selected backend.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 */ _renderObjectDirect(object, material, scene, camera, lightsNode, group, clippingContext, passId) {
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, clippingContext, passId);
        renderObject.drawRange = object.geometry.drawRange;
        renderObject.group = group;
        if (this._currentRenderBundle !== null) {
            const renderBundleData = this.backend.get(this._currentRenderBundle);
            renderBundleData.renderObjects.push(renderObject);
            renderObject.bundle = this._currentRenderBundle.bundleGroup;
        }
        //
        const needsRefresh = this._nodes.needsRefresh(renderObject);
        if (needsRefresh) {
            this._nodes.updateBefore(renderObject);
            this._geometries.updateForRender(renderObject);
            this._nodes.updateForRender(renderObject);
            this._bindings.updateForRender(renderObject);
        }
        this._pipelines.updateForRender(renderObject);
        //
        if (this._pipelines.isReady(renderObject)) {
            this.backend.draw(renderObject, this.info);
            if (needsRefresh) this._nodes.updateAfter(renderObject);
        }
    }
    /**
	 * A different implementation for `_handleObjectFunction` which only makes sure the object is ready for rendering.
	 * Used in `compileAsync()`.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The object's material.
	 * @param {Scene} scene - The scene the 3D object belongs to.
	 * @param {Camera} camera - The camera the object should be rendered with.
	 * @param {LightsNode} lightsNode - The current lights node.
	 * @param {?{start: number, count: number}} group - Only relevant for objects using multiple materials. This represents a group entry from the respective `BufferGeometry`.
	 * @param {ClippingContext} clippingContext - The clipping context.
	 * @param {string} [passId] - An optional ID for identifying the pass.
	 */ _createObjectPipeline(object, material, scene, camera, lightsNode, group, clippingContext, passId) {
        // If in async compilation mode, queue the work for sequential execution
        if (this._compilationPromises !== null) {
            // Store work items instead of promises - will be processed sequentially
            this._compilationPromises.push({
                object: object,
                material: material,
                scene: scene,
                camera: camera,
                lightsNode: lightsNode,
                group: group,
                clippingContext: clippingContext,
                passId: passId,
                renderContext: this._currentRenderContext
            });
            return;
        }
        // Sync path
        const renderObject = this._objects.get(object, material, scene, camera, lightsNode, this._currentRenderContext, clippingContext, passId);
        renderObject.drawRange = object.geometry.drawRange;
        renderObject.group = group;
        //
        this._nodes.updateBefore(renderObject);
        this._geometries.updateForRender(renderObject);
        this._nodes.updateForRender(renderObject);
        this._bindings.updateForRender(renderObject);
        this._pipelines.getForRender(renderObject, this._compilationPromises);
        this._nodes.updateAfter(renderObject);
    }
    /**
	 * Callback when the canvas has been resized.
	 *
	 * @private
	 */ _onCanvasTargetResize() {
        if (this._initialized) this.backend.updateSize();
    }
    /**
	 * Alias for `compileAsync()`.
	 *
	 * @method
	 * @param {Object3D} scene - The scene or 3D object to precompile.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Scene} targetScene - If the first argument is a 3D object, this parameter must represent the scene the 3D object is going to be added.
	 * @return {function(Object3D, Camera, ?Scene): Promise|undefined} A Promise that resolves when the compile has been finished.
	 */ get compile() {
        return this.compileAsync;
    }
}
/**
 * A binding represents the connection between a resource (like a texture, sampler
 * or uniform buffer) and the resource definition in a shader stage.
 *
 * This module is an abstract base class for all concrete bindings types.
 *
 * @abstract
 * @private
 */ class $03ccd63b0299d6a7$var$Binding {
    /**
	 * Constructs a new binding.
	 *
	 * @param {string} [name=''] - The binding's name.
	 */ constructor(name = ''){
        /**
		 * The binding's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * A bitmask that defines in what shader stages the
		 * binding's resource is accessible.
		 *
		 * @type {number}
		 */ this.visibility = 0;
    }
    /**
	 * Makes sure binding's resource is visible for the given shader stage.
	 *
	 * @param {number} visibility - The shader stage.
	 */ setVisibility(visibility) {
        this.visibility |= visibility;
    }
    /**
	 * The shader stages in which the binding's resource is visible.
	 *
	 * @return {number} The visibility bitmask.
	 */ getVisibility() {
        return this.visibility;
    }
    /**
	 * Clones the binding.
	 *
	 * @return {Binding} The cloned binding.
	 */ clone() {
        return Object.assign(new this.constructor(), this);
    }
}
/**
 * This function is usually called with the length in bytes of an array buffer.
 * It returns an padded value which ensure chunk size alignment according to STD140 layout.
 *
 * @function
 * @param {number} floatLength - The buffer length.
 * @return {number} The padded length.
 */ function $03ccd63b0299d6a7$var$getFloatLength(floatLength) {
    // ensure chunk size alignment (STD140 layout)
    return floatLength + ($03ccd63b0299d6a7$var$GPU_CHUNK_BYTES - floatLength % $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES) % $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES;
}
/**
 * Represents a buffer binding type.
 *
 * @private
 * @abstract
 * @augments Binding
 */ class $03ccd63b0299d6a7$var$Buffer extends $03ccd63b0299d6a7$var$Binding {
    /**
	 * Constructs a new buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {TypedArray} [buffer=null] - The buffer.
	 */ constructor(name, buffer = null){
        super(name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBuffer = true;
        /**
		 * The bytes per element.
		 *
		 * @type {number}
		 */ this.bytesPerElement = Float32Array.BYTES_PER_ELEMENT;
        /**
		 * A reference to the internal buffer.
		 *
		 * @private
		 * @type {TypedArray}
		 */ this._buffer = buffer;
        /**
		 * An array of update ranges.
		 *
		 * @private
		 * @type {Array<{start: number, count: number}>}
		 */ this._updateRanges = [];
    }
    /**
	 * The array of update ranges.
	 *
	 * @type {Array<{start: number, count: number}>}
	 */ get updateRanges() {
        return this._updateRanges;
    }
    /**
	 * Adds an update range.
	 *
	 * @param {number} start - The start index.
	 * @param {number} count - The number of elements.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears all update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * The buffer's byte length.
	 *
	 * @type {number}
	 * @readonly
	 */ get byteLength() {
        return $03ccd63b0299d6a7$var$getFloatLength(this._buffer.byteLength);
    }
    /**
	 * A reference to the internal buffer.
	 *
	 * @type {Float32Array}
	 * @readonly
	 */ get buffer() {
        return this._buffer;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the buffer has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        return true;
    }
}
/**
 * Represents a uniform buffer binding type.
 *
 * @private
 * @augments Buffer
 */ class $03ccd63b0299d6a7$var$UniformBuffer extends $03ccd63b0299d6a7$var$Buffer {
    /**
	 * Constructs a new uniform buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {TypedArray} [buffer=null] - The buffer.
	 */ constructor(name, buffer = null){
        super(name, buffer);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformBuffer = true;
    }
}
let $03ccd63b0299d6a7$var$_id$4 = 0;
/**
 * A special form of uniform buffer binding type.
 * It's buffer value is managed by a node object.
 *
 * @private
 * @augments UniformBuffer
 */ class $03ccd63b0299d6a7$var$NodeUniformBuffer extends $03ccd63b0299d6a7$var$UniformBuffer {
    /**
	 * Constructs a new node-based uniform buffer.
	 *
	 * @param {BufferNode} nodeUniform - The uniform buffer node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(nodeUniform, groupNode){
        super('UniformBuffer_' + $03ccd63b0299d6a7$var$_id$4++, nodeUniform ? nodeUniform.value : null);
        /**
		 * The uniform buffer node.
		 *
		 * @type {BufferNode}
		 */ this.nodeUniform = nodeUniform;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniformBuffer = true;
    }
    /**
	 * The array of update ranges.
	 *
	 * @param {Array<{start: number, count: number}>} value - The update ranges.
	 */ set updateRanges(value) {
        this.nodeUniform.updateRanges = value;
    }
    /**
	 * The array of update ranges.
	 *
	 * @type {Array<{start: number, count: number}>}
	 */ get updateRanges() {
        return this.nodeUniform.updateRanges;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.nodeUniform.addUpdateRange(start, count);
    }
    /**
	 * Clears all update ranges.
	 */ clearUpdateRanges() {
        this.nodeUniform.clearUpdateRanges();
    }
    /**
	 * The uniform buffer.
	 *
	 * @type {Float32Array}
	 */ get buffer() {
        return this.nodeUniform.value;
    }
}
/**
 * This class represents a uniform buffer binding but with
 * an API that allows to maintain individual uniform objects.
 *
 * @private
 * @augments UniformBuffer
 */ class $03ccd63b0299d6a7$var$UniformsGroup extends $03ccd63b0299d6a7$var$UniformBuffer {
    /**
	 * Constructs a new uniforms group.
	 *
	 * @param {string} name - The group's name.
	 */ constructor(name){
        super(name);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * An array with the raw uniform values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this._values = null;
        /**
		 * An array of uniform objects.
		 *
		 * The order of uniforms in this array must match the order of uniforms in the shader.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
        /**
		 * A cache for the uniform update ranges.
		 *
		 * @private
		 * @type {Map<number, {start: number, count: number}>}
		 */ this._updateRangeCache = new Map();
    }
    /**
	 * Adds a uniform's update range to this buffer.
	 *
	 * @param {Uniform} uniform - The uniform.
	 */ addUniformUpdateRange(uniform) {
        const index = uniform.index;
        if (this._updateRangeCache.has(index) !== true) {
            const updateRanges = this.updateRanges;
            const start = uniform.offset;
            const count = uniform.itemSize;
            const range = {
                start: start,
                count: count
            };
            updateRanges.push(range);
            this._updateRangeCache.set(index, range);
        }
    }
    /**
	 * Clears all update ranges of this buffer.
	 */ clearUpdateRanges() {
        this._updateRangeCache.clear();
        super.clearUpdateRanges();
    }
    /**
	 * Adds a uniform to this group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this group.
	 */ addUniform(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes a uniform from this group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this group.
	 */ removeUniform(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * An array with the raw uniform values.
	 *
	 * @type {Array<number>}
	 */ get values() {
        if (this._values === null) this._values = Array.from(this.buffer);
        return this._values;
    }
    /**
	 * A Float32 array buffer with the uniform values.
	 *
	 * @type {Float32Array}
	 */ get buffer() {
        let buffer = this._buffer;
        if (buffer === null) {
            const byteLength = this.byteLength;
            buffer = new Float32Array(new ArrayBuffer(byteLength));
            this._buffer = buffer;
        }
        return buffer;
    }
    /**
	 * The byte length of the buffer with correct buffer alignment.
	 *
	 * @type {number}
	 */ get byteLength() {
        const bytesPerElement = this.bytesPerElement;
        let offset = 0; // global buffer offset in bytes
        for(let i = 0, l = this.uniforms.length; i < l; i++){
            const uniform = this.uniforms[i];
            const boundary = uniform.boundary;
            const itemSize = uniform.itemSize * bytesPerElement; // size of the uniform in bytes
            const chunkOffset = offset % $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES; // offset in the current chunk
            const chunkPadding = chunkOffset % boundary; // required padding to match boundary
            const chunkStart = chunkOffset + chunkPadding; // start position in the current chunk for the data
            offset += chunkPadding;
            // Check for chunk overflow
            if (chunkStart !== 0 && $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES - chunkStart < itemSize) // Add padding to the end of the chunk
            offset += $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES - chunkStart;
            uniform.offset = offset / bytesPerElement;
            uniform.index = i;
            offset += itemSize;
        }
        return Math.ceil(offset / $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES) * $03ccd63b0299d6a7$var$GPU_CHUNK_BYTES;
    }
    /**
	 * Updates this group by updating each uniform object of
	 * the internal uniform list. The uniform objects check if their
	 * values has actually changed so this method only returns
	 * `true` if there is a real value change.
	 *
	 * @return {boolean} Whether the uniforms have been updated and
	 * must be uploaded to the GPU.
	 */ update() {
        let updated = false;
        for (const uniform of this.uniforms)if (this.updateByType(uniform) === true) updated = true;
        return updated;
    }
    /**
	 * Updates a given uniform by calling an update method matching
	 * the uniforms type.
	 *
	 * @param {Uniform} uniform - The uniform to update.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateByType(uniform) {
        if (uniform.isNumberUniform) return this.updateNumber(uniform);
        if (uniform.isVector2Uniform) return this.updateVector2(uniform);
        if (uniform.isVector3Uniform) return this.updateVector3(uniform);
        if (uniform.isVector4Uniform) return this.updateVector4(uniform);
        if (uniform.isColorUniform) return this.updateColor(uniform);
        if (uniform.isMatrix3Uniform) return this.updateMatrix3(uniform);
        if (uniform.isMatrix4Uniform) return this.updateMatrix4(uniform);
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUUniformsGroup: Unsupported uniform type.', uniform);
    }
    /**
	 * Updates a given Number uniform.
	 *
	 * @param {NumberUniform} uniform - The Number uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateNumber(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset] !== v) {
            const b = this._getBufferForType(type);
            b[offset] = a[offset] = v;
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Vector2 uniform.
	 *
	 * @param {Vector2Uniform} uniform - The Vector2 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector2(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Vector3 uniform.
	 *
	 * @param {Vector3Uniform} uniform - The Vector3 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector3(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Vector4 uniform.
	 *
	 * @param {Vector4Uniform} uniform - The Vector4 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateVector4(uniform) {
        let updated = false;
        const a = this.values;
        const v = uniform.getValue();
        const offset = uniform.offset;
        const type = uniform.getType();
        if (a[offset + 0] !== v.x || a[offset + 1] !== v.y || a[offset + 2] !== v.z || a[offset + 3] !== v.w) {
            const b = this._getBufferForType(type);
            b[offset + 0] = a[offset + 0] = v.x;
            b[offset + 1] = a[offset + 1] = v.y;
            b[offset + 2] = a[offset + 2] = v.z;
            b[offset + 3] = a[offset + 3] = v.w;
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Color uniform.
	 *
	 * @param {ColorUniform} uniform - The Color uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateColor(uniform) {
        let updated = false;
        const a = this.values;
        const c = uniform.getValue();
        const offset = uniform.offset;
        if (a[offset + 0] !== c.r || a[offset + 1] !== c.g || a[offset + 2] !== c.b) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = c.r;
            b[offset + 1] = a[offset + 1] = c.g;
            b[offset + 2] = a[offset + 2] = c.b;
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Matrix3 uniform.
	 *
	 * @param {Matrix3Uniform} uniform - The Matrix3 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateMatrix3(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if (a[offset + 0] !== e[0] || a[offset + 1] !== e[1] || a[offset + 2] !== e[2] || a[offset + 4] !== e[3] || a[offset + 5] !== e[4] || a[offset + 6] !== e[5] || a[offset + 8] !== e[6] || a[offset + 9] !== e[7] || a[offset + 10] !== e[8]) {
            const b = this.buffer;
            b[offset + 0] = a[offset + 0] = e[0];
            b[offset + 1] = a[offset + 1] = e[1];
            b[offset + 2] = a[offset + 2] = e[2];
            b[offset + 4] = a[offset + 4] = e[3];
            b[offset + 5] = a[offset + 5] = e[4];
            b[offset + 6] = a[offset + 6] = e[5];
            b[offset + 8] = a[offset + 8] = e[6];
            b[offset + 9] = a[offset + 9] = e[7];
            b[offset + 10] = a[offset + 10] = e[8];
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Updates a given Matrix4 uniform.
	 *
	 * @param {Matrix4Uniform} uniform - The Matrix4 uniform.
	 * @return {boolean} Whether the uniform has been updated or not.
	 */ updateMatrix4(uniform) {
        let updated = false;
        const a = this.values;
        const e = uniform.getValue().elements;
        const offset = uniform.offset;
        if ($03ccd63b0299d6a7$var$arraysEqual(a, e, offset) === false) {
            const b = this.buffer;
            b.set(e, offset);
            $03ccd63b0299d6a7$var$setArray(a, e, offset);
            updated = true;
            this.addUniformUpdateRange(uniform);
        }
        return updated;
    }
    /**
	 * Returns a typed array that matches the given data type.
	 *
	 * @private
	 * @param {string} type - The data type.
	 * @return {TypedArray} The typed array.
	 */ _getBufferForType(type) {
        if (type === 'int' || type === 'ivec2' || type === 'ivec3' || type === 'ivec4') return new Int32Array(this.buffer.buffer);
        if (type === 'uint' || type === 'uvec2' || type === 'uvec3' || type === 'uvec4') return new Uint32Array(this.buffer.buffer);
        return this.buffer;
    }
}
/**
 * Sets the values of the second array to the first array.
 *
 * @private
 * @param {TypedArray} a - The first array.
 * @param {TypedArray} b - The second array.
 * @param {number} offset - An index offset for the first array.
 */ function $03ccd63b0299d6a7$var$setArray(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++)a[offset + i] = b[i];
}
/**
 * Returns `true` if the given arrays are equal.
 *
 * @private
 * @param {TypedArray} a - The first array.
 * @param {TypedArray} b - The second array.
 * @param {number} offset - An index offset for the first array.
 * @return {boolean} Whether the given arrays are equal or not.
 */ function $03ccd63b0299d6a7$var$arraysEqual(a, b, offset) {
    for(let i = 0, l = b.length; i < l; i++){
        if (a[offset + i] !== b[i]) return false;
    }
    return true;
}
let $03ccd63b0299d6a7$var$_id$3 = 0;
/**
 * A special form of uniforms group that represents
 * the individual uniforms as node-based uniforms.
 *
 * @private
 * @augments UniformsGroup
 */ class $03ccd63b0299d6a7$var$NodeUniformsGroup extends $03ccd63b0299d6a7$var$UniformsGroup {
    /**
	 * Constructs a new node-based uniforms group.
	 *
	 * @param {string} name - The group's name.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(name, groupNode){
        super(name);
        /**
		 * The group's ID.
		 *
		 * @type {number}
		 */ this.id = $03ccd63b0299d6a7$var$_id$3++;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isNodeUniformsGroup = true;
    }
}
/**
 * Represents a sampler binding type.
 *
 * @private
 * @augments Binding
 */ class $03ccd63b0299d6a7$var$Sampler extends $03ccd63b0299d6a7$var$Binding {
    /**
	 * Constructs a new sampler.
	 *
	 * @param {string} name - The samplers's name.
	 * @param {?Texture} texture - The texture this binding is referring to.
	 */ constructor(name, texture){
        super(name);
        /**
		 * The texture the sampler is referring to.
		 *
		 * @private
		 * @type {?Texture}
		 */ this._texture = null;
        /**
		 * An event listener which is added to {@link texture}'s dispose event.
		 *
		 * @private
		 * @type {Function}
		 */ this._onTextureDispose = ()=>{
            this.generation = null;
            this.version = -1;
        };
        // Assignment to the texture via a setter must occur after "_onTextureDispose" is initialized.
        this.texture = texture;
        /**
		 * The binding's version.
		 *
		 * @type {number}
		 */ this.version = texture ? texture.version : -1;
        /**
		 * The binding's generation which is an additional version
		 * qualifier.
		 *
		 * @type {?number}
		 * @default null
		 */ this.generation = null;
        /**
		 * The binding's sampler key.
		 *
		 * @type {string}
		 * @default ''
		 */ this.samplerKey = '';
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampler = true;
    }
    /**
	 * Sets the texture of this sampler.
	 *
	 * @param {Texture} value - The texture to set.
	 */ set texture(value) {
        if (this._texture === value) return;
        if (this._texture) this._texture.removeEventListener('dispose', this._onTextureDispose);
        this._texture = value;
        this.generation = null;
        this.version = -1;
        if (this._texture) this._texture.addEventListener('dispose', this._onTextureDispose);
    }
    /**
	 * Gets the texture of this sampler.
	 * @return {?Texture} The texture.
	 */ get texture() {
        return this._texture;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the texture has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        const { texture: texture, version: version } = this;
        if (version !== texture.version) {
            this.version = texture.version;
            return true;
        }
        return false;
    }
    clone() {
        const clonedSampler = super.clone();
        // fix dispose handler for cloned instances
        // TODO: Find better solution, see #31747
        clonedSampler._texture = null;
        clonedSampler._onTextureDispose = ()=>{
            clonedSampler.generation = null;
            clonedSampler.version = -1;
        };
        clonedSampler.texture = this.texture;
        return clonedSampler;
    }
}
let $03ccd63b0299d6a7$var$_id$2 = 0;
/**
 * Represents a sampled texture binding type.
 *
 * @private
 * @augments Sampler
 */ class $03ccd63b0299d6a7$var$SampledTexture extends $03ccd63b0299d6a7$var$Sampler {
    /**
	 * Constructs a new sampled texture.
	 *
	 * @param {string} name - The sampled texture's name.
	 * @param {?Texture} texture - The texture this binding is referring to.
	 */ constructor(name, texture){
        super(name, texture);
        /**
		 * This identifier.
		 *
		 * @type {number}
		 */ this.id = $03ccd63b0299d6a7$var$_id$2++;
        /**
		 * Whether the texture is a storage texture or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.store = false;
        /**
		 * The mip level to bind for storage textures.
		 *
		 * @type {number}
		 * @default 0
		 */ this.mipLevel = 0;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledTexture = true;
    }
}
/**
 * A special form of sampled texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments SampledTexture
 */ class $03ccd63b0299d6a7$var$NodeSampledTexture extends $03ccd63b0299d6a7$var$SampledTexture {
    /**
	 * Constructs a new node-based sampled texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode ? textureNode.value : null);
        /**
		 * The texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
        /**
		 * The access type.
		 *
		 * @type {?string}
		 * @default null
		 */ this.access = access;
    }
    /**
	 * Updates the binding.
	 *
	 * @return {boolean} Whether the texture has been updated and must be
	 * uploaded to the GPU.
	 */ update() {
        const { textureNode: textureNode } = this;
        if (this.texture !== textureNode.value) {
            this.texture = textureNode.value;
            return true;
        }
        return super.update();
    }
}
/**
 * A special form of sampled cube texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments NodeSampledTexture
 */ class $03ccd63b0299d6a7$var$NodeSampledCubeTexture extends $03ccd63b0299d6a7$var$NodeSampledTexture {
    /**
	 * Constructs a new node-based sampled cube texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode, groupNode, access);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledCubeTexture = true;
    }
}
/**
 * A special form of sampled 3D texture binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments NodeSampledTexture
 */ class $03ccd63b0299d6a7$var$NodeSampledTexture3D extends $03ccd63b0299d6a7$var$NodeSampledTexture {
    /**
	 * Constructs a new node-based sampled 3D texture.
	 *
	 * @param {string} name - The textures's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 * @param {?string} [access=null] - The access type.
	 */ constructor(name, textureNode, groupNode, access = null){
        super(name, textureNode, groupNode, access);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSampledTexture3D = true;
    }
}
const $03ccd63b0299d6a7$var$glslPolyfills = {
    bitcast_int_uint: new $03ccd63b0299d6a7$export$347eb46a3090e941(/* glsl */ 'uint tsl_bitcast_int_to_uint ( int x ) { return floatBitsToUint( intBitsToFloat ( x ) ); }'),
    bitcast_uint_int: new $03ccd63b0299d6a7$export$347eb46a3090e941(/* glsl */ 'uint tsl_bitcast_uint_to_int ( uint x ) { return floatBitsToInt( uintBitsToFloat ( x ) ); }')
};
const $03ccd63b0299d6a7$var$glslMethods = {
    textureDimensions: 'textureSize',
    equals: 'equal',
    bitcast_float_int: 'floatBitsToInt',
    bitcast_int_float: 'intBitsToFloat',
    bitcast_uint_float: 'uintBitsToFloat',
    bitcast_float_uint: 'floatBitsToUint',
    bitcast_uint_int: 'tsl_bitcast_uint_to_int',
    bitcast_int_uint: 'tsl_bitcast_int_to_uint',
    floatpack_snorm_2x16: 'packSnorm2x16',
    floatpack_unorm_2x16: 'packUnorm2x16',
    floatpack_float16_2x16: 'packHalf2x16',
    floatunpack_snorm_2x16: 'unpackSnorm2x16',
    floatunpack_unorm_2x16: 'unpackUnorm2x16',
    floatunpack_float16_2x16: 'unpackHalf2x16'
};
const $03ccd63b0299d6a7$var$precisionLib = {
    low: 'lowp',
    medium: 'mediump',
    high: 'highp'
};
const $03ccd63b0299d6a7$var$supports$1 = {
    swizzleAssign: true,
    storageBuffer: false
};
const $03ccd63b0299d6a7$var$interpolationTypeMap = {
    perspective: 'smooth',
    linear: 'noperspective'
};
const $03ccd63b0299d6a7$var$interpolationModeMap = {
    'centroid': 'centroid'
};
const $03ccd63b0299d6a7$var$defaultPrecisions = `
precision highp float;
precision highp int;
precision highp sampler2D;
precision highp sampler3D;
precision highp samplerCube;
precision highp sampler2DArray;

precision highp usampler2D;
precision highp usampler3D;
precision highp usamplerCube;
precision highp usampler2DArray;

precision highp isampler2D;
precision highp isampler3D;
precision highp isamplerCube;
precision highp isampler2DArray;

precision highp sampler2DShadow;
precision highp sampler2DArrayShadow;
precision highp samplerCubeShadow;
`;
/**
 * A node builder targeting GLSL.
 *
 * This module generates GLSL shader code from node materials and also
 * generates the respective bindings and vertex buffer definitions. These
 * data are later used by the renderer to create render and compute pipelines
 * for render objects.
 *
 * @augments NodeBuilder
 */ class $03ccd63b0299d6a7$export$9dbeb41c75797a5a extends $03ccd63b0299d6a7$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new GLSL node builder renderer.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(object, renderer){
        super(object, renderer, new $03ccd63b0299d6a7$export$18a74e8f50eca178());
        /**
		 * A dictionary holds for each shader stage ('vertex', 'fragment', 'compute')
		 * another dictionary which manages UBOs per group ('render','frame','object').
		 *
		 * @type {Object<string,Object<string,NodeUniformsGroup>>}
		 */ this.uniformGroups = {};
        /**
		 * An array that holds objects defining the varying and attribute data in
		 * context of Transform Feedback.
		 *
		 * @type {Array<Object<string,AttributeNode|string>>}
		 */ this.transforms = [];
        /**
		 * A dictionary that holds for each shader stage a Map of used extensions.
		 *
		 * @type {Object<string,Map<string,Object>>}
		 */ this.extensions = {};
        /**
		 * A dictionary that holds for each shader stage an Array of used builtins.
		 *
		 * @type {Object<string,Array<string>>}
		 */ this.builtins = {
            vertex: [],
            fragment: [],
            compute: []
        };
    }
    /**
	 * Checks if the given texture requires a manual conversion to the working color space.
	 *
	 * @param {Texture} texture - The texture to check.
	 * @return {boolean} Whether the given texture requires a conversion to working color space or not.
	 */ needsToWorkingColorSpace(texture) {
        return texture.isVideoTexture === true && texture.colorSpace !== (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51);
    }
    /**
	 * Includes the given method name into the current
	 * function node.
	 *
	 * @private
	 * @param {string} name - The method name to include.
	 * @return {CodeNode} The respective code node.
	 */ _include(name) {
        const codeNode = $03ccd63b0299d6a7$var$glslPolyfills[name];
        codeNode.build(this);
        this.addInclude(codeNode);
        return codeNode;
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved GLSL method name.
	 */ getMethod(method) {
        if ($03ccd63b0299d6a7$var$glslPolyfills[method] !== undefined) this._include(method);
        return $03ccd63b0299d6a7$var$glslMethods[method] || method;
    }
    /**
	 * Returns the bitcast method name for a given input and outputType.
	 *
	 * @param {string} type - The output type to bitcast to.
	 * @param {string} inputType - The input type of the.
	 * @return {string} The resolved WGSL bitcast invocation.
	 */ getBitcastMethod(type, inputType) {
        return this.getMethod(`bitcast_${inputType}_${type}`);
    }
    /**
	 * Returns the float packing method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @returns {string} The resolved GLSL float packing method name.
	 */ getFloatPackingMethod(encoding) {
        return this.getMethod(`floatpack_${encoding}_2x16`);
    }
    /**
	 * Returns the float unpacking method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the integer values are mapped to the float range.
	 * @returns {string} The resolved GLSL float unpacking method name.
	 */ getFloatUnpackingMethod(encoding) {
        return this.getMethod(`floatunpack_${encoding}_2x16`);
    }
    /**
	 * Returns the native snippet for a ternary operation.
	 *
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary(condSnippet, ifSnippet, elseSnippet) {
        return `${condSnippet} ? ${ifSnippet} : ${elseSnippet}`;
    }
    /**
	 * Returns the output struct name. Not relevant for GLSL.
	 *
	 * @return {string}
	 */ getOutputStructName() {
        return '';
    }
    /**
	 * Builds the given shader node.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The GLSL function code.
	 */ buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(this.getType(input.type) + ' ' + input.name);
        //
        const code = `${this.getType(layout.type)} ${layout.name}( ${parameters.join(', ')} ) {

	${flowData.vars}

${flowData.code}
	return ${flowData.result};

}`;
        //
        return code;
    }
    /**
	 * Setups the Pixel Buffer Object (PBO) for the given storage
	 * buffer node.
	 *
	 * @param {StorageBufferNode} storageBufferNode - The storage buffer node.
	 */ setupPBO(storageBufferNode) {
        const attribute = storageBufferNode.value;
        if (attribute.pbo === undefined) {
            const originalArray = attribute.array;
            const numElements = attribute.count * attribute.itemSize;
            const { itemSize: itemSize } = attribute;
            const isInteger = attribute.array.constructor.name.toLowerCase().includes('int');
            let format = isInteger ? (0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190) : (0, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b);
            if (itemSize === 2) format = isInteger ? (0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7) : (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0);
            else if (itemSize === 3) format = isInteger ? (0, $9ddd7e9b53f7a2d4$export$d1fd40c11bfa798e) : (0, $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb);
            else if (itemSize === 4) format = isInteger ? (0, $9ddd7e9b53f7a2d4$export$c200e7d26f592f21) : (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c);
            const typeMap = {
                Float32Array: (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596),
                Uint8Array: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10),
                Uint16Array: (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d),
                Uint32Array: (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96),
                Int8Array: (0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a),
                Int16Array: (0, $9ddd7e9b53f7a2d4$export$88572337f312435f),
                Int32Array: (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2),
                Uint8ClampedArray: (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)
            };
            const width = Math.pow(2, Math.ceil(Math.log2(Math.sqrt(numElements / itemSize))));
            let height = Math.ceil(numElements / itemSize / width);
            if (width * height * itemSize < numElements) height++; // Ensure enough space
            const newSize = width * height * itemSize;
            const newArray = new originalArray.constructor(newSize);
            newArray.set(originalArray, 0);
            attribute.array = newArray;
            const pboTexture = new (0, $9ddd7e9b53f7a2d4$export$b691f601014eabe1)(attribute.array, width, height, format, typeMap[attribute.array.constructor.name] || (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596));
            pboTexture.needsUpdate = true;
            pboTexture.isPBOTexture = true;
            const pbo = new $03ccd63b0299d6a7$export$2dd903bc9e8140bc(pboTexture, null, null);
            pbo.setPrecision('high');
            attribute.pboNode = pbo;
            attribute.pbo = pbo.value;
            this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.nodeName);
        }
    }
    /**
	 * Returns a GLSL snippet that represents the property name of the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeUniform && node.node.isTextureNode !== true && node.node.isBufferNode !== true) return node.name;
        return super.getPropertyName(node, shaderStage);
    }
    /**
	 * Setups the Pixel Buffer Object (PBO) for the given storage
	 * buffer node.
	 *
	 * @param {StorageArrayElementNode} storageArrayElementNode - The storage array element node.
	 * @return {string} The property name.
	 */ generatePBO(storageArrayElementNode) {
        const { node: node, indexNode: indexNode } = storageArrayElementNode;
        const attribute = node.value;
        if (this.renderer.backend.has(attribute)) {
            const attributeData = this.renderer.backend.get(attribute);
            attributeData.pbo = attribute.pbo;
        }
        const nodeUniform = this.getUniformFromNode(attribute.pboNode, 'texture', this.shaderStage, this.context.nodeName);
        const textureName = this.getPropertyName(nodeUniform);
        this.increaseUsage(indexNode); // force cache generate to be used as index in x,y
        const indexSnippet = indexNode.build(this, 'uint');
        const elementNodeData = this.getDataFromNode(storageArrayElementNode);
        let propertyName = elementNodeData.propertyName;
        if (propertyName === undefined) {
            // property element
            const nodeVar = this.getVarFromNode(storageArrayElementNode);
            propertyName = this.getPropertyName(nodeVar);
            // property size
            const bufferNodeData = this.getDataFromNode(node);
            let propertySizeName = bufferNodeData.propertySizeName;
            if (propertySizeName === undefined) {
                propertySizeName = propertyName + 'Size';
                this.getVarFromNode(node, propertySizeName, 'uint');
                this.addLineFlowCode(`${propertySizeName} = uint( textureSize( ${textureName}, 0 ).x )`, storageArrayElementNode);
                bufferNodeData.propertySizeName = propertySizeName;
            }
            //
            const { itemSize: itemSize } = attribute;
            const channel = '.' + $03ccd63b0299d6a7$export$1c0adcb9073b646d.join('').slice(0, itemSize);
            const uvSnippet = `ivec2(${indexSnippet} % ${propertySizeName}, ${indexSnippet} / ${propertySizeName})`;
            const snippet = this.generateTextureLoad(null, textureName, uvSnippet, '0', null, null);
            //
            let prefix = 'vec4';
            if (attribute.pbo.type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) prefix = 'uvec4';
            else if (attribute.pbo.type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) prefix = 'ivec4';
            this.addLineFlowCode(`${propertyName} = ${prefix}(${snippet})${channel}`, storageArrayElementNode);
            elementNodeData.propertyName = propertyName;
        }
        return propertyName;
    }
    /**
	 * Generates the GLSL snippet that reads a single texel from a texture without sampling or filtering.
	 *
	 * @param {?Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A GLSL snippet that represents the 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureLoad(texture, textureProperty, uvIndexSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (levelSnippet === null) levelSnippet = '0';
        let snippet;
        if (depthSnippet) {
            if (offsetSnippet) snippet = `texelFetchOffset( ${textureProperty}, ivec3( ${uvIndexSnippet}, ${depthSnippet} ), int( ${levelSnippet} ), ${offsetSnippet} )`;
            else snippet = `texelFetch( ${textureProperty}, ivec3( ${uvIndexSnippet}, ${depthSnippet} ), int( ${levelSnippet} ) )`;
        } else if (offsetSnippet) snippet = `texelFetchOffset( ${textureProperty}, ${uvIndexSnippet}, int( ${levelSnippet} ), ${offsetSnippet} )`;
        else snippet = `texelFetch( ${textureProperty}, ${uvIndexSnippet}, int( ${levelSnippet} ) )`;
        if (texture !== null && texture.isDepthTexture) snippet += '.x';
        return snippet;
    }
    /**
	 * Generates the GLSL snippet for sampling/loading the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet -  A GLSL snippet that represents the 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet) {
        if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
        if (texture.isDepthTexture) {
            if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet} ).x`;
            return `texture( ${textureProperty}, ${uvSnippet} ).x`;
        }
        if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet} )`;
        return `texture( ${textureProperty}, ${uvSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet when sampling textures with explicit mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A GLSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
        if (offsetSnippet) return `textureLodOffset( ${textureProperty}, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
        return `textureLod( ${textureProperty}, ${uvSnippet}, ${levelSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet when sampling textures with a bias to the mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} biasSnippet - A GLSL snippet that represents the bias to apply to the mip level before sampling.
	 * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, offsetSnippet) {
        if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
        if (offsetSnippet) return `textureOffset( ${textureProperty}, ${uvSnippet}, ${offsetSnippet}, ${biasSnippet} )`;
        return `texture( ${textureProperty}, ${uvSnippet}, ${biasSnippet} )`;
    }
    /**
	 * Generates the GLSL snippet for sampling/loading the given texture using explicit gradients.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {Array<string>} gradSnippet - An array holding both gradient GLSL snippets.
	 * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The GLSL snippet.
	 */ generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, offsetSnippet) {
        if (depthSnippet) uvSnippet = `vec3( ${uvSnippet}, ${depthSnippet} )`;
        if (offsetSnippet) return `textureGradOffset( ${textureProperty}, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]}, ${offsetSnippet} )`;
        return `textureGrad( ${textureProperty}, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]} )`;
    }
    /**
	 * Generates the GLSL snippet for sampling a depth texture and comparing the sampled depth values
	 * against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A GLSL snippet that represents texture coordinates used for sampling.
	 * @param {string} compareSnippet -  A GLSL snippet that represents the reference value.
	 * @param {?string} depthSnippet - A GLSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A GLSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The GLSL snippet.
	 */ generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            // Cube shadow maps use vec4(direction, compareValue)
            if (texture.isCubeTexture) return `texture( ${textureProperty}, vec4( ${uvSnippet}, ${compareSnippet} ) )`;
            if (depthSnippet) {
                if (offsetSnippet) return `textureOffset( ${textureProperty}, vec4( ${uvSnippet}, ${depthSnippet}, ${compareSnippet} ), ${offsetSnippet} )`;
                return `texture( ${textureProperty}, vec4( ${uvSnippet}, ${depthSnippet}, ${compareSnippet} ) )`;
            }
            if (offsetSnippet) return `textureOffset( ${textureProperty}, vec3( ${uvSnippet}, ${compareSnippet} ), ${offsetSnippet} )`;
            return `texture( ${textureProperty}, vec3( ${uvSnippet}, ${compareSnippet} ) )`;
        } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    /**
	 * Returns the uniforms of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the uniforms.
	 */ getUniforms(shaderStage) {
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            let snippet = null;
            let group = false;
            if (uniform.type === 'texture' || uniform.type === 'texture3D') {
                const texture = uniform.node.value;
                let typePrefix = '';
                if (texture.isDataTexture === true || texture.isData3DTexture === true) {
                    if (texture.type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) typePrefix = 'u';
                    else if (texture.type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) typePrefix = 'i';
                }
                if (uniform.type === 'texture3D' && texture.isArrayTexture === false) snippet = `${typePrefix}sampler3D ${uniform.name};`;
                else if (texture.compareFunction) {
                    if (texture.isArrayTexture === true) snippet = `sampler2DArrayShadow ${uniform.name};`;
                    else snippet = `sampler2DShadow ${uniform.name};`;
                } else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) snippet = `${typePrefix}sampler2DArray ${uniform.name};`;
                else snippet = `${typePrefix}sampler2D ${uniform.name};`;
            } else if (uniform.type === 'cubeTexture') snippet = `samplerCube ${uniform.name};`;
            else if (uniform.type === 'cubeDepthTexture') {
                const texture = uniform.node.value;
                if (texture.compareFunction) snippet = `samplerCubeShadow ${uniform.name};`;
                else snippet = `samplerCube ${uniform.name};`;
            } else if (uniform.type === 'buffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.bufferType);
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 ? bufferCount : '';
                snippet = `${bufferNode.name} {\n\t${bufferType} ${uniform.name}[${bufferCountSnippet}];\n};\n`;
            } else {
                const groupName = uniform.groupNode.name;
                // Check if this group has already been processed
                if (uniformGroups[groupName] === undefined) {
                    // Get the shared uniform group that contains uniforms from all stages
                    const sharedUniformGroup = this.uniformGroups[groupName];
                    if (sharedUniformGroup !== undefined) {
                        // Generate snippets for ALL uniforms in this shared group
                        const snippets = [];
                        for (const sharedUniform of sharedUniformGroup.uniforms){
                            const type = sharedUniform.getType();
                            const vectorType = this.getVectorType(type);
                            const precision = sharedUniform.nodeUniform.node.precision;
                            let uniformSnippet = `${vectorType} ${sharedUniform.name};`;
                            if (precision !== null) uniformSnippet = $03ccd63b0299d6a7$var$precisionLib[precision] + ' ' + uniformSnippet;
                            snippets.push('\t' + uniformSnippet);
                        }
                        uniformGroups[groupName] = snippets;
                    }
                }
                group = true;
            }
            if (!group) {
                const precision = uniform.node.precision;
                if (precision !== null) snippet = $03ccd63b0299d6a7$var$precisionLib[precision] + ' ' + snippet;
                snippet = 'uniform ' + snippet;
                bindingSnippets.push(snippet);
            }
        }
        let output = '';
        for(const name in uniformGroups){
            const groupSnippets = uniformGroups[name];
            output += this._getGLSLUniformStruct(name, groupSnippets.join('\n')) + '\n';
        }
        output += bindingSnippets.join('\n');
        return output;
    }
    /**
	 * Returns the type for a given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @return {string} The type.
	 */ getTypeFromAttribute(attribute) {
        let nodeType = super.getTypeFromAttribute(attribute);
        if (/^[iu]/.test(nodeType) && attribute.gpuType !== (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) {
            let dataAttribute = attribute;
            if (attribute.isInterleavedBufferAttribute) dataAttribute = attribute.data;
            const array = dataAttribute.array;
            if ((array instanceof Uint32Array || array instanceof Int32Array) === false) nodeType = nodeType.slice(1);
        }
        return nodeType;
    }
    /**
	 * Returns the shader attributes of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the shader attributes.
	 */ getAttributes(shaderStage) {
        let snippet = '';
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const attributes = this.getAttributesArray();
            let location = 0;
            for (const attribute of attributes)snippet += `layout( location = ${location++} ) in ${attribute.type} ${attribute.name};\n`;
        }
        return snippet;
    }
    /**
	 * Returns the members of the given struct type node as a GLSL string.
	 *
	 * @param {StructTypeNode} struct - The struct type node.
	 * @return {string} The GLSL snippet that defines the struct members.
	 */ getStructMembers(struct) {
        const snippets = [];
        for (const member of struct.members)snippets.push(`\t${member.type} ${member.name};`);
        return snippets.join('\n');
    }
    /**
	 * Returns the structs of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the structs.
	 */ getStructs(shaderStage) {
        const snippets = [];
        const structs = this.structs[shaderStage];
        const outputSnippet = [];
        for (const struct of structs){
            if (struct.output) for (const member of struct.members)outputSnippet.push(`layout( location = ${member.index} ) out ${member.type} ${member.name};`);
            else {
                let snippet = 'struct ' + struct.name + ' {\n';
                snippet += this.getStructMembers(struct);
                snippet += '\n};\n';
                snippets.push(snippet);
            }
        }
        if (outputSnippet.length === 0) outputSnippet.push('layout( location = 0 ) out vec4 fragColor;');
        return '\n' + outputSnippet.join('\n') + '\n\n' + snippets.join('\n');
    }
    /**
	 * Returns the varyings of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the varyings.
	 */ getVaryings(shaderStage) {
        let snippet = '';
        const varyings = this.varyings;
        if (shaderStage === 'vertex' || shaderStage === 'compute') for (const varying of varyings){
            if (shaderStage === 'compute') varying.needsInterpolation = true;
            const type = this.getType(varying.type);
            if (varying.needsInterpolation) {
                if (varying.interpolationType) {
                    const interpolationType = $03ccd63b0299d6a7$var$interpolationTypeMap[varying.interpolationType] || varying.interpolationType;
                    const sampling = $03ccd63b0299d6a7$var$interpolationModeMap[varying.interpolationSampling] || '';
                    snippet += `${interpolationType} ${sampling} out ${type} ${varying.name};\n`;
                } else {
                    const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
                    snippet += `${flat}out ${type} ${varying.name};\n`;
                }
            } else snippet += `${type} ${varying.name};\n`; // generate variable (no varying required)
        }
        else if (shaderStage === 'fragment') {
            for (const varying of varyings)if (varying.needsInterpolation) {
                const type = this.getType(varying.type);
                if (varying.interpolationType) {
                    const interpolationType = $03ccd63b0299d6a7$var$interpolationTypeMap[varying.interpolationType] || varying.interpolationType;
                    const sampling = $03ccd63b0299d6a7$var$interpolationModeMap[varying.interpolationSampling] || '';
                    snippet += `${interpolationType} ${sampling} in ${type} ${varying.name};\n`;
                } else {
                    const flat = type.includes('int') || type.includes('uv') || type.includes('iv') ? 'flat ' : '';
                    snippet += `${flat}in ${type} ${varying.name};\n`;
                }
            }
        }
        for (const builtin of this.builtins[shaderStage])snippet += `${builtin};\n`;
        return snippet;
    }
    /**
	 * Returns the vertex index builtin.
	 *
	 * @return {string} The vertex index.
	 */ getVertexIndex() {
        return 'uint( gl_VertexID )';
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @return {string} The instance index.
	 */ getInstanceIndex() {
        return 'uint( gl_InstanceID )';
    }
    /**
	 * Returns a builtin representing the index of an invocation within its workgroup.
	 *
	 * @return {string} The invocation local index.
	 */ getInvocationLocalIndex() {
        const workgroupSize = this.object.workgroupSize;
        const size = workgroupSize.reduce((acc, curr)=>acc * curr, 1);
        return `uint( gl_InstanceID ) % ${size}u`;
    }
    /**
	 * Returns a builtin representing the size of a subgroup within the current shader.
	 */ getSubgroupSize() {
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('GLSLNodeBuilder: WebGLBackend does not support the subgroupSize node');
    }
    /**
	 * Returns a builtin representing the index of an invocation within its subgroup.
	 */ getInvocationSubgroupIndex() {
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('GLSLNodeBuilder: WebGLBackend does not support the invocationSubgroupIndex node');
    }
    /**
	 * Returns a builtin representing the index of the current invocation's subgroup within its workgroup.
	 */ getSubgroupIndex() {
        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('GLSLNodeBuilder: WebGLBackend does not support the subgroupIndex node');
    }
    /**
	 * Returns the draw index builtin.
	 *
	 * @return {?string} The drawIndex shader string. Returns `null` if `WEBGL_multi_draw` isn't supported by the device.
	 */ getDrawIndex() {
        const extensions = this.renderer.backend.extensions;
        if (extensions.has('WEBGL_multi_draw')) return 'uint( gl_DrawID )';
        else return 'nodeUniformDrawId'; // fallback to uniform
    }
    /**
	 * Returns the front facing builtin.
	 *
	 * @return {string} The front facing builtin.
	 */ getFrontFacing() {
        return 'gl_FrontFacing';
    }
    /**
	 * Returns the frag coord builtin.
	 *
	 * @return {string} The frag coord builtin.
	 */ getFragCoord() {
        return 'gl_FragCoord.xy';
    }
    /**
	 * Returns the frag depth builtin.
	 *
	 * @return {string} The frag depth builtin.
	 */ getFragDepth() {
        return 'gl_FragDepth';
    }
    /**
	 * Enables the given extension.
	 *
	 * @param {string} name - The extension name.
	 * @param {string} behavior - The extension behavior.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage.
	 */ enableExtension(name, behavior, shaderStage = this.shaderStage) {
        const map = this.extensions[shaderStage] || (this.extensions[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            behavior: behavior
        });
    }
    /**
	 * Returns the enabled extensions of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the enabled extensions.
	 */ getExtensions(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') {
            const ext = this.renderer.backend.extensions;
            const isBatchedMesh = this.object.isBatchedMesh;
            if (isBatchedMesh && ext.has('WEBGL_multi_draw')) this.enableExtension('GL_ANGLE_multi_draw', 'require', shaderStage);
        }
        const extensions = this.extensions[shaderStage];
        if (extensions !== undefined) for (const { name: name, behavior: behavior } of extensions.values())snippets.push(`#extension ${name} : ${behavior}`);
        return snippets.join('\n');
    }
    /**
	 * Returns the clip distances builtin.
	 *
	 * @return {string} The clip distances builtin.
	 */ getClipDistance() {
        return 'gl_ClipDistance';
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable(name) {
        let result = $03ccd63b0299d6a7$var$supports$1[name];
        if (result === undefined) {
            let extensionName;
            result = false;
            switch(name){
                case 'float32Filterable':
                    extensionName = 'OES_texture_float_linear';
                    break;
                case 'clipDistance':
                    extensionName = 'WEBGL_clip_cull_distance';
                    break;
            }
            if (extensionName !== undefined) {
                const extensions = this.renderer.backend.extensions;
                if (extensions.has(extensionName)) {
                    extensions.get(extensionName);
                    result = true;
                }
            }
            $03ccd63b0299d6a7$var$supports$1[name] = result;
        }
        return result;
    }
    /**
	 * Whether to flip texture data along its vertical axis or not.
	 *
	 * @return {boolean} Returns always `true` in context of GLSL.
	 */ isFlipY() {
        return true;
    }
    /**
	 * Enables hardware clipping.
	 *
	 * @param {string} planeCount - The clipping plane count.
	 */ enableHardwareClipping(planeCount) {
        this.enableExtension('GL_ANGLE_clip_cull_distance', 'require');
        this.builtins['vertex'].push(`out float gl_ClipDistance[ ${planeCount} ]`);
    }
    /**
	 * Enables multiview.
	 */ enableMultiview() {
        this.enableExtension('GL_OVR_multiview2', 'require', 'fragment');
        this.enableExtension('GL_OVR_multiview2', 'require', 'vertex');
        this.builtins['vertex'].push('layout(num_views = 2) in');
    }
    /**
	 * Registers a transform in context of Transform Feedback.
	 *
	 * @param {string} varyingName - The varying name.
	 * @param {AttributeNode} attributeNode - The attribute node.
	 */ registerTransform(varyingName, attributeNode) {
        this.transforms.push({
            varyingName: varyingName,
            attributeNode: attributeNode
        });
    }
    /**
	 * Returns the transforms of the given shader stage as a GLSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The GLSL snippet that defines the transforms.
	 */ getTransforms() {
        const transforms = this.transforms;
        let snippet = '';
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            const attributeName = this.getPropertyName(transform.attributeNode);
            if (attributeName) snippet += `${transform.varyingName} = ${attributeName};\n\t`;
        }
        return snippet;
    }
    /**
	 * Returns a GLSL struct based on the given name and variables.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @return {string} The GLSL snippet representing a struct.
	 */ _getGLSLUniformStruct(name, vars) {
        return `
layout( std140 ) uniform ${name} {
${vars}
};`;
    }
    /**
	 * Returns a GLSL vertex shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getGLSLVertexCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// extensions
${shaderData.extensions}

// precision
${$03ccd63b0299d6a7$var$defaultPrecisions}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// attributes
${shaderData.attributes}

// vars
${shaderData.vars}

// codes
${shaderData.codes}

void main() {

	// transforms
	${shaderData.transforms}

	// flow
	${shaderData.flow}

	gl_PointSize = 1.0;

}
`;
    }
    /**
	 * Returns a GLSL fragment shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getGLSLFragmentCode(shaderData) {
        return `#version 300 es

${this.getSignature()}

// extensions
${shaderData.extensions}

// precision
${$03ccd63b0299d6a7$var$defaultPrecisions}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}

// vars
${shaderData.vars}

// codes
${shaderData.codes}

void main() {

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Controls the code build of the shader stages.
	 */ buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n\t`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\t';
                    if (shaderStage === 'vertex') {
                        flow += 'gl_Position = ';
                        flow += `${flowSlotData.result};`;
                    } else if (shaderStage === 'fragment') {
                        if (!node.outputNode.isOutputStructNode) {
                            flow += 'fragColor = ';
                            flow += `${flowSlotData.result};`;
                        }
                    }
                }
            }
            const stageData = shadersData[shaderStage];
            stageData.extensions = this.getExtensions(shaderStage);
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.vars = this.getVars(shaderStage, true);
            stageData.structs = this.getStructs(shaderStage);
            stageData.codes = this.getCodes(shaderStage);
            stageData.transforms = this.getTransforms(shaderStage);
            stageData.flow = flow;
            // fallbacks
            if (shaderStage === 'vertex') {
                const ext = this.renderer.backend.extensions;
                if (this.object.isBatchedMesh && ext.has('WEBGL_multi_draw') === false) stageData.uniforms += '\nuniform uint nodeUniformDrawId;\n';
            }
        }
        if (this.material !== null) {
            this.vertexShader = this._getGLSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getGLSLFragmentCode(shadersData.fragment);
        } else this.computeShader = this._getGLSLVertexCode(shadersData.compute);
    }
    /**
	 * This method is one of the more important ones since it's responsible
	 * for generating a matching binding instance for the given uniform node.
	 *
	 * These bindings are later used in the renderer to create bind groups
	 * and layouts.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The node data type.
	 * @param {string} shaderStage - The shader stage.
	 * @param {?string} [name=null] - An optional uniform name.
	 * @return {NodeUniform} The node uniform object.
	 */ getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        let uniformGPU = nodeData.uniformGPU;
        if (uniformGPU === undefined) {
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture') {
                uniformGPU = new $03ccd63b0299d6a7$var$NodeSampledTexture(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'cubeTexture' || type === 'cubeDepthTexture') {
                uniformGPU = new $03ccd63b0299d6a7$var$NodeSampledCubeTexture(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'texture3D') {
                uniformGPU = new $03ccd63b0299d6a7$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group);
                bindings.push(uniformGPU);
            } else if (type === 'buffer') {
                uniformNode.name = `buffer${node.id}`;
                const sharedData = this.getSharedDataFromNode(node);
                let buffer = sharedData.buffer;
                if (buffer === undefined) {
                    node.name = `NodeBuffer_${node.id}`;
                    buffer = new $03ccd63b0299d6a7$var$NodeUniformBuffer(node, group);
                    buffer.name = node.name;
                    sharedData.buffer = buffer;
                }
                bindings.push(buffer);
                uniformGPU = buffer;
            } else {
                let uniformsGroup = this.uniformGroups[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new $03ccd63b0299d6a7$var$NodeUniformsGroup(groupName, group);
                    this.uniformGroups[groupName] = uniformsGroup;
                    bindings.push(uniformsGroup);
                } else // Add to bindings for this stage if not already present
                if (bindings.indexOf(uniformsGroup) === -1) bindings.push(uniformsGroup);
                uniformGPU = this.getNodeUniform(uniformNode, type);
                // Only add uniform if not already present in the group (check by name to avoid duplicates across stages)
                const uniformName = uniformGPU.name;
                const alreadyExists = uniformsGroup.uniforms.some((u)=>u.name === uniformName);
                if (!alreadyExists) uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
}
let $03ccd63b0299d6a7$var$_vector2 = null;
let $03ccd63b0299d6a7$var$_color4 = null;
/**
 * Most of the rendering related logic is implemented in the
 * {@link Renderer} module and related management components.
 * Sometimes it is required though to execute commands which are
 * specific to the current 3D backend (which is WebGPU or WebGL 2).
 * This abstract base class defines an interface that encapsulates
 * all backend-related logic. Derived classes for each backend must
 * implement the interface.
 *
 * @abstract
 * @private
 */ class $03ccd63b0299d6a7$var$Backend {
    /**
	 * Constructs a new backend.
	 *
	 * @param {Object} parameters - An object holding parameters for the backend.
	 */ constructor(parameters = {}){
        /**
		 * The parameters of the backend.
		 *
		 * @type {Object}
		 */ this.parameters = Object.assign({}, parameters);
        /**
		 * This weak map holds backend-specific data of objects
		 * like textures, attributes or render targets.
		 *
		 * @type {WeakMap<Object, Object>}
		 */ this.data = new WeakMap();
        /**
		 * A reference to the renderer.
		 *
		 * @type {?Renderer}
		 * @default null
		 */ this.renderer = null;
        /**
		 * A reference to the canvas element the renderer is drawing to.
		 *
		 * @type {?(HTMLCanvasElement|OffscreenCanvas)}
		 * @default null
		 */ this.domElement = null;
        /**
		 * A reference to the timestamp query pool.
   		 *
   		 * @type {{render: ?TimestampQueryPool, compute: ?TimestampQueryPool}}
		 */ this.timestampQueryPool = {
            [(0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).RENDER]: null,
            [(0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).COMPUTE]: null
        };
        /**
		 * Whether to track timestamps with a Timestamp Query API or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.trackTimestamp = parameters.trackTimestamp === true;
    }
    /**
	 * Initializes the backend so it is ready for usage. Concrete backends
	 * are supposed to implement their rendering context creation and related
	 * operations in this method.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the backend has been initialized.
	 */ async init(renderer) {
        this.renderer = renderer;
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @abstract
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {}
    // render context
    /**
	 * This method is executed at the beginning of a render call and
	 * can be used by the backend to prepare the state for upcoming
	 * draw calls.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender() {}
    /**
	 * This method is executed at the end of a render call and
	 * can be used by the backend to finalize work after draw
	 * calls.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender() {}
    /**
	 * This method is executed at the beginning of a compute call and
	 * can be used by the backend to prepare the state for upcoming
	 * compute tasks.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute() {}
    /**
	 * This method is executed at the end of a compute call and
	 * can be used by the backend to finalize work after compute
	 * tasks.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute() {}
    // render object
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw() {}
    // compute node
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @abstract
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 */ compute() {}
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @abstract
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram() {}
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @abstract
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram() {}
    // bindings
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings() {}
    /**
	 * Updates the given bind group definition.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings() {}
    /**
	 * Updates a buffer binding.
	 *
	 * @abstract
	 * @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding() {}
    // pipeline
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline() {}
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @abstract
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline() {}
    // cache key
    /**
	 * Returns `true` if the render pipeline requires an update.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate() {}
    /**
	 * Returns a cache key that is used to identify render pipelines.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey() {}
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @abstract
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {NodeBuilder} The node builder.
	 */ createNodeBuilder() {}
    // textures
    /**
	 * Updates a GPU sampler for the given texture.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler() {}
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture() {}
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture() {}
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture() {}
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps() {}
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @abstract
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture() {}
    /**
	 * Returns texture data as a typed array.
	 *
	 * @abstract
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer() {}
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @abstract
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture() {}
    /**
	* Copies the current bound framebuffer to the given texture.
	*
	* @abstract
	* @param {Texture} texture - The destination texture.
	* @param {RenderContext} renderContext - The render context.
	* @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	*/ copyFramebufferToTexture() {}
    // attributes
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute() {}
    /**
	 * Creates the GPU buffer of an indexed shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute() {}
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute() {}
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute() {}
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @abstract
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute() {}
    // canvas
    /**
	 * Returns the backend's rendering context.
	 *
	 * @abstract
	 * @return {Object} The rendering context.
	 */ getContext() {}
    /**
	 * Backends can use this method if they have to run
	 * logic when the renderer gets resized.
	 *
	 * @abstract
	 */ updateSize() {}
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport() {}
    // utils
    /**
	 * Updates a unique identifier for the given render context that can be used
	 * to allocate resources like occlusion queries or timestamp queries.
	 *
	 * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
	 */ updateTimeStampUID(abstractRenderContext) {
        const contextData = this.get(abstractRenderContext);
        const frame = this.renderer.info.frame;
        let prefix;
        if (abstractRenderContext.isComputeNode === true) prefix = 'c:' + this.renderer.info.compute.frameCalls;
        else prefix = 'r:' + this.renderer.info.render.frameCalls;
        contextData.timestampUID = prefix + ':' + abstractRenderContext.id + ':f' + frame;
    }
    /**
	 * Returns a unique identifier for the given render context that can be used
	 * to allocate resources like occlusion queries or timestamp queries.
	 *
	 * @param {RenderContext|ComputeNode} abstractRenderContext - The render context.
	 * @return {string} The unique identifier.
	 */ getTimestampUID(abstractRenderContext) {
        return this.get(abstractRenderContext).timestampUID;
    }
    /**
	 * Returns all timestamp frames for the given type.
	 *
	 * @param {string} type - The type of the time stamp.
	 * @return {Array<number>} The timestamp frames.
	 */ getTimestampFrames(type) {
        const queryPool = this.timestampQueryPool[type];
        return queryPool ? queryPool.getTimestampFrames() : [];
    }
    /**
	 * Returns the query pool for the given uid.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {TimestampQueryPool} The query pool.
	 */ _getQueryPool(uid) {
        const type = uid.startsWith('c:') ? (0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).COMPUTE : (0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).RENDER;
        const queryPool = this.timestampQueryPool[type];
        return queryPool;
    }
    /**
	 * Returns the timestamp for the given uid.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {number} The timestamp.
	 */ getTimestamp(uid) {
        const queryPool = this._getQueryPool(uid);
        return queryPool.getTimestamp(uid);
    }
    /**
	 * Returns `true` if a timestamp for the given uid is available.
	 *
	 * @param {string} uid - The unique identifier.
	 * @return {boolean} Whether the timestamp is available or not.
	 */ hasTimestamp(uid) {
        const queryPool = this._getQueryPool(uid);
        return queryPool.hasTimestamp(uid);
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene. Backends must implement this method by using
	 * a Occlusion Query API.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded() {}
    /**
	 * Resolves the time stamp for the given render context and type.
	 *
	 * @async
	 * @abstract
	 * @param {string} [type='render'] - The type of the time stamp.
	 * @return {Promise<number>} A Promise that resolves with the time stamp.
	 */ async resolveTimestampsAsync(type = 'render') {
        if (!this.trackTimestamp) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGPURenderer: Timestamp tracking is disabled.');
            return;
        }
        const queryPool = this.timestampQueryPool[type];
        if (!queryPool) return;
        const duration = await queryPool.resolveQueriesAsync();
        this.renderer.info[type].timestamp = duration;
        return duration;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU.
	 *
	 * @async
	 * @param {StorageBufferAttribute} attribute - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync() {}
    /**
	 * Checks if the given feature is supported by the backend.
	 *
	 * @async
	 * @abstract
	 * @param {string} name - The feature's name.
	 * @return {Promise<boolean>} A Promise that resolves with a bool that indicates whether the feature is supported or not.
	 */ async hasFeatureAsync() {}
    /**
	 * Checks if the given feature is supported  by the backend.
	 *
	 * @abstract
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature() {}
    /**
	 * Returns the drawing buffer size.
	 *
	 * @return {Vector2} The drawing buffer size.
	 */ getDrawingBufferSize() {
        $03ccd63b0299d6a7$var$_vector2 = $03ccd63b0299d6a7$var$_vector2 || new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        return this.renderer.getDrawingBufferSize($03ccd63b0299d6a7$var$_vector2);
    }
    /**
	 * Defines the scissor test.
	 *
	 * @abstract
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest() {}
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const renderer = this.renderer;
        $03ccd63b0299d6a7$var$_color4 = $03ccd63b0299d6a7$var$_color4 || new $03ccd63b0299d6a7$var$Color4();
        renderer.getClearColor($03ccd63b0299d6a7$var$_color4);
        $03ccd63b0299d6a7$var$_color4.getRGB($03ccd63b0299d6a7$var$_color4);
        return $03ccd63b0299d6a7$var$_color4;
    }
    /**
	 * Returns the DOM element. If no DOM element exists, the backend
	 * creates a new one.
	 *
	 * @return {HTMLCanvasElement} The DOM element.
	 */ getDomElement() {
        let domElement = this.domElement;
        if (domElement === null) {
            domElement = this.parameters.canvas !== undefined ? this.parameters.canvas : (0, $9ddd7e9b53f7a2d4$export$1033a2df66368859)();
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in domElement) domElement.setAttribute('data-engine', `three.js r${(0, $9ddd7e9b53f7a2d4$export$3545e07a80636437)} webgpu`);
            this.domElement = domElement;
        }
        return domElement;
    }
    /**
	 * Checks if the backend has the given compatibility.
	 *
	 * @abstract
	 * @param {string} name - The compatibility.
	 * @return {boolean} Whether the backend has the given compatibility or not.
	 */ hasCompatibility() {
        return false;
    }
    /**
	 * Initializes the render target defined in the given render context.
	 *
	 * @abstract
	 * @param {RenderContext} renderContext - The render context.
	 */ initRenderTarget() {}
    /**
	 * Sets a dictionary for the given object into the
	 * internal data structure.
	 *
	 * @param {Object} object - The object.
	 * @param {Object} value - The dictionary to set.
	 */ set(object, value) {
        this.data.set(object, value);
    }
    /**
	 * Returns the dictionary for the given object.
	 *
	 * @param {Object} object - The object.
	 * @return {Object} The object's dictionary.
	 */ get(object) {
        let map = this.data.get(object);
        if (map === undefined) {
            map = {};
            this.data.set(object, map);
        }
        return map;
    }
    /**
	 * Checks if the given object has a dictionary
	 * with data defined.
	 *
	 * @param {Object} object - The object.
	 * @return {boolean} Whether a dictionary for the given object as been defined or not.
	 */ has(object) {
        return this.data.has(object);
    }
    /**
	 * Deletes an object from the internal data structure.
	 *
	 * @param {Object} object - The object to delete.
	 */ delete(object) {
        this.data.delete(object);
    }
    /**
	 * Delete GPU data associated with a bind group.
	 *
	 * @abstract
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData() {}
    /**
	 * Frees internal resources.
	 *
	 * @abstract
	 */ dispose() {}
}
let $03ccd63b0299d6a7$var$_id$1 = 0;
/**
 * This module is internally used in context of compute shaders.
 * This type of shader is not natively supported in WebGL 2 and
 * thus implemented via Transform Feedback. `DualAttributeData`
 * manages the related data.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$DualAttributeData {
    constructor(attributeData, dualBuffer){
        this.buffers = [
            attributeData.bufferGPU,
            dualBuffer
        ];
        this.type = attributeData.type;
        this.bufferType = attributeData.bufferType;
        this.pbo = attributeData.pbo;
        this.byteLength = attributeData.byteLength;
        this.bytesPerElement = attributeData.BYTES_PER_ELEMENT;
        this.version = attributeData.version;
        this.isInteger = attributeData.isInteger;
        this.activeBufferIndex = 0;
        this.baseId = attributeData.id;
    }
    get id() {
        return `${this.baseId}|${this.activeBufferIndex}`;
    }
    get bufferGPU() {
        return this.buffers[this.activeBufferIndex];
    }
    get transformBuffer() {
        return this.buffers[this.activeBufferIndex ^ 1];
    }
    switchBuffers() {
        this.activeBufferIndex ^= 1;
    }
}
/**
 * A WebGL 2 backend utility module for managing shader attributes.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGLAttributeUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
    }
    /**
	 * Creates the GPU buffer for the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
	 */ createAttribute(attribute, bufferType) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const usage = attribute.usage || gl.STATIC_DRAW;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        let bufferGPU = bufferData.bufferGPU;
        if (bufferGPU === undefined) {
            bufferGPU = this._createBuffer(gl, bufferType, array, usage);
            bufferData.bufferGPU = bufferGPU;
            bufferData.bufferType = bufferType;
            bufferData.version = bufferAttribute.version;
        }
        //attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLBackend: Unsupported buffer data format: ' + array);
        let attributeData = {
            bufferGPU: bufferGPU,
            bufferType: bufferType,
            type: type,
            byteLength: array.byteLength,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            pbo: attribute.pbo,
            isInteger: type === gl.INT || type === gl.UNSIGNED_INT || attribute.gpuType === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2),
            id: $03ccd63b0299d6a7$var$_id$1++
        };
        if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) {
            // create buffer for transform feedback use
            const bufferGPUDual = this._createBuffer(gl, bufferType, array, usage);
            attributeData = new $03ccd63b0299d6a7$var$DualAttributeData(attributeData, bufferGPUDual);
        }
        backend.set(attribute, attributeData);
    }
    /**
	 * Updates the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ updateAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const array = attribute.array;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const bufferData = backend.get(bufferAttribute);
        const bufferType = bufferData.bufferType;
        const updateRanges = attribute.isInterleavedBufferAttribute ? attribute.data.updateRanges : attribute.updateRanges;
        gl.bindBuffer(bufferType, bufferData.bufferGPU);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            bufferAttribute.clearUpdateRanges();
        }
        gl.bindBuffer(bufferType, null);
        bufferData.version = bufferAttribute.version;
    }
    /**
	 * Destroys the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ destroyAttribute(attribute) {
        const backend = this.backend;
        const { gl: gl } = backend;
        if (attribute.isInterleavedBufferAttribute) backend.delete(attribute.data);
        const attributeData = backend.get(attribute);
        gl.deleteBuffer(attributeData.bufferGPU);
        backend.delete(attribute);
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU. ReadbackBuffer can
	 * be used to retain and reuse handles to the intermediate buffers and prevent
	 * new allocation.
	 *
	 * @async
	 * @param {BufferAttribute} attribute - The storage buffer attribute to read frm.
	 * @param {ReadbackBuffer|ArrayBuffer} target - The storage buffer attribute.
	 * @param {number} offset - The storage buffer attribute.
	 * @param {number} count - The offset from which to start reading the
	 * @return {Promise<ArrayBuffer|ReadbackBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute, target = null, offset = 0, count = -1) {
        const backend = this.backend;
        const { gl: gl } = backend;
        const bufferAttribute = attribute.isInterleavedBufferAttribute ? attribute.data : attribute;
        const attributeInfo = backend.get(bufferAttribute);
        const { bufferGPU: bufferGPU } = attributeInfo;
        const byteLength = count === -1 ? attributeInfo.byteLength - offset : count;
        // read the data back
        let dstBuffer;
        if (target === null) dstBuffer = new Uint8Array(new ArrayBuffer(byteLength));
        else if (target.isReadbackBuffer) {
            if (target._mapped === true) throw new Error('WebGPURenderer: ReadbackBuffer must be released before being used again.');
            const releaseCallback = ()=>{
                target.buffer = null;
                target._mapped = false;
                target.removeEventListener('release', releaseCallback);
                target.removeEventListener('dispose', releaseCallback);
            };
            target.addEventListener('release', releaseCallback);
            target.addEventListener('dispose', releaseCallback);
            // WebGL has no concept of a "mapped" data buffer so we create a new buffer, instead.
            dstBuffer = new Uint8Array(new ArrayBuffer(byteLength));
            target.buffer = dstBuffer.buffer;
        } else dstBuffer = new Uint8Array(target);
        // Ensure the buffer is bound before reading
        gl.bindBuffer(gl.COPY_READ_BUFFER, bufferGPU);
        gl.getBufferSubData(gl.COPY_READ_BUFFER, offset, dstBuffer);
        gl.bindBuffer(gl.COPY_READ_BUFFER, null);
        gl.bindBuffer(gl.COPY_WRITE_BUFFER, null);
        // return the appropriate type
        if (target && target.isReadbackBuffer) return target;
        else return dstBuffer.buffer;
    }
    /**
	 * Creates a WebGL buffer with the given data.
	 *
	 * @private
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 * @param {GLenum } bufferType - A flag that indicates the buffer type and thus binding point target.
	 * @param {TypedArray} array - The array of the buffer attribute.
	 * @param {GLenum} usage - The usage.
	 * @return {WebGLBuffer} The WebGL buffer.
	 */ _createBuffer(gl, bufferType, array, usage) {
        const bufferGPU = gl.createBuffer();
        gl.bindBuffer(bufferType, bufferGPU);
        gl.bufferData(bufferType, array, usage);
        gl.bindBuffer(bufferType, null);
        return bufferGPU;
    }
}
let $03ccd63b0299d6a7$var$equationToGL, $03ccd63b0299d6a7$var$factorToGL;
/**
 * A WebGL 2 backend utility module for managing the WebGL state.
 *
 * The major goal of this module is to reduce the number of state changes
 * by caching the WEbGL state with a series of variables. In this way, the
 * renderer only executes state change commands when necessary which
 * improves the overall performance.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGLState {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        // Below properties are intended to cache
        // the WebGL state and are not explicitly
        // documented for convenience reasons.
        this.enabled = {};
        this.parameters = {};
        this.currentFlipSided = null;
        this.currentCullFace = null;
        this.currentProgram = null;
        this.currentBlendingEnabled = false;
        this.currentBlending = null;
        this.currentBlendSrc = null;
        this.currentBlendDst = null;
        this.currentBlendSrcAlpha = null;
        this.currentBlendDstAlpha = null;
        this.currentPremultipledAlpha = null;
        this.currentPolygonOffsetFactor = null;
        this.currentPolygonOffsetUnits = null;
        this.currentColorMask = null;
        this.currentDepthReversed = false;
        this.currentDepthFunc = null;
        this.currentDepthMask = null;
        this.currentStencilFunc = null;
        this.currentStencilRef = null;
        this.currentStencilFuncMask = null;
        this.currentStencilFail = null;
        this.currentStencilZFail = null;
        this.currentStencilZPass = null;
        this.currentStencilMask = null;
        this.currentLineWidth = null;
        this.currentClippingPlanes = 0;
        this.currentVAO = null;
        this.currentIndex = null;
        this.currentBoundFramebuffers = {};
        this.currentDrawbuffers = new WeakMap();
        this.maxTextures = this.gl.getParameter(this.gl.MAX_TEXTURE_IMAGE_UNITS);
        this.currentTextureSlot = null;
        this.currentBoundTextures = {};
        this.currentBoundBufferBases = {};
        this._init();
    }
    /**
	 * Inits the state of the utility.
	 *
	 * @private
	 */ _init() {
        const gl = this.gl;
        // Store only WebGL constants here.
        $03ccd63b0299d6a7$var$equationToGL = {
            [(0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0)]: gl.FUNC_ADD,
            [(0, $9ddd7e9b53f7a2d4$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
            [(0, $9ddd7e9b53f7a2d4$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
        };
        $03ccd63b0299d6a7$var$factorToGL = {
            [(0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d)]: gl.ZERO,
            [(0, $9ddd7e9b53f7a2d4$export$8805bad65e24940e)]: gl.ONE,
            [(0, $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
            [(0, $9ddd7e9b53f7a2d4$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
            [(0, $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
            [(0, $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
            [(0, $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
            [(0, $9ddd7e9b53f7a2d4$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
            [(0, $9ddd7e9b53f7a2d4$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
            [(0, $9ddd7e9b53f7a2d4$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
            [(0, $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA
        };
        const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
        const viewportParam = gl.getParameter(gl.VIEWPORT);
        this.currentScissor = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)().fromArray(scissorParam);
        this.currentViewport = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)().fromArray(viewportParam);
        this._tempVec4 = new (0, $9ddd7e9b53f7a2d4$export$fa7daccca11cdbe3)();
    }
    /**
	 * Enables the given WebGL capability.
	 *
	 * This method caches the capability state so
	 * `gl.enable()` is only called when necessary.
	 *
	 * @param {GLenum} id - The capability to enable.
	 */ enable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== true) {
            this.gl.enable(id);
            enabled[id] = true;
        }
    }
    /**
	 * Disables the given WebGL capability.
	 *
	 * This method caches the capability state so
	 * `gl.disable()` is only called when necessary.
	 *
	 * @param {GLenum} id - The capability to enable.
	 */ disable(id) {
        const { enabled: enabled } = this;
        if (enabled[id] !== false) {
            this.gl.disable(id);
            enabled[id] = false;
        }
    }
    /**
	 * Specifies whether polygons are front- or back-facing
	 * by setting the winding orientation.
	 *
	 * This method caches the state so `gl.frontFace()` is only
	 * called when necessary.
	 *
	 * @param {boolean} flipSided - Whether triangles flipped their sides or not.
	 */ setFlipSided(flipSided) {
        if (this.currentFlipSided !== flipSided) {
            const { gl: gl } = this;
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            this.currentFlipSided = flipSided;
        }
    }
    /**
	 * Specifies whether or not front- and/or back-facing
	 * polygons can be culled.
	 *
	 * This method caches the state so `gl.cullFace()` is only
	 * called when necessary.
	 *
	 * @param {number} cullFace - Defines which polygons are candidates for culling.
	 */ setCullFace(cullFace) {
        const { gl: gl } = this;
        if (cullFace !== (0, $9ddd7e9b53f7a2d4$export$3237e1f2c1ea1f44)) {
            this.enable(gl.CULL_FACE);
            if (cullFace !== this.currentCullFace) {
                if (cullFace === (0, $9ddd7e9b53f7a2d4$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $9ddd7e9b53f7a2d4$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else this.disable(gl.CULL_FACE);
        this.currentCullFace = cullFace;
    }
    /**
	 * Specifies the width of line primitives.
	 *
	 * This method caches the state so `gl.lineWidth()` is only
	 * called when necessary.
	 *
	 * @param {number} width - The line width.
	 */ setLineWidth(width) {
        const { currentLineWidth: currentLineWidth, gl: gl } = this;
        if (width !== currentLineWidth) {
            gl.lineWidth(width);
            this.currentLineWidth = width;
        }
    }
    setMRTBlending(textures, mrt, material) {
        const gl = this.gl;
        const drawBuffersIndexedExt = this.backend.drawBuffersIndexedExt;
        if (!drawBuffersIndexedExt) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGPURenderer: Multiple Render Targets (MRT) blending configuration is not fully supported in compatibility mode. The material blending will be used for all render targets.');
            return;
        }
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            let blending = null;
            if (mrt !== null) {
                const blendMode = mrt.getBlendMode(texture.name);
                if (blendMode.blending === (0, $9ddd7e9b53f7a2d4$export$ec822fcd0c1d2914)) // use material blending
                blending = material;
                else if (blendMode.blending !== (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) blending = blendMode;
            } else // use material blending
            blending = material;
            if (blending !== null) this._setMRTBlendingIndex(i, blending);
            else // use opaque blending (no blending)
            drawBuffersIndexedExt.blendFuncSeparateiOES(i, gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        }
    }
    /**
	 * Applies blending configuration for a specific draw buffer index.
	 *
	 * @private
	 * @param {number} index - The draw buffer index.
	 * @param {Object} blending - The blending configuration (material or BlendMode).
	 */ _setMRTBlendingIndex(index, blending) {
        const { gl: gl } = this;
        const drawBuffersIndexedExt = this.backend.drawBuffersIndexedExt;
        const blendingType = blending.blending;
        const blendSrc = blending.blendSrc;
        const blendDst = blending.blendDst;
        const blendEquation = blending.blendEquation;
        const premultipliedAlpha = blending.premultipliedAlpha;
        if (blendingType === (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2)) {
            const blendSrcAlpha = blending.blendSrcAlpha !== null ? blending.blendSrcAlpha : blendSrc;
            const blendDstAlpha = blending.blendDstAlpha !== null ? blending.blendDstAlpha : blendDst;
            const blendEquationAlpha = blending.blendEquationAlpha !== null ? blending.blendEquationAlpha : blendEquation;
            drawBuffersIndexedExt.blendEquationSeparateiOES(index, $03ccd63b0299d6a7$var$equationToGL[blendEquation], $03ccd63b0299d6a7$var$equationToGL[blendEquationAlpha]);
            drawBuffersIndexedExt.blendFuncSeparateiOES(index, $03ccd63b0299d6a7$var$factorToGL[blendSrc], $03ccd63b0299d6a7$var$factorToGL[blendDst], $03ccd63b0299d6a7$var$factorToGL[blendSrcAlpha], $03ccd63b0299d6a7$var$factorToGL[blendDstAlpha]);
        } else {
            drawBuffersIndexedExt.blendEquationSeparateiOES(index, gl.FUNC_ADD, gl.FUNC_ADD);
            if (premultipliedAlpha) switch(blendingType){
                case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.ONE, gl.ONE, gl.ONE, gl.ONE);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                    break;
                default:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    break;
            }
            else switch(blendingType){
                case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                    break;
                default:
                    drawBuffersIndexedExt.blendFuncSeparateiOES(index, gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                    break;
            }
        }
    }
    /**
	 * Defines the blending.
	 *
	 * This method caches the state so `gl.blendEquation()`, `gl.blendEquationSeparate()`,
	 * `gl.blendFunc()` and  `gl.blendFuncSeparate()` are only called when necessary.
	 *
	 * @param {number} blending - The blending type.
	 * @param {number} blendEquation - The blending equation.
	 * @param {number} blendSrc - Only relevant for custom blending. The RGB source blending factor.
	 * @param {number} blendDst - Only relevant for custom blending. The RGB destination blending factor.
	 * @param {number} blendEquationAlpha - Only relevant for custom blending. The blending equation for alpha.
	 * @param {number} blendSrcAlpha - Only relevant for custom blending. The alpha source blending factor.
	 * @param {number} blendDstAlpha - Only relevant for custom blending. The alpha destination blending factor.
	 * @param {boolean} premultipliedAlpha - Whether premultiplied alpha is enabled or not.
	 */ setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        const { gl: gl } = this;
        if (blending === (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) {
            if (this.currentBlendingEnabled === true) {
                this.disable(gl.BLEND);
                this.currentBlendingEnabled = false;
            }
            return;
        }
        if (this.currentBlendingEnabled === false) {
            this.enable(gl.BLEND);
            this.currentBlendingEnabled = true;
        }
        if (blending !== (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2)) {
            if (blending !== this.currentBlending || premultipliedAlpha !== this.currentPremultipledAlpha) {
                if (this.currentBlendEquation !== (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0) || this.currentBlendEquationAlpha !== (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    this.currentBlendEquation = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
                    this.currentBlendEquationAlpha = (0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                this.currentBlendSrc = null;
                this.currentBlendDst = null;
                this.currentBlendSrcAlpha = null;
                this.currentBlendDstAlpha = null;
                this.currentBlending = blending;
                this.currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== this.currentBlendEquation || blendEquationAlpha !== this.currentBlendEquationAlpha) {
            gl.blendEquationSeparate($03ccd63b0299d6a7$var$equationToGL[blendEquation], $03ccd63b0299d6a7$var$equationToGL[blendEquationAlpha]);
            this.currentBlendEquation = blendEquation;
            this.currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== this.currentBlendSrc || blendDst !== this.currentBlendDst || blendSrcAlpha !== this.currentBlendSrcAlpha || blendDstAlpha !== this.currentBlendDstAlpha) {
            gl.blendFuncSeparate($03ccd63b0299d6a7$var$factorToGL[blendSrc], $03ccd63b0299d6a7$var$factorToGL[blendDst], $03ccd63b0299d6a7$var$factorToGL[blendSrcAlpha], $03ccd63b0299d6a7$var$factorToGL[blendDstAlpha]);
            this.currentBlendSrc = blendSrc;
            this.currentBlendDst = blendDst;
            this.currentBlendSrcAlpha = blendSrcAlpha;
            this.currentBlendDstAlpha = blendDstAlpha;
        }
        this.currentBlending = blending;
        this.currentPremultipledAlpha = false;
    }
    /**
	 * Specifies whether colors can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.colorMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} colorMask - The color mask.
	 */ setColorMask(colorMask) {
        if (this.currentColorMask !== colorMask) {
            this.gl.colorMask(colorMask, colorMask, colorMask, colorMask);
            this.currentColorMask = colorMask;
        }
    }
    /**
	 * Specifies whether the depth test is enabled or not.
	 *
	 * @param {boolean} depthTest - Whether the depth test is enabled or not.
	 */ setDepthTest(depthTest) {
        const { gl: gl } = this;
        if (depthTest) this.enable(gl.DEPTH_TEST);
        else this.disable(gl.DEPTH_TEST);
    }
    /**
	 * Configures the WebGL state to use a reversed depth buffer.
	 *
	 * @param {boolean} reversed - Whether the depth buffer is reversed or not.
	 */ setReversedDepth(reversed) {
        if (this.currentDepthReversed !== reversed) {
            const ext = this.backend.extensions.get('EXT_clip_control');
            if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
            else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
            this.currentDepthReversed = reversed;
        }
    }
    /**
	 * Specifies whether depth values can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.depthMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} depthMask - The depth mask.
	 */ setDepthMask(depthMask) {
        if (this.currentDepthMask !== depthMask) {
            this.gl.depthMask(depthMask);
            this.currentDepthMask = depthMask;
        }
    }
    /**
	 * Specifies the depth compare function.
	 *
	 * This method caches the state so `gl.depthFunc()` is only
	 * called when necessary.
	 *
	 * @param {number} depthFunc - The depth compare function.
	 */ setDepthFunc(depthFunc) {
        if (this.currentDepthReversed) depthFunc = (0, $9ddd7e9b53f7a2d4$export$611f4ad2374e11ff)[depthFunc];
        if (this.currentDepthFunc !== depthFunc) {
            const { gl: gl } = this;
            switch(depthFunc){
                case 0, $9ddd7e9b53f7a2d4$export$69025ce147cee220:
                    gl.depthFunc(gl.NEVER);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04:
                    gl.depthFunc(gl.ALWAYS);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe:
                    gl.depthFunc(gl.LESS);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$296f78a0b892f81a:
                    gl.depthFunc(gl.LEQUAL);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e:
                    gl.depthFunc(gl.EQUAL);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4:
                    gl.depthFunc(gl.GEQUAL);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c5e2c52991f30937:
                    gl.depthFunc(gl.GREATER);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2f843afa843d8916:
                    gl.depthFunc(gl.NOTEQUAL);
                    break;
                default:
                    gl.depthFunc(gl.LEQUAL);
            }
            this.currentDepthFunc = depthFunc;
        }
    }
    /**
	 * Specifies the scissor box.
	 *
	 * @param {number} x - The x-coordinate of the lower left corner of the viewport.
	 * @param {number} y - The y-coordinate of the lower left corner of the viewport.
	 * @param {number} width - The width of the viewport.
	 * @param {number} height - The height of the viewport.
	 *
	 */ scissor(x, y, width, height) {
        const scissor = this._tempVec4.set(x, y, width, height);
        if (this.currentScissor.equals(scissor) === false) {
            const { gl: gl } = this;
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            this.currentScissor.copy(scissor);
        }
    }
    /**
	 * Specifies the viewport.
	 *
	 * @param {number} x - The x-coordinate of the lower left corner of the viewport.
	 * @param {number} y - The y-coordinate of the lower left corner of the viewport.
	 * @param {number} width - The width of the viewport.
	 * @param {number} height - The height of the viewport.
	 *
	 */ viewport(x, y, width, height) {
        const viewport = this._tempVec4.set(x, y, width, height);
        if (this.currentViewport.equals(viewport) === false) {
            const { gl: gl } = this;
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            this.currentViewport.copy(viewport);
        }
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        const gl = this.gl;
        if (boolean) this.enable(gl.SCISSOR_TEST);
        else this.disable(gl.SCISSOR_TEST);
    }
    /**
	 * Specifies whether the stencil test is enabled or not.
	 *
	 * @param {boolean} stencilTest - Whether the stencil test is enabled or not.
	 */ setStencilTest(stencilTest) {
        const { gl: gl } = this;
        if (stencilTest) this.enable(gl.STENCIL_TEST);
        else this.disable(gl.STENCIL_TEST);
    }
    /**
	 * Specifies whether stencil values can be written when rendering
	 * into a framebuffer or not.
	 *
	 * This method caches the state so `gl.stencilMask()` is only
	 * called when necessary.
	 *
	 * @param {boolean} stencilMask - The stencil mask.
	 */ setStencilMask(stencilMask) {
        if (this.currentStencilMask !== stencilMask) {
            this.gl.stencilMask(stencilMask);
            this.currentStencilMask = stencilMask;
        }
    }
    /**
	 * Specifies whether the stencil test functions.
	 *
	 * This method caches the state so `gl.stencilFunc()` is only
	 * called when necessary.
	 *
	 * @param {number} stencilFunc - The stencil compare function.
	 * @param {number} stencilRef - The reference value for the stencil test.
	 * @param {number} stencilMask - A bit-wise mask that is used to AND the reference value and the stored stencil value when the test is done.
	 */ setStencilFunc(stencilFunc, stencilRef, stencilMask) {
        if (this.currentStencilFunc !== stencilFunc || this.currentStencilRef !== stencilRef || this.currentStencilFuncMask !== stencilMask) {
            this.gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
            this.currentStencilFunc = stencilFunc;
            this.currentStencilRef = stencilRef;
            this.currentStencilFuncMask = stencilMask;
        }
    }
    /**
	 * Specifies whether the stencil test operation.
	 *
	 * This method caches the state so `gl.stencilOp()` is only
	 * called when necessary.
	 *
	 * @param {number} stencilFail - The function to use when the stencil test fails.
	 * @param {number} stencilZFail - The function to use when the stencil test passes, but the depth test fail.
	 * @param {number} stencilZPass - The function to use when both the stencil test and the depth test pass,
	 * or when the stencil test passes and there is no depth buffer or depth testing is disabled.
	 */ setStencilOp(stencilFail, stencilZFail, stencilZPass) {
        if (this.currentStencilFail !== stencilFail || this.currentStencilZFail !== stencilZFail || this.currentStencilZPass !== stencilZPass) {
            this.gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
            this.currentStencilFail = stencilFail;
            this.currentStencilZFail = stencilZFail;
            this.currentStencilZPass = stencilZPass;
        }
    }
    /**
	 * Configures the WebGL state for the given material.
	 *
	 * @param {Material} material - The material to configure the state for.
	 * @param {number} frontFaceCW - Whether the front faces are counter-clockwise or not.
	 * @param {number} hardwareClippingPlanes - The number of hardware clipping planes.
	 */ setMaterial(material, frontFaceCW, hardwareClippingPlanes) {
        const { gl: gl } = this;
        material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) ? this.disable(gl.CULL_FACE) : this.enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        this.setFlipSided(flipSided);
        material.blending === (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) && material.transparent === false ? this.setBlending((0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) : this.setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        this.setDepthFunc(material.depthFunc);
        this.setDepthTest(material.depthTest);
        this.setDepthMask(material.depthWrite);
        this.setColorMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        this.setStencilTest(stencilWrite);
        if (stencilWrite) {
            this.setStencilMask(material.stencilWriteMask);
            this.setStencilFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            this.setStencilOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        this.setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true && this.backend.renderer.currentSamples > 0 ? this.enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : this.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        if (hardwareClippingPlanes > 0) {
            if (this.currentClippingPlanes !== hardwareClippingPlanes) {
                const CLIP_DISTANCE0_WEBGL = 0x3000;
                for(let i = 0; i < 8; i++)if (i < hardwareClippingPlanes) this.enable(CLIP_DISTANCE0_WEBGL + i);
                else this.disable(CLIP_DISTANCE0_WEBGL + i);
            }
        }
    }
    /**
	 * Specifies the polygon offset.
	 *
	 * This method caches the state so `gl.polygonOffset()` is only
	 * called when necessary.
	 *
	 * @param {boolean} polygonOffset - Whether polygon offset is enabled or not.
	 * @param {number} factor - The scale factor for the variable depth offset for each polygon.
	 * @param {number} units - The multiplier by which an implementation-specific value is multiplied with to create a constant depth offset.
	 */ setPolygonOffset(polygonOffset, factor, units) {
        const { gl: gl } = this;
        if (polygonOffset) {
            this.enable(gl.POLYGON_OFFSET_FILL);
            if (this.currentPolygonOffsetFactor !== factor || this.currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                this.currentPolygonOffsetFactor = factor;
                this.currentPolygonOffsetUnits = units;
            }
        } else this.disable(gl.POLYGON_OFFSET_FILL);
    }
    /**
	 * Defines the usage of the given WebGL program.
	 *
	 * This method caches the state so `gl.useProgram()` is only
	 * called when necessary.
	 *
	 * @param {WebGLProgram} program - The WebGL program to use.
	 * @return {boolean} Whether a program change has been executed or not.
	 */ useProgram(program) {
        if (this.currentProgram !== program) {
            this.gl.useProgram(program);
            this.currentProgram = program;
            return true;
        }
        return false;
    }
    /**
	 * Sets the vertex state by binding the given VAO and element buffer.
	 *
	 * @param {WebGLVertexArrayObject} vao - The VAO.
	 * @param {?WebGLBuffer} indexBuffer - The index buffer.
	 * @return {boolean} Whether a vertex state has been changed or not.
	 */ setVertexState(vao, indexBuffer = null) {
        const gl = this.gl;
        if (this.currentVAO !== vao || this.currentIndex !== indexBuffer) {
            gl.bindVertexArray(vao);
            if (indexBuffer !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
            this.currentVAO = vao;
            this.currentIndex = indexBuffer;
            return true;
        }
        return false;
    }
    /**
	 * Resets the vertex array state by resetting the VAO and element buffer.
	 */ resetVertexState() {
        const gl = this.gl;
        gl.bindVertexArray(null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
        this.currentVAO = null;
        this.currentIndex = null;
    }
    // framebuffer
    /**
	 * Binds the given framebuffer.
	 *
	 * This method caches the state so `gl.bindFramebuffer()` is only
	 * called when necessary.
	 *
	 * @param {number} target - The binding point (target).
	 * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer to bind.
	 * @return {boolean} Whether a bind has been executed or not.
	 */ bindFramebuffer(target, framebuffer) {
        const { gl: gl, currentBoundFramebuffers: currentBoundFramebuffers } = this;
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    /**
	 * Defines draw buffers to which fragment colors are written into.
	 * Configures the MRT setup of custom framebuffers.
	 *
	 * This method caches the state so `gl.drawBuffers()` is only
	 * called when necessary.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {WebGLFramebuffer} framebuffer - The WebGL framebuffer.
	 */ drawBuffers(renderContext, framebuffer) {
        const { gl: gl } = this;
        let drawBuffers = [];
        let needsUpdate = false;
        if (renderContext.textures !== null) {
            drawBuffers = this.currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                this.currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderContext.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    // texture
    /**
	 * Makes the given texture unit active.
	 *
	 * This method caches the state so `gl.activeTexture()` is only
	 * called when necessary.
	 *
	 * @param {number} webglSlot - The texture unit to make active.
	 */ activeTexture(webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            this.currentTextureSlot = webglSlot;
        }
    }
    /**
	 * Binds the given WebGL texture to a target.
	 *
	 * This method caches the state so `gl.bindTexture()` is only
	 * called when necessary.
	 *
	 * @param {number} webglType - The binding point (target).
	 * @param {WebGLTexture} webglTexture - The WebGL texture to bind.
	 * @param {number} webglSlot - The texture.
	 */ bindTexture(webglType, webglTexture, webglSlot) {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures, maxTextures: maxTextures } = this;
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                this.currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    /**
	 * Binds a given WebGL buffer to a given binding point (target) at a given index.
	 *
	 * This method caches the state so `gl.bindBufferBase()` is only
	 * called when necessary.
	 *
	 * @param {number} target - The target for the bind operation.
	 * @param {number} index - The index of the target.
	 * @param {WebGLBuffer} buffer - The WebGL buffer.
	 * @return {boolean} Whether a bind has been executed or not.
	 */ bindBufferBase(target, index, buffer) {
        const { gl: gl } = this;
        const key = `${target}-${index}`;
        if (this.currentBoundBufferBases[key] !== buffer) {
            gl.bindBufferBase(target, index, buffer);
            this.currentBoundBufferBases[key] = buffer;
            return true;
        }
        return false;
    }
    /**
	 * Unbinds the current bound texture.
	 *
	 * This method caches the state so `gl.bindTexture()` is only
	 * called when necessary.
	 */ unbindTexture() {
        const { gl: gl, currentTextureSlot: currentTextureSlot, currentBoundTextures: currentBoundTextures } = this;
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    /**
	 * Returns the value for the given parameter.
	 *
	 * @param {number} name - The paramter to get the value for.
	 * @return {any} The value for the given parameter.
	 */ getParameter(name) {
        const { gl: gl, parameters: parameters } = this;
        if (parameters[name] !== undefined) return parameters[name];
        else return gl.getParameter(name);
    }
    /**
	 * Specifies a pixel storage mode.
	 *
	 * @param {number} name - The parameter to set.
	 * @param {any} value - A value to set the parameter to.
	 */ pixelStorei(name, value) {
        const { gl: gl, parameters: parameters } = this;
        if (parameters[name] !== value) {
            gl.pixelStorei(name, value);
            parameters[name] = value;
        }
    }
}
/**
 * A WebGL 2 backend utility module with common helpers.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGLUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {WebGLExtensions}
		 */ this.extensions = backend.extensions;
    }
    /**
	 * Converts the given three.js constant into a WebGL constant.
	 * The method currently supports the conversion of texture formats
	 * and types.
	 *
	 * @param {number} p - The three.js constant.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 * @return {?number} The corresponding WebGL constant.
	 */ convert(p, colorSpace = (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51)) {
        const { gl: gl, extensions: extensions } = this;
        let extension;
        const transfer = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $9ddd7e9b53f7a2d4$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $9ddd7e9b53f7a2d4$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $9ddd7e9b53f7a2d4$export$f240f067f72abe41)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $9ddd7e9b53f7a2d4$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $9ddd7e9b53f7a2d4$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0) || p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668) || p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c) || p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) {
            if (transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573) || p === (0, $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4) || p === (0, $9ddd7e9b53f7a2d4$export$b82296714358084c) || p === (0, $9ddd7e9b53f7a2d4$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $9ddd7e9b53f7a2d4$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7) || p === (0, $9ddd7e9b53f7a2d4$export$7800993ef8106a6a) || p === (0, $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8) || p === (0, $9ddd7e9b53f7a2d4$export$d5c566817123b2bf) || p === (0, $9ddd7e9b53f7a2d4$export$f5668dc623297d86) || p === (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf) || p === (0, $9ddd7e9b53f7a2d4$export$211402338cb75433)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7) || p === (0, $9ddd7e9b53f7a2d4$export$7800993ef8106a6a)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d5c566817123b2bf)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$f5668dc623297d86)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, $9ddd7e9b53f7a2d4$export$211402338cb75433)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48) || p === (0, $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb) || p === (0, $9ddd7e9b53f7a2d4$export$7d2c0be323373d95) || p === (0, $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e) || p === (0, $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e) || p === (0, $9ddd7e9b53f7a2d4$export$118fff5afa255b63) || p === (0, $9ddd7e9b53f7a2d4$export$120713c829ae0667) || p === (0, $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9) || p === (0, $9ddd7e9b53f7a2d4$export$443cf6567cdd6424) || p === (0, $9ddd7e9b53f7a2d4$export$6573984fc9840780) || p === (0, $9ddd7e9b53f7a2d4$export$e7aee563f30091de) || p === (0, $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7) || p === (0, $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742) || p === (0, $9ddd7e9b53f7a2d4$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$7d2c0be323373d95)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$118fff5afa255b63)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$120713c829ae0667)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$443cf6567cdd6424)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$6573984fc9840780)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$e7aee563f30091de)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $9ddd7e9b53f7a2d4$export$18ab77abd087e467)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$ce40b115e188bc81)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$ce40b115e188bc81)) return transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $9ddd7e9b53f7a2d4$export$b1688df4c4c21670) || p === (0, $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58) || p === (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f) || p === (0, $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $9ddd7e9b53f7a2d4$export$b1688df4c4c21670)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    /**
	 * This method can be used to synchronize the CPU with the GPU by waiting until
	 * ongoing GPU commands have been completed.
	 *
	 * @private
	 * @return {Promise} A promise that resolves when all ongoing GPU commands have been completed.
	 */ _clientWaitAsync() {
        const { gl: gl } = this;
        const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        gl.flush();
        return new Promise((resolve, reject)=>{
            function test() {
                const res = gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0);
                if (res === gl.WAIT_FAILED) {
                    gl.deleteSync(sync);
                    reject();
                    return;
                }
                if (res === gl.TIMEOUT_EXPIRED) {
                    requestAnimationFrame(test);
                    return;
                }
                gl.deleteSync(sync);
                resolve();
            }
            test();
        });
    }
}
let $03ccd63b0299d6a7$var$initialized = false, $03ccd63b0299d6a7$var$wrappingToGL, $03ccd63b0299d6a7$var$filterToGL, $03ccd63b0299d6a7$var$compareToGL;
/**
 * A WebGL 2 backend utility module for managing textures.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGLTextureUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = backend.gl;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {WebGLExtensions}
		 */ this.extensions = backend.extensions;
        /**
		 * A dictionary for managing default textures. The key
		 * is the binding point (target), the value the WEbGL texture object.
		 *
		 * @type {Object<GLenum,WebGLTexture>}
		 */ this.defaultTextures = {};
        /**
		 * A scratch framebuffer used for attaching the source texture in
		 * {@link copyTextureToTexture}.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 */ this._srcFramebuffer = null;
        /**
		 * A scratch framebuffer used for attaching the destination texture in
		 * {@link copyTextureToTexture}.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 */ this._dstFramebuffer = null;
        if ($03ccd63b0299d6a7$var$initialized === false) {
            this._init();
            $03ccd63b0299d6a7$var$initialized = true;
        }
    }
    /**
	 * Inits the state of the utility.
	 *
	 * @private
	 */ _init() {
        const gl = this.gl;
        // Store only WebGL constants here.
        $03ccd63b0299d6a7$var$wrappingToGL = {
            [(0, $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5)]: gl.REPEAT,
            [(0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06)]: gl.CLAMP_TO_EDGE,
            [(0, $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f)]: gl.MIRRORED_REPEAT
        };
        $03ccd63b0299d6a7$var$filterToGL = {
            [(0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0)]: gl.NEAREST,
            [(0, $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c)]: gl.NEAREST_MIPMAP_NEAREST,
            [(0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2)]: gl.NEAREST_MIPMAP_LINEAR,
            [(0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8)]: gl.LINEAR,
            [(0, $9ddd7e9b53f7a2d4$export$19a719f377145a13)]: gl.LINEAR_MIPMAP_NEAREST,
            [(0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)]: gl.LINEAR_MIPMAP_LINEAR
        };
        $03ccd63b0299d6a7$var$compareToGL = {
            [(0, $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab)]: gl.NEVER,
            [(0, $9ddd7e9b53f7a2d4$export$187b73a3e352c145)]: gl.ALWAYS,
            [(0, $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7)]: gl.LESS,
            [(0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1)]: gl.LEQUAL,
            [(0, $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5)]: gl.EQUAL,
            [(0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61)]: gl.GEQUAL,
            [(0, $9ddd7e9b53f7a2d4$export$155af022118f3a38)]: gl.GREATER,
            [(0, $9ddd7e9b53f7a2d4$export$67ab95dde6bed156)]: gl.NOTEQUAL
        };
    }
    /**
	 * Returns the native texture type for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {GLenum} The native texture type.
	 */ getGLTextureType(texture) {
        const { gl: gl } = this;
        let glTextureType;
        if (texture.isCubeTexture === true) glTextureType = gl.TEXTURE_CUBE_MAP;
        else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) glTextureType = gl.TEXTURE_2D_ARRAY;
        else if (texture.isData3DTexture === true) glTextureType = gl.TEXTURE_3D;
        else glTextureType = gl.TEXTURE_2D;
        return glTextureType;
    }
    /**
	 * Returns the native texture type for the given texture.
	 *
	 * @param {?string} internalFormatName - The internal format name. When `null`, the internal format is derived from the subsequent parameters.
	 * @param {GLenum} glFormat - The WebGL format.
	 * @param {GLenum} glType - The WebGL type.
	 * @param {string} colorSpace - The texture's color space.
	 * @param {boolean} [forceLinearTransfer=false] - Whether to force a linear transfer or not.
	 * @return {GLenum} The internal format.
	 */ getInternalFormat(internalFormatName, glFormat, glType, normalized, colorSpace, forceLinearTransfer = false) {
        const { gl: gl, extensions: extensions } = this;
        if (internalFormatName !== null) {
            if (gl[internalFormatName] !== undefined) return gl[internalFormatName];
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLBackend: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let extTextureNorm16 = null;
        if (normalized) {
            extTextureNorm16 = extensions.get('EXT_texture_norm16');
            if (!extTextureNorm16) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension');
        }
        let internalFormat = glFormat;
        if (glFormat === gl.RED) {
            if (glType === gl.FLOAT) internalFormat = gl.R32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.R16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8;
            if (glType === gl.BYTE) internalFormat = gl.R8_SNORM;
            if (glType === gl.UNSIGNED_SHORT && extTextureNorm16) internalFormat = extTextureNorm16.R16_EXT;
            if (glType === gl.SHORT && extTextureNorm16) internalFormat = extTextureNorm16.R16_SNORM_EXT;
        }
        if (glFormat === gl.RED_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.R8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.R16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.R32UI;
            if (glType === gl.BYTE) internalFormat = gl.R8I;
            if (glType === gl.SHORT) internalFormat = gl.R16I;
            if (glType === gl.INT) internalFormat = gl.R32I;
        }
        if (glFormat === gl.RG) {
            if (glType === gl.FLOAT) internalFormat = gl.RG32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RG16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8;
            if (glType === gl.BYTE) internalFormat = gl.RG8_SNORM;
            if (glType === gl.UNSIGNED_SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RG16_EXT;
            if (glType === gl.SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RG16_SNORM_EXT;
        }
        if (glFormat === gl.RG_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RG8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RG16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RG32UI;
            if (glType === gl.BYTE) internalFormat = gl.RG8I;
            if (glType === gl.SHORT) internalFormat = gl.RG16I;
            if (glType === gl.INT) internalFormat = gl.RG32I;
        }
        if (glFormat === gl.RGB) {
            const transfer = forceLinearTransfer ? (0, $9ddd7e9b53f7a2d4$export$f197347d588c1b4a) : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === gl.FLOAT) internalFormat = gl.RGB32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGB16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? gl.SRGB8 : gl.RGB8;
            if (glType === gl.BYTE) internalFormat = gl.RGB8_SNORM;
            if (glType === gl.UNSIGNED_SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RGB16_EXT;
            if (glType === gl.SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RGB16_SNORM_EXT;
            if (glType === gl.UNSIGNED_SHORT_5_6_5) internalFormat = gl.RGB565;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGB4;
            if (glType === gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = gl.RGB9_E5;
            if (glType === gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = gl.R11F_G11F_B10F;
        }
        if (glFormat === gl.RGB_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGB8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGB16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGB32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGB8I;
            if (glType === gl.SHORT) internalFormat = gl.RGB16I;
            if (glType === gl.INT) internalFormat = gl.RGB32I;
        }
        if (glFormat === gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $9ddd7e9b53f7a2d4$export$f197347d588c1b4a) : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === gl.FLOAT) internalFormat = gl.RGBA32F;
            if (glType === gl.HALF_FLOAT) internalFormat = gl.RGBA16F;
            if (glType === gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? gl.SRGB8_ALPHA8 : gl.RGBA8;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8_SNORM;
            if (glType === gl.UNSIGNED_SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RGBA16_EXT;
            if (glType === gl.SHORT && extTextureNorm16) internalFormat = extTextureNorm16.RGBA16_SNORM_EXT;
            if (glType === gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = gl.RGBA4;
            if (glType === gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = gl.RGB5_A1;
        }
        if (glFormat === gl.RGBA_INTEGER) {
            if (glType === gl.UNSIGNED_BYTE) internalFormat = gl.RGBA8UI;
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.RGBA16UI;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.RGBA32UI;
            if (glType === gl.BYTE) internalFormat = gl.RGBA8I;
            if (glType === gl.SHORT) internalFormat = gl.RGBA16I;
            if (glType === gl.INT) internalFormat = gl.RGBA32I;
        }
        if (glFormat === gl.DEPTH_COMPONENT) {
            if (glType === gl.UNSIGNED_SHORT) internalFormat = gl.DEPTH_COMPONENT16;
            if (glType === gl.UNSIGNED_INT) internalFormat = gl.DEPTH_COMPONENT24;
            if (glType === gl.FLOAT) internalFormat = gl.DEPTH_COMPONENT32F;
        }
        if (glFormat === gl.DEPTH_STENCIL) {
            if (glType === gl.UNSIGNED_INT_24_8) internalFormat = gl.DEPTH24_STENCIL8;
        }
        if (internalFormat === gl.R16F || internalFormat === gl.R32F || internalFormat === gl.RG16F || internalFormat === gl.RG32F || internalFormat === gl.RGBA16F || internalFormat === gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    /**
	 * Sets the texture parameters for the given texture.
	 *
	 * @param {GLenum} textureType - The texture type.
	 * @param {Texture} texture - The texture.
	 */ setTextureParameters(textureType, texture) {
        const { gl: gl, extensions: extensions, backend: backend } = this;
        const { state: state } = this.backend;
        const workingPrimaries = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries((0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace);
        const texturePrimaries = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) ? null : (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
        const unpackConversion = texture.colorSpace === (0, $9ddd7e9b53f7a2d4$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? gl.NONE : gl.BROWSER_DEFAULT_WEBGL;
        state.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
        state.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
        state.pixelStorei(gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
        state.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_S, $03ccd63b0299d6a7$var$wrappingToGL[texture.wrapS]);
        gl.texParameteri(textureType, gl.TEXTURE_WRAP_T, $03ccd63b0299d6a7$var$wrappingToGL[texture.wrapT]);
        if (textureType === gl.TEXTURE_3D || textureType === gl.TEXTURE_2D_ARRAY) // WebGL 2 does not support wrapping for depth 2D array textures
        {
            if (!texture.isArrayTexture) gl.texParameteri(textureType, gl.TEXTURE_WRAP_R, $03ccd63b0299d6a7$var$wrappingToGL[texture.wrapR]);
        }
        gl.texParameteri(textureType, gl.TEXTURE_MAG_FILTER, $03ccd63b0299d6a7$var$filterToGL[texture.magFilter]);
        const hasMipmaps = texture.mipmaps !== undefined && texture.mipmaps.length > 0;
        // follow WebGPU backend mapping for texture filtering
        const minFilter = texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8) && hasMipmaps ? (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b) : texture.minFilter;
        gl.texParameteri(textureType, gl.TEXTURE_MIN_FILTER, $03ccd63b0299d6a7$var$filterToGL[minFilter]);
        if (texture.compareFunction) {
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            gl.texParameteri(textureType, gl.TEXTURE_COMPARE_FUNC, $03ccd63b0299d6a7$var$compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $9ddd7e9b53f7a2d4$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (texture.anisotropy > 1) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, backend.capabilities.getMaxAnisotropy()));
            }
        }
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        const { gl: gl, backend: backend, defaultTextures: defaultTextures } = this;
        const glTextureType = this.getGLTextureType(texture);
        let textureGPU = defaultTextures[glTextureType];
        if (textureGPU === undefined) {
            textureGPU = gl.createTexture();
            backend.state.bindTexture(glTextureType, textureGPU);
            gl.texParameteri(glTextureType, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(glTextureType, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            // gl.texImage2D( glTextureType, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data );
            defaultTextures[glTextureType] = textureGPU;
        }
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType
        });
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 * @return {undefined}
	 */ createTexture(texture, options) {
        const { gl: gl, backend: backend } = this;
        const { levels: levels, width: width, height: height, depth: depth } = options;
        const glFormat = backend.utils.convert(texture.format, texture.colorSpace);
        const glType = backend.utils.convert(texture.type);
        const glInternalFormat = this.getInternalFormat(texture.internalFormat, glFormat, glType, texture.normalized, texture.colorSpace, texture.isVideoTexture);
        const textureGPU = gl.createTexture();
        const glTextureType = this.getGLTextureType(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isArrayTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) gl.texStorage3D(gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, width, height, depth);
        else if (texture.isData3DTexture) gl.texStorage3D(gl.TEXTURE_3D, levels, glInternalFormat, width, height, depth);
        else if (!texture.isVideoTexture) gl.texStorage2D(glTextureType, levels, glInternalFormat, width, height);
        backend.set(texture, {
            textureGPU: textureGPU,
            glTextureType: glTextureType,
            glFormat: glFormat,
            glType: glType,
            glInternalFormat: glInternalFormat
        });
    }
    /**
	 * Uploads texture buffer data to the GPU memory.
	 *
	 * @param {WebGLBuffer} buffer - The buffer data.
	 * @param {Texture} texture - The texture,
	 */ copyBufferToTexture(buffer, texture) {
        const { gl: gl, backend: backend } = this;
        const { state: state } = backend;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType } = backend.get(texture);
        const { width: width, height: height } = texture.source.data;
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, buffer);
        backend.state.bindTexture(glTextureType, textureGPU);
        state.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
        state.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_UNPACK_BUFFER, null);
        backend.state.unbindTexture();
    // debug
    // const framebuffer = gl.createFramebuffer();
    // backend.state.bindFramebuffer( gl.FRAMEBUFFER, framebuffer );
    // gl.framebufferTexture2D( gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, glTextureType, textureGPU, 0 );
    // const readout = new Float32Array( width * height * 4 );
    // const altFormat = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_FORMAT );
    // const altType = gl.getParameter( gl.IMPLEMENTATION_COLOR_READ_TYPE );
    // gl.readPixels( 0, 0, width, height, altFormat, altType, readout );
    // backend.state.bindFramebuffer( gl.FRAMEBUFFER, null );
    // log( readout );
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        const { gl: gl } = this;
        const { width: width, height: height } = options;
        const { textureGPU: textureGPU, glTextureType: glTextureType, glFormat: glFormat, glType: glType, glInternalFormat: glInternalFormat } = this.backend.get(texture);
        if (texture.isRenderTargetTexture || textureGPU === undefined /* unsupported texture format */ ) return;
        this.backend.state.bindTexture(glTextureType, textureGPU);
        this.setTextureParameters(glTextureType, texture);
        if (texture.isCompressedTexture) {
            const mipmaps = texture.mipmaps;
            const image = options.image;
            for(let i = 0; i < mipmaps.length; i++){
                const mipmap = mipmaps[i];
                if (texture.isCompressedArrayTexture) {
                    if (texture.format !== gl.RGBA) {
                        if (glFormat !== null) gl.compressedTexSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                        else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLBackend: Attempt to load unsupported compressed texture format in .uploadTexture()');
                    } else gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                } else if (glFormat !== null) gl.compressedTexSubImage2D(gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                else (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLBackend: Unsupported compressed texture format');
            }
        } else if (texture.isCubeTexture) {
            const images = options.images;
            const mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++){
                const image = $03ccd63b0299d6a7$var$getImage(images[i]);
                gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, width, height, glFormat, glType, image);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const image = $03ccd63b0299d6a7$var$getImage(mipmap.images[i]);
                    gl.texSubImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, image.width, image.height, glFormat, glType, image);
                }
            }
        } else if (texture.isDataArrayTexture || texture.isArrayTexture) {
            const image = options.image;
            if (texture.layerUpdates.size > 0) {
                const layerByteLength = (0, $9ddd7e9b53f7a2d4$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                for (const layerIndex of texture.layerUpdates){
                    const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                    gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                }
                texture.clearLayerUpdates();
            } else gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isData3DTexture) {
            const image = options.image;
            gl.texSubImage3D(gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else if (texture.isVideoTexture) {
            texture.update();
            gl.texImage2D(glTextureType, 0, glInternalFormat, glFormat, glType, options.image);
        } else if (texture.isHTMLTexture) {
            if (typeof gl.texElementImage2D === 'function') gl.texElementImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, options.image);
        } else {
            const mipmaps = texture.mipmaps;
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                const image = $03ccd63b0299d6a7$var$getImage(mipmap);
                gl.texSubImage2D(glTextureType, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, image);
            }
            else {
                const image = $03ccd63b0299d6a7$var$getImage(options.image);
                gl.texSubImage2D(glTextureType, 0, 0, 0, width, height, glFormat, glType, image);
            }
        }
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, glTextureType: glTextureType } = backend.get(texture);
        backend.state.bindTexture(glTextureType, textureGPU);
        gl.generateMipmap(glTextureType);
    }
    /**
	 * Deallocates the render buffers of the given render target.
	 *
	 * @param {RenderTarget} renderTarget - The render target.
	 */ deallocateRenderBuffers(renderTarget) {
        const { gl: gl, backend: backend } = this;
        // remove framebuffer reference
        if (renderTarget) {
            const renderContextData = backend.get(renderTarget);
            renderContextData.renderBufferStorageSetup = undefined;
            if (renderContextData.framebuffers) {
                for(const cacheKey in renderContextData.framebuffers)gl.deleteFramebuffer(renderContextData.framebuffers[cacheKey]);
                delete renderContextData.framebuffers;
            }
            if (renderContextData.depthRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.depthRenderbuffer);
                delete renderContextData.depthRenderbuffer;
            }
            if (renderContextData.stencilRenderbuffer) {
                gl.deleteRenderbuffer(renderContextData.stencilRenderbuffer);
                delete renderContextData.stencilRenderbuffer;
            }
            if (renderContextData.msaaFrameBuffer) {
                gl.deleteFramebuffer(renderContextData.msaaFrameBuffer);
                delete renderContextData.msaaFrameBuffer;
            }
            if (renderContextData.msaaRenderbuffers) {
                for(let i = 0; i < renderContextData.msaaRenderbuffers.length; i++)gl.deleteRenderbuffer(renderContextData.msaaRenderbuffers[i]);
                delete renderContextData.msaaRenderbuffers;
            }
        }
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        const { gl: gl, backend: backend } = this;
        const { textureGPU: textureGPU, renderTarget: renderTarget } = backend.get(texture);
        this.deallocateRenderBuffers(renderTarget);
        if (isDefaultTexture === false) gl.deleteTexture(textureGPU);
        backend.delete(texture);
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        const { gl: gl, backend: backend } = this;
        const { state: state } = this.backend;
        const { textureGPU: dstTextureGPU, glTextureType: glTextureType, glType: glType, glFormat: glFormat } = backend.get(dstTexture);
        state.bindTexture(glTextureType, dstTextureGPU);
        // gather the necessary dimensions to copy
        let width, height, depth, minX, minY, minZ;
        let dstX, dstY, dstZ;
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
        if (srcRegion !== null) {
            width = srcRegion.max.x - srcRegion.min.x;
            height = srcRegion.max.y - srcRegion.min.y;
            depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
            minX = srcRegion.min.x;
            minY = srcRegion.min.y;
            minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
        } else {
            const levelScale = Math.pow(2, -srcLevel);
            width = Math.floor(image.width * levelScale);
            height = Math.floor(image.height * levelScale);
            if (srcTexture.isDataArrayTexture || srcTexture.isArrayTexture) depth = image.depth;
            else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
            else depth = 1;
            minX = 0;
            minY = 0;
            minZ = 0;
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstZ = dstPosition.z;
        } else {
            dstX = 0;
            dstY = 0;
            dstZ = 0;
        }
        state.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
        state.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
        state.pixelStorei(gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
        // used for copying data from cpu
        const currentUnpackRowLen = state.getParameter(gl.UNPACK_ROW_LENGTH);
        const currentUnpackImageHeight = state.getParameter(gl.UNPACK_IMAGE_HEIGHT);
        const currentUnpackSkipPixels = state.getParameter(gl.UNPACK_SKIP_PIXELS);
        const currentUnpackSkipRows = state.getParameter(gl.UNPACK_SKIP_ROWS);
        const currentUnpackSkipImages = state.getParameter(gl.UNPACK_SKIP_IMAGES);
        state.pixelStorei(gl.UNPACK_ROW_LENGTH, image.width);
        state.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, image.height);
        state.pixelStorei(gl.UNPACK_SKIP_PIXELS, minX);
        state.pixelStorei(gl.UNPACK_SKIP_ROWS, minY);
        state.pixelStorei(gl.UNPACK_SKIP_IMAGES, minZ);
        // set up the src texture
        const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture || dstTexture.isArrayTexture;
        const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture || dstTexture.isArrayTexture;
        if (srcTexture.isDepthTexture) {
            const srcTextureData = backend.get(srcTexture);
            const dstTextureData = backend.get(dstTexture);
            const srcRenderContextData = backend.get(srcTextureData.renderTarget);
            const dstRenderContextData = backend.get(dstTextureData.renderTarget);
            const srcFramebuffer = srcRenderContextData.framebuffers[srcTextureData.cacheKey];
            const dstFramebuffer = dstRenderContextData.framebuffers[dstTextureData.cacheKey];
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, srcFramebuffer);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, dstFramebuffer);
            for(let i = 0; i < depth; i++){
                // if the source or destination are a 3d target then a layer needs to be bound
                if (isSrc3D) {
                    gl.framebufferTextureLayer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, srcTextureData.textureGPU, srcLevel, minZ + i);
                    gl.framebufferTextureLayer(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, dstTextureGPU, dstLevel, dstZ + i);
                }
                gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, gl.DEPTH_BUFFER_BIT, gl.NEAREST);
            }
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || backend.has(srcTexture)) {
            // get the appropriate frame buffers
            const srcTextureData = backend.get(srcTexture);
            if (this._srcFramebuffer === null) this._srcFramebuffer = gl.createFramebuffer();
            if (this._dstFramebuffer === null) this._dstFramebuffer = gl.createFramebuffer();
            // bind the frame buffer targets
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, this._srcFramebuffer);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, this._dstFramebuffer);
            for(let i = 0; i < depth; i++){
                // assign the correct layers and mip maps to the frame buffers
                if (isSrc3D) gl.framebufferTextureLayer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, srcTextureData.textureGPU, srcLevel, minZ + i);
                else gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, srcTextureData.textureGPU, srcLevel);
                if (isDst3D) gl.framebufferTextureLayer(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, dstTextureGPU, dstLevel, dstZ + i);
                else gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, dstTextureGPU, dstLevel);
                // copy the data using the fastest function that can achieve the copy
                if (srcLevel !== 0) gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
                else if (isDst3D) gl.copyTexSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                else gl.copyTexSubImage2D(glTextureType, dstLevel, dstX, dstY, minX, minY, width, height);
            }
            // unbind read, draw buffers
            state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        } else if (isDst3D) {
            // copy data into the 3d texture
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) gl.texSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
            else if (dstTexture.isCompressedArrayTexture) gl.compressedTexSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
            else gl.texSubImage3D(glTextureType, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
        } else {
            // copy data into the 2d texture
            if (srcTexture.isDataTexture) gl.texSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
            else if (srcTexture.isCompressedTexture) gl.compressedTexSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
            else gl.texSubImage2D(gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
        }
        // reset values
        state.pixelStorei(gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
        state.pixelStorei(gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
        state.pixelStorei(gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
        state.pixelStorei(gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        state.pixelStorei(gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (dstLevel === 0 && dstTexture.generateMipmaps) gl.generateMipmap(glTextureType);
        state.unbindTexture();
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        const { gl: gl } = this;
        const { state: state } = this.backend;
        const { textureGPU: textureGPU } = this.backend.get(texture);
        const { x: x, y: y, z: width, w: height } = rectangle;
        const requireDrawFrameBuffer = texture.isDepthTexture === true || renderContext.renderTarget && renderContext.renderTarget.samples > 0;
        const srcHeight = renderContext.renderTarget ? renderContext.renderTarget.height : this.backend.getDrawingBufferSize().y;
        if (requireDrawFrameBuffer) {
            const partial = x !== 0 || y !== 0;
            let mask;
            let attachment;
            if (texture.isDepthTexture === true) {
                mask = gl.DEPTH_BUFFER_BIT;
                attachment = gl.DEPTH_ATTACHMENT;
                if (renderContext.stencil) mask |= gl.STENCIL_BUFFER_BIT;
            } else {
                mask = gl.COLOR_BUFFER_BIT;
                attachment = gl.COLOR_ATTACHMENT0;
            }
            if (partial) {
                const renderTargetContextData = this.backend.get(renderContext.renderTarget);
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                const flippedY = srcHeight - y - height;
                gl.blitFramebuffer(x, flippedY, x + width, flippedY + height, x, flippedY, x + width, flippedY + height, mask, gl.NEAREST);
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
                state.bindTexture(gl.TEXTURE_2D, textureGPU);
                gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, flippedY, width, height);
                state.unbindTexture();
            } else {
                const fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureGPU, 0);
                gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, gl.NEAREST);
                gl.deleteFramebuffer(fb);
            }
        } else {
            state.bindTexture(gl.TEXTURE_2D, textureGPU);
            gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, x, srcHeight - height - y, width, height);
            state.unbindTexture();
        }
        if (texture.generateMipmaps) this.generateMipmaps(texture);
        this.backend._setFramebuffer(renderContext);
    }
    /**
	 * SetupS storage for internal depth/stencil buffers and bind to correct framebuffer.
	 *
	 * @param {WebGLRenderbuffer} renderbuffer - The render buffer.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {number} samples - The MSAA sample count.
	 * @param {boolean} [useMultisampledRTT=false] - Whether to use WEBGL_multisampled_render_to_texture or not.
	 */ setupRenderBufferStorage(renderbuffer, renderContext, samples, useMultisampledRTT = false) {
        const { gl: gl } = this;
        const renderTarget = renderContext.renderTarget;
        const { depthTexture: depthTexture, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer, width: width, height: height } = renderTarget;
        gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
        if (depthBuffer && !stencilBuffer) {
            let glInternalFormat = gl.DEPTH_COMPONENT24;
            if (useMultisampledRTT === true) {
                const multisampledRTTExt = this.extensions.get('WEBGL_multisampled_render_to_texture');
                multisampledRTTExt.renderbufferStorageMultisampleEXT(gl.RENDERBUFFER, renderTarget.samples, glInternalFormat, width, height);
            } else if (samples > 0) {
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === gl.FLOAT) glInternalFormat = gl.DEPTH_COMPONENT32F;
                }
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, glInternalFormat, width, height);
            } else gl.renderbufferStorage(gl.RENDERBUFFER, glInternalFormat, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        } else if (depthBuffer && stencilBuffer) {
            if (samples > 0) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, gl.DEPTH24_STENCIL8, width, height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, renderbuffer);
        }
        gl.bindRenderbuffer(gl.RENDERBUFFER, null);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const { backend: backend, gl: gl } = this;
        const { textureGPU: textureGPU, glFormat: glFormat, glType: glType } = this.backend.get(texture);
        const fb = gl.createFramebuffer();
        backend.state.bindFramebuffer(gl.READ_FRAMEBUFFER, fb);
        const target = texture.isCubeTexture ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex : gl.TEXTURE_2D;
        gl.framebufferTexture2D(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, target, textureGPU, 0);
        const typedArrayType = this._getTypedArrayType(glType);
        const bytesPerTexel = this._getBytesPerTexel(glType, glFormat);
        const elementCount = width * height;
        const byteLength = elementCount * bytesPerTexel;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, byteLength, gl.STREAM_READ);
        gl.readPixels(x, y, width, height, glFormat, glType, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        await backend.utils._clientWaitAsync();
        const dstBuffer = new typedArrayType(byteLength / typedArrayType.BYTES_PER_ELEMENT);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, dstBuffer);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        backend.state.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.deleteFramebuffer(fb);
        return dstBuffer;
    }
    /**
	 * Returns the corresponding typed array type for the given WebGL data type.
	 *
	 * @private
	 * @param {GLenum} glType - The WebGL data type.
	 * @return {TypedArray.constructor} The typed array type.
	 */ _getTypedArrayType(glType) {
        const { gl: gl } = this;
        if (glType === gl.UNSIGNED_BYTE) return Uint8Array;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_5_5_1) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT_5_6_5) return Uint16Array;
        if (glType === gl.UNSIGNED_SHORT) return Uint16Array;
        if (glType === gl.UNSIGNED_INT) return Uint32Array;
        if (glType === gl.HALF_FLOAT) return Uint16Array;
        if (glType === gl.FLOAT) return Float32Array;
        throw new Error(`Unsupported WebGL type: ${glType}`);
    }
    /**
	 * Returns the bytes-per-texel value for the given WebGL data type and texture format.
	 *
	 * @private
	 * @param {GLenum} glType - The WebGL data type.
	 * @param {GLenum} glFormat - The WebGL texture format.
	 * @return {number} The bytes-per-texel.
	 */ _getBytesPerTexel(glType, glFormat) {
        const { gl: gl } = this;
        let bytesPerComponent = 0;
        if (glType === gl.UNSIGNED_BYTE) bytesPerComponent = 1;
        if (glType === gl.UNSIGNED_SHORT_4_4_4_4 || glType === gl.UNSIGNED_SHORT_5_5_5_1 || glType === gl.UNSIGNED_SHORT_5_6_5 || glType === gl.UNSIGNED_SHORT || glType === gl.HALF_FLOAT) bytesPerComponent = 2;
        if (glType === gl.UNSIGNED_INT || glType === gl.FLOAT) bytesPerComponent = 4;
        if (glFormat === gl.RGBA) return bytesPerComponent * 4;
        if (glFormat === gl.RGB) return bytesPerComponent * 3;
        if (glFormat === gl.ALPHA) return bytesPerComponent;
    }
    /**
	 * Frees the internal resources.
	 */ dispose() {
        const { gl: gl } = this;
        if (this._srcFramebuffer !== null) gl.deleteFramebuffer(this._srcFramebuffer);
        if (this._dstFramebuffer !== null) gl.deleteFramebuffer(this._dstFramebuffer);
    }
}
function $03ccd63b0299d6a7$var$getImage(source) {
    if (source.isDataTexture) return source.image.data;
    else if (typeof HTMLImageElement !== 'undefined' && source instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && source instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap || typeof OffscreenCanvas !== 'undefined' && source instanceof OffscreenCanvas) return source;
    return source.data;
}
/**
 * A WebGL 2 backend utility module for managing extensions.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGLExtensions {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {WebGL2RenderingContext}
		 */ this.gl = this.backend.gl;
        /**
		 * A list with all the supported WebGL extensions.
		 *
		 * @type {Array<string>}
		 */ this.availableExtensions = this.gl.getSupportedExtensions();
        /**
		 * A dictionary with requested WebGL extensions.
		 * The key is the name of the extension, the value
		 * the requested extension object.
		 *
		 * @type {Object<string,Object>}
		 */ this.extensions = {};
    }
    /**
	 * Returns the extension object for the given extension name.
	 *
	 * @param {string} name - The extension name.
	 * @return {Object} The extension object.
	 */ get(name) {
        let extension = this.extensions[name];
        if (extension === undefined) {
            extension = this.gl.getExtension(name);
            this.extensions[name] = extension;
        }
        return extension;
    }
    /**
	 * Returns `true` if the requested extension is available.
	 *
	 * @param {string} name - The extension name.
	 * @return {boolean} Whether the given extension is available or not.
	 */ has(name) {
        return this.availableExtensions.includes(name);
    }
}
/**
 * A WebGL 2 backend utility module for managing the device's capabilities.
 *
 * @private
 */ class $03ccd63b0299d6a7$export$8b8a3854b4979269 {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGLBackend} backend - The WebGL 2 backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGL 2 backend.
		 *
		 * @type {WebGLBackend}
		 */ this.backend = backend;
        /**
		 * This value holds the cached max anisotropy value.
		 *
		 * @type {?number}
		 * @default null
		 */ this.maxAnisotropy = null;
        /**
		 * This value holds the cached max uniform block size value.
		 *
		 * @type {?number}
		 * @default null
		 */ this.maxUniformBlockSize = null;
    }
    /**
	 * Returns the maximum anisotropy texture filtering value. This value
	 * depends on the device and is reported by the `EXT_texture_filter_anisotropic`
	 * WebGL extension.
	 *
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {
        if (this.maxAnisotropy !== null) return this.maxAnisotropy;
        const gl = this.backend.gl;
        const extensions = this.backend.extensions;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            this.maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else this.maxAnisotropy = 0;
        return this.maxAnisotropy;
    }
    /**
	 * Returns the maximum number of bytes available for uniform buffers.
	 *
	 * @return {number} The maximum number of bytes available for uniform buffers.
	 */ getUniformBufferLimit() {
        if (this.maxUniformBlockSize !== null) return this.maxUniformBlockSize;
        const gl = this.backend.gl;
        this.maxUniformBlockSize = gl.getParameter(gl.MAX_UNIFORM_BLOCK_SIZE);
        return this.maxUniformBlockSize;
    }
}
const $03ccd63b0299d6a7$var$GLFeatureName = {
    'WEBGL_multi_draw': 'WEBGL_multi_draw',
    'WEBGL_compressed_texture_astc': 'texture-compression-astc',
    'WEBGL_compressed_texture_etc': 'texture-compression-etc2',
    'WEBGL_compressed_texture_etc1': 'texture-compression-etc1',
    'WEBGL_compressed_texture_pvrtc': 'texture-compression-pvrtc',
    'WEBGL_compressed_texture_s3tc': 'texture-compression-s3tc',
    'EXT_texture_compression_bptc': 'texture-compression-bc',
    'EXT_disjoint_timer_query_webgl2': 'timestamp-query',
    'OVR_multiview2': 'OVR_multiview2'
};
class $03ccd63b0299d6a7$var$WebGLBufferRenderer {
    constructor(backend){
        this.gl = backend.gl;
        this.extensions = backend.extensions;
        this.info = backend.renderer.info;
        this.mode = null;
        this.index = 0;
        this.type = null;
        this.object = null;
    }
    render(start, count) {
        const { gl: gl, mode: mode, object: object, type: type, info: info, index: index } = this;
        if (index !== 0) gl.drawElements(mode, count, type, start);
        else gl.drawArrays(mode, start, count);
        info.update(object, count, 1);
    }
    renderInstances(start, count, primcount) {
        const { gl: gl, mode: mode, type: type, index: index, object: object, info: info } = this;
        if (primcount === 0) return;
        if (index !== 0) gl.drawElementsInstanced(mode, count, type, start, primcount);
        else gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(object, count, primcount);
    }
    renderMultiDraw(starts, counts, drawCount) {
        const { extensions: extensions, mode: mode, object: object, info: info } = this;
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < drawCount; i++)this.render(starts[i], counts[i]);
        else {
            if (this.index !== 0) extension.multiDrawElementsWEBGL(mode, counts, 0, this.type, starts, 0, drawCount);
            else extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i];
            info.update(object, elementCount, 1);
        }
    }
}
/**
 * Abstract base class of a timestamp query pool.
 *
 * @abstract
 */ class $03ccd63b0299d6a7$var$TimestampQueryPool {
    /**
	 * Creates a new timestamp query pool.
	 *
	 * @param {number} [maxQueries=256] - Maximum number of queries this pool can hold.
	 */ constructor(maxQueries = 256){
        /**
		 * Whether to track timestamps or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.trackTimestamp = true;
        /**
		 * Maximum number of queries this pool can hold.
		 *
		 * @type {number}
		 * @default 256
		 */ this.maxQueries = maxQueries;
        /**
		 * How many queries allocated so far.
		 *
		 * @type {number}
		 * @default 0
		 */ this.currentQueryIndex = 0;
        /**
		 * Tracks offsets for different contexts.
		 *
		 * @type {Map<string, number>}
		 */ this.queryOffsets = new Map();
        /**
		 * Whether the pool has been disposed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.isDisposed = false;
        /**
		 * The total frame duration until the next update.
		 *
		 * @type {number}
		 * @default 0
		 */ this.lastValue = 0;
        /**
		 * Stores all timestamp frames.
		 *
		 * @type {Array<number>}
		 */ this.frames = [];
        /**
		 * This property is used to avoid multiple concurrent resolve operations.
		 * The WebGL backend uses it as a boolean flag. In context of WebGPU, it holds
		 * the promise of the current resolve operation.
		 *
		 * @type {boolean|Promise<number>}
		 * @default false
		 */ this.pendingResolve = false;
        /**
		 * Stores the latest timestamp for each render context.
		 *
		 * @type {Map<string, number>}
		 */ this.timestamps = new Map();
    }
    /**
	 * Returns all timestamp frames.
	 *
	 * @return {Array<number>} The timestamp frames.
	 */ getTimestampFrames() {
        return this.frames;
    }
    /**
	 * Returns the timestamp for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @return {?number} The timestamp, or undefined if not available.
	 */ getTimestamp(uid) {
        let timestamp = this.timestamps.get(uid);
        if (timestamp === undefined) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`TimestampQueryPool: No timestamp available for uid ${uid}.`);
            timestamp = 0;
        }
        return timestamp;
    }
    /**
	 * Returns whether a timestamp is available for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @return {boolean} True if a timestamp is available, false otherwise.
	 */ hasTimestamp(uid) {
        return this.timestamps.has(uid);
    }
    /**
	 * Allocate queries for a specific uid.
	 *
	 * @abstract
	 * @param {string} uid - A unique identifier for the render context.
	 * @param {number} frameId - The current frame identifier.
	 * @returns {?number}
	 */ allocateQueriesForContext() {}
    /**
	 * Resolve all timestamps and return data (or process them).
	 *
	 * @abstract
	 * @async
	 * @returns {Promise<number>|number} The resolved timestamp value.
	 */ async resolveQueriesAsync() {}
    /**
	 * Dispose of the query pool.
	 *
	 * @abstract
	 */ dispose() {}
}
/**
 * Manages a pool of WebGL timestamp queries for performance measurement.
 * Handles creation, execution, and resolution of timer queries using WebGL extensions.
 *
 * @augments TimestampQueryPool
 */ class $03ccd63b0299d6a7$var$WebGLTimestampQueryPool extends $03ccd63b0299d6a7$var$TimestampQueryPool {
    /**
	 * Creates a new WebGL timestamp query pool.
	 *
	 * @param {WebGLRenderingContext|WebGL2RenderingContext} gl - The WebGL context.
	 * @param {string} type - The type identifier for this query pool.
	 * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
	 */ constructor(gl, type, maxQueries = 2048){
        super(maxQueries);
        this.gl = gl;
        this.type = type;
        // Check for timer query extensions
        this.ext = gl.getExtension('EXT_disjoint_timer_query_webgl2') || gl.getExtension('EXT_disjoint_timer_query');
        if (!this.ext) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('EXT_disjoint_timer_query not supported; timestamps will be disabled.');
            this.trackTimestamp = false;
            return;
        }
        // Create query objects
        this.queries = [];
        for(let i = 0; i < this.maxQueries; i++)this.queries.push(gl.createQuery());
        this.activeQuery = null;
        this.queryStates = new Map(); // Track state of each query: 'inactive', 'started', 'ended'
    }
    /**
	 * Allocates a pair of queries for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
	 */ allocateQueriesForContext(uid) {
        if (!this.trackTimestamp) return null;
        // Check if we have enough space for a new query pair
        if (this.currentQueryIndex + 2 > this.maxQueries) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)(`WebGLTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`);
            return null;
        }
        const baseOffset = this.currentQueryIndex;
        this.currentQueryIndex += 2;
        // Initialize query states
        this.queryStates.set(baseOffset, 'inactive');
        this.queryOffsets.set(uid, baseOffset);
        return baseOffset;
    }
    /**
	 * Begins a timestamp query for the specified render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ beginQuery(uid) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const baseOffset = this.queryOffsets.get(uid);
        if (baseOffset == null) return;
        // Don't start a new query if there's an active one
        if (this.activeQuery !== null) return;
        const query = this.queries[baseOffset];
        if (!query) return;
        try {
            // Only begin if query is inactive
            if (this.queryStates.get(baseOffset) === 'inactive') {
                this.gl.beginQuery(this.ext.TIME_ELAPSED_EXT, query);
                this.activeQuery = baseOffset;
                this.queryStates.set(baseOffset, 'started');
            }
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error in beginQuery:', e);
            this.activeQuery = null;
            this.queryStates.set(baseOffset, 'inactive');
        }
    }
    /**
	 * Ends the active timestamp query for the specified render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 */ endQuery(uid) {
        if (!this.trackTimestamp || this.isDisposed) return;
        const baseOffset = this.queryOffsets.get(uid);
        if (baseOffset == null) return;
        // Only end if this is the active query
        if (this.activeQuery !== baseOffset) return;
        try {
            this.gl.endQuery(this.ext.TIME_ELAPSED_EXT);
            this.queryStates.set(baseOffset, 'ended');
            this.activeQuery = null;
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error in endQuery:', e);
            // Reset state on error
            this.queryStates.set(baseOffset, 'inactive');
            this.activeQuery = null;
        }
    }
    /**
	 * Asynchronously resolves all completed queries and returns the total duration.
	 *
	 * @async
	 * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
	 */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.pendingResolve) return this.lastValue;
        this.pendingResolve = true;
        try {
            // Wait for all ended queries to complete
            const resolvePromises = new Map();
            for (const [uid, baseOffset] of this.queryOffsets){
                const state = this.queryStates.get(baseOffset);
                if (state === 'ended') {
                    const query = this.queries[baseOffset];
                    resolvePromises.set(uid, this.resolveQuery(query));
                }
            }
            if (resolvePromises.size === 0) return this.lastValue;
            //
            const framesDuration = {};
            const frames = [];
            for (const [uid, promise] of resolvePromises){
                const match = uid.match(/^(.*):f(\d+)$/);
                const frame = parseInt(match[2]);
                if (frames.includes(frame) === false) frames.push(frame);
                if (framesDuration[frame] === undefined) framesDuration[frame] = 0;
                const duration = await promise;
                this.timestamps.set(uid, duration);
                framesDuration[frame] += duration;
            }
            // Return the total duration of the last frame
            const totalDuration = framesDuration[frames[frames.length - 1]];
            // Store the last valid result
            this.lastValue = totalDuration;
            this.frames = frames;
            // Reset states
            this.currentQueryIndex = 0;
            this.queryOffsets.clear();
            this.queryStates.clear();
            this.activeQuery = null;
            return totalDuration;
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error resolving queries:', e);
            return this.lastValue;
        } finally{
            this.pendingResolve = false;
        }
    }
    /**
	 * Resolves a single query, checking for completion and disjoint operation.
	 *
	 * @async
	 * @param {WebGLQuery} query - The query object to resolve.
	 * @returns {Promise<number>} The elapsed time in milliseconds.
	 */ async resolveQuery(query) {
        return new Promise((resolve)=>{
            if (this.isDisposed) {
                resolve(this.lastValue);
                return;
            }
            let timeoutId;
            let isResolved = false;
            const cleanup = ()=>{
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }
            };
            const finalizeResolution = (value)=>{
                if (!isResolved) {
                    isResolved = true;
                    cleanup();
                    resolve(value);
                }
            };
            const checkQuery = ()=>{
                if (this.isDisposed) {
                    finalizeResolution(this.lastValue);
                    return;
                }
                try {
                    // Check if the GPU timer was disjoint (i.e., timing was unreliable)
                    const disjoint = this.gl.getParameter(this.ext.GPU_DISJOINT_EXT);
                    if (disjoint) {
                        finalizeResolution(this.lastValue);
                        return;
                    }
                    const available = this.gl.getQueryParameter(query, this.gl.QUERY_RESULT_AVAILABLE);
                    if (!available) {
                        timeoutId = setTimeout(checkQuery, 1);
                        return;
                    }
                    const elapsed = this.gl.getQueryParameter(query, this.gl.QUERY_RESULT);
                    resolve(Number(elapsed) / 1e6); // Convert nanoseconds to milliseconds
                } catch (e) {
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error checking query:', e);
                    resolve(this.lastValue);
                }
            };
            checkQuery();
        });
    }
    /**
	 * Releases all resources held by this query pool.
	 * This includes deleting all query objects and clearing internal state.
	 */ dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        if (!this.trackTimestamp) return;
        for (const query of this.queries)this.gl.deleteQuery(query);
        this.queries = [];
        this.queryStates.clear();
        this.queryOffsets.clear();
        this.lastValue = 0;
        this.activeQuery = null;
    }
}
/**
 * A backend implementation targeting WebGL 2.
 *
 * @private
 * @augments Backend
 */ class $03ccd63b0299d6a7$export$5356cb3ea4262d92 extends $03ccd63b0299d6a7$var$Backend {
    /**
	 * WebGLBackend options.
	 *
	 * @typedef {Object} WebGLBackend~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [reversedDepthBuffer=false] - Whether reversed depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {WebGL2RenderingContext} [context=undefined] - A WebGL 2 rendering context.
	 */ /**
	 * Constructs a new WebGPU backend.
	 *
	 * @param {WebGLBackend~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLBackend = true;
        /**
		 * A reference to a backend module holding shader attribute-related
		 * utility functions.
		 *
		 * @type {?WebGLAttributeUtils}
		 * @default null
		 */ this.attributeUtils = null;
        /**
		 * A reference to a backend module holding extension-related
		 * utility functions.
		 *
		 * @type {?WebGLExtensions}
		 * @default null
		 */ this.extensions = null;
        /**
		 * A reference to a backend module holding capability-related
		 * utility functions.
		 *
		 * @type {?WebGLCapabilities}
		 * @default null
		 */ this.capabilities = null;
        /**
		 * A reference to a backend module holding texture-related
		 * utility functions.
		 *
		 * @type {?WebGLTextureUtils}
		 * @default null
		 */ this.textureUtils = null;
        /**
		 * A reference to a backend module holding renderer-related
		 * utility functions.
		 *
		 * @type {?WebGLBufferRenderer}
		 * @default null
		 */ this.bufferRenderer = null;
        /**
		 * A reference to the rendering context.
		 *
		 * @type {?WebGL2RenderingContext}
		 * @default null
		 */ this.gl = null;
        /**
		 * A reference to a backend module holding state-related
		 * utility functions.
		 *
		 * @type {?WebGLState}
		 * @default null
		 */ this.state = null;
        /**
		 * A reference to a backend module holding common
		 * utility functions.
		 *
		 * @type {?WebGLUtils}
		 * @default null
		 */ this.utils = null;
        /**
		 * Dictionary for caching VAOs.
		 *
		 * @type {Object<string,WebGLVertexArrayObject>}
		 */ this.vaoCache = {};
        /**
		 * Dictionary for caching transform feedback objects.
		 *
		 * @type {Object<string,WebGLTransformFeedback>}
		 */ this.transformFeedbackCache = {};
        /**
		 * Controls if `gl.RASTERIZER_DISCARD` should be enabled or not.
		 * Only relevant when using compute shaders.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.discard = false;
        /**
		 * A reference to the `EXT_disjoint_timer_query_webgl2` extension. `null` if the
		 * device does not support the extension.
		 *
		 * @type {?EXTDisjointTimerQueryWebGL2}
		 * @default null
		 */ this.disjoint = null;
        /**
		* A reference to the `KHR_parallel_shader_compile` extension. `null` if the
		* device does not support the extension.
		*
		* @type {?KHRParallelShaderCompile}
		* @default null
		*/ this.parallel = null;
        /**
		 * A reference to the current render context.
		 *
		 * @private
		 * @type {RenderContext}
		 * @default null
		 */ this._currentContext = null;
        /**
		 * A unique collection of bindings.
		 *
		 * @private
		 * @type {WeakSet<Array<BindGroup>>}
		 */ this._knownBindings = new WeakSet();
        /**
		 * Whether the device supports framebuffers invalidation or not.
		 *
		 * @private
		 * @type {boolean}
		 */ this._supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
        /**
		 * The target framebuffer when rendering with
		 * the WebXR device API.
		 *
		 * @private
		 * @type {?WebGLFramebuffer}
		 * @default null
		 */ this._xrFramebuffer = null;
    }
    /**
	 * Initializes the backend so it is ready for usage.
	 *
	 * @param {Renderer} renderer - The renderer.
	 */ init(renderer) {
        super.init(renderer);
        //
        const parameters = this.parameters;
        const contextAttributes = {
            antialias: renderer.currentSamples > 0,
            alpha: true,
            depth: renderer.depth,
            stencil: renderer.stencil
        };
        const glContext = parameters.context !== undefined ? parameters.context : renderer.domElement.getContext('webgl2', contextAttributes);
        function onContextLost(event) {
            event.preventDefault();
            const contextLossInfo = {
                api: 'WebGL',
                message: event.statusMessage || 'Unknown reason',
                reason: null,
                originalEvent: event
            };
            renderer.onDeviceLost(contextLossInfo);
        }
        this._onContextLost = onContextLost;
        renderer.domElement.addEventListener('webglcontextlost', onContextLost, false);
        this.gl = glContext;
        this.extensions = new $03ccd63b0299d6a7$var$WebGLExtensions(this);
        this.capabilities = new $03ccd63b0299d6a7$export$8b8a3854b4979269(this);
        this.attributeUtils = new $03ccd63b0299d6a7$var$WebGLAttributeUtils(this);
        this.textureUtils = new $03ccd63b0299d6a7$var$WebGLTextureUtils(this);
        this.bufferRenderer = new $03ccd63b0299d6a7$var$WebGLBufferRenderer(this);
        this.state = new $03ccd63b0299d6a7$var$WebGLState(this);
        this.utils = new $03ccd63b0299d6a7$var$WebGLUtils(this);
        this.extensions.get('EXT_color_buffer_float');
        this.extensions.get('WEBGL_clip_cull_distance');
        this.extensions.get('OES_texture_float_linear');
        this.extensions.get('EXT_color_buffer_half_float');
        this.extensions.get('WEBGL_multisampled_render_to_texture');
        this.extensions.get('WEBGL_render_shared_exponent');
        this.extensions.get('WEBGL_multi_draw');
        this.extensions.get('OVR_multiview2');
        this.extensions.get('EXT_clip_control');
        this.disjoint = this.extensions.get('EXT_disjoint_timer_query_webgl2');
        this.parallel = this.extensions.get('KHR_parallel_shader_compile');
        this.drawBuffersIndexedExt = this.extensions.get('OES_draw_buffers_indexed');
        if (parameters.reversedDepthBuffer) {
            if (this.extensions.has('EXT_clip_control')) renderer.reversedDepthBuffer = true;
            else {
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.');
                renderer.reversedDepthBuffer = false;
            }
        }
        if (renderer.reversedDepthBuffer) this.state.setReversedDepth(true);
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $9ddd7e9b53f7a2d4$export$5a0e9190d10875d3;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU. ReadbackBuffer can
	 * be used to retain and reuse handles to the intermediate buffers and prevent
	 * new allocation.
	 *
	 * @async
	 * @param {BufferAttribute} attribute - The storage buffer attribute to read frm.
	 * @param {ReadbackBuffer|ArrayBuffer} target - The storage buffer attribute.
	 * @param {number} offset - The storage buffer attribute.
	 * @param {number} count - The offset from which to start reading the
	 * @return {Promise<ArrayBuffer|ReadbackBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute, target = null, offset = 0, count = -1) {
        return await this.attributeUtils.getArrayBufferAsync(attribute, target, offset, count);
    }
    /**
	 * Ensures the backend is XR compatible.
	 *
	 * @async
	 * @return {Promise} A Promise that resolve when the renderer is XR compatible.
	 */ async makeXRCompatible() {
        const attributes = this.gl.getContextAttributes();
        if (attributes.xrCompatible !== true) await this.gl.makeXRCompatible();
    }
    /**
	 * Sets the XR rendering destination.
	 *
	 * @param {WebGLFramebuffer} xrFramebuffer - The XR framebuffer.
	 */ setXRTarget(xrFramebuffer) {
        this._xrFramebuffer = xrFramebuffer;
    }
    /**
	 * Configures the given XR render target with external textures.
	 *
	 * This method is only relevant when using the WebXR Layers API.
	 *
	 * @param {XRRenderTarget} renderTarget - The XR render target.
	 * @param {WebGLTexture} colorTexture - A native color texture.
	 * @param {?WebGLTexture} [depthTexture=null] - A native depth texture.
	 */ setXRRenderTargetTextures(renderTarget, colorTexture, depthTexture = null) {
        const gl = this.gl;
        this.set(renderTarget.texture, {
            textureGPU: colorTexture,
            glInternalFormat: gl.RGBA8
        }); // see #24698 why RGBA8 and not SRGB8_ALPHA8 is used
        if (depthTexture !== null) {
            const glInternalFormat = renderTarget.stencilBuffer ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
            this.set(renderTarget.depthTexture, {
                textureGPU: depthTexture,
                glInternalFormat: glInternalFormat
            });
            // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth texture.
            if (this.extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTarget._autoAllocateDepthBuffer === true && renderTarget.multiview === false) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLBackend: Render-to-texture extension was disabled because an external texture was provided');
            renderTarget._autoAllocateDepthBuffer = false;
        }
    }
    /**
	 * Inits a time stamp query for the given render context.
	 *
	 * @param {string} type - The type of the timestamp query.
	 * @param {string} uid - A unique identifier for the timestamp query.
	 */ initTimestampQuery(type, uid) {
        if (!this.disjoint || !this.trackTimestamp) return;
        if (!this.timestampQueryPool[type]) // TODO: Variable maxQueries?
        this.timestampQueryPool[type] = new $03ccd63b0299d6a7$var$WebGLTimestampQueryPool(this.gl, type, 2048);
        const timestampQueryPool = this.timestampQueryPool[type];
        const baseOffset = timestampQueryPool.allocateQueriesForContext(uid);
        if (baseOffset !== null) timestampQueryPool.beginQuery(uid);
    }
    // timestamp utils
    /**
	 * Prepares the timestamp buffer.
	 *
	 * @param {string} type - The type of the timestamp query.
	 * @param {string} uid - A unique identifier for the timestamp query.
	 */ prepareTimestampBuffer(type, uid) {
        if (!this.disjoint || !this.trackTimestamp) return;
        const timestampQueryPool = this.timestampQueryPool[type];
        timestampQueryPool.endQuery(uid);
    }
    /**
	 * Returns the backend's rendering context.
	 *
	 * @return {WebGL2RenderingContext} The rendering context.
	 */ getContext() {
        return this.gl;
    }
    /**
	 * This method is executed at the beginning of a render call and prepares
	 * the WebGL state for upcoming render calls
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender(renderContext) {
        const { state: state } = this;
        const renderContextData = this.get(renderContext);
        //
        if (renderContext.viewport) this.updateViewport(renderContext);
        else {
            const { width: width, height: height } = this.getDrawingBufferSize();
            state.viewport(0, 0, width, height);
        }
        if (renderContext.scissor) this.updateScissor(renderContext);
        else {
            const { width: width, height: height } = this.getDrawingBufferSize();
            state.scissor(0, 0, width, height);
        }
        //
        this.initTimestampQuery((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).RENDER, this.getTimestampUID(renderContext));
        renderContextData.previousContext = this._currentContext;
        this._currentContext = renderContext;
        this._setFramebuffer(renderContext);
        this.clear(renderContext.clearColor, renderContext.clearDepth, renderContext.clearStencil, renderContext, false);
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the async reading of all previous queries complete
            renderContextData.currentOcclusionQueries = renderContextData.occlusionQueries;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            renderContextData.lastOcclusionObject = null;
            renderContextData.occlusionQueries = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.occlusionQueryIndex = 0;
        }
    }
    /**
	 * This method is executed at the end of a render call and finalizes work
	 * after draw calls.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender(renderContext) {
        const { gl: gl, state: state } = this;
        const renderContextData = this.get(renderContext);
        const previousContext = renderContextData.previousContext;
        state.resetVertexState();
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (occlusionQueryCount > 0) {
            if (occlusionQueryCount > renderContextData.occlusionQueryIndex) gl.endQuery(gl.ANY_SAMPLES_PASSED);
            this.resolveOccludedAsync(renderContext);
        }
        const textures = renderContext.textures;
        if (textures !== null) for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (texture.generateMipmaps) this.generateMipmaps(texture);
        }
        this._currentContext = previousContext;
        this._resolveRenderTarget(renderContext);
        if (previousContext !== null) {
            this._setFramebuffer(previousContext);
            if (previousContext.viewport) this.updateViewport(previousContext);
            else {
                const { width: width, height: height } = this.getDrawingBufferSize();
                state.viewport(0, 0, width, height);
            }
            if (previousContext.scissor) this.updateScissor(previousContext);
            else {
                const { width: width, height: height } = this.getDrawingBufferSize();
                state.scissor(0, 0, width, height);
            }
        }
        this.prepareTimestampBuffer((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).RENDER, this.getTimestampUID(renderContext));
    }
    /**
	 * This method processes the result of occlusion queries and writes it
	 * into render context data.
	 *
	 * @async
	 * @param {RenderContext} renderContext - The render context.
	 */ resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueries: currentOcclusionQueries, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueries && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            const { gl: gl } = this;
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueries = null;
            const check = ()=>{
                let completed = 0;
                // check all queries and requeue as appropriate
                for(let i = 0; i < currentOcclusionQueries.length; i++){
                    const query = currentOcclusionQueries[i];
                    if (query === null) continue;
                    if (gl.getQueryParameter(query, gl.QUERY_RESULT_AVAILABLE)) {
                        if (gl.getQueryParameter(query, gl.QUERY_RESULT) === 0) occluded.add(currentOcclusionQueryObjects[i]);
                        currentOcclusionQueries[i] = null;
                        gl.deleteQuery(query);
                        completed++;
                    }
                }
                if (completed < currentOcclusionQueries.length) requestAnimationFrame(check);
                else renderContextData.occluded = occluded;
            };
            check();
        }
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport(renderContext) {
        const { state: state } = this;
        const { x: x, y: y, width: width, height: height } = renderContext.viewportValue;
        state.viewport(x, renderContext.height - height - y, width, height);
    }
    /**
	 * Updates the scissor with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateScissor(renderContext) {
        const { state: state } = this;
        const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
        state.scissor(x, renderContext.height - height - y, width, height);
    }
    /**
	 * Defines the scissor test.
	 *
	 * @param {boolean} boolean - Whether the scissor test should be enabled or not.
	 */ setScissorTest(boolean) {
        const state = this.state;
        state.setScissorTest(boolean);
    }
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const clearColor = super.getClearColor();
        // Since the canvas is always created with alpha: true,
        // WebGL must always premultiply the clear color.
        clearColor.r *= clearColor.a;
        clearColor.g *= clearColor.a;
        clearColor.b *= clearColor.a;
        return clearColor;
    }
    /**
	 * Performs a clear operation.
	 *
	 * @param {boolean} color - Whether the color buffer should be cleared or not.
	 * @param {boolean} depth - Whether the depth buffer should be cleared or not.
	 * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
	 * @param {?Object} [descriptor=null] - The render context of the current set render target.
	 * @param {boolean} [setFrameBuffer=true] - Controls whether the intermediate framebuffer should be set or not.
	 * @param {boolean} [resolveRenderTarget=true] - Controls whether an active render target should be resolved
	 * or not. Only relevant for explicit clears.
	 */ clear(color, depth, stencil, descriptor = null, setFrameBuffer = true, resolveRenderTarget = true) {
        const { gl: gl, renderer: renderer } = this;
        if (descriptor === null) {
            const clearColor = this.getClearColor();
            descriptor = {
                textures: null,
                clearColorValue: clearColor
            };
        }
        //
        let clear = 0;
        if (color) clear |= gl.COLOR_BUFFER_BIT;
        if (depth) clear |= gl.DEPTH_BUFFER_BIT;
        if (stencil) clear |= gl.STENCIL_BUFFER_BIT;
        if (clear !== 0) {
            let clearColor;
            if (descriptor.clearColorValue) clearColor = descriptor.clearColorValue;
            else clearColor = this.getClearColor();
            const clearDepth = renderer.getClearDepth();
            const clearStencil = renderer.getClearStencil();
            if (depth) this.state.setDepthMask(true);
            if (descriptor.textures === null) {
                gl.clearColor(clearColor.r, clearColor.g, clearColor.b, clearColor.a);
                gl.clear(clear);
            } else {
                if (setFrameBuffer) this._setFramebuffer(descriptor);
                if (color) {
                    for(let i = 0; i < descriptor.textures.length; i++)if (i === 0) gl.clearBufferfv(gl.COLOR, i, [
                        clearColor.r,
                        clearColor.g,
                        clearColor.b,
                        clearColor.a
                    ]);
                    else gl.clearBufferfv(gl.COLOR, i, [
                        0,
                        0,
                        0,
                        1
                    ]);
                }
                if (depth && stencil) gl.clearBufferfi(gl.DEPTH_STENCIL, 0, clearDepth, clearStencil);
                else if (depth) gl.clearBufferfv(gl.DEPTH, 0, [
                    clearDepth
                ]);
                else if (stencil) gl.clearBufferiv(gl.STENCIL, 0, [
                    clearStencil
                ]);
                if (setFrameBuffer && resolveRenderTarget) this._resolveRenderTarget(descriptor);
            }
        }
    }
    /**
	 * This method is executed at the beginning of a compute call and
	 * prepares the state for upcoming compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute(computeGroup) {
        const { state: state, gl: gl } = this;
        //
        state.bindFramebuffer(gl.FRAMEBUFFER, null);
        this.initTimestampQuery((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).COMPUTE, this.getTimestampUID(computeGroup));
    }
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {?number} [count=null] - The count of compute invocations. If `null`, the count is determined by the compute node.
	 */ compute(computeGroup, computeNode, bindings, pipeline, count = null) {
        const { state: state, gl: gl } = this;
        if (this.discard === false) {
            // required here to handle async behaviour of render.compute()
            state.enable(gl.RASTERIZER_DISCARD);
            this.discard = true;
        }
        const { programGPU: programGPU, transformBuffers: transformBuffers, attributes: attributes } = this.get(pipeline);
        const vaoKey = this._getVaoKey(attributes);
        const vaoGPU = this.vaoCache[vaoKey];
        if (vaoGPU === undefined) this.vaoCache[vaoKey] = this._createVao(attributes);
        else state.setVertexState(vaoGPU);
        state.useProgram(programGPU);
        this._bindUniforms(bindings);
        const transformFeedbackGPU = this._getTransformFeedback(transformBuffers);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        gl.beginTransformFeedback(gl.POINTS);
        count = count !== null ? count : computeNode.count;
        if (Array.isArray(count)) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGLBackend.compute(): The count parameter must be a single number, not an array.');
            count = count[0];
        } else if (count && typeof count === 'object' && count.isIndirectStorageBufferAttribute) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGLBackend.compute(): The count parameter must be a single number, not IndirectStorageBufferAttribute');
            count = computeNode.count;
        }
        if (attributes[0].isStorageInstancedBufferAttribute) gl.drawArraysInstanced(gl.POINTS, 0, 1, count);
        else gl.drawArrays(gl.POINTS, 0, count);
        gl.endTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        // switch active buffers
        for(let i = 0; i < transformBuffers.length; i++){
            const dualAttributeData = transformBuffers[i];
            if (dualAttributeData.pbo && this.has(dualAttributeData.pbo)) this.textureUtils.copyBufferToTexture(dualAttributeData.transformBuffer, dualAttributeData.pbo);
            dualAttributeData.switchBuffers();
        }
    }
    /**
	 * This method is executed at the end of a compute call and
	 * finalizes work after compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute(computeGroup) {
        const { state: state, gl: gl } = this;
        this.discard = false;
        state.disable(gl.RASTERIZER_DISCARD);
        this.prepareTimestampBuffer((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).COMPUTE, this.getTimestampUID(computeGroup));
        if (this._currentContext) this._setFramebuffer(this._currentContext);
    }
    /**
	 * Internal to determine if the current render target is a render target array with depth 2D array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
	 *
	 * @private
	 */ _isRenderCameraDepthArray(renderContext) {
        return renderContext.depthTexture && renderContext.depthTexture.isArrayTexture && renderContext.camera.isArrayCamera;
    }
    /**
	 * Internal draw function.
	 *
	 * @private
	 * @param {Object3D} object - The object to render.
	 * @param {WebGLBufferRenderer} renderer - The internal renderer.
	 * @param {number} firstVertex - The first vertex to render.
	 * @param {number} vertexCount - The vertex count.
	 * @param {number} instanceCount - The intance count.
	 * @param {WebGLProgram} programGPU - The raw WebGL shader program.
	 */ _draw(object, renderer, firstVertex, vertexCount, instanceCount, programGPU) {
        if (object.isBatchedMesh) {
            if (this.hasFeature('WEBGL_multi_draw') === false) {
                const { gl: gl } = this;
                const drawIdLocation = gl.getUniformLocation(programGPU, 'nodeUniformDrawId');
                const starts = object._multiDrawStarts;
                const counts = object._multiDrawCounts;
                const drawCount = object._multiDrawCount;
                for(let i = 0; i < drawCount; i++){
                    gl.uniform1ui(drawIdLocation, i);
                    renderer.render(starts[i], counts[i]);
                }
            } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
        } else if (instanceCount > 1) renderer.renderInstances(firstVertex, vertexCount, instanceCount);
        else renderer.render(firstVertex, vertexCount);
    }
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw(renderObject /*, info*/ ) {
        const { object: object, pipeline: pipeline, material: material, context: context, hardwareClippingPlanes: hardwareClippingPlanes } = renderObject;
        const { programGPU: programGPU } = this.get(pipeline);
        const { gl: gl, state: state } = this;
        const contextData = this.get(context);
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        //
        this._bindUniforms(renderObject.getBindings());
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        state.setMaterial(material, frontFaceCW, hardwareClippingPlanes);
        if (context.mrt !== null && context.textures !== null) state.setMRTBlending(context.textures, context.mrt, material);
        state.useProgram(programGPU);
        // vertex state
        const attributes = renderObject.getAttributes();
        const attributesData = this.get(attributes);
        let vaoGPU = attributesData.vaoGPU;
        if (vaoGPU === undefined) {
            const vaoKey = this._getVaoKey(attributes);
            vaoGPU = this.vaoCache[vaoKey];
            if (vaoGPU === undefined) {
                vaoGPU = this._createVao(attributes);
                this.vaoCache[vaoKey] = vaoGPU;
                attributesData.vaoGPU = vaoGPU;
            }
        }
        const index = renderObject.getIndex();
        const indexGPU = index !== null ? this.get(index).bufferGPU : null;
        state.setVertexState(vaoGPU, indexGPU);
        //
        const lastObject = contextData.lastOcclusionObject;
        if (lastObject !== object && lastObject !== undefined) {
            if (lastObject !== null && lastObject.occlusionTest === true) {
                gl.endQuery(gl.ANY_SAMPLES_PASSED);
                contextData.occlusionQueryIndex++;
            }
            if (object.occlusionTest === true) {
                const query = gl.createQuery();
                gl.beginQuery(gl.ANY_SAMPLES_PASSED, query);
                contextData.occlusionQueries[contextData.occlusionQueryIndex] = query;
                contextData.occlusionQueryObjects[contextData.occlusionQueryIndex] = object;
            }
            contextData.lastOcclusionObject = object;
        }
        //
        const renderer = this.bufferRenderer;
        if (object.isPoints) renderer.mode = gl.POINTS;
        else if (object.isLineSegments) renderer.mode = gl.LINES;
        else if (object.isLine) renderer.mode = gl.LINE_STRIP;
        else if (object.isLineLoop) renderer.mode = gl.LINE_LOOP;
        else if (material.wireframe === true) {
            state.setLineWidth(material.wireframeLinewidth * this.renderer.getPixelRatio());
            renderer.mode = gl.LINES;
        } else renderer.mode = gl.TRIANGLES;
        //
        const { vertexCount: vertexCount, instanceCount: instanceCount } = drawParams;
        let { firstVertex: firstVertex } = drawParams;
        renderer.object = object;
        if (index !== null) {
            firstVertex *= index.array.BYTES_PER_ELEMENT;
            const indexData = this.get(index);
            renderer.index = index.count;
            renderer.type = indexData.type;
        } else renderer.index = 0;
        if (renderObject.camera.isArrayCamera === true && renderObject.camera.cameras.length > 0 && renderObject.camera.isMultiViewCamera === false) {
            const cameraData = this.get(renderObject.camera);
            const cameras = renderObject.camera.cameras;
            const cameraIndex = renderObject.getBindingGroup('cameraIndex').bindings[0];
            if (cameraData.indexesGPU === undefined || cameraData.indexesGPU.length !== cameras.length) {
                const data = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]);
                const indexesGPU = [];
                for(let i = 0, len = cameras.length; i < len; i++){
                    const bufferGPU = gl.createBuffer();
                    data[0] = i;
                    gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                    gl.bufferData(gl.UNIFORM_BUFFER, data, gl.STATIC_DRAW);
                    indexesGPU.push(bufferGPU);
                }
                cameraData.indexesGPU = indexesGPU; // TODO: Create a global library for this
            }
            let cameraIndexBufferIndex = 0;
            bindingsSearch: for (const bindGroup of renderObject.getBindings())for (const binding of bindGroup.bindings){
                if (binding === cameraIndex) break bindingsSearch;
                if (binding.isUniformsGroup || binding.isUniformBuffer) cameraIndexBufferIndex++;
            }
            const pixelRatio = this.renderer.getPixelRatio();
            const renderTarget = this._currentContext.renderTarget;
            const isRenderCameraDepthArray = this._isRenderCameraDepthArray(this._currentContext);
            const prevActiveCubeFace = this._currentContext.activeCubeFace;
            if (isRenderCameraDepthArray) {
                // Clear the depth texture
                const textureData = this.get(renderTarget.depthTexture);
                if (textureData.clearedRenderId !== this.renderer._nodes.nodeFrame.renderId) {
                    textureData.clearedRenderId = this.renderer._nodes.nodeFrame.renderId;
                    const { stencilBuffer: stencilBuffer } = renderTarget;
                    for(let i = 0, len = cameras.length; i < len; i++){
                        this.renderer._activeCubeFace = i;
                        this._currentContext.activeCubeFace = i;
                        this._setFramebuffer(this._currentContext);
                        this.clear(false, true, stencilBuffer, this._currentContext, false, false);
                    }
                    this.renderer._activeCubeFace = prevActiveCubeFace;
                    this._currentContext.activeCubeFace = prevActiveCubeFace;
                }
            }
            for(let i = 0, len = cameras.length; i < len; i++){
                const subCamera = cameras[i];
                if (object.layers.test(subCamera.layers)) {
                    if (isRenderCameraDepthArray) {
                        // Update the active layer
                        this.renderer._activeCubeFace = i;
                        this._currentContext.activeCubeFace = i;
                        this._setFramebuffer(this._currentContext);
                    }
                    const vp = subCamera.viewport;
                    if (vp !== undefined) {
                        const x = vp.x * pixelRatio;
                        const y = vp.y * pixelRatio;
                        const width = vp.width * pixelRatio;
                        const height = vp.height * pixelRatio;
                        state.viewport(Math.floor(x), Math.floor(renderObject.context.height - height - y), Math.floor(width), Math.floor(height));
                    }
                    state.bindBufferBase(gl.UNIFORM_BUFFER, cameraIndexBufferIndex, cameraData.indexesGPU[i]);
                    this._draw(object, renderer, firstVertex, vertexCount, instanceCount, programGPU);
                }
                this._currentContext.activeCubeFace = prevActiveCubeFace;
                this.renderer._activeCubeFace = prevActiveCubeFace;
            }
        } else this._draw(object, renderer, firstVertex, vertexCount, instanceCount, programGPU);
    }
    /**
	 * Explain why always null is returned.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate() {
        return false;
    }
    /**
	 * Explain why no cache key is computed.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey() {
        return '';
    }
    // textures
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        this.textureUtils.createDefaultTexture(texture);
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        this.textureUtils.destroyTexture(texture, isDefaultTexture);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    /**
	 * This method does nothing since WebGL 2 has no concept of samplers.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler() {
        return '';
    }
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {GLSLNodeBuilder} The node builder.
	 */ createNodeBuilder(object, renderer) {
        return new $03ccd63b0299d6a7$export$9dbeb41c75797a5a(object, renderer);
    }
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram(program) {
        const gl = this.gl;
        const { stage: stage, code: code } = program;
        const shader = stage === 'fragment' ? gl.createShader(gl.FRAGMENT_SHADER) : gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(shader, code);
        gl.compileShader(shader);
        this.set(program, {
            shaderGPU: shader
        });
    }
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram(program) {
        this.delete(program);
    }
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        const gl = this.gl;
        const pipeline = renderObject.pipeline;
        // Program
        const { fragmentProgram: fragmentProgram, vertexProgram: vertexProgram } = pipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(vertexProgram).shaderGPU;
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.linkProgram(programGPU);
        this.set(pipeline, {
            programGPU: programGPU,
            fragmentShader: fragmentShader,
            vertexShader: vertexShader
        });
        if (promises !== null && this.parallel) {
            const p = new Promise((resolve /*, reject*/ )=>{
                const parallel = this.parallel;
                const checkStatus = ()=>{
                    if (gl.getProgramParameter(programGPU, parallel.COMPLETION_STATUS_KHR)) {
                        this._completeCompile(renderObject, pipeline);
                        resolve();
                    } else requestAnimationFrame(checkStatus);
                };
                checkStatus();
            });
            promises.push(p);
            return;
        }
        this._completeCompile(renderObject, pipeline);
    }
    /**
	 * Formats the source code of error messages.
	 *
	 * @private
	 * @param {string} string - The code.
	 * @param {number} errorLine - The error line.
	 * @return {string} The formatted code.
	 */ _handleSource(string, errorLine) {
        const lines = string.split('\n');
        const lines2 = [];
        const from = Math.max(errorLine - 6, 0);
        const to = Math.min(errorLine + 6, lines.length);
        for(let i = from; i < to; i++){
            const line = i + 1;
            lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
        }
        return lines2.join('\n');
    }
    /**
	 * Gets the shader compilation errors from the info log.
	 *
	 * @private
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 * @param {WebGLShader} shader - The WebGL shader object.
	 * @param {string} type - The shader type.
	 * @return {string} The shader errors.
	 */ _getShaderErrors(gl, shader, type) {
        const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
        const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
        const errors = shaderInfoLog.trim();
        if (status && errors === '') return '';
        const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
        if (errorMatches) {
            const errorLine = parseInt(errorMatches[1]);
            return type.toUpperCase() + '\n\n' + errors + '\n\n' + this._handleSource(gl.getShaderSource(shader), errorLine);
        } else return errors;
    }
    /**
	 * Logs shader compilation errors.
	 *
	 * @private
	 * @param {WebGLProgram} programGPU - The WebGL program.
	 * @param {WebGLShader} glFragmentShader - The fragment shader as a native WebGL shader object.
	 * @param {WebGLShader} glVertexShader - The vertex shader as a native WebGL shader object.
	 */ _logProgramError(programGPU, glFragmentShader, glVertexShader) {
        if (this.renderer.debug.checkShaderErrors) {
            const gl = this.gl;
            const programInfoLog = gl.getProgramInfoLog(programGPU) || '';
            const programLog = programInfoLog.trim();
            if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) {
                if (typeof this.renderer.debug.onShaderError === 'function') this.renderer.debug.onShaderError(gl, programGPU, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = this._getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = this._getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(programGPU, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGLProgram: Program Info Log:', programLog);
        }
    }
    /**
	 * Completes the shader program setup for the given render object.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {RenderPipeline} pipeline - The render pipeline.
	 */ _completeCompile(renderObject, pipeline) {
        const { state: state, gl: gl } = this;
        const pipelineData = this.get(pipeline);
        const { programGPU: programGPU, fragmentShader: fragmentShader, vertexShader: vertexShader } = pipelineData;
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        const bindings = renderObject.getBindings();
        this._setupBindings(bindings, programGPU);
        //
        this.set(pipeline, {
            programGPU: programGPU,
            pipeline: programGPU
        });
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(computePipeline, bindings) {
        const { state: state, gl: gl } = this;
        // Program
        const fragmentProgram = {
            stage: 'fragment',
            code: '#version 300 es\nprecision highp float;\nvoid main() {}'
        };
        this.createProgram(fragmentProgram);
        const { computeProgram: computeProgram } = computePipeline;
        const programGPU = gl.createProgram();
        const fragmentShader = this.get(fragmentProgram).shaderGPU;
        const vertexShader = this.get(computeProgram).shaderGPU;
        const transforms = computeProgram.transforms;
        const transformVaryingNames = [];
        const transformAttributeNodes = [];
        for(let i = 0; i < transforms.length; i++){
            const transform = transforms[i];
            transformVaryingNames.push(transform.varyingName);
            transformAttributeNodes.push(transform.attributeNode);
        }
        gl.attachShader(programGPU, fragmentShader);
        gl.attachShader(programGPU, vertexShader);
        gl.transformFeedbackVaryings(programGPU, transformVaryingNames, gl.SEPARATE_ATTRIBS);
        gl.linkProgram(programGPU);
        if (gl.getProgramParameter(programGPU, gl.LINK_STATUS) === false) this._logProgramError(programGPU, fragmentShader, vertexShader);
        state.useProgram(programGPU);
        // Bindings
        this._setupBindings(bindings, programGPU);
        const attributeNodes = computeProgram.attributes;
        const attributes = [];
        const transformBuffers = [];
        for(let i = 0; i < attributeNodes.length; i++){
            const attribute = attributeNodes[i].node.attribute;
            attributes.push(attribute);
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
        }
        for(let i = 0; i < transformAttributeNodes.length; i++){
            const attribute = transformAttributeNodes[i].attribute;
            if (!this.has(attribute)) this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
            const attributeData = this.get(attribute);
            transformBuffers.push(attributeData);
        }
        //
        this.set(computePipeline, {
            programGPU: programGPU,
            transformBuffers: transformBuffers,
            attributes: attributes
        });
    }
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings /*, cacheIndex, version*/ ) {
        if (this._knownBindings.has(bindings) === false) {
            this._knownBindings.add(bindings);
            let uniformBuffers = 0;
            let textures = 0;
            for (const bindGroup of bindings){
                this.set(bindGroup, {
                    textures: textures,
                    uniformBuffers: uniformBuffers
                });
                for (const binding of bindGroup.bindings){
                    if (binding.isUniformBuffer) uniformBuffers++;
                    if (binding.isSampledTexture) textures++;
                }
            }
        }
        this.updateBindings(bindGroup, bindings);
    }
    /**
	 * Updates the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings(bindGroup /*, bindings, cacheIndex, version*/ ) {
        const { gl: gl } = this;
        for (const binding of bindGroup.bindings){
            const map = this.get(binding);
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const array = binding.buffer;
                let { bufferGPU: bufferGPU } = this.get(array);
                if (bufferGPU === undefined) {
                    // create
                    bufferGPU = gl.createBuffer();
                    gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                    gl.bufferData(gl.UNIFORM_BUFFER, array.byteLength, gl.DYNAMIC_DRAW);
                    this.set(array, {
                        bufferGPU: bufferGPU
                    });
                } else gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                // update
                const updateRanges = binding.updateRanges;
                gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
                if (updateRanges.length === 0) gl.bufferData(gl.UNIFORM_BUFFER, array, gl.DYNAMIC_DRAW);
                else {
                    const isTyped = (0, $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c)(array);
                    const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
                    for(let i = 0, l = updateRanges.length; i < l; i++){
                        const range = updateRanges[i];
                        const dataOffset = range.start * byteOffsetFactor;
                        const size = range.count * byteOffsetFactor;
                        const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                        gl.bufferSubData(gl.UNIFORM_BUFFER, bufferOffset, array, dataOffset, size);
                    }
                }
                map.bufferGPU = bufferGPU;
                this.set(binding, map);
            } else if (binding.isSampledTexture) {
                const { textureGPU: textureGPU, glTextureType: glTextureType } = this.get(binding.texture);
                map.textureGPU = textureGPU;
                map.glTextureType = glTextureType;
                this.set(binding, map);
            }
        }
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        const gl = this.gl;
        if (binding.isUniformsGroup || binding.isUniformBuffer) {
            const bindingData = this.get(binding);
            const bufferGPU = bindingData.bufferGPU;
            const array = binding.buffer;
            const updateRanges = binding.updateRanges;
            gl.bindBuffer(gl.UNIFORM_BUFFER, bufferGPU);
            if (updateRanges.length === 0) gl.bufferData(gl.UNIFORM_BUFFER, array, gl.DYNAMIC_DRAW);
            else {
                const isTyped = (0, $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c)(array);
                const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
                for(let i = 0, l = updateRanges.length; i < l; i++){
                    const range = updateRanges[i];
                    const dataOffset = range.start * byteOffsetFactor;
                    const size = range.count * byteOffsetFactor;
                    const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                    gl.bufferSubData(gl.UNIFORM_BUFFER, bufferOffset, array, dataOffset, size);
                }
            }
        }
    }
    // attributes
    /**
	 * Creates the GPU buffer of an indexed shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute(attribute) {
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ELEMENT_ARRAY_BUFFER);
    }
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute(attribute) {
        if (this.has(attribute)) return;
        const gl = this.gl;
        this.attributeUtils.createAttribute(attribute, gl.ARRAY_BUFFER);
    }
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    /**
	 * Checks if the given feature is supported  by the backend.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        const keysMatching = Object.keys($03ccd63b0299d6a7$var$GLFeatureName).filter((key)=>$03ccd63b0299d6a7$var$GLFeatureName[key] === name);
        const extensions = this.extensions;
        for(let i = 0; i < keysMatching.length; i++){
            if (extensions.has(keysMatching[i])) return true;
        }
        return false;
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The source mip level to copy from.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        this.textureUtils.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, srcLevel, dstLevel);
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        this.textureUtils.copyFramebufferToTexture(texture, renderContext, rectangle);
    }
    /**
	 * Checks if the given compatibility is supported by the backend.
	 *
	 * @param {string} name - The compatibility name.
	 * @return {boolean} Whether the compatibility is supported or not.
	 */ hasCompatibility(name) {
        if (name === (0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE) return true;
        return super.hasCompatibility(name);
    }
    /**
	 * Initializes the render target defined in the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ initRenderTarget(renderContext) {
        const { gl: gl, state: state } = this;
        this._setFramebuffer(renderContext);
        state.bindFramebuffer(gl.FRAMEBUFFER, null);
    }
    /**
	 * Configures the active framebuffer from the given render context.
	 *
	 * @private
	 * @param {RenderContext} descriptor - The render context.
	 */ _setFramebuffer(descriptor) {
        const { gl: gl, state: state } = this;
        let currentFrameBuffer = null;
        if (descriptor.textures !== null) {
            const renderTarget = descriptor.renderTarget;
            const renderTargetContextData = this.get(renderTarget);
            const { samples: samples, depthBuffer: depthBuffer, stencilBuffer: stencilBuffer } = renderTarget;
            const isCube = renderTarget.isCubeRenderTarget === true;
            const isRenderTarget3D = renderTarget.isRenderTarget3D === true;
            const isRenderTargetArray = renderTarget.depth > 1;
            const isXRRenderTarget = renderTarget.isXRRenderTarget === true;
            const _hasExternalTextures = isXRRenderTarget === true && renderTarget._hasExternalTextures === true;
            let msaaFb = renderTargetContextData.msaaFrameBuffer;
            let depthRenderbuffer = renderTargetContextData.depthRenderbuffer;
            const multisampledRTTExt = this.extensions.get('WEBGL_multisampled_render_to_texture');
            const multiviewExt = this.extensions.get('OVR_multiview2');
            const useMultisampledRTT = this._useMultisampledExtension(renderTarget);
            const cacheKey = $03ccd63b0299d6a7$var$getCacheKey(descriptor);
            let fb;
            if (isCube) {
                renderTargetContextData.cubeFramebuffers || (renderTargetContextData.cubeFramebuffers = {});
                fb = renderTargetContextData.cubeFramebuffers[cacheKey];
            } else if (isXRRenderTarget && _hasExternalTextures === false) fb = this._xrFramebuffer;
            else {
                renderTargetContextData.framebuffers || (renderTargetContextData.framebuffers = {});
                fb = renderTargetContextData.framebuffers[cacheKey];
            }
            if (fb === undefined) {
                fb = gl.createFramebuffer();
                state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                const textures = descriptor.textures;
                const depthInvalidationArray = [];
                if (isCube) {
                    renderTargetContextData.cubeFramebuffers[cacheKey] = fb;
                    const { textureGPU: textureGPU } = this.get(textures[0]);
                    const cubeFace = this.renderer._activeCubeFace;
                    const mipLevel = this.renderer._activeMipmapLevel;
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace, textureGPU, mipLevel);
                } else {
                    renderTargetContextData.framebuffers[cacheKey] = fb;
                    for(let i = 0; i < textures.length; i++){
                        const texture = textures[i];
                        const textureData = this.get(texture);
                        textureData.renderTarget = descriptor.renderTarget;
                        textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                        const attachment = gl.COLOR_ATTACHMENT0 + i;
                        if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, attachment, textureData.textureGPU, 0, samples, 0, 2);
                        else if (isRenderTarget3D || isRenderTargetArray) {
                            const layer = this.renderer._activeCubeFace;
                            const mipLevel = this.renderer._activeMipmapLevel;
                            gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, textureData.textureGPU, mipLevel, layer);
                        } else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                        else {
                            const mipLevel = this.renderer._activeMipmapLevel;
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, textureData.textureGPU, mipLevel);
                        }
                    }
                }
                const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                if (renderTarget._autoAllocateDepthBuffer === true) {
                    const renderbuffer = gl.createRenderbuffer();
                    this.textureUtils.setupRenderBufferStorage(renderbuffer, descriptor, 0, useMultisampledRTT);
                    renderTargetContextData.xrDepthRenderbuffer = renderbuffer;
                    depthInvalidationArray.push(stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT);
                    gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
                    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, depthStyle, gl.RENDERBUFFER, renderbuffer);
                } else if (descriptor.depthTexture !== null) {
                    depthInvalidationArray.push(stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT);
                    const textureData = this.get(descriptor.depthTexture);
                    textureData.renderTarget = descriptor.renderTarget;
                    textureData.cacheKey = cacheKey; // required for copyTextureToTexture()
                    if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, samples, 0, 2);
                    else if (_hasExternalTextures && useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                    else {
                        if (descriptor.depthTexture.isArrayTexture) {
                            const layer = this.renderer._activeCubeFace;
                            gl.framebufferTextureLayer(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, layer);
                        } else if (descriptor.depthTexture.isCubeTexture) {
                            const cubeFace = this.renderer._activeCubeFace;
                            gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace, textureData.textureGPU, 0);
                        } else gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    }
                }
                renderTargetContextData.depthInvalidationArray = depthInvalidationArray;
            } else {
                const isRenderCameraDepthArray = this._isRenderCameraDepthArray(descriptor);
                if (isRenderCameraDepthArray) {
                    state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                    const layer = this.renderer._activeCubeFace;
                    const depthData = this.get(descriptor.depthTexture);
                    const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                    gl.framebufferTextureLayer(gl.FRAMEBUFFER, depthStyle, depthData.textureGPU, 0, layer);
                }
                // rebind external XR textures
                if ((isXRRenderTarget || useMultisampledRTT || renderTarget.multiview) && renderTarget._isOpaqueFramebuffer !== true) {
                    state.bindFramebuffer(gl.FRAMEBUFFER, fb);
                    // rebind color
                    const textureData = this.get(descriptor.textures[0]);
                    if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, textureData.textureGPU, 0, samples, 0, 2);
                    else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                    else gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    // rebind depth
                    const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                    if (renderTarget._autoAllocateDepthBuffer === true) {
                        const renderbuffer = renderTargetContextData.xrDepthRenderbuffer;
                        gl.bindRenderbuffer(gl.RENDERBUFFER, renderbuffer);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, depthStyle, gl.RENDERBUFFER, renderbuffer);
                    } else {
                        const textureData = this.get(descriptor.depthTexture);
                        if (renderTarget.multiview) multiviewExt.framebufferTextureMultisampleMultiviewOVR(gl.FRAMEBUFFER, depthStyle, textureData.textureGPU, 0, samples, 0, 2);
                        else if (useMultisampledRTT) multisampledRTTExt.framebufferTexture2DMultisampleEXT(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0, samples);
                        else gl.framebufferTexture2D(gl.FRAMEBUFFER, depthStyle, gl.TEXTURE_2D, textureData.textureGPU, 0);
                    }
                }
            }
            if (samples > 0 && useMultisampledRTT === false && !renderTarget.multiview) {
                if (msaaFb === undefined) {
                    const invalidationArray = [];
                    msaaFb = gl.createFramebuffer();
                    state.bindFramebuffer(gl.FRAMEBUFFER, msaaFb);
                    const msaaRenderbuffers = [];
                    const textures = descriptor.textures;
                    for(let i = 0; i < textures.length; i++){
                        msaaRenderbuffers[i] = gl.createRenderbuffer();
                        gl.bindRenderbuffer(gl.RENDERBUFFER, msaaRenderbuffers[i]);
                        invalidationArray.push(gl.COLOR_ATTACHMENT0 + i);
                        const texture = descriptor.textures[i];
                        const textureData = this.get(texture);
                        gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, textureData.glInternalFormat, descriptor.width, descriptor.height);
                        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                    }
                    gl.bindRenderbuffer(gl.RENDERBUFFER, null);
                    renderTargetContextData.msaaFrameBuffer = msaaFb;
                    renderTargetContextData.msaaRenderbuffers = msaaRenderbuffers;
                    if (depthBuffer && depthRenderbuffer === undefined) {
                        depthRenderbuffer = gl.createRenderbuffer();
                        this.textureUtils.setupRenderBufferStorage(depthRenderbuffer, descriptor, samples);
                        renderTargetContextData.depthRenderbuffer = depthRenderbuffer;
                        const depthStyle = stencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
                        invalidationArray.push(depthStyle);
                    }
                    renderTargetContextData.invalidationArray = invalidationArray;
                }
                currentFrameBuffer = renderTargetContextData.msaaFrameBuffer;
            } else currentFrameBuffer = fb;
            state.drawBuffers(descriptor, fb);
        }
        state.bindFramebuffer(gl.FRAMEBUFFER, currentFrameBuffer);
    }
    /**
	 * Computes the VAO key for the given index and attributes.
	 *
	 * @private
	 * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
	 * @return {string} The VAO key.
	 */ _getVaoKey(attributes) {
        let key = '';
        for(let i = 0; i < attributes.length; i++){
            const attributeData = this.get(attributes[i]);
            key += ':' + attributeData.id;
        }
        return key;
    }
    /**
	 * Creates a VAO from the index and attributes.
	 *
	 * @private
	 * @param {Array<BufferAttribute>} attributes - An array of buffer attributes.
	 * @return {Object} The VAO data.
	 */ _createVao(attributes) {
        const { gl: gl } = this;
        const vaoGPU = gl.createVertexArray();
        gl.bindVertexArray(vaoGPU);
        for(let i = 0; i < attributes.length; i++){
            const attribute = attributes[i];
            const attributeData = this.get(attribute);
            gl.bindBuffer(gl.ARRAY_BUFFER, attributeData.bufferGPU);
            gl.enableVertexAttribArray(i);
            let stride, offset;
            if (attribute.isInterleavedBufferAttribute === true) {
                stride = attribute.data.stride * attributeData.bytesPerElement;
                offset = attribute.offset * attributeData.bytesPerElement;
            } else {
                stride = 0;
                offset = 0;
            }
            if (attributeData.isInteger) gl.vertexAttribIPointer(i, attribute.itemSize, attributeData.type, stride, offset);
            else gl.vertexAttribPointer(i, attribute.itemSize, attributeData.type, attribute.normalized, stride, offset);
            if (attribute.isInstancedBufferAttribute && !attribute.isInterleavedBufferAttribute) gl.vertexAttribDivisor(i, attribute.meshPerAttribute);
            else if (attribute.isInterleavedBufferAttribute && attribute.data.isInstancedInterleavedBuffer) gl.vertexAttribDivisor(i, attribute.data.meshPerAttribute);
        }
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        return vaoGPU;
    }
    /**
	 * Creates a transform feedback from the given transform buffers.
	 *
	 * @private
	 * @param {Array<DualAttributeData>} transformBuffers - The transform buffers.
	 * @return {WebGLTransformFeedback} The transform feedback.
	 */ _getTransformFeedback(transformBuffers) {
        let key = '';
        for(let i = 0; i < transformBuffers.length; i++)key += ':' + transformBuffers[i].id;
        let transformFeedbackGPU = this.transformFeedbackCache[key];
        if (transformFeedbackGPU !== undefined) return transformFeedbackGPU;
        const { gl: gl } = this;
        transformFeedbackGPU = gl.createTransformFeedback();
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, transformFeedbackGPU);
        for(let i = 0; i < transformBuffers.length; i++){
            const attributeData = transformBuffers[i];
            gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, attributeData.transformBuffer);
        }
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
        this.transformFeedbackCache[key] = transformFeedbackGPU;
        return transformFeedbackGPU;
    }
    /**
	 * Setups the given bindings.
	 *
	 * @private
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {WebGLProgram} programGPU - The WebGL program.
	 */ _setupBindings(bindings, programGPU) {
        const gl = this.gl;
        let uniformBuffers = 0;
        let textures = 0;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const index = uniformBuffers++;
                const location = gl.getUniformBlockIndex(programGPU, binding.name);
                gl.uniformBlockBinding(programGPU, location, index);
            } else if (binding.isSampledTexture) {
                const index = textures++;
                const location = gl.getUniformLocation(programGPU, binding.name);
                gl.uniform1i(location, index);
            }
        }
    }
    /**
	 * Binds the given uniforms.
	 *
	 * @private
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ _bindUniforms(bindings) {
        const { gl: gl, state: state } = this;
        let uniformBuffers = 0;
        let textures = 0;
        for (const bindGroup of bindings)for (const binding of bindGroup.bindings){
            const bindingData = this.get(binding);
            if (binding.isUniformsGroup || binding.isUniformBuffer) {
                const index = uniformBuffers++;
                // TODO USE bindBufferRange to group multiple uniform buffers
                state.bindBufferBase(gl.UNIFORM_BUFFER, index, bindingData.bufferGPU);
            } else if (binding.isSampledTexture) {
                const index = textures++;
                state.bindTexture(bindingData.glTextureType, bindingData.textureGPU, gl.TEXTURE0 + index);
            }
        }
    }
    /**
	 * The method ensures multisampled render targets are resolved.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 */ _resolveRenderTarget(renderContext) {
        const { gl: gl, state: state } = this;
        const renderTarget = renderContext.renderTarget;
        if (renderContext.textures !== null && renderTarget) {
            const renderTargetContextData = this.get(renderTarget);
            if (renderTarget.samples > 0 && this._useMultisampledExtension(renderTarget) === false) {
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                let mask = gl.COLOR_BUFFER_BIT;
                if (renderTarget.resolveDepthBuffer) {
                    if (renderTarget.depthBuffer) mask |= gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= gl.STENCIL_BUFFER_BIT;
                }
                const msaaFrameBuffer = renderTargetContextData.msaaFrameBuffer;
                const msaaRenderbuffers = renderTargetContextData.msaaRenderbuffers;
                const textures = renderContext.textures;
                const isMRT = textures.length > 1;
                state.bindFramebuffer(gl.READ_FRAMEBUFFER, msaaFrameBuffer);
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                if (isMRT) // blitFramebuffer() can only copy/resolve the first color attachment of a framebuffer. When using MRT,
                // the engine temporarily removes all attachments and then configures each attachment for the resolve.
                for(let i = 0; i < textures.length; i++){
                    gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, null);
                    gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, null, 0);
                }
                for(let i = 0; i < textures.length; i++){
                    if (isMRT) {
                        // configure attachment for resolve
                        const { textureGPU: textureGPU } = this.get(textures[i]);
                        gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                        gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, textureGPU, 0);
                    }
                    if (renderContext.scissor) {
                        const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
                        const viewY = renderContext.height - height - y;
                        gl.blitFramebuffer(x, viewY, x + width, viewY + height, x, viewY, x + width, viewY + height, mask, gl.NEAREST);
                    } else gl.blitFramebuffer(0, 0, renderContext.width, renderContext.height, 0, 0, renderContext.width, renderContext.height, mask, gl.NEAREST);
                }
                if (isMRT) // restore attachments
                for(let i = 0; i < textures.length; i++){
                    const { textureGPU: textureGPU } = this.get(textures[i]);
                    gl.framebufferRenderbuffer(gl.READ_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.RENDERBUFFER, msaaRenderbuffers[i]);
                    gl.framebufferTexture2D(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, gl.TEXTURE_2D, textureGPU, 0);
                }
                if (this._supportsInvalidateFramebuffer === true) gl.invalidateFramebuffer(gl.READ_FRAMEBUFFER, renderTargetContextData.invalidationArray);
            } else if (renderTarget.resolveDepthBuffer === false && renderTargetContextData.framebuffers) {
                const fb = renderTargetContextData.framebuffers[renderContext.getCacheKey()];
                state.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fb);
                gl.invalidateFramebuffer(gl.DRAW_FRAMEBUFFER, renderTargetContextData.depthInvalidationArray);
            }
        }
    }
    /**
	 * Returns `true` if the `WEBGL_multisampled_render_to_texture` extension
	 * should be used when MSAA is enabled.
	 *
	 * @private
	 * @param {RenderTarget} renderTarget - The render target that should be multisampled.
	 * @return {boolean} Whether to use the `WEBGL_multisampled_render_to_texture` extension for MSAA or not.
	 */ _useMultisampledExtension(renderTarget) {
        if (renderTarget.multiview === true) return true;
        return renderTarget.samples > 0 && this.extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTarget._autoAllocateDepthBuffer !== false;
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        if (this.textureUtils !== null) this.textureUtils.dispose();
        const extension = this.extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
        this.renderer.domElement.removeEventListener('webglcontextlost', this._onContextLost);
    }
}
const $03ccd63b0299d6a7$var$GPUPrimitiveTopology = {
    PointList: 'point-list',
    LineList: 'line-list',
    LineStrip: 'line-strip',
    TriangleList: 'triangle-list'
};
const $03ccd63b0299d6a7$var$GPUShaderStage = typeof self !== 'undefined' && self.GPUShaderStage ? self.GPUShaderStage : {
    VERTEX: 1,
    FRAGMENT: 2,
    COMPUTE: 4
};
const $03ccd63b0299d6a7$var$GPUCompareFunction = {
    Never: 'never',
    Less: 'less',
    Equal: 'equal',
    LessEqual: 'less-equal',
    Greater: 'greater',
    NotEqual: 'not-equal',
    GreaterEqual: 'greater-equal',
    Always: 'always'
};
const $03ccd63b0299d6a7$var$GPUStoreOp = {
    Store: 'store'
};
const $03ccd63b0299d6a7$var$GPULoadOp = {
    Load: 'load',
    Clear: 'clear'
};
const $03ccd63b0299d6a7$var$GPUFrontFace = {
    CCW: 'ccw',
    CW: 'cw'
};
const $03ccd63b0299d6a7$var$GPUCullMode = {
    None: 'none',
    Back: 'back'
};
const $03ccd63b0299d6a7$var$GPUIndexFormat = {
    Uint16: 'uint16',
    Uint32: 'uint32'
};
const $03ccd63b0299d6a7$var$GPUTextureFormat = {
    // 8-bit formats
    R8Unorm: 'r8unorm',
    R8Snorm: 'r8snorm',
    R8Uint: 'r8uint',
    R8Sint: 'r8sint',
    // 16-bit formats
    R16Uint: 'r16uint',
    R16Sint: 'r16sint',
    R16Float: 'r16float',
    RG8Unorm: 'rg8unorm',
    RG8Snorm: 'rg8snorm',
    RG8Uint: 'rg8uint',
    RG8Sint: 'rg8sint',
    R16Unorm: 'r16unorm',
    R16Snorm: 'r16snorm',
    // 32-bit formats
    R32Uint: 'r32uint',
    R32Sint: 'r32sint',
    R32Float: 'r32float',
    RG16Uint: 'rg16uint',
    RG16Sint: 'rg16sint',
    RG16Float: 'rg16float',
    RGBA8Unorm: 'rgba8unorm',
    RGBA8UnormSRGB: 'rgba8unorm-srgb',
    RGBA8Snorm: 'rgba8snorm',
    RGBA8Uint: 'rgba8uint',
    RGBA8Sint: 'rgba8sint',
    BGRA8Unorm: 'bgra8unorm',
    BGRA8UnormSRGB: 'bgra8unorm-srgb',
    RG16Unorm: 'rg16unorm',
    RG16Snorm: 'rg16snorm',
    // Packed 32-bit formats
    RGB9E5UFloat: 'rgb9e5ufloat',
    RGB10A2Unorm: 'rgb10a2unorm',
    RG11B10UFloat: 'rg11b10ufloat',
    // 64-bit formats
    RG32Uint: 'rg32uint',
    RG32Sint: 'rg32sint',
    RG32Float: 'rg32float',
    RGBA16Uint: 'rgba16uint',
    RGBA16Sint: 'rgba16sint',
    RGBA16Float: 'rgba16float',
    RGBA16Unorm: 'rgba16unorm',
    RGBA16Snorm: 'rgba16snorm',
    // 128-bit formats
    RGBA32Uint: 'rgba32uint',
    RGBA32Sint: 'rgba32sint',
    RGBA32Float: 'rgba32float',
    Depth16Unorm: 'depth16unorm',
    Depth24Plus: 'depth24plus',
    Depth24PlusStencil8: 'depth24plus-stencil8',
    Depth32Float: 'depth32float',
    // 'depth32float-stencil8' extension
    Depth32FloatStencil8: 'depth32float-stencil8',
    // BC compressed formats usable if 'texture-compression-bc' is both
    // supported by the device/user agent and enabled in requestDevice.
    BC1RGBAUnorm: 'bc1-rgba-unorm',
    BC1RGBAUnormSRGB: 'bc1-rgba-unorm-srgb',
    BC2RGBAUnorm: 'bc2-rgba-unorm',
    BC2RGBAUnormSRGB: 'bc2-rgba-unorm-srgb',
    BC3RGBAUnorm: 'bc3-rgba-unorm',
    BC3RGBAUnormSRGB: 'bc3-rgba-unorm-srgb',
    BC4RUnorm: 'bc4-r-unorm',
    BC4RSnorm: 'bc4-r-snorm',
    BC5RGUnorm: 'bc5-rg-unorm',
    BC5RGSnorm: 'bc5-rg-snorm',
    BC6HRGBUFloat: 'bc6h-rgb-ufloat',
    BC6HRGBFloat: 'bc6h-rgb-float',
    BC7RGBAUnorm: 'bc7-rgba-unorm',
    BC7RGBAUnormSRGB: 'bc7-rgba-unorm-srgb',
    // ETC2 compressed formats usable if 'texture-compression-etc2' is both
    // supported by the device/user agent and enabled in requestDevice.
    ETC2RGB8Unorm: 'etc2-rgb8unorm',
    ETC2RGB8UnormSRGB: 'etc2-rgb8unorm-srgb',
    ETC2RGB8A1Unorm: 'etc2-rgb8a1unorm',
    ETC2RGB8A1UnormSRGB: 'etc2-rgb8a1unorm-srgb',
    ETC2RGBA8Unorm: 'etc2-rgba8unorm',
    ETC2RGBA8UnormSRGB: 'etc2-rgba8unorm-srgb',
    EACR11Unorm: 'eac-r11unorm',
    EACR11Snorm: 'eac-r11snorm',
    EACRG11Unorm: 'eac-rg11unorm',
    EACRG11Snorm: 'eac-rg11snorm',
    // ASTC compressed formats usable if 'texture-compression-astc' is both
    // supported by the device/user agent and enabled in requestDevice.
    ASTC4x4Unorm: 'astc-4x4-unorm',
    ASTC4x4UnormSRGB: 'astc-4x4-unorm-srgb',
    ASTC5x4Unorm: 'astc-5x4-unorm',
    ASTC5x4UnormSRGB: 'astc-5x4-unorm-srgb',
    ASTC5x5Unorm: 'astc-5x5-unorm',
    ASTC5x5UnormSRGB: 'astc-5x5-unorm-srgb',
    ASTC6x5Unorm: 'astc-6x5-unorm',
    ASTC6x5UnormSRGB: 'astc-6x5-unorm-srgb',
    ASTC6x6Unorm: 'astc-6x6-unorm',
    ASTC6x6UnormSRGB: 'astc-6x6-unorm-srgb',
    ASTC8x5Unorm: 'astc-8x5-unorm',
    ASTC8x5UnormSRGB: 'astc-8x5-unorm-srgb',
    ASTC8x6Unorm: 'astc-8x6-unorm',
    ASTC8x6UnormSRGB: 'astc-8x6-unorm-srgb',
    ASTC8x8Unorm: 'astc-8x8-unorm',
    ASTC8x8UnormSRGB: 'astc-8x8-unorm-srgb',
    ASTC10x5Unorm: 'astc-10x5-unorm',
    ASTC10x5UnormSRGB: 'astc-10x5-unorm-srgb',
    ASTC10x6Unorm: 'astc-10x6-unorm',
    ASTC10x6UnormSRGB: 'astc-10x6-unorm-srgb',
    ASTC10x8Unorm: 'astc-10x8-unorm',
    ASTC10x8UnormSRGB: 'astc-10x8-unorm-srgb',
    ASTC10x10Unorm: 'astc-10x10-unorm',
    ASTC10x10UnormSRGB: 'astc-10x10-unorm-srgb',
    ASTC12x10Unorm: 'astc-12x10-unorm',
    ASTC12x10UnormSRGB: 'astc-12x10-unorm-srgb',
    ASTC12x12Unorm: 'astc-12x12-unorm',
    ASTC12x12UnormSRGB: 'astc-12x12-unorm-srgb'
};
const $03ccd63b0299d6a7$var$GPUAddressMode = {
    ClampToEdge: 'clamp-to-edge',
    Repeat: 'repeat',
    MirrorRepeat: 'mirror-repeat'
};
const $03ccd63b0299d6a7$var$GPUFilterMode = {
    Linear: 'linear',
    Nearest: 'nearest'
};
const $03ccd63b0299d6a7$var$GPUBlendFactor = {
    Zero: 'zero',
    One: 'one',
    Src: 'src',
    OneMinusSrc: 'one-minus-src',
    SrcAlpha: 'src-alpha',
    OneMinusSrcAlpha: 'one-minus-src-alpha',
    Dst: 'dst',
    OneMinusDst: 'one-minus-dst',
    DstAlpha: 'dst-alpha',
    OneMinusDstAlpha: 'one-minus-dst-alpha',
    SrcAlphaSaturated: 'src-alpha-saturated',
    Constant: 'constant',
    OneMinusConstant: 'one-minus-constant'
};
const $03ccd63b0299d6a7$var$GPUBlendOperation = {
    Add: 'add',
    Subtract: 'subtract',
    ReverseSubtract: 'reverse-subtract',
    Min: 'min',
    Max: 'max'
};
const $03ccd63b0299d6a7$var$GPUColorWriteFlags = {
    None: 0,
    All: 0xF
};
const $03ccd63b0299d6a7$var$GPUStencilOperation = {
    Keep: 'keep',
    Zero: 'zero',
    Replace: 'replace',
    Invert: 'invert',
    IncrementClamp: 'increment-clamp',
    DecrementClamp: 'decrement-clamp',
    IncrementWrap: 'increment-wrap',
    DecrementWrap: 'decrement-wrap'
};
const $03ccd63b0299d6a7$var$GPUBufferBindingType = {
    Storage: 'storage',
    ReadOnlyStorage: 'read-only-storage'
};
const $03ccd63b0299d6a7$var$GPUStorageTextureAccess = {
    WriteOnly: 'write-only',
    ReadOnly: 'read-only',
    ReadWrite: 'read-write'
};
const $03ccd63b0299d6a7$var$GPUSamplerBindingType = {
    NonFiltering: 'non-filtering',
    Comparison: 'comparison'
};
const $03ccd63b0299d6a7$var$GPUTextureSampleType = {
    Float: 'float',
    UnfilterableFloat: 'unfilterable-float',
    Depth: 'depth',
    SInt: 'sint',
    UInt: 'uint'
};
const $03ccd63b0299d6a7$var$GPUTextureDimension = {
    TwoD: '2d',
    ThreeD: '3d'
};
const $03ccd63b0299d6a7$var$GPUTextureViewDimension = {
    TwoD: '2d',
    TwoDArray: '2d-array',
    Cube: 'cube',
    ThreeD: '3d'
};
const $03ccd63b0299d6a7$var$GPUTextureAspect = {
    All: 'all'
};
const $03ccd63b0299d6a7$var$GPUInputStepMode = {
    Vertex: 'vertex',
    Instance: 'instance'
};
const $03ccd63b0299d6a7$var$GPUFeatureName = {
    CoreFeaturesAndLimits: 'core-features-and-limits',
    DepthClipControl: 'depth-clip-control',
    Depth32FloatStencil8: 'depth32float-stencil8',
    TextureCompressionBC: 'texture-compression-bc',
    TextureCompressionBCSliced3D: 'texture-compression-bc-sliced-3d',
    TextureCompressionETC2: 'texture-compression-etc2',
    TextureCompressionASTC: 'texture-compression-astc',
    TextureCompressionASTCSliced3D: 'texture-compression-astc-sliced-3d',
    TimestampQuery: 'timestamp-query',
    IndirectFirstInstance: 'indirect-first-instance',
    ShaderF16: 'shader-f16',
    RG11B10UFloat: 'rg11b10ufloat-renderable',
    BGRA8UNormStorage: 'bgra8unorm-storage',
    Float32Filterable: 'float32-filterable',
    Float32Blendable: 'float32-blendable',
    ClipDistances: 'clip-distances',
    DualSourceBlending: 'dual-source-blending',
    Subgroups: 'subgroups',
    TextureFormatsTier1: 'texture-formats-tier1',
    TextureFormatsTier2: 'texture-formats-tier2'
};
const $03ccd63b0299d6a7$var$GPUFeatureMap = {
    'texture-compression-s3tc': 'texture-compression-bc',
    'texture-compression-etc1': 'texture-compression-etc2'
};
/**
 * A special form of sampler binding type.
 * It's texture value is managed by a node object.
 *
 * @private
 * @augments Sampler
 */ class $03ccd63b0299d6a7$var$NodeSampler extends $03ccd63b0299d6a7$var$Sampler {
    /**
	 * Constructs a new node-based sampler.
	 *
	 * @param {string} name - The samplers's name.
	 * @param {TextureNode} textureNode - The texture node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(name, textureNode, groupNode){
        super(name, textureNode ? textureNode.value : null);
        /**
		 * The texture node.
		 *
		 * @type {TextureNode}
		 */ this.textureNode = textureNode;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
    }
    /**
	 * Updates the texture value of this sampler.
	 *
	 * @return {boolean} Whether the sampler needs an update or not.
	 */ update() {
        const { textureNode: textureNode } = this;
        if (this.texture !== textureNode.value) {
            this.texture = textureNode.value;
            return true;
        }
        return super.update();
    }
}
/**
 * Represents a storage buffer binding type.
 *
 * @private
 * @augments Buffer
 */ class $03ccd63b0299d6a7$var$StorageBuffer extends $03ccd63b0299d6a7$var$Buffer {
    /**
	 * Constructs a new uniform buffer.
	 *
	 * @param {string} name - The buffer's name.
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ constructor(name, attribute){
        super(name, attribute ? attribute.array : null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @private
		 * @type {BufferAttribute}
		 */ this._attribute = attribute;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageBuffer = true;
    }
    /**
	 * The storage buffer attribute.
	 *
	 * @type {BufferAttribute}
	 */ get attribute() {
        return this._attribute;
    }
}
let $03ccd63b0299d6a7$var$_id = 0;
/**
 * A special form of storage buffer binding type.
 * It's buffer value is managed by a node object.
 *
 * @private
 * @augments StorageBuffer
 */ class $03ccd63b0299d6a7$var$NodeStorageBuffer extends $03ccd63b0299d6a7$var$StorageBuffer {
    /**
	 * Constructs a new node-based storage buffer.
	 *
	 * @param {StorageBufferNode} nodeUniform - The storage buffer node.
	 * @param {UniformGroupNode} groupNode - The uniform group node.
	 */ constructor(nodeUniform, groupNode){
        super('StorageBuffer_' + $03ccd63b0299d6a7$var$_id++, nodeUniform ? nodeUniform.value : null);
        /**
		 * The node uniform.
		 *
		 * @type {StorageBufferNode}
		 */ this.nodeUniform = nodeUniform;
        /**
		 * The access type.
		 *
		 * @type {string}
		 */ this.access = nodeUniform ? nodeUniform.access : $03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE;
        /**
		 * The uniform group node.
		 *
		 * @type {UniformGroupNode}
		 */ this.groupNode = groupNode;
    }
    /**
	 * The storage buffer attribute node.
	 *
	 * @type {StorageBufferAttribute}
	 */ get attribute() {
        return this.nodeUniform.value;
    }
    /**
	 * The storage buffer.
	 *
	 * @type {Float32Array}
	 */ get buffer() {
        return this.nodeUniform.value.array;
    }
}
/**
 * A WebGPU backend utility module used by {@link WebGPUTextureUtils}.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUTexturePassUtils extends $03ccd63b0299d6a7$var$DataMap {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {GPUDevice} device - The WebGPU device.
	 */ constructor(device){
        super();
        /**
		 * The WebGPU device.
		 *
		 * @type {GPUDevice}
		 */ this.device = device;
        const mipmapSource = `
struct VarysStruct {
	@builtin( position ) Position: vec4f,
	@location( 0 ) vTex : vec2f,
	@location( 1 ) @interpolate(flat, either) vBaseArrayLayer: u32,
};

@group( 0 ) @binding ( 2 )
var<uniform> flipY: u32;

@vertex
fn mainVS(
		@builtin( vertex_index ) vertexIndex : u32,
		@builtin( instance_index ) instanceIndex : u32 ) -> VarysStruct {

	var Varys : VarysStruct;

	var pos = array(
		vec2f( -1, -1 ),
		vec2f( -1,  3 ),
		vec2f(  3, -1 ),
	);

	let p = pos[ vertexIndex ];
	let mult = select( vec2f( 0.5, -0.5 ), vec2f( 0.5, 0.5 ), flipY != 0 );
	Varys.vTex = p * mult + vec2f( 0.5 );
	Varys.Position = vec4f( p, 0, 1 );
	Varys.vBaseArrayLayer = instanceIndex;

	return Varys;

}

@group( 0 ) @binding( 0 )
var imgSampler : sampler;

@group( 0 ) @binding( 1 )
var img2d : texture_2d<f32>;

@fragment
fn main_2d( Varys: VarysStruct ) -> @location( 0 ) vec4<f32> {

	return textureSample( img2d, imgSampler, Varys.vTex );

}

@group( 0 ) @binding( 1 )
var img2dArray : texture_2d_array<f32>;

@fragment
fn main_2d_array( Varys: VarysStruct ) -> @location( 0 ) vec4<f32> {

	return textureSample( img2dArray, imgSampler, Varys.vTex, Varys.vBaseArrayLayer );

}

const faceMat = array(
  mat3x3f(  0,  0,  -2,  0, -2,   0,  1,  1,   1 ),   // pos-x
  mat3x3f(  0,  0,   2,  0, -2,   0, -1,  1,  -1 ),   // neg-x
  mat3x3f(  2,  0,   0,  0,  0,   2, -1,  1,  -1 ),   // pos-y
  mat3x3f(  2,  0,   0,  0,  0,  -2, -1, -1,   1 ),   // neg-y
  mat3x3f(  2,  0,   0,  0, -2,   0, -1,  1,   1 ),   // pos-z
  mat3x3f( -2,  0,   0,  0, -2,   0,  1,  1,  -1 ),   // neg-z
);

@group( 0 ) @binding( 1 )
var imgCube : texture_cube<f32>;

@fragment
fn main_cube( Varys: VarysStruct ) -> @location( 0 ) vec4<f32> {

	return textureSample( imgCube, imgSampler, faceMat[ Varys.vBaseArrayLayer ] * vec3f( fract( Varys.vTex ), 1 ) );

}
`;
        /**
		 * The mipmap GPU sampler.
		 *
		 * @type {GPUSampler}
		 */ this.mipmapSampler = device.createSampler({
            minFilter: $03ccd63b0299d6a7$var$GPUFilterMode.Linear
        });
        /**
		 * The flipY GPU sampler.
		 *
		 * @type {GPUSampler}
		 */ this.flipYSampler = device.createSampler({
            minFilter: $03ccd63b0299d6a7$var$GPUFilterMode.Nearest
        }); //@TODO?: Consider using textureLoad()
        /**
		 * flip uniform buffer
		 * @type {GPUBuffer}
		 */ this.flipUniformBuffer = device.createBuffer({
            size: 4,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(this.flipUniformBuffer, 0, new Uint32Array([
            1
        ]));
        /**
		 * no flip uniform buffer
		 * @type {GPUBuffer}
		 */ this.noFlipUniformBuffer = device.createBuffer({
            size: 4,
            usage: GPUBufferUsage.UNIFORM
        });
        /**
		 * A cache for GPU render pipelines used for copy/transfer passes.
		 * Every texture format and textureBindingViewDimension combo requires a unique pipeline.
		 *
		 * @type {Object<string,GPURenderPipeline>}
		 */ this.transferPipelines = {};
        /**
		 * The mipmap shader module.
		 *
		 * @type {GPUShaderModule}
		 */ this.mipmapShaderModule = device.createShaderModule({
            label: 'mipmap',
            code: mipmapSource
        });
    }
    /**
	 * Returns a render pipeline for the internal copy render pass. The pass
	 * requires a unique render pipeline for each texture format.
	 *
	 * @param {string} format - The GPU texture format
	 * @param {string?} textureBindingViewDimension - The GPU texture binding view dimension
	 * @return {GPURenderPipeline} The GPU render pipeline.
	 */ getTransferPipeline(format, textureBindingViewDimension) {
        textureBindingViewDimension = textureBindingViewDimension || '2d-array';
        const key = `${format}-${textureBindingViewDimension}`;
        let pipeline = this.transferPipelines[key];
        if (pipeline === undefined) {
            pipeline = this.device.createRenderPipeline({
                label: `mipmap-${format}-${textureBindingViewDimension}`,
                vertex: {
                    module: this.mipmapShaderModule
                },
                fragment: {
                    module: this.mipmapShaderModule,
                    entryPoint: `main_${textureBindingViewDimension.replace('-', '_')}`,
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                layout: 'auto'
            });
            this.transferPipelines[key] = pipeline;
        }
        return pipeline;
    }
    /**
	 * Flip the contents of the given GPU texture along its vertical axis.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureGPUDescriptor - The texture descriptor.
	 * @param {number} [baseArrayLayer=0] - The index of the first array layer accessible to the texture view.
	 */ flipY(textureGPU, textureGPUDescriptor, baseArrayLayer = 0) {
        const format = textureGPUDescriptor.format;
        const { width: width, height: height } = textureGPUDescriptor.size;
        const tempTexture = this.device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: format,
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        });
        const copyTransferPipeline = this.getTransferPipeline(format, textureGPU.textureBindingViewDimension);
        const flipTransferPipeline = this.getTransferPipeline(format, tempTexture.textureBindingViewDimension);
        const commandEncoder = this.device.createCommandEncoder({});
        const pass = (pipeline, sourceTexture, sourceArrayLayer, destinationTexture, destinationArrayLayer, flipY)=>{
            const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.flipYSampler
                    },
                    {
                        binding: 1,
                        resource: sourceTexture.createView({
                            dimension: sourceTexture.textureBindingViewDimension || '2d-array',
                            baseMipLevel: 0,
                            mipLevelCount: 1
                        })
                    },
                    {
                        binding: 2,
                        resource: {
                            buffer: flipY ? this.flipUniformBuffer : this.noFlipUniformBuffer
                        }
                    }
                ]
            });
            const passEncoder = commandEncoder.beginRenderPass({
                colorAttachments: [
                    {
                        view: destinationTexture.createView({
                            dimension: '2d',
                            baseMipLevel: 0,
                            mipLevelCount: 1,
                            baseArrayLayer: destinationArrayLayer,
                            arrayLayerCount: 1
                        }),
                        loadOp: $03ccd63b0299d6a7$var$GPULoadOp.Clear,
                        storeOp: $03ccd63b0299d6a7$var$GPUStoreOp.Store
                    }
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(3, 1, 0, sourceArrayLayer);
            passEncoder.end();
        };
        pass(copyTransferPipeline, textureGPU, baseArrayLayer, tempTexture, 0, false);
        pass(flipTransferPipeline, tempTexture, 0, textureGPU, baseArrayLayer, true);
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        tempTexture.destroy();
    }
    /**
	 * Generates mipmaps for the given GPU texture.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ generateMipmaps(textureGPU, encoder = null) {
        const textureData = this.get(textureGPU);
        const passes = textureData.layers || this._mipmapCreateBundles(textureGPU);
        const commandEncoder = encoder || this.device.createCommandEncoder({
            label: 'mipmapEncoder'
        });
        this._mipmapRunBundles(commandEncoder, passes);
        if (encoder === null) this.device.queue.submit([
            commandEncoder.finish()
        ]);
        textureData.layers = passes;
    }
    /**
	 * Since multiple copy render passes are required to generate mipmaps, the passes
	 * are managed as render bundles to improve performance.
	 *
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @return {Array<Object>} An array of render bundles.
	 */ _mipmapCreateBundles(textureGPU) {
        const textureBindingViewDimension = textureGPU.textureBindingViewDimension || '2d-array';
        const pipeline = this.getTransferPipeline(textureGPU.format, textureBindingViewDimension);
        const bindGroupLayout = pipeline.getBindGroupLayout(0); // @TODO: Consider making this static.
        const passes = [];
        for(let baseMipLevel = 1; baseMipLevel < textureGPU.mipLevelCount; baseMipLevel++)for(let baseArrayLayer = 0; baseArrayLayer < textureGPU.depthOrArrayLayers; baseArrayLayer++){
            const bindGroup = this.device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.mipmapSampler
                    },
                    {
                        binding: 1,
                        resource: textureGPU.createView({
                            dimension: textureBindingViewDimension,
                            baseMipLevel: baseMipLevel - 1,
                            mipLevelCount: 1
                        })
                    },
                    {
                        binding: 2,
                        resource: {
                            buffer: this.noFlipUniformBuffer
                        }
                    }
                ]
            });
            const passDescriptor = {
                colorAttachments: [
                    {
                        view: textureGPU.createView({
                            dimension: '2d',
                            baseMipLevel: baseMipLevel,
                            mipLevelCount: 1,
                            baseArrayLayer: baseArrayLayer,
                            arrayLayerCount: 1
                        }),
                        loadOp: $03ccd63b0299d6a7$var$GPULoadOp.Clear,
                        storeOp: $03ccd63b0299d6a7$var$GPUStoreOp.Store
                    }
                ]
            };
            const passEncoder = this.device.createRenderBundleEncoder({
                colorFormats: [
                    textureGPU.format
                ]
            });
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(3, 1, 0, baseArrayLayer);
            passes.push({
                renderBundles: [
                    passEncoder.finish()
                ],
                passDescriptor: passDescriptor
            });
        }
        return passes;
    }
    /**
	 * Executes the render bundles.
	 *
	 * @param {GPUCommandEncoder} commandEncoder - The GPU command encoder.
	 * @param {Array<Object>} passes - An array of render bundles.
	 */ _mipmapRunBundles(commandEncoder, passes) {
        const levels = passes.length;
        for(let i = 0; i < levels; i++){
            const pass = passes[i];
            const passEncoder = commandEncoder.beginRenderPass(pass.passDescriptor);
            passEncoder.executeBundles(pass.renderBundles);
            passEncoder.end();
        }
    }
}
const $03ccd63b0299d6a7$var$_compareToWebGPU = {
    [(0, $9ddd7e9b53f7a2d4$export$d9e2d19a747baaab)]: 'never',
    [(0, $9ddd7e9b53f7a2d4$export$36bcf49c713b3eb7)]: 'less',
    [(0, $9ddd7e9b53f7a2d4$export$66f28d946fc6a0d5)]: 'equal',
    [(0, $9ddd7e9b53f7a2d4$export$64eea11eb407ddf1)]: 'less-equal',
    [(0, $9ddd7e9b53f7a2d4$export$155af022118f3a38)]: 'greater',
    [(0, $9ddd7e9b53f7a2d4$export$1cdcb70d53d65f61)]: 'greater-equal',
    [(0, $9ddd7e9b53f7a2d4$export$187b73a3e352c145)]: 'always',
    [(0, $9ddd7e9b53f7a2d4$export$67ab95dde6bed156)]: 'not-equal'
};
const $03ccd63b0299d6a7$var$_flipMap = [
    0,
    1,
    3,
    2,
    4,
    5
];
/**
 * A WebGPU backend utility module for managing textures.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUTextureUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A reference to the pass utils.
		 *
		 * @type {?WebGPUTexturePassUtils}
		 * @default null
		 */ this._passUtils = null;
        /**
		 * A dictionary for managing default textures. The key
		 * is the texture format, the value the texture object.
		 *
		 * @type {Object<string,Texture>}
		 */ this.defaultTexture = {};
        /**
		 * A dictionary for managing default cube textures. The key
		 * is the texture format, the value the texture object.
		 *
		 * @type {Object<string,CubeTexture>}
		 */ this.defaultCubeTexture = {};
        /**
		 * A default video frame.
		 *
		 * @type {?VideoFrame}
		 * @default null
		 */ this.defaultVideoFrame = null;
        /**
		 * A cache of shared texture samplers.
		 *
		 * @type {Map<string, Object>}
		 */ this._samplerCache = new Map();
    }
    /**
	 * Creates a GPU sampler for the given texture.
	 *
	 * @param {Texture} texture - The texture to create the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        const backend = this.backend;
        const samplerKey = texture.minFilter + '-' + texture.magFilter + '-' + texture.wrapS + '-' + texture.wrapT + '-' + (texture.wrapR || '0') + '-' + texture.anisotropy + '-' + (texture.compareFunction || 0);
        let samplerData = this._samplerCache.get(samplerKey);
        if (samplerData === undefined) {
            const samplerDescriptorGPU = {
                addressModeU: this._convertAddressMode(texture.wrapS),
                addressModeV: this._convertAddressMode(texture.wrapT),
                addressModeW: this._convertAddressMode(texture.wrapR),
                magFilter: this._convertFilterMode(texture.magFilter),
                minFilter: this._convertFilterMode(texture.minFilter),
                mipmapFilter: this._convertFilterMode(texture.minFilter),
                maxAnisotropy: 1
            };
            // Depth textures without compare function must use non-filtering (nearest) sampling
            if (texture.isDepthTexture && texture.compareFunction === null) {
                samplerDescriptorGPU.magFilter = $03ccd63b0299d6a7$var$GPUFilterMode.Nearest;
                samplerDescriptorGPU.minFilter = $03ccd63b0299d6a7$var$GPUFilterMode.Nearest;
                samplerDescriptorGPU.mipmapFilter = $03ccd63b0299d6a7$var$GPUFilterMode.Nearest;
            }
            // anisotropy can only be used when all filter modes are set to linear.
            if (samplerDescriptorGPU.magFilter === $03ccd63b0299d6a7$var$GPUFilterMode.Linear && samplerDescriptorGPU.minFilter === $03ccd63b0299d6a7$var$GPUFilterMode.Linear && samplerDescriptorGPU.mipmapFilter === $03ccd63b0299d6a7$var$GPUFilterMode.Linear) samplerDescriptorGPU.maxAnisotropy = texture.anisotropy;
            if (texture.isDepthTexture && texture.compareFunction !== null && backend.hasCompatibility((0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE)) samplerDescriptorGPU.compare = $03ccd63b0299d6a7$var$_compareToWebGPU[texture.compareFunction];
            const sampler = backend.device.createSampler(samplerDescriptorGPU);
            samplerData = {
                sampler: sampler,
                usedTimes: 0
            };
            this._samplerCache.set(samplerKey, samplerData);
        }
        const textureData = backend.get(texture);
        if (textureData.sampler !== samplerData.sampler) {
            // check if previous sampler is unused so it can be deleted
            if (textureData.sampler !== undefined) {
                const oldSamplerData = this._samplerCache.get(textureData.samplerKey);
                oldSamplerData.usedTimes--;
                if (oldSamplerData.usedTimes === 0) this._samplerCache.delete(textureData.samplerKey);
            }
            // update to new sampler data
            textureData.samplerKey = samplerKey;
            textureData.sampler = samplerData.sampler;
            samplerData.usedTimes++;
        }
        return samplerKey;
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 */ createDefaultTexture(texture) {
        let textureGPU;
        const format = $03ccd63b0299d6a7$var$getFormat(texture, this.backend.device);
        if (texture.isCubeTexture) textureGPU = this._getDefaultCubeTextureGPU(format);
        else textureGPU = this._getDefaultTextureGPU(format);
        this.backend.get(texture).texture = textureGPU;
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options = {}) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        if (textureData.initialized) throw new Error('WebGPUTextureUtils: Texture already initialized.');
        if (texture.isExternalTexture) {
            textureData.texture = texture.sourceTexture;
            textureData.initialized = true;
            return;
        }
        if (options.needsMipmaps === undefined) options.needsMipmaps = false;
        if (options.levels === undefined) options.levels = 1;
        if (options.depth === undefined) options.depth = 1;
        const { width: width, height: height, depth: depth, levels: levels } = options;
        if (texture.isFramebufferTexture) {
            if (options.renderTarget) options.format = this.backend.utils.getCurrentColorFormat(options.renderTarget);
            else options.format = this.backend.utils.getPreferredCanvasFormat();
        }
        const dimension = this._getDimension(texture);
        const format = texture.internalFormat || options.format || $03ccd63b0299d6a7$var$getFormat(texture, backend.device);
        textureData.format = format;
        const { samples: samples, primarySamples: primarySamples, isMSAA: isMSAA } = backend.utils.getTextureSampleData(texture);
        let usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC;
        if (texture.isStorageTexture === true) usage |= GPUTextureUsage.STORAGE_BINDING;
        if (texture.isCompressedTexture !== true && texture.isCompressedArrayTexture !== true && format !== $03ccd63b0299d6a7$var$GPUTextureFormat.RGB9E5UFloat) usage |= GPUTextureUsage.RENDER_ATTACHMENT;
        const textureDescriptorGPU = {
            label: texture.name,
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: depth
            },
            mipLevelCount: levels,
            sampleCount: primarySamples,
            dimension: dimension,
            format: format,
            usage: usage
        };
        // texture creation
        if (format === undefined) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Texture format not supported.');
            this.createDefaultTexture(texture);
            return;
        }
        if (texture.isCubeTexture) textureDescriptorGPU.textureBindingViewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.Cube;
        try {
            textureData.texture = backend.device.createTexture(textureDescriptorGPU);
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Failed to create texture with descriptor:', textureDescriptorGPU);
            this.createDefaultTexture(texture);
            return;
        }
        if (isMSAA) {
            const msaaTextureDescriptorGPU = Object.assign({}, textureDescriptorGPU);
            msaaTextureDescriptorGPU.label = msaaTextureDescriptorGPU.label + '-msaa';
            msaaTextureDescriptorGPU.sampleCount = samples;
            msaaTextureDescriptorGPU.mipLevelCount = 1; // See https://www.w3.org/TR/webgpu/#texture-creation
            textureData.msaaTexture = backend.device.createTexture(msaaTextureDescriptorGPU);
        }
        textureData.initialized = true;
        textureData.textureDescriptorGPU = textureDescriptorGPU;
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        const backend = this.backend;
        const textureData = backend.get(texture);
        if (textureData.texture !== undefined && isDefaultTexture === false) textureData.texture.destroy();
        if (textureData.msaaTexture !== undefined) textureData.msaaTexture.destroy();
        backend.delete(texture);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ generateMipmaps(texture, encoder = null) {
        const textureData = this.backend.get(texture);
        this._generateMipmaps(textureData.texture, encoder);
    }
    /**
	 * Returns the color buffer representing the color
	 * attachment of the default framebuffer.
	 *
	 * @return {GPUTexture} The color buffer.
	 */ getColorBuffer() {
        const backend = this.backend;
        const canvasTarget = backend.renderer.getCanvasTarget();
        const { width: width, height: height } = backend.getDrawingBufferSize();
        const samples = backend.renderer.currentSamples;
        const colorTexture = canvasTarget.colorTexture;
        const colorTextureData = backend.get(colorTexture);
        if (colorTexture.width === width && colorTexture.height === height && colorTexture.samples === samples) return colorTextureData.texture;
        // recreate
        let colorBuffer = colorTextureData.texture;
        if (colorBuffer) colorBuffer.destroy();
        colorBuffer = backend.device.createTexture({
            label: 'colorBuffer',
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            },
            sampleCount: backend.utils.getSampleCount(backend.renderer.currentSamples),
            format: backend.utils.getPreferredCanvasFormat(),
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC
        });
        //
        colorTexture.source.width = width;
        colorTexture.source.height = height;
        colorTexture.samples = samples;
        colorTextureData.texture = colorBuffer;
        return colorBuffer;
    }
    /**
	 * Returns the depth buffer representing the depth
	 * attachment of the default framebuffer.
	 *
	 * @param {boolean} [depth=true] - Whether depth is enabled or not.
	 * @param {boolean} [stencil=false] -  Whether stencil is enabled or not.
	 * @return {GPUTexture} The depth buffer.
	 */ getDepthBuffer(depth = true, stencil = false) {
        const backend = this.backend;
        const canvasTarget = backend.renderer.getCanvasTarget();
        const { width: width, height: height } = backend.getDrawingBufferSize();
        const samples = backend.renderer.currentSamples;
        const depthTexture = canvasTarget.depthTexture;
        if (depthTexture.width === width && depthTexture.height === height && depthTexture.samples === samples && depthTexture.depth === depth && depthTexture.stencil === stencil) return backend.get(depthTexture).texture;
        //
        const depthTextureGPU = backend.get(depthTexture).texture;
        let format, type;
        if (stencil) {
            format = (0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829);
            type = backend.renderer.reversedDepthBuffer === true ? (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) : (0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301);
        } else if (depth) {
            format = (0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045);
            type = backend.renderer.reversedDepthBuffer === true ? (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) : (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96);
        }
        if (depthTextureGPU !== undefined) {
            if (depthTexture.image.width === width && depthTexture.image.height === height && depthTexture.format === format && depthTexture.type === type && depthTexture.samples === samples) return depthTextureGPU;
            this.destroyTexture(depthTexture);
        }
        // recreate
        depthTexture.name = 'depthBuffer';
        depthTexture.format = format;
        depthTexture.type = type;
        depthTexture.image.width = width;
        depthTexture.image.height = height;
        depthTexture.samples = samples;
        this.createTexture(depthTexture, {
            width: width,
            height: height
        });
        return backend.get(depthTexture).texture;
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        const textureData = this.backend.get(texture);
        const mipmaps = texture.mipmaps;
        const { textureDescriptorGPU: textureDescriptorGPU } = textureData;
        if (texture.isRenderTargetTexture || textureDescriptorGPU === undefined /* unsupported texture format */ ) return;
        // transfer texture data
        if (texture.isDataTexture) {
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                this._copyBufferToTexture(mipmap, textureData.texture, textureDescriptorGPU, 0, texture.flipY, 0, i);
            }
            else this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY);
        } else if (texture.isArrayTexture || texture.isDataArrayTexture || texture.isData3DTexture) {
            if (texture.layerUpdates && texture.layerUpdates.size > 0) {
                for (const layerIndex of texture.layerUpdates)this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, layerIndex, texture.flipY, layerIndex);
                texture.clearLayerUpdates();
            } else for(let i = 0; i < options.image.depth; i++)this._copyBufferToTexture(options.image, textureData.texture, textureDescriptorGPU, i, texture.flipY, i);
        } else if (texture.isCompressedTexture || texture.isCompressedArrayTexture) this._copyCompressedBufferToTexture(texture.mipmaps, textureData.texture, textureDescriptorGPU);
        else if (texture.isCubeTexture) this._copyCubeMapToTexture(texture, textureData.texture, textureDescriptorGPU);
        else if (texture.isHTMLTexture) {
            const device = this.backend.device;
            const canvas = this.backend.renderer.domElement;
            const image = texture.image;
            if (typeof device.queue.copyElementImageToTexture !== 'function') return;
            // Skip the first frame — the element needs a paint record first.
            if (!textureData.hasPaintCallback) {
                textureData.hasPaintCallback = true;
                canvas.requestPaint();
                return;
            }
            const width = textureDescriptorGPU.size.width;
            const height = textureDescriptorGPU.size.height;
            device.queue.copyElementImageToTexture(image, width, height, {
                texture: textureData.texture
            });
            if (texture.flipY) this._flipY(textureData.texture, textureDescriptorGPU);
        } else {
            if (mipmaps.length > 0) for(let i = 0, il = mipmaps.length; i < il; i++){
                const mipmap = mipmaps[i];
                this._copyImageToTexture(mipmap, textureData.texture, textureDescriptorGPU, 0, texture.flipY, texture.premultiplyAlpha, i);
            }
            else this._copyImageToTexture(options.image, textureData.texture, textureDescriptorGPU, 0, texture.flipY, texture.premultiplyAlpha);
        }
        //
        textureData.version = texture.version;
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        const device = this.backend.device;
        const textureData = this.backend.get(texture);
        const textureGPU = textureData.texture;
        const format = textureData.textureDescriptorGPU.format;
        const bytesPerTexel = this._getBytesPerTexel(format);
        let bytesPerRow = width * bytesPerTexel;
        bytesPerRow = Math.ceil(bytesPerRow / 256) * 256; // Align to 256 bytes
        const readBuffer = device.createBuffer({
            size: (height - 1) * bytesPerRow + width * bytesPerTexel,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        const encoder = device.createCommandEncoder();
        encoder.copyTextureToBuffer({
            texture: textureGPU,
            origin: {
                x: x,
                y: y,
                z: faceIndex
            }
        }, {
            buffer: readBuffer,
            bytesPerRow: bytesPerRow
        }, {
            width: width,
            height: height
        });
        const typedArrayType = this._getTypedArrayType(format);
        device.queue.submit([
            encoder.finish()
        ]);
        await readBuffer.mapAsync(GPUMapMode.READ);
        const buffer = readBuffer.getMappedRange().slice();
        readBuffer.destroy();
        return new typedArrayType(buffer);
    }
    /**
	 * Frees all internal resources.
	 */ dispose() {
        this._samplerCache.clear();
    }
    /**
	 * Returns the default GPU texture for the given format.
	 *
	 * @private
	 * @param {string} format - The GPU format.
	 * @return {GPUTexture} The GPU texture.
	 */ _getDefaultTextureGPU(format) {
        let defaultTexture = this.defaultTexture[format];
        if (defaultTexture === undefined) {
            const texture = new (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a)();
            texture.minFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
            texture.magFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                format: format
            });
            this.defaultTexture[format] = defaultTexture = texture;
        }
        return this.backend.get(defaultTexture).texture;
    }
    /**
	 * Returns the default GPU cube texture for the given format.
	 *
	 * @private
	 * @param {string} format - The GPU format.
	 * @return {GPUTexture} The GPU texture.
	 */ _getDefaultCubeTextureGPU(format) {
        let defaultCubeTexture = this.defaultCubeTexture[format];
        if (defaultCubeTexture === undefined) {
            const texture = new (0, $9ddd7e9b53f7a2d4$export$ee2e5a18258a4049)();
            texture.minFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
            texture.magFilter = (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0);
            this.createTexture(texture, {
                width: 1,
                height: 1,
                depth: 6
            });
            this.defaultCubeTexture[format] = defaultCubeTexture = texture;
        }
        return this.backend.get(defaultCubeTexture).texture;
    }
    /**
	 * Uploads cube texture image data to the GPU memory.
	 *
	 * @private
	 * @param {CubeTexture} texture - The cube texture.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 */ _copyCubeMapToTexture(texture, textureGPU, textureDescriptorGPU) {
        const images = texture.images;
        const mipmaps = texture.mipmaps;
        for(let i = 0; i < 6; i++){
            const image = images[i];
            const flipIndex = texture.flipY === true ? $03ccd63b0299d6a7$var$_flipMap[i] : i;
            if (image.isDataTexture) this._copyBufferToTexture(image.image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY);
            else this._copyImageToTexture(image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, texture.premultiplyAlpha);
            for(let j = 0; j < mipmaps.length; j++){
                const mipmap = mipmaps[j];
                const image = mipmap.images[i];
                if (image.isDataTexture) this._copyBufferToTexture(image.image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, 0, j + 1);
                else this._copyImageToTexture(image, textureGPU, textureDescriptorGPU, flipIndex, texture.flipY, texture.premultiplyAlpha, j + 1);
            }
        }
    }
    /**
	 * Uploads texture image data to the GPU memory.
	 *
	 * @private
	 * @param {HTMLImageElement|ImageBitmap|HTMLCanvasElement} image - The image data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 * @param {number} originDepth - The origin depth.
	 * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
	 * @param {boolean} premultiplyAlpha - Whether the texture should have its RGB channels premultiplied by the alpha channel or not.
	 * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
	 */ _copyImageToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY, premultiplyAlpha, mipLevel = 0) {
        const device = this.backend.device;
        const width = mipLevel > 0 ? image.width : textureDescriptorGPU.size.width;
        const height = mipLevel > 0 ? image.height : textureDescriptorGPU.size.height;
        try {
            device.queue.copyExternalImageToTexture({
                source: image,
                flipY: flipY
            }, {
                texture: textureGPU,
                mipLevel: mipLevel,
                origin: {
                    x: 0,
                    y: 0,
                    z: originDepth
                },
                premultipliedAlpha: premultiplyAlpha
            }, {
                width: width,
                height: height,
                depthOrArrayLayers: 1
            });
        // try/catch has been added to fix bad video frame data on certain devices, see #32391
        } catch (_) {}
    }
    /**
	 * Returns the pass utils singleton.
	 *
	 * @private
	 * @return {WebGPUTexturePassUtils} The utils instance.
	 */ _getPassUtils() {
        let passUtils = this._passUtils;
        if (passUtils === null) this._passUtils = passUtils = new $03ccd63b0299d6a7$var$WebGPUTexturePassUtils(this.backend.device);
        return passUtils;
    }
    /**
	 * Generates mipmaps for the given GPU texture.
	 *
	 * @private
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {?GPUCommandEncoder} [encoder=null] - An optional command encoder used to generate mipmaps.
	 */ _generateMipmaps(textureGPU, encoder = null) {
        this._getPassUtils().generateMipmaps(textureGPU, encoder);
    }
    /**
	 * Flip the contents of the given GPU texture along its vertical axis.
	 *
	 * @private
	 * @param {GPUTexture} textureGPU - The GPU texture object.
	 * @param {Object} textureDescriptorGPU - The texture descriptor.
	 * @param {number} [originDepth=0] - The origin depth.
	 */ _flipY(textureGPU, textureDescriptorGPU, originDepth = 0) {
        this._getPassUtils().flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    /**
	 * Uploads texture buffer data to the GPU memory.
	 *
	 * @private
	 * @param {Object} image - An object defining the image buffer data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 * @param {number} originDepth - The origin depth.
	 * @param {boolean} flipY - Whether to flip texture data along their vertical axis or not.
	 * @param {number} [depth=0] - The depth offset when copying array or 3D texture data.
	 * @param {number} [mipLevel=0] - The mip level where the data should be copied to.
	 */ _copyBufferToTexture(image, textureGPU, textureDescriptorGPU, originDepth, flipY, depth = 0, mipLevel = 0) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        // @TODO: Consider to support valid buffer layouts with other formats like RGB
        const device = this.backend.device;
        const data = image.data;
        const bytesPerTexel = this._getBytesPerTexel(textureDescriptorGPU.format);
        const bytesPerRow = image.width * bytesPerTexel;
        device.queue.writeTexture({
            texture: textureGPU,
            mipLevel: mipLevel,
            origin: {
                x: 0,
                y: 0,
                z: originDepth
            }
        }, data, {
            offset: image.width * image.height * bytesPerTexel * depth,
            bytesPerRow: bytesPerRow
        }, {
            width: image.width,
            height: image.height,
            depthOrArrayLayers: 1
        });
        if (flipY === true) this._flipY(textureGPU, textureDescriptorGPU, originDepth);
    }
    /**
	 * Uploads compressed texture data to the GPU memory.
	 *
	 * @private
	 * @param {Array<Object>} mipmaps - An array with mipmap data.
	 * @param {GPUTexture} textureGPU - The GPU texture.
	 * @param {Object} textureDescriptorGPU - The GPU texture descriptor.
	 */ _copyCompressedBufferToTexture(mipmaps, textureGPU, textureDescriptorGPU) {
        // @TODO: Consider to use GPUCommandEncoder.copyBufferToTexture()
        const device = this.backend.device;
        const blockData = this._getBlockData(textureDescriptorGPU.format);
        const isArrayTexture = textureDescriptorGPU.size.depthOrArrayLayers > 1;
        for(let i = 0; i < mipmaps.length; i++){
            const mipmap = mipmaps[i];
            const width = mipmap.width;
            const height = mipmap.height;
            const depth = isArrayTexture ? textureDescriptorGPU.size.depthOrArrayLayers : 1;
            const bytesPerRow = Math.ceil(width / blockData.width) * blockData.byteLength;
            const bytesPerImage = bytesPerRow * Math.ceil(height / blockData.height);
            for(let j = 0; j < depth; j++)device.queue.writeTexture({
                texture: textureGPU,
                mipLevel: i,
                origin: {
                    x: 0,
                    y: 0,
                    z: j
                }
            }, mipmap.data, {
                offset: j * bytesPerImage,
                bytesPerRow: bytesPerRow,
                rowsPerImage: Math.ceil(height / blockData.height)
            }, {
                width: Math.ceil(width / blockData.width) * blockData.width,
                height: Math.ceil(height / blockData.height) * blockData.height,
                depthOrArrayLayers: 1
            });
        }
    }
    /**
	 * This method is only relevant for compressed texture formats. It returns a block
	 * data descriptor for the given GPU compressed texture format.
	 *
	 * @private
	 * @param {string} format - The GPU compressed texture format.
	 * @return {Object} The block data descriptor.
	 */ _getBlockData(format) {
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC1RGBAUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC1RGBAUnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // DXT1
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC2RGBAUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC2RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT3
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC3RGBAUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC3RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // DXT5
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC4RUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC4RSnorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        }; // RGTC1
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC5RGUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC5RGSnorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // RGTC2
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC6HRGBUFloat || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC6HRGBFloat) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (float)
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC7RGBAUnorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BC7RGBAUnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        }; // BPTC (unorm)
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8A1Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8A1UnormSRGB) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGBA8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGBA8UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.EACR11Unorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.EACR11Snorm) return {
            byteLength: 8,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.EACRG11Unorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.EACRG11Snorm) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC4x4Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC4x4UnormSRGB) return {
            byteLength: 16,
            width: 4,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x4Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x4UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 4
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x5Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x5UnormSRGB) return {
            byteLength: 16,
            width: 5,
            height: 5
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x5Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x5UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 5
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x6Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x6UnormSRGB) return {
            byteLength: 16,
            width: 6,
            height: 6
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x5Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x5UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 5
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x6Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x6UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 6
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x8UnormSRGB) return {
            byteLength: 16,
            width: 8,
            height: 8
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x5Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x5UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 5
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x6Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x6UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 6
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x8UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 8
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x10Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x10UnormSRGB) return {
            byteLength: 16,
            width: 10,
            height: 10
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x10Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x10UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 10
        };
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x12Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x12UnormSRGB) return {
            byteLength: 16,
            width: 12,
            height: 12
        };
    }
    /**
	 * Converts the three.js uv wrapping constants to GPU address mode constants.
	 *
	 * @private
	 * @param {number} value - The three.js constant defining a uv wrapping mode.
	 * @return {string} The GPU address mode.
	 */ _convertAddressMode(value) {
        let addressMode = $03ccd63b0299d6a7$var$GPUAddressMode.ClampToEdge;
        if (value === (0, $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5)) addressMode = $03ccd63b0299d6a7$var$GPUAddressMode.Repeat;
        else if (value === (0, $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f)) addressMode = $03ccd63b0299d6a7$var$GPUAddressMode.MirrorRepeat;
        return addressMode;
    }
    /**
	 * Converts the three.js filter constants to GPU filter constants.
	 *
	 * @private
	 * @param {number} value - The three.js constant defining a filter mode.
	 * @return {string} The GPU filter mode.
	 */ _convertFilterMode(value) {
        let filterMode = $03ccd63b0299d6a7$var$GPUFilterMode.Linear;
        if (value === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0) || value === (0, $9ddd7e9b53f7a2d4$export$d129e38cf6feaa8c) || value === (0, $9ddd7e9b53f7a2d4$export$d2327c1afe5bfdf2)) filterMode = $03ccd63b0299d6a7$var$GPUFilterMode.Nearest;
        return filterMode;
    }
    /**
	 * Returns the bytes-per-texel value for the given GPU texture format.
	 *
	 * @private
	 * @param {string} format - The GPU texture format.
	 * @return {number} The bytes-per-texel.
	 */ _getBytesPerTexel(format) {
        // 8-bit formats
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Snorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Sint) return 1;
        // 16-bit formats
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Snorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Snorm) return 2;
        // 32-bit formats
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8UnormSRGB || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Snorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BGRA8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BGRA8UnormSRGB || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Snorm || // Packed 32-bit formats
        format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGB9E5UFloat || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGB10A2Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG11B10UFloat || format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24Plus || format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24PlusStencil8 || format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32FloatStencil8) return 4;
        // 64-bit formats
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Float || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Snorm) return 8;
        // 128-bit formats
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Uint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Sint || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Float) return 16;
    }
    /**
	 * Returns the corresponding typed array type for the given GPU texture format.
	 *
	 * @private
	 * @param {string} format - The GPU texture format.
	 * @return {TypedArray.constructor} The typed array type.
	 */ _getTypedArrayType(format) {
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Uint) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Sint) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Unorm) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R8Snorm) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Uint) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Sint) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Unorm) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Snorm) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Uint) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Sint) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8UnormSRGB) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Snorm) return Int8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Uint) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Sint) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Uint) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Sint) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Uint) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Sint) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Float) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Float) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Float) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Unorm) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R16Snorm) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Unorm) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Snorm) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Unorm) return Uint16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Snorm) return Int16Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Uint) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Sint) return Int32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.R32Float) return Float32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Uint) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Sint) return Int32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Float) return Float32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Uint) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Sint) return Int32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Float) return Float32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.BGRA8Unorm || format === $03ccd63b0299d6a7$var$GPUTextureFormat.BGRA8UnormSRGB) return Uint8Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGB10A2Unorm) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RGB9E5UFloat) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.RG11B10UFloat) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32Float) return Float32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24Plus) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24PlusStencil8) return Uint32Array;
        if (format === $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32FloatStencil8) return Float32Array;
    }
    /**
	 * Returns the GPU dimensions for the given texture.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @return {string} The GPU dimension.
	 */ _getDimension(texture) {
        let dimension;
        if (texture.is3DTexture || texture.isData3DTexture) dimension = $03ccd63b0299d6a7$var$GPUTextureDimension.ThreeD;
        else dimension = $03ccd63b0299d6a7$var$GPUTextureDimension.TwoD;
        return dimension;
    }
}
/**
 * Returns the GPU format for the given texture.
 *
 * @param {Texture} texture - The texture.
 * @param {GPUDevice} [device] - The GPU device which is used for feature detection.
 * @return {string} The GPU format.
 */ function $03ccd63b0299d6a7$var$getFormat(texture, device) {
    const format = texture.format;
    const type = texture.type;
    const normalized = texture.normalized;
    const colorSpace = texture.colorSpace;
    const transfer = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).getTransfer(colorSpace);
    let formatGPU;
    let textureFormatsTier1 = false;
    if (normalized) {
        textureFormatsTier1 = device.features.has($03ccd63b0299d6a7$var$GPUFeatureName.TextureFormatsTier1);
        if (textureFormatsTier1 === false) (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Unable to use normalized textures without texture-formats-tier1 feature.');
    }
    if (texture.isCompressedTexture === true || texture.isCompressedArrayTexture === true) switch(format){
        case 0, $9ddd7e9b53f7a2d4$export$21d1799c6d552fc0:
        case 0, $9ddd7e9b53f7a2d4$export$afa304c3e981b668:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.BC1RGBAUnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.BC1RGBAUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$d2a1a68024a3e56c:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.BC2RGBAUnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.BC2RGBAUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$9a79c424327dacf9:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.BC3RGBAUnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.BC3RGBAUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$b1688df4c4c21670:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.BC4RUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$fc15e5d8261eed58:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.BC4RSnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$d220f6ade8463a0f:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.BC5RGUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$768646d09dc1b6ef:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.BC5RGSnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$ce40b115e188bc81:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.BC7RGBAUnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.BC7RGBAUnorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$7800993ef8106a6a:
        case 0, $9ddd7e9b53f7a2d4$export$6ab91af2d757aee7:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGB8Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$23ed8300a860e7d8:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGBA8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ETC2RGBA8Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$d5c566817123b2bf:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.EACR11Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$f5668dc623297d86:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.EACR11Snorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$e443ea3e1485f7bf:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.EACRG11Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$211402338cb75433:
            formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.EACRG11Snorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$dc5570b4a2b92d48:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC4x4UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC4x4Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$68880cd325f8b2fb:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x4UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x4Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$7d2c0be323373d95:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x5UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC5x5Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$22b52da301fc3a3e:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x5UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x5Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$c009e2cb4a66485e:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x6UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC6x6Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$118fff5afa255b63:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x5UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x5Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$120713c829ae0667:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x6UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x6Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$c79eeabbf53313e9:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC8x8Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$443cf6567cdd6424:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x5UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x5Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$6573984fc9840780:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x6UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x6Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$e7aee563f30091de:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x8Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$2eb8634622ddeab7:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x10UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC10x10Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$202b1ce7b5d25742:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x10UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x10Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$18ab77abd087e467:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x12UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.ASTC12x12Unorm;
            break;
        case 0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c:
            formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Unorm;
            break;
        default:
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture format.', format);
    }
    else switch(format){
        case 0, $9ddd7e9b53f7a2d4$export$3f8bb04b555a363c:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Snorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$88572337f312435f:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Snorm : $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Unorm : $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10:
                    formatGPU = transfer === (0, $9ddd7e9b53f7a2d4$export$8d0a61916cc26abb) ? $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8UnormSRGB : $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA8Unorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2697304443f382bc:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Float;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f6d331659b644596:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Float;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RGBAFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$7c67423a5ee6f5eb:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$5a4c329b7e2092d3:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGB9E5UFloat;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f240f067f72abe41:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG11B10UFloat;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RGBFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$4e041a7967d15c4b:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R8Snorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$88572337f312435f:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.R16Snorm : $03ccd63b0299d6a7$var$GPUTextureFormat.R16Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.R16Unorm : $03ccd63b0299d6a7$var$GPUTextureFormat.R16Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R32Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R8Unorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2697304443f382bc:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R16Float;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f6d331659b644596:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R32Float;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RedFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$6cdf0b461c7ce8a0:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$545fce0311a9796a:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Snorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$88572337f312435f:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Snorm : $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
                    formatGPU = textureFormatsTier1 ? $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Unorm : $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Uint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG8Unorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2697304443f382bc:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG16Float;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f6d331659b644596:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Float;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RGFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$c1b6b5136be58045:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$c63dc51868b06a9d:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth16Unorm;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24Plus;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f6d331659b644596:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32Float;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with DepthFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$1e113ac2d0905829:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$6c8ea339bfab1301:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24PlusStencil8;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$f6d331659b644596:
                    if (device && device.features.has($03ccd63b0299d6a7$var$GPUFeatureName.Depth32FloatStencil8) === false) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Depth textures with DepthStencilFormat + FloatType can only be used with the "depth32float-stencil8" GPU feature.');
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32FloatStencil8;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with DepthStencilFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$aa92e870a709d190:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.R32Uint;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RedIntegerFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$1ba1c45f9f77d4d7:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RG32Uint;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RGIntegerFormat.', type);
            }
            break;
        case 0, $9ddd7e9b53f7a2d4$export$c200e7d26f592f21:
            switch(type){
                case 0, $9ddd7e9b53f7a2d4$export$5c612977753abe2:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Sint;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96:
                    formatGPU = $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA32Uint;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture type with RGBAIntegerFormat.', type);
            }
            break;
        default:
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Unsupported texture format.', format);
    }
    return formatGPU;
}
const $03ccd63b0299d6a7$var$declarationRegexp = /^[fn]*\s*([a-z_0-9]+)?\s*\(([\s\S]*?)\)\s*[\-\>]*\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/i;
const $03ccd63b0299d6a7$var$propertiesRegexp = /([a-z_0-9]+)\s*:\s*([a-z_0-9]+(?:<[\s\S]+?>)?)/ig;
const $03ccd63b0299d6a7$var$wgslTypeLib$1 = {
    'f32': 'float',
    'i32': 'int',
    'u32': 'uint',
    'bool': 'bool',
    'vec2<f32>': 'vec2',
    'vec2<i32>': 'ivec2',
    'vec2<u32>': 'uvec2',
    'vec2<bool>': 'bvec2',
    'vec2f': 'vec2',
    'vec2i': 'ivec2',
    'vec2u': 'uvec2',
    'vec2b': 'bvec2',
    'vec3<f32>': 'vec3',
    'vec3<i32>': 'ivec3',
    'vec3<u32>': 'uvec3',
    'vec3<bool>': 'bvec3',
    'vec3f': 'vec3',
    'vec3i': 'ivec3',
    'vec3u': 'uvec3',
    'vec3b': 'bvec3',
    'vec4<f32>': 'vec4',
    'vec4<i32>': 'ivec4',
    'vec4<u32>': 'uvec4',
    'vec4<bool>': 'bvec4',
    'vec4f': 'vec4',
    'vec4i': 'ivec4',
    'vec4u': 'uvec4',
    'vec4b': 'bvec4',
    'mat2x2<f32>': 'mat2',
    'mat2x2f': 'mat2',
    'mat3x3<f32>': 'mat3',
    'mat3x3f': 'mat3',
    'mat4x4<f32>': 'mat4',
    'mat4x4f': 'mat4',
    'sampler': 'sampler',
    'texture_1d': 'texture',
    'texture_2d': 'texture',
    'texture_2d_array': 'texture',
    'texture_multisampled_2d': 'cubeTexture',
    'texture_depth_2d': 'depthTexture',
    'texture_depth_2d_array': 'depthTexture',
    'texture_depth_multisampled_2d': 'depthTexture',
    'texture_depth_cube': 'depthTexture',
    'texture_depth_cube_array': 'depthTexture',
    'texture_3d': 'texture3D',
    'texture_cube': 'cubeTexture',
    'texture_cube_array': 'cubeTexture',
    'texture_storage_1d': 'storageTexture',
    'texture_storage_2d': 'storageTexture',
    'texture_storage_2d_array': 'storageTexture',
    'texture_storage_3d': 'storageTexture'
};
const $03ccd63b0299d6a7$var$parse = (source)=>{
    source = source.trim();
    const declaration = source.match($03ccd63b0299d6a7$var$declarationRegexp);
    if (declaration !== null && declaration.length === 4) {
        const inputsCode = declaration[2];
        const propsMatches = [];
        let match = null;
        while((match = $03ccd63b0299d6a7$var$propertiesRegexp.exec(inputsCode)) !== null)propsMatches.push({
            name: match[1],
            type: match[2]
        });
        // Process matches to correctly pair names and types
        const inputs = [];
        for(let i = 0; i < propsMatches.length; i++){
            const { name: name, type: type } = propsMatches[i];
            let resolvedType = type;
            if (resolvedType.startsWith('ptr')) resolvedType = 'pointer';
            else {
                if (resolvedType.startsWith('texture')) resolvedType = type.split('<')[0];
                resolvedType = $03ccd63b0299d6a7$var$wgslTypeLib$1[resolvedType];
            }
            inputs.push(new $03ccd63b0299d6a7$export$9909d560ff36ee5e(resolvedType, name));
        }
        const blockCode = source.substring(declaration[0].length);
        const outputType = declaration[3] || 'void';
        const name = declaration[1] !== undefined ? declaration[1] : '';
        const type = $03ccd63b0299d6a7$var$wgslTypeLib$1[outputType] || outputType;
        return {
            type: type,
            inputs: inputs,
            name: name,
            inputsCode: inputsCode,
            blockCode: blockCode,
            outputType: outputType
        };
    } else throw new Error('FunctionNode: Function is not a WGSL code.');
};
/**
 * This class represents a WSL node function.
 *
 * @augments NodeFunction
 */ class $03ccd63b0299d6a7$var$WGSLNodeFunction extends $03ccd63b0299d6a7$var$NodeFunction {
    /**
	 * Constructs a new WGSL node function.
	 *
	 * @param {string} source - The WGSL source.
	 */ constructor(source){
        const { type: type, inputs: inputs, name: name, inputsCode: inputsCode, blockCode: blockCode, outputType: outputType } = $03ccd63b0299d6a7$var$parse(source);
        super(type, inputs, name);
        this.inputsCode = inputsCode;
        this.blockCode = blockCode;
        this.outputType = outputType;
    }
    /**
	 * This method returns the WGSL code of the node function.
	 *
	 * @param {string} [name=this.name] - The function's name.
	 * @return {string} The shader code.
	 */ getCode(name = this.name) {
        const outputType = this.outputType !== 'void' ? '-> ' + this.outputType : '';
        return `fn ${name} ( ${this.inputsCode.trim()} ) ${outputType}` + this.blockCode;
    }
}
/**
 * A WGSL node parser.
 *
 * @augments NodeParser
 */ class $03ccd63b0299d6a7$var$WGSLNodeParser extends $03ccd63b0299d6a7$var$NodeParser {
    /**
	 * The method parses the given WGSL code an returns a node function.
	 *
	 * @param {string} source - The WGSL code.
	 * @return {WGSLNodeFunction} A node function.
	 */ parseFunction(source) {
        return new $03ccd63b0299d6a7$var$WGSLNodeFunction(source);
    }
}
const $03ccd63b0299d6a7$var$accessNames = {
    [$03ccd63b0299d6a7$export$92538c74c63a703d.READ_ONLY]: 'read',
    [$03ccd63b0299d6a7$export$92538c74c63a703d.WRITE_ONLY]: 'write',
    [$03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE]: 'read_write'
};
const $03ccd63b0299d6a7$var$wrapNames = {
    [(0, $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5)]: 'repeat',
    [(0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06)]: 'clamp',
    [(0, $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f)]: 'mirror'
};
const $03ccd63b0299d6a7$var$gpuShaderStageLib = {
    'vertex': $03ccd63b0299d6a7$var$GPUShaderStage.VERTEX,
    'fragment': $03ccd63b0299d6a7$var$GPUShaderStage.FRAGMENT,
    'compute': $03ccd63b0299d6a7$var$GPUShaderStage.COMPUTE
};
const $03ccd63b0299d6a7$var$supports = {
    instance: true,
    swizzleAssign: false,
    storageBuffer: true
};
const $03ccd63b0299d6a7$var$wgslFnOpLib = {
    '^^': 'tsl_xor'
};
const $03ccd63b0299d6a7$var$wgslTypeLib = {
    float: 'f32',
    int: 'i32',
    uint: 'u32',
    bool: 'bool',
    color: 'vec3<f32>',
    vec2: 'vec2<f32>',
    ivec2: 'vec2<i32>',
    uvec2: 'vec2<u32>',
    bvec2: 'vec2<bool>',
    vec3: 'vec3<f32>',
    ivec3: 'vec3<i32>',
    uvec3: 'vec3<u32>',
    bvec3: 'vec3<bool>',
    vec4: 'vec4<f32>',
    ivec4: 'vec4<i32>',
    uvec4: 'vec4<u32>',
    bvec4: 'vec4<bool>',
    mat2: 'mat2x2<f32>',
    mat3: 'mat3x3<f32>',
    mat4: 'mat4x4<f32>'
};
const $03ccd63b0299d6a7$var$wgslCodeCache = {};
const $03ccd63b0299d6a7$var$wgslPolyfill = {
    tsl_xor: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_xor( a : bool, b : bool ) -> bool { return ( a || b ) && !( a && b ); }'),
    mod_float: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_mod_float( x : f32, y : f32 ) -> f32 { return x - y * floor( x / y ); }'),
    mod_vec2: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_mod_vec2( x : vec2f, y : vec2f ) -> vec2f { return x - y * floor( x / y ); }'),
    mod_vec3: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_mod_vec3( x : vec3f, y : vec3f ) -> vec3f { return x - y * floor( x / y ); }'),
    mod_vec4: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_mod_vec4( x : vec4f, y : vec4f ) -> vec4f { return x - y * floor( x / y ); }'),
    equals_bool: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_equals_bool( a : bool, b : bool ) -> bool { return a == b; }'),
    equals_bvec2: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_equals_bvec2( a : vec2f, b : vec2f ) -> vec2<bool> { return vec2<bool>( a.x == b.x, a.y == b.y ); }'),
    equals_bvec3: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_equals_bvec3( a : vec3f, b : vec3f ) -> vec3<bool> { return vec3<bool>( a.x == b.x, a.y == b.y, a.z == b.z ); }'),
    equals_bvec4: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_equals_bvec4( a : vec4f, b : vec4f ) -> vec4<bool> { return vec4<bool>( a.x == b.x, a.y == b.y, a.z == b.z, a.w == b.w ); }'),
    repeatWrapping_float: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_repeatWrapping_float( coord: f32 ) -> f32 { return fract( coord ); }'),
    mirrorWrapping_float: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_mirrorWrapping_float( coord: f32 ) -> f32 { let mirrored = fract( coord * 0.5 ) * 2.0; return 1.0 - abs( 1.0 - mirrored ); }'),
    clampWrapping_float: new $03ccd63b0299d6a7$export$347eb46a3090e941('fn tsl_clampWrapping_float( coord: f32 ) -> f32 { return clamp( coord, 0.0, 1.0 ); }'),
    biquadraticTexture: new $03ccd63b0299d6a7$export$347eb46a3090e941(/* wgsl */ `
fn tsl_biquadraticTexture( map : texture_2d<f32>, coord : vec2f, iRes : vec2u, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`),
    biquadraticTextureArray: new $03ccd63b0299d6a7$export$347eb46a3090e941(/* wgsl */ `
fn tsl_biquadraticTexture_array( map : texture_2d_array<f32>, coord : vec2f, iRes : vec2u, layer : u32, level : u32 ) -> vec4f {

	let res = vec2f( iRes );

	let uvScaled = coord * res;
	let uvWrapping = ( ( uvScaled % res ) + res ) % res;

	// https://www.shadertoy.com/view/WtyXRy

	let uv = uvWrapping - 0.5;
	let iuv = floor( uv );
	let f = fract( uv );

	let rg1 = textureLoad( map, vec2u( iuv + vec2( 0.5, 0.5 ) ) % iRes, layer, level );
	let rg2 = textureLoad( map, vec2u( iuv + vec2( 1.5, 0.5 ) ) % iRes, layer, level );
	let rg3 = textureLoad( map, vec2u( iuv + vec2( 0.5, 1.5 ) ) % iRes, layer, level );
	let rg4 = textureLoad( map, vec2u( iuv + vec2( 1.5, 1.5 ) ) % iRes, layer, level );

	return mix( mix( rg1, rg2, f.x ), mix( rg3, rg4, f.x ), f.y );

}
`)
};
const $03ccd63b0299d6a7$var$wgslMethods = {
    dFdx: 'dpdx',
    dFdy: '- dpdy',
    mod_float: 'tsl_mod_float',
    mod_vec2: 'tsl_mod_vec2',
    mod_vec3: 'tsl_mod_vec3',
    mod_vec4: 'tsl_mod_vec4',
    equals_bool: 'tsl_equals_bool',
    equals_bvec2: 'tsl_equals_bvec2',
    equals_bvec3: 'tsl_equals_bvec3',
    equals_bvec4: 'tsl_equals_bvec4',
    inversesqrt: 'inverseSqrt',
    bitcast: 'bitcast<f32>',
    floatpack_snorm_2x16: 'pack2x16snorm',
    floatpack_unorm_2x16: 'pack2x16unorm',
    floatpack_float16_2x16: 'pack2x16float',
    floatunpack_snorm_2x16: 'unpack2x16snorm',
    floatunpack_unorm_2x16: 'unpack2x16unorm',
    floatunpack_float16_2x16: 'unpack2x16float'
};
//
let $03ccd63b0299d6a7$var$diagnostics = '';
if ((typeof navigator !== 'undefined' && /Firefox|Deno/g.test(navigator.userAgent)) !== true) $03ccd63b0299d6a7$var$diagnostics += 'diagnostic( off, derivative_uniformity );\n';
/**
 * A node builder targeting WGSL.
 *
 * This module generates WGSL shader code from node materials and also
 * generates the respective bindings and vertex buffer definitions. These
 * data are later used by the renderer to create render and compute pipelines
 * for render objects.
 *
 * @augments NodeBuilder
 */ class $03ccd63b0299d6a7$var$WGSLNodeBuilder extends $03ccd63b0299d6a7$export$e3bd53a4d3c1a94e {
    /**
	 * Constructs a new WGSL node builder renderer.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Renderer} renderer - The renderer.
	 */ constructor(object, renderer){
        super(object, renderer, new $03ccd63b0299d6a7$var$WGSLNodeParser());
        /**
		 * A dictionary that holds for each shader stage ('vertex', 'fragment', 'compute')
		 * another dictionary which manages UBOs per group ('render','frame','object').
		 *
		 * @type {Object<string,Object<string,NodeUniformsGroup>>}
		 */ this.uniformGroups = {};
        /**
		 * A dictionary that holds the assigned binding indices for each uniform group.
		 * This ensures the same binding index is used across all shader stages.
		 *
		 * @type {Object<string,{index: number, id: number}>}
		 */ this.uniformGroupsBindings = {};
        /**
		 * A dictionary that holds for each shader stage a Map of builtins.
		 *
		 * @type {Object<string,Map<string,Object>>}
		 */ this.builtins = {};
        /**
		 * A dictionary that holds for each shader stage a Set of directives.
		 *
		 * @type {Object<string,Set<string>>}
		 */ this.directives = {};
        /**
		 * A map for managing scope arrays. Only relevant for when using
		 * {@link WorkgroupInfoNode} in context of compute shaders.
		 *
		 * @type {Map<string,Object>}
		 */ this.scopedArrays = new Map();
        /**
		 * A flag that indicates that early returns are allowed.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowEarlyReturns = true;
        /**
		 * A flag that indicates that global variables are allowed.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowGlobalVariables = true;
    }
    /**
	 * Generates the WGSL snippet for sampled textures.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ _generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${offsetSnippet} )`;
                return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet} )`;
            } else {
                if (offsetSnippet) return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${offsetSnippet} )`;
                return `textureSample( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet} )`;
            }
        } else return this.generateTextureSampleLevel(texture, textureProperty, uvSnippet, '0', depthSnippet);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with explicit mip level.
	 *
	 * @private
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureSampleLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (this.isUnfilterable(texture) === false) {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
                return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${levelSnippet} )`;
            } else {
                if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
                return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet} )`;
            }
        } else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet, depthSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet);
    }
    /**
	 * Generates a wrap function used in context of textures.
	 *
	 * @param {Texture} texture - The texture to generate the function for.
	 * @return {string} The name of the generated function.
	 */ generateWrapFunction(texture) {
        const functionName = `tsl_coord_${$03ccd63b0299d6a7$var$wrapNames[texture.wrapS]}S_${$03ccd63b0299d6a7$var$wrapNames[texture.wrapT]}_${texture.is3DTexture || texture.isData3DTexture ? '3d' : '2d'}T`;
        let nodeCode = $03ccd63b0299d6a7$var$wgslCodeCache[functionName];
        if (nodeCode === undefined) {
            const includes = [];
            // For 3D textures, use vec3f; for texture arrays, keep vec2f since array index is separate
            const coordType = texture.is3DTexture || texture.isData3DTexture ? 'vec3f' : 'vec2f';
            let code = `fn ${functionName}( coord : ${coordType} ) -> ${coordType} {\n\n\treturn ${coordType}(\n`;
            const addWrapSnippet = (wrap, axis)=>{
                if (wrap === (0, $9ddd7e9b53f7a2d4$export$533346c8e8dac0f5)) {
                    includes.push($03ccd63b0299d6a7$var$wgslPolyfill.repeatWrapping_float);
                    code += `\t\ttsl_repeatWrapping_float( coord.${axis} )`;
                } else if (wrap === (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06)) {
                    includes.push($03ccd63b0299d6a7$var$wgslPolyfill.clampWrapping_float);
                    code += `\t\ttsl_clampWrapping_float( coord.${axis} )`;
                } else if (wrap === (0, $9ddd7e9b53f7a2d4$export$c7e7c00b14f51a4f)) {
                    includes.push($03ccd63b0299d6a7$var$wgslPolyfill.mirrorWrapping_float);
                    code += `\t\ttsl_mirrorWrapping_float( coord.${axis} )`;
                } else {
                    code += `\t\tcoord.${axis}`;
                    (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)(`WebGPURenderer: Unsupported texture wrap type "${wrap}" for vertex shader.`);
                }
            };
            addWrapSnippet(texture.wrapS, 'x');
            code += ',\n';
            addWrapSnippet(texture.wrapT, 'y');
            if (texture.is3DTexture || texture.isData3DTexture) {
                code += ',\n';
                addWrapSnippet(texture.wrapR, 'z');
            }
            code += '\n\t);\n\n}\n';
            $03ccd63b0299d6a7$var$wgslCodeCache[functionName] = nodeCode = new $03ccd63b0299d6a7$export$347eb46a3090e941(code, includes);
        }
        nodeCode.build(this);
        return functionName;
    }
    /**
	 * Generates the array declaration string.
	 *
	 * @param {string} type - The type.
	 * @param {?number} [count] - The count.
	 * @return {string} The generated value as a shader string.
	 */ generateArrayDeclaration(type, count) {
        return `array< ${this.getType(type)}, ${count} >`;
    }
    /**
	 * Generates a WGSL variable that holds the texture dimension of the given texture.
	 * It also returns information about the number of layers (elements) of an arrayed
	 * texture as well as the cube face count of cube textures.
	 *
	 * @param {Texture} texture - The texture to generate the function for.
	 * @param {string} textureProperty - The name of the video texture uniform in the shader.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @return {string} The name of the dimension variable.
	 */ generateTextureDimension(texture, textureProperty, levelSnippet) {
        const textureData = this.getDataFromNode(texture, this.shaderStage, this.cache);
        if (textureData.dimensionsSnippet === undefined) textureData.dimensionsSnippet = {};
        let textureDimensionNode = textureData.dimensionsSnippet[levelSnippet];
        if (textureData.dimensionsSnippet[levelSnippet] === undefined) {
            let textureDimensionsParams;
            let dimensionType;
            const { primarySamples: primarySamples } = this.renderer.backend.utils.getTextureSampleData(texture);
            const isMultisampled = primarySamples > 1;
            if (texture.is3DTexture || texture.isData3DTexture) dimensionType = 'vec3<u32>';
            else // Regular 2D textures, depth textures, etc.
            dimensionType = 'vec2<u32>';
            // Build parameters string based on texture type and multisampling
            if (isMultisampled || texture.isStorageTexture) textureDimensionsParams = textureProperty;
            else textureDimensionsParams = `${textureProperty}${levelSnippet ? `, u32( ${levelSnippet} )` : ''}`;
            textureDimensionNode = new $03ccd63b0299d6a7$export$fec192598c332c7e(new $03ccd63b0299d6a7$export$e59ba5d29a1947fc(`textureDimensions( ${textureDimensionsParams} )`, dimensionType));
            textureData.dimensionsSnippet[levelSnippet] = textureDimensionNode;
            if (texture.isArrayTexture || texture.isDataArrayTexture || texture.is3DTexture || texture.isData3DTexture) textureData.arrayLayerCount = new $03ccd63b0299d6a7$export$fec192598c332c7e(new $03ccd63b0299d6a7$export$e59ba5d29a1947fc(`textureNumLayers(${textureProperty})`, 'u32'));
            // For cube textures, we know it's always 6 faces
            if (texture.isTextureCube) textureData.cubeFaceCount = new $03ccd63b0299d6a7$export$fec192598c332c7e(new $03ccd63b0299d6a7$export$e59ba5d29a1947fc('6u', 'u32'));
        }
        return textureDimensionNode.build(this);
    }
    /**
	 * Generates the WGSL snippet for a manual filtered texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @return {string} The WGSL snippet.
	 */ generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet = '0u', depthSnippet) {
        const wrapFunction = this.generateWrapFunction(texture);
        const textureDimension = this.generateTextureDimension(texture, textureProperty, levelSnippet);
        if (offsetSnippet) uvSnippet = `${uvSnippet} + vec2<f32>(${offsetSnippet}) / ${textureDimension}`;
        if (depthSnippet) {
            this._include('biquadraticTextureArray');
            return `tsl_biquadraticTexture_array( ${textureProperty}, ${wrapFunction}( ${uvSnippet} ), ${textureDimension}, u32( ${depthSnippet} ), u32( ${levelSnippet} ) )`;
        }
        this._include('biquadraticTexture');
        return `tsl_biquadraticTexture( ${textureProperty}, ${wrapFunction}( ${uvSnippet} ), ${textureDimension}, u32( ${levelSnippet} ) )`;
    }
    /**
	 * Generates the WGSL snippet for a texture lookup with explicit level-of-detail.
	 * Since it's a lookup, no sampling or filtering is applied.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [levelSnippet='0u'] - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet = '0u') {
        // Cube textures cannot use textureLoad in WGSL, must use textureSampleLevel
        if (texture.isCubeTexture === true) {
            if (offsetSnippet) uvSnippet = `${uvSnippet} + vec3<f32>(${offsetSnippet})`;
            // Depth textures require integer level, regular textures use float
            const levelType = texture.isDepthTexture ? 'u32' : 'f32';
            return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelType}( ${levelSnippet} ) )`;
        }
        const wrapFunction = this.generateWrapFunction(texture);
        const textureDimension = this.generateTextureDimension(texture, textureProperty, levelSnippet);
        const vecType = texture.is3DTexture || texture.isData3DTexture ? 'vec3' : 'vec2';
        const textureDimensionMargin = vecType === 'vec3' ? 'vec3<u32>( 1, 1, 1 )' : 'vec2<u32>( 1, 1 )';
        if (offsetSnippet) uvSnippet = `${uvSnippet} + ${vecType}<f32>(${offsetSnippet}) / ${vecType}<f32>( ${textureDimension} )`;
        const clampMin = `${vecType}<f32>( 0 )`;
        const clampMax = `${vecType}<f32>( ${textureDimension} - ${textureDimensionMargin} )`;
        uvSnippet = `${vecType}<u32>( clamp( floor( ${wrapFunction}( ${uvSnippet} ) * ${vecType}<f32>( ${textureDimension} ) ), ${clampMin}, ${clampMax} ) )`;
        return this.generateTextureLoad(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, null);
    }
    /**
	 * Generates the WGSL snippet that reads a single texel from a storage texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The WGSL snippet.
	 */ generateStorageTextureLoad(texture, textureProperty, uvIndexSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (offsetSnippet) uvIndexSnippet = `${uvIndexSnippet} + ${offsetSnippet}`;
        let snippet;
        if (depthSnippet) snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet} )`;
        else snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet} )`;
        return snippet;
    }
    /**
	 * Generates the WGSL snippet that reads a single texel from a texture without sampling or filtering.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLoad(texture, textureProperty, uvIndexSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (levelSnippet === null) levelSnippet = '0u';
        if (offsetSnippet) uvIndexSnippet = `${uvIndexSnippet} + ${offsetSnippet}`;
        let snippet;
        if (depthSnippet) snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet}, u32( ${levelSnippet} ) )`;
        else {
            snippet = `textureLoad( ${textureProperty}, ${uvIndexSnippet}, u32( ${levelSnippet} ) )`;
            if (this.renderer.backend.compatibilityMode && texture.isDepthTexture) snippet += '.x';
        }
        return snippet;
    }
    /**
	 * Generates the WGSL snippet that writes a single texel to a texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvIndexSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {string} valueSnippet - A WGSL snippet that represent the new texel value.
	 * @return {string} The WGSL snippet.
	 */ generateTextureStore(texture, textureProperty, uvIndexSnippet, depthSnippet, valueSnippet) {
        let snippet;
        if (depthSnippet) snippet = `textureStore( ${textureProperty}, ${uvIndexSnippet}, ${depthSnippet}, ${valueSnippet} )`;
        else snippet = `textureStore( ${textureProperty}, ${uvIndexSnippet}, ${valueSnippet} )`;
        return snippet;
    }
    /**
	 * Returns `true` if the sampled values of the given texture should be compared against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether the sampled values of the given texture should be compared against a reference value or not.
	 */ isSampleCompare(texture) {
        return texture.isDepthTexture === true && texture.compareFunction !== null && this.renderer.hasCompatibility((0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE);
    }
    /**
	 * Returns `true` if the given texture is unfilterable.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {boolean} Whether the given texture is unfilterable or not.
	 */ isUnfilterable(texture) {
        return this.getComponentTypeFromTexture(texture) !== 'float' || !this.isAvailable('float32Filterable') && texture.type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596) || this.isSampleCompare(texture) === false && texture.minFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0) && texture.magFilter === (0, $9ddd7e9b53f7a2d4$export$727aa5ec3fe39bf0) || this.renderer.backend.utils.getTextureSampleData(texture).primarySamples > 1;
    }
    /**
	 * Generates the WGSL snippet for sampling/loading the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTexture(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        let snippet = null;
        if (this.isUnfilterable(texture)) snippet = this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, '0', shaderStage);
        else snippet = this._generateTextureSample(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, shaderStage);
        return snippet;
    }
    /**
	 * Generates the WGSL snippet for sampling/loading the given texture using explicit gradients.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {Array<string>} gradSnippet - An array holding both gradient WGSL snippets.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureGrad(texture, textureProperty, uvSnippet, gradSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]}, ${offsetSnippet} )`;
                return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]} )`;
            } else {
                if (offsetSnippet) return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]}, ${offsetSnippet} )`;
                return `textureSampleGrad( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${gradSnippet[0]}, ${gradSnippet[1]} )`;
            }
        } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: THREE.TextureNode.gradient() does not support ${shaderStage} shader.`);
    }
    /**
	 * Generates the WGSL snippet for sampling a depth texture and comparing the sampled depth values
	 * against a reference value.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} compareSnippet -  A WGSL snippet that represents the reference value.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureCompare(texture, textureProperty, uvSnippet, compareSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (texture.isDepthTexture === true && texture.isArrayTexture === true) {
                if (offsetSnippet) return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${compareSnippet}, ${offsetSnippet} )`;
                return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${compareSnippet} )`;
            }
            if (offsetSnippet) return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${compareSnippet}, ${offsetSnippet} )`;
            return `textureSampleCompare( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${compareSnippet} )`;
        } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: THREE.DepthTexture.compareFunction() does not support ${shaderStage} shader.`);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with explicit mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} levelSnippet - A WGSL snippet that represents the mip level, with level 0 containing a full size version of the texture.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureLevel(texture, textureProperty, uvSnippet, levelSnippet, depthSnippet, offsetSnippet) {
        if (this.isUnfilterable(texture) === false) {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
                return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${levelSnippet} )`;
            } else {
                if (offsetSnippet) return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet}, ${offsetSnippet} )`;
                return `textureSampleLevel( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${levelSnippet} )`;
            }
        } else if (this.isFilteredTexture(texture)) return this.generateFilteredTexture(texture, textureProperty, uvSnippet, offsetSnippet, levelSnippet, depthSnippet);
        else return this.generateTextureLod(texture, textureProperty, uvSnippet, depthSnippet, offsetSnippet, levelSnippet);
    }
    /**
	 * Generates the WGSL snippet when sampling textures with a bias to the mip level.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {string} textureProperty - The name of the texture uniform in the shader.
	 * @param {string} uvSnippet - A WGSL snippet that represents texture coordinates used for sampling.
	 * @param {string} biasSnippet - A WGSL snippet that represents the bias to apply to the mip level before sampling.
	 * @param {?string} depthSnippet - A WGSL snippet that represents 0-based texture array index to sample.
	 * @param {?string} offsetSnippet - A WGSL snippet that represents the offset that will be applied to the unnormalized texture coordinate before sampling the texture.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The WGSL snippet.
	 */ generateTextureBias(texture, textureProperty, uvSnippet, biasSnippet, depthSnippet, offsetSnippet, shaderStage = this.shaderStage) {
        if (shaderStage === 'fragment') {
            if (depthSnippet) {
                if (offsetSnippet) return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${biasSnippet}, ${offsetSnippet} )`;
                return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${depthSnippet}, ${biasSnippet} )`;
            } else {
                if (offsetSnippet) return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${biasSnippet}, ${offsetSnippet} )`;
                return `textureSampleBias( ${textureProperty}, ${textureProperty}_sampler, ${uvSnippet}, ${biasSnippet} )`;
            }
        } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: THREE.TextureNode.biasNode does not support ${shaderStage} shader.`);
    }
    /**
	 * Returns a WGSL snippet that represents the property name of the given node.
	 *
	 * @param {Node} node - The node.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getPropertyName(node, shaderStage = this.shaderStage) {
        if (node.isNodeVarying === true && node.needsInterpolation === true) {
            if (shaderStage === 'vertex') return `varyings.${node.name}`;
        } else if (node.isNodeUniform === true) {
            const name = node.name;
            const type = node.type;
            if (type === 'texture' || type === 'cubeTexture' || type === 'cubeDepthTexture' || type === 'storageTexture' || type === 'texture3D') return name;
            else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') {
                if (this.isCustomStruct(node)) return name;
                return name + '.value';
            } else return node.groupNode.name + '.' + name;
        }
        return super.getPropertyName(node);
    }
    /**
	 * Returns the output struct name.
	 *
	 * @return {string} The name of the output struct.
	 */ getOutputStructName() {
        return 'output';
    }
    /**
	 * Returns the native shader operator name for a given generic name.
	 *
	 * @param {string} op - The operator name to resolve.
	 * @return {?string} The resolved operator name.
	 */ getFunctionOperator(op) {
        const fnOp = $03ccd63b0299d6a7$var$wgslFnOpLib[op];
        if (fnOp !== undefined) {
            this._include(fnOp);
            return fnOp;
        }
        return null;
    }
    /**
	 * Returns the node access for the given node and shader stage.
	 *
	 * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The node access.
	 */ getNodeAccess(node, shaderStage) {
        if (shaderStage !== 'compute') {
            if (node.isAtomic === true) {
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: Atomic operations are only supported in compute shaders.');
                return $03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE;
            }
            return $03ccd63b0299d6a7$export$92538c74c63a703d.READ_ONLY;
        }
        return node.access;
    }
    /**
	 * Returns A WGSL snippet representing the storage access.
	 *
	 * @param {StorageTextureNode|StorageBufferNode} node - The storage node.
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet representing the storage access.
	 */ getStorageAccess(node, shaderStage) {
        return $03ccd63b0299d6a7$var$accessNames[this.getNodeAccess(node, shaderStage)];
    }
    /**
	 * This method is one of the more important ones since it's responsible
	 * for generating a matching binding instance for the given uniform node.
	 *
	 * These bindings are later used in the renderer to create bind groups
	 * and layouts.
	 *
	 * @param {UniformNode} node - The uniform node.
	 * @param {string} type - The node data type.
	 * @param {string} shaderStage - The shader stage.
	 * @param {?string} [name=null] - An optional uniform name.
	 * @return {NodeUniform} The node uniform object.
	 */ getUniformFromNode(node, type, shaderStage, name = null) {
        const uniformNode = super.getUniformFromNode(node, type, shaderStage, name);
        const nodeData = this.getDataFromNode(node, shaderStage, this.globalCache);
        if (nodeData.uniformGPU === undefined) {
            let uniformGPU;
            const group = node.groupNode;
            const groupName = group.name;
            const bindings = this.getBindGroupArray(groupName, shaderStage);
            if (type === 'texture' || type === 'cubeTexture' || type === 'cubeDepthTexture' || type === 'storageTexture' || type === 'texture3D') {
                let texture = null;
                const access = this.getNodeAccess(node, shaderStage);
                if (type === 'texture' || type === 'storageTexture') {
                    if (node.value.is3DTexture === true) texture = new $03ccd63b0299d6a7$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group, access);
                    else texture = new $03ccd63b0299d6a7$var$NodeSampledTexture(uniformNode.name, uniformNode.node, group, access);
                } else if (type === 'cubeTexture' || type === 'cubeDepthTexture') texture = new $03ccd63b0299d6a7$var$NodeSampledCubeTexture(uniformNode.name, uniformNode.node, group, access);
                else if (type === 'texture3D') texture = new $03ccd63b0299d6a7$var$NodeSampledTexture3D(uniformNode.name, uniformNode.node, group, access);
                texture.store = node.isStorageTextureNode === true;
                texture.mipLevel = texture.store ? node.mipLevel : 0;
                texture.setVisibility($03ccd63b0299d6a7$var$gpuShaderStageLib[shaderStage]);
                // Cube textures always need samplers (they use textureSampleLevel, not textureLoad)
                const needsSampler = node.value.isCubeTexture === true || this.isUnfilterable(node.value) === false && texture.store === false;
                if (needsSampler) {
                    const sampler = new $03ccd63b0299d6a7$var$NodeSampler(`${uniformNode.name}_sampler`, uniformNode.node, group);
                    sampler.setVisibility($03ccd63b0299d6a7$var$gpuShaderStageLib[shaderStage]);
                    bindings.push(sampler, texture);
                    uniformGPU = [
                        sampler,
                        texture
                    ];
                } else {
                    bindings.push(texture);
                    uniformGPU = [
                        texture
                    ];
                }
            } else if (type === 'buffer' || type === 'storageBuffer' || type === 'indirectStorageBuffer') {
                const sharedData = this.getSharedDataFromNode(node);
                let buffer = sharedData.buffer;
                if (buffer === undefined) {
                    const bufferClass = type === 'buffer' ? $03ccd63b0299d6a7$var$NodeUniformBuffer : $03ccd63b0299d6a7$var$NodeStorageBuffer;
                    buffer = new bufferClass(node, group);
                    sharedData.buffer = buffer;
                }
                buffer.setVisibility(buffer.getVisibility() | $03ccd63b0299d6a7$var$gpuShaderStageLib[shaderStage]);
                bindings.push(buffer);
                uniformGPU = buffer;
                uniformNode.name = name ? name : 'NodeBuffer_' + uniformNode.id;
            } else {
                let uniformsGroup = this.uniformGroups[groupName];
                if (uniformsGroup === undefined) {
                    uniformsGroup = new $03ccd63b0299d6a7$var$NodeUniformsGroup(groupName, group);
                    uniformsGroup.setVisibility($03ccd63b0299d6a7$var$GPUShaderStage.VERTEX | $03ccd63b0299d6a7$var$GPUShaderStage.FRAGMENT | $03ccd63b0299d6a7$var$GPUShaderStage.COMPUTE);
                    this.uniformGroups[groupName] = uniformsGroup;
                }
                // Add to bindings for this stage if not already present
                if (bindings.indexOf(uniformsGroup) === -1) bindings.push(uniformsGroup);
                uniformGPU = this.getNodeUniform(uniformNode, type);
                // Only add uniform if not already present in the group (check by name to avoid duplicates across stages)
                const uniformName = uniformGPU.name;
                const alreadyExists = uniformsGroup.uniforms.some((u)=>u.name === uniformName);
                if (!alreadyExists) uniformsGroup.addUniform(uniformGPU);
            }
            nodeData.uniformGPU = uniformGPU;
        }
        return uniformNode;
    }
    /**
	 * This method should be used whenever builtins are required in nodes.
	 * The internal builtins data structure will make sure builtins are
	 * defined in the WGSL source.
	 *
	 * @param {string} name - The builtin name.
	 * @param {string} property - The property name.
	 * @param {string} type - The node data type.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {string} The property name.
	 */ getBuiltin(name, property, type, shaderStage = this.shaderStage) {
        const map = this.builtins[shaderStage] || (this.builtins[shaderStage] = new Map());
        if (map.has(name) === false) map.set(name, {
            name: name,
            property: property,
            type: type
        });
        return property;
    }
    /**
	 * Returns `true` if the given builtin is defined in the given shader stage.
	 *
	 * @param {string} name - The builtin name.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage this code snippet is generated for.
	 * @return {boolean} Whether the given builtin is defined in the given shader stage or not.
	 */ hasBuiltin(name, shaderStage = this.shaderStage) {
        return this.builtins[shaderStage] !== undefined && this.builtins[shaderStage].has(name);
    }
    /**
	 * Returns the vertex index builtin.
	 *
	 * @return {string} The vertex index.
	 */ getVertexIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('vertex_index', 'vertexIndex', 'u32', 'attribute');
        return 'vertexIndex';
    }
    /**
	 * Builds the given shader node.
	 *
	 * @param {ShaderNodeInternal} shaderNode - The shader node.
	 * @return {string} The WGSL function code.
	 */ buildFunctionCode(shaderNode) {
        const layout = shaderNode.layout;
        const flowData = this.flowShaderNode(shaderNode);
        const parameters = [];
        for (const input of layout.inputs)parameters.push(input.name + ' : ' + this.getType(input.type));
        //
        let code = `fn ${layout.name}( ${parameters.join(', ')} ) -> ${this.getType(layout.type)} {
${flowData.vars}
${flowData.code}
`;
        if (flowData.result) code += `\treturn ${flowData.result};\n`;
        code += '\n}\n';
        //
        return code;
    }
    /**
	 * Contextually returns either the vertex stage instance index builtin
	 * or the linearized index of an compute invocation within a grid of workgroups.
	 *
	 * @return {string} The instance index.
	 */ getInstanceIndex() {
        if (this.shaderStage === 'vertex') return this.getBuiltin('instance_index', 'instanceIndex', 'u32', 'attribute');
        return 'instanceIndex';
    }
    /**
	 * Returns a builtin representing the index of a compute invocation within the scope of a workgroup load.
	 *
	 * @return {string} The invocation local index.
	 */ getInvocationLocalIndex() {
        return this.getBuiltin('local_invocation_index', 'invocationLocalIndex', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the size of a subgroup within the current shader.
	 *
	 * @return {string} The subgroup size.
	 */ getSubgroupSize() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the index of a compute invocation within the scope of a subgroup.
	 *
	 * @return {string} The invocation subgroup index.
	 */ getInvocationSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_invocation_id', 'invocationSubgroupIndex', 'u32', 'attribute');
    }
    /**
	 * Returns a builtin representing the index of a compute invocation's subgroup within its workgroup.
	 *
	 * @return {string} The subgroup index.
	 */ getSubgroupIndex() {
        this.enableSubGroups();
        return this.getBuiltin('subgroup_id', 'subgroupIndex', 'u32', 'attribute');
    }
    /**
	 * Overwritten as a NOP since this method is intended for the WebGL 2 backend.
	 *
	 * @return {null} Null.
	 */ getDrawIndex() {
        return null;
    }
    /**
	 * Returns the front facing builtin.
	 *
	 * @return {string} The front facing builtin.
	 */ getFrontFacing() {
        return this.getBuiltin('front_facing', 'isFront', 'bool');
    }
    /**
	 * Returns the frag coord builtin.
	 *
	 * @return {string} The frag coord builtin.
	 */ getFragCoord() {
        return this.getBuiltin('position', 'fragCoord', 'vec4<f32>') + '.xy';
    }
    /**
	 * Returns the frag depth builtin.
	 *
	 * @return {string} The frag depth builtin.
	 */ getFragDepth() {
        return 'output.' + this.getBuiltin('frag_depth', 'depth', 'f32', 'output');
    }
    /**
	 * Returns the clip distances builtin.
	 *
	 * @return {string} The clip distances builtin.
	 */ getClipDistance() {
        return 'varyings.hw_clip_distances';
    }
    /**
	 * Whether to flip texture data along its vertical axis or not.
	 *
	 * @return {boolean} Returns always `false` in context of WGSL.
	 */ isFlipY() {
        return false;
    }
    /**
	 * Enables the given directive for the given shader stage.
	 *
	 * @param {string} name - The directive name.
	 * @param {string} [shaderStage=this.shaderStage] - The shader stage to enable the directive for.
	 */ enableDirective(name, shaderStage = this.shaderStage) {
        const stage = this.directives[shaderStage] || (this.directives[shaderStage] = new Set());
        stage.add(name);
    }
    /**
	 * Returns the directives of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} A WGSL snippet that enables the directives of the given stage.
	 */ getDirectives(shaderStage) {
        const snippets = [];
        const directives = this.directives[shaderStage];
        if (directives !== undefined) for (const directive of directives)snippets.push(`enable ${directive};`);
        return snippets.join('\n');
    }
    /**
	 * Enables the 'subgroups' directive.
	 */ enableSubGroups() {
        this.enableDirective('subgroups');
    }
    /**
	 * Enables the 'subgroups-f16' directive.
	 */ enableSubgroupsF16() {
        this.enableDirective('subgroups-f16');
    }
    /**
	 * Enables the 'clip_distances' directive.
	 */ enableClipDistances() {
        this.enableDirective('clip_distances');
    }
    /**
	 * Enables the 'f16' directive.
	 */ enableShaderF16() {
        this.enableDirective('f16');
    }
    /**
	 * Enables the 'dual_source_blending' directive.
	 */ enableDualSourceBlending() {
        this.enableDirective('dual_source_blending');
    }
    /**
	 * Enables hardware clipping.
	 *
	 * @param {string} planeCount - The clipping plane count.
	 */ enableHardwareClipping(planeCount) {
        this.enableClipDistances();
        this.getBuiltin('clip_distances', 'hw_clip_distances', `array<f32, ${planeCount} >`, 'vertex');
    }
    /**
	 * Returns the builtins of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} A WGSL snippet that represents the builtins of the given stage.
	 */ getBuiltins(shaderStage) {
        const snippets = [];
        const builtins = this.builtins[shaderStage];
        if (builtins !== undefined) for (const { name: name, property: property, type: type } of builtins.values())snippets.push(`@builtin( ${name} ) ${property} : ${type}`);
        return snippets.join(',\n\t');
    }
    /**
	 * This method should be used when a new scoped buffer is used in context of
	 * compute shaders. It adds the array to the internal data structure which is
	 * later used to generate the respective WGSL.
	 *
	 * @param {string} name - The array name.
	 * @param {string} scope - The scope.
	 * @param {string} bufferType - The buffer type.
	 * @param {string} bufferCount - The buffer count.
	 * @return {string} The array name.
	 */ getScopedArray(name, scope, bufferType, bufferCount) {
        if (this.scopedArrays.has(name) === false) this.scopedArrays.set(name, {
            name: name,
            scope: scope,
            bufferType: bufferType,
            bufferCount: bufferCount
        });
        return name;
    }
    /**
	 * Returns the scoped arrays of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string|undefined} The WGSL snippet that defines the scoped arrays.
	 * Returns `undefined` when used in the vertex or fragment stage.
	 */ getScopedArrays(shaderStage) {
        if (shaderStage !== 'compute') return;
        const snippets = [];
        for (const { name: name, scope: scope, bufferType: bufferType, bufferCount: bufferCount } of this.scopedArrays.values()){
            const type = this.getType(bufferType);
            snippets.push(`var<${scope}> ${name}: array< ${type}, ${bufferCount} >;`);
        }
        return snippets.join('\n');
    }
    /**
	 * Returns the shader attributes of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the shader attributes.
	 */ getAttributes(shaderStage) {
        const snippets = [];
        if (shaderStage === 'compute') {
            this.getBuiltin('global_invocation_id', 'globalId', 'vec3<u32>', 'attribute');
            this.getBuiltin('workgroup_id', 'workgroupId', 'vec3<u32>', 'attribute');
            this.getBuiltin('local_invocation_id', 'localId', 'vec3<u32>', 'attribute');
            this.getBuiltin('num_workgroups', 'numWorkgroups', 'vec3<u32>', 'attribute');
            if (this.renderer.hasFeature('subgroups')) {
                this.enableDirective('subgroups', shaderStage);
                this.getBuiltin('subgroup_size', 'subgroupSize', 'u32', 'attribute');
            }
        }
        if (shaderStage === 'vertex' || shaderStage === 'compute') {
            const builtins = this.getBuiltins('attribute');
            if (builtins) snippets.push(builtins);
            const attributes = this.getAttributesArray();
            for(let index = 0, length = attributes.length; index < length; index++){
                const attribute = attributes[index];
                const name = attribute.name;
                const type = this.getType(attribute.type);
                snippets.push(`@location( ${index} ) ${name} : ${type}`);
            }
        }
        return snippets.join(',\n\t');
    }
    /**
	 * Returns the members of the given struct type node as a WGSL string.
	 *
	 * @param {StructTypeNode} struct - The struct type node.
	 * @return {string} The WGSL snippet that defines the struct members.
	 */ getStructMembers(struct) {
        const snippets = [];
        for (const member of struct.members){
            const prefix = struct.output ? '@location( ' + member.index + ' ) ' : '';
            let type = this.getType(member.type);
            if (member.atomic) type = 'atomic< ' + type + ' >';
            snippets.push(`\t${prefix + member.name} : ${type}`);
        }
        if (struct.output) snippets.push(`\t${this.getBuiltins('output')}`);
        return snippets.join(',\n');
    }
    /**
	 * Returns the structs of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the structs.
	 */ getStructs(shaderStage) {
        let result = '';
        const structs = this.structs[shaderStage];
        if (structs.length > 0) {
            const snippets = [];
            for (const struct of structs){
                let snippet = `struct ${struct.name} {\n`;
                snippet += this.getStructMembers(struct);
                snippet += '\n};';
                snippets.push(snippet);
            }
            result = '\n' + snippets.join('\n\n') + '\n';
        }
        return result;
    }
    /**
	 * Returns a WGSL string representing a variable.
	 *
	 * @param {string} type - The variable's type.
	 * @param {string} name - The variable's name.
	 * @param {?number} [count=null] - The array length.
	 * @param {string} [qualifier=''] - The variable's qualifier.
	 * @return {string} The WGSL snippet that defines a variable.
	 */ getVar(type, name, count = null, qualifier = '') {
        let snippet = `var${qualifier} ${name} : `;
        if (count !== null) snippet += this.generateArrayDeclaration(type, count);
        else snippet += this.getType(type);
        return snippet;
    }
    /**
	 * Returns the variables of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the variables.
	 */ getVars(shaderStage, global = false) {
        let qualifier = '';
        if (global) qualifier = '<private>';
        const snippets = [];
        const vars = this.vars[shaderStage];
        if (vars !== undefined) for (const variable of vars)snippets.push(`${this.getVar(variable.type, variable.name, variable.count, qualifier)};`);
        return global ? snippets.join('\n') : `\n\t${snippets.join('\n\t')}\n`;
    }
    /**
	 * Returns the varyings of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the varyings.
	 */ getVaryings(shaderStage) {
        const snippets = [];
        if (shaderStage === 'vertex') this.getBuiltin('position', 'builtinClipSpace', 'vec4<f32>', 'vertex');
        if (shaderStage === 'vertex' || shaderStage === 'fragment') {
            const varyings = this.varyings;
            const vars = this.vars[shaderStage];
            let varyingIndex = 0;
            for(let index = 0; index < varyings.length; index++){
                const varying = varyings[index];
                if (varying.needsInterpolation) {
                    let attributesSnippet = `@location( ${varyingIndex++} )`;
                    if (varying.interpolationType) {
                        const samplingSnippet = varying.interpolationSampling !== null ? `, ${varying.interpolationSampling} )` : ' )';
                        attributesSnippet += ` @interpolate( ${varying.interpolationType}${samplingSnippet}`;
                    // Otherwise, optimize interpolation when sensible
                    } else if (/^(int|uint|ivec|uvec)/.test(varying.type)) attributesSnippet += ' @interpolate(flat, either)';
                    snippets.push(`${attributesSnippet} ${varying.name} : ${this.getType(varying.type)}`);
                } else if (shaderStage === 'vertex' && vars.includes(varying) === false) vars.push(varying);
            }
        }
        const builtins = this.getBuiltins(shaderStage);
        if (builtins) snippets.push(builtins);
        const code = snippets.join(',\n\t');
        return shaderStage === 'vertex' ? this._getWGSLStruct('VaryingsStruct', '\t' + code) : code;
    }
    isCustomStruct(nodeUniform) {
        const attribute = nodeUniform.value;
        const bufferNode = nodeUniform.node;
        const isAttributeStructType = (attribute.isBufferAttribute || attribute.isInstancedBufferAttribute) && bufferNode.structTypeNode !== null;
        const isStructArray = bufferNode.value && bufferNode.value.array && typeof bufferNode.value.itemSize === 'number' && bufferNode.value.array.length > bufferNode.value.itemSize;
        return isAttributeStructType && !isStructArray;
    }
    /**
	 * Returns the uniforms of the given shader stage as a WGSL string.
	 *
	 * @param {string} shaderStage - The shader stage.
	 * @return {string} The WGSL snippet that defines the uniforms.
	 */ getUniforms(shaderStage) {
        const backend = this.renderer.backend;
        const uniforms = this.uniforms[shaderStage];
        const bindingSnippets = [];
        const bufferSnippets = [];
        const structSnippets = [];
        const uniformGroups = {};
        for (const uniform of uniforms){
            const groupName = uniform.groupNode.name;
            const uniformIndexes = this.bindingsIndexes[groupName];
            if (uniform.type === 'texture' || uniform.type === 'cubeTexture' || uniform.type === 'cubeDepthTexture' || uniform.type === 'storageTexture' || uniform.type === 'texture3D') {
                const texture = uniform.node.value;
                // Cube textures always need samplers (they use textureSampleLevel, not textureLoad)
                const needsSampler = texture.isCubeTexture === true || this.isUnfilterable(texture) === false && uniform.node.isStorageTextureNode !== true;
                if (needsSampler) {
                    if (this.isSampleCompare(texture)) bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler_comparison;`);
                    else bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name}_sampler : sampler;`);
                }
                let textureType;
                let multisampled = '';
                const { primarySamples: primarySamples } = backend.utils.getTextureSampleData(texture);
                if (primarySamples > 1) multisampled = '_multisampled';
                if (texture.isCubeTexture === true && texture.isDepthTexture === true) textureType = 'texture_depth_cube';
                else if (texture.isCubeTexture === true) textureType = 'texture_cube<f32>';
                else if (texture.isDepthTexture === true) {
                    if (backend.compatibilityMode && texture.compareFunction === null) textureType = `texture${multisampled}_2d<f32>`;
                    else textureType = `texture_depth${multisampled}_2d${texture.isArrayTexture === true ? '_array' : ''}`;
                } else if (uniform.node.isStorageTextureNode === true) {
                    const format = $03ccd63b0299d6a7$var$getFormat(texture, backend.device);
                    const access = this.getStorageAccess(uniform.node, shaderStage);
                    const is3D = uniform.node.value.is3DTexture;
                    const isArrayTexture = uniform.node.value.isArrayTexture;
                    const dimension = is3D ? '3d' : `2d${isArrayTexture ? '_array' : ''}`;
                    textureType = `texture_storage_${dimension}<${format}, ${access}>`;
                } else if (texture.isArrayTexture === true || texture.isDataArrayTexture === true || texture.isCompressedArrayTexture === true) textureType = 'texture_2d_array<f32>';
                else if (texture.is3DTexture === true || texture.isData3DTexture === true) textureType = 'texture_3d<f32>';
                else {
                    const componentPrefix = this.getComponentTypeFromTexture(texture).charAt(0);
                    textureType = `texture${multisampled}_2d<${componentPrefix}32>`;
                }
                bindingSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var ${uniform.name} : ${textureType};`);
            } else if (uniform.type === 'buffer' || uniform.type === 'storageBuffer' || uniform.type === 'indirectStorageBuffer') {
                const bufferNode = uniform.node;
                const bufferType = this.getType(bufferNode.getNodeType(this));
                const bufferCount = bufferNode.bufferCount;
                const bufferCountSnippet = bufferCount > 0 && uniform.type === 'buffer' ? ', ' + bufferCount : '';
                const bufferAccessMode = bufferNode.isStorageBufferNode ? `storage, ${this.getStorageAccess(bufferNode, shaderStage)}` : 'uniform';
                if (this.isCustomStruct(uniform)) bufferSnippets.push(`@binding( ${uniformIndexes.binding++} ) @group( ${uniformIndexes.group} ) var<${bufferAccessMode}> ${uniform.name} : ${bufferType};`);
                else {
                    const bufferTypeSnippet = bufferNode.isAtomic ? `atomic<${bufferType}>` : `${bufferType}`;
                    const bufferSnippet = `\tvalue : array< ${bufferTypeSnippet}${bufferCountSnippet} >`;
                    bufferSnippets.push(this._getWGSLStructBinding(uniform.name, bufferSnippet, bufferAccessMode, uniformIndexes.binding++, uniformIndexes.group));
                }
            } else {
                const groupName = uniform.groupNode.name;
                // Check if this group has already been processed in this shader stage
                if (uniformGroups[groupName] === undefined) {
                    // Get the shared uniform group that contains uniforms from all stages
                    const sharedUniformGroup = this.uniformGroups[groupName];
                    if (sharedUniformGroup !== undefined) {
                        // Generate snippets for ALL uniforms in this shared group
                        const snippets = [];
                        for (const sharedUniform of sharedUniformGroup.uniforms){
                            const type = sharedUniform.getType();
                            const vectorType = this.getType(this.getVectorType(type));
                            snippets.push(`\t${sharedUniform.name} : ${vectorType}`);
                        }
                        // Check if this group already has an assigned binding index (from another shader stage)
                        let groupBinding = this.uniformGroupsBindings[groupName];
                        if (groupBinding === undefined) {
                            // First time processing this group - assign a new binding index
                            groupBinding = {
                                index: uniformIndexes.binding++,
                                id: uniformIndexes.group
                            };
                            this.uniformGroupsBindings[groupName] = groupBinding;
                        }
                        uniformGroups[groupName] = {
                            index: groupBinding.index,
                            id: groupBinding.id,
                            snippets: snippets
                        };
                    }
                }
            }
        }
        for(const name in uniformGroups){
            const group = uniformGroups[name];
            structSnippets.push(this._getWGSLStructBinding(name, group.snippets.join(',\n'), 'uniform', group.index, group.id));
        }
        const code = [
            ...bindingSnippets,
            ...bufferSnippets,
            ...structSnippets
        ].join('\n');
        return code;
    }
    /**
	 * Controls the code build of the shader stages.
	 */ buildCode() {
        const shadersData = this.material !== null ? {
            fragment: {},
            vertex: {}
        } : {
            compute: {}
        };
        this.sortBindingGroups();
        for(const shaderStage in shadersData){
            this.shaderStage = shaderStage;
            const allowGlobal = this.allowGlobalVariables;
            const stageData = shadersData[shaderStage];
            stageData.uniforms = this.getUniforms(shaderStage);
            stageData.attributes = this.getAttributes(shaderStage);
            stageData.varyings = this.getVaryings(shaderStage);
            stageData.structs = this.getStructs(shaderStage);
            stageData.vars = this.getVars(shaderStage, allowGlobal);
            stageData.codes = this.getCodes(shaderStage);
            stageData.directives = this.getDirectives(shaderStage);
            stageData.scopedArrays = this.getScopedArrays(shaderStage);
            //
            let flow = '// code\n\n';
            flow += this.flowCode[shaderStage];
            const flowNodes = this.flowNodes[shaderStage];
            const mainNode = flowNodes[flowNodes.length - 1];
            const outputNode = mainNode.outputNode;
            const isOutputStruct = outputNode !== undefined && outputNode.isOutputStructNode === true;
            for (const node of flowNodes){
                const flowSlotData = this.getFlowData(node /*, shaderStage*/ );
                const slotName = node.name;
                if (slotName) {
                    if (flow.length > 0) flow += '\n';
                    flow += `\t// flow -> ${slotName}\n`;
                }
                flow += `${flowSlotData.code}\n\t`;
                if (node === mainNode && shaderStage !== 'compute') {
                    flow += '// result\n\n\t';
                    if (shaderStage === 'vertex') flow += `varyings.builtinClipSpace = ${flowSlotData.result};`;
                    else if (shaderStage === 'fragment') {
                        if (isOutputStruct) {
                            stageData.returnType = outputNode.getNodeType(this);
                            stageData.structs += 'var<private> output : ' + stageData.returnType + ';';
                            flow += `return ${flowSlotData.result};`;
                        } else {
                            let structSnippet = '\t@location( 0 ) color: vec4<f32>';
                            const builtins = this.getBuiltins('output');
                            if (builtins) structSnippet += ',\n\t' + builtins;
                            stageData.returnType = 'OutputStruct';
                            stageData.structs += this._getWGSLStruct('OutputStruct', structSnippet);
                            stageData.structs += '\nvar<private> output : OutputStruct;';
                            flow += `output.color = ${flowSlotData.result};\n\n\treturn output;`;
                        }
                    }
                }
            }
            stageData.flow = flow;
        }
        this.shaderStage = null;
        if (this.material !== null) {
            this.vertexShader = this._getWGSLVertexCode(shadersData.vertex);
            this.fragmentShader = this._getWGSLFragmentCode(shadersData.fragment);
        } else {
            // Early strictly validated in computeNode
            const workgroupSize = this.object.workgroupSize;
            this.computeShader = this._getWGSLComputeCode(shadersData.compute, workgroupSize);
        }
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @param {string} method - The method name to resolve.
	 * @param {?string} [output=null] - An optional output.
	 * @return {string} The resolved WGSL method name.
	 */ getMethod(method, output = null) {
        let wgslMethod;
        if (output !== null) wgslMethod = this._getWGSLMethod(method + '_' + output);
        if (wgslMethod === undefined) wgslMethod = this._getWGSLMethod(method);
        return wgslMethod || method;
    }
    /**
	 * Returns the bitcast method name for a given input and outputType.
	 *
	 * @param {string} type - The output type to bitcast to.
	 * @return {string} The resolved WGSL bitcast invocation.
	 */ getBitcastMethod(type) {
        const dataType = this.getType(type);
        return `bitcast<${dataType}>`;
    }
    /**
	 * Returns the float packing method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the float values are mapped to the integer range.
	 * @returns {string} The resolve WGSL float packing method name.
	 */ getFloatPackingMethod(encoding) {
        return this.getMethod(`floatpack_${encoding}_2x16`);
    }
    /**
	 * Returns the float unpacking method name for a given numeric encoding.
	 *
	 * @param {string} encoding - The numeric encoding that describes how the integer values are mapped to the float range.
	 * @returns {string} The resolve WGSL float unpacking method name.
	 */ getFloatUnpackingMethod(encoding) {
        return this.getMethod(`floatunpack_${encoding}_2x16`);
    }
    /**
	 * Returns the native snippet for a ternary operation.
	 *
	 * @param {string} condSnippet - The condition determining which expression gets resolved.
	 * @param {string} ifSnippet - The expression to resolve to if the condition is true.
	 * @param {string} elseSnippet - The expression to resolve to if the condition is false.
	 * @return {string} The resolved method name.
	 */ getTernary(condSnippet, ifSnippet, elseSnippet) {
        return `select( ${elseSnippet}, ${ifSnippet}, ${condSnippet} )`;
    }
    /**
	 * Returns the WGSL type of the given node data type.
	 *
	 * @param {string} type - The node data type.
	 * @return {string} The WGSL type.
	 */ getType(type) {
        return $03ccd63b0299d6a7$var$wgslTypeLib[type] || type;
    }
    /**
	 * Whether the requested feature is available or not.
	 *
	 * @param {string} name - The requested feature.
	 * @return {boolean} Whether the requested feature is supported or not.
	 */ isAvailable(name) {
        let result = $03ccd63b0299d6a7$var$supports[name];
        if (result === undefined) {
            if (name === 'float32Filterable') result = this.renderer.hasFeature('float32-filterable');
            else if (name === 'clipDistance') result = this.renderer.hasFeature('clip-distances');
            $03ccd63b0299d6a7$var$supports[name] = result;
        }
        return result;
    }
    /**
	 * Returns the native shader method name for a given generic name.
	 *
	 * @private
	 * @param {string} method - The method name to resolve.
	 * @return {string} The resolved WGSL method name.
	 */ _getWGSLMethod(method) {
        if ($03ccd63b0299d6a7$var$wgslPolyfill[method] !== undefined) this._include(method);
        return $03ccd63b0299d6a7$var$wgslMethods[method];
    }
    /**
	 * Includes the given method name into the current
	 * function node.
	 *
	 * @private
	 * @param {string} name - The method name to include.
	 * @return {CodeNode} The respective code node.
	 */ _include(name) {
        const codeNode = $03ccd63b0299d6a7$var$wgslPolyfill[name];
        codeNode.build(this);
        this.addInclude(codeNode);
        return codeNode;
    }
    /**
	 * Returns a WGSL vertex shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getWGSLVertexCode(shaderData) {
        return `${this.getSignature()}
// directives
${shaderData.directives}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// varyings
${shaderData.varyings}
var<private> varyings : VaryingsStruct;

// vars
${shaderData.vars}

// codes
${shaderData.codes}

@vertex
fn main( ${shaderData.attributes} ) -> VaryingsStruct {

	// flow
	${shaderData.flow}

	return varyings;

}
`;
    }
    /**
	 * Returns a WGSL fragment shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @return {string} The vertex shader.
	 */ _getWGSLFragmentCode(shaderData) {
        return `${this.getSignature()}
// global
${$03ccd63b0299d6a7$var$diagnostics}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// vars
${shaderData.vars}

// codes
${shaderData.codes}

@fragment
fn main( ${shaderData.varyings} ) -> ${shaderData.returnType} {

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Returns a WGSL compute shader based on the given shader data.
	 *
	 * @private
	 * @param {Object} shaderData - The shader data.
	 * @param {string} workgroupSize - The workgroup size.
	 * @return {string} The vertex shader.
	 */ _getWGSLComputeCode(shaderData, workgroupSize) {
        const [workgroupSizeX, workgroupSizeY, workgroupSizeZ] = workgroupSize;
        return `${this.getSignature()}
// directives
${shaderData.directives}

// system
var<private> instanceIndex : u32;

// locals
${shaderData.scopedArrays}

// structs
${shaderData.structs}

// uniforms
${shaderData.uniforms}

// vars
${this.allowGlobalVariables ? shaderData.vars : ''}

// codes
${shaderData.codes}

@compute @workgroup_size( ${workgroupSizeX}, ${workgroupSizeY}, ${workgroupSizeZ} )
fn main( ${shaderData.attributes} ) {

	// local vars
	${this.allowGlobalVariables ? '' : shaderData.vars}

	// system
	instanceIndex = globalId.x
		+ globalId.y * ( ${workgroupSizeX} * numWorkgroups.x )
		+ globalId.z * ( ${workgroupSizeX} * numWorkgroups.x ) * ( ${workgroupSizeY} * numWorkgroups.y );

	// flow
	${shaderData.flow}

}
`;
    }
    /**
	 * Returns a WGSL struct based on the given name and variables.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @return {string} The WGSL snippet representing a struct.
	 */ _getWGSLStruct(name, vars) {
        return `
struct ${name} {
${vars}
};`;
    }
    /**
	 * Returns a WGSL struct binding.
	 *
	 * @private
	 * @param {string} name - The struct name.
	 * @param {string} vars - The struct variables.
	 * @param {string} access - The access.
	 * @param {number} [binding=0] - The binding index.
	 * @param {number} [group=0] - The group index.
	 * @return {string} The WGSL snippet representing a struct binding.
	 */ _getWGSLStructBinding(name, vars, access, binding = 0, group = 0) {
        const structName = name + 'Struct';
        const structSnippet = this._getWGSLStruct(structName, vars);
        return `${structSnippet}
@binding( ${binding} ) @group( ${group} )
var<${access}> ${name} : ${structName};`;
    }
}
/**
 * A WebGPU backend utility module with common helpers.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
    }
    /**
	 * Returns the depth/stencil GPU format for the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The depth/stencil GPU texture format.
	 */ getCurrentDepthStencilFormat(renderContext) {
        let format;
        if (renderContext.depth) {
            if (renderContext.depthTexture !== null) format = this.getTextureFormatGPU(renderContext.depthTexture);
            else if (renderContext.stencil) {
                if (this.backend.renderer.reversedDepthBuffer === true) format = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32FloatStencil8;
                else format = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24PlusStencil8;
            } else if (this.backend.renderer.reversedDepthBuffer === true) format = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth32Float;
            else format = $03ccd63b0299d6a7$var$GPUTextureFormat.Depth24Plus;
        }
        return format;
    }
    /**
	 * Returns the GPU format for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {string} The GPU texture format.
	 */ getTextureFormatGPU(texture) {
        return this.backend.get(texture).format;
    }
    /**
	 * Returns an object that defines the multi-sampling state of the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Object} The multi-sampling state.
	 */ getTextureSampleData(texture) {
        let samples;
        if (texture.isFramebufferTexture) samples = 1;
        else if (texture.isDepthTexture && !texture.renderTarget) {
            const renderer = this.backend.renderer;
            const renderTarget = renderer.getRenderTarget();
            samples = renderTarget ? renderTarget.samples : renderer.currentSamples;
        } else if (texture.renderTarget) samples = texture.renderTarget.samples;
        samples = samples || 1;
        const isMSAA = samples > 1 && texture.renderTarget !== null && texture.isDepthTexture !== true && texture.isFramebufferTexture !== true;
        const primarySamples = isMSAA ? 1 : samples;
        return {
            samples: samples,
            primarySamples: primarySamples,
            isMSAA: isMSAA
        };
    }
    /**
	 * Returns the default color attachment's GPU format of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The GPU texture format of the default color attachment.
	 */ getCurrentColorFormat(renderContext) {
        let format;
        if (renderContext.textures !== null) format = this.getTextureFormatGPU(renderContext.textures[0]);
        else format = this.getPreferredCanvasFormat(); // default context format
        return format;
    }
    /**
	 * Returns the GPU formats of all color attachments of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {Array<string>} The GPU texture formats of all color attachments.
	 */ getCurrentColorFormats(renderContext) {
        if (renderContext.textures !== null) return renderContext.textures.map((t)=>this.getTextureFormatGPU(t));
        else return [
            this.getPreferredCanvasFormat()
        ]; // default context format
    }
    /**
	 * Returns the output color space of the current render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {string} The output color space.
	 */ getCurrentColorSpace(renderContext) {
        if (renderContext.textures !== null) return renderContext.textures[0].colorSpace;
        return this.backend.renderer.outputColorSpace;
    }
    /**
	 * Returns GPU primitive topology for the given object and material.
	 *
	 * @param {Object3D} object - The 3D object.
	 * @param {Material} material - The material.
	 * @return {string} The GPU primitive topology.
	 */ getPrimitiveTopology(object, material) {
        if (object.isPoints) return $03ccd63b0299d6a7$var$GPUPrimitiveTopology.PointList;
        else if (object.isLineSegments || object.isMesh && material.wireframe === true) return $03ccd63b0299d6a7$var$GPUPrimitiveTopology.LineList;
        else if (object.isLine) return $03ccd63b0299d6a7$var$GPUPrimitiveTopology.LineStrip;
        else if (object.isMesh) return $03ccd63b0299d6a7$var$GPUPrimitiveTopology.TriangleList;
    }
    /**
	 * Returns a modified sample count from the given sample count value.
	 *
	 * That is required since WebGPU only supports either 1 or 4.
	 *
	 * @param {number} sampleCount - The input sample count.
	 * @return {number} The (potentially updated) output sample count.
	 */ getSampleCount(sampleCount) {
        return sampleCount >= 4 ? 4 : 1;
    }
    /**
	 * Returns the sample count of the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {number} The sample count.
	 */ getSampleCountRenderContext(renderContext) {
        if (renderContext.textures !== null) return this.getSampleCount(renderContext.sampleCount);
        return this.getSampleCount(this.backend.renderer.currentSamples);
    }
    /**
	 * Returns the preferred canvas format.
	 *
	 * There is a separate method for this so it's possible to
	 * honor edge cases for specific devices.
	 *
	 * @return {string} The GPU texture format of the canvas.
	 */ getPreferredCanvasFormat() {
        const parameters = this.backend.parameters;
        const bufferType = parameters.outputType;
        if (bufferType === undefined) return navigator.gpu.getPreferredCanvasFormat();
        else if (bufferType === (0, $9ddd7e9b53f7a2d4$export$2e8ce08d3f6f5e10)) return $03ccd63b0299d6a7$var$GPUTextureFormat.BGRA8Unorm;
        else if (bufferType === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)) return $03ccd63b0299d6a7$var$GPUTextureFormat.RGBA16Float;
        else throw new Error('Unsupported output buffer type.');
    }
}
const $03ccd63b0299d6a7$var$typedArraysToVertexFormatPrefix = new Map([
    [
        Int8Array,
        [
            'sint8',
            'snorm8'
        ]
    ],
    [
        Uint8Array,
        [
            'uint8',
            'unorm8'
        ]
    ],
    [
        Int16Array,
        [
            'sint16',
            'snorm16'
        ]
    ],
    [
        Uint16Array,
        [
            'uint16',
            'unorm16'
        ]
    ],
    [
        Int32Array,
        [
            'sint32',
            'snorm32'
        ]
    ],
    [
        Uint32Array,
        [
            'uint32',
            'unorm32'
        ]
    ],
    [
        Float32Array,
        [
            'float32'
        ]
    ]
]);
if (typeof Float16Array !== 'undefined') $03ccd63b0299d6a7$var$typedArraysToVertexFormatPrefix.set(Float16Array, [
    'float16'
]);
const $03ccd63b0299d6a7$var$typedAttributeToVertexFormatPrefix = new Map([
    [
        (0, $9ddd7e9b53f7a2d4$export$dbd3698c64958d69),
        [
            'float16'
        ]
    ]
]);
const $03ccd63b0299d6a7$var$typeArraysToVertexFormatPrefixForItemSize1 = new Map([
    [
        Int32Array,
        'sint32'
    ],
    [
        Int16Array,
        'sint32'
    ],
    [
        Uint32Array,
        'uint32'
    ],
    [
        Uint16Array,
        'uint32'
    ],
    [
        Float32Array,
        'float32'
    ]
]);
/**
 * A WebGPU backend utility module for managing shader attributes.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUAttributeUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
    }
    /**
	 * Creates the GPU buffer for the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 * @param {GPUBufferUsage} usage - A flag that indicates how the buffer may be used after its creation.
	 */ createAttribute(attribute, usage) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const bufferData = backend.get(bufferAttribute);
        let buffer = bufferData.buffer;
        if (buffer === undefined) {
            const device = backend.device;
            let array = bufferAttribute.array;
            // patch for INT16 and UINT16
            if (attribute.normalized === false) {
                if (array.constructor === Int16Array || array.constructor === Int8Array) array = new Int32Array(array);
                else if (array.constructor === Uint16Array || array.constructor === Uint8Array) {
                    array = new Uint32Array(array);
                    if (usage & GPUBufferUsage.INDEX) {
                        for(let i = 0; i < array.length; i++)if (array[i] === 0xffff) array[i] = 0xffffffff; // use correct primitive restart index
                    }
                }
            }
            bufferAttribute.array = array;
            if ((bufferAttribute.isStorageBufferAttribute || bufferAttribute.isStorageInstancedBufferAttribute) && bufferAttribute.itemSize === 3) {
                array = new array.constructor(bufferAttribute.count * 4);
                for(let i = 0; i < bufferAttribute.count; i++)array.set(bufferAttribute.array.subarray(i * 3, i * 3 + 3), i * 4);
                // Update BufferAttribute
                bufferAttribute.itemSize = 4;
                bufferAttribute.array = array;
                bufferData._force3to4BytesAlignment = true;
            }
            // ensure 4 byte alignment
            const byteLength = array.byteLength;
            const size = byteLength + (4 - byteLength % 4) % 4;
            buffer = device.createBuffer({
                label: bufferAttribute.name,
                size: size,
                usage: usage,
                mappedAtCreation: true
            });
            new array.constructor(buffer.getMappedRange()).set(array);
            buffer.unmap();
            bufferData.buffer = buffer;
        }
    }
    /**
	 * Updates the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ updateAttribute(attribute) {
        const bufferAttribute = this._getBufferAttribute(attribute);
        const backend = this.backend;
        const device = backend.device;
        const bufferData = backend.get(bufferAttribute);
        const buffer = backend.get(bufferAttribute).buffer;
        let array = bufferAttribute.array;
        //  if storage buffer ensure 4 byte alignment
        if (bufferData._force3to4BytesAlignment === true) {
            array = new array.constructor(bufferAttribute.count * 4);
            for(let i = 0; i < bufferAttribute.count; i++)array.set(bufferAttribute.array.subarray(i * 3, i * 3 + 3), i * 4);
            bufferAttribute.array = array;
        }
        const updateRanges = bufferAttribute.updateRanges;
        if (updateRanges.length === 0) // Not using update ranges
        device.queue.writeBuffer(buffer, 0, array, 0);
        else {
            const isTyped = (0, $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c)(array);
            const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                let dataOffset, size;
                if (bufferData._force3to4BytesAlignment === true) {
                    const vertexStart = Math.floor(range.start / 3);
                    const vertexCount = Math.ceil(range.count / 3);
                    dataOffset = vertexStart * 4 * byteOffsetFactor;
                    size = vertexCount * 4 * byteOffsetFactor;
                } else {
                    dataOffset = range.start * byteOffsetFactor;
                    size = range.count * byteOffsetFactor;
                }
                const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                device.queue.writeBuffer(buffer, bufferOffset, array, dataOffset, size);
            }
            bufferAttribute.clearUpdateRanges();
        }
    }
    /**
	 * This method creates the vertex buffer layout data which are
	 * require when creating a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {Array<Object>} An array holding objects which describe the vertex buffer layout.
	 */ createShaderVertexBuffers(renderObject) {
        const attributes = renderObject.getAttributes();
        const vertexBuffers = new Map();
        for(let slot = 0; slot < attributes.length; slot++){
            const geometryAttribute = attributes[slot];
            const bytesPerElement = geometryAttribute.array.BYTES_PER_ELEMENT;
            const bufferAttribute = this._getBufferAttribute(geometryAttribute);
            let vertexBufferLayout = vertexBuffers.get(bufferAttribute);
            if (vertexBufferLayout === undefined) {
                let arrayStride, stepMode;
                if (geometryAttribute.isInterleavedBufferAttribute === true) {
                    arrayStride = geometryAttribute.data.stride * bytesPerElement;
                    stepMode = geometryAttribute.data.isInstancedInterleavedBuffer ? $03ccd63b0299d6a7$var$GPUInputStepMode.Instance : $03ccd63b0299d6a7$var$GPUInputStepMode.Vertex;
                } else {
                    arrayStride = geometryAttribute.itemSize * bytesPerElement;
                    stepMode = geometryAttribute.isInstancedBufferAttribute ? $03ccd63b0299d6a7$var$GPUInputStepMode.Instance : $03ccd63b0299d6a7$var$GPUInputStepMode.Vertex;
                }
                // patch for INT16 and UINT16
                if (geometryAttribute.normalized === false && (geometryAttribute.array.constructor === Int16Array || geometryAttribute.array.constructor === Uint16Array)) arrayStride = 4;
                vertexBufferLayout = {
                    arrayStride: arrayStride,
                    attributes: [],
                    stepMode: stepMode
                };
                vertexBuffers.set(bufferAttribute, vertexBufferLayout);
            }
            const format = this._getVertexFormat(geometryAttribute);
            const offset = geometryAttribute.isInterleavedBufferAttribute === true ? geometryAttribute.offset * bytesPerElement : 0;
            vertexBufferLayout.attributes.push({
                shaderLocation: slot,
                offset: offset,
                format: format
            });
        }
        return Array.from(vertexBuffers.values());
    }
    /**
	 * Destroys the GPU buffer of the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ destroyAttribute(attribute) {
        const backend = this.backend;
        const data = backend.get(this._getBufferAttribute(attribute));
        data.buffer.destroy();
        backend.delete(attribute);
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU. ReadbackBuffer can
	 * be used to retain and reuse handles to the intermediate buffers and prevent
	 * new allocation.
	 *
	 * @async
	 * @param {BufferAttribute} attribute - The storage buffer attribute to read frm.
	 * @param {number} count - The offset from which to start reading the
	 * @param {number} offset - The storage buffer attribute.
	 * @param {ReadbackBuffer|ArrayBuffer} target - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer|ReadbackBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute, target = null, offset = 0, count = -1) {
        const backend = this.backend;
        const device = backend.device;
        const data = backend.get(this._getBufferAttribute(attribute));
        const bufferGPU = data.buffer;
        const byteLength = count === -1 ? bufferGPU.size - offset : count;
        let readBufferGPU;
        if (target !== null && target.isReadbackBuffer) {
            const readbackInfo = backend.get(target);
            if (target._mapped === true) throw new Error('WebGPURenderer: ReadbackBuffer must be released before being used again.');
            target._mapped = true;
            // initialize the GPU-side read copy buffer if it is not present
            if (readbackInfo.readBufferGPU === undefined) {
                readBufferGPU = device.createBuffer({
                    label: `${target.name}_readback`,
                    size: target.maxByteLength,
                    usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
                });
                // release / dispose
                const releaseCallback = ()=>{
                    target.buffer = null;
                    target._mapped = false;
                    readBufferGPU.unmap();
                };
                const disposeCallback = ()=>{
                    target.buffer = null;
                    target._mapped = false;
                    readBufferGPU.destroy();
                    backend.delete(target);
                    target.removeEventListener('release', releaseCallback);
                    target.removeEventListener('dispose', disposeCallback);
                };
                target.addEventListener('release', releaseCallback);
                target.addEventListener('dispose', disposeCallback);
                // register
                readbackInfo.readBufferGPU = readBufferGPU;
            } else readBufferGPU = readbackInfo.readBufferGPU;
        } else // create a new temp buffer for array buffers otherwise
        readBufferGPU = device.createBuffer({
            label: `${attribute.name}_readback`,
            size: byteLength,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
        // copy the data
        const cmdEncoder = device.createCommandEncoder({
            label: `readback_encoder_${attribute.name}`
        });
        cmdEncoder.copyBufferToBuffer(bufferGPU, offset, readBufferGPU, 0, byteLength);
        const gpuCommands = cmdEncoder.finish();
        device.queue.submit([
            gpuCommands
        ]);
        // map the data to the CPU
        await readBufferGPU.mapAsync(GPUMapMode.READ, 0, byteLength);
        if (target === null) {
            // return a new array buffer and clean up the gpu handles
            const arrayBuffer = readBufferGPU.getMappedRange(0, byteLength);
            const result = arrayBuffer.slice();
            readBufferGPU.destroy();
            return result;
        } else if (target.isReadbackBuffer) {
            // assign the data to the read back handle
            target.buffer = readBufferGPU.getMappedRange(0, byteLength);
            return target;
        } else {
            // copy the data into the target array buffer
            const arrayBuffer = readBufferGPU.getMappedRange(0, byteLength);
            new Uint8Array(target).set(new Uint8Array(arrayBuffer));
            readBufferGPU.destroy();
            return target;
        }
    }
    /**
	 * Returns the vertex format of the given buffer attribute.
	 *
	 * @private
	 * @param {BufferAttribute} geometryAttribute - The buffer attribute.
	 * @return {string|undefined} The vertex format (e.g. 'float32x3').
	 */ _getVertexFormat(geometryAttribute) {
        const { itemSize: itemSize, normalized: normalized } = geometryAttribute;
        const ArrayType = geometryAttribute.array.constructor;
        const AttributeType = geometryAttribute.constructor;
        let format;
        if (itemSize === 1) format = $03ccd63b0299d6a7$var$typeArraysToVertexFormatPrefixForItemSize1.get(ArrayType);
        else {
            const prefixOptions = $03ccd63b0299d6a7$var$typedAttributeToVertexFormatPrefix.get(AttributeType) || $03ccd63b0299d6a7$var$typedArraysToVertexFormatPrefix.get(ArrayType);
            const prefix = prefixOptions[normalized ? 1 : 0];
            if (prefix) {
                const bytesPerUnit = ArrayType.BYTES_PER_ELEMENT * itemSize;
                const paddedBytesPerUnit = Math.floor((bytesPerUnit + 3) / 4) * 4;
                const paddedItemSize = paddedBytesPerUnit / ArrayType.BYTES_PER_ELEMENT;
                if (paddedItemSize % 1) throw new Error('THREE.WebGPUAttributeUtils: Bad vertex format item size.');
                format = `${prefix}x${paddedItemSize}`;
            }
        }
        if (!format) (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUAttributeUtils: Vertex format not supported yet.');
        return format;
    }
    /**
	 * Utility method for handling interleaved buffer attributes correctly.
	 * To process them, their `InterleavedBuffer` is returned.
	 *
	 * @private
	 * @param {BufferAttribute} attribute - The attribute.
	 * @return {BufferAttribute|InterleavedBuffer}
	 */ _getBufferAttribute(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return attribute;
    }
}
/**
 * Class representing a WebGPU bind group layout.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$BindGroupLayout {
    /**
	 * Constructs a new layout.
	 *
	 * @param {GPUBindGroupLayout} layoutGPU - A GPU Bind Group Layout.
	 */ constructor(layoutGPU){
        /**
		 * The current GPUBindGroupLayout.
		 *
		 * @type {GPUBindGroupLayout}
		 */ this.layoutGPU = layoutGPU;
        /**
		 * The number of bind groups that use this layout.
		 *
		 * @type {number}
		 */ this.usedTimes = 0;
    }
}
/**
 * A WebGPU backend utility module for managing bindings.
 *
 * When reading the documentation it's helpful to keep in mind that
 * all class definitions starting with 'GPU*' are modules from the
 * WebGPU API. So for example `BindGroup` is a class from the engine
 * whereas `GPUBindGroup` is a class from WebGPU.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUBindingUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A cache that maps combinations of layout entries to existing bind group layouts.
		 *
		 * @private
		 * @type {Map<string, BindGroupLayout>}
		 */ this._bindGroupLayoutCache = new Map();
    }
    /**
	 * Creates a GPU bind group layout for the given bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @return {GPUBindGroupLayout} The GPU bind group layout.
	 */ createBindingsLayout(bindGroup) {
        const backend = this.backend;
        const device = backend.device;
        const bindingsData = backend.get(bindGroup);
        // check if the the bind group already has a layout
        if (bindingsData.layout) return bindingsData.layout.layoutGPU;
        // if not, assing one
        const entries = this._createLayoutEntries(bindGroup);
        const bindGroupLayoutKey = $03ccd63b0299d6a7$var$hashString(JSON.stringify(entries));
        // try to find an existing layout in the cache
        let bindGroupLayout = this._bindGroupLayoutCache.get(bindGroupLayoutKey);
        // if not create a new one
        if (bindGroupLayout === undefined) {
            bindGroupLayout = new $03ccd63b0299d6a7$var$BindGroupLayout(device.createBindGroupLayout({
                entries: entries
            }));
            this._bindGroupLayoutCache.set(bindGroupLayoutKey, bindGroupLayout);
        }
        bindGroupLayout.usedTimes++;
        bindingsData.layout = bindGroupLayout;
        bindingsData.layoutKey = bindGroupLayoutKey;
        return bindGroupLayout.layoutGPU;
    }
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings, cacheIndex, version = 0) {
        const { backend: backend } = this;
        const bindingsData = backend.get(bindGroup);
        // setup (static) binding layout and (dynamic) binding group
        const bindLayoutGPU = this.createBindingsLayout(bindGroup);
        let bindGroupGPU;
        if (cacheIndex > 0) {
            if (bindingsData.groups === undefined) {
                bindingsData.groups = [];
                bindingsData.versions = [];
            }
            if (bindingsData.versions[cacheIndex] === version) bindGroupGPU = bindingsData.groups[cacheIndex];
        }
        if (bindGroupGPU === undefined) {
            bindGroupGPU = this.createBindGroup(bindGroup, bindLayoutGPU);
            if (cacheIndex > 0) {
                bindingsData.groups[cacheIndex] = bindGroupGPU;
                bindingsData.versions[cacheIndex] = version;
            }
        }
        bindingsData.group = bindGroupGPU;
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        const backend = this.backend;
        const device = backend.device;
        const array = binding.buffer; // cpu
        const buffer = backend.get(binding).buffer; // gpu
        const updateRanges = binding.updateRanges;
        if (updateRanges.length === 0) device.queue.writeBuffer(buffer, 0, array, 0);
        else {
            const isTyped = (0, $9ddd7e9b53f7a2d4$export$b119cc7e1840e59c)(array);
            const byteOffsetFactor = isTyped ? 1 : array.BYTES_PER_ELEMENT;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const dataOffset = range.start * byteOffsetFactor;
                const size = range.count * byteOffsetFactor;
                const bufferOffset = dataOffset * (isTyped ? array.BYTES_PER_ELEMENT : 1); // bufferOffset is always in bytes
                device.queue.writeBuffer(buffer, bufferOffset, array, dataOffset, size);
            }
        }
    }
    /**
	 * Creates a GPU bind group for the camera index.
	 *
	 * @param {Uint32Array} data - The index data.
	 * @param {GPUBindGroupLayout} layoutGPU - The GPU bind group layout.
	 * @return {GPUBindGroup} The GPU bind group.
	 */ createBindGroupIndex(data, layoutGPU) {
        const backend = this.backend;
        const device = backend.device;
        const usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
        const index = data[0];
        const buffer = device.createBuffer({
            label: 'bindingCameraIndex_' + index,
            size: 16,
            usage: usage
        });
        device.queue.writeBuffer(buffer, 0, data, 0);
        const entries = [
            {
                binding: 0,
                resource: {
                    buffer: buffer
                }
            }
        ];
        return device.createBindGroup({
            label: 'bindGroupCameraIndex_' + index,
            layout: layoutGPU,
            entries: entries
        });
    }
    /**
	 * Creates a GPU bind group for the given bind group and GPU layout.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {GPUBindGroupLayout} layoutGPU - The GPU bind group layout.
	 * @return {GPUBindGroup} The GPU bind group.
	 */ createBindGroup(bindGroup, layoutGPU) {
        const backend = this.backend;
        const device = backend.device;
        let bindingPoint = 0;
        const entriesGPU = [];
        for (const binding of bindGroup.bindings){
            if (binding.isUniformBuffer) {
                const bindingData = backend.get(binding);
                if (bindingData.buffer === undefined) {
                    const byteLength = binding.byteLength;
                    const usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
                    const visibilities = [];
                    if (binding.visibility & $03ccd63b0299d6a7$var$GPUShaderStage.VERTEX) visibilities.push('vertex');
                    if (binding.visibility & $03ccd63b0299d6a7$var$GPUShaderStage.FRAGMENT) visibilities.push('fragment');
                    if (binding.visibility & $03ccd63b0299d6a7$var$GPUShaderStage.COMPUTE) visibilities.push('compute');
                    const bufferVisibility = `(${visibilities.join(',')})`;
                    const bufferGPU = device.createBuffer({
                        label: `bindingBuffer${binding.id}_${binding.name}_${bufferVisibility}`,
                        size: byteLength,
                        usage: usage
                    });
                    bindingData.buffer = bufferGPU;
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: bindingData.buffer
                    }
                });
            } else if (binding.isStorageBuffer) {
                const buffer = backend.get(binding.attribute).buffer;
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: {
                        buffer: buffer
                    }
                });
            } else if (binding.isSampledTexture) {
                const textureData = backend.get(binding.texture);
                let resourceGPU;
                if (textureData.externalTexture !== undefined) resourceGPU = device.importExternalTexture({
                    source: textureData.externalTexture
                });
                else {
                    const mipLevelCount = binding.store ? 1 : textureData.texture.mipLevelCount;
                    const baseMipLevel = binding.store ? binding.mipLevel : 0;
                    let propertyName = `view-${textureData.texture.width}-${textureData.texture.height}`;
                    if (textureData.texture.depthOrArrayLayers > 1) propertyName += `-${textureData.texture.depthOrArrayLayers}`;
                    propertyName += `-${mipLevelCount}-${baseMipLevel}`;
                    resourceGPU = textureData[propertyName];
                    if (resourceGPU === undefined) {
                        const aspectGPU = $03ccd63b0299d6a7$var$GPUTextureAspect.All;
                        let dimensionViewGPU;
                        if (binding.isSampledCubeTexture) dimensionViewGPU = $03ccd63b0299d6a7$var$GPUTextureViewDimension.Cube;
                        else if (binding.isSampledTexture3D) dimensionViewGPU = $03ccd63b0299d6a7$var$GPUTextureViewDimension.ThreeD;
                        else if (binding.texture.isArrayTexture || binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) dimensionViewGPU = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoDArray;
                        else dimensionViewGPU = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoD;
                        resourceGPU = textureData[propertyName] = textureData.texture.createView({
                            aspect: aspectGPU,
                            dimension: dimensionViewGPU,
                            mipLevelCount: mipLevelCount,
                            baseMipLevel: baseMipLevel
                        });
                    }
                }
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: resourceGPU
                });
            } else if (binding.isSampler) {
                const textureGPU = backend.get(binding.texture);
                entriesGPU.push({
                    binding: bindingPoint,
                    resource: textureGPU.sampler
                });
            }
            bindingPoint++;
        }
        return device.createBindGroup({
            label: 'bindGroup_' + bindGroup.name,
            layout: layoutGPU,
            entries: entriesGPU
        });
    }
    /**
	 * Creates a GPU bind group layout entries for the given bind group.
	 *
	 * @private
	 * @param {BindGroup} bindGroup - The bind group.
	 * @return {Array<GPUBindGroupLayoutEntry>} The GPU bind group layout entries.
	 */ _createLayoutEntries(bindGroup) {
        const entries = [];
        let index = 0;
        for (const binding of bindGroup.bindings){
            const backend = this.backend;
            const bindingGPU = {
                binding: index,
                visibility: binding.visibility
            };
            if (binding.isUniformBuffer || binding.isStorageBuffer) {
                const buffer = {}; // GPUBufferBindingLayout
                if (binding.isStorageBuffer) {
                    if (binding.visibility & $03ccd63b0299d6a7$var$GPUShaderStage.COMPUTE) {
                        // compute
                        if (binding.access === $03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE || binding.access === $03ccd63b0299d6a7$export$92538c74c63a703d.WRITE_ONLY) buffer.type = $03ccd63b0299d6a7$var$GPUBufferBindingType.Storage;
                        else buffer.type = $03ccd63b0299d6a7$var$GPUBufferBindingType.ReadOnlyStorage;
                    } else buffer.type = $03ccd63b0299d6a7$var$GPUBufferBindingType.ReadOnlyStorage;
                }
                bindingGPU.buffer = buffer;
            } else if (binding.isSampledTexture && binding.store) {
                const storageTexture = {}; // GPUStorageTextureBindingLayout
                storageTexture.format = this.backend.get(binding.texture).texture.format;
                const access = binding.access;
                if (access === $03ccd63b0299d6a7$export$92538c74c63a703d.READ_WRITE) storageTexture.access = $03ccd63b0299d6a7$var$GPUStorageTextureAccess.ReadWrite;
                else if (access === $03ccd63b0299d6a7$export$92538c74c63a703d.WRITE_ONLY) storageTexture.access = $03ccd63b0299d6a7$var$GPUStorageTextureAccess.WriteOnly;
                else storageTexture.access = $03ccd63b0299d6a7$var$GPUStorageTextureAccess.ReadOnly;
                if (binding.texture.isArrayTexture) storageTexture.viewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoDArray;
                else if (binding.texture.is3DTexture) storageTexture.viewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.ThreeD;
                bindingGPU.storageTexture = storageTexture;
            } else if (binding.isSampledTexture) {
                const texture = {}; // GPUTextureBindingLayout
                const { primarySamples: primarySamples } = backend.utils.getTextureSampleData(binding.texture);
                if (primarySamples > 1) {
                    texture.multisampled = true;
                    if (!binding.texture.isDepthTexture) texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.UnfilterableFloat;
                }
                if (binding.texture.isDepthTexture) {
                    if (backend.compatibilityMode && binding.texture.compareFunction === null) texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.UnfilterableFloat;
                    else texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.Depth;
                } else if (binding.texture.isDataTexture || binding.texture.isDataArrayTexture || binding.texture.isData3DTexture || binding.texture.isStorageTexture) {
                    const type = binding.texture.type;
                    if (type === (0, $9ddd7e9b53f7a2d4$export$5c612977753abe2)) texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.SInt;
                    else if (type === (0, $9ddd7e9b53f7a2d4$export$c3c7fc4518ebba96)) texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.UInt;
                    else if (type === (0, $9ddd7e9b53f7a2d4$export$f6d331659b644596)) {
                        if (this.backend.hasFeature('float32-filterable')) texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.Float;
                        else texture.sampleType = $03ccd63b0299d6a7$var$GPUTextureSampleType.UnfilterableFloat;
                    }
                }
                if (binding.isSampledCubeTexture) texture.viewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.Cube;
                else if (binding.texture.isArrayTexture || binding.texture.isDataArrayTexture || binding.texture.isCompressedArrayTexture) texture.viewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoDArray;
                else if (binding.isSampledTexture3D) texture.viewDimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.ThreeD;
                bindingGPU.texture = texture;
            } else if (binding.isSampler) {
                const sampler = {}; // GPUSamplerBindingLayout
                if (binding.texture.isDepthTexture) {
                    if (binding.texture.compareFunction !== null && backend.hasCompatibility((0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE)) sampler.type = $03ccd63b0299d6a7$var$GPUSamplerBindingType.Comparison;
                    else // Depth textures without compare must use non-filtering sampler
                    sampler.type = $03ccd63b0299d6a7$var$GPUSamplerBindingType.NonFiltering;
                }
                bindingGPU.sampler = sampler;
            } else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPUBindingUtils: Unsupported binding "${binding}".`);
            entries.push(bindingGPU);
            index++;
        }
        return entries;
    }
    /**
	 * Delete the data associated with a bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData(bindGroup) {
        const { backend: backend } = this;
        const bindingsData = backend.get(bindGroup);
        if (bindingsData.layout) {
            bindingsData.layout.usedTimes--;
            if (bindingsData.layout.usedTimes === 0) this._bindGroupLayoutCache.delete(bindingsData.layoutKey);
            bindingsData.layout = undefined;
            bindingsData.layoutKey = undefined;
        }
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this._bindGroupLayoutCache.clear();
    }
}
/**
 * A WebGPU backend utility module for managing the device's capabilities.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUCapabilities {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
    }
    /**
	 * Returns the maximum anisotropy texture filtering value.
	 *
	 * @return {number} The maximum anisotropy texture filtering value.
	 */ getMaxAnisotropy() {
        return 16;
    }
    /**
	 * Returns the maximum number of bytes available for uniform buffers.
	 *
	 * @return {number} The maximum number of bytes available for uniform buffers.
	 */ getUniformBufferLimit() {
        return this.backend.device.limits.maxUniformBufferBindingSize;
    }
}
/**
 * A WebGPU backend utility module for managing pipelines.
 *
 * @private
 */ class $03ccd63b0299d6a7$var$WebGPUPipelineUtils {
    /**
	 * Constructs a new utility object.
	 *
	 * @param {WebGPUBackend} backend - The WebGPU backend.
	 */ constructor(backend){
        /**
		 * A reference to the WebGPU backend.
		 *
		 * @type {WebGPUBackend}
		 */ this.backend = backend;
        /**
		 * A Weak Map that tracks the active pipeline for render or compute passes.
		 *
		 * @private
		 * @type {WeakMap<(GPURenderPassEncoder|GPUComputePassEncoder),(GPURenderPipeline|GPUComputePipeline)>}
		 */ this._activePipelines = new WeakMap();
    }
    /**
	 * Sets the given pipeline for the given pass. The method makes sure to only set the
	 * pipeline when necessary.
	 *
	 * @param {(GPURenderPassEncoder|GPUComputePassEncoder)} pass - The pass encoder.
	 * @param {(GPURenderPipeline|GPUComputePipeline)} pipeline - The pipeline.
	 */ setPipeline(pass, pipeline) {
        const currentPipeline = this._activePipelines.get(pass);
        if (currentPipeline !== pipeline) {
            pass.setPipeline(pipeline);
            this._activePipelines.set(pass, pipeline);
        }
    }
    /**
	 * Returns the sample count derived from the given render context.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 * @return {number} The sample count.
	 */ _getSampleCount(renderContext) {
        return this.backend.utils.getSampleCountRenderContext(renderContext);
    }
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        const { object: object, material: material, geometry: geometry, pipeline: pipeline } = renderObject;
        const { vertexProgram: vertexProgram, fragmentProgram: fragmentProgram } = pipeline;
        const backend = this.backend;
        const device = backend.device;
        const utils = backend.utils;
        const pipelineData = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindGroup of renderObject.getBindings()){
            const bindingsData = backend.get(bindGroup);
            const { layoutGPU: layoutGPU } = bindingsData.layout;
            bindGroupLayouts.push(layoutGPU);
        }
        // vertex buffers
        const vertexBuffers = backend.attributeUtils.createShaderVertexBuffers(renderObject);
        // material blending
        let materialBlending;
        if (material.blending !== (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba) && (material.blending !== (0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0) || material.transparent !== false)) materialBlending = this._getBlending(material);
        // stencil
        let stencilFront = {};
        if (material.stencilWrite === true) stencilFront = {
            compare: this._getStencilCompare(material),
            failOp: this._getStencilOperation(material.stencilFail),
            depthFailOp: this._getStencilOperation(material.stencilZFail),
            passOp: this._getStencilOperation(material.stencilZPass)
        };
        const colorWriteMask = this._getColorWriteMask(material);
        const targets = [];
        if (renderObject.context.textures !== null) {
            const textures = renderObject.context.textures;
            const mrt = renderObject.context.mrt;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const colorFormat = utils.getTextureFormatGPU(texture);
                // mrt blending
                let blending;
                if (mrt !== null) {
                    if (this.backend.compatibilityMode !== true) {
                        const blendMode = mrt.getBlendMode(texture.name);
                        if (blendMode.blending === (0, $9ddd7e9b53f7a2d4$export$ec822fcd0c1d2914)) blending = materialBlending;
                        else if (blendMode.blending !== (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba)) blending = this._getBlending(blendMode);
                    } else {
                        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('WebGPURenderer: Multiple Render Targets (MRT) blending configuration is not fully supported in compatibility mode. The material blending will be used for all render targets.');
                        blending = materialBlending;
                    }
                } else blending = materialBlending;
                targets.push({
                    format: colorFormat,
                    blend: blending,
                    writeMask: colorWriteMask
                });
            }
        } else {
            const colorFormat = utils.getCurrentColorFormat(renderObject.context);
            targets.push({
                format: colorFormat,
                blend: materialBlending,
                writeMask: colorWriteMask
            });
        }
        const vertexModule = backend.get(vertexProgram).module;
        const fragmentModule = backend.get(fragmentProgram).module;
        const primitiveState = this._getPrimitiveState(object, geometry, material);
        const depthCompare = this._getDepthCompare(material);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const sampleCount = this._getSampleCount(renderObject.context);
        const pipelineDescriptor = {
            label: `renderPipeline_${material.name || material.type}_${material.id}`,
            vertex: Object.assign({}, vertexModule, {
                buffers: vertexBuffers
            }),
            fragment: Object.assign({}, fragmentModule, {
                targets: targets
            }),
            primitive: primitiveState,
            multisample: {
                count: sampleCount,
                alphaToCoverageEnabled: material.alphaToCoverage && sampleCount > 1
            },
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        };
        const depthStencil = {};
        const renderDepth = renderObject.context.depth;
        const renderStencil = renderObject.context.stencil;
        if (renderDepth === true || renderStencil === true) {
            if (renderDepth === true) {
                depthStencil.format = depthStencilFormat;
                depthStencil.depthWriteEnabled = material.depthWrite;
                depthStencil.depthCompare = depthCompare;
            }
            if (renderStencil === true) {
                depthStencil.stencilFront = stencilFront;
                depthStencil.stencilBack = stencilFront; // apply the same stencil ops to both faces, matching gl.stencilOp() which is not face-separated
                depthStencil.stencilReadMask = material.stencilFuncMask;
                depthStencil.stencilWriteMask = material.stencilWriteMask;
            }
            if (material.polygonOffset === true) {
                depthStencil.depthBias = material.polygonOffsetUnits;
                depthStencil.depthBiasSlopeScale = material.polygonOffsetFactor;
                depthStencil.depthBiasClamp = 0; // three.js does not provide an API to configure this value
            }
            pipelineDescriptor.depthStencil = depthStencil;
        }
        // create pipeline
        device.pushErrorScope('validation');
        if (promises === null) {
            pipelineData.pipeline = device.createRenderPipeline(pipelineDescriptor);
            device.popErrorScope().then((err)=>{
                if (err !== null) {
                    pipelineData.error = true;
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(err.message);
                }
            });
        } else {
            const p = new Promise(async (resolve /*, reject*/ )=>{
                try {
                    pipelineData.pipeline = await device.createRenderPipelineAsync(pipelineDescriptor);
                } catch (err) {}
                const errorScope = await device.popErrorScope();
                if (errorScope !== null) {
                    pipelineData.error = true;
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(errorScope.message);
                }
                resolve();
            });
            promises.push(p);
        }
    }
    /**
	 * Creates GPU render bundle encoder for the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {?string} [label='renderBundleEncoder'] - The label.
	 * @return {GPURenderBundleEncoder} The GPU render bundle encoder.
	 */ createBundleEncoder(renderContext, label = 'renderBundleEncoder') {
        const backend = this.backend;
        const { utils: utils, device: device } = backend;
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderContext);
        const colorFormats = utils.getCurrentColorFormats(renderContext);
        const sampleCount = this._getSampleCount(renderContext);
        const descriptor = {
            label: label,
            colorFormats: colorFormats,
            depthStencilFormat: depthStencilFormat,
            sampleCount: sampleCount
        };
        return device.createRenderBundleEncoder(descriptor);
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(pipeline, bindings) {
        const backend = this.backend;
        const device = backend.device;
        const computeProgram = backend.get(pipeline.computeProgram).module;
        const pipelineGPU = backend.get(pipeline);
        // bind group layouts
        const bindGroupLayouts = [];
        for (const bindingsGroup of bindings){
            const bindingsData = backend.get(bindingsGroup);
            const { layoutGPU: layoutGPU } = bindingsData.layout;
            bindGroupLayouts.push(layoutGPU);
        }
        pipelineGPU.pipeline = device.createComputePipeline({
            compute: computeProgram,
            layout: device.createPipelineLayout({
                bindGroupLayouts: bindGroupLayouts
            })
        });
    }
    /**
	 * Returns the blending state as a descriptor object required
	 * for the pipeline creation.
	 *
	 * @private
	 * @param {Material|BlendMode} object - The object containing blending information.
	 * @return {Object} The blending state.
	 */ _getBlending(object) {
        let color, alpha;
        const blending = object.blending;
        const blendSrc = object.blendSrc;
        const blendDst = object.blendDst;
        const blendEquation = object.blendEquation;
        if (blending === (0, $9ddd7e9b53f7a2d4$export$eda4864c68df1fa2)) {
            const blendSrcAlpha = object.blendSrcAlpha !== null ? object.blendSrcAlpha : blendSrc;
            const blendDstAlpha = object.blendDstAlpha !== null ? object.blendDstAlpha : blendDst;
            const blendEquationAlpha = object.blendEquationAlpha !== null ? object.blendEquationAlpha : blendEquation;
            color = {
                srcFactor: this._getBlendFactor(blendSrc),
                dstFactor: this._getBlendFactor(blendDst),
                operation: this._getBlendOperation(blendEquation)
            };
            alpha = {
                srcFactor: this._getBlendFactor(blendSrcAlpha),
                dstFactor: this._getBlendFactor(blendDstAlpha),
                operation: this._getBlendOperation(blendEquationAlpha)
            };
        } else {
            const premultipliedAlpha = object.premultipliedAlpha;
            const setBlend = (srcRGB, dstRGB, srcAlpha, dstAlpha)=>{
                color = {
                    srcFactor: srcRGB,
                    dstFactor: dstRGB,
                    operation: $03ccd63b0299d6a7$var$GPUBlendOperation.Add
                };
                alpha = {
                    srcFactor: srcAlpha,
                    dstFactor: dstAlpha,
                    operation: $03ccd63b0299d6a7$var$GPUBlendOperation.Add
                };
            };
            if (premultipliedAlpha) switch(blending){
                case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.One);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.Zero, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrc, $03ccd63b0299d6a7$var$GPUBlendFactor.Zero, $03ccd63b0299d6a7$var$GPUBlendFactor.One);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.Dst, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha, $03ccd63b0299d6a7$var$GPUBlendFactor.Zero, $03ccd63b0299d6a7$var$GPUBlendFactor.One);
                    break;
            }
            else switch(blending){
                case 0, $9ddd7e9b53f7a2d4$export$5b29a26d96ee6af0:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.SrcAlpha, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$777d8f9551c2216b:
                    setBlend($03ccd63b0299d6a7$var$GPUBlendFactor.SrcAlpha, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.One, $03ccd63b0299d6a7$var$GPUBlendFactor.One);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$cdfa06f868e2e467:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: "SubtractiveBlending" requires "${object.isMaterial ? 'material' : 'blendMode'}.premultipliedAlpha = true".`);
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$4138e1c684b46a20:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(`WebGPURenderer: "MultiplyBlending" requires "${object.isMaterial ? 'material' : 'blendMode'}.premultipliedAlpha = true".`);
                    break;
            }
        }
        if (color !== undefined && alpha !== undefined) return {
            color: color,
            alpha: alpha
        };
        else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Invalid blending: ', blending);
    }
    /**
	 * Returns the GPU blend factor which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} blend - The blend factor as a three.js constant.
	 * @return {string} The GPU blend factor.
	 */ _getBlendFactor(blend) {
        let blendFactor;
        switch(blend){
            case 0, $9ddd7e9b53f7a2d4$export$2110f05edf778d3d:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.Zero;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$8805bad65e24940e:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.One;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$7fbe15b28d28cf52:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.Src;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$947829af9f2c17f6:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrc;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$d5773124e86cf28c:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.SrcAlpha;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$11d468cc7f19e971:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusSrcAlpha;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$ef5f2dd8ffac5574:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.Dst;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$56b85b2686ab16:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusDst;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$a78aed1ca2a87192:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.DstAlpha;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$5d0fe17fd8773bac:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusDstAlpha;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$c05e2a1fc8609506:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.SrcAlphaSaturated;
                break;
            case $03ccd63b0299d6a7$var$BlendColorFactor:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.Constant;
                break;
            case $03ccd63b0299d6a7$var$OneMinusBlendColorFactor:
                blendFactor = $03ccd63b0299d6a7$var$GPUBlendFactor.OneMinusConstant;
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Blend factor not supported.', blend);
        }
        return blendFactor;
    }
    /**
	 * Returns the GPU stencil compare function which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {string} The GPU stencil compare function.
	 */ _getStencilCompare(material) {
        let stencilCompare;
        const stencilFunc = material.stencilFunc;
        switch(stencilFunc){
            case 0, $9ddd7e9b53f7a2d4$export$1343870698229224:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Never;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$14cf96713ddd97a8:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Always;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$8e1d8ed281997fa6:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Less;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$2dff107857e6aca2:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.LessEqual;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$55648a1cde8329a7:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Equal;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$4119cf7b4c98fd5a:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.GreaterEqual;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$6f93765ab2f451a2:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Greater;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$6f3fb2d2440f2b76:
                stencilCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.NotEqual;
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Invalid stencil function.', stencilFunc);
        }
        return stencilCompare;
    }
    /**
	 * Returns the GPU stencil operation which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} op - A three.js constant defining the stencil operation.
	 * @return {string} The GPU stencil operation.
	 */ _getStencilOperation(op) {
        let stencilOperation;
        switch(op){
            case 0, $9ddd7e9b53f7a2d4$export$9f542ae4b5baca34:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.Keep;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$69433f11f42d5527:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.Zero;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$8a4f28336ef203d3:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.Replace;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$22e2e5726612443:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.Invert;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$2928c0231297c036:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.IncrementClamp;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$c0e9611c8a15f9a8:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.DecrementClamp;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$9c2c08927385dcc4:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.IncrementWrap;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$7c74ea00fa1315e6:
                stencilOperation = $03ccd63b0299d6a7$var$GPUStencilOperation.DecrementWrap;
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPURenderer: Invalid stencil operation.', stencilOperation);
        }
        return stencilOperation;
    }
    /**
	 * Returns the GPU blend operation which is required for the pipeline creation.
	 *
	 * @private
	 * @param {number} blendEquation - A three.js constant defining the blend equation.
	 * @return {string} The GPU blend operation.
	 */ _getBlendOperation(blendEquation) {
        let blendOperation;
        switch(blendEquation){
            case 0, $9ddd7e9b53f7a2d4$export$20183a0484ce21a0:
                blendOperation = $03ccd63b0299d6a7$var$GPUBlendOperation.Add;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$73e0df5177988548:
                blendOperation = $03ccd63b0299d6a7$var$GPUBlendOperation.Subtract;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$28e582859cbec660:
                blendOperation = $03ccd63b0299d6a7$var$GPUBlendOperation.ReverseSubtract;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$c8c1508da8d0600c:
                blendOperation = $03ccd63b0299d6a7$var$GPUBlendOperation.Min;
                break;
            case 0, $9ddd7e9b53f7a2d4$export$99948c02fb51055f:
                blendOperation = $03ccd63b0299d6a7$var$GPUBlendOperation.Max;
                break;
            default:
                (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUPipelineUtils: Blend equation not supported.', blendEquation);
        }
        return blendOperation;
    }
    /**
	 * Returns the primitive state as a descriptor object required
	 * for the pipeline creation.
	 *
	 * @private
	 * @param {Object3D} object - The 3D object.
	 * @param {BufferGeometry} geometry - The geometry.
	 * @param {Material} material - The material.
	 * @return {Object} The primitive state.
	 */ _getPrimitiveState(object, geometry, material) {
        const descriptor = {};
        const utils = this.backend.utils;
        //
        descriptor.topology = utils.getPrimitiveTopology(object, material);
        if (geometry.index !== null && object.isLine === true && object.isLineSegments !== true) descriptor.stripIndexFormat = geometry.index.array instanceof Uint16Array ? $03ccd63b0299d6a7$var$GPUIndexFormat.Uint16 : $03ccd63b0299d6a7$var$GPUIndexFormat.Uint32;
        //
        let flipSided = material.side === (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace);
        if (object.isMesh && object.matrixWorld.determinant() < 0) flipSided = !flipSided;
        descriptor.frontFace = flipSided === true ? $03ccd63b0299d6a7$var$GPUFrontFace.CW : $03ccd63b0299d6a7$var$GPUFrontFace.CCW;
        //
        descriptor.cullMode = material.side === (0, $9ddd7e9b53f7a2d4$export$3b296b6f144d5b03) ? $03ccd63b0299d6a7$var$GPUCullMode.None : $03ccd63b0299d6a7$var$GPUCullMode.Back;
        return descriptor;
    }
    /**
	 * Returns the GPU color write mask which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {number} The GPU color write mask.
	 */ _getColorWriteMask(material) {
        return material.colorWrite === true ? $03ccd63b0299d6a7$var$GPUColorWriteFlags.All : $03ccd63b0299d6a7$var$GPUColorWriteFlags.None;
    }
    /**
	 * Returns the GPU depth compare function which is required for the pipeline creation.
	 *
	 * @private
	 * @param {Material} material - The material.
	 * @return {string} The GPU depth compare function.
	 */ _getDepthCompare(material) {
        let depthCompare;
        if (material.depthTest === false) depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Always;
        else {
            const depthFunc = this.backend.parameters.reversedDepthBuffer ? (0, $9ddd7e9b53f7a2d4$export$611f4ad2374e11ff)[material.depthFunc] : material.depthFunc;
            switch(depthFunc){
                case 0, $9ddd7e9b53f7a2d4$export$69025ce147cee220:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Never;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$7182eb52ea3b3f04:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Always;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$eedccec66ab7ebe:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Less;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$296f78a0b892f81a:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.LessEqual;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$a60d398fc7b7590e:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Equal;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$7d7234c1240a1fc4:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.GreaterEqual;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$c5e2c52991f30937:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.Greater;
                    break;
                case 0, $9ddd7e9b53f7a2d4$export$2f843afa843d8916:
                    depthCompare = $03ccd63b0299d6a7$var$GPUCompareFunction.NotEqual;
                    break;
                default:
                    (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUPipelineUtils: Invalid depth function.', depthFunc);
            }
        }
        return depthCompare;
    }
}
/**
 * Manages a pool of WebGPU timestamp queries for performance measurement.
 * Extends the base TimestampQueryPool to provide WebGPU-specific implementation.
 *
 * @augments TimestampQueryPool
 */ class $03ccd63b0299d6a7$var$WebGPUTimestampQueryPool extends $03ccd63b0299d6a7$var$TimestampQueryPool {
    /**
	 * Creates a new WebGPU timestamp query pool.
	 *
	 * @param {GPUDevice} device - The WebGPU device to create queries on.
	 * @param {string} type - The type identifier for this query pool.
	 * @param {number} [maxQueries=2048] - Maximum number of queries this pool can hold.
	 */ constructor(device, type, maxQueries = 2048){
        super(maxQueries);
        this.device = device;
        this.type = type;
        this.querySet = this.device.createQuerySet({
            type: 'timestamp',
            count: this.maxQueries,
            label: `queryset_global_timestamp_${type}`
        });
        const bufferSize = this.maxQueries * 8;
        this.resolveBuffer = this.device.createBuffer({
            label: `buffer_timestamp_resolve_${type}`,
            size: bufferSize,
            usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
        });
        this.resultBuffer = this.device.createBuffer({
            label: `buffer_timestamp_result_${type}`,
            size: bufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        });
    }
    /**
	 * Allocates a pair of queries for a given render context.
	 *
	 * @param {string} uid - A unique identifier for the render context.
	 * @returns {?number} The base offset for the allocated queries, or null if allocation failed.
	 */ allocateQueriesForContext(uid) {
        if (!this.trackTimestamp || this.isDisposed) return null;
        if (this.currentQueryIndex + 2 > this.maxQueries) {
            (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)(`WebGPUTimestampQueryPool [${this.type}]: Maximum number of queries exceeded, when using trackTimestamp it is necessary to resolves the queries via renderer.resolveTimestampsAsync( THREE.TimestampQuery.${this.type.toUpperCase()} ).`);
            return null;
        }
        const baseOffset = this.currentQueryIndex;
        this.currentQueryIndex += 2;
        this.queryOffsets.set(uid, baseOffset);
        return baseOffset;
    }
    /**
	 * Asynchronously resolves all pending queries and returns the total duration.
	 * If there's already a pending resolve operation, returns that promise instead.
	 *
	 * @async
	 * @returns {Promise<number>} The total duration in milliseconds, or the last valid value if resolution fails.
	 */ async resolveQueriesAsync() {
        if (!this.trackTimestamp || this.currentQueryIndex === 0 || this.isDisposed) return this.lastValue;
        if (this.pendingResolve) return this.pendingResolve;
        this.pendingResolve = this._resolveQueries();
        try {
            const result = await this.pendingResolve;
            return result;
        } finally{
            this.pendingResolve = null;
        }
    }
    /**
	 * Internal method to resolve queries and calculate total duration.
	 *
	 * @async
	 * @private
	 * @returns {Promise<number>} The total duration in milliseconds.
	 */ async _resolveQueries() {
        if (this.isDisposed) return this.lastValue;
        try {
            if (this.resultBuffer.mapState !== 'unmapped') return this.lastValue;
            const currentOffsets = new Map(this.queryOffsets);
            const queryCount = this.currentQueryIndex;
            const bytesUsed = queryCount * 8;
            // Reset state before GPU work
            this.currentQueryIndex = 0;
            this.queryOffsets.clear();
            const commandEncoder = this.device.createCommandEncoder();
            commandEncoder.resolveQuerySet(this.querySet, 0, queryCount, this.resolveBuffer, 0);
            commandEncoder.copyBufferToBuffer(this.resolveBuffer, 0, this.resultBuffer, 0, bytesUsed);
            const commandBuffer = commandEncoder.finish();
            this.device.queue.submit([
                commandBuffer
            ]);
            if (this.resultBuffer.mapState !== 'unmapped') return this.lastValue;
            // Create and track the mapping operation
            await this.resultBuffer.mapAsync(GPUMapMode.READ, 0, bytesUsed);
            if (this.isDisposed) {
                if (this.resultBuffer.mapState === 'mapped') this.resultBuffer.unmap();
                return this.lastValue;
            }
            //
            const times = new BigUint64Array(this.resultBuffer.getMappedRange(0, bytesUsed));
            const framesDuration = {};
            const frames = [];
            for (const [uid, baseOffset] of currentOffsets){
                const match = uid.match(/^(.*):f(\d+)$/);
                const frame = parseInt(match[2]);
                if (frames.includes(frame) === false) frames.push(frame);
                if (framesDuration[frame] === undefined) framesDuration[frame] = 0;
                const startTime = times[baseOffset];
                const endTime = times[baseOffset + 1];
                const duration = Number(endTime - startTime) / 1e6;
                this.timestamps.set(uid, duration);
                framesDuration[frame] += duration;
            }
            // Return the total duration of the last frame
            const totalDuration = framesDuration[frames[frames.length - 1]];
            this.resultBuffer.unmap();
            this.lastValue = totalDuration;
            this.frames = frames;
            return totalDuration;
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error resolving queries:', e);
            if (this.resultBuffer.mapState === 'mapped') this.resultBuffer.unmap();
            return this.lastValue;
        }
    }
    /**
	 * Dispose of the query pool.
	 *
	 * @async
	 * @returns {Promise} A Promise that resolves when the dispose has been executed.
	 */ async dispose() {
        if (this.isDisposed) return;
        this.isDisposed = true;
        // Wait for pending resolve operation
        if (this.pendingResolve) try {
            await this.pendingResolve;
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error waiting for pending resolve:', e);
        }
        // Ensure buffer is unmapped before destroying
        if (this.resultBuffer && this.resultBuffer.mapState === 'mapped') try {
            this.resultBuffer.unmap();
        } catch (e) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('Error unmapping buffer:', e);
        }
        // Destroy resources
        if (this.querySet) {
            this.querySet.destroy();
            this.querySet = null;
        }
        if (this.resolveBuffer) {
            this.resolveBuffer.destroy();
            this.resolveBuffer = null;
        }
        if (this.resultBuffer) {
            this.resultBuffer.destroy();
            this.resultBuffer = null;
        }
        this.queryOffsets.clear();
        this.pendingResolve = null;
    }
}
/*// debugger tools
import 'https://greggman.github.io/webgpu-avoid-redundant-state-setting/webgpu-check-redundant-state-setting.js';
//*/ const $03ccd63b0299d6a7$var$_clearValue = {
    r: 0,
    g: 0,
    b: 0,
    a: 1
};
/**
 * A backend implementation targeting WebGPU.
 *
 * @private
 * @augments Backend
 */ class $03ccd63b0299d6a7$export$6f9bc39baf8c093a extends $03ccd63b0299d6a7$var$Backend {
    /**
	 * WebGPUBackend options.
	 *
	 * @typedef {Object} WebGPUBackend~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [reversedDepthBuffer=false] - Whether reversed depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {boolean} [trackTimestamp=false] - Whether to track timestamps with a Timestamp Query API or not.
	 * @property {string} [powerPreference=undefined] - The power preference.
	 * @property {Object} [requiredLimits=undefined] - Specifies the limits that are required by the device request. The request will fail if the adapter cannot provide these limits.
	 * @property {GPUDevice} [device=undefined] - If there is an existing GPU device on app level, it can be passed to the renderer as a parameter.
	 * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
	 */ /**
	 * Constructs a new WebGPU backend.
	 *
	 * @param {WebGPUBackend~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGPUBackend = true;
        // some parameters require default values other than "undefined"
        this.parameters.alpha = parameters.alpha === undefined ? true : parameters.alpha;
        this.parameters.requiredLimits = parameters.requiredLimits === undefined ? {} : parameters.requiredLimits;
        /**
		 * Indicates whether the backend is in WebGPU compatibility mode or not.
		 * The backend must be initialized before the property can be evaluated.
		 *
		 * @type {?boolean}
		 * @readonly
		 * @default null
		 */ this.compatibilityMode = null;
        /**
		 * A reference to the device.
		 *
		 * @type {?GPUDevice}
		 * @default null
		 */ this.device = null;
        /**
		 * A reference to the default render pass descriptor.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.defaultRenderPassdescriptor = null;
        /**
		 * A reference to a backend module holding common utility functions.
		 *
		 * @type {WebGPUUtils}
		 */ this.utils = new $03ccd63b0299d6a7$var$WebGPUUtils(this);
        /**
		 * A reference to a backend module holding shader attribute-related
		 * utility functions.
		 *
		 * @type {WebGPUAttributeUtils}
		 */ this.attributeUtils = new $03ccd63b0299d6a7$var$WebGPUAttributeUtils(this);
        /**
		 * A reference to a backend module holding shader binding-related
		 * utility functions.
		 *
		 * @type {WebGPUBindingUtils}
		 */ this.bindingUtils = new $03ccd63b0299d6a7$var$WebGPUBindingUtils(this);
        /**
		 * A reference to a backend module holding device capability related
		 * utility functions.
		 *
		 * @type {WebGPUCapabilities}
		 */ this.capabilities = new $03ccd63b0299d6a7$var$WebGPUCapabilities(this);
        /**
		 * A reference to a backend module holding shader pipeline-related
		 * utility functions.
		 *
		 * @type {WebGPUPipelineUtils}
		 */ this.pipelineUtils = new $03ccd63b0299d6a7$var$WebGPUPipelineUtils(this);
        /**
		 * A reference to a backend module holding shader texture-related
		 * utility functions.
		 *
		 * @type {WebGPUTextureUtils}
		 */ this.textureUtils = new $03ccd63b0299d6a7$var$WebGPUTextureUtils(this);
        /**
		 * A map that manages the resolve buffers for occlusion queries.
		 *
		 * @type {Map<number,GPUBuffer>}
		 */ this.occludedResolveCache = new Map();
        // compatibility checks
        const compatibilityTextureCompare = typeof navigator === 'undefined' ? true : /Android/.test(navigator.userAgent) === false;
        /**
		 * A map of compatibility checks.
		 *
		 * @type {Object}
		 */ this._compatibility = {
            [(0, $9ddd7e9b53f7a2d4$export$10255bda2baf681).TEXTURE_COMPARE]: compatibilityTextureCompare
        };
    }
    /**
	 * Initializes the backend so it is ready for usage.
	 *
	 * @async
	 * @param {Renderer} renderer - The renderer.
	 * @return {Promise} A Promise that resolves when the backend has been initialized.
	 */ async init(renderer) {
        await super.init(renderer);
        //
        const parameters = this.parameters;
        // create the device if it is not passed with parameters
        let device;
        if (parameters.device === undefined) {
            const adapterOptions = {
                powerPreference: parameters.powerPreference,
                featureLevel: 'compatibility'
            };
            const adapter = typeof navigator !== 'undefined' ? await navigator.gpu.requestAdapter(adapterOptions) : null;
            if (adapter === null) throw new Error('WebGPUBackend: Unable to create WebGPU adapter.');
            // feature support
            const features = Object.values($03ccd63b0299d6a7$var$GPUFeatureName);
            const supportedFeatures = [];
            for (const name of features)if (adapter.features.has(name)) supportedFeatures.push(name);
            const deviceDescriptor = {
                requiredFeatures: supportedFeatures,
                requiredLimits: parameters.requiredLimits
            };
            device = await adapter.requestDevice(deviceDescriptor);
        } else device = parameters.device;
        this.compatibilityMode = !device.features.has('core-features-and-limits');
        if (this.compatibilityMode) renderer._samples = 0;
        device.lost.then((info)=>{
            if (info.reason === 'destroyed') return;
            const deviceLossInfo = {
                api: 'WebGPU',
                message: info.message || 'Unknown reason',
                reason: info.reason || null,
                originalEvent: info
            };
            renderer.onDeviceLost(deviceLossInfo);
        });
        this.device = device;
        this.trackTimestamp = this.trackTimestamp && this.hasFeature($03ccd63b0299d6a7$var$GPUFeatureName.TimestampQuery);
        this.updateSize();
    }
    /**
	 * A reference to the context.
	 *
	 * @type {?GPUCanvasContext}
	 * @default null
	 */ get context() {
        const canvasTarget = this.renderer.getCanvasTarget();
        const canvasData = this.get(canvasTarget);
        let context = canvasData.context;
        if (context === undefined) {
            const parameters = this.parameters;
            if (canvasTarget.isDefaultCanvasTarget === true && parameters.context !== undefined) context = parameters.context;
            else context = canvasTarget.domElement.getContext('webgpu');
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvasTarget.domElement) canvasTarget.domElement.setAttribute('data-engine', `three.js r${(0, $9ddd7e9b53f7a2d4$export$3545e07a80636437)} webgpu`);
            const alphaMode = parameters.alpha ? 'premultiplied' : 'opaque';
            const toneMappingMode = parameters.outputType === (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc) ? 'extended' : 'standard';
            context.configure({
                device: this.device,
                format: this.utils.getPreferredCanvasFormat(),
                usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
                alphaMode: alphaMode,
                toneMapping: {
                    mode: toneMappingMode
                }
            });
            canvasData.context = context;
        }
        return context;
    }
    /**
	 * The coordinate system of the backend.
	 *
	 * @type {number}
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $9ddd7e9b53f7a2d4$export$cc83beedcb9be9ac;
    }
    /**
	 * This method performs a readback operation by moving buffer data from
	 * a storage buffer attribute from the GPU to the CPU. ReadbackBuffer can
	 * be used to retain and reuse handles to the intermediate buffers and prevent
	 * new allocation.
	 *
	 * @async
	 * @param {BufferAttribute} attribute - The storage buffer attribute to read frm.
	 * @param {number} count - The offset from which to start reading the
	 * @param {number} offset - The storage buffer attribute.
	 * @param {ReadbackBuffer|ArrayBuffer} target - The storage buffer attribute.
	 * @return {Promise<ArrayBuffer|ReadbackBuffer>} A promise that resolves with the buffer data when the data are ready.
	 */ async getArrayBufferAsync(attribute, target = null, offset = 0, count = -1) {
        return await this.attributeUtils.getArrayBufferAsync(attribute, target, offset, count);
    }
    /**
	 * Returns the backend's rendering context.
	 *
	 * @return {GPUCanvasContext} The rendering context.
	 */ getContext() {
        return this.context;
    }
    /**
	 * Returns the default render pass descriptor.
	 *
	 * In WebGPU, the default framebuffer must be configured
	 * like custom framebuffers so the backend needs a render
	 * pass descriptor even when rendering directly to screen.
	 *
	 * @private
	 * @return {Object} The render pass descriptor.
	 */ _getDefaultRenderPassDescriptor() {
        const renderer = this.renderer;
        const canvasTarget = renderer.getCanvasTarget();
        const canvasData = this.get(canvasTarget);
        const samples = renderer.currentSamples;
        let descriptor = canvasData.descriptor;
        if (descriptor === undefined || canvasData.samples !== samples) {
            descriptor = {
                colorAttachments: [
                    {
                        view: null
                    }
                ]
            };
            if (renderer.depth === true || renderer.stencil === true) descriptor.depthStencilAttachment = {
                view: this.textureUtils.getDepthBuffer(renderer.depth, renderer.stencil).createView()
            };
            const colorAttachment = descriptor.colorAttachments[0];
            if (samples > 0) colorAttachment.view = this.textureUtils.getColorBuffer().createView();
            else colorAttachment.resolveTarget = undefined;
            canvasData.descriptor = descriptor;
            canvasData.samples = samples;
        }
        const colorAttachment = descriptor.colorAttachments[0];
        if (samples > 0) colorAttachment.resolveTarget = this.context.getCurrentTexture().createView();
        else colorAttachment.view = this.context.getCurrentTexture().createView();
        return descriptor;
    }
    /**
	 * Internal to determine if the current render target is a render target array with depth 2D array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @return {boolean} Whether the render target is a render target array with depth 2D array texture.
	 *
	 * @private
	 */ _isRenderCameraDepthArray(renderContext) {
        return renderContext.depthTexture && renderContext.depthTexture.image.depth > 1 && renderContext.camera.isArrayCamera;
    }
    /**
	 * Returns the render pass descriptor for the given render context.
	 *
	 * @private
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} colorAttachmentsConfig - Configuration object for the color attachments.
	 * @return {Object} The render pass descriptor.
	 */ _getRenderPassDescriptor(renderContext, colorAttachmentsConfig = {}) {
        const renderTarget = renderContext.renderTarget;
        const renderTargetData = this.get(renderTarget);
        let descriptors = renderTargetData.descriptors;
        if (descriptors === undefined || renderTargetData.width !== renderTarget.width || renderTargetData.height !== renderTarget.height || renderTargetData.samples !== renderTarget.samples) {
            descriptors = {};
            renderTargetData.descriptors = descriptors;
        }
        const cacheKey = renderContext.getCacheKey();
        let descriptorBase = descriptors[cacheKey];
        if (descriptorBase === undefined) {
            const textures = renderContext.textures;
            const textureViews = [];
            let sliceIndex;
            const isRenderCameraDepthArray = this._isRenderCameraDepthArray(renderContext);
            for(let i = 0; i < textures.length; i++){
                const textureData = this.get(textures[i]);
                const viewDescriptor = {
                    label: `colorAttachment_${i}`,
                    baseMipLevel: renderContext.activeMipmapLevel,
                    mipLevelCount: 1,
                    baseArrayLayer: renderContext.activeCubeFace,
                    arrayLayerCount: 1,
                    dimension: $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoD
                };
                if (renderTarget.isRenderTarget3D) {
                    sliceIndex = renderContext.activeCubeFace;
                    viewDescriptor.baseArrayLayer = 0;
                    viewDescriptor.dimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.ThreeD;
                    viewDescriptor.depthOrArrayLayers = textures[i].image.depth;
                } else if (renderTarget.isRenderTarget && textures[i].image.depth > 1) {
                    if (isRenderCameraDepthArray === true) {
                        const cameras = renderContext.camera.cameras;
                        for(let layer = 0; layer < cameras.length; layer++){
                            const layerViewDescriptor = {
                                ...viewDescriptor,
                                baseArrayLayer: layer,
                                arrayLayerCount: 1,
                                dimension: $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoD
                            };
                            const textureView = textureData.texture.createView(layerViewDescriptor);
                            textureViews.push({
                                view: textureView,
                                resolveTarget: undefined,
                                depthSlice: undefined
                            });
                        }
                    } else {
                        viewDescriptor.dimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoDArray;
                        viewDescriptor.depthOrArrayLayers = textures[i].image.depth;
                    }
                }
                if (isRenderCameraDepthArray !== true) {
                    const textureView = textureData.texture.createView(viewDescriptor);
                    let view, resolveTarget;
                    if (textureData.msaaTexture !== undefined) {
                        view = textureData.msaaTexture.createView();
                        resolveTarget = textureView;
                    } else {
                        view = textureView;
                        resolveTarget = undefined;
                    }
                    textureViews.push({
                        view: view,
                        resolveTarget: resolveTarget,
                        depthSlice: sliceIndex
                    });
                }
            }
            descriptorBase = {
                textureViews: textureViews
            };
            if (renderContext.depth) {
                const depthTextureData = this.get(renderContext.depthTexture);
                const options = {};
                if (renderContext.depthTexture.isArrayTexture || renderContext.depthTexture.isCubeTexture) {
                    options.dimension = $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoD;
                    options.arrayLayerCount = 1;
                    options.baseArrayLayer = renderContext.activeCubeFace;
                }
                descriptorBase.depthStencilView = depthTextureData.texture.createView(options);
            }
            descriptors[cacheKey] = descriptorBase;
            renderTargetData.width = renderTarget.width;
            renderTargetData.height = renderTarget.height;
            renderTargetData.samples = renderTarget.samples;
            renderTargetData.activeMipmapLevel = renderContext.activeMipmapLevel;
            renderTargetData.activeCubeFace = renderContext.activeCubeFace;
        }
        const descriptor = {
            colorAttachments: []
        };
        // Apply dynamic properties to cached views
        for(let i = 0; i < descriptorBase.textureViews.length; i++){
            const viewInfo = descriptorBase.textureViews[i];
            let clearValue = {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            };
            if (i === 0 && colorAttachmentsConfig.clearValue) clearValue = colorAttachmentsConfig.clearValue;
            descriptor.colorAttachments.push({
                view: viewInfo.view,
                depthSlice: viewInfo.depthSlice,
                resolveTarget: viewInfo.resolveTarget,
                loadOp: colorAttachmentsConfig.loadOp || $03ccd63b0299d6a7$var$GPULoadOp.Load,
                storeOp: colorAttachmentsConfig.storeOp || $03ccd63b0299d6a7$var$GPUStoreOp.Store,
                clearValue: clearValue
            });
        }
        if (descriptorBase.depthStencilView) descriptor.depthStencilAttachment = {
            view: descriptorBase.depthStencilView
        };
        return descriptor;
    }
    /**
	 * This method is executed at the beginning of a render call and prepares
	 * the WebGPU state for upcoming render calls
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginRender(renderContext) {
        const renderContextData = this.get(renderContext);
        //
        const device = this.device;
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        let occlusionQuerySet;
        if (occlusionQueryCount > 0) {
            if (renderContextData.currentOcclusionQuerySet) renderContextData.currentOcclusionQuerySet.destroy();
            if (renderContextData.currentOcclusionQueryBuffer) renderContextData.currentOcclusionQueryBuffer.destroy();
            // Get a reference to the array of objects with queries. The renderContextData property
            // can be changed by another render pass before the buffer.mapAsyc() completes.
            renderContextData.currentOcclusionQuerySet = renderContextData.occlusionQuerySet;
            renderContextData.currentOcclusionQueryBuffer = renderContextData.occlusionQueryBuffer;
            renderContextData.currentOcclusionQueryObjects = renderContextData.occlusionQueryObjects;
            //
            occlusionQuerySet = device.createQuerySet({
                type: 'occlusion',
                count: occlusionQueryCount,
                label: `occlusionQuerySet_${renderContext.id}`
            });
            renderContextData.occlusionQuerySet = occlusionQuerySet;
            renderContextData.occlusionQueryIndex = 0;
            renderContextData.occlusionQueryObjects = new Array(occlusionQueryCount);
            renderContextData.lastOcclusionObject = null;
        }
        let descriptor;
        if (renderContext.textures === null) descriptor = this._getDefaultRenderPassDescriptor();
        else descriptor = this._getRenderPassDescriptor(renderContext, {
            loadOp: $03ccd63b0299d6a7$var$GPULoadOp.Load
        });
        this.initTimestampQuery((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).RENDER, this.getTimestampUID(renderContext), descriptor);
        descriptor.occlusionQuerySet = occlusionQuerySet;
        const depthStencilAttachment = descriptor.depthStencilAttachment;
        if (renderContext.textures !== null) {
            const colorAttachments = descriptor.colorAttachments;
            for(let i = 0; i < colorAttachments.length; i++){
                const colorAttachment = colorAttachments[i];
                if (renderContext.clearColor) {
                    if (i === 0) colorAttachment.clearValue = renderContext.clearColorValue;
                    else {
                        $03ccd63b0299d6a7$var$_clearValue.r = 0;
                        $03ccd63b0299d6a7$var$_clearValue.g = 0;
                        $03ccd63b0299d6a7$var$_clearValue.b = 0;
                        $03ccd63b0299d6a7$var$_clearValue.a = 1;
                        colorAttachment.clearValue = $03ccd63b0299d6a7$var$_clearValue;
                    }
                    colorAttachment.loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                } else colorAttachment.loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
                colorAttachment.storeOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
        } else {
            const colorAttachment = descriptor.colorAttachments[0];
            if (renderContext.clearColor) {
                colorAttachment.clearValue = renderContext.clearColorValue;
                colorAttachment.loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
            } else colorAttachment.loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            colorAttachment.storeOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
        }
        //
        if (renderContext.depth) {
            if (renderContext.clearDepth) {
                depthStencilAttachment.depthClearValue = renderContext.clearDepthValue;
                depthStencilAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
            } else depthStencilAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            depthStencilAttachment.depthStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
        }
        if (renderContext.stencil) {
            if (renderContext.clearStencil) {
                depthStencilAttachment.stencilClearValue = renderContext.clearStencilValue;
                depthStencilAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
            } else depthStencilAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            depthStencilAttachment.stencilStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
        }
        //
        const encoder = device.createCommandEncoder({
            label: 'renderContext_' + renderContext.id
        });
        // shadow arrays - prepare bundle encoders for each camera in an array camera
        if (this._isRenderCameraDepthArray(renderContext) === true) {
            const cameras = renderContext.camera.cameras;
            if (!renderContextData.layerDescriptors || renderContextData.layerDescriptors.length !== cameras.length) this._createDepthLayerDescriptors(renderContext, renderContextData, descriptor, cameras);
            else this._updateDepthLayerDescriptors(renderContext, renderContextData, cameras);
            // Create bundle encoders for each layer
            renderContextData.bundleEncoders = [];
            renderContextData.bundleSets = [];
            // Create separate bundle encoders for each camera in the array
            for(let i = 0; i < cameras.length; i++){
                const bundleEncoder = this.pipelineUtils.createBundleEncoder(renderContext, 'renderBundleArrayCamera_' + i);
                // Initialize state tracking for this bundle
                const bundleSets = {
                    attributes: {},
                    bindingGroups: [],
                    pipeline: null,
                    index: null
                };
                renderContextData.bundleEncoders.push(bundleEncoder);
                renderContextData.bundleSets.push(bundleSets);
            }
            // We'll complete the bundles in finishRender
            renderContextData.currentPass = null;
        } else {
            const currentPass = encoder.beginRenderPass(descriptor);
            renderContextData.currentPass = currentPass;
            if (renderContext.viewport) this.updateViewport(renderContext);
            if (renderContext.scissor) this.updateScissor(renderContext);
        }
        //
        renderContextData.descriptor = descriptor;
        renderContextData.encoder = encoder;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.renderBundles = [];
    }
    /**
	 * This method creates layer descriptors for each camera in an array camera
	 * to prepare for rendering to a depth array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} renderContextData - The render context data.
	 * @param {Object} descriptor  - The render pass descriptor.
	 * @param {ArrayCamera} cameras - The array camera.
	 *
	 * @private
	 */ _createDepthLayerDescriptors(renderContext, renderContextData, descriptor, cameras) {
        const depthStencilAttachment = descriptor.depthStencilAttachment;
        renderContextData.layerDescriptors = [];
        const depthTextureData = this.get(renderContext.depthTexture);
        if (!depthTextureData.viewCache) depthTextureData.viewCache = [];
        for(let i = 0; i < cameras.length; i++){
            const layerDescriptor = {
                ...descriptor,
                colorAttachments: [
                    {
                        ...descriptor.colorAttachments[0],
                        view: descriptor.colorAttachments[i].view
                    }
                ]
            };
            if (descriptor.depthStencilAttachment) {
                const layerIndex = i;
                if (!depthTextureData.viewCache[layerIndex]) depthTextureData.viewCache[layerIndex] = depthTextureData.texture.createView({
                    dimension: $03ccd63b0299d6a7$var$GPUTextureViewDimension.TwoD,
                    baseArrayLayer: i,
                    arrayLayerCount: 1
                });
                layerDescriptor.depthStencilAttachment = {
                    view: depthTextureData.viewCache[layerIndex],
                    depthLoadOp: depthStencilAttachment.depthLoadOp || $03ccd63b0299d6a7$var$GPULoadOp.Clear,
                    depthStoreOp: depthStencilAttachment.depthStoreOp || $03ccd63b0299d6a7$var$GPUStoreOp.Store,
                    depthClearValue: depthStencilAttachment.depthClearValue || 1.0
                };
                if (renderContext.stencil) {
                    layerDescriptor.depthStencilAttachment.stencilLoadOp = depthStencilAttachment.stencilLoadOp;
                    layerDescriptor.depthStencilAttachment.stencilStoreOp = depthStencilAttachment.stencilStoreOp;
                    layerDescriptor.depthStencilAttachment.stencilClearValue = depthStencilAttachment.stencilClearValue;
                }
            } else layerDescriptor.depthStencilAttachment = {
                ...depthStencilAttachment
            };
            renderContextData.layerDescriptors.push(layerDescriptor);
        }
    }
    /**
	 * This method updates the layer descriptors for each camera in an array camera
	 * to prepare for rendering to a depth array texture.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object} renderContextData - The render context data.
	 * @param {ArrayCamera} cameras - The array camera.
	 *
	 */ _updateDepthLayerDescriptors(renderContext, renderContextData, cameras) {
        for(let i = 0; i < cameras.length; i++){
            const layerDescriptor = renderContextData.layerDescriptors[i];
            if (layerDescriptor.depthStencilAttachment) {
                const depthAttachment = layerDescriptor.depthStencilAttachment;
                if (renderContext.depth) {
                    if (renderContext.clearDepth) {
                        depthAttachment.depthClearValue = renderContext.clearDepthValue;
                        depthAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                    } else depthAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
                }
                if (renderContext.stencil) {
                    if (renderContext.clearStencil) {
                        depthAttachment.stencilClearValue = renderContext.clearStencilValue;
                        depthAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                    } else depthAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
                }
            }
        }
    }
    /**
	 * This method is executed at the end of a render call and finalizes work
	 * after draw calls.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ finishRender(renderContext) {
        const renderContextData = this.get(renderContext);
        const occlusionQueryCount = renderContext.occlusionQueryCount;
        if (renderContextData.renderBundles.length > 0) renderContextData.currentPass.executeBundles(renderContextData.renderBundles);
        if (occlusionQueryCount > renderContextData.occlusionQueryIndex) renderContextData.currentPass.endOcclusionQuery();
        // shadow arrays - Execute bundles for each layer
        const encoder = renderContextData.encoder;
        if (this._isRenderCameraDepthArray(renderContext) === true) {
            const bundles = [];
            for(let i = 0; i < renderContextData.bundleEncoders.length; i++){
                const bundleEncoder = renderContextData.bundleEncoders[i];
                bundles.push(bundleEncoder.finish());
            }
            for(let i = 0; i < renderContextData.layerDescriptors.length; i++)if (i < bundles.length) {
                const layerDescriptor = renderContextData.layerDescriptors[i];
                const renderPass = encoder.beginRenderPass(layerDescriptor);
                if (renderContext.viewport) {
                    const { x: x, y: y, width: width, height: height, minDepth: minDepth, maxDepth: maxDepth } = renderContext.viewportValue;
                    renderPass.setViewport(x, y, width, height, minDepth, maxDepth);
                }
                if (renderContext.scissor) {
                    const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
                    renderPass.setScissorRect(x, y, width, height);
                }
                renderPass.executeBundles([
                    bundles[i]
                ]);
                renderPass.end();
            }
        } else if (renderContextData.currentPass) renderContextData.currentPass.end();
        if (occlusionQueryCount > 0) {
            const bufferSize = occlusionQueryCount * 8; // 8 byte entries for query results
            //
            let queryResolveBuffer = this.occludedResolveCache.get(bufferSize);
            if (queryResolveBuffer === undefined) {
                queryResolveBuffer = this.device.createBuffer({
                    size: bufferSize,
                    usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
                });
                this.occludedResolveCache.set(bufferSize, queryResolveBuffer);
            }
            //
            const readBuffer = this.device.createBuffer({
                size: bufferSize,
                usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
            });
            // two buffers required here - WebGPU doesn't allow usage of QUERY_RESOLVE & MAP_READ to be combined
            renderContextData.encoder.resolveQuerySet(renderContextData.occlusionQuerySet, 0, occlusionQueryCount, queryResolveBuffer, 0);
            renderContextData.encoder.copyBufferToBuffer(queryResolveBuffer, 0, readBuffer, 0, bufferSize);
            renderContextData.occlusionQueryBuffer = readBuffer;
            //
            this.resolveOccludedAsync(renderContext);
        }
        this.device.queue.submit([
            renderContextData.encoder.finish()
        ]);
        //
        if (renderContext.textures !== null) {
            const textures = renderContext.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                if (texture.generateMipmaps === true) this.textureUtils.generateMipmaps(texture);
            }
        }
    }
    /**
	 * Returns `true` if the given 3D object is fully occluded by other
	 * 3D objects in the scene.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object is fully occluded or not.
	 */ isOccluded(renderContext, object) {
        const renderContextData = this.get(renderContext);
        return renderContextData.occluded && renderContextData.occluded.has(object);
    }
    /**
	 * This method processes the result of occlusion queries and writes it
	 * into render context data.
	 *
	 * @async
	 * @param {RenderContext} renderContext - The render context.
	 * @return {Promise} A Promise that resolves when the occlusion query results have been processed.
	 */ async resolveOccludedAsync(renderContext) {
        const renderContextData = this.get(renderContext);
        // handle occlusion query results
        const { currentOcclusionQueryBuffer: currentOcclusionQueryBuffer, currentOcclusionQueryObjects: currentOcclusionQueryObjects } = renderContextData;
        if (currentOcclusionQueryBuffer && currentOcclusionQueryObjects) {
            const occluded = new WeakSet();
            renderContextData.currentOcclusionQueryObjects = null;
            renderContextData.currentOcclusionQueryBuffer = null;
            await currentOcclusionQueryBuffer.mapAsync(GPUMapMode.READ);
            const buffer = currentOcclusionQueryBuffer.getMappedRange();
            const results = new BigUint64Array(buffer);
            for(let i = 0; i < currentOcclusionQueryObjects.length; i++)if (results[i] === BigInt(0)) occluded.add(currentOcclusionQueryObjects[i]);
            currentOcclusionQueryBuffer.destroy();
            renderContextData.occluded = occluded;
        }
    }
    /**
	 * Updates the viewport with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateViewport(renderContext) {
        const { currentPass: currentPass } = this.get(renderContext);
        const { x: x, y: y, width: width, height: height, minDepth: minDepth, maxDepth: maxDepth } = renderContext.viewportValue;
        currentPass.setViewport(x, y, width, height, minDepth, maxDepth);
    }
    /**
	 * Updates the scissor with the values from the given render context.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ updateScissor(renderContext) {
        const { currentPass: currentPass } = this.get(renderContext);
        const { x: x, y: y, width: width, height: height } = renderContext.scissorValue;
        currentPass.setScissorRect(x, y, width, height);
    }
    /**
	 * Returns the clear color and alpha into a single
	 * color object.
	 *
	 * @return {Color4} The clear color.
	 */ getClearColor() {
        const clearColor = super.getClearColor();
        // only premultiply alpha when alphaMode is "premultiplied"
        if (this.renderer.alpha === true) {
            clearColor.r *= clearColor.a;
            clearColor.g *= clearColor.a;
            clearColor.b *= clearColor.a;
        }
        return clearColor;
    }
    /**
	 * Performs a clear operation.
	 *
	 * @param {boolean} color - Whether the color buffer should be cleared or not.
	 * @param {boolean} depth - Whether the depth buffer should be cleared or not.
	 * @param {boolean} stencil - Whether the stencil buffer should be cleared or not.
	 * @param {?RenderContext} [renderTargetContext=null] - The render context of the current set render target.
	 */ clear(color, depth, stencil, renderTargetContext = null) {
        const device = this.device;
        const renderer = this.renderer;
        let colorAttachments = [];
        let depthStencilAttachment;
        let supportsDepth;
        let supportsStencil;
        if (color) {
            const clearColor = this.getClearColor();
            $03ccd63b0299d6a7$var$_clearValue.r = clearColor.r;
            $03ccd63b0299d6a7$var$_clearValue.g = clearColor.g;
            $03ccd63b0299d6a7$var$_clearValue.b = clearColor.b;
            $03ccd63b0299d6a7$var$_clearValue.a = clearColor.a;
        }
        if (renderTargetContext === null) {
            supportsDepth = renderer.depth;
            supportsStencil = renderer.stencil;
            const descriptor = this._getDefaultRenderPassDescriptor();
            if (color) {
                colorAttachments = descriptor.colorAttachments;
                const colorAttachment = colorAttachments[0];
                colorAttachment.clearValue = $03ccd63b0299d6a7$var$_clearValue;
                colorAttachment.loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                colorAttachment.storeOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
            if (supportsDepth || supportsStencil) depthStencilAttachment = descriptor.depthStencilAttachment;
        } else {
            supportsDepth = renderTargetContext.depth;
            supportsStencil = renderTargetContext.stencil;
            const clearConfig = {
                loadOp: color ? $03ccd63b0299d6a7$var$GPULoadOp.Clear : $03ccd63b0299d6a7$var$GPULoadOp.Load,
                clearValue: color ? $03ccd63b0299d6a7$var$_clearValue : undefined
            };
            if (supportsDepth) {
                clearConfig.depthLoadOp = depth ? $03ccd63b0299d6a7$var$GPULoadOp.Clear : $03ccd63b0299d6a7$var$GPULoadOp.Load;
                clearConfig.depthClearValue = depth ? renderer.getClearDepth() : undefined;
                clearConfig.depthStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
            if (supportsStencil) {
                clearConfig.stencilLoadOp = stencil ? $03ccd63b0299d6a7$var$GPULoadOp.Clear : $03ccd63b0299d6a7$var$GPULoadOp.Load;
                clearConfig.stencilClearValue = stencil ? renderer.getClearStencil() : undefined;
                clearConfig.stencilStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
            const descriptor = this._getRenderPassDescriptor(renderTargetContext, clearConfig);
            colorAttachments = descriptor.colorAttachments;
            depthStencilAttachment = descriptor.depthStencilAttachment;
        }
        if (supportsDepth && depthStencilAttachment) {
            if (depth) {
                depthStencilAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                depthStencilAttachment.depthClearValue = renderer.getClearDepth();
                depthStencilAttachment.depthStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            } else {
                depthStencilAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
                depthStencilAttachment.depthStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
        }
        //
        if (supportsStencil && depthStencilAttachment) {
            if (stencil) {
                depthStencilAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Clear;
                depthStencilAttachment.stencilClearValue = renderer.getClearStencil();
                depthStencilAttachment.stencilStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            } else {
                depthStencilAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
                depthStencilAttachment.stencilStoreOp = $03ccd63b0299d6a7$var$GPUStoreOp.Store;
            }
        }
        //
        const encoder = device.createCommandEncoder({
            label: 'clear'
        });
        const currentPass = encoder.beginRenderPass({
            colorAttachments: colorAttachments,
            depthStencilAttachment: depthStencilAttachment
        });
        currentPass.end();
        device.queue.submit([
            encoder.finish()
        ]);
    }
    // compute
    /**
	 * This method is executed at the beginning of a compute call and
	 * prepares the state for upcoming compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ beginCompute(computeGroup) {
        const groupGPU = this.get(computeGroup);
        //
        const descriptor = {
            label: 'computeGroup_' + computeGroup.id
        };
        this.initTimestampQuery((0, $9ddd7e9b53f7a2d4$export$f97db56e2b647801).COMPUTE, this.getTimestampUID(computeGroup), descriptor);
        groupGPU.cmdEncoderGPU = this.device.createCommandEncoder({
            label: 'computeGroup_' + computeGroup.id
        });
        groupGPU.passEncoderGPU = groupGPU.cmdEncoderGPU.beginComputePass(descriptor);
    }
    /**
	 * Executes a compute command for the given compute node.
	 *
	 * @param {Node|Array<Node>} computeGroup - The group of compute nodes of a compute call. Can be a single compute node.
	 * @param {Node} computeNode - The compute node.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 * @param {ComputePipeline} pipeline - The compute pipeline.
	 * @param {number|Array<number>|IndirectStorageBufferAttribute} [dispatchSize=null]
	 * - A single number representing count, or
	 * - An array [x, y, z] representing dispatch size, or
	 * - A IndirectStorageBufferAttribute for indirect dispatch size.
	 */ compute(computeGroup, computeNode, bindings, pipeline, dispatchSize = null) {
        const computeNodeData = this.get(computeNode);
        const { passEncoderGPU: passEncoderGPU } = this.get(computeGroup);
        // pipeline
        const pipelineGPU = this.get(pipeline).pipeline;
        this.pipelineUtils.setPipeline(passEncoderGPU, pipelineGPU);
        // bind groups
        for(let i = 0, l = bindings.length; i < l; i++){
            const bindGroup = bindings[i];
            const bindingsData = this.get(bindGroup);
            passEncoderGPU.setBindGroup(i, bindingsData.group);
        }
        if (dispatchSize === null) dispatchSize = computeNode.dispatchSize || computeNode.count;
        // When the dispatchSize is set with a StorageBuffer from the GPU.
        if (dispatchSize && dispatchSize.isIndirectStorageBufferAttribute) {
            const dispatchBuffer = this.get(dispatchSize).buffer;
            passEncoderGPU.dispatchWorkgroupsIndirect(dispatchBuffer, 0);
            return;
        }
        if (typeof dispatchSize === 'number') {
            // If a single number is given, we calculate the dispatch size based on the workgroup size
            const count = dispatchSize;
            if (computeNodeData.dispatchSize === undefined || computeNodeData.count !== count) {
                // cache dispatch size to avoid recalculating it every time
                computeNodeData.dispatchSize = [
                    0,
                    1,
                    1
                ];
                computeNodeData.count = count;
                const workgroupSize = computeNode.workgroupSize;
                let size = workgroupSize[0];
                for(let i = 1; i < workgroupSize.length; i++)size *= workgroupSize[i];
                const dispatchCount = Math.ceil(count / size);
                //
                const maxComputeWorkgroupsPerDimension = this.device.limits.maxComputeWorkgroupsPerDimension;
                dispatchSize = [
                    dispatchCount,
                    1,
                    1
                ];
                if (dispatchCount > maxComputeWorkgroupsPerDimension) {
                    dispatchSize[0] = Math.min(dispatchCount, maxComputeWorkgroupsPerDimension);
                    dispatchSize[1] = Math.ceil(dispatchCount / maxComputeWorkgroupsPerDimension);
                }
                computeNodeData.dispatchSize = dispatchSize;
            }
            dispatchSize = computeNodeData.dispatchSize;
        }
        //
        passEncoderGPU.dispatchWorkgroups(dispatchSize[0], dispatchSize[1] || 1, dispatchSize[2] || 1);
    }
    /**
	 * This method is executed at the end of a compute call and
	 * finalizes work after compute tasks.
	 *
	 * @param {Node|Array<Node>} computeGroup - The compute node(s).
	 */ finishCompute(computeGroup) {
        const groupData = this.get(computeGroup);
        groupData.passEncoderGPU.end();
        this.device.queue.submit([
            groupData.cmdEncoderGPU.finish()
        ]);
    }
    /**
	 * Internal draw function that performs the draw with the given pass encoder.
	 *
	 * @private
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 * @param {Object} renderContextData - The render context data object, holding current pass state and occlusion query tracking.
	 * @param {GPURenderPipeline} pipelineGPU - The GPU render pipeline.
	 * @param {Array<BindGroup>} bindings - The bind groups.
	 * @param {Array<BufferAttribute>} vertexBuffers - The vertex buffers.
	 * @param {{vertexCount: number, firstVertex: number, instanceCount: number, firstInstance: number}} drawParams - The draw parameters.
	 * @param {GPURenderPassEncoder|GPURenderBundleEncoder} passEncoderGPU - The GPU pass encoder used for recording draw commands.
	 * @param {Object} currentSets - Tracking object for currently set pipeline, attributes, bind groups, and index state.
	 */ _draw(renderObject, info, renderContextData, pipelineGPU, bindings, vertexBuffers, drawParams, passEncoderGPU, currentSets) {
        const { object: object, material: material, context: context } = renderObject;
        const index = renderObject.getIndex();
        const hasIndex = index !== null;
        // pipeline
        this.pipelineUtils.setPipeline(passEncoderGPU, pipelineGPU);
        currentSets.pipeline = pipelineGPU;
        // bind groups
        const currentBindingGroups = currentSets.bindingGroups;
        for(let i = 0, l = bindings.length; i < l; i++){
            const bindGroup = bindings[i];
            const bindingsData = this.get(bindGroup);
            if (currentBindingGroups[i] !== bindGroup.id) {
                passEncoderGPU.setBindGroup(i, bindingsData.group);
                currentBindingGroups[i] = bindGroup.id;
            }
        }
        // attributes
        // index
        if (hasIndex === true) {
            if (currentSets.index !== index) {
                const buffer = this.get(index).buffer;
                const indexFormat = index.array instanceof Uint16Array ? $03ccd63b0299d6a7$var$GPUIndexFormat.Uint16 : $03ccd63b0299d6a7$var$GPUIndexFormat.Uint32;
                passEncoderGPU.setIndexBuffer(buffer, indexFormat);
                currentSets.index = index;
            }
        }
        for(let i = 0, l = vertexBuffers.length; i < l; i++){
            const vertexBuffer = vertexBuffers[i];
            if (currentSets.attributes[i] !== vertexBuffer) {
                const buffer = this.get(vertexBuffer).buffer;
                passEncoderGPU.setVertexBuffer(i, buffer);
                currentSets.attributes[i] = vertexBuffer;
            }
        }
        // stencil
        if (context.stencil === true && material.stencilWrite === true && renderContextData.currentStencilRef !== material.stencilRef) {
            passEncoderGPU.setStencilReference(material.stencilRef);
            renderContextData.currentStencilRef = material.stencilRef;
        }
        if (object.isBatchedMesh === true) {
            const starts = object._multiDrawStarts;
            const counts = object._multiDrawCounts;
            const drawCount = object._multiDrawCount;
            let bytesPerElement = hasIndex === true ? index.array.BYTES_PER_ELEMENT : 1;
            if (material.wireframe) bytesPerElement = object.geometry.attributes.position.count > 65535 ? 4 : 2;
            for(let i = 0; i < drawCount; i++){
                if (hasIndex === true) passEncoderGPU.drawIndexed(counts[i], 1, starts[i] / bytesPerElement, 0, i);
                else passEncoderGPU.draw(counts[i], 1, starts[i], i);
                info.update(object, counts[i], 1);
            }
        } else if (hasIndex === true) {
            const { vertexCount: indexCount, instanceCount: instanceCount, firstVertex: firstIndex } = drawParams;
            const indirect = renderObject.getIndirect();
            if (indirect !== null) {
                const buffer = this.get(indirect).buffer;
                const indirectOffset = renderObject.getIndirectOffset();
                const indirectOffsets = Array.isArray(indirectOffset) ? indirectOffset : [
                    indirectOffset
                ];
                for(let i = 0; i < indirectOffsets.length; i++)passEncoderGPU.drawIndexedIndirect(buffer, indirectOffsets[i]);
            } else passEncoderGPU.drawIndexed(indexCount, instanceCount, firstIndex, 0, 0);
            info.update(object, indexCount, instanceCount);
        } else {
            const { vertexCount: vertexCount, instanceCount: instanceCount, firstVertex: firstVertex } = drawParams;
            const indirect = renderObject.getIndirect();
            if (indirect !== null) {
                const buffer = this.get(indirect).buffer;
                const indirectOffset = renderObject.getIndirectOffset();
                const indirectOffsets = Array.isArray(indirectOffset) ? indirectOffset : [
                    indirectOffset
                ];
                for(let i = 0; i < indirectOffsets.length; i++)passEncoderGPU.drawIndirect(buffer, indirectOffsets[i]);
            } else passEncoderGPU.draw(vertexCount, instanceCount, firstVertex, 0);
            info.update(object, vertexCount, instanceCount);
        }
    }
    // render object
    /**
	 * Executes a draw command for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object to draw.
	 * @param {Info} info - Holds a series of statistical information about the GPU memory and the rendering process.
	 */ draw(renderObject, info) {
        const { object: object, context: context, pipeline: pipeline } = renderObject;
        const renderContextData = this.get(context);
        const pipelineData = this.get(pipeline);
        const pipelineGPU = pipelineData.pipeline;
        // Skip if pipeline has error
        if (pipelineData.error === true) return;
        const drawParams = renderObject.getDrawParameters();
        if (drawParams === null) return;
        const bindings = renderObject.getBindings();
        // vertex buffers
        const vertexBuffers = renderObject.getVertexBuffers();
        if (renderObject.camera.isArrayCamera && renderObject.camera.cameras.length > 0) {
            const cameraData = this.get(renderObject.camera);
            const cameras = renderObject.camera.cameras;
            const cameraIndex = renderObject.getBindingGroup('cameraIndex');
            if (cameraData.indexesGPU === undefined || cameraData.indexesGPU.length !== cameras.length) {
                const bindingsData = this.get(cameraIndex);
                const indexesGPU = [];
                const data = new Uint32Array([
                    0,
                    0,
                    0,
                    0
                ]);
                for(let i = 0, len = cameras.length; i < len; i++){
                    data[0] = i;
                    const { layoutGPU: layoutGPU } = bindingsData.layout;
                    const bindGroupIndex = this.bindingUtils.createBindGroupIndex(data, layoutGPU);
                    indexesGPU.push(bindGroupIndex);
                }
                cameraData.indexesGPU = indexesGPU; // TODO: Create a global library for this
            }
            const pixelRatio = this.renderer.getPixelRatio();
            for(let i = 0, len = cameras.length; i < len; i++){
                const subCamera = cameras[i];
                if (object.layers.test(subCamera.layers)) {
                    const vp = subCamera.viewport;
                    let pass = renderContextData.currentPass;
                    let sets = renderContextData.currentSets;
                    if (renderContextData.bundleEncoders) {
                        const bundleEncoder = renderContextData.bundleEncoders[i];
                        const bundleSets = renderContextData.bundleSets[i];
                        pass = bundleEncoder;
                        sets = bundleSets;
                    }
                    if (vp) pass.setViewport(Math.floor(vp.x * pixelRatio), Math.floor(vp.y * pixelRatio), Math.floor(vp.width * pixelRatio), Math.floor(vp.height * pixelRatio), context.viewportValue.minDepth, context.viewportValue.maxDepth);
                    // Set camera index binding for this layer
                    if (cameraIndex && cameraData.indexesGPU) {
                        const indexPos = bindings.indexOf(cameraIndex);
                        pass.setBindGroup(indexPos, cameraData.indexesGPU[i]);
                        sets.bindingGroups[indexPos] = cameraIndex.id;
                    }
                    this._draw(renderObject, info, renderContextData, pipelineGPU, bindings, vertexBuffers, drawParams, pass, sets);
                }
            }
        } else // Regular single camera rendering
        if (renderContextData.currentPass) {
            // Handle occlusion queries
            if (renderContextData.occlusionQuerySet !== undefined) {
                const lastObject = renderContextData.lastOcclusionObject;
                if (lastObject !== object) {
                    if (lastObject !== null && lastObject.occlusionTest === true) {
                        renderContextData.currentPass.endOcclusionQuery();
                        renderContextData.occlusionQueryIndex++;
                    }
                    if (object.occlusionTest === true) {
                        renderContextData.currentPass.beginOcclusionQuery(renderContextData.occlusionQueryIndex);
                        renderContextData.occlusionQueryObjects[renderContextData.occlusionQueryIndex] = object;
                    }
                    renderContextData.lastOcclusionObject = object;
                }
            }
            this._draw(renderObject, info, renderContextData, pipelineGPU, bindings, vertexBuffers, drawParams, renderContextData.currentPass, renderContextData.currentSets);
        }
    }
    // cache key
    /**
	 * Returns `true` if the render pipeline requires an update.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {boolean} Whether the render pipeline requires an update or not.
	 */ needsRenderUpdate(renderObject) {
        const data = this.get(renderObject);
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const sampleCount = utils.getSampleCountRenderContext(renderObject.context);
        const colorSpace = utils.getCurrentColorSpace(renderObject.context);
        const colorFormat = utils.getCurrentColorFormat(renderObject.context);
        const depthStencilFormat = utils.getCurrentDepthStencilFormat(renderObject.context);
        const primitiveTopology = utils.getPrimitiveTopology(object, material);
        let needsUpdate = false;
        if (data.material !== material || data.materialVersion !== material.version || data.transparent !== material.transparent || data.blending !== material.blending || data.premultipliedAlpha !== material.premultipliedAlpha || data.blendSrc !== material.blendSrc || data.blendDst !== material.blendDst || data.blendEquation !== material.blendEquation || data.blendSrcAlpha !== material.blendSrcAlpha || data.blendDstAlpha !== material.blendDstAlpha || data.blendEquationAlpha !== material.blendEquationAlpha || data.colorWrite !== material.colorWrite || data.depthWrite !== material.depthWrite || data.depthTest !== material.depthTest || data.depthFunc !== material.depthFunc || data.stencilWrite !== material.stencilWrite || data.stencilFunc !== material.stencilFunc || data.stencilFail !== material.stencilFail || data.stencilZFail !== material.stencilZFail || data.stencilZPass !== material.stencilZPass || data.stencilFuncMask !== material.stencilFuncMask || data.stencilWriteMask !== material.stencilWriteMask || data.side !== material.side || data.alphaToCoverage !== material.alphaToCoverage || data.sampleCount !== sampleCount || data.colorSpace !== colorSpace || data.colorFormat !== colorFormat || data.depthStencilFormat !== depthStencilFormat || data.primitiveTopology !== primitiveTopology || data.clippingContextCacheKey !== renderObject.clippingContextCacheKey) {
            data.material = material;
            data.materialVersion = material.version;
            data.transparent = material.transparent;
            data.blending = material.blending;
            data.premultipliedAlpha = material.premultipliedAlpha;
            data.blendSrc = material.blendSrc;
            data.blendDst = material.blendDst;
            data.blendEquation = material.blendEquation;
            data.blendSrcAlpha = material.blendSrcAlpha;
            data.blendDstAlpha = material.blendDstAlpha;
            data.blendEquationAlpha = material.blendEquationAlpha;
            data.colorWrite = material.colorWrite;
            data.depthWrite = material.depthWrite;
            data.depthTest = material.depthTest;
            data.depthFunc = material.depthFunc;
            data.stencilWrite = material.stencilWrite;
            data.stencilFunc = material.stencilFunc;
            data.stencilFail = material.stencilFail;
            data.stencilZFail = material.stencilZFail;
            data.stencilZPass = material.stencilZPass;
            data.stencilFuncMask = material.stencilFuncMask;
            data.stencilWriteMask = material.stencilWriteMask;
            data.side = material.side;
            data.alphaToCoverage = material.alphaToCoverage;
            data.sampleCount = sampleCount;
            data.colorSpace = colorSpace;
            data.colorFormat = colorFormat;
            data.depthStencilFormat = depthStencilFormat;
            data.primitiveTopology = primitiveTopology;
            data.clippingContextCacheKey = renderObject.clippingContextCacheKey;
            needsUpdate = true;
        }
        return needsUpdate;
    }
    /**
	 * Returns a cache key that is used to identify render pipelines.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @return {string} The cache key.
	 */ getRenderCacheKey(renderObject) {
        const { object: object, material: material } = renderObject;
        const utils = this.utils;
        const renderContext = renderObject.context;
        // meshes with negative scale have a different frontFace render pipeline
        // descriptor value so the following must be honored in the cache key
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        return [
            material.transparent,
            material.blending,
            material.premultipliedAlpha,
            material.blendSrc,
            material.blendDst,
            material.blendEquation,
            material.blendSrcAlpha,
            material.blendDstAlpha,
            material.blendEquationAlpha,
            material.colorWrite,
            material.depthWrite,
            material.depthTest,
            material.depthFunc,
            material.stencilWrite,
            material.stencilFunc,
            material.stencilFail,
            material.stencilZFail,
            material.stencilZPass,
            material.stencilFuncMask,
            material.stencilWriteMask,
            material.side,
            frontFaceCW,
            utils.getSampleCountRenderContext(renderContext),
            utils.getCurrentColorSpace(renderContext),
            utils.getCurrentColorFormat(renderContext),
            utils.getCurrentDepthStencilFormat(renderContext),
            utils.getPrimitiveTopology(object, material),
            renderObject.getGeometryCacheKey(),
            renderObject.clippingContextCacheKey
        ].join();
    }
    // textures
    /**
	 * Updates a GPU sampler for the given texture.
	 *
	 * @param {Texture} texture - The texture to update the sampler for.
	 * @return {string} The current sampler key.
	 */ updateSampler(texture) {
        return this.textureUtils.updateSampler(texture);
    }
    /**
	 * Creates a default texture for the given texture that can be used
	 * as a placeholder until the actual texture is ready for usage.
	 *
	 * @param {Texture} texture - The texture to create a default texture for.
	 * @return {boolean} Whether the sampler has been updated or not.
	 */ createDefaultTexture(texture) {
        return this.textureUtils.createDefaultTexture(texture);
    }
    /**
	 * Defines a texture on the GPU for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ createTexture(texture, options) {
        this.textureUtils.createTexture(texture, options);
    }
    /**
	 * Uploads the updated texture data to the GPU.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {Object} [options={}] - Optional configuration parameter.
	 */ updateTexture(texture, options) {
        this.textureUtils.updateTexture(texture, options);
    }
    /**
	 * Generates mipmaps for the given texture.
	 *
	 * @param {Texture} texture - The texture.
	 */ generateMipmaps(texture) {
        this.textureUtils.generateMipmaps(texture);
    }
    /**
	 * Destroys the GPU data for the given texture object.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {boolean} [isDefaultTexture=false] - Whether the texture uses a default GPU texture or not.
	 */ destroyTexture(texture, isDefaultTexture = false) {
        this.textureUtils.destroyTexture(texture, isDefaultTexture);
    }
    /**
	 * Returns texture data as a typed array.
	 *
	 * @async
	 * @param {Texture} texture - The texture to copy.
	 * @param {number} x - The x coordinate of the copy origin.
	 * @param {number} y - The y coordinate of the copy origin.
	 * @param {number} width - The width of the copy.
	 * @param {number} height - The height of the copy.
	 * @param {number} faceIndex - The face index.
	 * @return {Promise<TypedArray>} A Promise that resolves with a typed array when the copy operation has finished.
	 */ async copyTextureToBuffer(texture, x, y, width, height, faceIndex) {
        return this.textureUtils.copyTextureToBuffer(texture, x, y, width, height, faceIndex);
    }
    /**
	 * Inits a time stamp query for the given render context.
	 *
	 * @param {string} type - The type of the timestamp query (e.g. 'render', 'compute').
	 * @param {number} uid - Unique id for the context (e.g. render context id).
	 * @param {Object} descriptor - The query descriptor.
	 */ initTimestampQuery(type, uid, descriptor) {
        if (!this.trackTimestamp) return;
        if (!this.timestampQueryPool[type]) // TODO: Variable maxQueries?
        this.timestampQueryPool[type] = new $03ccd63b0299d6a7$var$WebGPUTimestampQueryPool(this.device, type, 2048);
        const timestampQueryPool = this.timestampQueryPool[type];
        const baseOffset = timestampQueryPool.allocateQueriesForContext(uid);
        descriptor.timestampWrites = {
            querySet: timestampQueryPool.querySet,
            beginningOfPassWriteIndex: baseOffset,
            endOfPassWriteIndex: baseOffset + 1
        };
    }
    // node builder
    /**
	 * Returns a node builder for the given render object.
	 *
	 * @param {RenderObject} object - The render object.
	 * @param {Renderer} renderer - The renderer.
	 * @return {WGSLNodeBuilder} The node builder.
	 */ createNodeBuilder(object, renderer) {
        return new $03ccd63b0299d6a7$var$WGSLNodeBuilder(object, renderer);
    }
    // program
    /**
	 * Creates a shader program from the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ createProgram(program) {
        const programGPU = this.get(program);
        programGPU.module = {
            module: this.device.createShaderModule({
                code: program.code,
                label: program.stage + (program.name !== '' ? `_${program.name}` : '')
            }),
            entryPoint: 'main'
        };
    }
    /**
	 * Destroys the shader program of the given programmable stage.
	 *
	 * @param {ProgrammableStage} program - The programmable stage.
	 */ destroyProgram(program) {
        this.delete(program);
    }
    // pipelines
    /**
	 * Creates a render pipeline for the given render object.
	 *
	 * @param {RenderObject} renderObject - The render object.
	 * @param {Array<Promise>} promises - An array of compilation promises which are used in `compileAsync()`.
	 */ createRenderPipeline(renderObject, promises) {
        this.pipelineUtils.createRenderPipeline(renderObject, promises);
    }
    /**
	 * Creates a compute pipeline for the given compute node.
	 *
	 * @param {ComputePipeline} computePipeline - The compute pipeline.
	 * @param {Array<BindGroup>} bindings - The bindings.
	 */ createComputePipeline(computePipeline, bindings) {
        this.pipelineUtils.createComputePipeline(computePipeline, bindings);
    }
    /**
	 * Prepares the state for encoding render bundles.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 */ beginBundle(renderContext) {
        const renderContextData = this.get(renderContext);
        renderContextData._currentPass = renderContextData.currentPass;
        renderContextData._currentSets = renderContextData.currentSets;
        renderContextData.currentSets = {
            attributes: {},
            bindingGroups: [],
            pipeline: null,
            index: null
        };
        renderContextData.currentPass = this.pipelineUtils.createBundleEncoder(renderContext);
    }
    /**
	 * After processing render bundles this method finalizes related work.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {RenderBundle} bundle - The render bundle.
	 */ finishBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        const bundleEncoder = renderContextData.currentPass;
        const bundleGPU = bundleEncoder.finish();
        this.get(bundle).bundleGPU = bundleGPU;
        // restore render pass state
        renderContextData.currentSets = renderContextData._currentSets;
        renderContextData.currentPass = renderContextData._currentPass;
    }
    /**
	 * Adds a render bundle to the render context data.
	 *
	 * @param {RenderContext} renderContext - The render context.
	 * @param {RenderBundle} bundle - The render bundle to add.
	 */ addBundle(renderContext, bundle) {
        const renderContextData = this.get(renderContext);
        renderContextData.renderBundles.push(this.get(bundle).bundleGPU);
    }
    // bindings
    /**
	 * Creates bindings from the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ createBindings(bindGroup, bindings, cacheIndex, version) {
        this.bindingUtils.createBindings(bindGroup, bindings, cacheIndex, version);
    }
    /**
	 * Updates the given bind group definition.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 * @param {Array<BindGroup>} bindings - Array of bind groups.
	 * @param {number} cacheIndex - The cache index.
	 * @param {number} version - The version.
	 */ updateBindings(bindGroup, bindings, cacheIndex, version) {
        this.bindingUtils.createBindings(bindGroup, bindings, cacheIndex, version);
    }
    /**
	 * Updates a buffer binding.
	 *
	 *  @param {Buffer} binding - The buffer binding to update.
	 */ updateBinding(binding) {
        this.bindingUtils.updateBinding(binding);
    }
    /**
	 * Delete data associated with the current bind group.
	 *
	 * @param {BindGroup} bindGroup - The bind group.
	 */ deleteBindGroupData(bindGroup) {
        this.bindingUtils.deleteBindGroupData(bindGroup);
    }
    // attributes
    /**
	 * Creates the buffer of an indexed shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The indexed buffer attribute.
	 */ createIndexAttribute(attribute) {
        let usage = GPUBufferUsage.INDEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
        if (attribute.isStorageBufferAttribute || attribute.isStorageInstancedBufferAttribute) usage |= GPUBufferUsage.STORAGE;
        this.attributeUtils.createAttribute(attribute, usage);
    }
    /**
	 * Creates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Creates the GPU buffer of a storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Creates the GPU buffer of an indirect storage attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute.
	 */ createIndirectStorageAttribute(attribute) {
        this.attributeUtils.createAttribute(attribute, GPUBufferUsage.STORAGE | GPUBufferUsage.INDIRECT | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST);
    }
    /**
	 * Updates the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to update.
	 */ updateAttribute(attribute) {
        this.attributeUtils.updateAttribute(attribute);
    }
    /**
	 * Destroys the GPU buffer of a shader attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute to destroy.
	 */ destroyAttribute(attribute) {
        this.attributeUtils.destroyAttribute(attribute);
    }
    // canvas
    /**
	 * Triggers an update of the default render pass descriptor.
	 */ updateSize() {
        this.delete(this.renderer.getCanvasTarget());
    }
    // utils public
    /**
	 * Checks if the given feature is supported by the backend.
	 *
	 * @param {string} name - The feature's name.
	 * @return {boolean} Whether the feature is supported or not.
	 */ hasFeature(name) {
        if ($03ccd63b0299d6a7$var$GPUFeatureMap[name] !== undefined) name = $03ccd63b0299d6a7$var$GPUFeatureMap[name];
        return this.device.features.has(name);
    }
    /**
	 * Copies data of the given source texture to the given destination texture.
	 *
	 * @param {Texture} srcTexture - The source texture.
	 * @param {Texture} dstTexture - The destination texture.
	 * @param {?(Box3|Box2)} [srcRegion=null] - The region of the source texture to copy.
	 * @param {?(Vector2|Vector3)} [dstPosition=null] - The destination position of the copy.
	 * @param {number} [srcLevel=0] - The mipmap level to copy.
	 * @param {number} [dstLevel=0] - The destination mip level to copy to.
	 */ copyTextureToTexture(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = 0) {
        let dstX = 0;
        let dstY = 0;
        let dstZ = 0;
        let srcX = 0;
        let srcY = 0;
        let srcZ = 0;
        let srcWidth = srcTexture.image.width;
        let srcHeight = srcTexture.image.height;
        let srcDepth = 1;
        if (srcRegion !== null) {
            if (srcRegion.isBox3 === true) {
                srcX = srcRegion.min.x;
                srcY = srcRegion.min.y;
                srcZ = srcRegion.min.z;
                srcWidth = srcRegion.max.x - srcRegion.min.x;
                srcHeight = srcRegion.max.y - srcRegion.min.y;
                srcDepth = srcRegion.max.z - srcRegion.min.z;
            } else {
                // Assume it's a Box2
                srcX = srcRegion.min.x;
                srcY = srcRegion.min.y;
                srcWidth = srcRegion.max.x - srcRegion.min.x;
                srcHeight = srcRegion.max.y - srcRegion.min.y;
                srcDepth = 1;
            }
        }
        if (dstPosition !== null) {
            dstX = dstPosition.x;
            dstY = dstPosition.y;
            dstZ = dstPosition.z || 0;
        }
        const encoder = this.device.createCommandEncoder({
            label: 'copyTextureToTexture_' + srcTexture.id + '_' + dstTexture.id
        });
        const sourceGPU = this.get(srcTexture).texture;
        const destinationGPU = this.get(dstTexture).texture;
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            mipLevel: srcLevel,
            origin: {
                x: srcX,
                y: srcY,
                z: srcZ
            }
        }, {
            texture: destinationGPU,
            mipLevel: dstLevel,
            origin: {
                x: dstX,
                y: dstY,
                z: dstZ
            }
        }, [
            srcWidth,
            srcHeight,
            srcDepth
        ]);
        this.device.queue.submit([
            encoder.finish()
        ]);
        if (dstLevel === 0 && dstTexture.generateMipmaps) this.textureUtils.generateMipmaps(dstTexture);
    }
    /**
	 * Copies the current bound framebuffer to the given texture.
	 *
	 * @param {Texture} texture - The destination texture.
	 * @param {RenderContext} renderContext - The render context.
	 * @param {Vector4} rectangle - A four dimensional vector defining the origin and dimension of the copy.
	 */ copyFramebufferToTexture(texture, renderContext, rectangle) {
        const renderContextData = this.get(renderContext);
        let sourceGPU = null;
        if (renderContext.renderTarget) {
            if (texture.isDepthTexture) sourceGPU = this.get(renderContext.depthTexture).texture;
            else sourceGPU = this.get(renderContext.textures[0]).texture;
        } else if (texture.isDepthTexture) sourceGPU = this.textureUtils.getDepthBuffer(renderContext.depth, renderContext.stencil);
        else sourceGPU = this.context.getCurrentTexture();
        const destinationGPU = this.get(texture).texture;
        if (sourceGPU.format !== destinationGPU.format) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('WebGPUBackend: copyFramebufferToTexture: Source and destination formats do not match.', sourceGPU.format, destinationGPU.format);
            return;
        }
        let encoder;
        if (renderContextData.currentPass) {
            renderContextData.currentPass.end();
            encoder = renderContextData.encoder;
        } else encoder = this.device.createCommandEncoder({
            label: 'copyFramebufferToTexture_' + texture.id
        });
        encoder.copyTextureToTexture({
            texture: sourceGPU,
            origin: [
                rectangle.x,
                rectangle.y,
                0
            ]
        }, {
            texture: destinationGPU
        }, [
            rectangle.z,
            rectangle.w
        ]);
        // mipmaps must be genereated with the same encoder otherwise the copied texture data
        // might be out-of-sync, see #31768
        if (texture.generateMipmaps) this.textureUtils.generateMipmaps(texture, encoder);
        if (renderContextData.currentPass) {
            const { descriptor: descriptor } = renderContextData;
            for(let i = 0; i < descriptor.colorAttachments.length; i++)descriptor.colorAttachments[i].loadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            if (renderContext.depth) descriptor.depthStencilAttachment.depthLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            if (renderContext.stencil) descriptor.depthStencilAttachment.stencilLoadOp = $03ccd63b0299d6a7$var$GPULoadOp.Load;
            renderContextData.currentPass = encoder.beginRenderPass(descriptor);
            renderContextData.currentSets = {
                attributes: {},
                bindingGroups: [],
                pipeline: null,
                index: null
            };
            if (renderContext.viewport) this.updateViewport(renderContext);
            if (renderContext.scissor) this.updateScissor(renderContext);
        } else this.device.queue.submit([
            encoder.finish()
        ]);
    }
    /**
	 * Checks if the given compatibility is supported by the backend.
	 *
	 * @param {string} name - The compatibility name.
	 * @return {boolean} Whether the compatibility is supported or not.
	 */ hasCompatibility(name) {
        if (this._compatibility[name] !== undefined) return this._compatibility[name];
        return super.hasCompatibility(name);
    }
    dispose() {
        this.bindingUtils.dispose();
        this.textureUtils.dispose();
        if (this.occludedResolveCache) {
            for (const buffer of this.occludedResolveCache.values())buffer.destroy();
            this.occludedResolveCache.clear();
        }
        if (this.timestampQueryPool) {
            for (const queryPool of Object.values(this.timestampQueryPool))if (queryPool !== null) queryPool.dispose();
        }
        if (this.parameters.device === undefined && this.device !== null) this.device.destroy();
    }
}
/**
 * A IES version of {@link SpotLight}. Can only be used with {@link WebGPURenderer}.
 *
 * @augments SpotLight
 */ class $03ccd63b0299d6a7$export$667dbe87cac0f9fb extends (0, $9ddd7e9b53f7a2d4$export$81495cbb73897362) {
    /**
	 * Constructs a new IES spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance, angle, penumbra, decay){
        super(color, intensity, distance, angle, penumbra, decay);
        /**
		 * The IES map. It's a lookup table that stores normalized attenuation factors
		 * (0.0 to 1.0) that represent the light's intensity at a specific angle.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iesMap = null;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.iesMap = source.iesMap;
        return this;
    }
}
/**
 * A projector light version of {@link SpotLight}. Can only be used with {@link WebGPURenderer}.
 *
 * @augments SpotLight
 */ class $03ccd63b0299d6a7$export$89b0247b4dafcd44 extends (0, $9ddd7e9b53f7a2d4$export$81495cbb73897362) {
    /**
	 * Constructs a new projector light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance, angle, penumbra, decay){
        super(color, intensity, distance, angle, penumbra, decay);
        /**
		 * Aspect ratio of the light. Set to `null` to use the texture aspect ratio.
		 *
		 * @type {?number}
		 * @default null
		 */ this.aspect = null;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.aspect = source.aspect;
        return this;
    }
}
/**
 * This version of a node library represents the standard version
 * used in {@link WebGPURenderer}. It maps lights, tone mapping
 * techniques and materials to node-based implementations.
 *
 * @private
 * @augments NodeLibrary
 */ class $03ccd63b0299d6a7$var$StandardNodeLibrary extends $03ccd63b0299d6a7$var$NodeLibrary {
    /**
	 * Constructs a new standard node library.
	 */ constructor(){
        super();
        this.addMaterial($03ccd63b0299d6a7$export$eb6f457467ca986e, 'MeshPhongMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$92edd3f060e85562, 'MeshStandardMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$f336706882be0d39, 'MeshPhysicalMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$2dd2c8d143c7c392, 'MeshToonMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$14d4a26075247662, 'MeshBasicMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$ca28182707938248, 'MeshLambertMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$57e770545986d2b1, 'MeshNormalMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$f7d65f3d82d7b0b0, 'MeshMatcapMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$511219d03f927a3f, 'LineBasicMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$19c85750bbe979a0, 'LineDashedMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$986cd66fa4ca801b, 'PointsMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$80f4e36249294380, 'SpriteMaterial');
        this.addMaterial($03ccd63b0299d6a7$export$6ba7483788b75e55, 'ShadowMaterial');
        this.addLight($03ccd63b0299d6a7$export$8613ba691750588b, (0, $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455));
        this.addLight($03ccd63b0299d6a7$export$6e67a8efcfed4d14, (0, $9ddd7e9b53f7a2d4$export$3fea33cc9972c868));
        this.addLight($03ccd63b0299d6a7$export$1029ea47a4dd9399, (0, $9ddd7e9b53f7a2d4$export$61db2d908bbd2429));
        this.addLight($03ccd63b0299d6a7$export$df1aa5fd66541854, (0, $9ddd7e9b53f7a2d4$export$81495cbb73897362));
        this.addLight($03ccd63b0299d6a7$export$ade3bbc96c5c4bf1, (0, $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96));
        this.addLight($03ccd63b0299d6a7$export$8c237e4e9b54f548, (0, $9ddd7e9b53f7a2d4$export$8d474f55edbb9624));
        this.addLight($03ccd63b0299d6a7$export$c2c4ca9136f2b869, (0, $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2));
        this.addLight($03ccd63b0299d6a7$export$5d7cdca61c24be58, $03ccd63b0299d6a7$export$667dbe87cac0f9fb);
        this.addLight($03ccd63b0299d6a7$export$e6df2aceb76fe9a0, $03ccd63b0299d6a7$export$89b0247b4dafcd44);
        this.addToneMapping($03ccd63b0299d6a7$var$linearToneMapping, (0, $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca));
        this.addToneMapping($03ccd63b0299d6a7$var$reinhardToneMapping, (0, $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548));
        this.addToneMapping($03ccd63b0299d6a7$var$cineonToneMapping, (0, $9ddd7e9b53f7a2d4$export$932b3dd283d4a366));
        this.addToneMapping($03ccd63b0299d6a7$var$acesFilmicToneMapping, (0, $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64));
        this.addToneMapping($03ccd63b0299d6a7$var$agxToneMapping, (0, $9ddd7e9b53f7a2d4$export$212d53a513a325b2));
        this.addToneMapping($03ccd63b0299d6a7$var$neutralToneMapping, (0, $9ddd7e9b53f7a2d4$export$f2863e1668a8e317));
    }
}
/*
const debugHandler = {

	get: function ( target, name ) {

		// Add |update
		if ( /^(create|destroy)/.test( name ) ) log( 'WebGPUBackend.' + name );

		return target[ name ];

	}

};
*/ /**
 * This renderer is the new alternative of `WebGLRenderer`. `WebGPURenderer` has the ability
 * to target different backends. By default, the renderer tries to use a WebGPU backend if the
 * browser supports WebGPU. If not, `WebGPURenderer` falls backs to a WebGL 2 backend.
 *
 * @augments Renderer
 */ class $03ccd63b0299d6a7$export$19fd8015bd4822d4 extends $03ccd63b0299d6a7$var$Renderer {
    /**
	 * WebGPURenderer options.
	 *
	 * @typedef {Object} WebGPURenderer~Options
	 * @property {boolean} [logarithmicDepthBuffer=false] - Whether logarithmic depth buffer is enabled or not.
	 * @property {boolean} [reversedDepthBuffer=false] - Whether reversed depth buffer is enabled or not.
	 * @property {boolean} [alpha=true] - Whether the default framebuffer (which represents the final contents of the canvas) should be transparent or opaque.
	 * @property {boolean} [depth=true] - Whether the default framebuffer should have a depth buffer or not.
	 * @property {boolean} [stencil=false] - Whether the default framebuffer should have a stencil buffer or not.
	 * @property {boolean} [antialias=false] - Whether MSAA as the default anti-aliasing should be enabled or not.
	 * @property {number} [samples=0] - When `antialias` is `true`, `4` samples are used by default. Set this parameter to any other integer value than 0 to overwrite the default.
	 * @property {boolean} [forceWebGL=false] - If set to `true`, the renderer uses a WebGL 2 backend no matter if WebGPU is supported or not.
	 * @property {boolean} [multiview=false] - If set to `true`, the renderer will use multiview during WebXR rendering if supported.
	 * @property {number} [outputType=undefined] - Texture type for output to canvas. By default, device's preferred format is used; other formats may incur overhead.
	 * @property {number} [outputBufferType=HalfFloatType] - Defines the type of output buffers. The default `HalfFloatType` is recommend for best
	 * quality. To save memory and bandwidth, `UnsignedByteType` might be used. This will reduce rendering quality though.
	 */ /**
	 * Constructs a new WebGPU renderer.
	 *
	 * @param {WebGPURenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        let BackendClass;
        if (parameters.forceWebGL) BackendClass = $03ccd63b0299d6a7$export$5356cb3ea4262d92;
        else {
            BackendClass = $03ccd63b0299d6a7$export$6f9bc39baf8c093a;
            parameters.getFallback = ()=>{
                (0, $9ddd7e9b53f7a2d4$export$c106dd0671a0fc2d)('WebGPURenderer: WebGPU is not available, running under WebGL2 backend.');
                return new $03ccd63b0299d6a7$export$5356cb3ea4262d92(parameters);
            };
        }
        const backend = new BackendClass(parameters);
        //super( new Proxy( backend, debugHandler ) );
        super(backend, parameters);
        /**
		 * The generic default value is overwritten with the
		 * standard node library for type mapping.
		 *
		 * @type {StandardNodeLibrary}
		 */ this.library = new $03ccd63b0299d6a7$var$StandardNodeLibrary();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGPURenderer = true;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
}
/**
 * A specialized group which enables applications access to the
 * Render Bundle API of WebGPU. The group with all its descendant nodes
 * are considered as one render bundle and processed as such by
 * the renderer.
 *
 * This module is only fully supported by `WebGPURenderer` with a WebGPU backend.
 * With a WebGL backend, the group can technically be rendered but without
 * any performance improvements.
 *
 * @augments Group
 */ class $03ccd63b0299d6a7$export$e04febd15a99bd94 extends (0, $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4) {
    /**
	 * Constructs a new bundle group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBundleGroup = true;
        /**
		 * This property is only relevant for detecting types
		 * during serialization/deserialization. It should always
		 * match the class name.
		 *
		 * @type {string}
		 * @readonly
		 * @default 'BundleGroup'
		 */ this.type = 'BundleGroup';
        /**
		 * Whether the bundle is static or not. When set to `true`, the structure
		 * is assumed to be static and does not change. E.g. no new objects are
		 * added to the group.
		 *
		 * If a change is required, an update can still be forced by setting the
		 * `needsUpdate` flag to `true`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.static = true;
        /**
		 * The bundle group's version.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Set this property to `true` when the bundle group has changed.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * This module is responsible to manage the rendering pipeline setups in apps.
 * You usually create a single instance of this class and use it to define
 * the output of your render pipeline and post processing effect chain.
 * ```js
 * const renderPipeline = new RenderPipeline( renderer );
 *
 * const scenePass = pass( scene, camera );
 *
 * renderPipeline.outputNode = scenePass;
 * ```
 *
 * Note: This module can only be used with `WebGPURenderer`.
 */ class $03ccd63b0299d6a7$export$52ff0c46af33b1fd {
    /**
	 * Constructs a new render pipeline management module.
	 *
	 * @param {Renderer} renderer - A reference to the renderer.
	 * @param {Node<vec4>} outputNode - An optional output node.
	 */ constructor(renderer, outputNode = $03ccd63b0299d6a7$var$vec4(0, 0, 1, 1)){
        /**
		 * A reference to the renderer.
		 *
		 * @type {Renderer}
		 */ this.renderer = renderer;
        /**
		 * A node which defines the final output of the rendering
		 * pipeline. This is usually the last node in a chain
		 * of effect nodes.
		 *
		 * @type {Node<vec4>}
		 */ this.outputNode = outputNode;
        /**
		 * Whether the default output tone mapping and color
		 * space transformation should be enabled or not.
		 *
		 * This is enabled by default but it must be disabled for
		 * effects that expect to be executed after tone mapping and color
		 * space conversion. A typical example is FXAA which
		 * requires sRGB input.
		 *
		 * When set to `false`, the app must control the output
		 * transformation with `RenderOutputNode`.
		 *
		 * ```js
		 * const outputPass = renderOutput( scenePass );
		 * ```
		 *
		 * @type {boolean}
		 */ this.outputColorTransform = true;
        /**
		 * Must be set to `true` when the output node changes.
		 *
		 * @type {Node<vec4>}
		 */ this.needsUpdate = true;
        const material = new $03ccd63b0299d6a7$export$caaf3b30a544c946();
        material.name = 'RenderPipeline';
        /**
		 * The full screen quad that is used to render
		 * the effects.
		 *
		 * @private
		 * @type {QuadMesh}
		 */ this._quadMesh = new $03ccd63b0299d6a7$export$266ce19fe399ee9a(material);
        this._quadMesh.name = 'Render Pipeline';
        /**
		 * The context of the render pipeline stack.
		 *
		 * @private
		 * @type {?Object}
		 * @default null
		 */ this._context = null;
        /**
		 * The current tone mapping.
		 *
		 * @private
		 * @type {ToneMapping}
		 */ this._toneMapping = renderer.toneMapping;
        /**
		 * The current output color space.
		 *
		 * @private
		 * @type {ColorSpace}
		 */ this._outputColorSpace = renderer.outputColorSpace;
    }
    /**
	 * When `RenderPipeline` is used to apply rendering pipeline and post processing effects,
	 * the application must use this version of `render()` inside
	 * its animation loop (not the one from the renderer).
	 */ render() {
        const renderer = this.renderer;
        this._update();
        if (this._context.onBeforeRenderPipeline !== null) this._context.onBeforeRenderPipeline();
        const toneMapping = renderer.toneMapping;
        const outputColorSpace = renderer.outputColorSpace;
        renderer.toneMapping = (0, $9ddd7e9b53f7a2d4$export$9fcb6b4294603b2);
        renderer.outputColorSpace = (0, $9ddd7e9b53f7a2d4$export$5e6fd513f44698c).workingColorSpace;
        //
        const currentXR = renderer.xr.enabled;
        renderer.xr.enabled = false;
        this._quadMesh.render(renderer);
        renderer.xr.enabled = currentXR;
        //
        renderer.toneMapping = toneMapping;
        renderer.outputColorSpace = outputColorSpace;
        if (this._context.onAfterRenderPipeline !== null) this._context.onAfterRenderPipeline();
    }
    /**
	 * Returns the current context of the render pipeline stack.
	 *
	 * @readonly
	 * @type {?Object}
	 */ get context() {
        return this._context;
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this._quadMesh.material.dispose();
    }
    /**
	 * Updates the state of the module.
	 *
	 * @private
	 */ _update() {
        if (this._toneMapping !== this.renderer.toneMapping) {
            this._toneMapping = this.renderer.toneMapping;
            this.needsUpdate = true;
        }
        if (this._outputColorSpace !== this.renderer.outputColorSpace) {
            this._outputColorSpace = this.renderer.outputColorSpace;
            this.needsUpdate = true;
        }
        if (this.needsUpdate === true) {
            const toneMapping = this._toneMapping;
            const outputColorSpace = this._outputColorSpace;
            const context = {
                renderPipeline: this,
                onBeforeRenderPipeline: null,
                onAfterRenderPipeline: null
            };
            let outputNode = this.outputNode;
            if (this.outputColorTransform === true) {
                outputNode = outputNode.context(context);
                outputNode = $03ccd63b0299d6a7$var$renderOutput(outputNode, toneMapping, outputColorSpace);
            } else {
                context.toneMapping = toneMapping;
                context.outputColorSpace = outputColorSpace;
                outputNode = outputNode.context(context);
            }
            this._context = context;
            this._quadMesh.material.fragmentNode = outputNode;
            this._quadMesh.material.needsUpdate = true;
            this.needsUpdate = false;
        }
    }
    /**
	 * When `RenderPipeline` is used to apply rendering pipeline and post processing effects,
	 * the application must use this version of `renderAsync()` inside
	 * its animation loop (not the one from the renderer).
	 *
	 * @async
	 * @deprecated
	 * @return {Promise} A Promise that resolves when the render has been finished.
	 */ async renderAsync() {
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('RenderPipeline: "renderAsync()" has been deprecated. Use "render()" and "await renderer.init();" when creating the renderer.'); // @deprecated r181
        await this.renderer.init();
        this.render();
    }
}
/**
 * @deprecated since r183. Use {@link RenderPipeline} instead. PostProcessing has been renamed to RenderPipeline.
 *
 * This class is a wrapper for backward compatibility and will be removed in a future version.
 */ class $03ccd63b0299d6a7$export$6eafee11db0bd883 extends $03ccd63b0299d6a7$export$52ff0c46af33b1fd {
    /**
	 * Constructs a new post processing management module.
	 *
	 * @param {Renderer} renderer - A reference to the renderer.
	 * @param {Node<vec4>} outputNode - An optional output node.
	 * @deprecated since r183. Use {@link RenderPipeline} instead.
	 */ constructor(renderer, outputNode){
        (0, $9ddd7e9b53f7a2d4$export$5b28268982f175ba)('PostProcessing: "PostProcessing" has been renamed to "RenderPipeline". Please update your code to use "THREE.RenderPipeline" instead.'); // @deprecated, r183
        super(renderer, outputNode);
    }
}
/**
 * A readback buffer is used to transfer data from the GPU to the CPU.
 * It is primarily used to read back compute shader results.
 *
 * @augments EventDispatcher
 */ class $03ccd63b0299d6a7$export$e7e7fb441012524 extends (0, $9ddd7e9b53f7a2d4$export$ec8b666c5fe2c75a) {
    /**
	 * Constructs a new readback buffer.
	 *
	 * @param {number} maxByteLength - The maximum size of the buffer to be read back.
	 */ constructor(maxByteLength){
        super();
        /**
		 * Name used for debugging purposes.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The mapped, read back array buffer.
		 *
		 * @type {ArrayBuffer|null}
		 */ this.buffer = null;
        /**
		 * The maximum size of the buffer to be read back.
		 *
		 * @type {number}
		 */ this.maxByteLength = maxByteLength;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isReadbackBuffer = true;
        this._mapped = false;
    }
    /**
	 * Releases the mapped buffer data so the GPU buffer can be
	 * used by the GPU again.
	 *
	 * Note: Any `ArrayBuffer` data associated with this readback buffer
	 * are removed and no longer accessible after calling this method.
	 */ release() {
        this.dispatchEvent({
            type: 'release'
        });
    }
    /**
	 * Frees internal resources.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $03ccd63b0299d6a7$export$31c2478de2390334 extends (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 */ constructor(width = 1, height = 1){
        super();
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
        /**
		 * When `true`, mipmaps will be auto-generated after compute writes.
		 * When `false`, mipmaps must be written manually via compute shaders.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.mipmapsAutoUpdate = true;
    }
    /**
	 * Sets the size of the storage texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 */ setSize(width, height) {
        if (this.image.width !== width || this.image.height !== height) {
            this.image.width = width;
            this.image.height = height;
            this.dispose();
        }
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $03ccd63b0299d6a7$export$8372ed547e6486b6 extends (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 * @param {number} [depth=1] - The storage texture's depth.
	 */ constructor(width = 1, height = 1, depth = 1){
        super();
        //inherited from texture. Must be false for 3DTexture
        this.isArrayTexture = false;
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number, depth: number}}
		 */ this.image = {
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * This defines how the texture is wrapped in the depth direction and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {number}
		 */ this.wrapR = (0, $9ddd7e9b53f7a2d4$export$9d9334239a5a5e06);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
        /**
		 * Indicates whether this texture is a 3D texture.
		 *
		 * @type {boolean}
		 *
		 */ this.is3DTexture = true;
    }
    /**
	 * Sets the size of the storage 3d texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 * @param {number} depth - The new depth of the storage texture.
	 */ setSize(width, height, depth) {
        if (this.image.width !== width || this.image.height !== height || this.image.depth !== depth) {
            this.image.width = width;
            this.image.height = height;
            this.image.depth = depth;
            this.dispose();
        }
    }
}
/**
 * This special type of texture is intended for compute shaders.
 * It can be used to compute the data of a texture with a compute shader.
 *
 * Note: This type of texture can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments Texture
 */ class $03ccd63b0299d6a7$export$3c647e796d9064bc extends (0, $9ddd7e9b53f7a2d4$export$5431306cf43de24a) {
    /**
	 * Constructs a new storage texture.
	 *
	 * @param {number} [width=1] - The storage texture's width.
	 * @param {number} [height=1] - The storage texture's height.
	 * @param {number} [depth=1] - The storage texture's depth.
	 */ constructor(width = 1, height = 1, depth = 1){
        super();
        //inherited from texture
        this.isArrayTexture = true;
        /**
		 * The image object which just represents the texture's dimension.
		 *
		 * @type {{width: number, height: number, depth: number}}
		 */ this.image = {
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * The default `magFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.magFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * The default `minFilter` for storage textures is `THREE.LinearFilter`.
		 *
		 * @type {number}
		 */ this.minFilter = (0, $9ddd7e9b53f7a2d4$export$8a72f490b25c56c8);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isStorageTexture = true;
    }
    /**
	 * Sets the size of the storage array texture.
	 *
	 * @param {number} width - The new width of the storage texture.
	 * @param {number} height - The new height of the storage texture.
	 * @param {number} depth - The new depth of the storage texture.
	 */ setSize(width, height, depth) {
        if (this.image.width !== width || this.image.height !== height || this.image.depth !== depth) {
            this.image.width = width;
            this.image.height = height;
            this.image.depth = depth;
            this.dispose();
        }
    }
}
/**
 * This special type of buffer attribute is intended for compute shaders.
 * It can be used to encode draw parameters for indirect draw calls.
 *
 * Note: This type of buffer attribute can only be used with `WebGPURenderer`
 * and a WebGPU backend.
 *
 * @augments StorageBufferAttribute
 */ class $03ccd63b0299d6a7$export$5f124751e00a3c7e extends $03ccd63b0299d6a7$export$5eb1a076d3725e22 {
    /**
	 * Constructs a new storage buffer attribute.
	 *
	 * @param {number|Uint32Array} count - The item count. It is also valid to pass a `Uint32Array` as an argument.
	 * The subsequent parameter is then obsolete.
	 * @param {number} itemSize - The item size.
	 */ constructor(count, itemSize){
        super(count, itemSize, Uint32Array);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isIndirectStorageBufferAttribute = true;
    }
}
/**
 * A loader for loading node objects in the three.js JSON Object/Scene format.
 *
 * @augments Loader
 */ class $03ccd63b0299d6a7$export$f768aec11625a454 extends (0, $9ddd7e9b53f7a2d4$export$3b0d6d7590275603) {
    /**
	 * Constructs a new node loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of textures.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
    }
    /**
	 * Loads the node definitions from the given URL.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Will be called when load completes.
	 * @param {Function} onProgress - Will be called while load progresses.
	 * @param {Function} onError - Will be called when errors are thrown during the loading process.
	 */ load(url, onLoad, onProgress, onError) {
        const loader = new (0, $9ddd7e9b53f7a2d4$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (text)=>{
            try {
                onLoad(this.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)(e);
                this.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parse the node dependencies for the loaded node.
	 *
	 * @param {Array<Object>} [json] - The JSON definition
	 * @return {Object<string,Node>} A dictionary with node dependencies.
	 */ parseNodes(json) {
        const nodes = {};
        if (json !== undefined) {
            for (const nodeJSON of json){
                const { uuid: uuid, type: type } = nodeJSON;
                nodes[uuid] = this.createNodeFromType(type);
                nodes[uuid].uuid = uuid;
            }
            const meta = {
                nodes: nodes,
                textures: this.textures
            };
            for (const nodeJSON of json){
                nodeJSON.meta = meta;
                const node = nodes[nodeJSON.uuid];
                node.deserialize(nodeJSON);
                delete nodeJSON.meta;
            }
        }
        return nodes;
    }
    /**
	 * Parses the node from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {string} json.type - The node type.
	 * @param {string} json.uuid - The node UUID.
	 * @param {Array<Object>} [json.nodes] - The node dependencies.
	 * @param {Object} [json.meta] - The meta data.
	 * @return {Node} The parsed node.
	 */ parse(json) {
        const node = this.createNodeFromType(json.type);
        node.uuid = json.uuid;
        const nodes = this.parseNodes(json.nodes);
        const meta = {
            nodes: nodes,
            textures: this.textures
        };
        json.meta = meta;
        node.deserialize(json);
        delete json.meta;
        return node;
    }
    /**
	 * Defines the dictionary of textures.
	 *
	 * @param {Object<string,Texture>} value - The texture library defines as `<uuid,texture>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Creates a node object from the given type.
	 *
	 * @param {string} type - The node type.
	 * @return {Node} The created node instance.
	 */ createNodeFromType(type) {
        if (this.nodes[type] === undefined) {
            (0, $9ddd7e9b53f7a2d4$export$a3bc9b8ed74fc)('NodeLoader: Node type not found:', type);
            return $03ccd63b0299d6a7$var$float();
        }
        return new this.nodes[type]();
    }
}
/**
 * A special type of material loader for loading node materials.
 *
 * @augments MaterialLoader
 */ class $03ccd63b0299d6a7$export$2cf76db1a8c42c86 extends (0, $9ddd7e9b53f7a2d4$export$3bd6d323353dcf96) {
    /**
	 * Constructs a new node material loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
        /**
		 * Represents a dictionary of node material types.
		 *
		 * @type {Object<string,NodeMaterial.constructor>}
		 */ this.nodeMaterials = {};
    }
    /**
	 * Parses the node material from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @return {NodeMaterial}. The parsed material.
	 */ parse(json) {
        const material = super.parse(json);
        const nodes = this.nodes;
        const inputNodes = json.inputNodes;
        for(const property in inputNodes){
            const uuid = inputNodes[property];
            material[property] = nodes[uuid];
        }
        return material;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Defines the dictionary of node material types.
	 *
	 * @param {Object<string,NodeMaterial.constructor>} value - The node material library defined as `<classname,class>`.
	 * @return {NodeLoader} A reference to this loader.
	 */ setNodeMaterials(value) {
        this.nodeMaterials = value;
        return this;
    }
    /**
	 * Creates a node material from the given type.
	 *
	 * @param {string} type - The node material type.
	 * @return {Node} The created node material instance.
	 */ createMaterialFromType(type) {
        const materialClass = this.nodeMaterials[type];
        if (materialClass !== undefined) return new materialClass();
        return super.createMaterialFromType(type);
    }
}
/**
 * A special type of object loader for loading 3D objects using
 * node materials.
 *
 * @augments ObjectLoader
 */ class $03ccd63b0299d6a7$export$e6dfc9c3655ca55d extends (0, $9ddd7e9b53f7a2d4$export$40110c8505c5ad19) {
    /**
	 * Constructs a new node object loader.
	 *
	 * @param {LoadingManager} [manager] - A reference to a loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * Represents a dictionary of node types.
		 *
		 * @type {Object<string,Node.constructor>}
		 */ this.nodes = {};
        /**
		 * Represents a dictionary of node material types.
		 *
		 * @type {Object<string,NodeMaterial.constructor>}
		 */ this.nodeMaterials = {};
        /**
		 * A reference to hold the `nodes` JSON property.
		 *
		 * @private
		 * @type {?Object[]}
		 */ this._nodesJSON = null;
    }
    /**
	 * Defines the dictionary of node types.
	 *
	 * @param {Object<string,Node.constructor>} value - The node library defined as `<classname,class>`.
	 * @return {NodeObjectLoader} A reference to this loader.
	 */ setNodes(value) {
        this.nodes = value;
        return this;
    }
    /**
	 * Defines the dictionary of node material types.
	 *
	 * @param {Object<string,NodeMaterial.constructor>} value - The node material library defined as `<classname,class>`.
	 * @return {NodeObjectLoader} A reference to this loader.
	 */ setNodeMaterials(value) {
        this.nodeMaterials = value;
        return this;
    }
    /**
	 * Parses the node objects from the given JSON.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {Function} onLoad - The onLoad callback function.
	 * @return {Object3D}. The parsed 3D object.
	 */ parse(json, onLoad) {
        this._nodesJSON = json.nodes;
        const data = super.parse(json, onLoad);
        this._nodesJSON = null; // dispose
        return data;
    }
    /**
	 * Async version of {@link NodeObjectLoader#parse}.
	 *
	 * @param {Object} json - The JSON definition
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        this._nodesJSON = json.nodes;
        const data = await super.parseAsync(json);
        this._nodesJSON = null; // dispose
        return data;
    }
    /**
	 * Parses the node objects from the given JSON and textures.
	 *
	 * @param {Object[]} json - The JSON definition
	 * @param {Object<string,Texture>} textures - The texture library.
	 * @return {Object<string,Node>}. The parsed nodes.
	 */ parseNodes(json, textures) {
        if (json !== undefined) {
            const loader = new $03ccd63b0299d6a7$export$f768aec11625a454();
            loader.setNodes(this.nodes);
            loader.setTextures(textures);
            return loader.parseNodes(json);
        }
        return {};
    }
    /**
	 * Parses the node objects from the given JSON and textures.
	 *
	 * @param {Object} json - The JSON definition
	 * @param {Object<string,Texture>} textures - The texture library.
	 * @return {Object<string,NodeMaterial>}. The parsed materials.
	 */ parseMaterials(json, textures) {
        const materials = {};
        if (json !== undefined) {
            const nodes = this.parseNodes(this._nodesJSON, textures);
            const loader = new $03ccd63b0299d6a7$export$2cf76db1a8c42c86();
            loader.setTextures(textures);
            loader.setNodes(nodes);
            loader.setNodeMaterials(this.nodeMaterials);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                materials[data.uuid] = loader.parse(data);
            }
        }
        return materials;
    }
}
/**
 * This version of a node library represents a basic version
 * just focusing on lights and tone mapping techniques.
 *
 * @private
 * @augments NodeLibrary
 */ class $03ccd63b0299d6a7$export$e6f06f5d1e446748 extends $03ccd63b0299d6a7$var$NodeLibrary {
    /**
	 * Constructs a new basic node library.
	 */ constructor(){
        super();
        this.addLight($03ccd63b0299d6a7$export$8613ba691750588b, (0, $9ddd7e9b53f7a2d4$export$4c9c1cb3f0b6f455));
        this.addLight($03ccd63b0299d6a7$export$6e67a8efcfed4d14, (0, $9ddd7e9b53f7a2d4$export$3fea33cc9972c868));
        this.addLight($03ccd63b0299d6a7$export$1029ea47a4dd9399, (0, $9ddd7e9b53f7a2d4$export$61db2d908bbd2429));
        this.addLight($03ccd63b0299d6a7$export$df1aa5fd66541854, (0, $9ddd7e9b53f7a2d4$export$81495cbb73897362));
        this.addLight($03ccd63b0299d6a7$export$ade3bbc96c5c4bf1, (0, $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96));
        this.addLight($03ccd63b0299d6a7$export$8c237e4e9b54f548, (0, $9ddd7e9b53f7a2d4$export$8d474f55edbb9624));
        this.addLight($03ccd63b0299d6a7$export$c2c4ca9136f2b869, (0, $9ddd7e9b53f7a2d4$export$e7ef036e309b38d2));
        this.addLight($03ccd63b0299d6a7$export$5d7cdca61c24be58, $03ccd63b0299d6a7$export$667dbe87cac0f9fb);
        this.addLight($03ccd63b0299d6a7$export$e6df2aceb76fe9a0, $03ccd63b0299d6a7$export$89b0247b4dafcd44);
        this.addToneMapping($03ccd63b0299d6a7$var$linearToneMapping, (0, $9ddd7e9b53f7a2d4$export$98f52c2a46c598ca));
        this.addToneMapping($03ccd63b0299d6a7$var$reinhardToneMapping, (0, $9ddd7e9b53f7a2d4$export$74b25e54b3bcd548));
        this.addToneMapping($03ccd63b0299d6a7$var$cineonToneMapping, (0, $9ddd7e9b53f7a2d4$export$932b3dd283d4a366));
        this.addToneMapping($03ccd63b0299d6a7$var$acesFilmicToneMapping, (0, $9ddd7e9b53f7a2d4$export$a0d98fe6d7e4af64));
        this.addToneMapping($03ccd63b0299d6a7$var$agxToneMapping, (0, $9ddd7e9b53f7a2d4$export$212d53a513a325b2));
        this.addToneMapping($03ccd63b0299d6a7$var$neutralToneMapping, (0, $9ddd7e9b53f7a2d4$export$f2863e1668a8e317));
    }
}
/**
 * In earlier three.js versions, clipping was defined globally
 * on the renderer or on material level. This special version of
 * `THREE.Group` allows to encode the clipping state into the scene
 * graph. Meaning if you create an instance of this group, all
 * descendant 3D objects will be affected by the respective clipping
 * planes.
 *
 * Note: `ClippingGroup` can only be used with `WebGPURenderer`.
 *
 * @augments Group
 */ class $03ccd63b0299d6a7$export$f4cfbc80e09ad28c extends (0, $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4) {
    /**
	 * Constructs a new clipping group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isClippingGroup = true;
        /**
		 * An array with clipping planes.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether clipping should be enabled or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * Whether the intersection of the clipping planes is used to clip objects, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Whether shadows should be clipped or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
    }
}



/**
 * Fires when the camera has been transformed by the controls.
 *
 * @event TrackballControls#change
 * @type {Object}
 */ const $164afa34e4b04624$var$_changeEvent = {
    type: 'change'
};
/**
 * Fires when an interaction was initiated.
 *
 * @event TrackballControls#start
 * @type {Object}
 */ const $164afa34e4b04624$var$_startEvent = {
    type: 'start'
};
/**
 * Fires when an interaction has finished.
 *
 * @event TrackballControls#end
 * @type {Object}
 */ const $164afa34e4b04624$var$_endEvent = {
    type: 'end'
};
const $164afa34e4b04624$var$_EPS = 0.000001;
const $164afa34e4b04624$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    ZOOM: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_ZOOM_PAN: 4
};
const $164afa34e4b04624$var$_v2 = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $164afa34e4b04624$var$_mouseChange = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
const $164afa34e4b04624$var$_objectUp = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_pan = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_axis = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_quaternion = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)();
const $164afa34e4b04624$var$_eyeDirection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_objectUpDirection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_objectSidewaysDirection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $164afa34e4b04624$var$_moveDirection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
/**
 * This class is similar to {@link OrbitControls}. However, it does not maintain a constant camera
 * `up` vector. That means if the camera orbits over the “north” and “south” poles, it does not flip
 * to stay "right side up".
 *
 * @augments Controls
 * @three_import import { TrackballControls } from 'three/addons/controls/TrackballControls.js';
 */ class $164afa34e4b04624$export$18b7f869be764a91 extends (0, $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f) {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super(object, domElement);
        /**
		 * Represents the properties of the screen. Automatically set when `handleResize()` is called.
		 *
		 * @type {Object}
		 * @readonly
		 */ this.screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
        /**
		 * The rotation speed.
		 *
		 * @type {number}
		 * @default 1
		 */ this.rotateSpeed = 1.0;
        /**
		 * The zoom speed.
		 *
		 * @type {number}
		 * @default 1.2
		 */ this.zoomSpeed = 1.2;
        /**
		 * The pan speed.
		 *
		 * @type {number}
		 * @default 0.3
		 */ this.panSpeed = 0.3;
        /**
		 * Whether rotation is disabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.noRotate = false;
        /**
		 * Whether zooming is disabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.noZoom = false;
        /**
		 * Whether panning is disabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.noPan = false;
        /**
		 * Whether damping is disabled or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.staticMoving = false;
        /**
		 * Defines the intensity of damping. Only considered if `staticMoving` is set to `false`.
		 *
		 * @type {number}
		 * @default 0.2
		 */ this.dynamicDampingFactor = 0.2;
        /**
		 * How far you can dolly in (perspective camera only).
		 *
		 * @type {number}
		 * @default 0
		 */ this.minDistance = 0;
        /**
		 * How far you can dolly out (perspective camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.maxDistance = Infinity;
        /**
		 * How far you can zoom in (orthographic camera only).
		 *
		 * @type {number}
		 * @default 0
		 */ this.minZoom = 0;
        /**
		 * How far you can zoom out (orthographic camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.maxZoom = Infinity;
        /**
		 * This array holds keycodes for controlling interactions.
		 *
		 * - When the first defined key is pressed, all mouse interactions (left, middle, right) performs orbiting.
		 * - When the second defined key is pressed, all mouse interactions (left, middle, right) performs zooming.
		 * - When the third defined key is pressed, all mouse interactions (left, middle, right) performs panning.
		 *
		 * Default is *KeyA, KeyS, KeyD* which represents A, S, D.
		 *
		 * @type {Array<string>}
		 */ this.keys = [
            'KeyA' /*A*/ ,
            'KeyS' /*S*/ ,
            'KeyD' /*D*/ 
        ];
        /**
		 * This object contains references to the mouse actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	LEFT: THREE.MOUSE.ROTATE,
		 * 	MIDDLE: THREE.MOUSE.DOLLY,
		 * 	RIGHT: THREE.MOUSE.PAN
		 * }
		 * ```
		 * @type {Object}
		 */ this.mouseButtons = {
            LEFT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN
        };
        /**
		 * The focus point of the controls.
		 *
		 * @type {Vector3}
		 */ this.target = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        // internals
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this._lastPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._lastZoom = 1;
        this._touchZoomDistanceStart = 0;
        this._touchZoomDistanceEnd = 0;
        this._lastAngle = 0;
        this._eye = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._movePrev = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._moveCurr = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._lastAxis = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._zoomStart = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._zoomEnd = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._panStart = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._pointers = [];
        this._pointerPositions = {};
        // event listeners
        this._onPointerMove = $164afa34e4b04624$var$onPointerMove.bind(this);
        this._onPointerDown = $164afa34e4b04624$var$onPointerDown.bind(this);
        this._onPointerUp = $164afa34e4b04624$var$onPointerUp.bind(this);
        this._onPointerCancel = $164afa34e4b04624$var$onPointerCancel.bind(this);
        this._onContextMenu = $164afa34e4b04624$var$onContextMenu.bind(this);
        this._onMouseWheel = $164afa34e4b04624$var$onMouseWheel.bind(this);
        this._onKeyDown = $164afa34e4b04624$var$onKeyDown.bind(this);
        this._onKeyUp = $164afa34e4b04624$var$onKeyUp.bind(this);
        this._onTouchStart = $164afa34e4b04624$var$onTouchStart.bind(this);
        this._onTouchMove = $164afa34e4b04624$var$onTouchMove.bind(this);
        this._onTouchEnd = $164afa34e4b04624$var$onTouchEnd.bind(this);
        this._onMouseDown = $164afa34e4b04624$var$onMouseDown.bind(this);
        this._onMouseMove = $164afa34e4b04624$var$onMouseMove.bind(this);
        this._onMouseUp = $164afa34e4b04624$var$onMouseUp.bind(this);
        // for reset
        this._target0 = this.target.clone();
        this._position0 = this.object.position.clone();
        this._up0 = this.object.up.clone();
        this._zoom0 = this.object.zoom;
        if (domElement !== null) {
            this.connect(domElement);
            this.handleResize();
        }
        // force an update at start
        this.update();
    }
    connect(element) {
        super.connect(element);
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('keyup', this._onKeyUp);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerCancel);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // Disable touch scroll
    }
    disconnect() {
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('keyup', this._onKeyUp);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerCancel);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = ''; // Restore touch scroll
    }
    dispose() {
        this.disconnect();
    }
    /**
	 * Must be called if the application window is resized.
	 */ handleResize() {
        const box = this.domElement.getBoundingClientRect();
        // adjustments come from similar code in the jquery offset() function
        const d = this.domElement.ownerDocument.documentElement;
        this.screen.left = box.left + window.pageXOffset - d.clientLeft;
        this.screen.top = box.top + window.pageYOffset - d.clientTop;
        this.screen.width = box.width;
        this.screen.height = box.height;
    }
    update() {
        this._eye.subVectors(this.object.position, this.target);
        if (!this.noRotate) this._rotateCamera();
        if (!this.noZoom) this._zoomCamera();
        if (!this.noPan) this._panCamera();
        this.object.position.addVectors(this.target, this._eye);
        if (this.object.isPerspectiveCamera) {
            this._checkDistances();
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
            }
        } else if (this.object.isOrthographicCamera) {
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS || this._lastZoom !== this.object.zoom) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
                this._lastZoom = this.object.zoom;
            }
        } else console.warn('THREE.TrackballControls: Unsupported camera type.');
    }
    /**
	 * Resets the controls to its initial state.
	 */ reset() {
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this.target.copy(this._target0);
        this.object.position.copy(this._position0);
        this.object.up.copy(this._up0);
        this.object.zoom = this._zoom0;
        this.object.updateProjectionMatrix();
        this._eye.subVectors(this.object.position, this.target);
        this.object.lookAt(this.target);
        this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
        this._lastPosition.copy(this.object.position);
        this._lastZoom = this.object.zoom;
    }
    _panCamera() {
        $164afa34e4b04624$var$_mouseChange.copy(this._panEnd).sub(this._panStart);
        if ($164afa34e4b04624$var$_mouseChange.lengthSq()) {
            if (this.object.isOrthographicCamera) {
                const scale_x = (this.object.right - this.object.left) / this.object.zoom / this.domElement.clientWidth;
                const scale_y = (this.object.top - this.object.bottom) / this.object.zoom / this.domElement.clientWidth;
                $164afa34e4b04624$var$_mouseChange.x *= scale_x;
                $164afa34e4b04624$var$_mouseChange.y *= scale_y;
            }
            $164afa34e4b04624$var$_mouseChange.multiplyScalar(this._eye.length() * this.panSpeed);
            $164afa34e4b04624$var$_pan.copy(this._eye).cross(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.x);
            $164afa34e4b04624$var$_pan.add($164afa34e4b04624$var$_objectUp.copy(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.y));
            this.object.position.add($164afa34e4b04624$var$_pan);
            this.target.add($164afa34e4b04624$var$_pan);
            if (this.staticMoving) this._panStart.copy(this._panEnd);
            else this._panStart.add($164afa34e4b04624$var$_mouseChange.subVectors(this._panEnd, this._panStart).multiplyScalar(this.dynamicDampingFactor));
        }
    }
    _rotateCamera() {
        $164afa34e4b04624$var$_moveDirection.set(this._moveCurr.x - this._movePrev.x, this._moveCurr.y - this._movePrev.y, 0);
        let angle = $164afa34e4b04624$var$_moveDirection.length();
        if (angle) {
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_eyeDirection.copy(this._eye).normalize();
            $164afa34e4b04624$var$_objectUpDirection.copy(this.object.up).normalize();
            $164afa34e4b04624$var$_objectSidewaysDirection.crossVectors($164afa34e4b04624$var$_objectUpDirection, $164afa34e4b04624$var$_eyeDirection).normalize();
            $164afa34e4b04624$var$_objectUpDirection.setLength(this._moveCurr.y - this._movePrev.y);
            $164afa34e4b04624$var$_objectSidewaysDirection.setLength(this._moveCurr.x - this._movePrev.x);
            $164afa34e4b04624$var$_moveDirection.copy($164afa34e4b04624$var$_objectUpDirection.add($164afa34e4b04624$var$_objectSidewaysDirection));
            $164afa34e4b04624$var$_axis.crossVectors($164afa34e4b04624$var$_moveDirection, this._eye).normalize();
            angle *= this.rotateSpeed;
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle($164afa34e4b04624$var$_axis, angle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this._lastAxis.copy($164afa34e4b04624$var$_axis);
            this._lastAngle = angle;
        } else if (!this.staticMoving && this._lastAngle) {
            this._lastAngle *= Math.sqrt(1.0 - this.dynamicDampingFactor);
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle(this._lastAxis, this._lastAngle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
        }
        this._movePrev.copy(this._moveCurr);
    }
    _zoomCamera() {
        let factor;
        if (this.state === $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN) {
            factor = this._touchZoomDistanceStart / this._touchZoomDistanceEnd;
            this._touchZoomDistanceStart = this._touchZoomDistanceEnd;
            if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
            else if (this.object.isOrthographicCamera) {
                this.object.zoom = (0, $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
            } else console.warn('THREE.TrackballControls: Unsupported camera type');
        } else {
            factor = 1.0 + (this._zoomEnd.y - this._zoomStart.y) * this.zoomSpeed;
            if (factor !== 1.0 && factor > 0.0) {
                if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
                else if (this.object.isOrthographicCamera) {
                    this.object.zoom = (0, $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                    if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
                } else console.warn('THREE.TrackballControls: Unsupported camera type');
            }
            if (this.staticMoving) this._zoomStart.copy(this._zoomEnd);
            else this._zoomStart.y += (this._zoomEnd.y - this._zoomStart.y) * this.dynamicDampingFactor;
        }
    }
    _getMouseOnScreen(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.left) / this.screen.width, (pageY - this.screen.top) / this.screen.height);
        return $164afa34e4b04624$var$_v2;
    }
    _getMouseOnCircle(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.width * 0.5 - this.screen.left) / (this.screen.width * 0.5), (this.screen.height + 2 * (this.screen.top - pageY)) / this.screen.width // screen.width intentional
        );
        return $164afa34e4b04624$var$_v2;
    }
    _addPointer(event) {
        this._pointers.push(event);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointer = event.pointerId === this._pointers[0].pointerId ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointer.pointerId];
    }
    _checkDistances() {
        if (!this.noZoom || !this.noPan) {
            if (this._eye.lengthSq() > this.maxDistance * this.maxDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.maxDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
            if (this._eye.lengthSq() < this.minDistance * this.minDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.minDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
        }
    }
}
function $164afa34e4b04624$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.ownerDocument.addEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.addEventListener('pointerup', this._onPointerUp);
    }
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $164afa34e4b04624$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $164afa34e4b04624$var$onPointerUp(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchEnd(event);
    else this._onMouseUp();
    //
    this._removePointer(event);
    if (this._pointers.length === 0) {
        this.domElement.releasePointerCapture(event.pointerId);
        this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.removeEventListener('pointerup', this._onPointerUp);
    }
}
function $164afa34e4b04624$var$onPointerCancel(event) {
    this._removePointer(event);
}
function $164afa34e4b04624$var$onKeyUp() {
    if (this.enabled === false) return;
    this.keyState = $164afa34e4b04624$var$_STATE.NONE;
    window.addEventListener('keydown', this._onKeyDown);
}
function $164afa34e4b04624$var$onKeyDown(event) {
    if (this.enabled === false) return;
    window.removeEventListener('keydown', this._onKeyDown);
    if (this.keyState !== $164afa34e4b04624$var$_STATE.NONE) return;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ROTATE] && !this.noRotate) this.keyState = $164afa34e4b04624$var$_STATE.ROTATE;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ZOOM] && !this.noZoom) this.keyState = $164afa34e4b04624$var$_STATE.ZOOM;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.PAN] && !this.noPan) this.keyState = $164afa34e4b04624$var$_STATE.PAN;
}
function $164afa34e4b04624$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).DOLLY:
            this.state = $164afa34e4b04624$var$_STATE.ZOOM;
            break;
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE:
            this.state = $164afa34e4b04624$var$_STATE.ROTATE;
            break;
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN:
            this.state = $164afa34e4b04624$var$_STATE.PAN;
            break;
        default:
            this.state = $164afa34e4b04624$var$_STATE.NONE;
    }
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
        this._movePrev.copy(this._moveCurr);
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) {
        this._zoomStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._zoomEnd.copy(this._zoomStart);
    } else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) {
        this._panStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._panEnd.copy(this._panStart);
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onMouseMove(event) {
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._movePrev.copy(this._moveCurr);
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) this._zoomEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
    else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) this._panEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
}
function $164afa34e4b04624$var$onMouseUp() {
    this.state = $164afa34e4b04624$var$_STATE.NONE;
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onMouseWheel(event) {
    if (this.enabled === false) return;
    if (this.noZoom === true) return;
    event.preventDefault();
    switch(event.deltaMode){
        case 2:
            // Zoom in pages
            this._zoomStart.y -= event.deltaY * 0.025;
            break;
        case 1:
            // Zoom in lines
            this._zoomStart.y -= event.deltaY * 0.01;
            break;
        default:
            // undefined, 0, assume pixels
            this._zoomStart.y -= event.deltaY * 0.00025;
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $164afa34e4b04624$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(this._pointers[0].pageX, this._pointers[0].pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        default:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            const dx = this._pointers[0].pageX - this._pointers[1].pageX;
            const dy = this._pointers[0].pageY - this._pointers[1].pageY;
            this._touchZoomDistanceEnd = this._touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
            const x = (this._pointers[0].pageX + this._pointers[1].pageX) / 2;
            const y = (this._pointers[0].pageY + this._pointers[1].pageY) / 2;
            this._panStart.copy(this._getMouseOnScreen(x, y));
            this._panEnd.copy(this._panStart);
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this._movePrev.copy(this._moveCurr);
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            break;
        default:
            const position = this._getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            this._touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
            const x = (event.pageX + position.x) / 2;
            const y = (event.pageY + position.y) / 2;
            this._panEnd.copy(this._getMouseOnScreen(x, y));
            break;
    }
}
function $164afa34e4b04624$var$onTouchEnd(event) {
    switch(this._pointers.length){
        case 0:
            this.state = $164afa34e4b04624$var$_STATE.NONE;
            break;
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        case 2:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId !== event.pointerId) {
                const position = this._pointerPositions[this._pointers[i].pointerId];
                this._moveCurr.copy(this._getMouseOnCircle(position.x, position.y));
                this._movePrev.copy(this._moveCurr);
                break;
            }
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}



/**
 * Fires when the camera has been transformed by the controls.
 *
 * @event OrbitControls#change
 * @type {Object}
 */ const $443c013b983d0324$var$_changeEvent = {
    type: 'change'
};
/**
 * Fires when an interaction was initiated.
 *
 * @event OrbitControls#start
 * @type {Object}
 */ const $443c013b983d0324$var$_startEvent = {
    type: 'start'
};
/**
 * Fires when an interaction has finished.
 *
 * @event OrbitControls#end
 * @type {Object}
 */ const $443c013b983d0324$var$_endEvent = {
    type: 'end'
};
const $443c013b983d0324$var$_ray = new (0, $9ddd7e9b53f7a2d4$export$a186db52eed6d40e)();
const $443c013b983d0324$var$_plane = new (0, $9ddd7e9b53f7a2d4$export$7ff5ac152ef991b0)();
const $443c013b983d0324$var$_TILT_LIMIT = Math.cos(70 * (0, $9ddd7e9b53f7a2d4$export$6a7ef315a0d1ef07).DEG2RAD);
const $443c013b983d0324$var$_v = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
const $443c013b983d0324$var$_twoPI = 2 * Math.PI;
const $443c013b983d0324$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
};
const $443c013b983d0324$var$_EPS = 0.000001;
/**
 * Orbit controls allow the camera to orbit around a target.
 *
 * OrbitControls performs orbiting, dollying (zooming), and panning. Unlike {@link TrackballControls},
 * it maintains the "up" direction `object.up` (+Y by default).
 *
 * - Orbit: Left mouse / touch: one-finger move.
 * - Zoom: Middle mouse, or mousewheel / touch: two-finger spread or squish.
 * - Pan: Right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move.
 *
 * ```js
 * const controls = new OrbitControls( camera, renderer.domElement );
 *
 * // controls.update() must be called after any manual changes to the camera's transform
 * camera.position.set( 0, 20, 100 );
 * controls.update();
 *
 * function animate() {
 *
 * 	// required if controls.enableDamping or controls.autoRotate are set to true
 * 	controls.update();
 *
 * 	renderer.render( scene, camera );
 *
 * }
 * ```
 *
 * @augments Controls
 * @three_import import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
 */ class $443c013b983d0324$export$8ff7788029dfdf52 extends (0, $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f) {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super(object, domElement);
        this.state = $443c013b983d0324$var$_STATE.NONE;
        /**
		 * The focus point of the controls, the `object` orbits around this.
		 * It can be updated manually at any point to change the focus of the controls.
		 *
		 * @type {Vector3}
		 */ this.target = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        /**
		 * The focus point of the `minTargetRadius` and `maxTargetRadius` limits.
		 * It can be updated manually at any point to change the center of interest
		 * for the `target`.
		 *
		 * @type {Vector3}
		 */ this.cursor = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        /**
		 * How far you can dolly in (perspective camera only).
		 *
		 * @type {number}
		 * @default 0
		 */ this.minDistance = 0;
        /**
		 * How far you can dolly out (perspective camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.maxDistance = Infinity;
        /**
		 * How far you can zoom in (orthographic camera only).
		 *
		 * @type {number}
		 * @default 0
		 */ this.minZoom = 0;
        /**
		 * How far you can zoom out (orthographic camera only).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.maxZoom = Infinity;
        /**
		 * How close you can get the target to the 3D `cursor`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.minTargetRadius = 0;
        /**
		 * How far you can move the target from the 3D `cursor`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.maxTargetRadius = Infinity;
        /**
		 * How far you can orbit vertically, lower limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.minPolarAngle = 0;
        /**
		 * How far you can orbit vertically, upper limit. Range is `[0, Math.PI]` radians.
		 *
		 * @type {number}
		 * @default Math.PI
		 */ this.maxPolarAngle = Math.PI;
        /**
		 * How far you can orbit horizontally, lower limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */ this.minAzimuthAngle = -Infinity;
        /**
		 * How far you can orbit horizontally, upper limit. If set, the interval `[ min, max ]`
		 * must be a sub-interval of `[ - 2 PI, 2 PI ]`, with `( max - min < 2 PI )`.
		 *
		 * @type {number}
		 * @default -Infinity
		 */ this.maxAzimuthAngle = Infinity;
        /**
		 * Set to `true` to enable damping (inertia), which can be used to give a sense of weight
		 * to the controls. Note that if this is enabled, you must call `update()` in your animation
		 * loop.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enableDamping = false;
        /**
		 * The damping inertia used if `enableDamping` is set to `true`.
		 *
		 * Note that for this to work, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 0.05
		 */ this.dampingFactor = 0.05;
        /**
		 * Enable or disable zooming (dollying) of the camera.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enableZoom = true;
        /**
		 * Speed of zooming / dollying.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoomSpeed = 1.0;
        /**
		 * Enable or disable horizontal and vertical rotation of the camera.
		 *
		 * Note that it is possible to disable a single axis by setting the min and max of the
		 * `minPolarAngle` or `minAzimuthAngle` to the same value, which will cause the vertical
		 * or horizontal rotation to be fixed at that value.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enableRotate = true;
        /**
		 * Speed of rotation.
		 *
		 * @type {number}
		 * @default 1
		 */ this.rotateSpeed = 1.0;
        /**
		 * How fast to rotate the camera when the keyboard is used.
		 *
		 * @type {number}
		 * @default 1
		 */ this.keyRotateSpeed = 1.0;
        /**
		 * Enable or disable camera panning.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enablePan = true;
        /**
		 * Speed of panning.
		 *
		 * @type {number}
		 * @default 1
		 */ this.panSpeed = 1.0;
        /**
		 * Defines how the camera's position is translated when panning. If `true`, the camera pans
		 * in screen space. Otherwise, the camera pans in the plane orthogonal to the camera's up
		 * direction.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.screenSpacePanning = true;
        /**
		 * How fast to pan the camera when the keyboard is used in
		 * pixels per keypress.
		 *
		 * @type {number}
		 * @default 7
		 */ this.keyPanSpeed = 7.0;
        /**
		 * Setting this property to `true` allows to zoom to the cursor's position.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.zoomToCursor = false;
        /**
		 * Set to true to automatically rotate around the target
		 *
		 * Note that if this is enabled, you must call `update()` in your animation loop.
		 * If you want the auto-rotate speed to be independent of the frame rate (the refresh
		 * rate of the display), you must pass the time `deltaTime`, in seconds, to `update()`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoRotate = false;
        /**
		 * How fast to rotate around the target if `autoRotate` is `true`. The default  equates to 30 seconds
		 * per orbit at 60fps.
		 *
		 * Note that if `autoRotate` is enabled, you must call `update()` in your animation loop.
		 *
		 * @type {number}
		 * @default 2
		 */ this.autoRotateSpeed = 2.0;
        /**
		 * This object contains references to the keycodes for controlling camera panning.
		 *
		 * ```js
		 * controls.keys = {
		 * 	LEFT: 'ArrowLeft', //left arrow
		 * 	UP: 'ArrowUp', // up arrow
		 * 	RIGHT: 'ArrowRight', // right arrow
		 * 	BOTTOM: 'ArrowDown' // down arrow
		 * }
		 * ```
		 * @type {Object}
		 */ this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        /**
		 * This object contains references to the mouse actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	LEFT: THREE.MOUSE.ROTATE,
		 * 	MIDDLE: THREE.MOUSE.DOLLY,
		 * 	RIGHT: THREE.MOUSE.PAN
		 * }
		 * ```
		 * @type {Object}
		 */ this.mouseButtons = {
            LEFT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN
        };
        /**
		 * This object contains references to the touch actions used by the controls.
		 *
		 * ```js
		 * controls.mouseButtons = {
		 * 	ONE: THREE.TOUCH.ROTATE,
		 * 	TWO: THREE.TOUCH.DOLLY_PAN
		 * }
		 * ```
		 * @type {Object}
		 */ this.touches = {
            ONE: (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        /**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */ this.target0 = this.target.clone();
        /**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {Vector3}
		 */ this.position0 = this.object.position.clone();
        /**
		 * Used internally by `saveState()` and `reset()`.
		 *
		 * @type {number}
		 */ this.zoom0 = this.object.zoom;
        this._cursorStyle = 'auto';
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // internals
        this._lastPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._lastQuaternion = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)();
        this._lastTargetPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        // so camera.up is the orbit axis
        this._quat = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        // current position in spherical coordinates
        this._spherical = new (0, $9ddd7e9b53f7a2d4$export$d712cd887b4a00f7)();
        this._sphericalDelta = new (0, $9ddd7e9b53f7a2d4$export$d712cd887b4a00f7)();
        this._scale = 1;
        this._panOffset = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._rotateStart = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._rotateEnd = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._rotateDelta = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._panStart = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._panDelta = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._dollyStart = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._dollyEnd = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._dollyDelta = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._dollyDirection = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._mouse = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        // event listeners
        this._onPointerMove = $443c013b983d0324$var$onPointerMove.bind(this);
        this._onPointerDown = $443c013b983d0324$var$onPointerDown.bind(this);
        this._onPointerUp = $443c013b983d0324$var$onPointerUp.bind(this);
        this._onContextMenu = $443c013b983d0324$var$onContextMenu.bind(this);
        this._onMouseWheel = $443c013b983d0324$var$onMouseWheel.bind(this);
        this._onKeyDown = $443c013b983d0324$var$onKeyDown.bind(this);
        this._onTouchStart = $443c013b983d0324$var$onTouchStart.bind(this);
        this._onTouchMove = $443c013b983d0324$var$onTouchMove.bind(this);
        this._onMouseDown = $443c013b983d0324$var$onMouseDown.bind(this);
        this._onMouseMove = $443c013b983d0324$var$onMouseMove.bind(this);
        this._interceptControlDown = $443c013b983d0324$var$interceptControlDown.bind(this);
        this._interceptControlUp = $443c013b983d0324$var$interceptControlUp.bind(this);
        //
        if (this.domElement !== null) this.connect(this.domElement);
        this.update();
    }
    /**
	 * Defines the visual representation of the cursor.
	 *
	 * @type {('auto'|'grab')}
	 * @default 'auto'
	 */ set cursorStyle(type) {
        this._cursorStyle = type;
        if (type === 'grab') this.domElement.style.cursor = 'grab';
        else this.domElement.style.cursor = 'auto';
    }
    get cursorStyle() {
        return this._cursorStyle;
    }
    connect(element) {
        super.connect(element);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerUp);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keydown', this._interceptControlDown, {
            passive: true,
            capture: true
        });
        this.domElement.style.touchAction = 'none'; // Disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerUp);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.stopListenToKeyEvents();
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keydown', this._interceptControlDown, {
            capture: true
        });
        this.domElement.style.touchAction = ''; // Restore touch scroll
    }
    dispose() {
        this.disconnect();
    }
    /**
	 * Get the current vertical rotation, in radians.
	 *
	 * @return {number} The current vertical rotation, in radians.
	 */ getPolarAngle() {
        return this._spherical.phi;
    }
    /**
	 * Get the current horizontal rotation, in radians.
	 *
	 * @return {number} The current horizontal rotation, in radians.
	 */ getAzimuthalAngle() {
        return this._spherical.theta;
    }
    /**
	 * Returns the distance from the camera to the target.
	 *
	 * @return {number} The distance from the camera to the target.
	 */ getDistance() {
        return this.object.position.distanceTo(this.target);
    }
    /**
	 * Adds key event listeners to the given DOM element.
	 * `window` is a recommended argument for using this method.
	 *
	 * @param {HTMLElement} domElement - The DOM element
	 */ listenToKeyEvents(domElement) {
        domElement.addEventListener('keydown', this._onKeyDown);
        this._domElementKeyEvents = domElement;
    }
    /**
	 * Removes the key event listener previously defined with `listenToKeyEvents()`.
	 */ stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
            this._domElementKeyEvents.removeEventListener('keydown', this._onKeyDown);
            this._domElementKeyEvents = null;
        }
    }
    /**
	 * Save the current state of the controls. This can later be recovered with `reset()`.
	 */ saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
    }
    /**
	 * Reset the controls to their state from either the last time the `saveState()`
	 * was called, or the initial state.
	 */ reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent($443c013b983d0324$var$_changeEvent);
        this.update();
        this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    /**
	 * Programmatically pan the camera.
	 *
	 * @param {number} deltaX - The horizontal pan amount in pixels.
	 * @param {number} deltaY - The vertical pan amount in pixels.
	 */ pan(deltaX, deltaY) {
        this._pan(deltaX, deltaY);
        this.update();
    }
    /**
	 * Programmatically dolly in (zoom in for perspective camera).
	 *
	 * @param {number} dollyScale - The dolly scale factor.
	 */ dollyIn(dollyScale) {
        this._dollyIn(dollyScale);
        this.update();
    }
    /**
	 * Programmatically dolly out (zoom out for perspective camera).
	 *
	 * @param {number} dollyScale - The dolly scale factor.
	 */ dollyOut(dollyScale) {
        this._dollyOut(dollyScale);
        this.update();
    }
    /**
	 * Programmatically rotate the camera left (around the vertical axis).
	 *
	 * @param {number} angle - The rotation angle in radians.
	 */ rotateLeft(angle) {
        this._rotateLeft(angle);
        this.update();
    }
    /**
	 * Programmatically rotate the camera up (around the horizontal axis).
	 *
	 * @param {number} angle - The rotation angle in radians.
	 */ rotateUp(angle) {
        this._rotateUp(angle);
        this.update();
    }
    update(deltaTime = null) {
        const position = this.object.position;
        $443c013b983d0324$var$_v.copy(position).sub(this.target);
        // rotate offset to "y-axis-is-up" space
        $443c013b983d0324$var$_v.applyQuaternion(this._quat);
        // angle from z-axis around y-axis
        this._spherical.setFromVector3($443c013b983d0324$var$_v);
        if (this.autoRotate && this.state === $443c013b983d0324$var$_STATE.NONE) this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        if (this.enableDamping) {
            this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
            this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
            this._spherical.theta += this._sphericalDelta.theta;
            this._spherical.phi += this._sphericalDelta.phi;
        }
        // restrict theta to be between desired limits
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
            if (min < -Math.PI) min += $443c013b983d0324$var$_twoPI;
            else if (min > Math.PI) min -= $443c013b983d0324$var$_twoPI;
            if (max < -Math.PI) max += $443c013b983d0324$var$_twoPI;
            else if (max > Math.PI) max -= $443c013b983d0324$var$_twoPI;
            if (min <= max) this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
            else this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
        // restrict phi to be between desired limits
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        // move target to panned location
        if (this.enableDamping === true) this.target.addScaledVector(this._panOffset, this.dampingFactor);
        else this.target.add(this._panOffset);
        // Limit the target distance from the cursor to create a sphere around the center of interest
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        // adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
        // we adjust zoom later in these cases
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
            const prevRadius = this._spherical.radius;
            this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
            zoomChanged = prevRadius != this._spherical.radius;
        }
        $443c013b983d0324$var$_v.setFromSpherical(this._spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        $443c013b983d0324$var$_v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add($443c013b983d0324$var$_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
            this._sphericalDelta.theta *= 1 - this.dampingFactor;
            this._sphericalDelta.phi *= 1 - this.dampingFactor;
            this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
            this._sphericalDelta.set(0, 0, 0);
            this._panOffset.set(0, 0, 0);
        }
        // adjust camera position
        if (this.zoomToCursor && this._performCursorZoom) {
            let newRadius = null;
            if (this.object.isPerspectiveCamera) {
                // move the camera down the pointer ray
                // this method avoids floating point error
                const prevRadius = $443c013b983d0324$var$_v.length();
                newRadius = this._clampDistance(prevRadius * this._scale);
                const radiusDelta = prevRadius - newRadius;
                this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
                this.object.updateMatrixWorld();
                zoomChanged = !!radiusDelta;
            } else if (this.object.isOrthographicCamera) {
                // adjust the ortho camera position based on zoom changes
                const mouseBefore = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseBefore.unproject(this.object);
                const prevZoom = this.object.zoom;
                this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
                this.object.updateProjectionMatrix();
                zoomChanged = prevZoom !== this.object.zoom;
                const mouseAfter = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseAfter.unproject(this.object);
                this.object.position.sub(mouseAfter).add(mouseBefore);
                this.object.updateMatrixWorld();
                newRadius = $443c013b983d0324$var$_v.length();
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.');
                this.zoomToCursor = false;
            }
            // handle the placement of the target
            if (newRadius !== null) {
                if (this.screenSpacePanning) // position the orbit target in front of the new camera position
                this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
                else {
                    // get the ray and translation plane to compute target
                    $443c013b983d0324$var$_ray.origin.copy(this.object.position);
                    $443c013b983d0324$var$_ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
                    // if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
                    // extremely large values
                    if (Math.abs(this.object.up.dot($443c013b983d0324$var$_ray.direction)) < $443c013b983d0324$var$_TILT_LIMIT) this.object.lookAt(this.target);
                    else {
                        $443c013b983d0324$var$_plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                        $443c013b983d0324$var$_ray.intersectPlane($443c013b983d0324$var$_plane, this.target);
                    }
                }
            }
        } else if (this.object.isOrthographicCamera) {
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            if (prevZoom !== this.object.zoom) {
                this.object.updateProjectionMatrix();
                zoomChanged = true;
            }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > $443c013b983d0324$var$_EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > $443c013b983d0324$var$_EPS || this._lastTargetPosition.distanceToSquared(this.target) > $443c013b983d0324$var$_EPS) {
            this.dispatchEvent($443c013b983d0324$var$_changeEvent);
            this._lastPosition.copy(this.object.position);
            this._lastQuaternion.copy(this.object.quaternion);
            this._lastTargetPosition.copy(this.target);
            return true;
        }
        return false;
    }
    _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) return $443c013b983d0324$var$_twoPI / 60 * this.autoRotateSpeed * deltaTime;
        else return $443c013b983d0324$var$_twoPI / 60 / 60 * this.autoRotateSpeed;
    }
    _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
        $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
        $443c013b983d0324$var$_v.multiplyScalar(-distance);
        this._panOffset.add($443c013b983d0324$var$_v);
    }
    _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 1);
        else {
            $443c013b983d0324$var$_v.setFromMatrixColumn(objectMatrix, 0);
            $443c013b983d0324$var$_v.crossVectors(this.object.up, $443c013b983d0324$var$_v);
        }
        $443c013b983d0324$var$_v.multiplyScalar(distance);
        this._panOffset.add($443c013b983d0324$var$_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
            // perspective
            const position = this.object.position;
            $443c013b983d0324$var$_v.copy(position).sub(this.target);
            let targetDistance = $443c013b983d0324$var$_v.length();
            // half of the fov is center to top of screen
            targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180.0);
            // we use only clientHeight here so aspect ratio does not distort speed
            this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
            this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
            // orthographic
            this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
            this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
            // camera neither orthographic nor perspective
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
            this.enablePan = false;
        }
    }
    _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale /= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale *= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($443c013b983d0324$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($443c013b983d0324$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
    }
    _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        else if (this._dollyDelta.y < 0) this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        this._dollyStart.copy(this._dollyEnd);
        this.update();
    }
    _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
    }
    _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) this._dollyIn(this._getZoomScale(event.deltaY));
        else if (event.deltaY > 0) this._dollyOut(this._getZoomScale(event.deltaY));
        this.update();
    }
    _handleKeyDown(event) {
        let needsUpdate = false;
        switch(event.code){
            case this.keys.UP:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateUp($443c013b983d0324$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.BOTTOM:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateUp(-$443c013b983d0324$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.LEFT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateLeft($443c013b983d0324$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case this.keys.RIGHT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateLeft(-$443c013b983d0324$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            this.update();
        }
    }
    _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) this._rotateStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateStart.set(x, y);
        }
    }
    _handleTouchStartPan(event) {
        if (this._pointers.length === 1) this._panStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panStart.set(x, y);
        }
    }
    _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) this._rotateEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($443c013b983d0324$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($443c013b983d0324$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
        if (this._pointers.length === 1) this._panEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
        this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _isTrackingPointer(event) {
        for(let i = 0; i < this._pointers.length; i++){
            if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
        const mode = event.deltaMode;
        // minimal wheel event altered to meet delta-zoom demand
        const newEvent = {
            clientX: event.clientX,
            clientY: event.clientY,
            deltaY: event.deltaY
        };
        switch(mode){
            case 1:
                newEvent.deltaY *= 16;
                break;
            case 2:
                newEvent.deltaY *= 100;
                break;
        }
        // detect if event was triggered by pinching
        if (event.ctrlKey && !this._controlActive) newEvent.deltaY *= 10;
        return newEvent;
    }
}
function $443c013b983d0324$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.ownerDocument.addEventListener('pointermove', this._onPointerMove);
        this.domElement.ownerDocument.addEventListener('pointerup', this._onPointerUp);
    }
    //
    if (this._isTrackingPointer(event)) return;
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
    if (this._cursorStyle === 'grab') this.domElement.style.cursor = 'grabbing';
}
function $443c013b983d0324$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $443c013b983d0324$var$onPointerUp(event) {
    this._removePointer(event);
    switch(this._pointers.length){
        case 0:
            this.domElement.releasePointerCapture(event.pointerId);
            this.domElement.ownerDocument.removeEventListener('pointermove', this._onPointerMove);
            this.domElement.ownerDocument.removeEventListener('pointerup', this._onPointerUp);
            this.dispatchEvent($443c013b983d0324$var$_endEvent);
            this.state = $443c013b983d0324$var$_STATE.NONE;
            if (this._cursorStyle === 'grab') this.domElement.style.cursor = 'grab';
            break;
        case 1:
            const pointerId = this._pointers[0];
            const position = this._pointerPositions[pointerId];
            // minimal placeholder event - allows state correction on pointer-up
            this._onTouchStart({
                pointerId: pointerId,
                pageX: position.x,
                pageY: position.y
            });
            break;
    }
}
function $443c013b983d0324$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseDownDolly(event);
            this.state = $443c013b983d0324$var$_STATE.DOLLY;
            break;
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).ROTATE:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $443c013b983d0324$var$_STATE.PAN;
            } else {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $443c013b983d0324$var$_STATE.ROTATE;
            }
            break;
        case (0, $9ddd7e9b53f7a2d4$export$7177b3e430c2d7ca).PAN:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $443c013b983d0324$var$_STATE.ROTATE;
            } else {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $443c013b983d0324$var$_STATE.PAN;
            }
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    if (this.state !== $443c013b983d0324$var$_STATE.NONE) this.dispatchEvent($443c013b983d0324$var$_startEvent);
}
function $443c013b983d0324$var$onMouseMove(event) {
    switch(this.state){
        case $443c013b983d0324$var$_STATE.ROTATE:
            if (this.enableRotate === false) return;
            this._handleMouseMoveRotate(event);
            break;
        case $443c013b983d0324$var$_STATE.DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseMoveDolly(event);
            break;
        case $443c013b983d0324$var$_STATE.PAN:
            if (this.enablePan === false) return;
            this._handleMouseMovePan(event);
            break;
    }
}
function $443c013b983d0324$var$onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== $443c013b983d0324$var$_STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent($443c013b983d0324$var$_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent($443c013b983d0324$var$_endEvent);
}
function $443c013b983d0324$var$onKeyDown(event) {
    if (this.enabled === false) return;
    this._handleKeyDown(event);
}
function $443c013b983d0324$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            switch(this.touches.ONE){
                case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).ROTATE:
                    if (this.enableRotate === false) return;
                    this._handleTouchStartRotate(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_ROTATE;
                    break;
                case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).PAN:
                    if (this.enablePan === false) return;
                    this._handleTouchStartPan(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_PAN;
                    break;
                default:
                    this.state = $443c013b983d0324$var$_STATE.NONE;
            }
            break;
        case 2:
            switch(this.touches.TWO){
                case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).DOLLY_PAN:
                    if (this.enableZoom === false && this.enablePan === false) return;
                    this._handleTouchStartDollyPan(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_DOLLY_PAN;
                    break;
                case (0, $9ddd7e9b53f7a2d4$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                    if (this.enableZoom === false && this.enableRotate === false) return;
                    this._handleTouchStartDollyRotate(event);
                    this.state = $443c013b983d0324$var$_STATE.TOUCH_DOLLY_ROTATE;
                    break;
                default:
                    this.state = $443c013b983d0324$var$_STATE.NONE;
            }
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
    if (this.state !== $443c013b983d0324$var$_STATE.NONE) this.dispatchEvent($443c013b983d0324$var$_startEvent);
}
function $443c013b983d0324$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this.state){
        case $443c013b983d0324$var$_STATE.TOUCH_ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchMoveRotate(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_PAN:
            if (this.enablePan === false) return;
            this._handleTouchMovePan(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchMoveDollyPan(event);
            this.update();
            break;
        case $443c013b983d0324$var$_STATE.TOUCH_DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchMoveDollyRotate(event);
            this.update();
            break;
        default:
            this.state = $443c013b983d0324$var$_STATE.NONE;
    }
}
function $443c013b983d0324$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $443c013b983d0324$var$interceptControlDown(event) {
    if (event.key === 'Control') {
        this._controlActive = true;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}
function $443c013b983d0324$var$interceptControlUp(event) {
    if (event.key === 'Control') {
        this._controlActive = false;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}



/**
 * Fires when the camera has been transformed by the controls.
 *
 * @event FlyControls#change
 * @type {Object}
 */ const $37d4d287f7c195e5$var$_changeEvent = {
    type: 'change'
};
const $37d4d287f7c195e5$var$_EPS = 0.000001;
const $37d4d287f7c195e5$var$_tmpQuaternion = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)();
/**
 * This class enables a navigation similar to fly modes in DCC tools like Blender.
 * You can arbitrarily transform the camera in 3D space without any limitations
 * (e.g. focus on a specific target).
 *
 * @augments Controls
 * @three_import import { FlyControls } from 'three/addons/controls/FlyControls.js';
 */ class $37d4d287f7c195e5$export$4cec72bd81e75195 extends (0, $9ddd7e9b53f7a2d4$export$c7c44baae9d9f25f) {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super(object, domElement);
        /**
		 * The movement speed.
		 *
		 * @type {number}
		 * @default 1
		 */ this.movementSpeed = 1.0;
        /**
		 * The rotation speed.
		 *
		 * @type {number}
		 * @default 0.005
		 */ this.rollSpeed = 0.005;
        /**
		 * If set to `true`, you can only look around by performing a drag interaction.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dragToLook = false;
        /**
		 * If set to `true`, the camera automatically moves forward (and does not stop) when initially translated.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoForward = false;
        // internals
        this._moveState = {
            up: 0,
            down: 0,
            left: 0,
            right: 0,
            forward: 0,
            back: 0,
            pitchUp: 0,
            pitchDown: 0,
            yawLeft: 0,
            yawRight: 0,
            rollLeft: 0,
            rollRight: 0
        };
        this._moveVector = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 0);
        this._rotationVector = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)(0, 0, 0);
        this._lastQuaternion = new (0, $9ddd7e9b53f7a2d4$export$23d6a54f0bbc85a3)();
        this._lastPosition = new (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699)();
        this._status = 0;
        // event listeners
        this._onKeyDown = $37d4d287f7c195e5$var$onKeyDown.bind(this);
        this._onKeyUp = $37d4d287f7c195e5$var$onKeyUp.bind(this);
        this._onPointerMove = $37d4d287f7c195e5$var$onPointerMove.bind(this);
        this._onPointerDown = $37d4d287f7c195e5$var$onPointerDown.bind(this);
        this._onPointerUp = $37d4d287f7c195e5$var$onPointerUp.bind(this);
        this._onPointerCancel = $37d4d287f7c195e5$var$onPointerCancel.bind(this);
        this._onContextMenu = $37d4d287f7c195e5$var$onContextMenu.bind(this);
        //
        if (domElement !== null) this.connect(domElement);
    }
    connect(element) {
        super.connect(element);
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('keyup', this._onKeyUp);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
        this.domElement.addEventListener('pointercancel', this._onPointerCancel);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // Disable touch scroll
    }
    disconnect() {
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('keyup', this._onKeyUp);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerCancel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = ''; // Restore touch scroll
    }
    dispose() {
        this.disconnect();
    }
    update(delta) {
        if (this.enabled === false) return;
        const object = this.object;
        const moveMult = delta * this.movementSpeed;
        const rotMult = delta * this.rollSpeed;
        object.translateX(this._moveVector.x * moveMult);
        object.translateY(this._moveVector.y * moveMult);
        object.translateZ(this._moveVector.z * moveMult);
        $37d4d287f7c195e5$var$_tmpQuaternion.set(this._rotationVector.x * rotMult, this._rotationVector.y * rotMult, this._rotationVector.z * rotMult, 1).normalize();
        object.quaternion.multiply($37d4d287f7c195e5$var$_tmpQuaternion);
        if (this._lastPosition.distanceToSquared(object.position) > $37d4d287f7c195e5$var$_EPS || 8 * (1 - this._lastQuaternion.dot(object.quaternion)) > $37d4d287f7c195e5$var$_EPS) {
            this.dispatchEvent($37d4d287f7c195e5$var$_changeEvent);
            this._lastQuaternion.copy(object.quaternion);
            this._lastPosition.copy(object.position);
        }
    }
    // private
    _updateMovementVector() {
        const forward = this._moveState.forward || this.autoForward && !this._moveState.back ? 1 : 0;
        this._moveVector.x = -this._moveState.left + this._moveState.right;
        this._moveVector.y = -this._moveState.down + this._moveState.up;
        this._moveVector.z = -forward + this._moveState.back;
    //console.log( 'move:', [ this._moveVector.x, this._moveVector.y, this._moveVector.z ] );
    }
    _updateRotationVector() {
        this._rotationVector.x = -this._moveState.pitchDown + this._moveState.pitchUp;
        this._rotationVector.y = -this._moveState.yawRight + this._moveState.yawLeft;
        this._rotationVector.z = -this._moveState.rollRight + this._moveState.rollLeft;
    //console.log( 'rotate:', [ this._rotationVector.x, this._rotationVector.y, this._rotationVector.z ] );
    }
    _getContainerDimensions() {
        if (this.domElement != document) return {
            size: [
                this.domElement.offsetWidth,
                this.domElement.offsetHeight
            ],
            offset: [
                this.domElement.offsetLeft,
                this.domElement.offsetTop
            ]
        };
        else return {
            size: [
                window.innerWidth,
                window.innerHeight
            ],
            offset: [
                0,
                0
            ]
        };
    }
}
function $37d4d287f7c195e5$var$onKeyDown(event) {
    if (event.altKey || this.enabled === false) return;
    switch(event.code){
        case 'ShiftLeft':
        case 'ShiftRight':
            this.movementSpeedMultiplier = .1;
            break;
        case 'KeyW':
            this._moveState.forward = 1;
            break;
        case 'KeyS':
            this._moveState.back = 1;
            break;
        case 'KeyA':
            this._moveState.left = 1;
            break;
        case 'KeyD':
            this._moveState.right = 1;
            break;
        case 'KeyR':
            this._moveState.up = 1;
            break;
        case 'KeyF':
            this._moveState.down = 1;
            break;
        case 'ArrowUp':
            this._moveState.pitchUp = 1;
            break;
        case 'ArrowDown':
            this._moveState.pitchDown = 1;
            break;
        case 'ArrowLeft':
            this._moveState.yawLeft = 1;
            break;
        case 'ArrowRight':
            this._moveState.yawRight = 1;
            break;
        case 'KeyQ':
            this._moveState.rollLeft = 1;
            break;
        case 'KeyE':
            this._moveState.rollRight = 1;
            break;
    }
    this._updateMovementVector();
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onKeyUp(event) {
    if (this.enabled === false) return;
    switch(event.code){
        case 'ShiftLeft':
        case 'ShiftRight':
            this.movementSpeedMultiplier = 1;
            break;
        case 'KeyW':
            this._moveState.forward = 0;
            break;
        case 'KeyS':
            this._moveState.back = 0;
            break;
        case 'KeyA':
            this._moveState.left = 0;
            break;
        case 'KeyD':
            this._moveState.right = 0;
            break;
        case 'KeyR':
            this._moveState.up = 0;
            break;
        case 'KeyF':
            this._moveState.down = 0;
            break;
        case 'ArrowUp':
            this._moveState.pitchUp = 0;
            break;
        case 'ArrowDown':
            this._moveState.pitchDown = 0;
            break;
        case 'ArrowLeft':
            this._moveState.yawLeft = 0;
            break;
        case 'ArrowRight':
            this._moveState.yawRight = 0;
            break;
        case 'KeyQ':
            this._moveState.rollLeft = 0;
            break;
        case 'KeyE':
            this._moveState.rollRight = 0;
            break;
    }
    this._updateMovementVector();
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this.dragToLook) this._status++;
    else {
        switch(event.button){
            case 0:
                this._moveState.forward = 1;
                break;
            case 2:
                this._moveState.back = 1;
                break;
        }
        this._updateMovementVector();
    }
}
function $37d4d287f7c195e5$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (!this.dragToLook || this._status > 0) {
        const container = this._getContainerDimensions();
        const halfWidth = container.size[0] / 2;
        const halfHeight = container.size[1] / 2;
        this._moveState.yawLeft = -(event.pageX - container.offset[0] - halfWidth) / halfWidth;
        this._moveState.pitchDown = (event.pageY - container.offset[1] - halfHeight) / halfHeight;
        this._updateRotationVector();
    }
}
function $37d4d287f7c195e5$var$onPointerUp(event) {
    if (this.enabled === false) return;
    if (this.dragToLook) {
        this._status--;
        this._moveState.yawLeft = this._moveState.pitchDown = 0;
    } else {
        switch(event.button){
            case 0:
                this._moveState.forward = 0;
                break;
            case 2:
                this._moveState.back = 0;
                break;
        }
        this._updateMovementVector();
    }
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onPointerCancel() {
    if (this.enabled === false) return;
    if (this.dragToLook) {
        this._status = 0;
        this._moveState.yawLeft = this._moveState.pitchDown = 0;
    } else {
        this._moveState.forward = 0;
        this._moveState.back = 0;
        this._updateMovementVector();
    }
    this._updateRotationVector();
}
function $37d4d287f7c195e5$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}



/**
 * @module CopyShader
 * @three_import import { CopyShader } from 'three/addons/shaders/CopyShader.js';
 */ /**
 * Full-screen copy shader pass.
 *
 * @constant
 * @type {ShaderMaterial~Shader}
 */ const $2f93ac2d46312da9$export$57f84a24a9a6130d = {
    name: 'CopyShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'opacity': {
            value: 1.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
};




/**
 * Abstract base class for all post processing passes.
 *
 * This module is only relevant for post processing with {@link WebGLRenderer}.
 *
 * @abstract
 * @three_import import { Pass } from 'three/addons/postprocessing/Pass.js';
 */ class $0a1d3a5a6a49de03$export$802bc10488da99c7 {
    /**
	 * Constructs a new pass.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPass = true;
        /**
		 * If set to `true`, the pass is processed by the composer.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to `true`, the pass indicates to swap read and write buffer after rendering.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.needsSwap = true;
        /**
		 * If set to `true`, the pass clears its buffer before rendering
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clear = false;
        /**
		 * If set to `true`, the result of the pass is rendered to screen. The last pass in the composers
		 * pass chain gets automatically rendered to screen, no matter how this property is configured.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.renderToScreen = false;
    }
    /**
	 * Sets the size of the pass.
	 *
	 * @abstract
	 * @param {number} width - The width to set.
	 * @param {number} height - The height to set.
	 */ setSize() {}
    /**
	 * This method holds the render logic of a pass. It must be implemented in all derived classes.
	 *
	 * @abstract
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render() {
        console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 *
	 * @abstract
	 */ dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $0a1d3a5a6a49de03$var$_camera = new (0, $9ddd7e9b53f7a2d4$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
class $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry extends (0, $9ddd7e9b53f7a2d4$export$b7be63a67df8959) {
    constructor(){
        super();
        this.setAttribute('position', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        this.setAttribute('uv', new (0, $9ddd7e9b53f7a2d4$export$cbe7a62641830ebd)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
    }
}
const $0a1d3a5a6a49de03$var$_geometry = new $0a1d3a5a6a49de03$var$FullscreenTriangleGeometry();
/**
 * This module is a helper for passes which need to render a full
 * screen effect which is quite common in context of post processing.
 *
 * The intended usage is to reuse a single full screen quad for rendering
 * subsequent passes by just reassigning the `material` reference.
 *
 * This module can only be used with {@link WebGLRenderer}.
 *
 * @augments Mesh
 * @three_import import { FullScreenQuad } from 'three/addons/postprocessing/Pass.js';
 */ class $0a1d3a5a6a49de03$export$3983474c8e6e978b {
    /**
	 * Constructs a new full screen quad.
	 *
	 * @param {?Material} material - The material to render te full screen quad with.
	 */ constructor(material){
        this._mesh = new (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5)($0a1d3a5a6a49de03$var$_geometry, material);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the instance is no longer used in your app.
	 */ dispose() {
        this._mesh.geometry.dispose();
    }
    /**
	 * Renders the full screen quad.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ render(renderer) {
        renderer.render(this._mesh, $0a1d3a5a6a49de03$var$_camera);
    }
    /**
	 * The quad's material.
	 *
	 * @type {?Material}
	 */ get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}


/**
 * This pass can be used to create a post processing effect
 * with a raw GLSL shader object. Useful for implementing custom
 * effects.
 *
 * ```js
 * const fxaaPass = new ShaderPass( FXAAShader );
 * composer.addPass( fxaaPass );
 * ```
 *
 * @augments Pass
 * @three_import import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';
 */ class $6ac47a3de6300e1f$export$c55093fd4f9e42f0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new shader pass.
	 *
	 * @param {Object|ShaderMaterial} [shader] - A shader object holding vertex and fragment shader as well as
	 * defines and uniforms. It's also valid to pass a custom shader material.
	 * @param {string} [textureID='tDiffuse'] - The name of the texture uniform that should sample
	 * the read buffer.
	 */ constructor(shader, textureID = 'tDiffuse'){
        super();
        /**
		 * The name of the texture uniform that should sample the read buffer.
		 *
		 * @type {string}
		 * @default 'tDiffuse'
		 */ this.textureID = textureID;
        /**
		 * The pass uniforms.
		 *
		 * @type {?Object}
		 */ this.uniforms = null;
        /**
		 * The pass material.
		 *
		 * @type {?ShaderMaterial}
		 */ this.material = null;
        if (shader instanceof (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        } else if (shader) {
            this.uniforms = (0, $9ddd7e9b53f7a2d4$export$d8ecdf8615bfea69).clone(shader.uniforms);
            this.material = new (0, $9ddd7e9b53f7a2d4$export$83c7d75d550a8b0d)({
                name: shader.name !== undefined ? shader.name : 'unspecified',
                defines: Object.assign({}, shader.defines),
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        // internals
        this._fsQuad = new (0, $0a1d3a5a6a49de03$export$3983474c8e6e978b)(this.material);
    }
    /**
	 * Performs the shader pass.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
        this._fsQuad.material = this.material;
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this._fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(writeBuffer);
            // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
            if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
            this._fsQuad.render(renderer);
        }
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the pass is no longer used in your app.
	 */ dispose() {
        this.material.dispose();
        this._fsQuad.dispose();
    }
}



/**
 * This pass can be used to define a mask during post processing.
 * Meaning only areas of subsequent post processing are affected
 * which lie in the masking area of this pass. Internally, the masking
 * is implemented with the stencil buffer.
 *
 * ```js
 * const maskPass = new MaskPass( scene, camera );
 * composer.addPass( maskPass );
 * ```
 *
 * @augments Pass
 * @three_import import { MaskPass } from 'three/addons/postprocessing/MaskPass.js';
 */ class $0f4907a355572481$export$bb424a4005d6dde0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new mask pass.
	 *
	 * @param {Scene} scene - The 3D objects in this scene will define the mask.
	 * @param {Camera} camera - The camera.
	 */ constructor(scene, camera){
        super();
        /**
		 * The scene that defines the mask.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * Overwritten to perform a clear operation by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clear = true;
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
        /**
		 * Whether to inverse the mask or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.inverse = false;
    }
    /**
	 * Performs a mask pass with the configured scene and camera.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const context = renderer.getContext();
        const state = renderer.state;
        // don't update color or depth
        state.buffers.color.setMask(false);
        state.buffers.depth.setMask(false);
        // lock buffers
        state.buffers.color.setLocked(true);
        state.buffers.depth.setLocked(true);
        // set up stencil
        let writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        } else {
            writeValue = 1;
            clearValue = 0;
        }
        state.buffers.stencil.setTest(true);
        state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
        state.buffers.stencil.setClear(clearValue);
        state.buffers.stencil.setLocked(true);
        // draw into the stencil buffer
        renderer.setRenderTarget(readBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        // unlock color and depth buffer and make them writable for subsequent rendering/clearing
        state.buffers.color.setLocked(false);
        state.buffers.depth.setLocked(false);
        state.buffers.color.setMask(true);
        state.buffers.depth.setMask(true);
        // only render where stencil is set to 1
        state.buffers.stencil.setLocked(false);
        state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        state.buffers.stencil.setLocked(true);
    }
}
/**
 * This pass can be used to clear a mask previously defined with {@link MaskPass}.
 *
 * ```js
 * const clearPass = new ClearMaskPass();
 * composer.addPass( clearPass );
 * ```
 *
 * @augments Pass
 */ class $0f4907a355572481$export$8d8650aed29c6251 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new clear mask pass.
	 */ constructor(){
        super();
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
    }
    /**
	 * Performs the clear of the currently defined mask.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
        renderer.state.buffers.stencil.setLocked(false);
        renderer.state.buffers.stencil.setTest(false);
    }
}


/**
 * Used to implement post-processing effects in three.js.
 * The class manages a chain of post-processing passes to produce the final visual result.
 * Post-processing passes are executed in order of their addition/insertion.
 * The last pass is automatically rendered to screen.
 *
 * This module can only be used with {@link WebGLRenderer}.
 *
 * ```js
 * const composer = new EffectComposer( renderer );
 *
 * // adding some passes
 * const renderPass = new RenderPass( scene, camera );
 * composer.addPass( renderPass );
 *
 * const glitchPass = new GlitchPass();
 * composer.addPass( glitchPass );
 *
 * const outputPass = new OutputPass()
 * composer.addPass( outputPass );
 *
 * function animate() {
 *
 * 	composer.render(); // instead of renderer.render()
 *
 * }
 * ```
 *
 * @three_import import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
 */ class $1f89f80dfbd5e815$export$7fe01e6ab8aa748c {
    /**
	 * Constructs a new effect composer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} [renderTarget] - This render target and a clone will
	 * be used as the internal read and write buffers. If not given, the composer creates
	 * the buffers automatically.
	 */ constructor(renderer, renderTarget){
        /**
		 * The renderer.
		 *
		 * @type {WebGLRenderer}
		 */ this.renderer = renderer;
        this._pixelRatio = renderer.getPixelRatio();
        if (renderTarget === undefined) {
            const size = renderer.getSize(new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)());
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $9ddd7e9b53f7a2d4$export$3c052beb2e51e23f)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
                type: (0, $9ddd7e9b53f7a2d4$export$2697304443f382bc)
            });
            renderTarget.texture.name = 'EffectComposer.rt1';
        } else {
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = 'EffectComposer.rt2';
        /**
		 * A reference to the internal write buffer. Passes usually write
		 * their result into this buffer.
		 *
		 * @type {WebGLRenderTarget}
		 */ this.writeBuffer = this.renderTarget1;
        /**
		 * A reference to the internal read buffer. Passes usually read
		 * the previous render result from this buffer.
		 *
		 * @type {WebGLRenderTarget}
		 */ this.readBuffer = this.renderTarget2;
        /**
		 * Whether the final pass is rendered to the screen (default framebuffer) or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.renderToScreen = true;
        /**
		 * An array representing the (ordered) chain of post-processing passes.
		 *
		 * @type {Array<Pass>}
		 */ this.passes = [];
        /**
		 * A copy pass used for internal swap operations.
		 *
		 * @private
		 * @type {ShaderPass}
		 */ this.copyPass = new (0, $6ac47a3de6300e1f$export$c55093fd4f9e42f0)((0, $2f93ac2d46312da9$export$57f84a24a9a6130d));
        this.copyPass.material.blending = (0, $9ddd7e9b53f7a2d4$export$63b8d6b580fc65ba);
        /**
		 * The internal timer for managing time data.
		 *
		 * @private
		 * @type {Timer}
		 */ this.timer = new (0, $9ddd7e9b53f7a2d4$export$c57e9b2d8b9e4de)();
    }
    /**
	 * Swaps the internal read/write buffers.
	 */ swapBuffers() {
        const tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    }
    /**
	 * Adds the given pass to the pass chain.
	 *
	 * @param {Pass} pass - The pass to add.
	 */ addPass(pass) {
        this.passes.push(pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    /**
	 * Inserts the given pass at a given index.
	 *
	 * @param {Pass} pass - The pass to insert.
	 * @param {number} index - The index into the pass chain.
	 */ insertPass(pass, index) {
        this.passes.splice(index, 0, pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    /**
	 * Removes the given pass from the pass chain.
	 *
	 * @param {Pass} pass - The pass to remove.
	 */ removePass(pass) {
        const index = this.passes.indexOf(pass);
        if (index !== -1) this.passes.splice(index, 1);
    }
    /**
	 * Returns `true` if the pass for the given index is the last enabled pass in the pass chain.
	 *
	 * @param {number} passIndex - The pass index.
	 * @return {boolean} Whether the pass for the given index is the last pass in the pass chain.
	 */ isLastEnabledPass(passIndex) {
        for(let i = passIndex + 1; i < this.passes.length; i++){
            if (this.passes[i].enabled) return false;
        }
        return true;
    }
    /**
	 * Executes all enabled post-processing passes in order to produce the final frame.
	 *
	 * @param {number} deltaTime - The delta time in seconds. If not given, the composer computes
	 * its own time delta value.
	 */ render(deltaTime) {
        // deltaTime value is in seconds
        this.timer.update();
        if (deltaTime === undefined) deltaTime = this.timer.getDelta();
        const currentRenderTarget = this.renderer.getRenderTarget();
        let maskActive = false;
        for(let i = 0, il = this.passes.length; i < il; i++){
            const pass = this.passes[i];
            if (pass.enabled === false) continue;
            pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    const context = this.renderer.getContext();
                    const stencil = this.renderer.state.buffers.stencil;
                    //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                    //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if ((0, $0f4907a355572481$export$bb424a4005d6dde0) !== undefined) {
                if (pass instanceof (0, $0f4907a355572481$export$bb424a4005d6dde0)) maskActive = true;
                else if (pass instanceof (0, $0f4907a355572481$export$8d8650aed29c6251)) maskActive = false;
            }
        }
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    /**
	 * Resets the internal state of the EffectComposer.
	 *
	 * @param {WebGLRenderTarget} [renderTarget] - This render target has the same purpose like
	 * the one from the constructor. If set, it is used to setup the read and write buffers.
	 */ reset(renderTarget) {
        if (renderTarget === undefined) {
            const size = this.renderer.getSize(new (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1)());
            this._pixelRatio = this.renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = this.renderTarget1.clone();
            renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
        }
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    /**
	 * Resizes the internal read and write buffers as well as all passes. Similar to {@link WebGLRenderer#setSize},
	 * this method honors the current pixel ration.
	 *
	 * @param {number} width - The width in logical pixels.
	 * @param {number} height - The height in logical pixels.
	 */ setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
        this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
        for(let i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
    }
    /**
	 * Sets device pixel ratio. This is usually used for HiDPI device to prevent blurring output.
	 * Setting the pixel ratio will automatically resize the composer.
	 *
	 * @param {number} pixelRatio - The pixel ratio to set.
	 */ setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever the composer is no longer used in your app.
	 */ dispose() {
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.copyPass.dispose();
    }
}




/**
 * This class represents a render pass. It takes a camera and a scene and produces
 * a beauty pass for subsequent post processing effects.
 *
 * ```js
 * const renderPass = new RenderPass( scene, camera );
 * composer.addPass( renderPass );
 * ```
 *
 * @augments Pass
 * @three_import import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
 */ class $f4d3a60efece63cd$export$f63ea822f020b5b0 extends (0, $0a1d3a5a6a49de03$export$802bc10488da99c7) {
    /**
	 * Constructs a new render pass.
	 *
	 * @param {Scene} scene - The scene to render.
	 * @param {Camera} camera - The camera.
	 * @param {?Material} [overrideMaterial=null] - The override material. If set, this material is used
	 * for all objects in the scene.
	 * @param {?(number|Color|string)} [clearColor=null] - The clear color of the render pass.
	 * @param {?number} [clearAlpha=null] - The clear alpha of the render pass.
	 */ constructor(scene, camera, overrideMaterial = null, clearColor = null, clearAlpha = null){
        super();
        /**
		 * The scene to render.
		 *
		 * @type {Scene}
		 */ this.scene = scene;
        /**
		 * The camera.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The override material. If set, this material is used
		 * for all objects in the scene.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = overrideMaterial;
        /**
		 * The clear color of the render pass.
		 *
		 * @type {?(number|Color|string)}
		 * @default null
		 */ this.clearColor = clearColor;
        /**
		 * The clear alpha of the render pass.
		 *
		 * @type {?number}
		 * @default null
		 */ this.clearAlpha = clearAlpha;
        /**
		 * Overwritten to perform a clear operation by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.clear = true;
        /**
		 * If set to `true`, only the depth can be cleared when `clear` is to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clearDepth = false;
        /**
		 * Overwritten to disable the swap.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsSwap = false;
        /**
		 * This flag indicates that this pass renders the scene itself.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderPass = true;
        this._oldClearColor = new (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e)();
    }
    /**
	 * Performs a beauty pass with the configured scene and camera.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGLRenderTarget} writeBuffer - The write buffer. This buffer is intended as the rendering
	 * destination for the pass.
	 * @param {WebGLRenderTarget} readBuffer - The read buffer. The pass can access the result from the
	 * previous pass from this buffer.
	 * @param {number} deltaTime - The delta time in seconds.
	 * @param {boolean} maskActive - Whether masking is active or not.
	 */ render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        let oldClearAlpha, oldOverrideMaterial;
        if (this.overrideMaterial !== null) {
            oldOverrideMaterial = this.scene.overrideMaterial;
            this.scene.overrideMaterial = this.overrideMaterial;
        }
        if (this.clearColor !== null) {
            renderer.getClearColor(this._oldClearColor);
            renderer.setClearColor(this.clearColor, renderer.getClearAlpha());
        }
        if (this.clearAlpha !== null) {
            oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearAlpha(this.clearAlpha);
        }
        if (this.clearDepth == true) renderer.clearDepth();
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        if (this.clear === true) // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
        renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        renderer.render(this.scene, this.camera);
        // restore
        if (this.clearColor !== null) renderer.setClearColor(this._oldClearColor);
        if (this.clearAlpha !== null) renderer.setClearAlpha(oldClearAlpha);
        if (this.overrideMaterial !== null) this.scene.overrideMaterial = oldOverrideMaterial;
        renderer.autoClear = oldAutoClear;
    }
}


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}



function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $b2099f49db83e2df$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $7fc69e80a314c4c3$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $a01f1d6c8bd49d36$export$2e2bcd8739ae039)(t, arguments, (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}


function $c5db23e5823ab236$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}


function $c4f699b4a01e0372$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $c4f699b4a01e0372$var$negation(a) {
    return -a;
}
function $c4f699b4a01e0372$var$addition(a, b) {
    return a + b;
}
function $c4f699b4a01e0372$var$subtraction(a, b) {
    return a - b;
}
function $c4f699b4a01e0372$var$multiplication(a, b) {
    return a * b;
}
function $c4f699b4a01e0372$var$division(a, b) {
    return a / b;
}
function $c4f699b4a01e0372$var$max() {
    return Math.max.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$min() {
    return Math.min.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $c4f699b4a01e0372$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $c4f699b4a01e0372$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $c4f699b4a01e0372$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $c4f699b4a01e0372$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $c4f699b4a01e0372$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $c4f699b4a01e0372$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $c4f699b4a01e0372$var$defaultSymbolMap = $c4f699b4a01e0372$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $c4f699b4a01e0372$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $c4f699b4a01e0372$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $c4f699b4a01e0372$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039)(Error));
var $c4f699b4a01e0372$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $c4f699b4a01e0372$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $c4f699b4a01e0372$var$calculate(expression, additionalSymbols) {
    var symbolMap = $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $c4f699b4a01e0372$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($c4f699b4a01e0372$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $c4f699b4a01e0372$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $c4f699b4a01e0372$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $c4f699b4a01e0372$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $c4f699b4a01e0372$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $c4f699b4a01e0372$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $c4f699b4a01e0372$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $c4f699b4a01e0372$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($c4f699b4a01e0372$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $c4f699b4a01e0372$var$PolishedError(41);
    var cleanFormula = $c4f699b4a01e0372$var$reverseString(reversedFormula.replace($c4f699b4a01e0372$var$unitRegExp, ''));
    return "" + $c4f699b4a01e0372$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $c4f699b4a01e0372$var$reverseString(formulaMatch[0]) : '');
}
var $c4f699b4a01e0372$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $c4f699b4a01e0372$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($c4f699b4a01e0372$var$cssVariableRegex)) throw new $c4f699b4a01e0372$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $c4f699b4a01e0372$var$PolishedError(74);
}
// @private
function $c4f699b4a01e0372$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $c4f699b4a01e0372$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $c4f699b4a01e0372$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $c4f699b4a01e0372$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$c4f699b4a01e0372$var$generateProperty(property, $c4f699b4a01e0372$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $c4f699b4a01e0372$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $c4f699b4a01e0372$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $c4f699b4a01e0372$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $c4f699b4a01e0372$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(pxval, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(69, to, pxval);
            newPxval = $c4f699b4a01e0372$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(base, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(70, to, base);
            newBase = $c4f699b4a01e0372$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $c4f699b4a01e0372$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $c4f699b4a01e0372$var$pixelsto = $c4f699b4a01e0372$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $c4f699b4a01e0372$var$em = $c4f699b4a01e0372$var$pixelsto('em');
var $c4f699b4a01e0372$export$c63c6f932822f543 = $c4f699b4a01e0372$var$em;
var $c4f699b4a01e0372$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $c4f699b4a01e0372$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new $c4f699b4a01e0372$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $c4f699b4a01e0372$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $c4f699b4a01e0372$var$getRatio(ratioName) {
    return $c4f699b4a01e0372$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $c4f699b4a01e0372$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $c4f699b4a01e0372$var$PolishedError(42);
    if (typeof ratio === 'string' && !$c4f699b4a01e0372$var$ratioNames[ratio]) throw new $c4f699b4a01e0372$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $c4f699b4a01e0372$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $c4f699b4a01e0372$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $c4f699b4a01e0372$var$rem = $c4f699b4a01e0372$var$pixelsto('rem');
var $c4f699b4a01e0372$export$fb1897a40d146f7f = $c4f699b4a01e0372$var$rem;
var $c4f699b4a01e0372$var$defaultFontSize = 16;
function $c4f699b4a01e0372$var$convertBase(base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $c4f699b4a01e0372$var$defaultFontSize;
    throw new $c4f699b4a01e0372$var$PolishedError(78, deconstructedValue[1]);
}
function $c4f699b4a01e0372$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $c4f699b4a01e0372$var$convertBase(rootFontSize) : $c4f699b4a01e0372$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $c4f699b4a01e0372$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $c4f699b4a01e0372$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $c4f699b4a01e0372$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $c4f699b4a01e0372$var$convertBase(base) : $c4f699b4a01e0372$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $c4f699b4a01e0372$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$929e5a82286172a6(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $c4f699b4a01e0372$export$c07234257a03d5e9(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $c4f699b4a01e0372$export$57636bb43b1ccbb0(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $c4f699b4a01e0372$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $c4f699b4a01e0372$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $c4f699b4a01e0372$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $c4f699b4a01e0372$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $c4f699b4a01e0372$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $c4f699b4a01e0372$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $c4f699b4a01e0372$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $c4f699b4a01e0372$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c4f699b4a01e0372$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4f699b4a01e0372$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
}
function $c4f699b4a01e0372$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $c4f699b4a01e0372$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new $c4f699b4a01e0372$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $c4f699b4a01e0372$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $c4f699b4a01e0372$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $c4f699b4a01e0372$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $c4f699b4a01e0372$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $c4f699b4a01e0372$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $c4f699b4a01e0372$var$formatHintMap[format] + "\")";
}
function $c4f699b4a01e0372$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($c4f699b4a01e0372$var$dataURIRegex);
}
function $c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($c4f699b4a01e0372$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $c4f699b4a01e0372$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $c4f699b4a01e0372$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($c4f699b4a01e0372$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $c4f699b4a01e0372$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $c4f699b4a01e0372$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $c4f699b4a01e0372$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $c4f699b4a01e0372$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $c4f699b4a01e0372$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $c4f699b4a01e0372$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $c4f699b4a01e0372$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $c4f699b4a01e0372$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $c4f699b4a01e0372$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $c4f699b4a01e0372$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject$1 || ($c4f699b4a01e0372$var$_templateObject$1 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $c4f699b4a01e0372$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $c4f699b4a01e0372$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject || ($c4f699b4a01e0372$var$_templateObject = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $c4f699b4a01e0372$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $c4f699b4a01e0372$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$c4f699b4a01e0372$export$e79006618d7c6cc3()] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $c4f699b4a01e0372$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $c4f699b4a01e0372$var$getTimingFunction(functionName) {
    return $c4f699b4a01e0372$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$61210fa83792a81(timingFunction) {
    return $c4f699b4a01e0372$var$getTimingFunction(timingFunction);
}
var $c4f699b4a01e0372$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $c4f699b4a01e0372$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $c4f699b4a01e0372$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $c4f699b4a01e0372$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(width);
    var heightAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $c4f699b4a01e0372$var$PolishedError(60);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $c4f699b4a01e0372$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $c4f699b4a01e0372$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $c4f699b4a01e0372$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $c4f699b4a01e0372$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $c4f699b4a01e0372$var$convertToInt(red, green, blue) {
    return $c4f699b4a01e0372$var$colorToInt(red) + "," + $c4f699b4a01e0372$var$colorToInt(green) + "," + $c4f699b4a01e0372$var$colorToInt(blue);
}
function $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $c4f699b4a01e0372$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $c4f699b4a01e0372$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $c4f699b4a01e0372$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] ? "#" + $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] : color;
}
var $c4f699b4a01e0372$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $c4f699b4a01e0372$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $c4f699b4a01e0372$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $c4f699b4a01e0372$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $c4f699b4a01e0372$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $c4f699b4a01e0372$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $c4f699b4a01e0372$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $c4f699b4a01e0372$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $c4f699b4a01e0372$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(3);
    var normalizedColor = $c4f699b4a01e0372$var$nameToHex(color);
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $c4f699b4a01e0372$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $c4f699b4a01e0372$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $c4f699b4a01e0372$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $c4f699b4a01e0372$var$PolishedError(5);
}
function $c4f699b4a01e0372$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $c4f699b4a01e0372$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $c4f699b4a01e0372$var$rgbToHsl($c4f699b4a01e0372$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $c4f699b4a01e0372$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $c4f699b4a01e0372$var$reduceHexValue$1 = $c4f699b4a01e0372$var$reduceHexValue;
function $c4f699b4a01e0372$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $c4f699b4a01e0372$var$colorToHex(color) {
    return $c4f699b4a01e0372$var$numberToHex(Math.round(color * 255));
}
function $c4f699b4a01e0372$var$convertToHex(red, green, blue) {
    return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$colorToHex(red) + $c4f699b4a01e0372$var$colorToHex(green) + $c4f699b4a01e0372$var$colorToHex(blue));
}
function $c4f699b4a01e0372$var$hslToHex(hue, saturation, lightness) {
    return $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, $c4f699b4a01e0372$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $c4f699b4a01e0372$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $c4f699b4a01e0372$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value) + $c4f699b4a01e0372$var$numberToHex(green) + $c4f699b4a01e0372$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value.red) + $c4f699b4a01e0372$var$numberToHex(value.green) + $c4f699b4a01e0372$var$numberToHex(value.blue));
    throw new $c4f699b4a01e0372$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $c4f699b4a01e0372$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(7);
}
var $c4f699b4a01e0372$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $c4f699b4a01e0372$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new $c4f699b4a01e0372$var$PolishedError(8);
    if ($c4f699b4a01e0372$var$isRgba(color)) return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(color);
    if ($c4f699b4a01e0372$var$isRgb(color)) return $c4f699b4a01e0372$export$8972dc0e6ad9238f(color);
    if ($c4f699b4a01e0372$var$isHsla(color)) return $c4f699b4a01e0372$export$810b04175080204c(color);
    if ($c4f699b4a01e0372$var$isHsl(color)) return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(color);
    throw new $c4f699b4a01e0372$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $c4f699b4a01e0372$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $c4f699b4a01e0372$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedAdjustHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$adjustHue);
var $c4f699b4a01e0372$export$2b372a09365374d6 = $c4f699b4a01e0372$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $c4f699b4a01e0372$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDarken = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$darken);
var $c4f699b4a01e0372$export$4b073707ff63303 = $c4f699b4a01e0372$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDesaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$desaturate);
var $c4f699b4a01e0372$export$fb75607d98509d9 = $c4f699b4a01e0372$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $c4f699b4a01e0372$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $c4f699b4a01e0372$export$c852d90bf7403b62(color1);
    var luminance2 = $c4f699b4a01e0372$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$97fc773b219a4ae(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $c4f699b4a01e0372$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedLighten = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$lighten);
var $c4f699b4a01e0372$export$c0816ed86df316af = $c4f699b4a01e0372$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $c4f699b4a01e0372$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $c4f699b4a01e0372$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var color1 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $c4f699b4a01e0372$export$2f48baff6995707a(otherColor);
    var color2 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedMix = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string, string> */ ($c4f699b4a01e0372$var$mix);
var $c4f699b4a01e0372$export$2c9e8a9632a706b2 = $c4f699b4a01e0372$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedOpacify = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$opacify);
var $c4f699b4a01e0372$export$f4f50e3877dd0530 = $c4f699b4a01e0372$var$curriedOpacify;
var $c4f699b4a01e0372$var$defaultReturnIfLightColor = '#000';
var $c4f699b4a01e0372$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $c4f699b4a01e0372$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $c4f699b4a01e0372$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $c4f699b4a01e0372$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $c4f699b4a01e0372$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $c4f699b4a01e0372$var$defaultReturnIfLightColor : $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$34b0917fcca19deb(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $c4f699b4a01e0372$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$saturate);
var $c4f699b4a01e0372$export$5fcac96f5a87e3db = $c4f699b4a01e0372$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setHue);
var $c4f699b4a01e0372$export$3bf58ce3e497a846 = $c4f699b4a01e0372$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetLightness = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setLightness);
var $c4f699b4a01e0372$export$7ef5d725337b805d = $c4f699b4a01e0372$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetSaturation = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setSaturation);
var $c4f699b4a01e0372$export$b40fe421ea7a4f7e = $c4f699b4a01e0372$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $c4f699b4a01e0372$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedShade = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$shade);
var $c4f699b4a01e0372$export$3e32adda0df4ef5d = $c4f699b4a01e0372$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $c4f699b4a01e0372$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTint = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$tint);
var $c4f699b4a01e0372$export$fc176dd65a27d98b = $c4f699b4a01e0372$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $c4f699b4a01e0372$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTransparentize = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$transparentize);
var $c4f699b4a01e0372$export$d11da87e55cc498f = $c4f699b4a01e0372$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $c4f699b4a01e0372$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $c4f699b4a01e0372$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $c4f699b4a01e0372$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $c4f699b4a01e0372$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $c4f699b4a01e0372$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $c4f699b4a01e0372$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $c4f699b4a01e0372$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $c4f699b4a01e0372$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $c4f699b4a01e0372$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $c4f699b4a01e0372$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $c4f699b4a01e0372$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $c4f699b4a01e0372$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $c4f699b4a01e0372$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $c4f699b4a01e0372$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $c4f699b4a01e0372$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $c4f699b4a01e0372$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $c4f699b4a01e0372$var$PolishedError(67);
    if (states.length === 0) return $c4f699b4a01e0372$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $c4f699b4a01e0372$var$PolishedError(68);
        selectors.push($c4f699b4a01e0372$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $c4f699b4a01e0372$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template$1, $c4f699b4a01e0372$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $c4f699b4a01e0372$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $c4f699b4a01e0372$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($c4f699b4a01e0372$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $c4f699b4a01e0372$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $c4f699b4a01e0372$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template, $c4f699b4a01e0372$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $c4f699b4a01e0372$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}



var $8PNKb = parcelRequire("8PNKb");



function $69c9538f9a62b4e8$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $69c9538f9a62b4e8$var$css_248z = ".scene-nav-info {\n  position: absolute;\n  bottom: 5px;\n  width: 100%;\n  text-align: center;\n  color: slategrey;\n  opacity: 0.7;\n  font-size: 10px;\n  font-family: sans-serif;\n  pointer-events: none;\n  user-select: none;\n}\n\n.scene-container canvas:focus {\n  outline: none;\n}";
$69c9538f9a62b4e8$var$styleInject($69c9538f9a62b4e8$var$css_248z);
function $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $69c9538f9a62b4e8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $69c9538f9a62b4e8$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $69c9538f9a62b4e8$var$_arrayLikeToArray(r);
}
function $69c9538f9a62b4e8$var$_defineProperty(e, r, t) {
    return (r = $69c9538f9a62b4e8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $69c9538f9a62b4e8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $69c9538f9a62b4e8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $69c9538f9a62b4e8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69c9538f9a62b4e8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $69c9538f9a62b4e8$var$_slicedToArray(r, e) {
    return $69c9538f9a62b4e8$var$_arrayWithHoles(r) || $69c9538f9a62b4e8$var$_iterableToArrayLimit(r, e) || $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r, e) || $69c9538f9a62b4e8$var$_nonIterableRest();
}
function $69c9538f9a62b4e8$var$_toConsumableArray(r) {
    return $69c9538f9a62b4e8$var$_arrayWithoutHoles(r) || $69c9538f9a62b4e8$var$_iterableToArray(r) || $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r) || $69c9538f9a62b4e8$var$_nonIterableSpread();
}
function $69c9538f9a62b4e8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $69c9538f9a62b4e8$var$_toPropertyKey(t) {
    var i = $69c9538f9a62b4e8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $69c9538f9a62b4e8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $69c9538f9a62b4e8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $69c9538f9a62b4e8$var$_materialDispose = function materialDispose(material) {
    if (material instanceof Array) material.forEach($69c9538f9a62b4e8$var$_materialDispose);
    else {
        if (material.map) material.map.dispose();
        material.dispose();
    }
};
var $69c9538f9a62b4e8$var$_deallocate = function deallocate(obj) {
    if (obj.geometry) obj.geometry.dispose();
    if (obj.material) $69c9538f9a62b4e8$var$_materialDispose(obj.material);
    if (obj.texture) obj.texture.dispose();
    if (obj.children) obj.children.forEach($69c9538f9a62b4e8$var$_deallocate);
};
var $69c9538f9a62b4e8$var$emptyObject = function emptyObject(obj) {
    while(obj.children.length){
        var childObj = obj.children[0];
        obj.remove(childObj);
        $69c9538f9a62b4e8$var$_deallocate(childObj);
    }
};
var $69c9538f9a62b4e8$var$three = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    WebGLRenderer: (0, $d5b33d7c30034067$export$f6cc00ef28d7cf97),
    Scene: (0, $9ddd7e9b53f7a2d4$export$38af1803e3442a7f),
    PerspectiveCamera: (0, $9ddd7e9b53f7a2d4$export$74e4ae24825f68d7),
    Raycaster: (0, $9ddd7e9b53f7a2d4$export$8b7aaceff00bd2f),
    SRGBColorSpace: (0, $9ddd7e9b53f7a2d4$export$561f394b24edfcaa),
    TextureLoader: (0, $9ddd7e9b53f7a2d4$export$fd1bfc71f64c538c),
    Vector2: (0, $9ddd7e9b53f7a2d4$export$c977b3e384af9ae1),
    Vector3: (0, $9ddd7e9b53f7a2d4$export$64b5c384219d3699),
    Box3: (0, $9ddd7e9b53f7a2d4$export$6f7d5a9418ab2aa3),
    Color: (0, $9ddd7e9b53f7a2d4$export$892596cec99bc70e),
    Mesh: (0, $9ddd7e9b53f7a2d4$export$e176487c05830cc5),
    SphereGeometry: (0, $9ddd7e9b53f7a2d4$export$1b417fc3b307a251),
    MeshBasicMaterial: (0, $9ddd7e9b53f7a2d4$export$55cbcc9b622fe1f5),
    BackSide: (0, $9ddd7e9b53f7a2d4$export$d9f0486e75b5ace),
    Timer: (0, $9ddd7e9b53f7a2d4$export$c57e9b2d8b9e4de)
};
var $69c9538f9a62b4e8$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: {
        width: {
            "default": window.innerWidth,
            onChange: function onChange(width, state, prevWidth) {
                isNaN(width) && (state.width = prevWidth);
            }
        },
        height: {
            "default": window.innerHeight,
            onChange: function onChange(height, state, prevHeight) {
                isNaN(height) && (state.height = prevHeight);
            }
        },
        viewOffset: {
            "default": [
                0,
                0
            ]
        },
        backgroundColor: {
            "default": '#000011'
        },
        backgroundImageUrl: {},
        onBackgroundImageLoaded: {},
        showNavInfo: {
            "default": true
        },
        skyRadius: {
            "default": 50000
        },
        objects: {
            "default": []
        },
        lights: {
            "default": []
        },
        enablePointerInteraction: {
            "default": true,
            onChange: function onChange(_, state) {
                // Reset hover state
                state.hoverObj = null;
                state.tooltip && state.tooltip.content(null);
            },
            triggerUpdate: false
        },
        pointerRaycasterThrottleMs: {
            "default": 50,
            triggerUpdate: false
        },
        lineHoverPrecision: {
            "default": 1,
            triggerUpdate: false
        },
        pointsHoverPrecision: {
            "default": 1,
            triggerUpdate: false
        },
        hoverOrderComparator: {
            triggerUpdate: false
        },
        // keep existing order by default
        hoverFilter: {
            "default": function _default() {
                return true;
            },
            triggerUpdate: false
        },
        // exclude objects from interaction
        tooltipContent: {
            triggerUpdate: false
        },
        hoverDuringDrag: {
            "default": false,
            triggerUpdate: false
        },
        clickAfterDrag: {
            "default": false,
            triggerUpdate: false
        },
        onHover: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onClick: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onRightClick: {
            triggerUpdate: false
        }
    },
    methods: {
        tick: function tick(state) {
            if (state.initialised) {
                state.controls.enabled && state.controls.update && state.controls.update(Math.min(1, state.timer.update().getDelta())); // timedelta is required for fly controls
                state.postProcessingComposer ? state.postProcessingComposer.render() // if using postprocessing, switch the output to it
                 : state.renderer.render(state.scene, state.camera);
                state.extraRenderers.forEach(function(r) {
                    return r.render(state.scene, state.camera);
                });
                var now = +new Date();
                if (state.enablePointerInteraction && now - state.lastRaycasterCheck >= state.pointerRaycasterThrottleMs) {
                    state.lastRaycasterCheck = now;
                    // Update tooltip and trigger onHover events
                    var topObject = null;
                    if (state.hoverDuringDrag || !state.isPointerDragging) {
                        var intersects = this.intersectingObjects(state.pointerPos.x, state.pointerPos.y);
                        state.hoverOrderComparator && intersects.sort(function(a, b) {
                            return state.hoverOrderComparator(a.object, b.object);
                        });
                        var topIntersect = intersects.find(function(d) {
                            return state.hoverFilter(d.object);
                        }) || null;
                        topObject = topIntersect ? topIntersect.object : null;
                        state.intersection = topIntersect || null;
                    }
                    if (topObject !== state.hoverObj) {
                        state.onHover(topObject, state.hoverObj, state.intersection);
                        state.tooltip.content(topObject ? (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.tooltipContent)(topObject, state.intersection) || null : null);
                        state.hoverObj = topObject;
                    }
                }
                state.tweenGroup.update(); // update camera animation tweens
            }
            return this;
        },
        getPointerPos: function getPointerPos(state) {
            var _state$pointerPos = state.pointerPos, x = _state$pointerPos.x, y = _state$pointerPos.y;
            return {
                x: x,
                y: y
            };
        },
        cameraPosition: function cameraPosition(state, position, lookAt, transitionDuration) {
            var camera = state.camera;
            // Setter
            if (position && state.initialised) {
                var finalPos = position;
                var finalLookAt = lookAt || {
                    x: 0,
                    y: 0,
                    z: 0
                };
                if (!transitionDuration) {
                    // no animation
                    setCameraPos(finalPos);
                    setLookAt(finalLookAt);
                } else {
                    var camPos = Object.assign({}, camera.position);
                    var camLookAt = getLookAt();
                    state.tweenGroup.add(new (0, $8PNKb.Tween)(camPos).to(finalPos, transitionDuration).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(setCameraPos).onComplete(function() {
                        state.tweenGroup.remove(this);
                    }).start());
                    // Face direction in 1/3rd of time
                    state.tweenGroup.add(new (0, $8PNKb.Tween)(camLookAt).to(finalLookAt, transitionDuration / 3).easing((0, $8PNKb.Easing).Quadratic.Out).onUpdate(setLookAt).onComplete(function() {
                        state.tweenGroup.remove(this);
                    }).start());
                }
                return this;
            }
            // Getter
            return Object.assign({}, camera.position, {
                lookAt: getLookAt()
            });
            //
            function setCameraPos(pos) {
                var x = pos.x, y = pos.y, z = pos.z;
                if (x !== undefined) camera.position.x = x;
                if (y !== undefined) camera.position.y = y;
                if (z !== undefined) camera.position.z = z;
            }
            function setLookAt(lookAt) {
                var lookAtVect = new $69c9538f9a62b4e8$var$three.Vector3(lookAt.x, lookAt.y, lookAt.z);
                if (state.controls.enabled && state.controls.target) state.controls.target = lookAtVect;
                else // Fly controls doesn't have target attribute
                camera.lookAt(lookAtVect); // note: lookAt may be overridden by other controls in some cases
            }
            function getLookAt() {
                return Object.assign(new $69c9538f9a62b4e8$var$three.Vector3(0, 0, -1000).applyQuaternion(camera.quaternion).add(camera.position));
            }
        },
        zoomToFit: function zoomToFit(state) {
            var transitionDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
            for(var _len = arguments.length, bboxArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)bboxArgs[_key - 3] = arguments[_key];
            return this.fitToBbox(this.getBbox.apply(this, bboxArgs), transitionDuration, padding);
        },
        fitToBbox: function fitToBbox(state, bbox) {
            var transitionDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var padding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
            // based on https://discourse.threejs.org/t/camera-zoom-to-fit-object/936/24
            var camera = state.camera;
            if (bbox) {
                var center = new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0); // reset camera aim to center
                var maxBoxSide = Math.max.apply(Math, $69c9538f9a62b4e8$var$_toConsumableArray(Object.entries(bbox).map(function(_ref) {
                    var _ref2 = $69c9538f9a62b4e8$var$_slicedToArray(_ref, 2), coordType = _ref2[0], coords = _ref2[1];
                    return Math.max.apply(Math, $69c9538f9a62b4e8$var$_toConsumableArray(coords.map(function(c) {
                        return Math.abs(center[coordType] - c);
                    })));
                }))) * 2;
                // find distance that fits whole bbox within padded fov
                var paddedFov = (1 - padding * 2 / state.height) * camera.fov;
                var fitHeightDistance = maxBoxSide / Math.atan(paddedFov * Math.PI / 180);
                var fitWidthDistance = fitHeightDistance / camera.aspect;
                var distance = Math.max(fitHeightDistance, fitWidthDistance);
                if (distance > 0) {
                    var newCameraPosition = center.clone().sub(camera.position).normalize().multiplyScalar(-distance);
                    this.cameraPosition(newCameraPosition, center, transitionDuration);
                }
            }
            return this;
        },
        getBbox: function getBbox(state) {
            var objFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                return true;
            };
            var box = new $69c9538f9a62b4e8$var$three.Box3(new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0), new $69c9538f9a62b4e8$var$three.Vector3(0, 0, 0));
            var objs = state.objects.filter(objFilter);
            if (!objs.length) return null;
            objs.forEach(function(obj) {
                return box.expandByObject(obj);
            });
            // extract global x,y,z min/max
            return Object.assign.apply(Object, $69c9538f9a62b4e8$var$_toConsumableArray([
                'x',
                'y',
                'z'
            ].map(function(c) {
                return $69c9538f9a62b4e8$var$_defineProperty({}, c, [
                    box.min[c],
                    box.max[c]
                ]);
            })));
        },
        getScreenCoords: function getScreenCoords(state, x, y, z) {
            var vec = new $69c9538f9a62b4e8$var$three.Vector3(x, y, z);
            vec.project(this.camera()); // project to the camera plane
            return {
                // align relative pos to canvas dimensions
                x: (vec.x + 1) * state.width / 2,
                y: -(vec.y - 1) * state.height / 2
            };
        },
        getSceneCoords: function getSceneCoords(state, screenX, screenY) {
            var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var relCoords = new $69c9538f9a62b4e8$var$three.Vector2(screenX / state.width * 2 - 1, -(screenY / state.height) * 2 + 1);
            var raycaster = new $69c9538f9a62b4e8$var$three.Raycaster();
            raycaster.setFromCamera(relCoords, state.camera);
            return Object.assign({}, raycaster.ray.at(distance, new $69c9538f9a62b4e8$var$three.Vector3()));
        },
        intersectingObjects: function intersectingObjects(state, x, y) {
            var relCoords = new $69c9538f9a62b4e8$var$three.Vector2(x / state.width * 2 - 1, -(y / state.height) * 2 + 1);
            var raycaster = new $69c9538f9a62b4e8$var$three.Raycaster();
            raycaster.params.Line.threshold = state.lineHoverPrecision; // set linePrecision
            raycaster.params.Points.threshold = state.pointsHoverPrecision; // set pointsPrecision
            raycaster.setFromCamera(relCoords, state.camera);
            return raycaster.intersectObjects(state.objects, true);
        },
        renderer: function renderer(state) {
            return state.renderer;
        },
        scene: function scene(state) {
            return state.scene;
        },
        camera: function camera(state) {
            return state.camera;
        },
        postProcessingComposer: function postProcessingComposer(state) {
            return state.postProcessingComposer;
        },
        controls: function controls(state) {
            return state.controls;
        },
        tbControls: function tbControls(state) {
            return state.controls;
        },
        // to be deprecated
        _destructor: function _destructor(state) {
            var _state$controls, _state$renderer, _state$postProcessing;
            $69c9538f9a62b4e8$var$emptyObject(state.scene);
            (_state$controls = state.controls) === null || _state$controls === void 0 || _state$controls.dispose();
            (_state$renderer = state.renderer) === null || _state$renderer === void 0 || _state$renderer.dispose();
            (_state$postProcessing = state.postProcessingComposer) === null || _state$postProcessing === void 0 || _state$postProcessing.dispose();
        }
    },
    stateInit: function stateInit() {
        return {
            scene: new $69c9538f9a62b4e8$var$three.Scene(),
            camera: new $69c9538f9a62b4e8$var$three.PerspectiveCamera(),
            timer: new $69c9538f9a62b4e8$var$three.Timer(),
            tweenGroup: new (0, $8PNKb.Group)(),
            lastRaycasterCheck: 0
        };
    },
    init: function init(domNode, state) {
        var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref4$controlType = _ref4.controlType, controlType = _ref4$controlType === void 0 ? 'trackball' : _ref4$controlType, _ref4$useWebGPU = _ref4.useWebGPU, useWebGPU = _ref4$useWebGPU === void 0 ? false : _ref4$useWebGPU, _ref4$rendererConfig = _ref4.rendererConfig, rendererConfig = _ref4$rendererConfig === void 0 ? {} : _ref4$rendererConfig, _ref4$extraRenderers = _ref4.extraRenderers, extraRenderers = _ref4$extraRenderers === void 0 ? [] : _ref4$extraRenderers, _ref4$waitForLoadComp = _ref4.waitForLoadComplete, waitForLoadComplete = _ref4$waitForLoadComp === void 0 ? true : _ref4$waitForLoadComp;
        // Wipe DOM
        domNode.innerHTML = '';
        // Add relative container
        domNode.appendChild(state.container = document.createElement('div'));
        state.container.className = 'scene-container';
        state.container.style.position = 'relative';
        // Add nav info section
        state.container.appendChild(state.navInfo = document.createElement('div'));
        state.navInfo.className = 'scene-nav-info';
        state.navInfo.textContent = ({
            orbit: 'Left-click: rotate, Mouse-wheel/middle-click: zoom, Right-click: pan',
            trackball: 'Left-click: rotate, Mouse-wheel/middle-click: zoom, Right-click: pan',
            fly: 'WASD: move, R|F: up | down, Q|E: roll, up|down: pitch, left|right: yaw'
        })[controlType] || '';
        state.navInfo.style.display = state.showNavInfo ? null : 'none';
        // Setup tooltip
        state.tooltip = new (0, $9a9373909b03959a$export$2e2bcd8739ae039)(state.container);
        // Capture pointer coords on move or touchstart
        state.pointerPos = new $69c9538f9a62b4e8$var$three.Vector2();
        state.pointerPos.x = -2; // Initialize off canvas
        state.pointerPos.y = -2;
        [
            'pointermove',
            'pointerdown'
        ].forEach(function(evType) {
            return state.container.addEventListener(evType, function(ev) {
                // track click state
                evType === 'pointerdown' && (state.isPointerPressed = true);
                // detect point drag
                !state.isPointerDragging && ev.type === 'pointermove' && (ev.pressure > 0 || state.isPointerPressed // ev.pressure always 0 on Safari, so we used the isPointerPressed tracker
                ) && (ev.pointerType === 'mouse' || ev.movementX === undefined || [
                    ev.movementX,
                    ev.movementY
                ].some(function(m) {
                    return Math.abs(m) > 1;
                }) // relax drag trigger sensitivity on non-mouse (touch/pen) events
                ) && (state.isPointerDragging = true);
                if (state.enablePointerInteraction) {
                    // update the pointer pos
                    var offset = getOffset(state.container);
                    state.pointerPos.x = ev.pageX - offset.left;
                    state.pointerPos.y = ev.pageY - offset.top;
                }
                function getOffset(el) {
                    var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return {
                        top: rect.top + scrollTop,
                        left: rect.left + scrollLeft
                    };
                }
            }, {
                passive: true
            });
        });
        // Handle click events on objs
        state.container.addEventListener('pointerup', function(ev) {
            if (!state.isPointerPressed) return; // don't trigger click events if pointer is not pressed on the canvas
            state.isPointerPressed = false;
            if (state.isPointerDragging) {
                state.isPointerDragging = false;
                if (!state.clickAfterDrag) return; // don't trigger onClick after pointer drag (camera motion via controls)
            }
            requestAnimationFrame(function() {
                // trigger click events asynchronously, to allow hoverObj to be set (on frame)
                if (ev.button === 0) // left-click
                state.onClick(state.hoverObj || null, ev, state.intersection); // trigger background clicks with null
                if (ev.button === 2 && state.onRightClick) // right-click
                state.onRightClick(state.hoverObj || null, ev, state.intersection);
            });
        }, {
            passive: true,
            capture: true
        }); // use capture phase to prevent propagation blocking from controls (specifically for fly)
        state.container.addEventListener('contextmenu', function(ev) {
            if (state.onRightClick) ev.preventDefault(); // prevent default contextmenu behavior and allow pointerup to fire instead
        });
        // Setup renderer, camera and controls
        state.renderer = new (useWebGPU ? (0, $03ccd63b0299d6a7$export$19fd8015bd4822d4) : $69c9538f9a62b4e8$var$three.WebGLRenderer)(Object.assign({
            antialias: true,
            alpha: true
        }, rendererConfig));
        state.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio)); // clamp device pixel ratio
        state.container.appendChild(state.renderer.domElement);
        // Setup extra renderers
        state.extraRenderers = extraRenderers;
        state.extraRenderers.forEach(function(r) {
            // overlay them on top of main renderer
            r.domElement.style.position = 'absolute';
            r.domElement.style.top = '0px';
            r.domElement.style.pointerEvents = 'none';
            state.container.appendChild(r.domElement);
        });
        // configure post-processing composer
        state.postProcessingComposer = new (0, $1f89f80dfbd5e815$export$7fe01e6ab8aa748c)(state.renderer);
        state.postProcessingComposer.addPass(new (0, $f4d3a60efece63cd$export$f63ea822f020b5b0)(state.scene, state.camera)); // render scene as first pass
        // configure controls
        state.controls = new ({
            trackball: (0, $164afa34e4b04624$export$18b7f869be764a91),
            orbit: (0, $443c013b983d0324$export$8ff7788029dfdf52),
            fly: (0, $37d4d287f7c195e5$export$4cec72bd81e75195)
        })[controlType](state.camera, state.renderer.domElement);
        if (controlType === 'fly') {
            state.controls.movementSpeed = 300;
            state.controls.rollSpeed = Math.PI / 6;
            state.controls.dragToLook = true;
        }
        if (controlType === 'trackball' || controlType === 'orbit') {
            state.controls.minDistance = 0.1;
            state.controls.maxDistance = state.skyRadius;
            state.controls.addEventListener('start', function() {
                state.controlsEngaged = true;
            });
            state.controls.addEventListener('change', function() {
                if (state.controlsEngaged) state.controlsDragging = true;
            });
            state.controls.addEventListener('end', function() {
                state.controlsEngaged = false;
                state.controlsDragging = false;
            });
        }
        [
            state.renderer,
            state.postProcessingComposer
        ].concat($69c9538f9a62b4e8$var$_toConsumableArray(state.extraRenderers)).forEach(function(r) {
            return r.setSize(state.width, state.height);
        });
        state.camera.aspect = state.width / state.height;
        state.camera.updateProjectionMatrix();
        state.camera.position.z = 1000;
        // add sky
        state.scene.add(state.skysphere = new $69c9538f9a62b4e8$var$three.Mesh());
        state.skysphere.visible = false;
        state.loadComplete = state.scene.visible = !waitForLoadComplete;
        window.scene = state.scene;
    },
    update: function update(state, changedProps) {
        // resize canvas
        if (state.width && state.height && (changedProps.hasOwnProperty('width') || changedProps.hasOwnProperty('height'))) {
            var _state$camera;
            var w = state.width;
            var h = state.height;
            state.container.style.width = "".concat(w, "px");
            state.container.style.height = "".concat(h, "px");
            [
                state.renderer,
                state.postProcessingComposer
            ].concat($69c9538f9a62b4e8$var$_toConsumableArray(state.extraRenderers)).forEach(function(r) {
                return r.setSize(w, h);
            });
            state.camera.aspect = w / h;
            var o = state.viewOffset.slice(0, 2);
            o.some(function(n) {
                return n;
            }) && (_state$camera = state.camera).setViewOffset.apply(_state$camera, [
                w,
                h
            ].concat($69c9538f9a62b4e8$var$_toConsumableArray(o), [
                w,
                h
            ]));
            state.camera.updateProjectionMatrix();
        }
        if (changedProps.hasOwnProperty('viewOffset')) {
            var _state$camera2;
            var _w = state.width;
            var _h = state.height;
            var _o = state.viewOffset.slice(0, 2);
            _o.some(function(n) {
                return n;
            }) ? (_state$camera2 = state.camera).setViewOffset.apply(_state$camera2, [
                _w,
                _h
            ].concat($69c9538f9a62b4e8$var$_toConsumableArray(_o), [
                _w,
                _h
            ])) : state.camera.clearViewOffset();
        }
        if (changedProps.hasOwnProperty('skyRadius') && state.skyRadius) {
            state.controls.hasOwnProperty('maxDistance') && changedProps.skyRadius && (state.controls.maxDistance = Math.min(state.controls.maxDistance, state.skyRadius));
            state.camera.far = state.skyRadius * 2.5;
            state.camera.updateProjectionMatrix();
            state.skysphere.geometry = new $69c9538f9a62b4e8$var$three.SphereGeometry(state.skyRadius);
        }
        if (changedProps.hasOwnProperty('backgroundColor')) {
            var alpha = (0, $c4f699b4a01e0372$export$2f48baff6995707a)(state.backgroundColor).alpha;
            if (alpha === undefined) alpha = 1;
            state.renderer.setClearColor(new $69c9538f9a62b4e8$var$three.Color((0, $c4f699b4a01e0372$export$f4f50e3877dd0530)(1, state.backgroundColor)), alpha);
        }
        if (changedProps.hasOwnProperty('backgroundImageUrl')) {
            if (!state.backgroundImageUrl) {
                state.skysphere.visible = false;
                state.skysphere.material.map = null;
                !state.loadComplete && finishLoad();
            } else new $69c9538f9a62b4e8$var$three.TextureLoader().load(state.backgroundImageUrl, function(texture) {
                texture.colorSpace = $69c9538f9a62b4e8$var$three.SRGBColorSpace;
                state.skysphere.material = new $69c9538f9a62b4e8$var$three.MeshBasicMaterial({
                    map: texture,
                    side: $69c9538f9a62b4e8$var$three.BackSide
                });
                state.skysphere.visible = true;
                // triggered when background image finishes loading (asynchronously to allow 1 frame to load texture)
                state.onBackgroundImageLoaded && setTimeout(state.onBackgroundImageLoaded);
                !state.loadComplete && finishLoad();
            });
        }
        changedProps.hasOwnProperty('showNavInfo') && (state.navInfo.style.display = state.showNavInfo ? null : 'none');
        if (changedProps.hasOwnProperty('lights')) {
            (changedProps.lights || []).forEach(function(light) {
                return state.scene.remove(light);
            }); // Clear the place
            state.lights.forEach(function(light) {
                return state.scene.add(light);
            }); // Add to scene
        }
        if (changedProps.hasOwnProperty('objects')) {
            (changedProps.objects || []).forEach(function(obj) {
                return state.scene.remove(obj);
            }); // Clear the place
            state.objects.forEach(function(obj) {
                return state.scene.add(obj);
            }); // Add to scene
        }
        //
        function finishLoad() {
            state.loadComplete = state.scene.visible = true;
        }
    }
});




function $66a418df8d4b954b$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $66a418df8d4b954b$var$css_248z = ".graph-info-msg {\n  top: 50%;\n  width: 100%;\n  text-align: center;\n  color: lavender;\n  opacity: 0.7;\n  font-size: 22px;\n  position: absolute;\n  font-family: Sans-serif;\n}\n\n.scene-container .clickable {\n  cursor: pointer;\n}\n\n.scene-container .grabbable {\n  cursor: move;\n  cursor: grab;\n  cursor: -moz-grab;\n  cursor: -webkit-grab;\n}\n\n.scene-container .grabbable:active {\n  cursor: grabbing;\n  cursor: -moz-grabbing;\n  cursor: -webkit-grabbing;\n}";
$66a418df8d4b954b$var$styleInject($66a418df8d4b954b$var$css_248z);
function $66a418df8d4b954b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $66a418df8d4b954b$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $66a418df8d4b954b$var$_arrayLikeToArray(r);
}
function $66a418df8d4b954b$var$_defineProperty(e, r, t) {
    return (r = $66a418df8d4b954b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $66a418df8d4b954b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $66a418df8d4b954b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $66a418df8d4b954b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66a418df8d4b954b$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66a418df8d4b954b$var$ownKeys(Object(t), true).forEach(function(r) {
            $66a418df8d4b954b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66a418df8d4b954b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66a418df8d4b954b$var$_toConsumableArray(r) {
    return $66a418df8d4b954b$var$_arrayWithoutHoles(r) || $66a418df8d4b954b$var$_iterableToArray(r) || $66a418df8d4b954b$var$_unsupportedIterableToArray(r) || $66a418df8d4b954b$var$_nonIterableSpread();
}
function $66a418df8d4b954b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $66a418df8d4b954b$var$_toPropertyKey(t) {
    var i = $66a418df8d4b954b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66a418df8d4b954b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $66a418df8d4b954b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $66a418df8d4b954b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $66a418df8d4b954b$var$linkKapsule(kapsulePropName, kapsuleType) {
    var dummyK = new kapsuleType(); // To extract defaults
    dummyK._destructor && dummyK._destructor();
    return {
        linkProp: function linkProp(prop) {
            // link property config
            return {
                "default": dummyK[prop](),
                onChange: function onChange(v, state) {
                    state[kapsulePropName][prop](v);
                },
                triggerUpdate: false
            };
        },
        linkMethod: function linkMethod(method) {
            // link method pass-through
            return function(state) {
                var kapsuleInstance = state[kapsulePropName];
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                var returnVal = kapsuleInstance[method].apply(kapsuleInstance, args);
                return returnVal === kapsuleInstance ? this // chain based on the parent object, not the inner kapsule
                 : returnVal;
            };
        }
    };
}
var $66a418df8d4b954b$var$three = window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    AmbientLight: (0, $9ddd7e9b53f7a2d4$export$af279bfef9ec2c96),
    DirectionalLight: (0, $9ddd7e9b53f7a2d4$export$3fea33cc9972c868),
    REVISION: (0, $9ddd7e9b53f7a2d4$export$3545e07a80636437)
};
//
var $66a418df8d4b954b$var$CAMERA_DISTANCE2NODES_FACTOR = 170;
//
// Expose config from forceGraph
var $66a418df8d4b954b$var$bindFG = $66a418df8d4b954b$var$linkKapsule('forceGraph', (0, $e83b3346bbbc2544$export$2e2bcd8739ae039));
var $66a418df8d4b954b$var$linkedFGProps = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'jsonUrl',
    'graphData',
    'numDimensions',
    'dagMode',
    'dagLevelDistance',
    'dagNodeFilter',
    'onDagError',
    'nodeRelSize',
    'nodeId',
    'nodeVal',
    'nodeResolution',
    'nodeColor',
    'nodeAutoColorBy',
    'nodeOpacity',
    'nodeVisibility',
    'nodeThreeObject',
    'nodeThreeObjectExtend',
    'nodePositionUpdate',
    'linkSource',
    'linkTarget',
    'linkVisibility',
    'linkColor',
    'linkAutoColorBy',
    'linkOpacity',
    'linkWidth',
    'linkResolution',
    'linkCurvature',
    'linkCurveRotation',
    'linkMaterial',
    'linkThreeObject',
    'linkThreeObjectExtend',
    'linkPositionUpdate',
    'linkDirectionalArrowLength',
    'linkDirectionalArrowColor',
    'linkDirectionalArrowRelPos',
    'linkDirectionalArrowResolution',
    'linkDirectionalParticles',
    'linkDirectionalParticleSpeed',
    'linkDirectionalParticleOffset',
    'linkDirectionalParticleWidth',
    'linkDirectionalParticleColor',
    'linkDirectionalParticleResolution',
    'linkDirectionalParticleThreeObject',
    'forceEngine',
    'd3AlphaDecay',
    'd3VelocityDecay',
    'd3AlphaMin',
    'ngraphPhysics',
    'warmupTicks',
    'cooldownTicks',
    'cooldownTime',
    'onEngineTick',
    'onEngineStop'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindFG.linkProp(p));
})));
var $66a418df8d4b954b$var$linkedFGMethods = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'refresh',
    'getGraphBbox',
    'd3Force',
    'd3ReheatSimulation',
    'emitParticle'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindFG.linkMethod(p));
})));
// Expose config from renderObjs
var $66a418df8d4b954b$var$bindRenderObjs = $66a418df8d4b954b$var$linkKapsule('renderObjs', (0, $69c9538f9a62b4e8$export$2e2bcd8739ae039));
var $66a418df8d4b954b$var$linkedRenderObjsProps = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'width',
    'height',
    'backgroundColor',
    'showNavInfo',
    'enablePointerInteraction'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindRenderObjs.linkProp(p));
})));
var $66a418df8d4b954b$var$linkedRenderObjsMethods = Object.assign.apply(Object, $66a418df8d4b954b$var$_toConsumableArray([
    'lights',
    'cameraPosition',
    'postProcessingComposer'
].map(function(p) {
    return $66a418df8d4b954b$var$_defineProperty({}, p, $66a418df8d4b954b$var$bindRenderObjs.linkMethod(p));
})).concat([
    {
        graph2ScreenCoords: $66a418df8d4b954b$var$bindRenderObjs.linkMethod('getScreenCoords'),
        screen2GraphCoords: $66a418df8d4b954b$var$bindRenderObjs.linkMethod('getSceneCoords')
    }
]));
//
var $66a418df8d4b954b$export$2e2bcd8739ae039 = (0, $752852d7be1532d9$export$2e2bcd8739ae039)({
    props: $66a418df8d4b954b$var$_objectSpread2($66a418df8d4b954b$var$_objectSpread2({
        nodeLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        linkLabel: {
            "default": 'name',
            triggerUpdate: false
        },
        linkHoverPrecision: {
            "default": 1,
            onChange: function onChange(p, state) {
                return state.renderObjs.lineHoverPrecision(p);
            },
            triggerUpdate: false
        },
        enableNavigationControls: {
            "default": true,
            onChange: function onChange(enable, state) {
                var controls = state.renderObjs.controls();
                if (controls) {
                    controls.enabled = enable;
                    // trigger mouseup on re-enable to prevent sticky controls
                    enable && controls.domElement && controls.domElement.dispatchEvent(new PointerEvent('pointerup'));
                }
            },
            triggerUpdate: false
        },
        enableNodeDrag: {
            "default": true,
            triggerUpdate: false
        },
        onNodeDrag: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeDragEnd: {
            "default": function _default() {},
            triggerUpdate: false
        },
        onNodeClick: {
            triggerUpdate: false
        },
        onNodeRightClick: {
            triggerUpdate: false
        },
        onNodeHover: {
            triggerUpdate: false
        },
        onLinkClick: {
            triggerUpdate: false
        },
        onLinkRightClick: {
            triggerUpdate: false
        },
        onLinkHover: {
            triggerUpdate: false
        },
        onBackgroundClick: {
            triggerUpdate: false
        },
        onBackgroundRightClick: {
            triggerUpdate: false
        },
        showPointerCursor: {
            "default": true,
            triggerUpdate: false
        }
    }, $66a418df8d4b954b$var$linkedFGProps), $66a418df8d4b954b$var$linkedRenderObjsProps),
    methods: $66a418df8d4b954b$var$_objectSpread2($66a418df8d4b954b$var$_objectSpread2({
        zoomToFit: function zoomToFit(state, transitionDuration, padding) {
            var _state$forceGraph;
            for(var _len = arguments.length, bboxArgs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)bboxArgs[_key - 3] = arguments[_key];
            state.renderObjs.fitToBbox((_state$forceGraph = state.forceGraph).getGraphBbox.apply(_state$forceGraph, bboxArgs), transitionDuration, padding);
            return this;
        },
        pauseAnimation: function pauseAnimation(state) {
            if (state.animationFrameRequestId !== null) {
                cancelAnimationFrame(state.animationFrameRequestId);
                state.animationFrameRequestId = null;
            }
            return this;
        },
        resumeAnimation: function resumeAnimation(state) {
            if (state.animationFrameRequestId === null) this._animationCycle();
            return this;
        },
        _animationCycle: function _animationCycle(state) {
            if (state.enablePointerInteraction) // reset canvas cursor (override dragControls cursor)
            this.renderer().domElement.style.cursor = null;
            // Frame cycle
            state.forceGraph.tickFrame();
            state.renderObjs.tick();
            state.animationFrameRequestId = requestAnimationFrame(this._animationCycle);
        },
        scene: function scene(state) {
            return state.renderObjs.scene();
        },
        // Expose scene
        camera: function camera(state) {
            return state.renderObjs.camera();
        },
        // Expose camera
        renderer: function renderer(state) {
            return state.renderObjs.renderer();
        },
        // Expose renderer
        controls: function controls(state) {
            return state.renderObjs.controls();
        },
        // Expose controls
        _destructor: function _destructor(state) {
            var _state$forceGraph$_de, _state$forceGraph2;
            this.pauseAnimation();
            this.graphData({
                nodes: [],
                links: []
            });
            (_state$forceGraph$_de = (_state$forceGraph2 = state.forceGraph)._destructor) === null || _state$forceGraph$_de === void 0 || _state$forceGraph$_de.call(_state$forceGraph2);
            state.renderObjs._destructor();
        }
    }, $66a418df8d4b954b$var$linkedFGMethods), $66a418df8d4b954b$var$linkedRenderObjsMethods),
    stateInit: function stateInit(_ref5) {
        var controlType = _ref5.controlType, rendererConfig = _ref5.rendererConfig, extraRenderers = _ref5.extraRenderers;
        var forceGraph = new (0, $e83b3346bbbc2544$export$2e2bcd8739ae039)();
        return {
            forceGraph: forceGraph,
            renderObjs: (0, $69c9538f9a62b4e8$export$2e2bcd8739ae039)({
                controlType: controlType,
                rendererConfig: rendererConfig,
                extraRenderers: extraRenderers
            }).objects([
                forceGraph
            ]) // Populate scene
            .lights([
                new $66a418df8d4b954b$var$three.AmbientLight(0xcccccc, Math.PI),
                new $66a418df8d4b954b$var$three.DirectionalLight(0xffffff, 0.6 * Math.PI)
            ])
        };
    },
    init: function init(domNode, state) {
        // Wipe DOM
        domNode.innerHTML = '';
        // Add relative container
        domNode.appendChild(state.container = document.createElement('div'));
        state.container.style.position = 'relative';
        // Add renderObjs
        var roDomNode = document.createElement('div');
        state.container.appendChild(roDomNode);
        state.renderObjs(roDomNode);
        var camera = state.renderObjs.camera();
        var renderer = state.renderObjs.renderer();
        var controls = state.renderObjs.controls();
        controls.enabled = !!state.enableNavigationControls;
        state.lastSetCameraZ = camera.position.z;
        // Add info space
        var infoElem;
        state.container.appendChild(infoElem = document.createElement('div'));
        infoElem.className = 'graph-info-msg';
        infoElem.textContent = '';
        // config forcegraph
        state.forceGraph.onLoading(function() {
            infoElem.textContent = 'Loading...';
        }).onFinishLoading(function() {
            infoElem.textContent = '';
        }).onUpdate(function() {
            // sync graph data structures
            state.graphData = state.forceGraph.graphData();
            // re-aim camera, if still in default position (not user modified)
            if (camera.position.x === 0 && camera.position.y === 0 && camera.position.z === state.lastSetCameraZ && state.graphData.nodes.length) {
                camera.lookAt(state.forceGraph.position);
                state.lastSetCameraZ = camera.position.z = Math.cbrt(state.graphData.nodes.length) * $66a418df8d4b954b$var$CAMERA_DISTANCE2NODES_FACTOR;
            }
        }).onFinishUpdate(function() {
            // Setup node drag interaction
            if (state._dragControls) {
                var curNodeDrag = state.graphData.nodes.find(function(node) {
                    return node.__initialFixedPos && !node.__disposeControlsAfterDrag;
                }); // detect if there's a node being dragged using the existing drag controls
                if (curNodeDrag) curNodeDrag.__disposeControlsAfterDrag = true; // postpone previous controls disposal until drag ends
                else state._dragControls.dispose(); // cancel previous drag controls
                state._dragControls = undefined;
            }
            if (state.enableNodeDrag && state.enablePointerInteraction && state.forceEngine === 'd3') {
                // Can't access node positions programmatically in ngraph
                var dragControls = state._dragControls = new (0, $40043d5ea0db3d61$export$350d0cf1f91b53f4)(state.graphData.nodes.map(function(node) {
                    return node.__threeObj;
                }).filter(function(obj) {
                    return obj;
                }), camera, renderer.domElement);
                dragControls.addEventListener('dragstart', function(event) {
                    var nodeObj = $66a418df8d4b954b$var$getGraphObj(event.object);
                    if (!nodeObj) return;
                    controls.enabled = false; // Disable controls while dragging
                    // track drag object movement
                    event.object.__initialPos = event.object.position.clone();
                    event.object.__prevPos = event.object.position.clone();
                    var node = nodeObj.__data;
                    !node.__initialFixedPos && (node.__initialFixedPos = {
                        fx: node.fx,
                        fy: node.fy,
                        fz: node.fz
                    });
                    !node.__initialPos && (node.__initialPos = {
                        x: node.x,
                        y: node.y,
                        z: node.z
                    });
                    // lock node
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(c) {
                        return node["f".concat(c)] = node[c];
                    });
                    // drag cursor
                    renderer.domElement.classList.add('grabbable');
                });
                dragControls.addEventListener('drag', function(event) {
                    var nodeObj = $66a418df8d4b954b$var$getGraphObj(event.object);
                    if (!nodeObj) return;
                    if (!event.object.hasOwnProperty('__graphObjType')) {
                        // If dragging a child of the node, update the node object instead
                        var initPos = event.object.__initialPos;
                        var prevPos = event.object.__prevPos;
                        var _newPos = event.object.position;
                        nodeObj.position.add(_newPos.clone().sub(prevPos)); // translate node object by the motion delta
                        prevPos.copy(_newPos);
                        _newPos.copy(initPos); // reset child back to its initial position
                    }
                    var node = nodeObj.__data;
                    var newPos = nodeObj.position;
                    var translate = {
                        x: newPos.x - node.x,
                        y: newPos.y - node.y,
                        z: newPos.z - node.z
                    };
                    // Move fx/fy/fz (and x/y/z) of nodes based on object new position
                    [
                        'x',
                        'y',
                        'z'
                    ].forEach(function(c) {
                        return node["f".concat(c)] = node[c] = newPos[c];
                    });
                    state.forceGraph.d3AlphaTarget(0.3) // keep engine running at low intensity throughout drag
                    .resetCountdown(); // prevent freeze while dragging
                    node.__dragged = true;
                    state.onNodeDrag(node, translate);
                });
                dragControls.addEventListener('dragend', function(event) {
                    var nodeObj = $66a418df8d4b954b$var$getGraphObj(event.object);
                    if (!nodeObj) return;
                    delete event.object.__initialPos; // remove tracking attributes
                    delete event.object.__prevPos;
                    var node = nodeObj.__data;
                    // dispose previous controls if needed
                    if (node.__disposeControlsAfterDrag) {
                        dragControls.dispose();
                        delete node.__disposeControlsAfterDrag;
                    }
                    var initFixedPos = node.__initialFixedPos;
                    var initPos = node.__initialPos;
                    var translate = {
                        x: initPos.x - node.x,
                        y: initPos.y - node.y,
                        z: initPos.z - node.z
                    };
                    if (initFixedPos) {
                        [
                            'x',
                            'y',
                            'z'
                        ].forEach(function(c) {
                            var fc = "f".concat(c);
                            if (initFixedPos[fc] === undefined) delete node[fc];
                        });
                        delete node.__initialFixedPos;
                        delete node.__initialPos;
                        if (node.__dragged) {
                            delete node.__dragged;
                            state.onNodeDragEnd(node, translate);
                        }
                    }
                    state.forceGraph.d3AlphaTarget(0) // release engine low intensity
                    .resetCountdown(); // let the engine readjust after releasing fixed nodes
                    if (state.enableNavigationControls) {
                        var _controls$_onPointerC;
                        controls.enabled = true; // Re-enable controls
                        controls._status && ((_controls$_onPointerC = controls._onPointerCancel) === null || _controls$_onPointerC === void 0 || _controls$_onPointerC.call(controls)); // cancel pressed status on fly controls
                        controls.domElement && controls.domElement.ownerDocument && controls.domElement.ownerDocument.dispatchEvent(// simulate mouseup to ensure the controls don't take over after dragend
                        new PointerEvent('pointerup', {
                            pointerType: 'touch'
                        }));
                    }
                    // clear cursor
                    renderer.domElement.classList.remove('grabbable');
                });
            }
        });
        // config renderObjs
        $66a418df8d4b954b$var$three.REVISION < 155 && (state.renderObjs.renderer().useLegacyLights = false); // force behavior for three < 155
        state.renderObjs.hoverOrderComparator(function(a, b) {
            // Prioritize graph objects
            var aObj = $66a418df8d4b954b$var$getGraphObj(a);
            if (!aObj) return 1;
            var bObj = $66a418df8d4b954b$var$getGraphObj(b);
            if (!bObj) return -1;
            // Prioritize nodes over links
            var isNode = function isNode(o) {
                return o.__graphObjType === 'node';
            };
            return isNode(bObj) - isNode(aObj);
        }).tooltipContent(function(obj) {
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            return graphObj ? (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state["".concat(graphObj.__graphObjType, "Label")])(graphObj.__data) || '' : '';
        }).hoverDuringDrag(false).onHover(function(obj) {
            // Update tooltip and trigger onHover events
            var hoverObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (hoverObj !== state.hoverObj) {
                var prevObjType = state.hoverObj ? state.hoverObj.__graphObjType : null;
                var prevObjData = state.hoverObj ? state.hoverObj.__data : null;
                var objType = hoverObj ? hoverObj.__graphObjType : null;
                var objData = hoverObj ? hoverObj.__data : null;
                if (prevObjType && prevObjType !== objType) {
                    // Hover out
                    var fn = state["on".concat(prevObjType === 'node' ? 'Node' : 'Link', "Hover")];
                    fn && fn(null, prevObjData);
                }
                if (objType) {
                    // Hover in
                    var _fn = state["on".concat(objType === 'node' ? 'Node' : 'Link', "Hover")];
                    _fn && _fn(objData, prevObjType === objType ? prevObjData : null);
                }
                // set pointer if hovered object is clickable
                renderer.domElement.classList[(hoverObj && state["on".concat(objType === 'node' ? 'Node' : 'Link', "Click")] || !hoverObj && state.onBackgroundClick) && (0, $85d8080a057d7be2$export$2e2bcd8739ae039)(state.showPointerCursor)(objData) ? 'add' : 'remove']('clickable');
                state.hoverObj = hoverObj;
            }
        }).clickAfterDrag(false).onClick(function(obj, ev) {
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (graphObj) {
                var fn = state["on".concat(graphObj.__graphObjType === 'node' ? 'Node' : 'Link', "Click")];
                fn && fn(graphObj.__data, ev);
            } else state.onBackgroundClick && state.onBackgroundClick(ev);
        }).onRightClick(function(obj, ev) {
            // Handle right-click events
            var graphObj = $66a418df8d4b954b$var$getGraphObj(obj);
            if (graphObj) {
                var fn = state["on".concat(graphObj.__graphObjType === 'node' ? 'Node' : 'Link', "RightClick")];
                fn && fn(graphObj.__data, ev);
            } else state.onBackgroundRightClick && state.onBackgroundRightClick(ev);
        });
        //
        // Kick-off renderer
        this._animationCycle();
    }
});
//
function $66a418df8d4b954b$var$getGraphObj(object) {
    var obj = object;
    // recurse up object chain until finding the graph object
    while(obj && !obj.hasOwnProperty('__graphObjType'))obj = obj.parent;
    return obj;
}



const $fb74db41c312cc9d$var$commonPropTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    graphData: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        nodes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
        links: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired
    }),
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeRelSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    nodeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVal: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onNodeHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkSource: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkLabel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkAutoColorBy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCurvature: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowLength: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalArrowRelPos: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleSpeed: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleWidth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDirectionalParticleColor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onLinkHover: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    dagMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'td',
        'bu',
        'lr',
        'rl',
        'zin',
        'zout',
        'radialin',
        'radialout'
    ]),
    dagLevelDistance: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    dagNodeFilter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onDagError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    d3AlphaMin: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3AlphaDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    d3VelocityDecay: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    warmupTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTicks: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    cooldownTime: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onEngineTick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onEngineStop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    getGraphBbox: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
const $fb74db41c312cc9d$var$pointerBasedPropTypes = {
    zoomToFit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onNodeDragEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLinkRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkHoverPrecision: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    onBackgroundClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onBackgroundRightClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    showPointerCursor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    enablePointerInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    enableNodeDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
const $fb74db41c312cc9d$var$threeBasedPropTypes = {
    showNavInfo: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    nodeOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    nodeThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodePositionUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkCurveRotation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkMaterial: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkThreeObjectExtend: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkPositionUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkDirectionalArrowResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkDirectionalParticleResolution: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    linkDirectionalParticleThreeObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    forceEngine: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'd3',
        'ngraph'
    ]),
    ngraphPhysics: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    numDimensions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        1,
        2,
        3
    ])
};
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$pointerBasedPropTypes, {
    linkLineDash: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    nodeCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    nodePointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkCanvasObjectMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkPointerAreaPaint: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    linkDirectionalParticleCanvasObject: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    autoPauseRedraw: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    minZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    maxZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    enableZoomInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    enablePanInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    onZoom: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onZoomEnd: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePre: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderFramePost: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
});
const $fb74db41c312cc9d$var$ForceGraph3DPropTypes = Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$pointerBasedPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    enableNavigationControls: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    controlType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'trackball',
        'orbit',
        'fly'
    ]),
    rendererConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    extraRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        render: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    }))
});
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    nodeDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ]),
    linkDesc: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ])
});
Object.assign({}, $fb74db41c312cc9d$var$commonPropTypes, $fb74db41c312cc9d$var$threeBasedPropTypes, {
    markerAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    yOffset: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    glScale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
const $fb74db41c312cc9d$export$2e2bcd8739ae039 = (0, $5d3aea6df4994d8c$export$2e2bcd8739ae039)((0, $66a418df8d4b954b$export$2e2bcd8739ae039), {
    methodNames: [
        // bind methods
        'emitParticle',
        'd3Force',
        'd3ReheatSimulation',
        'stopAnimation',
        'pauseAnimation',
        'resumeAnimation',
        'cameraPosition',
        'zoomToFit',
        'getGraphBbox',
        'screen2GraphCoords',
        'graph2ScreenCoords',
        'postProcessingComposer',
        'lights',
        'scene',
        'camera',
        'renderer',
        'controls',
        'refresh'
    ],
    initPropNames: [
        'controlType',
        'rendererConfig',
        'extraRenderers'
    ]
});
$fb74db41c312cc9d$export$2e2bcd8739ae039.displayName = 'ForceGraph3D';
$fb74db41c312cc9d$export$2e2bcd8739ae039.propTypes = $fb74db41c312cc9d$var$ForceGraph3DPropTypes;











function $e971b40c07629a0e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e971b40c07629a0e$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e971b40c07629a0e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e971b40c07629a0e$var$_arrayLikeToArray(r);
}
function $e971b40c07629a0e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $e971b40c07629a0e$var$_callSuper(t, o, e) {
    return o = $e971b40c07629a0e$var$_getPrototypeOf(o), $e971b40c07629a0e$var$_possibleConstructorReturn(t, $e971b40c07629a0e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e971b40c07629a0e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e971b40c07629a0e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $e971b40c07629a0e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, $e971b40c07629a0e$var$_toPropertyKey(o.key), o);
    }
}
function $e971b40c07629a0e$var$_createClass(e, r, t) {
    return r && $e971b40c07629a0e$var$_defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
        writable: false
    }), e;
}
function $e971b40c07629a0e$var$_getPrototypeOf(t) {
    return $e971b40c07629a0e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e971b40c07629a0e$var$_getPrototypeOf(t);
}
function $e971b40c07629a0e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: true,
            configurable: true
        }
    }), Object.defineProperty(t, "prototype", {
        writable: false
    }), e && $e971b40c07629a0e$var$_setPrototypeOf(t, e);
}
function $e971b40c07629a0e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e971b40c07629a0e$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $e971b40c07629a0e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $e971b40c07629a0e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e971b40c07629a0e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e971b40c07629a0e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e971b40c07629a0e$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $e971b40c07629a0e$var$_assertThisInitialized(t);
}
function $e971b40c07629a0e$var$_setPrototypeOf(t, e) {
    return $e971b40c07629a0e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e971b40c07629a0e$var$_setPrototypeOf(t, e);
}
function $e971b40c07629a0e$var$_slicedToArray(r, e) {
    return $e971b40c07629a0e$var$_arrayWithHoles(r) || $e971b40c07629a0e$var$_iterableToArrayLimit(r, e) || $e971b40c07629a0e$var$_unsupportedIterableToArray(r, e) || $e971b40c07629a0e$var$_nonIterableRest();
}
function $e971b40c07629a0e$var$_toConsumableArray(r) {
    return $e971b40c07629a0e$var$_arrayWithoutHoles(r) || $e971b40c07629a0e$var$_iterableToArray(r) || $e971b40c07629a0e$var$_unsupportedIterableToArray(r) || $e971b40c07629a0e$var$_nonIterableSpread();
}
function $e971b40c07629a0e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
function $e971b40c07629a0e$var$_toPropertyKey(t) {
    var i = $e971b40c07629a0e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e971b40c07629a0e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e971b40c07629a0e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e971b40c07629a0e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $e971b40c07629a0e$var$three = typeof window !== 'undefined' && window.THREE ? window.THREE // Prefer consumption from global THREE, if exists
 : {
    CanvasTexture: (0, $9ddd7e9b53f7a2d4$export$f7189e49152d1c13),
    Sprite: (0, $9ddd7e9b53f7a2d4$export$3075603db8e6204c),
    SpriteMaterial: (0, $9ddd7e9b53f7a2d4$export$5ec7dd1c6994bf8e),
    SRGBColorSpace: (0, $9ddd7e9b53f7a2d4$export$561f394b24edfcaa)
};
var $e971b40c07629a0e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_three$Sprite) {
    function _default() {
        var _this;
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var textHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
        var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rgba(255, 255, 255, 1)';
        $e971b40c07629a0e$var$_classCallCheck(this, _default);
        _this = $e971b40c07629a0e$var$_callSuper(this, _default, [
            new $e971b40c07629a0e$var$three.SpriteMaterial()
        ]);
        _this._text = "".concat(text);
        _this._textHeight = textHeight;
        _this._color = color;
        _this._backgroundColor = false; // no background color
        _this._padding = 0;
        _this._borderWidth = 0;
        _this._borderRadius = 0;
        _this._borderColor = 'white';
        _this._offsetX = 0;
        _this._offsetY = 0;
        _this._strokeWidth = 0;
        _this._strokeColor = 'white';
        _this._fontFace = 'system-ui';
        _this._fontSize = 90; // defines text resolution
        _this._fontWeight = 'normal';
        _this._canvas = document.createElement('canvas');
        _this._genCanvas();
        return _this;
    }
    $e971b40c07629a0e$var$_inherits(_default, _three$Sprite);
    return $e971b40c07629a0e$var$_createClass(_default, [
        {
            key: "text",
            get: function get() {
                return this._text;
            },
            set: function set(text) {
                this._text = text;
                this._genCanvas();
            }
        },
        {
            key: "textHeight",
            get: function get() {
                return this._textHeight;
            },
            set: function set(textHeight) {
                this._textHeight = textHeight;
                this._genCanvas();
            }
        },
        {
            key: "color",
            get: function get() {
                return this._color;
            },
            set: function set(color) {
                this._color = color;
                this._genCanvas();
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._backgroundColor;
            },
            set: function set(color) {
                this._backgroundColor = color;
                this._genCanvas();
            }
        },
        {
            key: "padding",
            get: function get() {
                return this._padding;
            },
            set: function set(padding) {
                this._padding = padding;
                this._genCanvas();
            }
        },
        {
            key: "borderWidth",
            get: function get() {
                return this._borderWidth;
            },
            set: function set(borderWidth) {
                this._borderWidth = borderWidth;
                this._genCanvas();
            }
        },
        {
            key: "borderRadius",
            get: function get() {
                return this._borderRadius;
            },
            set: function set(borderRadius) {
                this._borderRadius = borderRadius;
                this._genCanvas();
            }
        },
        {
            key: "borderColor",
            get: function get() {
                return this._borderColor;
            },
            set: function set(borderColor) {
                this._borderColor = borderColor;
                this._genCanvas();
            }
        },
        {
            key: "offsetX",
            get: function get() {
                return this._offsetX;
            },
            set: function set(offset) {
                this._offsetX = offset;
                this._genCanvas();
            }
        },
        {
            key: "offsetY",
            get: function get() {
                return this._offsetY;
            },
            set: function set(offset) {
                this._offsetY = offset;
                this._genCanvas();
            }
        },
        {
            key: "fontFace",
            get: function get() {
                return this._fontFace;
            },
            set: function set(fontFace) {
                this._fontFace = fontFace;
                this._genCanvas();
            }
        },
        {
            key: "fontSize",
            get: function get() {
                return this._fontSize;
            },
            set: function set(fontSize) {
                this._fontSize = fontSize;
                this._genCanvas();
            }
        },
        {
            key: "fontWeight",
            get: function get() {
                return this._fontWeight;
            },
            set: function set(fontWeight) {
                this._fontWeight = fontWeight;
                this._genCanvas();
            }
        },
        {
            key: "strokeWidth",
            get: function get() {
                return this._strokeWidth;
            },
            set: function set(strokeWidth) {
                this._strokeWidth = strokeWidth;
                this._genCanvas();
            }
        },
        {
            key: "strokeColor",
            get: function get() {
                return this._strokeColor;
            },
            set: function set(strokeColor) {
                this._strokeColor = strokeColor;
                this._genCanvas();
            }
        },
        {
            key: "_genCanvas",
            value: function _genCanvas() {
                var _this2 = this;
                var canvas = this._canvas;
                var ctx = canvas.getContext('2d');
                var relFactor = 1 / this.textHeight;
                var border = Array.isArray(this.borderWidth) ? this.borderWidth : [
                    this.borderWidth,
                    this.borderWidth
                ]; // x,y border
                var relBorder = border.map(function(b) {
                    return b * _this2.fontSize * relFactor;
                }); // border in canvas units
                var borderRadius = Array.isArray(this.borderRadius) ? this.borderRadius : [
                    this.borderRadius,
                    this.borderRadius,
                    this.borderRadius,
                    this.borderRadius
                ]; // tl tr br bl corners
                var relBorderRadius = borderRadius.map(function(b) {
                    return b * _this2.fontSize * relFactor;
                }); // border radius in canvas units
                var padding = Array.isArray(this.padding) ? this.padding : [
                    this.padding,
                    this.padding
                ]; // x,y padding
                var relPadding = padding.map(function(p) {
                    return p * _this2.fontSize * relFactor;
                }); // padding in canvas units
                var relOffset = [
                    this.offsetX,
                    this.offsetY
                ].map(function(o) {
                    return o * _this2.fontSize * relFactor;
                }); // offset in canvas units
                var lines = this.text.split('\n');
                var font = "".concat(this.fontWeight, " ").concat(this.fontSize, "px ").concat(this.fontFace);
                ctx.font = font; // measure canvas with appropriate font
                var innerWidth = Math.max.apply(Math, $e971b40c07629a0e$var$_toConsumableArray(lines.map(function(line) {
                    return ctx.measureText(line).width;
                })));
                var innerHeight = this.fontSize * lines.length;
                var boxWidth = innerWidth + relBorder[0] * 2 + relPadding[0] * 2;
                var boxHeight = innerHeight + relBorder[1] * 2 + relPadding[1] * 2;
                canvas.width = boxWidth + Math.abs(relOffset[0]);
                canvas.height = boxHeight + Math.abs(relOffset[1]);
                // offset transform (only needed for positive values)
                ctx.translate.apply(ctx, $e971b40c07629a0e$var$_toConsumableArray(relOffset.map(function(o) {
                    return Math.max(0, o);
                })));
                // paint border
                if (this.borderWidth) {
                    ctx.strokeStyle = this.borderColor;
                    if (relBorder[0]) {
                        // left + right borders
                        var hb = relBorder[0] / 2;
                        ctx.lineWidth = relBorder[0];
                        ctx.beginPath();
                        ctx.moveTo(hb, relBorderRadius[0]);
                        ctx.lineTo(hb, boxHeight - relBorderRadius[3]);
                        ctx.moveTo(boxWidth - hb, relBorderRadius[1]);
                        ctx.lineTo(boxWidth - hb, boxHeight - relBorderRadius[2]);
                        ctx.stroke();
                    }
                    if (relBorder[1]) {
                        // top + bottom borders
                        var _hb = relBorder[1] / 2;
                        ctx.lineWidth = relBorder[1];
                        ctx.beginPath();
                        ctx.moveTo(Math.max(relBorder[0], relBorderRadius[0]), _hb);
                        ctx.lineTo(boxWidth - Math.max(relBorder[0], relBorderRadius[1]), _hb);
                        ctx.moveTo(Math.max(relBorder[0], relBorderRadius[3]), boxHeight - _hb);
                        ctx.lineTo(boxWidth - Math.max(relBorder[0], relBorderRadius[2]), boxHeight - _hb);
                        ctx.stroke();
                    }
                    if (this.borderRadius) {
                        // strike rounded corners
                        var cornerWidth = Math.max.apply(Math, $e971b40c07629a0e$var$_toConsumableArray(relBorder));
                        var _hb2 = cornerWidth / 2;
                        ctx.lineWidth = cornerWidth;
                        ctx.beginPath();
                        [
                            !!relBorderRadius[0] && [
                                relBorderRadius[0],
                                _hb2,
                                _hb2,
                                relBorderRadius[0]
                            ],
                            !!relBorderRadius[1] && [
                                boxWidth - relBorderRadius[1],
                                boxWidth - _hb2,
                                _hb2,
                                relBorderRadius[1]
                            ],
                            !!relBorderRadius[2] && [
                                boxWidth - relBorderRadius[2],
                                boxWidth - _hb2,
                                boxHeight - _hb2,
                                boxHeight - relBorderRadius[2]
                            ],
                            !!relBorderRadius[3] && [
                                relBorderRadius[3],
                                _hb2,
                                boxHeight - _hb2,
                                boxHeight - relBorderRadius[3]
                            ]
                        ].filter(function(d) {
                            return d;
                        }).forEach(function(_ref) {
                            var _ref2 = $e971b40c07629a0e$var$_slicedToArray(_ref, 4), x0 = _ref2[0], x1 = _ref2[1], y0 = _ref2[2], y1 = _ref2[3];
                            ctx.moveTo(x0, y0);
                            ctx.quadraticCurveTo(x1, y0, x1, y1);
                        });
                        ctx.stroke();
                    }
                }
                // paint background
                if (this.backgroundColor) {
                    ctx.fillStyle = this.backgroundColor;
                    if (!this.borderRadius) ctx.fillRect(relBorder[0], relBorder[1], boxWidth - relBorder[0] * 2, boxHeight - relBorder[1] * 2);
                    else {
                        // fill with rounded corners
                        ctx.beginPath();
                        ctx.moveTo(relBorder[0], relBorderRadius[0]);
                        [
                            [
                                relBorder[0],
                                relBorderRadius[0],
                                boxWidth - relBorderRadius[1],
                                relBorder[1],
                                relBorder[1],
                                relBorder[1]
                            ],
                            // t
                            [
                                boxWidth - relBorder[0],
                                boxWidth - relBorder[0],
                                boxWidth - relBorder[0],
                                relBorder[1],
                                relBorderRadius[1],
                                boxHeight - relBorderRadius[2]
                            ],
                            // r
                            [
                                boxWidth - relBorder[0],
                                boxWidth - relBorderRadius[2],
                                relBorderRadius[3],
                                boxHeight - relBorder[1],
                                boxHeight - relBorder[1],
                                boxHeight - relBorder[1]
                            ],
                            // b
                            [
                                relBorder[0],
                                relBorder[0],
                                relBorder[0],
                                boxHeight - relBorder[1],
                                boxHeight - relBorderRadius[3],
                                relBorderRadius[0]
                            ] // t
                        ].forEach(function(_ref3) {
                            var _ref4 = $e971b40c07629a0e$var$_slicedToArray(_ref3, 6), x0 = _ref4[0], x1 = _ref4[1], x2 = _ref4[2], y0 = _ref4[3], y1 = _ref4[4], y2 = _ref4[5];
                            ctx.quadraticCurveTo(x0, y0, x1, y1);
                            ctx.lineTo(x2, y2);
                        });
                        ctx.closePath();
                        ctx.fill();
                    }
                }
                ctx.translate.apply(ctx, $e971b40c07629a0e$var$_toConsumableArray(relBorder));
                ctx.translate.apply(ctx, $e971b40c07629a0e$var$_toConsumableArray(relPadding));
                // paint text
                ctx.font = font; // Set font again after canvas is resized, as context properties are reset
                ctx.fillStyle = this.color;
                ctx.textBaseline = 'bottom';
                var drawTextStroke = this.strokeWidth > 0;
                if (drawTextStroke) {
                    ctx.lineWidth = this.strokeWidth * this.fontSize / 10;
                    ctx.strokeStyle = this.strokeColor;
                }
                lines.forEach(function(line, index) {
                    var lineX = (innerWidth - ctx.measureText(line).width) / 2;
                    var lineY = (index + 1) * _this2.fontSize;
                    drawTextStroke && ctx.strokeText(line, lineX, lineY);
                    ctx.fillText(line, lineX, lineY);
                });
                // Inject canvas into sprite
                if (this.material.map) this.material.map.dispose(); // gc previous texture
                var texture = this.material.map = new $e971b40c07629a0e$var$three.CanvasTexture(canvas);
                texture.colorSpace = $e971b40c07629a0e$var$three.SRGBColorSpace;
                var yScale = this.textHeight * lines.length + border[1] * 2 + padding[1] * 2 + Math.abs(this.offsetY);
                this.scale.set(yScale * canvas.width / canvas.height, yScale, 0);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.text, this.textHeight, this.color).copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                $e971b40c07629a0e$var$three.Sprite.prototype.copy.call(this, source);
                this.color = source.color;
                this.backgroundColor = source.backgroundColor;
                this.padding = source.padding;
                this.borderWidth = source.borderWidth;
                this.borderColor = source.borderColor;
                this.offsetX = source.offsetX;
                this.offsetY = source.offsetY;
                this.fontFace = source.fontFace;
                this.fontSize = source.fontSize;
                this.fontWeight = source.fontWeight;
                this.strokeWidth = source.strokeWidth;
                this.strokeColor = source.strokeColor;
                return this;
            }
        }
    ]);
}($e971b40c07629a0e$var$three.Sprite);


function $ed1aee4c7e2a413d$export$da329417badd9dc5() {
    const fgRef = (0, $acw62.useRef)();
    const detailsPanelRef = (0, $acw62.useRef)();
    const [selectedNode, setSelectedNode] = (0, $acw62.useState)(null);
    const [minGraphSize, setMinGraphSize] = (0, $acw62.useState)(10);
    const [showLabel, setShowLabel] = (0, $acw62.useState)(false);
    const graphData = (0, $acw62.useMemo)(()=>{
        const full = (0, $bcf1285b349e5342$export$521ccb2585222b04)((0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))));
        const components = (0, $21f819a4461f8efa$export$cb4545c791e478f)(full.nodes, full.links);
        // keep only components large enough
        const validIds = new Set(components.filter((comp)=>comp.length >= minGraphSize && comp.length < 50).flat());
        const filteredNodes = full.nodes.filter((n)=>validIds.has(n.id));
        const filteredLinks = full.links.filter((l)=>validIds.has(l.source) && validIds.has(l.target));
        return {
            nodes: filteredNodes,
            links: filteredLinks
        };
    }, [
        minGraphSize
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d5c879b82e9fecb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb74db41c312cc9d$export$2e2bcd8739ae039), {
                ref: fgRef,
                graphData: graphData,
                nodeLabel: (node)=>node.label,
                nodeAutoColorBy: "type",
                linkColor: ()=>"black",
                linkWidth: 2.5,
                onNodeClick: (node)=>{
                    detailsPanelRef.current.open();
                    setSelectedNode(node);
                },
                backgroundColor: "white",
                nodeThreeObject: (node)=>{
                    const circle = new $9ddd7e9b53f7a2d4$export$e176487c05830cc5(new $9ddd7e9b53f7a2d4$export$1b417fc3b307a251(node.members.length * 2), new $9ddd7e9b53f7a2d4$export$5023a9a8114806b8({
                        color: node.type.includes("claim") ? "DarkMagenta" : "green",
                        transparent: true,
                        opacity: 0.75
                    }));
                    if (!showLabel) return circle;
                    const group = new $9ddd7e9b53f7a2d4$export$eb2fcfdbd7ba97d4();
                    group.add(circle);
                    const text = new (0, $e971b40c07629a0e$export$2e2bcd8739ae039)(node.label);
                    text.textHeight = 8;
                    text.offsetY = -12;
                    text.color = "black";
                    group.add(text);
                    return group;
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5e037e99aaeb8b9f$export$cadf57dd3336ca84), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ad14db7d065b8e$export$e54a7f2505304e20), {
                        selectedNode: selectedNode,
                        data: (0, (/*@__PURE__*/$parcel$interopDefault($7e152637e430236b$exports))),
                        ref: detailsPanelRef
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bd45a1af81ff630a$export$cbfa8a8d33d01a14), {
                        title: "Config",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "mr-1 grow",
                                        children: "Show Labels"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: showLabel,
                                        onChange: ()=>setShowLabel(!showLabel)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                children: [
                                    "Min connected graph size: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: minGraphSize
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "range",
                                min: "9",
                                max: "20",
                                value: minGraphSize,
                                onChange: (e)=>setMinGraphSize(Number(e.target.value))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $70fc9a727fa662ae$export$8707b35fd1c03f46() {
    const [route, setRoute] = (0, $acw62.useState)(()=>window.location.hash);
    (0, $acw62.useEffect)(()=>{
        const onHashChange = ()=>{
            setRoute(window.location.hash);
        };
        window.addEventListener("hashchange", onHashChange);
        return ()=>window.removeEventListener("hashchange", onHashChange);
    }, []);
    if (route === "#small") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcf1285b349e5342$export$dee8003db84ef533), {});
    if (route === "#time") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db08f6f394937c76$export$8a445f1917e2e2cc), {});
    if (route === "#3d") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed1aee4c7e2a413d$export$da329417badd9dc5), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93c05bd4543c9b04$export$b94310965bed44e6), {});
}
let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($70fc9a727fa662ae$export$8707b35fd1c03f46, {})
}));


//# sourceMappingURL=frontend.02d932cc.js.map
